mcapp.controller('monthPickerController', ['$scope', '$element', function ($scope, $element) {}]);

  mcapp.directive('monthPicker', ['$rootScope', 'detectBrowserService', 'translationService', '$timeout', function ($rootScope, detectBrowserService, translationService, $timeout) {
    return {
        restrict: 'E',
        templateUrl: function (element, attrs) {
            return "ui/components/directives/datepicker/monthPicker/month-picker-template.html"
        },
        link: function (scope, element, attrs) {
            scope.ytd = attrs.ytd == "true" ? true : false;
            scope.hideCalButtons = attrs.hideCalButtons == "true" ? true : false;
            scope.dynamicDatePopover = {templateUrl: 'monthPopoverTemplate.html'};
            scope.mobile = $rootScope.mobile;
            scope.classicView = $rootScope.classicView;

            scope.currentDate = function(){
              if(scope.hideCalButtons)
              {$timeout( function(){
                $(scope.$parent.$ctrl.element).find(".fc-today-button").click()
                $(element).find(".quickdate-button").click()}, 0 )
                }
            }

            scope.prevMonth = function(){
              if(scope.hideCalButtons) 
              {$timeout( function(){
                $(scope.$parent.$ctrl.element).find(".fc-prev-button").click()
                $(element).find(".quickdate-button").click()}, 0 )
                }
            }

            scope.nextMonth = function(){
              if(scope.hideCalButtons) {
                $timeout( function(){
                $(scope.$parent.$ctrl.element).find(".fc-next-button").click()
                $(element).find(".quickdate-button").click()}, 0 )
                }
            }

            scope.$on('updatePreferencesLanguage', function (event, args) {
              scope.translation = args;
            });
            
        }
    };
}]);

mcapp.controller('dateTimePickerController', ['$scope', '$element', function ($scope, $element) {}]);

  mcapp.directive('dateTimePicker', ['$rootScope', 'detectBrowserService', 'translationService', function ($rootScope, detectBrowserService, translationService) {
    return {
        restrict: 'E',
        templateUrl: function (element, attrs) {
            return "ui/components/directives/datepicker/dateTimePicker/date-time-template.html";
        },
        link: function (scope, element, attrs) {
            scope.disableTime = attrs.disableTime == "true" ? true : false;
            scope.boxHide = attrs.boxHide == "true" ? true : false;
            scope.dynamicDatePopover = { templateUrl: 'datePopoverTemplate.html' };
            scope.datePopoverVisible = false;
            scope.mobile = $rootScope.mobile;
            scope.classicView = $rootScope.classicView;

            scope.$on('updatePreferencesLanguage', function (event, args) {
                scope.translation = args;
            });

            scope.$on('uibDatePopoverHide', function () {
                scope.datePopoverVisible = false;
                //popover closes - harmless here since focus never actually leaves this
                //button, but keeps the behavior consistent with the other date-popover
                //wrappers where it does.
                var btn = element[0].querySelector('button.quickdate-button');
                if (btn) btn.focus();
            });

            var obj = !angular.isUndefined(attrs.stickyProperties) && attrs.stickyProperties != "" ? JSON.parse(attrs.stickyProperties) : null;

            if (obj != null && !angular.isUndefined(obj.zoomMax) && obj.zoomMax != null) {
                var tmpDate = new Date(obj.zoomMax);
                tmpDate.setHours(0, 0, 0, 0)
                scope.myDate = tmpDate;
            }

            scope.localCall = function (ctrl, myDate) {
                ctrl.myDate = myDate;
            };
        }
    };
}]);

mcapp.controller('dateRangePickerController', ['$scope', '$element', function ($scope, $element) {}]);

  mcapp.directive('dateRangePicker', ['$rootScope', 'detectBrowserService', 'translationService', function ($rootScope, detectBrowserService, translationService) {
    return {
        restrict: 'E',
        templateUrl: function (element, attrs) {
            return "ui/components/directives/datepicker/dateRangePicker/date-range-template.html"
        },
        link: function (scope, element, attrs) {
            scope.disableTime = attrs.disableTime == "true" ? true : false;
            scope.boxHide = attrs.boxHide == "true" ? true : false;
            scope.dynamicDatePopover = {templateUrl: 'dateRangePopoverTemplate.html'};
            scope.datePopoverVisible = false;
            scope.mobile = $rootScope.mobile;
            scope.classicView = $rootScope.classicView;
            scope.ctrlActive = scope.$ctrl ? true : false;

            scope.hideDatePopover = function () {
              scope.datePopoverVisible = false;
            };

            scope.$on('updatePreferencesLanguage', function (event, args) {
              scope.translation = args;
            });

            scope.$on('uibDatePopoverHide', function () {
              scope.datePopoverVisible = false;
              //popover can leave focus on an element that's about to be removed from
              //the DOM; return it to the trigger that opened the popover.
              var btn = element[0].querySelector('button.quickdate-button');
              if (btn) btn.focus();
          });
        }
    };
}]);

'use strict';

function mmPlusAnalogOutputChannelController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, MMPlusRtuSettingFactory, deviceService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = ctrl.stickyProperties;
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.channel = 1;
        ctrl.channelTypeID = 4;
        ctrl.loading = true;
        ctrl.channels = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];
        ctrl.analogInputHWSetup = [{ id: 0, name: '(Volts) MyDro HW & Adams Modules' }, { id: 1, name: '(4-20 mA) MyDro HW & Adams Modules' }, { id: 2, name: '(0-20 mA) Adams Modules' }];
        ctrl.unitOfValue = [{ id: 0, name: 'Volts' }, { id: 1, name: 'mA' }, { id: 2, name: 'Amps' }, { id: 3, name: 'Feet' }, { id: 4, name: 'Inches' }, { id: 5, name: 'Meters' }, { id: 6, name: 'mm' }, { id: 7, name: 'GPM' }, { id: 8, name: 'PSI' }, { id: 9, name: 'pH' }, { id: 10, name: 'NTU' }, { id: 11, name: '%' }, { id: 12, name: 'ppm' }, { id: 13, name: 'MGD' }, { id: 14, name: 'mg/l' }, { id: 15, name: 'Hz' }, { id: 16, name: 'C' }, { id: 17, name: 'F' }, { id: 18, name: 'gal' }, { id: 19, name: 'KGal' }, { id: 20, name: 'lbs' }, { id: 21, name: 'uS' }];
        ctrl.analogFilter = [{ id: 0, name: 'Default FIR filter - 5 sample, equal weights' }, { id: 1, name: 'IIR Filter - Fast Beta' }, { id: 2, name: 'IIR Filter - Slow Beta' }];
        ctrl.channelTypeName = '(AO) Analog Output channel';
    };

    ctrl.getData = function () {
        ctrl.MMPlusRtuSettingFactory.getData(ctrl.deviceId, ctrl.channel, ctrl.channelTypeID).then(function (result) {
            ctrl.data = result.data;
            ctrl.networkDeviceConfigID = ctrl.data.networkDeviceConfigID;
            ctrl.loading = false;
            ctrl.getImei();
            if (!ctrl.data) {
                ctrl.dataAvailable = false;
                ctrl.setDefaultData();
                ctrl.configButtonVisible = false;
                ctrl.MMPlusRtuSettingFactory.PostChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.data);
            } else {
                ctrl.dataAvailable = true;
                ctrl.configButtonVisible = true;
            }
        }, function (error) {
            //error
        });

        //NOTE: this call has to happen ONLY one time for this tab launch
        //Log tab access event to NLog
        ctrl.MMPlusRtuSettingFactory.postUserAction2Nlog(ctrl.accountInfo.customerId, ctrl.deviceId, "GEN II >> Channel >> Analog Output").then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });
    };

    ctrl.getImei = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loadingInProgress = false;
        });
    };

    ctrl.postData = function (path) {
        var tmpDevice = { "op": "replace", "path": path, "value": ctrl.data[path] };
        ctrl.MMPlusRtuSettingFactory.PatchChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.channelTypeID, ctrl.networkDeviceConfigID, tmpDevice).then(function (result) {
            ctrl.data = result.data;
            ctrl.dataAvailable = true;
            ctrl.configButtonVisible = true;
        }, function (error) {
            //error
        });
    };

    ctrl.setDefaultData = function () {
        ctrl.data = {
            networkDeviceConfigID: ctrl.networkDeviceConfigID,
            deviceID: ctrl.deviceId,
            channelNo: ctrl.channel,
            channelTypeID: 0,
            registerAddr: 40001,
            accessModeID: 0,
            alarmHighRestore: 0,
            alarmHighThreshold: 0,
            alarmLowRestore: 0,
            alarmLowThreshold: 0,
            analogFilterID: 0,
            analogInputHWSetupID: 0,
            bitOfInterest: 0,
            cfgValue: 0,
            deEnergizeOnCommLoss: false,
            debounceTimeSecs: 0,
            electModeID: 0,
            floatToIntegerScale: 0,
            msgTransmitRate: 2,
            pulseTimeSecs: 0,
            regAddressModeID: 1,
            runtimeModeID: 0,
            scalingOffset: 0,
            scalingRange: 0,
            sendOnPercentageChg: 0,
            startUpValue: 0,
            unitOfValueID: 0,
            sampleInterval: 1,
            nonc: false
        };
        ctrl.dataAvailable = true;
    };

    ctrl.configure = function () {
        ctrl.MMPlusRtuSettingFactory.configMMPlusChannel(ctrl.deviceId, ctrl.imei, ctrl.channel, ctrl.data.channelTypeID).then(function (result) {
            //success
            var configResult = result.data.result.match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
            ctrl.alertMessage = "Channel Config " + configResult[0] + ": " + configResult[1];
            ctrl.setTimeOut();
        }, function (error) {
            //error
            ctrl.alertMessage = "Something went wrong while processing channel config request";
            ctrl.setTimeOut();
        });
    };

    ctrl.clickLog = function () {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = ctrl.deviceId;
        optionsStickyProperties.device = { deviceId: ctrl.deviceId, title: "", deviceName: ctrl.deviceSelectedName, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };
        //optionsStickyProperties.channel = { deviceId: ctrl.deviceId, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/log/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };
            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 40;

            //openViewService.openView('MM Plus Config History', { width: 700, height: 400 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });

            openViewService.openView('MM Plus Channel History', { width: 820, height: 420 }, { my: 'right-10 top+6', at: 'right top', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 }, false);
        }
    };

    $scope.$on('syncG2ChannelConfig', function (event, args) {
        if (args.deviceID == ctrl.deviceId) {
            ctrl.channelDeviceConfig = args;
            ctrl.updateChannelConfigData(ctrl.channelDeviceConfig);
        }
    });

    ctrl.updateChannelConfigData = function (channelConfig) {
        ctrl.MMPlusRtuSettingFactory.updateChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.networkDeviceConfigID, channelConfig).then(function (result) {
            ctrl.data = result.data;
        }, function (error) {
            //error
        });
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;

            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    ctrl.alertMessage = null;
                    $timeout(function () {
                        ctrl.getData();
                    }, 0);
                } else {
                    ctrl.data = null;
                    ctrl.alertMessage = "Please configure the device as Gen 2";
                    ctrl.configButtonVisible = false;
                }
            });
        }
    }, true);
};

mmPlusAnalogOutputChannelController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService'];
"use strict";

angular.module("mc.mm-plus-rtu-setting", []);
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusAnalogOutputChannel', {
    controller: mmPlusAnalogOutputChannelController,
    templateUrl: 'ui/mmplusrtusetting/mmPlusChannel/analogOutput/mm-plus-analog-output-channel-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceId: '<'
    }
});
mcapp.directive('convertToNumber', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function(val) {
        return parseInt(val, 10);
      });
      ngModel.$formatters.push(function(val) {
        return '' + val;
      });
    }
  };
});

'use strict';

mcapp.factory("tankAndWellOffPeakGraphicalScheduleService", ['$', '$q', '$timeout', function ($, $q, $timeout) {
    var _this = this;

    var tankAndWellOffPeakGraphicalScheduleFactory = {};

    var schedules = [];
    var scheduleGraphValues = [];
    var _DEBUG = false;

    var _convertChartToSchedule = function _convertChartToSchedule(scheduleGraphData, customerId, startDate, endDate, selectedProfiles) {
        var deferred = $q.defer();

        schedules = [];
        if (!selectedProfiles) {
            // handling wizard scenario
            selectedProfiles = [];
            selectedProfiles.push({ id: -1, label: "", grpId: 1, typeId: 2 }); // adding dummy profile for Navy Blue heading
        }
        var copyScheduleGraphData = angular.copy(scheduleGraphData); //preventing modifying passed parameters
        var prof1ScheduleGraphData = copyScheduleGraphData.filter(function (schedule) {
            return schedule.typeId === 2;
        }); //Navy Blue: first profile selected
        var thisProfile = selectedProfiles.find(function (profile) {
            return profile.typeId === 2;
        });
        if (prof1ScheduleGraphData && thisProfile) {
            for (var i = 0; i < prof1ScheduleGraphData.length; i++) {
                prof1ScheduleGraphData.endTime = getEndTime(prof1ScheduleGraphData[i]);
                addSchedule(prof1ScheduleGraphData[i], customerId, startDate, endDate, thisProfile.id);
            }
        }

        var prof2ScheduleGraphData = copyScheduleGraphData.filter(function (schedule) {
            return schedule.typeId === 3;
        }); //Yellow :second profile selected
        thisProfile = selectedProfiles.find(function (profile) {
            return profile.typeId === 3;
        });
        if (prof2ScheduleGraphData && thisProfile) {
            for (var _i = 0; _i < prof2ScheduleGraphData.length; _i++) {
                prof2ScheduleGraphData.endTime = getEndTime(prof2ScheduleGraphData[_i]);
                addSchedule(prof2ScheduleGraphData[_i], customerId, startDate, endDate, thisProfile.id);
            }
        }

        $timeout(function () {
            deferred.resolve(schedules);
        }, 0);

        return deferred.promise;
    };

    var getEndTime = function getEndTime(schedule) {
        //Remove 1 min from all endTimes
        if (schedule.endTime == "00:00:00") {
            schedule.endTime = "23:59:00";
        } else {
            var endHour = schedule.endTime.substring(0, 2);
            var endMin = schedule.endTime.substring(3, 5);

            //Get end min
            if (endMin == "00") {
                endMin = "59";
                //Get end Hour
                if (parseInt(endHour) != 0) {
                    endHour = parseInt(endHour) - 1;
                    endHour = endHour.toString();
                    endHour = endHour.length == 2 ? endHour : "0" + endHour;
                }
            } else if (endMin == "30") {
                endMin = "29";
            } else {
                endMin = parseInt(endMin) - 1;
                endMin = endMin.toString();
            }
            //Set New End Time
            schedule.endTime = endHour + ':' + endMin + ':00';
        }
    };

    var addSchedule = function addSchedule(schedule, customerId, startDate, endDate, profileId) {
        schedules.push({
            id: -1,
            profileId: profileId,
            customerId: customerId,
            startDate: startDate,
            endDate: endDate,
            dayOfWeek: schedule.dayOfWeek + 1,
            startTime: schedule.startTime,
            endTime: schedule.endTime,
            name: null,
            isDeleted: false
        });
    };

    var _convertScheduleToChart = function _convertScheduleToChart(schedulesGrp) {
        scheduleGraphValues = [];
        //Update endTime add 1 min
        schedulesGrp.wsScheduleList.forEach(function (sch) {
            return endTimeAddMinute(sch);
        });

        //Break apart Single and MultiDay
        var singleDaySchedules = schedulesGrp.wsScheduleList.filter(function (schedule) {
            return schedule.dayOfWeek < 8;
        });
        var multiDaySchedules = schedulesGrp.wsScheduleList.filter(function (schedule) {
            return schedule.dayOfWeek >= 8;
        });

        //Add offpeak values to scheduleGraphValues array
        addSingleDays(singleDaySchedules, schedulesGrp.selectedProfiles, schedulesGrp.id);
        addMultiDays(multiDaySchedules, schedulesGrp.selectedProfiles, schedulesGrp.id);

        //add onPeak values to scheduleGraphValues array
        addOnPeakDays(schedulesGrp.id);
        return scheduleGraphValues;
    };

    var addSingleDays = function addSingleDays(singleDaySchedules, selectedProfiles, groupId) {
        var _loop = function _loop(i) {
            //if it matches with first selected item, then it is Navy blue (TypeId:2), otherwise Yellow (TypeId:3)
            var foundSelectedProfile = selectedProfiles.find(function (uiProfile) {
                return uiProfile.id === singleDaySchedules[i].profileId;
            });
            if (foundSelectedProfile) {
                //selectedProfiles[0].id === singleDaySchedules[i].profileId ? 2 : 3; 
                addScheduleGraphValue(groupId, singleDaySchedules[i], singleDaySchedules[i].dayOfWeek - 1, foundSelectedProfile.typeId);
            }
        };

        //Add Single Days
        for (var i = 0; i < singleDaySchedules.length; i++) {
            _loop(i);
        }
    };

    var addMultiDays = function addMultiDays(multiDaySchedules, selectedProfiles, groupId) {
        var _loop2 = function _loop2(i) {
            //if it matches with first selected item, then it is Navy blue (TypeId:2), otherwise Yellow (TypeId:3)
            //selectedProfiles[0].id === singleDaySchedules[i].profileId ? 2 : 3; 
            var tmpTypeId = 2; //default is Navy blue (TypeId:2)
            var foundSelectedProfile = selectedProfiles.find(function (uiProfile) {
                return uiProfile.id === multiDaySchedules[i].profileId;
            });
            if (foundSelectedProfile) {
                tmpTypeId = foundSelectedProfile.typeId;
            }
            //Add schedules for all Days
            if (multiDaySchedules[i].dayOfWeek === 8) {
                for (var index = 0; index < 7; index++) {
                    addScheduleGraphValue(groupId, multiDaySchedules[i], index, tmpTypeId);
                }
            }
            //Add schedules for Weekdays
            if (multiDaySchedules[i].dayOfWeek == 9) {
                addScheduleGraphValue(groupId, multiDaySchedules[i], 1, tmpTypeId);
                addScheduleGraphValue(groupId, multiDaySchedules[i], 2, tmpTypeId);
                addScheduleGraphValue(groupId, multiDaySchedules[i], 3, tmpTypeId);
                addScheduleGraphValue(groupId, multiDaySchedules[i], 4, tmpTypeId);
                addScheduleGraphValue(groupId, multiDaySchedules[i], 5, tmpTypeId);
            }
            //Add schedules for Weekends
            if (multiDaySchedules[i].dayOfWeek == 10) {
                addScheduleGraphValue(groupId, multiDaySchedules[i], 0, tmpTypeId);
                addScheduleGraphValue(groupId, multiDaySchedules[i], 6, tmpTypeId);
            }
        };

        //Add MultiDays

        //let tmpTypeId = 2; //default is Navy blue (TypeId:2)
        for (var i = 0; i < multiDaySchedules.length; i++) {
            _loop2(i);
        }
    };

    var addOnPeakDays = function addOnPeakDays(groupId) {
        //Add On Peak Days based on offpeak
        var offPeakStart = void 0;
        var offPeakEnd = void 0;

        //filter all by day & create array for each day
        var singleDayFilteredSchedules = [];

        var _loop3 = function _loop3(i) {
            singleDayFilteredSchedules[i] = scheduleGraphValues.filter(function (schedule) {
                return schedule.dayOfWeek == i;
            });
            //sort new array by startTime
            if (singleDayFilteredSchedules[i].length > 1) {
                singleDayFilteredSchedules[i] = singleDayFilteredSchedules[i].sort(function (a, b) {
                    return parseInt(a.startTime.substring(0, 5)) - parseInt(b.startTime.substring(0, 5));
                });
            }
        };

        for (var i = 0; i < 7; i++) {
            _loop3(i);
        }

        var _loop4 = function _loop4(i) {
            var daySchedules = singleDayFilteredSchedules[i];
            var tmpTypeId = 1; //for on-peak schedules, color is green (TypeId:1)
            offPeakStart = false;
            offPeakEnd = false;
            if (daySchedules.length > 1) {
                daySchedules.forEach(function (sch, index) {
                    //Check if offPeak is at start and end 
                    if (sch.startTime == "00:00:00") {
                        offPeakStart = true;
                    }
                    if (sch.endTime == "00:00:00") {
                        offPeakEnd = true;
                    }
                    //create onPeak, with sch endTime and next sch startTime
                    if (typeof daySchedules[index + 1] != 'undefined') {
                        addScheduleGraphValue(groupId, sch, sch.dayOfWeek, tmpTypeId, sch.endTime, daySchedules[index + 1].startTime);
                    }

                    //Check on Last record in array
                    if (index == daySchedules.length - 1) {
                        //Check if day starts onPeak / add time
                        if (!offPeakStart) {
                            addScheduleGraphValue(groupId, daySchedules[0], daySchedules[0].dayOfWeek, tmpTypeId, "00:00:00", daySchedules[0].startTime);
                        }

                        //Check if day end onPeak / add time
                        if (!offPeakEnd) {
                            addScheduleGraphValue(groupId, daySchedules[index], daySchedules[index].dayOfWeek, tmpTypeId, daySchedules[index].endTime, "00:00:00");
                        }
                    }
                });
            } else if (daySchedules.length == 1) {
                //Check if day starts onPeak / add time
                if (daySchedules[0].startTime != "00:00:00") {
                    addScheduleGraphValue(groupId, daySchedules[0], daySchedules[0].dayOfWeek, tmpTypeId, "00:00:00", daySchedules[0].startTime);
                }

                //Check if day end onPeak / add time
                if (daySchedules[0].endTime != "00:00:00") {
                    addScheduleGraphValue(groupId, daySchedules[0], daySchedules[0].dayOfWeek, tmpTypeId, daySchedules[0].endTime, "00:00:00");
                }
            }
            //Check if onPeak all day
            else if (daySchedules.length == 0) {
                    addScheduleGraphValue(groupId, singleDayFilteredSchedules[i], i, tmpTypeId, "00:00:00", "00:00:00");
                }
        };

        for (var i = 0; i < singleDayFilteredSchedules.length; i++) {
            _loop4(i);
        }
    };

    var endTimeAddMinute = function endTimeAddMinute(schedule) {
        //Remove 1 min from all endTimes
        if (schedule.endTime == "23:59:00") {
            schedule.endTime = "00:00:00";
        } else {
            var endHour = schedule.endTime.substring(0, 2);
            var endMin = schedule.endTime.substring(3, 5);

            //Get end min
            if (endMin == "59") {
                endMin = "00";
                //Get end Hour
                if (parseInt(endHour) != 0) {
                    endHour = parseInt(endHour) + 1;
                    endHour = endHour.toString();
                    endHour = endHour.length == 2 ? endHour : "0" + endHour;
                }
            } else if (endMin == "29") {
                endMin = "30";
            } else {
                endMin = parseInt(endMin);
                endMin = endMin.toString();
                endMin = endMin.length == 2 ? endMin : "0" + endMin;
            }
            //Set New End Time
            schedule.endTime = endHour + ':' + endMin + ':00';
        }
    };

    var addScheduleGraphValue = function addScheduleGraphValue(grpId, schedule, dayOfWeek, typeId, onPeakStartTime, onPeakEndTime) {
        scheduleGraphValues.push({
            eventId: 0,
            typeId: typeId,
            dayOfWeek: dayOfWeek,
            startTime: onPeakStartTime || schedule.startTime,
            endTime: onPeakEndTime || schedule.endTime,
            frequency: 5,
            description: null,
            groupId: grpId
        });
    };

    //TypeId => 1: OnPeak, 2: OffPeak1, 3: OffPeak2
    var _scheduleGraphDefaultValues = [{
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 0,
        startTime: '00:00:00',
        endTime: '00:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 1,
        startTime: '00:00:00',
        endTime: '06:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 1,
        profileId: -1,
        dayOfWeek: 1,
        startTime: '06:00:00',
        endTime: '19:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 1,
        startTime: '19:00:00',
        endTime: '00:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 2,
        startTime: '00:00:00',
        endTime: '06:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 1,
        profileId: -1,
        dayOfWeek: 2,
        startTime: '06:00:00',
        endTime: '19:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 2,
        startTime: '19:00:00',
        endTime: '00:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 3,
        startTime: '00:00:00',
        endTime: '06:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 1,
        profileId: -1,
        dayOfWeek: 3,
        startTime: '06:00:00',
        endTime: '19:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 3,
        startTime: '19:00:00',
        endTime: '00:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 4,
        startTime: '00:00:00',
        endTime: '06:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 1,
        profileId: -1,
        dayOfWeek: 4,
        startTime: '06:00:00',
        endTime: '19:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 4,
        startTime: '19:00:00',
        endTime: '00:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 5,
        startTime: '00:00:00',
        endTime: '06:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 1,
        profileId: -1,
        dayOfWeek: 5,
        startTime: '06:00:00',
        endTime: '19:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 5,
        startTime: '19:00:00',
        endTime: '00:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }, {
        eventId: 0,
        typeId: 2,
        profileId: -1,
        dayOfWeek: 6,
        startTime: '00:00:00',
        endTime: '00:00:00',
        frequency: 5,
        description: null,
        groupId: -1
    }];

    var _myShifts = [{ notificationScheduleId: 10, typeId: 1, name: "onPeak", classType: "P" }, { notificationScheduleId: 11, typeId: 2, name: "offPeak1", classType: "O1" }, { notificationScheduleId: 12, typeId: 3, name: "offPeak2", classType: "O2" }];

    var _myDays = [{ dayOfWeek: 0, name: "Sunday" }, { dayOfWeek: 1, name: "Monday" }, { dayOfWeek: 2, name: "Tuesday" }, { dayOfWeek: 3, name: "Wednesday" }, { dayOfWeek: 4, name: "Thursday" }, { dayOfWeek: 5, name: "Friday" }, { dayOfWeek: 6, name: "Saturday" }];

    var _getNotificationScheduleId = function _getNotificationScheduleId(varType) {
        for (var i = 0; i < _myShifts.length; i++) {
            if (_myShifts[i].classType === varType) {
                return _myShifts[i].notificationScheduleId;
            }
        }
        return varType;
    };
    var _getTypeId = function _getTypeId(varType) {
        for (var i = 0; i < _myShifts.length; i++) {
            if (_myShifts[i].classType === varType) {
                return _myShifts[i].typeId;
            }
        }
        return varType;
    };
    var _getClassType = function _getClassType(varTypeId) {
        for (var i = 0; i < _myShifts.length; i++) {
            if (_myShifts[i].typeId === varTypeId) {
                return _myShifts[i].classType;
            }
        }
        return varTypeId;
    };
    var _getShiftName = function _getShiftName(varType) {
        for (var i = 0; i < _myShifts.length; i++) {
            if (_myShifts[i].classType === varType) {
                return _myShifts[i].name;
            }
        }
        return varType;
    };

    var _paintGrid = function _paintGrid(varElement, varRow, varClass, varStartTime, varEndTime) {
        if (_DEBUG) console.log(varRow, varClass, varStartTime, varEndTime);
        $(varElement).find("table").find('tbody').each(function () {
            $(this).find('tr').each(function (i) {
                if (varRow === i) {
                    if (_DEBUG) console.log("--------" + i + "--------");
                    var _match = false;
                    $(this).find('td').each(function () {
                        var _dataSpan = $(this).attr("data-span");
                        if (_DEBUG) console.log(varStartTime, _dataSpan);
                        if (varEndTime === _dataSpan) {
                            _match = false;
                        }
                        if (varStartTime === _dataSpan || _match) {
                            _match = true;
                            if (_DEBUG) console.log("-------- mark --------");
                            //console.log($(this));
                            $(this).removeClass("selectedP selectedO1 selectedO2");
                            //console.log($(this));
                            var newClass = _getClassType(varClass);
                            $(this).addClass("selected" + newClass);
                            //console.log($(this));
                        }
                    });
                }
            });
        });
    };

    var _gridToCalendar = function _gridToCalendar(varElement, grpId) {
        var _myEventTemplate = { notificationScheduleId: null, typeId: null, dayOfWeek: null, startTime: null, endTime: null, groupId: grpId };
        var _myCalendar = { calendarId: null, customerId: null, events: [] };
        _myCalendar.events = [];
        _myCalendar.customerId = _this.customerId;

        $(varElement).find("table").find('tbody').each(function () {
            $(this).find('tr').each(function (i) {
                if (_DEBUG) {
                    console.log("-----------------");
                    console.log("Row: " + _myDays[i].name);
                    console.log("-----------------");
                }
                var _type;
                var _typePr = null;

                var _dataHour = null;
                var _dataMinute = null;
                var _dataMeridiem = null;
                var _dataSpan = null;

                var _printStartTime = false;
                var _printEndTime = false;

                var _needEndTime = false;

                $(this).find('td').each(function () {
                    if ($(this).hasClass("selectable")) {
                        _type = $(this).attr("class").replace("selectable ng-scope selected", "").trim();
                        _dataHour = $(this).attr("data-hour");
                        _dataMinute = ("0" + $(this).attr("data-min")).slice(-2);
                        _dataMeridiem = " " + $(this).attr("data-meridiem");
                        var _dataSpan = $(this).attr("data-span");

                        if (_type !== "" && _type !== _typePr) {
                            _printStartTime = true;
                        }

                        if (_needEndTime && _type !== _typePr) {
                            _printEndTime = true;
                        }

                        if (_printEndTime) {
                            if (_DEBUG) console.log("EndTime: " + _dataHour + ":" + _dataMinute + _dataMeridiem);
                            _printEndTime = false;
                            _needEndTime = false;
                            _myEventTemplate.endTime = _dataSpan;
                            _myCalendar.events.push(_myEventTemplate);
                        }

                        if (_printStartTime) {
                            if (_DEBUG) {
                                console.log("Shift: " + _getShiftName(_type));
                                console.log("Day: " + _myDays[i].name);
                                console.log("StartTime: " + _dataHour + ":" + _dataMinute + _dataMeridiem);
                            }
                            _printStartTime = false;
                            _needEndTime = true;
                            _myEventTemplate = { notificationScheduleId: _getNotificationScheduleId(_type), typeId: _getTypeId(_type), dayOfWeek: _myDays[i].dayOfWeek, startTime: _dataSpan, endTime: null, groupId: grpId };
                        }
                        _typePr = _type;
                    }
                });

                if (_needEndTime) {
                    if (_DEBUG) console.log("EndTime: 12:00 am");
                    _typePr = null;
                    _needEndTime = false;
                    _myEventTemplate.endTime = "00:00:00";
                    _myCalendar.events.push(_myEventTemplate);
                }
            });
        });

        for (var i = 0; i < _myDays.length; i++) {
            _myCalendar.events.push({ notificationScheduleId: _getNotificationScheduleId(""), typeId: _getTypeId(""), dayOfWeek: _myDays[i].dayOfWeek, startTime: "00:00:00", endTime: "00:00:00" });
        }

        if (_DEBUG) {
            console.log("-----------------");
            console.log(_myCalendar);
        }

        return _myCalendar;
    };

    tankAndWellOffPeakGraphicalScheduleFactory.gridToCalendar = _gridToCalendar;
    tankAndWellOffPeakGraphicalScheduleFactory.paintGrid = _paintGrid;
    tankAndWellOffPeakGraphicalScheduleFactory.convertScheduleToChart = _convertScheduleToChart;
    tankAndWellOffPeakGraphicalScheduleFactory.convertChartToSchedule = _convertChartToSchedule;
    tankAndWellOffPeakGraphicalScheduleFactory.scheduleGraphDefaultValues = _scheduleGraphDefaultValues;
    return tankAndWellOffPeakGraphicalScheduleFactory;
}]);

//tankAndWellOffPeakGraphicalScheduleService.$inject = ['$', '$q'];
"use strict";

angular.module("mc.tankandwell-graphical-schedule", []);
"use strict";

function OffpeakGraphicalScheduleController($scope, $http, $location, $window, authenticationService, $rootScope, translationService, sharedSetupService, serviceUserService, notificationGroupDestinationsService, detectBrowserService, $timeout, notificationGroupsService, toaster, openViewService, $element, manageScheduleFactory, scheduleGridFactory, $filter, wizardSplashService, twopGraphScheduleService) {
    var ctrl = this;
    ctrl.groups = [];
    var DEBUG = false;
    ctrl.blEditCalendar = true;
    ctrl.translation = translationService.translation;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.hourToSendLocalTimes = [];
    ctrl.mobile = $rootScope.mobile;
    ctrl.scheduleChanged = false;

    ctrl.$onInit = function () {
        //sharedSetupService.getWindowId(ctrl);
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.initializeSetting();
        init(ctrl.accountInfo.customerId);
        //ctrl.parentToChildChangeNotifyRegistration({ handler: ctrl.processParentProfileChange });
        $timeout(function () {
            setChartHeadings(ctrl.selectedProfiles, ctrl.groupId);
            renderScheduleCalendarFromData();

            //set default schedule class for painting
            ctrl.setScheduleClass(-1);
        }, 0);
    };

    var generateGroupsArray = function generateGroupsArray(grpId) {
        //headingBlueRequired >> Navy Blue and typeId = 2
        //headingYellowRequired >> Yellow and typeId = 3
        //blueProfile >> profile associated with Navy Blue color and typeId = 2
        //yellowProfile >> profile associated with Yellow color and typeId = 3
        var groups = [{ id: 0, headingBlueRequired: null, headingYellowRequired: null, blueProfile: null, yellowProfile: null }];
        for (var i = 1; i <= grpId; i++) {
            groups.push({ id: i, headingBlueRequired: null, headingYellowRequired: null, blueProfile: null, yellowProfile: null });
        }
        return groups;
    };

    var setChartHeadings = function setChartHeadings(selectedProfiles, grpId) {
        //first handle schedules wizard scenario
        if (!grpId) {
            grpId = 1;
        }

        ctrl.groups = generateGroupsArray(grpId); // generate dummy groups

        ctrl.groups[grpId].headingBlueRequired = selectedProfiles.length === 0 || selectedProfiles.findIndex(function (uiProfile) {
            return uiProfile.typeId === 2;
        }) > -1; // Navy Blue schedules
        if (selectedProfiles.findIndex(function (uiProfile) {
            return uiProfile.typeId === 2;
        }) > -1) {
            ctrl.groups[grpId].blueProfile = selectedProfiles.find(function (uiProfile) {
                return uiProfile.typeId === 2;
            });
        } else {
            ctrl.groups[grpId].blueProfile = {};
        }
        if (selectedProfiles.findIndex(function (uiProfile) {
            return uiProfile.typeId === 3;
        }) > -1) {
            ctrl.groups[grpId].headingYellowRequired = true; // Yellow schedules
            ctrl.groups[grpId].yellowProfile = selectedProfiles.find(function (uiProfile) {
                return uiProfile.typeId === 3;
            });
        } else {
            ctrl.groups[grpId].yellowProfile = {};
            ctrl.groups[grpId].headingYellowRequired = false;
        }
        //}
    };

    var _formatTwoDigits = function _formatTwoDigits(varNumber) {
        return ("0" + varNumber).slice(-2);
    };

    var init = function init(custId) {
        ctrl.customerId = custId;
        ctrl.timeGrid = [];
        ctrl.days = [{ id: 'sun' }, { id: 'mon' }, { id: 'tue' }, { id: 'wed' }, { id: 'thu' }, { id: 'fri' }, { id: 'sat' }];
        ctrl.hours = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }, { id: 11 }];

        for (var i = 0; i <= 23; i++) {
            for (var j = 0; j <= 30; j += 30) {
                ctrl.timeGrid.push({ timeSpan: _formatTwoDigits(i) + ":" + _formatTwoDigits(j) + ":" + "00" });
            }
        }
    };

    ctrl.myShifts = ["onPeak", "offPeak1", "offPeak2"];

    if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') {
        ctrl.isAdmin = true;
    }

    var _hourToSendLocalTimes = function _hourToSendLocalTimes() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.hourToSendLocalTimes.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.hourToSendLocalTimes.push(arguments[i]);
            } else {
                ctrl.hourToSendLocalTimes[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        ctrl.dt = new Date();
        _hourToSendLocalTimes({
            "id": 24,
            "name": $filter('date')(ctrl.dt.setHours(24, 0), ctrl.timeFormat)
        }, {
            "id": 1,
            "name": $filter('date')(ctrl.dt.setHours(1, 0), ctrl.timeFormat)
        }, {
            "id": 2,
            "name": $filter('date')(ctrl.dt.setHours(2, 0), ctrl.timeFormat)
        }, {
            "id": 3,
            "name": $filter('date')(ctrl.dt.setHours(3, 0), ctrl.timeFormat)
        }, {
            "id": 4,
            "name": $filter('date')(ctrl.dt.setHours(4, 0), ctrl.timeFormat)
        }, {
            "id": 5,
            "name": $filter('date')(ctrl.dt.setHours(5, 0), ctrl.timeFormat)
        }, {
            "id": 6,
            "name": $filter('date')(ctrl.dt.setHours(6, 0), ctrl.timeFormat)
        }, {
            "id": 7,
            "name": $filter('date')(ctrl.dt.setHours(7, 0), ctrl.timeFormat)
        }, {
            "id": 8,
            "name": $filter('date')(ctrl.dt.setHours(8, 0), ctrl.timeFormat)
        }, {
            "id": 9,
            "name": $filter('date')(ctrl.dt.setHours(9, 0), ctrl.timeFormat)
        }, {
            "id": 10,
            "name": $filter('date')(ctrl.dt.setHours(10, 0), ctrl.timeFormat)
        }, {
            "id": 11,
            "name": $filter('date')(ctrl.dt.setHours(11, 0), ctrl.timeFormat)
        }, {
            "id": 12,
            "name": $filter('date')(ctrl.dt.setHours(12, 0), ctrl.timeFormat)
        }, {
            "id": 13,
            "name": $filter('date')(ctrl.dt.setHours(13, 0), ctrl.timeFormat)
        }, {
            "id": 14,
            "name": $filter('date')(ctrl.dt.setHours(14, 0), ctrl.timeFormat)
        }, {
            "id": 15,
            "name": $filter('date')(ctrl.dt.setHours(15, 0), ctrl.timeFormat)
        }, {
            "id": 16,
            "name": $filter('date')(ctrl.dt.setHours(16, 0), ctrl.timeFormat)
        }, {
            "id": 17,
            "name": $filter('date')(ctrl.dt.setHours(17, 0), ctrl.timeFormat)
        }, {
            "id": 18,
            "name": $filter('date')(ctrl.dt.setHours(18, 0), ctrl.timeFormat)
        }, {
            "id": 19,
            "name": $filter('date')(ctrl.dt.setHours(19, 0), ctrl.timeFormat)
        }, {
            "id": 20,
            "name": $filter('date')(ctrl.dt.setHours(20, 0), ctrl.timeFormat)
        }, {
            "id": 21,
            "name": $filter('date')(ctrl.dt.setHours(21, 0), ctrl.timeFormat)
        }, {
            "id": 22,
            "name": $filter('date')(ctrl.dt.setHours(22, 0), ctrl.timeFormat)
        }, {
            "id": 23,
            "name": $filter('date')(ctrl.dt.setHours(23, 0), ctrl.timeFormat)
        });
    };

    ctrl.getTime = function (td) {
        return function (hour) {
            switch (td) {
                case "am":
                    return hour.id >= 1 && hour.id <= 11 || hour.id === 24;
                    break;
                case "pm":
                    return hour.id >= 13 && hour.id <= 23;
                    break;
            }
        };
    };

    //var scheduleGrid = new scheduleGridFactory(ctrl.accountInfo.customerId);
    //ctrl.timeGrid = scheduleGrid.timeGrid;
    //ctrl.days = scheduleGrid.days;
    //ctrl.hours = scheduleGrid.hours;

    ctrl.getText = function (text) {
        if (!angular.isDefined(text)) return;
        return typeof eval("ctrl.translation.text." + text.toUpperCase().replace(/-/g, "_")) !== 'undefined' ? eval("ctrl.translation.text." + text.toUpperCase().replace(/-/g, "_")) : text;
    };

    ctrl.setScheduleClass = function (id) {
        if (!ctrl.isAdmin) return;
        switch (id) {
            case 1:
                //peak hours
                ctrl.scheduleClass = "selectedP";
                ctrl.scheduleColor = "#138a72"; //green
                ctrl.shiftModel = ctrl.groups[ctrl.groupId];
                break;
            case 2:
                //Off-Peak 1 hours
                ctrl.scheduleClass = "selectedO1";
                ctrl.scheduleColor = "#43668d"; //navy blue
                ctrl.shiftModel = ctrl.groups[ctrl.groupId];
                break;
            case 3:
                //Off-Peak 2 hours
                ctrl.scheduleClass = "selectedO2";
                ctrl.scheduleColor = "#e8db4f"; //Yellow
                ctrl.shiftModel = ctrl.groups[ctrl.groupId];
                break;
            default:
                ctrl.scheduleClass = "selectedO1";
                ctrl.scheduleColor = "#43668d"; //navy blue
                ctrl.shiftModel = ctrl.groups[ctrl.groupId];
                break;
        }

        $element.find('table').awesomeCursor('paint-brush', {
            color: ctrl.scheduleColor,
            size: 22,
            hotspot: [5, 20],
            outline: 'black'
        });
    };

    ctrl.fnToggleSchedule = function (e) {
        if (!ctrl.isAdmin) return;
        if ($(e.target).hasClass(ctrl.scheduleClass)) {
            //$(e.target).removeClass(ctrl.scheduleClass).addClass("selected");
        } else {
            $(e.target).removeClass("selectedP selectedO1 selectedO2");
            $(e.target).addClass(ctrl.scheduleClass);
        }
        ctrl.scheduleChanged = true;
        ctrl.updateGraphData();
    };

    ctrl.changeSchedule = function (e) {
        if (!ctrl.isAdmin) return;
        if (ctrl.mouseDown) {
            $(e.target).removeClass("selectedP selectedO1 selectedO2").addClass(ctrl.scheduleClass);
            ctrl.updateGraphData();
        }
    };

    ctrl.changeScheduleRow = function (e) {
        if (!ctrl.isAdmin) return;
        $(e.target).closest('tr').each(function (i) {
            $(this).find('td').each(function (i1) {
                if ($(this).hasClass("selectable")) $(this).removeClass("selectedP selectedO1 selectedO2").addClass(ctrl.scheduleClass);
            });
        });
        ctrl.scheduleChanged = true;
        ctrl.updateGraphData();
    };

    ctrl.highlightScheduleRow = function (e) {
        if (!ctrl.isAdmin) return;
        $(e.target).closest('tr').each(function (i) {
            $(this).find('td').each(function (i1) {
                if ($(this).hasClass("selectable")) $(this).addClass(ctrl.scheduleClass + "overlay");
            });
        });
        ctrl.updateGraphData();
    };
    ctrl.removeHighlightScheduleRow = function (e) {
        if (!ctrl.isAdmin) return;
        $(e.target).closest('tr').each(function (i) {
            $(this).find('td').each(function (i1) {
                if ($(this).hasClass("selectable")) $(this).removeClass(ctrl.scheduleClass + "overlay");
            });
        });
        ctrl.updateGraphData();
    };

    ctrl.changeScheduleColumn = function (e) {
        if (!ctrl.isAdmin) return;
        if ($(e.target).eq(0)) {
            var cellIndex = $(e.target).eq(0)[0].cellIndex;
            $(e.target).parents("table").find('tbody').each(function (i) {
                $(this).find('tr').each(function (i1) {
                    $(this).find('td:eq(' + (cellIndex * 2 - 1) + '), td:eq(' + cellIndex * 2 + ')').each(function (i1) {
                        if ($(this).hasClass("selectable")) $(this).removeClass("selectedP selectedO1 selectedO2").addClass(ctrl.scheduleClass);
                    });
                });
            });
            ctrl.scheduleChanged = true;
            ctrl.updateGraphData();
        }
    };

    ctrl.highlightScheduleColumn = function (e) {
        if (!ctrl.isAdmin) return;
        if ($(e.target).eq(0)) {
            var cellIndex = $(e.target).eq(0)[0].cellIndex;
            $(e.target).parents("table").find('tbody').each(function (i) {
                $(this).find('tr').each(function (i1) {
                    $(this).find('td:eq(' + (cellIndex * 2 - 1) + '), td:eq(' + cellIndex * 2 + ')').each(function (i1) {
                        if ($(this).hasClass("selectable")) $(this).addClass(ctrl.scheduleClass + "overlay");
                    });
                });
            });
            ctrl.updateGraphData();
        }
    };
    ctrl.removeHighlightScheduleColumn = function (e) {
        if (!ctrl.isAdmin) return;
        if ($(e.target).eq(0)) {
            var cellIndex = $(e.target).eq(0)[0].cellIndex;
            $(e.target).parents("table").find('tbody').each(function (i) {
                $(this).find('tr').each(function (i1) {
                    $(this).find('td:eq(' + (cellIndex * 2 - 1) + '), td:eq(' + cellIndex * 2 + ')').each(function (i1) {
                        if ($(this).hasClass("selectable")) $(this).removeClass(ctrl.scheduleClass + "overlay");
                    });
                });
            });
            ctrl.updateGraphData();
        }
    };

    ctrl.changeScheduleRandC = function (e) {
        if (!ctrl.isAdmin) return;
        $(e.target).parents("table").find('tbody').each(function (i) {
            $(this).find('tr').each(function (i1) {
                $(this).find('td').each(function (i1) {
                    if ($(this).hasClass("selectable")) $(this).removeClass("selectedP selectedO1 selectedO2").addClass(ctrl.scheduleClass);
                });
            });
        });
        ctrl.scheduleChanged = true;
        ctrl.updateGraphData();
    };

    ctrl.highlightScheduleRandC = function (e) {
        if (!ctrl.isAdmin) return;
        $(e.target).parents("table").find('tbody').each(function (i) {
            $(this).find('tr').each(function (i1) {
                $(this).find('td').each(function (i1) {
                    if ($(this).hasClass("selectable")) $(this).addClass(ctrl.scheduleClass + "overlay");
                });
            });
        });
        ctrl.updateGraphData();
    };
    ctrl.removeHighlightScheduleRandC = function (e) {
        if (!ctrl.isAdmin) return;
        $(e.target).parents("table").find('tbody').each(function (i) {
            $(this).find('tr').each(function (i1) {
                $(this).find('td').each(function (i1) {
                    if ($(this).hasClass("selectable")) $(this).removeClass(ctrl.scheduleClass + "overlay");
                });
            });
        });
        ctrl.updateGraphData();
    };

    ctrl.updateGraphData = function (grpId) {
        $timeout(function () {
            var tmpGrpId = grpId ? grpId : ctrl.groupId;
            var currentElement = $element.parent().parent().parent().parent().find('.sch-grp-' + tmpGrpId);
            if (currentElement && currentElement.length > 0) {
                var calendar = twopGraphScheduleService.gridToCalendar(currentElement, tmpGrpId);
                $scope.$emit('tw-sch-calendar-updated', { grpId: tmpGrpId, chartEvents: calendar.events });
                //ctrl.updatedGraphData = calendar.events;
            }
        }, 0);
        //ctrl.updatedGraphData = true;
    };

    var renderScheduleCalendarFromData = function renderScheduleCalendarFromData() {
        for (var i = 0; i < ctrl.scheduleGraphData.length; i++) {
            // render Peak schedules from data
            if (ctrl.scheduleGraphData[i].typeId === 1) twopGraphScheduleService.paintGrid($element, ctrl.scheduleGraphData[i].dayOfWeek, ctrl.scheduleGraphData[i].typeId, ctrl.scheduleGraphData[i].startTime, ctrl.scheduleGraphData[i].endTime);
        }
        for (var i = 0; i < ctrl.scheduleGraphData.length; i++) {
            // render Off-Peak schedules from data
            if (ctrl.scheduleGraphData[i].typeId !== 1) twopGraphScheduleService.paintGrid($element, ctrl.scheduleGraphData[i].dayOfWeek, ctrl.scheduleGraphData[i].typeId, ctrl.scheduleGraphData[i].startTime, ctrl.scheduleGraphData[i].endTime);
        }
    };

    var replaceRemovedSchedulesToPeakSchedules = function replaceRemovedSchedulesToPeakSchedules(grpId, removedTypeId) {
        var savedSchedule = {};
        var currentElement = $element.parent().parent().parent().parent().find('.sch-grp-' + grpId);
        if (currentElement && currentElement.length > 0) {
            ctrl.scheduleGraphData = twopGraphScheduleService.gridToCalendar(currentElement, grpId);
        }
        savedSchedule.events = ctrl.scheduleGraphData.events;
        if (savedSchedule.events.length > 0 && savedSchedule.events[0].groupId === grpId) {
            for (var i = 0; i < savedSchedule.events.length; i++) {
                // mark as peak hours
                if (savedSchedule.events[i].typeId === removedTypeId) twopGraphScheduleService.paintGrid(currentElement, savedSchedule.events[i].dayOfWeek, 1, savedSchedule.events[i].startTime, savedSchedule.events[i].endTime);
            }
            ctrl.scheduleChanged = true;
            ctrl.updateGraphData(grpId);
        }
    };

    ctrl.closeSchedule = function () {
        if (!$rootScope.classicView && !$rootScope.mobile) {
            _this.getExistingDialog(ctrl.windowId).ref.dialog("close");
        } else {
            renderScheduleCalendarFromData();
        }
    };

    var updateChartHeadings = function updateChartHeadings(schedulesGrp) {
        var currentElement = $element.parent().parent().parent().parent().find(".sch-grp-" + schedulesGrp.id + " .com-sch-grp-" + schedulesGrp.id + " .btn-group");
        if (currentElement && currentElement.length > 0) {
            var headingObj = { id: schedulesGrp.id, headingBlueRequired: null, headingYellowRequired: null, blueProfile: null, yellowProfile: null };
            //default navy blue schedules heading is required, even no profiles are selected
            headingObj.headingBlueRequired = schedulesGrp.selectedProfiles.length === 0; // Navy Blue schedules
            if (!headingObj.headingBlueRequired) {
                if (schedulesGrp.selectedProfiles.findIndex(function (uiProfile) {
                    return uiProfile.typeId === 2;
                }) > -1) {
                    headingObj.headingBlueRequired = true;
                    headingObj.blueProfile = schedulesGrp.selectedProfiles.find(function (uiProfile) {
                        return uiProfile.typeId === 2;
                    });
                } else {
                    headingObj.headingBlueRequired = false;
                    headingObj.blueProfile = {};
                }
            }
            if (schedulesGrp.selectedProfiles.findIndex(function (uiProfile) {
                return uiProfile.typeId === 3;
            }) > -1) {
                headingObj.headingYellowRequired = true; // Yellow schedules heading
                headingObj.yellowProfile = schedulesGrp.selectedProfiles.find(function (uiProfile) {
                    return uiProfile.typeId === 3;
                });
            } else {
                headingObj.yellowProfile = {};
                headingObj.headingYellowRequired = false;
            }

            //update chart heading on groups array
            var tmpGroups = generateGroupsArray(schedulesGrp.id); // generate dummy groups
            tmpGroups[schedulesGrp.id] = headingObj;
            ctrl.groups = tmpGroups;

            var tmpElement = null;
            if (headingObj.headingBlueRequired) {
                tmpElement = currentElement.find('.btn-mc-offpeak1');
                $(tmpElement).removeClass("ng-hide");
            } else {
                tmpElement = currentElement.find('.btn-mc-offpeak1');
                $(tmpElement).addClass("ng-hide");
            }
            if (headingObj.headingYellowRequired) {
                tmpElement = currentElement.find('.btn-mc-days');
                $(tmpElement).removeClass("ng-hide");
            } else {
                tmpElement = currentElement.find('.btn-mc-days');
                $(tmpElement).addClass("ng-hide");
            }
        }
    };

    $scope.$on("sch-profile-change", function (event, data) {
        if (ctrl.groupId === data.id) processParentProfileChange(data);
    });

    var processParentProfileChange = function processParentProfileChange(schedulesGrp) {
        ctrl.groupId = schedulesGrp.id;
        ctrl.selectedProfiles = schedulesGrp.selectedProfiles;

        // replace removed profiles' schedules with Peak profile schedules
        if (schedulesGrp.removedProfile) replaceRemovedSchedulesToPeakSchedules(schedulesGrp.id, schedulesGrp.removedProfile.typeId);

        updateChartHeadings(schedulesGrp);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on('$destroy', function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });
};

OffpeakGraphicalScheduleController.$inject = ['$scope', '$http', '$location', '$window', 'authenticationService', '$rootScope', 'translationService', 'sharedSetupService', 'serviceUserService', 'notificationGroupDestinationsService', 'detectBrowserService', '$timeout', 'notificationGroupsService', 'toaster', 'openViewService', '$element', 'manageScheduleFactory', 'scheduleGridFactory', '$filter', 'wizardSplashService', 'tankAndWellOffPeakGraphicalScheduleService'];
'use strict';

angular.module('mc.tankandwell', []);
'use strict';

angular.module('mc.tankandwell').component('offpeakGraphicalSchedule', {
    controller: OffpeakGraphicalScheduleController,
    templateUrl: 'ui/tankandwell/setup/offpeakgraphicalschedule/offpeak-graphical-schedule-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        scheduleGraphData: '=',
        updatedGraphData: '=',
        scheduleChanged: '=',
        selectedProfiles: '<',
        parentToChildChangeNotifyRegistration: '&',
        groupId: '<'
    }
});
'use strict';

function mmPlusPulseInputChannelController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, MMPlusRtuSettingFactory, deviceService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = ctrl.stickyProperties;
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.channel = 1;
        ctrl.channelTypeID = 2;
        ctrl.loading = true;
        ctrl.channels = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];
        ctrl.channelTypeName = 'PI Pulse Input channel';
    };

    ctrl.getData = function () {
        ctrl.MMPlusRtuSettingFactory.getData(ctrl.deviceId, ctrl.channel, ctrl.channelTypeID).then(function (result) {
            ctrl.data = result.data;
            ctrl.networkDeviceConfigID = ctrl.data.networkDeviceConfigID;
            ctrl.loading = false;
            ctrl.getImei();
            if (!ctrl.data) {
                ctrl.dataAvailable = false;
                ctrl.setDefaultData();
                ctrl.configButtonVisible = false;
                ctrl.MMPlusRtuSettingFactory.PostChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.data);
            } else {
                ctrl.dataAvailable = true;
                ctrl.configButtonVisible = true;
            }
        }, function (error) {
            //error
        });

        //NOTE: this call has to happen ONLY one time for this tab launch
        //Log tab access event to NLog
        ctrl.MMPlusRtuSettingFactory.postUserAction2Nlog(ctrl.accountInfo.customerId, ctrl.deviceId, "GEN II >> Channel >> Pulse Input").then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });
    };

    ctrl.getImei = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loadingInProgress = false;
        });
    };

    ctrl.postData = function (path) {
        var tmpDevice = { "op": "replace", "path": path, "value": ctrl.data[path] };
        ctrl.MMPlusRtuSettingFactory.PatchChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.channelTypeID, ctrl.networkDeviceConfigID, tmpDevice).then(function (result) {
            ctrl.data = result.data;
            ctrl.dataAvailable = true;
            ctrl.configButtonVisible = true;
        }, function (error) {
            //error
        });
    };

    ctrl.setDefaultData = function () {
        ctrl.data = {
            networkDeviceConfigID: ctrl.networkDeviceConfigID,
            deviceID: ctrl.deviceId,
            channelNo: ctrl.channel,
            channelTypeID: 0,
            registerAddr: 40001,
            accessModeID: 0,
            alarmHighRestore: 0,
            alarmHighThreshold: 0,
            alarmLowRestore: 0,
            alarmLowThreshold: 0,
            analogFilterID: 0,
            analogInputHWSetupID: 0,
            bitOfInterest: 0,
            cfgValue: 0,
            deEnergizeOnCommLoss: false,
            debounceTimeSecs: 0,
            electModeID: 0,
            floatToIntegerScale: 0,
            msgTransmitRate: 2,
            pulseTimeSecs: 0,
            regAddressModeID: 1,
            runtimeModeID: 0,
            scalingOffset: 0,
            scalingRange: 0,
            sendOnPercentageChg: 0,
            startUpValue: 0,
            unitOfValueID: 0,
            sampleInterval: 1,
            nonc: false
        };
        ctrl.dataAvailable = true;
    };

    ctrl.configure = function () {
        ctrl.MMPlusRtuSettingFactory.configMMPlusChannel(ctrl.deviceId, ctrl.imei, ctrl.channel, ctrl.data.channelTypeID).then(function (result) {
            //success
            var configResult = result.data.result.match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
            ctrl.alertMessage = "Channel Config " + configResult[0] + ": " + configResult[1];
            ctrl.setTimeOut();
        }, function (error) {
            //error
            ctrl.alertMessage = "Something went wrong while processing channel config request";
            ctrl.setTimeOut();
        });
    };

    ctrl.clickLog = function () {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = ctrl.deviceId;
        optionsStickyProperties.device = { deviceId: ctrl.deviceId, title: "", deviceName: ctrl.deviceSelectedName, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };
        //optionsStickyProperties.channel = { deviceId: ctrl.deviceId, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/log/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };
            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 40;

            //openViewService.openView('MM Plus Config History', { width: 700, height: 400 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });

            openViewService.openView('MM Plus Channel History', { width: 820, height: 420 }, { my: 'right-10 top+6', at: 'right top', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 }, false);
        }
    };

    $scope.$on('syncG2ChannelConfig', function (event, args) {
        if (args.deviceID == ctrl.deviceId) {
            ctrl.channelDeviceConfig = args;
            ctrl.updateChannelConfigData(ctrl.channelDeviceConfig);
        }
    });

    ctrl.updateChannelConfigData = function (channelConfig) {
        ctrl.MMPlusRtuSettingFactory.updateChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.networkDeviceConfigID, channelConfig).then(function (result) {
            ctrl.data = result.data;
        }, function (error) {
            //error
        });
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;

            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    ctrl.alertMessage = null;
                    $timeout(function () {
                        ctrl.getData();
                    }, 0);
                } else {
                    ctrl.data = null;
                    ctrl.alertMessage = "Please configure the device as Gen 2";
                    ctrl.configButtonVisible = false;
                }
            });
        }
    }, true);
};

mmPlusPulseInputChannelController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusPulseInputChannel', {
    controller: mmPlusPulseInputChannelController,
    templateUrl: 'ui/mmplusrtusetting/mmPlusChannel/pulseInput/mm-plus-pulse-input-channel-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceId: '<'
    }
});
'use strict';

function mmPlusRegisterIoChannelController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, MMPlusRtuSettingFactory, deviceService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = ctrl.stickyProperties;
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.channel = 1;
        ctrl.channelTypeID = 3;
        ctrl.loading = true;
        ctrl.channels = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];
        ctrl.channelTypeName = '(RIO)	Register I/O channel';
        ctrl.accessMode = [{ id: 0, name: 'Read' }, { id: 1, name: 'Write' }, { id: 2, name: 'Read/Write' }];
    };

    ctrl.getData = function () {
        ctrl.MMPlusRtuSettingFactory.getData(ctrl.deviceId, ctrl.channel, ctrl.channelTypeID).then(function (result) {
            ctrl.data = result.data;
            ctrl.networkDeviceConfigID = ctrl.data.networkDeviceConfigID;
            ctrl.loading = false;
            ctrl.getImei();
            if (!ctrl.data) {
                ctrl.dataAvailable = false;
                ctrl.setDefaultData();
                ctrl.configButtonVisible = false;
                ctrl.MMPlusRtuSettingFactory.PostChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.data);
            } else {
                ctrl.dataAvailable = true;
                ctrl.configButtonVisible = true;
            }
        }, function (error) {
            //error
        });

        //NOTE: this call has to happen ONLY one time for this tab launch
        //Log tab access event to NLog
        ctrl.MMPlusRtuSettingFactory.postUserAction2Nlog(ctrl.accountInfo.customerId, ctrl.deviceId, "GEN II >> Channel >> Register IO").then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });
    };

    ctrl.getImei = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loadingInProgress = false;
        });
    };

    ctrl.postData = function (path) {
        var tmpDevice = { "op": "replace", "path": path, "value": ctrl.data[path] };
        ctrl.MMPlusRtuSettingFactory.PatchChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.channelTypeID, ctrl.networkDeviceConfigID, tmpDevice).then(function (result) {
            ctrl.data = result.data;
            ctrl.dataAvailable = true;
            ctrl.configButtonVisible = true;
        }, function (error) {
            //error
        });
    };

    ctrl.setDefaultData = function () {
        ctrl.data = {
            networkDeviceConfigID: ctrl.networkDeviceConfigID,
            deviceID: ctrl.deviceId,
            channelNo: ctrl.channel,
            channelTypeID: 0,
            registerAddr: 40001,
            accessModeID: 0,
            alarmHighRestore: 0,
            alarmHighThreshold: 0,
            alarmLowRestore: 0,
            alarmLowThreshold: 0,
            analogFilterID: 0,
            analogInputHWSetupID: 0,
            bitOfInterest: 0,
            cfgValue: 0,
            deEnergizeOnCommLoss: false,
            debounceTimeSecs: 0,
            electModeID: 0,
            floatToIntegerScale: 0,
            msgTransmitRate: 2,
            pulseTimeSecs: 0,
            regAddressModeID: 1,
            runtimeModeID: 0,
            scalingOffset: 0,
            scalingRange: 0,
            sendOnPercentageChg: 0,
            startUpValue: 0,
            unitOfValueID: 0,
            sampleInterval: 1,
            nonc: false
        };
        ctrl.dataAvailable = true;
    };

    ctrl.configure = function () {
        ctrl.MMPlusRtuSettingFactory.configMMPlusChannel(ctrl.deviceId, ctrl.imei, ctrl.channel, ctrl.data.channelTypeID).then(function (result) {
            //success
            var configResult = result.data.result.match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
            ctrl.alertMessage = "Channel Config " + configResult[0] + ": " + configResult[1];
            ctrl.setTimeOut();
        }, function (error) {
            //error
            ctrl.alertMessage = "Something went wrong while processing channel config request";
            ctrl.setTimeOut();
        });
    };

    ctrl.clickLog = function () {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = ctrl.deviceId;
        optionsStickyProperties.device = { deviceId: ctrl.deviceId, title: "", deviceName: ctrl.deviceSelectedName, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };
        //optionsStickyProperties.channel = { deviceId: ctrl.deviceId, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/log/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };
            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 40;

            //openViewService.openView('MM Plus Config History', { width: 700, height: 400 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });

            openViewService.openView('MM Plus Channel History', { width: 820, height: 420 }, { my: 'right-10 top+6', at: 'right top', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 }, false);
        }
    };

    $scope.$on('syncG2ChannelConfig', function (event, args) {
        if (args.deviceID == ctrl.deviceId) {
            ctrl.channelDeviceConfig = args;
            ctrl.updateChannelConfigData(ctrl.channelDeviceConfig);
        }
    });

    ctrl.updateChannelConfigData = function (channelConfig) {
        ctrl.MMPlusRtuSettingFactory.updateChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.networkDeviceConfigID, channelConfig).then(function (result) {
            ctrl.data = result.data;
        }, function (error) {
            //error
        });
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;

            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    ctrl.alertMessage = null;
                    $timeout(function () {
                        ctrl.getData();
                    }, 0);
                } else {
                    ctrl.data = null;
                    ctrl.alertMessage = "Please configure the device as Gen 2";
                    ctrl.configButtonVisible = false;
                }
            });
        }
    }, true);
};

mmPlusRegisterIoChannelController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusRegisterIoChannel', {
    controller: mmPlusRegisterIoChannelController,
    templateUrl: 'ui/mmplusrtusetting/mmPlusChannel/registerIO/mm-plus-register-io-channel-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceId: '<'
    }
});
(function() {
    mcapp.directive('scadaSwitchGroup', [
        'authenticationService', function(authenticationService) {
            return {
                restrict: 'EA',
                transclude: false,
                scope: true,
                replace: true,
                link: function(scope, elem, attrs) {
                    var switchTexts = [];
                    scope.inGroup = true;

                    scope.addSwitchTexts = function(arr) {
                        switchTexts = switchTexts.concat(arr);
                    };

                    scope.determineSwitchWidths = function() {
                        //Cheap way; Determine by max char length
                        if (!!authenticationService.getAccountInfo()) { //scada-1254 (NOTE: could not find the reference to this directive anywhere???
                            var charWidth = authenticationService.getAccountInfo().preferenceUser.i18nCode == 'zh-cn' ? 12 : 6;
                            var longest = switchTexts.sort(function (a, b) { return b.length - a.length; })[0];
                            if (longest)
                                return longest.length * charWidth + (!_.isUndefined(attrs.smallerButtons) ? 12 : 26);
                            return 0;
                        }
                        return 0;

                        //TODO? More precise way; Determine by max span width
                    };

                    scope.$on('updatePreferencesLanguage', function() {
                        switchTexts.length = 0;
                    });
                }
            };
        }
    ]);
}());

'use strict';

function SwitchDirective($timeout) {
  return {
    restrict: 'E',
    transclude: false,
    replace: true,
    require: 'ngModel',
    templateUrl: 'ui/components/directives/switch/switch-directive.html',
    scope: {
      animate: '=',
      onResize: '=',
      externalChanges: '=',
      onVal: '@',
      onText: '@',
      offVal: '@',
      offText: '@',
      offColor: '@',
      switchLabel: '@',
      // Space separated id(s) of visible element(s) that name the switch (aria-labelledby). Takes precedence over switch-label
      switchLabelledBy: '@',
      setWidth: '@width',
      setHeight: '@height'
    },
    link: function link(scope, elem, attrs, ngModel) {
      var DEFAULT_ON = 'ON';
      var DEFAULT_OFF = 'OFF';
      var DEFAULT_WRAPPER_WIDTH = 108;
      var DEFAULT_CONTAINER_WIDTH = 159;
      var initialLoad = true;

      var onLoad = scope.$watch(function () {
        return ngModel.$modelValue;
      }, function (newVal, oldVal) {
        if (typeof newVal !== 'undefined') {
          // Only on initial load to prevent pollution of switch texts array in instances where the watcher needs to be left alive
          if (scope.$parent.inGroup && initialLoad) {
            scope.$parent.addSwitchTexts([scope.onText || DEFAULT_ON, scope.offText || DEFAULT_OFF]);
          }

          initialLoad = false;

          // Determine if the switch is initially on or off based on the model value compared against the provided 'on' value
          if (scope.onVal && newVal === scope.onVal || !scope.onVal && newVal === true) {
            scope.isOn = true;
          } else {
            scope.isOn = false;
          }

          // If the components ng-model property can be altered by an external source we need to maintain this watch in order to change the switch itself
          if (!scope.externalChanges) {
            // If the watch isn't needed to monitor for external changes to the model value, cancel it
            onLoad();
          }
        }
      });

      // Text to be displayed in grey on the divider
      scope.hiddenText = function () {
        if (scope.isOn) {
          return scope.offText || DEFAULT_OFF;
        }

        return scope.onText || DEFAULT_ON;
      };

      // Accessible name announced by screen readers. Falls back to "<on> / <off>" when no switch-label is provided
      scope.getAriaLabel = function () {
        if (scope.switchLabel) {
          return scope.switchLabel;
        }

        return (scope.onText || DEFAULT_ON) + ' / ' + (scope.offText || DEFAULT_OFF);
      };

      // On switch click/toggle
      scope.toggle = function () {
        if (scope.isOn) {
          ngModel.$setViewValue(scope.offVal || false);
        } else {
          ngModel.$setViewValue(scope.onVal || true);
        }

        ngModel.$render();
        scope.isOn = !scope.isOn;
      };

      // Keyboard support: Space and Enter toggle the switch, matching native checkbox/switch behaviour
      scope.onKeydown = function ($event) {
        var key = $event.key || $event.keyCode;
        var isSpace = key === ' ' || key === 'Spacebar' || key === 32;
        var isEnter = key === 'Enter' || key === 13;

        if (isSpace || isEnter) {
          // Prevent Space from scrolling the page
          $event.preventDefault();
          scope.toggle();
        }
      };

      // Width of a switch segment
      scope.getWidth = function () {
        return scope.setWidth;
      };

      scope.getWrapperWidth = function () {
        if (scope.setWidth) {
          // Switch wrapper needs to be twice the width of a switch segment (On or Off/Divider) with 2 pixels for padding
          return scope.setWidth * 2 + 2;
        }

        return DEFAULT_WRAPPER_WIDTH;
      };

      scope.getContainerWidth = function () {
        if (scope.setWidth) {
          // Container needs to be three times the width of a switch segment (On/Divider/Off)
          return scope.setWidth * 3;
        }

        return DEFAULT_CONTAINER_WIDTH;
      };

      // When switching languages update the parent switch texts array
      scope.$on('updatePreferencesLanguage', function () {
        $timeout(function () {
          if (scope.$parent.addSwitchTexts) {
            scope.$parent.addSwitchTexts([scope.onText || DEFAULT_ON, scope.offText || DEFAULT_OFF]);
          }
        });
      });

      if (scope.$parent.determineSwitchWidths) {
        // If any external event causes the switch group to recalculate switch width
        scope.$watch(function () {
          return scope.$parent.determineSwitchWidths();
        }, function (newVal, oldVal) {
          if (newVal && newVal !== oldVal) {
            scope.setWidth = newVal;
            if (scope.onResize) {
              scope.onResize();
            }
          }
        });

        // Wait for the first digest cycle to complete to give the switch group time to calculate ideal switch width
        $timeout(function () {
          scope.setWidth = scope.$parent.determineSwitchWidths();
          if (scope.onResize) {
            scope.onResize();
          }
        });
      }
    }
  };
}

SwitchDirective.$inject = ['$timeout'];

angular.module('mcapp').directive('scadaSwitch', SwitchDirective);
(function () {
    // Registering a second 'bsSwitch' directive lets every bs-switch in the app also toggle with Enter,
    // without touching the vendored angular-bootstrap-switch code or each individual template.
    mcapp.directive('bsSwitch', function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.on('keydown.bsSwitchEnterKey', function (e) {
                    var key = e.key || e.which || e.keyCode;

                    if (key === 'Enter' || key === 13) {
                        // Stop Enter from submitting an enclosing form
                        e.preventDefault();
                        e.stopPropagation();

                        // toggleState fires change.bootstrapSwitch -> switchChange.bootstrapSwitch,
                        // which angular-bootstrap-switch already uses to update ng-model
                        element.bootstrapSwitch('toggleState');
                    }
                });

                scope.$on('$destroy', function () {
                    element.off('keydown.bsSwitchEnterKey');
                });
            }
        };
    });
}());

'use strict';

function mmPlusDigitalOutputChannelController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, MMPlusRtuSettingFactory, deviceService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = ctrl.stickyProperties;
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        //fetch device details
        ctrl.myDevice = deviceMenuService.getDevice(ctrl.stickyProperties.deviceId);

        ctrl.channel = 1;
        ctrl.channelTypeID = 5;
        ctrl.loading = true;
        ctrl.channels = getDigitalOutputChannels(ctrl.myDevice.maxDigitalOutputs);
        //[{ id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }, { id: 11 }, { id: 12 },
        //                   { id: 13 },{ id: 14 }, { id: 15 }, { id: 16 } ,{ id: 17 }, { id: 18 }, { id: 19 }];

        ctrl.channelTypeName = '(DO) Digital Output channel';
        ctrl.regAddrMode = [{ id: 1, name: 'USE COIL ADDRESS' }, { id: 2, name: 'USE REGISTER ADDRESS' }];
    };
    var getDigitalOutputChannels = function getDigitalOutputChannels(maxChannels) {
        var channels = [];
        for (var i = 1; i <= maxChannels; i++) {
            channels.push({ id: i });
        }
        return channels;
    };
    ctrl.getData = function () {
        ctrl.MMPlusRtuSettingFactory.getData(ctrl.deviceId, ctrl.channel, ctrl.channelTypeID).then(function (result) {
            ctrl.data = result.data;
            ctrl.networkDeviceConfigID = ctrl.data.networkDeviceConfigID;
            ctrl.loading = false;
            ctrl.getImei();
            if (!ctrl.data) {
                ctrl.dataAvailable = false;
                ctrl.setDefaultData();
                ctrl.configButtonVisible = false;
                ctrl.MMPlusRtuSettingFactory.PostChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.data);
            } else {
                ctrl.dataAvailable = true;
                ctrl.configButtonVisible = true;
            }
        }, function (error) {
            //error
        });

        //NOTE: this call has to happen ONLY one time for this tab launch
        //Log tab access event to NLog
        ctrl.MMPlusRtuSettingFactory.postUserAction2Nlog(ctrl.accountInfo.customerId, ctrl.deviceId, "GEN II >> Channel >> Digital Output").then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });
    };

    ctrl.getImei = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loadingInProgress = false;
        });
    };

    ctrl.postData = function (path) {
        var tmpDevice = { "op": "replace", "path": path, "value": ctrl.data[path] };
        console.log(tmpDevice);
        ctrl.MMPlusRtuSettingFactory.PatchChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.channelTypeID, ctrl.networkDeviceConfigID, tmpDevice).then(function (result) {
            ctrl.data = result.data;
            ctrl.dataAvailable = true;
            ctrl.configButtonVisible = true;
        }, function (error) {
            //error
        });
    };

    ctrl.setDefaultData = function () {
        ctrl.data = {
            networkDeviceConfigID: ctrl.networkDeviceConfigID,
            deviceID: ctrl.deviceId,
            channelNo: ctrl.channel,
            channelTypeID: 0,
            registerAddr: 40001,
            accessModeID: 0,
            alarmHighRestore: 0,
            alarmHighThreshold: 0,
            alarmLowRestore: 0,
            alarmLowThreshold: 0,
            analogFilterID: 0,
            analogInputHWSetupID: 0,
            bitOfInterest: 0,
            cfgValue: 0,
            deEnergizeOnCommLoss: false,
            debounceTimeSecs: 0,
            electModeID: 0,
            floatToIntegerScale: 0,
            msgTransmitRate: 2,
            pulseTimeSecs: 0,
            regAddressModeID: 1,
            runtimeModeID: 0,
            scalingOffset: 0,
            scalingRange: 0,
            sendOnPercentageChg: 0,
            startUpValue: 0,
            unitOfValueID: 0,
            sampleInterval: 1,
            nonc: false
        };
        ctrl.dataAvailable = true;
    };

    ctrl.configure = function () {
        ctrl.MMPlusRtuSettingFactory.configMMPlusChannel(ctrl.deviceId, ctrl.imei, ctrl.channel, ctrl.data.channelTypeID).then(function (result) {
            //success
            var configResult = result.data.result.match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
            ctrl.alertMessage = "Channel Config " + configResult[0] + ": " + configResult[1];
            ctrl.setTimeOut();
        }, function (error) {
            //error
            ctrl.alertMessage = "Something went wrong while processing channel config request";
            ctrl.setTimeOut();
        });
    };

    ctrl.clickLog = function () {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = ctrl.deviceId;
        optionsStickyProperties.device = { deviceId: ctrl.deviceId, title: "", deviceName: ctrl.deviceSelectedName, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };
        //optionsStickyProperties.channel = { deviceId: ctrl.deviceId, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/log/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };
            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 40;

            //openViewService.openView('MM Plus Config History', { width: 700, height: 400 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });

            openViewService.openView('MM Plus Channel History', { width: 820, height: 420 }, { my: 'right-10 top+6', at: 'right top', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 }, false);
        }
    };

    $scope.$on('syncG2ChannelConfig', function (event, args) {
        if (args.deviceID == ctrl.deviceId) {
            ctrl.channelDeviceConfig = args;
            ctrl.updateChannelConfigData(ctrl.channelDeviceConfig);
        }
    });

    //getChannelConfigHistory = customerId, deviceId, channel, netwrokDeviceConfigID, channelConfig
    ctrl.updateChannelConfigData = function (channelConfig) {
        ctrl.MMPlusRtuSettingFactory.updateChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.networkDeviceConfigID, channelConfig).then(function (result) {
            ctrl.data = result.data;
        }, function (error) {
            //error
        });
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;

            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    ctrl.alertMessage = null;
                    $timeout(function () {
                        ctrl.getData();
                    }, 0);
                } else {
                    ctrl.data = null;
                    ctrl.alertMessage = "Please configure the device as Gen 2";
                    ctrl.configButtonVisible = false;
                }
            });
        }
    }, true);
};

mmPlusDigitalOutputChannelController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusDigitalOutputChannel', {
    controller: mmPlusDigitalOutputChannelController,
    templateUrl: 'ui/mmplusrtusetting/mmPlusChannel/digitalOutput/mm-plus-digital-output-channel-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceId: '<'
    }
});
'use strict';

function mmPlusDigitalChannelController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, MMPlusRtuSettingFactory, deviceService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = ctrl.stickyProperties;
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);

        //fetch device details
        ctrl.myDevice = deviceMenuService.getDevice(ctrl.stickyProperties.deviceId);

        ctrl.channel = 1;
        ctrl.channelTypeID = 1;
        ctrl.loading = true;

        ctrl.channels = getDigitalInputChannels(ctrl.myDevice.maxDigitalInputs);

        ctrl.electMode = [{ id: 0, name: 'DIGITAL_DRY_CONTACT' }, { id: 1, name: 'DIGITAL_DRY_CONTACT_NF' }, { id: 2, name: 'DIGITAL_LOAD_SENSOR' }, { id: 3, name: 'DIGITAL_LOAD_SENSOR_NF' }];
        ctrl.runtimeMode = [{ id: 0, name: 'Digital Input Disabled' }, { id: 1, name: 'Digital Input Runtime' }, { id: 2, name: 'Digital Input Alarm' }, { id: 3, name: 'Digital Input Sim. Runtime' }];

        ctrl.channelTypeName = '(DI) Digital Input channel';

        ctrl.digitalDebounceTimeSeconds = [{ id: 1, name: '1' }, { id: 2, name: '2' }, { id: 3, name: '3' }, { id: 4, name: '4' }, { id: 5, name: '5' }];
    };

    var getDigitalInputChannels = function getDigitalInputChannels(maxChannels) {
        var channels = [];
        for (var i = 1; i <= maxChannels; i++) {
            channels.push({ id: i });
        }
        return channels;
    };

    ctrl.getDigitalData = function () {
        ctrl.MMPlusRtuSettingFactory.getData(ctrl.deviceId, ctrl.channel, ctrl.channelTypeID).then(function (result) {
            ctrl.data = result.data;
            ctrl.networkDeviceConfigID = ctrl.data.networkDeviceConfigID;
            ctrl.loading = false;
            ctrl.getImei(); //TODO: already we have reference to ctrl.myDevice, so this service call may not be required
            if (!ctrl.data) {
                ctrl.dataAvailable = false;
                ctrl.setDefaultData();
                ctrl.configButtonVisible = false;
                ctrl.MMPlusRtuSettingFactory.PostChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.data);
            } else {
                ctrl.dataAvailable = true;
                ctrl.configButtonVisible = true;
            }
        }, function (error) {
            //error
            console.log("Error", error);
        });

        //NOTE: this call has to happen ONLY one time for this tab launch
        //Log tab access event to NLog
        ctrl.MMPlusRtuSettingFactory.postUserAction2Nlog(ctrl.accountInfo.customerId, ctrl.deviceId, "GEN II >> Channel >> Digital").then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });
    };

    ctrl.getImei = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loadingInProgress = false;
        });
    };

    ctrl.postData = function (path) {
        var tmpDevice = { "op": "replace", "path": path, "value": ctrl.data[path] };
        console.log(tmpDevice);
        ctrl.MMPlusRtuSettingFactory.PatchChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.channelTypeID, ctrl.networkDeviceConfigID, tmpDevice).then(function (result) {
            ctrl.data = result.data;
            ctrl.dataAvailable = true;
            ctrl.configButtonVisible = true;
        }, function (error) {
            //error
        });
    };

    ctrl.setDefaultData = function () {
        ctrl.data = {
            networkDeviceConfigID: ctrl.networkDeviceConfigID,
            deviceID: ctrl.deviceId,
            channelNo: ctrl.channel,
            channelTypeID: 0,
            registerAddr: 40001,
            accessModeID: 0,
            alarmHighRestore: 0,
            alarmHighThreshold: 0,
            alarmLowRestore: 0,
            alarmLowThreshold: 0,
            analogFilterID: 0,
            analogInputHWSetupID: 0,
            bitOfInterest: 0,
            cfgValue: 0,
            deEnergizeOnCommLoss: false,
            debounceTimeSecs: 0,
            electModeID: 0,
            floatToIntegerScale: 0,
            msgTransmitRate: 2,
            pulseTimeSecs: 0,
            regAddressModeID: 1,
            runtimeModeID: 0,
            scalingOffset: 0,
            scalingRange: 0,
            sendOnPercentageChg: 0,
            startUpValue: 0,
            unitOfValueID: 0,
            sampleInterval: 1,
            nonc: false
        };
        ctrl.dataAvailable = true;
    };

    ctrl.configure = function () {
        ctrl.MMPlusRtuSettingFactory.configMMPlusChannel(ctrl.deviceId, ctrl.imei, ctrl.channel, ctrl.data.channelTypeID).then(function (result) {
            //success
            var configResult = result.data.result.match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
            ctrl.alertMessage = "Channel Config " + configResult[0] + ": " + configResult[1];
            ctrl.setTimeOut();
        }, function (error) {
            //error
            ctrl.alertMessage = "Something went wrong while processing channel config request";
            ctrl.setTimeOut();
        });
    };

    ctrl.clickLog = function () {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = ctrl.deviceId;
        optionsStickyProperties.device = { deviceId: ctrl.deviceId, title: "", deviceName: ctrl.deviceSelectedName, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };
        //optionsStickyProperties.channel = { deviceId: ctrl.deviceId, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/log/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };
            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 40;

            //openViewService.openView('MM Plus Config History', { width: 700, height: 400 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });

            openViewService.openView('MM Plus Channel History', { width: 820, height: 420 }, { my: 'right-10 top+6', at: 'right top', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 }, false);
        }
    };

    $scope.$on('syncG2ChannelConfig', function (event, args) {
        if (args.deviceID == ctrl.deviceId) {
            ctrl.channelDeviceConfig = args;
            ctrl.updateChannelConfigData(ctrl.channelDeviceConfig);
        }
    });

    //getChannelConfigHistory = customerId, deviceId, channel, netwrokDeviceConfigID, channelConfig
    ctrl.updateChannelConfigData = function (channelConfig) {
        ctrl.MMPlusRtuSettingFactory.updateChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.networkDeviceConfigID, channelConfig).then(function (result) {
            ctrl.data = result.data;
        }, function (error) {
            //error
        });
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;

            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    ctrl.alertMessage = null;
                    $timeout(function () {
                        ctrl.getDigitalData();
                    }, 0);
                } else {
                    ctrl.data = null;
                    ctrl.alertMessage = "Please configure the device as Gen 2";
                    ctrl.configButtonVisible = false;
                }
            });
        }
    }, true);
};

mmPlusDigitalChannelController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusDigitalChannel', {
    controller: mmPlusDigitalChannelController,
    templateUrl: 'ui/mmplusrtusetting/mmPlusChannel/digital/mm-plus-digital-channel-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceId: '<'
    }
});
'use strict';

function mmPlusAnalogChannelController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, MMPlusRtuSettingFactory, deviceService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = ctrl.stickyProperties;
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.channel = 1;
        ctrl.channelTypeID = 0;
        ctrl.hasModbusRTU = false;
        ctrl.loading = true;
        //fetch device details
        ctrl.myDevice = deviceMenuService.getDevice(ctrl.stickyProperties.deviceId);

        ctrl.channels = getAnalogInputChannels(ctrl.myDevice.maxAnalogInputs);

        ctrl.analogInputHWSetup = [{ id: 0, name: '(Volts) MyDro HW & Adams Modules' }, { id: 1, name: '(4-20 mA) MyDro HW & Adams Modules' }, { id: 2, name: '(0-20 mA) Adams Modules' }, { id: 3, name: 'Device Formula' }];
        ctrl.unitOfValue = [{ id: 0, name: 'Volts' }, { id: 1, name: 'mA' }, { id: 2, name: 'Amps' }, { id: 3, name: 'Feet' }, { id: 4, name: 'Inches' }, { id: 5, name: 'Meters' }, { id: 6, name: 'mm' }, { id: 7, name: 'GPM' }, { id: 8, name: 'PSI' }, { id: 9, name: 'pH' }, { id: 10, name: 'NTU' }, { id: 11, name: '%' }, { id: 12, name: 'ppm' }, { id: 13, name: 'MGD' }, { id: 14, name: 'mg/l' }, { id: 15, name: 'Hz' }, { id: 16, name: 'C' }, { id: 17, name: 'F' }, { id: 18, name: 'gal' }, { id: 19, name: 'KGal' }, { id: 20, name: 'lbs' }, { id: 21, name: 'uS' }, { id: 23, name: 'Centimeters' }];
        ctrl.analogFilter = [{ id: 0, name: 'Default FIR filter - 5 sample, equal weights' }, { id: 1, name: 'IIR Filter - Fast Beta' }, { id: 2, name: 'IIR Filter - Slow Beta' }];
        ctrl.channelTypeName = '(AI) Analog Input channel';
    };

    var getAnalogInputChannels = function getAnalogInputChannels(maxChannels) {
        var channels = [];
        for (var i = 1; i <= maxChannels; i++) {
            channels.push({ id: i });
        }
        return channels;
    };

    ctrl.getData = function () {
        ctrl.MMPlusRtuSettingFactory.getData(ctrl.deviceId, ctrl.channel, ctrl.channelTypeID).then(function (result) {
            ctrl.data = result.data;
            ctrl.loading = false;
            ctrl.getImei();

            if (!ctrl.data) {
                ctrl.dataAvailable = false;
                ctrl.setDefaultData();
                ctrl.configButtonVisible = false;
                ctrl.MMPlusRtuSettingFactory.PostChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.data.networkDeviceConfigID, ctrl.data);
            } else {
                ctrl.networkDeviceConfigID = ctrl.data.networkDeviceConfigID;
                ctrl.dataAvailable = true;
                ctrl.configButtonVisible = true;
            }

            ctrl.originalData = angular.copy(ctrl.data);
        }, function (error) {
            //error
        });

        //NOTE: this call has to happen ONLY one time for this tab launch
        //Log tab access event to NLog
        ctrl.MMPlusRtuSettingFactory.postUserAction2Nlog(ctrl.accountInfo.customerId, ctrl.deviceId, "GEN II >> Channel >> Analog").then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });
    };

    ctrl.getImei = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loadingInProgress = false;
        });
    };

    ctrl.getConfigData = function () {
        ctrl.MMPlusRtuSettingFactory.getDeviceConfigData(ctrl.deviceId, true).then(function (result) {
            if (result.data) {
                var index = result.data.findIndex(function (l) {
                    return l.networkDeviceTypeID >= 13 && l.networkDeviceTypeID <= 16;
                });
                ctrl.hasModbusRTU = index >= 0 ? true : false;
            }
        }, function (error) {
            //error
        });
    };

    ctrl.postData = function (path) {
        if (ctrl.data[path] === ctrl.originalData[path]) {
            console.log("Value for " + path + " has not changed. Skipping API call.");
            return;
        }

        var tmpDevice = { "op": "replace", "path": path, "value": ctrl.data[path] };
        ctrl.MMPlusRtuSettingFactory.PatchChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.channelTypeID, ctrl.networkDeviceConfigID, tmpDevice).then(function (result) {
            ctrl.data = result.data;
            ctrl.originalData = angular.copy(result.data);

            ctrl.dataAvailable = true;
            ctrl.configButtonVisible = true;

            if (path == "unitOfValueID") {
                var mmPlusData = {
                    deviceId: ctrl.deviceId,
                    fieldName: path
                };
                $rootScope.$broadcast('rtuAnalogUpdateMMPlus', mmPlusData);
            }
        }, function (error) {
            //error
            //Revert the UI back to the original data             
            ctrl.data[path] = ctrl.originalData[path];
        });
    };

    ctrl.setDefaultData = function () {
        ctrl.data = {
            networkDeviceConfigID: ctrl.networkDeviceConfigID,
            deviceID: ctrl.deviceId,
            channelNo: ctrl.channel,
            channelTypeID: 0,
            registerAddr: 40001,
            accessModeID: 0,
            alarmHighRestore: 0,
            alarmHighThreshold: 0,
            alarmLowRestore: 0,
            alarmLowThreshold: 0,
            analogFilterID: 0,
            analogInputHWSetupID: 0,
            bitOfInterest: 0,
            cfgValue: 0,
            deEnergizeOnCommLoss: false,
            debounceTimeSecs: 0,
            electModeID: 0,
            floatToIntegerScale: 0,
            msgTransmitRate: 2,
            pulseTimeSecs: 0,
            regAddressModeID: 1,
            runtimeModeID: 0,
            scalingOffset: 0,
            scalingRange: 0,
            sendOnPercentageChg: 0,
            startUpValue: 0,
            unitOfValueID: 0,
            sampleInterval: 1,
            nonc: false
        };
        ctrl.dataAvailable = true;
    };

    ctrl.configure = function () {
        ctrl.MMPlusRtuSettingFactory.configMMPlusChannel(ctrl.deviceId, ctrl.imei, ctrl.channel, ctrl.data.channelTypeID).then(function (result) {
            //success
            var configResult = result.data.result.match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
            ctrl.alertMessage = "Channel Config " + configResult[0] + ": " + configResult[1];
            ctrl.setTimeOut();
        }, function (error) {
            //error
            ctrl.alertMessage = "Something went wrong while processing channel config request";
            ctrl.setTimeOut();
        });
    };

    ctrl.clickLog = function () {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = ctrl.deviceId;
        optionsStickyProperties.device = { deviceId: ctrl.deviceId, title: "", deviceName: ctrl.deviceSelectedName, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };
        //optionsStickyProperties.channel = { deviceId: ctrl.deviceId, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/log/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };
            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 40;

            //openViewService.openView('MM Plus Config History', { width: 700, height: 400 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });

            openViewService.openView('MM Plus Channel History', { width: 820, height: 420 }, { my: 'right-10 top+6', at: 'right top', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 }, false);
        }
    };

    $scope.$on('syncG2ChannelConfig', function (event, args) {
        if (args.deviceID == ctrl.deviceId) {
            ctrl.channelDeviceConfig = args;
            ctrl.updateChannelConfigData(ctrl.channelDeviceConfig);
        }
    });

    ctrl.updateChannelConfigData = function (channelConfig) {
        ctrl.MMPlusRtuSettingFactory.updateChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.networkDeviceConfigID, channelConfig).then(function (result) {
            openViewService.closeConfigHistoryView("MM Plus Channel History");
            ctrl.data = result.data;
        }, function (error) {
            //error
        });
    };

    ctrl.setTimeOut = function () {
        setTimeout(function () {
            ctrl.alertMessage = null;
        }, 15000); // 15 Seconds
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;

            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    ctrl.alertMessage = null;
                    $timeout(function () {
                        ctrl.getData();
                    }, 0);
                    ctrl.getConfigData();
                } else {
                    ctrl.data = null;
                    ctrl.alertMessage = "Please configure the device as Gen 2";
                    ctrl.configButtonVisible = false;
                }
            });
        }
    }, true);
};

mmPlusAnalogChannelController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusAnalogChannel', {
    controller: mmPlusAnalogChannelController,
    templateUrl: ['$element', '$attrs', function ($element, $attrs) {
        var _template = angular.isUndefined($attrs.templateUrl) ? "mm-plus-analog-channel-template.html" : $attrs.templateUrl;
        return "ui/mmplusrtusetting/mmPlusChannel/analog/" + _template;
    }],
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceId: '<'
    }
});
(function () {
    mcapp.directive('pageTitleMobile', [
        '$rootScope', '$timeout', 'sharedSetupService', 'openViewService', '$window', 'translationService', '$interval', '$route', '$location' , function ($rootScope, $timeout, sharedSetupService, openViewService, $window, translationService, $interval, $route, $location) {
            return {
                restrict: 'E',
                transclude: false,
                require: 'ngModel',
                scope: {
                    mobileTitle: '@',
                    mobileSubtitle: '@'
                },
                replace: true,
                templateUrl: 'ui/components/directives/pagetitle/page-title-mobile.html',
                link: function (scope, elem, attrs, ngModel) {

                    scope.isOn = $rootScope.classicView || $rootScope.mobile;
                    scope.pageTitleMobileWidth = "100%";
                    scope.mobileSavedDesktop = $location.path().indexOf("/saveddesktop/saved-desktop-view") > -1;

                    scope.$watch('mobileSubtitle', function (newValue, oldValue) {
                        if (newValue) {//(newValue && newValue != oldValue)
                            scope.pageTitleMobile = scope.getText(scope.mobileTitle) + (scope.mobileSubtitle ? ', ' + scope.mobileSubtitle : '');
                        }
                    }, true);

                    scope.getText = function (text) {
                        if (!angular.isDefined(text) || text == "") return false;
                        scope.translation = translationService.translation;
                        return typeof scope.translation !== 'undefined' && typeof eval("scope.translation.text." + text.toUpperCase().replace(/ /g, "_")) !== 'undefined' ? eval("scope.translation.text." + text.toUpperCase().replace(/ /g, "_")) : text;
                    };

                    scope.pageTitleMobile = scope.getText(scope.mobileTitle) + (scope.mobileSubtitle ? ', ' + scope.mobileSubtitle : '');

                    scope.getIcon = function (varTitle, varMode) {
                        return sharedSetupService.getIcon(varTitle, varMode);
                    };

                    if ($rootScope.mobile || $rootScope.classicView) {
                        var _startScopeApply;
                        var _windowDimensionsOld;
                        var _windowDimensionsNew;

                        var w = angular.element($window);
                        scope.getWindowDimensions = function () {
                            scope.windowHeight = w.height();
                            scope.windowWidth = w.width();
                            return {
                                'h': w.height(),
                                'w': w.width()
                            };
                        };

                        _windowDimensionsNew = scope.getWindowDimensions();

                        w.on('resize', function (event) {
                            //only if from window - we do not want it if bubble up from views ('resize')
                            if (event.target === this) {
                                //do it on resize-end rather than on every single resize
                                if (angular.isDefined(_startScopeApply)) {
                                    $timeout.cancel(_startScopeApply);
                                    _startScopeApply = undefined;
                                }
                                _startScopeApply = $timeout(function () {
                                    scope.$apply();
                                    _windowDimensionsNew = scope.getWindowDimensions();
                                    _watchWindowDimensions();
                                }, 300);
                            }
                        });

                        //more controll with custom $watch on "scope.getWindowDimensions"
                        var _watchWindowDimensions = function () {
                            if (_windowDimensionsNew && _windowDimensionsNew != _windowDimensionsOld) {
                                if ($rootScope.classicView) $rootScope.$broadcast('windowDimensions', { landscapeMode: scope.windowHeight < scope.windowWidth, windowHeight: scope.windowHeight < scope.windowWidth, windowWidth: scope.windowWidth });
                                if ($rootScope.mobile) {
                                    $(".content-mobile").css("height", scope.windowHeight);
                                    $(".chart").css("height", scope.windowHeight - 64);
                                    var _char = $(".chart").highcharts();
                                    if ($(".chart").highcharts()) {
                                        _char.reflow();
                                    }
                                    var _headerTable = angular.isUndefined($(".headertable").css("height")) ? 0 : $(".headertable").css("height").replace(/[^0-9.]+/g, "");
                                    $(".tabular-data-container-mobile").css("height", scope.windowHeight - 60 - _headerTable);
                                    $(".rtu-data-container").css("height", scope.windowHeight - 72);
                                    $timeout(function () {
                                        var _addHeight = $(".ui-tabs-nav").is(':visible') ? $(".ui-tabs-nav").css("height").replace(/[^0-9.]+/g, "") : 0;
                                        $(".ui-tabs-panel").css("height", scope.windowHeight - 69 - _addHeight);
                                    }, 0);
                                    scope.pageTitleMobileWidth = scope.windowWidth - 75 - (scope.mobileSavedDesktop ? 40 : 0) + "px"; //35 + 35 + 5px for two buttons;
                                }
                            }
                            _windowDimensionsOld = _windowDimensionsNew;
                        };

                        scope.$on('updatePreferencesLanguage', function () {
                            scope.pageTitleMobile = scope.getText(scope.mobileTitle) + (scope.mobileSubtitle ? ', ' + scope.mobileSubtitle : '');
                        });

                        scope.$on('$destroy', function () {
                            if (angular.isDefined(w)) w.off('resize');
                        });

                        $timeout(function () {
                            _watchWindowDimensions();
                        }, 0);
                    }
                }
            };
        }
    ]);
}());

"use strict";

angular.module("mc.weekly-management-report-setup", []);
'use strict';

function WeeklyManagementReportDestinationsFactory(HOST, $http) {

    // instantiate our initial object
    var WeeklyManagementReportDestinations = function WeeklyManagementReportDestinations(customerId) {
        this.customerId = customerId;
    };

    WeeklyManagementReportDestinations.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + '/api/TaskList' + '?customerId=' + this.customerId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    WeeklyManagementReportDestinations.prototype.postData = function (taskList) {
        var self = this;
        return $http.post(HOST + '/api/TaskList' + '?customerId=' + this.customerId, taskList).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    WeeklyManagementReportDestinations.prototype.patchData = function (id, taskListPatch) {
        var self = this;
        return $http.patch(HOST + '/api/TaskList' + '?customerId=' + this.customerId + '&id=' + id, taskListPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    WeeklyManagementReportDestinations.prototype.deleteData = function (id) {
        var self = this;
        return $http.delete(HOST + '/api/TaskList' + '?customerId=' + this.customerId + '&id=' + id).then(function (response) {
            self.dataBack = response.data;
            self.loading = false;
            return response;
        });
    };

    WeeklyManagementReportDestinations.prototype.emailDailyStationReport = function (customerId, sendTo, langId) {
        var self = this;
        return $http({
            method: 'POST',
            url: HOST + '/api/Reports/ManagementReport',
            params: { customerId: customerId, sendTo: sendTo, langId: langId }
        }).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    return WeeklyManagementReportDestinations;
}

WeeklyManagementReportDestinationsFactory.$inject = ['HOST', '$http'];

angular.module('mc.weekly-management-report-setup').factory('WeeklyManagementReportDestinationsFactory', WeeklyManagementReportDestinationsFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function WeeklyManagementReportSetupController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, WeeklyManagementReportDestinationsFactory, $timeout, $filter, toaster, $uibModal, unsavedChangesService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.triggerIds = [];
    ctrl.tmpTriggerId = 1077;
    ctrl.weeklyManagementReportDestinations = [];
    ctrl.languages = [{ "display": "English", "value": "Eng" }, { "display": "French", "value": "Fr" }];
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.frequency = ctrl.frequency; //need for
        ctrl.initializeSetting();
        ctrl.getWeeklyManagementReport();

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    var _triggerIds = function _triggerIds() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.triggerIds.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.triggerIds.push(arguments[i]);
            } else {
                ctrl.triggerIds[i].name = arguments[i].name;
            }
        }
    };

    ctrl.resendReportPopover = {
        templateUrl: 'ResendReportPopoverTemplate.html'
    };

    ctrl.processReportAndSendEmail = function (item) {
        item.popoverIsOpen1 = !item.popoverIsOpen1;
        var _weeklyManagementReportDestinations = new WeeklyManagementReportDestinationsFactory(ctrl.accountInfo.customerId);
        _weeklyManagementReportDestinations.emailDailyStationReport(ctrl.accountInfo.customerId, item.strData1, item.language).then(function (success) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.OK + ", 1 " + ctrl.translation.text.ATTACHMENT;
            toaster.pop('success', userMessage, ctrl.translation.text.SUCCESS);
        }, function (error) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.FAILURE;
            toaster.pop('error', userMessage, ctrl.translation.text.FAILURE);
        });
    };

    ctrl.initializeSetting = function () {
        generateAndLoadTriggerIds();
    };

    var generateAndLoadTriggerIds = function generateAndLoadTriggerIds() {
        var triggerStartId = 1245; // default id for EST = 12AM
        var triggerObj = {};

        //set initial triggerId based on timezone
        switch (ctrl.accountInfo.timeZone.toUpperCase()) {
            case 'C':
                triggerStartId = triggerStartId + 1; //central timezone
                break;
            case 'M':
                //Mountain timezone
                triggerStartId = triggerStartId + 2;
                break;
            case 'P':
                //Pacific timezone
                triggerStartId = triggerStartId + 3;
                break;
            //case 'A': //Alaska timezone //NOT Supported
            //    triggerStartId = triggerStartId + 4;
            //    break;
            case 'H':
                //Hawaii timezone
                triggerStartId = triggerStartId + 6;
                break;
            default:
                //Eastern timezone
                triggerStartId = 1245;
                break;
        }

        //dynamically generate triggers for entire 24 hours range
        var dt = new Date();
        //per discussion with Ned, decided to display options from 5AM - 6PM EST only.
        for (var i = 5; i <= 18; i++) {
            //hiding the midnight option, per Dave: **Do not let the user choose midnight because M800 data will not be computed before maybe midnight:30
            //for 6AM,7AM,8AM,9AM, use old TriggerIDs, 
            //because, those values are already used previously and old report setups are using those IDS
            var calculatedTriggerId = i === 6 || i === 7 || i === 8 || i === 9 ? getOldTriggerIds(i, triggerStartId) : triggerStartId + i;

            triggerObj = {
                "id": calculatedTriggerId,
                "name": $filter('date')(dt.setHours(i, 0), ctrl.timeFormat)
            };
            ctrl.triggerIds.push(triggerObj);
        }
    };

    var getOldTriggerIds = function getOldTriggerIds(hourIndex, currentTriggerId) {
        var oldTriggerId = 1077;
        switch (ctrl.accountInfo.timeZone.toUpperCase()) {
            case 'C':
                //central timezone
                ctrl.tmpTriggerId = 1150;
                switch (hourIndex) {
                    case 6:
                        oldTriggerId = 1007;
                        break;
                    case 7:
                        oldTriggerId = 1076;
                        break;
                    case 8:
                        oldTriggerId = 1077;
                        break;
                    case 9:
                        oldTriggerId = 1150;
                        break;
                }
                break;
            case 'M':
                //Mountain timezone
                ctrl.tmpTriggerId = 7;
                switch (hourIndex) {
                    case 6:
                        oldTriggerId = 1076;
                        break;
                    case 7:
                        oldTriggerId = 1077;
                        break;
                    case 8:
                        oldTriggerId = 1150;
                        break;
                    case 9:
                        oldTriggerId = 7;
                        break;
                }
                break;
            case 'P':
                //Pacific timezone
                ctrl.tmpTriggerId = 1151;
                switch (hourIndex) {
                    case 6:
                        oldTriggerId = 1077;
                        break;
                    case 7:
                        oldTriggerId = 1150;
                        break;
                    case 8:
                        oldTriggerId = 7;
                        break;
                    case 9:
                        oldTriggerId = 1151;
                        break;
                }
                break;
            //case 'A': //Alaska timezone --> NOT Supported
            //    ctrl.tmpTriggerId = 1150;
            //    break;
            case 'H':
                //Hawaii timezone
                ctrl.tmpTriggerId = 1154;
                switch (hourIndex) {
                    case 6:
                        oldTriggerId = 1151;
                        break;
                    case 7:
                        oldTriggerId = 1152;
                        break;
                    case 8:
                        oldTriggerId = 1153;
                        break;
                    case 9:
                        oldTriggerId = 1154;
                        break;
                }
                break;
            default:
                //'E' Eastern timezone
                ctrl.tmpTriggerId = 1077;
                switch (hourIndex) {
                    case 6:
                        oldTriggerId = 4;
                        break;
                    case 7:
                        oldTriggerId = 1007;
                        break;
                    case 8:
                        oldTriggerId = 1076;
                        break;
                    case 9:
                        oldTriggerId = 1077;
                        break;
                }
                break;
        }
        return oldTriggerId;
    };

    ctrl.getWeeklyManagementReport = function () {

        var _weeklyManagementReportDestinations = new WeeklyManagementReportDestinationsFactory(ctrl.accountInfo.customerId);

        _weeklyManagementReportDestinations.getData().then(function () {
            ctrl.weeklyManagementReportDestinations = _weeklyManagementReportDestinations.list;
            for (var i = 0; i < ctrl.weeklyManagementReportDestinations.length; i++) {
                ctrl.weeklyManagementReportDestinations[i].triggerId = { id: ctrl.weeklyManagementReportDestinations[i].triggerId };
            }
            ctrl.setLanguage();
        });
    };

    ctrl.setLanguage = function () {
        for (var i = 0; i < ctrl.weeklyManagementReportDestinations.length; i++) {
            var currentType = ctrl.weeklyManagementReportDestinations[i].type;
            var currentFormat = ctrl.weeklyManagementReportDestinations[i].format;
            if (currentFormat === 1) {
                if (currentType === 2 || currentType === 4 || currentType === 6) {
                    ctrl.weeklyManagementReportDestinations[i].language = 'Fr';
                } else if (currentType === 0 || currentType === 1 || currentType === 3 || currentType === 5) {
                    ctrl.weeklyManagementReportDestinations[i].language = 'Eng';
                }
            } else {
                if (currentType === 5) {
                    ctrl.weeklyManagementReportDestinations[i].language = 'Eng';
                } else if (currentType === 6) {
                    ctrl.weeklyManagementReportDestinations[i].language = 'Fr';
                }
            }
        }
    };

    ctrl.addDestination = function () {
        var newWeeklyManagementReportDestination = {
            customerId: ctrl.accountInfo.customerId,
            id: -1,
            triggerId: { id: ctrl.tmpTriggerId },
            strData1: '',
            strData2: '',
            format: 1,
            type: 3,
            pio: true, //popover-is-open
            language: 'Eng'
        };
        ctrl.weeklyManagementReportDestinations.unshift(newWeeklyManagementReportDestination);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveDestination = function (item) {
        var _weeklyManagementReportDestinations = new WeeklyManagementReportDestinationsFactory(ctrl.accountInfo.customerId);
        if (!angular.isUndefined(item.triggerId)) item.triggerId = item.triggerId.id;
        if (item.format === 1) {
            item.strData2 = '';
            var reportType = ctrl.returnReportType(item.type);
            ctrl.checkMethod(item, reportType);
        } else if (item.format === 0) {
            item.triggerId = ctrl.tmpTriggerId;
            ctrl.checkMethod(item, 'fax');
        }

        if (typeof item.language !== "undefined") delete item.language;

        _weeklyManagementReportDestinations.postData(item).then(function () {
            ctrl.weeklyManagementReportDestinations[0] = _weeklyManagementReportDestinations.newDestination;
            ctrl.weeklyManagementReportDestinations[0].triggerId = { id: ctrl.weeklyManagementReportDestinations[0].triggerId };
            ctrl.setLanguage();
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.cancelDestination = function (item) {
        if (item.id === -1) ctrl.weeklyManagementReportDestinations.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.checkEmail = function (item) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!angular.isUndefined(item) && item.length === 0) return false;
        return !re.test(item);
    };

    ctrl.checkIfEmailExists = function (item) {
        for (var i = 0; i < ctrl.weeklyManagementReportDestinations.length; i++) {
            if (ctrl.weeklyManagementReportDestinations[i].type < 8 && ctrl.weeklyManagementReportDestinations[i].format !== 0 && item.strData1.toLowerCase() === ctrl.weeklyManagementReportDestinations[i].strData1.toLowerCase() && item.id !== ctrl.weeklyManagementReportDestinations[i].id) return true;
        }
        return false;
    };

    ctrl.checkIfFaxExists = function (item) {
        for (var i = 0; i < ctrl.weeklyManagementReportDestinations.length; i++) {
            if (ctrl.weeklyManagementReportDestinations[i].type < 8 && ctrl.weeklyManagementReportDestinations[i].format === 0 && item.strData2 === ctrl.weeklyManagementReportDestinations[i].strData2 && item.id !== ctrl.weeklyManagementReportDestinations[i].id) return true;
        }
        return false;
    };

    ctrl.formatPhoneNumberDisplay = function (f_val) {
        if (typeof f_val === "undefined") return f_val;
        f_val = f_val.replace(/\D/g, '');
        //f_val = f_val.substring(0, 1) == "1" ? f_val.substring(1, f_val.lenght) : f_val;
        f_val = f_val.length > 10 ? f_val.replace(/(\d{3})(\d{3})(\d{4})(\d{4})/, "($1) $2-$3 ext. $4") : f_val.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        return f_val;
    };

    ctrl.checkPhoneNumber = function (item) {
        return angular.isUndefined(item);
    };

    ctrl.patchData = function (item, propertyName, propertyNameOld, allowNull) {
        if (item.id === -1 || propertyNameOld !== null && item[propertyName] == item[propertyNameOld]) return false;
        if (!allowNull && !item[propertyName]) return false;

        if (propertyName === "language") {
            propertyName = "type";
            if (item.format === 1) {

                if (item.type == 5 && item.language == "Fr") {
                    item.type = 6;
                } else if (item.type == 6 && item.language == "Eng") {
                    item.type = 5;
                } else if (item.type == 3 && item.language == "Fr") {
                    item.type = 4;
                } else if (item.type == 4 && item.language == "Eng") {
                    item.type = 3;
                } else if (item.type == 0 && item.language == "Fr") {
                    item.type = 2;
                } else if (item.type == 2 && item.language == "Eng") {
                    item.type = 0;
                } else if (item.type == 1 && item.language == "Eng") {
                    item.type = 1;
                } else if (item.type == 1 && item.language == "Fr") {
                    item.type = 1;
                }
            } else if (item.format === 0) {
                if (item.type === 5 && item.language == "Fr") {
                    item.type = 6;
                } else if (item.type === 6 && item.language == "Eng") {
                    item.type = 5;
                }
            }
        }
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName], item.format)) return false;
        if (propertyName === "strData1" && ctrl.checkIfEmailExists(item)) {
            item.strData1 = item[propertyNameOld];
            return false;
        }
        if (propertyName === "strData2" && ctrl.checkIfFaxExists(item)) {
            item.strData2 = item[propertyNameOld];
            return false;
        }
        var tmpWeeklyManagementReportDestinationPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _weeklyManagementReportDestinations = new WeeklyManagementReportDestinationsFactory(ctrl.accountInfo.customerId);
        _weeklyManagementReportDestinations.patchData(item.id, tmpWeeklyManagementReportDestinationPatch).then(function () {
            //success
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
        });
    };

    ctrl.checkData = function (propertyName, value, format) {
        switch (propertyName) {
            case "triggerId":
            case "type":
                return true;
            case "strData1":
                if (format === 1) {
                    return !ctrl.checkEmail(value);
                } else {
                    return true;
                }
            case "strData2":
                if (format === 1) {
                    return !ctrl.checkPhoneNumber(value);
                } else {
                    return true;
                }
            default:
                return false;
        }
    };

    ctrl.returnReportType = function (type) {
        if (type === 3 || type === 4) {
            return 'newhtml';
        } else if (type === 5 || type === 6) {
            return 'pdf';
        }
    };

    ctrl.checkMethod = function (item, type) {
        item.typeOld = item.type;
        item.pio = false; //popover-is-open no more
        var _formatChange = false;
        switch (type) {

            case "newhtml":
                if (item.format == 0) _formatChange = true;
                item.format = 1;
                if (item.language === 'Eng') {
                    item.type = 3;
                } else if (item.language === 'Fr') {
                    item.type = 4;
                }
                break;

            case "pdf":
                if (item.format == 0) _formatChange = true;
                item.format = 1;

                if (item.language === 'Eng') {
                    item.type = 5;
                } else if (item.language === 'Fr') {
                    item.type = 6;
                }
                break;

            case "fax":
                if (item.format == 1) _formatChange = true;
                item.format = 0;

                if (item.language === 'Eng') {
                    item.type = 5;
                } else if (item.language === 'Fr') {
                    item.type = 6;
                }
                break;
        }

        //new block

        //end new block

        if (_formatChange) {
            item.strData1 = '';
            item.strData2 = '';
        }
        ctrl.patchData(item, 'type', 'typeOld', true);
        item.popoverIsOpen = false;
    };

    ctrl.dynamicPopover = {
        templateUrl: 'WeeklyManagementReportPopoverTemplate.html'
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE_REPORT_DESTINATION + ":";
            this.tmpConfirmMessageB = item.format === 1 ? ctrl.translation.text.EMAIL + ': ' + item.strData1 : ctrl.translation.text.FAX + ': ' + ctrl.formatPhoneNumberDisplay(item.strData2) + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _weeklyManagementReportDestinations = new WeeklyManagementReportDestinationsFactory(ctrl.accountInfo.customerId);
            _weeklyManagementReportDestinations.deleteData(item.id).then(function () {

                var index = ctrl.weeklyManagementReportDestinations.indexOf(item);
                if (index !== -1) {
                    ctrl.weeklyManagementReportDestinations.splice(index, 1);
                }

                // ctrl.addMode = null;
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });
};

WeeklyManagementReportSetupController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'WeeklyManagementReportDestinationsFactory', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService'];
'use strict';

angular.module('mc.weekly-management-report-setup').component('weeklyManagementReportSetup', {
    controller: WeeklyManagementReportSetupController,
    templateUrl: 'ui/missionreportssetup/weeklyreports/weeklymanagementreport/weekly-management-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.daily-pulseflow-report-setup", []);
'use strict';

function DailyPulseflowReportSetupFactory(HOST, $http) {
    var _this = this;

    // instantiate our initial object
    var DailyPulseflowReportSetup = function DailyPulseflowReportSetup(customerId) {
        this.customerId = customerId;
    };

    DailyPulseflowReportSetup.prototype.getData = function (reportTypeId) {
        var self = this;
        return $http.get(HOST + '/api/ReportDestination/GetList' + '?customerId=' + this.customerId + '&reportTypeId=' + reportTypeId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    DailyPulseflowReportSetup.prototype.postData = function (dailyPulseflowReportDestination) {
        var self = this;
        return $http.post(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId, dailyPulseflowReportDestination).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    DailyPulseflowReportSetup.prototype.patchData = function (reportDestinationId, dailyPulseflowReportDestinationPatch) {
        var self = this;
        return $http.patch(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId + '&reportDestinationId=' + reportDestinationId, dailyPulseflowReportDestinationPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    DailyPulseflowReportSetup.prototype.deleteData = function (reportDestinationId) {
        var self = this;
        return $http.delete(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId + '&reportDestinationId=' + reportDestinationId).then(function (response) {
            self.dataBack = response.data;
            self.loading = false;
            return response;
        });
    };

    DailyPulseflowReportSetup.prototype.resendReportEmail = function (customerId, reportId) {
        var self = _this;
        return $http({
            method: 'POST',
            url: HOST + '/api/Download/PulseflowDownload/InsertDailyPulseFlowRequest' + '?customerId=' + customerId + '&reportId=' + reportId
        }).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    return DailyPulseflowReportSetup;
}

DailyPulseflowReportSetupFactory.$inject = ['HOST', '$http'];

angular.module('mc.daily-pulseflow-report-setup').factory('DailyPulseflowReportSetupFactory', DailyPulseflowReportSetupFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function DailyPulseflowReportSetupController($, $rootScope, $scope, $sce, $http, HOST, authenticationService, translationService, sharedSetupService, DailyPulseflowReportSetupFactory, $timeout, $filter, toaster, $uibModal, unsavedChangesService, modalService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.hourToSendLocalTimes = [];
    ctrl.languages = [];
    // ctrl.daysOfWeek = [];
    ctrl.volumeUnits = [];
    ctrl.dailyPulseflowReportDestinations = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.preferredTimeFormat == 1 ? ctrl.isMeridian = true : ctrl.isMeridian = false;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        ctrl.measurementSystems = [{ lookupMeasurementId: 'I', "value": ctrl.translation.text.IMPERIAL }, { lookupMeasurementId: "M", "value": ctrl.translation.text.METRIC }];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.frequency = ctrl.frequency; //need for
        _this2.alerts = [];
        ctrl.initializeSetting();
        ctrl.getDailyPulseflowReportDestinations();

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    var _hourToSendLocalTimes = function _hourToSendLocalTimes() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.hourToSendLocalTimes.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.hourToSendLocalTimes.push(arguments[i]);
            } else {
                ctrl.hourToSendLocalTimes[i].name = arguments[i].name;
            }
        }
    };

    var _languages = function _languages() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.languages.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.languages.push(arguments[i]);
            } else {
                ctrl.languages[i].name = arguments[i].name;
            }
        }
    };

    // var _daysOfWeek = function () {
    //     var len = arguments.length,
    //         i = 0;
    //     var tmpLength = ctrl.daysOfWeek.length;
    //     for (i = 0; i < len; i++) {
    //         if (tmpLength == 0) {
    //             ctrl.daysOfWeek.push(arguments[i]);
    //         } else {
    //             ctrl.daysOfWeek[i].name = arguments[i].name;
    //         }
    //     }
    // };

    var _volumeUnits = function _volumeUnits() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.volumeUnits.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.volumeUnits.push(arguments[i]);
            } else {
                ctrl.volumeUnits[i].name = arguments[i].name;
            }
        }
    };

    ctrl.resendReportPopover = {
        templateUrl: 'ResendReportPopoverTemplate.html'
    };

    ctrl.preferredTimePopover = {
        templateUrl: 'PreferredTimePopoverTemplate.html'
    };

    ctrl.processReportAndSendEmail = function (item) {
        item.popoverIsOpen1 = !item.popoverIsOpen1;
        var _dailyPulseflowReportSetupFactory = new DailyPulseflowReportSetupFactory(ctrl.accountInfo.customerId);

        _dailyPulseflowReportSetupFactory.resendReportEmail(ctrl.accountInfo.customerId, item.id).then(function (success) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.OK + ", 1 " + ctrl.translation.text.ATTACHMENT;
            toaster.pop('success', userMessage, ctrl.translation.text.SUCCESS);
        }, function (error) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.FAILURE;
            toaster.pop('error', userMessage, ctrl.translation.text.FAILURE);
        });
        return;
    };

    ctrl.getCurrentDate = function (item) {
        ctrl.oldPreferredTime = item.preferredTime;
        item.preferredTime = new Date();
    };

    ctrl.cancelPreferredTime = function (item) {
        if (ctrl.oldPreferredTime) item.preferredTime = ctrl.oldPreferredTime;
        item.popoverIsOpen2 = !item.popoverIsOpen2;
    };

    ctrl.initializeSetting = function () {
        var _this3 = this;

        ctrl.dt = new Date();
        _hourToSendLocalTimes({
            "id": 1,
            "name": $filter('date')(ctrl.dt.setHours(1, 0), ctrl.timeFormat)
        }, {
            "id": 2,
            "name": $filter('date')(ctrl.dt.setHours(2, 0), ctrl.timeFormat)
        }, {
            "id": 3,
            "name": $filter('date')(ctrl.dt.setHours(3, 0), ctrl.timeFormat)
        }, {
            "id": 4,
            "name": $filter('date')(ctrl.dt.setHours(4, 0), ctrl.timeFormat)
        }, {
            "id": 5,
            "name": $filter('date')(ctrl.dt.setHours(5, 0), ctrl.timeFormat)
        }, {
            "id": 6,
            "name": $filter('date')(ctrl.dt.setHours(6, 0), ctrl.timeFormat)
        }, {
            "id": 7,
            "name": $filter('date')(ctrl.dt.setHours(7, 0), ctrl.timeFormat)
        }, {
            "id": 8,
            "name": $filter('date')(ctrl.dt.setHours(8, 0), ctrl.timeFormat)
        }, {
            "id": 9,
            "name": $filter('date')(ctrl.dt.setHours(9, 0), ctrl.timeFormat)
        }, {
            "id": 10,
            "name": $filter('date')(ctrl.dt.setHours(10, 0), ctrl.timeFormat)
        }, {
            "id": 11,
            "name": $filter('date')(ctrl.dt.setHours(11, 0), ctrl.timeFormat)
        }, {
            "id": 12,
            "name": $filter('date')(ctrl.dt.setHours(12, 0), ctrl.timeFormat)
        }, {
            "id": 13,
            "name": $filter('date')(ctrl.dt.setHours(13, 0), ctrl.timeFormat)
        }, {
            "id": 14,
            "name": $filter('date')(ctrl.dt.setHours(14, 0), ctrl.timeFormat)
        }, {
            "id": 15,
            "name": $filter('date')(ctrl.dt.setHours(15, 0), ctrl.timeFormat)
        }, {
            "id": 16,
            "name": $filter('date')(ctrl.dt.setHours(16, 0), ctrl.timeFormat)
        }, {
            "id": 17,
            "name": $filter('date')(ctrl.dt.setHours(17, 0), ctrl.timeFormat)
        }, {
            "id": 18,
            "name": $filter('date')(ctrl.dt.setHours(18, 0), ctrl.timeFormat)
        }, {
            "id": 19,
            "name": $filter('date')(ctrl.dt.setHours(19, 0), ctrl.timeFormat)
        }, {
            "id": 20,
            "name": $filter('date')(ctrl.dt.setHours(20, 0), ctrl.timeFormat)
        }, {
            "id": 21,
            "name": $filter('date')(ctrl.dt.setHours(21, 0), ctrl.timeFormat)
        }, {
            "id": 22,
            "name": $filter('date')(ctrl.dt.setHours(22, 0), ctrl.timeFormat)
        }, {
            "id": 23,
            "name": $filter('date')(ctrl.dt.setHours(23, 0), ctrl.timeFormat)
        }, {
            "id": 24,
            "name": $filter('date')(ctrl.dt.setHours(24, 0), ctrl.timeFormat)
        });

        _languages({
            "id": 1,
            "name": ctrl.translation.text.ENGLISH
        }, {
            "id": 4,
            "name": ctrl.translation.text.FRENCH
        }, {
            "id": 5,
            "name": ctrl.translation.text.SPANISH
        }, {
            "id": 6,
            "name": ctrl.translation.text.CHINESE
        }, {
            "id": 8,
            "name": ctrl.translation.text.GERMAN
        }, {
            "id": 9,
            "name": ctrl.translation.text.PORTUGUESE
        });

        // _daysOfWeek(
        //     {
        //         "id": 1,
        //         "name": ctrl.translation.text.SUNDAY
        //     },
        //     {
        //         "id": 2,
        //         "name": ctrl.translation.text.MONDAY
        //     },
        //     {
        //         "id": 3,
        //         "name": ctrl.translation.text.TUESDAY
        //     },
        //     {
        //         "id": 4,
        //         "name": ctrl.translation.text.WEDNESDAY
        //     },
        //     {
        //         "id": 5,
        //         "name": ctrl.translation.text.THURSDAY
        //     },
        //     {
        //         "id": 6,
        //         "name": ctrl.translation.text.FRIDAY
        //     },
        //     {
        //         "id": 7,
        //         "name": ctrl.translation.text.SATURDAY
        //     }
        // );

        _volumeUnits({
            "id": 1,
            "name": ctrl.translation.text.IMPERIAL
        }, {
            "id": 2,
            "name": ctrl.translation.text.METRIC
        });

        $http.get(HOST + "/api/Overview?customerId=" + this.accountInfo.customerId).then(function (resp) {
            _this3.noDevices = true;
            _this3.alerts = [];
            _this3.devices = resp.data;
            if (_this3.devices.length === 0) {
                _this3.alerts.push({ msg: _this3.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIME' });
                _this3.noDevices = true;
                return;
            } else {
                for (var i = 0; i < _this3.devices.length; i++) {
                    if (_this3.devices[i].inputMode.indexOf('R') !== -1) {
                        _this3.noDevices = false;
                    }
                }
                if (_this3.noDevices) {
                    ctrl.getPulseOptionBoardSettings();
                }
            }
        });
        if (this.noDevices) {
            this.alerts.push({ msg: this.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIMED' });
        }
    };

    ctrl.getPulseOptionBoardSettings = function () {
        $http.get(HOST + "/api/OptionBoardPulse?customerId=" + _this2.accountInfo.customerId).then(function (resp) {
            _this2.pulseOptioBoard = resp.data;
            if (_this2.pulseOptioBoard.length != 0) {
                _this2.noDevices = false;
                return;
            }
        });
    };
    ctrl.getDailyPulseflowReportDestinations = function () {

        var _dailyPulseflowReportSetupFactory = new DailyPulseflowReportSetupFactory(ctrl.accountInfo.customerId);

        //6 is for Daily pulse flow summary report destinations
        _dailyPulseflowReportSetupFactory.getData(6).then(function () {
            ctrl.dailyPulseflowReportDestinations = _dailyPulseflowReportSetupFactory.list;
            for (var i = 0; i < ctrl.dailyPulseflowReportDestinations.length; i++) {
                ctrl.dailyPulseflowReportDestinations[i].language = { id: ctrl.dailyPulseflowReportDestinations[i].language };
                // ctrl.dailyPulseflowReportDestinations[i].dayOfWeek = { id: ctrl.dailyPulseflowReportDestinations[i].dayOfWeek };
                ctrl.dailyPulseflowReportDestinations[i].volumeUnit = { id: ctrl.dailyPulseflowReportDestinations[i].volumeUnit };
                ctrl.dailyPulseflowReportDestinations[i].preferredTime = ctrl.dt.setHours(ctrl.dailyPulseflowReportDestinations[i].hourToSendLocalTime, ctrl.dailyPulseflowReportDestinations[i].minuteToSendLocalTime);
            }
        });
    };

    ctrl.addDestination = function () {
        var newPulseFlowReportDestination = {
            id: -1,
            reportType: 6, //Daily Pulse Flow Summary Report
            customerId: ctrl.accountInfo.customerId,
            emailAddress: '',
            sendAsAttachment: false,
            frequency: 1,
            // dayOfWeek: { id: 1 },
            hourToSendLocalTime: 8,
            minuteToSendLocalTime: 0,
            language: { id: 1 },
            volumeUnit: { id: 1 },
            preferredTime: ctrl.dt.setHours(8, 0)
        };
        ctrl.dailyPulseflowReportDestinations.unshift(newPulseFlowReportDestination);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveDestination = function (item) {
        var _dailyPulseflowReportSetupFactory = new DailyPulseflowReportSetupFactory(ctrl.accountInfo.customerId);
        // item.dayOfWeek = item.dayOfWeek.id;
        item.language = item.language.id;
        item.volumeUnit = item.volumeUnit.id;
        //if (!angular.isUndefined(item.hourToSendLocalTime)) item.hourToSendLocalTime = item.hourToSendLocalTime.id;
        _dailyPulseflowReportSetupFactory.postData(item).then(function () {
            ctrl.dailyPulseflowReportDestinations[0] = _dailyPulseflowReportSetupFactory.newDestination;
            ctrl.dailyPulseflowReportDestinations[0].language = { id: _dailyPulseflowReportSetupFactory.newDestination.language };
            ctrl.dailyPulseflowReportDestinations[0].volumeUnit = { id: _dailyPulseflowReportSetupFactory.newDestination.volumeUnit };
            ctrl.dailyPulseflowReportDestinations[0].preferredTime = ctrl.dt.setHours(_dailyPulseflowReportSetupFactory.newDestination.hourToSendLocalTime, _dailyPulseflowReportSetupFactory.newDestination.minuteToSendLocalTime);
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.cancelDestination = function (item) {
        if (item.id === -1) ctrl.dailyPulseflowReportDestinations.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.checkEmail = function (item) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!angular.isUndefined(item) && item.length === 0) return false;
        return !re.test(item);
    };

    ctrl.checkIfEmailExists = function (item) {
        for (var i = 0; i < ctrl.dailyPulseflowReportDestinations.length; i++) {
            if (item.emailAddress.toLowerCase() === ctrl.dailyPulseflowReportDestinations[i].emailAddress.toLowerCase() && item.id !== ctrl.dailyPulseflowReportDestinations[i].id) return true;
        }
        return false;
    };

    ctrl.patchData = function (item, propertyName, propertyNameOld, allowNull) {
        if (item.id === -1 || propertyNameOld !== null && item[propertyName] == item[propertyNameOld]) return false;
        if (!allowNull && !item[propertyName]) return false;
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;
        if (propertyName === "emailAddress" && ctrl.checkIfEmailExists(item)) {
            item.emailAddress = item[propertyNameOld];
            return false;
        }
        var tmpDailyPulseflowReportDestinationPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _dailyPulseflowReportSetupFactory = new DailyPulseflowReportSetupFactory(ctrl.accountInfo.customerId);
        _dailyPulseflowReportSetupFactory.patchData(item.id, tmpDailyPulseflowReportDestinationPatch).then(function () {
            //success
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
        });
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            // case "dayOfWeek":
            case "volumeUnit":
            case "language":
            case "hourToSendLocalTime":
            case "minuteToSendLocalTime":
                return true;
            case "emailAddress":
                return !ctrl.checkEmail(value);
            default:
                return false;
        }
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE_REPORT_DESTINATION + ":";
            this.tmpConfirmMessageB = item.emailAddress + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _dailyPulseflowReportSetupFactory = new DailyPulseflowReportSetupFactory(ctrl.accountInfo.customerId);
            _dailyPulseflowReportSetupFactory.deleteData(item.id).then(function () {

                var index = ctrl.dailyPulseflowReportDestinations.indexOf(item);
                if (index !== -1) {
                    ctrl.dailyPulseflowReportDestinations.splice(index, 1);
                }

                // ctrl.addMode = null;
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.setPreferredTime = function (item) {
        item.popoverIsOpen2 = !item.popoverIsOpen2;
        item.hourToSendLocalTime = item.preferredTime.getHours();
        item.minuteToSendLocalTime = item.preferredTime.getMinutes();
        ctrl.patchData(item, 'hourToSendLocalTime', false);
        ctrl.patchData(item, 'minuteToSendLocalTime', false);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });
};

DailyPulseflowReportSetupController.$inject = ['$', '$rootScope', '$scope', '$sce', '$http', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'DailyPulseflowReportSetupFactory', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService', 'modalService'];
'use strict';

angular.module('mc.daily-pulseflow-report-setup').component('dailyPulseflowReportSetup', {
    controller: DailyPulseflowReportSetupController,
    templateUrl: 'ui/missionreportssetup/dailyreports/dailypulseflowreportsetup/daily-pulseflow-report-setup-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.pulse-flow-summary-report-setup", []);
'use strict';

function PulseFlowSummaryReportSetupFactory(HOST, $http) {
    var _this = this;

    // instantiate our initial object
    var PulseFlowSummaryReportSetup = function PulseFlowSummaryReportSetup(customerId) {
        this.customerId = customerId;
    };

    PulseFlowSummaryReportSetup.prototype.getData = function (reportTypeId) {
        var self = this;
        return $http.get(HOST + '/api/ReportDestination/GetList' + '?customerId=' + this.customerId + '&reportTypeId=' + reportTypeId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    PulseFlowSummaryReportSetup.prototype.postData = function (integratedFlowSummaryReportDestination) {
        var self = this;
        return $http.post(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId, integratedFlowSummaryReportDestination).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    PulseFlowSummaryReportSetup.prototype.patchData = function (reportDestinationId, integratedFlowSummaryReportDestinationPatch) {
        var self = this;
        return $http.patch(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId + '&reportDestinationId=' + reportDestinationId, integratedFlowSummaryReportDestinationPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    PulseFlowSummaryReportSetup.prototype.deleteData = function (reportDestinationId) {
        var self = this;
        return $http.delete(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId + '&reportDestinationId=' + reportDestinationId).then(function (response) {
            self.dataBack = response.data;
            self.loading = false;
            return response;
        });
    };

    PulseFlowSummaryReportSetup.prototype.resendReportEmail = function (customerId, reportId) {
        var self = _this;
        return $http({
            method: 'POST',
            url: HOST + '/api/PulseflowDownload' + '?customerId=' + customerId + '&reportId=' + reportId
        }).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    return PulseFlowSummaryReportSetup;
}

PulseFlowSummaryReportSetupFactory.$inject = ['HOST', '$http'];

angular.module('mc.pulse-flow-summary-report-setup').factory('PulseFlowSummaryReportSetupFactory', PulseFlowSummaryReportSetupFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function PulseFlowSummaryReportSetupController($, $rootScope, $scope, $sce, $http, HOST, authenticationService, translationService, sharedSetupService, PulseFlowSummaryReportSetupFactory, $timeout, $filter, toaster, $uibModal, unsavedChangesService, modalService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.hourToSendLocalTimes = [];
    ctrl.languages = [];
    ctrl.daysOfWeek = [];
    ctrl.volumeUnits = [];
    ctrl.pulseFlowReportDestinations = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.preferredTimeFormat == 1 ? ctrl.isMeridian = true : ctrl.isMeridian = false;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        ctrl.measurementSystems = [{ lookupMeasurementId: 'I', "value": ctrl.translation.text.IMPERIAL }, { lookupMeasurementId: "M", "value": ctrl.translation.text.METRIC }];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.frequency = ctrl.frequency; //need for
        _this2.alerts = [];
        ctrl.initializeSetting();
        ctrl.getPulseFlowSummaryReportDestinations();

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    var _hourToSendLocalTimes = function _hourToSendLocalTimes() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.hourToSendLocalTimes.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.hourToSendLocalTimes.push(arguments[i]);
            } else {
                ctrl.hourToSendLocalTimes[i].name = arguments[i].name;
            }
        }
    };

    var _languages = function _languages() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.languages.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.languages.push(arguments[i]);
            } else {
                ctrl.languages[i].name = arguments[i].name;
            }
        }
    };

    var _daysOfWeek = function _daysOfWeek() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.daysOfWeek.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.daysOfWeek.push(arguments[i]);
            } else {
                ctrl.daysOfWeek[i].name = arguments[i].name;
            }
        }
    };

    var _volumeUnits = function _volumeUnits() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.volumeUnits.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.volumeUnits.push(arguments[i]);
            } else {
                ctrl.volumeUnits[i].name = arguments[i].name;
            }
        }
    };

    ctrl.resendReportPopover = {
        templateUrl: 'ResendReportPopoverTemplate.html'
    };

    ctrl.preferredTimePopover = {
        templateUrl: 'PreferredTimePopoverTemplate.html'
    };

    ctrl.processReportAndSendEmail = function (item) {
        item.popoverIsOpen1 = !item.popoverIsOpen1;
        var _pulseFlowSummaryReportSetupFactory = new PulseFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);

        _pulseFlowSummaryReportSetupFactory.resendReportEmail(ctrl.accountInfo.customerId, item.id).then(function (success) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.OK + ", 1 " + ctrl.translation.text.ATTACHMENT;
            toaster.pop('success', userMessage, ctrl.translation.text.SUCCESS);
        }, function (error) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.FAILURE;
            toaster.pop('error', userMessage, ctrl.translation.text.FAILURE);
        });
        return;
    };

    ctrl.getCurrentDate = function (item) {
        ctrl.oldPreferredTime = item.preferredTime;
        item.preferredTime = new Date();
    };

    ctrl.cancelPreferredTime = function (item) {
        if (ctrl.oldPreferredTime) item.preferredTime = ctrl.oldPreferredTime;
        item.popoverIsOpen2 = !item.popoverIsOpen2;
    };

    ctrl.initializeSetting = function () {
        var _this3 = this;

        ctrl.dt = new Date();
        _hourToSendLocalTimes({
            "id": 1,
            "name": $filter('date')(ctrl.dt.setHours(1, 0), ctrl.timeFormat)
        }, {
            "id": 2,
            "name": $filter('date')(ctrl.dt.setHours(2, 0), ctrl.timeFormat)
        }, {
            "id": 3,
            "name": $filter('date')(ctrl.dt.setHours(3, 0), ctrl.timeFormat)
        }, {
            "id": 4,
            "name": $filter('date')(ctrl.dt.setHours(4, 0), ctrl.timeFormat)
        }, {
            "id": 5,
            "name": $filter('date')(ctrl.dt.setHours(5, 0), ctrl.timeFormat)
        }, {
            "id": 6,
            "name": $filter('date')(ctrl.dt.setHours(6, 0), ctrl.timeFormat)
        }, {
            "id": 7,
            "name": $filter('date')(ctrl.dt.setHours(7, 0), ctrl.timeFormat)
        }, {
            "id": 8,
            "name": $filter('date')(ctrl.dt.setHours(8, 0), ctrl.timeFormat)
        }, {
            "id": 9,
            "name": $filter('date')(ctrl.dt.setHours(9, 0), ctrl.timeFormat)
        }, {
            "id": 10,
            "name": $filter('date')(ctrl.dt.setHours(10, 0), ctrl.timeFormat)
        }, {
            "id": 11,
            "name": $filter('date')(ctrl.dt.setHours(11, 0), ctrl.timeFormat)
        }, {
            "id": 12,
            "name": $filter('date')(ctrl.dt.setHours(12, 0), ctrl.timeFormat)
        }, {
            "id": 13,
            "name": $filter('date')(ctrl.dt.setHours(13, 0), ctrl.timeFormat)
        }, {
            "id": 14,
            "name": $filter('date')(ctrl.dt.setHours(14, 0), ctrl.timeFormat)
        }, {
            "id": 15,
            "name": $filter('date')(ctrl.dt.setHours(15, 0), ctrl.timeFormat)
        }, {
            "id": 16,
            "name": $filter('date')(ctrl.dt.setHours(16, 0), ctrl.timeFormat)
        }, {
            "id": 17,
            "name": $filter('date')(ctrl.dt.setHours(17, 0), ctrl.timeFormat)
        }, {
            "id": 18,
            "name": $filter('date')(ctrl.dt.setHours(18, 0), ctrl.timeFormat)
        }, {
            "id": 19,
            "name": $filter('date')(ctrl.dt.setHours(19, 0), ctrl.timeFormat)
        }, {
            "id": 20,
            "name": $filter('date')(ctrl.dt.setHours(20, 0), ctrl.timeFormat)
        }, {
            "id": 21,
            "name": $filter('date')(ctrl.dt.setHours(21, 0), ctrl.timeFormat)
        }, {
            "id": 22,
            "name": $filter('date')(ctrl.dt.setHours(22, 0), ctrl.timeFormat)
        }, {
            "id": 23,
            "name": $filter('date')(ctrl.dt.setHours(23, 0), ctrl.timeFormat)
        }, {
            "id": 24,
            "name": $filter('date')(ctrl.dt.setHours(24, 0), ctrl.timeFormat)
        });

        _languages({
            "id": 1,
            "name": ctrl.translation.text.ENGLISH
        }, {
            "id": 4,
            "name": ctrl.translation.text.FRENCH
        }, {
            "id": 5,
            "name": ctrl.translation.text.SPANISH
        }, {
            "id": 6,
            "name": ctrl.translation.text.CHINESE
        }, {
            "id": 8,
            "name": ctrl.translation.text.GERMAN
        }, {
            "id": 9,
            "name": ctrl.translation.text.PORTUGUESE
        });

        _daysOfWeek({
            "id": 1,
            "name": ctrl.translation.text.SUNDAY
        }, {
            "id": 2,
            "name": ctrl.translation.text.MONDAY
        }, {
            "id": 3,
            "name": ctrl.translation.text.TUESDAY
        }, {
            "id": 4,
            "name": ctrl.translation.text.WEDNESDAY
        }, {
            "id": 5,
            "name": ctrl.translation.text.THURSDAY
        }, {
            "id": 6,
            "name": ctrl.translation.text.FRIDAY
        }, {
            "id": 7,
            "name": ctrl.translation.text.SATURDAY
        });

        _volumeUnits({
            "id": 1,
            "name": ctrl.translation.text.IMPERIAL
        }, {
            "id": 2,
            "name": ctrl.translation.text.METRIC
        });

        $http.get(HOST + "/api/Overview?customerId=" + this.accountInfo.customerId).then(function (resp) {
            _this3.noDevices = true;
            _this3.alerts = [];
            _this3.devices = resp.data;
            if (_this3.devices.length === 0) {
                _this3.alerts.push({ msg: _this3.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIME' });
                _this3.noDevices = true;
                return;
            } else {
                for (var i = 0; i < _this3.devices.length; i++) {
                    if (_this3.devices[i].inputMode.indexOf('R') !== -1) {
                        _this3.noDevices = false;
                    }
                }
                if (_this3.noDevices) {
                    ctrl.getPulseOptionBoardSettings();
                }
            }
        });
        if (this.noDevices) {
            this.alerts.push({ msg: this.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIMED' });
        }
    };

    ctrl.getPulseOptionBoardSettings = function () {
        $http.get(HOST + "/api/OptionBoardPulse?customerId=" + _this2.accountInfo.customerId).then(function (resp) {
            _this2.pulseOptioBoard = resp.data;
            if (_this2.pulseOptioBoard.length != 0) {
                _this2.noDevices = false;
                return;
            }
        });
    };
    ctrl.getPulseFlowSummaryReportDestinations = function () {

        var _pulseFlowSummaryReportSetupFactory = new PulseFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);

        //2 is for pulse flow summary report destinations
        _pulseFlowSummaryReportSetupFactory.getData(2).then(function () {
            ctrl.pulseFlowReportDestinations = _pulseFlowSummaryReportSetupFactory.list;
            for (var i = 0; i < ctrl.pulseFlowReportDestinations.length; i++) {
                ctrl.pulseFlowReportDestinations[i].language = { id: ctrl.pulseFlowReportDestinations[i].language };
                ctrl.pulseFlowReportDestinations[i].dayOfWeek = { id: ctrl.pulseFlowReportDestinations[i].dayOfWeek };
                ctrl.pulseFlowReportDestinations[i].volumeUnit = { id: ctrl.pulseFlowReportDestinations[i].volumeUnit };
                ctrl.pulseFlowReportDestinations[i].preferredTime = ctrl.dt.setHours(ctrl.pulseFlowReportDestinations[i].hourToSendLocalTime, ctrl.pulseFlowReportDestinations[i].minuteToSendLocalTime);
            }
        });
    };

    ctrl.addDestination = function () {
        var newPulseFlowReportDestination = {
            id: -1,
            reportType: 2,
            customerId: ctrl.accountInfo.customerId,
            emailAddress: '',
            sendAsAttachment: false,
            frequency: 2,
            dayOfWeek: { id: 1 },
            hourToSendLocalTime: 8,
            minuteToSendLocalTime: 0,
            language: { id: 1 },
            volumeUnit: { id: 1 },
            preferredTime: ctrl.dt.setHours(8, 0)
        };
        ctrl.pulseFlowReportDestinations.unshift(newPulseFlowReportDestination);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveDestination = function (item) {
        var _pulseFlowSummaryReportSetupFactory = new PulseFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);
        item.dayOfWeek = item.dayOfWeek.id;
        item.language = item.language.id;
        item.volumeUnit = item.volumeUnit.id;
        //if (!angular.isUndefined(item.hourToSendLocalTime)) item.hourToSendLocalTime = item.hourToSendLocalTime.id;
        _pulseFlowSummaryReportSetupFactory.postData(item).then(function () {
            ctrl.pulseFlowReportDestinations[0] = _pulseFlowSummaryReportSetupFactory.newDestination;
            ctrl.pulseFlowReportDestinations[0].language = { id: _pulseFlowSummaryReportSetupFactory.newDestination.language };
            ctrl.pulseFlowReportDestinations[0].dayOfWeek = { id: _pulseFlowSummaryReportSetupFactory.newDestination.dayOfWeek };
            ctrl.pulseFlowReportDestinations[0].volumeUnit = { id: _pulseFlowSummaryReportSetupFactory.newDestination.volumeUnit };
            ctrl.pulseFlowReportDestinations[0].preferredTime = ctrl.dt.setHours(_pulseFlowSummaryReportSetupFactory.newDestination.hourToSendLocalTime, _pulseFlowSummaryReportSetupFactory.newDestination.minuteToSendLocalTime);
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.cancelDestination = function (item) {
        if (item.id === -1) ctrl.pulseFlowReportDestinations.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.checkEmail = function (item) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!angular.isUndefined(item) && item.length === 0) return false;
        return !re.test(item);
    };

    ctrl.checkIfEmailExists = function (item) {
        for (var i = 0; i < ctrl.pulseFlowReportDestinations.length; i++) {
            if (item.emailAddress.toLowerCase() === ctrl.pulseFlowReportDestinations[i].emailAddress.toLowerCase() && item.id !== ctrl.pulseFlowReportDestinations[i].id) return true;
        }
        return false;
    };

    ctrl.patchData = function (item, propertyName, propertyNameOld, allowNull) {
        if (item.id === -1 || propertyNameOld !== null && item[propertyName] == item[propertyNameOld]) return false;
        if (!allowNull && !item[propertyName]) return false;
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;
        if (propertyName === "emailAddress" && ctrl.checkIfEmailExists(item)) {
            item.emailAddress = item[propertyNameOld];
            return false;
        }
        var tmpPulseFlowReportDestinationPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _pulseFlowSummaryReportSetupFactory = new PulseFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);
        _pulseFlowSummaryReportSetupFactory.patchData(item.id, tmpPulseFlowReportDestinationPatch).then(function () {
            //success
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
        });
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            case "dayOfWeek":
            case "volumeUnit":
            case "language":
            case "hourToSendLocalTime":
            case "minuteToSendLocalTime":
                return true;
            case "emailAddress":
                return !ctrl.checkEmail(value);
            default:
                return false;
        }
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE_REPORT_DESTINATION + ":";
            this.tmpConfirmMessageB = item.emailAddress + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _pulseFlowSummaryReportSetupFactory = new PulseFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);
            _pulseFlowSummaryReportSetupFactory.deleteData(item.id).then(function () {

                var index = ctrl.pulseFlowReportDestinations.indexOf(item);
                if (index !== -1) {
                    ctrl.pulseFlowReportDestinations.splice(index, 1);
                }

                // ctrl.addMode = null;
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.setPreferredTime = function (item) {
        item.popoverIsOpen2 = !item.popoverIsOpen2;
        item.hourToSendLocalTime = item.preferredTime.getHours();
        item.minuteToSendLocalTime = item.preferredTime.getMinutes();
        ctrl.patchData(item, 'hourToSendLocalTime', false);
        ctrl.patchData(item, 'minuteToSendLocalTime', false);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });
};

PulseFlowSummaryReportSetupController.$inject = ['$', '$rootScope', '$scope', '$sce', '$http', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'PulseFlowSummaryReportSetupFactory', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService', 'modalService'];
'use strict';

angular.module('mc.pulse-flow-summary-report-setup').component('pulseFlowSummaryReportSetup', {
    controller: PulseFlowSummaryReportSetupController,
    templateUrl: 'ui/missionreportssetup/weeklyreports/pulseflowsummaryreport/pulse-flow-summary-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.runtime-variance-report-setup", []);
'use strict';

function RuntimeVarianceReportDestinationsFactory(HOST, $http) {
    var _this = this;

    // instantiate our initial object
    var RuntimeVarianceReportDestinations = function RuntimeVarianceReportDestinations(customerId) {
        this.customerId = customerId;
    };

    RuntimeVarianceReportDestinations.prototype.getData = function (frequency) {
        var self = this;
        return $http.get(HOST + '/api/RuntimeVarianceReportDestinations' + '?customerId=' + this.customerId + '&frequency=' + frequency).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    RuntimeVarianceReportDestinations.prototype.postData = function (runtimeReportDestination) {
        var self = this;
        return $http.post(HOST + '/api/RuntimeVarianceReportDestinations' + '?customerId=' + this.customerId, runtimeReportDestination).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    RuntimeVarianceReportDestinations.prototype.patchData = function (id, runtimeReportDestinationPatch) {
        var self = this;
        return $http.patch(HOST + '/api/RuntimeVarianceReportDestinations' + '?customerId=' + this.customerId + '&id=' + id, runtimeReportDestinationPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    RuntimeVarianceReportDestinations.prototype.deleteData = function (id) {
        var self = this;
        return $http.delete(HOST + '/api/RuntimeVarianceReportDestinations' + '?customerId=' + this.customerId + '&id=' + id).then(function (response) {
            self.dataBack = response.data;
            self.loading = false;
            return response;
        });
    };

    RuntimeVarianceReportDestinations.prototype.emailRuntimeVarianceReport = function (customerId, sendTo, langId) {
        var self = _this;
        return $http({
            method: 'POST',
            url: HOST + '/api/RuntimevarianceDownload',
            params: { customerId: customerId, sendTo: sendTo, langId: langId // Pass parameters as an object instead of concatenating them to the URL, this prevents issues with special characters in the parameters
            } }).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    return RuntimeVarianceReportDestinations;
}

RuntimeVarianceReportDestinationsFactory.$inject = ['HOST', '$http'];

angular.module('mc.runtime-variance-report-setup').factory('RuntimeVarianceReportDestinationsFactory', RuntimeVarianceReportDestinationsFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RuntimeVarianceReportSetupController($, $rootScope, $scope, $sce, $http, HOST, authenticationService, translationService, sharedSetupService, RuntimeVarianceReportDestinationsFactory, $timeout, $filter, toaster, $uibModal, unsavedChangesService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.hourToSendLocalTimes = [];
    ctrl.runtimeVarianceReportDestinations = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        ctrl.measurementSystems = [{ lookupMeasurementId: 'I', "value": ctrl.translation.text.IMPERIAL }, { lookupMeasurementId: "M", "value": ctrl.translation.text.METRIC }];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.frequency = ctrl.frequency; //need for
        _this2.alerts = [];
        ctrl.initializeSetting();
        ctrl.getRuntimeVarianceReportDestinations();

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    var _hourToSendLocalTimes = function _hourToSendLocalTimes() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.hourToSendLocalTimes.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.hourToSendLocalTimes.push(arguments[i]);
            } else {
                ctrl.hourToSendLocalTimes[i].name = arguments[i].name;
            }
        }
    };

    ctrl.resendReportPopover = {
        templateUrl: 'ResendReportPopoverTemplate.html'
    };

    ctrl.processReportAndSendEmail = function (item) {
        item.popoverIsOpen1 = !item.popoverIsOpen1;
        var _runtimeVarianceReportDestinationsFactory = new RuntimeVarianceReportDestinationsFactory(ctrl.accountInfo.customerId);

        _runtimeVarianceReportDestinationsFactory.emailRuntimeVarianceReport(ctrl.accountInfo.customerId, item.emailAddress, item.languageCode).then(function (success) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.OK + ", 1 " + ctrl.translation.text.ATTACHMENT;
            toaster.pop('success', userMessage, ctrl.translation.text.SUCCESS);
        }, function (error) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.FAILURE;
            toaster.pop('error', userMessage, ctrl.translation.text.FAILURE);
        });
        return;
    };

    ctrl.initializeSetting = function () {
        var _this3 = this;

        ctrl.dt = new Date();
        _hourToSendLocalTimes({
            "id": 1,
            "name": $filter('date')(ctrl.dt.setHours(1, 0), ctrl.timeFormat)
        }, {
            "id": 2,
            "name": $filter('date')(ctrl.dt.setHours(2, 0), ctrl.timeFormat)
        }, {
            "id": 3,
            "name": $filter('date')(ctrl.dt.setHours(3, 0), ctrl.timeFormat)
        }, {
            "id": 4,
            "name": $filter('date')(ctrl.dt.setHours(4, 0), ctrl.timeFormat)
        }, {
            "id": 5,
            "name": $filter('date')(ctrl.dt.setHours(5, 0), ctrl.timeFormat)
        }, {
            "id": 6,
            "name": $filter('date')(ctrl.dt.setHours(6, 0), ctrl.timeFormat)
        }, {
            "id": 7,
            "name": $filter('date')(ctrl.dt.setHours(7, 0), ctrl.timeFormat)
        }, {
            "id": 8,
            "name": $filter('date')(ctrl.dt.setHours(8, 0), ctrl.timeFormat)
        }, {
            "id": 9,
            "name": $filter('date')(ctrl.dt.setHours(9, 0), ctrl.timeFormat)
        }, {
            "id": 10,
            "name": $filter('date')(ctrl.dt.setHours(10, 0), ctrl.timeFormat)
        }, {
            "id": 11,
            "name": $filter('date')(ctrl.dt.setHours(11, 0), ctrl.timeFormat)
        }, {
            "id": 12,
            "name": $filter('date')(ctrl.dt.setHours(12, 0), ctrl.timeFormat)
        }, {
            "id": 13,
            "name": $filter('date')(ctrl.dt.setHours(13, 0), ctrl.timeFormat)
        }, {
            "id": 14,
            "name": $filter('date')(ctrl.dt.setHours(14, 0), ctrl.timeFormat)
        }, {
            "id": 15,
            "name": $filter('date')(ctrl.dt.setHours(15, 0), ctrl.timeFormat)
        }, {
            "id": 16,
            "name": $filter('date')(ctrl.dt.setHours(16, 0), ctrl.timeFormat)
        }, {
            "id": 17,
            "name": $filter('date')(ctrl.dt.setHours(17, 0), ctrl.timeFormat)
        }, {
            "id": 18,
            "name": $filter('date')(ctrl.dt.setHours(18, 0), ctrl.timeFormat)
        }, {
            "id": 19,
            "name": $filter('date')(ctrl.dt.setHours(19, 0), ctrl.timeFormat)
        }, {
            "id": 20,
            "name": $filter('date')(ctrl.dt.setHours(20, 0), ctrl.timeFormat)
        }, {
            "id": 21,
            "name": $filter('date')(ctrl.dt.setHours(21, 0), ctrl.timeFormat)
        }, {
            "id": 22,
            "name": $filter('date')(ctrl.dt.setHours(22, 0), ctrl.timeFormat)
        }, {
            "id": 23,
            "name": $filter('date')(ctrl.dt.setHours(23, 0), ctrl.timeFormat)
        }, {
            "id": 24,
            "name": $filter('date')(ctrl.dt.setHours(24, 0), ctrl.timeFormat)
        });

        $http.get(HOST + "/api/Overview?customerId=" + this.accountInfo.customerId).then(function (resp) {
            _this3.noDevices = true;
            _this3.alerts = [];
            _this3.devices = resp.data;
            if (_this3.devices.length === 0) {
                _this3.alerts.push({ msg: _this3.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIME' });
                _this3.noDevices = true;
                return;
            } else {
                for (var i = 0; i < _this3.devices.length; i++) {
                    if (_this3.devices[i].inputMode.indexOf('R') !== -1) {
                        _this3.noDevices = false;
                    }
                }
                if (_this3.noDevices) {
                    _this3.alerts.push({ msg: _this3.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIMED' });
                }
            }
        });
    };

    ctrl.getRuntimeVarianceReportDestinations = function () {

        var _runtimeVarianceReportDestinationsFactory = new RuntimeVarianceReportDestinationsFactory(ctrl.accountInfo.customerId);

        _runtimeVarianceReportDestinationsFactory.getData('W').then(function () {
            ctrl.runtimeVarianceReportDestinations = _runtimeVarianceReportDestinationsFactory.list;
            for (var i = 0; i < ctrl.runtimeVarianceReportDestinations.length; i++) {
                ctrl.runtimeVarianceReportDestinations[i].hourToSendLocalTime = { id: ctrl.runtimeVarianceReportDestinations[i].hourToSendLocalTime };
            }
        });
    };

    ctrl.addDestination = function () {
        var newRuntimeVarianceReportDestination = {
            customerId: ctrl.accountInfo.customerId,
            id: -1,
            hourToSendLocalTime: { id: 5 },
            emailAddress: '',
            frequency: 'W',
            measurementSystem: 'I',
            reportLanguage: 'En'

        };
        ctrl.runtimeVarianceReportDestinations.unshift(newRuntimeVarianceReportDestination);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveDestination = function (item) {
        var _runtimeVarianceReportDestinations = new RuntimeVarianceReportDestinationsFactory(ctrl.accountInfo.customerId);
        if (!angular.isUndefined(item.hourToSendLocalTime)) item.hourToSendLocalTime = item.hourToSendLocalTime.id;
        _runtimeVarianceReportDestinations.postData(item).then(function () {
            ctrl.runtimeVarianceReportDestinations[0] = _runtimeVarianceReportDestinations.newDestination;
            ctrl.runtimeVarianceReportDestinations[0].hourToSendLocalTime = { id: ctrl.runtimeVarianceReportDestinations[0].hourToSendLocalTime };
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.cancelDestination = function (item) {
        if (item.id === -1) ctrl.runtimeVarianceReportDestinations.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.checkEmail = function (item) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!angular.isUndefined(item) && item.length === 0) return false;
        return !re.test(item);
    };

    ctrl.checkIfEmailExists = function (item) {
        for (var i = 0; i < ctrl.runtimeVarianceReportDestinations.length; i++) {
            if (item.emailAddress.toLowerCase() === ctrl.runtimeVarianceReportDestinations[i].emailAddress.toLowerCase() && item.id !== ctrl.runtimeVarianceReportDestinations[i].id) return true;
        }
        return false;
    };

    ctrl.patchData = function (item, propertyName, propertyNameOld, allowNull) {
        if (item.id === -1 || propertyNameOld !== null && item[propertyName] == item[propertyNameOld]) return false;
        if (!allowNull && !item[propertyName]) return false;
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;
        if (propertyName === "emailAddress" && ctrl.checkIfEmailExists(item)) {
            item.emailAddress = item[propertyNameOld];
            return false;
        }
        var tmpRuntimeVarianceReportDestinationPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _runtimeVarianceReportDestinations = new RuntimeVarianceReportDestinationsFactory(ctrl.accountInfo.customerId);
        _runtimeVarianceReportDestinations.patchData(item.id, tmpRuntimeVarianceReportDestinationPatch).then(function () {
            //success
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
        });
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            case "hourToSendLocalTime":
            case "measurementSystem":
            case "reportLanguage":
                return true;
            case "emailAddress":
                return !ctrl.checkEmail(value);
            default:
                return false;
        }
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE_REPORT_DESTINATION + ":";
            this.tmpConfirmMessageB = item.emailAddress + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _runtimeVarianceReportDestinations = new RuntimeVarianceReportDestinationsFactory(ctrl.accountInfo.customerId);
            _runtimeVarianceReportDestinations.deleteData(item.id).then(function () {

                var index = ctrl.runtimeVarianceReportDestinations.indexOf(item);
                if (index !== -1) {
                    ctrl.runtimeVarianceReportDestinations.splice(index, 1);
                }

                // ctrl.addMode = null;
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });
};

RuntimeVarianceReportSetupController.$inject = ['$', '$rootScope', '$scope', '$sce', '$http', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'RuntimeVarianceReportDestinationsFactory', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService'];
'use strict';

angular.module('mc.runtime-variance-report-setup').component('runtimeVarianceReportSetup', {
    controller: RuntimeVarianceReportSetupController,
    templateUrl: 'ui/missionreportssetup/weeklyreports/runtimevariancereport/runtime-variance-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.integrated-flow-summary-report-setup", []);
'use strict';

function IntegratedFlowSummaryReportSetupFactory(HOST, $http) {
    var _this = this;

    // instantiate our initial object
    var IntegratedFlowSummaryReportSetup = function IntegratedFlowSummaryReportSetup(customerId) {
        this.customerId = customerId;
    };

    IntegratedFlowSummaryReportSetup.prototype.getData = function (reportTypeId) {
        // 1: Weekly Integrated Flow Summary; 
        // 3: Daily Integrated Flow Summary; 
        var self = this;
        return $http.get(HOST + '/api/ReportDestination/GetList' + '?customerId=' + this.customerId + '&reportTypeId=' + reportTypeId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    IntegratedFlowSummaryReportSetup.prototype.postData = function (integratedFlowSummaryReportDestination) {
        var self = this;
        return $http.post(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId, integratedFlowSummaryReportDestination).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    IntegratedFlowSummaryReportSetup.prototype.patchData = function (reportDestinationId, integratedFlowSummaryReportDestinationPatch) {
        var self = this;
        return $http.patch(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId + '&reportDestinationId=' + reportDestinationId, integratedFlowSummaryReportDestinationPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    IntegratedFlowSummaryReportSetup.prototype.deleteData = function (reportDestinationId) {
        var self = this;
        return $http.delete(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId + '&reportDestinationId=' + reportDestinationId).then(function (response) {
            self.dataBack = response.data;
            self.loading = false;
            return response;
        });
    };

    IntegratedFlowSummaryReportSetup.prototype.resendReportEmail = function (customerId, reportId) {
        var self = _this;
        return $http({
            method: 'POST',
            url: HOST + '/api/IntegratedflowDownload' + '?customerId=' + customerId + '&reportId=' + reportId
        }).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    return IntegratedFlowSummaryReportSetup;
}

IntegratedFlowSummaryReportSetupFactory.$inject = ['HOST', '$http'];

angular.module('mc.integrated-flow-summary-report-setup').factory('IntegratedFlowSummaryReportSetupFactory', IntegratedFlowSummaryReportSetupFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function IntegratedFlowSummaryReportSetupController($, $rootScope, $scope, $sce, $http, HOST, authenticationService, translationService, sharedSetupService, IntegratedFlowSummaryReportSetupFactory, $timeout, $filter, toaster, $uibModal, unsavedChangesService, modalService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.hourToSendLocalTimes = [];
    ctrl.languages = [];
    ctrl.daysOfWeek = [];
    ctrl.volumeUnits = [];
    ctrl.integratedFlowReportDestinations = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.preferredTimeFormat == 1 ? ctrl.isMeridian = true : ctrl.isMeridian = false;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        ctrl.measurementSystems = [{ lookupMeasurementId: 'I', "value": ctrl.translation.text.IMPERIAL }, { lookupMeasurementId: "M", "value": ctrl.translation.text.METRIC }];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.frequency = ctrl.frequency; //need for
        _this2.alerts = [];
        ctrl.initializeSetting();
        ctrl.getIntegratedFlowSummaryReportDestinations();

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    var _hourToSendLocalTimes = function _hourToSendLocalTimes() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.hourToSendLocalTimes.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.hourToSendLocalTimes.push(arguments[i]);
            } else {
                ctrl.hourToSendLocalTimes[i].name = arguments[i].name;
            }
        }
    };

    var _languages = function _languages() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.languages.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.languages.push(arguments[i]);
            } else {
                ctrl.languages[i].name = arguments[i].name;
            }
        }
    };

    var _daysOfWeek = function _daysOfWeek() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.daysOfWeek.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.daysOfWeek.push(arguments[i]);
            } else {
                ctrl.daysOfWeek[i].name = arguments[i].name;
            }
        }
    };

    var _volumeUnits = function _volumeUnits() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.volumeUnits.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.volumeUnits.push(arguments[i]);
            } else {
                ctrl.volumeUnits[i].name = arguments[i].name;
            }
        }
    };

    ctrl.resendReportPopover = {
        templateUrl: 'ResendReportPopoverTemplate.html'
    };

    ctrl.preferredTimePopover = {
        templateUrl: 'PreferredTimePopoverTemplate.html'
    };

    ctrl.processReportAndSendEmail = function (item) {
        item.popoverIsOpen1 = !item.popoverIsOpen1;
        var _integratedFlowSummaryReportSetupFactory = new IntegratedFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);

        _integratedFlowSummaryReportSetupFactory.resendReportEmail(ctrl.accountInfo.customerId, item.id).then(function (success) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.OK + ", 1 " + ctrl.translation.text.ATTACHMENT;
            toaster.pop('success', userMessage, ctrl.translation.text.SUCCESS);
        }, function (error) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.FAILURE;
            toaster.pop('error', userMessage, ctrl.translation.text.FAILURE);
        });
        return;
    };

    ctrl.getCurrentDate = function (item) {
        ctrl.oldPreferredTime = item.preferredTime;
        item.preferredTime = new Date();
    };

    ctrl.cancelPreferredTime = function (item) {
        if (ctrl.oldPreferredTime) item.preferredTime = ctrl.oldPreferredTime;
        item.popoverIsOpen2 = !item.popoverIsOpen2;
    };

    ctrl.initializeSetting = function () {
        var _this3 = this;

        ctrl.dt = new Date();
        _hourToSendLocalTimes({
            "id": 1,
            "name": $filter('date')(ctrl.dt.setHours(1, 0), ctrl.timeFormat)
        }, {
            "id": 2,
            "name": $filter('date')(ctrl.dt.setHours(2, 0), ctrl.timeFormat)
        }, {
            "id": 3,
            "name": $filter('date')(ctrl.dt.setHours(3, 0), ctrl.timeFormat)
        }, {
            "id": 4,
            "name": $filter('date')(ctrl.dt.setHours(4, 0), ctrl.timeFormat)
        }, {
            "id": 5,
            "name": $filter('date')(ctrl.dt.setHours(5, 0), ctrl.timeFormat)
        }, {
            "id": 6,
            "name": $filter('date')(ctrl.dt.setHours(6, 0), ctrl.timeFormat)
        }, {
            "id": 7,
            "name": $filter('date')(ctrl.dt.setHours(7, 0), ctrl.timeFormat)
        }, {
            "id": 8,
            "name": $filter('date')(ctrl.dt.setHours(8, 0), ctrl.timeFormat)
        }, {
            "id": 9,
            "name": $filter('date')(ctrl.dt.setHours(9, 0), ctrl.timeFormat)
        }, {
            "id": 10,
            "name": $filter('date')(ctrl.dt.setHours(10, 0), ctrl.timeFormat)
        }, {
            "id": 11,
            "name": $filter('date')(ctrl.dt.setHours(11, 0), ctrl.timeFormat)
        }, {
            "id": 12,
            "name": $filter('date')(ctrl.dt.setHours(12, 0), ctrl.timeFormat)
        }, {
            "id": 13,
            "name": $filter('date')(ctrl.dt.setHours(13, 0), ctrl.timeFormat)
        }, {
            "id": 14,
            "name": $filter('date')(ctrl.dt.setHours(14, 0), ctrl.timeFormat)
        }, {
            "id": 15,
            "name": $filter('date')(ctrl.dt.setHours(15, 0), ctrl.timeFormat)
        }, {
            "id": 16,
            "name": $filter('date')(ctrl.dt.setHours(16, 0), ctrl.timeFormat)
        }, {
            "id": 17,
            "name": $filter('date')(ctrl.dt.setHours(17, 0), ctrl.timeFormat)
        }, {
            "id": 18,
            "name": $filter('date')(ctrl.dt.setHours(18, 0), ctrl.timeFormat)
        }, {
            "id": 19,
            "name": $filter('date')(ctrl.dt.setHours(19, 0), ctrl.timeFormat)
        }, {
            "id": 20,
            "name": $filter('date')(ctrl.dt.setHours(20, 0), ctrl.timeFormat)
        }, {
            "id": 21,
            "name": $filter('date')(ctrl.dt.setHours(21, 0), ctrl.timeFormat)
        }, {
            "id": 22,
            "name": $filter('date')(ctrl.dt.setHours(22, 0), ctrl.timeFormat)
        }, {
            "id": 23,
            "name": $filter('date')(ctrl.dt.setHours(23, 0), ctrl.timeFormat)
        }, {
            "id": 24,
            "name": $filter('date')(ctrl.dt.setHours(24, 0), ctrl.timeFormat)
        });

        _languages({
            "id": 1,
            "name": ctrl.translation.text.ENGLISH
        }, {
            "id": 4,
            "name": ctrl.translation.text.FRENCH
        }, {
            "id": 5,
            "name": ctrl.translation.text.SPANISH
        }, {
            "id": 6,
            "name": ctrl.translation.text.CHINESE
        }, {
            "id": 8,
            "name": ctrl.translation.text.GERMAN
        }, {
            "id": 9,
            "name": ctrl.translation.text.PORTUGUESE
        });

        _daysOfWeek({
            "id": 1,
            "name": ctrl.translation.text.SUNDAY
        }, {
            "id": 2,
            "name": ctrl.translation.text.MONDAY
        }, {
            "id": 3,
            "name": ctrl.translation.text.TUESDAY
        }, {
            "id": 4,
            "name": ctrl.translation.text.WEDNESDAY
        }, {
            "id": 5,
            "name": ctrl.translation.text.THURSDAY
        }, {
            "id": 6,
            "name": ctrl.translation.text.FRIDAY
        }, {
            "id": 7,
            "name": ctrl.translation.text.SATURDAY
        });

        _volumeUnits({
            "id": 1,
            "name": ctrl.translation.text.IMPERIAL
        }, {
            "id": 2,
            "name": ctrl.translation.text.METRIC
        });

        $http.get(HOST + "/api/Overview?customerId=" + this.accountInfo.customerId).then(function (resp) {
            _this3.noDevices = true;
            _this3.alerts = [];
            _this3.devices = resp.data;
            if (ctrl.accountInfo.integratedFlow === 0) {
                _this3.alerts.push({ msg: _this3.translation.text.INTEGRATED_FLOW_REPORT_NO_RTU_SETUP, type: 'info', languageCode: 'INTEGRATED_FLOW_REPORT_NO_RTU_SETUP' });
                _this3.noDevices = true;
                return;
            } else if (_this3.devices.length === 0) {
                _this3.alerts.push({ msg: _this3.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIME' });
                _this3.noDevices = true;
                return;
            } else {
                for (var i = 0; i < _this3.devices.length; i++) {
                    if (_this3.devices[i].inputMode.indexOf('R') !== -1 || ctrl.accountInfo.integratedFlow > 0) {
                        _this3.noDevices = false;
                    }
                }
                if (_this3.noDevices) {
                    _this3.alerts.push({ msg: _this3.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIMED' });
                }
            }
        });
    };

    ctrl.getIntegratedFlowSummaryReportDestinations = function () {

        var _integratedFlowSummaryReportSetupFactory = new IntegratedFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);

        _integratedFlowSummaryReportSetupFactory.getData(1).then(function () {
            // 1: Weekly Integrated Flow Summary; 3: Daily Integrated Flow Summary; 
            ctrl.integratedFlowReportDestinations = _integratedFlowSummaryReportSetupFactory.list;
            for (var i = 0; i < ctrl.integratedFlowReportDestinations.length; i++) {
                ctrl.integratedFlowReportDestinations[i].language = { id: ctrl.integratedFlowReportDestinations[i].language };
                ctrl.integratedFlowReportDestinations[i].dayOfWeek = { id: ctrl.integratedFlowReportDestinations[i].dayOfWeek };
                ctrl.integratedFlowReportDestinations[i].volumeUnit = { id: ctrl.integratedFlowReportDestinations[i].volumeUnit };
                ctrl.integratedFlowReportDestinations[i].preferredTime = ctrl.dt.setHours(ctrl.integratedFlowReportDestinations[i].hourToSendLocalTime, ctrl.integratedFlowReportDestinations[i].minuteToSendLocalTime);
            }
        });
    };

    ctrl.addDestination = function () {
        var newIntegratedFlowReportDestination = {
            id: -1,
            reportType: 1, // 1: Weekly Integrated Flow Summary; 3: Daily Integrated Flow Summary;
            customerId: ctrl.accountInfo.customerId,
            emailAddress: '',
            sendAsAttachment: false,
            frequency: 2,
            dayOfWeek: { id: 1 },
            hourToSendLocalTime: 8,
            minuteToSendLocalTime: 0,
            language: { id: 1 },
            volumeUnit: { id: 1 },
            preferredTime: ctrl.dt.setHours(8, 0)
        };
        ctrl.integratedFlowReportDestinations.unshift(newIntegratedFlowReportDestination);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveDestination = function (item) {
        var _integratedFlowSummaryReportSetupFactory = new IntegratedFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);
        item.dayOfWeek = item.dayOfWeek.id;
        item.language = item.language.id;
        item.volumeUnit = item.volumeUnit.id;
        //if (!angular.isUndefined(item.hourToSendLocalTime)) item.hourToSendLocalTime = item.hourToSendLocalTime.id;
        _integratedFlowSummaryReportSetupFactory.postData(item).then(function () {
            ctrl.integratedFlowReportDestinations[0] = _integratedFlowSummaryReportSetupFactory.newDestination;
            ctrl.integratedFlowReportDestinations[0].language = { id: _integratedFlowSummaryReportSetupFactory.newDestination.language };
            ctrl.integratedFlowReportDestinations[0].dayOfWeek = { id: _integratedFlowSummaryReportSetupFactory.newDestination.dayOfWeek };
            ctrl.integratedFlowReportDestinations[0].volumeUnit = { id: _integratedFlowSummaryReportSetupFactory.newDestination.volumeUnit };
            ctrl.integratedFlowReportDestinations[0].preferredTime = ctrl.dt.setHours(_integratedFlowSummaryReportSetupFactory.newDestination.hourToSendLocalTime, _integratedFlowSummaryReportSetupFactory.newDestination.minuteToSendLocalTime);
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.cancelDestination = function (item) {
        if (item.id === -1) ctrl.integratedFlowReportDestinations.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.checkEmail = function (item) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!angular.isUndefined(item) && item.length === 0) return false;
        return !re.test(item);
    };

    ctrl.checkIfEmailExists = function (item) {
        for (var i = 0; i < ctrl.integratedFlowReportDestinations.length; i++) {
            if (item.emailAddress.toLowerCase() === ctrl.integratedFlowReportDestinations[i].emailAddress.toLowerCase() && item.id !== ctrl.integratedFlowReportDestinations[i].id) return true;
        }
        return false;
    };

    ctrl.patchData = function (item, propertyName, propertyNameOld, allowNull) {
        if (item.id === -1 || propertyNameOld !== null && item[propertyName] == item[propertyNameOld]) return false;
        if (!allowNull && !item[propertyName]) return false;
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;
        if (propertyName === "emailAddress" && ctrl.checkIfEmailExists(item)) {
            item.emailAddress = item[propertyNameOld];
            return false;
        }
        var tmpIntegratedFlowReportDestinationPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _integratedFlowSummaryReportSetupFactory = new IntegratedFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);
        _integratedFlowSummaryReportSetupFactory.patchData(item.id, tmpIntegratedFlowReportDestinationPatch).then(function () {
            //success
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
        });
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            case "dayOfWeek":
            case "volumeUnit":
            case "language":
            case "hourToSendLocalTime":
            case "minuteToSendLocalTime":
                return true;
            case "emailAddress":
                return !ctrl.checkEmail(value);
            default:
                return false;
        }
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE_REPORT_DESTINATION + ":";
            this.tmpConfirmMessageB = item.emailAddress + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _integratedFlowSummaryReportSetupFactory = new IntegratedFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);
            _integratedFlowSummaryReportSetupFactory.deleteData(item.id).then(function () {

                var index = ctrl.integratedFlowReportDestinations.indexOf(item);
                if (index !== -1) {
                    ctrl.integratedFlowReportDestinations.splice(index, 1);
                }

                // ctrl.addMode = null;
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.setPreferredTime = function (item) {
        item.popoverIsOpen2 = !item.popoverIsOpen2;
        item.hourToSendLocalTime = item.preferredTime.getHours();
        item.minuteToSendLocalTime = item.preferredTime.getMinutes();
        ctrl.patchData(item, 'hourToSendLocalTime', false);
        ctrl.patchData(item, 'minuteToSendLocalTime', false);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });
};

IntegratedFlowSummaryReportSetupController.$inject = ['$', '$rootScope', '$scope', '$sce', '$http', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'IntegratedFlowSummaryReportSetupFactory', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService', 'modalService'];
'use strict';

angular.module('mc.integrated-flow-summary-report-setup').component('integratedFlowSummaryReportSetup', {
    controller: IntegratedFlowSummaryReportSetupController,
    templateUrl: 'ui/missionreportssetup/weeklyreports/integratedflowsummaryreport/integrated-flow-summary-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.integrated-flow-setup", []);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function IntegratedFlowSetupController($, $rootScope, $scope, $sce, $http, HOST, authenticationService, translationService, sharedSetupService, IntegratedFlowSummaryReportSetupFactory, $timeout, $filter, toaster, $uibModal, unsavedChangesService, modalService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.hourToSendLocalTimes = [];
    ctrl.languages = [];
    ctrl.daysOfWeek = [];
    ctrl.volumeUnits = [];
    ctrl.integratedFlowReportDestinations = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.preferredTimeFormat == 1 ? ctrl.isMeridian = true : ctrl.isMeridian = false;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        ctrl.measurementSystems = [{ lookupMeasurementId: 'I', "value": ctrl.translation.text.IMPERIAL }, { lookupMeasurementId: "M", "value": ctrl.translation.text.METRIC }];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.frequency = ctrl.frequency; //need for
        _this2.alerts = [];
        ctrl.initializeSetting();
        ctrl.getIntegratedFlowSummaryReportDestinations();

        //Check for unsaved Changes
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    var _hourToSendLocalTimes = function _hourToSendLocalTimes() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.hourToSendLocalTimes.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.hourToSendLocalTimes.push(arguments[i]);
            } else {
                ctrl.hourToSendLocalTimes[i].name = arguments[i].name;
            }
        }
    };

    var _languages = function _languages() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.languages.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.languages.push(arguments[i]);
            } else {
                ctrl.languages[i].name = arguments[i].name;
            }
        }
    };

    var _daysOfWeek = function _daysOfWeek() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.daysOfWeek.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.daysOfWeek.push(arguments[i]);
            } else {
                ctrl.daysOfWeek[i].name = arguments[i].name;
            }
        }
    };

    var _volumeUnits = function _volumeUnits() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.volumeUnits.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.volumeUnits.push(arguments[i]);
            } else {
                ctrl.volumeUnits[i].name = arguments[i].name;
            }
        }
    };

    ctrl.resendReportPopover = {
        templateUrl: 'ResendReportPopoverTemplate.html'
    };

    ctrl.preferredTimePopover = {
        templateUrl: 'PreferredTimePopoverTemplate.html'
    };

    ctrl.processReportAndSendEmail = function (item) {
        item.popoverIsOpen1 = !item.popoverIsOpen1;
        var _integratedFlowSummaryReportSetupFactory = new IntegratedFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);

        _integratedFlowSummaryReportSetupFactory.resendReportEmail(ctrl.accountInfo.customerId, item.id).then(function (success) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.OK + ", 1 " + ctrl.translation.text.ATTACHMENT;
            toaster.pop('success', userMessage, ctrl.translation.text.SUCCESS);
        }, function (error) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.FAILURE;
            toaster.pop('error', userMessage, ctrl.translation.text.FAILURE);
        });
        return;
    };

    ctrl.getCurrentDate = function (item) {
        ctrl.oldPreferredTime = item.preferredTime;
        item.preferredTime = new Date();
    };

    ctrl.cancelPreferredTime = function (item) {
        if (ctrl.oldPreferredTime) item.preferredTime = ctrl.oldPreferredTime;
        item.popoverIsOpen2 = !item.popoverIsOpen2;
    };

    ctrl.initializeSetting = function () {
        var _this3 = this;

        ctrl.dt = new Date();
        _hourToSendLocalTimes({
            "id": 1,
            "name": $filter('date')(ctrl.dt.setHours(1, 0), ctrl.timeFormat)
        }, {
            "id": 2,
            "name": $filter('date')(ctrl.dt.setHours(2, 0), ctrl.timeFormat)
        }, {
            "id": 3,
            "name": $filter('date')(ctrl.dt.setHours(3, 0), ctrl.timeFormat)
        }, {
            "id": 4,
            "name": $filter('date')(ctrl.dt.setHours(4, 0), ctrl.timeFormat)
        }, {
            "id": 5,
            "name": $filter('date')(ctrl.dt.setHours(5, 0), ctrl.timeFormat)
        }, {
            "id": 6,
            "name": $filter('date')(ctrl.dt.setHours(6, 0), ctrl.timeFormat)
        }, {
            "id": 7,
            "name": $filter('date')(ctrl.dt.setHours(7, 0), ctrl.timeFormat)
        }, {
            "id": 8,
            "name": $filter('date')(ctrl.dt.setHours(8, 0), ctrl.timeFormat)
        }, {
            "id": 9,
            "name": $filter('date')(ctrl.dt.setHours(9, 0), ctrl.timeFormat)
        }, {
            "id": 10,
            "name": $filter('date')(ctrl.dt.setHours(10, 0), ctrl.timeFormat)
        }, {
            "id": 11,
            "name": $filter('date')(ctrl.dt.setHours(11, 0), ctrl.timeFormat)
        }, {
            "id": 12,
            "name": $filter('date')(ctrl.dt.setHours(12, 0), ctrl.timeFormat)
        }, {
            "id": 13,
            "name": $filter('date')(ctrl.dt.setHours(13, 0), ctrl.timeFormat)
        }, {
            "id": 14,
            "name": $filter('date')(ctrl.dt.setHours(14, 0), ctrl.timeFormat)
        }, {
            "id": 15,
            "name": $filter('date')(ctrl.dt.setHours(15, 0), ctrl.timeFormat)
        }, {
            "id": 16,
            "name": $filter('date')(ctrl.dt.setHours(16, 0), ctrl.timeFormat)
        }, {
            "id": 17,
            "name": $filter('date')(ctrl.dt.setHours(17, 0), ctrl.timeFormat)
        }, {
            "id": 18,
            "name": $filter('date')(ctrl.dt.setHours(18, 0), ctrl.timeFormat)
        }, {
            "id": 19,
            "name": $filter('date')(ctrl.dt.setHours(19, 0), ctrl.timeFormat)
        }, {
            "id": 20,
            "name": $filter('date')(ctrl.dt.setHours(20, 0), ctrl.timeFormat)
        }, {
            "id": 21,
            "name": $filter('date')(ctrl.dt.setHours(21, 0), ctrl.timeFormat)
        }, {
            "id": 22,
            "name": $filter('date')(ctrl.dt.setHours(22, 0), ctrl.timeFormat)
        }, {
            "id": 23,
            "name": $filter('date')(ctrl.dt.setHours(23, 0), ctrl.timeFormat)
        }, {
            "id": 24,
            "name": $filter('date')(ctrl.dt.setHours(24, 0), ctrl.timeFormat)
        });

        _languages({
            "id": 1,
            "name": ctrl.translation.text.ENGLISH
        }, {
            "id": 4,
            "name": ctrl.translation.text.FRENCH
        }, {
            "id": 5,
            "name": ctrl.translation.text.SPANISH
        }, {
            "id": 6,
            "name": ctrl.translation.text.CHINESE
        }, {
            "id": 8,
            "name": ctrl.translation.text.GERMAN
        }, {
            "id": 9,
            "name": ctrl.translation.text.PORTUGUESE
        });

        _daysOfWeek({
            "id": 1,
            "name": ctrl.translation.text.SUNDAY
        }, {
            "id": 2,
            "name": ctrl.translation.text.MONDAY
        }, {
            "id": 3,
            "name": ctrl.translation.text.TUESDAY
        }, {
            "id": 4,
            "name": ctrl.translation.text.WEDNESDAY
        }, {
            "id": 5,
            "name": ctrl.translation.text.THURSDAY
        }, {
            "id": 6,
            "name": ctrl.translation.text.FRIDAY
        }, {
            "id": 7,
            "name": ctrl.translation.text.SATURDAY
        });

        _volumeUnits({
            "id": 1,
            "name": ctrl.translation.text.IMPERIAL
        }, {
            "id": 2,
            "name": ctrl.translation.text.METRIC
        });

        $http.get(HOST + "/api/Overview?customerId=" + this.accountInfo.customerId).then(function (resp) {
            _this3.noDevices = true;
            _this3.alerts = [];
            _this3.devices = resp.data;
            if (ctrl.accountInfo.integratedFlow === 0) {
                _this3.alerts.push({ msg: _this3.translation.text.INTEGRATED_FLOW_REPORT_NO_RTU_SETUP, type: 'info', languageCode: 'INTEGRATED_FLOW_REPORT_NO_RTU_SETUP' });
                _this3.noDevices = true;
                return;
            } else if (_this3.devices.length === 0) {
                _this3.alerts.push({ msg: _this3.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIME' });
                _this3.noDevices = true;
                return;
            } else {
                for (var i = 0; i < _this3.devices.length; i++) {
                    if (_this3.devices[i].inputMode.indexOf('R') !== -1 || ctrl.accountInfo.integratedFlow > 0) {
                        _this3.noDevices = false;
                    }
                }
                if (_this3.noDevices) {
                    _this3.alerts.push({ msg: _this3.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIMED' });
                }
            }
        });
    };

    ctrl.getIntegratedFlowSummaryReportDestinations = function () {

        var _integratedFlowSummaryReportSetupFactory = new IntegratedFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);

        _integratedFlowSummaryReportSetupFactory.getData(3).then(function () {
            // 3: Daily Integrated Flow Summary; 1: Weekly Integrated Flow Summary; 
            ctrl.reportList = _integratedFlowSummaryReportSetupFactory.list;

            for (var i = 0; i < ctrl.reportList.length; i++) {
                ctrl.reportList[i].language = { id: ctrl.reportList[i].language };
                ctrl.reportList[i].dayOfWeek = { id: ctrl.reportList[i].dayOfWeek };
                ctrl.reportList[i].volumeUnit = { id: ctrl.reportList[i].volumeUnit };
                ctrl.reportList[i].preferredTime = ctrl.dt.setHours(ctrl.reportList[i].hourToSendLocalTime, ctrl.reportList[i].minuteToSendLocalTime);
                ctrl.reportList[i].reportTime = new Date().setHours(ctrl.reportList[i].startHourOffset, 0, 0, 0);
                ctrl.reportList[i].displayTime = moment(ctrl.reportList[i].reportTime).format(ctrl.timeFormat);
            }
            $timeout(function () {
                ctrl.integratedFlowReportDestinations = ctrl.reportList;
            }, 0);
        });
    };

    ctrl.updateReportTime = function (item) {
        item.displayTime = moment(item.reportTime).format(ctrl.timeFormat);
        item.startHourOffset = item.reportTime.getHours();
        //Delay patch
        if (angular.isDefined(ctrl.delayPatch)) {
            $timeout.cancel(ctrl.delayPatch);
        }
        ctrl.delayPatch = $timeout(function () {
            ctrl.patchData(item, "startHourOffset", false, false);
        }, 1000);
    };

    ctrl.updateDisplayTimeFormat = function (item) {
        ctrl.reportList.map(function (report) {
            report.displayTime = moment(report.reportTime).format(ctrl.timeFormat);
        });
    };

    ctrl.addDestination = function () {
        var newIntegratedFlowReportDestination = {
            id: -1,
            reportType: 3, // 1: Weekly Integrated Flow Summary; 3: Daily Integrated Flow Summary;
            customerId: ctrl.accountInfo.customerId,
            emailAddress: '',
            sendAsAttachment: false,
            frequency: 1,
            dayOfWeek: { id: 1 },
            hourToSendLocalTime: 8,
            minuteToSendLocalTime: 0,
            language: { id: 1 },
            volumeUnit: { id: 1 },
            preferredTime: ctrl.dt.setHours(8, 0),
            startHourOffset: 0,
            reportTime: new Date().setHours(0, 0, 0, 0),
            displayTime: moment(new Date().setHours(0, 0, 0, 0)).format(ctrl.timeFormat)
        };
        ctrl.integratedFlowReportDestinations.unshift(newIntegratedFlowReportDestination);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveDestination = function (item) {
        var _integratedFlowSummaryReportSetupFactory = new IntegratedFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);
        item.dayOfWeek = item.dayOfWeek.id;
        item.language = item.language.id;
        item.volumeUnit = item.volumeUnit.id;
        _integratedFlowSummaryReportSetupFactory.postData(item).then(function () {
            ctrl.integratedFlowReportDestinations[0] = _integratedFlowSummaryReportSetupFactory.newDestination;
            ctrl.integratedFlowReportDestinations[0].language = { id: _integratedFlowSummaryReportSetupFactory.newDestination.language };
            ctrl.integratedFlowReportDestinations[0].dayOfWeek = { id: _integratedFlowSummaryReportSetupFactory.newDestination.dayOfWeek };
            ctrl.integratedFlowReportDestinations[0].volumeUnit = { id: _integratedFlowSummaryReportSetupFactory.newDestination.volumeUnit };
            ctrl.integratedFlowReportDestinations[0].preferredTime = ctrl.dt.setHours(_integratedFlowSummaryReportSetupFactory.newDestination.hourToSendLocalTime, _integratedFlowSummaryReportSetupFactory.newDestination.minuteToSendLocalTime);
            ctrl.integratedFlowReportDestinations[0].reportTime = new Date().setHours(_integratedFlowSummaryReportSetupFactory.newDestination.startHourOffset, 0, 0, 0);
            ctrl.integratedFlowReportDestinations[0].displayTime = moment(ctrl.integratedFlowReportDestinations[0].reportTime).format(ctrl.timeFormat);
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.cancelDestination = function (item) {
        if (item.id === -1) ctrl.integratedFlowReportDestinations.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.checkEmail = function (item) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!angular.isUndefined(item) && item.length === 0) return false;
        return !re.test(item);
    };

    ctrl.checkIfEmailExists = function (item) {
        for (var i = 0; i < ctrl.integratedFlowReportDestinations.length; i++) {
            if (item.emailAddress.toLowerCase() === ctrl.integratedFlowReportDestinations[i].emailAddress.toLowerCase() && item.id !== ctrl.integratedFlowReportDestinations[i].id) return true;
        }
        return false;
    };

    ctrl.patchData = function (item, propertyName, propertyNameOld, allowNull) {
        if (item.id === -1 || propertyNameOld !== null && item[propertyName] == item[propertyNameOld]) return false;
        if (!allowNull && !(propertyName in item)) return false; //if property do not exists in the object
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;
        if (propertyName === "emailAddress" && ctrl.checkIfEmailExists(item)) {
            item.emailAddress = item[propertyNameOld];
            return false;
        }
        var tmpIntegratedFlowReportDestinationPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _integratedFlowSummaryReportSetupFactory = new IntegratedFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);
        _integratedFlowSummaryReportSetupFactory.patchData(item.id, tmpIntegratedFlowReportDestinationPatch).then(function () {
            //success
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
        });
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            case "dayOfWeek":
            case "volumeUnit":
            case "language":
            case "hourToSendLocalTime":
            case "minuteToSendLocalTime":
            case "startHourOffset":
                return true;
            case "emailAddress":
                return !ctrl.checkEmail(value);
            default:
                return false;
        }
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE_REPORT_DESTINATION + ":";
            this.tmpConfirmMessageB = item.emailAddress + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _integratedFlowSummaryReportSetupFactory = new IntegratedFlowSummaryReportSetupFactory(ctrl.accountInfo.customerId);
            _integratedFlowSummaryReportSetupFactory.deleteData(item.id).then(function () {

                var index = ctrl.integratedFlowReportDestinations.indexOf(item);
                if (index !== -1) {
                    ctrl.integratedFlowReportDestinations.splice(index, 1);
                }

                // ctrl.addMode = null;
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.reportRangePopover = {
        templateUrl: 'GenerateReportRangeTemplate.html'
    };

    ctrl.setPreferredTime = function (item) {
        item.popoverIsOpen2 = !item.popoverIsOpen2;
        item.hourToSendLocalTime = item.preferredTime.getHours();
        item.minuteToSendLocalTime = item.preferredTime.getMinutes();
        ctrl.patchData(item, 'hourToSendLocalTime', false);
        ctrl.patchData(item, 'minuteToSendLocalTime', false);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.updateDisplayTimeFormat();
        ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });
};

IntegratedFlowSetupController.$inject = ['$', '$rootScope', '$scope', '$sce', '$http', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'IntegratedFlowSummaryReportSetupFactory', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService', 'modalService'];
'use strict';

angular.module('mc.integrated-flow-setup').component('integratedFlowSetup', {
    controller: IntegratedFlowSetupController,
    templateUrl: 'ui/missionreportssetup/dailyreports/integratedflowsetup/integrated-flow-setup-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.daily-station-report-setup", []);
'use strict';

function DailyStationReportDestinationsFactory(HOST, $http) {

    // instantiate our initial object
    var DailyStationReportDestinations = function DailyStationReportDestinations(customerId) {
        this.customerId = customerId;
    };

    DailyStationReportDestinations.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + '/api/TaskList' + '?customerId=' + this.customerId + '&type=8').then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    DailyStationReportDestinations.prototype.postData = function (taskList) {
        var self = this;
        return $http.post(HOST + '/api/TaskList' + '?customerId=' + this.customerId, taskList).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    DailyStationReportDestinations.prototype.patchData = function (id, taskListPatch) {
        var self = this;
        return $http.patch(HOST + '/api/TaskList' + '?customerId=' + this.customerId + '&id=' + id, taskListPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    DailyStationReportDestinations.prototype.patchReportConfig = function (id, taskListPatch) {
        var self = this;
        return $http.put(HOST + '/api/Reports/StationSummaryReportConfig' + '?customerId=' + this.customerId + '&id=' + id, taskListPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };
    DailyStationReportDestinations.prototype.deleteReportConfig = function (id) {
        var self = this;
        return $http.delete(HOST + '/api/Reports/StationSummaryReportConfig' + '?customerId=' + this.customerId + '&id=' + id).then(function (response) {
            self.dataBack = response.data;
            self.loading = false;
            return response;
        });
    };

    DailyStationReportDestinations.prototype.createReportConfig = function (taskListId, reportConfig) {
        var self = this;
        return $http.post(HOST + '/api/Reports/StationSummaryReportConfig' + '?customerId=' + this.customerId + '&taskListId=' + taskListId, reportConfig).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    DailyStationReportDestinations.prototype.createTaskListAndConfig = function (taskList, reportConfig) {
        var self = this;
        this.currentModel = {};
        this.currentModel.destination = taskList;
        this.currentModel.configuration = reportConfig;
        return $http.post(HOST + '/api/Reports/StationSummaryReportConfig' + '?customerId=' + this.customerId, this.currentModel).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    DailyStationReportDestinations.prototype.deleteData = function (id) {
        var self = this;
        return $http.delete(HOST + '/api/Reports/StationSummaryReportConfig' + '?remove=' + 'y' + '&customerId=' + this.customerId + '&taskListId=' + id).then(function (response) {
            self.dataBack = response.data;
            self.loading = false;
            return response;
        });
    };
    DailyStationReportDestinations.prototype.getDailyStationReport = function (id) {
        var self = this;
        return $http.get(HOST + '/api/Reports/StationSummaryReportConfig' + '?customerId=' + this.customerId + '&tasklistid=' + id).then(function (response) {
            self.listReportConfigs = response.data;
            self.loading = false;
            return response;
        });
    };
    DailyStationReportDestinations.prototype.getDailyStationReportAdd = function () {
        var self = this;
        return $http.get(HOST + '/api/Reports/StationSummaryReportConfig' + '?customerId=' + this.customerId).then(function (response) {
            self.listReportConfigs = response.data;
            self.loading = false;
            return response;
        });
    };
    DailyStationReportDestinations.prototype.emailDailyStationReport = function (customerId, sendTo, taskListId, langId) {
        var self = this;
        return $http({
            method: 'POST',
            url: HOST + '/api/Reports/StationSummaryReportAll',
            params: { customerId: customerId, sendTo: sendTo, taskListId: taskListId, langId: langId }
        }).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    return DailyStationReportDestinations;
}

DailyStationReportDestinationsFactory.$inject = ['HOST', '$http'];

angular.module('mc.daily-station-report-setup').factory('DailyStationReportDestinationsFactory', DailyStationReportDestinationsFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function DailyStationReportSetupController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, DailyStationReportDestinationsFactory, $timeout, $filter, toaster, $uibModal, unsavedChangesService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.showResend = false;
    ctrl.triggerIds = [];
    ctrl.tmpTriggerId = 1077;
    ctrl.dailyStationReportDestinations = [];
    //ctrl.languages = [{"display":"English", "value":"Eng"}, {"display":"French", "value":"Fr"}]
    ctrl.reportConfigs = [];
    ctrl.addReportConfigTriggered = false;
    ctrl.currentTaskListId = '';
    ctrl.selectAllDevices = true;
    ctrl.selectAllCoverPage = true;
    ctrl.selectAllAnalogs = true;
    ctrl.selectAllFlows = true;
    ctrl.selectAllSiteEvents = true;
    ctrl.isLoading = false;

    ctrl.$onInit = function () {
        ctrl.isMobile = $rootScope.mobile;
        ctrl.dateTimeDownload = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        //ctrl.max = new Date().setHours(12,0,0,0);
        ctrl.preferredTimeFormat == 1 ? ctrl.ismeridian = true : ctrl.ismeridian = false;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;

        switch (ctrl.accountInfo.customerId) {
            //Remove option for Beaufort Jasper WSA #358
            case 358:
                ctrl.showResend = false;
                break;
            default:
                ctrl.showResend = true;
                break;
        }

        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.frequency = ctrl.frequency; //need for
        ctrl.measurementSystems = [{ lookupMeasurementId: 1, "value": ctrl.translation.text.IMPERIAL }, { lookupMeasurementId: 2, "value": ctrl.translation.text.METRIC }];
        ctrl.initializeSetting();
        ctrl.getDailyStationReport();

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    ctrl.initializeSetting = function () {
        generateAndLoadTriggerIds();
    };

    var generateAndLoadTriggerIds = function generateAndLoadTriggerIds() {
        var triggerStartId = 1221; // default id for EST = 12AM
        var triggerObj = {};

        //set initial triggerId based on timezone
        switch (ctrl.accountInfo.timeZone.toUpperCase()) {
            case 'C':
                triggerStartId = triggerStartId + 1; //central timezone
                break;
            case 'M':
                //Mountain timezone
                triggerStartId = triggerStartId + 2;
                break;
            case 'P':
                //Pacific timezone
                triggerStartId = triggerStartId + 3;
                break;
            case 'A':
                //Alaska timezone
                triggerStartId = triggerStartId + 4;
                break;
            case 'H':
                //Hawaii timezone
                triggerStartId = triggerStartId + 6;
                break;
            default:
                //Eastern timezone
                triggerStartId = 1221;
                break;
        }

        //dynamically generate triggers for entire 24 hours range
        var dt = new Date();
        for (var i = 1; i <= 23; i++) {
            //hiding the midnight option, per Dave: **Do not let the user choose midnight because M800 data will not be computed before maybe midnight:30
            //for 9AM or 6PM, use old TriggerIDs, 
            //because, those values are already used previously and old report setups are using those IDS
            var calculatedTriggerId = i === 9 || i === 18 ? getOldTriggerIds(i, triggerStartId) : triggerStartId + i;

            triggerObj = {
                "id": calculatedTriggerId,
                "name": $filter('date')(dt.setHours(i, 0), ctrl.timeFormat)
            };
            ctrl.triggerIds.push(triggerObj);
        }
    };

    var getOldTriggerIds = function getOldTriggerIds(hourIndex, currentTriggerId) {
        var oldTriggerId = 1202;
        switch (ctrl.accountInfo.timeZone.toUpperCase()) {
            case 'C':
                //central timezone
                oldTriggerId = hourIndex === 9 ? 1203 : hourIndex === 18 ? 1206 : 1037;
                break;
            case 'M':
                //Mountain timezone
                oldTriggerId = hourIndex === 9 ? 1204 : hourIndex === 18 ? 1207 : 1037;
                break;
            case 'P':
                //Pacific timezone
                oldTriggerId = hourIndex === 9 ? 1205 : hourIndex === 18 ? 1208 : 1037;
                break;
            case 'A':
                //Alaska timezone
                oldTriggerId = currentTriggerId + 1; // this timezone is not supported earlier, so there will not be any existing report schedules
                break;
            case 'H':
                //Hawaii timezone
                oldTriggerId = hourIndex === 9 ? 1209 : hourIndex === 18 ? 1210 : 1037;
                break;
            default:
                //Eastern timezone
                oldTriggerId = hourIndex === 9 ? 1202 : hourIndex === 18 ? 1037 : currentTriggerId + 1;
                break;
        }
        return oldTriggerId;
    };

    var setReportTypeToLanguageMapping = function setReportTypeToLanguageMapping() {
        for (var i = 0; i < ctrl.dailyStationReportDestinations.length; i++) {
            //Daily Station Summary report has been setup for each language type (DSSR-En/Fr/Es/De/PtBr/ZhCn)
            var dssReportType = ctrl.dailyStationReportDestinations[i].type;
            switch (dssReportType) {
                case 8:
                    ctrl.dailyStationReportDestinations[i].language = 'En';
                    break;
                case 9:
                    ctrl.dailyStationReportDestinations[i].language = 'Fr';
                    break;
                case 10:
                    ctrl.dailyStationReportDestinations[i].language = 'De';
                    break;
                case 11:
                    ctrl.dailyStationReportDestinations[i].language = 'Es';
                    break;
                case 12:
                    ctrl.dailyStationReportDestinations[i].language = 'PtBr';
                    break;
                case 13:
                    ctrl.dailyStationReportDestinations[i].language = 'ZhCn';
                    break;
            }
        }
    };

    ctrl.setReportTime = function (offset) {
        ctrl.reportList.map(function (report) {
            report.reportTime = new Date().setHours(report.timeHourOffset, 0, 0, 0);
            report.displayTime = moment(report.reportTime).format(ctrl.timeFormat);
        });
    };

    ctrl.updateReportTime = function (item) {
        item.displayTime = moment(item.reportTime).format(ctrl.timeFormat);
        item.timeHourOffset = item.reportTime.getHours();
        //Delay patch
        if (angular.isDefined(ctrl.delayPatch)) {
            $timeout.cancel(ctrl.delayPatch);
        }
        ctrl.delayPatch = $timeout(function () {
            ctrl.patchData(item, "timeHourOffset", false, false);
        }, 1000);
    };

    ctrl.updateDisplayTimeFormat = function (item) {
        ctrl.reportList.map(function (report) {
            report.displayTime = moment(report.reportTime).format(ctrl.timeFormat);
        });
    };

    ctrl.getDailyStationReport = function () {
        var _dailyStationList = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);
        _dailyStationList.getData().then(function () {
            ctrl.reportList = _dailyStationList.list;
            ctrl.setReportTime();

            for (var i = 0; i < ctrl.reportList.length; i++) {
                ctrl.reportList[i].triggerId = { id: ctrl.reportList[i].triggerId };
            }

            ctrl.dailyStationReportDestinations = ctrl.reportList;
            setReportTypeToLanguageMapping();
        });
    };

    ctrl.setReportConfiguration = function (reportConfig) {
        var tmpDailyStationReportDestinationPatch = {};
        if (ctrl.addMode !== -1) {
            var _dailyStationReportConfig = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);
            _dailyStationReportConfig.patchReportConfig(reportConfig.id, reportConfig).then(function () {}, function (resp) {
                toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
            });
        }
        ctrl.checkReportConfig(ctrl.reportConfigs);
    };

    ctrl.setReportConfigurationAll = function (reportConfig) {
        if (reportConfig.isSelected === true) {
            reportConfig.analog = true;
            reportConfig.coverPage = true;
            reportConfig.flow = true;
            reportConfig.siteEvent = true;
            if (ctrl.addMode !== -1) {
                var _dailyStationCreateReportConfig = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);
                reportConfig.taskListID = ctrl.currentTaskListId;
                _dailyStationCreateReportConfig.createReportConfig(ctrl.currentTaskListId, reportConfig).then(function () {
                    reportConfig.id = _dailyStationCreateReportConfig.newDestination.id;
                }, function (resp) {
                    toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
                });
            }
        } else if (reportConfig.isSelected === false) {
            reportConfig.analog = false;
            reportConfig.coverPage = false;
            reportConfig.flow = false;
            reportConfig.siteEvent = false;
            // lets delete this config please
            if (ctrl.addMode !== -1) {
                var _dailyStationDeleteReportConfig = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);
                _dailyStationDeleteReportConfig.deleteReportConfig(reportConfig.id).then(function () {}, function (resp) {
                    toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
                });
            }
        }
        ctrl.checkReportConfig(ctrl.reportConfigs);
    };

    ctrl.addDestination = function () {
        var newDailyStationReportDestination = {
            customerId: ctrl.accountInfo.customerId,
            id: -1,
            language: 'En',
            strData1: '',
            strData2: '',
            format: 1,
            type: 8, // default adding English (8) report
            pio: true, //popover-is-open
            triggerId: { id: 1202, name: "09:00 AM" },
            lookupMeasurementId: 1,
            timeHourOffset: 0,
            reportTime: new Date().setHours(0, 0, 0, 0),
            displayTime: moment(new Date().setHours(0, 0, 0, 0)).format(ctrl.timeFormat)

        };
        ctrl.dailyStationReportDestinations.unshift(newDailyStationReportDestination);
        ctrl.addMode = -1;
        ctrl.editMode = null;
        ctrl.activeItemId = newDailyStationReportDestination.id;
    };

    ctrl.saveDestination = function (item, reportConfigurations) {
        var _dailyStationReportDestinations = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);
        _dailyStationReportDestinations.createTaskListAndConfig(item, reportConfigurations).then(function () {

            _dailyStationReportDestinations.newDestination.reportTime = new Date().setHours(_dailyStationReportDestinations.newDestination.timeHourOffset, 0, 0, 0);
            _dailyStationReportDestinations.newDestination.displayTime = moment(_dailyStationReportDestinations.newDestination.reportTime).format(ctrl.timeFormat);
            ctrl.dailyStationReportDestinations[0] = _dailyStationReportDestinations.newDestination;
            ctrl.dailyStationReportDestinations[0].triggerId = { id: ctrl.dailyStationReportDestinations[0].triggerId };
            setReportTypeToLanguageMapping();
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.setDestinationForSave = function (item) {
        var _dailyStationReportDestinations = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);

        if (!angular.isUndefined(item.triggerId)) item.triggerId = item.triggerId.id;
        if (item.format === 1) {
            item.strData2 = '';
        } else if (item.format === 0) {
            item.triggerId = ctrl.tmpTriggerId;
        }

        // lets get report type and then pass to checkMethod when adding a new item
        if (item.format === 1) {
            var reportType = ctrl.returnReportType(item.type);
            ctrl.checkMethod(item, reportType);
        }

        if (typeof item.language !== "undefined") delete item.language;

        if (ctrl.addMode === -1) {
            if (ctrl.addReportConfigTriggered === false) {
                _dailyStationReportDestinations.getDailyStationReportAdd().then(function () {
                    ctrl.reportConfigs = _dailyStationReportDestinations.listReportConfigs.configuration;
                    var currentConfigurations = [];
                    for (var i = 0; i < ctrl.reportConfigs.length; i++) {
                        if (ctrl.reportConfigs[i].isSelected === true) {
                            currentConfigurations.push(ctrl.reportConfigs[i]);
                        }
                    }
                    ctrl.reportConfigs = currentConfigurations;
                    ctrl.saveDestination(item, ctrl.reportConfigs);
                });
            } else {
                var currentConfigurations = [];
                for (var i = 0; i < ctrl.reportConfigs.length; i++) {
                    if (ctrl.reportConfigs[i].isSelected === true) {
                        currentConfigurations.push(ctrl.reportConfigs[i]);
                    }
                }
                ctrl.reportConfigs = currentConfigurations;
                ctrl.saveDestination(item, ctrl.reportConfigs);
            }
        }
    };

    ctrl.cancelDestination = function (item) {
        if (item.id === -1) ctrl.dailyStationReportDestinations.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.checkEmail = function (item) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!angular.isUndefined(item) && item.length === 0) return false;
        return !re.test(item);
    };

    var setLanguageToReportTypeMapping = function setLanguageToReportTypeMapping(dssrConfig) {
        switch (dssrConfig.language) {
            case "En":
                dssrConfig.type = 8; //daily station summary report - English
                break;
            case "Fr":
                dssrConfig.type = 9; //aily station summary report - French
                break;
            case "De":
                dssrConfig.type = 10;
                break;
            case "Es":
                dssrConfig.type = 11;
                break;
            case "PtBr":
                dssrConfig.type = 12;
                break;
            case "ZhCn":
                dssrConfig.type = 13;
                break;
        }
    };

    ctrl.checkIfEmailExists = function (item) {
        //NOTE: email, language combination should be unique
        for (var i = 0; i < ctrl.dailyStationReportDestinations.length; i++) {
            if (ctrl.dailyStationReportDestinations[i].type >= 8 && ctrl.dailyStationReportDestinations[i].type <= 13 && // here type = 8 (daily station summary report - English) & type = 9 (daily station summary report - French)
            item.strData1.toLowerCase() === ctrl.dailyStationReportDestinations[i].strData1.toLowerCase() && //strData1 represents email address
            item.id !== ctrl.dailyStationReportDestinations[i].id && item.language === ctrl.dailyStationReportDestinations[i].language) // same language 
                return true;
        }
        return false;
    };

    ctrl.patchData = function (item, propertyName, propertyNameOld, allowNull) {
        if (item.id === -1 || propertyNameOld !== null && item[propertyName] === item[propertyNameOld]) {
            // if language is  slected in add mode lets set the value then return false
            if (propertyName === "language") {
                setLanguageToReportTypeMapping(item);
            }
            return false;
        }
        if (propertyName != "timeHourOffset" && !allowNull && !item[propertyName]) return false;
        //Data for below logic, reference: GlobalVars  
        //Report Type	Description
        //8		        Station Summary Report
        //9		        Station Summary Report FR
        //10		    Station Summary Report De
        //11		    Station Summary Report Es
        //12		    Station Summary Report PtBr
        //13		    Station Summary Report ZhCn
        if (propertyName === "language") {
            propertyName = "type";
            setLanguageToReportTypeMapping(item);
        }
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName], item.format)) return false;
        //following method validates for duplicates on Email & Language combination
        if (ctrl.checkIfEmailExists(item)) {
            //following condition may not be useful
            if (propertyName === "strData1") item.strData1 = item[propertyNameOld];
            return false;
        }

        var tmpDailyStationReportDestinationPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _dailyStationReportDestinations = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);
        _dailyStationReportDestinations.patchData(item.id, tmpDailyStationReportDestinationPatch).then(function () {
            //success
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
        });
    };

    ctrl.selectAllReportConfigs = function (config, selectAll) {
        for (var i = 0; i < ctrl.reportConfigs.length; i++) {
            switch (config) {
                case 1:
                    if (!selectAll && ctrl.reportConfigs[i].isSelected) {
                        ctrl.reportConfigs[i].isSelected = selectAll;
                        ctrl.reportConfigs[i].analog = selectAll;
                        ctrl.reportConfigs[i].coverPage = selectAll;
                        ctrl.reportConfigs[i].flow = selectAll;
                        ctrl.reportConfigs[i].siteEvent = selectAll;
                        ctrl.setReportConfigurationAll(ctrl.reportConfigs[i]);
                    } else if (selectAll && !ctrl.reportConfigs[i].isSelected) {
                        ctrl.reportConfigs[i].isSelected = selectAll;
                        ctrl.reportConfigs[i].analog = selectAll;
                        ctrl.reportConfigs[i].coverPage = selectAll;
                        ctrl.reportConfigs[i].flow = selectAll;
                        ctrl.reportConfigs[i].siteEvent = selectAll;
                        ctrl.setReportConfigurationAll(ctrl.reportConfigs[i]);
                    }
                    break;
                case 2:
                    if (ctrl.reportConfigs[i].isSelected) {
                        ctrl.reportConfigs[i].coverPage = selectAll;
                        ctrl.setReportConfiguration(ctrl.reportConfigs[i]);
                    }
                    break;
                case 3:
                    if (ctrl.reportConfigs[i].isSelected) {
                        ctrl.reportConfigs[i].analog = selectAll;
                        ctrl.setReportConfiguration(ctrl.reportConfigs[i]);
                    }
                    break;
                case 4:
                    if (ctrl.reportConfigs[i].isSelected) {
                        ctrl.reportConfigs[i].flow = selectAll;
                        ctrl.setReportConfiguration(ctrl.reportConfigs[i]);
                    }
                    break;
                case 5:
                    if (ctrl.reportConfigs[i].isSelected) {
                        ctrl.reportConfigs[i].siteEvent = selectAll;
                        ctrl.setReportConfiguration(ctrl.reportConfigs[i]);
                    }
                    break;
            }
        }
    };

    ctrl.checkData = function (propertyName, value, format) {
        switch (propertyName) {
            case "triggerId":
            case "type":
            case "lookupMeasurementId":
            case "timeHourOffset":
                return true;
            case "strData1":
                if (format === 1) {
                    return !ctrl.checkEmail(value);
                } else {
                    return true;
                }
            case "strData2":
                if (format === 1) {
                    return !ctrl.checkPhoneNumber(value);
                } else {
                    return true;
                }
            default:
                return false;
        }
    };

    ctrl.returnReportType = function (type) {
        if (type === 0 || type === 2) {
            return 'legacyhtml';
        } else if (type === 1) {
            return 'legacytext';
        } else if (type === 3 || type === 4) {
            return 'newhtml';
        } else if (type === 5 || type === 6) {
            return 'pdf';
        }
    };

    ctrl.checkMethod = function (item, type) {
        item.typeOld = item.type;
        item.pio = false; //popover-is-open no more
        var _formatChange = false;
        switch (type) {

            case "legacyhtml":
                if (item.format == 0) _formatChange = true;
                item.format = 1;
                if (item.language === 'Eng') {
                    item.type = 0;
                } else if (item.language === 'Fr') {
                    item.type = 2;
                }
                break;

            case "legacytext":
                if (item.format == 0) _formatChange = true;
                item.format = 1;
                item.type = 1;
                item.language = 'Eng';
                break;

            case "newhtml":
                if (item.format == 0) _formatChange = true;
                item.format = 1;
                if (item.language === 'Eng') {
                    item.type = 3;
                } else if (item.language === 'Fr') {
                    item.type = 4;
                }
                break;

            case "pdf":
                if (item.format == 0) _formatChange = true;
                item.format = 1;

                if (item.language === 'En') {
                    item.type = 8;
                } else if (item.language === 'Fr') {
                    item.type = 9;
                }
                break;

            case "fax":
                if (item.format == 1) _formatChange = true;
                item.format = 0;
                item.type = 0;
                break;
        }

        //new block

        //end new block

        if (_formatChange) {
            item.strData1 = '';
            item.strData2 = '';
        }
        ctrl.patchData(item, 'type', 'typeOld', true);
        item.popoverIsOpen = false;
        item.popoverDeviceListIsOpen = false;
    };

    ctrl.resendReportPopover = {
        templateUrl: 'ResendReportPopoverTemplate.html'
    };

    ctrl.dynamicPopover = {
        templateUrl: 'DailyStationReportPopoverTemplate.html'
    };

    ctrl.popoverDeviceList = {
        templateUrl: 'DailyStationDeviceListReportPopoverTemplate.html'
    };

    ctrl.reportTimePopover = {
        templateUrl: 'GenerateReportTimeTemplate.html'
    };

    ctrl.editReportConfig = function (reportItem, mode) {
        ctrl.isLoading = true;
        ctrl.currentTaskListId = reportItem.id;
        var _dailyReportList = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);
        ctrl.reportConfigs = [];
        if (mode === 'edit') {
            _dailyReportList.getDailyStationReport(reportItem.id).then(function () {
                ctrl.reportConfigs = _dailyReportList.listReportConfigs.configuration;
                ctrl.isLoading = false;
                ctrl.checkReportConfig(ctrl.reportConfigs);
            });
        }
    };

    ctrl.addReportConfig = function (reportItem, mode) {
        ctrl.addReportConfigTriggered = true;
        var _dailyReportList = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);
        ctrl.reportConfigs = [];
        if (mode === 'add') {
            _dailyReportList.getDailyStationReportAdd().then(function () {
                ctrl.reportConfigs = _dailyReportList.listReportConfigs.configuration;
            });
        }
    };

    ctrl.processReportAndSendEmail = function (item) {
        item.resendReportPopoverOpen = !item.resendReportPopoverOpen;
        var reportSetupService = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);
        reportSetupService.emailDailyStationReport(ctrl.accountInfo.customerId, item.strData1, item.id, item.language).then(function (success) {
            //console.log('success');
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.OK + ", 1 " + ctrl.translation.text.ATTACHMENT;
            toaster.pop('success', userMessage, ctrl.translation.text.SUCCESS);
            //ctrl.openOkModal(userMessage);
        }, function (error) {
            //console.log('failure');
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.FAILURE;
            toaster.pop('error', userMessage, ctrl.translation.text.FAILURE);
            //ctrl.openOkModal(userMessage);
        });
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE_REPORT_DESTINATION + ":";
            this.tmpConfirmMessageB = item.format === 1 ? ctrl.translation.text.EMAIL + ': ' + item.strData1 : ctrl.translation.text.FAX + ': ' + ctrl.formatPhoneNumberDisplay(item.strData2) + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _dailyStationReportDestinations = new DailyStationReportDestinationsFactory(ctrl.accountInfo.customerId);
            _dailyStationReportDestinations.deleteData(item.id).then(function () {

                var index = ctrl.dailyStationReportDestinations.indexOf(item);
                if (index !== -1) {
                    ctrl.dailyStationReportDestinations.splice(index, 1);
                }

                // ctrl.addMode = null;
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };
    ctrl.checkReportConfig = function (reportConfigs) {

        var oneDeviceSelected = reportConfigs.find(function (x) {
            return x.isSelected == false;
        });
        ctrl.selectAllDevices = typeof oneDeviceSelected !== 'undefined' ? false : true;

        var oneAnalogSelected = reportConfigs.find(function (x) {
            return x.analog == false && x.isSelected == true;
        });
        ctrl.selectAllAnalogs = typeof oneAnalogSelected !== 'undefined' ? false : true;

        var oneCoverPageSelected = reportConfigs.find(function (x) {
            return x.coverPage == false && x.isSelected == true;
        });
        ctrl.selectAllCoverPage = typeof oneCoverPageSelected !== 'undefined' ? false : true;

        var oneFlowSelected = reportConfigs.find(function (x) {
            return x.flow == false && x.isSelected == true;
        });
        ctrl.selectAllFlows = typeof oneFlowSelected !== 'undefined' ? false : true;

        var oneSiteEventSelected = reportConfigs.find(function (x) {
            return x.siteEvent == false && x.isSelected == true;
        });
        ctrl.selectAllSiteEvents = typeof oneSiteEventSelected !== 'undefined' ? false : true;

        var DeviceSelected = reportConfigs.find(function (x) {
            return x.isSelected == true;
        });
        if (typeof DeviceSelected == 'undefined') {
            ctrl.selectAllAnalogs = false;
            ctrl.selectAllCoverPage = false;
            ctrl.selectAllFlows = false;
            ctrl.selectAllSiteEvents = false;
        }
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.preferredTimeFormat = preferredTimeFormat;
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.preferredTimeFormat == 1 ? ctrl.ismeridian = true : ctrl.ismeridian = false;
        ctrl.updateDisplayTimeFormat();
        ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    //Modal popover related code
    ctrl.openOkModal = function (message) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.popoverMessage = message;

            this.ok = function () {
                $uibModalInstance.close();
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/ok-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });
    };
};

DailyStationReportSetupController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'DailyStationReportDestinationsFactory', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService'];
'use strict';

angular.module('mc.daily-station-report-setup').component('dailyStationReportSetup', {
    controller: DailyStationReportSetupController,
    templateUrl: 'ui/missionreportssetup/dailyreports/dailystationreport/daily-station-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.runtime-report-setup", []);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RuntimeReportSetupController(HOST, $, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, RuntimeReportDestinationsFactory, $http, $timeout, $filter, toaster, $uibModal, unsavedChangesService, datetimeService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.hourToSendLocalTimes = [];
    ctrl.runtimeReportDestinations = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.frequency = ctrl.frequency; //need for
        _this2.alerts = [];
        ctrl.initializeSetting();
        ctrl.getDailyRuntimeReport();

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    var _hourToSendLocalTimes = function _hourToSendLocalTimes() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.hourToSendLocalTimes.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.hourToSendLocalTimes.push(arguments[i]);
            } else {
                ctrl.hourToSendLocalTimes[i].name = arguments[i].name;
            }
        }
    };

    ctrl.resendReportPopover = {
        templateUrl: 'ResendReportPopoverTemplate.html'
    };

    ctrl.processReportAndSendEmail = function (item) {
        item.popoverIsOpen1 = !item.popoverIsOpen1;
        var _runtimeReportDestinations = new RuntimeReportDestinationsFactory(ctrl.accountInfo.customerId);
        if (ctrl.frequency == 'D') {
            //Daily
            _runtimeReportDestinations.emailRuntimeDailyReport(ctrl.accountInfo.customerId, item.id).then(function (success) {
                var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.OK + ", 1 " + ctrl.translation.text.ATTACHMENT;
                toaster.pop('success', userMessage, ctrl.translation.text.SUCCESS);
            }, function (error) {
                var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.FAILURE;
                toaster.pop('error', userMessage, ctrl.translation.text.FAILURE);
            });
        } else {
            //Monthly
            _runtimeReportDestinations.emailRuntimeMonthlyReport(ctrl.accountInfo.customerId, item.emailAddress).then(function (success) {
                var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.OK + ", 1 " + ctrl.translation.text.ATTACHMENT;
                toaster.pop('success', userMessage, ctrl.translation.text.SUCCESS);
            }, function (error) {
                var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.FAILURE;
                toaster.pop('error', userMessage, ctrl.translation.text.FAILURE);
            });
        }
    };

    ctrl.initializeSetting = function () {
        var _this3 = this;

        ctrl.dt = new Date();
        _hourToSendLocalTimes({
            "id": 1,
            "name": $filter('date')(ctrl.dt.setHours(1, 0), ctrl.timeFormat)
        }, {
            "id": 2,
            "name": $filter('date')(ctrl.dt.setHours(2, 0), ctrl.timeFormat)
        }, {
            "id": 3,
            "name": $filter('date')(ctrl.dt.setHours(3, 0), ctrl.timeFormat)
        }, {
            "id": 4,
            "name": $filter('date')(ctrl.dt.setHours(4, 0), ctrl.timeFormat)
        }, {
            "id": 5,
            "name": $filter('date')(ctrl.dt.setHours(5, 0), ctrl.timeFormat)
        }, {
            "id": 6,
            "name": $filter('date')(ctrl.dt.setHours(6, 0), ctrl.timeFormat)
        }, {
            "id": 7,
            "name": $filter('date')(ctrl.dt.setHours(7, 0), ctrl.timeFormat)
        }, {
            "id": 8,
            "name": $filter('date')(ctrl.dt.setHours(8, 0), ctrl.timeFormat)
        }, {
            "id": 9,
            "name": $filter('date')(ctrl.dt.setHours(9, 0), ctrl.timeFormat)
        }, {
            "id": 10,
            "name": $filter('date')(ctrl.dt.setHours(10, 0), ctrl.timeFormat)
        }, {
            "id": 11,
            "name": $filter('date')(ctrl.dt.setHours(11, 0), ctrl.timeFormat)
        }, {
            "id": 12,
            "name": $filter('date')(ctrl.dt.setHours(12, 0), ctrl.timeFormat)
        }, {
            "id": 13,
            "name": $filter('date')(ctrl.dt.setHours(13, 0), ctrl.timeFormat)
        }, {
            "id": 14,
            "name": $filter('date')(ctrl.dt.setHours(14, 0), ctrl.timeFormat)
        }, {
            "id": 15,
            "name": $filter('date')(ctrl.dt.setHours(15, 0), ctrl.timeFormat)
        }, {
            "id": 16,
            "name": $filter('date')(ctrl.dt.setHours(16, 0), ctrl.timeFormat)
        }, {
            "id": 17,
            "name": $filter('date')(ctrl.dt.setHours(17, 0), ctrl.timeFormat)
        }, {
            "id": 18,
            "name": $filter('date')(ctrl.dt.setHours(18, 0), ctrl.timeFormat)
        }, {
            "id": 19,
            "name": $filter('date')(ctrl.dt.setHours(19, 0), ctrl.timeFormat)
        }, {
            "id": 20,
            "name": $filter('date')(ctrl.dt.setHours(20, 0), ctrl.timeFormat)
        }, {
            "id": 21,
            "name": $filter('date')(ctrl.dt.setHours(21, 0), ctrl.timeFormat)
        }, {
            "id": 22,
            "name": $filter('date')(ctrl.dt.setHours(22, 0), ctrl.timeFormat)
        }, {
            "id": 23,
            "name": $filter('date')(ctrl.dt.setHours(23, 0), ctrl.timeFormat)
        }, {
            "id": 24,
            "name": $filter('date')(ctrl.dt.setHours(24, 0), ctrl.timeFormat)
        });

        $http.get(HOST + "/api/Overview?customerId=" + this.accountInfo.customerId).then(function (resp) {
            _this3.noDevices = true;
            _this3.alerts = [];
            _this3.devices = resp.data;
            if (_this3.devices.length === 0) {
                _this3.alerts.push({ msg: _this3.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIME' });
                _this3.noDevices = true;
                ctrl.noDevices = _this3.noDevices;
                return;
            } else {
                for (var i = 0; i < _this3.devices.length; i++) {
                    if (_this3.devices[i].inputMode.indexOf('R') !== -1) {
                        _this3.noDevices = false;
                        ctrl.noDevices = _this3.noDevices;
                    }
                }
                if (_this3.noDevices) {
                    _this3.alerts.push({ msg: _this3.translation.text.NO_RTU_RUNTIME, type: 'info', languageCode: 'NO_RTU_RUNTIMED' });
                }
            }
        });
    };

    ctrl.getDailyRuntimeReport = function () {

        var _runtimeReportDestinations = new RuntimeReportDestinationsFactory(ctrl.accountInfo.customerId);

        _runtimeReportDestinations.getDataV2(ctrl.frequency).then(function () {
            ctrl.runtimeReportDestinations = _runtimeReportDestinations.list;
            for (var i = 0; i < ctrl.runtimeReportDestinations.length; i++) {
                ctrl.runtimeReportDestinations[i].hourToSendLocalTime = { id: ctrl.runtimeReportDestinations[i].hourToSendLocalTime };
                // Ensure emailAddress exists as empty string if null
                if (!ctrl.runtimeReportDestinations[i].emailAddress) ctrl.runtimeReportDestinations[i].emailAddress = '';
            }
        });
    };

    ctrl.addDestination = function () {
        var newRuntimeReportDestination = {
            customerId: ctrl.accountInfo.customerId,
            id: -1,
            hourToSendLocalTime: { id: 5 },
            emailAddress: '',
            frequency: ctrl.frequency == 'D' ? 1 : 3, //1: Daily, 3: Monthly
            reportType: ctrl.frequency == 'D' ? 4 : 5, // 4: DailyRuntimeReport, 5: MonthlyRuntimeReport
            reportFormat: ctrl.frequency == 'D' ? 3 : 0, //3: inlineHtml, 0:Xslx
            sendAsAttachment: false,
            dayOfWeek: 1,
            minuteToSendLocalTime: 0,
            language: 1,
            volumeUnit: 1
        };
        ctrl.runtimeReportDestinations.unshift(newRuntimeReportDestination);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveDestination = function (item) {
        var _runtimeReportDestinations = new RuntimeReportDestinationsFactory(ctrl.accountInfo.customerId);
        if (!angular.isUndefined(item.hourToSendLocalTime)) item.hourToSendLocalTime = item.hourToSendLocalTime.id;
        _runtimeReportDestinations.postDataV2(item).then(function () {
            ctrl.runtimeReportDestinations[0] = _runtimeReportDestinations.newDestination;
            ctrl.runtimeReportDestinations[0].hourToSendLocalTime = { id: ctrl.runtimeReportDestinations[0].hourToSendLocalTime };
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.cancelDestination = function (item) {
        if (item.id === -1) ctrl.runtimeReportDestinations.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    // Helper: parse a comma/semicolon/space separated string into normalized lower-case email array
    ctrl.parseEmails = function (value) {
        if (!value) return [];
        return ('' + value).split(/[,;\s]+/).map(function (e) {
            return (e || '').trim().toLowerCase();
        }).filter(function (e) {
            return e.length > 0;
        });
    };

    ctrl.checkEmail = function (value) {
        // Allow multiple addresses separated by comma/semicolon/whitespace.
        // Return true when any address is invalid (preserves original semantics).
        if (angular.isUndefined(value) || value === null) return false;
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var list = [];
        if (angular.isArray(value)) {
            list = value;
        } else {
            list = ('' + value).split(/[,;\s]+/).map(function (e) {
                return (e || '').trim();
            }).filter(function (e) {
                return e.length > 0;
            });
        }
        if (list.length === 0) return false;
        for (var i = 0; i < list.length; i++) {
            if (!re.test(list[i])) return true; // invalid found
        }
        return false; // all valid
    };

    ctrl.checkIfEmailExists = function (item) {
        if (!item || !item.emailAddress) return false;
        var current = ctrl.parseEmails(item.emailAddress);
        if (current.length === 0) return false;
        for (var i = 0; i < ctrl.runtimeReportDestinations.length; i++) {
            var other = ctrl.runtimeReportDestinations[i];
            if (!other || !other.emailAddress) continue;
            if (other.id === item.id) continue;
            var otherList = ctrl.parseEmails(other.emailAddress);
            for (var j = 0; j < current.length; j++) {
                if (otherList.indexOf(current[j]) !== -1) return true;
            }
        }
        return false;
    };

    // Preserve old emailAddress before editing so changes can be reverted if validation fails
    ctrl.setEmailOld = function (item) {
        if (!item) return;
        // store a copy of the current value (string). ensure defined.
        item.emailAddressOld = item.emailAddress || '';
    };

    // user attempted to add duplicate email within same row — show inline flag and global error
    ctrl.handleDuplicateEmailWithinSameRow = function (item, duplicateValue) {
        if (!item) return;
        // Debug: verify this function is invoked
        //try { 
        //    console.log('Duplicate email attempted:', duplicateValue, 'for item.id=', item.id);
        //} catch (e) { }
        // mark the item so template can show inline error icon beside the control
        item._duplicateFlag = true;

        // push a global error alert (use 'danger' for uib-alert to show error styling)
        var msg = ctrl.translation && ctrl.translation.text && ctrl.translation.text.DUPLICATES_NOT_ALLOWED ? ctrl.translation.text.DUPLICATES_NOT_ALLOWED : 'Duplicates not allowed';
        var fullMsg = msg + (duplicateValue ? ': ' + duplicateValue : '');
        ctrl.alerts.push({ msg: fullMsg, type: 'danger', languageCode: 'DUPLICATE_EMAIL' });

        // clear the global alert after 4s (inline flag remains until user updates/removes)
        $timeout(function () {
            for (var k = 0; k < ctrl.alerts.length; k++) {
                if (ctrl.alerts[k].languageCode === 'DUPLICATE_EMAIL') {
                    ctrl.alerts.splice(k, 1);
                    break;
                }
            }
            item._duplicateFlag = false;
        }, 4000);
    };
    // user attempted to add duplicate email compared to other rows — show inline flag and global error
    var validateDuplicateEmailsAgainstOtherRows = function validateDuplicateEmailsAgainstOtherRows(item, duplicateValue) {
        if (!item) return;
        //Debug: verify this function is invoked
        //try {
        //    console.log('Duplicate email attempted:', duplicateValue, 'for item.id=', item.id);
        //} catch (e) { }

        // push a global error alert (use 'danger' for uib-alert to show error styling)
        var msg = ctrl.translation && ctrl.translation.text && ctrl.translation.text.DUPLICATES_NOT_ALLOWED ? ctrl.translation.text.DUPLICATES_NOT_ALLOWED : 'Duplicates not allowed';
        var fullMsg = msg + (duplicateValue ? ': ' + duplicateValue : '');
        ctrl.alerts.push({ msg: fullMsg, type: 'danger', languageCode: 'DUPLICATE_EMAIL' });

        // clear the global alert after 4s (inline flag remains until user updates/removes)
        $timeout(function () {
            for (var k = 0; k < ctrl.alerts.length; k++) {
                if (ctrl.alerts[k].languageCode === 'DUPLICATE_EMAIL') {
                    ctrl.alerts.splice(k, 1);
                    break;
                }
            }
            item.emailAddress = item.emailAddressOld;
        }, 4000);
    };

    // New: called by email-list component when the list changes.
    // Updates the item's emailAddress and patches the server for existing records.
    // Also clears inline duplicate indicator so the user can retry.
    ctrl.emailListChanged = function (item, value, duplicate) {
        // Debug: verify this function is invoked
        //try {
        //    console.log('emailListChanged called for item.id=', item && item.id, 'value=', value);
        //} catch (e) { /* noop in prod */ }
        // store a copy of the current value (string). ensure defined.
        item.emailAddressOld = item.emailAddress || '';
        // Keep model in sync
        item.emailAddress = value;

        // Clear inline duplicate flag as user has modified the address list
        if (item._duplicateFlag) {
            item._duplicateFlag = false;
        }

        // if it is a duplicate emailAddress across other rows, then Show duplicate error message and return without patching
        if (ctrl.checkIfEmailExists(item)) {
            validateDuplicateEmailsAgainstOtherRows(item, duplicate);
            return false;
        }

        // Only patch when this is an existing record (not a new unsaved one with id === -1)
        if (item.id !== -1) {
            // propertyNameOld = null to skip equality check (we already replaced the model)
            ctrl.patchData(item, 'emailAddress', 'emailAddressOld', false);
        }
    };

    ctrl.patchData = function (item, propertyName, propertyNameOld, allowNull) {
        if (item.id === -1 || propertyNameOld !== null && item[propertyName] == item[propertyNameOld]) return false;
        if (!allowNull && !item[propertyName]) return false;
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;
        //verify whether the email address already exists in the list, if yes then return without patching
        if (propertyName === "emailAddress" && ctrl.checkIfEmailExists(item)) {
            return false;
        }
        var tmpRuntimeReportDestinationPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _runtimeReportDestinations = new RuntimeReportDestinationsFactory(ctrl.accountInfo.customerId);
        _runtimeReportDestinations.patchDataV2(item.id, tmpRuntimeReportDestinationPatch).then(function () {
            //success
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Update Error!");
        });
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            case "hourToSendLocalTime":
                return true;
            case "emailAddress":
                return !ctrl.checkEmail(value);
            default:
                return false;
        }
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE_REPORT_DESTINATION + ":";
            this.tmpConfirmMessageB = item.emailAddress + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _runtimeReportDestinations = new RuntimeReportDestinationsFactory(ctrl.accountInfo.customerId);
            _runtimeReportDestinations.deleteDataV2(item.id).then(function () {

                var index = ctrl.runtimeReportDestinations.indexOf(item);
                if (index !== -1) {
                    ctrl.runtimeReportDestinations.splice(index, 1);
                }

                // ctrl.addMode = null;
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });
};

RuntimeReportSetupController.$inject = ['HOST', '$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'RuntimeReportDestinationsFactory', '$http', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService', 'datetimeService'];
'use strict';

angular.module('mc.runtime-report-setup').component('runtimeReportSetup', {
    controller: RuntimeReportSetupController,
    templateUrl: 'ui/missionreportssetup/dailyreports/dailyruntimereportsetup/runtime-report-setup-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        frequency: '<'
    }
});
'use strict';

function RuntimeReportDestinationsFactory(HOST, $http) {
    var _this = this;

    // instantiate our initial object
    var RuntimeReportDestinations = function RuntimeReportDestinations(customerId) {
        this.customerId = customerId;
    };

    RuntimeReportDestinations.prototype.getDataV2 = function (frequency) {
        var self = this;
        var reportTypeId = frequency == 'D' ? 4 : 5; // 4: DailyRuntimeReport, 5: MonthlyRuntimeReport
        return $http.get(HOST + '/api/ReportDestination/GetList' + '?customerId=' + this.customerId + '&reportTypeId=' + reportTypeId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    RuntimeReportDestinations.prototype.postDataV2 = function (reportDestination) {
        var self = this;
        return $http.post(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId, reportDestination).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    RuntimeReportDestinations.prototype.patchDataV2 = function (id, reportDestinationPatch) {
        var self = this;
        return $http.patch(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId + '&reportDestinationId=' + id, reportDestinationPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    RuntimeReportDestinations.prototype.deleteDataV2 = function (id) {
        var self = this;
        return $http.delete(HOST + '/api/ReportDestination' + '?customerId=' + this.customerId + '&reportDestinationId=' + id).then(function (response) {
            self.dataBack = response.data;
            self.loading = false;
            return response;
        });
    };

    RuntimeReportDestinations.prototype.emailRuntimeDailyReport = function (customerId, reportDestinationId) {
        var self = _this;
        return $http({
            method: 'POST',
            url: HOST + '/api/Reports/PostLegacyLikeRuntimeDaily',
            params: { customerId: customerId, reportDestinationId: reportDestinationId }
        }).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    RuntimeReportDestinations.prototype.emailRuntimeMonthlyReport = function (customerId, sendTo) {
        var self = _this;
        return $http({
            method: 'POST',
            url: HOST + '/api/RuntimeMonthlyReport',
            params: { customerId: customerId, sendTo: sendTo }
        }).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    return RuntimeReportDestinations;
}

RuntimeReportDestinationsFactory.$inject = ['HOST', '$http'];

angular.module('mc.runtime-report-setup').factory('RuntimeReportDestinationsFactory', RuntimeReportDestinationsFactory);
'use strict';

(function () {
    'use strict';

    // Email list component:
    // - Binds to `model` (comma-separated string)
    // - Watches `model` for parent-side assignments and updates internal UI immediately
    // - Minimal vertical spacing so row height equals number of email rows only
    // - Does not display remove icon if only one email address exists
    // - Cancel button properly discards input without adding to emails

    function EmailListController($scope, $element, $timeout) {
        var $ctrl = this;

        $ctrl.$onInit = function () {
            $ctrl.maxLength = $ctrl.maxLength || 256;
            $ctrl.placeholder = $ctrl.placeholder || '';
            $ctrl.input = '';
            $ctrl.emails = $ctrl._stringToArray($ctrl.model);
            $ctrl.validEmailsCount = 0;
            $ctrl.adding = false;
            $ctrl.newInput = '';
            $ctrl._suppressWatch = false;
            $ctrl._recomputeValidity();

            // Notify parent when internal emails change
            $scope.$watchCollection(function () {
                return $ctrl.emails;
            }, function (newVal, oldVal) {
                if (newVal === oldVal) return;
                if ($ctrl._suppressWatch) return;
                if ($ctrl.onChange) {
                    $ctrl.onChange({ value: $ctrl._arrayToString(newVal) });
                }
            });

            // Watch the bound `model` so parent-side assignments immediately update UI.
            $scope.$watch(function () {
                return $ctrl.model;
            }, function (newVal, oldVal) {
                if (newVal === oldVal) return;
                $ctrl._suppressWatch = true;
                $ctrl.emails = $ctrl._stringToArray(newVal);
                $ctrl._recomputeValidity();
                $timeout(function () {
                    $ctrl._suppressWatch = false;
                }, 0);
            });
        };

        // helpers
        $ctrl._stringToArray = function (value) {
            if (!value) return [];
            return ('' + value).split(/[,;\s]+/).map(function (e) {
                return (e || '').trim();
            }).filter(function (e) {
                return e.length > 0;
            });
        };

        $ctrl._arrayToString = function (arr) {
            if (!arr || arr.length === 0) return '';
            return arr.join(',');
        };

        $ctrl._isValidEmail = function (email) {
            if (!email) return false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        };

        $ctrl._recomputeValidity = function () {
            $ctrl.validEmailsCount = ($ctrl.emails || []).filter(function (e) {
                return $ctrl._isValidEmail(e);
            }).length;
        };

        // Add items from a raw input string (supports comma/semicolon/space separated)
        $ctrl._addParts = function (raw) {
            if (!raw) return;
            var parts = ('' + raw).split(/[,;\s]+/).map(function (p) {
                return p.trim();
            }).filter(function (p) {
                return p.length > 0;
            });
            var added = false;
            var duplicates = [];
            for (var i = 0; i < parts.length; i++) {
                var part = parts[i];
                if ($ctrl.emails.indexOf(part) === -1) {
                    $ctrl.emails.push(part);
                    added = true;
                } else {
                    duplicates.push(part);
                }
            }
            if (added) {
                $ctrl._syncModel();
            }
            if (duplicates.length > 0 && $ctrl.onDuplicate) {
                duplicates.forEach(function (d) {
                    $timeout(function () {
                        $ctrl.onDuplicate({ value: d });
                    }, 0);
                });
            }
        };

        // Remove email only if more than one exists
        $ctrl.remove = function (index) {
            if ($ctrl.emails.length > 1) {
                $ctrl.emails.splice(index, 1);
                $ctrl._syncModel();
            }
        };

        $ctrl._syncModel = function () {
            $ctrl.model = $ctrl._arrayToString($ctrl.emails);
            $ctrl._recomputeValidity();

            $ctrl._suppressWatch = true;
            if ($ctrl.onChange) {
                $ctrl.onChange({ value: $ctrl.model });
            }
            $timeout(function () {
                $ctrl._suppressWatch = false;
            }, 0);
        };

        // Open the add email input row
        $ctrl.startAdd = function () {
            $ctrl.adding = true;
            $ctrl.newInput = '';
            $timeout(function () {
                var inp = $element[0].querySelector('.email-new-input');
                if (inp) inp.focus();
            }, 0);
        };

        // Commit new email: add from input only if non-empty, then close add row
        $ctrl.commitNew = function () {
            if ($ctrl.newInput && $ctrl.newInput.length > 0) {
                $ctrl._addParts($ctrl.newInput);
            }
            // Always close the add row (whether or not email was added)
            $ctrl.cancelAdd();
        };

        // Cancel adding: close add row WITHOUT committing/adding the email. Discards typed text.
        $ctrl.cancelAdd = function () {
            $ctrl.adding = false;
            $ctrl.newInput = '';
        };

        // Handle key events in the add-email input row
        $ctrl.onNewKeyDown = function ($event) {
            if ($event.key === 'Enter' || $event.key === ',' || $event.key === ';') {
                $event.preventDefault();
                $ctrl.commitNew();
            } else if ($event.key === 'Escape') {
                $event.preventDefault();
                $ctrl.cancelAdd();
            } else if ($event.key === 'Backspace' && !$ctrl.newInput) {
                $event.preventDefault();
                $ctrl.cancelAdd();
            }
        };

        // Blur handler for legacy inline input (kept for compatibility)
        $ctrl.onBlur = function () {
            if ($ctrl.input && $ctrl.input.length > 0) {
                $ctrl._addParts($ctrl.input);
                $ctrl.input = '';
            }
            if ($ctrl.onBlur) $ctrl.onBlur();
        };

        $ctrl.onFocus = function () {
            if ($ctrl.onFocus) $ctrl.onFocus();
        };
    }

    EmailListController.$inject = ['$scope', '$element', '$timeout'];

    angular.module('mc.runtime-report-setup').component('emailList', {
        bindings: {
            model: '=', // two-way bound string (comma separated)
            maxLength: '@?',
            placeholder: '@?',
            onChange: '&?',
            onDuplicate: '&?',
            onBlur: '&?',
            onFocus: '&?'
        },
        controller: EmailListController,
        template:
        // Reduced padding/margins so component does not add extra row height.
        '<div class="email-list" style="border:0; padding:2px; border-radius:3px; box-sizing:border-box;">' + '<div>' +
        // Hide remove icon when only one email exists. Show '+' button only on last row.
        '<div ng-repeat="e in $ctrl.emails track by $index" style="display:flex; width:100%; box-sizing:border-box; margin:0; padding:4px 6px; border-radius:3px; background:transparent; border:0; align-items:center; justify-content:space-between;">' + '<div style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:calc(100% - 56px);">' + '<div ng-class="{\'invalid-email\': !$ctrl._isValidEmail(e)}" style="display:block;">{{e}}</div>' + '</div>' + '<div style="display:flex; align-items:center; margin-left:8px;">' +
        // Remove icon only visible if more than one email exists
        '<i class="fa fa-close clickable" ng-click="$ctrl.remove($index)" ng-if="$ctrl.emails.length > 1" style="font-size:12px; cursor:pointer; margin-left:6px;"></i>' +
        // Add button only on last email row
        '<button type="button" class="btn btn-xs btn-default" ng-if="$last" ng-click="$ctrl.startAdd()" title="Add email" style="padding:3px 6px; font-size:12px; margin-left:6px;">' + '<i class="fa fa-plus"></i>' + '</button>' + '</div>' + '</div>' +
        // Compact add button when list is empty
        '<div ng-if="(!$ctrl.emails || $ctrl.emails.length === 0)" style="display:flex; justify-content:flex-end; margin:0;">' + '<button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.startAdd()" title="Add email" style="padding:3px 6px; font-size:12px;">' + '<i class="fa fa-plus"></i>' + '</button>' + '</div>' + '</div>' +
        // Add-input row appears only when adding; otherwise no extra row visible
        '<div ng-if="$ctrl.adding" style="margin-top:4px; display:block;">' + '<div style="width:100%; box-sizing:border-box; padding:6px 8px; border-radius:3px; background:#fff; border:1px solid #c8e1f6; display:flex; align-items:center;">' + '<!-- Input field: no ng-blur to prevent unwanted commits. Only Enter/comma/semicolon trigger commitNew via ng-keydown -->' + '<input type="text" class="email-new-input" ng-model="$ctrl.newInput" ng-keydown="$ctrl.onNewKeyDown($event)" placeholder="{{$ctrl.placeholder}}" style="border:0; outline:none; width:100%; padding:4px 2px;"/>' + '<!-- Check button commits and adds the email -->' + '<button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.commitNew()" style="margin-left:6px; padding:3px 6px;"><i class="fa fa-check"></i></button>' + '<!-- Cancel button discards input without adding -->' + '<button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.cancelAdd()" style="margin-left:4px; padding:3px 6px;"><i class="fa fa-times"></i></button>' + '</div>' + '</div>' + '</div>' + '<style>.invalid-email{ color:#a94442; font-weight:600; display:block; }</style>'
    });
})();
angular.module('mc.interconnect', []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DigitalInterconnectSetupModel(_, HOST, $http, $rootScope, translationService, authenticationService, modalService, toaster, digitalSettingService, $q) {
    //There are two modes of operation of Interconnect object
    // New => (DisplayMode = 0)=> Adding new Interconnect
    // View/Edit => (DisplayMode=1)=> ReadOnly/Edit Interconnect

    var DigitalInterconnectSetup = function () {
        function DigitalInterconnectSetup(customerId) {
            _classCallCheck(this, DigitalInterconnectSetup);

            this._interconnects = [];
            this._inputDevices = [];
            this._inputDevicesOldSchema = [];
            this._inputDevicesNewSchema = [];
            this._outputDevices = [];
            this._outputDevicesOldSchema = [];
            this._outputDevicesNewSchema = [];
            this._loading = false;
            this._customerId = customerId;
            this._devicesRelayCount = [];
            this.accountInfo = authenticationService.getAccountInfo();
        }

        _createClass(DigitalInterconnectSetup, [{
            key: 'fetchInterconnects',
            value: function fetchInterconnects() {
                var _this = this;

                return $http.get(HOST + '/api/Interconnect/DigitalInterconnectSetup?customerId=' + this._customerId).then(function (resp) {
                    _this._interconnects = resp.data.interconnects;
                    _this._inputDevices = resp.data.inputDevices;
                    // Create a new array excluding M50 devices
                    _this._inputDevicesOldSchema = _this._inputDevices.filter(function (device) {
                        return device.deviceType !== 21;
                    });
                    _this._inputDevicesNewSchema = _this._inputDevices;
                    _this._outputDevices = resp.data.outputDevices;
                    // Create a new array excluding M50 devices
                    _this._outputDevicesOldSchema = _this._outputDevices.filter(function (device) {
                        return device.deviceType !== 21;
                    });
                    _this._outputDevicesNewSchema = _this._outputDevices;
                    _this._devicesRelayCount = resp.data.devicesRelayCount;

                    _this.processInterconnects();
                    _this._loading = false;
                    return resp;
                });
            }
        }, {
            key: 'processInterconnects',
            value: function processInterconnects() {
                for (var i = 0; i < this._interconnects.length; i++) {
                    this._interconnects[i].sourceDeviceID = this._interconnects[i].sourceDeviceID.toString();
                    this._interconnects[i].destinationDeviceID = this._interconnects[i].destinationDeviceID.toString();

                    //update interconnect properites
                    this.setInterconnectProperties(this._interconnects[i]);
                }
            }
        }, {
            key: 'addInterconnect',
            value: function addInterconnect() {
                var newInterconnect = {
                    interconnectID: 0,
                    description: null,
                    sourceDeviceID: null,
                    input: null,
                    destinationDeviceID: null,
                    output: null,
                    polarity: null,
                    ignoreCommFault: null,
                    disableCommFaultOption: false,
                    isNewSchema: true,
                    displayMode: 0 // 0: New, 1: Edit/ReadOnly
                };

                this._interconnects.unshift(newInterconnect);
            }
        }, {
            key: 'setSourceDigitalChannels',
            value: function setSourceDigitalChannels(interconnect) {
                var _this2 = this;

                var icIdx = _.findIndex(this._interconnects, function (ic) {
                    return ic.interconnectID === interconnect.interconnectID;
                });
                var idIdx = _.findIndex(this._inputDevices, function (device) {
                    return device.id == interconnect.sourceDeviceID;
                });

                // If no device is selected yet, clear channels and exit
                if (idIdx === -1 || icIdx === -1) {
                    if (icIdx > -1) this._interconnects[icIdx].sourceDigitalChannels = [];
                    return $q.when();
                }

                var device = this._inputDevices[idIdx];
                this._interconnects[icIdx].sourceDeviceType = device.deviceType;

                // Fetch settings and build the filtered channel array
                return digitalSettingService.getData(this.accountInfo.customerId, interconnect.sourceDeviceID, device.deviceType, false).then(function (resp) {
                    _this2.digitalSettings = resp.data;
                    var filteredChannels = [];
                    var disableChannel1 = device.deviceType === 20 && device.skuId === 2;

                    var _loop = function _loop(i) {
                        var channelValue = i + 1;

                        // Skip channel 1 for M84 MM+
                        if (disableChannel1 && channelValue === 1) {
                            return 'continue';
                        }

                        var matchingSetting = _this2.digitalSettings ? _this2.digitalSettings.find(function (setting) {
                            return setting.channel === channelValue;
                        }) : null;

                        // Only add the channel if it's NOT in Digital Mode 'D'
                        if (!matchingSetting || matchingSetting.digitalMode !== 'D') {
                            filteredChannels.push({ value: channelValue, name: channelValue });
                        }
                    };

                    for (var i = 0; i < device.maxChannels; i++) {
                        var _ret = _loop(i);

                        if (_ret === 'continue') continue;
                    }

                    _this2._interconnects[icIdx].sourceDigitalChannels = filteredChannels;
                });
            }
        }, {
            key: 'setInputRelayChannels',
            value: function setInputRelayChannels(interconnect) {
                var _this3 = this;

                var inputRelayChannels = []; // relay channel values stored as negative (to identify difference between digital and relay channels )
                var icIdx = _.findIndex(this._interconnects, function (ic) {
                    return ic.interconnectID === interconnect.interconnectID;
                });
                //first make sure, current Interconnect source deviceId is present in the DevicesRelays list
                var idIdx = _.findIndex(this._devicesRelayCount, function (device) {
                    return device.deviceId === parseInt(interconnect.sourceDeviceID, 10);
                });
                // set input Relay Channels
                if (idIdx > -1) {
                    //var hasMyDro =  this._inputDevices.find(s=>s.id == this._devicesRelayCount[idIdx].deviceId).hasMyDroExpansion;
                    //var deviceType = this._inputDevices.find(s => s.id == this._devicesRelayCount[idIdx].deviceId).deviceType;

                    //handles situation where there's existing digital interconnect with M50 as source device
                    var matchedDevice = this._inputDevices.find(function (s) {
                        return s.id == _this3._devicesRelayCount[idIdx].deviceId;
                    });
                    var hasMyDro = matchedDevice ? matchedDevice.hasMyDroExpansion : false;
                    var deviceType = matchedDevice ? matchedDevice.deviceType : 21;
                    //M84 devices don't have relay channels
                    if (deviceType == 20) {
                        this._devicesRelayCount[idIdx].relaysCount = 0;
                    }
                    //M50 devices have 1 relay channel
                    else if (deviceType == 21) {
                            this._devicesRelayCount[idIdx].relaysCount = 1;
                        } else if (!hasMyDro) this._devicesRelayCount[idIdx].relaysCount = 3;
                    for (var i = 0; i < this._devicesRelayCount[idIdx].relaysCount; i++) {
                        inputRelayChannels.push({ value: (i + 1) * -1, name: translationService.translation.text.RELAY + ' ' + (i + 1) });
                    }
                }
                this._interconnects[icIdx].inputRelayDisplayText = translationService.translation.text.RELAY + ' ' + interconnect.input * -1;
                this._interconnects[icIdx].inputRelayChannels = inputRelayChannels;
            }
        }, {
            key: 'setOutputRelayChannels',
            value: function setOutputRelayChannels(interconnect) {
                var _this4 = this;

                var outputRelayChannels = []; // output relay channels stored as positive values
                var icIdx = _.findIndex(this._interconnects, function (ic) {
                    return ic.interconnectID === interconnect.interconnectID;
                });
                //first make sure, current Interconnect destination deviceId is present in the DevicesRelays list
                var ddIdx = _.findIndex(this._devicesRelayCount, function (device) {
                    return device.deviceId === parseInt(interconnect.destinationDeviceID, 10);
                });
                //get index for current selected output device from dropdownlist
                var odIdx = _.findIndex(this._outputDevices, function (device) {
                    return device.id === parseInt(interconnect.destinationDeviceID, 10);
                });
                // SAFETY CHECK: If no destination device is selected or index is invalid, clear channels and exit
                if (odIdx === -1 || icIdx === -1) {
                    if (icIdx > -1) {
                        this._interconnects[icIdx].outputRelayChannels = [];
                        this._interconnects[icIdx].outputRelayDisplayText = '';
                    }
                    return;
                }
                // set output Relay Channels
                if (ddIdx > -1) {
                    //first find already used relay channels
                    var usedRelayChannels = [];
                    for (var ic = 0; ic < this._interconnects.length; ic++) {
                        //make sure it is not new interconnect object
                        //or Edit mode given relay should be available in the list
                        if (this._interconnects[ic].destinationDeviceID == interconnect.destinationDeviceID && this._interconnects[ic].output !== null) {
                            usedRelayChannels.push(this._interconnects[ic].output); //output is the channel number
                        }
                    }
                    //removing current output relay channel from used channels, as this should be displayed on dropdown
                    usedRelayChannels = usedRelayChannels.filter(function (x) {
                        return x != interconnect.output;
                    });
                    ////M50 device only has 1 relay channel
                    var tempDevice = this._outputDevices.find(function (s) {
                        return s.id == _this4._devicesRelayCount[ddIdx].deviceId;
                    });
                    if (tempDevice != null && tempDevice.deviceType == 21) {
                        this._devicesRelayCount[ddIdx].relaysCount = 1;
                    }
                    //add relay channels (1 - 9) that are not used in other interconnects
                    //also adding current output relay channel to dropdown list

                    var _loop2 = function _loop2(k) {
                        if (usedRelayChannels.length === 0 || usedRelayChannels.findIndex(function (x) {
                            return x == k;
                        }) < 0) {
                            //NOTE: x and k are not same type, but values are same
                            outputRelayChannels.push({ value: k, name: translationService.translation.text.RELAY + ' ' + k });
                        }
                    };

                    for (var k = 1; k <= this._devicesRelayCount[ddIdx].relaysCount; k++) {
                        _loop2(k);
                    }
                    //removing relay 1 and relay 2 if the device has EBPC purchased
                    if (odIdx > -1 && this._outputDevices[odIdx].ebpcPurchased) {
                        outputRelayChannels = outputRelayChannels.filter(function (x) {
                            return x.value != 1 && x.value != 2;
                        });
                    }
                }
                this._interconnects[icIdx].outputRelayDisplayText = translationService.translation.text.RELAY + ' ' + interconnect.output; //this is used during ReadOnly mode/view
                this._interconnects[icIdx].outputRelayChannels = outputRelayChannels;
                //Get destination device's device type
                this._interconnects[icIdx].destinationDeviceType = this._outputDevices[odIdx].deviceType;
            }
        }, {
            key: 'setSourceCommFailAction',
            value: function setSourceCommFailAction(interconnect) {
                interconnect.disableCommFaultOption = false;
                this._inputDevices.forEach(function (device) {
                    if (interconnect.sourceDeviceID == device.id) {
                        //Check if source device is manhole monitor or manhole monitor plus
                        if (device.deviceType == 15 || device.deviceType == 20) {
                            interconnect.ignoreCommFault = "true";
                            interconnect.disableCommFaultOption = true;
                        }
                    }
                });
            }
        }, {
            key: 'hasNewInterconnect',
            value: function hasNewInterconnect() {
                return _.findIndex(this._interconnects, function (interconnect) {
                    return interconnect.interconnectID === 0;
                }) > -1;
            }
        }, {
            key: 'cancelAdd',
            value: function cancelAdd() {
                this._interconnects.splice(0, 1);
            }
        }, {
            key: 'cancelEdit',
            value: function cancelEdit(interconnect) {
                interconnect.displayMode = 0;
                interconnect = angular.copy(interconnect.backupIntertie, interconnect);
                delete interconnect.backupIntertie;
            }
        }, {
            key: 'deleteInterconnect',
            value: function deleteInterconnect(id) {
                var _this5 = this;

                modalService.confirmDelete('DELETE_INTERCONNECT').then(function () {
                    var interconnect = _this5._interconnects.find(function (item) {
                        return item.interconnectID === id;
                    });
                    // An unsaved edit may point at a different relay than the persisted intertie.
                    var deletedInterconnect = interconnect && angular.copy(interconnect.backupIntertie && interconnect.backupIntertie.destinationDeviceID != null ? interconnect.backupIntertie : interconnect);
                    $http.delete(HOST + '/api/DigitalInterconnectSetup?interconnectId=' + id + '&customerId=' + _this5.accountInfo.customerId).then(function (resp) {
                        var idx = _.findIndex(_this5._interconnects, function (interconnect) {
                            return interconnect.interconnectID === id;
                        });
                        if (idx > -1) {
                            _this5._interconnects.splice(idx, 1);
                        }
                        _this5.processInterconnects();
                        $rootScope.$broadcast('digital_intertie_deleted', id, deletedInterconnect);

                        if (_this5._interconnects.length == 0) $rootScope.$broadcast('interconnectApplicationMenu', { digital: false });
                    }, function (resp) {
                        toaster.pop('error', translationService.translation.text.INTERCONNECT_SETUP, resp.data.message);
                    });
                }, function () {
                    // Do nothing!
                });
            }
        }, {
            key: 'enableEditMode',
            value: function enableEditMode(interconnect) {
                // first cancelEdit of other interconnect objects
                for (var ic = 0; ic < this._interconnects.length; ic++) {
                    if (this._interconnects[ic].displayMode == 1) this.cancelEdit(this._interconnects[ic]);
                }
                this.setSourceCommFailAction(interconnect);
                this.setSourceDigitalChannels(interconnect);
                interconnect.backupIntertie = angular.copy(interconnect);
                interconnect.displayMode = 1;
            }
        }, {
            key: 'validateInterconnect',
            value: function validateInterconnect(interconnect) {
                if (interconnect.description === '' || interconnect.description === null) {
                    return false;
                }

                if (interconnect.sourceDeviceID === null || interconnect.input === null || interconnect.destinationDeviceID === null || interconnect.output === null || interconnect.polarity === null || interconnect.ignoreCommFault === null) {
                    return false;
                }

                if (interconnect.sourceDeviceID == interconnect.destinationDeviceID && interconnect.input == -interconnect.output) {
                    interconnect.error = "Same relay can't be used as source and destination at the same time.";
                    return false;
                }

                return true;
            }
        }, {
            key: 'setInputChannels',
            value: function setInputChannels(interconnect) {
                this.setSourceDigitalChannels(interconnect);
                this.setInputRelayChannels(interconnect);
                this.setSourceCommFailAction(interconnect);
            }
        }, {
            key: 'insertInterconnect',
            value: function insertInterconnect(interconnect) {
                var _this6 = this;

                if (this.validateInterconnect(interconnect)) {
                    $http.post(HOST + '/api/Interconnect/DigitalInterconnectSetup?customerId=' + this._customerId, interconnect).then(function (resp) {
                        //update interconnect properties
                        interconnect = resp.data;
                        var icIdx = _.findIndex(_this6._interconnects, function (intrcnct) {
                            return intrcnct.interconnectID === 0;
                        }); //new interconnectId = 0
                        _this6._interconnects[icIdx] = interconnect; //required to find and replace the properties
                        _this6.processInterconnects();

                        if (_this6._interconnects.length == 1) $rootScope.$broadcast('interconnectApplicationMenu', { digital: true });

                        $rootScope.$broadcast('digital_intertie_added', interconnect);
                    }, function (resp) {
                        interconnect.error = translationService.translation.text.OUTPUT + ': ' + translationService.translation.text.RELAY + ' ' + interconnect.output + ' ' + translationService.translation.text[resp.data];
                    });
                }
            }
        }, {
            key: 'saveInterconnectChange',
            value: function saveInterconnectChange(interconnect) {
                var _this7 = this;

                //interconnect.displayMode = 0;
                if (this.validateInterconnect(interconnect)) {
                    var previousInterconnect = angular.copy(interconnect.backupIntertie);
                    $http.put(HOST + '/api/Interconnect/DigitalInterconnectSetup?customerId=' + this._customerId, interconnect).then(function (resp) {
                        //update interconnect properties
                        interconnect = resp.data;
                        var icIdx = _.findIndex(_this7._interconnects, function (intrcnct) {
                            return intrcnct.interconnectID === interconnect.interconnectID;
                        }); //new interconnectId = 0
                        if (icIdx == -1) {
                            //console.log('Unable to find the interconnect just updated in the list');
                            //this._interconnects[icIdx] = interconnect; 
                            return;
                        } else {
                            _this7._interconnects[icIdx] = interconnect;
                            $rootScope.$broadcast('digital_intertie_updated', interconnect, previousInterconnect);
                        }
                        //this._interconnects[icIdx] = interconnect; //required to find and replace the properties
                        _this7.processInterconnects();
                    }, function (resp) {
                        interconnect.error = '' + translationService.translation.text[resp.data];
                    });
                }
            }
        }, {
            key: 'setInterconnectProperties',
            value: function setInterconnectProperties(interconnect) {
                var idx = _.findIndex(this._interconnects, function (intrcnct) {
                    return intrcnct.interconnectID === interconnect.interconnectID;
                });
                if (idx > -1) {
                    this._interconnects[idx].input = this._interconnects[idx].input.toString();
                    this._interconnects[idx].output = this._interconnects[idx].output.toString();
                    this._interconnects[idx].ignoreCommFault = this._interconnects[idx].ignoreCommFault.toString();
                    this.setSourceDigitalChannels(this._interconnects[idx]);
                    this.setInputRelayChannels(this._interconnects[idx]);
                    this.setOutputRelayChannels(this._interconnects[idx]);
                    this._interconnects[idx].displayMode = 0; //0 for dispaly, 1 for edit
                    this._interconnects[idx].backupIntertie = {};
                }
            }
        }, {
            key: 'interconnects',
            get: function get() {
                return this._interconnects;
            }
        }, {
            key: 'inputDevices',
            get: function get() {
                return this._inputDevices;
            }
        }, {
            key: 'inputDevicesOldSchema',
            get: function get() {
                return this._inputDevicesOldSchema;
            }
        }, {
            key: 'inputDevicesNewSchema',
            get: function get() {
                return this._inputDevicesNewSchema;
            }
        }, {
            key: 'outputDevices',
            get: function get() {
                return this._outputDevices;
            }
        }, {
            key: 'outputDevicesOldSchema',
            get: function get() {
                return this._outputDevicesOldSchema;
            }
        }, {
            key: 'outputDevicesNewSchema',
            get: function get() {
                return this._outputDevicesNewSchema;
            }
        }, {
            key: 'loading',
            get: function get() {
                return this._loading;
            }
        }]);

        return DigitalInterconnectSetup;
    }();

    return DigitalInterconnectSetup;
}

DigitalInterconnectSetupModel.$inject = ['_', 'HOST', '$http', '$rootScope', 'translationService', 'authenticationService', 'modalService', 'toaster', 'digitalSettingService', '$q'];

angular.module('mc.interconnect').factory('DigitalInterconnectSetupModel', DigitalInterconnectSetupModel);
'use strict';

function DigitalInterconnectSetupController(_, $, $rootScope, $scope, $sce, authenticationService, translationService, modalService, DigitalInterconnectSetupModel, wizardSplashService, sharedSetupService, unsavedChangesService, websocketService) {
  var _this2 = this;

  this.$onInit = function () {
    _this2._ = _;
    sharedSetupService.getWindowId(_this2);
    $scope.alerts = [];
    _this2.alerts = [];
    _this2.canClose = false;
    _this2.accountInfo = authenticationService.getAccountInfo();
    _this2.translation = translationService.translation;
    _this2.interconnects = new DigitalInterconnectSetupModel(_this2.accountInfo.customerId);
    _this2.interconnects.fetchInterconnects().then(function (resp) {
      if (resp.data.inputDevices.length === 0 || resp.data.outputDevices.length === 0) {
        var errormsg = _this2.translation.message.NO_ELIGIBLE_DEVICES;
        $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_ELIGIBLE_DEVICES' });
        _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_ELIGIBLE_DEVICES' });
      } else {
        _registerListener(_this2.interconnects.interconnects);
      }
    });

    $scope.$on('updatePreferencesLanguage', function (event, language) {
      if ($scope.alerts.length > 0) {
        var _msg = _this2.translation.message[$scope.alerts[0].languageCode.toUpperCase()];
        var _type = $scope.alerts[0].type;
        var _languageCode = $scope.alerts[0].languageCode;

        $scope.alerts = [];
        _this2.alerts = [];
        $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        _this2.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
      }
    });

    // binding 'dialogbeforeclose' event to Check for unsaved Changes function
    if (!_this2.mobile && !_this2.classicView) {
      _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
      $(_this2._popup).on('dialogbeforeclose', function (event) {
        unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, _this2.interconnects.hasNewInterconnect());
      });
    }
  };

  this.getHeight = function () {
    if (!_this2.mobile && !_this2.classicView) {
      return _this2._popup.parent().find('.digital-interconnect-setup-container')[0].clientHeight - _this2._popup.parent().find('.table')[0].clientHeight;
    }

    return $('.digital-interconnect-setup-container')[0].clientHeight - 65;
  };

  var wsDataReceivedRTUBASICINFOSETTING = function wsDataReceivedRTUBASICINFOSETTING(data) {
    if (data.Type == 'DEVICEBASICINFO' && data.Value.path == "name") {
      for (var i = 0; i < _this2.interconnects.interconnects.length; i++) {
        if (_this2.interconnects.interconnects[i].destinationSerial == data.SN && _this2.interconnects.interconnects[i].destinationSerial == _this2.interconnects.interconnects[i].sourceSerial) {
          _this2.interconnects.interconnects[i].destinationName = data.Value.value;
          _this2.interconnects.interconnects[i].sourceName = data.Value.value;
        } else if (_this2.interconnects.interconnects[i].destinationSerial == data.SN) {
          _this2.interconnects.interconnects[i].destinationName = data.Value.value;
        } else if (_this2.interconnects.interconnects[i].sourceSerial == data.SN) {
          _this2.interconnects.interconnects[i].sourceName = data.Value.value;
        }
      }
    }
  };

  var _registerListener = function _registerListener(interconnectList) {
    for (var i = 0; i < interconnectList.length; i++) {
      if (interconnectList[i].interconnectID != 0) {
        websocketService.register("DEVICEBASICINFO", interconnectList[i].destinationSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
        websocketService.register("DEVICEBASICINFO", interconnectList[i].sourceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
      }
    }
  };

  var _unRegisterListener = function _unRegisterListener(interconnectList) {
    for (var k = 0; k < interconnectList.length; k++) {
      websocketService.unRegister("DEVICEBASICINFO", interconnectList[k].destinationSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
      websocketService.unRegister("DEVICEBASICINFO", interconnectList[k].sourceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
    }
  };

  //$scope.$on('$routeChangeStart', (event) => {
  //  if (this.newKey()) {
  //    if (confirm(this.translation.text.EXIT_WITHOUT_SAVE) !== true) {
  //      console.log(event);
  //      event.preventDefault();
  //      $rootScope.loadingView = false;
  //    }
  //  }
  //});

  this.isAdmin = function () {
    return _this2.accountInfo.userRole === 'Administrator' || _this2.accountInfo.userRole === 'SuperAdministrator';
  };

  this.hasOverflow = function () {
    var element = document.getElementById('setup-rows');
    if (element.offsetHeight < element.scrollHeight) {
      return true;
    }
    return false;
  };

  this.selectInput = function ($event) {
    $event.target.select();
  };

  this.$onDestroy = function () {
    //save wizard step status if wizard splash lauched this view.
    if ($rootScope.launchedByWizard) {
      wizardSplashService.SaveWizardStepStatus(_this2.accountInfo.customerId, _this2.accountInfo.userId, $rootScope.wizardId, _this2.windowId, 2); //save status as completed (2: status complete)
      $rootScope.$broadcast('wizardSplashStepClosed');
      _unRegisterListener(_this2.interconnects.interconnects);
    }
  };
}

DigitalInterconnectSetupController.$inject = ['_', '$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'modalService', 'DigitalInterconnectSetupModel', 'wizardSplashService', 'sharedSetupService', 'unsavedChangesService', 'websocketService'];

angular.module('mc.interconnect').component('digitalInterconnectSetup', {
  controller: DigitalInterconnectSetupController,
  transclude: true,
  templateUrl: 'ui/interconnect/setup/digital/digital-interconnect-setup-partial.html',
  bindings: {
    windowId: '<',
    mobile: '<',
    classicView: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AnalogInterconnectSetupModel(_, HOST, $http, $rootScope, translationService, authenticationService, modalService, toaster) {
    var AnalogInterconnectSetup = function () {
        function AnalogInterconnectSetup(customerId) {
            _classCallCheck(this, AnalogInterconnectSetup);

            this._interconnects = [];
            this._devices = [];
            this._analogOutputDevices = [];
            this._loading = false;
            this._customerId = customerId;
        }

        _createClass(AnalogInterconnectSetup, [{
            key: 'fetchInterconnects',
            value: function fetchInterconnects() {
                var _this = this;

                return $http.get(HOST + '/api/Interconnect/AnalogInterconnectSetup?customerId=' + this._customerId).then(function (resp) {
                    _this._interconnects = resp.data.interconnects;
                    _this._devices = resp.data.devices;
                    _this._analogOutputDevices = resp.data.analogOutputDevices;

                    for (var i = 0; i < _this._interconnects.length; i++) {
                        _this._interconnects[i].sourceDeviceID = _this._interconnects[i].sourceDeviceID.toString();
                        _this._interconnects[i].destinationDeviceID = _this._interconnects[i].destinationDeviceID.toString();
                        _this._interconnects[i].sourceAnalogChannel = _this._interconnects[i].sourceAnalogChannel.toString();
                        _this._interconnects[i].destinationOutputChannel = _this._interconnects[i].destinationOutputChannel.toString();
                        _this._interconnects[i].connectFrequency = _this._interconnects[i].connectFrequency.toString();
                        _this.setChannels(_this._interconnects[i]);
                        _this.setDestChannels(_this._interconnects[i]);
                        _this._interconnects[i].displayMode = 0; //0 for dispaly, 1 for edit
                        _this._interconnects[i].backupIntertie = {}; //used when user cancels editing to restore previous intertie setting
                    }

                    _this._loading = false;

                    return resp;
                });
            }
        }, {
            key: 'addInterconnect',
            value: function addInterconnect() {
                var newInterconnect = {
                    analogIntertieID: 0,
                    description: null,
                    sourceDeviceID: null,
                    sourceAnalogChannel: null,
                    destinationDeviceID: null,
                    destinationOutputChannel: null,
                    connectFrequency: null,
                    displayMode: 0
                };

                this._interconnects.unshift(newInterconnect);
            }
        }, {
            key: 'setChannels',
            value: function setChannels(interconnect) {
                var idx = _.findIndex(this._devices, function (device) {
                    return device.id === parseInt(interconnect.sourceDeviceID, 10);
                });

                if (idx > -1) {
                    var channels = [];
                    for (var i = 0; i < this._devices[idx].maxChannels; i++) {
                        channels.push({ value: i + 1 });
                    }

                    interconnect.sourceChannels = channels;
                    //Get source device's device type
                    interconnect.sourceDeviceType = this._devices[idx].deviceType;
                    return true;
                }

                interconnect.sourceChannels = [];
                return false;
            }
        }, {
            key: 'setDestChannels',
            value: function setDestChannels(interconnect) {
                var idx = _.findIndex(this._analogOutputDevices, function (device) {
                    return device.id === parseInt(interconnect.destinationDeviceID, 10);
                });

                if (idx > -1) {
                    var channels = [];
                    for (var i = 0; i < this._analogOutputDevices[idx].maxChannels; i++) {
                        channels.push({ value: i + 1 });
                    }

                    interconnect.destinationChannels = channels;
                    return true;
                }

                interconnect.destinationChannels = [];
                return false;
            }
        }, {
            key: 'hasNewInterconnect',
            value: function hasNewInterconnect() {
                return _.findIndex(this._interconnects, function (interconnect) {
                    return interconnect.analogIntertieID === 0;
                }) > -1;
            }
        }, {
            key: 'cancelAdd',
            value: function cancelAdd() {
                this._interconnects.splice(0, 1);
            }
        }, {
            key: 'cancelEdit',
            value: function cancelEdit(interconnect) {
                interconnect.displayMode = 0;
                interconnect = angular.copy(interconnect.backupIntertie, interconnect);
                delete interconnect.backupIntertie;
            }
        }, {
            key: 'deleteInterconnect',
            value: function deleteInterconnect(id) {
                var _this2 = this;

                modalService.confirmDelete('DELETE_INTERCONNECT').then(function () {
                    $http.delete(HOST + '/api/Interconnect/AnalogInterconnectSetup?interconnectId=' + id + '&customerId=' + _this2._customerId).then(function (resp) {
                        var idx = _.findIndex(_this2._interconnects, function (interconnect) {
                            return interconnect.analogIntertieID === id;
                        });
                        if (idx > -1) {
                            _this2._interconnects.splice(idx, 1);
                        }

                        $rootScope.$broadcast('analog_intertie_deleted', id);
                        if (_this2._interconnects.length == 0) $rootScope.$broadcast('interconnectApplicationMenu', { analog: false });
                    }, function (resp) {
                        toaster.pop('error', translationService.translation.text.INTERCONNECT_SETUP, resp.data.message);
                    });
                }, function () {
                    // Do nothing!
                });
            }
        }, {
            key: 'enableEditMode',
            value: function enableEditMode(interconnect) {
                interconnect.backupIntertie = angular.copy(interconnect);
                interconnect.displayMode = 1;
            }
        }, {
            key: 'validateInterconnect',
            value: function validateInterconnect(interconnect) {
                if (interconnect.description === '' || interconnect.description === null) {
                    return false;
                }

                if (interconnect.sourceDeviceID === null || interconnect.sourceAnalogChannel === null || interconnect.destinationDeviceID === null || interconnect.destinationOutputChannel === null || interconnect.connectFrequency === null) {
                    return false;
                }

                return true;
            }
        }, {
            key: 'insertInterconnect',
            value: function insertInterconnect(interconnect) {
                var _this3 = this;

                if (this.validateInterconnect(interconnect)) {
                    $http.post(HOST + '/api/Interconnect/AnalogInterconnectSetup?customerId=' + this._customerId, interconnect).then(function (resp) {
                        interconnect.analogIntertieID = resp.data.analogIntertieID;
                        interconnect.sourceDeviceName = resp.data.sourceDeviceName;
                        interconnect.destinationDeviceName = resp.data.destinationDeviceName;

                        if (_this3._interconnects.length == 1) $rootScope.$broadcast('interconnectApplicationMenu', { analog: true });

                        $rootScope.$broadcast('analog_intertie_added', resp.data);
                    }, function (resp) {
                        interconnect.error = '' + translationService.translation.text[resp.data];
                    });
                }
            }
        }, {
            key: 'saveInterconnectChange',
            value: function saveInterconnectChange(interconnect) {
                var _this4 = this;

                if (this.validateInterconnect(interconnect)) {
                    $http.put(HOST + '/api/Interconnect/AnalogInterconnectSetup?customerId=' + this._customerId, interconnect).then(function (resp) {
                        //interconnect.analogIntertieID = resp.data.analogIntertieID;
                        //interconnect.sourceDeviceName = resp.data.sourceDeviceName;
                        //interconnect.destinationDeviceName = resp.data.destinationDeviceName;
                        interconnect = resp.data;

                        $rootScope.$broadcast('reloadAnalogInterconnects', interconnect);
                        $rootScope.$broadcast('analog_intertie_updated', interconnect);
                    }, function (resp) {

                        var count = 0;
                        _this4._interconnects.forEach(function (item) {
                            if (interconnect.destinationDeviceID == item.destinationDeviceID && interconnect.destinationOutputChannel == item.destinationOutputChannel) {
                                count++;
                            }
                        });

                        if (count > 1) {
                            interconnect.error = '' + translationService.translation.text[resp.data];
                        } else {
                            interconnect.error = null;
                            interconnect.displayMode = 0;
                        }
                    });
                }
            }
        }, {
            key: 'interconnects',
            get: function get() {
                return this._interconnects;
            }
        }, {
            key: 'analogOutputDevices',
            get: function get() {
                return this._analogOutputDevices;
            }
        }, {
            key: 'devices',
            get: function get() {
                return this._devices;
            }
        }, {
            key: 'loading',
            get: function get() {
                return this._loading;
            }
        }]);

        return AnalogInterconnectSetup;
    }();

    return AnalogInterconnectSetup;
}

AnalogInterconnectSetupModel.$inject = ['_', 'HOST', '$http', '$rootScope', 'translationService', 'authenticationService', 'modalService', 'toaster'];

angular.module('mc.interconnect').factory('AnalogInterconnectSetupModel', AnalogInterconnectSetupModel);
'use strict';

function AnalogInterconnectSetupController(_, $, $rootScope, $scope, $sce, authenticationService, translationService, modalService, AnalogInterconnectSetupModel, wizardSplashService, sharedSetupService, unsavedChangesService, websocketService) {
    var _this2 = this;

    this.$onInit = function () {
        _this2._ = _;
        $scope.alerts = [];
        _this2.alerts = [];
        _this2.canClose = false;
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;

        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this2);

        _this2.interconnects = new AnalogInterconnectSetupModel(_this2.accountInfo.customerId);

        _this2.interconnects.fetchInterconnects().then(function (resp) {
            if (resp.data.devices.length === 0) {
                var errormsg = _this2.translation.message.NO_ELIGIBLE_DEVICES;
                $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_ELIGIBLE_DEVICES' });
                _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_ELIGIBLE_DEVICES' });
            } else {
                _registerListener(_this2.interconnects.interconnects);
            }
        });

        $scope.$on('updatePreferencesLanguage', function (event, language) {
            if ($scope.alerts.length > 0) {
                var _msg = _this2.translation.message[$scope.alerts[0].languageCode.toUpperCase()];
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;

                $scope.alerts = [];
                _this2.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
                _this2.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });

        $rootScope.$on('reloadAnalogInterconnects', function (interconnect) {
            console.log("Interconnect", interconnect);
            _this2.interconnects.fetchInterconnects().then(function (resp) {
                if (resp.data.devices.length === 0) {
                    var errormsg = _this2.translation.message.NO_ELIGIBLE_DEVICES;
                    $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_ELIGIBLE_DEVICES' });
                    _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_ELIGIBLE_DEVICES' });
                } else {
                    _registerListener(_this2.interconnects.interconnects);
                }
            });
        });

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!_this2.mobile && !_this2.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, _this2.interconnects.hasNewInterconnect());
            });
        }
    };

    var wsDataReceivedRTUBASICINFOSETTING = function wsDataReceivedRTUBASICINFOSETTING(data) {
        if (data.Type == 'DEVICEBASICINFO' && data.Value.path == "name") {
            for (var i = 0; i < _this2.interconnects.interconnects.length; i++) {
                if (_this2.interconnects.interconnects[i].destinationDeviceSerial == data.SN && _this2.interconnects.interconnects[i].destinationDeviceSerial == _this2.interconnects.interconnects[i].sourceDeviceSerial) {
                    _this2.interconnects.interconnects[i].destinationDeviceName = data.Value.value;
                    _this2.interconnects.interconnects[i].sourceDeviceName = data.Value.value;
                } else if (_this2.interconnects.interconnects[i].destinationDeviceSerial == data.SN) {
                    _this2.interconnects.interconnects[i].destinationDeviceName = data.Value.value;
                } else if (_this2.interconnects.interconnects[i].sourceDeviceSerial == data.SN) {
                    _this2.interconnects.interconnects[i].sourceDeviceName = data.Value.value;
                }
            }
        }
    };

    var _registerListener = function _registerListener(interconnectList) {
        for (var i = 0; i < interconnectList.length; i++) {
            if (interconnectList[i].analogIntertieID != 0) {
                websocketService.register("DEVICEBASICINFO", interconnectList[i].destinationDeviceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
                websocketService.register("DEVICEBASICINFO", interconnectList[i].sourceDeviceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
            }
        }
    };

    var _unRegisterListener = function _unRegisterListener(interconnectList) {
        for (var k = 0; k < interconnectList.length; k++) {
            websocketService.unRegister("DEVICEBASICINFO", interconnectList[k].destinationDeviceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
            websocketService.unRegister("DEVICEBASICINFO", interconnectList[k].sourceDeviceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
        }
    };

    this.getHeight = function () {
        if (!_this2.mobile && !_this2.classicView) {
            return _this2._popup.parent().find('.analog-interconnect-setup-container')[0].clientHeight - _this2._popup.parent().find('.table')[0].clientHeight;
        }

        return $('.analog-interconnect-setup-container')[0].clientHeight - 65;
    };

    this.isAdmin = function () {
        return _this2.accountInfo.userRole === 'Administrator' || _this2.accountInfo.userRole === 'SuperAdministrator';
    };

    this.hasOverflow = function () {
        var element = document.getElementById('setup-rows');
        if (element.offsetHeight < element.scrollHeight) {
            return true;
        }
        return false;
    };

    this.selectInput = function ($event) {
        $event.target.select();
    };

    this.$onDestroy = function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(_this2.accountInfo.customerId, _this2.accountInfo.userId, $rootScope.wizardId, _this2.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
            _unRegisterListener(_this2.interconnects.interconnects);
        }
    };
}

AnalogInterconnectSetupController.$inject = ['_', '$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'modalService', 'AnalogInterconnectSetupModel', 'wizardSplashService', 'sharedSetupService', 'unsavedChangesService', 'websocketService'];

angular.module('mc.interconnect').component('analogInterconnectSetup', {
    controller: AnalogInterconnectSetupController,
    transclude: true,
    templateUrl: 'ui/interconnect/setup/analog/analog-interconnect-setup-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<'
    }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AnalogInterconnectChartModel(HOST, $http, translationService) {
  var AnalogInterconnect = function () {
    function AnalogInterconnect(customerId, interconnectId) {
      _classCallCheck(this, AnalogInterconnect);

      this._loading = false;
      this._customerId = customerId;
      this._interconnectId = interconnectId;
    }

    _createClass(AnalogInterconnect, [{
      key: 'fetchData',
      value: function fetchData(startDate, endDate) {
        var _this = this;

        this._loading = true;
        return $http.get(HOST + '/api/Interconnect/AnalogIntertieChart?customerID=' + this._customerId + '&analogIntertieId=' + this._interconnectId + '&StartDate=' + startDate + '&EndDate=' + endDate).then(function (resp) {
          _this._loading = false;

          return resp;
        });
      }
    }, {
      key: 'fetchDetails',
      value: function fetchDetails() {
        return $http.get(HOST + '/api/Interconnect/AnalogIntertieDetails?customerID=' + this._customerId + '&analogIntertieId=' + this._interconnectId).then(function (resp) {
          return resp;
        });
      }
    }, {
      key: 'loading',
      get: function get() {
        return this._loading;
      }
    }]);

    return AnalogInterconnect;
  }();

  return AnalogInterconnect;
}

AnalogInterconnectChartModel.$inject = ['HOST', '$http', 'translationService'];

angular.module('mc.interconnect').factory('analogInterconnectChartModel', AnalogInterconnectChartModel);
'use strict';

function AnalogInterconnectChartController(_, $, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, timeLapseService, websocketService, openViewService, sharedSetupService, AnalogInterconnectChart, $location, toaster, rangeSelectorService) {
    var _this2 = this;

    var getInputName = function getInputName(status) {
        if (status.sourceChannelName) {
            return status.sourceChannelName;
        }

        return _this2.translation.text.CHANNEL + ' ' + status.sourceAnalogChannel;
    };

    var getOutputName = function getOutputName(status) {
        if (status.destinationChannelName) {
            return status.destinationChannelName;
        }

        return _this2.translation.text.CHANNEL + ' ' + status.destinationOutputChannel;
    };

    var wsDataReceivedANALOGOUT = function wsDataReceivedANALOGOUT(data) {
        if (_this2.liveData === false) {
            unregisterListener();
            return;
        }
        if (!_this2.lastAnalogSourceLive.rawTime) {
            // TODO: SHOULD never happen, but in case it does we should probably have a use case
            // TODO: Maybe either just call the db function or insert some kind of dummy data? Maybe do nothing for chart?
        } else {
            var extremes = _this2.chart.xAxis[0].getExtremes();
            var tmpRange = extremes.max - extremes.min;

            var str = '' + data.Time;
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2), 10) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2));
            unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, _this2.accountInfo.timeZone);

            // The source points were accumulated from the ANALOG_G2 / ANALOGRAW messages but held back.
            // Now that the AnalogOutput message arrived, add only the points whose timestamp is
            // <= the output timestamp. Any newer points are kept for a later AnalogOutput message.
            var flushSourcePoints = function flushSourcePoints(points, series) {
                if (!points || !points.length) return points || [];
                var remaining = [];
                var toAdd = [];
                points.forEach(function (point) {
                    if (point[0] <= unixtime) toAdd.push(point);else remaining.push(point);
                });
                if (series) {
                    toAdd.sort(function (a, b) {
                        return a[0] - b[0];
                    }).forEach(function (point) {
                        return series.addPoint(point);
                    });
                }
                return remaining;
            };

            _this2.lastAnalogSourceLive.rawPoints = flushSourcePoints(_this2.lastAnalogSourceLive.rawPoints, _this2.chart.get('0').series[0]);
            _this2.lastAnalogSourceLive.scaledPoints = flushSourcePoints(_this2.lastAnalogSourceLive.scaledPoints, _this2.chart.get('2').series[0]);

            var destSeries = _this2.chart.get('1').series[0];
            var outputVal = parseFloat(data.Value);
            outputVal = 4 + 16 * ($scope.stickyProperties.deviceId === 105 ? outputVal * (2 / 3) : outputVal) / 256; // TODO: scope.stickyProperties.analogIntertieId
            if (destSeries) destSeries.addPoint([unixtime, outputVal]);

            var destSeriesScaled = _this2.chart.get('3').series[0];
            var outputScaled = parseFloat(data.RepID);
            if (destSeriesScaled) destSeriesScaled.addPoint([unixtime, outputScaled]);

            if (extremes.max + _this2.liveDataOffset > extremes.dataMax && data.CH === 1) {
                _this2.chart.xAxis[0].setExtremes(unixtime - tmpRange + _this2.minPadding, unixtime + _this2.maxPadding);
            }
            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            _this2.lastUpdateAt = varTime;
            // Clear the analog input lists after processing the AnalogOutput message.
            _this2.lastAnalogSourceLive = {};
        }
    };
    var wsDataReceivedANALOGRequest = function wsDataReceivedANALOGRequest(data) {
        if (_this2.liveData === false) {
            unregisterListener();
            return;
        }

        var str = '' + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2), 10) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2));
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, _this2.accountInfo.timeZone);

        if (data.Type === 'ANALOG_G2' || data.Type === 'ANALOGRAW') {
            var value = parseFloat(data.Value);
            // Accumulate the source data points but don't add them to the chart yet.
            // They will be plotted only when the matching AnalogOutput message arrives,
            // and only the ones whose timestamp is <= the output timestamp.
            // ANALOG_G2 and ANALOGRAW are separate attributes:
            //   ANALOG_G2  -> already scaled analog value (used as-is)
            //   ANALOGRAW  -> raw value (scaling formula applied)
            if (!_this2.lastAnalogSourceLive) _this2.lastAnalogSourceLive = {};
            if (!_this2.lastAnalogSourceLive.scaledPoints) _this2.lastAnalogSourceLive.scaledPoints = [];
            if (!_this2.lastAnalogSourceLive.rawPoints) _this2.lastAnalogSourceLive.rawPoints = [];

            _this2.lastAnalogSourceLive.rawTime = data.Time;
            _this2.lastAnalogSourceLive.CH = data.CH;

            if (data.Type === 'ANALOG_G2') {
                _this2.lastAnalogSourceLive.scaledPoints.push([unixtime, value]);
            } else {
                //const scaledVal = 20 * ((value / 256) * (1023 - 204.5) + 204.5) / 1024;
                var rawVal = value;
                _this2.lastAnalogSourceLive.rawPoints.push([unixtime, rawVal]);
            }
        } else {
            var _rawVal = parseFloat(data.RawValue);
            _rawVal = 20 * (_rawVal / 256 * (1023 - 204.5) + 204.5) / 1024;
            _this2.lastAnalogSourceLive.rawPoints.push([unixtime, _rawVal]);

            var scaledVal = parseFloat(data.Value);
            _this2.lastAnalogSourceLive.rawPoints.push([unixtime, scaledVal]);
        }
    };
    var wsReconnectANALOGOUT = function wsReconnectANALOGOUT(data) {
        if (_this2.liveData === false) {
            unregisterListener();
            return;
        }
        if (data.Channel !== 1) {
            return;
        }
        toaster.pop('success', scope.windowTitle + ' -- ' + scope.devicename, 'View reloading');
        var tmpStartDate = null;
        var tmpEndDate = null;
        $scope.stickyProperties.on = true;
        tmpStartDate = $scope.stickyProperties.dateMin;
        tmpEndDate = $scope.stickyProperties.dateMax;
        _getData(tmpStartDate, tmpEndDate);
    };

    var tlDataReceivedANALOGOUT = function tlDataReceivedANALOGOUT(data) {
        data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, _this2.accountInfo.timeZone);
        if (_this2.liveData === false) {
            unregisterListener();
            return;
        }

        var extremes = _this2.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - _this2.unixDay / 2) {
            unregisterListener();
            return;
        }

        var liveDataLine = _this2.chart.xAxis[0].plotLinesAndBands;
        liveDataLine[0].options.value = data.Unix + _this2.maxPadding;

        if (extremes.max + _this2.liveDataOffset > extremes.dataMax) {
            _this2.chart.xAxis[0].setExtremes(data.Unix - tmpRange + _this2.minPadding, data.Unix + _this2.maxPadding);
        }
    };
    var registerListener = function registerListener() {
        websocketService.connect();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: true, windowId: _this2.windowId });

        // websocketService.register('ANALOGOUTPUTSOURCE', this.details.destinationSerialNumber, this.details.destinationOutputChannel, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);
        websocketService.register("ANALOG", _this2.details.sourceSerialNumber, _this2.details.sourceAnalogChannel, wsDataReceivedANALOGRequest, null);
        websocketService.register("ANALOG_G2", _this2.details.sourceSerialNumber, _this2.details.sourceAnalogChannel, wsDataReceivedANALOGRequest, null);
        websocketService.register("ANALOGRAW", _this2.details.sourceSerialNumber, _this2.details.sourceAnalogChannel, wsDataReceivedANALOGRequest, null);
        websocketService.register('ANALOGOUT', _this2.details.destinationSerialNumber, _this2.details.destinationOutputChannel, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);
        timeLapseService.register('ANALOGOUT', _this2.details.destinationSerialNumber, _this2.details.destinationOutputChannel, tlDataReceivedANALOGOUT);

        _this2.liveData = true;
    };

    var unregisterListener = function unregisterListener(deviceSn) {
        if (!angular.isDefined(_this2.details)) return;
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: _this2.windowId });
        //websocketService.unRegister('ANALOGOUTPUTSOURCE', this.details.destinationSerialNumber, this.details.destinationOutputChannel, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);
        websocketService.unRegister("ANALOG", _this2.details.sourceSerialNumber, _this2.details.sourceAnalogChannel, wsDataReceivedANALOGRequest, null);
        websocketService.unRegister("ANALOG_G2", _this2.details.sourceSerialNumber, _this2.details.sourceAnalogChannel, wsDataReceivedANALOGRequest, null);
        websocketService.unRegister("ANALOGRAW", _this2.details.sourceSerialNumber, _this2.details.sourceAnalogChannel, wsDataReceivedANALOGRequest, null);
        websocketService.unRegister('ANALOGOUT', _this2.details.destinationSerialNumber, _this2.details.destinationOutputChannel, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);
        timeLapseService.unRegister('ANALOGOUT', _this2.details.destinationSerialNumber, _this2.details.destinationOutputChannel, tlDataReceivedANALOGOUT);

        _this2.liveData = false;
        _this2.lastUpdateAt = undefined;
    };

    var setLiveDataStatus = function setLiveDataStatus(varEndDate) {
        _this2.liveDataEndDate = varEndDate || _this2.liveDataEndDate;

        timeLapseService.getLocalDateTime().then(function (resp) {
            var result = resp.data;
            $scope.heartbeatLocalDateTime = resp.data.unixTimeStamp;
            var extremes = _this2.chart.xAxis[0].getExtremes();
            if (_this2.liveDataEndDate > result.unixTimeStamp && $scope.stickyProperties.zoomMax + _this2.liveDataOffset >= extremes.dataMax) {
                registerListener();
                var data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedANALOGOUT(data);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: _this2.windowId });
                unregisterListener();
            }
        });
    };

    var _drawChart = function _drawChart(resetView) {
        _this2.chartDrawn = false;
        var chartBase = $('#analog-interconnect-chart-' + _this2.replaceSpaces(_this2.windowId));
        var tmpData = _this2.series;
        var chartXaxisHourFormat = _this2.preferredTimeFormat === _this2.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
        var chartToolTipHourFormat = _this2.preferredTimeFormat === _this2.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';
        var midPadding = 0;
        var maxPadding = 0;
        var self = _this2;

        var numberOfSeries = 0;
        var numberOfHiddenSeries = 0;
        var _tmpTimer = void 0;

        self.chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: true,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1
            },
            time: {
                getTimezoneOffset: function getTimezoneOffset(timestamp) {
                    return -moment.tz(timestamp, datetimeService.getTimeZoneId(self.accountInfo.timeZone)).utcOffset();
                }
            },
            chart: {
                renderTo: chartBase[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#d3d3d3',
                borderWidth: 1,
                borderRadius: 2,
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                marginRight: 10,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                spacingRight: 5,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {
                        var analogInterconnectData = [];
                        var extremes = this.xAxis[0].getExtremes();

                        var tmpDates = null;
                        var i = -1;

                        if (this.xAxis && self.chartDrawn === true && self.scrollingInProgress === false) {
                            if (extremes && extremes.dataMin >= extremes.min - self.liveDataOffset) {
                                self.scrollingInProgress = true;

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -11);

                                self.analogInterconnect.fetchData(tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            analogInterconnectData.push(resp.data.series[i].data);
                                        }
                                    }

                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            var combinedData = analogInterconnectData[i].concat(tmpData[i].data);
                                            combinedData.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            tmpData[i].data = combinedData;
                                            //tmpData[i].data = analogInterconnectData[i].concat(tmpData[i].data);
                                            self.chart.series[i].setData(tmpData[i].data);
                                        }
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, windowId: self.windowId });
                                    self.chart.xAxis[0].setExtremes(extremes.min + self.minPadding, extremes.max + self.maxPadding);
                                    setLiveDataStatus();

                                    $timeout(function () {
                                        self.scrollingInProgress = false;
                                    }, 1000);

                                    self.chart.hideLoading();
                                }, function (resp) {
                                    $scope.alerts = [];
                                    self.alerts = [];
                                    chartBase.empty();
                                    var errormsg = self.translation.message.GENERAL_SERVER_ERROR;
                                    $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                    self.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                });
                            } else if (self.liveData === false && extremes && extremes.max + self.liveDataOffset >= extremes.dataMax) {
                                self.scrollingInProgress = true;

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 11);

                                if (self.selectedGrouping === '4') {
                                    tmpDates.endDate += self.unixDay;
                                }

                                self.analogInterconnect.fetchData(tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            analogInterconnectData.push(resp.data.series[i].data);
                                        }
                                    }

                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            var combinedData = tmpData[i].data.concat(analogInterconnectData[i]);
                                            combinedData.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            tmpData[i].data = combinedData;
                                            //tmpData[i].data = tmpData[i].data.concat(analogInterconnectData[i]);
                                            self.chart.series[i].setData(tmpData[i].data);
                                        }
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: tmpDates.endDate, windowId: self.windowId });
                                    self.chart.xAxis[0].setExtremes(extremes.min + self.minPadding, extremes.max + self.maxPadding);
                                    setLiveDataStatus(tmpDates.endDate);

                                    $timeout(function () {
                                        self.scrollingInProgress = false;
                                    }, 1000);

                                    self.chart.hideLoading();
                                }, function (resp) {
                                    $scope.alerts = [];
                                    self.alerts = [];
                                    chartBase.empty();
                                    var errormsg = self.translation.message.GENERAL_SERVER_ERROR;
                                    $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                    self.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                });
                            }
                        }
                    },
                    load: function load(event) {
                        if (self.initialLoad) openViewService.adjustContentSize(self._popup);
                        self.initialLoad = false;
                    },
                    selection: function selection(event) {
                        if (!event.xAxis) {
                            var button = this.exportSVGElements[0];
                            var button2 = this.exportSVGElements[2];
                            button.attr({
                                x: -5
                            });
                            button2.attr({
                                x: -100
                            });
                            adjustScale(this);
                        }
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                }
            },
            xAxis: {
                title: {
                    text: self.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 3,
                    color: 'green',
                    dashStyle: 'solid',
                    zIndex: 1
                }],
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minorTickInterval: 'auto',
                minorGridLineColor: '#ebebeb',
                dateTimeLabelFormats: {
                    hour: chartXaxisHourFormat
                },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (self.chartDrawn === true) {
                            if (e.trigger === 'rangeSelectorButton') {

                                var newRanges = rangeSelectorService.getrangeExtremes(e.dataMax, e.dataMin, e.rangeSelectorButton, $scope.dataGroupingInterval);

                                sharedSetupService.setStickyProperties($scope.stickyProperties, {
                                    zoomMin: newRanges.newMin,
                                    zoomMax: newRanges.newMax,
                                    windowId: scope.windowId
                                });
                                $scope.stickyProperties.on = true;
                                //Reload
                                if (newRanges.newDataMax < event.dataMin || newRanges.newDataMax > event.dataMax) _getData($scope.stickyProperties.deviceId, newRanges.newDataMin, newRanges.newDataMax);
                            } else {
                                var _extremes = self.chart.xAxis[0].getExtremes();
                                if (self.liveData === true && (e.trigger === 'navigator' || e.trigger === 'pan' || typeof e.trigger === 'undefined')) {
                                    if (_extremes.max + self.liveDataOffset <= _extremes.dataMax) {
                                        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: self.windowId });
                                        unregisterListener();
                                    }
                                }
                                sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: _extremes.min, zoomMax: _extremes.max, windowId: self.windowId });
                            }
                        }
                    }
                }
            },
            yAxis: self.yAxis,
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var s = '';
                    s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, self.accountInfo.timeZone)) + '</td></tr>';
                    $.each(this.points, function (i, point) {
                        var decimals = 0;

                        if (point.series.color === '#2288cc') {
                            if (point.y > 1000) {
                                decimals = 0;
                            } else {
                                if (point.y > 10) {
                                    decimals = 1;
                                } else {
                                    decimals = 2;
                                }
                            }
                        }

                        s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + $filter('number')(parseFloat(point.y).toFixed(2), 2) + '</td></tr>';
                        self.xValue = point.x;
                    });
                    s += '</table>';
                    return s;
                },

                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 0,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
            },
            plotOptions: {
                series: {
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                self.xValue = this.x;
                            }
                        }
                    },
                    borderColor: '#303030',
                    borderWidth: 1,
                    marker: {
                        enabled: null, // If null, the markers are hidden when the data is dense, and shown for more widespread data points.
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    pointWidth: 12,
                    events: {
                        legendItemClick: function legendItemClick() {
                            numberOfSeries = self.chart.series.length - 1;
                            var visibility = this.visible ? 'visible' : 'hidden';
                            numberOfHiddenSeries = visibility === 'hidden' ? numberOfHiddenSeries - 1 : numberOfHiddenSeries + 1;
                            numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                            if (numberOfHiddenSeries < numberOfSeries) {
                                self.chart.yAxis[this.index].update({
                                    labels: {
                                        enabled: visibility !== 'visible'
                                    },
                                    title: {
                                        text: visibility === 'visible' ? null : self.series[this.index].name
                                    },
                                    lineWidth: visibility === 'visible' ? 0 : 2
                                });
                                return true;
                            }
                            numberOfHiddenSeries = numberOfHiddenSeries - 1;
                            return false;
                        },
                        mouseOut: function mouseOut() {
                            self.xValue = null;
                        }
                    }
                }
            },
            series: self.series
        });

        var tmpNewDateA = void 0;
        var tmpNewDateB = void 0;
        var extremes = self.chart.xAxis[0].getExtremes();

        if ($scope.stickyProperties.on === true) {
            tmpNewDateA = $scope.stickyProperties.zoomMin >= extremes.dataMin ? $scope.stickyProperties.zoomMin : extremes.dataMin;
            tmpNewDateB = $scope.stickyProperties.zoomMax <= extremes.dataMax + _this2.liveDataOffset ? $scope.stickyProperties.zoomMax : extremes.dataMax;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + _this2.unixDay / 24 ? tmpNewDateB : extremes.dataMax - _this2.unixDay / 24 * 12;
            // $scope.stickyProperties.on = false;
        } else {
            tmpNewDateA = _this2.myDate !== null ? extremes.dataMin + _this2.unixDay : extremes.dataMax - _this2.unixDay / 24 * 6;
            tmpNewDateB = _this2.myDate !== null ? tmpNewDateA + _this2.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - _this2.unixDay;
            }
            tmpNewDateA = tmpNewDateA + _this2.minPadding;
            tmpNewDateB = tmpNewDateB + _this2.maxPadding;
        }

        _this2.chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        if (_this2.series !== null) {
            // only for analog chart if no setup
            sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: _this2.windowId });
        } else {
            // this.chart.showLoading('Pulse Flow Setup not available!');
        }

        if (!resetView) {
            setLiveDataStatus();
        } else {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var data = { Unix: resp.data.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedVOLCALC(data);
            });
        }

        self.chartDrawn = true;
    };

    var _getData = function _getData(startDate, endDate, resetView) {
        _this2.liveDataEndDate = endDate;
        _this2.analogInterconnect.fetchData(startDate, endDate).then(function (resp) {
            var chartBase = $('#analog-interconnect-chart-' + _this2.replaceSpaces(_this2.windowId));
            _this2.setting = resp.data.setting;
            _this2.seriesNames = [resp.data.series[0].name, resp.data.series[1].name, resp.data.series[2].name, resp.data.series[3].name];
            _this2.yAxis = resp.data.yAxis;
            _this2.series = resp.data.series;
            _this2.yAxis[0].title.text = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[0];
            _this2.yAxis[1].title.text = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[1];
            _this2.yAxis[2].title.text = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[2];
            _this2.yAxis[3].title.text = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[3];
            _this2.series[0].name = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[0];
            _this2.series[1].name = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[1];
            _this2.series[2].name = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[2];
            _this2.series[3].name = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[3];

            $scope.alerts = [];
            _this2.alerts = [];

            if (resp.data.series && resp.data.series.length > 0 && resp.data.series[0].data.length >= 1) {
                registerListener();
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate, windowId: _this2.windowId });
                _drawChart(resetView);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate, windowId: _this2.windowId });
                chartBase.empty();
                var errormsg = _this2.translation.message.NO_DATA;
                $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
                _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
            }
        }, function (resp) {
            $scope.alerts = [];
            _this2.alerts = [];
            chartBase.empty();
            var errormsg = _this2.translation.message.GENERAL_SERVER_ERROR;
            $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
            _this2.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
        });
    };

    this.$onInit = function () {
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        $scope.qdpLeft = -237;

        _this2.chart = null;
        _this2.myDate = null;
        _this2.scrollingInProgress = false;
        _this2.initialLoad = true;
        _this2.zoomLevelCurrent = 0;
        _this2.zoomLevelPrevious = 0;
        _this2.xValue = null;
        _this2.liveData = false;
        _this2.selectedDeviceSN = null;
        _this2.chartDrawn = false;
        _this2.minPadding = 0;
        _this2.maxPadding = 0;
        _this2.selectedGrouping = '1';
        _this2.afterSetExtremesTimer = null;
        _this2.windowId = _this2.windowId || 'Analog Interconnect Chart';
        $scope.windowId = _this2.windowId;
        _this2.lastAnalogSourceLive = {};
        _this2.alerts = [];
        $scope.alerts = [];
        _this2.series = [];
        _this2.rawSeries = [];
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        $scope.windowTitle = _this2.translation.text.ANALOG_INTERCONNECT_CHART;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.TimeFormatEnum = { Civilian: 1, Military: 2 };
        _this2.measurement = _this2.accountInfo.preferenceUser.lookupMeasurementID;
        _this2.preferredTimeFormat = _this2.accountInfo.preferenceUser.timeFormat;
        _this2.unixDay = sharedSetupService.unixDay;
        _this2.unixHour = 3600000;
        _this2.liveDataOffset = 20 * 60 * 1000;
        _this2.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        _this2.downloadViewTypeOptions = [1];

        if (!$scope.stickyProperties.deviceId) {
            $location.path('/interconnect/analoginterconnectlist/analog-interconnect-list');
            return;
        }

        _this2.analogInterconnect = new AnalogInterconnectChart(_this2.accountInfo.customerId, $scope.stickyProperties.deviceId);

        _this2.analogInterconnect.fetchDetails().then(function (resp) {
            _this2.details = resp.data;

            if (!_this2.mobile && !_this2.classicView) {
                _this2._popup = _this.getExistingDialog(_this2.windowId).ref;

                _this2.windowTitle = _this2.translation.text.ANALOG_INTERCONNECT_OPERATION + ', ' + _this2.details.sourceDeviceName + ',\n                           ' + getInputName(_this2.details) + ' to\n                           ' + _this2.details.destinationDeviceName + ', ' + getOutputName(_this2.details);

                _this2._popup.dialog('option', 'title', _this2.windowTitle);
            }
        });

        var tmpDates = null;
        var tmpStartDate = null;
        var tmpEndDate = null;

        if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
            $scope.stickyProperties.on = true;
            tmpStartDate = $scope.stickyProperties.dateMin;
            tmpEndDate = $scope.stickyProperties.dateMax;
        } else {
            $scope.stickyProperties.on = false;
        }

        if (!tmpStartDate) {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                // tmpDates = new Date(result.localDateTime);
                // tmpDates.setHours(0, 0, 0, 0);
                // tmpDates = datetimeService.dateToUnixtime(tmpDates);
                // tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                // tmpStartDate = tmpDates.startDate;
                // tmpEndDate = tmpDates.endDate;

                var startDate = new Date(result.localDateTime);
                var endDate = new Date(startDate.getTime() + 0.15 * 86400000);
                startDate = new Date(startDate.getTime() - 0.15 * 86400000);
                startDate = datetimeService.dateToUnixtime(startDate);
                endDate = datetimeService.dateToUnixtime(endDate);

                _getData(startDate, endDate);
            });
        } else {
            _getData(tmpStartDate, tmpEndDate);
        }

        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        if (!_this2.mobile && !_this2.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
        }

        $timeout(function () {
            var chartBase = $('#analog-interconnect-chart-' + _this2.replaceSpaces(_this2.windowId));
            chartBase.on('mousewheel', function (event) {
                if (!_this2.scrollingInProgress) {
                    _this2.mouseWheelZoom(event, _this2.chart, _this2.xValue);
                }
            });
        });

        $scope.$on('updatePreferencesLanguage', function (event, language) {
            openViewService.adjustContentSize(_this2._popup);
            if ($scope.alerts.length > 0) {
                var _msg = _this2.translation.text[$scope.alerts[0].languageCode.toUpperCase()];
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                $scope.alerts = [];
                _this2.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
                _this2.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            } else {
                _this2.yAxis[0].title.text = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[0];
                _this2.yAxis[1].title.text = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[1];
                _this2.yAxis[2].title.text = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[2];
                _this2.yAxis[3].title.text = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[3];
                _this2.series[0].name = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[0];
                _this2.series[1].name = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[1];
                _this2.series[2].name = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[2];
                _this2.series[3].name = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[3];

                _drawChart();
            }

            _this2.windowTitle = _this2.translation.text.ANALOG_INTERCONNECT_OPERATION + ', ' + _this2.details.sourceDeviceName + ',\n                           ' + getInputName(_this2.details) + ' to\n                           ' + _this2.details.destinationDeviceName + ', ' + getOutputName(_this2.details);

            _this2._popup.dialog('option', 'title', _this2.windowTitle);
        });

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            _this2.preferredTimeFormat = parseInt(timeFormat, 10);
            _drawChart();
        });

        _this2.zoomAdjust = function (varDay) {
            var extremeMinMax = rangeSelectorService.getChartExtremes(this.chart.xAxis[1].dataMax, this.chart.xAxis[1].dataMin, varDay, $scope.heartbeatLocalDateTime);
            this.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
            setLiveDataStatus();
        };

        $scope.mostRecentData = function () {
            _this2.myDate = null;
            _selectDate(new Date());
            toaster.pop('success', 'Analog Interconnect Chart', 'View reloading');
        };

        var _selectDate = function _selectDate(newVal) {
            var chartBase = $('#analog-interconnect-chart-' + _this2.replaceSpaces(_this2.windowId));
            var tmpDates = newVal;
            tmpDates.setHours(0, 0, 0, 0);
            _this2.myDate = tmpDates;
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);

            _this2.analogInterconnect.fetchData(tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                _this2.series = resp.data.series;
                _this2.yAxis[0].title.text = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[0];
                _this2.yAxis[1].title.text = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[1];
                _this2.yAxis[2].title.text = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[2];
                _this2.yAxis[3].title.text = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[3];
                _this2.series[0].name = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[0];
                _this2.series[1].name = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[1];
                _this2.series[2].name = _this2.translation.text.SOURCE + ': ' + _this2.seriesNames[2];
                _this2.series[3].name = _this2.translation.text.OUTPUT + ': ' + _this2.seriesNames[3];

                $scope.alerts = [];
                _this2.alerts = [];
                if (resp.data.series && resp.data.series.length > 0 && resp.data.series[0].data.length >= 1) {
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, windowId: _this2.windowId });
                    _drawChart();
                } else {
                    var errormsg = _this2.translation.message.NO_DATA;
                    console.log(errormsg);
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, windowId: _this2.windowId });
                    chartBase.empty();
                    $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
                    _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
                }
            }, function (resp) {
                var errormsg = _this2.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts = [];
                _this2.alerts = [];
                chartBase.empty();
                $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                _this2.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
            });
        };

        $scope.$watch(function () {
            return _this2.myDate;
        }, function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                _selectDate(newVal);
            }
        });
    };

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    this.$onDestroy = function () {
        unregisterListener();
    };

    $scope.$on('analog_intertie_deleted', function (e, repId) {
        var analogIntertieId = $scope.stickyProperties.deviceId;
        if (repId == analogIntertieId) {
            _this2._popup.dialog("close");
        }
    });
}

AnalogInterconnectChartController.$inject = ['_', '$', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'timeLapseService', 'websocketService', 'openViewService', 'sharedSetupService', 'analogInterconnectChartModel', '$location', 'toaster', 'rangeSelectorService'];

angular.module('mc.interconnect').component('analogInterconnectChart', {
    controller: AnalogInterconnectChartController,
    transclude: true,
    templateUrl: 'ui/interconnect/analog/chart/analog-interconnect-chart-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        myDate: '<'
    }
});
"use strict";

angular.module("mc.download-icon", []);
'use strict';

function DownloadIconController($scope, authenticationService, translationService, sharedSetupService, openViewService) {
    var _this2 = this;

    var ctrl = this;
    this.popupOffset = 0;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.openDownload = function () {
        console.log(ctrl.stickyProperties);
        console.log(ctrl.windowId);

        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        var startDate;
        var endDate;
        optionsStickyProperties.downloadOptions.resolution = ctrl.options.resolution;

        if (ctrl.windowId.indexOf("Chart") !== -1) {
            //Chart
            if (ctrl.stickyProperties.zoomMin !== undefined && ctrl.stickyProperties.zoomMin !== null) {
                startDate = moment(ctrl.stickyProperties.zoomMin).utc().toDate().toDateString();
                if (startDate !== 'Invalid Date') {
                    optionsStickyProperties.downloadOptions.startDate = new Date(startDate);
                }
            }
            if (ctrl.stickyProperties.zoomMax !== undefined && ctrl.stickyProperties.zoomMax !== null) {
                endDate = moment(ctrl.stickyProperties.zoomMax).utc().toDate().toDateString();

                if (endDate !== 'Invalid Date') {
                    optionsStickyProperties.downloadOptions.endDate = new Date(endDate);
                }
            }
        } else if (ctrl.windowId.indexOf("Calendar") !== -1) {
            if (ctrl.stickyProperties.dateMin !== undefined && ctrl.stickyProperties.dateMin !== null) {
                startDate = moment(ctrl.stickyProperties.dateMin).utc().toDate().toDateString();
                var startDatedt = new Date(startDate);
                var y = startDatedt.getFullYear();
                var m = startDatedt.getMonth();
                var firstDay = new Date(y, m, 1);
                var lastDay = new Date(y, m + 1, 0);
                optionsStickyProperties.downloadOptions.startDate = new Date(firstDay);
                optionsStickyProperties.downloadOptions.endDate = new Date(lastDay);
            }
        } else {
            if (ctrl.stickyProperties.dateMin !== undefined && ctrl.stickyProperties.dateMin !== null) {
                startDate = moment(ctrl.stickyProperties.dateMin).utc().toDate().toDateString();
                if (startDate !== 'Invalid Date') {
                    optionsStickyProperties.downloadOptions.startDate = new Date(startDate);
                }
            }
            if (ctrl.stickyProperties.dateMax !== undefined && ctrl.stickyProperties.dateMax !== null) {
                endDate = moment(ctrl.stickyProperties.dateMax).utc().toDate().toDateString();

                if (endDate !== 'Invalid Date') {
                    optionsStickyProperties.downloadOptions.endDate = new Date(endDate);
                }
            }
        }

        switch (ctrl.windowId) {
            case 'Rainfall Table':
            case 'Rainfall Chart':
            case 'Rainfall Calendar':
                optionsStickyProperties.downloadOptions.reportType = 'Airport Rainfall';
                break;

        }

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/detail/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };

            newPopupPosition.at = 'left+' + (popup.offset().left + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 10;
            openViewService.openView('Download', { width: 400, height: 200 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 200, minimumHeight: 100 });
        }
    };
}

DownloadIconController.$inject = ['$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService'];
'use strict';

angular.module('mc.download-icon').component('downloadIcon', {
    controller: DownloadIconController,
    //controllerAs: 'reportdateInputCtrl',
    templateUrl: 'ui/download/components/downloadIcon/download-icon-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        metarStationId: '<',
        options: '<'
    }
});
"use strict";

angular.module("mc.resolution-select", []);
'use strict';

function ResolutionSelectController(authenticationService, translationService, $scope) {
    var ctrl = this;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;

        initializeList();
    };

    var initializeList = function initializeList() {
        ctrl.resolutions = [{
            label: ctrl.translation.text.INDIVIDUAL_POINTS,
            value: 0,
            show: ctrl.datapoint ? true : false
        }, {
            label: 5 + ' ' + ctrl.translation.text.MINUTE,
            value: 1,
            show: ctrl.minute5 ? true : false
        }, {
            label: 15 + ' ' + ctrl.translation.text.MINUTE,
            value: 2,
            show: ctrl.minute15 ? true : false
        }, {
            label: 30 + ' ' + ctrl.translation.text.MINUTE,
            value: 3,
            show: ctrl.minute30 ? true : false
        }, {
            label: ctrl.translation.text.HOURLY,
            value: 4,
            show: ctrl.hourly ? true : false
        }, {
            label: ctrl.translation.text.DAILY,
            value: 5,
            show: ctrl.daily ? true : false
        }];
    };
    $scope.$on('updatePreferencesLanguage', function (event, args) {
        initializeList();
    });
}

ResolutionSelectController.$inject = ['authenticationService', 'translationService', '$scope'];
'use strict';

angular.module('mc.resolution-select').component('resolutionSelect', {
    controller: ResolutionSelectController,
    templateUrl: 'ui/download/components/resolutionSelect/resolution-select-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        datapoint: '<',
        minute15: '<',
        minute30: '<',
        hourly: '<',
        daily: '<',
        selectedresolution: '='
    }
});
"use strict";

angular.module("mc.resolution-radiobutton", []);
'use strict';

function ResolutionRadiobuttonController(authenticationService, translationService) {
    var ctrl = this;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.resolutions = [{
        label: ctrl.translation.text.INDIVIDUAL_POINTS,
        value: 0,
        show: ctrl.datapoint ? true : false
    }, {
        label: 5 + ' ' + ctrl.translation.text.MINUTE,
        value: 1,
        show: ctrl.minute5 ? true : false
    }, {
        label: 15 + ' ' + ctrl.translation.text.MINUTE,
        value: 2,
        show: ctrl.minute15 ? true : false
    }, {
        label: 30 + ' ' + ctrl.translation.text.MINUTE,
        value: 3,
        show: ctrl.minute30 ? true : false
    }, {
        label: ctrl.translation.text.HOURLY,
        value: 4,
        show: ctrl.hourly ? true : false
    }, {
        label: ctrl.translation.text.DAILY,
        value: 5,
        show: ctrl.daily ? true : false
    }];
}

ResolutionRadiobuttonController.$inject = ['authenticationService', 'translationService'];
'use strict';

angular.module('mc.resolution-radiobutton').component('resolutionRadiobutton', {
    controller: ResolutionRadiobuttonController,
    templateUrl: 'ui/download/components/resolutionRadiobutton/resolution-radiobutton-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        datapoint: '<',
        minute15: '<',
        minute30: '<',
        hourly: '<',
        daily: '<',
        selectedresolution: '='
    }
});
"use strict";

angular.module("mc.report-year-input", []);
'use strict';

function ReportYearInputController($scope, authenticationService, translationService, detectBrowserService) {
    var ctrl = this;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;

        ctrl.years = [];
        for (var i = moment().year() - 1; i >= 2000; i--) {
            // starting from last year (skipping current year from the list)
            ctrl.years.push({ value: i });
        }

        if (ctrl.years.length > 0) {
            ctrl.selectedYear = ctrl.years[0].value; //default year
        }
    };
}

ReportYearInputController.$inject = ['$scope', 'authenticationService', 'translationService', 'detectBrowserService'];
'use strict';

angular.module('mc.report-year-input').component('reportYearInput', {
    controller: ReportYearInputController,
    templateUrl: 'ui/download/components/reportyearinput/report-year-input-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        selectedYear: '='
    }
});
"use strict";

angular.module("mc.reportmonth-select", []);
'use strict';

function ReportmonthSelectController($scope, authenticationService, translationService, detectBrowserService) {
    var ctrl = this;

    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.months = [];
    ctrl.months.push({ value: 1, text: ctrl.translation.text.JANUARY });
    ctrl.months.push({ value: 2, text: ctrl.translation.text.FEBRUARY });
    ctrl.months.push({ value: 3, text: ctrl.translation.text.MARCH });
    ctrl.months.push({ value: 4, text: ctrl.translation.text.APRIL });
    ctrl.months.push({ value: 5, text: ctrl.translation.text.MAY });
    ctrl.months.push({ value: 6, text: ctrl.translation.text.JUNE });
    ctrl.months.push({ value: 7, text: ctrl.translation.text.JULY });
    ctrl.months.push({ value: 8, text: ctrl.translation.text.AUGUST });
    ctrl.months.push({ value: 9, text: ctrl.translation.text.SEPTEMBER });
    ctrl.months.push({ value: 10, text: ctrl.translation.text.OCTOBER });
    ctrl.months.push({ value: 11, text: ctrl.translation.text.NOVEMBER });
    ctrl.months.push({ value: 12, text: ctrl.translation.text.DECEMBER });

    ctrl.years = [];
    for (var i = moment().year(); i >= 2000; i--) {
        ctrl.years.push({ value: i });
    }
}

ReportmonthSelectController.$inject = ['$scope', 'authenticationService', 'translationService', 'detectBrowserService'];
'use strict';

angular.module('mc.reportmonth-select').component('reportmonthSelect', {
    controller: ReportmonthSelectController,
    templateUrl: 'ui/download/components/reportmonthSelect/reportmonth-select-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        selectedmonth: '=',
        selectedyear: '='
    }
});
"use strict";

angular.module("mc.reportdate-input", []);
"use strict";

function ReportdateInputController($scope, authenticationService, translationService, detectBrowserService) {
    var ctrl = this;

    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.curentBrowser = detectBrowserService();
    ctrl.fnBrowser = function () {
        return ctrl.curentBrowser === "chrome" || ctrl.curentBrowser === "firefox";
    };

    ctrl.datefilter = function (d) {
        var today = new Date();
        switch (ctrl.filter) {
            case undefined:

                return d.getTime() < today.getTime();
                break;
            case 'disableCurrentWeek':
                var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000),
                    day = beforeOneWeek.getDay(),
                    diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1),
                    lastMonday = new Date(beforeOneWeek.setDate(diffToMonday)),
                    lastSat = new Date(beforeOneWeek.setDate(diffToMonday + 5));
                return d.getTime() < lastSat.getTime();
                break;
            case 'disableCurrentDate':

                var yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);
                return d.getTime() < yesterday.getTime();
                break;
        }
    };
}

ReportdateInputController.$inject = ['$scope', 'authenticationService', 'translationService', 'detectBrowserService'];
'use strict';

angular.module('mc.reportdate-input').component('reportdateInput', {
    controller: ReportdateInputController,
    //controllerAs: 'reportdateInputCtrl',
    templateUrl: 'ui/download/components/reportdateInput/reportdate-input-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        reportdate: '=',
        filter: '@'
    }
});
"use strict";

angular.module("mc.device-select", []);
'use strict';

function DeviceSelectController(authenticationService, translationService) {
    var ctrl = this;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
}

DeviceSelectController.$inject = ['authenticationService', 'translationService', 'detectBrowserService'];
'use strict';

angular.module('mc.device-select').component('deviceSelect', {
    controller: DeviceSelectController,
    templateUrl: 'ui/download/components/deviceSelect/device-select-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceList: '<',
        label: '<',
        selecteddevice: '=selecteddevice'
    }
});
"use strict";

angular.module("mc.modal-confirmation", []);
'use strict';

function ModalConfirmationController(translationService, $uibModal, $scope) {

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.openConfirmationPopUp.currentValue && changes.openConfirmationPopUp.currentValue !== changes.openConfirmationPopUp.previousValue) {
            ctrl.translation = translationService.translation;
            ctrl.openOkModal("Email Sent");
            ctrl.resetOpenConfirmationPopUpLocal();
        }
    };

    ctrl.resetOpenConfirmationPopUpLocal = function () {
        ctrl.resetOpenConfirmationPopUp({ toggle: { popUpStatus: false } });
    };

    ctrl.openOkModal = function (message) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.popoverMessage = message;

            this.ok = function () {
                $uibModalInstance.close();
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/ok-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });
    };
}

ModalConfirmationController.$inject = ['translationService', '$uibModal', '$scope'];
'use strict';

angular.module('mc.modal-confirmation').component('modalConfirmation', {
    controller: ModalConfirmationController,
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        attrValue: '<',
        fnValue: '&',
        showMsg: '<',
        msg: '<',
        isEmailCapable: '<', //determines whether email capability added to the component
        isEmailValid: '=', //this parameter specifies, whether email is valid
        email: '=', // this parameter indicates emailAddress string
        openConfirmationPopUp: '<',
        resetOpenConfirmationPopUp: '&'
    }
});
"use strict";

angular.module("mc.report-date-hour-input", []);
"use strict";

function ReportDateHourInputController($scope, authenticationService, translationService, detectBrowserService, $timeout) {
    var ctrl = this;
    var _firstRun = true;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.curentBrowser = detectBrowserService();
        ctrl.max = ctrl.dpMax;

        ctrl.getTimeFormat = function (timeFormat) {
            return timeFormat === 1 ? "h:mm a" : "H:mm";
        };
        ctrl.timeFormatTimePicker = ctrl.getTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormatTimePicker = false;
        $timeout(function () {
            ctrl.timeFormatTimePicker = ctrl.getTimeFormat(timeFormat);
        }, 1000);
    });

    ctrl.fnBrowser = function () {
        return ctrl.curentBrowser === "chrome" || ctrl.curentBrowser === "firefox";
    };

    ctrl.datefilter = function (d) {
        var today = new Date();
        switch (ctrl.filter) {
            case undefined:
            default:
                if (_firstRun) {
                    ctrl.reportdate.setHours(0, 0, 0, 0);
                    _firstRun = false;
                }
                return d.getTime() < today.getTime();
            case 'disableCurrentWeek':
                var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000),
                    day = beforeOneWeek.getDay(),
                    diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1),
                    lastMonday = new Date(beforeOneWeek.setDate(diffToMonday)),
                    lastSat = new Date(beforeOneWeek.setDate(diffToMonday + 5));
                return d.getTime() < lastSat.getTime();
            case 'disableCurrentDate':

                var yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);
                return d.getTime() < yesterday.getTime();
        }
    };
}

ReportDateHourInputController.$inject = ['$scope', 'authenticationService', 'translationService', 'detectBrowserService', '$timeout'];
'use strict';

angular.module('mc.report-date-hour-input').component('reportDateHourInput', {
    controller: ReportDateHourInputController,
    templateUrl: 'ui/download/components/reportdatehourinput/report-date-hour-input-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        reportdate: '=',
        filter: '@',
        dpMax: '<'
    }
});
"use strict";

angular.module("mc.download-button", []);
"use strict";

function DownloadButtonController($, $rootScope, $scope, $sce, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, openViewService) {
    var ctrl = this;
    ctrl.initLoad = true;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.isEmailValid = false;
    ctrl.allEmailsValid = false;
    ctrl.email = "";
    ctrl.emailArray = [];
    ctrl.validateEmail = function (index) {

        var regExpn = /^[a-zA-Z0-9.'_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;

        if (regExpn.test(ctrl.emailArray[index].address)) {
            ctrl.emailArray[index].isValid = true;
            ctrl.isEmailValid = true;
            ctrl.mapEmailArrayToString();
        } else {
            ctrl.emailArray[index].isValid = false;
            ctrl.isEmailValid = false;
        }

        ctrl.validateAllEmails();
    };

    ctrl.validateAllEmails = function () {
        var count = 0;
        ctrl.emailArray.forEach(function (email) {
            if (email.isValid == false) {
                count++;
            }
        });
        count > 0 ? ctrl.allEmailsValid = false : ctrl.allEmailsValid = true;
    };

    ctrl.onEmailCheckedChange = function () {
        if (!ctrl.isEmailChecked) {
            ctrl.email = "";
            ctrl.adjustParentHeight('-');
            ctrl.emailArray[0].isValid = false;
        } else {
            ctrl.emailArray = [];
            ctrl.emailArray.push({ address: "", isValid: false });
            ctrl.adjustParentHeight('+');
        }
    };

    ctrl.addEmailAddress = function () {
        ctrl.isEmailValid = false;
        ctrl.emailArray.push({ address: "", isValid: false });
        ctrl.adjustParentHeight('+');
        ctrl.validateAllEmails();
    };
    ctrl.removeEmailAddress = function (index) {
        ctrl.emailArray.splice(index, 1);
        ctrl.adjustParentHeight('-');
        ctrl.mapEmailArrayToString();
        if (ctrl.emailArray.length < 1) {
            ctrl.isEmailChecked = false;
        }
        ctrl.isEmailValid = true;
        ctrl.validateAllEmails();
    };
    ctrl.mapEmailArrayToString = function () {
        ctrl.email = "";
        ctrl.email = ctrl.emailArray.map(function (elem) {
            if (elem.isValid) {
                return elem.address;
            }
        }).join(",");
    };

    ctrl.adjustParentHeight = function (operator) {
        var increment = 35;
        $scope.popup = _this.getExistingDialog('Download').ref;

        var parentHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        var contentHeight = $scope.popup.parent().find(".ui-dialog-content").css("height").replace(/[^0-9.]+/g, "");
        if (operator == "+") {
            $scope.popup.parent().css("height", parseInt(parentHeight) + increment);
            $scope.popup.parent().find(".ui-dialog-content").css("height", parseInt(contentHeight) + increment);
        } else {
            $scope.popup.parent().css("height", parseInt(parentHeight) - increment);
            $scope.popup.parent().find(".ui-dialog-content").css("height", parseInt(contentHeight) - increment);
        }
    };
}

DownloadButtonController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'HOST', '$http', 'translationService', 'sharedSetupService', 'datetimeService', 'deviceService', '$timeout', '$filter', '$element', 'openViewService'];
'use strict';

angular.module('mc.download-button').component('downloadButton', {
    controller: DownloadButtonController,
    controllerAs: 'DnldBtnCtrl',
    templateUrl: 'ui/download/components/downloadbutton/download-button-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        attrValue: '<',
        fnValue: '&',
        showMsg: '<',
        msg: '<',
        isEmailCapable: '<', //determines whether email capability added to the component
        isEmailValid: '=', //this parameter specifies, whether email is valid
        email: '=' // this parameter indicates emailAddress string
    }
});
"use strict";

angular.module("mc.format-radiobutton", []);
"use strict";

function FormatRadiobuttonController(authenticationService, translationService) {
    var ctrl = this;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;

        ctrl.formats = [{
            label: "XLSX",
            value: 0,
            show: ctrl.xlsx ? true : false
        }, {
            label: "CSV",
            value: 1,
            show: ctrl.csv ? true : false
        }, {
            label: "PDF",
            value: 2,
            show: ctrl.pdf ? true : false
        }, {
            label: "PNG",
            value: 3,
            show: ctrl.png ? true : false
        }];
    };
}

FormatRadiobuttonController.$inject = ['authenticationService', 'translationService', 'detectBrowserService'];
'use strict';

angular.module('mc.format-radiobutton').component('formatRadiobutton', {
    controller: FormatRadiobuttonController,
    templateUrl: 'ui/download/components/formatRadiobutton/format-radiobutton-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceList: '<',
        xlsx: '<',
        csv: '<',
        pdf: '<',
        png: '<',
        selectedformat: '='
    }
});
//angular.module("mc.daterange-input", []);
"use strict";
"use strict";

function DaterangeStarthourInputController($scope, authenticationService, translationService, detectBrowserService, $timeout) {
    var ctrl = this;
    var _firstRun = true;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.curentBrowser = detectBrowserService();
        ctrl.startDate = ctrl.startDate > moment() ? new Date() : ctrl.startDate;
        ctrl.endDate = ctrl.endDate > moment() ? new Date() : ctrl.endDate;

        ctrl.getTimeFormat = function (timeFormat) {
            return timeFormat === 1 ? "h:mm a" : "H:mm";
        };
        ctrl.timeFormatTimePicker = ctrl.getTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormatTimePicker = false;
        $timeout(function () {
            ctrl.timeFormatTimePicker = ctrl.getTimeFormat(timeFormat);
        }, 1000);
    });

    ctrl.fnBrowser = function () {
        return ctrl.curentBrowser === "chrome" || ctrl.curentBrowser === "firefox";
    };

    ctrl.datefilter = function (d) {
        var today = new Date();
        switch (ctrl.filter) {
            case undefined:
            default:
                if (_firstRun) {
                    ctrl.startDate.setHours(0, 0, 0, 0);
                    // if endDate is today, then set endDate hour with current hour, otherwise set endDate hour to 0
                    if (ctrl.endDate.getFullYear() === today.getFullYear() && ctrl.endDate.getMonth() === today.getMonth() && ctrl.endDate.getDate() === today.getDate()) {
                        ctrl.endDate.setHours(today.getHours(), today.getMinutes(), today.getSeconds(), today.getMilliseconds());
                    } else {
                        ctrl.endDate.setHours(0, 0, 0, 0);
                    }
                    _firstRun = false;
                }
                return d.getTime() < today.getTime();
            //case 'disableCurrentWeek':
            //    var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000),
            //        day = beforeOneWeek.getDay(),
            //        diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1),
            //        lastMonday = new Date(beforeOneWeek.setDate(diffToMonday)),
            //        lastSat = new Date(beforeOneWeek.setDate(diffToMonday + 5));
            //    return (d.getTime() < lastSat.getTime());
            //case 'disableCurrentDate':

            //    var yesterday = new Date(today);
            //    yesterday.setDate(today.getDate() - 1);
            //    return (d.getTime() < yesterday.getTime());
        }
    };

    ctrl.onClick = function (sourceField) {
        //if startDate is updated, then set endDate hour with startDate hour
        //it means, user wants to fetch 24/48/72/..... hours of report
        //if endDate is updated, then user wants to fetch date for different hourly ranges, so NO action is required
        if (sourceField === "startdate") {
            //ctrl.endDate.setHours(ctrl.startDate.getHours()); //NOTE: this statement is not updating endDate on UI, but in the code it is okay.
            var updatedDate = new Date(ctrl.endDate.getFullYear(), ctrl.endDate.getMonth(), ctrl.endDate.getDate(), ctrl.startDate.getHours(), 0, 0); // setting hours, minutes, seconds, milli seconds
            ctrl.endDate = updatedDate;
        }
    };
}

DaterangeStarthourInputController.$inject = ['$scope', 'authenticationService', 'translationService', 'detectBrowserService', '$timeout'];
"use strict";

angular.module("mc.daterange-input", []);
'use strict';

angular.module('mc.daterange-input').component('daterangeStarthourInput', {
    controller: DaterangeStarthourInputController,
    templateUrl: 'ui/download/components/daterangeStarthourInput/daterange-starthour-input-template.html',
    bindings: {
        //stickyProperties: '<',
        //windowId: '<',
        //mobile: '<',
        //windowTitle: '<',
        //classicView: '<',
        startDate: '=',
        endDate: '=',
        filter: '@'
    }
});
"use strict";

function DaterangeInputController($scope, authenticationService, translationService, detectBrowserService) {
    var ctrl = this;

    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.curentBrowser = detectBrowserService();
    ctrl.startDate = ctrl.startDate > moment() ? new Date() : ctrl.startDate;
    ctrl.endDate = ctrl.endDate > moment() ? new Date() : ctrl.endDate;
    ctrl.fnBrowser = function () {
        return ctrl.curentBrowser === "chrome" || ctrl.curentBrowser === "firefox";
    };
    //ctrl.startDateChange = function () {
    //    ctrl.endDate = ctrl.startDate;
    //};
}

DaterangeInputController.$inject = ['$scope', 'authenticationService', 'translationService', 'detectBrowserService'];
'use strict';

angular.module('mc.daterange-input').component('daterangeInput', {
    controller: DaterangeInputController,
    //controllerAs: 'reportdateInputCtrl',
    templateUrl: 'ui/download/components/daterangeInput/daterange-input-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        startDate: '=',
        endDate: '='
    }
});
'use strict';

mcapp.service('siteSecurityModalService', siteSecurityModalService);

function siteSecurityModalService($rootScope, $uibModal, translationService) {
    return {
        siteSecurity: siteSecurity
    };

    function siteSecurity(_tag, _parentScope) {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            keyboard: false,
            templateUrl: 'ui/components/scadaviews/site-security-popover.html',
            controller: siteSecurityController,
            controllerAs: '$ctrl',
            //appendTo: 'body',
            size: 'lg',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                },
                tag: function tag() {
                    return _tag;
                },
                parentScope: function parentScope() {
                    return _parentScope;
                }
            }
        });

        function siteSecurityController($scope, $uibModalInstance, $window, translation, tag, parentScope, TwoFactorAuthenticationFactory, authenticationService, QRCode, $location, $timeout, updatePasswordService, SiteSecurityPortalFactory, toaster, sharedSetupService, userloginRoutingService) {
            var _this = this;

            this.translation = translation;
            this.tag = !tag ? 'GENERIC_DELETE_MESSAGE' : tag;
            this.secretKey = "";
            this.pendingVerify = true;
            this.verifySuccess = false;
            this.verifyFailed = false;
            this.accountInfo = authenticationService.getAccountInfo();
            this.securitySetting = parentScope.securitySetting;
            this.securityUser = parentScope.securityUser;
            this.isFromUpdatePassword = parentScope.isFromUpdatePassword;
            this.mobile = parentScope.mobile;
            $scope.countdown = 10;

            this.daysBetween = function (dateString) {
                // Parse the specific date from the string (format: YYYY-MM-DD)
                var specificDate = new Date(dateString);
                // Get today's date
                var today = new Date();

                // Reset the time portion of both dates to ensure we're only comparing dates
                today.setHours(0, 0, 0, 0);
                specificDate.setHours(0, 0, 0, 0);

                // Calculate the difference in milliseconds
                var differenceInMs = today - specificDate;

                // Convert milliseconds to days
                var differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

                return differenceInDays;
            };

            $scope.startCountdown = function () {
                if ($scope.countdown > 0) {
                    $timeout(function () {
                        $scope.countdown--;
                        $scope.startCountdown(); // Call the function again
                    }, 1000);
                } else {
                    // Redirect when countdown is finished                    
                    _this.returnToLogin();
                }
            };

            this.prePopoverProcess = function () {
                //default password length is 6
                if (_this.securitySetting.minPwdLengthOfNChars == 0 || _this.securitySetting.minPwdLengthOfNChars == null) _this.securitySetting.minPwdLengthOfNChars = 6;
                //default mandatory password reset days is 30
                if (_this.securitySetting.pwdResetEveryNDays < 0 || _this.securitySetting.pwdResetEveryNDays == null) _this.securitySetting.pwdResetEveryNDays = 30;

                _this.resettingPassword = true;
                _this.passwordReset = false;
                _this.settingTwoFa = true;
                _this.TwoFaSet = false;

                //-------------------------------------------------------------------------------------------------------
                //check whether to show "Remind me later" button
                _this.showSkipWizard = false;
                _this.showSkipFor2Fa = false;
                //Check mfaMigrationExpiryDate and see if we need to display skip wizard button
                var today = new Date();
                if (today.getTime() < new Date(_this.securityUser.mfaMigrationExpiryDate).getTime() && _this.securityUser.mfaMigrationStatus < 2) {
                    _this.showSkipWizard = true;
                    _this.showSkipFor2Fa = true;
                }
                //handling scenario when admin requires password reset
                if (_this.securityUser.updatePasswordFlag == 1 && _this.securityUser.mfaMigrationStatus == 2) {
                    _this.showSkipWizard = true;
                }
                //check whether user's password is about to expire
                if (_this.securitySetting.pwdResetEveryNDays > 0 && _this.daysBetween(_this.securityUser.passwordChangedDate) > _this.securitySetting.pwdResetEveryNDays - 7 && _this.daysBetween(_this.securityUser.passwordChangedDate) <= _this.securitySetting.pwdResetEveryNDays) {
                    _this.showSkipWizard = true;
                }
                //if password reset is requested by admin, no skip button
                if (_this.securityUser.updatePasswordFlag == 2) {
                    _this.showSkipWizard = false;
                }
                //--------------------------------------------------------------------------------------------------------

                //-------------------------------------------------------------------------------------------------------------
                //check whether to display date after "remind me later" button
                _this.showRemindMeLaterDate = false;
                if (_this.securityUser.updatePasswordFlag !== 1 && _this.securityUser.updatePasswordFlag !== 2 && _this.securityUser.mfaMigrationStatus < 2) {
                    _this.showRemindMeLaterDate = true;;
                }
                //-------------------------------------------------------------------------------------------------------------

                //------------------------------------------------------------------------------------------------------------
                //check which view to show first
                _this.showResetPasswordPopover = false;
                _this.show2FaSetupPopover = false;

                if (_this.securityUser.mfaMigrationStatus == 0 || _this.securityUser.mfaMigrationStatus == 2) {
                    _this.showResetPasswordPopover = true;
                } else {
                    if (_this.securitySetting.pwdResetEveryNDays == null || _this.securitySetting.pwdResetEveryNDays < 0) {
                        _this.show2FaSetupPopover = true;
                    } else if (_this.daysBetween(_this.securityUser.passwordChangedDate) > _this.securitySetting.pwdResetEveryNDays) {
                        _this.showResetPasswordPopover = true;
                    } else if (_this.securityUser.updatePasswordFlag == 1 || _this.securityUser.updatePasswordFlag == 2) {
                        _this.showResetPasswordPopover = true;
                    } else {
                        _this.show2FaSetupPopover = true;
                    }
                }
                //------------------------------------------------------------------------------------------------------------                                                            
            };
            this.prePopoverProcess();
            this.isValid = false;
            this.password = {
                val: "",
                show: false,
                confirmPassword: { val: "", show: false }
            };

            var _twoFactorAuthenticationAppName = "123Scada";
            var _host = $location.host().toLowerCase();
            if (_host.includes("localhost") || _host.includes("dev")) _twoFactorAuthenticationAppName = "Dev.123Scada";else if (_host.includes("qa")) _twoFactorAuthenticationAppName = "Qa.123Scada";

            var _twoFactorAuthenticationFactory = new TwoFactorAuthenticationFactory(this.accountInfo.customerId);
            _twoFactorAuthenticationFactory.generateSecret().then(function (result) {
                _this.secretKey = _twoFactorAuthenticationFactory.secretKey;
                var secretQrString = 'otpauth://totp/' + _twoFactorAuthenticationAppName + ':' + _this.accountInfo.email + '?secret=' + _twoFactorAuthenticationFactory.secretKey;
                var formatKey = _twoFactorAuthenticationFactory.secretKey.match(/.{1,4}/g);
                _this.secretKeyFormatted = formatKey.join(' ');
                var qrcode = new QRCode("qrcode");

                function makeCode() {
                    if (_twoFactorAuthenticationFactory.secretKey) {
                        qrcode.makeCode(secretQrString);
                    }
                }
                makeCode();
            }, function (error) {});

            this.clearVerifyStatus = function () {
                _this.pendingVerify = true;
                _this.verifySuccess = false;
                _this.verifyFailed = false;
            };

            this.verify = function () {
                _twoFactorAuthenticationFactory.verifyCode(_this.secretKey, _this.authenticatorCode).then(function (result) {
                    if (result.data == true) {
                        _this.pendingVerify = false;
                        _this.verifySuccess = true;
                    } else {
                        _this.pendingVerify = false;
                        _this.verifyFailed = true;
                    }
                }, function (error) {});
            };

            this.ok = function () {
                if (!_this.verifySuccess) return;
                _twoFactorAuthenticationFactory.updateSecret(_this.secretKey, false).then(function (result) {
                    _this.settingTwoFa = false;
                    _this.TwoFaSet = true;

                    $scope.startCountdown();
                }, function (error) {});
            };

            this.returnToLogin = function () {
                $scope.countdown = 0;
                $uibModalInstance.close();
                authenticationService.logout().then(function (result) {
                    $location.path("/account/userlogin");
                }, function (error) {
                    $window.alert("logout error");
                    console.log(error);
                });
            };

            var reset = function reset() {
                _this.isValid = false;
                _this.password = {
                    val: _this.password.val,
                    show: _this.password.show,
                    isValid: false,
                    isValidLength: false,
                    isValidLetter: false,
                    isValidNumber: false,
                    isValidNonEmail: false,
                    isValidIdentical: false,
                    isValidUpperCase: false,
                    isValidSpecialCharacter: false,

                    confirmPassword: {
                        val: _this.password.confirmPassword.val,
                        show: _this.password.confirmPassword.show
                    }
                };
            };

            this.validate = function () {
                reset();
                //$scope.alerts = [];
                _this.errorMsg = "";
                _this.serverErrorMessage = "";
                var regExpn = void 0;

                var pwdVal = _this.password.val;
                if (!pwdVal) return;

                regExpn = /^(?=.*[A-Z]).*$/; //Validate Uppercase
                if (regExpn.test(pwdVal)) {
                    _this.password.isValidUpperCase = true;
                }

                regExpn = /\W|_/g; //Validate Special Character
                if (regExpn.test(pwdVal)) {
                    _this.password.isValidSpecialCharacter = true;
                }

                regExpn = new RegExp('^.{' + _this.securitySetting.minPwdLengthOfNChars + ',}$');
                if (regExpn.test(pwdVal)) {
                    _this.password.isValidLength = true;
                }

                regExpn = /^(?=.*[a-z]|[A-Z]).*$/; // /^[A-Za-z]+$/; //at least one letter
                if (regExpn.test(pwdVal)) {
                    _this.password.isValidLetter = true;
                }

                regExpn = /^(?=.*[0-9]).*$/; //at least one number number  
                if (regExpn.test(pwdVal)) {
                    _this.password.isValidNumber = true;
                }

                if (pwdVal === _this.password.confirmPassword.val) {
                    //validate both passwords match
                    _this.password.isValidIdentical = true;
                } else {
                    _this.errorMsg += _this.translation.text.PASSWORD_MATCH_MSG;
                }

                if (pwdVal != _this.accountInfo.email) {
                    //validate password is not same as Email
                    _this.password.isValidNonEmail = true;
                }

                //Validate overall password based on customerId
                if (_this.password.isValidUpperCase && _this.password.isValidSpecialCharacter && _this.password.isValidLength && _this.password.isValidLetter && _this.password.isValidNumber && _this.password.isValidIdentical) {
                    _this.password.isValid = true;
                    _this.isValid = true;
                } else {
                    _this.btnTitle = _this.errorMsg;
                }
            };

            this.updatePassword = function () {
                if (!_this.isValid) return;
                _this.showLoading = true;
                SiteSecurityPortalFactory.UpdateLoginsPasswordHash(_this.accountInfo.userId, _this.password.val).then(function (resp) {
                    _this.isFromUpdatePassword = false;
                    if (_this.securityUser.mfaMigrationStatus !== 2) {
                        _this.showResetPasswordPopover = false;
                        _this.show2FaSetupPopover = true;
                    } else {
                        _this.resettingPassword = false;
                        _this.passwordReset = true;

                        $scope.startCountdown();
                        //$uibModalInstance.close();
                        //$location.path("/account/userlogin");
                    }
                }, function (error) {
                    toaster.pop('error', 'Update password failed', 'For your security, please ensure that your new password is different from your previous one.');
                    _this.btnTitle = "error processing the request.";
                    _this.showLoading = false;
                });
            };

            this.skipWizard = function () {
                $uibModalInstance.close();
                if (_this.isFromUpdatePassword) {
                    _this.isFromUpdatePassword = false;
                    if ($rootScope.classicView || sharedSetupService.getClassicViewState()) {
                        $rootScope.classicView = true;
                        //$location.path("map/map");
                        $location.path(sharedSetupService.currentUrl);
                    } else {
                        $location.path("/");
                    }
                } else {
                    var okToSkip = { securityPortal: true, communicationPortal: true };
                    userloginRoutingService.routUser(_this.accountInfo, okToSkip);
                }
            };

            this.toggleShowPassword = function () {
                //this.password.oldPassword.show = !this.password.oldPassword.show;
                _this.password.show = !_this.password.show;
                _this.password.confirmPassword.show = !_this.password.confirmPassword.show;
            };

            this.copyToClipboard = function () {
                // Create a temporary textarea element
                var textarea = document.createElement('textarea');
                textarea.value = _this.secretKeyFormatted; // The text to copy
                document.body.appendChild(textarea);
                textarea.select(); // Select the text
                document.execCommand('copy'); // Copy the text to clipboard
                document.body.removeChild(textarea); // Remove the textarea

                toaster.pop("ticket_warning", _this.translation.text.NOTIFICATION, 'Key copied to clipboard!', 5000, 'trustedHtml');
            };

            $timeout(function () {
                document.getElementById("qr-verification-code").focus();
            }, 0);

            // Listen for URL changes
            var locationChangeStartHandler = $scope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
                // Check if the new URL is different
                if (newUrl !== oldUrl) {
                    // Close the modal
                    $uibModalInstance.dismiss('cancel'); // or use close() if you prefer
                }
            });

            // Clean up the listener when the modal is closed or destroyed
            $scope.$on('$destroy', function () {
                locationChangeStartHandler();
            });
        }

        siteSecurityController.$inject = ['$scope', '$uibModalInstance', '$window', 'translation', 'tag', 'parentScope', 'TwoFactorAuthenticationFactory', 'authenticationService', 'QRCode', '$location', '$timeout', 'updatePasswordService', 'SiteSecurityPortalFactory', 'toaster', 'sharedSetupService', 'userloginRoutingService'];

        return modalInstance.result;
    }
}

siteSecurityModalService.$inject = ['$rootScope', '$uibModal', 'translationService', 'sendMailFactory', 'recaptchaFactory'];
'use strict';

angular.module('mcapp').service('modalService', ModalService);

function ModalService($rootScope, $uibModal, translationService) {
    return {
        prfDeleteErrorNotification: prfDeleteErrorNotification,
        navigateAway: navigateAway,
        confirmDelete: confirmDelete,
        saveNotification: saveNotification,
        updateRtusServiceMode: updateRtusServiceMode,
        pumpStartAlertsTime: pumpStartAlertsTime,
        enableTwoFactorAuthentication: enableTwoFactorAuthentication,
        displayVideo: displayVideo
    };

    function prfDeleteErrorNotification(_tag) {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/ok-popover.html',
            controller: navAwayController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                },
                tag: function tag() {
                    return _tag;
                }
            }
        });

        function navAwayController($uibModalInstance, translation, tag) {
            this.translation = translation;
            this.popoverMessage = this.translation.text[tag];

            this.ok = function () {
                $uibModalInstance.close();
            };
        }

        navAwayController.$inject = ['$uibModalInstance', 'translation', 'tag'];

        return modalInstance.result;
    }

    function navigateAway(_tag2) {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: navAwayController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                },
                tag: function tag() {
                    return _tag2;
                }
            }
        });

        function navAwayController($uibModalInstance, translation, tag) {
            this.translation = translation;
            this.tmpConfirmMessageA = this.translation.text[tag];

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        navAwayController.$inject = ['$uibModalInstance', 'translation', 'tag'];

        return modalInstance.result;
    }

    function saveNotification() {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/prf-popover.html',
            controller: saveNotificationController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                }
            }
        });

        function saveNotificationController($uibModalInstance, translation) {
            this.translation = translation;

            this.ok = function () {
                $uibModalInstance.close();
            };
        }

        saveNotificationController.$inject = ['$uibModalInstance', 'translation'];

        return modalInstance.result;
    }

    function confirmDelete(_tag3) {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: confirmDeleteController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                },
                tag: function tag() {
                    return _tag3;
                }
            }
        });

        function confirmDeleteController($uibModalInstance, translation, tag) {
            this.translation = translation;
            this.tmpConfirmMessageA = !tag ? this.translation.text['GENERIC_DELETE_MESSAGE'] : this.translation.text[tag];

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        confirmDeleteController.$inject = ['$uibModalInstance', 'translation', 'tag'];

        return modalInstance.result;
    }

    function updateRtusServiceMode(_tag4) {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/popover-update-service-mode-template.html',
            controller: updateRtusServiceModeController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                },
                tag: function tag() {
                    return _tag4;
                }
            }
        });

        function updateRtusServiceModeController($uibModalInstance, translation, tag) {
            this.translation = translation;
            this.tmpConfirmMessageA = !tag ? this.translation.text['GENERIC_DELETE_MESSAGE'] : this.translation.text[tag];

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        updateRtusServiceModeController.$inject = ['$uibModalInstance', 'translation', 'tag'];

        return modalInstance.result;
    }

    function pumpStartAlertsTime(_tag5, _index, _parentScope) {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/services/modal-service/pump-start-alerts-time.html',
            controller: pumpStartAlertsTimeController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                },
                tag: function tag() {
                    return _tag5;
                },
                index: function index() {
                    return _index;
                },
                parentScope: function parentScope() {
                    return _parentScope;
                }
            }
        });

        function pumpStartAlertsTimeController($uibModalInstance, translation, tag, index, parentScope, preferencesService, authenticationService) {
            var _this = this;

            this.translation = translation;
            this.tag = !tag ? 'GENERIC_DELETE_MESSAGE' : tag;
            this.accountInfo = authenticationService.getAccountInfo();

            preferencesService.getPreferenceUser(this.accountInfo.userId, this.accountInfo.customerId).then(function (result) {
                _this.timeFormat = result.data.timeFormat;
                _this.timeFormat == 1 ? _this.ismeridian = true : _this.ismeridian = false;
            }, function (error) {
                //$scope.status = 'Unable to load customer data: ' + error.message;
            });

            //TimePicker
            if (parentScope.destinations[index].psAlertTime) {
                this.mytime = parentScope.destinations[index].psAlertTime;
            } else {
                this.mytime = new Date();
            }
            this.hstep = 1;
            this.mstep = 1;

            this.currentDate = function () {
                _this.mytime = new Date();
            };

            this.ok = function () {
                parentScope.destinations[index].psAlertTime = _this.mytime;
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        pumpStartAlertsTimeController.$inject = ['$uibModalInstance', 'translation', 'tag', 'index', 'parentScope', 'preferencesService', 'authenticationService'];

        return modalInstance.result;
    }

    function enableTwoFactorAuthentication(_tag6, _parentScope2, _accountWorkflow) {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            keyboard: false,
            templateUrl: 'ui/components/scadaviews/two-factor-authentication-popover.html',
            controller: enableTwoFactorAuthenticationController,
            controllerAs: '$ctrl',
            //appendTo: 'body',
            size: 'lg',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                },
                tag: function tag() {
                    return _tag6;
                },
                parentScope: function parentScope() {
                    return _parentScope2;
                },
                accountWorkflow: function accountWorkflow() {
                    return _accountWorkflow;
                }
            }
        });

        function enableTwoFactorAuthenticationController($uibModalInstance, $window, translation, tag, parentScope, accountWorkflow, TwoFactorAuthenticationFactory, authenticationService, QRCode, $location, $timeout) {
            var _this2 = this;

            this.translation = translation;
            this.tag = !tag ? 'GENERIC_DELETE_MESSAGE' : tag;
            this.secretKey = "";
            this.pendingVerify = true;
            this.verifySuccess = false;
            this.verifyFailed = false;
            this.accountInfo = authenticationService.getAccountInfo();

            var _twoFactorAuthenticationAppName = "123Scada";
            var _host = $location.host().toLowerCase();
            if (_host.includes("localhost") || _host.includes("dev")) _twoFactorAuthenticationAppName = "Dev.123Scada";else if (_host.includes("qa")) _twoFactorAuthenticationAppName = "Qa.123Scada";

            var _twoFactorAuthenticationFactory = new TwoFactorAuthenticationFactory(this.accountInfo.customerId);
            _twoFactorAuthenticationFactory.generateSecret().then(function (result) {
                _this2.secretKey = _twoFactorAuthenticationFactory.secretKey;
                var secretQrString = 'otpauth://totp/' + _twoFactorAuthenticationAppName + ':' + _this2.accountInfo.email + '?secret=' + _twoFactorAuthenticationFactory.secretKey;
                var formatKey = _twoFactorAuthenticationFactory.secretKey.match(/.{1,4}/g);
                _this2.secretKeyFormatted = formatKey.join(' ');
                var qrcode = new QRCode("qrcode");

                function makeCode() {
                    if (_twoFactorAuthenticationFactory.secretKey) {
                        qrcode.makeCode(secretQrString);
                    }
                }
                makeCode();
            }, function (error) {});

            this.clearVerifyStatus = function () {
                _this2.pendingVerify = true;
                _this2.verifySuccess = false;
                _this2.verifyFailed = false;
            };

            this.verify = function () {
                _twoFactorAuthenticationFactory.verifyCode(_this2.secretKey, _this2.authenticatorCode).then(function (result) {
                    if (result.data == true) {
                        _this2.pendingVerify = false;
                        _this2.verifySuccess = true;
                    } else {
                        _this2.pendingVerify = false;
                        _this2.verifyFailed = true;
                    }
                }, function (error) {});
            };

            this.ok = function () {
                if (!_this2.verifySuccess) return;
                _twoFactorAuthenticationFactory.updateSecret(_this2.secretKey, accountWorkflow).then(function (result) {
                    parentScope.twoFactorAuthentication = true;
                    parentScope.viewStatus = "success";
                    var tmpAccountInfo = angular.copy(_this2.accountInfo);
                    tmpAccountInfo.twoFactorAuthentication = true;
                    var accountInfoChanged = angular.copy(tmpAccountInfo);
                    $window.sessionStorage.accountInfo = JSON.stringify(accountInfoChanged);
                }, function (error) {});
                $uibModalInstance.close();
            };

            this.cancel = function () {
                parentScope.twoFactorAuthentication = false;
                var tmpAccountInfo = angular.copy(_this2.accountInfo);
                tmpAccountInfo.twoFactorAuthentication = true;
                var accountInfoChanged = angular.copy(tmpAccountInfo);
                $window.sessionStorage.accountInfo = JSON.stringify(accountInfoChanged);
                $uibModalInstance.dismiss('cancel');
            };

            $timeout(function () {
                document.getElementById("qr-verification-code").focus();
            }, 0);
        }

        enableTwoFactorAuthenticationController.$inject = ['$uibModalInstance', '$window', 'translation', 'tag', 'parentScope', 'accountWorkflow', 'TwoFactorAuthenticationFactory', 'authenticationService', 'QRCode', '$location', '$timeout'];

        return modalInstance.result;
    }

    function displayVideo(id) {
        //console.log($rootScope);
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/services/modal-service/vimeo-player.html',
            controller: modalController,
            controllerAs: '$ctrl',
            windowClass: 'video-modal',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                },
                videoId: function videoId() {
                    return id;
                }
            }
        });

        function modalController($uibModalInstance, $timeout, $window, openViewService, sharedSetupService, translation, videoId) {
            this.mobile = $rootScope.mobile;
            this.classicView = $rootScope.classicView;
            this.translation = translation;
            var playerWidth = 900;
            var player = void 0;

            if ($window.innerWidth <= 480) {
                playerWidth = 300;
            } else if ($window.innerWidth <= 768) {
                playerWidth = 500;
            } else if ($window.innerWidth <= 992) {
                playerWidth = 700;
            }

            var playerHeight = playerWidth * .563;

            var options = {
                id: videoId,
                autoplay: true,
                width: playerWidth
            };

            $timeout(function () {
                player = new Vimeo.Player('vimeo-player', options);

                $timeout(function () {
                    player.element.style.width = playerWidth;
                    player.element.style.height = playerWidth * .563;
                }, 200);

                angular.element($window).bind('resize', function () {
                    if ($window.innerWidth <= 480) {
                        player.element.style.width = 300;
                        player.element.style.height = 300 * .563;
                    } else if ($window.innerWidth <= 768) {
                        player.element.style.width = 500;
                        player.element.style.height = 500 * .563;
                    } else if ($window.innerWidth <= 992) {
                        player.element.style.width = 700;
                        player.element.style.height = 700 * .563;
                    } else {
                        player.element.style.width = 900;
                        player.element.style.height = 900 * .563;
                    }
                });

                angular.element($window).bind('orientationchange', function () {
                    if ($window.innerWidth <= 480) {
                        player.element.style.width = 300;
                        player.element.style.height = 300 * .563;
                    } else if ($window.innerWidth <= 768) {
                        player.element.style.width = 500;
                        player.element.style.height = 500 * .563;
                    } else if ($window.innerWidth <= 992) {
                        player.element.style.width = 700;
                        player.element.style.height = 700 * .563;
                    } else {
                        player.element.style.width = 900;
                        player.element.style.height = 900 * .563;
                    }
                });
            });

            this.openPopout = function () {
                var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
                optionsStickyProperties.deviceId = videoId;

                var popupPosition = {
                    at: 'left+0 top+0',
                    collision: 'fit',
                    my: 'left+100 top+10',
                    of: window
                };

                var windowWidth = void 0;
                var windowHeight = void 0;

                if ($window.innerWidth <= 480) {
                    windowWidth = 312;
                    windowHeight = 300 * .563 + 38;
                } else if ($window.innerWidth <= 768) {
                    windowWidth = 512;
                    windowHeight = 500 * .563 + 38;
                } else if ($window.innerWidth <= 992) {
                    windowWidth = 712;
                    windowHeight = 700 * .563 + 38;
                } else {
                    windowWidth = 1012;
                    windowHeight = 1000 * .563 + 38;
                }

                openViewService.openView('Video Player', { width: windowWidth, height: windowHeight }, popupPosition, optionsStickyProperties);
                $uibModalInstance.dismiss('cancel');
            };

            this.attemptHover = function () {
                player.element.focus();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', '$timeout', '$window', 'openViewService', 'sharedSetupService', 'translation', 'videoId'];

        return modalInstance.result;
    }
}

ModalService.$inject = ['$rootScope', '$uibModal', 'translationService'];
'use strict';

mcapp.service('importantInformationModalService', importantInformationModalService);

function importantInformationModalService($rootScope, $uibModal, translationService) {
    return {
        importantInformation: importantInformation
    };

    function importantInformation(_parentScope, _communicationPortal) {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            keyboard: false,
            templateUrl: 'ui/importantinformation/important-information-message.html',
            controller: importantInformationController,
            controllerAs: '$ctrl',
            //appendTo: 'body',
            size: 'lg',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                },
                communicationPortal: function communicationPortal() {
                    return _communicationPortal;
                },
                parentScope: function parentScope() {
                    return _parentScope;
                }
            }
        });

        function importantInformationController($scope, $uibModalInstance, translation, communicationPortal, parentScope, authenticationService, userloginRoutingService, $window, $interval) {
            var _this = this;

            var __this = this;
            this.translation = translation;
            this.communicationPortal = communicationPortal;

            this.accountInfo = authenticationService.getAccountInfo();
            this.isMcAdmin = parentScope.isMcAdmin;
            this.mobile = parentScope.mobile;

            this.parentScope = parentScope;

            if (this.accountInfo != null) {
                this.daysPastDue = Math.abs(this.accountInfo.daysPastDue);
            } else {
                if (typeof this.parentScope.stopTimeout === "function") {
                    this.parentScope.stopTimeout();
                }
                $uibModalInstance.close();
                if (this.mobile) $window.location.reload(true);
                return;
            }

            if (typeof this.parentScope.stopTimeout === "function") {
                this.parentScope.stopTimeout();
            }

            this.skipWizard = function () {

                $uibModalInstance.close();

                if (_this.communicationPortal) {
                    var okToSkip = { communicationPortal: true };
                    userloginRoutingService.routUser(_this.accountInfo, okToSkip);
                } else {
                    _this.parentScope.startTimeout();
                }
            };

            // Listen for URL changes
            var locationChangeStartHandler = $scope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
                // Check if the new URL is different
                if (newUrl !== oldUrl) {
                    // Close the modal
                    $uibModalInstance.dismiss('cancel'); // or use close() if you prefer
                }
            });

            this.counter = this.isMcAdmin || this.accountInfo.userType == "TechSupport" ? 1 : 30;
            this.buttonDisabled = true;
            var timer; // Variable to hold the $interval promise

            this.startTimer = function () {
                // Start the timer if it's not already running
                if (angular.isDefined(timer)) return;

                timer = $interval(function () {
                    __this.counter--; // Decrement the counter every second
                    if (__this.counter == 0) {
                        __this.stopTimer();
                        __this.counter = "OK";
                        __this.buttonDisabled = false;
                    }
                }, this.isMcAdmin || this.accountInfo.userType == "TechSupport" ? 0 : 1000); // 1000 milliseconds = 1 second
            };

            this.stopTimer = function () {
                // Stop the timer
                if (angular.isDefined(timer)) {
                    $interval.cancel(timer);
                    timer = undefined;
                }
            };

            this.startTimer();

            // Clean up the listener when the modal is closed or destroyed
            $scope.$on('$destroy', function () {
                locationChangeStartHandler();
                __this.stopTimer();
            });
        }

        importantInformationController.$inject = ['$scope', '$uibModalInstance', 'translation', 'communicationPortal', 'parentScope', 'authenticationService', 'userloginRoutingService', '$window', '$interval'];

        return modalInstance.result;
    }
}

importantInformationModalService.$inject = ['$rootScope', '$uibModal', 'translationService'];
"use strict";

angular.module("mc.forgots", []); //for forgot username and password functionality
//function ForgotUsrPwdFactory(HOST, $http) {
//    var forgots = {};
//    //// instantiate our initial object
//    //var Forgots = function (email) {
//    //    this.email = email;
//    //};

//    //Forgots.prototype.getData = function () {
//    //    var self = this;
//    //    return $http.get(HOST + "/api/Forgots"
//    //        + "?email=" + this.email
//    //    ).then(function (response) {
//    //        self.data = response.data;
//    //        self.loading = false;
//    //        return response;
//    //    });
//    //};

//    var _username = function (email) {
//        return $http({
//            method: 'Get',
//            url: HOST + '/api/Forgots?email=' + email,
//            cache: false
//        });

//        var _sendMail = function (toAddr, mailBody) {
//            return $http.put(HOST + '/api/Forgots?toAddr=' + toAddr + "&" + "mailBody=" + mailBody);
//        };

//        forgots.Username = _username;
//        forgots.SendMail = _sendMail;

//        return forgots;
//    }
//}

//ForgotUsrPwdFactory.$inject = ["HOST", "$http"];

//angular.module("mc.forgots").factory("ForgotUsrPwdFactory", ForgotUsrPwdFactory);
"use strict";
'use strict';

mcapp.service('forgotUsernamePasswordModalService', forgotUsernamePasswordModalService);

function forgotUsernamePasswordModalService($rootScope, $uibModal, translationService, sendMailFactory) {
    return {
        confirmForgotUsername: forgotUsername,
        confirmForgotPassword: forgotPassword
    };

    function forgotUsername() {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/services/modal-service/forgot-username.html',
            controller: forgotUsernameController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                }
            }
        });

        function forgotUsernameController($uibModalInstance, translation, sendMailFactory) {
            //this.translation = translation;
            var vm = this;

            vm.email = "venkatr@123mc.com";
            vm.displayerror = false;
            vm.errormessage = "";
            vm.Username = "";

            //this._username = "";

            vm.ok = function () {

                ////1. Retrieve Username from database

                //getUsernameFactory.Username(this.email)
                //.then(function (result) {
                //    this._username = result;
                //    alert("Successful retrieving username "+result); //service is returning username as string
                //})
                //.error(function (error) {
                //    alert("Error while retrieving result.");
                //});

                //2. SendMail to customer
                sendMailFactory.SendMail(this.email).then(function (result) {
                    //alert("Successful SendMail for username: " + result); //service is returning username as string
                    vm.Username = result.data;
                    $uibModalInstance.close();
                }, function (error) {
                    //this.displayerror = error != undefined;
                    vm.displayerror = true;
                    vm.errormessage = error;
                    //alert("Error while SendMail. "+error);
                });
                //3. TODO: add audit entry about the this action

            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        forgotUsernameController.$inject = ['$uibModalInstance', 'translation', 'sendMailFactory'];

        return modalInstance.result;
    }

    function forgotPassword() {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/services/modal-service/forgot-password.html',
            controller: forgotPasswordController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                }
            }
        });

        function forgotPasswordController($uibModalInstance, translation) {
            this.translation = translation;

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        forgotPasswordController.$inject = ['$uibModalInstance', 'translation'];

        return modalInstance.result;
    }
}

//mcapp.factory("forgotUsernameFactory", function ($http, HOST) {
//    var Result = {};

//    var _username = function (email) {
//        return $http({
//            method: 'Get',
//            url: HOST + '/api/Forgots?email=' + email,
//            cache: false
//        });
//    }

//    var _sendMail = function (toEmail, username) {
//        return $http.put(HOST + '/api/Forgots?toEmail=' + toEmail + "&" + "username=" + username);
//    };

//    Result.Username = _username;
//    Result.SendMail = _sendMail;

//    return Result;
//});

//forgotUsrPwdFactory.$inject = ["HOST", "$http"];

//mcapp.factory("getUsernameFactory", function ($http, HOST) {
//    var Result = {};

//    var _username = function (email) {
//        return $http({
//            method: 'Get',
//            url: HOST + '/api/Forgots?email=' + email,
//            cache: false
//        });
//    }

//    Result.Username = _username;

//    return Result;
//});

mcapp.factory("sendMailFactory", ["$http", "HOST", function ($http, HOST) {
    var Result = {};

    var _sendMail = function _sendMail(toEmail) {
        return $http.put(HOST + '/api/Forgots?toEmail=' + toEmail);
    };

    Result.SendMail = _sendMail;

    return Result;
}]);
//sendMailFactory.$inject = ['$http', 'HOST'];

forgotUsernamePasswordModalService.$inject = ['$rootScope', '$uibModal', 'translationService', 'sendMailFactory'];
'use strict';

mcapp.service('forgotUsernameModalService', forgotUsernameModalService);

function forgotUsernameModalService($rootScope, $uibModal, translationService, sendMailFactory, recaptchaFactory) {
    return {
        confirmForgotUsername: forgotUsername
    };

    function forgotUsername() {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/services/modal-service/forgot-username.html',
            controller: forgotUsernameController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                }
            }
        });

        function forgotUsernameController($rootScope, $uibModalInstance, translation, sendMailFactory, vcRecaptchaService, recaptchaFactory) {
            var _this = this;

            //this.translation = translation;
            var vm = this;

            this.email = "";
            this.displayerror = false;
            this.errormessage = "";
            this.clientResponse = undefined; //recaptcha response for the client
            //this.serverResponse = undefined; //recaptcha response from the server
            vm.mobileApp = $rootScope.mobileApp;
            vm.txtInput = '';
            vm.captchaNumber = '';
            vm.errorMsgNumber = '';
            vm.errorNumber = undefined;

            this.$onInit = function () {
                _this.generateCaptcha();
            };

            this.model = {
                key: '6Le92ikUAAAAAN4WKNWkE9i7Z-vO76ciOjHaOqVi'
            };

            this.setResponse = function (response) {
                console.info('Response available');
                console.info(response);

                this.clientResponse = response;
            };

            this.setWidgetId = function (widgetId) {
                console.info('Created widget ID: %s', widgetId);

                this.widgetId = widgetId;
            };

            this.cbExpiration = function () {
                console.info('Captcha expired. Resetting response object');

                vcRecaptchaService.reload(this.widgetId);

                this.clientResponse = undefined;
            };

            this.ok = function () {
                //1. validate Recaptcha first at server side
                //this.recaptcha();
                //if (vm.clientResponse === undefined)
                //    return;
                if (!vm.mobileApp) {
                    recaptchaFactory.RecaptchaServerValidate(vm.clientResponse, "ForgotUsername").then(function (result) {
                        // console.info("Client:Server Response Success , " + result);
                        vm.serverResponse = true;
                        if (vm.clientResponse !== undefined) {
                            vm.clientResponse = undefined;
                        }

                        vm.sendMail();
                    }, function (error) {
                        //console.info("Client:Server Response failure , " + error.Message);
                        if (vm.clientResponse !== undefined) {
                            vm.clientResponse = undefined;
                        }
                        //if (vm.serverResponse !== undefined) {
                        //    vm.serverResponse = undefined;
                        //}
                        vm.displayerror = true;
                        vm.errormessage = error.message;
                        vcRecaptchaService.reload(vm.widgetId);
                    });
                } else if (vm.mobileApp && vm.clientResponse) {
                    vm.clientResponse = undefined;
                    vm.sendMail();
                }

                //2. TODO:VENKAT add audit entry about the this action
            };

            this.sendMail = function () {
                sendMailFactory.SendMail(vm.email, "ForgotUsername").then(function (result) {
                    //alert("Successful SendMail for username: " + result); //service is returning username as string
                    //vm.Username = result;
                    $rootScope.$broadcast('forgotUsernameEmailSent');
                    $uibModalInstance.close();
                }, function (error) {
                    //Prevent Username Enumeration, redirect to Login page in case of failure (i.e, email address in not present in DB)
                    $rootScope.$broadcast('forgotUsernameEmailSentFailed', error.data.message);
                    $uibModalInstance.close();
                });
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            this.generateCaptcha = function () {
                var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                vm.captchaNumber = '';
                for (var i = 0; i < 6; i++) {
                    vm.captchaNumber += chars.charAt(Math.floor(Math.random() * chars.length)) + ' ';
                }
                vm.captchaNumber = vm.captchaNumber.trim();
                vm.errorNumber = undefined;
                vm.errorMsgNumber = '';
                vm.txtInput = '';
            };

            this.validateCaptcha = function () {
                var generated = vm.captchaNumber.split(' ').join('');
                var entered = (vm.txtInput || '').split(' ').join('');
                if (generated === entered && entered !== '') {
                    vm.errorNumber = false;
                    vm.errorMsgNumber = 'Captcha Matched!';
                    vm.clientResponse = true;
                } else {
                    vm.clientResponse = undefined;
                    vm.errorNumber = true;
                    vm.errorMsgNumber = 'Invalid Captcha. Try again!';
                }
            };

            //this.scaleCaptcha = function () {
            //    // Width of the reCAPTCHA element, in pixels
            //    var reCaptchaWidth = 304;
            //    // Get the containing element's width
            //    var containerWidth = $('.container').width();

            //    // Only scale the reCAPTCHA if it won't fit
            //    // inside the container
            //    if (reCaptchaWidth > containerWidth) {
            //        // Calculate the scale
            //        var captchaScale = containerWidth / reCaptchaWidth;
            //        // Apply the transformation
            //        $('.g-recaptcha').css({
            //            'transform': 'scale(' + captchaScale + ')'
            //        });
            //    }
            //}

            //$(function () {

            //    // Initialize scaling
            //    this.scaleCaptcha();

            //    // Update scaling on window resize
            //    // Uses jQuery throttle plugin to limit strain on the browser
            //    $(window).resize($.throttle(100, scaleCaptcha));

            //});
        }

        forgotUsernameController.$inject = ['$rootScope', '$uibModalInstance', 'translation', 'sendMailFactory', 'vcRecaptchaService', 'recaptchaFactory'];

        return modalInstance.result;
    }
}

mcapp.factory("sendMailFactory", ["$http", "HOST", function ($http, HOST) {
    var Result = {};

    var _sendMail = function _sendMail(toEmail, toServicesController) {
        //Example:-->  return $http.put(HOST + '/api/ForgotUsername?toEmail=' + toEmail);
        return $http.get(HOST + '/api/' + toServicesController + '?toEmail=' + encodeURIComponent(toEmail));
    };

    Result.SendMail = _sendMail;

    return Result;
}]);

mcapp.factory("recaptchaFactory", ["$http", "HOST", function ($http, HOST) {
    var Result = {};

    var _recaptchaServerValidate = function _recaptchaServerValidate(clientResponse, toServicesController) {
        return $http.post(HOST + '/api/' + toServicesController + '?clientResponse=' + clientResponse);
    };

    Result.RecaptchaServerValidate = _recaptchaServerValidate;

    return Result;
}]);

forgotUsernameModalService.$inject = ['$rootScope', '$uibModal', 'translationService', 'sendMailFactory', 'recaptchaFactory'];
'use strict';

mcapp.service('forgotPasswordModalService', forgotPasswordModalService);

function forgotPasswordModalService($rootScope, $uibModal, translationService, sendMailFactory, recaptchaFactory) {
    return {
        // confirmForgotUsername: forgotUsername,
        confirmForgotPassword: forgotPassword
    };

    function forgotPassword() {
        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/services/modal-service/forgot-password.html',
            controller: forgotPasswordController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                }
            }
        });

        function forgotPasswordController($rootScope, $uibModalInstance, translation, sendMailFactory, vcRecaptchaService, recaptchaFactory) {
            var _this = this;

            //this.translation = translation;
            var vm = this;

            vm.email = "";
            //vm.username = "";
            //vm.vCode = "";
            //vm.displayerror = false;
            //vm.errormessage = "";
            //vm.userid = "";
            vm.sentemailsuccess = undefined;
            vm.displayMessage = "";
            // vm.currentState = "validateEmail";
            vm.clientResponse = undefined; //recaptcha response for the client
            //vm.serverResponse = undefined; //recaptcha response from the server
            vm.mobileApp = true; //$rootScope.mobileApp;
            vm.txtInput = '';
            vm.captchaNumber = '';
            vm.errorMsgNumber = '';
            vm.errorNumber = undefined;

            this.$onInit = function () {
                _this.generateCaptcha();
            };

            this.model = {
                key: '6Le92ikUAAAAAN4WKNWkE9i7Z-vO76ciOjHaOqVi'
            };

            this.setResponse = function (response) {
                console.info('Response available');
                console.info(response);

                this.clientResponse = response;
            };

            this.setWidgetId = function (widgetId) {
                console.info('Created widget ID: %s', widgetId);

                this.widgetId = widgetId;
            };

            this.cbExpiration = function () {
                console.info('Captcha expired. Resetting response object');

                vcRecaptchaService.reload(this.widgetId);

                this.clientResponse = undefined;
            };

            this.validateEmail = function () {
                if (!vm.mobileApp) {
                    recaptchaFactory.RecaptchaServerValidate(vm.clientResponse, "ForgotPassword").then(function (result) {
                        //console.info("Client:Server Response Success , " + result.data);
                        //vm.serverResponse = true;
                        if (vm.clientResponse !== undefined) {
                            vm.clientResponse = undefined;
                        }

                        //2. SendMail to customer
                        vm.sendMail();
                    }, function (error) {
                        //console.info("Client:Server Response failure , " + error.Message);
                        if (vm.clientResponse !== undefined) {
                            vm.clientResponse = undefined;
                        }
                        //if (vm.serverResponse !== undefined) {
                        //    vm.serverResponse = undefined;
                        //}
                        vm.displayMessage = error.message;
                        vcRecaptchaService.reload(vm.widgetId);
                    });
                } else if (vm.mobileApp && vm.clientResponse) {
                    vm.clientResponse = undefined;
                    vm.sendMail();
                }
            };

            this.sendMail = function () {
                sendMailFactory.SendMail(vm.email, "ForgotPassword").then(function (result) {
                    //vm.userid = result;
                    vm.sentemailsuccess = true;
                    vm.displayMessage = "A message has been sent to your email address. Please follow the link provided in the email to reset your password.";
                }, function (error) {
                    //vm.displayerror = true;
                    vm.sentemailsuccess = false;
                    vm.displayMessage = error.data.message; //"No account found with this email address";
                    vcRecaptchaService.reload(vm.widgetId);
                });
            };

            this.cancel = function () {
                //vm.currentState = "validateEmail";
                $uibModalInstance.dismiss('cancel');
            };

            this.generateCaptcha = function () {
                var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                vm.captchaNumber = '';
                for (var i = 0; i < 6; i++) {
                    vm.captchaNumber += chars.charAt(Math.floor(Math.random() * chars.length)) + ' ';
                }
                vm.captchaNumber = vm.captchaNumber.trim();
                vm.errorNumber = undefined;
                vm.errorMsgNumber = '';
                vm.txtInput = '';
            };

            this.validateCaptcha = function () {
                var generated = vm.captchaNumber.split(' ').join('');
                var entered = (vm.txtInput || '').split(' ').join('');
                if (generated === entered && entered !== '') {
                    vm.errorNumber = false;
                    vm.errorMsgNumber = 'Captcha Matched!';
                    vm.clientResponse = true;
                } else {
                    vm.clientResponse = undefined;
                    vm.errorNumber = true;
                    vm.errorMsgNumber = 'Invalid Captcha. Try again!';
                }
            };
        }

        forgotPasswordController.$inject = ['$rootScope', '$uibModalInstance', 'translation', 'sendMailFactory', 'vcRecaptchaService', 'recaptchaFactory'];

        return modalInstance.result;
    }
}

forgotPasswordModalService.$inject = ['$rootScope', '$uibModal', 'translationService', 'sendMailFactory', 'recaptchaFactory'];
mcapp.directive('missionViewBox', function () {
    return {
        link: function (scope, element, attrs) {
            attrs.$observe('missionViewBox',
                function(value) {
                    if (value !== null && value !== '') {
                        element.get(0).setAttribute("viewBox", value);
                    }
                });
        }
    };
});
mcapp.controller('topMenuController', ['$scope', '$element', function ($scope, $element) {
    //$scope.liveData = false;
}]);

mcapp.directive('topMenu', ['$rootScope', 'detectBrowserService', 'translationService', 'openViewService', '$cookies', '$location', function ($rootScope, detectBrowserService, translationService, openViewService, $cookies, $location) {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        templateUrl: function (element, attrs) {
            return "ui/components/directives/menu/top-menu" + (attrs.topMenuTemplate ? "-" + attrs.topMenuTemplate + ".html" : ".html");
        },
        link: function (scope, element, attrs) {
            scope.mobile = $rootScope.mobile;
            scope.classicView = $rootScope.classicView;
            scope.topMenuDevice = attrs.topMenuDevice == 'false' ? false : true;
            scope.showMenuDevice = attrs.showMenuDevice == 'true' ? true : false;
            scope.topMenuCalendar = attrs.topMenuCalendar == 'false' ? false : true;
            scope.topMenuDateRange = attrs.topMenuDateRange == 'true' ? true : false;
            scope.liveData = false;
            scope.liveDataIn = false;
            scope.topMenuLiveData = attrs.topMenuLiveData == 'false' ? false : true;
            scope.topMenuPrint = attrs.topMenuPrint == 'false' ? false : detectBrowserService() == 'chrome' ? true : false; // for now disabling print feature on Firefox, as it has some issues printing charts.
            scope.topMenuDownload = attrs.topMenuDownload == 'true' ? true : false;
            scope.topMenuSearchReport = attrs.topMenuSearchReport == 'true' ? true : false;
            scope.topMenuExcelProgress = false;
            scope.curentBrowser = detectBrowserService();
            scope.ieFileSuffix = "";
            scope.translation = translationService.translation;
            scope.topMenuPdfProgress = false;
            scope.topMenuExcel = attrs.topMenuExcel == 'true' ? true : false;
            scope.topMenuPdf = attrs.topMenuPdf == 'true' ? true : false;
            scope.isTransactionDataMenu = attrs.isTransactionDataMenu == 'true' ? true : false;

            scope.saveExcel = function () {
                // if view specific controller function exists to save to Excel, then invoke it, otherwise invoke this function implementation.
                if ('saveExcel' in scope.$ctrl && typeof scope.$ctrl.saveExcel === 'function'){
                    scope.$ctrl.saveExcel();
                } else {
                    scope.topMenuExcelProgress = true;

                    //Copy html elements
                    var requiredElementCopy = angular.copy(element.parents("div").find("div.save-excel"));
                    var requiredHeaderCopy = angular.copy(element.parents("div").find(".excel-pdf-header"));
                    var reportTitle = scope.windowTitle.trim();
                    if (!/Report$/.test(reportTitle)) {
                        reportTitle += " Report";
                    }
                    $(requiredElementCopy).prepend("<h4>" + reportTitle + "</h4>");
                    //Remove Undesired html
                    $(requiredElementCopy).find(".mc-remove-extra-column").remove();
                    $(requiredElementCopy).find(".mc-remove-extra-data-pdf-only").remove();
                    $(requiredElementCopy).find(".img-excel-download-remove").remove();
                    if (scope.windowTitle !== "Rain Analysis Report") {
                        $(requiredHeaderCopy).find(".mc-remove-extra-column").remove();
                        $(requiredHeaderCopy).find(".dropdown-menu").remove();

                        // Prepend Header to table
                        $(requiredElementCopy).find("tbody:first").prepend(requiredHeaderCopy);
                    }

                    var blob = new Blob([requiredElementCopy.html()],
                        {
                            type: "application/vnd.ms-excel;charset=utf-8"
                        });
                    //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
                    if (scope.curentBrowser == "ie")
                        scope.ieFileSuffix = " (" + (new Date().getTime()) + ")";
                    setTimeout(function() {
                            scope.topMenuExcelProgress = false;
                            scope.$apply();
                            saveAs(blob, scope.windowTitle.replace(/ /g, "_") + scope.ieFileSuffix + ".xls");
                        },
                        1000);
                }
            };

            scope.setTitles = function () {
              scope.title = [
                  { name: eval("scope.translation.text." + ("Clear Filter").toUpperCase().replace(/ /g, "_")) },
                  { name: eval("scope.translation.text." + ("Save to Excel").toUpperCase().replace(/ /g, "_")) },
                  { name: eval("scope.translation.text." + ("Save to Pdf").toUpperCase().replace(/ /g, "_")) },
                  { name: eval("scope.translation.text." + ("Select View").toUpperCase().replace(/ /g, "_")) },
                  { name: eval("scope.translation.text." + ("Select Device").toUpperCase().replace(/ /g, "_")) },
                  { name: eval("scope.translation.text." + ("Click to toggle").toUpperCase().replace(/ /g, "_")) },
                  { name: eval("scope.translation.text." + ("Paging Log").toUpperCase().replace(/ /g, "_")) },
                  { name: eval("scope.translation.text." + ("Current Status").toUpperCase().replace(/ /g, "_")) },
                  { name: eval("scope.translation.text." + ("Select Download").toUpperCase().replace(/ /g, "_"))},
                  { name: eval("scope.translation.text." + ("Paging").toUpperCase().replace(/ /g, "_"))},
                  { name: eval("scope.translation.text." + ("Monthly Flow Summary").toUpperCase().replace(/ /g, "_"))
                }
              ];
            };

            scope.setTitles();

            scope.$on('updatePreferencesLanguage', function (event, args) {
              scope.translation = args;
              scope.setTitles();
            });

            scope.$on('change_current_status_top_menu', function (event, args, window) {
                scope.isTransactionDataMenu = args;                
            });

            scope.popupTo = function (startDate) {
                if(startDate && scope.$ctrl){
                  scope.$ctrl.myDateRangeStart = startDate;
                  scope.$ctrl.myDateRangeEnd = scope.$ctrl.myDateRangeEnd < scope.$ctrl.myDateRangeStart ? scope.$ctrl.myDateRangeStart : scope.$ctrl.myDateRangeEnd;
                }
                else if(startDate){
                  scope.myDateRangeStart = startDate;
                  scope.myDateRangeEnd = scope.myDateRangeEnd < scope.myDateRangeStart ? scope.myDateRangeStart : scope.myDateRangeEnd;
                }
                element.parents("div").find(".quickdate-button-range").focus();
            };
            scope.checkFrom = function (endDate) {
                if(endDate && scope.$ctrl){
                  scope.$ctrl.myDateRangeEnd = endDate;
                  scope.$ctrl.myDateRangeStart = scope.$ctrl.myDateRangeEnd < scope.$ctrl.myDateRangeStart ? scope.$ctrl.myDateRangeEnd : scope.$ctrl.myDateRangeStart;
                }
                else if(endDate){
                  scope.myDateRangeEnd = endDate;
                  scope.myDateRangeStart = scope.myDateRangeEnd < scope.myDateRangeStart ? scope.myDateRangeEnd : scope.myDateRangeStart;
                }
            };

            scope.openViewMobile = function (varUrl) {
                $location.path(varUrl);
            };

            if (scope.$ctrl)
                scope.$ctrl.openViewMobile = scope.openViewMobile;

            scope.openView = ($rootScope.mobile || $rootScope.classicView) ? scope.openViewMobile : openViewService.openView;

            scope.isMcAdmin = $cookies.get('AdminInfo') != null ? true : false;

            scope.search = { undefined: '' };

            // Commenting the below line and handling it in Alarm History.
            // in RTU View when clicked on Dispatch icon the Alarm History Report 
            // should open with filter having device selected

            
            // if (scope.windowTitle == "Alarm History") {
            //   if (!$rootScope.mobile && !$rootScope.classicView) { 
            //     if (scope.$ctrl.stickyProperties.device.deviceName){
            //         scope.search = { undefined: scope.$ctrl.stickyProperties.device.deviceName };
            //     } else {
            //       scope.search = { undefined: '' }
            //     }
            //   } else {
            //     scope.search = { undefined: '' }
            //   }
            // } else {
            //   scope.search = { undefined: '' } 
            // }

            scope.topMenuView = attrs.topMenuView == 'false' ? false : true;

            scope.clearSearchField = function (varInput) {
                if (angular.isUndefined(varInput) || varInput == null) {
                    scope.search = { undefined: '' };
                } else {
                    scope.search[varInput] = '';
                }
            };

            if (scope.$ctrl)
                scope.$ctrl.clearSearchField = scope.clearSearchField;

            if ($rootScope.mobile || $rootScope.classicView) return;

            scope.topMenuToggle = attrs.topMenuToggle == 'true' ? true : false;
            scope.topMenuToggleA = attrs.topMenuToggleA == 'true' ? true : false;
            scope.topMenuPagingLog = attrs.topMenuPagingLog == 'true' ? true : false;

            //scope.$watch('myDate', function (newVal, oldVal) {
            //  if (newVal && newVal < new Date('1/1/2016')) {
            //    scope.alerts.push({ msg: 'Data before January 1st, 2016 is currently unavailable, but coming soon!', type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
            //  }
            //});

            attrs.$observe('topMenuToggle', function (val) {
                scope.topMenuToggle = val == 'true' ? true : false;
            });
            attrs.$observe('topMenuToggleA', function (val) {
                scope.topMenuToggleA = val == 'true' ? true : false;
            });
        }
    };
}]);

mcapp.controller('mainMenuController', ['$scope', function ($scope) {
    //$scope.liveData = false;
}]);

mcapp.directive('mainMenu', ['$http', '$document', '$cookies', 'sharedSetupService', '$timeout', '$window', 'openViewService', 'notificationOpenService', 'modalService', 'translationService', 'desktopViewService', '$location', 'CustomerListFactory', 'ApplicationPortalFactory', '$rootScope', 'HOST',
    function ($http, $document, $cookies, sharedSetupService, $timeout, $window, openViewService, notificationOpenService, modalService, translationService, desktopViewService, $location, CustomerListFactory, ApplicationPortalFactory, $rootScope, HOST) {
        return {
            restrict: 'E',
            transclude: false,
            replace: true,
            templateUrl: function (element, attrs) {
                return "ui/components/directives/menu/main-menu.html";
            },
            //templateUrl: 'ui/components/directives/menu/main-menu.html',
            link: function (scope, element, attrs) {
                //$http.get('https://api.vimeo.com/channels/1253760/videos', { headers: { 'Authorization': 'Bearer de80698101d0919a68ba258bebee8099', 'Accept': 'application/vnd.vimeo.*+json;version=3.2' } }).then(function (resp) {
                //  scope.videos = resp.data.data;
                //});

                var firstRun = true;
                scope.loadMenu = true;
              
                scope.refreshData = function () {
                    scope.accountInfo.menuItems = angular.copy(scope.accountInfo.menuItems);
                };

                scope.$on('refreshMenuItems', function () {
                    scope.refreshData();
                });

                if (angular.isDefined(scope.translation)) {
                    translationService.loadLanguage(true)
                        .then(function (result) {
                            scope.translation = translationService.translation;
                        }, function (error) {
                            console.log("error");
                        });
                }

                scope.clickHandler = function (menu) {

                    eval('scope.' + menu.clickFunction);
                }

                scope.openVideo = function (link) {
                    var id = link.substring(link.lastIndexOf('/') + 1);
                    modalService.displayVideo(id);
                };

                scope.checkVideos = function () {
                    //$http.get('https://api.vimeo.com/channels/1253760/videos', { headers: { 'Authorization': 'Bearer de80698101d0919a68ba258bebee8099', 'Accept': 'application/vnd.vimeo.*+json;version=3.2' } }).then(function (resp) {
                    //  scope.videos = resp.data.data;
                    //});
                };

                scope.adminUser = $cookies.get('AdminUser1') != null ? true : false;//old, will go away
                scope.mcAdminAccess = sharedSetupService.mcAdmin(); //old, will go away

                ///////////////////////////////////////////////////////////////////////////////////
                ///////////////////////////////////////////////////////////////////////////////////
                scope.reportAccess = false;
                scope.isAdmin = false;
                //scope.isAlarmUser = false; //able to acknowledge alarms on dashboard
                scope.isUser = false; // ReadOnly user
                //scope.isDemoUser = false; //able to accessLive Demo of Tank & Well system at Front office, in-addition to Public User
                scope.isPublicUser = false;
                scope.isMcAdmin = $cookies.get('AdminInfo') != null ? true : false;
                scope.dispatcherVersion = scope.accountInfo.dispatcherVersion;

                switch(scope.accountInfo.userRole) {
                    case "Administrator":
                        scope.reportAccess = true;
                        scope.isAdmin = true;
                        break;
                    case "SuperAdministrator":
                        scope.reportAccess = true;
                        scope.isAdmin = true;
                        scope.isSuperAdmin = true;
                        break;
                    //case "AlarmUser": //Able to Acknowledge Alarms on Dashboard
                    //    scope.isAlarmUser = true;
                    //    break;
                    case "User": //ReadOnly
                        scope.isUser = true;
                        break;
                    //case "DemoUser": //Able to view Live Demo of Tank & Well System on front office
                    //    scope.isDemoUser = true;
                    //    break;
                    case "PublicUser":
                        scope.isPublicUser = true;
                        break;
                    default:
                        scope.isPublicUser = true;
                }

                switch (scope.accountInfo.customerId) {
                    case 597:
                    case 15177:
                    case 15147:
                        scope.bulkWaterManagementAccess = true;
                        break;
                    default:
                        scope.bulkWaterManagementAccess = false;
                }

                var userTypeParms = sharedSetupService.getUserTypeParms(scope.accountInfo.portal, scope.accountInfo.preferenceUser.adminPortal);
                if (userTypeParms.name.length > 0) {
                    scope.portalName = userTypeParms.name;
                    scope.portalPath = userTypeParms.path;
                    scope.portalOptions = true;
                }

                scope.goToPortal = function () {
                    desktopViewService.closeAllViews();
                    $location.path(scope.portalPath);
                };

                ///////////////////////////////////////////////////////////////////////////////////
                ///////////////////////////////////////////////////////////////////////////////////

                scope.toogleSelectCopy = function (menuOtion) {
                    scope.selectCopy = !scope.selectCopy;
                    if (scope.selectCopy) {
                        $("body").css("-moz-user-select", "text").css("-khtml-user-select", "text").css("-webkit-user-select", "text").css("-ms-user-select", "text").css("user-select", "text");
                    } else {
                        $("body").css("-moz-user-select", "-moz-none").css("-khtml-user-select", "none").css("-webkit-user-select", "none").css("-ms-user-select", "none").css("user-select", "none");
                    }

                };

                scope.pagingViewHeightAdjustment = 0;
                if (scope.mcAdminAccess) {
                    scope.pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
                }

                var initializeMenu = function () {

                    scope.managedSites = null;
                    if (scope.selectCopy === true) {
                        scope.selectCopy = false;
                        scope.toogleSelectCopy();
                    }
                    else if (scope.selectCopy !== false && scope.mcAdminAccess === true) {
                        scope.selectCopy = false;
                        scope.toogleSelectCopy();
                    }

                    if (scope.accountInfo.portal) {
                        var _customerList = new CustomerListFactory();

                        _customerList.getData(true).then(function () {
                            var _managedSites = _customerList.data.customers;
                            scope.managedSites = _managedSites.filter(function (item) {
                                return item.customerId != scope.accountInfo.customerId;
                            });

                        });
                    }

                    $timeout(function () {
                        if (!firstRun) $("#menu").menu("destroy");
                        $("#menu").menu();


                        //$("#menu li").first().click(function (event) {
                        //    event.stopPropagation();
                        //    event.preventDefault();
                        //});

                        $('#menu li > ul').each(function (index, domEle) {
                            $(domEle).parents('li').not(".no-click").click(function (event) {
                                if (!$(event.target).hasClass('no-click')) {
                                    event.stopPropagation();
                                    event.preventDefault();
                                }
                            });
                        });

                        if (firstRun) {
                            $("#start-button, #menu, #menub").click(function () {
                                $("#font-color-menu").hide("fast");
                                $("#nav-menu").toggle("fast");
                            });

                            $("#desktopicons").click(function () {
                                $("#nav-menu, #font-color-menu").hide("fast");
                            });

                            scope.selectCopy = ($("body").css("-moz-user-select") === "text" ||
                                $("body").css("-khtml-user-select") === "text" ||
                                $("body").css("-webkit-user-select") === "text" ||
                                $("body").css("-ms-user-select") === "text" ||
                                $("body").css("user-select") === "text")
                                ? true
                                : false;
                        }

                        firstRun = false;

                    }, 500);
                };

                initializeMenu();

                var tmpEventname = "click.outsideMenu";
                $document.on(tmpEventname, function (event) {
                    if (!$(event.target).closest('#nav-menu').length && !$(event.target).closest('#start-button').length) {
                        $("#nav-menu").hide("fast");
                    }
                });

                scope.goToLegacySite = function () {
                    $window.open('https://www.123mc.com/123mc/main2011.asp', '_blank');
                };

                scope.updatePasswordView = function () {                    
                    if (scope.accountInfo.mfaMigrationStatus >= 1) {
                        var currentPath = $location.path();                        
                        $rootScope.classicView = false;
                        sharedSetupService.isFromUpdatePassword = true;
                        sharedSetupService.currentUrl = currentPath;
                        $location.path('/security/portal');
                    }
                    else {
                        if (!$rootScope.mobile && !$rootScope.classicView) {
                            openViewService.openView('Update Password', { width: 700, height: 280 }, { my: 'top+120', at: 'center top', of: undefined }, undefined, { minimumWidth: 700, minimumHeight: 280 }, undefined);
                        }
                        else {
                            $location.path('/account/password/update-password-template');
                        }
                    }                    
                }

                scope.openNotification = function (menuOption) {
                    var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
                    optionsStickyProperties.deviceId = (menuOption == "Rules" ? 1 : 2);
                    var position = null;
                    if (scope.accountInfo.dispatcherVersion === 1) {
                        position = { my: 'top+120', at: 'center top', of: window };
                        openViewService.openView('Migrate Notification', { width: 750, height: 350 }, position, optionsStickyProperties, { minimumWidth: 750, minimumHeight: 350 }, true);
                        return;
                    }

                    notificationOpenService.open(menuOption);
                };

                scope.openWizard = function (menuOption) {
                    var optionsStickyProperties = {deviceId: 2};
                    var position = null;
                    position = { my: 'top+120', at: 'center top', of: window };
                    openViewService.openView('Wizard', { width: 770, height: 800 }, position, optionsStickyProperties, { minimumWidth: 750, minimumHeight: 350 }, true);
                    return;
                };

                scope.openWizardSplash = function (menuOption) {
                    var optionsStickyProperties = { deviceId: 2 };
                    var position = null;
                    position = { my: 'top+120', at: 'center top', of: window };
                    openViewService.openView('Wizard Splash', { width: 770, height: 435 }, position, optionsStickyProperties, { minimumWidth: 750, minimumHeight: 350 }, true);
                    return;
                };

                scope.openHelpPanel = function () {
                    openViewService.openHelpPanel("Documentation");
                };

                scope.checkReportsNavSize = function () {
                    //Check for Hover on Reports
                    $( "[katalon-id='6000']" ).hover(
                        function() {

                            var currentDesktopSize = sharedSetupService.getWindowSize();

                            if (currentDesktopSize.height < 825 ) {
                                $timeout(function () {
                                    //Adjust Nav to fit page based on font size
                                    // if(scope.accountInfo.preferenceUser.fontSizeId == 3)$( "[katalon-id='6010']" ).parent().css('top','-250px');
                                    // if(scope.accountInfo.preferenceUser.fontSizeId == 2)$( "[katalon-id='6010']" ).parent().css('top','-300px');
                                    $( "[katalon-id='6010']" ).parent().animate({ top: "-400px" }, "fast");
                                }, 350);
                            }
                        }
                      );
                };

                scope.selectCustomer = function (customer, busyLoading) {
                    var _applicationPortal = new ApplicationPortalFactory(customer.customerId);
                    _applicationPortal.switchCustomer(customer, busyLoading);
                };

                $timeout(function () {scope.checkReportsNavSize();}, 0);

                scope.$on('interconnectApplicationMenu', function (e, msg) {
                    var msgAanalog = angular.isUndefined(msg.analog) ? scope.accountInfo.analogInterconnect : msg.analog;
                    var msgDigital = angular.isUndefined(msg.digital) ? scope.accountInfo.digitalInterconnect : msg.digital;

                    scope.accountInfo.analogInterconnect = msgAanalog;
                    scope.accountInfo.digitalInterconnect = msgDigital;

                    var accountInfoString = $window.sessionStorage.getItem('accountInfo');
                    var accountInfo = JSON.parse(accountInfoString);

                    accountInfo.analogInterconnect = msgAanalog;
                    accountInfo.digitalInterconnect = msgDigital;

                    var updatedAccountInfoString = JSON.stringify(accountInfo);
                    $window.sessionStorage.setItem('accountInfo', updatedAccountInfoString);

                    _updateMenuItems();

                });

                var _updateMenuItems = function () {

                    var accountInfoString = $window.sessionStorage.getItem('accountInfo');
                    var accountInfo = JSON.parse(accountInfoString);

                    var viewMode = $rootScope.mobileApp === true ? 4 : $rootScope.mobile === true
                        ? 3 : $rootScope.classicView === true ? 2 : 1;

                    var url = HOST + "/api/Menu?userId=" + scope.accountInfo.userId + "&customerId=" + scope.accountInfo.customerId + "&viewMode=" + viewMode;

                    scope.loadMenu = null;

                    $http.get(url).then(function (result) {
                        scope.accountInfo.menuItems = result.data;
                        accountInfo.menuItems = result.data;
                        var updatedAccountInfoString = JSON.stringify(accountInfo);
                        $window.sessionStorage.setItem('accountInfo', updatedAccountInfoString);
                        scope.loadMenu = true;
                        initializeMenu();

                    }, function (error) {
                        console.log(error);
                        scope.loadMenu = true;
                        initializeMenu();
                    });
                };
                
                scope.$on('updatePreferencesLanguage', function (event, args) {
                    scope.translation = args;
                    scope.loadMenu = null;
                    $timeout(function () {
                        scope.loadMenu = true;
                        initializeMenu();
                    }, 0);
                });
                
                scope.$on(
                    "$destroy",
                    function (event) {
                        $document.off(tmpEventname);
                    }
                );

            }
        };
    }]);

mcapp.controller('mainMenuMobileController', ['$scope', 'sharedSetupService', 'deviceMenuService', '$rootScope', 'deviceService', '$filter', 'nativeBridge',
    function ($scope, sharedSetupService, deviceMenuService, $rootScope, deviceService, $filter, nativeBridge) {
        //
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;

        $scope.mobileAppFindDeviceBySn = function (barCode) {
            if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }
            var _device = null;
            deviceMenuService.getDeviceMenuList($scope.accountInfo.customerId)
                .then(function (result) {
                    for (var index = 0; index < result.data.devices.length; ++index) {
                        if (result.data.devices[index].serialNumber === barCode.text) {
                            $scope.mobileAppDeviceName = result.data.devices[index].name;
                            _device = { deviceName: $scope.mobileAppDeviceName };
                            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: result.data.devices[index].deviceId, device: _device, windowId: $scope.windowId });
                            $scope.mobileAppFoundDevice();
                            break;
                        }
                    }
                    if (_device === null) $scope.mobileAppSomethingWentWrong("No match!");
                }, function (error) {
                    $scope.mobileAppSomethingWentWrong("Error!");
                });
        };


        $scope.dismissedFalse = function () {
            // do something
        }

        $scope.dismissedFoundDevice = function (buttonIndex) {
            var origin = location.origin;
            var path = location.pathname;
            var queryString = $rootScope.mobileApp ? "?" + location.href.split("?")[1] : "";
            var angJs = "#!/";
            var tmpPage = "pleasewait/please-wait";
            var newPage;

            switch (buttonIndex) {
                case 2:
                    newPage = "rtuview/rtu-view";
                    break;
                case 1:
                    newPage = "rtuinfo/rtu-info";
                    break;
                case 3:
                    newPage = "rtuconfiguration/rtu-configuration";
                    break;
                default:
                    newPage = "rtuview/rtu-view";
            }

            location.replace(origin + path + angJs + tmpPage + queryString);
            location.replace(origin + path + angJs + newPage + queryString);
        }

        $scope.mobileAppFoundDevice = function () {
            nativeBridge.beep(1);
            // Three choices, so nativeBridge routes this to the native action
            // sheet - Capacitor's Dialog.confirm only supports two buttons and
            // would silently drop "Config". The resolved index keeps Cordova's
            // 1-based convention, so dismissedFoundDevice is unchanged.
            // The old "display order is off" quirk was a Cordova-on-Android
            // artefact; the action sheet renders these in the order given.
            nativeBridge.confirm(
                'Customer: ' + $scope.accountInfo.customerName + '\n' +
                'Device: ' + $scope.mobileAppDeviceName,  // message
                'We have found your device!',// title
                ['» Info', '» Data', '» Config']     // buttonLabels
            ).then($scope.dismissedFoundDevice);
        };

        $scope.mobileAppSomethingWentWrong = function (varTitle) {
            //SpinnerDialog.hide();
            nativeBridge.beep(1);
            nativeBridge.alert(
                'oops! something went wrong', // message
                varTitle,            // title
                'ok'                  // buttonName
            ).then($scope.dismissedFalse);
        };

        $scope.dismissedWorkInProgress = function () {
            nativeBridge.beep(1);
            nativeBridge.alert(
                'oops! we are still working on this feature', // message
                'Work in Progress!',            // title
                'ok'                  // buttonName
            ).then($scope.dismissedFalse);
        };

        $scope.mobileAppSetLocation = function (barCode) {

            var geolocationOnSuccess = function (position) {

                //SpinnerDialog.show();

                var dismissedGeolocationOnSuccess = function (buttonIndex) {
                    //var origin = location.origin;
                    //var path = location.pathname;
                    //var queryString = $rootScope.mobileApp ? "?" + location.href.split("?")[1] : "";
                    //var angJs = "#!/";
                    //var tmpPage = "pleasewait/please-wait";
                    //var newPage = "rtuinfo/rtu-info";

                    switch (buttonIndex) {
                        case 1:
                            $scope.updateRtuLocation(position.coords.latitude, position.coords.longitude, barCode.text);
                            break;
                        default:
                            //SpinnerDialog.hide();
                            break;
                            //location.replace(origin + path + angJs + tmpPage + queryString);
                            //location.replace(origin + path + angJs + newPage + queryString);
                            break;
                    }

                }

                nativeBridge.beep(1);
                // Two choices, so this maps straight onto Dialog.confirm.
                nativeBridge.confirm(
                    'Latitude: ' + position.coords.latitude + '\n' +
                    'Longitude: ' + position.coords.longitude + '\n' +
                    'Altitude: ' + position.coords.altitude + '\n' +
                    'Accuracy: ' + position.coords.accuracy + '\n',  // message
                    //'Altitude Accuracy: ' + position.coords.altitudeAccuracy + '\n' +
                    //'Heading: ' + position.coords.heading + '\n' +
                    //'Speed: ' + position.coords.speed + '\n' +
                    //'Timestamp: ' + position.timestamp + '\n',  // message
                    'Update RTU location!',// title
                    ['» Yes', '» No']     // buttonLabels
                ).then(dismissedGeolocationOnSuccess);
            };

            // onError Callback receives a PositionError object
            //
            var geolocationOnError = function (error) {
                $scope.mobileAppSomethingWentWrong("Your location!");
            }

            navigator.geolocation.getCurrentPosition(geolocationOnSuccess, geolocationOnError, { enableHighAccuracy: true });

        };

        $scope.updateRtuLocation = function (latitude, longitude, serialNumber) {
            if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }
            var _device = null;
            deviceMenuService.getDeviceMenuList($scope.accountInfo.customerId)
                .then(function (result) {
                    for (var index = 0; index < result.data.devices.length; ++index) {
                        if (result.data.devices[index].serialNumber === serialNumber) {
                            $scope.mobileAppDeviceName = result.data.devices[index].name;
                            _device = { deviceName: $scope.mobileAppDeviceName, channel: 1 };
                            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: result.data.devices[index].deviceId, device: _device, windowId: $scope.windowId });

                            var latitudePatch = { op: 'replace', path: 'latitude', value: $filter('number')(latitude, 7) * 1 };
                            deviceService.patchDevice(result.data.devices[index].deviceId, $scope.accountInfo.customerId, latitudePatch).then(function (resp) {
                                //console.log(latitude);
                            }, function (resp) {
                                console.log(resp);
                            });


                            var longitudePatch = { op: 'replace', path: 'longitude', value: longitude * 1 };
                            deviceService.patchDevice(result.data.devices[index].deviceId, $scope.accountInfo.customerId, longitudePatch).then(function (resp) {
                                //console.log(longitude);
                            }, function (resp) {
                                console.log(resp);
                            });

                            var origin = location.origin;
                            var path = location.pathname;
                            var queryString = $rootScope.mobileApp ? "?" + location.href.split("?")[1] : "";
                            var angJs = "#!/";
                            var tmpPage = "pleasewait/please-wait";
                            var newPage = "rtuinfo/rtu-info";

                            location.replace(origin + path + angJs + tmpPage + queryString);
                            location.replace(origin + path + angJs + newPage + queryString);
                            //SpinnerDialog.hide();
                            break;
                        }
                    }
                    if (_device === null) $scope.mobileAppSomethingWentWrong("No match!");
                }, function (error) {
                    $scope.mobileAppSomethingWentWrong("Error!");
                });
        };

        //

    }]);

mcapp.directive('mainMenuMobile', ['$cookies', '$rootScope', '$location', 'authenticationService', 'translationService', 'websocketService', 'modalService', '$http', '$window', '$timeout', 'sharedSetupService', 'locationFactory', 'accountWorkflowService', 'openViewService', 'desktopViewService', 'LoginsFactory', 'importantInformationModalService',
    function ($cookies, $rootScope, $location, authenticationService, translationService, websocketService, modalService, $http, $window, $timeout, sharedSetupService, locationFactory, accountWorkflowService, openViewService, desktopViewService, LoginsFactory, importantInformationModalService) {
        return {
            restrict: 'E',
            transclude: false,
            replace: true,
            templateUrl: 'ui/components/directives/menu/main-menu-mobile.html',
            link: function (scope, element, attrs) {

                var firstRun = true;
                scope.imageHeight = 0;
                var DAYSPASTDUETIMER = 86400 * 1000; //10 seconds: 10 * 1000; One day: 86400 * 1000

                //scope.devOrQa = ($location.host().startsWith("localhost") || $location.host().startsWith("dev.123scada.com") ||  $location.host().startsWith("qa.123scada.com"));

                $timeout(function () {
                    if (document.getElementById('menu-image')) {
                        scope.imageHeight = document.getElementById('menu-image').clientHeight;
                    };
                }, 1000);

                scope.$on('switchedCustomers', function () {
                    if (document.getElementById('menu-image')) {
                        scope.imageHeight = document.getElementById('menu-image').clientHeight;
                    };
                    scope.accountInfo = authenticationService.getAccountInfo();
                });

                //$http.get('https://api.vimeo.com/channels/1253760/videos', { headers: { 'Authorization': 'Bearer de80698101d0919a68ba258bebee8099', 'Accept': 'application/vnd.vimeo.*+json;version=3.2' } }).then(function (resp) {
                //  scope.videos = resp.data.data;
                //});

                scope.openVideo = function (link) {
                    var id = link.substring(link.lastIndexOf('/') + 1);
                    modalService.displayVideo(id);
                };

                scope.checkVideos = function () {
                    //$http.get('https://api.vimeo.com/channels/1253760/videos', { headers: { 'Authorization': 'Bearer de80698101d0919a68ba258bebee8099', 'Accept': 'application/vnd.vimeo.*+json;version=3.2' } }).then(function (resp) {
                    //  scope.videos = resp.data.data;
                    //});
                };

                scope.getMenuOffset = function () {
                    if ($window.innerWidth < 658) {
                        return 85;
                    } else if ($window.innerWidth <= 800) {
                        return 125;
                    } else {
                        return 314;//165
                    }
                }

                scope.setMenuHeight = function () {
                    return 'calc(100% - ' + scope.getMenuOffset() + 'px)';
                };

                scope.mainMenuHeight = scope.setMenuHeight();
                scope.menuImageTop = 'calc(100% - ' + (scope.getMenuOffset() - 4) + 'px)';

                scope.isFF = !!navigator.userAgent.match(/firefox/i);

                scope.hasOverflow = function () {
                    var element = document.getElementById('nav-menu-mobile');
                    if (element.offsetHeight < element.scrollHeight) {
                        return true;
                    }
                    return false;
                }

                scope.isSmallScreen = function () {
                    if ($window.innerWidth <= 800) {
                        return true;
                    }

                    return false;
                }

                scope.menuHasOverflow = scope.hasOverflow();
                scope.menuSmallScreen = scope.isSmallScreen();

                scope.refreshMobiMenuData = function () {
                    $rootScope.CustomerNameStart = null;
                    $rootScope.CustomerNameStart = scope.accountInfo ? scope.accountInfo.customerName : null;
                };

                scope.$on('refreshMobiMenuItems', function () {
                    scope.refreshMobiMenuData();
                });

                scope.startTimeout = function () {
                    scope.myTimeout = $timeout(function () {

                        importantInformationModalService.importantInformation(scope, false).then(function () {
                            //                   
                        },
                            function (error) {
                                //                      
                            });

                    }, DAYSPASTDUETIMER);
                }

                scope.stopTimeout = function () {
                    if (!angular.isUndefined(scope.myTimeout)) $timeout.cancel(scope.myTimeout);
                    scope.myTimeout = undefined; // Clear $scope.myTimeout reference
                }

                scope.$on("$destroy", function () {
                    scope.stopTimeout();
                });

                scope.accountInfo = authenticationService.getAccountInfo();
                $rootScope.CustomerNameStart = scope.accountInfo ? scope.accountInfo.customerName : null;
                scope.$watch('CustomerNameStart', function (newValue, oldValue) {
                    if (newValue) {
                        translationService.loadLanguage(true)
                            .then(function (result) {
                                scope.accountInfo = authenticationService.getAccountInfo();
                                scope.translation = translationService.translation;
                                scope.reportAccess = false;
                                scope.isAdmin = false;
                                //scope.isAlarmUser = false; //able to acknowledge alarms on dashboard
                                scope.isUser = false; // ReadOnly user
                                //scope.isDemoUser = false; //able to access Live Demo of Tank & Well system at Front office, in-addition to Public User
                                scope.isPublicUser = false;
                                scope.isMcAdmin = $cookies.get('AdminInfo') != null ? true : false;
                                scope.intTry = 15;
                                scope.countdown = function myhandler() {
                                    if (scope.accountInfo != null && typeof scope.accountInfo != "undefined") {
                                        scope.portal = scope.accountInfo.portal;;
                                        scope.adminPortal = scope.accountInfo.preferenceUser.adminPortal;
                                        scope.initializeMenu();

                                        scope.stopTimeout();
                                        if ($rootScope.mobile && !angular.isUndefined(scope.accountInfo) && scope.accountInfo.daysPastDue > 0)
                                            scope.startTimeout();

                                        return;
                                    }
                                    else { scope.accountInfo = authenticationService.getAccountInfo(); }
                                    if (scope.intTry === 0) { return; }
                                    else { scope.intTry--; }
                                    $timeout(myhandler, 300);
                                }
                                scope.countdown();
                            });
                    }
                }, true);

                scope.adminUser = $cookies.get('AdminUser1') != null ? true : false;

                scope.initializeMenu = function () {

                    if (!sharedSetupService.adminPortal() && !sharedSetupService.securityPortal()) $timeout(function () { //only if regular user - no portals
                        if (scope.accountInfo.userType !== "TechSupport" && scope.accountInfo.userType !== "RSM") {
                            //launch update username & password etc views
                            accountWorkflowService.init(); //initialize the account workflow service
                            accountWorkflowService.launchView();
                        }
                    }, 0);


                    $timeout(function () {
                        ///////////////////////////////////////////////////////////////////////////////////
                        ///////////////////////////////////////////////////////////////////////////////////
                        switch (scope.accountInfo.userRole) {
                            case "Administrator":
                                scope.reportAccess = true;
                                scope.isAdmin = true;
                                break;
                            case "SuperAdministrator":
                                scope.reportAccess = true;
                                scope.isAdmin = true;
                                scope.isSuperAdmin = true;
                                break;
                            //case "AlarmUser": //Able to Acknowledge Alarms on Dashboard
                            //    scope.isAlarmUser = true;
                            //    break;
                            case "User": //ReadOnly
                                scope.isUser = true;
                                break;
                            //case "DemoUser": //Able to view Live Demo of Tank & Well System on front office
                            //    scope.isDemoUser = true;
                            //    break;
                            case "PublicUser":
                                scope.isPublicUser = true;
                                break;
                            default:
                                scope.isPublicUser = true;
                        }

                        switch (scope.accountInfo.customerId) {
                            case 597:
                            case 15177:
                            case 15147:
                                scope.bulkWaterManagementAccess = true;
                                break;
                            default:
                                scope.bulkWaterManagementAccess = false;
                        }

                        scope.initMenu();

                        scope.selectCopy = ($("body").css("-moz-user-select") === "text" ||
                            $("body").css("-khtml-user-select") === "text" ||
                            $("body").css("-webkit-user-select") === "text" ||
                            $("body").css("-ms-user-select") === "text" ||
                            $("body").css("user-select") === "text")
                            ? true
                            : false;
                        ///////////////////////////////////////////////////////////////////////////////////
                        ///////////////////////////////////////////////////////////////////////////////////
                    }, 0);
                };

                scope.initMenu = function () {
                    document.querySelector("meta[name=viewport]").setAttribute('content', 'width=device-width, height=device-height, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no');
                    var _theMenuDIv = $(element).find('ul'); //$('#menu-mobile')
                    if (!firstRun) _theMenuDIv.menu("destroy");
                    //if (_theMenuDIv.hasClass("ui-menu")) return; //menu is available
                    $timeout(function () {
                        _theMenuDIv.menu();

                        _theMenuDIv.unbind('mouseenter mouseleave');
                        _theMenuDIv.find('li.li-menu_sub').css({ cursor: "pointer" }).on('click', function (event) {
                            event.stopPropagation();
                            event.preventDefault();
                            scope.$emit('mobile-menu_click', { message: 'li-menu_sub' });
                            if (!$rootScope.classicView) $('#menu-mobile li.li-menu_sub').not(this).find('ul').hide("fast");
                            $(this).find('ul').css('top', '-1px').css('left', _theMenuDIv.css("width").replace(/[^0-9.]+/g, "") - 2).toggle("fast");
                        });

                        if (firstRun) {

                            $("#start-button-mobile, #menu-mobile, .start-button-classicView").click(function () {
                                if ($rootScope.mobile || $(".start-button-classicView").is(":visible")) $("#nav-menu-mobile").toggle("slide", { direction: 'right' }, "fast");
                            });

                            $("#desktopicons").click(function () {
                                $("#nav-menu-mobile").hide("fast");
                            });
                        }
                        firstRun = false;

                        _theMenuDIv.find('li.list-view-header').css({ cursor: "pointer" }).on('click', function (event) {
                            event.stopPropagation();
                            event.preventDefault();
                            scope.$emit('mobile-menu_click', { message: 'list-view-header' });
                            var _this = $(this);

                            if (event.target.className.includes('videos') === 23) {
                                //$http.get('https://api.vimeo.com/channels/1253760/videos', { headers: { 'Authorization': 'Bearer de80698101d0919a68ba258bebee8099', 'Accept': 'application/vnd.vimeo.*+json;version=3.2' } }).then(function (resp) {
                                //  scope.videos = resp.data.data;

                                //  $timeout(function () {
                                //    $(_this).nextAll("." + $(_this).attr("tag")).toggle("blind", "fast", callback);

                                //    function callback() {
                                //      if (_this.next("." + _this.attr("tag")).is(":visible")) {
                                //        _this.find(".fa-chevron-down").removeClass("fa-chevron-down").addClass("fa-chevron-up");
                                //      } else {
                                //        _this.find(".fa-chevron-up").removeClass("fa-chevron-up").addClass("fa-chevron-down");
                                //      }
                                //    };
                                //  });

                                //});
                            } else {
                                $(this).nextAll("." + $(this).attr("tag")).toggle("blind", "fast", callback);

                                function callback() {
                                    if (_this.next("." + _this.attr("tag")).is(":visible")) {
                                        _this.find(".fa-chevron-down").removeClass("fa-chevron-down").addClass("fa-chevron-up");
                                    } else {
                                        _this.find(".fa-chevron-up").removeClass("fa-chevron-up").addClass("fa-chevron-down");
                                    }
                                };
                            }
                        });

                    }, 0);
                };

                scope.clickHandler = function (menu) {
                    eval('scope.' + menu.clickFunction);
                };

                scope.getIcon = function (varTitle, varMode) {
                    return openViewService.getIcon(varTitle, varMode);
                };
                scope.mobileMenuOption = function (varUrl) {
                    $location.path(varUrl);
                };
                scope.goToHomePage = function () {
                    var tmpHome = "/";
                    scope.mobileMenuOption(tmpHome);
                };
                // For feedback display
                scope.openFeedback = function () {
                    $timeout(function () {
                        $("#send-feedback-button").trigger("click");
                    }, 0);
                };

                scope.getPortalPath = function () {
                    var userTypeParms = !angular.isUndefined(scope.accountInfo) ? sharedSetupService.getUserTypeParms(scope.accountInfo.portal, scope.accountInfo.preferenceUser.adminPortal) : null;
                    if (userTypeParms !== null && userTypeParms.name.length > 0) {
                        scope.portalName = userTypeParms.name;
                        scope.portalPath = userTypeParms.path;
                        scope.portalOptions = true;
                    }
                };

                scope.goToPortal = function () {
                    scope.getPortalPath();
                    websocketService.close();
                    $rootScope.CustomerNameStart = "";
                    $location.path(scope.portalPath);
                };

                scope.openHelpPanel = function () {
                    openViewService.openHelpPanel("Documentation");
                };

                scope.openNotification = function (menuOption) {
                    scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
                    menuOption = menuOption === "Rules" ? '/notificationrules/notification-rules' : '/manageschedule/manage-schedule';
                    if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }
                    if (scope.accountInfo.dispatcherVersion === 1) {
                        scope.stickyProperties.deviceId = menuOption === "/notificationrules/notification-rules" ? 1 : 2;
                        $location.path("/notification/migratenotification/migrate-notification");
                        return;
                    }

                    $location.path("/notification" + menuOption);
                };

                scope.toogleSelectCopy = function (menuOtion) {
                    scope.selectCopy = !scope.selectCopy;
                    if (scope.selectCopy) {
                        $("body").css("-moz-user-select", "text").css("-khtml-user-select", "text").css("-webkit-user-select", "text").css("-ms-user-select", "text").css("user-select", "text");
                    } else {
                        $("body").css("-moz-user-select", "-moz-none").css("-khtml-user-select", "none").css("-webkit-user-select", "none").css("-ms-user-select", "none").css("user-select", "none");
                    }

                };

                scope.logout = function () {
                    scope.stopTimeout();
                    websocketService.close();
                    $rootScope.CustomerNameStart = "";
                    scope.accountInfo = null;
                    $rootScope.login = false;
                    $rootScope.classicView = false;
                    $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
                    $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
                    $rootScope.logoSizeId = $rootScope.defaultFontAndColorId;
                    $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
                    if ($rootScope.mobileApp) locationFactory.mobileAppClearShareMyLocation();
                    authenticationService.logout()
                        .then(function (result) {
                            $location.path(result.loginPath);
                        }, function (error) {
                            $window.alert("logout error");
                            console.log(error);
                        });
                };

                scope.redirectToLegacySite = function () {
                    //notify mc.services to create record with sessionid
                    //collect the sessionID returned from mc.services
                    //build url for LegacySite
                    //append url with sessionID
                    //then change the location to new url

                    //for Mobile users (NOT Mobile APP), help them to navigate to old MOBI site 
                    if ($rootScope.mobile) $window.location.href = "https://www.123mc.com/123mc/log_in.asp";

                    var _loginsService = new LoginsFactory(scope.accountInfo.customerId);
                    _loginsService.redirectToLegacySite(scope.accountInfo.userId).then(
                        function (success) {
                            var slstObj = success.data; //scadaLegacySessionTransfer object
                            //console.log(success.data);
                            var legacyUrl = slstObj.legacySiteUrl + "?s=" + slstObj.sessionID; // TODO: update this with correct Url later
                            $window.location.href = legacyUrl;
                        },
                        function (failure) {
                            console.log(failure.data);
                        }
                    );
                };

                scope.updatePasswordView = function () {
                    if (scope.accountInfo.mfaMigrationStatus >= 1) {
                        var currentPath = $location.path();
                        $rootScope.classicView = false;
                        sharedSetupService.isFromUpdatePassword = true;
                        sharedSetupService.currentUrl = currentPath;
                        $location.path('/security/portal');
                    }
                    else {
                        if (!$rootScope.mobile && !$rootScope.classicView) {
                            openViewService.openView('Update Password', { width: 700, height: 280 }, { my: 'top+120', at: 'center top', of: undefined }, undefined, { minimumWidth: 700, minimumHeight: 280 }, undefined);
                        }
                        else {
                            $location.path('/account/password/update-password-template');
                        }
                    }
                }

                scope.$on('mobileLogout', function (event, args) {
                    scope.logout();
                });

                scope.$on('windowDimensions', function (event, args) {
                    if (args.windowWidth > 800) {
                        $("#nav-menu-mobile").show("fast");
                        if (scope.imageHeight === 0 && document.getElementById('menu-image')) {
                            scope.imageHeight = document.getElementById('menu-image').clientHeight;
                        };
                    } else {
                        scope.imageHeight = 0;
                    }

                    scope.mainMenuHeight = scope.setMenuHeight();
                    scope.menuImageTop = 'calc(100% - ' + (scope.getMenuOffset() - 4) + 'px)';
                    scope.menuHasOverflow = scope.hasOverflow();
                    scope.menuSmallScreen = scope.isSmallScreen();

                });

                $rootScope.fullScreenModeAvailable = undefined;

                scope.toggleFullScreen = function () {

                    var doc = window.document;
                    var docEl = doc.documentElement;

                    var requestFullScreen = scope.ifFullScreenAvailable(docEl);
                    var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

                    if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                        requestFullScreen.call(docEl);
                        scope.fullScreenMode = true;
                    } else {
                        cancelFullScreen.call(doc);
                        scope.fullScreenMode = false;
                    }
                };

                scope.ifFullScreenAvailable = function (docEl) {
                    return docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
                };

                if (typeof $rootScope.fullScreenModeAvailable === "undefined") {
                    $rootScope.fullScreenModeAvailable = scope.ifFullScreenAvailable(window.document.documentElement) ? true : false;
                }

                if ($rootScope.classicView) $("#nav-menu-mobile").show("fast");
            }
        };
    }]);
mcapp.controller('fontColorMenuController', ['$scope', function ($scope) {
    //$scope.liveData = false;
}]);

mcapp.directive('fontColorMenu', ['$cookies', function ($cookies) {
    return {
        restrict: 'E',
        transclude: false,
        replace: true,
        templateUrl: 'ui/components/directives/menu/font-color-menu.html',
        link: function (scope, element, attrs) {
            if (scope.accountInfo.userRole == 'Administrator' || scope.accountInfo.userRole == 'SuperAdministrator') {
                scope.isAdmin = true;
            }
            setTimeout(function () {
                $("#menu-font-color").menu();
                $("#font-color-button").click(function () {
                    $("#nav-menu").hide("fast");
                    $("#font-color-menu").toggle("fast");
                });                
            }, 1000);
        }
    };
}]);
mcapp.controller('additionalMenuAController', ['$scope', function ($scope) {
    //$scope.liveData = false;
}]);

mcapp.directive('additionalMenuA', ['$rootScope', 'websocketService', 'authenticationService', '$location', function ($rootScope, websocketService, authenticationService, $location) {
    return {
        restrict: 'E',
        transclude: false,
        replace: true,
        templateUrl: 'ui/components/directives/menu/additional-menu-a.html',
        link: function (scope, element, attrs) {
            scope.logout = function () {
                websocketService.close();
                $rootScope.CustomerNameStart = "";
                scope.accountInfo = null;
                $rootScope.login = false;
                $rootScope.classicView = false;
                $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
                $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
                $rootScope.logoSizeId = $rootScope.defaultFontAndColorId;
                $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
                authenticationService.logout()
                    .then(function (result) {
                        $location.path("/account/userlogin");
                    }, function (error) {
                        $window.alert("logout error");
                        console.log(error);
                    });
            };
        }
    };
}]);

mcapp.controller('additionalMenuBController', ['$scope', function ($scope) {
    //$scope.liveData = false;
}]);

mcapp.directive('additionalMenuB', ['$rootScope', 'websocketService', 'authenticationService', '$location', 'CustomerListFactory', 'ApplicationPortalFactory', function ($rootScope, websocketService, authenticationService, $location, CustomerListFactory, ApplicationPortalFactory) {
    return {
        restrict: 'E',
        transclude: false,
        replace: true,
        templateUrl: 'ui/components/directives/menu/additional-menu-b.html',
        link: function (scope, element, attrs) {

            var _initializeManagedSites = function () {
                scope.managedSites = null;

                scope.accountInfo = authenticationService.getAccountInfo();


                if (scope.accountInfo.portal) {
                    var _customerList = new CustomerListFactory();

                    _customerList.getData(true).then(function () {
                        var _managedSites = _customerList.data.customers;
                        scope.managedSites = _managedSites.filter(function (item) {
                            return item.customerId != scope.accountInfo.customerId;
                        });

                    });
                }
            };

            scope.selectCustomer = function (customer, busyLoading) {
                var _applicationPortal = new ApplicationPortalFactory(customer.customerId);
                _applicationPortal.switchCustomer(customer, busyLoading);
            };

            scope.toggleManagedSites = function ($event) {
                var _managedSitesDropdownContent = $(element).find('.managed-sites-dropdown-content.li_first');
                if (_managedSitesDropdownContent.is(":visible")) {
                    _managedSitesDropdownContent.hide();
                } else {
                    _managedSitesDropdownContent.show();
                }
                $event.stopPropagation();
            };

            scope.$watch('CustomerNameStart', function (newValue, oldValue) {
                if (newValue) {
                    _initializeManagedSites();
                }
            }, true);

            scope.logout = function () {
                websocketService.close();
                $rootScope.CustomerNameStart = "";
                scope.accountInfo = null;
                $rootScope.login = false;
                $rootScope.classicView = false;
                $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
                $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
                $rootScope.logoSizeId = $rootScope.defaultFontAndColorId;
                $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
                authenticationService.logout()
                    .then(function (result) {
                        $location.path("/account/userlogin");
                    }, function (error) {
                        $window.alert("logout error");
                        console.log(error);
                    });
            };

            var _onDocumentClick = $rootScope.$on('document_click', function (event, args) {
                $(element).find('.managed-sites-dropdown-content.li_first').hide();
            });

            var _onMobileMenuClick = scope.$on('mobile-menu_click', function (event, args) {
                $(element).find('.managed-sites-dropdown-content.li_first').hide();
            });

            scope.$on("$destroy", function(){
                _onDocumentClick();
                _onMobileMenuClick();
                console.log("$destroy: _onDocumentClick()");
            });
        }
    };
}]);

mcapp.directive('additionalMenuC', ['$cookies', '$rootScope', '$location', 'authenticationService', 'translationService', 'websocketService', '$window', '$timeout', function ($cookies, $rootScope, $location, authenticationService, translationService, websocketService, $window, $timeout) {
    return {
        restrict: 'E',
        transclude: false,
        replace: true,
        templateUrl: 'ui/components/directives/menu/additional-menu-c.html',
        link: function (scope, element, attrs) {

            scope.accountInfo = authenticationService.getAccountInfo();
            $rootScope.CustomerNameStart = scope.accountInfo ? scope.accountInfo.customerName : null;
            scope.$watch('CustomerNameStart', function (newValue, oldValue) {
                if (newValue) {
                    translationService.loadLanguage(true)
                    .then(function (result) {
                        scope.translation = translationService.translation;
                    });
                }
            }, true);

            scope.mobileMenuOption = function (varUrl) {
                $location.path(varUrl);
            };
                 scope.openFeedback = function () {
             console.log('still hear');
          }


            scope.logout = function () {
                websocketService.close();
                $rootScope.CustomerNameStart = "";
                scope.accountInfo = null;
                $rootScope.login = false;
                $rootScope.classicView = false;
                $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
                $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
                $rootScope.logoSizeId = $rootScope.defaultFontAndColorId;
                $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
                authenticationService.logout()
                    .then(function (result) {
                        $location.path("/account/userlogin");
                    }, function (error) {
                        $window.alert("logout error");
                        console.log(error);
                    });
            };
        }
    };
}]);
mcapp.directive('viewList', ['$rootScope', 'authenticationService', 'translationService', 'openViewService', 'deviceMenuService', '$cookies', '$location', '$timeout', function ($rootScope, authenticationService, translationService, openViewService, deviceMenuService, $cookies, $location, $timeout) {
    return {
        //comments test
        restrict: 'E',
        transclude: true,
        replace: true, 
        templateUrl: 'ui/components/directives/viewselection/view-selection.html',
        link: function (scope, element, attrs) {
            var _checkSolar = 0, _checkPulseFlow = 0;

            scope.showViews = false;
            scope.isSupergraph = false;
            scope.isSupergraph = attrs.isSupergraph;
            scope.translation = translationService.translation;
            scope.isMcAdmin = $cookies.get('AdminInfo') != null ? true : false;
            scope.viewList = function () {
                scope.views = [ 
                    {
                        "master": "ANALOG", "id": "Analog Chart", "name": scope.translation.text.ANALOG_CHART, "url": "/analog/analog-chart", "mobile": "true", "detail": [
                            { "id": "Mc Analog Gauge", "name": scope.translation.text.ANALOG_GAUGE, "icon": "fa-tachometer", "url": "", "mobile": "false" },
                            { "id": "Analog Chart Recorder", "name": scope.translation.text.ANALOG_CHART_RECORDER, "icon": "fa-bullseye", "url": "/analog/chartrecorder/analog-chart-recorder-view", "mobile": "true" },
                            { "id": "Analog Chart", "name": scope.translation.text.ANALOG_CHART, "icon": "fa-line-chart", "url": "/analog/analog-chart", "mobile": "true" },
                            { "id": "Analog Table", "name": scope.translation.text.ANALOG_TABLE, "icon": "fa-table", "url": "/analog/analog-table", "mobile": "true" },
                            { "id": "Analog Gauge", "name": scope.translation.text.ANALOG_GAUGE, "icon": "fa-tachometer", "url": "/analog/analog-chart", "mobile": "false" }
                        ]
                    },
                    {
                        "master": "ANALOG_OUTPUT", "id": "Analog Output Chart", "name": scope.translation.text.ANALOG_OUTPUT_CHART, "url": "/analogoutput/analog-output-chart", "mobile": "true", "detail": [                            
                            { "id": "Mc Analog Output Gauge", "name": scope.translation.text.ANALOG_OUTPUT_GAUGE, "icon": "fa-tachometer", "url": "", "mobile": "false" },
                            { "id": "Analog Output Chart", "name": scope.translation.text.ANALOG_OUTPUT_CHART, "icon": "fa-line-chart", "url": "/analogoutput/analog-output-chart", "mobile": "true" },
                            { "id": "Analog Output Table", "name": scope.translation.text.ANALOG_OUTPUT_TABLE, "icon": "fa-table", "url": "/analogoutput/analog-output-table", "mobile": "true" },                            
                            { "id": "Analog Output Gauge", "name": scope.translation.text.ANALOG_OUTPUT_GAUGE, "icon": "fa-tachometer", "url": "/analogoutput/analog-output-gauge", "mobile": "false" }
                        ]
                    },
                    {
                        "master": "DIGITAL", "id": "Digital Chart", "name": scope.translation.text.DIGITAL_CHART, "url": "/digital/digital-chart", "mobile": "true", "detail": [
                            { "id": "", "name": "", "icon": "", "url": "", "mobile": "false" },
                            { "id": "", "name": "", "icon": "", "url": "", "mobile": "false" },
                            { "id": "Digital Chart", "name": scope.translation.text.DIGITAL_CHART, "icon": "fa-line-chart", "url": "/digital/digital-chart", "mobile": "true" },
                            { "id": "Digital Table", "name": scope.translation.text.DIGITAL_TABLE, "icon": "fa-table", "url": "/digital/digital-table", "mobile": "true" },
                            { "id": "Mc Digital Gauge", "name": scope.translation.text.DIGITAL_GAUGE, "icon": "fa-tachometer", "url": "", "mobile": "false" }
                        ]
                    },
                    {
                        "master": "PUMP", "id": "Pump Chart", "name": scope.translation.text.PUMP_CHART, "url": "/pump/pump-chart", "mobile": "true", "detail": [
                            { "id": "", "name": "", "icon": "", "url": "", "mobile": "false" },
                            { "id": "Pump Peak Flow Capacity Estimator", "name": scope.translation.text.PUMP_PEAK_FLOW_CAPACITY_ESTIMATOR, "icon": "fa-calculator", "url": "/pump/capacityestimator/pump-capacity-estimator-view", "mobile": "true" },
                            { "id": "Pump Chart", "name": scope.translation.text.PUMP_CHART, "icon": "fa-line-chart", "url": "/pump/pump-chart", "mobile": "true" },
                            { "id": "Pump Table", "name": scope.translation.text.PUMP_TABLE, "icon": "fa-table", "url": "/pump/pump-table", "mobile": "true" },
                            { "id": "Mc Pump Gauge View", "name": scope.translation.text.MC_PUMP_GAUGE, "icon": "fa-tachometer", "url": "", "mobile": "false" }
                        ]
                    },
                    // {
                    //     "master": "SOLAR", "id": "Solar Chart", "name": scope.translation.text.SOLAR_CHART, "url": "/solar/solar-chart", "mobile": "true", "detail": [
                    //         { "id": "Solar Chart", "name": scope.translation.text.SOLAR_CHART, "icon": "fa-line-chart", "url": "/solar/solar-chart", "mobile": "true" },
                    //         { "id": "Solar Table", "name": scope.translation.text.SOLAR_TABLE, "icon": "fa-table", "url": "/solar/solar-chart", "mobile": "true" },
                    //         { "id": "", "name": "", "icon": "", "url": "", "mobile": "false" }
                    //     ]
                    // },
                    {
                        "master": "PULSE_FLOW", "id": "Pulse Flow Chart", "name": scope.translation.text.PULSE_FLOW_CHART, "url": "/pulseflow/chart/pulseflow-chart-template", "mobile": "true", "detail": [
                            { "id": "Pulse Flow Calendar", "name": scope.translation.text.PULSE_FLOW_CALENDAR, "icon": "fa-calendar-o", "url": "/pulseflow/calendar/pulseflow-calendar-template", "mobile": "true" },
                            { "id": "Pulse Flow Chart", "name": scope.translation.text.PULSE_FLOW_CHART, "icon": "fa-line-chart", "url": "/pulseflow/chart/pulseflow-chart-template", "mobile": "true" },
                            { "id": "Pulse Flow Table", "name": scope.translation.text.PULSE_FLOW_TABLE, "icon": "fa-table", "url": "/pulseflow/table/pulseflow-table-template", "mobile": "true" },
                            { "id": "Pulse Flow Gauge", "name": scope.translation.text.PULSE_FLOW_GAUGE, "icon": "fa-tachometer", "url": "", "mobile": "false" }
                        ]
                    },
                    {
                        "master": "HUMIDITY", "id": "Humidity Chart", "name": scope.translation.text.HUMIDITY_CHART, "url": "/humidity/chart/humidity-chart", "mobile": "true", "detail": [
                            { "id": "Humidity Chart", "name": scope.translation.text.HUMIDITY_CHART, "icon": "fa-line-chart", "url": "/humidity/chart/humidity-chart-view", "mobile": "true" },
                            { "id": "Humidity Table", "name": scope.translation.text.HUMIDITY_TABLE, "icon": "fa-table", "url": "/humidity/table/humidity-table-view", "mobile": "true" },
                            { "id": "Humidity Gauge", "name": scope.translation.text.HUMIDITY_GAUGE, "icon": "fa-tachometer", "url": "/humidity/gauge/humidity-gauge-view", "mobile": "false" }
                        ]
                    },
                    {
                        "master": "SEQUENCE_NUMBER", "id": "Sequence Number", "name": scope.translation.text.SEQUENCE_NUMBER_TABLE, "url": "/sequencenumber/table/sequence-number-table", "mobile": "true", "detail": [
                            { "id": "", "name": "", "icon": "", "url": "", "mobile": "false" },
                            { "id": "Sequence Number Table", "name": scope.translation.text.SEQUENCE_NUMBER_TABLE, "icon": "fa-table", "url": "/sequencenumber/table/sequence-number-table-view", "mobile": "true" },
                            { "id": "", "name": "", "icon": "", "url": "", "mobile": "false" }
                        ]
                    },
                    {
                        "master": "SIGNAL", "id": "Signal Chart", "name": scope.translation.text.SIGNAL_CHART, "url": "/signal/chart/signal-chart", "mobile": "true", "detail": [
                            { "id": "", "name": "", "icon": "", "url": "", "mobile": "false" },
                            { "id": "Signal Chart", "name": scope.translation.text.SIGNAL_CHART, "icon": "fa-line-chart", "url": "/signal/chart/signal-chart", "mobile": "true" },
                            { "id": "Signal Table", "name": scope.translation.text.SIGNAL_TABLE, "icon": "fa-table", "url": "/signal/table/signal-table", "mobile": "true" },
                            { "id": "Signal Gauge", "name": scope.translation.text.SIGNAL_GAUGE, "icon": "fa-tachometer", "url": "", "mobile": "false" }
                        ]
                    },
                    {
                        "master": "SIGNAL_CONNECT", "id": "Signal Connect", "name": scope.translation.text.SIGNAL_CONNECT_CHART, "url": "/signalconnect/chart/signal-connect-chart", "mobile": "true", "detail": [
                            { "id": "Signal Connect Calendar", "name": scope.translation.text.SIGNAL_CONNECT_CALENDAR, "icon": "fa-calendar-o", "url": "/signalconnect/calendar/signal-connect-calendar", "mobile": "true" },
                            { "id": "Signal Connect Chart", "name": scope.translation.text.SIGNAL_CONNECT_CHART, "icon": "fa-line-chart", "url": "/signalconnect/chart/signal-connect-chart", "mobile": "true" },
                            { "id": "Signal Connect Table", "name": scope.translation.text.SIGNAL_CONNECT_TABLE, "icon": "fa-table", "url": "/signalconnect/table/signal-connect-table", "mobile": "true" },
                            { "id": "", "name": "", "icon": "", "url": "", "mobile": "false" } 
                        ]
                    },
                    {
                        "master": "TEMPERATURE", "id": "Temperature Chart", "name": scope.translation.text.TEMPERATURE_CHART, "url": "/temperature/chart/temperature-chart", "mobile": "true", "detail": [                            
                            { "id": "Temperature Chart", "name": scope.translation.text.TEMPERATURE_CHART, "icon": "fa-line-chart", "url": "/temperature/chart/temperature-chart", "mobile": "true" },
                            { "id": "Temperature Table", "name": scope.translation.text.TEMPERATURE_TABLE, "icon": "fa-table", "url": "/temperature/temperature-table", "mobile": "true" },
                            { "id": "Mc Temperature Gauge", "name": scope.translation.text.TEMPERATURE_GAUGE, "icon": "fa-tachometer", "url": "", "mobile": "false" }
                        ]
                    },
                    {
                        "master": "VOLTAGE", "id": "Voltage Chart", "name": scope.translation.text.VOLTAGE_CHART, "url": "/voltage/chart/voltage-chart-view", "mobile": "true", "detail": [
                            { "id": "Voltage Chart", "name": scope.translation.text.VOLTAGE_CHART, "icon": "fa-line-chart", "url": "/voltage/chart/voltage-chart-view", "mobile": "true" },
                            { "id": "Voltage Table", "name": scope.translation.text.VOLTAGE_TABLE, "icon": "fa-table", "url": "/voltage/voltage-table", "mobile": "true" },
                            { "id": "Voltage Gauge", "name": scope.translation.text.VOLTAGE_GAUGE, "icon": "fa-tachometer", "url": "", "mobile": "false" }
                        ]
                    }
                ];

                scope.adminViews =
                {
                    "master": "DATA_USAGE", "id": "Data Usage", "name": scope.translation.text.DATA_USAGE, "url": "/carrierdatausage/carrier-data-usage", "mobile": "false", "detail": [
                        { "id": "Data Usage", "name": scope.translation.text.DATA_USAGE, "icon": "fa-line-chart", "url": "/carrierdatausage/carrier-data-usage", "mobile": "false" },
                        { "id": "", "name": "", "icon": "", "url": "/analog/analog-chart", "mobile": "true" },
                        { "id": "", "name": "", "icon": "", "url": "/analog/analog-chart", "mobile": "true" }
                    ]
                };
                // {
                //     "master": "SIM_DATA_USAGE", "id": "Sim Data Usage", "name": scope.translation.text.SIM_DATA_USAGE, "detail": [
                //         { "id": "Sim Data Usage", "name": scope.translation.text.SIM_DATA_USAGE, "icon": "fa-line-chart" },
                //         { "id": "", "name": "", "icon": "" },
                //         { "id": "", "name": "", "icon": "" }
                //     ]
                // };

                //if (scope.isMcAdmin) scope.views.push(scope.adminViews);

                scope.selected = scope.views[0].DeviceId;
                scope.viewSelected = scope.views[0].DeviceId;
            };
            scope.viewList();
            scope.label = attrs.label;
            scope.showViews = false;

            //This popover sets popover-append-to-body, so DOM focus cannot be placed
            //inside it and Tab from the trigger never reaches the list. Keyboard
            //support is therefore built as a select-only combobox: focus stays on the
            //trigger, keys are handled there, and the highlighted option is tracked
            //with aria-activedescendant plus a .view-option-active class standing in
            //for the focus ring. Same pattern as the device menu in device-lookup.
            scope.activeViewIndex = -1;
            scope.activeViewOptionId = null;

            var _viewOptions = function () {
                return $('body').find('.popover-deatils [role="option"]');
            };

            var _setActiveViewOption = function (index) {
                var $options = _viewOptions();
                if (!$options.length) return;
                if (index < 0) index = $options.length - 1;
                if (index >= $options.length) index = 0;

                $options.removeClass("view-option-active");
                var $option = $options.eq(index);
                $option.addClass("view-option-active");

                scope.activeViewIndex = index;
                scope.activeViewOptionId = $option.attr("id");

                //nothing here holds focus, so the browser will not scroll it into view
                if ($option[0].scrollIntoView) $option[0].scrollIntoView({ block: "nearest" });
            };

            //ids are assigned here rather than in the template because view ids contain
            //spaces ("Analog Table"), which are not valid in an id
            scope.syncActiveViewOption = function () {
                if (!scope.showViews) return;
                var attempts = 0;

                var _init = function () {
                    if (!scope.showViews) return; //closed again while we waited
                    var $options = _viewOptions();

                    //uib resolves popover-template through a promise, so the list is not
                    //in the DOM on the next tick
                    if (!$options.length) {
                        if (++attempts <= 20) $timeout(_init, 25);
                        return;
                    }

                    var start = 0;
                    $options.each(function (i) {
                        if (!this.id) this.id = "viewoption_" + i;
                        if ($(this).attr("aria-selected") === "true") start = i;
                    });
                    _setActiveViewOption(start);
                };

                $timeout(_init, 0);
            };

            scope.viewMenuKeydown = function ($event) {
                var key = $event.key;

                if (!scope.showViews) {
                    if (key === "ArrowDown" || key === "ArrowUp") {
                        $event.preventDefault();
                        scope.showViews = true;
                        scope.syncActiveViewOption();
                    }
                    return;
                }

                switch (key) {
                    case "ArrowDown":
                        _setActiveViewOption(scope.activeViewIndex + 1);
                        break;
                    case "ArrowUp":
                        _setActiveViewOption(scope.activeViewIndex - 1);
                        break;
                    case "Home":
                        _setActiveViewOption(0);
                        break;
                    case "End":
                        _setActiveViewOption(_viewOptions().length - 1);
                        break;
                    case "Enter":
                    case " ":
                    case "Spacebar":
                        var $active = _viewOptions().eq(scope.activeViewIndex);
                        if ($active.length) scope.setView($active.attr("data-view-id"), $active.attr("data-view-url"));
                        break;
                    case "Escape":
                    case "Esc":
                        scope.showViews = false;
                        break;
                    default:
                        return;
                }

                //also stops Enter/Space re-triggering the trigger's own click
                $event.preventDefault();
            };

            scope.setView = function (id, url) {
                scope.showViews = false;
                if ($rootScope.mobile || $rootScope.classicView) {
                    scope.mobileMenuOption(url);
                    return;
                }

                scope.selected = id;
                scope.viewSelected = id;

                var _popup = _this.getExistingDialog(scope.windowId).ref;
                var _popupPosition = _popup.dialog("option", "position");
                var _popupWidth = _popup.dialog("option", "width");
                var _popupHeight = _popup.dialog("option", "height");

                var _popupSize = {};
                _popupSize.width = _popupWidth;
                _popupSize.height = _popupHeight;
                if (id === 'Volumetric Flow Table') {
                    if (_popupSize.width < 535) {
                        _popupSize.width = 535;
                    }
                    openViewService.openView(id, _popupSize, _popupPosition, scope.stickyProperties, { minimumWidth: 535, minimumHeight: 400 });
                } else {
                    if(id && scope.isSupergraph)
                    {
                        _popupPosition.my = "top+100";
                        _popupSize.width = _popupWidth - 75;
                        _popupSize.height = _popupHeight - 75;
                        openViewService.openView(id, _popupSize, _popupPosition, scope.stickyProperties);
                    }
                    else if (id) openViewService.openView(id, _popupSize, _popupPosition, scope.stickyProperties);
                }

                // SCADA-1745 white space was clicked if no id
                if(id && typeof scope.isSupergraph === 'undefined')
                {
                    _popup.dialog("close");
                }
                else if(id && !scope.isSupergraph) 
                {
                    _popup.dialog("close");
                }
            };

            scope.mobileMenuOption = function (varUrl) {
                $location.path(varUrl);
            };

            scope.filterOptions = function (obj) {
                if ($rootScope.mobile || $rootScope.classicView) return obj.mobile === "true";
                return true;
            };

            scope.isViewSelected = function (section) {
                return scope.selected === section;
            };

            scope.selectView = function ($event, varID, varName) {
                $event.stopPropagation();
                scope.viewSelected = varID;
                scope.showViews = false;
            };

            scope.getText = function (text) {
                return eval("scope.translation.text." + text.toUpperCase());
            };

            scope.$on('updatePreferencesLanguage', function (event, args) {
                scope.translation = args;
                scope.viewList();
            });

            scope.mouseupViewList = function () {
                if (_checkSolar == 0) {
                    scope.checkSolar();
                }
                if (_checkPulseFlow === 0) {
                    scope.checkPulseFlow();
                }

                scope.checkIfGenIIDeviceOrHasAnalogOutput();

            };

            scope.$on(
                "$destroy",
                function (event) {
                    //
                }
            );

            scope.checkSolar = function () {
                if (deviceMenuService.getSolar() === undefined) return;
                _checkSolar = 1;
                if (!deviceMenuService.getSolar()) {
                    scope.views = scope.views.filter(function (item) {
                        return item.master !== "SOLAR";
                    });
                }
            };

            scope.checkPulseFlow = function () {
                if (deviceMenuService.getPulseFlow() === undefined) return;
                _checkPulseFlow = 1;
                if (!deviceMenuService.getPulseFlow()) {
                    scope.views = scope.views.filter(function (item) {
                        return item.master !== "PULSE_FLOW";
                    });
                }
            };

            scope.tmpViews = angular.copy(scope.views);

            scope.checkIfGenIIDeviceOrHasAnalogOutput = function () {

                deviceMenuService.getDeviceMenuList(authenticationService.getAccountInfo().customerId)
                    .then(function (result) {

                        var myDevice = result.data.devices.filter(function (i, n) {
                            return i.deviceId == attrs.deviceSelected;
                        });
                        var views = scope.tmpViews;
                        if (myDevice[0].protocolVersion !== 2) {
                            views = views.filter(function (item) {
                                return item.master !== "HUMIDITY" && item.master !== "SEQUENCE_NUMBER";
                            });
                            scope.views = views;
                        } else {
                            scope.views = views;
                        }

                        //Hide Analog Output view for MM+ devices and device without analog output board
                        if (myDevice[0].model == 20 || myDevice[0].hasAnalogOutputBoard == false) {
                            views = views.filter(function (item) {
                                return item.master !== "ANALOG_OUTPUT" ;
                            });
                            // MM+ device filter based on SKU
                            if(myDevice[0].model == 20) {
                                 views = views.filter(function (item) {
                                            return item.master !== "PUMP" && item.master !== "PULSE_FLOW";
                                        });
                            }
                            scope.views = views;
                        } else {
                            scope.views = views;
                        }                        
                    }, function (error) {
                        console.log("Error");
                        scope.views = scope.views.filter(function (item) {
                            return item.master !== "HUMIDITY" && item.master !== "SEQUENCE_NUMBER" && item.master !== "ANALOG_OUTPUT";
                        });
                    });
            };

            scope.dynamicPopover = {
                templateUrl: 'viewSelectionTemplate.html'
            };
        }
    };
}]);
(function () {
    mcapp.directive('printWidget', ["$rootScope", "$timeout", "$window", printWidgetDirective]);

    function printWidgetDirective($rootScope, $timeout, $window) {
        var copyComputedStyle = function (from, to) {
            var computed_style_object = false;
            //trying to figure out which style object we need to use depending on the browser support
            //so we try until we have one
            computed_style_object = from.currentStyle || document.defaultView.getComputedStyle(from, null);

            //if the browser does not support both methods, we will return null
            if (!computed_style_object) return null;

            var stylePropertyValid = function (name, value) {
                //checking that the value is not a undefined
                return typeof value !== 'undefined' &&
                        //checking that the value is not a object
                    typeof value !== 'object' &&
                        //checking that the value is not a function
                    typeof value !== 'function' &&
                        //checking that we don't have empty string
                    value.length > 0 &&
                        //checking that the property is not an int (happens on some browsers)
                    value != parseInt(value);
            };

            //we iterating the computed style object and copy the style props and values
            for (var property in computed_style_object) {
                //checking if the property and the value we get are valid since browsers have different implementations
                if (stylePropertyValid(property, computed_style_object[property])) {
                    //applying the style property to the target element
                    to.style[property] = computed_style_object[property];
                }
            }
        };

        function printWidget($target, mywindow, scope, attr) {
            $timeout(function () {
                var elementToPrint;

                if (!$rootScope.mobile && !$rootScope.classicView) {
                    scope.popup = _this.getExistingDialog(attr.altTarget).ref;
                    elementToPrint = scope.popup.parent();
                }
                else {
                    elementToPrint = $("div").parent(".content-classic");
                }

                html2canvas2(elementToPrint, { timeout: 333 }).then(function (canvas) {
                    var img = canvas.toDataURL("image\png");

                    var strHtml = "<!DOCTYPE HTML>\n<html>\n<head>\n<script>function onLoadFn(){var myImg = document.getElementById('imgid'); myImg.src='" + img + "';}<\/script></head>\n<body onload='onLoadFn();'>\n<div>\n<img src='' id='imgid' alt='No Image Found'>\n</div>\n<script>setTimeout(function(){window.print();window.close();}, 500);<\/script></body>\n</html>";

                    mywindow.document.open();
                    mywindow.document.write(strHtml);
                    mywindow.document.close();
                    mywindow.focus();
                });
            }, null);
        }

        return {
            restrict: 'E',
            template: '<i class="fa fa-print fa-lg" aria-hidden="true" style="font-size: 1.6em; margin-left: -1px;"></i>',
            scope: {
                elementId: '@',
                altTarget: '@'
            },
            link: function (scope, element, attr) {
                //ticket 53660: <print-widget> is a custom element with no native button
                //semantics, so it never received keyboard focus - role/tabindex/aria-label
                //make it announce and focus like a real button, and the keydown handler
                //below answers Enter/Space the way a real button would.
                //Every use sits inside a <div class="quickdate-button"> - the visible button box.
                //The focus ring is drawn on whichever element holds the role, and on the inline
                //<print-widget> it hugged just the icon (and was clipped by the box), so the
                //box itself becomes the control, like the other toolbar buttons. That also makes
                //the whole box clickable, not just the icon.
                var control = element.parent().hasClass('quickdate-button') ? element.parent() : element;
                control.attr({
                    'role': 'button',
                    'tabindex': '0',
                    'aria-label': 'Print'
                });

                function triggerPrint() {
                    var $target = $('#' + attr.elementId);
                    if ($target.length == 0)
                        $target = $('div[class*="' + attr.altTarget + '"]');
                    var mywindow = $window.open('', 'MyWindow', 'width=750,height=650,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes');
                    printWidget($target, mywindow, scope, attr);
                }

                control.on('click', triggerPrint);
                control.on('keydown', function (event) {
                    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                        event.preventDefault(); //stop Space from scrolling the view behind it
                        triggerPrint();
                    }
                });
            }
        };
    }
})();

(function (angular) {
    'use strict';
    function printDirective() {
        var printSection = document.getElementById('printSection');
        // if there is no printing section, create one
        if (!printSection) {
            printSection = document.createElement('div');
            printSection.id = 'printSection';
            document.body.appendChild(printSection);
        }
        function link(scope, element, attrs) {
            element.on('click', function () {
                var elemToPrint = document.getElementById(attrs.printElementId);
                if (elemToPrint) {
                    printElement(elemToPrint);
                }
            });
            window.onafterprint = function () {
                // clean the print section before adding new content
                printSection.innerHTML = '';
            };
        }
        function printElement(elem) {
            // clones the element you want to print
            var domClone = elem.cloneNode(true);
            printSection.appendChild(domClone);
            window.print();
        }
        return {
            link: link,
            restrict: 'A'
        };
    }
    angular.module('mcapp').directive('ngPrint', [printDirective]);
}(window.angular));
mcapp.directive('printWidgetA', ["$timeout", function ($timeout) {
    return {
        restrict: 'E',
        template: '<image src="images/printer32x32.png" width="17" height="16"></image>',
        scope: {
            targetId: '@'
        },
        link: function (scope, element, attr) {
            element.on('click', function () {
                printWidgetA(attr.targetId);
            });

            function printWidgetA(id) {

                var DocumentContainer = $('div[class*="' + id + '"]');
                var WindowObject = window.open('', 'PrintWindow', 'width=750,height=650,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes');
                var strHtml = "<!DOCTYPE HTML><html>\n<head>\n<style>.print-no, .ui-dialog-titlebar-buttonpane {display: none;} .tabular-data a:link {color: #666;font-weight: bold;text-decoration:none;}.tabular-data a:visited {color: #999999;font-weight:bold;text-decoration:none;}.tabular-data a:active,.tabular-data a:hover {color: #bd5a35;	text-decoration:underline;}.tabular-data {font-family:Arial, Helvetica, sans-serif;color:#666;font-size:12px;text-shadow: 1px 1px 0px #fff;background:#eaebec;margin:20px;border:#ccc 1px solid;-moz-border-radius:3px;	-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow: 0 1px 2px #d1d1d1;-webkit-box-shadow: 0 1px 2px #d1d1d1;box-shadow: 0 1px 2px #d1d1d1;}.tabular-data th {padding:15px 20px 17px 20px;border-top:1px solid #fafafa;border-bottom:1px solid #e0e0e0;background: #ededed;background: -webkit-gradient(linear, left top, left bottom, from(#ededed), to(#ebebeb));	background: -moz-linear-gradient(top,  #ededed,  #ebebeb);}.tabular-data th:first-child {text-align: left;padding-left:20px;}.tabular-data tr:first-child th:first-child {	-moz-border-radius-topleft:3px;	-webkit-border-top-left-radius:3px;border-top-left-radius:3px;}.tabular-data tr:first-child th:last-child {-moz-border-radius-topright:3px;-webkit-border-top-right-radius:3px;border-top-right-radius:3px;}.tabular-data tr {text-align: center;padding-left:20px;}.tabular-data td:first-child {text-align: left;padding-left:20px;border-left: 0;}.tabular-data td {padding:18px;border-top: 1px solid #ffffff;border-bottom:1px solid #e0e0e0;border-left: 1px solid #e0e0e0;	background: #fafafa;background: -webkit-gradient(linear, left top, left bottom, from(#fbfbfb), to(#fafafa));background: -moz-linear-gradient(top,  #fbfbfb,  #fafafa);}.tabular-data tr.even td {background: #f6f6f6;background: -webkit-gradient(linear, left top, left bottom, from(#f8f8f8), to(#f6f6f6));background: -moz-linear-gradient(top,  #f8f8f8,  #f6f6f6);}.tabular-data tr:last-child td {border-bottom:0;}.tabular-data tr:last-child td:first-child {-moz-border-radius-bottomleft:3px;-webkit-border-bottom-left-radius:3px;border-bottom-left-radius:3px;}.tabular-data tr:last-child td:last-child {-moz-border-radius-bottomright:3px;-webkit-border-bottom-right-radius:3px;	border-bottom-right-radius:3px;}.tabular-data tr:hover td {background: #f2f2f2;background: -webkit-gradient(linear, left top, left bottom, from(#f2f2f2), to(#f0f0f0));background: -moz-linear-gradient(top,  #f2f2f2,  #f0f0f0);}.tabular-data .thmain { background: #d6d3d3; color: #000000;font-size:larger;}.tabular-data .thmain a:link {color: #000000;	font-weight: bold;text-decoration:underline;}.tabular-data .thmain a:visited {color: #000000;	font-weight:bold;text-decoration:underline;}.tabular-data .thmain a:active,.tabular-data .thmain a:hover {color: #bd5a35;	text-decoration:none;}.tabular-data .tha a:link {color: #bd5a35;font-weight: bold;text-decoration:underline;}.tabular-data .tha a:visited {color: #bd5a35;font-weight:bold;text-decoration:underline;}.tabular-data .tha a:active,.tabular-data .tha a:hover {	color: #bd5a35;	text-decoration:underline;}</style></head><body><div>\n" + DocumentContainer.html() + "\n</div>\n</body>\n</html>";
                // var strHtml = "<!DOCTYPE HTML><html>\n<head>\n<style>.print-no, .ui-dialog-titlebar-buttonpane {display: none;} .tabular-data a:link {color: #666;font-weight: bold;text-decoration:none;}.tabular-data a:visited {color: #999999;font-weight:bold;text-decoration:none;}.tabular-data a:active,.tabular-data a:hover {color: #bd5a35; text-decoration:underline;}.tabular-data {font-family:Arial, Helvetica, sans-serif;color:#666;font-size:12px;text-shadow: 1px 1px 0px #fff;background:#eaebec;margin:20px;border:#ccc 1px solid;-moz-border-radius:3px; -webkit-border-radius:3px;border-radius:3px;-moz-box-shadow: 0 1px 2px #d1d1d1;-webkit-box-shadow: 0 1px 2px #d1d1d1;box-shadow: 0 1px 2px #d1d1d1;}.tabular-data th {padding:15px 20px 17px 20px;border-top:1px solid #fafafa;border-bottom:1px solid #e0e0e0;background: #ededed;background: -webkit-gradient(linear, left top, left bottom, from(#ededed), to(#ebebeb)); background: -moz-linear-gradient(top,  #ededed,  #ebebeb);}.tabular-data th:first-child {text-align: left;padding-left:20px;}.tabular-data tr:first-child th:first-child { -moz-border-radius-topleft:3px; -webkit-border-top-left-radius:3px;border-top-left-radius:3px;}.tabular-data tr:first-child th:last-child {-moz-border-radius-topright:3px;-webkit-border-top-right-radius:3px;border-top-right-radius:3px;}.tabular-data tr {text-align: center;padding-left:20px;}.tabular-data td:first-child {text-align: left;padding-left:20px;border-left: 0;}.tabular-data td {padding:18px;border-top: 1px solid #ffffff;border-bottom:1px solid #e0e0e0;border-left: 1px solid #e0e0e0; background: #fafafa;background: -webkit-gradient(linear, left top, left bottom, from(#fbfbfb), to(#fafafa));background: -moz-linear-gradient(top,  #fbfbfb,  #fafafa);}.tabular-data tr.even td {background: #f6f6f6;background: -webkit-gradient(linear, left top, left bottom, from(#f8f8f8), to(#f6f6f6));background: -moz-linear-gradient(top,  #f8f8f8,  #f6f6f6);}.tabular-data tr:last-child td {border-bottom:0;}.tabular-data tr:last-child td:first-child {-moz-border-radius-bottomleft:3px;-webkit-border-bottom-left-radius:3px;border-bottom-left-radius:3px;}.tabular-data tr:last-child td:last-child {-moz-border-radius-bottomright:3px;-webkit-border-bottom-right-radius:3px; border-bottom-right-radius:3px;}.tabular-data tr:hover td {background: #f2f2f2;background: -webkit-gradient(linear, left top, left bottom, from(#f2f2f2), to(#f0f0f0));background: -moz-linear-gradient(top,  #f2f2f2,  #f0f0f0);}.tabular-data .thmain { background: #d6d3d3; color: #000000;font-size:larger;}.tabular-data .thmain a:link {color: #000000; font-weight: bold;text-decoration:underline;}.tabular-data .thmain a:visited {color: #000000; font-weight:bold;text-decoration:underline;}.tabular-data .thmain a:active,.tabular-data .thmain a:hover {color: #bd5a35; text-decoration:none;}.tabular-data .tha a:link {color: #bd5a35;font-weight: bold;text-decoration:underline;}.tabular-data .tha a:visited {color: #bd5a35;font-weight:bold;text-decoration:underline;}.tabular-data .tha a:active,.tabular-data .tha a:hover { color: #bd5a35; text-decoration:underline; }.imgtxtlod {display: none;}</style></head><body><div>\n" + DocumentContainer.html() + "\n</div>\n</body>\n</html>";
                WindowObject.document.writeln(strHtml);
                WindowObject.document.close();
                WindowObject.focus();
                $timeout(function () {
                    WindowObject.print();
                    WindowObject.close();
                });
            }
        }
    };
}]);

//mcapp.directive('loadingInProgress', ["authenticationService", function (authenticationService) {
//    return {
//        restrict: 'E',
//        transclude: false,
//        replace: true,
//        templateUrl: 'ui/components/directives/loading/loading-in-progress.html',
//        link: function (scope, element, attrs) {
//            attrs.$observe('valueToWatch', function (newValue) {
//                scope.lipValue = newValue == 'false' ? false : true;
//                scope.lipClass = attrs.positionClass ? attrs.positionClass : 'imgtxtlod';
//                scope.lipText =  attrs.lipTextShow == 'false' ? false  : true;
//            }, true);
//        }
//    };
//}]);

mcapp.directive('icheck', ["$timeout", "$parse", function ($timeout, $parse) {
    return {
        require: '?ngModel',
        link: function ($scope, element, $attrs, ngModel) {
            return $timeout(function () {
                var parentLabel = element.parent('label');
                if (parentLabel.length)
                    parentLabel.addClass('icheck-label');
                var value;
                value = $attrs.value;

                $scope.$watch($attrs.ngModel, function (newValue) {
                    $(element).iCheck('update');
                });

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_minimal-blue',
                    radioClass: 'iradio_minimal-blue'

                }).on('ifChanged', function (event) {
                    if ($(element).attr('type') === 'checkbox' && $attrs.ngModel) {
                        $scope.$apply(function () {
                            return ngModel.$setViewValue(event.target.checked);
                        });
                    }
                    if ($(element).attr('type') === 'radio' && $attrs.ngModel) {
                        return $scope.$apply(function () {
                            return ngModel.$setViewValue(value);
                        });
                    }
                });
            });
        }
    };
}]);
'use strict';

function NumericInput() {
  return {
    require: '?ngModel',
    scope: {
      maxPrecision: '@'
    },
    link: function link($scope, element, attrs, ngModelCtrl) {
      if (!ngModelCtrl) {
        return;
      }

      ngModelCtrl.$parsers.push(function (val) {
        var maxPrecision = parseInt($scope.maxPrecision, 10);
        var value = angular.isUndefined(val) ? '' : val;
        var clean = value.replace(/[^0-9\.]+/g, '');

        var decimalSplit = clean.split('.');

        if (maxPrecision === 0) {
          clean = decimalSplit[0];
        } else {
          if (decimalSplit[1]) {
            if (!isNaN(maxPrecision)) {
              decimalSplit[1] = decimalSplit[1].slice(0, maxPrecision);
            }

            clean = decimalSplit[0] + '.' + decimalSplit[1];
          }
        }

        if (value !== clean) {
          ngModelCtrl.$setViewValue(clean);
          ngModelCtrl.$render();
        }

        return clean;
      });

      element.bind('keypress', function (event) {
        if (event.keyCode === 32) {
          event.preventDefault();
        }
      });
    }
  };
}

mcapp.directive('numericInput', NumericInput);
mcapp.directive('mcDraggable', ['$document', function ($document) {
    return {
      restrict: 'A',
      link: function(scope, elm, attrs) {
        var startX, startY, initialMouseX, initialMouseY;
        elm.css({position: 'absolute'});
 
        elm.bind('mousedown', function($event) {
          startX = elm.prop('offsetLeft');
          startY = elm.prop('offsetTop');
          initialMouseX = $event.clientX;
          initialMouseY = $event.clientY;
          $document.bind('mousemove', mousemove);
          $document.bind('mouseup', mouseup);
          return false;
        });
 
        function mousemove($event) {
          var dx = $event.clientX - initialMouseX;
          var dy = $event.clientY - initialMouseY;
          elm.css({
            top:  startY + dy + 'px',
            left: startX + dx + 'px'
          });
          return false;
        }
 
        function mouseup() {
          $document.unbind('mousemove', mousemove);
          $document.unbind('mouseup', mouseup);
        }
      }
    };
}]);
mcapp.controller('monthlyFlowSummaryWidgetController', ['$scope', '$element', function ($scope, $element) {
    //$scope.liveData = false;
  }]);
  
  mcapp.directive('monthlyFlowSummaryWidget', ['$rootScope', 'detectBrowserService', 'translationService', '$location', 'openViewService', 'sharedSetupService', function ($rootScope, detectBrowserService, translationService, $location, openViewService, sharedSetupService) {
      return {
          restrict: 'E',
          transclude: true,
          replace: true,
          template: '<i ng-click="openMonthlyFlowSummary()" class="fa fa-file-text fa-lg" aria-hidden="true" style="margin-top: 1.5px;"></i>',
          link: function (scope, element, attrs) {
              scope.mobile = $rootScope.mobile;
              scope.classicView = $rootScope.classicView;

              scope.openMonthlyFlowSummary = function () {
                if (this.mobile || this.classicView) {
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.stickyProperties.deviceId, device: { channel: scope.stickyProperties.channel } });
                    $location.path('/flowsummarymonthly/flow-summary-monthly');
                }
                else {
                    const optionsStickyProperties = scope.stickyProperties;
                    openViewService.openView('Monthly Flow Summary', { width: 900, height: 500 }, { my: 'center', at: 'center', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });
                }
              };

          }
      };
  }]);
  
(function () {
    mcapp.controller('mobiPageLandscapeWarningController', [
        '$scope', function ($scope) {
            $scope.$on('windowDimensions', function (event, args) {
                if (args.landscapeMode) {
                    $scope.stopIconAnimation();
                } else {
                    $scope.iconAnimation();
                }
            });
        }
    ]);
    mcapp.directive('mobiPageLandscapeWarning', ['$timeout', '$interval',
        function ($timeout, $interval) {
            return {
                restrict: 'E',
                transclude: false,
                replace: true,
                templateUrl: 'ui/components/directives/mobipagelandscapewarning/mobi-page-landscape-warning.html',
                link: function (scope, element, attrs) {
                    scope.isActive = false;

                    var stop;
                    scope.iconAnimation = function () {
                        if (angular.isDefined(stop)) return;

                        stop = $interval(function () {
                            scope.isActive = !scope.isActive;
                        }, 5000);
                    };

                    scope.stopIconAnimation = function () {
                        if (angular.isDefined(stop)) {
                            $interval.cancel(stop);
                            stop = undefined;
                        }
                    };

                    $timeout(function () {
                        scope.isActive = !scope.isActive;
                        scope.iconAnimation();
                    }, 1000);
                  
                    scope.$on('$destroy', function () {
                        scope.stopIconAnimation();
                    });
                }
            };
        }
    ]);
}());

'use strict';

function MapWrapper($timeout, authenticationService) {
  return {
    restrict: 'E',
    transclude: false,
    replace: false,
    templateUrl: 'ui/components/directives/google-map/simple-map-partial.html',
    scope: {
      options: '=',
      onDrag: '='
    },
    link: function link($scope, elem, attrs) {
      var accountInfo = authenticationService.getAccountInfo();
      var readOnly = accountInfo.userRole.indexOf("Administrator") !== -1 ? false : true;
      var listeners = [];
      var defaultOptions = {
        longitude: 0,
        latitude: 0,
        draggable: readOnly ? false : true
      };
      var marker = null;

      var options = Object.assign({}, defaultOptions, $scope.options);

      var map = new google.maps.Map(elem.find('.simple-scada-map')[0], {
        zoom: 16,
        streetViewControl: false,
        draggable: readOnly ? false : true
      });

      marker = new google.maps.Marker({
        position: new google.maps.LatLng(options.latitude, options.longitude),
        draggable: options.draggable,
        map: map
      });

      if ($scope.onDrag) {
        listeners.push(marker.addListener('dragend', function (event) {
          $scope.onDrag(marker.getPosition().lat(), marker.getPosition().lng());
        }));
      }

      $scope.$watch('options', function (newVal, oldVal) {
        google.maps.event.trigger(map, 'resize');
        options = Object.assign({}, options, newVal);

        var newPosition = new google.maps.LatLng(options.latitude, options.longitude);

        marker.setPosition(newPosition);
        $timeout(function () {
          map.panTo(newPosition);
          // map.setZoom(16);
        }, 500);
      }, true);

      $scope.$on('resize_map', function () {
        google.maps.event.trigger(map, 'resize');
      });

      $scope.$on('$destroy', function () {
        for (var i = 0; i < listeners.length; i++) {
          listeners[i].remove();
        }
      });
    }
  };
}

MapWrapper.$inject = ['$timeout', 'authenticationService'];

angular.module('mcapp').directive('simpleScadaMap', MapWrapper);
'use strict';

angular.module('mc.user-accounts', []);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function ManageUserController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, LoginsFactory, $uibModal, $element, $timeout, datetimeService, savePdfService, registerWebinarService, unsavedChangesService, desktopViewListService, toaster) {
    var _this = this;

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.isMcAdmin = false;
    ctrl.availableDesktopsOnly = [];

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.editModeIndex = null;
        ctrl.editMode = null;
        ctrl.addMode = null;
        ctrl.myModalTemplate = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.isSuperAdmin = sharedSetupService.isSuperAdmin(ctrl.accountInfo);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        ctrl.downloadViewTypeOptions = [0, 1, 2];

        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(ctrl);

        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = true;
        ctrl.getLogins();
        ctrl.getDesktops();
        ctrl.validEmail = true;
        ctrl.showTooltip = false;

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        //if (!$rootScope.mobile && !$rootScope.classicView) {
        //    this._popup = _this.getExistingDialog(this.windowId).ref;
        //    $(this._popup).on('dialogbeforeclose', (event) => {
        //        unsavedChangesService.checkUnsavedChanges(event, this._popup, this, ctrl.addMode == -1)
        //    });
        //}
    };

    ctrl.dynamicPopover = {
        templateUrl: 'ManageUserPopoverTemplate.html'
    };

    ctrl.getAccessLevelName = function (item) {
        var data = ctrl.roles.filter(function (login) {
            if (login.id == item.accessLevel) {
                //assign lastAccessLevel if unassigned
                item.lastAccessLevel = item.lastAccessLevel ? item.lastAccessLevel : login.id;
                return login;
            }
        });
        //Return Translation for role
        return data.length ? _this.translation.text['USER_ROLE_' + data[0].id] : _this.translation.text['USER_ROLE_100'];
    };

    ctrl.getDesktopName = function (item) {
        var data = ctrl.desktops.filter(function (login) {
            if (login.desktopId == item.defaultDesktopID) {
                return login;
            }
        });
        //Return Desktop Name
        return data.length ? data[0].desktopName : _this.translation.text.NO_DEFAULT;
    };

    ctrl.updateAccessLevel = function (item) {
        _this._prevName = item.lastAccessLevel;
        //Alert user if accessLevel is being lowered from admin status
        if (item.lastAccessLevel >= 255 & item.accessLevel < 255) {
            ctrl.openCommonModal(item, false);
        } else if (item.lastAccessLevel <= 255 & item.accessLevel == 511 && item.userId != -1) {
            ctrl.openCommonModal(item, false, true);
        }
        //else run patch
        else {
                ctrl.patchData(item, 'accessLevel');
            }

        ctrl.filterOutavailableDesktopsOnly(item);
    };

    ctrl.editingTo = function (name) {
        _this._prevName = name;
    };

    ctrl.hasOverflow = function () {
        var element = document.getElementById('user-rows');
        if (element.offsetHeight < element.scrollHeight) {
            return true;
        }
        return false;
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    ctrl.getLogins = function () {

        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.getLogins().then(function () {
            ctrl.roles = ctrl.getRoles(_loginsFactory.data.userRoleList);
            ctrl.logins = _loginsFactory.data.loginsInfo;
            ctrl.logins.forEach(function (element) {
                element.invalidEmail = false;
                element.invalidPhone = false;
                element.invalidPin = false;
                element.requirePhone = false;
                element.requirePin = false;
                element.pinStartsWithZero = false;
                element.phonePinDuplicate = false;
                element.pinFailsChecks = false;
                element.phoneFailsChecks = false;
                element.phoneAlertMessage = "";
                element.pinAlertMessage = "";
                element.passwordResetEmailSent = false;
                element.twoFaSecretReset = false;
            });
            //Enable View tooltips
            $(document).ready(function () {
                $('.user-container [data-toggle="tooltip"]').tooltip();
            });
        });
    };

    ctrl.getDesktops = function () {
        desktopViewListService.getData(ctrl.accountInfo.customerId).then(function (result) {
            ctrl._loading = false;
            ctrl.desktops = result.data.desktopViews;
            ctrl.desktops.unshift({ desktopId: 0, desktopName: $scope.translation.text.NO_DEFAULT });
        }, function (error) {});
    };

    ctrl.getRoles = function (roles) {
        return ctrl.isMcAdmin ? roles : roles.filter(function (role) {
            return role.id != 100;
        });
    };

    ctrl.patchData = function (item, propertyName) {
        if (item.vxmlPhone == "") {
            item.vxmlPhone = null;
        };
        if (item.vxmlPsw == "") {
            item.vxmlPsw = null;
        };
        //Conditions to not patch Data
        if (item.userId === -1 || item[propertyName] == _this._prevName) return false;
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;
        if (item.invalidEmail) return false;

        //All conditions passed, patch data
        var tmpServiceUserPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        ctrl.updateValue(item, propertyName);
    };

    ctrl.putData = function (item, propertyName, index) {

        //Conditions to not Put Data
        if (item.userId === -1 || item[propertyName] == _this._prevName) return false;
        if (item.invalidEmail) return false;
        if (item.invalidPhone || item.requirePhone) return false;
        if (item.invalidPin || item.requirePin) return false;
        if (item.phonePinDuplicate) return false;
        if (item.pinStartsWithZero) return false;

        //All conditions passed, put data
        ctrl.updateUser(item, index);
    };

    ctrl.addNewUser = function () {
        if (ctrl.addMode === -1) return false;

        $timeout(function () {
            $element.find("div[class^='tabular-data-container']").animate({
                scrollTop: 0
            }, 'slow');
        }, 0);

        var newUser = {
            customerId: ctrl.accountInfo.customerId,
            userId: -1,
            email: "",
            fullName: "",
            vxmlPhone: "",
            vxmlPsw: "",
            invalidEmail: false,
            invalidPhone: false,
            invalidPin: false,
            pinStartsWithZero: false,
            requirePhone: false,
            requirePin: false,
            pinFailsChecks: false,
            phoneFailsChecks: false,
            phoneAlertMessage: "",
            pinAlertMessage: "",
            phonePinDuplicate: false,
            superAdministrator: false,
            accessLevel: 63,
            lastAccessLevel: 63,
            sendWelcomeEmail: true,
            defaultDesktopID: 0
        };
        ctrl.logins.unshift(newUser);
        ctrl.editModeIndex = 0;
        ctrl.addMode = -1;
        ctrl.editMode = null;
        ctrl.filterOutavailableDesktopsOnly(ctrl.logins[0]);
    };

    ctrl.saveUser = function (item) {
        if (item.accessLevel == 511) {
            ctrl.openCommonModal(item, false, false, true);
        } else {
            ctrl.postAccount(item);
        }
    };

    ctrl.postAccount = function (item) {
        item.userName = item.email;
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.post(item).then(function (resp) {
            ctrl.logins = resp.data.loginsInfo;
        });
        ctrl.editModeIndex = null;
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.updateUser = function (item, index) {
        item.userName = item.email;
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.put(item).then(function (resp) {
            //If Phone Pin combo is already in use
            if (resp.data == null) {
                item.phonePinDuplicate = true;
                ctrl.pinPhoneAlerts(index);
            };
        });
    };

    ctrl.cancelUser = function (destination) {

        ctrl.editModeIndex = null;
        if (destination.userId === -1) ctrl.logins.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.setEditMode = function (index) {
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = ctrl.editModeIndex === index ? null : index;
        if (ctrl.logins[0].userId === -1) ctrl.logins.splice(0, 1);

        if (ctrl.editModeIndex == null) {
            ctrl.availableDesktopsOnly = ctrl.desktops;
        } else {
            ctrl.filterOutavailableDesktopsOnly(ctrl.logins[index]);
        }
    };

    ctrl.filterOutavailableDesktopsOnly = function (user) {
        if (user.accessLevel > 127) {
            ctrl.availableDesktopsOnly = ctrl.desktops;
        } else {

            desktopViewListService.getDesktopViewUserAccessByLoginId(ctrl.accountInfo.customerId, user.userId).then(function (result) {
                var _tmpList = result.data;
                var _availableDesktopsOnly = ctrl.desktops.filter(function (i, n) {
                    return i.desktopId === 0 || i.createdByLoginId == user.userId || _tmpList.find(function (p) {
                        return p.desktopId == i.desktopId;
                    });
                });

                ctrl.availableDesktopsOnly = _availableDesktopsOnly;
            }, function (error) {
                //error
            });
        }
    };

    ctrl.openRegisterWebinar = function (loginUser) {
        registerWebinarService.isPopup = false;
        registerWebinarService.userRegisteredToWebinar.fullName = loginUser.fullName;
        registerWebinarService.userRegisteredToWebinar.email = loginUser.email;
        var optionsStickyProperties = { windowId: ctrl.windowId };
        var position = null;
        position = { my: 'top+120', at: 'center top', of: window };
        if (!$rootScope.mobile && !$rootScope.classicView) {
            openViewService.openView('Register Webinar', { width: 700, height: 600 }, position, optionsStickyProperties, { minimumWidth: 700, minimumHeight: 600 });
        } else {
            $location.path('/account/webinar/register-webinar-template');
        }
    };

    ctrl.sendResetEmail = function (loginUser, field) {
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        switch (field) {
            case "Username":
                _loginsFactory.sendResetEmail(loginUser, "Username").then(function (resp) {});
                break;
            case "Password":
                _loginsFactory.sendResetEmail(loginUser, "Password").then(function (resp) {
                    loginUser.passwordResetEmailSent = true;
                    toaster.pop('success', 'Request Password Reset', 'Email sent');
                });
                break;
        }
    };
    ctrl.sendWelcomeEmail = function (loginUser) {
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.sendWelcomeEmail(loginUser.userId).then(function (resp) {
            //success
            toaster.pop('success', 'Send Welcome', 'Email sent');
        }, function (error) {
            console.log("failed to send email");
        });
    };

    ctrl.updateDatabaseFlag = function (field, flag, loginUser) {
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.updateDatabaseFlag(field, flag, loginUser).then(function (resp) {
            //success
            var title = "";
            var action = "";

            switch (field) {
                case "2Fa":
                    title = "Two-factor Authentication (2FA) Change";
                    break;
                case "Password":
                    title = "Password Change";
                    break;
                case "Username":
                    title = "Username Change";
                    break;
            }

            switch (field) {
                case "0":
                    action = "No Action";
                    break;
                case "1":
                    action = "Recommended";
                    break;
                case "2":
                    action = "Required";
                    break;
            }
            toaster.pop('success', title, loginUser.fullName + ' (' + loginUser.userName + ')' + action);
        }, function (error) {
            console.log("Failed to updateDatabaseFlag()");
        });
    };

    ctrl.clearSecret = function (loginUser) {

        {
            var fn = function modalController($uibModalInstance, translation) {
                this.translation = _translation;
                this.tmpConfirmMessageA = "Are you sure you want to clear Two-factor Authentication" + "?";

                this.ok = function () {
                    $uibModalInstance.close(event);
                };

                this.cancel = function () {
                    $uibModalInstance.dismiss(event);
                };
            };

            fn.$inject = ['$uibModalInstance', 'translation'];

            var modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
                controller: fn,
                controllerAs: '$ctrl',
                size: 'sm',
                resolve: {
                    translation: function translation() {
                        ctrl.translation;
                    }
                }
            });

            modalInstance.result.then(function (event) {
                event.preventDefault();
                event.stopPropagation();
                var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
                _loginsFactory.clearSecret(loginUser.userId).then(function (resp) {
                    //success
                    toaster.pop('success', 'Two-factor Authentication (2FA)', loginUser.fullName + ' (' + loginUser.userName + ')' + ', Cleared!');
                    loginUser.twoFaSecretReset = true;
                    for (var i = 0; i < ctrl.logins.length; i++) {
                        if (ctrl.logins[i].userId == loginUser.userId) {
                            ctrl.logins[i].mfaMigrationStatus = 1;
                            break;
                        }
                    }
                }, function (error) {
                    console.log("Failed to Clear Two-factor Authentication (2FA)");
                });
            }, function (event) {
                event.preventDefault();
                event.stopPropagation();
                //cancel button
                console.log("cancel");
            });
        }
    };

    ctrl.suspend2Fa = function (loginUser, suspend2FaHours) {
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.suspend2Fa(loginUser.userId, suspend2FaHours).then(function (resp) {
            //success
            toaster.pop('success', 'Two-factor Authentication (2FA)', loginUser.fullName + ' (' + loginUser.userName + ')' + ', Suspended for ' + suspend2FaHours + 'hrs!');
        }, function (error) {
            console.log("Failed to Suspend Two-factor Authentication (2FA)");
        });
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            case "fullName":
            case "email":
            case "vxmlPhone":
            case "vxmlPsw":
            case "userName":
                return value.length > 0;
            case "administrator":
            case "isMerlin":
            case "accessLevel":
            case "defaultDesktopID":
                return true;
            default:
                return false;
        }
    };

    ctrl.updateValue = function (item, propertyName) {
        var tmpServiceUserPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.patchData(item.userId, tmpServiceUserPatch).then(function (resp) {
            ctrl.resp = resp.data;
            for (var i = 0; i < ctrl.logins.length; i++) {
                if (ctrl.logins[i].userId == resp.data.userId) {
                    ctrl.logins[i].userName = resp.data.userName;
                    ctrl.logins[i].lastAccessLevel = resp.data.accessLevel;
                }
            };
        });
    };

    ctrl.onKeyUpValidate = function (idx) {

        var regExpn = /^("(?:[!#-\[\]-~]|\\[\t -~])*"|[!#-'*+\-/-9=?A-Z\^-~](?:\.?[!#-'*+\-/-9=?A-Z\^-~])*)@([!#-'*+\-/-9=?A-Z\^-~](?:\.?[!#-'*+\-/-9=?A-Z\^-~])*|\[[!-Z\^-~]*\])$/;

        if (ctrl.logins[idx].email.length === 0) {
            ctrl.logins[idx].invalidEmail = false;
        } else if (regExpn.test(String(ctrl.logins[idx].email).toLowerCase())) {

            ctrl.logins[idx].invalidEmail = false;
        } else {

            ctrl.logins[idx].invalidEmail = true;
        }
    };

    ctrl.onKeyUpValidatePhonePin = function (idx) {
        ctrl.onKeyUpValidatePhone(idx);
        ctrl.onKeyUpValidatePin(idx);
        ctrl.isPhonePinDuplicate(idx);
    };

    ctrl.onKeyUpValidatePhone = function (idx) {

        //Set vxmlPhone to "" if value is Null
        if (ctrl.logins[idx].vxmlPhone == null) {
            ctrl.logins[idx].vxmlPhone = "";
        };

        //Check if Pin field is required
        ctrl.onKeyUpValidateRequirePhone(idx);
        ctrl.onKeyUpValidateRequirePin(idx);

        //Check is input is Number, and its length >=10
        if (ctrl.logins[idx].vxmlPhone.toString().length >= 10 && !isNaN(ctrl.logins[idx].vxmlPhone)) {

            ctrl.logins[idx].invalidPhone = false;
        }
        //If phone not required and is empty, no alert displayed
        else if (!ctrl.logins[idx].requirePhone && ctrl.logins[idx].vxmlPhone.toString().length === 0) {

                ctrl.logins[idx].invalidPhone = false;
            }
            //If phone is required and is empty
            else if (ctrl.logins[idx].requirePhone && ctrl.logins[idx].vxmlPhone.toString().length === 0) {

                    ctrl.logins[idx].invalidPhone = false;
                } else {
                    ctrl.logins[idx].invalidPhone = true;
                }

        ctrl.pinPhoneAlerts(idx);
    };

    ctrl.onKeyUpValidateRequirePhone = function (idx) {

        //Set vxmlPsw to "" if value is Null
        if (ctrl.logins[idx].vxmlPsw == null) {
            ctrl.logins[idx].vxmlPsw = "";
        };

        //Check if pin is completed, then require Phone
        if (ctrl.logins[idx].vxmlPsw.toString().length >= 4 && !isNaN(ctrl.logins[idx].vxmlPsw)) {

            //if both are complete require completion of neither
            if (ctrl.logins[idx].vxmlPhone.toString().length >= 10 && !isNaN(ctrl.logins[idx].vxmlPhone)) {
                ctrl.logins[idx].requirePhone = false;
            }
            //else require user to complete phone
            else {
                    ctrl.logins[idx].requirePhone = true;
                }
        } else {
            ctrl.logins[idx].requirePhone = false;
        }
    };

    ctrl.onKeyUpValidatePin = function (idx) {

        //Set vxmlPin to "" if value is Null
        if (ctrl.logins[idx].vxmlPsw == null) {
            ctrl.logins[idx].vxmlPsw = "";
        };

        //Check if Phone field is required
        ctrl.onKeyUpValidateRequirePhone(idx);
        ctrl.onKeyUpValidateRequirePin(idx);
        ctrl.isPhonePinDuplicate(idx);

        //Check pin starts with 0
        if (ctrl.logins[idx].vxmlPsw.toString().length > 0 && ctrl.logins[idx].vxmlPsw.toString()[0] == '0') {

            ctrl.logins[idx].pinStartsWithZero = true;
        } else {
            ctrl.logins[idx].pinStartsWithZero = false;
        }

        //Check is input is Number, and its length = 5
        if (ctrl.logins[idx].vxmlPsw.toString().length >= 4 && !isNaN(ctrl.logins[idx].vxmlPsw)) {

            ctrl.logins[idx].invalidPin = false;
        }
        //If pin not required and is empty, no alert displayed
        else if (!ctrl.logins[idx].requirePin && ctrl.logins[idx].vxmlPsw.toString().length === 0) {

                ctrl.logins[idx].invalidPin = false;
            }
            //If pin is required and is empty
            else if (ctrl.logins[idx].requirePin && ctrl.logins[idx].vxmlPsw.toString().length === 0) {

                    ctrl.logins[idx].invalidPin = false;
                } else {
                    ctrl.logins[idx].invalidPin = true;
                }

        ctrl.pinPhoneAlerts(idx);
    };

    ctrl.onKeyUpValidateRequirePin = function (idx) {

        //Set vxmlPhone to "" if value is Null
        if (ctrl.logins[idx].vxmlPhone == null) {
            ctrl.logins[idx].vxmlPhone = "";
        };

        //Check if phone is completed, then require pin
        if (ctrl.logins[idx].vxmlPhone.toString().length >= 10 && !isNaN(ctrl.logins[idx].vxmlPhone)) {

            //if both are complete require completion of neither
            if (ctrl.logins[idx].vxmlPsw.toString().length >= 4 && !isNaN(ctrl.logins[idx].vxmlPsw)) {
                ctrl.logins[idx].requirePin = false;
            }
            //else require user to complete pin
            else {
                    ctrl.logins[idx].requirePin = true;
                }
        } else {
            ctrl.logins[idx].requirePin = false;
        }
    };

    ctrl.isPhonePinDuplicate = function (idx) {

        //Ensure Values are not Null or empty
        if (ctrl.logins[idx].vxmlPhone && ctrl.logins[idx].vxmlPsw) {

            var duplicateCount = 0;

            //Check for Duplicate Phone/Pin combinations
            ctrl.logins.map(function (login) {
                if (login.vxmlPhone == ctrl.logins[idx].vxmlPhone && login.vxmlPsw == ctrl.logins[idx].vxmlPsw) {
                    duplicateCount++;
                }
            });

            if (duplicateCount >= 2) {
                ctrl.logins[idx].phonePinDuplicate = true;
            }
            //No duplicates
            else {
                    ctrl.logins[idx].phonePinDuplicate = false;
                }
        }
        //No duplicates
        else {
                ctrl.logins[idx].phonePinDuplicate = false;
            }
    };

    //Returns Alert Message
    ctrl.pinPhoneAlerts = function (idx) {

        //Phone Alert Message
        ctrl.logins[idx].phoneFailsChecks = ctrl.logins[idx].invalidPhone || ctrl.logins[idx].requirePhone || ctrl.logins[idx].phonePinDuplicate ? true : true;
        if (ctrl.logins[idx].invalidPhone) {
            ctrl.logins[idx].phoneAlertMessage = ctrl.translation.text.INVALID_PHONE;
        } else if (ctrl.logins[idx].requirePhone) {
            ctrl.logins[idx].phoneAlertMessage = ctrl.translation.text.PHONE_NEEDED;
        } else if (ctrl.logins[idx].phonePinDuplicate) {
            ctrl.logins[idx].phoneAlertMessage = ctrl.translation.text.DUPLICATE_PHONE_PIN;
        } else {
            ctrl.logins[idx].phoneFailsChecks = false;
            ctrl.logins[idx].phoneAlertMessage = "";
        }

        //Pin Alert Message
        ctrl.logins[idx].pinFailsChecks = ctrl.logins[idx].invalidPin || ctrl.logins[idx].requirePin || ctrl.logins[idx].phonePinDuplicate || ctrl.logins[idx].pinStartsWithZero ? true : false;
        if (ctrl.logins[idx].invalidPin) {
            ctrl.logins[idx].pinAlertMessage = ctrl.translation.text.INVALID_PIN;
        } else if (ctrl.logins[idx].requirePin) {
            ctrl.logins[idx].pinAlertMessage = ctrl.translation.text.PIN_NEEDED;
        } else if (ctrl.logins[idx].pinStartsWithZero) {
            ctrl.logins[idx].pinAlertMessage = ctrl.translation.text.PIN_STARTS_WITH_INT;
        } else if (ctrl.logins[idx].phonePinDuplicate) {
            ctrl.logins[idx].pinAlertMessage = ctrl.translation.text.DUPLICATE_PHONE_PIN;
        } else {
            ctrl.logins[idx].pinAlertMessage = "";
            ctrl.logins[idx].pinFailsChecks = false;
        }
    };

    ctrl.formatPhoneNumberDisplay = function (f_val) {
        if (typeof f_val === "undefined" || !f_val) return f_val;
        f_val = f_val.replace(/\D/g, '');
        //f_val = f_val.substring(0, 1) == "1" ? f_val.substring(1, f_val.lenght) : f_val;
        f_val = f_val.length > 10 ? f_val.replace(/(\d{3})(\d{3})(\d{4})(\d{4})/, "($1) $2-$3 ext. $4") : f_val.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        return f_val;
    };

    ctrl.getLoginStatusIcon = function (loginStatus) {
        switch (loginStatus) {
            case 1:
                return '🟢 ';
            case 2:
            case 3:
                return '🟡 ';
            default:
                return '🔴 ';
        }
    };

    ctrl.openCommonModal = function (item, deleteUser, superAdminUpdate, newSuperAdmin) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            if (deleteUser) {
                this.tmpConfirmMessageA = this.translation.text.DELETE_ACCOUNT_MESSAGE_A + item.fullName + this.translation.text.DELETE_ACCOUNT_MESSAGE_B;
            } else if (superAdminUpdate) {
                this.tmpConfirmMessageA = this.translation.text.READONLY_ACCOUNT_MESSAGE_A + item.fullName + (' ' + this.translation.text.TO + ' ') + this.translation.text['USER_ROLE_' + item.accessLevel] + ", " + this.translation.text.NEW_SUPER_ADMIN + ".";
            } else if (newSuperAdmin) {
                this.tmpConfirmMessageA = this.translation.text.NEW_USER_PRIVILEGES + " " + item.fullName + (' ' + this.translation.text.TO + ' ') + this.translation.text['USER_ROLE_' + item.accessLevel] + ", " + this.translation.text.NEW_SUPER_ADMIN + ".";
            } else {
                this.tmpConfirmMessageA = this.translation.text.READONLY_ACCOUNT_MESSAGE_A + item.fullName + (' ' + this.translation.text.TO + ' ') + this.translation.text['USER_ROLE_' + item.accessLevel];
            }
            this.tmpConfirmMessageB = this.translation.text.DELETE_ACCOUNT_MESSAGE_C;
            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                if (!deleteUser && !newSuperAdmin) {
                    var index = ctrl.logins.findIndex(function (l) {
                        return l.userId == item.userId;
                    });
                    //Reset access to last value
                    ctrl.logins[index].accessLevel = ctrl.logins[index].lastAccessLevel;
                }

                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            if (deleteUser) {
                var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
                _loginsFactory.delete(item.userId, item.userName).then(function (resp) {
                    var index = ctrl.logins.indexOf(item);
                    if (index !== -1) {
                        ctrl.logins.splice(index, 1);
                    }
                    ctrl.addMode = null;
                    ctrl.editMode = null;
                });
            } else if (newSuperAdmin) {
                ctrl.postAccount(item);
            } else {
                ctrl.patchData(item, 'accessLevel');
            }
        }, function () {
            // cancel button
        });
    };

    ctrl.unlockAccount = function (item, index) {
        $scope.alerts = [];
        ctrl.editModeIndex = null;
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            this.tmpConfirmMessageA = "Unlock " + (item.fullName + ', ' + item.email) + ".";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
            _loginsFactory.unlockUser(item.userId, item.userName).then(function (resp) {
                ctrl.getLogins();
            });
        }, function () {
            // cancel button
        });
    };
}
angular.module('mc.user-accounts').controller('manageUserController', ManageUserController);
ManageUserController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'LoginsFactory', '$uibModal', '$element', '$timeout', 'datetimeService', 'savePdfService', 'registerWebinarService', 'unsavedChangesService', 'desktopViewListService', 'toaster'];
'use strict';

angular.module('mc.user-accounts').component('manageUser', {
    controller: ManageUserController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/account/useraccounts/manageuser/manage-user-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.directive('focusOn', ["$timeout", function ($timeout) {
    return function (scope, element, attrs) {
        scope.$on(attrs.focusOn, function (e) {
            $timeout(function () {
                element[0].focus();
            }, 0);
        });
    };
}]);
mcapp.directive('missionAlert', function () {
    return {
        restrict: 'E',
        replace: true,
        template: function(element, attrs){
            return '<uib-alert ng-repeat="alert in alerts" type="{{alert.type}}"' + (attrs.needClose ? 'close="closeAlert($index)">{{alert.msg}}</uib-alert>' : '>{{alert.msg}}</uib-alert>');
        },   
        link: function ($scope, element, attrs) {
            $scope.alerts = [];
            $scope.closeAlert = function (index) {
                $scope.alerts.splice(index, 1);
            };
        }
    };
});


angular.module("datePickerMod", []).directive('datePicker', ["$parse", function ($parse) {
    var uniqueId = 1;
    return {
        restrict: "E",
        replace: true,
        transclude: false,
        compile: function (element, attrs) {
            var modelAccessor = $parse(attrs.ngModel);
            var tmpId = 'item' + uniqueId++;
            var html = "<input type='hidden' id='" + tmpId + "' >" +
               "</input>";

            var newElem = $(html);
            element.replaceWith(newElem);

            return function (scope, element, attrs, controller) {

                var processChange = function () {
                    var date = new Date(element.datepicker("getDate"));

                    scope.$apply(function (scope) {
                        // Change bound variable
                        modelAccessor.assign(scope, date);
                    });
                };

                element.datepicker({
                    showOn: "button",
                    buttonImage: "images/calendar.gif",
                    buttonImageOnly: true,
                    buttonText: "Select date",
                    onClose: processChange,
                    onSelect: processChange
                });

                scope.$watch(modelAccessor, function (val) {
                    var date = new Date(val);
                    element.datepicker("setDate", date);
                });

            };

        }
    };
}]);
'use strict';

function ManageSecurityService(HOST, $http) {

    function GetSecuritySetting(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/SecuritySetting',
            params: { customerId: customerId }
        });
    }

    //create new SecuritySetting => Add operation
    function PostSecuritySetting(customerId, securitySetting) {
        return $http({
            method: 'POST',
            url: HOST + '/api/SecuritySetting',
            data: securitySetting,
            params: { customerId: customerId }
        });
    }

    function PatchSecuritySetting(customerId, securitySettingPatch) {
        return $http({
            method: 'PATCH',
            url: HOST + '/api/SecuritySetting',
            data: securitySettingPatch,
            params: { customerId: customerId }
        });
    }

    //update  SecuritySetting => update operation
    function UpdateSecuritySetting(customerId, securitySetting) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/SecuritySetting',
            data: securitySetting,
            params: { customerId: customerId }
        });
    }

    function DeleteSecuritySetting(customerId, userName) {
        return $http({
            method: "Delete",
            url: HOST + '/api/TwoFactorAuthenticationUndo',
            params: { customerId: customerId, userName: userName },
            cache: false
        });
    }

    return {
        GetSecuritySetting: GetSecuritySetting,
        PostSecuritySetting: PostSecuritySetting,
        PatchSecuritySetting: PatchSecuritySetting,
        UpdateSecuritySetting: UpdateSecuritySetting,
        DeleteSecuritySetting: DeleteSecuritySetting
    };
}

ManageSecurityService.$inject = ['HOST', '$http'];

angular.module('mc.user-accounts').factory('manageSecurityService', ManageSecurityService);
"use strict";

function ManageSecurityController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, manageSecurityService, $uibModal, $element, $timeout, datetimeService, savePdfService, registerWebinarService, unsavedChangesService, desktopViewListService, toaster) {
    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.isMcAdmin = false;
    ctrl._loading = false;

    //default security properties
    ctrl.enforce2FA = false;
    ctrl.enforceStrongPwd = false;
    ctrl.invalidExpDate = false;
    //ctrl.enforcePwdExpInterval = false;
    //ctrl.enforceAutoUserLogoff = false;
    //ctrl.customerMFAMigrationExpDate = datetimeService.currentTimeLocal().format('YYYY-MM-DD');   //`${(new Date()).getYear() + 1900}-01-01T00:00:00`;;

    var defaultPwdLength = 8;
    var default2FAType = 3; //AuthenticationApp
    var defaultPwdExpInterval = 90; //90days
    var defaultUserLogoffDuration = 120; //120 minutes

    ctrl.initMode = false;
    ctrl.isDirty = false;
    ctrl.patchMode = false;
    ctrl.updateMode = false;
    var _existingSS = {};

    ctrl.customerMFAMigrationExpDateEditable = true;
    ctrl.isFirsttime = false; //determines whether it is first time launching the view and site security settings were not created yet.

    var spinner = "<i class='fa fa-spinner fa-2x fa-spin'></i>";
    var okCheck = "";
    ctrl.dateFormat = "MM/dd/yyyy";

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.isSuperAdmin = sharedSetupService.isSuperAdmin(ctrl.accountInfo);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;

        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(ctrl);

        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl.mobile = $rootScope.mobile;

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        //if (!$rootScope.mobile && !$rootScope.classicView) {
        //    this._popup = _this.getExistingDialog(this.windowId).ref;
        //    $(this._popup).on('dialogbeforeclose', (event) => {
        //        unsavedChangesService.checkUnsavedChanges(event, this._popup, this, ctrl.isDirty == true)
        //    });
        //}

        _getSecuritySetting();
    };

    var _updateUiMode = function _updateUiMode(modeType, modeValue) {
        switch (modeType) {
            case "init":
                ctrl.initMode = modeValue !== undefined ? modeValue : true;
                break;
            case "dirty":
                ctrl.isDirty = modeValue !== undefined ? modeValue : true;
                break;
            case "patch":
                ctrl.patchMode = modeValue !== undefined ? modeValue : true;
                break;
            case "update":
                ctrl.updateMode = modeValue !== undefined ? modeValue : true;
                break;
        }
    };

    var _initUi = function _initUi() {
        ctrl.invalidExpDate = false;
        ctrl.enforce2FA = false;
        ctrl.enforceStrongPwd = false;
        ctrl.pwdExpInterval = {
            "id": "0",
            "days": "None"
        };
        ctrl.forceLogoffDuration = {
            "id": "0",
            "mins": "None"
        };
        _updateSwitchLabel();
    };

    var _enforce2FaAndPwd = function _enforce2FaAndPwd() {
        _init2Fa();
        if (!ctrl.enforceStrongPwd) _enforceStrongPwd();
        //_initPwdExpInterval();
        //_initAutoUserLogoffInterval();
    };
    var _enforceStrongPwd = function _enforceStrongPwd() {
        ctrl.enforceStrongPwd = true;
        _initPwd();

        //NOTE: this values are not saved in the backend, these are UI only
        ctrl.pwdUppercase = true;
        ctrl.pwdNoSpaces = true;
        ctrl.pwdLowercase = true;
        ctrl.pwdSpecialChars = true;
        ctrl.pwdDigits = true;
    };
    var _init2Fa = function _init2Fa() {
        ctrl.twoFactorAuthenticationType = default2FAType;
    };
    var _initPwd = function _initPwd() {
        ctrl.pwdLength = {
            "id": "1",
            "chars": defaultPwdLength //default value: 8 chars
        };
        //NOTE: this values are not saved in the backend, these are UI only
        ctrl.pwdUppercase = true;
        ctrl.pwdNoSpaces = true;
        ctrl.pwdLowercase = true;
        ctrl.pwdSpecialChars = true;
        ctrl.pwdDigits = true;
    };
    var _initPwdExpInterval = function _initPwdExpInterval() {
        ctrl.pwdExpInterval = {
            "id": "0",
            "days": "None"
        };
    };
    var _initForceLogoffDuration = function _initForceLogoffDuration() {
        ctrl.forceLogoffDuration = {
            "id": "0",
            "days": "None"
        };
    };

    // NOTE: value in Days
    ctrl.pwdExpInervals = [{
        "id": "0",
        "days": "None"
    }, {
        "id": "1",
        "days": "30"
    }, {
        "id": "2",
        "days": "60"
    }, {
        "id": "3",
        "days": "90"
    }, {
        "id": "4",
        "days": "120"
    }];

    ctrl.forceLogoffOptions = [{
        "id": "0",
        "days": "None"
    }, {
        "id": "1",
        "days": "15"
    }, {
        "id": "2",
        "days": "30"
    }, {
        "id": "3",
        "days": "120"
    }];

    ctrl.pwdCharsOptions = [{
        "id": "1",
        "chars": "8" //default value: 8 chars
    }, {
        "id": "2",
        "chars": "10"
    }, {
        "id": "3",
        "chars": "12"
    }, {
        "id": "4",
        "chars": "14"
    }, {
        "id": "5",
        "chars": "16"
    }, {
        "id": "6",
        "chars": "18"
    }, {
        "id": "7",
        "chars": "20"
    }, {
        "id": "8",
        "chars": "25"
    }];

    var _updateSwitchLabel = function _updateSwitchLabel() {
        ctrl.enforce2FALabel = ctrl.enforce2FA == true ? ctrl.translation.text.OFF : ctrl.translation.text.ON;
        ctrl.enforceStrongPwdLabel = ctrl.enforceStrongPwd == true ? ctrl.translation.text.OFF : ctrl.translation.text.ON;
        $(".bootstrap-switch-label").css("color", "grey");
    };

    ctrl.onUserSelection = function (varProperty) {
        switch (varProperty) {
            case "enforce2FA":
                ctrl.updateStatusTwoFA = spinner;
                if (ctrl.enforce2FA) {
                    //if ON
                    if (ctrl.initMode) {
                        _updateUiMode("dirty");
                        //UI should render default 2fa ui controls
                        //UI should render default enforce strong pwd ui controls
                        _enforce2FaAndPwd();
                    } else if (ctrl.patchMode) {
                        if (_existingSS.minPwdLengthOfNChars == -1) {
                            //update both 2fa and strong pwd
                            _enforce2FaAndPwd();
                            _updateSecuritySetting();
                        } else {
                            //just patch 2fa
                            _init2Fa();
                            _patchSecuritySetting("twoFactorAuthenticationType", default2FAType); // updating with default 2FAType
                        }
                    }
                } else {
                    // if OFF
                    ctrl.twoFactorAuthenticationType = -1;
                    ctrl.customerMFAMigrationExpDate = null;
                    if (ctrl.patchMode) _updateSecuritySetting();
                    //_patchSecuritySetting("twoFactorAuthenticationType", -1);
                }
                _updateSwitchLabel();
                break;
            case "twoFactorAuthenticationType":
                if (ctrl.patchMode) {
                    _patchSecuritySetting("twoFactorAuthenticationType", ctrl.twoFactorAuthenticationType);
                }
                break;
            case "customerMFAMigrationExpDate":
                ctrl.invalidExpDate = false;
                if (ctrl.patchMode) {
                    ctrl.customerMFAMigrationExpDateUpdate = spinner;
                    _patchSecuritySetting("customerMFAMigrationExpDate", ctrl.customerMFAMigrationExpDate);
                }
                break;
            case "enforceStrongPwd":
                ctrl.updateStatusEnforceStrongPwd = spinner;
                if (ctrl.enforceStrongPwd) {
                    //if ON
                    if (ctrl.initMode) {
                        _updateUiMode("dirty");
                        _enforceStrongPwd();
                    } else if (ctrl.patchMode) {
                        _enforceStrongPwd();
                        _patchSecuritySetting("minPwdLengthOfNChars", ctrl.pwdLength.chars);
                    }
                } else {
                    ctrl.pwdLength = {};
                    if (ctrl.patchMode) {
                        _patchSecuritySetting("minPwdLengthOfNChars", -1);
                    }
                }
                _updateSwitchLabel();
                break;
            case "minPwdLengthOfNChars":
                if (ctrl.patchMode) {
                    ctrl.minPwdLengthOfNCharsUpdate = spinner;
                    _patchSecuritySetting("minPwdLengthOfNChars", ctrl.pwdLength.chars);
                }
                break;
            case "pwdResetEveryNDays":
                if (ctrl.initMode) _updateUiMode("dirty");else if (ctrl.patchMode) {
                    ctrl.pwdResetEveryNDaysUpdate = spinner;
                    var noOfDays = ctrl.pwdExpInterval.days;
                    if (ctrl.pwdExpInterval.id == 0) noOfDays = -1;
                    _patchSecuritySetting("pwdResetEveryNDays", noOfDays);
                }
                break;
            case "forceLogoffDuration":
                if (ctrl.initMode) _updateUiMode("dirty");else if (ctrl.patchMode) {
                    var _noOfDays = ctrl.forceLogoffDuration.days;
                    if (ctrl.forceLogoffDuration.id == 0) _noOfDays = -1;
                    _patchSecuritySetting("forceLogoffAfterNDays", _noOfDays);
                }
                break;
            case "save":
                //save the user selections to DB
                //determine whether it is initial post or update scenario
                if (ctrl.initMode && ctrl.isDirty) {
                    //post to service
                    _createSecuritySetting();
                }
        }

        //now update the settings on the backend. make webapi call

        switch (varProperty) {
            case "enforce2FA":
                ctrl.updateStatusTwoFA = okCheck;
                break;
            case "enforceStrongPwd":
                ctrl.updateStatusEnforceStrongPwd = okCheck;
                break;
        }
    };

    ctrl.openConfirmationModal = function (option) {
        if (option != "cancle") ctrl.enforce2FA = !ctrl.enforce2FA;
        function modalController($uibModalInstance, translation) {
            var _this = this;

            this.translation = translation;
            this.customerName = ctrl.accountInfo.customerName;
            this.checkButtonShow = option != "cancle" && ctrl.enforce2FA;
            this.check2fa = false;
            if (option == "cancle") {
                this.tmpConfirmMessageB = "Exit without saving?";
            } else {
                this.tmpConfirmMessageB = ctrl.enforce2FA ? "Turn Off Two-factor Authentication." : "Turn on Two-factor Authentication.";
            }
            this.ok = function () {
                $uibModalInstance.close(event);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss(event);
            };

            this.check2faConfirm = function () {
                _this.check2fa = !_this.check2fa;
            };

            this.validateBtn = function () {
                return _this.checkButtonShow && !_this.check2fa;
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: option == "cancle" || ctrl.enforce2FA ? 'ui/components/scadaviews/confirmation-popover.html' : 'ui/components/scadaviews/confirmation-popover-manage-security.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            if (option == "cancle") {
                ctrl.enforce2FA = false;
                ctrl.clear2fa();
            } else {
                ctrl.enforce2FA = !ctrl.enforce2FA;
                ctrl.onUserSelection('enforce2FA');
            }
        }, function () {
            // cancel button
        });
    };

    ctrl.clear2fa = function () {
        _updateUiMode("init");
        _updateUiMode("dirty", false);
        _initUi();
    };

    ctrl.cancle = function () {
        if (ctrl.isDirty) {
            ctrl.openConfirmationModal("cancle");
        } else {
            ctrl.clear2fa();
        }
    };

    var _loadRespData = function _loadRespData(respData) {
        $timeout(function () {
            _updateUiMode("dirty", false);

            if (respData !== null) {
                ctrl.customerMFAMigrationExpDateUpdate = okCheck;
                ctrl.minPwdLengthOfNCharsUpdate = okCheck;
                ctrl.pwdResetEveryNDaysUpdate = okCheck;
                _updateUiMode("patch");

                // for future references, store the existing object
                _storeSecuritySetting(respData);

                if (respData.twoFactorAuthenticationType == -1) {
                    ctrl.enforce2FA = false;
                } else {
                    ctrl.enforce2FA = true;
                    ctrl.twoFactorAuthenticationType = respData.twoFactorAuthenticationType;
                    ctrl.customerMFAMigrationExpDate = respData.customerMFAMigrationExpDate;
                    if (respData.customerMFAMigrationExpDate) {
                        _customerMFAMigrationExpDateEditable(respData.customerMFAMigrationExpDate);
                    }
                }

                if (respData.minPwdLengthOfNChars == -1) {
                    ctrl.enforceStrongPwd = false;
                    ctrl.pwdLength = {
                        //"id": "0",
                        //"chars": "-1"
                    };
                } else {
                    ctrl.enforceStrongPwd = true;
                    ctrl.pwdLength = ctrl.pwdCharsOptions.find(function (x) {
                        return x.chars == respData.minPwdLengthOfNChars;
                    });

                    //NOTE: this values are not saved in the backend, these are UI only
                    ctrl.pwdUppercase = true;
                    ctrl.pwdNoSpaces = true;
                    ctrl.pwdLowercase = true;
                    ctrl.pwdSpecialChars = true;
                    ctrl.pwdDigits = true;
                }

                if (respData.pwdResetEveryNDays == -1) {
                    ctrl.pwdExpInterval = {
                        "id": "0",
                        "days": "None"
                    };
                } else {
                    /*ctrl.enforcePwdExpInterval = true;*/
                    //find the object of the pwdExpInterval
                    ctrl.pwdExpInterval = ctrl.pwdExpInervals.find(function (x) {
                        return x.days == respData.pwdResetEveryNDays;
                    });
                }

                if (respData.forceLogoffAfterNDays == -1) {
                    ctrl.forceLogoffDuration = {
                        "id": "0",
                        "days": "None"
                    };
                } else {
                    ctrl.forceLogoffDuration = ctrl.forceLogoffOptions.find(function (x) {
                        return x.days == respData.forceLogoffAfterNDays;
                    });
                }

                _updateSwitchLabel();
            } else {
                // response is null
                _updateUiMode("init");
                _initUi();
            }
            ctrl._loading = false;
        }, 0);
    };

    //this function useful for comparing user input with existing data, to make decision whether user made changes to data or not
    var _storeSecuritySetting = function _storeSecuritySetting(ss) {
        _existingSS = JSON.parse(JSON.stringify(ss));
    };

    //this function using for Migration Exp Date editable
    var _customerMFAMigrationExpDateEditable = function _customerMFAMigrationExpDateEditable(date) {
        var currentDate = new Date();
        var endOfCurrentDate = new Date(currentDate.setHours(0, 0, 0, 0)); // End of the current date

        var MigrationExpDate = new Date(date);
        MigrationExpDate.setHours(0, 0, 0, 0); // Set time to end of the specified date

        ctrl.customerMFAMigrationExpDateEditable = MigrationExpDate > endOfCurrentDate ? true : false;
    };

    var _getSecuritySetting = function _getSecuritySetting() {
        ctrl._loading = true;

        manageSecurityService.GetSecuritySetting(ctrl.accountInfo.customerId).then(function (resp) {

            _loadRespData(resp.data);
        }, function (err) {
            // console.log(resp);
            ctrl._loading = false;
        });
    };
    var _patchSecuritySetting = function _patchSecuritySetting(patchPath, patchValue) {
        var patch = { op: 'replace', path: patchPath, value: patchValue };
        manageSecurityService.PatchSecuritySetting(ctrl.accountInfo.customerId, patch).then(function (resp) {
            _loadRespData(resp.data);
        }, function (resp) {//console.log(resp);
        });
    };

    var _createSecuritySetting = function _createSecuritySetting() {
        // first extract user selection
        var _2faAuthType = -1;
        var _pwdLengthOfChars = -1;
        var _pwdExpInterval = -1;
        var _forceLogoffDuration = -1;
        var _migrateBeforeDate = null;

        ctrl.invalidExpDate = ctrl.customerMFAMigrationExpDate ? false : true;

        if (ctrl.enforce2FA) {
            //if ON
            _2faAuthType = ctrl.twoFactorAuthenticationType;
            _migrateBeforeDate = ctrl.customerMFAMigrationExpDate;
        }

        if (ctrl.enforceStrongPwd) //if ON
            _pwdLengthOfChars = ctrl.pwdLength.chars;

        if (ctrl.pwdExpInterval.id != "0") _pwdExpInterval = ctrl.pwdExpInterval.days;

        if (ctrl.forceLogoffDuration.id != "0") _forceLogoffDuration = ctrl.forceLogoffDuration.days;

        var newSecuritySetting = {
            customerId: ctrl.accountInfo.customerId,
            customerMFAMigrationExpDate: _migrateBeforeDate,
            twoFactorAuthenticationType: _2faAuthType,
            minPwdLengthOfNChars: _pwdLengthOfChars,
            pwdResetEveryNDays: _pwdExpInterval,
            forceLogoffAfterNDays: _forceLogoffDuration
        };

        if (!ctrl.invalidExpDate) {
            manageSecurityService.PostSecuritySetting(ctrl.accountInfo.customerId, newSecuritySetting).then(function (resp) {
                _updateUiMode("init", false);
                _loadRespData(resp.data);;
            }, function (resp) {//console.log(resp);
            });
        }
    };

    var _updateSecuritySetting = function _updateSecuritySetting() {
        // first extract user selection
        var _2faAuthType = -1;
        var _pwdLengthOfChars = -1;
        var _pwdExpInterval = -1;
        var _forceLogoffDuration = -1;
        var _migrateBeforeDate = null;

        if (ctrl.enforce2FA) {
            //if ON
            _2faAuthType = ctrl.twoFactorAuthenticationType;
            _migrateBeforeDate = ctrl.customerMFAMigrationExpDate;
        }

        if (ctrl.enforceStrongPwd) //if ON
            _pwdLengthOfChars = ctrl.pwdLength.chars;

        if (ctrl.pwdExpInterval.id != "0") _pwdExpInterval = ctrl.pwdExpInterval.days;

        if (ctrl.forceLogoffDuration.id != "0") _forceLogoffDuration = ctrl.forceLogoffDuration.days;

        var newSecuritySetting = {
            customerId: ctrl.accountInfo.customerId,
            customerMFAMigrationExpDate: _migrateBeforeDate,
            twoFactorAuthenticationType: _2faAuthType,
            minPwdLengthOfNChars: _pwdLengthOfChars,
            pwdResetEveryNDays: _pwdExpInterval,
            forceLogoffAfterNDays: _forceLogoffDuration
        };

        if (newSecuritySetting.customerMFAMigrationExpDate) {
            manageSecurityService.UpdateSecuritySetting(ctrl.accountInfo.customerId, newSecuritySetting).then(function (resp) {
                _loadRespData(resp.data);;
            }, function (resp) {//console.log(resp);
            });
        } else {
            manageSecurityService.DeleteSecuritySetting(ctrl.accountInfo.customerId, ctrl.accountInfo.userName).then(function (resp) {
                ctrl.clear2fa();
                _updateUiMode("patch", false);
                // _loadRespData(resp.data);
            }, function (resp) {//console.log(resp);
            });
        }
    };
}
angular.module('mc.user-accounts').controller('manageSecurityController', ManageSecurityController);
ManageSecurityController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'manageSecurityService', '$uibModal', '$element', '$timeout', 'datetimeService', 'savePdfService', 'registerWebinarService', 'unsavedChangesService', 'desktopViewListService', 'toaster'];
'use strict';

angular.module('mc.user-accounts').component('manageSecurity', {
    controller: ManageSecurityController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/account/useraccounts/managesecurity/manage-security-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.user-accounts').factory('AuthorizedUsersFactory', ['$http', 'HOST', function ($http, HOST) {
    var AuthorizedUsersFactory = {};

    var _getAuthorizedUsers = function _getAuthorizedUsers(customerId) {
        return $http({
            method: "Get",
            url: HOST + "/api/AuthorizedUsers?customerId=" + customerId,
            cache: false
        });
    };

    var _getUserRoles = function _getUserRoles(customerId) {
        return $http({
            method: "Get",
            url: HOST + "/api/Logins/Get2FAUsers/?customerId=" + customerId,
            cache: false
        });
    };

    var _updateAuthorizedUserRole = function _updateAuthorizedUserRole(customerId, loginId, userRole) {
        return $http({
            method: "Put",
            url: HOST + "/api/AuthorizedUsers?customerId=" + customerId + "&loginId=" + loginId + "&accessLevel=" + userRole,
            cache: false
        });
    };

    var _removeAuthorizedUser = function _removeAuthorizedUser(customerId, loginId) {
        return $http({
            method: "Delete",
            url: HOST + "/api/AuthorizedUsers?customerId=" + customerId + "&loginId=" + loginId,
            cache: false
        });
    };

    AuthorizedUsersFactory.getAuthorizedUsers = _getAuthorizedUsers;
    AuthorizedUsersFactory.getUserRoles = _getUserRoles;
    AuthorizedUsersFactory.updateAuthorizedUserRole = _updateAuthorizedUserRole;
    AuthorizedUsersFactory.removeAuthorizedUser = _removeAuthorizedUser;

    return AuthorizedUsersFactory;
}]);
'use strict';

function AuthorizedUsersController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, AuthorizedUsersFactory, $uibModal, $element, $timeout, datetimeService, savePdfService, registerWebinarService, unsavedChangesService, desktopViewListService, toaster) {
    var _this = this;

    var ctrl = this;
    ctrl.isMcAdmin = false;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.isSuperAdmin = sharedSetupService.isSuperAdmin(ctrl.accountInfo);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.alerts = [];
        ctrl.mobile = $rootScope.mobile;

        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(ctrl);

        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = true;

        ctrl.editModeIndex = null;

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        //if (!$rootScope.mobile && !$rootScope.classicView) {
        //    this._popup = _this.getExistingDialog(this.windowId).ref;
        //    $(this._popup).on('dialogbeforeclose', (event) => {
        //        //unsavedChangesService.checkUnsavedChanges(event, this._popup, this, ctrl.addMode == -1)
        //    });
        //}
        ctrl.getUserRoles();
        ctrl.getAuthorizedUsers();
    };

    ctrl.getAuthorizedUsers = function () {
        ctrl.authorizedUser = [];
        AuthorizedUsersFactory.getAuthorizedUsers(ctrl.accountInfo.customerId).then(function (dataFromFactory) {
            ctrl._loading = false;
            ctrl.alerts = [];
            ctrl.authorizedUser = dataFromFactory.data;

            // If we didn't get any items back 
            if (ctrl.authorizedUser.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                ctrl.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        }, function (error) {
            //error
        }).then(function (data) {
            ctrl._loading = false;
        });
    };

    ctrl.savePdf = function () {
        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            // pdfTitle: (eval("ctrl.translation.text." + windowTitle)),
            pdfTitle: 'Authorized Users',
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    ctrl.getUserRoles = function () {
        AuthorizedUsersFactory.getUserRoles(ctrl.accountInfo.customerId).then(function (dataFromFactory) {
            ctrl.userRoleList = dataFromFactory.data.userRoleList;
        }, function (error) {
            //error
        });
    };

    ctrl.updateAuthorizedUserRole = function (customer, role, index) {
        AuthorizedUsersFactory.updateAuthorizedUserRole(ctrl.accountInfo.customerId, customer.loginId, role.id).then(function (dataFromFactory) {
            // ctrl.getAuthorizedUsers();
            if (dataFromFactory.data.message == "Updated Successfully") {
                ctrl.authorizedUser[index].accessLevel = role.id;
                ctrl.authorizedUser[index].role = role.value;
            }
            ctrl.editModeIndex = null;
        }, function (error) {
            //error
        });
    };

    ctrl.setEditMode = function (index, customer) {
        ctrl.editModeIndex = ctrl.editModeIndex === index ? null : index;
        if (ctrl.editModeIndex == index) {
            ctrl.customerAccessLevel = ctrl.userRoleList.find(function (role) {
                return role.id == customer.accessLevel;
            });
        };
    };

    ctrl.removeAuthorizedUser = function (index, customer) {
        ctrl.editModeIndex = null;
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = translation.text.REMOVE + " Authorized User " + customer.userFullName + ".";
            this.ok = function () {
                AuthorizedUsersFactory.removeAuthorizedUser(ctrl.accountInfo.customerId, customer.loginId).then(function (dataFromFactory) {
                    if (dataFromFactory.data.message == "Deleted Successfully") {
                        ctrl.authorizedUser.splice(index, 1);
                        if (ctrl.authorizedUser.length === 0) {
                            $scope.alerts.push({ msg: "No Data", type: 'info', languageCode: 'NO_DATA' });
                        } else {
                            $scope.alerts = [];
                        }
                    }
                }, function (error) {
                    //error
                });

                $uibModalInstance.close(customer);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this.translation;
                }
            }
        });
    };
}
angular.module('mc.user-accounts').controller('authorizedUsersController', AuthorizedUsersController);
AuthorizedUsersController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'AuthorizedUsersFactory', '$uibModal', '$element', '$timeout', 'datetimeService', 'savePdfService', 'registerWebinarService', 'unsavedChangesService', 'desktopViewListService', 'toaster'];
'use strict';

angular.module('mc.user-accounts').component('authorizedUsers', {
    controller: AuthorizedUsersController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/account/useraccounts/authorizedusers/authorized-users-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.user-accounts').factory('AuthorizedPortalsFactory', ['$http', 'HOST', function ($http, HOST) {
    var AuthorizedPortalsFactory = {};

    var _getUserRoles = function _getUserRoles(customerId) {
        return $http({
            method: "Get",
            url: HOST + "/api/Logins/Get2FAUsers/?customerId=" + customerId,
            cache: false
        });
    };

    var _getAuthorizedPortals = function _getAuthorizedPortals(customerId) {
        return $http({
            method: "Get",
            url: HOST + "/api/AuthorizedPortals?customerId=" + customerId,
            cache: false
        });
    };

    var _updateAuthorizedPortalsUserRole = function _updateAuthorizedPortalsUserRole(customerId, loginId, pthCustomerId, pthLoginId, userRole) {
        return $http({
            method: "Put",
            url: HOST + "/api/AuthorizedPortals?customerId=" + customerId + "&loginId=" + loginId + "&pthCustomerId=" + pthCustomerId + "&pthLoginId=" + pthLoginId + "&accessLevel=" + userRole,
            cache: false
        });
    };

    var _removeAuthorizedPortalsUser = function _removeAuthorizedPortalsUser(customerId, loginId, pthCustomerId, pthLoginId) {
        return $http({
            method: "Delete",
            url: HOST + "/api/AuthorizedPortals?customerId=" + customerId + "&loginId=" + loginId + "&pthCustomerId=" + pthCustomerId + "&pthLoginId=" + pthLoginId,
            cache: false
        });
    };

    AuthorizedPortalsFactory.getUserRoles = _getUserRoles;
    AuthorizedPortalsFactory.getAuthorizedPortals = _getAuthorizedPortals;
    AuthorizedPortalsFactory.updateAuthorizedPortalsUserRole = _updateAuthorizedPortalsUserRole;
    AuthorizedPortalsFactory.removeAuthorizedPortalsUser = _removeAuthorizedPortalsUser;

    return AuthorizedPortalsFactory;
}]);
'use strict';

function AuthorizedPortalsController($rootScope, $scope, sharedSetupService, translationService, authenticationService, AuthorizedPortalsFactory, $element, savePdfService, $uibModal) {

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.isMcAdmin = false;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.isSuperAdmin = sharedSetupService.isSuperAdmin(ctrl.accountInfo);
        ctrl.isInvestorOwnedUtility = sharedSetupService.isInvestorOwnedUtility(ctrl.accountInfo);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();

        ctrl.authorizedPortalsAccess = ctrl.isSuperAdmin && (ctrl.isMcAdmin || ctrl.isInvestorOwnedUtility) ? true : false;

        ctrl.translation = translationService.translation;
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.alerts = [];

        // need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(ctrl);

        ctrl.editModeIndex = { outer: null, inner: null };
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = true;
        ctrl.getUserRoles();
        ctrl.getAuthorizedPortals();
    };

    ctrl.getUserRoles = function () {
        AuthorizedPortalsFactory.getUserRoles(ctrl.accountInfo.customerId).then(function (dataFromFactory) {
            ctrl.userRoleList = dataFromFactory.data.userRoleList;
        }, function (error) {
            //error
        });
    };

    ctrl.getAuthorizedPortals = function () {
        ctrl.authorizedPortal = [];
        AuthorizedPortalsFactory.getAuthorizedPortals(ctrl.accountInfo.customerId).then(function (dataFromFactory) {
            ctrl._loading = false;
            ctrl.alerts = [];
            ctrl.authorizedPortal = dataFromFactory.data;
            // If response returns no data
            if (ctrl.authorizedPortal.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                ctrl.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        }, function (error) {
            //error
        }).then(function (data) {
            ctrl._loading = false;
        });
    };

    ctrl.savePdf = function () {
        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            // pdfTitle: (eval("ctrl.translation.text." + windowTitle)),
            pdfTitle: 'Authorized Portals',
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    ctrl.setEditMode = function (innerIndex, item, outerIndex) {
        if (ctrl.editModeIndex.outer === outerIndex && ctrl.editModeIndex.inner === innerIndex) {
            ctrl.editModeIndex = { outer: null, inner: null };
        } else {
            ctrl.editModeIndex.outer = outerIndex;
            ctrl.editModeIndex.inner = innerIndex;

            ctrl.customerAccessLevel = ctrl.userRoleList.find(function (role) {
                return role.id == item.accessLevel;
            });
        }
    };

    ctrl.updateAuthorizedPortalsUserRole = function (pthItem, role, innerIndex, outerIndex) {
        AuthorizedPortalsFactory.updateAuthorizedPortalsUserRole(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, pthItem.customerId, pthItem.loginId, role.id).then(function (dataFromFactory) {
            // ctrl.getAuthorizedUsers();
            if (dataFromFactory.data.message == "Updated Successfully") {
                ctrl.authorizedPortal[outerIndex].authorizedLoginsList[innerIndex].accessLevel = role.id;
                ctrl.authorizedPortal[outerIndex].authorizedLoginsList[innerIndex].role = role.value;
            }
            ctrl.editModeIndex = { outer: null, inner: null };
        }, function (error) {
            //error
        });
    };

    ctrl.removeAuthorizedPortalsUser = function (pthItem, innerIndex, outerIndex) {
        var _this = this;

        ctrl.editModeIndex = { outer: null, inner: null };
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = translation.text.REMOVE + " Authorized User " + pthItem.userFullName + " for " + pthItem.customerName + ".";
            this.ok = function () {
                $uibModalInstance.close(pthItem);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this.translation;
                }
            }
        });

        modalInstance.result.then(function (pthItem) {
            AuthorizedPortalsFactory.removeAuthorizedPortalsUser(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, pthItem.customerId, pthItem.loginId).then(function (dataFromFactory) {
                if (dataFromFactory.data.message == "Deleted Successfully") {
                    if (ctrl.authorizedPortal[outerIndex].authorizedLoginsList.length > 1) {
                        ctrl.authorizedPortal[outerIndex].authorizedLoginsList.splice(innerIndex, 1);
                    } else {
                        ctrl.authorizedPortal.splice(outerIndex, 1);
                    }

                    if (ctrl.authorizedPortal.length === 0) {
                        $scope.alerts.push({ msg: "No Data", type: 'info', languageCode: 'NO_DATA' });
                    } else {
                        $scope.alerts = [];
                    }
                } else {
                    ctrl.getAuthorizedPortals();
                }
            }, function (error) {
                //error
            });
        }, function () {
            // cancel button
        });
    };
}
angular.module('mc.user-accounts').controller('authorizedPortalsController', AuthorizedPortalsController);
AuthorizedPortalsController.$inject = ['$rootScope', '$scope', 'sharedSetupService', 'translationService', 'authenticationService', 'AuthorizedPortalsFactory', '$element', 'savePdfService', '$uibModal'];
'use strict';

angular.module('mc.user-accounts').component('authorizedPortals', {
    controller: AuthorizedPortalsController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/account/useraccounts/authorizedportals/authorized-portals-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.volumetricflow', []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VolumetricFlowTableModel(HOST, $http, $q, $timeout, datetimeService, translationService, sharedSetupService) {
  var VolumetricFlow = function () {
    function VolumetricFlow(customerId, deviceId) {
      _classCallCheck(this, VolumetricFlow);

      this._deviceName = '';
      this._table = [];
      this._setting = null;
      this._loading = false;
      this._customerId = customerId;
      this._flowUnitText = translationService.translation.text.PUMP_GALLONS;
      this._deviceId = deviceId;
      this._liveData = false;
      this._startRow = 1;
      this._pageSize = 50;
      this._numberOfReturnedRecords = -1;
      this._numberOfNewRecordsPrevious = -1;
      this._start = '19000101';
      this._end = '19000101';
    }

    _createClass(VolumetricFlow, [{
      key: 'formatRuntime',
      value: function formatRuntime(runtime) {
        var formatted = '';

        var intRuntime = parseInt(runtime);
        if (runtime < 100) {
          formatted = (' ' + intRuntime).substr(intRuntime.toString().length - 1) + ':';
        } else if (runtime < 1000) {
          formatted = ('' + intRuntime).substr(intRuntime.toString().length - 3) + ':';
        }

        var temp = '0' + parseInt(60 * (runtime - parseInt(runtime)) + 0.5);
        formatted += temp.substring(temp.length - 2);

        return formatted;
      }
    }, {
      key: 'getStartLevel',
      value: function getStartLevel(row, convertToUnit) {
        var startLevel = null;
        if (row.startLevel > row.endLevel) {
          startLevel = row.startLevel.toFixed(2);
        } else {
          startLevel = row.endLevel.toFixed(2);
        }
        if (convertToUnit === 2) {
          return Math.abs(startLevel * 0.3048).toFixed(2);
        } else {
          return startLevel;
        }
      }
    }, {
      key: 'getEndLevel',
      value: function getEndLevel(row, convertToUnit) {
        var endLevel = null;
        if (row.startLevel > row.endLevel) {
          endLevel = row.endLevel.toFixed(2);
        } else {
          endLevel = row.startLevel.toFixed(2);
        }
        if (convertToUnit === 2) {
          return Math.abs(endLevel * 0.3048).toFixed(2);
        } else {
          return endLevel;
        }
      }
    }, {
      key: 'getCalculatedFlow',
      value: function getCalculatedFlow(row, convertToUnit) {
        if (convertToUnit === 1) {
          this._flowUnitText = translationService.translation.text.PUMP_GALLONS;
          return Math.abs(row.flow).toFixed(0);
        } else if (convertToUnit === 2) {
          this._flowUnitText = translationService.translation.text.PUMP_LITERS;
          return Math.abs(3.78541178 * row.flow).toFixed(2);
        }

        return row.flow;
      }
    }, {
      key: 'getCalculatedPumpRate',
      value: function getCalculatedPumpRate(row, convertToUnit) {
        if (convertToUnit === 1) {
          return Math.abs(row.pumpRate).toFixed(0);
        } else if (convertToUnit === 2) {
          return (0.06 * Math.abs(3.78541178 * row.pumpRate)).toFixed(2);
        }

        return row.pumpFlow;
      }
    }, {
      key: 'getInFlow',
      value: function getInFlow(row, convertToUnit) {
        var decimals = -1;
        if (row.inFlow > 1000) {
          decimals = 0;
        } else {
          if (row.inFlow > 10) {
            decimals = 1;
          } else {
            decimals = 2;
          }
        }

        if (convertToUnit === 1) {
          return Math.abs(row.inFlow).toFixed(decimals);
        } else if (convertToUnit === 2) {
          return (0.06 * Math.abs(3.78541178 * row.inFlow)).toFixed(decimals);
        }

        return row.inFlow;
      }
    }, {
      key: 'fetchData',
      value: function fetchData(type, startDate, endDate) {
        var _this = this;

        this._loading = true;

        return $http.get(HOST + '/api/VolumetricFlowTable?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&startDate=' + startDate + '&endDate=' + endDate + '&direction=' + type).then(function (resp) {
          _this._deviceName = resp.data.device.name;
          _this._loading = false;
          _this._setting = resp.data.setting;

          var items = resp.data.data;

          if (type === 0) {
            _this._table = _this._table.concat(resp.data.data);
          } else if (type === 1) {
            _this._numberOfNewRecordsPrevious = resp.data.data.length;
            _this._table = resp.data.data.reverse().concat(_this._table);
          }

          if (_this._table.length > 0) {
            // if there are records returned
            _this._end = datetimeService.toUnixtime(_this._table[_this._table.length - 1].computeTime.replace(/\D/g, ''));
          }

          return resp;
        });
      }
    }, {
      key: 'nextPage',
      value: function nextPage() {
        var _this2 = this;

        if (this._loading) {
          return $q(function (resolve, reject) {
            resolve({ data: { setting: _this2._setting, data: _this2._table } });
          });
        }

        if (this._table.length > 0) {
          var newEnd = datetimeService.toUnixtime(this._table[this._table.length - 1].computeTime.replace(/\D/g, ''));
          var newStart = newEnd - 86400000 * 15;
          return this.fetchData(0, newStart, newEnd);
        } else {

          //TODO: will come back to reconsider sharedSetupService.regenerateDates()
          if (this._end === 0) {
            var tmpDates = sharedSetupService.getLiveDates();
            this._end = tmpDates.endDate;

            var _newStart2 = this._end - 86400000 * 15;
            this.start = _newStart2;
            return this.fetchData(0, _newStart2, this._end);
          }
          var _newStart = this._end - 86400000 * 15;
          this.start = _newStart;
          return this.fetchData(0, _newStart, this._end);
        }
      }
    }, {
      key: 'previousPage',
      value: function previousPage() {
        var _this3 = this;

        if (this._loading) {
          return $q(function (resolve, reject) {
            resolve({ data: { settings: _this3.settings } });
          });
        }

        var newStart = datetimeService.toUnixtime(this._table[0].computeTime.replace(/\D/g, ''));
        var newEnd = newStart + 86400000 * 15;
        return this.fetchData(1, newStart, newEnd);
      }
    }, {
      key: 'reset',
      value: function reset(deviceId) {
        if (deviceId) {
          this._setting = null;
          this._deviceId = deviceId;
        }

        this._numberOfNewRecordsPrevious = -1;
        this._table.length = 0;
        this._start = '19000101';
        this._end = '19000101';
      }
    }, {
      key: 'deleteDataPoint',
      value: function deleteDataPoint(row) {
        var _this4 = this;

        this._loading = true;

        return $http.put(HOST + '/api/VolumetricFlowTable?customerId=' + this._customerId + '&deviceId=' + this._deviceId, row).then(function (resp) {
          _this4._loading = false;
          return resp;
        });
      }
    }, {
      key: 'deviceName',
      get: function get() {
        return this._deviceName;
      }
    }, {
      key: 'table',
      get: function get() {
        return this._table;
      },
      set: function set(newTable) {
        this._table = newTable;
      }
    }, {
      key: 'settings',
      get: function get() {
        return this._setting;
      }
    }, {
      key: 'previousRecords',
      get: function get() {
        return this._numberOfNewRecordsPrevious;
      },
      set: function set(num) {
        this._numberOfNewRecordsPrevious = num;
      }
    }, {
      key: 'loading',
      get: function get() {
        return this._loading;
      }
    }, {
      key: 'deviceId',
      set: function set(deviceId) {
        this._deviceId = deviceId;
      }
    }, {
      key: 'start',
      set: function set(startDate) {
        this._start = startDate;
      },
      get: function get() {
        return this._start;
      }
    }, {
      key: 'end',
      set: function set(endDate) {
        this._end = endDate;
      },
      get: function get() {
        return this._end;
      }
    }, {
      key: 'liveData',
      set: function set(liveData) {
        this._liveData = liveData;
      }
    }]);

    return VolumetricFlow;
  }();

  return VolumetricFlow;
}

VolumetricFlowTableModel.$inject = ['HOST', '$http', '$q', '$timeout', 'datetimeService', 'translationService', 'sharedSetupService'];

angular.module('mc.volumetricflow').factory('volumetricFlowTableModel', VolumetricFlowTableModel);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function VolumetricFlowTableController(_, $, $scope, $filter, $timeout, $element, authenticationService, translationService, datetimeService, sharedSetupService, openViewService, timeLapseService, websocketService, VolumetricFlowTable, toaster, $uibModal, getDateRangeService) {
    var _this2 = this;

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    this.setDevice = function (selectedDevice) {
        $scope.deviceSelected = selectedDevice.deviceId;
        $scope.deviceSelectedSn = selectedDevice.serialNumber;
        $scope.deviceSelectedType = selectedDevice.type;
        $scope.deviceSelectedName = selectedDevice.name;
        $scope.currentSelectedDevice = selectedDevice;
    };

    var wsDataReceivedVOLCALC = function wsDataReceivedVOLCALC(data) {
        if (data && data.ComputeTime) {
            var varTime = datetimeService.socketStrToServerStrTime(data.ComputeTime);
            var newRecord = { computeTime: varTime, pump: parseInt(data.Pump), runtime: parseFloat(data.Runtime), startLevel: parseFloat(data.StartLevel), endLevel: parseFloat(data.EndLevel), flow: parseFloat(data.Gallons), pumpRate: parseFloat(data.PumpGPM), inFlow: parseFloat(data.AvgFlow) };

            _this2.volumetricFlow._table.unshift(newRecord);
        }
    };

    var wsReconnectVOLCALC = function wsReconnectVOLCALC(data) {
        console.log(data);
    };

    this._registerListener = function (deviceSn) {
        if (_this2.liveData === true) {
            return;
        }

        _this2.liveData = true;
        if (_this2.volumetricFlow) {
            _this2.volumetricFlow.liveData = _this2.liveData;
        }

        _this2.liveDataLine(_this2.liveData);
        _this2.volumetricFlow.previousRecords = -1;
        websocketService.connect();

        websocketService.register('VOLCALC', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedVOLCALC, wsReconnectVOLCALC);
    };

    this._unRegisterListener = function (deviceSn) {
        if (_this2.liveData === false) {
            return;
        }

        _this2.liveData = false;
        if (_this2.volumetricFlow) {
            _this2.volumetricFlow.liveData = _this2.liveData;
        }

        _this2.liveDataLine(_this2.liveData);

        websocketService.unRegister('VOLCALC', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedVOLCALC, wsReconnectVOLCALC);
    };

    this._checkTopOffset = function (liveDataStatusOn) {
        if (liveDataStatusOn) {
            _this2._registerListener();
        } else {
            _this2._unRegisterListener();
        }
    };

    this._setLiveDataStatus = function (firstRow, liveDataStatusOn) {
        if (_this2.checkFirstRowLiveStatus === true) {
            _this2._checkTopOffset(liveDataStatusOn);
        } else if (_this2.checkFirstRowLiveStatus === null) {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                if (parseFloat(firstRow) + parseFloat(_this2.liveDataOffset) >= parseFloat(result.unixTimeStamp)) {
                    _this2.checkFirstRowLiveStatus = true;
                    _this2._checkTopOffset(liveDataStatusOn);
                } else {
                    _this2.checkFirstRowLiveStatus = false;
                }
            });
        }
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        _this2.myDate = null;
        _this2.infiniteScrollOn = false;
        _this2.infiniteScrollUpOn = false;
        _this2.infiniteScrollDownOn = false;
        _this2.checkFirstRowLiveStatus = null;
        _this2.liveTable = $element.find('.headertable');
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.isAdmin = sharedSetupService.isAdmin(_this2.accountInfo);
        _this2.measurement = _this2.accountInfo.preferenceUser.lookupMeasurementID;
        _this2.preferredTimeFormat = _this2.accountInfo.preferenceUser.timeFormat;
        _this2.unixDay = sharedSetupService.unixDay;
        _this2.liveDataOffset = sharedSetupService.liveDataOffset;
        _this2.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
        _this2.translation = translationService.translation;
        _this2.alerts = [];
        _this2.currentScrollbarPosition = 0;
        _this2.previousScrollbarPosition = 0;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
        _this2.checkFirstRowLiveStatus = null;
        _this2.paddingZoom = _this2.paddingZoom === 0 ? _this2.unixDay / 2 : _this2.paddingZoom;
        $scope.alerts = [];
        $scope.windowTitle = _this2.translation.text.VOLUMETRIC_FLOW_TABLE;
        _this2.windowId = _this2.windowId || 'VOLUMETRIC FLOW TABLE';
        $scope.windowId = JSON.parse(JSON.stringify(_this2.windowId));
        _this2.paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
        _this2.paddingZoom = _this2.paddingZoom === 0 ? _this2.unixDay / 2 : _this2.paddingZoom;

        if (!_this2.mobile && !_this2.classicView) {
            _this2._popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize(_this2._popup);

            var adjustSize = function adjustSize() {
                _this2._popup.parent().find('div:eq(2)').css('width', _this2._popup.parent().css('width'));
                _this2._popup.parent().find('div:eq(2)').css('min-width', _this2._popup.parent().css('width').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('div:eq(2)').css('height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('div:eq(2)').css('min-height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('.tabular-data-container').css('height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('.headertable').css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('.top-menu').css('height').replace(/[^0-9.]+/g, "") - 15);
            };

            _this2._popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            _this2._popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(_this2._popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(_this2._popup);
                    adjustSize();
                }
            });

            $scope.$on('ngRepeatFinished', function () {
                adjustSize();
            });

            $scope.$on('updatePreferencesLanguage', function () {
                adjustSize();

                if ($scope.alerts.length > 0) {
                    var msg = _this2.translation.message[$scope.alerts[0].languageCode.toUpperCase()];
                    var type = $scope.alerts[0].type;
                    var languageCode = $scope.alerts[0].languageCode;
                    if (languageCode.toUpperCase() === 'NO_DATA') {
                        msg += ': ' + moment(_this2.volumetricFlow.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.volumetricFlow.end).utc().format('MM/DD/YY, h:mm:ss a');
                    }
                    $scope.alerts = [];
                    _this2.alerts = [];
                    $scope.alerts.push({ msg: msg, type: type, languageCode: languageCode });
                    _this2.alerts.push({ msg: msg, type: type, languageCode: languageCode });
                }
            });
        }

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            _this2.preferredTimeFormat = parseInt(timeFormat, 10);
        });

        $scope.$on('updatePreferencesMeasurement', function (event, measurement) {
            _this2.measurement = measurement;
        });

        $scope.$on('ngRepeatFinished', function () {
            _this2._autoScroll();
            _this2.checkFirstRowLiveStatus = null;
        });

        _this2._autoScroll = function () {
            if (_this2.volumetricFlow.previousRecords > 0) {
                var trRow = _this2.table.find('tr').eq(_this2.volumetricFlow.previousRecords - 1);
                var yPosition = typeof trRow.position() !== 'undefined' ? trRow.position().top - 90 : 2;
                _this2.table.scrollTop(yPosition);
            } else {
                var _this = _this2;
                $timeout(function () {
                    _this.table.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        // dateAgentText filter called from html
        _this2.dateAgentText = function (date, timeFormat) {
            return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
        };

        $timeout(function () {
            _this2.table = $('#volumetric-flow-table-' + _this2.replaceSpaces(_this2.windowId || 'VOLUMETRIC FLOW TABLE'));
            // Handle infinite scrolling
            _this2.table.on('scroll', function (event) {
                var $rowFirst = _this2.table.contents().find('tr:first');
                var $rowLast = _this2.table.contents().find('tr:last');
                var _firstRow = $rowFirst.attr('name');
                if (typeof $rowFirst.position() !== 'undefined') {
                    _this2.infiniteScrollOn = true;
                    _this2.infiniteScrollUpOn = true;
                    _this2.infiniteScrollDownOn = true;

                    var _tableTop = _this2.table.offset().top;
                    var _rowTop = $rowFirst.offset().top;
                    _this2._setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);

                    _this2.previousScrollbarPosition = _this2.currentScrollbarPosition;
                    _this2.currentScrollbarPosition = _this2.table[0].scrollTop;
                }

                if (_this2.infiniteScrollOn === true) {
                    _this2.infiniteScrollUpOn = true;
                    _this2.infiniteScrollDownOn = true;

                    if (_this2.currentScrollbarPosition <= 35 && _this2.previousScrollbarPosition > 35) {
                        _this2.checkFirstRowLiveStatus = null;
                    }

                    if (_this2.infiniteScrollDownOn === true && _this2.table[0].scrollTop + _this2.table[0].offsetHeight + 5 > _this2.table[0].scrollHeight && _this2.table[0].scrollTop > 0) {
                        $rowLast.addClass('active-row');
                        _this2.alerts = [];
                        $scope.alerts = [];
                        _this2.volumetricFlow.nextPage().then(function (resp) {
                            if (resp.data.setting === null || resp.data.data && resp.data.data.length === 0 && _this2.volumetricFlow.table.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.volumetricFlow.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.volumetricFlow.end).utc().format('MM/DD/YY, h:mm:ss a');

                                $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            }
                        });
                    }
                    if (_this2.infiniteScrollUpOn === true && _this2.table[0].scrollTop < 5 && _this2.currentScrollbarPosition < _this2.previousScrollbarPosition) {
                        $rowFirst.addClass('active-row');
                        _this2.alerts = [];
                        $scope.alerts = [];
                        $timeout(function () {
                            // Give it time to set the live data status
                            _this2.volumetricFlow.previousPage().then(function (resp) {
                                if (resp.data.setting === null || resp.data.data && resp.data.data.length === 0 && _this2.volumetricFlow.table.length === 0) {
                                    $scope.alerts.length = 0;
                                    _this2.alerts.length = 0;

                                    var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.volumetricFlow.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.volumetricFlow.end).utc().format('MM/DD/YY, h:mm:ss a');

                                    $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                    _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                }
                            });
                        });
                    }
                }

                var rows = _this2.table.children().children().children().children();
                var scrollpos = 40;
                var start = 0;
                var end = rows.length;
                var count = 0;

                while (start !== end) {
                    count++;
                    var mid = start + Math.floor((end - start) / 2);
                    if ($(rows[mid]).position().top < scrollpos) {
                        start = mid + 1;
                    } else {
                        end = mid;
                    }
                }
                _this2._updateZoom(parseFloat($($(rows[start])).attr('name')));
            });
        });

        // Toggle the active row when user clicks
        _this2.toggle = function ($event) {
            if ($($event.currentTarget).hasClass('active-row')) {
                $($event.currentTarget).removeClass('active-row');
            } else {
                $($event.currentTarget).addClass('active-row');
            }
        };

        $scope.$watch(function () {
            return $scope.deviceSelectedSn;
        }, function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                if (oldVal) {
                    // this._unRegisterListener(oldVal);
                }
            }
        }, true);

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                $scope.goSelectReportData(true, newVal);
            }
        }, true);

        $scope.mostRecentData = function () {
            _this2.myDate = null;
            toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
            $scope.goSelectReportData(true);
        };

        $scope.goSelectReportData = function (isRefreshing, newVal) {
            var deviceSelected = newVal ? newVal : $scope.deviceSelected;
            if (_this2.volumetricFlow) {
                _this2.volumetricFlow.reset(deviceSelected);
            } else {
                _this2.volumetricFlow = new VolumetricFlowTable(_this2.accountInfo.customerId, newVal);
            }
            _this2.currentScrollbarPosition = 0;
            _this2.previousScrollbarPosition = 0;
            _this2.checkFirstRowLiveStatus = null;
            _this2._unRegisterListener();

            $scope.alerts = [];
            _this2.alerts = [];
            $scope.loading = true;
            $scope.maxDateRange = getDateRangeService.getRange("VolumetricFlowTable");

            $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
            if (_typeof($scope.stickyProperties) != 'object') {
                $scope.stickyProperties = $scope.stickyPropertiesInterface;
            }
            var numberOfDays = $scope.maxDateRange - 1,
                varDateRangeStart,
                varDateRangeEnd,
                varDateRangeEndTmp;
            if ($scope.stickyProperties.on === true && !isRefreshing) {
                //sharedSetupService.checkStickyProperties($scope.stickyProperties); TODO: will come back to reconsider sharedSetupService.getLiveDates()
                $scope.stickyProperties.on = false;
                varDateRangeStart = $scope.stickyProperties.dateMin;
                varDateRangeEnd = $scope.stickyProperties.dateMax;
                $scope.myDateRangeStart = new Date(varDateRangeStart);
                $scope.myDateRangeEnd = new Date(varDateRangeEnd);
            } else if (new Date(_this2.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(_this2.myDateRangeEnd)) && new Date(_this2.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(_this2.myDateRangeStart)) && !isRefreshing) {
                $scope.myDateRangeEnd = new Date(_this2.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(_this2.myDateRangeEnd)) ? _this2.myDateRangeEnd : new Date();
                $scope.myDateRangeStart = new Date(_this2.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(_this2.myDateRangeStart)) ? _this2.myDateRangeStart : new Date();
                varDateRangeEnd = _this2.myDateRangeEnd;
                varDateRangeEnd = varDateRangeEnd.setHours(0, 0, 0, 0);
                varDateRangeStart = _this2.myDateRangeStart;
                varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
            } else {
                _this2.myDateRangeEnd = new Date();
                _this2.myDateRangeStart = new Date();
                _this2.myDateRangeStart.setDate(_this2.myDateRangeStart.getDate() - 15);

                varDateRangeEnd = new Date();
                varDateRangeEnd = varDateRangeEnd.setHours(0, 0, 0, 0);
                ///////// needed to calculate varDateRangeStart
                varDateRangeEndTmp = new Date();
                varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
                ///////// needed to calculate varDateRangeStart
                varDateRangeStart = varDateRangeEndTmp - (15 + 0) * _this2.unixDay;
                _this2.volumetricFlow = new VolumetricFlowTable(_this2.accountInfo.customerId, deviceSelected);
            }
            _this2.volumetricFlow.start = varDateRangeStart;
            _this2.volumetricFlow.end = varDateRangeEnd + _this2.unixDay;

            if (new Date(_this2.myDateRangeEnd - _this2.myDateRangeStart) / 86400000 > $scope.maxDateRange) {
                $scope.loading = false;
                var errorMessage = $scope.translation.text.MAXDATE + ": " + $scope.maxDateRange + " " + $scope.translation.text.DAYS;
                $scope.alerts.push({
                    msg: errorMessage,
                    type: "danger"
                });
            } else {
                _this2.volumetricFlow.nextPage().then(function (resp) {
                    if (resp.data.setting === null || resp.data.data && resp.data.data.length === 0 && _this2.volumetricFlow.table.length === 0) {
                        $scope.alerts.length = 0;
                        _this2.alerts.length = 0;

                        var msg = _this2.translation.message.NO_DATA + ': ' + moment(varDateRangeStart).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(varDateRangeEnd).format('MM/DD/YY, h:mm:ss a');

                        $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                        _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                    }
                });
            }
            var _device = { deviceId: deviceSelected, devdeviceName: $scope.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: deviceSelected, device: _device, dataMin: _this2.volumetricFlow.start, dataMax: _this2.volumetricFlow.end, windowId: _this2.windowId });
        };
    };

    this.liveDataLine = function (varLiveData) {
        if (varLiveData) {
            _this2.liveTable.addClass('live-data-line');
        } else {
            _this2.liveTable.removeClass('live-data-line');
        }
    };

    this._updateZoom = function (currentRow) {
        if (isNaN(currentRow)) {
            return;
        }

        var zoomMin = currentRow - _this2.paddingZoom;
        var zoomMax = currentRow + _this2.paddingZoom;

        var dateMin = $scope.stickyProperties.dateMin;
        var dateMax = $scope.stickyProperties.dateMax;

        if (zoomMin < $scope.stickyProperties.dateMin) {
            dateMin = zoomMin;
        }
        if (zoomMax > $scope.stickyProperties.dateMax) {
            dateMax = zoomMax;
        }

        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: _this2.windowId });
    };

    this.deleteLogVolumetricDataPoint = function (row) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = this.translation.text.REMOVE_VOLUMETRIC_DATA_POINT;
            this.ok = function () {
                $uibModalInstance.close(row);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            _this2.volumetricFlow.deleteDataPoint(row).then(function () {
                _this2.removeLogVolumetricDataPoint(row);
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.REMOVE_VOLUMETRIC_DATA_POINT_ERROR, "Delete Error!");
            });
        }, function () {
            // cancel button 
        });
    };

    this.removeLogVolumetricDataPoint = function (row) {

        var volumetricFlowTable = _this2.volumetricFlow.table.filter(function (item) {
            return item.logVolumetricID !== row.logVolumetricID;
        });

        _this2.volumetricFlow.table = volumetricFlowTable;
    };
}

VolumetricFlowTableController.$inject = ['_', '$', '$scope', '$filter', '$timeout', '$element', 'authenticationService', 'translationService', 'datetimeService', 'sharedSetupService', 'openViewService', 'timeLapseService', 'websocketService', 'volumetricFlowTableModel', 'toaster', '$uibModal', 'getDateRangeService'];

angular.module('mc.volumetricflow').component('volumetricFlowTable', {
    controller: VolumetricFlowTableController,
    transclude: true,
    templateUrl: 'ui/volumetricflow/table/volumetricflow-table-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        deviceSelected: '<'
    }
});
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function VolumetricSummaryTableController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, VolumetricFlowSummaryFactory, LoginsFactory, $timeout, $filter, $element, getDateRangeService, savePdfService, toaster) {
    var _this2 = this;

    var ctrl = this;
    $scope.alerts = [];

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurement = _this2.accountInfo.preferenceUser.lookupMeasurementID;
        //ctrl._scale = 1;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for        
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        $scope.showMsg = false;
        ctrl.hasPump1 = false;
        ctrl.hasPump2 = false;
        ctrl.hasPump3 = false;
        ctrl.hasPump4 = false;
        ctrl.hasPump5 = false;
        ctrl.hasPump6 = false;
        ctrl.hasPump7 = false;
        ctrl.hasPump8 = false;

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.checkScrollBar();
            };
        }
        ctrl.checkScrollBar = function () {
            var _table = $scope.popup.parent().find('.tabular-data-container');
            _table.css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            ctrl.scrollBar = _table.get(0).scrollHeight > _table.get(0).clientHeight;
        };

        ctrl.setDevice = function (selectedDevice) {
            $scope.deviceSelected = selectedDevice.deviceId;
            $scope.deviceSelectedSn = selectedDevice.serialNumber;
            $scope.deviceSelectedType = selectedDevice.type;
            $scope.deviceSelectedName = selectedDevice.name;
            $scope.currentSelectedDevice = selectedDevice;
            ctrl.goSelectReportData(false);
        };
    };

    ctrl.getCalculatedFlow = function (flow, measurement) {
        if (measurement === 1) {
            this._gallons = translationService.translation.text.PUMP_GALLONS;
            return Math.abs(flow).toFixed(0);
        } else if (measurement === 2) {
            this._gallons = translationService.translation.text.PUMP_LITERS;
            return Math.abs(3.78541178 * flow).toFixed(0);
        }
        return flow;
    };

    $scope.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
        ctrl.goSelectReportData(true);
    };

    ctrl.goSelectReportData = function (isRefreshing) {
        $scope.alerts = [];
        ctrl.loading = true;
        $scope.showMsg = false;
        ctrl.volumetricFlowSummary = [];
        ctrl.maxDateRange = getDateRangeService.getRange("VolumetricFlowTable");

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        var numberOfDays = ctrl.maxDateRange - 1,
            varDateRangeStart,
            varDateRangeEnd,
            varDateRangeEndTmp;
        if (ctrl.stickyProperties.on === true && !isRefreshing) {
            //sharedSetupService.checkStickyProperties(ctrl.stickyProperties); TODO: will come back to reconsider sharedSetupService.getLiveDates()
            ctrl.stickyProperties.on = false;
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd);
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) && !isRefreshing) {
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
            varDateRangeEnd = ctrl.myDateRangeEnd;
            varDateRangeEnd = varDateRangeEnd.setHours(0, 0, 0, 0);
            varDateRangeStart = ctrl.myDateRangeStart;
            varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
        } else {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - 15);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (15 + 0) * ctrl.unixDay;
        }

        //TODO: will revisit - just a quick fix if/when dates are invalid
        if (!(new Date(varDateRangeStart).getTime() > 0 && new Date(varDateRangeEnd).getTime() > 0)) {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - 15);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (15 + 0) * ctrl.unixDay;
        }

        var _deviceid = $scope.deviceSelected;
        var _device = { deviceId: $scope.deviceSelected, devdeviceName: $scope.deviceSelectedName };
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: _deviceid, device: _device, dataMin: varDateRangeStart, dataMax: varDateRangeEnd, windowId: ctrl.windowId });

        if (new Date(ctrl.myDateRangeEnd - ctrl.myDateRangeStart) / 86400000 > ctrl.maxDateRange) {
            ctrl.loading = false;
            var errorMessage = $scope.translation.text.MAXDATE + ": " + ctrl.maxDateRange + " " + $scope.translation.text.DAYS;
            $scope.alerts.push({
                msg: errorMessage,
                type: "danger"
            });
        } else {
            var _volumetricFlowSummary = new VolumetricFlowSummaryFactory(ctrl.accountInfo.customerId, $scope.deviceSelected, varDateRangeStart, varDateRangeEnd, ctrl.accountInfo.timeZone); //varDateRangeEndTmp - is StartDate
            _volumetricFlowSummary.getData().then(function () {
                ctrl.volumetricFlowSummary = _volumetricFlowSummary.data.dailyVolFlowSummaryTable;
                ctrl.pumpSettings = _volumetricFlowSummary.data.pumpSettings;
                var width = 30 / ctrl.pumpSettings.length;
                ctrl.width = width + '%';
                ctrl.hasPump1 = false;
                ctrl.hasPump2 = false;
                ctrl.hasPump3 = false;
                ctrl.hasPump4 = false;
                ctrl.hasPump5 = false;
                ctrl.hasPump6 = false;
                ctrl.hasPump7 = false;
                ctrl.hasPump8 = false;
                for (var i = 0; i < ctrl.pumpSettings.length; i++) {
                    switch (ctrl.pumpSettings[i].channel) {
                        case 1:
                            ctrl.hasPump1 = true;
                            break;
                        case 2:
                            ctrl.hasPump2 = true;
                            break;
                        case 3:
                            ctrl.hasPump3 = true;
                            break;
                        case 4:
                            ctrl.hasPump4 = true;
                            break;
                        case 5:
                            ctrl.hasPump5 = true;
                            break;
                        case 6:
                            ctrl.hasPump6 = true;
                            break;
                        case 7:
                            ctrl.hasPump7 = true;
                            break;
                        case 8:
                            ctrl.hasPump8 = true;
                            break;
                    }
                }
                // if(ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2)
                // {
                //    for(var i = 0; i < ctrl.volumetricFlowSummary.length; i++)
                //    {
                //     ctrl.volumetricFlowSummary[i].pump1Gallons = Math.abs(3.78541178 * ctrl.volumetricFlowSummary[i].pump1Gallons).toFixed(0);
                //     ctrl.volumetricFlowSummary[i].pump2Gallons = Math.abs(3.78541178 * ctrl.volumetricFlowSummary[i].pump2Gallons).toFixed(0);
                //     ctrl.volumetricFlowSummary[i].pump3Gallons = Math.abs(3.78541178 * ctrl.volumetricFlowSummary[i].pump3Gallons).toFixed(0);
                //     ctrl.volumetricFlowSummary[i].totalGallons  = Math.abs(3.78541178 * ctrl.volumetricFlowSummary[i].totalGallons).toFixed(0);
                //    }
                // }
                ctrl.loading = false;
                if (ctrl.volumetricFlowSummary.length === 0) {
                    $scope.showMsg = true;
                    var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(varDateRangeStart).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(varDateRangeEnd).format('MM/DD/YY, h:mm:ss a');
                    $scope.alerts.push({
                        msg: errorMessage,
                        type: "info"
                    });
                }
            });
        }
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesMeasurement', function (event, measurement) {
        ctrl.measurement = measurement;
    });

    ctrl.refreshAlerts = function () {
        $scope.alerts = [];
        if (ctrl.volumetricFlowSummary.length === 0) {
            $scope.showMsg = true;
            var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(ctrl.volumetricFlowSummary.startDate).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.volumetricFlowSummary.endDate).format('MM/DD/YY, h:mm:ss a');
            $scope.alerts.push({
                msg: errorMessage,
                type: "info"
            });
        }
    };

    ctrl.refreshData = function () {
        ctrl.volumetricFlowSummary = angular.copy(ctrl.volumetricFlowSummary);
        ctrl.loading = false;
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                1: { columnWidth: 120 },
                2: { columnWidth: 90 },
                3: { columnWidth: 90 },
                4: { columnWidth: 90 },
                5: { columnWidth: 90 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };
}
VolumetricSummaryTableController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'VolumetricFlowSummaryFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'getDateRangeService', 'savePdfService', 'toaster'];
'use strict';

angular.module('mc.volumetricflowsummary', []);
'use strict';

angular.module('mc.volumetricflowsummary').component('volumetricSummaryTable', {
    controller: VolumetricSummaryTableController,
    templateUrl: 'ui/volumetricflowsummary/table/volumetric-summary-table-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function VolumetricSummaryChartController($, $rootScope, $scope, $sce, $element, $timeout, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, VolumetricFlowSummaryFactory, flowChartService, detectBrowserService, getDateRangeService, toaster) {
    var ctrl = this;
    $scope.alerts = [];
    var varToggle = false;
    var curentBrowser = detectBrowserService();
    var ieEdge = curentBrowser === 'ie' || curentBrowser === 'edge';

    var chart;
    var series = [];
    ctrl.loading = true;

    ctrl.replaceSpaces = function (str) {
        return str.replace(/ /g, '_');
    };

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.loadingInProgress = true;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for        
        ctrl.downloadViewTypeOptions = [0, 1, 2];

        ctrl.element = $element.find('.vfs-chart');
        ctrl.element.addClass('chart');

        ctrl.respData = null;

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.chart').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 175); //25: total padding
                var _char = $scope.popup.parent().find('.chart').highcharts();
                if ($scope.popup.parent().find(".chart").highcharts()) {
                    _char.reflow();
                }
            };
        }
        ctrl.setDevice = function (selectedDevice) {
            $scope.deviceSelected = selectedDevice.deviceId;
            $scope.deviceSelectedSn = selectedDevice.serialNumber;
            $scope.deviceSelectedType = selectedDevice.type;
            $scope.deviceSelectedName = selectedDevice.name;
            $scope.currentSelectedDevice = selectedDevice;
            ctrl.goSelectReportData(false);
        };
    };

    $scope.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
        ctrl.goSelectReportData(true);
    };

    $scope.zoomAdjust = function (varDay) {
        if (varDay == 1) {
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeEnd - 86400000);
        } else {
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeEnd - 3 * 86400000);
        }
        ctrl.goSelectReportData(false);
    };

    ctrl.goSelectReportData = function (isRefreshing) {
        $scope.alerts = [];
        ctrl.loading = true;
        $scope.showMsg = false;
        ctrl.maxDateRange = getDateRangeService.getRange("VolumetricFlowTable");

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        var numberOfDays = ctrl.maxDateRange - 1,
            varDateRangeStart,
            varDateRangeEnd,
            varDateRangeEndTmp;
        if (ctrl.stickyProperties.on === true && !isRefreshing) {
            ctrl.stickyProperties.on = false;
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) && !isRefreshing) {
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
            varDateRangeEnd = ctrl.myDateRangeEnd;
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeStart = ctrl.myDateRangeStart;
            varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
        } else {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - 15);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (15 + 0) * ctrl.unixDay;
        }

        //TODO: will revisit - just a quick fix if/when dates are invalid
        if (!(new Date(varDateRangeStart).getTime() > 0 && new Date(varDateRangeEnd).getTime() > 0)) {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - 15);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (15 + 0) * ctrl.unixDay;
        }

        if (new Date(ctrl.myDateRangeEnd - ctrl.myDateRangeStart) / 86400000 > ctrl.maxDateRange) {
            ctrl.loading = false;
            var errorMessage = $scope.translation.text.MAXDATE + ": " + ctrl.maxDateRange + " " + $scope.translation.text.DAYS;
            $scope.alerts.push({
                msg: errorMessage,
                type: "danger"
            });
        } else {
            var _volumetricFlowSummary = new VolumetricFlowSummaryFactory(ctrl.accountInfo.customerId, $scope.deviceSelected, varDateRangeStart, varDateRangeEnd, ctrl.accountInfo.timeZone); //varDateRangeEndTmp - is StartDate

            _volumetricFlowSummary.getChartData().then(function () {
                ctrl.respData = _volumetricFlowSummary.data;
                if (ctrl.respData.series.length === 0) {
                    var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(ctrl.volumetricFlowSummary.startDate).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.volumetricFlowSummary.endDate).format('MM/DD/YY, h:mm:ss a');
                    $scope.alerts.push({
                        msg: errorMessage,
                        type: "info"
                    });
                } else {
                    buildSeries();
                }
            });
            var _deviceid = $scope.deviceSelected;
            var _device = { deviceId: $scope.deviceSelected, devdeviceName: $scope.deviceSelectedName };
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: _deviceid, device: _device, dataMin: varDateRangeStart, dataMax: varDateRangeEnd, windowId: ctrl.windowId });

            $timeout(function () {
                ctrl.drawChart();
                if (!$rootScope.mobile && !$rootScope.classicView) $scope.adjustSize();
                ctrl.loading = false;
            }, 1000);
        }
    };

    ctrl.drawChart = function () {
        ctrl.chart = new Highcharts.chart({
            time: {
                getTimezoneOffset: function getTimezoneOffset(timestamp) {
                    return -moment.tz(timestamp, datetimeService.getTimeZoneId(ctrl.accountInfo.timeZone)).utcOffset();
                }
            },
            chart: {
                renderTo: ctrl.element[0],
                type: 'spline',
                events: {
                    load: function load(event) {
                        //if (initialLoad) 
                        openViewService.adjustContentSize($scope.popup);
                    }
                }
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                }
            },
            credits: {
                enabled: false
            },
            title: {
                text: ctrl.translation.text.PUMP_DUTY_CYCLE_PLOT
            },
            subtitle: {
                text: ctrl.translation.text.DUTY_CYCLE + ' - ' + $scope.deviceSelectedName
            },
            xAxis: {
                softMax: 100,
                showFirstLabel: true,
                title: {
                    text: ctrl.translation.text.RATIO_PUMP_ON_2_OFF_TIME
                },
                minRange: null,
                //type: 'category',
                labels: {
                    formatter: function formatter() {
                        return this.value + '%';
                    },
                    style: {
                        fontSize: '10px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                },
                showLastLabel: true,
                minorTicks: false,
                tickPositions: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
            },
            yAxis: {
                title: {
                    text: ctrl.translation.text.NUMBER_OF_OCCURANCES
                },
                labels: {
                    formatter: function formatter() {
                        return this.value;
                    }
                },
                lineWidth: 1 //shows vertical (y-axis) line
            },
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var s = '';
                    s += '<table style="width:auto;height:auto;white-space: nowrap !important; font-size:small;">'; // tooltip height/width are auto calculated and no text wrap allowed
                    s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + this.x + '%</td></tr>';
                    $.each(this.points, function (i, point) {
                        s += '<tr><td style="color: ' + point.series.color + ';">\u25CF ' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + point.y + '</td></tr>';
                    });
                    s += '</table>';
                    return s;
                },
                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            plotOptions: {
                spline: {
                    dataLabels: {
                        enabled: false
                    },
                    enableMouseTracking: true
                },
                series: {
                    marker: {
                        enabled: false,
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    }
                }
            },
            series: series
        });
    };

    var buildSeries = function buildSeries() {
        series = [];
        for (var i = 0; i < ctrl.respData.series.length; i++) {
            series.push({
                name: ctrl.respData.series[i].name,
                data: ctrl.respData.series[i].data,
                color: ctrl.respData.series[i].color
            });
        }
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        //if (!ctrl.checkDateRange()) return;
        ctrl.timeFormat = timeFormat;
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        //if (!ctrl.checkDateRange()) return;
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    ctrl.refreshAlerts = function () {
        $scope.alerts = [];
        if (ctrl.respData.series.length === 0) {
            var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(ctrl.volumetricFlowSummary.startDate).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.volumetricFlowSummary.endDate).format('MM/DD/YY, h:mm:ss a');
            $scope.alerts.push({
                msg: errorMessage,
                type: "info"
            });
        }
    };

    ctrl.refreshData = function () {
        //if (!ctrl.checkDateRange()) return;
        ctrl.respData = angular.copy(ctrl.respData);
        buildSeries();
        $timeout(function () {
            ctrl.drawChart();
            if (!$rootScope.mobile && !$rootScope.classicView) $scope.adjustSize();
            ctrl.loading = false;
        }, 0);
        //ctrl.drawChart();
        //ctrl.loading = false;
    };
}
VolumetricSummaryChartController.$inject = ['$', '$rootScope', '$scope', '$sce', '$element', '$timeout', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'VolumetricFlowSummaryFactory', 'flowChartService', 'detectBrowserService', 'getDateRangeService', 'toaster'];
'use strict';

angular.module('mc.volumetricflowsummary').component('volumetricSummaryChart', {
    controller: VolumetricSummaryChartController,
    templateUrl: 'ui/volumetricflowsummary/chart/volumetric-summary-chart-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
'use strict';

angular.module('mc.voltage-chart', []);
'use strict';

function VoltageChartFactory(HOST, $http) {

    function GetData(customerId, deviceId, startDate, endDate, timeZone) {
        return $http.get(HOST + '/api/VoltageChart?customerId=' + customerId + '&deviceId=' + deviceId + '&startDate=' + startDate + '&endDate=' + endDate).then(function (response) {
            return response;
        });
    };
    return {
        GetData: GetData
    };
}

VoltageChartFactory.$inject = ['HOST', '$http'];

angular.module('mc.voltage-chart').factory('VoltageChartFactory', VoltageChartFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function VoltageChartController($scope, sharedSetupService, openViewService, $element, authenticationService, $rootScope, $timeout, datetimeService, websocketService, timeLapseService, toaster, rangeSelectorService, SaveDesktopSettingService, VoltageChartFactory, translationService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.downloadViewTypeOptions = [0, 1];
    var chart = void 0;
    ctrl.accountInfo = authenticationService.getAccountInfo();

    ctrl.$onInit = function () {
        ctrl.myDate = null;
        ctrl.TimeFormatEnum = { Civilian: 1, Military: 2 };
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.liveDataOffset = 20 * 60 * 1000;
        ctrl.minPadding = 0;
        ctrl.maxPadding = 0;
        ctrl.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.alerts = [];
        ctrl.loadingInProgress = true;
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        sharedSetupService.broadcastAllDeviceSelected($scope);
        $scope.openView = openViewService.openView;
        $scope.windowId = _this2.windowId;
        $scope.windowTitle = _this2.windowTitle;
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        $scope.deviceSelected = _this2.deviceSelected;
        $scope.stickyProperties = _this2.stickyProperties;
        sharedSetupService.getWindowId(ctrl);
        ctrl.varToggle = false;
        ctrl.xValue = null;
        ctrl.scrollingInProgress = false;
        ctrl.zoomLevelCurrent, ctrl.zoomLevelPrevious = 0;
        ctrl.initialLoad = true;
        ctrl.showAutoscaleBtn = true;

        //Get my icon based on my title
        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        //find the element of the chart class
        ctrl.element = $element.find('.voltage-chart');

        //Manage Dialog Geometry
        if ($rootScope.classicView && ctrl.element.parent('div').parent('div').parent('div').attr('class') && ctrl.element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") == 0) {
            ctrl.largeChart = true;
            ctrl.element.height(500);
        };

        //Manage Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        //Mouse wheel zoom
        ctrl.element.on('mousewheel', function (event) {
            if (!ctrl.scrollingInProgress) ctrl.mouseWheelZoom(event, chart, ctrl.xValue);
        });

        // Handle Language Change Event
        ctrl.fnChangeLanguage = function () {
            if ($scope.alerts.length > 0) {
                var _msg = eval("ctrl.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;

                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(ctrl.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                }
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        };
    };

    $timeout(function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.dialog({
                resizeStop: function resizeStop(event, ui) {
                    $('#map').removeClass('no-events');
                    ui.size.width < 420 ? ctrl.showAutoscaleBtn = false : ctrl.showAutoscaleBtn = true;
                    $scope.$apply();
                }
            });
        }
    });

    $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            $scope.liveDataIn = !$scope.liveDataIn;
            $timeout(function () {
                $scope.liveDataIn = !$scope.liveDataIn;
            }, 3000);
        }
    }, true);

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            var tmpDates,
                tmpStartDate = null,
                tmpEndDate = null;
            ctrl.loadingInProgress = true;
            ctrl.saveDesktopSettingService = new SaveDesktopSettingService(newValue, ctrl.windowId);

            if (ctrl.stickyProperties.setting && ctrl.stickyProperties.setting.savedDesktop) {
                ctrl.savedDesktopSetting = ctrl.stickyProperties.setting;
            } else {
                ctrl.savedDesktopSetting = ctrl.saveDesktopSettingService.getObject();
            }

            if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.dateMax !== null) {
                ctrl.stickyProperties.on = true;
                tmpStartDate = ctrl.stickyProperties.dateMin;
                tmpEndDate = ctrl.stickyProperties.dateMax;
            } else {
                ctrl.stickyProperties.on = false;
            }

            if (!tmpStartDate) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    tmpDates = new Date(result.data.localDateTime);
                    tmpDates.setHours(0, 0, 0, 0);
                    tmpDates = datetimeService.dateToUnixtime(tmpDates);
                    tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                    tmpDates = datetimeService.startEndLocalToUtc(tmpDates, ctrl.accountInfo.timeZone);
                    tmpStartDate = tmpDates.startDate;
                    tmpEndDate = tmpDates.endDate;
                    _getData(newValue, tmpStartDate, tmpEndDate);
                });
            } else {
                _getData(newValue, tmpStartDate, tmpEndDate);
            }
        }
    }, true);

    $scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            ctrl.stickyProperties.device.serialNumber = newValue;
            if (oldValue) {
                _unRegisterListener(oldValue);
            }
        }
    }, true);

    var _getData = function _getData(deviceId, StartDate, EndDate) {
        $scope.liveDataEndDate = EndDate;
        var _device = { deviceId: deviceId, deviceName: $scope.deviceSelectedName };
        VoltageChartFactory.GetData(ctrl.accountInfo.customerId, deviceId, StartDate, EndDate).then(function (datafromFactory) {
            $scope.yAxis = datafromFactory.data.yAxis;
            $scope.series = datafromFactory.data.series;
            $scope.solar = datafromFactory.data.device.solar;
            $scope.deviceModel = datafromFactory.data.device.model;
            $scope.alerts = [];
            if (datafromFactory.data.series && datafromFactory.data.series[0].data.length >= 1) {
                $scope.devicename = datafromFactory.data.device.name;
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, windowId: ctrl.windowId });
                _drawChart();
            } else {
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, zoomMin: ctrl.stickyProperties.zoomMin || StartDate, zoomMax: ctrl.stickyProperties.zoomMax || EndDate, windowId: ctrl.windowId });
                ctrl.element.empty();
                $scope.chart = null;
                ctrl.loadingInProgress = false;
                ctrl.lastStart = StartDate;
                ctrl.lastEnd = EndDate;
                var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(StartDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(EndDate).utc().format('MM/DD/YY, h:mm:ss a');
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        });
    };

    ctrl.selectMyDate = function (date) {
        ctrl.myDate = date;
        var tmpDates = ctrl.myDate;
        ctrl.loadingInProgress = true;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
        tmpDates = datetimeService.startEndLocalToUtc(tmpDates, $scope.accountInfo.timeZone);
        VoltageChartFactory.GetData(ctrl.accountInfo.customerId, $scope.deviceSelected, tmpDates.startDate, tmpDates.endDate).then(function (datafromFactory) {
            $scope.series = datafromFactory.data.series;
            $scope.devicename = datafromFactory.data.device.name;
            $scope.alerts = [];
            if (datafromFactory.data.series && datafromFactory.data.series[0].data.length >= 1) {
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, windowId: ctrl.windowId });
                _drawChart();
            } else {
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + ctrl.unixDay, zoomMax: tmpDates.endDate - ctrl.unixDay, windowId: ctrl.windowId });
                ctrl.element.empty();
                $scope.chart = null;
                ctrl.lastStart = tmpDates.startDate;
                ctrl.lastEnd = tmpDates.endDate;
                var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(tmpDates.startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(tmpDates.endDate).utc().format('MM/DD/YY, h:mm:ss a');
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                ctrl.loadingInProgress = false;
            }
        });
    };

    ctrl.zoomAdjust = function (varDay) {
        var extremes = $scope.chart.xAxis[0].getExtremes();
        var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, $scope.heartbeatLocalDateTime);
        $scope.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
        _setLiveDataStatus();
    };

    function adjustScale(chart) {

        for (var i = 0; i < chart.series.length - 1; i++) {
            if (ctrl.varToggle === false) {
                chart.yAxis[i].setExtremes(0, 20);
            } else {
                chart.yAxis[i].setExtremes(null, null);
            }
        }
        var extremes = chart.xAxis[0].getExtremes();
        chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
        ctrl.varToggle = !ctrl.varToggle;
    }

    ctrl.adjustScaleNew = function () {
        adjustScale($scope.chart);
    };

    var _drawChart = function _drawChart() {
        ctrl.varToggle = false;
        var tmpData = $scope.series,
            chartDrawn = false;

        $scope.series[0].name = ctrl.translation.text.BATTERY_VOLTAGE + " (" + ctrl.translation.text.VOLTS + ")";
        if ($scope.deviceSelectedType !== 10 && $scope.deviceSelectedType !== 15 && $scope.deviceSelectedType !== 21) $scope.series[1].name = $scope.solar ? ctrl.translation.text.DC_VOLTAGE : ctrl.translation.text.AC_VOLTAGE + " (" + ctrl.translation.text.VOLTS + ")";

        $scope.series[0].marker = {
            enabled: null,
            symbol: 'circle',
            radius: 4,
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: null // inherit from series
        };
        if ($scope.deviceSelectedType !== 10 && $scope.deviceSelectedType !== 15 && $scope.deviceSelectedType !== 21) $scope.series[1].marker = {
            enabled: null,
            symbol: 'circle',
            radius: 4,
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: null // inherit from series
        };

        $scope.yAxis[0].title.text = ctrl.translation.text.BATTERY_VOLTAGE + " (" + ctrl.translation.text.VOLTS + ")";
        if ($scope.deviceSelectedType !== 10 && $scope.deviceSelectedType !== 15 && $scope.deviceSelectedType !== 21) $scope.yAxis[1].title.text = $scope.solar ? ctrl.translation.text.DC_VOLTAGE : ctrl.translation.text.AC_VOLTAGE + " (" + ctrl.translation.text.VOLTS + ")";

        var chartXaxisHourFormat = ctrl.preferredTimeFormat === ctrl.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
        var chartToolTipHourFormat = ctrl.preferredTimeFormat === ctrl.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

        $scope.numberOfSeries = $scope.series.length;
        $scope.numberOfHiddenSeries = 0;

        chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: true,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1
            },
            time: {
                getTimezoneOffset: function getTimezoneOffset(timestamp) {
                    return -moment.tz(timestamp, datetimeService.getTimeZoneId(ctrl.accountInfo.timeZone)).utcOffset();
                }
            },
            chart: {
                renderTo: ctrl.element[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1,
                borderRadius: 2,
                type: 'line',
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                marginRight: 10,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                spacingRight: 5,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {

                        var tmpDates = void 0,
                            i = void 0,
                            voltageData = [],
                            extremes = this.xAxis[0].getExtremes();

                        if (this.xAxis && chartDrawn === true && ctrl.scrollingInProgress === false) {
                            if (extremes && extremes.dataMin >= extremes.min - ctrl.liveDataOffset) {
                                ctrl.scrollingInProgress = true;
                                this.showLoading();

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -95);

                                VoltageChartFactory.GetData(ctrl.accountInfo.customerId, $scope.deviceSelected, tmpDates.startDate, tmpDates.endDate).then(function (datafromFactory) {
                                    if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                        for (i = 0; i < datafromFactory.data.series.length; i++) {
                                            voltageData.push(datafromFactory.data.series[i].data);
                                        }
                                    }

                                    if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                        for (i = 0; i < datafromFactory.data.series.length; i++) {
                                            tmpData[i].data = voltageData[i].concat(tmpData[i].data);
                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                            tmpData[i].data.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            chart.series[i].setData(tmpData[i].data);
                                        }
                                    }

                                    $scope.devicename = datafromFactory.data.device.name;
                                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceSelected, dataMin: tmpDates.startDate, windowId: ctrl.windowId });
                                    chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
                                    _setLiveDataStatus();

                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);

                                    chart.hideLoading();
                                }, function (error) {
                                    var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
                                    toaster.pop('error', $scope.windowTitle, errormsg);
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    chart.hideLoading();
                                });
                            } else if ($scope.liveData === false && extremes && extremes.max + ctrl.liveDataOffset >= extremes.dataMax) {
                                ctrl.scrollingInProgress = true;
                                this.showLoading();

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 95);

                                VoltageChartFactory.GetData(ctrl.accountInfo.customerId, $scope.deviceSelected, tmpDates.startDate, tmpDates.endDate).then(function (datafromFactory) {
                                    if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                        for (i = 0; i < datafromFactory.data.series.length; i++) {
                                            voltageData.push(datafromFactory.data.series[i].data);
                                        }
                                    }

                                    if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                        for (i = 0; i < datafromFactory.data.series.length; i++) {
                                            tmpData[i].data = tmpData[i].data.concat(voltageData[i]);
                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                            tmpData[i].data.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            chart.series[i].setData(tmpData[i].data);
                                        }
                                    }

                                    $scope.devicename = datafromFactory.data.device.name;
                                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceSelected, dataMax: tmpDates.endDate, windowId: ctrl.windowId });
                                    chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
                                    _setLiveDataStatus(tmpDates.endDate);

                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);

                                    chart.hideLoading();
                                }, function (error) {
                                    var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
                                    toaster.pop('error', $scope.windowTitle, errormsg);
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    chart.hideLoading();
                                });
                            }
                        }
                    },
                    load: function load(event) {
                        if (ctrl.initialLoad) openViewService.adjustContentSize(ctrl.popup);
                        ctrl.initialLoad = false;
                        $timeout(function () {
                            ctrl.saveDesktopSettingService.applySavedDesktopSetting(chart, ctrl, true);
                        }, 0);
                    },
                    selection: function selection(event) {
                        if (event.xAxis) {
                            //
                        } else {
                            var button = this.exportSVGElements[0];
                            var button2 = this.exportSVGElements[2];
                            button.attr({
                                x: -200 //1
                            });
                            button2.attr({
                                x: -200
                            });
                            adjustScale(this);
                        }
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        enabled: false
                    },
                    customButton: {
                        symbol: 'text:\uF205',
                        text: ctrl.translation.text.AUTO_SCALE,
                        symbolSize: 9,
                        symbolFill: '#337ab7',
                        symbolStrokeWidth: 0,
                        align: "left",
                        verticalAlign: 'bottom',
                        x: -200, //1,
                        y: $scope.mobile ? -70 : -70, //I know...
                        symbolY: $scope.mobile ? 14 : 14,
                        theme: {
                            'stroke-width': 0,
                            stroke: '#ebebeb',
                            fill: '#ebebeb',
                            r: 0,
                            states: {
                                hover: {
                                    title: ctrl.translation.text.TOGGLE_AUTOSCALE,
                                    fill: '#ebebeb'
                                },
                                select: {
                                    stroke: '#ebebeb',
                                    fill: '#ebebeb'
                                }
                            }
                        },
                        onclick: function onclick() {
                            var button = this.exportSVGElements[0];
                            var button2 = this.exportSVGElements[2];
                            button.attr({
                                x: -200
                            });
                            button2.attr({
                                x: -200 //1
                            });
                            adjustScale(this);
                        }
                    },
                    customButton2: {
                        symbol: 'text:\uF204',
                        text: ctrl.translation.text.AUTO_SCALE,
                        symbolSize: 9,
                        symbolFill: '#6b7074',
                        symbolStrokeWidth: 0,
                        align: "left",
                        verticalAlign: 'bottom',
                        x: -200,
                        y: $scope.mobile ? -70 : -70, //I know...
                        symbolY: $scope.mobile ? 14 : 14,
                        theme: {
                            'stroke-width': 0,
                            stroke: '#ebebeb',
                            fill: '#ebebeb',
                            r: 0,
                            states: {
                                hover: {
                                    title: ctrl.translation.text.TOGGLE_AUTOSCALE,
                                    fill: '#ebebeb'
                                },
                                select: {
                                    stroke: '#ebebeb',
                                    fill: '#ebebeb'
                                }
                            }
                        },
                        onclick: function onclick() {
                            var button = this.exportSVGElements[0];
                            var button2 = this.exportSVGElements[2];
                            button.attr({
                                x: -200 //1
                            });
                            button2.attr({
                                x: -200
                            });
                            adjustScale(this);
                        }
                    }
                }
            },
            xAxis: {
                title: {
                    text: ctrl.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 3,
                    color: 'green',
                    dashStyle: "solid",
                    zIndex: 1
                }],
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minTickInterval: 3600 * 1000,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                dateTimeLabelFormats: {
                    hour: chartXaxisHourFormat
                },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (chartDrawn === true) {
                            var _extremes = chart.xAxis[0].getExtremes();
                            if ($scope.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) {
                                //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                if (_extremes.max + ctrl.liveDataOffset <= _extremes.dataMax) {
                                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: false, windowId: ctrl.windowId });
                                    _unRegisterListener($scope.deviceSelectedSn);
                                }
                            }
                            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { zoomMin: _extremes.min, zoomMax: _extremes.max, windowId: ctrl.windowId });
                            _downsampleSeries(_extremes.min, _extremes.max);
                        }
                    }
                }
            },
            yAxis: $scope.yAxis,
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var d = new Date(this.x);
                    var s = '';
                    s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, ctrl.accountInfo.timeZone)) + '</td></tr>';
                    $.each(this.points, function (i, point) {
                        s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, 2) + '</td></tr>';
                        ctrl.xValue = point.x;
                    });
                    s += '</table>';
                    return s;
                },
                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 0,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
            },
            plotOptions: {
                series: {
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                ctrl.xValue = this.x;
                            }
                        }
                    },
                    borderColor: 'red',
                    borderWidth: 1,
                    marker: {
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    events: {
                        legendItemClick: function legendItemClick() {
                            if (this.visible) {
                                if ($scope.numberOfHiddenSeries < $scope.numberOfSeries - 1) {
                                    $scope.numberOfHiddenSeries = $scope.numberOfHiddenSeries + 1;
                                } else {
                                    return false;
                                }
                            } else {
                                $scope.numberOfHiddenSeries = $scope.numberOfHiddenSeries - 1;
                            }

                            this.chart.yAxis[this.index].update({
                                labels: {
                                    enabled: this.visible ? false : true
                                },
                                title: {
                                    text: this.visible ? null : $scope.series[this.index].name
                                },
                                lineWidth: this.visible ? 0 : 2
                            });

                            ctrl.saveDesktopSettingService.setSerieVisibilitySetting(this.options.id, this.visible ? false : true, ctrl);
                        },
                        mouseOut: function mouseOut() {
                            ctrl.xValue = null;
                        }
                    }
                }
            },
            series: $scope.series
        });

        $scope.chart = chart;
        var tmpNewDateA = void 0;
        var tmpNewDateB = void 0;
        var extremes = chart.xAxis[0].getExtremes();

        if (ctrl.stickyProperties.on === true && ctrl.stickyProperties.mostRecentData === undefined) {
            tmpNewDateA = ctrl.stickyProperties.zoomMin >= extremes.dataMin ? ctrl.stickyProperties.zoomMin : extremes.dataMin; //extremes.dataMin + scope.unixDay / 24 * 3;
            tmpNewDateB = ctrl.stickyProperties.zoomMax <= extremes.dataMax + ctrl.liveDataOffset ? ctrl.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + ctrl.unixDay / 24 ? tmpNewDateB : extremes.dataMax - ctrl.unixDay / 24 * 12;
            ctrl.stickyProperties.on = false;
        } else {
            ctrl.stickyProperties.mostRecentData === undefined;
            tmpNewDateA = ctrl.myDate !== null ? extremes.dataMin + ctrl.unixDay : extremes.dataMax - ctrl.unixDay / 24 * 12;
            tmpNewDateB = ctrl.myDate !== null ? tmpNewDateA + ctrl.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - ctrl.unixDay;
            }
            tmpNewDateA = tmpNewDateA + ctrl.minPadding;
            tmpNewDateB = tmpNewDateB + ctrl.maxPadding;
        }

        chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        if ($scope.series !== null) {
            //only for voltage chart if no setup
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceSelected, zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: ctrl.windowId });
        } else {
            chart.showLoading('Voltage Setup not available!');
        }
        _setLiveDataStatus();
        chartDrawn = true;
        ctrl.loadingInProgress = false;
    };

    //==========================socket data================================
    var wsDataReceivedVOLTAGE = function wsDataReceivedVOLTAGE(data) {

        if ($scope.liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        var str = data.Time + "";
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, ctrl.accountInfo.timeZone);

        var varValue = parseFloat(data.Value);
        var varType = data.Type;
        var varVBATT = null;
        var varVAC = null;

        if (varType == "VBATT") {
            varVBATT = varValue;
        } else {
            if ($scope.solar && $scope.deviceModel != 18 && $scope.deviceModel != 19) {
                varVAC = (100 * varValue + 140) / 100;
            } else if ($scope.solar) {
                varVAC = 100 * varValue / 100;
            } else {
                varVAC = 100 * varValue * .707 / 100;
            }
        }

        if (varType == "VBATT") {
            $scope.series = chart.get("0");
            $scope.series.addPoint([unixtime, varVBATT]);
        }
        if (varType == "VAC") {
            $scope.series = chart.get("1");
            $scope.series.addPoint([unixtime, varVAC]);
        }

        if (extremes.max + ctrl.liveDataOffset > extremes.dataMax && varType == "VBATT") chart.xAxis[0].setExtremes(unixtime - tmpRange + ctrl.minPadding, unixtime + ctrl.maxPadding);
        var varTime = datetimeService.socketStrToServerStrTime(data.Time);
        ctrl.lastUpdateAt = varTime;
    };

    $scope.$on('processReconnect', function (event, args) {
        ctrl.reconnectData(event, args);
    });

    ctrl.reconnectData = function (event, args) {
        sharedSetupService.processReconnect({
            stickyProperties: ctrl.stickyProperties,
            localDateTime: args != null ? args.localDateTime : $scope.keepAlive,
            dateRangeOption: 0,
            windowTitle: $scope.windowTitle,
            fnUnregister: _unRegisterListener,
            fnGetData: _getData,
            viewType: "Chart"
        });
    };

    var tlDataReceivedVOLTAGE = function tlDataReceivedVOLTAGE(data) {
        data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, ctrl.accountInfo.timeZone);

        if ($scope.liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - ctrl.unixDay / 2) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var liveDataLine = chart.xAxis[0].plotLinesAndBands;
        liveDataLine[0].options.value = data.Unix + ctrl.maxPadding;

        if (extremes.max + ctrl.liveDataOffset > extremes.dataMax) chart.xAxis[0].setExtremes(data.Unix - tmpRange + ctrl.minPadding, data.Unix + ctrl.maxPadding);
    };

    var _setLiveDataStatus = function _setLiveDataStatus(varEndDate) {
        $scope.liveDataEndDate = varEndDate != null ? varEndDate : $scope.liveDataEndDate;
        timeLapseService.getLocalDateTime().then(function (result) {
            $scope.heartbeatLocalDateTime = result.data.unixTimeStamp;
            var extremes = chart.xAxis[0].getExtremes();
            if ($scope.liveDataEndDate > result.data.unixTimeStamp && ctrl.stickyProperties.zoomMax + ctrl.liveDataOffset >= extremes.dataMax) {
                _registerListener($scope.deviceSelectedSn);
                var data = { Unix: result.data.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedVOLTAGE(data);
            } else {
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: false, windowId: ctrl.windowId });
                _unRegisterListener($scope.deviceSelectedSn);
            }
        });
    };

    var _registerListener = function _registerListener(varSelectedSN) {
        websocketService.connect();
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: true, windowId: ctrl.windowId });
        for (var i = 0; i <= 1; i++) {
            if (chart.series[i] && parseInt(chart.series[i].options.id) <= 1) {
                if (i == 0) {
                    websocketService.register("VBATT", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
                    timeLapseService.register("VBATT", varSelectedSN, "", tlDataReceivedVOLTAGE);
                }
                if (i == 1) websocketService.register("VAC", varSelectedSN, "", wsDataReceivedVOLTAGE, null); //one call-back to reconnect is enough
            }
        }
        $scope.liveData = true;
    };

    var _unRegisterListener = function _unRegisterListener(varSelectedSN) {
        websocketService.unRegister("VBATT", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
        timeLapseService.unRegister("VBATT", varSelectedSN, "", tlDataReceivedVOLTAGE);
        websocketService.unRegister("VAC", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
        $scope.liveData = false;
        ctrl.lastUpdateAt = undefined;
    };

    var _downsampleSeries = function _downsampleSeries(varMin, varMax) {
        ctrl.zoomLevelCurrent = varMax - varMin;
        if (ctrl.zoomLevelCurrent <= ctrl.unixDay && ctrl.zoomLevelPrevious > ctrl.unixDay) {
            for (var i = 0; i < chart.series.length - 1; i++) {
                chart.series[i].update({ downsample: { threshold: 0 } }, false);
                chart.series[i].setData($scope.series[i].data, false);
            }
            chart.redraw();
        } else if (ctrl.zoomLevelCurrent > ctrl.unixDay && ctrl.zoomLevelPrevious <= ctrl.unixDay) {
            for (var _i = 0; _i < chart.series.length - 1; _i++) {
                chart.series[_i].update({ downsample: { threshold: 1000 } }, false);
            }
            chart.redraw();
        }
        ctrl.zoomLevelPrevious = ctrl.zoomLevelCurrent;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        if ($scope.alerts.length === 0) {
            _drawChart();
        }
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.applyTimeFormat(timeFormat);
        if ($scope.alerts.length === 0) {
            _drawChart();
        }
    });

    $scope.applyTimeFormat = function (timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat);
    };

    $scope.$on("$destroy", function () {
        _unRegisterListener($scope.deviceSelectedSn);
        if (chart) chart.destroy();
        if (!angular.isUndefined(ctrl.stickyProperties.setting)) ctrl.stickyProperties.setting = null;
    });
}

VoltageChartController.$inject = ['$scope', 'sharedSetupService', 'openViewService', '$element', 'authenticationService', '$rootScope', '$timeout', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'rangeSelectorService', 'SaveDesktopSettingService', 'VoltageChartFactory', 'translationService'];
'use strict';

angular.module('mc.voltage-chart').component('voltageChart', {
    controller: VoltageChartController,
    templateUrl: 'ui/voltage/chart/voltage-chart-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VolumetricFlowChartModel(HOST, $http, translationService) {
  var VolumetricFlow = function () {
    function VolumetricFlow(customerId, deviceId) {
      _classCallCheck(this, VolumetricFlow);

      this._setting = [];
      this._loading = false;
      this._customerId = customerId;
      this._deviceId = deviceId;
      this._deviceName = '';
      this._scale = 1;
    }

    _createClass(VolumetricFlow, [{
      key: 'fetchData',
      value: function fetchData(startDate, endDate) {
        var _this = this;

        this._loading = true;
        return $http.get(HOST + '/api/VolumetricFlowChart?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&startDate=' + startDate + '&endDate=' + endDate).then(function (resp) {
          _this._deviceName = resp.data.device.name;
          _this._loading = false;

          return resp;
        });
      }
    }, {
      key: 'deviceName',
      get: function get() {
        return this._deviceName;
      }
    }, {
      key: 'setting',
      get: function get() {
        return this._setting;
      }
    }, {
      key: 'loading',
      get: function get() {
        return this._loading;
      }
    }, {
      key: 'deviceId',
      set: function set(deviceId) {
        this._deviceId = deviceId;
      }
    }]);

    return VolumetricFlow;
  }();

  return VolumetricFlow;
}

VolumetricFlowChartModel.$inject = ['HOST', '$http', 'translationService'];

angular.module('mc.volumetricflow').factory('volumetricFlowChartModel', VolumetricFlowChartModel);
"use strict";

function VolumetricFlowChartController(_, $, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, timeLapseService, websocketService, openViewService, sharedSetupService, VolumetricFlowChart, toaster, rangeSelectorService) {
    var _this2 = this;

    this.downloadViewTypeOptions = [1];
    this.setDevice = function (selectedDevice) {
        $scope.deviceSelected = selectedDevice.deviceId;
        $scope.deviceSelectedSn = selectedDevice.serialNumber;
        $scope.deviceSelectedType = selectedDevice.type;
        $scope.deviceSelectedName = selectedDevice.name;
        $scope.currentSelectedDevice = selectedDevice;
    };

    var tlDataReceivedVOLCALC = function tlDataReceivedVOLCALC(data) {
        data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, $scope.accountInfo.timeZone);

        if (_this2.liveData === false) {
            unregisterListener();
            return;
        }

        var extremes = _this2.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - _this2.unixDay / 2) {
            unregisterListener($scope.deviceSelectedSn);
            return;
        }

        var liveDataLine = _this2.chart.xAxis[0].plotLinesAndBands;
        liveDataLine[0].options.value = data.Unix + _this2.maxPadding;

        if (extremes.max + _this2.liveDataOffset > extremes.dataMax) {
            _this2.chart.xAxis[0].setExtremes(data.Unix - tmpRange + _this2.minPadding, data.Unix + _this2.maxPadding);
        }
    };

    var wsDataReceivedVOLCALC = function wsDataReceivedVOLCALC(data) {
        if (data && data.ComputeTime) {
            var varTime = datetimeService.socketStrToServerStrTime(data.ComputeTime);
            var newRecord = { computeTime: varTime, pump: parseInt(data.Pump), runtime: parseFloat(data.Runtime), startLevel: parseFloat(data.StartLevel), endLevel: parseFloat(data.EndLevel), flow: parseFloat(data.Gallons), pumpRate: parseFloat(data.PumpGPM), inFlow: parseFloat(data.AvgFlow) };
            var gpmData = [data.ComputeTime, parseFloat(data.PumpGPM)];
            var avgFlowData = [data.ComputeTime, parseFloat(data.AvgFlow)];
            var gpmSerieName = _this2.measurement == 1 ? "Pump " + data.Pump + " GPM" : "Pump " + data.Pump + " Liters";
            var avgFlowSerieName = "Station Inflow Pump " + data.Pump;
            var extremes = _this2.chart.xAxis[0].getExtremes();
            var tmpRange = extremes.max - extremes.min;
            var str = data.ComputeTime + '';
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
            unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, $scope.accountInfo.timeZone);

            for (var i = 0; i < _this2.series.length; i++) {
                if (_this2.series[i].name == gpmSerieName) _this2.series[i].data.push([unixtime, parseFloat(data.PumpGPM)]);
                if (_this2.series[i].name == avgFlowSerieName) _this2.series[i].data.push([unixtime, parseFloat(data.AvgFlow)]);
            }

            for (var i = 0; i < _this2.rawSeries.length; i++) {
                if (_this2.rawSeries[i].name == gpmSerieName) _this2.rawSeries[i].data.push([unixtime, parseFloat(data.PumpGPM)]);
                if (_this2.rawSeries[i].name == avgFlowSerieName) _this2.rawSeries[i].data.push([unixtime, parseFloat(data.AvgFlow)]);
            }

            var pumpGPM = parseFloat(data.PumpGPM);
            var avgFlow = parseFloat(data.AvgFlow);

            if (_this2.measurement === 1) {
                pumpGPM = Math.abs(pumpGPM / _this2.volumetricFlow._scale);
                avgFlow = Math.abs(avgFlow / _this2.volumetricFlow._scale);
            } else if (_this2.measurement === 2) {
                pumpGPM = 0.06 * Math.abs(3.78541178 * pumpGPM / _this2.volumetricFlow._scale);
                avgFlow = 0.06 * Math.abs(3.78541178 * avgFlow / _this2.volumetricFlow._scale);
            }

            for (var i = 0; i < _this2.chart.series.length; i++) {
                if (_this2.chart.series[i].name == gpmSerieName) _this2.chart.series[i].data.push([unixtime, pumpGPM]);
                if (_this2.chart.series[i].name == avgFlowSerieName) _this2.chart.series[i].data.push([unixtime, avgFlow]);
            }
            var resetView = 'live';
            _drawChart(resetView);

            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;
                var extremes = _this2.chart.xAxis[0].getExtremes();
                if (_this2.liveDataEndDate > result.unixTimeStamp && $scope.stickyProperties.zoomMax + _this2.liveDataOffset >= extremes.dataMax) {
                    registerListener($scope.deviceSelectedSn);
                    var _data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                    tlDataReceivedVOLCALC(_data);
                }
            });
        }
    };

    var wsReconnectVOLCALC = function wsReconnectVOLCALC(data) {
        console.log(data);
    };

    var registerListener = function registerListener(deviceSn) {

        if (_this2.liveData === true) {
            return;
        }

        _this2.liveData = true;
        if (_this2.volumetricFlow) {
            _this2.volumetricFlow.liveData = _this2.liveData;
        }
        websocketService.connect();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: true, windowId: _this2.windowId });
        timeLapseService.register('VOLCALC', deviceSn || $scope.deviceSelectedSn, '', tlDataReceivedVOLCALC);
        websocketService.register('VOLCALC', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedVOLCALC, wsReconnectVOLCALC);
    };

    var unregisterListener = function unregisterListener(deviceSn) {
        if (_this2.liveData === false) {
            return;
        }
        _this2.liveData = false;
        if (_this2.volumetricFlow) {
            _this2.volumetricFlow.liveData = _this2.liveData;
        }
        _this2.lastUpdateAt = undefined;
        if (_this2.chart != null) timeLapseService.unRegister('VOLCALC', deviceSn || $scope.deviceSelectedSn, '', tlDataReceivedVOLCALC);
        websocketService.unRegister('VOLCALC', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedVOLCALC, wsReconnectVOLCALC);
    };

    var setLiveDataStatus = function setLiveDataStatus(varEndDate) {
        _this2.liveDataEndDate = varEndDate ? varEndDate : _this2.liveDataEndDate;
        if (_this2.selectedGrouping === '4') {
            _this2.liveDataEndDate += _this2.unixDay;
        }

        timeLapseService.getLocalDateTime().then(function (resp) {
            var result = resp.data;
            $scope.heartbeatLocalDateTime = resp.data.unixTimeStamp;
            var extremes = _this2.chart.xAxis[0].getExtremes();
            if (_this2.liveDataEndDate > result.unixTimeStamp && $scope.stickyProperties.zoomMax + _this2.liveDataOffset >= extremes.dataMax) {
                registerListener($scope.deviceSelectedSn);
                var data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedVOLCALC(data);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: _this2.windowId });
                unregisterListener($scope.deviceSelectedSn);
            }
        });
    };

    var _drawChart = function _drawChart(resetView) {
        _this2.chartDrawn = false;
        var chartBase = $("#volumetric-flow-chart-" + _this2.replaceSpaces(_this2.windowId));
        var tmpData = _this2.series;
        var chartXaxisHourFormat = _this2.preferredTimeFormat === _this2.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
        var chartToolTipHourFormat = _this2.preferredTimeFormat === _this2.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';
        var midPadding = 0;
        var maxPadding = 0;
        var self = _this2;

        var numberOfSeries = 0;
        var numberOfHiddenSeries = 0;
        self.yAxis = [];
        for (var i = 0; i < _this2.series.length; i++) {
            self.yAxis.push({
                gridLineWidth: 0,
                gridLineColor: _this2.series[i].color,
                id: '0',
                opposite: false,
                endOnTick: true,
                lineColor: _this2.series[i].color,
                min: 0,
                nax: null,
                labels: {
                    enabled: false,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                title: {
                    enabled: false,
                    text: _this2.measurement === 1 ? "GPM" : "m³h",
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                }
            });
        }
        if (!!self.yAxis[0]) {
            self.yAxis[0].title.enabled = true;
            self.yAxis[0].labels.enabled = true;
        }
        self.chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: true,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1
            },
            time: {
                getTimezoneOffset: function getTimezoneOffset(timestamp) {
                    return -moment.tz(timestamp, datetimeService.getTimeZoneId($scope.accountInfo.timeZone)).utcOffset();
                }
            },
            chart: {
                renderTo: chartBase[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#d3d3d3',
                borderWidth: 1,
                borderRadius: 2,
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                marginRight: 10,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                spacingRight: 5,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {
                        var _this3 = this;

                        var volumetricFlowData = [];
                        var extremes = this.xAxis[0].getExtremes();

                        var tmpDates = null;
                        var i = -1;

                        if (this.xAxis && self.chartDrawn === true && self.scrollingInProgress === false) {
                            if (extremes && extremes.dataMin >= extremes.min - self.liveDataOffset) {
                                self.scrollingInProgress = true;
                                var dateMin = new Date(extremes.dataMin);
                                var dateMinOffset = dateMin.getTimezoneOffset();
                                var offset = !isNaN(dateMinOffset) ? dateMinOffset : $scope.accountInfo.timeZoneOffset;

                                //Highcharts retruns extreme data points in Local Machine TimeZone. 
                                //If customer logs in from different timeZone. Respect the set Customer TimeZone for the incoming data
                                if (dateMinOffset != $scope.accountInfo.timeZoneOffset) {
                                    extremes.dataMin = extremes.dataMin + Number(dateMinOffset - $scope.accountInfo.timeZoneOffset) * 60 * 1000;
                                }
                                //convert utctime to local time by considering timezoneoffset
                                var newtempDate = extremes.dataMin - offset * 60 * 1000;
                                if ($scope.varDay == 3) {
                                    tmpDates = datetimeService.getNewStartEndDates(newtempDate, -12);
                                } else {
                                    tmpDates = datetimeService.getNewStartEndDates(newtempDate, -11);
                                }
                                self.volumetricFlow.fetchData(tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            self.rawSeries[i].data = JSON.parse(JSON.stringify(resp.data.series[i].data)).concat(self.rawSeries[i].data);
                                            for (var j = 0; j < resp.data.series[i].data.length; j++) {
                                                if (self.measurement === 1) {
                                                    resp.data.series[i].data[j][1] = Math.abs(resp.data.series[i].data[j][1] / self.volumetricFlow._scale);
                                                } else if (self.measurement === 2) {
                                                    resp.data.series[i].data[j][1] = 0.06 * Math.abs(3.78541178 * resp.data.series[i].data[j][1] / self.volumetricFlow._scale);
                                                }
                                            }
                                            volumetricFlowData.push(resp.data.series[i].data);
                                        }
                                    }

                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            tmpData[i].data = volumetricFlowData[i].concat(tmpData[i].data);
                                            self.chart.series[i].setData(tmpData[i].data);
                                        }
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, windowId: self.windowId });
                                    self.chart.xAxis[0].setExtremes(extremes.min + self.minPadding, extremes.max + self.maxPadding);
                                    setLiveDataStatus();

                                    $timeout(function () {
                                        self.scrollingInProgress = false;
                                    }, 1000);

                                    self.chart.hideLoading();
                                }, function (resp) {
                                    $scope.alerts = [];
                                    self.alerts = [];
                                    chartBase.empty();
                                    _this3.chart = null;
                                    var errormsg = self.translation.message.GENERAL_SERVER_ERROR;
                                    $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                    self.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                });
                            } else if (self.liveData === false && extremes && extremes.max + self.liveDataOffset >= extremes.dataMax) {
                                self.scrollingInProgress = true;

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 11);

                                if (self.selectedGrouping === '4') {
                                    tmpDates.endDate += self.unixDay;
                                }

                                self.volumetricFlow.fetchData(tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            self.rawSeries[i].data = self.rawSeries[i].data.concat(JSON.parse(JSON.stringify(resp.data.series[i].data)));
                                            for (var j = 0; j < resp.data.series[i].data.length; j++) {
                                                if (self.measurement === 1) {
                                                    resp.data.series[i].data[j][1] = Math.abs(resp.data.series[i].data[j][1]);
                                                } else if (self.measurement === 2) {
                                                    resp.data.series[i].data[j][1] = 0.06 * Math.abs(3.78541178 * resp.data.series[i].data[j][1]);
                                                }
                                            }
                                            volumetricFlowData.push(resp.data.series[i].data);
                                        }
                                    }

                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            tmpData[i].data = tmpData[i].data.concat(volumetricFlowData[i]);
                                            self.chart.series[i].setData(tmpData[i].data);
                                        }
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: tmpDates.endDate, windowId: self.windowId });
                                    self.chart.xAxis[0].setExtremes(extremes.min + self.minPadding, extremes.max + self.maxPadding);
                                    setLiveDataStatus(tmpDates.endDate);

                                    $timeout(function () {
                                        self.scrollingInProgress = false;
                                    }, 1000);

                                    self.chart.hideLoading();
                                }, function (resp) {
                                    $scope.alerts = [];
                                    self.alerts = [];
                                    chartBase.empty();
                                    _this3.chart = null;
                                    var errormsg = self.translation.message.GENERAL_SERVER_ERROR;
                                    $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                    self.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                });
                            }
                        }
                    },
                    load: function load(event) {
                        if (self.initialLoad) openViewService.adjustContentSize(self._popup);
                        self.initialLoad = false;
                    },
                    selection: function selection(event) {
                        if (!event.xAxis) {
                            var button = this.exportSVGElements[0];
                            var button2 = this.exportSVGElements[2];
                            button.attr({
                                x: -5
                            });
                            button2.attr({
                                x: -100
                            });
                            adjustScale(this);
                        }
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                }
            },
            xAxis: {
                title: {
                    text: self.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 3,
                    color: 'green',
                    dashStyle: 'solid',
                    zIndex: 1
                }],
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minorTickInterval: 'auto',
                minorGridLineColor: '#ebebeb',
                dateTimeLabelFormats: {
                    hour: chartXaxisHourFormat
                },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (self.chartDrawn === true) {

                            if (e.trigger === 'rangeSelectorButton') {

                                var newRanges = rangeSelectorService.getrangeExtremes(e.dataMax, e.dataMin, e.rangeSelectorButton, 24);

                                sharedSetupService.setStickyProperties($scope.stickyProperties, {
                                    zoomMin: newRanges.newMin,
                                    zoomMax: newRanges.newMax,
                                    windowId: self.windowId
                                });
                                $scope.stickyProperties.on = true;
                                //Reload
                                if (newRanges.newDataMax < event.dataMin || newRanges.newDataMax > event.dataMax) _getData($scope.stickyProperties.deviceId, newRanges.newDataMin, newRanges.newDataMax);
                            } else {
                                var _extremes = self.chart.xAxis[0].getExtremes();
                                if (self.liveData === true && (e.trigger === 'navigator' || e.trigger === 'pan' || typeof e.trigger === 'undefined')) {
                                    if (_extremes.max + self.liveDataOffset <= _extremes.dataMax) {
                                        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: self.windowId });
                                        unregisterListener($scope.deviceSelectedSn);
                                    }
                                }
                                sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: _extremes.min, zoomMax: _extremes.max, windowId: self.windowId });
                            }
                        }
                    }
                }
            },
            yAxis: self.yAxis,

            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var s = '';
                    s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartXaxisHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, $scope.accountInfo.timeZone)) + '</td></tr>';
                    $.each(this.points, function (i, point) {
                        var decimals = 0;

                        if (point.series.color === '#2288cc') {
                            if (point.y > 1000) {
                                decimals = 0;
                            } else {
                                if (point.y > 10) {
                                    decimals = 1;
                                } else {
                                    decimals = 2;
                                }
                            }
                        }

                        s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + $filter('number')(parseFloat(point.y).toFixed(decimals), decimals) + '</td></tr>';
                        self.xValue = point.x;
                    });
                    s += '</table>';
                    return s;
                },

                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 0,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
            },
            plotOptions: {
                series: {
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                self.xValue = this.x;
                            }
                        }
                    },
                    borderColor: '#303030',
                    borderWidth: 1,
                    marker: {
                        enabled: null, //If null, the markers are hidden when the data is dense, and shown for more widespread data points.
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    pointWidth: 12,
                    events: {
                        legendItemClick: function legendItemClick() {
                            numberOfSeries = self.chart.series.length - 1;
                            var visibility = this.visible ? 'visible' : 'hidden';
                            numberOfHiddenSeries = visibility === 'hidden' ? numberOfHiddenSeries - 1 : numberOfHiddenSeries + 1;
                            numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                            if (numberOfHiddenSeries < numberOfSeries) {
                                self.chart.yAxis[this.index].update({
                                    labels: {
                                        // enabled: visibility !== 'visible',
                                    },
                                    title: {
                                        // text: visibility === 'visible' ? null : self.series[this.index].name,
                                    }
                                    //lineWidth: visibility === 'visible' ? 0 : 2,
                                });
                                return true;
                            }
                            numberOfHiddenSeries = numberOfHiddenSeries - 1;
                            return false;
                        },
                        mouseOut: function mouseOut() {
                            self.xValue = null;
                        }
                    }
                }
            },
            series: self.series
        });

        $timeout(function () {
            for (var i = 0; i < self.series.length; i++) {
                self.series[i].marker = {
                    enabled: null,
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#FFFFFF',
                    lineWidth: 2,
                    lineColor: null // inherit from series
                };
            }
        });

        var tmpNewDateA = void 0;
        var tmpNewDateB = void 0;
        var extremes = self.chart.xAxis[0].getExtremes();

        if ($scope.stickyProperties.on === true) {
            tmpNewDateA = $scope.stickyProperties.zoomMin >= extremes.dataMin ? $scope.stickyProperties.zoomMin : extremes.dataMin;
            tmpNewDateB = $scope.stickyProperties.zoomMax <= extremes.dataMax + _this2.liveDataOffset ? $scope.stickyProperties.zoomMax : extremes.dataMax;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + _this2.unixDay / 24 ? tmpNewDateB : extremes.dataMax - _this2.unixDay / 24 * 12;
            $scope.stickyProperties.on = false;
        } else {
            tmpNewDateA = _this2.myDate !== null ? extremes.dataMin + _this2.unixDay : extremes.dataMax - _this2.unixDay / 24 * 6;
            tmpNewDateB = _this2.myDate !== null ? tmpNewDateA + _this2.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - _this2.unixDay;
            }
            tmpNewDateA = tmpNewDateA + _this2.minPadding;
            tmpNewDateB = tmpNewDateB + _this2.maxPadding;
        }

        if (tmpNewDateA > tmpNewDateB) {
            var temp = tmpNewDateA;
            tmpNewDateA = tmpNewDateB;
            tmpNewDateB = temp;
        }

        _this2.chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        if (_this2.series !== null) {
            // only for analog chart if no setup
            sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: _this2.windowId });
        } else {
            // this.chart.showLoading('Pulse Flow Setup not available!');
        }

        if (!resetView) {
            setLiveDataStatus();
        } else {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var data = { Unix: resp.data.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedVOLCALC(data);
            });
        }

        self.chartDrawn = true;
    };

    var _getData = function _getData(startDate, endDate, resetView) {
        _this2.liveDataEndDate = endDate;
        _this2.volumetricFlow.fetchData(startDate, endDate).then(function (resp) {
            var chartBase = $("#volumetric-flow-chart-" + _this2.replaceSpaces(_this2.windowId));
            _this2.setting = resp.data.setting;
            // this.deviceSelectedSN = resp.data.device.serialNumber;
            // this.yAxis = resp.data.yAxis;
            _this2.rawSeries = JSON.parse(JSON.stringify(resp.data.series));
            _this2.series = resp.data.series;
            if (_this2.series.length > 0) {
                for (var k = 0; k < _this2.series.length; k++) {
                    for (var i = 0; i < _this2.series[k].data.length; i++) {
                        if (_this2.measurement === 1) {
                            _this2.series[k].data[i][1] = Math.abs(_this2.series[k].data[i][1]);
                        } else if (_this2.measurement === 2) {
                            _this2.series[k].data[i][1] = 0.06 * Math.abs(3.78541178 * _this2.series[k].data[i][1]);
                        }
                    }
                    if (_this2.measurement === 2 && _this2.series[k].name.substr(_this2.series[k].name.length - 3) === "GPM") {
                        _this2.series[k].name = _this2.series[k].name.substring(0, _this2.series[k].name.length - 3) + "m³h";
                    } else if (_this2.measurement === 1 && _this2.series[k].name.substr(_this2.series[k].name.length - 3) === "m³h") {
                        _this2.series[k].name = _this2.series[k].name.substring(0, _this2.series[k].name.length - 3) + "GPM";
                    } else {
                        _this2.series[k].name = _this2.series[k].name;
                    }
                }
            }
            $scope.alerts = [];
            _this2.alerts = [];

            if (resp.data.series && resp.data.series.length > 0 && resp.data.series[0].data.length >= 1) {
                _this2.devicename = resp.data.device.name;
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate, windowId: _this2.windowId });
                _drawChart(resetView);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate, windowId: _this2.windowId });
                chartBase.empty();
                _this2.chart = null;
                _this2.lastStart = startDate;
                _this2.lastEnd = endDate;
                var errormsg = _this2.translation.message.NO_DATA + ': ' + moment(startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(endDate).utc().format('MM/DD/YY, h:mm:ss a');
                $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
                _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
            }
        }, function (resp) {
            $scope.alerts = [];
            _this2.alerts = [];
            chartBase.empty();
            _this2.chart = null;
            var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
            $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
            _this2.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
        });
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        _this2.chart = null;
        _this2.myDate = null;
        _this2.scrollingInProgress = false;
        _this2.initialLoad = true;
        _this2.zoomLevelCurrent = 0;
        _this2.zoomLevelPrevious = 0;
        _this2.xValue = null;
        _this2.liveData = false;
        _this2.selectedDeviceSN = null;
        _this2.chartDrawn = false;
        _this2.minPadding = 0;
        _this2.maxPadding = 0;
        _this2.selectedGrouping = '1';
        _this2.afterSetExtremesTimer = null;
        _this2.windowId = _this2.windowId || 'Volumetric Flow Chart';
        _this2.alerts = [];
        $scope.alerts = [];
        _this2.series = [];
        _this2.rawSeries = [];
        _this2.accountInfo = authenticationService.getAccountInfo();
        $scope.accountInfo = _this2.accountInfo;
        _this2.translation = translationService.translation;
        $scope.windowTitle = _this2.translation.text.VOLUMETRIC_FLOW_CHART;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.TimeFormatEnum = { Civilian: 1, Military: 2 };
        _this2.measurement = _this2.accountInfo.preferenceUser.lookupMeasurementID;
        _this2.preferredTimeFormat = _this2.accountInfo.preferenceUser.timeFormat;
        _this2.unixDay = sharedSetupService.unixDay;
        _this2.unixHour = 3600000;
        _this2.liveDataOffset = 20 * 60 * 1000;
        _this2.mouseWheelZoom = sharedSetupService.mouseWheelZoom;

        if (!_this2.mobile && !_this2.classicView) {
            $scope.windowId = _this2.windowId;
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;

            $timeout(function () {
                var chartBase = $("#volumetric-flow-chart-" + _this2.replaceSpaces(_this2.windowId));

                chartBase.on('mousewheel', function (event) {
                    if (!_this2.scrollingInProgress) {
                        _this2.mouseWheelZoom(event, _this2.chart, _this2.xValue);
                    }
                });
            });
        }

        $scope.$on('updatePreferencesLanguage', function (event, language) {
            openViewService.adjustContentSize(_this2._popup);
            if ($scope.alerts.length > 0) {
                var _msg = _this2.translation.message[$scope.alerts[0].languageCode.toUpperCase()];
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;

                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ": " + moment(_this2.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(_this2.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                }

                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }

            if (_this2.series.length > 0) {
                //   this.series[0].name = `${this.translation.text.PUMP} (${this.measurement === 1 ? 'GPM' : 'm³h'})`;
                //  this.series[1].name = `${this.translation.text.STATION_INFLOW} (${this.measurement === 1 ? 'GPM' : 'm³h'})`;
            }

            if (_this2.alerts.length === 0) {
                _drawChart();
            }
        });

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            _this2.preferredTimeFormat = parseInt(timeFormat, 10);
            if (_this2.alerts.length === 0) {
                _drawChart();
            }
        });

        $scope.$on('updatePreferencesMeasurement', function (event, measurement) {
            _this2.measurement = measurement;
            for (var i = 0; i < _this2.series.length; i++) {
                _this2.series[i].data = JSON.parse(JSON.stringify(_this2.rawSeries[i].data));
                for (var j = 0; j < _this2.series[i].data.length; j++) {
                    if (_this2.measurement === 1) {
                        _this2.series[i].data[j][1] = Math.abs(_this2.series[i].data[j][1]);
                    } else if (_this2.measurement === 2) {
                        _this2.series[i].data[j][1] = 0.06 * Math.abs(3.78541178 * _this2.series[i].data[j][1]);
                    }
                }
                if (_this2.measurement === 2 && _this2.series[i].name.substr(_this2.series[i].name.length - 3) === "GPM") {
                    _this2.series[i].name = _this2.series[i].name.substring(0, _this2.series[i].name.length - 3) + "m³h";
                } else if (_this2.measurement === 1 && _this2.series[i].name.substr(_this2.series[i].name.length - 3) === "m³h") {
                    _this2.series[i].name = _this2.series[i].name.substring(0, _this2.series[i].name.length - 3) + "GPM";
                } else {
                    _this2.series[i].name = _this2.series[i].name;
                }
            }

            if (_this2.series.length > 0) {
                //  this.series[0].name = `${this.translation.text.PUMP} (${this.measurement === 1 ? 'GPM' : 'm³h'})`;
                // this.series[1].name = `${this.translation.text.STATION_INFLOW} (${this.measurement === 1 ? 'GPM' : 'm³h'})`;
            }

            if (_this2.alerts.length === 0) {
                _drawChart();
            }
        });

        $scope.zoomAdjust = function (varDay) {
            var extremes = _this2.chart.xAxis[0].getExtremes();
            $scope.varDay = varDay;
            var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, $scope.heartbeatLocalDateTime);
            _this2.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
            setLiveDataStatus();
        };

        $scope.mostRecentData = function () {
            _this2.myDate = null;
            toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
            $scope.fetchDataForSelectedDate(new Date());
        };

        $scope.fetchDataForSelectedDate = function (newVal) {
            var chartBase = $("#volumetric-flow-chart-" + _this2.replaceSpaces(_this2.windowId));
            var tmpDates = newVal;
            tmpDates.setHours(0, 0, 0, 0);
            _this2.myDate = tmpDates;
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);

            _this2.volumetricFlow.fetchData(tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                _this2.rawSeries = JSON.parse(JSON.stringify(resp.data.series));
                _this2.series = resp.data.series;
                //  resp.data.series[0].name = `${this.translation.text.PUMP} (${this.measurement === 1 ? 'GPM' : 'm³h'})`;
                //  resp.data.series[1].name = `${this.translation.text.STATION_INFLOW} (${this.measurement === 1 ? 'GPM' : 'm³h'})`;

                for (var k = 0; k < _this2.series.length; k++) {
                    for (var i = 0; i < _this2.series[k].data.length; i++) {
                        if (_this2.measurement === 1) {
                            _this2.series[k].data[i][1] = Math.abs(_this2.series[k].data[i][1]);
                        } else if (_this2.measurement === 2) {
                            _this2.series[k].data[i][1] = 0.06 * Math.abs(3.78541178 * _this2.series[k].data[i][1]);
                        }
                    }
                    if (_this2.measurement === 2 && _this2.series[k].name.substr(_this2.series[k].name.length - 3) === "GPM") {
                        _this2.series[k].name = _this2.series[k].name.substring(0, _this2.series[k].name.length - 3) + "m³h";
                    } else if (_this2.measurement === 1 && _this2.series[k].name.substr(_this2.series[k].name.length - 3) === "m³h") {
                        _this2.series[k].name = _this2.series[k].name.substring(0, _this2.series[k].name.length - 3) + "GPM";
                    } else {
                        _this2.series[k].name = _this2.series[k].name;
                    }
                }
                $scope.alerts = [];
                _this2.alerts = [];
                if (resp.data.series && resp.data.series.length > 0 && resp.data.series[0].data.length >= 1) {
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, windowId: _this2.windowId });
                    _drawChart();
                } else {
                    _this2.lastStart = tmpDates.startDate;
                    _this2.lastEnd = tmpDates.endDate;
                    var errormsg = _this2.translation.message.NO_DATA + ': ' + moment(tmpDates.startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(tmpDates.endDate).utc().format('MM/DD/YY, h:mm:ss a');
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + _this2.unixDay, zoomMax: tmpDates.endDate - _this2.unixDay, windowId: _this2.windowId });
                    chartBase.empty();
                    _this2.chart = null;
                    $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
                    _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
                }
            }, function (resp) {
                var errormsg = _this2.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts = [];
                _this2.alerts = [];
                chartBase.empty();
                _this2.chart = null;
                $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                _this2.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
            });
        };

        $scope.$watch(function () {
            return _this2.myDate;
        }, function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                $scope.fetchDataForSelectedDate(newVal);
            }
        });

        $scope.$watch(function () {
            return $scope.deviceSelectedSn;
        }, function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                if (oldVal) {
                    unregisterListener(oldVal);
                }
            }
        }, true);

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal) {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newVal, windowId: _this2.windowId });

                if (_this2.volumetricFlow) {
                    _this2.volumetricFlow.deviceId = newVal;
                } else {
                    _this2.volumetricFlow = new VolumetricFlowChart(_this2.accountInfo.customerId, newVal);
                }

                var tmpDates = null;
                var tmpStartDate = null;
                var tmpEndDate = null;

                if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
                    $scope.stickyProperties.on = true;
                    tmpStartDate = $scope.stickyProperties.dateMin;
                    tmpEndDate = $scope.stickyProperties.dateMax;
                } else {
                    $scope.stickyProperties.on = false;
                }

                if (!tmpStartDate) {
                    timeLapseService.getLocalDateTime().then(function (resp) {
                        var result = resp.data;

                        tmpDates = new Date(result.localDateTime);
                        tmpDates.setHours(0, 0, 0, 0);
                        tmpDates = datetimeService.dateToUnixtime(tmpDates);
                        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                        tmpStartDate = tmpDates.startDate;
                        tmpEndDate = tmpDates.endDate;
                        _getData(tmpStartDate, tmpEndDate);
                    });
                } else {
                    _getData(tmpStartDate, tmpEndDate);
                }
            }
        }, true);
    };

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    this.$onDestroy = function () {
        unregisterListener($scope.deviceSelectedSn);
        if (_this2.chart) _this2.chart.destroy();
    };
}

VolumetricFlowChartController.$inject = ['_', '$', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'timeLapseService', 'websocketService', 'openViewService', 'sharedSetupService', 'volumetricFlowChartModel', 'toaster', 'rangeSelectorService'];

angular.module('mc.volumetricflow').component('volumetricFlowChart', {
    controller: VolumetricFlowChartController,
    transclude: true,
    templateUrl: 'ui/volumetricflow/chart/volumetricflow-chart-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        myDate: '<'
    }
});
"use strict";

function TicketSystemEditController($, $rootScope, $scope, $q, $sce, $element, $timeout, host, authenticationService, translationService, sharedSetupService, openViewService, deviceMenuService, ticketSystemService, attchmentUpload, datetimeService, ivhTreeviewMgr, ivhTreeviewBfs, unsavedChangesService, $http) {
    var _this2 = this;

    var ctrl = this;
    //ctrl.UploadDirectory = "\\FS-CLUSTER\TicketFiles\";
    ctrl.deviceList = [];
    ctrl.priorities = [];
    ctrl.fileAttachments = [{ fileName: "", fileSize: 0, success: false }];

    ctrl.assignedToOptions = [{ id: 15288, name: "Technical Support" }, { id: 15283, name: "Sales" }];
    ctrl.jiraAttachments = [];
    ctrl.selectedProblemCategory = { id: '', label: '' };

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.buildProblemCategory();
        ctrl.filename = "Please Choose a file";

        $scope.windowId = ctrl.windowId; //need for
        //$scope.windowTitle = ctrl.windowTitle;//need for

        ctrl.getDevices();
        ctrl.getTicketEditModel();

        ctrl.viewMode = 2; //0:view, 1:create, 2:edit

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            //Check for unsaved Changes
            $(ctrl.popup).on('dialogbeforeclose', function (event) {
                if (ctrl.viewMode !== 0) {
                    unsavedChangesService.checkUnsavedChanges(event, ctrl.popup, _this2, true);
                }
            });
        }

        //update selected device
        $q.all([devicesDeffered.promise, modelDeffered.promise]).then(function () {
            for (var i = 0; i < ctrl.deviceList.length; i++) {
                if (ctrl.deviceList[i].serialNumber == ctrl.ticket.serialNumber) ctrl.selectedDevice = ctrl.deviceList[i];
            }
        });

        //manually making call to adjustSize in order to load scrollbar
        $timeout(function () {
            ctrl.adjustSize();
        }, 500);
    };

    ctrl.status = {
        //default - all the collapsible panels are open and enabled
        isFirstOpen: true,
        isFirstDisabled: false,
        isSecondOpen: true,
        isSecondDisabled: false,
        isThirdOpen: true,
        isThirdDisabled: false,
        isForthOpen: true,
        isForthDisabled: false

        //cancel editing ticket
    };ctrl.cancelEdit = function () {
        ctrl.viewMode = 0;
        ctrl.out();
    };

    //save the user entries 
    ctrl.update = function (newStatusCode) {
        if (ctrl.ticket.selectedTicketIssueType.issueTypeCode !== 'FTRQ') {
            ctrl.jiraAttachments = [];
        }
        ctrl.ticket.customerId = ctrl.accountInfo.customerId;
        ctrl.ticket.createdByLoginId = ctrl.accountInfo.userId;
        //ctrl.ticket.description = ctrl.txtNote;
        //ctrl.ticket.contactName = ctrl.txtContactName;
        //ctrl.ticket.contactPhone = ctrl.txtContactPhone;
        //ctrl.ticket.contactEmail = ctrl.txtContactEmail;
        ctrl.ticket.serialNumber = !isUndefinedOrNull(ctrl.selectedDevice) ? !isUndefinedOrNull(ctrl.selectedDevice.serialNumber) ? ctrl.selectedDevice.serialNumber : "" : "", ctrl.ticket.statusCode = newStatusCode;
        ctrl.ticket.issueTypeCode = ctrl.ticket.selectedTicketIssueType.issueTypeCode;
        ctrl.ticket.inputAttachmentBase64 = ctrl.jiraAttachments;
        ctrl.ticket.problemTypeCode = ctrl.selectedProblemCategory.id == 1 ? null : ctrl.selectedProblemCategory.id;
        ctrl.ticket.problemDescription = ctrl.selectedProblemCategory.label;

        ticketSystemService.UpdateTicket(ctrl.accountInfo.customerId, ctrl.ticket).then(function (resp) {
            //now upload the attachments to server
            // loop thru each row and upload to network folder and save to database.

            //create JIRA ticket if ticket issue type is 'New Feature Request'
            if (ctrl.ticket.selectedTicketIssueType.issueTypeCode == 'FTRQ' && ctrl.previousIssueTypeCode !== 'FTRQ') {
                ctrl.createJiraTicket(ctrl.accountInfo.customerId, ctrl.ticket);
            }
            ctrl.out(); //return back to parent view
        });
    };

    ctrl.createJiraTicket = function (customerId, _jiraIssue) {
        return $http.post(host + "/api/ITCMJira?customerId=" + customerId, _jiraIssue);
    };

    //close the ticket 
    ctrl.submit = function () {
        if (ctrl.updating || ctrl.updatingClose) return;
        ctrl.updating = true;
        ctrl.viewMode = 0;
        ctrl.update("ASND"); //status is set to ASND
    };

    //close the ticket 
    ctrl.close = function () {
        if (ctrl.updating || ctrl.updatingClose) return;
        ctrl.updatingClose = true;
        ctrl.update("CLSD"); //status is set to CLSD
    };

    //retrieve list of devices to load
    var devicesDeffered = $q.defer();
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data.devices;
            devicesDeffered.resolve();
        }, function (result) {});

        return devicesDeffered.promise;
    };

    //retrieve ticket edit model
    var modelDeffered = $q.defer();
    ctrl.getTicketEditModel = function () {
        ticketSystemService.GetTicketEditModel(ctrl.accountInfo.customerId, ctrl.ticketId).then(function (resp) {
            ctrl.ticket = resp.data.ticket;
            ctrl.ticket.description = "";
            ctrl.ticketEvents = resp.data.events;
            ctrl.ticketAttachments = resp.data.attachments;
            ctrl.ticketIssueTypes = resp.data.ticketIssueTypes;

            // Remove New Feature Request option if user type is not TechSupport
            if (ctrl.accountInfo.userType !== "TechSupport") {
                var index = ctrl.ticketIssueTypes.findIndex(function (obj) {
                    return obj.issueTypeCode === "FTRQ";
                });
                ctrl.ticketIssueTypes.splice(index, 1);
            }

            //set problem category
            var ivhTreeNode = ctrl.stuff.find(function (x) {
                return x.id == ctrl.ticket.problemTypeCode;
            });
            if (!!ivhTreeNode) {
                ivhTreeNode.selected = true;
                selectNode(ctrl.stuff, ivhTreeNode);
            }

            //set Ticket Issue Type
            if (ctrl.ticketIssueTypes.length > 0) {
                ctrl.ticket.selectedTicketIssueType = ctrl.ticketIssueTypes.find(function (x) {
                    return x.issueTypeCode === ctrl.ticket.issueTypeCode;
                });
                ctrl.previousIssueTypeCode = angular.copy(ctrl.ticket.issueTypeCode);
            }

            //set problem category
            var ivhNodeSelected = { id: ctrl.ticket.problemTypeCode, label: ctrl.ticket.problemDescription, selected: true };
            selectNode(ctrl.stuff, ivhNodeSelected);

            //ctrl.selectedDevice.serialNumber = ctrl.ticket.serialNumber;
            modelDeffered.resolve();
        });

        return modelDeffered.promise;
    };

    ctrl.addAttachment = function () {
        ctrl.fileAttachments.push({ fileName: "", fileSize: 0, success: false });
    };

    ctrl.removeAttachment = function (index) {
        ctrl.fileAttachments.splice(index, 1);
    };

    ctrl.uploadAttachments = function () {
        // loop thru each row 
        // first, upload file to network folder 
        // second, save details to database.
        $scope.alerts = [];
        angular.forEach(ctrl.fileAttachments, function (attachment, idx) {
            if (attachment.name == null || attachment.name === "") return;
            //isValidAttachment(attachment);
            var uploadUrl = host + "/api/uploadTicketAttachment?CustomerId=" + ctrl.accountInfo.customerId + "&TicketId=" + ctrl.ticketId;
            attchmentUpload.uploadFileToUrl(attachment, uploadUrl, saveAttachmentToDb, updateErrorAlerts);
        });
    };

    ctrl.uploadAttachment = function (attachment, idx) {
        $scope.alerts = [];
        if (attachment.name == null || attachment.name === "") return;
        if (isValidAttachment(attachment)) {
            var uploadUrl = host + "/api/uploadTicketAttachment?CustomerId=" + ctrl.accountInfo.customerId + "&TicketId=" + ctrl.ticketId;
            attchmentUpload.uploadFileToUrl(attachment, uploadUrl, idx, saveAttachmentToDb, updateErrorAlerts);
            ctrl.createJiraAttachment(attachment);
        }
    };

    ctrl.createJiraAttachment = function (attachment) {
        var reader = new FileReader();
        reader.readAsDataURL(attachment);
        reader.onload = function () {
            ctrl.base64result = reader.result.split(',')[1];
            ctrl.jiraAttachments.push(ctrl.base64result);
        };
    };

    var saveAttachmentToDb = function saveAttachmentToDb(obj, idx) {
        ticketSystemService.SaveAttachment(ctrl.accountInfo.customerId, ctrl.ticketId, obj).then(function (resp) {
            ctrl.fileAttachments[idx] = { fileName: "", fileSize: 0, success: true };

            //fetch updated list of attachments
            ticketSystemService.GetTicketAttachments(ctrl.accountInfo.customerId, ctrl.ticketId, true).then(function (result) {
                ctrl.ticketAttachments = result.data;
            });
        });
    };

    var updateErrorAlerts = function updateErrorAlerts(error) {
        $scope.alerts = [];
        $scope.alerts.push({ msg: "Failed to upload attachment (Error: " + error.data + ")", type: "danger", languageCode: 'NO_DATA' });
        $timeout(function () {
            ctrl.adjustSize();
        }, 0);
    };

    var isValidAttachment = function isValidAttachment(fileInput) {
        var retVal = false;
        //validate attachment first
        $scope.alerts = [];
        if (!isUndefinedOrNull(fileInput)) {
            if (!ticketSystemService.ValidateFile(fileInput)) {
                //manually making call to adjustSize in order to load scrollbar
                $scope.alerts.push({ msg: "Invalid file attachment (Allowed: .bmp, .gif, .png, .jpg, .jpeg, .doc, .docx, .rtf, .xls, .xlsx, .csv, .zip, .txt, .pdf, .wav, .mp3, .mp4)", type: "danger", languageCode: 'NO_DATA' }); //TODO:VEN: need to translate
                $timeout(function () {
                    ctrl.adjustSize();
                }, 100);
            } else {
                retVal = true;
            }
        }
        return retVal;
    };

    var isUndefinedOrNull = function isUndefinedOrNull(value) {
        return angular.isUndefined(value) || value === null;
    };

    ctrl.uploadFile = function (file) {
        var uploadUrl = host + "/api/uploadTicketAttachment?CustomerId=" + ctrl.accountInfo.customerId + "&TicketId=" + ctrl.ticketId;
        var deffered = $q.defer();
        $timeout(function () {
            attchmentUpload.uploadFileToUrl(file, uploadUrl).then(function (resp) {
                deffered.resolve({ fileName: file.name, fileSize: Math.round(file.size / 1024) }); // resp object to save to database
            });
        }, 3000);
        return deffered.promise;
    };

    ctrl.getAttachmentUrl = function (fileName) {
        return host + "/AttachedFiles/" + ctrl.ticket.ticketId + "/" + fileName;
    };

    ctrl.minutesToTime = function (minutes) {
        var MINUTES_IN_DAY = 60 * 24;
        var retVal = '';

        if (minutes >= MINUTES_IN_DAY) {
            var days = Math.floor(minutes / MINUTES_IN_DAY);
            retVal = days + " " + (days > 1 ? ctrl.translation.text.DAYS : ctrl.translation.text.DAY);

            if (minutes % MINUTES_IN_DAY >= 60) {
                var hours = (minutes % MINUTES_IN_DAY / 60).toFixed(1); //rounding to 1 decimal place
                if (isFinite(hours)) {
                    retVal += " " + hours + " " + (hours > 1 ? ctrl.translation.text.HOURS : ctrl.translation.text.HOUR);
                }
                return retVal;
            } else {
                minutes = minutes % MINUTES_IN_DAY;
                if (isFinite(minutes)) {
                    retVal += " " + minutes + " " + (minutes > 1 ? ctrl.translation.text.MINUTES : ctrl.translation.text.MINUTE);
                }
                return retVal;
            }
        } else if (minutes >= 60) {
            var _hours = Math.floor(minutes / 60);
            if (isFinite(_hours)) {
                retVal = _hours + " " + (_hours > 1 ? ctrl.translation.text.HOURS : ctrl.translation.text.HOUR);
            }
            return retVal + " " + ctrl.minutesToTime(minutes % 60);
        } else {
            return minutes + " " + ctrl.translation.text.MINUTES;
        }
    };

    ctrl.dateAgentText = function (date) {
        var timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        var retVal = datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
        //per PAUL, ticketing system DateTime format is in EST timezone only. DO NOT concerned about customer timezone
        retVal = retVal + " EST";
        return retVal;
    };

    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));

            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            if (!!ctrl.popup.parent().find('.alert').css("height")) {
                //ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - (80 + ctrl.popup.parent().find('.alert').css("height").replace(/[^0-9.]+/g, "")));
                ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 130);
            } else {
                ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 80); //80: total padding
            }
        }
    };

    // *** Following code is related to Problem Category ***** START//

    ctrl.buildProblemCategory = function () {
        ctrl.stuff = ticketSystemService.GetProblemCategories();
    };

    ctrl.onClickShowHideIvhDropdown1 = function (e) {
        var isItemSelected = true;
        if (e.target.classList[0] === "dropDown" && e.target.parentElement.children.length === 2 && e.target.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        }
        if (e.target.classList[0] === "dropDownLabel" && e.target.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        } else if (e.target.classList[0] === "dropDownButton" && e.target.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        } else if (e.target.classList[0] === "dropDownButtonIcon" && e.target.parentElement.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        }
        var selectedItm = getSelectedFormIvhTreeModel1(ctrl.stuff);
        if (isItemSelected) {
            //collapse dropdown
            var ivhTreeViewElement = $element.find(".dropdown-with-ivhTreeView .dropDownContent");
            if (!!ivhTreeViewElement) {
                if (ivhTreeViewElement[0].classList.contains("show")) {
                    ivhTreeViewElement[0].classList.remove("show");
                }
            }
        }
        //console.log(selectedItm);
    };

    $scope.$on("ChildNodeEvent", function (evt, data) {
        selectNode(data.ivhTree, data.ivhNode);
    });

    ctrl.tpl = ['<div class="ivh-treeview-node-content" title="{{::trvw.label(node)}}">', '<span ivh-treeview-toggle>', '<span class="ivh-treeview-twistie-wrapper" ivh-treeview-twistie></span>', '</span>',
    //'<span class="ivh-treeview-node-label" ivh-treeview-toggle>',
    //'{{:: trvw.label(node)}}',
    '<prob-category-node></prob-category-node>',
    //'</span>',
    '<div ivh-treeview-children></div>', '</div>'].join('\n');

    ctrl.arrowDownTpl = '<span class="arrow-down"></span>';

    ctrl.arrowRightTpl = '<span class="arrow-right"></span>';

    var getSelectedFormIvhTreeModel1 = function getSelectedFormIvhTreeModel1(ivhModel) {
        var selectedItems = [];
        angular.forEach(ivhModel, function (value) {
            if (value.selected) {
                selectedItems.push(value.label);
            }
            if (angular.isDefined(value.children) && value.children.length > 0) {
                angular.forEach(getSelectedFormIvhTreeModel1(value.children), function (vle) {
                    selectedItems.push(vle);
                });
            }
        });
        return selectedItems;
    };

    var selectNode = function selectNode(ivhTree, ivhNode) {
        ivhTreeviewMgr.deselectAll(ivhTree);
        ivhTreeviewMgr.select(ivhTree, ivhNode);
        if (ivhNode.id) {
            ctrl.selectedProblemCategory = { id: ivhNode.id, label: getNodeDisplayText(ivhTree, ivhNode) };
        } else {
            ctrl.selectedProblemCategory = { id: 1, label: ctrl.translation.text.NO_CATEGORY_SELECTED };
        }
    };

    var getNodeDisplayText = function getNodeDisplayText(ivhTree, selectedProblemCategory) {
        var displayText = '';
        var done = false;
        ivhTreeviewBfs(ivhTree, function (node, parentsArray) {
            if (done) {
                return false;
            }
            if (node.id === selectedProblemCategory.id) {
                angular.forEach(parentsArray.reverse(), function (parentNode, index) {
                    displayText += parentNode.label + ' > ';
                });
                done = true;
            }
            return !done;
        });

        displayText += selectedProblemCategory.label;
        return displayText;
    };
    // *** END code is related to Problem Category ***** END//
};

TicketSystemEditController.$inject = ['$', '$rootScope', '$scope', '$q', '$sce', '$element', '$timeout', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'deviceMenuService', 'ticketSystemService', 'attchmentUpload', 'datetimeService', 'ivhTreeviewMgr', 'ivhTreeviewBfs', 'unsavedChangesService', '$http'];
"use strict";

angular.module("mc.ticket-system", []);
'use strict';

angular.module('mc.ticket-system').component('ticketSystemEdit', {
    controller: TicketSystemEditController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/ticketsystem/edit/ticket-system-edit.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        //windowTitle: '<',
        classicView: '<',
        ticketId: '<',
        out: '&'
    }
});
'use strict';

mcapp.factory('ticketSystemViewTableService', ['$http', 'datetimeService', 'translationService', 'HOST', function ($http, datetimeService, translationService, host) {
    var ticketSystemViewTableService = function ticketSystemViewTableService() {
        this.items = [];
        this.customerId = null;
        this.userId = 1;
        this.searchString = "";
        this.statusCode = ""; //supports Filter by StatusCode
        this.createdLoginId = null; //supports Filter by CreatedBy LoginId
        this.assignedToLoginId = null; //supports Filter by AssignedTo LoginId
        this.openOrAllTickets = 0; //default: load all open tickets --> 0:open tickets, 1:All tickets, -1: searchByString
        this.startRow = 1;
        this.pageSize = 50;
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.tdWidth = null;
        this.alerts = [];
        this.translation = translationService.translation;
    };

    ticketSystemViewTableService.prototype.Poll = function () {
        this.LoadData(-this.pageSize, true);
    };

    ticketSystemViewTableService.prototype.PreviousPage = function () {
        this.LoadData(-this.pageSize);
    };

    ticketSystemViewTableService.prototype.NextPage = function () {
        this.LoadData(this.pageSize);
    };

    ticketSystemViewTableService.prototype.Reload = function () {
        this.items = [];
        this.alerts = [];
        this.startRow = 1;
        this.LoadData(this.pageSize);
    };

    var getList = function getList(customerId, userId, ticketRetrieveType, searchString, startRow, pageSize, statusCode, createdLoginId, assignedToLoginId) {
        //console.log("Request for StartRow: "+startRow+" PageSize: "+pageSize);
        return $http.get(host + "/api/TicketSystem" + "?customerId=" + customerId + "&userId=" + userId + "&ticketRetrieveType=" + ticketRetrieveType + "&searchString=" + searchString + '&startRow=' + startRow + '&pageSize=' + pageSize + '&statusCode=' + statusCode + '&createdLoginId=' + createdLoginId + '&assignedToLoginId=' + assignedToLoginId);
    };

    ticketSystemViewTableService.prototype.LoadData = function (pageSize, blinkTheLight) {
        if (this.busy) return;
        this.busy = true;

        getList(this.customerId, this.userId, this.openOrAllTickets, this.searchString, this.startRow, this.pageSize, this.statusCode, this.createdLoginId, this.assignedToLoginId).then(function (result) {

            var items = result.data;
            this.numberOfReturnedRecords = items.length;

            this.startRow = this.startRow + items.length;

            //add new records to the beginning or end:
            if (pageSize > 0) {
                this.items = this.items.concat(items);
            }

            this.numberOfRecords = this.items.length;

            //Make toast if next page has no result
            if (this.numberOfReturnedRecords === 0 && pageSize > 0) {
                // If we didn't get any items back AND there aren't already any items
                if (this.items.length === 0) {
                    this.alerts = [];
                    var errorMessage = this.translation.message.NO_DATA;
                    this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this), function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({
                msg: errorMessage, type: "danger"
            });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };

    return ticketSystemViewTableService;
}]);
'use strict';

function TicketSystemViewController($, $rootScope, $scope, $sce, $timeout, $filter, $element, authenticationService, translationService, sharedSetupService, openViewService, ticketSystemService, ticketSystemViewTableService, DistributorCustomerInfoListFactory) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    ctrl.popup = null;
    ctrl.searchString = '';

    //status filter related variables
    ctrl.statusModel = [];
    ctrl.statusData = [];
    ctrl.statusModelLength = null;

    //createdBy filter related variables
    ctrl.createdModel = [];
    ctrl.createdData = [];
    ctrl.createdModelLength = null;

    //assignedTo filter related variables
    ctrl.assignedToModel = [];
    ctrl.assignedToData = [];
    ctrl.assignedToModelLength = null;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        //If this view is opened from distributor's customers list view, load customer id from that view
        ctrl.isFromDistributorCustomerList = DistributorCustomerInfoListFactory.getCustomerIdForTicketView() !== null ? true : false;
        ctrl.customerId = ctrl.isFromDistributorCustomerList ? DistributorCustomerInfoListFactory.getCustomerIdForTicketView() : ctrl.accountInfo.customerId;

        $scope.windowId = ctrl.windowId; //need for
        //$scope.windowTitle = ctrl.windowTitle;//need for
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        $scope.ticketSystemViewTableService = new ticketSystemViewTableService();
        $scope.ticketSystemViewTableService.startRow = 1;
        $scope.ticketSystemViewTableService.pageSize = 50;
        $scope.ticketSystemViewTableService.customerId = ctrl.customerId;
        $scope.alerts = [];

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        }

        //Handle infinite scrolling
        $timeout(function () {
            //find the element of the chart class
            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.element = $element.find('.tabular-data-container');
            } else {
                ctrl.element = $element.find('.tabular-data-container-mobile');
            }

            ctrl.element.on('scroll', function (event) {
                var $rowFirst = ctrl.element.contents().find("tr:first");
                var $rowLast = ctrl.element.contents().find("tr:last");
                var _firstRow = $rowFirst.attr("name");
                if (typeof $rowFirst.position() !== "undefined") {
                    ctrl.infiniteScrollOn = true;
                    ctrl.infiniteScrollUpOn = true;
                    ctrl.infiniteScrollDownOn = true;
                    var _topOffset = $rowFirst.position().top;

                    ctrl.previousScrollbarPosition = ctrl.currentScrollbarPosition;
                    ctrl.currentScrollbarPosition = ctrl.element[0].scrollTop;
                }

                if (ctrl.infiniteScrollOn === true) {
                    ctrl.infiniteScrollUpOn = true;
                    ctrl.infiniteScrollDownOn = true;

                    if (ctrl.infiniteScrollDownOn === true && ctrl.element[0].scrollTop + ctrl.element[0].offsetHeight + 5 > ctrl.element[0].scrollHeight) {
                        $rowLast.addClass("active-row");
                        $scope.ticketSystemViewTableService.alerts = [];
                        $scope.ticketSystemViewTableService.NextPage();
                    }
                    if (ctrl.infiniteScrollUpOn === true && ctrl.element[0].scrollTop < 5 && ctrl.currentScrollbarPosition < ctrl.previousScrollbarPosition) {
                        $rowFirst.addClass("active-row");
                        $scope.ticketSystemViewTableService.alerts = [];
                        $scope.ticketSystemViewTableService.PreviousPage();
                    }
                }

                var rows = ctrl.element.children().children().children().children();
                var scrollpos = 40;
                var start = 0;
                var end = rows.length;
                var count = 0;

                while (start != end) {
                    count++;
                    var mid = start + Math.floor((end - start) / 2);
                    if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
                }
            });

            ctrl.getTicketModel();
        });

        ctrl.openOrAllTickets = "open";
        $scope.ticketSystemViewTableService.Reload();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        //manually making call to adjustSize in order to load scrollbar
        $timeout(function () {
            ctrl.adjustSize();
        }, 500);
    };

    ctrl.ListOpenTickets = function () {
        $scope.ticketSystemViewTableService.openOrAllTickets = 0; //Open tickets only
        $scope.ticketSystemViewTableService.searchString = "";
        resetFiltersAndReload();
    };

    ctrl.ListAllTickets = function () {
        $scope.ticketSystemViewTableService.openOrAllTickets = 1; // All tickets
        $scope.ticketSystemViewTableService.searchString = "";
        resetFiltersAndReload();
    };

    ctrl.Search = function () {
        $scope.ticketSystemViewTableService.openOrAllTickets = 2; // search tickets By String
        $scope.ticketSystemViewTableService.searchString = $scope.ticketSystemViewTableService.searchString.replace("'", "''"); //input.value.replace("'", "''");
        resetFiltersAndReload();
    };

    var resetFiltersAndReload = function resetFiltersAndReload() {
        $scope.ticketSystemViewTableService.statusCode = "";
        ctrl.statusModel = [];
        $scope.ticketSystemViewTableService.createdLoginId = null;
        ctrl.createdModel = [];
        $scope.ticketSystemViewTableService.assignedToLoginId = null;
        ctrl.assignedToModel = [];
        $scope.ticketSystemViewTableService.Reload();
    };

    //Filters related code
    ctrl.getTicketModel = function () {

        ticketSystemService.GetTicketModel(ctrl.customerId).then(function (result) {

            //load statuses NOTE:ntf-mc-filter takes options as id/label pair, hence creating creating new collection with id/label pair
            var tmp = [];
            for (var i = 0; i < result.data.statuses.length; i++) {
                tmp.push({
                    id: result.data.statuses[i].statusCode, label: result.data.statuses[i].description
                });
            }
            ctrl.statusData = tmp;

            //load created users NOTE:ntf-mc-filter takes options as id/label pair, hence creating creating new collection with id/label pair
            tmp = [];
            for (var i = 0; i < result.data.createdUsers.length; i++) {
                tmp.push({
                    id: result.data.createdUsers[i].userId, label: result.data.createdUsers[i].fullName
                });
            }
            ctrl.createdData = tmp;

            //load assignedTo users NOTE:ntf-mc-filter takes options as id/label pair, hence creating creating new collection with id/label pair
            tmp = [];
            for (var i = 0; i < result.data.assignedToUsers.length; i++) {
                tmp.push({
                    id: result.data.assignedToUsers[i].userId, label: result.data.assignedToUsers[i].fullName
                });
            }
            ctrl.assignedToData = tmp;
        });
    };

    ctrl.statusSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.statusEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === $scope.ticketSystemViewTableService.statusCode) {
                $scope.ticketSystemViewTableService.statusCode = "";
                ctrl.statusModel = [];
            } else {
                $scope.ticketSystemViewTableService.statusCode = item.id;
            }
            ctrl.statusModelLength = ctrl.statusModel.length;
            $scope.ticketSystemViewTableService.Reload();
        }
    };

    ctrl.createdSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.createdEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === $scope.ticketSystemViewTableService.createdLoginId) {
                $scope.ticketSystemViewTableService.createdLoginId = null;
                ctrl.createdModel = [];
            } else {
                $scope.ticketSystemViewTableService.createdLoginId = item.id;
            }
            ctrl.createdModelLength = ctrl.createdModel.length;
            $scope.ticketSystemViewTableService.Reload();
        }
    };

    ctrl.assignedToSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.assignedToEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === $scope.ticketSystemViewTableService.assignedToLoginId) {
                $scope.ticketSystemViewTableService.assignedToLoginId = null;
                ctrl.assignedToModel = [];
            } else {
                $scope.ticketSystemViewTableService.assignedToLoginId = item.id;
            }
            ctrl.assignedToModelLength = ctrl.assignedToModel.length;
            $scope.ticketSystemViewTableService.Reload();
        }
    };

    ctrl.getTextWidth = function () {
        switch (ctrl.accountInfo.preferenceUser.i18nCode) {
            case 'es':
            case 'de':
                return '160px';
            case 'zh-cn':
                return '80px';
            case 'en':
            case 'fr':
            case 'pt-br':
            default:
                return '140px';
        }
    };

    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));

            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 143); //143: total padding
        }
    };

    ctrl.minutesToTime = function (minutes) {
        var MINUTES_IN_DAY = 60 * 24;
        var retVal = '';

        if (minutes >= MINUTES_IN_DAY) {
            var days = Math.floor(minutes / MINUTES_IN_DAY);
            retVal = days + " " + (days > 1 ? ctrl.translation.text.DAYS : ctrl.translation.text.DAY);

            if (minutes % MINUTES_IN_DAY >= 60) {
                var hours = (minutes % MINUTES_IN_DAY / 60).toFixed(1); //rounding to 1 decimal place
                if (isFinite(hours)) {
                    retVal += " " + hours + " " + (hours > 1 ? ctrl.translation.text.HOURS : ctrl.translation.text.HOUR);
                }
                return retVal;
            } else {
                minutes = minutes % MINUTES_IN_DAY;
                if (isFinite(minutes)) {
                    retVal += " " + minutes + " " + (minutes > 1 ? ctrl.translation.text.MINUTES : ctrl.translation.text.MINUTE);
                }
                return retVal;
            }
        } else if (minutes >= 60) {
            var _hours = Math.floor(minutes / 60);
            if (isFinite(_hours)) {
                retVal = _hours + " " + (_hours > 1 ? ctrl.translation.text.HOURS : ctrl.translation.text.HOUR);
            }
            return retVal + " " + ctrl.minutesToTime(minutes % 60);
        } else {
            return minutes + " " + ctrl.translation.text.MINUTES;
        }
    };

    ctrl.getSeverityIcon = function (txtSeverity) {
        var IconuUrl = void 0;
        switch (txtSeverity) {
            case "Critical":
                IconuUrl = "fa fa-exclamation-triangle mission-alert-level-4";
                break;
            case "High":
                IconuUrl = "fa fa-exclamation-triangle mission-alert-level-3";
                break;
            case "Medium":
                IconuUrl = "fa fa-exclamation-triangle mission-alert-level-1";
                break;
            case "Low":
                IconuUrl = "fa fa-exclamation-triangle fa-green";
                break;
            default:
                IconuUrl = "fa fa-exclamation-triangle mission-alert-level-1";
                break;
        }

        return IconuUrl;
    };

    var _autoScroll = function _autoScroll() {
        if ($scope.ticketSystemViewTableService.numberOfNewRecordsPrevious > 0) {
            var trRow = ctrl.element.find('tr').eq($scope.ticketSystemViewTableService.numberOfNewRecordsPrevious - 1);
            var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
            ctrl.element.scrollTop(yPosition);
        } else if (ctrl.element[0].scrollTop <= 1) {
            ctrl.element.animate({
                scrollTop: ctrl.element.scrollTop() + 2
            }, 500);
        }
    };

    $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
        _autoScroll();
    });

    ctrl.$onDestroy = function () {
        //Clear distributor factory's customer id
        DistributorCustomerInfoListFactory.setCustomerIdForTicketView(null);
    };
};

TicketSystemViewController.$inject = ['$', '$rootScope', '$scope', '$sce', '$timeout', '$filter', '$element', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'ticketSystemService', 'ticketSystemViewTableService', 'DistributorCustomerInfoListFactory'];
'use strict';

angular.module('mc.ticket-system').component('ticketSystemView', {
    controller: TicketSystemViewController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/ticketsystem/view/ticket-system-view.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        //windowTitle: '<',
        classicView: '<',
        out: '&'
    }
});
'use strict';

mcapp.factory('ticketSystemAdminViewTableService', ['$http', 'datetimeService', 'translationService', 'HOST', function ($http, datetimeService, translationService, host) {
    var ticketSystemAdminViewTableService = function ticketSystemAdminViewTableService() {
        this.items = [];
        this.customerId = null;
        this.userId = 1;
        this.searchString = "";
        this.statusCode = ""; //supports Filter by StatusCode
        this.createdLoginId = null; //supports Filter by CreatedBy LoginId
        this.assignedToLoginId = null; //supports Filter by AssignedTo LoginId
        this.fetchType = 0; //default: load all open tickets -->0:Search string 1:My Open, 2:All Open, 3: All, 4:TechSupport Open, 5: Engineering Open, 6: Production Open
        this.startRow = 1;
        this.pageSize = 50;
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.tdWidth = null;
        this.alerts = [];
        this.translation = translationService.translation;
    };

    ticketSystemAdminViewTableService.prototype.Poll = function () {
        this.LoadData(-this.pageSize, true);
    };

    ticketSystemAdminViewTableService.prototype.PreviousPage = function () {
        this.LoadData(-this.pageSize);
    };

    ticketSystemAdminViewTableService.prototype.NextPage = function () {
        this.LoadData(this.pageSize);
    };

    ticketSystemAdminViewTableService.prototype.Reload = function () {
        this.items = [];
        this.alerts = [];
        this.startRow = 1;
        this.LoadData(this.pageSize);
    };

    var getList = function getList(customerId, userId, fetchType, searchString, startRow, pageSize, statusCode, createdLoginId, assignedToLoginId) {
        //console.log("Request for StartRow: "+startRow+" PageSize: "+pageSize);
        return $http.get(host + "/api/TicketSystemAdminView" + "?customerId=" + customerId + "&userId=" + userId + "&ticketRetrieveType=" + fetchType + "&searchString=" + searchString + '&startRow=' + startRow + '&pageSize=' + pageSize + '&statusCode=' + statusCode + '&createdLoginId=' + createdLoginId + '&assignedToLoginId=' + assignedToLoginId);
    };

    ticketSystemAdminViewTableService.prototype.LoadData = function (pageSize, blinkTheLight) {
        if (this.busy) return;
        this.busy = true;

        getList(this.customerId, this.userId, this.fetchType, this.searchString, this.startRow, this.pageSize, this.statusCode, this.createdLoginId, this.assignedToLoginId).then(function (result) {

            var items = result.data;
            this.numberOfReturnedRecords = items.length;

            this.startRow = this.startRow + items.length;

            //add new records to the beginning or end:
            if (pageSize > 0) {
                this.items = this.items.concat(items);
            }

            this.numberOfRecords = this.items.length;

            //Make toast if next page has no result
            if (this.numberOfReturnedRecords === 0 && pageSize > 0) {
                // If we didn't get any items back AND there aren't already any items
                if (this.items.length === 0) {
                    this.alerts = [];
                    var errorMessage = this.translation.message.NO_DATA;
                    this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this), function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({
                msg: errorMessage, type: "danger"
            });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };

    return ticketSystemAdminViewTableService;
}]);
'use strict';

function TicketSystemAdminViewController($, $rootScope, $scope, $sce, $timeout, $filter, $element, authenticationService, translationService, sharedSetupService, openViewService, ticketSystemAdminService, ticketSystemAdminViewTableService, DistributorCustomerInfoListFactory) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    ctrl.popup = null;
    ctrl.searchString = '';

    //customer filter related variables
    ctrl.customerModel = [];
    ctrl.customerData = [];
    ctrl.customerModelLength = null;

    //status filter related variables
    ctrl.statusModel = [];
    ctrl.statusData = [];
    ctrl.statusModelLength = null;

    //createdBy filter related variables
    ctrl.createdModel = [];
    ctrl.createdData = [];
    ctrl.createdModelLength = null;

    //assignedTo filter related variables
    ctrl.assignedToModel = [];
    ctrl.assignedToData = [];
    ctrl.assignedToModelLength = null;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        //If this view is opened from distributor's customers list view, load customer id from that view
        ctrl.isFromDistributorCustomerList = DistributorCustomerInfoListFactory.getCustomerIdForTicketView() !== null ? true : false;
        ctrl.customerId = ctrl.isFromDistributorCustomerList ? DistributorCustomerInfoListFactory.getCustomerIdForTicketView() : ctrl.accountInfo.customerId;

        $scope.windowId = ctrl.windowId; //need for
        //$scope.windowTitle = ctrl.windowTitle;//need for
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        $scope.ticketSystemAdminViewTableService = new ticketSystemAdminViewTableService();
        $scope.ticketSystemAdminViewTableService.startRow = 1;
        $scope.ticketSystemAdminViewTableService.pageSize = 50;
        $scope.ticketSystemAdminViewTableService.customerId = ctrl.customerId;
        $scope.alerts = [];

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        }

        //Handle infinite scrolling
        $timeout(function () {
            //find the element of the chart class
            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.element = $element.find('.tabular-data-container');
            } else {
                ctrl.element = $element.find('.tabular-data-container-mobile');
            }

            ctrl.element.on('scroll', function (event) {
                var $rowFirst = ctrl.element.contents().find("tr:first");
                var $rowLast = ctrl.element.contents().find("tr:last");
                var _firstRow = $rowFirst.attr("name");
                if (typeof $rowFirst.position() !== "undefined") {
                    ctrl.infiniteScrollOn = true;
                    ctrl.infiniteScrollUpOn = true;
                    ctrl.infiniteScrollDownOn = true;
                    var _topOffset = $rowFirst.position().top;

                    ctrl.previousScrollbarPosition = ctrl.currentScrollbarPosition;
                    ctrl.currentScrollbarPosition = ctrl.element[0].scrollTop;
                }

                if (ctrl.infiniteScrollOn === true) {
                    ctrl.infiniteScrollUpOn = true;
                    ctrl.infiniteScrollDownOn = true;

                    if (ctrl.infiniteScrollDownOn === true && ctrl.element[0].scrollTop + ctrl.element[0].offsetHeight + 5 > ctrl.element[0].scrollHeight) {
                        $rowLast.addClass("active-row");
                        $scope.ticketSystemAdminViewTableService.alerts = [];
                        $scope.ticketSystemAdminViewTableService.NextPage();
                    }
                    if (ctrl.infiniteScrollUpOn === true && ctrl.element[0].scrollTop < 5 && ctrl.currentScrollbarPosition < ctrl.previousScrollbarPosition) {
                        $rowFirst.addClass("active-row");
                        $scope.ticketSystemAdminViewTableService.alerts = [];
                        $scope.ticketSystemAdminViewTableService.PreviousPage();
                    }
                }

                var rows = ctrl.element.children().children().children().children();
                var scrollpos = 40;
                var start = 0;
                var end = rows.length;
                var count = 0;

                while (start != end) {
                    count++;
                    var mid = start + Math.floor((end - start) / 2);
                    if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
                }
            });

            ctrl.getTicketModel();
        });

        ctrl.openOrAllTickets = "open";
        $scope.ticketSystemAdminViewTableService.Reload();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        //manually making call to adjustSize in order to load scrollbar
        $timeout(function () {
            ctrl.adjustSize();
        }, 500);
    };

    ctrl.Load = function () {
        switch (ctrl.searchOptions.selected.id) {
            case 3:
                ctrl.ListAllTickets();
                break;
            default:
                break;
        }
    };

    ctrl.ListOpenTickets = function () {
        $scope.ticketSystemAdminViewTableService.fetchType = 2; //Open tickets only
        $scope.ticketSystemAdminViewTableService.searchString = "";
        resetFiltersAndReload();
    };

    ctrl.ListAllTickets = function () {
        $scope.ticketSystemAdminViewTableService.fetchType = 3; // All tickets
        $scope.ticketSystemAdminViewTableService.searchString = "";
        resetFiltersAndReload();
    };

    ctrl.Search = function () {
        $scope.ticketSystemAdminViewTableService.fetchType = 0; // search tickets By String
        $scope.ticketSystemAdminViewTableService.searchString = $scope.ticketSystemAdminViewTableService.searchString.replace("'", "''"); //input.value.replace("'", "''");
        resetFiltersAndReload();
    };

    var resetFiltersAndReload = function resetFiltersAndReload() {
        //$scope.ticketSystemAdminViewTableService.customerId = "";
        ctrl.customerModel = [];
        //$scope.ticketSystemAdminViewTableService.statusCode = "";
        ctrl.statusModel = [];
        //$scope.ticketSystemAdminViewTableService.createdLoginId = null;
        ctrl.createdModel = [];
        //$scope.ticketSystemAdminViewTableService.assignedToLoginId = null;
        ctrl.assignedToModel = [];
        $scope.ticketSystemAdminViewTableService.Reload();
    };

    ctrl.searchOptions = [{ id: 1, name: 'My Open Tickets' }, { id: 2, name: 'List Open Tickets' }, { id: 3, name: 'List All Tickets' }, { id: 4, name: 'Tech Support Open' }, { id: 5, name: 'Engineering Open' }, { id: 6, name: 'Production Open' }];

    //Filters related code
    ctrl.getTicketModel = function () {

        ticketSystemAdminService.GetTicketModel(ctrl.customerId).then(function (result) {

            //load statuses NOTE:ntf-mc-filter takes options as id/label pair, hence creating creating new collection with id/label pair
            var tmp = [];
            for (var i = 0; i < result.data.statuses.length; i++) {
                tmp.push({
                    id: result.data.statuses[i].statusCode, label: result.data.statuses[i].description
                });
            }
            ctrl.statusData = tmp;

            //load created users NOTE:ntf-mc-filter takes options as id/label pair, hence creating creating new collection with id/label pair
            tmp = [];
            for (var i = 0; i < result.data.createdUsers.length; i++) {
                tmp.push({
                    id: result.data.createdUsers[i].userId, label: result.data.createdUsers[i].fullName
                });
            }
            ctrl.createdData = tmp;

            //load assignedTo users NOTE:ntf-mc-filter takes options as id/label pair, hence creating creating new collection with id/label pair
            tmp = [];
            for (var i = 0; i < result.data.assignedToUsers.length; i++) {
                tmp.push({
                    id: result.data.assignedToUsers[i].userId, label: result.data.assignedToUsers[i].fullName
                });
            }
            ctrl.assignedToData = tmp;
        });
    };

    ctrl.customerSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.customerEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === $scope.ticketSystemAdminViewTableService.customerId) {
                $scope.ticketSystemAdminViewTableService.customerId = undefined;
                ctrl.customerModel = [];
            } else {
                $scope.ticketSystemAdminViewTableService.customerId = item.id;
            }
            ctrl.customerModelLength = ctrl.customerModel.length;
            $scope.ticketSystemAdminViewTableService.Reload();
        }
    };

    ctrl.statusSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.statusEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === $scope.ticketSystemAdminViewTableService.statusCode) {
                $scope.ticketSystemAdminViewTableService.statusCode = "";
                ctrl.statusModel = [];
            } else {
                $scope.ticketSystemAdminViewTableService.statusCode = item.id;
            }
            ctrl.statusModelLength = ctrl.statusModel.length;
            $scope.ticketSystemAdminViewTableService.Reload();
        }
    };

    ctrl.createdSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.createdEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === $scope.ticketSystemAdminViewTableService.createdLoginId) {
                $scope.ticketSystemAdminViewTableService.createdLoginId = null;
                ctrl.createdModel = [];
            } else {
                $scope.ticketSystemAdminViewTableService.createdLoginId = item.id;
            }
            ctrl.createdModelLength = ctrl.createdModel.length;
            $scope.ticketSystemAdminViewTableService.Reload();
        }
    };

    ctrl.assignedToSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.assignedToEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === $scope.ticketSystemAdminViewTableService.assignedToLoginId) {
                $scope.ticketSystemAdminViewTableService.assignedToLoginId = null;
                ctrl.assignedToModel = [];
            } else {
                $scope.ticketSystemAdminViewTableService.assignedToLoginId = item.id;
            }
            ctrl.assignedToModelLength = ctrl.assignedToModel.length;
            $scope.ticketSystemAdminViewTableService.Reload();
        }
    };

    ctrl.getTextWidth = function () {
        switch (ctrl.accountInfo.preferenceUser.i18nCode) {
            case 'es':
            case 'de':
                return '160px';
            case 'zh-cn':
                return '80px';
            case 'en':
            case 'fr':
            case 'pt-br':
            default:
                return '140px';
        }
    };

    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));

            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 143); //143: total padding
        }
    };

    ctrl.minutesToTime = function (minutes) {
        var MINUTES_IN_DAY = 60 * 24;
        var retVal = '';

        if (minutes >= MINUTES_IN_DAY) {
            var days = Math.floor(minutes / MINUTES_IN_DAY);
            retVal = days + " " + (days > 1 ? ctrl.translation.text.DAYS : ctrl.translation.text.DAY);

            if (minutes % MINUTES_IN_DAY >= 60) {
                var hours = (minutes % MINUTES_IN_DAY / 60).toFixed(1); //rounding to 1 decimal place
                if (isFinite(hours)) {
                    retVal += " " + hours + " " + (hours > 1 ? ctrl.translation.text.HOURS : ctrl.translation.text.HOUR);
                }
                return retVal;
            } else {
                minutes = minutes % MINUTES_IN_DAY;
                if (isFinite(minutes)) {
                    retVal += " " + minutes + " " + (minutes > 1 ? ctrl.translation.text.MINUTES : ctrl.translation.text.MINUTE);
                }
                return retVal;
            }
        } else if (minutes >= 60) {
            var _hours = Math.floor(minutes / 60);
            if (isFinite(_hours)) {
                retVal = _hours + " " + (_hours > 1 ? ctrl.translation.text.HOURS : ctrl.translation.text.HOUR);
            }
            return retVal + " " + ctrl.minutesToTime(minutes % 60);
        } else {
            return minutes + " " + ctrl.translation.text.MINUTES;
        }
    };

    ctrl.getSeverityIcon = function (txtSeverity) {
        var IconuUrl = void 0;
        switch (txtSeverity) {
            case "Critical":
                IconuUrl = "fa fa-exclamation-triangle mission-alert-level-4";
                break;
            case "High":
                IconuUrl = "fa fa-exclamation-triangle mission-alert-level-3";
                break;
            case "Medium":
                IconuUrl = "fa fa-exclamation-triangle mission-alert-level-1";
                break;
            case "Low":
                IconuUrl = "fa fa-exclamation-triangle fa-green";
                break;
            default:
                IconuUrl = "fa fa-exclamation-triangle mission-alert-level-1";
                break;
        }

        return IconuUrl;
    };

    var _autoScroll = function _autoScroll() {
        if ($scope.ticketSystemAdminViewTableService.numberOfNewRecordsPrevious > 0) {
            var trRow = ctrl.element.find('tr').eq($scope.ticketSystemAdminViewTableService.numberOfNewRecordsPrevious - 1);
            var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
            ctrl.element.scrollTop(yPosition);
        } else if (ctrl.element[0].scrollTop <= 1) {
            ctrl.element.animate({
                scrollTop: ctrl.element.scrollTop() + 2
            }, 500);
        }
    };

    $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
        _autoScroll();
    });

    ctrl.$onDestroy = function () {
        //Clear distributor factory's customer id
        DistributorCustomerInfoListFactory.setCustomerIdForTicketView(null);
    };
};

TicketSystemAdminViewController.$inject = ['$', '$rootScope', '$scope', '$sce', '$timeout', '$filter', '$element', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'ticketSystemAdminService', 'ticketSystemAdminViewTableService', 'DistributorCustomerInfoListFactory'];
'use strict';

angular.module('mc.ticket-system').component('ticketSystemAdminView', {
    controller: TicketSystemAdminViewController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/ticketsystemadmin/view/ticket-system-admin-view.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        //windowTitle: '<',
        classicView: '<',
        out: '&'
    }
});
'use strict';

function TicketSystemAdminEditController($, $rootScope, $scope, $q, $sce, $element, $timeout, host, authenticationService, translationService, sharedSetupService, openViewService, deviceMenuService, ticketSystemService, ticketSystemAdminService, attchmentUpload, datetimeService, ivhTreeviewMgr, ivhTreeviewBfs, unsavedChangesService, $http) {
    var _this2 = this;

    var ctrl = this;
    //ctrl.UploadDirectory = "\\FS-CLUSTER\TicketFiles\";
    ctrl.deviceList = [];
    ctrl.priorities = [];
    ctrl.fileAttachments = [{ fileName: "", fileSize: 0, success: false }];
    ctrl.ticketModel = {};
    ctrl.chkEmailDSM = false;
    ctrl.chkEmailContact = false;
    ctrl.selectedCoworkers = [];
    ctrl.selectedSendToUsers = [];
    ctrl.loadingAdminEdit = true;
    ctrl.users = [];
    ctrl.sendToUsers = [];
    ctrl.selectedProblemCategory = { id: '', label: '' };
    ctrl.scheduleReminderOn = new Date();
    ctrl.selectUsersTexts = { buttonDefaultText: 'Select Coworkers' };
    ctrl.selectUsersSettings = { smartButtonMaxItems: 4, showCheckAll: false, showUncheckAll: true, styleActive: true, scrollableHeight: '200px', scrollable: true, checkBoxes: false };
    ctrl.isScrolled = false;
    ctrl.element = $element;
    ctrl.jiraAttachments = [];
    //ctrl.selectSendToUsersTexts = { buttonDefaultText: 'Select Send To Users' };
    //ctrl.selectSendToUsersSettings = { smartButtonMaxItems: 4, showCheckAll: false, showUncheckAll: true, styleActive: true, scrollableHeight: '200px', scrollable: true, checkBoxes: false };


    //retrieve ticket edit model
    var modelDeffered = $q.defer();

    var convertToLogins = function convertToLogins(selectedUiBindingUsers) {
        var logins = [];
        angular.forEach(selectedUiBindingUsers, function (coworker, index) {
            logins.push(ctrl.ticketModel.assignedToUsers.find(function (x) {
                return x.userId === coworker.id;
            }));
        });
        return logins;
    };

    var convertToUiBindingUsers = function convertToUiBindingUsers(assignedToUsers) {
        var uiUsers = [];
        angular.forEach(assignedToUsers, function (user, index) {
            uiUsers.push({ id: user.userId, label: user.fullName, customerId: user.customerId });
        });
        return uiUsers;
    };

    //cancel editing ticket
    ctrl.cancelEdit = function () {
        ctrl.viewMode = 0;
        ctrl.out();
    };

    //save the user entries 
    var update = function update(newStatusCode) {
        if (ctrl.ticketModel.selectedTicketIssueType.issueTypeCode !== 'FTRQ') {
            ctrl.jiraAttachments = [];
        }
        var updatedTicket = {
            ticketId: ctrl.ticket.ticketId,
            customerId: ctrl.ticketModel.selectedCustomer.customerId,
            title: ctrl.ticket.title,
            description: !isUndefinedOrNull(ctrl.ticket.description) ? ctrl.ticket.description : "",
            createdByLoginId: ctrl.accountInfo.userId,
            createdBy: ctrl.accountInfo.name,
            AssignedToLoginId: ctrl.ticketModel.selectedAssignedTo.userId,
            AssignedToCustomerId: ctrl.ticketModel.selectedAssignedTo.customerId,
            assignedTo: ctrl.ticketModel.selectedAssignedTo.fullName,
            contactName: !isUndefinedOrNull(ctrl.ticket.contactName) ? ctrl.ticket.contactName.replace("'", "''") : "",
            contactPhone: !isUndefinedOrNull(ctrl.ticket.contactPhone) ? ctrl.ticket.contactPhone.replace("'", "''") : "",
            contactEmail: !isUndefinedOrNull(ctrl.ticket.contactEmail) ? ctrl.ticket.contactEmail.replace("'", "''").replace(";", ",") : "",
            serialNumber: !isUndefinedOrNull(ctrl.selectedDevice) ? !isUndefinedOrNull(ctrl.selectedDevice.serialNumber) ? ctrl.selectedDevice.serialNumber : "" : "",
            severity: ctrl.ticketModel.selectedSeverity.ticketPriorityCode,
            statusCode: ctrl.ticketModel.selectedStatus.statusCode,
            causeTypeCode: ctrl.ticket.causeTypeCode,
            issueTypeCode: ctrl.ticketModel.selectedTicketIssueType.issueTypeCode,
            resolutionTypeCode: ctrl.ticketModel.selectedResolution.resolutionTypeCode,
            attachmentFileName: !isUndefinedOrNull(ctrl.myFile) ? ctrl.myFile.name : "",
            attachmentFileSize: !isUndefinedOrNull(ctrl.myFile) ? Math.round(ctrl.myFile.size / 1024) : 0, //save file size as K bytes
            doEmailContact: ctrl.chkEmailContact,
            doEmailDistributorAndSalesManager: ctrl.chkEmailDSM,
            emailCoworkers: convertToLogins(ctrl.selectedCoworkers),
            problemTypeCode: ctrl.selectedProblemCategory.id == 1 ? null : ctrl.selectedProblemCategory.id,
            reminderText: ctrl.ticket.reminderText,
            sendToUsers: convertToLogins(ctrl.selectedSendToUsers),
            scheduleReminderOn: ctrl.scheduleReminderOn,
            inputAttachmentBase64: ctrl.jiraAttachments
        };

        ticketSystemAdminService.UpdateTicket(ctrl.accountInfo.customerId, updatedTicket).then(function (resp) {
            //now upload the attachments to server
            // loop thru each row and upload to network folder and save to database.

            //create JIRA ticket if ticket issue type is 'New Feature Request'
            if (ctrl.ticketModel.selectedTicketIssueType.issueTypeCode == 'FTRQ' && ctrl.previousIssueTypeCode !== 'FTRQ') {
                ctrl.createJiraTicket(ctrl.accountInfo.customerId, updatedTicket);
            }
            ctrl.out(); //return back to parent view
        });
    };

    ctrl.createJiraTicket = function (customerId, _jiraIssue) {
        return $http.post(host + "/api/ITCMJira?customerId=" + customerId, _jiraIssue);
    };

    var saveAttachmentToDb = function saveAttachmentToDb(obj, idx) {
        ticketSystemService.SaveAttachment(ctrl.accountInfo.customerId, ctrl.ticketId, obj).then(function (resp) {
            ctrl.fileAttachments[idx] = { fileName: "", fileSize: 0, success: true };

            //fetch updated list of attachments
            ticketSystemService.GetTicketAttachments(ctrl.accountInfo.customerId, ctrl.ticketId, true).then(function (result) {
                ctrl.ticketAttachments = result.data;
            });
        });
    };

    var updateErrorAlerts = function updateErrorAlerts(error) {
        $scope.alerts = [];
        $scope.alerts.push({
            msg: "Failed to upload attachment (Error: " + error.data + ")",
            type: "danger",
            languageCode: 'NO_DATA'
        });
        $timeout(function () {
            adjustSize();
        }, 0);
    };

    var isValidAttachment = function isValidAttachment(fileInput) {
        var retVal = false;
        //validate attachment first
        $scope.alerts = [];
        if (!isUndefinedOrNull(fileInput)) {
            if (!ticketSystemService.ValidateFile(fileInput)) {
                //manually making call to adjustSize in order to load scrollbar
                $scope.alerts.push({
                    msg: "Invalid file attachment (Allowed: .bmp, .gif, .png, .jpg, .jpeg, .doc, .docx, .rtf, .xls, .xlsx, .csv, .zip, .txt, .pdf, .wav, .mp3, .mp4)",
                    type: "danger",
                    languageCode: 'NO_DATA'
                }); //TODO:VEN: need to translate
                $timeout(function () {
                    adjustSize();
                }, 100);
            } else {
                retVal = true;
            }
        }
        return retVal;
    };

    var isUndefinedOrNull = function isUndefinedOrNull(value) {
        return angular.isUndefined(value) || value === null;
    };

    var adjustSize = function adjustSize() {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));

            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            if (!!ctrl.popup.parent().find('.alert').css("height")) {
                //ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - (80 + ctrl.popup.parent().find('.alert').css("height").replace(/[^0-9.]+/g, "")));
                ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 130);
            } else {
                ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 80); //80: total padding
            }
        }
    };

    var getSelectedFormIvhTreeModel1 = function getSelectedFormIvhTreeModel1(ivhModel) {
        var selectedItems = [];
        angular.forEach(ivhModel, function (value) {
            if (value.selected) {
                selectedItems.push(value.label);
            }
            if (angular.isDefined(value.children) && value.children.length > 0) {
                angular.forEach(getSelectedFormIvhTreeModel1(value.children), function (vle) {
                    selectedItems.push(vle);
                });
            }
        });
        return selectedItems;
    };

    var selectNode = function selectNode(ivhTree, ivhNode) {
        ivhTreeviewMgr.deselectAll(ivhTree);
        ivhTreeviewMgr.select(ivhTree, ivhNode);
        if (ivhNode.id) {
            ctrl.selectedProblemCategory = { id: ivhNode.id, label: getNodeDisplayText(ivhTree, ivhNode) };
        } else {
            ctrl.selectedProblemCategory = { id: 1, label: ctrl.translation.text.NO_CATEGORY_SELECTED };
        }
    };

    var getNodeDisplayText = function getNodeDisplayText(ivhTree, selectedProblemCategory) {
        var displayText = '';
        var done = false;
        ivhTreeviewBfs(ivhTree, function (node, parentsArray) {
            if (done) {
                return false;
            }
            if (node.id === selectedProblemCategory.id) {
                angular.forEach(parentsArray.reverse(), function (parentNode, index) {
                    displayText += parentNode.label + ' > ';
                });
                done = true;
            }
            return !done;
        });

        displayText += selectedProblemCategory.label;
        return displayText;
    };

    ctrl.setDatePickerBoundaries = function (event) {
        if (event.target.className !== "quickdate-button quickdate-button-range") return;

        ctrl.isScrolled = !ctrl.isScrolled;

        var parentElement = $element.find(".my-date-time-picker");
        // Helper function to get and set parent element's position
        if (!angular.isDefined(parentElement[0])) return;
        var box = parentElement[0].getBoundingClientRect();
        var popupElement = $element.find(".ticket-system-admin-edit-html .quickdate-popup");
        if (angular.isDefined(popupElement)) {
            if (!!popupElement[0]) {
                popupElement[0].style.left = box.left + "px";
                popupElement[0].style.top = box.top - 260 + "px"; //height of popup :260px
            }
        }
    };

    var getTicketEditModel = function getTicketEditModel() {
        ticketSystemAdminService.GetAdminTicketEditModel(ctrl.accountInfo.customerId, ctrl.ticketId).then(function (resp) {
            ctrl.ticketModel = resp.data;
            ctrl.ticket = resp.data.ticket;
            ctrl.ticket.description = "";
            ctrl.ticketEvents = resp.data.events;
            ctrl.ticketAttachments = resp.data.attachments;

            var onlyCustomer = { customerId: ctrl.accountInfo.customerId, name: ctrl.accountInfo.customerName };
            ctrl.ticketModel.customers = [onlyCustomer];
            ctrl.ticketModel.selectedCustomer = onlyCustomer;

            //load contact info
            ctrl.txtContactName = ctrl.ticket.contactName;
            ctrl.txtContactEmail = ctrl.ticket.contactEmail;
            ctrl.txtContactPhone = ctrl.ticket.contactPhone;

            //set problem category
            var ivhTreeNode = ctrl.stuff.find(function (x) {
                return x.id == ctrl.ticket.problemTypeCode;
            });
            if (!!ivhTreeNode) {
                ivhTreeNode.selected = true;
                selectNode(ctrl.stuff, ivhTreeNode);
            }
            //set Resolution
            if (ctrl.ticketModel.resolutionTypes.length > 0) ctrl.ticketModel.selectedResolution = ctrl.ticketModel.resolutionTypes.find(function (x) {
                return x.resolutionTypeCode == ctrl.ticket.resolutionTypeCode;
            });
            //set AssignedTo
            if (!!ctrl.ticketModel.assignedToUsers && ctrl.ticketModel.assignedToUsers.length > 0) {
                ctrl.ticketModel.selectedAssignedTo = ctrl.ticketModel.assignedToUsers.find(function (x) {
                    return x.userId === ctrl.ticket.assignedToLoginId;
                });

                // coworker control needs object with id/label properties
                ctrl.users = convertToUiBindingUsers(ctrl.ticketModel.assignedToUsers);
                // sendTo users control needs object with id/label properties
                //ctrl.sendToUsers = convertToUiBindingUsers(ctrl.ticketModel.assignedToUsers);
            }
            //set Status
            if (ctrl.ticketModel.statuses.length > 0) ctrl.ticketModel.selectedStatus = ctrl.ticketModel.statuses.find(function (x) {
                return x.statusCode == ctrl.ticket.statusCode;
            });
            //set Severity
            if (ctrl.ticketModel.severities.length > 0) ctrl.ticketModel.selectedSeverity = ctrl.ticketModel.severities.find(function (x) {
                return x.ticketPriorityCode === ctrl.ticket.ticketPriorityCode;
            });
            // Remove New Feature Request option if user type is not TechSupport
            if (ctrl.accountInfo.userType !== "TechSupport") {
                var index = ctrl.ticketModel.ticketIssueTypes.findIndex(function (obj) {
                    return obj.issueTypeCode === "FTRQ";
                });
                ctrl.ticketModel.ticketIssueTypes.splice(index, 1);
            }
            //set Ticket Issue Type
            if (ctrl.ticketModel.ticketIssueTypes.length > 0) {
                ctrl.ticketModel.selectedTicketIssueType = ctrl.ticketModel.ticketIssueTypes.find(function (x) {
                    return x.issueTypeCode === ctrl.ticket.issueTypeCode;
                });
                ctrl.previousIssueTypeCode = angular.copy(ctrl.ticket.issueTypeCode);
            }
            //load and set device
            ctrl.getAndSetDevices();
            //set problem category
            var ivhNodeSelected = { id: ctrl.ticket.problemTypeCode, label: ctrl.ticket.problemDescription, selected: true };
            selectNode(ctrl.stuff, ivhNodeSelected);

            modelDeffered.resolve();
        });

        return modelDeffered.promise;
    };

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.buildProblemCategory();
        ctrl.filename = "Please Choose a file";

        $scope.windowId = ctrl.windowId; //need for
        //$scope.windowTitle = ctrl.windowTitle;//need for

        //ctrl.getAndSetDevices();
        getTicketEditModel();

        ctrl.viewMode = 2; //0:view, 1:create, 2:edit

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    adjustSize();
                }
            });

            //Check for unsaved Changes
            $(ctrl.popup).on('dialogbeforeclose', function (event) {
                if (ctrl.viewMode !== 0) {
                    unsavedChangesService.checkUnsavedChanges(event, ctrl.popup, _this2, true);
                }
            });
        }

        ctrl.timeFormatTimePicker = ctrl.getTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);

        //manually making call to adjustSize in order to load scrollbar
        $timeout(function () {
            adjustSize();
            ctrl.element = $element.find(".ticket-system-admin-edit-html")[0];
        }, 500);
    };

    ctrl.status = {
        //default - all the collapsible panels are open and enabled
        isFirstOpen: true,
        isFirstDisabled: false,
        isSecondOpen: true,
        isSecondDisabled: false,
        isThirdOpen: true,
        isThirdDisabled: false,
        isForthOpen: true,
        isForthDisabled: false,
        isFifthOpen: true,
        isFifthDisabled: false

        //close the ticket 
    };ctrl.submit = function () {
        if (ctrl.updating) return;
        ctrl.updating = true;
        ctrl.viewMode = 0;
        update("ASND"); //status is set to ASND
    };

    //close the ticket 
    //ctrl.close = () => {
    //    update("CLSD"); //status is set to CLSD
    //};

    //retrieve list of devices to load
    ctrl.getAndSetDevices = function () {
        if (ctrl.ticketModel.selectedCustomer == undefined) return;
        ctrl.loadingAdminEdit = true;
        ticketSystemAdminService.GetDeviceList(ctrl.accountInfo.customerId, ctrl.ticketModel.selectedCustomer.customerId).then(function (result) {
            $timeout(function () {
                ctrl.deviceList = result.data.devices;
                if (ctrl.deviceList.length > 0) ctrl.selectedDevice = ctrl.deviceList.find(function (x) {
                    return x.serialNumber == ctrl.ticket.serialNumber;
                });
                ctrl.loadingAdminEdit = false;
            }, 0);
        }, function (result) {
            ctrl.loadingAdminEdit = false;
        });
    };

    ctrl.addAttachment = function () {
        ctrl.fileAttachments.push({ fileName: "", fileSize: 0, success: false });
    };

    ctrl.removeAttachment = function (index) {
        ctrl.fileAttachments.splice(index, 1);
    };

    //ctrl.uploadAttachments = () => {
    //    // loop thru each row 
    //    // first, upload file to network folder 
    //    // second, save details to database.
    //    $scope.alerts = [];
    //    angular.forEach(ctrl.fileAttachments, function (attachment, idx) {
    //        if (attachment.name == null || attachment.name === "") return;
    //        //isValidAttachment(attachment);
    //        var uploadUrl = `${host}/api/uploadTicketAttachment?CustomerId=` + ctrl.accountInfo.customerId + "&TicketId=" + ctrl.ticketId;
    //        attchmentUpload.uploadFileToUrl(attachment, uploadUrl, saveAttachmentToDb, updateErrorAlerts);

    //    });

    //}

    ctrl.uploadAttachment = function (attachment, idx) {
        $scope.alerts = [];
        if (attachment.name == null || attachment.name === "") return;
        if (isValidAttachment(attachment)) {
            var uploadUrl = host + '/api/uploadTicketAttachment?CustomerId=' + ctrl.accountInfo.customerId + "&TicketId=" + ctrl.ticketId;
            attchmentUpload.uploadFileToUrl(attachment, uploadUrl, idx, saveAttachmentToDb, updateErrorAlerts);
            ctrl.createJiraAttachment(attachment);
        }
    };

    ctrl.createJiraAttachment = function (attachment) {
        var reader = new FileReader();
        reader.readAsDataURL(attachment);
        reader.onload = function () {
            ctrl.base64result = reader.result.split(',')[1];
            ctrl.jiraAttachments.push(ctrl.base64result);
        };
    };

    //ctrl.uploadFile = (file) => {
    //    var uploadUrl = `${host}/api/uploadTicketAttachment?CustomerId=` + ctrl.accountInfo.customerId + "&TicketId=" + ctrl.ticketId;
    //    const deffered = $q.defer();
    //    $timeout(function () {
    //        attchmentUpload.uploadFileToUrl(file, uploadUrl).then((resp) => {
    //            deffered.resolve({ fileName: file.name, fileSize: Math.round(file.size / 1024) }); // resp object to save to database
    //        });
    //    }, 3000);
    //    return deffered.promise;
    //};

    ctrl.getAttachmentUrl = function (fileName) {
        return host + '/AttachedFiles/' + ctrl.ticket.ticketId + '/' + fileName;
    };

    ctrl.minutesToTime = function (minutes) {
        var MINUTES_IN_DAY = 60 * 24;
        var retVal = '';

        if (minutes >= MINUTES_IN_DAY) {
            var days = Math.floor(minutes / MINUTES_IN_DAY);
            retVal = days + " " + (days > 1 ? ctrl.translation.text.DAYS : ctrl.translation.text.DAY);

            if (minutes % MINUTES_IN_DAY >= 60) {
                var hours = (minutes % MINUTES_IN_DAY / 60).toFixed(1); //rounding to 1 decimal place
                if (isFinite(hours)) {
                    retVal += " " + hours + " " + (hours > 1 ? ctrl.translation.text.HOURS : ctrl.translation.text.HOUR);
                }
                return retVal;
            } else {
                minutes = minutes % MINUTES_IN_DAY;
                if (isFinite(minutes)) {
                    retVal += " " + minutes + " " + (minutes > 1 ? ctrl.translation.text.MINUTES : ctrl.translation.text.MINUTE);
                }
                return retVal;
            }
        } else if (minutes >= 60) {
            var _hours = Math.floor(minutes / 60);
            if (isFinite(_hours)) {
                retVal = _hours + " " + (_hours > 1 ? ctrl.translation.text.HOURS : ctrl.translation.text.HOUR);
            }
            return retVal + " " + ctrl.minutesToTime(minutes % 60);
        } else {
            return minutes + " " + ctrl.translation.text.MINUTES;
        }
    };

    ctrl.dateAgentText = function (date) {
        var timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        var retVal = datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
        //per PAUL, ticketing system DateTime format is in EST timezone only. DO NOT concerned about customer timezone
        retVal = retVal + " EST";
        return retVal;
    };

    ctrl.getTimeFormat = function (timeFormat) {
        return timeFormat == 1 ? "h:mm a" : "H:mm";
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormatTimePicker = false;
        $timeout(function () {
            ctrl.timeFormatTimePicker = ctrl.getTimeFormat(timeFormat);
        }, 1000);
    });

    ctrl.dateFilter = function () {
        return true;
    };

    ctrl.buildProblemCategory = function () {
        ctrl.stuff = ticketSystemService.GetProblemCategories();
    };

    ctrl.onClickShowHideIvhDropdown1 = function (e) {
        var isItemSelected = true;
        if (e.target.classList[0] === "dropDown" && e.target.parentElement.children.length === 2 && e.target.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        }
        if (e.target.classList[0] === "dropDownLabel" && e.target.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        } else if (e.target.classList[0] === "dropDownButton" && e.target.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        } else if (e.target.classList[0] === "dropDownButtonIcon" && e.target.parentElement.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        }
        var selectedItm = getSelectedFormIvhTreeModel1(ctrl.stuff);
        if (isItemSelected) {
            //collapse dropdown
            var ivhTreeViewElement = $element.find(".dropdown-with-ivhTreeView .dropDownContent");
            if (!!ivhTreeViewElement) {
                if (ivhTreeViewElement[0].classList.contains("show")) {
                    ivhTreeViewElement[0].classList.remove("show");
                }
            }
        }
        //console.log(selectedItm);
    };

    $scope.$on("ChildNodeEvent", function (evt, data) {
        selectNode(data.ivhTree, data.ivhNode);
    });

    ctrl.tpl = ['<div class="ivh-treeview-node-content" title="{{::trvw.label(node)}}">', '<span ivh-treeview-toggle>', '<span class="ivh-treeview-twistie-wrapper" ivh-treeview-twistie></span>', '</span>',
    //'<span class="ivh-treeview-node-label" ivh-treeview-toggle>',
    //'{{:: trvw.label(node)}}',
    '<prob-category-node></prob-category-node>',
    //'</span>',
    '<div ivh-treeview-children></div>', '</div>'].join('\n');

    ctrl.arrowDownTpl = '<span class="arrow-down"></span>';

    ctrl.arrowRightTpl = '<span class="arrow-right"></span>';

    // in order to handle scroll (either by mousewheel or arrow keys) -- following two functions are created for date-picker
    ctrl.element.on("mousewheel", function () {
        $timeout(function () {
            ctrl.isScrolled = !ctrl.isScrolled;
        }, 0);
    });
    ctrl.onKeyDown = function ($event) {
        // arrowUp or arrowDown keys
        if ($event.keyCode === 38 || $event.keyCode === 40) {
            $timeout(function () {
                ctrl.isScrolled = !ctrl.isScrolled;
            }, 0);
        }
    };
};

TicketSystemAdminEditController.$inject = ['$', '$rootScope', '$scope', '$q', '$sce', '$element', '$timeout', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'deviceMenuService', 'ticketSystemService', 'ticketSystemAdminService', 'attchmentUpload', 'datetimeService', 'ivhTreeviewMgr', 'ivhTreeviewBfs', 'unsavedChangesService', '$http'];
'use strict';

angular.module('mc.ticket-system').component('ticketSystemAdminEdit', {
    controller: TicketSystemAdminEditController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/ticketsystem/adminedit/ticket-system-admin-edit.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        //windowTitle: '<',
        classicView: '<',
        ticketId: '<',
        out: '&'
    }
});
'use strict';

function TWOverviewController(_, $scope, $rootScope, $location, $q, $sce, $timeout, authenticationService, openViewService, sharedSetupService, tankAndWellService, translationService, websocketService, toaster, $cookies, wizardSplashService) {
    var _this2 = this;

    var windowTitle = this.windowTitle;
    var ctrl = this;
    ctrl.windowId = "Tank And Well Overview";
    //sharedSetupService.getWindowId(ctrl);
    ctrl.readOnlyTW = false;
    ctrl.isMcAdmin = $cookies.get('AdminInfo') != null ? true : false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    if (ctrl.accountInfo.userRole !== 'Administrator' && ctrl.accountInfo.userRole !== 'SuperAdministrator') {
        ctrl.readOnlyTW = true;
    }
    ctrl.getTooltipTitleArr = [];

    //// --> need windowId for Wiki/Help for the Classic View
    sharedSetupService.getWindowId(ctrl);

    $scope.sortableOptions = {
        handle: ".sort-yes",
        items: "li:not(.not-sortable)",
        update: function update(e, ui) {
            $scope.oldIndex = [];
            for (var i = 0; i < ctrl.devices.length; ++i) {
                $scope.oldIndex.push({ wsDeviceId: ctrl.devices[i].wsDeviceId, customerDisplayOrder: i });
            }
            $scope.updateHappened = true;
        },
        stop: function stop(e, ui) {
            if (!$scope.updateHappened) return false;
            var objToUpdate = [];
            for (var index in ctrl.devices) {
                objToUpdate.push({ wsDeviceId: ctrl.devices[index].wsDeviceId, customerDisplayOrder: Number(index) });
            }
            tankAndWellService.UpdateDisplayOrder(objToUpdate);
            $scope.updateHappened = false;
        }
    };

    ctrl.getTooltip = function (section, i) {
        if (!angular.isDefined(ctrl.devices[i])) return false;
        if (!angular.isDefined(ctrl.devices[i].basicInfo)) return false;
        $('#overview-tankandwell-' + section + '-' + i).tooltip({
            items: 'span',
            position: { my: 'left+15 center top', at: 'center bottom', collision: "flip" },
            tooltipClass: 'panel panel-default overview-tooltipborder ov-tw-size',
            content: '<div>' + _this2.translation.text.LOADING + '...</div>'
        }).tooltip('open');

        $('#overview-tankandwell-' + section + '-' + i).tooltip({
            content: ctrl.getKeyValue(section, ctrl.devices[i])
        });
    };

    ctrl.destroyTooltip = function (section, i) {
        $('#overview-tankandwell-' + section + '-' + i).tooltip('close');
        $('#overview-tankandwell-' + section + '-' + i).tooltip('destroy');
    };

    ctrl.getKeyValue = function (section, obj) {

        var tmpHtml = "<div style='width: 100%;'>";

        switch (section) {
            case 0:
                tmpHtml += '<div style=\'font-weight: bold; text-align: center; color: #157fcc; text-decoration: underline; padding-bottom: 5px;\'>' + 'Tank And Well Basic' + '</div>';

                for (var key in obj.basicInfo.tankAndWellBasic) {
                    if (obj.basicInfo.tankAndWellBasic.hasOwnProperty(key)) {
                        if (key === "labelSource") continue;
                        tmpHtml += '<div style=\'font-weight: normal; text-align: left; width: 60%; float: left;\'>' + key + ': </div>';
                        tmpHtml += '<div style=\'font-weight: bold; text-align: left; width: 38%; float: right;\'>' + obj.basicInfo.tankAndWellBasic[key] + '</div>';
                        tmpHtml += '<div style=\'clear: both;\'></div>';
                    }
                }
                break;
            case 1:
                tmpHtml += '<div style=\'font-weight: bold; text-align: center; color: #157fcc; text-decoration: underline; padding-bottom: 5px;\'>' + 'Tank And Well Labels' + '</div>';

                for (var key2 in obj.basicInfo.tankAndWellLabels) {
                    if (obj.basicInfo.tankAndWellLabels.hasOwnProperty(key2)) {
                        if (key2 === "wsDeviceId") continue;
                        tmpHtml += '<div style=\'font-weight: normal; text-align: left; width: 50%; float: left;\'>' + key2 + ': </div>';
                        tmpHtml += '<div style=\'font-weight: bold; text-align: left; width: 48%; float: right;\'>' + obj.basicInfo.tankAndWellLabels[key2] + '</div>';
                        tmpHtml += '<div style=\'clear: both;\'></div>';
                    }
                }
                break;

            case 2:
                tmpHtml += '<div style=\'font-weight: bold; text-align: center; color: #157fcc; text-decoration: underline; padding-bottom: 5px;\'>' + 'Placeholder' + '</div>';

                tmpHtml += '<div style=\'font-weight: normal; text-align: left; width: 50%; float: left;\'>' + 'Label' + ':  </div>';
                tmpHtml += '<div style=\'font-weight: bold; text-align: left; width: 48%; float: right;\'>' + 'Value' + '</div>';
                tmpHtml += '<div style=\'clear: both;\'></div>';
                break;
        }

        tmpHtml += "</div>";
        return tmpHtml;
    };

    var initializeDevices = function initializeDevices(i) {
        var basicPromise = $q.defer();
        tankAndWellService.GetBasicInfo(_this2.devices[i].wsDeviceId, _this2.accountInfo.customerId).then(function (resp) {
            basicPromise.resolve();
            _this2.devices[i].basicInfo = resp.data;
            _this2.devices[i].source = { label: '', deviceName: '' };
            _this2.devices[i].source.label = resp.data.tankAndWellLabels.labelSource ? resp.data.tankAndWellLabels.labelSource : resp.data.analogSetting ? resp.data.analogSetting.name : '';
            _this2.devices[i].source.deviceName = resp.data.sourceDevice.name;
            _this2.devices[i].destPumpArray = [];

            for (var j = 1; j <= 5; j++) {
                var destPumpDevId = resp.data.tankAndWellBasic['destPump' + j + 'DeviceId'];
                if (destPumpDevId !== 0) {
                    _this2.devices[i].destPumpArray.push({
                        wsDeviceId: _this2.devices[i].wsDeviceId,
                        deviceId: destPumpDevId,
                        deviceSerialNumber: getDeviceSerialNumber(i, destPumpDevId),
                        deviceName: resp.data.pumpsDetail[j - 1].deviceName,
                        pumpId: j,
                        position: getPumpCurrentPosition(resp.data.tankAndWellBasic, j),
                        positionIdx: getPumpPositionIndex(resp.data.tankAndWellBasic, j),
                        mode: resp.data.tankAndWellBasic['destPump' + j + 'Mode'],
                        polarity: resp.data.tankAndWellBasic['destPump' + j + 'Polarity'],
                        channel: resp.data.tankAndWellBasic['destPump' + j + 'Relay'],
                        pLbl: resp.data.tankAndWellLabels['labelPump' + j],
                        label: getPumpLabel(resp.data.tankAndWellLabels['labelPump' + j], resp.data.pumpsDetail[j - 1].description),
                        loading: true
                    });

                    getPumpData(_this2.accountInfo.customerId, destPumpDevId, resp.data.tankAndWellBasic['destPump' + j + 'Relay'], i, j - 1, _this2.accountInfo.timeZone);
                }
            }
        });

        _this2.devices[i].tankLoading = true;
        var tankPromise = $q.defer();
        tankAndWellService.GetGroundTankData(_this2.devices[i].wsDeviceId, _this2.accountInfo.timeZone, _this2.accountInfo.customerId).then(function (resp) {
            tankPromise.resolve();
            $timeout(function () {
                _this2.devices[i].tankLoading = false;
            });

            _this2.devices[i].tank = resp.data;
            if (resp.data.alternateSource) {
                _this2.devices[i].alternateSource = { label: '', deviceName: '' };
                _this2.devices[i].alternateSource.label = resp.data.alternateSource.labelSource ? resp.data.alternateSource.labelSource : resp.data.alternateSource.channelName;
                _this2.devices[i].alternateSource.deviceName = resp.data.alternateSource.deviceName;
            }

            $timeout(function () {
                drawGroundTank(_this2.devices[i], resp.data);
            });
        });

        $q.all([basicPromise.promise, tankPromise.promise]).then(function () {
            var wsIdforWebS = 'TW' + Array(8 - ('' + _this2.devices[i].wsDeviceId).length + 1).join('0') + _this2.devices[i].wsDeviceId;
            websocketService.connect();
            //websocketService.register('RELAYS', this.devices[i].basicInfo.sourceDevice.serialNumber, '', wsDataReceivedTWP, null);
            websocketService.register('ALTERNATOR', wsIdforWebS, '', wsDataReceivedAlternator, null);
            websocketService.register('ANALOG', _this2.devices[i].basicInfo.sourceDevice.serialNumber, _this2.devices[i].tank.sourceChannel, wsDataReceivedGT, null);
            websocketService.register('ANALOG_G2', _this2.devices[i].basicInfo.sourceDevice.serialNumber, _this2.devices[i].tank.sourceChannel, wsDataReceivedGT, null);

            //registering for relays of each device based on Device Serial Number
            var previousSerialNumber = void 0;
            for (var k = 0; k < _this2.devices[i].destPumpArray.length; k++) {
                if (_this2.devices[i].destPumpArray[k].deviceSerialNumber === previousSerialNumber) continue;
                websocketService.register('DIGITALOUTPUT', _this2.devices[i].destPumpArray[k].deviceSerialNumber, '', wsDataReceivedTWP, null);
                //console.log('Registered for Relay of Device SN:'+this.devices[i].destPumpArray[k].deviceSerialNumber);
                previousSerialNumber = _this2.devices[i].destPumpArray[k].deviceSerialNumber;
            }
        });
    };

    var getPumpDeviceName = function getPumpDeviceName(devIdx, deviceId) {
        for (var i = 0; i < _this2.devices[devIdx].basicInfo.pumpsDetail.length; i++) {
            if (_this2.devices[devIdx].basicInfo.pumpsDetail[i].deviceId == deviceId) return _this2.devices[devIdx].basicInfo.pumpsDetail[i].deviceName;
        }
    };

    var getDeviceSerialNumber = function getDeviceSerialNumber(devIdx, deviceId) {
        for (var i = 0; i < _this2.devices[devIdx].basicInfo.pumpsDetail.length; i++) {
            if (_this2.devices[devIdx].basicInfo.pumpsDetail[i].deviceId == deviceId) return _this2.devices[devIdx].basicInfo.pumpsDetail[i].deviceSerialNumber;
        }
    };

    //set upper and lower limits for tank and well overview
    function checkBarLevel(tank) {
        var value = void 0;
        var tenPercentDiff = (tank.tankYellowAbove - tank.tankRedBelow) / 0.9 - (tank.tankYellowAbove - tank.tankRedBelow);
        var upperLimit = tank.tankYellowAbove + tenPercentDiff;
        var lowerLimit = tank.tankRedBelow - tenPercentDiff;

        if (tank.currentReading < lowerLimit) {
            value = lowerLimit;
        } else if (tank.currentReading > upperLimit) {
            value = upperLimit;
        } else {
            value = tank.currentReading;
        }
        return {
            value: value,
            upperLimit: upperLimit,
            lowerLimit: lowerLimit
        };
    }

    function drawGroundTank(device, tank) {
        var result = checkBarLevel(tank);

        device.fuelWidget = new FusionCharts({
            type: 'hlineargauge',
            renderAt: 'tank-list-chart-' + device.wsDeviceId,
            width: '100%',
            height: 30,
            dataFormat: 'json',
            dataSource: {
                'chart': {
                    'theme': 'fint',
                    'lowerLimit': result.lowerLimit,
                    'upperLimit': result.upperLimit,
                    'numberSuffix': ' ' + tank.unit,
                    'chartTopMargin': '5',
                    'chartBottomMargin': '5',
                    'valueFontSize': '11',
                    'valueFontBold': '0',
                    'manageresize': 1,
                    'showhovereffect': '0',
                    'showTickValues': '0',
                    'showTickMarks': '0',
                    'showValue': '0',
                    'pointerOnTop': '0',
                    'showTooltip': '0',
                    'canvasBgAlpha': '0',
                    'bgAlpha': 0
                },
                'colorRange': {
                    'color': [{
                        'minValue': result.lowerLimit,
                        'maxValue': tank.tankRedBelow,
                        'code': '#FF8472'
                    }, {
                        'minValue': tank.tankRedBelow,
                        'maxValue': tank.tankYellowAbove,
                        'code': '#5fa4ce' //'#A2C833'
                    }, {
                        'minValue': tank.tankYellowAbove,
                        'maxValue': result.upperLimit,
                        'code': '#F8CA3F'
                    }]
                },
                'pointers': {
                    'pointer': [{
                        'value': result.value,
                        'sides': '2',
                        'radius': '6'
                    }]
                }
            }
        }).render();

        device.fuelWidget.setTransparent(true);

        if (tank.alternateSource) {
            device.fuelWidgetAlt = new FusionCharts({
                type: 'hlineargauge',
                renderAt: 'tank-list-chart-alt' + device.wsDeviceId,
                width: '100%',
                height: 30,
                dataFormat: 'json',
                dataSource: {
                    'chart': {
                        'theme': 'fint',
                        'lowerLimit': result.lowerLimit,
                        'upperLimit': result.upperLimit,
                        'numberSuffix': ' ' + tank.unit,
                        'chartTopMargin': '5',
                        'chartBottomMargin': '5',
                        'valueFontSize': '11',
                        'valueFontBold': '0',
                        'manageresize': 1,
                        'showhovereffect': '0',
                        'showTickValues': '0',
                        'showTickMarks': '0',
                        'showValue': '0',
                        'pointerOnTop': '0',
                        'showTooltip': '0',
                        'canvasBgAlpha': '0',
                        'bgAlpha': 0
                    },
                    'colorRange': {
                        'color': [{
                            'minValue': result.lowerLimit,
                            'maxValue': tank.tankRedBelow,
                            'code': '#FF8472'
                        }, {
                            'minValue': tank.tankRedBelow,
                            'maxValue': tank.tankYellowAbove,
                            'code': '#868e96'
                        }, {
                            'minValue': tank.tankYellowAbove,
                            'maxValue': result.upperLimit,
                            'code': '#F8CA3F'
                        }]
                    },
                    'pointers': {
                        'pointer': [{
                            'value': result.value,
                            'sides': '2',
                            'radius': '6'
                        }]
                    }
                }
            }).render();
        }

        $('#tank-and-well-overview').find('svg[id^=\'raphael-paper\']').css('background-color', 'rgb(255, 255, 255, 0)');
    }

    //const getWaterColor = (tank) => {
    //    if (tank.currentReading <= tank.tankRedBelow) {
    //        return '#ff0000';
    //    } else if (tank.currentReading >= tank.tankYellowAbove) {
    //        return '#ffff00';
    //    } else {
    //        return '#5fa4ce';  //'#008ee4';
    //    }
    //};

    var getPumpCurrentPosition = function getPumpCurrentPosition(basic, pumpId) {
        if (parseInt(basic.currentLeadPump, 10) === parseInt(pumpId, 10)) {
            return _this2.translation.text.LEAD;
        } else if (parseInt(basic.currentLagPump, 10) === parseInt(pumpId, 10)) {
            return _this2.translation.text.LAG;
        } else if (parseInt(basic.currentLag2Pump, 10) === parseInt(pumpId, 10)) {
            return _this2.translation.text.LAG + '2';
        } else if (parseInt(basic.currentLag3Pump, 10) === parseInt(pumpId, 10)) {
            return _this2.translation.text.LAG + '3';
        } else if (parseInt(basic.currentLag4Pump, 10) === parseInt(pumpId, 10)) {
            return _this2.translation.text.LAG + '4';
        }
    };

    var getPumpPositionIndex = function getPumpPositionIndex(basic, pumpId) {
        if (parseInt(basic.currentLeadPump, 10) === parseInt(pumpId, 10)) {
            return 0;
        } else if (parseInt(basic.currentLagPump, 10) === parseInt(pumpId, 10)) {
            return 1;
        } else if (parseInt(basic.currentLag2Pump, 10) === parseInt(pumpId, 10)) {
            return 2;
        } else if (parseInt(basic.currentLag3Pump, 10) === parseInt(pumpId, 10)) {
            return 3;
        } else if (parseInt(basic.currentLag4Pump, 10) === parseInt(pumpId, 10)) {
            return 4;
        }
    };

    var getPumpLabel = function getPumpLabel(label, pumpDescription) {
        return label ? label : pumpDescription;
    }; // `${getPumpDeviceName(devIdx, destPumpDevId)} ${this.translation.text.PUMP} ${channel}`;


    var convertStatus = function convertStatus(statusCode, pumpName, wsdeviceid) {
        var statusMsg = null;
        switch (parseInt(statusCode, 10)) {
            default:
            case 0:
                //open
                if (pumpName.toLowerCase().indexOf('valve') >= 0 && parseInt(wsdeviceid, 10) === 94) {
                    statusMsg = { statusColor: 'rgb(162, 200, 53)', statusMessage: _this2.translation.text.STOPPED };
                } else {
                    statusMsg = { statusColor: '#404040', statusMessage: _this2.translation.text.STOPPED };
                }

                break;
            case 1:
                //close
                if (pumpName.toLowerCase().indexOf('valve') >= 0 && parseInt(wsdeviceid, 10) === 94) {
                    statusMsg = { statusColor: '#404040', statusMessage: _this2.translation.text.RUNNING };
                } else {
                    statusMsg = { statusColor: 'rgb(162, 200, 53)', statusMessage: _this2.translation.text.RUNNING };
                }

                break;
            case null: //fault
            case '':
                statusMessage = { statusColor: 'red', statusMessage: _this2.translation.text.FAULT };

                break;
        }

        return statusMsg;
    };

    var updateValue = function updateValue(relay, polarity) {
        return relay ? relay ^ polarity : '';
    };

    var getPumpData = function getPumpData(customerId, deviceId, channel, deviceIdx, pumpIdx, timeZone) {
        tankAndWellService.GetPumpData(customerId, deviceId, channel, timeZone).then(function (resp) {
            _this2.devices[deviceIdx].destPumpArray[pumpIdx].loading = false;
            _this2.devices[deviceIdx].destPumpArray[pumpIdx].relayReading = updateValue(resp.data.relayData.latestReading, _this2.devices[deviceIdx].destPumpArray[pumpIdx].polarity);

            var _convertStatus = convertStatus(_this2.devices[deviceIdx].destPumpArray[pumpIdx].relayReading, _this2.devices[deviceIdx].destPumpArray[pumpIdx].label, _this2.devices[deviceIdx].wsDeviceId),
                statusColor = _convertStatus.statusColor,
                statusMessage = _convertStatus.statusMessage;

            _this2.devices[deviceIdx].destPumpArray[pumpIdx].color = statusColor;
            _this2.devices[deviceIdx].destPumpArray[pumpIdx].status = statusMessage;
        });
    };

    var wsDataReceivedGT = function wsDataReceivedGT(data) {
        for (var i = 0; i < _this2.devices.length; i++) {
            if (_this2.devices[i].tank.sourceChannel === parseInt(data.CH, 10) && _this2.devices[i].basicInfo.sourceDevice.serialNumber === data.SN) {
                _this2.devices[i].tank.currentReading = data.Value;
                var result = checkBarLevel(_this2.devices[i].tank);
                _this2.devices[i].fuelWidget.feedData('&value=' + result.value);
            }
        }
    };

    var wsDataReceivedTWP = function wsDataReceivedTWP(data) {
        var channel = parseInt(data.CH);
        var chValue = data.Value;
        for (var i = 0; i < _this2.devices.length; i++) {
            for (var j = 0; j < _this2.devices[i].destPumpArray.length; j++) {
                if (_this2.devices[i].destPumpArray[j].deviceSerialNumber === data.SN && _this2.devices[i].destPumpArray[j].channel === channel && data.Value) {

                    if (chValue !== _this2.devices[i].destPumpArray[j].relayReading) {
                        _this2.devices[i].destPumpArray[j].relayReading = updateValue(chValue, _this2.devices[i].destPumpArray[j].polarity);

                        var _convertStatus2 = convertStatus(_this2.devices[i].destPumpArray[j].relayReading, _this2.devices[i].destPumpArray[j].label, _this2.devices[i].wsDeviceId),
                            statusColor = _convertStatus2.statusColor,
                            _statusMessage = _convertStatus2.statusMessage;

                        _this2.devices[i].destPumpArray[j].color = statusColor;
                        _this2.devices[i].destPumpArray[j].status = _statusMessage;
                    }
                }
            }
            //}
        }
    };

    var wsDataReceivedAlternator = function wsDataReceivedAlternator(data) {
        for (var i = 0; i < _this2.devices.length; i++) {
            var wsIdforWebS = 'TW' + Array(8 - ('' + _this2.devices[i].wsDeviceId).length + 1).join('0') + _this2.devices[i].wsDeviceId;

            if (wsIdforWebS === data.SN) {
                var positionArray = data.Value.replace(/[[\]]/g, '').split(',');

                for (var j = 0; j < _this2.devices[i].destPumpArray.length; j++) {
                    var position = positionArray.indexOf(_this2.devices[i].destPumpArray[j].pumpId);

                    if (position > -1) {
                        switch (position) {
                            case 0:
                                _this2.devices[i].destPumpArray[j].position = _this2.translation.text.LEAD;
                                break;
                            case 1:
                                _this2.devices[i].destPumpArray[j].position = _this2.translation.text.LAG;
                                break;
                            case 2:
                                _this2.devices[i].destPumpArray[j].position = _this2.translation.text.LAG + '2';
                                break;
                            case 3:
                                _this2.devices[i].destPumpArray[j].position = _this2.translation.text.LAG + '3';
                                break;
                            case 4:
                                _this2.devices[i].destPumpArray[j].position = _this2.translation.text.LAG + '4';
                                break;
                        }
                    }
                }
            }
        }
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId(_this2);
        _this2.devices = [];
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        _this2.popupOffset = 0;
        _this2.sortableOptions = {
            handle: '.sort-yes'
        };
        _this2.devicesLoading = true;

        if (/Edge\/\d./i.test(navigator.userAgent)) {
            _this2.isEdge = true;
        }

        if (!_this2.mobile && !_this2.classicView) {
            _this2.popup = _this.getExistingDialog(_this2.windowId).ref;
        }

        $scope.$on('updatePreferencesLanguage', function () {
            //No translations are required.
            //for (let i = 0; i < this.devices.length; i++) {
            //    for (let j = 0; j < this.devices[i].destPumpArray.length; j++) {
            //        this.devices[i].destPumpArray[j].label = getPumpLabel(this.devices[i].destPumpArray[j].pLbl, i, j);
            //    }
            //}
        });

        tankAndWellService.GetList(_this2.accountInfo.customerId).then(function (resp) {
            _this2.devicesLoading = false;
            _this2.devices = resp.data;

            for (var i = 0; i < _this2.devices.length; i++) {
                initializeDevices(i);
            }
        });
    };

    this.getContainerHeight = function () {
        if (_this2.classicView) {
            return 'calc(100% - 15px)';
        } else if (_this2.mobile) {
            return 'calc(100% - 38px)';
        }
        if (_this2.popup && _this2.isEdge) {
            return _this2.popup[0].clientHeight - 12;
        } else {
            return '100%';
        }
    };

    this.openSetup = function (device) {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = device.wsDeviceId;
        optionsStickyProperties.device = { wsDeviceId: device.wsDeviceId, serialNumber: device.basicInfo.sourceDevice.serialNumber, title: device.title, deviceName: device.title, channel: device.basicInfo.tankAndWellBasic.sourceAnalogChannel };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/setup/tw-setup-template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };

            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 10;

            openViewService.openView('Tank And Well Setup', { width: 700, height: 500 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 700, minimumHeight: 400 });
        }
    };

    this.openDetail = function (device) {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = device.wsDeviceId;
        optionsStickyProperties.device = { wsDeviceId: device.wsDeviceId, serialNumber: device.basicInfo.sourceDevice.serialNumber, title: device.title, deviceName: device.title, channel: device.basicInfo.tankAndWellBasic.sourceAnalogChannel };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/detail/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };

            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 10;

            openViewService.openView('Tank And Well Detail', { width: 700, height: 500 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 700, minimumHeight: 400 });

            tankAndWellService.GetTank(authenticationService.getAccountInfo().customerId, device.wsDeviceId).then(function (resp) {
                //done
            });
        }
    };

    this.openChart = function (device) {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = device.wsDeviceId;
        optionsStickyProperties.device = { wsDeviceId: device.wsDeviceId, serialNumber: device.basicInfo.sourceDevice.serialNumber, title: device.title, deviceName: device.title, channel: device.basicInfo.tankAndWellBasic.sourceAnalogChannel };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/chart/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };

            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 10;

            openViewService.openView('Tank And Well Chart', { width: 600, height: 550 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 300, minimumHeight: 300 });
        }
    };

    this.openLog = function (device) {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = device.wsDeviceId;
        optionsStickyProperties.device = { wsDeviceId: device.wsDeviceId, title: device.title, deviceName: device.title, channel: device.basicInfo.tankAndWellBasic.sourceAnalogChannel };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/log/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };

            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 10;

            openViewService.openView('Tank And Well Log', { width: 600, height: 400 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });
        }
    };

    $scope.$on('processReconnect', function (event, arargs) {
        tankAndWellService.GetList(authenticationService.getAccountInfo().customerId).then(function (resp) {
            for (var i = 0; i < resp.data.length; i++) {
                initializeDevices(i);
            }
        });
        console.log("** ** TW Overview Reconnect > " + event.localDateTime);
        toaster.pop('success', windowTitle, translationService.translation.text.VIEW_RELOADING);
    });

    $scope.$on('alternateSourceUpdated', function () {
        _this2.devicesLoading = true;

        tankAndWellService.GetList(authenticationService.getAccountInfo().customerId).then(function (resp) {
            for (var i = 0; i < resp.data.length; i++) {
                initializeDevices(i);
            }
        });

        _this2.devicesLoading = false;
    });

    $scope.$on('pumpPositionChanged', function () {
        _this2.devicesLoading = true;

        tankAndWellService.GetList(authenticationService.getAccountInfo().customerId).then(function (resp) {
            for (var i = 0; i < resp.data.length; i++) {
                initializeDevices(i);
            }
        });
        $timeout(function () {
            _this2.devicesLoading = false;
        }, 1000);
    });

    this.$onDestroy = function () {
        for (var i = 0; i < _this2.devices.length; i++) {
            if (_this2.devices[i].fuelWidget) {
                _this2.devices[i].fuelWidget.dispose();
            }

            var wsIdforWebS = 'TW' + Array(8 - ('' + _this2.devices[i].wsDeviceId).length + 1).join('0') + _this2.devices[i].wsDeviceId;

            //websocketService.unRegister('RELAYS', this.devices[i].basicInfo.sourceDevice.serialNumber, '', wsDataReceivedTWP, null);
            websocketService.unRegister('ALTERNATOR', wsIdforWebS, '', wsDataReceivedAlternator, null);
            websocketService.unRegister('ANALOG', _this2.devices[i].basicInfo.sourceDevice.serialNumber, _this2.devices[i].tank.sourceChannel, wsDataReceivedGT, null);
            websocketService.unRegister('ANALOG_G2', _this2.devices[i].basicInfo.sourceDevice.serialNumber, _this2.devices[i].tank.sourceChannel, wsDataReceivedGT, null);

            //unregistering for relays of each device based on Device Serial Number
            var previousSerialNumber = void 0;
            for (var k = 0; k < _this2.devices[i].destPumpArray.length; k++) {
                if (_this2.devices[i].destPumpArray[k].deviceSerialNumber === previousSerialNumber) continue;
                websocketService.unRegister('DIGITALOUTPUT', _this2.devices[i].destPumpArray[k].deviceSerialNumber, '', wsDataReceivedTWP, null);
                //console.log('UnRegistered for Relay of Device SN:'+this.devices[i].destPumpArray[k].deviceSerialNumber);
                previousSerialNumber = _this2.devices[i].destPumpArray[k].deviceSerialNumber;
            }
        }

        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(_this2.accountInfo.customerId, _this2.accountInfo.userId, $rootScope.wizardId, _this2.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    };
}

TWOverviewController.$inject = ['_', '$scope', '$rootScope', '$location', '$q', '$sce', '$timeout', 'authenticationService', 'openViewService', 'sharedSetupService', 'tankAndWellService', 'translationService', 'websocketService', 'toaster', '$cookies', 'wizardSplashService'];

angular.module('mc.tankandwell').component('tankAndWellOverview', {
    controller: TWOverviewController,
    transclude: true,
    templateUrl: 'ui/tankandwell/overview/partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        windowTitle: '<'
    }
});
"use strict";

function TicketSystemCreateController($, $rootScope, $scope, $sce, $element, $timeout, host, authenticationService, translationService, sharedSetupService, openViewService, deviceMenuService, ticketSystemService, attchmentUpload, ivhTreeviewMgr, ivhTreeviewBfs, unsavedChangesService, $http, $cookies) {
    var _this2 = this;

    var ctrl = this;
    //ctrl.UploadDirectory = "\\FS-CLUSTER\TicketFiles\";
    ctrl.deviceList = [];
    ctrl.priorities = [];

    ctrl.assignedToOptions = [{ id: 15288, name: "Technical Support" }, { id: 15283, name: "Sales" }];
    ctrl.jiraAttachments = [];
    ctrl.selectedProblemCategory = { id: '', label: '' };

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.buildProblemCategory();
        ctrl.filename = "Please Choose a file";

        $scope.windowId = ctrl.windowId; //need for
        //$scope.windowTitle = ctrl.windowTitle;//need for

        ctrl.getPriorities();
        ctrl.getTicketIssueTypes();
        ctrl.getDevices();

        //load contact info
        ctrl.txtContactName = ctrl.accountInfo.name;
        ctrl.txtContactEmail = ctrl.accountInfo.email;
        ctrl.txtContactPhone = ctrl.accountInfo.phone;

        ctrl.viewMode = 1; //0:view, 1:create, 2:edit

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            //Check for unsaved Changes
            $(ctrl.popup).on('dialogbeforeclose', function (event) {
                if (ctrl.viewMode !== 0) {
                    unsavedChangesService.checkUnsavedChanges(event, ctrl.popup, _this2, true);
                }
            });
        }

        //manually making call to adjustSize in order to load scrollbar
        $timeout(function () {
            ctrl.adjustSize();
        }, 500);
    };

    ctrl.status = {
        //default - all the collapsible panels are open and enabled
        isFirstOpen: true,
        isFirstDisabled: false,
        isSecondOpen: true,
        isSecondDisabled: false,
        isThirdOpen: true,
        isThirdDisabled: false

        //cancel creating new ticket
    };ctrl.cancelCreate = function () {
        ctrl.viewMode = 0;
        ctrl.out();
    };

    //Append Mission user name to the end of ticket note
    ctrl.updateTxtNote = function () {
        var missionUserName = $cookies.get('AdminInfo');
        if (missionUserName != null) {
            ctrl.txtNote = ctrl.txtNote + " (" + missionUserName + ")";
        }
    };

    //save the user entries 
    ctrl.save = function () {
        //validate attachment first
        //if (!isUndefinedOrNull(ctrl.myFile)) {
        //    if (!ticketSystemService.ValidateFile(ctrl.myFile)) {
        //        //manually making call to adjustSize in order to load scrollbar
        //        $scope.alerts = [];
        //        $scope.alerts.push({ msg: "Invalid file attachment (Allowed: .bmp, .gif, .png, .jpg, .jpeg, .doc, .docx, .rtf, .xls, .xlsx, .csv, .zip, .txt, .pdf, .wav, .mp3, .mp4)", type: "danger", languageCode: 'NO_DATA' });
        //        $timeout(function () {
        //            ctrl.adjustSize();
        //        }, 0);
        //        return;
        //    }
        //}
        if (ctrl.addingTicket) return;
        ctrl.addingTicket = true;
        if (ctrl.accountInfo.name.toLowerCase() == "mission") ctrl.updateTxtNote();
        if (isValidAttachment(ctrl.myFile)) {
            var ticketSystem = {
                customerId: ctrl.accountInfo.customerId,
                title: ctrl.txtTitle,
                description: !isUndefinedOrNull(ctrl.txtNote) ? ctrl.txtNote : "",
                createdByLoginId: ctrl.accountInfo.userId,
                createdBy: ctrl.accountInfo.userName,
                AssignedToLoginId: ctrl.selectedSubmitTo,
                assignedTo: getAssignedToName(ctrl.selectedSubmitTo),
                contactName: !isUndefinedOrNull(ctrl.txtContactName) ? ctrl.txtContactName.replace("'", "''") : "",
                contactPhone: !isUndefinedOrNull(ctrl.txtContactPhone) ? ctrl.txtContactPhone.replace("'", "''") : "",
                contactEmail: !isUndefinedOrNull(ctrl.txtContactEmail) ? ctrl.txtContactEmail.replace("'", "''").replace(";", ",") : "",
                serialNumber: !isUndefinedOrNull(ctrl.selectedDevice) ? !isUndefinedOrNull(ctrl.selectedDevice.serialNumber) ? ctrl.selectedDevice.serialNumber : "" : "",
                severity: ctrl.selectedPriority.ticketPriorityCode,
                attachmentFileName: !isUndefinedOrNull(ctrl.myFile) ? ctrl.myFile.name : "",
                attachmentFileSize: !isUndefinedOrNull(ctrl.myFile) ? Math.round(ctrl.myFile.size / 1024) : 0, //save file size as K bytes
                issueTypeCode: ctrl.selectedTicketIssueType.issueTypeCode,
                problemTypeCode: ctrl.selectedProblemCategory.id == 1 ? null : ctrl.selectedProblemCategory.id,
                inputAttachmentBase64: ctrl.jiraAttachments
            };
            ticketSystemService.SaveTicket(ctrl.accountInfo.customerId, ticketSystem).then(function (resp) {
                //after saving the user entries, it should return the newTicketId that has been created.
                ctrl.newTicketId = resp.data;
                ticketSystem.ticketId = ctrl.newTicketId;
                //now upload the attachment to server
                if (angular.isDefined(ctrl.myFile)) {
                    ctrl.uploadFile();
                } else {
                    ctrl.out(); //return back to parent view
                }
                //create JIRA ticket if ticket issue type is 'New Feature Request'
                if (ctrl.selectedTicketIssueType.issueTypeCode == 'FTRQ') {
                    if (angular.isDefined(ctrl.myFile)) {
                        $timeout(function () {
                            ctrl.getBase64AttachmentAndCreateJiraTicket(ctrl.myFile);
                        }, 10000);
                    } else {
                        ctrl.createJiraTicket(ctrl.accountInfo.customerId, ticketSystem);
                    }
                }
                ctrl.viewMode = 0;
            });
        }
    };

    var getAssignedToName = function getAssignedToName(assignedToLoginId) {
        for (var i = 0; i < ctrl.assignedToOptions.length; i++) {
            if (ctrl.assignedToOptions[i].id == assignedToLoginId) return ctrl.assignedToOptions[i].name;
        }
        return "";
    };

    var isValidAttachment = function isValidAttachment(fileInput) {
        var retVal = true;
        //validate attachment first
        $scope.alerts = [];
        if (!isUndefinedOrNull(fileInput)) {
            if (!ticketSystemService.ValidateFile(fileInput)) {
                retVal = false;
                //manually making call to adjustSize in order to load scrollbar
                $scope.alerts.push({ msg: "Invalid file attachment (Allowed: .bmp, .gif, .png, .jpg, .jpeg, .doc, .docx, .rtf, .xls, .xlsx, .csv, .zip, .txt, .pdf, .wav, .mp3, .mp4)", type: "danger", languageCode: 'NO_DATA' }); //TODO:VEN: need to translate
                $timeout(function () {
                    ctrl.adjustSize();
                }, 100);
            }
        }
        return retVal;
    };

    var isUndefinedOrNull = function isUndefinedOrNull(value) {
        return angular.isUndefined(value) || value === null;
    };

    //retrieve list of priorities to load
    ctrl.getPriorities = function () {
        ticketSystemService.GetPriorities(ctrl.accountInfo.customerId, ctrl.accountInfo.userId).then(function (resp) {
            ctrl.priorities = resp.data;
        });
    };

    //retrieve list of devices to load
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data.devices;
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selectedDevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            }
            /*                 else {
                                ctrl.selectedDevice = undefined;
                            } */
        }, function (result) {});
    };

    //retrieve list of ticket issue types to load
    ctrl.getTicketIssueTypes = function () {
        ticketSystemService.GetTicketIssueTypes(ctrl.accountInfo.customerId).then(function (resp) {
            ctrl.ticketIssueTypes = resp.data;

            // Remove New Feature Request option if user type is not TechSupport
            if (ctrl.accountInfo.userType !== "TechSupport") {
                var index = ctrl.ticketIssueTypes.findIndex(function (obj) {
                    return obj.issueTypeCode === "FTRQ";
                });
                ctrl.ticketIssueTypes.splice(index, 1);
            }

            //Default Ticket Issue Type
            if (ctrl.ticketIssueTypes.length > 0) {
                var currentIndex = ctrl.ticketIssueTypes.findIndex(function (obj) {
                    return obj.issueTypeCode === "UNK";
                });
                ctrl.selectedTicketIssueType = ctrl.ticketIssueTypes[currentIndex];
            }
        });
    };

    //var validateFile = (fileInput) => {
    //    let filename = fileInput.name;
    //    var validFilesTypes = ["bmp", "gif", "png", "jpg",
    //         "jpeg", "doc", "docx", "rtf", "xls", "xlsx", "csv",
    //         "zip", "txt", "pdf", "wav", "mp3", "mp4"];

    //    var isValidFile = false;
    //    let ext = filename.slice(filename.lastIndexOf('.') + 1).toLowerCase();
    //    for (var i = 0; i < validFilesTypes.length; i++) {
    //        if (ext == validFilesTypes[i]) {
    //            isValidFile = true;
    //            break;
    //        }
    //    }

    //    return isValidFile;
    //}

    ctrl.uploadFile = function () {
        var file = ctrl.myFile;
        var uploadUrl = host + "/api/uploadTicketAttachment?CustomerId=" + ctrl.accountInfo.customerId + "&TicketId=" + ctrl.newTicketId;
        attchmentUpload.uploadFileToUrl(file, uploadUrl, 0, onUploadSuccess, onUploadError);
    };

    ctrl.getBase64AttachmentAndCreateJiraTicket = function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            ctrl.base64result = reader.result.split(',')[1];
            ctrl.jiraAttachments.push(ctrl.base64result);
            var ticketSystem = {
                ticketId: ctrl.newTicketId,
                customerId: ctrl.accountInfo.customerId,
                title: ctrl.txtTitle,
                description: !isUndefinedOrNull(ctrl.txtNote) ? ctrl.txtNote : "",
                createdByLoginId: ctrl.accountInfo.userId,
                createdBy: ctrl.accountInfo.userName,
                AssignedToLoginId: ctrl.selectedSubmitTo,
                assignedTo: getAssignedToName(ctrl.selectedSubmitTo),
                contactName: !isUndefinedOrNull(ctrl.txtContactName) ? ctrl.txtContactName.replace("'", "''") : "",
                contactPhone: !isUndefinedOrNull(ctrl.txtContactPhone) ? ctrl.txtContactPhone.replace("'", "''") : "",
                contactEmail: !isUndefinedOrNull(ctrl.txtContactEmail) ? ctrl.txtContactEmail.replace("'", "''").replace(";", ",") : "",
                serialNumber: !isUndefinedOrNull(ctrl.selectedDevice) ? !isUndefinedOrNull(ctrl.selectedDevice.serialNumber) ? ctrl.selectedDevice.serialNumber : "" : "",
                severity: ctrl.selectedPriority.ticketPriorityCode,
                attachmentFileName: !isUndefinedOrNull(ctrl.myFile) ? ctrl.myFile.name : "",
                attachmentFileSize: !isUndefinedOrNull(ctrl.myFile) ? Math.round(ctrl.myFile.size / 1024) : 0, //save file size as K bytes
                problemTypeCode: ctrl.selectedProblemCategory.id == 1 ? null : ctrl.selectedProblemCategory.id,
                inputAttachmentBase64: ctrl.jiraAttachments
            };
            ctrl.createJiraTicket(ctrl.accountInfo.customerId, ticketSystem);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };

    ctrl.createJiraTicket = function (customerId, _jiraIssue) {
        return $http.post(host + "/api/ITCMJira?customerId=" + customerId, _jiraIssue);
    };

    var onUploadSuccess = function onUploadSuccess(obj, idx) {
        //console.log("upload attachment is success");
        ctrl.out(); //return back to parent view
    };

    var onUploadError = function onUploadError(error) {
        $scope.alerts = [];
        //console.log("Failed to upload attachment (Error: " + error.data + ")");
        $scope.alerts.push({ msg: "Failed to upload attachment (Error: " + error.data + ")", type: "danger", languageCode: 'NO_DATA' });
        $timeout(function () {
            ctrl.adjustSize();
        }, 0);
    };

    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));

            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            if (!!ctrl.popup.parent().find('.alert').css("height")) {
                //ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - (80 + ctrl.popup.parent().find('.alert').css("height").replace(/[^0-9.]+/g, "")));
                ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 130);
            } else {
                ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 80); //80: total padding
            }
        }
    };

    ctrl.buildProblemCategory = function () {
        ctrl.stuff = ticketSystemService.GetProblemCategories();
    };
    ctrl.onClickShowHideIVHDropdown1 = function (e) {
        var isItemSelected = true;
        if (e.target.classList[0] === "dropDown" && e.target.parentElement.children.length === 2 && e.target.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        }
        if (e.target.classList[0] === "dropDownLabel" && e.target.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        } else if (e.target.classList[0] === "dropDownButton" && e.target.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        } else if (e.target.classList[0] === "dropDownButtonIcon" && e.target.parentElement.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        }
        var selectedItm = getSelectedFormIVHTreeModel1(ctrl.stuff);
        if (isItemSelected) {
            //collapse dropdown
            var ivhTreeViewElement = $element.find(".dropdown-with-ivhTreeView .dropDownContent");
            if (!!ivhTreeViewElement) {
                if (ivhTreeViewElement[0].classList.contains("show")) {
                    ivhTreeViewElement[0].classList.remove("show");
                }
            }
        }
    };
    var getSelectedFormIVHTreeModel1 = function getSelectedFormIVHTreeModel1(ivhModel) {
        var selectedItems = [];
        angular.forEach(ivhModel, function (value) {
            if (value.selected) {
                selectedItems.push(value.label);
            }
            if (angular.isDefined(value.children) && value.children.length > 0) {
                angular.forEach(getSelectedFormIVHTreeModel1(value.children), function (vle) {
                    selectedItems.push(vle);
                });
            }
        });
        return selectedItems;
    };
    $scope.$on("ChildNodeEvent", function (evt, data) {
        ctrl.selectNode(data.ivhTree, data.ivhNode);
    });

    ctrl.selectNode = function (ivhTree, ivhNode) {
        ivhTreeviewMgr.deselectAll(ivhTree);
        ivhTreeviewMgr.select(ivhTree, ivhNode);
        if (ivhNode.id) {
            ctrl.selectedProblemCategory = { id: ivhNode.id, label: ctrl.getNodeDisplayText(ivhTree, ivhNode) };
        } else {
            ctrl.selectedProblemCategory = { id: 1, label: ctrl.translation.text.NO_CATEGORY_SELECTED };
        }
    };

    ctrl.getNodeDisplayText = function (ivhTree, selectedProblemCategory) {
        var displayText = '';
        var done = false;
        ivhTreeviewBfs(ivhTree, function (node, parentsArray) {
            if (done) {
                return false;
            }
            if (node.id === selectedProblemCategory.id) {
                angular.forEach(parentsArray.reverse(), function (parentNode, index) {
                    displayText += parentNode.label + ' > ';
                });
                done = true;
            }
            return !done;
        });

        displayText += selectedProblemCategory.label;
        return displayText;
    };

    ctrl.tpl = ['<div class="ivh-treeview-node-content" title="{{::trvw.label(node)}}">', '<span ivh-treeview-toggle>', '<span class="ivh-treeview-twistie-wrapper" ivh-treeview-twistie></span>', '</span>', '<prob-category-node></prob-category-node>', '<div ivh-treeview-children></div>', '</div>'].join('\n');
    ctrl.arrowDownTpl = '<span class="arrow-down"></span>';
    ctrl.arrowRightTpl = '<span class="arrow-right"></span>';
};

TicketSystemCreateController.$inject = ['$', '$rootScope', '$scope', '$sce', '$element', '$timeout', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'deviceMenuService', 'ticketSystemService', 'attchmentUpload', 'ivhTreeviewMgr', 'ivhTreeviewBfs', 'unsavedChangesService', '$http', '$cookies'];

mcapp.service('attchmentUpload', ['$http', '$rootScope', 'HOST', 'LOCALHOST', function ($http, $rootScope, HOST, LOCALHOST) {
    this.uploadFileToUrl = function (file, uploadUrl, idx, scb, ecb) {
        var fd = new FormData();
        fd.append('file', file);

        return $http.post(uploadUrl, fd, {
            transformRequest: angular.identity,
            headers: {
                //'enctype': 'multipart/form-data',
                'Content-Type': undefined
            }
        }).then(function (result) {
            //$rootScope.backgroundLogo = (document.location.hostname === "localhost" ? LOCALHOST + HOST : HOST) + "/images/cust/" + result.data.toString(),//"/mc.services/images/" + result.data.toString();
            var obj = { fileName: file.name, fileSize: Math.round(file.size / 1024) };
            scb(obj, idx);
        }, function (error) {
            console.log("Error");
            ecb(error);
            //$scope.alerts.push({
            //    msg: "Failed to upload attachment (Error: " + error.data + ")", type: "danger", languageCode: 'NO_DATA'
            //});
            //$rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
            //cb();
        });
    };
}]);
'use strict';

angular.module('mc.ticket-system').component('ticketSystemCreate', {
    controller: TicketSystemCreateController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/ticketsystem/create/ticket-system-create.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        //windowTitle: '<',
        classicView: '<',
        out: '&'
    }
});
'use strict';

function TWSetupSetPointsController($scope, authenticationService, translationService, sharedSetupService, tankAndWellService, $q, $timeout, $element, $rootScope, $uibModal) {
    var _this = this;

    var ctrl = this;

    //NOTE: '+' operator is prefixed for converting string to Number
    // difference between setpoints could be any values, earlier we have 1 unit difference but removed the condition

    //OP: OffPeak related code
    //NOP: Non-OffPeak related code
    //Normal Setpoints: setpoints that are part of WSDevices, each pump's ON/OFF value
    //In case of OffPeak setpoints, Normal Setpoints are the one which are Default WsLevels
    // all other setpoints are regular OffPeak setpoints aka. WsLevels

    //ctrl.wsProfilesAvailable = false; //TODO: hiding off-peak feature for current release
    ctrl.viewLoading = true;
    ctrl.destPumpArray = [];
    ctrl.invalidPumpOffValTooltip = "";
    ctrl.MaxNumberRunningPumps = 5;
    ctrl.pumpTypeUp = true; // there are two types of pump operation; 1. PumpUp: Turn Pump ON when water is at low; 2. PumpDown: Turn Pump ON when water is at high;

    ctrl.offError = false;
    ctrl.onError = false;
    ctrl.errorCount = 0;
    ctrl.enableOffPeakAlert = true;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;
    ctrl.editModeIndex = -1;
    ctrl.addMode = false;
    ctrl.wsProfilesReady = true; // by setting the value to 'false' will enable to test PRE-OffPeak profiles scenario for TW System.
    ctrl.defaultIsActive = false;

    ctrl.profileOffError = [];
    ctrl.profileOnError = [];
    ctrl.invalidProfilePumpOnValTooltip = [];
    ctrl.invalidProfilePumpOffValTooltip = [];
    ctrl.peakProfileId = 0;
    ctrl.offPeakSliderProfile;
    ctrl.showMultiplePumpsRunMessage = false;

    //NOP: Non-OffPeak
    ctrl.editModeNOP = false; // non-offpeak edit mode.  true:Edit mode
    ctrl.isDirty = false;
    ctrl.propPatches = [];

    var LEAD = 'Lead';
    var LAG = 'Lag';
    var LAG2 = 'Lag2';
    var LAG3 = 'Lag3';
    var LAG4 = 'Lag4';

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        tankAndWellService.checkUnsavedChanges = false;
        $scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;

        //fetch & load non-offPeak setpoints 
        getSetPointsSetup($scope.stickyProperties.deviceId); //http call for webapi
        //following function implementation is required as per Legacy
        updateLabels();

        //fetch & load offPeak setpoints
        loadProfiles_OP(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId); // http call for webapi
    };

    ctrl.setEditModeNOP = function () {
        ctrl.editModeNOP = true;
    };

    ctrl.editCancelNOP = function (profile) {
        //ctrl.offPeakProfiles = angular.copy(ctrl.previousOffPeakProfiles);
        tankAndWellService.tabPopupWarningOn = false;
        ctrl.viewLoading = true;
        ctrl.isDirty = false;
        ctrl.editModeNOP = false;
        ctrl.offError = false;
        ctrl.onError = false;
        ctrl.propPatches = [];
        //restore the setpoints to its original values;
        $timeout(function () {
            updatePumpArray();

            processIsOutsideVisualLimits_NOP();

            ////validate and error out the values which do not fit the validation rules.
            //for (let k = 0; k < ctrl.pumpsCount; k++) {
            //    if (ctrl.pumpTypeUp) {
            //        ctrl.isValidOffPumpLimitPumpTypeUp_NOP(k);
            //        ctrl.isValidOnPumpLimitPumpTypeUp_NOP(k);
            //    }
            //    else {
            //        ctrl.isValidOffPumpLimitPumpTypeDown_NOP(k);
            //        ctrl.isValidOnPumpLimitPumpTypeDown_NOP(k);
            //    }
            //}

            ctrl.initErrorCount = ctrl.errorCount;
            ctrl.initErrorCount = 0;
            ctrl.errorCount = 0;

            //load slider's options for each pump
            for (var j = 0; j < ctrl.destPumpArray.length; j++) {
                ctrl.destPumpArray[j].options = loadPumpSliderOptions_NOP(getPumpPositionIndex(ctrl.twBasic, ctrl.destPumpArray[j].pumpId));
            }
            ctrl.viewLoading = false;
        }, 0);
    };

    // this method is used to toggle the Edit mode (into or out of Edit mode)
    ctrl.setEditMode_OP = function (profileId) {
        if (profileId == ctrl.peakProfiles[0].profileId) {
            profileId = ctrl.peakProfileId;
        }
        ctrl.editModeIndex = ctrl.editModeIndex == profileId ? -1 : profileId;
        clearNewProfile_OP();
    };

    var storeProfiles_OP = function storeProfiles_OP() {
        ctrl.previousOffPeakProfiles = angular.copy(ctrl.offPeakProfiles); //JSON.parse(JSON.stringify(ctrl.offPeakProfiles));
    };
    var storeProfiles_peak_OP = function storeProfiles_peak_OP() {
        ctrl.previousPeakProfiles = angular.copy(ctrl.peakProfiles); //JSON.parse(JSON.stringify(ctrl.offPeakProfiles));
    };

    // fetch & load offPeak setpoints
    var loadProfiles_OP = function loadProfiles_OP(customerId, wsDeviceId) {
        ctrl.defaultIsActive = false;
        var offPeakPromise = $q.defer();
        if (ctrl.wsProfilesReady) {
            tankAndWellService.GetProfiles(customerId, wsDeviceId).then(function (resp) {
                offPeakPromise.resolve();
                $timeout(function () {
                    if (resp.data.wsProfileList.length > 0) {
                        ctrl.wsProfiles = resp.data.wsProfileList;

                        //set UI related local properties to profiles
                        initLocalPropertiesOnProfiles_OP();
                        ctrl.peakProfiles = ctrl.wsProfiles.filter(function (profile) {
                            return profile.isDefault;
                        });

                        ctrl.activeProfiles = ctrl.wsProfiles.filter(function (profile) {
                            return profile.isActive;
                        });

                        ctrl.offPeakProfiles = ctrl.wsProfiles.filter(function (profile) {
                            return !profile.isDefault;
                        });
                        storeProfiles_OP();
                        storeProfiles_peak_OP();

                        // override default setpoints pumpType 
                        ctrl.pumpTypeUp = getPumpTypeByProfile_OP(ctrl.peakProfiles[0]);
                        updateProfilesPumpType_OP();
                        ctrl.peakProfileId = ctrl.peakProfiles[0].profileId;
                        ctrl.wsProfilesAvailable = true;
                        if (ctrl.activeProfiles.length == 0) {
                            ctrl.defaultIsActive = true;
                            ctrl.offPeakSliderProfile = angular.copy(ctrl.peakProfiles[0]); // separating slider and input box binding modal
                        } else {
                            ctrl.offPeakSliderProfile = angular.copy(ctrl.activeProfiles[0]); // separating slider and input box binding modal
                        }
                        //setting slider options for each WsLevel / setpoint in order to render as a slider
                        ctrl.offPeakSliderProfile.wsLevels.forEach(function (level) {
                            level.options = loadPumpSliderOptions_OP();
                        });

                        //logic whether to show simultaneous multiple pumps run message
                        ctrl.showMultiplePumpsRunMessage = IsMultiplePumpsOn();
                        //verify whether any setpoint is outside the visual limits
                        processIsOutsideVisualLimits_OP(); //all off-peak profile setpoints
                    }
                });
            }, function (resp) {
                // console.log(resp);
            });
        } else {
            // this Code never executed as current TW system is WSProfilesReady
            tankAndWellService.GetProfiles(customerId, wsDeviceId).then(function (resp) {
                offPeakPromise.resolve();
                $timeout(function () {
                    ctrl.offPeakProfiles = resp.data.wsProfileList;
                    ctrl.wsProfilesAvailable = false;
                });
            }, function (resp) {
                //console.log(resp);
            });
        }
    };

    var IsMultiplePumpsOn = function IsMultiplePumpsOn() {
        // multiple pumpsOn message is applicable for Off-Peak or Force-Fill UI only
        if (!ctrl.offPeakSliderProfile || ctrl.offPeakSliderProfile.wsLevels.length === 0) return false;
        //validate upto max number of running pumps
        var len = ctrl.MaxNumberRunningPumps; //ctrl.offPeakSliderProfile.wsLevels.length;

        for (var lIdx = 0; lIdx < len; lIdx++) {
            for (var i = lIdx; i < len - 1; i++) {
                if (ctrl.offPeakSliderProfile.wsLevels[i].on === ctrl.offPeakSliderProfile.wsLevels[i + 1].on) {
                    return true;
                }
            }
        };
    };

    var initLocalPropertiesOnProfiles_OP = function initLocalPropertiesOnProfiles_OP() {
        ctrl.wsProfiles.forEach(function (profile) {
            profile.profileOnError = false;
            profile.profileOffError = false;
            profile.validName = true;
            profile.isValid = true;
            profile.isDirty = false;
            profile.loading = false;
            profile.invalidPump0OffVal = false;
            profile.invalidPump1OffVal = false;
            profile.invalidPump2OffVal = false;
            profile.invalidPump3OffVal = false;
            profile.invalidPump4OffVal = false;

            profile.invalidPump0OnVal = false;
            profile.invalidPump1OnVal = false;
            profile.invalidPump2OnVal = false;
            profile.invalidPump3OnVal = false;
            profile.invalidPump4OnVal = false;
            profile.wsLevels.forEach(function (level) {
                //if value is -999 means just ignore the pump as it is disabled
                level.ignoreValidation = level.on == -999; // if given setpoints / level values are not valid, OR ignore given pump from validation mechanism
            });
            profile.prevWsLevels = JSON.parse(JSON.stringify(profile.wsLevels));
            profile.prevProfileName = profile.name;
        });
    };

    var initLocalPropertiesOnProfile_OP = function initLocalPropertiesOnProfile_OP(profile) {
        profile.profileOnError = false;
        profile.profileOffError = false;
        profile.validName = true;
        profile.isValid = true;
        profile.isDirty = false;
        profile.loading = false;
        profile.invalidPump0OffVal = false;
        profile.invalidPump1OffVal = false;
        profile.invalidPump2OffVal = false;
        profile.invalidPump3OffVal = false;
        profile.invalidPump4OffVal = false;

        profile.invalidPump0OnVal = false;
        profile.invalidPump1OnVal = false;
        profile.invalidPump2OnVal = false;
        profile.invalidPump3OnVal = false;
        profile.invalidPump4OnVal = false;
        profile.wsLevels.forEach(function (level) {
            level.ignoreValidation = false; // if given setpoints / level values are not valid, it means has negative value, then ignore given pump from validation mechanism
        });
        profile.prevProfileName = profile.name;
    };

    // get ALL the INFORMATION required to load the tab
    // fetch WsDevices and related non-offPeak setpoints details
    var getSetPointsSetup = function getSetPointsSetup(wsDeviceId) {
        ctrl.viewLoading = true;
        var tabPromise = $q.defer();

        tankAndWellService.GetSetPointsSetup(wsDeviceId).then(function (resp) {
            //ctrl.viewLoading = true;

            tabPromise.resolve();
            $timeout(function () {
                ctrl.twBasic = resp.data.tankAndWellBasic; // this object contains all the pumps' related information
                ctrl.twLabels = resp.data.tankAndWellLabels;
                ctrl.twParameter = resp.data.tankAndWellParameter; // this object contains source & pumps' related label information
                ctrl.tank = resp.data.tank; // this object contains tank's top, bottom, yellow & red levels
                ctrl.unit = resp.data.unit;

                ctrl.MaxNumberRunningPumps = ctrl.twParameter.maxNumberRunningPumps === null ? ctrl.MaxNumberRunningPumps : ctrl.twParameter.maxNumberRunningPumps;
                ctrl.pumpsCount = getPumpsCount();
                ctrl.MaxNumberRunningPumps = ctrl.MaxNumberRunningPumps > ctrl.pumpsCount ? ctrl.pumpsCount : ctrl.MaxNumberRunningPumps; //making sure max running pumps should not be more than pumps exists.

                updatePumpArray();

                //determine pump type, PumpUp? or PumpDown?
                ctrl.pumpTypeUp = getPumpTypeByParameter(ctrl.twParameter);

                ctrl.errorCount = 0;

                //validate and error out the values which do not fit the validation rules.
                for (var k = 0; k < ctrl.pumpsCount; k++) {
                    if (ctrl.pumpTypeUp) {
                        ctrl.isValidOffPumpLimitPumpTypeUp_NOP(k);
                        ctrl.isValidOnPumpLimitPumpTypeUp_NOP(k);
                    } else {
                        ctrl.isValidOffPumpLimitPumpTypeDown_NOP(k);
                        ctrl.isValidOnPumpLimitPumpTypeDown_NOP(k);
                    }
                }

                ctrl.initErrorCount = ctrl.errorCount;
                ctrl.initErrorCount = 0;
                ctrl.errorCount = 0;

                //load slider's options for each pump
                for (var j = 0; j < ctrl.destPumpArray.length; j++) {
                    ctrl.destPumpArray[j].options = loadPumpSliderOptions_NOP(getPumpPositionIndex(ctrl.twBasic, ctrl.destPumpArray[j].pumpId));
                }
                storePreviousParameter(ctrl.twParameter);
                storePreviousBasicInfo(ctrl.twBasic);
                ctrl.viewLoading = false;
            });
        }, function (resp) {
            // console.log(resp);
        });
    };

    // code inherited from Legacy
    var updateLabels = function updateLabels() {
        ctrl.modeOffLabel = ctrl.translation.text.OFF;
        ctrl.modeHandLabel = ctrl.translation.text.HAND;
        ctrl.modeAutoLabel = ctrl.translation.text.AUTO;

        // this logic carried over from legacy 123mc.com and applies if pump count <= 1
        if (ctrl.destPumpArray.length <= 1 && ctrl.accountInfo.customerId == 11351 && $scope.stickyProperties.deviceId == 94) {
            ctrl.modeOffLabel = ctrl.translation.text.OPEN;
            ctrl.modeHandLabel = ctrl.translation.text.CLOSED;
        }

        // this logic carried over from legacy 123mc.com and applies if pump count <= 1
        if (ctrl.destPumpArray.length == 1 && ctrl.accountInfo.customerId == 10920) {
            ctrl.destPumpArray[0].pumpOffLabel = ctrl.translation.text.PUMP_OFF;
            ctrl.destPumpArray[0].pumpOnLabel = ctrl.translation.text.PUMP_ON;
        }
    };

    var getPumpsCount = function getPumpsCount() {
        // create pump array for binding processed/calculated values with UI
        var pumpsCount = 0;
        for (var j = 1; j <= 5; j++) {
            if (ctrl.twBasic['destPump' + j + 'DeviceId'] !== 0) {
                pumpsCount++;
            }
        }
        return pumpsCount;
    };

    // applies to WSDevices only setpoints
    var updatePumpArray = function updatePumpArray() {
        // create pump array for binding processed/calculated values with UI
        ctrl.destPumpArray = [];
        for (var j = 1; j <= 5; j++) {
            if (ctrl.twBasic['destPump' + j + 'DeviceId'] !== 0) {
                var pumpDispName = getPumpDisplayName(ctrl.twBasic, j);
                var pumpOnLabel = pumpDispName + ' ' + ctrl.translation.text.ON;
                var pumpOffLabel = pumpDispName + ' ' + ctrl.translation.text.OFF;
                var pumpLabel = ctrl.twLabels['labelPump' + j];
                var onVal = ctrl.twParameter[getPumpPositionName(ctrl.twBasic, j).toLowerCase() + 'PumpOn'];
                var offVal = ctrl.twParameter[getPumpPositionName(ctrl.twBasic, j).toLowerCase() + 'PumpOff'];
                ctrl.destPumpArray.push({
                    pumpId: j,
                    positionName: getPumpPositionName(ctrl.twBasic, j),
                    positionIdx: getPumpPositionIndex(ctrl.twBasic, j),
                    mode: ctrl.twBasic['destPump' + j + 'Mode'],
                    label: angular.isUndefined(pumpLabel) || !angular.isString(pumpLabel) ? ctrl.translation.text.PUMP + ' ' + j : pumpLabel,
                    positionDisplayName: pumpDispName,
                    pumpOnVal: onVal,
                    pumpOffVal: offVal,
                    sliderOnVal: onVal,
                    sliderOffVal: offVal,
                    pumpOnLabel: pumpOnLabel,
                    pumpOffLabel: pumpOffLabel,
                    options: null, //loadPumpSliderOptions_NOP(getPumpPositionIndex(ctrl.twBasic, j)),
                    ignoreValidation: onVal == -999 //if value is -999 means just ignore the pump as it is disabled
                    //loading: true,
                });
            }
        }
        // sort the array
        ctrl.destPumpArray.sort(compare);
    };

    var updatePumpArrayTranslation = function updatePumpArrayTranslation() {
        // create pump array for binding processed/calculated values with UI
        for (var j = 0; j < ctrl.destPumpArray.length; j++) {
            if (ctrl.twBasic['destPump' + j + 'DeviceId'] !== 0) {
                var pumpDispName = getPumpDisplayName(ctrl.twBasic, j + 1);
                var pumpOnLabel = pumpDispName + ' ' + ctrl.translation.text.ON;
                var pumpOffLabel = pumpDispName + ' ' + ctrl.translation.text.OFF;
                //var pumpLabel = ctrl.twLabels[`labelPump${j}`];
                ctrl.destPumpArray[j].positionDisplayName = pumpDispName;
                ctrl.destPumpArray[j].pumpOnLabel = pumpOnLabel;
                ctrl.destPumpArray[j].pumpOffLabel = pumpOffLabel;
            }
        }
    };

    //this function useful for comparing user input with existing data, to make decision whether user made changes to data or not
    var storePreviousParameter = function storePreviousParameter(params) {
        ctrl.previousTwParameter = JSON.parse(JSON.stringify(params));
    };
    var storePreviousBasicInfo = function storePreviousBasicInfo(basicinfo) {
        ctrl.previousTwBasic = JSON.parse(JSON.stringify(basicinfo));
    };

    var getPumpDisplayName = function getPumpDisplayName(basic, pumpId) {
        if (parseInt(basic.currentLeadPump, 10) === parseInt(pumpId, 10)) {
            return _this.translation.text.LEAD;
        } else if (parseInt(basic.currentLagPump, 10) === parseInt(pumpId, 10)) {
            return _this.translation.text.LAG;
        } else if (parseInt(basic.currentLag2Pump, 10) === parseInt(pumpId, 10)) {
            return _this.translation.text.LAG + ' 2';
        } else if (parseInt(basic.currentLag3Pump, 10) === parseInt(pumpId, 10)) {
            return _this.translation.text.LAG + ' 3';
        } else if (parseInt(basic.currentLag4Pump, 10) === parseInt(pumpId, 10)) {
            return _this.translation.text.LAG + ' 4';
        }
    };
    var getPumpPositionName = function getPumpPositionName(basic, pumpId) {
        if (parseInt(basic.currentLeadPump, 10) === parseInt(pumpId, 10)) {
            return LEAD;
        } else if (parseInt(basic.currentLagPump, 10) === parseInt(pumpId, 10)) {
            return LAG;
        } else if (parseInt(basic.currentLag2Pump, 10) === parseInt(pumpId, 10)) {
            return LAG2;
        } else if (parseInt(basic.currentLag3Pump, 10) === parseInt(pumpId, 10)) {
            return LAG3;
        } else if (parseInt(basic.currentLag4Pump, 10) === parseInt(pumpId, 10)) {
            return LAG4;
        }
    };
    var getPumpPositionIndex = function getPumpPositionIndex(basic, pumpId) {
        if (parseInt(basic.currentLeadPump, 10) === parseInt(pumpId, 10)) {
            return 0;
        } else if (parseInt(basic.currentLagPump, 10) === parseInt(pumpId, 10)) {
            return 1;
        } else if (parseInt(basic.currentLag2Pump, 10) === parseInt(pumpId, 10)) {
            return 2;
        } else if (parseInt(basic.currentLag3Pump, 10) === parseInt(pumpId, 10)) {
            return 3;
        } else if (parseInt(basic.currentLag4Pump, 10) === parseInt(pumpId, 10)) {
            return 4;
        }
    };
    var loadPumpSliderOptions_NOP = function loadPumpSliderOptions_NOP(idx) {

        return {
            floor: ctrl.tank.tankBottom,
            ceil: ctrl.tank.tankTop,
            step: 0.01,
            precision: 2,
            vertical: true,
            disabled: true, //idx >= ctrl.pumpsCount || ctrl.initErrorCount > 1,
            showSelectionBar: true, // allows to slide using range in addition to individual slider pointers
            noSwitching: true, // prevents both the sliders to overlap each other
            minRange: 1, // represents min difference between min & max slider values
            hidePointerLabels: true,
            hideLimitLabels: true,
            onChange: function onChange(pointerType, newTankRedBelowVal, newTankYellowAboveVal) {
                if (ctrl.pumpTypeUp) {
                    ctrl.isValidOffPumpLimitPumpTypeUp_NOP(idx, true);
                    ctrl.isValidOnPumpLimitPumpTypeUp_NOP(idx, true);
                } else {
                    ctrl.isValidOffPumpLimitPumpTypeDown_NOP(idx, true);
                    ctrl.isValidOnPumpLimitPumpTypeDown_NOP(idx, true);
                }
            },
            onEnd: function onEnd(pointerType, newTankRedBelowVal, newTankYellowAboveVal) {
                //console.log("Starts -->  newTankRedBelowVal:" + newTankRedBelowVal + ", newTankYellowAboveVal:" + newTankYellowAboveVal + ", pointerType:" + pointerType);
                savePumpLimit_NOP(idx, true);
                savePumpLimit_NOP(idx, false);
            }
        };
    };
    var loadPumpSliderOptions_OP = function loadPumpSliderOptions_OP() {
        return {
            floor: ctrl.tank.tankBottom,
            ceil: ctrl.tank.tankTop,
            step: 0.01,
            precision: 2,
            vertical: true,
            disabled: true,
            //readOnly: ctrl.errorCount > 0,
            showSelectionBar: true, // allows to slide using range in addition to individual slider pointers
            noSwitching: true, // prevents both the sliders to overlap each other
            minRange: 1, // represents min difference between min & max slider values
            hidePointerLabels: true,
            hideLimitLabels: true
        };
    };
    var compare = function compare(a, b) {
        if (a.positionIdx < b.positionIdx) return -1;
        if (a.positionIdx > b.positionIdx) return 1;
        return 0;
    };

    // this function useful to update labels once user input is saved.
    var updateParameter = function updateParameter(params) {
        ctrl.twParameter = params;storePreviousParameter(params);ctrl.updateSetPointWithProfiles = true;
    };
    //ctrl.updateBasic = (basicinfo) => {
    //    ctrl.twBasic = basicinfo; storePreviousBasicInfo(basicinfo);
    //}
    var resetAllInvalidValues_NOP = function resetAllInvalidValues_NOP() {
        //resetAll non-peak InvalidValues 
        ctrl.offError = false;
        ctrl.onError = false;
        if (!ctrl.viewLoading) {
            ctrl.invalidPump0OffVal = false;
            ctrl.invalidPump1OffVal = false;
            ctrl.invalidPump2OffVal = false;
            ctrl.invalidPump3OffVal = false;
            ctrl.invalidPump4OffVal = false;

            ctrl.invalidPump0OnVal = false;
            ctrl.invalidPump1OnVal = false;
            ctrl.invalidPump2OnVal = false;
            ctrl.invalidPump3OnVal = false;
            ctrl.invalidPump4OnVal = false;
        }
    };

    var setInvalidPumpVal_NOP = function setInvalidPumpVal_NOP(idx, isOffField, status) {
        //isOffField ->> is useful to determine whether it is OFF or ON val of pump
        if (status) {}
        // ctrl.errorCount = ctrl.errorCount + 1;

        //console.log("Profile ")

        if (isOffField) {
            switch (idx) {
                case 0:
                    ctrl.invalidPump0OffVal = status;
                    break;
                case 1:
                    ctrl.invalidPump1OffVal = status;
                    break;
                case 2:
                    ctrl.invalidPump2OffVal = status;
                    break;
                case 3:
                    ctrl.invalidPump3OffVal = status;
                    break;
                case 4:
                    ctrl.invalidPump4OffVal = status;
                    break;
            }
        } else {
            switch (idx) {
                case 0:
                    ctrl.invalidPump0OnVal = status;
                    break;
                case 1:
                    ctrl.invalidPump1OnVal = status;
                    break;
                case 2:
                    ctrl.invalidPump2OnVal = status;
                    break;
                case 3:
                    ctrl.invalidPump3OnVal = status;
                    break;
                case 4:
                    ctrl.invalidPump4OnVal = status;
                    break;
            }
        }
    };
    var setInvalidPumpVal_OP = function setInvalidPumpVal_OP(idx, isOffField, status, profile) {
        //isOffField ->> is useful to determine whether it is OFF or ON val of pump
        //if it is peak/Normal setpoints profile
        if (profile.profileId == ctrl.peakProfiles[0].profileId) {
            setInvalidPumpVal_peak_OP(idx, isOffField, status, profile);
            return;
        }

        //if (status) {
        //    ctrl.initErrorCount = ctrl.initErrorCount + 1;
        //}


        //if it is offpeak profile
        //update pumpUp/Down based on new setpoints elections
        var thisProfileIdx = ctrl.offPeakProfiles.findIndex(function (x) {
            return x.profileId == profile.profileId;
        });
        if (thisProfileIdx > -1) {

            if (isOffField) {
                switch (idx) {
                    case 0:
                        profile.invalidPump0OffVal = status;
                        ctrl.offPeakProfiles[thisProfileIdx].invalidPump0OffVal = status;
                        break;
                    case 1:
                        profile.invalidPump1OffVal = status;
                        ctrl.offPeakProfiles[thisProfileIdx].invalidPump1OffVal = status;
                        break;
                    case 2:
                        profile.invalidPump2OffVal = status;
                        ctrl.offPeakProfiles[thisProfileIdx].invalidPump2OffVal = status;
                        break;
                    case 3:
                        profile.invalidPump3OffVal = status;
                        ctrl.offPeakProfiles[thisProfileIdx].invalidPump3OffVal = status;
                        break;
                    case 4:
                        profile.invalidPump4OffVal = status;
                        ctrl.offPeakProfiles[thisProfileIdx].invalidPump4OffVal = status;
                        break;
                }
                profile.profileOffError = status;
                ctrl.offPeakProfiles[thisProfileIdx].profileOffError = status;
            } else if (!isOffField) {
                switch (idx) {
                    case 0:
                        profile.invalidPump0OnVal = status;
                        ctrl.offPeakProfiles[thisProfileIdx].invalidPump0OnVal = status;
                        break;
                    case 1:
                        profile.invalidPump1OnVal = status;
                        ctrl.offPeakProfiles[thisProfileIdx].invalidPump1OnVal = status;
                        break;
                    case 2:
                        profile.invalidPump2OnVal = status;
                        ctrl.offPeakProfiles[thisProfileIdx].invalidPump2OnVal = status;
                        break;
                    case 3:
                        profile.invalidPump3OnVal = status;
                        ctrl.offPeakProfiles[thisProfileIdx].invalidPump3OnVal = status;
                        break;
                    case 4:
                        profile.invalidPump4OnVal = status;
                        ctrl.offPeakProfiles[thisProfileIdx].invalidPump4OnVal = status;
                        break;
                }
                profile.profileOnError = status;
                ctrl.offPeakProfiles[thisProfileIdx].profileOnError = status;
            }
        }
    };
    var setInvalidPumpVal_peak_OP = function setInvalidPumpVal_peak_OP(idx, isOffField, status, profile) {
        //isOffField ->> is useful to determine whether it is OFF or ON val of pump
        //if (status) {
        //    ctrl.initErrorCount = ctrl.initErrorCount + 1;
        //}

        //update pumpUp/Down based on new setpoints elections
        if (isOffField) {
            switch (idx) {
                case 0:
                    profile.invalidPump0OffVal = status;
                    ctrl.peakProfiles[0].invalidPump0OffVal = status;
                    break;
                case 1:
                    profile.invalidPump1OffVal = status;
                    ctrl.peakProfiles[0].invalidPump1OffVal = status;
                    break;
                case 2:
                    profile.invalidPump2OffVal = status;
                    ctrl.peakProfiles[0].invalidPump2OffVal = status;
                    break;
                case 3:
                    profile.invalidPump3OffVal = status;
                    ctrl.peakProfiles[0].invalidPump3OffVal = status;
                    break;
                case 4:
                    profile.invalidPump4OffVal = status;
                    ctrl.peakProfiles[0].invalidPump4OffVal = status;
                    break;
            }
            profile.profileOffError = status;
            ctrl.peakProfiles[0].profileOffError = status;
        } else if (!isOffField) {
            switch (idx) {
                case 0:
                    profile.invalidPump0OnVal = status;
                    ctrl.peakProfiles[0].invalidPump0OnVal = status;
                    break;
                case 1:
                    profile.invalidPump1OnVal = status;
                    ctrl.peakProfiles[0].invalidPump1OnVal = status;
                    break;
                case 2:
                    profile.invalidPump2OnVal = status;
                    ctrl.peakProfiles[0].invalidPump2OnVal = status;
                    break;
                case 3:
                    profile.invalidPump3OnVal = status;
                    ctrl.peakProfiles[0].invalidPump3OnVal = status;
                    break;
                case 4:
                    profile.invalidPump4OnVal = status;
                    ctrl.peakProfiles[0].invalidPump4OnVal = status;
                    break;
            }
            profile.profileOnError = status;
            ctrl.peakProfiles[0].profileOnError = status;
        }
    };

    // for Non-offPeak setpoints
    // WsDevices individual setpoints save function
    ctrl.onChangePumpLimitNOP = function (idx, isOffField) {
        if (idx > -1) {
            var patchPath = undefined;
            var oldPumpOffVal = undefined;
            var oldPumpOnVal = undefined;
            if (isOffField) {
                // OFF field value
                //var curPumpOffVal = ctrl.destPumpArray[idx].pumpOffVal;
                var pumpPrefixLabel = ctrl.destPumpArray[idx].positionName;
                patchPath = undefined;
                oldPumpOffVal = undefined;
                switch (pumpPrefixLabel) {
                    case LEAD:
                        patchPath = 'LeadPumpOff';
                        oldPumpOffVal = ctrl.previousTwParameter.leadPumpOff;
                        break;
                    case LAG:
                        patchPath = 'LagPumpOff';
                        oldPumpOffVal = ctrl.previousTwParameter.lagPumpOff;
                        break;
                    case LAG2:
                        patchPath = 'Lag2PumpOff';
                        oldPumpOffVal = ctrl.previousTwParameter.lag2PumpOff;
                        break;
                    case LAG3:
                        patchPath = 'Lag3PumpOff';
                        oldPumpOffVal = ctrl.previousTwParameter.lag3PumpOff;
                        break;
                    case LAG4:
                        patchPath = 'Lag4PumpOff';
                        oldPumpOffVal = ctrl.previousTwParameter.lag4PumpOff;
                        break;
                    default:
                }
            } else if (!isOffField) {
                //ON field Value
                //var curPumpOnVal = ctrl.destPumpArray[idx].pumpOnVal;
                var _pumpPrefixLabel = ctrl.destPumpArray[idx].positionName;
                patchPath = undefined;
                oldPumpOnVal = undefined;
                switch (_pumpPrefixLabel) {
                    case LEAD:
                        patchPath = 'LeadPumpOn';
                        oldPumpOnVal = ctrl.previousTwParameter.leadPumpOn;
                        break;
                    case LAG:
                        patchPath = 'LagPumpOn';
                        oldPumpOnVal = ctrl.previousTwParameter.lagPumpOn;
                        break;
                    case LAG2:
                        patchPath = 'Lag2PumpOn';
                        oldPumpOnVal = ctrl.previousTwParameter.lag2PumpOn;
                        break;
                    case LAG3:
                        patchPath = 'Lag3PumpOn';
                        oldPumpOnVal = ctrl.previousTwParameter.lag3PumpOn;
                        break;
                    case LAG4:
                        patchPath = 'Lag4PumpOn';
                        oldPumpOnVal = ctrl.previousTwParameter.lag4PumpOn;
                        break;
                    default:
                }
            }
            // if PumpOffVal is not valid (i.e., within allowed limits), then revert back to original value.
            var isValid = void 0;
            if (ctrl.pumpTypeUp) {
                isValid = isOffField ? ctrl.isValidOffPumpLimitPumpTypeUp_NOP(idx) : ctrl.isValidOnPumpLimitPumpTypeUp_NOP(idx);
            } else {
                isValid = isOffField ? ctrl.isValidOffPumpLimitPumpTypeDown_NOP(idx) : ctrl.isValidOnPumpLimitPumpTypeDown_NOP(idx);
            }
            if (!isValid) {
                if (isOffField) {
                    ctrl.destPumpArray[idx].pumpOffVal = oldPumpOffVal;
                    ctrl.offError = false;
                } else {
                    ctrl.destPumpArray[idx].pumpOnVal = oldPumpOnVal;
                    ctrl.onError = false;
                }
                resetAllInvalidValues_NOP();
                return;
            }

            //if item exists in the propPatches, then remove it.
            angular.forEach(ctrl.propPatches, function (item, index) {
                if (item.key == patchPath) ctrl.propPatches.splice(index, 1);
            });

            //actual patch logic, making wepapi call
            if (isOffField) {
                var curPumpOffVal = ctrl.destPumpArray[idx].pumpOffVal;
                if (oldPumpOffVal != curPumpOffVal) {
                    ctrl.isDirty = true;
                    tankAndWellService.tabPopupWarningOn = true;

                    //add new patch
                    ctrl.propPatches.push({
                        key: patchPath, value: curPumpOffVal
                    });
                }
            } else if (!isOffField) {
                var curPumpOnVal = ctrl.destPumpArray[idx].pumpOnVal;
                if (oldPumpOnVal != curPumpOnVal) {
                    ctrl.isDirty = true;
                    tankAndWellService.tabPopupWarningOn = true;

                    //add new patch
                    ctrl.propPatches.push({
                        key: patchPath, value: curPumpOnVal
                    });
                }
            }
        }
    };

    ctrl.updateNOP = function () {
        if (ctrl.propPatches.length > 0) {
            ctrl.viewLoading = true;
            var patches = { op: 'replace', patchColl: ctrl.propPatches };
            tankAndWellService.UpdateSetPointsSetupNOP(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, patches).then(function (resp) {
                updateParameter(resp.data);

                //update pumps' array with latest values
                updatePumpArray();

                //load slider's options for each pump
                for (var j = 0; j < ctrl.destPumpArray.length; j++) {
                    ctrl.destPumpArray[j].options = loadPumpSliderOptions_NOP(getPumpPositionIndex(ctrl.twBasic, ctrl.destPumpArray[j].pumpId));
                }

                ctrl.isDirty = false;
                ctrl.editModeNOP = false;
                ctrl.offError = false;
                ctrl.onError = false;
                ctrl.propPatches = [];
                tankAndWellService.tabPopupWarningOn = false;
                ctrl.viewLoading = false;
                $scope.alerts = [];
            }, function (resp) {
                //console.log(resp);
                //display error message
                var errormsg = "Your selections are not saved. Please try again."; //TODO: translate the text, after it is approved
                $scope.alerts = [];
                $scope.alerts.push({ msg: errormsg, type: "danger" });

                ctrl.viewLoading = false;
            });
        }
    };

    // this function is used for updating profile name (or) delete profile
    //TODO: this method is not used for name save any longer
    var deleteProfile_OP = function deleteProfile_OP(profile, path) {
        if (profile.profileId != -1 && (profile.profileId == ctrl.editModeIndex || path == 'isDeleted')) {

            //if profile name is not valid, then DO NOT PROCEED.
            if (!ctrl.isValidProfileName_OP(profile)) {
                if (path === "name") {
                    //rollback to prev name and local properties
                    profile.name = profile.prevProfileName;
                    initLocalPropertiesOnProfile_OP(profile);
                }
                return;
            };

            var patch = { op: 'replace', path: path, value: profile[path] };
            tankAndWellService.PatchProfile(profile.profileId, patch).then(function (resp) {
                //console.log(resp.data);
                initLocalPropertiesOnProfile_OP(profile);
            }, function (resp) {// console.log(resp);
            });
        }
    };

    //off-peak setpoints
    //disable the pump from turn on/off based on setpoint values
    ctrl.disablePumpUpPumpOnVal_OP = function (pumpLevel, profile, isPeakProfile) {
        pumpLevel.on = -999; //disable the pump from turn on/off based on setpoint values
        pumpLevel.ignoreValidation = true;
        profile.isDirty = true;
        //ctrl.isOutsideVisualLimits = true;

        if (!isPeakProfile) {
            var thisProfileIdx = ctrl.offPeakProfiles.findIndex(function (x) {
                return x.profileId == profile.profileId;
            });
            if (thisProfileIdx > -1) {
                ctrl.offPeakProfiles[thisProfileIdx].isDirty = true;
            }
        } else {
            if (profile.profileId == ctrl.peakProfiles[0].profileId) {
                ctrl.peakProfiles[0].isDirty = true;
            }
        }
    };

    // non-offpeak setpoints
    //disable the pump from turn on/off based on setpoint values
    ctrl.disablePumpUpPumpOnValNOP = function (pumpIndex) {
        ctrl.destPumpArray[pumpIndex].pumpOnVal = -999; //disable the pump from turn on/off based on setpoint values
        ctrl.destPumpArray[pumpIndex].ignoreValidation = true;
        //ctrl.isOutsideVisualLimits = true;

        ctrl.onChangePumpLimitNOP(pumpIndex, false);
    };

    //off-peak setpoints
    //disable the pump from turn on/off based on setpoint values
    ctrl.disablePumpDownPumpOnVal_OP = function (pumpLevel, profile, isPeakProfile) {
        pumpLevel.on = 9999; //disable the pump from turn on/off based on setpoint values
        pumpLevel.ignoreValidation = true;
        profile.isDirty = true;
        //ctrl.isOutsideVisualLimits = true;

        if (!isPeakProfile) {
            var thisProfileIdx = ctrl.offPeakProfiles.findIndex(function (x) {
                return x.profileId == profile.profileId;
            });
            if (thisProfileIdx > -1) {
                ctrl.offPeakProfiles[thisProfileIdx].isDirty = true;
            }
        } else {
            if (profile.profileId == ctrl.peakProfiles[0].profileId) {
                ctrl.peakProfiles[0].isDirty = true;
            }
        }
    };

    // non-offpeak setpoints
    //disable the pump from turn on/off based on setpoint values
    ctrl.disablePumpDownPumpOnValNOP = function (pumpIndex) {
        ctrl.destPumpArray[pumpIndex].pumpOnVal = 9999; //disable the pump from turn on/off based on setpoint values
        ctrl.destPumpArray[pumpIndex].ignoreValidation = true;
        //ctrl.isOutsideVisualLimits = true;

        savePumpLimit_NOP(pumpIndex, false);
    };

    // for Non-offPeak setpoints
    // WsDevices individual setpoints save function
    var savePumpLimit_NOP = function savePumpLimit_NOP(idx, isOffField) {
        if (idx > -1) {
            var patchPath = undefined;
            var oldPumpOffVal = undefined;
            var oldPumpOnVal = undefined;
            if (isOffField) {
                var curPumpOffVal = ctrl.destPumpArray[idx].pumpOffVal;
                var pumpPrefixLabel = ctrl.destPumpArray[idx].positionName;
                patchPath = undefined;
                oldPumpOffVal = undefined;
                switch (pumpPrefixLabel) {
                    case LEAD:
                        patchPath = 'LeadPumpOff';
                        oldPumpOffVal = ctrl.previousTwParameter.leadPumpOff;
                        break;
                    case LAG:
                        patchPath = 'LagPumpOff';
                        oldPumpOffVal = ctrl.previousTwParameter.lagPumpOff;
                        break;
                    case LAG2:
                        patchPath = 'Lag2PumpOff';
                        oldPumpOffVal = ctrl.previousTwParameter.lag2PumpOff;
                        break;
                    case LAG3:
                        patchPath = 'Lag3PumpOff';
                        oldPumpOffVal = ctrl.previousTwParameter.lag3PumpOff;
                        break;
                    case LAG4:
                        patchPath = 'Lag4PumpOff';
                        oldPumpOffVal = ctrl.previousTwParameter.lag4PumpOff;
                        break;
                    default:
                }
            } else if (!isOffField) {
                var curPumpOnVal = ctrl.destPumpArray[idx].pumpOnVal;
                var _pumpPrefixLabel2 = ctrl.destPumpArray[idx].positionName;
                patchPath = undefined;
                oldPumpOnVal = undefined;
                switch (_pumpPrefixLabel2) {
                    case LEAD:
                        patchPath = 'LeadPumpOn';
                        oldPumpOnVal = ctrl.previousTwParameter.leadPumpOn;
                        break;
                    case LAG:
                        patchPath = 'LagPumpOn';
                        oldPumpOnVal = ctrl.previousTwParameter.lagPumpOn;
                        break;
                    case LAG2:
                        patchPath = 'Lag2PumpOn';
                        oldPumpOnVal = ctrl.previousTwParameter.lag2PumpOn;
                        break;
                    case LAG3:
                        patchPath = 'Lag3PumpOn';
                        oldPumpOnVal = ctrl.previousTwParameter.lag3PumpOn;
                        break;
                    case LAG4:
                        patchPath = 'Lag4PumpOn';
                        oldPumpOnVal = ctrl.previousTwParameter.lag4PumpOn;
                        break;
                    default:
                }
            }
            // if PumpOffVal is not valid (i.e., within allowed limits), then revert back to original value.
            var isValid = void 0;
            if (ctrl.pumpTypeUp) {
                isValid = isOffField ? ctrl.isValidOffPumpLimitPumpTypeUp_NOP(idx) : ctrl.isValidOnPumpLimitPumpTypeUp_NOP(idx);
            } else {
                isValid = isOffField ? ctrl.isValidOffPumpLimitPumpTypeDown_NOP(idx) : ctrl.isValidOnPumpLimitPumpTypeDown_NOP(idx);
            }
            if (!isValid) {
                if (isOffField) {
                    ctrl.destPumpArray[idx].pumpOffVal = oldPumpOffVal;
                    ctrl.offError = false;
                } else {
                    ctrl.destPumpArray[idx].pumpOnVal = oldPumpOnVal;
                    ctrl.onError = false;
                }
                resetAllInvalidValues_NOP();
                return;
            }
            //actual patch logic, making wepapi call
            if (isOffField) {
                if (oldPumpOffVal != curPumpOffVal) {
                    var patch = { op: 'replace', path: patchPath, value: curPumpOffVal };
                    tankAndWellService.PatchSetPointsSetup(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, patch).then(function (resp) {
                        updateParameter(resp.data);
                        //update slider value
                        ctrl.destPumpArray[idx].sliderOffVal = curPumpOffVal;
                    }, function (resp) {//console.log(resp);
                    });
                }
            } else if (!isOffField) {
                if (oldPumpOnVal != curPumpOnVal) {
                    var _patch = { op: 'replace', path: patchPath, value: curPumpOnVal };
                    tankAndWellService.PatchSetPointsSetup(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, _patch).then(function (resp) {
                        updateParameter(resp.data);
                        //udpate slider value
                        ctrl.destPumpArray[idx].sliderOnVal = curPumpOnVal;
                    }, function (resp) {//console.log(resp);
                    });
                }
            }
        }
    };

    var updateProfilesPumpType_OP = function updateProfilesPumpType_OP() {
        //first update pumpType on Peak/Normal profile
        ctrl.peakProfiles[0].pumpTypeUp = getPumpTypeByProfile_OP(ctrl.peakProfiles[0]);

        var index = 0;
        ctrl.offPeakProfiles.forEach(function (profile) {
            profile.index = index;
            index++;
            //determine given profile is PumpUp or PumpDown
            profile.pumpTypeUp = getPumpTypeByProfile_OP(profile); // True: PumpUp, False: PumpDown
        });
    };

    var updateProfilePumpType_OP = function updateProfilePumpType_OP(profile) {
        //if Peak/Normal Setpoints profile, then call its own method
        if (profile.profileId == ctrl.peakProfiles[0].profileId) {
            updateProfilePumpType_peak_OP(profile);
            return;
        }

        //update pumpUp/Down based on new setpoints elections
        var thisProfileIdx = ctrl.offPeakProfiles.findIndex(function (x) {
            return x.profileId == profile.profileId;
        });
        if (thisProfileIdx > -1) {
            //determine given profile is PumpUp or PumpDown
            profile.pumpTypeUp = getPumpTypeByProfile_OP(profile); // True: PumpUp, False: PumpDown
            ctrl.offPeakProfiles[thisProfileIdx].pumpTypeUp = profile.pumpTypeUp;
        }
    };

    var updateProfilePumpType_peak_OP = function updateProfilePumpType_peak_OP(profile) {
        //update pumpUp/Down based on new setpoints elections
        if (profile.profileId == ctrl.peakProfiles[0].profileId) {
            //determine given profile is PumpUp or PumpDown
            profile.pumpTypeUp = getPumpTypeByProfile_OP(profile); // True: PumpUp, False: PumpDown
            ctrl.peakProfiles[0].pumpTypeUp = profile.pumpTypeUp;
        }
    };

    var updateIgnoreValidation_OP = function updateIgnoreValidation_OP(profile) {
        //update setpoints ignoreValidation property if it has -999 as pumpOn value
        //if value is -999 means just ignore the pump as it is disabled
        for (var i = 0; i < ctrl.pumpsCount; i++) {
            if (profile.wsLevels[i].on == -999) {
                profile.wsLevels[i].ignoreValidation = true;
            }
        };
    };

    //this method could be used to validate all the pumps' setpoints or specific pump setpoints based on whether pumpIdx and isOn is passed or not
    ctrl.validateProfile_OP = function (profile, pumpIdx, isOn) {
        //if it is peak/Normal setpoints profile
        if (profile.profileId == ctrl.peakProfiles[0].profileId) {
            return validateProfile_peak_OP(profile, pumpIdx, isOn);
        }

        //validate whether all the setpoints are valid
        var isValid = true;

        //validate profile name first
        isValid = ctrl.isValidProfileName_OP(profile);

        //update setpoints ignoreValidation property if it has -ve pumpOn value
        updateIgnoreValidation_OP(profile);

        //update pumpUp/Down based on new setpoints elections
        updateProfilePumpType_OP(profile);

        //validate whether profile is dirty
        processIsDirty_OP(profile);

        // determine whether we need to validate specific value ON or OFF
        var onOrOff = -1; // -1: None, 1: ON, 2: OFF
        if (angular.isDefined(isOn)) {
            if (isOn) onOrOff = 1;else onOrOff = 2;
        }

        //validate all setpoints
        for (var k = 0; k < ctrl.pumpsCount && isValid; k++) {
            //only validate current pump values if pumpIdx > -1
            if (pumpIdx > -1 && pumpIdx != k) continue;

            if (profile.pumpTypeUp) {
                if (onOrOff == -1 || onOrOff == 2) {
                    isValid = isValidPumpOffLimitU_OP(k, true, profile);
                }
                if (onOrOff == -1 || onOrOff == 1) {
                    isValid = isValidPumpOnLimitU_OP(k, false, profile);
                }
            } else {
                if (onOrOff == -1 || onOrOff == 2) {
                    isValid = isValidPumpOffLimitD_OP(k, true, profile);
                }
                if (onOrOff == -1 || onOrOff == 1) {
                    isValid = isValidPumpOnLimitD_OP(k, false, profile);
                }
            }
        }

        //update given profile's isValid property
        var thisProfileIdx = ctrl.offPeakProfiles.findIndex(function (x) {
            return x.profileId == profile.profileId;
        });
        if (thisProfileIdx > -1) {
            profile.isValid = isValid;
            ctrl.offPeakProfiles[thisProfileIdx].isValid = profile.isValid;
        }

        return isValid;
    };

    //this method could be used to validate all the pumps' setpoints or specific pump setpoints based on whether pumpIdx and isOn is passed or not
    var validateProfile_peak_OP = function validateProfile_peak_OP(profile, pumpIdx, isOn) {
        //validate whether all the setpoints are valid
        var isValid = true;

        //update setpoints ignoreValidation property if it has -ve pumpOn value
        updateIgnoreValidation_OP(profile);

        //update pumpUp/Down based on new setpoints elections
        updateProfilePumpType_OP(profile);

        //validate whether profile is dirty
        processIsDirty_OP(profile);

        // determine whether we need to validate specific value ON or OFF
        var onOrOff = -1; // -1: None, 1: ON, 2: OFF
        if (angular.isDefined(isOn)) {
            if (isOn) onOrOff = 1;else onOrOff = 2;
        }

        //validate all setpoints
        for (var k = 0; k < ctrl.pumpsCount && isValid; k++) {
            //only validate current pump values if pumpIdx > -1
            if (pumpIdx > -1 && pumpIdx != k) continue;

            if (profile.pumpTypeUp) {
                if (onOrOff == -1 || onOrOff == 2) {
                    isValid = isValidPumpOffLimitU_OP(k, true, profile);
                }
                if (onOrOff == -1 || onOrOff == 1) {
                    isValid = isValidPumpOnLimitU_OP(k, false, profile);
                }
            } else {
                if (onOrOff == -1 || onOrOff == 2) {
                    isValid = isValidPumpOffLimitD_OP(k, true, profile);
                }
                if (onOrOff == -1 || onOrOff == 1) {
                    isValid = isValidPumpOnLimitD_OP(k, false, profile);
                }
            }
        }
        //update given profile's isValid property
        profile.isValid = isValid;
        ctrl.peakProfiles[0].isValid = profile.isValid;

        return isValid;
    };

    var updateProfileLoading = function updateProfileLoading(profile, status) {
        if (profile.profileId == ctrl.peakProfiles[0].profileId) {
            ctrl.peakProfiles[0].loading = status;
            profile.loading = status;
        } else {
            var thisProfileIdx = ctrl.offPeakProfiles.findIndex(function (x) {
                return x.profileId == profile.profileId;
            });
            if (thisProfileIdx > -1) {
                ctrl.offPeakProfiles[thisProfileIdx].loading = status;
                profile.loading = status;
            }
        }
    };

    //for add profile operation only
    ctrl.postProfile_OP = function (profile) {
        if (ctrl.addMode) {
            // add mode save operation
            $timeout(function () {
                updateProfileLoading(profile, true);
            });

            //if profile name is not valid, then DO NOT PROCEED.
            if (!ctrl.isValidProfileName_OP(profile)) return;

            //add/post the profile on the backend
            tankAndWellService.PostProfile(ctrl.accountInfo.customerId, profile).then(function (resp) {
                //console.log(resp.data);
                $timeout(function () {
                    ctrl.addMode = false;
                    ctrl.editModeIndex = -1;
                    loadProfiles_OP(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId);
                    updateProfileLoading(profile, false);
                });
            }, function (resp) {
                //console.log(resp); 
                updateProfileLoading(profile, false);
            });
        }
    };

    ctrl.updateProfile_OP = function (profile) {
        if (ctrl.editModeIndex == profile.profileId) {
            //Edit mode save operation
            $timeout(function () {
                updateProfileLoading(profile, true);
            });
            //validate all the setpoints
            if (!ctrl.validateProfile_OP(profile)) {
                updateProfileLoading(profile, false);
                return; // DO NOT PROCEED.
            }

            //validate profile name, if it is NOT peak/Normal setpoints profile
            if (profile.profileId != ctrl.peakProfiles[0].profileId) {
                if (!ctrl.isValidProfileName_OP(profile)) {
                    updateProfileLoading(profile, false);
                    return; // DO NOT PROCEED.
                }
            }

            //update the profile on backend
            tankAndWellService.UpdateProfile(ctrl.accountInfo.customerId, profile).then(function (resp) {
                //console.log(resp.data);
                $timeout(function () {
                    ctrl.addMode = false;
                    ctrl.editModeIndex = -1;
                    loadProfiles_OP(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId);
                    updateProfileLoading(profile, false);
                });
            }, function (resp) {
                //console.log(resp); 
                updateProfileLoading(profile, false);
            });
        }
    };

    // cancel add profile operation
    ctrl.addCancel_OP = function (profile) {
        ctrl.offPeakProfiles = angular.copy(ctrl.previousOffPeakProfiles);
        ctrl.addMode = false;
        ctrl.editModeIndex = -1;
        clearNewProfile_OP();
    };

    // cancel edit profile operation
    ctrl.editCancel_OP = function (profile) {
        //if profile is peak/Normal setpoints profile
        if (profile.profileId == ctrl.peakProfiles[0].profileId) {
            ctrl.peakProfiles = angular.copy(ctrl.previousPeakProfiles);
        }
        ctrl.offPeakProfiles = angular.copy(ctrl.previousOffPeakProfiles);
        ctrl.editModeIndex = -1;
        updateProfilesPumpType_OP();
        processIsOutsideVisualLimits_OP();
    };

    ctrl.addNewProfile_OP = function () {
        //create new profile with levels, whose Ids equal to -1
        var newProfile = angular.copy(ctrl.peakProfiles[0]);
        newProfile.name = "Off Peak Profile";
        newProfile.profileId = -1;
        newProfile.isDefault = false;
        newProfile.wsLevels.forEach(function (level) {
            level.levelId = -1;
            level.profileId = -1;
        });
        //determine newProfile is PumpUp or PumpDown
        newProfile.pumpTypeUp = getPumpTypeByProfile_OP(newProfile); // True: PumpUp, False: PumpDown

        initLocalPropertiesOnProfile_OP(newProfile);

        ctrl.addMode = true;
        ctrl.editModeIndex = -1;
        ctrl.offPeakProfiles.push(newProfile);
    };

    var clearNewProfile_OP = function clearNewProfile_OP() {
        var index = ctrl.offPeakProfiles.findIndex(function (x) {
            return x.profileId === -1;
        });
        if (index > -1) {
            ctrl.offPeakProfiles.splice(index, 1); //remove empty profile
            ctrl.addMode = false;
        }
    };

    // this function is called when user is trying to delete the profile
    ctrl.openCommonModal = function (profile) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            //this.tmpConfirmMessageA =  this.translation.text.READONLY_ACCOUNT_MESSAGE_A + item.fullName  + ` ${this.translation.text.TO} ` + this.translation.text[`USER_ROLE_${item.accessLevel}`];
            this.tmpConfirmMessageA = this.translation.text.DELETE + " " + "Tank Profile";
            //this.tmpConfirmMessageB =   this.translation.text.DELETE_ACCOUNT_MESSAGE_C ;
            this.ok = function () {
                $uibModalInstance.close(profile);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function (prof) {
            prof.isDeleted = true;
            deleteProfile_OP(prof, 'isDeleted');
        }, function () {
            // cancel button
        });
    };

    ctrl.isValidProfileName_OP = function (profile) {
        if (!profile.name) {
            if (profile.pumpTypeUp) {
                ctrl.invalidPumpOffValTooltip = ctrl.translation.text.PROFILE_NAME_REQUIRED;
                profile.profileOffError = true;
            } else {
                ctrl.invalidPumpOnValTooltip = ctrl.translation.text.PROFILE_NAME_REQUIRED;
                profile.profileOnError = true;
            }

            profile.validName = false;
        } else {
            initLocalPropertiesOnProfile_OP(profile);
            ctrl.invalidPumpOffValTooltip = "";
            ctrl.invalidPumpOnValTooltip = "";
        }

        return profile.validName;
    };
    var getPumpTypeByProfile_OP = function getPumpTypeByProfile_OP(profile) {
        //determine given profile is PumpUp or PumpDown
        // pumpType => true: PumpUp, false: PumpDown 
        //NOTE: Ignore the pumps that are Disabled
        //      pumpUp disabled ON value = -999
        //      pumpDown disabled on value = 9999 
        var validPumpCount = 0;
        var pumpUpCount = 0;
        var firstPumpUp = false;
        for (var i = 0; i < ctrl.pumpsCount; i++) {
            //if pump is NOT disabled
            if (+profile.wsLevels[i].on != -999 && +profile.wsLevels[i].on != 9999) {
                if (+profile.wsLevels[i].off > +profile.wsLevels[i].on) {
                    if (validPumpCount == 0) firstPumpUp = true;
                    pumpUpCount++;
                } else if (validPumpCount == 0) {
                    firstPumpUp = false;
                }

                validPumpCount++;
            }
        }

        var majority = validPumpCount / 2;
        if (pumpUpCount > majority) return true;else if (pumpUpCount == majority) return firstPumpUp;else return false;
    };

    var getPumpTypeByParameter = function getPumpTypeByParameter(twParameter) {
        // pumpType => true: PumpUp, false: PumpDown 
        //NOTE: Ignore the pumps that are Disabled
        //      pumpUp disabled ON value = -999
        //      pumpDown disabled on value = 9999 
        var validPumpCount = 0;
        var pumpUpCount = 0;
        var firstPumpUp = false;

        if (+twParameter.leadPumpOn != -999 && +twParameter.leadPumpOn != 9999) {
            if (+twParameter.leadPumpOff > +twParameter.leadPumpOn) {
                pumpUpCount++;
                if (validPumpCount == 0) firstPumpUp = true;
                validPumpCount++;
            }
        } else if (+twParameter.lagPumpOff != -999 && +twParameter.lagPumpOn != 9999) {
            if (+twParameter.lagPumpOff > +twParameter.lagPumpOn) {
                pumpUpCount++;
                if (validPumpCount == 0) firstPumpUp = true;
                validPumpCount++;
            }
        } else if (+twParameter.lag2PumpOff != -999 && +twParameter.lag2PumpOn != 9999) {
            if (+twParameter.lag2PumpOff > +twParameter.lag2PumpOn) {
                pumpUpCount++;
                if (validPumpCount == 0) firstPumpUp = true;
                validPumpCount++;
            }
        } else if (twParameter.lag3PumpOff != -999 && twParameter.lag3PumpOn != 9999) {
            if (+twParameter.lag3PumpOff > +twParameter.lag3PumpOn) {
                pumpUpCount++;
                if (validPumpCount == 0) firstPumpUp = true;
                validPumpCount++;
            }
        } else if (twParameter.lag4PumpOff != -999 && twParameter.lag4PumpOn != 9999) {
            if (+twParameter.lag4PumpOff > +twParameter.lag4PumpOn) {
                pumpUpCount++;
                if (validPumpCount == 0) firstPumpUp = true;
                validPumpCount++;
            }
        }

        var majority = validPumpCount / 2;
        if (pumpUpCount > majority) return true;else if (pumpUpCount == majority) return firstPumpUp;else return false;
    };
    var processIsDirty_OP = function processIsDirty_OP(profile) {
        //if it is peak/Normal setpoints profile
        if (profile.profileId == ctrl.peakProfiles[0].profileId) {
            processIsDirty_peak_OP(profile);
            return;
        }

        //find whether profile is dirty
        var storedProfileIdx = ctrl.previousOffPeakProfiles.findIndex(function (x) {
            return x.profileId == profile.profileId;
        });
        if (storedProfileIdx > -1) {
            if (ctrl.previousOffPeakProfiles[storedProfileIdx].name != profile.name) {
                //profile name is dirty, 
                profile.isDirty = true;
                ctrl.offPeakProfiles[storedProfileIdx].isDirty = true;
                return; // no further action required
            } else {
                //loop thru all the setpoints to make sure any setpoint value is dirty

                for (var k = 0; k < ctrl.pumpsCount; k++) {
                    if (+ctrl.previousOffPeakProfiles[storedProfileIdx].wsLevels[k].off != +profile.wsLevels[k].off || +ctrl.previousOffPeakProfiles[storedProfileIdx].wsLevels[k].on != +profile.wsLevels[k].on) {
                        //profile is dirty
                        profile.isDirty = true;
                        ctrl.offPeakProfiles[storedProfileIdx].isDirty = true;
                        return; // no further action required
                    }
                }
            }
            // if we reached this point means, profile is NOT dirty
            profile.isDirty = false;
            ctrl.offPeakProfiles[storedProfileIdx].isDirty = false;
        }
    };

    var processIsDirty_peak_OP = function processIsDirty_peak_OP(profile) {
        //find whether profile is dirty
        //loop thru all the setpoints to make sure any setpoint value is dirty
        for (var k = 0; k < ctrl.pumpsCount; k++) {
            if (+ctrl.previousPeakProfiles[0].wsLevels[k].off != +profile.wsLevels[k].off || +ctrl.previousPeakProfiles[0].wsLevels[k].on != +profile.wsLevels[k].on) {
                //profile is dirty
                profile.isDirty = true;
                ctrl.peakProfiles[0].isDirty = true;
                return; // no further action required
            }
        }

        // if we reached this point means, profile is NOT dirty
        profile.isDirty = false;
        ctrl.peakProfiles[0].isDirty = false;
    };

    // for non-OffPeak setpoints
    // if valid pump exists, it returns value, otherwise -998; this number has been chosen as user may set -ve value as setpoint
    var findPrevPumpVal_NOP = function findPrevPumpVal_NOP(idx, off) {
        if (off) {
            //pumpOffVal is to be processed
            if (idx > 0) {
                for (var i = idx - 1; i >= 0; i--) {
                    if (!ctrl.destPumpArray[i].ignoreValidation) {
                        return +ctrl.destPumpArray[i].pumpOffVal;
                    }
                }
            }
        } else {
            //pumpOnVal is to be processed
            if (idx > 0) {
                for (var _i = idx - 1; _i >= 0; _i--) {
                    if (!ctrl.destPumpArray[_i].ignoreValidation) {
                        return +ctrl.destPumpArray[_i].pumpOnVal;
                    }
                }
            }
        }
        return -998; // no valid pump exists
    };

    // for non-OffPeak setpoints
    // if valid pump exists, it returns value, otherwise -998; this number has been chosen as user may set -ve value as setpoint
    var findNextPumpVal_NOP = function findNextPumpVal_NOP(idx, off) {
        if (off) {
            //pumpOffVal is to be processed
            //if (idx > 0) {
            for (var i = idx + 1; i < ctrl.pumpsCount; i++) {
                if (!ctrl.destPumpArray[i].ignoreValidation) {
                    return +ctrl.destPumpArray[i].pumpOffVal;
                }
            }

            //}
        } else {
            //pumpOnVal is to be processed
            //if (idx > 0) {
            for (var _i2 = idx + 1; _i2 < ctrl.pumpsCount; _i2++) {
                if (!ctrl.destPumpArray[_i2].ignoreValidation) {
                    return +ctrl.destPumpArray[_i2].pumpOnVal;
                }
            }

            //}
        }
        return -998; // no valid pump exists
    };

    //verify whether any setpoint is outside the visual limits
    var processIsOutsideVisualLimits_NOP = function processIsOutsideVisualLimits_NOP() {
        ctrl.isOutsideVisualLimits = false; //setting default value

        for (var i = 0; i < ctrl.pumpsCount; i++) {
            if (ctrl.pumpTypeUp) {
                //pump up
                if (+ctrl.destPumpArray[i].pumpOnVal !== -999 && (+ctrl.destPumpArray[i].pumpOffVal > ctrl.tank.tankTop || +ctrl.destPumpArray[i].pumpOffVal < ctrl.tank.tankBottom || +ctrl.destPumpArray[i].pumpOnVal > ctrl.tank.tankTop || +ctrl.destPumpArray[i].pumpOnVal < ctrl.tank.tankBottom)) {
                    ctrl.isOutsideVisualLimits = true;
                    return;
                }
            } else {
                //pump down
                if (+ctrl.destPumpArray[i].pumpOnVal !== 9999 && (+ctrl.destPumpArray[i].pumpOnVal > ctrl.tank.tankTop || +ctrl.destPumpArray[i].pumpOnVal < ctrl.tank.tankBottom || +ctrl.destPumpArray[i].pumpOffVal > ctrl.tank.tankTop || +ctrl.destPumpArray[i].pumpOffVal < ctrl.tank.tankBottom)) {
                    ctrl.isOutsideVisualLimits = true;
                    return;
                }
            }
        }
    };

    // Region Start => Non-OffPeak Pumps validation >> OLD Config
    ctrl.isValidOffPumpLimitPumpTypeUp_NOP = function (idx, isSlider) {
        //NOTE: -998 : represents there are NO valid pump exists

        var retVal = false;
        var itemUpperLimit = ctrl.tank.tankTop;
        var itemLowerLimit = ctrl.tank.tankBottom;
        var validAgainstPredecessor = false;
        var validAgainstSuccessor = false;
        var validAgainstOtherRow = false;
        //make sure the value of current pump is between predecessor and successor pumps (Lead >= Lag >= Lag2)
        //validate PumpOffVal (Upper Row)
        if (ctrl.twParameter.alternatorEnabled) {
            // compare against Predecessor item.
            if (idx > 0 && findPrevPumpVal_NOP(idx, true) > -998) {
                //all items except first item and should NOT be disabled pump
                var prevPumpOffVal = findPrevPumpVal_NOP(idx, true);
                validAgainstPredecessor = +prevPumpOffVal >= +ctrl.destPumpArray[idx].pumpOffVal;
                itemUpperLimit = prevPumpOffVal;
            } else {
                // if it is first item
                validAgainstPredecessor = true;
                itemUpperLimit = null; //this index value is largest setpoint
            }

            // compare against Successor item.
            if (idx + 1 < ctrl.pumpsCount && findNextPumpVal_NOP(idx, true) > -998) {
                //all items except last item
                var nextPumpOffVal = findNextPumpVal_NOP(idx, true);
                validAgainstSuccessor = +ctrl.destPumpArray[idx].pumpOffVal >= +nextPumpOffVal;
                itemLowerLimit = nextPumpOffVal;
            } else {
                // if it is last item
                validAgainstSuccessor = +ctrl.destPumpArray[idx].pumpOffVal > +ctrl.destPumpArray[idx].pumpOnVal; //TODO: figure out, I think OffVal should be > OnVal, never be equal
                itemLowerLimit = ctrl.destPumpArray[idx].pumpOnVal;
            }
        }
        validAgainstOtherRow = +ctrl.destPumpArray[idx].pumpOffVal > +ctrl.destPumpArray[idx].pumpOnVal;
        if (!validAgainstOtherRow && +itemLowerLimit < +ctrl.destPumpArray[idx].pumpOnVal) {
            itemLowerLimit = ctrl.destPumpArray[idx].pumpOnVal;
        }
        //PumpOFFVal error condition
        if (ctrl.twParameter.alternatorEnabled && validAgainstPredecessor && validAgainstSuccessor && validAgainstOtherRow || !ctrl.twParameter.alternatorEnabled && validAgainstOtherRow) {
            ctrl.invalidPumpOffValTooltip = "";
            setInvalidPumpVal_NOP(idx, true, false);
            ctrl.offError = false;
            retVal = true;
        } else {
            if (idx == 0) ctrl.invalidPumpOffValTooltip = '[Value should be greater than]' + ' ' + itemLowerLimit;else ctrl.invalidPumpOffValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;;
            setInvalidPumpVal_NOP(idx, true, true);
            ctrl.offError = true;
            retVal = false;
        }
        //verify whether any setpoint is outside the visual limits
        processIsOutsideVisualLimits_NOP();

        return retVal;
    };
    ctrl.isValidOnPumpLimitPumpTypeUp_NOP = function (idx, isSlider) {
        //NOTE: -998 : represents there are NO valid pump exists

        // if pump is disabled by sestting -999 as on value then set as valid.
        if (ctrl.destPumpArray[idx].pumpOnVal == -999) return true;

        var retVal = false;
        var itemUpperLimit = ctrl.tank.tankTop;
        var itemLowerLimit = ctrl.tank.tankBottom;
        var validAgainstPredecessor = false;
        var validAgainstSuccessor = false;
        var validAgainstOtherRow = false;
        //make sure the value of current pump is between predecessor and successor pumps (Lead >= Lag >= Lag2)
        //validate PumpOnVal (Lower Row)
        if (ctrl.twParameter.alternatorEnabled) {
            // compare against Predecessor item.
            if (idx > 0 && findPrevPumpVal_NOP(idx, false) > -998) {
                //all items except first item and should NOT be disabled pump
                var prevPumpOnVal = findPrevPumpVal_NOP(idx, false);
                validAgainstPredecessor = +prevPumpOnVal >= +ctrl.destPumpArray[idx].pumpOnVal;
                itemUpperLimit = prevPumpOnVal;
            } else {
                // if it is first item
                validAgainstPredecessor = +ctrl.destPumpArray[idx].pumpOnVal < +ctrl.destPumpArray[idx].pumpOffVal;
                itemUpperLimit = ctrl.destPumpArray[idx].pumpOffVal; //ctrl.tank.tankTop;
            }
            // compare against Successor item.
            if (idx + 1 < ctrl.pumpsCount && findNextPumpVal_NOP(idx, false) > -998) {
                //all items except last item
                var nextPumpOnVal = findNextPumpVal_NOP(idx, false);
                validAgainstSuccessor = +ctrl.destPumpArray[idx].pumpOnVal >= +nextPumpOnVal;
                itemLowerLimit = nextPumpOnVal;
            } else {
                // if it is last item
                validAgainstSuccessor = true; //ctrl.destPumpArray[idx].pumpOnVal < ctrl.destPumpArray[idx].pumpOffVal;
                itemLowerLimit = null; //this index value is smallest setpoint
            }
        }
        validAgainstOtherRow = +ctrl.destPumpArray[idx].pumpOnVal < +ctrl.destPumpArray[idx].pumpOffVal;
        if (!validAgainstOtherRow && +itemUpperLimit > +ctrl.destPumpArray[idx].pumpOffVal) {
            itemUpperLimit = ctrl.destPumpArray[idx].pumpOffVal;
        }
        //PumpONVal error condition
        if (ctrl.twParameter.alternatorEnabled && validAgainstPredecessor && validAgainstSuccessor && validAgainstOtherRow || !ctrl.twParameter.alternatorEnabled && validAgainstOtherRow) {
            ctrl.invalidPumpOnValTooltip = "";
            setInvalidPumpVal_NOP(idx, false, false);
            ctrl.onError = false;
            retVal = true;
        } else {
            if (idx + 1 == ctrl.pumpsCount) // if last item
                ctrl.invalidPumpOnValTooltip = '[Value should be less than]' + ' ' + itemUpperLimit;else ctrl.invalidPumpOnValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;
            ctrl.onError = true;
            setInvalidPumpVal_NOP(idx, false, true);
            retVal = false;
        }
        //verify whether any setpoint is outside the visual limits
        processIsOutsideVisualLimits_NOP();

        return retVal;
    };
    ctrl.isValidOffPumpLimitPumpTypeDown_NOP = function (idx, isSlider) {
        //NOTE: -998 : represents there are NO valid pump exists

        var retVal = false;
        // ctrl.setAllInvalidValues();
        var itemUpperLimit = ctrl.tank.tankTop;
        var itemLowerLimit = ctrl.tank.tankBottom;
        var validAgainstPredecessor = false;
        var validAgainstSuccessor = false;
        var validAgainstOtherRow = false;
        //validate PumpOnVal (Lower Row)

        if (ctrl.twParameter.alternatorEnabled) {
            // compare against Predecessor item.
            if (idx > 0 && findPrevPumpVal_NOP(idx, true) > -998) {
                //all items except first item and should NOT be disabled pump) 
                var prevPumpOffVal = findPrevPumpVal_NOP(idx, true);
                validAgainstPredecessor = +ctrl.destPumpArray[idx].pumpOffVal >= +prevPumpOffVal;
                itemLowerLimit = prevPumpOffVal;
            } else {
                // if it is first item
                validAgainstPredecessor = true;
                itemLowerLimit = null; //this index value is smallest setpoint
            }

            // compare against Successor item.
            if (idx + 1 < ctrl.pumpsCount && findNextPumpVal_NOP(idx, true) > -998) {
                //all items except last item
                var nextPumpOffVal = findNextPumpVal_NOP(idx, true);
                validAgainstSuccessor = +ctrl.destPumpArray[idx].pumpOffVal <= +nextPumpOffVal;
                itemUpperLimit = nextPumpOffVal;
            } else {
                // if it is last item
                validAgainstSuccessor = +ctrl.destPumpArray[idx].pumpOffVal < +ctrl.destPumpArray[idx].pumpOnVal;
                itemUpperLimit = ctrl.destPumpArray[idx].pumpOnVal;
            }
        }

        validAgainstOtherRow = +ctrl.destPumpArray[idx].pumpOffVal < +ctrl.destPumpArray[idx].pumpOnVal;
        if (!validAgainstOtherRow && +itemUpperLimit > +ctrl.destPumpArray[idx].pumpOnVal) {
            itemUpperLimit = ctrl.destPumpArray[idx].pumpOnVal;
        }
        //PumpOFFVal error condition
        if (ctrl.twParameter.alternatorEnabled && validAgainstPredecessor && validAgainstSuccessor && validAgainstOtherRow || !ctrl.twParameter.alternatorEnabled && validAgainstOtherRow) {
            ctrl.invalidPumpOffValTooltip = "";
            setInvalidPumpVal_NOP(idx, true, false);
            ctrl.offError = false;
            retVal = true;
        } else {
            if (idx == 0) ctrl.invalidPumpOffValTooltip = '[Value should be less than]' + ' ' + itemUpperLimit;else ctrl.invalidPumpOffValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;
            setInvalidPumpVal_NOP(idx, true, true);
            ctrl.offError = true;
            retVal = false;
        }
        //verify whether any setpoint is outside the visual limits
        processIsOutsideVisualLimits_NOP();

        return retVal;
    };
    ctrl.isValidOnPumpLimitPumpTypeDown_NOP = function (idx, isSlider) {
        //NOTE: -998 : represents there are NO valid pump exists

        var retVal = false;
        var itemUpperLimit = ctrl.tank.tankTop;
        var itemLowerLimit = ctrl.tank.tankBottom;
        var validAgainstPredecessor = false;
        var validAgainstSuccessor = false;
        var validAgainstOtherRow = false;
        //validate PumpOnVal (Upper ROW)
        if (ctrl.twParameter.alternatorEnabled) {
            // compare against Predecessor item.
            if (idx > 0 && findPrevPumpVal_NOP(idx, false) > -998) {
                //all items except first item and should NOT be disabled pump
                var prevPumpOnVal = findPrevPumpVal_NOP(idx, false);
                validAgainstPredecessor = +ctrl.destPumpArray[idx].pumpOnVal >= +prevPumpOnVal;
                itemLowerLimit = prevPumpOnVal;
            } else {
                // if it is first item
                validAgainstPredecessor = +ctrl.destPumpArray[idx].pumpOnVal > +ctrl.destPumpArray[idx].pumpOffVal;
                //ctrl.tankBottomMsg = true;
                itemLowerLimit = ctrl.destPumpArray[idx].pumpOffVal;
            }

            // compare against Successor item.
            if (idx + 1 < ctrl.pumpsCount && findNextPumpVal_NOP(idx, false) > -998) {
                //all items except last item
                var nextPumpOnVal = findNextPumpVal_NOP(idx, false);
                validAgainstSuccessor = +ctrl.destPumpArray[idx].pumpOnVal <= +nextPumpOnVal;
                itemUpperLimit = nextPumpOnVal;
            } else {
                // if it is last item
                validAgainstSuccessor = true;
                //ctrl.tankTopMsg = true; //TODO: why this line of code?????
                itemUpperLimit = null;
            }
        }

        validAgainstOtherRow = +ctrl.destPumpArray[idx].pumpOnVal > +ctrl.destPumpArray[idx].pumpOffVal;
        if (!validAgainstOtherRow && +itemLowerLimit < +ctrl.destPumpArray[idx].pumpOffVal) {
            itemLowerLimit = ctrl.destPumpArray[idx].pumpOffVal;
        }
        //PumpONVal error condition
        if (ctrl.twParameter.alternatorEnabled && validAgainstPredecessor && validAgainstSuccessor && validAgainstOtherRow || !ctrl.twParameter.alternatorEnabled && validAgainstOtherRow) {
            ctrl.invalidPumpOnValTooltip = "";
            setInvalidPumpVal_NOP(idx, false, false);
            ctrl.onError = false;
            retVal = true;
        } else {
            if (idx + 1 == ctrl.pumpsCount) //if last item
                ctrl.invalidPumpOnValTooltip = '[Value should be greater than]' + ' ' + itemLowerLimit;else ctrl.invalidPumpOnValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;
            ctrl.onError = true;
            setInvalidPumpVal_NOP(idx, false, true);
            retVal = false;
        }
        //verify whether any setpoint is outside the visual limits
        processIsOutsideVisualLimits_NOP();

        return retVal;
    };

    // Region End => Non-OffPeak Pumps validation >> OLD Config

    // Region Start => OffPeak Peak/Normal/default Pumps validation  >> NEW Config
    // for OffPeak setpoints
    // if valid pump exists, it returns value, otherwise -998; this number has been chosen as user may set -ve value as setpoint
    var findPrevPumpVal_OP = function findPrevPumpVal_OP(idx, off, profile) {
        if (off) {
            //off value is to be processed
            if (idx > 0) {
                for (var i = idx - 1; i >= 0; i--) {
                    if (!profile.wsLevels[i].ignoreValidation) {
                        return +profile.wsLevels[i].off;
                    }
                }
            }
        } else {
            //on value is to be processed
            if (idx > 0) {
                for (var _i3 = idx - 1; _i3 >= 0; _i3--) {
                    if (!profile.wsLevels[_i3].ignoreValidation) {
                        return +profile.wsLevels[_i3].on;
                    }
                }
            }
        }
        return -998; // no valid pump exists
    };

    // for OffPeak setpoints
    // if valid pump exists, it returns value, otherwise -998; this number has been chosen as user may set -ve value as setpoint
    var findNextPumpVal_OP = function findNextPumpVal_OP(idx, off, profile) {
        if (off) {
            // off value is to be processed
            //if (idx > 0) {
            for (var i = idx + 1; i < ctrl.pumpsCount; i++) {
                if (!profile.wsLevels[i].ignoreValidation) {
                    return +profile.wsLevels[i].off;
                }
            }

            //}
        } else {
            // on value is to be processed
            //if (idx > 0) {
            for (var _i4 = idx + 1; _i4 < ctrl.pumpsCount; _i4++) {
                if (!profile.wsLevels[_i4].ignoreValidation) {
                    return +profile.wsLevels[_i4].on;
                }
            }

            //}
        }
        return -998; // no valid pump exists
    };

    //off-peak setpoints
    //verify whether any setpoint is outside the visual limits
    var processIsOutsideVisualLimits_OP = function processIsOutsideVisualLimits_OP() {
        ctrl.isOutsideVisualLimits = false; //setting default value

        //NOTE:unary plus (+) operator precedes its operand and evaluates to its operand but attempts to convert it into a number, if it isn't already
        //process peak setpoints
        for (var j = 0; j < ctrl.pumpsCount; j++) {
            if (ctrl.peakProfiles[0].pumpTypeUp) {
                //pump up
                if (+ctrl.peakProfiles[0].wsLevels[j].on !== -999 && (+ctrl.peakProfiles[0].wsLevels[j].off > +ctrl.tank.tankTop || +ctrl.peakProfiles[0].wsLevels[j].off < +ctrl.tank.tankBottom || +ctrl.peakProfiles[0].wsLevels[j].on > +ctrl.tank.tankTop || +ctrl.peakProfiles[0].wsLevels[j].on < +ctrl.tank.tankBottom)) {
                    ctrl.isOutsideVisualLimits = true;
                    return;
                }
            } else {
                //pump down
                if (+ctrl.peakProfiles[0].wsLevels[j].on !== 9999 && (+ctrl.peakProfiles[0].wsLevels[j].on > +ctrl.tank.tankTop || +ctrl.peakProfiles[0].wsLevels[j].on < +ctrl.tank.tankBottom || +ctrl.peakProfiles[0].wsLevels[j].off > +ctrl.tank.tankTop || +ctrl.peakProfiles[0].wsLevels[j].off < +ctrl.tank.tankBottom)) {
                    ctrl.isOutsideVisualLimits = true;
                    return;
                }
            }
        }

        //process off-peak setpoints
        for (var i = 0; i < ctrl.offPeakProfiles.length; i++) {
            for (var _j = 0; _j < ctrl.pumpsCount; _j++) {
                if (ctrl.offPeakProfiles[i].pumpTypeUp) {
                    //pump up
                    if (+ctrl.offPeakProfiles[i].wsLevels[_j].on !== -999 && (+ctrl.offPeakProfiles[i].wsLevels[_j].off > +ctrl.tank.tankTop || +ctrl.offPeakProfiles[i].wsLevels[_j].off < +ctrl.tank.tankBottom || +ctrl.offPeakProfiles[i].wsLevels[_j].on > +ctrl.tank.tankTop || +ctrl.offPeakProfiles[i].wsLevels[_j].on < +ctrl.tank.tankBottom)) {
                        ctrl.isOutsideVisualLimits = true;
                        return;
                    }
                } else {
                    //pump down
                    if (+ctrl.offPeakProfiles[i].wsLevels[_j].on !== 9999 && (+ctrl.offPeakProfiles[i].wsLevels[_j].on > +ctrl.tank.tankTop || +ctrl.offPeakProfiles[i].wsLevels[_j].on < +ctrl.tank.tankBottomp || +ctrl.offPeakProfiles[i].wsLevels[_j].off > +ctrl.tank.tankTop || +ctrl.offPeakProfiles[i].wsLevels[_j].off < +ctrl.tank.tankBottom)) {
                        ctrl.isOutsideVisualLimits = true;
                        return;
                    }
                }
            }
        }
    };

    // Region End => OffPeak Peak/Normal Pumps validation  >> NEW Config

    var updateProfilePumpTypeAndIsDirty_OP = function updateProfilePumpTypeAndIsDirty_OP(idx, isOffField, profile) {
        //update pumpUp/Down based on new setpoints elections
        //if it is peak/Normal setpoints profile
        if (profile.profileId == ctrl.peakProfiles[0].profileId) {
            profile.pumpTypeUp = getPumpTypeByProfile_OP(profile); // True: PumpUp, False: PumpDown
            ctrl.peakProfiles[0].pumpTypeUp = profile.pumpTypeUp;

            if (+ctrl.previousPeakProfiles[0].wsLevels[idx].on != +profile.wsLevels[idx].on || +ctrl.previousPeakProfiles[0].wsLevels[idx].off != +profile.wsLevels[idx].off) {
                profile.isDirty = true;
                ctrl.peakProfiles[0].isDirty = true;
            }
        } else {
            //regular offpeak setpoints profile
            var thisProfileIdx = ctrl.offPeakProfiles.findIndex(function (x) {
                return x.profileId == profile.profileId;
            });
            if (thisProfileIdx > -1) {
                //determine given profile is PumpUp or PumpDown
                profile.pumpTypeUp = getPumpTypeByProfile_OP(profile); // True: PumpUp, False: PumpDown
                ctrl.offPeakProfiles[thisProfileIdx].pumpTypeUp = profile.pumpTypeUp;

                //find whether profile is dirty
                var storedProfileIdx = ctrl.previousOffPeakProfiles.findIndex(function (x) {
                    return x.profileId == profile.profileId;
                });
                if (storedProfileIdx > -1 && (+ctrl.previousOffPeakProfiles[storedProfileIdx].wsLevels[idx].on != +profile.wsLevels[idx].on || +ctrl.previousOffPeakProfiles[storedProfileIdx].wsLevels[idx].off != +profile.wsLevels[idx].off)) {
                    profile.isDirty = true;
                    ctrl.offPeakProfiles[thisProfileIdx].isDirty = true;
                }
            }
        }
    };

    // Region Start => NEW OffPeak Pumps validation  >> NEW Config
    // validations for pump-Up scenario
    var isValidPumpOffLimitU_OP = function isValidPumpOffLimitU_OP(idx, isOffField, profile) {
        //if NO validation required on the setpoint, then just return 
        if (profile.wsLevels[idx].ignoreValidation) {
            ctrl.showWarningMessage = true;
            return true;
        }

        //validate Upper row
        var retVal = false;

        var itemUpperLimit = ctrl.tank.tankTop;
        var itemLowerLimit = ctrl.tank.tankBottom;
        var validAgainstPredecessor = false;
        var validAgainstSuccessor = false;
        var validAgainstOtherRow = false;

        //if level value is null or undefined then set error condition and return false;
        if (typeof profile.wsLevels[idx].off === 'undefined' || profile.wsLevels[idx].off === null) {
            ctrl.invalidPumpOffValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;;
            setInvalidPumpVal_OP(idx, true, true, profile);
            return false;
        }

        //update pumpUp/Down and isDirty properties based on new setpoints elections
        updateProfilePumpTypeAndIsDirty_OP(idx, isOffField, profile);

        //NOTE: -998 : represents there are NO valid pump exists

        //validate PumpOffVal (Upper Row) for Pump-Up
        if (ctrl.twParameter.alternatorEnabled && profile.pumpTypeUp) {
            // compare against Predecessor item.
            if (idx > 0 && findPrevPumpVal_OP(idx, true, profile) > -998) {
                //all items except first item and should NOT be disabled pump //all items except first item
                var prevPumpOffVal = findPrevPumpVal_OP(idx, true, profile);
                validAgainstPredecessor = +prevPumpOffVal >= +profile.wsLevels[idx].off;
                itemUpperLimit = prevPumpOffVal;
            } else {
                // if it is first item
                validAgainstPredecessor = true;
                itemUpperLimit = null;
            }
            // compare against Successor item.
            if (idx + 1 < ctrl.pumpsCount && findNextPumpVal_OP(idx, true, profile) > -998) {
                //all items except last item
                var nextPumpOffVal = findNextPumpVal_OP(idx, true, profile);
                validAgainstSuccessor = +profile.wsLevels[idx].off >= +nextPumpOffVal;
                itemLowerLimit = nextPumpOffVal;
            } else {
                // if it is last item
                //there is nothing like comparing with successor for last item, the only thing we make sure is it is >= corresponding on value
                validAgainstSuccessor = +profile.wsLevels[idx].off > +profile.wsLevels[idx].on;
                itemLowerLimit = profile.wsLevels[idx].on;
            }
        } else if (ctrl.twParameter.alternatorEnabled && !profile.pumpTypeUp) {
            //if Pump-DOWN
            return isValidPumpOffLimitD_OP(idx, isOffField, profile);
        }

        validAgainstOtherRow = +profile.wsLevels[idx].off > +profile.wsLevels[idx].on;
        if (!validAgainstOtherRow && +itemLowerLimit < +profile.wsLevels[idx].on) {
            itemLowerLimit = profile.wsLevels[idx].on;
        }

        //PumpOFFVal error condition
        if (ctrl.twParameter.alternatorEnabled && validAgainstPredecessor && validAgainstSuccessor && validAgainstOtherRow || !ctrl.twParameter.alternatorEnabled && validAgainstOtherRow) {
            ctrl.invalidPumpOffValTooltip = "";
            setInvalidPumpVal_OP(idx, true, false, profile);

            retVal = true;
        } else {
            if (idx == 0) ctrl.invalidPumpOffValTooltip = '[Value should be greater than]' + ' ' + itemLowerLimit;else ctrl.invalidPumpOffValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;;
            setInvalidPumpVal_OP(idx, true, true, profile);
            retVal = false;
        }
        //verify whether any setpoint is outside the visual limits
        processIsOutsideVisualLimits_OP();

        return retVal;
    };
    var isValidPumpOnLimitU_OP = function isValidPumpOnLimitU_OP(idx, isOffField, profile) {
        //if NO validation required on the setpoint, then just return 
        if (profile.wsLevels[idx].ignoreValidation) {
            ctrl.showWarningMessage = true;
            return true;
        }

        //validate on (Lower Row)
        var retVal = false;

        var itemUpperLimit = ctrl.tank.tankTop;
        var itemLowerLimit = ctrl.tank.tankBottom;
        var validAgainstPredecessor = false;
        var validAgainstSuccessor = false;
        var validAgainstOtherRow = false;

        //if level value is null or undefined then set error condition and return false;
        if (typeof profile.wsLevels[idx].on === 'undefined' || profile.wsLevels[idx].on === null) {
            ctrl.invalidPumpOnValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;;
            setInvalidPumpVal_OP(idx, false, true, profile);
            return false;
        }

        //update pumpUp/Down and isDirty properties based on new setpoints elections
        updateProfilePumpTypeAndIsDirty_OP(idx, isOffField, profile);

        //NOTE: -998 : represents there are NO valid pump exists

        //validate PumpOnVal (Upper Row) for Pump-Up
        if (ctrl.twParameter.alternatorEnabled && profile.pumpTypeUp) {
            // compare against Predecessor item.
            if (idx > 0 && findPrevPumpVal_OP(idx, false, profile) > -998) {
                //all items except first item and should NOT be disabled pump
                var prevPumpOnVal = findPrevPumpVal_OP(idx, false, profile);
                validAgainstPredecessor = +prevPumpOnVal >= +profile.wsLevels[idx].on;
                itemUpperLimit = prevPumpOnVal;
            } else {
                // if it is first item
                //there is nothing like comparing with predecessor for first item, the only thing we make sure is it is >= successor item
                validAgainstPredecessor = +profile.wsLevels[idx].on < +profile.wsLevels[idx].off;
                itemUpperLimit = profile.wsLevels[idx].off;
            }
            // compare against Successor item.
            if (idx + 1 < ctrl.pumpsCount && findNextPumpVal_OP(idx, false, profile) > -998) {
                //all items except last item
                var nextPumpOnVal = findNextPumpVal_OP(idx, false, profile);
                validAgainstSuccessor = +profile.wsLevels[idx].on >= +nextPumpOnVal;
                itemLowerLimit = nextPumpOnVal;
            } else {
                // if it is last item
                //there is nothing like comparing with successor for last item, the only thing we make sure is it is >= 0
                validAgainstSuccessor = true;
                itemLowerLimit = null;
            }
        } else if (ctrl.twParameter.alternatorEnabled && !profile.pumpTypeUp) {
            //if Pump-DOWN
            return isValidPumpOnLimitD_OP(idx, isOffField, profile);
        }

        validAgainstOtherRow = +profile.wsLevels[idx].on < +profile.wsLevels[idx].off;
        if (!validAgainstOtherRow && +itemUpperLimit > +profile.wsLevels[idx].off) {
            itemUpperLimit = profile.wsLevels[idx].off;
        }

        //PumpONVal error condition
        if (ctrl.twParameter.alternatorEnabled && validAgainstPredecessor && validAgainstSuccessor && validAgainstOtherRow || !ctrl.twParameter.alternatorEnabled && validAgainstOtherRow) {
            ctrl.invalidPumpOnValTooltip = "";
            setInvalidPumpVal_OP(idx, false, false, profile);
            retVal = true;
        } else {
            if (idx + 1 == ctrl.pumpsCount) // if last item
                ctrl.invalidPumpOnValTooltip = '[Value should be less than]' + ' ' + itemUpperLimit;else ctrl.invalidPumpOnValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;;
            setInvalidPumpVal_OP(idx, false, true, profile);
            retVal = false;
        }
        //verify whether any setpoint is outside the visual limits
        processIsOutsideVisualLimits_OP();

        return retVal;
    };
    // validations for pump-Down scenario
    var isValidPumpOffLimitD_OP = function isValidPumpOffLimitD_OP(idx, isOffField, profile) {
        //if NO validation required on the setpoint, then just return 
        if (profile.wsLevels[idx].ignoreValidation) {
            ctrl.showWarningMessage = true;
            return true;
        }

        var retVal = false;
        var itemUpperLimit = profile.wsLevels[idx].on;
        var itemLowerLimit = 0;
        var validAgainstPredecessor = false;
        var validAgainstSuccessor = false;
        var validAgainstOtherRow = false;

        //if level value is null or undefined then set error condition and return false;
        if (typeof profile.wsLevels[idx].off === 'undefined' || profile.wsLevels[idx].off === null) {
            ctrl.invalidPumpOffValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;;
            setInvalidPumpVal_OP(idx, true, true, profile);
            return false;
        }

        //update pumpUp/Down and isDirty properties based on new setpoints elections
        updateProfilePumpTypeAndIsDirty_OP(idx, isOffField, profile);

        //NOTE: -998 : represents there are NO valid pump exists

        //validate PumpOffVal (Lower Row) for Pump-Down
        if (ctrl.twParameter.alternatorEnabled && !profile.pumpTypeUp) {
            //if Pump-DOWN
            // compare against Predecessor item.
            if (idx > 0 && findPrevPumpVal_OP(idx, true, profile) > -998) {
                //all items except first item and should NOT be disabled pump)
                var prevPumpOffVal = findPrevPumpVal_OP(idx, true, profile);
                validAgainstPredecessor = +profile.wsLevels[idx].off >= +prevPumpOffVal;
                itemLowerLimit = prevPumpOffVal;
            } else {
                // if it is first item
                //there is nothing like comparing with predecessor for first item, the only thing we make sure is it is >= 0
                //NOTE: this is the lowest value for all the pumps' setpoint values
                validAgainstPredecessor = true;
                itemLowerLimit = null;
            }

            // compare against Successor item.
            if (idx + 1 < ctrl.pumpsCount && findNextPumpVal_OP(idx, true, profile) > -998) {
                //all items except last item
                var nextPumpOffVal = findNextPumpVal_OP(idx, true, profile);
                validAgainstSuccessor = +profile.wsLevels[idx].off <= +nextPumpOffVal;
                itemUpperLimit = nextPumpOffVal;
            } else {
                // if it is last item
                //there is nothing like comparing with successor for last item, the only thing we make sure is it is <= corresponding on value
                validAgainstSuccessor = +profile.wsLevels[idx].off < +profile.wsLevels[idx].on;
                itemUpperLimit = profile.wsLevels[idx].on;
            }
        } else if (ctrl.twParameter.alternatorEnabled && profile.pumpTypeUp) {
            //if Pump-UP
            return isValidPumpOffLimitU_OP(idx, isOffField, profile);
        }

        validAgainstOtherRow = +profile.wsLevels[idx].off < +profile.wsLevels[idx].on;
        if (!validAgainstOtherRow && +itemUpperLimit > +profile.wsLevels[idx].on) {
            itemUpperLimit = profile.wsLevels[idx].on;
        }

        //PumpOFFVal error condition
        if (ctrl.twParameter.alternatorEnabled && validAgainstPredecessor && validAgainstSuccessor && validAgainstOtherRow || !ctrl.twParameter.alternatorEnabled && validAgainstOtherRow) {
            ctrl.invalidPumpOffValTooltip = "";
            setInvalidPumpVal_OP(idx, true, false, profile);
            retVal = true;
        } else {
            if (idx == 0) ctrl.invalidPumpOffValTooltip = '[Value should be less than]' + ' ' + itemUpperLimit;else ctrl.invalidPumpOffValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;;
            setInvalidPumpVal_OP(idx, true, true, profile);
            retVal = false;
        }
        //verify whether any setpoint is outside the visual limits
        processIsOutsideVisualLimits_OP();

        return retVal;
    };
    var isValidPumpOnLimitD_OP = function isValidPumpOnLimitD_OP(idx, isOffField, profile) {
        //if NO validation required on the setpoint, then just return 
        if (profile.wsLevels[idx].ignoreValidation) {
            ctrl.showWarningMessage = true;
            return true;
        }

        var retVal = false;
        var itemUpperLimit = ctrl.tank.tankTop;
        var itemLowerLimit = profile.wsLevels[idx].off;
        var validAgainstPredecessor = false;
        var validAgainstSuccessor = false;
        var validAgainstOtherRow = false;

        //if level value is null or undefined then set error condition and return false;
        if (typeof profile.wsLevels[idx].on === 'undefined' || profile.wsLevels[idx].on === null) {
            ctrl.invalidPumpOnValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;
            setInvalidPumpVal_OP(idx, false, true, profile);
            return false;
        }

        //update pumpUp/Down and isDirty properties based on new setpoints elections
        updateProfilePumpTypeAndIsDirty_OP(idx, isOffField, profile);

        //NOTE: -998 : represents there are NO valid pump exists

        //validate PumpOnVal (Upper ROW) for Pump-Down
        if (ctrl.twParameter.alternatorEnabled && !profile.pumpTypeUp) {
            //if Pump-DOWN
            // compare against Predecessor item.
            if (idx > 0 && findPrevPumpVal_OP(idx, false, profile) > -998) {
                //all items except first item and should NOT be disabled pump
                var prevPumpOnVal = findPrevPumpVal_OP(idx, false, profile);
                validAgainstPredecessor = +profile.wsLevels[idx].on >= +prevPumpOnVal;
                itemLowerLimit = prevPumpOnVal;
            } else {
                // if it is first item
                //there is nothing like comparing with predecessor for first item, the only thing we make sure is it is >= corresponding off value
                validAgainstPredecessor = +profile.wsLevels[idx].on > +profile.wsLevels[idx].off;
                itemLowerLimit = profile.wsLevels[idx].off;
            }

            // compare against Successor item.
            if (idx + 1 < ctrl.pumpsCount && findNextPumpVal_OP(idx, false, profile) > -998) {
                //all items except last item
                var nextPumpOnVal = findNextPumpVal_OP(idx, false, profile);
                validAgainstSuccessor = +profile.wsLevels[idx].on <= +nextPumpOnVal;
                itemUpperLimit = nextPumpOnVal;
            } else {
                // if it is last item
                //there is nothing like comparing with successor for last item, the only thing we make sure is it is >= corresponding on value
                validAgainstSuccessor = true;
                itemUpperLimit = null;
            }
        } else if (ctrl.twParameter.alternatorEnabled && profile.pumpTypeUp) {
            //if Pump-UP
            return isValidPumpOnLimitU_OP(idx, isOffField, profile);
        }

        validAgainstOtherRow = +profile.wsLevels[idx].on > +profile.wsLevels[idx].off;
        if (!validAgainstOtherRow && +itemLowerLimit < +profile.wsLevels[idx].off) {
            itemLowerLimit = profile.wsLevels[idx].off;
        }

        if (ctrl.twParameter.alternatorEnabled && validAgainstPredecessor && validAgainstSuccessor && validAgainstOtherRow || !ctrl.twParameter.alternatorEnabled && validAgainstOtherRow) {
            ctrl.invalidPumpOnValTooltip = "";
            setInvalidPumpVal_OP(idx, false, false, profile);
            retVal = true;
        } else {
            if (idx + 1 == ctrl.pumpsCount) //if last item
                ctrl.invalidPumpOnValTooltip = '[Value should be greater than]' + ' ' + itemLowerLimit;else ctrl.invalidPumpOnValTooltip = ctrl.translation.text.VALUES_ALLOWED_BETWEEN + ' ' + itemLowerLimit + ' ' + ctrl.translation.text.AND + ' ' + itemUpperLimit;
            setInvalidPumpVal_OP(idx, false, true, profile);
            retVal = false;
        }
        //verify whether any setpoint is outside the visual limits
        processIsOutsideVisualLimits_OP();

        return retVal;
    };
    // Region End   => NEW OffPeak Pumps validation  >> NEW Config

    //update slider if profile passed is defaultActive or Active profile
    var updateSliderProfile = function updateSliderProfile(profile) {
        if (ctrl.defaultIsActive) {
            ctrl.offPeakSliderProfile.wsLevels.forEach(function (level) {
                level.on = ctrl.peakProfiles[0].wsLevels[level.index].on;
                level.off = ctrl.peakProfiles[0].wsLevels[level.index].off;
            });
        } else {
            if (ctrl.offPeakSliderProfile.profileId !== profile.profileId) return;

            ctrl.offPeakSliderProfile.wsLevels.forEach(function (level) {
                level.on = profile.wsLevels[level.index].on;
                level.off = profile.wsLevels[level.index].off;
            });
        }
        //logic whether to show simultaneous multiple pumps run message
        ctrl.showMultiplePumpsRunMessage = IsMultiplePumpsOn();
    };

    $scope.$on('updatePreferencesLanguage', function () {
        updatePumpArrayTranslation();
        updateLabels();
    });
}
angular.module('mc.tankandwell').controller('twSetupSetPointsController', TWSetupSetPointsController);
TWSetupSetPointsController.$inject = ['$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'tankAndWellService', '$q', '$timeout', '$element', '$rootScope', '$uibModal'];
angular.module('mc.tankandwell').directive('stringToNumber', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {
            //Parsers change how view values will be saved in the model.
            ngModel.$parsers.push(function (value) {
                return parseFloat(value);
            });
            //Formatters change how model values will appear in the view.
            ngModel.$formatters.push(function (value) {
                return parseFloat(value); //'' + value;
            });
        }
    };
});
'use strict';

angular.module('mc.tankandwell').component('tankAndWellSetupSetPoint', {
    controller: 'twSetupSetPointsController',
    templateUrl: 'ui/tankandwell/setup/setpoints/tw-setup-setpoints-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function TWSetupPumpPositionsController($rootScope, $scope, authenticationService, translationService, sharedSetupService, tankAndWellService, $q, $timeout) {
    var _this = this;

    var ctrl = this;
    ctrl.positionsLoading = true;
    ctrl.destPumpArray = [];
    ctrl.isDirty = false;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        tankAndWellService.checkUnsavedChanges = false;
        $scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;

        ctrl.getInfo($scope.stickyProperties.deviceId, ctrl.accountInfo.customerId); // http call for webapi

        ctrl.sortableOptions = {
            handle: '.sort-yes',
            stop: function stop(event, ui) {
                for (var index in ctrl.destPumpArray) {
                    ctrl.destPumpArray[index].positionIdx = index;
                }
                ctrl.isDirty = true;
                tankAndWellService.tabPopupWarningOn = true;
            }
        };
    };

    ctrl.getInfo = function (wsDeviceId, customerId) {
        ctrl.positionsLoading = true;
        var configPromise = $q.defer();
        tankAndWellService.GetLabelsSetup(wsDeviceId, customerId).then(function (resp) {
            configPromise.resolve();
            $timeout(function () {
                ctrl.positionsLoading = false;
            });

            ctrl.twSourceDevice = resp.data.sourceDevice; // this object contains source device (tank) related information
            ctrl.twBasic = resp.data.tankAndWellBasic; // this object contains all the pumps' related information
            ctrl.twLabels = resp.data.tankAndWellLabels; // this object contains source & pumps' related label information
            ctrl.twPumpsDetail = resp.data.pumpsDetail; // this object contains pumps' device name and channel (relay) description

            ctrl.updatePumpArray();
            ctrl.updateModeLabels();
            ctrl.storePrevious();
        }, function (resp) {
            console.log(resp);
        });
    };

    ctrl.updatePumpArray = function () {
        // create pump array for binding processed/calculated values with UI
        ctrl.destPumpArray = [];
        var tmpArray = [];
        for (var j = 1; j <= 5; j++) {
            var pumpLabel = ctrl.twLabels['labelPump' + j];
            if (ctrl.twBasic['destPump' + j + 'DeviceId'] !== 0) {
                tmpArray.push({
                    positionIdx: getPumpPositionIndex(ctrl.twBasic, j), //values are 0 - 4 (Lead, Lag to Lag4)
                    pumpId: j,
                    label: getPumpLabel(ctrl.twLabels['labelPump' + j], ctrl.twPumpsDetail[j - 1].description),
                    mode: ctrl.twBasic['destPump' + j + 'Mode'],
                    deviceName: ctrl.getDeviceName(ctrl.twBasic['destPump' + j + 'DeviceId'])
                });
            }
        }

        // sort the array
        ctrl.destPumpArray = tmpArray.sort(compare);
    };

    var getPumpLabel = function getPumpLabel(label, pumpDescription) {
        return label ? label : pumpDescription;
    };

    ctrl.updateModeLabels = function () {
        ctrl.modeOffLabel = 'O';
        ctrl.modeOffTitle = ctrl.translation.text.OFF;
        ctrl.modeHandLabel = 'H';
        ctrl.modeHandTitle = ctrl.translation.text.HAND;
        ctrl.modeAutoLabel = 'A';
        ctrl.modeAutoTitle = ctrl.translation.text.AUTO;

        // this logic carried over from legacy 123mc.com and applies if pump count <= 1
        if (ctrl.destPumpArray.length <= 1 && ctrl.accountInfo.customerId == 11351 && $scope.stickyProperties.deviceId == 94) {
            ctrl.modeOffLabel = 'O';
            ctrl.modeOffTitle = ctrl.translation.text.OPEN;
            ctrl.modeHandLabel = 'C';
            ctrl.modeHandTitle = ctrl.translation.text.CLOSED;
        }
    };

    var getPumpPositionIndex = function getPumpPositionIndex(basic, pumpId) {
        if (parseInt(basic.currentLeadPump, 10) === parseInt(pumpId, 10)) {
            return 1;
        } else if (parseInt(basic.currentLagPump, 10) === parseInt(pumpId, 10)) {
            return 2;
        } else if (parseInt(basic.currentLag2Pump, 10) === parseInt(pumpId, 10)) {
            return 3;
        } else if (parseInt(basic.currentLag3Pump, 10) === parseInt(pumpId, 10)) {
            return 4;
        } else if (parseInt(basic.currentLag4Pump, 10) === parseInt(pumpId, 10)) {
            return 5;
        }
    };

    ctrl.getDeviceName = function (deviceId) {
        for (var i = 0; i < ctrl.twPumpsDetail.length; i++) {
            if (ctrl.twPumpsDetail[i].deviceId == deviceId) return ctrl.twPumpsDetail[i].deviceName;
        }
    };

    var compare = function compare(a, b) {
        if (a.positionIdx < b.positionIdx) return -1;
        if (a.positionIdx > b.positionIdx) return 1;
        return 0;
    };

    // following method is consumed by UI
    ctrl.getNameByPosition = function (pos) {
        switch (pos) {
            case 1:
                return _this.translation.text.LEAD;
                break;
            case 2:
                return _this.translation.text.LAG;
                break;
            case 3:
                return _this.translation.text.LAG + ' 2';
                break;
            case 4:
                return _this.translation.text.LAG + ' 3';
                break;
            case 5:
                return _this.translation.text.LAG + ' 4';
                break;
        }
    };

    // this function useful to update basic info once user input is saved.
    ctrl.updateBasic = function (twBasic) {
        ctrl.twBasic = twBasic;
        ctrl.storePrevious();
        ctrl.updatePumpArray();
    };

    //this function useful for comparing user input with existing data, to make decision whether user made changes to data or not
    ctrl.storePrevious = function () {
        ctrl.previousTwBasic = JSON.parse(JSON.stringify(ctrl.twBasic));
    };

    ctrl.onModeChange = function (idx) {
        var curModeVal = ctrl.destPumpArray[idx].mode;
        var modePropName = 'destPump' + ctrl.destPumpArray[idx].pumpId + 'Mode';
        var preModeVal = ctrl.previousTwBasic[modePropName];

        if (preModeVal != curModeVal) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
        }
    };

    ctrl.saveAll = function () {
        ctrl.positionsLoading = true;
        //build the patch collection or return tw basic object

        //patch = {"op":"replace", patchColl:[{"key":"currentLeadPump","value":"2"}, {"propName":"currentLagPump","value":"3"}]}
        var propPatches = [];
        // build CurrentXXXPump patches --> so loop thru the array and update each pump position
        for (var i = 0; i < ctrl.destPumpArray.length; i++) {
            //build patch for destPumpXXXMode
            if (isDestPumpModeChanged(i)) {
                propPatches.push({
                    key: 'destPump' + ctrl.destPumpArray[i].pumpId + 'Mode',
                    value: ctrl.destPumpArray[i].mode
                });
            }

            //build patch for CurrentXXXPump
            switch (ctrl.destPumpArray[i].positionIdx) {
                case "0":
                    propPatches.push({ key: 'CurrentLeadPump', value: ctrl.destPumpArray[i].pumpId });
                    break;
                case "1":
                    propPatches.push({ key: 'CurrentLagPump', value: ctrl.destPumpArray[i].pumpId });
                    break;
                case "2":
                    propPatches.push({ key: 'CurrentLag2Pump', value: ctrl.destPumpArray[i].pumpId });
                    break;
                case "3":
                    propPatches.push({ key: 'CurrentLag3Pump', value: ctrl.destPumpArray[i].pumpId });
                    break;
                case "4":
                    propPatches.push({ key: 'CurrentLag4Pump', value: ctrl.destPumpArray[i].pumpId });
                    break;
            }
        }

        if (propPatches.length > 0) {
            //const patch = { op: 'replace', path: 'DelayTime', value: curDelayTime };
            var patch = { op: 'replace', patchColl: propPatches };
            tankAndWellService.PatchBasicInfoList(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, patch).then(function (resp) {
                ctrl.updateBasic(resp.data);

                //broadcast the pump positions change, listeners will update accordingly
                $rootScope.$broadcast('pumpPositionChanged');

                ctrl.isDirty = false;
                tankAndWellService.tabPopupWarningOn = false;
                ctrl.positionsLoading = false;
            }, function (resp) {
                //display error message
                var errormsg = "Your selections are not saved. Please try again."; //TODO: translate the text, after it is approved
                $scope.alerts = [];
                $scope.alerts.push({ msg: errormsg, type: "danger" });

                ctrl.positionsLoading = false;
                //console.log(resp);
            });
        }
    };

    var isDestPumpModeChanged = function isDestPumpModeChanged(idx) {
        var retVal = false;

        var curModeVal = ctrl.destPumpArray[idx].mode;
        var modePropName = 'destPump' + ctrl.destPumpArray[idx].pumpId + 'Mode';
        var preModeVal = ctrl.previousTwBasic[modePropName];

        if (preModeVal != curModeVal) {
            retVal = true;
        }

        return retVal;
    };

    ctrl.cancel = function () {
        ctrl.twBasic = JSON.parse(JSON.stringify(ctrl.previousTwBasic)); // this object contains all the pumps' related information

        ctrl.updatePumpArray();
        ctrl.updateModeLabels();
        ctrl.isDirty = false;
        tankAndWellService.tabPopupWarningOn = false;
        $scope.alerts = [];
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.updatePumpArray();
        ctrl.updateModeLabels();
    });
}

angular.module('mc.tankandwell').controller('twSetupPumpPositionsController', TWSetupPumpPositionsController);
TWSetupPumpPositionsController.$inject = ['$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'tankAndWellService', '$q', '$timeout'];
'use strict';

angular.module('mc.tankandwell').component('tankAndWellSetupPumpPosition', {
    controller: 'twSetupPumpPositionsController',
    templateUrl: 'ui/tankandwell/setup/pumppositions/tw-setup-pumppositions-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function TWSetupOffpeakWizardController($, $q, $rootScope, $scope, $timeout, authenticationService, translationService, sharedSetupService, tankAndWellService, tankAndWellOffPeakScheduleService, $uibModal, unsavedChangesService, tankAndWellOffPeakWizardService, tankAndWellOffPeakGraphicalScheduleService, twSchedulePopoverService) {
    var _this2 = this;

    //NOTE: This controller is responsible
    // 1. create new profile with existing TW system's setpoint values --> name it as Default profile
    // 2. capture schedules along with time ranges, date range for all schedules and profile name 
    // 3. create copy of "Default" profile and associate with captured schedules' 

    var ctrl = this;
    var schedulesFromGraph = [];
    var apiSchedules = [];
    ctrl.profileName = "";
    ctrl.wsDefaultProfile = {};
    ctrl.wsLevels = [];
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        tankAndWellService.checkUnsavedChanges = false;
        ctrl.exitWarningOn = false;
        $scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        ctrl.translation = translationService.translation;
        ctrl.overlapErrorMessage = ctrl.translation.text.SCHEDULE_OVERLAP;
        ctrl.scheduleCannotBeSavedMessage = ctrl.translation.text.SCHEDULE_OVERLAP + " / " + ctrl.translation.text.NO_CHANGES_SAVED;
        ctrl.offPeakProfiles = [];
        ctrl.offPeakSchedulesGrps = [];
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.addMode = false;
        ctrl.dateOverlap = false;
        ctrl.displayDateRangeWarning = false;
        ctrl.warningMessage = "<div align='left'>End date should be later than start date.<br>\
        The dates have been resetted.<br>\
        </div>";

        ctrl.step = 0;
        ctrl.totalSteps = 3; //Hard Coded, must be updated based on total steps in UI
        ctrl.wizardPercentComplete = "0%";
        ctrl.hideUI = false;

        createDefaultProfile(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId); // http call for webapi
        //initially load default ScheduleGraph data and pass it to ScheduleGrid component
        ctrl.scheduleGraphData = angular.copy(tankAndWellOffPeakGraphicalScheduleService.scheduleGraphDefaultValues);

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                if (tankAndWellService.checkUnsavedChanges) {
                    unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.exitWarningOn);
                }
            });
        }
    };

    //following will create replica from original TW System setpoints --> it is actually On-Peak profile
    var createDefaultProfileFromTwSystem = function createDefaultProfileFromTwSystem(pumpDetailList, wsDeviceId) {
        var defaultProfileLevels = [];
        var defaultProfile = { profileId: -1, wsDeviceId: wsDeviceId, name: "Peak Profile Default", isDefault: true, isDeleted: false, wsLevels: [] };

        for (var k = 0; k < pumpDetailList.length; k++) {
            var levels = { levelId: -1, profileId: -1, index: pumpDetailList[k].pumpNumber, on: pumpDetailList[k].pumpOnPeakTurnOnLevel, off: pumpDetailList[k].pumpOnPeakTurnOffLevel, IsDeleted: false };
            defaultProfileLevels.push(levels);
        }
        defaultProfile.wsLevels = defaultProfileLevels;
        ctrl.wsDefaultProfile = defaultProfile;
        return;
    };

    //post wizard (profile & schedule)
    ctrl.postWizard = function () {
        //let schedulesFromGraph = tankAndWellOffPeakGraphicalScheduleService.convertChartToSchedule(ctrl.scheduleGraphData.events, ctrl.accountInfo.customerId, ctrl.offPeakSchedulesGrps[0].wsScheduleList[0].startDate, ctrl.offPeakSchedulesGrps[0].wsScheduleList[0].endDate);
        var wsScheduleStartDate = void 0,
            wsScheduleEndDate = void 0;
        //start & end dates are defaulted to Leap Year 2020
        var leapYear = getLeapYear();
        var startDateNew = new Date(ctrl.offPeakSchedulesGrps[0].startDate);
        var endDateNew = new Date(ctrl.offPeakSchedulesGrps[0].endDate);

        // there is an issue for browser machine localtime and server localtime, 
        // trying to fix the issue by converting the start /end dates to EST date before passing to the server
        var localToUtcOffsetMins = startDateNew.getTimezoneOffset();
        var utcToEstOffsetMins = 300; //NOTE: there is NO issue during daylight saving
        var tzOffsetCorrectionMins = -localToUtcOffsetMins + utcToEstOffsetMins;
        startDateNew.setTime(startDateNew.getTime() + tzOffsetCorrectionMins * 60 * 1000);
        endDateNew.setTime(endDateNew.getTime() + tzOffsetCorrectionMins * 60 * 1000);

        var wsProfile = angular.copy(ctrl.wsDefaultProfile);
        wsProfile.name = ctrl.profileName;
        wsProfile.isDefault = false;
        updateSchedulesProperties(apiSchedules, startDateNew, endDateNew, ctrl.accountInfo.customerId);
        var wsProfileAndSchedules = { WsDefaultProfile: ctrl.wsDefaultProfile, WsProfile: wsProfile, WsSchedules: apiSchedules };
        tankAndWellOffPeakWizardService.Post(ctrl.accountInfo.customerId, wsProfileAndSchedules).then(function (resp) {
            var wsWizard = resp.data;
            ctrl.notifyParent();
        }, function (resp) {});
    };

    var updateSchedulesProperties = function updateSchedulesProperties(apiSchedules, startDate, endDate, customerId) {
        // Prepare schedule object to post to api
        apiSchedules.forEach(function (schedule, i) {
            schedule.id = -1;
            schedule.profileId = -1;
            schedule.customerId = customerId;
            schedule.startDate = startDate;
            schedule.endDate = endDate;
            schedule.isDeleted = false;
        });
    };

    //Wizard moves to next step
    ctrl.nextStep = function () {
        var tmpSchedules = [];
        if (ctrl.step === 1) {
            // make sure user selection is valid
            if (ctrl.scheduleChanged) {
                // convert user udpated schedules to apiSchedules
                tmpSchedules = schedulesFromGraph;
            } else {
                // convert default schedules to apiSchedules
                tmpSchedules = ctrl.scheduleGraphData;
            }

            tankAndWellOffPeakGraphicalScheduleService.convertChartToSchedule(tmpSchedules, ctrl.accountInfo.customerId, ctrl.offPeakSchedulesGrps[0].wsScheduleList[0].startDate, ctrl.offPeakSchedulesGrps[0].wsScheduleList[0].endDate).then(function (convertedSchedules) {
                apiSchedules = convertedSchedules;
                //still no schedules selected, then notify user
                if (apiSchedules.length === 0) {
                    twSchedulePopoverService.notifyUser();
                    return;
                }
            }, function (error) {});
        }
        ctrl.step++;
        //Get percentage completed based on total steps
        ctrl.wizardPercentComplete = Math.trunc((ctrl.step - 1) / ctrl.totalSteps * 100) + "%";
        //Check UI visiblity
        if (ctrl.step == 2) ctrl.hideUI = true;else ctrl.hideUI = false;

        if (ctrl.step == ctrl.totalSteps + 1) {
            ctrl.postWizard();
            ctrl.wizardPercentComplete = '100%';
        }
    };

    //Wizard moves to previous step
    ctrl.prevStep = function () {
        ctrl.step--;
        ctrl.wizardPercentComplete = Math.trunc((ctrl.step - 1) / ctrl.totalSteps * 100) + "%";
        //Check UI visiblity
        if (ctrl.step == 2) ctrl.hideUI = true;else ctrl.hideUI = false;
    };

    var createDefaultProfile = function createDefaultProfile(customerId, wsDeviceId) {
        var offPeakPromise = $q.defer();
        tankAndWellService.GetProfiles(customerId, wsDeviceId).then(function (resp) {
            offPeakPromise.resolve();
            $timeout(function () {
                createDefaultProfileFromTwSystem(resp.data.pumpDetailList, wsDeviceId);
            });
        }, function (resp) {
            //console.log(resp);
        });
    };

    var getLeapYear = function getLeapYear() {
        //defaulting to Leap Year 2020
        return 2020;
    };

    //Check if date or time range overlaps
    var rangeOverlaps = function rangeOverlaps(a_start, a_end, b_start, b_end) {
        if (a_start <= b_start && b_start <= a_end) return 1; // b starts in a
        if (a_start <= b_end && b_end <= a_end) return 1; // b ends in a
        if (b_start < a_start && a_end < b_end) return 1; // a in b
        return 0;
    };

    var getDayOfYear = function getDayOfYear(date) {
        var now = new Date(date);
        var start = new Date(now.getFullYear(), 0, 0);
        var diff = now - start;
        var oneDay = 1000 * 60 * 60 * 24;
        return Math.floor(diff / oneDay);
    };

    ctrl.addEmptySchedulesGroup = function () {
        tankAndWellService.checkUnsavedChanges = true;
        ctrl.exitWarningOn = true;
        //start & end dates are defaulted to Leap Year 2020
        var leapYear = getLeapYear();
        var startDate = new Date(leapYear, 0, 1);
        var endDate = new Date(leapYear, 11, 31);
        //ctrl.currentSchedulesGrpIndex++;;

        var newSchedulesGroup = {
            startDate: moment(startDate).format(),
            endDate: moment(endDate).format(),
            wsScheduleList: [],
            isYearRound: true,
            index: 1 //only one group for the wizard //ctrl.currentSchedulesGrpIndex
        };

        addScheduleToGroup(newSchedulesGroup);
        ctrl.offPeakSchedulesGrps.unshift(newSchedulesGroup);
        ctrl.nextStep();
    };

    var addScheduleToGroup = function addScheduleToGroup(schedulesGroup) {
        var startTime = new Date();
        var endTime = new Date();
        startTime.setMinutes(0);
        endTime.setMinutes(0);
        startTime.setHours(8);
        endTime.setHours(17);

        schedulesGroup.wsScheduleList.push({
            id: -1,
            profileId: null,
            customerId: ctrl.accountInfo.customerId,
            startDate: schedulesGroup.startDate,
            endDate: schedulesGroup.endDate,
            dayOfWeek: 8,
            startTime: startTime,
            endTime: endTime,
            name: null,
            isDeleted: false
        });
    };

    // set all schedules in offPeakPeriod dates to year round
    ctrl.setYearRound = function (schedulesGrp) {
        schedulesGrp.startDate = new Date().getYear() + 1900 + "-01-01T00:00:00";
        schedulesGrp.endDate = new Date().getYear() + 1900 + "-12-31T00:00:00";

        var overlap = 0;

        if (schedulesGrp) {
            ctrl.offPeakSchedulesGrps.map(function (schGrp) {
                if (schGrp.index != schedulesGrp.index) {
                    overlap += rangeOverlaps(getDayOfYear(schedulesGrp.startDate), getDayOfYear(schedulesGrp.endDate), getDayOfYear(schGrp.startDate), getDayOfYear(schGrp.endDate));
                }
            });
        }
    };

    // Update all year round checkboxes
    var updateAllYearRound = function updateAllYearRound() {
        ctrl.offPeakSchedulesGrps.map(function (schedulesGrp) {
            schedulesGrp.isYearRound = yearRoudCheck(schedulesGrp);
        });
    };

    // Update schedule to year round if selected
    ctrl.isYearRound = function (yearRound, schedulesGrp) {
        if (yearRound) {
            schedulesGrp.startDate = new Date().getYear() + 1900 + "-01-01T00:00:00";
            schedulesGrp.endDate = new Date().getYear() + 1900 + "-12-31T00:00:00";
        }
    };

    //check if startDate = 01/01 & endDate  = 12/31
    var yearRoudCheck = function yearRoudCheck(schedulesGrp) {
        //Convert to string
        if (_typeof(schedulesGrp.startDate) === 'object') {
            schedulesGrp.startDate = moment(schedulesGrp.startDate).format();
        }
        if (_typeof(schedulesGrp.endDate) === 'object') {
            schedulesGrp.endDate = moment(schedulesGrp.endDate).format();
        }
        //Check for year round date
        if (schedulesGrp.startDate.substring(5, 7) == "01" && schedulesGrp.startDate.substring(8, 10) == "01" && schedulesGrp.endDate.substring(5, 7) == "12" && schedulesGrp.endDate.substring(8, 10) == "31") return true;else {
            return false;
        }
    };

    // Time vales are strings EX: 03:12:00, need to be converted to Date
    var dateToString = function dateToString(date) {
        //Add 0 if hours or mins are only 1 digit, and 2 zeros for seconds -- for database format 07:05:00
        var hours = date.getHours().toString().length == 1 ? "0" + date.getHours() : date.getHours();
        var mins = date.getMinutes().toString().length == 1 ? "0" + date.getMinutes() : date.getMinutes();
        var string = hours + ":" + mins + ":00";
        return string;
    };

    ctrl.checkDateRanges = function (schedulesGrp, property) {
        //Check for date range overlaps
        var overlap = 0;
        if (schedulesGrp) {
            ctrl.offPeakSchedulesGrps.map(function (schGrp) {
                if (schGrp.index != schedulesGrp.index) {
                    overlap += rangeOverlaps(getDayOfYear(schedulesGrp.startDate), getDayOfYear(schedulesGrp.endDate), getDayOfYear(schGrp.startDate), getDayOfYear(schGrp.endDate));
                }
            });
        }

        //if start is greater than end, set them equal
        var inverseProperty = property == "endDate" ? "startDate" : "endDate";
        if (new Date(schedulesGrp.startDate) >= new Date(schedulesGrp.endDate)) {
            ctrl.displayDateRangeWarning = true;
            schedulesGrp[inverseProperty] = schedulesGrp[property];
        } else {
            ctrl.displayDateRangeWarning = false;
        }

        //if no overlap patch start and end dates
        if (!overlap) {
            ctrl.dateOverlap = false;
        } else {
            ctrl.dateOverlap = true;
        }

        //Check if year round toggle has changed
        updateAllYearRound();
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.preferredTimeFormat = timeFormat;
    });

    ctrl.notifyParent = function () {
        $scope.$emit('onSchedulesWizardComplete', 'completed');
        ctrl.exitWarningOn = false;
    };

    //following is work-around to send updated chart calendar to the parent component
    $scope.$on('tw-sch-calendar-updated', function (event, args) {
        schedulesFromGraph = args.chartEvents;
    });

    ctrl.$onDestroy = function () {
        ctrl.exitWarningOn = false;
    };
}

angular.module('mc.tankandwell').controller('twSetupOffpeakWizardController', TWSetupOffpeakWizardController);
TWSetupOffpeakWizardController.$inject = ['$', '$q', '$rootScope', '$scope', '$timeout', 'authenticationService', 'translationService', 'sharedSetupService', 'tankAndWellService', 'tankAndWellOffPeakScheduleService', '$uibModal', 'unsavedChangesService', 'tankAndWellOffPeakWizardService', 'tankAndWellOffPeakGraphicalScheduleService', 'twSchedulePopoverService'];
'use strict';

angular.module('mc.tankandwell').component('tankAndWellSetupOffpeakWizard', {
    controller: 'twSetupOffpeakWizardController',
    templateUrl: 'ui/tankandwell/setup/offpeakwizard/tw-setup-offpeak-wizard-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.tankandwell').factory('twSchedulePopoverService', twSchedulePopoverService);
twSchedulePopoverService.$inject = ['$uibModal'];

function twSchedulePopoverService($uibModal) {
    var service = {
        notifyUser: notifyUser
    };

    return service;

    //////// implementation /////////
    function notifyUser() {
        var _this = this;

        function modalController($uibModalInstance, translationService) {

            this.translation = translationService.translation;
            this.tmpConfirmMessageA = this.translation.text.TW_SCHEDULE_INVAVLID1;
            this.tmpConfirmMessageB = this.translation.text.TW_SCHEDULE_INVAVLID2;
            this.tmpConfirmFooter = this.translation.text.OK;

            this.cancel = function () {
                $uibModalInstance.close();
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translationService'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this.translation;
                }
            }
        });

        modalInstance.result.then(function () {
            //console.log("scheduler OK result success");
        }, function () {
            // cancel button
            //console.log("scheduler CANCEL clicked");
        });
    }
};
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function TWSetupOffpeakSchedulesController($, $q, $rootScope, $scope, $timeout, authenticationService, translationService, sharedSetupService, tankAndWellService, tankAndWellOffPeakScheduleService, $uibModal, unsavedChangesService, tankAndWellOffPeakGraphicalScheduleService, twSchedulePopoverService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.offpeakSchedulesLoading = false;
    ctrl.wsPeakSchedulesNew = [];
    //NOTE: setting => externalIdProp: '' will pass full items to events rather than just id property
    ctrl.profileSelectSettings = { selectionLimit: 2, showUncheckAll: false, externalIdProp: '' }; //, smartButtonMaxItems: 3, smartButtonTextConverter: function (itemText, originalItem) { return itemText; }  }; //{ displayProp: 'name', idProperty: 'profileId', selectionLimit: 2, showUncheckAll: false }; //template: '<b>{{option.name}}</b>', //{ selectionLimit: 2 };{ idProperty: 'id', };
    ctrl.selectedModel = [];
    //uiProfiles >> display on dropdown purpose => ui only profiles (object with id/label properties)
    //selectedProfiles >> profiles to be passed to schedule chart/graph
    ctrl.currentGrp = {};
    //let childComponentEventHandler = null;

    //NOTES
    // AddMode -> false: Not in Add Mode; true: Add Mode
    // EditMode(groupId) -> null: Not in Edit Mode; groupId: (-1: newly adding; >-1: Editing existing one)
    // isYearRound --> property on SchedulesGroup object, specifying whether it belongs to entire period of the year
    // id          --> property on SchedulesGroup object, helps to identify the object, this value is UI only for manipulating the data
    // events      --> property on SchedulesGroup object, specifies collection of schedules within. passed From/To schedules chart component


    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        tankAndWellService.checkUnsavedChanges = true;
        $scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        ctrl.translation = translationService.translation;
        // default error message when dates are overlaped for the schedules
        ctrl.overlapErrorMessage = ctrl.translation.text.DATES_OVERLAP;
        // if schedules or dates are overlaped then display this message on bottom of schedules grid/chart
        ctrl.scheduleCannotBeSavedMessage = ctrl.translation.text.DATES_OVERLAP + " / " + ctrl.translation.text.NO_CHANGES_SAVED;
        ctrl.loadOffPeakSchedulesGroups(); // http call for webapi
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.exitWarningOn = false;
        ctrl.addMode = false;
        ctrl.addOffPeakPeriod = false;
        ctrl.editMode = null;
        ctrl.dateOverlap = false;
        ctrl.iconClass = false;
        ctrl.hstep = 1;
        ctrl.mstep = 1;
        ctrl.ismeridian = true;
        ctrl.mytime = new Date();
        //ctrl.updatedGraphData = false;
        ctrl.scheduleChanged = false;
        ctrl.days = [{ id: 1, name: ctrl.translation.text.SUNDAY }, { id: 2, name: ctrl.translation.text.MONDAY }, { id: 3, name: ctrl.translation.text.TUESDAY }, { id: 4, name: ctrl.translation.text.WEDNESDAY }, { id: 5, name: ctrl.translation.text.THURSDAY }, { id: 6, name: ctrl.translation.text.FRIDAY }, { id: 7, name: ctrl.translation.text.SATURDAY }, { id: 8, name: ctrl.translation.text.ALL_DAYS }, { id: 9, name: ctrl.translation.text.WEEKDAYS }, { id: 10, name: ctrl.translation.text.WEEKEND }];

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                if (tankAndWellService.checkUnsavedChanges) {
                    unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.exitWarningOn);
                }
            });
        }
    };

    var getLeapYear = function getLeapYear() {
        //defaulting to Leap Year 2020
        return 2020;
    };

    ctrl.scheduleValid = function (inSchedulesGrp, schedule, editIndex) {
        var overlap = 0; //false
        if (!inSchedulesGrp) return overlap;

        ctrl.schedulesGroups.map(function (schsGrp) {
            //Do not check against itself
            if (schsGrp.id !== inSchedulesGrp.id) {
                overlap = ctrl.rangeOverlaps(ctrl.getDayOfYear(inSchedulesGrp.startDate), ctrl.getDayOfYear(inSchedulesGrp.endDate), ctrl.getDayOfYear(schsGrp.startDate), ctrl.getDayOfYear(schsGrp.endDate));
            }
        });
        //0: No Overlap; 1: Overlap
        return overlap;
    };

    ctrl.dayOfWeekCheck = function (day1, day2) {
        //all days
        if (day1 == 8 || day2 == 8) return true;
        //same day
        else if (day1 == day2) return true;
            //Weekdays Does not overlap Saturday
            else if (day1 == 9 && day2 == 7 || day1 == 7 && day2 == 9) return false;
                //Weekdays over lap with single day
                else if (day1 == 9 && day2 < 9 && day2 > 1 || day2 == 9 && day1 < 9 && day1 > 1) return true;
                    //Weekends over lap with single day
                    else if (day1 == 10 && (day2 == 1 || day2 == 7) || day2 == 10 && (day1 == 1 || day1 == 7)) return true;
        //no overlap
        return false;
    };

    //Check if date or time range overlaps
    ctrl.rangeOverlaps = function (a_start, a_end, b_start, b_end) {
        //return value 1 means, range overlap is YES, 0 means NO overlap
        if (a_start == b_start && a_end == b_end) return 1; // date is same
        //if (a_end == b_start || a_start == b_end) return 0; // b starts after a /or/ a starts after b
        if (a_start <= b_start && b_start <= a_end) return 1; // b starts in a
        if (a_start <= b_end && b_end <= a_end) return 1; // b ends in a
        if (b_start < a_start && a_end < b_end) return 1; // a in b
        return 0;
    };

    ctrl.getDayOfYear = function (date) {
        var now = new Date(date);
        var start = new Date(now.getFullYear(), 0, 0);
        var diff = now - start;
        var oneDay = 1000 * 60 * 60 * 24;
        return Math.floor(diff / oneDay);
    };

    ctrl.addEmptySchedule = function () {
        //start & end dates are defaulted to Leap Year 2020
        var leapYear = getLeapYear();
        var startDate = new Date(leapYear, 0, 1);
        var endDate = new Date(leapYear, 11, 31);
        ctrl.currentSchedulesGrpId++;

        var newSchedulesGroup = {
            startDate: moment(startDate).format(),
            endDate: moment(endDate).format(),
            wsScheduleList: [],
            isYearRound: true,
            id: ctrl.currentSchedulesGrpId,
            events: angular.copy(tankAndWellOffPeakGraphicalScheduleService.scheduleGraphDefaultValues),
            chartEvents: [],
            isDirty: true
        };

        newSchedulesGroup.uiProfiles = generateUiProfiles(ctrl.offPeakProfiles, newSchedulesGroup.id);
        newSchedulesGroup.selectedProfiles = [];
        newSchedulesGroup.prevSelectedProfiles = [];
        addSchedule(newSchedulesGroup);
        ctrl.schedulesGroups.unshift(newSchedulesGroup); //add at the beginning of array
        ctrl.addOffPeakPeriod = true;
        ctrl.addMode = true;
        ctrl.exitWarningOn = true;
        ctrl.editMode = ctrl.currentSchedulesGrpId;
        ctrl.currentGrp = newSchedulesGroup;
        // ctrl.editMode = null; // NOT edit mode
    };

    var addSchedule = function addSchedule(schedulesGroup) {
        var startTime = new Date();
        var endTime = new Date();
        startTime.setMinutes(0);
        endTime.setMinutes(0);
        startTime.setHours(8);
        endTime.setHours(17);

        schedulesGroup.wsScheduleList.push({
            id: -1,
            profileId: null,
            customerId: ctrl.accountInfo.customerId,
            startDate: schedulesGroup.startDate,
            endDate: schedulesGroup.endDate,
            dayOfWeek: 8,
            startTime: startTime,
            endTime: endTime,
            name: null,
            isDeleted: false
        });
    };

    ctrl.saveNewSchedule = function (schedulesGrp, newRange) {
        //Save new schedule range
        if (newRange) {
            //Set Date Range and post all schedules generated by gpaphical interface
            tankAndWellOffPeakGraphicalScheduleService.convertChartToSchedule(schedulesGrp.chartEvents, ctrl.accountInfo.customerId, schedulesGrp.startDate, schedulesGrp.endDate, schedulesGrp.selectedProfiles).then(function (newSchedules) {
                if (newSchedules.length === 0) {
                    //all schedules are on-peak which is not allowed
                    //notify user about all on-peak schedules condition
                    twSchedulePopoverService.notifyUser();
                } else {
                    //newSchedules = updateSchedulesProperties(newSchedules, schedulesGrp.startDate, schedulesGrp.endDate, ctrl.accountInfo.customerId);
                    postNewSchedules(newSchedules);
                    ctrl.editMode = null;
                }

                //Set add modes back to default
                _this2.addMode = false;
                ctrl.exitWarningOn = false;
                ctrl.addOffPeakPeriod = false;
            }, function () {});
        }
    };

    ctrl.editingTo = function (name) {
        _this2._prevName = name;
    };

    //Display comma delimited profile names
    ctrl.displayProfilesName = function (schedulesGrp) {
        var names = "";
        if (schedulesGrp.selectedProfiles) {
            schedulesGrp.selectedProfiles.forEach(function (uiProfile, index) {
                if (index === 0) names = uiProfile.label;else names = names.concat(", " + uiProfile.label);
            });
        }
        return names;
    };

    //Update all Schedules in Off Peak Period
    //var patchOffPeakPeriodData = (schedulesGrp, propertyName) => {

    //    //Update all schedules if adding
    //    if(ctrl.addOffPeakPeriod) {
    //        schedulesGrp.wsScheduleList.map((schedule) => {
    //            schedule[propertyName] = schedulesGrp[propertyName];
    //        });
    //    }
    //    //Patch all schedules if not adding
    //    else {
    //        schedulesGrp.wsScheduleList.map((schedule) => {
    //            ctrl.patchData(schedule, propertyName, schedulesGrp);
    //        });
    //    }
    //};

    ctrl.patchTime = function (schedule, property) {
        //End Time Max Value 11:59pm
        if (schedule.endTime.getHours() == 0) {
            schedule.endTime = schedule.endTime.setHours(23);
            schedule.endTime = new Date(schedule.endTime);
            schedule.endTime = schedule.endTime.setMinutes(59);
            schedule.endTime = new Date(schedule.endTime);
        }
        //if start is greater than end, set them equal
        var inverseProperty = property == "endTime" ? "startTime" : "endTime";
        if (new Date(schedule.startTime) >= new Date(schedule.endTime)) {
            schedule[inverseProperty] = schedule[property];
        }

        //Delay patch to account for multiple user clicks
        if (angular.isDefined(ctrl.delayPatch)) {
            $timeout.cancel(ctrl.delayPatch);
        }
        ctrl.delayPatch = $timeout(function () {
            //patch both times
            // ctrl.patchData(schedule, property);
            // ctrl.patchData(schedule, inverseProperty);
        }, 1000);
    };

    //var patchData = (schedule, propertyName, schedulesGrp) => {
    //    //Conditions to not patch Data
    //    if (schedule.id === -1 || schedule[propertyName] == this._prevName) return false;
    //    if (!ctrl.checkData(propertyName, typeof schedule[propertyName] == "object" && schedule[propertyName] != null && typeof schedule[propertyName].id != "undefined" ? schedule[propertyName].id : schedule[propertyName])) return false;
    //    if (ctrl.isSchedulesOverlap()) return false;

    //    //All conditions passed, patch data
    //    updateValue(schedule, propertyName, schedulesGrp);
    //};

    ctrl.makeDirty = function (schedulesGrp, propertyName) {
        schedulesGrp.isDirty = true;

        //NOTE: NO action is required, SAVE button click will take care of it
    };

    //ctrl.childComponentEventHandlerRegistration = (handler) => {
    //    childComponentEventHandler = handler;

    //    console.log("child component event handler is registered");
    //}

    //ctrl.notifyChild = (currentGrp) => {
    //    console.log("Notifying the child component");

    //    if (childComponentEventHandler) {
    //        childComponentEventHandler(currentGrp);
    //    }
    //}

    ctrl.profileEvents = {
        onItemSelect: function onItemSelect(item) {
            ctrl.schedulesGroups.forEach(function (schGrp) {
                if (schGrp.id === item.grpId) {
                    schGrp.isDirty = true;
                    schGrp.removedProfile = null;
                    if (schGrp.selectedProfiles) {
                        //if adding first profile
                        if (schGrp.selectedProfiles.length === 0) {
                            //dont think this code is going to hit anytime, but only safety purpose
                            var tmpProfile = { id: item.id, label: item.label, grpId: item.grpId, typeId: 2 }; //Navy Blue profile
                            schGrp.selectedProfiles.push(tmpProfile);
                        } else if (schGrp.selectedProfiles.length === 1) {
                            //if adding second profile
                            if (!schGrp.selectedProfiles[0].typeId) {
                                //if typeId present means => profile selection is complete, so we 
                                schGrp.selectedProfiles[0].typeId = 2; //Navy Blue
                            }
                        } else if (schGrp.selectedProfiles.length === 2) {
                            // if second profiles typeId not present
                            //color for newly added profile should be different from existing one.
                            if (schGrp.selectedProfiles[0].typeId === 2) {
                                schGrp.selectedProfiles[1].typeId = 3; //Yellow
                            } else if (schGrp.selectedProfiles[0].typeId === 3) {
                                schGrp.selectedProfiles[1].typeId = 2; //Navy Blue
                            }
                        }
                        schGrp.prevSelectedProfiles = JSON.parse(JSON.stringify(schGrp.selectedProfiles));
                        ctrl.scheduleChanged = true;
                        //let child chart/graph know that new profile is being added
                        $scope.$broadcast("sch-profile-change", schGrp);
                    }
                }
            });
        },
        onItemDeselect: function onItemDeselect(item) {
            var removedProfile = ctrl.currentGrp.prevSelectedProfiles.find(function (uiProfile) {
                return uiProfile.id === item.id;
            });
            if (removedProfile) {
                ctrl.schedulesGroups.forEach(function (schGrp) {
                    if (schGrp.id === removedProfile.grpId) {
                        schGrp.removedProfile = JSON.parse(JSON.stringify(removedProfile)); //{ id: removedProfile.id, label: removedProfile.label, grpId: removedProfile.grpId, typeId: removedProfile.typeId };
                        var removedProfileIndex = schGrp.prevSelectedProfiles.indexOf(function (profile) {
                            return profile.id === removeProfile.id;
                        });
                        if (removedProfileIndex > -1) schGrp.prevSelectedProfiles.splice(removedProfile, 1); //remove item
                        schGrp.isDirty = true;
                        var grpParam = JSON.parse(JSON.stringify(schGrp));
                        //let child chart/graph know that it has to remove the schedules for removed profile
                        $scope.$broadcast("sch-profile-change", grpParam);
                    }
                });
            }
        }
    };

    var putSchedules = function putSchedules(offPeakSchedulesOld, offPeakSchedulesNew) {
        ctrl.offpeakSchedulesLoading = true;
        //ctrl.updatedGraphData = false;
        ctrl.scheduleChanged = false;
        var offPeakSchedulePromise = $q.defer();
        var oldNewSchedules = { wsSchedulesOld: offPeakSchedulesOld, wsSchedulesNew: offPeakSchedulesNew };

        tankAndWellOffPeakScheduleService.PutSchedules(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, oldNewSchedules).then(function (resp) {
            offPeakSchedulePromise.resolve();
            $timeout(function () {
                ctrl.loadOffPeakSchedulesGroups();
            });
        }, function (resp) {});
    };
    //NOTE: used for schedules' start/end date updates
    var updateSchedules = function updateSchedules(startDate, endDate, updateoffPeakSchedules) {
        ctrl.offpeakSchedulesLoading = true;
        //ctrl.updatedGraphData = false;
        ctrl.scheduleChanged = false;
        var offPeakSchedulePromise = $q.defer();

        tankAndWellOffPeakScheduleService.UpdateSchedules(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, startDate, endDate, updateoffPeakSchedules).then(function (resp) {
            offPeakSchedulePromise.resolve();
            $timeout(function () {
                ctrl.loadOffPeakSchedulesGroups();
            });
        }, function (resp) {});
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            case "profileId":
            case "startDate":
            case "endDate":
            case "dayOfWeek":
            case "startTime":
            case "endTime":
            case "isDeleted":
            case "accessLevel":
                return true;
        }
    };

    // set all schedules in offPeakPeriod dates to year round
    ctrl.setYearRound = function (schedulesGrp) {

        schedulesGrp.startDate = new Date().getYear() + 1900 + '-01-01T00:00:00';
        schedulesGrp.endDate = new Date().getYear() + 1900 + '-12-31T00:00:00';

        var overlap = 0;

        if (schedulesGrp) {
            ctrl.schedulesGroups.map(function (schGrp) {
                if (schGrp.id != schedulesGrp.id) {
                    overlap += ctrl.rangeOverlaps(ctrl.getDayOfYear(schedulesGrp.startDate), ctrl.getDayOfYear(schedulesGrp.endDate), ctrl.getDayOfYear(schGrp.startDate), ctrl.getDayOfYear(schGrp.endDate));
                }
            });
            schedulesGrp.isDirty = true;
        }
    };

    // Update all year round checkboxes
    ctrl.updateAllYearRound = function () {
        ctrl.schedulesGroups.map(function (schGrp) {
            schGrp.isYearRound = yearRoudCheck(schGrp);
        });
    };

    //check if startDate = 01/01 & endDate  = 12/31
    var yearRoudCheck = function yearRoudCheck(schedulesGrp) {
        //Convert to string
        if (_typeof(schedulesGrp.startDate) === 'object') {
            schedulesGrp.startDate = moment(schedulesGrp.startDate).format();
        }
        if (_typeof(schedulesGrp.endDate) === 'object') {
            schedulesGrp.endDate = moment(schedulesGrp.endDate).format();
        }
        //Check for year round date
        if (schedulesGrp.startDate.substring(5, 7) == "01" && schedulesGrp.startDate.substring(8, 10) == "01" && schedulesGrp.endDate.substring(5, 7) == "12" && schedulesGrp.endDate.substring(8, 10) == "31") return true;else {
            return false;
        }
    };

    // Update all schedules time values
    ctrl.updateAllTimes = function (time) {
        ctrl.schedulesGroup.map(function (schedule) {
            schedule.wsScheduleList.map(function (sch) {
                sch.startTime = ctrl.timeStringToDate(sch.startTime);
                sch.endTime = ctrl.timeStringToDate(sch.endTime);
            });
        });
    };

    ctrl.setEditMode = function (grpId) {
        ctrl.currentGrp = ctrl.schedulesGroups[grpId - 1];
        ctrl.editMode = grpId;
        ctrl.exitWarningOn = true;
        tankAndWellService.tabPopupWarningOn = true;
    };
    ctrl.editSchedule = function (grpId, schedulesGrp) {
        //if schedulesGrp is not provided means, just to change the view to Edit mode
        //if schedulesGrp is present then update the entire group schedules
        if (ctrl.editMode === grpId && ctrl.scheduleChanged) //if chart values changes
            {
                tankAndWellOffPeakGraphicalScheduleService.convertChartToSchedule(schedulesGrp.chartEvents, ctrl.accountInfo.customerId, schedulesGrp.startDate, schedulesGrp.endDate, schedulesGrp.selectedProfiles).then(function (updatedSchedules) {
                    if (updatedSchedules.length === 0) {
                        //all schedules are on-peak which is not allowed
                        //notify user about all on-peak schedules condition
                        twSchedulePopoverService.notifyUser();
                    } else {
                        //updatedSchedules = updateSchedulesProperties(updatedSchedules, schedulesGrp.startDate, schedulesGrp.endDate, ctrl.accountInfo.customerId);
                        putSchedules(schedulesGrp.wsScheduleList, updatedSchedules);
                    }
                });
            } else if (ctrl.editMode === grpId && schedulesGrp.isDirty) // if start/end date & profile changes
            {
                updateSchedules(schedulesGrp.startDate, schedulesGrp.endDate, schedulesGrp.wsScheduleList);
            }
        ctrl.exitWarningOn = false;
        tankAndWellService.tabPopupWarningOn = false;
    };

    // if schedules are overlaped then we disable SAVE button
    ctrl.isSchedulesOverlap = function () {
        var overlapCount = 0;
        ctrl.schedulesGroups.forEach(function (schGrp) {
            overlapCount += ctrl.scheduleValid(schGrp, false);
        });
        return overlapCount > 0;
    };

    // Time vales are strings EX: 03:12:00, need to be converted to Date
    ctrl.timeStringToDate = function (timeString) {
        var date = new Date();
        date.setHours(timeString.substring(0, 2));
        date.setMinutes(timeString.substring(3, 5));
        return date;
    };

    // Time vales are strings EX: 03:12:00, need to be converted to Date
    ctrl.dateToString = function (date) {
        //Add 0 if hours or mins are only 1 digit, and 2 zeros for seconds -- for database format 07:05:00
        var hours = date.getHours().toString().length == 1 ? '0' + date.getHours() : date.getHours();
        var mins = date.getMinutes().toString().length == 1 ? '0' + date.getMinutes() : date.getMinutes();
        var string = hours + ':' + mins + ':00';
        return string;
    };

    var generateUiProfiles = function generateUiProfiles(offPeakProfiles, grpId) {
        var tmpProfiles = [];
        offPeakProfiles.forEach(function (profile) {
            tmpProfiles.push({ id: profile.profileId, label: profile.name, grpId: grpId });
        });
        return tmpProfiles;
    };

    var getSelectedProfiles = function getSelectedProfiles(scheduleGrp) {
        var tmpProfiles = [];
        var profileIds = [];
        scheduleGrp.wsScheduleList.forEach(function (schedule, index) {
            if (index === 0) profileIds.push(schedule.profileId);
            if (profileIds.indexOf(schedule.profileId) < 0) {
                //if NOT in the array
                profileIds.push(schedule.profileId); // add to the array
            }
        });

        var tmpTypeId = 2; // 2: profile with Navy Blue color, 3: profile with Yellow color
        profileIds.forEach(function (profileId) {
            var foundUiProfile = scheduleGrp.uiProfiles.find(function (uiProfile) {
                return uiProfile.id === profileId;
            });
            tmpProfiles.push({ id: foundUiProfile.id, label: foundUiProfile.label, grpId: scheduleGrp.id, typeId: tmpTypeId++ });
        });
        return tmpProfiles;
    };

    ctrl.loadOffPeakSchedulesGroups = function () {
        ctrl.offpeakSchedulesLoading = true;
        var offPeakPromise = $q.defer();

        tankAndWellOffPeakScheduleService.GetList($scope.stickyProperties.deviceId, ctrl.accountInfo.customerId).then(function (resp) {
            offPeakPromise.resolve();
            $timeout(function () {
                ctrl.offpeakSchedulesLoading = false;
                ctrl.offPeakProfiles = resp.data.wsProfileList.filter(function (profile) {
                    return !profile.isDefault;
                });
                ctrl.schedulesGroups = resp.data.wsScheduleGroupByDate; //each group represents list of schedules within date range

                //Add Logic to Year round check
                ctrl.updateAllYearRound(); // update property on the each SchedulesGroup whether it covers for entire year.
                ctrl.assignOffPeakSchedulesGrpIds();
                ctrl.editMode = null;
                ctrl.addMode = false;
                ctrl.exitWarningOn = false;
                //Show Wizard if no schedules & no off-peak profiles
                if (ctrl.offPeakProfiles.length === 0 && ctrl.schedulesGroups.length === 0) {
                    ctrl.wizardVisible = true;
                } else {
                    ctrl.wizardVisible = false;
                }
                //ctrl.wizardVisible = (ctrl.schedulesGroups.length === 0 && ctrl.offPeakProfiles.length === 0) ? true : false;
                if (!ctrl.wizardVisible) {
                    ctrl.schedulesGroups.forEach(function (schedulesGrp) {
                        schedulesGrp.uiProfiles = generateUiProfiles(ctrl.offPeakProfiles, schedulesGrp.id);
                        schedulesGrp.selectedProfiles = getSelectedProfiles(schedulesGrp);
                        schedulesGrp.prevSelectedProfiles = JSON.parse(JSON.stringify(schedulesGrp.selectedProfiles)); // for future reference purpose
                        schedulesGrp.events = tankAndWellOffPeakGraphicalScheduleService.convertScheduleToChart(schedulesGrp);
                        schedulesGrp.chartEvents = [];
                        schedulesGrp.removedProfile = null; //for future reference purpose
                    });
                }
            });
        }, function (resp) {});
    };

    ctrl.assignOffPeakSchedulesGrpIds = function () {
        ctrl.currentSchedulesGrpId = 0;
        ctrl.schedulesGroups.map(function (schsGrp) {
            ctrl.currentSchedulesGrpId++;
            schsGrp.id = ctrl.currentSchedulesGrpId;
            schsGrp.isDirty = false;
        });
    };

    //var postSchedule = (schedule, isLast) => {
    //    if (ctrl.isSchedulesOverlap()) return false;
    //    const offPeakPromise = $q.defer();
    //    var scheduleCopy = angular.copy(schedule);
    //    tankAndWellOffPeakScheduleService.Post(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, isLast, scheduleCopy).then((resp) => {
    //        offPeakPromise.resolve();
    //        $timeout(() => {
    //            schedule.id = resp.data.id;
    //        });

    //    }, (resp) => {
    //    });
    //};

    var postNewSchedules = function postNewSchedules(schedules) {
        if (ctrl.isSchedulesOverlap()) return false;
        var offPeakPromise = $q.defer();
        tankAndWellOffPeakScheduleService.PostSchedules(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, schedules).then(function (resp) {
            offPeakPromise.resolve();
            $timeout(function () {
                ctrl.loadOffPeakSchedulesGroups();
            });
        }, function (resp) {});
    };

    ctrl.checkDateRanges = function (schedulesGrp, property) {
        if (ctrl.addMode) {
            //set group's date ranges to individual schedules' date ranges
            schedulesGrp.wsScheduleList[0].startDate = schedulesGrp.startDate;
            schedulesGrp.wsScheduleList[0].endDate = schedulesGrp.endDate;
            schedulesGrp.isDirty = true;
        }
        if (ctrl.editMode != null || ctrl.editMode > -1) schedulesGrp.isDirty = true;
        //Check for date range overlaps
        var overlap = 0;
        if (schedulesGrp) {
            ctrl.schedulesGroups.map(function (schGrp) {
                if (schGrp.id != schedulesGrp.id) {
                    overlap += ctrl.rangeOverlaps(ctrl.getDayOfYear(schedulesGrp.startDate), ctrl.getDayOfYear(schedulesGrp.endDate), ctrl.getDayOfYear(schGrp.startDate), ctrl.getDayOfYear(schGrp.endDate));
                }
            });
        }

        //if start is greater than end, set them equal
        var inverseProperty = property == "endDate" ? "startDate" : "endDate";
        if (new Date(schedulesGrp.startDate) >= new Date(schedulesGrp.endDate)) {
            schedulesGrp[inverseProperty] = schedulesGrp[property];
        }

        //if no overlap patch start and end dates
        if (!overlap) {
            ctrl.dateOverlap = false;
        } else {
            ctrl.dateOverlap = true;
        }

        //Check if year round toggle has changed
        ctrl.updateAllYearRound();
    };

    ctrl.cancelSchedule = function (schedule) {
        schedule.wsScheduleList.pop();
        ctrl.addMode = false;
        ctrl.exitWarningOn = false;
        tankAndWellService.tabPopupWarningOn = false;
    };

    var deleteSchedulesGroup = function deleteSchedulesGroup(schedulesGrp, schedulesGrpId) {
        var firstSchedule = schedulesGrp.wsScheduleList.length > 0 ? schedulesGrp.wsScheduleList[0] : null;
        if (firstSchedule == null) return;

        //as we are supporting multi-profiles (upto 2 profiles) within same group, 
        //so separate the group schedules based on each profile
        var profileIds = [];
        schedulesGrp.wsScheduleList.forEach(function (schedule, index) {
            if (index === 0) profileIds.push(schedule.profileId);
            if (profileIds.indexOf(schedule.profileId) < 0) {
                //if NOT in the array
                profileIds.push(schedule.profileId); // add to the array
            }
        });

        //firstSchedule.profileId = schedulesGrp.profileId;
        tankAndWellOffPeakScheduleService.DeleteSchedules(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, firstSchedule.startDate, firstSchedule.endDate, profileIds).then(function (resp) {
            //success
            ctrl.loadOffPeakSchedulesGroups();
        }, function (resp) {
            //failure
        });
    };

    ctrl.hasSchedules = function (schedulesGroup) {
        var deletedCount = 0;
        schedulesGroup.wsScheduleList.map(function (sch) {
            if (sch.isDeleted === true) {
                deletedCount++;
            }
        });
        //Remove Entire OffPeakSchedule from UI if all schedules are deleted
        if (deletedCount === schedulesGroup.wsScheduleList.length) {
            ctrl.schedulesGroups = ctrl.schedulesGroups.filter(function (schsGrp) {
                return schsGrp.profileId !== schedulesGroup.profileId;
            });
            ctrl.editMode = null;
            return false;
        }
        return true;
    };

    ctrl.cancelAddSchedule = function (schedulesGrp) {
        if (ctrl.addMode) ctrl.schedulesGroups.shift();
        if (schedulesGrp.isDirty) {
            //reload the schedules groups
            ctrl.loadOffPeakSchedulesGroups();
            return;
        }
        ctrl.addMode = false;
        ctrl.exitWarningOn = false;
        ctrl.editMode = null;
        ctrl.addOffPeakPeriod = false;
    };

    ctrl.cancelEditSchedule = function (schedulesGrp) {
        if (schedulesGrp.isDirty || ctrl.scheduleChanged) {
            //reload the schedules groups
            tankAndWellService.tabPopupWarningOn = false;
            ctrl.loadOffPeakSchedulesGroups();
            return;
        }
        ctrl.addMode = false;
        ctrl.exitWarningOn = false;
        tankAndWellService.tabPopupWarningOn = false;
        ctrl.editMode = null;
        ctrl.addOffPeakPeriod = false;
    };

    ctrl.delete = function (schedulesGrp, schedulesGrpId) {
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE + " " + _translation.text.SCHEDULE + "?";

            this.ok = function () {
                $uibModalInstance.close(schedulesGrp);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (schedulesGrp) {
            deleteSchedulesGroup(schedulesGrp, schedulesGrpId);
            //Show Wizard if no schedules & no off-peak profiles
            if (ctrl.offPeakProfiles.length === 0 && ctrl.schedulesGroups.length === 0) {
                ctrl.wizardVisible = true;
            } else {
                ctrl.wizardVisible = false;
            }
        }, function () {
            // cancel button
        });
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.days = [];
        ctrl.days = [{ id: 1, name: ctrl.translation.text.SUNDAY }, { id: 2, name: ctrl.translation.text.MONDAY }, { id: 3, name: ctrl.translation.text.TUESDAY }, { id: 4, name: ctrl.translation.text.WEDNESDAY }, { id: 5, name: ctrl.translation.text.THURSDAY }, { id: 6, name: ctrl.translation.text.FRIDAY }, { id: 7, name: ctrl.translation.text.SATURDAY }, { id: 8, name: ctrl.translation.text.ALL_DAYS }, { id: 9, name: ctrl.translation.text.WEEKDAYS }, { id: 10, name: ctrl.translation.text.WEEKEND }];
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.preferredTimeFormat = timeFormat;
    });

    $scope.$on('offPeakWizard', function () {
        //ctrl.wizardVisible = false;
        ctrl.loadOffPeakSchedulesGroups(); // http call for webapi
    });

    $scope.$on('onSchedulesWizardComplete', function (evt) {
        ctrl.loadOffPeakSchedulesGroups(); // http call for webapi
    });

    //following is work-around to send updated chart calendar to the parent component
    $scope.$on('tw-sch-calendar-updated', function (event, args) {
        ctrl.schedulesGroups.forEach(function (schedulesGrp) {
            if (schedulesGrp.id === args.grpId) {
                schedulesGrp.chartEvents = args.chartEvents;
            }
        });
    });

    ctrl.$onDestroy = function () {
        ctrl.exitWarningOn = false;
        tankAndWellService.tabPopupWarningOn = false;
    };
}

angular.module('mc.tankandwell').controller('twSetupOffpeakSchedulesController', TWSetupOffpeakSchedulesController);
TWSetupOffpeakSchedulesController.$inject = ['$', '$q', '$rootScope', '$scope', '$timeout', 'authenticationService', 'translationService', 'sharedSetupService', 'tankAndWellService', 'tankAndWellOffPeakScheduleService', '$uibModal', 'unsavedChangesService', 'tankAndWellOffPeakGraphicalScheduleService', 'twSchedulePopoverService'];
'use strict';

angular.module('mc.tankandwell').component('tankAndWellSetupOffpeakSchedules', {
    controller: 'twSetupOffpeakSchedulesController',
    templateUrl: 'ui/tankandwell/setup/offpeakschedules/tw-setup-offpeak-schedules-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function TWSetupOffpeakProfilesController($, $q, $rootScope, $scope, $timeout, authenticationService, translationService, sharedSetupService, tankAndWellService, $uibModal, unsavedChangesService, tankAndWellOffPeakScheduleService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.offpeakProfilesLoading = false;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        tankAndWellService.checkUnsavedChanges = true;
        $scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        ctrl.translation = translationService.translation;
        ctrl.fillLevelUnit = true;
        ctrl.fillLevelUnitValue = "";
        ctrl.significantDecimals = $scope.stickyProperties.significantDecimals;
        ctrl.getSignifcantDecimalMathRound();
        ctrl.loadOffPeakProfiles(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId); // http call for webapi

        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;

            // binding 'dialogbeforeclose' event to Check for unsaved Changes function
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                if (tankAndWellService.checkUnsavedChanges) {
                    unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
                }
            });

            _this2._popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    ctrl.adjustSliderSize();
                },
                restore: function restore(event, ui) {
                    ctrl.adjustSliderSize();
                }
            });
        }
    };

    var loadData = function loadData(resp) {
        $timeout(function () {
            ctrl.offpeakProfilesLoading = false;
            ctrl.offPeakFillModel = resp.data;
            ctrl.offPeakProfiles = ctrl.offPeakFillModel.offPeakProfiles;
            angular.forEach(ctrl.offPeakProfiles, function (profile, index) {
                profile.sliderOptions = {
                    id: profile.offPeakProfileId,
                    floor: ctrl.fillLevelUnit ? ctrl.offPeakFillModel.tankBottom : 0,
                    ceil: ctrl.fillLevelUnit ? ctrl.offPeakFillModel.tankTop : 100,
                    step: ctrl.fillLevelUnit ? .1 : .01,
                    precision: 5,
                    disabled: true, //read-only mode
                    onEnd: patchSliderLevel, //triggers at the end of slider value change
                    onChange: function onChange(x, value) {
                        profile.tankOrWellFillLevel = Math.round(value * 10) / 10;
                    },
                    translate: function translate(value) {
                        return ctrl.fillLevelUnit ? value : value + '%';
                    }
                };
            });
        });
    };

    ctrl.loadOffPeakProfiles = function (customerId, wsDeviceId) {
        ctrl.offpeakProfilesLoading = true;
        var offPeakPromise = $q.defer();
        tankAndWellService.GetOffPeakProfiles(customerId, wsDeviceId).then(function (resp) {
            offPeakPromise.resolve();
            $timeout(function () {
                ctrl.offPeakFillModel = resp.data;
                ctrl.fillLevelUnitValue = resp.data.unit;
                ctrl.offPeakProfiles = ctrl.offPeakFillModel.offPeakProfiles;
                ctrl.leadOffPeakTurnOnLevelCheck();
                ctrl.getOffPeakLagProfileEnabled();
                angular.forEach(ctrl.offPeakProfiles, function (profile, index) {
                    profile.sliderOptions = {
                        id: profile.offPeakProfileId,
                        floor: ctrl.fillLevelUnit ? ctrl.offPeakFillModel.tankBottom : 0,
                        ceil: ctrl.fillLevelUnit ? ctrl.offPeakFillModel.tankTop : 100,
                        step: ctrl.fillLevelUnit ? .1 : .01,
                        precision: 5,
                        disabled: true, //read-only mode
                        onEnd: patchSliderLevel, //triggers at the end of slider value change
                        onChange: function onChange(x, value) {
                            profile.tankOrWellFillLevel = Math.round(value * 10) / 10;
                        },
                        translate: function translate(value) {
                            return ctrl.fillLevelUnit ? value : value + '%';
                        }
                    };
                });
            });
            ctrl.loadOffPeakSchedules();
        }, function (resp) {
            console.log(resp);
        });
    };

    ctrl.leadOffPeakTurnOnLevelCheck = function () {
        ctrl.offPeakProfiles.forEach(function (profile) {
            profile.leadOffPeakTurnOnLevel = profile.leadOffPeakTurnOnLevel == null || profile.leadOffPeakTurnOnLevel == undefined ? profile.leadOnPeakTurnOffLevel : profile.leadOffPeakTurnOnLevel;
        });
    };

    ctrl.checkExistingProfileNames = function () {
        //Logic Coming soon
        var hasSummerProfile = false;
        var hasWinterProfile = false;
    };

    ctrl.getSignifcantDecimalMathRound = function () {
        ctrl.decimalRound = 1;
        for (var index = 0; index < ctrl.significantDecimals; index++) {
            ctrl.decimalRound = ctrl.decimalRound * 10;
        }
    };

    ctrl.displaySignifcantDecimals = function (value) {
        value = Math.round(value * ctrl.decimalRound) / ctrl.decimalRound;
        var decimalCount = ctrl.countDecimals(value);
        value = value.toString();
        if (decimalCount < ctrl.significantDecimals) {
            for (var i = decimalCount; i < ctrl.significantDecimals; i++) {
                if (!value.includes('.')) {
                    value = value + '.';
                }
                value = value + '0';
            }
        }
        return value;
    };

    ctrl.countDecimals = function (value) {
        if (Math.floor(value) === value) return 0;
        return value.toString().split(".")[1].length || 0;
    };

    ctrl.getOffPeakLagProfileEnabled = function () {
        ctrl.offPeakProfiles.map(function (profile) {
            profile.lagProfiles.map(function (lag) {
                lag.enabled = lag.offPeakTurnOnLevel != null ? true : false;
            });
        });
    };

    ctrl.hasLagPumpsEnabled = function (offPeakProfile) {
        var lagEnabledCount = 0;
        offPeakProfile.lagProfiles.map(function (lag) {
            if (lag.enabled) lagEnabledCount++;
        });
        return lagEnabledCount;
    };

    ctrl.loadOffPeakSchedules = function () {
        var offPeakPromise = $q.defer();
        tankAndWellOffPeakScheduleService.GetList($scope.stickyProperties.deviceId, ctrl.accountInfo.customerId).then(function (resp) {
            offPeakPromise.resolve();
            $timeout(function () {
                ctrl.offpeakProfilesLoading = false;
                ctrl.offPeakSchedules = resp.data.wsScheduleGroupByDate;
                //Show Wizard if no schedules
                ctrl.wizardVisible = ctrl.offPeakSchedules.length == 0 && ctrl.offPeakProfiles.length == 0 ? true : false;
            });
        }, function (resp) {});
    };

    var getEmptyLagPumpProfiles = function getEmptyLagPumpProfiles() {
        var lagPumpsProfiles = [];
        angular.forEach(ctrl.offPeakFillModel.pumpsDetails, function (pumpDetail, index) {
            if (pumpDetail.pumpNumber > 0) {
                lagPumpsProfiles.push({
                    logPumpProfileId: undefined,
                    offPeakProfileId: -1,
                    pumpNumber: pumpDetail.pumpNumber,
                    delay: 0,
                    offPeakTurnOnLevel: null, //ctrl.offPeakFillModel.tankBottom,
                    onPeakTurnOnLevel: pumpDetail.pumpOnPeakTurnOnLevel
                });
            }
        });
        return lagPumpsProfiles;
    };

    ctrl.addEmptyProfile = function () {
        ctrl.fillLevelUnit = true;

        if (!angular.isUndefined(ctrl.editMode) && ctrl.editMode !== null) {
            // already other profile is in edit mode, first bring back that profile to ReadOnly mode
            var previousProfile = ctrl.offPeakProfiles.find(function (tmpProfile) {
                return tmpProfile.offPeakProfileId === ctrl.editMode;
            });
            previousProfile.sliderOptions.disabled = true;
        }
        ctrl.editMode = null; // NOT edit mode
        ctrl.addMode = null;
        var newProfile = {
            name: "",
            wsDeviceId: $scope.stickyProperties.deviceId,
            offPeakProfileId: -1,
            tankOrWellFillLevel: ctrl.offPeakFillModel.tankTop, // setting default level to tank top
            leadOffPeakTurnOnLevel: ctrl.offPeakFillModel.pumpsDetails[0].pumpOnPeakTurnOnLevel,
            leadOnPeakTurnOnLevel: ctrl.offPeakFillModel.pumpsDetails[0].pumpOnPeakTurnOnLevel,
            isPumpsOffOnPeak: false,
            lagProfiles: getEmptyLagPumpProfiles(),
            sliderOptions: {
                floor: ctrl.fillLevelUnit ? ctrl.offPeakFillModel.tankBottom : 0,
                ceil: ctrl.fillLevelUnit ? ctrl.offPeakFillModel.tankTop : 100,
                step: ctrl.fillLevelUnit ? .1 : .01,
                precision: 5,
                disabled: false,
                onChange: function onChange(x, value) {
                    this.tankOrWellFillLevel = Math.round(value * 10) / 10;
                },
                translate: function translate(value) {
                    return ctrl.fillLevelUnit ? value : value + '%';
                }
            }
        };
        ctrl.offPeakProfiles.unshift(newProfile);
        ctrl.addMode = -1; // in Add mode
    };

    ctrl.addProfile = function (inProfile) {
        // based on offPeakProfileId (-1: Add OR >-1:Edit), kick off Add/POST or Update/PUT operation related logic

        // if in Add mode then Post/Add/Insert the profile
        if (ctrl.addMode === inProfile.offPeakProfileId) {
            // Post the profile to web api
            var offPeakAddPromise = $q.defer();
            tankAndWellService.AddOffPeakProfile(ctrl.accountInfo.customerId, inProfile).then(function (resp) {
                offPeakAddPromise.resolve();
                $timeout(function () {
                    inProfile.offPeakProfileId = resp.data.offPeakProfileId;
                    angular.forEach(ctrl.offPeakProfiles, function (profile, index) {
                        profile.sliderOptions = {
                            id: profile.offPeakProfileId,
                            floor: ctrl.fillLevelUnit ? ctrl.offPeakFillModel.tankBottom : 0,
                            ceil: ctrl.fillLevelUnit ? ctrl.offPeakFillModel.tankTop : 100,
                            step: ctrl.fillLevelUnit ? .1 : .01,
                            precision: 5,
                            disabled: true, //read-only mode
                            onEnd: patchSliderLevel, //triggers at the end of slider value change
                            onChange: function onChange(x, value) {
                                profile.tankOrWellFillLevel = Math.round(value * 10) / 10;
                            },
                            translate: function translate(value) {
                                return ctrl.fillLevelUnit ? value : value + '%';
                            }
                        };
                    });
                    inProfile.lagProfiles = resp.data.lagProfiles;
                    ctrl.getOffPeakLagProfileEnabled();
                });
                ctrl.addMode = null; // NOT add mode any more
            }, function (resp) {
                console.log(resp);
            });
        }
    };

    ctrl.editProfile = function (inProfile) {
        if (ctrl.addMode === -1) {
            // if Add Mode, remove dummy/empty profile from the collection
            ctrl.offPeakProfiles.splice(0, 1); //NOTE: dummy profile will be the first element of array
            ctrl.addMode = null;
        }
        if (!angular.isUndefined(ctrl.editMode) && ctrl.editMode !== null) {
            // already other profile is in edit mode, first bring back that profile to ReadOnly mode
            var previousProfile = ctrl.offPeakProfiles.find(function (tmpProfile) {
                return tmpProfile.offPeakProfileId === ctrl.editMode;
            });
            previousProfile.sliderOptions.disabled = true;
        }
        ctrl.editMode = null;
        ctrl.editMode = inProfile.offPeakProfileId; // modify field to Edit mode
        inProfile.sliderOptions.disabled = false;
    };

    ctrl.cancelOperation = function (inProfile) {
        if (ctrl.editMode === inProfile.offPeakProfileId) {
            // if Edit mode, then bring back to read-only display
            inProfile.sliderOptions.disabled = true;
        }
        if (ctrl.addMode === inProfile.offPeakProfileId) {
            // if Add Mode, remove dummy/empty profile from the collection
            ctrl.offPeakProfiles.splice(0, 1); //remove first profile/element which is dummy/empty
        }
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.deleteProfile = function (inProfile) {
        ctrl.offpeakProfilesLoading = true;
        var indexOfProfile = ctrl.offPeakProfiles.findIndex(function (profile) {
            return profile.offPeakProfileId === inProfile.offPeakProfileId;
        });

        // make web api call to delete the profile and its children (lag profiles)
        var offPeakDeletePromise = $q.defer();
        //web api is not required to return any data except success/failure
        tankAndWellService.DeleteOffPeakProfile(ctrl.accountInfo.customerId, inProfile.offPeakProfileId).then(function (resp) {
            offPeakDeletePromise.resolve();
            $timeout(function () {
                ctrl.offpeakProfilesLoading = false;
                ctrl.offPeakProfiles.splice(indexOfProfile, 1); //remove element

                if (inProfile.offPeakProfileId === -1) ctrl.addMode = null; // NOT add mode any more
                ctrl.editMode = null;
            });
        }, function (resp) {
            console.log(resp);
        });
    };

    ctrl.editLeadProfile = function (item, propertyName) {
        if (ctrl.addMode !== inLeadProfile.offPeakProfileId) {
            ctrl.offpeakProfilesLoading = true;
            //patch the profile
            var tmpLeadProfilePatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) === "object" && item[propertyName] !== null ? item[propertyName] : "" };

            var offPeakLeadEditPromise = $q.defer();
            //TODO: after patching make sure web api returns the lead profile that has been updated, and reload returned lead profile into offPeakProfiles object
            tankAndWellService.PatchOffPeakLeadProfile(ctrl.accountInfo.customerId, item.offPeakProfileId, tmpLeadProfilePatch).then(function (resp) {
                offPeakLeadEditPromise.resolve();
                $timeout(function () {
                    ctrl.offpeakProfilesLoading = false;
                    ctrl.offPeakProfiles = resp.data;
                    ctrl.leadOffPeakTurnOnLevelCheck();
                });
            }, function (resp) {
                console.log(resp);
            });
        }
    };

    ctrl.editLagProfile = function (item, inLagProfile) {
        if (ctrl.addMode !== inProfile.offPeakProfileId) {
            ctrl.offpeakProfilesLoading = true;

            //patch the Lag pump profile
            var tmpLagProfilePatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) === "object" && item[propertyName] !== null ? item[propertyName] : "" };

            var offPeakLeadEditPromise = $q.defer();
            //TODO: after patching make sure web api returns the lag profile that has been updated, and reload returned lag profile into offPeakProfiles object
            tankAndWellService.PatchOffPeakLeadProfile(ctrl.accountInfo.customerId, inLagProfile.lagPumpProfileId, tmpLagProfilePatch).then(function (resp) {
                offPeakLeadEditPromise.resolve();
                $timeout(function () {
                    ctrl.offpeakProfilesLoading = false;
                    ctrl.offPeakProfiles = resp.data;
                });
            }, function (resp) {
                console.log(resp);
            });
        }
    };

    var patchSliderLevel = function patchSliderLevel(offPeakProfileId, sliderValue) {
        var foundProfile = ctrl.offPeakProfiles.find(function (profile) {
            return profile.offPeakProfileId === offPeakProfileId;
        });
        ctrl.patchData(foundProfile, 'tankOrWellFillLevel');
    };

    ctrl.patchData = function (item, propertyName) {
        // data validation logic
        if (ctrl.addMode === -1) return false; //no patching allowed in Add Mode

        //Conditions to not patch Data
        if (propertyName != "leadOffPeakTurnOnLevel" && item[propertyName] === null) return false;

        //check if offpeak == onpeak
        //item.leadOffPeakTurnOnLevel = item.leadOffPeakTurnOnLevel == item.leadOnPeakTurnOnLevel ? null : item.leadOffPeakTurnOnLevel;

        //All conditions passed, patch data
        var profilePatch = { "op": "replace", "path": propertyName, "value": item[propertyName] };
        tankAndWellService.PatchOffPeakLeadProfile(ctrl.accountInfo.customerId, item.offPeakProfileId, profilePatch).then(function (resp) {
            //success
        }, function (error) {
            //toaster.pop('error', translationService.translation.text.OFF_PEAK_PROFILES, "Update Error!");
        });
    };

    ctrl.patchLagPumpData = function (item, propertyName) {
        // data validation logic
        if (ctrl.addMode === -1) return false; //no patching allowed in Add Mode

        //Conditions to not patch Data
        if (propertyName != "offPeakTurnOnLevel" && item[propertyName] === null) return false;

        //All conditions passed, patch data
        var lagPumpProfilePatch = { "op": "replace", "path": propertyName, "value": item[propertyName] };
        tankAndWellService.PatchOffPeakLagPumpProfile(ctrl.accountInfo.customerId, item.lagPumpProfileId, lagPumpProfilePatch).then(function (resp) {
            //success
        }, function (error) {
            //toaster.pop('error', translationService.translation.text.OFF_PEAK_PROFILES, "Update Error!");
        });
    };

    ctrl.delete = function (item) {
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE + " " + _translation.text.PROFILE + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            ctrl.deleteProfile(item);
        }, function () {
            // cancel button
        });
    };

    ctrl.fillLevelUnitUpdate = function () {
        angular.forEach(ctrl.offPeakProfiles, function (profile, index) {
            profile.sliderOptions = {
                id: profile.offPeakProfileId,
                floor: ctrl.offPeakFillModel.tankBottom,
                ceil: ctrl.offPeakFillModel.tankTop,
                step: ctrl.fillLevelUnit ? .1 : .01,
                precision: 5,
                onEnd: patchSliderLevel, //triggers at the end of slider value change
                onChange: function onChange(x, value) {
                    profile.tankOrWellFillLevel = Math.round(value * 10) / 10;
                },
                translate: function translate(value, sliderId, label) {
                    if (label == "model") return ctrl.fillLevelUnit ? value : Math.round(value * (100 / (ctrl.offPeakFillModel.tankTop - ctrl.offPeakFillModel.tankBottom))) + '%';else if (label == "ceil" && !ctrl.fillLevelUnit) return '100%';else if (label == "floor" && !ctrl.fillLevelUnit) return '0%';else return value;
                }
            };
        });
    };

    ctrl.updateFillLevel = function (offPeakProfile) {
        // Round 1 Dec Place
        offPeakProfile.tankOrWellFillLevel = Math.round(offPeakProfile.tankOrWellFillLevel * ctrl.decimalRound) / ctrl.decimalRound;
        //Check if value is in range
        if (offPeakProfile.tankOrWellFillLevel > ctrl.offPeakFillModel.tankTop) offPeakProfile.tankOrWellFillLevel = ctrl.offPeakFillModel.tankTop;
        if (offPeakProfile.tankOrWellFillLevel < ctrl.offPeakFillModel.tankBottom) offPeakProfile.tankOrWellFillLevel = ctrl.offPeakFillModel.tankBottom;
        //Patch Update
        ctrl.patchData(offPeakProfile, 'tankOrWellFillLevel');
    };

    ctrl.checkMaxValues = function (offPeakProfile, patchPath) {
        // Round 1 Dec Place if not null
        if (offPeakProfile[patchPath] != null) {
            offPeakProfile[patchPath] = Math.round(offPeakProfile[patchPath] * ctrl.decimalRound) / ctrl.decimalRound;

            //Check if value is in range
            if (offPeakProfile[patchPath] > ctrl.offPeakFillModel.tankTop) offPeakProfile[patchPath] = ctrl.offPeakFillModel.tankTop;
            if (offPeakProfile[patchPath] < ctrl.offPeakFillModel.tankBottom) offPeakProfile[patchPath] = ctrl.offPeakFillModel.tankBottom;
        } else if (offPeakProfile.leadOffPeakTurnOnLevel == null) {
            offPeakProfile.leadOffPeakTurnOnLevel = 0;
        }
        //Patch Update
        ctrl.patchData(offPeakProfile, patchPath);
    };

    ctrl.checkMaxSeconds = function (offPeakProfile, patchPath) {
        // Round 1 Dec Place
        offPeakProfile[patchPath] = Math.round(offPeakProfile[patchPath]);
        //Check if value is in range
        if (offPeakProfile[patchPath] > 86400) offPeakProfile[patchPath] = 86400;
        if (offPeakProfile[patchPath] < 0) offPeakProfile[patchPath] = 0;
        //Patch Update
        ctrl.patchLagPumpData(offPeakProfile, patchPath);
    };

    ctrl.checkOffPeakLevel = function (offPeakProfile, patchPath, profile) {
        // Round 1 Dec Place if not null
        if (offPeakProfile[patchPath] != null) {
            offPeakProfile[patchPath] = Math.round(offPeakProfile[patchPath] * ctrl.decimalRound) / ctrl.decimalRound;
            //Check if value is in range
            if (offPeakProfile[patchPath] > profile.leadOffPeakTurnOnLevel) offPeakProfile[patchPath] = profile.leadOffPeakTurnOnLevel;
            if (offPeakProfile[patchPath] < ctrl.offPeakFillModel.tankBottom) offPeakProfile[patchPath] = ctrl.offPeakFillModel.tankBottom;
        } else {
            offPeakProfile.enabled = false;
        }
        //Patch Update
        ctrl.patchLagPumpData(offPeakProfile, patchPath);
    };

    ctrl.checkOffPeakLevelEnabled = function (offPeakProfile, patchPath, enabled) {
        if (!enabled) {
            offPeakProfile[patchPath] = null;

            //Patch offPeakTurnOnLevel to null
            ctrl.patchLagPumpData(offPeakProfile, patchPath);

            //Patch delat to 0
            offPeakProfile.delay = 0;
            ctrl.patchLagPumpData(offPeakProfile, "delay");
        }
    };

    ctrl.patchName = function (offPeakProfile, patchPath) {
        //Cannot be less than 3 or greater than 50
        if (offPeakProfile.name.length < 3) return;
        if (offPeakProfile.name.length > 50) offPeakProfile.name = offPeakProfile.name.slice(0, 50);

        //Delay patch to account for typing
        if (angular.isDefined(ctrl.delayPatch)) {
            $timeout.cancel(ctrl.delayPatch);
        }
        ctrl.delayPatch = $timeout(function () {
            if (offPeakProfile.name.length < 3) return;
            ctrl.patchData(offPeakProfile, patchPath);
        }, 1000);
    };

    ctrl.validateAllNames = function () {
        var invalidCount = 0;
        angular.forEach(ctrl.offPeakProfiles, function (profile) {
            if (profile.name.length < 3) {
                invalidCount++;
            }
        });
        return invalidCount;
    };

    ctrl.adjustSliderSize = function () {
        $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');
        }, 10);
    };

    $scope.$on('offPeakWizard', function () {
        ctrl.wizardVisible = false;
        ctrl.loadOffPeakProfiles(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId); // http call for webapi
    });

    $scope.$on('contentAdjusted', function () {
        ctrl.adjustSliderSize();
    });
}

angular.module('mc.tankandwell').controller('twSetupOffpeakProfilesController', TWSetupOffpeakProfilesController);
TWSetupOffpeakProfilesController.$inject = ['$', '$q', '$rootScope', '$scope', '$timeout', 'authenticationService', 'translationService', 'sharedSetupService', 'tankAndWellService', '$uibModal', 'unsavedChangesService', 'tankAndWellOffPeakScheduleService'];
'use strict';

angular.module('mc.tankandwell').component('tankAndWellSetupOffpeakProfile', {
    controller: 'twSetupOffpeakProfilesController',
    templateUrl: 'ui/tankandwell/setup/offpeakprofiles/tw-setup-offpeak-profiles-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

function TWSetupLabelsController($rootScope, $scope, authenticationService, translationService, sharedSetupService, tankAndWellService, digitalSettingService, $q, $timeout) {
    var ctrl = this;
    ctrl.labelsLoading = true;
    ctrl.destPumpArray = [];
    ctrl.maxRunningPumpsError = false;
    ctrl.delayTimeError = false;
    ctrl.translation = translationService.translation;
    ctrl.options = [];
    ctrl.propPatches = []; // refers list of user changes 

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        tankAndWellService.checkUnsavedChanges = false;

        $scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;

        ctrl.options = generateOptions();

        ctrl.getLabelsSetup($scope.stickyProperties.deviceId, ctrl.accountInfo.customerId); // http call for webapi
    };

    ctrl.getLabelsSetup = function (wsDeviceId, customerId) {
        ctrl.labelsLoading = true;
        var labelsPromise = $q.defer();

        tankAndWellService.GetConfigOptionsSetup(customerId, wsDeviceId, true).then(function (resp) {
            labelsPromise.resolve();
            $timeout(function () {
                ctrl.labelsLoading = false;
            });

            loadData(resp.data);
        }, function (resp) {
            console.log(resp);
        });
    };

    var loadData = function loadData(result) {
        //current source
        ctrl.twCurrentSource = result.sourceDevice; // this object contains current source device (tank) related information
        ctrl.analogSetting = result.analogSetting;

        ctrl.twBasic = result.tankAndWellBasic; // this object contains all the pumps' related information
        ctrl.twPumpsDetail = result.pumpsDetail; // this object contains pumps' device name and channel (relay) description
        ctrl.twConfigOptions = result.tankAndWellConfigOptionsAll; // this object contains DestPumpXMaxRuntimeMinutes, alternatorEnabled, DelayTime information

        ctrl.tank = { deviceAndChannelDesc: ctrl.twCurrentSource.name + " - " + ctrl.analogSetting.name, enabled: true }; //NOTE: Legacy Site is NOT translating the text "Analog"

        // alternate source
        ctrl.twAlternateSource = result.alternateSource;
        if (ctrl.twAlternateSource) {
            //if labelSource is NOT defined then use Device Name as source name
            ctrl.alternateSourceName = !!ctrl.twAlternateSource.labelSource ? ctrl.twAlternateSource.labelSource : ctrl.twAlternateSource.deviceName; // + ' ' + ctrl.translation.text.CHANNEL + ' ' + ctrl.twAlternateSource.channel;
            //ctrl.updateCurrentSource();
        }
        //ctrl.updateSources(result);
        ctrl.currentSourceName = !!ctrl.twConfigOptions.labelSource ? ctrl.twConfigOptions.labelSource : ctrl.twCurrentSource.name; // + ' ' + ctrl.translation.text.CHANNEL + ' ' + ctrl.twBasic.sourceAnalogChannel; //this property logic is required for selecting CurrentSource

        ctrl.updatePumpArray();

        ctrl.boolAlternatorEnabled = ctrl.twConfigOptions.alternatorEnabled == 1;

        ctrl.storeOptions(ctrl.twConfigOptions);
        ctrl.storeCurrentSource(result.sourceDevice);
        ctrl.storeAlternateSource(result.alternateSource);
    };
    var reloadData = function reloadData() {
        //current source
        ctrl.twCurrentSource = JSON.parse(JSON.stringify(ctrl.previousCurrentSource)); // this object contains current source device (tank) related information
        ctrl.twAlternateSource = JSON.parse(JSON.stringify(ctrl.previousAlternateSource));
        ctrl.twConfigOptions = JSON.parse(JSON.stringify(ctrl.previousTwConfigOptions));

        ctrl.tank = { deviceAndChannelDesc: ctrl.twCurrentSource.name + " Analog " + ctrl.twBasic.sourceAnalogChannel, enabled: true }; //NOTE: Legacy Site is NOT translating the text "Analog"

        // alternate source
        if (ctrl.twAlternateSource) {
            //if labelSource is NOT defined then use Device Name as source name
            ctrl.alternateSourceName = !!ctrl.twAlternateSource.labelSource ? ctrl.twAlternateSource.labelSource : ctrl.twAlternateSource.deviceName;
        }
        ctrl.currentSourceName = !!ctrl.twConfigOptions.labelSource ? ctrl.twConfigOptions.labelSource : ctrl.twCurrentSource.name; //this property logic is required for selecting CurrentSource

        ctrl.updatePumpArray();

        ctrl.boolAlternatorEnabled = ctrl.twConfigOptions.alternatorEnabled == 1;
    };

    ctrl.updatePumpArray = function () {
        // create pump array for binding processed/calculated values with UI
        ctrl.destPumpArray = [];
        var tmpArray = [];

        for (var j = 1; j <= 5; j++) {
            var pumpLabel = ctrl.twConfigOptions["labelPump" + j];
            var runtimeVal = ctrl.twConfigOptions["destPump" + j + "MaxRuntimeMinutes"];
            var deviceAndChannelDesc = ctrl.setPumpDeviceAndChannelDesc(ctrl.twBasic["destPump" + j + "DeviceId"], ctrl.twBasic["destPump" + j + "Relay"]); // this variable helps to identify given pump is really setup as pump in ParmDigital table
            if (ctrl.twBasic["destPump" + j + "DeviceId"] !== 0
            //&& !!deviceAndChannelDesc
            ) {
                    tmpArray.push({
                        pumpId: j,
                        pumpName: ctrl.translation.text["PUMP_" + j + "_LABEL"],
                        pumpLabel: pumpLabel,
                        deviceAndChannelDesc: deviceAndChannelDesc,
                        image: 'pump_1.gif', // hard coding the image as there is no relation to depend on digital input image //ctrl.getPumpImage(ctrl.twBasic[`destPump${j}DeviceId`], ctrl.twBasic[`destPump${j}Relay`]),
                        channel: ctrl.twBasic["destPump" + j + "Relay"],
                        runtimeVal: runtimeVal,
                        options: ctrl.getOptions(runtimeVal),
                        selectedOption: ctrl.findOption(runtimeVal)
                    });
                }
        }
        // sort the array
        ctrl.destPumpArray = tmpArray.sort(compare);
    };

    var compare = function compare(a, b) {
        if (a.pumpId < b.pumpId) return -1;
        if (a.pumpId > b.pumpId) return 1;
        return 0;
    };

    //this function useful for comparing user input with existing data, to make decision whether user made changes to data or not
    ctrl.storeCurrentSource = function (currentSource) {
        ctrl.previousCurrentSource = JSON.parse(JSON.stringify(currentSource));
    };
    //this function useful for comparing user input with existing data, to make decision whether user made changes to data or not
    ctrl.storeAlternateSource = function (alternateSource) {
        ctrl.previousAlternateSource = JSON.parse(JSON.stringify(alternateSource));
    };
    //this function useful for comparing user input with existing data, to make decision whether user made changes to data or not
    ctrl.storeOptions = function (options) {
        ctrl.previousTwConfigOptions = JSON.parse(JSON.stringify(options));
    };

    ctrl.setPumpDeviceAndChannelDesc = function (deviceId, channelNum) {
        for (var i = 0; i < ctrl.twPumpsDetail.length; i++) {
            if (ctrl.twPumpsDetail[i].deviceId == deviceId && ctrl.twPumpsDetail[i].channel == channelNum) return ctrl.twPumpsDetail[i].deviceName + " - " + ctrl.twPumpsDetail[i].description;
        }
    };

    ctrl.getPumpImage = function (deviceId, channelNum) {
        for (var i = 0; i < ctrl.twPumpsDetail.length; i++) {
            if (ctrl.twPumpsDetail[i].deviceId == deviceId && ctrl.twPumpsDetail[i].channel == channelNum) return ctrl.twPumpsDetail[i].image;
        }
    };

    var generateOptions = function generateOptions() {
        var tmpOptions = [{ name: ctrl.translation.text.NOT_LIMITED, id: 0 }, { name: '0.25', id: 15 }, { name: '0.5', id: 30 }];
        //generate options for 1 - 24 hours
        for (var i = 1; i <= 24; i++) {
            tmpOptions.push({ name: i, id: 60 * i });
        }

        return tmpOptions;
    };

    ctrl.getOptions = function (runtimeVal) {
        var data = { availableOptions: ctrl.getTranslatedOptions(), selectedOption: ctrl.findOption(runtimeVal) };
        return data;
    };

    ctrl.findOption = function (optionId) {
        for (var i = 0; i < ctrl.options.length; i++) {
            if (ctrl.options[i].id == optionId) return ctrl.options[i];
        }
    };

    ctrl.getTranslatedOptions = function () {
        for (var i = 0; i < ctrl.options.length; i++) {
            if (ctrl.options[i].id == 0) {
                ctrl.options[i].name = "" + ctrl.translation.text.NOT_LIMITED;
                break;
            }
        }
        return ctrl.options;
    };

    // following logic carried over from legacy 123mc.com
    ctrl.showAlternator = function () {
        var retVal = true;
        var custId = ctrl.accountInfo.customerId;
        var wsDevId = $scope.stickyProperties.deviceId;
        if (custId != 10385 && custId != 10357 && custId != 10920 && wsDevId != 13 && wsDevId != 41 && wsDevId != 98 && wsDevId != 176 && wsDevId != 219 && wsDevId != 1343 && ctrl.destPumpArray.length <= 1) {
            retVal = false;
        }
        return retVal;
    };

    ctrl.onChangeAlternateSource = function (altSourceName) {
        //patch = {"op":"replace", patchColl:[{"key":"currentLeadPump","value":"2"}, {"propName":"currentLagPump","value":"3"}]}
        //var propPatches = [];
        if (altSourceName != ctrl.alternateSourceName) //if call is not from alternate source radio, then no action is required.
            return;

        if (ctrl.twAlternateSource) {
            var propPatch = { key: 'CurrentSourceDeviceID', value: ctrl.twBasic.sourceDeviceId };
            ctrl.propPatches.push(propPatch);
            propPatch = { key: 'CurrentSourceName', value: ctrl.twConfigOptions.labelSource };
            ctrl.propPatches.push(propPatch);
            propPatch = { key: 'CurrentSourceChannel', value: ctrl.twBasic.sourceAnalogChannel };
            ctrl.propPatches.push(propPatch);
            propPatch = { key: 'NewSourceDeviceID', value: ctrl.twAlternateSource.deviceId };
            ctrl.propPatches.push(propPatch);
            propPatch = { key: 'NewSourceName', value: ctrl.twAlternateSource.labelSource };
            ctrl.propPatches.push(propPatch);
            propPatch = { key: 'NewSourceChannel', value: ctrl.twAlternateSource.channel };
            ctrl.propPatches.push(propPatch);

            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
        }
    };

    ctrl.onChangeAlternatorEnabled = function () {
        var curAlternatorEnabled = ctrl.boolAlternatorEnabled ? 1 : 0;
        if (ctrl.previousTwConfigOptions.alternatorEnabled != curAlternatorEnabled) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
            //if item exists in the propPatches, then remove it.
            angular.forEach(ctrl.propPatches, function (item, index) {
                if (item.key == 'AlternatorEnabled') ctrl.propPatches.splice(index, 1);
            });
            //add new patch
            ctrl.propPatches.push({
                key: 'AlternatorEnabled', value: curAlternatorEnabled
            });
        }
    };

    ctrl.onChangeDelayTime = function () {
        if (!ctrl.isValidDelayTime()) {
            ctrl.twConfigOptions.delayTime = ctrl.previousTwConfigOptions.delayTime;
            ctrl.delayTimeError = false;
            return;
        }

        var curDelayTime = ctrl.twConfigOptions.delayTime;
        if (ctrl.previousTwConfigOptions.delayTime != curDelayTime) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
            //if item exists in the propPatches, then remove it.
            angular.forEach(ctrl.propPatches, function (item, index) {
                if (item.key == 'DelayTime') ctrl.propPatches.splice(index, 1);
            });
            //add new patch
            ctrl.propPatches.push({
                key: 'DelayTime', value: curDelayTime
            });
        }
    };
    ctrl.isValidDelayTime = function () {

        if (!ctrl.twConfigOptions.delayTime || ctrl.twConfigOptions.delayTime > 2147483647 || ctrl.twConfigOptions.delayTime < 0) {
            ctrl.delayTimeError = true;
            ctrl.delayTimeTooltip = ctrl.translation.text.ALLOWED_RANGE + ': ' + 0 + ' ' + ctrl.translation.text.TO + ' 2,147,483,647';
        } else {
            ctrl.delayTimeError = false;
            ctrl.delayTimeTooltip = "";
        }

        return !ctrl.delayTimeError;
    };

    ctrl.onChangeMaxRunningPumps = function () {
        if (!ctrl.isValidMaxRunningPumps()) {
            ctrl.twConfigOptions.maxNumberRunningPumps = ctrl.previousTwConfigOptions.maxNumberRunningPumps;
            ctrl.maxRunningPumpsError = false;
            return;
        }

        var curMaxRunningPumps = ctrl.twConfigOptions.maxNumberRunningPumps;
        if (ctrl.previousTwConfigOptions.maxNumberRunningPumps != curMaxRunningPumps) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
            //if item exists in the propPatches, then remove it.
            angular.forEach(ctrl.propPatches, function (item, index) {
                if (item.key == 'MaxNumberRunningPumps') ctrl.propPatches.splice(index, 1);
            });
            //add new patch
            ctrl.propPatches.push({
                key: 'MaxNumberRunningPumps', value: curMaxRunningPumps
            });
        }
    };

    ctrl.isValidMaxRunningPumps = function () {

        if (!ctrl.twConfigOptions.maxNumberRunningPumps || ctrl.twConfigOptions.maxNumberRunningPumps > ctrl.destPumpArray.length || ctrl.twConfigOptions.maxNumberRunningPumps < 0) {
            ctrl.maxRunningPumpsError = true;
            ctrl.maxRunningPumpsTooltip = ctrl.translation.text.ALLOWED_RANGE + ': ' + 0 + ' ' + ctrl.translation.text.TO + ' ' + ctrl.destPumpArray.length;
        } else {
            ctrl.maxRunningPumpsError = false;
            ctrl.maxRunningPumpsTooltip = "";
        }

        return !ctrl.maxRunningPumpsError;
    };

    this.onChangeSourceLabel = function () {
        if (ctrl.previousTwConfigOptions.labelSource != ctrl.twConfigOptions.labelSource) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
            //if item exists in the propPatches, then remove it.
            angular.forEach(ctrl.propPatches, function (item, index) {
                if (item.key == 'LabelSource') ctrl.propPatches.splice(index, 1);
            });
            //add new patch
            ctrl.propPatches.push({
                key: 'LabelSource', value: ctrl.twConfigOptions.labelSource
            });
        }
    };

    this.onChangePumpLabel = function (pumpId) {
        var newLabel = ctrl.destPumpArray[pumpId - 1].pumpLabel;
        if (ctrl.previousTwConfigOptions["labelPump" + pumpId] != newLabel) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
            //if item exists in the propPatches, then remove it.
            angular.forEach(ctrl.propPatches, function (item, index) {
                if (item.key == 'LabelPump' + pumpId) ctrl.propPatches.splice(index, 1);
            });
            //add new patch
            ctrl.propPatches.push({
                key: 'LabelPump' + pumpId, value: newLabel
            });
        }
    };

    ctrl.onChangePumpRuntimeMinutes = function (idx) {
        var curVal = ctrl.destPumpArray[idx - 1].selectedOption.id;
        var patchPath = 'destPump' + ctrl.destPumpArray[idx - 1].pumpId + 'MaxRuntimeMinutes';
        var oldVal = ctrl.previousTwConfigOptions[patchPath];

        if (oldVal != curVal) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
            //if item exists in the propPatches, then remove it.
            angular.forEach(ctrl.propPatches, function (item, index) {
                if (item.key == patchPath) ctrl.propPatches.splice(index, 1);
            });
            //add new patch
            ctrl.propPatches.push({
                key: patchPath, value: curVal
            });
        }
    };

    ctrl.saveAll = function () {
        //perform data validation, if any

        //create the patches, for the changes 
        ctrl.labelsLoading = true;

        //if patches exists, then send it to webapi to udpate them
        if (ctrl.propPatches.length > 0) {
            //const patch = { op: 'replace', path: 'DelayTime', value: curDelayTime };
            var patches = { op: 'replace', patchColl: ctrl.propPatches };
            tankAndWellService.PatchConfigOptionsSetup(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, patches).then(function (resp) {

                loadData(resp.data);

                //notify other views that are bound to Source label information etc...
                $scope.stickyProperties.device.title = undefined;
                $rootScope.$broadcast('alternateSourceUpdated');

                ctrl.isDirty = false;
                ctrl.labelsLoading = false;
                $scope.alerts = [];
                ctrl.propPatches = [];
                tankAndWellService.tabPopupWarningOn = false;
            }, function (resp) {
                //display error message
                var errormsg = "Your selections are not saved. Please try again."; //TODO: translate the text, after it is approved
                $scope.alerts = [];
                $scope.alerts.push({ msg: errormsg, type: "danger" });

                ctrl.labelsLoading = false;
                //console.log(resp);
            });
        }
    };

    ctrl.cancel = function () {
        ctrl.labelsLoading = true;
        //reloading previously stored data
        $timeout(function () {
            reloadData();
            ctrl.isDirty = false;
            $scope.alerts = [];
            tankAndWellService.tabPopupWarningOn = false;
            ctrl.propPatches = [];
            ctrl.labelsLoading = false;
        }, 100);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        $timeout(function () {
            ctrl.updatePumpArray();
        }, 10);
    });
}
angular.module('mc.tankandwell').controller('twSetupLabelsController', TWSetupLabelsController);
TWSetupLabelsController.$inject = ['$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'tankAndWellService', 'digitalSettingService', '$q', '$timeout'];
'use strict';

angular.module('mc.tankandwell').component('tankAndWellSetupLabel', {
    controller: 'twSetupLabelsController',
    templateUrl: 'ui/tankandwell/setup/labels/tw-setup-labels-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function TWSetupDisplayController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, tankAndWellService, $q, $timeout, $filter, toaster, $uibModal) {
    var ctrl = this;
    ctrl.displayLoading = true;
    ctrl.invalidTankRedBelow = false;
    ctrl.invalidTankYellowAbove = false;
    ctrl.showFaultSlider = false;
    ctrl.lowFaultUndefined = false;
    ctrl.isDirty = false;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        tankAndWellService.checkUnsavedChanges = false;

        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') {
            ctrl.isAdmin = true;
        }
        ctrl.translation = translationService.translation;
        $scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;

        ctrl.getDisplaySetup($scope.stickyProperties.deviceId); // http call for webapi
    };

    ctrl.getDisplaySetup = function (wsDeviceId) {
        ctrl.displayLoading = true;
        var displayPromise = $q.defer();

        tankAndWellService.GetDisplaySetup(wsDeviceId).then(function (resp) {
            displayPromise.resolve();
            $timeout(function () {
                ctrl.displayLoading = false;
            }, 10);

            ctrl.displayLoading = true;
            ctrl.groundTank = resp.data;
            ctrl.analogSetting = ctrl.groundTank.analogSettings[0];

            ctrl.max = ctrl.analogSetting.maximumValue;
            ctrl.min = ctrl.analogSetting.minimumValue;

            // make sure user entered value should be between analog setting max & analog setting min
            validateLimits();

            ctrl.storePrevious(ctrl.groundTank);
            ctrl.options = loadSliderOptions();
            if (!!ctrl.groundTank.thresholds[0]) {
                // assuming only one entry exists for thresholds and it is for SourceChannel.
                ctrl.faultSlider.lowAlert = !!ctrl.groundTank.thresholds[0].lowFault == 0 ? undefined : ctrl.groundTank.thresholds[0].lowFault;
                ctrl.faultSlider.highAlert = !!ctrl.groundTank.thresholds[0].highFault == 0 ? undefined : ctrl.groundTank.thresholds[0].highFault;
                if (ctrl.faultSlider.lowAlert == undefined) {
                    ctrl.lowFaultUndefined = true;
                    ctrl.faultSlider.lowAlert = ctrl.faultSlider.highAlert; // slider is going to behave as single pointer slider. minvalue should be present in order one pointer to display
                    ctrl.faultSlider.highAlert = undefined;
                }
                ctrl.faultSlider.options = loadFaultSliderOptions();
                ctrl.showFaultSlider = true;
            } else {
                ctrl.faultSlider.options = undefined;
                ctrl.showFaultSlider = false;
            }
            ctrl.displayLoading = false;
        }, function (resp) {
            console.log(resp);
        });
    };

    var validateLimits = function validateLimits() {
        ctrl.invalidTankDisplayRange = false;

        // make sure user entered value should be between analog setting max & analog setting min
        if (ctrl.groundTank.tankTop > ctrl.max || ctrl.groundTank.tankBottom < ctrl.min) {
            ctrl.invalidTankDisplayRange = true;
            ctrl.invalidTankDisplayRangeMessage = ctrl.translation.text.TW_DISPLAY_RANGE_MESSAGE;
            //"Configure display settings within Analog {0} (min) and {1} (max) range";
            ctrl.invalidTankDisplayRangeMessage = ctrl.invalidTankDisplayRangeMessage.replace("{0}", ctrl.min);
            ctrl.invalidTankDisplayRangeMessage = ctrl.invalidTankDisplayRangeMessage.replace("{1}", ctrl.max);
        }
    };

    ctrl.storePrevious = function (groundTank) {
        ctrl.previousGroundTank = JSON.parse(JSON.stringify(groundTank));
    };

    var loadSliderOptions = function loadSliderOptions() {
        return {
            floor: ctrl.groundTank.tankBottom,
            ceil: ctrl.groundTank.tankTop,
            step: 0.1,
            precision: 1,
            vertical: true,
            draggableRange: true,
            showTicks: false,
            noSwitching: true, // prevents both the sliders to overlap each other
            minRange: 1, // represents min difference between min & max slider values
            pushRange: false, //prevents min/max handles to push each other
            showSelectionBarMax: true,
            hidePointerLabels: true,
            hideLimitLabels: true,
            onEnd: function onEnd(pointerType, newTankRedBelowVal, newTankYellowAboveVal) {
                //console.log("Starts -->  newTankRedBelowVal:" + newTankRedBelowVal + ", newTankYellowAboveVal:" + newTankYellowAboveVal + ", pointerType:" + pointerType);
                ctrl.onChangeTankRedBelow();
                ctrl.onChangeTankYellowAbove();
            }
        };
    };

    ctrl.faultSlider = {
        lowAlert: undefined,
        highAlert: undefined,
        options: {
            //NOTE: options will be lazy loaded 
        }
    };

    var loadFaultSliderOptions = function loadFaultSliderOptions() {
        return {
            floor: ctrl.groundTank.tankBottom,
            ceil: ctrl.groundTank.tankTop,
            step: 0.1,
            precision: 1,
            vertical: true,
            showSelectionBar: false, // prevents to slide using range in addition to individual slider pointers
            draggableRange: false,
            readOnly: true,
            showSelectionBarEnd: false,
            showTicks: false,
            noSwitching: true, // prevents both the sliders to overlap each other
            minRange: 1, // represents min difference between min & max slider values
            pushRange: false,
            showSelectionBarMax: true,
            hidePointerLabels: false,
            hideLimitLabels: true,
            translate: function translate(value, sliderId, label) {
                //Logic for handling translations while both Faults present or single Fault present
                switch (label) {
                    case 'model':
                        var retVal = '' + ctrl.translation.text.LOW_FAULT + ': ' + value;
                        if (!!ctrl.lowFaultUndefined) {
                            retVal = '' + ctrl.translation.text.HIGH_FAULT + ': ' + value;
                        }
                        return retVal;
                    case 'high':
                        return '' + ctrl.translation.text.HIGH_FAULT + ': ' + value;
                    default:
                        return value;
                }
            }
        };
    };

    ctrl.isValidTankTop = function () {
        ctrl.setDefaultValidationValues();

        // make sure user entered value should be between analog setting max & analog setting min
        if (ctrl.groundTank.tankTop <= ctrl.max && ctrl.groundTank.tankTop > ctrl.min && ctrl.groundTank.tankTop > ctrl.groundTank.tankYellowAbove) {
            ctrl.invalidTankTopTooltip = "";
            return true;
        } else {
            ctrl.invalidTankTopTooltip = ctrl.translation.text.ALLOWED_RANGE + ': ' + ctrl.groundTank.tankYellowAbove + ' ' + ctrl.translation.text.TO + ' ' + ctrl.max; //"[Values allowed: between " + ctrl.groundTank.tankTop + " and " + ctrl.groundTank.tankRedBelow + " ]";
            ctrl.invalidTankTop = true;
            return false;
        }
    };

    ctrl.isValidTankYellowAbove = function () {
        ctrl.setDefaultValidationValues();

        // make sure user entered value should be between tankTop & tankRedBelow
        if (ctrl.groundTank.tankYellowAbove <= ctrl.groundTank.tankTop && ctrl.groundTank.tankYellowAbove > ctrl.groundTank.tankBottom && ctrl.groundTank.tankYellowAbove > ctrl.groundTank.tankRedBelow) {
            ctrl.invalidYellowAboveTooltip = "";
            return true;
        } else {
            ctrl.invalidYellowAboveTooltip = ctrl.translation.text.ALLOWED_RANGE + ': ' + ctrl.groundTank.tankRedBelow + ' ' + ctrl.translation.text.TO + ' ' + ctrl.groundTank.tankTop; //"[Values allowed: between " + ctrl.groundTank.tankTop + " and " + ctrl.groundTank.tankRedBelow + " ]";
            ctrl.invalidTankYellowAbove = true;
            return false;
        }
    };

    ctrl.isValidTankRedBelow = function () {
        ctrl.setDefaultValidationValues();

        // make sure user entered value should be between tankYellowAbove & tankBottom 
        if (ctrl.groundTank.tankRedBelow < ctrl.groundTank.tankTop && ctrl.groundTank.tankRedBelow >= ctrl.groundTank.tankBottom && ctrl.groundTank.tankRedBelow < ctrl.groundTank.tankYellowAbove) {
            ctrl.invalidRedBelowTooltip = "";
            return true;
        } else {
            ctrl.invalidRedBelowTooltip = ctrl.translation.text.ALLOWED_RANGE + ': ' + ctrl.groundTank.tankBottom + ' ' + ctrl.translation.text.TO + ' ' + ctrl.groundTank.tankYellowAbove; //     "[Values allowed: between " + ctrl.groundTank.tankYellowAbove + " and " + ctrl.groundTank.tankBottom + " ]";
            ctrl.invalidTankRedBelow = true;
            return false;
        }
    };

    ctrl.isValidTankBottom = function () {
        ctrl.setDefaultValidationValues();

        // make sure user entered value should be between tankYellowAbove & tankBottom 
        if (ctrl.groundTank.tankBottom < ctrl.groundTank.tankRedBelow && ctrl.groundTank.tankBottom >= ctrl.min) {
            ctrl.invalidTankBottomTooltip = "";
            return true;
        } else {
            ctrl.invalidTankBottomTooltip = ctrl.translation.text.ALLOWED_RANGE + ': ' + ctrl.min + ' ' + ctrl.translation.text.TO + ' ' + ctrl.groundTank.tankRedBelow; //     "[Values allowed: between " + ctrl.groundTank.tankYellowAbove + " and " + ctrl.groundTank.tankBottom + " ]";
            ctrl.invalidTankBottom = true;
            return false;
        }
    };

    ctrl.setDefaultValidationValues = function () {
        ctrl.invalidTankTop = false;
        ctrl.invalidTankRedBelow = false;
        ctrl.invalidTankYellowAbove = false;
        ctrl.invalidTankBottom = false;
    };

    ctrl.saveAll = function () {
        if (!ctrl.isValidTankTop()) {
            //reverting invalid value to original value
            ctrl.groundTank.tankTop = ctrl.previousGroundTank.tankTop;
            ctrl.setDefaultValidationValues();
            return;
        }
        if (!ctrl.isValidTankBottom()) {
            //reverting invalid value to original value
            ctrl.groundTank.tankBottom = ctrl.previousGroundTank.tankBottom;
            ctrl.setDefaultValidationValues();
            return;
        }
        if (!ctrl.isValidTankYellowAbove()) {
            //reverting invalid value to original value
            ctrl.groundTank.tankYellowAbove = ctrl.previousGroundTank.tankYellowAbove;
            ctrl.setDefaultValidationValues();
            return;
        }
        if (!ctrl.isValidTankRedBelow()) {
            //reverting invalid value to original value
            ctrl.groundTank.tankRedBelow = ctrl.previousGroundTank.tankRedBelow;
            ctrl.setDefaultValidationValues();
            return;
        }

        ctrl.displayLoading = true;
        var propPatches = [];
        if (ctrl.previousGroundTank.tankTop != ctrl.groundTank.tankTop) {
            propPatches.push({
                key: 'tankTop', value: ctrl.groundTank.tankTop
            });
        }

        if (ctrl.previousGroundTank.tankBottom != ctrl.groundTank.tankBottom) {
            propPatches.push({
                key: 'tankBottom', value: ctrl.groundTank.tankBottom
            });
        }

        if (ctrl.previousGroundTank.tankYellowAbove != ctrl.groundTank.tankYellowAbove) {
            propPatches.push({
                key: 'tankYellowAbove', value: ctrl.groundTank.tankYellowAbove
            });
        }

        if (ctrl.previousGroundTank.tankRedBelow != ctrl.groundTank.tankRedBelow) {
            propPatches.push({
                key: 'tankRedBelow', value: ctrl.groundTank.tankRedBelow
            });
        }

        if (propPatches.length > 0) {
            //const patch = { op: 'replace', path: 'DelayTime', value: curDelayTime };
            var patches = { op: 'replace', patchColl: propPatches };
            tankAndWellService.PatchDisplaySetup(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, patches).then(function (resp) {
                ctrl.groundTank = resp.data;
                ctrl.groundTank.unit = ctrl.previousGroundTank.unit;
                ctrl.storePrevious(ctrl.groundTank);
                ctrl.refreshTankLimits();
                // make sure user entered value should be between analog setting max & analog setting min
                validateLimits();

                ctrl.isDirty = false;
                tankAndWellService.tabPopupWarningOn = false;
                ctrl.displayLoading = false;
                $scope.alerts = [];
            }, function (resp) {
                //display error message
                var errormsg = "Your selections are not saved. Please try again."; //TODO: translate the text, after it is approved
                $scope.alerts = [];
                $scope.alerts.push({ msg: errormsg, type: "danger" });

                ctrl.displayLoading = false;
                //console.log(resp);
            });
        }
    };

    ctrl.cancel = function () {
        ctrl.groundTank = JSON.parse(JSON.stringify(ctrl.previousGroundTank)); // this object contains all the pumps' related information

        ctrl.isDirty = false;
        $scope.alerts = [];
        tankAndWellService.tabPopupWarningOn = false;
    };

    this.onChangeTankTop = function () {
        if (!ctrl.isValidTankTop()) {
            //reverting invalid value to original value
            ctrl.groundTank.tankTop = ctrl.previousGroundTank.tankTop;
            ctrl.setDefaultValidationValues();
            return;
        }
        if (ctrl.previousGroundTank.tankTop != ctrl.groundTank.tankTop) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
        }
    };

    this.onChangeTankBottom = function () {
        if (!ctrl.isValidTankBottom()) {
            //reverting invalid value to original value
            ctrl.groundTank.tankBottom = ctrl.previousGroundTank.tankBottom;
            ctrl.setDefaultValidationValues();
            return;
        }
        if (ctrl.previousGroundTank.tankBottom != ctrl.groundTank.tankBottom) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
        }
    };

    this.onChangeTankYellowAbove = function () {
        if (!ctrl.isValidTankYellowAbove()) {
            //reverting invalid value to original value
            ctrl.groundTank.tankYellowAbove = ctrl.previousGroundTank.tankYellowAbove;
            ctrl.setDefaultValidationValues();
            return;
        }
        if (ctrl.previousGroundTank.tankYellowAbove != ctrl.groundTank.tankYellowAbove) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
        }
    };

    this.onChangeTankRedBelow = function () {
        if (!ctrl.isValidTankRedBelow()) {
            //reverting invalid value to original value
            ctrl.groundTank.tankRedBelow = ctrl.previousGroundTank.tankRedBelow;
            ctrl.setDefaultValidationValues();
            return;
        }
        if (ctrl.previousGroundTank.tankRedBelow != ctrl.groundTank.tankRedBelow) {
            ctrl.isDirty = true;
            tankAndWellService.tabPopupWarningOn = true;
        }
    };

    $scope.$on('updatePreferencesLanguage', function () {
        // slider will reload when different language selection is made
        $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');
        }, 10);
    });

    ctrl.refreshTankLimits = function () {
        $timeout(function () {
            ctrl.options = loadSliderOptions(); //update floor & ceil values of the rzSlider
            $scope.$broadcast('rzSliderForceRender');
        });
    };

    $scope.$on('rtuAnalogUpdate', function (event, args) {
        var dataChanged = "minimumValue, maximumValue";
        if (args.deviceId == ctrl.analogSetting.deviceId && ctrl.analogSetting.channel == args.channel && dataChanged.includes(args.fieldName)) {
            args.newSetting.forEach(function (analogSetting) {
                if (analogSetting.channel == ctrl.analogSetting.channel) {
                    ctrl.max = analogSetting.maximumValue;
                    ctrl.min = analogSetting.minimumValue;
                }
            });

            // make sure user entered value should be between analog setting max & analog setting min
            validateLimits();
        }
    });
}

angular.module('mc.tankandwell').controller('twSetupDisplayController', TWSetupDisplayController);
TWSetupDisplayController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'tankAndWellService', '$q', '$timeout', '$filter', 'toaster', '$uibModal'];
'use strict';

angular.module('mc.tankandwell').component('tankAndWellSetupDisplay', {
    controller: 'twSetupDisplayController',
    templateUrl: 'ui/tankandwell/setup/display/tw-setup-display-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function TWSetupController($rootScope, $scope, $location, authenticationService, translationService, sharedSetupService, openViewService, tankAndWellService, wizardSplashService, $uibModal, unsavedChangesService) {
    var _this2 = this;

    var ctrl = this;
    sharedSetupService.getWindowId(ctrl);
    ctrl.tabConfiguration = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        $scope.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        ctrl.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.stickyProperties.device.title = undefined;
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { windowId: $scope.windowId });

        if (ctrl.accountInfo.userRole !== 'Administrator' && ctrl.accountInfo.userRole !== 'SuperAdministrator') {
            ctrl.readOnlyTW = true;
        }

        ctrl.initializeSetting();

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, tankAndWellService.tabPopupWarningOn);
            });
        }
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {

        _tabConfiguration({
            "id": "Pump Positions",
            "name": $scope.translation.text.TANK_AND_WELL_PUMP_POSITIONS,
            "templateName": "tw-setup-pump-position-template",
            "templateUrl": "ui/tankandwell/setup/pumppositions/tw-setup-pumppositions-template.html",
            "height": 135
        }, {
            "id": "Tank Display",
            "name": $scope.translation.text.TANK_AND_WELL_TANK_DISPLAY,
            "templateName": "tw-setup-display-template",
            "templateUrl": "ui/tankandwell/setup/display/tw-setup-display-template.html",
            "height": 135
        }, {
            "id": "Set Points",
            "name": $scope.translation.text.TANK_AND_WELL_SET_POINTS,
            "templateName": "tw-setup-set-point-template",
            "templateUrl": "ui/tankandwell/setup/setpoints/tw-setup-setpoints-template.html",
            "height": 135
        }, {
            "id": "Options", //NOTE: labels tab has been renamed to Options
            "name": $scope.translation.text.TANK_AND_WELL_CONFIG_OPTIONS,
            "templateName": "tw-setup-label-template",
            "templateUrl": "ui/tankandwell/setup/labels/tw-setup-labels-template.html",
            "height": 135
        }, {
            "id": "OffpeakSchedules",
            "name": $scope.translation.text.OFF_PEAK_SCHEDULES,
            "templateName": "tw-setup-offpeak-schedules-template",
            "templateUrl": "ui/tankandwell/setup/offpeakschedules/tw-setup-offpeak-schedules-template.html",
            "height": 135 //,
            //{
            //    "id": "OffpeakProfiles", 
            //    "name": $scope.translation.text.OFF_PEAK_PROFILES,
            //    "templateName": "tw-setup-offpeak-profiles-template",
            //    "templateUrl": "ui/tankandwell/setup/offpeakprofiles/tw-setup-offpeak-profiles-template.html",
            //    "height": 135
            //}
        });

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            if (!ctrl.stickyProperties.device.title) {
                var devId = ctrl.stickyProperties.device.wsDeviceId || ctrl.stickyProperties.deviceId;
                tankAndWellService.GetBasicInfo(devId, ctrl.accountInfo.customerId).then(function (resp) {
                    ctrl.stickyProperties.significantDecimals = sharedSetupService.getNumberOfDecimals(resp.data.analogSetting.maximumValue, resp.data.analogSetting.minimumValue);
                    ctrl.stickyProperties.device.title = ctrl.getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                    ctrl.popup.dialog('option', 'title', $scope.translation.text.TANK_AND_WELL_SETUP + ', ' + ctrl.stickyProperties.device.title);
                });
            } else {
                ctrl.popup.dialog('option', 'title', $scope.translation.text.TANK_AND_WELL_SETUP + ', ' + ctrl.stickyProperties.device.title);
            }

            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                ctrl.popup.parent().find('.tab-content').css("height", 'auto');
                ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        } else {

            if (!ctrl.stickyProperties.deviceId) {
                $location.path('/tankandwell/overview/template');
            }
        }

        var devId = ctrl.stickyProperties.device.wsDeviceId || ctrl.stickyProperties.deviceId;
        if (!ctrl.stickyProperties.device.title && !!devId) {
            tankAndWellService.GetBasicInfo(devId, ctrl.accountInfo.customerId).then(function (resp) {
                ctrl.stickyProperties.device.title = ctrl.getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                ctrl.title = ctrl.stickyProperties.device.title;
            });
        } else {
            ctrl.title = ctrl.stickyProperties.device.title;
        }
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }
        return 'ui/tankandwell/setup/' + tab.templateName.toLowerCase().replace(' ', '-') + '-tab.html';
    };

    //add or remove expansion module
    ctrl.exitWithoutSavingConfirmation = function ($event, $selectedIndex) {

        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            this.tmpConfirmHeader = _translation.text.CONFIRM;
            this.tmpConfirmMessageA = _translation.text.EXIT_WITHOUT_SAVE;
            //this.tmpConfirmMessageB = _translation.text.EXIT_WITHOUT_SAVE;

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        };

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/tankandwell/setup/switching-tab-warning-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            ctrl.activeTab = $selectedIndex;
            tankAndWellService.tabPopupWarningOn = false;
        }, function () {
            $event.preventDefault(); // cancel button
        });
    };

    ctrl.selectTab = function (index) {
        ctrl.activeTab = index;
    };

    ctrl.deselectTab = function ($event, $selectedIndex) {
        if (tankAndWellService.tabPopupWarningOn) {
            $event.preventDefault();
            ctrl.exitWithoutSavingConfirmation($event, $selectedIndex);
        }
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on('alternateSourceUpdated', function () {
        ctrl.initializeSetting();
    });

    ctrl.getTitle = function (deviceName, sourceName, channel, channelName) {
        var title = '';

        if (sourceName) {
            title += sourceName;
        } else {
            title += deviceName;
        }

        if (channelName) {
            title += ' : ' + channelName;
        } else {
            title += ' : ' + ctrl.translation.text.CHANNEL + ' ' + channel;
        }

        return title;
    };

    ctrl.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return 'TWSETUP';
    };

    ctrl.getContainerHeight = function () {
        if ($rootScope.classicView) {
            return 'calc(100% - 15px)';
        } else if ($rootScope.mobile) {
            return 'calc(100% - 38px)';
        }
        return '100%';
    };

    ctrl.openView = function (varUrl) {
        $location.path(varUrl);
    };

    ctrl.setupTabs = ctrl.tabConfiguration;

    //ctrl.$onDestroy = () => {
    //};
};

angular.module('mc.tankandwell').controller('twSetupController', TWSetupController);
TWSetupController.$inject = ['$rootScope', '$scope', '$location', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'tankAndWellService', 'wizardSplashService', '$uibModal', 'unsavedChangesService'];
'use strict';

function TWSetupConfigOptionsController($scope, authenticationService, translationService, sharedSetupService, tankAndWellService, $q, $timeout) {
    var ctrl = this;
    ctrl.optionsLoading = true;
    ctrl.destPumpArray = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();

        ctrl.translation = translationService.translation;

        tankAndWellService.checkUnsavedChanges = false;

        $scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;

        ctrl.getModel($scope.stickyProperties.deviceId);
    };

    // get ALL the INFORMATION required to load the tab
    ctrl.getModel = function (wsDeviceId) {
        ctrl.optionsLoading = true;
        var tabPromise = $q.defer();

        tankAndWellService.GetConfigOptionsSetup(ctrl.accountInfo.customerId, wsDeviceId).then(function (resp) {
            tabPromise.resolve();
            $timeout(function () {
                ctrl.optionsLoading = false;
            });

            ctrl.twBasic = resp.data.tankAndWellBasic; // this object contains all the pumps' related information
            ctrl.twLabels = resp.data.tankAndWellLabels;
            ctrl.twConfigOptions = resp.data.tankAndWellConfigOptions; // this object contains DestPumpXMaxRuntimeMinutes, alternatorEnabled, DelayTime information
            ctrl.updateSources(resp.data);

            ctrl.updatePumpArray();

            ctrl.boolAlternatorEnabled = ctrl.twConfigOptions.alternatorEnabled == 1;

            ctrl.getOptions(); //Options to Display

            ctrl.storePreviousOptions(ctrl.twConfigOptions);
        }, function (resp) {
            console.log(resp);
        });
    };

    ctrl.updateSources = function (data) {
        ctrl.twPrimarySource = data.sourceDevice;
        ctrl.twAlternateSource = data.alternateSource;

        if (ctrl.twAlternateSource) {
            ctrl.alternateSourceName = !!ctrl.twAlternateSource.labelSource ? ctrl.twAlternateSource.labelSource : ctrl.twAlternateSource.deviceName + ' ' + ctrl.translation.text.CHANNEL + ' ' + ctrl.twAlternateSource.channel;
            ctrl.twAlternateSource.labelSource = ctrl.alternateSourceName;
            ctrl.primarySourceName = ctrl.twLabels.labelSource ? ctrl.twLabels.labelSource : ctrl.twPrimarySource.name;
            ctrl.twPrimarySource.name = ctrl.primarySourceName;
        }
    };

    // following logic carried over from legacy 123mc.com
    ctrl.showAlternator = function () {
        var retVal = true;
        var custId = ctrl.accountInfo.customerId;
        var wsDevId = $scope.stickyProperties.deviceId;
        if (custId != 10385 && custId != 10357 && custId != 10920 && wsDevId != 13 && wsDevId != 41 && wsDevId != 98 && wsDevId != 176 && wsDevId != 219 && wsDevId != 1343 && ctrl.destPumpArray.length <= 1) {
            retVal = false;
        }

        return retVal;
    };

    //this function useful for comparing user input with existing data, to make decision whether user made changes to data or not
    ctrl.storePreviousOptions = function (options) {
        ctrl.previousTwConfigOptions = JSON.parse(JSON.stringify(options));
    };

    // this function useful to update labels once user input is saved.
    ctrl.updateOptions = function (options) {
        ctrl.twConfigOptions = options;
        ctrl.storePreviousOptions(options);
    };

    //TODO: May be translate following -- 
    ctrl.options = [{ name: 'Not Limited', id: 0 }, { name: 'One Hour', id: 60 }, { name: 'Two Hours', id: 120 }, { name: 'Four Hours', id: 240 }, { name: 'Six Hours', id: 360 }];

    ctrl.getOptions = function (runtimeVal) {
        var data = { availableOptions: ctrl.options, selectedOption: ctrl.findOption(runtimeVal) };
        return data;
    };

    ctrl.findOption = function (optionId) {
        for (var i = 0; i < ctrl.options.length; i++) {
            if (ctrl.options[i].id == optionId) return ctrl.options[i];
        }
    };

    ctrl.updatePumpArray = function () {
        // create pump array for binding processed/calculated values with UI
        ctrl.destPumpArray = [];
        for (var j = 1; j <= 5; j++) {
            var pumpLabel = ctrl.twLabels['labelPump' + j];
            var runtimeVal = ctrl.twConfigOptions['destPump' + j + 'MaxRuntimeMinutes'];
            if (ctrl.twBasic['destPump' + j + 'DeviceId'] !== 0) {
                ctrl.destPumpArray.push({
                    pumpId: j,
                    label: angular.isUndefined(pumpLabel) || !angular.isString(pumpLabel) ? ctrl.translation.text.PUMP + ' ' + j : pumpLabel,
                    runtimeVal: runtimeVal,
                    options: ctrl.getOptions(runtimeVal),
                    selectedOption: ctrl.findOption(runtimeVal)
                });
            }
        }
    };

    ctrl.saveAlternateSource = function (altSourceName) {
        //patch = {"op":"replace", patchColl:[{"key":"currentLeadPump","value":"2"}, {"propName":"currentLagPump","value":"3"}]}
        var propPatches = [];
        if (altSourceName != ctrl.twAlternateSource.labelSource) //if call is not from alternate source radio, then no action is required.
            return;

        if (ctrl.twAlternateSource) {
            var propPatch = { key: 'CurrentSourceDeviceID', value: ctrl.twBasic.sourceDeviceId };
            propPatches.push(propPatch);
            propPatch = { key: 'CurrentSourceName', value: ctrl.twPrimarySource.name };
            propPatches.push(propPatch);
            propPatch = { key: 'CurrentSourceChannel', value: ctrl.twBasic.sourceAnalogChannel };
            propPatches.push(propPatch);
            propPatch = { key: 'NewSourceDeviceID', value: ctrl.twAlternateSource.deviceId };
            propPatches.push(propPatch);
            propPatch = { key: 'NewSourceName', value: ctrl.twAlternateSource.labelSource };
            propPatches.push(propPatch);
            propPatch = { key: 'NewSourceChannel', value: ctrl.twAlternateSource.channel };
            propPatches.push(propPatch);
        }

        if (propPatches.length > 0) {
            //const patch = { op: 'replace', patchColl: collectionOfProperties };
            var patch = { op: 'replace', patchColl: propPatches };
            tankAndWellService.PatchAlternateSource(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, patch).then(function (resp) {
                ctrl.getModel($scope.stickyProperties.deviceId);
            }, function (resp) {
                console.log(resp);
            });
        }
    };

    ctrl.saveAlternatorEnabled = function () {
        var curAlternatorEnabled = ctrl.boolAlternatorEnabled ? 1 : 0;
        if (ctrl.previousTwConfigOptions.alternatorEnabled != curAlternatorEnabled) {
            var patch = { op: 'replace', path: 'AlternatorEnabled', value: curAlternatorEnabled };
            tankAndWellService.PatchConfigOptionsSetup(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, patch).then(function (resp) {
                ctrl.updateOptions(resp.data);
            }, function (resp) {
                console.log(resp);
            });
        }
    };

    ctrl.saveDelayTime = function () {
        var curDelayTime = ctrl.twConfigOptions.delayTime;
        if (ctrl.previousTwConfigOptions.delayTime != curDelayTime) {
            var patch = { op: 'replace', path: 'DelayTime', value: curDelayTime };
            tankAndWellService.PatchConfigOptionsSetup(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, patch).then(function (resp) {
                ctrl.updateOptions(resp.data);
            }, function (resp) {
                console.log(resp);
            });
        }
    };

    ctrl.savePumpRuntimeMinutes = function (idx) {
        var curVal = ctrl.destPumpArray[idx].selectedOption.id;
        var patchPath = 'destPump' + ctrl.destPumpArray[idx].pumpId + 'MaxRuntimeMinutes';
        var oldVal = ctrl.previousTwConfigOptions[patchPath];

        if (oldVal != curVal) {
            var patch = { op: 'replace', path: patchPath, value: curVal };
            tankAndWellService.PatchConfigOptionsSetup(ctrl.accountInfo.customerId, $scope.stickyProperties.deviceId, patch).then(function (resp) {
                ctrl.updateOptions(resp.data);
            }, function (resp) {
                console.log(resp);
            });
        }
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.updatePumpArray();
    });
}
angular.module('mc.tankandwell').controller('twSetupConfigOptionsController', TWSetupConfigOptionsController);
TWSetupConfigOptionsController.$inject = ['$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'tankAndWellService', '$q', '$timeout'];
'use strict';

angular.module('mc.tankandwell').component('tankAndWellSetupConfigOption', {
    controller: 'twSetupConfigOptionsController',
    templateUrl: 'ui/tankandwell/setup/configoptions/tw-setup-configoptions-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.tankandwell').component('tankAndWellSetup', {
    controller: 'twSetupController',
    templateUrl: 'ui/tankandwell/setup/tw-setup-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function TicketSystemAdminCreateController($, $rootScope, $scope, $sce, $element, $timeout, host, authenticationService, translationService, sharedSetupService, openViewService, deviceMenuService, ticketSystemService, ticketSystemAdminService, attchmentUpload, ivhTreeviewMgr, ivhTreeviewBfs, unsavedChangesService, $http, $cookies) {
    var _this2 = this;

    var ctrl = this;
    //ctrl.UploadDirectory = "\\FS-CLUSTER\TicketFiles\";
    ctrl.deviceList = [];
    //ctrl.priorities = [];
    ctrl.ticketModel = {};
    ctrl.chkEmailDSM = false;
    ctrl.chkEmailContact = false;
    ctrl.selectedCoworkers = [];
    ctrl.loadingAdminCreate = true;
    ctrl.coworkers = [];
    ctrl.selectedProblemCategory = { id: '', label: '' };
    ctrl.jiraAttachments = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.buildProblemCategory();
        ctrl.filename = "Please Choose a file";

        ctrl.selectCoworkerTexts = { buttonDefaultText: 'Select Coworkers' };
        ctrl.coworkerSettings = { smartButtonMaxItems: 4, showCheckAll: false, showUncheckAll: true, styleActive: true, scrollableHeight: '200px', scrollable: true, checkBoxes: false };

        $scope.windowId = ctrl.windowId; //need for
        //$scope.windowTitle = ctrl.windowTitle;//need for

        ctrl.getModel();

        //load contact info
        ctrl.txtContactName = ctrl.accountInfo.name;
        ctrl.txtContactEmail = ctrl.accountInfo.email;
        ctrl.txtContactPhone = ctrl.accountInfo.phone;

        ctrl.viewMode = 1; //0:view, 1:create, 2:edit

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            //Check for unsaved Changes   
            $(ctrl.popup).on('dialogbeforeclose', function (event) {
                if (ctrl.viewMode !== 0) {
                    unsavedChangesService.checkUnsavedChanges(event, ctrl.popup, _this2, true);
                }
            });
        }

        //manually making call to adjustSize in order to load scrollbar
        $timeout(function () {
            ctrl.adjustSize();
            ctrl.loadingAdminCreate = false;
        }, 500);
    };

    var isUndefinedOrNull = function isUndefinedOrNull(value) {
        return angular.isUndefined(value) || value === null;
    };

    var convertToLogins = function convertToLogins(selectedCoworkers) {
        var logins = [];
        angular.forEach(selectedCoworkers, function (coworker, index) {
            logins.push(ctrl.ticketModel.assignedToUsers.find(function (x) {
                return x.userId === coworker.id;
            }));
        });
        return logins;
    };

    var convertToCoworkers = function convertToCoworkers(assignedToUsers) {
        var coworkers = [];
        angular.forEach(assignedToUsers, function (user, index) {
            coworkers.push({ id: user.userId, label: user.fullName, customerId: user.customerId });
        });
        return coworkers;
    };

    var isValidAttachment = function isValidAttachment(fileInput) {
        var retVal = true;
        //validate attachment first
        $scope.alerts = [];
        if (!isUndefinedOrNull(fileInput)) {
            if (!ticketSystemService.ValidateFile(fileInput)) {
                retVal = false;
                //manually making call to adjustSize in order to load scrollbar
                $scope.alerts.push({ msg: "Invalid file attachment (Allowed: .bmp, .gif, .png, .jpg, .jpeg, .doc, .docx, .rtf, .xls, .xlsx, .csv, .zip, .txt, .pdf, .wav, .mp3, .mp4)", type: "danger", languageCode: 'NO_DATA' }); //TODO:VEN: need to translate
                $timeout(function () {
                    ctrl.adjustSize();
                }, 100);
            }
        }
        return retVal;
    };

    ctrl.status = {
        //default - all the collapsible panels are open and enabled
        isFirstOpen: true,
        isFirstDisabled: false,
        isSecondOpen: true,
        isSecondDisabled: false,
        isThirdOpen: true,
        isThirdDisabled: false

        //cancel creating new ticket
    };ctrl.cancelCreate = function () {
        ctrl.viewMode = 0;
        ctrl.out();
    };

    //Append Mission user name to the end of ticket note
    ctrl.updateTxtNote = function () {
        var missionUserName = $cookies.get('AdminInfo');
        if (missionUserName != null) {
            ctrl.txtNote = ctrl.txtNote + " (" + missionUserName + ")";
        }
    };

    //save the user entries 
    ctrl.save = function () {
        if (ctrl.addingTicket) return;
        ctrl.addingTicket = true;
        if (ctrl.accountInfo.name.toLowerCase() == "mission") ctrl.updateTxtNote();
        if (isValidAttachment(ctrl.myFile)) {
            var ticketSystem = {
                customerId: ctrl.ticketModel.selectedCustomer.customerId,
                customerName: ctrl.ticketModel.selectedCustomer.name,
                title: ctrl.txtTitle,
                description: !isUndefinedOrNull(ctrl.txtNote) ? ctrl.txtNote : "",
                createdByLoginId: ctrl.accountInfo.userId,
                createdBy: ctrl.accountInfo.userName,
                AssignedToLoginId: ctrl.ticketModel.selectedAssignedTo.userId,
                AssignedToCustomerId: ctrl.ticketModel.selectedAssignedTo.customerId,
                assignedTo: ctrl.ticketModel.selectedAssignedTo.fullName,
                contactName: !isUndefinedOrNull(ctrl.txtContactName) ? ctrl.txtContactName.replace("'", "''") : "",
                contactPhone: !isUndefinedOrNull(ctrl.txtContactPhone) ? ctrl.txtContactPhone.replace("'", "''") : "",
                contactEmail: !isUndefinedOrNull(ctrl.txtContactEmail) ? ctrl.txtContactEmail.replace("'", "''").replace(";", ",") : "",
                serialNumber: !isUndefinedOrNull(ctrl.selectedDevice) ? !isUndefinedOrNull(ctrl.selectedDevice.serialNumber) ? ctrl.selectedDevice.serialNumber : "" : "",
                severity: ctrl.ticketModel.selectedSeverity.ticketPriorityCode,
                statusCode: ctrl.ticketModel.selectedStatus.statusCode,
                //causeTypeCode: ctrl.ticketModel.selectedCause.causeTypeCode,
                resolutionTypeCode: ctrl.ticketModel.selectedResolution.resolutionTypeCode,
                attachmentFileName: !isUndefinedOrNull(ctrl.myFile) ? ctrl.myFile.name : "",
                attachmentFileSize: !isUndefinedOrNull(ctrl.myFile) ? Math.round(ctrl.myFile.size / 1024) : 0, //save file size as K bytes
                doEmailContact: ctrl.chkEmailContact,
                doEmailDistributorAndSalesManager: ctrl.chkEmailDSM,
                emailCoworkers: convertToLogins(ctrl.selectedCoworkers),
                problemTypeCode: ctrl.selectedProblemCategory.id == 1 ? null : ctrl.selectedProblemCategory.id,
                issueTypeCode: ctrl.ticketModel.selectedTicketIssueType.issueTypeCode,
                inputAttachmentBase64: ctrl.jiraAttachments
            };
            ctrl.loadingAdminCreate = true;
            ticketSystemAdminService.CreateTicket(ctrl.accountInfo.customerId, ticketSystem).then(function (resp) {
                //after saving the user entries, it should return the newTicketId that has been created.
                ctrl.newTicketId = resp.data;
                ticketSystem.ticketId = ctrl.newTicketId;
                //now upload the attachment to server
                if (angular.isDefined(ctrl.myFile)) {
                    ctrl.uploadFile();
                } else {
                    ctrl.out(); //return back to parent view
                }
                //create JIRA ticket if ticket issue type is 'New Feature Request'
                if (ctrl.ticketModel.selectedTicketIssueType.issueTypeCode == 'FTRQ') {
                    if (angular.isDefined(ctrl.myFile)) {
                        $timeout(function () {
                            ctrl.getBase64AttachmentAndCreateJiraTicket(ctrl.myFile);
                        }, 10000);
                    } else {
                        ctrl.createJiraTicket(ctrl.accountInfo.customerId, ticketSystem);
                    }
                }
                ctrl.viewMode = 0;
                ctrl.loadingAdminCreate = false;
            });
        }
    };

    //retrieve list of priorities to load
    ctrl.getModel = function () {
        ticketSystemAdminService.GetAdminTicketModel(ctrl.accountInfo.customerId).then(function (resp) {
            ctrl.ticketModel = resp.data;
            $timeout(function () {
                //setting default customer as the current login user's customer.
                //TODO: Temporarily loading customers dropdown with current customer only
                //if (ctrl.ticketModel.customers.length > 0) {
                //    var index = ctrl.ticketModel.customers.findIndex(x => x.customerId == ctrl.accountInfo.customerId);
                //    ctrl.ticketModel.selectedCustomer = ctrl.ticketModel.customers[index];
                //}
                var onlyCustomer = { customerId: ctrl.accountInfo.customerId, name: ctrl.accountInfo.customerName };
                ctrl.ticketModel.customers = [onlyCustomer];
                ctrl.ticketModel.selectedCustomer = onlyCustomer;

                //Default Resolution
                if (ctrl.ticketModel.resolutionTypes.length > 0) {
                    var currentIndex = ctrl.ticketModel.resolutionTypes.findIndex(function (obj) {
                        return obj.description === "Unknown";
                    });
                    ctrl.ticketModel.selectedResolution = ctrl.ticketModel.resolutionTypes[currentIndex];
                }
                //Default AssignedTo
                if (!!ctrl.ticketModel.assignedToUsers && ctrl.ticketModel.assignedToUsers.length > 0) {
                    var currentUserIndex = ctrl.ticketModel.assignedToUsers.findIndex(function (obj) {
                        return obj.fullName === ctrl.accountInfo.name;
                    }); //TODO: find how to map login user to WebAdminUsers
                    ctrl.ticketModel.selectedAssignedTo = ctrl.ticketModel.assignedToUsers[currentUserIndex];

                    ctrl.coworkers = convertToCoworkers(ctrl.ticketModel.assignedToUsers);
                }
                //Default Status
                if (ctrl.ticketModel.statuses.length > 0) ctrl.ticketModel.selectedStatus = ctrl.ticketModel.statuses[2];
                //Default Severity
                if (ctrl.ticketModel.severities.length > 0) {
                    var currentIndex = ctrl.ticketModel.severities.findIndex(function (obj) {
                        return obj.ticketPriorityCode === "LOW";
                    });
                    ctrl.ticketModel.selectedSeverity = ctrl.ticketModel.severities[currentIndex];
                }
                // Remove New Feature Request option if user type is not TechSupport
                if (ctrl.accountInfo.userType !== "TechSupport") {
                    var index = ctrl.ticketModel.ticketIssueTypes.findIndex(function (obj) {
                        return obj.issueTypeCode === "FTRQ";
                    });
                    ctrl.ticketModel.ticketIssueTypes.splice(index, 1);
                }
                //Default Ticket Issue Type
                if (ctrl.ticketModel.ticketIssueTypes.length > 0) {
                    var currentIndex = ctrl.ticketModel.ticketIssueTypes.findIndex(function (obj) {
                        return obj.issueTypeCode === "UNK";
                    });
                    ctrl.ticketModel.selectedTicketIssueType = ctrl.ticketModel.ticketIssueTypes[currentIndex];
                }
                //loading devices for the customer
                ctrl.getDevices();
            }, 500);
        });
    };

    //retrieve list of devices to load
    ctrl.getDevices = function () {
        if (ctrl.ticketModel.selectedCustomer == undefined) return;
        ctrl.loadingAdminCreate = true;
        ticketSystemAdminService.GetDeviceList(ctrl.accountInfo.customerId, ctrl.ticketModel.selectedCustomer.customerId).then(function (result) {
            $timeout(function () {
                ctrl.deviceList = result.data.devices;
                if ($rootScope.deviceStatusDeviceId) {
                    ctrl.selectedDevice = ctrl.deviceList.find(function (x) {
                        return x.deviceId == $rootScope.deviceStatusDeviceId;
                    });
                    $rootScope.deviceStatusDeviceId = null;
                }
                /*                     else if (ctrl.deviceList.length > 0) {
                                        ctrl.selectedDevice = ctrl.deviceList[0];
                                    }; */
                ctrl.loadingAdminCreate = false;
            }, 0);
        }, function (result) {
            ctrl.loadingAdminCreate = false;
        });
    };

    ctrl.uploadFile = function () {
        var file = ctrl.myFile;
        var uploadUrl = host + '/api/uploadTicketAttachment?CustomerId=' + ctrl.accountInfo.customerId + "&TicketId=" + ctrl.newTicketId;
        attchmentUpload.uploadFileToUrl(file, uploadUrl, 0, onUploadSuccess, onUploadError);
    };

    ctrl.createJiraTicket = function (customerId, _jiraIssue) {
        return $http.post(host + "/api/ITCMJira?customerId=" + customerId, _jiraIssue);
    };

    ctrl.getBase64AttachmentAndCreateJiraTicket = function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            ctrl.base64result = reader.result.split(',')[1];
            ctrl.jiraAttachments.push(ctrl.base64result);
            var ticketSystem = {
                ticketId: ctrl.newTicketId,
                customerId: ctrl.ticketModel.selectedCustomer.customerId,
                customerName: ctrl.ticketModel.selectedCustomer.name,
                title: ctrl.txtTitle,
                description: !isUndefinedOrNull(ctrl.txtNote) ? ctrl.txtNote : "",
                createdByLoginId: ctrl.accountInfo.userId,
                createdBy: ctrl.accountInfo.userName,
                AssignedToLoginId: ctrl.ticketModel.selectedAssignedTo.userId,
                AssignedToCustomerId: ctrl.ticketModel.selectedAssignedTo.customerId,
                assignedTo: ctrl.ticketModel.selectedAssignedTo.fullName,
                contactName: !isUndefinedOrNull(ctrl.txtContactName) ? ctrl.txtContactName.replace("'", "''") : "",
                contactPhone: !isUndefinedOrNull(ctrl.txtContactPhone) ? ctrl.txtContactPhone.replace("'", "''") : "",
                contactEmail: !isUndefinedOrNull(ctrl.txtContactEmail) ? ctrl.txtContactEmail.replace("'", "''").replace(";", ",") : "",
                serialNumber: !isUndefinedOrNull(ctrl.selectedDevice) ? !isUndefinedOrNull(ctrl.selectedDevice.serialNumber) ? ctrl.selectedDevice.serialNumber : "" : "",
                severity: ctrl.ticketModel.selectedSeverity.ticketPriorityCode,
                statusCode: ctrl.ticketModel.selectedStatus.statusCode,
                //causeTypeCode: ctrl.ticketModel.selectedCause.causeTypeCode,
                resolutionTypeCode: ctrl.ticketModel.selectedResolution.resolutionTypeCode,
                attachmentFileName: !isUndefinedOrNull(ctrl.myFile) ? ctrl.myFile.name : "",
                attachmentFileSize: !isUndefinedOrNull(ctrl.myFile) ? Math.round(ctrl.myFile.size / 1024) : 0, //save file size as K bytes
                doEmailContact: ctrl.chkEmailContact,
                doEmailDistributorAndSalesManager: ctrl.chkEmailDSM,
                emailCoworkers: convertToLogins(ctrl.selectedCoworkers),
                problemTypeCode: ctrl.selectedProblemCategory.id == 1 ? null : ctrl.selectedProblemCategory.id,
                inputAttachmentBase64: ctrl.jiraAttachments
            };
            ctrl.createJiraTicket(ctrl.accountInfo.customerId, ticketSystem);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };

    var onUploadSuccess = function onUploadSuccess(obj, idx) {
        //console.log("upload attachment is success");
        ctrl.out(); //return back to parent view
    };

    var onUploadError = function onUploadError(error) {
        $scope.alerts = [];
        //console.log("Failed to upload attachment (Error: " + error.data + ")");
        $scope.alerts.push({ msg: "Failed to upload attachment (Error: " + error.data + ")", type: "danger", languageCode: 'NO_DATA' });
        $timeout(function () {
            ctrl.adjustSize();
        }, 0);
    };

    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));

            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            if (!!ctrl.popup.parent().find('.alert').css("height")) {
                //ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - (80 + ctrl.popup.parent().find('.alert').css("height").replace(/[^0-9.]+/g, "")));
                ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 130);
            } else {
                ctrl.popup.parent().find('.ob-accordion').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 80); //80: total padding
            }
        }
    };

    ctrl.buildProblemCategory = function () {
        ctrl.stuff = ticketSystemService.GetProblemCategories();
    };
    ctrl.onClickShowHideIVHDropdown1 = function (e) {
        var isItemSelected = true;
        if (e.target.classList[0] === "dropDown" && e.target.parentElement.children.length === 2 && e.target.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        }
        if (e.target.classList[0] === "dropDownLabel" && e.target.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        } else if (e.target.classList[0] === "dropDownButton" && e.target.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        } else if (e.target.classList[0] === "dropDownButtonIcon" && e.target.parentElement.parentElement.parentElement.children.length === 2 && e.target.parentElement.parentElement.parentElement.children[1].classList[0] === "dropDownContent") {
            e.target.parentElement.parentElement.parentElement.children[1].classList.toggle("show");
            isItemSelected = false;
        }
        var selectedItm = getSelectedFormIVHTreeModel1(ctrl.stuff);
        if (isItemSelected) {
            //collapse dropdown
            var ivhTreeViewElement = $element.find(".dropdown-with-ivhTreeView .dropDownContent");
            if (!!ivhTreeViewElement) {
                if (ivhTreeViewElement[0].classList.contains("show")) {
                    ivhTreeViewElement[0].classList.remove("show");
                }
            }
        }
        //console.log(selectedItm);
    };
    var getSelectedFormIVHTreeModel1 = function getSelectedFormIVHTreeModel1(ivhModel) {
        var selectedItems = [];
        angular.forEach(ivhModel, function (value) {
            if (value.selected) {
                selectedItems.push(value.label);
            }
            if (angular.isDefined(value.children) && value.children.length > 0) {
                angular.forEach(getSelectedFormIVHTreeModel1(value.children), function (vle) {
                    selectedItems.push(vle);
                });
            }
        });
        return selectedItems;
    };
    $scope.$on("ChildNodeEvent", function (evt, data) {
        ctrl.selectNode(data.ivhTree, data.ivhNode);
    });

    ctrl.selectNode = function (ivhTree, ivhNode) {
        ivhTreeviewMgr.deselectAll(ivhTree);
        ivhTreeviewMgr.select(ivhTree, ivhNode);
        if (ivhNode.id) {
            ctrl.selectedProblemCategory = { id: ivhNode.id, label: ctrl.getNodeDisplayText(ivhTree, ivhNode) };
        } else {
            ctrl.selectedProblemCategory = { id: 1, label: ctrl.translation.text.NO_CATEGORY_SELECTED };
        }
    };

    ctrl.getNodeDisplayText = function (ivhTree, selectedProblemCategory) {
        var displayText = '';
        var done = false;
        ivhTreeviewBfs(ivhTree, function (node, parentsArray) {
            if (done) {
                return false;
            }
            if (node.id === selectedProblemCategory.id) {
                angular.forEach(parentsArray.reverse(), function (parentNode, index) {
                    displayText += parentNode.label + ' > ';
                });
                done = true;
            }
            return !done;
        });

        displayText += selectedProblemCategory.label;
        return displayText;
    };

    ctrl.tpl = ['<div class="ivh-treeview-node-content" title="{{::trvw.label(node)}}">', '<span ivh-treeview-toggle>', '<span class="ivh-treeview-twistie-wrapper" ivh-treeview-twistie></span>', '</span>',
    //'<span class="ivh-treeview-node-label" ivh-treeview-toggle>',
    //'{{:: trvw.label(node)}}',
    '<prob-category-node></prob-category-node>',
    //'</span>',
    '<div ivh-treeview-children></div>', '</div>'].join('\n');
    ctrl.arrowDownTpl = '<span class="arrow-down"></span>';
    ctrl.arrowRightTpl = '<span class="arrow-right"></span>';
};

TicketSystemAdminCreateController.$inject = ['$', '$rootScope', '$scope', '$sce', '$element', '$timeout', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'deviceMenuService', 'ticketSystemService', 'ticketSystemAdminService', 'attchmentUpload', 'ivhTreeviewMgr', 'ivhTreeviewBfs', 'unsavedChangesService', '$http', '$cookies'];
mcapp.directive('probCategoryNode', ['ivhTreeviewMgr', function (ivhTreeviewMgr) {
    return {
        restrict: 'AE',
        //scope: {
        //    dataInfo: '=data'
        //},
        require: '^ivhTreeview',

        template: ['<span class="ivh-treeview-node-label" >', '{{:: trvw.label(node)}}', '<span >',
        //'<span ng-show="(!node.children || node.children.length == 0)">',
        '<span ng-show="node.selected" ><i class="fa fa-check" aria-hidden="true"></i></span>',
        //'<span ng-show="node.__ivhTreeviewIndeterminate" class="y">~</span>',
        //'<span ng-hide="node.selected || node.__ivhTreeviewIndeterminate"> </span>',
        '</span>', '</span>'].join(''),
        link: function link(scope, element, attrs, ctrl) {
            element.on('click', function () {
                ivhTreeviewMgr.select(ctrl.root(), scope.node, !scope.node.selected);
                //emitting data to parent controller
                //emit only if it is child node
                //if (!scope.node.children || scope.node.children.length == 0) {
                var data = { ivhTree: ctrl.root(), ivhNode: scope.node };
                scope.$emit("ChildNodeEvent", data);
                //}
                scope.$apply();
            });
        }
    };
}]);
'use strict';

angular.module('mc.ticket-system').component('ticketSystemAdminCreate', {
    controller: TicketSystemAdminCreateController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/ticketsystem/admincreate/ticket-system-admin-create.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        //windowTitle: '<',
        classicView: '<',
        out: '&'
    }
});
'use strict';

function TWLogFilter() {
  return function (events, wsDeviceId) {
    var filteredEvents = [];

    angular.forEach(events, function (event) {
      if (event.eventInfo.includes('Duplicate')) {} else if (event.eventInfo.includes('689MIS0571 now online') || event.eventInfo.includes('689SFW0537 now online') || event.eventInfo.includes('689SFN1096 now online')) {} else if (event.eventInfo.includes('Alternator: Disabled')) {} else if (event.eventInfo.includes('Adding: ')) {} else if (event.eventInfo.includes('command not acknowledged.')) {} else if (wsDeviceId === 8) {
        // TODO: This wsDeviceId no longer exists (preprod and production)? 
        var newEventInfo = event.eventInfo;
        var newEvent = {
          localTime: event.localTime,
          logId: event.logId
        };

        newEventInfo = newEventInfo.replace('Relay 1 On', 'Valve Close');
        newEventInfo = newEventInfo.replace('Relay 1 Off', 'Valve Open');
        newEventInfo = newEventInfo.replace('Turning Lead Pump off', 'Closing Valve');
        newEventInfo = newEventInfo.replace('Turning Lead Pump on', 'Opening Valve');
        newEventInfo = newEventInfo.replace('Lead Pump Manual On', 'Valve Manual Open');
        newEventInfo = newEventInfo.replace('to 689MIS0571', '');
        // First silly conditional
        newEventInfo = newEventInfo.replace('New LeadPumpOn', 'Adjusted Valve-Open Level');
        // Second silly conditional
        newEventInfo = newEventInfo.replace('New LeadPumpOff', 'Adjusted Valve-Close Level');
        newEventInfo = newEventInfo.replace(': Level=', ' Current Level: ');

        newEvent.eventInfo = newEventInfo;

        filteredEvents.push(newEvent);
      } else if (wsDeviceId === 28 || wsDeviceId === 29 || wsDeviceId === 30) {
        var _newEventInfo = event.eventInfo;
        var _newEvent = {
          localTime: event.localTime,
          logId: event.logId
        };

        _newEventInfo = _newEventInfo.replace('Lead', '');
        if (_newEventInfo.includes('Lag')) {} else {
          _newEvent.eventInfo = _newEventInfo;
          filteredEvents.push(event);
        }
      } else {
        filteredEvents.push(event);
      }
    });

    return filteredEvents;
  };
};

angular.module('mc.tankandwell').filter('twLogFilter', TWLogFilter);
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function TWLogController($scope, $element, $location, $timeout, $window, authenticationService, datetimeService, sharedSetupService, openViewService, tankAndWellService, timeLapseService, translationService, websocketService, savePdfService, toaster) {
    var _this2 = this;

    $scope.needSearchBox = true;
    var getTitle = function getTitle(deviceName, sourceName, channel, channelName) {
        var title = '';

        if (sourceName) {
            title += sourceName;
        } else {
            title += deviceName;
        }

        if (channelName) {
            title += ' : ' + channelName;
        } else {
            title += ' : ' + _this2.translation.text.CHANNEL + ' ' + channel;
        }

        return title;
    };

    var wsDataReceivedEventLog = function wsDataReceivedEventLog(data) {
        if (_this2.liveData === false) {
            unRegisterListener();
            return;
        }

        var newRecord = { localTime: datetimeService.socketStrToServerStrTime(data.Time), eventInfo: data.Value };
        _this2.events.unshift(newRecord);
    };

    var wsReconnectEventLog = function wsReconnectEventLog(data) {};

    var registerListener = function registerListener() {
        if (_this2.liveData === true) {
            return;
        }

        _this2.liveData = true;
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: true });
        liveDataLine(_this2.liveData);

        websocketService.register('EVENTLOG', 'TW' + Array(8 - ('' + _this2.wsDeviceId).length + 1).join('0') + _this2.wsDeviceId, '', wsDataReceivedEventLog, wsReconnectEventLog);
    };

    var unRegisterListener = function unRegisterListener() {
        if (_this2.liveData === false) {
            return;
        }

        _this2.liveData = false;
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false });
        liveDataLine(_this2.liveData);

        websocketService.unRegister('EVENTLOG', 'TW' + Array(8 - ('' + _this2.wsDeviceId).length + 1).join('0') + _this2.wsDeviceId, '', wsDataReceivedEventLog, wsReconnectEventLog);
    };

    var autoScroll = function autoScroll() {
        if (_this2.numberOfNewRecordsPrevious > 0) {
            var trRow = _this2.table.find('tr').eq(_this2.numberOfNewRecordsPrevious - 1);
            var yPosition = typeof trRow.position() !== 'undefined' ? trRow.position().top - 90 : 2;
            _this2.table.scrollTop(yPosition);
        } else {
            var _this = _this2;
            $timeout(function () {
                _this.table.animate({
                    scrollTop: 5
                }, 500);
            }, 0);
        }
    };

    var checkTopOffset = function checkTopOffset(liveDataStatusOn) {
        if (liveDataStatusOn) {
            registerListener();
        } else {
            unRegisterListener();
        }
    };

    var liveDataLine = function liveDataLine(varLiveData) {
        if (varLiveData) {
            _this2.liveTable.addClass('live-data-line');
        } else {
            _this2.liveTable.removeClass('live-data-line');
        }
    };

    var setLiveDataStatus = function setLiveDataStatus(firstRow, liveDataStatusOn) {
        if (_this2.checkFirstRowLiveStatus === true) {
            checkTopOffset(liveDataStatusOn);
        } else if (_this2.checkFirstRowLiveStatus === null) {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                if (parseFloat(firstRow) + parseFloat(_this2.liveDataOffset) >= parseFloat(result.unixTimeStamp)) {
                    _this2.checkFirstRowLiveStatus = true;
                    checkTopOffset(liveDataStatusOn);
                } else {
                    _this2.checkFirstRowLiveStatus = false;
                }
            });
        }
    };

    var updateZoom = function updateZoom(currentRow) {
        if (isNaN(currentRow)) {
            return;
        }

        var zoomMin = currentRow - _this2.paddingZoom;
        var zoomMax = currentRow + _this2.paddingZoom;

        var dateMin = $scope.stickyProperties.dateMin;
        var dateMax = $scope.stickyProperties.dateMax;

        if (zoomMin < $scope.stickyProperties.dateMin) {
            dateMin = zoomMin;
        }
        if (zoomMax > $scope.stickyProperties.dateMax) {
            dateMax = zoomMax;
        }

        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: _this2.windowId });
    };

    var nextPage = function nextPage() {
        if (!_this2.isLoading) {
            _this2.isLoading = true;
            if (_this2.events.length > 0) {
                var newEnd = datetimeService.toUnixtime(_this2.events[_this2.events.length - 1].localTime.replace(/\D/g, ''));
                var newStart = newEnd - 86400000 * 6;

                tankAndWellService.GetOperationLog(_this2.wsDeviceId, _this2.accountInfo.timeZone, newStart, newEnd, 0).then(function (resp) {
                    _this2.isLoading = false;
                    _this2.alerts = [];
                    $scope.alerts = [];

                    if (resp.data.length === 0 && _this2.events.length === 0) {
                        $scope.alerts.push({ msg: _this2.translation.text.NO_DATA, type: 'info', languageCode: 'NO_DATA' });
                        _this2.alerts.push({ msg: _this2.translation.text.NO_DATA, type: 'info', languageCode: 'NO_DATA' });
                    } else {
                        var _events;

                        _this2.numberOfNewRecordsPrevious = _this2.events.length === 0 ? -1 : resp.data.length;
                        (_events = _this2.events).push.apply(_events, _toConsumableArray(resp.data));
                    }
                });
            } else {
                var _newStart = _this2.end - 86400000 * 6;

                tankAndWellService.GetOperationLog(_this2.wsDeviceId, _this2.accountInfo.timeZone, _newStart, _this2.end, 0).then(function (resp) {
                    _this2.isLoading = false;
                    _this2.alerts = [];
                    $scope.alerts = [];

                    if (resp.data.length === 0 && _this2.events.length === 0) {
                        $scope.alerts.push({ msg: _this2.translation.text.NO_DATA, type: 'info', languageCode: 'NO_DATA' });
                        _this2.alerts.push({ msg: _this2.translation.text.NO_DATA, type: 'info', languageCode: 'NO_DATA' });
                    } else {
                        _this2.events = resp.data;
                    }
                });
            }
        }
    };

    var previousPage = function previousPage() {
        if (!_this2.isLoading) {
            _this2.isLoading = true;
            var newStart = datetimeService.toUnixtime(_this2.events[0].localTime.replace(/\D/g, ''));
            var newEnd = newStart + 86400000 * 3;

            tankAndWellService.GetOperationLog(_this2.wsDeviceId, _this2.accountInfo.timeZone, newStart, newEnd, 1).then(function (resp) {
                _this2.isLoading = false;
                _this2.alerts = [];
                $scope.alerts = [];

                if (resp.data.length === 0 && _this2.events.length === 0) {
                    $scope.alerts.push({ msg: _this2.translation.text.NO_DATA, type: 'info', languageCode: 'NO_DATA' });
                    _this2.alerts.push({ msg: _this2.translation.text.NO_DATA, type: 'info', languageCode: 'NO_DATA' });
                } else {
                    var _events2;

                    (_events2 = _this2.events).unshift.apply(_events2, _toConsumableArray(resp.data.reverse()));
                    _this2.numberOfNewRecordsPrevious = resp.data.length;
                }
            });
        }
    };

    this.savePdf = function () {

        var windowTitle = _this2.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("this.translation.text." + windowTitle),
            customerName: _this2.accountInfo.customerName,
            customerId: _this2.accountInfo.customerId,
            dateTranslate: _this2.translation.text.DATE,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    this.$onInit = function () {
        if (!_this2.mobile) {
            $scope.qdpLeft = -237;
        }
        sharedSetupService.getWindowId(_this2);
        $scope.windowTitle = _this2.windowTitle;
        $scope.windowId = _this2.windowId;

        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        $scope.alerts = [];
        _this2.alerts = [];
        _this2.infiniteScrollOn = false;
        _this2.infiniteScrollUpOn = false;
        _this2.infiniteScrollDownOn = false;
        _this2.checkFirstRowLiveStatus = null;
        _this2.liveTable = $element.find('.headertable');
        _this2.preferredTimeFormat = _this2.accountInfo.preferenceUser.timeFormat;
        _this2.unixDay = sharedSetupService.unixDay;
        _this2.liveDataOffset = 86400000 * 3; // sharedSetupService.liveDataOffset;
        _this2.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
        _this2.currentScrollbarPosition = 0;
        _this2.previousScrollbarPosition = 0;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties.device.title = $scope.stickyProperties.device.deviceName;
        _this2.wsDeviceId = $scope.stickyProperties.device.wsDeviceId || $scope.stickyProperties.deviceId;
        _this2.paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
        _this2.paddingZoom = _this2.paddingZoom === 0 ? _this2.unixDay / 2 : _this2.paddingZoom;
        _this2.numberOfNewRecordsPrevious = -1;
        _this2.end = '19000101';
        _this2.events = [];
        _this2.title = '';
        _this2.downloadViewTypeOptions = [0, 1, 2];

        if (/Edge\/\d./i.test(navigator.userAgent)) {
            _this2.isEdge = true;
        }

        _this2.isFF = !!navigator.userAgent.match(/firefox/i);

        if (!_this2.mobile && !_this2.classicView) {
            _this2.popup = _this.getExistingDialog(_this2.windowId).ref;

            if (!$scope.stickyProperties.device.title) {
                tankAndWellService.GetBasicInfo(_this2.wsDeviceId, _this2.accountInfo.customerId).then(function (resp) {
                    $scope.stickyProperties.device.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                    _this2.popup.dialog('option', 'title', _this2.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);
                });
            } else {
                _this2.popup.dialog('option', 'title', _this2.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);
            }

            sharedSetupService.maximize(_this2.popup);

            var adjustSize = function adjustSize() {
                _this2.popup.parent().find('div:eq(2)').css('width', _this2.popup.parent().css('width'));
                _this2.popup.parent().find('div:eq(2)').css('min-width', _this2.popup.parent().css('width').replace(/[^0-9.]+/g, ""));
                _this2.popup.parent().find('div:eq(2)').css('height', _this2.popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2.popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2.popup.parent().find('div:eq(2)').css('min-height', _this2.popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2.popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2.popup.parent().find('.tabular-data-container').css('height', _this2.popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2.popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, "") - _this2.popup.parent().find('.headertable').css('height').replace(/[^0-9.]+/g, "") - _this2.popup.parent().find('.top-menu').css('height').replace(/[^0-9.]+/g, "") - 15);
            };

            _this2.popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            _this2.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(_this2.popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(_this2.popup);
                    adjustSize();
                }
            });

            $scope.$on('ngRepeatFinished', function () {
                adjustSize();
            });

            $scope.$on('updatePreferencesLanguage', function () {
                if (!_this2.mobile && !_this2.classicView) {
                    _this2.popup.dialog('option', 'title', _this2.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);
                }

                adjustSize();
            });

            // following code handling is applicable to Dual Tank Systems.
            $scope.$on('alternateSourceUpdated', function () {
                if (!_this2.mobile && !_this2.classicView) {
                    var myPromise = tankAndWellService.GetBasicInfo(_this2.wsDeviceId, _this2.accountInfo.customerId);
                    myPromise.then(function (resp) {
                        $scope.stickyProperties.device.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                        _this2.title = $scope.stickyProperties.device.title;
                        _this2.popup.dialog('option', 'title', _this2.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);

                        adjustSize();
                    }, function (error) {
                        console.log(error);
                    });
                }
            });
        } else if (_this2.classicView) {
            if (!$scope.stickyProperties.deviceId) {
                $location.path('/tankandwell/overview/template');
            }

            if (!$scope.stickyProperties.device.title) {
                tankAndWellService.GetBasicInfo(_this2.wsDeviceId, _this2.accountInfo.customerId).then(function (resp) {
                    $scope.stickyProperties.device.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                    _this2.title = $scope.stickyProperties.device.title;
                });
            } else {
                _this2.title = $scope.stickyProperties.device.title;
            }

            $(document).find('.tabular-data-container-mobile').css('height', $(document).find('.content-classic').css('height').replace(/[^0-9.]+/g, "") - 150);

            angular.element($window).bind('resize', function () {
                $(document).find('.tabular-data-container-mobile').css('height', $(document).find('.content-classic').css('height').replace(/[^0-9.]+/g, "") - 134);
            });
        } else if (_this2.mobile) {
            if (!$scope.stickyProperties.deviceId) {
                $location.path('/tankandwell/overview/template');
            }

            if (!$scope.stickyProperties.device.title) {
                tankAndWellService.GetBasicInfo(_this2.wsDeviceId, _this2.accountInfo.customerId).then(function (resp) {
                    $scope.stickyProperties.device.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                    _this2.title = $scope.stickyProperties.device.title;
                });
            } else {
                _this2.title = $scope.stickyProperties.device.title;
            }

            $(document).find('.digital-body').css('height', $(document).find('.content-mobile').css('height').replace(/[^0-9.]+/g, "") - 116);

            angular.element($window).bind('orientationchange', function () {
                $timeout(function () {
                    $(document).find('.digital-body').css('height', $(document).find('.content-mobile').css('height').replace(/[^0-9.]+/g, "") - 116);
                });
            });
        }

        // Init
        sharedSetupService.setStickyProperties($scope.stickyProperties, { windowId: _this2.windowId });

        if ($scope.stickyProperties.savedDesktop === true && $scope.stickyProperties.on === true && $scope.stickyProperties.dateMax !== null) {
            _this2.savedDesktopRow = $scope.stickyProperties.zoomMax;
            $scope.stickyProperties.on = true;
            $scope.stickyProperties.savedDesktop = false;
            _this2.end = $scope.stickyProperties.dateMax;

            nextPage();
        } else if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
            // doesn't work well - need to check
            $scope.stickyProperties.on = true;
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                if ($scope.stickyProperties.dateMax >= parseFloat(result.unixTimeStamp) && $scope.stickyProperties.zoomMax + parseFloat(_this2.liveDataOffset) >= parseFloat(result.unixTimeStamp)) {
                    _this2.end = $scope.stickyProperties.dateMax;
                } else {
                    _this2.end = Math.round(($scope.stickyProperties.zoomMax + $scope.stickyProperties.zoomMin) / 2);
                }

                nextPage();
            });
        } else {
            $scope.stickyProperties.on = false;
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                var newDate = new Date(result.localDateTime);
                newDate.setHours(0, 0, 0, 0);
                var endDate = new Date(newDate.getTime() + 3 * 86400000);
                _this2.end = datetimeService.dateToUnixtime(endDate);
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: datetimeService.dateToUnixtime(endDate), windowId: _this2.windowId });

                nextPage();
            });
        }

        $scope.mostRecentData = function () {
            _this2.myDate = null;
            toaster.pop('success', $scope.windowTitle + " -- " + $scope.stickyProperties.device.title, 'View reloading');
            $scope.fetchDataForSelectedDate(new Date());
        };

        $scope.fetchDataForSelectedDate = function (newVal) {
            _this2.end = '19000101';
            _this2.events = [];
            _this2.numberOfNewRecordsPrevious = 0;
            _this2.currentScrollbarPosition = 0;
            _this2.previousScrollbarPosition = 0;
            _this2.checkFirstRowLiveStatus = null;
            unRegisterListener();

            var tmpDates = newVal;
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            tmpDatesA.setHours(12, 0, 0, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);

            if (new Date(newVal).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                _this2.end = tmpDatesA;
            } else {
                _this2.end = tmpDates.endDate;
            }

            $scope.alerts = [];
            _this2.alerts = [];

            nextPage();
            sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + _this2.unixDay, zoomMax: tmpDates.endDate - _this2.unixDay, windowId: _this2.windowId });
        };

        $scope.$watch(function () {
            return _this2.myDate;
        }, function (newVal, oldVal) {
            if (newVal) {
                $scope.fetchDataForSelectedDate(newVal);
            }
        });

        $scope.$on('ngRepeatFinished', function () {
            autoScroll();
            _this2.checkFirstRowLiveStatus = null;
        });

        $timeout(function () {
            _this2.table = $('#tank-and-well-log-' + _this2.replaceSpaces(_this2.windowId));
            // Handle infinite scrolling
            _this2.table.on('scroll', function (event) {
                var $rowFirst = _this2.table.contents().find('tr:first');
                var $rowLast = _this2.table.contents().find('tr:last');
                var _firstRow = $rowFirst.attr('name');
                if (typeof $rowFirst.position() !== 'undefined') {
                    _this2.infiniteScrollOn = true;
                    _this2.infiniteScrollUpOn = true;
                    _this2.infiniteScrollDownOn = true;

                    var _tableTop = _this2.table.offset().top;
                    var _rowTop = $rowFirst.offset().top;
                    setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);

                    _this2.previousScrollbarPosition = _this2.currentScrollbarPosition;
                    _this2.currentScrollbarPosition = _this2.table[0].scrollTop;
                }

                if (_this2.infiniteScrollOn === true) {
                    _this2.infiniteScrollUpOn = true;
                    _this2.infiniteScrollDownOn = true;

                    if (_this2.currentScrollbarPosition <= 35 && _this2.previousScrollbarPosition > 35) {
                        _this2.checkFirstRowLiveStatus = null;
                    }

                    if (_this2.infiniteScrollDownOn === true && _this2.table[0].scrollTop + _this2.table[0].offsetHeight + 5 > _this2.table[0].scrollHeight) {
                        $rowLast.addClass('active-row');
                        _this2.alerts = [];
                        $scope.alerts = [];
                        nextPage();
                    }
                    if (_this2.infiniteScrollUpOn === true && _this2.table[0].scrollTop < 5 && _this2.currentScrollbarPosition < _this2.previousScrollbarPosition) {
                        $rowFirst.addClass('active-row');
                        _this2.alerts = [];
                        $scope.alerts = [];
                        $timeout(function () {
                            previousPage();
                        });
                    }
                }

                var rows = _this2.table.children().children().children().children();
                var scrollpos = 40;
                var start = 0;
                var end = rows.length;
                var count = 0;

                while (start !== end) {
                    count++;
                    var mid = start + Math.floor((end - start) / 2);
                    if ($(rows[mid]).position().top < scrollpos) {
                        start = mid + 1;
                    } else {
                        end = mid;
                    }
                }
                updateZoom(parseFloat($($(rows[start])).attr('name')));
            });
        });
    };

    this.dateAgentText = function (date, timeFormat) {
        return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
    };

    this.getScrollOffset = function () {
        if (_this2.isEdge) {
            return 12;
        }

        return 18;
    };

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    this.toggle = function ($event) {
        if ($($event.currentTarget).hasClass('active-row')) {
            $($event.currentTarget).removeClass('active-row');
        } else {
            $($event.currentTarget).addClass('active-row');
        }
    };

    this.hasOverflow = function () {
        if (_this2.classicView) {
            return true;
        }

        var element = document.getElementById('tank-and-well-log-' + _this2.replaceSpaces(_this2.windowId));
        if (!element || _this2.mobile) {
            return false;
        }

        if (element.offsetHeight < element.scrollHeight) {
            return true;
        }

        return false;
    };

    this.$onDestroy = function () {
        websocketService.unRegister('EVENTLOG', 'TW' + Array(8 - ('' + _this2.wsDeviceId).length + 1).join('0') + _this2.wsDeviceId, '', wsDataReceivedEventLog, wsReconnectEventLog);
    };
}

TWLogController.$inject = ['$scope', '$element', '$location', '$timeout', '$window', 'authenticationService', 'datetimeService', 'sharedSetupService', 'openViewService', 'tankAndWellService', 'timeLapseService', 'translationService', 'websocketService', 'savePdfService', 'toaster'];

angular.module('mc.tankandwell').component('tankAndWellLog', {
    controller: TWLogController,
    transclude: true,
    templateUrl: 'ui/tankandwell/log/partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        windowTitle: '<'
    }
});
"use strict";

angular.module("mc.temperature-widget", []);
"use strict";

function McTemperatureWidgetController($, $rootScope, $scope, $sce, authenticationService, sharedSetupService, McTemperatureGaugeFactory, McWidgetsSharedFactory, toaster, translationService) {
    var ctrl = this;
    ctrl.closeIcon = false;

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 1);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.device.deviceId, windowId: $scope.windowId });
        ctrl.translation = translationService.translation;
        ctrl.getData();
    };

    ctrl.getData = function () {
        var _temperatureGauge = new McTemperatureGaugeFactory(ctrl.accountInfo.customerId, $scope.stickyProperties.device.deviceId, ctrl.accountInfo.timeZone, 1, 17);

        _temperatureGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;

            var device = _temperatureGauge.list.device;
            var deviceUnitState = _temperatureGauge.list.deviceUnitState;
            var defaultSetting = _temperatureGauge.list.defaultSetting;
            var temperatureGauge = _temperatureGauge.list.temperatureGauge.gauges;
            var temperatureWidgetSetting = _temperatureGauge.list.temperatureGauge.temperatureWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: true,
                displaySettingOn: true,
                defaultSetting: false
            };
            ctrl.temperatureGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                defaultSetting: defaultSetting,
                temperatureGauge: temperatureGauge,
                temperatureWidgetSetting: temperatureWidgetSetting,
                setting: setting
            };

            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.additionalSetting();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.fnChangeWidgetTitle = function (titleOption) {
        var _device = { channel: titleOption.channel, deviceId: titleOption.deviceId, deviceName: titleOption.name, serialNumber: titleOption.serialNumber };
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: titleOption.deviceId, device: _device, windowId: $scope.windowId });
        ctrl.setTitle(titleOption.name);
    };

    ctrl.setTitle = function (deviceName) {
        ctrl.deviceName = deviceName;
        ctrl.popup.dialog("option", "title", ctrl.deviceName);
    };

    ctrl.additionalSetting = function () {

        ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.popup.dialog({ resizable: false });

        ctrl.setTitle(ctrl.temperatureGauge.device.name);

        ctrl.popup.parent().find("div.ui-widget-content ").css('overflow', 'visible');

        ctrl.closeWidget = function () {
            ctrl.popup.dialog("close");
        };

        ctrl.setSize(ctrl.temperatureGauge.temperatureWidgetSetting.sizeId);

        ctrl.popup.dialog('widget').css("width", ctrl.svgSizeH + "px");
        ctrl.popup.dialog("option", "width", ctrl.svgSizeH);

        ctrl.popup.dialog('widget').css("height", ctrl.svgSizeH + 25 + "px");
        ctrl.popup.dialog("option", "height", ctrl.svgSizeH + 25);

        ctrl.popup.parent().addClass("ui-widget-content-mc");

        ctrl.popup.parent().on("mouseover", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().addClass("x-resize");
                ctrl.closeIcon = true;
            });
        });

        ctrl.popup.parent().on("mouseout", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().removeClass("x-resize");
                if (ctrl.isTouchSupported()) {
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 3000);
                } else {
                    ctrl.closeIcon = false;
                }
            });
        });

        ctrl.isTouchSupported = function () {
            var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
            var generalTouchEnabled = "ontouchstart" in document.createElement("div");

            if (msTouchEnabled || generalTouchEnabled) {
                return true;
            }
            return false;
        };

        $scope.$on("$destroy", function (event) {
            ctrl.popup.parent().off("mouseover");
            ctrl.popup.parent().off("mouseout");
        });
    };
}

McTemperatureWidgetController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "sharedSetupService", "McTemperatureGaugeFactory", "McWidgetsSharedFactory", "toaster", "translationService"];
'use strict';

angular.module('mc.temperature-widget').component('mcTemperatureWidget', {
    controller: McTemperatureWidgetController,
    templateUrl: 'ui/temperature/mctemperaturewidget/mc-temperature-widget-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.temperature-chart", []);
'use strict';

function TemperatureChartFactory(HOST, $http, translationService, REPORTS, $filter) {
    function getData(varParm) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TemperatureChart?' + varParm,
            cache: false
        });
    }

    return {
        getData: getData
    };
}

TemperatureChartFactory.$inject = ['HOST', '$http', 'translationService', 'REPORTS', '$filter'];

angular.module('mc.temperature-chart').factory('TemperatureChartFactory', TemperatureChartFactory);
"use strict";

function TemperatureChartController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, TemperatureChartFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, savePdfService, toaster, textToSpeechService, websocketService, timeLapseService, rangeSelectorService, userMessageService) {
    var ctrl = this;
    ctrl.$onInit = function () {
        ctrl.seriesData = [];
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.TimeFormatEnum = { Civilian: 1, Military: 2 };
        ctrl.MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
        ctrl.TemperatureUnitEnum = { Fahrenheit: 1, Celsius: 2 };
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.preferredMeasurementFormat = ctrl.accountInfo.preferenceUser.lookupMeasurementID;
        ctrl.unit = ctrl.preferredMeasurementFormat === 2 ? "°C" : "°F";
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.scrollingInProgress = false;
        ctrl.liveDataOffset = 20 * 60 * 1000;
        ctrl.minPadding = 0;
        ctrl.maxPadding = 0;
        ctrl.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        ctrl.loadingInProgress = true;
        ctrl.translation = translationService.translation;

        sharedSetupService.getWindowId(ctrl);
        sharedSetupService.broadcastAllDeviceSelected($scope);

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for

        ctrl.downloadViewTypeOptions = [0, 1];
        ctrl.xValue = null;
        ctrl.initialLoad = true;

        ctrl.element = $element.find('.vfs-chart');
        ctrl.element.addClass('chart');
        ctrl.element.addClass('chart' + ctrl.selectedDeviceId);

        ctrl.element.on('mousewheel', function (event) {
            if (!ctrl.scrollingInProgress) ctrl.mouseWheelZoom(event, ctrl.chart, ctrl.xValue);
        });

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                var _char = ctrl.popup.parent().find('.chart').highcharts();
                if (ctrl.popup.parent().find(".chart").highcharts()) {
                    $timeout(function () {
                        _char.reflow();
                    }, 600);
                }
            };
        }
    };

    ctrl.selectMyDate = function (date) {
        ctrl.myDate = date;
        var tmpDates = ctrl.myDate;
        ctrl.loadingInProgress = true;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
        tmpDates = datetimeService.startEndLocalToUtc(tmpDates, ctrl.accountInfo.timeZone);
        getData($scope.deviceSelected, tmpDates.startDate, tmpDates.endDate);
    };

    ctrl.zoomAdjust = function (varDay) {
        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, ctrl.heartbeatLocalDateTime);
        ctrl.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
        ctrl._setLiveDataStatus();
    };

    ctrl.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            ctrl.stickyProperties.device.serialNumber = newValue;
            if (oldValue) {
                ctrl._unRegisterListener(oldValue);
            }
        }
    }, true);

    $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            ctrl.liveDataIn = !ctrl.liveDataIn;
            $timeout(function () {
                ctrl.liveDataIn = !ctrl.liveDataIn;
            }, 3000);
        }
    }, true);

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {

            var tmpDates,
                tmpStartDate = null,
                tmpEndDate = null;
            ctrl.loadingInProgress = true;

            if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.dateMax !== null) {
                ctrl.stickyProperties.on = true;
                ctrl.tmpStartDate = ctrl.stickyProperties.dateMin;
                ctrl.tmpEndDate = ctrl.stickyProperties.dateMax;
            } else {
                ctrl.stickyProperties.on = false;
            }

            if (!ctrl.tmpStartDate) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    tmpDates = new Date(result.data.localDateTime);
                    tmpDates.setHours(0, 0, 0, 0);
                    tmpDates = datetimeService.dateToUnixtime(tmpDates);
                    tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                    tmpDates = datetimeService.startEndLocalToUtc(tmpDates, ctrl.accountInfo.timeZone);
                    ctrl.tmpStartDate = tmpDates.startDate;
                    ctrl.tmpEndDate = tmpDates.endDate;
                    getData(newValue, ctrl.tmpStartDate, ctrl.tmpEndDate);
                });
            } else {
                getData(newValue, ctrl.tmpStartDate, ctrl.tmpEndDate);
            }
        }
    }, true);

    var getData = function getData(deviceId, StartDate, EndDate) {
        ctrl.liveDataEndDate = EndDate;
        var _device = { deviceName: ctrl.deviceSelectedName };
        TemperatureChartFactory.getData('customerID=' + ctrl.accountInfo.customerId + '&deviceID=' + deviceId + '&StartDate=' + StartDate + '&EndDate=' + EndDate).then(function (datafromFactory) {
            ctrl.dataIsInFormat = 1; //data is in °F
            if (datafromFactory.data.data.length === 0) {
                datafromFactory.data.data.push([StartDate, null]);
                datafromFactory.data.data.push([EndDate, null]);
            }
            ctrl.chartData = datafromFactory.data.data;
            ctrl.devicename = datafromFactory.data.device.name;
            ctrl.unit = ctrl.preferredMeasurementFormat === 2 ? "°C" : "°F";
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, zoomMin: StartDate + ctrl.unixDay, zoomMax: EndDate - ctrl.unixDay, windowId: ctrl.windowId });
            ctrl._drawChart();
        }, function (datafromFactory) {
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, windowId: ctrl.windowId });
            ctrl.element.empty();
            ctrl.chart = null;
            ctrl.loadingInProgress = false;
            var tmpError = typeof datafromFactory.data.message !== 'undefined' ? datafromFactory.data.message : "No data available!"; // error from token [ Authorize ] OR error from [ InputParameterValidatorFilter ] or HttpError().
            ctrl.alerts = [];
            var errormsg = eval("ctrl.translation.message." + tmpError);
            ctrl.alerts.push({ msg: errormsg, type: "danger" });
        });
    };

    ctrl._drawChart = function () {
        var tmpData = ctrl.chartData;
        var chartDrawn = false;
        var chartXaxisHourFormat = ctrl.preferredTimeFormat === ctrl.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
        var chartToolTipHourFormat = ctrl.preferredTimeFormat === ctrl.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

        ctrl.chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            time: {
                getTimezoneOffset: function getTimezoneOffset(timestamp) {
                    return -moment.tz(timestamp, datetimeService.getTimeZoneId(ctrl.accountInfo.timeZone)).utcOffset();
                }
            },
            chart: {
                renderTo: ctrl.element[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1,
                borderRadius: 2,
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                marginRight: 10,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                spacingRight: 5,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {
                        if (this.options.chart.forExport) return false;
                        var tmpDates,
                            extremes = this.xAxis[0].getExtremes();

                        if (this.xAxis && chartDrawn === true && ctrl.scrollingInProgress === false) {
                            if (extremes && extremes.dataMin >= extremes.min - ctrl.liveDataOffset) {
                                ctrl.scrollingInProgress = true;
                                this.showLoading();

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -1);

                                TemperatureChartFactory.getData('customerID=' + ctrl.accountInfo.customerId + '&deviceID=' + $scope.deviceSelected + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromFactory) {
                                    ctrl.dataIsInFormat = 1; //data is in °F
                                    if (datafromFactory.data.data.length === 0) {
                                        datafromFactory.data.data.push([tmpDates.startDate, null]);
                                    } else {
                                        ctrl._convertData(datafromFactory.data.data);
                                    }

                                    tmpData = datafromFactory.data.data.concat(tmpData);
                                    //sort series to avoid HighChart multi line issue(SCADA-9892)
                                    tmpData.sort(function (a, b) {
                                        return a[0] - b[0];
                                    });
                                    ctrl.chart.series[0].setData(tmpData);

                                    ctrl.devicename = datafromFactory.data.device.name;
                                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceSelected, dataMin: tmpDates.startDate, windowId: ctrl.windowId });
                                    ctrl.chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
                                    ctrl._setLiveDataStatus();
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    ctrl.chart.hideLoading();
                                }, function (datafromFactory) {
                                    var uiErrorMessage = userMessageService.getUiErrorMessage(datafromFactory.data.message);
                                    toaster.pop('error', ctrl.windowTitle, uiErrorMessage);
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    ctrl.chart.hideLoading();
                                });
                            } else if (ctrl.liveData === false && extremes && extremes.max + ctrl.liveDataOffset >= extremes.dataMax) {
                                ctrl.scrollingInProgress = true;
                                this.showLoading();

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 1);

                                TemperatureChartFactory.getData('customerID=' + ctrl.accountInfo.customerId + '&deviceID=' + $scope.deviceSelected + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromFactory) {
                                    ctrl.dataIsInFormat = 1; //data is in °F
                                    if (datafromFactory.data.data.length === 0) {
                                        var tmpCheckDate = datetimeService.dateToUnixtime(new Date()); //will get it from time-lapse-service when changed to keep track of local time internally
                                        if (tmpDates.endDate < tmpCheckDate) {
                                            datafromFactory.data.data.push([tmpDates.endDate, null]);
                                        }
                                    }

                                    var tmpDataNew = datafromFactory.data.data;
                                    tmpData = tmpData.concat(ctrl._convertData(tmpDataNew));
                                    //sort series to avoid HighChart multi line issue(SCADA-9892)
                                    tmpData.sort(function (a, b) {
                                        return a[0] - b[0];
                                    });
                                    ctrl.chart.series[0].setData(tmpData);

                                    ctrl.devicename = datafromFactory.data.device.name;
                                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceSelected, dataMax: tmpDates.endDate, windowId: ctrl.windowId });
                                    ctrl.chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
                                    ctrl._setLiveDataStatus(tmpDates.endDate);
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    ctrl.chart.hideLoading();
                                }, function (datafromFactory) {
                                    var uiErrorMessage = userMessageService.getUiErrorMessage(datafromFactory.data.message);
                                    toaster.pop('error', ctrl.windowTitle, uiErrorMessage);
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    ctrl.chart.hideLoading();
                                });
                            }
                        }
                    },
                    load: function load(event) {
                        if (ctrl.initialLoad) openViewService.adjustContentSize(ctrl.popup);
                        ctrl.initialLoad = false;
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: false
            },
            xAxis: {
                title: {
                    text: ctrl.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 3,
                    color: 'green',
                    dashStyle: "solid",
                    zIndex: 1
                }],
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minTickInterval: 3600 * 1000,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                dateTimeLabelFormats: {
                    hour: chartXaxisHourFormat
                },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (chartDrawn === true) {
                            var extremes = ctrl.chart.xAxis[0].getExtremes();
                            if (ctrl.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) {
                                //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                if (extremes.max + ctrl.liveDataOffset <= extremes.dataMax) {
                                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: false, windowId: ctrl.windowId });
                                    ctrl._unRegisterListener(ctrl.deviceSelectedSn);
                                }
                            }
                            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { zoomMin: extremes.min, zoomMax: extremes.max, windowId: ctrl.windowId });
                        }
                    }
                }
            },
            yAxis: {
                title: {
                    text: ctrl.translation.text.TEMPERATURE + ' (' + ctrl.unit + ')',
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                opposite: false,
                allowDecimals: false,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                showFirstLabel: true,
                showLastLabel: true,
                labels: {
                    align: 'right',
                    y: 8,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    },
                    formatter: function formatter() {
                        return this.value;
                    }
                }
            },
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var d = new Date(this.x);
                    var s = '';
                    s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, ctrl.accountInfo.timeZone)) + '</td></tr>';
                    $.each(this.points, function (i, point) {
                        s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': <span style="color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, 0) + ' ' + ctrl.unit + '</span></tr>';
                        ctrl.xValue = point.x;
                    });
                    s += '</table>';
                    return s;
                },
                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 5,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
            },
            plotOptions: {
                series: [{
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                ctrl.xValue = this.x;
                            }
                        }
                    },
                    marker: {
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    events: {
                        mouseOut: function mouseOut() {
                            ctrl.xValue = null;
                        }
                    }
                }]
            },
            series: [{
                name: ctrl.translation.text.TEMPERATURE,
                color: '#2288cc',
                shadow: false,
                data: ctrl._convertData(ctrl.chartData),
                lineWidth: 2,
                marker: {
                    enabled: null,
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#FFFFFF',
                    lineWidth: 2,
                    lineColor: null // inherit from series
                }
            }]
        });

        var tmpNewDateA;
        var tmpNewDateB;
        var extremes = ctrl.chart.xAxis[0].getExtremes();

        if (ctrl.stickyProperties.on === true && ctrl.stickyProperties.mostRecentData === undefined) {
            tmpNewDateA = ctrl.stickyProperties.zoomMin >= extremes.dataMin ? ctrl.stickyProperties.zoomMin : extremes.dataMin; //extremes.dataMin + ctrl.unixDay / 24 * 3;
            tmpNewDateB = ctrl.stickyProperties.zoomMax <= extremes.dataMax + ctrl.liveDataOffset ? ctrl.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - ctrl.unixDay / 24 * 3;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + ctrl.unixDay / 24 ? tmpNewDateB : extremes.dataMax - ctrl.unixDay / 24 * 12;
            ctrl.stickyProperties.on = false;
        } else {
            ctrl.stickyProperties.mostRecentData = undefined;
            tmpNewDateA = ctrl.myDate !== null ? extremes.dataMin + ctrl.unixDay : extremes.dataMax - ctrl.unixDay / 24 * 12;
            tmpNewDateB = ctrl.myDate !== null ? tmpNewDateA + ctrl.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - ctrl.unixDay;
            }
            tmpNewDateA = tmpNewDateA + ctrl.minPadding;
            tmpNewDateB = tmpNewDateB + ctrl.maxPadding;
        }

        ctrl.chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceSelected, zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: ctrl.windowId });
        ctrl._setLiveDataStatus();
        chartDrawn = true;
        ctrl.loadingInProgress = false;
    };

    ctrl.mostRecentData = function (event, args) {
        ctrl.stickyProperties.mostRecentData = true;
        ctrl.stickyProperties.liveData = true;
        ctrl.myDate = null;
        ctrl.reconnectData(event, args);
    };

    $scope.$on('processReconnect', function (event, args) {
        ctrl.reconnectData(event, args);
    });

    ctrl.reconnectData = function (event, args) {
        sharedSetupService.processReconnect({
            stickyProperties: ctrl.stickyProperties,
            localDateTime: args != null ? args.localDateTime : $ctrl.keepAlive,
            dateRangeOption: 0,
            windowTitle: ctrl.windowTitle,
            fnUnregister: ctrl._unRegisterListener,
            fnGetData: getData,
            viewType: "Chart"
        });
    };

    ctrl._convertData = function (varData) {
        if (ctrl.preferredMeasurementFormat === 2 && ctrl.dataIsInFormat !== 2) for (var j = 0; j < varData.length; j++) {
            varData[j][1] = Math.round((varData[j][1] - 32) * (5 / 9));
        }
        if (ctrl.preferredMeasurementFormat === 1 && ctrl.dataIsInFormat !== 1) for (var j = 0; j < varData.length; j++) {
            varData[j][1] = Math.round(9 / 5 * varData[j][1] + 32);
        }
        ctrl.dataIsInFormat = ctrl.preferredMeasurementFormat;
        return varData;
    };

    ctrl._setLiveDataStatus = function (varEndDate) {
        ctrl.liveDataEndDate = varEndDate != null ? varEndDate : ctrl.liveDataEndDate;
        timeLapseService.getLocalDateTime().then(function (result) {
            ctrl.heartbeatLocalDateTime = result.data.unixTimeStamp;
            var extremes = ctrl.chart.xAxis[0].getExtremes();
            if (ctrl.liveDataEndDate > result.data.unixTimeStamp && ctrl.stickyProperties.zoomMax + ctrl.liveDataOffset >= extremes.dataMax) {
                ctrl._registerListener(ctrl.deviceSelectedSn);
                var data = { Unix: result.data.unixTimeStamp, Value: null, SN: null, CH: null };
                ctrl.tlDataReceivedTEMPERATURE(data);
            } else {
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: false, windowId: ctrl.windowId });
                ctrl._unRegisterListener(ctrl.deviceSelectedSn);
            }
        });
    };

    ctrl._registerListener = function (varSelectedSN) {
        websocketService.connect();
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: true, windowId: ctrl.windowId });
        websocketService.register("TEMPERATURE", varSelectedSN, "", ctrl.wsDataReceivedTEMPERATURE, null);
        timeLapseService.register("TEMPERATURE", varSelectedSN, "", ctrl.tlDataReceivedTEMPERATURE);
        ctrl.liveData = true;
    };

    ctrl._unRegisterListener = function (varSelectedSN) {
        websocketService.unRegister("TEMPERATURE", varSelectedSN, "", ctrl.wsDataReceivedTEMPERATURE, null);
        timeLapseService.unRegister("TEMPERATURE", varSelectedSN, "", ctrl.tlDataReceivedTEMPERATURE);
        ctrl.liveData = false;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl._drawChart();
    });

    $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
        ctrl.applyMeasurementFormat(measurementSystem);
        ctrl._drawChart();
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.applyTimeFormat(timeFormat);
        ctrl._drawChart();
    });

    ctrl.applyTimeFormat = function (timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat);
    };

    ctrl.applyMeasurementFormat = function (measurementFormat) {
        var _tmpFormat = parseInt(measurementFormat);
        if (ctrl.preferredMeasurementFormat === _tmpFormat) return;
        ctrl.preferredMeasurementFormat = parseInt(measurementFormat);
        ctrl.unit = ctrl.preferredMeasurementFormat === 2 ? "°C" : "°F";
    };

    ctrl.tlDataReceivedTEMPERATURE = function (data) {
        data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, ctrl.accountInfo.timeZone);

        if (ctrl.liveData === false) {
            ctrl._unRegisterListener(ctrl.deviceSelectedSn);
            return;
        }

        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - ctrl.unixDay / 2) {
            ctrl._unRegisterListener(ctrl.deviceSelectedSn);
            return;
        }

        var liveDataLine = ctrl.chart.xAxis[0].plotLinesAndBands;
        liveDataLine[0].options.value = data.Unix + ctrl.maxPadding;

        if (extremes.max + ctrl.liveDataOffset > extremes.dataMax) ctrl.chart.xAxis[0].setExtremes(data.Unix - tmpRange + ctrl.minPadding, data.Unix + ctrl.maxPadding);
    };

    ctrl.wsDataReceivedTEMPERATURE = function (data) {

        if (ctrl.liveData === false) {
            ctrl._unRegisterListener(ctrl.deviceSelectedSn);
            return;
        }

        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        var str = data.Time + "";
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, ctrl.accountInfo.timeZone);
        var varValue = parseInt(data.Value);

        ctrl.chart.series[0].addPoint([unixtime, ctrl.preferredMeasurementFormat === 1 ? Math.round(9 / 5 * varValue + 32) : varValue]); //, true, false, true

        if (extremes.max + ctrl.liveDataOffset > extremes.dataMax) ctrl.chart.xAxis[0].setExtremes(unixtime - tmpRange + ctrl.minPadding, unixtime + ctrl.maxPadding);
        var varTime = datetimeService.socketStrToServerStrTime(data.Time);
        ctrl.lastUpdateAt = varTime;
    };

    $scope.$on("$destroy", function () {
        ctrl._unRegisterListener(ctrl.deviceSelectedSn);
        if (ctrl.chart) ctrl.chart.destroy();
    });
}

TemperatureChartController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'TemperatureChartFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', 'savePdfService', 'toaster', 'textToSpeechService', 'websocketService', 'timeLapseService', 'rangeSelectorService', 'userMessageService'];
'use strict';

angular.module('mc.temperature-chart').component('temperatureChart', {
    controller: TemperatureChartController,
    templateUrl: 'ui/temperature/chart/temperature-chart-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        deviceSelectedSn: '<',
        myDate: '<'
    }
});
"use strict";

angular.module("mc.temperature-gauge", []);
'use strict';

function McTemperatureGaugeFactory(HOST, $http) {

    // instantiate our initial object
    var McTemperatureGauge = function McTemperatureGauge(customerId, deviceId, timeZone, categoryId, widgetId) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
    };

    McTemperatureGauge.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/TemperatureGauge' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McTemperatureGauge;
}

McTemperatureGaugeFactory.$inject = ['HOST', '$http'];

angular.module('mc.temperature-gauge').factory('McTemperatureGaugeFactory', McTemperatureGaugeFactory);
"use strict";

function McTemperatureGaugeController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, openViewService, $timeout, McTemperatureGaugeFactory, $filter, $element, McWidgetsSharedFactory, toaster) {
    var ctrl = this;

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        sharedSetupService.getWindowId($scope);

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();

        $scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                $scope.alerts = [];
                $scope.currentDeviceId = newValue;
                ctrl.hasTemperatureData = true;
                var _temperatureGauge = new McTemperatureGaugeFactory(ctrl.accountInfo.customerId, newValue, ctrl.accountInfo.timeZone, 1, 17);

                _temperatureGauge.getGaugeData().then(function () {
                    ctrl.loadingInProgress = false;
                    var tmpTemperatureGauge, device, deviceUnitState, temperatureGauge, temperatureWidgetSetting, setting, defaultSetting;

                    device = _temperatureGauge.list.device;
                    deviceUnitState = _temperatureGauge.list.deviceUnitState;
                    defaultSetting = _temperatureGauge.list.defaultSetting;
                    temperatureGauge = _temperatureGauge.list.temperatureGauge.gauges;
                    temperatureWidgetSetting = _temperatureGauge.list.temperatureGauge.temperatureWidgetSetting;

                    setting = {
                        customerId: ctrl.accountInfo.customerId,
                        displaySetting: false,
                        displaySettingOn: false,
                        defaultSetting: true
                    };
                    tmpTemperatureGauge = {
                        device: device,
                        deviceUnitState: deviceUnitState,
                        defaultSetting: defaultSetting,
                        temperatureGauge: temperatureGauge,
                        temperatureWidgetSetting: temperatureWidgetSetting,
                        setting: setting
                    };

                    ctrl.temperatureGauge = angular.copy(tmpTemperatureGauge);
                    if (_temperatureGauge.list.temperatureGauge.gauges[0].currentData === null) {
                        ctrl.hasTemperatureData = false;
                        $scope.alerts.push({ msg: ctrl.translation.text.NO_DATA, type: "info" });
                    }
                }, function (error) {
                    console.log(error);
                    ctrl.loadingInProgress = false;
                });
            }
        }, true);

        $element.on("mouseover.mcTemperatureGauge", ".upWidget", function (event) {
            if ($(event.currentTarget).is(".upWidget") && event.target.tagName !== "DIV" && !$scope.mobile && !$scope.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    zIndex: 9999,
                    disabled: false,
                    stop: function stop(event, ui) {
                        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(ui.helper.attr("mc-size"), 1);
                        var mcDevice = { deviceId: $scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: $scope.deviceSelectedSn, deviceName: $scope.deviceSelectedName };
                        var optionsStickyProperties = {
                            deviceId: $scope.deviceSelected,
                            device: mcDevice
                        };
                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        var viewName = "Mc Temperature Widget";
                        openViewService.openWidget(viewName, { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                        $scope.$apply();
                    }
                });
            } else {
                $(event.currentTarget).draggable({ disabled: true });
            }
        });

        $scope.$on("$destroy", function (event) {
            $element.off("mouseover.mcTemperatureGauge");
        });
    };
}

McTemperatureGaugeController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "translationService", "sharedSetupService", "datetimeService", "openViewService", "$timeout", "McTemperatureGaugeFactory", "$filter", "$element", "McWidgetsSharedFactory", "toaster"];
'use strict';

angular.module('mc.temperature-gauge').component('mcTemperatureGauge', {
    controller: McTemperatureGaugeController,
    templateUrl: 'ui/temperature/mctemperaturegauge/mc-temperature-gauge-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
'use strict';

function TankandWellGaugeFactory(HOST, $http) {

    // instantiate our initial object
    var TankandWellGauge = function TankandWellGauge(customerId, deviceId, timeZone, categoryId, widgetId, channel) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.channel = channel;
    };

    TankandWellGauge.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/DigitalWidget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&channel=' + this.channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };
    return TankandWellGauge;
}

TankandWellGaugeFactory.$inject = ['HOST', '$http'];

angular.module('mc.tankandwell').factory('TankandWellGaugeFactory', TankandWellGaugeFactory);
'use strict';

function TWDetailController(_, $scope, $element, $location, $q, $timeout, $window, authenticationService, datetimeService, digitalGaugeService, sharedSetupService, openViewService, tankAndWellService, timeLapseService, translationService, websocketService, toaster) {
    var _this2 = this;

    var _startLiveDurationUpdate = void 0;
    var width = '100%';
    var height = '95%';

    this.pumpsLoading = false;

    var convertDigital = function convertDigital(value, normalState) {
        if (value === null || value === '') {
            return null;
        }

        if (parseInt(value, 10) === parseInt(normalState, 10)) {
            return 1;
        }

        return 0;
    };

    var timeConversion = function timeConversion(millisec) {
        //if duration is > 3 months, then return > 3 months, otherwise actual duration

        function numberEnding(number) {
            return number > 1 ? 's' : '';
        }

        var seconds = (millisec / 1000).toFixed(1);

        var minutes = (millisec / (1000 * 60)).toFixed(1);

        var hours = (millisec / (1000 * 60 * 60)).toFixed(1);

        var days = (millisec / (1000 * 60 * 60 * 24)).toFixed(1);

        var years = (millisec / (1000 * 60 * 60 * 24 * 365)).toFixed(1);

        if (seconds < 60) {
            return seconds + ' ' + _this2.translation.text.SECOND + numberEnding(seconds);
        } else if (minutes < 60) {
            return minutes + ' ' + _this2.translation.text.MINUTE + numberEnding(minutes);
        } else if (hours < 24) {
            return hours + ' ' + _this2.translation.text.HOUR + numberEnding(hours);
        } else if (days < 365) {
            if (days > 90) return '> 3 ' + _this2.translation.text.MONTH;else return days + ' ' + _this2.translation.text.DAY + numberEnding(days);
        } else {
            return '> 3 ' + _this2.translation.text.MONTH;
            //return `${years} ${this.translation.text.YEAR}${numberEnding(years)}`; // we are not interested if it is > 3 months
        }
    };

    var updateDuration = function updateDuration(pump) {
        var duration = null;
        timeLapseService.getLocalDateTime().then(function (resp) {
            //preventing negative values for duration
            pump.duration = timeConversion(Math.abs(parseInt(resp.data.unixTimeStamp + 10000 - pump.lastStatusLocalTimeUnix, 10)));
        });
    };

    var startLiveDurationUpdate = function startLiveDurationUpdate() {
        timeLapseService.register("TWDetailDurationListener", 0, "", updateAllPumpsDuration, 1); // timeinterval = 1, means same time interval as timeLapseService (ie. 15 seconds)
    };

    var stopLiveDurationUpdate = function stopLiveDurationUpdate() {
        timeLapseService.unRegister("TWDetailDurationListener", 0, "", updateAllPumpsDuration, 1); // timeinterval = 1, means same time interval as timeLapseService (ie. 15 seconds)
    };

    var updateAllPumpsDuration = function updateAllPumpsDuration(data) {
        for (var j = 0; j < _this2.detail.destPumpArray.length; j++) {
            //preventing negative values for duration
            _this2.detail.destPumpArray[j].duration = timeConversion(Math.abs(data.Unix + 10000 - _this2.detail.destPumpArray[j].lastStatusLocalTimeUnix));
        }
    };

    var getWaterColor = function getWaterColor() {
        if (_this2.detail.tank.currentReading <= _this2.detail.tank.tankRedBelow) {
            return '#ff0000';
        } else if (_this2.detail.tank.currentReading >= _this2.detail.tank.tankYellowAbove) {
            return '#ffff00';
        } else {
            return '#008ee4';
        }
    };

    var drawGroundTank = function drawGroundTank() {

        if (_this2.classicView || _this2.mobile) {
            width = $('#tank-and-well-detail-' + _this2.replaceSpaces(_this2.windowId))[0].clientWidth * 0.2;
            height = $('#tank-and-well-detail-' + _this2.replaceSpaces(_this2.windowId))[0].clientHeight - 35;
        }

        _this2.sourceCaption = !!_this2.detail.basicInfo.tankAndWellLabels.labelSource ? _this2.detail.basicInfo.tankAndWellLabels.labelSource : _this2.detail.basicInfo.sourceDevice.name;
        _this2.subCaption = !!_this2.detail.tank.unit ? '(' + _this2.detail.tank.unit + ')' : '';

        var tmpWidgetSetting = {
            'lowerLimit': _this2.detail.tank.tankBottom,
            'upperLimit': _this2.detail.tank.tankTop,
            'cylFillColor': getWaterColor(),
            'value': _this2.detail.tank.currentReading,
            'altSource': false,
            'name': _this2.sourceCaption
        };

        _this2.widgetSetting = angular.copy(tmpWidgetSetting);

        if (!!_this2.detail.tank.alternateSource) {
            _this2.altSourceCaption = !!_this2.detail.tank.alternateSource.labelSource ? _this2.detail.tank.alternateSource.labelSource : _this2.detail.tank.alternateSource.deviceName;
            _this2.altSourceSubCaption = !!_this2.detail.tank.alternateSource.unit ? '(' + _this2.detail.tank.alternateSource.unit + ')' : _this2.subCaption;
            tmpWidgetSetting.cylFillColor = '#868e96';
            tmpWidgetSetting.value = _this2.detail.tank.alternateSource.currentReading;
            tmpWidgetSetting.name = _this2.altSourceCaption;
            tmpWidgetSetting.altSource = true;
            _this2.widgetSettingAlt = angular.copy(tmpWidgetSetting);
            _this2.widgetSetting.altSource = true;
        }
        //this.detail.fuelWidget = new FusionCharts({
        //    type: 'cylinder',
        //    dataFormat: 'json',
        //    renderAt: `tank-and-well-detail-chart-${this.replaceSpaces(this.windowId)}`,
        //    width: width,
        //    height: height,
        //    dataSource: {
        //        'chart': {
        //            'caption': sourceCaption,
        //            'subCaption': !!this.detail.tank.unit ? '('+this.detail.tank.unit+')' : '',
        //            'captionOnTop':'1',
        //            'captionAlignment':'center',
        //            //'xAxisName':'Pecan St Tank',
        //            'lowerLimit': this.detail.tank.tankBottom,
        //            'upperLimit': this.detail.tank.tankTop,
        //            //'numberSuffix': ' ' + this.detail.tank.unit,
        //            //'placeValuesInside': 1,
        //            'showhovereffect': '0',
        //            'chartTopMargin': '5',
        //            'chartBottomMargin': '5',
        //            'cylFillColor': getWaterColor(),
        //            //'showTickValues': 1,
        //            //'showTickMarks': 1,
        //            //'adjustTM': 1,
        //            //'canvasBgAlpha': '0',
        //            //'legendBgAlpha': '0',
        //            //'borderAlpha': '0',
        //            //'bgAlpha': '0,0',
        //            'showToolTip': 1,
        //            'labelDisplay': 'Auto',
        //            'theme': 'fint'
        //        },
        //        'value': this.detail.tank.currentReading
        //    }
        //}).render();

        //this.detail.fuelWidget.setTransparent(true);

        //if(!!this.detail.tank.alternateSource){
        //    var altSourceCaption = !!this.detail.tank.alternateSource.labelSource ? this.detail.tank.alternateSource.labelSource : this.detail.tank.alternateSource.deviceName;
        //    this.detail.fuelWidgetAlt = new FusionCharts({
        //        type: 'cylinder',
        //        dataFormat: 'json',
        //        renderAt: `tank-and-well-detail-chart-altsource-${this.replaceSpaces(this.windowId)}`,
        //        width: width,
        //        height: height,
        //        dataSource: {
        //            'chart': {
        //                'caption': altSourceCaption,
        //                'subCaption': !!this.detail.tank.unit ? '('+this.detail.tank.unit+')' : '',
        //                'captionOnTop':'1',
        //                'captionAlignment':'center',
        //                //'xAxisName':'Elevated Tank',
        //                'lowerLimit': this.detail.tank.tankBottom,
        //                'upperLimit': this.detail.tank.tankTop,
        //                //'numberSuffix': ' ' + this.detail.tank.unit,
        //                //'placeValuesInside': 1,
        //                'showhovereffect': '0',
        //                'chartTopMargin': '5',
        //                'chartBottomMargin': '5',
        //                'cylFillColor': '#868e96', // getWaterColor(),
        //                //'showTickValues': 1,
        //                //'showTickMarks': 1,
        //                //'adjustTM': 1,
        //                //'canvasBgAlpha': '0',
        //                //'legendBgAlpha': '0',
        //                //'borderAlpha': '0',
        //                //'bgAlpha': '0,0',
        //                'showToolTip': 1,
        //                'labelDisplay': 'Auto',
        //                'theme': 'fint'
        //            },
        //            'value': this.detail.tank.alternateSource.currentReading
        //        }
        //    }).render();

        //    this.detail.fuelWidgetAlt.setTransparent(true);
        //}

        //$(`#tank-and-well-detail-${this.replaceSpaces(this.windowId)}`).find('svg[id^=\'raphael-paper\']').css('background-color', 'rgb(255, 255, 255, 0)');
        //$(`#tank-and-well-detail-chart-altsource-${this.replaceSpaces(this.windowId)}`).find('svg[id^=\'raphael-paper\']').css('background-color', 'rgb(255, 255, 255, 0)');
    };

    var getTitle = function getTitle(deviceName, sourceName, channel, channelName) {
        var title = '';

        if (sourceName) {
            title += sourceName;
        } else {
            title += deviceName;
        }

        if (channelName) {
            title += ' : ' + channelName;
        } else {
            title += ' : ' + _this2.translation.text.CHANNEL + ' ' + channel;
        }

        return title;
    };

    var getMode = function getMode(modeCode) {
        switch (parseInt(modeCode, 10)) {
            default:
            case 0:
                return _this2.translation.text.OFF;
            case 1:
                return _this2.translation.text.ON;
            case 2:
                return _this2.translation.text.AUTO;
        }
    };

    var getPumpCurrentPosition = function getPumpCurrentPosition(basic, pumpId) {
        if (parseInt(basic.currentLeadPump, 10) === parseInt(pumpId, 10)) {
            return _this2.translation.text.LEAD;
        } else if (parseInt(basic.currentLagPump, 10) === parseInt(pumpId, 10)) {
            return _this2.translation.text.LAG;
        } else if (parseInt(basic.currentLag2Pump, 10) === parseInt(pumpId, 10)) {
            return _this2.translation.text.LAG + '2';
        } else if (parseInt(basic.currentLag3Pump, 10) === parseInt(pumpId, 10)) {
            return _this2.translation.text.LAG + '3';
        } else if (parseInt(basic.currentLag4Pump, 10) === parseInt(pumpId, 10)) {
            return _this2.translation.text.LAG + '4';
        }
    };

    var getPumpPositionIndex = function getPumpPositionIndex(basic, pumpId) {
        if (parseInt(basic.currentLeadPump, 10) === parseInt(pumpId, 10)) {
            return 0;
        } else if (parseInt(basic.currentLagPump, 10) === parseInt(pumpId, 10)) {
            return 1;
        } else if (parseInt(basic.currentLag2Pump, 10) === parseInt(pumpId, 10)) {
            return 2;
        } else if (parseInt(basic.currentLag3Pump, 10) === parseInt(pumpId, 10)) {
            return 3;
        } else if (parseInt(basic.currentLag4Pump, 10) === parseInt(pumpId, 10)) {
            return 4;
        }
    };

    var getPumpLabel = function getPumpLabel(label, destPumpDevId, channel) {
        return label ? label : getPumpDeviceName(destPumpDevId) + ' ' + _this2.translation.text.PUMP + ' ' + channel;
    };

    var convertStatus = function convertStatus(statusCode, pumpName, wsdeviceid) {
        var statusMsg = null;

        switch (parseInt(statusCode, 10)) {
            default:
            case 0:
                // open
                if (pumpName.toLowerCase().indexOf('valve') >= 0) {
                    if (parseInt(wsdeviceid, 10) !== 94) {
                        statusMsg = { statusColor: '#404040', statusImage: 'valve_closed.gif', statusMessage: _this2.translation.text.STOPPED };
                    } else {
                        statusMsg = { statusColor: 'rgb(162, 200, 53)', statusImage: 'valve_open.gif', statusMessage: _this2.translation.text.STOPPED };
                    }
                } else {
                    statusMsg = { statusColor: '#404040', statusImage: 'pump_off_a.gif', statusMessage: _this2.translation.text.STOPPED };
                }

                break;
            case 1:
                // close
                if (pumpName.toLowerCase().indexOf('valve') >= 0) {
                    if (parseInt(wsdeviceid, 10) !== 94) {
                        statusMsg = { statusColor: 'rgb(162, 200, 53)', statusImage: 'valve_open.gif', statusMessage: _this2.translation.text.RUNNING };
                    } else {
                        statusMsg = { statusColor: '#404040', statusImage: 'valve_close.gif', statusMessage: _this2.translation.text.RUNNING };
                    }
                } else {
                    statusMsg = { statusColor: 'rgb(162, 200, 53)', statusImage: 'pump_run_a.gif', statusMessage: _this2.translation.text.RUNNING };
                }

                break;
            case null: //fault
            case '':
                if (pumpName.toLowerCase().indexOf('valve') >= 0) {
                    statusMsg = { statusColor: 'red', statusImage: 'valve_fault.gif', statusMessage: _this2.translation.text.FAULT };
                } else {
                    statusMsg = { statusColor: 'red', statusImage: 'pump_fault_a.gif', statusMessage: _this2.translation.text.FAULT };
                }

                break;
        }
        //console.log(statusMsg);
        return statusMsg;
    };

    var updateValue = function updateValue(relay, polarity) {
        return relay ? relay ^ polarity : '';
    };

    var getPumpData = function getPumpData(customerId, deviceId, channel, pumpIdx, timeZone) {
        tankAndWellService.GetPumpData(customerId, deviceId, channel, timeZone).then(function (resp) {
            _this2.detail.destPumpArray[pumpIdx].loading = false;
            _this2.detail.destPumpArray[pumpIdx].relayReading = updateValue(resp.data.relayData.latestReading, _this2.detail.destPumpArray[pumpIdx].polarity);
            _this2.detail.destPumpArray[pumpIdx].feedback = { hasFeedback: false };
            _this2.detail.destPumpArray[pumpIdx].lastStatusLocalTimeUnix = resp.data.relayData.lastStatusLocalUnixTime < 0 ? 0 : resp.data.relayData.lastStatusLocalUnixTime; //negative values means it is never heard

            var _convertStatus = convertStatus(_this2.detail.destPumpArray[pumpIdx].relayReading, _this2.detail.destPumpArray[pumpIdx].label, $scope.stickyProperties.deviceId),
                statusColor = _convertStatus.statusColor,
                statusImage = _convertStatus.statusImage,
                statusMessage = _convertStatus.statusMessage;

            _this2.detail.destPumpArray[pumpIdx].color = statusColor;
            _this2.detail.destPumpArray[pumpIdx].image = statusImage;
            _this2.detail.destPumpArray[pumpIdx].status = statusMessage;

            if (resp.data.relayData.changed === 1) {
                updateDuration(_this2.detail.destPumpArray[pumpIdx]);
            } else {
                _this2.detail.destPumpArray[pumpIdx].duration = '> 3 ' + _this2.translation.text.MONTH;
            }

            if (resp.data.relayPositiveFeedback !== null) {
                digitalGaugeService.getData(_this2.accountInfo.customerId, resp.data.relayPositiveFeedback.feedbackDeviceIdNumber, _this2.accountInfo.timeZone).then(function (resp2) {
                    var RPF = resp2.data;

                    //element.tooltip({
                    //  track: true,
                    //  tooltipClass: 'tooltip-jq'
                    //});

                    for (var i = 0; i < RPF.digitalSettings.length; i++) {
                        var inputChannel = RPF.digitalSettings[i].channel;
                        if (inputChannel === resp.data.relayPositiveFeedback.feedbackInputId) {
                            var digValue = RPF.digitalData['d' + inputChannel];

                            if (digValue === "True") {
                                digValue = "1";
                            } else if (digValue === "False") {
                                digValue = "0";
                            }

                            var digitalReading = convertDigital(digValue, RPF.digitalSettings[i].normalClosed);
                            var digitalLocalTimeUnix = datetimeService.strToUnixtime(RPF.digitalData.localTime);

                            if (digitalReading !== _this2.detail.destPumpArray[pumpIdx].relayReading) {
                                var timeDiffseconds = Math.abs(parseInt(digitalLocalTimeUnix - _this2.detail.destPumpArray[pumpIdx].lastStatusLocalTimeUnix, 10));
                                var duration = timeConversion(timeDiffseconds);

                                _this2.detail.destPumpArray[pumpIdx].feedback = { hasFeedback: true };
                                if (timeDiffseconds <= resp.data.relayPositiveFeedback.tripDelay * 60 * 1000) {
                                    //yellow
                                    _this2.detail.destPumpArray[pumpIdx].feedback.image = 'light_truetrue.png';
                                    _this2.detail.destPumpArray[pumpIdx].feedback.duration = _this2.translation.text.DIGITAL_MISMTCH_RELAY + ': ' + duration;
                                } else {
                                    //red
                                    _this2.detail.destPumpArray[pumpIdx].feedback.image = 'input_fault.png';
                                    _this2.detail.destPumpArray[pumpIdx].feedback.duration = _this2.translation.text.DIGITAL_MISMTCH_RELAY + ': ' + duration;
                                }
                            }
                        }
                    }
                });
            }
        });
    };

    var getPumpDeviceName = function getPumpDeviceName(deviceId) {
        for (var i = 0; i < _this2.detail.basicInfo.pumpsDetail.length; i++) {
            if (_this2.detail.basicInfo.pumpsDetail[i].deviceId == deviceId) return _this2.detail.basicInfo.pumpsDetail[i].deviceName;
        }
    };

    var getDeviceSerialNumber = function getDeviceSerialNumber(deviceId) {
        for (var i = 0; i < _this2.detail.basicInfo.pumpsDetail.length; i++) {
            if (_this2.detail.basicInfo.pumpsDetail[i].deviceId == deviceId) return _this2.detail.basicInfo.pumpsDetail[i].deviceSerialNumber;
        }
    };

    var wsDataReceivedGT = function wsDataReceivedGT(data) {
        if (_this2.detail.tank.sourceChannel === parseInt(data.CH, 10) && _this2.detail.basicInfo.sourceDevice.serialNumber === data.SN) {
            _this2.detail.tank.currentReading = data.Value;
            _this2.detail.fuelWidget = null;
            if (!!_this2.detail.fuelWidgetAlt) {
                _this2.detail.fuelWidgetAlt = null;
            }
            drawGroundTank();
        }
    };

    var wsDataReceivedTWP = function wsDataReceivedTWP(data) {
        //if (this.detail.basicInfo.sourceDevice.serialNumber === data.SN && data.Value) {
        //console.log(data);
        var channel = parseInt(data.CH);
        var chValue = data.Value;
        for (var j = 0; j < _this2.detail.destPumpArray.length; j++) {
            if (_this2.detail.destPumpArray[j].deviceSerialNumber === data.SN && _this2.detail.destPumpArray[j].channel === channel && chValue) {
                if (chValue !== _this2.detail.destPumpArray[j].relayReading) {
                    _this2.detail.destPumpArray[j].relayReading = updateValue(chValue, _this2.detail.destPumpArray[j].polarity);

                    var _convertStatus2 = convertStatus(_this2.detail.destPumpArray[j].relayReading, _this2.detail.destPumpArray[j].label, $scope.stickyProperties.deviceId),
                        statusColor = _convertStatus2.statusColor,
                        statusImage = _convertStatus2.statusImage,
                        statusMessage = _convertStatus2.statusMessage;

                    _this2.detail.destPumpArray[j].color = statusColor;
                    _this2.detail.destPumpArray[j].image = statusImage;
                    _this2.detail.destPumpArray[j].status = statusMessage;
                    _this2.detail.destPumpArray[j].lastStatusLocalTimeUnix = datetimeService.toUnixtime(data.Time);
                    updateDuration(_this2.detail.destPumpArray[j]);
                }
            }
        }
        //}
    };

    var wsDataReceivedAlternator = function wsDataReceivedAlternator(data) {
        var wsIdforWebS = 'TW' + Array(8 - ('' + $scope.stickyProperties.deviceId).length + 1).join('0') + $scope.stickyProperties.deviceId;

        if (wsIdforWebS === data.SN) {
            var positionArray = data.Value.replace(/[[\]]/g, '').split(',');

            for (var j = 0; j < _this2.detail.destPumpArray.length; j++) {
                var position = positionArray.indexOf(_this2.detail.destPumpArray[j].pumpId);

                if (position > -1) {
                    switch (position) {
                        case 0:
                            _this2.detail.destPumpArray[j].position = _this2.translation.text.LEAD;
                            break;
                        case 1:
                            _this2.detail.destPumpArray[j].position = _this2.translation.text.LAG;
                            break;
                        case 2:
                            _this2.detail.destPumpArray[j].position = _this2.translation.text.LAG + '2';
                            break;
                        case 3:
                            _this2.detail.destPumpArray[j].position = _this2.translation.text.LAG + '3';
                            break;
                        case 4:
                            _this2.detail.destPumpArray[j].position = _this2.translation.text.LAG + '4';
                            break;
                    }
                }
            }
        }
    };

    var setMaxRunningPumps = function setMaxRunningPumps(data) {
        _this2.maxRunningPumps = data.tankAndWellParameter.maxNumberRunningPumps === null ? _this2.maxRunningPumps : data.tankAndWellParameter.maxNumberRunningPumps;
        var pumpsCount = getPumpsCount(data);
        _this2.maxRunningPumps = _this2.maxRunningPumps > pumpsCount ? pumpsCount : _this2.maxRunningPumps; //making sure max running pumps should not be more than pumps exists.
    };

    var getPumpsCount = function getPumpsCount(data) {
        // create pump array for binding processed/calculated values with UI
        var pumpsCount = 0;
        for (var j = 1; j <= 5; j++) {
            if (data.tankAndWellBasic['destPump' + j + 'DeviceId'] !== 0) {
                pumpsCount++;
            }
        }
        return pumpsCount;
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId(_this2);
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        sharedSetupService.setStickyProperties($scope.stickyProperties, { windowId: _this2.windowId });
        _this2.detail = {};
        _this2.sortBy = 'name';
        _this2.maxRunningPumps = 5; //default value to max 5 pumps

        _this2.startProcess();
    };

    this.mostRecentData = function () {
        toaster.pop('success', "Tank and Well Detail" + " -- " + $scope.stickyProperties.device.title, 'View reloading');
        _this2.startProcess();
    };

    this.startProcess = function () {
        var devId = $scope.stickyProperties.device.wsDeviceId || $scope.stickyProperties.deviceId;
        tankAndWellService.GetBasicInfo(devId, _this2.accountInfo.customerId).then(function (resp) {
            _this2.sourceCaption = !!resp.data.tankAndWellLabels.labelSource ? resp.data.tankAndWellLabels.labelSource : resp.data.sourceDevice.name; // this property is required for Tank caption to display
            setMaxRunningPumps(resp.data);
        });

        if (!_this2.mobile && !_this2.classicView) {
            _this2.popup = _this.getExistingDialog(_this2.windowId).ref;

            if (!$scope.stickyProperties.device.title) {
                tankAndWellService.GetBasicInfo(devId, _this2.accountInfo.customerId).then(function (resp) {
                    setMaxRunningPumps(resp.data);
                    $scope.stickyProperties.device.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                    _this2.popup.dialog('option', 'title', _this2.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);
                });
            } else {
                _this2.popup.dialog('option', 'title', _this2.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);
            }

            sharedSetupService.maximize(_this2.popup);

            _this2.wheight = _this2.popup.dialog('option', 'height') - 50;
            _this2.tankpumpheight = _this2.wheight - 30;

            var adjustSize = function adjustSize() {
                _this2.popup.parent().find('div:eq(2)').css('width', _this2.popup.parent().css('width'));
                _this2.popup.parent().find('div:eq(2)').css('min-width', _this2.popup.parent().css('width').replace(/[^0-9.]+/g, ""));
                _this2.popup.parent().find('div:eq(2)').css('height', _this2.popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2.popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2.popup.parent().find('div:eq(2)').css('min-height', _this2.popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2.popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2.popup.parent().find('.toptank').css('height', _this2.popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2.popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));

                //this.detail.fuelWidget.resizeTo($('#tank-and-well-detail-' + this.replaceSpaces(this.windowId))[0].clientWidth * 0.25, $('#tank-container-' + this.replaceSpaces(this.windowId))[0].clientHeight - 35);

                //if (!!this.detail.fuelWidgetAlt) {
                //    this.detail.fuelWidgetAlt.resizeTo($('#tank-and-well-detail-' + this.replaceSpaces(this.windowId))[0].clientWidth * 0.25, $('#tank-container-' + this.replaceSpaces(this.windowId))[0].clientHeight - 35);
                //}
            };

            _this2.popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            _this2.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(_this2.popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(_this2.popup);
                    adjustSize();
                }
            });
        } else {
            if (!$scope.stickyProperties.deviceId) {
                $location.path('/tankandwell/overview/template');
            }

            if (!$scope.stickyProperties.device.title) {
                tankAndWellService.GetBasicInfo(devId, _this2.accountInfo.customerId).then(function (resp) {
                    setMaxRunningPumps(resp.data);
                    $scope.stickyProperties.device.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                    _this2.title = $scope.stickyProperties.device.title;
                });
            } else {
                _this2.title = $scope.stickyProperties.device.title;
            }

            // TODO Handle mobile & classic
            angular.element($window).bind('resize', function () {
                if (_this2.containerResize !== null) {
                    $timeout.cancel(_this2.containerResize);
                    _this2.containerResize = null;
                }

                _this2.containerResize = $timeout(function () {
                    //Ref: Scada-1210
                    //client id is expected to be = '#tank-and-well-detail-Tank_And_Well_Detail';

                    var cWidth = $('#tank-and-well-detail-chart-TWDETAIL')[0].clientWidth;
                    var cHeight = $('#tank-and-well-detail-chart-TWDETAIL')[0].clientHeight;

                    if (cWidth && cHeight) {
                        _this2.detail.fuelWidget.resizeTo(width, height);
                        if (!!_this2.detail.fuelWidgetAlt) {
                            _this2.detail.fuelWidgetAlt.resizeTo(width, height);
                        }
                    }
                    $timeout.cancel(_this2.containerResize);
                    _this2.containerResize = null;
                }, 100);
            });
        }

        $scope.$on('updatePreferencesLanguage', function () {
            if (!_this2.mobile && !_this2.classicView) {
                _this2.popup.dialog('option', 'title', _this2.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);
            }

            for (var i = 0; i < _this2.detail.destPumpArray.length; i++) {
                _this2.detail.destPumpArray[i].position = getPumpCurrentPosition(_this2.detail.basicInfo.tankAndWellBasic, i + 1);
                _this2.detail.destPumpArray[i].modeLabel = getMode(_this2.detail.basicInfo.tankAndWellBasic['destPump' + (i + 1) + 'Mode']);
                _this2.detail.destPumpArray[i].label = getPumpLabel(_this2.detail.destPumpArray[i].pLbl, _this2.detail.destPumpArray[i].deviceId, _this2.detail.destPumpArray[i].channel);
                updateDuration(_this2.detail.destPumpArray[i]);
            }
        });

        // following code handling is applicable to Dual Tank Systems.
        $scope.$on('alternateSourceUpdated', function () {
            _this2.tankLoading = true;

            //fetch latest data from webApi
            var devId = $scope.stickyProperties.device.wsDeviceId || $scope.stickyProperties.deviceId;
            tankAndWellService.GetBasicInfo(devId, _this2.accountInfo.customerId).then(function (resp) {
                _this2.detail.basicInfo = resp.data;
                setMaxRunningPumps(resp.data);

                //update view title
                _this2.detail.title = getTitle(_this2.detail.basicInfo.sourceDevice.name, _this2.detail.basicInfo.tankAndWellLabels.labelSource, _this2.detail.basicInfo.tankAndWellBasic.sourceAnalogChannel, _this2.detail.basicInfo.analogSetting === null ? '' : _this2.detail.basicInfo.analogSetting.name);
                $scope.stickyProperties.device.title = _this2.detail.title;
                if (!_this2.mobile && !_this2.classicView) {
                    _this2.popup.dialog('option', 'title', _this2.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);
                }

                //fetch latest tank data and update tank's title
                tankAndWellService.GetGroundTankData($scope.stickyProperties.deviceId, _this2.accountInfo.timeZone, _this2.accountInfo.customerId).then(function (resp) {
                    $timeout(function () {
                        _this2.tankLoading = false;
                    });

                    _this2.detail.tank = resp.data;

                    $timeout(function () {
                        drawGroundTank();
                    });
                });
            });
        });

        var basicPromise = $q.defer();
        tankAndWellService.GetBasicInfo(devId, _this2.accountInfo.customerId).then(function (resp) {
            basicPromise.resolve();
            _this2.detail.basicInfo = resp.data;
            setMaxRunningPumps(resp.data);
            _this2.detail.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
            _this2.detail.destPumpArray = [];

            for (var j = 1; j <= 5; j++) {
                var destPumpDevId = resp.data.tankAndWellBasic['destPump' + j + 'DeviceId'];
                if (resp.data.tankAndWellBasic['destPump' + j + 'DeviceId'] !== 0) {
                    _this2.detail.destPumpArray.push({
                        wsDeviceId: $scope.stickyProperties.deviceId,
                        deviceId: destPumpDevId,
                        deviceSerialNumber: getDeviceSerialNumber(destPumpDevId),
                        pumpId: j,
                        position: getPumpCurrentPosition(resp.data.tankAndWellBasic, j),
                        positionIdx: getPumpPositionIndex(resp.data.tankAndWellBasic, j),
                        mode: resp.data.tankAndWellBasic['destPump' + j + 'Mode'],
                        modeLabel: getMode(resp.data.tankAndWellBasic['destPump' + j + 'Mode']),
                        polarity: resp.data.tankAndWellBasic['destPump' + j + 'Polarity'],
                        channel: resp.data.tankAndWellBasic['destPump' + j + 'Relay'],
                        pLbl: resp.data.tankAndWellLabels['labelPump' + j],
                        label: getPumpLabel(resp.data.tankAndWellLabels['labelPump' + j], destPumpDevId, resp.data.tankAndWellBasic['destPump' + j + 'Relay']),
                        loading: true
                    });

                    getPumpData(_this2.accountInfo.customerId, destPumpDevId, resp.data.tankAndWellBasic['destPump' + j + 'Relay'], j - 1, _this2.accountInfo.timeZone);
                }
            }

            // sort the array based on pump positions
            _this2.sortByPosition();

            return basicPromise.promise;
        });

        _this2.tankLoading = true;
        var tankPromise = $q.defer();
        tankAndWellService.GetGroundTankData($scope.stickyProperties.deviceId, _this2.accountInfo.timeZone, _this2.accountInfo.customerId).then(function (resp) {
            tankPromise.resolve();
            $timeout(function () {
                _this2.tankLoading = false;
            });

            _this2.detail.tank = resp.data;

            $timeout(function () {
                drawGroundTank();
            });

            return tankPromise.promise;
        });

        $q.all([basicPromise.promise, tankPromise.promise]).then(function () {
            var wsIdforWebS = 'TW' + Array(8 - ('' + $scope.stickyProperties.deviceId).length + 1).join('0') + $scope.stickyProperties.deviceId;
            websocketService.connect();
            //websocketService.register('RELAYS', this.detail.basicInfo.sourceDevice.serialNumber, '', wsDataReceivedTWP, wsDataReceivedTWP);
            websocketService.register('ALTERNATOR', wsIdforWebS, '', wsDataReceivedAlternator, wsDataReceivedAlternator);
            websocketService.register('ANALOG', _this2.detail.basicInfo.sourceDevice.serialNumber, _this2.detail.tank.sourceChannel, wsDataReceivedGT, wsDataReceivedGT);
            websocketService.register('ANALOG_G2', _this2.detail.basicInfo.sourceDevice.serialNumber, _this2.detail.tank.sourceChannel, wsDataReceivedGT, wsDataReceivedGT);

            //registering for relays of each device based on Device Serial Number
            var previousSerialNumber = void 0;
            for (var k = 0; k < _this2.detail.destPumpArray.length; k++) {
                if (_this2.detail.destPumpArray[k].deviceSerialNumber == previousSerialNumber) continue;
                websocketService.register('DIGITALOUTPUT', _this2.detail.destPumpArray[k].deviceSerialNumber, '', wsDataReceivedTWP, wsDataReceivedTWP);
                //console.log('Registered for Relay of Device SN:'+this.detail.destPumpArray[k].deviceSerialNumber);
                previousSerialNumber = _this2.detail.destPumpArray[k].deviceSerialNumber;
            }

            startLiveDurationUpdate();
        });
    };

    this.sortByPosition = function () {
        _this2.sortBy = 'position';
    };

    this.sortByName = function () {
        _this2.sortBy = 'name';
    };

    this.sortPumps = function (pump) {
        if (_this2.sortBy === 'position') return pump.positionIdx;else {
            return pump.pumpId;
        }
    };

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return 'TWDETAIL';
    };

    this.getContainerHeight = function () {
        if (_this2.classicView) {
            return 'calc(100% - 15px)';
        } else if (_this2.mobile) {
            return 'calc(100% - 38px)';
        }

        return '100%';
    };

    this.testChart = function () {
        _this2.detail.fuelWidget.dispose();
        if (!!_this2.detail.fuelWidgetAlt) {
            _this2.detail.fuelWidgetAlt.dispose();
        }
        _this2.detail.tank.currentReading = 25;
        $timeout(function () {
            drawGroundTank();
        });
        //this.detail.fuelWidget.feedData(`&chart.cylFillColor=#ffff00&value=${25}`);
    };

    $scope.$on('pumpPositionChanged', function () {
        _this2.mostRecentData();
        //const basicPromise = $q.defer();
        //var devId = $scope.stickyProperties.device.wsDeviceId || $scope.stickyProperties.deviceId;
        //tankAndWellService.GetBasicInfo(devId, this.accountInfo.customerId).then((resp) => {
        //    basicPromise.resolve();
        //    this.pumpsLoading = true;
        //    this.detail.basicInfo = resp.data;
        //    setMaxRunningPumps(resp.data);
        //    this.detail.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
        //    this.detail.destPumpArray = [];

        //    for (let j = 1; j <= 5; j++) {
        //        var destPumpDevId = resp.data.tankAndWellBasic[`destPump${j}DeviceId`];
        //        if (resp.data.tankAndWellBasic[`destPump${j}DeviceId`] !== 0) {
        //            this.detail.destPumpArray.push({
        //                wsDeviceId: $scope.stickyProperties.deviceId,
        //                deviceId: destPumpDevId,
        //                deviceSerialNumber: getDeviceSerialNumber(destPumpDevId),
        //                pumpId: j,
        //                position: getPumpCurrentPosition(resp.data.tankAndWellBasic, j),
        //                positionIdx: getPumpPositionIndex(resp.data.tankAndWellBasic, j),
        //                mode: resp.data.tankAndWellBasic[`destPump${j}Mode`],
        //                modeLabel: getMode(resp.data.tankAndWellBasic[`destPump${j}Mode`]),
        //                polarity: resp.data.tankAndWellBasic[`destPump${j}Polarity`],
        //                channel: resp.data.tankAndWellBasic[`destPump${j}Relay`],
        //                pLbl: resp.data.tankAndWellLabels[`labelPump${j}`],
        //                label: getPumpLabel(resp.data.tankAndWellLabels[`labelPump${j}`], destPumpDevId, resp.data.tankAndWellBasic[`destPump${j}Relay`]),
        //                loading: true,
        //            });

        //            getPumpData(this.accountInfo.customerId, destPumpDevId, resp.data.tankAndWellBasic[`destPump${j}Relay`], j - 1, this.accountInfo.timeZone);
        //        }
        //    }

        //    // sort the array based on pump positions
        //    this.sortByPosition();
        //    $timeout(() => {
        //        this.pumpsLoading = false;
        //    }, 2000);
        //    return basicPromise.promise;
        //});
    });

    this.$onDestroy = function () {
        if (_this2.detail.fuelWidget) {
            _this2.detail.fuelWidget.dispose();
        }

        if (!!_this2.detail.fuelWidgetAlt) {
            _this2.detail.fuelWidgetAlt.dispose();
        }

        var wsIdforWebS = 'TW' + Array(8 - ('' + $scope.stickyProperties.deviceId).length + 1).join('0') + $scope.stickyProperties.deviceId;

        //websocketService.unRegister('RELAYS', this.detail.basicInfo.sourceDevice.serialNumber, '', wsDataReceivedTWP, wsDataReceivedTWP);
        websocketService.unRegister('ALTERNATOR', wsIdforWebS, '', wsDataReceivedAlternator, wsDataReceivedAlternator);
        websocketService.unRegister('ANALOG', _this2.detail.basicInfo.sourceDevice.serialNumber, _this2.detail.tank.sourceChannel, wsDataReceivedGT, wsDataReceivedGT);
        websocketService.unRegister('ANALOG_G2', _this2.detail.basicInfo.sourceDevice.serialNumber, _this2.detail.tank.sourceChannel, wsDataReceivedGT, wsDataReceivedGT);

        //unregistering for relays of each device based on Device Serial Number
        var previousSerialNumber = void 0;
        for (var k = 0; k < _this2.detail.destPumpArray.length; k++) {
            if (_this2.detail.destPumpArray[k].deviceSerialNumber === previousSerialNumber) continue;
            websocketService.unRegister('DIGITALOUTPUT', _this2.detail.destPumpArray[k].deviceSerialNumber, '', wsDataReceivedTWP, wsDataReceivedTWP);
            //console.log('UnRegistered for Relay of Device SN:'+this.detail.destPumpArray[k].deviceSerialNumber);
            previousSerialNumber = _this2.detail.destPumpArray[k].deviceSerialNumber;
        }

        stopLiveDurationUpdate();
    };

    $scope.$on('processReconnect', function (event, args) {
        _this2.mostRecentData();
    });
}

TWDetailController.$inject = ['_', '$scope', '$element', '$location', '$q', '$timeout', '$window', 'authenticationService', 'datetimeService', 'digitalGaugeService', 'sharedSetupService', 'openViewService', 'tankAndWellService', 'timeLapseService', 'translationService', 'websocketService', 'toaster'];

angular.module('mc.tankandwell').component('tankAndWellDetail', {
    controller: TWDetailController,
    transclude: true,
    templateUrl: 'ui/tankandwell/detail/partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<'
    }
});
'use strict';

function TWChartController($scope, $location, $rootScope, $timeout, authenticationService, datetimeService, openViewService, sharedSetupService, tankAndWellService, timeLapseService, translationService, websocketService, toaster, rangeSelectorService, deviceMenuService) {
    var _this2 = this;

    var ctrl = this;
    var windowTitle = ctrl.windowTitle;
    var _twTooltipBusy = false;
    var callInCountTimeout = undefined;

    ctrl.downloadViewTypeOptions = [1];
    var varToggle = false;
    var getTitle = function getTitle(deviceName, sourceName, channel, channelName) {
        var title = '';

        if (sourceName) {
            title += sourceName;
        } else {
            title += deviceName;
        }

        if (channelName) {
            title += ' : ' + channelName;
        } else {
            title += ' : ' + ctrl.translation.text.CHANNEL + ' ' + channel;
        }

        return title;
    };

    var removeNull = function removeNull(seriesNumber, chart) {
        var cutSeries = ctrl.chart.series[seriesNumber];
        if (cutSeries.data.length > 3) {
            var curLength = cutSeries.data.length > 50 ? 50 : cutSeries.data.length;
            for (var i = 1; i < curLength; i++) {
                var pointindex = ctrl.series[seriesNumber].data.length - 1;
                if (ctrl.series[seriesNumber].data[pointindex][2] === 0) {
                    if (cutSeries.data[pointindex]) {
                        cutSeries.data[pointindex].remove();
                    }

                    ctrl.series[seriesNumber].data.splice(pointindex, 1);
                }
            }
        }
    };

    var setLiveDataStatus = function setLiveDataStatus(varEndDate) {
        ctrl.liveDataEndDate = varEndDate ? varEndDate : ctrl.liveDataEndDate;

        timeLapseService.getLocalDateTime().then(function (resp) {
            var result = resp.data;
            $scope.heartbeatLocalDateTime = resp.data.unixTimeStamp;
            var extremes = ctrl.chart.xAxis[0].getExtremes();
            if (ctrl.liveDataEndDate > result.unixTimeStamp && $scope.stickyProperties.zoomMax + ctrl.liveDataOffset >= extremes.dataMax) {
                registerListener();
                var data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedTA(data);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: ctrl.windowId });
                unregisterListener();
            }
        });
    };

    // Process: WebSocket Analog Data received
    var wsDataReceivedTA = function wsDataReceivedTA(data) {
        if (ctrl.liveData === false) {
            unregisterListener();
            return;
        }

        if (data.Type == "ANALOG" && ctrl.tankAndWellAnalog.analogDevice.deviceModel == 21) {
            return;
        }

        if (data.SN === $scope.stickyProperties.device.serialNumber) {
            var unixtime = datetimeService.toUnixtime(data.Time);
            var varValue = parseFloat(data.Value);
            var utcTime = datetimeService.localToUtcTimeStampByTime(unixtime, ctrl.accountInfo.timeZone);

            //NOTE: Total no. of series are as follows
            // AnalogData       => 1
            // Relay Data       => 5 (Type: DigitalOuput)
            // Setpoints Data   => 10
            // But Ctrl.Chart.Series has extra series for Navigator

            //Series[0] is the AnalogData
            ctrl.chart.series[0].addPoint([utcTime, varValue], false, false, false);
            ctrl.series[0].data.push([utcTime, varValue]);
            ////==Process Setpoints series and set them with previous value for new timestamp =====
            for (var i = 1; i < ctrl.series.length; i++) {
                if (ctrl.series[i].id.substr(0, 5) === 'relay') continue; // skip the relay series
                var y = ctrl.chart.series[i].data[0].y; //fetching existing value to set to new utctime for setpoints' related series
                if (y !== null) {
                    removeNull(i, ctrl.chart);
                    ctrl.chart.series[i].addPoint([utcTime, y], false, false, false);
                    ctrl.series[i].data.push([utcTime, y]);
                }
            }

            var extremes = ctrl.chart.xAxis[0].getExtremes();
            var tmpRange = extremes.max - extremes.min;
            if (extremes.max + ctrl.liveDataOffset > extremes.dataMax) {
                ctrl.chart.xAxis[0].setExtremes(utcTime - tmpRange + ctrl.minPadding, utcTime + ctrl.maxPadding);
            }
            //ctrl.chart.yAxis[0].setExtremes(null, null);

            ctrl.chart.redraw();
        }
    };

    var getCalculatedPumpId = function getCalculatedPumpId(chVal, polarity, pumpId) {
        var retVal = null;
        //calculate pumpId, only if chVal is not null and it is different from polarity
        if (chVal != null && chVal != polarity) retVal = pumpId * -1;

        return retVal;
    };
    // Process: WebSocket Relay Data received
    var wsDataReceivedTD = function wsDataReceivedTD(data) {
        var unixtime = datetimeService.toUnixtime(data.Time);
        var utcTime = datetimeService.localToUtcTimeStampByTime(unixtime, ctrl.accountInfo.timeZone);
        var channel = parseInt(data.CH);
        var chValue = data.Value;

        for (var i = 0; i < ctrl.tankAndWellRelay.length; i++) {
            var rDevice = ctrl.tankAndWellRelay[i].relayDevice;
            var rSetting = ctrl.tankAndWellRelay[i].relaySetting;
            var rBasic = ctrl.tankAndWellBasic;
            var polarity = 1;
            var pumpId = 0;

            if (data.SN === rDevice.serialNumber) {
                removeNull(i + 1, ctrl.chart);

                //logic to identify pumpId from Channel number received from message
                if (rBasic.destPump1DeviceId === rDevice.deviceId && rBasic.destPump1Relay === rSetting.channel && rSetting.channel === channel) {
                    polarity = parseInt(rBasic.destPump1Polarity);
                    pumpId = 1;
                } else if (rBasic.destPump2DeviceId === rDevice.deviceId && rBasic.destPump2Relay === rSetting.channel && rSetting.channel === channel) {
                    polarity = parseInt(rBasic.destPump2Polarity);
                    pumpId = 2;
                } else if (rBasic.destPump3DeviceId === rDevice.deviceId && rBasic.destPump3Relay === rSetting.channel && rSetting.channel === channel) {
                    polarity = parseInt(rBasic.destPump3Polarity);
                    pumpId = 3;
                } else if (rBasic.destPump4DeviceId === rDevice.deviceId && rBasic.destPump4Relay === rSetting.channel && rSetting.channel === channel) {
                    polarity = parseInt(rBasic.destPump4Polarity);
                    pumpId = 4;
                } else if (rBasic.destPump5DeviceId === rDevice.deviceId && rBasic.destPump5Relay === rSetting.channel && rSetting.channel === channel) {
                    polarity = parseInt(rBasic.destPump5Polarity);
                    pumpId = 5;
                }

                if (pumpId > 0) {
                    //Calculate PumpId based on the properties available
                    var calPumpId = getCalculatedPumpId(chValue, polarity, pumpId);
                    //fetch previous Calculated PumpId
                    var thisDOseries = ctrl.series[i + 1];
                    var preCalPumpId = thisDOseries.data[thisDOseries.data.length - 1][1];

                    if (calPumpId != null && preCalPumpId == null) {
                        // pump start message - 1
                        //extra entry for previous second to create the line (line needs two points)
                        ctrl.series[i + 1].data.push([(utcTime / 1000 - 1) * 1000, calPumpId, 1]);
                        ctrl.chart.series[i + 1].addPoint([(utcTime / 1000 - 1) * 1000, calPumpId], false, false, false);

                        ctrl.series[i + 1].data.push([utcTime, calPumpId, 1]);
                        ctrl.chart.series[i + 1].addPoint([utcTime, calPumpId], false, false, false);
                    } else if (calPumpId == null && preCalPumpId != null) {
                        // pump stop message - 0
                        ctrl.series[i + 1].data.push([utcTime, preCalPumpId, 1]);
                        ctrl.series[i + 1].data.push([(utcTime / 1000 + 1) * 1000, null, 1]); // extra entry for next second to indicate the end of the line

                        ctrl.chart.series[i + 1].addPoint([utcTime, preCalPumpId], false, false, false);
                        ctrl.chart.series[i + 1].addPoint([(utcTime / 1000 + 1) * 1000, null], false, false, false);
                    } else if (calPumpId != null && preCalPumpId != null) {
                        // guess, never hits to this line of code
                        ctrl.series[i + 1].data.push([utcTime, preCalPumpId, 1]);
                        ctrl.chart.series[i + 1].addPoint([utcTime, preCalPumpId], false, false, false);
                    }
                }
            }
        }

        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;
        if (extremes.max + ctrl.liveDataOffset > extremes.dataMax) {
            ctrl.chart.xAxis[0].setExtremes(utcTime - tmpRange + ctrl.minPadding, utcTime + ctrl.maxPadding);
        }
        //ctrl.chart.yAxis[0].setExtremes(null, null);
        ctrl.chart.redraw();
    };

    // Process: WebSocket CALLINSCOUNT data received
    var wsDataReceivedCALLINSCOUNT = function wsDataReceivedCALLINSCOUNT(data) {
        //CALLINSCOUNT message belongs to Ranger Device, and it is not applicable to other device type
        if (ctrl.tankAndWellAnalog.analogDevice.deviceModel != 21) {
            return;
        }

        if (ctrl.liveData === false) {
            unregisterListener();
            return;
        }

        callInCountTimeout = $timeout(function () {

            var str = data.Time + "";
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
            unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, ctrl.accountInfo.timeZone);

            //Series[0] is the AnalogData
            var tmpAnalogSeries = ctrl.chart.series[0];
            var currentAnalogDataObj = tmpAnalogSeries.data[tmpAnalogSeries.data.length - 1];
            //if new data point timestamp is different than current data timestamp, 
            //then build the dummy data for ANALOG_G2 message with new timestamp and current data value
            //because, we did not receive any ANALOG_G2 message for Ranger device, but it is has to be updated based on the time lapse
            if (currentAnalogDataObj.x != unixtime) {
                data.Type = "ANALOG_G2";
                data.Value = currentAnalogDataObj.y;
                data.CH = ctrl.tankAndWellAnalog.analogSetting.channel; //chart.series[i].options.id;
                wsDataReceivedTA(data);
            }
        }, 1000);
    };

    var tlDataReceivedTA = function tlDataReceivedTA(data) {
        if (ctrl.liveData === false) {
            unregisterListener();
            return;
        }

        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;
        var utcTime = datetimeService.localToUtcTimeStampByTime(data.Unix, ctrl.accountInfo.timeZone);

        $timeout(function () {
            var liveDataLine = ctrl.chart.xAxis[0].plotLinesAndBands;
            liveDataLine[0].options.value = utcTime + ctrl.maxPadding;

            ctrl.chart.xAxis[0].setExtremes(utcTime - tmpRange + ctrl.minPadding, utcTime + ctrl.maxPadding);
            //ctrl.chart.yAxis[0].setExtremes(null, null);
        });

        if (extremes.dataMax < utcTime - tmpRange || extremes.dataMax < utcTime - ctrl.unixDay / 2) {
            unregisterListener();
            return;
        }

        if (extremes.max + ctrl.liveDataOffset > extremes.dataMax) {
            $timeout(function () {
                var x = utcTime + ctrl.maxPadding;

                for (var t = 1; t < ctrl.series.length; t++) {
                    var series = ctrl.chart.series[t];
                    var dataseries = ctrl.series[t];
                    //NOTE: we are not considering first series as it is AnalogData
                    if (series.data.length > 1 && dataseries.data[series.data.length - 1]) {
                        // process setpoints and relay series
                        //if (dataseries.id.substr(0, 5) === 'relay') continue; // skip the relay series
                        var y = dataseries.data[series.data.length - 1][1];
                        series.addPoint([x, y], false, false, false);
                    }
                }

                ctrl.chart.xAxis[0].setExtremes(utcTime - tmpRange + ctrl.minPadding, utcTime + ctrl.maxPadding);
            });
        }
    };

    var registerListener = function registerListener() {
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: true, windowId: ctrl.windowId });

        ctrl.liveData = true;
        websocketService.connect();
        websocketService.register('ANALOG', $scope.stickyProperties.device.serialNumber, $scope.stickyProperties.device.channel, wsDataReceivedTA, null);
        timeLapseService.register('ANALOG', $scope.stickyProperties.device.serialNumber, $scope.stickyProperties.device.channel, tlDataReceivedTA);
        websocketService.register("ANALOG_G2", $scope.stickyProperties.device.serialNumber, $scope.stickyProperties.device.channel, wsDataReceivedTA, null);
        timeLapseService.register('ANALOG_G2', $scope.stickyProperties.device.serialNumber, $scope.stickyProperties.device.channel, tlDataReceivedTA);
        websocketService.register("CALLINSCOUNT", $scope.stickyProperties.device.serialNumber, "", wsDataReceivedCALLINSCOUNT, null);

        var tmpSerialNumber = void 0;
        for (var i = 1; i < ctrl.tankAndWellRelay.length; i++) {
            if (ctrl.tankAndWellRelay[i].relayDevice.serialNumber === tmpSerialNumber) continue;
            websocketService.register('DIGITALOUTPUT', ctrl.tankAndWellRelay[i].relayDevice.serialNumber, '', wsDataReceivedTD, null);
            tmpSerialNumber = ctrl.tankAndWellRelay[i].relayDevice.serialNumber;
        }
    };

    var unregisterListener = function unregisterListener(varSerialNumber) {
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: ctrl.windowId });
        ctrl.liveData = false;

        if (angular.isDefined(callInCountTimeout)) {
            $timeout.cancel(callInCountTimeout);
            callInCountTimeout = undefined;
        }

        websocketService.unRegister('ANALOG', $scope.stickyProperties.device.serialNumber, $scope.stickyProperties.device.channel, wsDataReceivedTA, null);
        timeLapseService.unRegister('ANALOG', $scope.stickyProperties.device.serialNumber, $scope.stickyProperties.device.channel, tlDataReceivedTA);
        websocketService.unRegister('ANALOG_G2', $scope.stickyProperties.device.serialNumber, $scope.stickyProperties.device.channel, wsDataReceivedTA, null);
        timeLapseService.unRegister('ANALOG_G2', $scope.stickyProperties.device.serialNumber, $scope.stickyProperties.device.channel, tlDataReceivedTA);
        websocketService.unRegister("CALLINSCOUNT", $scope.stickyProperties.device.serialNumber, "", wsDataReceivedCALLINSCOUNT, null);

        var tmpSerialNumber = void 0;
        for (var i = 1; i < ctrl.tankAndWellRelay.length; i++) {
            if (ctrl.tankAndWellRelay[i].relayDevice.serialNumber === tmpSerialNumber) continue;
            websocketService.unRegister('DIGITALOUTPUT', ctrl.tankAndWellRelay[i].relayDevice.serialNumber, '', wsDataReceivedTD, null);
            tmpSerialNumber = ctrl.tankAndWellRelay[i].relayDevice.serialNumber;
        }
    };

    var getRightX = function getRightX(seriesNumber, index) {
        var cutSeries = ctrl.chart.series[seriesNumber];
        var curLength = cutSeries.data.length;
        var rightX = cutSeries.data[curLength - 1].x;

        if (typeof cutSeries.data[index + 1] === 'undefined') {
            // if go right, didn't find null, use the very right point
            rightX = cutSeries.data[index].x;
        } else if (cutSeries.data[index + 1].y === null) {
            // if the one on the right one is null//it is the very left point, then look for the next not null
            for (var i = index + 1; i < curLength; i++) {
                if (cutSeries.data[i].y !== null) {
                    rightX = cutSeries.data[i].x;
                    break;
                }
            }
        } else {
            // look for the right
            for (var _i = index + 1; _i < curLength; _i++) {
                if (cutSeries.data[_i].y === null) {
                    rightX = cutSeries.data[_i - 1].x;
                    break;
                }
            }
        }

        return rightX;
    };

    var getLeftX = function getLeftX(seriesNumber, index) {
        var cutSeries = ctrl.chart.series[seriesNumber];

        //Ref: Scada-1239
        var leftX = null;
        if (cutSeries && cutSeries.data && cutSeries.data.length > 0) {
            leftX = cutSeries.data[0].x;
        }

        if (typeof cutSeries.data[index - 1] === 'undefined') {
            // if the point is the very left point, use itself
            leftX = cutSeries.data[index].x;
        } else if (typeof cutSeries.data[index + 1] === 'undefined') {
            // last data
            for (var t = index - 1; t >= 0; t--) {
                if (cutSeries.data[t].y === null) {
                    leftX = cutSeries.data[t + 1].x;
                    break;
                }
            }
        } else if (cutSeries.data[index + 1].y === null) {
            // if the one on the left is null//it is the very right point, use the point itself
            leftX = cutSeries.data[index].x;
        } else {
            for (var _t = index - 1; _t >= 0; _t--) {
                if (cutSeries.data[_t].y === null) {
                    leftX = cutSeries.data[_t + 1].x;
                    break;
                }
            }
        }

        return leftX;
    };

    var millisecondsToStr = function millisecondsToStr(milliseconds) {
        function numberEnding(number) {
            return number > 1 ? 's' : '';
        }

        var temp = Math.floor(milliseconds / 1000);

        var years = Math.floor(temp / 31536000);
        if (years) {
            return years + ' ' + ctrl.translation.text.YEAR + numberEnding(years);
        }

        var days = Math.floor((temp %= 31536000) / 86400);
        if (days) {
            temp = temp - days * 86400;
            var rhours = Math.floor((temp %= 86400) / 3600);
            if (rhours > 0) {
                return days + ' ' + ctrl.translation.text.DAY + numberEnding(days) + ' ' + rhours + ' ' + ctrl.translation.text.HOUR + numberEnding(rhours);
            }

            return days + ' ' + ctrl.translation.text.DAY + numberEnding(days);
        }

        var hours = Math.floor((temp %= 86400) / 3600);
        if (hours) {
            temp = temp - hours * 3600;
            var rminutes = Math.floor((temp %= 3600) / 60);
            if (rminutes > 0) {
                return hours + ' ' + ctrl.translation.text.HOUR + numberEnding(hours) + ' ' + rminutes + ' ' + ctrl.translation.text.MINUTE + numberEnding(rminutes);
            }

            return hours + ' ' + ctrl.translation.text.HOUR + numberEnding(hours);
        }

        var minutes = Math.floor((temp %= 3600) / 60);
        if (minutes) {
            return minutes + ' ' + ctrl.translation.text.MINUTE + numberEnding(minutes);
        }

        var seconds = temp % 60;
        if (seconds) {
            return seconds + ' ' + ctrl.translation.text.SECOND + numberEnding(seconds);
        }

        return ctrl.translation.text.LESS_THAN_A_SECOND;
    };

    var getDuration = function getDuration(seriesNumber, index) {
        var duration = null;
        var rightX = getRightX(seriesNumber, index);
        var leftX = getLeftX(seriesNumber, index);

        if (rightX - leftX >= 0) {
            duration = millisecondsToStr(rightX - leftX);
        } else {
            duration = 0;
        }

        return duration;
    };

    var adjustScale = function adjustScale(chart, autoScale) {
        if (autoScale === false) {
            chart.yAxis[0].setExtremes(ctrl.tankAndWellDisplay.tankBottom, ctrl.tankAndWellDisplay.tankTop);
        } else {
            chart.yAxis[0].setExtremes(null, null);
        }
        varToggle = autoScale;
    };

    var get_unique_array = function get_unique_array(arr) {
        //remove duplicate datetime
        var obj = {};
        var ret_arr = [];
        for (var i = 0; i < arr.length; i++) {
            obj[arr[i][0]] = arr[i]; //localDateTime should be unique across the array items
        }
        for (var key in obj) {
            ret_arr.push(obj[key]);
        }
        return ret_arr;
    };

    var drawChart = function drawChart(resetView) {
        ctrl.chartDrawn = false;
        var chartBase = $('#tank-and-well-chart-' + ctrl.replaceSpaces(ctrl.windowId));
        //const tmpData = ctrl.series.data;
        var chartXaxisHourFormat = ctrl.preferredTimeFormat === ctrl.timeFormatEnum.civilian ? '%l:%M %p' : '%H:%M';
        var chartToolTipHourFormat = ctrl.preferredTimeFormat === ctrl.timeFormatEnum.civilian ? '%l:%M:%S %p' : '%H:%M:%S';
        var midPadding = 0;
        var maxPadding = 0;
        var self = _this2;

        var numberOfSeries = 0;
        var numberOfHiddenSeries = 0;

        ctrl.chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: true,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1,
                itemHoverStyle: {
                    cursor: 'default'
                }
            },
            time: {
                getTimezoneOffset: function getTimezoneOffset(timestamp) {
                    return -moment.tz(timestamp, datetimeService.getTimeZoneId(self.accountInfo.timeZone)).utcOffset();
                }
            },
            chart: {
                renderTo: chartBase[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#d3d3d3',
                borderWidth: 1,
                borderRadius: 2,
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                marginRight: 10,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                spacingRight: 5,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {
                        if (this.options.chart.forExport) return false;
                        var tankAndWellData = [];
                        var extremes = this.xAxis[0].getExtremes();

                        var tmpDates = null;
                        var i = -1;

                        if (this.xAxis && self.chartDrawn === true && self.scrollingInProgress === false) {
                            //if scrolling left
                            if (extremes && extremes.dataMin >= extremes.min - self.liveDataOffset) {
                                self.scrollingInProgress = true;
                                self.chart.showLoading();

                                //get one-day backward/past date range (dataMin-1day to dataMin)
                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -11);

                                tankAndWellService.GetChartData($scope.stickyProperties.deviceId, parseInt(tmpDates.startDate, 10), parseInt(tmpDates.endDate, 10), self.accountInfo.customerId, self.accountInfo.timeZone).then(function (resp) {
                                    for (var _i2 = 0; _i2 < resp.data.series.length; _i2++) {
                                        self.series[_i2].data = resp.data.series[_i2].data.concat(self.series[_i2].data);
                                        //if (self.series[i].name.endsWith('Off') || self.series[i].name.endsWith('On')) {
                                        // remove duplicates if any
                                        //self.series[i].data = get_unique_array(self.series[i].data);
                                        // order data in descending order
                                        //self.series[i].data.sort((a, b) => { return a[0] - b[0] });
                                        //console.log( self.series[i].data);
                                        //}
                                        self.chart.series[_i2].setData(self.series[_i2].data);
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, windowId: self.windowId });
                                    self.chart.xAxis[0].setExtremes(extremes.min + self.minPadding, extremes.max + self.maxPadding);
                                    //self.chart.yAxis[0].setExtremes(null, null);
                                    setLiveDataStatus();

                                    $timeout(function () {
                                        self.scrollingInProgress = false;
                                    }, 1000);

                                    self.chart.hideLoading();
                                });
                                //if scrolling right
                            } else if (self.liveData === false && extremes && extremes.max + self.liveDataOffset >= extremes.dataMax) {
                                self.scrollingInProgress = true;
                                self.chart.showLoading();

                                //get one-day forward/future date range (dataMax to dataMax+1day)
                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 11);

                                tankAndWellService.GetChartData($scope.stickyProperties.deviceId, parseInt(tmpDates.startDate, 10), parseInt(tmpDates.endDate, 10), self.accountInfo.customerId, self.accountInfo.timeZone).then(function (resp) {
                                    var tmpSeries = self.series;
                                    for (var _i3 = 0; _i3 < resp.data.series.length; _i3++) {
                                        if (resp.data.series[_i3].data.length > 0) {
                                            if (resp.data.series[_i3].id.search('relay') !== -1) {
                                                removeNull(_i3, self.chart);
                                            }

                                            self.series[_i3].data = self.series[_i3].data.concat(resp.data.series[_i3].data);
                                            //if (self.series[i].name.endsWith('Off') || self.series[i].name.endsWith('On')) {
                                            // remove duplicates if any
                                            //self.series[i].data = get_unique_array(self.series[i].data);
                                            // order data in descending order
                                            //self.series[i].data.sort((a, b) => { return a[0] - b[0] });
                                            //console.log( self.series[i].data);
                                            //}
                                            self.chart.series[_i3].setData(self.series[_i3].data, true);
                                        }
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: tmpDates.endDate, windowId: self.windowId });
                                    self.chart.xAxis[0].setExtremes(extremes.min + self.minPadding, extremes.max + self.maxPadding);
                                    //self.chart.yAxis[0].setExtremes(null, null);
                                    setLiveDataStatus(tmpDates.endDate);

                                    $timeout(function () {
                                        self.scrollingInProgress = false;
                                    }, 1000);

                                    self.chart.hideLoading();
                                });
                            }
                        }
                    },
                    load: function load(event) {
                        if (self.initialLoad) openViewService.adjustContentSize(self.popup);
                        self.initialLoad = false;
                    },
                    selection: function selection(event) {
                        if (!event.xAxis) {
                            var button = this.exportSVGElements[0];
                            var button2 = this.exportSVGElements[2];
                            button.attr({
                                x: -5
                            });
                            button2.attr({
                                x: -200
                            });
                            adjustScale(this, false);
                        }
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        enabled: false
                    },
                    customButton: {
                        symbol: 'text:\uF205',
                        text: ctrl.translation.text.AUTO_SCALE,
                        symbolSize: 9,
                        symbolFill: '#337ab7',
                        symbolStrokeWidth: 0,
                        align: "left",
                        verticalAlign: 'bottom',
                        x: varToggle ? -5 : -200,
                        y: $rootScope.mobile ? -65 : -65, //I know...
                        symbolY: $rootScope.mobile ? 14 : 14,
                        theme: {
                            'stroke-width': 0,
                            stroke: 'transparent',
                            fill: 'transparent',
                            r: 0,
                            states: {
                                hover: {
                                    title: ctrl.translation.text.TOGGLE_AUTOSCALE,
                                    fill: 'transparent'
                                },
                                select: {
                                    stroke: 'transparent',
                                    fill: 'transparent'
                                }
                            }
                        },
                        onclick: function onclick() {
                            var button = this.exportSVGElements[0];
                            var button2 = this.exportSVGElements[2];
                            button.attr({
                                x: -200
                            });
                            button2.attr({
                                x: -5
                            });
                            adjustScale(this, false);
                        }
                    },
                    customButton2: {
                        symbol: 'text:\uF204',
                        text: ctrl.translation.text.AUTO_SCALE,
                        symbolSize: 9,
                        symbolFill: '#6b7074',
                        symbolStrokeWidth: 0,
                        align: "left",
                        verticalAlign: 'bottom',
                        x: varToggle ? -200 : -5,
                        y: $rootScope.mobile ? -65 : -65, //I know...
                        symbolY: $rootScope.mobile ? 14 : 14,
                        theme: {
                            'stroke-width': 0,
                            stroke: 'transparent',
                            fill: 'transparent',
                            r: 0,
                            states: {
                                hover: {
                                    title: ctrl.translation.text.TOGGLE_AUTOSCALE,
                                    fill: 'transparent'
                                },
                                select: {
                                    stroke: 'transparent',
                                    fill: 'transparent'
                                }
                            }
                        },
                        onclick: function onclick() {
                            var button = this.exportSVGElements[0];
                            var button2 = this.exportSVGElements[2];
                            button.attr({
                                x: -5
                            });
                            button2.attr({
                                x: -200
                            });
                            adjustScale(this, true);
                        }
                    }
                }
            },
            xAxis: {
                title: {
                    text: ctrl.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 3,
                    color: 'green',
                    dashStyle: 'solid',
                    zIndex: 10
                }],
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minorTickInterval: 'auto',
                minorGridLineColor: '#ebebeb',
                dateTimeLabelFormats: {
                    second: chartXaxisHourFormat,
                    minute: chartXaxisHourFormat,
                    hour: chartXaxisHourFormat
                },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (self.chartDrawn === true) {
                            if (e.trigger === 'rangeSelectorButton') {

                                var newRanges = rangeSelectorService.getrangeExtremes(e.dataMax, e.dataMin, e.rangeSelectorButton, $scope.dataGroupingInterval);

                                sharedSetupService.setStickyProperties($scope.stickyProperties, {
                                    zoomMin: newRanges.newMin,
                                    zoomMax: newRanges.newMax,
                                    windowId: scope.windowId
                                });
                                $scope.stickyProperties.on = true;
                                //Reload
                                if (newRanges.newDataMax < event.dataMin || newRanges.newDataMax > event.dataMax) getData($scope.stickyProperties.deviceId, newRanges.newDataMin, newRanges.newDataMax);
                            } else {
                                var _extremes = self.chart.xAxis[0].getExtremes();
                                if (self.liveData === true && (e.trigger === 'navigator' || e.trigger === 'pan' || typeof e.trigger === 'undefined')) {
                                    if (_extremes.max + self.liveDataOffset <= _extremes.dataMax) {
                                        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: self.windowId });
                                        unregisterListener($scope.deviceSelectedSn);
                                    }
                                }
                                sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: _extremes.min, zoomMax: _extremes.max, windowId: self.windowId });
                            }
                        }
                    }
                }
            },
            yAxis: [{
                top: '0%',
                height: ctrl.numberOfPumps == 0 ? "100%" : ctrl.numberOfPumps <= 3 ? "94%" : "90%",
                gridLineWidth: 0,
                // min: ctrl.tankAndWellDisplay.chartBottom,
                // max: ctrl.tankAndWellDisplay.chartTop,
                lineWidth: 2,
                opposite: false,
                startOnTick: true,
                endOnTick: true,
                minPadding: 0,
                showLastLabel: false,
                showFirstLabel: true,
                labels: {
                    format: '{value:.2f}'
                },
                title: { text: ctrl.analogName, style: { color: '#000' } },
                plotLines: ctrl.plotLines
            }, {
                top: ctrl.numberOfPumps == 0 ? "100%" : ctrl.numberOfPumps <= 3 ? "94%" : "90%",
                height: ctrl.numberOfPumps == 0 ? "0%" : ctrl.numberOfPumps <= 3 ? "6%" : "10%",
                offset: 0,
                gridLineWidth: 0,
                lineWidth: 2,
                showLastLabel: true,
                showFirstLabel: true,
                startOnTick: true,
                endOnTick: true,
                opposite: false,
                min: ctrl.numberOfPumps <= 3 ? -4 : -ctrl.numberOfPumps - 1,
                max: 0,
                steps: 1,
                labels: {
                    enabled: false
                },
                plotBands: [{
                    from: ctrl.numberOfPumps <= 3 ? -4 : -ctrl.numberOfPumps - 2,
                    to: 0,
                    color: '#edffff',
                    borderColor: '#d1fdfd',
                    borderWidth: 1
                }]
            }],
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    self.xValue = this.x;
                    var twPoints = this.points;
                    // The first returned item is the header, subsequent items are the
                    // points
                    if (this.points) {
                        var tip = '';
                        //format datetime for shared header
                        tip += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                        tip += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(twPoints[0].x, ctrl.accountInfo.timeZone)) + '</td></tr>';
                        tip += '</table>';

                        //fetch tooptip from setpoints
                        tip += _getTooltipForSetpoints(twPoints);
                        //fetch tooptip for plotlines (ie., setpoints without offpeak profiles)
                        tip += _getTooltipForPlotLines();
                        //fetch tooptip from analog/relay/flag series
                        tip += _getTooltipForSerie(twPoints);

                        $timeout(function () {
                            _twTooltipBusy = false;
                        }, 0);
                        return tip;
                    }
                },

                split: false,
                shared: true,
                shadow: true,
                stickOnContact: true,
                crosshairs: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 0,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        second: chartXaxisHourFormat,
                        minute: chartXaxisHourFormat,
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
            },
            plotOptions: {
                series: {
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                self.xValue = this.x;
                            }
                        }
                    },

                    events: {
                        //legendItemClick() {
                        //    //numberOfSeries = ctrl.chart.series.length - 1;
                        //    //const visibility = ctrl.visible ? 'visible' : 'hidden';
                        //    //numberOfHiddenSeries = visibility === 'hidden' ? numberOfHiddenSeries - 1 : numberOfHiddenSeries + 1;
                        //    //numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                        //    //if (numberOfHiddenSeries < numberOfSeries) {
                        //    //  ctrl.chart.yAxis[this.index].update({
                        //    //    labels: {
                        //    //      enabled: visibility !== 'visible',
                        //    //    },
                        //    //    title: {
                        //    //      text: visibility === 'visible' ? null : self.series[ctrl.index].name,
                        //    //    },
                        //    //    lineWidth: visibility === 'visible' ? 0 : 2,
                        //    //  });
                        //    //  return true;
                        //    //}
                        //    //numberOfHiddenSeries = numberOfHiddenSeries - 1;
                        //    return false;
                        //},
                        mouseOut: function mouseOut() {
                            self.xValue = null;
                        }
                    },
                    stickyTracking: false
                }
            },
            series: ctrl.series
        }, function (chart) {
            adjustScale(chart, varToggle);
        });

        var tmpNewDateA = void 0;
        var tmpNewDateB = void 0;
        var extremes = ctrl.chart.xAxis[0].getExtremes();

        if ($scope.stickyProperties.on === true) {
            tmpNewDateA = $scope.stickyProperties.zoomMin >= extremes.dataMin ? $scope.stickyProperties.zoomMin : extremes.dataMin;
            tmpNewDateB = $scope.stickyProperties.zoomMax <= extremes.dataMax + ctrl.liveDataOffset ? $scope.stickyProperties.zoomMax : extremes.dataMax;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + ctrl.unixDay / 24 ? tmpNewDateB : extremes.dataMax - ctrl.unixDay / 24 * 12;
            $scope.stickyProperties.on = false;
        } else {
            tmpNewDateA = ctrl.myDate !== null ? extremes.dataMin + ctrl.unixDay : extremes.dataMax - ctrl.unixDay / 24 * 6;
            tmpNewDateB = ctrl.myDate !== null ? tmpNewDateA + ctrl.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - ctrl.unixDay;
            }
            tmpNewDateA = tmpNewDateA + ctrl.minPadding;
            tmpNewDateB = tmpNewDateB + ctrl.maxPadding;
        }

        if (tmpNewDateA > tmpNewDateB) {
            var temp = tmpNewDateA;
            tmpNewDateA = tmpNewDateB;
            tmpNewDateB = temp;
        }

        ctrl.chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        //ctrl.chart.yAxis[0].setExtremes(null, null);
        if (ctrl.series !== null) {
            // only for analog chart if no setup
            sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: ctrl.windowId });
        } else {
            // ctrl.chart.showLoading('Pulse Flow Setup not available!');
        }

        if (!resetView) {
            setLiveDataStatus();
        } else {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var data = { Unix: resp.data.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedTA(data);
            });
        }

        ctrl.chartDrawn = true;
        ctrl.chart.redraw();
    };

    var _getTooltipForSetpoints = function _getTooltipForSetpoints(twPoints) {
        if (_twTooltipBusy || twPoints.length < 1) return '';
        _twTooltipBusy = true;

        var headerTip = '';
        var contentTip = '';

        // updated tooltip for setpoints to display relayseries(pump) color instead its own color
        twPoints.forEach(function (point) {
            var pumpIdx = -1;
            switch (point.series.name) {
                case 'LeadPumpOn':
                case 'LeadPumpOff':
                    pumpIdx = 1;
                    break;
                case 'LagPumpOn':
                case 'LagPumpOff':
                    pumpIdx = 2;
                    break;
                case 'Lag2PumpOn':
                case 'Lag2PumpOff':
                    pumpIdx = 3;
                    break;
                case 'Lag3PumpOn':
                case 'Lag3PumpOff':
                    pumpIdx = 4;
                    break;
                case 'Lag4PumpOn':
                case 'Lag4PumpOff':
                    pumpIdx = 5;
                    break;
            }

            var tmpSerie = ctrl.series.find(function (se) {
                return se.id.indexOf('relayseries' + pumpIdx) > -1;
            });

            if (!angular.isUndefined(tmpSerie)) {
                var pumpColor = tmpSerie.color;
                contentTip += '<br><span style="color: ' + pumpColor + ';">' + point.series.name + ': ' + point.point.y + '</span>';
            } else {
                _twTooltipBusy = false;
                return '';
            }
        });

        if (contentTip.length > 0) contentTip = headerTip + contentTip;

        return contentTip;
    };
    var _getTooltipForPlotLines = function _getTooltipForPlotLines() {
        if (_twTooltipBusy || ctrl.plotLines.length < 1) return '';
        _twTooltipBusy = true;

        var headerTip = '';
        var contentTip = '';

        // updated tooltip for setpoints of non-offpeak profiles
        ctrl.plotLines.forEach(function (pl) {
            contentTip += '<br><span style="color: ' + pl.color + ';">' + pl.name + ': ' + pl.value + '</span>';
        });

        if (contentTip.length > 0) contentTip = headerTip + contentTip;

        return contentTip;
    };
    var _getTooltipForSerie = function _getTooltipForSerie(twPoints) {
        var tip = '';
        twPoints.forEach(function (point) {
            if (point.series.options.id.toLowerCase().indexOf('analogseries') > -1) //analog data
                {
                    tip += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    tip += '<tr><td style="color: ' + point.series.color + ';">' + ctrl.analogName + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, 2) + '</td></tr>';
                    tip += '</table>';
                } else if (point.series.options.id.toLowerCase().indexOf('relayseries') > -1) {
                var status = ctrl.translation.text.CLOSE;

                if (point.point.index == point.series.data.length - 1 && point.point.y != null) {
                    //last point and in close status
                    status = ctrl.translation.text.STARTED;
                } else if (point.series.data[point.point.index + 1].y == null) {
                    status = ctrl.translation.text.STOPPED;
                } else {
                    status = ctrl.translation.text.STARTED;
                }

                tip += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                tip += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + status + '</td></tr>';
                tip += '<tr><td style="color: ' + point.series.color + ';">' + status + ' ' + ctrl.translation.text.FOR + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + getDuration(point.series.index, point.point.index) + '</td></tr>';

                tip += '</table>';
            } else if (point.series.options.id.toLowerCase().indexOf('flagseries') > -1) {
                tip += '<br><span style="color: ' + point.series.color + ';">' + point.point.text + '</span>';
            }
        });
        return tip;
    };

    var getData = function getData(varSerialNumber, startDate, endDate) {
        ctrl.liveDataEndDate = endDate;

        ctrl.isLoading = true;
        tankAndWellService.GetChartData($scope.stickyProperties.deviceId, startDate, endDate, ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone).then(function (resp) {
            ctrl.isLoading = false;
            ctrl.series = resp.data.series;

            //// start new logic ///////
            //for (let i = 0; i < resp.data.series.length; i++) {
            //    // on initial data fetch, massage setpoints related series data
            //    if (resp.data.series[i].name.endsWith('Off') || resp.data.series[i].name.endsWith('On')) {
            //        // remove duplicates if any
            //        ctrl.series[i].data = get_unique_array(resp.data.series[i].data);
            //        // order data in descending order
            //        ctrl.series[i].data.sort((a, b) => { return a[0] - b[0] });
            //        //console.log(ctrl.series[i].data);
            //    }
            //}
            //// end new logic ///////

            ctrl.tankAndWellAnalog = resp.data.tankAndWellAnalog;
            ctrl.tankAndWellRelay = resp.data.tankAndWellRelay;
            ctrl.tankAndWellBasic = resp.data.tankAndWellBasic;
            ctrl.flagSeries = resp.data.flagSeries;
            ctrl.allSeries = ctrl.series;
            ctrl.yAxis = resp.data.yAxis;
            ctrl.plotLines = resp.data.plotLines;
            ctrl.tankAndWellDisplay = resp.data.tankAndWellDisplay;
            ctrl.analogName = resp.data.tankAndWellAnalog.analogSetting.name + ' (' + resp.data.tankAndWellAnalog.analogSetting.unit + ')';
            ctrl.tickInterval = (ctrl.tankAndWellDisplay.chartTop - ctrl.tankAndWellDisplay.chartBottom) / ctrl.tankAndWellDisplay.chartGrid;
            sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate });
            self.chartTop = ctrl.tankAndWellDisplay.chartTop;
            self.chartBottom = ctrl.tankAndWellDisplay.chartBottom;
            ctrl.numberOfPumps = ctrl.series.filter(function (item) {
                return item.id.toLowerCase().indexOf('relayseries') > -1;
            }).length;
            drawChart();
        }, function (resp) {
            var error = resp.data;

            var errormsg = ctrl.translation.message[error.message];
            ctrl.alerts.push({ msg: errormsg, type: 'danger' });
            $scope.alerts.push({ msg: errormsg, type: 'danger' });
        }).finally(function () {
            //$scope.pageloading = false;
            //$scope.$parent.loadingInProgress = false;
            //$scope.chartBusy = false;
        });
    };

    ctrl.$onInit = function () {
        if (!ctrl.mobile) {
            $scope.qdpLeft = -237;
        }
        sharedSetupService.getWindowId(_this2);
        ctrl.title = '';
        ctrl.chart = null;
        ctrl.device = null;
        ctrl.series = [];
        ctrl.xValue = null;
        ctrl.alerts = [];
        $scope.alerts = [];
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.timeFormatEnum = { civilian: 1, military: 2 };
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.scrollingInProgress = false;
        ctrl.liveDataOffset = 20 * 60 * 1000;
        ctrl.minPadding = 0;
        ctrl.maxPadding = 0;
        ctrl.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties.device.title = $scope.stickyProperties.device.deviceName;
        $scope.wsDeviceID = $scope.stickyProperties.device.wsDeviceId || $scope.stickyProperties.deviceId;
        ctrl.initialLoad = true;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            if (!$scope.stickyProperties.device.title) {
                tankAndWellService.GetBasicInfo($scope.wsDeviceID, ctrl.accountInfo.customerId).then(function (resp) {
                    $scope.stickyProperties.device.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                    ctrl.popup.dialog('option', 'title', ctrl.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);
                });
            } else {
                ctrl.popup.dialog('option', 'title', ctrl.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);
            }

            sharedSetupService.maximize(ctrl.popup);
        } else {
            if (!$scope.stickyProperties.deviceId) {
                $location.path('/tankandwell/overview/template');
            }

            if (!$scope.stickyProperties.device.title) {
                tankAndWellService.GetBasicInfo($scope.wsDeviceID, ctrl.accountInfo.customerId).then(function (resp) {
                    $scope.stickyProperties.device.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                    ctrl.title = $scope.stickyProperties.device.title;
                });
            } else {
                ctrl.title = $scope.stickyProperties.device.title;
            }
        }

        $scope.$on('updatePreferencesLanguage', function () {
            if (!ctrl.mobile && !ctrl.classicView) {
                ctrl.popup.dialog('option', 'title', ctrl.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);
            }

            drawChart();
        });

        // following code handling is applicable to Dual Tank Systems.
        $scope.$on('alternateSourceUpdated', function () {
            if (!ctrl.mobile && !ctrl.classicView) {
                var myPromise = tankAndWellService.GetBasicInfo($scope.wsDeviceID, ctrl.accountInfo.customerId);
                myPromise.then(function (resp) {
                    $scope.stickyProperties.device.title = getTitle(resp.data.sourceDevice.name, resp.data.tankAndWellLabels.labelSource, resp.data.tankAndWellBasic.sourceAnalogChannel, resp.data.analogSetting === null ? '' : resp.data.analogSetting.name);
                    ctrl.title = $scope.stickyProperties.device.title;
                    ctrl.popup.dialog('option', 'title', ctrl.translation.text.TANK_AND_WELL + ', ' + $scope.stickyProperties.device.title);

                    getData(null, Math.floor($scope.stickyProperties.dateMin), Math.floor($scope.stickyProperties.dateMax));

                    drawChart();
                }, function (error) {
                    console.log(error);
                });
            }
        });

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            ctrl.preferredTimeFormat = parseInt(timeFormat, 10);
            drawChart();
        });

        $timeout(function () {
            var chartBase = $('#tank-and-well-chart-' + ctrl.replaceSpaces(ctrl.windowId));

            chartBase.on('mousewheel', function (event) {
                if (ctrl.xValue === null) {
                    var tempVal = ($scope.stickyProperties.zoomMax + $scope.stickyProperties.zoomMin) / 2;
                    ctrl.mouseWheelZoom(event, ctrl.chart, tempVal);
                } else {
                    ctrl.mouseWheelZoom(event, ctrl.chart, ctrl.xValue);
                }
            });
        });

        {
            sharedSetupService.setStickyProperties($scope.stickyProperties, { windowId: ctrl.windowId });

            var tmpDates = null;
            var tmpStartDate = null;
            var tmpEndDate = null;

            if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
                $scope.stickyProperties.on = true;
                tmpStartDate = $scope.stickyProperties.dateMin;
                tmpEndDate = $scope.stickyProperties.dateMax;
            } else {
                $scope.stickyProperties.on = false;
            }

            if (!tmpStartDate) {
                timeLapseService.getLocalDateTime().then(function (resp) {
                    var result = resp.data;

                    tmpDates = new Date(result.localDateTime);
                    tmpDates.setHours(0, 0, 0, 0);
                    tmpDates = datetimeService.dateToUnixtime(tmpDates);
                    tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                    tmpDates = datetimeService.startEndLocalToUtc(tmpDates, ctrl.accountInfo.timeZone);
                    tmpStartDate = tmpDates.startDate;
                    tmpEndDate = tmpDates.endDate;
                    getData(null, tmpStartDate, tmpEndDate);
                });
            } else {
                getData(null, tmpStartDate, tmpEndDate);
            }
        }

        ctrl.zoomAdjust = function (varDay) {
            var extremes = ctrl.chart.xAxis[0].getExtremes();
            var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, $scope.heartbeatLocalDateTime);
            ctrl.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
            setLiveDataStatus();
        };

        $scope.mostRecentData = function () {
            ctrl.myDate = null;
            toaster.pop('success', ctrl.windowTitle + " -- " + $scope.stickyProperties.device.title, 'View reloading');
            $scope.fetchDataForSelectedDate(new Date());
        };

        $scope.fetchDataForSelectedDate = function (newVal) {
            var chartBase = $('#tank-and-well-chart-' + ctrl.replaceSpaces(ctrl.windowId));
            var tmpDates = newVal;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.startEndLocalToUtc(tmpDates, ctrl.accountInfo.timeZone);
            ctrl.myDate = tmpDates;
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);

            getData(null, tmpDates.startDate, tmpDates.endDate);
        };

        $scope.$watch(function () {
            return ctrl.myDate;
        }, function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                $scope.fetchDataForSelectedDate(newVal);
            }
        });

        ctrl.$onDestroy = function () {
            unregisterListener();
        };

        $scope.$on('processReconnect', function (event, args) {
            if (ctrl.liveData === false) {
                unregisterListener();
                return;
            }
            $scope.mostRecentData();
        });

        $scope.$on('pumpPositionChanged', function () {
            ctrl.isLoading = true;

            $scope.mostRecentData();

            $timeout(function () {
                ctrl.isLoading = false;
            }, 500);
        });
    };

    ctrl.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    ctrl.$onDestroy = function () {
        unregisterListener();
    };
}

TWChartController.$inject = ['$scope', '$rootScope', '$location', '$timeout', 'authenticationService', 'datetimeService', 'openViewService', 'sharedSetupService', 'tankAndWellService', 'timeLapseService', 'translationService', 'websocketService', 'toaster', 'rangeSelectorService', 'deviceMenuService'];

angular.module('mc.tankandwell').component('tankAndWellChart', {
    controller: TWChartController,
    transclude: true,
    templateUrl: 'ui/tankandwell/chart/partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        windowTitle: '<'
    }
});
"use strict";

angular.module("mc.assign-user-to-customer", []);
'use strict';

function AssignUserToCustomerFactory(HOST, $http) {

    var _assignUserToCustomerFactory = function _assignUserToCustomerFactory() {};

    _assignUserToCustomerFactory.prototype.isUserMissionManager = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupport/IsUserMissionManager/'
        });
    };

    _assignUserToCustomerFactory.prototype.fetch2FAUsers = function (customerId) {
        return $http.get(HOST + "/api/Logins/Get2FAUsers/" + "?customerId=" + customerId).then(function (response) {
            return response.data;
        });
    };
    _assignUserToCustomerFactory.prototype.GetCustomerAccessList = function (customerId, loginId) {

        return $http.get(HOST + "/api/TechSupportAssignCustomer/GetCustomerAccessList/" + "?customerId=" + customerId + "&loginId=" + loginId).then(function (response) {
            return response.data;
        });
    };

    _assignUserToCustomerFactory.prototype.addNewLoginAuthorization = function (customerId, loginId, userRole) {

        return $http.post(HOST + "/api/TechSupportAssignCustomer/AssignCustomerToUser/" + "?customerId=" + customerId + "&loginId=" + loginId + "&accessLevel=" + userRole).then(function (response) {
            return response.data;
        });
    };

    _assignUserToCustomerFactory.prototype.removeLoginAuthorization = function (customerId, loginId) {

        return $http.delete(HOST + "/api/TechSupportAssignCustomer/RemoveCustomerFromUser/" + "?customerId=" + customerId + "&loginId=" + loginId).then(function (response) {
            return response.data;
        });
    };

    _assignUserToCustomerFactory.prototype.updateUserRoleForCustomer = function (customerId, loginId, userRole) {

        return $http.put(HOST + "/api/TechSupportAssignCustomer/UpdateUserRoleForCustomer/" + "?customerId=" + customerId + "&loginId=" + loginId + "&accessLevel=" + userRole).then(function (response) {
            return response.data;
        });
    };

    return _assignUserToCustomerFactory;
}

AssignUserToCustomerFactory.$inject = ['HOST', '$http'];

angular.module('mc.assign-user-to-customer').factory('AssignUserToCustomerFactory', AssignUserToCustomerFactory);
"use strict";

function AssignUserToCustomerController($, $scope, authenticationService, translationService, sharedSetupService, openViewService, AssignUserToCustomerFactory, TechSupportAssignCustomerFactory, $filter, $uibModal, toaster) {
    var _this2 = this;

    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    //ctrl.requiredCustomers = [];
    //ctrl.selectedCustomers = [];
    //ctrl.allCustomerSelected = false;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.customerId = ctrl.accountInfo.customerId;
        ctrl._assignUserToCustomerFactory = new AssignUserToCustomerFactory();
        ctrl._techSupportAssignCustomerFactory = new TechSupportAssignCustomerFactory();
        ctrl.loading = false;
        ctrl.isMissionManager = true;
        ctrl.reqRefresh = false;
        ctrl.editModeIndex = -1;
        ctrl.tableDisplay = false;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for   
        $scope.alerts = [];
        ctrl.customerAccessList = [];

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                // $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }
        ctrl.get2FALogins();
        ctrl.getCustomersList();

        // getting the elements by Id for them to enable/disable accordingly
        ctrl.customerName = document.getElementById('customerName');
        ctrl.customerName.disabled = true;
        ctrl.customerNameDropdownList = document.getElementById('customerNameDropdownList');
        ctrl.clearFilter = false;
        ctrl.roleDropdown = document.getElementById('roleDropdown');
        ctrl.roleDropdown.disabled = true;
        ctrl.grantAccess = document.getElementById('grantAccess');
        ctrl.grantAccess.disabled = true;
        ctrl.editModeIndex = null;
        ctrl.reverse = false;
    };

    var orderBy = $filter("orderBy");
    ctrl.order = function (predicate, reverse) {
        switch (predicate) {
            case "customerName":
                ctrl.accessLevelDesc = reverse ? '-accessLevelDesc' : 'accessLevelDesc';
                ctrl.customerAccessList = orderBy(ctrl.customerAccessList, [predicate, ctrl.accessLevelDesc], reverse); //Getting error for this line
                break;
            default:
                ctrl.customerAccessList = orderBy(ctrl.customerAccessList, predicate, reverse);
                break;
        }
        ctrl.predicate = predicate;
    };

    //Commenting the below $scope.setSorting as the intial asc order sorting is done by stored procedure
    // $scope.setSorting = function () { 
    //     ctrl.order('customerName', ctrl.reverse);
    // };

    ctrl.toggle = function ($event) {
        if ($($event.currentTarget).hasClass("active-row")) {
            $($event.currentTarget).removeClass("active-row");
        } else {
            $($event.currentTarget).addClass("active-row");
        }
    };

    // Function to show the dropdown when Customer Name input/select button is clicked
    var showDropdown = function showDropdown() {
        ctrl.editModeIndex = null;
        ctrl.customerName.setAttribute("placeholder", "Search ..."); // once drowndown is seen input placeholder should display Filter
        var filter = ctrl.customerName.value.toLowerCase();
        var filteredOptions = ctrl.customersList.filter(function (option) {
            return option.name.toLowerCase().includes(filter);
        });
        ctrl.renderOptions(filteredOptions); // Render filtered options
    };

    // Function to render options in the dropdown list
    ctrl.renderOptions = function (options) {
        ctrl.customerNameDropdownList.innerHTML = ''; // Clear the existing options
        // Assigning customerId and name to optionElement for it to display value in
        options.forEach(function (option) {
            var optionElement = document.createElement('div');
            optionElement.classList.add('dropdownOption');
            if (option.customerId == ctrl.accountInfo.customerId) {
                optionElement.textContent = option.name;
                optionElement.id = option.customerId;
                //Graying out the Customer Name which login user is logged in from
                optionElement.style.color = "darkgrey";
                optionElement.style.cursor = "not-allowed";
            } else {
                optionElement.textContent = option.name;
                optionElement.id = option.customerId; // Store the ID in data attribute
                optionElement.onclick = function () {
                    return ctrl.selectOption(option); // returning selected option on selecting value from dropdown
                };
            }
            ctrl.customerNameDropdownList.appendChild(optionElement); // adding each option in the dropdown list
        });
        ctrl.customerNameDropdownList.style.display = options.length ? 'block' : 'none'; // Show or hide dropdown based on options
    };

    //check if current user is manager or not and do following procedure accordingly
    ctrl.isCurrentUserManager = function () {
        ctrl._techSupportSummaryByAgent.isUserMissionManager().then(function (resp) {
            ctrl.isMissionManager = resp.data;
            if (ctrl.isMissionManager) {
                //login id for Paul, Joe and Yifan and Peter. Yifan and Peter are for testing purpose            
                ctrl.getTechSupportAgents();
            } else {
                ctrl.getTechSupportSummaries(-1); //pass -1 as parameter to get web login id from mcToken in service
            }
        });
    };

    //Get 2FA Users
    ctrl.get2FALogins = function () {
        ctrl.loading = true;
        ctrl._assignUserToCustomerFactory.fetch2FAUsers(ctrl.customerId).then(function (resp) {
            ctrl.twoFAUsers = resp.loginsInfo;
            ctrl.userRoleList = resp.userRoleList;
            ctrl.loading = false;
        });
    };

    //Get 2FA Users
    ctrl.getCustomersList = function () {
        ctrl._techSupportAssignCustomerFactory.fetchAllCustomersList().then(function (resp) {
            ctrl.customersList = resp.data;
        });
    };

    //Get Customer Access List
    ctrl.getCustomerAccessList = function (userId, error) {
        ctrl._assignUserToCustomerFactory.GetCustomerAccessList(ctrl.customerId, userId).then(function (resp) {
            ctrl.customerAccessList = resp;
            ctrl.tempCustomerAccessList = ctrl.customerAccessList;
            ctrl.tableDisplay = true;
            ctrl.loading = false;
            if (ctrl.customerAccessList.length === 0) {
                $scope.alerts.push({ msg: "No Data", type: 'info', languageCode: 'NO_DATA' });
            } else {
                $scope.alerts = [];
            }
            if (error) {
                toaster.pop('error', translationService.translation.text.ERROR, "Something went wrong.");
            }
        });
    };

    //Select User
    ctrl.selectUser = function (selectedUser) {
        if (selectedUser != null) {
            ctrl.alerts = []; //
            $scope.alerts = [];
            ctrl.editModeIndex = null;
            ctrl.reverse = null; //set the sorting to null when User is changed so that sorting icon hides
            ctrl.loading = true;
            ctrl.getCustomerAccessList(ctrl.selectedUser.userId, false);
            ctrl.customerName.disabled = false;
        } else {
            // if User Name dropdown has no value then clear and disable Customer Name, Role and Grant Access Button
            ctrl.customerAccessList = [];
            ctrl.tableDisplay = false;
            ctrl.customerName.disabled = true;
            ctrl.customerName.value = null;
            ctrl.userRole = null;
            ctrl.roleDropdown.disabled = true;
            ctrl.clearFilter = false;
            ctrl.grantAccess.disabled = true;
        }
    };

    ctrl.selectUserRole = function (userRole) {
        ctrl.clearFilter = false; //icon to disable while role is selected
        ctrl.editModeIndex = null;
        if (userRole != null) {
            // if clause to enable Grant Access button when Customer Name and User Role is selected
            if (ctrl.selectedCustomer == null) {
                ctrl.grantAccess.disabled = true; // Role selected but Customer Name not selected then disable Grant Acccess button
            } else {
                ctrl.grantAccess.disabled = false; // Role selected and Customer Name selected then enable Grant Acccess button
            }
        } else {
            ctrl.grantAccess.disabled = true; //if role not selected then disable Grant Access button
        }
    };

    ctrl.addNewLoginAuthorization = function () {
        $scope.alerts = [];
        ctrl.tempObject = [];
        if (ctrl.selectedCustomer != -1 && ctrl.selectedUser != -1 && ctrl.userRole != -1) {
            ctrl.tempObject = {
                "accessLevel": ctrl.userRole.id,
                "accessLevelDesc": ctrl.userRole.value,
                "custid": ctrl.selectedCustomer.customerId,
                "customerName": ctrl.selectedCustomer.name,
                "loginID": ctrl.selectedUser.userId
            };
            ctrl._assignUserToCustomerFactory.addNewLoginAuthorization(ctrl.selectedCustomer.customerId, ctrl.selectedUser.userId, ctrl.userRole.id).then(function (resp) {
                if (resp == 1) {
                    ctrl.tempCustomerAccessList.unshift(ctrl.tempObject);
                    ctrl.customerAccessList = ctrl.tempCustomerAccessList;
                    // ctrl.refreshData(false);
                    // set the value of input box to null and remove clear filter icon after Grant Access is completed
                    ctrl.clearDropdownValues();
                } else if (resp == 0) {
                    toaster.pop('warning', translationService.translation.text.WARNING, "Customer Name already exists");
                }
            });
        }
    };

    // Initial remove action without confirmation modal
    // ctrl.removeLoginAuthorization = (customer) => {
    // if (ctrl.selectedUser != -1) {
    //     ctrl._assignUserToCustomerFactory.removeLoginAuthorization(customer.custid, ctrl.selectedUser.userId).then((resp) => {
    //         ctrl.refreshData(false);
    //     });
    // }
    // };


    ctrl.removeLoginAuthorization = function (customer, index) {
        $scope.alerts = [];
        ctrl.editModeIndex = null;
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.REMOVE + " access for " + (ctrl.selectedUser.fullName + ' to ' + customer.customerName) + ".";

            this.ok = function () {
                $uibModalInstance.close(customer);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (customer) {
            ctrl._assignUserToCustomerFactory.removeLoginAuthorization(customer.custid, ctrl.selectedUser.userId).then(function (resp) {
                ctrl.editModeIndex = null;
                if (resp == 1) {
                    ctrl.customerAccessList.splice(index, 1);
                    if (ctrl.customerAccessList.length === 0) {
                        $scope.alerts.push({ msg: "No Data", type: 'info', languageCode: 'NO_DATA' });
                    } else {
                        $scope.alerts = [];
                    }
                } else {
                    ctrl.refreshData(true);
                }
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.REMOVE, "Remove Error!");
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.setEditMode = function (index, customer) {
        $scope.alerts = [];
        ctrl.editModeIndex = ctrl.editModeIndex === index ? null : index;
        if (ctrl.editModeIndex == index) {
            ctrl.customerAccessLevel = ctrl.userRoleList.find(function (role) {
                return role.id == customer.accessLevel;
            });
        };
    };

    ctrl.updateAccessLevel = function (item, customer, index) {
        // ctrl.loading = true;
        ctrl._assignUserToCustomerFactory.updateUserRoleForCustomer(customer.custid, ctrl.selectedUser.userId, item.id).then(function (resp) {
            if (resp == 1) {
                ctrl.customerAccessList[index].accessLevel = item.id;
                ctrl.customerAccessList[index].accessLevelDesc = item.value;
            } else {
                ctrl.refreshData(true);
            }
            ctrl.editModeIndex = null;
        });
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.refreshData(false);
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshData(false);
    });

    $scope.$on("$destroy", function () {
        ctrl.customerName.removeEventListener('click', showDropdown);
        document.removeEventListener('click', function (e) {
            if (!e.target.closest('#customerName') && !e.target.closest('#customerNameDropdownList')) {
                // Hide the dropdown and change the input placeholder when clicked outside without selecting value
                ctrl.customerNameDropdownList.style.display = 'none';
                ctrl.customerName.setAttribute("placeholder", "Select");
                ctrl.customerName.style.backgroundColor = "#f6ff95";
            }
        });
    });

    ctrl.refreshData = function (error) {
        ctrl.getCustomerAccessList(ctrl.selectedUser.userId, error);
        ctrl.clearDropdownValues();
    };

    ctrl.clearDropdownValues = function () {
        // Clearing values for Customer Name and User Role after refreshing 
        ctrl.userRole = null;
        ctrl.customerName.disabled = false;
        ctrl.customerName.value = null;
        ctrl.selectedCustomer = null;
        ctrl.roleDropdown.disabled = true;
        ctrl.clearFilter = false;
        ctrl.grantAccess.disabled = true;
    };

    ctrl.clearSearchField = function () {
        ctrl.selectedCustomer = null; //Make value null so input field is empty
        ctrl.customerName.value = null; //Make value null so input field is empty
        ctrl.clearFilter = false; // once field is empty Clear Filter icon should hide
        ctrl.grantAccess.disabled = true; // disable button until Customer Name is selected
    };

    ctrl.filterOptions = function () {
        //After clicking clear filter the input field should open just like it is opened for first time
        ctrl.selectedCustomer = null;
        ctrl.customerName.value = null;
        ctrl.roleDropdown.disabled = true;
        ctrl.grantAccess.disabled = true;

        //Call showDropdown() to show list once the input field is clicked
        ctrl.customerName.addEventListener('click', showDropdown);

        // Function to filter options based on search input
        ctrl.filterOption = function (searchText) {
            var filter = searchText.toLowerCase();
            var filteredOptions = ctrl.customersList.filter(function (option) {
                return option.name.toLowerCase().includes(filter);
            });
            ctrl.renderOptions(filteredOptions);
        };

        // Function to handle option selected from the dropdown
        ctrl.selectOption = function (option) {
            ctrl.customerName.value = option.name; // Set search input to selected option name
            ctrl.selectedCustomer = option; //assign option to ctrl.selectedCustomer

            ctrl.customerName.style.backgroundColor = "#f6ff95"; //set the color of the selected value
            ctrl.customerNameDropdownList.style.display = 'none'; // Hide dropdown after selection

            if (ctrl.selectedCustomer == null) {
                ctrl.roleDropdown.disabled = true; // Enable User Role  dropdown once Customer Name is selected
            } else {
                ctrl.roleDropdown.disabled = false; // Disable until Customer Name is selected
                if (ctrl.userRole == null) {
                    ctrl.grantAccess.disabled = true; // Role selected but Customer name is changed, Grant Acces button to enable
                } else {
                    ctrl.grantAccess.disabled = false; //user role not selected the grant access button to be disabled
                }
            }
        };

        // Alternate way without using oninput by creating event listener to listen everytime we enter something in input box
        ctrl.customerName.addEventListener('input', function () {
            // Adding clear filter icon if length more than 0
            if (ctrl.customerName.value.length > 3) {
                ctrl.clearFilter = true;
            } else {
                ctrl.clearFilter = false;
            }
            ctrl.filterOption(ctrl.customerName.value);
        });

        // Hide dropdown if clicked outside of the input and dropdown
        document.addEventListener('click', function (e) {
            if (!e.target.closest('#customerName') && !e.target.closest('#customerNameDropdownList')) {
                // Hide the dropdown and change the input placeholder when clicked outside without selecting value
                ctrl.customerNameDropdownList.style.display = 'none';
                ctrl.customerName.setAttribute("placeholder", "Select");
                ctrl.customerName.style.backgroundColor = "#f6ff95";
            }
        });
    };
}

AssignUserToCustomerController.$inject = ['$', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'AssignUserToCustomerFactory', 'TechSupportAssignCustomerFactory', '$filter', '$uibModal', 'toaster'];
'use strict';

angular.module('mc.assign-user-to-customer').component('assignUserToCustomer', {
    controller: AssignUserToCustomerController,
    templateUrl: 'ui/techsupportassigncustomer/assignusertocustomer/tech-support-assign-user-to-customer-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.tech-support-summary", []);
'use strict';

function TechSupportSummaryFactory(HOST, $http) {

    var _techSupportSummary = function _techSupportSummary() {};

    _techSupportSummary.prototype.GetTechSupportSummaries = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupportSummary/GetTechSupportSummary/'
        });
    };

    return _techSupportSummary;
}

TechSupportSummaryFactory.$inject = ['HOST', '$http'];

angular.module('mc.tech-support-summary').factory('TechSupportSummaryFactory', TechSupportSummaryFactory);
"use strict";

function TechSupportSummaryController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, TechSupportSummaryFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, $q, $uibModal, savePdfService) {
    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    //ctrl.requiredCustomers = [];
    //ctrl.selectedCustomers = [];
    //ctrl.allCustomerSelected = false;

    ctrl.$onInit = function () {
        ctrl._techSupportSummary = new TechSupportSummaryFactory();
        ctrl.reverse = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        //--------------------------------------------------------------------------------------------------
        ctrl.techSupportSummaries = null;
        ctrl.loading = false;
        $timeout(function () {
            ctrl.getTechSupportSummaries();
        }, 200);
        //ctrl.distributor = null;
        //ctrl.techSupportAgent = null;
        //ctrl.timeZone = null;
        //ctrl.state = null;
        //ctrl.initialLetterSelected = null;
        //--------------------------------------------------------------------------------------------------
        //ctrl.firstOpen = true;//to select the customer of the current site the user is in
        //ctrl.deviceType = null;
        //ctrl.currentPlan = null;
        //ctrl.selectedPlan = null;
        //ctrl.initialLetterSelected = ctrl.accountInfo.customerName.charAt(0);
        //ctrl.getDistributorsTechSupportAgents();//Get distributors and tech support agents for dropdown list

        //ctrl.states = [
        //    { "name": 'Alabama', "id": 'AL' },
        //    { "name": 'Alaska', "id": 'AK' },
        //    { "name": 'American Samoa', "id": 'AS' },
        //    { "name": 'Arizona', "id": 'AZ' },
        //    { "name": 'Arkansas', "id": 'AR' },
        //    //{ "name": 'Armed Forces Americas', "id": 'AA' },
        //    //{ "name": 'Armed Forces Europe', "id": 'AE' },
        //    //{ "name": 'Armed Forces Pacific', "id": 'AP' },
        //    { "name": 'California', "id": 'CA' },
        //    { "name": 'Colorado', "id": 'CO' },
        //    { "name": 'Connecticut', "id": 'CT' },
        //    { "name": 'Delaware', "id": 'DE' },
        //    { "name": 'District Of Columbia', "id": 'DC' },
        //    { "name": 'Federated States Of Micronesia', "id": 'FM' },
        //    { "name": 'Florida', "id": 'FL' },
        //    { "name": 'Georgia', "id": 'GA' },
        //    { "name": 'Guam', "id": 'GU' },
        //    { "name": 'Hawaii', "id": 'HI' },
        //    { "name": 'Idaho', "id": 'ID' },
        //    { "name": 'Illinois', "id": 'IL' },
        //    { "name": 'Indiana', "id": 'IN' },
        //    { "name": 'Iowa', "id": 'IA' },
        //    { "name": 'Kansas', "id": 'KS' },
        //    { "name": 'Kentucky', "id": 'KY' },
        //    { "name": 'Louisiana', "id": 'LA' },
        //    { "name": 'Maine', "id": 'ME' },
        //    { "name": 'Marshall Islands', "id": 'MH' },
        //    { "name": 'Maryland', "id": 'MD' },
        //    { "name": 'Massachusetts', "id": 'MA' },
        //    { "name": 'Michigan', "id": 'MI' },
        //    { "name": 'Minnesota', "id": 'MN' },
        //    { "name": 'Mississippi', "id": 'MS' },
        //    { "name": 'Missouri', "id": 'MO' },
        //    { "name": 'Montana', "id": 'MT' },
        //    { "name": 'Nebraska', "id": 'NE' },
        //    { "name": 'Nevada', "id": 'NV' },
        //    { "name": 'New Hampshire', "id": 'NH' },
        //    { "name": 'New Jersey', "id": 'NJ' },
        //    { "name": 'New Mexico', "id": 'NM' },
        //    { "name": 'New York', "id": 'NY' },
        //    { "name": 'North Carolina', "id": 'NC' },
        //    { "name": 'North Dakota', "id": 'ND' },
        //    { "name": 'Northern Mariana Islands', "id": 'MP' },
        //    { "name": 'Ohio', "id": 'OH' },
        //    { "name": 'Oklahoma', "id": 'OK' },
        //    { "name": 'Oregon', "id": 'OR' },
        //    { "name": 'Palau', "id": 'PW' },
        //    { "name": 'Pennsylvania', "id": 'PA' },
        //    { "name": 'Puerto Rico', "id": 'PR' },
        //    { "name": 'Rhode Island', "id": 'RI' },
        //    { "name": 'South Carolina', "id": 'SC' },
        //    { "name": 'South Dakota', "id": 'SD' },
        //    { "name": 'Tennessee', "id": 'TN' },
        //    { "name": 'Texas', "id": 'TX' },
        //    { "name": 'US Virgin Islands', "id": 'VI' },
        //    { "name": 'Utah', "id": 'UT' },
        //    { "name": 'Vermont', "id": 'VT' },
        //    { "name": 'Virginia', "id": 'VA' },
        //    { "name": 'Washington', "id": 'WA' },
        //    { "name": 'West Virginia', "id": 'WV' },
        //    { "name": 'Wisconsin', "id": 'WI' },
        //    { "name": 'Wyoming', "id": 'WY' },
        //    { "name": 'Alberta', "id": 'AB' },
        //    { "name": 'British Columbia', "id": 'BC' },
        //    { "name": 'Manitoba', "id": 'MB' },
        //    { "name": 'New Brunswick', "id": 'NB' },
        //    { "name": 'Ontario', "id": 'ON' },
        //    { "name": 'Quebec', "id": 'QC' },
        //    { "name": 'Saskatchewan', "id": 'SK' }
        //];

        //ctrl.timeZones = [
        //    {
        //        "id": "P",
        //        "name": "Pacific Time Zone"
        //    },
        //    {
        //        "id": "M",
        //        "name": "Mountain Time Zone"
        //    },
        //    {
        //        "id": "C",
        //        "name": "Central Time Zone"
        //    },
        //    {
        //        "id": "E",
        //        "name": "Eastern Time Zone"
        //    }
        //];

        //ctrl.initialLetters = {
        //    "A": "A",
        //    "B": "B",
        //    "C": "C",
        //    "D": "D",
        //    "E": "E",
        //    "F": "F",
        //    "G": "G",
        //    "H": "H",
        //    "I": "I",
        //    "J": "J",
        //    "K": "K",
        //    "L": "L",
        //    "M": "M",
        //    "N": "N",
        //    "O": "O",
        //    "P": "P",
        //    "Q": "Q",
        //    "R": "R",
        //    "S": "S",
        //    "T": "T",
        //    "U": "U",
        //    "V": "V",
        //    "W": "W",
        //    "X": "X",
        //    "Y": "Y",
        //    "Z": "Z"
        //};

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for       

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }
    };

    //Get tech support summaries
    ctrl.getTechSupportSummaries = function () {
        ctrl.loading = true;
        ctrl._techSupportSummary.GetTechSupportSummaries().then(function (resp) {
            ctrl.techSupportSummaries = resp.data;
            ctrl.loading = false;
        });
    };
    //Get tech support agents and distributors for dropdown list
    //ctrl.getDistributorsTechSupportAgents = () => {
    //    ctrl._techSupportAssign.GetDistributorsTechSupportAgents().then((resp) => {
    //        ctrl.distributors = resp.data.distributors;
    //        ctrl.techSupportAgents = resp.data.techSupportAgents;
    //    })
    //};

    //Get customer by provided distributor, tech support agnet and state and time zone
    //ctrl.getCustomerByTechSupportAgentOrDistributorStateTimeZone = (techSupportAgentId, distributorId, state, timeZone, initialLetter) => {
    //    ctrl.requiredCustomers = [];
    //    ctrl.displayMode = 0;
    //    ctrl.selectedPlan = null;
    //    ctrl._techSupportAssign.GetCustomerByTechSupportAgentOrDistributorStateTimeZone(techSupportAgentId, distributorId, state, timeZone, initialLetter).then((resp) => {
    //        ctrl.requiredCustomers = resp.data;

    //    })
    //};

    //Get customer by provided customer name
    //ctrl.getCustomerByCustomerName = (customerName) => {
    //    ctrl.requiredCustomers = [];
    //    ctrl.displayMode = 0;
    //    ctrl.selectedPlan = null;
    //    ctrl._techSupportAssign.GetCustomerByCustomerName(customerName).then((resp) => {
    //        ctrl.requiredCustomers = (resp.data);
    //    })
    //};

    //Filter customers based on the initial letter selected 
    //ctrl.filterCustomers = (initialLetter) => {
    //    ctrl.customersCopy = ctrl.customers.filter(function (el) {
    //        return el.name.startsWith(initialLetter);
    //    });
    //    if (ctrl.firstOpen) {
    //        for (var i = 0; i < ctrl.customersCopy.length; i++) {
    //            if (ctrl.customersCopy[i].name == ctrl.accountInfo.customerName) ctrl.customerName = ctrl.customersCopy[i];
    //        }
    //    };
    //    ctrl.firstOpen = false;
    //};

    //ctrl.cleanInputFields = () => {
    //    ctrl.simNumber = null;
    //    ctrl.serialNumber = null;
    //};

    //Select all RTUs
    //ctrl.selectAll = () => {
    //    var i;
    //    if (ctrl.allCustomerSelected) {
    //        for (i = 0; i < ctrl.requiredCustomers.length; i++) {
    //            ctrl.requiredCustomers[i].isSelected = true;
    //        }
    //    }
    //    else {
    //        for (i = 0; i < ctrl.requiredCustomers.length; i++) {
    //            ctrl.requiredCustomers[i].isSelected = false;
    //        }
    //    }
    //}

    //Update selected customers' assigned tech support agent
    //ctrl.updateTechSupportAgent = (techSupportAgent) => {
    //    ctrl.selectedCustomers = [];
    //    if (ctrl.allCustomerSelected) {
    //        ctrl.selectedCustomers = ctrl.requiredCustomers;
    //    }
    //    else {
    //        for (var i = 0; i < ctrl.requiredCustomers.length; i++) {
    //            if (ctrl.requiredCustomers[i].isSelected == true) ctrl.selectedCustomers.push(ctrl.requiredCustomers[i]);
    //        }
    //    }

    //    ctrl._techSupportAssign.AssignTechSupportAgent(ctrl.selectedCustomers, techSupportAgent.webLoginId).then((resp) => {
    //        //ctrl.displayMode = 1;
    //        //ctrl.updatePlanResult = resp.data;
    //        for (var i = 0; i < ctrl.selectedCustomers.length; i++) {
    //            ctrl.selectedCustomers[i].currentTechSupportAgentName = techSupportAgent.name;
    //        }
    //    })
    //};

    ///
    ///
    /// All of the below methods are left over and I do not use / do not know if they work.
    ///
    ///


    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                0: { columnWidth: 70 },
                1: { columnWidth: 100 },
                2: { columnWidth: 100 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshData();
    });

    ctrl.refreshData = function () {
        ctrl.carrierDataUsage = angular.copy(ctrl.carrierDataUsage);
    };
}

TechSupportSummaryController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'TechSupportSummaryFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', '$uibModal', 'savePdfService'];
'use strict';

angular.module('mc.tech-support-summary').component('techSupportSummary', {
    controller: TechSupportSummaryController,
    templateUrl: 'ui/techsupportassignment/summary/tech-support-summary-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.current-status", []);
'use strict';

function CurrentStatusFactory(HOST, $http) {

    // instantiate our initial object
    var CurrentStatus = function CurrentStatus(customerId, deviceId, timeZone, hasRMDT) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.hasRMDT = hasRMDT;
    };

    CurrentStatus.prototype.getData = function (interval) {
        var self = this;
        return $http.get(HOST + '/api/CurrentStatus' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&interval=' + interval).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    CurrentStatus.prototype.RecentDataOnly = function (interval, currentStatusModelRequired) {
        var self = this;
        return $http.get(HOST + '/api/CurrentStatus/RecentDataOnly/' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&currentStatusModelRequired=' + encodeURIComponent(JSON.stringify(currentStatusModelRequired)) + '&interval=' + interval).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    CurrentStatus.prototype.getRadioUpgradeData = function (interval) {
        var self = this;
        return $http.get(HOST + '/api/CurrentStatus' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&hasRMDT=' + this.hasRMDT + '&interval=' + interval).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    CurrentStatus.prototype.getMMPlusTransactionData = function () {
        var fromDate = new Date();
        fromDate = fromDate.getTime();
        var endDate = new Date();
        endDate = new Date(endDate.setDate(endDate.getDate() - 5));
        endDate = endDate.getTime();
        return $http.get(HOST + '/api/MMPlusTransactionData' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&pageSize=' + 100 + '&fromDate=' + fromDate + '&endDate=' + endDate).then(function (response) {
            self.list = response.data;
            return response;
        });
    };
    return CurrentStatus;
}

CurrentStatusFactory.$inject = ['HOST', '$http'];

angular.module('mc.current-status').factory('CurrentStatusFactory', CurrentStatusFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function CurrentStatusController($, $rootScope, $scope, $element, authenticationService, translationService, sharedSetupService, CurrentStatusFactory, openViewService, debounceService, $location, datetimeService, websocketService) {
    var ctrl = this;
    ctrl.loadingInProgress = true;
    ctrl.hasRMDTData = false;

    var _convertFromMeters = function _convertFromMeters(unitId, analogValue) {
        switch (unitId) {
            case 3:
                //Feet
                return analogValue * 3.280839895;
            case 4:
                //Inches
                return analogValue * 39.37007874;
            case 5:
                //Meters
                return analogValue;
            case 6:
                // mm
                return analogValue * 1000;
            case 23:
                // Centimeters
                return analogValue * 100;
            default:
                return analogValue;
        }
    };

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile;
        ctrl.getAccountInfo();
        ctrl.adminPortal = sharedSetupService.adminPortal();
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }

        ctrl.pagingViewHeightAdjustment = 0;
        if (ctrl.mcAdminAccess) {
            ctrl.pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
        }
    };

    ctrl.$onChanges = function (changes) {
        if (!angular.isUndefined(changes.stickyProperties) && changes.stickyProperties.currentValue && changes.stickyProperties.currentValue != changes.stickyProperties.previousValue) {
            ctrl.stickyProperties = changes.stickyProperties.currentValue;
        }
        if (changes.deviceSelectedSn.currentValue && changes.deviceSelectedSn.currentValue != changes.deviceSelectedSn.previousValue) {
            if (!angular.isUndefined(changes.deviceSelectedSn.previousValue)) {
                ctrl.unRegisterListener(changes.deviceSelectedSn.previousValue);
            }
        }
        if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue != changes.deviceSelected.previousValue) {
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
            ctrl.getAccountInfo();
            ctrl.getCurrentStatus(true);
        }
    };

    ctrl.getAccountInfo = function () {
        if (angular.isDefined(ctrl.accountInfo)) return;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.getPreferredTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
    };

    ctrl.animateRecentDataChange = function (dataType, channel) {
        var element = $element.find('.csrd-' + dataType + (channel || ''));
        element.addClass("underline").animate({ color: "green" }, "slow").animate({ color: "#222222" }, "slow").animate({ color: "green" }, "slow").animate({ color: "#222222" }, "slow").animate({ color: "green" }, "slow").animate({ color: "#222222" }, "slow", function () {
            element.removeClass("underline");
        });
    };

    ctrl.getM50DigitalInputs1_8 = function (d) {

        ctrl.digitalInput_1_8 = ctrl.getDigitalsOpenClose(d.d1) + ctrl.getDigitalsOpenClose(d.d2) + ctrl.getDigitalsOpenClose(d.d3);

        if (ctrl.currentStatus.digitalAsPulse == null) return;

        var tmpArray = ctrl.digitalInput_1_8.split('');

        for (var k = 0; k < ctrl.currentStatus.digitalAsPulse.length; k++) {
            var tmpChannel = ctrl.currentStatus.digitalAsPulse[k].channel;
            switch (tmpChannel) {
                case tmpChannel:
                    if (tmpChannel > 0 && tmpChannel <= 3) tmpArray.splice(tmpChannel - 1, 1, '-');
                    break;
            }
        }
        ctrl.digitalInput_1_8 = tmpArray.join('');
    };

    ctrl.getDigitals = function (varInt) {
        if (!angular.isDefined(ctrl.currentStatus)) return;
        if (ctrl.currentStatus.digital == null) return;
        var d = ctrl.currentStatus.digital;
        switch (varInt) {
            case 1:
                ctrl.animateRecentDataChange("digital");

                //Hide Digital Input Channel X when used as Pulse (M50 only)
                if (ctrl.currentStatus.device.model == 21) {
                    ctrl.getM50DigitalInputs1_8(d);
                    break;
                }

                //Hide Low Float (Digital Input Channel 1) when device has level sensor (skuId 2 is M84-L)
                ctrl.digitalInput_1_8 = ctrl.currentStatus.device.hasLevelSensor ? "-" : ctrl.getDigitalsOpenClose(d.d1);

                ctrl.digitalInput_1_8 = ctrl.digitalInput_1_8 + ctrl.getDigitalsOpenClose(d.d2) + ctrl.getDigitalsOpenClose(d.d3);

                //New Ranger has only 3 digitals
                ctrl.currentStatus.device.model != 21 ? ctrl.digitalInput_1_8 = ctrl.digitalInput_1_8 + ctrl.getDigitalsOpenClose(d.d4) + ctrl.getDigitalsOpenClose(d.d5) + ctrl.getDigitalsOpenClose(d.d6) : "";

                //M84 has 6 digitals
                ctrl.currentStatus.device.model != 20 && ctrl.currentStatus.device.model != 21 ? ctrl.digitalInput_1_8 = ctrl.digitalInput_1_8 + ctrl.getDigitalsOpenClose(d.d7) + ctrl.getDigitalsOpenClose(d.d8) : "";

                break;
            case 2:
                ctrl.animateRecentDataChange("digital-ext");
                ctrl.digitalInput_9_16 = ctrl.getDigitalsOpenClose(d.d9) + ctrl.getDigitalsOpenClose(d.d10) + ctrl.getDigitalsOpenClose(d.d11) + ctrl.getDigitalsOpenClose(d.d12) + ctrl.getDigitalsOpenClose(d.d13) + ctrl.getDigitalsOpenClose(d.d14) + ctrl.getDigitalsOpenClose(d.d15) + ctrl.getDigitalsOpenClose(d.d16);
                break;
            case 3:
                ctrl.animateRecentDataChange("relays");
                ctrl.digitalOutput_1_3 = ctrl.getRelaysOpenClose(d.r1);

                //New Ranger has only 1 relay
                ctrl.currentStatus.device.model != 21 ? ctrl.digitalOutput_1_3 = ctrl.digitalOutput_1_3 + ctrl.getRelaysOpenClose(d.r2) + ctrl.getRelaysOpenClose(d.r3) : "";

                break;
            case 4:
                ctrl.animateRecentDataChange("relays-ext");
                ctrl.digitalOutput_4_9 = ctrl.getRelaysOpenClose(d.r4) + ctrl.getRelaysOpenClose(d.r5) + ctrl.getRelaysOpenClose(d.r6) + ctrl.getRelaysOpenClose(d.r7) + ctrl.getRelaysOpenClose(d.r8) + ctrl.getRelaysOpenClose(d.r9);
                break;
            default:
                return "";
        }
    };

    ctrl.getDigitalsDebounce1 = debounceService(ctrl.getDigitals, 200, false);
    ctrl.getDigitalsDebounce2 = debounceService(ctrl.getDigitals, 200, false);
    ctrl.getDigitalsDebounce3 = debounceService(ctrl.getDigitals, 200, false);
    ctrl.getDigitalsDebounce4 = debounceService(ctrl.getDigitals, 200, false);

    ctrl.getDigitalsOpenClose = function (varStr) {
        switch (varStr.toLowerCase()) {
            case "true":
            case "1":
                return "0";
            case "false":
            case "0":
                return "1";
            case "null":
            case "fault":
                return "F";
            default:
                return "0";
        }
    };

    ctrl.getRelaysOpenClose = function (varStr) {
        switch (varStr.toLowerCase()) {
            case "true":
            case "1":
                return "1";
            case "false":
            case "0":
                return "0";
            case "null":
            case "fault":
                return "F";
            default:
                return "0";
        }
    };

    ctrl.getIpAddress = function () {
        if (!angular.isDefined(ctrl.currentStatus)) return;
        if (ctrl.currentStatus.device == null) return;

        if (angular.isUndefined(ctrl.ipAddressLastHeardTime)) ctrl.ipAddressLastHeardTime = ctrl.currentStatus.device.lastHeardTime;

        if (ctrl.currentStatus.device.wirelessCarrier === "C" && ctrl.currentStatus.device.ipAddress.substring(0, 6) === "172.16") {
            return ctrl.currentStatus.device.ipAddress;
        } else if (ctrl.currentStatus.device.wirelessCarrier === "C" && (ctrl.currentStatus.device.ipAddress.substring(0, 6) === "172.17" || ctrl.currentStatus.device.ipAddress.substring(0, 6) === "172.27")) {
            return ctrl.currentStatus.device.ipAddress + " (APN2)";
        } else if (ctrl.currentStatus.device.wirelessCarrier === "C") {
            return ctrl.currentStatus.device.ipAddress + " (PROXY)";
        } else {
            return ctrl.currentStatus.device.ipAddress;
        }
    };

    ctrl.getAnalogOutput = function (item) {
        if (!angular.isDefined(ctrl.currentStatus)) return;
        if (item == null) return;
        var voltageResult = (5 * item.newSettingRaw / 256).toFixed(2);
        var amperResult = (16 * item.newSettingRaw / 255 + 4).toFixed(2);
        return voltageResult + "V" + "," + amperResult + "mA";
    };

    ctrl.refreshMe = function () {
        ctrl.unRegisterListener(ctrl.deviceSelectedSn);
        ctrl.registerListener(ctrl.deviceSelectedSn);
        ctrl.hasRMDTData = false;
        ctrl.getCurrentStatus();
    };

    ctrl.getCurrentStatus = function (turnOnLiveData) {
        ctrl.loadingInProgress = true;
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: ctrl.deviceSelected, windowId: ctrl.windowId });
        var _currentStatus = new CurrentStatusFactory(ctrl.stickyProperties.portalCustomerId || ctrl.accountInfo.customerId, ctrl.deviceSelected, ctrl.accountInfo.timeZone);

        _currentStatus.getData().then(function () {
            var _datafromFactory = _currentStatus.list;
            ctrl.currentStatus = _datafromFactory;
            ctrl.hasRMDTData = ctrl.currentStatus.device.hasRMDTRadio;
            ctrl.hasMyDroExpansion = ctrl.currentStatus.device.model == 19 && ctrl.currentStatus.device.softwareVersion >= 18;
            ctrl.isMyDroOrMmplus = [18, 19, 20].indexOf(ctrl.currentStatus.device.model) > -1 ? true : false;

            ctrl.getDigitals(1);
            ctrl.getDigitals(2);
            ctrl.getDigitals(3);
            ctrl.getDigitals(4);

            for (var k = 0; k < ctrl.currentStatus.latestState.length; k++) {
                switch (ctrl.currentStatus.latestState[k].dataCategoryId) {
                    case 17:
                        ctrl.signalQualityRSRQ = ctrl.currentStatus.latestState[k];
                        break;
                    case 42:
                        ctrl.signalPowerRSRP = ctrl.currentStatus.latestState[k];
                        break;
                }
            }

            if (turnOnLiveData) ctrl.registerListener(ctrl.deviceSelectedSn);

            ctrl.loadingInProgress = false;
        }, function (error) {
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.openPaging = function () {
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: ctrl.deviceSelected, windowId: $scope.windowId });
        if (!$rootScope.mobile && !$rootScope.classicView) {
            openViewService.openView('Paging', { width: 600, height: 210 + ctrl.pagingViewHeightAdjustment }, { my: 'right-10 top+6', at: 'right top', of: window }, ctrl.stickyProperties, { minimumWidth: 600, minimumHeight: 210 + ctrl.pagingViewHeightAdjustment });
        } else {
            $location.path('/paging/paging');
        }
    };

    ctrl.initializeSetting = function () {};

    ctrl.getPreferredTimeFormat = function (varPreferredTimeFormat) {
        ctrl.preferredTimeFormat = varPreferredTimeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
    };

    var _onUpdatePreferencesTimeFormat = $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.getPreferredTimeFormat(preferredTimeFormat);
        ctrl.refreshMe();
    });

    var _onUpdatePreferencesLanguage = $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshMe();
    });

    var _calculateVAC = function _calculateVAC(value) {
        var _tmpValue = value;
        switch (ctrl.currentStatus.device.solar) {
            case true:
                if (ctrl.currentStatus.device.model != 18 && ctrl.currentStatus.device.model != 19) _tmpValue = (100 * value + 140) / 100;else _tmpValue = 100 * value / 100;
                break;
            default:
                _tmpValue = 100 * value * .707 / 100;
                break;
        }

        return _tmpValue;
    };

    var _wsUpdateAnalog = function _wsUpdateAnalog(message) {

        if (ctrl.currentStatus.device.model >= 20) return;

        if (angular.isUndefined(ctrl.currentStatus.analog)) return;

        for (var i = 0; i < ctrl.currentStatus.analog.length; i++) {
            if (ctrl.currentStatus.analog[i].channel == message.Ch) {
                ctrl.currentStatus.analog[i].localDateTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
                ctrl.currentStatus.analog[i].latestData = message.ScaledValue;
                ctrl.currentStatus.analog[i].rawVal = message.Value;
                ctrl.animateRecentDataChange("analog", message.Ch);
                break;
            }
        }
    };

    var _wsUpdateAnalogG2 = function _wsUpdateAnalogG2(message) {

        if (ctrl.currentStatus.device.model < 20) return;

        if (angular.isUndefined(ctrl.currentStatus.analog)) return;

        if (ctrl.currentStatus.device.model == 20 && message.Ch != 1) return;

        for (var i = 0; i < ctrl.currentStatus.analog.length; i++) {
            if (ctrl.currentStatus.analog[i].channel == message.Ch) {
                var tmpValue;
                switch (ctrl.currentStatus.device.model) {
                    case 20:
                        tmpValue = _convertFromMeters(ctrl.currentStatus.analog[i].unitOfValueID, parseFloat(message.ScaledValue));
                        break;
                    default:
                        tmpValue = parseFloat(message.ScaledValue);
                        break;
                }
                ctrl.currentStatus.analog[i].localDateTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
                ctrl.currentStatus.analog[i].latestData = tmpValue;
                ctrl.animateRecentDataChange("analog", message.Ch);
                break;
            }
        }
    };

    var _wsUpdateAnalogRaw = function _wsUpdateAnalogRaw(message) {

        if (ctrl.currentStatus.device.model < 20) return;

        if (angular.isUndefined(ctrl.currentStatus.analog)) return;

        if (ctrl.currentStatus.device.model == 20 && message.Ch != 1) return;

        for (var i = 0; i < ctrl.currentStatus.analog.length; i++) {
            if (ctrl.currentStatus.analog[i].channel == message.Ch) {
                var tmpValue;
                switch (ctrl.currentStatus.device.model) {
                    case 20:
                        tmpValue = _convertFromMeters(ctrl.currentStatus.analog[i].unitOfValueID, parseFloat(message.Value));
                        break;
                    default:
                        tmpValue = parseFloat(message.Value);
                        break;
                }
                ctrl.currentStatus.analog[i].localDateTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
                ctrl.currentStatus.analog[i].rawVal = tmpValue;
                ctrl.animateRecentDataChange("analog", message.Ch);
                break;
            }
        }
    };

    var _wsUpdateAnalogOut = function _wsUpdateAnalogOut(message) {
        var _analogOuCh = "analogOutput" + message.Ch;
        var _animation = "analog-output" + message.Ch;

        if (angular.isUndefined(ctrl.currentStatus[_analogOuCh])) return;

        ctrl.currentStatus[_analogOuCh].localDateTimeEntered = datetimeService.socketStrToServerStrTime(message.LocalTime);
        ctrl.currentStatus[_analogOuCh].newSettingScaled = message.ScaledValue;
        ctrl.currentStatus[_analogOuCh].newSettingRaw = message.Value;
        ctrl.animateRecentDataChange(_animation);
    };

    var _wsUpdateDigitalInput = function _wsUpdateDigitalInput(message) {
        var _ch = "d" + message.Ch;
        var _value = message.Value;

        if (angular.isUndefined(ctrl.currentStatus.digital) || angular.isUndefined(ctrl.currentStatus.digital[_ch])) return;

        ctrl.currentStatus.digital[_ch] = _value;
        ctrl.currentStatus.digital.localTime = datetimeService.socketStrToServerStrTime(message.LocalTime);

        switch (message.Ch) {
            case "1":case "2":case "3":case "4":case "5":case "6":case "7":case "8":
                ctrl.getDigitalsDebounce1(1);
                break;
            case "9":case "10":case "11":case "12":case "13":case "14":case "15":case "16":
                ctrl.getDigitalsDebounce2(2);
                break;
        }
    };

    var _wsUpdateDigitalOutput = function _wsUpdateDigitalOutput(message) {
        var _ch = "r" + message.Ch;
        var _value = message.Value;

        if (angular.isUndefined(ctrl.currentStatus.digital) || angular.isUndefined(ctrl.currentStatus.digital[_ch])) return;

        ctrl.currentStatus.digital[_ch] = _value;

        if (parseInt(message.Ch) >= 1 && parseInt(message.Ch) <= 3) ctrl.currentStatus.digital.localTime = datetimeService.socketStrToServerStrTime(message.LocalTime);else if (parseInt(message.Ch) >= 4 && parseInt(message.Ch) <= 9) ctrl.currentStatus.digital.digitalOutputRegTime = datetimeService.socketStrToServerStrTime(message.LocalTime);

        switch (message.Ch) {
            case "1":case "2":case "3":
                ctrl.getDigitalsDebounce3(3);
                break;
            case "4":case "5":case "6":case "7":case "8":case "9":
                ctrl.getDigitalsDebounce4(4);
                break;
        }
    };

    var _wsUpdateFlow = function _wsUpdateFlow(message) {

        if (!ctrl.currentStatus.flow) return;

        for (var i = 0; i < ctrl.currentStatus.flow.length; i++) {
            if (ctrl.currentStatus.flow[i].channel == message.Ch) {
                var _animation = "flow" + message.Ch;
                ctrl.currentStatus.flow[i].timestamp = datetimeService.socketStrToServerStrTime(message.LocalTime);
                ctrl.currentStatus.flow[i].raw = message.Value;
                ctrl.animateRecentDataChange(_animation);
                break;
            }
        }
    };

    var _wsUpdateDigitalAsPulse = function _wsUpdateDigitalAsPulse(message) {

        if (!ctrl.currentStatus.digitalAsPulse) return;

        for (var i = 0; i < ctrl.currentStatus.digitalAsPulse.length; i++) {
            if (ctrl.currentStatus.digitalAsPulse[i].channel == message.Ch) {
                var _animation = "digital-as-pulse" + message.Ch;
                ctrl.currentStatus.digitalAsPulse[i].timestamp = datetimeService.socketStrToServerStrTime(message.LocalTime);
                ctrl.currentStatus.digitalAsPulse[i].raw = message.Value;
                ctrl.currentStatus.digitalAsPulse[i].scaled = message.ScaledValue;
                ctrl.currentStatus.digitalAsPulse[i].delta = message.Field9;
                ctrl.animateRecentDataChange(_animation);
                break;
            }
        }
    };

    var _wsUpdateTemperature = function _wsUpdateTemperature(message) {

        if (angular.isUndefined(ctrl.currentStatus.temperature)) return;

        ctrl.currentStatus.temperature.localDateTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
        ctrl.currentStatus.temperature.value = message.Value;
        ctrl.animateRecentDataChange("temperature");
    };

    var _wsUpdateVoltageBattery = function _wsUpdateVoltageBattery(message) {

        if (angular.isUndefined(ctrl.currentStatus.voltage) || ctrl.currentStatus.voltage.length == 0) return;

        ctrl.currentStatus.voltage[0].localDateTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
        ctrl.currentStatus.voltage[0].value = message.Value;
        ctrl.animateRecentDataChange("vbatt");
    };

    var _wsUpdateVoltageAc = function _wsUpdateVoltageAc(message) {

        if (angular.isUndefined(ctrl.currentStatus.voltage) || ctrl.currentStatus.voltage.length < 2) return;

        ctrl.currentStatus.voltage[1].localDateTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
        ctrl.currentStatus.voltage[1].value = _calculateVAC(message.Value);
        ctrl.animateRecentDataChange("vac");
    };

    var _wsUpdateVAux = function _wsUpdateVAux(message) {

        if (angular.isUndefined(ctrl.currentStatus.vAux)) return;

        ctrl.currentStatus.vAux.localDateTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
        ctrl.currentStatus.vAux.value = message.Value;
        ctrl.animateRecentDataChange("vaux");
    };

    var _wsUpdateSignal = function _wsUpdateSignal(message) {

        if (angular.isUndefined(ctrl.currentStatus.signal)) return;

        ctrl.currentStatus.signal.localDateTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
        ctrl.currentStatus.signal.value = message.Value;
        ctrl.animateRecentDataChange("signal");
    };

    var _wsUpdateSignalQuality = function _wsUpdateSignalQuality(message) {

        if (angular.isUndefined(ctrl.signalQualityRSRQ)) return;

        ctrl.signalQualityRSRQ.localTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
        ctrl.signalQualityRSRQ.value = message.Value;
        ctrl.animateRecentDataChange("signal-quality");
    };

    var _wsUpdateSignalPower = function _wsUpdateSignalPower(message) {

        if (angular.isUndefined(ctrl.signalPowerRSRP)) return;

        ctrl.signalPowerRSRP.localTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
        ctrl.signalPowerRSRP.value = message.Value;
        ctrl.animateRecentDataChange("signal-power");
    };

    var _wsUpdateDallasKey = function _wsUpdateDallasKey(message) {

        if (angular.isUndefined(ctrl.currentStatus.dallasKey)) return;

        ctrl.currentStatus.dallasKey.localDateTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
        ctrl.currentStatus.dallasKey.keyHex = message.Value;
        ctrl.animateRecentDataChange("dallas-key");
    };

    var _wsUpdateIpAddress = function _wsUpdateIpAddress(message) {

        if (angular.isUndefined(ctrl.currentStatus.device)) return;

        ctrl.ipAddressLastHeardTime = datetimeService.socketStrToServerStrTime(message.LocalTime);
        ctrl.currentStatus.device.ipAddress = message.Value;
        ctrl.animateRecentDataChange("ip-address");
    };

    var _processLiveMessage = function _processLiveMessage(message) {
        switch (message.Type) {
            case "ANALOG":
                _wsUpdateAnalog(message);
            case "ANALOG_G2":
                _wsUpdateAnalogG2(message);
                break;
            case "ANALOGRAW":
                _wsUpdateAnalogRaw(message);
                break;
            case "ANALOGOUT":
                _wsUpdateAnalogOut(message);
                break;
            case "DIGITALINPUT":
                _wsUpdateDigitalInput(message);
                break;
            case "DIGITALOUTPUT":
                _wsUpdateDigitalOutput(message);
                break;
            case "PULSE":
                _wsUpdateFlow(message);
                break;
            case "DIGITALASPULSE":
                _wsUpdateDigitalAsPulse(message);
                break;
            case "TEMPERATURE":
                _wsUpdateTemperature(message);
                break;
            case "VBATT":
                _wsUpdateVoltageBattery(message);
            case "VAC":
                _wsUpdateVoltageAc(message);
                break;
            case "VAUX":
                _wsUpdateVAux(message);
                break;
            case "SIGNAL":
                _wsUpdateSignal(message);
                break;
            case "SIGNALQUALITY":
                _wsUpdateSignalQuality(message);
                break;
            case "SIGNALPOWER":
                _wsUpdateSignalPower(message);
                break;
            case "DALLASKEY":
                _wsUpdateDallasKey(message);
                break;
            case "IPADDRESS":
                _wsUpdateIpAddress(message);
                break;
            default:
                break;
        }
    };

    ctrl.registerListener = function (varSelectedSN) {
        websocketService.connect();
        websocketService.register("CURRENTSTATUSVIEW", varSelectedSN, "", _processLiveMessage, ctrl.refreshMe);
    };

    ctrl.unRegisterListener = function (varSelectedSN) {
        websocketService.unRegister("CURRENTSTATUSVIEW", varSelectedSN, "", _processLiveMessage, ctrl.refreshMe);
    };

    var _removeAllListeners = function _removeAllListeners() {
        _onUpdatePreferencesLanguage();
        _onUpdatePreferencesTimeFormat();
    };

    $scope.$on("$destroy", function () {
        _removeAllListeners();
        ctrl.unRegisterListener(ctrl.deviceSelectedSn);
    });

    $scope.$on('skuidChanged', function (event, args) {
        if (ctrl.deviceSelected !== args) return;
        ctrl.refreshMe();
    });
};

CurrentStatusController.$inject = ['$', '$rootScope', '$scope', '$element', 'authenticationService', 'translationService', 'sharedSetupService', 'CurrentStatusFactory', 'openViewService', 'debounceService', '$location', 'datetimeService', 'websocketService'];
'use strict';

angular.module('mc.current-status').component('currentStatus', {
    controller: CurrentStatusController,
    templateUrl: 'ui/technicalsupport/currentstatus/current-status-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        deviceSelectedSn: '<'
    }
});
"use strict";

angular.module("mc.tech-support-assign", []);
'use strict';

function TechSupportAssignFactory(HOST, $http) {

    var _techSupportAssign = function _techSupportAssign() {};

    _techSupportAssign.prototype.GetDistributorsTechSupportAgents = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupport/GetDistributorsAndTechSupportAgents/'
        });
    };

    _techSupportAssign.prototype.GetCustomerByCustomerName = function (customerName) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupport/GetCustomerByCustomerName/',
            params: { customerName: customerName }
        });
    };

    _techSupportAssign.prototype.GetCustomerByTechSupportAgentOrDistributorStateTimeZone = function (techSupportAgentId, distributorId, state, timeZone, initialLetter) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupport/GetCustomerByTechSupportAgentOrDistributorStateTimeZone/',
            params: { techSupportAgentId: techSupportAgentId, distributorId: distributorId, state: state, timeZone: timeZone, initialLetter: initialLetter }
        });
    };

    _techSupportAssign.prototype.AssignTechSupportAgent = function (customerList, techSupportAgentId) {
        return $http.post(HOST + "/api/TechSupport?techSupportAgentId=" + techSupportAgentId, customerList);
    };

    _techSupportAssign.prototype.DeleteAgents = function (customerList) {
        return $http.post(HOST + "/api/TechSupport/DeleteAgents/", customerList);
    };

    return _techSupportAssign;
}

TechSupportAssignFactory.$inject = ['HOST', '$http'];

angular.module('mc.tech-support-assign').factory('TechSupportAssignFactory', TechSupportAssignFactory);
'use strict';

function TechSupportAssignController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, TechSupportAssignFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, $q, $uibModal, savePdfService) {
    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    ctrl.requiredCustomers = [];
    ctrl.selectedCustomers = [];
    ctrl.allCustomerSelected = false;
    ctrl.numberOfSelectedCustomers = 0;
    ctrl.loading = false;

    ctrl.$onInit = function () {
        ctrl._techSupportAssign = new TechSupportAssignFactory();
        ctrl.reverse = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.selectedLetters = "";
        ctrl.selectInitialTexts = { buttonDefaultText: 'Select Initial' };
        ctrl.letterListSettings = { smartButtonMaxItems: 4, showCheckAll: false, showUncheckAll: true, styleActive: true, scrollableHeight: '200px', scrollable: true, checkBoxes: false };
        //--------------------------------------------------------------------------------------------------
        ctrl.distributor = null;
        ctrl.techSupportAgent = null;
        ctrl.timeZone = null;
        ctrl.state = null;
        ctrl.initialLetterSelected = [];
        //--------------------------------------------------------------------------------------------------
        //ctrl.firstOpen = true;//to select the customer of the current site the user is in
        //ctrl.deviceType = null;
        //ctrl.currentPlan = null;
        //ctrl.selectedPlan = null;
        //ctrl.initialLetterSelected = ctrl.accountInfo.customerName.charAt(0);
        ctrl.getDistributorsTechSupportAgents(); //Get distributors and tech support agents for dropdown list

        ctrl.states = [{ "name": 'Alabama', "id": 'AL' }, { "name": 'Alaska', "id": 'AK' }, { "name": 'American Samoa', "id": 'AS' }, { "name": 'Arizona', "id": 'AZ' }, { "name": 'Arkansas', "id": 'AR' },
        //{ "name": 'Armed Forces Americas', "id": 'AA' },
        //{ "name": 'Armed Forces Europe', "id": 'AE' },
        //{ "name": 'Armed Forces Pacific', "id": 'AP' },
        { "name": 'California', "id": 'CA' }, { "name": 'Colorado', "id": 'CO' }, { "name": 'Connecticut', "id": 'CT' }, { "name": 'Delaware', "id": 'DE' }, { "name": 'District Of Columbia', "id": 'DC' }, { "name": 'Federated States Of Micronesia', "id": 'FM' }, { "name": 'Florida', "id": 'FL' }, { "name": 'Georgia', "id": 'GA' }, { "name": 'Guam', "id": 'GU' }, { "name": 'Hawaii', "id": 'HI' }, { "name": 'Idaho', "id": 'ID' }, { "name": 'Illinois', "id": 'IL' }, { "name": 'Indiana', "id": 'IN' }, { "name": 'Iowa', "id": 'IA' }, { "name": 'Kansas', "id": 'KS' }, { "name": 'Kentucky', "id": 'KY' }, { "name": 'Louisiana', "id": 'LA' }, { "name": 'Maine', "id": 'ME' }, { "name": 'Marshall Islands', "id": 'MH' }, { "name": 'Maryland', "id": 'MD' }, { "name": 'Massachusetts', "id": 'MA' }, { "name": 'Michigan', "id": 'MI' }, { "name": 'Minnesota', "id": 'MN' }, { "name": 'Mississippi', "id": 'MS' }, { "name": 'Missouri', "id": 'MO' }, { "name": 'Montana', "id": 'MT' }, { "name": 'Nebraska', "id": 'NE' }, { "name": 'Nevada', "id": 'NV' }, { "name": 'New Hampshire', "id": 'NH' }, { "name": 'New Jersey', "id": 'NJ' }, { "name": 'New Mexico', "id": 'NM' }, { "name": 'New York', "id": 'NY' }, { "name": 'North Carolina', "id": 'NC' }, { "name": 'North Dakota', "id": 'ND' }, { "name": 'Northern Mariana Islands', "id": 'MP' }, { "name": 'Ohio', "id": 'OH' }, { "name": 'Oklahoma', "id": 'OK' }, { "name": 'Oregon', "id": 'OR' }, { "name": 'Palau', "id": 'PW' }, { "name": 'Pennsylvania', "id": 'PA' }, { "name": 'Puerto Rico', "id": 'PR' }, { "name": 'Rhode Island', "id": 'RI' }, { "name": 'South Carolina', "id": 'SC' }, { "name": 'South Dakota', "id": 'SD' }, { "name": 'Tennessee', "id": 'TN' }, { "name": 'Texas', "id": 'TX' }, { "name": 'US Virgin Islands', "id": 'VI' }, { "name": 'Utah', "id": 'UT' }, { "name": 'Vermont', "id": 'VT' }, { "name": 'Virginia', "id": 'VA' }, { "name": 'Washington', "id": 'WA' }, { "name": 'West Virginia', "id": 'WV' }, { "name": 'Wisconsin', "id": 'WI' }, { "name": 'Wyoming', "id": 'WY' }, { "name": 'Alberta', "id": 'AB' }, { "name": 'British Columbia', "id": 'BC' }, { "name": 'Manitoba', "id": 'MB' }, { "name": 'New Brunswick', "id": 'NB' }, { "name": 'Ontario', "id": 'ON' }, { "name": 'Quebec', "id": 'QC' }, { "name": 'Saskatchewan', "id": 'SK' }];

        ctrl.timeZones = [{
            "id": "P",
            "name": "Pacific Time Zone"
        }, {
            "id": "M",
            "name": "Mountain Time Zone"
        }, {
            "id": "C",
            "name": "Central Time Zone"
        }, {
            "id": "E",
            "name": "Eastern Time Zone"
        }];

        ctrl.initialLetters = [{ id: "A", label: "A" }, { id: "B", label: "B" }, { id: "C", label: "C" }, { id: "D", label: "D" }, { id: "E", label: "E" }, { id: "F", label: "F" }, { id: "G", label: "G" }, { id: "H", label: "H" }, { id: "I", label: "I" }, { id: "J", label: "J" }, { id: "K", label: "K" }, { id: "L", label: "L" }, { id: "M", label: "M" }, { id: "N", label: "N" }, { id: "O", label: "O" }, { id: "P", label: "P" }, { id: "Q", label: "Q" }, { id: "R", label: "R" }, { id: "S", label: "S" }, { id: "T", label: "T" }, { id: "U", label: "U" }, { id: "V", label: "V" }, { id: "W", label: "W" }, { id: "X", label: "X" }, { id: "Y", label: "Y" }, { id: "Z", label: "Z" }];

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for       

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }
    };

    //Get tech support agents and distributors for dropdown list
    ctrl.getDistributorsTechSupportAgents = function () {
        ctrl._techSupportAssign.GetDistributorsTechSupportAgents().then(function (resp) {
            ctrl.distributors = resp.data.distributors;
            ctrl.techSupportAgents = resp.data.techSupportAgents;
        });
    };

    //Get customer by provided distributor, tech support agnet and state and time zone
    ctrl.getCustomerByTechSupportAgentOrDistributorStateTimeZone = function (techSupportAgentId, distributorId, state, timeZone, initialLetter) {
        ctrl.loading = true;
        ctrl.allCustomerSelected = false;
        ctrl.numberOfSelectedCustomers = 0;
        ctrl.requiredCustomers = [];
        ctrl.displayMode = 0;
        ctrl.selectedPlan = null;
        ctrl.selectedLetters = "";
        for (var i = 0; i < initialLetter.length; i++) {
            ctrl.selectedLetters += initialLetter[i].id;
        }
        ctrl._techSupportAssign.GetCustomerByTechSupportAgentOrDistributorStateTimeZone(techSupportAgentId, distributorId, state, timeZone, ctrl.selectedLetters).then(function (resp) {
            ctrl.loading = false;
            ctrl.requiredCustomers = resp.data;
            for (var _i = 0; _i < ctrl.requiredCustomers.length; _i++) {
                for (var j = 0; j < ctrl.requiredCustomers[_i].currentTechSupportAgents.length; j++) {
                    if (ctrl.requiredCustomers[_i].agents == "") {
                        ctrl.requiredCustomers[_i].agents = ctrl.requiredCustomers[_i].currentTechSupportAgents[j].name;
                    } else {
                        ctrl.requiredCustomers[_i].agents = ctrl.requiredCustomers[_i].agents + "/" + ctrl.requiredCustomers[_i].currentTechSupportAgents[j].name;
                    }
                }
            }
        });
    };

    //Get customer by provided customer name
    ctrl.getCustomerByCustomerName = function (customerName) {
        ctrl.loading = true;
        ctrl.allCustomerSelected = false;
        ctrl.numberOfSelectedCustomers = 0;
        ctrl.requiredCustomers = [];
        ctrl.displayMode = 0;
        ctrl.selectedPlan = null;
        ctrl._techSupportAssign.GetCustomerByCustomerName(customerName).then(function (resp) {
            ctrl.loading = false;
            ctrl.requiredCustomers = resp.data;
            for (var i = 0; i < ctrl.requiredCustomers.length; i++) {
                for (var j = 0; j < ctrl.requiredCustomers[i].currentTechSupportAgents.length; j++) {
                    if (ctrl.requiredCustomers[i].agents == "") {
                        ctrl.requiredCustomers[i].agents = ctrl.requiredCustomers[i].currentTechSupportAgents[j].name;
                    } else {
                        ctrl.requiredCustomers[i].agents = ctrl.requiredCustomers[i].agents + "/" + ctrl.requiredCustomers[i].currentTechSupportAgents[j].name;
                    }
                }
            }
        });
    };

    //Filter customers based on the initial letter selected 
    ctrl.filterCustomers = function (initialLetter) {
        ctrl.customersCopy = ctrl.customers.filter(function (el) {
            return el.name.startsWith(initialLetter);
        });
        if (ctrl.firstOpen) {
            for (var i = 0; i < ctrl.customersCopy.length; i++) {
                if (ctrl.customersCopy[i].name == ctrl.accountInfo.customerName) ctrl.customerName = ctrl.customersCopy[i];
            }
        };
        ctrl.firstOpen = false;
    };

    ctrl.cleanInputFields = function () {
        ctrl.simNumber = null;
        ctrl.serialNumber = null;
    };

    //Select all RTUs
    ctrl.selectAll = function () {
        var i = void 0;
        if (ctrl.allCustomerSelected) {
            for (i = 0; i < ctrl.requiredCustomers.length; i++) {
                ctrl.requiredCustomers[i].isSelected = true;
            }
            ctrl.numberOfSelectedCustomers = ctrl.requiredCustomers.length;
            $(".tech-support-checkbox").prop("checked", true);
        } else {
            for (i = 0; i < ctrl.requiredCustomers.length; i++) {
                ctrl.requiredCustomers[i].isSelected = false;
            }
            ctrl.numberOfSelectedCustomers = 0;
            $(".tech-support-checkbox").prop("checked", false);
        }
    };

    //Update selected customers' assigned tech support agent
    ctrl.updateTechSupportAgent = function (techSupportAgent) {
        ctrl.selectedCustomers = [];
        ctrl.numberOfSelectedCustomers = 0;

        for (var i = 0; i < ctrl.requiredCustomers.length; i++) {
            if (ctrl.requiredCustomers[i].isSelected == true) ctrl.selectedCustomers.push(ctrl.requiredCustomers[i]);
        }

        ctrl._techSupportAssign.AssignTechSupportAgent(ctrl.selectedCustomers, techSupportAgent.id).then(function (resp) {
            for (var _i2 = 0; _i2 < ctrl.requiredCustomers.length; _i2++) {
                if (ctrl.requiredCustomers[_i2].isSelected == true) {
                    ctrl.requiredCustomers[_i2].isSelected = false; //clear the selected customer
                    var newCustomer = angular.copy(ctrl.requiredCustomers[_i2]);
                    if (newCustomer.agents == "") {
                        newCustomer.agents = techSupportAgent.name;
                    } else {
                        if (!newCustomer.agents.includes(techSupportAgent.name)) newCustomer.agents = ctrl.requiredCustomers[_i2].agents + "/" + techSupportAgent.name;
                    }

                    //newCustomer.currentTechSupportAgentName = techSupportAgent.name;
                    ctrl.requiredCustomers.splice(_i2, 1, newCustomer);
                }
            }
            ctrl.allCustomerSelected = false;
            $(".tech-support-checkbox").prop("checked", false); //clear selected customer from UI
        });
    };

    //Delete all assigned agents from customers
    ctrl.deleteAgents = function () {
        ctrl.selectedCustomers = [];
        ctrl.numberOfSelectedCustomers = 0;

        for (var i = 0; i < ctrl.requiredCustomers.length; i++) {
            if (ctrl.requiredCustomers[i].isSelected == true) ctrl.selectedCustomers.push(ctrl.requiredCustomers[i]);
        }

        ctrl._techSupportAssign.DeleteAgents(ctrl.selectedCustomers).then(function (resp) {
            for (var _i3 = 0; _i3 < ctrl.requiredCustomers.length; _i3++) {
                if (ctrl.requiredCustomers[_i3].isSelected == true) {
                    ctrl.requiredCustomers[_i3].isSelected = false; //clear the selected customer
                    var newCustomer = angular.copy(ctrl.requiredCustomers[_i3]);
                    newCustomer.agents = "";
                    ctrl.requiredCustomers.splice(_i3, 1, newCustomer);
                }
            }
            ctrl.allCustomerSelected = false;
            $(".tech-support-checkbox").prop("checked", false); //clear selected customer from UI
        });
    };

    //select/de-select a customer
    ctrl.selecteCustomer = function (customer) {
        customer.isSelected = !customer.isSelected;
        if (customer.isSelected) {
            ctrl.numberOfSelectedCustomers += 1;
        } else {
            ctrl.numberOfSelectedCustomers -= 1;
        }
        if (ctrl.numberOfSelectedCustomers == 0) {
            ctrl.allCustomerSelected = false;
            $(".tech-support-checkbox").prop("checked", false);
        }
    };

    ///
    ///
    /// All of the below methods are left over and I do not use / do not know if they work.
    ///
    ///

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                0: { columnWidth: 70 },
                1: { columnWidth: 100 },
                2: { columnWidth: 100 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshData();
    });

    ctrl.refreshData = function () {
        ctrl.carrierDataUsage = angular.copy(ctrl.carrierDataUsage);
    };
}

TechSupportAssignController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'TechSupportAssignFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', '$uibModal', 'savePdfService'];
'use strict';

angular.module('mc.tech-support-assign').component('techSupportAssign', {
    controller: TechSupportAssignController,
    templateUrl: 'ui/techsupportassignment/assign/tech-support-assign-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.assign-rtu-to-customer", []);
'use strict';

function AssignRtuToCustomerFactory(HOST, $http) {

    var _assignRtuToCustomer = function _assignRtuToCustomer() {};

    _assignRtuToCustomer.prototype.isUserMissionManager = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupport/IsUserMissionManager/'
        });
    };

    return _assignRtuToCustomer;
}

AssignRtuToCustomerFactory.$inject = ['HOST', '$http'];

angular.module('mc.assign-rtu-to-customer').factory('AssignRtuToCustomerFactory', AssignRtuToCustomerFactory);
"use strict";

function AssignRtuToCustomerController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, TechSupportSummaryByAgentFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, $q, $uibModal, savePdfService) {
    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    //ctrl.requiredCustomers = [];
    //ctrl.selectedCustomers = [];
    //ctrl.allCustomerSelected = false;

    ctrl.$onInit = function () {
        ctrl._assignRtuToCustomer = new AssignRtuToCustomerFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        //--------------------------------------------------------------------------------------------------
        ctrl.loading = false;
        ctrl.isMissionManager = false;
        ctrl.reqRefresh = false;

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for       

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }
    };

    //check if current user is manager or not and do following procedure accordingly
    ctrl.isCurrentUserManager = function () {
        ctrl._techSupportSummaryByAgent.isUserMissionManager().then(function (resp) {
            ctrl.isMissionManager = resp.data;
            if (ctrl.isMissionManager) {
                //login id for Paul, Joe and Yifan and Peter. Yifan and Peter are for testing purpose            
                ctrl.getTechSupportAgents();
            } else {
                ctrl.getTechSupportSummaries(-1); //pass -1 as parameter to get web login id from mcToken in service
            }
        });
    };

    //Get tech support agents for search option
    ctrl.getTechSupportAgents = function () {
        //ctrl.loading = true;
        ctrl._techSupportSummaryByAgent.GetTechSupportAgents().then(function (resp) {
            ctrl.techSupportAgents = resp.data;
            //ctrl.loading = false;
        });
    };

    //Get tech support summaries
    ctrl.getTechSupportSummaries = function (webLoginId) {
        if (!webLoginId) return;
        ctrl.loading = true;
        ctrl._techSupportSummaryByAgent.GetTechSupportSummaryByAgent(webLoginId).then(function (resp) {
            ctrl.reqRefresh = true;
            ctrl.techSupportSummaries = resp.data;
            ctrl.loading = false;
            $timeout(function () {
                ctrl.reqRefresh = false;
            });
        });
    };

    ///
    ///
    /// All of the below methods are left over and I do not use / do not know if they work.
    ///
    ///

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshData();
    });

    ctrl.refreshData = function () {
        ctrl.carrierDataUsage = angular.copy(ctrl.carrierDataUsage);
    };
}

AssignRtuToCustomerController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'TechSupportSummaryByAgentFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', '$uibModal', 'savePdfService'];
'use strict';

angular.module('mc.assign-rtu-to-customer').component('assignRtuToCustomer', {
    controller: AssignRtuToCustomerController,
    templateUrl: 'ui/techsupportassigncustomer/assignrtutocustomer/tech-support-assign-rtu-to-customer-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.tech-support-summary-by-agent", []);
'use strict';

function TechSupportSummaryByAgentFactory(HOST, $http) {

    var _techSupportSummaryByAgent = function _techSupportSummaryByAgent() {};

    _techSupportSummaryByAgent.prototype.GetTechSupportAgents = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupportSummaryByAgent/GetTechSupportAgents/'
        });
    };

    _techSupportSummaryByAgent.prototype.GetTechSupportSummaryByAgent = function (webLoginId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupportSummaryByAgent/GetTechSupportSummaryByAgent/',
            params: { webLoginId: webLoginId }
        });
    };

    _techSupportSummaryByAgent.prototype.isUserMissionManager = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupport/IsUserMissionManager/'
        });
    };

    return _techSupportSummaryByAgent;
}

TechSupportSummaryByAgentFactory.$inject = ['HOST', '$http'];

angular.module('mc.tech-support-summary-by-agent').factory('TechSupportSummaryByAgentFactory', TechSupportSummaryByAgentFactory);
"use strict";

function TechSupportSummaryByAgentController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, TechSupportSummaryByAgentFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, $q, $uibModal, savePdfService) {
    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    //ctrl.requiredCustomers = [];
    //ctrl.selectedCustomers = [];
    //ctrl.allCustomerSelected = false;

    ctrl.$onInit = function () {
        ctrl._techSupportSummaryByAgent = new TechSupportSummaryByAgentFactory();
        ctrl.reverse = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        //--------------------------------------------------------------------------------------------------
        ctrl.techSupportSummaries = null;
        ctrl.techSupportAgents = null;
        ctrl.loading = false;
        ctrl.isMissionManager = false;
        ctrl.reqRefresh = false;

        ctrl.isCurrentUserManager();
        ctrl.getTechSupportAgents();

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for       

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }
    };

    //check if current user is manager or not and do following procedure accordingly
    ctrl.isCurrentUserManager = function () {
        ctrl._techSupportSummaryByAgent.isUserMissionManager().then(function (resp) {
            ctrl.isMissionManager = resp.data;
            if (ctrl.isMissionManager) {
                //login id for Paul, Joe and Yifan and Peter. Yifan and Peter are for testing purpose            
                ctrl.getTechSupportAgents();
            } else {
                ctrl.getTechSupportSummaries(-1); //pass -1 as parameter to get web login id from mcToken in service
            }
        });
    };

    //Get tech support agents for search option
    ctrl.getTechSupportAgents = function () {
        //ctrl.loading = true;
        ctrl._techSupportSummaryByAgent.GetTechSupportAgents().then(function (resp) {
            ctrl.techSupportAgents = resp.data;
            //ctrl.loading = false;
        });
    };

    //Get tech support summaries
    ctrl.getTechSupportSummaries = function (webLoginId) {
        if (!webLoginId) return;
        ctrl.loading = true;
        ctrl._techSupportSummaryByAgent.GetTechSupportSummaryByAgent(webLoginId).then(function (resp) {
            ctrl.reqRefresh = true;
            ctrl.techSupportSummaries = resp.data;
            ctrl.loading = false;
            $timeout(function () {
                ctrl.reqRefresh = false;
            });
        });
    };

    ///
    ///
    /// All of the below methods are left over and I do not use / do not know if they work.
    ///
    ///

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                0: { columnWidth: 70 },
                1: { columnWidth: 100 },
                2: { columnWidth: 100 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshData();
    });

    ctrl.refreshData = function () {
        ctrl.carrierDataUsage = angular.copy(ctrl.carrierDataUsage);
    };
}

TechSupportSummaryByAgentController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'TechSupportSummaryByAgentFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', '$uibModal', 'savePdfService'];
'use strict';

angular.module('mc.tech-support-summary-by-agent').component('techSupportSummaryByAgent', {
    controller: TechSupportSummaryByAgentController,
    templateUrl: 'ui/techsupportassignment/summarybyagent/tech-support-summary-by-agent-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.signal-table', []);
'use strict';

function SignalTableFactory(HOST, $http) {
    var SignalTableFactory = function SignalTableFactory() {
        this.items = [];
        this.deviceName = '';
        this.customerId = null;
        this.deviceId = null;
        this.timeZone = "Z";
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.windowTitle = null;
        this.alerts = [];
        this.translation = this.translation;
        this.scrollUp = "";
        this.scrollDown = "";
        this.deviceType = null;
        this.deviceRadioTypeId = null;
    };

    SignalTableFactory.prototype.nextPage = function (customerId, deviceId, start, end, startRow, pageSize, timeZone, scrollDown) {
        return $http({
            method: 'GET',
            url: HOST + "/api/SignalTable?customerId=" + customerId + "&deviceId=" + deviceId + "&StartRow=" + startRow + "&PageSize=" + pageSize + "&StartDate=" + start + "&EndDate=" + end + "&fromDate=" + scrollDown + "&timeZone=" + timeZone,
            cache: true
        });
    };

    SignalTableFactory.prototype.previousPage = function (customerId, deviceId, start, end, startRow, pageSize, timeZone, scrollUp) {
        return $http({
            method: 'GET',
            url: HOST + "/api/SignalTable?customerId=" + customerId + "&deviceId=" + deviceId + "&StartRow=" + startRow + "&PageSize=" + pageSize + "&StartDate=" + start + "&EndDate=" + end + "&fromDate=" + scrollUp + "&timeZone=" + timeZone,
            cache: true
        });
    };

    return SignalTableFactory;
}

SignalTableFactory.$inject = ['HOST', '$http'];

angular.module('mc.signal-table').factory('SignalTableFactory', SignalTableFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function SignalTableController($scope, $rootScope, translationService, sharedSetupService, openViewService, $element, authenticationService, $timeout, websocketService, timeLapseService, datetimeService, SignalTableFactory) {
    var ctrl = this;
    ctrl.infiniteScrollOn = false;
    ctrl.infiniteScrollUpOn = false;
    ctrl.infiniteScrollDownOn = false;
    var element = $element.find("#signal-table-comp");
    var currentScrollbarPosition = 0;
    var previousScrollbarPosition = 0;
    var paddingZoom = void 0;
    ctrl.$onInit = function () {
        //console.log("** onInit: ");
        sharedSetupService.getWindowId($scope);
        ctrl.myDate = null;

        ctrl.checkFirstRowLiveStatus = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.preferredMeasurementFormat = ctrl.accountInfo.preferenceUser.lookupMeasurementID;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.liveDataOffset = sharedSetupService.liveDataOffset;
        ctrl.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
        ctrl.translation = translationService.translation;
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.alerts = [];
        ctrl.downloadViewTypeOptions = [0, 4];

        $scope.windowId = ctrl.windowId; //need for displaying correct header
        $scope.windowTitle = ctrl.windowTitle; //need for displaying correct header

        sharedSetupService.broadcastAllDeviceSelected($scope);
        ctrl.liveTable = $element.find(".headertable");
        ctrl.hasRMDTRadio = $scope.hasRMDTRadio;

        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        $scope.stickyProperties = ctrl.stickyProperties;

        paddingZoom = Math.round((ctrl.stickyProperties.zoomMax - ctrl.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? ctrl.unixDay / 2 : paddingZoom;

        _openTableInLiveMode();

        ctrl.liveDataLine = function (varLiveData) {
            if (varLiveData) {
                ctrl.liveTable.addClass("live-data-line");
            } else {
                ctrl.liveTable.removeClass("live-data-line");
            }
        };

        ctrl.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            ctrl.timeFormat = timeFormat;
            ctrl.updateLanguage();
        });

        $scope.$on('updatePreferencesLanguage', function () {
            ctrl.updateLanguage();
        });

        ctrl.updateLanguage = function () {
            ctrl.signalDataService.items = angular.copy(ctrl.signalDataService.items);
        };

        if (!$scope.mobile && !$scope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    ctrl.adjustSize();
                    openViewService.adjustContentSizeStart(ctrl.popup);
                }
            });

            ctrl.adjustSize = function () {
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };

            ctrl.adjustDeviceIdMenuSize = function () {
                var spph = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                if (spph < 450) {
                    ctrl.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
                } else {
                    ctrl.popup.parent().find('.device-id-menu').css('max-height', 400);
                }
            };
        }
    };

    ctrl.trgScroll = function () {
        $timeout(function () {
            var $rowFirst = element.contents().find("tr:first");
            var _firstRow = $rowFirst.attr("name");
            if (typeof $rowFirst.position() !== "undefined") {
                var _tableTop = element.offset().top;
                var _rowTop = $rowFirst.offset().top;
                _setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);
            }
        }, 0);
    };

    $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
        if ($scope.alerts.length > 0) {
            var _msg = eval("ctrl.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
            var _type = $scope.alerts[0].type;
            var _languageCode = $scope.alerts[0].languageCode;
            if (_languageCode.toUpperCase() === 'NO_DATA') {
                _msg += ': ' + moment(ctrl.signalDataService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.signalDataService.end).utc().format('MM/DD/YY, h:mm:ss a');
            }
            $scope.alerts = [];
            $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        }
    });

    element.on('scroll', function (event) {
        var $rowFirst = element.contents().find("tr:first");
        var $rowLast = element.contents().find("tr:last");
        if (typeof $rowFirst.position() !== "undefined") {
            ctrl.infiniteScrollOn = true;ctrl.infiniteScrollUpOn = true;ctrl.infiniteScrollDownOn = true;
            ctrl.trgScroll();
            previousScrollbarPosition = currentScrollbarPosition;
            currentScrollbarPosition = element[0].scrollTop;
        }

        if (ctrl.infiniteScrollOn === true) {
            ctrl.infiniteScrollUpOn = true;
            ctrl.infiniteScrollDownOn = true;

            if (ctrl.infiniteScrollDownOn === true && element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight) {
                $rowLast.addClass("active-row");
                $scope.alerts = [];
                ctrl.nextPage();
            }
            if (ctrl.infiniteScrollUpOn === true && element[0].scrollTop < 5 && currentScrollbarPosition < previousScrollbarPosition) {
                $rowFirst.addClass("active-row");
                $scope.alerts = [];
                ctrl.previousPage();
            }
        }

        var rows = element.children().children().children().children();
        var scrollpos = 40;
        var start = 0;
        var end = rows.length;
        var count = 0;

        while (start != end) {
            count++;
            var mid = start + Math.floor((end - start) / 2);
            if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
        }
        _updateZoom(parseFloat($($(rows[start])).attr("name")));
    });

    var _updateZoom = function _updateZoom(currentRow) {
        if (isNaN(currentRow)) return;

        var zoomMin = currentRow - paddingZoom;
        var zoomMax = currentRow + paddingZoom;

        var dateMin = ctrl.stickyProperties.dateMin;
        var dateMax = ctrl.stickyProperties.dateMax;

        if (zoomMin < ctrl.stickyProperties.dateMin) {
            dateMin = zoomMin;
        }
        if (zoomMax > ctrl.stickyProperties.dateMax) {
            dateMax = zoomMax;
        }

        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: ctrl.windowId });
    };

    ctrl.toggle = function ($event) {
        if ($($event.currentTarget).hasClass("active-row")) {
            $($event.currentTarget).removeClass("active-row");
        } else {
            $($event.currentTarget).addClass("active-row");
        }
    };

    $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            ctrl.liveDataIn = !ctrl.liveDataIn;
            $timeout(function () {
                ctrl.liveDataIn = !ctrl.liveDataIn;
            }, 3000);
        }
    }, true);

    $scope.$watch('signalDataService.alerts', function (newValue, oldValue) {
        if (newValue && newValue.length > 0 && newValue != oldValue) {
            $scope.alerts = newValue;
        }
    }, true);

    ctrl.newSignalTableService = function () {
        ctrl.signalDataService = new SignalTableFactory();
        ctrl.signalDataService.customerId = ctrl.accountInfo.customerId;
        ctrl.signalDataService.timeZone = ctrl.accountInfo.timeZone;
        ctrl.signalDataService.deviceId = ctrl.deviceSelected;
        ctrl.signalDataService.deviceType = $scope.deviceSelectedType;
        ctrl.signalDataService.hasRMDTRadio = ctrl.hasRMDTRadio;
        ctrl.signalDataService.windowTitle = ctrl.windowTitle;
        ctrl.signalDataService.startRow = 1;
        ctrl.signalDataService.pageSize = 50;

        ctrl.signalDataService.items = [];
        ctrl.signalDataService.deviceName = '';
        ctrl.signalDataService.start = '19000101';
        ctrl.signalDataService.end = '19000101';
        ctrl.signalDataService.busy = false;
        ctrl.signalDataService.numberOfReturnedRecords = -1;
        ctrl.signalDataService.numberOfNewRecordsPrevious = -1;
        ctrl.signalDataService.windowTitle = null;
        ctrl.signalDataService.alerts = [];
        ctrl.signalDataService.translation = this.translation;
        ctrl.signalDataService.scrollUp = "";
        ctrl.signalDataService.scrollDown = "";
        ctrl.signalDataService.deviceRadioTypeId = null;
    };

    var _openTableInLiveMode = function _openTableInLiveMode() {
        //console.log("** _openTableInLiveMode: ");
        ctrl.stickyProperties.on = false;
        timeLapseService.getLocalDateTime().then(function (result) {
            /////////////////////////////////////////////////////////////
            var tmpDates = new Date(result.data.localDateTime);
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
            tmpDatesA.setHours(23, 59, 59, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            ctrl.newSignalTableService();
            ctrl.signalDataService.start = tmpDates.startDate;
            ctrl.signalDataService.end = tmpDatesA;
            ctrl.signalDataService.deviceType = $scope.deviceSelectedType;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + ctrl.unixDay, zoomMax: tmpDates.endDate - ctrl.unixDay, windowId: ctrl.windowId });
            ctrl.nextPage();
            /////////////////////////////////////////////////////////////
        });
    };

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        //console.log("** Device Selected... newValue: " + (newValue ? newValue : 'null') + " oldValue: " + (ctrl.deviceSelected ? ctrl.deviceSelected : 'null'));
        if (newValue && newValue != ctrl.deviceSelected) {
            ctrl.deviceSelected = newValue;
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            ctrl.checkFirstRowLiveStatus = null;
            /////////////////////////////////////////////////////////////
            $scope.alerts = [];
            var _device = { deviceName: $scope.deviceSelectedName };
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: newValue, device: _device, windowId: ctrl.windowId, hasRMDTRadio: ctrl.hasRMDTRadio });

            if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.dateMin !== null) {
                ctrl.stickyProperties.on = true;
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (ctrl.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && ctrl.stickyProperties.zoomMax + parseFloat(ctrl.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        ctrl.newSignalTableService();
                        ctrl.signalDataService.start = ctrl.stickyProperties.dateMin - 3 * ctrl.unixDay; //need to extend data range;
                        ctrl.signalDataService.end = ctrl.stickyProperties.dateMax;
                        ctrl.signalDataService.deviceType = $scope.deviceSelectedType;
                        ctrl.signalDataService.hasRMDTRadio = ctrl.hasRMDTRadio;
                        ctrl.nextPage();
                    } else {
                        ctrl.newSignalTableService();
                        ctrl.signalDataService.start = ctrl.stickyProperties.dateMin - 3 * ctrl.unixDay; //need to extend data range;
                        ctrl.signalDataService.end = Math.round((ctrl.stickyProperties.zoomMax + ctrl.stickyProperties.zoomMin) / 2);
                        ctrl.signalDataService.deviceType = $scope.deviceSelectedType;
                        ctrl.signalDataService.hasRMDTRadio = ctrl.hasRMDTRadio;
                        ctrl.nextPage();
                    }
                });
            } else {
                //console.log("** Device Selected... openTableInLiveMode: ");
                _openTableInLiveMode();
            }
        }
    }, true);

    $scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
        if (newValue) ctrl.deviceSelectedSn = newValue;
        if (newValue && newValue != oldValue) {
            ctrl.stickyProperties.device.serialNumber = newValue;
            if (oldValue) {
                _unRegisterListener(oldValue);
            }
        }
    }, true);

    ctrl.selectMyDate = function (date) {
        ctrl.myDate = date;
        ctrl.signalDataService = new SignalTableFactory();
        /////////////////////////////////////////////////////////////
        currentScrollbarPosition = 0;
        previousScrollbarPosition = 0;
        ctrl.checkFirstRowLiveStatus = null;
        _unRegisterListener(ctrl.deviceSelectedSn);
        /////////////////////////////////////////////////////////////
        var tmpDates = ctrl.myDate;
        var tmpDatesA = tmpDates;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
        tmpDatesA.setHours(12, 0, 0, 0);
        tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
        /////////////////////////////////////////////////////////////
        ctrl.signalDataService.start = tmpDates.startDate;
        if (new Date(ctrl.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
            ctrl.signalDataService.end = tmpDatesA;
        } else {
            ctrl.signalDataService.end = tmpDates.endDate;
        }
        /////////////////////////////////////////////////////////////
        ctrl.signalDataService.startRow = 1;
        ctrl.signalDataService.pageSize = 50;
        ctrl.signalDataService.customerId = ctrl.accountInfo.customerId;
        ctrl.signalDataService.timeZone = ctrl.accountInfo.timeZone;
        ctrl.signalDataService.deviceId = $scope.deviceSelected;
        ctrl.signalDataService.windowTitle = ctrl.windowTitle;
        ctrl.signalDataService.deviceType = $scope.deviceSelectedType;
        ctrl.signalDataService.hasRMDTRadio = ctrl.hasRMDTRadio;
        $scope.alerts = [];
        ctrl.nextPage();
        /////////////////////////////////////////////////////////////
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + ctrl.unixDay, zoomMax: tmpDates.endDate - ctrl.unixDay, windowId: ctrl.windowId });
    };

    var _setLiveDataStatus = function _setLiveDataStatus(firstRow, liveDataStatusOn) {
        if (ctrl.checkFirstRowLiveStatus === true) {
            _checkTopOffset(liveDataStatusOn);
        } else if (ctrl.checkFirstRowLiveStatus === null) {
            timeLapseService.getLocalDateTime().then(function (result) {
                if (parseFloat(firstRow) + parseFloat(ctrl.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                    ctrl.checkFirstRowLiveStatus = true;
                    _checkTopOffset(liveDataStatusOn);
                } else {
                    ctrl.checkFirstRowLiveStatus = false;
                }
            });
        }
    };

    var _checkTopOffset = function _checkTopOffset(liveDataStatusOn) {
        if (liveDataStatusOn) {
            _registerListener(ctrl.deviceSelectedSn);
        } else {
            _unRegisterListener(ctrl.deviceSelectedSn);
        }
    };

    var wsDataReceivedSIGNAL = function wsDataReceivedSIGNAL(data) {
        var i = 0;
        var _recordExistAtIndex = null;
        if (ctrl.liveData === false) {
            _unRegisterListener(ctrl.deviceSelectedSn);
            return;
        }

        var varTime = datetimeService.socketStrToServerStrTime(data.Time);
        var varValue = parseFloat(data.Value);

        for (i = 0; i < ctrl.signalDataService.items.length; i++) {
            if (ctrl.signalDataService.items[i].localDateTime === varTime) {
                _recordExistAtIndex = i;
                break;
            }
        }

        if (_recordExistAtIndex !== null) {
            //console.log('New row in input at: ' + varTime);
            ctrl.signalDataService.items[_recordExistAtIndex].value = varValue;
        } else {
            var _newMeasurements = { "localDateTime": varTime, "value": varValue };
            ctrl.signalDataService.items.unshift(_newMeasurements);
        }
        ctrl.signalDataService.end = datetimeService.toUnixtime(data.Time) + ctrl.unixDay;
        ctrl.lastUpdateAt = varTime;
    };
    var wsDataReceivedSIGNALPOWER = function wsDataReceivedSIGNALPOWER(data) {
        var i = 0;
        var _recordExistAtIndex = null;
        if (ctrl.liveData === false) {
            _unRegisterListener(ctrl.deviceSelectedSn);
            return;
        }

        var varTime = datetimeService.socketStrToServerStrTime(data.Time);
        var varValue = parseFloat(data.Value);
        for (i = 0; i < ctrl.signalDataService.items.length; i++) {
            if (ctrl.signalDataService.items[i].localDateTime === varTime) {
                _recordExistAtIndex = i;
                break;
            }
        }
        if (_recordExistAtIndex !== null) {
            ctrl.signalDataService.items[_recordExistAtIndex].signalPower = varValue;
        } else {
            var _newMeasurements = { "localDateTime": varTime, "signalPower": varValue };
            ctrl.signalDataService.items.unshift(_newMeasurements);
        }
        ctrl.signalDataService.end = datetimeService.toUnixtime(data.Time) + ctrl.unixDay;
        ctrl.lastUpdateAt = varTime;
    };
    var wsDataReceivedSIGNALQUALITY = function wsDataReceivedSIGNALQUALITY(data) {
        var i = 0;
        var _recordExistAtIndex = null;
        if (ctrl.liveData === false) {
            _unRegisterListener(ctrl.deviceSelectedSn);
            return;
        }

        var varTime = datetimeService.socketStrToServerStrTime(data.Time);
        var varValue = parseFloat(data.Value);

        for (i = 0; i < ctrl.signalDataService.items.length; i++) {
            if (ctrl.signalDataService.items[i].localDateTime === varTime) {
                _recordExistAtIndex = i;
                break;
            }
        }
        if (_recordExistAtIndex !== null) {
            ctrl.signalDataService.items[_recordExistAtIndex].signalQuality = varValue;
        } else {
            var _newMeasurements = { "localDateTime": varTime, "signalQuality": varValue };
            ctrl.signalDataService.items.unshift(_newMeasurements);
        }
        ctrl.signalDataService.end = datetimeService.toUnixtime(data.Time) + ctrl.unixDay;
        ctrl.lastUpdateAt = varTime;
    };

    $scope.$on('processReconnect', function (event, args) {
        ctrl.reconnectData(event, args);
    });

    ctrl.reconnectData = function (event, args) {
        sharedSetupService.processReconnect({
            stickyProperties: ctrl.stickyProperties,
            localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
            dateRangeOption: null,
            windowTitle: ctrl.windowTitle,
            fnUnregister: _unRegisterListener,
            fnGetData: _openTableInLiveMode,
            viewType: "Table"
        });
    };

    ctrl.mostRecentData = function (event, args) {
        ctrl.stickyProperties.liveData = true;
        ctrl.myDate = null;
        ctrl.reconnectData(event, args);
    };

    var _registerListener = function _registerListener(varSelectedSN) {
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: true, windowId: ctrl.windowId });
        ctrl.liveData = true;
        ctrl.liveDataLine(ctrl.liveData);
        ctrl.signalDataService.numberOfNewRecordsPrevious = -1;
        websocketService.connect();
        websocketService.register("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, null);
        websocketService.register("SIGNALPOWER", varSelectedSN, "", wsDataReceivedSIGNALPOWER, null);
        websocketService.register("SIGNALQUALITY", varSelectedSN, "", wsDataReceivedSIGNALQUALITY, null);
    };

    var _unRegisterListener = function _unRegisterListener(varSelectedSN) {
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: false, windowId: ctrl.windowId });
        if (ctrl.liveData === false) return;
        ctrl.liveData = false;
        ctrl.liveDataLine(ctrl.liveData);
        ctrl.lastUpdateAt = undefined;
        websocketService.unRegister("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, null);
        websocketService.unRegister("SIGNALPOWER", varSelectedSN, "", wsDataReceivedSIGNALPOWER, null);
        websocketService.unRegister("SIGNALQUALITY", varSelectedSN, "", wsDataReceivedSIGNALQUALITY, null);
    };

    $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
        _autoScroll();
        ctrl.checkFirstRowLiveStatus = null;
        ctrl.trgScroll();
    });

    var _autoScroll = function _autoScroll() {
        if (ctrl.signalDataService.numberOfNewRecordsPrevious > 0) {
            var trRow = element.find('tr').eq(ctrl.signalDataService.numberOfNewRecordsPrevious - 1);
            var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
            element.scrollTop(yPosition);
        } else {
            $timeout(function () {
                element.animate({
                    scrollTop: 5
                }, 500);
            }, 0);
        }
    };

    $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
        ctrl.preferredMeasurementFormat = parseInt(measurementSystem);
    });

    $scope.$on("$destroy", function () {
        _unRegisterListener(ctrl.deviceSelectedSn);
    });

    ctrl.previousPage = function () {
        if (ctrl.signalDataService.busy || ctrl.signalDataService.numberOfNewRecordsPrevious === 0) return;
        ctrl.signalDataService.busy = true;
        ctrl.signalDataService.pageSize = -50;

        //from is: very top record
        ctrl.signalDataService.previousPage(ctrl.signalDataService.customerId, ctrl.signalDataService.deviceId, ctrl.signalDataService.start, ctrl.signalDataService.end, ctrl.signalDataService.startRow, ctrl.signalDataService.pageSize, ctrl.signalDataService.timeZone, ctrl.signalDataService.scrollUp).then(function (result) {
            /////////////////////////
            var intDayWindow = 10;
            var intDay = 86400000;
            /////////////////////////
            var deviceName = result.data.device.name;
            ctrl.hasRMDTRadio = result.data.device.hasRMDTRadio;
            var items = result.data.data.measurements;
            for (var i = 0; i < items.length; i++) {
                items[i].localDateTime = items[i].localDateTime;
                items[i].value = items[i].value;
                ctrl.signalDataService.items.unshift(items[i]);
            }

            ctrl.signalDataService.hasRMDTRadio = result.data.device.hasRMDTRadio;
            ctrl.signalDataService.numberOfNewRecordsPrevious = items.length;
            ctrl.signalDataService.numberOfRecords = ctrl.signalDataService.items.length;
            ctrl.signalDataService.deviceName = deviceName;
            ctrl.signalDataService.startRow = ctrl.signalDataService.startRow + items.length;
            if (items.length > 0) {
                //if there are records returned
                ctrl.signalDataService.start = datetimeService.toUnixtime(ctrl.signalDataService.items[ctrl.signalDataService.items.length - 1].localDateTime.replace(/\D/g, '')) - intDayWindow * intDay;
                ctrl.signalDataService.end = datetimeService.toUnixtimeMs(ctrl.signalDataService.items[0].localDateTime.replace(/\D/g, ''));
            }

            if (ctrl.signalDataService.items.length > 0) {
                ctrl.signalDataService.scrollUp = datetimeService.toUnixtimeMs(ctrl.signalDataService.items[0].localDateTime.replace(/\D/g, ''));
                ctrl.signalDataService.scrollDown = datetimeService.toUnixtimeMs(ctrl.signalDataService.items[ctrl.signalDataService.items.length - 1].localDateTime.replace(/\D/g, ''));
            } else {
                ctrl.signalDataService.scrollUp = "";
                ctrl.signalDataService.scrollDown = "";
            }
            ctrl.signalDataService.pageSize = 50;
            ctrl.signalDataService.busy = false;
        }.bind(ctrl.signalDataService), function (error) {
            $scope.alerts = [];
            var errorMessage = eval("ctrl.translation.message." + error.data.message);
            var errorMessage = '';
            $scope.alerts.push({ msg: errorMessage, type: "danger" });
            ctrl.signalDataService.pageSize = 50;
            ctrl.signalDataService.busy = false;
        }.bind(ctrl.signalDataService));
    };

    ctrl.nextPage = function () {
        //console.log("** nextPage TO feth..");
        if (ctrl.signalDataService.busy || ctrl.signalDataService.numberOfReturnedRecords === 0) return;
        ctrl.signalDataService.busy = true;
        //from is: very bottom record
        ctrl.signalDataService.nextPage(ctrl.signalDataService.customerId, ctrl.signalDataService.deviceId, ctrl.signalDataService.start, ctrl.signalDataService.end, ctrl.signalDataService.startRow, ctrl.signalDataService.pageSize, ctrl.signalDataService.timeZone, ctrl.signalDataService.scrollDown).then(function (result) {
            /////////////////////////
            //console.log("** nextPage fetched..");
            var intDayWindow = 10;
            var intDay = 86400000;
            /////////////////////////
            var deviceName = result.data.device.name;
            ctrl.hasRMDTRadio = result.data.device.hasRMDTRadio;
            var items = result.data.data.measurements;
            for (var i = 0; i < items.length; i++) {
                items[i].localDateTime = items[i].localDateTime;
                items[i].value = items[i].value;
                ctrl.signalDataService.items.push(items[i]);
            }
            //remove duplicate items, if any (group by arrivalDateTime and alarmDescription)
            ctrl.signalDataService.items = remove_duplicates(ctrl.signalDataService.items, ['localDateTime']);

            ctrl.signalDataService.numberOfReturnedRecords = items.length;
            ctrl.signalDataService.deviceName = deviceName;
            ctrl.signalDataService.startRow = ctrl.signalDataService.startRow + items.length;
            ctrl.signalDataService.hasRMDTRadio = result.data.device.hasRMDTRadio;

            if (items.length > 0) {
                //if there are records returned
                ctrl.signalDataService.start = datetimeService.toUnixtime(ctrl.signalDataService.items[ctrl.signalDataService.items.length - 1].localDateTime.replace(/\D/g, '')) - intDayWindow * intDay;
                ctrl.signalDataService.end = datetimeService.toUnixtimeMs(ctrl.signalDataService.items[0].localDateTime.replace(/\D/g, ''));
            } else {
                // If we didn't get any items back AND there aren't already any items
                if (ctrl.signalDataService.items.length === 0) {
                    $scope.alerts = [];
                    var errorMessage = "No Data" + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                    $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            }

            if (ctrl.signalDataService.items.length > 0) {
                ctrl.signalDataService.scrollUp = datetimeService.toUnixtimeMs(ctrl.signalDataService.items[0].localDateTime.replace(/\D/g, ''));
                ctrl.signalDataService.scrollDown = datetimeService.toUnixtimeMs(ctrl.signalDataService.items[ctrl.signalDataService.items.length - 1].localDateTime.replace(/\D/g, ''));
            } else {
                ctrl.signalDataService.scrollUp = "";
                ctrl.signalDataService.scrollDown = "";
            }
            ctrl.signalDataService.pageSize = 50;
            ctrl.signalDataService.busy = false;
        }.bind(ctrl.signalDataService), function (error) {
            $scope.alerts = [];
            var errorMessage = eval("ctrl.translation.message." + error.data.message);
            var errorMessage = '';
            $scope.alerts.push({ msg: errorMessage, type: "danger" });
            ctrl.signalDataService.pageSize = 50;
            ctrl.signalDataService.busy = false;
        }.bind(ctrl.signalDataService));
    };

    var remove_duplicates = function remove_duplicates(arr, props) {
        var seen = new Set();
        return arr.filter(function (item) {
            // Create a unique key by joining the values of the specified properties
            var key = props.map(function (prop) {
                return item[prop];
            }).join('|');
            if (seen.has(key)) {
                return false; // Duplicate found
            } else {
                seen.add(key); // New key, add to Set and keep the item
                return true;
            }
        });
    };
}

SignalTableController.$inject = ['$scope', '$rootScope', 'translationService', 'sharedSetupService', 'openViewService', '$element', 'authenticationService', '$timeout', 'websocketService', 'timeLapseService', 'datetimeService', 'SignalTableFactory'];
'use strict';

angular.module('mc.signal-table').component('signalTable', {
    controller: SignalTableController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/signal/table/signal-table-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        deviceSelectedSn: '<',
        myDate: '<'
    }
});
"use strict";

angular.module("mc.radio-upgrade-data", []);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RadioUpgradeDataController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, CurrentStatusFactory, openViewService, $interval, $location) {
    var ctrl = this;
    ctrl.loadingInProgress = true;
    var _startLiveData = void 0;
    ctrl.RMDTSignalData = [];
    ctrl.RMDTRadioData = [];
    ctrl.hasRMDTData = false;
    ctrl.networkOperator = "";

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile;
        ctrl.getAccountInfo();
        ctrl.adminPortal = sharedSetupService.adminPortal();
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
    };

    ctrl.$onChanges = function (changes) {
        if (!angular.isUndefined(changes.stickyProperties) && changes.stickyProperties.currentValue && changes.stickyProperties.currentValue != changes.stickyProperties.previousValue) {
            ctrl.stickyProperties = changes.stickyProperties.currentValue;
        }
        if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue != changes.deviceSelected.previousValue) {
            if (angular.isDefined(_startLiveData)) {
                $interval.cancel(_startLiveData);
                _startLiveData = undefined;
            }
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
            ctrl.getAccountInfo();
            ctrl.getRadioUpgradeData();
        }
    };

    ctrl.getAccountInfo = function () {
        if (angular.isDefined(ctrl.accountInfo)) return;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.getPreferredTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
    };

    ctrl.startLiveData = function () {
        _startLiveData = $interval(function () {
            ctrl.getRadioUpgradeData(0, true);
        }, 45000);
    };

    ctrl.refreshMe = function () {
        ctrl.getRadioUpgradeData(1);
    };

    ctrl.getRadioUpgradeData = function (varId, interval) {
        if (varId !== 0) ctrl.loadingInProgress = true;
        ctrl.RMDTSignalData = [];
        ctrl.RMDTRadioData = [];
        ctrl.radioUpgradeData = null;
        ctrl.networkOperator = "";
        ctrl.hasRMDTData = false;
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: ctrl.deviceSelected, windowId: ctrl.windowId });
        var _currentStatus = new CurrentStatusFactory(ctrl.stickyProperties.portalCustomerId || ctrl.accountInfo.customerId, ctrl.deviceSelected, ctrl.accountInfo.timeZone, true);

        _currentStatus.getRadioUpgradeData(interval).then(function () {
            var _datafromFactory = _currentStatus.list;
            ctrl.radioUpgradeData = _datafromFactory;
            ctrl.earfcnData = _datafromFactory.absoluteRadioFrequencyChannelData;
            if (ctrl.earfcnData != null) {
                ctrl.earfcnValue = '  [ ' + ctrl.earfcnData.band + ', ' + ctrl.earfcnData.mode + ', ' + ctrl.earfcnData.downLink + ', ' + ctrl.earfcnData.upLink + ' ]';
            } else {
                ctrl.earfcnValue = "";
            }

            ctrl.networkOperator = _datafromFactory.networkOperator;
            if (_datafromFactory.rmdtDeviceActivityData != null && _datafromFactory.rmdtDeviceActivityData.length > 0) {
                ctrl.processRMDTRadioData();
                ctrl.hasRMDTData = true;
            }
            ctrl.loadingInProgress = false;
            if (varId == null) ctrl.startLiveData();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.pagingViewHeightAdjustment = 0;
    if (ctrl.mcAdminAccess) {
        ctrl.pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
    }

    ctrl.processRMDTRadioData = function () {
        ctrl.RMDTSignalData = [];
        ctrl.RMDTRadioData = [];
        // RAT : Radio Access Technology
        // value 7: May represent LTE radio
        // value !=7: May represent 3G radio
        // So, 3G radios display Signal Strength
        // and, 4G/5G/LTE radios display Signal Quality & Signal Power
        var RATType = ctrl.radioUpgradeData.rmdtDeviceActivityData.find(function (d) {
            return d.dataCategoryId === 41;
        });
        for (var k = 0; k < ctrl.radioUpgradeData.rmdtDeviceActivityData.length; k++) {
            if (ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId == 15 && typeof RATType !== 'undefined' && RATType.value != 7) {
                var signalStrengthMin = ctrl.radioUpgradeData.rmdtDeviceActivityData.find(function (d) {
                    return d.dataCategoryId === 43;
                });
                var signalStrengthMax = ctrl.radioUpgradeData.rmdtDeviceActivityData.find(function (d) {
                    return d.dataCategoryId === 44;
                });
                ctrl.radioUpgradeData.rmdtDeviceActivityData[k].min = typeof signalStrengthMin !== 'undefined' ? signalStrengthMin.value : null;
                ctrl.radioUpgradeData.rmdtDeviceActivityData[k].max = typeof signalStrengthMax !== 'undefined' ? signalStrengthMax.value : null;

                ctrl.RMDTSignalData.push(ctrl.radioUpgradeData.rmdtDeviceActivityData[k]);
            } else if (ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId == 17 && typeof RATType !== 'undefined' && RATType.value == 7) {
                var signalQualityMin = ctrl.radioUpgradeData.rmdtDeviceActivityData.find(function (d) {
                    return d.dataCategoryId === 45;
                });
                var signalQualityMax = ctrl.radioUpgradeData.rmdtDeviceActivityData.find(function (d) {
                    return d.dataCategoryId === 46;
                });
                ctrl.radioUpgradeData.rmdtDeviceActivityData[k].min = typeof signalQualityMin !== 'undefined' ? signalQualityMin.value : null;
                ctrl.radioUpgradeData.rmdtDeviceActivityData[k].max = typeof signalQualityMax !== 'undefined' ? signalQualityMax.value : null;

                ctrl.RMDTSignalData.push(ctrl.radioUpgradeData.rmdtDeviceActivityData[k]);
            } else if (ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId == 42 && typeof RATType !== 'undefined' && RATType.value == 7) {
                var signalPowerMin = ctrl.radioUpgradeData.rmdtDeviceActivityData.find(function (d) {
                    return d.dataCategoryId === 47;
                });
                var signalPowerMax = ctrl.radioUpgradeData.rmdtDeviceActivityData.find(function (d) {
                    return d.dataCategoryId === 48;
                });
                ctrl.radioUpgradeData.rmdtDeviceActivityData[k].min = typeof signalPowerMin !== 'undefined' ? signalPowerMin.value : null;
                ctrl.radioUpgradeData.rmdtDeviceActivityData[k].max = typeof signalPowerMax !== 'undefined' ? signalPowerMax.value : null;

                ctrl.RMDTSignalData.push(ctrl.radioUpgradeData.rmdtDeviceActivityData[k]);
            } else if (ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId == 39 || ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId == 40) {
                ctrl.radioUpgradeData.rmdtDeviceActivityData[k].value = ctrl.radioUpgradeData.rmdtDeviceActivityData[k].value.toString(16);
                if (ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId == 40) ctrl.radioUpgradeData.rmdtDeviceActivityData[k].value.padStart(8, "0");
                if (ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId == 39 && typeof RATType !== 'undefined' && RATType.value == 7) {
                    ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryDesc = "Tracking Area Code";
                }
                ctrl.RMDTRadioData.push(ctrl.radioUpgradeData.rmdtDeviceActivityData[k]);
            } else if (ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId < 43 && ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId != 35 && ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId != 36 && ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId != 15 && ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId != 17 && ctrl.radioUpgradeData.rmdtDeviceActivityData[k].dataCategoryId != 42) {
                ctrl.RMDTRadioData.push(ctrl.radioUpgradeData.rmdtDeviceActivityData[k]);
            }
        }

        var objIndex = ctrl.RMDTRadioData.findIndex(function (x) {
            return x.dataCategoryId === 41;
        });
        if (objIndex >= 0) ctrl.RMDTRadioData[objIndex].value = ctrl.RMDTRadioData[objIndex].value === 7 ? ctrl.RMDTRadioData[objIndex].value = "LTE" : "3G";
    };

    ctrl.openPaging = function () {
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: ctrl.deviceSelected, windowId: $scope.windowId });
        if (!$rootScope.mobile && !$rootScope.classicView) {
            openViewService.openView('Paging', { width: 600, height: 210 + ctrl.pagingViewHeightAdjustment }, { my: 'right-10 top+6', at: 'right top', of: window }, ctrl.stickyProperties, { minimumWidth: 600, minimumHeight: 210 + ctrl.pagingViewHeightAdjustment });
        } else {
            $location.path('/paging/paging');
        }
    };

    ctrl.getPreferredTimeFormat = function (varPreferredTimeFormat) {
        ctrl.preferredTimeFormat = varPreferredTimeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.getPreferredTimeFormat(preferredTimeFormat);
        ctrl.refreshMe();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshMe();
    });

    $scope.$on("$destroy", function () {
        if (angular.isDefined(_startLiveData)) {
            $interval.cancel(_startLiveData);
            _startLiveData = undefined;
        }
    });
};

RadioUpgradeDataController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'CurrentStatusFactory', 'openViewService', '$interval', '$location'];
'use strict';

angular.module('mc.radio-upgrade-data').component('radioUpgradeData', {
    controller: RadioUpgradeDataController,
    templateUrl: 'ui/technicalsupport/radioupgradedata/radio-upgrade-data-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.mmplus-transaction-data", []);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function MmplusTransactionDataController($, $rootScope, $scope, $sce, $element, authenticationService, translationService, sharedSetupService, datetimeService, timeLapseService, mmplusTransactionDataService, CurrentStatusFactory, openViewService, $interval, $location, $timeout) {
    var ctrl = this;
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.preferredMeasurementFormat = $scope.accountInfo.preferenceUser.lookupMeasurementID;
    $scope.translation = translationService.translation;
    $scope.alerts = [];
    sharedSetupService.broadcastAllDeviceSelected($scope);
    sharedSetupService.getWindowId($scope);
    $scope.liveTable = $element.find(".headertable");
    ctrl.filterData = null;

    ctrl.loadingInProgress = true;
    var _startLiveData = void 0;
    ctrl.RMDTSignalData = [];
    ctrl.RMDTRadioData = [];
    ctrl.hasRMDTData = false;
    ctrl.networkOperator = "";
    ctrl.alertMessage = "";
    ctrl.units = [];
    ctrl.mmplusTransactionDataService = new mmplusTransactionDataService();

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        ctrl.getAccountInfo();
        ctrl.adminPortal = sharedSetupService.adminPortal();
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
    };

    ctrl.$onChanges = function (changes) {
        if (!angular.isUndefined(changes.stickyProperties) && changes.stickyProperties.currentValue && changes.stickyProperties.currentValue != changes.stickyProperties.previousValue) {
            ctrl.stickyProperties = changes.stickyProperties.currentValue;
        }
        if (typeof changes.deviceSelected !== 'undefined' && changes.deviceSelected.currentValue && changes.deviceSelected.currentValue != changes.deviceSelected.previousValue) {
            if (angular.isDefined(_startLiveData)) {
                $interval.cancel(_startLiveData);
                _startLiveData = undefined;
            }
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
            $scope.deviceSelected = changes.deviceSelected.currentValue;
            ctrl.getAccountInfo();
        }
        if (typeof changes.dateSelected !== 'undefined' && changes.dateSelected.currentValue && changes.dateSelected.currentValue != changes.dateSelected.previousValue) {
            ctrl.dateSelected = changes.dateSelected.currentValue;
            $scope.dateSelected = changes.dateSelected.currentValue;
        }
    };

    ctrl.getAccountInfo = function () {
        if (angular.isDefined(ctrl.accountInfo)) return;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.getPreferredTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
    };

    ctrl.startLiveData = function () {
        _startLiveData = $interval(function () {
            // ctrl.getRadioUpgradeData(0);
        }, 450000);
    };

    ctrl.pagingViewHeightAdjustment = 0;
    if (ctrl.mcAdminAccess) {
        ctrl.pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
    }

    ctrl.openPaging = function () {
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: ctrl.deviceSelected, windowId: $scope.windowId });
        if (!$rootScope.mobile && !$rootScope.classicView) {
            openViewService.openView('Paging', { width: 600, height: 210 + ctrl.pagingViewHeightAdjustment }, { my: 'right-10 top+6', at: 'right top', of: window }, ctrl.stickyProperties, { minimumWidth: 600, minimumHeight: 210 + ctrl.pagingViewHeightAdjustment });
        } else {
            $location.path('/paging/paging');
        }
    };

    ctrl.getPreferredTimeFormat = function (varPreferredTimeFormat) {
        ctrl.preferredTimeFormat = varPreferredTimeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.getPreferredTimeFormat(preferredTimeFormat);
        ctrl.refreshMe();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        $scope.refreshMe();
    });

    $scope.$on("$destroy", function () {
        if (angular.isDefined(_startLiveData)) {
            $interval.cancel(_startLiveData);
            _startLiveData = undefined;
        }
    });

    $scope.$watch(function () {
        return {
            width: document.getElementById("transacation-header").offsetWidth
        };
    }, function (newValue, oldValue) {
        ctrl.narrow = newValue.width <= 785 ? true : false;
        ctrl.mid = newValue.width <= 930 && newValue.width > 785 ? true : false;
        ctrl.wide = newValue.width > 930 ? true : false;
    }, true);

    var _rtuAnalogUpdateMMPlus = $rootScope.$on('rtuAnalogUpdateMMPlus', function (event, args) {
        var _dataChanged = "channelDesc, unitOfValueID, manholeDepth, sensorDepth";
        if (args.deviceId == ctrl.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
            $scope.refreshMe();
        }
    });

    ctrl.toggleData = function () {
        ctrl.filterData = ctrl.filterData == null ? .5 : null;
    };

    ctrl.checkSequenceNumber = function (i) {

        var currentSequenceNumber = $scope.mmplusTransactionDataService.items[i].sequenceNumber;

        if (currentSequenceNumber != null) {

            var result = $scope.mmplusTransactionDataService.items.slice(i + 1).find(function (obj) {
                return Boolean(obj.sequenceNumber);
            });

            if (!angular.isUndefined(result)) {
                return currentSequenceNumber - result.sequenceNumber == 1 ? "transparent" : "red";
            }
        }
        return "transparent";
    };
};

mcapp.directive('drawTransactionData', ['$rootScope', '$timeout', 'mmplusTransactionDataService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', function ($rootScope, $timeout, mmplusTransactionDataService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        if (_typeof(scope.stickyProperties) != 'object') {
            scope.stickyProperties = scope.stickyPropertiesInterface;
        }

        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        scope.trgScroll = function () {
            $timeout(function () {
                var $rowFirst = element.contents().find("tr:first");
                var _firstRow = $rowFirst.attr("name");
                if (typeof $rowFirst.position() !== "undefined") {
                    var _tableTop = element.offset().top;
                    var _rowTop = $rowFirst.offset().top;
                    _setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);
                }
            }, 0);
        };

        scope.refreshMe = function () {
            _openTableInLiveMode();
        };
        scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            if (scope.alerts.length > 0) {
                var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
                var _type = scope.alerts[0].type;
                var _languageCode = scope.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(scope.mmplusTransactionDataService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.mmplusTransactionDataService.end).utc().format('MM/DD/YY, h:mm:ss a');
                }
                scope.alerts = [];
                scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });

        $timeout(function () {
            element.on('scroll', function (event) {
                var $rowFirst = element.contents().find("tr:first");
                var $rowLast = element.contents().find("tr:last");
                if (typeof $rowFirst.position() !== "undefined") {
                    scope.infiniteScrollOn = true;scope.infiniteScrollUpOn = true;scope.infiniteScrollDownOn = true;
                    scope.trgScroll();
                    previousScrollbarPosition = currentScrollbarPosition;
                    currentScrollbarPosition = element[0].scrollTop;
                }

                if (scope.infiniteScrollOn === true) {
                    scope.infiniteScrollUpOn = true;
                    scope.infiniteScrollDownOn = true;

                    if (scope.infiniteScrollDownOn === true && element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight) {
                        $rowLast.addClass("active-row");
                        scope.mmplusTransactionDataService.alerts = [];
                        scope.mmplusTransactionDataService.nextPage();
                    }
                    if (scope.infiniteScrollUpOn === true && element[0].scrollTop < 5 && currentScrollbarPosition < previousScrollbarPosition) {
                        $rowFirst.addClass("active-row");
                        scope.mmplusTransactionDataService.alerts = [];
                        scope.mmplusTransactionDataService.previousPage();
                    }
                }

                var rows = element.children().children().children().children();
                var scrollpos = 40;
                var start = 0;
                var end = rows.length;
                var count = 0;

                while (start != end) {
                    count++;
                    var mid = start + Math.floor((end - start) / 2);
                    if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
                }
                _updateZoom(parseFloat($($(rows[start])).attr("name")));
            });
        });

        var _updateZoom = function _updateZoom(currentRow) {
            if (isNaN(currentRow)) return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            } else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () {
                    scope.liveDataIn = !scope.liveDataIn;
                }, 3000);
            }
        }, true);

        scope.$watch('mmplusTransactionDataService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        scope.newMmplusTransactionDataService = function () {
            scope.mmplusTransactionDataService = new mmplusTransactionDataService();
            scope.mmplusTransactionDataService.customerId = scope.accountInfo.customerId;
            scope.mmplusTransactionDataService.timeZone = scope.accountInfo.timeZone;
            scope.mmplusTransactionDataService.deviceId = scope.deviceSelected;
            scope.mmplusTransactionDataService.deviceType = scope.deviceSelectedType;
            scope.mmplusTransactionDataService.windowTitle = scope.windowTitle;
            scope.mmplusTransactionDataService.startRow = 1;
            scope.mmplusTransactionDataService.pageSize = 50;
            scope.mmplusTransactionDataService.alerts = [];
            scope.mmplusTransactionDataService.getUnits(); // load the units
        };

        var _openTableInLiveMode = function _openTableInLiveMode() {
            scope.stickyProperties.on = false;
            timeLapseService.getLocalDateTime().then(function (result) {
                /////////////////////////////////////////////////////////////
                var tmpDates = new Date(result.data.localDateTime);
                var tmpDatesA = tmpDates;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
                tmpDatesA.setHours(23, 59, 59, 0);
                tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
                /////////////////////////////////////////////////////////////
                scope.newMmplusTransactionDataService();
                scope.mmplusTransactionDataService.start = tmpDates.startDate;
                scope.mmplusTransactionDataService.end = tmpDatesA;
                scope.mmplusTransactionDataService.deviceType = scope.deviceSelectedType;
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + scope.unixDay, zoomMax: tmpDates.endDate - scope.unixDay, windowId: scope.windowId });
                scope.mmplusTransactionDataService.nextPage();
                /////////////////////////////////////////////////////////////
            });
        };

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                /////////////////////////////////////////////////////////////
                currentScrollbarPosition = 0;
                previousScrollbarPosition = 0;
                scope.checkFirstRowLiveStatus = null;
                /////////////////////////////////////////////////////////////
                scope.alerts = [];
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId, hasRMDTRadio: scope.hasRMDTRadio });

                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMin !== null) {
                    scope.stickyProperties.on = true;
                    timeLapseService.getLocalDateTime().then(function (result) {
                        if (scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && scope.stickyProperties.zoomMax + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                            scope.newMmplusTransactionDataService();
                            scope.mmplusTransactionDataService.start = scope.stickyProperties.dateMin - 3 * scope.unixDay; //need to extend data range;
                            scope.mmplusTransactionDataService.end = scope.stickyProperties.dateMax;
                            scope.mmplusTransactionDataService.deviceType = scope.deviceSelectedType;
                            scope.mmplusTransactionDataService.nextPage();
                        } else {
                            scope.newMmplusTransactionDataService();
                            scope.mmplusTransactionDataService.start = scope.stickyProperties.dateMin - 3 * scope.unixDay; //need to extend data range;
                            scope.mmplusTransactionDataService.end = Math.round((scope.stickyProperties.zoomMax + scope.stickyProperties.zoomMin) / 2);
                            scope.mmplusTransactionDataService.deviceType = scope.deviceSelectedType;
                            scope.mmplusTransactionDataService.nextPage();
                        }
                    });
                } else {
                    _openTableInLiveMode();
                }
            }
        }, true);

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.stickyProperties.device.serialNumber = newValue;
            }
        }, true);

        scope.$watch('dateSelected', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.selectMyDate(newValue);
            }
        }, true);

        scope.selectMyDate = function (date) {
            scope.myDate = date;
            scope.mmplusTransactionDataService = new mmplusTransactionDataService();
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            //_unRegisterListener(scope.deviceSelectedSn);
            /////////////////////////////////////////////////////////////
            var tmpDates = scope.myDate;
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
            tmpDatesA.setHours(12, 0, 0, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            scope.mmplusTransactionDataService.start = tmpDates.startDate;
            if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                scope.mmplusTransactionDataService.end = tmpDatesA;
            } else {
                scope.mmplusTransactionDataService.end = tmpDates.endDate;
            }
            /////////////////////////////////////////////////////////////
            scope.mmplusTransactionDataService.startRow = 1;
            scope.mmplusTransactionDataService.pageSize = 50;
            scope.mmplusTransactionDataService.customerId = scope.accountInfo.customerId;
            scope.mmplusTransactionDataService.timeZone = scope.accountInfo.timeZone;
            scope.mmplusTransactionDataService.deviceId = scope.deviceSelected;
            scope.mmplusTransactionDataService.windowTitle = scope.windowTitle;
            scope.mmplusTransactionDataService.deviceType = scope.deviceSelectedType;
            scope.alerts = [];
            scope.mmplusTransactionDataService.getUnits(); // load the units
            scope.mmplusTransactionDataService.nextPage();
            /////////////////////////////////////////////////////////////
            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + scope.unixDay, zoomMax: tmpDates.endDate - scope.unixDay, windowId: scope.windowId });
        };

        var _setLiveDataStatus = function _setLiveDataStatus(firstRow, liveDataStatusOn) {
            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            } else if (scope.checkFirstRowLiveStatus === null) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.checkFirstRowLiveStatus = true;
                        _checkTopOffset(liveDataStatusOn);
                    } else {
                        scope.checkFirstRowLiveStatus = false;
                    }
                });
            }
        };

        var _checkTopOffset = function _checkTopOffset(liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListener(scope.deviceSelectedSn);
            } else {
                _unRegisterListener(scope.deviceSelectedSn);
            }
        };

        scope.mostRecentData = function (event, args) {
            scope.stickyProperties.liveData = true;
            scope.myDate = null;
            scope.reconnectData(event, args);
        };

        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll();
            scope.checkFirstRowLiveStatus = null;
            scope.trgScroll();
        });

        var _autoScroll = function _autoScroll() {
            if (scope.mmplusTransactionDataService.numberOfNewRecordsPrevious > 0) {
                var trRow = element.find('tr').eq(scope.mmplusTransactionDataService.numberOfNewRecordsPrevious - 1);
                var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
                element.scrollTop(yPosition);
            } else {
                $timeout(function () {
                    element.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            scope.preferredMeasurementFormat = parseInt(measurementSystem);
            scope.mmplusTransactionDataService.timeZone = scope.accountInfo.timeZone;
            scope.mmplusTransactionDataService.scrollDown = "";
            scope.mmplusTransactionDataService.items = [];

            scope.mmplusTransactionDataService.nextPage();
        });

        scope.$on('skuidChanged', function (event, args) {
            if (scope.deviceSelectedSn !== args) return;
            scope.refreshMe();
        });

        scope.$on("$destroy", function () {
            //_unRegisterListener(scope.deviceSelectedSn);   
            scope.refreshMe();
        });
    };
}]);

mcapp.factory('mmplusTransactionDataService', ['$rootScope', '$http', 'datetimeService', 'translationService', '$sce', 'HOST', '$timeout', function ($rootScope, $http, datetimeService, translationService, $sce, HOST, $timeout) {
    var mmplusTransactionDataService = function mmplusTransactionDataService() {
        this.items = [];
        this.deviceName = '';
        this.customerId = null;
        this.deviceId = null;
        this.timeZone = "Z";
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.tdWidth = null;
        this.alerts = [];
        this.translation = translationService.translation;
        this.scrollUp = "";
        this.scrollDown = "";
        this.digitalDesc1 = "";
        this.digitalDesc2 = "";
        this.showLowFloat = true;
        this.levelDesc = "";
        this.levelUnit = "";
        this.levelUnitDesc = "";
        this.hasAnalog = "";
        this.units = [];
    };
    mmplusTransactionDataService.prototype.getUnits = function () {
        var _this2 = this;

        var url = HOST + '/api/Units';
        $http.get(url).then(function (result) {
            _this2.units = result.data;
        }, function () {});
    };
    mmplusTransactionDataService.prototype.previousPage = function () {
        var intDayWindow = 10;
        var intDay = 86400000;
        this.alerts = [];
        if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
        this.busy = true;
        this.pageSize = -50;

        if (this.items.length > 0) {
            var tmpEndDate = datetimeService.toUnixtimeMs(this.items[0].transactionDateTime.replace(/\D/g, ''));
            this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].transactionDateTime.replace(/\D/g, '')) - intDayWindow * intDay;
            this.end = this.end > tmpEndDate ? this.end : tmpEndDate;
        }

        //from is: very top record
        var url = HOST + '/api/MMPlusTransactionData?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&endDate=' + this.end + "&pageSize=" + this.pageSize + "&fromDate=" + this.scrollUp;
        $http.get(url).then(function (result) {
            var _this3 = this;

            /////////////////////////

            var intDayWindow = 10;
            var intDay = 86400000;
            /////////////////////////
            // this.items = items.concat(this.items);
            var items = result.data.transactionData;
            this.digitalDesc1 = result.data.digitalDescription1;
            this.digitalDesc2 = result.data.digitalDescription2;
            this.levelDesc = result.data.levelDescription;
            this.levelUnit = result.data.levelUnitOfValueId; // this is numeric value
            this.hasAnalog = result.data.hasAnalog;
            this.showLowFloat = result.data.showLowFloat;
            this.numberOfNewRecordsPrevious = items.length;
            this.numberOfRecords = this.items.length;
            this.startRow = this.startRow + items.length;
            this.levelUnitDesc = this.units.find(function (unit) {
                return unit.unitOfValueId == _this3.levelUnit;
            }).unitOfValueDesc;
            for (var j = 0; j < items.length; j++) {
                this.items.unshift(items[j]);
            }
            if (items.length > 0 || this.items.length > 0) {
                //if there are records returned
                var tmpEndDate = datetimeService.toUnixtimeMs(this.items[0].transactionDateTime.replace(/\D/g, ''));
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].transactionDateTime.replace(/\D/g, '')) - intDayWindow * intDay;
                this.end = this.end > tmpEndDate ? this.end : tmpEndDate;

                for (var k = 0; k < this.items.length; k++) {
                    if (k != this.items.length - 1 && this.items[k].sequenceNumber - this.items[k + 1].sequenceNumber > 1) {
                        this.items[k].background = '#FF4040';
                    }
                }
            } else {
                this.alerts = [];
                var errorMessage = "No data available";
                this.alerts.push({ msg: errorMessage, type: "info" });
            }

            if (this.items.length > 0) {
                this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].transactionDateTime.replace(/\D/g, ''));
                this.scrollDown = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].transactionDateTime.replace(/\D/g, ''));
            } else {
                this.scrollUp = "";
                this.scrollDown = "";
            }

            this.pageSize = 50;
            var _this = this;
            this.fn = $timeout(function () {
                _this.busy = false;
            }, 1000);
        }.bind(this), function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({ msg: errorMessage, type: "danger" });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };

    mmplusTransactionDataService.prototype.nextPage = function () {
        var intDayWindow = 10;
        var intDay = 86400000;
        this.alerts = [];
        if (this.busy || this.numberOfReturnedRecords === 0) return;
        this.busy = true;

        if (this.items.length > 0) {
            var tmpEndDate = datetimeService.toUnixtimeMs(this.items[0].transactionDateTime.replace(/\D/g, ''));
            this.end = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].transactionDateTime.replace(/\D/g, ''));
            // this.end = this.end > tmpEndDate ? this.end : tmpEndDate;
        }
        //from is: very bottom record

        var url = HOST + '/api/MMPlusTransactionData?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&endDate=' + this.end + "&pageSize=" + this.pageSize + "&fromDate=" + this.scrollDown;
        $http.get(url).then(function (result) {
            var _this4 = this;

            /////////////////////////
            var intDayWindow = 10;
            var intDay = 86400000;
            this.alerts = [];
            /////////////////////////
            var items = result.data.transactionData;
            this.digitalDesc1 = result.data.digitalDescription1;
            this.digitalDesc2 = result.data.digitalDescription2;
            this.levelDesc = result.data.levelDescription;
            this.levelUnit = result.data.levelUnitOfValueId; // this is numeric value
            this.hasAnalog = result.data.hasAnalog;
            this.showLowFloat = result.data.showLowFloat;
            this.levelUnitDesc = this.units.find(function (unit) {
                return unit.unitOfValueId == _this4.levelUnit;
            }).unitOfValueDesc;

            if (items.length > 0 && this.items.length > 0 && items[0].transactionDateTime.replace(/\D/g, '') == this.items[this.items.length - 1].transactionDateTime.replace(/\D/g, '')) {
                this.items.splice(this.items.length - 1, 1);
            }
            this.items = this.items.concat(items);
            this.numberOfReturnedRecords = items.length;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) {
                //if there are records returned
                var tmpEndDate = datetimeService.toUnixtimeMs(this.items[0].transactionDateTime.replace(/\D/g, ''));
                this.end = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].transactionDateTime.replace(/\D/g, ''));
                //this.end = this.end > tmpEndDate ? this.end : tmpEndDate;
            } else {
                // If we didn't get any items back AND there aren't already any items
                if (this.items.length === 0) {
                    this.alerts = [];
                    var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                    this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            }

            if (this.items.length > 0) {
                this.scrollUp = datetimeService.toUnixtime(this.items[0].transactionDateTime.replace(/\D/g, ''));
                this.scrollDown = datetimeService.toUnixtime(this.items[this.items.length - 1].transactionDateTime.replace(/\D/g, ''));
            } else {
                this.scrollUp = "";
                this.scrollDown = "";
            }

            this.pageSize = 50;
            var _this = this;
            this.fn = $timeout(function () {
                _this.busy = false;
            }, 1000);
        }.bind(this), function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({ msg: errorMessage, type: "danger" });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };
    return mmplusTransactionDataService;
}]);

MmplusTransactionDataController.$inject = ['$', '$rootScope', '$scope', '$sce', '$element', 'authenticationService', 'translationService', 'sharedSetupService', 'datetimeService', 'timeLapseService', 'mmplusTransactionDataService', 'CurrentStatusFactory', 'openViewService', '$interval', '$location', '$timeout'];
'use strict';

angular.module('mc.mmplus-transaction-data').component('mmplusTransactionData', {
    controller: MmplusTransactionDataController,
    templateUrl: 'ui/technicalsupport/mmplustransactiondata/mmplus-transaction-data-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        dateSelected: '<'
    }
});
'use strict';

angular.module('mc.signal-chart', []);
'use strict';

function SignalChartFactory(HOST, $http) {
    var SignalChartFactory = {};
    var _getData = function _getData(varParm) {
        return $http({
            method: 'GET',
            url: HOST + '/api/SignalChart?' + varParm,
            cache: false
        });
    };
    SignalChartFactory.getData = _getData;
    return SignalChartFactory;
}

SignalChartFactory.$inject = ['HOST', '$http'];

angular.module('mc.signal-chart').factory('SignalChartFactory', SignalChartFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function SignalChartController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, timeLapseService, datetimeService, $timeout, $filter, $element, SaveDesktopSettingService, SignalChartFactory, rangeSelectorService, websocketService) {
    var ctrl = this;
    var chart;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        ctrl.devicename = null;
        ctrl.myDate = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.TimeFormatEnum = { Civilian: 1, Military: 2 };
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.liveDataOffset = 20 * 60 * 1000;
        ctrl.minPadding = 0;
        ctrl.maxPadding = 0;
        ctrl.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        ctrl.loadingInProgress = true;
        ctrl.translation = translationService.translation;
        sharedSetupService.broadcastAllDeviceSelected($scope);
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = ctrl.stickyProperties;

        ctrl.downloadViewTypeOptions = [0, 1];
        ctrl.xValue = null;
        ctrl.initialLoad = true;
        ctrl.scrollingInProgress = false;
        ctrl.element = $element.find('.vfs-chart');

        ctrl.element.on('mousewheel', function (event) {
            if (!ctrl.scrollingInProgress) ctrl.mouseWheelZoom(event, chart, ctrl.xValue);
        });

        if (!ctrl.mobile && !ctrl.classicView && ctrl.windowId != ctrl.stickyProperties.deviceId) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                var _char = ctrl.popup.parent().find('.chart').highcharts();
                if (ctrl.popup.parent().find(".chart").highcharts()) {
                    $timeout(function () {
                        _char.reflow();
                    }, 600);
                }
            };
        }
    };

    $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            ctrl.liveDataIn = !ctrl.liveDataIn;
            $timeout(function () {
                ctrl.liveDataIn = !ctrl.liveDataIn;
            }, 3000);
        }
    }, true);

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceSelected = newValue;
            var tmpDates,
                tmpStartDate = null,
                tmpEndDate = null;
            ctrl.loadingInProgress = true;
            ctrl.saveDesktopSettingService = new SaveDesktopSettingService(newValue, ctrl.windowId);

            if (ctrl.stickyProperties.setting && ctrl.stickyProperties.setting.savedDesktop) {
                ctrl.savedDesktopSetting = ctrl.stickyProperties.setting;
            } else {
                ctrl.savedDesktopSetting = ctrl.saveDesktopSettingService.getObject();
            }

            if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.dateMax !== null) {
                ctrl.stickyProperties.on = true;
                tmpStartDate = ctrl.stickyProperties.dateMin;
                tmpEndDate = ctrl.stickyProperties.dateMax;
            } else {
                ctrl.stickyProperties.on = false;
            }

            if (!tmpStartDate) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    tmpDates = new Date(result.data.localDateTime);
                    tmpDates.setHours(0, 0, 0, 0);
                    tmpDates = datetimeService.dateToUnixtime(tmpDates);
                    tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                    tmpDates = datetimeService.startEndLocalToUtc(tmpDates, ctrl.accountInfo.timeZone);
                    tmpStartDate = tmpDates.startDate;
                    tmpEndDate = tmpDates.endDate;
                    _getData(newValue, tmpStartDate, tmpEndDate);
                });
            } else {
                _getData(newValue, tmpStartDate, tmpEndDate);
            }
        }
    }, true);

    $scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
        if (newValue) ctrl.deviceSelectedSn = newValue;
        if (newValue && newValue != oldValue) {
            ctrl.stickyProperties.device.serialNumber = newValue;
            if (oldValue) {
                _unRegisterListener(oldValue);
            }
        }
    }, true);

    $scope.$on('updatePreferencesLanguage', function () {
        _drawChart();
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.applyTimeFormat(timeFormat);
        _drawChart();
    });

    ctrl.applyTimeFormat = function (timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat);
    };

    $scope.$on("$destroy", function () {
        _unRegisterListener(ctrl.deviceSelectedSn);
        if (chart) chart.destroy();
        if (!angular.isUndefined(ctrl.stickyProperties.setting)) ctrl.stickyProperties.setting = null;
    });

    ctrl.selectMyDate = function (date) {
        ctrl.myDate = date;
        var tmpDates = ctrl.myDate;
        ctrl.loadingInProgress = true;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
        tmpDates = datetimeService.startEndLocalToUtc(tmpDates, ctrl.accountInfo.timeZone);
        _getData(ctrl.deviceSelected, tmpDates.startDate, tmpDates.endDate);
    };

    ctrl.zoomAdjust = function (varDay) {
        var extremes = chart.xAxis[0].getExtremes();
        var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, ctrl.heartbeatLocalDateTime);
        chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
        _setLiveDataStatus();
    };

    ctrl.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    var _getData = function _getData(deviceId, StartDate, EndDate) {
        ctrl.liveDataEndDate = EndDate;
        var _device = { deviceName: $scope.deviceSelectedName };
        SignalChartFactory.getData('customerID=' + ctrl.accountInfo.customerId + '&deviceId=' + deviceId + '&startDate=' + StartDate + '&EndDate=' + EndDate).then(function (datafromFactory) {
            if (datafromFactory.data.data && datafromFactory.data.data.length === 0) {
                datafromFactory.data.data.push([StartDate, null]);
                datafromFactory.data.data.push([EndDate, null]);
            }
            ctrl.chartData = datafromFactory.data.data;
            ctrl.qualityData = datafromFactory.data.signalQualityData;
            ctrl.powerData = datafromFactory.data.signalPowerData;
            ctrl.devicename = datafromFactory.data.device.name;
            ctrl.signalStrengthParam = datafromFactory.data.device.signalStrengthParameter;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, windowId: ctrl.windowId });
            _drawChart();
        }, function (datafromFactory) {
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, windowId: ctrl.windowId });
            ctrl.element.empty();
            chart = null;
            ctrl.loadingInProgress = false;
            ctrl.alerts.push({ msg: "No data available!", type: "danger" });
        });
    };

    var _drawChart = function _drawChart() {
        var tmpData = ctrl.chartData;
        var qualityTmpData = ctrl.qualityData;
        var powerTmpData = ctrl.powerData;
        var chartDrawn = false;

        var chartXaxisHourFormat = ctrl.preferredTimeFormat === ctrl.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
        var chartToolTipHourFormat = ctrl.preferredTimeFormat === ctrl.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

        var firstSerie = ($scope.deviceSelectedType === 17 || $scope.deviceSelectedType === 18 || $scope.deviceSelectedType === 19 || $scope.deviceSelectedType === 20 || $scope.deviceSelectedType === 21) && $scope.hasRMDTRadio ? 0 : 1;
        var secondSerie = $scope.deviceSelectedType === 20 || $scope.deviceSelectedType === 21 || $scope.hasRMDTRadio ? 1 : 0;
        var thirdSerie = $scope.hasRMDTRadio ? 1 : 0;

        var numberOfSeries = firstSerie + secondSerie + thirdSerie;
        var numberOfHiddenSeries = 0;

        chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: true, // (scope.deviceSelectedType === 20 || scope.deviceSelectedType === 21 || scope.hasRMDTRadio) ? true : false,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1
            },
            time: {
                getTimezoneOffset: function getTimezoneOffset(timestamp) {
                    return -moment.tz(timestamp, datetimeService.getTimeZoneId(ctrl.accountInfo.timeZone)).utcOffset();
                }
            },
            chart: {
                renderTo: ctrl.element[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1,
                borderRadius: 2,
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                marginRight: 10,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                spacingRight: 5,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {
                        if (this.options.chart.forExport) return false;
                        var tmpDates,
                            extremes = this.xAxis[0].getExtremes();

                        if (this.xAxis && chartDrawn === true && ctrl.scrollingInProgress === false) {
                            if (extremes && extremes.dataMin >= extremes.min - ctrl.liveDataOffset) {
                                ctrl.scrollingInProgress = true;
                                this.showLoading();

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -1);

                                SignalChartFactory.getData('customerID=' + ctrl.accountInfo.customerId + '&deviceId=' + ctrl.deviceSelected + '&startDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromFactory) {
                                    //if signal data is valid
                                    if (datafromFactory.data.data) {
                                        if (datafromFactory.data.data.length === 0) {
                                            datafromFactory.data.data.push([tmpDates.startDate, null]);
                                        } else {
                                            tmpData = datafromFactory.data.data.concat(tmpData);
                                            chart.series[2].setData(tmpData);
                                        }
                                    }
                                    // if Quality data is valid
                                    if (datafromFactory.data.signalQualityData != null) {
                                        qualityTmpData = datafromFactory.data.signalQualityData.concat(qualityTmpData);
                                        chart.series[0].setData(qualityTmpData);
                                    }
                                    //if power data is valid
                                    if (datafromFactory.data.signalPowerData != null) {

                                        powerTmpData = datafromFactory.data.signalPowerData.concat(powerTmpData);
                                        chart.series[1].setData(powerTmpData);
                                    }

                                    $scope.devicename = datafromFactory.data.device.name;
                                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: ctrl.deviceSelected, dataMin: tmpDates.startDate, windowId: ctrl.windowId });
                                    chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
                                    _setLiveDataStatus();
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    chart.hideLoading();
                                }, function (datafromFactory) {
                                    var uiErrorMessage = userMessageService.getUiErrorMessage(datafromFactory.data.message);
                                    toaster.pop('error', $scope.windowTitle, uiErrorMessage);
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    chart.hideLoading();
                                });
                            } else if (ctrl.liveData === false && extremes && extremes.max + ctrl.liveDataOffset >= extremes.dataMax) {
                                ctrl.scrollingInProgress = true;
                                this.showLoading();

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 1);

                                SignalChartFactory.getData('customerID=' + ctrl.accountInfo.customerId + '&deviceId=' + ctrl.deviceSelected + '&startDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromFactory) {
                                    //if signal data is valid
                                    if (datafromFactory.data.data) {
                                        if (datafromFactory.data.data.length === 0) {
                                            var tmpCheckDate = datetimeService.dateToUnixtime(new Date()); //will get it from time-lapse-service when changed to keep track of local time internally
                                            if (tmpDates.endDate < tmpCheckDate) {
                                                datafromFactory.data.data.push([tmpDates.endDate, null]);
                                            }
                                        } else {
                                            var tmpDataNew = datafromFactory.data.data;
                                            tmpData = tmpData.concat(tmpDataNew);
                                            chart.series[2].setData(tmpData);
                                        }
                                    }
                                    // if quality data is valid
                                    if (datafromFactory.data.signalQualityData != null) {
                                        var qualityTmpDataNew = datafromFactory.data.signalQualityData;
                                        qualityTmpData = qualityTmpData.concat(qualityTmpDataNew);
                                        chart.series[0].setData(qualityTmpData);
                                    }
                                    //if power data is valid
                                    if (datafromFactory.data.signalPowerData != null) {
                                        var powerTmpDataNew = datafromFactory.data.signalPowerData;
                                        powerTmpData = powerTmpData.concat(powerTmpDataNew);
                                        chart.series[1].setData(powerTmpData);
                                    }
                                    $scope.devicename = datafromFactory.data.device.name;
                                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: ctrl.deviceSelected, dataMax: tmpDates.endDate, windowId: ctrl.windowId });
                                    chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
                                    _setLiveDataStatus(tmpDates.endDate);
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    chart.hideLoading();
                                }, function (datafromFactory) {
                                    var uiErrorMessage = userMessageService.getUiErrorMessage(datafromFactory.data.message);
                                    toaster.pop('error', $scope.windowTitle, uiErrorMessage);
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    chart.hideLoading();
                                });
                            }
                        }
                    },
                    load: function load(event) {
                        if (ctrl.initialLoad) openViewService.adjustContentSize(ctrl.popup);
                        ctrl.initialLoad = false;
                        $timeout(function () {
                            ctrl.saveDesktopSettingService.applySavedDesktopSetting(chart, ctrl, true);
                        }, 0);
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: false
            },
            xAxis: {
                title: {
                    text: ctrl.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 3,
                    color: 'green',
                    dashStyle: "solid",
                    zIndex: 1
                }],
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minTickInterval: 3600 * 1000,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                dateTimeLabelFormats: {
                    hour: chartXaxisHourFormat
                },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (chartDrawn === true) {
                            var extremes = chart.xAxis[0].getExtremes();
                            if (ctrl.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) {
                                //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                if (extremes.max + ctrl.liveDataOffset <= extremes.dataMax) {
                                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: false, windowId: ctrl.windowId });
                                    _unRegisterListener(ctrl.deviceSelectedSn);
                                }
                            }
                            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { zoomMin: extremes.min, zoomMax: extremes.max, windowId: ctrl.windowId });
                        }
                    }
                }
            },
            yAxis: [{
                min: ctrl.signalStrengthParam.toLowerCase() == "rssi" ? -130 : -145,
                max: ctrl.signalStrengthParam.toLowerCase() == "rssi" ? -65 : -40,
                title: {
                    text: ctrl.translation.text.SIGNAL + ' (dBm)',
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                opposite: false,
                allowDecimals: false,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                showFirstLabel: true,
                showLastLabel: true,
                lineWidth: 2,
                lineColor: "#2288cc",
                labels: {
                    align: 'right',
                    y: 8,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '10px'
                    },
                    formatter: function formatter() {
                        return this.value;
                    }
                },
                visible: $scope.deviceSelectedType === 21 || ($scope.deviceSelectedType === 17 || $scope.deviceSelectedType === 18 || $scope.deviceSelectedType === 19 || $scope.deviceSelectedType === 20) && $scope.hasRMDTRadio ? false : true
            }, {
                min: null,
                max: null,
                title: {
                    text: ctrl.translation.text.SIGNAL_POWER + ' (dBm)',
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                opposite: false,
                allowDecimals: false,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                showFirstLabel: true,
                showLastLabel: true,
                lineWidth: 2,
                lineColor: "#ddaa00",
                labels: {
                    align: 'right',
                    y: 8,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '10px'
                    },
                    formatter: function formatter() {
                        return this.value;
                    }
                },
                visible: $scope.hasRMDTRadio || $scope.deviceSelectedType === 21
            }, {
                min: null,
                max: null,
                title: {
                    text: ctrl.translation.text.SIGNAL_QUALITY + ' (dB)',
                    style: {
                        color: '#6D869F', //GRAY
                        fontWeight: 'bold'
                    }
                },
                opposite: false,
                allowDecimals: false,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                showFirstLabel: true,
                showLastLabel: true,
                lineWidth: 2,
                lineColor: "#660000", //Dark RED
                labels: {
                    align: 'right',
                    y: 8,
                    style: {
                        color: '#6D869F', //GRAY
                        fontWeight: 'bold',
                        fontSize: '10px'
                    },
                    formatter: function formatter() {
                        return this.value;
                    }
                },
                visible: $scope.deviceSelectedType === 20 || $scope.deviceSelectedType === 21 || $scope.hasRMDTRadio ? true : false
            }],
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var d = new Date(this.x);
                    var s = '';
                    s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, ctrl.accountInfo.timeZone)) + '</td></tr>';
                    $.each(this.points, function (i, point) {
                        var measurmentType = point.series.name == "Signal Quality" ? ' dB' : ' dBm';
                        s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ' : <span style="color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, 0) + measurmentType + ' </span></tr>';
                        ctrl.xValue = point.x;
                    });
                    s += '</table>';
                    return s;
                },
                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 5,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
            },
            plotOptions: {
                series: {
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                ctrl.xValue = this.x;
                            }
                        }
                    },
                    marker: {
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    events: {
                        legendItemClick: function legendItemClick() {
                            numberOfSeries = chart.series.length - 1;
                            var visibility = this.visible ? 'visible' : 'hidden';
                            numberOfHiddenSeries = visibility === 'hidden' ? numberOfHiddenSeries - 1 : numberOfHiddenSeries + 1;
                            numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                            if (numberOfHiddenSeries < numberOfSeries) {
                                chart.yAxis[this.index].update({
                                    labels: {
                                        // enabled: visibility !== 'visible',
                                    },
                                    title: {
                                        // text: visibility === 'visible' ? null : self.series[this.index].name,
                                    }
                                    //lineWidth: visibility === 'visible' ? 0 : 2,
                                });
                                return true;
                            }
                            numberOfHiddenSeries = numberOfHiddenSeries - 1;
                            return false;
                        },
                        mouseOut: function mouseOut() {
                            ctrl.xValue = null;
                        }
                    }
                }
            },
            series: [{
                id: 0,
                name: ctrl.translation.text.SIGNAL_QUALITY,
                color: '#660000', //Dark Red
                shadow: false,
                data: ctrl.qualityData,
                lineWidth: 2,
                marker: {
                    enabled: null,
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#FFFFFF',
                    lineWidth: 1,
                    lineColor: null // inherit from series
                },
                yAxis: 2,
                visible: $scope.deviceSelectedType === 17 || $scope.deviceSelectedType === 21 || ($scope.deviceSelectedType === 18 || $scope.deviceSelectedType === 19 || $scope.deviceSelectedType === 20) && $scope.hasRMDTRadio ? true : false,
                showInLegend: $scope.deviceSelectedType === 17 || $scope.deviceSelectedType === 21 || ($scope.deviceSelectedType === 18 || $scope.deviceSelectedType === 19 || $scope.deviceSelectedType === 20) && $scope.hasRMDTRadio ? true : false
            }, {
                id: 1,
                name: ctrl.translation.text.SIGNAL_POWER,
                color: '#ddaa00',
                shadow: false,
                data: ctrl.powerData,
                lineWidth: 2,
                marker: {
                    enabled: null,
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#FFFFFF',
                    lineWidth: 1,
                    lineColor: null // inherit from series
                },
                yAxis: 1,
                visible: $scope.hasRMDTRadio || $scope.deviceSelectedType === 21
            }, {
                id: 2,
                name: ctrl.translation.text.SIGNAL,
                color: '#2288cc',
                shadow: false,
                data: ctrl.chartData,
                lineWidth: 2,
                marker: {
                    enabled: null,
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#FFFFFF',
                    lineWidth: 2,
                    lineColor: null // inherit from series
                },
                yAxis: 0,
                visible: $scope.deviceSelectedType === 17 || $scope.deviceSelectedType === 21 || ($scope.deviceSelectedType === 18 || $scope.deviceSelectedType === 19 || $scope.deviceSelectedType === 20) && $scope.hasRMDTRadio ? false : true,
                showInLegend: $scope.deviceSelectedType === 17 || $scope.deviceSelectedType === 21 || ($scope.deviceSelectedType === 18 || $scope.deviceSelectedType === 19 || $scope.deviceSelectedType === 20) && $scope.hasRMDTRadio ? false : true
            }]
        });

        $scope.chart = chart;
        $scope.series = chart.series;

        var tmpNewDateA;
        var tmpNewDateB;
        var extremes = chart.xAxis[0].getExtremes();

        if (ctrl.stickyProperties.on === true && ctrl.stickyProperties.mostRecentData === undefined) {
            tmpNewDateA = ctrl.stickyProperties.zoomMin >= extremes.dataMin ? ctrl.stickyProperties.zoomMin : extremes.dataMin; //extremes.dataMin + scope.unixDay / 24 * 3;
            tmpNewDateB = ctrl.stickyProperties.zoomMax <= extremes.dataMax + ctrl.liveDataOffset ? ctrl.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + ctrl.unixDay / 24 ? tmpNewDateB : extremes.dataMax - ctrl.unixDay / 24 * 12;
            ctrl.stickyProperties.on = false;
        } else {
            ctrl.stickyProperties.mostRecentData = undefined;
            tmpNewDateA = ctrl.myDate !== null ? extremes.dataMin + ctrl.unixDay : extremes.dataMax - ctrl.unixDay / 24 * 12;
            tmpNewDateB = ctrl.myDate !== null ? tmpNewDateA + ctrl.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - ctrl.unixDay;
            }
            tmpNewDateA = tmpNewDateA + ctrl.minPadding;
            tmpNewDateB = tmpNewDateB + ctrl.maxPadding;
        }

        chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: ctrl.deviceSelected, zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: ctrl.windowId });
        _setLiveDataStatus();
        chartDrawn = true;
        ctrl.loadingInProgress = false;
    };

    var tlDataReceivedSIGNAL = function tlDataReceivedSIGNAL(data) {
        data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, ctrl.accountInfo.timeZone);

        if (ctrl.liveData === false) {
            _unRegisterListener(ctrl.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - ctrl.unixDay / 2) {
            _unRegisterListener(ctrl.deviceSelectedSn);
            return;
        }

        var liveDataLine = chart.xAxis[0].plotLinesAndBands;
        liveDataLine[0].options.value = data.Unix + ctrl.maxPadding;

        if (extremes.max + ctrl.liveDataOffset > extremes.dataMax) chart.xAxis[0].setExtremes(data.Unix - tmpRange + ctrl.minPadding, data.Unix + ctrl.maxPadding);
    };

    var _setLiveDataStatus = function _setLiveDataStatus(varEndDate) {
        ctrl.liveDataEndDate = varEndDate != null ? varEndDate : ctrl.liveDataEndDate;
        timeLapseService.getLocalDateTime().then(function (result) {
            ctrl.heartbeatLocalDateTime = result.data.unixTimeStamp;
            var extremes = typeof chart.xAxis != "undefined" ? chart.xAxis[0].getExtremes() : null;
            if (extremes != null && ctrl.liveDataEndDate > result.data.unixTimeStamp && ctrl.stickyProperties.zoomMax + ctrl.liveDataOffset >= extremes.dataMax) {
                _registerListener(ctrl.deviceSelectedSn);
                var data = { Unix: result.data.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedSIGNAL(data);
            } else {
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: false, windowId: ctrl.windowId });
                _unRegisterListener(ctrl.deviceSelectedSn);
            }
        });
    };

    var _registerListener = function _registerListener(varSelectedSN) {
        websocketService.connect();
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: true, windowId: ctrl.windowId });
        websocketService.register("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, null);
        timeLapseService.register("SIGNAL", varSelectedSN, "", tlDataReceivedSIGNAL);
        timeLapseService.register("SIGNALPOWER", varSelectedSN, "", tlDataReceivedSIGNAL);
        timeLapseService.register("SIGNALQUALITY", varSelectedSN, "", tlDataReceivedSIGNAL);
        ctrl.liveData = true;
    };

    var _unRegisterListener = function _unRegisterListener(varSelectedSN) {
        websocketService.unRegister("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, null);
        timeLapseService.unRegister("SIGNAL", varSelectedSN, "", tlDataReceivedSIGNAL);
        timeLapseService.unRegister("SIGNALPOWER", varSelectedSN, "", tlDataReceivedSIGNAL);
        timeLapseService.unRegister("SIGNALQUALITY", varSelectedSN, "", tlDataReceivedSIGNAL);
        ctrl.liveData = false;
        ctrl.lastUpdateAt = undefined;
    };

    var wsDataReceivedSIGNAL = function wsDataReceivedSIGNAL(data) {

        if (ctrl.liveData === false) {
            _unRegisterListener(ctrl.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        var str = data.Time + "";
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, ctrl.accountInfo.timeZone);

        var varValue = parseInt(data.Value);
        var signlaType = data.Type;
        for (var k = 0; k < chart.series.length; k++) {
            var seriesType = chart.series[k].name.replace(/\s/g, '').toUpperCase();
            if (signlaType == seriesType) {
                chart.series[k].addPoint([unixtime, varValue]); //, true, false, true
            }
        }

        if (extremes.max + ctrl.liveDataOffset > extremes.dataMax) chart.xAxis[0].setExtremes(unixtime - tmpRange + ctrl.minPadding, unixtime + ctrl.maxPadding);
        var varTime = datetimeService.socketStrToServerStrTime(data.Time);
        ctrl.lastUpdateAt = varTime;
    };
}

SignalChartController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'timeLapseService', 'datetimeService', '$timeout', '$filter', '$element', 'SaveDesktopSettingService', 'SignalChartFactory', 'rangeSelectorService', "websocketService"];
'use strict';

angular.module('mc.signal-chart').component('signalChart', {
    controller: SignalChartController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/signal/chart/signal-chart-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        deviceSelectedSn: '<',
        myDate: '<'
    }
});
'use strict';

angular.module('mc.runtime', []);
'use strict';

function RuntimeVarianceController(REPORTS, $scope, $location, $http, $element, $filter, $timeout, $window, authenticationService, datetimeService, translationService, sharedSetupService, openViewService, savePdfService, toaster) {
    var _this2 = this;

    var ctrl = this;
    this.loading = true;

    this.$onInit = function () {
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        $scope.windowId = _this2.windowId;
        $scope.windowTitle = 'Runtime Variance';
        $scope.stickyProperties = _this2.stickyProperties;
        $scope.alerts = [];
        _this2.alerts = [];
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        _this2.devices = [];
        _this2.noDevices = true;
        _this2.previousPumpNumber = null;
        sharedSetupService.getWindowId(_this2);
        _this2.chartMaxWidth = $($element).find('#runtime-variance-max-width').width();
        _this2.adjustSizeTimeout = false;
        _this2.resizingModal = false;
        _this2.chartReady = true;
        $scope.downloadViewTypeOptions = [0, 1, 2];

        if (/Edge\/\d./i.test(navigator.userAgent)) {
            _this2.isEdge = true;
        }

        _this2.isFF = !!navigator.userAgent.match(/firefox/i);

        if (!_this2.mobile && !_this2.classicView) {
            _this2.qdpLeft = -237;
            _this2.popup = _this.getExistingDialog(_this2.windowId).ref;
            sharedSetupService.maximize(_this2.popup);
        }

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                _this2.resizingModal = true;
                _this2.chartReady = false;
                if (_this2.adjustSizeTimeout) {
                    $timeout.cancel(_this2.adjustSizeTimeout);
                }

                _this2.adjustSizeTimeout = $timeout(function () {
                    _this2.chartMaxWidth = $($element).find('#runtime-variance-max-width').width();
                    $timeout(function () {
                        _this2.resizingModal = false;
                    }, 0);
                    $timeout(function () {
                        _this2.activeChart = $($element).find('#runtime-variance-chart-scroll');
                        _this2.activeChartMenu = $(_this2.activeChart).find('.top-menu');
                        $(_this2.activeChart).css("margin-left", $(_this2.scrollElement).scrollLeft());
                        $(_this2.activeChartMenu).css("width", _this2.chartMaxWidth - 10);
                        _this2.chartReady = true;
                    }, 50);
                }, 500);
            };
        }

        _this2.endDate = new Date();
        _this2.endDate = _this2.endDate.setHours(0, 0, 0, 0);
        _this2.getData(_this2.endDate, _this2.accountInfo.customerId, _this2.accountInfo.timeZone);
    };

    this.getData = function (endDate, customerId, timeZone) {
        _this2.setDateRangeMessage(endDate);
        $http.get(REPORTS + "/api/RuntimeVariance" + "?customerId=" + customerId + "&endDate=" + endDate + "&timeZone=" + timeZone).then(function (resp) {

            _this2.alerts = [];

            _this2.allDevices = resp.data;

            if (_this2.allDevices.length === 0) {
                $scope.alerts.push({
                    msg: _this2.translation.text.NO_DEVICES_CONFIGURED,
                    type: 'info',
                    languageCode: 'NO_DEVICES_CONFIGURED'
                });
                _this2.alerts.push({
                    msg: _this2.translation.text.NO_DEVICES_CONFIGURED,
                    type: 'info',
                    languageCode: 'NO_DEVICES_CONFIGURED'
                });
                return;
            }
            _this2.maxPumps = 0;
            _this2.repatPumpColumns = [];
            for (var i = 0; i < _this2.allDevices.length; i++) {
                _this2.allDevices[i].hasPump3 = true;

                _this2.allDevices[i].hasPumps = !(_this2.allDevices[i].inputMode.indexOf('P') === -1);
                if (_this2.allDevices[i].inputMode.indexOf('P') !== -1) {
                    _this2.noDevices = false;
                }
                if (_this2.allDevices[i].maxPumps > _this2.maxPumps) {
                    _this2.maxPumps = _this2.allDevices[i].maxPumps;
                }
            }
            for (var k = 0; k < _this2.maxPumps; k++) {
                _this2.repatPumpColumns.push(k);
            }
            if (_this2.noDevices) {
                _this2.alerts.push({
                    msg: _this2.translation.text.NO_DEVICES_CONFIGURED,
                    type: 'info',
                    languageCode: 'NO_DEVICES_CONFIGURED'
                });
            }
            //Get Scroll element for Chart
            $timeout(function () {
                _this2.scrollElement = $($element).find(".data-pane")[0];
            }, 0);

            _this2.loading = false;
        });
    };

    this.mostRecentData = function () {
        _this2.currentDeviceId = null;
        _this2.currentPumpNumber = null;
        _this2.myDate = null;
        _this2.loading = true;
        var endDate = new Date();
        endDate = endDate.setHours(0, 0, 0, 0);
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        _this2.getData(endDate, _this2.accountInfo.customerId, _this2.accountInfo.timeZone);
    };

    this.selectMyDate = function () {
        _this2.currentDeviceId = null;
        _this2.currentPumpNumber = null;
        var endDate = _this2.myDate.setHours(0, 0, 0, 0);
        _this2.endDate = endDate;
        _this2.loading = true;
        _this2.getData(endDate, _this2.accountInfo.customerId, _this2.accountInfo.timeZone);
    };

    this.getScrollOffset = function () {
        if (_this2.isEdge) {
            return 12;
        }

        return 18;
    };

    this.hasOverflow = function () {
        if (_this2.classicView) {
            return true;
        }

        var element = document.getElementById('runtime-variance-body');
        if (!element || _this2.mobile) {
            return false;
        }

        if (element.offsetHeight < element.scrollHeight) {
            return true;
        }

        return false;
    };

    this.nullOrZero = function (value, precision, isPump3) {
        if (value !== null) {
            return $filter('number')(value, precision);
        }

        if (isPump3) {
            return '-';
        }

        return $filter('number')(0, precision);
    };

    //Mean/Deviation cover the 30 days ending the day before endDate, which is also the Current Pump day
    this.setDateRangeMessage = function (endDate) {
        _this2.meanStartDate = moment(endDate).subtract(30, 'days').format('DD MMM YYYY');
        _this2.currentPumpDate = moment(endDate).subtract(1, 'days').format('DD MMM YYYY');
        _this2.meanEndDate = _this2.currentPumpDate;
    };

    this.formatDate = function (localtime) {
        if (localtime != null) {
            return moment(localtime).format('DD MMM YYYY, h:mm:ss a');
        } else {
            return '--';
        }
    };

    this.getCurrentPumpColor = function (time, avg, std) {
        if (avg - 2 * std - 1 < time && avg + 2 * std + 1 > time) {
            return '#00A000';
        }

        return '#FF0000';
    };

    this.showRuntimeVarianceChart = function (deviceP, pumpNumber) {
        _this2.currentDeviceId = deviceP.deviceID;
        _this2.currentDeviceName = deviceP.deviceName;
        _this2.currentPumpNumber = pumpNumber;

        var oldState = deviceP.showRuntimeVarianceChart;
        for (var i = 0; i < _this2.allDevices.length; i++) {
            _this2.allDevices[i].showRuntimeVarianceChart = false;
        }
        if (!oldState || _this2.previousPumpNumber != pumpNumber) {
            $timeout(function () {
                deviceP.showRuntimeVarianceChart = true;
                //$element.find('.top-menu:eq(1)').css("width", "1200px");
                //$element.find('.chart').css("width", "1200px");
            });
        }
        _this2.previousPumpNumber = pumpNumber;

        //Set initial margin based on scroll & top-menu location
        $timeout(function () {
            _this2.activeChart = $($element).find('#runtime-variance-chart-scroll');
            _this2.activeChartMenu = $(_this2.activeChart).find('.top-menu');

            $(_this2.activeChart).css("margin-left", $(_this2.scrollElement).scrollLeft());
            $(_this2.activeChartMenu).css("width", _this2.chartMaxWidth - 10);
        }, 0);

        //Add Scroll Listener
        $(_this2.scrollElement).scroll(function () {
            $(_this2.activeChart).css("margin-left", $(_this2.scrollElement).scrollLeft());
        });
    };

    this.openRuntimeVarianceChart = function (deviceId, pumpNumber) {
        if (_this2.mobile || _this2.classicView) {
            sharedSetupService.setStickyProperties(sharedSetupService.stickyPropertiesInterface, { deviceId: deviceId, device: { channel: pumpNumber } });
            $location.path('/runtime/variancechart/runtime-variance-chart-template');
        } else {
            var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
            optionsStickyProperties.deviceId = deviceId;
            optionsStickyProperties.device.channel = pumpNumber;
            openViewService.openView('Runtime Variance Chart', { width: 900, height: 500 }, { my: 'center', at: 'center', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });
        }
    };

    this.savePdf = function () {

        var drawCell = function drawCell(row, data) {
            if (typeof data.row.raw[1] == "undefined") {
                data.doc.setFillColor(226, 239, 248);
            }
        };

        var windowTitle = $scope.windowTitle;
        savePdfService.savePDF(windowTitle, $scope.windowTitle, _this2.accountInfo.customerName, _this2.accountInfo.customerId, _this2.translation.text.DATE, null, null, $scope, $element, null, drawCell);
    };

    this.savePdf = function () {

        var windowTitle = $scope.windowTitle;

        var drawCell = function drawCell(row, data) {
            if (typeof data.row.raw[1] == "undefined") {
                data.doc.setFillColor(226, 239, 248);
            }
        };

        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: $scope.windowTitle,
            customerName: _this2.accountInfo.customerName,
            customerId: _this2.accountInfo.customerId,
            dateTranslate: _this2.translation.text.DATE,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            drawCell: drawCell
        };

        savePdfService.savePDF(pdfParams);
    };

    this.saveExcel = function () {
        $scope.topMenuExcelProgress = true;
        var reportTitle = $scope.windowTitle.trim();
        if (!/Report$/.test(reportTitle)) {
            reportTitle += ' Report';
        }
        //Copy html elements and prepend column header to table
        var requiredElementCopy = $element.parents('div').find('div.save-excel').first().clone();
        var requiredHeaderCopy = $element.parents('div').find('.excel-pdf-header').first().clone();

        $(requiredElementCopy).find('.mc-remove-extra-column').remove();
        $(requiredElementCopy).find('tbody:first').prepend(requiredHeaderCopy);
        var blob = new Blob(['<h4>' + reportTitle + '</h4>' + requiredElementCopy.html()], {
            type: 'application/vnd.ms-excel;charset=utf-8'
        });
        //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        if ($scope.curentBrowser == 'internet explorer') $scope.ieFileSuffix = '(' + new Date.getTime() + ')';
        $timeout(function () {
            $scope.topMenuExcelProgress = false;
            saveAs(blob, 'Runtime_Variance' + $scope.ieFileSuffix + '.xls');
        }, 1000);
    };
}

RuntimeVarianceController.$inject = ['REPORTS', '$scope', '$location', '$http', '$element', '$filter', '$timeout', '$window', 'authenticationService', 'datetimeService', 'translationService', 'sharedSetupService', 'openViewService', 'savePdfService', 'toaster'];

angular.module('mc.runtime').component('runtimeVariance', {
    controller: RuntimeVarianceController,
    transclude: true,
    templateUrl: 'ui/runtime/variance/runtime-variance-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<'
    }
});
"use strict";

angular.module("mc.signal-connect-table", []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SignalConnectTableFactory = function SignalConnectTableFactory($http, REPORTS) {
    var SignalConnectTable = function () {
        function SignalConnectTable(customerId, timeZone) {
            _classCallCheck(this, SignalConnectTable);

            this.customerId = customerId;
            this.timeZone = timeZone;
        }

        _createClass(SignalConnectTable, [{
            key: 'getData',


            //Fetch Signal Connect Data by DeviceId and Date range.
            value: function getData(deviceId, stDateUnix, endDateUnix) {
                return $http({
                    method: 'Get',
                    url: REPORTS + '/api/SignalConnect/Table/Get?customerId=' + this.customerId + '&deviceId=' + deviceId + '&timeZone=' + this.timeZone + '&startDate=' + stDateUnix + '&endDate=' + endDateUnix
                });
            }
        }, {
            key: 'nextPage',
            value: function nextPage() {
                return true;
            }
        }, {
            key: 'previousPage',
            value: function previousPage() {
                return true;
            }
        }]);

        return SignalConnectTable;
    }();

    return SignalConnectTable;
};

SignalConnectTableFactory.$inject = ['$http', 'REPORTS'];

angular.module('mc.signal-connect-table').factory('SignalConnectTableFactory', SignalConnectTableFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function SignalConnectTableController(_, $scope, SignalConnectTableFactory, sharedSetupService, openViewService, translationService, $timeout, authenticationService, datetimeService, $element) {

    var ctrl = this;

    ctrl.myDate = null;
    ctrl.infiniteScrollOn = false;
    ctrl.infiniteScrollUpOn = false;
    ctrl.infiniteScrollDownOn = false;
    ctrl.shrinkUI = false;
    ctrl.dispatchLoading = false;
    ctrl.alerts = [];
    ctrl.signalTableData = [];
    ctrl.signalConnectDataBusy = false;

    var element = $element.find('#signa-connect-table-component');

    var currentScrollbarPosition = void 0;
    var previousScrollbarPosition = void 0;
    var paddingZoom = void 0;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.prefLang = ctrl.accountInfo.preferenceUser.i18nCode;

        ctrl.translation = translationService.translation;

        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.liveDataOffset = sharedSetupService.liveDataOffset;

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        paddingZoom = Math.round((ctrl.stickyProperties.zoomMax - ctrl.stickyProperties.zoomMin) / 2) || ctrl.unixDay / 2;

        //getSignalConnectTable();

        //Manage Dialog Geometry
        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                if (ctrl.popup.parent().length > 0) {
                    ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                    ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                    ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                    ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                }
            };
        }
    };

    ctrl.$onChanges = function (changes) {

        if (!angular.isUndefined(changes.deviceSelected) && !angular.isUndefined(changes.deviceSelected.currentValue) && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {

            ctrl.signalTableData = [];
            ctrl.currentDeviceId = changes.deviceSelected.currentValue;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: ctrl.currentDeviceId, windowId: $scope.windowId });

            if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.zoomMin !== null && ctrl.stickyProperties.zoomMin !== undefined) {
                ctrl.stickyProperties.on = true;
                _nextPage(new Date(ctrl.stickyProperties.zoomMax));
            } else {
                ctrl.stickyProperties.on = false;
                _nextPage(new Date());
            }
        }

        if (!angular.isUndefined(changes.myDate) && !angular.isUndefined(changes.myDate.currentValue) && changes.myDate.currentValue !== changes.myDate.previousValue) {

            $scope.myDate = changes.myDate.currentValue;
            ctrl.myDate = changes.myDate.currentValue;
            _updateZoom(datetimeService.dateToUnixtime(changes.myDate.currentValue));
            ctrl.signalTableData = [];
            $timeout(function () {
                var tmpDates = changes.myDate.currentValue == null ? new Date() : changes.myDate.currentValue;
                _nextPage(tmpDates);
            }, 0);
        }
    };

    //Handle UI Scroll event
    element.on('scroll', function (event) {

        if (ctrl.signalTableData.length == 0) return;

        var $rowFirst = element.contents().find("tr:first");
        var $rowLast = element.contents().find("tr:last");
        var _firstRow = $rowFirst.attr("name");
        if (typeof $rowFirst.position() !== "undefined") {
            ctrl.infiniteScrollOn = true;ctrl.infiniteScrollUpOn = true;ctrl.infiniteScrollDownOn = true;
            var _topOffset = $rowFirst.position().top;
            previousScrollbarPosition = currentScrollbarPosition;
            currentScrollbarPosition = element[0].scrollTop;
        }

        if (ctrl.infiniteScrollOn === true) {
            ctrl.infiniteScrollUpOn = true;
            ctrl.infiniteScrollDownOn = true;

            if (ctrl.infiniteScrollDownOn === true && element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight) {
                $rowLast.addClass("active-row");
                ctrl.SignalConnectTableFactory.alerts = [];
                _nextPage();
            }
            if (ctrl.infiniteScrollUpOn === true && element[0].scrollTop < 5 && currentScrollbarPosition < previousScrollbarPosition) {
                $rowFirst.addClass("active-row");
                ctrl.SignalConnectTableFactory.alerts = [];
                _previousPage();
            }
        }

        var rows = element.children().children().children().children();
        var scrollpos = 40;
        var start = 0;
        var end = rows.length;
        var count = 0;

        while (start !== end) {
            count++;
            var mid = start + Math.floor((end - start) / 2);
            if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
        }
        _updateZoom(parseFloat($($(rows[start])).attr("name")));
    });

    $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
        if (!ctrl.mobile && !ctrl.classicView) ctrl.adjustSize();
        _autoScroll();
    });

    var _updateZoom = function _updateZoom(currentRow) {
        if (isNaN(currentRow)) return;
        var zoomMin = currentRow - paddingZoom;
        var zoomMax = currentRow + paddingZoom;
        var dateMin = ctrl.stickyProperties.dateMin;
        var dateMax = ctrl.stickyProperties.dateMax;
        if (zoomMin < ctrl.stickyProperties.dateMin) dateMin = zoomMin;
        if (zoomMax > ctrl.stickyProperties.dateMax) dateMax = zoomMax;
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: $scope.windowId });
    };

    var _autoScroll = function _autoScroll() {
        element.animate({
            scrollTop: element.scrollTop() + 2
        }, 500);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
    });

    var updateSignalTableData = function updateSignalTableData(newData, next) {
        var i = 0;
        switch (next) {
            case true:
                i = 0;
                newData.map(function (data) {
                    if (i == 0 && ctrl.signalTableData.length > 0) {
                        var lastDateDuplicates = ctrl.signalTableData.filter(function (x) {
                            return x.connect.substring(0, 10) === data.connect.substring(0, 10);
                        });
                        lastDateDuplicates.forEach(function (y) {
                            return ctrl.signalTableData.splice(ctrl.signalTableData.findIndex(function (z) {
                                return z.connect.substring(0, 10) === y.connect.substring(0, 10);
                            }), 1);
                        });
                    }
                    ctrl.signalTableData.push(data);
                    ++i;
                });
                break;

            case false:
            default:
                i = 0;
                newData.reverse().map(function (data) {
                    if (i == 0 && ctrl.signalTableData.length > 0) {
                        var lastDateDuplicates = ctrl.signalTableData.filter(function (x) {
                            return x.connect.substring(0, 10) === data.connect.substring(0, 10);
                        });
                        lastDateDuplicates.forEach(function (y) {
                            return ctrl.signalTableData.splice(ctrl.signalTableData.findIndex(function (z) {
                                return z.connect.substring(0, 10) === y.connect.substring(0, 10);
                            }), 1);
                        });
                    }
                    ctrl.signalTableData.unshift(data);
                    ++i;
                });
                break;
        }
    };

    var _getSignalConnectData = function _getSignalConnectData(theDate, next) {

        if (ctrl.signalConnectDataBusy) return;

        ctrl.signalConnectDataBusy = true;
        ctrl.alerts = [];
        ctrl.stickyProperties.on = false;

        var newDate = theDate == null ? new Date() : theDate;

        var tmpStartDate, tmpEndDate;

        newDate.setHours(0, 0, 0, 0);
        tmpStartDate = datetimeService.dateToUnixtime(newDate) - (next ? 90 * ctrl.unixDay : 0);
        newDate.setHours(23, 59, 59, 0);
        tmpEndDate = datetimeService.dateToUnixtime(newDate) + (next ? 0 : 90 * ctrl.unixDay);

        ctrl.SignalConnectTableFactory = new SignalConnectTableFactory(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone);
        ctrl.SignalConnectTableFactory.getData(ctrl.currentDeviceId, tmpStartDate, tmpEndDate).then(function (result) {
            ctrl.deviceName = result.data[0].deviceName;
            ctrl.onDeviceNameChange({ deviceName: ctrl.deviceName });
            if (result.data.length == 0 || result.data[0].data.length == 0) {
                var errormsg = ctrl.translation.message.NO_DATA + ": " + moment(tmpStartDate).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(tmpEndDate).utc().format('MM/DD/YY, h:mm:ss a');
                ctrl.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            } else {
                updateSignalTableData(result.data[0].data, next);
            }

            $timeout(function () {
                ctrl.signalConnectDataBusy = false;
            }, 500);
        }, function (error) {
            //error
            $timeout(function () {
                ctrl.signalConnectDataBusy = false;
            }, 500);
        });
    };

    var _nextPage = function _nextPage(tmpDate) {
        var lastDate = tmpDate == null && ctrl.signalTableData.length > 0 ? new Date(Date.parse(ctrl.signalTableData[ctrl.signalTableData.length - 1].connect)) : tmpDate == null ? null : tmpDate;
        _getSignalConnectData(lastDate, true);
    };

    var _previousPage = function _previousPage() {
        var firstDate = ctrl.signalTableData.length > 0 ? new Date(Date.parse(ctrl.signalTableData[0].connect)) : null;
        _getSignalConnectData(firstDate, firstDate ? false : true);
    };
};

SignalConnectTableController.$inject = ['_', '$scope', 'SignalConnectTableFactory', 'sharedSetupService', 'openViewService', 'translationService', '$timeout', 'authenticationService', 'datetimeService', '$element'];
'use strict';

angular.module('mc.signal-connect-table').component('signalConnectTable', {
    controller: SignalConnectTableController,
    templateUrl: 'ui/signalconnect/table/signal-connect-table-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        myDate: '<',
        onDeviceNameChange: '&'
    }
});
"use strict";

function RuntimeVarianceChartController(REPORTS, $scope, $http, $element, $filter, $timeout, $window, authenticationService, datetimeService, translationService, sharedSetupService, openViewService, rainfallDataCalendarFactory) {
    var _this = this;

    var ctrl = this;

    this.$onInit = function () {
        $scope.mobile = _this.mobile;
        $scope.classicView = _this.classicView;
        $scope.windowTitle = 'Runtime Variance Chart';
        $scope.alerts = [];
        $scope.downloadViewTypeOptions = [1];
        $scope.chartMaxWidth = _this.chartMaxWidth;
        _this.alerts = [];
        _this.accountInfo = authenticationService.getAccountInfo();
        _this.translation = translationService.translation;
        _this.devices = [];
        _this.noDevices = true;
        _this.openFirstTime = true;
        _this.rainfallDataCalendarFactory = new rainfallDataCalendarFactory(_this.accountInfo.customerId);
        $scope.windowId = ctrl.windowId;
        $scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.unit = "";
        $scope.hasRainfall = false;
        _this.checkRainfallAndUnit();
        _this.getRuntimeVarianceChart();

        //sharedSetupService.setStickyProperties($scope.stickyProperties, { windowId: $scope.windowId });               

        if (/Edge\/\d./i.test(navigator.userAgent)) {
            _this.isEdge = true;
        }

        _this.isFF = !!navigator.userAgent.match(/firefox/i);
    };

    this.checkRainfallAndUnit = function () {
        _this.rainfallDataCalendarFactory.fetchSettings(_this.deviceId).then(function (resp) {
            for (var i = 0; i < resp.data.length; i++) {
                if (resp.data[i].channelName.search(/rain/i) > -1 || resp.data[i].channelName.search(/plu/i) > -1) {
                    $scope.hasRainfall = true;
                    _this.unit = resp.data[i].unit; //case-insensitive search for 'rain' OR 'plu' --> these strings means device is connected to rainfall channel
                    $scope.unit = _this.unit.toLowerCase() === "inches" ? _this.translation.text.INCHES_ABBRV : _this.unit;
                    $scope.unit = _this.unit.toLowerCase() === "mm" ? _this.translation.text.MILLIMETER : _this.unit;
                    $scope.unit = _this.unit.toLowerCase() === "cm" ? _this.translation.text.CENTIMETERS : _this.unit;
                }
            }
        });
    };

    this.getRuntimeVarianceChart = function () {
        $http.get(REPORTS + "/api/RuntimeVariance?customerId=" + _this.accountInfo.customerId + "&deviceId=" + _this.deviceId + "&deviceName=" + encodeURIComponent(_this.deviceName) + "&endDate=" + _this.selectDate + "&pump=" + _this.pumpNumber + "&timeZone=" + _this.accountInfo.timeZone).then(function (resp) {
            _this.data = resp.data;
            _this.drawChart();
        });
    };

    $scope.$on('updatePreferencesLanguage', function () {
        _this.drawChart();
    });

    this.drawChart = function createChart() {

        if ($scope.chartMaxWidth) {
            var _chartWidth = $scope.chartMaxWidth;
        } else {
            var _chartWidth = $element.parents('tr').css("width").replace(/[^0-9.]+/g, "");
            $element.parents('tr').find('.top-menu').css("width", _chartWidth - 173 + "px"); //1400 - 1227
        }

        var startPoint = new Date(this.selectDate);
        startPoint = new Date(startPoint.setDate(startPoint.getDate() - 29));
        if (typeof this.data.reportTime !== "undefined" && this.data.reportTime.length > 0) {
            startPoint = new Date(this.data.reportTime[0]);
        }

        var times = this.data.reportTime.map(function (t) {
            return new Date(t).getTime();
        });

        var pumpSeries = this.data.pumpData.map(function (value, i) {
            return [times[i], value];
        });
        var avgSeries = this.data.avg.map(function (value, i) {
            return [times[i], value];
        });
        var rainfallSeries = this.data.rainfall.map(function (value, i) {
            return [times[i], value];
        });
        var candleSeries = this.data.candleStickData.map(function (value, i) {
            return [times[i], value[0], value[1], value[2], value[3]];
        });

        var yAxisCustomised = void 0;
        if ($scope.hasRainfall) {
            yAxisCustomised = [{
                min: 0,
                maxPadding: 0,
                title: {
                    text: this.translation.text.HOURS //'Hours' 
                }
            }, {
                min: 0,
                maxPadding: 0,
                title: {
                    text: this.translation.text.RAINFALL + ' (' + $scope.unit + ')' //'Rainfall' 
                }
            }];
        } else {
            yAxisCustomised = {
                min: 0,
                maxPadding: 0,
                title: {
                    text: this.translation.text.HOURS //'Hours' 
                }
            };
        }

        this.chart = new Highcharts.Chart({
            chart: {
                renderTo: $element.find(".chart")[0],
                borderWidth: 0,
                width: _chartWidth
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            title: {
                text: ' '
            },
            subtitle: {
                text: 'Runtime Variance -- ' + this.data.name + ' (Pump ' + this.data.pump + ')' //' (Pump <%=Request(" + Pump ")%>)'
            },
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: {
                    minute: '%H:%M',
                    hour: '%H:%M',
                    day: '%b %e',
                    week: '%b %e',
                    month: '%b \'%y',
                    year: '%Y'
                },
                showLastTickLabel: true
                //maxZoom: 30 * 24 * 3600000, // th days

                //title: {
                //    text: null
                //}
            },
            yAxis: yAxisCustomised,
            legend: {},
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var d = new Date(this.x);
                    var s = '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    s += "<tr><td colspan=\"2\" style=\"color: #000000; padding-bottom: 3px;\">" + Highcharts.dateFormat('%A, %b %e, %Y ', this.x) + "</td></tr>";
                    $.each(this.points, function (i, point) {
                        if (point.series.type == "candlestick") {
                            // s += '<tr><td style="text-align: left;color:#000000;' +  '">' + '<span style="text-align: left;color: ' + point.series.color + ';">\u25CF ' + ' </span>' + point.series.name + ': </td></tr>';
                            // s += '<tr><td style="text-align: right; color: #000000; font-weight: bold;">' + 'High Trigger: '+ point.point.high +  '</td></tr>';
                            // s += '<tr><td style="text-align: right; color: #000000; font-weight: bold;">' + 'Low Trigger: '+ point.point.low +  '</td></tr>';
                            s += '<tr><td style="text-align: left;color:#000000;' + '">' + '<span style="text-align: left;color: ' + point.series.color + ";\">\u25CF " + ' </span>' + point.series.name + '- High Trigger: ' + '</td><td style="text-align: right; color: #000000; font-weight: bold;">' + point.point.high + '(H)' + '</td></tr>';
                            s += '<tr><td style="text-align: left;color:#000000;' + '">' + '<span style="text-align: left;color: ' + point.series.color + ";\">\u25CF " + ' </span>' + point.series.name + '- Low Trigger: ' + '</td><td style="text-align: right; color: #000000; font-weight: bold;">' + point.point.low + '(H)' + '</td></tr>';
                        } else {
                            s += '<tr><td style="text-align: left;color:#000000;' + '">' + '<span style="text-align: left;color: ' + point.series.color + ";\">\u25CF " + ' </span>' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + point.y + '(H)' + '</td></tr>';
                        }
                    });
                    s += '</table>';
                    return s;
                },
                crosshairs: true,
                shared: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [{
                name: "Rainfall ",
                type: 'spline',
                color: '#ff9247',
                data: rainfallSeries,
                zIndex: 6
            }, {
                name: 'Pump Runtime',
                type: 'column',
                color: '#FF0000',
                data: pumpSeries,
                zIndex: 5
            }, {
                name: '30 Day Average',
                type: 'spline',
                color: '#00FF00',
                data: avgSeries,
                zIndex: 6
            }, {
                name: "Pump Variance",
                type: 'candlestick',
                dashStyle: 'shortdot',
                marker: {
                    enabled: false
                },
                data: candleSeries,
                zIndex: 4
            }]
        });
    };
}

RuntimeVarianceChartController.$inject = ['REPORTS', '$scope', '$http', '$element', '$filter', '$timeout', '$window', 'authenticationService', 'datetimeService', 'translationService', 'sharedSetupService', 'openViewService', 'rainfallDataCalendarFactory'];

angular.module('mc.runtime').component('runtimeVarianceChart', {
    controller: RuntimeVarianceChartController,
    transclude: true,
    templateUrl: 'ui/runtime/variancechart/runtime-variance-chart-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        deviceId: '<',
        pumpNumber: '<',
        selectDate: '<',
        chartMaxWidth: '<',
        deviceName: '<'
    }
});
'use strict';

function MultipleRuntimesReportController(REPORTS, $scope, $sce, $location, $http, $element, $filter, $timeout, $window, authenticationService, datetimeService, translationService, sharedSetupService, openViewService, savePdfService, toaster) {
    var _this2 = this;

    var ctrl = this;
    this.loading = true;

    this.$onInit = function () {
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        $scope.windowId = _this2.windowId;
        $scope.windowTitle = 'Runtime Variance';
        $scope.stickyProperties = _this2.stickyProperties;
        $scope.alerts = [];
        _this2.alerts = [];
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        _this2.devices = [];
        _this2.noDevices = true;
        _this2.previousPumpNumber = null;
        sharedSetupService.getWindowId(_this2);
        _this2.loading = false;
        $scope.downloadViewTypeOptions = [3];

        if (/Edge\/\d./i.test(navigator.userAgent)) {
            _this2.isEdge = true;
        }

        _this2.isFF = !!navigator.userAgent.match(/firefox/i);

        if (!_this2.mobile && !_this2.classicView) {
            _this2.qdpLeft = -237;
            _this2.popup = _this.getExistingDialog(_this2.windowId).ref;
            sharedSetupService.maximize(_this2.popup);
        }

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });
        }

        $scope.adjustSize = function () {
            _this2.resizingModal = true;
            _this2.chartReady = false;
            if (_this2.adjustSizeTimeout) {
                $timeout.cancel(_this2.adjustSizeTimeout);
            }

            _this2.adjustSizeTimeout = $timeout(function () {
                _this2.chartMaxWidth = $($element).find('#runtime-variance-max-width').width();
                $timeout(function () {
                    _this2.resizingModal = false;
                }, 0);
                $timeout(function () {
                    _this2.activeChart = $($element).find('#runtime-variance-chart-scroll');
                    _this2.activeChartMenu = $(_this2.activeChart).find('.top-menu');
                    $(_this2.activeChart).css("margin-left", $(_this2.scrollElement).scrollLeft());
                    $(_this2.activeChartMenu).css("width", _this2.chartMaxWidth - 10);
                    _this2.chartReady = true;
                }, 50);
            }, 500);
        };

        _this2.endDate = null;
        // this.endDate = this.endDate.setHours(0, 0, 0, 0);
        _this2.getData(_this2.accountInfo.customerId, _this2.endDate, _this2.accountInfo.timeZone);
    };

    this.getData = function (customerId, startDate, timeZone) {
        _this2.loading = false;
        $http.get(REPORTS + "/api/Reports/GetMultipleRuntimeDaily" + "?customerId=" + customerId + "&timeZone=" + timeZone + "&startDate=" + startDate).then(function (resp) {
            _this2.alerts = [];
            var cleanedHtml = cleanReportHtml(resp.data);
            _this2.reportHtml = $sce.trustAsHtml(cleanedHtml);
            $timeout(function () {
                _this2.scrollElement = $($element).find(".data-pane")[0];
            }, 0);
            _this2.loading = false;
        });
    };

    function cleanReportHtml(html) {
        if (!html) {
            return '';
        }

        html = html.replace(/<title[^>]*>[\s\S]*?<\/title>/gi, '');
        html = html.replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '');

        var bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
        html = bodyMatch ? bodyMatch[1] : html;

        // Remove visible h2 title
        // html = html.replace(/<h2[^>]*>[\s\S]*?<\/h2>/i, '');

        return html;
    }

    this.selectMyDate = function () {
        var endDate = _this2.myDate.setHours(0, 0, 0, 0);
        _this2.endDate = endDate;
        _this2.loading = true;
        _this2.getData(_this2.accountInfo.customerId, endDate, _this2.accountInfo.timeZone);
    };

    this.getScrollOffset = function () {
        if (_this2.isEdge) {
            return 12;
        }

        return 18;
    };

    this.formatDate = function (localtime) {
        if (localtime != null) {
            return moment(localtime).format('DD MMM');
        } else {
            return '--';
        }
    };

    this.mostRecentData = function () {
        ctrl.isRefresh = true;
        ctrl.myDate = null;
        _this2.getData(_this2.accountInfo.customerId, ctrl.myDate, _this2.accountInfo.timeZone);
    };

    this.downloadWidget = function () {
        var reportElement = document.querySelector('.runtime-report-html');

        if (!reportElement) {
            alert('Report content is not available.');
            return;
        }

        var customerName = this.accountInfo.customerName || 'Customer';
        var d = new Date();
        d.setDate(d.getDate() - 1);
        var reportDate = this.endDate || d;

        var fileName = sanitizeFileName(customerName) + '_DailyRuntimeReport_' + formatDateForFileName(new Date(reportDate)) + '.pdf';

        try {
            // Text-based PDF (jsPDF + AutoTable) so rows are never sliced across pages and text stays selectable
            var doc = new jsPDF('p', 'pt', 'letter');
            var margin = 40;
            var pageWidth = doc.internal.pageSize.width;
            var pageHeight = doc.internal.pageSize.height;
            var cursorY = margin;

            var ensureSpace = function ensureSpace(height) {
                if (cursorY + height > pageHeight - margin) {
                    doc.addPage();
                    cursorY = margin;
                }
            };

            var writeText = function writeText(text, fontSize, fontStyle, align) {
                doc.setFontSize(fontSize);
                doc.setFontStyle(fontStyle);
                doc.setTextColor(0, 0, 0);
                var lineHeight = fontSize * 1.2;
                doc.splitTextToSize(text, pageWidth - margin * 2).forEach(function (line) {
                    ensureSpace(lineHeight);
                    var x = align === 'center' ? (pageWidth - doc.getTextWidth(line)) / 2 : margin;
                    doc.text(x, cursorY + fontSize, line);
                    cursorY += lineHeight;
                });
                cursorY += 4;
            };

            collectReportBlocks(reportElement).forEach(function (block) {
                if (block.type === 'heading') {
                    writeText(block.text, 14, 'bold', 'center');
                } else if (block.type === 'text') {
                    writeText(block.text, 9, 'normal', 'left');
                } else if (block.type === 'rule') {
                    ensureSpace(12);
                    doc.setDrawColor(153, 153, 153);
                    doc.setLineWidth(0.5);
                    doc.line(margin, cursorY + 6, pageWidth - margin, cursorY + 6);
                    cursorY += 12;
                } else if (block.type === 'table') {
                    addReportTable(doc, block.element, cursorY, margin);
                    cursorY = doc.autoTable.previous.finalY + 10;
                }
            });

            doc.save(fileName);
        } catch (e) {
            alert('Unable to download PDF.');
        }
    };

    // Flattens the report HTML into an ordered list of headings, text, rules and leaf tables
    function collectReportBlocks(root) {
        var blocks = [];

        var walk = function walk(node) {
            Array.prototype.forEach.call(node.childNodes, function (child) {
                if (child.nodeType === Node.TEXT_NODE) {
                    var text = child.textContent.trim();
                    if (text) {
                        blocks.push({ type: 'text', text: text });
                    }
                    return;
                }

                if (child.nodeType !== Node.ELEMENT_NODE) {
                    return;
                }

                var tag = child.tagName;

                if (/^(STYLE|SCRIPT)$/.test(tag)) {
                    return;
                }

                if (tag === 'HR') {
                    blocks.push({ type: 'rule' });
                } else if (/^H[1-6]$/.test(tag)) {
                    var heading = (child.innerText || '').trim();
                    if (heading) {
                        blocks.push({ type: 'heading', text: heading });
                    }
                } else if (tag === 'TABLE' && !child.querySelector('table')) {
                    blocks.push({ type: 'table', element: child });
                } else if (child.querySelector('table, hr, h1, h2, h3, h4, h5, h6')) {
                    walk(child);
                } else {
                    var text = (child.innerText || '').trim();
                    if (text) {
                        blocks.push({ type: 'text', text: text });
                    }
                }
            });
        };

        walk(root);
        return blocks;
    }

    function addReportTable(doc, table, startY, margin) {
        var rows = Array.prototype.slice.call(table.rows);
        var columnCount = 0;

        rows.forEach(function (row) {
            var count = 0;
            Array.prototype.forEach.call(row.cells, function (cell) {
                count += cell.colSpan || 1;
            });
            columnCount = Math.max(columnCount, count);
        });

        if (columnCount === 0) {
            return;
        }

        // AutoTable 2.x has no colspan support, so spanned cells are padded with empty cells
        var data = rows.map(function (row) {
            var cells = [];
            Array.prototype.forEach.call(row.cells, function (cell) {
                cells.push(cell);
                for (var i = 1; i < (cell.colSpan || 1); i++) {
                    cells.push(cell);
                }
            });
            while (cells.length < columnCount) {
                cells.push('');
            }
            return cells;
        });

        var columns = [];
        for (var i = 0; i < columnCount; i++) {
            columns.push({ title: '', dataKey: i });
        }

        var spanStart = [];
        data.forEach(function (cells, rowIndex) {
            spanStart[rowIndex] = cells.map(function (cell, index) {
                return index === 0 || cells[index - 1] !== cell;
            });
        });

        doc.autoTable(columns, data, {
            startY: startY,
            margin: { left: margin, right: margin },
            theme: 'plain',
            showHeader: 'never',
            pageBreak: 'auto',
            styles: {
                font: 'helvetica',
                fontSize: 9,
                cellPadding: 4,
                overflow: 'linebreak',
                textColor: 0
            },
            createdCell: function createdCell(cell, data) {
                var element = cell.raw;
                if (!(element instanceof HTMLElement)) {
                    return;
                }

                // Only the first column of a spanned cell keeps its text
                if (!spanStart[data.row.index][data.column.dataKey]) {
                    cell.text = [''];
                }

                var style = window.getComputedStyle(element);
                var background = parseCssColor(style.backgroundColor);
                if (background) {
                    cell.styles.fillColor = background;
                }

                if (parseInt(style.fontWeight, 10) >= 600 || style.fontWeight === 'bold' || element.tagName === 'TH') {
                    cell.styles.fontStyle = 'bold';
                }

                var align = (element.getAttribute('align') || style.textAlign || '').toLowerCase();
                if (align === 'right' || align === 'center') {
                    cell.styles.halign = align;
                }
            }
        });
    }

    function parseCssColor(value) {
        var match = /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/.exec(value || '');
        if (!match || match[4] !== undefined && parseFloat(match[4]) === 0) {
            return null;
        }

        return [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3], 10)];
    }

    function sanitizeFileName(value) {
        if (!value) {
            return 'Customer';
        }

        return value.replace(/[\\\/:*?"<>|]/g, '') // remove invalid filename characters
        .replace(/\s+/g, '_') // replace spaces with underscore
        .trim();
    }

    function formatDateForFileName(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');

        return year + month + day;
    }
}

MultipleRuntimesReportController.$inject = ['REPORTS', '$scope', '$sce', '$location', '$http', '$element', '$filter', '$timeout', '$window', 'authenticationService', 'datetimeService', 'translationService', 'sharedSetupService', 'openViewService', 'savePdfService', 'toaster'];

angular.module('mc.runtime').component('multipleRuntimesReport', {
    controller: MultipleRuntimesReportController,
    transclude: true,
    templateUrl: 'ui/runtime/MultipleRuntimes/multiple-runtimes-daily-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<'
    }
});
'use strict';

mcapp.factory('runtimeRainfallTableService', ['$http', 'datetimeService', 'translationService', 'HOST', function ($http, datetimeService, translationService, host) {
    var runtimeRainfallTableService = function runtimeRainfallTableService() {
        this.items = [];
        this.setting = [];
        this.metarStationName = 'loading...';
        this.customerId = null;
        this.deviceId = null;
        this.deviceType = null;
        this.metarStationID = null;
        this.rainfallSite = 0;
        this.temperatureUnit = 1;
        this.rainfallUnit = 1;
        this.timeFormat = 1;
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.tdWidth = null;
        this.alerts = [];
        this.translation = translationService.translation;
        this.lastUpdateAt = null;
        this.unit = null;
        this.lookupMeasurementID = null;
        this.initialUnit = null;
    };

    runtimeRainfallTableService.prototype.Poll = function () {
        this.LoadData(-this.pageSize, true);
    };

    runtimeRainfallTableService.prototype.PreviousPage = function () {
        this.start = new Date(this.endDate);
        this.start = new Date(this.start.getFullYear(), this.start.getMonth(), this.start.getDate(), 1);
        this.start = datetimeService.dateToUnixtime(this.start);

        this.tmpEndDate = new Date(this.endDate);
        this.end = new Date(this.tmpEndDate.setDate(this.tmpEndDate.getDate() + 30));
        this.end = new Date(this.tmpEndDate.getFullYear(), this.tmpEndDate.getMonth(), this.tmpEndDate.getDate(), -1);
        this.end = datetimeService.dateToUnixtime(this.end);

        this.LoadData(-this.pageSize);
    };

    runtimeRainfallTableService.prototype.NextPage = function () {
        this.tmpEndDate = new Date(this.startDate);
        this.end = new Date(this.tmpEndDate.getFullYear(), this.tmpEndDate.getMonth(), this.tmpEndDate.getDate(), -1);
        this.end = datetimeService.dateToUnixtime(this.end);

        this.tmpStart = new Date(this.startDate);
        this.start = new Date(this.tmpStart.setDate(this.tmpStart.getDate() - 30));
        this.start = new Date(this.start.getFullYear(), this.start.getMonth(), this.start.getDate(), 1);
        this.start = datetimeService.dateToUnixtime(this.start);

        this.LoadData(this.pageSize);
    };

    runtimeRainfallTableService.prototype.Next = function () {
        this.LoadData(this.pageSize);
    };
    runtimeRainfallTableService.prototype.Reload = function () {
        this.items = [];
        this.alerts = [];
        this.startRow = 1;
        this.LoadData(this.pageSize);
    };

    runtimeRainfallTableService.prototype.fetchSettings = function (deviceId) {
        return $http.get(host + "/api/ParmPulse?deviceId=" + deviceId);
    };

    runtimeRainfallTableService.prototype.remove_duplicates = function (arr) {
        var obj = {};
        var ret_arr = [];
        for (var i = 0; i < arr.length; i++) {
            obj[arr[i].reportTime] = arr[i]; //reportTime should be unique across the array items
        }
        for (var key in obj) {
            ret_arr.push(obj[key]);
        }
        return ret_arr;
    };

    runtimeRainfallTableService.prototype.calculateItems = function () {
        if (this.lookupMeasurementID === 1 && this.unit != this.translation.text.INCHES) {
            if (this.unit.toLowerCase() == "mm") {
                for (var i = 0; i < this.items.length; i++) {
                    //Convert to IN
                    this.items[i].rainfall = this.items[i].rainfall * .0393701;
                    //Round
                    this.items[i].rainfall = Math.round(this.items[i].rainfall * 100) / 100;
                }
                this.unit = this.translation.text.INCHES;
            } else if (this.unit.toLowerCase() == "cm") {
                for (var _i = 0; _i < this.items.length; _i++) {
                    //Convert to IN
                    this.items[_i].rainfall = this.items[_i].rainfall * .393701;
                    //Round
                    this.items[_i].rainfall = Math.round(this.items[_i].rainfall * 100) / 100;
                }
                this.unit = this.translation.text.INCHES_ABBRV;
            }
        } else if (this.lookupMeasurementID === 2 && (this.unit.toLowerCase != this.translation.text.MILLIMETER || this.unit.toLowerCase != this.translation.text.CENTIMETERS)) {

            for (var _i2 = 0; _i2 < this.items.length; _i2++) {
                //Convert to CM
                if (this.initialUnit == "" || this.initialUnit == this.translation.text.CENTIMETERS) {
                    this.items[_i2].rainfall = this.items[_i2].rainfall * 2.54;
                    this.unit = this.translation.text.CENTIMETERS;
                }
                //Convert to MM
                else if (this.initialUnit == "" || this.initialUnit == this.translation.text.MILLIMETER) {
                        this.items[_i2].rainfall = this.items[_i2].rainfall * 25.4;
                        this.unit = this.translation.text.MILLIMETER;
                    }
                //Round
                this.items[_i2].rainfall = Math.round(this.items[_i2].rainfall * 100) / 100;
            }
        }
    };

    runtimeRainfallTableService.prototype.LoadData = function (pageSize, blinkTheLight) {
        this.pageSize = pageSize;
        if (this.busy) return;
        this.busy = true;
        var url = '';
        if (!angular.isDefined(this.deviceId)) return;
        var metarStationID = this.metarStationID ? this.metarStationID : -1;
        url = host + "/api/RuntimeVsRainfallTable" + "?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&deviceType=" + this.deviceType + "&startRow=" + this.startRow + "&pageSize=" + this.pageSize + "&startDate=" + this.start + "&endDate=" + this.end + "&metarStationId=" + this.metarStationID + "&rainfallSite=" + this.rainfallSite;

        $http.get(url).then(function (result) {
            this.numberOfReturnedRecords = result.data.length;
            this.startRow = 1;
            //add new records to the beginning or end:
            if (pageSize > 0) this.items = this.items.concat(result.data);
            if (pageSize < 0) this.items = result.data.reverse().concat(this.items);
            this.items = this.remove_duplicates(this.items); //TODO: improve this code.
            this.numberOfRecords = this.items.length;
            // this.calculateItems(); // For RTU/DeviceId, values are fetched as per the selected unit, hence no unit conversion is required. 

            //Get the first and last date, so I know how to get prev/next records in the future
            if (this.numberOfRecords > 0) {
                this.startDate = _getFirstDate(this.items);
                this.endDate = _getLastDate(this.items);
            }
            if (this.numberOfReturnedRecords > 0 && blinkTheLight) this.lastUpdateAt = this.items[0].reportTime;

            //Make toast if next page has no result
            if (this.numberOfReturnedRecords === 0 && pageSize > 0) {
                // If we didn't get any items back AND there aren't already any items
                if (this.items.length === 0) {
                    this.alerts = [];
                    var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                    this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this), function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({
                msg: errorMessage, type: "danger"
            });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };

    var _getFirstDate = function _getFirstDate(array) {
        //return datetimeService.dateToUnixtime(new Date(array[array.length - 1].reportTime));
        return array[array.length - 1].reportTime;
    };

    var _getLastDate = function _getLastDate(array) {
        //return datetimeService.dateToUnixtime(new Date(array[0].reportTime));
        return array[0].reportTime;
    };

    var _formatMetarStationName = function _formatMetarStationName(metarStation) {
        var result = '';
        if (metarStation.city.length > 0) result += metarStation.city;
        if (metarStation.state.length > 0 && result.length > 0) result += ', ';
        if (metarStation.state.length > 0) result += metarStation.state;
        if (metarStation.icao.length > 0) result += ' (' + metarStation.icao + ')';
        return result;
    };

    return runtimeRainfallTableService;
}]);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RuntimeRainfallTableController($, $q, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, $timeout, $filter, $element, runtimeRainfallTableService, timeLapseService, websocketService, toaster) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    ctrl.popup = null;
    ctrl.downloadViewTypeOptions = [0, 4];
    ctrl.downloadOptions = { resolution: 0 };
    ctrl.unit = null;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.infiniteScrollOn = false;
        ctrl.infiniteScrollUpOn = false;
        ctrl.infiniteScrollDownOn = false;
        ctrl.checkFirstRowLiveStatus = null;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.dataFormatDailyAdjustment = 60 * ctrl.unixDay;
        ctrl.liveData = false;
        ctrl.liveDataIn = false;
        ctrl.liveDataOffset = sharedSetupService.liveDataOffset;
        $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
        ctrl.translation = translationService.translation;
        ctrl.pollInterval = 60; //poll interval seconds = pollInterval/15
        ctrl.currentScrollbarPosition = 0;
        ctrl.previousScrollbarPosition = 0;
        ctrl.windowSubtitle = "Loading...";
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        ctrl.paddingZoom = Math.round((ctrl.stickyProperties.zoomMax - ctrl.stickyProperties.zoomMin) / 2);
        ctrl.checkFirstRowLiveStatus = null;
        ctrl.paddingZoom = ctrl.paddingZoom === 0 ? ctrl.unixDay / 2 : ctrl.paddingZoom;
        ctrl.runtimeScaleName = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? "Minutes" : "Hours";

        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        $scope.alerts = [];

        $scope.runtimeRainfallTableService = new runtimeRainfallTableService();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        $scope.windowTitle = ctrl.windowTitle;

        ctrl.liveTable = $element.find(".headertable");

        //Get my icon based on my title
        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        //Change the title when the service changes the weather station name
        $scope.$watch('rainfallTableService.metarStationName', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue !== oldValue) {
                if (!$rootScope.mobile && !$rootScope.classicView) ctrl.popup.dialog("option", "title", $scope.windowTitle + ", " + newValue);
            }
        }, true);

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        }

        //Handle infinite scrolling
        $timeout(function () {
            //find the element of the chart class
            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.element = $element.find('.tabular-data-container');
            } else {
                ctrl.element = $element.find('.tabular-data-container-mobile');
            }

            ctrl.element.on('scroll', function (event) {
                var $rowFirst = ctrl.element.contents().find("tr:first");
                var $rowLast = ctrl.element.contents().find("tr:last");
                if (typeof $rowFirst.position() !== "undefined") {
                    ctrl.infiniteScrollOn = true;
                    ctrl.infiniteScrollUpOn = true;
                    ctrl.infiniteScrollDownOn = true;
                    ctrl.previousScrollbarPosition = ctrl.currentScrollbarPosition;
                    ctrl.currentScrollbarPosition = ctrl.element[0].scrollTop;
                }

                if (ctrl.infiniteScrollOn === true) {
                    ctrl.infiniteScrollUpOn = true;
                    ctrl.infiniteScrollDownOn = true;

                    if (ctrl.currentScrollbarPosition <= 35 && ctrl.previousScrollbarPosition > 35) ctrl.checkFirstRowLiveStatus = null;

                    if (ctrl.infiniteScrollDownOn === true && ctrl.element[0].scrollTop + ctrl.element[0].offsetHeight + 5 > ctrl.element[0].scrollHeight) {
                        $rowLast.addClass("active-row");
                        $scope.runtimeRainfallTableService.alerts = [];

                        $scope.runtimeRainfallTableService.NextPage();
                    }
                    if (ctrl.infiniteScrollUpOn === true && ctrl.element[0].scrollTop < 5 && ctrl.currentScrollbarPosition < ctrl.previousScrollbarPosition) {
                        $rowFirst.addClass("active-row");
                        $scope.runtimeRainfallTableService.alerts = [];
                        $scope.runtimeRainfallTableService.PreviousPage();
                    }
                }

                var rows = ctrl.element.children().children().children().children();
                var scrollpos = 40;
                var start = 0;
                var end = rows.length;
                var count = 0;

                while (start != end) {
                    count++;
                    var mid = start + Math.floor((end - start) / 2);
                    if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
                }
                _updateZoom(parseFloat($($(rows[start])).attr("name")));
            });
        });

        //Blink the light when data received
        $scope.$watch('runtimeRainfallTableService.lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                $scope.lastUpdateAt = newValue;
                ctrl.liveDataIn = !ctrl.liveDataIn;
                $timeout(function () {
                    ctrl.liveDataIn = !ctrl.liveDataIn;
                }, 3000);
            }
        }, true);

        //Listen for alerts
        $scope.$watch('runtimeRainfallTableService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue !== oldValue) {
                $scope.alerts = newValue;
            }
        }, true);

        //Handle Preferences:Weather station was changed
        $scope.$on('updatePreferenceWeather', function (event, args) {
            ctrl.currentScrollbarPosition = 0;
            ctrl.previousScrollbarPosition = 0;
            ctrl.checkFirstRowLiveStatus = null;
            $scope.runtimeRainfallTableService.items = [];
            $scope.runtimeRainfallTableService.startRow = 1;
            $scope.runtimeRainfallTableService.pageSize = 50;
            $scope.alerts = [];
            $scope.runtimeRainfallTableService.start = ctrl.stickyProperties.zoomMin;
            $scope.runtimeRainfallTableService.end = ctrl.stickyProperties.zoomMax;
            $scope.runtimeRainfallTableService.Reload();
        });

        //Handle Preferences:MeasurementSystem changed
        $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            getRainfallUnit(ctrl.deviceId).then(function (resp) {
                // after fetching ctrl.unit 
                //ToDo: put these in some common place
                var MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
                var RainfallUnitEnum = { Inches: 1, Centimeters: 2 };
                var TemperatureUnitEnum = { Fahrenheit: 1, Celsius: 2 };

                switch (measurementSystem) {
                    case MeasurementSystemEnum.Imperial:
                        $scope.runtimeRainfallTableService.rainfallUnit = ctrl.unit;
                        $scope.runtimeRainfallTableService.temperatureUnit = TemperatureUnitEnum.Fahrenheit;
                        break;
                    case MeasurementSystemEnum.Metric:
                        $scope.runtimeRainfallTableService.rainfallUnit = ctrl.unit;
                        $scope.runtimeRainfallTableService.temperatureUnit = TemperatureUnitEnum.Celsius;
                        break;
                }
            });
            ctrl.GetRain();
        });

        //Handle Preferences:TimeFormat (12/24) changed
        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            $scope.runtimeRainfallTableService.timeFormat = timeFormat;
        });

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            ctrl.updateSetting();
            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
                ctrl.popup.dialog("option", "title", ctrl.translation.text.RAINFALL_VS_RUNTIME_TABLE + ", " + $scope.deviceName);
            }
            if ($scope.alerts.length > 0) {
                var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment($scope.runtimeRainfallTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.runtimeRainfallTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                }
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });

        //Scroll to the right place after the table is finished drawing
        $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll();
            ctrl.checkFirstRowLiveStatus = null;
        });

        //Clean up when dialog is closed
        $scope.$on("$destroy", function () {
            ctrl.element.empty();
        });

        //manually making call to adjustSize in order to load scrollbar
        $timeout(function () {
            ctrl.adjustSize();
        }, 500);
    };

    ctrl.updateSetting = function () {
        $scope.runtimeRainfallTableService.items = angular.copy($scope.runtimeRainfallTableService.items);
    };
    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            //ctrl.adjustDeviceIdMenuSize();
        }
    };

    ctrl.adjustDeviceIdMenuSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            var spph = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            if (spph < 450) {
                ctrl.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            } else {
                ctrl.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        }
    };

    //dateAgentText filter called from html
    ctrl.dateAgentText = function (date, timeFormat) {
        return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
    };

    // Listen to DeviceID change
    ctrl.setDevice = function (rainfallData) {
        ctrl.downloadOptions.reportType = rainfallData.deviceModel != 0 ? "Rainfall vs Runtime" : "Rainfall";
        getRainfallUnit(rainfallData.rainfallSite).then(function (resp) {

            $scope.deviceName = rainfallData.deviceName;
            ctrl.currentSelectedDevice = rainfallData;
            ctrl.deviceId = rainfallData.deviceId;
            ctrl.deviceType = rainfallData.deviceType;
            ctrl.metarStationID = rainfallData.metarStationID;
            ctrl.rainfallSite = rainfallData.rainfallSite;

            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
                ctrl.popup.dialog("option", "title", ctrl.translation.text.RAINFALL_VS_RUNTIME_TABLE + ", " + $scope.deviceName);
            }
            $scope.deviceId = ctrl.deviceId;
            var _device = { deviceId: $scope.deviceId, deviceName: rainfallData.deviceName };
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceId, device: _device, windowId: $scope.windowId });

            ctrl.GetRain();
        });
    };

    ctrl.selectMyDate = function () {
        ctrl.passedDate = ctrl.myDate;
        ctrl.selectMyDateA();
    };

    //Toggle the active row when user clicks
    ctrl.toggle = function ($event) {
        if ($($event.currentTarget).hasClass("active-row")) {
            $($event.currentTarget).removeClass("active-row");
        } else {
            $($event.currentTarget).addClass("active-row");
        }
    };

    var getRainfallUnit = function getRainfallUnit(deviceId) {
        var deferred = $q.defer();
        //fetch device specific settings, if it is RTU/Device
        if (deviceId > 0) {
            $scope.runtimeRainfallTableService.fetchSettings(deviceId).then(function (resp) {
                deferred.resolve();
                if (resp.data.length > 0) {
                    //case-insensitive search for 'rain' OR 'plu' --> these strings means device is connected to rainfall channel
                    ctrl.rainChannelSetting = resp.data.find(function (x) {
                        return x.channelName.toLowerCase().search(/rain/i) > -1 || x.channelName.toLowerCase().search(/plu/i) > -1;
                    });
                    //for RTU/DeviceId use Unit as unit
                    ctrl.unit = ctrl.rainChannelSetting.unit;

                    // ctrl.unitFactor = 1;
                    // if (ctrl.unit.search(/mm/i) > -1 && ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2) {
                    //     ctrl.unitFactor = 0.1;
                    // }
                    // else if (ctrl.unit.search(/feet/i) > -1 && ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2) {
                    //     ctrl.unitFactor = 30.48;
                    // }
                    // else if (ctrl.unit.search(/inch/i) > -1 && ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2) {
                    //     ctrl.unitFactor = 2.54;
                    // }
                }
            });
        } else {
            //for Airport/Weather Station pull the unit from lookupMeasurementId
            if (ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1) {
                ctrl.unit = ctrl.translation.text.INCHES;
                ctrl.unitFactor = 1;
            } else {
                ctrl.unit = ctrl.translation.text.CENTIMETERS;
                ctrl.unitFactor = 2.54;
            }

            deferred.resolve();
        }
        return deferred.promise;
    };

    //Call me when the user changes the date
    ctrl.selectMyDateA = function () {
        //getRainfallUnit().then((resp) => { // after fetching ctrl.unit 
        $scope.runtimeRainfallTableService = new runtimeRainfallTableService();
        ctrl.currentScrollbarPosition = 0;
        ctrl.previousScrollbarPosition = 0;

        ctrl.checkFirstRowLiveStatus = null;

        var tmpDates = ctrl.passedDate;
        var tmpDatesA = tmpDates;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 50);
        tmpDatesA.setHours(23, 59, 59, 999);
        tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA) + 1000;
        ctrl.dataFormatDailyAdjustment = 60 * ctrl.unixDay;

        $scope.runtimeRainfallTableService.start = tmpDates.startDate - ctrl.dataFormatDailyAdjustment;
        if (new Date(ctrl.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
            $scope.runtimeRainfallTableService.end = tmpDatesA;
        } else {
            $scope.runtimeRainfallTableService.end = tmpDates.endDate;
        }

        $scope.runtimeRainfallTableService.startRow = 1;
        $scope.runtimeRainfallTableService.pageSize = 50;
        $scope.runtimeRainfallTableService.customerId = ctrl.accountInfo.customerId;
        $scope.runtimeRainfallTableService.deviceId = ctrl.deviceId; //$scope.metarStationSelected;
        $scope.runtimeRainfallTableService.deviceType = ctrl.deviceType;
        $scope.runtimeRainfallTableService.metarStationID = ctrl.metarStationID;
        $scope.runtimeRainfallTableService.rainfallSite = ctrl.rainfallSite;
        $scope.runtimeRainfallTableService.unit = ctrl.unit;
        $scope.runtimeRainfallTableService.lookupMeasurementID = ctrl.accountInfo.preferenceUser.lookupMeasurementID;
        $scope.runtimeRainfallTableService.initialUnit = ctrl.initialUnit;

        $scope.runtimeRainfallTableService.windowTitle = $scope.windowTitle;
        $scope.alerts = [];
        $scope.runtimeRainfallTableService.temperatureUnit = ctrl.accountInfo.preferenceUser.lookupMeasurementID;
        $scope.runtimeRainfallTableService.rainfallUnit = ctrl.unit; //ctrl.accountInfo.preferenceUser.lookupMeasurementID;
        $scope.runtimeRainfallTableService.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.runtimeRainfallTableService.metarStationName = ctrl.currentSelectedDevice.deviceName; //required to display appropriate name on mobile device.

        sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
            deviceId: ctrl.deviceId,
            dataMin: tmpDates.startDate,
            dataMax: tmpDates.endDate,
            zoomMin: tmpDates.startDate + ctrl.unixDay,
            zoomMax: tmpDates.endDate - ctrl.unixDay,
            windowId: ctrl.windowId
        });

        $scope.runtimeRainfallTableService.Next();
        //});
    };

    // remember where I'm scrolled to in StickyProps, for use when switching to chart
    var _updateZoom = function _updateZoom(currentRow) {
        if (isNaN(currentRow)) return;

        var zoomMin = currentRow - ctrl.paddingZoom;
        var zoomMax = currentRow + ctrl.paddingZoom;

        var dateMin = ctrl.stickyProperties.dateMin;
        var dateMax = ctrl.stickyProperties.dateMax;

        if (zoomMin < ctrl.stickyProperties.dateMin) {
            dateMin = zoomMin;
        }
        if (zoomMax > ctrl.stickyProperties.dateMax) {
            dateMax = zoomMax;
        }

        sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
            dataMin: dateMin,
            dataMax: dateMax,
            zoomMin: zoomMin,
            zoomMax: zoomMax,
            windowId: ctrl.windowId,
            deviceId: ctrl.deviceId
        });
    };

    //Initialize the scroll position after the data are first loaded
    var _autoScroll = function _autoScroll() {
        if ($scope.runtimeRainfallTableService.numberOfNewRecordsPrevious > 0) {
            var trRow = ctrl.element.find('tr').eq($scope.runtimeRainfallTableService.numberOfNewRecordsPrevious - 1);
            var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
            ctrl.element.scrollTop(yPosition);
        } else {
            $timeout(function () {
                ctrl.element.animate({
                    scrollTop: 5
                }, 500);
            }, 0);
        }
    };

    //Start the process of refreshing the whole table
    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.currentSelectedDevice.deviceName, 'View reloading');
        ctrl.myDate = new Date();
        ctrl.selectMyDate();
    };

    //Get Data and draw
    ctrl.GetRain = function () {
        getRainfallUnit(ctrl.currentSelectedDevice.rainfallSite).then(function (resp) {
            // after fetching ctrl.unit 
            ctrl.currentScrollbarPosition = 0;
            ctrl.previousScrollbarPosition = 0;
            ctrl.checkFirstRowLiveStatus = null;

            $scope.runtimeRainfallTableService = new runtimeRainfallTableService();
            $scope.runtimeRainfallTableService.customerId = ctrl.accountInfo.customerId;
            $scope.runtimeRainfallTableService.deviceId = ctrl.deviceId;
            $scope.runtimeRainfallTableService.metarStationID = ctrl.currentSelectedDevice.metarStationID;

            $scope.runtimeRainfallTableService.customerId = ctrl.accountInfo.customerId;
            $scope.runtimeRainfallTableService.deviceId = ctrl.deviceId;
            $scope.runtimeRainfallTableService.deviceType = ctrl.deviceType;
            $scope.runtimeRainfallTableService.metarStationID = ctrl.metarStationID;
            $scope.runtimeRainfallTableService.rainfallSite = ctrl.rainfallSite;
            $scope.runtimeRainfallTableService.unit = ctrl.unit;
            $scope.runtimeRainfallTableService.lookupMeasurementID = ctrl.accountInfo.preferenceUser.lookupMeasurementID;
            $scope.runtimeRainfallTableService.initialUnit = ctrl.initialUnit;

            $scope.runtimeRainfallTableService.windowTitle = $scope.windowTitle;
            $scope.runtimeRainfallTableService.startRow = 1;
            $scope.runtimeRainfallTableService.pageSize = 50;
            $scope.alerts = [];

            if (ctrl.stickyProperties.dateMin && ctrl.stickyProperties.dateMax) {
                $scope.runtimeRainfallTableService.start = ctrl.stickyProperties.dateMin;
                $scope.runtimeRainfallTableService.end = ctrl.stickyProperties.dateMax;
                $scope.runtimeRainfallTableService.Reload();
            } else {
                ctrl.stickyProperties.on = false;
                timeLapseService.getLocalDateTime().then(function (result) {
                    var endDate = new Date(result.data.localDateTime);
                    //   endDate = endDate.setDate(endDate.getDate() + 1);
                    //   endDate = endDate.setHours(20, 0, 0, 0);
                    //   var startDate = endDate.setDate(start.getDate() - 50);
                    //   startDate =  startDate.setHours(20, 0, 0, 0);
                    //   var startUnix = startDate.getTime();
                    //   var endUnix =  endDate.getTime();
                    var start = new Date(result.data.localDateTime);
                    start.setDate(start.getDate() - 50);
                    start.setHours(20, 0, 0, 0);
                    var startUnix = start.getTime();
                    var end = new Date(result.data.localDateTime);
                    end.setDate(end.getDate() + 1);
                    end.setHours(20, 0, 0, 0);
                    var endUnix = end.getTime();
                    $scope.runtimeRainfallTableService.start = startUnix - 3 * ctrl.unixDay - ctrl.dataFormatDailyAdjustment;
                    $scope.runtimeRainfallTableService.end = endUnix;

                    $scope.runtimeRainfallTableService.Reload();
                });
            }

            $scope.runtimeRainfallTableService.temperatureUnit = ctrl.accountInfo.preferenceUser.lookupMeasurementID;
            $scope.runtimeRainfallTableService.rainfallUnit = ctrl.unit; //ctrl.accountInfo.preferenceUser.lookupMeasurementID;
            $scope.runtimeRainfallTableService.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
            $scope.runtimeRainfallTableService.metarStationName = ctrl.currentSelectedDevice.deviceName; //required to display appropriate name on mobile device.
        });
        //});
    };
}

RuntimeRainfallTableController.$inject = ['$', '$q', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', '$timeout', '$filter', '$element', 'runtimeRainfallTableService', 'timeLapseService', 'websocketService', 'toaster'];
'use strict';

angular.module('mc.rainfall', []);
'use strict';

angular.module('mc.rainfall').component('runtimeRainfallDataTable', {
    controller: RuntimeRainfallTableController,
    templateUrl: 'ui/rainfall/runtimeTable/runtime-rainfall-table-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
//function RuntimeRainfallDataFactory(HOST, $http) {

//      // instantiate our initial object
//      var RainfallData = function (customerId, deviceId, startRow, pageSize, startDate, endDate) {
//          this.customerId = customerId;
//          this.deviceId = deviceId;
//          this.startRow = startRow;
//          this.pageSize = pageSize;
//          this.startDate = startDate;
//          this.endDate = endDate;
//          //this.timeZone = timeZone;
//          //this.stickyProperties = stickyProperties;
//      };

//      RainfallData.prototype.getDeviceData = function () {
//          var self = this;
//          return $http.get(HOST + "/api/MetarRainfallTable" +
//                  //"?customerId=" + this.customerId + //TODO: include customerId, eventhough we dont use it.
//                  "?deviceId=" + this.deviceId +
//                  "&StartRow=" + this.startRow +
//                  "&PageSize=" + this.pageSize +
//                  "&StartDate=" + this.startDate +
//                  "&EndDate=" + this.endDate
//              ).then(function (response) {
//                  self.list = response.data;
//                  self.loading = false;
//                  return response;
//              });
//      };

//      RainfallData.prototype.getAirportData = function () {
//          var self = this;
//          return $http.get(HOST + "/api/MetarRainfallTable" +
//                  "?customerId=" + this.customerId + 
//                  //"?deviceId=" + this.deviceId +
//                  "&StartRow=" + this.startRow +
//                  "&PageSize=" + this.pageSize +
//                  "&StartDate=" + this.startDate +
//                  "&EndDate=" + this.endDate
//              ).then(function (response) {
//                  self.list = response.data;
//                  self.loading = false;
//                  return response;
//              });
//      };

//      return RainfallData;
//  }

//  RuntimeRainfallDataFactory.$inject = ['HOST', '$http'];

//  angular.module('mc.rainfall').factory('RuntimeRainfallDataFactory', RuntimeRainfallDataFactory);
"use strict";
"use strict";

angular.module("mc.signal-connect-calendar", []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SignalConnectCalendarFactory = function SignalConnectCalendarFactory($http, HOST) {
    var SignalConnectCalendar = function () {
        function SignalConnectCalendar(customerId, deviceId) {
            _classCallCheck(this, SignalConnectCalendar);

            this.customerId = customerId;
            this.deviceId = deviceId;
            this.busy = false;
        }

        _createClass(SignalConnectCalendar, [{
            key: 'getData',
            value: function getData(startDate, endDate, timeZone) {
                if (this.busy) return;
                this.busy = true;
                var url = HOST + '/api/SignalCalendar?deviceId=' + this.deviceId + '&customerId=' + this.customerId + '&startDate=' + startDate + '&endDate=' + endDate + '&timeZone=' + timeZone;
                return $http.get(url);
            }
        }]);

        return SignalConnectCalendar;
    }();

    return SignalConnectCalendar;
};

SignalConnectCalendarFactory.$inject = ['$http', 'HOST'];

angular.module('mc.signal-connect-calendar').factory('SignalConnectCalendarFactory', SignalConnectCalendarFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function SignalConnectCalendarController(_, $scope, translationService, authenticationService, datetimeService, SignalConnectCalendarFactory, $timeout, $element, sharedSetupService, openViewService) {

    var ctrl = this;

    ctrl.$onInit = function () {

        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.lang = ctrl.accountInfo.preferenceUser.i18nCode;

        ctrl.translation = translationService.translation;

        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.liveDataOffset = sharedSetupService.liveDataOffset;

        //need for legacy directives/controllers
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.stickyProperties = ctrl.stickyProperties;
        //need for legacy directives/controllers

        ctrl.downloadViewTypeOptions = [0, 4];
        ctrl.downloadOptions = { resolution: 5 };

        ctrl.calendarHeight = "auto";

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = ctrl.stickyPropertiesInterface;

        ctrl.element = $element.find(".calendar-container");

        //Manage Dialog Geometry
        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
            ctrl.calendarHeight = ctrl.popup.outerHeight() - 90;

            var _resizeStop = function _resizeStop() {
                ctrl.calendarHeight = ctrl.popup.outerHeight() - 90;
                //ctrl.fullCalendar.fullCalendar('option', 'height', ctrl.calendarHeight);
                //ctrl.fullCalendar.fullCalendar('refresh');
                // $scope.$apply();
                ctrl.popup.find('.fc-time-grid').css("height", ctrl.calendarHeight / 6);
                ctrl.popup.find('.fc-slats td').css("height", ctrl.calendarHeight / 6);
                ctrl.fullCalendar.fullCalendar('refresh');
                $scope.$apply();
            };

            var _resize = function _resize() {
                $timeout(function () {

                    ctrl.calendarHeight = ctrl.popup.outerHeight() - 127;
                    ctrl.popup.find('.fc-time-grid').css('height', ctrl.calendarHeight / 6);
                    ctrl.popup.find('.fc-slats td').css('height', ctrl.calendarHeight / 6);

                    if (ctrl.fullCalendar) {
                        ctrl.fullCalendar.fullCalendar('option', 'contentHeight', ctrl.calendarHeight - 26);
                        ctrl.fullCalendar.fullCalendar('refresh');
                    }
                });
            };

            ctrl._resize = _resize;

            ctrl.popup.dialog({
                resizeStop: function resizeStop(event, ui) {
                    $('#map').removeClass('no-events');
                    _resizeStop();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    _resize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    _resize();
                }
            });

            $scope.$on('contentAdjusted', function () {
                _resize();
            });
        }
    };

    ctrl.setHideLegend = function ($event) {
        ctrl.hideLegend = !ctrl.hideLegend;
    };

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            var firstDay, lastDay;
            ctrl.element.empty();
            ctrl.currentDeviceId = newValue;

            if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.zoomMin !== null) {
                ctrl.stickyProperties.on = true;
                var zoomDate = new Date(ctrl.stickyProperties.zoomMin); // datetimeService.unixtimeToDate($scope.stickyProperties.zoomMin);
                firstDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth(), 1);
                lastDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth() + 1, 0);
                ctrl.startDateUnix = datetimeService.dateToUnixtime(firstDay);
                ctrl.endDateUnix = datetimeService.dateToUnixtime(lastDay);
            } else {
                ctrl.stickyProperties.on = false;
                var currentDate = new Date();
                firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
                lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
            }
            ctrl.SignalConnectCalendarFactory = new SignalConnectCalendarFactory(ctrl.accountInfo.customerId, newValue);
            ctrl.SignalConnectCalendarFactory.getData(datetimeService.dateToUnixtime(firstDay), datetimeService.dateToUnixtime(lastDay), ctrl.accountInfo.timeZone).then(function (result) {
                ctrl.SignalConnectCalendarFactory.busy = false;
                ctrl.signalCalendarData = result.data;
                _drawCalendar(newValue);
            }, function (error) {
                ctrl.enableButtons();
                ctrl.SignalConnectCalendarFactory.busy = false;
            });
        }
    }, true);

    //following method is used when top-menu refresh button is clicked
    ctrl.mostRecentData = function () {
        ctrl.element.empty();
        toaster.pop('success', "Signal Calendar" + " -- " + ctrl.signalCalendarData.device.name, 'View reloading');
        _drawCalendar(ctrl.currentDeviceId);
    };

    // on initial load, we highlight LAST 7 days from date passed (backward)
    // but if user selects particular date, then we highlight NEXT 7 days from date passed. (forward)
    // so we are passing direction to identify forward or backward
    ctrl.addDateRangeBackgroundColor = function (date, direction, noOfDays) {
        ctrl.initalialized = true;
        var el, shortDate, dataDate;
        //Remove previous highlighted range
        $(ctrl.element).find('[data-date]').removeClass("fc-date-range-selected");

        // calculate how many days it has to highlight background
        var noOfDaysToHighlight = 7; // default 7 days
        if (noOfDays) noOfDaysToHighlight = noOfDays;

        var today = new Date();

        //Add highlighted range 7 days from date
        for (var i = 0; i < noOfDaysToHighlight; i++) {
            //creating date from unix format of the date
            date = new Date(date);

            //highlight the date if it is less than tomorrow
            if (date.getMonth() === today.getMonth() && date.getDate() <= today.getDate() || date.getMonth() < today.getMonth()) {
                shortDate = moment(date).format("YYYY-MM-DD");
                //Add range-selected class based on 'data-date'
                dataDate = "[data-date=" + "'" + shortDate + "']";
                el = $(ctrl.element).find(dataDate);
                $(el).addClass("fc-date-range-selected");
            }
            //console.log("After Set --> index: " + i +" Dt: " + date);

            if (direction === 'forward') {
                //increment to next day
                date = date.setDate(date.getDate() + 1);
                // do not highlight if date is after today
                var nextDate = new Date(date);
                if (nextDate.getMonth() === today.getMonth() && nextDate.getDate() > today.getDate()) break;
                //console.log("Forward --> Dt: " + new Date(date));
            } else if (direction === 'backward') {
                //decrement to prev day
                date = date.setDate(date.getDate() - 1);
                //console.log("backward --> Dt: " + new Date(date));
            }
        }
    };

    //Runs on initial load to addDateRangeBackgroundColor based on current day
    $scope.getRangeStartDate = function () {
        if (!ctrl.initalialized) {
            //console.log("Before Initialized st.Dt: " + new Date() );
            ctrl.addDateRangeBackgroundColor(new Date(), 'backward');
            ctrl.initalialized = true;
        }
    };

    var container;
    var _drawCalendar = function _drawCalendar(deviceID) {

        container = document.createElement('div');
        ctrl.element.append(container);

        ctrl.fullCalendar = $(container).fullCalendar({
            fixedWeekCount: false,
            contentHeight: ctrl.calendarHeight,
            defaultDate: ctrl.startDateUnix,
            ignoreTimezone: true,
            lang: ctrl.lang,
            header: {
                left: 'title',
                center: '',
                right: 'today prev,next'
            },
            buttonText: {
                today: ctrl.translation.text.CURRENT_MONTH
            },
            businessHours: false, // display business hours
            editable: false,
            // events: calendarModel,
            viewRender: function viewRender(view, element) {
                if (view.start !== $scope.viewstart) {
                    ctrl.disableButtons();
                    $scope.viewstart = view.start;
                    $(container).fullCalendar('removeEvents');
                    //$timeout(function() {

                    if (!ctrl.initalialized) {
                        if ($(container).fullCalendar('getView').intervalEnd) {

                            var NewEvents = ctrl.signalCalendarData.calendarModel; //result.data.calendarModel; //ctrl.signalCalendarData; //
                            for (var i = 0; i < new Date($(container).fullCalendar('getView').intervalEnd.year(), $(container).fullCalendar('getView').intervalEnd.month(), 0).getDate(); i++) {
                                var newEvent = {};
                                if (NewEvents[i]) {
                                    var eventDate = new Date(NewEvents[i].start);

                                    if (i + 1 !== eventDate.getDate()) {
                                        newEvent = {
                                            allDay: true,
                                            className: 'signal-calendar',
                                            start: eventDate.getMonth() + 1 + '/' + (i + 1) + '/' + eventDate.getFullYear(),
                                            color: '#ff0000',
                                            title: '0%/0'
                                        };

                                        NewEvents.splice(i, 0, newEvent);
                                    }
                                } else {
                                    if (new Date($(container).fullCalendar('getView').intervalEnd.year(), $(container).fullCalendar('getView').intervalEnd.month() - 1, i + 1) <= new Date()) {
                                        newEvent = {
                                            allDay: true,
                                            className: 'signal-calendar',
                                            start: $(container).fullCalendar('getView').intervalEnd.month() + '/' + (i + 1) + '/' + $(container).fullCalendar('getView').intervalEnd.year(),
                                            color: '#ff0000',
                                            title: '0%/0'
                                        };

                                        NewEvents.push(newEvent);
                                    }
                                }
                            }

                            var clientEvents = $(container).fullCalendar('clientEvents');
                            for (var i = 0; i < clientEvents.length; i++) {
                                $(container).fullCalendar('removeEventSource', clientEvents[i].source);
                            }
                            $(container).fullCalendar('addEventSource', NewEvents);
                            var d = $(container).fullCalendar('getView').intervalEnd;
                            var month = d.month() === 1 ? 0 : d.month() - 1;
                            var middledate = new Date(d.year(), month, 15);
                            if (new Date() < middledate) {
                                middledate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                            }
                            var middleUnix = datetimeService.dateToUnixtime(middledate);
                            var tmpDataMin = middleUnix - 24 * 3600 * 1000,
                                tmpDataMax = middleUnix + 48 * 3600 * 1000,
                                tmpZoomMin = middleUnix,
                                tmpZoomMax = middleUnix + 24 * 3600 * 1000;
                            var _device = { deviceName: ctrl.signalCalendarData.device.name };
                            ctrl.deviceSelectedName = ctrl.signalCalendarData.device.name;
                            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceID, device: _device, dataMin: tmpDataMin, dataMax: tmpDataMax, zoomMin: tmpZoomMin, zoomMax: tmpZoomMax, windowId: $scope.windowId });
                            ctrl.enableButtons();
                        }
                        //get initial date range for selected calendar to add background color
                        $scope.getRangeStartDate();
                    } else {
                        ctrl.SignalConnectCalendarFactory = new SignalConnectCalendarFactory(ctrl.accountInfo.customerId, deviceID);
                        ctrl.SignalConnectCalendarFactory.getData(view.start, view.end, ctrl.accountInfo.timeZone).then(function (result) {
                            if ($(container).fullCalendar('getView').intervalEnd) {
                                ctrl.signalCalendarData = result.data;
                                var NewEvents = result.data.calendarModel;
                                //var NewEvents = ctrl.signalCalendarData;//.calendarModel; //result.data.calendarModel; //ctrl.signalCalendarData; //
                                for (var i = 0; i < new Date($(container).fullCalendar('getView').intervalEnd.year(), $(container).fullCalendar('getView').intervalEnd.month(), 0).getDate(); i++) {
                                    var newEvent = {};
                                    if (NewEvents[i]) {
                                        var eventDate = new Date(NewEvents[i].start);

                                        if (i + 1 !== eventDate.getDate()) {
                                            newEvent = {
                                                allDay: true,
                                                className: 'signal-calendar',
                                                start: eventDate.getMonth() + 1 + '/' + (i + 1) + '/' + eventDate.getFullYear(),
                                                color: '#ff0000',
                                                title: '0%/0'
                                            };

                                            NewEvents.splice(i, 0, newEvent);
                                        }
                                    } else {
                                        if (new Date($(container).fullCalendar('getView').intervalEnd.year(), $(container).fullCalendar('getView').intervalEnd.month() - 1, i + 1) <= new Date()) {
                                            newEvent = {
                                                allDay: true,
                                                className: 'signal-calendar',
                                                start: $(container).fullCalendar('getView').intervalEnd.month() + '/' + (i + 1) + '/' + $(container).fullCalendar('getView').intervalEnd.year(),
                                                color: '#ff0000',
                                                title: '0%/0'
                                            };

                                            NewEvents.push(newEvent);
                                        }
                                    }
                                }

                                var clientEvents = $(container).fullCalendar('clientEvents');
                                for (var i = 0; i < clientEvents.length; i++) {
                                    $(container).fullCalendar('removeEventSource', clientEvents[i].source);
                                }
                                $(container).fullCalendar('addEventSource', NewEvents);
                                var d = $(container).fullCalendar('getView').intervalEnd;
                                var month = d.month() === 1 ? 0 : d.month() - 1;
                                var middledate = new Date(d.year(), month, 15);
                                if (new Date() < middledate) {
                                    middledate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                                }
                                var middleUnix = datetimeService.dateToUnixtime(middledate);
                                var tmpDataMin = middleUnix - 24 * 3600 * 1000,
                                    tmpDataMax = middleUnix + 48 * 3600 * 1000,
                                    tmpZoomMin = middleUnix,
                                    tmpZoomMax = middleUnix + 24 * 3600 * 1000;
                                var _device = { deviceName: ctrl.signalCalendarData.device.name };
                                ctrl.deviceSelectedName = ctrl.signalCalendarData.device.name;
                                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceID, device: _device, dataMin: tmpDataMin, dataMax: tmpDataMax, zoomMin: tmpZoomMin, zoomMax: tmpZoomMax, windowId: $scope.windowId });
                                ctrl.enableButtons();
                            }
                            //get initial date range for selected calendar to add background color
                            $scope.getRangeStartDate();
                            //$scope.calendarLoading = false;
                            ctrl.SignalConnectCalendarFactory.busy = false;
                        }, function (error) {
                            ctrl.enableButtons();
                            ctrl.SignalConnectCalendarFactory.busy = false;
                        });
                    }
                    //});
                }
            }
        });

        $(container).fullCalendar('gotoDate', ctrl.startDateUnix);
        addMonthButtonListeners();

        if (!ctrl.mobile && !ctrl.classicView) ctrl._resize();
    };

    var addMonthButtonListeners = function addMonthButtonListeners() {
        //Add Listener for Prev Month
        var prevMonth = $(ctrl.element).find('.fc-prev-button');
        $(prevMonth).click(function () {
            //console.log("prev");
            //Add Logic Here
        });

        //Add Listener for Next Month
        var nextMonth = $(ctrl.element).find('.fc-next-button');
        $(nextMonth).click(function () {
            //console.log("next");
            //Add Logic Here
        });

        //Add Listener for Current Month
        var currentMonth = $(ctrl.element).find('.fc-today-button');
        $(currentMonth).click(function () {
            //console.log("current month");
            //Add Logic Here
        });
    };

    ctrl.fnDrawCalendar = function (varDeviceId) {
        $(container).fullCalendar('destroy');
        _drawCalendar(varDeviceId);
    };

    ctrl.disableButtons = function () {
        $(ctrl.element).find(".fc-prev-button").prop('disabled', true);
        $(ctrl.element).find(".fc-prev-button").addClass('fc-state-disabled');
        $(ctrl.element).find(".fc-next-button").prop('disabled', true);
        $(ctrl.element).find(".fc-next-button").addClass('fc-state-disabled');
    };

    ctrl.enableButtons = function () {
        $(ctrl.element).find(".fc-prev-button").removeClass('fc-state-disabled');
        $(ctrl.element).find(".fc-prev-button").prop('disabled', false);
        $(ctrl.element).find(".fc-next-button").removeClass('fc-state-disabled');
        $(ctrl.element).find(".fc-next-button").prop('disabled', false);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.lang = ctrl.accountInfo.preferenceUser.i18nCode;
        ctrl.fnDrawCalendar($scope.deviceSelected);
    });

    $scope.$on("$destroy", function () {
        if (ctrl.fullCalendar) $(container).fullCalendar('destroy');
    });
};

SignalConnectCalendarController.$inject = ['_', '$scope', 'translationService', 'authenticationService', 'datetimeService', 'SignalConnectCalendarFactory', '$timeout', '$element', 'sharedSetupService', 'openViewService'];
'use strict';

angular.module('mc.signal-connect-calendar').component('signalConnectCalendar', {
    controller: SignalConnectCalendarController,
    templateUrl: 'ui/signalconnect/calendar/signal-connect-calendar-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.factory('rainfallDataTableService', ['$http', 'datetimeService', 'translationService', 'HOST',
    function ($http, datetimeService, translationService, host) {
        var rainfallDataTableService = function () {
            this.items = [];
            this.setting = [];
            this.metarStationName = 'loading...';
            this.customerId = null;
            this.deviceId = null;
            this.temperatureUnit = 1;
            this.rainfallUnit = 1;
            this.timeFormat = 1;
            this.startRow = 1;
            this.pageSize = 50;
            this.start = '19000101';
            this.end = '19000101';
            this.busy = false;
            this.numberOfReturnedRecords = -1;
            this.numberOfRecords = -1;
            this.tdWidth = null;
            this.alerts = [];
            this.translation = translationService.translation;
            this.lastUpdateAt = null;
        };

        rainfallDataTableService.prototype.Poll = function () {
            this.LoadData(-this.pageSize, true);
        };

        rainfallDataTableService.prototype.PreviousPage = function () {
            this.LoadData(-this.pageSize);
        };

        rainfallDataTableService.prototype.NextPage = function () {
            this.LoadData(this.pageSize);
        };

        rainfallDataTableService.prototype.Reload = function () {
            this.items = [];
            this.alerts = [];
            this.startRow = 1;
            this.LoadData(this.pageSize);
        };

        rainfallDataTableService.prototype.LoadLiveData = function (item) {
            this.alerts = [];
            this.numberOfReturnedRecords = 1; // only one item is returned
            this.startRow = this.startRow + 1;

            //add new records to the beginning or end:
            this.items.unshift(item);
            this.numberOfRecords = this.items.length;

            //Get the first and last date, so I know how to get prev/next records in the future
            if (this.numberOfRecords > 0) {
                this.start = _getFirstDate(this.items);
                this.end = _getLastDate(this.items);
            }
        };

        rainfallDataTableService.prototype.fetchSettings = function(deviceId) {
            return $http.get(host+"/api/ParmPulse?deviceId="+deviceId);
        }

        remove_duplicates = function(arr) {
            var obj = {};
            var ret_arr = [];
            for (var i = 0; i < arr.length; i++) {
                obj[arr[i].localDateTime] = arr[i]; //localDateTime should be unique across the array items
            }
            for (var key in obj) {
                ret_arr.push(obj[key]);
            }
            return ret_arr;
        }

        rainfallDataTableService.prototype.LoadData = function (pageSize, blinkTheLight) {
            this.pageSize = pageSize;
            if (this.busy) return;
            this.busy = true;
            var url = '';
            var intDayWindow = 1;
            var intDay = 86400000;
            var intHour = 3600000;
            if (!angular.isDefined(this.deviceId)) return;
            var metarStationID = this.metarStationID ? this.metarStationID : -1;
            var startRow = this.startRow;
            if (pageSize < 0)
            {
                this.start =  this.end;
                this.end = this.end + (intDayWindow * intDay);
            }
            if(this.deviceId === 0){
                url = host + "/api/MetarRainfallTable" +
                    "?customerId=" + this.customerId +
                    "&StartRow=" + startRow +
                    "&PageSize=" + this.pageSize +
                    "&StartDate=" + this.start +
                    "&EndDate=" + this.end +
                    "&metarStationId=" + metarStationID;
            } else if (this.deviceId > 0) {
                url = host + "/api/MetarRainfallTable" +
                    "?deviceId=" + this.deviceId +
                    "&StartRow=" + startRow +
                    "&PageSize=" + this.pageSize +
                    "&StartDate=" + this.start +
                    "&EndDate=" + this.end;
            }

            $http.get(url).then(function (result) {
                //console.log('Request:');
                //console.log('   start: [' + this.start + ']' + new Date(this.start));
                //console.log('   end:   [' + this.end + ']' + new Date(this.end));

                this.numberOfReturnedRecords = result.data.reports.length;

                if (this.startRow === 1)
                    this.startRow = result.data.reports.length;
                else if (pageSize !== 0) //a live refresh re-reads the top of the list, so it must not move the paging offset
                    this.startRow = this.startRow + result.data.reports.length;

                if (this.deviceId === 0) {
                    this.metarStationName = _formatMetarStationName(result.data.metarStation);
                }
                //add new records to the beginning or end:
                if (pageSize > 0) this.items = this.items.concat(result.data.reports);
                if (pageSize <= 0) this.items = result.data.reports.concat(this.items);
                this.items = remove_duplicates(this.items); //TODO: improve this code.
                this.numberOfRecords = this.items.length;


                //Get the first and last date, so I know how to get prev/next records in the future
                if (this.numberOfRecords > 0) {
                    this.start = _getFirstDate(this.items);
                    this.end = _getLastDate(this.items);
                }

                //if (result.data.reports && result.data.reports.length > 0) {
                //    console.log('Response');
                //    console.log('   result.data.reports.length:' + result.data.reports.length);
                //    console.log('   First: [' + this.start + ']' + new Date(this.start));
                //    console.log('   Last:  [' + this.end + ']' + new Date(this.end));
                //}

                if (this.numberOfReturnedRecords > 0 && blinkTheLight)
                    this.lastUpdateAt = this.items[0].localDateTime;

                //Make toast if next page has no result
                if (this.numberOfReturnedRecords === 0 && pageSize > 0) {
                    // If we didn't get any items back AND there aren't already any items
                    if (this.items.length === 0) {
                        this.alerts = [];
                        var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                        this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                    }
                }
                this.pageSize = 50;
                this.busy = false;
            }.bind(this), function (error) {
                this.alerts = [];
                var errorMessage = eval("this.translation.message." + error.data.message);
                this.alerts.push({
                    msg: errorMessage, type: "danger"
                });
                this.pageSize = 50;
                this.busy = false;
            }.bind(this));
        }

        var _getFirstDate = function (array) {
            var intDayWindow = 10;
            var intDay = 86400000;
            return datetimeService.toUnixtime(array[array.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
        };

        var _getLastDate = function (array) {
            return datetimeService.toUnixtime(array[0].localDateTime.replace(/\D/g, ''));
        };

        var _formatMetarStationName = function (metarStation) {
            var result = '';
            if (metarStation.city.length > 0) result += metarStation.city;
            if (metarStation.state.length > 0 && result.length > 0) result += ', ';
            if (metarStation.state.length > 0) result += metarStation.state;
            if (metarStation.icao.length > 0) result += ' (' + metarStation.icao + ')';
            return result;
        }

        return rainfallDataTableService;
    }]);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RainfallDataTableController($, $q, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, $timeout, $filter, $element, rainfallDataTableService, timeLapseService, websocketService, toaster) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    ctrl.popup = null;
    ctrl.downloadViewTypeOptions = [0, 4];
    ctrl.downloadOptions = { resolution: 0 };
    ctrl.unit = null;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.infiniteScrollOn = false;
        ctrl.infiniteScrollUpOn = false;
        ctrl.infiniteScrollDownOn = false;
        ctrl.calculatedFirstRowLiveStatus = null; //determines what is the calculated value based on scroll position of the first row of the table data.
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.isListeningToLiveData = false; // determines whether UI is listening to live data or not
        ctrl.liveDataIn = false; //this is for blinking purpose only
        ctrl.liveDataOffset = sharedSetupService.liveDataOffset;
        $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
        ctrl.translation = translationService.translation;
        ctrl.pollInterval = 60; //poll interval seconds = pollInterval/15
        ctrl.currentScrollbarPosition = 0;
        ctrl.previousScrollbarPosition = 0;
        ctrl.windowSubtitle = "Loading...";
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        ctrl.paddingZoom = Math.round((ctrl.stickyProperties.zoomMax - ctrl.stickyProperties.zoomMin) / 2);
        ctrl.calculatedFirstRowLiveStatus = null;
        ctrl.paddingZoom = ctrl.paddingZoom === 0 ? ctrl.unixDay / 2 : ctrl.paddingZoom;

        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        $scope.alerts = [];

        $scope.rainfallDataTableService = new rainfallDataTableService();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        $scope.windowTitle = eval("translationService.translation.text.AIRPORT_RAINFALL");

        ctrl.liveTable = $element.find(".headertable");

        //Get my icon based on my title
        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        //Change the title when the service changes the weather station name
        $scope.$watch('rainfallTableService.metarStationName', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue !== oldValue) {
                if (!$rootScope.mobile && !$rootScope.classicView) ctrl.popup.dialog("option", "title", $scope.windowTitle + ", " + newValue);
            }
        }, true);

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        }

        //Handle infinite scrolling
        $timeout(function () {
            //find the element of the chart class
            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.element = $element.find('.rainfall-data-table-template .tabular-data-container');
            } else {
                ctrl.element = $element.find('.rainfall-data-table-template .tabular-data-container-mobile');
            }

            ctrl.element.on('scroll', function (event) {
                var $rowFirst = ctrl.element.contents().find("tr:first");
                var $rowLast = ctrl.element.contents().find("tr:last");
                if (typeof $rowFirst.position() !== "undefined") {
                    ctrl.infiniteScrollOn = true;
                    ctrl.infiniteScrollUpOn = true;
                    ctrl.infiniteScrollDownOn = true;
                    ctrl.calculateLiveDataStatus();
                    ctrl.previousScrollbarPosition = ctrl.currentScrollbarPosition;
                    ctrl.currentScrollbarPosition = ctrl.element[0].scrollTop;
                }

                if (ctrl.infiniteScrollOn === true) {
                    ctrl.infiniteScrollUpOn = true;
                    ctrl.infiniteScrollDownOn = true;

                    if (ctrl.currentScrollbarPosition <= 35 && ctrl.previousScrollbarPosition > 35) ctrl.calculatedFirstRowLiveStatus = null;

                    if (ctrl.infiniteScrollDownOn === true && ctrl.element[0].scrollTop + ctrl.element[0].offsetHeight + 5 > ctrl.element[0].scrollHeight) {
                        $rowLast.addClass("active-row");
                        $scope.rainfallDataTableService.alerts = [];
                        $scope.rainfallDataTableService.NextPage();
                    }
                    if (ctrl.infiniteScrollUpOn === true && ctrl.element[0].scrollTop < 5 && ctrl.currentScrollbarPosition < ctrl.previousScrollbarPosition) {
                        $rowFirst.addClass("active-row");
                        $scope.rainfallDataTableService.alerts = [];
                        $scope.rainfallDataTableService.PreviousPage();
                    }
                }

                var rows = ctrl.element.children().children().children().children();
                var scrollpos = 40;
                var start = 0;
                var end = rows.length;
                var count = 0;

                while (start != end) {
                    count++;
                    var mid = start + Math.floor((end - start) / 2);
                    if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
                }
                _updateZoom(parseFloat($($(rows[start])).attr("name")));
                //+.log("$scope.stickyProperties: " +
                //    "currRow: " + new Date(parseFloat($($(rows[start])).attr("name"))).toLocaleString() + ", " +
                //    "dateMin: " + new Date($scope.stickyProperties.dateMin).toLocaleString() + ", " +
                //    "dateMax: " + new Date($scope.stickyProperties.dateMax).toLocaleString() + ", " +
                //    "zoomMin: " + new Date($scope.stickyProperties.zoomMin).toLocaleString() + ", " +
                //    "zoomMax: " + new Date($scope.stickyProperties.zoomMax).toLocaleString());
            });
        });

        //Blink the light when data received
        $scope.$watch('rainfallDataTableService.lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                $scope.lastUpdateAt = newValue;
                ctrl.liveDataIn = !ctrl.liveDataIn;
                $timeout(function () {
                    ctrl.liveDataIn = !ctrl.liveDataIn;
                }, 3000);
            }
        }, true);

        //Listen for alerts
        $scope.$watch('rainfallDataTableService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue !== oldValue) {
                $scope.alerts = newValue;
            }
        }, true);

        //Handle Preferences:Weather station was changed
        $scope.$on('updatePreferenceWeather', function (event, args) {
            ctrl.currentScrollbarPosition = 0;
            ctrl.previousScrollbarPosition = 0;
            ctrl.calculatedFirstRowLiveStatus = null;
            $scope.rainfallDataTableService.items = [];
            $scope.rainfallDataTableService.startRow = 1;
            $scope.rainfallDataTableService.pageSize = 50;
            $scope.alerts = [];
            $scope.rainfallDataTableService.start = ctrl.stickyProperties.zoomMin;
            $scope.rainfallDataTableService.end = ctrl.stickyProperties.zoomMax;
            $scope.rainfallDataTableService.Reload();
        });

        //Handle Preferences:MeasurementSystem changed
        $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            getRainfallUnit(ctrl.deviceId).then(function (resp) {
                // after fetching ctrl.unit 
                //ToDo: put these in some common place
                var MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
                var RainfallUnitEnum = { Inches: 1, Centimeters: 2 };
                var TemperatureUnitEnum = { Fahrenheit: 1, Celsius: 2 };

                switch (measurementSystem) {
                    case MeasurementSystemEnum.Imperial:
                        $scope.rainfallDataTableService.rainfallUnit = ctrl.unit;
                        $scope.rainfallDataTableService.temperatureUnit = TemperatureUnitEnum.Fahrenheit;
                        break;
                    case MeasurementSystemEnum.Metric:
                        $scope.rainfallDataTableService.rainfallUnit = ctrl.unit;
                        $scope.rainfallDataTableService.temperatureUnit = TemperatureUnitEnum.Celsius;
                        break;
                }
                ctrl.GetRain();
            });
        });

        //Handle Preferences:TimeFormat (12/24) changed
        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            $scope.rainfallDataTableService.timeFormat = timeFormat;
        });

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            if ($scope.alerts.length > 0) {
                var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment($scope.rainfallDataTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.rainfallDataTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                }
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });

        //Scroll to the right place after the table is finished drawing
        $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll(true); //just table data loaded first time, so scroll to top of table
            ctrl.calculatedFirstRowLiveStatus = null;
        });

        //Clean up when dialog is closed
        $scope.$on("$destroy", function () {
            ctrl.UnRegisterForLiveData();
            ctrl.element.empty();
        });

        //manually making call to adjustSize in order to load scrollbar
        $timeout(function () {
            ctrl.adjustSize();
        }, 500);
    };

    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            //ctrl.adjustDeviceIdMenuSize();
        }
    };

    ctrl.adjustDeviceIdMenuSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            var spph = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            if (spph < 450) {
                ctrl.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            } else {
                ctrl.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        }
    };

    //dateAgentText filter called from html
    ctrl.dateAgentText = function (date, timeFormat) {
        return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
    };

    ctrl.setLiveDataLine = function (varLiveData) {
        if (varLiveData) {
            ctrl.liveTable.addClass("live-data-line");
        } else {
            ctrl.liveTable.removeClass("live-data-line");
        }
    };

    // Listen to DeviceID change
    ctrl.setDevice = function (rainfallData) {
        ctrl.downloadOptions.reportType = rainfallData.deviceModel != 0 ? "RTU Rainfall" : "Rainfall";
        getRainfallUnit(rainfallData.deviceId).then(function (resp) {
            // after fetching ctrl.unit 
            ctrl.currentSelectedDevice = rainfallData;
            ctrl.deviceId = rainfallData.deviceId;

            //reset the live data line
            ctrl.setLiveDataLine(false);

            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
                ctrl.popup.dialog("option", "title", $scope.windowTitle + ", " + rainfallData.deviceName);
            }

            $scope.deviceId = ctrl.deviceId;
            var _device = { deviceId: $scope.deviceId, deviceName: rainfallData.deviceName };
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceId, device: _device, windowId: $scope.windowId });

            ctrl.GetRain();
        });
    };

    ctrl.selectMyDate = function () {
        ctrl.passedDate = ctrl.myDate;
        ctrl.selectMyDateA();
    };

    //Toggle the active row when user clicks
    ctrl.toggle = function ($event) {
        if ($($event.currentTarget).hasClass("active-row")) {
            $($event.currentTarget).removeClass("active-row");
        } else {
            $($event.currentTarget).addClass("active-row");
        }
    };

    var getRainfallUnit = function getRainfallUnit(deviceId) {
        var deferred = $q.defer();

        //fetch device specific settings, if it is RTU/Device
        if (deviceId > 0) {
            $scope.rainfallDataTableService.fetchSettings(deviceId).then(function (resp) {
                deferred.resolve(resp);
                if (resp.data && resp.data.length > 0) {
                    // if device is M50 then Digital As Rainfall with flowScale > 0
                    // all other devices, case -insensitive search for 'rain' OR 'plu' -- > these strings means device is connected to rainfall channel
                    ctrl.rainChannelSetting = resp.data.find(function (x) {
                        return x.channelTypeID == 1 && x.flowScale > 0 || x.channelName.search(/rain/i) > -1 || x.channelName.search(/plu/i) > -1;
                    });

                    //for RTU/DeviceId use Unit as unit
                    ctrl.unit = ctrl.rainChannelSetting.unit;
                }
            });
        } else {
            //for Airport/Weather Station pull the unit from lookupMeasurementId
            ctrl.unit = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? ctrl.translation.text.INCHES : ctrl.translation.text.CENTIMETERS;
            deferred.resolve();
        }
        return deferred.promise;
    };

    //Call me when the user changes the date
    ctrl.selectMyDateA = function () {
        //getRainfallUnit().then((resp) => { // after fetching ctrl.unit 
        $scope.rainfallDataTableService = new rainfallDataTableService();
        ctrl.currentScrollbarPosition = 0;
        ctrl.previousScrollbarPosition = 0;

        ctrl.calculatedFirstRowLiveStatus = null;
        ctrl.UnRegisterForLiveData();

        var tmpDates = ctrl.passedDate;
        var tmpDatesA = tmpDates;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
        tmpDatesA.setHours(12, 0, 0, 0);
        tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
        $scope.rainfallDataTableService.start = tmpDates.startDate;
        if (new Date(ctrl.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
            $scope.rainfallDataTableService.end = tmpDatesA;
        } else {
            $scope.rainfallDataTableService.end = tmpDates.endDate;
        }
        $scope.rainfallDataTableService.startRow = 1;
        $scope.rainfallDataTableService.pageSize = 50;
        $scope.rainfallDataTableService.customerId = ctrl.accountInfo.customerId;
        $scope.rainfallDataTableService.deviceId = ctrl.deviceId; //$scope.metarStationSelected;
        $scope.rainfallDataTableService.metarStationID = ctrl.currentSelectedDevice.metarStationID;
        $scope.rainfallDataTableService.windowTitle = $scope.windowTitle;
        $scope.alerts = [];
        $scope.rainfallDataTableService.temperatureUnit = ctrl.accountInfo.preferenceUser.lookupMeasurementID;
        $scope.rainfallDataTableService.rainfallUnit = ctrl.unit; //ctrl.accountInfo.preferenceUser.lookupMeasurementID;
        $scope.rainfallDataTableService.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.rainfallDataTableService.metarStationName = ctrl.currentSelectedDevice.deviceName; //required to display appropriate name on mobile device.


        sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
            deviceId: ctrl.deviceId,
            dataMin: tmpDates.startDate,
            dataMax: tmpDates.endDate,
            zoomMin: tmpDates.startDate + ctrl.unixDay,
            zoomMax: tmpDates.endDate - ctrl.unixDay,
            windowId: ctrl.windowId
        });

        $scope.rainfallDataTableService.NextPage();

        //after loading data, it is the time to determine live data status
        ctrl.calculateLiveDataStatus();
        //});
    };

    // remember where I'm scrolled to in StickyProps, for use when switching to chart
    var _updateZoom = function _updateZoom(currentRow) {
        if (isNaN(currentRow)) return;

        var zoomMin = currentRow - ctrl.paddingZoom;
        var zoomMax = currentRow + ctrl.paddingZoom;

        var dateMin = ctrl.stickyProperties.dateMin;
        var dateMax = ctrl.stickyProperties.dateMax;

        if (zoomMin < ctrl.stickyProperties.dateMin) {
            dateMin = zoomMin;
        }
        if (zoomMax > ctrl.stickyProperties.dateMax) {
            dateMax = zoomMax;
        }

        sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
            dataMin: dateMin,
            dataMax: dateMax,
            zoomMin: zoomMin,
            zoomMax: zoomMax,
            windowId: ctrl.windowId,
            deviceId: ctrl.deviceId
        });
    };

    // Only enable live data if the top visible row is within the past 24 hours

    //Look for new data
    var tlGetNewRainfallData = function tlGetNewRainfallData() {
        //console.log('Polling');
        // $scope.rainfallDataTableService.Poll();
    };

    ctrl.calculateLiveDataStatus = function () {
        $timeout(function () {
            var $rowFirst = ctrl.element.contents().find("tr:first");
            if (typeof $rowFirst.position() == "undefined") return;
            var firstRowTicks = parseFloat($rowFirst.attr("name")); // datetime ticks are stored in the "name" attribute

            var _tableTop = ctrl.element.offset().top;
            var _rowTop = $rowFirst.offset().top;

            if (ctrl.calculatedFirstRowLiveStatus === true) {
                //take action based on previously calculatedFirstRowLiveStatus
                if (_tableTop < _rowTop + 10) {
                    ctrl.RegisterForLiveData();
                } else {
                    ctrl.UnRegisterForLiveData();
                }
                return;
            } else if (ctrl.calculatedFirstRowLiveStatus === null) {
                //determine value of calculatedFirstRowLiveStatus
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (ctrl.calculatedFirstRowLiveStatus === null) {
                        // making sure it is the scenario where we need to determine/Check FirstRowLiveStatus
                        ctrl.calculatedFirstRowLiveStatus = firstRowTicks + ctrl.liveDataOffset >= result.data.unixTimeStamp;
                        if (ctrl.calculatedFirstRowLiveStatus) {
                            if (_tableTop < _rowTop + 10) {
                                ctrl.RegisterForLiveData();
                            } else {
                                ctrl.UnRegisterForLiveData();
                            }
                        } else {
                            //no action....
                        }
                    }
                });
            }
        }, 500);
    };

    ctrl.wsDataReceivedRainfallPULSE = function (data) {
        // process the data if it matches with current device serialnumber and rainfall channel
        if (data.SN != ctrl.currentSelectedDevice.serialNumber || data.CH != ctrl.rainChannelSetting.channel) {
            return;
        }

        var varTime = datetimeService.socketStrToServerStrTime(data.Time);
        var varValue = parseInt(data.ScaledValue);
        var liveItem = { "localDateTime": varTime, "rainfall": varValue, "temperature": 0 };
        $scope.rainfallDataTableService.LoadLiveData(liveItem);
        _autoScroll(); // scroll position should keep on top of the table
    };

    ctrl.RegisterForLiveData = function () {
        ctrl.isListeningToLiveData = true;
        ctrl.setLiveDataLine(ctrl.isListeningToLiveData);
        $scope.rainfallDataTableService.numberOfReturnedRecords = -1; //setting to initial condition
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: true, windowId: ctrl.windowId, deviceId: ctrl.deviceId });
        // subscribe for live Rainfall data
        if (ctrl.rainChannelSetting && ctrl.currentSelectedDevice) {
            if (ctrl.currentSelectedDevice.deviceModel == 21) {
                websocketService.register("DIGITALASPULSE", ctrl.currentSelectedDevice.serialNumber, ctrl.rainChannelSetting.channel, ctrl.wsDataReceivedRainfallPULSE, null);
            } else {
                websocketService.register("PULSE", ctrl.currentSelectedDevice.serialNumber, ctrl.rainChannelSetting.channel, ctrl.wsDataReceivedRainfallPULSE, null);
                //timeLapseService.register("RainfallListener", 0, "", tlGetNewRainfallData, ctrl.pollInterval);
            }
        }
    };
    ctrl.UnRegisterForLiveData = function () {
        ctrl.isListeningToLiveData = false;
        ctrl.calculatedFirstRowLiveStatus = null; // resetting the calculatedFirstRowLiveStatus
        ctrl.setLiveDataLine(ctrl.isListeningToLiveData);
        // un-subscribe for live Rainfall data
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: false, windowId: ctrl.windowId, deviceId: ctrl.deviceId });
        if (ctrl.rainChannelSetting && ctrl.currentSelectedDevice) {
            if (ctrl.rainChannelSetting && ctrl.currentSelectedDevice.deviceModel == 21) {
                websocketService.unRegister("DIGITALASPULSE", ctrl.currentSelectedDevice.serialNumber, ctrl.rainChannelSetting.channel, ctrl.wsDataReceivedRainfallPULSE, null);
            } else {
                websocketService.unRegister("PULSE", ctrl.currentSelectedDevice.serialNumber, ctrl.rainChannelSetting.channel, ctrl.wsDataReceivedRainfallPULSE, null);
                //timeLapseService.unRegister("RainfallListener", 0, "", tlGetNewRainfallData, ctrl.pollInterval);
            }
        }
    };

    //Initialize the scroll position after the data is loaded
    var _autoScroll = function _autoScroll(isFirsttime) {
        //NOTE: if it is called first time or when live data (1 record) received, 
        //then scrollbar should be on top of the table, 
        //otherwise, during regular user scrolling action after fetching new data, it should position to specific location
        var yPosition = 5;
        if ($scope.rainfallDataTableService.numberOfReturnedRecords > 1 && !isFirsttime) {
            var trRow = ctrl.element.find('tr').eq($scope.rainfallDataTableService.numberOfReturnedRecords - 1);
            yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
            ctrl.element.scrollTop(yPosition);
        } else {
            $timeout(function () {
                ctrl.element.animate({
                    scrollTop: yPosition
                }, 500);
            }, 0);
        }
    };

    var addDays = function addDays(date, days) {
        return new Date(date.valueOf() + days * 86400000);
    };

    //Start the process of refreshing the whole table
    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.currentSelectedDevice.deviceName, 'View reloading');
        ctrl.myDate = null;
        ctrl.stickyProperties.dateMin = null;
        ctrl.stickyProperties.dateMax = null;
        ctrl.GetRain();
    };

    //Get Data and draw
    ctrl.GetRain = function () {
        //getRainfallUnit().then((resp) => { // after fetching ctrl.unit 
        ctrl.currentScrollbarPosition = 0;
        ctrl.previousScrollbarPosition = 0;
        ctrl.calculatedFirstRowLiveStatus = null;

        $scope.rainfallDataTableService = new rainfallDataTableService();
        $scope.rainfallDataTableService.customerId = ctrl.accountInfo.customerId;
        $scope.rainfallDataTableService.deviceId = ctrl.deviceId;
        $scope.rainfallDataTableService.metarStationID = ctrl.currentSelectedDevice.metarStationID;

        $scope.rainfallDataTableService.windowTitle = $scope.windowTitle;
        $scope.rainfallDataTableService.startRow = 1;
        $scope.rainfallDataTableService.pageSize = 50;
        $scope.alerts = [];

        if (ctrl.stickyProperties.dateMin && ctrl.stickyProperties.dateMax) {
            $scope.rainfallDataTableService.start = ctrl.stickyProperties.dateMin;
            $scope.rainfallDataTableService.end = ctrl.stickyProperties.dateMax;
            $scope.rainfallDataTableService.Reload();
        } else {
            ctrl.stickyProperties.on = false;
            timeLapseService.getLocalDateTime().then(function (result) {
                var endDate = new Date(result.data.localDateTime).setHours(4, 0, 0, 0);
                endDate = addDays(endDate, 1);
                var startDate = addDays(endDate, -3);
                $scope.rainfallDataTableService.start = datetimeService.dateToUnixtime(startDate);
                $scope.rainfallDataTableService.end = datetimeService.dateToUnixtime(endDate);
                $scope.rainfallDataTableService.Reload();
            });
        }
        //after loading data, it is the time to determine live data status
        ctrl.calculateLiveDataStatus();

        $scope.rainfallDataTableService.temperatureUnit = ctrl.accountInfo.preferenceUser.lookupMeasurementID;
        $scope.rainfallDataTableService.rainfallUnit = ctrl.unit; //ctrl.accountInfo.preferenceUser.lookupMeasurementID;
        $scope.rainfallDataTableService.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.rainfallDataTableService.metarStationName = ctrl.currentSelectedDevice.deviceName; //required to display appropriate name on mobile device.
        //});
    };
}

RainfallDataTableController.$inject = ['$', '$q', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', '$timeout', '$filter', '$element', 'rainfallDataTableService', 'timeLapseService', 'websocketService', 'toaster'];
'use strict';

angular.module('mc.rainfall').component('rainfallDataTable', {
    controller: RainfallDataTableController,
    templateUrl: 'ui/rainfall/table/rainfall-data-table-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
//function RainfallDataFactory(HOST, $http) {

//    // instantiate our initial object
//    var RainfallData = function (customerId, deviceId, startRow, pageSize, startDate, endDate) {
//        this.customerId = customerId;
//        this.deviceId = deviceId;
//        this.startRow = startRow;
//        this.pageSize = pageSize;
//        this.startDate = startDate;
//        this.endDate = endDate;
//        //this.timeZone = timeZone;
//        //this.stickyProperties = stickyProperties;
//    };

//    RainfallData.prototype.getDeviceData = function () {
//        var self = this;
//        return $http.get(HOST + "/api/MetarRainfallTable" +
//                //"?customerId=" + this.customerId + //TODO: include customerId, eventhough we dont use it.
//                "?deviceId=" + this.deviceId +
//                "&StartRow=" + this.startRow +
//                "&PageSize=" + this.pageSize +
//                "&StartDate=" + this.startDate +
//                "&EndDate=" + this.endDate
//            ).then(function (response) {
//                self.list = response.data;
//                self.loading = false;
//                return response;
//            });
//    };

//    RainfallData.prototype.getAirportData = function () {
//        var self = this;
//        return $http.get(HOST + "/api/MetarRainfallTable" +
//                "?customerId=" + this.customerId + 
//                //"?deviceId=" + this.deviceId +
//                "&StartRow=" + this.startRow +
//                "&PageSize=" + this.pageSize +
//                "&StartDate=" + this.startDate +
//                "&EndDate=" + this.endDate
//            ).then(function (response) {
//                self.list = response.data;
//                self.loading = false;
//                return response;
//            });
//    };

//    return RainfallData;
//}

//RainfallDataFactory.$inject = ['HOST', '$http'];

//angular.module('mc.rainfall').factory('rainfallDataFactory', RainfallDataFactory);
'use strict';

angular.module('mc.signal-connect-chart', []);
"use strict";

function SignalConnectChartFactory(HOST, $http) {

    function GetData(customerId, deviceId, startDate, endDate, timeZone) {
        //return $http.get(HOST + "/api/SignalConnect/GetSignalConnectChartByDateAndDeviceId"   
        return $http.get(HOST + "/api/SignalChart" + "?customerId=" + customerId + "&deviceId=" + deviceId + "&startDate=" + startDate + "&endDate=" + endDate + "&element=" + "All" + "&timeZone=" + timeZone).then(function (response) {
            return response;
        });
    }
    return {
        GetData: GetData
    };
}

SignalConnectChartFactory.$inject = ['HOST', '$http'];

angular.module('mc.signal-connect-chart').factory('SignalConnectChartFactory', SignalConnectChartFactory);
'use strict';

function SignalConnectChartController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, timeLapseService, datetimeService, $timeout, $filter, $element, SaveDesktopSettingService, SignalConnectChartFactory, rangeSelectorService) {
    var _this2 = this;

    var ctrl = this;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.seriesData = [];
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.TimeFormatEnum = { Civilian: 1, Military: 2 };
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.scrollingInProgress = false;
        ctrl.liveDataOffset = 20 * 60 * 1000;
        ctrl.minPadding = 0;
        ctrl.maxPadding = 0;
        ctrl.loadingInProgress = true;

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;

        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        ctrl.xValue = null;
        ctrl.initialLoad = true;

        ctrl.element = $element.find('.vfs-chart');
        ctrl.element.addClass('chart');
        ctrl.element.addClass('chart' + ctrl.selectedDeviceId);

        // setting default start & end dates during initial load
        ctrl.myDateRangeStart = null;
        ctrl.myDateRangeEnd = null;

        if (!ctrl.mobile && !ctrl.classicView && ctrl.windowId != ctrl.selectedDeviceId) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                var _char = $scope.popup.parent().find('.chart').highcharts();
                if ($scope.popup.parent().find(".chart").highcharts()) {
                    $timeout(function () {
                        _char.reflow();
                    }, 600);
                }
            };
        }
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    // on top-menu deviceSelected
    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.element.empty();
            ctrl.selectedDeviceId = newValue;

            var tmpDates = void 0;
            ctrl.loadingInProgress = true;

            $scope.saveDesktopSettingService = new SaveDesktopSettingService(newValue, ctrl.windowId);

            if ($scope.stickyProperties.setting && $scope.stickyProperties.setting.savedDesktop) {
                $scope.savedDesktopSetting = $scope.stickyProperties.setting;
            } else {
                $scope.savedDesktopSetting = $scope.saveDesktopSettingService.getObject();
            }

            if ($scope.stickyProperties.on !== null && $scope.stickyProperties.dateMax !== null) {
                $scope.stickyProperties.on = true;
                ctrl.myDateRangeStart = $scope.stickyProperties.dateMin;
                ctrl.myDateRangeEnd = $scope.stickyProperties.dateMax;
            } else {
                $scope.stickyProperties.on = false;
            }

            if (!ctrl.myDateRangeStart) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    ctrl.heartbeatLocalDateTime = result.data.unixTimeStamp;
                    tmpDates = new Date(result.data.localDateTime);
                    tmpDates.setHours(0, 0, 0, 0);
                    tmpDates = datetimeService.dateToUnixtime(tmpDates);
                    tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                    tmpDates = datetimeService.startEndLocalToUtc(tmpDates, ctrl.accountInfo.timeZone);
                    ctrl.myDateRangeStart = tmpDates.startDate;
                    ctrl.myDateRangeEnd = tmpDates.endDate;
                    getData();
                });
            } else {
                getData();
            }
        }
    }, true);
    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat);
        ctrl._drawChart();
    });
    $scope.$on('updatePreferencesLanguage', function () {
        ctrl._drawChart();
    });

    var getData = function getData() {
        ctrl.liveDataEndDate = ctrl.myDateRangeEnd;

        SignalConnectChartFactory.GetData(ctrl.accountInfo.customerId, ctrl.selectedDeviceId, ctrl.myDateRangeStart, ctrl.myDateRangeEnd, ctrl.accountInfo.timeZone).then(function (resp) {
            $scope.alerts = [];

            //if no data, then display message
            if ((!resp.data.signal.data || resp.data.signal.data.length === 0) && (!resp.data.signal.signalQualityData || resp.data.signal.signalQualityData.length === 0) && (!resp.data.signal.signalPowerData || resp.data.signal.signalPowerData.length === 0)) {
                var errorMessage = "No Data to display";
                $scope.alerts = [];
                $scope.alerts.push({
                    msg: errorMessage,
                    type: "info"
                });
                if (ctrl.chart && ctrl.chart.series && ctrl.chart.series.length > 0) {
                    ctrl.chart.destroy();
                }
                ctrl.loadingInProgress = false;
            } else {
                //if data present, then segregate SS, SP, SQ
                ctrl.signalData = resp.data.signal.data;
                ctrl.qualityData = resp.data.signal.signalQualityData;
                ctrl.powerData = resp.data.signal.signalPowerData;
                ctrl.signalStrengthParam = resp.data.signal.device.signalStrengthParameter;
                ctrl.selectedDeviceName = resp.data.signal.device.name;
                ctrl.selectedDeviceType = resp.data.signal.device.model;
                ctrl.hasRMDTRadio = resp.data.signal.device.hasRMDTRadio;
                ctrl.signalConnectivityModel = resp.data.signalConnectivityModel.signalLogConnects;
                if (ctrl.chart && ctrl.chart.series && ctrl.chart.series.length > 0) {
                    ctrl.chart.destroy();
                }
                $timeout(function () {
                    ctrl._drawChart();
                }, 0);
            }
        });
    };

    var loadPlotBands = function loadPlotBands() {
        var i = 0;
        while (i < ctrl.signalConnectivityModel.length - 1) {
            ctrl.plotBands.push({
                from: ctrl.signalConnectivityModel[i].start,
                to: new Date(ctrl.signalConnectivityModel[i + 1].start),
                percentage: ctrl.signalConnectivityModel[i].percentage / 100,
                color: ctrl.signalConnectivityModel[i].color
            });
            i++;
        }
    };

    var updatePlotBands = function updatePlotBands(signalConnectivityModel) {
        var i = 0;
        if (ctrl.chart) {
            while (i < signalConnectivityModel.length - 1) {
                ctrl.chart.xAxis[0].addPlotBand({
                    from: signalConnectivityModel[i].start,
                    to: new Date(signalConnectivityModel[i + 1].start),
                    percentage: signalConnectivityModel[i].percentage / 100,
                    color: signalConnectivityModel[i].color
                });
                i++;
            }
        }
    };

    ctrl._drawChart = function () {
        var signalTmpData = ctrl.signalData;
        var qualityTmpData = ctrl.qualityData;
        var powerTmpData = ctrl.powerData;
        var signalConnectivityTmpData = ctrl.signalConnectivityModel;
        var chartDrawn = false;

        var firstSerie = (ctrl.selectedDeviceType === 17 || ctrl.selectedDeviceType === 18 || ctrl.selectedDeviceType === 19 || ctrl.selectedDeviceType === 20 || ctrl.selectedDeviceType === 21) && ctrl.hasRMDTRadio ? 0 : 1;
        var secondSerie = ctrl.selectedDeviceType === 20 || ctrl.hasRMDTRadio ? 1 : 0;
        var thirdSerie = ctrl.hasRMDTRadio ? 1 : 0;

        $scope.numberOfSeries = firstSerie + secondSerie + thirdSerie;
        $scope.numberOfHiddenSeries = 0;

        var chartXaxisHourFormat = ctrl.preferredTimeFormat === ctrl.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
        var chartToolTipHourFormat = ctrl.preferredTimeFormat === ctrl.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

        ctrl.plotBands = [];
        loadPlotBands();

        ctrl.chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: ctrl.selectedDeviceType === 20 || ctrl.hasRMDTRadio ? true : false,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1
            },
            time: {
                //getTimezoneOffset: function (timestamp) {
                //    return -moment.tz(timestamp, datetimeService.getTimeZoneId(ctrl.accountInfo.timeZone)).utcOffset();
                //}
            },
            chart: {
                renderTo: ctrl.element[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1,
                borderRadius: 2,
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                marginRight: 10,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                spacingRight: 5,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {
                        if (this.options.chart.forExport) return false;
                        var tmpDates,
                            extremes = this.xAxis[0].getExtremes();

                        //Handle scroll left & right
                        if (this.xAxis && chartDrawn === true && ctrl.scrollingInProgress === false) {
                            //srolling /navigating left
                            if (extremes && extremes.dataMin >= extremes.min - ctrl.liveDataOffset) {
                                ctrl.scrollingInProgress = true;
                                this.showLoading();

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -1);
                                ctrl.myDateRangeEnd = ctrl.myDateRangeStart; //setting to previously fetched start date//tmpDates.endDate;
                                ctrl.myDateRangeStart = tmpDates.startDate;

                                SignalConnectChartFactory.GetData(ctrl.accountInfo.customerId, ctrl.selectedDeviceId, ctrl.myDateRangeStart, ctrl.myDateRangeEnd, ctrl.accountInfo.timeZone).then(function (resp) {
                                    //if (resp.data.data.length === 0) {
                                    //    resp.data.data.push([tmpDates.startDate, null]);
                                    //}
                                    if ((!resp.data.signal.data || resp.data.signal.data.length === 0) && (!resp.data.signal.signalQualityData || resp.data.signal.signalQualityData.length === 0) && (!resp.data.signal.signalPowerData || resp.data.signal.signalPowerData.length === 0)) {
                                        var errorMessage = "No Data to display";
                                    } else {
                                        //updating existing connectivity data with newly fetched data.
                                        signalConnectivityTmpData = resp.data.signalConnectivityModel.signalLogConnects.concat(ctrl.signalConnectivityModel);
                                        //sort series to avoid HighChart multi line issue(SCADA-9892)
                                        signalConnectivityTmpData.sort(function (a, b) {
                                            return a[0] - b[0];
                                        });
                                        ctrl.signalConnectivityModel = signalConnectivityTmpData;
                                        //NOTE: add newly fetched data to the left of existing data
                                        updatePlotBands(resp.data.signalConnectivityModel.signalLogConnects);
                                        //if data present, then segregate SS, SP, SQ
                                        if (ctrl.hasRMDTRadio) {
                                            //SP: SignalPower => updating existing data with newly fetched data
                                            powerTmpData = resp.data.signal.signalPowerData.concat(powerTmpData);
                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                            powerTmpData.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            ctrl.chart.series[2].setData(powerTmpData);
                                            //SP: SignalQuality => updating existing data with newly fetched data
                                            qualityTmpData = resp.data.signal.signalQualityData.concat(qualityTmpData);
                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                            qualityTmpData.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            ctrl.chart.series[1].setData(qualityTmpData);
                                        } else if (ctrl.selectedDeviceType == 20) {
                                            //SS: SignalStrength => updating existing data with newly fetched data
                                            signalTmpData = resp.data.signal.data.concat(signalTmpData);
                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                            signalTmpData.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            ctrl.chart.series[0].setData(signalTmpData);
                                            //SQ: SignalQuality => updating existing data with newly fetched data
                                            qualityTmpData = resp.data.signal.signalQualityData.concat(qualityTmpData);
                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                            qualityTmpData.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            ctrl.chart.series[1].setData(qualityTmpData);
                                        } else {
                                            //SS: SignalStrength => updating existing data with newly fetched data
                                            signalTmpData = resp.data.signal.data.concat(signalTmpData);
                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                            signalTmpData.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            ctrl.chart.series[0].setData(signalTmpData);
                                        }
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: ctrl.selectedDeviceId, dataMin: tmpDates.startDate, windowId: ctrl.windowId });
                                    ctrl.chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
                                    //_setLiveDataStatus();
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    ctrl.chart.hideLoading();
                                }, function (errorResp) {
                                    var uiErrorMessage = userMessageService.getUiErrorMessage(errorResp.data.message);
                                    toaster.pop('error', $scope.windowTitle, uiErrorMessage);
                                    $timeout(function () {
                                        ctrl.scrollingInProgress = false;
                                    }, 1000);
                                    ctrl.chart.hideLoading();
                                });
                            } //srolling /navigating right
                            else if ($scope.liveData === false && extremes && extremes.max + ctrl.liveDataOffset >= extremes.dataMax) {
                                    ctrl.scrollingInProgress = true;
                                    this.showLoading();

                                    tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 1);
                                    ctrl.myDateRangeStart = ctrl.myDateRangeEnd; //setting to previous end date //tmpDates.startDate;
                                    ctrl.myDateRangeEnd = tmpDates.endDate;

                                    SignalConnectChartFactory.GetData(ctrl.accountInfo.customerId, ctrl.selectedDeviceId, ctrl.myDateRangeStart, ctrl.myDateRangeEnd, ctrl.accountInfo.timeZone).then(function (resp) {
                                        if ((!resp.data.signal.data || resp.data.signal.data.length === 0) && (!resp.data.signal.signalQualityData || resp.data.signal.signalQualityData.length === 0) && (!resp.data.signal.signalPowerData || resp.data.signal.signalPowerData.length === 0)) {
                                            var errorMessage = "No Data to display";
                                        } else {
                                            //updating existing connectivity data with newly fetched data.
                                            signalConnectivityTmpData = ctrl.signalConnectivityModel.concat(resp.data.signalConnectivityModel.signalLogConnects);
                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                            signalConnectivityTmpData.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            ctrl.signalConnectivityModel = signalConnectivityTmpData;
                                            //NOTE: add newly fetched data to the right of existing data
                                            updatePlotBands(resp.data.signalConnectivityModel.signalLogConnects);

                                            //if data present, then segregate SS, SP, SQ
                                            if (ctrl.hasRMDTRadio) {
                                                //SP: SignalPower => updating existing data with newly fetched data
                                                powerTmpData = powerTmpData.concat(resp.data.signal.signalPowerData);
                                                //sort series to avoid HighChart multi line issue(SCADA-9892)
                                                powerTmpData.sort(function (a, b) {
                                                    return a[0] - b[0];
                                                });
                                                ctrl.chart.series[2].setData(powerTmpData);
                                                //SP: SignalQuality => updating existing data with newly fetched data
                                                qualityTmpData = qualityTmpData.concat(resp.data.signal.signalQualityData);
                                                //sort series to avoid HighChart multi line issue(SCADA-9892)
                                                qualityTmpData.sort(function (a, b) {
                                                    return a[0] - b[0];
                                                });
                                                ctrl.chart.series[1].setData(qualityTmpData);
                                            } else if (ctrl.selectedDeviceType == 20) {
                                                //SS: SignalStrength => updating existing data with newly fetched data
                                                signalTmpData = signalTmpData.concat(resp.data.signal.data);
                                                //sort series to avoid HighChart multi line issue(SCADA-9892)
                                                signalTmpData.sort(function (a, b) {
                                                    return a[0] - b[0];
                                                });
                                                ctrl.chart.series[0].setData(signalTmpData);
                                                //SQ: SignalQuality => updating existing data with newly fetched data
                                                qualityTmpData = qualityTmpData.concat(resp.data.signal.signalQualityData);
                                                //sort series to avoid HighChart multi line issue(SCADA-9892)
                                                qualityTmpData.sort(function (a, b) {
                                                    return a[0] - b[0];
                                                });
                                                ctrl.chart.series[1].setData(qualityTmpData);
                                            } else {
                                                //SS: SignalStrength => updating existing data with newly fetched data
                                                signalTmpData = signalTmpData.concat(resp.data.signal.data);
                                                //sort series to avoid HighChart multi line issue(SCADA-9892)
                                                signalTmpData.sort(function (a, b) {
                                                    return a[0] - b[0];
                                                });
                                                ctrl.chart.series[0].setData(signalTmpData);
                                            }
                                        }

                                        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: ctrl.selectedDeviceId, dataMax: tmpDates.endDate, windowId: ctrl.windowId });
                                        ctrl.chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
                                        //_setLiveDataStatus(tmpDates.endDate);
                                        $timeout(function () {
                                            ctrl.scrollingInProgress = false;
                                        }, 1000);
                                        ctrl.chart.hideLoading();
                                    }, function (errorResp) {
                                        var uiErrorMessage = userMessageService.getUiErrorMessage(errorResp.data.message);
                                        toaster.pop('error', $scope.windowTitle, uiErrorMessage);
                                        $timeout(function () {
                                            ctrl.scrollingInProgress = false;
                                        }, 1000);
                                        ctrl.chart.hideLoading();
                                    });
                                }
                        }
                    },
                    load: function load(event) {
                        if (ctrl.initialLoad) openViewService.adjustContentSize($scope.popup);
                        ctrl.initialLoad = false;
                        $timeout(function () {
                            $scope.saveDesktopSettingService.applySavedDesktopSetting(ctrl.chart, $scope, true);
                        }, 0);
                    },
                    render: function render(event) {
                        //handle plotbands
                        $.each(event.target.axes[0].plotLinesAndBands, function (i, L) {
                            if (this.options.percentage < 1) {
                                var band = L.svgElem;
                                if (!band || !band.d) {
                                    return;
                                }

                                var path = band.d.split(' ');
                                //let yAxisMin = event.target.series[0].yAxis.min; //-60
                                var yAxisMax = event.target.series[0].yAxis.max; // -135
                                var yAxisTop = event.target.yAxis[0].top; // specifies offset on the top => from where yAxis starts from Top
                                //let _yMin = event.target.series[0].yAxis.translate(yAxisMin)

                                var _yMax = event.target.series[0].yAxis.translate(yAxisMax); // yAxis height in pixel

                                var scaledHeight = _yMax * this.options.percentage; // plotband height for a given scaled data value

                                var heightDiff = Number(_yMax) - Number(scaledHeight); // offset of difference in length (actual to scaled value)

                                var yStart = Number(yAxisTop) + Number(heightDiff); // starting height of yAxis from TOP
                                var yEnd = Number(_yMax) + Number(yAxisTop); // ending height of yAxis from TOP

                                path[2] = yStart;
                                path[11] = yStart;
                                path[5] = yEnd;
                                path[8] = yEnd;
                                band.attr('d', path);
                            }
                        });
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: false
            },
            xAxis: {
                plotBands: ctrl.plotBands,
                title: {
                    text: ctrl.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 3,
                    color: 'green',
                    dashStyle: "solid",
                    zIndex: 1
                }],
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minTickInterval: 3600 * 1000,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                dateTimeLabelFormats: {
                    hour: chartXaxisHourFormat
                },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (chartDrawn === true) {
                            var extremes = ctrl.chart.xAxis[0].getExtremes();
                            if ($scope.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) {
                                //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                if (extremes.max + ctrl.liveDataOffset <= extremes.dataMax) {
                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: ctrl.windowId });
                                    //TODO: following method tobe implemented
                                    //_unRegisterListener($scope.deviceSelectedSn);
                                }
                            }
                            sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: extremes.min, zoomMax: extremes.max, windowId: ctrl.windowId });
                        }
                    }
                }
            },
            yAxis: [{
                min: ctrl.signalStrengthParam.toLowerCase() == "rssi" ? -130 : -145,
                max: ctrl.signalStrengthParam.toLowerCase() == "rssi" ? -65 : -40,
                title: {
                    text: ctrl.translation.text.SIGNAL + ' (dBm)',
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                opposite: false,
                allowDecimals: false,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                showFirstLabel: true,
                showLastLabel: true,
                lineWidth: 2,
                lineColor: "#2288cc",
                labels: {
                    align: 'right',
                    y: 8,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '10px'
                    },
                    formatter: function formatter() {
                        return this.value;
                    }
                },
                visible: (ctrl.selectedDeviceType === 17 || ctrl.selectedDeviceType === 18 || ctrl.selectedDeviceType === 19 || ctrl.selectedDeviceType === 20 || ctrl.selectedDeviceType === 21) && ctrl.hasRMDTRadio ? false : true
            }, {
                min: null,
                title: {
                    text: ctrl.translation.text.SIGNAL_QUALITY + ' (dB)',
                    style: {
                        color: '#6D869F', //GRAY
                        fontWeight: 'bold'
                    }
                },
                opposite: false,
                allowDecimals: false,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                showFirstLabel: true,
                showLastLabel: true,
                lineWidth: 2,
                lineColor: "#660000", //Dark RED
                labels: {
                    align: 'right',
                    y: 8,
                    style: {
                        color: '#6D869F', //GRAY
                        fontWeight: 'bold',
                        fontSize: '10px'
                    },
                    formatter: function formatter() {
                        return this.value;
                    }
                },
                visible: ctrl.selectedDeviceType === 20 || ctrl.hasRMDTRadio ? true : false
            }, {
                min: null,
                title: {
                    text: ctrl.translation.text.SIGNAL_POWER + ' (dBm)',
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                opposite: false,
                allowDecimals: false,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                showFirstLabel: true,
                showLastLabel: true,
                lineWidth: 2,
                lineColor: "#ddaa00",
                labels: {
                    align: 'right',
                    y: 8,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '10px'
                    },
                    formatter: function formatter() {
                        return this.value;
                    }
                },
                visible: ctrl.hasRMDTRadio
            }],
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var s = '';
                    var lastPointIndex = this.points.length - 1;
                    s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, this.x) + '</td></tr>';
                    $.each(this.points, function (i, point) {
                        var measurmentType = point.series.name == "Signal Quality" ? ' dB' : ' dBm';;
                        s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ' : </td><td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, 0) + measurmentType + ' </td></tr>';
                        if (i == lastPointIndex) {
                            if (ctrl.signalConnectivityModel.length > 0) {
                                var index = ctrl.signalConnectivityModel.findIndex(function (x) {
                                    return new Date(x.start).getDate() === new Date(point.x).getDate() & new Date(x.start).getMonth() === new Date(point.x).getMonth() & new Date(x.start).getHours() === new Date(point.x).getHours();
                                });
                                if (index >= 0) {
                                    s += '<tr><td>' + ctrl.signalConnectivityModel[index].percentage + '% ' + ctrl.signalConnectivityModel[index].reconnects + ' reconnects' + '</td></tr>';
                                }
                            }
                        }
                    });
                    s += '</table>';
                    return s;
                },
                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 5,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
            },
            plotOptions: {
                series: {
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                ctrl.xValue = this.x;
                            }
                        }
                    },
                    marker: {
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    events: {
                        legendItemClick: function legendItemClick() {
                            if (this.visible) {
                                if ($scope.numberOfHiddenSeries < $scope.numberOfSeries - 1) {
                                    $scope.numberOfHiddenSeries = $scope.numberOfHiddenSeries + 1;
                                } else {
                                    return false;
                                }
                            } else {
                                $scope.numberOfHiddenSeries = $scope.numberOfHiddenSeries - 1;
                            }

                            ctrl.chart.yAxis[this.index].update({
                                labels: {
                                    enabled: this.visible ? false : true
                                },
                                title: {
                                    enabled: this.visible ? false : true
                                },
                                lineWidth: this.visible ? 0 : 2
                            });

                            $scope.saveDesktopSettingService.setSerieVisibilitySetting(this.options.id, this.visible ? false : true, $scope);
                        },
                        mouseOut: function mouseOut() {
                            ctrl.xValue = null;
                        }
                    }
                }
            },
            series: [{
                id: 0,
                name: ctrl.translation.text.SIGNAL,
                color: '#2288cc',
                shadow: false,
                data: ctrl.signalData,
                lineWidth: 2,
                marker: {
                    enabled: null,
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#FFFFFF',
                    lineWidth: 2,
                    lineColor: null // inherit from series
                },
                yAxis: 0,
                visible: (ctrl.selectedDeviceType === 17 || ctrl.selectedDeviceType === 18 || ctrl.selectedDeviceType === 19 || ctrl.selectedDeviceType === 20 || ctrl.selectedDeviceType === 21) && ctrl.hasRMDTRadio ? false : true,
                showInLegend: (ctrl.selectedDeviceType === 17 || ctrl.selectedDeviceType === 18 || ctrl.selectedDeviceType === 19 || ctrl.selectedDeviceType === 20 || ctrl.selectedDeviceType === 21) && ctrl.hasRMDTRadio ? false : true
            }, {
                id: 1,
                name: ctrl.translation.text.SIGNAL_QUALITY,
                color: '#660000', //Dark Red
                shadow: false,
                data: ctrl.qualityData,
                lineWidth: 2,
                marker: {
                    enabled: null,
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#FFFFFF',
                    lineWidth: 1,
                    lineColor: null // inherit from series
                },
                yAxis: 1,
                // Model = 20 => MM+
                // RadioTypeID = 5 => RMDM/DFN                      
                // RadioTypeID = 6 => RMDT
                visible: ctrl.selectedDeviceType === 20 || ctrl.hasRMDTRadio ? true : false
            }, {
                id: 2,
                name: ctrl.translation.text.SIGNAL_POWER,
                color: '#ddaa00',
                shadow: false,
                data: ctrl.powerData,
                lineWidth: 2,
                marker: {
                    enabled: null,
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#FFFFFF',
                    lineWidth: 1,
                    lineColor: null // inherit from series
                },
                yAxis: 2,
                visible: ctrl.hasRMDTRadio
            }]
        });

        $scope.series = ctrl.chart.series;

        var tmpNewDateA;
        var tmpNewDateB;
        var extremes = ctrl.chart.xAxis[0].getExtremes();

        if ($scope.stickyProperties.on === true && $scope.stickyProperties.mostRecentData === undefined) {
            tmpNewDateA = $scope.stickyProperties.zoomMin >= extremes.dataMin ? $scope.stickyProperties.zoomMin : extremes.dataMin; //extremes.dataMin + scope.unixDay / 24 * 3;
            tmpNewDateB = $scope.stickyProperties.zoomMax <= extremes.dataMax + ctrl.liveDataOffset ? $scope.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + ctrl.unixDay / 24 ? tmpNewDateB : extremes.dataMax - ctrl.unixDay / 24 * 12;
            $scope.stickyProperties.on = false;
        } else {
            $scope.stickyProperties.mostRecentData = undefined;
            tmpNewDateA = ctrl.myDate !== null ? extremes.dataMin + ctrl.unixDay : extremes.dataMax - ctrl.unixDay / 24 * 12;
            tmpNewDateB = ctrl.myDate !== null ? tmpNewDateA + ctrl.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - ctrl.unixDay;
            }
            tmpNewDateA = tmpNewDateA + ctrl.minPadding;
            tmpNewDateB = tmpNewDateB + ctrl.maxPadding;
        }

        ctrl.chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: ctrl.selectedDeviceId, zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: ctrl.windowId });
        //_setLiveDataStatus();
        chartDrawn = true;
        ctrl.loadingInProgress = false;
    };

    // this method is called when top-menu calendar Date is selected
    ctrl.selectMyDate = function (date) {
        ctrl.myDate = date;
        var tmpDates = ctrl.myDate;
        ctrl.loadingInProgress = true;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
        tmpDates = datetimeService.startEndLocalToUtc(tmpDates, ctrl.accountInfo.timeZone);
        ctrl.myDateRangeStart = tmpDates.startDate;
        ctrl.myDateRangeEnd = tmpDates.endDate;
        getData();
    };
    //top menu range selection buttons click
    ctrl.zoomAdjust = function (varDay) {
        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, ctrl.heartbeatLocalDateTime);
        ctrl.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
        //_setLiveDataStatus();
    };

    var _setLiveDataStatus = function _setLiveDataStatus(varEndDate) {
        ctrl.liveDataEndDate = varEndDate != null ? varEndDate : ctrl.liveDataEndDate;
        timeLapseService.getLocalDateTime().then(function (result) {
            //TODO: where following variable is used?
            ctrl.heartbeatLocalDateTime = result.data.unixTimeStamp;
            var extremes = typeof ctrl.chart.xAxis != "undefined" ? ctrl.chart.xAxis[0].getExtremes() : null;
            if (extremes != null && ctrl.liveDataEndDate > result.data.unixTimeStamp && $scope.stickyProperties.zoomMax + ctrl.liveDataOffset >= extremes.dataMax) {
                //TODO:Implement below method
                //_registerListener(scope.deviceSelectedSn);
                var data = { Unix: result.data.unixTimeStamp, Value: null, SN: null, CH: null };
                //TODO:Implement below method
                //tlDataReceivedSIGNAL(data);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: ctrl.windowId });
                //TODO:Implement below method
                //_unRegisterListener(scope.deviceSelectedSn);
            }
        });
    };
}

SignalConnectChartController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'timeLapseService', 'datetimeService', '$timeout', '$filter', '$element', 'SaveDesktopSettingService', 'SignalConnectChartFactory', 'rangeSelectorService'];
'use strict';

angular.module('mc.signal-connect-chart').component('signalConnectChart', {
    controller: SignalConnectChartController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/signalconnect/chart/signal-connect-chart-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.sequence-number", []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SequenceNumberTableFactory(HOST, $http, $q, $timeout, datetimeService, translationService, sharedSetupService) {
    var SequenceNumberTable = function () {
        function SequenceNumberTable(customerId, deviceId, deviceSelectedName, timeZone) {
            _classCallCheck(this, SequenceNumberTable);

            this._deviceName = deviceSelectedName;
            this._table = [];
            this._loading = false;
            this._customerId = customerId;
            this._timeZone = timeZone;
            //this._flowUnitText = translationService.translation.text.PUMP_GALLONS;
            this._deviceId = deviceId;
            this._liveData = false;
            this._startRow = 1;
            this._pageSize = 50;
            this._numberOfReturnedRecords = -1;
            this._numberOfNewRecordsPrevious = -1;
            this._start = '19000101';
            this._end = '19000101';
        }

        _createClass(SequenceNumberTable, [{
            key: 'getStartLevel',
            value: function getStartLevel(row, convertToUnit) {
                var startLevel = null;
                if (row.startLevel > row.endLevel) {
                    startLevel = row.startLevel.toFixed(2);
                } else {
                    startLevel = row.endLevel.toFixed(2);
                }
                if (convertToUnit === 2) {
                    return Math.abs(startLevel * 0.3048).toFixed(2);
                } else {
                    return startLevel;
                }
            }
        }, {
            key: 'getEndLevel',
            value: function getEndLevel(row, convertToUnit) {
                var endLevel = null;
                if (row.startLevel > row.endLevel) {
                    endLevel = row.endLevel.toFixed(2);
                } else {
                    endLevel = row.startLevel.toFixed(2);
                }
                if (convertToUnit === 2) {
                    return Math.abs(endLevel * 0.3048).toFixed(2);
                } else {
                    return endLevel;
                }
            }

            // process and notify if any gap in sequence numbers
            //processItems(direction, items) {
            //    angular.forEach(items, (item, index) => {
            //        if (index > 0 && direction === 0 && item.value !== items[index - 1].value - 1) {
            //            item.background = '#FF4040';
            //        } else if (index > 0 && direction === 1 && item.value !== items[index - 1].value + 1) {
            //            item.background = '#FF4040';
            //        }
            //        else {
            //            item.background = '#FFFFFF';
            //        }
            //    });
            //    return items;
            //}

            //remove duplicates from table items, if any

        }, {
            key: 'removeDuplicates',
            value: function removeDuplicates() {
                var obj = {}; //contains localDateTime as Key, and item as value
                var out_arr = [];

                for (var i = 0; i < this._table.length; i++) {
                    obj[this._table[i].localDateTime] = this._table[i]; //localDateTime should be unique across the table items
                }

                for (var key in obj) {
                    out_arr.push(obj[key]);
                }
                this._table = out_arr;
            }
        }, {
            key: 'fetchData',
            value: function fetchData(type, startDate, endDate) {
                var _this = this;

                this._loading = true;
                //console.log("************* st dt: " + new Date(startDate) + " end Dt: " + new Date(endDate));
                return $http.get(HOST + '/api/RegistrationCount?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&startDate=' + startDate + '&endDate=' + endDate + '&scrollDirection=' + type + '&timeZone=' + this._timeZone).then(function (resp) {
                    _this._loading = false;

                    var items = resp.data; //this.processItems(type, resp.data);

                    if (type === 0) {
                        _this._table = _this._table.concat(items);
                    } else if (type === 1) {
                        _this._numberOfNewRecordsPrevious = items.length;
                        _this._table = items.reverse().concat(_this._table);
                    }

                    //clean the duplicate items from the table
                    _this.removeDuplicates();

                    if (_this._table.length > 0) {
                        // if there are records returned
                        _this._end = datetimeService.toUnixtimeMs(_this._table[_this._table.length - 1].localDateTime.replace(/\D/g, ''));
                    }

                    return resp;
                });
            }
        }, {
            key: 'nextPage',
            value: function nextPage() {
                var _this2 = this;

                if (this._loading) {
                    return $q(function (resolve, reject) {
                        resolve({ data: { data: _this2._table } });
                    });
                }

                if (this._table.length > 0) {
                    var newEnd = datetimeService.toUnixtimeMs(this._table[this._table.length - 1].localDateTime.replace(/\D/g, ''));
                    var newStart = newEnd - 86400000 * 6;
                    return this.fetchData(0, newStart, newEnd);
                } else {

                    //TODO: will come back to reconsider sharedSetupService.regenerateDates()
                    if (this._end === 0) {
                        var tmpDates = sharedSetupService.getLiveDates();
                        this._end = tmpDates.endDate;

                        var _newStart2 = this._end - 86400000 * 6;
                        this.start = _newStart2;
                        return this.fetchData(0, _newStart2, this._end);
                    }

                    var _newStart = this._end - 86400000 * 6;
                    this.start = _newStart;
                    return this.fetchData(0, _newStart, this._end);
                }
            }
        }, {
            key: 'previousPage',
            value: function previousPage() {

                var newStart = datetimeService.toUnixtimeMs(this._table[0].localDateTime.replace(/\D/g, ''));
                var newEnd = newStart + 86400000 * 3;
                return this.fetchData(1, newStart, newEnd);
            }
        }, {
            key: 'reset',
            value: function reset(deviceId, deviceSelectedName) {

                if (deviceId) {
                    this._deviceId = deviceId;
                }

                if (deviceSelectedName) {
                    this._deviceName = deviceSelectedName;
                }

                this._numberOfNewRecordsPrevious = -1;
                this._table.length = 0;
                this._start = '19000101';
                this._end = '19000101';
            }
        }, {
            key: 'deviceName',
            get: function get() {
                return this._deviceName;
            }
        }, {
            key: 'table',
            get: function get() {
                return this._table;
            }
        }, {
            key: 'previousRecords',
            get: function get() {
                return this._numberOfNewRecordsPrevious;
            },
            set: function set(num) {
                this._numberOfNewRecordsPrevious = num;
            }
        }, {
            key: 'loading',
            get: function get() {
                return this._loading;
            }
        }, {
            key: 'deviceId',
            set: function set(deviceId) {
                this._deviceId = deviceId;
            }
        }, {
            key: 'start',
            set: function set(startDate) {
                this._start = startDate;
            },
            get: function get() {
                return this._start;
            }
        }, {
            key: 'end',
            set: function set(endDate) {
                this._end = endDate;
            },
            get: function get() {
                return this._end;
            }
        }, {
            key: 'liveData',
            set: function set(liveData) {
                this._liveData = liveData;
            }
        }]);

        return SequenceNumberTable;
    }();

    return SequenceNumberTable;
}

SequenceNumberTableFactory.$inject = ['HOST', '$http', '$q', '$timeout', 'datetimeService', 'translationService', 'sharedSetupService'];

angular.module('mc.sequence-number').factory('SequenceNumberTableFactory', SequenceNumberTableFactory);
'use strict';

function SequenceNumberTableController(_, $, $scope, $filter, $timeout, $element, authenticationService, translationService, datetimeService, sharedSetupService, openViewService, timeLapseService, websocketService, SequenceNumberTableFactory, toaster) {
    var _this2 = this;

    this.liveDataisOffForNow = true;

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    this.setDevice = function (selectedDevice) {
        $scope.deviceSelected = selectedDevice.deviceId;
        $scope.deviceSelectedSn = selectedDevice.serialNumber;
        $scope.deviceSelectedType = selectedDevice.type;
        $scope.deviceSelectedName = selectedDevice.name;
        $scope.currentSelectedDevice = selectedDevice;
    };

    var wsDataReceivedSEQUENCENUMBER = function wsDataReceivedSEQUENCENUMBER(data) {
        if (data && data.ComputeTime) {
            var varTime = datetimeService.socketStrToServerStrTime(data.ComputeTime);
            var newRecord = { computeTime: varTime, pump: parseInt(data.Pump), runtime: parseFloat(data.Runtime), startLevel: parseFloat(data.StartLevel), endLevel: parseFloat(data.EndLevel), flow: parseFloat(data.Gallons), pumpRate: parseFloat(data.PumpGPM), inFlow: parseFloat(data.AvgFlow) };

            _this2.sequenceNumberTable._table.unshift(newRecord);
        }
    };

    var wsReconnectSEQUENCENUMBER = function wsReconnectSEQUENCENUMBER(data) {
        console.log(data);
    };

    this._registerListener = function (deviceSn) {
        if (_this2.liveData === true) {
            return;
        }

        _this2.liveData = true;
        if (_this2.sequenceNumberTable) {
            _this2.sequenceNumberTable.liveData = _this2.liveData;
        }

        _this2.liveDataLine(_this2.liveData);
        _this2.sequenceNumberTable.previousRecords = -1;
        websocketService.connect();

        //TODO: findout correct Key and replace
        websocketService.register('SEQUENCENUMBER', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedSEQUENCENUMBER, wsReconnectSEQUENCENUMBER);
    };

    this._unRegisterListener = function (deviceSn) {
        if (_this2.liveData === false) {
            return;
        }

        _this2.liveData = false;
        if (_this2.sequenceNumberTable) {
            _this2.sequenceNumberTable.liveData = _this2.liveData;
        }

        _this2.liveDataLine(_this2.liveData);

        //TODO: findout correct Key and replace
        websocketService.unRegister('SEQUENCENUMBER', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedSEQUENCENUMBER, wsReconnectSEQUENCENUMBER);
    };

    this._checkTopOffset = function (liveDataStatusOn) {
        if (liveDataStatusOn) {
            _this2._registerListener();
        } else {
            _this2._unRegisterListener();
        }
    };

    this._setLiveDataStatus = function (firstRow, liveDataStatusOn) {
        if (_this2.checkFirstRowLiveStatus === true) {
            _this2._checkTopOffset(liveDataStatusOn);
        } else if (_this2.checkFirstRowLiveStatus === null) {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                if (parseFloat(firstRow) + parseFloat(_this2.liveDataOffset) >= parseFloat(result.unixTimeStamp)) {
                    _this2.checkFirstRowLiveStatus = true;
                    _this2._checkTopOffset(liveDataStatusOn);
                } else {
                    _this2.checkFirstRowLiveStatus = false;
                }
            });
        }
    };

    this.checkSequenceNumber = function (i) {

        var currentSequenceNumber = _this2.sequenceNumberTable.table[i].value;

        if (currentSequenceNumber != null) {

            var result = _this2.sequenceNumberTable.table.slice(i + 1).find(function (obj) {
                return Boolean(obj.value);
            });

            if (!angular.isUndefined(result)) {
                return currentSequenceNumber - result.value == 1 ? "transparent" : "red";
            }
        }
        return "transparent";
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        _this2.myDate = null;
        _this2.infiniteScrollOn = false;
        _this2.infiniteScrollUpOn = false;
        _this2.infiniteScrollDownOn = false;
        _this2.checkFirstRowLiveStatus = null;
        _this2.liveTable = $element.find('.headertable');
        _this2.accountInfo = authenticationService.getAccountInfo();
        //this.measurement = this.accountInfo.preferenceUser.lookupMeasurementID;
        _this2.preferredTimeFormat = _this2.accountInfo.preferenceUser.timeFormat;
        _this2.unixDay = sharedSetupService.unixDay;
        _this2.liveDataOffset = sharedSetupService.liveDataOffset;
        _this2.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
        _this2.translation = translationService.translation;
        _this2.alerts = [];
        _this2.currentScrollbarPosition = 0;
        _this2.previousScrollbarPosition = 0;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
        _this2.checkFirstRowLiveStatus = null;
        _this2.paddingZoom = _this2.paddingZoom === 0 ? _this2.unixDay / 2 : _this2.paddingZoom;
        $scope.alerts = [];
        $scope.windowTitle = _this2.translation.text.SEQUENCE_NUMBER_TABLE;
        _this2.windowId = _this2.windowId || _this2.translation.text.SEQUENCE_NUMBER_TABLE;
        $scope.windowId = JSON.parse(JSON.stringify(_this2.windowId));
        _this2.paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
        _this2.paddingZoom = _this2.paddingZoom === 0 ? _this2.unixDay / 2 : _this2.paddingZoom;

        if (!_this2.mobile && !_this2.classicView) {
            _this2._popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize(_this2._popup);

            var adjustSize = function adjustSize() {
                _this2._popup.parent().find('div:eq(2)').css('width', _this2._popup.parent().css('width'));
                _this2._popup.parent().find('div:eq(2)').css('min-width', _this2._popup.parent().css('width').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('div:eq(2)').css('height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('div:eq(2)').css('min-height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('.tabular-data-container').css('height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('.headertable').css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('.top-menu').css('height').replace(/[^0-9.]+/g, "") - 15);
            };

            _this2._popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            _this2._popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(_this2._popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(_this2._popup);
                    adjustSize();
                }
            });

            $scope.$on('ngRepeatFinished', function () {
                adjustSize();
            });

            $scope.$on('updatePreferencesLanguage', function () {
                adjustSize();

                if ($scope.alerts.length > 0) {
                    var msg = _this2.translation.message[$scope.alerts[0].languageCode.toUpperCase()];
                    var type = $scope.alerts[0].type;
                    var languageCode = $scope.alerts[0].languageCode;
                    if (languageCode.toUpperCase() === 'NO_DATA') {
                        msg += ': ' + moment(_this2.sequenceNumberTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.sequenceNumberTable.end).utc().format('MM/DD/YY, h:mm:ss a');
                    }
                    $scope.alerts = [];
                    _this2.alerts = [];
                    $scope.alerts.push({ msg: msg, type: type, languageCode: languageCode });
                    _this2.alerts.push({ msg: msg, type: type, languageCode: languageCode });
                }
            });
        }

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            _this2.preferredTimeFormat = parseInt(timeFormat, 10);
        });

        $scope.$on('ngRepeatFinished', function () {
            _this2._autoScroll();
            _this2.checkFirstRowLiveStatus = null;
        });

        _this2._autoScroll = function () {
            if (_this2.sequenceNumberTable.previousRecords > 0) {
                var trRow = _this2.table.find('tr').eq(_this2.sequenceNumberTable.previousRecords - 1);
                var yPosition = typeof trRow.position() !== 'undefined' ? trRow.position().top - 90 : 2;
                _this2.table.scrollTop(yPosition);
            } else {
                var _this = _this2;
                $timeout(function () {
                    _this.table.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        // dateAgentText filter called from html
        //this.dateAgentText = (date, timeFormat) =>
        //    datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss.sss', false, timeFormat);

        $timeout(function () {
            _this2.table = $('#sequence-number-table-' + _this2.replaceSpaces(_this2.windowId || _this2.translation.text.SEQUENCE_NUMBER_TABLE));
            // Handle infinite scrolling
            _this2.table.on('scroll', function (event) {
                var $rowFirst = _this2.table.contents().find('tr:first');
                var $rowLast = _this2.table.contents().find('tr:last');
                var _firstRow = $rowFirst.attr('name');
                if (typeof $rowFirst.position() !== 'undefined') {
                    _this2.infiniteScrollOn = true;
                    _this2.infiniteScrollUpOn = true;
                    _this2.infiniteScrollDownOn = true;

                    var _tableTop = _this2.table.offset().top;
                    var _rowTop = $rowFirst.offset().top;
                    _this2._setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);

                    _this2.previousScrollbarPosition = _this2.currentScrollbarPosition;
                    _this2.currentScrollbarPosition = _this2.table[0].scrollTop;
                }

                if (_this2.infiniteScrollOn === true) {
                    _this2.infiniteScrollUpOn = true;
                    _this2.infiniteScrollDownOn = true;

                    if (_this2.currentScrollbarPosition <= 35 && _this2.previousScrollbarPosition > 35) {
                        _this2.checkFirstRowLiveStatus = null;
                    }

                    if (_this2.infiniteScrollDownOn === true && _this2.table[0].scrollTop + _this2.table[0].offsetHeight + 5 > _this2.table[0].scrollHeight && _this2.table[0].scrollTop > 0) {
                        $rowLast.addClass('active-row');
                        _this2.alerts = [];
                        $scope.alerts = [];
                        _this2.sequenceNumberTable.nextPage().then(function (resp) {
                            if (resp.data && resp.data.length === 0 && _this2.sequenceNumberTable.table.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.sequenceNumberTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.sequenceNumberTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                                $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            }
                        });
                    }
                    if (_this2.infiniteScrollUpOn === true && _this2.table[0].scrollTop < 5 && _this2.currentScrollbarPosition < _this2.previousScrollbarPosition) {
                        $rowFirst.addClass('active-row');
                        _this2.alerts = [];
                        $scope.alerts = [];
                        $timeout(function () {
                            // Give it time to set the live data status
                            _this2.sequenceNumberTable.previousPage().then(function (resp) {
                                if (resp.data && resp.data.length === 0 && _this2.sequenceNumberTable.table.length === 0) {
                                    $scope.alerts.length = 0;
                                    _this2.alerts.length = 0;

                                    var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.sequenceNumberTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.sequenceNumberTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                                    $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                    _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                }
                            });
                        });
                    }
                }

                var rows = _this2.table.children().children().children().children();
                var scrollpos = 40;
                var start = 0;
                var end = rows.length;
                var count = 0;

                while (start !== end) {
                    count++;
                    var mid = start + Math.floor((end - start) / 2);
                    if ($(rows[mid]).position().top < scrollpos) {
                        start = mid + 1;
                    } else {
                        end = mid;
                    }
                }
                _this2._updateZoom(parseFloat($($(rows[start])).attr('name')));
            });
        });

        // Toggle the active row when user clicks
        _this2.toggle = function ($event) {
            if ($($event.currentTarget).hasClass('active-row')) {
                $($event.currentTarget).removeClass('active-row');
            } else {
                $($event.currentTarget).addClass('active-row');
            }
        };

        $scope.$watch(function () {
            return $scope.deviceSelectedSn;
        }, function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                if (oldVal) {
                    // this._unRegisterListener(oldVal);
                }
            }
        }, true);

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal) {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newVal, windowId: _this2.windowId });
                if (_this2.sequenceNumberTable) {
                    _this2.sequenceNumberTable.reset(newVal, $scope.deviceSelectedName);
                } else {
                    _this2.sequenceNumberTable = new SequenceNumberTableFactory(_this2.accountInfo.customerId, newVal, $scope.deviceSelectedName, _this2.accountInfo.timeZone);
                }

                _this2.currentScrollbarPosition = 0;
                _this2.previousScrollbarPosition = 0;
                _this2.checkFirstRowLiveStatus = null;
                $scope.alerts = [];
                _this2.alerts = [];

                if ($scope.stickyProperties.savedDesktop === true && $scope.stickyProperties.on === true) {
                    _this2.savedDesktopRow = $scope.stickyProperties.zoomMax;
                    $scope.stickyProperties.on = true;
                    $scope.stickyProperties.savedDesktop = false;
                    _this2.sequenceNumberTable.start = $scope.stickyProperties.dateMin;
                    _this2.sequenceNumberTable.end = $scope.stickyProperties.dateMax;
                    _this2.sequenceNumberTable.nextPage().then(function (resp) {
                        if (resp.data && resp.data.length === 0 && _this2.sequenceNumberTable.table.length === 0) {
                            $scope.alerts.length = 0;
                            _this2.alerts.length = 0;

                            var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.sequenceNumberTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.sequenceNumberTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                            $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                        }
                    });
                } else if ($scope.stickyProperties.on !== null && $scope.stickyProperties.dateMin !== null) {
                    // doesn't work well - need to check
                    $scope.stickyProperties.on = true;
                    _this2.sequenceNumberTable.start = $scope.stickyProperties.dateMin - 3 * _this2.unixDay;
                    timeLapseService.getLocalDateTime().then(function (resp) {
                        var result = resp.data;

                        if ($scope.stickyProperties.dateMax >= parseFloat(result.unixTimeStamp) && $scope.stickyProperties.zoomMax + parseFloat(_this2.liveDataOffset) >= parseFloat(result.unixTimeStamp)) {
                            _this2.sequenceNumberTable.end = $scope.stickyProperties.dateMax;
                        } else {
                            _this2.sequenceNumberTable.end = Math.round(($scope.stickyProperties.zoomMax + $scope.stickyProperties.zoomMin) / 2);
                        }

                        _this2.sequenceNumberTable.nextPage().then(function (resp) {
                            if (resp.data && resp.data.length === 0 && _this2.sequenceNumberTable.table.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.sequenceNumberTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.sequenceNumberTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                                $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            }
                        });
                    });
                } else {
                    $scope.stickyProperties.on = false;
                    timeLapseService.getLocalDateTime().then(function (resp) {
                        var result = resp.data;

                        var newDate = new Date(result.localDateTime);
                        newDate.setHours(0, 0, 0, 0);
                        var endDate = new Date(newDate.getTime() + 3 * 86400000);
                        _this2.sequenceNumberTable.end = datetimeService.dateToUnixtime(endDate);
                        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: datetimeService.dateToUnixtime(endDate), windowId: _this2.windowId });
                        _this2.sequenceNumberTable.nextPage().then(function (resp) {
                            if (resp.data && resp.data.length === 0 && _this2.sequenceNumberTable.table.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.sequenceNumberTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.sequenceNumberTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                                $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            }
                        });
                    });
                }
            }
        }, true);

        $scope.mostRecentData = function () {
            _this2.myDate = null;
            toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
            $scope.fetchDataForSelectedDate(new Date());
        };

        $scope.fetchDataForSelectedDate = function (newVal) {
            _this2.sequenceNumberTable.reset();
            _this2.currentScrollbarPosition = 0;
            _this2.previousScrollbarPosition = 0;
            _this2.checkFirstRowLiveStatus = null;
            _this2._unRegisterListener();

            var tmpDates = newVal;
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            if (_this2.selectedGrouping === '4') {
                tmpDatesA.setHours(23, 59, 59, 999);
            } else {
                tmpDatesA.setHours(12, 0, 0, 0);
            }
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);

            _this2.sequenceNumberTable.start = tmpDates.startDate;
            if (new Date(newVal).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                _this2.sequenceNumberTable.end = tmpDatesA;
            } else {
                _this2.sequenceNumberTable.end = tmpDates.endDate;
            }

            $scope.alerts = [];
            _this2.alerts = [];
            _this2.sequenceNumberTable.nextPage().then(function (resp) {
                if (resp.data && resp.data.length === 0 && _this2.sequenceNumberTable.table.length === 0) {
                    $scope.alerts.length = 0;
                    _this2.alerts.length = 0;

                    var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.sequenceNumberTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.sequenceNumberTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                    $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                    _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                }
            });
            sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + _this2.unixDay, zoomMax: tmpDates.endDate - _this2.unixDay, windowId: _this2.windowId });
        };

        $scope.$watch(function () {
            return _this2.myDate;
        }, function (newVal, oldVal) {
            if (newVal) {
                $scope.fetchDataForSelectedDate(newVal);
            }
        });
    };

    this.liveDataLine = function (varLiveData) {
        if (_this2.liveDataisOffForNow) return;
        if (varLiveData) {
            _this2.liveTable.addClass('live-data-line');
        } else {
            _this2.liveTable.removeClass('live-data-line');
        }
    };

    this._updateZoom = function (currentRow) {
        if (isNaN(currentRow)) {
            return;
        }

        var zoomMin = currentRow - _this2.paddingZoom;
        var zoomMax = currentRow + _this2.paddingZoom;

        var dateMin = $scope.stickyProperties.dateMin;
        var dateMax = $scope.stickyProperties.dateMax;

        if (zoomMin < $scope.stickyProperties.dateMin) {
            dateMin = zoomMin;
        }
        if (zoomMax > $scope.stickyProperties.dateMax) {
            dateMax = zoomMax;
        }

        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: _this2.windowId });
    };
}

SequenceNumberTableController.$inject = ['_', '$', '$scope', '$filter', '$timeout', '$element', 'authenticationService', 'translationService', 'datetimeService', 'sharedSetupService', 'openViewService', 'timeLapseService', 'websocketService', 'SequenceNumberTableFactory', 'toaster'];
'use strict';

angular.module('mc.sequence-number').component('sequenceNumberTable', {
    controller: SequenceNumberTableController,
    templateUrl: 'ui/sequencenumber/table/sequence-number-table-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
//angular.module('mc.location', []);
"use strict";
'use strict';

angular.module('mc.location', []);
'use strict';

function DeviceLocationController($scope, $http, HOST, authenticationService, translationService, deviceService, sharedSetupService, openViewService, $timeout) {
  var _this2 = this;

  this.$onInit = function () {
    _this2.accountInfo = authenticationService.getAccountInfo();
    _this2.readOnly = _this2.accountInfo.userRole.indexOf("Administrator") !== -1 ? false : true;
    _this2.translation = translationService.translation;
    _this2.selectedTab = 0;
    _this2.mapOptions = {
      latitude: 0,
      longitude: 0
    };
    //this.originalLocation = {
    //  latitude: 0,
    //  longitude: 0,
    //};
    _this2.location = {
      latitude: {
        degrees: 0,
        minutes: 0,
        seconds: 0,
        direction: 'N'
      },
      longitude: {
        degrees: 0,
        minutes: 0,
        seconds: 0,
        direction: 'W'
      }
    };

    //$http.get(`${HOST}/api/Device?deviceId=${this.deviceId}&customerId=${this.accountInfo.customerId}`).then((resp) => {
    //  if (resp.data.latitude < 0) {
    //    this.location.latitude.direction = 'S';
    //  }

    //  if (resp.data.longitude < 0) {
    //    this.location.longitude.direction = 'W';
    //  }

    //  this.mapOptions.latitude = resp.data.latitude || 0;
    //  this.mapOptions.longitude = resp.data.longitude || 0;
    //  this.originalLocation.latitude = Math.abs(resp.data.latitude).toFixed(7) * 1 || 0;
    //  this.originalLocation.longitude = Math.abs(resp.data.longitude).toFixed(7) * 1 || 0;
    //  this.location.latitude.degrees = Math.abs(resp.data.latitude).toFixed(7)  * 1 || 0;
    //  this.location.longitude.degrees = Math.abs(resp.data.longitude).toFixed(7) * 1 || 0;
    //});

    if (!_this2.mobile && !_this2.classicView) {
      _this2._popup = _this.getExistingDialog(_this2.windowId).ref;

      _this2.resizeContent = function () {
        $timeout(function () {
          var _newWidth = $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().css('width').replace(/[^0-9.]+/g, "");
          $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.widgetSettingNew').css('width', _newWidth < 240 ? 240 : _newWidth).css('margin-left', _newWidth < 240 ? -(240 - _newWidth) / 2 : 'auto');
          $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().css('height', $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.dragwidget')[0].clientHeight);
          $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().css('height', $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.dragwidget')[0].clientHeight + $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.ui-dialog-titlebar')[0].clientHeight);
        });
      };

      _this2._popup.dialog({
        resize: function resize(event, ui) {
          _this2.onResize();
          $scope.$broadcast('resize_map');
        }
      });

      _this2._popup.dialogExtend({
        maximize: function maximize(event, ui) {
          openViewService.adjustContentSizeStart(_this2._popup);
          _this2.onResize();
          $scope.$broadcast('resize_map');
        },
        restore: function restore(event, ui) {
          openViewService.adjustContentSizeStart(_this2._popup);
          _this2.onResize();
          $scope.$broadcast('resize_map');
        }
      });

      $timeout(function () {
        _this2.onResize();
      }, 0);
    }
    _this2.latitudeMinutesDecimalErrorTab1 = false;
    _this2.longitudeMinutesDecimalErrorTab1 = false;
    _this2.latitudeSecondsDecimalErrorTab2 = false;
    _this2.longitudeSecondsDecimalErrorTab2 = false;
  };

  this.checkDecimal = function (number, value, tab) {
    var count = (number.match(/\./g) || []).length;
    if (count > 1) {
      if (value == "latitudeMinutes" && tab == "tab1") {
        _this2.latitudeMinutesDecimalErrorTab1 = true;
      } else if (value == "longitudeMinutes" && tab == "tab1") {
        _this2.longitudeMinutesDecimalErrorTab1 = true;
      } else if (value == "latitudeSeconds" && tab == "tab2") {
        _this2.latitudeSecondsDecimalErrorTab2 = true;
      } else if (value == "longitudeSeconds" && tab == "tab2") {
        _this2.longitudeSecondsDecimalErrorTab2 = true;
      } else {
        _this2.latitudeMinutesDecimalErrorTab1 = false;
        _this2.longitudeMinutesDecimalErrorTab1 = false;
        _this2.latitudeSecondsDecimalErrorTab2 = false;
        _this2.longitudeSecondsDecimalErrorTab2 = false;
      }
    } else {
      _this2.latitudeMinutesDecimalErrorTab1 = false;
      _this2.longitudeMinutesDecimalErrorTab1 = false;
      _this2.latitudeSecondsDecimalErrorTab2 = false;
      _this2.longitudeSecondsDecimalErrorTab2 = false;
    }
  };

  this.hasValidValues = function () {
    if (_this2.selectedTab === 0) {
      if (_this2.location.latitude.degrees > 90 || _this2.location.latitude.degrees === '') {
        return false;
      }

      if (_this2.location.longitude.degrees > 180 || _this2.location.longitude.degrees === '') {
        return false;
      }
    } else if (_this2.selectedTab === 1) {
      if (_this2.location.latitude.degrees > 89 || _this2.location.latitude.degrees === '') {
        return false;
      }

      if (_this2.location.longitude.degrees > 179 || _this2.location.longitude.degrees === '') {
        return false;
      }

      if (_this2.location.latitude.minutes > 60 || _this2.location.latitude.minutes === '' || _this2.latitudeMinutesDecimalErrorTab1 == true) {
        return false;
      }

      if (_this2.location.longitude.minutes > 60 || _this2.location.longitude.minutes === '' || _this2.longitudeMinutesDecimalErrorTab1 == true) {
        return false;
      }
    } else if (_this2.selectedTab === 2) {
      if (_this2.location.latitude.degrees > 89 || _this2.location.latitude.degrees === '') {
        return false;
      }

      if (_this2.location.longitude.degrees > 179 || _this2.location.longitude.degrees === '') {
        return false;
      }

      if (_this2.location.latitude.minutes > 59 || _this2.location.latitude.minutes === '') {
        return false;
      }

      if (_this2.location.longitude.minutes > 59 || _this2.location.longitude.minutes === '') {
        return false;
      }

      if (_this2.location.latitude.seconds > 60 || _this2.location.latitude.seconds === '' || _this2.latitudeSecondsDecimalErrorTab2 == true) {
        return false;
      }

      if (_this2.location.longitude.seconds > 60 || _this2.location.longitude.seconds === '' || _this2.longitudeSecondsDecimalErrorTab2 == true) {
        return false;
      }
    } else {
      return false;
    }

    return true;
  };

  this.disableSwitching = function () {
    if (_this2.location.latitude.degrees === '' || _this2.location.latitude.minutes === '' || _this2.location.longitude.seconds === '' || _this2.location.longitude.degrees === '' || _this2.location.longitude.minutes === '' || _this2.location.longitude.seconds === '') {
      return true;
    }

    return false;
  };

  this.handleTabSwitch = function (tabId) {
    if (tabId !== _this2.selectedTab) {
      // Handle switching to Degrees tab from other tabs
      if (tabId === 0) {
        if (_this2.selectedTab === 2) {
          _this2.location.latitude.degrees = _this2.location.latitude.degrees * 1 + _this2.location.latitude.seconds / 3600;
          _this2.location.longitude.degrees = _this2.location.longitude.degrees * 1 + _this2.location.longitude.seconds / 3600;
          _this2.location.latitude.seconds = 0;
          _this2.location.longitude.seconds = 0;
        }

        _this2.location.latitude.degrees = (_this2.location.latitude.degrees * 1 + _this2.location.latitude.minutes / 60).toFixed(7) * 1;
        _this2.location.longitude.degrees = (_this2.location.longitude.degrees * 1 + _this2.location.longitude.minutes / 60).toFixed(7) * 1;
        _this2.location.latitude.minutes = 0;
        _this2.location.longitude.minutes = 0;

        _this2.selectedTab = tabId;
        return;
      }

      // Handle switching to Degrees Minutes tab from other tabs
      if (tabId === 1) {
        if (_this2.selectedTab === 2) {
          _this2.location.latitude.minutes = (_this2.location.latitude.minutes * 1 + _this2.location.latitude.seconds / 60).toFixed(5) * 1;
          _this2.location.longitude.minutes = (_this2.location.longitude.minutes * 1 + _this2.location.longitude.seconds / 60).toFixed(5) * 1;
          _this2.location.latitude.seconds = 0;
          _this2.location.longitude.seconds = 0;
        } else {
          _this2.location.latitude.minutes = ((_this2.location.latitude.degrees * 1 - Math.floor(_this2.location.latitude.degrees)) * 60).toFixed(5) * 1;
          _this2.location.longitude.minutes = ((_this2.location.longitude.degrees * 1 - Math.floor(_this2.location.longitude.degrees)) * 60).toFixed(5) * 1;
          _this2.location.latitude.degrees = Math.floor(_this2.location.latitude.degrees);
          _this2.location.longitude.degrees = Math.floor(_this2.location.longitude.degrees);
        }

        _this2.selectedTab = tabId;
        return;
      }

      // Handle switching to Degrees Minutes Seconds tab from other tabs
      if (tabId === 2) {
        if (_this2.selectedTab === 0) {
          _this2.location.latitude.minutes = (_this2.location.latitude.degrees * 1 - Math.floor(_this2.location.latitude.degrees)) * 60;
          _this2.location.longitude.minutes = (_this2.location.longitude.degrees * 1 - Math.floor(_this2.location.longitude.degrees)) * 60;
          _this2.location.latitude.degrees = Math.floor(_this2.location.latitude.degrees);
          _this2.location.longitude.degrees = Math.floor(_this2.location.longitude.degrees);
        }

        _this2.location.latitude.seconds = ((_this2.location.latitude.minutes * 1 - Math.floor(_this2.location.latitude.minutes)) * 60).toFixed(3) * 1;
        _this2.location.longitude.seconds = ((_this2.location.longitude.minutes * 1 - Math.floor(_this2.location.longitude.minutes)) * 60).toFixed(3) * 1;
        _this2.location.latitude.minutes = Math.floor(_this2.location.latitude.minutes);
        _this2.location.longitude.minutes = Math.floor(_this2.location.longitude.minutes);

        if (_this2.location.latitude.seconds === 60) {
          _this2.location.latitude.minutes += 1;
          _this2.location.latitude.seconds = 0;
        }

        if (_this2.location.longitude.seconds === 60) {
          _this2.location.longitude.minutes += 1;
          _this2.location.longitude.seconds = 0;
        }

        _this2.selectedTab = tabId;
        return;
      }
    }
  };

  //this.onDragEnd = (lat, long) => {
  //  if (lat < 0 && this.location.latitude.direction === 'N') {
  //    this.location.latitude.direction = 'S';
  //  } else if (lat > 0 && this.location.latitude.direction === 'S') {
  //    this.location.latitude.direction = 'N';
  //  }

  //  if (long < 0 && this.location.longitude.direction === 'E') {
  //    this.location.longitude.direction = 'W';
  //  } else if (long > 0 && this.location.longitude.direction === 'W') {
  //    this.location.longitude.direction = 'E';
  //  }

  //  lat = Math.abs((lat).toFixed(7) * 1);
  //  long = Math.abs((long).toFixed(7) * 1);

  //  if (this.selectedTab === 0) {
  //    this.location.latitude.degrees = lat;
  //    this.location.longitude.degrees = long;
  //  } else if (this.selectedTab === 1) {
  //    this.location.latitude.minutes = ((lat * 1 - Math.floor(lat)) * 60).toFixed(5) * 1;
  //    this.location.longitude.minutes = ((long * 1 - Math.floor(long)) * 60).toFixed(5) * 1;
  //    this.location.latitude.degrees = Math.floor(lat);
  //    this.location.longitude.degrees = Math.floor(long);
  //  } else if (this.selectedTab === 2) {
  //    this.location.latitude.minutes = ((lat * 1 - Math.floor(lat)) * 60);
  //    this.location.longitude.minutes = ((long * 1 - Math.floor(long)) * 60);
  //    this.location.latitude.degrees = Math.floor(lat);
  //    this.location.longitude.degrees = Math.floor(long);

  //    this.location.latitude.seconds = ((this.location.latitude.minutes * 1 - Math.floor(this.location.latitude.minutes)) * 60).toFixed(3)  * 1;
  //    this.location.longitude.seconds = ((this.location.longitude.minutes * 1 - Math.floor(this.location.longitude.minutes)) * 60).toFixed(3)  * 1;
  //    this.location.latitude.minutes = Math.floor(this.location.latitude.minutes);
  //    this.location.longitude.minutes = Math.floor(this.location.longitude.minutes);
  //  }

  //  this.updateOptions();
  //}

  this.updateOptions = function () {
    if (_this2.hasValidValues()) {
      //const oldLat = (this.mapOptions.latitude * 1).toFixed(7);
      //const oldLong = (this.mapOptions.longitude * 1).toFixed(7);
      var latitude = _this2.location.latitude.degrees;
      var longitude = _this2.location.longitude.degrees;

      if (_this2.selectedTab === 0) {
        _this2.mapOptions.latitude = _this2.location.latitude.direction === 'S' ? -_this2.location.latitude.degrees : _this2.location.latitude.degrees;
        _this2.mapOptions.longitude = _this2.location.longitude.direction === 'W' ? -_this2.location.longitude.degrees : _this2.location.longitude.degrees;
      } else if (_this2.selectedTab === 1) {
        latitude = _this2.location.latitude.degrees * 1 + _this2.location.latitude.minutes / 60;
        longitude = _this2.location.longitude.degrees * 1 + _this2.location.longitude.minutes / 60;

        _this2.mapOptions.latitude = _this2.location.latitude.direction === 'S' ? -latitude : latitude;
        _this2.mapOptions.longitude = _this2.location.longitude.direction === 'W' ? -longitude : longitude;
      } else if (_this2.selectedTab === 2) {
        latitude = _this2.location.latitude.degrees * 1 + _this2.location.latitude.minutes / 60 + _this2.location.latitude.seconds / 3600;
        longitude = _this2.location.longitude.degrees * 1 + _this2.location.longitude.minutes / 60 + _this2.location.longitude.seconds / 3600;

        _this2.mapOptions.latitude = _this2.location.latitude.direction === 'S' ? -latitude : latitude;
        _this2.mapOptions.longitude = _this2.location.longitude.direction === 'W' ? -longitude : longitude;
      }

      //if (this.mapOptions.latitude !== oldLat) {
      //  const latitudePatch = { op: 'replace', path: 'latitude', value: (this.mapOptions.latitude * 1).toFixed(7) };
      //  deviceService.patchDevice(this.deviceId, this.accountInfo.customerId, latitudePatch).then((resp) => {
      //    console.log(latitude);
      //    this.originalLocation.latitude = latitude;
      //  }, (resp) => {
      //    console.log(resp);
      //  });
      //}

      //if (this.mapOptions.longitude !== oldLong) {
      //  const longitudePatch = { op: 'replace', path: 'longitude', value: (this.mapOptions.longitude * 1).toFixed(7) };
      //  deviceService.patchDevice(this.deviceId, this.accountInfo.customerId, longitudePatch).then((resp) => {
      //    this.originalLocation.longitude = longitude;
      //  }, (resp) => {
      //    console.log(resp);
      //  });
      //  }

      //invoke parent compenent callback function to return the latitude and longtude to parent.
      _this2.onUpdate({ mapOptions: _this2.mapOptions });
    }
  };
}

DeviceLocationController.$inject = ['$scope', '$http', 'HOST', 'authenticationService', 'translationService', 'deviceService', 'sharedSetupService', 'openViewService', '$timeout'];

angular.module('mc.location').component('deviceLocation', {
  controller: DeviceLocationController,
  transclude: true,
  templateUrl: 'ui/rtulist/location/device-location-partial.html',
  bindings: {
    windowId: '<',
    //deviceId: '<',
    mobile: '<',
    classicView: '<',
    stickyProperties: '<',
    //deviceSelected: '<',
    onResize: '&',
    onUpdate: '&'
  }
});
'use strict';

function LocationController($scope, $http, HOST, authenticationService, translationService, deviceService, sharedSetupService, openViewService, $timeout) {
  var _this2 = this;

  this.$onInit = function () {
    _this2.accountInfo = authenticationService.getAccountInfo();
    _this2.readOnly = _this2.accountInfo.userRole.indexOf("Administrator") !== -1 ? false : true;
    _this2.translation = translationService.translation;
    _this2.selectedTab = 0;

    //this.ourMmPlusDevice = this.deviceId == 50007 ? true : false;

    _this2.mapOptions = {
      latitude: 0,
      longitude: 0
    };
    _this2.originalLocation = {
      latitude: 0,
      longitude: 0
    };
    _this2.location = {
      latitude: {
        degrees: 0,
        minutes: 0,
        seconds: 0,
        direction: 'N'
      },
      longitude: {
        degrees: 0,
        minutes: 0,
        seconds: 0,
        direction: 'W'
      }
    };

    $http.get(HOST + '/api/Device?deviceId=' + _this2.deviceId + '&customerId=' + _this2.accountInfo.customerId + '&mcLogName=Location').then(function (resp) {
      if (resp.data.latitude < 0) {
        _this2.location.latitude.direction = 'S';
      }

      if (resp.data.longitude < 0) {
        _this2.location.longitude.direction = 'W';
      }

      _this2.mapOptions.latitude = resp.data.latitude || 0;
      _this2.mapOptions.longitude = resp.data.longitude || 0;
      _this2.originalLocation.latitude = Math.abs(resp.data.latitude).toFixed(7) * 1 || 0;
      _this2.originalLocation.longitude = Math.abs(resp.data.longitude).toFixed(7) * 1 || 0;
      _this2.location.latitude.degrees = Math.abs(resp.data.latitude).toFixed(7) * 1 || 0;
      _this2.location.longitude.degrees = Math.abs(resp.data.longitude).toFixed(7) * 1 || 0;
    });

    if (!_this2.mobile && !_this2.classicView) {
      _this2._popup = _this.getExistingDialog(_this2.windowId).ref;

      _this2.resizeContent = function () {
        $timeout(function () {
          var _newWidth = $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().css('width').replace(/[^0-9.]+/g, "");
          $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.widgetSettingNew').css('width', _newWidth < 240 ? 240 : _newWidth).css('margin-left', _newWidth < 240 ? -(240 - _newWidth) / 2 : 'auto');
          $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().css('height', $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.dragwidget')[0].clientHeight);
          $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().css('height', $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.dragwidget')[0].clientHeight + $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.ui-dialog-titlebar')[0].clientHeight);
        });
      };

      _this2._popup.dialog({
        resize: function resize(event, ui) {
          _this2.onResize();
          $scope.$broadcast('resize_map');
        }
      });

      _this2._popup.dialogExtend({
        maximize: function maximize(event, ui) {
          openViewService.adjustContentSizeStart(_this2._popup);
          _this2.onResize();
          $scope.$broadcast('resize_map');
        },
        restore: function restore(event, ui) {
          openViewService.adjustContentSizeStart(_this2._popup);
          _this2.onResize();
          $scope.$broadcast('resize_map');
        }
      });

      $timeout(function () {
        _this2.onResize();
      }, 0);
    }
    _this2.latitudeMinutesDecimalErrorTab1 = false;
    _this2.longitudeMinutesDecimalErrorTab1 = false;
    _this2.latitudeSecondsDecimalErrorTab2 = false;
    _this2.longitudeSecondsDecimalErrorTab2 = false;
  };

  this.checkDecimal = function (number, value, tab) {
    var count = (number.match(/\./g) || []).length;
    if (count > 1) {
      if (value == "latitudeMinutes" && tab == "tab1") {
        _this2.latitudeMinutesDecimalErrorTab1 = true;
      } else if (value == "longitudeMinutes" && tab == "tab1") {
        _this2.longitudeMinutesDecimalErrorTab1 = true;
      } else if (value == "latitudeSeconds" && tab == "tab2") {
        _this2.latitudeSecondsDecimalErrorTab2 = true;
      } else if (value == "longitudeSeconds" && tab == "tab2") {
        _this2.longitudeSecondsDecimalErrorTab2 = true;
      } else {
        _this2.latitudeMinutesDecimalErrorTab1 = false;
        _this2.longitudeMinutesDecimalErrorTab1 = false;
        _this2.latitudeSecondsDecimalErrorTab2 = false;
        _this2.longitudeSecondsDecimalErrorTab2 = false;
      }
    } else {
      _this2.latitudeMinutesDecimalErrorTab1 = false;
      _this2.longitudeMinutesDecimalErrorTab1 = false;
      _this2.latitudeSecondsDecimalErrorTab2 = false;
      _this2.longitudeSecondsDecimalErrorTab2 = false;
    }
  };

  this.hasValidValues = function () {
    if (_this2.selectedTab === 0) {
      if (_this2.location.latitude.degrees > 90 || _this2.location.latitude.degrees === '') {
        return false;
      }

      if (_this2.location.longitude.degrees > 180 || _this2.location.longitude.degrees === '') {
        return false;
      }
    } else if (_this2.selectedTab === 1) {
      if (_this2.location.latitude.degrees > 89 || _this2.location.latitude.degrees === '') {
        return false;
      }

      if (_this2.location.longitude.degrees > 179 || _this2.location.longitude.degrees === '') {
        return false;
      }

      if (_this2.location.latitude.minutes > 60 || _this2.location.latitude.minutes === '' || _this2.latitudeMinutesDecimalErrorTab1 == true) {
        return false;
      }

      if (_this2.location.longitude.minutes > 60 || _this2.location.longitude.minutes === '' || _this2.longitudeMinutesDecimalErrorTab1 == true) {
        return false;
      }
    } else if (_this2.selectedTab === 2) {
      if (_this2.location.latitude.degrees > 89 || _this2.location.latitude.degrees === '') {
        return false;
      }

      if (_this2.location.longitude.degrees > 179 || _this2.location.longitude.degrees === '') {
        return false;
      }

      if (_this2.location.latitude.minutes > 59 || _this2.location.latitude.minutes === '') {
        return false;
      }

      if (_this2.location.longitude.minutes > 59 || _this2.location.longitude.minutes === '') {
        return false;
      }

      if (_this2.location.latitude.seconds > 60 || _this2.location.latitude.seconds === '' || _this2.latitudeSecondsDecimalErrorTab2 == true) {
        return false;
      }

      if (_this2.location.longitude.seconds > 60 || _this2.location.longitude.seconds === '' || _this2.longitudeSecondsDecimalErrorTab2 == true) {
        return false;
      }
    } else {
      return false;
    }

    return true;
  };

  this.disableSwitching = function () {
    if (_this2.location.latitude.degrees === '' || _this2.location.latitude.minutes === '' || _this2.location.longitude.seconds === '' || _this2.location.longitude.degrees === '' || _this2.location.longitude.minutes === '' || _this2.location.longitude.seconds === '') {
      return true;
    }

    return false;
  };

  this.handleTabSwitch = function (tabId) {
    if (tabId !== _this2.selectedTab) {
      // Handle switching to Degrees tab from other tabs
      if (tabId === 0) {
        if (_this2.selectedTab === 2) {
          _this2.location.latitude.degrees = _this2.location.latitude.degrees * 1 + _this2.location.latitude.seconds / 3600;
          _this2.location.longitude.degrees = _this2.location.longitude.degrees * 1 + _this2.location.longitude.seconds / 3600;
          _this2.location.latitude.seconds = 0;
          _this2.location.longitude.seconds = 0;
        }

        _this2.location.latitude.degrees = (_this2.location.latitude.degrees * 1 + _this2.location.latitude.minutes / 60).toFixed(7) * 1;
        _this2.location.longitude.degrees = (_this2.location.longitude.degrees * 1 + _this2.location.longitude.minutes / 60).toFixed(7) * 1;
        _this2.location.latitude.minutes = 0;
        _this2.location.longitude.minutes = 0;

        _this2.selectedTab = tabId;
        return;
      }

      // Handle switching to Degrees Minutes tab from other tabs
      if (tabId === 1) {
        if (_this2.selectedTab === 2) {
          _this2.location.latitude.minutes = (_this2.location.latitude.minutes * 1 + _this2.location.latitude.seconds / 60).toFixed(5) * 1;
          _this2.location.longitude.minutes = (_this2.location.longitude.minutes * 1 + _this2.location.longitude.seconds / 60).toFixed(5) * 1;
          _this2.location.latitude.seconds = 0;
          _this2.location.longitude.seconds = 0;
        } else {
          _this2.location.latitude.minutes = ((_this2.location.latitude.degrees * 1 - Math.floor(_this2.location.latitude.degrees)) * 60).toFixed(5) * 1;
          _this2.location.longitude.minutes = ((_this2.location.longitude.degrees * 1 - Math.floor(_this2.location.longitude.degrees)) * 60).toFixed(5) * 1;
          _this2.location.latitude.degrees = Math.floor(_this2.location.latitude.degrees);
          _this2.location.longitude.degrees = Math.floor(_this2.location.longitude.degrees);
        }

        _this2.selectedTab = tabId;
        return;
      }

      // Handle switching to Degrees Minutes Seconds tab from other tabs
      if (tabId === 2) {
        if (_this2.selectedTab === 0) {
          _this2.location.latitude.minutes = (_this2.location.latitude.degrees * 1 - Math.floor(_this2.location.latitude.degrees)) * 60;
          _this2.location.longitude.minutes = (_this2.location.longitude.degrees * 1 - Math.floor(_this2.location.longitude.degrees)) * 60;
          _this2.location.latitude.degrees = Math.floor(_this2.location.latitude.degrees);
          _this2.location.longitude.degrees = Math.floor(_this2.location.longitude.degrees);
        }

        _this2.location.latitude.seconds = ((_this2.location.latitude.minutes * 1 - Math.floor(_this2.location.latitude.minutes)) * 60).toFixed(3) * 1;
        _this2.location.longitude.seconds = ((_this2.location.longitude.minutes * 1 - Math.floor(_this2.location.longitude.minutes)) * 60).toFixed(3) * 1;
        _this2.location.latitude.minutes = Math.floor(_this2.location.latitude.minutes);
        _this2.location.longitude.minutes = Math.floor(_this2.location.longitude.minutes);

        if (_this2.location.latitude.seconds === 60) {
          _this2.location.latitude.minutes += 1;
          _this2.location.latitude.seconds = 0;
        }

        if (_this2.location.longitude.seconds === 60) {
          _this2.location.longitude.minutes += 1;
          _this2.location.longitude.seconds = 0;
        }

        _this2.selectedTab = tabId;
        return;
      }
    }
  };

  this.onDragEnd = function (lat, long) {
    if (lat < 0 && _this2.location.latitude.direction === 'N') {
      _this2.location.latitude.direction = 'S';
    } else if (lat > 0 && _this2.location.latitude.direction === 'S') {
      _this2.location.latitude.direction = 'N';
    }

    if (long < 0 && _this2.location.longitude.direction === 'E') {
      _this2.location.longitude.direction = 'W';
    } else if (long > 0 && _this2.location.longitude.direction === 'W') {
      _this2.location.longitude.direction = 'E';
    }

    lat = Math.abs(lat.toFixed(7) * 1);
    long = Math.abs(long.toFixed(7) * 1);

    if (_this2.selectedTab === 0) {
      _this2.location.latitude.degrees = lat;
      _this2.location.longitude.degrees = long;
    } else if (_this2.selectedTab === 1) {
      _this2.location.latitude.minutes = ((lat * 1 - Math.floor(lat)) * 60).toFixed(5) * 1;
      _this2.location.longitude.minutes = ((long * 1 - Math.floor(long)) * 60).toFixed(5) * 1;
      _this2.location.latitude.degrees = Math.floor(lat);
      _this2.location.longitude.degrees = Math.floor(long);
    } else if (_this2.selectedTab === 2) {
      _this2.location.latitude.minutes = (lat * 1 - Math.floor(lat)) * 60;
      _this2.location.longitude.minutes = (long * 1 - Math.floor(long)) * 60;
      _this2.location.latitude.degrees = Math.floor(lat);
      _this2.location.longitude.degrees = Math.floor(long);

      _this2.location.latitude.seconds = ((_this2.location.latitude.minutes * 1 - Math.floor(_this2.location.latitude.minutes)) * 60).toFixed(3) * 1;
      _this2.location.longitude.seconds = ((_this2.location.longitude.minutes * 1 - Math.floor(_this2.location.longitude.minutes)) * 60).toFixed(3) * 1;
      _this2.location.latitude.minutes = Math.floor(_this2.location.latitude.minutes);
      _this2.location.longitude.minutes = Math.floor(_this2.location.longitude.minutes);
    }

    _this2.updateOptions();
  };

  this.updateOptions = function () {
    if (_this2.hasValidValues()) {
      var oldLat = (_this2.mapOptions.latitude * 1).toFixed(7);
      var oldLong = (_this2.mapOptions.longitude * 1).toFixed(7);
      var latitude = _this2.location.latitude.degrees;
      var longitude = _this2.location.longitude.degrees;

      if (_this2.selectedTab === 0) {
        _this2.mapOptions.latitude = _this2.location.latitude.direction === 'S' ? -_this2.location.latitude.degrees : _this2.location.latitude.degrees;
        _this2.mapOptions.longitude = _this2.location.longitude.direction === 'W' ? -_this2.location.longitude.degrees : _this2.location.longitude.degrees;
      } else if (_this2.selectedTab === 1) {
        latitude = _this2.location.latitude.degrees * 1 + _this2.location.latitude.minutes / 60;
        longitude = _this2.location.longitude.degrees * 1 + _this2.location.longitude.minutes / 60;

        _this2.mapOptions.latitude = _this2.location.latitude.direction === 'S' ? -latitude : latitude;
        _this2.mapOptions.longitude = _this2.location.longitude.direction === 'W' ? -longitude : longitude;
      } else if (_this2.selectedTab === 2) {
        latitude = _this2.location.latitude.degrees * 1 + _this2.location.latitude.minutes / 60 + _this2.location.latitude.seconds / 3600;
        longitude = _this2.location.longitude.degrees * 1 + _this2.location.longitude.minutes / 60 + _this2.location.longitude.seconds / 3600;

        _this2.mapOptions.latitude = _this2.location.latitude.direction === 'S' ? -latitude : latitude;
        _this2.mapOptions.longitude = _this2.location.longitude.direction === 'W' ? -longitude : longitude;
      }

      if (_this2.mapOptions.latitude !== oldLat) {
        var latitudePatch = { op: 'replace', path: 'latitude', value: (_this2.mapOptions.latitude * 1).toFixed(7) };
        deviceService.patchDevice(_this2.deviceId, _this2.accountInfo.customerId, latitudePatch).then(function (resp) {
          console.log(latitude);
          _this2.originalLocation.latitude = latitude;
        }, function (resp) {
          console.log(resp);
        });
      }

      if (_this2.mapOptions.longitude !== oldLong) {
        var longitudePatch = { op: 'replace', path: 'longitude', value: (_this2.mapOptions.longitude * 1).toFixed(7) };
        deviceService.patchDevice(_this2.deviceId, _this2.accountInfo.customerId, longitudePatch).then(function (resp) {
          _this2.originalLocation.longitude = longitude;
        }, function (resp) {
          console.log(resp);
        });
      }
    }
  };
}

LocationController.$inject = ['$scope', '$http', 'HOST', 'authenticationService', 'translationService', 'deviceService', 'sharedSetupService', 'openViewService', '$timeout'];

angular.module('mc.location').component('location', {
  controller: LocationController,
  transclude: true,
  templateUrl: 'ui/rtuinfo/location/location-partial.html',
  bindings: {
    windowId: '<',
    deviceId: '<',
    mobile: '<',
    classicView: '<',
    stickyProperties: '<',
    deviceSelected: '<',
    onResize: '&'
  }
});
'use strict';

angular.module('mc.volumetric-calc', []);
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VolumetricCalcModel(_, HOST, $http, translationService, toaster) {
  var VolumetricCalc = function () {
    function VolumetricCalc(customerId, deviceId) {
      _classCallCheck(this, VolumetricCalc);

      this._loading = false;
      this._customerId = customerId;
      this._deviceId = deviceId;
    }

    _createClass(VolumetricCalc, [{
      key: "fetch",
      value: function fetch() {
        return $http.get(HOST + "/api/VolumetricCalc?customerId=" + this._customerId + "&deviceId=" + this._deviceId);
      }
    }, {
      key: "postUserActionVolCalc2Nlog",
      value: function postUserActionVolCalc2Nlog(customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Volumetric Flow Calculation";

        return $http({
          method: 'POST',
          url: HOST + "/api/VolumetricCalc",
          params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
          } });
      }
    }, {
      key: "settings",
      get: function get() {
        return this._settings;
      }
    }, {
      key: "loading",
      get: function get() {
        return this._loading;
      }
    }]);

    return VolumetricCalc;
  }();

  return VolumetricCalc;
}

VolumetricCalcModel.$inject = ['_', 'HOST', '$http', 'translationService', 'toaster'];

angular.module('mc.volumetric-calc').factory('VolumetricCalcModel', VolumetricCalcModel);
'use strict';

function VolumetricCalcController($scope, $filter, $timeout, $uibModal, authenticationService, translationService, deviceService, VolumetricCalc) {
    var _this = this;

    this.$onInit = function () {
        $scope.mobile = _this.mobile;
        $scope.classicView = _this.classicView;
        $scope.alerts = [];
        _this.alerts = [];
        _this.analogSettings = [];
        _this.accountInfo = authenticationService.getAccountInfo();
        _this.readOnly = _this.accountInfo.userRole.indexOf("Administrator") !== -1 ? false : true;
        _this.measurement = _this.accountInfo.preferenceUser.lookupMeasurementID;
        _this.translation = translationService.translation;
        _this.volCalcSettings = {};

        _this.volumetricCalc = new VolumetricCalc(_this.accountInfo.customerId, _this.deviceId);
        _this.volumetricCalc.fetch().then(function (resp) {
            if (resp.data.device.type !== 5 && resp.data.device.type !== 9 && resp.data.device.type !== 19) {
                _this.unsupported = true;
                return;
            }

            _this.digitalSettings = resp.data.digitalSettings;
            var hasOnePump = _this.digitalSettings.find(function (x) {
                return x.digitalMode === 'P';
            });
            if (typeof hasOnePump === 'undefined') {
                _this.unsupported = true;
                return;
            }

            _this.volCalcSettings = resp.data.volCalcSettings;
            resp.data.analogSettings.forEach(function (analogSetting) {
                var unit = analogSetting.unit.toLowerCase();
                if (unit.includes('meters') || unit.includes('meter') || unit.includes('inch') || unit.includes('inches') || unit.includes('mètre') || unit.includes('metre') || unit.includes('feet') || unit.includes('mm')) {
                    _this.analogSettings.push(analogSetting);
                }
            });

            _this.DIModes = '';
            _this.ParmOverrideModes = '';
            for (var i = 0; i < _this.digitalSettings.length; i++) {
                _this.digitalSettings[i].state = 'P';
                _this.DIModes += _this.digitalSettings[i].digitalMode;
                if (_this.digitalSettings[i].digitalMode !== 'P') {
                    _this.ParmOverrideModes += 'D';
                } else {
                    _this.ParmOverrideModes += 'P';
                }
            }

            if (_this.volCalcSettings.volCalcDigitalModeOverride !== '') {
                if (_this.volCalcSettings.volCalcDigitalModeOverride !== _this.ParmOverrideModes) {
                    for (var _i = 0; _i < _this.digitalSettings.length; _i++) {
                        if (_this.digitalSettings[_i].digitalMode === 'P') {
                            if (_this.volCalcSettings.volCalcDigitalModeOverride && _this.volCalcSettings.volCalcDigitalModeOverride.charAt(_i) === 'D') {
                                _this.digitalSettings[_i].state = 'D';
                            }
                        }
                    }
                }
            }

            _this.volCalcSettings.wellSqFt = _this.measurement === 2 ? (_this.volCalcSettings.wellSqFt * 0.3048 * 0.3048).toFixed(3) : (_this.volCalcSettings.wellSqFt * 1).toFixed(3);
            _this.volCalcSettings.volCalcLowLevel = (_this.volCalcSettings.volCalcLowLevel * 1).toFixed(1);
            _this.volCalcSettings.volCalcHighLevel = (_this.volCalcSettings.volCalcHighLevel * 1).toFixed(1);
            _this.volCalcSettings.volCalcLevelChannel = _this.volCalcSettings.volCalcLevelChannel.toString();
        }, function (resp) {});

        //Log tab access event to NLog
        _this.volumetricCalc.postUserActionVolCalc2Nlog(_this.accountInfo.customerId, _this.deviceId).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        $scope.$on('updatePreferencesMeasurement', function (event, measurement) {
            _this.measurement = measurement;

            // TODO: modify area
            _this.volCalcSettings.wellSqFt = measurement === 2 ? $filter('number')(_this.volCalcSettings.wellSqFt.replace(',', '') * 0.3048 * 0.3048, 3) : $filter('number')(_this.volCalcSettings.wellSqFt.replace(',', '') / 0.3048 / 0.3048, 3);
        });
    };

    this.openCalc = function () {
        function modalController($uibModalInstance, translation, measurement) {
            var $ctrl = this;
            $ctrl.areaType = '0';
            $ctrl.translation = translation;
            $ctrl.measurement = measurement;

            $ctrl.ok = function () {
                var area = 0;

                if ($ctrl.areaType === '0') {
                    if (angular.isUndefined($ctrl.length) || angular.isUndefined($ctrl.width)) return;
                    area = $ctrl.length * $ctrl.width;
                } else {
                    if (angular.isUndefined($ctrl.diameter)) return;
                    area = 3.14 * ($ctrl.diameter / 2) * ($ctrl.diameter / 2);
                }

                $uibModalInstance.close(area);
            };

            $ctrl.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation', 'measurement'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/rtuinfo/volumetriccalc/calculator-modal-partial.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this.translation;
                },
                measurement: function measurement() {
                    return _this.measurement;
                }
            }
        });

        modalInstance.result.then(function (area) {
            _this.volCalcSettings.wellSqFt = area;
            _this.saveWellSqFt();
        }, function () {
            // If user cancels
        });
    };

    this.resetLevels = function () {
        if (_this.volCalcSettings.volCalcLevelChannel === '0') {
            _this.volCalcSettings.volCalcLowLevel = 0;
            _this.volCalcSettings.volCalcHighLevel = 0;
        } else {
            _this.volCalcSettings.volCalcLowLevel = null;
            _this.volCalcSettings.volCalcHighLevel = null;
        }

        var devicePatch = { op: 'replace', path: 'volCalcLevelChannel', value: _this.volCalcSettings.volCalcLevelChannel };
        deviceService.patchDevice(_this.deviceId, _this.accountInfo.customerId, devicePatch).then(function (resp) {}, function (resp) {
            console.log(resp);
        });
        _this.saveCalcArea();
    };

    this.fixedPointsValid = function () {
        if (_this.volCalcSettings.volCalcLevelChannel === '0') {
            if (parseFloat(_this.volCalcSettings.volCalcLowLevel) > parseFloat(_this.volCalcSettings.volCalcHighLevel)) {
                return false;
            }

            if (angular.isUndefined(_this.volCalcSettings.volCalcHighLevel) || _this.volCalcSettings.volCalcHighLevel === null) {
                return false;
            }

            if (angular.isUndefined(_this.volCalcSettings.volCalcLowLevel) || _this.volCalcSettings.volCalcLowLevel === null) {
                return false;
            }
        }

        return true;
    };

    this.wellSqFtValid = function () {
        if (_this.volCalcSettings.wellSqFt === null || _this.volCalcSettings.wellSqFt === '' || _this.volCalcSettings.wellSqFt < 0 || _this.volCalcSettings.wellSqFt >= 1000000) {
            return false;
        }

        return true;
    };

    this.saveWellSqFt = function () {
        if (_this.wellSqFtValid()) {
            var wellSqFt = _this.measurement === 2 ? $filter('number')(_this.volCalcSettings.wellSqFt / 0.3048 / 0.3048, 3) : _this.volCalcSettings.wellSqFt;

            // Insert nulls if all values 0/null
            if (parseFloat(wellSqFt) === 0 && _this.volCalcSettings.volCalcLevelChannel === '0' && parseFloat(_this.volCalcSettings.volCalcLowLevel) === 0 && parseFloat(_this.volCalcSettings.volCalcHighLevel) === 0) {
                wellSqFt = null;
                _this.saveCalcArea();
            } else if (parseFloat(wellSqFt) === 0 && _this.volCalcSettings.volCalcLevelChannel !== '0') {
                wellSqFt = null;
            }

            var devicePatch = { op: 'replace', path: 'wellSqFt', value: wellSqFt };
            deviceService.patchDevice(_this.deviceId, _this.accountInfo.customerId, devicePatch).then(function (resp) {
                //console.log('SUCCESS');
            }, function (resp) {
                console.log(resp);
            });
        }
    };

    this.saveCalcArea = function () {
        if (_this.fixedPointsValid()) {
            var volCalcLowLevel = _this.volCalcSettings.volCalcLowLevel;
            var volCalcHighLevel = _this.volCalcSettings.volCalcHighLevel;

            if (parseFloat(_this.volCalcSettings.wellSqFt) === 0 && parseFloat(volCalcLowLevel) === 0 && parseFloat(volCalcHighLevel) === 0) {
                volCalcLowLevel = null;
                volCalcHighLevel = null;
            }

            var lowLevel = { op: 'replace', path: 'volCalcLowLevel', value: volCalcLowLevel };
            deviceService.patchDevice(_this.deviceId, _this.accountInfo.customerId, lowLevel).then(function (resp) {}, function (resp) {
                console.log(resp);
            });
            var highLevel = { op: 'replace', path: 'volCalcHighLevel', value: volCalcHighLevel };
            deviceService.patchDevice(_this.deviceId, _this.accountInfo.customerId, highLevel).then(function (resp) {}, function (resp) {
                console.log(resp);
            });
        }
    };

    this.savePumpOverrides = function () {
        var currentDigitalStates = '';
        var requiredDigitalStates = '';

        for (var i = 0; i < _this.digitalSettings.length; i++) {
            if (_this.digitalSettings[i].digitalMode !== 'P') {
                currentDigitalStates += 'D';
            } else {
                currentDigitalStates += _this.digitalSettings[i].state;
            }
        }
        //VolcalcDigitalModeOverride should only be 8 characters, only accept first 8 characters of VolcalcDigitalModeOverride
        if (currentDigitalStates.length > 0) requiredDigitalStates = currentDigitalStates.substring(0, 8);

        if (_this.volCalcSettings.volCalcDigitalModeOverride === '') {
            if (currentDigitalStates !== _this.ParmOverrideModes) {
                // TODO: Patch Device VolCalcDigitalModeOverride to currentDigitalStates
                var devicePatch = { op: 'replace', path: 'volCalcDigitalModeOverride', value: requiredDigitalStates };
                deviceService.patchDevice(_this.deviceId, _this.accountInfo.customerId, devicePatch).then(function (resp) {
                    _this.volCalcSettings.volCalcDigitalModeOverride = requiredDigitalStates;
                }, function (resp) {
                    console.log(resp);
                });
            }
        } else {
            // Preexisting override
            if (_this.volCalcSettings.volCalcDigitalModeOverride !== currentDigitalStates) {
                if (currentDigitalStates !== _this.ParmOverrideModes) {
                    // TODO: Patch Device VolCalcDigitalModeOverride to currentDigitalStates
                    var _devicePatch = { op: 'replace', path: 'volCalcDigitalModeOverride', value: requiredDigitalStates };
                    deviceService.patchDevice(_this.deviceId, _this.accountInfo.customerId, _devicePatch).then(function (resp) {
                        _this.volCalcSettings.volCalcDigitalModeOverride = requiredDigitalStates;
                    }, function (resp) {
                        console.log(resp);
                    });
                } else {
                    // TODO: Patch Device VolCalcDigitalModeOverride to null
                    var _devicePatch2 = { op: 'replace', path: 'volCalcDigitalModeOverride', value: null };
                    deviceService.patchDevice(_this.deviceId, _this.accountInfo.customerId, _devicePatch2).then(function (resp) {
                        _this.volCalcSettings.volCalcDigitalModeOverride = null;
                    }, function (resp) {
                        console.log(resp);
                    });
                }
            }
        }
    };
}

VolumetricCalcController.$inject = ['$scope', '$filter', '$timeout', '$uibModal', 'authenticationService', 'translationService', 'deviceService', 'VolumetricCalcModel'];

angular.module('mc.volumetric-calc').component('volumetricCalc', {
    controller: VolumetricCalcController,
    transclude: true,
    templateUrl: 'ui/rtuinfo/volumetriccalc/volumetric-calc-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        deviceId: '<'
    }
});
'use strict';

function RuntimeRainfallChartFactory(HOST, $http) {
    var _this = this;

    var RuntimeRainfallChart = function RuntimeRainfallChart(customerId) {
        //this.loading = false;
        _this.customerId = customerId;
    };

    //Rainfall.prototype.isLoading = () =>
    //    this.loading;

    RuntimeRainfallChart.prototype.fetchSettings = function (deviceId) {
        return $http.get(HOST + '/api/ParmPulse?deviceId=' + deviceId);
    };

    RuntimeRainfallChart.prototype.fetchData = function (customerId, deviceId, deviceType, startRow, pageSize, startDate, endDate, metarStationId, rainfallSite) {
        _this.loading = true;
        //   let reqUrl  = HOST + "/api/RuntimeVsRainfallChart" +
        //                 "?customerId=" + customerId +
        //                 "&deviceId=" + deviceId +
        //                 "&deviceType=" + deviceType +
        //                 "&startRow=" + startRow +
        //                 "&pageSize=" + pageSize +
        //                 "&startDate=" + start +
        //                 "&endDate=" + end +
        //                 "&metarStationId=" + metarStationID +
        //                 "&rainfallSite=" + rainfallSite;
        var reqUrl = HOST + '/api/RuntimeVsRainfallChart?customerId=' + customerId + '&deviceId=' + deviceId + '&deviceType=' + deviceType + '&startRow=' + (startRow || 1) + '&pageSize=' + (pageSize || 50) + '&startDate=' + startDate + '&endDate=' + endDate + '&metarStationId=' + metarStationId + '&rainfallSite=' + rainfallSite;
        return $http.get(reqUrl);
    };

    return RuntimeRainfallChart;
}

RuntimeRainfallChartFactory.$inject = ['HOST', '$http'];

angular.module('mc.rainfall').factory('RuntimeRainfallChartFactory', RuntimeRainfallChartFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RuntimeRainfallChartController($scope, $q, sharedSetupService, openViewService, translationService, $element, authenticationService, $rootScope, $timeout, RuntimeRainfallChartFactory, datetimeService, websocketService, timeLapseService, toaster, rangeSelectorService) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    ctrl.downloadViewTypeOptions = [0, 1];
    ctrl.downloadOptions = { resolution: 0 };
    ctrl.popup = null;
    var xValue = null;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.liveDataOffset = 20 * 60 * 1000;
        ctrl.minPadding = 0;
        ctrl.maxPadding = 0;
        var mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.alerts = [];
        ctrl.translation = translationService.translation;
        ctrl.loadingInProgress = true;
        ctrl.stacking = false;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.dataFormatDailyAdjustment = 60 * ctrl.unixDay;

        ctrl.runtimeRainfallChartFactory = new RuntimeRainfallChartFactory(ctrl.accountInfo.customerId);

        ctrl.MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
        ctrl.RainfallUnitEnum = { Inches: 1, Centimeters: 2 };
        ctrl.TemperatureUnitEnum = { Fahrenheit: 1, Celsius: 2 };
        ctrl.TimeFormatEnum = { Civilian: 1, Military: 2 };

        ctrl.preferredRainfallUnit = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? ctrl.RainfallUnitEnum.Inches : ctrl.RainfallUnitEnum.Centimeters;
        ctrl.preferredTemperatureUnit = ctrl.TemperatureUnitEnum.Fahrenheit;
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.windowSubtitle = "Loading...";
        ctrl.SeriesData = null;
        ctrl.numberOfHiddenSeries = 0;
        ctrl.chartXaxisHourFormat = ctrl.preferredTimeFormat === ctrl.TimeFormatEnum.Civilian ? '%l:%M %P' : '%H:%M';

        //create the structure required for the chart: red:
        ctrl.seriesIndex = { Rain: 0, Temp: 1 };
        ctrl.seriesColors = ["#2288CC", "#DD3221", "#00CC00", "#660066", "#FF6600", "#00CCFF", "#d74375", "#618a13"];
        ctrl.chart;
        ctrl.xValue = null;
        ctrl.scrollingInProgress = false;
        ctrl.zoomLevelCurrent, ctrl.zoomLevelPrevious = 0;
        ctrl.initialLoad = true;
        ctrl.pollInterval = 60;
        ctrl.scrollInProgressTimer;
        ctrl.chartFirstDrawn = true;

        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;

        //Get my icon based on my title
        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };
        //find the element of the chart class
        ctrl.element = $element.find('.data-pane');

        //Manage Dialog Geometry
        if (ctrl.classicView && ctrl.element.parent('div').parent('div').parent('div').attr('class') && ctrl.element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") === 0) {
            ctrl.largeChart = true;
            ctrl.element.height(500);
        }

        ctrl.element.attr('class', 'chart');
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;

        //Manage Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        //Mouse wheel zoom
        ctrl.element.on('mousewheel', function (event) {
            if (!ctrl.scrollingInProgress) sharedSetupService.mouseWheelZoom(event, ctrl.chart, ctrl.xValue);
        });

        //Change the title when the service changes the weather station name
        $scope.$watch('rainfallTableService.metarStationName', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue !== oldValue) {
                ctrl.initializeChartA();
            }
        }, true);

        // Handle Language Change Event
        $scope.fnChangeLanguage = function () {
            if ($scope.alerts.length > 0) {
                var _msg = eval("ctrl.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;

                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(ctrl.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                }

                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
            ctrl.drawChart();
            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.popup.dialog("option", "title", ctrl.translation.text.AIRPORT_RAINFALL + ", " + ctrl.windowSubtitle);
        };

        //Handle Preferences:MeasurementSystem changed
        $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            ctrl.applyMeasurementSystem(measurementSystem);
            if ($scope.alerts.length === 0) {
                ctrl.drawChart();
            }
        });

        //Handle Preferences:TimeFormat (12/24) changed
        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            ctrl.applyTimeFormat(timeFormat);
            if ($scope.alerts.length === 0) {
                ctrl.drawChart();
            }
        });

        $scope.$on('updatePreferencesLanguage', function () {
            if ($scope.alerts.length === 0) {
                if (!$rootScope.mobile && !$rootScope.classicView) {
                    ctrl.popup.dialog("option", "title", ctrl.translation.text.RAINFALL_VS_RUNTIME_CHART + ", " + ctrl.deviceName);
                }

                ctrl.drawChart();
            }
        });

        //Handle Preferences:Weather station was changed
        $scope.$on('updatePreferenceWeather', function (event, args) {
            ctrl.initializeChartA();
        });

        //blink the light when data recieved
        $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                $scope.liveDataIn = !$scope.liveDataIn;
                $timeout(function () {
                    $scope.liveDataIn = !$scope.liveDataIn;
                }, 3000);
            }
        }, true);

        //stop all listeners and pollers when the window is closed
        $scope.$on("$destroy", function () {
            if (!!ctrl.chart) ctrl.chart.destroy();
        });
    };

    ctrl.setDevice = function (rainfallData) {
        ctrl.downloadOptions.reportType = rainfallData.deviceModel != 0 ? "Rainfall vs Runtime" : "Rainfall";
        getRainfallUnit(rainfallData.rainfallSite).then(function (resp) {
            // whenever device selection is made, we need to fetch corresponding unit for rainfall
            ctrl.currentSelectedDevice = rainfallData;

            ctrl.deviceId = rainfallData.deviceId;
            ctrl.deviceType = rainfallData.deviceType;
            ctrl.metarStationID = rainfallData.metarStationID;
            ctrl.rainfallSite = rainfallData.rainfallSite;
            ctrl.deviceName = rainfallData.deviceName;

            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.popup.dialog("option", "title", ctrl.translation.text.RAINFALL_VS_RUNTIME_CHART + ", " + ctrl.deviceName);
            }

            //set the deviceId on the stickyProperties for use by other views
            $scope.deviceId = ctrl.deviceId;
            var _device = { deviceId: $scope.deviceId, deviceName: rainfallData.deviceName };
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceId, device: _device, windowId: $scope.windowId });

            ctrl.initializeChartA();
        });
    };

    ctrl.selectMyDate = function () {
        ctrl.passedDate = ctrl.myDate;
        ctrl.selectMyDateA();
    };

    var getRainfallUnit = function getRainfallUnit(deviceId) {
        var deferred = $q.defer();
        //fetch device specific settings, if it is RTU/Device
        if (deviceId > 0) {
            ctrl.runtimeRainfallChartFactory.fetchSettings(deviceId).then(function (resp) {
                deferred.resolve();
                //for RTU/DeviceId use Unit as unit
                ctrl.preferredRainfallUnit = resp.data.find(function (x) {
                    return x.channelName.search(/rain/i) > -1 || x.channelName.search(/plu/i) > -1;
                }).unit; //case-insensitive search for 'rain' OR 'plu' --> these strings means device is connected to rainfall channel
            });
        } else {
            //for Airport/Weather Station already it has been set in the OnInit()
            //ctrl.preferredRainfallUnit = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? ctrl.RainfallUnitEnum.Inches : ctrl.RainfallUnitEnum.Centimeters;;
            deferred.resolve();
        }
        return deferred.promise;
    };

    //Handle user selected a date from the calendar
    ctrl.selectMyDateA = function () {
        var start = new Date(ctrl.myDate);
        start.setDate(start.getDate() - 6);
        start.setHours(20, 0, 0, 0);
        var startUnix = start.getTime();
        var end = new Date(ctrl.myDate);
        end.setDate(end.getDate() + 1);
        end.setHours(20, 0, 0, 0);
        var endUnix = end.getTime();
        var startTicks = startUnix;
        var endTicks = endUnix;
        var zoomMin = startTicks;
        var zoomMax = endTicks;

        setStickyDateRange(startTicks, endTicks);
        setStickyZoomRange(zoomMin, zoomMax);
        ctrl.getInitialPage(startTicks, endTicks);
    };

    ctrl.applyTimeFormat = function (timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat);
    };

    //Update the chart When user preference:$scope.drawChartMeasurementSystem is changed
    ctrl.applyMeasurementSystem = function (measurementSystem) {
        //following logic only applies for Airport Station (ie. deviceId == 0)
        if (ctrl.deviceId === 0) {
            var newRainfallUnit = ctrl.preferredRainfallUnit;
            var newTemperatureUnit = ctrl.preferredTemperatureUnit;
            switch (parseInt(measurementSystem)) {
                case ctrl.MeasurementSystemEnum.Imperial:
                    newRainfallUnit = ctrl.RainfallUnitEnum.Inches;
                    newTemperatureUnit = ctrl.TemperatureUnitEnum.Fahrenheit;
                    break;
                case ctrl.MeasurementSystemEnum.Metric:
                    newRainfallUnit = ctrl.RainfallUnitEnum.Centimeters;
                    newTemperatureUnit = ctrl.TemperatureUnitEnum.Celsius;
                    break;
            }

            if (typeof ctrl.SeriesData != 'undefined' && ctrl.SeriesData != null) {
                if (ctrl.SeriesData.length > 0) ctrl.ConvertRainfallSeriesMeasurementUnit(ctrl.SeriesData[ctrl.seriesIndex.Rain], ctrl.preferredRainfallUnit, newRainfallUnit);
                if (ctrl.SeriesData.length > 1) ctrl.ConvertTemperatureSeriesMeasurementUnit(ctrl.SeriesData[ctrl.seriesIndex.Temp], ctrl.preferredTemperatureUnit, newTemperatureUnit);
            }

            ctrl.preferredRainfallUnit = newRainfallUnit;
            ctrl.preferredTemperatureUnit = newTemperatureUnit;
        }
    };

    //convert a single value between centimeters and inches
    var convertLengthUnit = function convertLengthUnit(value, fromUnit, toUnit) {
        if (typeof value === "undefined" || value === null) return 0;
        if (value < 0) return 0;
        if (fromUnit === ctrl.RainfallUnitEnum.Inches && toUnit === ctrl.RainfallUnitEnum.Centimeters) return value * 2.54;
        if (fromUnit === ctrl.RainfallUnitEnum.Centimeters && toUnit === ctrl.RainfallUnitEnum.Inches) return value / 2.54;
        return value.toFixed(2);
    };

    //convert a single point between F and C
    var convertTemperatureUnit = function convertTemperatureUnit(value, fromUnit, toUnit) {
        if (typeof value === "undefined" || value === null) return 0;
        if (fromUnit === ctrl.TemperatureUnitEnum.Fahrenheit && toUnit === ctrl.TemperatureUnitEnum.Celsius) return (value - 32) * 5 / 9;
        if (fromUnit === ctrl.TemperatureUnitEnum.Celsius && toUnit === ctrl.TemperatureUnitEnum.Fahrenheit) return value * 9 / 5 + 32;
        return value.toFixed(2);
    };

    //convert an [x,y] series between inches and centimeters
    ctrl.ConvertRainfallSeriesMeasurementUnit = function (series, fromUnit, toUnit) {
        if (fromUnit === toUnit || typeof series === 'undefined' || series == null) return;
        for (var i = 0; i < series.length; i++) {
            series[i][1] = convertLengthUnit(series[i][1], fromUnit, toUnit);
        }
    };

    //convert an [x,y] series between C & F
    ctrl.ConvertTemperatureSeriesMeasurementUnit = function (series, fromUnit, toUnit) {
        if (fromUnit === toUnit || typeof series === 'undefined' || series == null) return;
        for (var i = 0; i < series.length; i++) {
            series[i][1] = convertTemperatureUnit(series[i][1], fromUnit, toUnit);
        }
    };

    //Set start and end date sticky properties convenience function
    var setStickyDateRange = function setStickyDateRange(startDate, endDate) {
        if (typeof startDate !== 'undefined' && startDate != null) {
            ctrl.stickyProperties.on = true;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                dataMin: startDate,
                windowId: ctrl.windowId,
                deviceId: ctrl.deviceId
            });
        }
        if (typeof endDate !== 'undefined' && endDate != null) {
            ctrl.stickyProperties.on = true;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                dataMax: endDate, //wtf?!
                windowId: ctrl.windowId,
                deviceId: ctrl.deviceId
            });
        }
        debugShowStickies('stickDateRange');
    };

    //Set zoom range sticky properties convenience function
    var setStickyZoomRange = function setStickyZoomRange(startDate, endDate) {
        if (typeof startDate !== 'undefined' && startDate != null) {
            ctrl.stickyProperties.on = true;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                zoomMin: startDate,
                windowId: ctrl.windowId,
                deviceId: ctrl.deviceId
            });
        }
        if (typeof endDate !== 'undefined' && endDate != null) {
            ctrl.stickyProperties.on = true;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                zoomMax: endDate,
                windowId: ctrl.windowId,
                deviceId: ctrl.deviceId
            });
        }
        debugShowStickies('stickZoomRange');
    };

    //Set the ScrollingInProgress flag or clear it after 1 sec
    var setScrollingInProgressFlag = function setScrollingInProgressFlag(value) {
        if (ctrl.scrollInProgressTimer != null && ctrl.scrollingInProgress) clearTimeout(ctrl.scrollInProgressTimer);
        if (value === true) ctrl.scrollingInProgress = true;else ctrl.scrollInProgressTimer = $timeout(function () {
            ctrl.scrollingInProgress = false;
        }, 1000);
    };

    ctrl.zoomAdjust = function (varDay) {
        timeLapseService.getLocalDateTime().then(function (result) {
            ctrl.heartbeatLocalDateTime = result.data.unixTimeStamp;
        });
        var extremes = ctrl.chart.xAxis[0].getExtremes();
        ctrl.varDay = varDay;
        var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, ctrl.heartbeatLocalDateTime);
        ctrl.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
    };

    //Start the process of refreshing the whole chart
    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.windowSubtitle, 'View reloading');
        ctrl.myDate = null;
        ctrl.stickyProperties.on = null;
        ctrl.initializeChartA();
    };

    //reset the chart, get the first page of data and render it.
    ctrl.getInitialPage = function (startDate, endDate) {
        ctrl.loadingInProgress = true;

        ctrl.runtimeRainfallChartFactory.fetchData(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.deviceType, 1, 50, startDate, endDate, ctrl.metarStationID, ctrl.rainfallSite).then(function (response) {
            //GetData.SuccessCallback:              
            response = processResponse(response);
            $scope.alerts = [];
            ctrl.windowSubtitle = ctrl.currentSelectedDevice.deviceName;

            if (response.data.series && response.data.series.length > 0 && response.data.series[0].data.length > 0) {
                ctrl.series = response.data.series;
                ctrl.drawChart();
            } else {
                ctrl.element.empty();
                ctrl.chart = null;
                ctrl.lastStart = startDate;
                ctrl.lastEnd = endDate;
                var errormsg = ctrl.translation.message.NO_DATA + ": " + moment(startDate).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(endDate).utc().format('MM/DD/YY, h:mm:ss a');
                $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                ctrl.chartFirstDrawn = false;
            }
            ctrl.loadingInProgress = false;
        }, function (response) {
            //GetData.ErrorCallback:
            ctrl.element.empty();
            ctrl.chart = null;
            ctrl.loadingInProgress = false;
            $scope.alerts.push({ msg: ctrl.translation.message.ERROR, type: "error", languageCode: "ERROR" });
        });
    };

    //get and display data when user scrolls right to a new page:
    var pageRight = function pageRight(callback) {
        ctrl.chart.showLoading();
        var extremes = ctrl.chart.xAxis[0].getExtremes();

        var tmpStart = new Date(extremes.dataMax);
        var start = tmpStart.setDate(tmpStart.getDate() + 1);
        var tmpEndDate = new Date(extremes.dataMax);
        var end = tmpEndDate.setDate(tmpEndDate.getDate() + 6);

        ctrl.runtimeRainfallChartFactory.fetchData(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.deviceType, 1, 50, start, end, ctrl.metarStationID, ctrl.rainfallSite).then(function (response) {
            response = processResponse(response);
            if (response.data.series && response.data.series.length > 0 && response.data.series[0].data.length > 0) {
                for (var i = 0; i < response.data.series.length; i++) {
                    //2
                    ctrl.series[i].data = ctrl.series[i].data.concat(response.data.series[i].data);
                    ctrl.chart.series[i].setData(ctrl.series[i].data);
                }
                setStickyDateRange(null, end);
            }
            ctrl.chart.hideLoading();
            if (typeof callback === "function") callback();
        });
    };

    //get and display data when user scrolls right to a new page:
    var pageLeft = function pageLeft(callback) {
        ctrl.chart.showLoading();
        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var requestDateRange = datetimeService.getNewStartEndDates(extremes.dataMin, -1);

        var tmpEnd = new Date(extremes.dataMin);
        var end = tmpEnd.setDate(tmpEnd.getDate() - 1);
        var tmpStartDate = new Date(extremes.dataMin);
        var start = tmpStartDate.setDate(tmpStartDate.getDate() - 6);

        ctrl.runtimeRainfallChartFactory.fetchData(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.deviceType, 1, 50, start, end, ctrl.metarStationID, ctrl.rainfallSite).then(function (response) {
            response = processResponse(response);
            if (response.data.series && response.data.series.length > 0 && response.data.series[0].data.length > 0) {
                for (var i = 0; i < response.data.series.length; i++) {
                    //2
                    //append existing data (at right side of array) to the new series data
                    ctrl.series[i].data = response.data.series[i].data.concat(ctrl.series[i].data);
                    ctrl.chart.series[i].setData(ctrl.series[i].data);
                }
            }
            setStickyDateRange(start, null);
            ctrl.chart.hideLoading();
            if (typeof callback === "function") callback();
        });
    };

    var processResponse = function processResponse(response) {
        //following logic only applies for Airport Station (ie. deviceId == 0)
        if (ctrl.deviceId === 0) {
            if (response.data.seriesData && response.data.seriesData.length > ctrl.seriesIndex.Rain) ctrl.ConvertRainfallSeriesMeasurementUnit(response.data.seriesData[ctrl.seriesIndex.Rain], ctrl.RainfallUnitEnum.Inches, ctrl.preferredRainfallUnit);
            if (response.data.seriesData && response.data.seriesData.length > ctrl.seriesIndex.Temp) ctrl.ConvertTemperatureSeriesMeasurementUnit(response.data.seriesData[ctrl.seriesIndex.Temp], ctrl.TemperatureUnitEnum.Fahrenheit, ctrl.preferredTemperatureUnit);
        }
        return response;
    };

    ctrl.drawChart = function () {
        ctrl.chartSetupGrouping();
        ctrl.chartDrawn = false;

        ctrl.chart = new Highcharts.StockChart({
            credits: { enabled: false },
            legend: {
                enabled: true,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1
            },
            chart: {
                renderTo: ctrl.element[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1,
                borderRadius: 2,
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                spacingRight: 5,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {

                        //exit maybe
                        if (!this.xAxis || !ctrl.chartDrawn || ctrl.scrollingInProgress) return;
                        var extremes = this.xAxis[0].getExtremes();
                        if (!extremes) return;

                        //We need to get another page of infinite data for the left
                        if (extremes.dataMin >= extremes.min - ctrl.liveDataOffset) {
                            setScrollingInProgressFlag(true);
                            pageLeft(function () {
                                setScrollingInProgressFlag(false);
                            });
                        }
                        //We need to get another page of infinite data for the right
                        else if (extremes.max + ctrl.liveDataOffset >= extremes.dataMax) {
                                setScrollingInProgressFlag(true);
                                pageRight(function () {
                                    setScrollingInProgressFlag(false);
                                });
                            }
                    },
                    load: function load(event) {
                        if (ctrl.initialLoad && !$rootScope.mobile && !$rootScope.classicView) openViewService.adjustContentSize(ctrl.popup);
                        ctrl.initialLoad = false;
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: { text: null },
            exporting: { enabled: false },
            xAxis: {
                title: {
                    text: ctrl.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minorTickInterval: 'auto',
                minorGridLineColor: '#ffffff',
                dateTimeLabelFormats: { hour: ctrl.chartXaxisHourFormat },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (ctrl.chartDrawn !== true) return;
                        var newMin, newMax, newDataMin, newDataMax;

                        //If we've scrolled too far left then exit "Live" mode:
                        if (ctrl.liveData === true && (e.trigger === "navigator" || e.trigger === "pan" || typeof e.trigger === "undefined")) {
                            if (e.max + ctrl.liveDataOffset <= e.dataMax) {
                                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: false, windowId: $scope.windowId });
                            }
                        }
                        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { zoomMin: newMin, zoomMax: newMax, windowId: $scope.windowId });
                        ctrl.downsampleSeries(newMin, newMax);
                    },
                    redraw: function redraw(event) {

                        //exit maybe
                        if (!this.xAxis || !ctrl.chartDrawn || ctrl.scrollingInProgress) return;
                        var extremes = this.xAxis[0].getExtremes();
                        if (!extremes) return;

                        //We need to get another page of infinite data for the left
                        if (extremes.dataMin >= extremes.min - ctrl.liveDataOffset) {
                            setScrollingInProgressFlag(true);
                            pageLeft(function () {
                                setScrollingInProgressFlag(false);
                            });
                        }
                        //We need to get another page of infinite data for the right
                        else if (ctrl.liveData === false && extremes.max + ctrl.liveDataOffset >= extremes.dataMax) {
                                setScrollingInProgressFlag(true);
                                pageRight(function () {
                                    setScrollingInProgressFlag(false);
                                });
                            }
                    },
                    load: function load(event) {
                        if (ctrl.initialLoad && !$rootScope.mobile && !$rootScope.classicView) openViewService.adjustContentSize(ctrl.popup);
                        ctrl.initialLoad = false;
                    }
                }
            },
            yAxis: [{
                gridLineWidth: 1,
                gridLineColor: '#c0c0c0',
                opposite: true,
                endOnTick: true,
                lineWidth: 1,
                min: 0,
                title: {
                    text: ctrl.translation.text.PUMP + ' ' + ctrl.translation.text.PUMP_RUNTIME + ' (' + ctrl.translation.text.MINUTES + ')',
                    style: { color: '#000' }
                },
                labels: { align: 'left' },
                allowDecimals: false
            }, {
                gridLineWidth: 1,
                gridLineColor: '#c0c0c0',
                opposite: false,
                endOnTick: true,
                lineWidth: 1,
                min: 0,
                title: {
                    text: ctrl.translation.text.RAINFALL,
                    style: { color: '#000' }
                },
                labels: { align: 'right' }
            }],
            tooltip: {
                useHTML: true,
                formatter: function formatter(e) {
                    return ctrl.onChartTooltipFormatter(this, e);
                },
                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 0,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: { hour: '%l:%M %p' },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
                //buttonTheme: {
                //    stroke: '#ccc',
                //    'stroke-width': 1,
                //    r: 4,
                //    width: null, //fit to contents
                //    padding: 4
                //},
                //inputEnabled: false,
                //allButtonsEnabled: true,
                //buttons: ctrl.getRangeSelectorButtons()
            },
            plotOptions: {
                series: {
                    dataGrouping: {
                        enabled: true,
                        forced: true,
                        approximation: "sum",
                        units: [['day', [1]]]
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                xValue = ctrl.chart.x;
                            },
                            dblclick: function dblclick() {
                                var s = ctrl.chart.series;
                                var sLen = s.length;

                                for (var i = 0; i < sLen; i++) {
                                    s[i].update({
                                        stacking: ctrl.stacking ? undefined : 'normal',
                                        pointWidth: ctrl.stacking ? 12 : 20
                                    }, false);
                                }
                                ctrl.chart.redraw();
                                ctrl.stacking = !ctrl.stacking;
                            }
                        }
                    },
                    borderColor: '#303030',
                    borderWidth: 1,
                    marker: {
                        enabled: null, //auto-hide when too dense
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    pointWidth: 12,
                    events: {
                        legendItemClick: function legendItemClick(e) {
                            return ctrl.onChartLegendItemClick(this, e);
                        },
                        mouseOut: function mouseOut() {
                            xValue = null;
                        }
                    }
                }
            },
            series: ctrl.series
        });

        // ctrl.chart = chart;

        var tmpNewDateA;
        var tmpNewDateB;
        var extremes = ctrl.chart.xAxis[0].getExtremes();

        if (ctrl.stickyProperties.on === true) {
            ctrl.logGetData('drawChart.stickies', ctrl.stickyProperties.zoomMin, ctrl.stickyProperties.zoomMax);
            tmpNewDateA = ctrl.stickyProperties.zoomMin >= extremes.dataMin ? ctrl.stickyProperties.zoomMin : extremes.dataMin; //extremes.dataMin + scope.unixDay / 24 * 3;
            tmpNewDateB = ctrl.stickyProperties.zoomMax <= extremes.dataMax + $scope.liveDataOffset ? ctrl.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
            //tmpNewDateB = tmpNewDateB >= tmpNewDateA + scope.unixDay / 24 ? tmpNewDateB : extremes.dataMax - scope.unixDay / 24 * 12;
            ctrl.stickyProperties.on = false;
            ctrl.logGetData('drawChart.setExtremes', tmpNewDateA, tmpNewDateB);
            ctrl.chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        }
        if (ctrl.series !== null) {
            //only for pump chart if no setup
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                deviceId: ctrl.deviceSelected,
                zoomMin: tmpNewDateA,
                zoomMax: tmpNewDateB,
                windowId: ctrl.windowId
            });
        } else {
            ctrl.chart.showLoading(ctrl.translation.message.NO_DATA);
        }
        ctrl.chartDrawn = true;
        ctrl.loadingInProgress = false;
    };

    ctrl.chartSetupGrouping = function () {
        var dataGroupingD = {
            enabled: true,
            forced: true,
            approximation: "sum",
            units: [['day', [1]]]
        };

        var dataGroupingH = {
            enabled: false
        };

        ctrl.stickyProperties.dataFormat == "D";

        ctrl.dataGroupingSetting = dataGroupingD;
        ctrl.dataGroupingInterval = 24;
        ctrl.dataGroupingTooltip = '%A, %b %e, %Y';
        ctrl.stickyProperties.dataFormat = "D";
    };

    ctrl.getRangeSelectorButtons = function () {
        //if (scope.dataGroupingInterval === 24)
        return [{ type: 'day', count: 1, text: '1 ' + ctrl.translation.text.DAY }, { type: 'day', count: 3, text: '3 ' + ctrl.translation.text.DAYS.toLowerCase() }, { type: 'day', count: 7, text: '7 ' + ctrl.translation.text.DAYS.toLowerCase() }, { type: 'month', count: 1, text: '1 ' + ctrl.translation.text.MONTH }];
    };

    ctrl.onChartTooltipFormatter = function (object, event) {
        var row = 0;
        var s = '';
        s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
        s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px; border-bottom: 1px solid #e4e9db;">';
        s += Highcharts.dateFormat(ctrl.dataGroupingTooltip, object.x);
        s += '</td></tr>';
        $.each(object.points, function (i, point) {
            if (point.series.name.indexOf(ctrl.translation.text.PUMP_STARTS) >= 0) {
                if (row++ === 0) {
                    s += '<tr><td style="color: ' + point.series.color + '; padding-top: 3px; border-top: 1px solid #e4e9db;">';
                    s += point.series.name + ': </td>';
                    s += '<td style="text-align: right; color: #000000; font-weight: bold; padding-top: 3px; border-top: 1px solid #e4e9db;">';
                    s += Highcharts.numberFormat(point.y, 0) + '</td></tr>';
                } else {
                    s += '<tr><td style="color: ' + point.series.color + ';">';
                    s += point.series.name + ': </td>';
                    s += '<td style="text-align: right; color: #000000; font-weight: bold;">';
                    s += Highcharts.numberFormat(point.y, 0) + '</td></tr>';
                }
            } else {
                s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td>';
                s += '<td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, 2) + '</td></tr>';
            }
            xValue = point.x;
        });
        s += '</table>';
        return s;
    };

    ctrl.logGetData = function (src, startDate, endDate) {
        //console.log(('getData@' + src + ':                              ').substring(0, 30) +
        //    ' Start=' + moment.utc(startDate).format("M/DD HH:mm") +
        //    ', End=' + moment.utc(endDate).format("M/DD HH:mm"));
    };

    ctrl.onChartLegendItemClick = function (object, event) {
        var numberOfSeries = object.chart.series.length - 1;
        var visibility = object.visible ? 'visible' : 'hidden';
        ctrl.numberOfHiddenSeries = visibility === 'hidden' ? ctrl.numberOfHiddenSeries - 1 : ctrl.numberOfHiddenSeries + 1;
        ctrl.numberOfHiddenSeries = ctrl.numberOfHiddenSeries < 0 ? 0 : ctrl.numberOfHiddenSeries;
        if (ctrl.numberOfHiddenSeries < numberOfSeries) return true;
        ctrl.numberOfHiddenSeries = ctrl.numberOfHiddenSeries - 1;
        return false;
    };

    // Downsample logic for zooming
    ctrl.downsampleSeries = function (varMin, varMax) {
        ctrl.zoomLevelCurrent = varMax - varMin;
        var i;
        if (ctrl.zoomLevelCurrent <= ctrl.unixDay && ctrl.zoomLevelPrevious > ctrl.unixDay) {
            for (i = 0; i < ctrl.chart.series.length - 1; i++) {
                ctrl.chart.series[i].update({
                    downsample: {
                        threshold: 0
                    }
                }, false);
                ctrl.chart.series[i].setData(ctrl.SeriesData[i], false);
            }
            ctrl.chart.redraw();
        } else if (ctrl.zoomLevelCurrent > ctrl.unixDay && ctrl.zoomLevelPrevious <= ctrl.unixDay) {
            for (i = 0; i < ctrl.chart.series.length - 1; i++) {
                ctrl.chart.series[i].update({
                    downsample: {
                        threshold: 1000
                    }
                }, false);
            }
            ctrl.chart.redraw();
        }
        ctrl.zoomLevelPrevious = ctrl.zoomLevelCurrent;
    };

    //Start the process of loading data
    ctrl.initializeChartA = function () {
        var tmpStartDate = null,
            tmpEndDate = null;
        ctrl.loadingInProgress = true;
        ctrl.applyMeasurementSystem(ctrl.accountInfo.preferenceUser.lookupMeasurementID);
        ctrl.applyTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);
        debugShowStickies('initializeChart');
        if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.dateMax !== null) {

            ctrl.stickyProperties.on = true;
            tmpStartDate = ctrl.stickyProperties.dateMin;
            tmpEndDate = ctrl.stickyProperties.dateMax;
        } else {
            ctrl.stickyProperties.on = false;
        }

        //Page is displaying for the first time, so get today
        if (!tmpStartDate) {
            timeLapseService.getLocalDateTime().then(function (result) {

                //   var nowTicks  = new Date(result.data.localDateTime).valueOf();
                var start = new Date(result.data.localDateTime);
                start.setDate(start.getDate() - 6);
                start.setHours(20, 0, 0, 0);
                var startUnix = start.getTime();
                var end = new Date(result.data.localDateTime);
                end.setDate(end.getDate() + 1);
                end.setHours(20, 0, 0, 0);
                var endUnix = end.getTime();
                var startTicks = startUnix;
                var endTicks = endUnix;

                var zoomMinTicks = startTicks;
                var zoomMaxTicks = endTicks;

                zoomMinTicks = _subtractZoneOffset(zoomMinTicks, ctrl.accountInfo.timeZone);
                zoomMaxTicks = _subtractZoneOffset(zoomMaxTicks, ctrl.accountInfo.timeZone);

                setStickyDateRange(startTicks, endTicks);
                setStickyZoomRange(zoomMinTicks, zoomMaxTicks);
                ctrl.getInitialPage(startTicks, endTicks);
            });
        } else {
            ctrl.getInitialPage(tmpStartDate, tmpEndDate);
        }
    };

    //This is a kludge:
    var _subtractZoneOffset = function _subtractZoneOffset(timestamp, zoneCode) {
        var offset = 0;
        if (zoneCode === 'E') offset = -4;
        if (zoneCode === 'C') offset = -5;
        if (zoneCode === 'M') offset = -6;
        if (zoneCode === 'P') offset = -7;
        if (zoneCode === 'A') offset = -8;
        return moment(timestamp).add(offset, 'hours').format('X') * 1000;
    };

    var debugShowStickies = function debugShowStickies(msg) {
        //console.log(msg);
        //console.log('   on:' + ctrl.stickyProperties.on);
        //console.log('   dateMin: [' + ctrl.stickyProperties.dateMin + ']' + new Date(ctrl.stickyProperties.dateMin));
        //console.log('   zoomMin: [' + ctrl.stickyProperties.zoomMin + ']' + new Date(ctrl.stickyProperties.zoomMin));
        //console.log('   zoomMax: [' + ctrl.stickyProperties.zoomMax + ']' + new Date(ctrl.stickyProperties.zoomMax));
        //console.log('   dateMax: [' + ctrl.stickyProperties.dateMax + ']' + new Date(ctrl.stickyProperties.dateMax));
    };
}

RuntimeRainfallChartController.$inject = ['$scope', '$q', 'sharedSetupService', 'openViewService', 'translationService', '$element', 'authenticationService', '$rootScope', '$timeout', 'RuntimeRainfallChartFactory', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'rangeSelectorService'];
'use strict';

angular.module('mc.rainfall').component('runtimeRainfallChart', {
    controller: RuntimeRainfallChartController,
    templateUrl: 'ui/rainfall/runtimeChart/runtime-rainfall-chart-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.device-config', []);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function deviceConfigController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, MMPlusRtuSettingFactory, deviceService, MMPlusRtuConfigHistoryFactory, $uibModal) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.runtimeReportDestinations = [];
    ctrl.selectedTab = 0;
    ctrl.hasModbusRTU = false;
    ctrl.finalDataList = [];

    ctrl.callInIntervals = [{ id: 6, IntervalValueHrs: '1 Hour', IntervalValueMin: 60 }, { id: 7, IntervalValueHrs: '2 Hours', IntervalValueMin: 120 }, { id: 8, IntervalValueHrs: '4 Hours', IntervalValueMin: 240 }, { id: 9, IntervalValueHrs: '12 Hours', IntervalValueMin: 720 }, { id: 10, IntervalValueHrs: '24 Hours', IntervalValueMin: 1440 }];

    ctrl.sensorVoltages = [{ name: '13 Volts', sensorVoltage: 13 }, { name: '18 Volts', sensorVoltage: 18 }];

    ctrl.sensorOnTimes = [{ name: 'Keep Sensor Power Enabled Continuously', sensorOnTime: -1 }, { name: 'Disable Sensor Power', sensorOnTime: 0 }, { name: '1 Second', sensorOnTime: 1 }, { name: '2 Seconds', sensorOnTime: 2 }, { name: '3 Seconds', sensorOnTime: 3 }, { name: '4 Seconds', sensorOnTime: 4 }, { name: '5 Seconds', sensorOnTime: 5 }, { name: '6 Seconds', sensorOnTime: 6 }, { name: '7 Seconds', sensorOnTime: 7 }, { name: '8 Seconds', sensorOnTime: 8 }, { name: '9 Seconds', sensorOnTime: 9 }, { name: '10 Seconds', sensorOnTime: 10 }, { name: '12 Seconds', sensorOnTime: 12 }, { name: '14 Seconds', sensorOnTime: 14 }, { name: '16 Seconds', sensorOnTime: 16 }, { name: '20 Seconds', sensorOnTime: 20 }, { name: '30 Seconds', sensorOnTime: 30 }, { name: '40 Seconds', sensorOnTime: 40 }, { name: '50 Seconds', sensorOnTime: 50 }, { name: '1 Minute', sensorOnTime: 60 }, { name: '1 and 1/2 Minutes', sensorOnTime: 90 }, { name: '2 Minutes', sensorOnTime: 120 }];

    ctrl.sensorPowerOverrides = [{ name: 'Disable the Override', sensorPowerOverride: 0 }, { name: '1 Second', sensorPowerOverride: 1 }, { name: '2 Seconds', sensorPowerOverride: 2 }, { name: '3 Seconds', sensorPowerOverride: 3 }, { name: '5 Seconds', sensorPowerOverride: 5 }, { name: '6 Seconds', sensorPowerOverride: 6 }, { name: '8 Seconds', sensorPowerOverride: 8 }, { name: '10 Seconds', sensorPowerOverride: 10 }, { name: '20 Seconds', sensorPowerOverride: 20 }, { name: '30 Seconds', sensorPowerOverride: 30 }, { name: '40 Seconds', sensorPowerOverride: 40 }, { name: '50 Seconds', sensorPowerOverride: 50 }, { name: '1 Minute', sensorPowerOverride: 60 }, { name: '1 and 1/2 Minutes', sensorPowerOverride: 90 }, { name: '2 Minutes', sensorPowerOverride: 120 }, { name: '3 Minutes', sensorPowerOverride: 180 }, { name: '5 Minutes', sensorPowerOverride: 300 }, { name: '10 Minutes', sensorPowerOverride: 600 }, { name: '20 Minutes', sensorPowerOverride: 1200 }, { name: '30 Minutes', sensorPowerOverride: 1800 }, { name: '40 Minutes', sensorPowerOverride: 2400 }, { name: '50 Minutes', sensorPowerOverride: 3000 }, { name: '1 Hour', sensorPowerOverride: 3600 }];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.popoverConfigHistoryListIsOpen = false;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.MMPlusRtuConfigHistoryFactory = new MMPlusRtuConfigHistoryFactory(ctrl.accountInfo.customerId);
        sharedSetupService.checkUnsavedChanges = false;
        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
                //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        };
    };

    ctrl.getData = function () {
        ctrl.loading = true;
        ctrl.MMPlusRtuSettingFactory.getDeviceConfigData(ctrl.deviceId, false).then(function (result) {
            ctrl.data = result.data;
            if (ctrl.data.lightSensorOnTime === null) {
                ctrl.data.lightSensorOnTime = 2;
                ctrl.postData('lightSensorOnTime');
            }
            ctrl.preData = angular.copy(ctrl.data);
            ctrl.getImeiAndModel();
            if (!ctrl.data) {
                ctrl.alertMessage = "Please configure the device as Gen 2";
                ctrl.isDirty = false;
            }
        }, function (error) {
            //error
        });

        //NOTE: this call has to happen ONLY one time for this tab launch
        //Log tab access event to NLog
        ctrl.MMPlusRtuSettingFactory.postUserAction2Nlog(ctrl.accountInfo.customerId, ctrl.deviceId, "GEN II >> Configuration").then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
            ctrl.loading = false;
        });
    };

    ctrl.finalDataProduced = function (path) {
        var existing = ctrl.finalDataList.find(function (item) {
            return item.path === path;
        });
        if (existing) {
            existing.value = ctrl.data[path];
        } else {
            ctrl.finalDataList.push({ op: "replace", path: path, value: ctrl.data[path] });
        }
    };

    ctrl.getImeiAndModel = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
            ctrl.model = datafromFactory.data.model;
            if (ctrl.model == 21) {
                ctrl.callInIntervals.splice(0, 0, { id: 0, IntervalValueHrs: '2 Minutes', IntervalValueMin: 2 }, { id: 1, IntervalValueHrs: '5 Minutes', IntervalValueMin: 5 }, { id: 2, IntervalValueHrs: '10 Minutes', IntervalValueMin: 10 }, { id: 3, IntervalValueHrs: '15 Minutes', IntervalValueMin: 15 }, { id: 4, IntervalValueHrs: '20 Minutes', IntervalValueMin: 20 }, { id: 5, IntervalValueHrs: '30 Minutes', IntervalValueMin: 30 });

                ctrl.callInIntervals.splice(10, 1);
            }
            ctrl.loading = false;
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loading = false;
        });
    };

    ctrl.postData = function (path) {
        var curVal = ctrl.data[path];
        var preVal = ctrl.preData[path];

        if (!angular.equals(preVal, curVal)) {
            ctrl.isDirty = true;
            sharedSetupService.tabPopupWarningOn = true;
            ctrl.finalDataProduced(path);
        }
    };

    ctrl.saveAll = function () {
        ctrl.isDirty = false;
        ctrl.MMPlusRtuSettingFactory.DeviceConfigSave(ctrl.deviceId, ctrl.imei, ctrl.finalDataList).then(function (result) {
            var configResult = String(result.data).match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
            ctrl.alertMessage = configResult ? "Device Config " + configResult[0] + ": " + configResult[1] : "Device Config success: Page deferred for " + ctrl.imei + " until it is online";
            ctrl.setTimeOut();
            ctrl.preData = ctrl.data;
            sharedSetupService.tabPopupWarningOn = false;
        }, function (resp) {
            //display error message
            ctrl.alertMessage = "Something went wrong while processing device config request";
            ctrl.setTimeOut();
        });
    };

    ctrl.cancel = function () {
        ctrl.isDirty = false;
        sharedSetupService.tabPopupWarningOn = false;
    };

    ctrl.setTimeOut = function () {
        setTimeout(function () {
            ctrl.alertMessage = null;
        }, 15000); // 15 Seconds
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;
            var _device = { deviceId: newValue, deviceName: $scope.$parent.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });

            if (!angular.isUndefined(ctrl.currentDevice)) return;

            ctrl.currentDevice = newValue;

            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    ctrl.alertMessage = null;
                    $timeout(function () {
                        ctrl.getData();
                    }, 0);
                } else {
                    ctrl.data = null;
                    ctrl.alertMessage = "Please configure the device as Gen 2";
                    ctrl.isDirty = false;
                }
            });
        }
    }, true);
};

deviceConfigController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService', 'MMPlusRtuConfigHistoryFactory', '$uibModal'];
'use strict';

angular.module('mc.device-config').component('deviceConfig', {
    controller: deviceConfigController,
    templateUrl: 'ui/rtuinfo/config/device-config-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelectedName: '<'
    }
});
'use strict';

function RainfallDataCalendarFactory(HOST, $http) {
    var _this = this;

    var Rainfall = function Rainfall(customerId) {
        _this.days = [];
        _this.loading = false;
        _this.customerId = customerId;
    };

    // Return a copy of the data, not the original
    Rainfall.prototype.get = function () {
        return JSON.parse(JSON.stringify(_this.days));
    };

    Rainfall.prototype.updateValue = function (value) {
        //increment existing value with new value
        //this method helps to update the specific daily value with live data value
        if (_this.days.length > 0) {
            var tmpTitle = '' + (parseFloat(_this.days[_this.days.length - 1].title) + Number(value));
            _this.days[_this.days.length - 1].title = tmpTitle;
        }
    };

    Rainfall.prototype.addDay = function (day) {
        if (_this.days.length > 0) _this.days.push(day);
    };
    Rainfall.prototype.isLoading = function () {
        return _this.loading;
    };

    Rainfall.prototype.fetchData = function (deviceId, startDate, endDate, metarStation) {
        _this.loading = true;
        var metarStationID = metarStation ? metarStation : -1;
        var reqUrl = HOST + '/api/MetarRainfallCalendar?customerId=' + _this.customerId + '&startDate=' + startDate + '&endDate=' + endDate + '&metarStationId=' + metarStationID;
        if (deviceId > 0) reqUrl = HOST + '/api/MetarRainfallCalendar?customerId=' + _this.customerId + '&deviceId=' + deviceId + '&startDate=' + startDate + '&endDate=' + endDate;

        return $http.get(reqUrl).then(function (resp) {
            _this.days = resp.data.calendarDays;
            _this.metarStation = resp.data.metarStation;
            _this.loading = false;
        });
    };

    Rainfall.prototype.fetchSettings = function (deviceId) {
        return $http.get(HOST + '/api/ParmPulse?deviceId=' + deviceId);
    };

    Rainfall.prototype.getStationName = function () {
        if (!_this.metarStation) {
            return '';
        }

        var name = '';

        if (_this.metarStation.city.length > 0) name += _this.metarStation.city;
        if (_this.metarStation.state.length > 0 && name.length > 0) name += ', ';
        if (_this.metarStation.state.length > 0) name += _this.metarStation.state;
        if (_this.metarStation.icao.length > 0) name += ' (' + _this.metarStation.icao + ')';

        return name;
    };

    return Rainfall;
}

RainfallDataCalendarFactory.$inject = ['HOST', '$http'];

angular.module('mc.rainfall').factory('rainfallDataCalendarFactory', RainfallDataCalendarFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RainfallDataCalendarController($, $q, $scope, $rootScope, $filter, $timeout, authenticationService, translationService, datetimeService, sharedSetupService, openViewService, timeLapseService, websocketService, rainfallDataCalendarFactory, $element, $window, toaster) {
    //NOTE: Live Data listening capability is added to M50 (device model = 21) onwards
    var ctrl = this;
    $scope.qdpLeft = -237; //position-left-correction for the quick-datepicker
    ctrl.downloadViewTypeOptions = [0, 4];
    ctrl.downloadOptions = { resolution: 5 };
    ctrl._popup = null;
    ctrl._elm = null;
    ctrl.fullCalendar = null;
    ctrl.unit = '';
    ctrl.isUnitFetched = false; //helps to prevent repeated calls to fetch channel settings
    ctrl.alreadyListening = false; // helps to prevent duplicate entries registering with websocket to listen to live data
    ctrl.deviceId = -1; // helps to identify whether device is set first time or it is the scenario of modifying device
    ctrl.channel = -1; // required to pass channel number to the live data listener
    ctrl.totalRain = 0;
    ctrl.initialUnit = "";
    ctrl.element = $element;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl._elm = $element.find('.rainfall-data-calendar-template .data-pane');
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.windowId = ctrl.windowId || 'Rainfall Data Calendar';
        $scope.windowId = ctrl.windowId;
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        ctrl.currentDate = new Date();

        ctrl.rainfallDataCalendarFactory = new rainfallDataCalendarFactory(ctrl.accountInfo.customerId);
        ctrl.initialLoad = true;
        ctrl.calendarHeight = 'auto';
        ctrl.reloadData = false;

        if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.zoomMin !== null) {
            ctrl.stickyProperties.on = true;
            var zoomDate = new Date(ctrl.stickyProperties.zoomMin); // datetimeService.unixtimeToDate($scope.stickyProperties.zoomMin);
            var firstDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth(), 1);
            var lastDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth() + 1, 0);
            //prevent fetching data for future dates
            var todayDate = new Date();
            if (lastDay > todayDate) lastDay = todayDate;
            $scope.startDateUnix = datetimeService.dateToUnixtime(firstDay);
            $scope.endDateUnix = datetimeService.dateToUnixtime(lastDay);
        } else {
            ctrl.stickyProperties.on = false;
        }

        if ($rootScope.mobile) {
            var tmpCurrentWindow = angular.element($window);
            tmpCurrentWindow.bind('resize', function () {

                //this is a trick to refresh the calendar on resize
                //this is a trick to refresh the calendar on resize
                //this is a trick to refresh the calendar on resize
                var origin = location.origin;
                var path = location.pathname;
                var queryString = $rootScope.mobileApp ? "?" + location.href.split("?")[1] : "";
                var angJs = "#!/";
                var newPage = "pleasewait/please-wait";
                location.replace(origin + path + angJs + newPage + queryString);
                newPage = "rainfall/calendar/rainfall-data-calendar-view";
                location.replace(origin + path + angJs + newPage + queryString);

                $scope.$apply();
            });
        }

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.calendarHeight = ctrl._popup.outerHeight() - 86; //offsetting month description etc on the top of the calendar to calculate actual calendar height 

            ctrl._popup.dialogExtend({
                maximize: function maximize() {
                    openViewService.adjustContentSizeStart(ctrl._popup);
                    _resize();
                },
                restore: function restore() {
                    openViewService.adjustContentSizeStart(ctrl._popup);
                    _resize();
                }
            });
        }

        $scope.$on('contentAdjusted', function () {
            _resize();
        });

        $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            updateFromPrefs(true);
        });

        $scope.$on('updatePreferencesLanguage', function (event, language) {
            updateFromPrefs(true);
        });

        $scope.$on('updatePreferenceWeather', function (event, args) {
            updateFromPrefs(false);
        });

        //Clean up when dialog is closed
        $scope.$on("$destroy", function () {
            if (ctrl.currentSelectedDevice.deviceModel === 21) unRegisterListener();

            ctrl.isUnitFetched = false; //resetting to default value
            ctrl._elm.empty();
        });

        // watching for date change scenarios
        $scope.$watch(function () {
            if (ctrl.fullCalendar !== null && ctrl.fullCalendar.fullCalendar('getDate')._d) {
                return ctrl.fullCalendar.fullCalendar('getDate');
            }
            return undefined;
        }, function (newVal, oldVal) {
            if (newVal) {
                if (newVal._d.getUTCMonth() === moment()._d.getUTCMonth()) {
                    if (ctrl.alreadyListening === true) //if we are already listening, then unregister for it
                        unRegisterListener();
                    registerListener();
                } else {
                    unRegisterListener();
                }
            }
        }, true);
    };

    var getRainfallUnit = function getRainfallUnit() {
        var deferred = $q.defer();
        //fetch device specific settings, if it is RTU/Device
        if (ctrl.deviceId > 0) {
            if (!ctrl.isUnitFetched) {
                //if already Unit is fetched previously then dont fetch it again
                ctrl.rainfallDataCalendarFactory.fetchSettings(ctrl.deviceId).then(function (resp) {
                    deferred.resolve();
                    //for RTU/DeviceId use Unit as unit
                    var unitData = resp.data.find(function (x) {
                        return x.channelName.search(/rain/i) > -1 || x.channelName.search(/plu/i) > -1;
                    }); //case-insensitive search for 'rain' OR 'plu' --> these strings means device is connected to rainfall channel
                    if (typeof unitData !== 'undefined') {
                        ctrl.unit = unitData.unit;
                        ctrl.channel = unitData.channel;
                    }
                    //assign value to translation
                    if (!ctrl.initialUnit || ctrl.unit.toLowerCase() === "inches" || ctrl.unit.toLowerCase() === "mm" || ctrl.unit.toLowerCase() === "cm") {
                        ctrl.unit = ctrl.unit.toLowerCase() === "inches" ? ctrl.translation.text.INCHES_ABBRV : ctrl.unit;
                        ctrl.unit = ctrl.unit.toLowerCase() === "mm" ? ctrl.translation.text.MILLIMETER : ctrl.unit;
                        ctrl.unit = ctrl.unit.toLowerCase() === "cm" ? ctrl.translation.text.CENTIMETERS : ctrl.unit;
                    }
                    ctrl.initialUnit = ctrl.unit;
                    ctrl.isUnitFetched = true; // helps to fetch settings only once when device is set first time

                    registerListener(); // Live data is applicable to devicemodel = 21 onwards 
                });
            } else {
                deferred.resolve();
            }
        } else {
            //for Airport/Weather Station pull the unit from lookupMeasurementId
            ctrl.unit = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? ctrl.translation.text.INCHES_ABBRV : ctrl.translation.text.CENTIMETERS;
            ctrl.initialUnit = "";
            deferred.resolve();
        }
        return deferred.promise;
    };

    //Start the process of refreshing the whole calendar
    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowId + " -- " + ctrl.currentSelectedDevice.deviceName, 'View reloading');
        ctrl.reloadData = true;
        ctrl.setDevice(ctrl.currentSelectedDevice);
        updateFromDeviceChange(true); //added to avoid wrong header display after refresh         
    };

    ctrl.setDevice = function (rainfallData) {
        if (ctrl.deviceId !== -1 && ctrl.currentSelectedDevice.deviceModel === 21) {
            //if previously deviceid set, it means it is the scenario changing devices
            unRegisterListener();
        }
        ctrl.downloadOptions.reportType = rainfallData.deviceModel != 0 ? "RTU Rainfall" : "Rainfall";
        ctrl.currentSelectedDevice = rainfallData;
        ctrl.deviceId = rainfallData.deviceId;

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.calendarHeight = ctrl._popup.outerHeight() - 86; //offsetting month description etc on the top of the calendar to calculate actual calendar height 
        }

        $scope.deviceId = ctrl.deviceId;
        var _device = { deviceId: $scope.deviceId, deviceName: rainfallData.deviceName };
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceId, device: _device, windowId: $scope.windowId });

        updateFromDeviceChange(false);
    };

    ctrl.tlDataReceivedRainfallInterval = function (data) {
        ctrl.fullCalendar.fullCalendar('destroy');
        ctrl.drawCalendar();
    };

    var registerListener = function registerListener() {
        switch (true) {
            case ctrl.currentSelectedDevice.deviceId === 0:
                timeLapseService.register('RainfallListener', 0, '', ctrl.tlDataReceivedRainfallInterval, 60);
                break;
            case ctrl.currentSelectedDevice.deviceId >= 21:
                websocketService.register('DIGITALASPULSE', ctrl.currentSelectedDevice.serialNumber, ctrl.channel, ctrl.wsDataReceivedRainfallPULSE, ctrl.wsReconnectDigitalAsPulse);
                break;
            case ctrl.currentSelectedDevice.deviceId >= 1 && ctrl.currentSelectedDevice.deviceId < 20:
                websocketService.register('PULSE', ctrl.currentSelectedDevice.serialNumber, ctrl.channel, ctrl.wsDataReceivedRainfallPULSE, ctrl.wsReconnectDigitalAsPulse);
                break;
        }
        ctrl.alreadyListening = true;
    };

    var unRegisterListener = function unRegisterListener() {
        switch (true) {
            case ctrl.currentSelectedDevice.deviceId === 0:
                timeLapseService.unRegister('RainfallListener', 0, '', ctrl.tlDataReceivedRainfallInterval, 60);
                break;
            case ctrl.currentSelectedDevice.deviceId >= 21:
                websocketService.unRegister('DIGITALASPULSE', ctrl.currentSelectedDevice.serialNumber, ctrl.channel, ctrl.wsDataReceivedRainfallPULSE, ctrl.wsReconnectDigitalAsPulse);
                break;
            case ctrl.currentSelectedDevice.deviceId >= 1 && ctrl.currentSelectedDevice.deviceId < 20:
                websocketService.unRegister('PULSE', ctrl.currentSelectedDevice.serialNumber, ctrl.channel, ctrl.wsDataReceivedRainfallPULSE, ctrl.wsReconnectDigitalAsPulse);
                break;
        }

        ctrl.alreadyListening = false;
    };

    ctrl.wsReconnectDigitalAsPulse = function (data) {
        ctrl.fullCalendar.fullCalendar('destroy');
        ctrl.drawCalendar(false);
    };

    ctrl.wsDataReceivedRainfallPULSE = function (data) {
        // process the data if it matches with current device serialnumber and rainfall channel
        if (data.SN != ctrl.currentSelectedDevice.serialNumber || data.CH != ctrl.channel) {
            return;
        }

        var varTime = datetimeService.socketStrToServerStrTime(data.Time);
        var varValue = parseInt(data.ScaledValue);
        var liveItem = { "localDateTime": varTime, "rainfall": varValue, "temperature": 0 };

        if (data.SN == ctrl.currentSelectedDevice.serialNumber && data.CH == ctrl.channel) {
            var receivedTime = moment(datetimeService.socketStrToServerStrTime(data.Time));

            var incomingUtc = moment.utc(data.UtcDateTime, "YYYYMMDDHHmmss");
            //get existing days of data
            var existingData = ctrl.rainfallDataCalendarFactory.get();
            var updatedData = existingData.reverse();

            //if (this.pulseFlow && this.pulseFlow.days && this.pulseFlow.days.length > 0 && this.pulseFlow.days[0] && this.pulseFlow.days[0].start && receivedTime._d.getUTCDate() === todayDate.getUTCDate()) {
            if (updatedData && updatedData.length > 0 && updatedData[0].start && incomingUtc.isSame(moment.utc(updatedData[0].start), "day")) {
                ctrl.rainfallDataCalendarFactory.updateValue(data.ScaledValue);
            } else {
                ctrl.rainfallDataCalendarFactory.addDay({
                    allDay: true,
                    color: 'transparent',
                    start: receivedTime.format('MM/DD/YYYY'),
                    title: '' + Number(data.ScaledValue),
                    url: null
                });
            }

            ctrl.fullCalendar.fullCalendar('destroy');
            ctrl.drawCalendar(true);
        }
    };

    ctrl.drawCalendar = function (refresh) {
        //let _elm = $element.find('div:eq(1)');
        //let mydate = new Date($scope.startDateUnix);
        //console.log("Inside DrawCalender: calender defaultDate: " + $filter('date')(mydate, 'MM/dd/yyyy'));
        var data = {};

        ctrl.fullCalendar = ctrl._elm.fullCalendar({
            fixedWeekCount: false,
            contentHeight: ctrl.calendarHeight,
            defaultDate: $scope.startDateUnix, //ctrl.viewStart,
            ignoreTimezone: true,
            lang: ctrl.accountInfo.preferenceUser.i18nCode,
            header: {
                left: 'title',
                center: '',
                right: 'today prev,next'
            },
            buttonText: {
                today: $scope.translation.text.CURRENT_MONTH
            },
            businessHours: false,
            eventClick: function eventClick(calEvent, jsEvent, view) {
                var endDate = new Date(calEvent.start._i);
                endDate.setHours(12, 0, 0, 0);
                endDate = datetimeService.dateToUnixtime(endDate);
                var startDate = datetimeService.dateToUnixtime(new Date(calEvent.start._i));
                startDate = datetimeService.getNewStartEndDates(startDate, 0).startDate;

                var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
                //console.log("sticky props dates: BEFORE eventClick: ");
                //console.log("                  : Start: " + $filter('date')(optionsStickyProperties.dateMin, 'MM/dd/yyyy'));
                //console.log("                  : End: " + $filter('date')(optionsStickyProperties.dateMax, 'MM/dd/yyyy'));
                optionsStickyProperties.dateMin = startDate;
                optionsStickyProperties.dateMax = endDate;
                optionsStickyProperties.zoomMin = startDate + 86400000;
                optionsStickyProperties.zoomMax = endDate - 86400000;
                optionsStickyProperties.deviceId = ctrl.deviceId;
                //console.log("                  : AFTER eventClick: ");
                //console.log("                  : Start: " + $filter('date')(optionsStickyProperties.dateMin, 'MM/dd/yyyy'));
                //console.log("                  : End: " + $filter('date')(optionsStickyProperties.dateMax, 'MM/dd/yyyy'));

                if (!ctrl.mobile && !ctrl.classicView) {
                    var popupPosition = ctrl._popup.dialog('option', 'position');
                    var x = ctrl._popup.offset().left;
                    var y = ctrl._popup.offset().top;
                    var dialogWidth = ctrl._popup.dialog('option', 'width');
                    popupPosition.at = 'left+' + (x + dialogWidth) + ' top+ ' + y;
                    openViewService.openView('Rainfall Data Chart', { width: 750, height: 450 }, popupPosition, optionsStickyProperties);
                }
                //console.log(new Date(calEvent.start._i));
            },
            viewRender: function viewRender(view, element) {
                //  ctrl._elm.fullCalendar('removeEvents');

                // If we're just refreshing due to a change in preferences we don't need to call the server
                if (refresh) {
                    refresh = false;

                    var zoomDate = new Date(ctrl.stickyProperties.zoomMin);
                    console.log("Zoom", zoomDate);
                    var firstDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth(), 1);
                    $scope.startDateUnix = datetimeService.dateToUnixtime(firstDay);

                    var goToDate = $scope.startDateUnix;
                    data = ctrl.rainfallDataCalendarFactory.get();
                    //console.log(data);
                    getRainfallUnit().then(function (resp) {
                        // after fetching ctrl.unit 
                        if (ctrl.deviceId === 0) {
                            //Switching between Imperial/Metric only if Airport Rainfall Station
                            if (ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 && ctrl.unit != ctrl.translation.text.INCHES_ABBRV) {
                                if (ctrl.unit.toLowerCase() == "mm") {
                                    for (var i = 0; i < data.length; i++) {
                                        //Convert to IN
                                        data[i].title = data[i].title * .0393701;
                                        //Round
                                        data[i].title = Math.round(data[i].title * 100) / 100;
                                    }
                                    ctrl.unit = ctrl.translation.text.INCHES_ABBRV;
                                } else if (ctrl.unit.toLowerCase() == "cm") {
                                    for (var _i = 0; _i < data.length; _i++) {
                                        //Convert to IN
                                        data[_i].title = data[_i].title * .393701;
                                        //Round
                                        data[_i].title = Math.round(data[_i].title * 100) / 100;
                                    }
                                    ctrl.unit = ctrl.translation.text.INCHES_ABBRV;
                                }
                            } else if (ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2 && (ctrl.unit.toLowerCase() != ctrl.translation.text.MILLIMETER || ctrl.unit.toLowerCase() != ctrl.translation.text.CENTIMETERS)) {

                                for (var _i2 = 0; _i2 < data.length; _i2++) {
                                    //Convert to CM
                                    if (ctrl.initialUnit == "" || ctrl.initialUnit == ctrl.translation.text.CENTIMETERS) {
                                        data[_i2].title = data[_i2].title * 2.54;
                                        ctrl.unit = ctrl.translation.text.CENTIMETERS;
                                    }
                                    //Convert to MM
                                    else {
                                            data[_i2].title = data[_i2].title * 25.4;
                                            ctrl.unit = ctrl.translation.text.MILLIMETER;
                                        }
                                    //Round
                                    data[_i2].title = Math.round(data[_i2].title * 100) / 100;
                                }
                            }
                        }

                        ctrl.totalRain = 0;
                        for (var _i3 = 0; _i3 < data.length; _i3++) {
                            ctrl.totalRain += parseFloat(data[_i3].title);
                            data[_i3].title = data[_i3].title;
                            data[_i3].textColor = '#000000';
                            data[_i3].className = 'rainfall-calendar';
                        }
                        $timeout(function () {
                            ctrl._elm.fullCalendar('removeEvents');
                            ctrl._elm.fullCalendar('addEventSource', data);
                            ctrl.fullCalendar.fullCalendar('gotoDate', goToDate);
                            _displayRainfallTotal();
                        });
                    });

                    return true;
                }

                if (view.start !== $scope.startDateUnix) {
                    _disableButtons();

                    $scope.startDateUnix = view.start;

                    if (ctrl.reloadData) {
                        view = ctrl.todayView; //when refreshing most recent data, assign current month's view's value
                        ctrl.reloadData = false;
                    }
                    var d = view.intervalEnd;
                    var month = d.month() === 1 ? 0 : d.month() - 1;
                    var middledate = new Date(d.year(), month, 15);
                    //if (new Date() < middledate) {
                    //    middledate = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate());
                    //}
                    if (new Date().getMonth() == middledate.getMonth()) ctrl.todayView = angular.copy(view); //if middledate is in the same month as of today, deep copy current view for refreshing most recent data purpose
                    var middleUnix = datetimeService.dateToUnixtime(middledate);
                    var tmpDataMin = middleUnix - 24 * 3600 * 1000,
                        tmpDataMax = middleUnix + 48 * 3600 * 1000,
                        tmpZoomMin = middleUnix,
                        tmpZoomMax = middleUnix + 24 * 3600 * 1000;

                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: tmpDataMin, dataMax: tmpDataMax, zoomMin: tmpZoomMin, zoomMax: tmpZoomMax, windowId: $scope.windowId, deviceId: ctrl.deviceId });
                    ctrl.loadingRainfall = true;
                    var addHours = ctrl.deviceId > 0 ? 0 : 1;

                    middleUnix = new Date(middleUnix);
                    var first = new Date(middleUnix.getFullYear(), middleUnix.getMonth(), 1, addHours);
                    var last = new Date(middleUnix.getFullYear(), middleUnix.getMonth() + 1, 1);
                    //prevent fetching data for future dates
                    var todayDate = new Date();
                    if (last > todayDate) last = todayDate;
                    ctrl.currentDate = new Date(first);
                    var start = datetimeService.dateToUnixtime(first);
                    var end = datetimeService.dateToUnixtime(last);

                    var fetchDataResolvePromise = ctrl.rainfallDataCalendarFactory.fetchData(ctrl.deviceId, start, end, ctrl.currentSelectedDevice.metarStationID);
                    var getRainfallUnitResolvePromise = getRainfallUnit();
                    $q.all([fetchDataResolvePromise, getRainfallUnitResolvePromise]).then(function () {
                        var data = ctrl.rainfallDataCalendarFactory.get();

                        if (ctrl.deviceId === 0) {
                            //Switching between Imperial/Metric only if Airport Rainfall Station
                            if (ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 && ctrl.unit != ctrl.translation.text.INCHES_ABBRV) {
                                if (ctrl.unit.toLowerCase() == "mm") {
                                    for (var i = 0; i < data.length; i++) {
                                        //Convert to IN
                                        data[i].title = data[i].title * .0393701;
                                        //Round
                                        data[i].title = Math.round(data[i].title * 100) / 100;
                                    }
                                    ctrl.unit = ctrl.translation.text.INCHES_ABBRV;
                                } else if (ctrl.unit.toLowerCase() == "cm") {
                                    for (var _i4 = 0; _i4 < data.length; _i4++) {
                                        //Convert to IN
                                        data[_i4].title = data[_i4].title * .393701;
                                        //Round
                                        data[_i4].title = Math.round(data[_i4].title * 100) / 100;
                                    }
                                    ctrl.unit = ctrl.translation.text.INCHES_ABBRV;
                                }
                            } else if (ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2 && (ctrl.unit.toLowerCase() != ctrl.translation.text.MILLIMETER || ctrl.unit.toLowerCase() != ctrl.translation.text.CENTIMETERS)) {

                                for (var _i5 = 0; _i5 < data.length; _i5++) {
                                    //Convert to CM
                                    if (ctrl.initialUnit == "" || ctrl.initialUnit == ctrl.translation.text.CENTIMETERS) {
                                        data[_i5].title = data[_i5].title * 2.54;
                                        ctrl.unit = ctrl.translation.text.CENTIMETERS;
                                    }
                                    //Convert to CM or MM
                                    else {
                                            data[_i5].title = data[_i5].title * 25.4;
                                            ctrl.unit = ctrl.translation.text.MILLIMETER;
                                        }
                                    //Round
                                    data[_i5].title = Math.round(data[_i5].title * 100) / 100;
                                }
                            }
                        }

                        ctrl.totalRain = 0;
                        for (var _i6 = 0; _i6 < data.length; _i6++) {
                            ctrl.totalRain += parseFloat(data[_i6].title);
                            data[_i6].title = data[_i6].title;
                            data[_i6].textColor = '#000000';
                            data[_i6].className = 'rainfall-calendar';
                        }

                        $timeout(function () {
                            ctrl._elm.fullCalendar('removeEvents');
                            ctrl._elm.fullCalendar('addEventSource', data);
                            ctrl.loadingRainfall = false;
                            _enableButtons();
                            _displayRainfallTotal();
                        });
                    });
                }

                return true;
            },
            eventRender: function eventRender(event, element, view) {
                if (event.start._d.getUTCMonth() !== ctrl.fullCalendar.fullCalendar('getDate')._d.getUTCMonth()) {
                    return false;
                }
                var val = element.find('span.fc-title').text();
                if (typeof val === 'undefined' || val.trim() === '') val = 0;
                var tmpHtml = '<div><i style=\'color: ' + (parseFloat(val) > 0 ? '#76c7e7' : '#ff9247') + '; font-size:' + (ctrl.mobile ? '1em' : '1.7em') + '; margin-bottom: ' + (view.dayGrid.rowCnt > 5 ? '1px' : '5px;') + '\' class=\'fa ' + (parseFloat(val) > 0 ? 'fa-tint' : 'fa-sun-o') + '\'/>\n                                <i class=\'row fa-fw\' style=\'color: ' + (parseFloat(val) > 0 ? '#76c7e7' : '#ff9247') + ';margin-bottom: ' + (view.dayGrid.rowCnt > 5 ? '1px' : '5px;') + '\'/>  ' + parseFloat(val) + ' ' + ctrl.unit + '</div>';

                element.find('span.fc-title').html(tmpHtml);
                return true;
            }
        });
    };

    var _resize = function _resize() {
        $timeout(function () {
            if (!ctrl.mobile && !ctrl.classicView) {
                ctrl.calendarHeight = ctrl._popup.outerHeight() - 86;
                ctrl._popup.find('.fc-time-grid').css('height', ctrl.calendarHeight / 6);
                ctrl._popup.find('.fc-slats td').css('height', ctrl.calendarHeight / 6);
            }
            ctrl.fullCalendar.fullCalendar('option', 'contentHeight', ctrl.calendarHeight);
            ctrl.fullCalendar.fullCalendar('refresh');
        });
    };

    var updateFromDeviceChange = function updateFromDeviceChange(refresh) {
        if (ctrl._popup) {
            ctrl._popup.dialog('option', 'title', ctrl.translation.text.RAINFALL_CALENDAR + ", " + ctrl.currentSelectedDevice.deviceName);
        }

        if (!!ctrl.fullCalendar) {
            ctrl.fullCalendar.fullCalendar('destroy');
        }

        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = $scope.stickyPropertiesInterface;
        }

        if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.zoomMin !== null) {
            ctrl.stickyProperties.on = true;
            var zoomDate = new Date(ctrl.stickyProperties.zoomMin);
            var firstDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth(), 1);
            var lastDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth() + 1, 0);
            //prevent fetching data for future dates
            var todayDate = new Date();
            if (lastDay > todayDate) lastDay = todayDate;

            $scope.startDateUnix = datetimeService.dateToUnixtime(firstDay);
            $scope.endDateUnix = datetimeService.dateToUnixtime(lastDay);
        } else {
            ctrl.stickyProperties.on = false;
        }

        ctrl.drawCalendar(refresh);
    };

    var _disableButtons = function _disableButtons() {
        $($element).find(".fc-prev-button").prop('disabled', true);
        $($element).find(".fc-prev-button").addClass('fc-state-disabled');
        $($element).find(".fc-next-button").prop('disabled', true);
        $($element).find(".fc-next-button").addClass('fc-state-disabled');
    };

    var _enableButtons = function _enableButtons() {
        $($element).find(".fc-prev-button").removeClass('fc-state-disabled');
        $($element).find(".fc-prev-button").prop('disabled', false);
        $($element).find(".fc-next-button").removeClass('fc-state-disabled');
        $($element).find(".fc-next-button").prop('disabled', false);
    };

    var _displayRainfallTotal = function _displayRainfallTotal() {
        $($element).find(".fc-center").css("text-align", "center").css("font-weight", "bold").html(ctrl.translation.text.TOTAL + ": " + ctrl.totalRain.toFixed(2) + " " + ctrl.unit);
    };

    var updateFromPrefs = function updateFromPrefs(refresh) {
        if (!!ctrl.fullCalendar) {
            ctrl.fullCalendar.fullCalendar('destroy');
        }
        ctrl.drawCalendar(refresh);
    };
}

RainfallDataCalendarController.$inject = ['$', '$q', '$scope', '$rootScope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'sharedSetupService', 'openViewService', 'timeLapseService', 'websocketService', 'rainfallDataCalendarFactory', '$element', '$window', 'toaster'];
angular.module('mc.rainfall').component('rainfallDataCalendar', {
    controller: RainfallDataCalendarController,
    transclude: true,
    templateUrl: 'ui/rainfall/calendar/rainfall-data-calendar-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<'
    }
});

'use strict';

function RainfallModel(HOST, $http) {
  var _this = this;

  var Rainfall = function Rainfall(customerId) {
    _this.days = [];
    _this.loading = false;
    _this.customerId = customerId;
  };

  // Return a copy of the data, not the original
  Rainfall.prototype.get = function () {
    return JSON.parse(JSON.stringify(_this.days));
  };

  Rainfall.prototype.isLoading = function () {
    return _this.loading;
  };

  Rainfall.prototype.fetchData = function (startDate, endDate) {
    _this.loading = true;
    return $http.get(HOST + '/api/MetarRainfallCalendar?customerId=' + _this.customerId + '&startDate=' + startDate + '&endDate=' + endDate).then(function (resp) {
      _this.days = resp.data.calendarDays;
      _this.metarStation = resp.data.metarStation;
      _this.loading = false;
    });
  };

  Rainfall.prototype.getStationName = function () {
    if (!_this.metarStation) {
      return '';
    }

    var name = '';

    if (_this.metarStation.city.length > 0) name += _this.metarStation.city;
    if (_this.metarStation.state.length > 0 && name.length > 0) name += ', ';
    if (_this.metarStation.state.length > 0) name += _this.metarStation.state;
    if (_this.metarStation.icao.length > 0) name += ' (' + _this.metarStation.icao + ')';

    return name;
  };

  return Rainfall;
}

RainfallModel.$inject = ['HOST', '$http'];

angular.module('mc.rainfall').factory('rainfallModel', RainfallModel);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RainfallCalendarController($, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, sharedSetupService, openViewService, timeLapseService, Rainfall, $element) {
  var _this2 = this;

  $scope.qdpLeft = -237; //position-left-correction for the quick-datepicker
  $scope.downloadViewTypeOptions = [0];

  $scope.downloadOptions = { resolution: 5 };
  var ctrl = this;
  var _elm = $element.find('div:eq(1)');
  this.tlDataReceivedRainfallInterval = function (data) {
    _this2.fullCalendar.fullCalendar('destroy');
    _this2.drawCalendar();
  };

  this._registerListener = function () {
    if (_this2.liveData === true) {
      return;
    }
    _this2.liveData = true;
    timeLapseService.register('RainfallListener', 0, '', _this2.tlDataReceivedRainfallInterval, 60);
  };

  this._unRegisterListener = function () {
    if (_this2.liveData === false) {
      return;
    }
    _this2.liveData = false;
    timeLapseService.unRegister('RainfallListener', 0, '', _this2.tlDataReceivedRainfallInterval, 60);
  };

  this.$onInit = function () {
    _this2.accountInfo = authenticationService.getAccountInfo();
    _this2.translation = translationService.translation;
    _this2.windowId = _this2.windowId || 'Rainfall Calendar';
    $scope.windowId = _this2.windowId;
    $scope.stickyProperties = _this2.stickyProperties;

    _this2.fullCalendar = null;
    _this2.rainfallData = new Rainfall(_this2.accountInfo.customerId);
    _this2.initialLoad = true;
    _this2.calendarHeight = 'auto';
    _this2.viewStart = null;

    if (_typeof($scope.stickyProperties) != 'object') {
      $scope.stickyProperties = sharedSetupService.stickyPropertiesInterface;
    }
    ctrl.defaultDate = $scope.stickyProperties.dateMax == null ? new Date().getTime() : $scope.stickyProperties.dateMax;
    ctrl.defaultDate = $scope.stickyProperties.dateMax > new Date().getTime() ? new Date().getTime() : $scope.stickyProperties.dateMax;
    _this2.viewStart = ctrl.defaultDate;

    if (!_this2.mobile && !_this2.classicView) {
      _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
      _this2.calendarHeight = _this2._popup.outerHeight() - 59;
      var updateFromPrefs = function updateFromPrefs(refresh) {
        if (_this2._popup) {
          _this2._popup.dialog('option', 'title', _this2.translation.text.RAINFALL_CALENDAR + ', ' + _this2.rainfallData.getStationName());
        }

        _this2.previousMonth = _this2.fullCalendar.fullCalendar('getDate');
        _this2.fullCalendar.fullCalendar('destroy');
        _this2.drawCalendar(refresh);
      };

      $scope.$on('contentAdjusted', function () {
        _resize();
      });

      $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
        updateFromPrefs(true);
      });

      $scope.$on('updatePreferencesLanguage', function (event, language) {
        updateFromPrefs(true);
      });

      $scope.$on('updatePreferenceWeather', function (event, args) {
        updateFromPrefs(false);
      });

      _this2._popup.dialogExtend({
        maximize: function maximize() {
          openViewService.adjustContentSizeStart(_this2._popup);
          _resize();
        },
        restore: function restore() {
          openViewService.adjustContentSizeStart(_this2._popup);
          _resize();
        }
      });
    }

    $scope.$watch(function () {
      if (_this2.fullCalendar !== null) return _this2.fullCalendar.fullCalendar('getDate');
      return undefined;
    }, function (newVal, oldVal) {
      if (newVal) {
        if (newVal._d.getUTCMonth() === moment()._d.getUTCMonth()) {
          _this2._registerListener();
        } else {
          _this2._unRegisterListener();
        }
      }
    }, true);

    _this2.drawCalendar();
  };

  var _resize = function _resize() {
    $timeout(function () {
      _this2.calendarHeight = _this2._popup.outerHeight() - 59;
      _this2._popup.find('.fc-time-grid').css('height', _this2.calendarHeight / 6);
      _this2._popup.find('.fc-slats td').css('height', _this2.calendarHeight / 6);
      _this2.fullCalendar.fullCalendar('option', 'contentHeight', _this2.calendarHeight - 26);
      _this2.fullCalendar.fullCalendar('refresh');
    });
  };

  this.drawCalendar = function (refresh) {
    _this2.fullCalendar = _elm.fullCalendar({
      fixedWeekCount: false,
      contentHeight: _this2.calendarHeight,
      defaultDate: _this2.viewStart,
      ignoreTimezone: true,
      lang: _this2.accountInfo.preferenceUser.i18nCode,
      header: {
        left: 'title',
        center: '',
        right: 'today prev,next'
      },
      businessHours: false,
      eventClick: function eventClick(calEvent, jsEvent, view) {
        var endDate = new Date(calEvent.start._i);
        endDate.setHours(12, 0, 0, 0);
        endDate = datetimeService.dateToUnixtime(endDate);
        var startDate = datetimeService.dateToUnixtime(new Date(calEvent.start._i));
        startDate = datetimeService.getNewStartEndDates(startDate, 0).startDate;

        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.dateMin = startDate;
        optionsStickyProperties.dateMax = endDate;
        optionsStickyProperties.zoomMin = startDate + 86400000;
        optionsStickyProperties.zoomMax = endDate - 86400000;

        var popupPosition = _this2._popup.dialog('option', 'position');
        var x = _this2._popup.offset().left;
        var y = _this2._popup.offset().top;
        var dialogWidth = _this2._popup.dialog('option', 'width');
        popupPosition.at = 'left+' + (x + dialogWidth) + ' top+ ' + y;
        openViewService.openView('Rainfall Table', { width: 750, height: 450 }, popupPosition, optionsStickyProperties);
        console.log(new Date(calEvent.start._i));
      },
      viewRender: function viewRender(view, element) {
        _elm.fullCalendar('removeEvents');

        // If we're just refreshing due to a change in preferences we don't need to call the server
        if (refresh) {
          refresh = false;
          var data = _this2.rainfallData.get();
          console.log(data);

          for (var i = 0; i < data.length; i++) {
            data[i].title = '<div><i style=\'color: ' + (parseFloat(data[i].title) > 0 ? '#76c7e7' : '#ff9247') + '; font-size: 1.7em; margin-bottom: ' + (view.dayGrid.rowCnt > 5 ? '1px' : '5px;') + '\' class=\'fa ' + (parseFloat(data[i].title) > 0 ? 'fa-tint' : 'fa-sun-o') + '\'/></div>\n                                 ' + $filter('airportRainfall')(parseFloat(data[i].title), _this2.accountInfo.preferenceUser.lookupMeasurementID) + '\n                                 ' + (_this2.accountInfo.preferenceUser.lookupMeasurementID === 1 ? _this2.translation.text.INCHES : _this2.translation.text.CENTIMETERS);
            data[i].textColor = '#000000';
            data[i].className = 'rainfall-calendar';
          }

          $timeout(function () {
            _elm.fullCalendar('addEventSource', data);
            _this2.fullCalendar.fullCalendar('gotoDate', _this2.previousMonth);
          });

          return true;
        }

        if (view.start !== _this2.viewStart) {
          _disableButtons();
          _this2.viewStart = view.start;
          var midpoint = (view.start._d.getTime() + view.end._d.getTime()) / 2;
          var tdDate = new Date();
          midpoint = new Date(midpoint);
          midpoint = midpoint > tdDate ? tdDate.getTime() : midpoint.setDate(15);
          sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: midpoint - 1 * sharedSetupService.unixDay, dataMax: midpoint + 1 * sharedSetupService.unixDay, zoomMin: midpoint - .5 * sharedSetupService.unixDay, zoomMax: midpoint + .5 * sharedSetupService.unixDay, windowId: $scope.windowId });
          ctrl.loadingRainfall = true;
          _this2.rainfallData.fetchData(view.start, view.end).then(function () {
            if (_this2._popup) {
              _this2._popup.dialog('option', 'title', _this2.translation.text.RAINFALL_CALENDAR + ', ' + _this2.rainfallData.getStationName());
            }

            var data = _this2.rainfallData.get();

            for (var _i = 0; _i < data.length; _i++) {
              data[_i].title = '<div><i style=\'color: ' + (parseFloat(data[_i].title) > 0 ? '#76c7e7' : '#ff9247') + '; font-size: 1.7em; margin-bottom: ' + (view.dayGrid.rowCnt > 5 ? '1px' : '5px;') + '\' class=\'fa ' + (parseFloat(data[_i].title) > 0 ? 'fa-tint' : 'fa-sun-o') + '\'/></div>\n                                 ' + $filter('airportRainfall')(parseFloat(data[_i].title), _this2.accountInfo.preferenceUser.lookupMeasurementID) + '\n                                 ' + (_this2.accountInfo.preferenceUser.lookupMeasurementID === 1 ? _this2.translation.text.INCHES : _this2.translation.text.CENTIMETERS);
              data[_i].textColor = '#000000';
              data[_i].className = 'rainfall-calendar';
            }

            $timeout(function () {
              _elm.fullCalendar('addEventSource', data);
              ctrl.loadingRainfall = false;
              _resize();
              _enableButtons();
            });
          });
        }

        return true;
      },
      eventRender: function eventRender(event, element, view) {
        if (event.start._d.getUTCMonth() !== _this2.fullCalendar.fullCalendar('getDate')._d.getUTCMonth()) {
          return false;
        }

        element.find('span.fc-title').html(element.find('span.fc-title').text());
        return true;
      }
    });
  };

  var _disableButtons = function _disableButtons() {
    $($element).find(".fc-prev-button").prop('disabled', true);
    $($element).find(".fc-prev-button").addClass('fc-state-disabled');
    $($element).find(".fc-next-button").prop('disabled', true);
    $($element).find(".fc-next-button").addClass('fc-state-disabled');
  };

  var _enableButtons = function _enableButtons() {
    $($element).find(".fc-prev-button").removeClass('fc-state-disabled');
    $($element).find(".fc-prev-button").prop('disabled', false);
    $($element).find(".fc-next-button").removeClass('fc-state-disabled');
    $($element).find(".fc-next-button").prop('disabled', false);
  };
}

RainfallCalendarController.$inject = ['$', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'sharedSetupService', 'openViewService', 'timeLapseService', 'rainfallModel', '$element'];

angular.module('mc.rainfall').component('rainfallCalendar', {
  controller: RainfallCalendarController,
  transclude: true,
  templateUrl: 'ui/rainfall/calendar/rainfall-calendar-partial.html',
  bindings: {
    stickyProperties: '<',
    windowId: '<',
    mobile: '<',
    classicView: '<'
  }
});
angular.module("mc.pump-service", []);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function PumpServiceController($, $rootScope, $scope, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, $timeout, $element, pumpServiceFactory, deviceMenuService, savePdfService, toaster) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    ctrl.popup = null;
    ctrl.device = null;
    $scope.alerts = [];
    ctrl.deviceList = [];
    ctrl.downloadViewTypeOptions = [0, 1, 2];

    ctrl.$onInit = function () {
        //$scope.topMenuDateRange = false;
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.windowSubtitle = "Loading...";
        ctrl.loadingInProgress = true;
        if (_typeof($scope.stickyProperties) != 'object') $scope.stickyProperties = sharedSetupService.stickyPropertiesInterface;

        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle; // required for saveExcel feature from top-menu-module.js
        $scope.alerts = [];

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    //openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    //openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        }

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            $scope.timeFormat = timeFormat;
        });

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            if ($scope.alerts.length > 0) {
                var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });

        //Clean up when dialog is closed
        $scope.$on("$destroy", function () {
            ctrl.items = null;
        });

        $timeout(function () {
            ctrl.getPumpServiceHours();
            ctrl.adjustSize();
        }, 500);
    };

    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
        }
    };

    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.getPumpServiceHours();
    };

    //Get Data and load
    ctrl.getPumpServiceHours = function () {
        if (ctrl.accountInfo === null) return;
        if (ctrl.loadingInProgress == false) {
            ctrl.loadingInProgress = true;
            ctrl.items = [];
        }

        pumpServiceFactory.getData(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone).then(function (dataFromFactory) {
            $scope.alerts = [];
            ctrl.items = dataFromFactory.data;

            // If we didn't get any items back 
            if (ctrl.items.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        }, function (error) {
            //error
        }).then(function (data) {
            ctrl.loadingInProgress = false;
            //$scope.setLoadingInProgress(false);
        });
    };

    //dateAgentText filter called from html
    ctrl.dateAgentText = function (date, timeFormat) {
        return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var drawCell = function drawCell(row, data) {
            if (typeof data.row.raw[1] == "undefined") {
                data.doc.setFillColor(226, 239, 248);
            }
        };
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            drawCell: drawCell
        };

        savePdfService.savePDF(pdfParams);
    };
}

PumpServiceController.$inject = ['$', '$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', '$timeout', '$element', 'pumpServiceFactory', 'deviceMenuService', 'savePdfService', 'toaster'];

mcapp.factory('pumpServiceFactory', ['$http', 'REPORTS', function ($http, REPORTS) {
    var pumpServiceFactory = {};

    var _getData = function _getData(customerId, timeZone) {
        return $http({
            method: 'Get',
            url: REPORTS + '/api/PumpService?customerId=' + customerId + '&timeZone=' + timeZone,
            cache: false
        });
    };

    pumpServiceFactory.getData = _getData;

    return pumpServiceFactory;
}]);
'use strict';

angular.module('mc.pump-service').component('pumpService', {
    controller: PumpServiceController,
    templateUrl: 'ui/reports/pumpservice/pump-service-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function RainfallDataChartFactory(HOST, $http) {
    var _this = this;

    var Rainfall = function Rainfall(customerId) {
        //this.loading = false;
        _this.customerId = customerId;
    };

    //Rainfall.prototype.isLoading = () =>
    //    this.loading;

    Rainfall.prototype.fetchSettings = function (deviceId) {
        return $http.get(HOST + '/api/ParmPulse?deviceId=' + deviceId);
    };

    Rainfall.prototype.fetchData = function (deviceId, startDate, endDate, metarStation, startRow, pageSize) {
        _this.loading = true;
        var metarStationID = metarStation ? metarStation : -1;
        var reqUrl = HOST + '/api/MetarRainfallChart?customerId=' + _this.customerId + '&StartRow=' + (startRow || 1) + '&PageSize=' + (pageSize || 500) + '&startDate=' + startDate + '&endDate=' + endDate + '&metarStationId=' + metarStationID;
        if (deviceId > 0) reqUrl = HOST + '/api/MetarRainfallChart?customerId=' + _this.customerId + '&deviceId=' + deviceId + '&StartRow=' + (startRow || 1) + '&PageSize=' + (pageSize || 500) + '&startDate=' + startDate + '&endDate=' + endDate;

        return $http.get(reqUrl);
    };

    return Rainfall;
}

RainfallDataChartFactory.$inject = ['HOST', '$http'];

angular.module('mc.rainfall').factory('rainfallDataChartFactory', RainfallDataChartFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RainfallDataChartController($scope, $q, sharedSetupService, openViewService, translationService, $element, authenticationService, $rootScope, $timeout, rainfallDataChartFactory, datetimeService, websocketService, timeLapseService, toaster, rangeSelectorService) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    ctrl.downloadViewTypeOptions = [0, 1];
    ctrl.downloadOptions = { resolution: 0 };
    ctrl.popup = null;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.liveData = false;
        ctrl.liveDataOffset = 20 * 60 * 1000;
        ctrl.minPadding = 0;
        ctrl.maxPadding = 0;
        var mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.alerts = [];
        ctrl.translation = translationService.translation;
        ctrl.loadingInProgress = true;

        ctrl.rainfallDataChartFactory = new rainfallDataChartFactory(ctrl.accountInfo.customerId);

        ctrl.MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
        ctrl.RainfallUnitEnum = { Inches: 1, Centimeters: 2 };
        ctrl.TemperatureUnitEnum = { Fahrenheit: 1, Celsius: 2 };
        ctrl.TimeFormatEnum = { Civilian: 1, Military: 2 };

        ctrl.preferredRainfallUnit = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? ctrl.RainfallUnitEnum.Inches : ctrl.RainfallUnitEnum.Centimeters;
        ctrl.preferredTemperatureUnit = ctrl.TemperatureUnitEnum.Fahrenheit;
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.windowSubtitle = "Loading...";
        ctrl.SeriesData = null;

        //create the structure required for the chart: red:
        ctrl.seriesIndex = { Rain: 0, Temp: 1 };
        ctrl.seriesColors = ["#2288CC", "#DD3221", "#00CC00", "#660066", "#FF6600", "#00CCFF", "#d74375", "#618a13"];
        ctrl.chart;
        ctrl.xValue = null;
        ctrl.scrollingInProgress = false;
        ctrl.zoomLevelCurrent, ctrl.zoomLevelPrevious = 0;
        ctrl.initialLoad = true;
        ctrl.pollInterval = 60;
        ctrl.scrollInProgressTimer;
        ctrl.chartFirstDrawn = true;

        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        //Get my icon based on my title
        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        //find the element of the chart class
        ctrl.element = $element.find('.data-pane');

        //Manage Dialog Geometry
        if (ctrl.classicView && ctrl.element.parent('div').parent('div').parent('div').attr('class') && ctrl.element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") === 0) {
            ctrl.largeChart = true;
            ctrl.element.height(500);
        }

        ctrl.element.attr('class', 'chart');
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;

        //Manage Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        //Mouse wheel zoom
        ctrl.element.on('mousewheel', function (event) {
            if (!ctrl.scrollingInProgress) sharedSetupService.mouseWheelZoom(event, ctrl.chart, ctrl.xValue);
        });

        //Change the title when the service changes the weather station name
        $scope.$watch('rainfallTableService.metarStationName', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue !== oldValue) {
                ctrl.initializeChartA();
            }
        }, true);

        // Handle Language Change Event
        $scope.fnChangeLanguage = function () {
            if ($scope.alerts.length > 0) {
                var _msg = eval("ctrl.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;

                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(ctrl.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                }

                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
            ctrl.drawChart();
            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.popup.dialog("option", "title", ctrl.translation.text.AIRPORT_RAINFALL + ", " + ctrl.windowSubtitle);
        };

        //Handle Preferences:MeasurementSystem changed
        $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            ctrl.applyMeasurementSystem(measurementSystem);
            if ($scope.alerts.length === 0) {
                ctrl.drawChart();
            }
        });

        //Handle Preferences:TimeFormat (12/24) changed
        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            ctrl.applyTimeFormat(timeFormat);
            if ($scope.alerts.length === 0) {
                ctrl.drawChart();
            }
        });

        //Handle Preferences:Weather station was changed
        $scope.$on('updatePreferenceWeather', function (event, args) {
            ctrl.initializeChartA();
        });

        //blink the light when data recieved
        $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                $scope.liveDataIn = !$scope.liveDataIn;
                $timeout(function () {
                    $scope.liveDataIn = !$scope.liveDataIn;
                }, 3000);
            }
        }, true);

        //stop all listeners and pollers when the window is closed
        $scope.$on("$destroy", function () {
            ctrl.enableLiveData(false);
            if (!!ctrl.chart) ctrl.chart.destroy();
        });
    };

    ctrl.setDevice = function (rainfallData) {
        ctrl.downloadOptions.reportType = rainfallData.deviceModel != 0 ? "RTU Rainfall" : "Rainfall";
        getRainfallUnit(rainfallData.deviceId).then(function (resp) {
            // whenever device selection is made, we need to fetch corresponding unit for rainfall
            ctrl.currentSelectedDevice = rainfallData;
            ctrl.deviceId = rainfallData.deviceId;
            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.popup.dialog("option", "title", $scope.windowTitle + ", " + rainfallData.deviceName);
            }

            //set the deviceId on the stickyProperties for use by other views
            $scope.deviceId = ctrl.deviceId;
            var _device = { deviceId: $scope.deviceId, deviceName: rainfallData.deviceName };
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceId, device: _device, windowId: $scope.windowId });

            ctrl.liveData = false; //resetting the live data status
            ctrl.initializeChartA();
        });
    };

    ctrl.selectMyDate = function () {
        ctrl.passedDate = ctrl.myDate;
        ctrl.selectMyDateA();
    };

    var getRainfallUnit = function getRainfallUnit(deviceId) {
        var deferred = $q.defer();
        //fetch device specific settings, if it is RTU/Device
        if (deviceId > 0) {
            ctrl.rainfallDataChartFactory.fetchSettings(deviceId).then(function (resp) {
                deferred.resolve(resp);
                if (resp.data && resp.data.length > 0) {

                    // if device is M50 then Digital As Rainfall with flowScale > 0
                    // all other devices, case -insensitive search for 'rain' OR 'plu' -- > these strings means device is connected to rainfall channel
                    ctrl.rainChannelSetting = resp.data.find(function (x) {
                        return x.channelTypeID == 1 && x.flowScale > 0 || x.channelName.search(/rain/i) > -1 || x.channelName.search(/plu/i) > -1;
                    });
                    //for RTU/DeviceId use Unit as unit
                    ctrl.preferredRainfallUnit = typeof ctrl.rainChannelSetting !== 'undefined' ? ctrl.rainChannelSetting.unit : '';
                }
            });
        } else {
            //for Airport/Weather Station already it has been set in the OnInit()
            //ctrl.preferredRainfallUnit = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? ctrl.RainfallUnitEnum.Inches : ctrl.RainfallUnitEnum.Centimeters;;
            deferred.resolve();
        }
        return deferred.promise;
    };

    var getSeriesLabelText = function getSeriesLabelText() {
        //rainfall related logic is different for deviceId > 0 and Airport Station (ie. deviceId == 0)
        //for MeterGauge unit no translation is required, directly use preferredRainfallUnit
        var rainfallUnitTxt = ctrl.deviceId === 0 ? ctrl.preferredRainfallUnit === ctrl.RainfallUnitEnum.Inches ? ctrl.translation.text.INCHES : ctrl.translation.text.CENTIMETERS : ctrl.preferredRainfallUnit;
        return [ctrl.translation.text.RAINFALL + " (" + rainfallUnitTxt + ")", ctrl.translation.text.TEMPERATURE + " (" + (ctrl.preferredTemperatureUnit === ctrl.TemperatureUnitEnum.Fahrenheit ? ctrl.translation.text.FAHRENHEIT : ctrl.translation.text.CELSIUS) + ")"];
    };

    //Handle user selected a date from the calendar
    ctrl.selectMyDateA = function () {
        var today = Date.now();
        var selectedUnixDate = ctrl.myDate.setHours(0, 0, 0, 0).valueOf();
        selectedUnixDate = datetimeService.localToUtcTimeStampByTime(selectedUnixDate, ctrl.accountInfo.timeZone);
        if (today - selectedUnixDate < 86400000) {
            ctrl.chartFirstDrawn = true;
        }
        var dateMax = selectedUnixDate + 4 * ctrl.unixDay;
        var zoomMax = selectedUnixDate + 1.5 * ctrl.unixDay;
        var zoomMin = selectedUnixDate;
        var dateMin = selectedUnixDate - 3 * ctrl.unixDay;

        var hourOffset = moment.tz(zoomMin, datetimeService.getTimeZoneId(ctrl.accountInfo.timeZone)).utcOffset() / 60;

        dateMin = dateMin + 3600 * hourOffset * 1000;
        dateMax = dateMax + 3600 * hourOffset * 1000;
        zoomMin = zoomMin + 3600 * hourOffset * 1000;
        zoomMax = zoomMax + 3600 * hourOffset * 1000;

        $timeout(function () {
            ctrl.chart.xAxis[0].setExtremes(zoomMin, zoomMax);
        }, 300);

        ctrl.getInitialPage(dateMin, dateMax);
    };

    ctrl.applyTimeFormat = function (timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat);
    };

    //Update the chart When user preference:$scope.drawChartMeasurementSystem is changed
    ctrl.applyMeasurementSystem = function (measurementSystem) {
        //following logic only applies for Airport Station (ie. deviceId == 0)
        if (ctrl.deviceId === 0) {
            var newRainfallUnit = ctrl.preferredRainfallUnit;
            var newTemperatureUnit = ctrl.preferredTemperatureUnit;
            switch (parseInt(measurementSystem)) {
                case ctrl.MeasurementSystemEnum.Imperial:
                    newRainfallUnit = ctrl.RainfallUnitEnum.Inches;
                    newTemperatureUnit = ctrl.TemperatureUnitEnum.Fahrenheit;
                    break;
                case ctrl.MeasurementSystemEnum.Metric:
                    newRainfallUnit = ctrl.RainfallUnitEnum.Centimeters;
                    newTemperatureUnit = ctrl.TemperatureUnitEnum.Celsius;
                    break;
            }

            if (typeof ctrl.SeriesData != 'undefined' && ctrl.SeriesData != null) {
                if (ctrl.SeriesData.length > 0) ctrl.ConvertRainfallSeriesMeasurementUnit(ctrl.SeriesData[ctrl.seriesIndex.Rain], ctrl.preferredRainfallUnit, newRainfallUnit);
                if (ctrl.SeriesData.length > 1) ctrl.ConvertTemperatureSeriesMeasurementUnit(ctrl.SeriesData[ctrl.seriesIndex.Temp], ctrl.preferredTemperatureUnit, newTemperatureUnit);
            }

            ctrl.preferredRainfallUnit = newRainfallUnit;
            ctrl.preferredTemperatureUnit = newTemperatureUnit;
        }
    };

    //convert a single value between centimeters and inches
    var convertLengthUnit = function convertLengthUnit(value, fromUnit, toUnit) {
        if (typeof value === "undefined" || value === null) return 0;
        if (value < 0) return 0;
        if (fromUnit === ctrl.RainfallUnitEnum.Inches && toUnit === ctrl.RainfallUnitEnum.Centimeters) return value * 2.54;
        if (fromUnit === ctrl.RainfallUnitEnum.Centimeters && toUnit === ctrl.RainfallUnitEnum.Inches) return value / 2.54;
        return value.toFixed(2);
    };

    //convert a single point between F and C
    var convertTemperatureUnit = function convertTemperatureUnit(value, fromUnit, toUnit) {
        if (typeof value === "undefined" || value === null) return 0;
        if (fromUnit === ctrl.TemperatureUnitEnum.Fahrenheit && toUnit === ctrl.TemperatureUnitEnum.Celsius) return (value - 32) * 5 / 9;
        if (fromUnit === ctrl.TemperatureUnitEnum.Celsius && toUnit === ctrl.TemperatureUnitEnum.Fahrenheit) return value * 9 / 5 + 32;
        return value.toFixed(2);
    };

    //convert an [x,y] series between inches and centimeters
    ctrl.ConvertRainfallSeriesMeasurementUnit = function (series, fromUnit, toUnit) {
        if (fromUnit === toUnit || typeof series === 'undefined' || series == null) return;
        for (var i = 0; i < series.length; i++) {
            series[i][1] = convertLengthUnit(series[i][1], fromUnit, toUnit);
        }
    };

    //convert an [x,y] series between C & F
    ctrl.ConvertTemperatureSeriesMeasurementUnit = function (series, fromUnit, toUnit) {
        if (fromUnit === toUnit || typeof series === 'undefined' || series == null) return;
        for (var i = 0; i < series.length; i++) {
            series[i][1] = convertTemperatureUnit(series[i][1], fromUnit, toUnit);
        }
    };

    //Set start and end date sticky properties convenience function
    var setStickyDateRange = function setStickyDateRange(startDate, endDate) {
        if (typeof startDate !== 'undefined' && startDate != null) {
            ctrl.stickyProperties.on = true;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                dataMin: startDate,
                windowId: ctrl.windowId,
                deviceId: ctrl.deviceId
            });
        }
        if (typeof endDate !== 'undefined' && endDate != null) {
            ctrl.stickyProperties.on = true;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                dataMax: endDate, //wtf?!
                windowId: ctrl.windowId,
                deviceId: ctrl.deviceId
            });
        }
        debugShowStickies('stickDateRange');
    };

    //Set zoom range sticky properties convenience function
    var setStickyZoomRange = function setStickyZoomRange(startDate, endDate) {
        if (typeof startDate !== 'undefined' && startDate != null) {
            ctrl.stickyProperties.on = true;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                zoomMin: startDate,
                windowId: ctrl.windowId,
                deviceId: ctrl.deviceId
            });
        }
        if (typeof endDate !== 'undefined' && endDate != null) {
            ctrl.stickyProperties.on = true;
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                zoomMax: endDate,
                windowId: ctrl.windowId,
                deviceId: ctrl.deviceId
            });
        }
        debugShowStickies('stickZoomRange');
    };

    //Set the ScrollingInProgress flag or clear it after 1 sec
    var setScrollingInProgressFlag = function setScrollingInProgressFlag(value) {
        if (ctrl.scrollInProgressTimer != null && ctrl.scrollingInProgress) clearTimeout(ctrl.scrollInProgressTimer);
        if (value === true) ctrl.scrollingInProgress = true;else ctrl.scrollInProgressTimer = $timeout(function () {
            ctrl.scrollingInProgress = false;
        }, 1000);
    };

    // Turn live polling on or off based on where the user has scrolled
    var setLiveDataStatus = function setLiveDataStatus(varEndDate) {
        ctrl.liveDataEndDate = varEndDate != null ? varEndDate : ctrl.liveDataEndDate;
        timeLapseService.getLocalDateTime().then(function (result) {
            $scope.heartbeatLocalDateTime = result.data.unixTimeStamp;
            //console.log('zoomMax:' + new Date($scope.stickyProperties.zoomMax));
            //console.log('zoom+:  ' + new Date($scope.stickyProperties.zoomMax + ctrl.liveDataOffset));
            //console.log('result: ' + new Date(result.data.unixTimeStamp));
            if (ctrl.chart != null && ctrl.chart.xAxis != null && ctrl.chart.xAxis.length > 0) {
                var extremes = ctrl.chart.xAxis[0].getExtremes();
                var shouldEnableLiveData = ctrl.liveDataEndDate > result.data.unixTimeStamp && ctrl.stickyProperties.zoomMax + ctrl.liveDataOffset >= extremes.dataMax;
                ctrl.enableLiveData(shouldEnableLiveData);

                //Following code is meant for displaying live data (Green) bar, if it is LiveData
                var data = { Unix: result.data.unixTimeStamp, Value: null, SN: null, CH: null };
                ctrl.tlDataReceivedRAINFALL(data);
            }
        });
    };

    //reset the chart, get the first page of data and render it.
    ctrl.getInitialPage = function (startDate, endDate) {
        ctrl.loadingInProgress = true;
        ctrl.liveDataEndDate = endDate;
        ctrl.rainfallDataChartFactory.fetchData(ctrl.deviceId, startDate, endDate, ctrl.currentSelectedDevice.metarStationID).then(function (response) {
            //GetData.SuccessCallback:
            response = processResponse(response);
            $scope.alerts = [];
            ctrl.windowSubtitle = ctrl.currentSelectedDevice.deviceName;

            if (response.data.seriesData && response.data.seriesData[0].length > 0) {
                ctrl.SeriesData = response.data.seriesData;

                ctrl.drawChart();
            } else {
                ctrl.element.empty();
                ctrl.chart = null;
                ctrl.lastStart = startDate;
                ctrl.lastEnd = endDate;
                var errormsg = ctrl.translation.message.NO_DATA + ": " + moment(startDate).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(endDate).utc().format('MM/DD/YY, h:mm:ss a');
                $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                ctrl.chartFirstDrawn = false;
            }
            ctrl.loadingInProgress = false;
        }, function (response) {
            //GetData.ErrorCallback:
            ctrl.element.empty();
            ctrl.chart = null;
            ctrl.loadingInProgress = false;
            $scope.alerts.push({ msg: ctrl.translation.message.ERROR, type: "error", languageCode: "ERROR" });
        });
    };

    //get and display data when user scrolls right to a new page:
    var pageRight = function pageRight(callback) {
        ctrl.chart.showLoading();
        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var requestDateRange = datetimeService.getNewStartEndDates(extremes.dataMax, 1);
        ctrl.liveDataEndDate = requestDateRange.endDate;
        ctrl.rainfallDataChartFactory.fetchData(ctrl.deviceId, requestDateRange.startDate, requestDateRange.endDate, ctrl.currentSelectedDevice.metarStationID).then(function (response) {
            response = processResponse(response);

            if (response.data.seriesData) {
                for (var i = 0; i < response.data.seriesData.length; i++) {
                    //2
                    //append new series data (at right side of array) to the existing series data
                    ctrl.SeriesData[i] = ctrl.SeriesData[i].concat(response.data.seriesData[i]);
                    ctrl.chart.series[i].setData(ctrl.SeriesData[i]);
                }
                setStickyDateRange(null, requestDateRange.endDate);
            }
            setLiveDataStatus(requestDateRange.endDate);
            ctrl.chart.hideLoading();
            if (typeof callback === "function") callback();
        });
    };

    //get and display data when user scrolls right to a new page:
    var pageLeft = function pageLeft(callback) {
        ctrl.chart.showLoading();
        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var requestDateRange = datetimeService.getNewStartEndDates(extremes.dataMin, -1);
        ctrl.rainfallDataChartFactory.fetchData(ctrl.deviceId, requestDateRange.startDate, requestDateRange.endDate, ctrl.currentSelectedDevice.metarStationID).then(function (response) {
            response = processResponse(response);

            if (response.data.seriesData) {
                for (var i = 0; i < response.data.seriesData.length; i++) {
                    //2
                    //append existing data (at right side of array) to the new series data
                    ctrl.SeriesData[i] = response.data.seriesData[i].concat(ctrl.SeriesData[i]);
                    ctrl.chart.series[i].setData(ctrl.SeriesData[i]);
                }
            }
            setStickyDateRange(requestDateRange.startDate, null);
            setLiveDataStatus();
            ctrl.chart.hideLoading();
            if (typeof callback === "function") callback();
        });
    };

    var processResponse = function processResponse(response) {
        //following logic only applies for Airport Station (ie. deviceId == 0)
        if (ctrl.deviceId === 0) {
            if (response.data.seriesData && response.data.seriesData.length > ctrl.seriesIndex.Rain) ctrl.ConvertRainfallSeriesMeasurementUnit(response.data.seriesData[ctrl.seriesIndex.Rain], ctrl.RainfallUnitEnum.Inches, ctrl.preferredRainfallUnit);
            if (response.data.seriesData && response.data.seriesData.length > ctrl.seriesIndex.Temp) ctrl.ConvertTemperatureSeriesMeasurementUnit(response.data.seriesData[ctrl.seriesIndex.Temp], ctrl.TemperatureUnitEnum.Fahrenheit, ctrl.preferredTemperatureUnit);
        }
        return response;
    };

    //(re)draw the chart
    ctrl.drawChart = function () {
        var chartDrawn = false;
        var numberOfSeries,
            numberOfHiddenSeries = 0;

        var chartXaxisHourFormat = ctrl.preferredTimeFormat === ctrl.TimeFormatEnum.Civilian ? '%l:%M %P' : '%H:%M';

        Highcharts.setOptions({
            chart: {
                style: {
                    fontFamily: 'arial'
                }
            },
            loading: {
                labelStyle: {
                    color: 'black'
                },
                style: {
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    opacity: 1,
                    textAlign: 'center'
                }
            },
            lang: {
                loading: '<div class="imgtxtlod" title="' + ctrl.translation.text.LOADING_DATA + '"><i class="fa fa-spinner fa-spin fa-3x red imglodred"></i> <span class="txtlodblk">' + ctrl.translation.text.LOADING_DATA + '</span></div>',
                rangeSelectorZoom: ''
            }
        });

        ctrl.chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: true,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1
            },
            time: {
                getTimezoneOffset: function getTimezoneOffset(timestamp) {
                    return -moment.tz(timestamp, datetimeService.getTimeZoneId(ctrl.accountInfo.timeZone)).utcOffset();
                }
            },
            chart: {
                renderTo: ctrl.element[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1,
                borderRadius: 2,
                type: 'line',
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                marginRight: 10,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                spacingRight: 5,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {

                        //exit maybe
                        if (!this.xAxis || !chartDrawn || ctrl.scrollingInProgress) return;
                        var extremes = this.xAxis[0].getExtremes();
                        if (!extremes) return;

                        //We need to get another page of infinite data for the left
                        if (extremes.dataMin >= extremes.min - ctrl.liveDataOffset) {
                            setScrollingInProgressFlag(true);
                            pageLeft(function () {
                                setLiveDataStatus();
                                setScrollingInProgressFlag(false);
                            });
                        }
                        //We need to get another page of infinite data for the right
                        else if (ctrl.liveData === false && extremes.max + ctrl.liveDataOffset >= extremes.dataMax) {
                                setScrollingInProgressFlag(true);
                                pageRight(function () {
                                    setLiveDataStatus();
                                    setScrollingInProgressFlag(false);
                                });
                            }
                    },
                    load: function load(event) {
                        if (ctrl.initialLoad && !$rootScope.mobile && !$rootScope.classicView) openViewService.adjustContentSize(ctrl.popup);
                        ctrl.initialLoad = false;
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: false
            },
            xAxis: {
                title: {
                    text: ctrl.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 3,
                    color: 'green',
                    dashStyle: "solid",
                    zIndex: 1
                }],
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minTickInterval: 3600 * 1000,
                minorGridLineColor: '#ebebeb',
                minorTickInterval: 'auto',
                dateTimeLabelFormats: {
                    hour: chartXaxisHourFormat
                },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (chartDrawn === true) {
                            if (e.trigger === 'rangeSelectorButton') {

                                var newRanges = rangeSelectorService.getrangeExtremes(e.dataMax, e.dataMin, e.rangeSelectorButton, $scope.dataGroupingInterval);

                                sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                                    zoomMin: newRanges.newMin,
                                    zoomMax: newRanges.newMax,
                                    windowId: scope.windowId
                                });
                                ctrl.stickyProperties.on = true;
                                //Reload
                                if (newRanges.newDataMax < event.dataMin || newRanges.newDataMax > event.dataMax) ctrl.getInitialPage(newRanges.newDataMin, newRanges.newDataMax);
                                //_getData($scope.stickyProperties.deviceId, newRanges.newDataMin, newRanges.newDataMax);
                            } else {
                                var extremes = ctrl.chart.xAxis[0].getExtremes();
                                if (ctrl.liveData === true && (e.trigger === "navigator" || e.trigger === "pan" || typeof e.trigger == "undefined")) {
                                    //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                    if (extremes.max + ctrl.liveDataOffset <= extremes.dataMax) {
                                        //setLiveDataStatus();
                                        ctrl.enableLiveData(false);
                                    }
                                }
                                setStickyZoomRange(extremes.min, extremes.max);
                                ctrl.downsampleSeries(extremes.min, extremes.max);

                                //following code helps to set extremes when dataMax is close to 0 and it prevents the y=0 to be inline with x-axis
                                if (ctrl.chart.yAxis[0].dataMin === 0 && ctrl.chart.yAxis[0].dataMax === 0) ctrl.chart.yAxis[0].setExtremes(0, 1);
                            }
                        }
                    },
                    setExtremes: function setExtremes(e) {
                        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { zoomMin: e.min, zoomMax: e.max, windowId: $scope.windowId });
                    }
                }
            },
            yAxis: getYAxis(),
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var s = '';
                    s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartXaxisHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, ctrl.accountInfo.timeZone)) + '</td></tr>';
                    //console.log("this.x: " + this.x);
                    //console.log("this.points: " + this.points);
                    //console.log("this.xValue: " + this.xValue);
                    $.each(this.points, function (i, point) {
                        s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, 2) + '</td></tr>';
                        ctrl.xValue = point.x;
                        //console.log("inside each: this.xValue: " + this.xValue);
                    });
                    s += '</table>';
                    //console.log("s: " + s);
                    return s;
                },
                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 0,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false,
                inputEnabled: false,
                allButtonsEnabled: true,
                selected: 3,
                buttons: [{
                    type: 'hour',
                    count: 1,
                    text: '1h'
                }, {
                    type: 'hour',
                    count: 6,
                    text: '6h'
                }, {
                    type: 'hour',
                    count: 12,
                    text: '12h'
                }, {
                    type: 'day',
                    count: 1,
                    text: '1d'
                }]
            },
            plotOptions: {
                series: {
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                ctrl.xValue = this.x;
                            }
                        }
                    },
                    borderColor: 'red',
                    borderWidth: 1,
                    marker: {
                        enabled: null, //If null, the markers are hidden when the data is dense, and shown for more widespread data points.
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    events: {
                        legendItemClick: function legendItemClick(e) {
                            numberOfSeries = ctrl.chart.series.length - 1;
                            var visibility = this.visible ? 'visible' : 'hidden';
                            numberOfHiddenSeries = visibility === 'hidden' ? numberOfHiddenSeries - 1 : numberOfHiddenSeries + 1;
                            if (numberOfHiddenSeries < numberOfSeries) {
                                ctrl.chart.yAxis[this.index].update({
                                    labels: { enabled: visibility === 'visible' ? false : true },
                                    title: { text: visibility === 'visible' ? null : getSeriesLabelText()[this.index] },
                                    lineWidth: visibility === 'visible' ? 0 : 2
                                });
                                return true;
                            }
                            numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                            if (numberOfHiddenSeries < numberOfSeries) {
                                this.yAxis.update({ visible: !this.visible });
                                return true;
                            }
                            numberOfHiddenSeries = numberOfHiddenSeries - 1;
                            return false;
                        },
                        mouseOut: function mouseOut() {
                            ctrl.xValue = null;
                        }
                    }
                }
            },
            series: getSeries()
        });

        //This only happens after chart is first drawn:
        if (ctrl.stickyProperties.on === true) {
            var extremes = ctrl.chart.xAxis[0].getExtremes();
            var zoomMin = Math.max(ctrl.stickyProperties.zoomMin, extremes.min);
            var zoomMax = Math.min(ctrl.stickyProperties.zoomMax, extremes.max);

            var liveDataLine = ctrl.chart.xAxis[0].plotLinesAndBands;
            if (ctrl.chartFirstDrawn) {
                liveDataLine[0].options.value = extremes.max + ctrl.maxPadding;
                ctrl.chartFirstDrawn = false;
            }
            ctrl.chart.xAxis[0].setExtremes(zoomMin, zoomMax);
            debugShowChartExtents();
        }

        setLiveDataStatus();
        chartDrawn = true;
        if (!$rootScope.mobile && !$rootScope.classicView) {
            $timeout(function () {
                openViewService.adjustContentSize(ctrl.popup);
            }, 500);
        }
        if (ctrl.chart.yAxis[0].dataMin === 0 && ctrl.chart.yAxis[0].dataMax === 0) ctrl.chart.yAxis[0].setExtremes(0, 1);
        ctrl.loadingInProgress = false;
    };

    var getSeries = function getSeries() {
        //rainfall related logic is different for deviceId > 0 and Airport Station (ie. deviceId == 0)
        //for MeterGauge unit no translation is required, directly use preferredRainfallUnit
        var rainfallUnitTxt = ctrl.deviceId === 0 ? ctrl.preferredRainfallUnit === ctrl.RainfallUnitEnum.Inches ? ctrl.translation.text.INCHES : ctrl.translation.text.CENTIMETERS : ctrl.preferredRainfallUnit;
        var rainfallLabelText = ctrl.translation.text.RAINFALL + " (" + rainfallUnitTxt + ")";

        var temperatureLabelText = ctrl.translation.text.TEMPERATURE + " (" + (ctrl.preferredTemperatureUnit === 1 ? ctrl.translation.text.FAHRENHEIT : ctrl.translation.text.CELSIUS) + ")";

        var rainSeries = {
            name: rainfallLabelText,
            id: "0",
            yAxis: 0,
            type: "line",
            color: ctrl.seriesColors[ctrl.seriesIndex.Rain],
            marker: { symbol: "circle", radius: 4 },
            shadow: false,
            data: ctrl.SeriesData[ctrl.seriesIndex.Rain]
        };

        var tempSeries = {
            name: temperatureLabelText,
            id: "1",
            yAxis: 1,
            type: "line",
            color: ctrl.seriesColors[ctrl.seriesIndex.Temp],
            marker: {
                symbol: "circle", radius: 4
            },
            shadow: false,
            data: ctrl.SeriesData[ctrl.seriesIndex.Temp]
        };

        var series = [];
        series.push(rainSeries);

        if (ctrl.deviceId === 0) series.push(tempSeries);

        return series;
    };

    var getYAxis = function getYAxis() {
        var yAxis = [];

        var rainYAxis = {
            showEmpty: false,
            gridLineWidth: 0,
            gridLineColor: "#dedede",
            opposite: false,
            startOnTick: true,
            endOnTick: true,
            lineWidth: 2,
            lineColor: ctrl.seriesColors[ctrl.seriesIndex.Rain],
            title: {
                text: getSeriesLabelText()[0],
                style: { color: "#000" }
            },
            labels: {
                format: "{value:.2f}"
            },
            //min: 0,
            //max:5,
            tickPositioner: function tickPositioner() {
                var positions = [];
                var firstTick = 0;
                //Only whole units, starting at 1
                var lastTick = Math.max(Math.ceil(this.dataMax), 1);
                //Only zoom out, not in:
                if (this.tickPositions && this.dataMin >= this.tickPositions[0] && this.dataMax <= this.tickPositions[this.tickPositions.length - 1]) {
                    return this.tickPositions;
                }
                //Ten labels
                var increment = (lastTick - firstTick) / 10;
                for (var tick = firstTick; tick <= lastTick + increment; tick += increment) {
                    positions.push(tick);
                }
                return positions;
            }
        };

        yAxis.push(rainYAxis);

        var tempYAxis = {
            showEmpty: false,
            allowDecimals: false,
            gridLineWidth: 0,
            gridLineColor: "#dedede",
            opposite: false,
            startOnTick: true,
            endOnTick: true,
            lineWidth: 2,
            lineColor: ctrl.seriesColors[ctrl.seriesIndex.Temp],
            title: {
                text: getSeriesLabelText()[1],
                style: { color: "#000" }
            },
            tickPositioner: function tickPositioner() {
                var positions = [];
                var median = (this.dataMin + this.dataMax) / 2;
                var swing = ctrl.preferredTemperatureUnit === ctrl.TemperatureUnitEnum.Fahrenheit ? 10 : 10 * 5 / 9;
                var firstTick = Math.floor(Math.min(median - swing, this.dataMin) / 10) * 10;
                var lastTick = Math.ceil(Math.max(median + swing, this.dataMax) / 10) * 10;
                var step = Math.ceil((lastTick - firstTick) / 10);

                var freezing = ctrl.preferredTemperatureUnit === ctrl.TemperatureUnitEnum.Fahrenheit ? 32 : 0;

                //Dont let the scale get smaller
                if (this.tickPositions && this.dataMin >= this.tickPositions[0] && this.dataMax <= this.tickPositions[this.tickPositions.length - 1]) return this.tickPositions;

                for (var tick = firstTick; tick <= lastTick; tick += step) {
                    //if (tick > (freezing - step) && tick < freezing) {
                    //    positions.push(freezing);
                    //    tick += step;
                    //} else
                    positions.push(tick);
                }return positions;
            }
        };

        if (ctrl.deviceId === 0) yAxis.push(tempYAxis);

        return yAxis;
    };

    ctrl.enableLiveData = function (enable) {
        if (ctrl.liveData === enable) return;
        ctrl.liveData = enable;
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
            liveData: ctrl.liveData,
            windowId: ctrl.windowId
        });

        if (enable) {
            // subscribe for live Rainfall data
            if (ctrl.rainChannelSetting && ctrl.currentSelectedDevice.deviceModel == 21) {
                //ctrl.liveDataOffset = 0;
                websocketService.register("DIGITALASPULSE", ctrl.currentSelectedDevice.serialNumber, ctrl.rainChannelSetting.channel, ctrl.wsDataReceivedRainfallPULSE, null);
            } else if (ctrl.rainChannelSetting && ctrl.currentSelectedDevice.deviceModel > 0) {
                websocketService.register("PULSE", ctrl.currentSelectedDevice.serialNumber, ctrl.rainChannelSetting.channel, ctrl.wsDataReceivedRainfallPULSE, null);
            }
            // else 
            // {
            //     timeLapseService.register("RainfallListener", 0, "", ctrl.pollForLiveData, ctrl.pollInterval);
            //     timeLapseService.register("RainfallLive", 0, "", ctrl.tlDataReceivedRAINFALL, 1);
            // }
        } else {
            // un-subscribe for live Rainfall data
            if (ctrl.rainChannelSetting && ctrl.currentSelectedDevice.deviceModel == 21) {
                //ctrl.liveDataOffset = 0;
                websocketService.unRegister("DIGITALASPULSE", ctrl.currentSelectedDevice.serialNumber, ctrl.rainChannelSetting.channel, ctrl.wsDataReceivedRainfallPULSE, null);
            } else if (ctrl.rainChannelSetting && ctrl.currentSelectedDevice.deviceModel > 0) {
                websocketService.unRegister("PULSE", ctrl.currentSelectedDevice.serialNumber, ctrl.rainChannelSetting.channel, ctrl.wsDataReceivedRainfallPULSE, null);
            }
            // else {
            //     timeLapseService.unRegister("RainfallListener", 0, "", ctrl.pollForLiveData, ctrl.pollInterval);
            //     timeLapseService.unRegister("RainfallLive", 0, "", ctrl.tlDataReceivedRAINFALL, 1);
            //     $scope.lastUpdateAt = undefined;
            // }
        }
    };
    ctrl.pollForLiveData = function () {
        pageRight();
    };

    ctrl.wsDataReceivedRainfallPULSE = function (data) {
        // process the data if it matches with current device serialnumber and rainfall channel
        if (data.SN != ctrl.currentSelectedDevice.serialNumber || data.CH != ctrl.rainChannelSetting.channel) {
            return;
        }

        //ctrl.liveDataOffset = 0;
        //following condition should not satisfy, if yes, just return. 
        if (ctrl.liveData === true && ctrl.currentSelectedDevice.deviceModel == 0) {
            //wrong place... for the device.
            return;
        }

        // following is only for deviceModel = 21 (M50)
        if (ctrl.liveData === false) {
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, { liveData: false, windowId: ctrl.windowId, deviceId: ctrl.deviceId });
            if (ctrl.rainChannelSetting && ctrl.currentSelectedDevice.deviceModel == 21) {
                websocketService.unRegister("DIGITALASPULSE", ctrl.currentSelectedDevice.serialNumber, ctrl.rainChannelSetting.channel, ctrl.wsDataReceivedRainfallPULSE, null);
            } else if (ctrl.rainChannelSetting && ctrl.currentSelectedDevice.deviceModel > 0) {
                websocketService.unRegister("PULSE", ctrl.currentSelectedDevice.serialNumber, ctrl.rainChannelSetting.channel, ctrl.wsDataReceivedRainfallPULSE, null);
            }
            return;
        }
        if (ctrl.liveData === false) {
            // never this place... for the device.
            return;
        }

        //extract the data date and value
        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, ctrl.accountInfo.timeZone);
        var varScaledValue = parseFloat(data.ScaledValue);

        // update existing serie with live data (TODO: modify to series.addPoint())
        var newDataSeri = [[unixtime, varScaledValue]];
        ctrl.SeriesData[0] = ctrl.SeriesData[0].concat(newDataSeri);
        ctrl.chart.series[0].setData(ctrl.SeriesData[0]);

        ctrl.liveDataEndDate = unixtime + 1000; // setting datamax + 1second

        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var shouldEnableLiveData = ctrl.liveDataEndDate > unixtime && ctrl.stickyProperties.zoomMax + ctrl.liveDataOffset >= extremes.dataMax;
        ctrl.enableLiveData(shouldEnableLiveData);

        //update the live data line (GREEN line)
        var liveDataLine = ctrl.chart.xAxis[0].plotLinesAndBands;
        liveDataLine[0].options.value = ctrl.liveDataEndDate + ctrl.maxPadding;

        //update the extremes of the chart
        extremes = ctrl.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;
        if (extremes.max + ctrl.liveDataOffset > extremes.dataMax) ctrl.chart.xAxis[0].setExtremes(unixtime - tmpRange + ctrl.minPadding, unixtime + ctrl.maxPadding);
    };

    ctrl.tlDataReceivedRAINFALL = function (data) {
        data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, ctrl.accountInfo.timeZone);
        if (ctrl.liveData === false) {
            //timeLapseService.unRegister($scope.deviceSelectedSn);
            timeLapseService.unRegister("RainfallListener", 0, "", ctrl.pollForLiveData, ctrl.pollInterval);
            timeLapseService.unRegister("RainfallLive", 0, "", ctrl.tlDataReceivedRAINFALL, 1);
            return;
        }

        var extremes = ctrl.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - ctrl.unixDay / 2) {
            //timeLapseService.unRegister($scope.deviceSelectedSn);
            timeLapseService.unRegister("RainfallListener", 0, "", ctrl.pollForLiveData, ctrl.pollInterval);
            timeLapseService.unRegister("RainfallLive", 0, "", ctrl.tlDataReceivedRAINFALL, 1);
            return;
        }

        var liveDataLine = ctrl.chart.xAxis[0].plotLinesAndBands;
        liveDataLine[0].options.value = data.Unix + ctrl.maxPadding;

        if (extremes.max + ctrl.liveDataOffset > extremes.dataMax) {
            ctrl.chart.xAxis[0].setExtremes(data.Unix - tmpRange + ctrl.minPadding, data.Unix + ctrl.maxPadding);
        }
    };

    // Downsample logic for zooming
    ctrl.downsampleSeries = function (varMin, varMax) {
        ctrl.zoomLevelCurrent = varMax - varMin;
        var i;
        if (ctrl.zoomLevelCurrent <= ctrl.unixDay && ctrl.zoomLevelPrevious > ctrl.unixDay) {
            for (i = 0; i < ctrl.chart.series.length - 1; i++) {
                ctrl.chart.series[i].update({
                    downsample: {
                        threshold: 0
                    }
                }, false);
                ctrl.chart.series[i].setData(ctrl.SeriesData[i], false);
            }
            ctrl.chart.redraw();
        } else if (ctrl.zoomLevelCurrent > ctrl.unixDay && ctrl.zoomLevelPrevious <= ctrl.unixDay) {
            for (i = 0; i < ctrl.chart.series.length - 1; i++) {
                ctrl.chart.series[i].update({
                    downsample: {
                        threshold: 1000
                    }
                }, false);
            }
            ctrl.chart.redraw();
        }
        ctrl.zoomLevelPrevious = ctrl.zoomLevelCurrent;
    };

    ctrl.zoomAdjust = function (varDay) {
        var extremeMinMax = rangeSelectorService.getChartExtremes(ctrl.chart.xAxis[1].dataMax, ctrl.chart.xAxis[1].dataMin, varDay, $scope.heartbeatLocalDateTime);
        ctrl.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
        setLiveDataStatus();
    };

    //Start the process of refreshing the whole chart
    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.windowSubtitle, 'View reloading');
        ctrl.myDate = null;
        ctrl.stickyProperties.on = null;
        ctrl.initializeChartA();
    };

    //Start the process of loading data
    ctrl.initializeChartA = function () {
        var tmpStartDate = null,
            tmpEndDate = null;
        ctrl.loadingInProgress = true;
        ctrl.applyMeasurementSystem(ctrl.accountInfo.preferenceUser.lookupMeasurementID);
        ctrl.applyTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);
        debugShowStickies('initializeChart');
        if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.dateMax !== null) {
            ctrl.stickyProperties.on = true;
            tmpStartDate = ctrl.stickyProperties.dateMin;
            tmpEndDate = ctrl.stickyProperties.dateMax;
        } else {
            ctrl.stickyProperties.on = false;
        }

        //Page is displaying for the first time, so get today
        if (!tmpStartDate) {
            timeLapseService.getLocalDateTime().then(function (result) {
                var nowTicks = new Date(result.data.utcDateTime).valueOf();
                var todayTicks = new Date(result.data.utcDateTime).setHours(0, 0, 0, 0).valueOf();
                var endTicks = todayTicks + ctrl.unixDay;
                var startTicks = endTicks - 3 * ctrl.unixDay;
                var zoomMinTicks = todayTicks;
                var zoomMaxTicks = nowTicks;

                var hourOffset = moment.tz(zoomMinTicks, datetimeService.getTimeZoneId(ctrl.accountInfo.timeZone)).utcOffset() / 60;

                startTicks = startTicks + 3600 * hourOffset * 1000;
                endTicks = endTicks + 3600 * hourOffset * 1000;
                zoomMinTicks = zoomMinTicks + 3600 * hourOffset * 1000;
                zoomMaxTicks = zoomMaxTicks + 3600 * hourOffset * 1000;
                setStickyDateRange(startTicks, endTicks);
                setStickyZoomRange(zoomMinTicks, zoomMaxTicks);
                ctrl.getInitialPage(startTicks, endTicks);
            });
        } else {
            ctrl.getInitialPage(tmpStartDate, tmpEndDate);
        }
    };

    //This is a kludge:
    var _subtractZoneOffset = function _subtractZoneOffset(timestamp, zoneCode) {
        var offset = 0;
        if (zoneCode === 'E') offset = -4;
        if (zoneCode === 'C') offset = -5;
        if (zoneCode === 'M') offset = -6;
        if (zoneCode === 'P') offset = -7;
        if (zoneCode === 'A') offset = -8;
        return moment(timestamp).add(offset, 'hours').format('X') * 1000;
    };

    var debugShowStickies = function debugShowStickies(msg) {
        //console.log(msg);
        //console.log('   on:' + $scope.stickyProperties.on);
        //console.log('   dateMin: [' + $scope.stickyProperties.dateMin + ']' + new Date($scope.stickyProperties.dateMin));
        //console.log('   zoomMin: [' + $scope.stickyProperties.zoomMin + ']' + new Date($scope.stickyProperties.zoomMin));
        //console.log('   zoomMax: [' + $scope.stickyProperties.zoomMax + ']' + new Date($scope.stickyProperties.zoomMax));
        //console.log('   dateMax: [' + $scope.stickyProperties.dateMax + ']' + new Date($scope.stickyProperties.dateMax));
    };

    var debugShowChartExtents = function debugShowChartExtents() {
        //var extremes = ctrl.chart.xAxis[0].getExtremes();
        //console.log('debugShowChartExtents:');
        //console.log('   datMin: ' + extremes.dataMin);
        //console.log('   min:     ' + extremes.min);
        //console.log('   max:     ' + extremes.max);
        //console.log('   dataMax: ' + extremes.dataMax);
    };

    var debugLogDates = function debugLogDates(start, end, response) {
        console.log('Request:');
        console.log('   start: [' + start + ']' + new Date(start));
        console.log('   end:   [' + end + ']' + new Date(end));
        if (response.data.series && response.data.series.length > 0 && response.data.series[0].data.length > 0) {
            console.log('Response');
            console.log('   First: [' + response.data.series[0].data[0][0] + ']' + new Date(response.data.series[0].data[0][0]));
            console.log('   Last:  [' + response.data.series[0].data[response.data.series[0].data.length - 1][0] + ']' + new Date(response.data.series[0].data[response.data.series[0].data.length - 1][0]));
        }
    };
}

RainfallDataChartController.$inject = ['$scope', '$q', 'sharedSetupService', 'openViewService', 'translationService', '$element', 'authenticationService', '$rootScope', '$timeout', 'rainfallDataChartFactory', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'rangeSelectorService'];
angular.module('mc.rainfall').component('rainfallDataChart', {
    controller: RainfallDataChartController,
    templateUrl: 'ui/rainfall/chart/rainfall-data-chart-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

'use strict';

function RuntimeRainfallCalendarFactory(HOST, $http) {
    var _this = this;

    var RuntimeRainfallCalendar = function RuntimeRainfallCalendar(customerId) {
        _this.days = [];
        _this.loading = false;
        _this.customerId = customerId;
    };

    // Return a copy of the data, not the original
    RuntimeRainfallCalendar.prototype.get = function () {
        return JSON.parse(JSON.stringify(_this.days));
    };

    RuntimeRainfallCalendar.prototype.isLoading = function () {
        return _this.loading;
    };

    RuntimeRainfallCalendar.prototype.fetchData = function (customerId, deviceId, deviceType, startDate, endDate, metarStationId, rainfallSite) {
        _this.loading = true;
        var reqUrl = HOST + '/api/RuntimeVsRainfallCalendar?customerId=' + customerId + '&deviceId=' + deviceId + '&deviceType=' + deviceType + '&startDate=' + startDate + '&endDate=' + endDate + '&metarStationId=' + metarStationId + '&rainfallSite=' + rainfallSite;
        return $http.get(reqUrl).then(function (resp) {
            _this.days = resp.data;
            _this.metarStation = resp.data.metarStation;
            _this.loading = false;
        });
    };

    RuntimeRainfallCalendar.prototype.fetchSettings = function (deviceId) {
        return $http.get(HOST + '/api/ParmPulse?deviceId=' + deviceId);
    };

    RuntimeRainfallCalendar.prototype.getStationName = function () {
        if (!_this.metarStation) {
            return '';
        }

        var name = '';

        if (_this.metarStation.city.length > 0) name += _this.metarStation.city;
        if (_this.metarStation.state.length > 0 && name.length > 0) name += ', ';
        if (_this.metarStation.state.length > 0) name += _this.metarStation.state;
        if (_this.metarStation.icao.length > 0) name += ' (' + _this.metarStation.icao + ')';

        return name;
    };

    return RuntimeRainfallCalendar;
}

RuntimeRainfallCalendarFactory.$inject = ['HOST', '$http'];

angular.module('mc.rainfall').factory('runtimeRainfallCalendarFactory', RuntimeRainfallCalendarFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RuntimeRainfallCalendarController($scope, $q, sharedSetupService, openViewService, translationService, $element, authenticationService, $rootScope, $timeout, runtimeRainfallCalendarFactory, datetimeService, websocketService, timeLapseService, toaster) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    ctrl.downloadViewTypeOptions = [0, 4];
    ctrl.downloadOptions = { resolution: 5 };
    ctrl.popup = null;
    var xValue = null;
    ctrl.element = $element;
    ctrl.unit = '';

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl._elm = $element.find('.data-pane');
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.windowId = ctrl.windowId || 'Rainfall vs Runtime Chart';
        $scope.windowId = ctrl.windowId;
        ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        var stickyProperties = ctrl.stickyProperties;
        ctrl.currentDate = new Date();

        ctrl.runtimeRainfallCalendarFactory = new runtimeRainfallCalendarFactory(ctrl.accountInfo.customerId);
        ctrl.initialLoad = true;
        ctrl.reloadData = false;
        ctrl.calendarHeight = 'auto';
        ctrl.runtimeScaleName = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? "Min" : "Hours";

        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = $scope.stickyPropertiesInterface;
        }

        if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.zoomMin !== null) {
            ctrl.stickyProperties.on = true;
            var zoomDate = new Date(ctrl.stickyProperties.zoomMin); // datetimeService.unixtimeToDate(ctrl.stickyProperties.zoomMin);
            var firstDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth(), 1);
            var lastDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth() + 1, 0);
            $scope.startDateUnix = datetimeService.dateToUnixtime(firstDay);
            $scope.endDateUnix = datetimeService.dateToUnixtime(lastDay);
        } else {
            ctrl.stickyProperties.on = false;
        }

        if ($rootScope.mobile) {
            var tmpCurrentWindow = angular.element($window);
            tmpCurrentWindow.bind('resize', function () {

                //this is a trick to refresh the calendar on resize
                //this is a trick to refresh the calendar on resize
                //this is a trick to refresh the calendar on resize
                var origin = location.origin;
                var path = location.pathname;
                var queryString = $rootScope.mobileApp ? "?" + location.href.split("?")[1] : "";
                var angJs = "#!/";
                var newPage = "pleasewait/please-wait";
                location.replace(origin + path + angJs + newPage + queryString);
                newPage = "rainfall/calendar/rainfall-data-calendar-view";
                location.replace(origin + path + angJs + newPage + queryString);

                $scope.$apply();
            });
        }

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.calendarHeight = ctrl._popup.outerHeight() - 59;

            ctrl._popup.dialogExtend({
                maximize: function maximize() {
                    openViewService.adjustContentSizeStart(ctrl._popup);
                    _resize();
                },
                restore: function restore() {
                    openViewService.adjustContentSizeStart(ctrl._popup);
                    _resize();
                }
            });
        }

        $scope.$on('contentAdjusted', function () {
            _resize();
        });

        $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            updateFromPrefs(true);
        });

        $scope.$on('updatePreferencesLanguage', function (event, language) {
            updateFromPrefs(true);
        });

        $scope.$on('updatePreferenceWeather', function (event, args) {
            updateFromPrefs(false);
        });
    };

    var getRainfallUnit = function getRainfallUnit(deviceId) {
        var deferred = $q.defer();
        //fetch device specific settings, if it is RTU/Device
        if (ctrl.deviceId > 0) {
            ctrl.runtimeRainfallCalendarFactory.fetchSettings(ctrl.deviceId).then(function (resp) {
                deferred.resolve();
                if (resp.data.length > 0) {
                    var unitData = resp.data.find(function (x) {
                        return x.channelName.search(/rain/i) > -1 || x.channelName.search(/plu/i) > -1;
                    });
                    ctrl.unit = typeof unitData !== 'undefined' ? unitData.unit : '';
                    //case-insensitive search for 'rain' OR 'plu' --> these strings means device is connected to rainfall channel
                    ctrl.unitFactor = 1;
                    if (!ctrl.initialUnit) {
                        ctrl.unit = ctrl.unit.toLowerCase() === "inches" ? ctrl.translation.text.INCHES_ABBRV : ctrl.unit;
                        ctrl.unit = ctrl.unit.toLowerCase() === "mm" ? ctrl.translation.text.MILLIMETER : ctrl.unit;
                        ctrl.unit = ctrl.unit.toLowerCase() === "cm" ? ctrl.translation.text.CENTIMETERS : ctrl.unit;
                    }
                    ctrl.initialUnit = ctrl.unit;
                }
            });
        } else {
            //for Airport/Weather Station pull the unit from lookupMeasurementId
            ctrl.unit = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? ctrl.translation.text.INCHES_ABBRV : ctrl.translation.text.CENTIMETERS;
            ctrl.initialUnit = "";
            deferred.resolve();
        }
        return deferred.promise;
    };

    //Start the process of refreshing the whole calendar
    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowId + " -- " + ctrl.currentSelectedDevice.deviceName, 'View reloading');
        ctrl.reloadData = true;
        ctrl.setDevice(ctrl.currentSelectedDevice);
        updateFromDeviceChange(true); //added to avoid wrong header display after refresh        
    };

    ctrl.setDevice = function (rainfallData) {
        ctrl.downloadOptions.reportType = rainfallData.deviceModel != 0 ? "Rainfall vs Runtime" : "Rainfall";
        ctrl.currentSelectedDevice = rainfallData;
        ctrl.deviceId = rainfallData.deviceId;

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.calendarHeight = ctrl._popup.outerHeight() - 59;
        }

        $scope.deviceId = ctrl.deviceId;
        var _device = { deviceId: $scope.deviceId, deviceName: rainfallData.deviceName };
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: $scope.deviceId, device: _device, windowId: $scope.windowId });
        updateFromDeviceChange(false);
    };

    ctrl.drawCalendar = function (refresh) {
        //let _elm = $element.find('div:eq(1)');
        //let mydate = new Date($scope.startDateUnix);
        //console.log("Inside DrawCalender: calender defaultDate: " + $filter('date')(mydate, 'MM/dd/yyyy'));
        var data = {};

        ctrl.fullCalendar = ctrl._elm.fullCalendar({
            fixedWeekCount: false,
            contentHeight: ctrl.calendarHeight,
            defaultDate: $scope.startDateUnix, //ctrl.viewStart,
            ignoreTimezone: true,
            lang: ctrl.accountInfo.preferenceUser.i18nCode,
            header: {
                left: 'title',
                center: '',
                right: 'today prev,next'
            },
            buttonText: {
                today: $scope.translation.text.CURRENT_MONTH
            },
            businessHours: false,
            eventClick: function eventClick(calEvent, jsEvent, view) {
                var endDate = new Date(calEvent.start._i);
                endDate.setHours(12, 0, 0, 0);
                endDate = datetimeService.dateToUnixtime(endDate);
                var startDate = datetimeService.dateToUnixtime(new Date(calEvent.start._i));
                startDate = datetimeService.getNewStartEndDates(startDate, 0).startDate;

                var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
                optionsStickyProperties.dateMin = startDate;
                optionsStickyProperties.dateMax = endDate;
                optionsStickyProperties.zoomMin = startDate + 86400000;
                optionsStickyProperties.zoomMax = endDate - 86400000;
                optionsStickyProperties.deviceId = ctrl.deviceId;

                if (!ctrl.mobile && !ctrl.classicView) {
                    var popupPosition = ctrl._popup.dialog('option', 'position');
                    var x = ctrl._popup.offset().left;
                    var y = ctrl._popup.offset().top;
                    var dialogWidth = ctrl._popup.dialog('option', 'width');
                    popupPosition.at = 'left+' + (x + dialogWidth) + ' top+ ' + y;
                    openViewService.openView('Rainfall vs Runtime Chart', { width: 750, height: 450 }, popupPosition, optionsStickyProperties);
                }
                //console.log(new Date(calEvent.start._i));
            },
            viewRender: function viewRender(view, element) {
                //  ctrl._elm.fullCalendar('removeEvents');

                // If we're just refreshing due to a change in preferences we don't need to call the server
                if (refresh) {
                    refresh = false;

                    var zoomDate = new Date(ctrl.stickyProperties.zoomMin);
                    var firstDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth(), 1);
                    $scope.startDateUnix = datetimeService.dateToUnixtime(firstDay);

                    var goToDate = $scope.startDateUnix;
                    data = ctrl.runtimeRainfallCalendarFactory.get();

                    getRainfallUnit().then(function (resp) {
                        // after fetching ctrl.unit 
                        if (ctrl.deviceId === 0) {
                            //Switching between Imperial/Metric only if Airport Rainfall Station
                            if (ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 && ctrl.unit != ctrl.translation.text.INCHES_ABBRV) {
                                if (ctrl.unit.toLowerCase() == "mm") {
                                    for (var i = 0; i < data.length; i++) {
                                        //Convert to IN
                                        data[i].title1 = data[i].title1 * .0393701;
                                        //Round
                                        data[i].title1 = Math.round(data[i].title1 * 100) / 100;
                                    }
                                    ctrl.unit = ctrl.translation.text.INCHES_ABBRV;
                                } else if (ctrl.unit.toLowerCase() == "cm") {
                                    for (var _i = 0; _i < data.length; _i++) {
                                        //Convert to IN
                                        data[_i].title1 = data[_i].title1 * .393701;
                                        //Round
                                        data[_i].title1 = Math.round(data[_i].title1 * 100) / 100;
                                    }
                                    ctrl.unit = ctrl.translation.text.INCHES_ABBRV;
                                }
                            } else if (ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2 && (ctrl.unit.toLowerCase != ctrl.translation.text.MILLIMETER || ctrl.unit.toLowerCase != ctrl.translation.text.CENTIMETERS)) {

                                for (var _i2 = 0; _i2 < data.length; _i2++) {
                                    //Convert to CM
                                    if (ctrl.initialUnit == "" || ctrl.initialUnit == ctrl.translation.text.CENTIMETERS) {
                                        data[_i2].title1 = data[_i2].title1 * 2.54;
                                        ctrl.unit = ctrl.translation.text.CENTIMETERS;
                                    }
                                    //Convert to CM or MM
                                    else {
                                            data[_i2].title1 = data[_i2].title1 * 25.4;
                                            ctrl.unit = ctrl.translation.text.MILLIMETER;
                                        }
                                    //Round
                                    data[_i2].title1 = Math.round(data[_i2].title1 * 100) / 100;
                                }
                            }
                        }

                        ctrl.totalRain = 0;
                        ctrl.totalRuntime = 0;

                        for (var _i3 = 0; _i3 < data.length; _i3++) {
                            ctrl.totalRain += parseFloat(data[_i3].title1);
                            ctrl.totalRuntime += parseFloat(data[_i3].title2);
                            data[_i3].title = '<div style=\'color: #008ae6\'><i style=\'color: ' + (parseFloat(data[_i3].title1) > 0 ? '#76c7e7' : '#ff9247') + '; font-size:' + (ctrl.mobile ? '1em' : '1.5em') + '; margin-bottom: ' + (view.dayGrid.rowCnt > 5 ? '1px' : '5px;') + '; position: relative; top: ' + (ctrl.mobile ? '-3.8px' : '-6px') + ';\'/>  ' + parseFloat(data[_i3].title1) + ' ' + ctrl.unit + '</div>\n                                             <div style=\'color: #cc0000\'><i style=\'color: ' + (parseFloat(data[_i3].title2) > 0 ? '#76c7e7' : '#ff9247') + '; font-size:' + (ctrl.mobile ? '1em' : '') + '; margin-bottom: ' + (view.dayGrid.rowCnt > 5 ? '1px' : '5px;') + '; position: relative; top: ' + (ctrl.mobile ? '-5.1px' : '-6px') + ';\'/>  ' + parseFloat(data[_i3].title2) + ' ' + ctrl.runtimeScaleName + '</div>';
                            // data[i].textColor = '#000000';
                            data[_i3].className = 'rainfall-calendar';
                        }
                        _displayRainfallTotal();
                    });

                    $timeout(function () {
                        var clientEvents = ctrl._elm.fullCalendar('clientEvents');
                        for (var i = 0; i < clientEvents.length; i++) {
                            ctrl._elm.fullCalendar('removeEventSource', clientEvents[i].source);
                        }
                        ctrl._elm.fullCalendar('addEventSource', data);
                        ctrl.fullCalendar.fullCalendar('gotoDate', goToDate);
                        _displayRainfallTotal();
                    });

                    return true;
                }

                if (view.start !== $scope.startDateUnix) {
                    _disableButtons();

                    $scope.startDateUnix = view.start;

                    var d = view.intervalEnd;
                    var month = d.month() === 1 ? 0 : d.month() - 1;
                    var middledate = new Date(d.year(), month, 15);
                    if (new Date() < middledate) {
                        middledate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                    }
                    if (new Date().getMonth() == middledate.getMonth()) ctrl.todayMiddledate = angular.copy(middledate); //if middledate is in the same month as of today, deep copy current view for refreshing most recent data purpose
                    if (ctrl.reloadData) {
                        middledate = ctrl.todayMiddledate; //when refreshing most recent data, assign current month's view's value
                        ctrl.reloadData = false;
                    }
                    var middleUnix = datetimeService.dateToUnixtime(middledate);
                    var tmpDataMin = middleUnix - 24 * 3600 * 1000,
                        tmpDataMax = middleUnix + 48 * 3600 * 1000,
                        tmpZoomMin = middleUnix,
                        tmpZoomMax = middleUnix + 24 * 3600 * 1000;

                    sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: tmpDataMin, dataMax: tmpDataMax, zoomMin: tmpZoomMin, zoomMax: tmpZoomMax, windowId: $scope.windowId, deviceId: ctrl.deviceId });
                    ctrl.loadingRainfall = true;

                    middleUnix = new Date(middleUnix);
                    var first = new Date(middleUnix.getFullYear(), middleUnix.getMonth(), 1, 1);
                    var last = new Date(middleUnix.getFullYear(), middleUnix.getMonth() + 1, 1);
                    var start = datetimeService.dateToUnixtime(first);
                    var end = datetimeService.dateToUnixtime(last);
                    ctrl.currentDate = new Date(first);

                    var fetchDataResolvePromise = ctrl.runtimeRainfallCalendarFactory.fetchData(ctrl.accountInfo.customerId, ctrl.currentSelectedDevice.deviceId, ctrl.currentSelectedDevice.deviceType, start, end, ctrl.currentSelectedDevice.metarStationID, ctrl.currentSelectedDevice.rainfallSite);
                    var getRainfallUnitResolvePromise = getRainfallUnit(ctrl.currentSelectedDevice.rainfallSite);

                    $q.all([fetchDataResolvePromise, getRainfallUnitResolvePromise]).then(function () {
                        var data = ctrl.runtimeRainfallCalendarFactory.get();
                        if (ctrl.deviceId === 0) {
                            //Switching between Imperial/Metric only if Airport Rainfall Station
                            if (ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 && ctrl.unit != ctrl.translation.text.INCHES_ABBRV) {
                                if (ctrl.unit.toLowerCase() == "mm") {
                                    for (var i = 0; i < data.length; i++) {
                                        //Convert to IN
                                        data[i].title1 = data[i].title1 * .0393701;
                                        //Round
                                        data[i].title1 = Math.round(data[i].title1 * 100) / 100;
                                    }
                                    ctrl.unit = ctrl.translation.text.INCHES_ABBRV;
                                } else if (ctrl.unit.toLowerCase() == "cm") {
                                    for (var _i4 = 0; _i4 < data.length; _i4++) {
                                        //Convert to IN
                                        data[_i4].title1 = data[_i4].title1 * .393701;
                                        //Round
                                        data[_i4].title1 = Math.round(data[_i4].title1 * 100) / 100;
                                    }
                                    ctrl.unit = ctrl.translation.text.INCHES_ABBRV;
                                }
                            } else if (ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2 && (ctrl.unit.toLowerCase != ctrl.translation.text.MILLIMETER || ctrl.unit.toLowerCase != ctrl.translation.text.CENTIMETERS)) {

                                for (var _i5 = 0; _i5 < data.length; _i5++) {
                                    //Convert to CM
                                    if (ctrl.initialUnit == "" || ctrl.initialUnit == ctrl.translation.text.CENTIMETERS) {
                                        data[_i5].title1 = data[_i5].title1 * 2.54;
                                        ctrl.unit = ctrl.translation.text.CENTIMETERS;
                                    }
                                    //Convert to CM or MM
                                    else {
                                            data[_i5].title1 = data[_i5].title1 * 25.4;
                                            ctrl.unit = ctrl.translation.text.MILLIMETER;
                                        }
                                    //Round
                                    data[_i5].title1 = Math.round(data[_i5].title1 * 100) / 100;
                                }
                            }
                        }

                        ctrl.totalRain = 0;
                        ctrl.totalRuntime = 0;
                        for (var _i6 = 0; _i6 < data.length; _i6++) {
                            ctrl.totalRain += parseFloat(data[_i6].title1);
                            ctrl.totalRuntime += parseFloat(data[_i6].title2);
                            data[_i6].title = '<div style=\'color: #008ae6\'><i style=\'color: ' + (parseFloat(data[_i6].title1) > 0 ? '#76c7e7' : '#ff9247') + '; font-size:' + (ctrl.mobile ? '1em' : '1.5em') + '; margin-bottom: ' + (view.dayGrid.rowCnt > 5 ? '1px' : '5px;') + '; position: relative; top: ' + (ctrl.mobile ? '-3.8px' : '-6px') + ';\'/>  ' + parseFloat(data[_i6].title1) + ' ' + ctrl.unit + '</div>\n                                             <div style=\'color: #cc0000\'><i style=\'color: ' + (parseFloat(data[_i6].title2) > 0 ? '#76c7e7' : '#ff9247') + '; font-size:' + (ctrl.mobile ? '1em' : '') + '; margin-bottom: ' + (view.dayGrid.rowCnt > 5 ? '1px' : '5px;') + '; position: relative; top: ' + (ctrl.mobile ? '-5.1px' : '-6px') + ';\'/>  ' + parseFloat(data[_i6].title2) + ' ' + ctrl.runtimeScaleName + '</div>';
                            // data[i].textColor = '#000000';
                            data[_i6].className = 'rainfall-calendar';
                        }

                        $timeout(function () {
                            var clientEvents = ctrl._elm.fullCalendar('clientEvents');
                            for (var i = 0; i < clientEvents.length; i++) {
                                ctrl._elm.fullCalendar('removeEventSource', clientEvents[i].source);
                            }
                            ctrl._elm.fullCalendar('addEventSource', data);
                            ctrl.loadingRainfall = false;
                            _resize();
                            _enableButtons();
                            _displayRainfallTotal();
                        });
                    });
                }

                return true;
            },
            eventRender: function eventRender(event, element, view) {
                if (event.start._d.getUTCMonth() !== ctrl.fullCalendar.fullCalendar('getDate')._d.getUTCMonth()) {
                    return false;
                }
                element.find('span.fc-title').html(element.find('span.fc-title').text());
                return true;
            }
        });
    };

    var _resize = function _resize() {
        $timeout(function () {
            if (!ctrl.mobile && !ctrl.classicView) {
                ctrl.calendarHeight = ctrl._popup.outerHeight() - 59;
                ctrl._popup.find('.fc-time-grid').css('height', ctrl.calendarHeight / 6);
                ctrl._popup.find('.fc-slats td').css('height', ctrl.calendarHeight / 6);
            }
            ctrl.fullCalendar.fullCalendar('option', 'contentHeight', ctrl.calendarHeight - 26);
            ctrl.fullCalendar.fullCalendar('refresh');
        });
    };

    var updateFromDeviceChange = function updateFromDeviceChange(refresh) {
        if (ctrl._popup) {
            ctrl._popup.dialog('option', 'title', ctrl.translation.text.RAINFALL_VS_RUNTIME_CALENDAR + ", " + ctrl.currentSelectedDevice.deviceName);
        }

        if (!!ctrl.fullCalendar) {
            ctrl.fullCalendar.fullCalendar('destroy');
        }

        // ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        // if (typeof ctrl.stickyProperties != 'object') {
        //     ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        // }

        if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.zoomMin !== null) {
            ctrl.stickyProperties.on = true;
            var zoomDate = new Date(ctrl.stickyProperties.zoomMin);
            var firstDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth(), 1);
            var lastDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth() + 1, 0);
            $scope.startDateUnix = datetimeService.dateToUnixtime(firstDay);
            $scope.endDateUnix = datetimeService.dateToUnixtime(lastDay);
        } else {
            ctrl.stickyProperties.on = false;
        }

        ctrl.drawCalendar(refresh);
    };

    var _disableButtons = function _disableButtons() {
        $($element).find(".fc-prev-button").prop('disabled', true);
        $($element).find(".fc-prev-button").addClass('fc-state-disabled');
        $($element).find(".fc-next-button").prop('disabled', true);
        $($element).find(".fc-next-button").addClass('fc-state-disabled');
    };

    var _enableButtons = function _enableButtons() {
        $($element).find(".fc-prev-button").removeClass('fc-state-disabled');
        $($element).find(".fc-prev-button").prop('disabled', false);
        $($element).find(".fc-next-button").removeClass('fc-state-disabled');
        $($element).find(".fc-next-button").prop('disabled', false);
    };

    var _displayRainfallTotal = function _displayRainfallTotal() {

        var totalHtml = '<div><div id="rain">' + ctrl.translation.text.TOTAL + ": " + ctrl.totalRain.toFixed(2) + " " + ctrl.unit + '</div>' + '<div id="runtime">' + ctrl.translation.text.RUNTIME + ": " + ctrl.totalRuntime.toFixed(2) + " " + ctrl.runtimeScaleName + '</div> </div>';

        $($element).find(".fc-center").css("text-align", "center").css("font-weight", "bold").html(totalHtml);
    };

    ctrl.applyTimeFormat = function (timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat);
    };

    //Update the chart When user preference:$scope.drawChartMeasurementSystem is changed
    ctrl.applyMeasurementSystem = function (measurementSystem) {
        //following logic only applies for Airport Station (ie. deviceId == 0)
        if (ctrl.deviceId === 0) {
            var newRainfallUnit = ctrl.preferredRainfallUnit;
            var newTemperatureUnit = ctrl.preferredTemperatureUnit;
            switch (parseInt(measurementSystem)) {
                case ctrl.MeasurementSystemEnum.Imperial:
                    newRainfallUnit = ctrl.RainfallUnitEnum.Inches;
                    newTemperatureUnit = ctrl.TemperatureUnitEnum.Fahrenheit;
                    break;
                case ctrl.MeasurementSystemEnum.Metric:
                    newRainfallUnit = ctrl.RainfallUnitEnum.Centimeters;
                    newTemperatureUnit = ctrl.TemperatureUnitEnum.Celsius;
                    break;
            }

            if (typeof ctrl.SeriesData != 'undefined' && ctrl.SeriesData != null) {
                if (ctrl.SeriesData.length > 0) ctrl.ConvertRainfallSeriesMeasurementUnit(ctrl.SeriesData[ctrl.seriesIndex.Rain], ctrl.preferredRainfallUnit, newRainfallUnit);
                if (ctrl.SeriesData.length > 1) ctrl.ConvertTemperatureSeriesMeasurementUnit(ctrl.SeriesData[ctrl.seriesIndex.Temp], ctrl.preferredTemperatureUnit, newTemperatureUnit);
            }

            ctrl.preferredRainfallUnit = newRainfallUnit;
            ctrl.preferredTemperatureUnit = newTemperatureUnit;
        }
    };
}

RuntimeRainfallCalendarController.$inject = ['$scope', '$q', 'sharedSetupService', 'openViewService', 'translationService', '$element', 'authenticationService', '$rootScope', '$timeout', 'runtimeRainfallCalendarFactory', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster'];
'use strict';

angular.module('mc.rainfall').component('runtimeRainfallCalendar', {
    controller: RuntimeRainfallCalendarController,
    templateUrl: 'ui/rainfall/runtimeCalendar/runtime-rainfall-calendar-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
angular.module("mc.cumulative-flow-reading", []);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function CumulativeFlowReadingController($, $rootScope, $scope, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, $timeout, $element, cumulativeFlowReadingService, deviceMenuService, toaster) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    ctrl.popup = null;
    ctrl.device = null;
    $scope.alerts = [];
    ctrl.deviceList = [];
    ctrl.downloadViewTypeOptions = [0];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.windowSubtitle = "Loading...";
        ctrl.loadingInProgress = true;
        if (_typeof($scope.stickyProperties) != 'object') $scope.stickyProperties = sharedSetupService.stickyPropertiesInterface;

        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        $scope.alerts = [];

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    //openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    //openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        }

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            if ($scope.alerts.length > 0) {
                var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });

        //Clean up when dialog is closed
        $scope.$on("$destroy", function () {
            ctrl.items = null;
        });
    };

    // Listen to Device change
    ctrl.setDevice = function (currentDevice) {
        // If we didn't get any items back 
        if (!currentDevice) {
            var errorMessage = ctrl.translation.text.NO_DATA;
            ctrl.loadingInProgress = false;
            $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            return;
        }

        ctrl.currentSelectedDevice = currentDevice;
        ctrl.deviceId = currentDevice.deviceId;
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.popup.dialog("option", "title", ctrl.translation.text.CUMULATIVE_FLOW_READING + ", " + currentDevice.name);
        }

        $scope.deviceId = ctrl.deviceId;
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceId, windowId: ctrl.windowId });

        ctrl.loadingInProgress = true;
        ctrl.getCumulativeFlowReading(ctrl.deviceId);
    };

    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('.cumulative-flow-reading-template').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 25); //25: total padding
            //ctrl.adjustDeviceIdMenuSize();
        }
    };

    ctrl.mostRecentData = function () {
        toaster.pop('success', "Cumulative Flow Reading" + "--" + ctrl.currentSelectedDevice.name, 'View reloading');
        ctrl.getCumulativeFlowReading(ctrl.deviceId);
    };

    //Get Data and load
    ctrl.getCumulativeFlowReading = function (varDeviceId) {
        if (ctrl.accountInfo === null || varDeviceId === null) return;
        if (ctrl.loadingInProgress == false) {
            ctrl.loadingInProgress = true;
            ctrl.items = [];
        }

        cumulativeFlowReadingService.getData(ctrl.accountInfo.customerId, varDeviceId, ctrl.accountInfo.timeZone).then(function (dataFromFactory) {
            $scope.alerts = [];
            ctrl.items = dataFromFactory.data;

            // If we didn't get any items back 
            if (ctrl.items.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        }, function (error) {
            //error
        }).then(function (data) {
            ctrl.loadingInProgress = false;
            //$scope.setLoadingInProgress(false);
        });
    };

    //dateAgentText filter called from html
    ctrl.dateAgentText = function (date, timeFormat) {
        return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
    };

    ctrl.getBackgroundColor = function (indexValue) {
        switch (indexValue) {
            case 0:
                return '#2288cc;';
            case 1:
                return '#dd3322;;';
            case 2:
                return '#22aa99;';
            case 3:
                return '#bb4488;';
            case 4:
                return '#ddaa00;';
            case 5:
                return '#77b300;';
            default:
                return '#2288cc;';
        }

        if (scope.series[indexValue].color) {
            return scope.series[indexValue].color;
        } else {
            return false;
        }
    };
}

CumulativeFlowReadingController.$inject = ['$', '$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', '$timeout', '$element', 'cumulativeFlowReadingService', 'deviceMenuService', 'toaster'];

mcapp.factory('cumulativeFlowReadingService', ['$http', 'REPORTS', function ($http, REPORTS) {
    var cumulativeFlowReadingFactory = {};

    var _getData = function _getData(customerId, deviceId, timeZone) {
        return $http({
            method: 'Get',
            url: REPORTS + '/api/CumulativeFlowReading?customerId=' + customerId + '&deviceId=' + deviceId + '&timeZone=' + timeZone,
            cache: false
        });
    };

    cumulativeFlowReadingFactory.getData = _getData;

    return cumulativeFlowReadingFactory;
}]);
'use strict';

angular.module('mc.cumulative-flow-reading').component('cumulativeFlowReading', {
    controller: CumulativeFlowReadingController,
    templateUrl: 'ui/reports/cumulativeflowreading/cumulative-flow-reading-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function CumulativeFlowDevicesMenuController($, $scope, authenticationService, translationService, Rainfall, deviceMenuService, sharedSetupService) {
    var _this = this;

    var ctrl = this;
    this.$onInit = function () {
        _this.translation = translationService.translation;
        _this.windowId = _this.windowId;
        $scope.windowId = _this.windowId;
        _this.accountInfo = authenticationService.getAccountInfo();
        deviceMenuService.resetDeviceMenuList(); //clear the list before making call.

        deviceMenuService.getDeviceMenuList(_this.accountInfo.customerId).then(function (result) {
            ctrl.devices = [];

            angular.forEach(result.data.devices, function (value, key) {
                if (value.hasCumulativeFlow === null || value.hasCumulativeFlow) ctrl.devices.push(value);
            });

            if (_typeof($scope.stickyProperties) != 'object') $scope.stickyProperties = sharedSetupService.stickyPropertiesInterface;

            if (ctrl.devices.length > 0) {
                ctrl.currentSelectedDevice = ctrl.devices[0];
            }
            if (ctrl.devices.length > 0 && !$scope.stickyProperties.deviceId) {
                $scope.deviceId = ctrl.currentSelectedDevice.deviceId;
            } else if (!!$scope.stickyProperties.deviceId) {
                $scope.deviceId = $scope.stickyProperties.deviceId;
                for (var idx = 0; idx < ctrl.devices.length; idx++) {
                    if (ctrl.devices[idx].deviceId == $scope.deviceId) {
                        ctrl.currentSelectedDevice = ctrl.devices[idx];
                    }
                }
            }
            ctrl.callback(ctrl.currentSelectedDevice);
        }, function (error) {
            console.log(error);
        });
    };
}

CumulativeFlowDevicesMenuController.$inject = ['$', '$scope', 'authenticationService', 'translationService', 'rainfallModel', 'deviceMenuService', 'sharedSetupService'];

mcapp.component('cumulativeFlowDevicesMenu', {
    controller: CumulativeFlowDevicesMenuController,
    transclude: true,
    templateUrl: 'ui/reports/cumulativeflowreading/cumulative-flow-devices-menu.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<',
        callback: '='
    }
});
'use strict';

function RelayAlarmDescriptionsController(_, $, HOST, $http, $rootScope, $timeout, $scope, $sce, authenticationService, datetimeService, timeLapseService, translationService, toaster, deviceMenuService) {
    var _this = this;

    this.$onInit = function () {
        _this._ = _;
        _this.accountInfo = authenticationService.getAccountInfo();
        _this.langId = _this.accountInfo.preferenceUser.i18nCode === 'fr' ? _this.accountInfo.preferenceUser.i18nCode : 'en';
        _this.translation = translationService.translation;
        _this.alerts = [];
        $scope.alerts = [];
        _this.loading = true;
        // Sort of like enums. Allow me to loop through all the description fields without repeating myself
        // TODO: If we ever add support for additional languages in the DB this will need to be updated as well.
        _this.supportedLanguages = ['en', 'fr'];
        _this.descriptionFields = ['normal', 'offNormal', 'tamper'];
        _this.disableChannel1 = false; //if it is M84 with SkuId = 2 (MM+ with SkuId = L), device type or Model = 20

        timeLapseService.getLocalDateTime().then(function (resp) {
            _this.currentTime = moment(resp.data.localDateTime).valueOf();
        });

        _this.currentDevice = _this.deviceId;
        $http.get(HOST + '/api/RelayAlarmDescription?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId).then(function (resp) {
            _this.loading = false;
            _this.relayAlarmsEnabled = resp.data.relayAlarmsEnabled;
            _this.relayAlarmDescriptions = resp.data.relayAlarmDescriptions;
        }, function (resp) {
            console.log(resp.data);
        });

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            _this.langId = langId === 'fr' ? langId : 'en';
        });

        //Log tab access event to NLog
        _this.postUserAction2Nlog(_this.accountInfo.customerId, _this.deviceId).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        //disabling all the elements under readonly group to prevent from tab order
        $timeout(function () {
            $(".data-read-only-digital-descriptions").find("*").prop("disabled", true);
        }, 5000);
    };

    this.updateRelayAlarmEnableStatus = function () {
        var _this2 = this;

        $http.put(HOST + '/api/RelayAlarmDescription?customerId=' + this.accountInfo.customerId + '&deviceId=' + this.deviceId + '&relayAlarmEnableStatus=' + this.relayAlarmsEnabled).then(function (resp) {}, function (resp) {
            toaster.pop('error', _this2.translation.text.RTU_CONFIGURATION, resp.data);
        });
    };

    this.isDescriptionValid = function (description) {
        if (description === null || description === undefined || description.length === 0) {
            return false;
        }
        return true;
    };

    this.storeCurrentDescription = function (description) {
        this.storedFieldValue = description;
    };

    this.saveRelayAlarmDescription = function (relayAlarmDescription, isTtsDescription) {
        var _this3 = this;

        var description = isTtsDescription ? relayAlarmDescription.ttsDescription : relayAlarmDescription.description;
        // Only perform a save if the description in question is valid                        
        if (this.isDescriptionValid(description)) {
            if (description !== this.storedFieldValue) {
                $http.put(HOST + '/api/RelayAlarmDescription?customerId=' + this.accountInfo.customerId + '&deviceId=' + this.deviceId + '&state=' + relayAlarmDescription.state + '&input=' + relayAlarmDescription.input + '&languageId=' + relayAlarmDescription.langID + '&entryType=' + 2 + '&description=' + relayAlarmDescription.description + '&ttsDescription=' + relayAlarmDescription.ttsDescription + '&isTtsDescription=' + isTtsDescription).then(function (resp) {
                    if (resp.data !== 1) {
                        toaster.pop('error', _this3.translation.text.RTU_CONFIGURATION, _this3.translation.text.ERROR_REOPEN_WINDOW);
                    }
                }, function (resp) {
                    toaster.pop('error', _this3.translation.text.RTU_CONFIGURATION, resp.data);
                });
            }
        }
    };

    this.isAdmin = function () {
        return _this.accountInfo.userRole === 'Administrator' || _this.accountInfo.userRole === 'SuperAdministrator';
    };

    this.getDeviceType = function (deviceId) {
        deviceMenuService.getDeviceMenuList(_this.accountInfo.customerId).then(function (result) {
            var _devices = result.data.devices;

            for (var index = 0; index < _devices.length; ++index) {
                if (_devices[index].deviceId === deviceId) {
                    _this.device.type = _devices[index].model;
                    if (_this.device.type == 20) {
                        //M84/MM+ device
                        _this.descriptionFields.splice(2, 1);
                        if (_devices[index].skuId == 2) _this.disableChannel1 = true; // disable channel 1 from configuring on UI, it is ReadOnly
                    }
                    break;
                }
            }
        }, function (error) {
            console.log("device type error");
        });
    };

    this.postUserAction2Nlog = function (customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Relay Alarm Descriptions";

        return $http({
            method: 'POST',
            url: HOST + '/api/RelayAlarmDescription',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    this.$onDestroy = function () {};
}

RelayAlarmDescriptionsController.$inject = ['_', '$', 'HOST', '$http', '$rootScope', '$timeout', '$scope', '$sce', 'authenticationService', 'datetimeService', 'timeLapseService', 'translationService', 'toaster', 'deviceMenuService'];
'use strict';

angular.module('mc.rtu-configuration', []);
'use strict';

angular.module('mc.rtu-configuration').component('relayAlarmDescriptions', {
    controller: RelayAlarmDescriptionsController,
    transclude: true,
    templateUrl: 'ui/rtuconfiguration/relayalarmdescriptions/relay-alarm-descriptions-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        deviceId: '<',
        deviceName: '<',
        deviceTypeId: '<'
    }
});
'use strict';

angular.module('mc.pulseflow', []);
"use strict";

function PulseFlowMultiDayReportFactory(REPORTS, $http) {
    var PulseFlowMultiDayReport = function PulseFlowMultiDayReport(customerId, startDate, endDate, timeZone) {
        this.customerId = customerId;
        this.startDate = startDate;
        this.endDate = endDate;
        this.timeZone = timeZone;
    };

    PulseFlowMultiDayReport.prototype.getData = function () {
        var self = this;
        return $http.get(REPORTS + "/api/Reports/GetPulseFlowMultiDayReportByDateRange" + "?customerId=" + this.customerId + "&startDate=" + this.startDate + "&endDate=" + this.endDate + "&timeZone=" + this.timeZone).then(function (response) {
            self.data = response.data;
            return response;
        });
    };

    return PulseFlowMultiDayReport;
}

PulseFlowMultiDayReportFactory.$inject = ['REPORTS', '$http'];

angular.module('mc.pulseflow').factory('PulseFlowMultiDayReportFactory', PulseFlowMultiDayReportFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function PulseFlowMultiDayReportController($, $rootScope, $scope, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, PulseFlowMultiDayReportFactory, $timeout, $filter, $element, savePulseflowMultiDayPdfService, toaster) {
    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.isRefresh = false;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.downloadViewTypeOptions = [0, 1, 2];

        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        ctrl.goSelectReportData();
        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };
    ctrl.mostRecentData = function () {
        ctrl.isRefresh = true;
        ctrl.myDate == null;
        toaster.pop('success', ctrl.windowTitle, 'View reloading');
        ctrl.pulseFlowMultiDayReport.loading = true;
        ctrl.goSelectReportData();
    };

    ctrl.selectMyDate = function () {
        ctrl.goSelectReportData(true);
        return;
    };
    ctrl.goSelectReportData = function (varClick) {

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }

        var numberOfDays = 3,
            dateRangeStart = void 0,
            dateRangeEnd = void 0,
            dateRangeStartUnix = void 0,
            dateRangeEndUnix = void 0;
        if (ctrl.stickyProperties.on === true) {
            ctrl.stickyProperties.on = false;
            dateRangeStartUnix = ctrl.stickyProperties.dateMin;
            dateRangeEndUnix = ctrl.stickyProperties.dateMax;
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            dateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            dateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();

            dateRangeStartUnix = dateRangeStart.getTime();
            dateRangeEndUnix = dateRangeEnd.getTime();
        } else {
            dateRangeStart = new Date();
            dateRangeStart.setDate(dateRangeStart.getDate() - numberOfDays);
            dateRangeStartUnix = dateRangeStart.setHours(0, 0, 0, 0);

            dateRangeEnd = new Date();
            dateRangeEndUnix = dateRangeEnd.setHours(23, 59, 59, 999);
        }
        if (ctrl.isRefresh) {
            dateRangeStart = new Date();
            dateRangeStart.setDate(dateRangeStart.getDate() - numberOfDays);
            dateRangeStartUnix = dateRangeStart.setHours(0, 0, 0, 0);

            dateRangeEnd = new Date();
            dateRangeEndUnix = dateRangeEnd.setHours(23, 59, 59, 999);
        }
        if ((ctrl.mobile || ctrl.classicView) && !(new Date(dateRangeStartUnix).getTime() > 0 && new Date(dateRangeEndUnix).getTime() > 0)) {
            var tmpDates = sharedSetupService.getLiveDates();
            dateRangeStartUnix = tmpDates.startDate;
            dateRangeEndUnix = tmpDates.endDate;
        }
        dateRangeStart = new Date(dateRangeStartUnix);
        dateRangeEnd = new Date(dateRangeEndUnix);

        var currentDate = new Date(Date.now());
        if (dateRangeEnd > currentDate) dateRangeEnd = currentDate;

        ctrl.myDateRangeStart = ctrl.viewStDate = dateRangeStart;
        ctrl.myDateRangeEnd = ctrl.viewEndDate = dateRangeEnd;

        dateRangeEndUnix = dateRangeEnd.getTime();
        ctrl.pulseFlowMultiDayReport = new PulseFlowMultiDayReportFactory(ctrl.accountInfo.customerId, dateRangeStartUnix, dateRangeEndUnix, ctrl.accountInfo.timeZone);
        ctrl.pulseFlowMultiDayReport.loading = true;
        ctrl.pulseFlowMultiDayReport.getData().then(function () {
            ctrl.pulseFlowMultiDayReport.loading = false;
        });
    };

    ctrl.savePdf = function () {
        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");

        var drawCell = function drawCell(row, data) {
            if (typeof data.row.raw[1] == "undefined") {
                data.doc.setFillColor(226, 239, 248);
            }
        };

        if (ctrl.timeFormat == 1) {
            var pdfParams = {
                windowTitle: windowTitle,
                pdfTitle: eval("ctrl.translation.text." + windowTitle) + (" (" + moment(ctrl.viewStDate).format("MMMM D, YYYY h:mm a") + " - " + moment(ctrl.viewEndDate).format("MMMM D, YYYY h:mm a") + ")"),
                customerName: ctrl.accountInfo.customerName,
                customerId: ctrl.accountInfo.customerId,
                dateTranslate: ctrl.translation.text.DATE_CREATED,
                dateRangeStart: $scope.myDateRangeStart,
                dateRangeEnd: $scope.myDateRangeEnd,
                $scope: $scope,
                $element: $element,
                drawCell: drawCell
            };
        } else {
            var pdfParams = {
                windowTitle: windowTitle,
                pdfTitle: eval("ctrl.translation.text." + windowTitle) + (" (" + moment(ctrl.viewStDate).format("MMMM D, YYYY HH:mm") + " - " + moment(ctrl.viewEndDate).format("MMMM D, YYYY HH:mm") + ")"),
                customerName: ctrl.accountInfo.customerName,
                customerId: ctrl.accountInfo.customerId,
                dateTranslate: ctrl.translation.text.DATE_CREATED,
                dateRangeStart: $scope.myDateRangeStart,
                dateRangeEnd: $scope.myDateRangeEnd,
                $scope: $scope,
                $element: $element,
                drawCell: drawCell
            };
        }

        savePulseflowMultiDayPdfService.savePDF(pdfParams);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
    });
}
PulseFlowMultiDayReportController.$inject = ['$', '$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'PulseFlowMultiDayReportFactory', '$timeout', '$filter', '$element', 'savePulseflowMultiDayPdfService', 'toaster'];
'use strict';

angular.module('mc.pulseflow').component('pulseFlowMultiDayReport', {
    controller: PulseFlowMultiDayReportController,
    templateUrl: 'ui/pulseflow/pulseflowmultidayreport/pulseflow-multi-day-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.widget-pump-station-display", []);
"use strict";

function McWidgetPumpStationDisplayController($, $timeout, $rootScope, $scope, $element, debounceService, $compile, websocketService, toaster, datetimeService, sharedSetupService, McPumpStationWidgetFactory, authenticationService, translationService, PopupFactory, detectBrowserService, McWidgetsSharedFactory, $filter, openViewService, $interval) {

    var ctrl = this;

    ctrl.timestamp_DisplayStyle = { "font-size": '16px' };
    ctrl.unit_DisplayStyle = { "font-size": '25px' };
    ctrl.inputStatusStyle = { "font-size": '24px' };

    ctrl.waterLevelUp = false;

    ctrl.validateFloatChannel = true;

    var deviceStateEnum = {
        Ok: 1,
        Alarm: 2,
        Offline: 3,
        Service: 4,
        Disabled: 5
    };

    ctrl.waterLevelTypeEnum = {
        Default: 'Default',
        Digital: 'Digital',
        Analog: 'Analog',
        Both: 'Both'
    };

    ctrl.minY = 119; //359;
    ctrl.minHeight = 267; //38;
    ctrl.svgSizeW = "380";
    ctrl.svgSizeH = "460";

    ctrl.buildAnalogLevel = function () {

        if (!ctrl.hasAnalogChannel) return;

        var minY = 386; //minY is starting position for minHeight = 0
        var minHeight = 0; //when minHeight goes up minY goes down
        var maxHeight = 267; //minHeight to maxHeight is the range of the tanks

        var analogLatestData = ctrl.widgetSetting.analogSetting.latestData;
        var numberOfDecimals = sharedSetupService.getNumberOfDecimals(ctrl.widgetSetting.analogSetting.maxVal, ctrl.widgetSetting.analogSetting.minVal);
        ctrl.analogLatestData = parseFloat(analogLatestData).toFixed(numberOfDecimals);

        ctrl.analogUnit = ctrl.widgetSetting.analogSetting.unit;

        ctrl.analogMinValY = 400; //min valu display position, see dry-well-level-markers on HTML template
        ctrl.analogMaxValY = 133; //max valu display position, see dry-well-level-markers on HTML template

        var analogGaugeSetting = ctrl.widgetSetting.analogGaugeSetting;
        var gaugeMinValue = Number(analogGaugeSetting.gaugeMinValue) || 0;
        var gaugeMaxValue = Number(analogGaugeSetting.gaugeMaxValue) || 0;

        ctrl.analogMinVal = gaugeMinValue !== 0 ? gaugeMinValue : ctrl.widgetSetting.analogSetting.minVal;
        ctrl.analogMaxVal = gaugeMaxValue !== 0 ? gaugeMaxValue : ctrl.widgetSetting.analogSetting.maxVal;

        var rangeMin = Math.min(ctrl.analogMinVal, ctrl.analogMaxVal);
        var rangeMax = Math.max(ctrl.analogMinVal, ctrl.analogMaxVal);

        var getValueInRange = function getValueInRange(value) {
            return value >= rangeMin && value <= rangeMax ? value : 0;
        };

        // Calling getValueInRange to ensure that the alarm and restore values are within the range of min and max values
        ctrl.analogLowAlarm = getValueInRange(ctrl.widgetSetting.analogSetting.lowAlarm);
        ctrl.analogLowRestore = getValueInRange(ctrl.widgetSetting.analogSetting.lowRestore);
        ctrl.analogHighRestore = getValueInRange(ctrl.widgetSetting.analogSetting.highRestore);
        ctrl.analogHighAlarm = getValueInRange(ctrl.widgetSetting.analogSetting.highAlarm);

        // If either Low Alarm or Low Restore is 0, make both 0
        if (ctrl.analogLowAlarm === 0 || ctrl.analogLowRestore === 0) {
            ctrl.analogLowAlarm = 0;
            ctrl.analogLowRestore = 0;
        }

        // If either High Restore or High Alarm is 0, make both 0
        if (ctrl.analogHighRestore === 0 || ctrl.analogHighAlarm === 0) {
            ctrl.analogHighRestore = 0;
            ctrl.analogHighAlarm = 0;
        }

        var analogLowAlarmPerc = ctrl.calcScale(ctrl.analogMinVal, ctrl.analogMaxVal, ctrl.analogLowAlarm);
        ctrl.analogLowAlarmY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * analogLowAlarmPerc / 100;

        var analogLowRestorePerc = ctrl.calcScale(ctrl.analogMinVal, ctrl.analogMaxVal, ctrl.analogLowRestore);
        ctrl.analogLowRestoreY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * analogLowRestorePerc / 100;

        var analogHighRestorePerc = ctrl.calcScale(ctrl.analogMinVal, ctrl.analogMaxVal, ctrl.analogHighRestore);
        ctrl.analogHighRestoreY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * analogHighRestorePerc / 100;

        var analogHighAlarmPerc = ctrl.calcScale(ctrl.analogMinVal, ctrl.analogMaxVal, ctrl.analogHighAlarm);
        ctrl.analogHighAlarmY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * analogHighAlarmPerc / 100;

        var curentValuePerc = ctrl.calcScale(ctrl.widgetSetting.analogSetting.minVal, ctrl.widgetSetting.analogSetting.maxVal, ctrl.widgetSetting.analogSetting.latestData);
        var currentValue = maxHeight * curentValuePerc / 100;

        ctrl.minY = minY - currentValue;
        ctrl.minHeight = minHeight + currentValue;
    };

    ctrl.difference = function (a, b) {
        return Math.abs(a - b);
    };

    ctrl.calcScale = function (g_min, g_max, g_numb) {
        var calc_minmaxDiff = ctrl.difference(g_min, g_max); // Calculate diference between min and max
        var calc_minnumbDiff = ctrl.difference(g_min, g_numb); // Calculate diference between min and number
        var calc_numbPerc = calc_minnumbDiff / calc_minmaxDiff * 100;
        return calc_numbPerc;
    };

    var getState = function getState(state) {
        //Options: AllNormal, Alarm, Alert, Service, CommFail
        switch (state) {
            case deviceStateEnum.Ok:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
            //case deviceStateEnum.Disabled:
            //    return "Disabled";
            case deviceStateEnum.Offline:
                //device.CommsFault
                ctrl.orbitTitle = ctrl.translation.text.COMM_FAIL;
                return "CommFail";
            case deviceStateEnum.Service:
                ctrl.orbitTitle = ctrl.translation.text.SERVICE_MODE;
                return "Service";
            case deviceStateEnum.Alarm:
                ctrl.orbitTitle = null; //ctrl.translation.text.ALARM;
                return "Alarm";
            default:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
        }
    };

    var getView = function getView(state) {
        switch (state) {
            case deviceStateEnum.Service:
                return "RTU Configuration"; //"Service";
            case deviceStateEnum.Alarm:
                return "Dashboard"; //"Alarm";
            default:
                return "Dashboard"; //"AllNormal";
        }
    };

    ctrl.$onInit = function () {
        ctrl.mobile = $rootScope.mobile;
        ctrl.displaySettingOn = ctrl.settingShow;

        if (angular.isUndefined(ctrl.accountInfo)) {
            ctrl.accountInfo = authenticationService.getAccountInfo();
            ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        }
        if (angular.isUndefined(ctrl.popupWindow)) {
            ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
            ctrl.getPopupWindowDateTimeDifference = debounceService(ctrl.popupWindow.datetime_difference, 200, false);
        }
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
    };

    ctrl.pwMouseEnter = function (event, pumpOrderNumber) {
        //if (!angular.isUndefined(ctrl.widgetSetting) && ctrl.hideHudElements) {
        if (!angular.isUndefined(ctrl.widgetSetting)) {

            var displayPumpTimestamp = ctrl.displayPumpTimestamp(ctrl.widgetSetting.pumpStationGauge[pumpOrderNumber - 1].pump.channel);

            var _hudObj = {
                inputStatus: ctrl.getInputStatus(ctrl.widgetSetting.pumpStationGauge[pumpOrderNumber - 1].pump),
                timeStampA: displayPumpTimestamp.lineOne,
                timeStampB: displayPumpTimestamp.lineTwo,
                theme: angular.isUndefined(ctrl.themeIdOverridePopupOnly) ? ctrl.widgetSetting.pumpStationSetting.theme : ctrl.themeIdOverridePopupOnly
            };

            ctrl.popupWindow.getWidgetStatusTooltip(ctrl.widgetSetting, event, angular.isUndefined(ctrl.additionalSize) ? -120 : ctrl.additionalSize - 5, _hudObj);
        }
    };

    ctrl.pwMouseLeave = function (event) {
        //if (!angular.isUndefined(ctrl.widgetSetting) && ctrl.hideHudElements)
        if (!angular.isUndefined(ctrl.widgetSetting)) ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.pwMouseEnterAlarm = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.getTooltip(ctrl.widgetSetting.device.deviceId, event, 20);
    };

    ctrl.pwMouseLeaveAlarm = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.getInputStatus = function (_pump) {
        switch (ctrl.widgetSetting.deviceDigitalData["d" + _pump.channel]) {
            case "True":
                if (_pump.normalClosed === 0) {
                    return ctrl.translation.text.STOPPED;
                } else {
                    return ctrl.translation.text.RUNNING;
                }

            case "False":
                if (_pump.normalClosed === 0) {
                    return ctrl.translation.text.RUNNING;
                } else {
                    return ctrl.translation.text.STOPPED;
                }

            case "NULL":
            case "Fault":
                return ctrl.translation.text.FAULT;
        }
    };

    ctrl.$onChanges = function (changes) {

        if (!angular.isUndefined(changes.widgetSetting) && changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            $scope.alerts = [];
            if (angular.isUndefined(ctrl.accountInfo)) {
                ctrl.accountInfo = authenticationService.getAccountInfo();
                ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
            }
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            ctrl.curentBrowser = detectBrowserService();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            if (angular.isUndefined(ctrl.popupWindow)) {
                ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
                ctrl.getPopupWindowDateTimeDifference = debounceService(ctrl.popupWindow.datetime_difference, 200, false);
            }

            if (!angular.isUndefined(changes.widgetSetting.previousValue) && !angular.isUndefined(changes.widgetSetting.previousValue.device)) {
                ctrl.unRegisterListenerListDeviceState(changes.widgetSetting.previousValue.device.serialNumber);
                ctrl.unRegisterListenerAnalogData(changes.widgetSetting.previousValue.device.serialNumber);
            }

            ////////////////////////////////////////////////////////////////////////////////////
            ctrl.pumpStationWidgetId = changes.widgetSetting.currentValue.pumpStationWidgetId;
            ctrl.pumpStationType = changes.widgetSetting.currentValue.pumpStationType;
            ////////////////////////////////////////////////////////////////////////////////////

            ctrl.numberOfPumps = angular.isUndefined(changes.widgetSetting.currentValue) || angular.isUndefined(changes.widgetSetting.currentValue.pumpStationGauge) ? 0 : changes.widgetSetting.currentValue.pumpStationGauge.length;

            ctrl.deviceDigitalData = angular.isUndefined(changes.widgetSetting.currentValue) || changes.widgetSetting.currentValue.deviceDigitalData != null ? true : false;

            if (ctrl.numberOfPumps > 0 && ctrl.deviceDigitalData) {
                ctrl.validateFloatChannel = true;
                ctrl.buildWidget(changes.widgetSetting.currentValue);
            } else if (ctrl.numberOfPumps === 0) {
                $scope.alerts.push({ msg: ctrl.translation.text.NO_PUMPS, type: "danger" });
            } else {
                ctrl.numberOfPumps = 0;
                $scope.alerts.push({ msg: ctrl.translation.text.NO_DATA, type: "info" });
            }
        }
    };

    ctrl.wsListDeviceStateMsgReceived = function (data) {
        ctrl.widgetSetting.deviceUnitState.state = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).state;
        ctrl.widgetSetting.deviceUnitState.acFail = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).acFail;
        ctrl.widgetSetting.deviceUnitState.lastTimeHeardUtc = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).lastTimeHeardUtc;
        ctrl.fnRtuStatusOptions(getState(ctrl.widgetSetting.deviceUnitState.state));
    };

    var _setTimeOut = function _setTimeOut() {
        $timeout(function () {
            ctrl.liveUpdateItem = null;
            ctrl.liveUpdated = null;
            ctrl.liveMessage = null;
        }, 20000); // 20 Seconds
    };

    ctrl.wsDataReceivedANALOG = function (data) {
        if (data.SN == ctrl.widgetSetting.device.serialNumber && ctrl.widgetSetting.pumpStationSetting.analogChannel == data.CH) {
            var numberOfDecimals = sharedSetupService.getNumberOfDecimals(ctrl.analogMaxVal, ctrl.analogMinVal);
            ctrl.widgetSetting.analogSetting.latestData = parseFloat(data.Value).toFixed(numberOfDecimals);
            ctrl.buildMainClass();
        }
    };

    ctrl.registerListenerListDeviceState = function (varSerialNum) {
        //subscribe for digital setting changes
        websocketService.connect();
        websocketService.register('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.startOverview();
    };

    ctrl.unRegisterListenerListDeviceState = function (varSerialNum) {
        websocketService.connect();
        websocketService.unRegister('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.stopOverview();
    };

    ctrl.registerListenerAnalogData = function (varSerialNum) {
        //subscribe for digital setting changes
        if (ctrl.widgetSetting.pumpStationSetting.analogChannel > 0) {
            websocketService.connect();
            websocketService.register("ANALOG", varSerialNum, ctrl.widgetSetting.pumpStationSetting.analogChannel, ctrl.wsDataReceivedANALOG, null);
        }
    };

    ctrl.unRegisterListenerAnalogData = function (varSerialNum) {
        if (ctrl.widgetSetting.pumpStationSetting.analogChannel > 0) {
            websocketService.connect();
            websocketService.unRegister("ANALOG", varSerialNum, ctrl.widgetSetting.pumpStationSetting.analogChannel, ctrl.wsDataReceivedANALOG, null);
        }
    };

    var _validateFloatChannel = function _validateFloatChannel() {
        if (!ctrl.validateFloatChannel) return;
        if (ctrl.widgetSetting.pumpStationSetting.digitalChannel > 0) if (!ctrl.widgetSetting.floatSettings.some(function (item) {
            return item.channel === ctrl.widgetSetting.pumpStationSetting.digitalChannel;
        })) ctrl.widgetSetting.pumpStationSetting.digitalChannel = 0;
        ctrl.validateFloatChannel = false;
    };

    ctrl.buildWidget = function (widgetData) {

        ctrl.widgetSetting = widgetData;

        _validateFloatChannel();

        //var _pumpStationGauge = ctrl.widgetSetting.pumpStationGauge; //ctrl.widgetSetting.pumpStationGauge[0].pumpStationGauge

        ctrl.registerListenerListDeviceState(ctrl.widgetSetting.device.serialNumber);
        ctrl.registerListenerAnalogData(ctrl.widgetSetting.device.serialNumber);

        ctrl.hudText = getState(ctrl.widgetSetting.deviceUnitState.state); // Options: AllNormal, Alarm, Alert, Service, CommFail

        ctrl.w_BorderWidth = 2; // Set the inside solid border of the HUD
        ctrl.w_BorderPadding = 5; // Set the outside opaque border outline

        ctrl.DisplayTimestamp();
        ctrl.setSize(_returnSizeId());
        ctrl.hudInfoId = ctrl.widgetSetting.pumpStationSetting.hudInfo;

        ctrl.buildMainClass();

        if (ctrl.widgetSetting.setting.displaySettingOn) {
            var newScope = $scope;
            var html = '<mc-widget-pump-station-setting widget-setting="$ctrl.widgetSetting" ng-if="$ctrl.widgetSetting.setting.displaySetting" change-display-options="$ctrl.fnChangeDisplayOptions(settingOptions)"></mc-widget-pump-station-setting>';
            var element = $element.find('.component-setting');
            if (element.is(':empty')) {
                element.append($compile(html)(newScope));
            }
        }

        ctrl.fnSizeOptions();
        ctrl.loadingInProgress = false;
    };

    ctrl.getData = function (deviceId, openSetting) {

        var _pumpStationGauge = new McPumpStationWidgetFactory(ctrl.accountInfo.customerId, deviceId, 6, ctrl.mcWidgetsSharedFactory.getWidgetIdByPumpStationType(ctrl.pumpStationType), ctrl.accountInfo.timeZone);

        _pumpStationGauge.getWidgetData().then(function () {
            ctrl.loadingInProgress = false;

            var device = _pumpStationGauge.list.device;
            var deviceUnitState = _pumpStationGauge.list.deviceUnitState;
            var deviceDigitalData = _pumpStationGauge.list.digitalData;
            var enteredStateTime = _pumpStationGauge.list.enteredStateTime;
            var floatSettings = _pumpStationGauge.list.floatSettings;
            var pumpStationGauge = _pumpStationGauge.list.pumpStationGauge;
            var pumpStationSetting = _pumpStationGauge.list.pumpStationSetting;
            var rtuTelemetry = _pumpStationGauge.list.rtuTelemetry;
            var analogSetting = _pumpStationGauge.list.analogSetting;
            var analogGaugeSetting = _pumpStationGauge.list.analogGaugeSetting;

            ctrl.numberOfPumps = _pumpStationGauge.list.pumpStationGauge.length;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.widgetSetting.setting.displaySetting,
                displaySettingOn: ctrl.displaySettingOn
            };

            ctrl.pumpStationGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                deviceDigitalData: deviceDigitalData,
                enteredStateTime: enteredStateTime,
                floatSettings: floatSettings,
                pumpStationGauge: pumpStationGauge,
                pumpStationSetting: pumpStationSetting,
                rtuTelemetry: rtuTelemetry,
                pumpStationWidgetId: ctrl.pumpStationWidgetId,
                pumpStationType: ctrl.pumpStationType,
                setting: setting,
                analogSetting: analogSetting,
                analogGaugeSetting: analogGaugeSetting
            };

            $scope.alerts = [];
            if (ctrl.numberOfPumps === 0) {
                $scope.alerts.push({ msg: ctrl.translation.text.NO_PUMPS, type: "danger" });
            } else if (ctrl.pumpStationGauge.deviceDigitalData === null) {
                ctrl.numberOfPumps = 0;
                $scope.alerts.push({ msg: ctrl.translation.text.NO_DATA, type: "info" });
            }

            ctrl.validateFloatChannel = true;

            ctrl.buildWidget(ctrl.pumpStationGauge);

            if (!angular.isUndefined(openSetting)) {
                $timeout(function () {
                    ctrl.mouseOverHUD();
                    ctrl.editSetting();
                }, 0);
            }

            ctrl.updateWidgetTitle();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.updateWidgetTitle = function () {
        ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.widgetSetting.device.deviceId, name: ctrl.widgetSetting.device.name, serialNumber: ctrl.widgetSetting.device.serialNumber, channel: ctrl.widgetSetting.pumpStationGauge.channel, channelDescription: ctrl.widgetSetting.pumpStationGauge.description, titleId: ctrl.widgetSetting.pumpStationSetting.titleId } });
    };

    ctrl.fnThemeOptions = function (themeOption) {
        ctrl.widgetSetting.pumpStationSetting.theme = themeOption.name;
        ctrl.widgetSetting.pumpStationSetting.themeId = themeOption.id;
        ctrl.buildMainClass();
    };

    ctrl.fnTitleOptions = function (titleOption) {
        ctrl.widgetSetting.pumpStationSetting.titleId = titleOption.id;
        ctrl.widgetSetting.pumpStationSetting.titleState = titleOption.state;
        ctrl.updateWidgetTitle();
    };

    ctrl.fnStateOptions = function (stateOption) {
        ctrl.widgetSetting.pumpStationSetting.stateId = stateOption.id;
        ctrl.widgetSetting.pumpStationSetting.stateDescription = stateOption.description;
        ctrl.buildMainClass();
    };

    ctrl.fnHeardTypeOptions = function (heardTypeOption) {
        ctrl.widgetSetting.pumpStationSetting.dateTimeFormat = heardTypeOption.type;
        ctrl.widgetSetting.pumpStationSetting.dateTimeFormatId = heardTypeOption.id;
        ctrl.DisplayTimestamp();
    };

    ctrl.fnSizeOptions = function (sizeOption, openSetting) {
        if (!ctrl.widgetSetting.setting.displaySetting) return;

        if (sizeOption != null) {
            ctrl.widgetSetting.pumpStationSetting.sizeId = sizeOption.id;
            ctrl.widgetSetting.pumpStationSetting.size = sizeOption.description;
        }

        ctrl.setSize(ctrl.widgetSetting.pumpStationSetting.sizeId);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.parent().addClass("ui-widget-content-mc");

            $timeout(function () {
                var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
                ctrl.popup.parent().css("height", svgH + "px");
                ctrl.popup.parent().css("width", svgH + 25 + "px");
                ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
                ctrl.popup.parent().find('.alert').css("position", "relative").css("left", 25 / 2 + "px");
            }, 100);
        }

        ctrl.closeSetting();
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);
        ctrl.buildMainClass();

        if (!angular.isUndefined(openSetting)) {
            $timeout(function () {
                ctrl.mouseOverHUD();
                ctrl.editSetting();
            }, 0);
        }
    };

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getPumpStationSize(sizeId, 1);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.fnColorOptions = function (colorOption) {
        ctrl.widgetSetting.pumpStationSetting.runningColor = colorOption.runningColor;
        ctrl.widgetSetting.pumpStationSetting.runningBlink = colorOption.runningBlink;
        ctrl.widgetSetting.pumpStationSetting.notRunningColor = colorOption.notRunningColor;
        ctrl.widgetSetting.pumpStationSetting.notRunningBlink = colorOption.notRunningBlink;
        ctrl.widgetSetting.pumpStationSetting.faultColor = colorOption.faultColor;
        ctrl.widgetSetting.pumpStationSetting.faultBlink = colorOption.faultBlink;
        ctrl.buildMainClass();
        //ctrl.closeSetting();
    };

    ctrl.fnRtuStatusOptions = function (rtuStatus) {
        ctrl.buildMainClass();
        ctrl.hudText = rtuStatus;
    };

    ctrl.fnHudInfoOption = function (hudInfoId) {
        ctrl.hudInfoId = hudInfoId;
        ctrl.buildMainClass();
    };

    ctrl.fnAnalogChannelOptions = function (analogChannel) {

        if (ctrl.widgetSetting.pumpStationSetting.analogChannel > 0) ctrl.unRegisterListenerAnalogData(ctrl.widgetSetting.device.serialNumber);

        ctrl.widgetSetting.pumpStationSetting.analogChannel = analogChannel;
        ctrl.ignoreUpdatePumpStationSetting = true;
        $rootScope.$broadcast('updatePumpStationAnalogSetting', ctrl.widgetSetting.pumpStationSetting);
        ctrl.webSocketReconnect();
    };

    ctrl.fnDigitalChannelOptions = function (digitalChannel) {
        ctrl.widgetSetting.pumpStationSetting.digitalChannel = digitalChannel;
        ctrl.buildMainClass();
        ctrl.ignoreUpdatePumpStationSetting = true;
        $rootScope.$broadcast('updatePumpStationFloatSetting', ctrl.widgetSetting.pumpStationSetting);
    };

    ctrl.fnChangeDisplayOptions = function (parSettingOptions) {
        if (!angular.isUndefined(parSettingOptions.titleOption)) {
            ctrl.fnTitleOptions(parSettingOptions.titleOption);
        }
        if (!angular.isUndefined(parSettingOptions.stateOption)) {
            ctrl.fnStateOptions(parSettingOptions.stateOption);
        }
        if (!angular.isUndefined(parSettingOptions.heardTypeOption)) {
            ctrl.fnHeardTypeOptions(parSettingOptions.heardTypeOption);
        }
        if (!angular.isUndefined(parSettingOptions.sizeOption)) {
            ctrl.fnSizeOptions(parSettingOptions.sizeOption, true);
        }
        if (!angular.isUndefined(parSettingOptions.themeOption)) {
            ctrl.fnThemeOptions(parSettingOptions.themeOption);
        }
        if (!angular.isUndefined(parSettingOptions.colorOption)) {
            ctrl.fnColorOptions(parSettingOptions.colorOption);
        }
        if (!angular.isUndefined(parSettingOptions.rtuOption)) {
            if (ctrl.ignoreFnChangeDisplayOptions) {
                ctrl.ignoreFnChangeDisplayOptions = undefined;
            } else {
                ctrl.getData(parSettingOptions.rtuOption.deviceId, true);
            }
        }
        if (!angular.isUndefined(parSettingOptions.hudInfoOption)) {
            ctrl.fnHudInfoOption(parSettingOptions.hudInfoOption.id);
        }
        if (!angular.isUndefined(parSettingOptions.analogChannelOption)) {
            ctrl.fnAnalogChannelOptions(parSettingOptions.analogChannelOption.channel);
        }
        if (!angular.isUndefined(parSettingOptions.digitalChannelOption)) {
            ctrl.fnDigitalChannelOptions(parSettingOptions.digitalChannelOption.channel);
        }
    };

    ctrl.editSetting = function (event) {
        ctrl.mcWidgetsSharedFactory.editSetting($element, event, ctrl);
    };

    ctrl.closeSetting = function () {
        ctrl.mcWidgetsSharedFactory.closeSetting($element, ctrl);
    };

    ctrl.mouseOverHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOver;
        }
    };
    ctrl.mouseOffHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOff;
        }
    };

    ctrl.resize_HUD = function (w_svgSizeW, w_svgSizeH) {
        ctrl.mcWidgetsSharedFactory.resizeHud(w_svgSizeW, w_svgSizeH, ctrl);
    };

    ctrl.webSocketHeartbeatReceived = function (data) {
        if (angular.isUndefined(ctrl.widgetSetting)) return; //The Widget has not initialized yetl
        ctrl.heartbeatDateTime = new Date(data.LocalDateTime).toISOString();
        ctrl.DisplayTimestamp();
    };

    ctrl.DisplayTimestamp = function () {

        if (angular.isUndefined(ctrl.widgetSetting.deviceUnitState)) return;

        if (ctrl.widgetSetting.deviceDigitalData === null) return;

        var reportDateTime = ctrl.widgetSetting.deviceDigitalData.regTime;
        var currentDateTime = _returnUtcNow();
        var format = ctrl.widgetSetting.pumpStationSetting.dateTimeFormat;

        if (angular.isUndefined(reportDateTime) && angular.isUndefined(currentDateTime)) return;
        var _timestamp_Display;

        if (format === ctrl.translation.text.ABSOLUTE && reportDateTime !== "0001-01-01T00:00:00") {
            //if (format === "Absolute")
            _timestamp_Display = $filter('filterDateAgentTextTimeFormat')(datetimeService.UtcToLocalByTimeZone(reportDateTime, ctrl.accountInfo.timeZone), ctrl.preferredTimeFormat);
            var _substrings;
            _substrings = _timestamp_Display.split(' ');

            switch (_timestamp_Display.length) {
                case 7:case 8:case 9:case 10:case 11:
                    ctrl.timestamp_DisplayPre = "";
                    ctrl.timestamp_Display = _substrings[0] + (angular.isUndefined(_substrings[1]) ? " " : " " + _substrings[1]);
                    break;
                case 14:case 15:case 16:case 17:case 18:
                    ctrl.timestamp_DisplayPre = _substrings[0] + " " + _substrings[1];
                    ctrl.timestamp_Display = _substrings[2] + (angular.isUndefined(_substrings[3]) ? "" : " " + _substrings[3]);
                    break;
                case 19:case 20:case 21:case 22:case 23:
                    if (_substrings.length === 2) {
                        ctrl.timestamp_DisplayPre = _substrings[0];
                        ctrl.timestamp_Display = _substrings[1];
                    } else {
                        ctrl.timestamp_DisplayPre = _substrings[0] + " " + _substrings[1] + " " + _substrings[2];
                        ctrl.timestamp_Display = _substrings[3] + (angular.isUndefined(_substrings[4]) ? "" : " " + _substrings[4]);
                    }
                    break;
            }

            ctrl.buildStyle(12, ctrl.timestamp_Display.length, 20, ctrl.unit_DisplayStyle);
        } else {
            //if (format === "Elapsed")
            _timestamp_Display = ctrl.getPopupWindowDateTimeDifference(reportDateTime, currentDateTime, format);
            _timestamp_Display.then(function (value) {
                ctrl.timestamp_DisplayPre = "";
                ctrl.timestamp_Display = ctrl.translation.text.LAST_HEARD + " " + value + " " + ctrl.translation.text.AGO;
                ctrl.buildStyle(10, ctrl.timestamp_Display.length, 16, ctrl.timestamp_DisplayStyle);
            });
        }
    };

    ctrl.displayPumpTimestamp = function (channel) {

        var reportDateTime = ctrl.inputStatus == ctrl.translation.text.COMMS_FAULT ? ctrl.widgetSetting.deviceUnitState.lastTimeHeardUtc : ctrl.widgetSetting.enteredStateTime["d" + channel];
        var currentDateTime = _returnUtcNow();
        var format = ctrl.widgetSetting.pumpStationSetting.dateTimeFormat;
        var displayPumpTimestamp = { lineOne: null, lineTwo: null };

        if (angular.isUndefined(reportDateTime) && angular.isUndefined(currentDateTime)) return;
        var _timestamp_Display;

        if (format === ctrl.translation.text.ABSOLUTE && reportDateTime !== "0001-01-01T00:00:00") {
            _timestamp_Display = $filter('filterDateAgentTextTimeFormat')(datetimeService.UtcToLocalByTimeZone(reportDateTime, ctrl.accountInfo.timeZone), ctrl.preferredTimeFormat);

            var _substrings;
            _substrings = _timestamp_Display.split(' ');
            //_timestamp_Display = _timestamp_Display.replace(/\s/g, '');

            switch (_timestamp_Display.length) {//"Nov 01 2019 02:42:21 AM"
                case 7: //2:42:21
                case 8: //02:42:21
                case 9:
                case 10: //2:42:21 AM
                case 11:
                    //02:42:21 AM
                    displayPumpTimestamp.lineOne = "";
                    displayPumpTimestamp.lineTwo = _substrings[0] + (angular.isUndefined(_substrings[1]) ? " " : " " + _substrings[1]);
                    break;
                case 14: //Nov 01 2:42:21
                case 15: //Nov 01 02:42:21
                case 16:
                case 17: //Nov 01 2019 2:42:21 AM
                case 18:
                    //Nov 01 02:42:21 AM
                    displayPumpTimestamp.lineOne = _substrings[0] + " " + _substrings[1];
                    displayPumpTimestamp.lineTwo = _substrings[2] + (angular.isUndefined(_substrings[3]) ? "" : " " + _substrings[3]);
                    break;
                case 19: //Nov 01 2019 2:42:21
                case 20: //Nov 01 2019 02:42:21
                case 21:
                case 22: //Nov 01 2019 2:42:21 AM
                case 23:
                    //Nov 01 2019 02:42:21 AM
                    if (_substrings.length === 2) {
                        //Yesterday 02:42:21 AM
                        displayPumpTimestamp.lineOne = _substrings[0];
                        displayPumpTimestamp.lineTwo = _substrings[1];
                    } else {
                        displayPumpTimestamp.lineOne = _substrings[0] + " " + _substrings[1] + " " + _substrings[2];
                        displayPumpTimestamp.lineTwo = _substrings[3] + (angular.isUndefined(_substrings[4]) ? "" : " " + _substrings[4]);
                    }
                    break;
            }
        } else {
            //if (format === "Elapsed")
            displayPumpTimestamp.lineOne = "";
            displayPumpTimestamp.lineTwo = ctrl.popupWindow.datetime_difference(reportDateTime, currentDateTime);
        }

        return displayPumpTimestamp;
    };

    ctrl.buildStyle = function (numberOfFontsThatFits, strLength, maxFontSize, obj) {
        var _minFontSize = maxFontSize;
        obj["font-size"] = ctrl.adjustFontSize(numberOfFontsThatFits, strLength, _minFontSize, maxFontSize) + "px";
    };

    ctrl.adjustFontSize = function (numberOfFontsThatFits, strLength, minFontSize, maxFontSize) {
        var newFontSize = maxFontSize / strLength * numberOfFontsThatFits;
        return newFontSize > maxFontSize ? maxFontSize : newFontSize < minFontSize ? minFontSize : newFontSize;
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ctrl.buildMainClass = function () {

        var gaugeType = "TachGauge1"; // Options: TachGauge1 (Styled in mcwidgets.css)
        var pumpStationTransparentObj = "PumpStationTransparentObj";
        var mainClass = ["upWidget", gaugeType, ctrl.widgetSetting.pumpStationSetting.theme, "rtu" + getState(ctrl.widgetSetting.deviceUnitState.state), "acfail" + ctrl.widgetSetting.deviceUnitState.acFail, pumpStationTransparentObj];
        ctrl.mainClass = angular.copy(mainClass);

        ctrl.hasDigitalChannel = ctrl.widgetSetting.pumpStationSetting.digitalChannel > 0;
        ctrl.hasAnalogChannel = ctrl.widgetSetting.pumpStationSetting.analogChannel > 0;

        ctrl.waterLevelType = ctrl.hasDigitalChannel && !ctrl.hasAnalogChannel ? ctrl.waterLevelTypeEnum.Digital : !ctrl.hasDigitalChannel && ctrl.hasAnalogChannel ? ctrl.waterLevelTypeEnum.Analog : ctrl.hasDigitalChannel && ctrl.hasAnalogChannel ? ctrl.waterLevelTypeEnum.Both : ctrl.waterLevelTypeEnum.Default;

        ctrl.buildAnalogLevel();

        var _int = 0;
        var _running = 0;
        var _stopped = 0;
        var _error = 0;

        ctrl.widgetSetting.pumpStationGauge.forEach(function (value) {
            var _inputStatus = ctrl.buildMainClassByPump(ctrl.widgetSetting.pumpStationGauge[_int].pump, _int + 1);

            switch (_inputStatus) {
                case ctrl.translation.text.RUNNING:
                    _running++;
                    break;
                case ctrl.translation.text.STOPPED:
                    _stopped++;
                    break;
                case ctrl.translation.text.FAULT:
                    _error++;
                    break;
            }
            _int++;
        });

        ctrl.updateHudInfo(_running, _stopped, _error);

        if (getState(ctrl.widgetSetting.deviceUnitState.state) === "CommFail") ctrl.inputStatus = ctrl.translation.text.COMMS_FAULT;

        ctrl.pumpStationTextOverlayStyle = { "margin-top": "42.5%", "margin-left": "50%", "margin-right": "10%", "height": "15%", "color": "#000000", "font-size": ctrl.svgSizeW * .1 + "px" };
        ctrl.hideHudElements = _returnSizeId() <= 0 ? true : false; //<= 2
        ctrl.mcXsmallOnlyNo = _returnSizeId() === 0 ? true : false; //===1

        ctrl.buildStyle(9, ctrl.inputStatus.length, 24, ctrl.inputStatusStyle);

        ctrl.updateWaterLevel();

        $timeout(function () {
            ctrl.svgStyle = angular.isUndefined(ctrl.svgStyleAdjustment) ? { "opacity": '1' } : _getSvgStyleAdjustments(ctrl.pumpStationType);
        }, 100);
    };

    ctrl.buildMainClassByPump = function (_pumpStationGauge, pumpOrderNumber) {

        if (ctrl.widgetSetting.deviceDigitalData === null) return;

        ctrl.blink = false;

        switch (ctrl.widgetSetting.deviceDigitalData["d" + _pumpStationGauge.channel]) {
            case "True":
                if (_pumpStationGauge.normalClosed === 0) {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.pumpStationSetting.notRunningColor };
                    ctrl.blink = ctrl.widgetSetting.pumpStationSetting.notRunningBlink ? _getRotatingClassByPumpStationType(ctrl.pumpStationType) : ctrl.blink;
                    ctrl.inputStatus = ctrl.translation.text.STOPPED;
                } else {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.pumpStationSetting.runningColor };
                    ctrl.blink = ctrl.widgetSetting.pumpStationSetting.runningBlink ? _getRotatingClassByPumpStationType(ctrl.pumpStationType) : ctrl.blink;
                    ctrl.inputStatus = ctrl.translation.text.RUNNING;
                }
                break;

            case "False":
                if (_pumpStationGauge.normalClosed === 0) {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.pumpStationSetting.runningColor };
                    ctrl.blink = ctrl.widgetSetting.pumpStationSetting.runningBlink ? _getRotatingClassByPumpStationType(ctrl.pumpStationType) : ctrl.blink;
                    ctrl.inputStatus = ctrl.translation.text.RUNNING;
                } else {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.pumpStationSetting.notRunningColor };
                    ctrl.blink = ctrl.widgetSetting.pumpStationSetting.notRunningBlink ? _getRotatingClassByPumpStationType(ctrl.pumpStationType) : ctrl.blink;
                    ctrl.inputStatus = ctrl.translation.text.STOPPED;
                }
                break;

            case "NULL":
            case "Fault":
                ctrl.colorLayer = { 'fill': ctrl.widgetSetting.pumpStationSetting.faultColor };
                ctrl.blink = ctrl.widgetSetting.pumpStationSetting.faultBlink ? _getRotatingClassByPumpStationType(ctrl.pumpStationType) : ctrl.blink;
                ctrl.inputStatus = ctrl.translation.text.FAULT;
                break;

        }

        switch (pumpOrderNumber) {
            case 1:
                ctrl.cog1 = ctrl.blink;
                ctrl.bladeStyle1 = ctrl.colorLayer;
                break;
            case 2:
                ctrl.cog2 = ctrl.blink;
                ctrl.bladeStyle2 = ctrl.colorLayer;
                break;
            case 3:
                ctrl.cog3 = ctrl.blink;
                ctrl.bladeStyle3 = ctrl.colorLayer;
                break;
            case 4:
                ctrl.cog4 = ctrl.blink;
                ctrl.bladeStyle4 = ctrl.colorLayer;
                break;
            case 5:
                ctrl.cog5 = ctrl.blink;
                ctrl.bladeStyle5 = ctrl.colorLayer;
                break;
            case 6:
                ctrl.cog6 = ctrl.blink;
                ctrl.bladeStyle6 = ctrl.colorLayer;
                break;
            case 7:
                ctrl.cog7 = ctrl.blink;
                ctrl.bladeStyle7 = ctrl.colorLayer;
                break;
            case 8:
                ctrl.cog8 = ctrl.blink;
                ctrl.bladeStyle8 = ctrl.colorLayer;
                break;
        }

        return ctrl.inputStatus;
    };

    ctrl.convertTemperature = function (value) {
        var tmpValue = void 0;
        switch (ctrl.accountInfo.preferenceUser.lookupMeasurementID) {
            case 1:
                tmpValue = value * 9 / 5 + 32;
                break;

            default:
                tmpValue = value;
                break;
        }
        return tmpValue.toFixed(0);
    };

    ctrl.updateHudInfo = function (running, stopped, error) {
        switch (ctrl.hudInfoId) {
            case 1:
                ctrl.hudRowOne = ctrl.translation.text.PUMPS + " " + ctrl.translation.text.RUNNING + " (" + running + ")";
                ctrl.hudRowTwo = ctrl.translation.text.PUMPS + " " + ctrl.translation.text.STOPPED + " (" + stopped + ")";
                ctrl.hudRowThree = ctrl.translation.text.PUMPS_IN + " " + ctrl.translation.text.FAULT + " (" + error + ")";
                break;
            case 0:
            default:
                for (var i = 0; i < ctrl.widgetSetting.rtuTelemetry.length; i++) {

                    switch (ctrl.widgetSetting.rtuTelemetry[i].name) {
                        case "Temperature":
                            ctrl.hudRowThree = ctrl.convertTemperature(ctrl.widgetSetting.rtuTelemetry[i].value);
                            ctrl.hudRowThreeA = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? "F" : "C";
                            break;

                        case "Battery":
                            ctrl.hudRowTwo = ctrl.widgetSetting.rtuTelemetry[i].value.toFixed(1) + " " + ctrl.widgetSetting.rtuTelemetry[i].unit;
                            break;

                        case "D.C.":
                        case "A.C.":
                            ctrl.hudRowOne = ctrl.widgetSetting.rtuTelemetry[i].value.toFixed(1) + " " + ctrl.widgetSetting.rtuTelemetry[i].unit;
                            break;
                    }
                }
                break;
        }
    };

    ctrl.updateWaterLevelDigital = function () {

        if (ctrl.widgetSetting.deviceDigitalData === null || ctrl.widgetSetting.pumpStationSetting.digitalChannel === 0) {
            ctrl.waterLevelUp = false;
            return;
        }

        var floatSetting = _getFloatSetting();

        if (floatSetting === null) {
            ctrl.waterLevelUp = false;
            return;
        }

        switch (ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.pumpStationSetting.digitalChannel]) {
            case "True":
                if (floatSetting.normalClosed === 0) {
                    ctrl.waterLevelUp = false;
                } else {
                    ctrl.waterLevelUp = true;
                }
                break;

            case "False":
                if (floatSetting.normalClosed === 0) {
                    ctrl.waterLevelUp = true;
                } else {
                    ctrl.waterLevelUp = false;
                }
                break;

            case "NULL":
            case "Fault":
                ctrl.waterLevelUp = false;
                break;

        }
    };

    ctrl.updateWaterLevel = function () {
        ctrl.updateWaterLevelDigital();
    };

    var _getFloatSetting = function _getFloatSetting() {
        var floatSetting = ctrl.widgetSetting.floatSettings.filter(function (item) {
            return item.channel === ctrl.widgetSetting.pumpStationSetting.digitalChannel;
        });
        return floatSetting[0];
    };

    var _getRotatingClassByPumpStationType = function _getRotatingClassByPumpStationType(pumpStationType) {
        var _pumpStationType = angular.isUndefined(pumpStationType) ? "" : pumpStationType;

        switch (_pumpStationType.toUpperCase()) {
            case "SUBMERSIBLE PUMP STATION":
                return "run-ps";
            case "WET WELL PUMP STATION":
            case "DRY WELL PUMP STATION":
                return "run-shaft";
            default:
                return "spin";
        }
    };

    var _getSvgStyleAdjustments = function _getSvgStyleAdjustments(pumpStationType) {
        var _pumpStationType = angular.isUndefined(pumpStationType) ? "" : pumpStationType;

        switch (_pumpStationType.toUpperCase()) {
            case "SUBMERSIBLE PUMP STATION":
            case "DRY WELL PUMP STATION":
            case "WET WELL PUMP STATION":
            default:
                return { "opacity": '1' };
        }
    };

    var _returnUtcNow = function _returnUtcNow() {
        var _a = $rootScope.heartbeatUtcDateTime;
        var _b = moment().utc().format('MM/DD/YY, h:mm:ss a').valueOf();
        var tmpTime = _a || _b;
        return tmpTime;
    };

    var _returnSizeId = function _returnSizeId() {
        if (angular.isUndefined(ctrl.sizeIdOverride) || ctrl.sizeIdOverride === "") {
            return ctrl.widgetSetting.pumpStationSetting.sizeId;
        } else return parseInt(ctrl.sizeIdOverride);
    };

    ctrl.openView = function ($event) {
        if (!$rootScope.mobile && !$rootScope.classicView) openViewService.openView(getView(ctrl.widgetSetting.deviceUnitState.state));
    };

    // from socket

    ctrl.updateValue = function (value) {

        switch (value) {
            case "1":
                return "True";
            case "0":
                return "False";
            case "-1":
                return "Fault";
        }
        return "Fault";
    };

    ctrl.wsDataReceivedDigital = function (data, numberOfChannels) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;

        var chValue = data.Value;
        var channel = parseInt(data.CH);
        var digValue = ctrl.updateValue(chValue);

        if (ctrl.widgetSetting.deviceDigitalData["d" + channel] !== digValue) {
            ctrl.widgetSetting.deviceDigitalData["d" + channel] = digValue;
            ctrl.widgetSetting.enteredStateTime["d" + channel] = datetimeService.socketStrToServerStrTime(data.UtcDateTime);
        }

        ctrl.widgetSetting.deviceDigitalData.regTime = datetimeService.socketStrToServerStrTime(data.UtcDateTime);
        ctrl.widgetSetting.deviceDigitalData.localTime = datetimeService.socketStrToServerStrTime(data.Time);
        ctrl.buildMainClass();
    };

    ctrl.wsDataReceivedFAULTS = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;

        var faultBinary;
        if (isNaN(data.Value)) {
            faultBinary = data.Value.replace(/[[\]]/g, '').split(',').join('');
        } else {
            faultBinary = (data.Value >>> 0).toString(2);

            while (faultBinary.length < 16) {
                faultBinary = faultBinary.length < 8 ? "0" + faultBinary : faultBinary + "0";
            }
        }

        for (var channel = 1; channel <= 16 && channel <= faultBinary.length; channel++) {

            if (faultBinary[channel - 1] === '1') {
                //console.log('Got a fault for channel: ', channelId);
                var digValue = "NULL";

                if (ctrl.widgetSetting.deviceDigitalData["d" + channel] !== digValue) {
                    ctrl.widgetSetting.deviceDigitalData["d" + channel] = digValue;
                    ctrl.widgetSetting.enteredStateTime["d" + channel] = datetimeService.socketStrToServerStrTime(data.UtcDateTime);
                }
            }
        }

        ctrl.buildMainClass();
    };

    ctrl.webSocketReconnect = function () {
        ctrl.validateFloatChannel = true;
        ctrl.unRegisterListenerListDeviceState(ctrl.widgetSetting.device.serialNumber);
        ctrl.unRegisterListenerAnalogData(ctrl.widgetSetting.device.serialNumber);
        toaster.pop('success', "Pump Station " + " -- " + ctrl.widgetSetting.device.name, 'View reloading');
        ctrl.getData(ctrl.widgetSetting.device.deviceId);
    };

    var _onHeartbeat = $rootScope.$on('Heartbeat', function (event, args) {
        if (args.message.Type === "HEARTBEAT") {
            ctrl.webSocketHeartbeatReceived(args.message);
        }
    });

    var _onINPUTS = $rootScope.$on('DIGITALINPUT', function (event, args) {
        ctrl.wsDataReceivedDigital(args.data, 8);
    });

    var _onOPTIONDIGITAL = $rootScope.$on('OPTIONDIGITAL', function (event, args) {
        ctrl.wsDataReceivedDigital(args.data, 16);
    });

    var _onFAULTS = $rootScope.$on('FAULTS', function (event, args) {
        ctrl.wsDataReceivedFAULTS(args.data);
    });

    var _onRECONNECT = $scope.$on('processReconnect', function (event, args) {
        ctrl.webSocketReconnect();
    });

    var _onDocumentClick = $rootScope.$on('document_click', function (event, args) {
        ctrl.closeSetting();
    });

    var _onUpdatePreferencesLanguage = $scope.$on('updatePreferencesLanguage', function () {
        ctrl.buildMainClass();
    });

    var _onUpdatePreferencesTimeFormat = $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.applyTimeFormat(timeFormat);
    });

    var _onWebSocketService = $rootScope.$on('WebSocketService', function (event, args) {
        if (args.message.SN === ctrl.widgetSetting.device.serialNumber && args.message.Type === "DIGITALSETTING" && args.message.Value.path === "digitalMode" || args.message.SN === ctrl.widgetSetting.device.serialNumber && args.message.Type === "DIGITALSETTING" && args.message.Value.path === "normalClosed" || args.message.SN === ctrl.widgetSetting.device.serialNumber && args.message.Type === "DEVICEBASICINFO" && args.message.Value.path === "pumpStationWidgetId" || args.message.SN === ctrl.widgetSetting.device.serialNumber && args.message.Type === "DEVICEBASICINFO" && args.message.Value.path === "name" || args.message.SN === ctrl.widgetSetting.device.serialNumber && args.message.Type === "ANALOGSETTING" && args.message.Value.path === "name") {
            switch (args.message.Value.path) {
                case "pumpStationWidgetId":
                    ctrl.pumpStationWidgetId = args.message.Value.value;
                    ctrl.pumpStationType = ctrl.mcWidgetsSharedFactory.getPumpStationTypeByWidgetId(parseInt(ctrl.pumpStationWidgetId));
                    break;
                case "name":
                    //Updating title only!
                    if (args.message.Type === "DEVICEBASICINFO") {

                        ctrl.ignoreFnChangeDisplayOptions = true;

                        if (args.message.UniqueWebID != $rootScope.uniqueWebID) {
                            $scope.liveUpdateItem = args.message.Value.path;
                            ctrl.liveUpdated = true;
                            ctrl.liveMessage = " " + args.message.UserName + " changed " + "\"Site Name\"" + " from " + ctrl.widgetSetting.device.name + " to " + args.message.Value.value;
                            _setTimeOut();
                        }
                    }

                    break;
                default:
                    break;
            }

            ctrl.webSocketReconnect();
        }
    });

    var _updatePumpStationFloatSetting = $rootScope.$on('updatePumpStationFloatSetting', function (event, args) {

        if (!ctrl.ignoreUpdatePumpStationSetting == true) {
            ctrl.widgetSetting.pumpStationSetting = args;
            ctrl.buildMainClass();
        }

        ctrl.ignoreUpdatePumpStationSetting = false;
    });

    var _updatePumpStationAnalogSetting = $rootScope.$on('updatePumpStationAnalogSetting', function (event, args) {

        if (!ctrl.ignoreUpdatePumpStationSetting == true) {
            ctrl.webSocketReconnect();
        }

        ctrl.ignoreUpdatePumpStationSetting = false;
    });

    $scope.applyTimeFormat = function (timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat);
    };

    var _removeAllListeners = function _removeAllListeners() {
        _onHeartbeat();
        _onDocumentClick();
        _onINPUTS();
        _onOPTIONDIGITAL();
        _onFAULTS();
        _onRECONNECT();
        _onWebSocketService();
        _setTimeOut();
        _updatePumpStationFloatSetting();
        _updatePumpStationAnalogSetting();
        _onUpdatePreferencesLanguage();
        _onUpdatePreferencesTimeFormat();
        ctrl.unRegisterListenerListDeviceState(ctrl.widgetSetting.device.serialNumber);
        ctrl.unRegisterListenerAnalogData(ctrl.widgetSetting.device.serialNumber);
    };

    $scope.$on("$destroy", function () {
        _removeAllListeners();
    });

    $scope.$on("StopOverview", function (event, args) {
        if ($scope.$$destroyed) {
            // The scope is already destroyed, skip further processing.
            return;
        } else if (args.stop) {
            websocketService.connect();
            websocketService.startOverview();
        }
    });
}

McWidgetPumpStationDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'debounceService', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'McPumpStationWidgetFactory', 'authenticationService', 'translationService', 'PopupFactory', 'detectBrowserService', 'McWidgetsSharedFactory', '$filter', 'openViewService', '$interval'];
'use strict';

angular.module('mc.widget-pump-station-display').component('mcWidgetPumpStationDisplay', {
    controller: McWidgetPumpStationDisplayController,
    templateUrl: 'ui/pumpstation/mcwidgetpumpstationdisplay/mcwidget-pump-station-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        settingShow: '<',
        changeWidgetTitle: '&',
        labelMode: '@',
        additionalSize: '@',
        sizeIdOverride: '@',
        themeIdOverridePopupOnly: '@',
        svgStyleAdjustment: '@'
    }
});
"use strict";

angular.module("mc.widget-pump-station-setting", []);
"use strict";

function McWidgetPumpStationSettingController($, $timeout, $rootScope, $scope, $element, authenticationService, translationService, websocketService, pumpStationWidgetService, McWidgetsSharedFactory) {

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            ctrl.mcWidgetPumpStationSetting = changes.widgetSetting.currentValue;
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            if (!angular.isUndefined(changes.widgetSetting.previousValue.device)) ctrl.unRegisterListenerDigitalSetting(changes.widgetSetting.previousValue.device.serialNumber, changes.widgetSetting.previousValue.pumpStationGauge.channel);
            ctrl.registerListenerDigitalSetting(changes.widgetSetting.currentValue.device.serialNumber, changes.widgetSetting.currentValue.pumpStationGauge.channel);
            ctrl.getUiData();
        }
    };

    ctrl.$onInit = function () {
        if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        ctrl.w_tabpaneIsOpen = { "height": "100%", "display": "block" };
        ctrl.w_tabpaneIsClosed = { "height": "0%", "display": "none" };
        ctrl.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.colorPalet = ctrl.mcWidgetsSharedFactory.getColorPalet();
        ctrl.mobile = $rootScope.mobile;
    };

    ctrl.setModel = function (parm) {
        ctrl.clearModel();
        $timeout(function () {
            ctrl.parm = parm;
        }, 0);
    };

    ctrl.clearModel = function () {
        ctrl.parm = null;
    };

    ctrl.testNgChange = function () {
        ctrl.validateColors(true);
    };

    ctrl.selectColor = function (event) {
        switch (ctrl.parm) {
            case "runningColor":
                ctrl.runningColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "notRunningColor":
                ctrl.notRunningColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "faultColor":
                ctrl.faultColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            default:
            // code block
        }
        ctrl.clearModel();
        ctrl.validateColors(true);
    };

    ctrl.updateDisplayOptions = function (param) {

        var tmpNewPumpStationSetting = angular.copy(ctrl.mcWidgetPumpStationSetting.pumpStationSetting);
        tmpNewPumpStationSetting.customerId = ctrl.accountInfo.customerId;
        tmpNewPumpStationSetting.deviceId = ctrl.mcWidgetPumpStationSetting.device.deviceId;
        tmpNewPumpStationSetting.channel = ctrl.mcWidgetPumpStationSetting.pumpStationGauge.channel;

        if (!angular.isUndefined(param.settingOptions.titleOption)) {
            tmpNewPumpStationSetting.titleId = param.settingOptions.titleOption.id;
            ctrl.updateUiData(param, tmpNewPumpStationSetting);
        }

        if (!angular.isUndefined(param.settingOptions.heardTypeOption)) {
            tmpNewPumpStationSetting.dateTimeFormatId = param.settingOptions.heardTypeOption.id;
            ctrl.updateUiData(param, tmpNewPumpStationSetting);
        }

        if (!angular.isUndefined(param.settingOptions.stateOption)) {
            tmpNewPumpStationSetting.stateId = param.settingOptions.stateOption.id;
            ctrl.updateUiData(param, tmpNewPumpStationSetting);
        }

        if (!angular.isUndefined(param.settingOptions.sizeOption)) {
            tmpNewPumpStationSetting.sizeId = param.settingOptions.sizeOption.id;
            ctrl.updateUiData(param, tmpNewPumpStationSetting);
        }

        if (!angular.isUndefined(param.settingOptions.themeOption)) {
            tmpNewPumpStationSetting.themeId = param.settingOptions.themeOption.id;
            ctrl.updateUiData(param, tmpNewPumpStationSetting);
        }

        if (!angular.isUndefined(param.settingOptions.colorOption)) {

            tmpNewPumpStationSetting.runningColor = param.settingOptions.colorOption.runningColor;
            tmpNewPumpStationSetting.runningBlink = param.settingOptions.colorOption.runningBlink;
            tmpNewPumpStationSetting.notRunningColor = param.settingOptions.colorOption.notRunningColor;
            tmpNewPumpStationSetting.notRunningBlink = param.settingOptions.colorOption.notRunningBlink;
            tmpNewPumpStationSetting.faultColor = param.settingOptions.colorOption.faultColor;
            tmpNewPumpStationSetting.faultBlink = param.settingOptions.colorOption.faultBlink;

            ctrl.updateUiData(param, tmpNewPumpStationSetting);
        }

        if (!angular.isUndefined(param.settingOptions.analogChannelOption)) {
            tmpNewPumpStationSetting.analogChannel = param.settingOptions.analogChannelOption.channel;
            ctrl.updateUiData(param, tmpNewPumpStationSetting);
        }

        if (!angular.isUndefined(param.settingOptions.digitalChannelOption)) {
            tmpNewPumpStationSetting.digitalChannel = param.settingOptions.digitalChannelOption.channel;
            ctrl.updateUiData(param, tmpNewPumpStationSetting);
        }

        if (!angular.isUndefined(param.settingOptions.hudInfoOption)) {
            tmpNewPumpStationSetting.hudInfo = param.settingOptions.hudInfoOption.id;
            ctrl.updateUiData(param, tmpNewPumpStationSetting);
        }

        if (!angular.isUndefined(param.settingOptions.rtuOption)) {

            ctrl.getChannels(param.settingOptions.rtuOption.deviceId, true);
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: param.settingOptions.rtuOption.deviceId, channel: ctrl.channelSelectedOption.channel } } });
        }

        if (!angular.isUndefined(param.settingOptions.channelOption)) {
            ctrl.channelSelectedOption = { channel: param.settingOptions.channelOption.channel };
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: ctrl.rtuSelectedOption.deviceId, channel: param.settingOptions.channelOption.channel } } });
        }
    };

    ctrl.updateUiData = function (param, naws) {
        ctrl.mcWidgetsSharedFactory.updateUiData(param, naws, "GaugePumpStationWidget", "newMcWidgetPumpStationSettingOptions", ctrl, ctrl.widgetSetting.pumpStationSetting);
    };

    ctrl.getUiData = function () {
        ctrl.mcWidgetsSharedFactory.getUiData("mcWidgetPumpStationSettingOptions", "All", ctrl);
    };

    ctrl.getSetting = function () {
        pumpStationWidgetService.getSettings(ctrl.accountInfo.customerId, ctrl.mcWidgetPumpStationSetting.device.deviceId).then(function (result) {
            ctrl.rtuOptions = result.data.digitalDevices;
            ctrl.digitalSettings = result.data.digitalSettings;
            ctrl.analogSettings = result.data.analogSettings;

            ctrl.getChannels(ctrl.mcWidgetPumpStationSetting.device.deviceId);

            ctrl.getAnalogChannels(ctrl.mcWidgetPumpStationSetting.device.deviceId);

            ctrl.getDigitalChannels(ctrl.mcWidgetPumpStationSetting.device.deviceId);

            ctrl.rtuSelectedOption = { deviceId: ctrl.mcWidgetPumpStationSetting.device.deviceId, name: ctrl.mcWidgetPumpStationSetting.device.name };
        }, function (error) {});
    };

    ctrl.getChannels = function (deviceId, firstChannel) {
        ctrl.channelOptions = [];
        ctrl.channelOptions.push({ channel: 0, description: "0" });
        ctrl.channelSelectedOption = { channel: 0 };
        return;

        //angular.forEach(ctrl.pumpStationSettings, function (pumpStationSetting) {
        //    if (parseInt(deviceId) === parseInt(pumpStationSetting.deviceId) && pumpStationSetting.digitalMode === "P") {
        //        ctrl.channelOptions.push(pumpStationSetting);
        //    }
        //});

        //if (firstChannel) {
        //    ctrl.channelSelectedOption = { channel: ctrl.channelOptions[0].channel, description: ctrl.channelOptions[0].description };
        //} else {
        //    ctrl.channelSelectedOption = { channel: ctrl.mcWidgetPumpStationSetting.pumpStationGauge.channel, description: ctrl.mcWidgetPumpStationSetting.pumpStationGauge.description };
        //}
    };

    ctrl.getAnalogChannels = function (deviceId, firstChannel) {
        ctrl.analogChannelOptions = [];
        ctrl.analogChannelOptions.push({ channel: 0, name: "--- " + ctrl.translation.text.SELECT + " " + ctrl.translation.text.ANALOG + " " + ctrl.translation.text.CHANNEL + " ---" });

        angular.forEach(ctrl.analogSettings, function (analogSettings) {
            if (parseInt(deviceId) === parseInt(analogSettings.deviceId)) {
                ctrl.analogChannelOptions.push(analogSettings);
            }
        });

        if (firstChannel) {
            ctrl.analogChannelSelectedOption = { channel: ctrl.analogChannelOptions[0].channel, name: ctrl.analogChannelOptions[0].name };
        } else {
            ctrl.analogChannelSelectedOption = { channel: ctrl.mcWidgetPumpStationSetting.pumpStationSetting.analogChannel, name: "Analog Channel Dsc." };
        }
    };

    ctrl.getDigitalChannels = function (deviceId, firstChannel) {
        ctrl.digitalChannelOptions = [];
        ctrl.digitalChannelOptions.push({ channel: 0, description: "--- " + ctrl.translation.text.SELECT + " " + ctrl.translation.text.DIGITAL + " " + ctrl.translation.text.CHANNEL + " ---" });

        angular.forEach(ctrl.digitalSettings, function (digitalSettings) {
            if (parseInt(deviceId) === parseInt(digitalSettings.deviceId)) {
                ctrl.digitalChannelOptions.push(digitalSettings);
            }
        });

        if (firstChannel) {
            ctrl.digitalChannelSelectedOption = { channel: ctrl.digitalChannelOptions[0].channel, description: ctrl.digitalChannelOptions[0].name };
        } else {
            ctrl.digitalChannelSelectedOption = { channel: ctrl.mcWidgetPumpStationSetting.pumpStationSetting.digitalChannel, description: "Digital Channel Dsc." };
        }
    };

    ctrl.setOptions = function () {
        ctrl.titleOptions = ctrl.mcWidgetPumpStationSettingOptions.title;
        ctrl.titleSelectedOption = { id: ctrl.mcWidgetPumpStationSetting.pumpStationSetting.titleId };

        ctrl.heardTypeOptions = ctrl.mcWidgetPumpStationSettingOptions.dateTimeFormat;
        ctrl.heardTypeSelectedOption = { id: ctrl.mcWidgetPumpStationSetting.pumpStationSetting.dateTimeFormatId };

        ctrl.sizeOptions = ctrl.mcWidgetPumpStationSettingOptions.size;
        ctrl.sizeSelectedOption = { id: ctrl.mcWidgetPumpStationSetting.pumpStationSetting.sizeId };

        ctrl.themeOptions = ctrl.mcWidgetPumpStationSettingOptions.theme;
        ctrl.themeSelectedOption = { id: ctrl.mcWidgetPumpStationSetting.pumpStationSetting.themeId };

        ctrl.hudInfoOption = [];
        ctrl.hudInfoOption.push({ id: 0, name: "Telemetry Data" }, { id: 1, name: "Pump Status" });
        ctrl.hudInfoSelectedOption = { id: ctrl.mcWidgetPumpStationSetting.pumpStationSetting.hudInfo };

        ctrl.runningColor = ctrl.mcWidgetPumpStationSetting.pumpStationSetting.runningColor;
        ctrl.runningBlink = ctrl.mcWidgetPumpStationSetting.pumpStationSetting.runningBlink;
        ctrl.notRunningColor = ctrl.mcWidgetPumpStationSetting.pumpStationSetting.notRunningColor;
        ctrl.notRunningBlink = ctrl.mcWidgetPumpStationSetting.pumpStationSetting.notRunningBlink;
        ctrl.faultColor = ctrl.mcWidgetPumpStationSetting.pumpStationSetting.faultColor;
        ctrl.faultBlink = ctrl.mcWidgetPumpStationSetting.pumpStationSetting.faultBlink;

        ctrl.validateColors();
    };

    ctrl.validateColors = function (_dataChanged) {
        if (ctrl.runningColor.length !== 7 || ctrl.runningColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidRunningColor = true;
        } else {
            ctrl.invalidRunningColor = false;
        }
        if (ctrl.notRunningColor.length !== 7 || ctrl.notRunningColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidNotRunningColor = true;
        } else {
            ctrl.invalidNotRunningColor = false;
        }
        if (ctrl.faultColor.length !== 7 || ctrl.faultColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidFaultColor = true;
        } else {
            ctrl.invalidFaultColor = false;
        }

        ctrl.invalidColor = ctrl.invalidRunningColor || ctrl.invalidNotRunningColor || ctrl.invalidFaultColor ? true : false;

        if (_dataChanged && !ctrl.invalidColor) {
            ctrl.updateDisplayOptions({
                settingOptions: {
                    colorOption: {
                        runningColor: ctrl.runningColor,
                        runningBlink: ctrl.runningBlink,
                        notRunningColor: ctrl.notRunningColor,
                        notRunningBlink: ctrl.notRunningBlink,
                        faultColor: ctrl.faultColor,
                        faultBlink: ctrl.faultBlink
                    }
                }
            });
        }
    };

    ctrl.showTab = function (parm) {
        ctrl.clearModel();
        var element = $element.find(".w_tabbox");
        ctrl.mcWidgetsSharedFactory.showTab(parm, element, ctrl);
    };

    ctrl.translateOptions = function () {
        ctrl.titleOptions.forEach(function (option) {
            return option.state = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.heardTypeOptions.forEach(function (option) {
            return option.type = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.sizeOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.themeOptions.forEach(function (option) {
            return option.name = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
    };

    var _onUpdatePreferencesLanguage = $rootScope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translateOptions();
    });

    var setTimeOut = function setTimeOut() {
        setTimeout(function () {
            $scope.liveUpdateItem = null;
            $scope.liveUpdated = null;
            $scope.liveMessage = null;
        }, 20000); // 20 Seconds
    };

    var refreshDeviceBasicInfoLive = function refreshDeviceBasicInfoLive(patch, userName) {
        switch (patch.path) {
            case "description":
                $scope.basicInfoOldValue = $scope.deviceOld[patch.path];
                $scope.deviceOld[patch.path] = patch.value;
                $scope.device[patch.path] = $scope.deviceOld[patch.path];
                $scope.basicInfoNewValue = patch.value;
                break;
        }

        if ($scope.basicInfoOldValue != "") {
            $scope.liveUpdateItem = patch.path;
            $scope.liveUpdated = true;
            $scope.liveMessage = " " + userName + " changed " + patch.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + $scope.basicInfoOldValue + " to " + $scope.basicInfoNewValue;
            setTimeOut();
        }
    };

    ctrl.wsDataReceivedDIGITALSETTINGMCRW = function (data) {
        if (data.Type == 'DIGITALSETTING' && data.SN == ctrl.widgetSetting.device.serialNumber && data.CH == ctrl.widgetSetting.pumpStationGauge.channel) {
            //console.log(data);
            //refreshDeviceBasicInfoLive(data.Value, data.UserName);
        }
    };

    ctrl.registerListenerDigitalSetting = function (varSerialNum, channel) {
        //subscribe for digital setting changes
        websocketService.connect();
        websocketService.register("DIGITALSETTING", varSerialNum, channel, ctrl.wsDataReceivedDIGITALSETTINGMCRW, null);
    };

    ctrl.unRegisterListenerDigitalSetting = function (varSerialNum, channel) {
        websocketService.connect();
        websocketService.unRegister("DIGITALSETTING", varSerialNum, channel, ctrl.wsDataReceivedDIGITALSETTINGMCRW, null);
    };

    $scope.$on("$destroy", function () {
        _onUpdatePreferencesLanguage();
        ctrl.unRegisterListenerDigitalSetting(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.pumpStationGauge.channel);
    });
}

McWidgetPumpStationSettingController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'authenticationService', 'translationService', 'websocketService', 'pumpStationWidgetService', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-pump-station-setting').component('mcWidgetPumpStationSetting', {
    controller: McWidgetPumpStationSettingController,
    templateUrl: 'ui/pumpstation/mcwidgetpumpstationsetting/mcwidget-pump-station-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        changeDisplayOptions: '&'
    }
});
"use strict";

angular.module("mc.pump-station-widget", []);
'use strict';

function McPumpStationWidgetFactory(HOST, $http) {

    // instantiate our initial object
    var McPumpStationWidget = function McPumpStationWidget(customerId, deviceId, categoryId, widgetId, timeZone) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.timeZone = timeZone;
    };

    McPumpStationWidget.prototype.getWidgetData = function () {
        var self = this;
        return $http.get(HOST + '/api/PumpStationWidget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McPumpStationWidget;
}

McPumpStationWidgetFactory.$inject = ['HOST', '$http'];

angular.module('mc.pump-station-widget').factory('McPumpStationWidgetFactory', McPumpStationWidgetFactory);

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

mcapp.factory("pumpStationWidgetService", ["$http", "HOST", function ($http, HOST) {
    var pummpStationWidgetFatory = {};

    var _getSettings = function _getSettings(customerId, deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/PumpStationWidget?customerId=' + customerId + '&deviceId=' + deviceId,
            cache: false
        });
    };
    pummpStationWidgetFatory.getSettings = _getSettings;
    return pummpStationWidgetFatory;
}]);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function McPumpStationWidgetController($, $rootScope, $scope, $sce, $element, authenticationService, sharedSetupService, McPumpStationWidgetFactory, $timeout, McWidgetsSharedFactory, toaster, translationService, deviceMenuService, $q) {

    var ctrl = this;
    ctrl.closeIcon = false;

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 3);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.notSetup = function () {
        ctrl.pumpStationGauge = null;
        $scope.$emit('pumpStationWidgetDone_' + $scope.windowId, { message: true });
        ctrl.loadingInProgress = false;
        $scope.alerts.push({ msg: ctrl.translation.text.NOT_SETUP, type: "info" });
    };

    ctrl.$onChanges = function (changes) {
        if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
            $element.off("mouseover.mcPumpStationGauge");
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;

            ctrl.getPumpStationInfo(ctrl.accountInfo.customerId, changes.deviceSelected.currentValue).then(function (resp) {
                ctrl.getData(changes.deviceSelected.currentValue);
            });
        } else if (changes.deviceSelected.previousValue) {
            (function (event) {
                ctrl.popup.parent().off("mouseover");
                ctrl.popup.parent().off("mouseout");
            });
            ctrl.pumpStationGauge = null;
        }
    };

    ctrl.$onInit = function () {
        ctrl.mobile = $rootScope.mobile;
        ctrl.displaySettingOn = ctrl.settingShow;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.loadingInProgress = false;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;

        if (_typeof(ctrl.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        //Saved Desktop
        if ($scope.stickyProperties.device.deviceId !== null) {
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.device.deviceId, windowId: $scope.windowId });
            ctrl.getPumpStationInfo(ctrl.accountInfo.customerId, $scope.stickyProperties.device.deviceId).then(function (resp) {
                ctrl.getData($scope.stickyProperties.device.deviceId);
            });
        }
    };

    ctrl.getData = function (deviceId) {

        $scope.alerts = [];

        if (ctrl.pumpStationWidgetId === 0) {
            ctrl.notSetup();
            return;
        }

        var _pumpStationGauge = new McPumpStationWidgetFactory(ctrl.accountInfo.customerId, deviceId, 6, ctrl.pumpStationWidgetId, ctrl.accountInfo.timeZone);

        _pumpStationGauge.getWidgetData().then(function () {

            ctrl.loadingInProgress = false;
            var device = _pumpStationGauge.list.device;
            var deviceUnitState = _pumpStationGauge.list.deviceUnitState;
            var deviceDigitalData = _pumpStationGauge.list.digitalData;
            var enteredStateTime = _pumpStationGauge.list.enteredStateTime;
            var floatSettings = _pumpStationGauge.list.floatSettings;
            var pumpStationGauge = _pumpStationGauge.list.pumpStationGauge;
            var pumpStationSetting = _pumpStationGauge.list.pumpStationSetting;
            var rtuTelemetry = _pumpStationGauge.list.rtuTelemetry;
            var analogSetting = _pumpStationGauge.list.analogSetting;
            var analogGaugeSetting = _pumpStationGauge.list.analogGaugeSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.displaySettingOn,
                displaySettingOn: ctrl.displaySettingOn
            };
            ctrl.pumpStationGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                deviceDigitalData: deviceDigitalData,
                enteredStateTime: enteredStateTime,
                floatSettings: floatSettings,
                pumpStationGauge: pumpStationGauge,
                pumpStationSetting: pumpStationSetting,
                rtuTelemetry: rtuTelemetry,
                pumpStationWidgetId: ctrl.pumpStationWidgetId,
                pumpStationType: ctrl.pumpStationType,
                setting: setting,
                analogSetting: analogSetting,
                analogGaugeSetting: analogGaugeSetting
            };

            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.additionalSetting();
            $scope.$emit('pumpStationWidgetDone_' + $scope.windowId, { message: true });
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.getPumpStationWidgetId = function (customerId, deviceId) {
        var deferred = $q.defer();
        var _pumpStationWidgetId = 0;
        var _defaultPumpStationWidgetId = 0; //Default, WIdgetId == 0 -> "Submersible Pump Station";

        deviceMenuService.getDeviceMenuList(customerId).then(function (result) {
            var _devices = result.data.devices;

            for (var index = 0; index < _devices.length; ++index) {
                if (_devices[index].deviceId === deviceId) {
                    _pumpStationWidgetId = _devices[index].pumpStationWidgetId;
                    _pumpStationWidgetId = _pumpStationWidgetId === 0 ? _defaultPumpStationWidgetId : _pumpStationWidgetId;
                    deferred.resolve(_pumpStationWidgetId);
                }
            }
        }, function (error) {
            deferred.resolve(_defaultPumpStationWidgetId);
        });

        return deferred.promise;
    };

    ctrl.getPumpStationInfo = function (customerId, deviceId) {
        var deferred = $q.defer();

        ctrl.getPumpStationWidgetId(ctrl.accountInfo.customerId, deviceId).then(function (resp) {
            ctrl.pumpStationWidgetId = resp;
            ctrl.pumpStationType = ctrl.mcWidgetsSharedFactory.getPumpStationTypeByWidgetId(ctrl.pumpStationWidgetId);
            deferred.resolve();
        });

        return deferred.promise;
    };

    ctrl.mostRecentData = function () {
        ctrl.loadingInProgress = true;
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.pumpStationGauge.device.name, 'View reloading');
        ctrl.getData(ctrl.pumpStationGauge.device.deviceId);
    };

    ctrl.fnChangeWidgetTitle = function (titleOption) {
        var _device = { channel: titleOption.channel, deviceId: titleOption.deviceId, deviceName: titleOption.name, serialNumber: titleOption.serialNumber };
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: titleOption.deviceId, device: _device, windowId: $scope.windowId });
        ctrl.mcWidgetsSharedFactory.setTitle($element, titleOption.name, "", titleOption.titleId);
    };

    ctrl.additionalSetting = function () {

        if (!ctrl.displaySettingOn) return;

        ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.popup.dialog({ resizable: false });

        ctrl.mcWidgetsSharedFactory.setTitle($element, ctrl.pumpStationGauge.device.name, "", ctrl.pumpStationGauge.pumpStationSetting.titleId);

        ctrl.popup.parent().find("div.ui-widget-content ").css('overflow', 'visible');

        ctrl.closeWidget = function () {
            ctrl.popup.dialog("close");
        };

        ctrl.setSize(ctrl.pumpStationGauge.pumpStationSetting.sizeId);
        ctrl.popup.parent().addClass("ui-widget-content-mc");

        $timeout(function () {
            var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
            ctrl.popup.parent().css("height", svgH + "px");
            ctrl.popup.parent().css("width", svgH + 25 + "px");
            ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
        }, 0);

        ctrl.popup.parent().on("mouseover", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().addClass("x-resize");
                ctrl.closeIcon = true;
            });
        });

        ctrl.popup.parent().on("mouseout", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().removeClass("x-resize");
                if (ctrl.isTouchSupported()) {
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 3000);
                } else {
                    ctrl.closeIcon = false;
                }
            });
        });

        ctrl.isTouchSupported = function () {
            var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
            var generalTouchEnabled = "ontouchstart" in document.createElement("div");

            if (msTouchEnabled || generalTouchEnabled) {
                return true;
            }
            return false;
        };

        $scope.$on("$destroy", function (event) {
            ctrl.popup.parent().off("mouseover");
            ctrl.popup.parent().off("mouseout");
        });
    };

    // Reloads pump station view when digital settings are changed
    $scope.$on('updateDigitalSetting', function (event, args) {
        if (ctrl.pumpStationGauge && ctrl.pumpStationGauge.device && args && args.deviceId == ctrl.pumpStationGauge.device.deviceId) {
            ctrl.loadingInProgress = true;
            ctrl.getData(ctrl.pumpStationGauge.device.deviceId);
        }
    });
}

McPumpStationWidgetController.$inject = ["$", "$rootScope", "$scope", "$sce", "$element", "authenticationService", "sharedSetupService", "McPumpStationWidgetFactory", "$timeout", "McWidgetsSharedFactory", "toaster", "translationService", "deviceMenuService", "$q"];
'use strict';

angular.module('mc.pump-station-widget').component('mcPumpStationWidget', {
    controller: McPumpStationWidgetController,
    templateUrl: 'ui/pumpstation/mcpumpstationwidget/mc-pump-station-widget-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        sizeIdOverride: '@',
        settingShow: '<'
    }
});
'use strict';

function PositiveRelayFeedbackDescriptionsController(_, $, HOST, $http, $rootScope, $timeout, $scope, $sce, authenticationService, datetimeService, timeLapseService, translationService, toaster, deviceMenuService) {
    var _this = this;

    var setTimestamp = function setTimestamp(data) {
        _this.currentTime = moment(data.localDateTime).valueOf();
    };

    this.$onInit = function () {
        _this._ = _;
        _this.accountInfo = authenticationService.getAccountInfo();
        _this.langId = _this.accountInfo.preferenceUser.i18nCode === 'fr' ? _this.accountInfo.preferenceUser.i18nCode : 'en';
        _this.translation = translationService.translation;
        _this.alerts = [];
        $scope.alerts = [];
        //this.descriptions = [];
        //this.statuses = [];
        //this.acOverrides = [];
        //this.statusSelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        //this.delaySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        //this.reattemptDelaySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        //this.reattemptRetrySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.currentTime = 0;
        _this.loading = true;
        _this.ac_override_message = _this.translation.text.AC_OVERRIDE_INFO;
        // Sort of like enums. Allow me to loop through all the description fields without repeating myself
        // TODO: If we ever add support for additional languages in the DB this will need to be updated as well.
        _this.supportedLanguages = ['en', 'fr'];
        _this.descriptionFields = ['normal', 'offNormal', 'tamper'];

        timeLapseService.getLocalDateTime().then(function (resp) {
            _this.currentTime = moment(resp.data.localDateTime).valueOf();
        });

        timeLapseService.registerLocal('DIGITAL_STATUS', null, null, setTimestamp);

        $http.get(HOST + '/api/PositiveRelayFeedbacckDescription?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&languageId=' + (_this.langId === 'fr' ? 2 : 1)).then(function (resp) {
            _this.loading = false;
            if (resp.data.length === 0) {
                $scope.alerts.push({ msg: _this.translation.text.NO_DIGITAL_SETTINGS, type: 'info', languageCode: 'NO_DIGITAL_SETTINGS' });
                _this.alerts.push({ msg: _this.translation.text.NO_DIGITAL_SETTINGS, type: 'info', languageCode: 'NO_DIGITAL_SETTINGS' });
            } else {
                _this.device = { type: null };
                _this.getDeviceType(_this.deviceId);
                _this.prfDescriptions = resp.data;
                //this.descriptions = resp.data.descriptions;
                //this.statuses = resp.data.statuses;
                //this.alarmDelays = resp.data.alarmDelays;
                //this.alarmRecalls = resp.data.alarmRecalls;
                //this.acOverrides = resp.data.acOverrides;

                //for (let i = 0; i < resp.data.alarmDelays.length; i++) {
                //    this.delaySelectors[i] = `${resp.data.alarmDelays[i].delay}`;
                //}

                //for (let i = 0; i < resp.data.alarmRecalls.length; i++) {
                //    this.reattemptDelaySelectors[i] = `${resp.data.alarmRecalls[i].delayMins}`;
                //    this.reattemptRetrySelectors[i] = `${resp.data.alarmRecalls[i].retryCount}`;
                //}
            }
        }, function (resp) {
            console.log(resp.data);
        });

        //Log tab access event to NLog
        _this.postUserAction2Nlog(_this.accountInfo.customerId, _this.deviceId).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            _this.langId = langId === 'fr' ? langId : 'en';
            _this.ac_override_message = _this.translation.text.AC_OVERRIDE_INFO;
        });

        _this.$onChanges = function (changes) {
            if (changes.deviceId) {
                _this.device = null;
                _this.settings = null;
                _this.descriptions = null;
                $http.get(HOST + '/api/DigitalDescriptions?customerId=' + _this.accountInfo.customerId + '&deviceId=' + changes.deviceId.currentValue + '&timezone=' + _this.accountInfo.timeZone + '&languageId=' + (_this.langId === 'fr' ? 2 : 1)).then(function (resp) {
                    // this.device = resp.data.device;
                    _this.settings = resp.data.settings;
                    _this.descriptions = resp.data.descriptions;
                    _this.statuses = resp.data.statuses;
                    _this.alarmDelays = resp.data.alarmDelays;
                    _this.alarmRecalls = resp.data.alarmRecalls;
                    _this.acOverrides = resp.data.acOverrides;

                    for (var i = 0; i < resp.data.alarmDelays.length; i++) {
                        _this.delaySelectors[i] = '' + resp.data.alarmDelays[i].delay;
                    }
                }, function (resp) {
                    console.log(resp.data);
                });
            }
        };
    };

    this.isAdmin = function () {
        return _this.accountInfo.userRole === 'Administrator' || _this.accountInfo.userRole === 'SuperAdministrator';
    };

    this.getInputDescription = function (prfDescription) {

        return _this.translation.text.RELAY + ' #' + prfDescription.relayIdNumber;
    };

    this.isDescriptionValid = function (description) {
        if (description.length === 0) {
            return false;
        }

        return true;
    };

    this.getStateValue = function (field) {
        if (field === 'normal') {
            return 0;
        } else if (field === 'offNormal') {
            return 1;
        } else if (field === 'tamper') {
            return 2;
        }

        throw 'Error: Cannot match state value!';
    };

    this.generateTTSDescription = function (fieldValue) {
        var ttsDesc = fieldValue.replace(/\\|\//g, ' '); // Strip slashes from description
        var ttsParts = ttsDesc.split(' '); // Split the tts string into separate words

        for (var i = 0; i < ttsParts.length; i++) {
            if (ttsParts[i].toUpperCase() === ttsParts[i]) {
                // If the word is in all caps
                ttsParts[i] = ttsParts[i].split('').join(' '); // Add spaces between each letter so it will be read like an acronym
            }
        }

        ttsDesc = ttsParts.join(' '); // Rejoin the tts string from its parts
        return ttsDesc;
    };

    this.storeCurrentDescription = function (description) {
        _this.storedFieldValue = description;
    };

    this.saveDescription = function (prfDescription, relayNumber, state) {
        // Only perform a save if the description in question is valid
        var input = 69 + relayNumber; //relay 1: 70 relay 2: 71 relay 3: 72
        var description = "";
        if (state == 0) {
            description = prfDescription.relayNormal;
        } else {
            description = prfDescription.relayOffNormal;
        }
        if (_this.isDescriptionValid(description)) {
            if (description !== _this.storedFieldValue) {
                $http.put(HOST + '/api/PositiveRelayFeedbacckDescription?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&state=' + state + '&languageId=' + (_this.langId === 'fr' ? 2 : 1) + '&input=' + input, prfDescription).then(function (resp) {
                    if (resp.data !== 1) {
                        toaster.pop('error', _this.translation.text.RTU_CONFIGURATION, _this.translation.text.ERROR_REOPEN_WINDOW);
                    }
                }, function (resp) {
                    toaster.pop('error', _this.translation.text.RTU_CONFIGURATION, resp.data);
                });
            }
        }
    };

    this.disableInput = function (idx) {
        if (_this.statuses[idx] !== null) {
            if (moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
                var globalVarId = _this.statuses[idx].id;
                $http.delete(HOST + '/api/DigitalStatus?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&channel=' + (idx + 1) + '&globalVarId=' + globalVarId + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                    if (resp.data > 0) {
                        _this.statuses[idx] = null;
                    }

                    $http.post(HOST + '/api/DigitalStatus?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&channel=' + (idx + 1) + '&duration=' + _this.statusSelectors[idx] + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                        if (resp.data) {
                            _this.statuses[idx] = resp.data;
                        }
                    });
                });
            }
        } else {
            $http.post(HOST + '/api/DigitalStatus?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&channel=' + (idx + 1) + '&duration=' + _this.statusSelectors[idx] + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                if (resp.data) {
                    _this.statuses[idx] = resp.data;
                }
            });
        }
    };

    this.enableInput = function (idx) {
        var globalVarId = _this.statuses[idx].id;
        $http.delete(HOST + '/api/DigitalStatus?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&channel=' + (idx + 1) + '&globalVarId=' + globalVarId + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
            if (resp.data > 0) {
                _this.statuses[idx] = null;
            }
        });
    };

    this.isInputDisabled = function (idx) {
        if (_this.statuses[idx] !== null) {
            if (_this.statuses[idx].dateTime !== null && moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
                return false;
            }
            return true;
        }

        return false;
    };

    this.getCurrentStatus = function (idx) {
        if (_this.statuses[idx] === null) {
            return _this.translation.text.ENABLED;
        } else if (_this.statuses[idx].dateTime === null) {
            return _this.translation.text.DISABLED + ' ' + _this.translation.text.INDEFINITELY;
        }

        if (moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
            return _this.translation.text.ENABLED;
        }

        return _this.translation.text.DISABLED_UNTIL + ' ' + datetimeService.formatDateAgentText(_this.statuses[idx].dateTime, 'yyyy-MM-ddTHH:mm:ss', false, _this.accountInfo.preferenceUser.timeFormat);
    };

    this.getAlarmDelayDisplay = function (idx) {
        if (_this.alarmDelays[idx].entryType === 0) {
            return _this.translation.text.ENTRY_FACTORY;
        } else if (_this.alarmDelays[idx].entryType === 1) {
            return _this.translation.text.ENTRY_CUSTOMER;
        } else if (_this.alarmDelays[idx].entryType === 2) {
            return _this.translation.text.ENTRY_UNIT;
        }

        return _this.translation.text.ENTRY_UNKNOWN;
    };

    this.getDeviceType = function (deviceId) {
        deviceMenuService.getDeviceMenuList(_this.accountInfo.customerId).then(function (result) {
            var _devices = result.data.devices;

            for (var index = 0; index < _devices.length; ++index) {
                if (_devices[index].deviceId === deviceId) {
                    _this.device.type = _devices[index].model;
                    break;
                }
            }
        }, function (error) {
            console.log("device type error");
        });
    };

    this.saveAlarmDelay = function (idx) {
        var duration = _this.delaySelectors[idx];

        if (parseInt(duration, 10) === 32767) {
            // Delete
            if (_this.alarmDelays[idx].entryType === 2 && _this.alarmDelays[idx].id !== 0) {
                $http.delete(HOST + '/api/DigitalAlarmDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&entryId=' + _this.alarmDelays[idx].id).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            }
        } else {
            if (_this.alarmDelays[idx].entryType === 2 && _this.alarmDelays[idx].id !== 0) {
                // Update
                $http.put(HOST + '/api/DigitalAlarmDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&delay=' + duration + '&entryId=' + _this.alarmDelays[idx].id).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            } else {
                // Insert
                $http.post(HOST + '/api/DigitalAlarmDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&delay=' + duration).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            }
        }
    };

    this.getAlarmRecallDescription = function (idx) {
        if (_this.alarmRecalls[idx].entryType === 0) {
            return _this.translation.text.ENTRY_FACTORY;
        } else if (_this.alarmRecalls[idx].entryType === 1) {
            return _this.translation.text.ENTRY_CUSTOMER;
        } else if (_this.alarmRecalls[idx].entryType === 2) {
            return _this.translation.text.ENTRY_UNIT;
        }

        return _this.translation.text.ENTRY_UNKNOWN;
    };

    this.saveAlarmRecall = function (idx) {
        var delay = _this.reattemptDelaySelectors[idx];
        var retries = _this.reattemptRetrySelectors[idx];

        if (parseInt(delay, 10) === 0 && parseInt(retries, 10) !== 0) {
            retries = 0;
        }

        if (parseInt(delay, 10) > 0 && parseInt(retries, 10) === 0) {
            retries = 1;
        }

        if (parseInt(delay, 10) === 32767) {
            if (_this.alarmRecalls[idx].entryType === 2 && _this.alarmRecalls[idx].id !== 0) {
                // Delete
                $http.delete(HOST + '/api/DigitalAlarmRecall?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&entryId=' + _this.alarmRecalls[idx].id).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            }
        } else {
            if (_this.alarmRecalls[idx].entryType === 2 && _this.alarmRecalls[idx].id !== 0) {
                // Update
                $http.put(HOST + '/api/DigitalAlarmRecall?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&delay=' + delay + '&entryId=' + _this.alarmRecalls[idx].id + '&retries=' + retries).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            } else {
                // Insert
                $http.post(HOST + '/api/DigitalAlarmRecall?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&delay=' + delay + '&retries=' + retries).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            }
        }
    };

    this.toggleOverride = function (idx) {
        if (_this.acOverrides[idx].entryType === 2) {
            $http.put(HOST + '/api/DigitalACOverride?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&value=' + _this.acOverrides[idx].value + '&entryId=' + _this.acOverrides[idx].id).then(function (resp) {
                _this.acOverrides[idx] = resp.data;
            });
        } else {
            $http.post(HOST + '/api/DigitalACOverride?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&value=' + _this.acOverrides[idx].value).then(function (resp) {
                _this.acOverrides[idx] = resp.data;
            });
        }
    };

    this.postUserAction2Nlog = function (customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Positive Relay Feedback";

        return $http({
            method: 'POST',
            url: HOST + '/api/PositiveRelayFeedbacckDescription',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    this.$onDestroy = function () {
        timeLapseService.unRegisterLocal('DIGITAL_STATUS', null, null, setTimestamp);
    };
}

PositiveRelayFeedbackDescriptionsController.$inject = ['_', '$', 'HOST', '$http', '$rootScope', '$timeout', '$scope', '$sce', 'authenticationService', 'datetimeService', 'timeLapseService', 'translationService', 'toaster', 'deviceMenuService'];
'use strict';

angular.module('mc.rtu-configuration').component('positiveRelayFeedbackDescriptions', {
    controller: PositiveRelayFeedbackDescriptionsController,
    transclude: true,
    templateUrl: 'ui/rtuconfiguration/positiverelayfeedbackdescriptions/positive-relay-feedback-description-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        deviceId: '<',
        deviceName: '<',
        deviceTypeId: '<'
    }
});
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PulseDescriptionsController(_, $, HOST, $http, $rootScope, $timeout, $scope, $sce, authenticationService, datetimeService, timeLapseService, translationService, toaster) {
    var _this = this;

    var setTimestamp = function setTimestamp(data) {
        _this.currentTime = moment(data.localDateTime).valueOf();
    };

    this.$onInit = function () {
        _this._ = _;
        _this.accountInfo = authenticationService.getAccountInfo();
        _this.langId = _this.accountInfo.preferenceUser.i18nCode === 'fr' ? _this.accountInfo.preferenceUser.i18nCode : 'en';
        _this.translation = translationService.translation;
        _this.alerts = [];
        $scope.alerts = [];
        _this.descriptions = [];
        _this.originalDescriptions = [];
        _this.statuses = [];
        _this.acOverrides = [];
        _this.statusSelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.delaySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.reattemptDelaySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.reattemptRetrySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.currentTime = 0;
        _this.loading = true;
        _this.fixed_time_info = "HH:MM:SS";
        _this.set_time_message = _this.translation.text.SET_TIME_INFO;
        _this.ac_override_message = _this.translation.text.AC_OVERRIDE_INFO;
        // Sort of like enums. Allow me to loop through all the description fields without repeating myself
        // TODO: If we ever add support for additional languages in the DB this will need to be updated as well.
        _this.supportedLanguages = ['en', 'fr'];
        _this.descriptionFields = ['lowRestore', 'highRestore', 'lowFault', 'highFault'];
        _this.hrValid = false;
        _this.lrValid = false;
        _this.lowAlarmErrorMsg = "";
        _this.lowRestoreErrorMsg = "";
        _this.highRestoreErrorMsg = "";
        _this.highAlarmErrorMsg = "";

        timeLapseService.getLocalDateTime().then(function (resp) {
            _this.currentTime = moment(resp.data.localDateTime).valueOf();
        });

        timeLapseService.registerLocal('DIGITAL_STATUS', null, null, setTimestamp);
        $http.get(HOST + '/api/PulseDescriptions?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceModel=' + _this.deviceTypeId + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
            _this.loading = false;
            if (resp.data.settings.length === 0) {
                $scope.alerts.push({ msg: _this.translation.message.NO_PULSE_SETUP, type: 'info', languageCode: 'NO_PULSE_SETUP' });
                _this.alerts.push({ msg: _this.translation.message.NO_PULSE_SETUP, type: 'info', languageCode: 'NO_PULSE_SETUP' });
            } else {
                //this.device = resp.data.device;
                _this.settings = resp.data.settings;
                _this.descriptions = resp.data.descriptions;
                _this.originalDescriptions = resp.data.descriptions;
                _this.statuses = resp.data.statuses;
                _this.alarmDelays = resp.data.alarmDelays;
                _this.alarmRecalls = resp.data.alarmRecalls;
                _this.thresholds = resp.data.thresholds;
                _this.thresholds.haTouched = false;
                _this.thresholds.hrTouched = false;
                _this.thresholds.laTouched = false;
                _this.thresholds.lrTouched = false;
                //this.acOverrides = resp.data.acOverrides;

                for (var i = 0; i < _this.thresholds.length; i++) {
                    if (_this.thresholds[i].rangeMins || _this.thresholds[i].setTime) _this.thresholds[i].showFlowAlarm = true;
                    if (_this.thresholds[i].setTimeValue) _this.thresholds[i].setTimeValue = _this.thresholds[i].setTimeValue.substr(11);
                }

                for (var _i = 0; _i < resp.data.alarmDelays.length; _i++) {
                    _this.delaySelectors[_i] = '' + resp.data.alarmDelays[_i].delay;
                }

                for (var _i2 = 0; _i2 < resp.data.alarmRecalls.length; _i2++) {
                    _this.reattemptDelaySelectors[_i2] = '' + resp.data.alarmRecalls[_i2].delayMins;
                    _this.reattemptRetrySelectors[_i2] = '' + resp.data.alarmRecalls[_i2].retryCount;
                }

                // TODO: Do we need to clean any instances of ##2? Why is ##1 the only one that's hidden from the user.

                var _loop = function _loop(_i3) {
                    _this.supportedLanguages.forEach(function (lang) {
                        _this.descriptionFields.forEach(function (field) {
                            if (_this.descriptions[_i3][lang][field]) {
                                _this.descriptions[_i3][lang][field] = _this.descriptions[_i3][lang][field].replace(/##1|\(##1\)/g, '').trim();
                            }
                        });
                    });
                };

                for (var _i3 = 0; _i3 < _this.descriptions.length; _i3++) {
                    _loop(_i3);
                }
            }
        }, function (resp) {
            console.log(resp.data);
        });

        //Log tab access event to NLog
        _this.postUserAction2Nlog(_this.accountInfo.customerId, _this.deviceId).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            _this.langId = langId === 'fr' ? langId : 'en';
            _this.ac_override_message = _this.translation.text.AC_OVERRIDE_INFO;
        });

        //this.$onChanges = (changes) => {
        //    if (changes.deviceId) {
        //        this.device = null;
        //        this.settings = null;
        //        this.descriptions = null;
        //        $http.get(`${HOST}/api/DigitalDescriptions?customerId=${this.accountInfo.customerId}&deviceId=${changes.deviceId.currentValue}&timezone=${this.accountInfo.timeZone}`).then((resp) => {
        //            this.device = resp.data.device;
        //            this.settings = resp.data.settings;
        //            this.descriptions = resp.data.descriptions;
        //            this.statuses = resp.data.statuses;
        //            this.alarmDelays = resp.data.alarmDelays;
        //            this.alarmRecalls = resp.data.alarmRecalls;
        //            this.acOverrides = resp.data.acOverrides;

        //            for (let i = 0; i < resp.data.alarmDelays.length; i++) {
        //                this.delaySelectors[i] = `${resp.data.alarmDelays[i].delay}`;
        //            }
        //        }, (resp) => {
        //            console.log(resp.data);
        //        });
        //    }
        //};
    };

    this.isAdmin = function () {
        return _this.accountInfo.userRole === 'Administrator' || _this.accountInfo.userRole === 'SuperAdministrator';
    };

    this.getInputDescription = function (setting) {
        return setting.channelName || _this.translation.text.DIGITAL + ' ' + _this.translation.text.INPUT + ' #' + setting.channel;
    };

    this.isDescriptionValid = function (idx, field) {
        if (_this.descriptions[idx]) {
            if (!_this.descriptions[idx][_this.langId][field]) {
                return false;
            }
            return true;
        } else {
            return false;
        }
    };

    this.isValidAlarmValue = function (threshold, field) {
        if (field === 'lowAlarm' && threshold.laTouched) {
            if (threshold.lowAlarm === null || threshold.lowAlarm === "") {
                _this.lowAlarmErrorMsg = _this.translation.text.REQUIRED;
                return false;
            } else if (Number(threshold.lowAlarm) <= 0) {
                _this.lowAlarmErrorMsg = _this.translation.text.LOW_ALARM_ZERO;
                return false;
            } else if (Number(threshold.lowAlarm) > 0 && (threshold.lowRestore == null || threshold.lowRestore == "")) {
                _this.lrValid = true;
                _this.lowRestoreErrorMsg = _this.translation.text.REQUIRED;
                return true;
            } else {
                return true;
            }
        } else if (field === 'lowRestore' && threshold.lrTouched) {
            if (threshold.lowRestore === null || threshold.lowRestore === "") {
                _this.lowRestoreErrorMsg = _this.translation.text.REQUIRED;
                return false;
            } else if (Number(threshold.lowRestore) <= 0) {
                _this.lowRestoreErrorMsg = _this.translation.text.LOW_RESTORE_ZERO;
                return false;
            } else if (Number(threshold.lowRestore) <= Number(threshold.lowAlarm)) {
                _this.lowRestoreErrorMsg = _this.translation.text.LOW_RESTORE_GREATER_LOW_ALARM;
                return false;
            } else if (Number(threshold.lowRestore) > 0) {
                _this.lrValid = false;
                return true;
            } else {
                return true;
            }
        } else if (field === 'highRestore' && threshold.hrTouched) {
            if (threshold.highRestore === null || threshold.highRestore === "") {
                _this.highRestoreErrorMsg = _this.translation.text.REQUIRED;
                return false;
            } else if (Number(threshold.highRestore) <= 0) {
                _this.highRestoreErrorMsg = _this.translation.text.HIGH_RESTORE_ZERO;
                return false;
            } else if (Number(threshold.highRestore) >= Number(threshold.highAlarm)) {
                _this.highRestoreErrorMsg = _this.translation.text.HIGH_RESTORE_LESS_HIGH_ALARM;
                return false;
            } else if (Number(threshold.highRestore) > 0) {
                _this.hrValid = false;
                return true;
            } else {
                return true;
            }
        } else if (field === 'highAlarm' && threshold.haTouched) {
            if (threshold.highAlarm === null || threshold.highAlarm === "") {
                _this.highAlarmErrorMsg = _this.translation.text.REQUIRED;
                return false;
            } else if (Number(threshold.highAlarm) <= 0) {
                _this.highAlarmErrorMsg = _this.translation.text.HIGH_ALARM_ZERO;
                return false;
            } else if (Number(threshold.highAlarm) > 0 && (threshold.highRestore == null || threshold.highRestore == "")) {
                _this.hrValid = true;
                _this.highRestoreErrorMsg = _this.translation.text.REQUIRED;
                return true;
            } else {
                return true;
            }
        } else {
            return true;
        }
    };

    this.getStateValue = function (field) {
        if (field === 'lowRestore') {
            return 10;
        } else if (field === 'highRestore') {
            return 11;
        } else if (field === 'lowFault') {
            return 12;
        } else if (field === 'highFault') {
            return 13;
        }

        throw 'Error: Cannot match state value!';
    };

    this.generateTTSDescription = function (fieldValue) {
        var ttsDesc = fieldValue.replace(/\\|\//g, ' '); // Strip slashes from description
        var ttsParts = ttsDesc.split(' '); // Split the tts string into separate words

        for (var i = 0; i < ttsParts.length; i++) {
            if (ttsParts[i].toUpperCase() === ttsParts[i]) {
                // If the word is in all caps
                ttsParts[i] = ttsParts[i].split('').join(' '); // Add spaces between each letter so it will be read like an acronym
            }
        }

        ttsDesc = ttsParts.join(' '); // Rejoin the tts string from its parts
        return ttsDesc;
    };

    this.storeCurrentDescription = function (idx, field) {
        _this.storedFieldValue = _this.descriptions[idx][_this.langId][field];
    };

    this.disableInput = function (idx) {
        if (_this.statuses[idx] !== null) {
            if (moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
                var globalVarId = _this.statuses[idx].id;
                $http.delete(HOST + '/api/PulseDescription/EnableAlarm?deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&customerId=' + _this.accountInfo.customerId + '&channel=' + _this.settings[idx].channel + '&globalVarId=' + globalVarId + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                    if (resp.data > 0) {
                        _this.statuses[idx] = null;
                    }

                    $http.post(HOST + '/api/PulseDescription/DisableAlarm?deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&customerId=' + _this.accountInfo.customerId + '&channel=' + _this.settings[idx].channel + '&duration=' + _this.statusSelectors[idx] + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                        if (resp.data) {
                            _this.statuses[idx] = resp.data;
                        }
                    });
                });
            }
        } else {
            $http.post(HOST + '/api/PulseDescription/DisableAlarm?deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&customerId=' + _this.accountInfo.customerId + '&channel=' + _this.settings[idx].channel + '&duration=' + _this.statusSelectors[idx] + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                if (resp.data) {
                    _this.statuses[idx] = resp.data;
                }
            });
        }
    };

    this.enableInput = function (idx) {
        var globalVarId = _this.statuses[idx].id;
        $http.delete(HOST + '/api/PulseDescription/EnableAlarm?deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&customerId=' + _this.accountInfo.customerId + '&channel=' + _this.settings[idx].channel + '&globalVarId=' + globalVarId + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
            if (resp.data > 0) {
                _this.statuses[idx] = null;
            }
        });
    };

    this.isInputDisabled = function (idx) {
        if (_this.statuses[idx] !== null) {
            if (_this.statuses[idx].dateTime !== null && moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
                return false;
            }
            return true;
        }

        return false;
    };

    this.getCurrentStatus = function (idx) {
        if (_this.statuses[idx] === null) {
            return _this.translation.text.ENABLED;
        } else if (_this.statuses[idx].dateTime === null) {
            return _this.translation.text.DISABLED + ' ' + _this.translation.text.INDEFINITELY;
        }

        if (moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
            return _this.translation.text.ENABLED;
        }

        return _this.translation.text.DISABLED_UNTIL + ' ' + datetimeService.formatDateAgentText(_this.statuses[idx].dateTime, 'yyyy-MM-ddTHH:mm:ss', false, _this.accountInfo.preferenceUser.timeFormat);
    };

    this.getAlarmDelayDisplay = function (idx) {
        if (_this.alarmDelays[idx].entryType === 0) {
            return _this.translation.text.ENTRY_FACTORY;
        } else if (_this.alarmDelays[idx].entryType === 1) {
            return _this.translation.text.ENTRY_CUSTOMER;
        } else if (_this.alarmDelays[idx].entryType === 2) {
            return _this.translation.text.ENTRY_UNIT;
        }

        return _this.translation.text.ENTRY_UNKNOWN;
    };

    this.saveAlarmDelay = function (idx) {
        var duration = _this.delaySelectors[idx];

        if (parseInt(duration, 10) === 32767) {
            // Delete
            if (_this.alarmDelays[idx].entryType === 2 && _this.alarmDelays[idx].id !== 0) {
                $http.delete(HOST + '/api/PulseDescription/DeleteDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&entryId=' + _this.alarmDelays[idx].id).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            }
        } else {
            if (_this.alarmDelays[idx].entryType === 2 && _this.alarmDelays[idx].id !== 0) {
                // Update
                $http.put(HOST + '/api/PulseDescription/UpdateDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&delay=' + duration + '&entryId=' + _this.alarmDelays[idx].id).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            } else {
                // Insert
                $http.post(HOST + '/api/PulseDescription/AddDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&delay=' + duration).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            }
        }
    };

    this.getAlarmRecallDescription = function (idx) {
        if (_this.alarmRecalls[idx].entryType === 0) {
            return _this.translation.text.ENTRY_FACTORY;
        } else if (_this.alarmRecalls[idx].entryType === 1) {
            return _this.translation.text.ENTRY_CUSTOMER;
        } else if (_this.alarmRecalls[idx].entryType === 2) {
            return _this.translation.text.ENTRY_UNIT;
        }

        return _this.translation.text.ENTRY_UNKNOWN;
    };

    this.saveAlarmRecall = function (idx) {
        var delay = _this.reattemptDelaySelectors[idx];
        var retries = _this.reattemptRetrySelectors[idx];

        if (parseInt(delay, 10) === 0 && parseInt(retries, 10) !== 0) {
            retries = 0;
        }

        if (parseInt(delay, 10) > 0 && parseInt(retries, 10) === 0) {
            retries = 1;
        }

        if (parseInt(delay, 10) === 32767) {
            if (_this.alarmRecalls[idx].entryType === 2 && _this.alarmRecalls[idx].id !== 0) {
                // Delete
                $http.delete(HOST + '/api/PulseDescription/DeleteReattempt?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&entryId=' + _this.alarmRecalls[idx].id).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            }
        } else {
            if (_this.alarmRecalls[idx].entryType === 2 && _this.alarmRecalls[idx].id !== 0) {
                // Update
                $http.put(HOST + '/api/PulseDescription/UpdateReattempt?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&delay=' + delay + '&entryId=' + _this.alarmRecalls[idx].id + '&retries=' + retries).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            } else {
                // Insert
                $http.post(HOST + '/api/PulseDescription/AddReattempt?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&delay=' + delay + '&retries=' + retries).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            }
        }
    };

    this.storePrevious = function (threshold) {
        _this.previousThreshold = JSON.parse(JSON.stringify(threshold));
    };

    var _timeout = [];

    this.updateRange = function (idx, threshold, field) {
        if (field === 'LOW_ALARM') {
            if (threshold.lowAlarm === _this.previousThreshold.lowAlarm) {
                return;
            }
            if (threshold.rangeMinsSetTime < 15) {
                return;
            }
        } else if (field === 'LOW_RESTORE') {
            if (threshold.lowRestore === _this.previousThreshold.lowRestore) {
                return;
            }
            if (threshold.rangeMinsSetTime < 15) {
                return;
            }
        } else if (field === 'HIGH_RESTORE') {
            if (threshold.highRestore === _this.previousThreshold.highRestore) {
                return;
            }
            if (threshold.rangeMinsSetTime < 15) {
                return;
            }
        } else if (field === 'HIGH_ALARM') {
            if (threshold.highAlarm === _this.previousThreshold.highAlarm) {
                return;
            }
            if (threshold.highAlarm > 0 && threshold.setTime) {
                //highAlarm value should be higher than/equal to flowScale
                if (threshold.highAlarm < _this.settings[idx].flowScale) threshold.highAlarm = _this.settings[idx].flowScale;
                threshold.highRestore = threshold.highAlarm - 1;
            }
            if (threshold.rangeMinsSetTime < 15 && !threshold.setTime) {
                return;
            }
        } else if (field == 'RANGE_SET_MINS') {
            if (threshold.rangeMinsSetTime === _this.previousThreshold.rangeMinsSetTime) {
                return;
            }
            if (threshold.rangeMinsSetTime < 15) {
                return;
            }
        } else if (field == 'SET_TIME_VALUE') {
            if (threshold.setTimeValue === _this.previousThreshold.setTimeValue) {
                return;
            }
            if (!threshold.setTimeValue) {
                return;
            }
        }

        $timeout.cancel(_timeout[idx]);

        _timeout[idx] = $timeout(function () {
            var setting = _this.settings[idx];
            saveData(idx);
        }, 3000);
    };

    var saveData = function saveData(idx) {
        if (_this.isValid(_this.thresholds[idx])) {
            $http.post(HOST + '/api/PulseDescriptions?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&deviceName=' + encodeURIComponent(_this.deviceName), _this.thresholds[idx]).then(function (resp) {}, function (resp) {});
        }
    };

    this.isValid = function (threshold) {
        //if (!threshold.lowThresholds || !threshold.highThresholds) {
        //    return true;
        //}
        if (threshold.setTime) {
            if (threshold.highAlarm && threshold.highAlarm !== 0) {
                return true;
            } else {
                return false;
            }
        } else if (threshold.rangeMins) {
            if (Number(threshold.rangeMinsSetTime) < 15) {
                return false;
            }
            if (threshold.highAlarm && threshold.highRestore && threshold.lowAlarm && threshold.lowRestore) {
                if (Number(threshold.lowAlarm) >= Number(threshold.highAlarm)) {
                    return false;
                }
                if (Number(threshold.lowRestore) > Number(threshold.highRestore)) {
                    return false;
                }
            }
            if (threshold.highAlarm && Number(threshold.highAlarm) > 0 && threshold.highRestore && Number(threshold.highRestore) > 0 && threshold.lowAlarm == null && threshold.lowRestore == null) {
                if (Number(threshold.highRestore) < Number(threshold.highAlarm)) {
                    return true;
                }
            }
            if (threshold.lowAlarm && Number(threshold.lowAlarm) > 0 && threshold.lowRestore && Number(threshold.lowRestore) > 0 && threshold.highAlarm == null && threshold.highRestore == null) {
                if (Number(threshold.lowRestore) > Number(threshold.lowAlarm)) {
                    return true;
                }
            }
            if ((threshold.lowAlarm == null || threshold.lowAlarm == "" || Number(threshold.lowAlarm) == 0) && (threshold.lowRestore == null || threshold.lowRestore == "" || Number(threshold.lowRestore) == 0) && (threshold.highRestore == null || threshold.highRestore == "" || Number(threshold.highRestore) == 0) && (threshold.highAlarm == null || threshold.highAlarm == "" || Number(threshold.highAlarm) == 0)) {
                return false;
            }
            if (Number(threshold.lowAlarm) == 0 || Number(threshold.lowRestore) == 0 || Number(threshold.highRestore) == 0 || Number(threshold.highAlarm) == 0) {
                return false;
            }
            if (threshold.highAlarm && threshold.highRestore == null || threshold.highAlarm == null && threshold.highRestore) {
                return false;
            }
            if (threshold.lowAlarm && threshold.lowRestore == null || threshold.lowAlarm == null && threshold.lowRestore) {
                return false;
            }
            if ((threshold.lowAlarm || threshold.lowRestore) && (threshold.highAlarm == null || threshold.highAlarm == "") && (threshold.highRestore == null || threshold.highRestore == "")) {
                if (Number(threshold.lowAlarm) <= 0) {
                    return false;
                }
                if (Number(threshold.lowRestore) <= 0) {
                    return false;
                }
                if (Number(threshold.lowRestore) <= Number(threshold.lowAlarm)) {
                    return false;
                }
            }
            if ((threshold.highAlarm || threshold.highRestore) && (threshold.lowAlarm == null || threshold.lowAlarm == "") && (threshold.lowRestore == null || threshold.lowRestore == "")) {
                if (Number(threshold.highRestore) <= 0) {
                    return false;
                }
                if (Number(threshold.highAlarm) <= 0) {
                    return false;
                }
                if (Number(threshold.highRestore) >= Number(threshold.highAlarm)) {
                    return false;
                }
            }
            if (threshold.lowAlarm && threshold.lowRestore && threshold.highRestore && threshold.highAlarm) {
                if (Number(threshold.lowRestore) <= Number(threshold.lowAlarm)) {
                    return false;
                }
                if (Number(threshold.highRestore) >= Number(threshold.highAlarm)) {
                    return false;
                }
            }
            //if (threshold.lowAlarm > threshold.highAlarm) {
            //    return false;
            //}

            //if (threshold.lowRestore > threshold.highRestore) {
            //    return false;
            //}
        }

        return true;
    };

    this.updateType = function (idx, threshold, type) {
        if (type == 'SET_TIME') {
            threshold.setTime = true;
            threshold.rangeMins = false;
            threshold.rangeMinsSetTime = 0;
            threshold.lowAlarm = null;
            threshold.lowRestore = null;
            threshold.highRestore = null;
            _this.updateRange(idx, threshold, 'SET_TIME_VALUE');
        } else {
            threshold.setTime = false;
            threshold.setTimeValue = null;
            threshold.rangeMins = true;
            _this.updateRange(idx, threshold, 'RANGE_SET_MINS');
        }
    };

    this.setFlowAlarm = function (idx, threshold) {
        _this.showFlowAlarm = !_this.showFlowAlarm;
        if (threshold.rangeMins || threshold.setTime) {
            threshold.setTime = false;
            threshold.rangeMins = false;
            threshold.rangeMinsSetTime = 0;
            threshold.lowAlarm = null;
            threshold.lowRestore = null;
            threshold.highRestore = null;
            threshold.highAlarm = null;
            $http.post(HOST + '/api/PulseDescriptions?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&deviceName=' + encodeURIComponent(_this.deviceName), _this.thresholds[idx]).then(function (resp) {}, function (resp) {});
        }
    };

    this.saveDescription = function (idx, idx2, field) {
        // Only perform a save if the description in question is valid
        if (_this.isDescriptionValid(idx, field)) {
            var fieldValue = _this.descriptions[idx][_this.langId][field];
            if (fieldValue !== _this.storedFieldValue) {
                if (_this.descriptions[idx][_this.langId].entryType === 0 || _this.descriptions[idx][_this.langId].entryType === 1) {
                    var _fullDescriptionValue;

                    var fullDescriptionValues = (_fullDescriptionValue = {
                        entryType: _this.descriptions[idx][_this.langId].entryType
                    }, _defineProperty(_fullDescriptionValue, field, _this.descriptions[idx][_this.langId][field] + ' (##1)'), _defineProperty(_fullDescriptionValue, 'tts' + field, _this.generateTTSDescription(fieldValue)), _fullDescriptionValue);

                    // Since we have to save all 4 fields as 'custom' when only 1 is changed (the first time) we need to make sure ALL 4 fields are valid, and if they aren't we'll place the defaults in
                    _this.descriptionFields.forEach(function (descField) {
                        if (descField !== field) {
                            if (!_this.isDescriptionValid(idx, descField)) {
                                fullDescriptionValues[descField] = _this.originalDescriptions[idx][_this.langId][descField] + ' (##1)';
                                fullDescriptionValues['tts' + descField] = _this.originalDescriptions[idx][_this.langId][descField] + ' ##1';
                            } else {
                                fullDescriptionValues[descField] = _this.descriptions[idx][_this.langId][descField] + ' (##1)';
                                fullDescriptionValues['tts' + descField] = _this.descriptions[idx][_this.langId][descField] + ' ##1';
                            }
                        }
                    });

                    $http.post(HOST + '/api/PulseDescriptions?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&channel=' + _this.settings[idx2].channel + '&languageId=' + (_this.langId === 'fr' ? 2 : 1), fullDescriptionValues).then(function (resp) {
                        _this.descriptions[idx][_this.langId].entryType = 2;
                        if (resp.data !== 4) {
                            toaster.pop('error', _this.translation.text.RTU_CONFIGURATION, _this.translation.text.ERROR_REOPEN_WINDOW);
                        }
                    }, function (resp) {
                        toaster.pop('error', _this.translation.text.RTU_CONFIGURATION, resp.data);
                    });
                } else if (_this.descriptions[idx][_this.langId].entryType === 2) {
                    var simpleDescription = {
                        description: fieldValue + ' (##1)',
                        ttsdescription: _this.generateTTSDescription(fieldValue)
                    };

                    $http.put(HOST + '/api/PulseDescriptions?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&channel=' + _this.settings[idx2].channel + '&state=' + _this.getStateValue(field) + '&languageId=' + (_this.langId === 'fr' ? 2 : 1), simpleDescription).then(function (resp) {
                        if (resp.data !== 1) {
                            toaster.pop('error', _this.translation.text.RTU_CONFIGURATION, _this.translation.text.ERROR_REOPEN_WINDOW);
                        }
                    }, function (resp) {
                        toaster.pop('error', _this.translation.text.RTU_CONFIGURATION, resp.data);
                    });
                }
            }
        }
    };

    this.postUserAction2Nlog = function (customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Pulse Descriptions";

        return $http({
            method: 'POST',
            url: HOST + '/api/PulseDescriptions',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    //this.toggleOverride = (idx) => {
    //    if (this.acOverrides[idx].entryType === 2) {
    //        $http.put(`${HOST}/api/DigitalACOverride?customerId=${this.accountInfo.customerId}&deviceId=${this.deviceId}&input=${idx + 1}&value=${this.acOverrides[idx].value}&entryId=${this.acOverrides[idx].id}`).then((resp) => {
    //            this.acOverrides[idx] = resp.data;
    //        });
    //    } else {
    //        $http.post(`${HOST}/api/DigitalACOverride?customerId=${this.accountInfo.customerId}&deviceId=${this.deviceId}&input=${idx + 1}&value=${this.acOverrides[idx].value}`).then((resp) => {
    //            this.acOverrides[idx] = resp.data;
    //        });
    //    }
    //};

    this.$onDestroy = function () {
        timeLapseService.unRegisterLocal('DIGITAL_STATUS', null, null, setTimestamp);
    };
}

PulseDescriptionsController.$inject = ['_', '$', 'HOST', '$http', '$rootScope', '$timeout', '$scope', '$sce', 'authenticationService', 'datetimeService', 'timeLapseService', 'translationService', 'toaster'];
'use strict';

angular.module('mc.rtu-configuration').component('pulseDescriptions', {
    controller: PulseDescriptionsController,
    transclude: true,
    templateUrl: 'ui/rtuconfiguration/pulsedescriptions/pulse-descriptions-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        deviceId: '<',
        deviceName: '<',
        deviceTypeId: '<'
    }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PulseFlowWidgetModel(_, HOST, $http, $timeout, $rootScope) {
    var PulseFlow = function () {
        function PulseFlow(customerId, deviceId) {
            _classCallCheck(this, PulseFlow);

            this._device = {};
            this._channel = {
                values: [],
                sum: 0
            };
            this._setting = {};
            this._loading = false;
            this._customerId = customerId;
            this._deviceId = deviceId;
            this._timeout = null;
        }

        _createClass(PulseFlow, [{
            key: 'addPoint',
            value: function addPoint(point, isRawCount, group) {
                if (isRawCount && group == 6) {
                    var previousPoint = this._channel.values.length > 0 ? this._channel.values[0].scaledValue : null;
                    this._channel.values[0].scaledValue = previousPoint + point.scaledValue;
                    this._channel.values[0].localTime = point.localTime;
                } else if (isRawCount) {
                    this._channel.values[0] = point;
                } else {
                    this._channel.values.unshift(point);
                }
            }
        }, {
            key: 'fetchSettings',
            value: function fetchSettings() {
                var _this = this;

                this._loading = true;
                return $http.get(HOST + '/api/PulseFlowWidget?customerId=' + this._customerId + '&deviceId=' + this._deviceId).then(function (resp) {
                    _this._loading = false;
                    //console.log(resp);
                    return resp;
                });
            }
        }, {
            key: 'cleanupOldChannelValues',
            value: function cleanupOldChannelValues(heartbeatMsg) {
                //logic to remove older values from the list based on time range/group (15, 60... minutes etc)
                if (this._channel.values.length > 0) {
                    //compare the oldest point's local time against the heartbeat's local time (both wall-clock);
                    //using the difference of two new Date() values cancels the browser offset so the window math
                    //is timezone-safe. (utcUnixTimeStamp is on a different scale than new Date(LocalDateTime).)
                    var lastDate = new Date(this._channel.values[this._channel.values.length - 1].localTime).getTime();

                    var intervalEnd = new Date(heartbeatMsg.LocalDateTime).getTime() - 15 * 60 * 1000;
                    switch (this._setting.selectedGroup) {
                        case '2':
                            intervalEnd = new Date(heartbeatMsg.LocalDateTime).getTime() - 60 * 60 * 1000;
                            break;
                        case '3':
                            intervalEnd = new Date(heartbeatMsg.LocalDateTime).getTime() - 6 * 60 * 60 * 1000;
                            break;
                        case '4':
                            intervalEnd = new Date(heartbeatMsg.LocalDateTime).getTime() - 24 * 60 * 60 * 1000;
                            break;
                        case '5':
                            intervalEnd = new Date(heartbeatMsg.LocalDateTime).setHours(0, 0, 0, 0);
                            break;
                    }
                    //var momenttz = "America/New_York";
                    //var lastDateTime = moment(lastDate).tz(momenttz).format('YYYY-MM-DD hh:mm:ss');
                    //console.log("lastDate-Time: " + lastDateTime);
                    //var intervalEndTime = moment(intervalEnd).tz(momenttz).format('YYYY-MM-DD hh:mm:ss');
                    //console.log("intervalEnd-Time: " + intervalEndTime); 

                    if (lastDate < intervalEnd && this._setting.selectedGroup != '6') {
                        this._channel.values.pop();
                    }
                    this.createTimeout();
                }
                //calculate total for given channel
                this._channel.sum = this.sumPoints();
            }
        }, {
            key: 'updateColorWidget',
            value: function updateColorWidget(channel, color) {
                var _this2 = this;

                var encodedColor = encodeURIComponent(color);
                this._loading = true;
                $timeout.cancel(this._timeout);
                return $http.put(HOST + '/api/PulseFlowWidget?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&channel=' + channel + '&color=' + encodedColor).then(function (resp) {
                    _this2._loading = false;
                    return resp;
                });
            }
        }, {
            key: 'fetchData',
            value: function fetchData(channel, group) {
                var _this3 = this;

                this._loading = true;
                this.tempGroup = group || '1';
                $timeout.cancel(this._timeout);
                return $http.get(HOST + '/api/PulseFlowWidget?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&channel=' + channel + '&startdate=null&enddate=null&group=' + group).then(function (resp) {
                    _this3._channel = resp.data.data;
                    _this3._device = resp.data.device;
                    _this3._setting = resp.data.setting;
                    _this3._currentTime = resp.data.currentTime; // represents server time, which will be used for all kind of validation/calculations.
                    _this3._loading = false;

                    _this3._setting.selectedGroup = _this3.tempGroup;

                    //const offset = 15 * 60 * 1000;
                    var intervalEnd = _this3._currentTime.unixTimeStamp - 15 * 60 * 1000;
                    if (group === '2') {
                        intervalEnd = _this3._currentTime.unixTimeStamp - 60 * 60 * 1000;
                    } else if (group === '3') {
                        intervalEnd = _this3._currentTime.unixTimeStamp - 6 * 60 * 60 * 1000;
                    } else if (group === '4') {
                        intervalEnd = _this3._currentTime.unixTimeStamp - 24 * 60 * 60 * 1000;
                    } else if (group === '5') {
                        intervalEnd = new Date(_this3._currentTime.unixTimeStamp).setHours(0, 0, 0, 0);
                    }

                    if (_this3._channel.values.length > 0) {
                        var lastDate = _this3._channel.values[_this3._channel.values.length - 1].utcUnixTimeStamp;
                        if (lastDate < intervalEnd) {
                            _this3._channel.values.pop();
                        }

                        _this3.createTimeout(_this3.tempGroup);
                    }
                    //calculate total for given channel
                    _this3._channel.sum = _this3.sumPoints();

                    return resp;
                });
            }
        }, {
            key: 'groupingChange',
            value: function groupingChange(windowId) {
                var _this4 = this;

                return $http.get(HOST + '/api/PulseFlowWidget?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&channel=' + this._setting.channel + '&startdate=null&enddate=null&group=' + this._setting.selectedGroup).then(function (resp) {
                    $timeout.cancel(_this4._timeout);
                    var tempGroup = _this4._setting.selectedGroup;
                    _this4._channel.values = resp.data.data.values;
                    _this4._setting = resp.data.setting;
                    _this4._setting.selectedGroup = tempGroup;
                    _this4._currentTime = resp.data.currentTime;

                    $rootScope.$broadcast("groupingChanged", tempGroup, windowId);

                    //this.cleanupOldChannelValues(resp.data.currentTime);
                    if (_this4._channel.values.length > 0) {
                        _this4.createTimeout();
                    } else {
                        _this4._channel.sum = 0;
                    }
                });
            }
        }, {
            key: 'groupImmediately',
            value: function groupImmediately() {
                this._channel.sum = this.sumPoints();
            }
        }, {
            key: 'createTimeout',
            value: function createTimeout() {
                var _this5 = this;

                if (angular.isUndefined(this._channel.values[this._channel.values.length - 1])) return;
                //cancel any previously scheduled eviction so timeouts don't accumulate on every heartbeat
                $timeout.cancel(this._timeout);
                var intervalEnd = this._currentTime.unixTimeStamp - 15 * 60 * 1000;
                //let lastDate = moment(this._channel.values[this._channel.values.length - 1].localTime).valueOf();
                var lastDate = this._channel.values[this._channel.values.length - 1].utcUnixTimeStamp;
                if (this._setting.selectedGroup === '2') {
                    intervalEnd = this._currentTime.unixTimeStamp - 60 * 60 * 1000;
                } else if (this._setting.selectedGroup === '3') {
                    intervalEnd = this._currentTime.unixTimeStamp - 6 * 60 * 60 * 1000;
                } else if (this._setting.selectedGroup === '4') {
                    intervalEnd = this._currentTime.unixTimeStamp - 24 * 60 * 60 * 1000;
                } else if (this._setting.selectedGroup === '5') {
                    lastDate = new Date(this._currentTime.unixTimeStamp).setHours(0, 0, 0, 0) + 86400000;
                    intervalEnd = this._currentTime.unixTimeStamp;
                }

                this.groupImmediately();
                if (Number(this._setting.selectedGroup) >= 6) return;
                var delay = Math.max(0, lastDate - intervalEnd);
                this._timeout = $timeout(function () {
                    //console.log('TIMEOUT WIDGET');
                    //evict the oldest point (tail); values are newest-first so pop(), not shift()
                    _this5._channel.values.pop();
                    if (_this5._channel.values.length > 0) {
                        //calculate total for given channel
                        _this5._channel.sum = _this5.sumPoints();
                        _this5.createTimeout();
                    }
                }, delay);
            }
        }, {
            key: 'sumPoints',
            value: function sumPoints() {
                var sum = this._channel.values.reduce(function (a, b) {
                    return a + b.scaledValue;
                }, 0);

                return sum;
            }
        }, {
            key: 'getDecimals',
            value: function getDecimals() {
                var scale = this._setting.flowScale;

                if (scale < 1) {
                    return 2;
                } else if (scale < 12) {
                    return 1;
                }

                return 0;
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                $timeout.cancel(this._timeout);
            }
        }, {
            key: 'device',
            get: function get() {
                return this._device;
            }
        }, {
            key: 'channel',
            get: function get() {
                return JSON.parse(JSON.stringify(this._channel));
            }
        }, {
            key: 'setting',
            get: function get() {
                return this._setting;
            }
        }, {
            key: 'loading',
            get: function get() {
                return this._loading;
            }
        }, {
            key: 'deviceId',
            get: function get() {
                return this._deviceId;
            },
            set: function set(deviceId) {
                this._deviceId = deviceId;
            }
        }]);

        return PulseFlow;
    }();

    return PulseFlow;
}

PulseFlowWidgetModel.$inject = ['_', 'HOST', '$http', '$timeout', '$rootScope'];

angular.module('mc.pulseflow').factory('pulseFlowWidgetModel', PulseFlowWidgetModel);
'use strict';

function PulseFlowWidgetController(_, $, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, $sce, sharedSetupService, websocketService, PulseFlowWidget, toaster, McWidgetsSharedFactory) {
    var _this2 = this;

    var ctrl = this;
    ctrl.trustAsHtml = $sce.trustAsHtml;
    var wsDataReceivedPULSE = function wsDataReceivedPULSE(data) {
        if (_this2.pulseFlow.setting.channel === parseInt(data.CH, 10)) {
            if (_this2.pulseFlow.setting.selectedGroup == 6) {
                _this2.pulseFlow.addPoint({ localTime: moment(datetimeService.socketStrToServerStrTime(data.Time)).format(), scaledValue: Number(data.ScaledValue) }, true, _this2.pulseFlow.setting.selectedGroup);
            } else if (_this2.pulseFlow.setting.selectedGroup == 7) {
                _this2.pulseFlow.addPoint({ localTime: moment(datetimeService.socketStrToServerStrTime(data.Time)).format(), scaledValue: Number(data.RawCount) }, true, _this2.pulseFlow.setting.selectedGroup);
            } else {
                _this2.pulseFlow.addPoint({ localTime: moment(datetimeService.socketStrToServerStrTime(data.Time)).format(), scaledValue: Number(data.ScaledValue), utcUnixTimeStamp: datetimeService.toUnixtime(data.Time) }, false, _this2.pulseFlow.setting.selectedGroup);
            }
        }
    };

    $scope.$on('Heartbeat', function (event, args) {
        if (args.message.Type === "HEARTBEAT") {
            ctrl.pulseFlow.cleanupOldChannelValues(args.message);
        }
    });

    var _getData = function _getData() {
        _this2.pulseFlow.groupingChange($scope.windowId);
    };

    //$scope.mostRecentData = function () {
    //    toaster.pop('success', $scope.windowTitle + " -- " + $scope.stickyProperties.device.deviceName, 'View reloading');
    //    _getData();
    //}

    $scope.$on('processReconnect', function (event, args) {
        $scope.stickyProperties.liveData = true;
        sharedSetupService.processReconnect({
            stickyProperties: $scope.stickyProperties,
            localDateTime: args.localDateTime,
            dateRangeOption: 0,
            windowTitle: $scope.windowTitle,
            fnUnregister: _unRegisterListener,
            fnGetData: _getData,
            viewType: "Widget"
        });
    });

    var _registerListener = function _registerListener() {
        websocketService.connect();

        websocketService.register('PULSE', _this2.pulseFlow.device.serialNumber, parseInt(_this2.pulseFlow._setting.channel, 10), wsDataReceivedPULSE, null);
        websocketService.register('DIGITALASPULSE', _this2.pulseFlow.device.serialNumber, parseInt(_this2.pulseFlow._setting.channel, 10), wsDataReceivedPULSE, null);
    };

    var _unRegisterListener = function _unRegisterListener() {
        websocketService.unRegister('PULSE', _this2.pulseFlow.device.serialNumber, parseInt(_this2.pulseFlow._setting.channel, 10), wsDataReceivedPULSE, null);
        websocketService.unRegister('DIGITALASPULSE', _this2.pulseFlow.device.serialNumber, parseInt(_this2.pulseFlow._setting.channel, 10), wsDataReceivedPULSE, null);
    };

    this.$onInit = function () {
        $scope.windowId = _this2.windowId;
        _this2.alerts = [];
        $scope.alerts = [];
        _this2.closeIcon = false;
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        $scope.windowTitle = _this2.translation.text.PULSE_FLOW_WIDGET;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.selectedDevice = '' + $scope.stickyProperties.device.deviceId;
        _this2.selectedChannel = '' + $scope.stickyProperties.device.channel;
        _this2.isFlipped = false;
        sharedSetupService.getWindowId(_this2);
        _this2.isGen2Device = false;

        _this2.pulseFlowColor = "#022cfd";
        _this2.normalColor = "#022cfd";
        ctrl.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };

        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.colorPalet = ctrl.mcWidgetsSharedFactory.getColorPalet();

        if (!_this2.mobile && !_this2.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            _this2._popup.dialog('option', 'dialogClass', 'ui-widget-content-new');

            _this2._popup.dialog({
                resize: function resize(event, ui) {
                    _this2.resizeContent();
                }
            });

            $timeout(function () {
                $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.ui-resizable-s').hide();
                $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.ui-resizable-n').hide();
            });

            _this2.resizeContent = function () {
                $timeout(function () {
                    var _newWidth = $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().css('width').replace(/[^0-9.]+/g, "");
                    $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.widgetSettingNew').css('width', _newWidth < 240 ? 240 : _newWidth).css('margin-left', _newWidth < 240 ? -(240 - _newWidth) / 2 : 'auto');
                    $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().css('height', $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.dragwidget')[0].clientHeight);
                    $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().css('height', $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.dragwidget')[0].clientHeight + $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.ui-dialog-titlebar')[0].clientHeight);
                });
            };

            $scope.$on('updatePreferencesLanguage', function (event, language) {
                if ($scope.alerts.length > 0) {
                    var _msg = _this2.translation.text[$scope.alerts[0].languageCode.toUpperCase()];
                    var _type = $scope.alerts[0].type;
                    var _languageCode = $scope.alerts[0].languageCode;
                    $scope.alerts = [];
                    $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
                }
            });
        } else {
            _this2._popup = $(".flip-container");
            _this2.resizeContent = function () {
                return;
            };
        }

        _this2.pulseFlow = new PulseFlowWidget(_this2.accountInfo.customerId, $scope.stickyProperties.device.deviceId);
        _this2.pulseFlow.fetchSettings().then(function (resp) {
            _this2.pulseDevices = resp.data.pulseDevices;
            _this2.allPulseChannels = resp.data.pulseSettings;
            _this2.pulseChannels = [];

            angular.forEach(resp.data.pulseSettings, function (setting) {
                if (parseInt(_this2.selectedDevice, 10) === parseInt(setting.deviceId, 10)) {
                    _this2.pulseChannels.push(setting);
                }
            });

            _this2.pulseFlow.fetchData(_this2.selectedChannel || _this2.pulseChannels[0], '' + ($scope.stickyProperties.device.group || $scope.stickyProperties.setting || 1)).then(function (resp) {
                if (_this2.pulseFlow.setting) {
                    _this2.pulseFlowColor = _this2.pulseFlow.setting.color;
                    _this2.normalColor = _this2.pulseFlow.setting.color;
                }
                if (_this2._popup.selector !== ".flip-container") _this2._popup.dialog('option', 'title', _this2.pulseFlow.device.name + ', ' + _this2.pulseFlow.setting.channelName);
                sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: parseInt(_this2.selectedDevice, 10), device: _this2.pulseFlow._device, windowId: _this2.windowId });
                $timeout(function () {
                    $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().css('height', $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.dragwidget')[0].clientHeight);
                });
                _registerListener();
                _this2.isGen2Device = _this2.pulseFlow.device.model > 20 ? true : false;
            });
        });
    };

    this.setModel = function (parm) {
        _this2.clearModel();
        $timeout(function () {
            _this2.parm = parm;
        }, 0);
    };

    this.clearModel = function () {
        _this2.parm = null;
    };

    this.selectColor = function (event) {
        _this2.normalColor = _this2.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
        _this2.clearModel();
        _this2.validateColors(true);
    };

    this.validateColors = function (_dataChanged) {
        if (_this2.normalColor.length !== 7 || _this2.normalColor.charAt(0) !== "#") {
            _this2.invalidColor = true;
            _this2.invalidNormalColor = true;
        } else {
            _this2.invalidNormalColor = false;
        }

        _this2.invalidColor = _this2.invalidLowAlarmColor || _this2.invalidNormalColor || _this2.invalidHighAlarmColor ? true : false;

        if (_dataChanged && !_this2.invalidColor) {
            _this2.updateColor();
        }
    };

    this.updateColor = function () {
        _unRegisterListener();
        if (_this2.selectedChannel !== null) {
            _this2.pulseFlow.updateColorWidget(_this2.selectedChannel, _this2.normalColor).then(function (resp) {
                if (resp.statusText == "OK") {
                    _this2.pulseFlow.fetchData(_this2.selectedChannel, _this2.pulseFlow._setting.selectedGroup).then(function () {
                        _registerListener();
                        if (_this2.pulseFlow.setting) {
                            _this2.pulseFlowColor = _this2.pulseFlow.setting.color;
                            _this2.normalColor = _this2.pulseFlow.setting.color;
                        }
                        if (_this2._popup.selector !== ".flip-container") _this2._popup.dialog('option', 'title', _this2.pulseFlow.device.name + ', ' + _this2.pulseFlow.setting.channelName);
                    });
                }
            });
        }
    };

    this.focusCallback = function ($event) {
        if ($event.target === null) {
            return;
        }
        _this2.targetField = $($event.target).attr('ng-model');
    };

    this.updateDevice = function () {
        _unRegisterListener();
        _this2.pulseFlow.deviceId = _this2.selectedDevice;
        _this2.pulseChannels.length = 0;

        _this2.pulseFlow.fetchSettings().then(function (resp) {
            _this2.pulseDevices = resp.data.pulseDevices;
            _this2.allPulseChannels = resp.data.pulseSettings;
            _this2.pulseChannels = [];

            angular.forEach(resp.data.pulseSettings, function (setting) {
                if (parseInt(_this2.selectedDevice, 10) === parseInt(setting.deviceId, 10)) {
                    _this2.pulseChannels.push(setting);
                }
            });

            _this2.selectedChannel = '' + _this2.pulseChannels[0].channel;
            _this2.pulseFlow.fetchData(_this2.pulseChannels[0].channel, _this2.pulseFlow._setting.selectedGroup).then(function () {
                if (_this2._popup.selector !== ".flip-container") _this2._popup.dialog('option', 'title', _this2.pulseFlow.device.name + ', ' + _this2.pulseFlow.setting.channelName);
                $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().css('height', $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.dragwidget')[0].clientHeight);
                var mcDevice = { deviceId: _this2.pulseFlow._device.deviceId, serialNumber: _this2.pulseFlow._device.serialNumber, deviceName: _this2.pulseFlow._device.name };
                sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: parseInt(_this2.selectedDevice, 10), device: mcDevice, windowId: _this2.windowId });
                _this2.isGen2Device = _this2.pulseFlow.device.model > 20 ? true : false;
            });
        });
    };

    this.updateSetting = function () {
        _unRegisterListener();
        if (_this2.selectedChannel !== null) {
            _this2.pulseFlow.fetchData(_this2.selectedChannel, _this2.pulseFlow._setting.selectedGroup).then(function () {
                _registerListener();
                if (_this2._popup.selector !== ".flip-container") _this2._popup.dialog('option', 'title', _this2.pulseFlow.device.name + ', ' + _this2.pulseFlow.setting.channelName);
            });
        }
    };

    this.closeWidget = function () {
        $('#pulse-widget-' + this.replaceSpaces(this.windowId)).find('.flip-container').hide();
        if (this._popup.selector !== ".flip-container") this._popup.dialog('close');
    };

    this.replaceSpaces = function (str) {
        return str.replace(/ /g, '_');
    };

    this.getRange = function () {
        var group = _this2.pulseFlow.setting.selectedGroup;

        if (group === '1') {
            return _this2.translation.text.LAST_15_MINUTES;
        } else if (group === '2') {
            return _this2.translation.text.LAST_HOUR;
        } else if (group === '3') {
            return _this2.translation.text.LAST_6_HOURS;
        } else if (group === '4') {
            return _this2.translation.text.LAST_24_HOURS;
        } else if (group === '5') {
            return _this2.translation.text.SINCE_MIDNIGHT;
        } else if (group === '6') {
            return _this2.translation.text.METER_READING;
        } else if (group === '7') {
            return "Raw Pulse Count";
        }

        return _this2.translation.text.LAST_15_MINUTES;
    };

    this.toggleWidget = function (event) {
        event.preventDefault();

        if ($('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().is('.ui-draggable-dragging, .ui-resizable-resizing') || event.target.nodeName === 'SELECT' || event.target.nodeName === 'INPUT' || event.target.nodeName === 'I' || event.target.classList[0] === 'input-group-addon') {
            return;
        }

        if (_this2.isTouchSupported()) {
            $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.back').toggle();
            $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.front').toggle();
        } else {
            $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.flip-container').toggleClass('flip');
        }

        return;
    };

    $timeout(function () {
        var tmpEventMup = 'mouseup.temperatureWidgetDirective' + _this2.replaceSpaces(_this2.windowId);
        var tmpEventMover = 'mouseover.temperatureWidgetDirective' + _this2.replaceSpaces(_this2.windowId);
        var tmpEventMout = 'mouseout.temperatureWidgetDirective' + _this2.replaceSpaces(_this2.windowId);
        tmpEventMup = tmpEventMup.replace(/ /g, "_");
        tmpEventMover = tmpEventMover.replace(/ /g, "_");
        tmpEventMout = tmpEventMout.replace(/ /g, "_");

        $scope.$on('document_click', function (e, event) {
            var $tgt = $(event.target);
            if ($tgt.closest('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).length === 0 || $tgt.closest('.back').length === 0 && $tgt.closest('.front').length === 0) {

                if (_this2.isTouchSupported()) {
                    $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.front').toggle(true);
                    $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.back').toggle(false);
                } else {
                    $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().find('.flip-container').toggleClass('flip', false);
                }
            }
        });

        $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().on(tmpEventMover, function (event) {
            // event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().addClass("x-resize");
                _this2.closeIcon = true;
            });
        });

        $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().on(tmpEventMout, function (event) {
            // event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().offsetParent().removeClass("x-resize");
                if (_this2.isTouchSupported()) {
                    $timeout(function () {
                        _this2.closeIcon = false;
                    }, 3000);
                } else {
                    _this2.closeIcon = false;
                }
            });
        });
    });

    this.isTouchSupported = function () {
        var msTouchEnabled = 0; // msTouchEnabled = window.navigator.msMaxTouchPoints;
        var generalTouchEnabled = 'ontouchstart' in document.createElement('div');

        if (msTouchEnabled || generalTouchEnabled) {
            return true;
        }

        return false;
    };

    $scope.$watch(function () {
        return _this2.getRatio();
    }, function (newVal, oldVal) {
        if (newVal && oldVal !== 'undefined') {
            $timeout(function () {
                $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).offsetParent().css('height', $('#pulse-widget-' + _this2.replaceSpaces(_this2.windowId)).find('.dragwidget')[0].clientHeight);
            }, 100);
        }
    });

    this.getRatio = function () {
        var displayVal = $filter('number')(_this2.pulseFlow.sumPoints(), _this2.pulseFlow.getDecimals());
        var ratio = displayVal.replace(new RegExp('\\D', 'g'), '').length;
        ratio += (displayVal.length - ratio) / 2;

        if (ratio < 4.5) {
            ratio = 8;
        }

        if (_this2._popup.selector === ".flip-container") {
            ratio = 8;
        }

        return ratio;
    };

    $scope.$on("groupingChanged", function (evt, data, windowId) {
        if (windowId == $scope.windowId) {
            sharedSetupService.setStickyProperties($scope.stickyProperties, { setting: data, windowId: $scope.windowId });
        }
    });

    this.getSumFormatted = function (value) {
        return value.replace(",", "<mc-pulse-span>,</mc-pulse-span>");
    };

    this.$onDestroy = function () {
        _this2.pulseFlow.destroy();
        _unRegisterListener();
    };
}

PulseFlowWidgetController.$inject = ['_', '$', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', '$sce', 'sharedSetupService', 'websocketService', 'pulseFlowWidgetModel', 'toaster', 'McWidgetsSharedFactory'];

angular.module('mc.pulseflow').component('pulseFlowWidget', {
    controller: PulseFlowWidgetController,
    transclude: true,
    templateUrl: 'ui/pulseflow/widget/pulseflow-widget-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        deviceSelected: '<'
    }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AnalogAlarmThresholdsModel(_, HOST, $http, translationService, toaster) {
    var AnalogAlarmThresholds = function () {
        function AnalogAlarmThresholds(customerId, deviceId, thresholds, settings, descriptions, originalDescriptions, statuses, alarmDelays, alarmRecalls) {
            _classCallCheck(this, AnalogAlarmThresholds);

            this._thresholds = [];
            this._settings = [];
            this._loading = false;
            this._customerId = customerId;
            this._deviceId = deviceId;
            this._thresholds = thresholds;
            this._settings = settings;
            this._descriptions = descriptions;
            this._originalDescriptions = originalDescriptions;
            this._statuses = statuses;
            this._alarmDelays = alarmDelays;
            this._alarmRecalls = alarmRecalls;

            for (var i = 0; i < this._thresholds.length; i++) {
                if (this._thresholds[i].lowFault === null || this._thresholds[i].lowRestore === null) {
                    this._thresholds[i].lowThresholds = false;
                } else {
                    this._thresholds[i].lowThresholds = true;
                }

                if (this._thresholds[i].highFault === null || this._thresholds[i].highRestore === null) {
                    this._thresholds[i].highThresholds = false;
                } else {
                    this._thresholds[i].highThresholds = true;
                }

                if (this._thresholds[i].highHighFault === null || this._thresholds[i].highHighRestore === null) {
                    this._thresholds[i].highHighThresholds = false;
                } else {
                    this._thresholds[i].highHighThresholds = true;
                }
            }
        }

        _createClass(AnalogAlarmThresholds, [{
            key: 'thresholds',
            get: function get() {
                return this._thresholds;
            }
        }, {
            key: 'settings',
            get: function get() {
                return this._settings;
            }
        }, {
            key: 'descriptions',
            get: function get() {
                return this._descriptions;
            }
        }, {
            key: 'originalDescriptions',
            get: function get() {
                return this._originalDescriptions;
            }
        }, {
            key: 'statuses',
            get: function get() {
                return this._statuses;
            }
        }, {
            key: 'alarmDelays',
            get: function get() {
                return this._alarmDelays;
            }
        }, {
            key: 'alarmRecalls',
            get: function get() {
                return this._alarmRecalls;
            }
        }, {
            key: 'loading',
            get: function get() {
                return this._loading;
            }
        }]);

        return AnalogAlarmThresholds;
    }();

    return AnalogAlarmThresholds;
}

AnalogAlarmThresholdsModel.$inject = ['_', 'HOST', '$http', 'translationService', 'toaster'];

angular.module('mc.rtu-configuration').factory('AnalogAlarmThresholdsModel', AnalogAlarmThresholdsModel);
"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function AnalogThresholdsController(_, $, HOST, $http, $element, $rootScope, $timeout, $scope, $sce, authenticationService, datetimeService, timeLapseService, translationService, toaster, AnalogAlarmThreshold, MMPlusRtuSettingFactory, deviceService, $uibModal) {
    var _this2 = this;

    var __this = this;
    var getAnalogDigits = function getAnalogDigits(minVal, maxVal) {

        var diff = Math.abs(maxVal - minVal);

        if (diff <= 10 || _this2.accountInfo.customerId == 12317) {
            //Ruidoso NM, Village of
            return { step: .001, precision: 3 };
        }

        if (diff <= 100 || _this2.accountInfo.customerId == 11316) {
            return { step: .01, precision: 2 };
        }

        if (diff <= 1000 || _this2.accountInfo.customerId == 12520) {
            return { step: .1, precision: 1 };
        }

        return { step: .100000000001, precision: 1 };
    };

    var setTimestamp = function setTimestamp(data) {
        _this2.currentTime = moment(data.localDateTime).valueOf();
    };

    //Get virtual analog channel number
    var getCh = function getCh(i) {
        return _this2.analogAlarmThresholds.settings[i].channel + 50;
    };

    var saveData = function saveData(idx) {
        if (_this2.isValid(_this2.analogAlarmThresholds.thresholds[idx].modal) && _this2.isValidHighHighValues(_this2.analogAlarmThresholds.thresholds[idx].modal) && _this2.isValidHighHighCompareToLowValues(_this2.analogAlarmThresholds.thresholds[idx].modal)) {
            $http.post(HOST + "/api/AnalogAlarmThresholds?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&deviceTypeId=" + _this2.deviceTypeId, _this2.analogAlarmThresholds.thresholds[idx].modal).then(function (resp) {
                //console.log("Success");
                buildChart(_this2.analogAlarmThresholds.thresholds[idx]);
                broadcastThresholdsAndLevelReferenceChanges();
                //assign modified value to local model
                _this2.analogAlarmThresholds.thresholds[idx].lowRestore = _this2.analogAlarmThresholds.thresholds[idx].modal.lowRestore;
                _this2.analogAlarmThresholds.thresholds[idx].lowFault = _this2.analogAlarmThresholds.thresholds[idx].modal.lowFault;
                _this2.analogAlarmThresholds.thresholds[idx].highRestore = _this2.analogAlarmThresholds.thresholds[idx].modal.highRestore;
                _this2.analogAlarmThresholds.thresholds[idx].highFault = _this2.analogAlarmThresholds.thresholds[idx].modal.highFault;
                _this2.analogAlarmThresholds.thresholds[idx].highHighRestore = _this2.analogAlarmThresholds.thresholds[idx].modal.highHighRestore;
                _this2.analogAlarmThresholds.thresholds[idx].highHighFault = _this2.analogAlarmThresholds.thresholds[idx].modal.highHighFault;
            }, function (resp) {
                //console.log("Failure");
            });
        }
    };

    var startSaveTimer = function startSaveTimer(idx, type) {
        if (_this2.saveTimers[idx + "_" + type] !== null) {
            $timeout.cancel(_this2.saveTimers[idx + "_" + type]);
        }

        _this2.saveTimers[idx + "_" + type] = $timeout(function () {
            saveData(idx);
        }, 1000);
    };

    var buildChart = function buildChart(channelThreshold) {
        $timeout(function () {
            _this2.drawChart(channelThreshold);
        }, 100);
    };
    var mouseWheelHandler = function mouseWheelHandler(e) {
        $(_this2.myReadOnlyDiv).css("pointer-events", "none");
        $timeout(function () {
            $(_this2.myReadOnlyDiv).css("pointer-events", "auto");
        }, 100);
        return false;
    };

    this.$onInit = function () {
        _this2._ = _;
        _this2.device = {};
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.langId = _this2.accountInfo.preferenceUser.i18nCode === 'fr' ? _this2.accountInfo.preferenceUser.i18nCode : 'en';
        _this2.translation = translationService.translation;
        _this2.previousThreshold = null;
        _this2.alerts = [];
        _this2.readOnly = false;
        $scope.selectedChannel = { channelIndex: 0 };
        _this2.statusSelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this2.delaySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this2.reattemptDelaySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this2.reattemptRetrySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        $scope.alerts = [];
        _this2.saveTimers = {};
        _this2.currentTime = 0;
        _this2.loading = true;
        _this2.chartClicked = false;
        _this2.addMode = false;
        _this2.plotlineTypes = [];
        _this2.colorPalette = [];
        _this2.popoverAddLevelReference = {
            templateUrl: 'AnalogAddLakeLevelRefPopoverTemplate.html'
        };
        _this2.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };
        _this2.popoverAddLevelReferenceIsOpen = false;
        _this2.levelReferencesOnChart = 7;
        _this2.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(_this2.accountInfo.customerId);

        // Sort of like enums. Allow me to loop through all the description fields without repeating myself
        // TODO: If we ever add support for additional languages in the DB this will need to be updated as well.
        _this2.supportedLanguages = ['en', 'fr'];
        _this2.descriptionFields = ['lowRestore', 'highRestore', 'lowFault', 'highFault'];

        timeLapseService.getLocalDateTime().then(function (resp) {
            _this2.currentTime = moment(resp.data.localDateTime).valueOf();
        });

        if (!__this.mobile && !__this.classicView) {
            __this._popup = _this.getExistingDialog(__this.windowId).ref;

            // binding 'dialogbeforeclose' event to Check for unsaved Changes function
            $(__this._popup).on('dialogbeforeclose', function (event) {
                if (_this2.hasLevelSensor && __this.pendingPagingMessage) {
                    var modalController = function modalController($uibModalInstance, translation) {

                        this.translation = translation;

                        this.tmpConfirmMessageB = "Exit without paging device?";

                        this.ok = function () {
                            $uibModalInstance.close();
                        };

                        this.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                    };

                    event.preventDefault();
                    ;

                    modalController.$inject = ['$uibModalInstance', 'translation'];

                    var modalInstance = $uibModal.open({
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
                        controller: modalController,
                        controllerAs: '$ctrl',
                        size: 'sm',
                        resolve: {
                            translation: function translation() {
                                return _this2.translation;
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        __this.pendingPagingMessage = null;
                        $rootScope.$broadcast('has_pending_paging', { deviceId: _this2.deviceId, hasPendingPaging: false });
                        $(__this._popup).dialog('close');
                    }, function () {
                        // cancel button
                    });
                }
            });
        }

        _this2.getLevelReferencePlotlineTypes();
        timeLapseService.registerLocal('ANALOG_STATUS', null, null, setTimestamp);
        $http.get(HOST + "/api/AnalogAlarmThresholds?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceTypeId=" + _this2.deviceTypeId + "&timezone=" + _this2.accountInfo.timeZone).then(function (resp) {
            _this2.loading = false;
            _this2.hasLevelSensor = resp.data.hasLevelSensor;
            if (_this2.hasLevelSensor) {
                _this2.descriptionFields = ['lowRestore', 'highRestore', 'lowFault', 'highFault', 'highHighRestore', 'highHighFault'];
                _this2.networkDeviceType = resp.data.networkDeviceType;
                _this2.getImei();
                //filter channels to keep only channel 1 if device has level sensor 
                if (resp.data.settings.length !== 0) {
                    resp.data.settings = resp.data.settings.filter(function (obj) {
                        return obj.channel == 1;
                    });
                }
            }
            _this2.colorPalette = resp.data.colorPalette;
            if (_this2.deviceTypeId === 15 || _this2.deviceTypeId === 10) {
                d;
                $scope.alerts.push({ msg: _this2.translation.text.NO_DATA, type: 'info', languageCode: 'NO_DATA' });
                _this2.alerts.push({ msg: _this2.translation.text.NO_DATA, type: 'info', languageCode: 'NO_DATA' });
            } else if (resp.data.settings.length === 0) {
                $scope.alerts.push({ msg: _this2.translation.text.NO_ANALOG_SETTINGS, type: 'info', languageCode: 'NO_ANALOG_SETTINGS' });
                _this2.alerts.push({ msg: _this2.translation.text.NO_ANALOG_SETTINGS, type: 'info', languageCode: 'NO_ANALOG_SETTINGS' });
            } else {
                (function () {

                    var descriptions = resp.data.descriptions;

                    for (var i = 0; i < resp.data.alarmDelays.length; i++) {
                        _this2.delaySelectors[i] = "" + resp.data.alarmDelays[i].delay;
                    }

                    for (var _i = 0; _i < resp.data.alarmRecalls.length; _i++) {
                        _this2.reattemptDelaySelectors[_i] = "" + resp.data.alarmRecalls[_i].delayMins;
                        _this2.reattemptRetrySelectors[_i] = "" + resp.data.alarmRecalls[_i].retryCount;
                    }

                    // TODO: Do we need to clean any instances of ##2? Why is ##1 the only one that's hidden from the user.

                    var _loop = function _loop(_i2) {
                        _this2.supportedLanguages.forEach(function (lang) {
                            _this2.descriptionFields.forEach(function (field) {
                                if (descriptions[_i2][lang][field] !== null) descriptions[_i2][lang][field] = descriptions[_i2][lang][field].replace(/##1|\(##1\)/g, '').trim();
                            });
                        });
                    };

                    for (var _i2 = 0; _i2 < descriptions.length; _i2++) {
                        _loop(_i2);
                    }
                    _this2.analogAlarmThresholds = new AnalogAlarmThreshold(_this2.accountInfo.customerId, _this2.deviceId, resp.data.thresholds, resp.data.settings, descriptions, JSON.parse(JSON.stringify(descriptions)), resp.data.statuses, resp.data.alarmDelays, resp.data.alarmRecalls);
                    //identify whether device is ReverseScaled, i.e., minValue > maxValue
                    angular.forEach(_this2.analogAlarmThresholds.settings, function (value, key) {
                        _this2.analogAlarmThresholds.settings[key].channelIndex = key;
                        var copyThreshold = Object.assign({}, _this2.analogAlarmThresholds.thresholds[key]);
                        if (parseFloat(value.minimumValue) > parseFloat(value.maximumValue)) {
                            copyThreshold.reverseScaling = true;
                            value.reverseScaling = true;
                            //creating threshold modal with reverseScaled values
                            _this2.analogAlarmThresholds.thresholds[key].modal = copyThreshold;
                        } else {
                            value.reverseScaling = false;
                            copyThreshold.reverseScaling = false;
                            //creating threshold modal with reverseScaled values
                            _this2.analogAlarmThresholds.thresholds[key].modal = copyThreshold;
                        }
                        _this2.maximumValue = parseFloat(value.maximumValue);
                        _this2.minimumValue = parseFloat(value.minimumValue);
                        var lakeRefChannel = resp.data.lakeReferencesbyChannel.find(function (x) {
                            return x.channel == value.channel;
                        });
                        if (typeof lakeRefChannel != "undefined") {
                            _this2.analogAlarmThresholds.thresholds[key].lakeReferences = lakeRefChannel.levelReferences;
                        }
                        //Before loading making sure threshold values are valid, and setting the property with isValid value
                        copyThreshold.isValid = _this2.isValid(copyThreshold);
                        copyThreshold.isValidHighHighValues = _this2.isValidHighHighValues(copyThreshold);
                        copyThreshold.isValidHighHighCompareToLowValues = _this2.isValidHighHighCompareToLowValues(copyThreshold);
                    });

                    $timeout(function () {
                        $scope.$broadcast('rzSliderForceRender');
                    }, 10);

                    buildChart(_this2.analogAlarmThresholds.thresholds[$scope.selectedChannel.channelIndex]);
                })();
            }
        });

        //Log tab access event to NLog
        _this2.postUserAction2Nlog(_this2.accountInfo.customerId, _this2.deviceId).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            _this2.langId = langId === 'fr' ? langId : 'en';
            $timeout(function () {
                $scope.$broadcast('rzSliderForceRender');
            }, 10);
        });

        $scope.$on('contentAdjusted', function () {
            $timeout(function () {
                $scope.$broadcast('reCalcViewDimensions');$scope.$broadcast('rzSliderForceRender');
            }, 10);
        });

        _this2.myReadOnlyDiv = $($element).find(".data-read-only-analog-threshold")[0];
        _this2.toggleReadOnly();
    };

    this.toggleReadOnly = function () {
        _this2.readOnly = !_this2.readOnly;
        if (_this2.readOnly) {
            if (_this2.myReadOnlyDiv.addEventListener) {
                // IE9, Chrome, Safari, Opera
                _this2.myReadOnlyDiv.addEventListener("mousewheel", mouseWheelHandler, false);
                // Firefox
                _this2.myReadOnlyDiv.addEventListener("DOMMouseScroll", mouseWheelHandler, false);
            }
        } else {
            if (_this2.myReadOnlyDiv.addEventListener) {
                // IE9, Chrome, Safari, Opera
                _this2.myReadOnlyDiv.removeEventListener("mousewheel", mouseWheelHandler, false);
                // Firefox
                _this2.myReadOnlyDiv.removeEventListener("DOMMouseScroll", mouseWheelHandler, false);
            }
        }
    };
    this.changeChannel = function () {
        buildChart(_this2.analogAlarmThresholds.thresholds[$scope.selectedChannel.channelIndex]);
    };

    // Accessibility (WCAG 1.4.4 / 1.4.10): plot line labels must never overlap. Highcharts places every plot line label
    var separatePlotLineLabels = function separatePlotLineLabels(chart) {
        try {
            var axis = chart.yAxis[0];
            var gap = 1;
            var minTop = chart.plotTop;
            var maxBottom = chart.plotTop + chart.plotHeight;

            var items = (axis.plotLinesAndBands || []).filter(function (plotLine) {
                return plotLine.label && plotLine.label.element && plotLine.options && plotLine.options.value != null;
            }).map(function (plotLine) {
                var box = plotLine.label.getBBox(true);
                return { label: plotLine.label, box: box, lineY: axis.toPixels(plotLine.options.value), top: box.y };
            }).filter(function (item) {
                return item.box.width > 0 && item.box.height > 0;
            });

            // Group labels whose horizontal extents overlap; labels in different groups can never collide
            var groups = [];
            items.forEach(function (item) {
                var left = item.box.x;
                var right = item.box.x + item.box.width;
                var group = groups.find(function (g) {
                    return left < g.right && right > g.left;
                });
                if (!group) {
                    group = { left: left, right: right, items: [] };
                    groups.push(group);
                }
                group.left = Math.min(group.left, left);
                group.right = Math.max(group.right, right);
                group.items.push(item);
            });

            groups.forEach(function (group) {
                // Top-to-bottom in the same order as the lines they belong to, so a label is always next to its own line
                var sorted = group.items.sort(function (a, b) {
                    return a.lineY - b.lineY || a.box.y - b.box.y;
                });

                // Push each label below the one above it
                for (var i = 1; i < sorted.length; i++) {
                    sorted[i].top = Math.max(sorted[i].top, sorted[i - 1].top + sorted[i - 1].box.height + gap);
                }
                // Pull the stack back up so it does not run off the bottom of the plot area...
                for (var _i3 = sorted.length - 1; _i3 >= 0; _i3--) {
                    var limit = _i3 === sorted.length - 1 ? maxBottom - sorted[_i3].box.height : sorted[_i3 + 1].top - gap - sorted[_i3].box.height;
                    sorted[_i3].top = Math.min(sorted[_i3].top, limit);
                }
                // ...and never above the top of it (only matters when there are more labels than will fit)
                for (var _i4 = 0; _i4 < sorted.length; _i4++) {
                    var _limit = _i4 === 0 ? minTop : sorted[_i4 - 1].top + sorted[_i4 - 1].box.height + gap;
                    sorted[_i4].top = Math.max(sorted[_i4].top, _limit);
                }

                sorted.forEach(function (item) {
                    var delta = Math.round(item.top - item.box.y);
                    if (delta !== 0) {
                        var alignedY = item.label.alignAttr ? item.label.alignAttr.y : item.label.y || 0;
                        item.label.attr({ y: alignedY + delta });
                    }
                });
            });
        } catch (e) {
            // Label separation is cosmetic; never let it break the chart
        }
    };

    // --- Colour contrast helpers (WCAG 2.x relative luminance / contrast ratio) ---------------------------------------
    var CHART_PLOT_BACKGROUND = '#f9f9f9';
    var READ_ONLY_OVERLAY = { color: '#777777', opacity: 0.10 }; // .data-read-only-analog-threshold

    var hexToRgb = function hexToRgb(hex) {
        var h = String(hex || '').trim().replace('#', '');
        if (h.length === 3) {
            h = h.split('').map(function (ch) {
                return ch + ch;
            }).join('');
        }
        if (!/^[0-9a-f]{6}$/i.test(h)) {
            return null;
        }
        return [0, 2, 4].map(function (i) {
            return parseInt(h.substr(i, 2), 16);
        });
    };

    var rgbToHex = function rgbToHex(rgb) {
        return "#" + rgb.map(function (v) {
            return Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0');
        }).join('');
    };

    var relativeLuminance = function relativeLuminance(rgb) {
        var _rgb$map = rgb.map(function (v) {
            var c = v / 255;
            return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
        }),
            _rgb$map2 = _slicedToArray(_rgb$map, 3),
            r = _rgb$map2[0],
            g = _rgb$map2[1],
            b = _rgb$map2[2];

        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };

    var contrastRatio = function contrastRatio(rgbA, rgbB) {
        var lA = relativeLuminance(rgbA);
        var lB = relativeLuminance(rgbB);
        return (Math.max(lA, lB) + 0.05) / (Math.min(lA, lB) + 0.05);
    };

    // What a colour looks like underneath the semi-transparent read-only overlay
    var underReadOnlyOverlay = function underReadOnlyOverlay(rgb) {
        var overlay = hexToRgb(READ_ONLY_OVERLAY.color);
        return rgb.map(function (v, i) {
            return v * (1 - READ_ONLY_OVERLAY.opacity) + overlay[i] * READ_ONLY_OVERLAY.opacity;
        });
    };

    // both normally and when seen through the read-only overlay. Hue is preserved; only the shade changes.
    var readableTextColor = function readableTextColor(hex, backgroundHex) {
        var rgb = hexToRgb(hex);
        var background = hexToRgb(backgroundHex);
        if (!rgb || !background) {
            return hex;
        }

        // Judge the colour as it will actually be emitted (whole RGB values), so rounding cannot drop it below 4.5:1
        var isReadable = function isReadable(candidate) {
            var rounded = candidate.map(function (v) {
                return Math.round(v);
            });
            return contrastRatio(rounded, background) >= 4.5 && contrastRatio(underReadOnlyOverlay(rounded), underReadOnlyOverlay(background)) >= 4.5;
        };

        for (var step = 0; step < 40 && !isReadable(rgb); step++) {
            rgb = rgb.map(function (v) {
                return v * 0.94;
            });
        }

        return rgbToHex(rgb);
    };

    // Style for a plot line label: the text sits on a small chip in the plot background colour so that the dashed
    var plotLineLabelStyle = function plotLineLabelStyle(color) {
        return {
            color: readableTextColor(color, CHART_PLOT_BACKGROUND),
            backgroundColor: 'rgba(249, 249, 249, 0.92)',
            padding: '0 3px',
            borderRadius: '2px',
            whiteSpace: 'nowrap'
        };
    };

    this.drawChart = function createChart(threshold) {
        var _this3 = this,
            _chart;

        var channelIdx = __this.analogAlarmThresholds.settings.findIndex(function (x) {
            return x.channel == threshold.channel;
        });
        var colors = this.colorPalette;
        var plotLines = [];
        var chartSeries = [];
        var legendEvent = {
            legendItemClick: function legendItemClick(e) {
                var index = this.chart.yAxis[0].options.plotLines.findIndex(function (s) {
                    return s.label.text == e.browserEvent.target.innerHTML;
                });
                this.chart.yAxis[0].options.plotLines[index].width = this.visible ? 0 : 1;
                this.chart.yAxis[0].options.plotLines[index].label.style.color = this.visible ? "transparent" : this.chart.yAxis[0].options.plotLines[index].color;
                this.chart.yAxis[0].update({});
            }
        };
        var i = 0;
        if (threshold.modal.highHighRestore != null) {
            plotLines.push({
                id: "Threshold hhr", value: threshold.modal.highHighRestore, color: colors[channelIdx], dashStyle: 'Dash', width: 1,
                label: {
                    text: this.analogAlarmThresholds.descriptions[channelIdx][this.langId].highHighRestore + "<i class='fa fa-bell-slash-o' style='margin-left: 2px;'></i>",
                    align: "right",
                    y: 10,
                    x: -2,
                    style: plotLineLabelStyle(colors[channelIdx]),
                    useHTML: true
                }
            });
            chartSeries.push({
                color: colors[channelIdx], name: 'High High Restore', dashStyle: 'solid', marker: { enabled: false }, events: legendEvent
            });
        }
        if (threshold.modal.highHighFault != null) {
            plotLines.push({
                id: "Threshold hhf", value: threshold.modal.highHighFault, color: colors[channelIdx], dashStyle: 'ShortDash', width: 1,
                label: {
                    text: this.analogAlarmThresholds.descriptions[channelIdx][this.langId].highHighFault + "<i class='fa fa-bell' style='margin-left: 2px;'></i>",
                    align: "right",
                    y: -2,
                    x: -2,
                    style: plotLineLabelStyle(colors[channelIdx]),
                    useHTML: true
                }
            });
            chartSeries.push({
                color: colors[channelIdx], name: 'High High Fault', dashStyle: 'solid', marker: { enabled: false }, events: legendEvent
            });
        }
        if (threshold.modal.highRestore != null) {
            plotLines.push({
                id: "Threshold hr", value: threshold.modal.highRestore, color: colors[channelIdx], dashStyle: 'Dash', width: 1,
                label: {
                    text: this.analogAlarmThresholds.descriptions[channelIdx][this.langId].highRestore + "<i class='fa fa-bell-slash-o' style='margin-left: 2px;'></i>",
                    align: "right",
                    y: 10,
                    x: -2,
                    style: plotLineLabelStyle(colors[channelIdx]),
                    useHTML: true
                }
            });
            chartSeries.push({
                color: colors[channelIdx], name: 'High Restore', dashStyle: 'solid', marker: { enabled: false }, events: legendEvent
            });
        }
        if (threshold.modal.highFault != null) {
            plotLines.push({
                id: "Threshold hf", value: threshold.modal.highFault, color: colors[channelIdx], dashStyle: 'ShortDash', width: 1,
                label: {
                    text: this.analogAlarmThresholds.descriptions[channelIdx][this.langId].highFault + "<i class='fa fa-bell' style='margin-left: 2px;'></i>",
                    align: "right",
                    y: -2,
                    x: -2,
                    style: plotLineLabelStyle(colors[channelIdx]),
                    useHTML: true
                }
            });
            chartSeries.push({
                color: colors[channelIdx], name: 'High Fault', dashStyle: 'solid', marker: { enabled: false }, events: legendEvent
            });
        }
        if (threshold.modal.lowRestore != null) {
            plotLines.push({
                id: "Threshold lr", value: threshold.modal.lowRestore, color: colors[channelIdx], dashStyle: 'Dash', width: 1,
                label: {
                    text: this.analogAlarmThresholds.descriptions[channelIdx][this.langId].lowRestore + "<i class='fa fa-bell-slash-o' style='margin-left: 2px;'></i>",
                    align: "right",
                    y: -2,
                    x: -2,
                    style: plotLineLabelStyle(colors[channelIdx]),
                    useHTML: true
                }
            });
            chartSeries.push({
                color: colors[channelIdx], name: 'Low Restore', dashStyle: 'solid', marker: { enabled: false }, events: legendEvent
            });
        }
        if (threshold.modal.lowFault != null) {
            plotLines.push({
                id: "Threshold lf", value: threshold.modal.lowFault, color: colors[channelIdx], dashStyle: 'ShortDash', width: 1,
                label: {
                    text: this.analogAlarmThresholds.descriptions[channelIdx][this.langId].lowFault + "<i class='fa fa-bell' style='margin-left: 2px;'></i>",
                    align: "right",
                    y: 10,
                    x: -2,
                    style: plotLineLabelStyle(colors[channelIdx]),
                    useHTML: true
                }
            });
            chartSeries.push({
                color: colors[channelIdx], name: 'Low Fault', dashStyle: 'solid', marker: { enabled: false }, events: legendEvent
            });
        }
        threshold.lakeReferences.forEach(function (levelRef) {
            if (i < _this3.levelReferencesOnChart) {
                plotLines.push({
                    id: levelRef.levelReferenceID, value: levelRef.referenceValue, color: levelRef.hexColor, dashStyle: _this3.plotlineTypes[levelRef.plotLineTypeID - 1].description, width: 1,
                    // Level reference labels sit on the left of the plot so they cannot collide with the
                    // right-aligned threshold labels when a reference value is close to a threshold value
                    label: {
                        text: levelRef.referenceDescription,
                        align: "left",
                        y: -2,
                        x: 10,
                        style: plotLineLabelStyle(levelRef.hexColor),
                        useHTML: true
                    }
                });
                chartSeries.push({
                    color: levelRef.hexColor, name: levelRef.referenceDescription, dashStyle: _this3.plotlineTypes[levelRef.plotLineTypeID - 1].description, marker: { enabled: false }, events: legendEvent
                });
                i++;
            }
        });

        if (channelIdx >= 0) {
            __this.minimumValue = __this.analogAlarmThresholds.settings[channelIdx].minimumValue;
            __this.maximumValue = __this.analogAlarmThresholds.settings[channelIdx].maximumValue;
        }

        this.chart = new Highcharts.Chart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: false,
                itemStyle: {
                    color: 'black',
                    fontWeight: 'bold',
                    fontSize: '10px'
                }
            },
            exporting: {
                enabled: false
            },
            chart: (_chart = {
                events: {
                    render: function render() {
                        separatePlotLineLabels(this);

                        if (plotLines.length > 0) {

                            if (__this.hasLevelSensor) {
                                var minY = null;
                                var maxY = null;
                                for (var _i5 = 0; _i5 < plotLines.length; _i5++) {
                                    var currValue = plotLines[_i5].value;
                                    minY = minY == null || currValue < minY ? currValue : minY;
                                    maxY = maxY == null || currValue > maxY ? currValue : maxY;
                                }
                                chart.yAxis[0].update({
                                    startOnTick: true,
                                    endOnTick: true,
                                    min: 0,
                                    max: null
                                });

                                chart.yAxis[0].setExtremes(0, maxY);
                            }
                            return;
                        }
                        $(".highcharts-plot-background").next().remove();
                        this.customText = this.renderer.text('No Thresholds/Level References setup,<br/>no preview available.', this.plotLeft + this.plotWidth * 0.5, this.plotHeight * 0.5).css({
                            color: '#4572A7',
                            fontSize: '13px',
                            'text-anchor': 'middle'
                        }).add();
                    }
                },
                renderTo: $element.find(".chart")[0],
                // No animation so label positions are final when the render event fires (see separatePlotLineLabels)
                animation: false,
                borderWidth: 0,
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#d3d3d3'
            }, _defineProperty(_chart, "borderWidth", 1), _defineProperty(_chart, "borderRadius", 2), _defineProperty(_chart, "style", {
                fontSize: '10px'
            }), _chart),
            rangeSelector: {
                enabled: false
            },
            title: {
                text: ''
            },
            yAxis: {
                title: {
                    text: '(' + __this.analogAlarmThresholds.settings[channelIdx].unit + ')'
                },
                labels: {
                    style: {
                        fontSize: '10px'
                    }
                },
                opposite: true,
                lineColor: colors[channelIdx],
                lineWidth: 2,
                offset: 10,
                min: __this.maximumValue > __this.minimumValue ? __this.minimumValue : __this.maximumValue,
                max: __this.maximumValue > __this.minimumValue ? __this.maximumValue : __this.minimumValue,
                plotLines: plotLines,
                reversed: __this.maximumValue < __this.minimumValue,
                showFirstLabel: true,
                showLastLabel: true
            },
            series: chartSeries
        });
    };

    this.isAdmin = function () {
        return _this2.accountInfo.userRole === 'Administrator' || _this2.accountInfo.userRole === 'SuperAdministrator';
    };

    this.isValid = function (threshold) {
        if (!threshold.lowThresholds || !threshold.highThresholds) {
            return true;
        }

        if (!threshold.reverseScaling && parseFloat(threshold.lowRestore) >= parseFloat(threshold.highRestore)) {
            return false;
        } else if (threshold.reverseScaling && parseFloat(threshold.lowRestore) < parseFloat(threshold.highRestore)) {
            return false;
        }

        return true;
    };

    this.isValidHighHighValues = function (threshold) {
        if (!threshold.highHighThresholds) {
            return true;
        }

        if (!threshold.reverseScaling && parseFloat(threshold.highFault) >= parseFloat(threshold.highHighRestore)) {
            return false;
        } else if (threshold.reverseScaling && parseFloat(threshold.highFault) < parseFloat(threshold.highHighRestore)) {
            return false;
        }

        return true;
    };

    this.isValidHighHighCompareToLowValues = function (threshold) {
        //as long as there are high thresholds, the other validation functions will take care of validating thresholds' values
        if (!threshold.highHighThresholds || threshold.highThresholds) {
            return true;
        }

        if (!threshold.reverseScaling && parseFloat(threshold.lowRestore) >= parseFloat(threshold.highHighRestore)) {
            return false;
        } else if (threshold.reverseScaling && parseFloat(threshold.lowRestore) < parseFloat(threshold.highHighRestore)) {
            return false;
        }

        return true;
    };

    this.toggleThreshold = function (type, threshold) {
        if (type === 'LOW') {
            if (threshold.lowThresholds === false) {
                threshold.lowRestore = _this2.deviceTypeId == 20 || _this2.deviceTypeId == 21 ? 0 : null;
                threshold.lowFault = _this2.deviceTypeId == 20 || _this2.deviceTypeId == 21 ? 0 : null;

                $http.post(HOST + "/api/AnalogAlarmThresholds?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&deviceTypeId=" + _this2.deviceTypeId + "&channel=" + threshold.channel, threshold).then(function (resp) {
                    // threshold.modal.lowRestore = null;
                    // threshold.modal.lowFault = null;
                    threshold.modal.lowThresholds = false;
                    buildChart(threshold);
                    broadcastThresholdsAndLevelReferenceChanges();
                }, function (resp) {});
                _this2.rzSliderForceRender();
                _this2.updatePendingPagingMessage(threshold.modal);
            } else {
                threshold.modal.lowThresholds = true;
            }
        } else if (type === 'HIGH') {
            if (threshold.highThresholds === false) {
                threshold.highRestore = _this2.deviceTypeId == 20 || _this2.deviceTypeId == 21 ? 0 : null;
                threshold.highFault = _this2.deviceTypeId == 20 || _this2.deviceTypeId == 21 ? 0 : null;

                $http.post(HOST + "/api/AnalogAlarmThresholds?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&deviceTypeId=" + _this2.deviceTypeId + "&channel=" + threshold.channel, threshold).then(function (resp) {
                    // threshold.modal.highRestore = null;
                    // threshold.modal.highFault = null;
                    threshold.modal.highThresholds = false;
                    buildChart(threshold);
                    broadcastThresholdsAndLevelReferenceChanges();
                }, function (resp) {});
                _this2.rzSliderForceRender();
                _this2.updatePendingPagingMessage(threshold.modal);
            } else {
                threshold.modal.highThresholds = true;
            }
        } else if (type === 'HIGH_HIGH') {
            if (threshold.highHighThresholds === false) {
                threshold.highHighRestore = _this2.deviceTypeId == 20 || _this2.deviceTypeId == 21 ? 0 : null;
                threshold.highHighFault = _this2.deviceTypeId == 20 || _this2.deviceTypeId == 21 ? 0 : null;

                $http.post(HOST + "/api/AnalogAlarmThresholds?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&deviceTypeId=" + _this2.deviceTypeId + "&channel=" + threshold.channel, threshold).then(function (resp) {
                    // threshold.modal.highHighRestore = null;
                    // threshold.modal.highHighFault = null;
                    threshold.modal.highHighThresholds = false;
                    buildChart(threshold);
                    broadcastThresholdsAndLevelReferenceChanges();
                }, function (resp) {});
                _this2.rzSliderForceRender();
                _this2.updatePendingPagingMessage(threshold.modal);
            } else {
                threshold.modal.highHighThresholds = true;
            }
        }
    };

    this.rzSliderForceRender = function () {
        $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');
        }, 10);
    };

    this.storePrevious = function (threshold) {
        _this2.previousThreshold = JSON.parse(JSON.stringify(threshold));
    };

    this.updateRange = function (idx, thresholdModal, field) {
        if (field === 'LOW_FAULT') {
            if (thresholdModal.lowFault === _this2.previousThreshold.modal.lowFault) {
                return;
            }
        } else if (field === 'LOW_RESTORE') {
            if (thresholdModal.lowRestore === _this2.previousThreshold.modal.lowRestore) {
                return;
            }
        } else if (field === 'HIGH_RESTORE') {
            if (thresholdModal.highRestore === _this2.previousThreshold.modal.highRestore) {
                return;
            }
        } else if (field === 'HIGH_FAULT') {
            if (thresholdModal.highFault === _this2.previousThreshold.modal.highFault) {
                return;
            }
        } else if (field === 'HIGH_HIGH_RESTORE') {
            if (thresholdModal.highHighRestore === _this2.previousThreshold.modal.highHighRestore) {
                return;
            }
        } else if (field === 'HIGH_HIGH_FAULT') {
            if (thresholdModal.highHighFault === _this2.previousThreshold.modal.highHighFault) {
                return;
            }
        }

        $timeout(function () {
            var setting = _this2.analogAlarmThresholds.settings[idx];

            var _getAnalogDigits = getAnalogDigits(setting.minimumValue, setting.maximumValue),
                step = _getAnalogDigits.step,
                precision = _getAnalogDigits.precision;

            if (field === 'LOW_FAULT') {
                if (!thresholdModal.reverseScaling && parseFloat(thresholdModal.lowFault) >= parseFloat(thresholdModal.lowRestore)) {
                    if (thresholdModal.lowFault === setting.maximumValue) {
                        thresholdModal.lowRestore = thresholdModal.lowFault;
                        thresholdModal.lowFault -= step;
                    } else {
                        thresholdModal.lowRestore = thresholdModal.lowFault + step;
                    } //below logic is for reverseScaling threshold
                } else if (thresholdModal.reverseScaling && parseFloat(thresholdModal.lowFault) <= parseFloat(thresholdModal.lowRestore)) {
                    //reverseScaling scenario
                    if (thresholdModal.lowFault === setting.maximumValue) {
                        thresholdModal.lowRestore = thresholdModal.lowFault;
                        thresholdModal.lowFault += step;
                    } else {
                        thresholdModal.lowRestore = thresholdModal.lowFault - step;
                    }
                }
            } else if (field === 'LOW_RESTORE') {
                if (!thresholdModal.reverseScaling && parseFloat(thresholdModal.lowRestore) <= parseFloat(thresholdModal.lowFault)) {
                    if (thresholdModal.lowRestore === setting.minimumValue) {
                        thresholdModal.lowFault = thresholdModal.lowRestore;
                        thresholdModal.lowRestore += step;
                    } else {
                        thresholdModal.lowFault = thresholdModal.lowRestore - step;
                    } //below logic is for reverseScaling threshold
                } else if (thresholdModal.reverseScaling && parseFloat(thresholdModal.lowRestore) >= parseFloat(thresholdModal.lowFault)) {
                    //reverseScaling scenario
                    if (thresholdModal.lowRestore === setting.minimumValue) {
                        thresholdModal.lowFault = thresholdModal.lowRestore;
                        thresholdModal.lowRestore -= step;
                    } else {
                        thresholdModal.lowFault = thresholdModal.lowRestore + step;
                    }
                }
            } else if (field === 'HIGH_RESTORE') {
                if (!thresholdModal.reverseScaling && parseFloat(thresholdModal.highRestore) >= parseFloat(thresholdModal.highFault)) {
                    if (thresholdModal.highRestore === setting.maximumValue) {
                        thresholdModal.highFault = thresholdModal.highRestore;
                        thresholdModal.highRestore -= step;
                    } else {
                        thresholdModal.highFault = thresholdModal.highRestore + step;
                    } //below logic is for reverseScaling threshold
                } else if (thresholdModal.reverseScaling && parseFloat(thresholdModal.highRestore) <= parseFloat(thresholdModal.highFault)) {
                    //reverseScaling scenario
                    if (thresholdModal.highRestore === setting.maximumValue) {
                        thresholdModal.highFault = thresholdModal.highRestore;
                        thresholdModal.highRestore += step;
                    } else {
                        thresholdModal.highFault = thresholdModal.highRestore - step;
                    }
                }
            } else if (field === 'HIGH_FAULT') {
                if (!thresholdModal.reverseScaling && parseFloat(thresholdModal.highFault) <= parseFloat(thresholdModal.highRestore)) {
                    if (thresholdModal.highFault === setting.minimumValue) {
                        thresholdModal.highRestore = thresholdModal.highFault;
                        thresholdModal.highFault += step;
                    } else {
                        thresholdModal.highRestore = thresholdModal.highFault - step;
                    } //below logic is for reverseScaling threshold
                } else if (thresholdModal.reverseScaling && parseFloat(thresholdModal.highFault) >= parseFloat(thresholdModal.highRestore)) {
                    //reverseScaling scenario
                    if (thresholdModal.highFault === setting.minimumValue) {
                        thresholdModal.highRestore = thresholdModal.highFault;
                        thresholdModal.highFault -= step;
                    } else {
                        thresholdModal.highRestore = thresholdModal.highFault + step;
                    }
                }
            } else if (field === 'HIGH_HIGH_RESTORE') {
                if (!thresholdModal.reverseScaling && parseFloat(thresholdModal.highHighRestore) >= parseFloat(thresholdModal.highHighFault)) {
                    if (thresholdModal.highHighRestore === setting.maximumValue) {
                        thresholdModal.highHighFault = thresholdModal.highHighRestore;
                        thresholdModal.highHighRestore -= step;
                    } else {
                        thresholdModal.highHighFault = thresholdModal.highHighRestore + step;
                    } //below logic is for reverseScaling threshold
                } else if (thresholdModal.reverseScaling && parseFloat(thresholdModal.highHighRestore) <= parseFloat(thresholdModal.highHighFault)) {
                    //reverseScaling scenario
                    if (thresholdModal.highHighRestore === setting.maximumValue) {
                        thresholdModal.highHighFault = thresholdModal.highHighRestore;
                        thresholdModal.highHighRestore += step;
                    } else {
                        thresholdModal.highHighFault = thresholdModal.highHighRestore - step;
                    }
                }
            } else if (field === 'HIGH_HIGH_FAULT') {
                if (!thresholdModal.reverseScaling && parseFloat(thresholdModal.highHighFault) <= parseFloat(thresholdModal.highHighRestore)) {
                    if (thresholdModal.highHighFault === setting.minimumValue) {
                        thresholdModal.highHighRestore = thresholdModal.highHighFault;
                        thresholdModal.highHighFault += step;
                    } else {
                        thresholdModal.highHighRestore = thresholdModal.highHighFault - step;
                    } //below logic is for reverseScaling threshold
                } else if (thresholdModal.reverseScaling && parseFloat(thresholdModal.highHighFault) >= parseFloat(thresholdModal.highHighRestore)) {
                    //reverseScaling scenario
                    if (thresholdModal.highHighFault === setting.minimumValue) {
                        thresholdModal.highHighRestore = thresholdModal.highHighFault;
                        thresholdModal.highHighFault -= step;
                    } else {
                        thresholdModal.highHighRestore = thresholdModal.highHighFault + step;
                    }
                }
            }
            //Verify whether threshold values are valid
            thresholdModal.isValid = _this2.isValid(thresholdModal);
            thresholdModal.isValidHighHighValues = _this2.isValidHighHighValues(thresholdModal);
            thresholdModal.isValidHighHighCompareToLowValues = _this2.isValidHighHighCompareToLowValues(thresholdModal);

            _this2.updatePendingPagingMessage(thresholdModal);
            saveData(idx);
        }, 100);
    };

    var _convertFromMeters = function _convertFromMeters(unit, valueInMeter) {
        switch (unit) {
            case "Feet":
                //Feet
                return valueInMeter * 3.280839895;
            case "Inches":
                //Inches
                return valueInMeter * 39.37007874;
            case "Meters":
                //Meters
                return valueInMeter;
            case "mm":
                // mm
                return valueInMeter * 1000;
            case "Centimeters":
                // Centimeters
                return valueInMeter * 100;
            default:
                return valueInMeter;
        }
    };

    this.getFloorAndCeil = function (setting, step, precision) {
        if (_this2.hasLevelSensor) {
            //const emptyLevel = _convertFromMeters(setting.unit, this.networkDeviceType.emptyLevelMeters);
            var nearBlanking = _convertFromMeters(setting.unit, _this2.networkDeviceType.nearBlankingMeters);
            //const farBlanking = _convertFromMeters(setting.unit, this.networkDeviceType.farBlankingMeters);
            _this2.floor = setting.minimumValue;
            _this2.ceil = setting.maximumValue - nearBlanking;
            switch (precision) {
                case 1:
                    _this2.ceil = Math.round(_this2.ceil * 1e1) / 1e1;
                    break;
                case 2:
                    _this2.ceil = Math.round(_this2.ceil * 1e2) / 1e2;
                    break;
                case 3:
                    _this2.ceil = Math.round(_this2.ceil * 1e3) / 1e3;
                    break;
                default:
                    _this2.ceil = Math.round(_this2.ceil * 1e1) / 1e1;
                    break;
            }
        } else {
            //based on ReverseScaling, min & max values changes, make sure to set low value to floor and high value to ceil
            _this2.floor = !setting.reverseScaling ? setting.minimumValue : setting.maximumValue;
            _this2.ceil = !setting.reverseScaling ? setting.maximumValue : setting.minimumValue;
        }
        if (_this2.deviceTypeId == 20 || _this2.deviceTypeId == 21) {
            _this2.floor = _this2.floor == 0 ? step : _this2.floor;
        }
    };

    this.getSliderOptions = function (idx, lowField, type) {
        var _ref;

        var setting = _this2.analogAlarmThresholds.settings[idx];

        var _getAnalogDigits2 = getAnalogDigits(setting.minimumValue, setting.maximumValue),
            step = _getAnalogDigits2.step,
            precision = _getAnalogDigits2.precision;

        _this2.getFloorAndCeil(setting, step, precision);

        // Plain-text name of a slider handle ('model' = low handle, 'high' = high handle).
        // Which handle is the Fault and which is the Restore depends on the threshold type and on reverse scaling.
        var pointerName = function pointerName(label) {
            var text = _this2.translation.text;
            // For a normally-scaled slider the low handle is the Fault on LOW thresholds and the Restore on HIGH ones;
            // reverse scaling swaps the two handles.
            var lowHandleIsFault = type === 'LOW' !== !!setting.reverseScaling;
            var isFault = label === 'model' ? lowHandleIsFault : !lowHandleIsFault;

            if (type === 'LOW') {
                return isFault ? text.LOW_FAULT : text.LOW_RESTORE;
            }
            if (type === 'HIGH') {
                return isFault ? text.HIGH_FAULT : text.HIGH_RESTORE;
            }
            // HIGH_HIGH
            return text.HIGH + " " + (isFault ? text.HIGH_FAULT : text.HIGH_RESTORE);
        };

        return _ref = {
            id: idx + "_" + type,
            floor: _this2.floor,
            ceil: _this2.ceil,
            step: step,
            precision: precision,
            noSwitching: true,
            draggableRange: true,
            showSelectionBar: true,
            showSelectionBarEnd: true,
            showTicks: false
        }, _defineProperty(_ref, "noSwitching", true), _defineProperty(_ref, "minRange", step), _defineProperty(_ref, "enforceStep", true), _defineProperty(_ref, "enforceRange", true), _defineProperty(_ref, "pushRange", true), _defineProperty(_ref, "rightToLeft", setting.reverseScaling), _defineProperty(_ref, "ariaLabel", setting.name + " " + pointerName('model')), _defineProperty(_ref, "ariaLabelHigh", setting.name + " " + pointerName('high')), _defineProperty(_ref, "ariaValueText", function ariaValueText(value, sliderId, label) {
            return pointerName(label) + ", " + value + " " + setting.unit;
        }), _defineProperty(_ref, "translate", function translate(value, sliderId, label) {
            if (label === 'model' || label === 'high') {
                return "<b>" + pointerName(label) + ":</b> " + value;
            }
            if (label === 'floor' || label === 'ceil') {
                return value + " " + setting.unit;
            }

            return value;
        }), _defineProperty(_ref, "onChange", function onChange(sliderId, modelValue, highValue, pointerType) {
            $timeout.cancel(_this2.saveTimers[sliderId]);
        }), _defineProperty(_ref, "onEnd", function onEnd(sliderId, modelValue, highValue, pointerType) {
            var thresholdModal = _this2.analogAlarmThresholds.thresholds[sliderId.split('_')[0]].modal;
            var copyThreshold = Object.assign({}, thresholdModal);
            thresholdModal.isValid = _this2.isValid(copyThreshold);
            thresholdModal.isValidHighHighValues = _this2.isValidHighHighValues(copyThreshold);
            thresholdModal.isValidHighHighCompareToLowValues = _this2.isValidHighHighCompareToLowValues(copyThreshold);
            _this2.updatePendingPagingMessage(thresholdModal);
            if (thresholdModal.isValid && thresholdModal.isValidHighHighValues) {
                startSaveTimer.apply(undefined, _toConsumableArray(sliderId.split('_')));
            }
        }), _ref;
    };

    this.updatePendingPagingMessage = function (thresholdModal) {
        if (_this2.hasLevelSensor && thresholdModal.isValid && thresholdModal.isValidHighHighValues && thresholdModal.isValidHighHighCompareToLowValues) {
            __this.pendingPagingMessage = "Thresholds changes haven't been paged to device.";
            $rootScope.$broadcast('has_pending_paging', { deviceId: _this2.deviceId, hasPendingPaging: true });
        }
    };

    this.isDescriptionValid = function (idx, field) {
        if (_this2.analogAlarmThresholds && _this2.analogAlarmThresholds.descriptions[idx][_this2.langId][field].length === 0) {
            return false;
        }

        return true;
    };

    // Number of threshold description fields that are currently empty. Drives the inline error messages
    this.invalidDescriptionCount = function (idx) {
        if (!_this2.analogAlarmThresholds || !_this2.descriptionFields) {
            return 0;
        }

        return _this2.descriptionFields.filter(function (field) {
            return !_this2.isDescriptionValid(idx, field);
        }).length;
    };

    this.getStateValue = function (field) {
        if (field === 'lowRestore') {
            return 10;
        } else if (field === 'highRestore' || field === 'highHighRestore') {
            return 11;
        } else if (field === 'lowFault') {
            return 12;
        } else if (field === 'highFault' || field === 'highHighFault') {
            return 13;
        }

        throw 'Error: Cannot match state value!';
    };

    this.generateTTSDescription = function (fieldValue) {
        var ttsDesc = fieldValue.replace(/\\|\//g, ' '); // Strip slashes from description
        var ttsParts = ttsDesc.split(' '); // Split the tts string into separate words

        for (var i = 0; i < ttsParts.length; i++) {
            if (ttsParts[i].toUpperCase() === ttsParts[i]) {
                // If the word is in all caps
                ttsParts[i] = ttsParts[i].split('').join(' '); // Add spaces between each letter so it will be read like an acronym
            }
        }

        ttsDesc = ttsParts.join(' '); // Rejoin the tts string from its parts
        return ttsDesc + " ##1";
    };

    this.storeCurrentDescription = function (idx, field) {
        _this2.storedFieldValue = _this2.analogAlarmThresholds.descriptions[idx][_this2.langId][field];
    };

    this.saveDescription = function (idx, field) {
        // Only perform a save if the description in question is valid
        if (_this2.isDescriptionValid(idx, field)) {
            var fieldValue = _this2.analogAlarmThresholds.descriptions[idx][_this2.langId][field];
            if (fieldValue !== _this2.storedFieldValue) {
                if (_this2.analogAlarmThresholds.descriptions[idx][_this2.langId].entryType === 0 || _this2.analogAlarmThresholds.descriptions[idx][_this2.langId].entryType === 1) {
                    var _fullDescriptionValue;

                    var fullDescriptionValues = (_fullDescriptionValue = {
                        entryType: _this2.analogAlarmThresholds.descriptions[idx][_this2.langId].entryType
                    }, _defineProperty(_fullDescriptionValue, field, _this2.analogAlarmThresholds.descriptions[idx][_this2.langId][field] + " (##1)"), _defineProperty(_fullDescriptionValue, "tts" + field, _this2.generateTTSDescription(fieldValue)), _fullDescriptionValue);

                    // Since we have to save all 4 fields as 'custom' when only 1 is changed (the first time) we need to make sure ALL 4 fields are valid, and if they aren't we'll place the defaults in
                    _this2.descriptionFields.forEach(function (descField) {
                        if (descField !== field) {
                            if (!_this2.isDescriptionValid(idx, descField)) {
                                fullDescriptionValues[descField] = _this2.analogAlarmThresholds.originalDescriptions[idx][_this2.langId][descField] + " (##1)";
                                fullDescriptionValues["tts" + descField] = _this2.analogAlarmThresholds.originalDescriptions[idx][_this2.langId][descField] + " ##1";
                            } else {
                                fullDescriptionValues[descField] = _this2.analogAlarmThresholds.descriptions[idx][_this2.langId][descField] + " (##1)";
                                fullDescriptionValues["tts" + descField] = _this2.analogAlarmThresholds.descriptions[idx][_this2.langId][descField] + " ##1";
                            }
                        }
                    });

                    $http.post(HOST + "/api/AnalogDescriptions?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&channel=" + _this2.analogAlarmThresholds.settings[idx].channel + "&languageId=" + (_this2.langId === 'fr' ? 2 : 1) + "&hasLevelSensor=" + _this2.hasLevelSensor, fullDescriptionValues).then(function (resp) {
                        _this2.analogAlarmThresholds.descriptions[idx][_this2.langId].entryType = 2;
                        if (resp.data !== 4) {
                            toaster.pop('error', _this2.translation.text.RTU_CONFIGURATION, _this2.translation.text.ERROR_REOPEN_WINDOW);
                        } else {
                            buildChart(_this2.analogAlarmThresholds.thresholds[idx]);
                            broadcastThresholdsAndLevelReferenceChanges();
                        }
                    }, function (resp) {
                        toaster.pop('error', _this2.translation.text.RTU_CONFIGURATION, resp.data);
                    });
                } else if (_this2.analogAlarmThresholds.descriptions[idx][_this2.langId].entryType === 2) {
                    var simpleDescription = {
                        description: fieldValue + " (##1)",
                        ttsdescription: _this2.generateTTSDescription(fieldValue)
                    };

                    $http.put(HOST + "/api/AnalogDescriptions?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&channel=" + _this2.analogAlarmThresholds.settings[idx].channel + "&state=" + _this2.getStateValue(field) + "&languageId=" + (_this2.langId === 'fr' ? 2 : 1) + "&severity=" + (field === 'highHighFault' || field === 'highHighRestore' ? 1 : 0) + "&hasLevelSensor=" + _this2.hasLevelSensor, simpleDescription).then(function (resp) {
                        if (resp.data !== 1) {
                            toaster.pop('error', _this2.translation.text.RTU_CONFIGURATION, _this2.translation.text.ERROR_REOPEN_WINDOW);
                        } else {
                            buildChart(_this2.analogAlarmThresholds.thresholds[idx]);
                            broadcastThresholdsAndLevelReferenceChanges();
                        }
                    }, function (resp) {
                        toaster.pop('error', _this2.translation.text.RTU_CONFIGURATION, resp.data);
                    });
                }
            }
        }
    };

    this.disableInput = function (idx) {
        if (_this2.analogAlarmThresholds.statuses[idx] !== null) {
            if (moment(_this2.analogAlarmThresholds.statuses[idx].dateTime).valueOf() < _this2.currentTime) {
                var globalVarId = _this2.analogAlarmThresholds.statuses[idx].id;
                $http.delete(HOST + "/api/AnalogStatus?deviceId=" + _this2.deviceId + "&customerId=" + _this2.accountInfo.customerId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&channel=" + getCh(idx) + "&globalVarId=" + globalVarId + "&timezone=" + _this2.accountInfo.timeZone).then(function (resp) {
                    if (resp.data > 0) {
                        _this2.analogAlarmThresholds.statuses[idx] = null;
                    }

                    $http.post(HOST + "/api/AnalogStatus?deviceId=" + _this2.deviceId + "&customerId=" + _this2.accountInfo.customerId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&channel=" + getCh(idx) + "&duration=" + _this2.statusSelectors[idx] + "&timezone=" + _this2.accountInfo.timeZone).then(function (resp) {
                        if (resp.data) {
                            _this2.analogAlarmThresholds.statuses[idx] = resp.data;
                        }
                    });
                });
            }
        } else {
            $http.post(HOST + "/api/AnalogStatus?deviceId=" + _this2.deviceId + "&customerId=" + _this2.accountInfo.customerId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&channel=" + getCh(idx) + "&duration=" + _this2.statusSelectors[idx] + "&timezone=" + _this2.accountInfo.timeZone).then(function (resp) {
                if (resp.data) {
                    _this2.analogAlarmThresholds.statuses[idx] = resp.data;
                }
            });
        }
    };

    this.enableInput = function (idx) {
        var globalVarId = _this2.analogAlarmThresholds.statuses[idx].id;
        $http.delete(HOST + "/api/AnalogStatus?deviceId=" + _this2.deviceId + "&customerId=" + _this2.accountInfo.customerId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&channel=" + getCh(idx) + "&globalVarId=" + globalVarId + "&timezone=" + _this2.accountInfo.timeZone).then(function (resp) {
            if (resp.data > 0) {
                _this2.analogAlarmThresholds.statuses[idx] = null;
            }
        });
    };

    this.isInputDisabled = function (idx) {
        if (_this2.analogAlarmThresholds && _this2.analogAlarmThresholds.statuses[idx] !== null) {
            if (_this2.analogAlarmThresholds.statuses[idx].dateTime !== null && moment(_this2.analogAlarmThresholds.statuses[idx].dateTime).valueOf() < _this2.currentTime) {
                return false;
            }
            return true;
        }

        return false;
    };

    this.getCurrentStatus = function (idx) {
        if (_this2.analogAlarmThresholds) {
            if (_this2.analogAlarmThresholds.statuses[idx] === null) {
                return _this2.translation.text.ENABLED;
            } else if (_this2.analogAlarmThresholds.statuses[idx].dateTime === null) {
                return _this2.translation.text.DISABLED + " " + _this2.translation.text.INDEFINITELY;
            }
            if (moment(_this2.analogAlarmThresholds.statuses[idx].dateTime).valueOf() < _this2.currentTime) {
                return _this2.translation.text.ENABLED;
            }
            return _this2.translation.text.DISABLED_UNTIL + " " + datetimeService.formatDateAgentText(_this2.analogAlarmThresholds.statuses[idx].dateTime, 'yyyy-MM-ddTHH:mm:ss', false, _this2.accountInfo.preferenceUser.timeFormat);
        } else return _this2.translation.text.DISABLED;
    };

    this.getAlarmDelayDisplay = function (idx) {
        if (_this2.analogAlarmThresholds) {
            if (_this2.analogAlarmThresholds.alarmDelays[idx].entryType === 0) {
                return _this2.translation.text.ENTRY_FACTORY;
            } else if (_this2.analogAlarmThresholds.alarmDelays[idx].entryType === 1) {
                return _this2.translation.text.ENTRY_CUSTOMER;
            } else if (_this2.analogAlarmThresholds.alarmDelays[idx].entryType === 2) {
                return _this2.translation.text.ENTRY_UNIT;
            }
        }
        return _this2.translation.text.ENTRY_UNKNOWN;
    };

    this.saveAlarmDelay = function (idx) {
        var duration = _this2.delaySelectors[idx];

        if (parseInt(duration, 10) === 32767) {
            // Delete
            if (_this2.analogAlarmThresholds.alarmDelays[idx].entryType === 2 && _this2.analogAlarmThresholds.alarmDelays[idx].id !== 0) {
                $http.delete(HOST + "/api/AnalogAlarmDelay?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&input=" + getCh(idx) + "&entryId=" + _this2.analogAlarmThresholds.alarmDelays[idx].id).then(function (resp) {
                    _this2.analogAlarmThresholds.alarmDelays[idx] = resp.data;
                    _this2.delaySelectors[idx] = "" + resp.data.delay;
                });
            }
        } else {
            if (_this2.analogAlarmThresholds.alarmDelays[idx].entryType === 2 && _this2.analogAlarmThresholds.alarmDelays[idx].id !== 0) {
                // Update
                $http.put(HOST + "/api/AnalogAlarmDelay?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&input=" + getCh(idx) + "&delay=" + duration + "&entryId=" + _this2.analogAlarmThresholds.alarmDelays[idx].id).then(function (resp) {
                    _this2.analogAlarmThresholds.alarmDelays[idx] = resp.data;
                    _this2.delaySelectors[idx] = "" + resp.data.delay;
                });
            } else {
                // Insert
                $http.post(HOST + "/api/AnalogAlarmDelay?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&input=" + getCh(idx) + "&delay=" + duration).then(function (resp) {
                    _this2.analogAlarmThresholds.alarmDelays[idx] = resp.data;
                    _this2.delaySelectors[idx] = "" + resp.data.delay;
                });
            }
        }
    };

    this.getAlarmRecallDescription = function (idx) {
        if (_this2.analogAlarmThresholds) {
            if (_this2.analogAlarmThresholds.alarmRecalls[idx].entryType === 0) {
                return _this2.translation.text.ENTRY_FACTORY;
            } else if (_this2.analogAlarmThresholds.alarmRecalls[idx].entryType === 1) {
                return _this2.translation.text.ENTRY_CUSTOMER;
            } else if (_this2.analogAlarmThresholds.alarmRecalls[idx].entryType === 2) {
                return _this2.translation.text.ENTRY_UNIT;
            }
        }
        return _this2.translation.text.ENTRY_UNKNOWN;
    };

    this.saveAlarmRecall = function (idx) {
        var delay = _this2.reattemptDelaySelectors[idx];
        var retries = _this2.reattemptRetrySelectors[idx];

        if (parseInt(delay, 10) === 0 && parseInt(retries, 10) !== 0) {
            retries = 0;
        }

        if (parseInt(delay, 10) > 0 && parseInt(retries, 10) === 0) {
            retries = 1;
        }

        if (parseInt(delay, 10) === 32767) {
            if (_this2.analogAlarmThresholds.alarmRecalls[idx].entryType === 2 && _this2.analogAlarmThresholds.alarmRecalls[idx].id !== 0) {
                // Delete
                $http.delete(HOST + "/api/AnalogAlarmRecall?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&input=" + getCh(idx) + "&entryId=" + _this2.analogAlarmThresholds.alarmRecalls[idx].id).then(function (resp) {
                    _this2.analogAlarmThresholds.alarmRecalls[idx] = resp.data;
                    _this2.reattemptDelaySelectors[idx] = "" + resp.data.delayMins;
                    _this2.reattemptRetrySelectors[idx] = "" + resp.data.retryCount;
                });
            }
        } else {
            if (_this2.analogAlarmThresholds.alarmRecalls[idx].entryType === 2 && _this2.analogAlarmThresholds.alarmRecalls[idx].id !== 0) {
                // Update
                $http.put(HOST + "/api/AnalogAlarmRecall?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&input=" + getCh(idx) + "&delay=" + delay + "&entryId=" + _this2.analogAlarmThresholds.alarmRecalls[idx].id + "&retries=" + retries).then(function (resp) {
                    _this2.analogAlarmThresholds.alarmRecalls[idx] = resp.data;
                    _this2.reattemptDelaySelectors[idx] = "" + resp.data.delayMins;
                    _this2.reattemptRetrySelectors[idx] = "" + resp.data.retryCount;
                });
            } else {
                // Insert
                $http.post(HOST + "/api/AnalogAlarmRecall?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceName=" + encodeURIComponent(_this2.deviceName) + "&input=" + getCh(idx) + "&delay=" + delay + "&retries=" + retries).then(function (resp) {
                    _this2.analogAlarmThresholds.alarmRecalls[idx] = resp.data;
                    _this2.reattemptDelaySelectors[idx] = "" + resp.data.delayMins;
                    _this2.reattemptRetrySelectors[idx] = "" + resp.data.retryCount;
                });
            }
        }
    };

    this.updateLevelReferenceById = function (ref, channel, channelIndex, deviceTypeId) {
        if (angular.isUndefined(ref.referenceValue)) {
            ref.referenceValue = ref.referenceValueLastKnown;
            return;
        }
        $http.patch(HOST + "/api/LevelReference?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceType=" + deviceTypeId, ref).then(function (resp) {
            buildChart(_this2.analogAlarmThresholds.thresholds[channelIndex]);
            broadcastThresholdsAndLevelReferenceChanges();
        });
    };

    this.updateLevelReferenceByIdNew = function (ref, channel, channelIndex, plotLineTypeID, deviceTypeId) {
        ref.plotLineTypeID = plotLineTypeID;
        $http.patch(HOST + "/api/LevelReference?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceType=" + deviceTypeId, ref).then(function (resp) {
            buildChart(_this2.analogAlarmThresholds.thresholds[channelIndex]);
            broadcastThresholdsAndLevelReferenceChanges();
        });
    };

    this.validateNewAddLakeLevelRefVal = function (newAddLakeLevelRef) {
        if (angular.isUndefined(newAddLakeLevelRef.referenceValue)) {
            newAddLakeLevelRef.referenceValue = newAddLakeLevelRef.referenceValueLastKnown;
            newAddLakeLevelRef.stopSave = true;
        }
    };

    // Keyboard support for the Read Only Mode switch: Space and Enter toggle it, matching native checkbox/switch behaviour
    this.onReadOnlyKeyDown = function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            event.stopPropagation();
            _this2.toggleReadOnly();
        }
    };

    this.addNewLevelReference = function (channelIndex, channel) {
        _this2.popoverAddLevelReferenceIsOpen = true;
        // create new level Reference, whose Ids equal to -1
        var levelReferencesLength = _this2.analogAlarmThresholds.thresholds[channelIndex].lakeReferences.length;
        var newLakeLevelRef = {};
        newLakeLevelRef.levelReferenceID = -1;
        newLakeLevelRef.referenceValue = _this2.analogAlarmThresholds.settings[channelIndex].minimumValue;
        newLakeLevelRef.channel = channel;
        newLakeLevelRef.deviceID = _this2.deviceId;
        newLakeLevelRef.referenceOrder = levelReferencesLength + 1;
        newLakeLevelRef.referenceDescription = "Level Reference " + (levelReferencesLength + 1);
        newLakeLevelRef.plotLineTypeID = 2;
        newLakeLevelRef.description = "ShortDash";
        newLakeLevelRef.strokeDasharray = "6,2";
        newLakeLevelRef.hexColor = _this2.colorPalette[channelIndex];
        newLakeLevelRef.dateCreated = new Date();
        _this2.newAddLakeLevelRef = angular.copy(newLakeLevelRef);
        _this2.addMode = true;
        // ctrl.editModeIndex = -1;

        $timeout(function () {
            $element.find(".dscFocus").focus();
        }, 500);
    };

    // Called when the Line Type select in the Add Level Reference popover changes: copy the chosen type's
    // description and dash pattern onto the new reference so the preview and the saved record stay in sync
    this.updateNewAddLakeLevelRefPlotLineType = function () {
        var selectedType = _this2.plotlineTypes.find(function (type) {
            return type.plotLineTypeID === _this2.newAddLakeLevelRef.plotLineTypeID;
        });
        if (selectedType) {
            _this2.newAddLakeLevelRef.description = selectedType.description;
            _this2.newAddLakeLevelRef.strokeDasharray = selectedType.strokeDasharray;
        }
    };

    this.saveLevelReference = function (levelRefNew, deviceTypeId) {
        if (levelRefNew.stopSave) {
            levelRefNew.stopSave = null;
            return;
        }

        $http.post(HOST + "/api/LevelReference?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&deviceType=" + deviceTypeId, levelRefNew).then(function (resp) {
            var channelIndex = _this2.analogAlarmThresholds.thresholds.findIndex(function (x) {
                return x.channel == levelRefNew.channel;
            });
            _this2.analogAlarmThresholds.thresholds[channelIndex].lakeReferences = resp.data;
            _this2.popoverAddLevelReferenceIsOpen = false;
            _this2.newAddLakeLevelRef = null;
            buildChart(_this2.analogAlarmThresholds.thresholds[channelIndex]);
            broadcastThresholdsAndLevelReferenceChanges();
        });
    };

    this.deleteLevelReference = function (levelRef, deviceTypeId) {
        $http.delete(HOST + "/api/LevelReference?customerId=" + _this2.accountInfo.customerId + "&deviceId=" + _this2.deviceId + "&channel=" + levelRef.channel + "&referenceId=" + levelRef.levelReferenceID + "&levelRefDescription=" + levelRef.referenceDescription + "&deviceType=" + deviceTypeId).then(function (resp) {
            var channelIndex = _this2.analogAlarmThresholds.thresholds.findIndex(function (x) {
                return x.channel == levelRef.channel;
            });
            var lakeLevelRefIndex = _this2.analogAlarmThresholds.thresholds[channelIndex].lakeReferences.findIndex(function (x) {
                return x.levelReferenceID == resp.data;
            });
            if (lakeLevelRefIndex > -1) {
                // only splice array when item is found
                _this2.analogAlarmThresholds.thresholds[channelIndex].lakeReferences.splice(lakeLevelRefIndex, 1); // 2nd parameter means remove one item only
            }
            buildChart(_this2.analogAlarmThresholds.thresholds[channelIndex]);
            broadcastThresholdsAndLevelReferenceChanges();
        });
    };

    this.getLevelReferencePlotlineTypes = function () {
        $http.get(HOST + "/api/LevelReference/GetPlotlineTypes?customerId=" + _this2.accountInfo.customerId).then(function (resp) {
            _this2.plotlineTypes = resp.data;
        });
    };

    this.cancelLevelReference = function () {
        _this2.popoverAddLevelReferenceIsOpen = false;
        _this2.newAddLakeLevelRef = null;
    };

    var broadcastThresholdsAndLevelReferenceChanges = function broadcastThresholdsAndLevelReferenceChanges() {
        var _brdMsg = { deviceId: _this2.deviceId, channel: _this2.analogAlarmThresholds.settings[$scope.selectedChannel.channelIndex].channel, fieldName: "any" };
        $rootScope.$broadcast('updateThresholdsAndLevelReference', _brdMsg);
    };

    this.$onDestroy = function () {
        timeLapseService.unRegisterLocal('ANALOG_STATUS', null, null, setTimestamp);
        if (_this2.chart) _this2.chart.destroy();
        __this.pendingPagingMessage = null;
        $rootScope.$broadcast('has_pending_paging', { deviceId: _this2.deviceId, hasPendingPaging: false });
    };

    this.postUserAction2Nlog = function (customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Analog Thresholds";

        return $http({
            method: 'POST',
            url: HOST + "/api/AnalogAlarmThresholds",
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    this.configure = function () {
        _this2.MMPlusRtuSettingFactory.configMMPlusChannel(_this2.deviceId, _this2.imei, 1, 0).then(function (result) {
            //success
            var configResult = result.data.result.match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
            __this.alertMessage = "Channel Config " + configResult[0] + ": " + configResult[1];
            __this.setTimeOut();
        }, function (error) {
            //error
            __this.alertMessage = "Something went wrong while processing channel config request";
            __this.setTimeOut();
        });
    };

    this.getImei = function () {
        deviceService.getDevice(_this2.deviceId, _this2.accountInfo.customerId).then(function (datafromFactory) {
            __this.imei = datafromFactory.data.imei;
        }, function (error) {
            //error

        }).then(function (data) {});
    };

    this.setTimeOut = function () {
        setTimeout(function () {
            __this.alertMessage = null;
        }, 15000); // 15 Seconds
    };
}

AnalogThresholdsController.$inject = ['_', '$', 'HOST', '$http', '$element', '$rootScope', '$timeout', '$scope', '$sce', 'authenticationService', 'datetimeService', 'timeLapseService', 'translationService', 'toaster', 'AnalogAlarmThresholdsModel', 'MMPlusRtuSettingFactory', 'deviceService', '$uibModal'];
'use strict';

angular.module('mc.rtu-configuration').component('analogThresholds', {
  controller: AnalogThresholdsController,
  transclude: true,
  templateUrl: 'ui/rtuconfiguration/analogthresholds/analog-thresholds-partial.html',
  bindings: {
    windowId: '<',
    mobile: '<',
    classicView: '<',
    deviceId: '<',
    deviceName: '<',
    deviceTypeId: '<'
  }
});
"use strict";
'use strict';

function AcAlarmController(_, $, HOST, $http, $rootScope, $timeout, $scope, $sce, authenticationService, datetimeService, timeLapseService, translationService, toaster, sharedSetupService, $uibModal) {
    var _this = this;

    var setTimestamp = function setTimestamp(data) {
        _this.currentTime = moment(data.localDateTime).valueOf();
    };

    this.$onInit = function () {
        _this._ = _;
        _this.accountInfo = authenticationService.getAccountInfo();
        _this.langId = _this.accountInfo.preferenceUser.i18nCode === 'fr' ? _this.accountInfo.preferenceUser.i18nCode : 'en';
        _this.translation = translationService.translation;
        _this.alerts = [];
        $scope.alerts = [];
        _this.descriptions = [];
        _this.statuses = [];
        _this.settings = [];
        _this.alarmDelays = [];
        //this.acOverrides = [];
        _this.statusSelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.delaySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.reattemptDelaySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.reattemptRetrySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.currentTime = 0;
        _this.loading = true;
        _this.showWarning = false;
        _this.ac_override_message = _this.translation.text.AC_OVERRIDE_INFO;
        // Sort of like enums. Allow me to loop through all the description fields without repeating myself
        // TODO: If we ever add support for additional languages in the DB this will need to be updated as well.
        _this.supportedLanguages = ['en', 'fr'];
        //this.descriptionFields = ['normal', 'offNormal', 'tamper'];
        _this.isManholeMonitor = false; //flag for device model manhole monitor
        _this.is110Series = false; //flag for device model M110/150
        _this.is800Series = false; //flag for device model M800/850
        _this.isRangerM50 = false; //flag for device model Ranger M50
        _this.isMcAdmin = false;
        _this.isMcAdmin = sharedSetupService.mcAdmin();

        timeLapseService.getLocalDateTime().then(function (resp) {
            _this.currentTime = moment(resp.data.localDateTime).valueOf();
        });

        timeLapseService.registerLocal('DIGITAL_STATUS', null, null, setTimestamp);

        $http.get(HOST + '/api/ACCommsAlarm?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
            _this.loading = false;
            _this.showWarning = false;
            if (resp.data.settings.length === 0) {
                $scope.alerts.push({ msg: _this.translation.text.NO_AC_COMMS_SETTINGS, type: 'info', languageCode: 'NO_AC_COMMS_SETTINGS' });
                _this.alerts.push({ msg: _this.translation.text.NO_AC_COMMS_SETTINGS, type: 'info', languageCode: 'NO_AC_COMMS_SETTINGS' });
            } else {
                _this.device = resp.data.device;
                if (_this.device.model == 9 || _this.device.model == 19) _this.is800Series = true;
                if (_this.device.model == 8 || _this.device.model == 17 || _this.device.model == 18) _this.is110Series = true;
                if (_this.device.model == 15 || _this.device.model == 20) _this.isManholeMonitor = true;
                if (_this.device.model == 21) _this.isRangerM50 = true;
                _this.settings = resp.data.settings;
                //this.descriptions = resp.data.descriptions;
                _this.statuses = resp.data.statuses;
                _this.alarmDelays = resp.data.alarmDelays;
                _this.alarmRecalls = resp.data.alarmRecalls;
                //this.acOverrides = resp.data.acOverrides;

                for (var i = 0; i < resp.data.alarmDelays.length; i++) {
                    if (_this.alarmDelays[i].entryType == 0 && _this.settings[i].channel == 60 && _this.alarmDelays[i].delay !== 30) _this.showWarning = true;
                    _this.delaySelectors[i] = '' + resp.data.alarmDelays[i].delay;

                    //Get original Comm value -- *CURRENTLY 2ND VALUE MAY CHANGE IN FUTURE*
                    _this.commDelaySelectorOriginalValue = [];
                    if (i == 0) {
                        _this.commDelaySelectorOriginalValue[i] = '' + resp.data.alarmDelays[i].delay;
                    }
                    if (i == 1) {
                        _this.commDelaySelectorOriginalValue[i] = '' + resp.data.alarmDelays[i].delay;
                    }

                    //if (this.settings[i].channel == 60) {
                    //    if (this.is110Series && this.alarmDelays[i].delay == 125) this.alarmDelays[i].entryType = 0;
                    //    if (this.is800Series && this.alarmDelays[i].delay == 30) this.alarmDelays[i].entryType = 0;
                    //    if (this.isManholeMonitor && this.alarmDelays[i].delay == 1560) this.alarmDelays[i].entryType = 0;
                    //}
                }

                for (var _i = 0; _i < resp.data.alarmRecalls.length; _i++) {
                    _this.reattemptDelaySelectors[_i] = '' + resp.data.alarmRecalls[_i].delayMins;
                    _this.reattemptRetrySelectors[_i] = '' + resp.data.alarmRecalls[_i].retryCount;
                }
            }
        }, function (resp) {
            console.log(resp.data);
        });

        //Log tab access event to NLog
        _this.postUserAction2Nlog(_this.accountInfo.customerId, _this.deviceId).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            _this.langId = langId === 'fr' ? langId : 'en';
            _this.ac_override_message = _this.translation.text.AC_OVERRIDE_INFO;
        });
    };

    this.isAdmin = function () {
        return _this.accountInfo.userRole === 'Administrator' || _this.accountInfo.userRole === 'SuperAdministrator';
    };

    this.getInputDescription = function (setting) {
        return setting.description || _this.translation.text.DIGITAL + ' ' + _this.translation.text.INPUT + ' #' + setting.channel;
    };

    this.isDescriptionValid = function (idx, field) {
        if (_this.descriptions[idx][_this.langId][field].length === 0) {
            return false;
        }

        return true;
    };

    this.disableInput = function (idx) {
        if (_this.statuses[idx] !== null) {
            if (moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
                var globalVarId = _this.statuses[idx].id;
                $http.delete(HOST + '/api/ACCommsAlarm/EnableAlarm?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&channel=' + _this.settings[idx].channel + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&globalVarId=' + globalVarId + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                    if (resp.data > 0) {
                        _this.statuses[idx] = null;
                    }

                    $http.post(HOST + '/api/ACCommsAlarm/DisableAlarm?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&channel=' + _this.settings[idx].channel + '&duration=' + _this.statusSelectors[idx] + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                        if (resp.data) {
                            _this.statuses[idx] = resp.data;
                        }
                    });
                });
            }
        } else {
            $http.post(HOST + '/api/ACCommsAlarm/DisableAlarm?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&channel=' + _this.settings[idx].channel + '&duration=' + _this.statusSelectors[idx] + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                if (resp.data) {
                    _this.statuses[idx] = resp.data;
                }
            });
        }
    };

    this.enableInput = function (idx) {
        var globalVarId = _this.statuses[idx].id;
        $http.delete(HOST + '/api/ACCommsAlarm/EnableAlarm?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&channel=' + _this.settings[idx].channel + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&globalVarId=' + globalVarId + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
            if (resp.data > 0) {
                _this.statuses[idx] = null;
            }
        });
    };

    this.postUserAction2Nlog = function (customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Other";

        return $http({
            method: 'POST',
            url: HOST + '/api/ACCommsAlarm',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    this.isInputDisabled = function (idx) {
        if (_this.statuses[idx] !== null) {
            if (_this.statuses[idx].dateTime !== null && moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
                return false;
            }
            return true;
        }

        return false;
    };

    this.getCurrentStatus = function (idx) {
        if (_this.statuses[idx] === null) {
            return _this.translation.text.ENABLED;
        } else if (_this.statuses[idx].dateTime === null) {
            return _this.translation.text.DISABLED + ' ' + _this.translation.text.INDEFINITELY;
        }

        if (moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
            return _this.translation.text.ENABLED;
        }

        return _this.translation.text.DISABLED_UNTIL + ' ' + datetimeService.formatDateAgentText(_this.statuses[idx].dateTime, 'yyyy-MM-ddTHH:mm:ss', false, _this.accountInfo.preferenceUser.timeFormat);
    };

    this.getAlarmDelayDisplay = function (idx) {
        if (_this.alarmDelays[idx].entryType === 0) {
            return _this.translation.text.ENTRY_FACTORY;
        } else if (_this.alarmDelays[idx].entryType === 1) {
            return _this.translation.text.ENTRY_CUSTOMER;
        } else if (_this.alarmDelays[idx].entryType === 2) {
            return _this.translation.text.ENTRY_UNIT;
        }

        return _this.translation.text.ENTRY_UNKNOWN;
    };

    this.saveAlarmDelay = function (idx) {
        var duration = _this.delaySelectors[idx];

        if (_this.settings[idx].channel !== 60) {
            if (parseInt(duration, 10) === 32767) {
                // Delete
                if (_this.alarmDelays[idx].entryType === 2 && _this.alarmDelays[idx].id !== 0) {
                    $http.delete(HOST + '/api/ACCommsAlarm/DeleteDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&entryId=' + _this.alarmDelays[idx].id).then(function (resp) {
                        _this.alarmDelays[idx] = resp.data;
                        _this.delaySelectors[idx] = '' + resp.data.delay;
                    });
                }
            } else {
                if (_this.alarmDelays[idx].entryType === 2 && _this.alarmDelays[idx].id !== 0) {
                    // Update
                    $http.put(HOST + '/api/ACCommsAlarm/UpdateDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&delay=' + duration + '&entryId=' + _this.alarmDelays[idx].id).then(function (resp) {
                        _this.alarmDelays[idx] = resp.data;
                        _this.delaySelectors[idx] = '' + resp.data.delay;
                    });
                } else {
                    // Insert
                    $http.post(HOST + '/api/ACCommsAlarm/AddDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&delay=' + duration).then(function (resp) {
                        _this.alarmDelays[idx] = resp.data;
                        _this.delaySelectors[idx] = '' + resp.data.delay;
                    });
                }
            }
        } else {
            if (parseInt(duration, 10) === 32767) {
                if (_this.is110Series) duration = 125;
                if (_this.is800Series || _this.isRangerM50) duration = 30;
                if (_this.isManholeMonitor) duration = 1560;
            }

            if (_this.alarmDelays[idx].entryType === 0 && _this.alarmDelays[idx].id !== 0) {
                // Insert
                $http.post(HOST + '/api/ACCommsAlarm/AddDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&delay=' + duration).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            } else {
                // Update
                $http.put(HOST + '/api/ACCommsAlarm/UpdateDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&delay=' + duration + '&entryId=' + _this.alarmDelays[idx].id).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            }
        }
    };

    this.getAlarmRecallDescription = function (idx) {
        if (_this.alarmRecalls[idx].entryType === 0) {
            return _this.translation.text.ENTRY_FACTORY;
        } else if (_this.alarmRecalls[idx].entryType === 1) {
            return _this.translation.text.ENTRY_CUSTOMER;
        } else if (_this.alarmRecalls[idx].entryType === 2) {
            return _this.translation.text.ENTRY_UNIT;
        }

        return _this.translation.text.ENTRY_UNKNOWN;
    };

    this.saveAlarmRecall = function (idx) {
        var delay = _this.reattemptDelaySelectors[idx];
        var retries = _this.reattemptRetrySelectors[idx];

        if (parseInt(delay, 10) === 0 && parseInt(retries, 10) !== 0) {
            retries = 0;
        }

        if (parseInt(delay, 10) > 0 && parseInt(retries, 10) === 0) {
            retries = 1;
        }

        if (parseInt(delay, 10) === 32767) {
            if (_this.alarmRecalls[idx].entryType === 2 && _this.alarmRecalls[idx].id !== 0) {
                // Delete
                $http.delete(HOST + '/api/ACCommsAlarm/DeleteReattempt?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&entryId=' + _this.alarmRecalls[idx].id).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            }
        } else {
            if (_this.alarmRecalls[idx].entryType === 2 && _this.alarmRecalls[idx].id !== 0) {
                // Update
                $http.put(HOST + '/api/ACCommsAlarm/UpdateReattempt?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&delay=' + delay + '&entryId=' + _this.alarmRecalls[idx].id + '&retries=' + retries).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            } else {
                // Insert
                $http.post(HOST + '/api/ACCommsAlarm/AddReattempt?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + _this.settings[idx].channel + '&delay=' + delay + '&retries=' + retries).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            }
        }
    };

    this.openCommonModal = function (bool, item, index) {
        if (bool && _this.commDelaySelectorOriginalValue[index] == 15) {
            var modalController = function modalController($uibModalInstance, translation) {
                this.translation = translation;
                this.tmpConfirmMessageA = this.translation.text.CUSTOM_DELAY;
                this.tmpConfirmMessageB = this.translation.text.DELETE_ACCOUNT_MESSAGE_C;
                this.ok = function () {
                    $uibModalInstance.close(item);
                };

                this.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            };

            modalController.$inject = ['$uibModalInstance', 'translation'];

            var modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
                controller: modalController,
                controllerAs: '$ctrl',
                size: 'sm',
                resolve: {
                    translation: function translation() {
                        return _this.translation;
                    }
                }
            });

            modalInstance.result.then(function (item) {
                //Keep Change, no additional Logic Needed 

            }, function () {
                // cancel button - Reset to original value
                _this.delaySelectors[index] = _this.commDelaySelectorOriginalValue[index];
            });
        }
    };

    this.$onDestroy = function () {
        timeLapseService.unRegisterLocal('DIGITAL_STATUS', null, null, setTimestamp);
    };
}

AcAlarmController.$inject = ['_', '$', 'HOST', '$http', '$rootScope', '$timeout', '$scope', '$sce', 'authenticationService', 'datetimeService', 'timeLapseService', 'translationService', 'toaster', 'sharedSetupService', '$uibModal'];
'use strict';

angular.module('mc.rtu-configuration').component('acCommsAlarm', {
    controller: AcAlarmController,
    transclude: true,
    templateUrl: 'ui/rtuconfiguration/accommsalarm/ac-comms-alarm-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        deviceId: '<',
        deviceName: '<'
    }
});
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function DigitalDescriptionsController(_, $, HOST, $http, $rootScope, $timeout, $scope, $sce, authenticationService, datetimeService, timeLapseService, translationService, toaster, deviceMenuService) {
    var _this = this;

    var setTimestamp = function setTimestamp(data) {
        _this.currentTime = moment(data.localDateTime).valueOf();
    };

    this.$onInit = function () {
        _this._ = _;
        _this.accountInfo = authenticationService.getAccountInfo();
        _this.langId = _this.accountInfo.preferenceUser.i18nCode === 'fr' ? _this.accountInfo.preferenceUser.i18nCode : 'en';
        _this.translation = translationService.translation;
        _this.alerts = [];
        $scope.alerts = [];
        _this.descriptions = [];
        _this.statuses = [];
        _this.acOverrides = [];
        _this.statusSelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.delaySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.reattemptDelaySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.reattemptRetrySelectors = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        _this.currentTime = 0;
        _this.loading = true;
        _this.ac_override_message = _this.translation.text.AC_OVERRIDE_INFO;
        // Sort of like enums. Allow me to loop through all the description fields without repeating myself
        // TODO: If we ever add support for additional languages in the DB this will need to be updated as well.
        _this.supportedLanguages = ['en', 'fr'];
        _this.descriptionFields = ['normal', 'offNormal', 'tamper'];
        _this.disableChannel1 = false; //if it is M84 with SkuId = 2 (MM+ with SkuId = L), device type or Model = 20
        _this.disableRunningChannel = false; //if it is M120/M150 and running state, device type or Model = 17 or 18

        timeLapseService.getLocalDateTime().then(function (resp) {
            _this.currentTime = moment(resp.data.localDateTime).valueOf();
        });

        timeLapseService.registerLocal('DIGITAL_STATUS', null, null, setTimestamp);

        _this.currentDevice = _this.deviceId;
        $http.get(HOST + '/api/DigitalDescriptions?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&timezone=' + _this.accountInfo.timeZone + '&languageId=' + (_this.langId === 'fr' ? 2 : 1)).then(function (resp) {
            _this.loading = false;
            if (resp.data.settings.length === 0) {
                $scope.alerts.push({ msg: _this.translation.text.NO_DIGITAL_SETTINGS, type: 'info', languageCode: 'NO_DIGITAL_SETTINGS' });
                _this.alerts.push({ msg: _this.translation.text.NO_DIGITAL_SETTINGS, type: 'info', languageCode: 'NO_DIGITAL_SETTINGS' });
            } else {
                _this.device = { type: null };
                _this.getDeviceType(_this.deviceId);
                _this.settings = resp.data.settings;
                _this.descriptions = resp.data.descriptions;
                _this.statuses = resp.data.statuses;
                _this.alarmDelays = resp.data.alarmDelays;
                _this.alarmRecalls = resp.data.alarmRecalls;
                _this.acOverrides = resp.data.acOverrides;

                for (var i = 0; i < resp.data.alarmDelays.length; i++) {
                    _this.delaySelectors[i] = '' + resp.data.alarmDelays[i].delay;
                }

                for (var _i = 0; _i < resp.data.alarmRecalls.length; _i++) {
                    _this.reattemptDelaySelectors[_i] = '' + resp.data.alarmRecalls[_i].delayMins;
                    _this.reattemptRetrySelectors[_i] = '' + resp.data.alarmRecalls[_i].retryCount;
                }
            }
        }, function (resp) {
            console.log(resp.data);
        });

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            _this.langId = langId === 'fr' ? langId : 'en';
            _this.ac_override_message = _this.translation.text.AC_OVERRIDE_INFO;
        });

        _this.$onChanges = function (changes) {
            if (changes.deviceId) {
                if (!angular.isUndefined(_this.currentDevice)) return;

                _this.currentDevice = changes.deviceId.currentValue;
                _this.device = null;
                _this.settings = null;
                _this.descriptions = null;
                $http.get(HOST + '/api/DigitalDescriptions?customerId=' + _this.accountInfo.customerId + '&deviceId=' + changes.deviceId.currentValue + '&timezone=' + _this.accountInfo.timeZone + '&languageId=' + (_this.langId === 'fr' ? 2 : 1)).then(function (resp) {
                    // this.device = resp.data.device;
                    _this.settings = resp.data.settings;
                    _this.descriptions = resp.data.descriptions;
                    _this.statuses = resp.data.statuses;
                    _this.alarmDelays = resp.data.alarmDelays;
                    _this.alarmRecalls = resp.data.alarmRecalls;
                    _this.acOverrides = resp.data.acOverrides;

                    for (var i = 0; i < resp.data.alarmDelays.length; i++) {
                        _this.delaySelectors[i] = '' + resp.data.alarmDelays[i].delay;
                    }
                }, function (resp) {
                    console.log(resp.data);
                });
            }
        };

        //Log tab access event to NLog
        _this.postUserAction2Nlog(_this.accountInfo.customerId, _this.deviceId).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        //disabling all the elements under readonly group to prevent from tab order
        $timeout(function () {
            $(".data-read-only-digital-descriptions").find("*").prop("disabled", true);
        }, 5000);
    };

    this.isAdmin = function () {
        return _this.accountInfo.userRole === 'Administrator' || _this.accountInfo.userRole === 'SuperAdministrator';
    };

    this.getInputDescription = function (setting) {

        return setting.description + ' (' + _this.translation.text.INPUT + ' #' + setting.channel + ')' || _this.translation.text.DIGITAL + ' ' + _this.translation.text.INPUT + ' #' + setting.channel;
    };

    this.isDescriptionValid = function (idx, field) {
        if (_this.descriptions[idx][_this.langId][field].length === 0) {
            return false;
        }

        return true;
    };

    this.getStateValue = function (field) {
        if (field === 'normal') {
            return 0;
        } else if (field === 'offNormal') {
            return 1;
        } else if (field === 'tamper') {
            return 2;
        }

        throw 'Error: Cannot match state value!';
    };

    this.generateTTSDescription = function (fieldValue) {
        var ttsDesc = fieldValue.replace(/\\|\//g, ' '); // Strip slashes from description
        var ttsParts = ttsDesc.split(' '); // Split the tts string into separate words

        for (var i = 0; i < ttsParts.length; i++) {
            if (ttsParts[i].toUpperCase() === ttsParts[i]) {
                // If the word is in all caps
                ttsParts[i] = ttsParts[i].split('').join(' '); // Add spaces between each letter so it will be read like an acronym
            }
        }

        ttsDesc = ttsParts.join(' '); // Rejoin the tts string from its parts
        return ttsDesc;
    };

    this.storeCurrentDescription = function (idx, field) {
        _this.storedFieldValue = _this.descriptions[idx][_this.langId][field];
    };

    this.saveDescription = function (idx, field) {
        // Only perform a save if the description in question is valid
        if (_this.isDescriptionValid(idx, field)) {
            var fieldValue = _this.descriptions[idx][_this.langId][field];
            if (fieldValue !== _this.storedFieldValue) {
                if (_this.descriptions[idx][_this.langId].entryType === 0 || _this.descriptions[idx][_this.langId].entryType === 1) {
                    var _fullDescriptionValue;

                    var fullDescriptionValues = (_fullDescriptionValue = {
                        entryType: _this.descriptions[idx][_this.langId].entryType
                    }, _defineProperty(_fullDescriptionValue, field, _this.descriptions[idx][_this.langId][field]), _defineProperty(_fullDescriptionValue, 'tts' + field, _this.generateTTSDescription(fieldValue)), _fullDescriptionValue);
                    // Since we have to save all 3 fields as 'custom' when only 1 is changed (the first time) we need to make sure ALL 3 fields are valid, and if they aren't we'll place the defaults in
                    _this.descriptionFields.forEach(function (descField) {
                        if (descField !== field) {
                            if (!_this.isDescriptionValid(idx, descField)) {
                                fullDescriptionValues[descField] = _this.originalDescriptions[idx][_this.langId][descField];
                                fullDescriptionValues['tts' + descField] = _this.originalDescriptions[idx][_this.langId][descField];
                            } else {
                                fullDescriptionValues[descField] = _this.descriptions[idx][_this.langId][descField];
                                fullDescriptionValues['tts' + descField] = _this.descriptions[idx][_this.langId][descField];
                            }
                        }
                    });

                    $http.post(HOST + '/api/DigitalDescriptions?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&deviceModel=' + encodeURIComponent(_this.descriptions[idx].deviceModel) + '&channel=' + (idx + 1) + '&languageId=' + (_this.langId === 'fr' ? 2 : 1), fullDescriptionValues).then(function (resp) {
                        _this.descriptions[idx][_this.langId].entryType = 2;
                        if (resp.data !== 3) {
                            //toaster.pop('error', this.translation.text.RTU_CONFIGURATION, this.translation.text.ERROR_REOPEN_WINDOW);
                        }
                    }, function (resp) {
                        toaster.pop('error', _this.translation.text.RTU_CONFIGURATION, resp.data);
                    });
                } else if (_this.descriptions[idx][_this.langId].entryType === 2) {
                    var simpleDescription = {
                        description: fieldValue,
                        ttsdescription: _this.generateTTSDescription(fieldValue)
                    };

                    $http.put(HOST + '/api/DigitalDescriptions?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&deviceModel=' + encodeURIComponent(_this.descriptions[idx].deviceModel) + '&channel=' + (idx + 1) + '&state=' + _this.getStateValue(field) + '&languageId=' + (_this.langId === 'fr' ? 2 : 1), simpleDescription).then(function (resp) {
                        if (resp.data !== 1) {
                            //toaster.pop('error', this.translation.text.RTU_CONFIGURATION, this.translation.text.ERROR_REOPEN_WINDOW);
                        }
                    }, function (resp) {
                        toaster.pop('error', _this.translation.text.RTU_CONFIGURATION, resp.data);
                    });
                }
            }
        }
    };

    this.disableInput = function (idx) {
        if (_this.statuses[idx] !== null) {
            if (moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
                var globalVarId = _this.statuses[idx].id;
                $http.delete(HOST + '/api/DigitalStatus?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&deviceType=' + encodeURIComponent(_this.deviceTypeId) + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&channel=' + (idx + 1) + '&globalVarId=' + globalVarId + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                    if (resp.data > 0) {
                        _this.statuses[idx] = null;
                    }

                    $http.post(HOST + '/api/DigitalStatus?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&deviceType=' + encodeURIComponent(_this.deviceTypeId) + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&channel=' + (idx + 1) + '&duration=' + _this.statusSelectors[idx] + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                        if (resp.data) {
                            _this.statuses[idx] = resp.data;
                        }
                    });
                });
            }
        } else {
            $http.post(HOST + '/api/DigitalStatus?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&deviceType=' + encodeURIComponent(_this.deviceTypeId) + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&channel=' + (idx + 1) + '&duration=' + _this.statusSelectors[idx] + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
                if (resp.data) {
                    _this.statuses[idx] = resp.data;
                }
            });
        }
    };

    this.enableInput = function (idx) {
        var globalVarId = _this.statuses[idx].id;
        $http.delete(HOST + '/api/DigitalStatus?deviceId=' + _this.deviceId + '&customerId=' + _this.accountInfo.customerId + '&deviceType=' + encodeURIComponent(_this.deviceTypeId) + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&channel=' + (idx + 1) + '&globalVarId=' + globalVarId + '&timezone=' + _this.accountInfo.timeZone).then(function (resp) {
            if (resp.data > 0) {
                _this.statuses[idx] = null;
            }
        });
    };

    this.isInputDisabled = function (idx) {
        if (_this.statuses[idx] !== null) {
            if (_this.statuses[idx].dateTime !== null && moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
                return false;
            }
            return true;
        }

        return false;
    };

    this.getCurrentStatus = function (idx) {
        if (_this.statuses[idx] === null) {
            return _this.translation.text.ENABLED;
        } else if (_this.statuses[idx].dateTime === null) {
            return _this.translation.text.DISABLED + ' ' + _this.translation.text.INDEFINITELY;
        }

        if (moment(_this.statuses[idx].dateTime).valueOf() < _this.currentTime) {
            return _this.translation.text.ENABLED;
        }

        return _this.translation.text.DISABLED_UNTIL + ' ' + datetimeService.formatDateAgentText(_this.statuses[idx].dateTime, 'yyyy-MM-ddTHH:mm:ss', false, _this.accountInfo.preferenceUser.timeFormat);
    };

    this.getAlarmDelayDisplay = function (idx) {
        if (_this.alarmDelays[idx].entryType === 0 || _this.alarmDelays[idx].delay === 0) {
            return _this.translation.text.ENTRY_FACTORY;
        } else if (_this.alarmDelays[idx].entryType === 1) {
            return _this.translation.text.ENTRY_CUSTOMER;
        } else if (_this.alarmDelays[idx].entryType === 2) {
            return _this.translation.text.ENTRY_UNIT;
        }

        return _this.translation.text.ENTRY_UNKNOWN;
    };

    this.getDeviceType = function (deviceId) {
        deviceMenuService.getDeviceMenuList(_this.accountInfo.customerId).then(function (result) {
            var _devices = result.data.devices;

            for (var index = 0; index < _devices.length; ++index) {
                if (_devices[index].deviceId === deviceId) {
                    _this.device.type = _devices[index].model;
                    if (_this.device.type == 20) {
                        //M84/MM+ device
                        _this.descriptionFields.splice(2, 1);
                        if (_devices[index].skuId == 2) _this.disableChannel1 = true; // disable channel 1 from configuring on UI, it is ReadOnly
                    } else if (_this.device.type == 17 || _this.device.type == 18) {
                        // M120/M150 device
                        _this.disableRunningChannel = true; // disable Running state channel from configuring on UI, it is ReadOnly
                    }
                    break;
                }
            }
        }, function (error) {
            console.log("device type error");
        });
    };

    this.saveAlarmDelay = function (idx) {
        var duration = _this.delaySelectors[idx];

        if (parseInt(duration, 10) === 32767) {
            // Delete
            if (_this.alarmDelays[idx].entryType === 2 && _this.alarmDelays[idx].id !== 0) {
                $http.delete(HOST + '/api/DigitalAlarmDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceType=' + encodeURIComponent(_this.deviceTypeId) + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&entryId=' + _this.alarmDelays[idx].id).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            }
        } else {
            if (_this.alarmDelays[idx].entryType === 2 && _this.alarmDelays[idx].id !== 0) {
                // Update
                $http.put(HOST + '/api/DigitalAlarmDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceType=' + encodeURIComponent(_this.deviceTypeId) + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&delay=' + duration + '&entryId=' + _this.alarmDelays[idx].id).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            } else {
                // Insert
                $http.post(HOST + '/api/DigitalAlarmDelay?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceType=' + encodeURIComponent(_this.deviceTypeId) + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&delay=' + duration).then(function (resp) {
                    _this.alarmDelays[idx] = resp.data;
                    _this.delaySelectors[idx] = '' + resp.data.delay;
                });
            }
        }
    };

    this.getAlarmRecallDescription = function (idx) {
        if (_this.alarmRecalls[idx].entryType === 0 || _this.alarmRecalls[idx].delayMins === 0) {
            return _this.translation.text.ENTRY_FACTORY;
        } else if (_this.alarmRecalls[idx].entryType === 1) {
            return _this.translation.text.ENTRY_CUSTOMER;
        } else if (_this.alarmRecalls[idx].entryType === 2) {
            return _this.translation.text.ENTRY_UNIT;
        }

        return _this.translation.text.ENTRY_UNKNOWN;
    };

    this.saveAlarmRecall = function (idx) {
        var delay = _this.reattemptDelaySelectors[idx];
        var retries = _this.reattemptRetrySelectors[idx];

        if (parseInt(delay, 10) === 0 && parseInt(retries, 10) !== 0) {
            retries = 0;
        }

        if (parseInt(delay, 10) > 0 && parseInt(retries, 10) === 0) {
            retries = 1;
        }

        if (parseInt(delay, 10) === 32767) {
            if (_this.alarmRecalls[idx].entryType === 2 && _this.alarmRecalls[idx].id !== 0) {
                // Delete
                $http.delete(HOST + '/api/DigitalAlarmRecall?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceType=' + encodeURIComponent(_this.deviceTypeId) + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&entryId=' + _this.alarmRecalls[idx].id).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            }
        } else {
            if (_this.alarmRecalls[idx].entryType === 2 && _this.alarmRecalls[idx].id !== 0) {
                // Update
                $http.put(HOST + '/api/DigitalAlarmRecall?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceType=' + encodeURIComponent(_this.deviceTypeId) + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&delay=' + delay + '&entryId=' + _this.alarmRecalls[idx].id + '&retries=' + retries).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            } else {
                // Insert
                $http.post(HOST + '/api/DigitalAlarmRecall?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceType=' + encodeURIComponent(_this.deviceTypeId) + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&delay=' + delay + '&retries=' + retries).then(function (resp) {
                    _this.alarmRecalls[idx] = resp.data;
                    _this.reattemptDelaySelectors[idx] = '' + resp.data.delayMins;
                    _this.reattemptRetrySelectors[idx] = '' + resp.data.retryCount;
                });
            }
        }
    };

    this.toggleOverride = function (idx) {
        if (_this.acOverrides[idx].entryType === 2) {
            $http.put(HOST + '/api/DigitalACOverride?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&value=' + _this.acOverrides[idx].value + '&entryId=' + _this.acOverrides[idx].id).then(function (resp) {
                _this.acOverrides[idx] = resp.data;
            });
        } else {
            $http.post(HOST + '/api/DigitalACOverride?customerId=' + _this.accountInfo.customerId + '&deviceId=' + _this.deviceId + '&deviceName=' + encodeURIComponent(_this.deviceName) + '&input=' + (idx + 1) + '&value=' + _this.acOverrides[idx].value).then(function (resp) {
                _this.acOverrides[idx] = resp.data;
            });
        }
    };

    this.postUserAction2Nlog = function (customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Digital Descriptions";

        return $http({
            method: 'POST',
            url: HOST + '/api/DigitalDescriptions',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    this.$onDestroy = function () {
        timeLapseService.unRegisterLocal('DIGITAL_STATUS', null, null, setTimestamp);
    };
}

DigitalDescriptionsController.$inject = ['_', '$', 'HOST', '$http', '$rootScope', '$timeout', '$scope', '$sce', 'authenticationService', 'datetimeService', 'timeLapseService', 'translationService', 'toaster', 'deviceMenuService'];
'use strict';

angular.module('mc.rtu-configuration').component('digitalDescriptions', {
  controller: DigitalDescriptionsController,
  transclude: true,
  templateUrl: 'ui/rtuconfiguration/digitaldescriptions/digital-descriptions-partial.html',
  bindings: {
    windowId: '<',
    mobile: '<',
    classicView: '<',
    deviceId: '<',
    deviceName: '<',
    deviceTypeId: '<'
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PulseFlowTableModel(HOST, $http, $q, $timeout, datetimeService) {
  var PulseFlow = function () {
    function PulseFlow(customerId, deviceId) {
      _classCallCheck(this, PulseFlow);

      this._deviceName = '';
      this._deviceType = 1;
      this._table = [];
      this._settings = [];
      this._loading = false;
      this._customerId = customerId;
      this._deviceId = deviceId;
      this._liveData = false;
      this._startRow = 1;
      this._pageSize = 50;
      this._numberOfReturnedRecords = -1;
      this._numberOfNewRecordsPrevious = -1;
      this._start = '19000101';
      this._end = '19000101';
      this._show15MinInterval = true;
    }

    _createClass(PulseFlow, [{
      key: 'fetchData',
      value: function fetchData(type, startDate, endDate, group) {
        var _this = this;

        this._loading = true;
        this.group = group;

        return $http.get(HOST + '/api/PulseFlowTable?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&startDate=' + startDate + '&endDate=' + endDate + '&group=' + group + '&direction=' + type).then(function (resp) {
          _this._deviceName = resp.data.device.name;
          _this._deviceType = resp.data.device.model;
          _this._show15MinInterval = _this._deviceType == 17 ? false : true; // Hide 15 Minute interval as M120 (17) already reports every 15 min interval 
          _this._loading = false;
          _this._settings = resp.data.settings;

          var intDayWindow = 10;
          var intDay = 86400000;

          var items = resp.data.table;

          if (_this._liveData && _this.group !== '1' && resp.data.table.length > 0) {
            _this._table.shift();
          }

          if (type === 0) {
            _this._table = _this._table.concat(resp.data.table);
          } else if (type === 1) {
            _this._numberOfNewRecordsPrevious = _this._liveData && _this.group !== '1' && resp.data.table.length === 1 ? 0 : resp.data.table.length;
            if (_this._numberOfNewRecordsPrevious === 0 && (_this.group === '6' || _this.group === '7')) {
              if (typeof resp.data.table[0] != 'undefined') {
                resp.data.table[0].valueChannel1 = resp.data.table[0].valueChannel1 + _this._table[0].valueChannel1;
                resp.data.table[0].valueChannel2 = resp.data.table[0].valueChannel2 + _this._table[0].valueChannel2;
                resp.data.table[0].valueChannel3 = resp.data.table[0].valueChannel3 + _this._table[0].valueChannel3;
                resp.data.table[0].valueChannel4 = resp.data.table[0].valueChannel4 + _this._table[0].valueChannel4;
                resp.data.table[0].valueChannel5 = resp.data.table[0].valueChannel5 + _this._table[0].valueChannel5;
                resp.data.table[0].valueChannel6 = resp.data.table[0].valueChannel6 + _this._table[0].valueChannel6;
              }
            } else if (resp.data.table.length > 1 && (_this.group === '6' || _this.group === '7')) {
              resp.data.table.reverse();
              for (var i = resp.data.table.length - 1; i >= 0; i--) {
                var localDateTime = new Date(resp.data.table[i].localDateTime);
                if (_this.group === '7' && localDateTime.getDate() === 1) {
                  break;
                } else if (_this.group === '6' && localDateTime.getHours() === 0) {
                  break;
                }
                resp.data.table[i].valueChannel1 = resp.data.table[i].valueChannel1 + _this._table[0].valueChannel1;
                resp.data.table[i].valueChannel2 = resp.data.table[i].valueChannel2 + _this._table[0].valueChannel2;
                resp.data.table[i].valueChannel3 = resp.data.table[i].valueChannel3 + _this._table[0].valueChannel3;
                resp.data.table[i].valueChannel4 = resp.data.table[i].valueChannel4 + _this._table[0].valueChannel4;
                resp.data.table[i].valueChannel5 = resp.data.table[i].valueChannel5 + _this._table[0].valueChannel5;
                resp.data.table[i].valueChannel6 = resp.data.table[i].valueChannel6 + _this._table[0].valueChannel6;
              }
              resp.data.table.reverse();
            }
            _this._table = resp.data.table.reverse().concat(_this._table);
          }

          if (_this._table.length > 0) {
            // if there are records returned
            _this._table = _this.remove_duplicates(_this._table); //remove duplicate items
            _this._end = datetimeService.toUnixtime(_this._table[_this._table.length - 1].localDateTime.replace(/\D/g, ''));
          }

          return resp;
        });
      }
    }, {
      key: 'remove_duplicates',
      value: function remove_duplicates(arr) {
        var obj = {};
        var ret_arr = [];
        for (var i = 0; i < arr.length; i++) {
          obj[arr[i].localDateTime] = arr[i]; //localDateTime should be unique across the array items
        }
        for (var key in obj) {
          ret_arr.push(obj[key]);
        }
        return ret_arr;
      }
    }, {
      key: 'nextPage',
      value: function nextPage(group) {
        var _this2 = this;

        if (this._loading) {
          return $q(function (resolve, reject) {
            resolve({ data: { settings: _this2.settings } });
          });
        }

        if (this._table.length > 0) {
          var newEnd = datetimeService.toUnixtime(this._table[this._table.length - 1].localDateTime.replace(/\D/g, ''));
          var newStart = group === '4' || group === '7' ? newEnd - 86400000 * 50 : newEnd - 86400000 * 6;
          return this.fetchData(0, newStart, newEnd, group);
        } else {
          var _newStart = group === '4' || group === '7' ? this._end - 86400000 * 50 : this._end - 86400000 * 6;
          this._start = _newStart;
          return this.fetchData(0, _newStart, this._end, group);
        }
      }
    }, {
      key: 'previousPage',
      value: function previousPage(group) {
        var _this3 = this;

        if (this._loading) {
          return $q(function (resolve, reject) {
            resolve({ data: { settings: _this3.settings } });
          });
        }

        var newStart = datetimeService.toUnixtime(this._table[0].localDateTime.replace(/\D/g, ''));
        if ((group === '4' || group === '7') && !this._liveData) {
          newStart = moment(datetimeService.toUnixtime(this._table[0].localDateTime.replace(/\D/g, ''))).add(1, 'days').utc().valueOf();
        }

        var newEnd = group === '4' || group === '7' ? newStart + 86400000 * 50 : newStart + 86400000 * 3;
        return this.fetchData(1, newStart, newEnd, group);
      }
    }, {
      key: 'reset',
      value: function reset(deviceId) {
        if (deviceId) {
          this._settings.length = 0;
          this._deviceId = deviceId;
        }

        this._numberOfNewRecordsPrevious = -1;
        this._table.length = 0;
        this._start = '19000101';
        this._end = '19000101';
      }
    }, {
      key: 'updateDeletedFlag',
      value: function updateDeletedFlag(dataFlowId, channel, time, dataFlowValue) {
        var _this4 = this;

        this._loading = true;

        return $http.put(HOST + '/api/PulseFlowTable?dataFlowId=' + dataFlowId + '&customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&channel=' + channel + '&time=' + time + '&dataFlowValue=' + dataFlowValue).then(function (resp) {
          _this4._loading = false;
          return resp;
        });
      }
    }, {
      key: 'deviceName',
      get: function get() {
        return this._deviceName;
      }
    }, {
      key: 'deviceType',
      get: function get() {
        return this._deviceType;
      }
    }, {
      key: 'show15MinInterval',
      get: function get() {
        return this._show15MinInterval;
      }
    }, {
      key: 'table',
      get: function get() {
        return this._table;
      }
    }, {
      key: 'settings',
      get: function get() {
        return this._settings;
      }
    }, {
      key: 'previousRecords',
      get: function get() {
        return this._numberOfNewRecordsPrevious;
      },
      set: function set(num) {
        this._numberOfNewRecordsPrevious = num;
      }
    }, {
      key: 'loading',
      get: function get() {
        return this._loading;
      }
    }, {
      key: 'deviceId',
      set: function set(deviceId) {
        this._deviceId = deviceId;
      }
    }, {
      key: 'start',
      set: function set(startDate) {
        this._start = startDate;
      },
      get: function get() {
        return this._start;
      }
    }, {
      key: 'end',
      set: function set(endDate) {
        this._end = endDate;
      },
      get: function get() {
        return this._end;
      }
    }, {
      key: 'liveData',
      set: function set(liveData) {
        this._liveData = liveData;
      }
    }]);

    return PulseFlow;
  }();

  return PulseFlow;
}

PulseFlowTableModel.$inject = ['HOST', '$http', '$q', '$timeout', 'datetimeService'];

angular.module('mc.pulseflow').factory('pulseFlowTableModel', PulseFlowTableModel);
'use strict';

function PulseFlowTableController(_, $, $rootScope, $scope, $filter, $timeout, $element, authenticationService, translationService, datetimeService, sharedSetupService, openViewService, timeLapseService, websocketService, PulseFlowTable, $uibModal, $cookies, toaster) {
    var _this2 = this;

    this.downloadViewTypeOptions = [0, 4];
    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    var determineLiveDataByTable = function determineLiveDataByTable() {
        $timeout(function () {
            var $rowFirst = _this2.table.contents().find('tr:first');
            var $rowLast = _this2.table.contents().find('tr:last');
            var _firstRow = $rowFirst.attr('name');
            if (typeof $rowFirst.position() !== 'undefined') {
                _this2.infiniteScrollOn = true;
                _this2.infiniteScrollUpOn = true;
                _this2.infiniteScrollDownOn = true;

                var _tableTop = _this2.table.offset().top;
                var _rowTop = $rowFirst.offset().top;
                _this2._setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);

                _this2.previousScrollbarPosition = _this2.currentScrollbarPosition;
                _this2.currentScrollbarPosition = _this2.table[0].scrollTop;
            }
        });
    };

    var wsDataReceivedPULSE = function wsDataReceivedPULSE(data) {
        $timeout(function () {
            var str = data.Time;
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2));
            if (_this2.selectedGrouping === '1') {
                var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                if (_this2.pulseFlow._table[0].localDateTime !== varTime) {
                    _this2.pulseFlow._table.unshift({
                        localDateTime: varTime,
                        valueChannel1: null,
                        valueChannel2: null,
                        valueChannel3: null,
                        valueChannel4: null,
                        valueChannel5: null,
                        valueChannel6: null,
                        disableDelete: _this2.mcAdmin ? false : true
                    });
                }
            } else if (_this2.selectedGrouping === '2') {
                if (moment.utc(_this2.pulseFlow._table[0].localDateTime).valueOf() !== moment(unixtime).minute(15 * Math.floor(moment(unixtime).startOf('minute').minute() / 15)).startOf('minute').valueOf()) {
                    _this2.pulseFlow._table.unshift({
                        localDateTime: moment.utc(unixtime).minute(15 * Math.floor(moment.utc(unixtime).startOf('minute').minute() / 15)).startOf('minute').format('YYYY-MM-DDTHH:mm:ss'),
                        valueChannel1: null,
                        valueChannel2: null,
                        valueChannel3: null,
                        valueChannel4: null,
                        valueChannel5: null,
                        valueChannel6: null
                    });
                }
            } else if (_this2.selectedGrouping === '3' || _this2.selectedGrouping === '6') {
                if (moment.utc(_this2.pulseFlow._table[0].localDateTime).valueOf() !== moment.utc(unixtime).startOf('hour').valueOf()) {
                    _this2.pulseFlow._table.unshift({
                        localDateTime: moment.utc(unixtime).startOf('hour').format('YYYY-MM-DDTHH:mm:ss'),
                        valueChannel1: null,
                        valueChannel2: null,
                        valueChannel3: null,
                        valueChannel4: null,
                        valueChannel5: null,
                        valueChannel6: null
                    });
                }
            } else if (_this2.selectedGrouping === '4' || _this2.selectedGrouping === '7') {
                if (moment.utc(_this2.pulseFlow._table[0].localDateTime).valueOf() !== moment.utc(unixtime).startOf('day').valueOf()) {
                    _this2.pulseFlow._table.unshift({
                        localDateTime: moment.utc(unixtime).startOf('day').format('YYYY-MM-DDT00:mm:ss'),
                        valueChannel1: null,
                        valueChannel2: null,
                        valueChannel3: null,
                        valueChannel4: null,
                        valueChannel5: null,
                        valueChannel6: null
                    });
                }
            } else if (_this2.selectedGrouping === '5') {
                var varTimeRawCount = datetimeService.socketStrToServerStrTime(data.Time);
                if (_this2.pulseFlow._table[0].localDateTime !== varTimeRawCount) {
                    _this2.pulseFlow._table.unshift({
                        localDateTime: varTimeRawCount,
                        valueChannel1: null,
                        valueChannel2: null,
                        valueChannel3: null,
                        valueChannel4: null,
                        valueChannel5: null,
                        valueChannel6: null,
                        disableDelete: _this2.mcAdmin ? false : true
                    });
                }
            }

            for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
                if (_this2.selectedGrouping == 5) {
                    if (_this2.pulseFlow.settings[i].channel === parseInt(data.CH, 10)) {
                        _this2.pulseFlow._table[0]['valueChannel' + data.CH] += data.RawCount * 1;
                    }
                } else {
                    if (_this2.pulseFlow.settings[i].channel === parseInt(data.CH, 10)) {
                        // this.pulseFlow._table[0][`valueChannel${data.CH}`] += data.RepID * this.pulseFlow.settings[i].flowScale;
                        _this2.pulseFlow._table[0]['valueChannel' + data.CH] += Number(data.ScaledValue);
                    }
                }
            }
            //Add Channel settings to incoming live data
            if (_this2.selectedGrouping === '1' || _this2.selectedGrouping === '5') {
                _this2.pulseFlow._table[0].channelSettings = [];
                for (var _i = 1; _i <= 6; _i++) {
                    _this2.pulseFlow._table[0].channelSettings[_i - 1] = data.CH == _i ? 0 : 2;
                }
            }
        });
        _this2.compareSettingstoTableChannelSettings();
    };

    $scope.$on('processReconnect', function (event, args) {
        $scope.stickyProperties.liveData = _this2.liveData;
        $scope.reconnectData(event, args);
    });

    $scope.reconnectData = function (event, args) {
        sharedSetupService.processReconnect({
            stickyProperties: $scope.stickyProperties,
            localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
            dateRangeOption: null,
            windowTitle: $scope.windowTitle,
            fnUnregister: this._unRegisterListener,
            fnGetData: _openTableInLiveMode,
            viewType: "Table"
        });
    };

    //$scope.mostRecentData = function (event, args) {
    //    $scope.stickyProperties.liveData = true;
    //    this.myDate = null;
    //    $scope.reconnectData(event, args);
    //}

    var _openTableInLiveMode = function _openTableInLiveMode(localDateTime) {
        var tmpDateTime = new Date(localDateTime);
        this.myDate = tmpDateTime;
    };

    this._registerListener = function (deviceSn) {
        if (_this2.liveData === true) {
            return;
        }

        _this2.liveData = true;
        if (_this2.pulseFlow) {
            _this2.pulseFlow.liveData = _this2.liveData;
        }

        _this2.liveDataLine(_this2.liveData);
        _this2.pulseFlow.previousRecords = -1;
        websocketService.connect();
        for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
            websocketService.register('PULSE', deviceSn || $scope.deviceSelectedSn, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
            websocketService.register('DIGITALASPULSE', deviceSn || $scope.deviceSelectedSn, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
        }
    };

    this._unRegisterListener = function (deviceSn) {
        if (_this2.liveData === false) {
            return;
        }

        _this2.liveData = false;
        if (_this2.pulseFlow) {
            _this2.pulseFlow.liveData = _this2.liveData;
        }

        _this2.liveDataLine(_this2.liveData);
        for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
            websocketService.unRegister('PULSE', deviceSn || $scope.deviceSelectedSn, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
            websocketService.unRegister('DIGITALASPULSE', deviceSn || $scope.deviceSelectedSn, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
        }
    };

    this._checkTopOffset = function (liveDataStatusOn) {
        if (liveDataStatusOn) {
            _this2._registerListener();
        } else {
            _this2._unRegisterListener();
        }
    };

    this._setLiveDataStatus = function (firstRow, liveDataStatusOn) {
        if (_this2.checkFirstRowLiveStatus === true) {
            _this2._checkTopOffset(liveDataStatusOn);
        } else if (_this2.checkFirstRowLiveStatus === null) {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                if (parseFloat(firstRow) + parseFloat(_this2.liveDataOffset) >= parseFloat(result.unixTimeStamp)) {
                    _this2.checkFirstRowLiveStatus = true;
                    _this2._checkTopOffset(liveDataStatusOn);
                } else {
                    _this2.checkFirstRowLiveStatus = false;
                }
            });
        }
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        _this2.switchDevice = false;
        _this2.myDate = null;
        _this2.infiniteScrollOn = false;
        _this2.infiniteScrollUpOn = false;
        _this2.infiniteScrollDownOn = false;
        _this2.checkFirstRowLiveStatus = null;
        _this2.liveTable = $element.find('.headertable');
        _this2.selectedGrouping = '1';
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.mcAdmin = sharedSetupService.mcAdmin();
        _this2.preferredTimeFormat = _this2.accountInfo.preferenceUser.timeFormat;
        _this2.unixDay = sharedSetupService.unixDay;
        _this2.liveDataOffset = sharedSetupService.liveDataOffset;
        _this2.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
        _this2.translation = translationService.translation;
        _this2.alerts = [];
        _this2.currentScrollbarPosition = 0;
        _this2.previousScrollbarPosition = 0;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
        _this2.checkFirstRowLiveStatus = null;
        _this2.paddingZoom = _this2.paddingZoom === 0 ? _this2.unixDay / 2 : _this2.paddingZoom;
        $scope.alerts = [];
        $scope.windowTitle = _this2.translation.text.PULSE_FLOW_TABLE;
        _this2.windowId = _this2.windowId || 'PULSE FLOW TABLE';
        $scope.windowId = JSON.parse(JSON.stringify(_this2.windowId));
        _this2.paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
        _this2.paddingZoom = _this2.paddingZoom === 0 ? _this2.unixDay / 2 : _this2.paddingZoom;

        if (!_this2.mobile && !_this2.classicView) {
            _this2._popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize(_this2._popup);

            var adjustSize = function adjustSize() {
                _this2._popup.parent().find('div:eq(2)').css('width', _this2._popup.parent().css('width'));
                _this2._popup.parent().find('div:eq(2)').css('min-width', _this2._popup.parent().css('width').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('div:eq(2)').css('height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('div:eq(2)').css('min-height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('.tabular-data-container').css('height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('.headertable').css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('.top-menu').css('height').replace(/[^0-9.]+/g, "") - 15);
            };

            _this2._popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            _this2._popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(_this2._popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(_this2._popup);
                    adjustSize();
                }
            });

            $scope.$on('ngRepeatFinished', function () {
                adjustSize();
            });

            $scope.$on('updatePreferencesLanguage', function () {
                adjustSize();

                if ($scope.alerts.length > 0) {
                    var msg = _this2.translation.message[$scope.alerts[0].languageCode.toUpperCase()];
                    var type = $scope.alerts[0].type;
                    var languageCode = $scope.alerts[0].languageCode;
                    if (languageCode.toUpperCase() === 'NO_DATA') {
                        msg += ': ' + moment(_this2.pulseFlow.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.pulseFlow.end).utc().format('MM/DD/YY, h:mm:ss a');
                    }
                    $scope.alerts = [];
                    _this2.alerts = [];
                    $scope.alerts.push({ msg: msg, type: type, languageCode: languageCode });
                    _this2.alerts.push({ msg: msg, type: type, languageCode: languageCode });
                }
            });
        }

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            _this2.preferredTimeFormat = parseInt(timeFormat, 10);
        });

        $scope.$on('ngRepeatFinished', function () {
            _this2._autoScroll();
            _this2.checkFirstRowLiveStatus = null;
        });

        _this2._autoScroll = function () {
            if (_this2.pulseFlow.previousRecords > 0) {
                var trRow = _this2.table.find('tr').eq(_this2.pulseFlow.previousRecords - 1);
                var yPosition = typeof trRow.position() !== 'undefined' ? trRow.position().top - 90 : 2;
                _this2.table.scrollTop(yPosition);
            } else {
                var _this = _this2;
                $timeout(function () {
                    _this.table.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        // dateAgentText filter called from html
        _this2.dateAgentText = function (date, timeFormat) {
            return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
        };

        $timeout(function () {
            _this2.table = $('#pulse-flow-table-' + _this2.replaceSpaces(_this2.windowId || 'PULSE FLOW TABLE'));
            // Handle infinite scrolling
            _this2.table.on('scroll', function (event) {
                var $rowFirst = _this2.table.contents().find('tr:first');
                var $rowLast = _this2.table.contents().find('tr:last');
                var _firstRow = $rowFirst.attr('name');
                if (typeof $rowFirst.position() !== 'undefined') {
                    _this2.infiniteScrollOn = true;
                    _this2.infiniteScrollUpOn = true;
                    _this2.infiniteScrollDownOn = true;

                    var _tableTop = _this2.table.offset().top;
                    var _rowTop = $rowFirst.offset().top;
                    _this2._setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);

                    _this2.previousScrollbarPosition = _this2.currentScrollbarPosition;
                    _this2.currentScrollbarPosition = _this2.table[0].scrollTop;
                }

                if (_this2.infiniteScrollOn === true) {
                    _this2.infiniteScrollUpOn = true;
                    _this2.infiniteScrollDownOn = true;

                    if (_this2.currentScrollbarPosition <= 35 && _this2.previousScrollbarPosition > 35) {
                        _this2.checkFirstRowLiveStatus = null;
                    }

                    if (_this2.infiniteScrollDownOn === true && _this2.table[0].scrollTop + _this2.table[0].offsetHeight + 5 > _this2.table[0].scrollHeight) {
                        if (_this2.switchDevice) {
                            _this2.switchDevice = false;
                            return;
                        }
                        $rowLast.addClass('active-row');
                        _this2.alerts = [];
                        $scope.alerts = [];
                        _this2.pulseFlow.nextPage(_this2.selectedGrouping, _this2.liveData).then(function (resp) {
                            if (resp.data.settings.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                $scope.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                                _this2.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                            } else if ((!resp.data.table || resp.data.table.length === 0) && _this2.pulseFlow.table.length === 0 && !_this2.pulseFlow.loading) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.pulseFlow.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.pulseFlow.end).utc().format('MM/DD/YY, h:mm:ss a');

                                $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            }
                            _this2.compareSettingstoTableChannelSettings();
                        });
                    }
                    if (_this2.infiniteScrollUpOn === true && _this2.table[0].scrollTop < 5 && _this2.currentScrollbarPosition < _this2.previousScrollbarPosition) {
                        $rowFirst.addClass('active-row');
                        _this2.alerts = [];
                        $scope.alerts = [];
                        $timeout(function () {
                            // Give it time to set the live data status
                            _this2.pulseFlow.previousPage(_this2.selectedGrouping, _this2.liveData).then(function (resp) {
                                if (resp.data.settings.length === 0) {
                                    $scope.alerts.length = 0;
                                    _this2.alerts.length = 0;

                                    $scope.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                                    _this2.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                                }
                                _this2.compareSettingstoTableChannelSettings();
                            });
                        });
                    }
                }

                var rows = _this2.table.children().children().children().children();
                var scrollpos = 40;
                var start = 0;
                var end = rows.length;
                var count = 0;

                while (start !== end) {
                    count++;
                    var mid = start + Math.floor((end - start) / 2);
                    if ($(rows[mid]).position().top < scrollpos) {
                        start = mid + 1;
                    } else {
                        end = mid;
                    }
                }
                _this2._updateZoom(parseFloat($($(rows[start])).attr('name')));
            });
        });

        // Toggle the active row when user clicks
        _this2.toggle = function ($event) {
            if ($($event.currentTarget).hasClass('active-row')) {
                $($event.currentTarget).removeClass('active-row');
            } else {
                $($event.currentTarget).addClass('active-row');
            }
        };

        $scope.$watch(function () {
            return $scope.deviceSelectedSn;
        }, function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                if (oldVal) {
                    _this2._unRegisterListener(oldVal);
                }
            }
        }, true);

        $scope.$on('rtuPulseUpdate', function (event, args) {
            var _dataChanged = "channelName, unit, flowScale";
            if (_this2.pulseFlow && args.deviceId == $scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
                _this2.groupingChange();
            }
        });

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal) {
                _this2.switchDevice = true;
                sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newVal, windowId: _this2.windowId });
                if (_this2.pulseFlow) {
                    _this2.pulseFlow.reset(newVal);
                } else {
                    _this2.pulseFlow = new PulseFlowTable(_this2.accountInfo.customerId, newVal);
                }

                _this2.currentScrollbarPosition = 0;
                _this2.previousScrollbarPosition = 0;
                _this2.checkFirstRowLiveStatus = null;
                $scope.alerts = [];
                _this2.alerts = [];

                if ($scope.stickyProperties.savedDesktop === true && $scope.stickyProperties.on === true) {
                    _this2.savedDesktopRow = $scope.stickyProperties.zoomMax;
                    $scope.stickyProperties.on = true;
                    $scope.stickyProperties.savedDesktop = false;
                    _this2.pulseFlow.start = $scope.stickyProperties.dateMin;
                    _this2.pulseFlow.end = $scope.stickyProperties.dateMax;
                    _this2.pulseFlow.nextPage(_this2.selectedGrouping, _this2.liveData).then(function (resp) {
                        if (resp.data.settings.length === 0) {
                            $scope.alerts.length = 0;
                            _this2.alerts.length = 0;

                            $scope.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                            _this2.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                        } else if ((!resp.data.table || resp.data.table.length === 0) && _this2.pulseFlow.table.length === 0) {
                            $scope.alerts.length = 0;
                            _this2.alerts.length = 0;

                            var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.pulseFlow.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.pulseFlow.end).utc().format('MM/DD/YY, h:mm:ss a');

                            $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                        } else {
                            determineLiveDataByTable();
                        }
                        _this2.compareSettingstoTableChannelSettings();
                    });
                } else if ($scope.stickyProperties.on !== null && $scope.stickyProperties.dateMin !== null) {
                    // doesn't work well - need to check
                    $scope.stickyProperties.on = true;
                    _this2.pulseFlow.start = $scope.stickyProperties.dateMin - 3 * _this2.unixDay;
                    timeLapseService.getLocalDateTime().then(function (resp) {
                        var result = resp.data;
                        var newDate = new Date(result.localDateTime);
                        newDate.setHours(0, 0, 0, 0);
                        var endDate = new Date(newDate.getTime() + 3 * 86400000);
                        if (datetimeService.dateToUnixtime(endDate) < $scope.stickyProperties.dateMax) {
                            _this2.pulseFlow.end = datetimeService.dateToUnixtime(endDate);
                        } else if ($scope.stickyProperties.dateMax >= parseFloat(result.unixTimeStamp) && $scope.stickyProperties.zoomMax + parseFloat(_this2.liveDataOffset) >= parseFloat(result.unixTimeStamp)) {
                            _this2.pulseFlow.end = $scope.stickyProperties.dateMax;
                        } else {
                            _this2.pulseFlow.end = Math.round(($scope.stickyProperties.zoomMax + $scope.stickyProperties.zoomMin) / 2);
                        }

                        _this2.pulseFlow.nextPage(_this2.selectedGrouping, _this2.liveData).then(function (resp) {
                            if (resp.data.settings.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                $scope.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                                _this2.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                            } else if ((!resp.data.table || resp.data.table.length === 0) && _this2.pulseFlow.table.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.pulseFlow.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.pulseFlow.end).utc().format('MM/DD/YY, h:mm:ss a');

                                $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            } else {
                                determineLiveDataByTable();
                            }
                            _this2.compareSettingstoTableChannelSettings();
                        });
                    });
                } else {
                    $scope.stickyProperties.on = false;
                    timeLapseService.getLocalDateTime().then(function (resp) {
                        var result = resp.data;

                        var newDate = new Date(result.localDateTime);
                        newDate.setHours(0, 0, 0, 0);
                        var endDate = new Date(newDate.getTime() + 3 * 86400000);
                        _this2.pulseFlow.end = datetimeService.dateToUnixtime(endDate);
                        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: datetimeService.dateToUnixtime(endDate), windowId: _this2.windowId });
                        _this2.pulseFlow.nextPage(_this2.selectedGrouping, _this2.liveData).then(function (resp) {
                            if (resp.data.settings.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                $scope.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                                _this2.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                            } else if ((!resp.data.table || resp.data.table.length === 0) && _this2.pulseFlow.table.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.pulseFlow.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.pulseFlow.end).utc().format('MM/DD/YY, h:mm:ss a');

                                $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            } else {
                                determineLiveDataByTable();
                            }
                            _this2.compareSettingstoTableChannelSettings();
                        });
                    });
                }
            }
        }, true);

        _this2.compareSettingstoTableChannelSettings = function () {
            //loop through all table data
            _this2.pulseFlow._table.map(function (table) {
                //loop through all channel settings in each row
                table.channelSettings.map(function (channelSetting, index) {
                    var channelValid = 0;
                    //is Channel showing actual data (this is true when value is 0)
                    if (channelSetting == 0) {
                        // loop through all settings
                        _this2.pulseFlow._settings.map(function (setting) {
                            //check if settings includes channel
                            setting.channel == index + 1 ? channelValid++ : null;
                        });
                        //check if settings does not includes channel set value to 2 (indicates null)
                        if (channelValid == 0) {
                            channelSetting = 2;
                        }
                    }
                });
            });
        };

        $scope.$watch(function () {
            return _this2.myDate;
        }, function (newVal, oldVal) {
            if (newVal) {
                _this2.pulseFlow.reset();
                _this2.currentScrollbarPosition = 0;
                _this2.previousScrollbarPosition = 0;
                _this2.checkFirstRowLiveStatus = null;
                _this2._unRegisterListener();

                var tmpDates = newVal;
                var tmpDatesA = tmpDates;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                if (_this2.selectedGrouping === '4' || _this2.selectedGrouping === '7') {
                    tmpDatesA.setHours(23, 59, 59, 999);
                } else {
                    tmpDatesA.setHours(12, 0, 0, 0);
                }
                tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);

                _this2.pulseFlow.start = tmpDates.startDate;
                if (new Date(newVal).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                    _this2.pulseFlow.end = tmpDatesA;
                } else {
                    _this2.pulseFlow.end = tmpDates.endDate;
                }

                $scope.alerts = [];
                _this2.alerts = [];
                _this2.pulseFlow.nextPage(_this2.selectedGrouping, _this2.liveData).then(function (resp) {
                    if (resp.data.settings.length === 0) {
                        $scope.alerts.length = 0;
                        _this2.alerts.length = 0;

                        $scope.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                        _this2.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                    } else if ((!resp.data.table || resp.data.table.length === 0) && _this2.pulseFlow.table.length === 0) {
                        $scope.alerts.length = 0;
                        _this2.alerts.length = 0;

                        var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.pulseFlow.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.pulseFlow.end).utc().format('MM/DD/YY, h:mm:ss a');

                        $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                        _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                    } else {
                        determineLiveDataByTable();
                    }
                    _this2.compareSettingstoTableChannelSettings();
                });
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + _this2.unixDay, zoomMax: tmpDates.endDate - _this2.unixDay, windowId: _this2.windowId });
            }
        });
    };

    this.getDecimalPoints = function (idx) {
        var setting = _this2.pulseFlow.settings[idx];

        if (setting && setting.flowScale < 1) {
            return 2;
        } else if (setting && setting.flowScale < 12) {
            return 1;
        }

        return 0;
    };

    this.hasChannel = function (channel) {
        if (_.findIndex(_this2.pulseFlow.settings, function (setting) {
            return setting.channel === channel;
        }) > -1) {
            return true;
        }

        return false;
    };

    this.liveDataLine = function (varLiveData) {
        if (varLiveData) {
            _this2.liveTable.addClass('live-data-line');
        } else {
            _this2.liveTable.removeClass('live-data-line');
        }
    };

    this._updateZoom = function (currentRow) {
        if (isNaN(currentRow)) {
            return;
        }

        var zoomMin = currentRow - _this2.paddingZoom;
        var zoomMax = currentRow + _this2.paddingZoom;

        var dateMin = $scope.stickyProperties.dateMin;
        var dateMax = $scope.stickyProperties.dateMax;

        if (zoomMin < $scope.stickyProperties.dateMin) {
            dateMin = zoomMin;
        }
        if (zoomMax > $scope.stickyProperties.dateMax) {
            dateMax = zoomMax;
        }

        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: _this2.windowId });
    };

    this.groupingChange = function () {
        if (_this2.pulseFlow.table.length > 0) {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                var zoom = -1;
                var end = -1;
                if ($scope.stickyProperties.dateMax >= parseFloat(result.unixTimeStamp) && $scope.stickyProperties.zoomMax + parseFloat(_this2.liveDataOffset) >= parseFloat(result.unixTimeStamp)) {
                    zoom = $scope.stickyProperties.dateMax;
                } else {
                    zoom = Math.round(($scope.stickyProperties.zoomMax + $scope.stickyProperties.zoomMin) / 2);
                }

                if (_this2.selectedGrouping === '1') {
                    end = zoom;
                    _this2.liveDataOffset = 1000 * 60 * 60 * 6;
                } else if (_this2.selectedGrouping === '2') {
                    end = moment(zoom).minute(15 * Math.round(moment(zoom).startOf('minute').minute() / 15)).startOf('minute').valueOf();
                    _this2.liveDataOffset = 1000 * 60 * 60 * 6;
                } else if (_this2.selectedGrouping === '3' || _this2.selectedGrouping === '6') {
                    end = moment(zoom).add(1, 'hour').startOf('hour').valueOf();
                    _this2.liveDataOffset = 1000 * 60 * 60 * 10;
                } else if (_this2.selectedGrouping === '4' || _this2.selectedGrouping === '7') {
                    end = moment(zoom).utc().startOf('day').valueOf();
                    _this2.liveDataOffset = _this2.unixDay;
                } else if (_this2.selectedGrouping === '5') {
                    end = zoom;
                    _this2.liveDataOffset = 1000 * 60 * 60 * 6;
                }

                _this2.pulseFlow.reset();
                _this2.currentScrollbarPosition = 0;
                _this2.previousScrollbarPosition = 0;
                _this2.checkFirstRowLiveStatus = null;
                _this2.pulseFlow.end = end;
                _this2.pulseFlow.nextPage(_this2.selectedGrouping, _this2.liveData).then(function (resp) {
                    if (resp.data.settings.length === 0) {
                        $scope.alerts.length = 0;
                        _this2.alerts.length = 0;

                        $scope.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                        _this2.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                    } else if ((!resp.data.table || resp.data.table.length === 0) && _this2.pulseFlow.table.length === 0) {
                        $scope.alerts.length = 0;
                        _this2.alerts.length = 0;

                        var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.pulseFlow.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.pulseFlow.end).utc().format('MM/DD/YY, h:mm:ss a');

                        $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                        _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                    }
                    _this2.compareSettingstoTableChannelSettings();
                });
            });
        }
    };

    this.setDeleteFlag = function (row, channel) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = this.translation.text.REMOVE_DATA_FLOW;
            this.ok = function () {
                $uibModalInstance.close(row, channel);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var deletedChannelValue = channel == 1 ? row.valueChannel1 : channel == 2 ? row.valueChannel2 : channel == 3 ? row.valueChannel3 : channel == 4 ? row.valueChannel4 : channel == 5 ? row.valueChannel5 : row.valueChannel6;
            var deletedChannelDate = moment(row.localDateTime).format('MM/DD/YYYY h:mm:ss a');
            _this2.pulseFlow.updateDeletedFlag(row.channelIDs[channel - 1], channel, deletedChannelDate, deletedChannelValue).then(function () {
                //Update UI
                row.channelSettings[channel - 1] = 1;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.REMOVE_DATA_FLOW_ERROR, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };
}

PulseFlowTableController.$inject = ['_', '$', '$rootScope', '$scope', '$filter', '$timeout', '$element', 'authenticationService', 'translationService', 'datetimeService', 'sharedSetupService', 'openViewService', 'timeLapseService', 'websocketService', 'pulseFlowTableModel', '$uibModal', '$cookies', 'toaster'];

angular.module('mc.pulseflow').component('pulseFlowTable', {
    controller: PulseFlowTableController,
    transclude: true,
    templateUrl: 'ui/pulseflow/table/pulseflow-table-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        deviceSelected: '<'
    }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PulseFlowChartModel(HOST, $http) {
  var PulseFlow = function () {
    function PulseFlow(customerId, deviceId) {
      _classCallCheck(this, PulseFlow);

      this._points = [];
      this._settings = [];
      this._loading = false;
      this._customerId = customerId;
      this._deviceId = deviceId;
      this._deviceName = '';
    }

    _createClass(PulseFlow, [{
      key: 'fetchData',
      value: function fetchData(startDate, endDate, group) {
        var _this = this;

        this._loading = true;
        return $http.get(HOST + '/api/PulseFlowChart?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&startDate=' + startDate + '&endDate=' + endDate + '&group=' + group).then(function (resp) {
          _this._deviceName = resp.data.device.name;
          _this._loading = false;
          return resp;
        });
      }
    }, {
      key: 'deviceName',
      get: function get() {
        return this._deviceName;
      }
    }, {
      key: 'points',
      get: function get() {
        return JSON.parse(JSON.stringify(this._points));
      }
    }, {
      key: 'settings',
      get: function get() {
        return this._settings;
      }
    }, {
      key: 'loading',
      get: function get() {
        return this._loading;
      }
    }, {
      key: 'deviceId',
      set: function set(deviceId) {
        this._deviceId = deviceId;
      }
    }]);

    return PulseFlow;
  }();

  return PulseFlow;
}

PulseFlowChartModel.$inject = ['HOST', '$http'];

angular.module('mc.pulseflow').factory('pulseFlowChartModel', PulseFlowChartModel);
"use strict";

function PulseFlowChartController(_, $, $rootScope, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, timeLapseService, websocketService, openViewService, sharedSetupService, PulseFlow, rangeSelectorService, SaveDesktopSettingService) {
    var _this2 = this;

    this.downloadViewTypeOptions = [0, 1];
    this.chartTypes = ["line", "column"];
    this.chartTypeSelected = 1;
    var wsDataReceivedPULSE = function wsDataReceivedPULSE(data) {
        if (_this2.liveData === false) {
            unregisterListener();
            return;
        }

        var extremes = _this2.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;
        var setting = _.findIndex(_this2.flowSettings, function (obj) {
            return parseInt(obj.channel, 10) === parseInt(data.CH, 10);
        });

        var str = data.Time + '';
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        //const varValue = parseFloat(data.RepID) * this.flowSettings[setting].flowScale;
        var varValue = parseFloat(data.ScaledValue);
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, _this2.accountInfo.timeZone);

        for (var i = 0; i < _this2.chart.series.length; i++) {
            if (_this2.chart.series[i] && parseInt(_this2.chart.series[i].options.id, 10) === parseInt(data.CH, 10)) {
                var series = _this2.chart.get(data.CH).series[0];
                for (var j = 1; j <= 3; j++) {
                    if (!angular.isUndefined(series.data[series.data.length - j]) && typeof series.data[series.data.length - j].marker !== 'undefined' && series.data[series.data.length - j].marker !== null) {
                        series.data[series.data.length - j].remove();
                    }
                }

                if (_this2.selectedGrouping === '1') {
                    (function () {
                        series.addPoint([unixtime, varValue]);
                        series.addPoint([unixtime, varValue]);
                        var tmpObj = series.data[series.data.length - 1];
                        tmpObj.update({
                            marker: {
                                enabled: true,
                                fillColor: '#d4eacf',
                                lineWidth: 4,
                                lineColor: '#299610', // inherit from series
                                radius: 6
                            },
                            color: '#659355'
                        }, $timeout(function () {
                            if (tmpObj.series !== null) {
                                tmpObj.update({
                                    marker: {
                                        enabled: false
                                    }
                                });
                            }
                        }, 2000));
                    })();
                } else if (_this2.selectedGrouping === '2') {
                    if (moment(series.data[series.data.length - 1].x).valueOf() === moment(unixtime).minute(15 * Math.floor(moment(unixtime).startOf('minute').minute() / 15)).startOf('minute').valueOf()) {
                        series.data[series.data.length - 1].update(series.data[series.data.length - 1].y += varValue);
                    } else {
                        (function () {
                            unixtime = moment(unixtime).minute(15 * Math.floor(moment(unixtime).startOf('minute').minute() / 15)).startOf('minute').valueOf();
                            series.addPoint([unixtime, varValue]);
                            series.addPoint([unixtime, varValue]);
                            var tmpObj = series.data[series.data.length - 1];
                            tmpObj.update({
                                marker: {
                                    enabled: true,
                                    fillColor: '#d4eacf',
                                    lineWidth: 4,
                                    lineColor: '#299610', // inherit from series
                                    radius: 6
                                },
                                color: '#659355'
                            }, $timeout(function () {
                                if (tmpObj.series !== null) {
                                    tmpObj.update({
                                        marker: {
                                            enabled: false
                                        }
                                    });
                                }
                            }, 2000));

                            // When we add a new grouped point, move the line immediately
                            timeLapseService.getLocalDateTime().then(function (resp) {
                                var result = resp.data;
                                var data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                                tlDataReceivedPULSE(data);
                            });
                        })();
                    }
                } else if (_this2.selectedGrouping === '3') {
                    if (moment(series.data[series.data.length - 1].x).valueOf() === moment(unixtime).startOf('hour').valueOf()) {
                        series.data[series.data.length - 1].update(series.data[series.data.length - 1].y += varValue);
                    } else {
                        (function () {
                            unixtime = moment(unixtime).startOf('hour').valueOf();
                            series.addPoint([unixtime, varValue]);
                            series.addPoint([unixtime, varValue]);
                            var tmpObj = series.data[series.data.length - 1];
                            tmpObj.update({
                                marker: {
                                    enabled: true,
                                    fillColor: '#d4eacf',
                                    lineWidth: 4,
                                    lineColor: '#299610', // inherit from series
                                    radius: 6
                                },
                                color: '#659355'
                            }, $timeout(function () {
                                if (tmpObj.series !== null) {
                                    tmpObj.update({
                                        marker: {
                                            enabled: false
                                        }
                                    });
                                }
                            }, 2000));
                            // When we add a new grouped point, move the line immediately
                            timeLapseService.getLocalDateTime().then(function (resp) {
                                var result = resp.data;
                                var data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                                tlDataReceivedPULSE(data);
                            });
                        })();
                    }
                } else if (_this2.selectedGrouping === '4') {
                    if (moment.utc(series.data[series.data.length - 1].x).valueOf() === moment.utc(unixtime).startOf('day').valueOf()) {
                        series.data[series.data.length - 1].update(series.data[series.data.length - 1].y += varValue);
                    } else {
                        (function () {
                            unixtime = moment.utc(unixtime).startOf('day').valueOf();
                            series.addPoint([unixtime, varValue]);
                            series.addPoint([unixtime, varValue]);
                            var tmpObj = series.data[series.data.length - 1];
                            tmpObj.update({
                                marker: {
                                    enabled: true,
                                    fillColor: '#d4eacf',
                                    lineWidth: 4,
                                    lineColor: '#299610', // inherit from series
                                    radius: 6
                                },
                                color: '#659355'
                            }, $timeout(function () {
                                if (tmpObj.series !== null) {
                                    tmpObj.update({
                                        marker: {
                                            enabled: false
                                        }
                                    });
                                }
                            }, 2000));

                            // When we add a new grouped point, move the line immediately
                            timeLapseService.getLocalDateTime().then(function (resp) {
                                var result = resp.data;
                                var data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                                tlDataReceivedPULSE(data);
                            });
                        })();
                    }
                }
            }
        }

        //if ((extremes.max + this.liveDataOffset > extremes.dataMax) && parseInt(data.CH, 10) === 1) {
        //  this.chart.xAxis[0].setExtremes(unixtime - tmpRange + this.minPadding, unixtime + this.maxPadding);
        //}
    };

    $scope.$on('processReconnect', function (event, args) {
        $scope.stickyProperties.liveData = this.liveData;
        $scope.reconnectData(event, args);
    });

    $scope.reconnectData = function (event, args) {
        sharedSetupService.processReconnect({
            stickyProperties: $scope.stickyProperties,
            localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
            dateRangeOption: 0,
            windowTitle: $scope.windowTitle,
            fnUnregister: unregisterListener,
            fnGetData: _getData,
            viewType: "Chart",
            dataType: "Pulse"
        });
    };

    //$scope.mostRecentData = function (event, args) {
    //    $scope.stickyProperties.mostRecentData = true;
    //    $scope.stickyProperties.liveData = true;
    //    $scope.myDate = null;
    //    $scope.reconnectData(event, args);
    //};

    var wsReconnectPULSE = function wsReconnectPULSE(data) {
        if (_this2.liveData === false) {
            unregisterListener();
            return;
        }
        //toaster.pop('success', scope.windowTitle + " -- " + scope.devicename, 'View reloading');

        timeLapseService.getLocalDateTime().then(function (resp) {
            var result = resp.data;

            var tmpDates = new Date(result.localDateTime);
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            var tmpStartDate = tmpDates.startDate;
            var tmpEndDate = tmpDates.endDate;
            _getData(tmpStartDate, tmpEndDate, true);
        });
    };

    var tlDataReceivedPULSE = function tlDataReceivedPULSE(data) {
        data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, _this2.accountInfo.timeZone);
        if (_this2.liveData === false) {
            unregisterListener();
            return;
        }

        var extremes = _this2.chart.xAxis[0].getExtremes();
        var tmpRange = _this2.selectedGrouping === '4' ? _this2.unixDay : extremes.max - extremes.min;

        if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < (_this2.selectedGrouping === '4' ? data.Unix - _this2.unixDay : data.Unix - _this2.unixDay / 2)) {
            unregisterListener($scope.deviceSelectedSn);
            return;
        }

        var liveDataLine = _this2.chart.xAxis[0].plotLinesAndBands;
        if (_this2.selectedGrouping === '1') {
            liveDataLine[0].options.value = data.Unix + _this2.maxPadding;
            _this2.chart.xAxis[0].setExtremes(data.Unix - tmpRange + _this2.minPadding, data.Unix + _this2.maxPadding);
        } else if (_this2.selectedGrouping === '2') {
            liveDataLine[0].options.value = moment(data.Unix).minute(15 * Math.floor(moment(data.Unix).startOf('minute').minute() / 15)).startOf('minute').valueOf() + 60 * 1000;
            _this2.chart.xAxis[0].setExtremes(data.Unix - tmpRange + _this2.minPadding, moment(data.Unix).minute(15 * Math.floor(moment(data.Unix).startOf('minute').minute() / 15)).startOf('minute').valueOf() + 60 * 1000 + _this2.maxPadding);
        } else if (_this2.selectedGrouping === '3') {
            liveDataLine[0].options.value = moment(data.Unix).startOf('hour').valueOf() + 60 * 1000;
            _this2.chart.xAxis[0].setExtremes(data.Unix - tmpRange + _this2.minPadding, moment(data.Unix).startOf('hour').valueOf() + 60 * 1000 + _this2.maxPadding);
        } else if (_this2.selectedGrouping === '4') {
            liveDataLine[0].options.value = moment.utc(data.Unix).startOf('day').valueOf();
            //this.chart.xAxis[0].setExtremes(data.Unix - extremes.max - extremes.min + this.minPadding, moment.utc(data.Unix).startOf('day').valueOf() + this.maxPadding);
        }

        //if (extremes.max + this.liveDataOffset > extremes.dataMax) {
        //  this.chart.xAxis[0].setExtremes(data.Unix - tmpRange + this.minPadding, data.Unix  + this.maxPadding);
        //}
    };

    var registerListener = function registerListener(deviceSn) {
        websocketService.connect();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: true, windowId: _this2.windowId });

        timeLapseService.register('PULSE', deviceSn || $scope.deviceSelectedSn, _this2.chart.series[0].options.id, tlDataReceivedPULSE);
        for (var i = 0; i < _this2.flowSettings.length; i++) {
            websocketService.register('PULSE', deviceSn || $scope.deviceSelectedSn, _this2.flowSettings[i].channel, wsDataReceivedPULSE, null);
            websocketService.register('DIGITALASPULSE', deviceSn || $scope.deviceSelectedSn, _this2.flowSettings[i].channel, wsDataReceivedPULSE, null);
        }

        _this2.liveData = true;
    };

    var unregisterListener = function unregisterListener(deviceSn) {
        _this2.liveData = false;
        _this2.lastUpdateAt = undefined;

        if (_this2.chart) {
            timeLapseService.unRegister('PULSE', deviceSn || $scope.deviceSelectedSn, _this2.chart.series[0].options.id, tlDataReceivedPULSE);
        }
        for (var i = 0; i < _this2.flowSettings.length; i++) {
            websocketService.unRegister('PULSE', deviceSn || $scope.deviceSelectedSn, _this2.flowSettings[i].channel, wsDataReceivedPULSE, null);
            websocketService.unRegister('DIGITALASPULSE', deviceSn || $scope.deviceSelectedSn, _this2.flowSettings[i].channel, wsDataReceivedPULSE, null);
        }
    };

    $scope.zoomAdjust = function (varDay) {
        setExtremesFromZoom(varDay);
    };

    var setExtremesFromZoom = function setExtremesFromZoom(varDay) {
        var extremes = _this2.chart.xAxis[0].getExtremes();
        var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, $scope.heartbeatLocalDateTime);
        _this2.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
        setLiveDataStatus();
    };
    var setLiveDataStatus = function setLiveDataStatus(varEndDate) {
        _this2.liveDataEndDate = varEndDate ? varEndDate : _this2.liveDataEndDate;
        if (_this2.selectedGrouping === '4') {
            _this2.liveDataEndDate += _this2.unixDay;
        }

        timeLapseService.getLocalDateTime().then(function (resp) {
            var result = resp.data;
            var extremes = _this2.chart.xAxis[0].getExtremes();
            $scope.heartbeatLocalDateTime = result.unixTimeStamp;
            if (_this2.liveDataEndDate > result.unixTimeStamp && $scope.stickyProperties.zoomMax + _this2.liveDataOffset >= extremes.dataMax) {
                registerListener($scope.deviceSelectedSn);
                var data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedPULSE(data);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: _this2.windowId });
                unregisterListener($scope.deviceSelectedSn);
            }
        });
    };

    var _downsampleSeries = function _downsampleSeries(varMin, varMax) {
        _this2.zoomLevelCurrent = varMax - varMin;
        if (_this2.zoomLevelCurrent <= _this2.unixDay && _this2.zoomLevelPrevious > _this2.unixDay) {
            for (var i = 0; i < _this2.chart.series.length - 1; i++) {
                _this2.chart.series[i].update({ downsample: { threshold: 0 } }, false);
                _this2.chart.series[i].setData(_this2.series[i].data, false);
            }
            _this2.chart.redraw();
        } else if (_this2.zoomLevelCurrent > _this2.unixDay && _this2.zoomLevelPrevious <= _this2.unixDay) {
            for (var _i = 0; _i < _this2.chart.series.length - 1; _i++) {
                _this2.chart.series[_i].update({ downsample: { threshold: 1000 } }, false);
            }
            _this2.chart.redraw();
        }
        _this2.zoomLevelPrevious = _this2.zoomLevelCurrent;
    };

    var _drawChart = function _drawChart(resetView) {
        _this2.chartDrawn = false;
        var chartBase = $("#pulse-flow-chart-" + _this2.replaceSpaces(_this2.windowId));
        var tmpData = _this2.series;
        var chartXaxisHourFormat = _this2.preferredTimeFormat === _this2.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
        var chartToolTipHourFormat = _this2.preferredTimeFormat === _this2.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';
        var midPadding = 0;
        var maxPadding = 0;
        var self = _this2;
        var numberOfSeries = 0;
        var numberOfHiddenSeries = 0;

        for (var k = 0; k < self.series.length; k++) {
            self.series[k].type = _this2.chartTypes[_this2.chartTypeSelected];
        }

        self.chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: true,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1
            },
            time: {
                getTimezoneOffset: function getTimezoneOffset(timestamp) {
                    return -moment.tz(timestamp, datetimeService.getTimeZoneId(self.accountInfo.timeZone)).utcOffset();
                }
            },
            chart: {
                renderTo: chartBase[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#d3d3d3',
                borderWidth: $scope.mobile ? 0 : 1,
                borderRadius: 2,
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 0,
                marginTop: 10,
                marginRight: 10,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                spacingRight: 5,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {
                        var _this3 = this;

                        var pulseFlowData = [];
                        var extremes = this.xAxis[0].getExtremes();

                        var tmpDates = null;
                        var i = -1;

                        if (this.xAxis && self.chartDrawn === true && self.scrollingInProgress === false) {
                            if (extremes && extremes.dataMin >= extremes.min - self.liveDataOffset) {
                                self.scrollingInProgress = true;

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -11);

                                self.pulseFlow.fetchData(tmpDates.startDate, tmpDates.endDate, parseInt(self.selectedGrouping, 10)).then(function (resp) {
                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            pulseFlowData.push(resp.data.series[i].data);
                                        }
                                    }

                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            tmpData[i].data = pulseFlowData[i].concat(tmpData[i].data);
                                            self.chart.series[i].setData(tmpData[i].data);
                                        }
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, windowId: self.windowId });
                                    self.chart.xAxis[0].setExtremes(extremes.min + self.minPadding, extremes.max + self.maxPadding);
                                    setLiveDataStatus();

                                    $timeout(function () {
                                        self.scrollingInProgress = false;
                                    }, 1000);

                                    self.chart.hideLoading();
                                }, function (resp) {
                                    $scope.alerts = [];
                                    self.alerts = [];
                                    chartBase.empty();
                                    _this3.chart = null;
                                    var errormsg = self.translation.message.GENERAL_SERVER_ERROR;
                                    $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                    self.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                });
                            } else if (self.liveData === false && extremes && extremes.max + self.liveDataOffset >= extremes.dataMax) {
                                self.scrollingInProgress = true;

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 11);
                                var startDt = new Date(datetimeService.UtcToLocalByTimeZone(tmpDates.startDate, self.accountInfo.timeZone));
                                var endDt = new Date(datetimeService.UtcToLocalByTimeZone(tmpDates.endDate, self.accountInfo.timeZone));

                                if (self.selectedGrouping === '4') {
                                    tmpDates.endDate += self.unixDay;
                                }

                                self.pulseFlow.fetchData(startDt.getTime(), endDt.getTime(), parseInt(self.selectedGrouping, 10)).then(function (resp) {
                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            pulseFlowData.push(resp.data.series[i].data);
                                        }
                                    }

                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            if (self.selectedGrouping !== '1' && pulseFlowData[i].length > 0) {
                                                tmpData[i].data.pop();
                                            }

                                            tmpData[i].data = tmpData[i].data.concat(pulseFlowData[i]);
                                            self.chart.series[i].setData(tmpData[i].data);
                                        }
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: tmpDates.endDate, windowId: self.windowId });
                                    self.chart.xAxis[0].setExtremes(extremes.min + self.minPadding, extremes.max + self.maxPadding);
                                    setLiveDataStatus(tmpDates.endDate);

                                    $timeout(function () {
                                        self.scrollingInProgress = false;
                                    }, 1000);

                                    self.chart.hideLoading();
                                }, function (resp) {
                                    $scope.alerts = [];
                                    self.alerts = [];
                                    chartBase.empty();
                                    _this3.chart = null;
                                    var errormsg = self.translation.message.GENERAL_SERVER_ERROR;
                                    $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                    self.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                });
                            }
                        }
                    },
                    load: function load(event) {
                        if (self.initialLoad) openViewService.adjustContentSize(self._popup);
                        // will remove after changing Mc.Services
                        for (var i = 0; i < self.series.length - 1; i++) {
                            if (self.accountInfo.customerId === 13041 && $scope.deviceSelected === 29138 && i === 0) {
                                this.yAxis[i].update({
                                    startOnTick: false,
                                    endOnTick: false,
                                    allowDecimals: true,
                                    labels: {
                                        format: '{value:.1f}'
                                    }
                                });
                            } else {
                                this.yAxis[i].update({
                                    allowDecimals: false,
                                    labels: {
                                        format: '{value:.0f}'
                                    }
                                });
                            }
                        }
                        self.initialLoad = false;
                        $timeout(function () {
                            $scope.saveDesktopSettingService.applySavedDesktopSetting(self.chart, $scope, true);
                        }, 0);
                    },
                    selection: function selection(event) {
                        if (!event.xAxis) {
                            var button = this.exportSVGElements[0];
                            var button2 = this.exportSVGElements[2];
                            button.attr({
                                x: -5
                            });
                            button2.attr({
                                x: -100
                            });
                            adjustScale(this);
                        }
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                }
            },
            xAxis: {
                title: {
                    text: self.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 3,
                    color: 'green',
                    dashStyle: 'solid',
                    zIndex: 1
                }],
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minorTickInterval: 'auto',
                minorGridLineColor: '#ebebeb',
                dateTimeLabelFormats: {
                    hour: chartXaxisHourFormat
                },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (self.chartDrawn === true) {
                            var _extremes = self.chart.xAxis[0].getExtremes();
                            if (self.liveData === true && (e.trigger === 'navigator' || e.trigger === 'pan' || typeof e.trigger === 'undefined')) {
                                if (_extremes.max + self.liveDataOffset <= _extremes.dataMax) {
                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: self.windowId });
                                    unregisterListener($scope.deviceSelectedSn);
                                }
                            }
                            sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: _extremes.min, zoomMax: _extremes.max, windowId: self.windowId });
                            _downsampleSeries(_extremes.min, _extremes.max);
                        }
                    }
                }
            },
            yAxis: self.yAxis,
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var d = new Date(this.x);
                    var s = '';
                    s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    if (self.selectedGrouping === '1') {
                        s += "<tr><td colspan=\"2\" style=\"color: #000000; padding-bottom: 3px;\">" + Highcharts.dateFormat("%A, %b %e, %Y " + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, self.accountInfo.timeZone)) + "</td></tr>";
                    } else if (self.selectedGrouping === '2') {
                        s += "<tr><td colspan=\"2\" style=\"color: #000000; padding-bottom: 3px;\">" + Highcharts.dateFormat("%A, %b %e, %Y " + chartToolTipHourFormat.replace('%p', ''), datetimeService.utcToLocalTimeStampByTimeZone(this.x, self.accountInfo.timeZone)) + " - " + Highcharts.dateFormat("" + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, self.accountInfo.timeZone) + 15 * 60 * 1000) + "</td></tr>";
                    } else if (self.selectedGrouping === '3') {
                        s += "<tr><td colspan=\"2\" style=\"color: #000000; padding-bottom: 3px;\">" + Highcharts.dateFormat("%A, %b %e, %Y " + chartToolTipHourFormat.replace('%p', ''), datetimeService.utcToLocalTimeStampByTimeZone(this.x, self.accountInfo.timeZone)) + " - " + Highcharts.dateFormat("" + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, self.accountInfo.timeZone) + 60 * 60 * 1000) + "</td></tr>";
                    } else if (self.selectedGrouping === '4') {
                        s += "<tr><td colspan=\"2\" style=\"color: #000000; padding-bottom: 3px;\">" + Highcharts.dateFormat('%A, %b %e, %Y', datetimeService.utcToLocalTimeStampByTimeZone(this.x, self.accountInfo.timeZone)) + "</td></tr>";
                    }

                    $.each(this.points, function (i, point) {
                        var numDecimals = 0;
                        if (self.flowSettings[i].flowScale < 1) {
                            numDecimals = 2;
                        } else if (self.flowSettings[i].flowScale < 12) {
                            numDecimals = 1;
                        }
                        s += "<tr><td style=\"color: " + point.series.color + ";\">" + point.series.name + ": </td><td style=\"text-align: right; color: #000000; font-weight: bold;\">" + $filter('number')(point.y, numDecimals) + "</td></tr>";
                        self.xValue = point.x;
                    });
                    s += '</table>';
                    return s;
                },

                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 0,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
            },
            plotOptions: {
                series: {
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                self.xValue = this.x;
                            }
                        }
                    },
                    marker: {
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    events: {
                        legendItemClick: function legendItemClick() {
                            numberOfSeries = self.chart.series.length - 1;
                            var visibility = this.visible ? 'visible' : 'hidden';
                            numberOfHiddenSeries = visibility === 'hidden' ? numberOfHiddenSeries - 1 : numberOfHiddenSeries + 1;
                            numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                            if (numberOfHiddenSeries < numberOfSeries) {
                                self.chart.yAxis[this.index].update({
                                    labels: {
                                        enabled: visibility !== 'visible'
                                    },
                                    title: {
                                        enabled: this.visible ? false : true
                                    },
                                    lineWidth: visibility === 'visible' ? 0 : 2
                                });

                                $scope.saveDesktopSettingService.setSerieVisibilitySetting(this.options.id, this.visible ? false : true, $scope);
                                return true;
                            }
                            numberOfHiddenSeries = numberOfHiddenSeries - 1;
                            return false;
                        },
                        mouseOut: function mouseOut() {
                            self.xValue = null;
                        }
                    }
                }
            },
            series: self.series
        });

        var tmpNewDateA = void 0;
        var tmpNewDateB = void 0;
        var extremes = self.chart.xAxis[0].getExtremes();

        if ($scope.stickyProperties.on === true) {
            tmpNewDateA = $scope.stickyProperties.zoomMin >= extremes.dataMin ? $scope.stickyProperties.zoomMin : extremes.dataMin;
            tmpNewDateB = $scope.stickyProperties.zoomMax <= extremes.dataMax + _this2.liveDataOffset ? $scope.stickyProperties.zoomMax : extremes.dataMax;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + _this2.unixDay / 24 ? tmpNewDateB : extremes.dataMax - _this2.unixDay / 24 * 12;
            $scope.stickyProperties.on = false;
        } else {
            tmpNewDateA = _this2.myDate !== null ? extremes.dataMin + _this2.unixDay : extremes.dataMax - _this2.unixDay / 24 * 6;
            tmpNewDateB = _this2.myDate !== null ? tmpNewDateA + _this2.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - _this2.unixDay;
            }
            tmpNewDateA = tmpNewDateA + _this2.minPadding;
            tmpNewDateB = tmpNewDateB + _this2.maxPadding;
        }

        _this2.chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        if (_this2.series !== null) {
            // only for analog chart if no setup
            sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: _this2.windowId });
        } else {
            _this2.chart.showLoading('Pulse Flow Setup not available!');
        }

        if (!resetView) {
            setLiveDataStatus();
        } else {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var data = { Unix: resp.data.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedPULSE(data);
            });
        }

        self.chartDrawn = true;
    };

    var _getData = function _getData(startDate, endDate, resetView) {
        _this2.liveDataEndDate = endDate;
        _this2.pulseFlow.fetchData(startDate, endDate, parseInt(_this2.selectedGrouping, 10)).then(function (resp) {
            var chartBase = $("#pulse-flow-chart-" + _this2.replaceSpaces(_this2.windowId));
            _this2.flowSettings = resp.data.setting;
            // this.deviceSelectedSN = resp.data.device.serialNumber;
            _this2.yAxis = resp.data.yAxis;
            _this2.series = resp.data.series;
            $scope.alerts = [];
            _this2.alerts = [];
            _this2.deviceModel = resp.data.device.deviceModel;
            _this2.show15MinInterval = _this2.deviceModel == 17 ? false : true; // Hide 15 Minute interval as M120 (17) already reports every 15 min interval 
            if (resp.data.series && resp.data.series.length > 0 && resp.data.series[0].data.length >= 1) {
                _this2.devicename = resp.data.device.name;
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate, windowId: _this2.windowId });
                _drawChart(resetView);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate, windowId: _this2.windowId });
                chartBase.empty();
                _this2.chart = null;
                _this2.lastStart = startDate;
                _this2.lastEnd = endDate;
                var errormsg = _this2.translation.message.NO_DATA + ': ' + moment(startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(endDate).utc().format('MM/DD/YY, h:mm:ss a');
                var langCode = 'NO_DATA';
                if (resp.data.setting.length == 0) {
                    errormsg = _this2.translation.text.NO_PULSE_FLOW_SETTINGS;
                    langCode = 'NO_PULSE_FLOW_SETTINGS';
                }
                $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: langCode });
                _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: langCode });
            }
        }, function (resp) {
            $scope.alerts = [];
            _this2.alerts = [];
            chartBase.empty();
            _this2.chart = null;
            var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
            $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
            _this2.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
        });
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        _this2.chart = null;
        _this2.myDate = null;
        _this2.scrollingInProgress = false;
        _this2.initialLoad = true;
        _this2.zoomLevelCurrent = 0;
        _this2.zoomLevelPrevious = 0;
        _this2.xValue = null;
        _this2.liveData = false;
        _this2.selectedDeviceSN = null;
        _this2.chartDrawn = false;
        _this2.minPadding = 0;
        _this2.maxPadding = 0;
        _this2.selectedGrouping = '1';
        _this2.afterSetExtremesTimer = null;
        _this2.windowId = _this2.windowId || 'Pulse Flow Chart';
        _this2.alerts = [];
        $scope.alerts = [];
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        $scope.windowTitle = _this2.translation.text.PULSE_FLOW_CHART;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.TimeFormatEnum = { Civilian: 1, Military: 2 };
        _this2.preferredTimeFormat = _this2.accountInfo.preferenceUser.timeFormat;
        _this2.unixDay = sharedSetupService.unixDay;
        _this2.unixHour = 3600000;
        _this2.liveDataOffset = 20 * 60 * 1000;
        _this2.mouseWheelZoom = sharedSetupService.mouseWheelZoom;

        if (!_this2.mobile && !_this2.classicView) {
            $scope.windowId = _this2.windowId;
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;

            $timeout(function () {
                var chartBase = $("#pulse-flow-chart-" + _this2.replaceSpaces(_this2.windowId));

                chartBase.on('mousewheel', function (event) {
                    if (!_this2.scrollingInProgress) {
                        if (_this2.selectedGrouping === '4') {
                            var scrollingSpeed = 4;
                            _this2.mouseWheelZoom(event, _this2.chart, _this2.xValue, scrollingSpeed);
                        } else {
                            _this2.mouseWheelZoom(event, _this2.chart, _this2.xValue);
                        }
                    }
                });
            });
        }

        $scope.$on('updatePreferencesLanguage', function (event, language) {
            openViewService.adjustContentSize(_this2._popup);
            if ($scope.alerts.length > 0) {
                var _msg = _this2.translation.text[$scope.alerts[0].languageCode.toUpperCase()];
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;

                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ": " + moment(_this2.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(_this2.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                }

                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }

            if ($scope.alerts.length === 0) {
                _drawChart();
            }
        });

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            _this2.preferredTimeFormat = parseInt(timeFormat, 10);
            if ($scope.alerts.length === 0) {
                _drawChart();
            }
        });

        $scope.selectMyDate = function (date) {
            $scope.myDate = date;
        };

        $scope.$watch(function () {
            return $scope.myDate;
        }, function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                var _chartBase = $("#pulse-flow-chart-" + _this2.replaceSpaces(_this2.windowId));
                var tmpDates = newVal;
                tmpDates.setHours(0, 0, 0, 0);
                _this2.myDate = tmpDates;
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = tmpDates + _this2.accountInfo.timeZoneOffset * 60 * 1000;
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);

                _this2.pulseFlow.fetchData(tmpDates.startDate, tmpDates.endDate, parseInt(_this2.selectedGrouping, 10)).then(function (resp) {
                    _this2.series = resp.data.series;
                    $scope.alerts = [];
                    _this2.alerts = [];
                    if (resp.data.series && resp.data.series.length > 0 && resp.data.series[0].data.length >= 1) {
                        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, windowId: _this2.windowId });
                        _drawChart();
                    } else {
                        _this2.lastStart = tmpDates.startDate;
                        _this2.lastEnd = tmpDates.endDate;
                        var langCode = 'NO_DATA';
                        var errormsg = _this2.translation.message.NO_DATA + ': ' + moment(tmpDates.startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(tmpDates.endDate).utc().format('MM/DD/YY, h:mm:ss a');
                        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + _this2.unixDay, zoomMax: tmpDates.endDate - _this2.unixDay, windowId: _this2.windowId });
                        _chartBase.empty();
                        _this2.chart = null;
                        if (resp.data.setting.length == 0) {
                            errormsg = _this2.translation.text.NO_PULSE_FLOW_SETTINGS;
                            langCode = 'NO_PULSE_FLOW_SETTINGS';
                        }
                        $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: langCode });
                        _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: langCode });
                    }
                }, function (resp) {
                    var errormsg = _this2.translation.message.GENERAL_SERVER_ERROR;
                    $scope.alerts = [];
                    _this2.alerts = [];
                    _chartBase.empty();
                    _this2.chart = null;
                    $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                    _this2.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                });
            }
        });

        $scope.$watch(function () {
            return $scope.deviceSelectedSn;
        }, function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                if (oldVal) {
                    unregisterListener(oldVal);
                }
            }
        }, true);

        $scope.$on('rtuPulseUpdate', function (event, args) {
            var _dataChanged = "channelName, unit, flowScale";
            if (_this2.pulseFlow && args.deviceId == $scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
                _this2.groupingChange();
            }
        });

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal) {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newVal, windowId: _this2.windowId });

                if (_this2.pulseFlow) {
                    _this2.pulseFlow.deviceId = newVal;
                } else {
                    _this2.pulseFlow = new PulseFlow(_this2.accountInfo.customerId, newVal);
                }

                var tmpDates = null;
                var tmpStartDate = null;
                var tmpEndDate = null;

                $scope.saveDesktopSettingService = new SaveDesktopSettingService(newVal, _this2.windowId);

                if ($scope.stickyProperties.setting && $scope.stickyProperties.setting.savedDesktop) {
                    $scope.savedDesktopSetting = $scope.stickyProperties.setting;
                } else {
                    $scope.savedDesktopSetting = $scope.saveDesktopSettingService.getObject();
                }

                if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
                    $scope.stickyProperties.on = true;

                    timeLapseService.getLocalDateTime().then(function (resp) {
                        var result = resp.data;
                        var newDate = new Date(result.localDateTime);
                        newDate.setHours(0, 0, 0, 0);
                        var endDate = new Date(newDate.getTime() + 3 * 86400000);
                        if (datetimeService.dateToUnixtime(endDate) < $scope.stickyProperties.dateMax) {
                            tmpEndDate = datetimeService.dateToUnixtime(new Date(newDate.getTime() + 2 * 86400000));
                            var startDate = new Date(newDate.getTime() - 1 * 86400000);
                            tmpStartDate = datetimeService.dateToUnixtime(startDate);
                        } else {
                            tmpStartDate = $scope.stickyProperties.dateMin;
                            tmpEndDate = $scope.stickyProperties.dateMax;
                        }
                        if (!tmpStartDate) {
                            timeLapseService.getLocalDateTime().then(function (resp) {
                                var result = resp.data;

                                tmpDates = new Date(result.localDateTime);
                                tmpDates.setHours(0, 0, 0, 0);
                                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                                tmpStartDate = tmpDates.startDate;
                                tmpEndDate = tmpDates.endDate;
                                _getData(tmpStartDate, tmpEndDate);
                            });
                        } else {
                            _getData(tmpStartDate, tmpEndDate);
                        }
                    });
                } else {
                    $scope.stickyProperties.on = false;
                }

                // if (!tmpStartDate) {
                //     timeLapseService.getLocalDateTime().then((resp) => {
                //         const result = resp.data;

                //         tmpDates = new Date(result.localDateTime);
                //         tmpDates.setHours(0, 0, 0, 0);
                //         tmpDates = datetimeService.dateToUnixtime(tmpDates);
                //         tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                //         tmpStartDate = tmpDates.startDate;
                //         tmpEndDate = tmpDates.endDate;
                //         _getData(tmpStartDate, tmpEndDate);
                //     });
                // } else {
                // _getData(tmpStartDate, tmpEndDate);
                // }
            }
        }, true);
    };

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    this.getDecimalPoints = function () {
        var setting = _.find(_this2.pulseFlow.settings, function (obj) {
            return "" + obj.channel === _this2.selectedSetting;
        });

        if (setting && setting.flowScale < 1) {
            return 2;
        } else if (setting && setting.flowScale < 12) {
            return 1;
        }

        return 0;
    };

    this.chartTypeChange = function (index) {
        _this2.chartTypeSelected = index;
        for (var k = 0; k < _this2.chart.series.length; k++) {
            if (_this2.chart.series[k].type != "areaspline") {
                _this2.chart.series[k].update({ type: _this2.chartTypes[index] });
            }
        }
        _this2.chart.redraw();
    };
    this.groupingChange = function () {
        //const startPoint = this.series[0].data[0][0] || this.series[0].data[0].x;
        //const endPoint = this.series[0].data[this.series[0].data.length - 1][0] || this.series[0].data[this.series[0].data.length - 1].x;

        //const newStart = moment.utc(startPoint).startOf('day').valueOf();
        //const newEnd = moment.utc(endPoint).add(1, 'days').startOf('day').valueOf();

        var tmpDates = null;
        var tmpStartDate = null;
        var tmpEndDate = null;

        if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
            $scope.stickyProperties.on = true;
            tmpStartDate = $scope.stickyProperties.dateMin;
            tmpEndDate = $scope.stickyProperties.dateMax;
        } else {
            $scope.stickyProperties.on = false;
        }

        if (!tmpStartDate) {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                tmpDates = new Date(result.localDateTime);
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                tmpStartDate = tmpDates.startDate;
                tmpEndDate = tmpDates.endDate;
                _getData(tmpStartDate, tmpEndDate);
            });
        } else {
            _getData(tmpStartDate, tmpEndDate);
        }
        $scope.selectedGrouping = _this2.selectedGrouping;
        //const group = parseInt(this.selectedGrouping, 10);
        //if (group === 1) {
        //    this.liveDataOffset = 20 * 60 * 1000;
        //} else if (group === 2) {
        //    this.liveDataOffset = 12 * 15 * 60 * 1000;
        //} else if (group === 3) {
        //    this.liveDataOffset = 8 * 60 * 60 * 1000;
        //} else if (group === 4) {
        //    this.liveDataOffset = 24 * 60 * 60 * 1000;
        //}
        //_getData(newStart, newEnd, true);
    };

    this.$onDestroy = function () {
        if (_this2.chart) {
            unregisterListener($scope.deviceSelectedSn);
        }
        if (!angular.isUndefined($scope.stickyProperties.setting)) $scope.stickyProperties.setting = null;
    };
}

PulseFlowChartController.$inject = ['_', '$', '$rootScope', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'timeLapseService', 'websocketService', 'openViewService', 'sharedSetupService', 'pulseFlowChartModel', 'rangeSelectorService', 'SaveDesktopSettingService'];

angular.module('mc.pulseflow').component('pulseFlowChart', {
    controller: PulseFlowChartController,
    transclude: true,
    templateUrl: 'ui/pulseflow/chart/pulseflow-chart-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        myDate: '<'
    }
});
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PulseFlowGaugeModel(_, HOST, $http, $timeout, $sce) {
    var PulseFlow = function () {
        function PulseFlow(customerId, deviceId) {
            _classCallCheck(this, PulseFlow);

            this._device = {};
            this._channels = {};
            this._settings = [];
            this._latestStates = [];
            this._loading = false;
            this._customerId = customerId;
            this._deviceId = deviceId;
            this._timeouts = [];
        }

        _createClass(PulseFlow, [{
            key: "trustAsHtml",
            value: function trustAsHtml(a) {
                return $sce.trustAsHtml(a);
            }
        }, {
            key: "getSumFormatted",
            value: function getSumFormatted(value) {
                return value.replace(",", "<mc-pulse-span>,</mc-pulse-span>");
            }
        }, {
            key: "addPoint",
            value: function addPoint(channel, point, isRawCount, group) {
                var idx = _.findIndex(this._channels, function (obj) {
                    return obj.channel === channel;
                });
                if (isRawCount && group == 6) {
                    var previousPoint = this._channels[idx].values.length > 0 ? this._channels[idx].values[0].scaledValue : null;
                    this._channels[idx].values[0].scaledValue = previousPoint + point.scaledValue;
                    this._channels[idx].values[0].localTime = point.localTime;
                } else if (isRawCount) {
                    this._channels[idx].values[0] = point;
                } else {
                    this._channels[idx].values.unshift(point);
                }

                // If there were none, but now there's one
                //if (this._channels[idx].values.length === 1) {
                //    this.createTimeout(idx, this._settings[idx].selectedGroup);
                //}
            }
        }, {
            key: "cleanupOldChannelValues",
            value: function cleanupOldChannelValues(heartbeatMsg) {
                for (var i = 0; i < this._settings.length; i++) {
                    //logic to remove older values from the list based on time range/group (15, 60... minutes etc)
                    if (this._channels[i].values.length > 0) {
                        //compare the oldest point's local time against the heartbeat's local time (both wall-clock);
                        //using the difference of two new Date() values cancels the browser offset so the window math
                        //is timezone-safe. (utcUnixTimeStamp is on a different scale than new Date(LocalDateTime).)
                        var lastDate = new Date(this._channels[i].values[this._channels[i].values.length - 1].localTime).getTime();

                        var intervalEnd = new Date(heartbeatMsg.LocalDateTime).getTime() - 15 * 60 * 1000;
                        switch (this._settings[i].selectedGroup) {
                            case '2':
                                intervalEnd = new Date(heartbeatMsg.LocalDateTime).getTime() - 60 * 60 * 1000;
                                break;
                            case '3':
                                intervalEnd = new Date(heartbeatMsg.LocalDateTime).getTime() - 6 * 60 * 60 * 1000;
                                break;
                            case '4':
                                intervalEnd = new Date(heartbeatMsg.LocalDateTime).getTime() - 24 * 60 * 60 * 1000;
                                break;
                            case '5':
                                intervalEnd = new Date(heartbeatMsg.LocalDateTime).setHours(0, 0, 0, 0);
                                break;
                        }
                        //var momenttz = "America/New_York";
                        //var lastDateTime = moment(lastDate).tz(momenttz).format('YYYY-MM-DD hh:mm:ss');
                        //console.log("lastDate-Time: " + lastDateTime);
                        //var intervalEndTime = moment(intervalEnd).tz(momenttz).format('YYYY-MM-DD hh:mm:ss');
                        //console.log("intervalEnd-Time: " + intervalEndTime); 

                        if (lastDate < intervalEnd && this._settings[i].selectedGroup != '6') {
                            this._channels[i].values.pop();
                        }

                        this.createTimeout(i, this._settings[i].selectedGroup);
                    }

                    //calculate total for given channel                
                    this._channels[i].sum = this.sumPoints(this._settings[i]);
                }
            }
        }, {
            key: "fetchData",
            value: function fetchData(group) {
                var _this = this;

                var isRTUView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                this._loading = true;
                return $http.get(HOST + "/api/PulseFlowGauge?customerId=" + this._customerId + "&deviceId=" + this._deviceId + "&startdate=null&enddate=null&group=1&isRTUView=" + isRTUView).then(function (resp) {
                    _this._channels = resp.data.data;
                    _this._device = resp.data.device;
                    _this._settings = resp.data.settings;
                    _this._latestStates = resp.data.latestStates;
                    _this._currentTime = resp.data.currentTime; // represents server time, which will be used for all kind of validation/calculations.
                    _this._loading = false;

                    for (var i = 0; i < _this._settings.length; i++) {
                        _this._settings[i].selectedGroup = '1';
                    }

                    for (var _i = 0; _i < _this._channels.length; _i++) {
                        //const offset = 15 * 60 * 1000;
                        var intervalEnd = _this._currentTime.unixTimeStamp - 15 * 60 * 1000;
                        if (group === '2') {
                            intervalEnd = _this._currentTime.unixTimeStamp - 60 * 60 * 1000;
                        } else if (group === '3') {
                            intervalEnd = _this._currentTime.unixTimeStamp - 6 * 60 * 60 * 1000;
                        } else if (group === '4') {
                            intervalEnd = _this._currentTime.unixTimeStamp - 24 * 60 * 60 * 1000;
                        } else if (group === '5') {
                            intervalEnd = new Date(_this._currentTime.unixTimeStamp).setHours(0, 0, 0, 0);
                        }

                        //logic to remove older values from the list based on time range/group (15, 60... minutes etc)
                        if (_this._channels[_i].values.length > 0) {
                            var lastDate = _this._channels[_i].values[_this._channels[_i].values.length - 1].utcUnixTimeStamp;
                            if (lastDate < intervalEnd) {
                                _this._channels[_i].values.pop();
                            }

                            _this.createTimeout(_i, '1');
                        }

                        //calculate total for given channel
                        _this._channels[_i].sum = _this.sumPoints(_this._settings[_i]);
                    }

                    return resp;
                });
            }
        }, {
            key: "groupingChange",
            value: function groupingChange(setting) {
                var _this2 = this;

                this.tempSetting = setting;
                return $http.get(HOST + "/api/PulseFlowWidget?customerId=" + this._customerId + "&deviceId=" + this._deviceId + "&channel=" + setting.channel + "&startdate=null&enddate=null&group=" + setting.selectedGroup).then(function (resp) {
                    var idx = _.findIndex(_this2._channels, function (obj) {
                        return obj.channel === _this2.tempSetting.channel;
                    });
                    _this2._currentTime = resp.data.currentTime;

                    $timeout.cancel(_this2._timeouts[idx]);
                    _this2._channels[idx].values = resp.data.data.values; //updating channel values with latest data

                    //this.cleanupOldChannelValues(resp.data.currentTime);
                    if (_this2._channels[idx].values.length > 0) {
                        _this2.createTimeout(idx, _this2.tempSetting.selectedGroup);
                    } else {
                        _this2._channels[idx].sum = 0;
                    }
                });
            }
        }, {
            key: "groupImmediately",
            value: function groupImmediately(idx, group) {
                if (this._channels[idx].values.length > 0) {
                    //calculate total for given channel
                    this._channels[idx].sum = this.sumPoints(this._settings[idx]);
                }
            }
        }, {
            key: "createTimeout",
            value: function createTimeout(idx, group) {
                var _this3 = this;

                if (angular.isUndefined(this._channels[idx].values[this._channels[idx].values.length - 1])) return;
                //cancel any previously scheduled eviction for this channel so timeouts don't accumulate on every heartbeat
                $timeout.cancel(this._timeouts[idx]);
                var lastDate = this._channels[idx].values[this._channels[idx].values.length - 1].utcUnixTimeStamp;

                var intervalEnd = this._currentTime.unixTimeStamp - 15 * 60 * 1000; // group = 1

                if (group === '2') {
                    intervalEnd = this._currentTime.unixTimeStamp - 60 * 60 * 1000;
                } else if (group === '3') {
                    intervalEnd = this._currentTime.unixTimeStamp - 6 * 60 * 60 * 1000;
                } else if (group === '4') {
                    intervalEnd = this._currentTime.unixTimeStamp - 24 * 60 * 60 * 1000;
                } else if (group === '5') {
                    lastDate = new Date(this._currentTime.utcUnixTimeStamp).setHours(0, 0, 0, 0) + 86400000;
                    intervalEnd = this._currentTime.utcUnixTimeStamp;
                }

                this.groupImmediately(idx, group);
                var delay = Math.max(0, lastDate - intervalEnd);
                this._timeouts[idx] = $timeout(function () {
                    //evict the oldest point (tail); values are newest-first so pop(), not shift()
                    if (Number(group) < 6) _this3._channels[idx].values.pop();
                    if (_this3._channels[idx].values.length > 0) {
                        //calculate total for given channel
                        _this3._channels[idx].sum = _this3.sumPoints(_this3._settings[idx]);
                        _this3.createTimeout(idx, group);
                    }
                }, delay);
            }
        }, {
            key: "sumPoints",
            value: function sumPoints(setting) {
                var channelIdx = _.findIndex(this._channels, function (obj) {
                    return obj.channel === setting.channel;
                });

                if (channelIdx === -1) {
                    return -1;
                }

                var sum = this._channels[channelIdx].values.reduce(function (a, b) {
                    return a + b.scaledValue;
                }, 0);

                return sum;
            }
        }, {
            key: "getDecimals",
            value: function getDecimals(setting) {
                var scale = setting.flowScale;

                if (scale < 1) {
                    return 2;
                } else if (scale < 12) {
                    return 1;
                }

                return 0;
            }
        }, {
            key: "destroy",
            value: function destroy() {
                for (var i = 0; i < this._timeouts.length; i++) {
                    $timeout.cancel(this._timeouts[i]);
                }
            }
        }, {
            key: "device",
            get: function get() {
                return this._device;
            }
        }, {
            key: "channels",
            get: function get() {
                return JSON.parse(JSON.stringify(this._channels));
            }
        }, {
            key: "settings",
            get: function get() {
                return this._settings;
            }
        }, {
            key: "latestStates",
            get: function get() {
                return this._latestStates;
            }
        }, {
            key: "loading",
            get: function get() {
                return this._loading;
            }
        }, {
            key: "deviceId",
            get: function get() {
                return this._deviceId;
            },
            set: function set(deviceId) {
                this._deviceId = deviceId;
            }
        }]);

        return PulseFlow;
    }();

    return PulseFlow;
}

PulseFlowGaugeModel.$inject = ['_', 'HOST', '$http', '$timeout', '$sce'];

angular.module('mc.pulseflow').factory('pulseFlowGaugeModel', PulseFlowGaugeModel);
'use strict';

function PulseFlowGaugeController(_, $, $rootScope, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, openViewService, sharedSetupService, websocketService, PulseFlowGauge) {
    var _this2 = this;

    var ctrl = this;
    var wsDataReceivedPULSE = function wsDataReceivedPULSE(data) {
        for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
            if (_this2.pulseFlow.settings[i].channel === parseInt(data.CH, 10)) {
                if (_this2.pulseFlow.settings[i].selectedGroup == 6) {
                    _this2.pulseFlow.addPoint(_this2.pulseFlow.settings[i].channel, { localTime: moment(datetimeService.socketStrToServerStrTime(data.Time)).format(), scaledValue: Number(data.ScaledValue) }, true, _this2.pulseFlow.settings[i].selectedGroup);
                } else if (_this2.pulseFlow.settings[i].selectedGroup == 7) {
                    _this2.pulseFlow.addPoint(_this2.pulseFlow.settings[i].channel, { localTime: moment(datetimeService.socketStrToServerStrTime(data.Time)).format(), scaledValue: Number(data.RawCount) }, true, _this2.pulseFlow.settings[i].selectedGroup);
                } else {
                    _this2.pulseFlow.addPoint(_this2.pulseFlow.settings[i].channel, { localTime: moment(datetimeService.socketStrToServerStrTime(data.Time)).format(), scaledValue: Number(data.ScaledValue), utcUnixTimeStamp: datetimeService.toUnixtime(data.Time) }, false, _this2.pulseFlow.settings[i].selectedGroup);
                }
            }
        }
    };

    $scope.$on('Heartbeat', function (event, args) {
        if (args.message.Type === "HEARTBEAT") {
            ctrl.pulseFlow.cleanupOldChannelValues(args.message);
        }
    });

    $scope.$on('rtuPulseUpdate', function (event, args) {
        var _dataChanged = "channelName, unit, flowScale";
        if (ctrl.pulseFlow && args.deviceId == $scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
            _unRegisterListener();
            ctrl.pulseFlow.fetchData(1, false).then(function () {
                _registerListener();
            });
        }
    });

    var _getData = function _getData() {
        for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
            _this2.pulseFlow.groupingChange(_this2.pulseFlow.settings[i]);
        }
    };

    $scope.$on('processReconnect', function (event, args) {
        $scope.stickyProperties.liveData = true;
        $scope.reconnectData(event, args);
    });

    $scope.reconnectData = function (event, args) {
        sharedSetupService.processReconnect({
            stickyProperties: $scope.stickyProperties,
            localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
            dateRangeOption: 0,
            windowTitle: $scope.windowTitle,
            fnUnregister: _unRegisterListener,
            fnGetData: _getData,
            viewType: "Gauges"
        });
    };

    //$scope.mostRecentData = function (event, args) {
    //    $scope.stickyProperties.liveData = true;
    //    $scope.myDate = null;        
    //    $scope.reconnectData(event, args);
    //}

    var _registerListener = function _registerListener() {
        websocketService.connect();

        for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
            websocketService.register('PULSE', _this2.pulseFlow.device.serialNumber, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
            websocketService.register('DIGITALASPULSE', _this2.pulseFlow.device.serialNumber, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
        }
    };

    var _unRegisterListener = function _unRegisterListener() {
        for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
            websocketService.unRegister('PULSE', _this2.pulseFlow.device.serialNumber, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
            websocketService.unRegister('DIGITALASPULSE', _this2.pulseFlow.device.serialNumber, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
        }
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.windowId = _this2.windowId;
        _this2.alerts = [];
        $scope.alerts = [];
        _this2.selectedSetting = null;
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        $scope.windowTitle = _this2.translation.text.PULSE_FLOW_GAUGE;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.isGen2Device = false;
        if (!_this2.mobile && !_this2.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;

            $scope.$on('updatePreferencesLanguage', function (event, language) {

                if ($scope.alerts.length > 0) {
                    var _msg = _this2.translation.text[$scope.alerts[0].languageCode.toUpperCase()];
                    var _type = $scope.alerts[0].type;
                    var _languageCode = $scope.alerts[0].languageCode;
                    $scope.alerts = [];
                    $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
                }
            });
        }

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal) {
                _this2.alerts = [];
                $scope.alerts = [];
                if (_this2.pulseFlow) {
                    _unRegisterListener();
                    _this2.pulseFlow.deviceId = newVal;
                } else {
                    _this2.pulseFlow = new PulseFlowGauge(_this2.accountInfo.customerId, newVal);
                }

                _this2.pulseFlow.fetchData(1, false).then(function () {
                    if (_this2.pulseFlow.settings.length === 0) {
                        $scope.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                        _this2.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                    }

                    _registerListener();
                    var mcDevice = { deviceId: _this2.pulseFlow.device.deviceId, serialNumber: _this2.pulseFlow.device.serialNumber, deviceName: _this2.pulseFlow.device.name };
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newVal, windowId: _this2.windowId, device: mcDevice });
                    _this2.isGen2Device = _this2.pulseFlow.device.model > 20 ? true : false;
                });
            }
        }, true);

        $timeout(function () {
            var container = $('#pulseflow-gauge-container-' + _this2.replaceSpaces(_this2.windowId));

            if (container) {
                container.on('mouseover.blahblahblah', '.hcolPulseFlow', function (event) {
                    var localScope = $(event.target).scope();
                    if ($(event.currentTarget).is('.hcolPulseFlow') && !_this2.mobile && !_this2.classicView) {
                        $(event.currentTarget).find('.flow-gauge-draggable').draggable({
                            helper: 'clone',
                            revert: false,
                            appendTo: 'body',
                            containment: 'body',
                            opacity: 0.35,
                            stop: function stop(event, ui) {
                                var mcDevice = { deviceId: _this2.pulseFlow.device.deviceId, channel: parseInt(ui.helper.attr('mc-channel'), 10), serialNumber: _this2.pulseFlow.device.serialNumber, deviceName: _this2.pulseFlow.device.name, group: parseInt(ui.helper.attr('mc-group'), 10) };

                                var optionsStickyProperties = {
                                    device: mcDevice
                                };

                                var $newPosX = ui.offset.left;
                                var $newPosY = ui.offset.top;
                                var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                                openViewService.openWidget('Pulse Flow Widget', { width: 250, height: 100 }, position, optionsStickyProperties, { minimumWidth: 180, minimumHeight: 100 });
                                $scope.$apply();
                            }
                        });
                    }
                });
            }
        });
    };

    this.replaceSpaces = function (str) {
        if (angular.isUndefined(str)) return;
        return str.replace(new RegExp(' ', 'g'), '_');
    };

    this.getDecimalPoints = function () {
        var setting = _.find(_this2.pulseFlow.getSettings(), function (obj) {
            return '' + obj.channel === _this2.selectedSetting;
        });

        if (setting && setting.flowScale < 0.1) {
            return 3;
        } else if (setting && setting.flowScale < 1) {
            return 2;
        }

        return 0;
    };

    this.$onDestroy = function () {
        _unRegisterListener();
        _this2.pulseFlow.destroy();
    };
}

PulseFlowGaugeController.$inject = ['_', '$', '$rootScope', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'openViewService', 'sharedSetupService', 'websocketService', 'pulseFlowGaugeModel'];

angular.module('mc.pulseflow').component('pulseFlowGauge', {
    controller: PulseFlowGaugeController,
    transclude: true,
    templateUrl: 'ui/pulseflow/gauge/pulseflow-gauge-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        deviceSelected: '<'
    }
});
"use strict";

function PulseFlowCalendarModel(HOST, $http) {
    return function PulseFlow(customerId, deviceId) {
        var _this = this;

        this.loading = false;
        this.days = [];
        this.settings = [];
        this.customerId = customerId;
        this.deviceId = deviceId;

        this.get = function () {
            return JSON.parse(JSON.stringify(_this.days));
        };

        this.getSettings = function () {
            for (var i = 0; i < _this.settings.length; i++) {
                _this.settings[i].meterReadingChannel = "MR" + _this.settings[i].channel;
            }
            return _this.settings;
        };

        this.isLoading = function () {
            return _this.loading;
        };

        this.fetchSettings = function () {
            return $http.get(HOST + "/api/ParmPulse?deviceId=" + _this.deviceId).then(function (resp) {
                _this.settings = resp.data;
            });
        };

        this.fetchData = function (deviceType, channel, startDate, endDate) {
            _this.loading = true;
            var isRawCount = false;
            if (channel.includes("MR")) {
                isRawCount = true;
                channel = channel.replace('MR', '');
            }
            return $http.get(HOST + "/api/PulseFlowCalendar?customerId=" + _this.customerId + "&deviceId=" + _this.deviceId + "&channel=" + channel + "&deviceType=" + deviceType + "&startDate=" + startDate + "&endDate=" + endDate + "&isRawCount=" + isRawCount).then(function (resp) {
                _this.days = resp.data;
                _this.loading = false;
            });
        };

        this.setDevice = function (newDeviceId) {
            _this.deviceId = newDeviceId;
        };
    };
}

PulseFlowCalendarModel.$inject = ['HOST', '$http'];

angular.module('mc.pulseflow').factory('pulseFlowCalendarModel', PulseFlowCalendarModel);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function PulseFlowCalendarController(_, $, $scope, $rootScope, $filter, $timeout, authenticationService, translationService, datetimeService, sharedSetupService, openViewService, websocketService, PulseFlowCalendar, $window, $element, toaster) {
    var _this2 = this;

    this.wsDataReceivedPULSE = function (data) {
        if (parseInt(_this2.selectedSetting, 10) === parseInt(data.CH, 10)) {
            var receivedTime = moment(datetimeService.socketStrToServerStrTime(data.Time));
            var setting = _.findIndex(_this2.pulseFlow.settings, function (obj) {
                return parseInt(obj.channel, 10) === parseInt(_this2.selectedSetting, 10);
            });

            var incomingUtc = moment.utc(data.UtcDateTime, "YYYYMMDDHHmmss");

            ////Set this.pulseFlow.days[0].start with correct hour and minute so timezone won't cause issue
            //const sourceDate = new Date(receivedTime._d);
            //const todayDate = new Date(moment(this.pulseFlow.days[0].start)._d);            
            //const hours = sourceDate.getHours();
            //const minutes = sourceDate.getMinutes();           
            //todayDate.setHours(hours);
            //todayDate.setMinutes(minutes);

            //if (this.pulseFlow && this.pulseFlow.days && this.pulseFlow.days.length > 0 && this.pulseFlow.days[0] && this.pulseFlow.days[0].start && receivedTime._d.getUTCDate() === todayDate.getUTCDate()) {
            if (_this2.pulseFlow && _this2.pulseFlow.days && _this2.pulseFlow.days.length > 0 && _this2.pulseFlow.days[0] && _this2.pulseFlow.days[0].utcStart && incomingUtc.isSame(moment.utc(_this2.pulseFlow.days[0].utcStart), "day")) {
                if (setting < 0) {
                    _this2.pulseFlow.days[0].title = data.RawCount.toString();
                } else {
                    _this2.pulseFlow.days[0].title = "" + (parseFloat(_this2.pulseFlow.days[0].title) + Number(data.ScaledValue));
                }
            } else {
                _this2.pulseFlow.days.push({
                    allDay: true,
                    color: 'transparent',
                    start: receivedTime.format('MM/DD/YYYY'),
                    title: "" + Number(data.ScaledValue),
                    url: null
                });
            }

            _this2.fullCalendar.fullCalendar('destroy');
            _this2.drawCalendar(true);
        }
    };

    //this.mostRecentData = () => {
    //    toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
    //    this.wsReconnectPULSE();
    //}

    this.wsReconnectPULSE = function (data) {
        _this2.fullCalendar.fullCalendar('destroy');
        _this2.drawCalendar(false);
    };

    this._registerListener = function () {
        if (isNaN(parseInt(_this2.selectedSetting, 10))) return;
        websocketService.connect();
        websocketService.register('PULSE', $scope.deviceSelectedSn, parseInt(_this2.selectedSetting, 10), _this2.wsDataReceivedPULSE, _this2.wsReconnectPULSE);
        websocketService.register('DIGITALASPULSE', $scope.deviceSelectedSn, parseInt(_this2.selectedSetting, 10), _this2.wsDataReceivedPULSE, _this2.wsReconnectPULSE);
    };

    this._unRegisterListener = function (serial, setting) {
        var set = setting ? parseInt(setting, 10) : null;
        websocketService.unRegister('PULSE', serial || $scope.deviceSelectedSn, set || parseInt(_this2.selectedSetting, 10), _this2.wsDataReceivedPULSE, _this2.wsReconnectPULSE);
        websocketService.unRegister('DIGITALASPULSE', serial || $scope.deviceSelectedSn, set || parseInt(_this2.selectedSetting, 10), _this2.wsDataReceivedPULSE, _this2.wsReconnectPULSE);
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId(_this2);
        $scope.windowId = _this2.windowId;
        _this2.daily = null;
        _this2.alerts = [];
        $scope.alerts = [];
        _this2.selectedSetting = null;
        _this2.isRawCount = false;
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        $scope.windowTitle = _this2.translation.text.PULSE_FLOW_CALENDAR;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        if (_typeof($scope.stickyProperties) !== 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        _this2.fullCalendar = null;
        _this2.initialLoad = true;
        _this2.calendarHeight = 'auto';
        _this2.viewStart = null;

        $scope.downloadViewTypeOptions = [0, 4];

        if ($rootScope.mobile) {
            var tmpCurrentWindow = angular.element($window);
            tmpCurrentWindow.bind('resize', function () {

                //this is a trick to refresh the calendar on resize
                //this is a trick to refresh the calendar on resize
                //this is a trick to refresh the calendar on resize
                var origin = location.origin;
                var path = location.pathname;
                var queryString = $rootScope.mobileApp ? "?" + location.href.split("?")[1] : "";
                var angJs = "#!/";
                var newPage = "pleasewait/please-wait";
                location.replace(origin + path + angJs + newPage + queryString);
                newPage = "pulseflow/calendar/pulseflow-calendar-template";
                location.replace(origin + path + angJs + newPage + queryString);

                $scope.$apply();
            });
        }

        if (!_this2.mobile && !_this2.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            _this2.calendarHeight = _this2._popup.outerHeight() - 127;

            _this2._popup.dialogExtend({
                maximize: function maximize() {
                    openViewService.adjustContentSizeStart(_this2._popup);
                    _resize();
                },
                restore: function restore() {
                    openViewService.adjustContentSizeStart(_this2._popup);
                    _resize();
                }
            });
        }

        var _resize = function _resize() {
            $timeout(function () {
                if (!_this2.mobile && !_this2.classicView) {
                    _this2.calendarHeight = _this2._popup.outerHeight() - 127;
                    _this2._popup.find('.fc-time-grid').css('height', _this2.calendarHeight / 6);
                    _this2._popup.find('.fc-slats td').css('height', _this2.calendarHeight / 6);
                }
                if (_this2.fullCalendar) {
                    _this2.fullCalendar.fullCalendar('option', 'contentHeight', _this2.calendarHeight - 26);
                    _this2.fullCalendar.fullCalendar('refresh');
                }
            });
        };

        var updateFromPrefs = function updateFromPrefs(refresh) {
            _this2.previousMonth = _this2.fullCalendar.fullCalendar('getDate');
            if (_this2.fullCalendar) {
                _this2.fullCalendar.fullCalendar('destroy');
                _this2.drawCalendar(refresh);
            }
        };

        $scope.$on('contentAdjusted', function () {
            _resize();
        });

        $scope.$on('updatePreferencesLanguage', function (event, language) {
            updateFromPrefs(true);
            if ($scope.alerts.length > 0) {
                var _msg = _this2.translation.text[$scope.alerts[0].languageCode.toUpperCase()];
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });

        $scope.$watch(function () {
            return $scope.deviceSelectedSn;
        }, function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                if (oldVal) {
                    _this2._unRegisterListener(oldVal);
                }
            }
        }, true);

        $scope.$watch(function () {
            if (_this2.fullCalendar !== null && _this2.fullCalendar.fullCalendar('getDate')._d) {
                return _this2.fullCalendar.fullCalendar('getDate');
            }
            return undefined;
        }, function (newVal, oldVal) {
            if (newVal) {
                if (newVal._d.getUTCMonth() === moment()._d.getUTCMonth()) {
                    _this2._registerListener();
                } else {
                    _this2._unRegisterListener();
                }
            }
        }, true);

        $scope.$watch(function () {
            return _this2.selectedSetting;
        }, function (newVal, oldVal) {
            if (newVal && newVal !== oldVal && _this2.fullCalendar.fullCalendar('getDate')._d.getUTCMonth() === moment()._d.getUTCMonth()) {
                _this2._unRegisterListener(null, oldVal);
                _this2._registerListener();
            }
            if (_this2.selectedSetting !== null) {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { device: { channel: _this2.selectedSetting }, windowId: _this2.windowId });
            }
        });

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal) {
                _this2.alerts = [];
                $scope.alerts = [];

                if (_this2.pulseFlow) {
                    _this2.pulseFlow.setDevice(newVal);
                    if (_this2.fullCalendar) {
                        _this2.previousMonth = _this2.fullCalendar.fullCalendar('getDate');
                    }
                } else {
                    _this2.pulseFlow = new PulseFlowCalendar(_this2.accountInfo.customerId, newVal);
                }
                _this2._registerListener();

                _this2.pulseFlow.fetchSettings().then(function () {
                    if ($scope.deviceSelectedType === 15 || $scope.deviceSelectedType === 20) {
                        $scope.alerts.push({ msg: _this2.translation.text.DEVICE_UNSUPPORTED, type: 'info', languageCode: 'DEVICE_UNSUPPORTED' });
                        _this2.alerts.push({ msg: _this2.translation.text.DEVICE_UNSUPPORTED, type: 'info', languageCode: 'DEVICE_UNSUPPORTED' });
                    } else if (_this2.pulseFlow.getSettings().length === 0) {
                        $scope.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                        _this2.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                    } else {
                        if ($scope.stickyProperties.savedDesktop === true && $scope.stickyProperties.on === true) {
                            //handles saved desktop situation
                            _this2.selectedSetting = $scope.stickyProperties.device.channel;
                            var val = $scope.stickyProperties.device.serialNumber === "1" ? true : false; //"1" is true and "2" is false
                            _this2.daily = val;
                            $scope.stickyProperties.savedDesktop = false;
                        } else if ($scope.stickyProperties.device.channel !== null) {
                            //handle the situation when we switch back from other page where channel gets setted to null
                            _this2.selectedSetting = $scope.stickyProperties.device.channel;
                            var _val = $scope.stickyProperties.device.serialNumber === "1" ? true : false; //"1" is true and "2" is false
                            _this2.daily = _val;
                        } else {
                            _this2.selectedSetting = _this2.pulseFlow.getSettings().length > 0 ? "" + _this2.pulseFlow.getSettings()[0].channel : null;
                            _this2.daily = true;
                        }

                        if (_this2.fullCalendar) {
                            _this2.fullCalendar.fullCalendar('destroy');
                        }

                        if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
                            $scope.stickyProperties.on = true;
                            var zoomDate = new Date($scope.stickyProperties.zoomMin); // datetimeService.unixtimeToDate($scope.stickyProperties.zoomMin);
                            var firstDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth(), 1);
                            var lastDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth() + 1, 0);
                            _this2.startDateUnix = datetimeService.dateToUnixtime(firstDay);
                            _this2.endDateUnix = datetimeService.dateToUnixtime(lastDay);
                        }

                        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newVal, windowId: _this2.windowId });
                        _this2.drawCalendar(false, true);
                    }
                });
            }
        }, true);
    };

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }
        return '';
    };

    this.replaceCommas = function (str) {
        return str.replace(new RegExp(',', 'g'), '');
    };

    this.countDecimals = function (value) {
        if (value % 1 !== 0) {
            return value.toString().split('.')[1].length;
        }

        return 0;
    };

    this.getDecimalPoints = function () {
        var setting = _.find(_this2.pulseFlow.getSettings(), function (obj) {
            return "" + obj.channel === _this2.selectedSetting;
        });

        if (setting && setting.flowScale < 0.1) {
            if (setting.channelName && setting.channelName.includes("Rainfall")) {
                return 2;
            } else {
                return 3;
            }
        } else if (setting && setting.flowScale < 1) {
            return 2;
        }

        return 0;
    };

    this.settingChange = function () {
        if (_this2.selectedSetting > _this2.pulseFlow.settings.length) {
            _this2.daily = true;
        }
        _this2.previousMonth = _this2.fullCalendar.fullCalendar('getDate');
        _this2.fullCalendar.fullCalendar('destroy');
        _this2.drawCalendar(false, false);
        var val = _this2.daily === true ? "1" : "2"; //"1" is true and "2" is false        
        sharedSetupService.setStickyProperties($scope.stickyProperties, { device: { serialNumber: val }, windowId: _this2.windowId });
    };

    this.dailyOrCumulative = function () {
        _this2.previousMonth = _this2.fullCalendar.fullCalendar('getDate');
        _this2.fullCalendar.fullCalendar('destroy');
        _this2.drawCalendar(false, false);
        var val = _this2.daily === true ? "1" : "2"; //"1" is true and "2" is false        
        sharedSetupService.setStickyProperties($scope.stickyProperties, { device: { serialNumber: val }, windowId: _this2.windowId });
    };

    this.drawCalendar = function (refresh, newDevice) {
        _this2.fullCalendar = $("#pulse-flow-calendar-" + _this2.replaceSpaces(_this2.windowId)).fullCalendar({
            fixedWeekCount: false,
            contentHeight: _this2.calendarHeight,
            ignoreTimezone: true,
            lang: _this2.accountInfo.preferenceUser.i18nCode,
            header: {
                left: 'title',
                center: '',
                right: 'today prev,next'
            },
            buttonText: {
                today: $scope.translation.text.CURRENT_MONTH
            },
            businessHours: false,
            eventClick: function eventClick(calEvent, jsEvent, view) {},
            viewRender: function viewRender(view, element) {
                $("#pulse-flow-calendar-" + _this2.replaceSpaces(_this2.windowId)).fullCalendar('removeEvents');

                if (_this2.startDateUnix && _this2.startDateUnix !== view.intervalStart._d.getTime()) {
                    $("#pulse-flow-calendar-" + _this2.replaceSpaces(_this2.windowId)).fullCalendar('gotoDate', _this2.startDateUnix - datetimeService.GetTimeZoneOffset(_this2.accountInfo.timeZone) * 3600000);

                    return false;
                }

                if (_this2.previousMonth) {
                    _this2.fullCalendar.fullCalendar('gotoDate', _this2.previousMonth);
                    _this2.previousMonth = null;
                }

                if (_this2.timeout) {
                    $timeout.cancel(_this2.timeout);
                }

                // Debounce setting the events to prevent all sorts of issues
                _this2.timeout = $timeout(function () {
                    // If we're just refreshing due to a change in preferences we don't need to call the server
                    if (refresh) {
                        refresh = false;
                        var data = _this2.pulseFlow.get().reverse();
                        for (var i = 0; i < new Date(view.intervalEnd.year(), view.intervalEnd.month(), 0).getDate(); i++) {
                            if (data[i]) {
                                var eventDate = new Date(data[i].start);

                                if (i + 1 !== eventDate.getDate()) {
                                    var newEvent = {
                                        allDay: true,
                                        color: 'transparent',
                                        textColor: '#000000',
                                        className: 'pulse-flow-calendar',
                                        start: eventDate.getMonth() + 1 + "/" + (i + 1) + "/" + eventDate.getFullYear(),
                                        title: '0'
                                    };

                                    data.splice(i, 0, newEvent);
                                }
                            } else {
                                if (new Date(view.intervalEnd.year(), view.intervalEnd.month() - 1, i + 1) <= new Date()) {
                                    var _newEvent = {
                                        allDay: true,
                                        color: 'transparent',
                                        textColor: '#000000',
                                        className: 'pulse-flow-calendar',
                                        start: view.intervalEnd.month() + "/" + (i + 1) + "/" + view.intervalEnd.year(),
                                        title: '0'
                                    };

                                    data.push(_newEvent);
                                }
                            }
                        }

                        var modData = JSON.parse(JSON.stringify(data));
                        for (var _i = 0; _i < data.length; _i++) {
                            if (!_this2.daily) {
                                var sum = 0;

                                for (var j = 0; j <= _i; j++) {
                                    var tmp = parseFloat(_this2.replaceCommas(data[j].title));

                                    for (var k = _this2.countDecimals(parseFloat(data[_i].title)); k >= _this2.getDecimalPoints(); k--) {
                                        tmp = parseFloat(tmp.toFixed(k));
                                    }

                                    sum += tmp;
                                }

                                modData[_i].title = $filter('number')(sum, _this2.getDecimalPoints());
                            } else {
                                for (var _k = _this2.countDecimals(parseFloat(data[_i].title)); _k >= _this2.getDecimalPoints(); _k--) {
                                    data[_i].title = parseFloat(data[_i].title).toFixed(_k);
                                }

                                modData[_i].title = $filter('number')(data[_i].title, _this2.getDecimalPoints());
                            }

                            modData[_i].textColor = '#000000';
                            modData[_i].className = 'pulse-flow-calendar';
                        }

                        $timeout(function () {
                            $("#pulse-flow-calendar-" + _this2.replaceSpaces(_this2.windowId)).fullCalendar('removeEvents');
                            $("#pulse-flow-calendar-" + _this2.replaceSpaces(_this2.windowId)).fullCalendar('addEventSource', modData);
                        });

                        return true;
                    }

                    if (view.intervalStart !== _this2.viewStart || newDevice) {
                        _this2.viewStart = view.intervalStart;
                        newDevice = false;

                        var d = view.intervalEnd;
                        var month = d.month() === 1 ? 0 : d.month() - 1;
                        var middledate = new Date(d.year(), month, 15);
                        var middleUnix = datetimeService.dateToUnixtime(middledate);
                        var tmpDataMin = middleUnix - 24 * 3600 * 1000;
                        var tmpDataMax = middleUnix + 48 * 3600 * 1000;
                        var tmpZoomMin = middleUnix;
                        var tmpZoomMax = middleUnix + 24 * 3600 * 1000;

                        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDataMin, dataMax: tmpDataMax, zoomMin: tmpZoomMin, zoomMax: tmpZoomMax, windowId: _this2.windowId });
                        var now = new Date();
                        var isCurrentMonth = month === now.getMonth() && d.year() === now.getFullYear();
                        if (isCurrentMonth) {
                            $scope.stickyProperties.liveData = true;
                        } else {
                            $scope.stickyProperties.liveData = false;
                        }
                        _this2.startDateUnix = null;

                        //when switching devices check if new device has channel, else assign default selectedSetting if available
                        if (!_this2.selectedSetting && _this2.pulseFlow.settings.length) {
                            _this2.selectedSetting = _this2.pulseFlow.settings[0].channel.toString();
                        }

                        _this2.pulseFlow.fetchData($scope.deviceSelectedType, _this2.selectedSetting.toString() || '1', view.intervalStart, view.intervalEnd).then(function () {
                            var data = _this2.pulseFlow.get().reverse();

                            for (var _i2 = 0; _i2 < new Date(view.intervalEnd.year(), view.intervalEnd.month(), 0).getDate(); _i2++) {
                                if (data[_i2]) {
                                    var _eventDate = new Date(data[_i2].start);

                                    if (_i2 + 1 !== _eventDate.getDate()) {
                                        var _newEvent2 = {
                                            allDay: true,
                                            color: 'transparent',
                                            textColor: '#000000',
                                            className: 'pulse-flow-calendar',
                                            start: _eventDate.getMonth() + 1 + "/" + (_i2 + 1) + "/" + _eventDate.getFullYear(),
                                            title: '0'
                                        };

                                        data.splice(_i2, 0, _newEvent2);
                                    }
                                } else {
                                    if (new Date(view.intervalEnd.year(), view.intervalEnd.month() - 1, _i2 + 1) <= new Date()) {
                                        var _newEvent3 = {
                                            allDay: true,
                                            color: 'transparent',
                                            textColor: '#000000',
                                            className: 'pulse-flow-calendar',
                                            start: view.intervalEnd.month() + "/" + (_i2 + 1) + "/" + view.intervalEnd.year(),
                                            title: '0'
                                        };

                                        data.push(_newEvent3);
                                    }
                                }
                            }

                            var modData = JSON.parse(JSON.stringify(data));
                            for (var _i3 = 0; _i3 < data.length; _i3++) {
                                if (!_this2.daily) {
                                    var _sum = 0;

                                    for (var _j = 0; _j <= _i3; _j++) {
                                        var _tmp = parseFloat(_this2.replaceCommas(data[_j].title));

                                        for (var _k2 = _this2.countDecimals(parseFloat(data[_i3].title)); _k2 >= _this2.getDecimalPoints(); _k2--) {
                                            _tmp = parseFloat(_tmp.toFixed(_k2));
                                        }

                                        _sum += _tmp;
                                    }

                                    modData[_i3].title = $filter('number')(_sum, _this2.getDecimalPoints());
                                } else {
                                    for (var _k3 = _this2.countDecimals(parseFloat(data[_i3].title)); _k3 >= _this2.getDecimalPoints(); _k3--) {
                                        data[_i3].title = parseFloat(data[_i3].title).toFixed(_k3);
                                    }

                                    modData[_i3].title = $filter('number')(data[_i3].title, _this2.getDecimalPoints());
                                }
                                modData[_i3].textColor = '#000000';
                                modData[_i3].className = 'pulse-flow-calendar';
                            }

                            $timeout(function () {
                                $("#pulse-flow-calendar-" + _this2.replaceSpaces(_this2.windowId)).fullCalendar('removeEvents');
                                $("#pulse-flow-calendar-" + _this2.replaceSpaces(_this2.windowId)).fullCalendar('addEventSource', modData);
                            });
                        });
                    }

                    return true;
                }, 500);
            },
            eventRender: function eventRender(event, element, view) {
                if (event.start.month() !== view.intervalStart.month() || event.start.year() !== view.intervalStart.year()) {
                    return false;
                }

                element.find('span.fc-title').html(element.find('span.fc-title').text());
                return true;
            }
        });
    };

    this.$onDestroy = function () {
        _this2._unRegisterListener();
    };
}

PulseFlowCalendarController.$inject = ['_', '$', '$scope', '$rootScope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'sharedSetupService', 'openViewService', 'websocketService', 'pulseFlowCalendarModel', '$window', "$element", "toaster"];

angular.module('mc.pulseflow').component('pulseFlowCalendar', {
    controller: PulseFlowCalendarController,
    transclude: true,
    templateUrl: 'ui/pulseflow/calendar/pulseflow-calendar-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        deviceSelected: '<'
    }
});
'use strict';

function PulseFlowRtuViewGaugeController(_, $, $rootScope, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, openViewService, sharedSetupService, websocketService, PulseFlowGauge, $sce) {
    var _this2 = this;

    var ctrl = this;
    ctrl.trustAsHtml = $sce.trustAsHtml;
    var wsDataReceivedPULSE = function wsDataReceivedPULSE(data) {
        for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
            if (_this2.pulseFlow.settings[i].channel === parseInt(data.CH, 10)) {
                if (_this2.pulseFlow.settings[i].selectedGroup == 6) {
                    _this2.pulseFlow.addPoint(_this2.pulseFlow.settings[i].channel, { localTime: moment(datetimeService.socketStrToServerStrTime(data.Time)).format('YYYY-MM-DDTHH:mm:ss'), scaledValue: Number(data.ScaledValue) }, true, _this2.pulseFlow.settings[i].selectedGroup);
                } else if (_this2.pulseFlow.settings[i].selectedGroup == 7) {
                    _this2.pulseFlow.addPoint(_this2.pulseFlow.settings[i].channel, { localTime: moment(datetimeService.socketStrToServerStrTime(data.Time)).format('YYYY-MM-DDTHH:mm:ss'), scaledValue: Number(data.RawCount) }, true, _this2.pulseFlow.settings[i].selectedGroup);
                } else {
                    _this2.pulseFlow.addPoint(_this2.pulseFlow.settings[i].channel, { localTime: moment(datetimeService.socketStrToServerStrTime(data.Time)).format('YYYY-MM-DDTHH:mm:ss'), scaledValue: Number(data.ScaledValue), utcUnixTimeStamp: datetimeService.toUnixtime(data.Time) }, false, _this2.pulseFlow.settings[i].selectedGroup);
                }
            }
        }
    };

    $scope.$on('Heartbeat', function (event, args) {
        if (args.message.Type === "HEARTBEAT") {
            ctrl.pulseFlow.cleanupOldChannelValues(args.message);
        }
    });

    var _getData = function _getData() {
        for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
            _this2.pulseFlow.groupingChange(_this2.pulseFlow.settings[i]);
        }
    };

    $scope.$on('processReconnect', function (event, args) {
        $scope.stickyProperties.liveData = true;
        $scope.reconnectData(event, args);
    });

    $scope.reconnectData = function (event, args) {
        sharedSetupService.processReconnect({
            stickyProperties: $scope.stickyProperties,
            localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
            dateRangeOption: 0,
            windowTitle: $scope.windowTitle,
            fnUnregister: _unRegisterListener,
            fnGetData: _getData,
            viewType: "Gauges"
        });
    };

    //$scope.mostRecentData = function (event, args) {
    //    $scope.stickyProperties.liveData = true;
    //    $scope.myDate = null;        
    //    $scope.reconnectData(event, args);
    //}

    var _registerListener = function _registerListener() {
        websocketService.connect();

        for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
            websocketService.register('PULSE', _this2.pulseFlow.device.serialNumber, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
            websocketService.register('DIGITALASPULSE', _this2.pulseFlow.device.serialNumber, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
        }
    };

    var _unRegisterListener = function _unRegisterListener() {
        for (var i = 0; i < _this2.pulseFlow.settings.length; i++) {
            websocketService.unRegister('PULSE', _this2.pulseFlow.device.serialNumber, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
            websocketService.unRegister('DIGITALASPULSE', _this2.pulseFlow.device.serialNumber, _this2.pulseFlow.settings[i].channel, wsDataReceivedPULSE, null);
        }
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.windowId = _this2.windowId;
        _this2.alerts = [];
        $scope.alerts = [];
        _this2.selectedSetting = null;
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        $scope.windowTitle = _this2.translation.text.PULSE_FLOW_GAUGE;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.pulseFlowDataHideShow = false;
        if (!_this2.mobile && !_this2.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;

            $scope.$on('updatePreferencesLanguage', function (event, language) {

                if ($scope.alerts.length > 0) {
                    var _msg = _this2.translation.text[$scope.alerts[0].languageCode.toUpperCase()];
                    var _type = $scope.alerts[0].type;
                    var _languageCode = $scope.alerts[0].languageCode;
                    $scope.alerts = [];
                    $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
                }
            });
        }

        ctrl.$onChanges = function (changes) {
            if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
                _this2.alerts = [];
                $scope.alerts = [];
                $scope.pulseFlowDataHideShow = false;
                _this2.timeFormat = _this2.accountInfo.preferenceUser.timeFormat;
                if (_this2.pulseFlow) {
                    _unRegisterListener();
                    _this2.pulseFlow.deviceId = changes.deviceSelected.currentValue;
                } else {
                    _this2.pulseFlow = new PulseFlowGauge(_this2.accountInfo.customerId, changes.deviceSelected.currentValue);
                }

                _this2.pulseFlow.fetchData(1, true).then(function () {
                    $scope.$emit("SendPulseFlowCountUp", _this2.pulseFlow.settings.length);
                    if (_this2.pulseFlow.settings.length === 0) {
                        $scope.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                        _this2.alerts.push({ msg: _this2.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
                    }

                    _registerListener();
                    var mcDevice = { deviceId: _this2.pulseFlow.device.deviceId, serialNumber: _this2.pulseFlow.device.serialNumber, deviceName: _this2.pulseFlow.device.name };
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: changes.deviceSelected.currentValue, windowId: _this2.windowId, device: mcDevice });
                });
            }
        };

        $timeout(function () {
            var container = $('#pulseflow-gauge-container-' + _this2.replaceSpaces(_this2.windowId));

            if (container) {
                container.on('mouseover.blahblahblah', '.hcolPulseFlow', function (event) {
                    var localScope = $(event.target).scope();
                    if ($(event.currentTarget).is('.hcolPulseFlow') && !_this2.mobile && !_this2.classicView) {
                        $(event.currentTarget).find('.flow-gauge-draggable').draggable({
                            helper: 'clone',
                            revert: false,
                            appendTo: 'body',
                            containment: 'body',
                            opacity: 0.35,
                            stop: function stop(event, ui) {
                                var mcDevice = { deviceId: _this2.pulseFlow.device.deviceId, channel: parseInt(ui.helper.attr('mc-channel'), 10), serialNumber: _this2.pulseFlow.device.serialNumber, deviceName: _this2.pulseFlow.device.name, group: parseInt(ui.helper.attr('mc-group'), 10) };

                                var optionsStickyProperties = {
                                    device: mcDevice
                                };

                                var $newPosX = ui.offset.left;
                                var $newPosY = ui.offset.top;
                                var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                                openViewService.openWidget('Pulse Flow Widget', { width: 250, height: 100 }, position, optionsStickyProperties, { minimumWidth: 180, minimumHeight: 100 });
                                $scope.$apply();
                            }
                        });
                    }
                });
            }
        });
    };

    this.replaceSpaces = function (str) {
        if (angular.isUndefined(str)) return;
        return str.replace(new RegExp(' ', 'g'), '_');
    };

    this.getDecimalPoints = function () {
        var setting = _.find(_this2.pulseFlow.getSettings(), function (obj) {
            return '' + obj.channel === _this2.selectedSetting;
        });

        if (setting && setting.flowScale < 0.1) {
            return 3;
        } else if (setting && setting.flowScale < 1) {
            return 2;
        }

        return 0;
    };

    this.getLastPulseFlowTime = function (time, channel) {
        //if the time is undefined, it means there is NO latest Data, so fetch last reading time
        var retVal = _this2.translation.text.UNKNOWN;
        if (time === undefined) {
            //fetch last reading time aka latest States's time
            var latestState = _.find(_this2.pulseFlow.latestStates, function (ls) {
                return ls.channel == channel;
            });

            retVal = datetimeService.formatDateAgentText(latestState.localTime, 'yyyy-MM-ddTHH:mm:ss', false, _this2.timeFormat);
        } else {
            retVal = time === '0001-01-01T00:00:00' || time === 'Jan 01 1901 12:00:00 AM' ? _this2.translation.text.UNKNOWN : datetimeService.formatDateAgentText(time, 'yyyy-MM-ddTHH:mm:ss', false, _this2.timeFormat);
        }

        return retVal;
    };

    this.getLastPulseFlowValue = function (val, chSetting) {
        //if the val is undefined, it means there is NO latest Data, so fetch last reading value
        var retVal = '';
        if (val === undefined) {
            //fetch last reading value aka latest States's value
            var latestState = _.find(_this2.pulseFlow.latestStates, function (ls) {
                return ls.channel == chSetting.channel;
            });
            //format the value
            retVal = $filter('number')(latestState.value, _this2.pulseFlow.getDecimals(chSetting));
        } else {
            retVal = val;
        }

        return retVal;
    };

    this.getSumFormatted = function (value) {
        return value.replace(",", "<mc-pulse-span>,</mc-pulse-span>");
    };

    $scope.pulseFlowSectionShowHide = function () {
        $scope.pulseFlowDataHideShow = !$scope.pulseFlowDataHideShow;
    };

    $scope.$on('rtuViewRefreshButtonClicked', function (event, args) {
        if (ctrl.deviceSelected == args) {
            $scope.pulseFlowDataHideShow = false;
        }
    });

    this.$onDestroy = function () {
        _unRegisterListener();
        _this2.pulseFlow.destroy();
    };
}

PulseFlowRtuViewGaugeController.$inject = ['_', '$', '$rootScope', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'openViewService', 'sharedSetupService', 'websocketService', 'pulseFlowGaugeModel', '$sce'];
'use strict';

angular.module('mc.pulseflow').component('pulseFlowRtuViewGauge', {
    controller: PulseFlowRtuViewGaugeController,
    transclude: true,
    templateUrl: 'ui/pulseflow/pulseflowrtuviewgauge/pulseflow-rtu-view-gauge-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        deviceSelected: '<'
    }
});
"use strict";

mcapp.directive('preferencesMetarStations', ["$rootScope", "wizardSplashService", "authenticationService", function ($rootScope, wizardSplashService, authenticationService) {
    return {
        restrict: 'E',
        transclude: false,
        replace: true,
        templateUrl: 'ui/preferences/preferences-metar-stations.html',
        link: function link(scope, element, attrs) {
            var _element = element.find("input");

            scope.$on("$destroy", function (event) {
                //save wizard step status if wizard splash lauched this view.
                if ($rootScope.launchedByWizard) {
                    var accountInfo = authenticationService.getAccountInfo();
                    wizardSplashService.SaveWizardStepStatus(accountInfo.customerId, accountInfo.userId, $rootScope.wizardId, scope.windowId, 2); //save status as completed (2: status complete)
                    $rootScope.$broadcast('wizardSplashStepClosed');
                }
            });
        }
    };
}]);
'use strict';

mcapp.directive('preferencesLanguage', ['$timeout', "$rootScope", "wizardSplashService", "authenticationService", function ($timeout, $rootScope, wizardSplashService, authenticationService) {
    return {
        restrict: 'E',
        transclude: false,
        replace: true,
        templateUrl: 'ui/preferences/preferences-language.html',
        link: function link(scope, element, attrs) {
            var _element = element.find("input");

            scope.$on("$destroy", function (event) {
                //save wizard step status if wizard splash lauched this view.
                if ($rootScope.launchedByWizard) {
                    var accountInfo = authenticationService.getAccountInfo();
                    wizardSplashService.SaveWizardStepStatus(accountInfo.customerId, accountInfo.userId, $rootScope.wizardId, scope.windowId, 2); //save status as completed (2: status complete)
                    $rootScope.$broadcast('wizardSplashStepClosed');
                }
            });
        }
    };
}]);
"use strict";

angular.module("mc.notification-rules", []);
'use strict';

function NotificationRulesController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, notificationRuleService, notificationRuleDeviceService, notificationRuleScheduleService, $timeout, $filter, toaster, $uibModal, HOST, $http, $interval, $element, modalService, wizardSplashService, unsavedChangesService, $location) {
    var _this2 = this;

    var ctrl = this;
    ctrl.voiceTypes = [];
    ctrl.emailTypes = [];
    ctrl.rulesBusy = true;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.editMode = null;
        ctrl.addMode = null;
        ctrl.myModalTemplate = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.advancedMode = angular.isDefined(ctrl.accountInfo.notificationMode) ? ctrl.accountInfo.notificationMode : 1;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this2);
        ctrl.nrsGetData();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl._popup);

            ctrl._popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl._popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl._popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl._popup);
                    ctrl.adjustSize();
                }
            });

            $timeout(function () {
                ctrl.adjustSize(15);
            }, 500);

            // binding 'dialogbeforeclose' event to Check for unsaved Changes function
            $(ctrl._popup).on('dialogbeforeclose', function (event) {
                var closeWithoutSave = unsavedChangesService.checkUnsavedChanges(event, ctrl._popup, _this2, ctrl.incompleteChangesCheck());
                if (closeWithoutSave === true) {
                    for (var i = 0; i < $scope.notificationRules.length; i++) {
                        if ($scope.deviceListModel[i].length == 0 || $scope.notificationGroupsModel[i].length == 0) {
                            $http.delete(HOST + '/api/Notifications/NotificationRule?customerId=' + $scope.accountInfo.customerId + '&ruleId=' + $scope.notificationRules[i].ruleId).then(function (resp) {}, function (resp) {
                                alert("Error");
                            });
                        }
                    }
                }
            });
        }
    };

    ctrl.adjustSize = function () {
        ctrl._popup.parent().find('div:eq(2)').css("width", ctrl._popup.parent().css("width"));
        ctrl._popup.parent().find('div:eq(2)').css("min-width", ctrl._popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl._popup.parent().find('div:eq(2)').css("height", ctrl._popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl._popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl._popup.parent().find('.tabular-data-container').css("height", ctrl._popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl._popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
    };

    ctrl.clearObjects = function () {
        $scope.deviceListModel = [];
        $scope.deviceListData = [];
        $scope.notificationGroupsModel = [];
        $scope.notificationRules = [];
        $scope.oldIndex = [];
    };

    ctrl.clearObjects();

    $scope.validationError = false;
    $scope.updateHappened = false;

    $scope.Math = window.Math;

    $scope.translation = translationService.translation;
    $scope.accountInfo = authenticationService.getAccountInfo();

    if ($scope.accountInfo.userRole === 'Administrator' || $scope.accountInfo.userRole === 'SuperAdministrator') {
        $scope.isAdmin = true;
    }

    var digitalMode = [{
        "id": "1",
        "name": $scope.translation.text.SG_OFF_NORMAL
    }, {
        "id": "2",
        "name": $scope.translation.text.SG_RETURN_TO_NORMAL
    }, {
        "id": "3",
        "name": $scope.translation.text.SG_OFF_NORMAL_RETURN_TO_NORMAL
    }];

    $scope.rtuDigitalMode = digitalMode;

    $scope.sortableOptions = {
        handle: ".sort-yes",
        items: "li:not(.not-sortable)",
        update: function update(e, ui) {
            $scope.oldIndex = [];
            for (var i = 0; i < $scope.notificationRules.length; ++i) {
                $scope.oldIndex.push({ ruleId: $scope.notificationRules[i].ruleId, index: i });
            }
            $scope.updateHappened = true;
        },
        stop: function stop(e, ui) {
            if (!$scope.updateHappened) return false;
            $scope.deviceListModelCopy = angular.copy($scope.deviceListModel);
            $scope.notificationGroupsModelCopy = angular.copy($scope.notificationGroupsModel);
            for (var i = 0; i < $scope.notificationRules.length - 1; ++i) {
                notificationRuleService.putData($scope.accountInfo.customerId, $scope.notificationRules[i].ruleId, $scope.notificationRules[i].name, $scope.notificationRules.length - 1 - i);
                $scope.deviceListModel[i] = $scope.deviceListModelCopy[$scope.getOldIndex($scope.notificationRules[i].ruleId)];
                $scope.notificationGroupsModel[i] = $scope.notificationGroupsModelCopy[$scope.getOldIndex($scope.notificationRules[i].ruleId)];
            }
            _restartBroadcast();
            $scope.updateHappened = false;
        }
    };

    $scope.getOldIndex = function (varRuleId) {
        for (var i = 0; i < $scope.oldIndex.length; i++) {
            if (parseInt(varRuleId) === $scope.oldIndex[i].ruleId) {
                return i;
            }
        }
        return 0;
    };

    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////

    $scope.getTextToTranslate = function () {
        $scope.textToTranslate = {
            checkAll: $scope.translation.text.CHECK_ALL,
            uncheckAll: $scope.translation.text.UNCHECK_ALL,
            selectionCount: $scope.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: $scope.translation.text.SEARCH + '...',
            buttonDefaultText: $scope.translation.text.SELECT,
            dynamicButtonTextSuffix: $scope.translation.text.CHECKED,
            buttonDefaultTextAllDevices: $scope.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: $scope.translation.text.ALL_INPUTS,
            dynamicButtonTextISSelected: $scope.translation.text.INPUT_STATES_SELECTED
        };

        $scope.languageChange = !$scope.languageChange;
    };

    $scope.$on('updateNotificationMode', function (event, msg) {
        ctrl.advancedMode = msg;
        ctrl.clearObjects();
        ctrl.nrsGetData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        $scope.getTextToTranslate();
    });

    $scope.languageChange = false;
    $scope.getTextToTranslate();

    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////

    $scope.openView = function (varRuleId) {
        if (ctrl.mobile) {
            var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
            optionsStickyProperties.deviceId = varRuleId;
            $location.path('/notification/notification-schedule-mobile');
        } else {
            var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
            optionsStickyProperties.deviceId = varRuleId;
            var position = $rootScope.classicView ? { my: 'top+80', at: 'center top', of: window } : { my: "left+" + 270 + " top+" + 50, at: "left top", of: window };
            openViewService.openView('Notification Schedule', { width: 645, height: 580 }, position, optionsStickyProperties, { minimumWidth: 645, minimumHeight: 480 }, $rootScope.classicView);
        }
    };

    $scope.deviceEvents = {
        onItemSelect: function onItemSelect(item) {
            var _targetRuleId = $scope.targetRuleId;
            notificationRuleDeviceService.postData($scope.accountInfo.customerId, _targetRuleId, item.id, null, null).then(function (data) {
                _restartBroadcast();
            }, function (error) {
                alert("Error");
            });
        },
        onItemDeselect: function onItemDeselect(item) {
            var _targetRuleId = $scope.targetRuleId;
            notificationRuleDeviceService.deleteData($scope.accountInfo.customerId, _targetRuleId, item.id, null, null).then(function (data) {
                _restartBroadcast();
            }, function (error) {
                alert("Error");
            });
        },
        onDeselectAll: function onDeselectAll(selectedModel) {
            var _targetRuleId = $scope.targetRuleId;
            for (var index = 0; index < selectedModel.length; ++index) {
                notificationRuleDeviceService.deleteData($scope.accountInfo.customerId, _targetRuleId, selectedModel[index].id, null, null).then(function (data) {
                    _restartBroadcast();
                }, function (error) {
                    alert("Error");
                });
            }
        }
    };

    $scope.inputEvents = {
        onItemSelect: function onItemSelect(item) {
            var url = HOST + "/api/Notifications/NotificationRuleInputState?customerID=" + $scope.accountInfo.customerId + "&ruleId=" + $scope.targetRuleId + "&GroupId=" + item.id; //?customerId=" + ctrl.accountInfo.customerId + "&inline=true" + "&reportDate=" + _tmpTestEventDate;
            $http.post(url).then(function (data) {
                _restartBroadcast();
            }, function (result) {
                alert("Error");
            });
        },
        onItemDeselect: function onItemDeselect(item) {
            var url = HOST + "/api/Notifications/NotificationRuleInputState?customerID=" + $scope.accountInfo.customerId + "&ruleId=" + $scope.targetRuleId + "&GroupId=" + item.id; //?customerId=" + ctrl.accountInfo.customerId + "&inline=true" + "&reportDate=" + _tmpTestEventDate;
            $http.delete(url).then(function (data) {
                _restartBroadcast();
            }, function (result) {
                alert("Error");
            });
        },
        onDeselectAll: function onDeselectAll(selectedModel) {
            var tmpModelGroups = [];
            var _targetRuleId = $scope.targetRuleId;
            if (selectedModel.length > 0) tmpModelGroups = [{ id: 1 }, { id: 250 }, { id: 251 }, { id: 253 }, { id: 254 }];
            for (var index = 0; index < tmpModelGroups.length; ++index) {
                //for (var index = 0; index < selectedModel.length; ++index)
                var url = HOST + "/api/Notifications/NotificationRuleInputState?customerID=" + $scope.accountInfo.customerId + "&ruleId=" + _targetRuleId + "&GroupId=" + tmpModelGroups[index].id; //?customerId=" + ctrl.accountInfo.customerId + "&inline=true" + "&reportDate=" + _tmpTestEventDate;
                $http.delete(url).then(function (data) {
                    _restartBroadcast();
                }, function (result) {
                    alert("Error");
                });
            }
        }
    };

    $scope.stateEvents = {
        onItemSelect: function onItemSelect(item) {
            notificationRuleDeviceService.postData($scope.accountInfo.customerId, $scope.targetRuleId, null, null, null, item.id).then(function (data) {
                _restartBroadcast();
            }, function (error) {
                alert("Error");
            });
        }
    };

    $scope.focusCallback = function (ruleid) {
        $scope.targetRuleId = ruleid;
    };

    $scope.checkIfUpdate = function (varItem, oldName, newName, varPriority) {
        if (oldName != newName && varItem.nameError === false) {
            notificationRuleService.putData($scope.accountInfo.customerId, $scope.targetRuleId, newName, varPriority).then(function (data) {
                _restartBroadcast();
            }, function (error) {
                alert("Error");
            });
        }
    };

    $scope.checkIfValid = function (varItem) {
        var varObj = $scope.isValidRuleName(varItem.name, varItem.ruleId);
        varItem.nameError = varObj.hasMatch;

        //if (!varObj.hasMatch) return;

        for (var index = 0; index < $scope.notificationRules.length; ++index) {
            var item = $scope.notificationRules[index];
            if (item === varItem && varObj.hasMatch) {
                item.disabled = false;
                $scope.validationError = true;
                //break;
            } else if (varObj.hasMatch) {
                item.disabled = true;
            } else {
                item.disabled = false;
                $scope.validationError = false;
            }
        }
    };

    $scope.isValidRuleName = function (name, ruleId) {
        var hasMatch = false,
            newPriority = 0;
        if (name.length <= 0) return { hasMatch: true, newPriority: newPriority };;
        for (var index = 0; index < $scope.notificationRules.length; ++index) {
            var item = $scope.notificationRules[index];
            newPriority = newPriority > item.priority ? newPriority : item.priority + 1;

            if (item.name === name && item.ruleId !== ruleId) {
                hasMatch = true;
                break;
            }
        }
        return { hasMatch: hasMatch, newPriority: newPriority };
    };

    $scope.undoChanges = function () {
        $(".tooltip-error-message").hide(100);
        //$(_element).parent().find(".tooltip-error-message").show(100);
    };

    $scope.deviceListSetting = {
        smartButtonMaxItems: 3,
        smartButtonTextConverter: function smartButtonTextConverter(itemText, originalItem) {
            return itemText;
        }
    };

    $scope.notificationGroupsSetting = {
        smartButtonMaxItems: 3,
        //showCheckAll: false,
        //showUncheckAll: false,
        smartButtonTextConverter: function smartButtonTextConverter(itemText, originalItem) {
            return itemText;
        }
    };

    $scope.add = function () {
        var _newRuleName,
            tmpNewRuleName = "",
            varObj = {};
        for (var i = 0; i <= 100; ++i) {
            tmpNewRuleName = tmpNewRuleName === "" ? $scope.translation.text.NEW_RULE : tmpNewRuleName + "_";
            varObj = $scope.isValidRuleName(tmpNewRuleName, 0);
            _newRuleName = varObj.hasMatch ? "" : tmpNewRuleName;
            if (_newRuleName != "") break;
        }
        if (_newRuleName == "") {
            alert("Error");
        } else {
            notificationRuleService.postData($scope.accountInfo.customerId, null, _newRuleName, varObj.newPriority).then(function (result) {
                $scope.notificationRules.unshift({
                    ruleId: result.data.ruleId,
                    name: result.data.name,
                    priority: result.data.priority,
                    coverage: 0,
                    title: '',
                    disabled: false,
                    nameError: false,
                    nameMessage: translationService.translation.text.DUPLICATE_RULE_NAME
                });
                $scope.notificationGroupsModel.unshift([]);
                $scope.deviceListModel.unshift([]);
                _restartBroadcast();
                ////When it was sorted the other way
                //var objDiv = element.parent().find(".tabular-data-container")[0];
                //$timeout(function () {
                //    objDiv.scrollTop = objDiv.scrollHeight;
                //}, 0);
            }, function (error) {
                alert("Error");
            });
        }
    };

    $scope.remove = function (index, ruleId) {
        modalService.confirmDelete('DELETE_RULE').then(function () {
            $http.delete(HOST + '/api/Notifications/NotificationRule?customerId=' + $scope.accountInfo.customerId + '&ruleId=' + ruleId).then(function (resp) {
                $scope.notificationRules.splice(index, 1);
                $scope.notificationGroupsModel.splice(index, 1);
                $scope.deviceListModel.splice(index, 1);
                _restartBroadcast();
            }, function (resp) {
                alert("Error");
            });
        }, function () {
            // Do nothing!
        });
    };

    ctrl.incompleteChangesCheck = function () {
        var incomplete = 0;
        $scope.notificationGroupsModel.map(function (item) {
            if (item.length == 0) incomplete++;
        });
        $scope.deviceListModel.map(function (item) {
            if (item.length == 0) incomplete++;
        });
        return incomplete != 0;
    };

    ctrl.nrsGetData = function () {
        ctrl.rulesBusy = true;
        notificationRuleService.getData($scope.accountInfo.customerId, null, true, true).then(function (dataFromFactory) {
            $scope.data = dataFromFactory.data;
            for (var index = 0; index < $scope.data.rules[0].devices.length; ++index) {
                $scope.deviceListData.push({
                    id: $scope.data.rules[0].devices[index].deviceId,
                    label: $scope.data.rules[0].devices[index].deviceName
                });
            }

            $scope.notificationGroupsData = []; //{ id: 1, label: "Alarms" }, { id: 2, label: "Comms" }, { id: 3, label: "Digital Fault" }, { id: 4, label: "Pump Start" }];
            var tmpGroupsData = [];
            for (var z = 0; z < $scope.data.rules[0].devices[0].inputStates.length; ++z) {
                if ($scope.data.rules[0].devices[0].inputStates[z].input !== 0) //data has an extra record - will talk to Jeff
                    tmpGroupsData.push({ id: $scope.data.rules[0].devices[0].inputStates[z].input, label: $scope.data.rules[0].devices[0].inputStates[z].description });
            }

            //if(!ctrl.advancedMode) $scope.notificationGroupsData = tmpGroupsData;   //-   OFF OFF OFF OFF OFF OFF OFF OFF OFF OFF OFF OFF OFF OFF OFF OFF
            $scope.notificationGroupsData = tmpGroupsData;

            for (var index = 0; index < $scope.data.rules.length; ++index) {
                var _tmpCoverage = ctrl.getCoverage($scope.data.rules[index].shifts);
                $scope.notificationRules.unshift({
                    ruleId: $scope.data.rules[index].ruleId,
                    name: $scope.data.rules[index].name,
                    priority: $scope.data.rules[index].priority,
                    coverage: _tmpCoverage[0].size,
                    title: ctrl.formatCoverageList(_tmpCoverage[1]),
                    disabled: false,
                    nameError: false,
                    nameMessage: translationService.translation.text.DUPLICATE_RULE_NAME

                });

                var tmp = [];
                for (var i = 0; i < $scope.data.rules[index].devices.length; ++i) {
                    if ($scope.data.rules[index].devices[i].deviceId != 0) //data has an extra record - will talk to Jeff
                        tmp.push({ id: $scope.data.rules[index].devices[i].deviceId });
                }
                $scope.deviceListModel.unshift(tmp);

                var tmpGroupsModel = [];

                if (ctrl.advancedMode === 2 && $scope.data.rules[index].ruleId !== 0) {
                    for (var z = 0; z < $scope.data.rules[index].inputsStates.length; ++z) {
                        tmpGroupsModel.push({ id: $scope.data.rules[index].inputsStates[z].inputId + '' + $scope.data.rules[index].inputsStates[z].stateId });
                    }
                } else {
                    for (var z = 0; z < $scope.data.rules[index].devices[0].inputStates.length; ++z) {
                        if ($scope.data.rules[index].devices[0].inputStates[z].input !== 0) //data has an extra record - will talk to Jeff
                            tmpGroupsModel.push({ id: $scope.data.rules[index].devices[0].inputStates[z].input });
                    }
                }
                $scope.notificationGroupsModel.unshift(tmpGroupsModel);
                ctrl.rulesBusy = false;
            }

            if (!ctrl.mobile && !ctrl.classicView) ctrl.adjustSize();
        }, function (error) {
            $scope.alerts = [];
            element.empty();
            $scope.loadingInProgress = false;
            var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
            $scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            ctrl.rulesBusy = false;
        });
    };

    $scope.$on('changeNotificationScheduleOrRule', function (event, msg) {
        if (Number.isInteger(msg)) ctrl.nrsGetCoverage(msg);
    });

    $scope.$on('removeNotificationDestination', function (event, msg) {
        for (var i = 0; i < msg.length; i++) {
            ctrl.nrsGetCoverage(msg[i].notificationRuleId);
        }
    });

    ctrl.nrsGetCoverage = function (varRuleId) {
        ctrl.rulesBusy = true;
        notificationRuleService.getDataCoverage($scope.accountInfo.customerId, varRuleId).then(function (dataFromFactory) {
            var _tmpCoverage = ctrl.getCoverage(dataFromFactory.data.rules[0].shifts);
            ctrl.nrsUpdateCoverage(varRuleId, _tmpCoverage);
            ctrl.rulesBusy = false;
        }, function (error) {
            $scope.alerts = [];
            element.empty();
            $scope.loadingInProgress = false;
            var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
            $scope.alerts.push({
                msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR"
            });
            ctrl.rulesBusy = false;
        });
    };

    ctrl.nrsUpdateCoverage = function (varRuleId, varCoverage) {
        for (var i = 0; i < $scope.notificationRules.length; ++i) {
            if ($scope.notificationRules[i].ruleId === varRuleId) {
                $scope.notificationRules[i].coverage = Array.from(varCoverage[0]).length;
                $scope.notificationRules[i].title = ctrl.formatCoverageList(varCoverage[1]);
                break;
            }
        }
    };

    ctrl.formatCoverageList = function (varCoverageList) {
        return varCoverageList.size > 0 ? $scope.translation.text.COVERAGE_SERVICE_USERS + '\r\n \u2022 ' + Array.from(varCoverageList).join('\r\n \u2022 ') : "";
    };

    var _startBroadcast;

    var _checkStartBroadcast = function _checkStartBroadcast() {
        // Don't start if already started
        if (angular.isDefined(_startBroadcast)) return;
        _startBroadcast = $timeout(function () {
            _startBroadcast = undefined; // will revisit this line of code (has to do with Alert())
            $rootScope.$broadcast('changeNotificationScheduleOrRule', true);
        }, 1000);
    };

    var _stop = function _stop() {
        if (angular.isDefined(_startBroadcast)) {
            $timeout.cancel(_startBroadcast);
            _startBroadcast = undefined;
        }
    };

    var _restartBroadcast = function _restartBroadcast() {
        if (angular.isDefined(_startBroadcast)) _stop();
        _checkStartBroadcast();
    };

    ctrl.getDeviceStringFromObj = function (varModel, varData) {
        var _str = "";
        var numberOfMatches = 0;

        for (var z = 0; z < $scope.deviceListData.length; ++z) {
            for (var i = 0; i < varModel.length; ++i) {
                if ($scope.deviceListData[z].id === varModel[i].id) {
                    numberOfMatches++;
                    _str = _str === "" ? $scope.deviceListData[z].label : _str + ", " + $scope.deviceListData[z].label;
                }
            }
        }
        return _str === "" ? $scope.translation.text.SELECT : numberOfMatches === $scope.deviceListData.length ? $scope.translation.text.ALL_DEVICES : _str;
    };

    ctrl.getGroupStringFromObj = function (varModel, varData) {
        var _str = "";
        var numberOfMatches = 0;
        if (ctrl.advancedMode === 2) return varModel.length === 0 ? $scope.translation.text.SELECT : $scope.translation.text.INPUT_STATES_SELECTED;

        for (var z = 0; z < $scope.notificationGroupsData.length; ++z) {
            for (var i = 0; i < varModel.length; ++i) {
                if ($scope.notificationGroupsData[z].id === varModel[i].id) {
                    numberOfMatches++;
                    _str = _str === "" ? $scope.notificationGroupsData[z].label : _str + ", " + $scope.notificationGroupsData[z].label;
                }
            }
        }

        return _str === "" ? $scope.translation.text.SELECT : numberOfMatches === $scope.notificationGroupsData.length ? $scope.translation.text.ALL_INPUTS : _str;
    };

    ctrl.getOffset = function (evt, varIndex, varData) {
        var offset = $(evt.target).offset();
        var varTmpElm = $($element).find(".tabular-data-container").find(".nsr_popup");
        if (!varTmpElm.find("ul").is(':visible')) {
            varTmpElm.css("top", offset.top + 25 + "px");
            if ($scope.lastClick === "closeNsrPopup") {
                $timeout(function () {
                    $(evt.target).trigger("click");
                    $(evt.target).focus();
                }, 0);
            }
        }
        $scope.lastClick = "getOffset";
    };

    ctrl.getCoverage = function (obj) {
        var ids = new Set();
        var names = new Set();
        angular.forEach(obj, function (parent) {
            angular.forEach(parent.destinations, function (child) {
                if (child.onDuty && !child.disabled) {
                    ids.add(child.serviceUserId);
                    names.add(child.firstName + ' ' + child.lastName);
                }
            });
        });
        return [ids, names];
    };

    ctrl.closeNsrPopup = function (varIndex, varData) {
        //if(ctrl.activeIndex !== varIndex + varData) $($element).find(".tabular-data-container").find(".nsr_popup").find("ul").css("display", "none");
        ctrl.activeIndex = varIndex + varData;
        $scope.lastClick = "closeNsrPopup";
    };

    $scope.$on("$destroy", function () {
        if (angular.isDefined(_startBroadcast)) {
            $timeout.cancel(_startBroadcast);
        }

        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });
};

NotificationRulesController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'notificationRuleService', 'notificationRuleDeviceService', 'notificationRuleScheduleService', '$timeout', '$filter', 'toaster', '$uibModal', 'HOST', '$http', '$interval', '$element', 'modalService', 'wizardSplashService', 'unsavedChangesService', '$location'];
'use strict';

angular.module('mc.notification-rules').component('notificationRulesComp', {
    controller: NotificationRulesController,
    transclude: true,
    templateUrl: 'ui/notification/notificationrules/notification-rules-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
// Nothing here on purpose
"use strict";
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function PumpCapacityTableController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, timeLapseService, openViewService, toaster, $timeout, $filter, $element) {
    var _this2 = this;

    var ctrl = this;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
    $scope.MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
    $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.preferredMeasurementFormat = $scope.accountInfo.preferenceUser.lookupMeasurementID;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.alerts = [];
    ctrl.loadingInProgress = true;

    ctrl.volumeUnitLabel = $scope.preferredMeasurementFormat === 1 ? $scope.translation.text.PUMP_GALLONS : $scope.translation.text.PUMP_LITERS;
    ctrl.volumeUnitLableAbr = ctrl.volumeUnitLabel.substring(0, 3);
    ctrl.pumpCapacityTable = [];
    ctrl.pumpCapacityTableHeader = [];
    ctrl.pumpRowWidth = 0;

    ctrl.reverse = true;
    ctrl.predicate = '';

    sharedSetupService.broadcastAllDeviceSelected($scope);

    $scope.openView = openViewService.openView;

    // Delete the table if the device is changed
    ctrl.$onChanges = function (changes) {
        if (changes.deviceSelected && changes.deviceSelected.currentValue && isNaN(changes.deviceSelected.previousValue) === false && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
            ctrl.pumpCapacityTable = null;
            ctrl.pumpCapacityData = null;
            ctrl.pumpTopTable = null;
            ctrl.pumpCapacityTableHeader = null;
        }
    };

    this.$onInit = function () {
        $scope.windowId = _this2.windowId;
        $scope.windowTitle = _this2.windowTitle;
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        $scope.deviceSelected = _this2.deviceSelected;
        $scope.stickyProperties = _this2.stickyProperties;
        ctrl.pumpTopTable = _this2.pumpTopTable;
        ctrl.pumpCapacityData = _this2.pumpCapacityData;

        ctrl.loadingInProgress = true;

        ctrl.pumpTopTable.forEach(function (setting) {
            if (setting.enabled === true) {
                var head = {};
                head["channel"] = setting.channel;
                head["description"] = setting.description;
                ctrl.pumpCapacityTableHeader.push(head);
            }
        });

        ctrl.pumpCapacityData.pumpMeasurements.forEach(function (setting) {
            var pump = {};
            pump["localDateTime"] = setting.localDateTime;
            pump["totalVolume"] = setting.totalVolume;
            pump["percentDesign"] = setting.percentDesign;
            pump["remainingVolume"] = setting.remainingVolume;
            pump["warning"] = setting.warning;
            var i = void 0;
            for (i = 0; i < setting.volume.length; i++) {
                pump["volume" + setting.volume[i].channel] = setting.volume[i].value;
            }
            ctrl.pumpCapacityTable.push(pump);
        });

        ctrl.pumpRowWidth = 86 / (ctrl.pumpCapacityTableHeader.length + 3);
        ctrl.pumpRowWidth = ctrl.pumpRowWidth + '%';

        sharedSetupService.getWindowId($scope);

        ctrl.loadingInProgress = false;

        // maximize view if on desktop
        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);
        }

        //element.attr("class", "chart");

        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        // Triggered when the calendar date is changed, need to get new data from the API
        $scope.selectMyDateC = function () {
            //const tmpDates = $scope.myDate;

            //getDataFromApiForDates($scope.deviceSelected, tmpDates);
        };

        var orderBy = $filter('orderBy');

        ctrl.order = function (predicate, reverse) {
            ctrl.pumpCapacityTable = orderBy(ctrl.pumpCapacityTable, predicate, reverse);
            ctrl.predicate = predicate;
        };

        ctrl.setSorting = function () {
            scope.order('loginTimeSort', scope.reverse);
        };

        // #region SETTINGS CHANGE

        // #endregion SETTINGS CHANGE

        $scope.$on('updatePreferencesLanguage', function () {
            if ($scope.alerts.length === 0) {
                ctrl.volumeUnitLabel = $scope.preferredMeasurementFormat === 1 ? $scope.translation.text.PUMP_GALLONS : $scope.translation.text.PUMP_LITERS;
                ctrl.volumeUnitLableAbr = ctrl.volumeUnitLabel.substring(0, 3);
            }
        });

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            $scope.applyTimeFormat(timeFormat);
        });

        $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            ctrl.pumpCapacityTable = null;
            ctrl.pumpCapacityData = null;
            ctrl.pumpTopTable = null;
            ctrl.pumpCapacityTableHeader = null;
        });

        $scope.applyTimeFormat = function (timeFormat) {
            $scope.preferredTimeFormat = parseInt(timeFormat);
        };

        $scope.$on("$destroy", function () {
            ctrl.pumpCapacityTable = null;
            ctrl.pumpCapacityData = null;
            ctrl.pumpTopTable = null;
            ctrl.pumpCapacityTableHeader = null;
        });
    };
};

PumpCapacityTableController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'datetimeService', 'timeLapseService', 'openViewService', 'toaster', '$timeout', '$filter', '$element'];
"use strict";

angular.module("mc.pump-capacity-estimator", []);
'use strict';

angular.module('mc.pump-capacity-estimator').component('pumpCapacityTable', {
    controller: PumpCapacityTableController,
    templateUrl: 'ui/pump/capacityestimator/pump-capacity-table-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        pumpTopTable: '<',
        pumpCapacityData: '<'
    }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PumpCapacityEstimatorFactory(HOST, $http) {
    // instantiate our initial object
    var pumpCapacityEstimator = function () {
        function pumpCapacityEstimator(customerId, deviceId, designCapacity, startDate, endDate, pumpSettings) {
            _classCallCheck(this, pumpCapacityEstimator);

            this.customerId = customerId;
            this.deviceId = deviceId;
            this.startDate = startDate;
            this.endDate = endDate;
            this.designCapacity = designCapacity;
            this.pumpSettings = pumpSettings;
        }

        // Get pump capacity data from the REST API.  Using POST instead of GET to send pump capacity settings


        _createClass(pumpCapacityEstimator, [{
            key: 'getData',
            value: function getData() {
                var self = this;
                return $http.post(HOST + '/api/PumpCapacityEstimator?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&designCapacity=' + this.designCapacity + '&startDate=' + this.startDate + '&endDate=' + this.endDate, this.pumpSettings).then(function (response) {
                    self.data = response;
                    self.loading = false;
                    return response;
                });
            }
        }]);

        return pumpCapacityEstimator;
    }();

    return pumpCapacityEstimator;
}

PumpCapacityEstimatorFactory.$inject = ['HOST', '$http'];

angular.module('mc.pump-capacity-estimator').factory('PumpCapacityEstimatorFactory', PumpCapacityEstimatorFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function PumpCapacityEstimatorController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, deviceService, pumpSettingService, PumpCapacityEstimatorFactory, timeLapseService, openViewService, toaster, $timeout, $filter, $element) {
    var _this2 = this;

    var ctrl = this;
    sharedSetupService.getWindowId(ctrl);
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
    $scope.MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
    $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.preferredMeasurementFormat = $scope.accountInfo.preferenceUser.lookupMeasurementID;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.alerts = [];
    ctrl.loadingInProgress = true;
    $scope.downloadViewTypeOptions = [1]; //[0, 1];
    ctrl.deviceId = 0;
    ctrl.pumpTopTable = [];
    ctrl.pumpCapacityData = {};
    ctrl.designCapacity = null;
    ctrl.startDate = new Date();
    ctrl.endDate = new Date();
    ctrl.capacityUnitLabel = $scope.preferredMeasurementFormat === 1 ? $scope.translation.text.GALLONS_PER_MINUTE : $scope.translation.text.LITERS_PER_SECOND;
    ctrl.designUnitLabel = $scope.preferredMeasurementFormat === 1 ? $scope.translation.text.GALLONS_PER_DAY : $scope.translation.text.LITERS_PER_DAY;
    ctrl.noDataAlert = '';
    ctrl.noPumpEnableAlert = '';
    ctrl.noPumpCapacityAlert = '';
    ctrl.chart = null; // needed for printing

    ctrl.maxHeight = '800px';

    ctrl.gpmToLps = $scope.preferredMeasurementFormat === 1 ? 1.0 : 0.0630902; // Gallons per Minute to Liters per Second multiplier

    sharedSetupService.broadcastAllDeviceSelected($scope);

    $scope.openView = openViewService.openView;

    if ($scope.classicView && $element.parent('div').parent('div').parent('div').attr('class') && $element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") == 0) {
        $scope.largeChart = true;
        $element.height(700);
    }

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.fnChangeLanguage = function () {
        if ($scope.alerts.length > 0) {
            var _msg = eval('$scope.translation.message.' + $scope.alerts[0].languageCode.toUpperCase());
            var _type = $scope.alerts[0].type;
            var _languageCode = $scope.alerts[0].languageCode;
            if (_languageCode.toUpperCase() === 'NO_DATA') {
                _msg += ': ' + moment($scope.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
            }
            $scope.alerts = [];
            $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        }
    };

    this.$onInit = function () {
        $scope.windowId = _this2.windowId;
        $scope.windowTitle = _this2.windowTitle;
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        $scope.deviceSelected = _this2.deviceSelected;
        $scope.stickyProperties = _this2.stickyProperties;
        sharedSetupService.getWindowId($scope);

        // maximize view if on desktop
        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);
        }

        // #region ADJUST SIZE

        // Adjust the chart size of the window changes
        $(window).on("resize", function () {
            setTimeout(function () {
                adjustSize();
            }, 1000);
        });
        $(window).trigger('resize');

        // Adjust the chart size
        var adjustSize = function adjustSize() {
            var desktopHeight = void 0;

            if (!$rootScope.mobile && !$rootScope.classicView) {
                desktopHeight = $('.desktop-html:visible').height();

                if (!desktopHeight) desktopHeight = (window.innerHeight || document.body.clientHeight) - 36;

                ctrl.maxHeight = desktopHeight >= 600 ? desktopHeight - 20 : desktopHeight - 50;
            } else {
                desktopHeight = $('.content-classic:visible').height();

                if (!desktopHeight) desktopHeight = (window.innerHeight || document.body.clientHeight) - (36 + 64 + 27);

                ctrl.maxHeight = desktopHeight >= 600 ? desktopHeight - 20 : desktopHeight - 40;
            }

            ctrl.maxHeight = Math.round(ctrl.maxHeight) + 'px';
        };

        // #endregion ADJUST SIZE

        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        ctrl.noDataAlert = '';
        ctrl.noPumpEnableAlert = '';
        ctrl.noPumpCapacityAlert = '';

        // #region REST API

        // Get DeviceLookup from the REST API
        var getDeviceFromApi = function getDeviceFromApi() {
            ctrl.pumpTopTable = [];
            deviceService.getDeviceLookup($scope.accountInfo.customerId, ctrl.deviceId).then(function (datafromFactory) {
                var device = datafromFactory.data;
                $scope.alerts = [];

                if (!device || device.type !== 9 && device.type !== 19 && device.type !== 21) {
                    var errormsg = $scope.translation.message.NO_PUMP_ESTIMATOR;
                    $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_PUMP_ESTIMATOR" });
                } else {
                    getPumpSettingsFromApi();
                }
            }, function (error) {
                $scope.alerts = [];
                var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            }).then(function (data) {
                ctrl.loadingInProgress = false;
            });
        };

        var getPumpSettingsFromApi = function getPumpSettingsFromApi() {
            pumpSettingService.getData($scope.accountInfo.customerId, $scope.accountInfo.timeZone, ctrl.deviceId).then(function (datafromFactory) {
                var pumpSettings = datafromFactory.data;
                $scope.alerts = [];

                if (pumpSettings && pumpSettings.length > 0) {
                    pumpSettings.forEach(function (setting) {
                        var pump = {};
                        pump["enabled"] = true;
                        pump["channel"] = setting.channel;
                        pump["description"] = setting.description;
                        pump["model"] = setting.model;
                        pump["pumpCapacity"] = Math.round(setting.pumpCapacity * ctrl.gpmToLps * 100) / 100;
                        ctrl.pumpTopTable.push(pump);
                    });
                    // Top Table is now visible

                    initDates();
                } else {
                    var errormsg = $scope.translation.message.NO_PUMP_SETUP;
                    $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_PUMP_SETUP" });
                }
            }, function (error) {
                $scope.alerts = [];
                //element.empty();
                var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            }).then(function (data) {
                ctrl.loadingInProgress = false;
            });
        };

        var getPumCapacityEstimateFromApi = function getPumCapacityEstimateFromApi() {
            ctrl.endDate.setHours(0, 0, 0, 0);
            ctrl.startDate.setHours(0, 0, 0, 0);
            var unixStartDate = datetimeService.dateToUnixtime(ctrl.startDate);
            var unixEndDate = datetimeService.dateToUnixtime(ctrl.endDate);

            var pumpCapacityEstimator = new PumpCapacityEstimatorFactory($scope.accountInfo.customerId, ctrl.deviceId, ctrl.designCapacity, unixStartDate, unixEndDate, ctrl.pumpTopTable);

            pumpCapacityEstimator.getData().then(function () {
                ctrl.pumpCapacityData = pumpCapacityEstimator.data.data;
                $scope.alerts = [];

                if (ctrl.pumpCapacityData && ctrl.pumpCapacityData.pumpMeasurements && ctrl.pumpCapacityData.pumpMeasurements.length > 0) {
                    ctrl.noDataAlert = '';
                } else {
                    // Display NO DATA alert
                    ctrl.noDataAlert = eval('$scope.translation.message.NO_DATA');
                    ctrl.noDataAlert += ': ' + moment(unixStartDate).utc().format('MM/DD/YY') + ' - ' + moment(unixEndDate).utc().format('MM/DD/YY');
                }
            }, function (error) {
                $scope.alerts = [];
                //element.empty();

                var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            }).then(function (data) {
                ctrl.loadingInProgress = false;
            });
        };

        // #endregion REST API

        // Adjust start and end dates - they are not related to sticky properties
        var initDates = function initDates() {
            timeLapseService.getLocalDateTime().then(function (result) {
                ctrl.endDate = new Date(result.data.localDateTime);
            });

            ctrl.endDate.setHours(0, 0, 0, 0);

            ctrl.startDate = new Date(new Date().setDate(new Date().getDate() - 90));
            ctrl.startDate.setHours(0, 0, 0, 0);
        };

        // Calculate button that draws the pump table and pump chart
        ctrl.calculate = function () {
            ctrl.loadingInProgress = true;
            ctrl.pumpCapacityData = null;

            ctrl.noPumpEnableAlert = eval('$scope.translation.text.ERROR_CAPACITY_ESTIMATOR_NO_PUMP');
            ctrl.noPumpCapacityAlert = eval('$scope.translation.text.ERROR_CAPACITY_ESTIMATOR_NO_CAPACITY');

            ctrl.pumpTopTable.forEach(function (pump) {
                if (pump.enabled === true) ctrl.noPumpEnableAlert = '';
                if (pump.enabled === true && pump.pumpCapacity > 0 && !isNaN(pump.pumpCapacity)) ctrl.noPumpCapacityAlert = '';
            });

            if (ctrl.noPumpEnableAlert.length > 1) ctrl.noPumpCapacityAlert = ''; // only show one alert at a time

            if (ctrl.noPumpEnableAlert === '' && ctrl.noPumpCapacityAlert === '' && !isNaN(ctrl.designCapacity)) {
                getPumCapacityEstimateFromApi();
            } else {
                ctrl.loadingInProgress = false;
            }
        };

        // Check that the end date is not before the start date
        ctrl.checkEndDate = function () {
            ctrl.endDate = ctrl.endDate < ctrl.startDate ? ctrl.startDate : ctrl.endDate;
        };

        // Check that the start date is not after the end date
        ctrl.checkStartDate = function () {
            ctrl.startDate = ctrl.endDate < ctrl.startDate ? ctrl.endDate : ctrl.startDate;
        };

        ctrl.checkIfValid = function ($event, value) {
            var strValue = null;
            if (!angular.isUndefined(value) && value !== null) strValue = value.toString();

            if (isNaN(String.fromCharCode($event.charCode)) && $event.charCode !== 46 || $event.charCode === 46 && strValue && strValue.indexOf(".") > -1) {
                $event.preventDefault();
            }
        };

        // #region SETTINGS CHANGE

        // Triggered when first opening the table or when changing the device while the table is open
        $scope.$watch('deviceSelected', function (newDeviceId, oldDeviceId) {
            if (newDeviceId) {
                ctrl.loadingInProgress = true;
                ctrl.deviceId = newDeviceId;
                getDeviceFromApi();
            }
        }, true);

        $scope.$on('updatePreferencesLanguage', function () {
            if ($scope.alerts.length === 0) {
                ctrl.capacityUnitLabel = $scope.preferredMeasurementFormat === 1 ? $scope.translation.text.GALLONS_PER_MINUTE : $scope.translation.text.LITERS_PER_SECOND;
                ctrl.designUnitLabel = $scope.preferredMeasurementFormat === 1 ? $scope.translation.text.GALLONS_PER_DAY : $scope.translation.text.LITERS_PER_DAY;
            }
            $scope.fnChangeLanguage();
        });

        $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            switch (measurementSystem) {
                case $scope.MeasurementSystemEnum.Imperial:
                    ctrl.capacityUnitLabel = $scope.translation.text.GALLONS_PER_MINUTE;
                    ctrl.designUnitLabel = $scope.translation.text.GALLONS_PER_DAY;
                    ctrl.gpmToLps = 1.0;
                    break;
                case $scope.MeasurementSystemEnum.Metric:
                    ctrl.capacityUnitLabel = $scope.translation.text.LITERS_PER_SECOND;
                    ctrl.designUnitLabel = $scope.translation.text.LITERS_PER_DAY;
                    ctrl.gpmToLps = 0.0630902;
                    break;
            }

            ctrl.pumpCapacityData = null;
            ctrl.pumpTopTable = null;
            ctrl.designCapacity = null;

            ctrl.loadingInProgress = true;
            getDeviceFromApi();
        });

        $scope.applyTimeFormat = function (timeFormat) {
            $scope.preferredTimeFormat = parseInt(timeFormat);
        };

        // #endregion SETTINGS CHANGE

        $scope.$on("$destroy", function () {
            ctrl.pumpCapacityData = null;
            ctrl.pumpTopTable = null;
        });
    };
};

PumpCapacityEstimatorController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'datetimeService', 'deviceService', 'pumpSettingService', 'PumpCapacityEstimatorFactory', 'timeLapseService', 'openViewService', 'toaster', '$timeout', '$filter', '$element'];
'use strict';

angular.module('mc.pump-capacity-estimator').component('pumpCapacityEstimator', {
    controller: PumpCapacityEstimatorController,
    templateUrl: 'ui/pump/capacityestimator/pump-capacity-estimator-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
// Nothing here on purpose
"use strict";
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function PumpCapacityChartController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, timeLapseService, openViewService, rainfallDataChartFactory, toaster, $timeout, $filter, $element) {
    var _this2 = this;

    var ctrl = this;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
    $scope.MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
    $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.preferredMeasurementFormat = $scope.accountInfo.preferenceUser.lookupMeasurementID;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.alerts = [];
    ctrl.loadingInProgress = true;

    ctrl.volumeUnitLabel = $scope.preferredMeasurementFormat === 1 ? $scope.translation.text.PUMP_GALLONS : $scope.translation.text.PUMP_LITERS;
    ctrl.volumeUnitLableAbr = ctrl.volumeUnitLabel.substring(0, 3);
    ctrl.rainUnits = $scope.preferredMeasurementFormat === 1 ? $scope.translation.text.INCHES : $scope.translation.text.CENTIMETERS;

    var inchToCm = 2.54; // Inches to centimeters multiplier for rainfall data

    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    var chart = void 0;
    var seriesCount = 0;
    var chartObject = void 0;
    var containerId = null;

    var rainData = [];

    sharedSetupService.broadcastAllDeviceSelected($scope);

    $scope.openView = openViewService.openView;

    // Delete the chart if the device is changed
    ctrl.$onChanges = function (changes) {
        if (changes.deviceSelected && changes.deviceSelected.currentValue && isNaN(changes.deviceSelected.previousValue) === false && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
            ctrl.pumpCapacityData = null;
            ctrl.pumpTopTable = null;
            ctrl.designCapacity = null;
            if (chart && typeof chart.destroy === "function") chart.destroy();
        }
    };

    this.$onInit = function () {
        $scope.windowId = _this2.windowId;
        $scope.windowTitle = _this2.windowTitle;
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        ctrl.deviceSelected = _this2.deviceSelected;
        $scope.stickyProperties = _this2.stickyProperties;
        ctrl.pumpTopTable = _this2.pumpTopTable;
        ctrl.pumpCapacityData = _this2.pumpCapacityData;
        ctrl.designCapacity = _this2.designCapacity;

        var timeout = isFirefox ? 2000 : 1000;

        var chartColors = ["#2288cc", "#dd3322", "#22aa99", "#bb4488", "#ddaa00", "#6655cc", "#99aa00", "#dd7722", "#058dc7", "#50b432", "#ed561b", "#dddf00", "#24cbe5", "#64e572", "#ff9655", "#fff263", "#6af9c4"];
        var totalId = 14;
        var designCapacityId = 9;
        var rainfallId = 12;

        var element = $element.find(".pump-capacity-chart-container");

        element.attr("class", "chart");

        ctrl.loadingInProgress = true;

        sharedSetupService.getWindowId($scope);

        // maximize view if on desktop
        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    adjustSize();
                }
            });
        }

        //element.attr("class", "chart");

        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        // #region REST API

        // Get Rainfall from the REST API
        var getRainfallFromApi = function getRainfallFromApi() {
            var startDate = ctrl.pumpCapacityData.pumpMeasurements[ctrl.pumpCapacityData.pumpMeasurements.length - 1].localDateTime;
            var unixStartDate = datetimeService.strToUnixtime(startDate);

            var endDate = ctrl.pumpCapacityData.pumpMeasurements[0].localDateTime;
            var unixEndDate = datetimeService.strToUnixtime(endDate);

            var rainfallDataChart = new rainfallDataChartFactory($scope.accountInfo.customerId);

            rainfallDataChart.fetchData(ctrl.deviceId, unixStartDate, unixEndDate).then(function (response) {
                // Only seed series[0] because that is rain
                if (response && response.data && response.data.seriesData && response.data.seriesData[0].length > 0) {
                    response.data.seriesData[0].forEach(function (data) {
                        if ($scope.preferredMeasurementFormat !== 1) {
                            if (data.length > 1) {
                                data[1] = data[1] * inchToCm;
                            }
                        }
                        rainData.push(data);
                    });
                }
            }, function (error) {
                $scope.alerts = [];
                //element.empty();
                var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            }).then(function (data) {
                containerId = null;
                drawChart();
            });
        };

        getRainfallFromApi();

        // #endregion REST API

        // #region ADJUST CHART SIZE

        // Adjust the chart size of the window changes
        $(window).on("resize", function () {
            setTimeout(function () {
                adjustSize();
            }, timeout);
        });
        $(window).trigger('resize');

        // Adjust the chart size
        var adjustSize = function adjustSize() {
            if (!$rootScope.mobile && !$rootScope.classicView) openViewService.adjustContentSize($scope.popup);

            if (chartObject && chartObject.container) {
                if (containerId === null || containerId === chartObject.container.id) {
                    containerId = chartObject.container.id;

                    $("#" + chartObject.container.id).parent("div").css("height", getContainerHeight(element[0].style.height));
                    chartObject.reflow();

                    if (isFirefox && !$rootScope.classicView) {
                        $("#" + chartObject.container.id).parent("div").height(function (index, height) {
                            return height + 1;
                        });
                    }
                }
            } else {
                if (chart && chart.container) {
                    $("#" + chart.container.id).parent("div").css("height", getContainerHeight(element[0].style.height));
                    chart.reflow();
                }
            }
        };

        // Determine the size of the chart container
        function getContainerHeight(height) {
            var pumpTopRows = ctrl.pumpTopTable.length > 3 ? 3 : ctrl.pumpTopTable.length;
            var startingHeight = $rootScope.classicView ? 200 : 205;
            var initHeight = startingHeight + 30 * pumpTopRows;
            var extraLegend = 15;

            height = parseInt(height);

            // Needed for classic view since it does not have element[0]
            if (isNaN(height) || height < 250 || $rootScope.classicView) {
                var windowHeight = window.innerHeight || document.body.clientHeight;
                height = windowHeight - 240;
            }

            if (seriesCount > 5) {
                height = height - initHeight - extraLegend;
            } else {
                height = height - initHeight;
            }

            if (height < 225) height = 225;

            return height + "px";
        };

        // #endregion ADJUST CHART SIZE

        // #region DRAW CHART

        // Draw the pump capacity chart
        var drawChart = function drawChart() {
            var series = getSeries();

            chart = new Highcharts.StockChart({
                credits: {
                    enabled: false
                },
                legend: {
                    enabled: true,
                    backgroundColor: '#f9f9f9',
                    borderColor: '#cccccc',
                    borderWidth: 1
                },
                boost: {
                    enabled: true,
                    useGPUTranslations: false // do not use for timestamps
                },
                chart: {
                    renderTo: element[0],
                    backgroundColor: '#ebebeb',
                    plotBackgroundColor: '#f9f9f9',
                    borderColor: '#d3d3d3',
                    borderWidth: 1,
                    borderRadius: 2,
                    plotBorderWidth: 1,
                    marginTop: 10,
                    marginRight: 10,
                    marginLeft: rainData && rainData.length > 0 ? 130 : 80,
                    spacingBottom: 10,
                    spacingTop: 0,
                    spacingLeft: 2,
                    spacingRight: 5,
                    animation: false,
                    reflow: true,
                    events: {
                        load: function load(e) {
                            if (this.options.chart.forExport) return false;
                            if (this.container) {
                                seriesCount = series.length;
                                chartObject = this;
                                return adjustSize();
                            } else {
                                return null;
                            }
                        }
                    }
                },
                title: {
                    text: null
                },
                subtitle: {
                    text: null
                },
                exporting: {
                    enabled: true,
                    buttons: {
                        contextButton: {
                            enabled: false
                        }
                    }
                },
                xAxis: {
                    type: 'datetime',
                    showLastLabel: true,
                    startOnTick: false,
                    ordinal: false,
                    minorGridLineColor: '#ebebeb',
                    minorTickInterval: 'auto'
                },
                yAxis: getYaxis(),
                tooltip: {
                    useHTML: true,
                    formatter: function formatter() {
                        var s = '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                        s += "<tr><td colspan=\"2\" style=\"color: #000000; padding-bottom: 3px;\">" + Highcharts.dateFormat('%A, %b %e, %Y ', this.x) + "</td></tr>";
                        $.each(this.points, function (i, point) {
                            var numDecimals = point.series.color === chartColors[rainfallId] ? 2 : 0;
                            s += "<tr><td style=\"color: " + point.series.color + ";\">" + point.series.name + ": </td><td style=\"text-align: right; color: #000000; font-weight: bold;\">" + Highcharts.numberFormat(point.y, numDecimals) + "</td></tr>";
                        });
                        s += '</table>';
                        return s;
                    },

                    crosshairs: true,
                    shared: true,
                    valueDecimals: 1,
                    backgroundColor: '#FFFFFF',
                    borderColor: 'gray',
                    borderWidth: 1
                },
                navigator: {
                    enabled: false
                },
                scrollbar: {
                    enabled: false
                },
                rangeSelector: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        softThreshold: false,
                        dataGrouping: {
                            enabled: false
                        },
                        visible: true,
                        connectEnds: false,
                        marker: {
                            fillColor: '#FFFFFF',
                            lineWidth: 2,
                            lineColor: null // inherit from series
                        }
                    }
                },
                series: series
            });

            ctrl.chart = chart;
            ctrl.loadingInProgress = false;
        };

        // Create pump data series to be displayed
        function getSeries() {
            var series = [];

            // Add individual pumps
            ctrl.pumpTopTable.forEach(function (setting) {
                if (setting.enabled === true) {
                    var pump = { data: [], name: setting.description + ' (' + ctrl.volumeUnitLabel + ')', id: setting.channel - 1, type: 'line', boostThreshold: 2000, connectEnds: false, marker: { enabled: false }, color: chartColors[setting.channel - 1], yAxis: 0 };

                    var j = void 0;
                    for (j = ctrl.pumpCapacityData.pumpMeasurements.length - 1; j >= 0; j--) {
                        var measure = ctrl.pumpCapacityData.pumpMeasurements[j];
                        var i = void 0;
                        for (i = 0; i < measure.volume.length; i++) {
                            if (measure.volume[i].channel === setting.channel) {
                                var point = [datetimeService.strToUnixtime(measure.localDateTime), measure.volume[i].value];
                                pump.data.push(point);
                            }
                        }
                    }

                    series.push(pump);
                }
            });

            var total = { data: [], name: $scope.translation.text.TOTAL + ' (' + ctrl.volumeUnitLabel + ')', id: totalId, type: 'line', boostThreshold: 2000, connectEnds: false, marker: { enabled: false }, color: chartColors[totalId], yAxis: 0 };

            // Add total pumps
            var k = void 0;
            for (k = ctrl.pumpCapacityData.pumpMeasurements.length - 1; k >= 0; k--) {
                var measure = ctrl.pumpCapacityData.pumpMeasurements[k];

                var point = [datetimeService.strToUnixtime(measure.localDateTime), measure.totalVolume];
                total.data.push(point);
            }

            series.push(total);

            // Add rain if any
            if (rainData && rainData.length > 0) {
                var rain = {
                    data: rainData,
                    name: $scope.translation.text.RAINFALL + ' (' + ctrl.rainUnits + ')',
                    id: rainfallId,
                    type: 'line',
                    boostThreshold: 2000,
                    connectEnds: false,
                    marker: { enabled: false },
                    color: chartColors[rainfallId],
                    yAxis: 1
                };
                series.push(rain);
            }

            return series;
        }

        function getYaxis() {
            var yAxis = [];

            var flowYaxis = {
                showEmpty: false,
                allowDecimals: false,
                gridLineWidth: 0,
                gridLineColor: "#dedede",
                opposite: false,
                startOnTick: true,
                endOnTick: true,
                min: 0,
                lineWidth: 2,
                lineColor: chartColors[totalId],
                title: {
                    text: $scope.translation.text.FLOW + ' (' + ctrl.volumeUnitLabel + ')',
                    style: {
                        color: chartColors[totalId]
                    }
                },
                plotLines: [{
                    value: ctrl.designCapacity,
                    color: chartColors[designCapacityId],
                    dashStyle: 'shortdash',
                    width: 2,
                    label: {
                        text: $scope.translation.text.DESIGN_CAPACITY
                    }
                }]
            };

            yAxis.push(flowYaxis);

            if (rainData && rainData.length > 0) {
                var rainYaxis = {
                    showEmpty: false,
                    gridLineWidth: 0,
                    gridLineColor: "#dedede",
                    opposite: false,
                    startOnTick: true,
                    endOnTick: true,
                    min: 0,
                    lineWidth: 2,
                    lineColor: chartColors[rainfallId],
                    title: {
                        text: $scope.translation.text.RAINFALL + ' (' + ctrl.rainUnits + ')',
                        style: { color: chartColors[rainfallId] }
                    },
                    labels: {
                        format: "{value:.2f}"
                    }
                };

                yAxis.push(rainYaxis);
            }

            return yAxis;
        }

        // #endregion DRAW CHART

        // #region SETTINGS CHANGE

        // #endregion SETTINGS CHANGE

        $scope.$on('updatePreferencesLanguage', function () {
            if ($scope.alerts.length === 0) {
                ctrl.volumeUnitLabel = $scope.preferredMeasurementFormat === 1 ? $scope.translation.text.PUMP_GALLONS : $scope.translation.text.PUMP_LITERS;
                ctrl.volumeUnitLableAbr = ctrl.volumeUnitLabel.substring(0, 3);
                ctrl.rainUnits = $scope.preferredMeasurementFormat === 1 ? $scope.translation.text.INCHES : $scope.translation.text.CENTIMETERS;

                containerId = null;
                drawChart();
            }
        });

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            $scope.applyTimeFormat(timeFormat);
            if ($scope.alerts.length === 0) {
                containerId = null;
                drawChart();
            }
        });

        $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            ctrl.pumpCapacityData = null;
            ctrl.pumpTopTable = null;
            ctrl.designCapacity = null;
            if (chart && typeof chart.destroy === "function") chart.destroy();
        });

        $scope.applyTimeFormat = function (timeFormat) {
            $scope.preferredTimeFormat = parseInt(timeFormat);
        };

        $scope.$on("$destroy", function () {
            ctrl.pumpCapacityData = null;
            ctrl.pumpTopTable = null;
            ctrl.designCapacity = null;
            if (chart && typeof chart.destroy === "function") chart.destroy();
        });
    };
};

PumpCapacityChartController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'datetimeService', 'timeLapseService', 'openViewService', 'rainfallDataChartFactory', 'toaster', '$timeout', '$filter', '$element'];
'use strict';

angular.module('mc.pump-capacity-estimator').component('pumpCapacityChart', {
    controller: PumpCapacityChartController,
    templateUrl: 'ui/pump/capacityestimator/pump-capacity-chart-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        pumpTopTable: '<',
        pumpCapacityData: '<',
        designCapacity: '<',
        chart: '='
    }
});
angular.module("mc.migrate-notification", []);
function MigrateNotificationFactory(HOST, $http) {

    // instantiate our initial object
    var MigrationManager = function (customerId) {
        this.customerId = customerId;
        this.status = null;
    };

    // define the getProfile method which will fetch data
    // from GH API and *returns* a promise
    MigrationManager.prototype.saveChanges = function (mgrNotification) {

        // Generally, javascript callbacks, like here the $http.get callback,
        // change the value of the "this" variable inside it
        // so we need to keep a reference to the current instance "this" :
        var self = this;

        return $http.put(HOST + '/api/Notifications/MigrateNotification?customerId=' + this.customerId, mgrNotification).then(function (response) {

            // when we get the results we store the data in scheduleManager.calendarSchedule
            self.status = response.data;

            // promises success should always return something in order to allow chaining
            return response;

        });
    };

    return MigrationManager;
}

MigrateNotificationFactory.$inject = ['HOST', '$http'];

angular.module('mc.migrate-notification').factory('migrateNotificationFactory', MigrateNotificationFactory);

function MigrateNotificationController($scope, $http, $location, $window, authenticationService, $rootScope, translationService, sharedSetupService, serviceUserService, notificationGroupDestinationsService, detectBrowserService, $timeout, notificationGroupsService, toaster, openViewService, $element, migrateNotificationFactory, notificationOpenService) {
    var ctrl = this;
    ctrl.translation = translationService.translation;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') {
        ctrl.isAdmin = true;
        if (ctrl.accountInfo.allowMigration) ctrl.allowMigration = true;
    }
    
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        $timeout(function () {
            ctrl.alerts = [];
            ctrl.dispatcher = ctrl.accountInfo.dispatcherVersion;
            ctrl.importData = 0;
            ctrl.nextView = ctrl.stickyProperties.deviceId == 1 ? ctrl.translation.text.RULES : ctrl.translation.text.SCHEDULE;
        }, 0);
    };

    ctrl.continue = function () {
        var _migrateNotification = { customerId: ctrl.accountInfo.customerId, importData: ctrl.importData, dispatcher: ctrl.dispatcher };
        var migrationManager = new migrateNotificationFactory(ctrl.accountInfo.customerId);

        if (ctrl.isAdmin === true) {
            migrationManager.saveChanges(_migrateNotification).then(function() {
                    ctrl.openNextView();
                    if (parseInt(ctrl.dispatcher) === 2) ctrl.setDispatcherVersion(ctrl.dispatcher);
                },
                function(error) {
                    ctrl.alerts.push({ type: 'danger', msg: ctrl.translation.message.GENERAL_SERVER_ERROR });
                });
        } else {
            ctrl.openNextView();
        }
    };

    ctrl.setDispatcherVersion = function (varVersion) {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.accountInfo.dispatcherVersion = varVersion;
        authenticationService.setAccountInfo(ctrl.accountInfo);
    };

    ctrl.openNextView = function () {

        if ($rootScope.classicView === false) {
            _this.getExistingDialog(ctrl.windowId).ref.dialog("close");
            notificationOpenService.open(ctrl.stickyProperties.deviceId == 1 ? "Rules" : "Schedule", ctrl.importData);
            return;
        }
        $location.path("/notification/" + (ctrl.stickyProperties.deviceId == 1 ? "notificationrules/notification-rules" : "manageschedule/manage-schedule"));
    };
};

MigrateNotificationController.$inject = ['$scope', '$http', '$location', '$window', 'authenticationService', '$rootScope', 'translationService', 'sharedSetupService', 'serviceUserService', 'notificationGroupDestinationsService', 'detectBrowserService', '$timeout', 'notificationGroupsService', 'toaster', 'openViewService', '$element', 'migrateNotificationFactory', 'notificationOpenService']
angular.module('mc.migrate-notification').component('migrateNotification', {
    controller: MigrateNotificationController,
    templateUrl: 'ui/notification/migratenotification/migrate-notification-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<'
    }
});

angular.module("mc.schedule-grid", []);
function ScheduleGridFactory(HOST, $http) {
    var _DEBUG = false;

    var _myEventTemplate = { notificationScheduleId: null, typeId: null, dayOfWeek: null, startTime: null, endTime: null };
    var _myCalendar = { calendarId: null, customerId: null, events: [] };

    var _myDays = [
    { dayOfWeek: 0, name: "Sunday" },
    { dayOfWeek: 1, name: "Monday" },
    { dayOfWeek: 2, name: "Tuesday" },
    { dayOfWeek: 3, name: "Wednesday" },
    { dayOfWeek: 4, name: "Thursday" },
    { dayOfWeek: 5, name: "Friday" },
    { dayOfWeek: 6, name: "Saturday" }
    ];

    var _myShifts = [
    { notificationScheduleId: 10, typeId: 1, name: "24/7", classType: "" },
    { notificationScheduleId: 11, typeId: 2, name: "Days", classType: "D" },
    { notificationScheduleId: 12, typeId: 3, name: "Nights", classType: "N" },
    { notificationScheduleId: 13, typeId: 4, name: "Weekends", classType: "W" }
    ];

    var _formatTwoDigits = function (varNumber) {
        return ("0" + varNumber).slice(-2);
    };

    var _getNotificationScheduleId = function (varType) {
        for (var i = 0; i < _myShifts.length; i++) {
            if (_myShifts[i].classType === varType) {
                return _myShifts[i].notificationScheduleId;
            }
        }
        return varType;
    };


    var _getTypeId = function (varType) {
        for (var i = 0; i < _myShifts.length; i++) {
            if (_myShifts[i].classType === varType) {
                return _myShifts[i].typeId;
            }
        }
        return varType;
    };


    var _getShiftName = function (varType) {
        for (var i = 0; i < _myShifts.length; i++) {
            if (_myShifts[i].classType === varType) {
                return _myShifts[i].name;
            }
        }
        return varType;
    };

    var _getClassType = function (varTypeId) {
        for (var i = 0; i < _myShifts.length; i++) {
            if (_myShifts[i].typeId === varTypeId) {
                return _myShifts[i].classType;
            }
        }
        return varTypeId;
    };

    // instantiate our initial object
    var ScheduleGrid = function (customerId) {
        this.customerId = customerId;
        this.timeGrid = [];
        this.days = [{ id: 'sun' }, { id: 'mon' }, { id: 'tue' }, { id: 'wed' }, { id: 'thu' }, { id: 'fri' }, { id: 'sat' }];
        this.hours = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }, { id: 11 }];

        for (i = 0; i <= 23; i++) {
            for (j = 0; j <= 30; j += 30) {
                this.timeGrid.push({ timeSpan: _formatTwoDigits(i) + ":" + _formatTwoDigits(j) + ":" + "00" });
            }
        }
    };

    ScheduleGrid.prototype.paintGrid = function (varElement, varRow, varClass, varStartTime, varEndTime) {
        if (_DEBUG) console.log(varRow, varClass, varStartTime, varEndTime);
        $(varElement).find("table").find('tbody').each(function () {
            $(this).find('tr').each(function (i) {
                if (varRow === i) {
                    if (_DEBUG) console.log("--------" + i + "--------");
                    var _match = false;
                    $(this).find('td').each(function () {
                        var _dataSpan = $(this).attr("data-span");
                        if (_DEBUG) console.log(varStartTime, _dataSpan);
                        if (varEndTime === _dataSpan) {
                            _match = false;
                        }
                        if (varStartTime === _dataSpan || _match) {
                            _match = true;
                            if (_DEBUG) console.log("-------- mark --------");
                            $(this).removeClass("selected selectedD selectedN selectedW").addClass("selected" + _getClassType(varClass));
                        }
                    });
                }

            });
        });
    };

    ScheduleGrid.prototype.gridToCalendar = function (varElement) {
        _myCalendar.events = [];
        _myCalendar.customerId = this.customerId;

        $(varElement).find("table").find('tbody').each(function () {
            $(this).find('tr').each(function (i) {
                if (_DEBUG) {
                    console.log("-----------------");
                    console.log("Row: " + _myDays[i].name);
                    console.log("-----------------");
                }
                var _type;
                var _typePr = null;

                var _dataHour = null;
                var _dataMinute = null;
                var _dataMeridiem = null;
                var _dataSpan = null;

                var _printStartTime = false;
                var _printEndTime = false;

                var _needEndTime = false;

                $(this).find('td').each(function () {
                    if ($(this).hasClass("selectable")) {
                        _type = $(this).attr("class").replace("selectable ng-scope selected", "").trim();
                        _dataHour = $(this).attr("data-hour");
                        _dataMinute = _formatTwoDigits($(this).attr("data-min"));
                        _dataMeridiem = " " + $(this).attr("data-meridiem");
                        var _dataSpan = $(this).attr("data-span");

                        if (_type !== "" && _type !== _typePr) {
                            _printStartTime = true;
                        }

                        if (_needEndTime && _type !== _typePr) {
                            _printEndTime = true;
                        }

                        if (_printEndTime) {
                            if (_DEBUG) console.log("EndTime: " + _dataHour + ":" + _dataMinute + _dataMeridiem);
                            _printEndTime = false;
                            _needEndTime = false;
                            _myEventTemplate.endTime = _dataSpan;
                            _myCalendar.events.push(_myEventTemplate);
                        }

                        if (_printStartTime) {
                            if (_DEBUG) {
                                console.log("Shift: " + _getShiftName(_type));
                                console.log("Day: " + _myDays[i].name);
                                console.log("StartTime: " + _dataHour + ":" + _dataMinute + _dataMeridiem);
                            }
                            _printStartTime = false;
                            _needEndTime = true;
                            _myEventTemplate = { notificationScheduleId: _getNotificationScheduleId(_type), typeId: _getTypeId(_type), dayOfWeek: _myDays[i].dayOfWeek, startTime: _dataSpan, endTime: null };
                        }
                        _typePr = _type;
                    }
                });

                if (_needEndTime) {
                    if (_DEBUG) console.log("EndTime: 12:00 am");
                    _typePr = null;
                    _needEndTime = false;
                    _myEventTemplate.endTime = "00:00:00";
                    _myCalendar.events.push(_myEventTemplate);
                }
            });
        });

        for (var i = 0; i < _myDays.length; i++) {
            _myCalendar.events.push({ notificationScheduleId: _getNotificationScheduleId(""), typeId: _getTypeId(""), dayOfWeek: _myDays[i].dayOfWeek, startTime: "00:00:00", endTime: "00:00:00" });
        }

        if (_DEBUG) {
            console.log("-----------------");
            console.log(_myCalendar);
        }

        return _myCalendar;
    };

    return ScheduleGrid;
}

ScheduleGridFactory.$inject = ['HOST', '$http'];

angular.module('mc.schedule-grid').factory('scheduleGridFactory', ScheduleGridFactory);

angular.module("mc.manage-schedule", []);
function ManageScheduleFactory(HOST, $http) {

    // instantiate our initial object
    var ScheduleManager = function (customerId) {
        this.customerId = customerId;
        this.calendarSchedule = null;
    };

    // define the getProfile method which will fetch data
    // from GH API and *returns* a promise
    ScheduleManager.prototype.saveCalendar = function (calendar) {

        // Generally, javascript callbacks, like here the $http.get callback,
        // change the value of the "this" variable inside it
        // so we need to keep a reference to the current instance "this" :
        var self = this;

        return $http.put(HOST + '/api/NotificationCalendar/NotificationCalendar?customerId=' + this.customerId, calendar).then(function (response) {
            
            // when we get the results we store the data in scheduleManager.calendarSchedule
            self.calendarSchedule = response.data;

            // promises success should always return something in order to allow chaining
            return response;

        });
    };

    ScheduleManager.prototype.getCalendar = function () {
        var self = this;

        return $http.get(HOST + '/api/NotificationCalendar/NotificationCalendar?customerId=' + this.customerId + "&calendarId=null" + "&effectiveDateTime=null" + "&langId=1").then(function (response) {
            self.calendarSchedule = response.data;
            return response;
        });
    };

    ScheduleManager.prototype.getDefaultCalendar = function () {
        var self = this;

        return $http.get(HOST + '/api/NotificationCalendar/NotificationCalendar?customerId=' + this.customerId + '&restore=true').then(function (response) {
            self.calendarSchedule = response.data;
            return response;
        });
    };

    return ScheduleManager;
}

ManageScheduleFactory.$inject = ['HOST', '$http'];

angular.module('mc.manage-schedule').factory('manageScheduleFactory', ManageScheduleFactory);

function ManageScheduleController($scope, $http, $location, $window, authenticationService, $rootScope, translationService, sharedSetupService, serviceUserService, notificationGroupDestinationsService, detectBrowserService, $timeout, notificationGroupsService, toaster, openViewService, $element, manageScheduleFactory, scheduleGridFactory, $filter, wizardSplashService) {
    var ctrl = this;
    const DEBUG = false;
    ctrl.blEditCalendar = true;
    ctrl.translation = translationService.translation;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.hourToSendLocalTimes = [];
    ctrl.mobile = $rootScope.mobile;
    ctrl.myShifts = ["Catch-all", "Days", "Nights", "Weekends"];
    
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') {
            ctrl.isAdmin = true;
        }

        ctrl.scheduleGrid = new scheduleGridFactory(ctrl.accountInfo.customerId);
        ctrl.timeGrid = ctrl.scheduleGrid.timeGrid;
        ctrl.days = ctrl.scheduleGrid.days;
        ctrl.hours = ctrl.scheduleGrid.hours;

        ctrl.initializeSetting();
        $timeout(function () {
            ctrl.getCalendar();
            ctrl.setScheduleClass(ctrl.stickyProperties && ctrl.stickyProperties.deviceId || 1);
        }, 0);
    };

    var _hourToSendLocalTimes = function () {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.hourToSendLocalTimes.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.hourToSendLocalTimes.push(arguments[i]);
            } else {
                ctrl.hourToSendLocalTimes[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        ctrl.dt = new Date();
        _hourToSendLocalTimes(
            {
                "id": 24,
                "name": $filter('date')(ctrl.dt.setHours(24, 0), ctrl.timeFormat)
            },
            {
                "id": 1,
                "name": $filter('date')(ctrl.dt.setHours(1, 0), ctrl.timeFormat)
            },
            {
                "id": 2,
                "name": $filter('date')(ctrl.dt.setHours(2, 0), ctrl.timeFormat)
            },
            {
                "id": 3,
                "name": $filter('date')(ctrl.dt.setHours(3, 0), ctrl.timeFormat)
            },
            {
                "id": 4,
                "name": $filter('date')(ctrl.dt.setHours(4, 0), ctrl.timeFormat)
            },
            {
                "id": 5,
                "name": $filter('date')(ctrl.dt.setHours(5, 0), ctrl.timeFormat)
            },
            {
                "id": 6,
                "name": $filter('date')(ctrl.dt.setHours(6, 0), ctrl.timeFormat)
            },
            {
                "id": 7,
                "name": $filter('date')(ctrl.dt.setHours(7, 0), ctrl.timeFormat)
            },
            {
                "id": 8,
                "name": $filter('date')(ctrl.dt.setHours(8, 0), ctrl.timeFormat)
            },
            {
                "id": 9,
                "name": $filter('date')(ctrl.dt.setHours(9, 0), ctrl.timeFormat)
            },
            {
                "id": 10,
                "name": $filter('date')(ctrl.dt.setHours(10, 0), ctrl.timeFormat)
            },
            {
                "id": 11,
                "name": $filter('date')(ctrl.dt.setHours(11, 0), ctrl.timeFormat)
            },
            {
                "id": 12,
                "name": $filter('date')(ctrl.dt.setHours(12, 0), ctrl.timeFormat)
            },
            {
                "id": 13,
                "name": $filter('date')(ctrl.dt.setHours(13, 0), ctrl.timeFormat)
            },
            {
                "id": 14,
                "name": $filter('date')(ctrl.dt.setHours(14, 0), ctrl.timeFormat)
            },
            {
                "id": 15,
                "name": $filter('date')(ctrl.dt.setHours(15, 0), ctrl.timeFormat)
            },
            {
                "id": 16,
                "name": $filter('date')(ctrl.dt.setHours(16, 0), ctrl.timeFormat)
            },
            {
                "id": 17,
                "name": $filter('date')(ctrl.dt.setHours(17, 0), ctrl.timeFormat)
            },
            {
                "id": 18,
                "name": $filter('date')(ctrl.dt.setHours(18, 0), ctrl.timeFormat)
            },
            {
                "id": 19,
                "name": $filter('date')(ctrl.dt.setHours(19, 0), ctrl.timeFormat)
            },
            {
                "id": 20,
                "name": $filter('date')(ctrl.dt.setHours(20, 0), ctrl.timeFormat)
            },
            {
                "id": 21,
                "name": $filter('date')(ctrl.dt.setHours(21, 0), ctrl.timeFormat)
            },
            {
                "id": 22,
                "name": $filter('date')(ctrl.dt.setHours(22, 0), ctrl.timeFormat)
            },
            {
                "id": 23,
                "name": $filter('date')(ctrl.dt.setHours(23, 0), ctrl.timeFormat)
            }
        );
    };

    ctrl.getTime = function (td) {
        return function(hour) {
            console.log(hour.id, td);
            console.log(ctrl.hourToSendLocalTimes);
            switch (td) {
            case "am":
                return ((hour.id >= 1 && hour.id <= 11) || hour.id === 24);
                break;
            case "pm":
                return (hour.id >= 13 && hour.id <= 23);
                break;
            }
        }
    };
  
    ctrl.getText = function (text) {
        if (!angular.isDefined(text)) return;
        return typeof eval("ctrl.translation.text." + text.toUpperCase().replace(/-/g, "_")) !== 'undefined' ? eval("ctrl.translation.text." + text.toUpperCase().replace(/-/g, "_")) : text;
    };

    ctrl.setScheduleClass = function (id) {
        if (!ctrl.isAdmin) return;
        switch (id) {
            case 1:
                ctrl.scheduleClass = "selected";
                ctrl.scheduleColor = "#43668d";
                ctrl.shiftModel = ctrl.myShifts[id - 1];
                break;
            case 2:
                ctrl.scheduleClass = "selectedD";
                ctrl.scheduleColor = "#e8db4f";
                ctrl.shiftModel = ctrl.myShifts[id - 1];
                break;
            case 3:
                ctrl.scheduleClass = "selectedN";
                ctrl.scheduleColor = "#43464b";
                ctrl.shiftModel = ctrl.myShifts[id - 1];
                break;
            case 4:
                ctrl.scheduleClass = "selectedW";
                ctrl.scheduleColor = "#138a72";
                ctrl.shiftModel = ctrl.myShifts[id - 1];
                break;
            default:
                ctrl.scheduleClass = "selected";
                ctrl.scheduleColor = "#43668d";
                ctrl.shiftModel = ctrl.myShifts[id - 1];
                return;
        }

        $element.find('table').awesomeCursor('paint-brush', {
            color: ctrl.scheduleColor,
            size: 22,
            hotspot: [5, 20],
            outline: 'black'
        });
    };

    ctrl.fnToggleSchedule = function (e) {
        if (!ctrl.isAdmin) return;
        if ($(e.target).hasClass(ctrl.scheduleClass)) {
            //$(e.target).removeClass(ctrl.scheduleClass).addClass("selected");
        }
        else {
            $(e.target).removeClass("selected selectedD selectedN selectedW");
            $(e.target).addClass(ctrl.scheduleClass);
        }
    };

    ctrl.changeSchedule = function (e) {
        if (!ctrl.isAdmin) return;
        if (ctrl.mouseDown) {
            $(e.target).removeClass("selected selectedD selectedN selectedW").addClass(ctrl.scheduleClass);
        }
    };

    ctrl.changeScheduleRow = function (e) {
        if(!ctrl.isAdmin) return;
        $(e.target).closest('tr').each(function (i) {
            $(this).find('td').each(function (i1) {
                if ($(this).hasClass("selectable"))
                    $(this).removeClass("selected selectedD selectedN selectedW").addClass(ctrl.scheduleClass);
            });

        });
    };

    ctrl.highlightScheduleRow = function (e) {
        if(!ctrl.isAdmin) return;
        $(e.target).closest('tr').each(function (i) {
            $(this).find('td').each(function (i1) {
                if ($(this).hasClass("selectable"))
                    $(this).addClass(ctrl.scheduleClass + "overlay");
            });

        });
    };
    ctrl.removeHighlightScheduleRow = function (e) {
        if(!ctrl.isAdmin) return;
        $(e.target).closest('tr').each(function (i) {
            $(this).find('td').each(function (i1) {
                if ($(this).hasClass("selectable"))
                    $(this).removeClass(ctrl.scheduleClass + "overlay");
            });

        });
    };

    ctrl.changeScheduleColumn = function (e, inx) {
        if (!ctrl.isAdmin) return;
        var cellIndex = inx + 1;
        $(e.target).parents("table").find('tbody').each(function (i) {
            $(this).find('tr').each(function (i1) {
                $(this).find('td:eq(' + (cellIndex * 2 - 1) + '), td:eq(' + (cellIndex * 2) + ')').each(function (i1) {
                    if ($(this).hasClass("selectable"))
                        $(this).removeClass("selected selectedD selectedN selectedW").addClass(ctrl.scheduleClass);
                });
            });
        });
    };

    ctrl.highlightScheduleColumn = function (e, inx) {
        if(!ctrl.isAdmin) return;
        var cellIndex = inx + 1;
        $(e.target).parents("table").find('tbody').each(function (i) {
            $(this).find('tr').each(function (i1) {
                $(this).find('td:eq(' + (cellIndex * 2 - 1) + '), td:eq(' + (cellIndex * 2) + ')').each(function (i1) {
                    if ($(this).hasClass("selectable"))
                        $(this).addClass(ctrl.scheduleClass + "overlay");
                });
            });
        });
    };
    ctrl.removeHighlightScheduleColumn = function (e, inx) {
        if(!ctrl.isAdmin) return;
        var cellIndex = inx + 1;
        $(e.target).parents("table").find('tbody').each(function (i) {
            $(this).find('tr').each(function (i1) {
                $(this).find('td:eq(' + (cellIndex * 2 - 1) + '), td:eq(' + (cellIndex * 2) + ')').each(function (i1) {
                    if ($(this).hasClass("selectable"))
                        $(this).removeClass(ctrl.scheduleClass + "overlay");
                });
            });
        });
    };

    ctrl.changeScheduleRandC = function (e) {
        if(!ctrl.isAdmin) return;
        $(e.target).parents("table").find('tbody').each(function (i) {
            $(this).find('tr').each(function (i1) {
                $(this).find('td').each(function (i1) {
                    if ($(this).hasClass("selectable"))
                        $(this).removeClass("selected selectedD selectedN selectedW").addClass(ctrl.scheduleClass);
                });
            });

        });
    };

    ctrl.highlightScheduleRandC = function (e) {
        if(!ctrl.isAdmin) return;
        $(e.target).parents("table").find('tbody').each(function (i) {
            $(this).find('tr').each(function (i1) {
                $(this).find('td').each(function (i1) {
                    if ($(this).hasClass("selectable"))
                        $(this).addClass(ctrl.scheduleClass + "overlay");
                });
            });

        });
    };
    ctrl.removeHighlightScheduleRandC = function (e) {
        if(!ctrl.isAdmin) return;
        $(e.target).parents("table").find('tbody').each(function (i) {
            $(this).find('tr').each(function (i1) {
                $(this).find('td').each(function (i1) {
                    if ($(this).hasClass("selectable"))
                        $(this).removeClass(ctrl.scheduleClass + "overlay");
                });
            });

        });
    };

    ctrl.getCalendar = function() {
        // instantiate a new schedule
        var scheduleManager = new manageScheduleFactory(ctrl.accountInfo.customerId);
        // get data
        scheduleManager.getCalendar().then(function () {
            ctrl.savedSchedule = scheduleManager.calendarSchedule;
          
            for (var i = 0; i < ctrl.savedSchedule.events.length; i++) { // mark Catch-all first
                if (ctrl.savedSchedule.events[i].typeId === 1)
                    ctrl.scheduleGrid.paintGrid($element, ctrl.savedSchedule.events[i].dayOfWeek, ctrl.savedSchedule.events[i].typeId, ctrl.savedSchedule.events[i].startTime, ctrl.savedSchedule.events[i].endTime);
            }
            for (var i = 0; i < ctrl.savedSchedule.events.length; i++) {
                if (ctrl.savedSchedule.events[i].typeId !== 1)
                    ctrl.scheduleGrid.paintGrid($element, ctrl.savedSchedule.events[i].dayOfWeek, ctrl.savedSchedule.events[i].typeId, ctrl.savedSchedule.events[i].startTime, ctrl.savedSchedule.events[i].endTime);
            }
        });
    };

    ctrl.getDefaultCalendar = function () {
        // instantiate a new schedule
        var scheduleManager = new manageScheduleFactory(ctrl.accountInfo.customerId);
        // get data
        scheduleManager.getDefaultCalendar().then(function () {
            ctrl.savedSchedule = scheduleManager.calendarSchedule;

            for (var i = 0; i < ctrl.savedSchedule.events.length; i++) { // mark Catch-all first
                if (ctrl.savedSchedule.events[i].typeId === 1)
                    ctrl.scheduleGrid.paintGrid($element, ctrl.savedSchedule.events[i].dayOfWeek, ctrl.savedSchedule.events[i].typeId, ctrl.savedSchedule.events[i].startTime, ctrl.savedSchedule.events[i].endTime);
            }
            for (var i = 0; i < ctrl.savedSchedule.events.length; i++) {
                if (ctrl.savedSchedule.events[i].typeId !== 1)
                    ctrl.scheduleGrid.paintGrid($element, ctrl.savedSchedule.events[i].dayOfWeek, ctrl.savedSchedule.events[i].typeId, ctrl.savedSchedule.events[i].startTime, ctrl.savedSchedule.events[i].endTime);
            }
        });
    };

    ctrl.saveCalendar = function () {
        if(!ctrl.isAdmin) return;
        var _myCalendar = ctrl.scheduleGrid.gridToCalendar($element);

        var scheduleManager = new manageScheduleFactory(ctrl.accountInfo.customerId);
        
        scheduleManager.saveCalendar(_myCalendar).then(function () {
            $rootScope.$broadcast('updateNotificationSchedule', _myCalendar);
            if (!$rootScope.classicView && !$rootScope.mobile) _this.getExistingDialog(ctrl.windowId).ref.dialog("close");
        });

    };

    ctrl.closeSchedule = function () {
        if (!$rootScope.classicView && !$rootScope.mobile) {
            _this.getExistingDialog(ctrl.windowId).ref.dialog("close");
        } else {
            ctrl.getCalendar();
        }
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on('$destroy', function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });
};

ManageScheduleController.$inject = ['$scope', '$http', '$location', '$window', 'authenticationService', '$rootScope', 'translationService', 'sharedSetupService', 'serviceUserService', 'notificationGroupDestinationsService', 'detectBrowserService', '$timeout', 'notificationGroupsService', 'toaster', 'openViewService', '$element', 'manageScheduleFactory', 'scheduleGridFactory', '$filter', 'wizardSplashService']
angular.module('mc.manage-schedule').component('manageSchedule', {
    controller: ManageScheduleController,
    templateUrl: 'ui/notification/manageschedule/manage-schedule-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<'
    }
});

angular.module("mc.alarm-rule-test", []);
function RepEventFactory(HOST, $http) {

    // instantiate our initial object
    var RepEvent = function (customerId) {
        this.customerId = customerId;
    };

    RepEvent.prototype.getEvent = function (reportId, arivalDateTime) {
        var self = this;
        return $http.get(HOST + '/api/RepEvent'
            + '?reportId=' + reportId
            + '&customerId=' + this.customerId
            + '&ruleId=' + arivalDateTime
            ).then(function (response) {
                self.event = response.data;
                return response;
            });
    };

    RepEvent.prototype.postEvent = function (repEvent) {
        var self = this;
        return $http.post(HOST + '/api/RepEvent'
            + '?customerId=' + this.customerId, repEvent
            ).then(function (response) {
                self.reportId = response.data;
                return response;
            });
    };

    return RepEvent;
}

RepEventFactory.$inject = ['HOST', '$http'];

angular.module('mc.alarm-rule-test').factory('repEventFactory', RepEventFactory);

function DeviceSettingParmAllFactory(HOST, $http) {

    // instantiate our initial object
    var DeviceSettingParmAll = function (customerId, deviceId) {
        this.customerId = customerId;
        this.deviceId = deviceId;
    };

    DeviceSettingParmAll.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + '/api/DeviceSettingParmAll'
            + '?customerId=' + this.customerId
            + '&deviceId=' + this.deviceId
            ).then(function (response) {
                self.deviceLookup = response.data.deviceLookup;
                self.analogSetting = response.data.analogSetting;
                self.digitalSetting = response.data.digitalSetting;
                self.relaySetting = response.data.relaySetting;
                self.reportEvents = response.data.repEvents;
                return response;
            });
    };

    return DeviceSettingParmAll;
}

DeviceSettingParmAllFactory.$inject = ['HOST', '$http'];

angular.module('mc.alarm-rule-test').factory('deviceSettingParmAllFactory', DeviceSettingParmAllFactory);

"use strict";

function AlarmRuleTestController($scope, $timeout, authenticationService, translationService, alarmDestinationFactory, alarmDevicesFactory, repEventFactory, deviceSettingParmAllFactory, sharedSetupService, openViewService, HOST, $http) {
    var ctrl = this;
    ctrl.translation = translationService.translation;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.flTestRule = false;
    ctrl.flTestTb2Rule = false;
    ctrl.flTestTb2AlarmRule = false;

    ctrl.testDeviceId = null;
    ctrl.testInputId = null;
    ctrl.testStateId = null;
    ctrl.testEventLocalDateTime = new Date();

    ctrl.testTb2DeviceId = null;
    ctrl.testTb2InputId = null;
    ctrl.testTb2StateId = null;

    ctrl.dateFilter = function () {
        return true;
    };

    ctrl.rulesAndShifts = ["Default", "Days", "Nights", "Weekends", "Catch-all"]; //(Shifts) Default == Catch-all; (Rules) Catch-all == All Alarms

    ctrl.inputs = [];

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.timeFormatTimePicker = ctrl.getTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);
        // $timeout(function () {
        ctrl.getDevices();
        ctrl.getInputStateJsonTree();
        //}, 0);


        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        }
    };

    ctrl.adjustSize = function () {
        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        //ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('.test-rule-results').css("height", _tmpHeight - 201);
    };

    ctrl.buildInputsByDeviceId = function (deviceId) {
        ctrl.inputs = [];
        ctrl.inputStateJsonTreeCopy = angular.copy(ctrl.inputStateJsonTree);

        var intBrj = -1;
        angular.forEach(ctrl.inputStateJsonTreeCopy, function (item, i) {
            if (item.inputGroupName === "Digital Inputs") {
                intBrj++;
                if (intBrj < ctrl.deviceSettingParmAll.digitalSetting.length) {
                    item.label = ctrl.deviceSettingParmAll.digitalSetting[intBrj].description;
                    item.disabled = false;
                } else {
                    item.disabled = true;
                }
            }
        });

        intBrj = -1;
        angular.forEach(ctrl.inputStateJsonTreeCopy, function (item, i) {
            if (item.inputGroupName === "Analog Inputs") {
                intBrj++;
                if (intBrj < ctrl.deviceSettingParmAll.analogSetting.length) {
                    item.label = ctrl.deviceSettingParmAll.analogSetting[intBrj].name;
                    item.disabled = false;
                } else {
                    item.disabled = true;
                }
            }
        });

        intBrj = -1;
        angular.forEach(ctrl.inputStateJsonTreeCopy, function (item, i) {
            if (item.inputGroupName === "Relay Outputs") {
                intBrj++;
                if (intBrj < ctrl.deviceSettingParmAll.relaySetting.length) {
                    item.label = ctrl.deviceSettingParmAll.relaySetting[intBrj].description;
                    item.disabled = false;
                } else {
                    item.disabled = true;
                }
            }
        });

        var finalInputs = ctrl.inputStateJsonTreeCopy.filter(function (res) {
            return !res.disabled;
        });
        ctrl.inputs = finalInputs;
    };

    ctrl.testAlarmRule = function () {
        var now = new Date(ctrl.testEventLocalDateTime);
        var _tmpTestEventLocalDateTime = now.getFullYear().toString() + "-" + (now.getMonth() + 1).toString() + "-" + now.getDate() + "T" + ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2);

        if (!ctrl.testInputId) return;
        ctrl.getAlarmMessage(ctrl.testInputId.id, ctrl.testStateId.inputStateId, ctrl.testStateId.severity);
        var alarmDestination = new alarmDestinationFactory(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone, _tmpTestEventLocalDateTime, ctrl.testDeviceId.deviceId, ctrl.testInputId.id, ctrl.testStateId.inputStateId);

        alarmDestination.getDestination().then(function () {
            ctrl.destinations = alarmDestination.destinations;
            ctrl.ruleName = alarmDestination.notificationRule.ruleName;
            ctrl.shiftId = alarmDestination.shiftId;
            ctrl.shiftName = alarmDestination.shiftName;

            ctrl.destinations.forEach(function (destination) {
                if (destination.contactModeId) {
                    switch (destination.contactModeId) {
                        case 2:
                            //"Email":
                            destination.contactModeIcon = ["fa-envelope"];
                            break;
                        case 4:
                            //"Fax":
                            destination.contactModeIcon = ["fa-fax"];
                            break;
                        case 8:
                            //"Voice Pager":
                            destination.contactModeIcon = ["fa-volume-up"];
                            break;
                        case 17:
                            //"Numeric Pager":
                            destination.contactModeIcon = ["fa-hdd-o"];
                            break;
                        case 18:
                            //18 SMS
                            destination.contactModeIcon = ["fa-commenting-o"];
                            break;
                        case 1: //1	 Voice
                        case 11: //11 Voice Standard
                        case 12: //12 Voice Short
                        case 13: //13 Voice Short Ack 9
                        case 14: //14 Voice Short No Ack
                        case 15:
                            //15 Voice Short Ack *
                            destination.contactModeIcon = ["fa-phone"];
                            break;
                        default:
                        // do nothing
                    }
                }
            });
        });
    };

    ctrl.testTb2AlarmRule = function () {
        ctrl.testEventLocalDateTime = new Date();
        var inputState = ctrl.testInputId.children.find(function (x) {
            return x.inputStateId == ctrl.testStateId.inputStateId;
        });
        var descriptionTmp = "Input: " + ctrl.testInputId.label + "(" + ctrl.testInputId.id + ") - " + "State: " + inputState.label + "(" + ctrl.testStateId.inputStateId + ")";
        var _tmpRepEvent = { customerId: ctrl.accountInfo.customerId, deviceId: ctrl.testDeviceId.deviceId, input: ctrl.testInputId.id, state: ctrl.testStateId.inputStateId, severity: ctrl.testStateId.severity, description: descriptionTmp };
        var repEvent = new repEventFactory(ctrl.accountInfo.customerId);
        repEvent.postEvent(_tmpRepEvent).then(function () {
            ctrl.testAlarmRule();
            ctrl.reportId = repEvent.reportId;
        });
        ctrl.flTestTb2AlarmRule = true;
    };

    ctrl.getDevices = function () {
        var alarmDevices = new alarmDevicesFactory(ctrl.accountInfo.customerId);
        alarmDevices.getDevices().then(function () {
            ctrl.devices = alarmDevices.list;
        });
    };

    ctrl.getInputStateJsonTree = function () {
        var url = HOST + "/api/Notifications/NotificationRuleInputStateJsonTree?customerID=" + ctrl.accountInfo.customerId + "&ruleId=" + 0;
        $http.get(url).then(function (result) {
            ctrl.inputStateJsonTree = result.data;
        }).then(function (result) {
            //ok
        });
    };

    ctrl.checkTestData = function () {
        if (ctrl.testDeviceId !== null && ctrl.testInputId !== null && ctrl.testStateId !== null && ctrl.testEventLocalDateTime !== null) {
            ctrl.testAlarmRule();
            ctrl.flTestRule = true;
            ctrl.flTestTb2Rule = true;
        } else {
            ctrl.flTestRule = false;
            ctrl.flTestTb2Rule = false;
        }
        ctrl.flTestTb2AlarmRule = false;
    };

    ctrl.selectDevice = function () {
        ctrl.inputs = [];
        if (ctrl.testDeviceId === null) {
            ctrl.checkTestData();
        } else {
            var deviceSettingParmAll = new deviceSettingParmAllFactory(ctrl.accountInfo.customerId, ctrl.testDeviceId.deviceId);

            deviceSettingParmAll.getData().then(function () {
                ctrl.deviceSettingParmAll = deviceSettingParmAll;
                ctrl.buildInputsByDeviceId(deviceSettingParmAll.deviceId);
                ctrl.checkTestData();
            });
        }
    };

    ctrl.getAlarmMessage = function (input, state, severity) {
        if (typeof input === "undefined" || typeof state === "undefined") return "";
        var alarmMessage = ctrl.deviceSettingParmAll.reportEvents.filter(function (el) {
            return el.input === input && el.state === state;
        });

        ctrl.alarmMessage = alarmMessage.length > 0 ? alarmMessage[0].description : "";

        if (input == 51 && state == 11 && severity == 1) {
            ctrl.alarmMessage = ctrl.alarmMessage.replace("Restore", " High Restore");
        } else if (input == 51 && state == 13 && severity == 1) {
            ctrl.alarmMessage = ctrl.alarmMessage.replace("Fault", " High Fault");
        }
    };

    ctrl.print = function (datetime) {
        ctrl.testEventLocalDateTime = typeof datetime !== 'undefined' && datetime._isValid ? datetime._d : null;
        ctrl.checkTestData();
    };

    ctrl.getText = function (text) {
        if (!angular.isDefined(text)) return;
        if (!ctrl.isInArray(text, ctrl.rulesAndShifts)) return text;
        var _tmpText = text.replace("Catch-all", "ALL_ALARMS").replace("Default", "CATCH_ALL");
        return typeof eval("ctrl.translation.text." + _tmpText.toUpperCase().replace(/-/g, "_")) !== 'undefined' ? eval("ctrl.translation.text." + _tmpText.toUpperCase().replace(/-/g, "_")) : _tmpText;
    };

    ctrl.isInArray = function (value, array) {
        return array.indexOf(value) > -1;
    };

    ctrl.getTimeFormat = function (timeFormat) {
        return timeFormat == 1 ? "h:mm a" : "H:mm";
    };

    ////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////

    $scope.$on('changeNotificationScheduleOrRule', function () {
        ctrl.checkTestData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.testAlarmRule();
    });

    $scope.$on('destinationsPatch', function () {
        ctrl.testAlarmRule();
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormatTimePicker = false;
        $timeout(function () {
            ctrl.timeFormatTimePicker = ctrl.getTimeFormat(timeFormat);
        }, 1000);
    });

    ////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////
};

AlarmRuleTestController.$inject = ['$scope', '$timeout', 'authenticationService', 'translationService', 'alarmDestinationFactory', 'alarmDevicesFactory', 'repEventFactory', 'deviceSettingParmAllFactory', 'sharedSetupService', 'openViewService', 'HOST', '$http'];
angular.module('mc.alarm-rule-test').component('alarmRuleTest', {
    controller: AlarmRuleTestController,
    templateUrl: 'ui/notification/alarmruletest/alarm-rule-test-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function AlarmDevicesFactory(HOST, $http) {

    // instantiate our initial object
    var AlarmDevices = function (customerId) {
        this.customerId = customerId;
    };

    AlarmDevices.prototype.getDevices = function () {
        var self = this;
        return $http.get(HOST + '/api/Notifications/NotificationRuleDevice'
            + '?customerId=' + this.customerId
            + '&ruleId=' + 0
            + '&deviceId=' + null
            + '&input=' + null
            + '&state=' + null
            ).then(function (response) {
            self.list = response.data;
            return response;
        });
    };

    return AlarmDevices;
}

AlarmDevicesFactory.$inject = ['HOST', '$http'];

angular.module('mc.alarm-rule-test').factory('alarmDevicesFactory', AlarmDevicesFactory);

function AlarmDestinationFactory(HOST, $http) {

    // instantiate our initial object
    var AlarmDestination = function (customerId, timeZone, eventLocalDateTime, deviceId, inputId, stateId) {
        this.customerId = customerId;
        this.timeZone = timeZone,
        this.eventLocalDateTime = eventLocalDateTime;
        this.deviceid = deviceId;
        this.inputId = inputId;
        this.stateId = stateId;
        this.langId = 1;
    };

    AlarmDestination.prototype.getDestination = function () {
        var self = this;
        return $http.get(HOST + '/api/Notifications/AlarmDestination'
            + '?customerId=' + this.customerId
            + '&timeZone=' + this.timeZone
            + '&eventLocalDateTime=' + this.eventLocalDateTime
            + '&deviceid=' + this.deviceid
            + '&inputId=' + this.inputId
            + '&stateId=' + this.stateId
            + '&langId=' + this.langId
            + '&test=' + true
            ).then(function (response) {
                self.notificationRule = response.data.notificationRule;
                self.shiftId = response.data.shiftId;
                self.shiftName = response.data.name;
                self.destinations = response.data.destinations;
            return response;
        });
    };

    return AlarmDestination;
}

AlarmDestinationFactory.$inject = ['HOST', '$http'];

angular.module('mc.alarm-rule-test').factory('alarmDestinationFactory', AlarmDestinationFactory);

"use strict";

angular.module("mc.widget-mmplus-setting", []);
"use strict";

function McWidgetMmPlusSettingController($, $timeout, $rootScope, $scope, $element, authenticationService, translationService, websocketService, mmPlusWidgetService, McWidgetsSharedFactory) {

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            ctrl.mcWidgetMmPlusSetting = changes.widgetSetting.currentValue;
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.getUiData();
        }
    };

    ctrl.$onInit = function () {
        if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        ctrl.w_tabpaneIsOpen = { "height": "100%", "display": "block" };
        ctrl.w_tabpaneIsClosed = { "height": "0%", "display": "none" };
        ctrl.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.colorPalet = ctrl.mcWidgetsSharedFactory.getColorPalet();
        ctrl.mobile = $rootScope.mobile;
    };

    ctrl.setModel = function (parm) {
        ctrl.clearModel();
        $timeout(function () {
            ctrl.parm = parm;
        }, 0);
    };

    ctrl.clearModel = function () {
        ctrl.parm = null;
    };

    ctrl.testNgChange = function () {
        ctrl.validateColors(true);
    };

    ctrl.selectColor = function (event) {
        switch (ctrl.parm) {
            case "highAlarmColor":
                ctrl.highAlarmColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "highHighAlarmColor":
                ctrl.highHighAlarmColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "levelColor":
                ctrl.levelColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            default:
            // code block
        }
        ctrl.clearModel();
        ctrl.validateColors(true);
    };

    ctrl.updateDisplayOptions = function (param) {

        var tmpNewMmPlusSetting = angular.copy(ctrl.mcWidgetMmPlusSetting.mmPlusSetting);
        tmpNewMmPlusSetting.customerId = ctrl.accountInfo.customerId;
        tmpNewMmPlusSetting.deviceId = ctrl.mcWidgetMmPlusSetting.device.deviceId;
        tmpNewMmPlusSetting.channel = 0;

        if (!angular.isUndefined(param.settingOptions.titleOption)) {
            tmpNewMmPlusSetting.titleId = param.settingOptions.titleOption.id;
            ctrl.updateUiData(param, tmpNewMmPlusSetting);
        }

        if (!angular.isUndefined(param.settingOptions.heardTypeOption)) {
            tmpNewMmPlusSetting.dateTimeFormatId = param.settingOptions.heardTypeOption.id;
            ctrl.updateUiData(param, tmpNewMmPlusSetting);
        }

        if (!angular.isUndefined(param.settingOptions.stateOption)) {
            tmpNewMmPlusSetting.stateId = param.settingOptions.stateOption.id;
            ctrl.updateUiData(param, tmpNewMmPlusSetting);
        }

        if (!angular.isUndefined(param.settingOptions.sizeOption)) {
            tmpNewMmPlusSetting.sizeId = param.settingOptions.sizeOption.id;
            ctrl.updateUiData(param, tmpNewMmPlusSetting);
        }

        if (!angular.isUndefined(param.settingOptions.themeOption)) {
            tmpNewMmPlusSetting.themeId = param.settingOptions.themeOption.id;
            ctrl.updateUiData(param, tmpNewMmPlusSetting);
        }

        if (!angular.isUndefined(param.settingOptions.colorOption)) {

            tmpNewMmPlusSetting.levelColor = param.settingOptions.colorOption.levelColor;
            tmpNewMmPlusSetting.levelBlink = param.settingOptions.colorOption.levelBlink;

            ctrl.updateUiData(param, tmpNewMmPlusSetting);
        }

        if (!angular.isUndefined(param.settingOptions.analogChannelOption)) {
            tmpNewMmPlusSetting.analogChannel = param.settingOptions.analogChannelOption.channel;
            ctrl.updateUiData(param, tmpNewMmPlusSetting);
        }

        if (!angular.isUndefined(param.settingOptions.digitalChannelOption)) {
            tmpNewMmPlusSetting.digitalChannel = param.settingOptions.digitalChannelOption.channel;
            ctrl.updateUiData(param, tmpNewMmPlusSetting);
        }

        if (!angular.isUndefined(param.settingOptions.hudInfoOption)) {
            tmpNewMmPlusSetting.hudInfo = param.settingOptions.hudInfoOption.id;
            ctrl.updateUiData(param, tmpNewMmPlusSetting);
        }

        if (!angular.isUndefined(param.settingOptions.rtuOption)) {

            ctrl.getChannels(param.settingOptions.rtuOption.deviceId, true);
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: param.settingOptions.rtuOption.deviceId, channel: ctrl.channelSelectedOption.channel } } });
        }

        if (!angular.isUndefined(param.settingOptions.channelOption)) {
            ctrl.channelSelectedOption = { channel: param.settingOptions.channelOption.channel };
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: ctrl.rtuSelectedOption.deviceId, channel: param.settingOptions.channelOption.channel } } });
        }
    };

    ctrl.updateUiData = function (param, naws) {
        ctrl.mcWidgetsSharedFactory.updateUiData(param, naws, "GaugeMmPlusWidget", "newMcWidgetMmPlusSettingOptions", ctrl, ctrl.widgetSetting.mmPlusSetting);
    };

    ctrl.getUiData = function () {
        ctrl.mcWidgetsSharedFactory.getUiData("mcWidgetMmPlusSettingOptions", "All", ctrl);
    };

    ctrl.getSetting = function () {
        mmPlusWidgetService.getSettings(ctrl.accountInfo.customerId, ctrl.mcWidgetMmPlusSetting.device.deviceId).then(function (result) {
            ctrl.rtuOptions = result.data.digitalDevices;
            ctrl.digitalSettings = result.data.digitalSettings;
            ctrl.analogSettings = result.data.analogSettings;

            ctrl.getChannels(ctrl.mcWidgetMmPlusSetting.device.deviceId);

            ctrl.getAnalogChannels(ctrl.mcWidgetMmPlusSetting.device.deviceId);

            ctrl.getDigitalChannels(ctrl.mcWidgetMmPlusSetting.device.deviceId);

            ctrl.rtuSelectedOption = { deviceId: ctrl.mcWidgetMmPlusSetting.device.deviceId, name: ctrl.mcWidgetMmPlusSetting.device.name };
        }, function (error) {});
    };

    ctrl.getChannels = function (deviceId, firstChannel) {
        ctrl.channelOptions = [];
        ctrl.channelOptions.push({ channel: 0, description: "0" });
        ctrl.channelSelectedOption = { channel: 0 };
        return;
    };

    ctrl.getAnalogChannels = function (deviceId, firstChannel) {
        ctrl.analogChannelOptions = [];
        ctrl.analogChannelOptions.push({ channel: 0, name: "--- " + ctrl.translation.text.SELECT + " " + ctrl.translation.text.ANALOG + " " + ctrl.translation.text.CHANNEL + " ---" });

        angular.forEach(ctrl.analogSettings, function (analogSettings) {
            if (parseInt(deviceId) === parseInt(analogSettings.deviceId)) {
                ctrl.analogChannelOptions.push(analogSettings);
            }
        });

        if (firstChannel) {
            ctrl.analogChannelSelectedOption = { channel: ctrl.analogChannelOptions[0].channel, name: ctrl.analogChannelOptions[0].name };
        } else {
            ctrl.analogChannelSelectedOption = { channel: ctrl.mcWidgetMmPlusSetting.mmPlusSetting.analogChannel, name: "Analog Channel Dsc." };
        }
    };

    ctrl.getDigitalChannels = function (deviceId, firstChannel) {
        ctrl.digitalChannelOptions = [];
        ctrl.digitalChannelOptions.push({ channel: 0, description: "--- " + ctrl.translation.text.SELECT + " " + ctrl.translation.text.DIGITAL + " " + ctrl.translation.text.CHANNEL + " ---" });

        angular.forEach(ctrl.digitalSettings, function (digitalSettings) {
            if (parseInt(deviceId) === parseInt(digitalSettings.deviceId)) {
                ctrl.digitalChannelOptions.push(digitalSettings);
            }
        });

        if (firstChannel) {
            ctrl.digitalChannelSelectedOption = { channel: ctrl.digitalChannelOptions[0].channel, description: ctrl.digitalChannelOptions[0].name };
        } else {
            ctrl.digitalChannelSelectedOption = { channel: ctrl.mcWidgetMmPlusSetting.mmPlusSetting.digitalChannel, description: "Digital Channel Dsc." };
        }
    };

    ctrl.setOptions = function () {
        ctrl.titleOptions = ctrl.mcWidgetMmPlusSettingOptions.title;
        ctrl.titleSelectedOption = { id: ctrl.mcWidgetMmPlusSetting.mmPlusSetting.titleId };

        ctrl.heardTypeOptions = ctrl.mcWidgetMmPlusSettingOptions.dateTimeFormat;
        ctrl.heardTypeSelectedOption = { id: ctrl.mcWidgetMmPlusSetting.mmPlusSetting.dateTimeFormatId };

        ctrl.sizeOptions = ctrl.mcWidgetMmPlusSettingOptions.size;
        ctrl.sizeSelectedOption = { id: ctrl.mcWidgetMmPlusSetting.mmPlusSetting.sizeId };

        ctrl.themeOptions = ctrl.mcWidgetMmPlusSettingOptions.theme;
        ctrl.themeSelectedOption = { id: ctrl.mcWidgetMmPlusSetting.mmPlusSetting.themeId };

        ctrl.hudInfoOption = [];
        ctrl.hudInfoOption.push({ id: 0, name: "Telemetry Data" }, { id: 1, name: "Sewage Level/Distance" });
        ctrl.hudInfoSelectedOption = { id: ctrl.mcWidgetMmPlusSetting.mmPlusSetting.hudInfo };

        ctrl.levelColor = ctrl.mcWidgetMmPlusSetting.mmPlusSetting.levelColor;
        ctrl.levelBlink = ctrl.mcWidgetMmPlusSetting.mmPlusSetting.levelBlink;

        ctrl.validateColors();
    };

    ctrl.validateColors = function (_dataChanged) {
        if (ctrl.levelColor.length !== 7 || ctrl.levelColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidFaultColor = true;
        } else {
            ctrl.invalidFaultColor = false;
        }

        ctrl.invalidColor = ctrl.invalidRunningColor || ctrl.invalidNotRunningColor || ctrl.invalidFaultColor ? true : false;

        if (_dataChanged && !ctrl.invalidColor) {
            ctrl.updateDisplayOptions({
                settingOptions: {
                    colorOption: {
                        levelColor: ctrl.levelColor,
                        levelBlink: ctrl.levelBlink
                    }
                }
            });
        }
    };

    ctrl.showTab = function (parm) {
        ctrl.clearModel();
        var element = $element.find(".w_tabbox");
        ctrl.mcWidgetsSharedFactory.showTab(parm, element, ctrl);
    };

    ctrl.translateOptions = function () {
        ctrl.titleOptions.forEach(function (option) {
            return option.state = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.heardTypeOptions.forEach(function (option) {
            return option.type = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.sizeOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.themeOptions.forEach(function (option) {
            return option.name = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
    };

    var _onUpdatePreferencesLanguage = $rootScope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translateOptions();
    });

    var setTimeOut = function setTimeOut() {
        setTimeout(function () {
            $scope.liveUpdateItem = null;
            $scope.liveUpdated = null;
            $scope.liveMessage = null;
        }, 20000); // 20 Seconds
    };

    var refreshDeviceBasicInfoLive = function refreshDeviceBasicInfoLive(patch, userName) {
        switch (patch.path) {
            case "description":
                $scope.basicInfoOldValue = $scope.deviceOld[patch.path];
                $scope.deviceOld[patch.path] = patch.value;
                $scope.device[patch.path] = $scope.deviceOld[patch.path];
                $scope.basicInfoNewValue = patch.value;
                break;
        }

        if ($scope.basicInfoOldValue != "") {
            $scope.liveUpdateItem = patch.path;
            $scope.liveUpdated = true;
            $scope.liveMessage = " " + userName + " changed " + patch.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + $scope.basicInfoOldValue + " to " + $scope.basicInfoNewValue;
            setTimeOut();
        }
    };

    $scope.$on("$destroy", function () {
        _onUpdatePreferencesLanguage();
    });
}

McWidgetMmPlusSettingController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'authenticationService', 'translationService', 'websocketService', 'mmPlusWidgetService', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-mmplus-setting').component('mcWidgetMmPlusSetting', {
    controller: McWidgetMmPlusSettingController,
    templateUrl: 'ui/mmplus/mcwidgetmmplussetting/mcwidget-mmplus-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        changeDisplayOptions: '&'
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function mmPlusNetworkController($, $rootScope, $scope, $timeout, $element, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, MMPlusRtuSettingFactory, deviceService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.networkDeviceList = [];
    ctrl.selectedNetworkConfig = { networkConfigIndex: 0 };
    ctrl.networkDeviceTypeExtLookUp = [];
    ctrl.currentNetwrokDeviceTypeLookupExt = null;
    ctrl.popoverAddDeviceNetworkConfigIsOpen = false;
    ctrl.popoverAddNewNetworkConfigDevice = {
        templateUrl: 'AddNewNetworkConfigPopoverTemplate.html'
    };
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyProperties = ctrl.stickyProperties;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        $scope.windowTitle = ctrl.windowTitle; //need for
        //$scope.stickyProperties = ctrl.stickyProperties;
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.networkTypeIds = [];
        ctrl.networkType = [{ id: 0, name: 'RTU' }, { id: 1, name: 'ADAM' }, { id: 2, name: 'ModbusRTU' }, { id: 3, name: 'ModbusTCP' }, { id: 4, name: 'ProFiBus' }];
        ctrl.deviceIndexes = [{ id: 0, value: null, disabled: true }, { id: 1, value: 1, disabled: false }, { id: 2, value: 2, disabled: false }, { id: 3, value: 3, disabled: false }, { id: 4, value: 4, disabled: false }];
        ctrl.BaudRateList = [{ BaudRateID: 1, BaudRate: 9600 }, { BaudRateID: 2, BaudRate: 19200 }, { BaudRateID: 3, BaudRate: 38400 }, { BaudRateID: 4, BaudRate: 57600 }, { BaudRateID: 5, BaudRate: 115200 }];
        ctrl.BaudRateList = [{ BaudRateID: 1, BaudRate: 9600 }, { BaudRateID: 2, BaudRate: 19200 }, { BaudRateID: 3, BaudRate: 38400 }, { BaudRateID: 4, BaudRate: 57600 }, { BaudRateID: 5, BaudRate: 115200 }];
        ctrl.getNetworkDeviceTypes();
        ctrl.getNetworkDeviceTypeExtLookUp();
        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
                //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        };
    };

    ctrl.getNetworkDeviceTypes = function () {
        ctrl.MMPlusRtuSettingFactory.getNetworkDeviceTypes().then(function (result) {
            ctrl.unfilteredNetworkTypeIds = result.data;
        }, function (error) {});
    };

    ctrl.getNetworkDeviceTypeExtLookUp = function () {
        ctrl.MMPlusRtuSettingFactory.getNetworkDeviceTypeExtLookUp().then(function (result) {
            ctrl.networkDeviceTypeExtLookUp = result.data;
        }, function (error) {});
    };
    ctrl.getData = function () {
        ctrl.MMPlusRtuSettingFactory.getDeviceConfigData(ctrl.deviceId, true).then(function (result) {
            ctrl.getImeiAndSKU();
            ctrl.networkDeviceList = result.data;
            angular.forEach(ctrl.networkDeviceList, function (value, key) {
                ctrl.networkDeviceList[key].networkConfigIndex = key;
                ctrl.networkDeviceList[key].networkConfigDescription = value.deviceIndex > 0 ? "Network Device " + value.deviceIndex : "RTU";
                var deviceIndexId = ctrl.deviceIndexes.findIndex(function (d) {
                    return d.id === value.deviceIndex;
                });
                if (deviceIndexId > -1) ctrl.deviceIndexes[deviceIndexId].disabled = true;
            });
            ctrl.currentNetwrokDeviceTypeLookupExt = ctrl.networkDeviceTypeExtLookUp.find(function (o) {
                return o.networkDeviceTypeId === ctrl.networkDeviceList[ctrl.selectedNetworkConfig.networkConfigIndex].networkDeviceTypeID;
            });
            if (!ctrl.networkDeviceList) {
                ctrl.setDefaultData();
                ctrl.configButtonVisible = false;
            } else {
                ctrl.configButtonVisible = true;
            }
        }, function (error) {
            //error
        });

        //NOTE: this call has to happen ONLY one time for this tab launch
        //Log tab access event to NLog
        ctrl.MMPlusRtuSettingFactory.postUserAction2Nlog(ctrl.accountInfo.customerId, ctrl.deviceId, "GEN II >> Network").then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });
    };
    ctrl.changeNetworkDevice = function () {
        ctrl.currentNetwrokDeviceTypeLookupExt = ctrl.networkDeviceTypeExtLookUp.find(function (o) {
            return o.networkDeviceTypeId === ctrl.networkDeviceList[ctrl.selectedNetworkConfig.networkConfigIndex].networkDeviceTypeID;
        });
    };
    ctrl.getImeiAndSKU = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
            ctrl.skuId = datafromFactory.data.skuId;
            ctrl.filterNetworkDeviceTypeID();
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loadingInProgress = false;
        });
    };

    ctrl.filterNetworkDeviceTypeID = function () {
        //filter out level sensor options from Network Device Type ID if selected MM+ device is M84O/F
        if (ctrl.skuId == 0 || ctrl.skuId == 1) {
            ctrl.networkTypeIds = ctrl.unfilteredNetworkTypeIds.filter(function (item) {
                return item.networkDeviceTypeId !== 13 && item.networkDeviceTypeId !== 14 && item.networkDeviceTypeId !== 15 && item.networkDeviceTypeId !== 16;
            });
        } else {
            ctrl.networkTypeIds = ctrl.unfilteredNetworkTypeIds;
        }
    };

    ctrl.postData = function (path, networkConfigIndex) {
        if (path == "networkDeviceTypeID") ctrl.currentNetwrokDeviceTypeLookupExt = ctrl.networkDeviceTypeExtLookUp.find(function (o) {
            return o.networkDeviceTypeId === ctrl.networkDeviceList[networkConfigIndex][path];
        });
        if (path == 'networkDeviceTypeID' || path == 'networkTypeID') {
            deviceMenuService.resetDeviceMenuList();
            deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId);
        }
        var tmpDevice = { "op": "replace", "path": path, "value": ctrl.networkDeviceList[networkConfigIndex][path] };
        ctrl.MMPlusRtuSettingFactory.patchNetworkDeviceConfig(ctrl.deviceId, ctrl.networkDeviceList[networkConfigIndex].networkDeviceConfigID, tmpDevice).then(function (result) {
            ctrl.data = result.data;
            ctrl.configButtonVisible = true;
        }, function (error) {
            //error
        });
    };

    ctrl.addNewDeviceNetworkConfig = function () {
        ctrl.popoverAddDeviceNetworkConfigIsOpen = true;
        // create new network Device
        ctrl.newNetworkDevice = {
            deviceID: ctrl.deviceId,
            baudRateID: 1,
            commLossTimeMs: 0,
            delayMs: 0,
            deviceIndex: 1,
            enableDisableModbusPowerSupply: true,
            delayPowerBeforeCommSecs: 0,
            heartbeatMs: 0,
            isDefaultConfig: true,
            isTemplate: false,
            lastChangeDate: null,
            networkDeviceConfigID: 10,
            networkDeviceTypeID: 0,
            networkTypeID: 0,
            nodeAddress: "1",
            origConfigDate: null,
            responseTimeMs: 0,
            stopBitsID: 0
        };

        ctrl.addMode = true;
        // ctrl.editModeIndex = -1;
        $timeout(function () {
            $element.find(".dscFocus").focus();
        }, 500);
    };
    ctrl.saveNewNetworkDevice = function () {
        ctrl.popoverAddDeviceNetworkConfigIsOpen = false;
        ctrl.updateNetworkConfigData(ctrl.newNetworkDevice);
        ctrl.newNetworkDevice = null;
        $rootScope.$broadcast('resetDeviceMenuList', ctrl.accountInfo.customerId);
        ctrl.getData();
    };
    ctrl.cancelAddNewDeviceNetworkConfig = function () {
        ctrl.popoverAddDeviceNetworkConfigIsOpen = false;
        //this.newAddLakeLevelRef = null;
    };
    ctrl.deleteNetowrkConfig = function (networkConfig) {
        ctrl.MMPlusRtuSettingFactory.deleteNetworkDeviceConfig(ctrl.deviceId, networkConfig.networkDeviceConfigID).then(function (result) {
            ctrl.selectedNetworkConfig = { networkConfigIndex: 0 };
            ctrl.getData();
            $rootScope.$broadcast('resetDeviceMenuList', ctrl.accountInfo.customerId);
        }, function (error) {});
    };
    ctrl.clickLog = function () {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = ctrl.deviceId;
        optionsStickyProperties.device = { deviceId: ctrl.deviceId, title: "", deviceName: ctrl.deviceSelectedName };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/log/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };
            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 40;

            openViewService.openView('MM Plus Network History', { width: 820, height: 420 }, { my: 'right-10 top+6', at: 'right top', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 }, false);
        }
    };

    $scope.$on('syncG2NetworkConfig', function (event, args) {
        if (args.deviceID == ctrl.deviceId) {
            ctrl.networkDeviceConfig = args;
            ctrl.networkDeviceConfig.isTemplate = ctrl.networkDeviceList[args.deviceIndex].isTemplate;
            ctrl.networkDeviceConfig.isDefaultConfig = ctrl.networkDeviceList[args.deviceIndex].isDefaultConfig;
            ctrl.updateNetworkConfigData(ctrl.networkDeviceConfig);
        }
    });

    ctrl.updateNetworkConfigData = function (networkConfig) {
        ctrl.MMPlusRtuSettingFactory.updateNetworkConfig(ctrl.accountInfo.customerId, ctrl.deviceId, networkConfig).then(function (result) {
            openViewService.closeConfigHistoryView("MM Plus Network History");
            ctrl.networkDeviceList = result.data;
        }, function (error) {
            //error
        });
    };

    ctrl.setTimeOut = function () {
        setTimeout(function () {
            ctrl.alertMessage = null;
        }, 15000); // 15 Seconds
    };

    ctrl.setDefaultData = function () {
        ctrl.data = {
            commLossTimeMs: 0,
            delayMs: 0,
            heartbeatMs: 0,
            isDefaultConfig: true,
            isTemplate: false,
            lastChangeDate: null,
            networkDeviceConfigID: 10,
            networkDeviceTypeID: 0,
            networkTypeID: 0,
            nodeAddress: "1",
            origConfigDate: null,
            responseTimeMs: 0
        };
    };

    ctrl.configure = function () {
        ctrl.MMPlusRtuSettingFactory.configMMPlusNetwork(ctrl.deviceId, ctrl.imei, ctrl.networkDeviceList[ctrl.selectedNetworkConfig.networkConfigIndex].networkTypeID).then(function (result) {
            //success
            var configResult = result.data.match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
            ctrl.alertMessage = "Network Config " + configResult[0] + ": " + configResult[1];
            ctrl.setTimeOut();
        }, function (error) {
            //error
            ctrl.alertMessage = "Something went wrong while processing network config request";
            ctrl.setTimeOut();
        });
    };

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;
            var _device = { deviceId: newValue, deviceName: $scope.$parent.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });

            if (!angular.isUndefined(ctrl.currentDevice)) return;

            ctrl.currentDevice = newValue;
            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    ctrl.alertMessage = null;
                    $timeout(function () {
                        ctrl.getData();
                    }, 0);
                } else {
                    ctrl.data = null;
                    ctrl.alertMessage = "Please configure the device as Gen 2";
                    ctrl.configButtonVisible = false;
                }
            });
        }
    }, true);

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });
};

mmPlusNetworkController.$inject = ['$', '$rootScope', '$scope', '$timeout', '$element', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusNetwork', {
    controller: mmPlusNetworkController,
    templateUrl: 'ui/mmplusrtusetting/network/mm-plus-network-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.widget-mmplus-display", []);
"use strict";

function McWidgetMmPlusDisplayController($, $timeout, $rootScope, $scope, $element, debounceService, $compile, websocketService, toaster, datetimeService, sharedSetupService, McMmPlusWidgetFactory, authenticationService, translationService, PopupFactory, detectBrowserService, McWidgetsSharedFactory, $filter, openViewService, $http, HOST) {
    var _this2 = this;

    var ctrl = this;

    var INITIAL_Y = 7.7;
    var INITIAL_SENSOR_CABLE_Y = 71.9;
    var INITIAL_FLOAT_CABLE_Y = 72.3;

    ctrl.sensorCable = INITIAL_Y;
    ctrl.sensorCableStart = INITIAL_SENSOR_CABLE_Y;
    ctrl.oldSensorCable = INITIAL_Y;

    ctrl.sensorImageHeight = INITIAL_Y;
    ctrl.oldSensorImageHeight = INITIAL_Y;

    ctrl.floatCable = INITIAL_Y;
    ctrl.oldFloatCable = INITIAL_Y;
    ctrl.floatImageHeight = INITIAL_Y;
    ctrl.oldFloatImageHeight = INITIAL_Y;
    ctrl.floatCableStart = INITIAL_FLOAT_CABLE_Y;

    ctrl.plotlineTypes = [];

    //TODO:Will REMOVE TODO:Will REMOVE TODO:Will REMOVE TODO:Will REMOVE
    ctrl.mainClass = ["upWidget"];
    //TODO:Will REMOVE TODO:Will REMOVE TODO:Will REMOVE TODO:Will REMOVE

    ctrl.timestamp_DisplayStyle = { "font-size": '24px' };
    ctrl.inputStatusStyle = { "font-size": '24px' };

    ctrl.waterLevelUp = false;

    ctrl.validateFloatChannel = true;

    var deviceStateEnum = {
        Ok: 1,
        Alarm: 2,
        Offline: 3,
        Service: 4,
        Disabled: 5
    };

    ctrl.unitOfValues = [{ id: 0, name: 'Meters', symbol: 'm' }, //Missing Unit
    { id: 3, name: 'Feet', symbol: 'ft' }, { id: 4, name: 'Inches', symbol: 'in' }, { id: 5, name: 'Meters', symbol: 'm' },
    //{ id: 6, name: 'mm' },
    { id: 23, name: 'Centimeters', symbol: 'cm' }];

    var _convertFromMeters = function _convertFromMeters(unitId, analogValue) {
        switch (unitId) {
            case 3:
                //Feet
                return analogValue * 3.280839895;
            case 4:
                //Inches
                return analogValue * 39.37007874;
            case 5:
                //Meters
                return analogValue;
            case 6:
                // mm
                return analogValue * 1000;
            case 23:
                // Centimeters
                return analogValue * 100;
            default:
                return analogValue;
        }
    };

    var displayLevelReferences = function displayLevelReferences() {
        for (var i = 0; i < ctrl.widgetSetting.levelReferences.length; i++) {
            var llPerc = ctrl.calcScale(ctrl.widgetSetting.analogSetting.minVal, ctrl.widgetSetting.analogSetting.mmPlusDepth, ctrl.widgetSetting.levelReferences[i].referenceValue);
            var newY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * llPerc / 100;
            ctrl.widgetSetting.levelReferences[i].referenceValueY = newY;
            ctrl.widgetSetting.levelReferences[i].ngAttrD = "M 130 " + newY + " L 270 " + newY;
            ctrl.widgetSetting.levelReferences[i].strokeDasharray = ctrl.plotlineTypes[ctrl.widgetSetting.levelReferences[i].plotLineTypeID - 1].strokeDasharray;
        }
    };

    ctrl.openMMPlusSetting = function () {
        if (ctrl.widgetSetting.setting.displaySettingOn) return;
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            var tmpSize = ctrl.mcWidgetsSharedFactory.getSizeNew(88, 1, 0);
            var mcDevice = { deviceId: ctrl.widgetSetting.device.deviceId, channel: 0, serialNumber: ctrl.widgetSetting.device.serialNumber, deviceName: ctrl.widgetSetting.device.name };
            var optionsStickyProperties = {
                deviceId: ctrl.widgetSetting.device.deviceId,
                device: mcDevice,
                setting: true
            };
            var position = { my: 'right top', at: 'right top', of: ctrl.popup };
            var vieName = "Mc MyLevel Widget";
            openViewService.openWidget(vieName, { width: tmpSize.width, height: tmpSize.height }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
        }
    };

    ctrl.minY = 119; //359;
    ctrl.minHeight = 267; //38;

    ctrl.pwMouseOut = true;

    ctrl.buildSensor = function () {

        if (!ctrl.hasAnalogChannel || ctrl.widgetSetting.analogSetting == null) return;

        var totalDepth = 382 - INITIAL_Y;
        var sensorDepthPercentage = ctrl.widgetSetting.analogSetting.sensorDepth / ctrl.widgetSetting.analogSetting.mmPlusDepth;

        ctrl.sensorLineMarker = INITIAL_Y + totalDepth * sensorDepthPercentage;
        ctrl.sensorCable = ctrl.sensorLineMarker;
        ctrl.sensorCableStart = INITIAL_SENSOR_CABLE_Y;

        if (ctrl.sensorCable < INITIAL_SENSOR_CABLE_Y) {
            ctrl.sensorCableStart = INITIAL_Y;
            //scope.sensorCable = INITIAL_SENSOR_CABLE_Y;
        }

        ctrl.oldSensorImageHeight = ctrl.sensorImageHeight;

        ctrl.sensorImageHeight = ctrl.sensorLineMarker - 27;
        if (ctrl.sensorImageHeight < INITIAL_Y) ctrl.sensorImageHeight = INITIAL_Y;
    };

    //Sensore needs to be built first!
    ctrl.buildFloat = function () {

        if (ctrl.sensorCable > 105.1) {
            ctrl.floatCable = 105.1;
        } else if (ctrl.sensorCable <= INITIAL_Y) {
            ctrl.floatCable = INITIAL_Y;
        } else {
            ctrl.floatCable = ctrl.sensorCable - 15;
        }

        ctrl.oldFloatCable = ctrl.floatCable;

        ctrl.floatCableStart = INITIAL_FLOAT_CABLE_Y;

        if (ctrl.floatCable < INITIAL_FLOAT_CABLE_Y) {
            ctrl.floatCableStart = INITIAL_Y;
        }

        ctrl.oldFloatImageHeight = ctrl.floatImageHeight;

        if (ctrl.sensorImageHeight > 101.9475) {
            ctrl.floatImageHeight = 101.9475;
        } else if (ctrl.sensorImageHeight <= INITIAL_Y) {
            ctrl.floatImageHeight = INITIAL_Y;
        } else {
            ctrl.floatImageHeight = ctrl.sensorImageHeight - 15;
        }
    };

    ctrl.buildAnalogLevel = function () {

        if (!ctrl.hasAnalogChannel || ctrl.widgetSetting.analogSetting == null) return;

        var minY = 386; //minY is starting position for minHeight = 0
        var minHeight = 0; //when minHeight goes up minY goes down
        var maxHeight = 267; //minHeight to maxHeight is the range of the tanks

        ctrl.numberOfDecimals = sharedSetupService.getNumberOfDecimals(ctrl.widgetSetting.analogSetting.maxVal, ctrl.widgetSetting.analogSetting.minVal);
        var analogLatestData = ctrl.widgetSetting.analogSetting.latestData;

        ctrl.mmPlusDepth = ctrl.widgetSetting.analogSetting.mmPlusDepth;
        ctrl.sewageLevel = parseFloat(analogLatestData).toFixed(ctrl.numberOfDecimals);
        ctrl.distanceToSpill = parseFloat(ctrl.mmPlusDepth - analogLatestData).toFixed(ctrl.numberOfDecimals);
        ctrl.analogLocalDateTime = ctrl.widgetSetting.analogSetting.localDateTime;

        //Calculate markers
        {
            ctrl.firstMarker = ctrl.mmPlusDepth - ctrl.mmPlusDepth / 4;
            ctrl.secondMarker = ctrl.mmPlusDepth / 2;
            ctrl.thirdMarker = ctrl.mmPlusDepth / 2 - ctrl.mmPlusDepth / 4;
        }

        ctrl.latestAnalogReading = ctrl.sewageLevel; //7;
        //hide pipe water if analog reading is 0
        if (ctrl.latestAnalogReading != 0) {
            ctrl.showPipeWater = true;
        } else {
            ctrl.showPipeWater = false;
        }
        //const innerWaterDepth = 371.4 - 32.7
        var markerDifference = 380.7 - 7.4;
        var waterLevelPercentage = 1 - ctrl.latestAnalogReading / ctrl.mmPlusDepth;
        ctrl.waterLevel = 7.4 + markerDifference * waterLevelPercentage;
        //only show upper water body when water level passes certain threshold
        if (ctrl.waterLevel >= 371.2) {
            ctrl.showWaterBody = false;
        } else {
            ctrl.showWaterBody = true;
            if (ctrl.waterLevel > 149.375) {
                ctrl.waterBody = "114.9,363.4 114.9, " + ctrl.waterLevel + " 293.3, " + ctrl.waterLevel + " 293.3, 363.4 227, 371.4 183.7, 371.4";
            } else if (ctrl.waterLevel > 77.375) {
                ctrl.waterBody = "114.9,363.4 114.9, 149.375 " + (114.9 + (ctrl.waterLevel - 149.375) * (50 / -72)) + ", " + ctrl.waterLevel + " " + (293.3 + (ctrl.waterLevel - 149.375) * (45 / 72)) + "," + ctrl.waterLevel + " 293.3, 149.375 293.3, 363.4 227, 371.4 183.7, 371.4";
            } else {
                if (ctrl.waterLevel > 33.875) {
                    ctrl.waterBody = "114.9,363.4 114.9, 149.375 162.9, 77.375 162.9, " + ctrl.waterLevel + " 248.3, " + ctrl.waterLevel + " 248.3, 77.375 293.3, 149.375 293.3, 363.4 227, 371.4 183.7, 371.4";
                } else {
                    ctrl.waterBody = "114.9,363.4 114.9, 149.375 162.9, 77.375 162.9, 33.875 248.3, 33.875 248.3, 77.375 293.3, 149.375 293.3, 363.4 227, 371.4 183.7, 371.4";
                }
            }
        }

        ctrl.analogUnit = ctrl.widgetSetting.analogSetting.unit;

        ctrl.analogMinValY = 384; //min valu display position, see dry-well-level-markers on HTML template
        ctrl.analogMaxValY = 10; //max valu display position, see dry-well-level-markers on HTML template

        ctrl.analogMinVal = ctrl.widgetSetting.analogSetting.minVal;
        ctrl.analogMaxVal = ctrl.mmPlusDepth;

        ctrl.analogLowAlarm = ctrl.widgetSetting.analogSetting.lowAlarm;
        ctrl.analogLowRestore = ctrl.widgetSetting.analogSetting.lowRestore;

        ctrl.analogHighRestore = ctrl.widgetSetting.analogSetting.highRestore;
        ctrl.analogHighAlarm = ctrl.widgetSetting.analogSetting.highAlarm;

        ctrl.analogHighHighRestore = ctrl.widgetSetting.analogSetting.highHighRestore;
        ctrl.analogHighHighAlarm = ctrl.widgetSetting.analogSetting.highHighAlarm;

        var analogLowAlarmPerc = ctrl.calcScale(ctrl.widgetSetting.analogSetting.minVal, ctrl.mmPlusDepth, ctrl.widgetSetting.analogSetting.lowAlarm);
        ctrl.analogLowAlarmY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * analogLowAlarmPerc / 100;

        var analogLowRestorePerc = ctrl.calcScale(ctrl.widgetSetting.analogSetting.minVal, ctrl.mmPlusDepth, ctrl.widgetSetting.analogSetting.lowRestore);
        ctrl.analogLowRestoreY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * analogLowRestorePerc / 100;

        var analogHighRestorePerc = ctrl.calcScale(ctrl.widgetSetting.analogSetting.minVal, ctrl.mmPlusDepth, ctrl.widgetSetting.analogSetting.highRestore);
        ctrl.analogHighRestoreY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * analogHighRestorePerc / 100;

        var analogHighAlarmPerc = ctrl.calcScale(ctrl.widgetSetting.analogSetting.minVal, ctrl.mmPlusDepth, ctrl.widgetSetting.analogSetting.highAlarm);
        ctrl.analogHighAlarmY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * analogHighAlarmPerc / 100;

        var analogHighHighRestorePerc = ctrl.calcScale(ctrl.widgetSetting.analogSetting.minVal, ctrl.mmPlusDepth, ctrl.widgetSetting.analogSetting.highHighRestore);
        ctrl.analogHighHighRestoreY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * analogHighHighRestorePerc / 100;

        var analogHighHighAlarmPerc = ctrl.calcScale(ctrl.widgetSetting.analogSetting.minVal, ctrl.mmPlusDepth, ctrl.widgetSetting.analogSetting.highHighAlarm);
        ctrl.analogHighHighAlarmY = ctrl.analogMinValY - (ctrl.analogMinValY - ctrl.analogMaxValY) * analogHighHighAlarmPerc / 100;

        var curentValuePerc = ctrl.calcScale(ctrl.widgetSetting.analogSetting.minVal, ctrl.mmPlusDepth, ctrl.widgetSetting.analogSetting.latestData);
        var currentValue = maxHeight * curentValuePerc / 100;

        ctrl.minY = minY - currentValue;
        ctrl.minHeight = minHeight + currentValue;

        if (ctrl.plotlineTypes.length == 0) {
            $http.get(HOST + "/api/LevelReference/GetPlotlineTypes?customerId=" + _this2.accountInfo.customerId).then(function (resp) {
                ctrl.plotlineTypes = resp.data;
                displayLevelReferences();
            });
        } else {
            displayLevelReferences();
        }
    };

    ctrl.difference = function (a, b) {
        return Math.abs(a - b);
    };

    ctrl.calcScale = function (g_min, g_max, g_numb) {
        var calc_minmaxDiff = ctrl.difference(g_min, g_max); // Calculate diference between min and max
        var calc_minnumbDiff = ctrl.difference(g_min, g_numb); // Calculate diference between min and number
        var calc_numbPerc = calc_minnumbDiff / calc_minmaxDiff * 100;
        return calc_numbPerc;
    };

    var getState = function getState(state) {
        //Options: AllNormal, Alarm, Alert, Service, CommFail
        switch (state) {
            case deviceStateEnum.Ok:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
            case deviceStateEnum.Disabled:
                return "Disabled";
            case deviceStateEnum.Offline:
                //device.CommsFault
                ctrl.orbitTitle = ctrl.translation.text.COMM_FAIL;
                return "CommFail";
            case deviceStateEnum.Service:
                ctrl.orbitTitle = ctrl.translation.text.SERVICE_MODE;
                return "Service";
            case deviceStateEnum.Alarm:
                ctrl.orbitTitle = null; //ctrl.translation.text.ALARM;
                return "Alarm";
            default:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
        }
    };

    var getView = function getView(state) {
        switch (state) {
            case deviceStateEnum.Service:
                return "RTU Configuration"; //"Service";
            case deviceStateEnum.Alarm:
                return "Dashboard"; //"Alarm";
            default:
                return "Dashboard"; //"AllNormal";
        }
    };

    ctrl.$onInit = function () {

        ctrl.displaySettingOn = ctrl.settingShow;
        ctrl.mobile = $rootScope.mobile;

        if (angular.isUndefined(ctrl.accountInfo)) {
            ctrl.accountInfo = authenticationService.getAccountInfo();
            ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        }
        if (angular.isUndefined(ctrl.popupWindow)) {
            ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
            ctrl.getPopupWindowDateTimeDifference = debounceService(ctrl.popupWindow.datetime_difference, 200, false);
        }
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;

        if (angular.isUndefined(ctrl.buildMainClassDebounce)) ctrl.buildMainClassDebounce = debounceService(ctrl.buildMainClass, 200, false);
    };

    ctrl.pwMouseEnter = function () {
        if (!ctrl.hideHudElements) return;
        ctrl.pwMouseOut = false;
    };

    ctrl.pwMouseLeave = function () {
        ctrl.pwMouseOut = true;
    };

    ctrl.pwMouseEnterAlarm = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.getTooltip(ctrl.widgetSetting.device.deviceId, event, 20, 20);
    };

    ctrl.pwMouseLeaveAlarm = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.$onChanges = function (changes) {

        if (!angular.isUndefined(changes.widgetSetting) && changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            $scope.alerts = [];
            if (angular.isUndefined(ctrl.accountInfo)) {
                ctrl.accountInfo = authenticationService.getAccountInfo();
                ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
            }
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            ctrl.curentBrowser = detectBrowserService();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            if (angular.isUndefined(ctrl.popupWindow)) {
                ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
                ctrl.getPopupWindowDateTimeDifference = debounceService(ctrl.popupWindow.datetime_difference, 200, false);
            }

            if (!angular.isUndefined(changes.widgetSetting.previousValue) && !angular.isUndefined(changes.widgetSetting.previousValue.device)) {
                ctrl.unRegisterListenerListDeviceState(changes.widgetSetting.previousValue.device.serialNumber);
                ctrl.unRegisterListenerAnalogData(changes.widgetSetting.previousValue.device.serialNumber);
                ctrl.unRegisterListenerTelemetryData(changes.widgetSetting.previousValue.device.serialNumber);
            }

            if (angular.isUndefined(ctrl.buildMainClassDebounce)) ctrl.buildMainClassDebounce = debounceService(ctrl.buildMainClass, 200, false);

            ////////////////////////////////////////////////////////////////////////////////////
            ctrl.mmPlusWidgetId = changes.widgetSetting.currentValue.mmPlusWidgetId;
            ctrl.mmPlusType = changes.widgetSetting.currentValue.mmPlusType;
            ////////////////////////////////////////////////////////////////////////////////////

            ctrl.deviceDigitalData = angular.isUndefined(changes.widgetSetting.currentValue) || changes.widgetSetting.currentValue.deviceDigitalData != null ? true : false;

            ctrl.validateFloatChannel = true;

            if (changes.widgetSetting.currentValue.analogSetting != null) ctrl.getLevelSensorUnit(changes.widgetSetting.currentValue.analogSetting.unitOfValueID);

            ctrl.buildWidget(changes.widgetSetting.currentValue);
        }
    };

    ctrl.getLevelSensorUnit = function (unitOfValueID) {
        var unitObject = ctrl.unitOfValues.filter(function (x) {
            return x.id === unitOfValueID;
        });
        ctrl.levelSensorUnit = unitObject[0].name;
        ctrl.levelSensorUnitId = unitObject[0].id;
        ctrl.levelSensorUnitSymbol = unitObject[0].symbol;
    };

    ctrl.wsListDeviceStateMsgReceived = function (data) {
        var tmpObj = {
            state: data.find(function (x) {
                return x.id === ctrl.widgetSetting.device.deviceId;
            }).state,
            acFail: data.find(function (x) {
                return x.id === ctrl.widgetSetting.device.deviceId;
            }).acFail,
            lastTimeHeardUtc: data.find(function (x) {
                return x.id === ctrl.widgetSetting.device.deviceId;
            }).lastTimeHeardUtc
        };

        if (ctrl.widgetSetting.deviceUnitState.state != tmpObj.state || ctrl.widgetSetting.deviceUnitState.acFail != tmpObj.acFail || ctrl.widgetSetting.deviceUnitState.lastTimeHeardUtc != tmpObj.lastTimeHeardUtc) {

            ctrl.widgetSetting.deviceUnitState.state = tmpObj.state;
            ctrl.widgetSetting.deviceUnitState.acFail = tmpObj.acFail;
            ctrl.widgetSetting.deviceUnitState.lastTimeHeardUtc = tmpObj.lastTimeHeardUtc;
            ctrl.fnRtuStatusOptions(getState(ctrl.widgetSetting.deviceUnitState.state));
        }
    };

    var _setTimeOut = function _setTimeOut() {
        $timeout(function () {
            ctrl.liveUpdateItem = null;
            ctrl.liveUpdated = null;
            ctrl.liveMessage = null;
        }, 20000); // 20 Seconds
    };

    ctrl.wsDataReceivedANALOG_GII = function (data) {
        if (data.SN == ctrl.widgetSetting.device.serialNumber && ctrl.widgetSetting.mmPlusSetting.analogChannel == data.CH) {
            ctrl.widgetSetting.analogSetting.latestData = _convertFromMeters(ctrl.levelSensorUnitId, parseFloat(data.Value)).toFixed(ctrl.numberOfDecimals);
            ctrl.rtuTimeFormated = datetimeService.socketStrToServerStrTime(data.Time);
            ctrl.widgetSetting.analogSetting.localDateTime = ctrl.rtuTimeFormated;
            ctrl.widgetSetting.device.lastHeardTime = datetimeService.socketStrToServerStrTime(data.UtcDateTime);
            ctrl.buildMainClassDebounce();
        }
    };

    ctrl.wsDataReceivedTELEMETRYDATA = function (data) {
        if (data.Sn == ctrl.widgetSetting.device.serialNumber) {

            var lastHeardTime = datetimeService.socketStrToServerStrTime(data.RegTime);
            var varValue = data.Value;

            for (var i = 0; i < ctrl.widgetSetting.rtuTelemetry.length; i++) {

                switch (ctrl.widgetSetting.rtuTelemetry[i].name) {
                    case "Temperature":
                        ctrl.widgetSetting.rtuTelemetry[i].value = parseInt(varValue);
                        ctrl.widgetSetting.device.lastHeardTime = lastHeardTime;
                        ctrl.buildMainClassDebounce();
                        break;

                    case "Battery":
                        ctrl.widgetSetting.rtuTelemetry[i].value = parseFloat(varValue);
                        ctrl.widgetSetting.device.lastHeardTime = lastHeardTime;
                        ctrl.buildMainClassDebounce();
                        break;
                }
            }
        }
    };

    ctrl.registerListenerListDeviceState = function (varSerialNum) {
        //subscribe for digital setting changes
        websocketService.connect();
        websocketService.register('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.startOverview();
    };

    ctrl.unRegisterListenerListDeviceState = function (varSerialNum) {
        websocketService.connect();
        websocketService.unRegister('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.stopOverview();
    };

    ctrl.registerListenerAnalogData = function (varSerialNum) {
        //subscribe for digital setting changes
        if (ctrl.widgetSetting.mmPlusSetting.analogChannel > 0) {
            websocketService.connect();
            websocketService.register("ANALOG_G2", varSerialNum, ctrl.widgetSetting.mmPlusSetting.analogChannel, ctrl.wsDataReceivedANALOG_GII, null);
        }
    };

    ctrl.unRegisterListenerAnalogData = function (varSerialNum) {
        if (ctrl.widgetSetting.mmPlusSetting.analogChannel > 0) {
            websocketService.connect();
            websocketService.unRegister("ANALOG_G2", varSerialNum, ctrl.widgetSetting.mmPlusSetting.analogChannel, ctrl.wsDataReceivedANALOG_GII, null);
        }
    };

    ctrl.registerListenerTelemetryData = function (varSerialNum) {
        websocketService.connect();
        websocketService.register("TEMPERATURE", varSerialNum, "", ctrl.wsDataReceivedTELEMETRYDATA, null);
        websocketService.register("VBATT", varSerialNum, "", ctrl.wsDataReceivedTELEMETRYDATA, null);
    };

    ctrl.unRegisterListenerTelemetryData = function (varSerialNum) {
        websocketService.connect();
        websocketService.unRegister("TEMPERATURE", varSerialNum, "", ctrl.wsDataReceivedTELEMETRYDATA, null);
        websocketService.unRegister("VBATT", varSerialNum, "", ctrl.wsDataReceivedTELEMETRYDATA, null);
    };

    var _validateFloatChannel = function _validateFloatChannel() {
        if (!ctrl.validateFloatChannel) return;
        if (ctrl.widgetSetting.mmPlusSetting.digitalChannel > 0) if (!ctrl.widgetSetting.floatSettings.channel === ctrl.widgetSetting.mmPlusSetting.digitalChannel) ctrl.widgetSetting.mmPlusSetting.digitalChannel = 0;
        ctrl.validateFloatChannel = false;
    };

    ctrl.buildWidget = function (widgetData) {

        ctrl.widgetSetting = widgetData;

        _validateFloatChannel();

        //var _mmPlusGauge = ctrl.widgetSetting.mmPlusGauge; //ctrl.widgetSetting.mmPlusGauge[0].mmPlusGauge

        ctrl.registerListenerListDeviceState(ctrl.widgetSetting.device.serialNumber);
        ctrl.registerListenerAnalogData(ctrl.widgetSetting.device.serialNumber);

        ctrl.hudText = getState(ctrl.widgetSetting.deviceUnitState.state); // Options: AllNormal, Alarm, Alert, Service, CommFail

        ctrl.w_BorderWidth = 2; // Set the inside solid border of the HUD
        ctrl.w_BorderPadding = 5; // Set the outside opaque border outline

        ctrl.DisplayTimestamp();
        ctrl.setSize(_returnSizeId());
        ctrl.hudInfoId = ctrl.widgetSetting.mmPlusSetting.hudInfo;

        ctrl.buildMainClassDebounce();

        if (ctrl.widgetSetting.setting.displaySettingOn) {
            var newScope = $scope;
            var html = '<mc-widget-mm-plus-setting widget-setting="$ctrl.widgetSetting" ng-if="$ctrl.widgetSetting.setting.displaySetting" change-display-options="$ctrl.fnChangeDisplayOptions(settingOptions)"></mc-widget-mm-plus-setting>';
            var element = $element.find('.component-setting');
            if (element.is(':empty')) {
                element.append($compile(html)(newScope));
            }
        }

        ctrl.fnSizeOptions();
        ctrl.loadingInProgress = false;

        if (!angular.isUndefined(ctrl.widgetSetting.setting.flipToSetting) && ctrl.widgetSetting.setting.flipToSetting == true) {
            $timeout(function () {
                ctrl.mouseOverHUD();
                ctrl.editSetting();
            }, 0);
        }
    };

    ctrl.getData = function (deviceId, openSetting) {

        var _mmPlusGauge = new McMmPlusWidgetFactory(ctrl.accountInfo.customerId, deviceId, 9, ctrl.mcWidgetsSharedFactory.getWidgetIdByMmPlusType(ctrl.mmPlusType), ctrl.accountInfo.timeZone);

        _mmPlusGauge.getWidgetData().then(function () {
            ctrl.loadingInProgress = false;

            var device = _mmPlusGauge.list.device;
            var deviceUnitState = _mmPlusGauge.list.deviceUnitState;
            var deviceDigitalData = _mmPlusGauge.list.digitalData;
            var enteredStateTime = _mmPlusGauge.list.enteredStateTime;
            var floatSettings = _mmPlusGauge.list.floatSettings;
            var mmPlusSetting = _mmPlusGauge.list.mmPlusSetting;
            var rtuTelemetry = _mmPlusGauge.list.rtuTelemetry;
            var analogSetting = _mmPlusGauge.list.analogSetting;
            var levelReferences = _mmPlusGauge.list.levelReferences;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.widgetSetting.setting.displaySetting,
                displaySettingOn: ctrl.displaySettingOn
            };

            ctrl.mmPlusGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                deviceDigitalData: deviceDigitalData,
                enteredStateTime: enteredStateTime,
                floatSettings: floatSettings,
                mmPlusSetting: mmPlusSetting,
                rtuTelemetry: rtuTelemetry,
                mmPlusWidgetId: ctrl.mmPlusWidgetId,
                mmPlusType: ctrl.mmPlusType,
                setting: setting,
                analogSetting: analogSetting,
                levelReferences: levelReferences
            };

            $scope.alerts = [];

            ctrl.validateFloatChannel = true;

            if (ctrl.mmPlusGauge.analogSetting != null) ctrl.getLevelSensorUnit(ctrl.mmPlusGauge.analogSetting.unitOfValueID);

            ctrl.buildWidget(ctrl.mmPlusGauge);

            if (!angular.isUndefined(openSetting)) {
                $timeout(function () {
                    ctrl.mouseOverHUD();
                    ctrl.editSetting();
                }, 0);
            }

            ctrl.updateWidgetTitle();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.updateWidgetTitle = function () {
        ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.widgetSetting.device.deviceId, name: ctrl.widgetSetting.device.name, serialNumber: ctrl.widgetSetting.device.serialNumber, channel: 0, channelDescription: '', titleId: ctrl.widgetSetting.mmPlusSetting.titleId } });
    };

    ctrl.fnThemeOptions = function (themeOption) {
        ctrl.widgetSetting.mmPlusSetting.theme = themeOption.name;
        ctrl.widgetSetting.mmPlusSetting.themeId = themeOption.id;
        ctrl.buildMainClassDebounce();
    };

    ctrl.fnTitleOptions = function (titleOption) {
        ctrl.widgetSetting.mmPlusSetting.titleId = titleOption.id;
        ctrl.widgetSetting.mmPlusSetting.titleState = titleOption.state;
        ctrl.updateWidgetTitle();
    };

    ctrl.fnStateOptions = function (stateOption) {
        ctrl.widgetSetting.mmPlusSetting.stateId = stateOption.id;
        ctrl.widgetSetting.mmPlusSetting.stateDescription = stateOption.description;
        ctrl.buildMainClassDebounce();
    };

    ctrl.fnHeardTypeOptions = function (heardTypeOption) {
        ctrl.widgetSetting.mmPlusSetting.dateTimeFormat = heardTypeOption.type;
        ctrl.widgetSetting.mmPlusSetting.dateTimeFormatId = heardTypeOption.id;
        ctrl.DisplayTimestamp();
    };

    ctrl.fnSizeOptions = function (sizeOption, openSetting) {
        if (!ctrl.widgetSetting.setting.displaySetting) return;

        if (sizeOption != null) {
            ctrl.widgetSetting.mmPlusSetting.sizeId = sizeOption.id;
            ctrl.widgetSetting.mmPlusSetting.size = sizeOption.description;
        }

        ctrl.setSize(ctrl.widgetSetting.mmPlusSetting.sizeId);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.parent().addClass("ui-widget-content-mc");

            $timeout(function () {
                var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
                var svgW = parseInt(ctrl.popup.parent().find('svg').css("width"), 10);
                ctrl.popup.parent().css("height", svgH + "px");
                ctrl.popup.parent().css("width", svgW + "px");
                ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
                ctrl.popup.parent().find('.alert').css("position", "relative").css("left", 25 / 2 + "px");
            }, 100);
        }

        ctrl.closeSetting();
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);
        ctrl.buildMainClassDebounce();

        if (!angular.isUndefined(openSetting)) {
            $timeout(function () {
                ctrl.mouseOverHUD();
                ctrl.editSetting();
            }, 0);
        }
    };

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getMmPlusSize(sizeId, 1);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.fnColorOptions = function (colorOption) {
        ctrl.widgetSetting.mmPlusSetting.levelColor = colorOption.levelColor;
        ctrl.widgetSetting.mmPlusSetting.levelBlink = colorOption.levelBlink;
        ctrl.buildMainClassDebounce();
        //ctrl.closeSetting();
    };

    ctrl.fnRtuStatusOptions = function (rtuStatus) {
        ctrl.buildMainClassDebounce();
        ctrl.hudText = rtuStatus;
    };

    ctrl.fnHudInfoOption = function (hudInfoId) {
        ctrl.hudInfoId = hudInfoId;
        ctrl.buildMainClassDebounce();
    };

    ctrl.fnRtuOptions = function (rtuOption) {
        ctrl.widgetSetting.device.deviceId = rtuOption.deviceId;
        ctrl.webSocketReconnect(true);
    };

    ctrl.fnAnalogChannelOptions = function (analogChannel) {
        $rootScope.$broadcast('mmPlusWidgetSettingUpdate', { deviceId: ctrl.widgetSetting.device.deviceId });
        ctrl.webSocketReconnect(true);
    };

    ctrl.fnDigitalChannelOptions = function (digitalChannel) {
        $rootScope.$broadcast('mmPlusWidgetSettingUpdate', { deviceId: ctrl.widgetSetting.device.deviceId });
        ctrl.webSocketReconnect(true);
    };

    ctrl.fnChangeDisplayOptions = function (parSettingOptions) {
        if (!angular.isUndefined(parSettingOptions.titleOption)) {
            ctrl.fnTitleOptions(parSettingOptions.titleOption);
        }
        if (!angular.isUndefined(parSettingOptions.stateOption)) {
            ctrl.fnStateOptions(parSettingOptions.stateOption);
        }
        if (!angular.isUndefined(parSettingOptions.heardTypeOption)) {
            ctrl.fnHeardTypeOptions(parSettingOptions.heardTypeOption);
        }
        if (!angular.isUndefined(parSettingOptions.sizeOption)) {
            ctrl.fnSizeOptions(parSettingOptions.sizeOption, true);
        }
        if (!angular.isUndefined(parSettingOptions.themeOption)) {
            ctrl.fnThemeOptions(parSettingOptions.themeOption);
        }
        if (!angular.isUndefined(parSettingOptions.colorOption)) {
            ctrl.fnColorOptions(parSettingOptions.colorOption);
        }
        if (!angular.isUndefined(parSettingOptions.rtuOption)) {
            //if (ctrl.ignoreFnChangeDisplayOptions) {
            //    ctrl.ignoreFnChangeDisplayOptions = undefined;
            //}
            //else {
            //    ctrl.getData(parSettingOptions.rtuOption.deviceId, true);
            //}
            ctrl.fnRtuOptions(parSettingOptions.rtuOption);
        }
        if (!angular.isUndefined(parSettingOptions.hudInfoOption)) {
            ctrl.fnHudInfoOption(parSettingOptions.hudInfoOption.id);
        }
        if (!angular.isUndefined(parSettingOptions.analogChannelOption)) {
            ctrl.fnAnalogChannelOptions(parSettingOptions.analogChannelOption.channel);
        }
        if (!angular.isUndefined(parSettingOptions.digitalChannelOption)) {
            ctrl.fnDigitalChannelOptions(parSettingOptions.digitalChannelOption.channel);
        }
    };

    ctrl.editSetting = function (event) {
        ctrl.mcWidgetsSharedFactory.editSetting($element, event, ctrl);
    };

    ctrl.closeSetting = function () {
        ctrl.mcWidgetsSharedFactory.closeSetting($element, ctrl);
    };

    ctrl.mouseOverHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOver;
        }
    };
    ctrl.mouseOffHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOff;
        }
    };

    ctrl.resize_HUD = function (w_svgSizeW, w_svgSizeH) {
        ctrl.mcWidgetsSharedFactory.resizeHud(w_svgSizeW, w_svgSizeH, ctrl);
    };

    ctrl.webSocketHeartbeatReceived = function (data) {
        if (angular.isUndefined(ctrl.widgetSetting)) return; //The Widget has not initialized yetl
        ctrl.heartbeatDateTime = new Date(data.LocalDateTime).toISOString();
        ctrl.DisplayTimestamp();
    };

    ctrl.DisplayTimestamp = function () {

        if (angular.isUndefined(ctrl.widgetSetting.deviceUnitState)) return;

        if (ctrl.widgetSetting.deviceDigitalData === null) return;

        var reportDateTime = ctrl.widgetSetting.device.lastHeardTime;
        var currentDateTime = _returnUtcNow();
        var format = ctrl.widgetSetting.mmPlusSetting.dateTimeFormat;

        if (angular.isUndefined(reportDateTime) && angular.isUndefined(currentDateTime)) return;
        var _timestamp_Display;

        if (format === ctrl.translation.text.ABSOLUTE && reportDateTime !== "0001-01-01T00:00:00") {
            //if (format === "Absolute")
            _timestamp_Display = $filter('filterDateAgentTextTimeFormat')(datetimeService.UtcToLocalByTimeZone(reportDateTime, ctrl.accountInfo.timeZone), ctrl.preferredTimeFormat);
            var _substrings;
            _substrings = _timestamp_Display.split(' ');

            switch (_timestamp_Display.length) {
                case 7:case 8:case 9:case 10:case 11:
                    ctrl.timestamp_DisplayPre = "";
                    ctrl.timestamp_Display = _substrings[0] + (angular.isUndefined(_substrings[1]) ? " " : " " + _substrings[1]);
                    break;
                case 14:case 15:case 16:case 17:case 18:
                    ctrl.timestamp_DisplayPre = _substrings[0] + " " + _substrings[1];
                    ctrl.timestamp_Display = _substrings[2] + (angular.isUndefined(_substrings[3]) ? "" : " " + _substrings[3]);
                    break;
                case 19:case 20:case 21:case 22:case 23:
                    if (_substrings.length === 2) {
                        ctrl.timestamp_DisplayPre = _substrings[0];
                        ctrl.timestamp_Display = _substrings[1];
                    } else {
                        ctrl.timestamp_DisplayPre = _substrings[0] + " " + _substrings[1] + " " + _substrings[2];
                        ctrl.timestamp_Display = _substrings[3] + (angular.isUndefined(_substrings[4]) ? "" : " " + _substrings[4]);
                    }
                    break;
            }

            ctrl.buildStyle(12, ctrl.timestamp_Display.length, 24, ctrl.timestamp_DisplayStyle);
        } else {
            //if (format === "Elapsed")
            _timestamp_Display = ctrl.getPopupWindowDateTimeDifference(reportDateTime, currentDateTime, format);
            _timestamp_Display.then(function (value) {
                ctrl.timestamp_DisplayPre = "";
                ctrl.timestamp_Display = value;
                ctrl.buildStyle(10, ctrl.timestamp_Display.length, 24, ctrl.timestamp_DisplayStyle);
            });
        }
    };

    ctrl.buildStyle = function (numberOfFontsThatFits, strLength, maxFontSize, obj) {
        var _minFontSize = 25;
        obj["font-size"] = ctrl.adjustFontSize(numberOfFontsThatFits, strLength, _minFontSize, maxFontSize) + "px";
    };

    ctrl.adjustFontSize = function (numberOfFontsThatFits, strLength, minFontSize, maxFontSize) {
        var newFontSize = maxFontSize / strLength * numberOfFontsThatFits;
        return newFontSize > maxFontSize ? maxFontSize : newFontSize < minFontSize ? minFontSize : newFontSize;
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ctrl.buildMainClass = function () {

        var gaugeType = "TachGauge1"; // Options: TachGauge1 (Styled in mcwidgets.css)
        var mmPlusTransparentObj = "MmPlusTransparentObj";
        var mainClass = ["upWidget", gaugeType, ctrl.widgetSetting.mmPlusSetting.theme, "rtu" + getState(ctrl.widgetSetting.deviceUnitState.state), "acfail" + ctrl.widgetSetting.deviceUnitState.acFail, mmPlusTransparentObj];
        if ($rootScope.mobile) mainClass.push("widgetAlignCenter");
        var hudBorderClass = ["HUD-elements-A", "mmPlus", "rtu" + getState(ctrl.widgetSetting.deviceUnitState.state)];
        ctrl.mainClass = angular.copy(mainClass);
        ctrl.hudBorderClass = angular.copy(hudBorderClass);

        ctrl.hasDigitalChannel = ctrl.widgetSetting.mmPlusSetting.digitalChannel > 0;
        ctrl.hasAnalogChannel = ctrl.widgetSetting.mmPlusSetting.analogChannel > 0;

        ctrl.buildAnalogLevel();
        ctrl.buildSensor();
        ctrl.buildFloat();
        ctrl.updateHudInfo();

        if (getState(ctrl.widgetSetting.deviceUnitState.state) === "CommFail") ctrl.inputStatus = ctrl.translation.text.COMMS_FAULT;

        ctrl.mmPlusTextOverlayStyle = { "margin-top": "42.5%", "margin-left": "50%", "margin-right": "10%", "height": "15%", "color": "#000000", "font-size": ctrl.svgSizeW * .1 + "px" };
        ctrl.hideHudElements = _returnSizeId() <= 1 ? true : false; //<= 2
        ctrl.mcXsmallOnlyNo = _returnSizeId() === 0 ? true : false; //===1

        //ctrl.buildStyle(9, ctrl.inputStatus.length, 24, ctrl.inputStatusStyle);

        ctrl.updateWaterLevel();

        $timeout(function () {
            ctrl.svgStyle = angular.isUndefined(ctrl.svgStyleAdjustment) ? { "opacity": '1' } : _getSvgStyleAdjustments(ctrl.mmPlusType);

            if (ctrl.hideHudElements) {
                ctrl.svgViewBox = "46 5 350 430";
                ctrl.orbitStyle = { 'transform': 'translate(88px,120px) scale(.5)' };
                ctrl.hudStyle = { 'transform': 'translate(-55px, -202px)' };
            } else {
                ctrl.svgViewBox = "0 0 350 610";
                ctrl.orbitStyle = { 'transform': 'translate(88px,301px) scale(.5)' };
                ctrl.hudStyle = { 'transform': 'translate(-55px,-22px)' };
            }
        }, 100);
    };

    ctrl.convertTemperature = function (value) {
        var tmpValue = void 0;
        switch (ctrl.accountInfo.preferenceUser.lookupMeasurementID) {
            case 1:
                tmpValue = value * 9 / 5 + 32;
                break;

            default:
                tmpValue = value;
                break;
        }
        return tmpValue.toFixed(0);
    };

    ctrl.updateHudInfo = function () {
        for (var i = 0; i < ctrl.widgetSetting.rtuTelemetry.length; i++) {

            switch (ctrl.widgetSetting.rtuTelemetry[i].name) {
                case "Temperature":
                    ctrl.hudRowThree = ctrl.convertTemperature(ctrl.widgetSetting.rtuTelemetry[i].value);
                    ctrl.hudRowThreeA = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? "F" : "C";
                    break;

                case "Battery":
                    ctrl.hudRowTwo = ctrl.widgetSetting.rtuTelemetry[i].value.toFixed(1) + " " + ctrl.widgetSetting.rtuTelemetry[i].unit;
                    break;

                case "D.C.":
                case "A.C.":
                    ctrl.hudRowOne = ctrl.widgetSetting.rtuTelemetry[i].value.toFixed(1) + " " + ctrl.widgetSetting.rtuTelemetry[i].unit;
                    break;
            }
        }
    };

    ctrl.updateWaterLevelDigital = function () {

        if (ctrl.widgetSetting.deviceDigitalData === null || ctrl.widgetSetting.mmPlusSetting.digitalChannel === 0) {
            ctrl.waterLevelUp = false;
            return;
        }

        var floatSetting = ctrl.widgetSetting.floatSettings;

        if (floatSetting === null) {
            ctrl.waterLevelUp = false;
            return;
        }

        switch (ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.mmPlusSetting.digitalChannel]) {
            case "True":
                ctrl.waterLevelUp = floatSetting.normalClosed === 0 ? true : false;
                break;

            case "False":
                ctrl.waterLevelUp = floatSetting.normalClosed === 0 ? false : true;
                break;

            case "NULL":
            case "Fault":
            default:
                ctrl.waterLevelUp = false;
                break;
        }
    };

    ctrl.updateWaterLevel = function () {
        ctrl.updateWaterLevelDigital();
    };

    var _getSvgStyleAdjustments = function _getSvgStyleAdjustments(mmPlusType) {
        var _mmPlusType = angular.isUndefined(mmPlusType) ? "" : mmPlusType;

        switch (_mmPlusType.toUpperCase()) {
            default:
                return { "opacity": '1' };
        }
    };

    var _returnUtcNow = function _returnUtcNow() {
        var _a = $rootScope.heartbeatUtcDateTime;
        var _b = moment().utc().format('MM/DD/YY, h:mm:ss a').valueOf();
        var tmpTime = _a || _b;
        return tmpTime;
    };

    var _returnSizeId = function _returnSizeId() {
        if (angular.isUndefined(ctrl.sizeIdOverride) || ctrl.sizeIdOverride === "") {
            return ctrl.widgetSetting.mmPlusSetting.sizeId;
        } else return parseInt(ctrl.sizeIdOverride);
    };

    ctrl.openView = function ($event) {
        if (!$rootScope.mobile && !$rootScope.classicView) openViewService.openView(getView(ctrl.widgetSetting.deviceUnitState.state));
    };

    // from socket

    ctrl.updateValue = function (value) {
        switch (value) {
            case "null":
            case "-1":
                return "Fault";
                break;
            case "1":
                return "True";
                break;
            case "0":
                return "False";
                break;
            default:
                return "Fault";
                break;
        }
    };

    ctrl.wsDataReceivedDigital = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;

        var chValue = data.Value;
        var channel = parseInt(data.CH);
        var digValue = ctrl.updateValue(chValue);

        if (ctrl.widgetSetting.deviceDigitalData["d" + channel] !== digValue) {
            ctrl.widgetSetting.deviceDigitalData["d" + channel] = digValue;
            ctrl.widgetSetting.enteredStateTime["d" + channel] = datetimeService.socketStrToServerStrTime(data.UtcDateTime);
        }

        ctrl.widgetSetting.deviceDigitalData.regTime = datetimeService.socketStrToServerStrTime(data.UtcDateTime);
        ctrl.widgetSetting.deviceDigitalData.localTime = datetimeService.socketStrToServerStrTime(data.Time);
        ctrl.buildMainClassDebounce();
    };

    ctrl.webSocketReconnect = function (skipToaster) {
        ctrl.validateFloatChannel = true;
        ctrl.unRegisterListenerListDeviceState(ctrl.widgetSetting.device.serialNumber);
        ctrl.unRegisterListenerAnalogData(ctrl.widgetSetting.device.serialNumber);
        ctrl.unRegisterListenerTelemetryData(ctrl.widgetSetting.device.serialNumber);
        if (!skipToaster) toaster.pop('success', "MyLevel " + " -- " + ctrl.widgetSetting.device.name, 'View reloading');
        ctrl.getData(ctrl.widgetSetting.device.deviceId);
    };

    var _onHeartbeat = $rootScope.$on('Heartbeat', function (event, args) {
        if (args.message.Type === "HEARTBEAT") {
            ctrl.webSocketHeartbeatReceived(args.message);
        }
    });

    var _onDIGITALINPUT = $rootScope.$on('DIGITALINPUT', function (event, args) {
        ctrl.wsDataReceivedDigital(args.data);
    });

    var _onRECONNECT = $scope.$on('processReconnect', function (event, args) {
        ctrl.webSocketReconnect();
    });

    var _onDocumentClick = $rootScope.$on('document_click', function (event, args) {
        ctrl.closeSetting();
    });

    var _onUpdatePreferencesLanguage = $scope.$on('updatePreferencesLanguage', function () {
        ctrl.buildMainClassDebounce();
    });

    var _onUpdatePreferencesTimeFormat = $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.applyTimeFormat(timeFormat);
    });

    var _onWebSocketService = $rootScope.$on('WebSocketService', function (event, args) {
        if (args.message.SN === ctrl.widgetSetting.device.serialNumber && args.message.Type === "DIGITALSETTING" && args.message.Value.path === "digitalMode" || args.message.SN === ctrl.widgetSetting.device.serialNumber && args.message.Type === "DIGITALSETTING" && args.message.Value.path === "normalClosed" || args.message.SN === ctrl.widgetSetting.device.serialNumber && args.message.Type === "DEVICEBASICINFO" && args.message.Value.path === "mmPlusWidgetId" || args.message.SN === ctrl.widgetSetting.device.serialNumber && args.message.Type === "DEVICEBASICINFO" && args.message.Value.path === "name" || args.message.SN === ctrl.widgetSetting.device.serialNumber && args.message.Type === "ANALOGSETTING" && args.message.Value.path === "name") {
            ctrl.webSocketReconnect();
        }
    });

    var _updateMmPlusFloatSetting = $rootScope.$on('updateMmPlusFloatSetting', function (event, args) {

        if (!ctrl.ignoreUpdateMmPlusSetting == true) {
            ctrl.widgetSetting.mmPlusSetting = args;
            ctrl.buildMainClassDebounce();
        }

        ctrl.ignoreUpdateMmPlusSetting = false;
    });

    var _updateMmPlusAnalogSetting = $rootScope.$on('updateMmPlusAnalogSetting', function (event, args) {

        if (!ctrl.ignoreUpdateMmPlusSetting == true) {
            ctrl.webSocketReconnect();
        }

        ctrl.ignoreUpdateMmPlusSetting = false;
    });

    var _rtuAnalogUpdateMMPlus = $rootScope.$on('rtuAnalogUpdateMMPlus', function (event, args) {
        var _dataChanged = "channelDesc, unitOfValueID, manholeDepth, sensorDepth";
        if (args.deviceId == ctrl.widgetSetting.device.deviceId && _dataChanged.indexOf(args.fieldName) > -1) {
            ctrl.webSocketReconnect();
        }
    });

    var _updateThresholdsAndLevelReference = $rootScope.$on('updateThresholdsAndLevelReference', function (event, args) {
        var _dataChanged = "any";
        if (args.deviceId == ctrl.widgetSetting.device.deviceId && _dataChanged.indexOf(args.fieldName) > -1) {
            ctrl.webSocketReconnect();
        }
    });

    $scope.applyTimeFormat = function (timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat);
    };

    var _removeAllListeners = function _removeAllListeners() {
        _onHeartbeat();
        _onDocumentClick();
        _onDIGITALINPUT();
        _onRECONNECT();
        _onWebSocketService();
        _setTimeOut();
        _updateMmPlusFloatSetting();
        _updateMmPlusAnalogSetting();
        _rtuAnalogUpdateMMPlus();
        _updateThresholdsAndLevelReference();
        _onUpdatePreferencesLanguage();
        _onUpdatePreferencesTimeFormat();
        ctrl.unRegisterListenerListDeviceState(ctrl.widgetSetting.device.serialNumber);
        ctrl.unRegisterListenerAnalogData(ctrl.widgetSetting.device.serialNumber);
        ctrl.unRegisterListenerTelemetryData(ctrl.widgetSetting.device.serialNumber);
    };

    $scope.$on("$destroy", function () {
        _removeAllListeners();
    });

    $scope.$on("StopOverview", function (event, args) {
        if ($scope.$$destroyed) {
            // The scope is already destroyed, skip further processing.
            return;
        } else if (args.stop) {
            websocketService.connect();
            websocketService.startOverview();
        }
    });
}

McWidgetMmPlusDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'debounceService', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'McMmPlusWidgetFactory', 'authenticationService', 'translationService', 'PopupFactory', 'detectBrowserService', 'McWidgetsSharedFactory', '$filter', 'openViewService', '$http', 'HOST'];
'use strict';

angular.module('mc.widget-mmplus-display').component('mcWidgetMmPlusDisplay', {
    controller: McWidgetMmPlusDisplayController,
    templateUrl: 'ui/mmplus/mcwidgetmmplusdisplay/mcwidget-mmplus-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        settingShow: '<',
        changeWidgetTitle: '&',
        labelMode: '@',
        additionalSize: '@',
        sizeIdOverride: '@',
        themeIdOverridePopupOnly: '@',
        svgStyleAdjustment: '@'
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function mmPlusChannelsController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, MMPlusRtuSettingFactory, deviceService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyProperties = ctrl.stickyProperties;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        $scope.windowTitle = ctrl.windowTitle; //need for
        //fetch complete device details from deviceMenu cache, this is required oninit()
        ctrl.myDevice = deviceMenuService.getDevice(ctrl.stickyProperties.deviceId);
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this2);
        ctrl.initializeSetting();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
                //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        };
    };

    //var _tabConfiguration = function () {
    //    var len = arguments.length;
    //    var tmpLength = ctrl.tabConfiguration.length;
    //    for (var i = 0; i < len; i++) {
    //        if (tmpLength == 0) {
    //            ctrl.tabConfiguration.push(arguments[i]);
    //        } else {
    //            ctrl.tabConfiguration[i].name = arguments[i].name;
    //        }
    //    }
    //};

    ctrl.initializeSetting = function () {
        //_tabConfiguration(
        //    {
        //        "id": "AnalogChannel",
        //        "name": "Analog",
        //        "templateName": "Mm Plus Analog Channel",
        //        "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/analog/mm-plus-analog-channel.html",
        //        "height": 150
        //    },
        //    {
        //      "id": "DigitalChannel",
        //      "name": "Digital",
        //      "templateName": "Mm Plus Digital Channel",
        //      "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/digital/mm-plus-digital-channel.html",
        //      "height": 150
        //  },
        //   {
        //       "id": "AnalogOutputChannel",
        //       "name": "Analog Output",
        //       "templateName": "Mm Plus Analog Output Channel",
        //       "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/analogOutput/mm-plus-analog-output-channel.html",
        //       "height": 150
        //   },
        //   {
        //       "id": "DigitalOutputChannel",
        //       "name": "Digital Output",
        //       "templateName": "Mm Plus Digital Output Channel",
        //       "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/digitalOutput/mm-plus-digital-output-channel.html",
        //       "height": 150
        //   },
        //   {
        //       "id": "PulseInputChannel",
        //       "name": "Pulse Input",
        //       "templateName": "Mm Plus Pulse Input Channel",
        //       "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/pulseInput/mm-plus-pulse-input-channel.html",
        //       "height": 150
        //   },
        //   {
        //     "id": "RegisterIOChannel",
        //     "name": "Register IO",
        //     "templateName": "Mm Plus Register IO Channel",
        //     "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/registerIO/mm-plus-register-io-channel.html",
        //     "height": 150
        // }
        //);

        //loading each tab, if AI/DI/DO channels are allowed on the specific device
        if (ctrl.myDevice.genII && ctrl.myDevice.maxAnalogInputs > 0) {
            ctrl.tabConfiguration.push({
                "id": "AnalogChannel",
                "name": "Analog",
                "templateName": "Mm Plus Analog Channel",
                "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/analog/mm-plus-analog-channel.html",
                "height": 150
            });
        }
        if (ctrl.myDevice.genII && ctrl.myDevice.maxDigitalInputs > 0) {
            ctrl.tabConfiguration.push({
                "id": "DigitalChannel",
                "name": "Digital",
                "templateName": "Mm Plus Digital Channel",
                "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/digital/mm-plus-digital-channel.html",
                "height": 150
            });
        }
        if (ctrl.myDevice.genII && ctrl.myDevice.maxDigitalOutputs > 0) {
            ctrl.tabConfiguration.push({
                "id": "DigitalOutputChannel",
                "name": "Digital Output",
                "templateName": "Mm Plus Digital Output Channel",
                "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/digitalOutput/mm-plus-digital-output-channel.html",
                "height": 150
            });
        }
        ctrl.mmPlusChannelTabs = ctrl.tabConfiguration;
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        // return 'ui/mmplusrtusetting/' + (tab.templateName).toLowerCase().replace(' ', '-') + '.html';
    };

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;
            $scope.deviceSelected = newValue;
            var _device = { deviceId: newValue, deviceName: $scope.$parent.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });

            if (!angular.isUndefined(ctrl.currentDevice)) return;

            ctrl.currentDevice = newValue;

            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    //if(deviceMenuService.getskuId() !== 2)
                    //{                   
                    //     var index =(ctrl.tabConfiguration.findIndex(c=>c.name =='Analog'));
                    //     ctrl.tabConfiguration.splice(index, 1);
                    // }
                    ctrl.alertMessage = null;
                } else {
                    ctrl.data = null;
                    ctrl.alertMessage = "Please configure the device as Gen 2";
                    ctrl.configButtonVisible = false;
                }
            });
        }
    }, true);

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });
}

mmPlusChannelsController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusChannels', {
    controller: mmPlusChannelsController,
    templateUrl: 'ui/mmplusrtusetting/mmPlusChannel/mm-plus-channel-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.mmplus-widget", []);
'use strict';

function McMmPlusWidgetFactory(HOST, $http) {

    // instantiate our initial object
    var McMmPlusWidget = function McMmPlusWidget(customerId, deviceId, categoryId, widgetId, timeZone) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.timeZone = timeZone;
    };

    McMmPlusWidget.prototype.getWidgetData = function () {
        var self = this;
        return $http.get(HOST + '/api/MmPlusWidget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McMmPlusWidget;
}

McMmPlusWidgetFactory.$inject = ['HOST', '$http'];

angular.module('mc.pump-station-widget').factory('McMmPlusWidgetFactory', McMmPlusWidgetFactory);

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

mcapp.factory("mmPlusWidgetService", ["$http", "HOST", function ($http, HOST) {
    var mmPlusWidgetFatory = {};

    var _getSettings = function _getSettings(customerId, deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/MmPlusWidget?customerId=' + customerId + '&deviceId=' + deviceId,
            cache: false
        });
    };
    mmPlusWidgetFatory.getSettings = _getSettings;
    return mmPlusWidgetFatory;
}]);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function McMmPlusWidgetController($, $rootScope, $scope, $sce, $element, authenticationService, sharedSetupService, McMmPlusWidgetFactory, $timeout, McWidgetsSharedFactory, toaster, translationService, deviceMenuService, $q) {

    var ctrl = this;
    ctrl.closeIcon = false;

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 3);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.notSetup = function () {
        ctrl.mmPlusGauge = null;
        $scope.$emit('mmPlusWidgetDone_' + $scope.windowId, { message: true });
        ctrl.loadingInProgress = false;
        $scope.alerts.push({ msg: ctrl.translation.text.NOT_SETUP, type: "info" });
    };

    ctrl.$onChanges = function (changes) {
        if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
            $element.off("mouseover.mcMmPlusGauge");
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;

            ctrl.getMmPlusInfo(ctrl.accountInfo.customerId, changes.deviceSelected.currentValue).then(function (resp) {
                ctrl.getData(changes.deviceSelected.currentValue);
            });
        } else if (changes.deviceSelected.previousValue) {
            (function (event) {
                ctrl.popup.parent().off("mouseover");
                ctrl.popup.parent().off("mouseout");
            });
            ctrl.mmPlusGauge = null;
        }
    };

    ctrl.$onInit = function () {
        ctrl.mobile = $rootScope.mobile;
        ctrl.displaySettingOn = ctrl.settingShow;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.loadingInProgress = false;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;

        if (_typeof(ctrl.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        //Saved Desktop
        if ($scope.stickyProperties.device.deviceId !== null) {
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.device.deviceId, windowId: $scope.windowId });
            ctrl.getMmPlusInfo(ctrl.accountInfo.customerId, $scope.stickyProperties.device.deviceId).then(function (resp) {
                ctrl.getData($scope.stickyProperties.device.deviceId);
            });
        }
    };

    ctrl.getData = function (deviceId) {

        $scope.alerts = [];

        if (ctrl.mmPlusWidgetId === 0) {
            ctrl.notSetup();
            return;
        }

        var _mmPlusGauge = new McMmPlusWidgetFactory(ctrl.accountInfo.customerId, deviceId, 9, ctrl.mmPlusWidgetId, ctrl.accountInfo.timeZone);

        _mmPlusGauge.getWidgetData().then(function () {

            ctrl.loadingInProgress = false;
            var device = _mmPlusGauge.list.device;
            var deviceUnitState = _mmPlusGauge.list.deviceUnitState;
            var deviceDigitalData = _mmPlusGauge.list.digitalData;
            var enteredStateTime = _mmPlusGauge.list.enteredStateTime;
            var floatSettings = _mmPlusGauge.list.floatSettings;
            var mmPlusSetting = _mmPlusGauge.list.mmPlusSetting;
            var rtuTelemetry = _mmPlusGauge.list.rtuTelemetry;
            var analogSetting = _mmPlusGauge.list.analogSetting;
            var levelReferences = _mmPlusGauge.list.levelReferences;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.displaySettingOn,
                displaySettingOn: ctrl.displaySettingOn,
                flipToSetting: $scope.stickyProperties.setting
            };
            ctrl.mmPlusGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                deviceDigitalData: deviceDigitalData,
                enteredStateTime: enteredStateTime,
                floatSettings: floatSettings,
                mmPlusSetting: mmPlusSetting,
                rtuTelemetry: rtuTelemetry,
                mmPlusWidgetId: ctrl.mmPlusWidgetId,
                mmPlusType: ctrl.mmPlusType,
                setting: setting,
                analogSetting: analogSetting,
                levelReferences: levelReferences
            };

            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.additionalSetting();
            $scope.$emit('mmPlusWidgetDone_' + $scope.windowId, { message: true });
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.getMmPlusWidgetId = function (customerId, deviceId) {
        var deferred = $q.defer();
        var _mmPlusWidgetId = 0;
        var _defaultMmPlusWidgetId = 25; //Default, WIdgetId == 25 -> "MM+ with Level Sensor";

        //deviceMenuService.getDeviceMenuList(customerId)
        //    .then(function (result) {
        //        var _devices = result.data.devices;

        //        for (var index = 0; index < _devices.length; ++index) {
        //            if (_devices[index].deviceId === deviceId) {
        //                _mmPlusWidgetId = _devices[index].mmPlusWidgetId;
        //                _mmPlusWidgetId = _mmPlusWidgetId === 0 ? _defaultMmPlusWidgetId : _mmPlusWidgetId;
        //                deferred.resolve(_mmPlusWidgetId);
        //            }
        //        }
        //    }, function (error) {
        //            deferred.resolve(_defaultMmPlusWidgetId);
        //    });

        deferred.resolve(_defaultMmPlusWidgetId);

        return deferred.promise;
    };

    ctrl.getMmPlusInfo = function (customerId, deviceId) {

        var deferred = $q.defer();

        ctrl.getMmPlusWidgetId(ctrl.accountInfo.customerId, deviceId).then(function (resp) {
            ctrl.mmPlusWidgetId = resp;
            ctrl.mmPlusType = ctrl.mcWidgetsSharedFactory.getMmPlusTypeByWidgetId(ctrl.mmPlusWidgetId);
            deferred.resolve();
        });

        return deferred.promise;
    };

    ctrl.mostRecentData = function () {
        ctrl.loadingInProgress = true;
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.mmPlusGauge.device.name, 'View reloading');
        ctrl.getData(ctrl.mmPlusGauge.device.deviceId);
    };

    ctrl.fnChangeWidgetTitle = function (titleOption) {
        var _device = { channel: titleOption.channel, deviceId: titleOption.deviceId, deviceName: titleOption.name, serialNumber: titleOption.serialNumber };
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: titleOption.deviceId, device: _device, windowId: $scope.windowId });
        ctrl.mcWidgetsSharedFactory.setTitle($element, titleOption.name, "", titleOption.titleId);
    };

    ctrl.additionalSetting = function () {

        if (!ctrl.displaySettingOn) return;

        ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.popup.dialog({ resizable: false });

        ctrl.mcWidgetsSharedFactory.setTitle($element, ctrl.mmPlusGauge.device.name, "", 0); //ctrl.mmPlusGauge.mmPlusSetting.titleId); NEED TO FIX NEED TO FIX NEED TO FIX NEED TO FIX NEED TO FIX NEED TO FIX NEED TO FIX

        ctrl.popup.parent().find("div.ui-widget-content ").css('overflow', 'visible');

        ctrl.closeWidget = function () {
            ctrl.popup.dialog("close");
        };

        ctrl.setSize(88); //ctrl.mmPlusGauge.mmPlusSetting.sizeId); NEED TO FIX NEED TO FIX NEED TO FIX NEED TO FIX NEED TO FIX NEED TO FIX NEED TO FIX
        ctrl.popup.parent().addClass("ui-widget-content-mc");

        $timeout(function () {
            var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
            ctrl.popup.parent().css("height", svgH + "px");
            ctrl.popup.parent().css("width", svgH + 25 + "px");
            ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
        }, 0);

        ctrl.popup.parent().on("mouseover", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().addClass("x-resize");
                ctrl.closeIcon = true;
            });
        });

        ctrl.popup.parent().on("mouseout", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().removeClass("x-resize");
                if (ctrl.isTouchSupported()) {
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 3000);
                } else {
                    ctrl.closeIcon = false;
                }
            });
        });

        ctrl.isTouchSupported = function () {
            var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
            var generalTouchEnabled = "ontouchstart" in document.createElement("div");

            if (msTouchEnabled || generalTouchEnabled) {
                return true;
            }
            return false;
        };

        $scope.$on("$destroy", function (event) {
            ctrl.popup.parent().off("mouseover");
            ctrl.popup.parent().off("mouseout");
        });
    };
}

McMmPlusWidgetController.$inject = ["$", "$rootScope", "$scope", "$sce", "$element", "authenticationService", "sharedSetupService", "McMmPlusWidgetFactory", "$timeout", "McWidgetsSharedFactory", "toaster", "translationService", "deviceMenuService", "$q"];
'use strict';

angular.module('mc.mmplus-widget').component('mcMmPlusWidget', {
    controller: McMmPlusWidgetController,
    templateUrl: 'ui/mmplus/mcmmpluswidget/mc-mmplus-widget-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        sizeIdOverride: '@',
        settingShow: '<'
    }
});
'use strict';

function mmPlusChannelController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, MMPlusRtuSettingFactory, deviceService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = ctrl.stickyProperties;
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.channel = 1;
        ctrl.channelTypeID = 1;
        ctrl.loading = true;
        ctrl.channels = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];
        ctrl.electMode = [{ id: 0, name: 'DIGITAL_DRY_CONTACT' }, { id: 1, name: 'DIGITAL_DRY_CONTACT_NF' }, { id: 2, name: 'DIGITAL_LOAD_SENSOR' }, { id: 3, name: 'DIGITAL_LOAD_SENSOR_NF' }];
        ctrl.analogInputHWSetup = [{ id: 0, name: '(Volts) MyDro HW & Adams Modules' }, { id: 1, name: '(4-20 mA) MyDro HW & Adams Modules' }, { id: 2, name: '(0-20 mA) Adams Modules' }];
        ctrl.runtimeMode = [{ id: 0, name: 'Digital Input Disabled' }, { id: 1, name: 'Digital Input Runtime' }, { id: 2, name: 'Digital Input Alarm' }, { id: 3, name: 'Digital Input Sim. Runtime' }];
        ctrl.unitOfValue = [{ id: 0, name: 'Volts' }, { id: 1, name: 'mA' }, { id: 2, name: 'Amps' }, { id: 3, name: 'Feet' }, { id: 4, name: 'Inches' }, { id: 5, name: 'Meters' }, { id: 6, name: 'mm' }, { id: 7, name: 'GPM' }, { id: 8, name: 'PSI' }, { id: 9, name: 'pH' }, { id: 10, name: 'NTU' }, { id: 11, name: '%' }, { id: 12, name: 'ppm' }, { id: 13, name: 'MGD' }, { id: 14, name: 'mg/l' }, { id: 15, name: 'Hz' }, { id: 16, name: 'C' }, { id: 17, name: 'F' }, { id: 18, name: 'gal' }, { id: 19, name: 'KGal' }, { id: 20, name: 'lbs' }, { id: 21, name: 'uS' }, { id: 23, name: 'Centimeters' }];
        ctrl.accessMode = [{ id: 0, name: 'Read' }, { id: 1, name: 'Write' }, { id: 2, name: 'Read/Write' }];
        ctrl.analogFilter = [{ id: 0, name: 'Default FIR filter - 5 sample, equal weights' }, { id: 1, name: 'IIR Filter - Fast Beta' }, { id: 2, name: 'IIR Filter - Slow Beta' }];
        ctrl.channelType = [{ id: 0, name: '(AI) Analog Input channel' }, { id: 1, name: '(DI) Digital Input channel' }, { id: 2, name: 'PI Pulse Input channel' }, { id: 3, name: '(RIO)	Register I/O channel' }, { id: 4, name: '(AO) Analog Output channel' }, { id: 5, name: '(DO) Digital Output channel' }];
        ctrl.regAddrMode = [{ id: 1, name: 'USE COIL ADDRESS' }, { id: 2, name: 'USE REGISTER ADDRESS' }];
        ctrl.nonc = [{ id: 0, name: 'NORMALLY OPEN' }, { id: 1, name: 'NORMALLY CLOSED' }];
    };

    ctrl.getData = function () {
        ctrl.MMPlusRtuSettingFactory.getData(ctrl.deviceId, ctrl.channel, ctrl.channelTypeID).then(function (result) {
            ctrl.data = result.data;
            ctrl.filterInputFieldsByChannelType();
            ctrl.networkDeviceConfigID = ctrl.data.networkDeviceConfigID;
            ctrl.loading = false;
            ctrl.getImei();
            if (!ctrl.data) {
                ctrl.dataAvailable = false;
                ctrl.setDefaultData();
                ctrl.configButtonVisible = false;
                ctrl.MMPlusRtuSettingFactory.PostChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.data);
            } else {
                ctrl.dataAvailable = true;
                ctrl.configButtonVisible = true;
            }
        }, function (error) {
            //error
        });
    };

    ctrl.getImei = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loadingInProgress = false;
        });
    };

    ctrl.addMode = function () {
        ctrl.addMode = true;
        ctrl.data = {
            networkDeviceConfigID: ctrl.networkDeviceConfigID,
            deviceID: ctrl.deviceId,
            channelNo: 1,
            channelTypeID: 1,
            registerAddr: 40001,
            accessModeID: 0,
            alarmHighRestore: 0,
            alarmHighThreshold: 0,
            alarmLowRestore: 0,
            alarmLowThreshold: 0,
            analogFilterID: 0,
            analogInputHWSetupID: 0,
            bitOfInterest: 0,
            cfgValue: 0,
            deEnergizeOnCommLoss: false,
            debounceTimeSecs: 0,
            electModeID: 0,
            floatToIntegerScale: 0,
            msgTransmitRate: 2,
            pulseTimeSecs: 0,
            regAddressModeID: 1,
            runtimeModeID: 0,
            scalingOffset: 0,
            scalingRange: 0,
            sendOnPercentageChg: 0,
            startUpValue: 0,
            unitOfValueID: 0,
            sampleInterval: 1,
            nonc: false
        };
    };
    ctrl.postData = function (path) {
        if (path == 'channelTypeID') ctrl.filterInputFieldsByChannelType();
        var tmpDevice = { "op": "replace", "path": path, "value": ctrl.data[path] };
        console.log(tmpDevice);
        ctrl.MMPlusRtuSettingFactory.PatchChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.channelTypeID, ctrl.networkDeviceConfigID, tmpDevice).then(function (result) {
            ctrl.data = result.data;
            ctrl.dataAvailable = true;
            ctrl.configButtonVisible = true;
        }, function (error) {
            //error
        });
    };

    ctrl.filterInputFieldsByChannelType = function () {
        ctrl.showAnalogInputHWSetupID = false;
        ctrl.showAnalogFilterID = false;
        ctrl.showUnitOfValueID = false;
        ctrl.showScalingOffset = false;
        ctrl.showScalingRange = false;
        ctrl.showAlarmLowThreshold = false;
        ctrl.showAlarmLowRestore = false;
        ctrl.showAlarmHighThreshold = false;
        ctrl.showAlarmHighRestore = false;
        ctrl.showFloatToIntegerScale = false;
        ctrl.showMsgTransmitRate = false;
        ctrl.showSendOnPercentageChg = false;
        ctrl.showBitOfInterest = false;
        ctrl.showElectModeID = false;
        ctrl.showRuntimeModeID = false;
        ctrl.showDebounceTimeSecs = false;
        ctrl.showSampleInterval = false;
        ctrl.showRegAddressModeID = false;
        ctrl.showPulseTimeSecs = false;
        ctrl.showDeEnergizeOnCommLoss = false;
        ctrl.showAccessModeID = false;
        ctrl.showCfgValue = false;

        switch (ctrl.data.channelTypeID) {
            case 0:
                ctrl.showAnalogInputHWSetupID = true;
                ctrl.showAnalogFilterID = true;
                ctrl.showUnitOfValueID = true;
                ctrl.showScalingOffset = true;
                ctrl.showScalingRange = true;
                ctrl.showAlarmLowThreshold = true;
                ctrl.showAlarmLowRestore = true;
                ctrl.showAlarmHighThreshold = true;
                ctrl.showAlarmHighRestore = true;
                ctrl.showFloatToIntegerScale = true;
                ctrl.showMsgTransmitRate = true;
                ctrl.showSendOnPercentageChg = true;
                ctrl.channels = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];
                break;
            case 1:
                ctrl.showBitOfInterest = true;
                ctrl.showElectModeID = true;
                ctrl.showRuntimeModeID = true;
                ctrl.showDebounceTimeSecs = true;
                ctrl.showSampleInterval = true;
                ctrl.channels = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];
                break;
            case 2:
                ctrl.showMsgTransmitRate = true;
                ctrl.channels = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];
                break;
            case 3:
                ctrl.showAccessModeID = true;
                ctrl.showCfgValue = true;
                ctrl.channels = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];
                break;
            case 4:
                ctrl.showAnalogInputHWSetupID = true;
                ctrl.channels = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];
                break;
            case 5:
                ctrl.showBitOfInterest = true;
                ctrl.showRegAddressModeID = true;
                ctrl.showPulseTimeSecs = true;
                ctrl.showDeEnergizeOnCommLoss = true;
                ctrl.channels = [{ id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }, { id: 11 }, { id: 12 }, { id: 13 }, { id: 14 }, { id: 15 }, { id: 16 }, { id: 17 }, { id: 18 }, { id: 19 }];
                break;
            default:
                break;
        }
    };

    ctrl.setDefaultData = function () {
        ctrl.data = {
            networkDeviceConfigID: ctrl.networkDeviceConfigID,
            deviceID: ctrl.deviceId,
            channelNo: ctrl.channel,
            channelTypeID: 1,
            registerAddr: 40001,
            accessModeID: 0,
            alarmHighRestore: 0,
            alarmHighThreshold: 0,
            alarmLowRestore: 0,
            alarmLowThreshold: 0,
            analogFilterID: 0,
            analogInputHWSetupID: 0,
            bitOfInterest: 0,
            cfgValue: 0,
            deEnergizeOnCommLoss: false,
            debounceTimeSecs: 0,
            electModeID: 0,
            floatToIntegerScale: 0,
            msgTransmitRate: 2,
            pulseTimeSecs: 0,
            regAddressModeID: 1,
            runtimeModeID: 0,
            scalingOffset: 0,
            scalingRange: 0,
            sendOnPercentageChg: 0,
            startUpValue: 0,
            unitOfValueID: 0,
            sampleInterval: 1,
            nonc: false
        };
        ctrl.dataAvailable = true;
    };

    ctrl.configure = function () {
        ctrl.MMPlusRtuSettingFactory.configMMPlusChannel(ctrl.deviceId, ctrl.imei, ctrl.channel, ctrl.data.channelTypeID).then(function (result) {
            //success
            var configResult = result.data.result.match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
            ctrl.alertMessage = "Channel Config " + configResult[0] + ": " + configResult[1];
            ctrl.setTimeOut();
        }, function (error) {
            //error
            ctrl.alertMessage = "Something went wrong while processing channel config request";
            ctrl.setTimeOut();
        });
    };

    ctrl.clickLog = function () {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = ctrl.deviceId;
        optionsStickyProperties.device = { deviceId: ctrl.deviceId, title: "", deviceName: ctrl.deviceSelectedName, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };
        //optionsStickyProperties.channel = { deviceId: ctrl.deviceId, channel: ctrl.channel, networkDeviceConfigID: ctrl.networkDeviceConfigID };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/log/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };
            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 40;

            //openViewService.openView('MM Plus Config History', { width: 700, height: 400 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });

            openViewService.openView('MM Plus Channel History', { width: 820, height: 420 }, { my: 'right-10 top+6', at: 'right top', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 }, false);
        }
    };

    $scope.$on('syncG2ChannelConfig', function (event, args) {
        if (args.deviceID == ctrl.deviceId) {
            ctrl.channelDeviceConfig = args;
            ctrl.updateChannelConfigData(ctrl.channelDeviceConfig);
        }
    });

    //getChannelConfigHistory = customerId, deviceId, channel, netwrokDeviceConfigID, channelConfig
    ctrl.updateChannelConfigData = function (channelConfig) {
        ctrl.MMPlusRtuSettingFactory.updateChannelConfig(ctrl.accountInfo.customerId, ctrl.deviceId, ctrl.channel, ctrl.networkDeviceConfigID, channelConfig).then(function (result) {
            ctrl.data = result.data;
        }, function (error) {
            //error
        });
    };

    ctrl.setTimeOut = function () {
        setTimeout(function () {
            ctrl.alertMessage = null;
        }, 15000); // 15 Seconds
    };
    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;
            $timeout(function () {
                ctrl.getData();
            }, 0);
        }
    }, true);

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });

    if (!ctrl.mobile && !ctrl.classicView) {
        ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
        sharedSetupService.maximize(ctrl.popup);

        $scope.adjustSize = function () {
            ctrl.adjustSize();
        };

        ctrl.popup.dialog({
            resize: function resize(event, ui) {
                ctrl.adjustSize();
            }
        });

        ctrl.popup.dialogExtend({
            maximize: function maximize(event, ui) {
                openViewService.adjustContentSizeStart(ctrl.popup);
                ctrl.adjustSize();
            },
            restore: function restore(event, ui) {
                openViewService.adjustContentSizeStart(ctrl.popup);
                ctrl.adjustSize();
            }
        });

        ctrl.adjustSize = function () {
            var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            ctrl.popup.parent().css("height", _tmpHeight);
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
            //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
        };
    };
};

mmPlusChannelController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusChannel', {
    controller: mmPlusChannelController,
    templateUrl: 'ui/mmplusrtusetting/channel/mm-plus-channel-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function mmPlusConfigurationHistoryController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, MMPlusRtuSettingFactory, deviceService, MMPlusRtuConfigHistoryFactory) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.configHistory = [];
    ctrl.operatingModes = [{ id: 0, name: 'Manufacturing', modeCode: 0 }, { id: 1, name: 'Manufacturing Mode 2', modeCode: 1 }, { id: 2, name: 'Monitoring', modeCode: 2 }];
    ctrl.floatTypes = [{ id: 0, name: 'None', modeCode: 0 }, { id: 1, name: 'Optical', modeCode: 1 }, { id: 2, name: 'Mechanical', modeCode: 2 }];
    ctrl.skus = [{ SKUID: 0, SKUName: 'M84-O' }, { SKUID: 1, SKUName: 'M84-F' }, { SKUID: 2, SKUName: 'M84-L' }];
    ctrl.hasModbusRTU = false;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.windowTitle = "MM Plus Config History"; //need for
        ctrl.windowTitle = "MM Plus Config History";
        ctrl.deviceSelectedName = ctrl.stickyProperties.device.deviceName;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.MMPlusRtuConfigHistoryFactory = new MMPlusRtuConfigHistoryFactory(ctrl.accountInfo.customerId);
        ctrl.deviceId = ctrl.stickyProperties.deviceId;
        $scope.alerts = [];

        ctrl.MMPlusRtuSettingFactory.getDeviceConfigData(ctrl.deviceId, true).then(function (result) {
            if (result.data) {
                var index = result.data.findIndex(function (l) {
                    return l.networkDeviceTypeID >= 13 && l.networkDeviceTypeID <= 16;
                });
                ctrl.hasModbusRTU = index >= 0 ? true : false;
            }
        });

        ctrl.getConfigHistory(false);
        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
                //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        };
    };

    ctrl.getConfigHistory = function (isRefresh) {
        ctrl.configHistoryData = [];
        $scope.alerts = [];
        var numberOfDays = 3,
            varDateRangeStart,
            varDateRangeEnd,
            varDateRangeEndTmp;
        if (ctrl.stickyProperties.savedDesktop === true) {
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
            varDateRangeEnd = ctrl.myDateRangeEnd;
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeStart = ctrl.myDateRangeStart;
            varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
        } else {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }
        //used for refresh button to reload newest data
        if (isRefresh) {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }
        if ((ctrl.mobile || ctrl.classicView) && !(new Date(varDateRangeStart).getTime() > 0 && new Date(varDateRangeEnd).getTime() > 0)) {
            var tmpDates = sharedSetupService.getLiveDates();
            varDateRangeStart = tmpDates.startDate;
            varDateRangeEnd = tmpDates.endDate;

            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(tmpDates.endDate);
        }

        ctrl.loading = true;
        ctrl.MMPlusRtuConfigHistoryFactory.getDeviceConfigHistory(ctrl.deviceId, varDateRangeStart, varDateRangeEnd).then(function (result) {
            if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: ctrl.windowId });
            ctrl.loading = false;
            if (result.data.length > 0) {
                ctrl.configHistoryData = result.data;
                var index = result.data.findIndex(function (l) {
                    return l.skuid < 2;
                });
                ctrl.displayLowFloat = index >= 0 ? true : false;
            } else {
                var errormsg = ctrl.translation.message.NO_DATA + ": " + moment(varDateRangeStart).format('MM/DD/YY, h:mm:ss a') + " - " + moment(varDateRangeEnd).format('MM/DD/YY, h:mm:ss a');
                $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            }
        }, function (error) {
            //error
        });
    };

    ctrl.goSelectReportData = function () {
        ctrl.getConfigHistory(false);
    };

    ctrl.mostRecentData = function () {
        ctrl.getConfigHistory(true);
    };

    ctrl.syncConfig = function (config) {
        $rootScope.$broadcast('syncDeviceG2ExtConfig', config);
    };

    ctrl.setTimeOut = function () {
        setTimeout(function () {
            ctrl.alertMessage = null;
        }, 15000); // 15 Seconds
    };
    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;
            $timeout(function () {
                ctrl.getData();
            }, 0);
        }
    }, true);
};

mmPlusConfigurationHistoryController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService', 'MMPlusRtuConfigHistoryFactory'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusConfigHistory', {
  controller: mmPlusConfigurationHistoryController,
  templateUrl: 'ui/mmplusrtusetting/configurationHistory/mm-plus-configuration-history-template.html',
  bindings: {
    windowId: '<',
    mobile: '<',
    classicView: '<',
    stickyProperties: '<',
    windowTitle: '<',
    deviceSelectedName: '<'
  }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function mmPlusNetworkHistoryController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, MMPlusRtuSettingFactory, deviceService, MMPlusRtuConfigHistoryFactory) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.configHistory = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.alerts = [];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.windowTitle = "MM Plus Network History"; //need for
        ctrl.windowTitle = "MM Plus Network History";
        ctrl.deviceSelectedName = ctrl.stickyProperties.device.deviceName;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.MMPlusRtuConfigHistoryFactory = new MMPlusRtuConfigHistoryFactory(ctrl.accountInfo.customerId);
        ctrl.deviceId = ctrl.stickyProperties.deviceId;
        ctrl.getNetworkConfigHistory(false);

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
                //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        };
    };

    //getNetworkConfigHistory = function (deviceId, networkConfigId, startDate, endDate) 
    ctrl.getNetworkConfigHistory = function (isRefresh) {
        ctrl.networkConfigHistoryData = [];
        $scope.alerts = [];
        var numberOfDays = 3,
            varDateRangeStart,
            varDateRangeEnd,
            varDateRangeEndTmp;
        if (ctrl.stickyProperties.savedDesktop === true) {
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
            varDateRangeEnd = ctrl.myDateRangeEnd;
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeStart = ctrl.myDateRangeStart;
            varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
        } else {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }
        //used for refresh button to reload newest data
        if (isRefresh) {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }
        if ((ctrl.mobile || ctrl.classicView) && !(new Date(varDateRangeStart).getTime() > 0 && new Date(varDateRangeEnd).getTime() > 0)) {
            var tmpDates = sharedSetupService.getLiveDates();
            varDateRangeStart = tmpDates.startDate;
            varDateRangeEnd = tmpDates.endDate;

            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(tmpDates.endDate);
        }

        ctrl.loading = true;

        ctrl.MMPlusRtuConfigHistoryFactory.getNetworkConfigHistory(ctrl.deviceId, 10, varDateRangeStart, varDateRangeEnd).then(function (result) {
            if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: ctrl.windowId });
            ctrl.loading = false;
            if (result.data.length > 0) {
                ctrl.networkConfigHistoryData = result.data;
            } else {
                var errormsg = ctrl.translation.message.NO_DATA + ": " + moment(varDateRangeStart).format('MM/DD/YY, h:mm:ss a') + " - " + moment(varDateRangeEnd).format('MM/DD/YY, h:mm:ss a');
                $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            }
        }, function (error) {
            //error
        });
    };

    ctrl.goSelectReportData = function () {
        ctrl.getNetworkConfigHistory(false);
    };

    ctrl.mostRecentData = function () {
        ctrl.getNetworkConfigHistory(true);
    };

    ctrl.syncConfig = function (config) {
        $rootScope.$broadcast('syncG2NetworkConfig', config);
    };

    ctrl.setTimeOut = function () {
        setTimeout(function () {
            ctrl.alertMessage = null;
        }, 15000); // 15 Seconds
    };
    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;
            $timeout(function () {
                ctrl.getData();
            }, 0);
        }
    }, true);
};

mmPlusNetworkHistoryController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService', 'MMPlusRtuConfigHistoryFactory'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusNetworkHistory', {
  controller: mmPlusNetworkHistoryController,
  templateUrl: 'ui/mmplusrtusetting/networkHistory/mm-plus-network-history-template.html',
  bindings: {
    windowId: '<',
    mobile: '<',
    classicView: '<',
    stickyProperties: '<',
    windowTitle: '<',
    deviceSelectedName: '<'
  }
});
"use strict";

angular.module("mc.memory-cache", []);
'use strict';

angular.module('mc.memory-cache').factory('CacheKeyFactory', ['$http', 'HOST', function ($http, HOST) {
    var CacheKeyFactory = {};

    var _getData = function _getData() {
        return $http({
            method: "Get",
            url: HOST + "/api/CacheKey",
            cache: false
        });
    };

    var _clearCache = function _clearCache(prefix) {
        return $http({
            method: "DELETE",
            url: HOST + "/api/CacheKey?prefix=" + prefix,
            cache: false
        });
    };

    CacheKeyFactory.getData = _getData;
    CacheKeyFactory.clearCache = _clearCache;

    return CacheKeyFactory;
}]);
'use strict';

function CacheKeyController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, LoginsFactory, $uibModal, $element, $timeout, datetimeService, savePdfService, registerWebinarService, unsavedChangesService, desktopViewListService, toaster, CacheKeyFactory) {
    var _this = this;

    var ctrl = this;
    $scope.alerts = [];

    ctrl.$onInit = function () {
        ctrl._loading = true;
        ctrl.cacheKey = [];
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.isSuperAdmin = sharedSetupService.isSuperAdmin(ctrl.accountInfo);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        ctrl.downloadViewTypeOptions = [0];

        ctrl.mobile = $rootScope.mobile;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;

        ctrl.getData();
    };

    ctrl.getData = function () {
        CacheKeyFactory.getData().then(function (result) {
            $scope.alerts = [];
            ctrl.cacheKey = result.data;

            // If we didn't get any items back 
            if (ctrl.cacheKey.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            } else {
                ctrl.totalData = ctrl.calculateTotals(ctrl.cacheKey);
            }
            ctrl._loading = false;
        }, function (error) {
            ctrl._loading = false;
        });
    };

    ctrl.calculateTotals = function (dataArray) {
        var totals = {
            count: 0,
            totalSizeBytes: 0,
            minMB: 0,
            maxMB: 0
        };

        if (!dataArray || dataArray.length === 0) {
            return totals;
        }

        dataArray.forEach(function (item) {
            totals.count += item.count || 0;
            totals.totalSizeBytes += item.totalSizeBytes || 0;
            totals.minMB += item.minMB || 0;
            totals.maxMB += item.maxMB || 0;
        });

        return totals;
    };

    ctrl.clearMemoryCacheByPrefix = function (item) {
        ctrl._loading = true;
        CacheKeyFactory.clearCache(item.prefix).then(function (result) {
            ctrl.cacheKey = [];
            ctrl.getData();
        }, function (error) {
            ctrl._loading = false;
        });
    };

    ctrl.openCommonModal = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = "Are you sure you want to clear memory cache for " + item.prefix + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            ctrl.clearMemoryCacheByPrefix(item);
        }, function () {
            // cancel button
        });
    };

    ctrl.savePdf = function () {
        var windowTitle = $scope.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };
}
angular.module('mc.memory-cache').controller('cacheKeyController', CacheKeyController);
CacheKeyController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'LoginsFactory', '$uibModal', '$element', '$timeout', 'datetimeService', 'savePdfService', 'registerWebinarService', 'unsavedChangesService', 'desktopViewListService', 'toaster', 'CacheKeyFactory'];
'use strict';

angular.module('mc.memory-cache').component('cacheKey', {
    controller: CacheKeyController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/memorycache/cachekey/cache-key-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function mmPlusConfigurationController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, MMPlusRtuSettingFactory, deviceService, MMPlusRtuConfigHistoryFactory, commandOptionsService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.hasModbusRTU = false;
    ctrl.displayLangs = [{ id: 0, name: 'Chinese', langCode: 'zh-CN' }, { id: 1, name: 'English', langCode: 'en-US' }, { id: 2, name: 'Portuguese', langCode: 'pt-BR' }, { id: 3, name: 'Spanish', langCode: 'es-MX' }, { id: 4, name: 'French', langCode: 'fr' }, { id: 5, name: 'German', langCode: 'de' }];
    ctrl.deviceModes = [{ id: 0, name: 'M150', modeCode: 15 }, { id: 1, name: 'M850', modeCode: 85 }];
    ctrl.operatingModes = [{ id: 0, name: 'Manufacturing', modeCode: 0 }, { id: 1, name: 'Manufacturing Mode 2', modeCode: 1 }, { id: 2, name: 'Monitoring', modeCode: 2 }];
    ctrl.floatTypes = [{ id: 0, name: 'None', modeCode: 0 }, { id: 1, name: 'Optical', modeCode: 1 }, { id: 2, name: 'Mechanical', modeCode: 2 }];
    ctrl.lightSensorOnTimes = [{ id: 0, name: '0 Minutes', lightSensorOnTime: 0 }, { id: 1, name: '1 Minutes', lightSensorOnTime: 1 }, { id: 2, name: '2 Minutes', lightSensorOnTime: 2 }, { id: 3, name: '3 Minutes', lightSensorOnTime: 3 }];
    ctrl.callInIntervals = [{ id: 6, IntervalValueHrs: '1 Hour', IntervalValueMin: 60 }, { id: 7, IntervalValueHrs: '2 Hours', IntervalValueMin: 120 }, { id: 8, IntervalValueHrs: '4 Hours', IntervalValueMin: 240 }, { id: 9, IntervalValueHrs: '12 Hours', IntervalValueMin: 720 }, { id: 10, IntervalValueHrs: '24 Hours', IntervalValueMin: 1440 }];
    ctrl.sampleIntervals = [{ id: 1, name: '4 Minutes', IntervalValueMin: 4 }, { id: 2, name: '5 Minutes', IntervalValueMin: 5 }, { id: 3, name: '6 Minutes', IntervalValueMin: 6 }, { id: 4, name: '10 Minutes', IntervalValueMin: 10 }, { id: 5, name: '15 Minutes', IntervalValueMin: 15 }, { id: 6, name: '20 Minutes', IntervalValueMin: 20 }, { id: 7, name: '30 Minutes', IntervalValueMin: 30 }, { id: 8, name: '60 Minutes', IntervalValueMin: 60 }];
    ctrl.skus = [{ SKUID: 0, SKUName: 'M84-O' }, { SKUID: 1, SKUName: 'M84-F' }, { SKUID: 2, SKUName: 'M84-L' }];

    ctrl.sensorVoltages = [{ name: '13 Volts', sensorVoltage: 13 }, { name: '18 Volts', sensorVoltage: 18 }];

    ctrl.sensorOnTimes = [{ name: 'Keep Sensor Power Enabled Continuously', sensorOnTime: -1 }, { name: 'Disable Sensor Power', sensorOnTime: 0 }, { name: '1 Second', sensorOnTime: 1 }, { name: '2 Seconds', sensorOnTime: 2 }, { name: '3 Seconds', sensorOnTime: 3 }, { name: '4 Seconds', sensorOnTime: 4 }, { name: '5 Seconds', sensorOnTime: 5 }, { name: '6 Seconds', sensorOnTime: 6 }, { name: '7 Seconds', sensorOnTime: 7 }, { name: '8 Seconds', sensorOnTime: 8 }, { name: '9 Seconds', sensorOnTime: 9 }, { name: '10 Seconds', sensorOnTime: 10 }, { name: '12 Seconds', sensorOnTime: 12 }, { name: '14 Seconds', sensorOnTime: 14 }, { name: '16 Seconds', sensorOnTime: 16 }, { name: '20 Seconds', sensorOnTime: 20 }, { name: '30 Seconds', sensorOnTime: 30 }, { name: '40 Seconds', sensorOnTime: 40 }, { name: '50 Seconds', sensorOnTime: 50 }, { name: '1 Minute', sensorOnTime: 60 }, { name: '1 and 1/2 Minutes', sensorOnTime: 90 }, { name: '2 Minutes', sensorOnTime: 120 }];

    ctrl.sensorPowerOverrides = [{ name: 'Disable the Override', sensorPowerOverride: 0 }, { name: '1 Second', sensorPowerOverride: 1 }, { name: '2 Seconds', sensorPowerOverride: 2 }, { name: '3 Seconds', sensorPowerOverride: 3 }, { name: '5 Seconds', sensorPowerOverride: 5 }, { name: '6 Seconds', sensorPowerOverride: 6 }, { name: '8 Seconds', sensorPowerOverride: 8 }, { name: '10 Seconds', sensorPowerOverride: 10 }, { name: '20 Seconds', sensorPowerOverride: 20 }, { name: '30 Seconds', sensorPowerOverride: 30 }, { name: '40 Seconds', sensorPowerOverride: 40 }, { name: '50 Seconds', sensorPowerOverride: 50 }, { name: '1 Minute', sensorPowerOverride: 60 }, { name: '1 and 1/2 Minutes', sensorPowerOverride: 90 }, { name: '2 Minutes', sensorPowerOverride: 120 }, { name: '3 Minutes', sensorPowerOverride: 180 }, { name: '5 Minutes', sensorPowerOverride: 300 }, { name: '10 Minutes', sensorPowerOverride: 600 }, { name: '20 Minutes', sensorPowerOverride: 1200 }, { name: '30 Minutes', sensorPowerOverride: 1800 }, { name: '40 Minutes', sensorPowerOverride: 2400 }, { name: '50 Minutes', sensorPowerOverride: 3000 }, { name: '1 Hour', sensorPowerOverride: 3600 }];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loading = true;
        ctrl.popoverConfigHistoryListIsOpen = false;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.MMPlusRtuConfigHistoryFactory = new MMPlusRtuConfigHistoryFactory(ctrl.accountInfo.customerId);

        // ctrl.getIntervals();
        // ctrl.getSKUsList();
        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
                //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        };
    };

    ctrl.getData = function () {
        ctrl.MMPlusRtuSettingFactory.getDeviceConfigData(ctrl.deviceId, false).then(function (result) {
            ctrl.data = result.data;
            if (ctrl.data.lightSensorOnTime === null) {
                ctrl.data.lightSensorOnTime = 2;
                ctrl.postData('lightSensorOnTime');
            }
            if (ctrl.data.lightSensorLockoutTime === null) {
                ctrl.data.lightSensorLockoutTime = 10;
                ctrl.postData('lightSensorLockoutTime');
            }
            if (ctrl.data.manholeOpenLightThreshold === null) {
                ctrl.data.manholeOpenLightThreshold = 600;
                ctrl.postData('manholeOpenLightThreshold');
            }
            if (ctrl.data.manholeClosedLightThreshold === null) {
                ctrl.data.manholeClosedLightThreshold = 400;
                ctrl.postData('manholeClosedLightThreshold');
            }
            if (ctrl.data.lightSensorEnableDisable === null) {
                ctrl.data.lightSensorEnableDisable = false;
                ctrl.postData('lightSensorEnableDisable');
            }

            //Turn OFF Low FLoat - MyLevel L
            if (ctrl.data.skuid == 2 && ctrl.data.lowFloatType != 0) {
                ctrl.tunrOffLowFloat();
            }
            // ctrl.getMQTTBrokerPorts();
            ctrl.getImeiAndModel();
            ctrl.getConfigData();
            if (!ctrl.data) {
                //ctrl.setDefaultData();
                ctrl.alertMessage = "Please configure the device as Gen 2";
                ctrl.configButtonVisible = false;
            } else {
                ctrl.configButtonVisible = true;
            }
        }, function (error) {
            //error
        });

        //NOTE: this call has to happen ONLY one time for this tab launch
        //Log tab access event to NLog
        ctrl.MMPlusRtuSettingFactory.postUserAction2Nlog(ctrl.accountInfo.customerId, ctrl.deviceId, "GEN II >> Configuration").then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });
    };

    // ctrl.getMQTTBrokerPorts = () => {
    //     commandOptionsService.getMQTTBrokerPorts()
    //         .then(function (datafromFactory) {
    //             ctrl.mqttPortNumbers = datafromFactory.data;
    //         }, function (error) {
    //             //error
    //         })
    // }


    ctrl.tunrOffLowFloat = function () {
        var tmpPath = 'lowFloatType';
        var tmpDevice = { "op": "replace", "path": tmpPath, "value": 0 };
        ctrl.MMPlusRtuSettingFactory.patchDeviceG2ConfigPatch(ctrl.deviceId, tmpDevice).then(function (result) {
            ctrl.data = result.data;
            ctrl.configButtonVisible = true;
        }, function (error) {
            //error
        });
    };

    ctrl.getImeiAndModel = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
            ctrl.model = datafromFactory.data.model;
            if (ctrl.model == 21) {
                ctrl.callInIntervals.splice(0, 0, { id: 0, IntervalValueHrs: '2 Minutes', IntervalValueMin: 2 }, { id: 1, IntervalValueHrs: '5 Minutes', IntervalValueMin: 5 }, { id: 2, IntervalValueHrs: '10 Minutes', IntervalValueMin: 10 }, { id: 3, IntervalValueHrs: '15 Minutes', IntervalValueMin: 15 }, { id: 4, IntervalValueHrs: '20 Minutes', IntervalValueMin: 20 }, { id: 5, IntervalValueHrs: '30 Minutes', IntervalValueMin: 30 });

                ctrl.callInIntervals.splice(10, 1);
            }
            ctrl.loading = false;
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loadingInProgress = false;
        });
    };

    ctrl.getConfigData = function () {
        ctrl.MMPlusRtuSettingFactory.getDeviceConfigData(ctrl.deviceId, true).then(function (result) {
            if (result.data) {
                var index = result.data.findIndex(function (l) {
                    return l.networkDeviceTypeID >= 13 && l.networkDeviceTypeID <= 16;
                });
                ctrl.hasModbusRTU = index >= 0 ? true : false;
            }
        }, function (error) {
            //error
        });
    };

    ctrl.clickLog = function () {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = ctrl.deviceId;
        optionsStickyProperties.device = { deviceId: ctrl.deviceId, title: "", deviceName: ctrl.deviceSelectedName };

        if (_this2.classicView || _this2.mobile) {
            $location.path('/tankandwell/log/template');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;

            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };
            newPopupPosition.at = 'left+' + (popup.offset().left + popup.dialog('option', 'width') + _this2.popupOffset) + ' top+' + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 40;

            //openViewService.openView('MM Plus Config History', { width: 700, height: 400 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 });

            openViewService.openView('MM Plus Config History', { width: 820, height: 420 }, { my: 'right-10 top+6', at: 'right top', of: window }, optionsStickyProperties, { minimumWidth: 500, minimumHeight: 300 }, false);
        }
    };

    $scope.$on('syncDeviceG2ExtConfig', function (event, args) {
        if (args.deviceID == ctrl.deviceId) {
            ctrl.data = args;
            ctrl.updateConfigData(ctrl.data);
        }
    });

    ctrl.postData = function (path) {
        if (path == 'lightSensorLockoutTime') {
            if (!(ctrl.data.lightSensorLockoutTime >= 1 && ctrl.data.lightSensorLockoutTime <= 180)) {
                ctrl.showLightSensorLockoutTime = true;
                return;
            } else {
                ctrl.showLightSensorLockoutTime = false;
            }
        }
        if (path == 'manholeOpenLightThreshold' || path == 'manholeClosedLightThreshold') {
            if (ctrl.data.manholeOpenLightThreshold <= ctrl.data.manholeClosedLightThreshold) {
                ctrl.showManholeLightThresholdTooltip = true;
                return;
            } else {
                ctrl.showManholeLightThresholdTooltip = false;
            }
        }
        if (path == 'maxFloatTipCallsPerDay') {
            if (!(ctrl.data.maxFloatTipCallsPerDay >= 11 && ctrl.data.maxFloatTipCallsPerDay <= 2767)) {
                ctrl.maxFloatTipCallsPerDayError = "Value must be greater than 10";
                return;
            } else {
                ctrl.maxFloatTipCallsPerDayError = "";
            }
        }
        var tmpDevice = { "op": "replace", "path": path, "value": ctrl.data[path] };
        ctrl.MMPlusRtuSettingFactory.patchDeviceG2ConfigPatch(ctrl.deviceId, tmpDevice).then(function (result) {
            ctrl.data = result.data;
            ctrl.configButtonVisible = true;
            if (path == 'skuid') {
                deviceMenuService.resetDeviceMenuList();
                deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId);
                $rootScope.$broadcast('skuidChanged', ctrl.deviceId);
            }
        }, function (error) {
            //error
        });
    };

    ctrl.updateConfigData = function (deviceConfigExt) {
        ctrl.MMPlusRtuSettingFactory.updateDeviceG2Ext(ctrl.accountInfo.customerId, ctrl.deviceId, deviceConfigExt).then(function (result) {
            openViewService.closeConfigHistoryView("MM Plus Config History");
            ctrl.data = result.data;
        }, function (error) {
            //error
        });
    };

    ctrl.setDefaultData = function () {
        ctrl.data = {
            ackResponseTimeout: 1,
            ackRetryCount: 1,
            bleAdvertDuration: 1,
            bleAdvertInterval: 1,
            bleSchedEnd: 1,
            bleSchedStart: 1,
            callRetryDelay: 1,
            cellIpAddrTimeout: 1,
            cellRegistrationTimeout: 1,
            cellSocketTimeout: 1,
            cmdMsgWaitWatchDog: 1,
            dailyCallTime: 1,
            displayLang: "en-US",
            highFloatType: 1,
            lowFloatType: 1,
            m850M150Mode: 15,
            maxCallRetries: 1,
            maxFloatTipCallsPerDay: 1,
            mqttTimeout: 1,
            nAckRetryCount: 1,
            operatingMode: 1,
            sendHrlyAlarmMinMax: false,
            sendNightlyRuntimes: false,
            sendPumpStarts: false,
            simCardSlot: false,
            sleepWaitTimeout: 1,
            lightSensorOnTimes: 2,
            lightSensorLockoutTime: 10,
            manholeOpenLightThreshold: 600,
            manholeClosedLightThreshold: 400,
            lightSensorEnableDisable: 1,
            sensorVoltages: 13,
            sensorOnTimes: 2,
            sensorPowerOverrides: 0
            //mqttPortID: 0
        };
    };

    ctrl.configure = function () {
        $timeout(function () {
            ctrl.MMPlusRtuSettingFactory.configMMPlusDevice(ctrl.deviceId, ctrl.imei).then(function (result) {
                //success
                var configResult = String(result.data).match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
                ctrl.alertMessage = "Device Config " + configResult[0] + ": " + configResult[1];
                ctrl.setTimeOut();
            }, function (error) {
                //error
                ctrl.alertMessage = "Something went wrong while processing device config request";
                ctrl.setTimeOut();
            });
        }, 500);
    };

    ctrl.setTimeOut = function () {
        setTimeout(function () {
            ctrl.alertMessage = null;
        }, 15000); // 15 Seconds
    };
    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;
            var _device = { deviceId: newValue, deviceName: $scope.$parent.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });

            if (!angular.isUndefined(ctrl.currentDevice)) return;

            ctrl.currentDevice = newValue;

            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    ctrl.alertMessage = null;
                    $timeout(function () {
                        ctrl.getData();
                    }, 0);
                } else {
                    ctrl.data = null;
                    ctrl.alertMessage = "Please configure the device as Gen 2";
                    ctrl.configButtonVisible = false;
                }
            });
        }
    }, true);
};

mmPlusConfigurationController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService', 'MMPlusRtuConfigHistoryFactory', 'commandOptionsService'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusConfig', {
    controller: mmPlusConfigurationController,
    templateUrl: 'ui/mmplusrtusetting/configuration/mm-plus-configuration-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelectedName: '<'
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function mmPlusChannelHistoryController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, MMPlusRtuSettingFactory, deviceService, MMPlusRtuConfigHistoryFactory) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.configHistory = [];
    ctrl.hasModbusRTU = false;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.alerts = [];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.windowTitle = "MM Plus Channel History"; //need for
        ctrl.windowTitle = "MM Plus Channel History";
        ctrl.deviceSelectedName = ctrl.stickyProperties.device.deviceName;
        ctrl.channelNo = ctrl.stickyProperties.device.channel;
        ctrl.networkDeviceConfigId = ctrl.stickyProperties.device.networkDeviceConfigID;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(_this2);
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
        ctrl.MMPlusRtuConfigHistoryFactory = new MMPlusRtuConfigHistoryFactory(ctrl.accountInfo.customerId);
        ctrl.deviceId = ctrl.stickyProperties.deviceId;
        ctrl.getChannelConfigHistory(false);

        ctrl.MMPlusRtuSettingFactory.getDeviceConfigData(ctrl.deviceId, true).then(function (result) {
            if (result.data) {
                var index = result.data.findIndex(function (l) {
                    return l.networkDeviceTypeID >= 13 && l.networkDeviceTypeID <= 16;
                });
                ctrl.hasModbusRTU = index >= 0 ? true : false;
            }
        });

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
                //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        };
    };

    ctrl.getChannelConfigHistory = function (isRefresh) {
        ctrl.channelConfigHistoryData = [];
        $scope.alerts = [];
        var numberOfDays = 3,
            varDateRangeStart,
            varDateRangeEnd,
            varDateRangeEndTmp;
        if (ctrl.stickyProperties.savedDesktop === true) {
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
            varDateRangeEnd = ctrl.myDateRangeEnd;
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeStart = ctrl.myDateRangeStart;
            varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
        } else {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }
        //used for refresh button to reload newest data
        if (isRefresh) {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }
        if ((ctrl.mobile || ctrl.classicView) && !(new Date(varDateRangeStart).getTime() > 0 && new Date(varDateRangeEnd).getTime() > 0)) {
            var tmpDates = sharedSetupService.getLiveDates();
            varDateRangeStart = tmpDates.startDate;
            varDateRangeEnd = tmpDates.endDate;

            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(tmpDates.endDate);
        }

        ctrl.loading = true;

        ctrl.MMPlusRtuConfigHistoryFactory.getChannelConfigHistory(ctrl.deviceId, ctrl.channelNo, ctrl.networkDeviceConfigId, varDateRangeStart, varDateRangeEnd).then(function (result) {
            if (!ctrl.mobile && !ctrl.classicView) {
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: ctrl.windowId });
            }
            ctrl.loading = false;
            if (result.data.length > 0) {
                ctrl.channelConfigHistoryData = result.data;
            } else {
                var errormsg = ctrl.translation.message.NO_DATA + ": " + moment(varDateRangeStart).format('MM/DD/YY, h:mm:ss a') + " - " + moment(varDateRangeEnd).format('MM/DD/YY, h:mm:ss a');
                $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            }
        }, function (error) {
            //error
        });
    };

    ctrl.goSelectReportData = function () {
        ctrl.getChannelConfigHistory(false);
    };

    ctrl.mostRecentData = function () {
        ctrl.getChannelConfigHistory(true);
    };

    ctrl.syncConfig = function (config) {
        $rootScope.$broadcast('syncG2ChannelConfig', config);
    };

    ctrl.setTimeOut = function () {
        setTimeout(function () {
            ctrl.alertMessage = null;
        }, 15000); // 15 Seconds
    };
    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;
            $timeout(function () {
                ctrl.getData();
            }, 0);
        }
    }, true);
};

mmPlusChannelHistoryController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'MMPlusRtuSettingFactory', 'deviceService', 'MMPlusRtuConfigHistoryFactory'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusChannelHistory', {
  controller: mmPlusChannelHistoryController,
  templateUrl: 'ui/mmplusrtusetting/channelHistory/mm-plus-channel-history-template.html',
  bindings: {
    windowId: '<',
    mobile: '<',
    classicView: '<',
    stickyProperties: '<',
    windowTitle: '<',
    deviceSelectedName: '<'
  }
});
"use strict";

angular.module("mc.scheduling-service", []);
'use strict';

function SchedulingServiceDestinationsFactory(HOST, $http) {

    // instantiate our initial object
    var SchedulingServices = function SchedulingServices(customerId) {
        this.customerId = customerId;
    };

    SchedulingServices.prototype.getSchedulingServiceDestinations = function () {
        var self = this;
        return $http.get(HOST + '/api/SchedulingService/GetDestinations?custId=' + this.customerId).then(function (response) {
            self.schedulingServiceDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    SchedulingServices.prototype.getServiceConfig = function (schedulingServiceId) {
        var self = this;
        return $http.get(HOST + '/api/SchedulingService?schedulingServiceId=' + schedulingServiceId).then(function (response) {
            self.serviceConfigs = response.data;
            self.loading = false;
            return response;
        });
    };

    SchedulingServices.prototype.getEmptyServiceConfig = function () {
        var self = this;
        return $http.get(HOST + '/api/SchedulingService').then(function (response) {
            self.emptyServiceConfigs = response.data;
            self.loading = false;
            return response;
        });
    };

    SchedulingServices.prototype.createSchedulingServiceConfig = function (schedulingServiceId, categoryId, severityId) {
        var self = this;
        return $http({
            method: 'POST',
            url: HOST + '/api/SchedulingService',
            params: { schedulingServiceId: schedulingServiceId, categoryId: categoryId, severityId: severityId // Pass parameters as an object instead of concatenating them to the URL, this prevents issues with special characters in the parameters
            } }).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    SchedulingServices.prototype.deleteSchedulingServiceConfig = function (schedulingServiceId, categoryId, severityId) {
        var self = this;
        return $http({
            method: 'DELETE',
            url: HOST + '/api/SchedulingService',
            params: { schedulingServiceId: schedulingServiceId, categoryId: categoryId, severityId: severityId // Pass parameters as an object instead of concatenating them to the URL, this prevents issues with special characters in the parameters
            } }).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    SchedulingServices.prototype.deleteDestination = function (schedulingServiceId) {
        var self = this;
        return $http.delete(HOST + '/api/SchedulingService' + '?schedulingServiceId=' + schedulingServiceId).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    SchedulingServices.prototype.addDestination = function (custId, email, firstName, lastName) {
        var self = this;
        return $http({
            method: 'POST',
            url: HOST + '/api/SchedulingService',
            params: { custId: custId, email: email, firstName: firstName, lastName: lastName // Pass parameters as an object instead of concatenating them to the URL, this prevents issues with special characters in the parameters
            } }).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    SchedulingServices.prototype.updateDestination = function (schedulingServiceId, email, firstName, lastName) {
        var self = this;
        return $http({
            method: 'PUT',
            url: HOST + '/api/SchedulingService',
            params: { schedulingServiceId: schedulingServiceId, email: email, firstName: firstName, lastName: lastName // Pass parameters as an object instead of concatenating them to the URL, this prevents issues with special characters in the parameters
            } }).then(function (response) {
            self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    return SchedulingServices;
}

SchedulingServiceDestinationsFactory.$inject = ['HOST', '$http'];

angular.module('mc.scheduling-service').factory('SchedulingServiceDestinationsFactory', SchedulingServiceDestinationsFactory);
"use strict";

function SchedulingServiceController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, SchedulingServiceDestinationsFactory, $timeout, $filter, toaster, $uibModal, unsavedChangesService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.schedulingServiceDestinations = [];
    ctrl.severities = [];
    ctrl.schedulingServiceConfigs = [];
    ctrl.configsForSaving = [];
    ctrl.currentSchedulingServiceId = '';
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.timeFormat = ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.frequency = ctrl.frequency; //need for
        ctrl.getScheduledService();

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    ctrl.getScheduledService = function () {
        var _schedulingServiceDestinations = new SchedulingServiceDestinationsFactory(ctrl.accountInfo.customerId);
        _schedulingServiceDestinations.getSchedulingServiceDestinations().then(function () {
            ctrl.scheduledServices = _schedulingServiceDestinations.schedulingServiceDestination;
            ctrl.schedulingServiceDestinations = ctrl.scheduledServices;
        });
    };

    ctrl.setSchedulingServiceConfig = function (categoryId, severityId, isSelected) {
        //For add new configs for new destination
        if (ctrl.addMode == -1) {
            if (isSelected) {
                ctrl.configsForSaving.push({ categoryId: categoryId, severityId: severityId, isSelected: isSelected });
            } else {
                for (var i = 0; i < ctrl.configsForSaving.length; i++) {
                    if (ctrl.configsForSaving[i].categoryId == categoryId && ctrl.configsForSaving[i].severityId == severityId) ctrl.configsForSaving.splice(i, 1);
                }
            }
        }
        //For editing configs for existing destination
        else {
                if (isSelected) {
                    var _tmpSchedulingServiceConfig = new SchedulingServiceDestinationsFactory(ctrl.accountInfo.customerId);
                    _tmpSchedulingServiceConfig.createSchedulingServiceConfig(ctrl.currentSchedulingServiceId, categoryId, severityId).then(function () {}, function (resp) {
                        toaster.pop('error', "Update Error!");
                    });
                } else {
                    var _tmpSchedulingServiceConfig2 = new SchedulingServiceDestinationsFactory(ctrl.accountInfo.customerId);
                    _tmpSchedulingServiceConfig2.deleteSchedulingServiceConfig(ctrl.currentSchedulingServiceId, categoryId, severityId).then(function () {}, function (resp) {
                        toaster.pop('error', "Delete Error!");
                    });
                }
            }
    };

    ctrl.setReportConfigurationAll = function (reportConfig) {
        //Array to check for change in severity
        var severityChanged = [];

        if (reportConfig.allSeveritySelected === true) {
            //Set all Severities to true
            reportConfig.severities.map(function (severity, index) {
                //Check if Severity is Disabled
                if (!ctrl.getEventsLength(reportConfig.categoryId, severity.id)) {

                    //Check if Severity changed
                    if (!severity.isSelected) {
                        severityChanged[index] = true;
                        severity.isSelected = true;

                        //For add new configs for new destination
                        ctrl.setSchedulingServiceConfig(reportConfig.categoryId, severity.id, severity.isSelected);
                    } else {
                        severityChanged[index] = false;
                    }
                }
            });
        } else if (reportConfig.allSeveritySelected === false) {
            //Set all Severities to false
            reportConfig.severities.map(function (severity, index) {
                //Check if Severity is Disabled
                if (!ctrl.getEventsLength(reportConfig.categoryId, severity.id)) {

                    //Check if Severity changed
                    if (severity.isSelected) {
                        severityChanged[index] = true;
                        severity.isSelected = false;

                        //For add new configs for new destination
                        ctrl.setSchedulingServiceConfig(reportConfig.categoryId, severity.id, severity.isSelected);
                    } else {
                        severityChanged[index] = false;
                    }
                }
            });
        }
    };

    ctrl.addDestination = function () {
        ctrl.configsForSaving = [];
        var newSchedulingServiceDestination = {
            id: -1,
            customerId: ctrl.accountInfo.customerId,
            email: '',
            firstName: '',
            lastName: ''
        };
        ctrl.schedulingServiceDestinations.unshift(newSchedulingServiceDestination);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveDestination = function (item) {
        var _schedulingServiceDestinations = new SchedulingServiceDestinationsFactory(ctrl.accountInfo.customerId);
        _schedulingServiceDestinations.addDestination(ctrl.accountInfo.customerId, item.email, item.firstName, item.lastName).then(function () {
            var newSchedulingServiceId = _schedulingServiceDestinations.newDestination.id;
            for (var i = 0; i < ctrl.configsForSaving.length; i++) {
                _schedulingServiceDestinations.createSchedulingServiceConfig(newSchedulingServiceId, ctrl.configsForSaving[i].categoryId, ctrl.configsForSaving[i].severityId).then(function () {}, function (resp) {
                    toaster.pop('error', "Update Error!");
                });
            }
            ctrl.getScheduledService();
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.cancelDestination = function (item) {
        if (item.id === -1) ctrl.schedulingServiceDestinations.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.checkConfigs = function () {
        return ctrl.configsForSaving.length == 0;
    };

    ctrl.checkEmail = function (item) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!angular.isUndefined(item) && item.length === 0) return false;
        return !re.test(item);
    };

    ctrl.checkIfEmailExists = function (item) {
        for (var i = 0; i < ctrl.schedulingServiceDestinations.length; i++) {
            if (item.email.toLowerCase() === ctrl.schedulingServiceDestinations[i].email.toLowerCase() && item.id !== ctrl.schedulingServiceDestinations[i].id) return true;
        }
        return false;
    };

    //ctrl.checkData = (propertyName, value, format) => {
    //    switch (propertyName) {
    //        case "triggerId":
    //        case "type":
    //            return true;
    //        case "strData1":
    //            if (format === 1) {
    //                return !ctrl.checkEmail(value);
    //            } else {
    //                return true;
    //            }
    //        case "strData2":
    //            if (format === 1) {
    //                return !ctrl.checkPhoneNumber(value);
    //            } else {
    //                return true;
    //            }
    //        default:
    //            return false;
    //    }
    //};

    ctrl.popoverCategoryList = {
        templateUrl: 'SchedulingServicePopoverTemplate.html'
    };
    ctrl.dynamicPopoverSSI = {
        templateUrl: "SchedulingServiceInfoPopoverTemplate.html"
    };

    ctrl.getEventsLength = function (categoryId, severityId) {
        for (var i = 0; i < ctrl.events.length; i++) {
            if (ctrl.events[i].categoryId == categoryId && ctrl.events[i].severityId == severityId) return false;
        }
        return true;
    };

    ctrl.editSchedulingServiceConfig = function (schedulingServiceId) {
        var _schedulingServiceConfigs = new SchedulingServiceDestinationsFactory(ctrl.accountInfo.customerId);
        ctrl.schedulingServiceConfigs = [];
        ctrl.currentSchedulingServiceId = '';
        ctrl.currentSchedulingServiceId = schedulingServiceId;
        _schedulingServiceConfigs.getServiceConfig(schedulingServiceId).then(function () {
            ctrl.schedulingServiceConfigs = _schedulingServiceConfigs.serviceConfigs.schedulingServiceConfig;
            ctrl.severities = _schedulingServiceConfigs.serviceConfigs.severities;
            ctrl.events = _schedulingServiceConfigs.serviceConfigs.events;

            //Add property allSeveritySelected to each
            ctrl.schedulingServiceConfigs.map(function (config) {
                var severitiesCount = 0;
                //Check if all available severities are selected
                config.severities.map(function (severity) {
                    //check if disabled
                    if (ctrl.getEventsLength(config.categoryId, severity.id)) {
                        severitiesCount++;
                    }
                    //Check if not disabled and is selected
                    else if (severity.isSelected) {
                            severitiesCount++;
                        }
                });
                config.allSeveritySelected = severitiesCount === 3 ? true : false;
            });
        });
    };

    ctrl.addSchedulingServiceConfig = function (schedulingServiceId) {
        ctrl.configsForSaving = [];
        var _schedulingServiceEmptyConfigs = new SchedulingServiceDestinationsFactory(ctrl.accountInfo.customerId);
        ctrl.schedulingServiceConfigs = [];
        ctrl.currentSchedulingServiceId = '';
        ctrl.currentSchedulingServiceId = schedulingServiceId;
        _schedulingServiceEmptyConfigs.getEmptyServiceConfig().then(function () {
            ctrl.schedulingServiceConfigs = _schedulingServiceEmptyConfigs.emptyServiceConfigs.schedulingServiceConfig;
            ctrl.severities = _schedulingServiceEmptyConfigs.emptyServiceConfigs.severities;
            ctrl.events = _schedulingServiceEmptyConfigs.emptyServiceConfigs.events;
        });
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = _translation.text.DELETE_SCHEDULING_SERVICE_DESTINATION + ":";
            this.tmpConfirmMessageB = ctrl.translation.text.EMAIL + ': ' + item.email + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _deleteDestinations = new SchedulingServiceDestinationsFactory(ctrl.accountInfo.customerId);
            _deleteDestinations.deleteDestination(item.id).then(function () {

                var index = ctrl.schedulingServiceDestinations.indexOf(item);
                if (index !== -1) {
                    ctrl.schedulingServiceDestinations.splice(index, 1);
                }

                // ctrl.addMode = null;
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.SCHEDULING_SERVICE, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.updateDestination = function (item) {
        if (item.id === -1) return;
        var email = '';
        var firstName = '';
        var lastName = '';
        for (var i = 0; i < ctrl.schedulingServiceDestinations.length; i++) {
            if (item.id === ctrl.schedulingServiceDestinations[i].id) {
                email = ctrl.schedulingServiceDestinations[i].email;
                firstName = ctrl.schedulingServiceDestinations[i].email;
                lastName = ctrl.schedulingServiceDestinations[i].lastName;
            }
        }
        if (item.email === email && item.firstName === firstName && item.lastName === lastName) return;
        var _schedulingServiceDestinations = new SchedulingServiceDestinationsFactory(ctrl.accountInfo.customerId);
        _schedulingServiceDestinations.updateDestination(item.id, item.email, item.firstName, item.lastName).then(function () {
            //success
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.SCHEDULING_SERVICE, "Update Error!");
        });
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        //ctrl.initializeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        //ctrl.initializeSetting();
    });
};

SchedulingServiceController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'SchedulingServiceDestinationsFactory', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService'];
'use strict';

angular.module('mc.scheduling-service').component('schedulingService', {
    controller: SchedulingServiceController,
    templateUrl: 'ui/missionreportssetup/schedulingservice/scheduling-service-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.weekly-reports-setup", []);
'use strict';

function WeeklyReportsController($, $rootScope, $scope, $sce, $http, HOST, authenticationService, translationService, sharedSetupService, $timeout, $filter, toaster, $uibModal, unsavedChangesService) {
    var _this = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this);
        ctrl.initializeSetting();
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
        ctrl.weeklyReportsSetupTabs = ctrl.tabConfiguration;
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": "WeeklyManagement",
            "name": ctrl.translation.text.WEEKLY_MANAGEMENT,
            "templateName": "Weekly Management",
            "templateUrl": "ui/missionreportssetup/weeklyreports/weeklymanagementreport/weekly-management-report.html",
            "height": 150
        }, {
            "id": "RuntimeVariance",
            "name": ctrl.translation.text.RUNTIME_VARIANCE,
            "templateName": "Runtime Variance",
            "templateUrl": "ui/missionreportssetup/weeklyreports/runtimevariancereport/runtime-variance-report.html",
            "height": 150
        }, {
            "id": "IntegratedFlowSummary",
            "name": ctrl.translation.text.INTEGRATED_FLOW,
            "templateName": "Integrated Flow Summary",
            "templateUrl": "ui/missionreportssetup/weeklyreports/integratedflowsummaryreport/integrated-flow-summary-report.html",
            "height": 150
        }, {
            "id": "PulseFlowSummary",
            "name": ctrl.translation.text.PULSE_FLOW,
            "templateName": "Pulse Flow Summary",
            "templateUrl": "ui/missionreportssetup/weeklyreports/pulseflowsummaryreport/pulse-flow-summary-report.html",
            "height": 150
        });
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/missionreportssetup/' + tab.templateName.toLowerCase().replace(' ', '-') + '-tab.html';
    };

    ctrl.doIt = function () {
        alert('ive been hit!');
    };
};

WeeklyReportsController.$inject = ['$', '$rootScope', '$scope', '$sce', '$http', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService'];
'use strict';

angular.module('mc.weekly-reports-setup').component('weeklyReportsSetup', {
    controller: WeeklyReportsController,
    templateUrl: 'ui/missionreportssetup/weeklyreports/weekly-reports-setup-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.daily-reports", []);
'use strict';

function DailyReportsController($, $rootScope, $scope, $sce, $http, HOST, authenticationService, translationService, sharedSetupService, $timeout, $filter, toaster, $uibModal, unsavedChangesService) {
    var _this = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this);
        ctrl.initializeSetting();
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
        ctrl.dailyReportsSetupTabs = ctrl.tabConfiguration;
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": "DailyRuntime",
            "name": ctrl.translation.text.DAILY_RUNTIME,
            "templateName": "Daily Runtime",
            "templateUrl": "ui/missionreportssetup/dailyreports/dailyruntimereportsetup/runtime-report-setup-d.html",
            "height": 135
        }, {
            "id": "DailyStation",
            "name": ctrl.translation.text.DAILY_STATION_SUMMARY,
            "templateName": "Daily Station",
            "templateUrl": "ui/missionreportssetup/dailyreports/dailystationreport/daily-station-report.html",
            "height": 150
        }, {
            "id": "IntegratedFlow",
            "name": ctrl.translation.text.INTEGRATED_FLOW,
            "templateName": "Integrated Flow",
            "templateUrl": "ui/missionreportssetup/dailyreports/integratedflowsetup/integrated-flow-setup.html",
            "height": 150
        }, {
            "id": "Pulseflow",
            "name": ctrl.translation.text.PULSE_FLOW,
            "templateName": "Pulseflow",
            "templateUrl": "ui/missionreportssetup/dailyreports/dailypulseflowreportsetup/daily-pulseflow-report-setup.html",
            "height": 150
        });
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/missionreportssetup/' + tab.templateName.toLowerCase().replace(' ', '-') + '-tab.html';
    };

    ctrl.doIt = function () {
        alert('ive been hit!');
    };
};

DailyReportsController.$inject = ['$', '$rootScope', '$scope', '$sce', '$http', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService'];
'use strict';

angular.module('mc.daily-reports').component('dailyReports', {
    controller: DailyReportsController,
    templateUrl: 'ui/missionreportssetup/dailyreports/daily-reports-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.marker-rwa', []);
"use strict";

function MarkerRwaFactory(HOST, $http) {

    // instantiate our initial object
    var MarkerRwa = function MarkerRwa() {
        //
    };

    MarkerRwa.prototype.getData = function (rwaId) {
        var self = this;
        return $http.get(HOST + "/api/Map/Marker/RuralWaterAssociations/get" + "?rwaId=" + rwaId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return MarkerRwa;
}

MarkerRwaFactory.$inject = ['HOST', '$http'];

angular.module('mc.marker-rwa').factory('MarkerRwaFactory', MarkerRwaFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function markerRwaController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, $uibModal, $element, $timeout, datetimeService, MarkerRwaFactory, $cookies) {

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;
    ctrl.isTicketSystemAvailable = true;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl._loading = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.deviceId, windowId: $scope.windowId });
        sharedSetupService.keepVisibleOnlyCloseButton($element);
        ctrl.getMarkerRwa();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog($scope.windowId).ref;
            ctrl._popup.dialogExtend({
                restore: function restore(event, ui) {
                    sharedSetupService.keepVisibleOnlyCloseButton($element);
                }
            });
        }
    };

    ctrl.getMarkerRwa = function () {
        var _markerRwa = new MarkerRwaFactory(ctrl.accountInfo.customerId);
        _markerRwa.getData($scope.stickyProperties.deviceId).then(function () {
            ctrl.markerRwa = _markerRwa.data;

            ctrl._loading = false;
            //Adjust height to match content
            if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.viewAutoHeight(ctrl.windowId);
        });
    };
}

markerRwaController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$uibModal', '$element', '$timeout', 'datetimeService', 'MarkerRwaFactory', '$cookies'];
'use strict';

angular.module('mc.marker-rwa').component('markerRwa', {
    controller: markerRwaController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/map/markerrwa/marker-rwa-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.notes-rwa', []);
'use strict';

function NotesRwaFactory(HOST, $http) {

    return {
        AddNotes: function AddNotes(rwaId, userId, notes) {
            return $http({
                method: 'POST',
                url: HOST + '/api/Map/Marker/RuralWaterAssociations/notes/add',
                params: { rwaId: rwaId, userId: userId, notes: notes }
            });
        }
    };
}

NotesRwaFactory.$inject = ['HOST', '$http'];

angular.module('mc.notes-rwa').factory('NotesRwaFactory', NotesRwaFactory);
"use strict";

function NotesRwaController($, $scope, $rootScope, authenticationService, translationService, NotesRwaFactory, sharedSetupService) {
    var ctrl = this;
    ctrl.notesNew = "";

    ctrl.dynamicPopover = {
        templateUrl: 'NotesRwaPopoverTemplate.html'
    };

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.isPopoverOpen = false;
        ctrl.mobile = $rootScope.mobile;
        ctrl.classicView = $rootScope.classicView;
        ctrl.translation = translationService.translation;
        ctrl.windowId = ctrl.windowId;
        $scope.windowId = ctrl.windowId;

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.deviceSelected = $scope.deviceSelected;
        ctrl.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
    };

    ctrl.saveNotes = function () {
        NotesRwaFactory.AddNotes(ctrl.rwaId, ctrl.accountInfo.userId, ctrl.notesNew.trim()).then(function (response) {
            !ctrl.mobile && !ctrl.classicView && ctrl.updateMapPinImage();
            ctrl.notesNew = "";
            ctrl.notes = response.data.notes;
            ctrl.togglePopover();
        }).catch(function (error) {
            console.error(error);
        });
    };

    ctrl.updateMapPinImage = function () {
        var mapPin = ctrl.stickyProperties.setting.imageDiv.getAttribute("id");
        var mapPinImage = document.getElementById(mapPin + "_innerImage");
        mapPinImage.src = mapPinImage.src.replace("icon.png", "notes-icon.gif");
    };

    ctrl.formatBold = function (text) {
        if (text == null) return '';
        return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    };

    ctrl.togglePopover = function () {
        ctrl.isPopoverOpen = !ctrl.isPopoverOpen;
    };
}

NotesRwaController.$inject = ['$', '$scope', '$rootScope', 'authenticationService', 'translationService', 'NotesRwaFactory', 'sharedSetupService'];
'use strict';

angular.module('mc.notes-rwa').component('notesRwa', {
    controller: NotesRwaController,
    transclude: true,
    templateUrl: 'ui/map/notesrwa/notes-rwa.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<',
        deviceSelected: '<',
        notes: '<',
        rwaId: '<',
        windowTitle: '<'
    }
});
"use strict";

angular.module("mc.config-safe-water-report", []);
'use strict';

function ConfigSafeWaterReportFactory(HOST, $http) {

    var ConfigSafeWaterReport = function ConfigSafeWaterReport(customerId) {
        this.customerId = customerId;
    };

    ConfigSafeWaterReport.prototype.getConfigSafeWaterReport = function () {
        var self = this;
        return $http.get(HOST + '/api/SafeWaterConfigReport' + '?customerId=' + this.customerId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    ConfigSafeWaterReport.prototype.addDestination = function (configSafeWaterReport) {
        var self = this;
        return $http.post(HOST + '/api/SafeWaterConfigReport' + '?customerId=' + this.customerId, configSafeWaterReport).then(function (response) {
            self.newList = response.data;
            self.loading = false;
            return response;
        });
    };

    ConfigSafeWaterReport.prototype.updateConfigSafeWaterReport = function (configSafeWaterReport) {
        var self = this;
        return $http.patch(HOST + '/api/SafeWaterConfigReport' + '?customerId=' + this.customerId, configSafeWaterReport).then(function (response) {
            self.updatedList = response.data;
            self.loading = false;
            return response;
        });
    };

    ConfigSafeWaterReport.prototype.deleteConfigSafeWaterReport = function (deviceId) {
        var self = this;
        return $http.delete(HOST + '/api/SafeWaterConfigReport' + '?customerId=' + this.customerId + '&deviceId=' + deviceId).then(function (response) {
            self.deleteResponse = response.data;
            self.loading = false;
            return response;
        });
    };
    return ConfigSafeWaterReport;
}

ConfigSafeWaterReportFactory.$inject = ['HOST', '$http'];

angular.module('mc.config-safe-water-report').factory('ConfigSafeWaterReportFactory', ConfigSafeWaterReportFactory);
'use strict';

function ConfigSafeWaterReportController($, $rootScope, $scope, $sce, $http, HOST, authenticationService, translationService, sharedSetupService, ConfigSafeWaterReportFactory, deviceMenuService, $timeout, $filter, toaster, $uibModal, unsavedChangesService, modalService) {
    var _this2 = this;

    var ctrl = this;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.frequency = ctrl.frequency; //need for
        ctrl.getConfigSafeWaterReport();

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.getDevices = function () {
        ctrl.loading = true;
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.tempDevices = angular.copy(result.data.devices);
            //Filter the devices that has Chlorine Report === true
            ctrl.devices = [];
            ctrl.devices = ctrl.tempDevices.filter(function (device) {
                return device.hasChlorineReport === true;
            });

            //Remove the devices that are already present
            ctrl.devices = ctrl.devices.filter(function (device) {
                return !ctrl.configSafeWaterReport.some(function (oldDevice) {
                    return oldDevice.deviceId === device.deviceId;
                });
            });
            //Add the devices to ctrl.deviceData to read in dropdown in specific format
            ctrl.deviceData = ctrl.devices.map(function (device, index) {
                return { id: index, label: device.name, deviceId: device.deviceId };
            });
            ctrl.loading = false;
        }, function (error) {});
    };

    ctrl.getConfigSafeWaterReport = function () {
        var _configSafeWaterReports = new ConfigSafeWaterReportFactory(ctrl.accountInfo.customerId);
        _configSafeWaterReports.getConfigSafeWaterReport().then(function () {
            ctrl.configSafeWaterReport = _configSafeWaterReports.list;
            for (var i = 0; i < ctrl.configSafeWaterReport.length; i++) {
                ctrl.configSafeWaterReport[i].id = [i];
            }
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.addDestination = function () {
        ctrl.getDevices();
        var newConfigSafeWaterReports = {
            id: -1,
            customerId: ctrl.accountInfo.customerId,
            deviceId: '',
            location: '',
            lowLimit: '',
            pwsid: '',
            contaminantCode: '',
            method: '',
            labId: ''
        };
        ctrl.configSafeWaterReport.unshift(newConfigSafeWaterReports);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveDestination = function (item) {
        item.deviceId = item.deviceId.deviceId;
        var _configSafeWaterReports = new ConfigSafeWaterReportFactory(ctrl.accountInfo.customerId);
        _configSafeWaterReports.addDestination(item).then(function () {
            ctrl.configSafeWaterReport = _configSafeWaterReports.newList;
            for (var i = 0; i < ctrl.configSafeWaterReport.length; i++) {
                ctrl.configSafeWaterReport[i].id = [i];
            }
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.updateDestination = function (item) {
        item.customerId = ctrl.accountInfo.customerId;
        var _configSafeWaterReports = new ConfigSafeWaterReportFactory(ctrl.accountInfo.customerId);
        _configSafeWaterReports.updateConfigSafeWaterReport(item).then(function () {
            ctrl.configSafeWaterReport = _configSafeWaterReports.updatedList;
            for (var i = 0; i < ctrl.configSafeWaterReport.length; i++) {
                ctrl.configSafeWaterReport[i].id = [i];
            }
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = this.translation.text.DELETE_CONFIG_SAFE_WATER_REPORT + ":";
            this.tmpConfirmMessageB = item.deviceName + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _configSafeWaterReports = new ConfigSafeWaterReportFactory(ctrl.accountInfo.customerId);
            _configSafeWaterReports.deleteConfigSafeWaterReport(item.deviceId).then(function () {
                if (_configSafeWaterReports.deleteResponse == 1) {
                    ctrl.getConfigSafeWaterReport();
                }
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.MISSION_REPORTS, "Delete Error!");
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.cancelDestination = function (item) {
        if (item.id === -1) ctrl.configSafeWaterReport.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.setEditMode = function (index, item) {
        ctrl.editModeIndex = ctrl.editModeIndex === index ? null : index;
        if (ctrl.editModeIndex == null) {
            ctrl.updateDestination(item);
        };
    };
};

ConfigSafeWaterReportController.$inject = ['$', '$rootScope', '$scope', '$sce', '$http', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'ConfigSafeWaterReportFactory', 'deviceMenuService', '$timeout', '$filter', 'toaster', '$uibModal', 'unsavedChangesService', 'modalService'];
'use strict';

angular.module('mc.config-safe-water-report').component('configSafeWaterReport', {
    controller: ConfigSafeWaterReportController,
    templateUrl: 'ui/missionreportssetup/configsafewaterreport/config-safe-water-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function AnalogInterconnectListController($scope, authenticationService, datetimeService, translationService, interconnectListService, openViewService, sharedSetupService, websocketService, $location) {
    var _this2 = this;

    var ctrl = this;

    this.$onInit = function () {

        ctrl.translation = translationService.translation;
        var accountInfo = authenticationService.getAccountInfo();

        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        var windowTitle = ctrl.translation.text.ANALOG_INTERCONNECT_LIST;

        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties.device.title = $scope.stickyProperties.device.deviceName;

        $scope.classicView = _this2.classicView;
        $scope.mobile = _this2.mobile;
        var popup = void 0;
        if (!_this2.mobile && !_this2.classicView) {
            popup = _this.getExistingDialog(ctrl.windowId).ref;
            popup.dialog('option', 'title', windowTitle);
        }

        // TODO: Remove direct reliance on parent/child $scope objects
        // For now, due to the fact that this function is looked for on the scope, it needs to remain there
        $scope.fnChangeLanguage = function () {
            windowTitle = ctrl.translation.text.ANALOG_INTERCONNECT_LIST;

            if (!_this2.mobile && !_this2.classicView) {
                popup.dialog('option', 'title', windowTitle);
            }
        };

        ctrl.describeAnalogIntertieMode = function (connFreq) {
            var mode = void 0;

            switch (connFreq) {
                case 0:
                    mode = $scope.translation.text.DISABLED;
                    break;
                case 1:
                    mode = $scope.translation.text.EVERYTX;
                    break;
                case 2:
                    mode = $scope.translation.text.TWOMINUTE;
                    break;
                case 5:
                    mode = '5%';
                    break;
                default:
                    mode = $scope.translation.text.UNKNOWN;
            }

            return mode;
        };

        ctrl.parseStatus = function (status) {
            if (status === 1) {
                return ctrl.translation.text.OK;
            } else if (status === 2) {
                return ctrl.translation.text.PENDING;
            }

            return ctrl.translation.text.BAD;
        };

        ctrl.getStatusColor = function (status) {
            if (status === 1) {
                return 'lightgreen';
            } else if (status === 2) {
                return 'yellow';
            }

            return 'tomato';
        };

        ctrl.dateAgentText = function (date) {
            return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, accountInfo.preferenceUser.timeFormat);
        };

        ctrl.getLastOperation = function (date) {
            if (date === '0001-01-01T00:00:00') {
                return '--';
            }

            return ctrl.dateAgentText(date);
        };

        ctrl.getInputName = function (status) {
            if (status.sourceChannelName) {
                return status.sourceChannelName;
            }

            return ctrl.translation.text.CHANNEL + ' ' + status.sourceAnalogChannel;
        };

        ctrl.getOutputName = function (status) {
            if (status.destinationChannelName) {
                return status.destinationChannelName;
            }

            return ctrl.translation.text.CHANNEL + ' ' + status.destinationOutputChannel;
        };

        ctrl.hasOverflow = function () {
            var element = document.getElementById('analogIntertieList');
            if (element.offsetHeight < element.scrollHeight) {
                return true;
            }
            return false;
        };

        ctrl.openDetail = function (type, analogIntertieId) {
            var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
            optionsStickyProperties.analogIntertieId = analogIntertieId;
            optionsStickyProperties.deviceId = analogIntertieId;

            if ($scope.classicView || $scope.mobile) {
                if (type === 'chart') {
                    $location.path('/interconnect/analog/chart/analog-interconnect-chart-template');
                } else if (type === 'table') {
                    $location.path('/interconnect/analog-intertie-table');
                }
            } else {

                var detailType = void 0;
                var width = void 0;

                if (type === 'chart') {
                    detailType = 'Analog Interconnect Chart';
                    width = 750;
                } else if (type === 'table') {
                    detailType = 'Analog Intertie Table';
                    width = 750;
                }

                var popheight = 500;
                var popupPosition = popup.dialog('option', 'position');
                var x = popup.offset().left;
                var y = popup.offset().top;
                var dialogWidth = popup.dialog('option', 'width');
                var windowWidth = window.innerWidth;
                //console.log($scope.popupOffset);
                popupPosition.at = 'left+' + (x + dialogWidth + $scope.popupOffset) + ' top+ ' + (y + $scope.popupOffset);
                $scope.popupOffset = $scope.popupOffset + 10;
                openViewService.openView(detailType, { width: width, height: popheight }, $scope.popupPosition, optionsStickyProperties);
            }
        };

        // Fetches the latest interconnect status list. On the initial load it wires up
        // the websocket listeners; subsequent (interval) refreshes only update the data.
        ctrl.refreshStatus = function (isInitialLoad) {
            if (isInitialLoad) {
                ctrl.isLoading = true;
            }

            return interconnectListService.getAnalogInterconnectList(accountInfo.customerId).then(function (resp) {
                ctrl.analogStatusList = resp.data;
                if (isInitialLoad) {
                    _registerListener();
                }
            }, function (resp) {
                var errormsg = translation.message[resp.error.message];
                ctrl.alerts.push({ msg: errormsg, type: 'danger' });
            }).finally(function () {
                if (isInitialLoad) {
                    ctrl.isLoading = false;
                }
            });
        };

        ctrl.refreshStatus(true);

        // Manual refresh triggered by the toolbar button. The refresh-live-data
        // component handles disabling the button and the 30-second cooldown.
        ctrl.manualRefresh = function () {
            ctrl.refreshStatus(false);
        };

        var wsDataReceivedAIL = function wsDataReceivedAIL(data) {
            if (ctrl.liveData === false) {
                _unRegisterListener();
                return;
            }

            var updateRowIdx = _.findIndex(ctrl.analogStatusList, function (o) {
                return o.analogIntertieID === parseInt(data.InterconnectId);
            });
            if (updateRowIdx !== -1) {
                if (data.Status === 'OK') {
                    ctrl.analogStatusList[updateRowIdx].status = 1;
                } else if (data.Status === 'PENDING') {
                    ctrl.analogStatusList[updateRowIdx].status = 2;
                } else {
                    ctrl.analogStatusList[updateRowIdx].status = 0;
                }
            }

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            // $scope.analogStatusList[updateRowIdx].lastOperationTimeUTC = varTime;
            ctrl.lastUpdateAt = varTime;
        };

        var wsDataReceivedANALOG = function wsDataReceivedANALOG(data) {
            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            var updateRowIdx = _.findIndex(ctrl.analogStatusList, function (o) {
                return o.destinationDeviceSerial === data.SN && o.destinationOutputChannel === parseInt(data.CH);
            });

            if (updateRowIdx !== -1) {
                ctrl.analogStatusList[updateRowIdx].lastOperationTimeUTC = varTime;
                ctrl.lastUpdateAt = varTime;
            }
        };

        var wsReconnectAIL = function wsReconnectAIL(data) {
            if (ctrl.liveData === false) {
                _unRegisterListener();
                return;
            }
        };

        var wsReconnectANALOG = function wsReconnectANALOG(data) {
            if (ctrl.liveData === false) {
                _unRegisterListener();
                return;
            }
        };

        var wsDataReceivedRTUBASICINFOSETTING = function wsDataReceivedRTUBASICINFOSETTING(data) {
            if (data.Type == 'DEVICEBASICINFO') {
                for (var i = 0; i < ctrl.analogStatusList.length; i++) {
                    if (ctrl.analogStatusList[i].sourceDeviceSerial == data.SN && data.Value.path == "name") {
                        ctrl.analogStatusList[i].sourceDeviceName = data.Value.value;
                    }
                    if (ctrl.analogStatusList[i].destinationDeviceSerial == data.SN && data.Value.path == "name") {
                        ctrl.analogStatusList[i].destinationDeviceName = data.Value.value;
                    }
                }
            }
        };

        var _registerListener = function _registerListener(varSelectedSN) {
            if (ctrl.liveData === true) {
                return;
            }

            ctrl.liveData = true;
            websocketService.connect();
            var uniqueSources = _.uniq(ctrl.analogStatusList, function (o) {
                return o.sourceDeviceSerial;
            });
            //   angular.forEach(uniqueSources, (source) => {
            //       websocketService.register('ANALOGINTERTIE', source.destinationDeviceSerial, '', wsDataReceivedAIL, wsReconnectAIL);
            //   });
            angular.forEach(ctrl.analogStatusList, function (intertie) {
                websocketService.register('ANALOGOUTPUTSOURCE', intertie.destinationDeviceSerial, intertie.destinationOutputChannel, wsDataReceivedANALOG, wsReconnectANALOG);
            });
            for (var i = 0; i < ctrl.analogStatusList.length; i++) {
                websocketService.register("DEVICEBASICINFO", ctrl.analogStatusList[i].sourceDeviceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
                websocketService.register("DEVICEBASICINFO", ctrl.analogStatusList[i].destinationDeviceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
            }
        };

        var _unRegisterListener = function _unRegisterListener(varSelectedSN) {
            if (ctrl.liveData === false) {
                return;
            }

            ctrl.liveData = false;
            ctrl.lastUpdateAt = undefined;
            var uniqueSources = _.uniq(ctrl.analogStatusList, function (o) {
                return o.sourceDeviceSerial;
            });
            //   angular.forEach(uniqueSources, (source) => {
            //       websocketService.unRegister('ANALOGINTERTIE', source.destinationDeviceSerial, '', wsDataReceivedAIL, wsReconnectAIL);
            //   });
            angular.forEach(ctrl.analogStatusList, function (intertie) {
                websocketService.unRegister('ANALOGOUTPUTSOURCE', intertie.destinationDeviceSerial, intertie.destinationOutputChannel, wsDataReceivedANALOG, wsReconnectANALOG);
            });
            for (var i = 0; i < ctrl.analogStatusList.length; i++) {
                websocketService.unRegister("DEVICEBASICINFO", ctrl.analogStatusList[i].sourceDeviceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
                websocketService.unRegister("DEVICEBASICINFO", ctrl.analogStatusList[i].destinationDeviceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
            }
        };

        ctrl.$onDestroy = function () {
            _unRegisterListener();
        };

        $scope.$on('analog_intertie_added', function (e, newAnalogInterconnect) {
            _unRegisterListener();
            ctrl.analogStatusList.push(newAnalogInterconnect);
            ctrl.analogStatusList.sort(function (a, b) {
                return a.analogIntertieID - b.analogIntertieID;
            });
            _registerListener();
        });

        $scope.$on('analog_intertie_updated', function (e, updatedAnalogInterconnect) {
            _unRegisterListener();
            var index = -1;
            for (var i = 0; i < ctrl.analogStatusList.length; i++) {
                if (ctrl.analogStatusList[i].analogIntertieID === updatedAnalogInterconnect.analogIntertieID) {
                    index = i;
                    break;
                }
            }
            if (index !== -1) {
                ctrl.analogStatusList[index] = updatedAnalogInterconnect;
            }
            _registerListener();
        });

        $scope.$on('analog_intertie_deleted', function (e, repId) {
            var newArray = [];
            for (var i = 0; i < ctrl.analogStatusList.length; i++) {
                if (ctrl.analogStatusList[i].analogIntertieID !== repId) {
                    newArray.push(ctrl.analogStatusList[i]);
                }
            }
            ctrl.analogStatusList = angular.copy(newArray);
        });
    };
}

AnalogInterconnectListController.$inject = ['$scope', 'authenticationService', 'datetimeService', 'translationService', 'interconnectListService', 'openViewService', 'sharedSetupService', 'websocketService', '$location'];

angular.module('mc.interconnect').component('analogInterconnectList', {
    controller: AnalogInterconnectListController,
    templateUrl: 'ui/interconnect/analoginterconnectlist/component-template.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        windowTitle: '<'
    }
});
'use strict';

function MapMarkerFactory(HOST, $http) {

    function GetPushpin(customerId, pushpinId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/Map/Marker',
            params: {
                'customerId': customerId,
                'pushpinId': pushpinId
            }
        });
    }

    function SavePushpin(customerId, pushpin) {
        return $http({
            method: 'POST',
            url: HOST + '/api/Map/Marker',
            data: pushpin,
            contentType: 'application/json',
            params: {
                'customerId': customerId
            }
        });
    }

    function DeletePushpin(customerId, pushpinId) {
        return $http({
            method: 'DELETE',
            url: HOST + '/api/Map/Marker',
            params: {
                'customerId': customerId,
                'pushpinId': pushpinId
            }
        });
    }

    function GetMapIcons(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/Map/Marker/icons',
            params: {
                'customerId': customerId
            }
        });
    }

    return {
        GetPushpin: GetPushpin,
        SavePushpin: SavePushpin,
        DeletePushpin: DeletePushpin,
        GetMapIcons: GetMapIcons
    };
}

MapMarkerFactory.$inject = ['HOST', '$http'];

angular.module('mcapp').factory('mapMarkerdService', MapMarkerFactory);
"use strict";

function MapMarkerController($, $rootScope, $scope, $compile, $location, $timeout, $element, sharedSetupService, openViewService, translationService, authenticationService, mapMarkerdService, $window) {
    var _this2 = this;

    var ctrl = this;
    ctrl.pushpinIcons = [];
    ctrl.showLoading = false;
    ctrl.pushpin = {
        "id": -1,
        "customerId": -1,
        "latitude": 0,
        "longitude": 0,
        "name": "",
        "icon": "",
        "description": ""
    };

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(_this2);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for

        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        var tmpPushpin = optionsStickyProperties.pushpin;
        ctrl.pushpin.id = tmpPushpin.id;
        ctrl.pushpin.customerId = tmpPushpin.customerId;
        ctrl.pushpin.longitude = tmpPushpin.longitude;
        ctrl.pushpin.latitude = tmpPushpin.latitude;
        ctrl.pushpin.selectedIcon = "scripts/map/icons/pb.gif"; //setting default icon

        //if sticky properties has valid pushpinId, then fetch and load it
        if (ctrl.pushpin.id > 0) {
            mapMarkerdService.GetPushpin(ctrl.pushpin.customerId, ctrl.pushpin.id).then(function (resp) {
                ctrl.pushpin = resp.data;
                ctrl.pushpin.selectedIcon = "scripts/map/icons/" + ctrl.pushpin.icon;
            });
        }

        sharedSetupService.keepVisibleOnlyCloseButton($element);

        loadMapIconList();

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            $scope.popup.dialog({ resizable: false });

            $scope.popup.dialogExtend({
                restore: function restore(event, ui) {
                    sharedSetupService.keepVisibleOnlyCloseButton($element);
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            };
        }
    };

    ctrl.SavePushpin = function () {
        var tmpPushpin = {
            "id": -1,
            "customerId": -1,
            "latitude": 0,
            "longitude": 0,
            "name": "",
            "icon": "",
            "description": ""
        };

        var iconFullName = ctrl.pushpin.selectedIcon.split("/");
        tmpPushpin.id = ctrl.pushpin.id;
        tmpPushpin.customerId = ctrl.pushpin.customerId;
        tmpPushpin.latitude = ctrl.pushpin.latitude;
        tmpPushpin.longitude = ctrl.pushpin.longitude;
        tmpPushpin.name = ctrl.pushpin.name == null ? "" : ctrl.pushpin.name.replace(/'/gi, "''").replace(/"/gi, '');
        tmpPushpin.icon = iconFullName[iconFullName.length - 1];
        tmpPushpin.description = ctrl.pushpin.description == null ? "" : ctrl.pushpin.description.replace(/'/gi, "''").replace(/"/gi, '');

        //save pushpin
        mapMarkerdService.SavePushpin(tmpPushpin.customerId, tmpPushpin).then(function (resp) {
            //may fetch and reload or close the view
            //console.log("success");
            refreshPushpins(); //making call on mcmap.scada.js to reload pushpins on the map
            ctrl.CancelPushpin();
        }, function (error) {
            //console.log("failure");
        });
    };

    ctrl.DeletePushpin = function () {
        //Delete pushpin
        mapMarkerdService.DeletePushpin(ctrl.pushpin.customerId, ctrl.pushpin.id).then(function (resp) {
            //may fetch and reload or close the view
            //console.log("success");
            refreshPushpins(); //making call on mcmap.scada.js to reload pushpins on the map
            ctrl.CancelPushpin();
        }, function (error) {
            //console.log("failure");
        });
    };

    ctrl.CancelPushpin = function () {
        //Close pushpin view
        if ($rootScope.mobile || ctrl.classicView) $location.path("/map/map");else _this.getExistingDialog(ctrl.windowId).ref.dialog("close");
    };

    var loadMapIconList = function loadMapIconList() {
        mapMarkerdService.GetMapIcons(ctrl.pushpin.customerId).then(function (resp) {
            //may fetch and reload or close the view
            //console.log("success");
            ctrl.pushpinIcons = resp.data;
            //showIconList(ctrl.pushpinIcons);
        }, function (error) {
            //console.log("failure");
        });
    };

    ctrl.DisplayIcons = function () {
        if (ctrl.pushpinIcons.length == 0) loadMapIconList();

        showIconsPane(true);
    };

    ctrl.SetSelectedIcon = function (name) {
        ctrl.pushpin.selectedIcon = "scripts/map/icons/" + name + ".gif";
        showIconsPane(false);
    };

    var showIconsPane = function showIconsPane(isShow) {
        if (isShow) {
            $(".map-pushpin .popupIconList").removeClass("pnlHide");
            $(".map-pushpin .popupIconList").addClass("pnlShow");

            $(".map-pushpin .popupProperty").removeClass("pnlShow");
            $(".map-pushpin .popupProperty").addClass("pnlHide");

            $(".map-pushpin .popupFooter").removeClass("pnlShow");
            $(".map-pushpin .popupFooter").addClass("pnlHide");
        } else {
            $(".map-pushpin .popupIconList").removeClass("pnlShow");
            $(".map-pushpin .popupIconList").addClass("pnlHide");

            $(".map-pushpin .popupProperty").removeClass("pnlHide");
            $(".map-pushpin .popupProperty").addClass("pnlShow");

            $(".map-pushpin .popupFooter").removeClass("pnlHide");
            $(".map-pushpin .popupFooter").addClass("pnlShow");
        }
    };

    $scope.$on('updatePreferencesLanguage', function () {
        //
    });
};

MapMarkerController.$inject = ['$', '$rootScope', '$scope', '$compile', '$location', '$timeout', '$element', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'mapMarkerdService', 'accountWorkflowService', '$window'];
'use strict';

angular.module('mcapp').component('mapMarker', {
    controller: MapMarkerController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/map/marker/map-marker-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.marker-distributor', []);
"use strict";

function MarkerDistributorFactory(HOST, $http) {

    // instantiate our initial object
    var MarkerDistributor = function MarkerDistributor(distributorId) {
        this.distributorId = distributorId;
    };

    MarkerDistributor.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + "/api/Map/Marker/Distributor/get" + "?distributorId=" + this.distributorId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return MarkerDistributor;
}

MarkerDistributorFactory.$inject = ['HOST', '$http'];

angular.module('mc.marker-distributor').factory('MarkerDistributorFactory', MarkerDistributorFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function markerDistributorController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, $uibModal, $element, $timeout, datetimeService, MarkerDistributorFactory, $cookies) {

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;
    ctrl.isTicketSystemAvailable = true;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl._loading = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.deviceId, windowId: $scope.windowId });
        sharedSetupService.keepVisibleOnlyCloseButton($element);
        ctrl.getMarkerDistributor();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog($scope.windowId).ref;
            ctrl._popup.dialogExtend({
                restore: function restore(event, ui) {
                    sharedSetupService.keepVisibleOnlyCloseButton($element);
                }
            });
        }
    };

    ctrl.getMarkerDistributor = function () {
        var _markerDistributor = new MarkerDistributorFactory($scope.stickyProperties.deviceId);
        _markerDistributor.getData().then(function () {
            ctrl.markerDistributor = _markerDistributor.data;

            ctrl._loading = false;
            //Adjust height to match content
            if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.viewAutoHeight(ctrl.windowId);
        });
    };
}

markerDistributorController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$uibModal', '$element', '$timeout', 'datetimeService', 'MarkerDistributorFactory', '$cookies'];
'use strict';

angular.module('mc.marker-distributor').component('markerDistributor', {
    controller: markerDistributorController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/map/markerdistributor/marker-distributor-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.humidity-gauge", []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HumidityGaugeFactory(HOST, $http) {
    var HumidityGauge = function () {
        function HumidityGauge(customerId, deviceId, deviceSelectedName, timeZone) {
            _classCallCheck(this, HumidityGauge);

            this._setting = [];
            this._loading = false;
            this._customerId = customerId;
            this._deviceId = deviceId;
            this._timeZone = timeZone;
            this._deviceName = deviceSelectedName;
        }

        _createClass(HumidityGauge, [{
            key: 'fetchData',
            value: function fetchData() {
                var _this = this;

                this._loading = true;
                return $http.get(HOST + '/api/HumidityData?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&timeZone=' + this._timeZone).then(function (resp) {
                    _this._loading = false;
                    return resp;
                });
            }
        }, {
            key: 'getDataForWidget',
            value: function getDataForWidget(customerId, deviceId, timeZone) {
                var _this2 = this;

                this._loading = true;
                return $http.get(HOST + '/api/HumidityData?customerId=' + customerId + '&deviceId=' + deviceId + '&timeZone=' + timeZone).then(function (resp) {
                    _this2._loading = false;
                    return resp;
                });
            }
        }, {
            key: 'deviceName',
            get: function get() {
                return this._deviceName;
            }
        }, {
            key: 'setting',
            get: function get() {
                return this._setting;
            }
        }, {
            key: 'loading',
            get: function get() {
                return this._loading;
            }
        }, {
            key: 'deviceId',
            set: function set(deviceId) {
                this._deviceId = deviceId;
            }
        }]);

        return HumidityGauge;
    }();

    return HumidityGauge;
}

HumidityGaugeFactory.$inject = ['HOST', '$http', 'translationService'];

angular.module('mc.humidity-gauge').factory('HumidityGaugeFactory', HumidityGaugeFactory);
'use strict';

function HumidityGaugeController(_, $, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, timeLapseService, websocketService, openViewService, sharedSetupService, HumidityGaugeFactory, toaster, rangeSelectorService) {
    var _this2 = this;

    var LIVEDATAISOFFFORNOW = true;

    this.downloadViewTypeOptions = [0];
    this.setDevice = function (selectedDevice) {
        $scope.deviceSelected = selectedDevice.deviceId;
        $scope.deviceSelectedSn = selectedDevice.serialNumber;
        $scope.deviceSelectedType = selectedDevice.type;
        $scope.deviceSelectedName = selectedDevice.name;
        $scope.currentSelectedDevice = selectedDevice;
    };

    var tlDataReceivedHUMIDITY = function tlDataReceivedHUMIDITY(data) {

        if (LIVEDATAISOFFFORNOW) return;

        if (_this2.liveData === false) {
            unregisterListener();
            return;
        }

        var extremes = _this2.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - _this2.unixDay / 2) {
            unregisterListener($scope.deviceSelectedSn);
            return;
        }

        var liveDataLine = _this2.chart.xAxis[0].plotLinesAndBands;
        liveDataLine[0].options.value = data.Unix + _this2.maxPadding;

        if (extremes.max + _this2.liveDataOffset > extremes.dataMax) {
            _this2.chart.xAxis[0].setExtremes(data.Unix - tmpRange + _this2.minPadding, data.Unix + _this2.maxPadding);
        }
    };

    var wsDataReceivedHUMIDITY = function wsDataReceivedHUMIDITY(data) {

        if (LIVEDATAISOFFFORNOW) return;

        if (data && data.ComputeTime) {

            var str = data.ComputeTime + '';
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000

            for (var i = 0; i < _this2.series.length; i++) {
                _this2.series[i].data.push([unixtime, parseFloat(data.Value)]);
            }

            for (var i = 0; i < _this2.rawSeries.length; i++) {
                _this2.rawSeries[i].data.push([unixtime, parseFloat(data.Value)]);
            }

            for (var i = 0; i < _this2.chart.series.length; i++) {
                _this2.chart.series[i].data.push([unixtime, parseFloat(data.Value)]);
            }

            var resetView = 'live';
            _drawGauge(resetView);

            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;
                var extremes = _this2.chart.xAxis[0].getExtremes();
                if (_this2.liveDataEndDate > result.unixTimeStamp && $scope.stickyProperties.zoomMax + _this2.liveDataOffset >= extremes.dataMax) {
                    registerListener($scope.deviceSelectedSn);
                    var _data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                    tlDataReceivedHUMIDITY(_data);
                }
            });
        }
    };

    var wsReconnectHUMIDITY = function wsReconnectHUMIDITY(data) {
        //
    };

    var registerListener = function registerListener(deviceSn) {

        if (_this2.liveData === true) {
            return;
        }

        _this2.liveData = true;
        if (_this2.humidityGauge) {
            _this2.humidityGauge.liveData = _this2.liveData;
        }
        websocketService.connect();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: true, windowId: _this2.windowId });
        timeLapseService.register('HUMIDITY', deviceSn || $scope.deviceSelectedSn, '', tlDataReceivedHUMIDITY);
        websocketService.register('HUMIDITY', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedHUMIDITY, wsReconnectHUMIDITY);
    };

    var unregisterListener = function unregisterListener(deviceSn) {
        if (_this2.liveData === false) {
            return;
        }
        _this2.liveData = false;
        if (_this2.humidityGauge) {
            _this2.humidityGauge.liveData = _this2.liveData;
        }
        _this2.lastUpdateAt = undefined;
        if (_this2.chart != null) timeLapseService.unRegister('HUMIDITY', deviceSn || $scope.deviceSelectedSn, '', tlDataReceivedHUMIDITY);
        websocketService.unRegister('HUMIDITY', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedHUMIDITY, wsReconnectHUMIDITY);
    };

    var setLiveDataStatus = function setLiveDataStatus(varEndDate) {
        _this2.liveDataEndDate = varEndDate ? varEndDate : _this2.liveDataEndDate;
        if (_this2.selectedGrouping === '4') {
            _this2.liveDataEndDate += _this2.unixDay;
        }

        timeLapseService.getLocalDateTime().then(function (resp) {
            var result = resp.data;
            $scope.heartbeatLocalDateTime = resp.data.unixTimeStamp;
            var extremes = _this2.chart.xAxis[0].getExtremes();
            if (_this2.liveDataEndDate > result.unixTimeStamp && $scope.stickyProperties.zoomMax + _this2.liveDataOffset >= extremes.dataMax) {
                registerListener($scope.deviceSelectedSn);
                var data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedHUMIDITY(data);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: _this2.windowId });
                unregisterListener($scope.deviceSelectedSn);
            }
        });
    };

    var _drawGauge = function _drawGauge() {
        var chartBase = $('#humidity-gauge-' + _this2.replaceSpaces(_this2.windowId));
        chartBase[0].setAttribute("class", "hcolHumidity");
        var gaugeMeasurement = "%";
        var gaugeTitle = "Humidity";

        _this2.chart = new Highcharts.Chart({

            chart: {
                renderTo: chartBase[0],
                type: 'gauge',
                plotBackgroundColor: null,
                plotBackgroundImage: null,
                backgroundColor: 'rgba(0,0,0,0)',
                plotBorderWidth: 0,
                plotShadow: false,
                spacing: [0, 0, 0, 0]
            },

            title: {
                text: null
            },
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            pane: {
                startAngle: -150,
                endAngle: 150
            },
            xAxis: {
                labels: {
                    formatter: function formatter() {
                        return this.value.toString().substring(0, 2);
                    }
                }

            },
            //tooltip: {
            //    enabled: true,
            //    formatter: function () {
            //        return Highcharts.dateFormat('%b %e, %Y %H:%M:%S', this.time) + ': <br><b>' + this.y + "%" + "</b>";

            //    }

            //},
            yAxis: {
                min: 0,
                max: 100,

                minorTickWidth: 0,

                //   tickPixelInterval: 30,
                tickWidth: 1,
                tickLength: 10,
                tickColor: '#666',
                tickPositions: [0, 30, 60, 100],

                title: {
                    text: '<p style="text-align:center;">' + gaugeTitle + '</p>'
                },

                plotBands: [{
                    from: 0,
                    to: 30,
                    color: '#E8DB4F' // yellow
                }, {
                    from: 30,
                    to: 60,
                    color: '#55BF3B' // green
                }, {
                    from: 60,
                    to: 100,
                    color: '#DF5353' // red
                }]
            },
            plotOptions: {
                gauge: {
                    dataLabels: {
                        y: -10,
                        borderWidth: 0,
                        useHTML: true
                    }
                }
            },

            series: [{
                name: 'Humidity Percentage',
                data: [_this2.gaugeData.value],
                tooltip: {
                    valueSuffix: '%'
                },
                dataLabels: {
                    enabled: true,
                    borderWidth: 0,
                    format: '<div style="text-align:center;margin-top:16px;"><span style="font-size:120%;color:' + (Highcharts.theme && Highcharts.theme.contrastTextColor || 'black') + '">{y:.2f}</span><br/>' + '<span style="font-size:12px;">' + gaugeMeasurement + '</span></div>'
                }
            }]

        });
    };

    var _getData = function _getData() {
        _this2.humidityGauge.fetchData().then(function (resp) {
            var chartBase = $('#humidity-gauge-' + _this2.replaceSpaces(_this2.windowId));
            $scope.alerts = [];
            _this2.alerts = [];
            _this2.gaugeData = resp.data.gaugeMeasurement;
            _this2.time = resp.data.unixTime;

            if (resp.data.gaugeMeasurement.localDateTime != "0001-01-01T00:00:00") {
                //this.devicename = resp.data.device.name;
                //sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate, windowId: this.windowId });
                _drawGauge();
            } else {
                //sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate, windowId: this.windowId });
                chartBase.empty();
                _this2.chart = null;
                //this.lastStart = startDate;
                //this.lastEnd = endDate;
                var errormsg = _this2.translation.text.NO_DATA;
                $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
                _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
            }
        }, function (resp) {
            $scope.alerts = [];
            _this2.alerts = [];
            chartBase.empty();
            _this2.chart = null;
            var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
            $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
            _this2.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
        });
    };

    $timeout(function () {
        var chartBase = $('#humidity-gauge-' + _this2.replaceSpaces(_this2.windowId));

        if (chartBase) {
            //$("#humidity-gauge-Humidity_Gauge").on("mouseover", function () {
            //    alert("The paragraph was clicked.");
            //});
            $("#humidity-gauge-Humidity_Gauge").on('mouseover', function (event) {
                var localScope = $(event.target).scope();
                if ($(event.currentTarget).is('.hcolHumidity') && !_this2.mobile && !_this2.classicView) {
                    $(event.currentTarget).draggable({
                        helper: "clone",
                        revert: false,
                        appendTo: "body",
                        containment: "body",
                        opacity: 0.35,
                        stop: function stop(event, ui) {
                            var mcDevice = { deviceId: $scope.deviceSelected, serialNumber: $scope.deviceSelectedSn, signalStrength: true };

                            var optionsStickyProperties = {
                                device: mcDevice
                            };

                            var $newPosX = ui.offset.left;
                            var $newPosY = ui.offset.top;
                            var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                            openViewService.openWidget('Humidity Widget', { width: 240, height: 240 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                            $scope.$apply();
                        }
                    });
                }
            });
        }
    });

    this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        _this2.chart = null;
        _this2.myDate = null;
        //this.scrollingInProgress = false;
        //this.initialLoad = true;
        //this.zoomLevelCurrent = 0;
        //this.zoomLevelPrevious = 0;
        //this.xValue = null;
        _this2.liveData = false;
        _this2.selectedDeviceSN = null;
        _this2.chartDrawn = false;
        //this.minPadding = 0;
        //this.maxPadding = 0;
        //this.selectedGrouping = '1';
        //this.afterSetExtremesTimer = null;
        _this2.windowId = _this2.windowId || 'Humidity Chart';
        _this2.alerts = [];
        $scope.alerts = [];
        //this.series = [];
        //this.rawSeries = [];
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        $scope.windowTitle = _this2.translation.text.HUMIDITY_GAUGE;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.TimeFormatEnum = { Civilian: 1, Military: 2 };
        _this2.measurement = _this2.accountInfo.preferenceUser.lookupMeasurementID;
        _this2.preferredTimeFormat = _this2.accountInfo.preferenceUser.timeFormat;
        _this2.unixDay = sharedSetupService.unixDay;
        _this2.unixHour = 3600000;
        _this2.liveDataOffset = 20 * 60 * 1000;
        _this2.mouseWheelZoom = sharedSetupService.mouseWheelZoom;

        if (!_this2.mobile && !_this2.classicView) {
            $scope.windowId = _this2.windowId;
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;

            $timeout(function () {
                var chartBase = $('#humidity-chart-' + _this2.replaceSpaces(_this2.windowId));

                chartBase.on('mousewheel', function (event) {
                    if (!_this2.scrollingInProgress) {
                        _this2.mouseWheelZoom(event, _this2.chart, _this2.xValue);
                    }
                });
            });
        }

        $scope.$on('updatePreferencesLanguage', function (event, language) {
            openViewService.adjustContentSize(_this2._popup);
            if ($scope.alerts.length > 0) {
                var _msg = _this2.translation.message[$scope.alerts[0].languageCode.toUpperCase()];
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;

                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(_this2.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                }

                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }

            if (_this2.alerts.length === 0) {
                _drawGauge();
            }
        });

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            _this2.preferredTimeFormat = parseInt(timeFormat, 10);
            if (_this2.alerts.length === 0) {
                _drawGauge();
            }
        });

        //$scope.zoomAdjust = (varDay) => {
        //    var extremes = this.chart.xAxis[0].getExtremes();
        //    $scope.varDay = varDay;
        //    var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, $scope.heartbeatLocalDateTime);
        //    this.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
        //    setLiveDataStatus();
        //}

        //$scope.mostRecentData = () => {
        //    this.myDate = null;
        //    toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
        //    $scope.fetchDataForSelectedDate(new Date());
        //}

        $scope.$watch(function () {
            return $scope.deviceSelectedSn;
        }, function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                if (oldVal) {
                    unregisterListener(oldVal);
                }
            }
        }, true);

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal) {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newVal, windowId: _this2.windowId });

                if (_this2.humidityGauge) {
                    _this2.humidityGauge.deviceId = newVal;
                } else {
                    _this2.humidityGauge = new HumidityGaugeFactory(_this2.accountInfo.customerId, newVal, $scope.deviceSelectedName, _this2.accountInfo.timeZone);
                }

                _getData();
                //let tmpDates = null;
                //let tmpStartDate = null;
                //let tmpEndDate = null;

                //if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
                //    $scope.stickyProperties.on = true;
                //    tmpStartDate = $scope.stickyProperties.dateMin;
                //    tmpEndDate = $scope.stickyProperties.dateMax;
                //} else {
                //    $scope.stickyProperties.on = false;
                //}

                //if (!tmpStartDate) {
                //    timeLapseService.getLocalDateTime().then((resp) => {
                //        const result = resp.data;

                //        tmpDates = new Date(result.localDateTime);
                //        tmpDates.setHours(0, 0, 0, 0);
                //        tmpDates = datetimeService.dateToUnixtime(tmpDates);
                //        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                //        tmpStartDate = tmpDates.startDate;
                //        tmpEndDate = tmpDates.endDate;
                //        _getData(tmpStartDate, tmpEndDate);
                //    });
                //} else {
                //    _getData(tmpStartDate, tmpEndDate);
                //}
            }
        }, true);
    };

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    this.$onDestroy = function () {
        unregisterListener($scope.deviceSelectedSn);
        if (_this2.chart) _this2.chart.destroy();
    };
}

HumidityGaugeController.$inject = ['_', '$', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'timeLapseService', 'websocketService', 'openViewService', 'sharedSetupService', 'HumidityGaugeFactory', 'toaster', 'rangeSelectorService'];
'use strict';

angular.module('mc.humidity-gauge').component('humidityGauge', {
    controller: HumidityGaugeController,
    templateUrl: 'ui/humidity/gauge/humidity-gauge-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.marker-customer', []);
"use strict";

function MarkerCustomerFactory(HOST, $http) {

    // instantiate our initial object
    var MarkerCustomer = function MarkerCustomer(customerId) {
        this.customerId = customerId;
    };

    MarkerCustomer.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + "/api/Map/Marker/Customer/get" + "?customerId=" + this.customerId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return MarkerCustomer;
}

MarkerCustomerFactory.$inject = ['HOST', '$http'];

angular.module('mc.marker-customer').factory('MarkerCustomerFactory', MarkerCustomerFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function markerCustomerController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, $uibModal, $element, $timeout, datetimeService, MarkerCustomerFactory, $cookies) {

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;
    ctrl.isTicketSystemAvailable = true;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl._loading = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.deviceId, windowId: $scope.windowId });
        sharedSetupService.keepVisibleOnlyCloseButton($element);
        ctrl.getMarkerCustomer();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog($scope.windowId).ref;
            ctrl._popup.dialogExtend({
                restore: function restore(event, ui) {
                    sharedSetupService.keepVisibleOnlyCloseButton($element);
                }
            });
        }
    };

    ctrl.getMarkerCustomer = function () {
        var _markerCustomer = new MarkerCustomerFactory($scope.stickyProperties.deviceId);
        _markerCustomer.getData().then(function () {
            ctrl.markerCustomer = _markerCustomer.data;

            ctrl._loading = false;
            //Adjust height to match content
            if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.viewAutoHeight(ctrl.windowId);
        });
    };
}

markerCustomerController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$uibModal', '$element', '$timeout', 'datetimeService', 'MarkerCustomerFactory', '$cookies'];
'use strict';

angular.module('mc.marker-customer').component('markerCustomer', {
    controller: markerCustomerController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/map/markercustomer/marker-customer-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.wts-usage-log", []);
"use strict";

function WtsUsageLogFactory(HOST, $http) {

    // instantiate our initial object
    var WtsUsageLog = function WtsUsageLog(customerId, startDate, endDate, timeZone) {
        this.customerId = customerId;
        this.startDate = startDate;
        this.endDate = endDate;
        this.timeZone = timeZone;
    };

    WtsUsageLog.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + "/api/Germantown/WtsUsageLog" + "?customerId=" + this.customerId + "&startDate=" + this.startDate + "&endDate=" + this.endDate + "&timeZone=" + this.timeZone).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return WtsUsageLog;
}

WtsUsageLogFactory.$inject = ['HOST', '$http'];

angular.module('mc.wts-usage-log').factory('WtsUsageLogFactory', WtsUsageLogFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function WtsUsageLogController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, WtsUsageLogFactory, LoginsFactory, $timeout, $filter, $element, getDateRangeService, savePdfService) {
    var ctrl = this;
    $scope.alerts = [];

    ctrl.$onInit = function () {
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurementId = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? 1 : 3.78541;
        ctrl.wtsUsageLogScale = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? 1 : 1.00 / 60.00;
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for

        ctrl.goSelectReportData();
        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.checkScrollBar();
            };

            ctrl.checkScrollBar = function () {
                var _table = $scope.popup.parent().find('.tabular-data-container');
                _table.css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                ctrl.scrollBar = _table.get(0).scrollHeight > _table.get(0).clientHeight;
            };
        }
    };

    ctrl.goSelectReportData = function () {
        $scope.alerts = [];
        if (!angular.isUndefined(ctrl.wtsUsageLog)) ctrl.wtsUsageLog.loading = true;
        ctrl.maxDateRange = getDateRangeService.getRange("WtsUsageLog");
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        var numberOfDays = ctrl.maxDateRange - 1,
            varDateRangeStart,
            varDateRangeEnd,
            varDateRangeEndTmp;
        if (ctrl.stickyProperties.on === true) {
            //sharedSetupService.checkStickyProperties(ctrl.stickyProperties); TODO: will come back to reconsider sharedSetupService.getLiveDates()
            ctrl.stickyProperties.on = false;
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
            varDateRangeEnd = ctrl.myDateRangeEnd;
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeStart = ctrl.myDateRangeStart;
            varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
        } else {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }

        //TODO: will come back to reconsider sharedSetupService.regenerateDates()
        if ((ctrl.mobile || ctrl.classicView) && !(new Date(varDateRangeStart).getTime() > 0 && new Date(varDateRangeEnd).getTime() > 0)) {
            var tmpDates = sharedSetupService.getLiveDates();
            varDateRangeStart = tmpDates.startDate;
            varDateRangeEnd = tmpDates.endDate;

            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(tmpDates.endDate);
        }

        if (!ctrl.checkDateRange()) return;

        var _wtsUsageLog = new WtsUsageLogFactory(ctrl.accountInfo.customerId, varDateRangeStart, varDateRangeEnd, ctrl.accountInfo.timeZone); //varDateRangeEndTmp - is StartDate

        _wtsUsageLog.getData().then(function () {
            ctrl.wtsUsageLog = _wtsUsageLog.data;
            ctrl.wtsUsageLog.loading = false;
            if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: ctrl.windowId });
            ctrl.refreshAlerts();
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                1: { columnWidth: 90 },
                2: { columnWidth: 90 },
                3: { columnWidth: 80 },
                4: { columnWidth: 80 },
                5: { columnWidth: 70 }
            }
        };
        savePdfService.savePDF(pdfParams);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        if (!ctrl.checkDateRange()) return;
        ctrl.timeFormat = timeFormat;
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        if (!ctrl.checkDateRange()) return;
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    ctrl.refreshAlerts = function () {
        $scope.alerts = [];
        if (ctrl.wtsUsageLog.length === 0) {
            var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(ctrl.wtsUsageLog.startDate).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.wtsUsageLog.endDate).format('MM/DD/YY, h:mm:ss a');
            $scope.alerts.push({
                msg: errorMessage,
                type: "info"
            });
        }
    };

    ctrl.refreshData = function () {
        if (!ctrl.checkDateRange()) return;
        ctrl.wtsUsageLog = angular.copy(ctrl.wtsUsageLog);
        ctrl.wtsUsageLog.loading = false;
    };

    ctrl.checkDateRange = function () {
        if (new Date(ctrl.myDateRangeEnd - ctrl.myDateRangeStart) / 86400000 > ctrl.maxDateRange) {
            ctrl.wtsUsageLog = [];
            $scope.alerts = [];
            var errorMessage = ctrl.translation.text.MAXDATE + ": " + ctrl.maxDateRange + " " + ctrl.translation.text.DAYS;
            $scope.alerts.push({
                msg: errorMessage,
                type: "danger"
            });
            ctrl.wtsUsageLog.loading = false;
            return false;
        }
        return true;
    };
}

WtsUsageLogController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'WtsUsageLogFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'getDateRangeService', 'savePdfService'];
'use strict';

angular.module('mc.wts-usage-log').component('wtsUsageLog', {
    controller: WtsUsageLogController,
    templateUrl: 'ui/germantown/wtsusagelog/wts-usage-log-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.controller("humidityWidgetController", ["$scope", "$rootScope", "translationService", "sharedSetupService", "authenticationService", "$element",
    function ($scope, $rootScope, translationService, sharedSetupService, authenticationService, $element) {
        $scope.Time = null;
        $scope.translation = translationService.translation;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.downloadViewTypeOptions = [0];
        sharedSetupService.getWindowId($scope);
        if (typeof $scope.stickyProperties != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        $scope.setSetting = function () {
            $scope.deviceSelectedId = { "deviceId": $scope.stickyProperties.device.deviceId };
            $scope.signalStrength = $scope.stickyProperties.device.signalStrength;
            $scope.preDeviceSelected = $scope.stickyProperties.device;
        };

        $scope.setSetting();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            $scope.closeWidget = function () {
                $element.find(".flip-container").hide();
                $scope.popup.dialog("close");
            };

            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.resizeContent();
                    $scope.$apply();
                }
            });

            $scope.resizeContent = function () {
                if (!$element.find(".gauge-widget-icon").highcharts())
                    return;

                $element.find('circle:not(:last)').each(function () {
                    $(this).remove();
                });

                var _newWidth = $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "");
                var _newHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $element.find('.widgetSettingNew').css("width", _newWidth < 240 ? 240 : _newWidth)
                    .css("margin-left", _newWidth < 240 ? -(240 - _newWidth) / 2 : "auto");

                $scope.popup.parent().find('.gauge-widget-icon')
                    .css("width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.gauge-widget-icon')
                    .css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")); //25: total padding
                var _char = $element.find(".gauge-widget-icon").highcharts();
                _char.setSize(
                    $scope.popup.parent().find('.gauge-widget-icon').css("width").replace(/[^0-9.]+/g, "") * 1,
                    ($scope.popup.parent().find('.gauge-widget-icon').css("height").replace(/[^0-9.]+/g, "") -
                        $scope.popup.parent().find('.widget-title').css("height").replace(/[^0-9.]+/g, "")) *
                    .95,
                    false
                );
                var _fontSize = _newWidth < _newHeight ? _newWidth / 12 : _newHeight / 12;
                _fontSize = _fontSize < 12 ? 12 : _fontSize > 35 ? 35 : _fontSize;
                _char.container.parentNode.style.fontSize = _fontSize + "px";
                _char.reflow();
            };
        } else {
            $scope.popup = $(".flip-container");
            $scope.resizeContent = function () {
                if (!$element.find(".gauge-widget-icon").highcharts())
                    return;
                $element.find('circle:not(:last)').each(function () {
                    $(this).remove();
                });

                var _char = $element.find(".gauge-widget-icon").highcharts();

                var _fontSize = 25;
                _char.container.parentNode.style.fontSize = _fontSize + "px";
                _char.reflow();
            }
        }

    }]);
mcapp.directive('humidityWidgetDirective', ['$rootScope', "authenticationService", "websocketService", "signalGaugeService", "deviceService", "datetimeService", "toaster", "openViewService", "$document", "sharedSetupService", "$timeout", "HumidityGaugeFactory",
    function ($rootScope, authenticationService, websocketService, signalGaugeService, deviceService, datetimeService, toaster, openViewService, $document, sharedSetupService, $timeout, HumidityGaugeFactory) {
        function link(scope, element, attrs) {
            var chart;
            scope.humidityGauge = new HumidityGaugeFactory(scope.accountInfo.customerId, scope.deviceSelectedId.deviceId, scope.deviceSelectedName, scope.accountInfo.timeZone);
            scope.getSignalData = function (DeviceID) {
                scope.humidityGauge.getDataForWidget(scope.accountInfo.customerId, DeviceID, scope.accountInfo.timeZone)
                    .then(function (result) {
                        scope.alerts = [];
                        scope.device = result.data.device;
                        scope.signalStrengthParam = result.data.device.gaugeMeasurement;
                        var _device = { deviceId: scope.device.deviceId, channel: "Signal", serialNumber: scope.device.serialNumber };
                        sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.device.deviceId, device: _device, windowId: scope.windowId });
                        if (scope.popup.selector !== ".flip-container") scope.popup.dialog("option", "title", scope.device.name);
                        scope.deviceSelectedName = scope.device.name;
                        if (result.data.gaugeMeasurement.localDateTime != "0001-01-01T00:00:00") {
                            scope.Time = result.data.gaugeMeasurement.unixTime;
                            //websocketService.connect();
                            //websocketService.unRegister("SIGNAL", scope.preDeviceSelected.serialNumber, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                            //websocketService.register("SIGNAL", scope.device.serialNumber, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                            scope.preDeviceSelected = result.data.device;
                            _drawSignalGauge(result.data);
                        }
                        else {                            
                            if (chart) {
                                chart.destroy();
                                chart = null;
                            }
                            scope.alerts.push({ msg: scope.translation.text.NO_DATA, type: "info" });
                        }
                    }, function (error) {
                        scope.alerts = [];
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                    }).then(function () {
                        scope.resizeContent();
                        $timeout(function () {
                            scope.resizeContent();
                        }, 0); //need second call to adjust alignment
                    });
            }
            
            element.attr("class", "gauge-widget-icon");

            var _drawSignalGauge = function (data) {
                var signalMeasurement = "%";
                title = '<br><br>' + data.device.name + ' (Humidity)';
                var gaugeTitle = "Humidity";
                chart = new Highcharts.Chart({

                    chart: {
                        renderTo: element[0],
                        type: 'gauge',
                        plotBackgroundColor: null,
                        plotBackgroundImage: null,
                        backgroundColor: 'rgba(0,0,0,0)',
                        plotBorderWidth: 0,
                        plotShadow: false,
                        spacing: [0, 0, 0, 0],
                        style: {
                            fontSize: '1em'
                        }
                    },

                    title: {
                        text: null
                    },
                    exporting: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    pane: {
                        startAngle: -150,
                        endAngle: 150

                    },
                    xAxis: {
                        labels: {
                            formatter: function () {
                                return this.value.toString().substring(0, 2);
                            }
                        },

                    },
                    //tooltip: {
                    //    enabled: true,
                    //    formatter: function () {
                    //        return Highcharts.dateFormat('%b %e, %Y %H:%M:%S', scope.Time) + ': <br><b>' + this.y + signalMeasurement + "</b>";

                    //    }

                    //},
                    yAxis: {
                        min: 0,
                        max: 100,

                        minorTickWidth: 0,

                        //   tickPixelInterval: 30,
                        tickWidth: 1,
                        tickLength: 10,
                        tickColor: '#666',
                        tickPositions: [0, 30, 60, 100],
                        labels: {
                            style: {
                                fontSize: '.5em'
                            }

                        },
                        title: {
                            text: '<p style="text-align:center;">' + gaugeTitle + '</p>',
                            style: {
                                fontSize: '.7em'
                            }
                        },

                        plotBands: [{
                            from: 0,
                            to: 30,
                            color: '#E8DB4F' // yellow
                        }, {
                            from: 30,
                            to: 60,
                            color: '#55BF3B' // green
                        }, {
                            from: 60,
                            to: 100,
                            color: '#DF5353' // red
                        }]
                    },
                    plotOptions: {
                        gauge: {
                            dataLabels: {
                                y: -10,
                                borderWidth: 0,
                                useHTML: true
                            }
                        }
                    },

                    series: [{
                        name: 'Humidity Percentage',     
                        data: [data.gaugeMeasurement.value],
                        tooltip: {
                            valueSuffix: '%'
                        },
                        dataLabels: {
                            enabled: true,
                            borderWidth: 0,
                            format: '<div style="text-align:center;margin-top:16px;"><span style="font-size:120%;color:' +
                                ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y:.2f}</span><br/>' +
                                '<span style="font-size:12px;">' + "%" + '</span></div>'
                        }
                    }]

                });

            };

            var wsDataReceivedSIGNAL = function (data) {
                scope.Time = datetimeService.toUnixtime(data.Time);
                chart.series[0].points[0].update(parseFloat(data.Value));
                scope.lastUpdateAt = datetimeService.socketStrToServerStrTime(data.Time);
            };

            scope.mostRecentData = function () {
                toaster.pop('success', "Signal Widget" + " -- " + scope.deviceSelectedName, 'View reloading');
                wsReconnectSIGNAL();
            }

            var wsReconnectSIGNAL = function (data) {
                scope.getSignalData(scope.deviceSelectedId.deviceId);
            };

            scope.isTouchSupported = function () {
                var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
                var generalTouchEnabled = "ontouchstart" in document.createElement("div");

                if (msTouchEnabled || generalTouchEnabled) {
                    return true;
                }
                return false;
            };

            scope.replaceSpaces = function (str) {
                return str.replace(/ /g, '_');
            };

            scope.$on('document_click', function (e, event) {
                var $tgt = $(event.target);
                if ($tgt.closest('#signal-widget-' + scope.replaceSpaces(scope.windowId)).length === 0 || ($tgt.closest('.back').length === 0 && $tgt.closest('.front').length === 0)) {

                    if (scope.isTouchSupported()) {
                        scope.popup.parent().find(".front").toggle(true);
                        scope.popup.parent().find(".back").toggle(false);
                    } else {
                        $('#signal-widget-' + scope.replaceSpaces(scope.windowId)).offsetParent().offsetParent().find('.flip-container').toggleClass('flip', false);
                    }

                    scope.setSetting();
                    scope.resizeContent();
                }
            });

            scope.popup.parent().on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            if (scope.popup.parent().is('.ui-draggable-dragging, .ui-resizable-resizing') || event.target.nodeName === 'SELECT') {
                                return;
                            }

                            $rootScope.$broadcast('document_click', event);

                            if (scope.isTouchSupported()) {
                                scope.popup.parent().find(".back").toggle();
                                scope.popup.parent().find(".front").toggle();
                            } else {
                                scope.popup.parent().find('.flip-container').toggleClass('flip');
                            }

                            scope.setSetting();
                            scope.resizeContent();
                        }
                    );
                }
            );

            scope.popup.parent().find("select").on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            );

            scope.popup.parent().on(
                "mouseover",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            scope.popup.parent().addClass("x-resize");
                            scope.closeIcon = true;
                        }
                    );
                }
            );

            scope.popup.parent().on(
                "mouseout",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            scope.popup.parent().removeClass("x-resize");
                            if (scope.isTouchSupported()) {
                                setTimeout(function () {
                                    scope.closeIcon = false;
                                }, 3000);
                            }
                            else {
                                scope.closeIcon = false;
                            }
                        }
                    );
                }
            );

            scope.$on(
                "$destroy",
                function (event) {
                    //websocketService.unRegister("SIGNAL", scope.device.serialNumber, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                    scope.popup.parent().off();
                    scope.popup.parent().find("select").off();
                    if (chart) chart.destroy();
                }
            );

            scope.getSignalData(scope.deviceSelectedId.deviceId);
            if (scope.popup.selector !== ".flip-container") scope.popup.dialog("option", "dialogClass", "ui-widget-content-new");
        }


        return {
            restrict: 'A',
            replace: false,
            link: link
        };
    }]);

mcapp.directive('humiditySettingDirective', ["authenticationService", "websocketService", "deviceMenuService", "deviceService", "toaster",
    function (authenticationService, websocketService, deviceMenuService, deviceService, toaster) {
        function link(scope, element, attrs) {
            scope.notfirst = false;
            deviceMenuService.getDeviceMenuList(scope.accountInfo.customerId)
                .then(function (result) {
                    scope.Devices = result.data.devices;
                }, function (error) {
                });

            scope.getBackToSignalData = function (DeviceID) {
                if (DeviceID != null)
                    scope.getSignalData(DeviceID);
                scope.popup.parent().find('.flip-container').toggleClass('flip');
                if (scope.isTouchSupported()) {
                    scope.popup.parent().find(".back").toggle();
                    scope.popup.parent().find(".front").toggle();
                }

                scope.resizeContent();
            };

        }
        return {
            link: link
        };


    }]);
"use strict";

angular.module("mc.wts-usage-log-print", []);
"use strict";

function WtsUsageLogPrintFactory(HOST, $http) {

    // instantiate our initial object
    var _wtsUsageLogPrint = function _wtsUsageLogPrint() {};

    _wtsUsageLogPrint.prototype.listWtsCustomerLog = function (customerId, wtsCustomerId, month, year, timeZone, allCustomers) {
        var self = this;
        if (allCustomers) {
            return $http.get(HOST + "/api/Germantown/WtsUsageLogPrint" + "?customerId=" + customerId + "&month=" + month + "&year=" + year + "&timeZone=" + timeZone).then(function (response) {
                self.data = response.data;
                self.loading = false;
                return response;
            });
        } else {
            return $http.get(HOST + "/api/Germantown/WtsUsageLogPrint" + "?customerId=" + customerId + "&wtsCustomerId=" + wtsCustomerId + "&month=" + month + "&year=" + year + "&timeZone=" + timeZone).then(function (response) {
                self.data = response.data;
                self.loading = false;
                return response;
            });
        }
    };
    return _wtsUsageLogPrint;
}

WtsUsageLogPrintFactory.$inject = ['HOST', '$http'];

angular.module('mc.wts-usage-log-print').factory('WtsUsageLogPrintFactory', WtsUsageLogPrintFactory);
'use strict';

function WtsUsageLogPrintController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, WtsUsageLogFactory, LoginsFactory, $timeout, $filter, $element, getDateRangeService, WtsCustomerManagementFactory, WtsUsageLogPrintFactory, savePdfService) {
    var ctrl = this;
    $scope.alerts = [];

    ctrl.$onInit = function () {
        ctrl.years = [];
        ctrl.reverse = true;
        ctrl.displayIframe = true;
        ctrl.savedAlert = null;
        ctrl.displayCustomer = false;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurementId = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? 1 : 3.78541;
        ctrl.wtsUsageLogScale = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? 1 : 1.00 / 60.00;
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        $scope.currentYear = new Date().getFullYear();
        ctrl.MONTH_NAMES = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
        ctrl.getWtsCustomers();
        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            };

            ctrl.checkScrollBar = function () {
                var _table = $scope.popup.parent().find('.tabular-data-container');
                _table.css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.getWtsCustomerLog = function () {
        var _wtsUsageLogPrint = new WtsUsageLogPrintFactory();
        if (ctrl.wtsCustomer.wtsCustomerID == -1) {
            ctrl.allCustomers = true;
        } else {
            ctrl.allCustomers = false;
        }
        _wtsUsageLogPrint.listWtsCustomerLog(ctrl.accountInfo.customerId, ctrl.wtsCustomer.wtsCustomerID, ctrl.monthSelect, ctrl.yearSelect, ctrl.accountInfo.timeZone, ctrl.allCustomers).then(function (resp) {
            ctrl.displayCustomer = true;
            ctrl._loading = false;
            ctrl.wtsLog = resp.data;
            if (ctrl.wtsLog.length > 0) {
                ctrl.wtsLog.forEach(function (item) {
                    item.totalInvoice = 0;
                    item.totalGallons = 0;
                    item.usageLogs.forEach(function (wtsItem) {
                        item.totalInvoice = item.totalInvoice + wtsItem.cost;
                        item.totalGallons = item.totalGallons + wtsItem.gallons;
                    });
                });
            }
            ctrl.todayDate = new Date().toLocaleDateString();
        });
    };
    ctrl.getWtsCustomers = function () {
        var _wtsCustomerManagement = new WtsCustomerManagementFactory();
        _wtsCustomerManagement.listWtsCustomers().then(function (resp) {
            ctrl.wtsCustomers = resp.data;
            var wtsAllCustomers = {
                wtsCustomerID: -1,
                custName: 'All Customers'
            };

            ctrl.wtsCustomers.unshift(wtsAllCustomers);
            ctrl.wtsCustomer = ctrl.wtsCustomers[0];
            ctrl.setReportDate(0);
        });
    };
    ctrl.listWtsKeysByWtsCustomerId = function (item) {
        if (!item) return;
        ctrl._loading = true;
        ctrl.readMode = true;
        ctrl.displayCustomer = false;
        ctrl.wtsLog = [];
        ctrl.displayIframe = false;
        ctrl.getWtsCustomerLog();
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                1: { columnWidth: 90 },
                2: { columnWidth: 80 },
                3: { columnWidth: 60 },
                4: { columnWidth: 60 },
                5: { columnWidth: 60 },
                6: { columnWidth: 65 },
                7: { columnWidth: 60 },
                8: { columnWidth: 60 },
                9: { columnWidth: 60 },
                10: { columnWidth: 60 },
                11: { columnWidth: 10 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        if (!ctrl.checkDateRange()) return;
        ctrl.timeFormat = timeFormat;
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        if (!ctrl.checkDateRange()) return;
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    ctrl.refreshAlerts = function () {
        $scope.alerts = [];
        if (ctrl.wtsUsageLog.length === 0) {
            var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(ctrl.wtsUsageLog.startDate).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.wtsUsageLog.endDate).format('MM/DD/YY, h:mm:ss a');
            $scope.alerts.push({
                msg: errorMessage,
                type: "info"
            });
        }
    };

    ctrl.refreshData = function () {
        if (!ctrl.checkDateRange()) return;
        ctrl.wtsUsageLog = angular.copy(ctrl.wtsUsageLog);
        ctrl.wtsUsageLog.loading = false;
    };

    ctrl.checkDateRange = function () {
        if (new Date($scope.myDateRangeEnd - $scope.myDateRangeStart) / 86400000 > ctrl.maxDateRange) {
            ctrl.wtsUsageLog = [];
            $scope.alerts = [];
            var errorMessage = ctrl.translation.text.MAXDATE + ": " + ctrl.maxDateRange + " " + ctrl.translation.text.DAYS;
            $scope.alerts.push({
                msg: errorMessage,
                type: "danger"
            });
            ctrl.wtsUsageLog.loading = false;
            return false;
        }
        return true;
    };

    ctrl.getDaysInMonth = function () {
        var d = new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0);
        return d.getDate();
    };

    ctrl.setReportDate = function (months) {
        ctrl.displayCustomer = false;
        ctrl.wtsLog = [];
        if (months == 0) ctrl.reportDate = new Date();
        var d = new Date(ctrl.reportDate || new Date());
        d.setMonth(d.getMonth() + (months || 0), d.getDate());
        ctrl.reportDate = d;
        ctrl.adjustButtons();
        ctrl.monthSelect = d.getMonth() + 1;
        ctrl.yearSelect = d.getFullYear();
        ctrl.getWtsCustomerLog();
    };

    ctrl.adjustButtons = function () {
        if (new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0).getTime() === new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime()) {
            ctrl.todaysDate = true;
            ctrl.nextDate = true;
        } else {
            ctrl.todaysDate = false;
            ctrl.nextDate = false;
        }
    };

    ctrl.printSavePdf = function () {
        ctrl.displayIframe = true;
        var _pdfTitle = eval("ctrl.translation.text." + ctrl.windowTitle.toUpperCase().replace(/ /g, "_"));
        var doc = new jsPDF('l', 'pt');
        doc.setFont("Helvetica");
        doc.setFontSize(14);
        var i = 0;
        doc.setFontType("normal");

        ctrl.wtsLog.forEach(function (item) {
            doc.text(40, 45, ctrl.accountInfo.customerName);
            doc.text(400, 45, ctrl.translation.text.USAGE_FOR + ': ' + ctrl.MONTH_NAMES[ctrl.monthSelect - 1] + ' ' + ctrl.yearSelect);
            doc.text(40, 65, ctrl.accountInfo.address1);
            doc.text(400, 65, ctrl.translation.text.PRINT_DATE + ': ' + ctrl.todayDate);
            doc.text(40, 85, ctrl.accountInfo.city + ctrl.accountInfo.state + ctrl.accountInfo.zip);
            doc.text(400, 85, ctrl.translation.text.TOTAL_GALLONS + ': ' + item.totalGallons);
            doc.text(40, 105, ' ' + (ctrl.accountInfo.phone != null ? ctrl.accountInfo.phone : ''));
            doc.text(400, 105, ctrl.translation.text.COST_PER_HUNDRED_GALLONS + ': $' + item.cphg);
            doc.setFontType("bold");
            doc.text(40, 145, item.custName);
            doc.text(400, 145, ctrl.translation.text.TOTAL + ' ' + ctrl.translation.text.INVOICE + ': $' + $filter('number')(item.totalInvoice, 2));
            doc.text(40, 165, item.custAddress);
            doc.text(40, 185, item.cityStateZip);
            doc.setFontType("normal");
            var elem = $element.find(".table.pdf");
            var requiredElement = elem[i];
            var res = doc.autoTableHtmlToJson(requiredElement);

            doc.autoTable(res.columns, res.data, {
                pdfTitle: _pdfTitle,
                startY: 195,
                tableWidth: 'auto',
                styles: {
                    overflow: 'linebreak',
                    lineColor: 0
                },
                headerStyles: {
                    cellPadding: 2,
                    lineWidth: 0,
                    valign: 'top',
                    fontStyle: 'bold',
                    halign: 'left', //'center' or 'right'
                    fillColor: [255, 255, 255],
                    textColor: [78, 53, 73] //Black  
                },
                columnStyles: {
                    0: { columnWidth: 230 },
                    1: { columnWidth: 150 },
                    2: { columnWidth: 75 },
                    3: { columnWidth: 75 },
                    4: { columnWidth: 75 },
                    5: { columnWidth: 75 }
                }
            });
            i++;
            doc.addPage();
        });

        setTimeout(function () {
            $scope.topMenuPdfProgress = false;
            $scope.$apply();
            doc.autoPrint();
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(doc.output("blob"), _pdfTitle + ".pdf");
            } else {
                // For other browsers:
                // Create a link pointing to the ObjectURL containing the blob.
                var docUrl = doc.output('bloburl');
                var printIframe = document.querySelector('#iframePrint').contentWindow;
                printIframe.document.body.innerHTML = '';
                var newObjectTag = document.createElement('object');
                newObjectTag.setAttribute('data', docUrl);
                newObjectTag.setAttribute('type', 'application/pdf');
                var newEmbedTag = document.createElement('embed');
                newEmbedTag.setAttribute('url', docUrl);
                newEmbedTag.setAttribute('type', 'application/pdf');
                newObjectTag.appendChild(newEmbedTag);
                printIframe.document.body.appendChild(newObjectTag);
                printIframe.document.close();
                // For Firefox it is necessary to delay revoking the ObjectURL
                setTimeout(function () {
                    window.URL.revokeObjectURL(doc.output("bloburl"));
                }, 100);
            }
        }, 1000);
    };
}

WtsUsageLogPrintController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'WtsUsageLogFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'getDateRangeService', 'WtsCustomerManagementFactory', 'WtsUsageLogPrintFactory', 'savePdfService'];
'use strict';

angular.module('mc.wts-usage-log-print').component('wtsUsageLogPrint', {
    controller: WtsUsageLogPrintController,
    templateUrl: 'ui/germantown/wtsusagelogprint/wts-usage-log-print-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.wts-key-management", []);
'use strict';

function WtsKeyManagementFactory(HOST, $http) {

    // instantiate our initial object
    var _wtsKeyManagement = function _wtsKeyManagement() {};

    _wtsKeyManagement.prototype.patchData = function (wtsKeyId, keyPatch) {
        var self = this;
        return $http.patch(HOST + '/api/WtsKeyManagement' + '?wtsKeyId=' + wtsKeyId, keyPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    //_wtsKeyManagement.prototype.listWtsCustomers = function () {
    //    return $http({
    //        method: 'GET',
    //        url: HOST + '/api/WtsCustomerManagement/ListWtsCustomers/',
    //    });
    //};

    _wtsKeyManagement.prototype.listWtsKeysByWtsCustomerId = function (wtsCustomerId) {
        return $http.get(HOST + "/api/WtsKeyManagement/ListWtsKeysByWtsCustomerId?wtsCustomerId=" + wtsCustomerId);
    };

    _wtsKeyManagement.prototype.insertWtsKey = function (keyInfromation, wtsCustomerId) {
        return $http.post(HOST + "/api/WtsKeyManagement/InsertWtsKey?wtsCustomerId=" + wtsCustomerId, keyInfromation);
    };

    _wtsKeyManagement.prototype.deleteWtsKey = function (wtsKeyId) {
        return $http.delete(HOST + "/api/WtsKeyManagement/DeleteWtsKey?wtsKeyId=" + wtsKeyId);
    };

    return _wtsKeyManagement;
}

WtsKeyManagementFactory.$inject = ['HOST', '$http'];

angular.module('mc.wts-key-management').factory('WtsKeyManagementFactory', WtsKeyManagementFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function WtsKeyManagementController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, WtsKeyManagementFactory, WtsCustomerManagementFactory, $uibModal, $element, datetimeService, $timeout, savePdfService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;

    ctrl.$onInit = function () {
        ctrl.readMode = true;
        ctrl.editMode = null;
        ctrl.addMode = null;
        ctrl.myModalTemplate = null;
        ctrl.wtsKeys = [];
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = false;
        ctrl.getWtsCustomers();
        ctrl.validEmail = true;
        ctrl.downloadViewTypeOptions = [0, 1, 2];

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.checkScrollBar();
            };

            ctrl.checkScrollBar = function () {
                var _table = $scope.popup.parent().find('.tabular-data-container');
                _table.css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                ctrl.scrollBar = _table.get(0).scrollHeight > _table.get(0).clientHeight;
            };
        }
    };

    ctrl.editingTo = function (name) {
        _this2._prevName = name;
    };

    ctrl.getWtsCustomers = function () {
        var _wtsCustomerManagement = new WtsCustomerManagementFactory();
        _wtsCustomerManagement.listWtsCustomers().then(function (resp) {
            //ctrl._loading = false;
            ctrl.wtsCustomers = resp.data;
        });
    };

    ctrl.listWtsKeysByWtsCustomerId = function (item) {
        if (!item) return;
        if (ctrl.wtsKeys.length > 0) {
            ctrl.cancelKey(ctrl.wtsKeys[0]);
        }
        ctrl._loading = true;
        ctrl.readMode = true;
        var _wtsKeyManagement = new WtsKeyManagementFactory();
        _wtsKeyManagement.listWtsKeysByWtsCustomerId(item.wtsCustomerID).then(function (resp) {
            ctrl._loading = false;
            ctrl.wtsKeys = resp.data;
            if (!ctrl.mobile && !ctrl.classicView) $timeout(function () {
                ctrl.checkScrollBar();
            }, 0);
        });
    };

    ctrl.patchData = function (item, propertyName) {

        if (item.wtsKeyId === -1 || item[propertyName] == _this2._prevName) return false;

        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;

        //if (item.invalidEmail) return false;
        var tmpServiceUserPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };

        ctrl.updateValue(item, propertyName);
    };

    ctrl.addNewKey = function () {
        ctrl.readMode = null;

        $element.find("div[class^='tabular-data-container']").animate({
            scrollTop: $("div").offset().top
        }, 'slow');

        if (ctrl.addMode === -1) return false;

        ctrl.editModeIndex = 0; //first record
        var newKey = {
            customerId: ctrl.accountInfo.customerId,
            wtsKeyId: -1,
            keyName: "",
            keyHex: "",
            enabled: false
        };
        ctrl.wtsKeys.unshift(newKey);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveWtsKey = function (item) {
        var _wtsKeyManagement = new WtsKeyManagementFactory();
        _wtsKeyManagement.insertWtsKey(item, ctrl.wtsCustomer.wtsCustomerID).then(function (resp) {
            ctrl._loading = false;
            ctrl.wtsKeys = resp.data;
            if (!ctrl.mobile && !ctrl.classicView) $timeout(function () {
                ctrl.checkScrollBar();
            }, 0);
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = null;
        //ctrl.listWtsKeysByWtsCustomerId(ctrl.wtsCustomer);
    };

    ctrl.cancelKey = function (destination) {
        if (destination.wtsKeyId === -1) ctrl.wtsKeys.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = null;
    };

    ctrl.setReadMode = function () {
        ctrl.readMode = true;
        ctrl.addMode = null;
        ctrl.editMode = null;
        if (ctrl.wtsKeys[0].wtsKeyId === -1) ctrl.wtsKeys.splice(0, 1);
    };

    ctrl.setEditMode = function (index) {
        ctrl.readMode = null;
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = ctrl.editModeIndex === index ? null : index;
        if (ctrl.wtsKeys[0].wtsKeyId === -1) ctrl.wtsKeys.splice(0, 1);
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            case "keyName":
                return value.length > 0;
            case "keyHex":
                return value.length == 4;
            case "enabled":
                return true;
            default:
                return false;
        }
    };

    ctrl.validateKeyHex = function (item) {
        var regex = /[0-9A-Fa-f]{4}$/g;
        if (item.keyHex === '') {
            item.hexError = true;
            item.hexMessage = _this2.translation.text.MISSING_HEX;
            return false;
        } else if (!regex.test(item.keyHex)) {
            item.hexError = true;
            item.hexMessage = _this2.translation.text.INVALID_HEX;
            return false;
        }

        item.hexError = false;
        item.hexMessage = '';
        return true;
    };

    ctrl.updateValue = function (item, propertyName) {

        var tmpWtsKeyPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _wtsKeyManagement = new WtsKeyManagementFactory();
        _wtsKeyManagement.patchData(item.wtsKeyId, tmpWtsKeyPatch).then(function (resp) {
            ctrl.resp = resp;
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                1: { columnWidth: 90 },
                2: { columnWidth: 80 },
                3: { columnWidth: 60 },
                4: { columnWidth: 60 },
                5: { columnWidth: 60 },
                6: { columnWidth: 65 },
                7: { columnWidth: 60 },
                8: { columnWidth: 60 },
                9: { columnWidth: 60 },
                10: { columnWidth: 60 },
                11: { columnWidth: 10 }
            }
        };
        savePdfService.savePDF(pdfParams);
    };

    ctrl.searchFieldChanged = function (varInput) {
        if (!ctrl.mobile && !ctrl.classicView) $timeout(function () {
            ctrl.checkScrollBar();
        }, 0);
    };

    //ctrl.checkScrollBar = () => {
    //    var _table = $scope.popup.parent().find('.tabular-data-container');
    //    _table.css("height",
    //        $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") -
    //        $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") -
    //        $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") -
    //        $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") -
    //        15); //25: total padding
    //    ctrl.scrollBar = _table.get(0).scrollHeight > _table.get(0).clientHeight;
    //}

    ctrl.onKeyUpValidate = function (idx) {

        var regExpn = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;

        if (ctrl.logins[idx].email.length === 0) {
            ctrl.logins[idx].invalidEmail = false;
        } else if (regExpn.test(String(ctrl.logins[idx].email).toLowerCase())) {

            ctrl.logins[idx].invalidEmail = false;
        } else {

            ctrl.logins[idx].invalidEmail = true;
        }
    };
    ctrl.openCommonModal = function (item, deleteUser) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            if (deleteUser) {
                this.tmpConfirmMessageA = this.translation.text.DELETE_ACCOUNT_MESSAGE_A + item.keyName + this.translation.text.DELETE_ACCOUNT_MESSAGE_B;
            } else {
                this.tmpConfirmMessageA = this.translation.text.READONLY_ACCOUNT_MESSAGE_A + item.fullName + this.translation.text.READONLY_ACCOUNT_MESSAGE_B;
            }
            this.tmpConfirmMessageB = this.translation.text.DELETE_ACCOUNT_MESSAGE_C;
            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                if (!deleteUser) {
                    var index = ctrl.logins.findIndex(function (l) {
                        return l.userId == item.userId;
                    });
                    ctrl.logins[index].administrator = true;
                }

                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            if (deleteUser) {
                var _wtsKeyManagement = new WtsKeyManagementFactory();
                _wtsKeyManagement.deleteWtsKey(item.wtsKeyId).then(function (resp) {
                    var index = ctrl.wtsKeys.indexOf(item);
                    if (index !== -1) {
                        ctrl.wtsKeys.splice(index, 1);
                    }
                    ctrl.addMode = null;
                    ctrl.editMode = null;
                });
            } else {

                var propertyName = 'administrator';
                ctrl.updateValue(item, propertyName);
            }
        }, function () {
            // cancel button
        });
    };
}

WtsKeyManagementController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'WtsKeyManagementFactory', 'WtsCustomerManagementFactory', '$uibModal', '$element', 'datetimeService', '$timeout', 'savePdfService'];
'use strict';

angular.module('mc.wts-key-management').component('wtsKeyManagement', {
    controller: WtsKeyManagementController,
    templateUrl: 'ui/germantown/wtskeymanagement/wts-key-management-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.wts-customer-management", []);
'use strict';

function WtsCustomerManagementFactory(HOST, $http) {

    // instantiate our initial object
    var _wtsCustomerManagement = function _wtsCustomerManagement() {};

    _wtsCustomerManagement.prototype.patchData = function (wtsCustomerId, customerPatch) {
        var self = this;
        return $http.patch(HOST + '/api/Germantown/WtsCustomerManagement' + '?wtsCustomerId=' + wtsCustomerId, customerPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    _wtsCustomerManagement.prototype.listWtsCustomers = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/Germantown/WtsCustomerManagement/ListWtsCustomers/'
        });
    };

    _wtsCustomerManagement.prototype.insertWtsCustomer = function (customerInfromation) {
        return $http.post(HOST + "/api/Germantown/WtsCustomerManagement/InsertWtsCustomer", customerInfromation);
    };

    _wtsCustomerManagement.prototype.deleteWtsCustomer = function (wtsCustomerId) {
        return $http.delete(HOST + "/api/Germantown/WtsCustomerManagement/DeleteWtsCustomer?wtsCustomerId=" + wtsCustomerId);
    };

    return _wtsCustomerManagement;
}

WtsCustomerManagementFactory.$inject = ['HOST', '$http'];

angular.module('mc.wts-customer-management').factory('WtsCustomerManagementFactory', WtsCustomerManagementFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function WtsCustomerManagementController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, WtsCustomerManagementFactory, LoginsFactory, $uibModal, $element, $timeout, datetimeService, savePdfService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;

    ctrl.$onInit = function () {
        ctrl.readMode = true;
        ctrl.editMode = null;
        ctrl.addMode = null;
        ctrl.myModalTemplate = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = true;
        ctrl.getWtsCustomers();
        ctrl.validEmail = true;
        $scope.downloadViewTypeOptions = [0, 1, 2];

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.checkScrollBar();
            };

            ctrl.checkScrollBar = function () {
                var _table = $scope.popup.parent().find('.tabular-data-container');
                _table.css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                ctrl.scrollBar = _table.get(0).scrollHeight > _table.get(0).clientHeight;
            };

            ctrl.sun = ctrl.translation.text.SUNDAY;
            ctrl.mon = ctrl.translation.text.MONDAY;
            ctrl.tue = ctrl.translation.text.TUESDAY;
            ctrl.wed = ctrl.translation.text.WEDNESDAY;
            ctrl.thu = ctrl.translation.text.THURSDAY;
            ctrl.fri = ctrl.translation.text.FRIDAY;
            ctrl.sat = ctrl.translation.text.SATURDAY;
        } else {
            ctrl.sun = ctrl.translation.text.SUN;
            ctrl.mon = ctrl.translation.text.MON;
            ctrl.tue = ctrl.translation.text.TUE;
            ctrl.wed = ctrl.translation.text.WED;
            ctrl.thu = ctrl.translation.text.THU;
            ctrl.fri = ctrl.translation.text.FRI;
            ctrl.sat = ctrl.translation.text.SAT;
        }
    };

    ctrl.editingTo = function (name) {
        _this2._prevName = name;
    };

    ctrl.hasOverflow = function () {
        var element = document.getElementById('useraccount-rows');
        if (element.offsetHeight < element.scrollHeight) {
            return true;
        }
        return false;
    };

    ctrl.getWtsCustomers = function () {
        var _wtsCustomerManagement = new WtsCustomerManagementFactory();
        _wtsCustomerManagement.listWtsCustomers().then(function (resp) {
            ctrl._loading = false;
            ctrl.wtsCustomers = resp.data;
            if (!ctrl.mobile && !ctrl.classicView) $timeout(function () {
                ctrl.checkScrollBar();
            }, 0);
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                1: { columnWidth: 90 },
                2: { columnWidth: 80 },
                3: { columnWidth: 60 },
                4: { columnWidth: 60 },
                5: { columnWidth: 60 },
                6: { columnWidth: 65 },
                7: { columnWidth: 60 },
                8: { columnWidth: 60 },
                9: { columnWidth: 60 },
                10: { columnWidth: 60 },
                11: { columnWidth: 10 }
            }
        };
        savePdfService.savePDF(pdfParams);
    };

    ctrl.patchData = function (item, propertyName) {

        if (item.wtsCustomerID === -1 || item[propertyName] == _this2._prevName) return false;

        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;

        var tmpServiceUserPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };

        ctrl.updateValue(item, propertyName);
    };

    ctrl.addNewCustomer = function () {
        ctrl.readMode = null;

        $element.find("div[class^='tabular-data-container']").animate({
            scrollTop: 0
        }, 'slow');

        if (ctrl.addMode === -1) return false;

        ctrl.editModeIndex = 0; //first record
        var newCustomer = {
            wtsCustomerID: -1,
            custName: "",
            custAddress: "",
            cphg: 0,
            cityStateZip: "",
            schedSun: "0000-0000",
            schedMon: "0000-0000",
            schedTue: "0000-0000",
            schedWed: "0000-0000",
            schedThu: "0000-0000",
            schedFri: "0000-0000",
            schedSat: "0000-0000",
            isDeleted: false
        };
        ctrl.wtsCustomers.unshift(newCustomer);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveCustomerAccount = function (item) {
        var _wtsCustomerManagement = new WtsCustomerManagementFactory();
        _wtsCustomerManagement.insertWtsCustomer(item).then(function (resp) {

            ctrl._loading = false;
            ctrl.wtsCustomers = resp.data;
            if (!ctrl.mobile && !ctrl.classicView) $timeout(function () {
                ctrl.checkScrollBar();
            }, 0);
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = null;
        //ctrl.getWtsCustomers();
    };

    ctrl.cancelCustomer = function (destination) {
        if (destination.wtsCustomerID === -1) ctrl.wtsCustomers.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = null;
    };

    ctrl.setReadMode = function () {
        ctrl.readMode = true;
        ctrl.addMode = null;
        ctrl.editMode = null;
        if (ctrl.wtsCustomers[0].wtsCustomerID === -1) ctrl.wtsCustomers.splice(0, 1);
    };

    ctrl.setEditMode = function (index) {
        ctrl.readMode = null;
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = ctrl.editModeIndex === index ? null : index;
        if (ctrl.wtsCustomers[0].wtsCustomerID === -1) ctrl.wtsCustomers.splice(0, 1);
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            case "cphg":
                return value > 0;
            case "custName":
                return value.length > 0;
            case "custAddress":
            case "cityStateZip":
            case "schedSun":
            case "schedMon":
            case "schedTue":
            case "schedWed":
            case "schedThu":
            case "schedFri":
            case "schedSat":
                return true;
            default:
                return false;
        }
    };

    ctrl.updateValue = function (item, propertyName) {

        var tmpServiceCustomerPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _wtsCustomerManagement = new WtsCustomerManagementFactory();
        _wtsCustomerManagement.patchData(item.wtsCustomerID, tmpServiceCustomerPatch).then(function (resp) {
            ctrl.resp = resp;
        });
    };

    ctrl.onKeyUpValidate = function (idx) {

        var regExpn = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;

        if (ctrl.logins[idx].email.length === 0) {
            ctrl.logins[idx].invalidEmail = false;
        } else if (regExpn.test(String(ctrl.logins[idx].email).toLowerCase())) {

            ctrl.logins[idx].invalidEmail = false;
        } else {

            ctrl.logins[idx].invalidEmail = true;
        }
    };
    ctrl.openCommonModal = function (item, deleteUser) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            if (deleteUser) {
                this.tmpConfirmMessageA = this.translation.text.DELETE_ACCOUNT_MESSAGE_A + item.custName + this.translation.text.DELETE_ACCOUNT_MESSAGE_B;
            } else {
                this.tmpConfirmMessageA = this.translation.text.READONLY_ACCOUNT_MESSAGE_A + item.fullName + this.translation.text.READONLY_ACCOUNT_MESSAGE_B;
            }
            this.tmpConfirmMessageB = this.translation.text.DELETE_ACCOUNT_MESSAGE_C;
            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                if (!deleteUser) {
                    var index = ctrl.logins.findIndex(function (l) {
                        return l.userId == item.userId;
                    });
                    ctrl.logins[index].administrator = true;
                }

                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            if (deleteUser) {
                var _wtsCustomerManagement = new WtsCustomerManagementFactory();
                _wtsCustomerManagement.deleteWtsCustomer(item.wtsCustomerID).then(function (resp) {
                    var index = ctrl.wtsCustomers.indexOf(item);
                    if (index !== -1) {
                        ctrl.wtsCustomers.splice(index, 1);
                    }
                    ctrl.addMode = null;
                    ctrl.editMode = null;
                });
            }
            //not used for WTS customers management feature
            else {

                    var propertyName = 'administrator';
                    ctrl.updateValue(item, propertyName);
                }
        }, function () {
            // cancel button
        });
    };
}

WtsCustomerManagementController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'WtsCustomerManagementFactory', 'LoginsFactory', '$uibModal', '$element', '$timeout', 'datetimeService', 'savePdfService'];
'use strict';

angular.module('mc.wts-customer-management').component('wtsCustomerManagement', {
    controller: WtsCustomerManagementController,
    templateUrl: 'ui/germantown/wtscustomermanagement/wts-customer-management-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.humidity-table", []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HumidityTableFactory(HOST, $http, $q, $timeout, datetimeService, translationService, sharedSetupService) {
    var HumidityTable = function () {
        function HumidityTable(customerId, deviceId, deviceSelectedName, timeZone) {
            _classCallCheck(this, HumidityTable);

            this._deviceName = deviceSelectedName;
            this._table = [];
            this._loading = false;
            this._customerId = customerId;
            this._timeZone = timeZone;
            this._flowUnitText = translationService.translation.text.PUMP_GALLONS;
            this._deviceId = deviceId;
            this._liveData = false;
            this._startRow = 1;
            this._pageSize = 50;
            this._numberOfReturnedRecords = -1;
            this._numberOfNewRecordsPrevious = -1;
            this._start = '19000101';
            this._end = '19000101';
        }

        _createClass(HumidityTable, [{
            key: 'formatRuntime',
            value: function formatRuntime(runtime) {
                var formatted = '';

                var intRuntime = parseInt(runtime);
                if (runtime < 100) {
                    formatted = (' ' + intRuntime).substr(intRuntime.toString().length - 1) + ':';
                } else if (runtime < 1000) {
                    formatted = ('' + intRuntime).substr(intRuntime.toString().length - 3) + ':';
                }

                var temp = '0' + parseInt(60 * (runtime - parseInt(runtime)) + 0.5);
                formatted += temp.substring(temp.length - 2);

                return formatted;
            }
        }, {
            key: 'getStartLevel',
            value: function getStartLevel(row, convertToUnit) {
                var startLevel = null;
                if (row.startLevel > row.endLevel) {
                    startLevel = row.startLevel.toFixed(2);
                } else {
                    startLevel = row.endLevel.toFixed(2);
                }
                if (convertToUnit === 2) {
                    return Math.abs(startLevel * 0.3048).toFixed(2);
                } else {
                    return startLevel;
                }
            }
        }, {
            key: 'getEndLevel',
            value: function getEndLevel(row, convertToUnit) {
                var endLevel = null;
                if (row.startLevel > row.endLevel) {
                    endLevel = row.endLevel.toFixed(2);
                } else {
                    endLevel = row.startLevel.toFixed(2);
                }
                if (convertToUnit === 2) {
                    return Math.abs(endLevel * 0.3048).toFixed(2);
                } else {
                    return endLevel;
                }
            }
        }, {
            key: 'getCalculatedFlow',
            value: function getCalculatedFlow(row, convertToUnit) {
                if (convertToUnit === 1) {
                    this._flowUnitText = translationService.translation.text.PUMP_GALLONS;
                    return Math.abs(row.flow).toFixed(0);
                } else if (convertToUnit === 2) {
                    this._flowUnitText = translationService.translation.text.PUMP_LITERS;
                    return Math.abs(3.78541178 * row.flow).toFixed(2);
                }

                return row.flow;
            }
        }, {
            key: 'getCalculatedPumpRate',
            value: function getCalculatedPumpRate(row, convertToUnit) {
                if (convertToUnit === 1) {
                    return Math.abs(row.pumpRate).toFixed(0);
                } else if (convertToUnit === 2) {
                    return (0.06 * Math.abs(3.78541178 * row.pumpRate)).toFixed(2);
                }

                return row.pumpFlow;
            }
        }, {
            key: 'getInFlow',
            value: function getInFlow(row, convertToUnit) {
                var decimals = -1;
                if (row.inFlow > 1000) {
                    decimals = 0;
                } else {
                    if (row.inFlow > 10) {
                        decimals = 1;
                    } else {
                        decimals = 2;
                    }
                }

                if (convertToUnit === 1) {
                    return Math.abs(row.inFlow).toFixed(decimals);
                } else if (convertToUnit === 2) {
                    return (0.06 * Math.abs(3.78541178 * row.inFlow)).toFixed(decimals);
                }

                return row.inFlow;
            }
        }, {
            key: 'fetchData',
            value: function fetchData(type, startDate, endDate) {
                var _this = this;

                this._loading = true;

                return $http.get(HOST + '/api/HumidityData?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&startDate=' + startDate + '&endDate=' + endDate + '&scrollDirection=' + type + '&timeZone=' + this._timeZone).then(function (resp) {
                    _this._loading = false;

                    var items = resp.data.measurements;

                    if (type === 0) {
                        _this._table = _this._table.concat(resp.data.measurements);
                    } else if (type === 1) {
                        _this._numberOfNewRecordsPrevious = resp.data.measurements.length;
                        _this._table = resp.data.measurements.reverse().concat(_this._table);
                    }

                    if (_this._table.length > 0) {
                        // if there are records returned
                        _this._end = datetimeService.toUnixtimeMs(_this._table[_this._table.length - 1].localDateTime.replace(/\D/g, ''));
                    }

                    return resp;
                });
            }
        }, {
            key: 'nextPage',
            value: function nextPage() {
                var _this2 = this;

                if (this._loading) {
                    return $q(function (resolve, reject) {
                        resolve({ data: { data: _this2._table } });
                    });
                }

                if (this._table.length > 0) {
                    var newEnd = datetimeService.toUnixtimeMs(this._table[this._table.length - 1].localDateTime.replace(/\D/g, ''));
                    var newStart = newEnd - 86400000 * 6;
                    return this.fetchData(0, newStart, newEnd);
                } else {

                    //TODO: will come back to reconsider sharedSetupService.regenerateDates()
                    if (this._end === 0) {
                        var tmpDates = sharedSetupService.getLiveDates();
                        this._end = tmpDates.endDate;

                        var _newStart2 = this._end - 86400000 * 6;
                        this.start = _newStart2;
                        return this.fetchData(0, _newStart2, this._end);
                    }

                    var _newStart = this._end - 86400000 * 6;
                    this.start = _newStart;
                    return this.fetchData(0, _newStart, this._end);
                }
            }
        }, {
            key: 'previousPage',
            value: function previousPage() {

                var newStart = datetimeService.toUnixtimeMs(this._table[0].localDateTime.replace(/\D/g, ''));
                var newEnd = newStart + 86400000 * 3;
                return this.fetchData(1, newStart, newEnd);
            }
        }, {
            key: 'reset',
            value: function reset(deviceId, deviceSelectedName) {

                if (deviceId) {
                    this._deviceId = deviceId;
                }

                if (deviceSelectedName) {
                    this._deviceName = deviceSelectedName;
                }

                this._numberOfNewRecordsPrevious = -1;
                this._table.length = 0;
                this._start = '19000101';
                this._end = '19000101';
            }
        }, {
            key: 'deviceName',
            get: function get() {
                return this._deviceName;
            }
        }, {
            key: 'table',
            get: function get() {
                return this._table;
            }
        }, {
            key: 'previousRecords',
            get: function get() {
                return this._numberOfNewRecordsPrevious;
            },
            set: function set(num) {
                this._numberOfNewRecordsPrevious = num;
            }
        }, {
            key: 'loading',
            get: function get() {
                return this._loading;
            }
        }, {
            key: 'deviceId',
            set: function set(deviceId) {
                this._deviceId = deviceId;
            }
        }, {
            key: 'start',
            set: function set(startDate) {
                this._start = startDate;
            },
            get: function get() {
                return this._start;
            }
        }, {
            key: 'end',
            set: function set(endDate) {
                this._end = endDate;
            },
            get: function get() {
                return this._end;
            }
        }, {
            key: 'liveData',
            set: function set(liveData) {
                this._liveData = liveData;
            }
        }]);

        return HumidityTable;
    }();

    return HumidityTable;
}

HumidityTableFactory.$inject = ['HOST', '$http', '$q', '$timeout', 'datetimeService', 'translationService', 'sharedSetupService'];

angular.module('mc.humidity-table').factory('HumidityTableFactory', HumidityTableFactory);
'use strict';

function HumidityTableController(_, $, $scope, $filter, $timeout, $element, authenticationService, translationService, datetimeService, sharedSetupService, openViewService, timeLapseService, websocketService, HumidityTableFactory, toaster) {
    var _this2 = this;

    var LIVEDATAISOFFFORNOW = true;

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    this.setDevice = function (selectedDevice) {
        $scope.deviceSelected = selectedDevice.deviceId;
        $scope.deviceSelectedSn = selectedDevice.serialNumber;
        $scope.deviceSelectedType = selectedDevice.type;
        $scope.deviceSelectedName = selectedDevice.name;
        $scope.currentSelectedDevice = selectedDevice;
    };

    var wsDataReceivedHUMIDITY = function wsDataReceivedHUMIDITY(data) {
        if (data && data.ComputeTime) {
            var varTime = datetimeService.socketStrToServerStrTime(data.ComputeTime);
            var newRecord = { computeTime: varTime, pump: parseInt(data.Pump), runtime: parseFloat(data.Runtime), startLevel: parseFloat(data.StartLevel), endLevel: parseFloat(data.EndLevel), flow: parseFloat(data.Gallons), pumpRate: parseFloat(data.PumpGPM), inFlow: parseFloat(data.AvgFlow) };

            _this2.humidityTable._table.unshift(newRecord);
        }
    };

    var wsReconnectHUMIDITY = function wsReconnectHUMIDITY(data) {
        console.log(data);
    };

    this._registerListener = function (deviceSn) {
        if (_this2.liveData === true) {
            return;
        }

        _this2.liveData = true;
        if (_this2.humidityTable) {
            _this2.humidityTable.liveData = _this2.liveData;
        }

        _this2.liveDataLine(_this2.liveData);
        _this2.humidityTable.previousRecords = -1;
        websocketService.connect();

        websocketService.register('HUMIDITY', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedHUMIDITY, wsReconnectHUMIDITY);
    };

    this._unRegisterListener = function (deviceSn) {
        if (_this2.liveData === false) {
            return;
        }

        _this2.liveData = false;
        if (_this2.humidityTable) {
            _this2.humidityTable.liveData = _this2.liveData;
        }

        _this2.liveDataLine(_this2.liveData);

        websocketService.unRegister('HUMIDITY', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedHUMIDITY, wsReconnectHUMIDITY);
    };

    this._checkTopOffset = function (liveDataStatusOn) {
        if (liveDataStatusOn) {
            _this2._registerListener();
        } else {
            _this2._unRegisterListener();
        }
    };

    this._setLiveDataStatus = function (firstRow, liveDataStatusOn) {
        if (_this2.checkFirstRowLiveStatus === true) {
            _this2._checkTopOffset(liveDataStatusOn);
        } else if (_this2.checkFirstRowLiveStatus === null) {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                if (parseFloat(firstRow) + parseFloat(_this2.liveDataOffset) >= parseFloat(result.unixTimeStamp)) {
                    _this2.checkFirstRowLiveStatus = true;
                    _this2._checkTopOffset(liveDataStatusOn);
                } else {
                    _this2.checkFirstRowLiveStatus = false;
                }
            });
        }
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        _this2.myDate = null;
        _this2.infiniteScrollOn = false;
        _this2.infiniteScrollUpOn = false;
        _this2.infiniteScrollDownOn = false;
        _this2.checkFirstRowLiveStatus = null;
        _this2.liveTable = $element.find('.headertable');
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.measurement = _this2.accountInfo.preferenceUser.lookupMeasurementID;
        _this2.preferredTimeFormat = _this2.accountInfo.preferenceUser.timeFormat;
        _this2.unixDay = sharedSetupService.unixDay;
        _this2.liveDataOffset = sharedSetupService.liveDataOffset;
        _this2.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
        _this2.translation = translationService.translation;
        _this2.alerts = [];
        _this2.currentScrollbarPosition = 0;
        _this2.previousScrollbarPosition = 0;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
        _this2.checkFirstRowLiveStatus = null;
        _this2.paddingZoom = _this2.paddingZoom === 0 ? _this2.unixDay / 2 : _this2.paddingZoom;
        $scope.alerts = [];
        $scope.windowTitle = _this2.translation.text.HUMIDITY_TABLE;
        _this2.windowId = _this2.windowId || _this2.translation.text.HUMIDITY_TABLE;
        $scope.windowId = JSON.parse(JSON.stringify(_this2.windowId));
        _this2.paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
        _this2.paddingZoom = _this2.paddingZoom === 0 ? _this2.unixDay / 2 : _this2.paddingZoom;

        if (!_this2.mobile && !_this2.classicView) {
            _this2._popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize(_this2._popup);

            var adjustSize = function adjustSize() {
                _this2._popup.parent().find('div:eq(2)').css('width', _this2._popup.parent().css('width'));
                _this2._popup.parent().find('div:eq(2)').css('min-width', _this2._popup.parent().css('width').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('div:eq(2)').css('height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('div:eq(2)').css('min-height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, ""));
                _this2._popup.parent().find('.tabular-data-container').css('height', _this2._popup.parent().css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('div:eq(0)').css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('.headertable').css('height').replace(/[^0-9.]+/g, "") - _this2._popup.parent().find('.top-menu').css('height').replace(/[^0-9.]+/g, "") - 15);
            };

            _this2._popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            _this2._popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(_this2._popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(_this2._popup);
                    adjustSize();
                }
            });

            $scope.$on('ngRepeatFinished', function () {
                adjustSize();
            });

            $scope.$on('updatePreferencesLanguage', function () {
                adjustSize();

                if ($scope.alerts.length > 0) {
                    var msg = _this2.translation.message[$scope.alerts[0].languageCode.toUpperCase()];
                    var type = $scope.alerts[0].type;
                    var languageCode = $scope.alerts[0].languageCode;
                    if (languageCode.toUpperCase() === 'NO_DATA') {
                        msg += ': ' + moment(_this2.humidityTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.humidityTable.end).utc().format('MM/DD/YY, h:mm:ss a');
                    }
                    $scope.alerts = [];
                    _this2.alerts = [];
                    $scope.alerts.push({ msg: msg, type: type, languageCode: languageCode });
                    _this2.alerts.push({ msg: msg, type: type, languageCode: languageCode });
                }
            });
        }

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            _this2.preferredTimeFormat = parseInt(timeFormat, 10);
        });

        $scope.$on('updatePreferencesMeasurement', function (event, measurement) {
            _this2.measurement = measurement;
        });

        $scope.$on('ngRepeatFinished', function () {
            _this2._autoScroll();
            _this2.checkFirstRowLiveStatus = null;
        });

        _this2._autoScroll = function () {
            if (_this2.humidityTable.previousRecords > 0) {
                var trRow = _this2.table.find('tr').eq(_this2.humidityTable.previousRecords - 1);
                var yPosition = typeof trRow.position() !== 'undefined' ? trRow.position().top - 90 : 2;
                _this2.table.scrollTop(yPosition);
            } else {
                var _this = _this2;
                $timeout(function () {
                    _this.table.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        // dateAgentText filter called from html
        _this2.dateAgentText = function (date, timeFormat) {
            return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
        };

        $timeout(function () {
            _this2.table = $('#humidity-table-' + _this2.replaceSpaces(_this2.windowId || _this2.translation.text.HUMIDITY_TABLE));
            // Handle infinite scrolling
            _this2.table.on('scroll', function (event) {
                var $rowFirst = _this2.table.contents().find('tr:first');
                var $rowLast = _this2.table.contents().find('tr:last');
                var _firstRow = $rowFirst.attr('name');
                if (typeof $rowFirst.position() !== 'undefined') {
                    _this2.infiniteScrollOn = true;
                    _this2.infiniteScrollUpOn = true;
                    _this2.infiniteScrollDownOn = true;

                    var _tableTop = element.offset().top;
                    var _rowTop = $rowFirst.offset().top;
                    _this2._setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);

                    _this2.previousScrollbarPosition = _this2.currentScrollbarPosition;
                    _this2.currentScrollbarPosition = _this2.table[0].scrollTop;
                }

                if (_this2.infiniteScrollOn === true) {
                    _this2.infiniteScrollUpOn = true;
                    _this2.infiniteScrollDownOn = true;

                    if (_this2.currentScrollbarPosition <= 35 && _this2.previousScrollbarPosition > 35) {
                        _this2.checkFirstRowLiveStatus = null;
                    }

                    if (_this2.infiniteScrollDownOn === true && _this2.table[0].scrollTop + _this2.table[0].offsetHeight + 5 > _this2.table[0].scrollHeight && _this2.table[0].scrollTop > 0) {
                        $rowLast.addClass('active-row');
                        _this2.alerts = [];
                        $scope.alerts = [];
                        _this2.humidityTable.nextPage().then(function (resp) {
                            if (resp.data.measurements && resp.data.measurements.length === 0 && _this2.humidityTable.table.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.humidityTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.humidityTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                                $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            }
                        });
                    }
                    if (_this2.infiniteScrollUpOn === true && _this2.table[0].scrollTop < 5 && _this2.currentScrollbarPosition < _this2.previousScrollbarPosition) {
                        $rowFirst.addClass('active-row');
                        _this2.alerts = [];
                        $scope.alerts = [];
                        $timeout(function () {
                            // Give it time to set the live data status
                            _this2.humidityTable.previousPage().then(function (resp) {
                                if (resp.data.measurements && resp.data.measurements.length === 0 && _this2.humidityTable.table.length === 0) {
                                    $scope.alerts.length = 0;
                                    _this2.alerts.length = 0;

                                    var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.humidityTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.humidityTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                                    $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                    _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                }
                            });
                        });
                    }
                }

                var rows = _this2.table.children().children().children().children();
                var scrollpos = 40;
                var start = 0;
                var end = rows.length;
                var count = 0;

                while (start !== end) {
                    count++;
                    var mid = start + Math.floor((end - start) / 2);
                    if ($(rows[mid]).position().top < scrollpos) {
                        start = mid + 1;
                    } else {
                        end = mid;
                    }
                }
                _this2._updateZoom(parseFloat($($(rows[start])).attr('name')));
            });
        });

        // Toggle the active row when user clicks
        _this2.toggle = function ($event) {
            if ($($event.currentTarget).hasClass('active-row')) {
                $($event.currentTarget).removeClass('active-row');
            } else {
                $($event.currentTarget).addClass('active-row');
            }
        };

        $scope.$watch(function () {
            return $scope.deviceSelectedSn;
        }, function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                if (oldVal) {
                    // this._unRegisterListener(oldVal);
                }
            }
        }, true);

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal) {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newVal, windowId: _this2.windowId });
                if (_this2.humidityTable) {
                    _this2.humidityTable.reset(newVal, $scope.deviceSelectedName);
                } else {
                    _this2.humidityTable = new HumidityTableFactory(_this2.accountInfo.customerId, newVal, $scope.deviceSelectedName, _this2.accountInfo.timeZone);
                }

                _this2.currentScrollbarPosition = 0;
                _this2.previousScrollbarPosition = 0;
                _this2.checkFirstRowLiveStatus = null;
                $scope.alerts = [];
                _this2.alerts = [];

                if ($scope.stickyProperties.savedDesktop === true && $scope.stickyProperties.on === true) {
                    _this2.savedDesktopRow = $scope.stickyProperties.zoomMax;
                    $scope.stickyProperties.on = true;
                    $scope.stickyProperties.savedDesktop = false;
                    _this2.humidityTable.start = $scope.stickyProperties.dateMin;
                    _this2.humidityTable.end = $scope.stickyProperties.dateMax;
                    _this2.humidityTable.nextPage().then(function (resp) {
                        if (resp.data.measurements && resp.data.measurements.length === 0 && _this2.humidityTable.table.length === 0) {
                            $scope.alerts.length = 0;
                            _this2.alerts.length = 0;

                            var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.humidityTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.humidityTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                            $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                        }
                    });
                } else if ($scope.stickyProperties.on !== null && $scope.stickyProperties.dateMin !== null) {
                    // doesn't work well - need to check
                    $scope.stickyProperties.on = true;
                    _this2.humidityTable.start = $scope.stickyProperties.dateMin - 3 * _this2.unixDay;
                    timeLapseService.getLocalDateTime().then(function (resp) {
                        var result = resp.data;

                        if ($scope.stickyProperties.dateMax >= parseFloat(result.unixTimeStamp) && $scope.stickyProperties.zoomMax + parseFloat(_this2.liveDataOffset) >= parseFloat(result.unixTimeStamp)) {
                            _this2.humidityTable.end = $scope.stickyProperties.dateMax;
                        } else {
                            _this2.humidityTable.end = Math.round(($scope.stickyProperties.zoomMax + $scope.stickyProperties.zoomMin) / 2);
                        }

                        _this2.humidityTable.nextPage().then(function (resp) {
                            if (resp.data.measurements && resp.data.measurements.length === 0 && _this2.humidityTable.table.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.humidityTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.humidityTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                                $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            }
                        });
                    });
                } else {
                    $scope.stickyProperties.on = false;
                    timeLapseService.getLocalDateTime().then(function (resp) {
                        var result = resp.data;

                        var newDate = new Date(result.localDateTime);
                        newDate.setHours(0, 0, 0, 0);
                        var endDate = new Date(newDate.getTime() + 3 * 86400000);
                        _this2.humidityTable.end = datetimeService.dateToUnixtime(endDate);
                        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: datetimeService.dateToUnixtime(endDate), windowId: _this2.windowId });
                        _this2.humidityTable.nextPage().then(function (resp) {
                            if (resp.data.measurements && resp.data.measurements.length === 0 && _this2.humidityTable.table.length === 0) {
                                $scope.alerts.length = 0;
                                _this2.alerts.length = 0;

                                var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.humidityTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.humidityTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                                $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                                _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                            }
                        });
                    });
                }
            }
        }, true);

        $scope.mostRecentData = function () {
            _this2.myDate = null;
            toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
            $scope.fetchDataForSelectedDate(new Date());
        };

        $scope.fetchDataForSelectedDate = function (newVal) {
            _this2.humidityTable.reset();
            _this2.currentScrollbarPosition = 0;
            _this2.previousScrollbarPosition = 0;
            _this2.checkFirstRowLiveStatus = null;
            _this2._unRegisterListener();

            var tmpDates = newVal;
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            if (_this2.selectedGrouping === '4') {
                tmpDatesA.setHours(23, 59, 59, 999);
            } else {
                tmpDatesA.setHours(12, 0, 0, 0);
            }
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);

            _this2.humidityTable.start = tmpDates.startDate;
            if (new Date(newVal).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                _this2.humidityTable.end = tmpDatesA;
            } else {
                _this2.humidityTable.end = tmpDates.endDate;
            }

            $scope.alerts = [];
            _this2.alerts = [];
            _this2.humidityTable.nextPage().then(function (resp) {
                if (resp.data.measurements && resp.data.measurements.length === 0 && _this2.humidityTable.table.length === 0) {
                    $scope.alerts.length = 0;
                    _this2.alerts.length = 0;

                    var msg = _this2.translation.message.NO_DATA + ': ' + moment(_this2.humidityTable.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.humidityTable.end).utc().format('MM/DD/YY, h:mm:ss a');

                    $scope.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                    _this2.alerts.push({ msg: msg, type: 'info', languageCode: 'NO_DATA' });
                }
            });
            sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + _this2.unixDay, zoomMax: tmpDates.endDate - _this2.unixDay, windowId: _this2.windowId });
        };

        $scope.$watch(function () {
            return _this2.myDate;
        }, function (newVal, oldVal) {
            if (newVal) {
                $scope.fetchDataForSelectedDate(newVal);
            }
        });
    };

    this.liveDataLine = function (varLiveData) {
        if (LIVEDATAISOFFFORNOW) return;
        if (varLiveData) {
            _this2.liveTable.addClass('live-data-line');
        } else {
            _this2.liveTable.removeClass('live-data-line');
        }
    };

    this._updateZoom = function (currentRow) {
        if (isNaN(currentRow)) {
            return;
        }

        var zoomMin = currentRow - _this2.paddingZoom;
        var zoomMax = currentRow + _this2.paddingZoom;

        var dateMin = $scope.stickyProperties.dateMin;
        var dateMax = $scope.stickyProperties.dateMax;

        if (zoomMin < $scope.stickyProperties.dateMin) {
            dateMin = zoomMin;
        }
        if (zoomMax > $scope.stickyProperties.dateMax) {
            dateMax = zoomMax;
        }

        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: _this2.windowId });
    };
}

HumidityTableController.$inject = ['_', '$', '$scope', '$filter', '$timeout', '$element', 'authenticationService', 'translationService', 'datetimeService', 'sharedSetupService', 'openViewService', 'timeLapseService', 'websocketService', 'HumidityTableFactory', 'toaster'];
'use strict';

angular.module('mc.humidity-table').component('humidityTable', {
    controller: HumidityTableController,
    templateUrl: 'ui/humidity/table/humidity-table-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.splash-screen", []);
'use strict';

function SplashScreenController(translationService) {

    var ctrl = this;
    var previousValueToWatch;

    ctrl.$onInit = function () {
        //optional logic
        ctrl.translation = translationService.translation;
        ctrl.lipClass = ctrl.positionClass ? ctrl.positionClass : 'imgtxtlod';
        ctrl.lipText = ctrl.lipTextShow == 'false' ? false : true;
    };

    //$onChanges will not fire just because a bindable object changes.
    //If you need to know every time the object changes, you will have
    //to pass in a new /copied version of the object, or use $doCheck.

    //ctrl.$onChanges = (changes) => {
    //    //optional logic
    //    if (changes.alerts && changes.alerts.currentValue !== changes.alerts.previousValue) {
    //        if (ctrl.alerts.length > 0) {
    //            ctrl.hasAlerts();
    //        }
    //        else {
    //            ctrl.noAlerts();
    //        }
    //    }
    //}

    ctrl.$doCheck = function () {
        if (!angular.equals(ctrl.valueToWatch, previousValueToWatch)) {
            ctrl.handleValueToWatchChange();
            previousValueToWatch = angular.copy(ctrl.valueToWatch);
        }
    };

    ctrl.handleValueToWatchChange = function () {
        if (ctrl.valueToWatch) {
            ctrl.lipValue = true;
        } else {
            ctrl.lipValue = false;
        }
    };
};

SplashScreenController.$inject = ['translationService'];
'use strict';

angular.module('mc.splash-screen').component('loadingInProgress', {
    controller: SplashScreenController,
    templateUrl: 'ui/components/splashscreen/splash-screen-template.html',
    bindings: {
        valueToWatch: '<',
        positionClass: '@',
        lipTextShow: '@'
    }
});
"use strict";

angular.module("mc.humidity-chart", []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HumidityChartFactory(HOST, $http) {
    var HumidityChart = function () {
        function HumidityChart(customerId, deviceId, timeZone) {
            _classCallCheck(this, HumidityChart);

            this._setting = [];
            this._loading = false;
            this._customerId = customerId;
            this._deviceId = deviceId;
            this._timeZone = timeZone;
            this._deviceName = '';
        }

        _createClass(HumidityChart, [{
            key: 'fetchData',
            value: function fetchData(startDate, endDate) {
                var _this = this;

                this._loading = true;
                return $http.get(HOST + '/api/HumidityData?customerId=' + this._customerId + '&deviceId=' + this._deviceId + '&startDate=' + startDate + '&endDate=' + endDate + '&timeZone=' + this._timeZone).then(function (resp) {
                    _this._deviceName = resp.data.device.name;
                    _this._loading = false;

                    return resp;
                });
            }
        }, {
            key: 'deviceName',
            get: function get() {
                return this._deviceName;
            }
        }, {
            key: 'setting',
            get: function get() {
                return this._setting;
            }
        }, {
            key: 'loading',
            get: function get() {
                return this._loading;
            }
        }, {
            key: 'deviceId',
            set: function set(deviceId) {
                this._deviceId = deviceId;
            }
        }]);

        return HumidityChart;
    }();

    return HumidityChart;
}

HumidityChartFactory.$inject = ['HOST', '$http', 'translationService'];

angular.module('mc.humidity-chart').factory('HumidityChartFactory', HumidityChartFactory);
'use strict';

function HumidityChartController(_, $, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, timeLapseService, websocketService, openViewService, sharedSetupService, HumidityChartFactory, toaster, rangeSelectorService) {
    var _this2 = this;

    var LIVEDATAISOFFFORNOW = true;

    this.downloadViewTypeOptions = [1];
    this.setDevice = function (selectedDevice) {
        $scope.deviceSelected = selectedDevice.deviceId;
        $scope.deviceSelectedSn = selectedDevice.serialNumber;
        $scope.deviceSelectedType = selectedDevice.type;
        $scope.deviceSelectedName = selectedDevice.name;
        $scope.currentSelectedDevice = selectedDevice;
    };

    var tlDataReceivedHUMIDITY = function tlDataReceivedHUMIDITY(data) {

        if (LIVEDATAISOFFFORNOW) return;

        if (_this2.liveData === false) {
            unregisterListener();
            return;
        }

        var extremes = _this2.chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - _this2.unixDay / 2) {
            unregisterListener($scope.deviceSelectedSn);
            return;
        }

        var liveDataLine = _this2.chart.xAxis[0].plotLinesAndBands;
        liveDataLine[0].options.value = data.Unix + _this2.maxPadding;

        if (extremes.max + _this2.liveDataOffset > extremes.dataMax) {
            _this2.chart.xAxis[0].setExtremes(data.Unix - tmpRange + _this2.minPadding, data.Unix + _this2.maxPadding);
        }
    };

    var wsDataReceivedHUMIDITY = function wsDataReceivedHUMIDITY(data) {

        if (LIVEDATAISOFFFORNOW) return;

        if (data && data.ComputeTime) {

            var str = data.ComputeTime + '';
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000

            for (var i = 0; i < _this2.series.length; i++) {
                _this2.series[i].data.push([unixtime, parseFloat(data.Value)]);
            }

            for (var i = 0; i < _this2.rawSeries.length; i++) {
                _this2.rawSeries[i].data.push([unixtime, parseFloat(data.Value)]);
            }

            for (var i = 0; i < _this2.chart.series.length; i++) {
                _this2.chart.series[i].data.push([unixtime, parseFloat(data.Value)]);
            }

            var resetView = 'live';
            _drawChart(resetView);

            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;
                var extremes = _this2.chart.xAxis[0].getExtremes();
                if (_this2.liveDataEndDate > result.unixTimeStamp && $scope.stickyProperties.zoomMax + _this2.liveDataOffset >= extremes.dataMax) {
                    registerListener($scope.deviceSelectedSn);
                    var _data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                    tlDataReceivedHUMIDITY(_data);
                }
            });
        }
    };

    var wsReconnectHUMIDITY = function wsReconnectHUMIDITY(data) {
        //
    };

    var registerListener = function registerListener(deviceSn) {

        if (_this2.liveData === true) {
            return;
        }

        _this2.liveData = true;
        if (_this2.humidityChart) {
            _this2.humidityChart.liveData = _this2.liveData;
        }
        websocketService.connect();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: true, windowId: _this2.windowId });
        timeLapseService.register('HUMIDITY', deviceSn || $scope.deviceSelectedSn, '', tlDataReceivedHUMIDITY);
        websocketService.register('HUMIDITY', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedHUMIDITY, wsReconnectHUMIDITY);
    };

    var unregisterListener = function unregisterListener(deviceSn) {
        if (_this2.liveData === false) {
            return;
        }
        _this2.liveData = false;
        if (_this2.humidityChart) {
            _this2.humidityChart.liveData = _this2.liveData;
        }
        _this2.lastUpdateAt = undefined;
        if (_this2.chart != null) timeLapseService.unRegister('HUMIDITY', deviceSn || $scope.deviceSelectedSn, '', tlDataReceivedHUMIDITY);
        websocketService.unRegister('HUMIDITY', deviceSn || $scope.deviceSelectedSn, '', wsDataReceivedHUMIDITY, wsReconnectHUMIDITY);
    };

    var setLiveDataStatus = function setLiveDataStatus(varEndDate) {
        _this2.liveDataEndDate = varEndDate ? varEndDate : _this2.liveDataEndDate;
        if (_this2.selectedGrouping === '4') {
            _this2.liveDataEndDate += _this2.unixDay;
        }

        timeLapseService.getLocalDateTime().then(function (resp) {
            var result = resp.data;
            $scope.heartbeatLocalDateTime = resp.data.unixTimeStamp;
            var extremes = _this2.chart.xAxis[0].getExtremes();
            if (_this2.liveDataEndDate > result.unixTimeStamp && $scope.stickyProperties.zoomMax + _this2.liveDataOffset >= extremes.dataMax) {
                registerListener($scope.deviceSelectedSn);
                var data = { Unix: result.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedHUMIDITY(data);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: _this2.windowId });
                unregisterListener($scope.deviceSelectedSn);
            }
        });
    };

    var _drawChart = function _drawChart(resetView) {
        _this2.chartDrawn = false;
        var chartBase = $('#humidity-chart-' + _this2.replaceSpaces(_this2.windowId));
        var tmpData = _this2.series;
        var chartXaxisHourFormat = _this2.preferredTimeFormat === _this2.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
        var chartToolTipHourFormat = _this2.preferredTimeFormat === _this2.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';
        var midPadding = 0;
        var maxPadding = 0;
        var self = _this2;

        var numberOfSeries = 0;
        var numberOfHiddenSeries = 0;
        self.yAxis = [];
        for (var i = 0; i < _this2.series.length; i++) {
            self.yAxis.push({
                gridLineWidth: 0,
                gridLineColor: _this2.series[i].color,
                id: '0',
                opposite: false,
                endOnTick: true,
                lineColor: _this2.series[i].color,
                min: 0,
                nax: null,
                labels: {
                    enabled: false,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                title: {
                    enabled: false,
                    text: _this2.translation.text.PERCENTAGE,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                }
            });
        }
        if (!!self.yAxis[0]) {
            self.yAxis[0].title.enabled = true;
            self.yAxis[0].labels.enabled = true;
        }
        self.chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: true,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1
            },
            chart: {
                renderTo: chartBase[0],
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                borderColor: '#d3d3d3',
                borderWidth: 1,
                borderRadius: 2,
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                marginRight: 10,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 2,
                spacingRight: 5,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {
                        var _this3 = this;

                        var humidityChartData = [];
                        var extremes = this.xAxis[0].getExtremes();

                        var tmpDates = null;
                        var i = -1;

                        if (this.xAxis && self.chartDrawn === true && self.scrollingInProgress === false) {
                            if (extremes && extremes.dataMin >= extremes.min - self.liveDataOffset) {
                                self.scrollingInProgress = true;

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -11);

                                self.humidityChart.fetchData(tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            self.rawSeries[i].data = JSON.parse(JSON.stringify(resp.data.series[i].data)).concat(self.rawSeries[i].data);
                                            humidityChartData.push(resp.data.series[i].data);
                                        }
                                    }

                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            tmpData[i].data = humidityChartData[i].concat(tmpData[i].data);
                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                            tmpData[i].data.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            self.chart.series[i].setData(tmpData[i].data);
                                        }
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, windowId: self.windowId });
                                    self.chart.xAxis[0].setExtremes(extremes.min + self.minPadding, extremes.max + self.maxPadding);
                                    setLiveDataStatus();

                                    $timeout(function () {
                                        self.scrollingInProgress = false;
                                    }, 1000);

                                    self.chart.hideLoading();
                                }, function (resp) {
                                    $scope.alerts = [];
                                    self.alerts = [];
                                    chartBase.empty();
                                    _this3.chart = null;
                                    var errormsg = self.translation.message.GENERAL_SERVER_ERROR;
                                    $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                    self.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                });
                            } else if (self.liveData === false && extremes && extremes.max + self.liveDataOffset >= extremes.dataMax) {
                                self.scrollingInProgress = true;

                                tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 11);

                                if (self.selectedGrouping === '4') {
                                    tmpDates.endDate += self.unixDay;
                                }

                                self.humidityChart.fetchData(tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            self.rawSeries[i].data = self.rawSeries[i].data.concat(JSON.parse(JSON.stringify(resp.data.series[i].data)));
                                            humidityChartData.push(resp.data.series[i].data);
                                        }
                                    }

                                    if (resp.data.series && resp.data.series.length > 0) {
                                        for (i = 0; i < resp.data.series.length; i++) {
                                            tmpData[i].data = tmpData[i].data.concat(humidityChartData[i]);
                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                            tmpData[i].data.sort(function (a, b) {
                                                return a[0] - b[0];
                                            });
                                            self.chart.series[i].setData(tmpData[i].data);
                                        }
                                    }

                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: tmpDates.endDate, windowId: self.windowId });
                                    self.chart.xAxis[0].setExtremes(extremes.min + self.minPadding, extremes.max + self.maxPadding);
                                    setLiveDataStatus(tmpDates.endDate);

                                    $timeout(function () {
                                        self.scrollingInProgress = false;
                                    }, 1000);

                                    self.chart.hideLoading();
                                }, function (resp) {
                                    $scope.alerts = [];
                                    self.alerts = [];
                                    chartBase.empty();
                                    _this3.chart = null;
                                    var errormsg = self.translation.message.GENERAL_SERVER_ERROR;
                                    $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                    self.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                                });
                            }
                        }
                    },
                    load: function load(event) {
                        if (self.initialLoad) openViewService.adjustContentSize(self._popup);
                        self.initialLoad = false;
                    },
                    selection: function selection(event) {
                        if (!event.xAxis) {
                            var button = this.exportSVGElements[0];
                            var button2 = this.exportSVGElements[2];
                            button.attr({
                                x: -5
                            });
                            button2.attr({
                                x: -100
                            });
                            adjustScale(this);
                        }
                    }
                }
            },
            title: {
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                }
            },
            xAxis: {
                title: {
                    text: self.translation.text.TIME,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 3,
                    color: LIVEDATAISOFFFORNOW ? 'transparent' : 'green',
                    dashStyle: 'solid',
                    zIndex: 1
                }],
                endOnTick: true,
                showLastLabel: true,
                startOnTick: true,
                ordinal: false,
                minorTickInterval: 'auto',
                minorGridLineColor: '#ebebeb',
                dateTimeLabelFormats: {
                    hour: chartXaxisHourFormat
                },
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        if (self.chartDrawn === true) {

                            if (e.trigger === 'rangeSelectorButton') {

                                var newRanges = rangeSelectorService.getrangeExtremes(e.dataMax, e.dataMin, e.rangeSelectorButton, 24);

                                sharedSetupService.setStickyProperties($scope.stickyProperties, {
                                    zoomMin: newRanges.newMin,
                                    zoomMax: newRanges.newMax,
                                    windowId: self.windowId
                                });
                                $scope.stickyProperties.on = true;
                                //Reload
                                if (newRanges.newDataMax < event.dataMin || newRanges.newDataMax > event.dataMax) _getData($scope.stickyProperties.deviceId, newRanges.newDataMin, newRanges.newDataMax);
                            } else {
                                var _extremes = self.chart.xAxis[0].getExtremes();
                                if (self.liveData === true && (e.trigger === 'navigator' || e.trigger === 'pan' || typeof e.trigger === 'undefined')) {
                                    if (_extremes.max + self.liveDataOffset <= _extremes.dataMax) {
                                        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: self.windowId });
                                        unregisterListener($scope.deviceSelectedSn);
                                    }
                                }
                                sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: _extremes.min, zoomMax: _extremes.max, windowId: self.windowId });
                            }
                        }
                    }
                }
            },
            yAxis: self.yAxis,

            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var s = '';
                    s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                    s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartXaxisHourFormat, this.x) + '</td></tr>';
                    $.each(this.points, function (i, point) {
                        var decimals = 0;

                        if (point.series.color === '#2288cc') {
                            if (point.y > 1000) {
                                decimals = 0;
                            } else {
                                if (point.y > 10) {
                                    decimals = 1;
                                } else {
                                    decimals = 2;
                                }
                            }
                        }

                        s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + $filter('number')(parseFloat(point.y).toFixed(decimals), decimals) + '</td></tr>';
                        self.xValue = point.x;
                    });
                    s += '</table>';
                    return s;
                },

                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent'
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 0,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#61768f',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
            },
            plotOptions: {
                series: {
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                self.xValue = this.x;
                            }
                        }
                    },
                    borderColor: '#303030',
                    borderWidth: 1,
                    marker: {
                        enabled: null, //If null, the markers are hidden when the data is dense, and shown for more widespread data points.
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    pointWidth: 12,
                    events: {
                        legendItemClick: function legendItemClick() {
                            numberOfSeries = self.chart.series.length - 1;
                            var visibility = this.visible ? 'visible' : 'hidden';
                            numberOfHiddenSeries = visibility === 'hidden' ? numberOfHiddenSeries - 1 : numberOfHiddenSeries + 1;
                            numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                            if (numberOfHiddenSeries < numberOfSeries) {
                                self.chart.yAxis[this.index].update({
                                    labels: {
                                        // enabled: visibility !== 'visible',
                                    },
                                    title: {
                                        // text: visibility === 'visible' ? null : self.series[this.index].name,
                                    }
                                    //lineWidth: visibility === 'visible' ? 0 : 2,
                                });
                                return true;
                            }
                            numberOfHiddenSeries = numberOfHiddenSeries - 1;
                            return false;
                        },
                        mouseOut: function mouseOut() {
                            self.xValue = null;
                        }
                    }
                }
            },
            series: [{
                id: 0,
                name: _this2.translation.text[self.series[0].name],
                yAxis: self.series[0].yAxis,
                type: self.series[0].type,
                color: self.series[0].color,
                marker: self.series[0].marker,
                shadow: self.series[0].shadow,
                data: self.series[0].data
            }]
            //series: self.series
        });

        $timeout(function () {
            for (var i = 0; i < self.series.length; i++) {
                self.series[i].marker = {
                    enabled: null,
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#FFFFFF',
                    lineWidth: 2,
                    lineColor: null // inherit from series
                };
            }
        });

        var tmpNewDateA = void 0;
        var tmpNewDateB = void 0;
        var extremes = self.chart.xAxis[0].getExtremes();

        if ($scope.stickyProperties.on === true) {
            tmpNewDateA = $scope.stickyProperties.zoomMin >= extremes.dataMin ? $scope.stickyProperties.zoomMin : extremes.dataMin;
            tmpNewDateB = $scope.stickyProperties.zoomMax <= extremes.dataMax + _this2.liveDataOffset ? $scope.stickyProperties.zoomMax : extremes.dataMax;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + _this2.unixDay / 24 ? tmpNewDateB : extremes.dataMax - _this2.unixDay / 24 * 12;
            $scope.stickyProperties.on = false;
        } else {
            tmpNewDateA = _this2.myDate !== null ? extremes.dataMin + _this2.unixDay : extremes.dataMax - _this2.unixDay / 24 * 6;
            tmpNewDateB = _this2.myDate !== null ? tmpNewDateA + _this2.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - _this2.unixDay;
            }
            tmpNewDateA = tmpNewDateA + _this2.minPadding;
            tmpNewDateB = tmpNewDateB + _this2.maxPadding;
        }

        if (tmpNewDateA > tmpNewDateB) {
            var temp = tmpNewDateA;
            tmpNewDateA = tmpNewDateB;
            tmpNewDateB = temp;
        }

        _this2.chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        if (_this2.series !== null) {
            // only for analog chart if no setup
            sharedSetupService.setStickyProperties($scope.stickyProperties, { zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: _this2.windowId });
        } else {
            // this.chart.showLoading('Pulse Flow Setup not available!');
        }

        if (!resetView) {
            setLiveDataStatus();
        } else {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var data = { Unix: resp.data.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedHUMIDITY(data);
            });
        }

        self.chartDrawn = true;
    };

    var _getData = function _getData(startDate, endDate, resetView) {
        _this2.liveDataEndDate = endDate;
        _this2.humidityChart.fetchData(startDate, endDate).then(function (resp) {
            var chartBase = $('#humidity-chart-' + _this2.replaceSpaces(_this2.windowId));

            _this2.rawSeries = JSON.parse(JSON.stringify(resp.data.series));
            _this2.series = resp.data.series;

            $scope.alerts = [];
            _this2.alerts = [];

            if (resp.data.series && resp.data.series.length > 0 && resp.data.series[0].data.length >= 1) {
                _this2.devicename = resp.data.device.name;
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate, windowId: _this2.windowId });
                _drawChart(resetView);
            } else {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: startDate, dataMax: endDate, windowId: _this2.windowId });
                chartBase.empty();
                _this2.chart = null;
                _this2.lastStart = startDate;
                _this2.lastEnd = endDate;
                var errormsg = _this2.translation.message.NO_DATA + ': ' + moment(startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(endDate).utc().format('MM/DD/YY, h:mm:ss a');
                $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
                _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
            }
        }, function (resp) {
            $scope.alerts = [];
            _this2.alerts = [];
            chartBase.empty();
            _this2.chart = null;
            var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
            $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
            _this2.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
        });
    };

    this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        _this2.chart = null;
        _this2.myDate = null;
        _this2.scrollingInProgress = false;
        _this2.initialLoad = true;
        _this2.zoomLevelCurrent = 0;
        _this2.zoomLevelPrevious = 0;
        _this2.xValue = null;
        _this2.liveData = false;
        _this2.selectedDeviceSN = null;
        _this2.chartDrawn = false;
        _this2.minPadding = 0;
        _this2.maxPadding = 0;
        _this2.selectedGrouping = '1';
        _this2.afterSetExtremesTimer = null;
        _this2.windowId = _this2.windowId || 'Humidity Chart';
        _this2.alerts = [];
        $scope.alerts = [];
        _this2.series = [];
        _this2.rawSeries = [];
        _this2.accountInfo = authenticationService.getAccountInfo();
        _this2.translation = translationService.translation;
        $scope.windowTitle = _this2.translation.text.HUMIDITY_CHART;
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        _this2.TimeFormatEnum = { Civilian: 1, Military: 2 };
        _this2.measurement = _this2.accountInfo.preferenceUser.lookupMeasurementID;
        _this2.preferredTimeFormat = _this2.accountInfo.preferenceUser.timeFormat;
        _this2.unixDay = sharedSetupService.unixDay;
        _this2.unixHour = 3600000;
        _this2.liveDataOffset = 20 * 60 * 1000;
        _this2.mouseWheelZoom = sharedSetupService.mouseWheelZoom;

        if (!_this2.mobile && !_this2.classicView) {
            $scope.windowId = _this2.windowId;
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;

            $timeout(function () {
                var chartBase = $('#humidity-chart-' + _this2.replaceSpaces(_this2.windowId));

                chartBase.on('mousewheel', function (event) {
                    if (!_this2.scrollingInProgress) {
                        _this2.mouseWheelZoom(event, _this2.chart, _this2.xValue);
                    }
                });
            });
        }

        $scope.$on('updatePreferencesLanguage', function (event, language) {
            openViewService.adjustContentSize(_this2._popup);
            if ($scope.alerts.length > 0) {
                var _msg = _this2.translation.message[$scope.alerts[0].languageCode.toUpperCase()];
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;

                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(_this2.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(_this2.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                }

                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }

            if (_this2.alerts.length === 0) {
                _drawChart();
            }
        });

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            _this2.preferredTimeFormat = parseInt(timeFormat, 10);
            if (_this2.alerts.length === 0) {
                _drawChart();
            }
        });

        $scope.zoomAdjust = function (varDay) {
            var extremes = _this2.chart.xAxis[0].getExtremes();
            $scope.varDay = varDay;
            var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, $scope.heartbeatLocalDateTime);
            _this2.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
            setLiveDataStatus();
        };

        $scope.mostRecentData = function () {
            _this2.myDate = null;
            toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
            $scope.fetchDataForSelectedDate(new Date());
        };

        $scope.fetchDataForSelectedDate = function (newVal) {
            var chartBase = $('#humidity-chart-' + _this2.replaceSpaces(_this2.windowId));
            var tmpDates = newVal;
            tmpDates.setHours(0, 0, 0, 0);
            _this2.myDate = tmpDates;
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);

            _this2.humidityChart.fetchData(tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                _this2.rawSeries = JSON.parse(JSON.stringify(resp.data.series));
                _this2.series = resp.data.series;

                $scope.alerts = [];
                _this2.alerts = [];
                if (resp.data.series && resp.data.series.length > 0 && resp.data.series[0].data.length >= 1) {
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, windowId: _this2.windowId });
                    _drawChart();
                } else {
                    _this2.lastStart = tmpDates.startDate;
                    _this2.lastEnd = tmpDates.endDate;
                    var errormsg = _this2.translation.message.NO_DATA + ': ' + moment(tmpDates.startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(tmpDates.endDate).utc().format('MM/DD/YY, h:mm:ss a');
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + _this2.unixDay, zoomMax: tmpDates.endDate - _this2.unixDay, windowId: _this2.windowId });
                    chartBase.empty();
                    _this2.chart = null;
                    $scope.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
                    _this2.alerts.push({ msg: errormsg, type: 'info', languageCode: 'NO_DATA' });
                }
            }, function (resp) {
                var errormsg = _this2.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts = [];
                _this2.alerts = [];
                chartBase.empty();
                _this2.chart = null;
                $scope.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
                _this2.alerts.push({ msg: errormsg, type: 'danger', languageCode: 'GENERAL_SERVER_ERROR' });
            });
        };

        $scope.$watch(function () {
            return _this2.myDate;
        }, function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                $scope.fetchDataForSelectedDate(newVal);
            }
        });

        $scope.$watch(function () {
            return $scope.deviceSelectedSn;
        }, function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                if (oldVal) {
                    unregisterListener(oldVal);
                }
            }
        }, true);

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal) {
                sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newVal, windowId: _this2.windowId });

                if (_this2.humidityChart) {
                    _this2.humidityChart.deviceId = newVal;
                } else {
                    _this2.humidityChart = new HumidityChartFactory(_this2.accountInfo.customerId, newVal, _this2.accountInfo.timeZone);
                }

                var tmpDates = null;
                var tmpStartDate = null;
                var tmpEndDate = null;

                if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
                    $scope.stickyProperties.on = true;
                    tmpStartDate = $scope.stickyProperties.dateMin;
                    tmpEndDate = $scope.stickyProperties.dateMax;
                } else {
                    $scope.stickyProperties.on = false;
                }

                if (!tmpStartDate) {
                    timeLapseService.getLocalDateTime().then(function (resp) {
                        var result = resp.data;

                        tmpDates = new Date(result.localDateTime);
                        tmpDates.setHours(0, 0, 0, 0);
                        tmpDates = datetimeService.dateToUnixtime(tmpDates);
                        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                        tmpStartDate = tmpDates.startDate;
                        tmpEndDate = tmpDates.endDate;
                        _getData(tmpStartDate, tmpEndDate);
                    });
                } else {
                    _getData(tmpStartDate, tmpEndDate);
                }
            }
        }, true);
    };

    this.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    this.$onDestroy = function () {
        unregisterListener($scope.deviceSelectedSn);
        if (_this2.chart) _this2.chart.destroy();
    };
}

HumidityChartController.$inject = ['_', '$', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'timeLapseService', 'websocketService', 'openViewService', 'sharedSetupService', 'HumidityChartFactory', 'toaster', 'rangeSelectorService'];
'use strict';

angular.module('mc.humidity-chart').component('humidityChart', {
    controller: HumidityChartController,
    transclude: true,
    templateUrl: 'ui/humidity/chart/humidity-chart-template.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<',
        stickyProperties: '<',
        myDate: '<'
    }
});
"use strict";

angular.module("mc.pump-widget", []);
'use strict';

function McPumpWidgetController($, $rootScope, $scope, $sce, $element, authenticationService, sharedSetupService, McPumpGaugeFactory, $timeout, McWidgetsSharedFactory, toaster, translationService) {

    var ctrl = this;
    ctrl.closeIcon = false;

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 3);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.device.deviceId, windowId: $scope.windowId });
        ctrl.translation = translationService.translation;
        ctrl.getData();
    };

    ctrl.getData = function () {

        var _runtimeGauge = new McPumpGaugeFactory(ctrl.accountInfo.customerId, $scope.stickyProperties.device.deviceId, ctrl.accountInfo.timeZone, ctrl.mcWidgetsSharedFactory.getWidgetCategoryIdByPumpType(ctrl.pumpType), ctrl.mcWidgetsSharedFactory.getWidgetIdByPumpType(ctrl.pumpType), $scope.stickyProperties.device.channel); //Category: Runtime, Widget: 'Single Needle Gauge'

        _runtimeGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            var device = _runtimeGauge.list.device;
            var deviceUnitState = _runtimeGauge.list.deviceUnitState;
            var deviceDigitalData = _runtimeGauge.list.digitalData;
            var enteredStateTime = _runtimeGauge.list.enteredStateTime;
            var defaultSetting = _runtimeGauge.list.defaultSetting;
            var runtimeGauge = _runtimeGauge.list.runtimeGauge.length == 0 ? {} : _runtimeGauge.list.runtimeGauge[0].runtimeGauge;
            var runtimeWidgetSetting = _runtimeGauge.list.runtimeGauge.length == 0 ? {} : _runtimeGauge.list.runtimeGauge[0].runtimeWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: true,
                displaySettingOn: true,
                defaultSetting: false
            };
            ctrl.runtimeGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                deviceDigitalData: deviceDigitalData,
                enteredStateTime: enteredStateTime,
                defaultSetting: defaultSetting,
                runtimeGauge: runtimeGauge,
                runtimeWidgetSetting: runtimeWidgetSetting,
                setting: setting
            };

            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.additionalSetting();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.runtimeGauge.device.name, 'View reloading');
        ctrl.getData();
    };

    ctrl.fnChangeWidgetTitle = function (titleOption) {
        var _device = { channel: titleOption.channel, deviceId: titleOption.deviceId, deviceName: titleOption.name, serialNumber: titleOption.serialNumber };
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: titleOption.deviceId, device: _device, windowId: $scope.windowId });
        ctrl.mcWidgetsSharedFactory.setTitle($element, titleOption.name, titleOption.channelDescription, titleOption.titleId);
    };

    ctrl.additionalSetting = function () {

        ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.popup.dialog({ resizable: false });

        ctrl.mcWidgetsSharedFactory.setTitle($element, ctrl.runtimeGauge.device.name, Object.keys(ctrl.runtimeGauge.runtimeGauge).length !== 0 ? ctrl.runtimeGauge.runtimeGauge.description : ctrl.translation.text.NOT_SETUP, ctrl.runtimeGauge.runtimeWidgetSetting.titleId);

        ctrl.popup.parent().find("div.ui-widget-content ").css('overflow', 'visible');

        ctrl.closeWidget = function () {
            ctrl.popup.dialog("close");
        };

        ctrl.setSize(ctrl.runtimeGauge.runtimeWidgetSetting.sizeId);
        ctrl.popup.parent().addClass("ui-widget-content-mc");

        $timeout(function () {
            var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
            ctrl.popup.parent().css("height", svgH + "px");
            ctrl.popup.parent().css("width", svgH + 25 + "px");
            ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
        }, 0);

        ctrl.popup.parent().on("mouseover", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().addClass("x-resize");
                ctrl.closeIcon = true;
            });
        });

        ctrl.popup.parent().on("mouseout", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().removeClass("x-resize");
                if (ctrl.isTouchSupported()) {
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 3000);
                } else {
                    ctrl.closeIcon = true;
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 500);
                }
            });
        });

        ctrl.isTouchSupported = function () {
            var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
            var generalTouchEnabled = "ontouchstart" in document.createElement("div");

            if (msTouchEnabled || generalTouchEnabled) {
                return true;
            }
            return false;
        };

        $scope.$on("$destroy", function (event) {
            ctrl.popup.parent().off("mouseover");
            ctrl.popup.parent().off("mouseout");
        });
    };
}

McPumpWidgetController.$inject = ["$", "$rootScope", "$scope", "$sce", "$element", "authenticationService", "sharedSetupService", "McPumpGaugeFactory", "$timeout", "McWidgetsSharedFactory", "toaster", "translationService"];
'use strict';

angular.module('mc.pump-widget').component('mcPumpWidget', {
    controller: McPumpWidgetController,
    templateUrl: 'ui/digital/mcpumpwidget/mc-pump-widget-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        pumpType: '<'
    }
});
"use strict";

angular.module("mc.pump-gauge-view", []);
'use strict';

function McPumpGaugeViewFactory(HOST, $http) {

    // instantiate our initial object
    var McPumpGaugeView = function McPumpGaugeView(customerId, deviceId, timeZone, categoryId, widgetId, channel) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.channel = channel;
    };

    McPumpGaugeView.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/DigitalWidget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&channel=' + this.channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McPumpGaugeView.prototype.getWidgetData = function (channelId) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channelId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McPumpGaugeView;
}

McPumpGaugeViewFactory.$inject = ['HOST', '$http'];

angular.module('mc.pump-gauge-view').factory('McPumpGaugeViewFactory', McPumpGaugeViewFactory);
'use strict';

function McPumpGaugeViewController($, $rootScope, $scope, sharedSetupService, authenticationService, translationService, deviceMenuService, $timeout, toaster) {
    var ctrl = this;
    ctrl.digitalReady = true;
    //ctrl.$onChanges = (changes) => {
    //    if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
    //        ctrl.deviceSelected = changes.deviceSelected.currentValue;
    //        ctrl.getDeviceType(ctrl.deviceSelected);
    //    }
    //};

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;

        $scope.$on('rtuStatusDone_' + $scope.windowId, function (event, args) {
            ctrl.digitalReady = true;
            $scope.rtuStatusDone = args.message;
            ctrl.getDeviceType($scope.deviceSelected);
        });

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") + 0);
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") + 0);
            };

            $timeout(function () {
                $scope.adjustSize();
            }, 1000);
        }
    };

    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
        ctrl.digitalReady = false;
        $timeout(function () {
            ctrl.digitalReady = true;
            ctrl.getDeviceType($scope.deviceSelected);
        }, 0);
    };

    ctrl.getDeviceType = function (deviceId) {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            var _devices = result.data.devices;

            for (var index = 0; index < _devices.length; ++index) {
                if (_devices[index].deviceId === deviceId) {
                    ctrl.m110Runtime = _devices[index].model === 8 || _devices[index].model === 18 ? true : false;
                    break;
                }
            }
        }, function (error) {
            ctrl.m110Runtime = false;
        });
    };
}

McPumpGaugeViewController.$inject = ["$", "$rootScope", "$scope", "sharedSetupService", "authenticationService", "translationService", "deviceMenuService", "$timeout", "toaster"];
'use strict';

angular.module('mc.pump-gauge-view').component('mcPumpGaugeView', {
    controller: McPumpGaugeViewController,
    templateUrl: 'ui/digital/mcpumpgaugeview/mc-pump-gauge-view-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        pumpType: '<'
    }
});
"use strict";

angular.module("mc.switch-widget", []);
'use strict';

function McSwitchWidgetController($, $rootScope, $scope, $sce, $element, authenticationService, sharedSetupService, McSwitchGaugeFactory, $timeout, McWidgetsSharedFactory, translationService) {
    var ctrl = this;
    ctrl.closeIcon = false;

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 3);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.device.deviceId, windowId: $scope.windowId });
        var _switchGauge = new McSwitchGaugeFactory(ctrl.accountInfo.customerId, $scope.stickyProperties.device.deviceId, ctrl.accountInfo.timeZone, 2, 4, $scope.stickyProperties.device.channel); //Category: Switch, Widget: 'Single Needle Gauge'
        ctrl.translation = translationService.translation;

        _switchGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            var device = _switchGauge.list.device;
            var deviceDigitalData = _switchGauge.list.digitalData;
            var defaultSetting = _switchGauge.list.defaultSetting;
            var switchGauge = _switchGauge.list.switchGauge.length == 0 ? {} : _switchGauge.list.switchGauge[0].switchGauge;
            var switchWidgetSetting = _switchGauge.list.switchGauge.length == 0 ? {} : _switchGauge.list.switchGauge[0].switchWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: true,
                displaySettingOn: true,
                defaultSetting: false
            };
            ctrl.switchGauge = {
                device: device,
                deviceDigitalData: deviceDigitalData,
                defaultSetting: defaultSetting,
                switchGauge: switchGauge,
                switchWidgetSetting: switchWidgetSetting,
                setting: setting
            };

            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.additionalSetting();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.fnChangeWidgetTitle = function (titleOption) {
        var _device = { channel: titleOption.channel, deviceId: titleOption.deviceId, deviceName: titleOption.name, serialNumber: titleOption.serialNumber };
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: titleOption.deviceId, device: _device, windowId: $scope.windowId });
        ctrl.mcWidgetsSharedFactory.setTitle($element, titleOption.name, titleOption.channelDescription, titleOption.titleId);
    };

    ctrl.additionalSetting = function () {

        ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.popup.dialog({ resizable: false });

        ctrl.mcWidgetsSharedFactory.setTitle($element, ctrl.switchGauge.device.name, Object.keys(ctrl.switchGauge.switchGauge).length !== 0 ? ctrl.switchGauge.switchGauge.description : ctrl.translation.text.NOT_SETUP, ctrl.switchGauge.switchWidgetSetting.titleId);

        ctrl.popup.parent().find("div.ui-widget-content ").css('overflow', 'visible');

        ctrl.closeWidget = function () {
            ctrl.popup.dialog("close");
        };

        ctrl.setSize(ctrl.switchGauge.switchWidgetSetting.sizeId);
        ctrl.popup.parent().addClass("ui-widget-content-mc");

        $timeout(function () {
            var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
            ctrl.popup.parent().css("height", svgH + "px");
            ctrl.popup.parent().css("width", svgH + 25 + "px");
            ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
        }, 0);

        ctrl.popup.parent().on("mouseover", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().addClass("x-resize");
                ctrl.closeIcon = true;
            });
        });

        ctrl.popup.parent().on("mouseout", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().removeClass("x-resize");
                if (ctrl.isTouchSupported()) {
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 3000);
                } else {
                    ctrl.closeIcon = false;
                }
            });
        });

        ctrl.isTouchSupported = function () {
            var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
            var generalTouchEnabled = "ontouchstart" in document.createElement("div");

            if (msTouchEnabled || generalTouchEnabled) {
                return true;
            }
            return false;
        };

        $scope.$on("$destroy", function (event) {
            ctrl.popup.parent().off("mouseover");
            ctrl.popup.parent().off("mouseout");
        });
    };
}

McSwitchWidgetController.$inject = ["$", "$rootScope", "$scope", "$sce", "$element", "authenticationService", "sharedSetupService", "McSwitchGaugeFactory", "$timeout", "McWidgetsSharedFactory", "translationService"];
'use strict';

angular.module('mc.switch-widget').component('mcSwitchWidget', {
    controller: McSwitchWidgetController,
    templateUrl: 'ui/digital/mcswitchwidget/mc-switch-widget-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.switch-gauge", []);
"use strict";

angular.module("mc.analog-gauge", []);
'use strict';

function McSwitchGaugeFactory(HOST, $http) {

    // instantiate our initial object
    var McSwitchGauge = function McSwitchGauge(customerId, deviceId, timeZone, categoryId, widgetId, channel) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.channel = channel;
    };

    McSwitchGauge.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/DigitalWidget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&channel=' + this.channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McSwitchGauge.prototype.getWidgetData = function (channelId) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channelId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McSwitchGauge;
}

McSwitchGaugeFactory.$inject = ['HOST', '$http'];

angular.module('mc.analog-gauge').factory('McSwitchGaugeFactory', McSwitchGaugeFactory);
"use strict";

function McSwitchGaugeController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, openViewService, $timeout, McSwitchGaugeFactory, $filter, $element, McWidgetsSharedFactory) {
    var _this = this;

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
            $element.off("mouseover.mcSwitchGauge");
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.buildGauges(ctrl.deviceSelected);
        }
    };

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(_this);
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
    };

    ctrl.buildGauges = function (deviceSelected) {
        $scope.alerts = [];
        var _switchGauges = new McSwitchGaugeFactory(ctrl.accountInfo.customerId, deviceSelected, ctrl.accountInfo.timeZone, 2, 4); //Category: Switch, Widget: 'Switch Gauge'

        _switchGauges.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            ctrl.deviceSelectedSn = _switchGauges.list.device.serialNumber;
            ctrl.deviceSelectedName = _switchGauges.list.device.name;

            var _device = { deviceId: deviceSelected, deviceName: ctrl.deviceSelectedName, serialNumber: ctrl.deviceSelectedSn };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: deviceSelected, device: _device, windowId: $scope.windowId });

            $scope.$emit('rtuSwitchDone_' + $scope.windowId, { message: _switchGauges.list.digitalData === null || _switchGauges.list.switchGauge.length === 0 ? 0 : _switchGauges.list.switchGauge.length });

            if (_switchGauges.list.digitalData === null) {
                $scope.alerts.push({ msg: ctrl.translation.text.NO_DATA, type: "info" });
                ctrl.switchGauges = [];
                return;
            }

            if (_switchGauges.list.switchGauge.length === 0) {
                $scope.alerts.push({ msg: ctrl.translation.message.DIGITAL_SETUP_INCOMPLETE, type: "info" });
                ctrl.switchGauges = [];
                return;
            }

            var tmpSwitchGauges = [],
                device,
                deviceDigitalData,
                switchGauge,
                switchWidgetSetting,
                setting,
                defaultSetting;

            for (var i = 0; i <= _switchGauges.list.switchGauge.length - 1; i++) {
                device = _switchGauges.list.device;
                deviceDigitalData = _switchGauges.list.digitalData;
                defaultSetting = _switchGauges.list.defaultSetting;
                switchGauge = _switchGauges.list.switchGauge[i].switchGauge;
                switchWidgetSetting = _switchGauges.list.switchGauge[i].switchWidgetSetting;

                setting = {
                    customerId: ctrl.accountInfo.customerId,
                    displaySetting: false,
                    displaySettingOn: false,
                    defaultSetting: true
                };
                tmpSwitchGauges.push({
                    device: device,
                    deviceDigitalData: deviceDigitalData,
                    defaultSetting: defaultSetting,
                    switchGauge: switchGauge,
                    switchWidgetSetting: switchWidgetSetting,
                    setting: setting
                });
            }

            ctrl.switchGauges = angular.copy(tmpSwitchGauges);
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });

        $element.on("mouseover.mcSwitchGauge", ".upWidget", function (event) {
            if ($(event.currentTarget).is(".upWidget") && event.target.tagName !== "DIV" && !$scope.mobile && !$scope.classicView && !$scope.classicView && !ctrl.mobile && !ctrl.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    zIndex: 9999,
                    disabled: false,
                    stop: function stop(event, ui) {
                        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(ui.helper.attr("mc-size"), 3);
                        var mcDevice = { deviceId: deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: ctrl.deviceSelectedSn, deviceName: ctrl.deviceSelectedName };
                        var optionsStickyProperties = {
                            deviceId: deviceSelected,
                            device: mcDevice
                        };
                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        openViewService.openWidget('Mc Switch Widget', { width: tmpSize.width, height: tmpSize.height }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                        $scope.$apply();
                    }
                });
            } else {
                $(event.currentTarget).draggable({ disabled: true });
            }
        });
    };

    $scope.$on("$destroy", function (event) {
        $element.off("mouseover.mcSwitchGauge");
    });
}

McSwitchGaugeController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "translationService", "sharedSetupService", "datetimeService", "openViewService", "$timeout", "McSwitchGaugeFactory", "$filter", "$element", "McWidgetsSharedFactory"];
'use strict';

angular.module('mc.switch-gauge').component('mcSwitchGauge', {
    controller: McSwitchGaugeController,
    templateUrl: ['$element', '$attrs', function ($element, $attrs) {
        var _template = angular.isUndefined($attrs.templateUrl) ? "mc-switch-gauge-template.html" : $attrs.templateUrl;
        return "ui/digital/mcswitchgauge/" + _template;
    }],
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.status-widget", []);
'use strict';

function McStatusWidgetController($, $rootScope, $scope, $sce, $element, authenticationService, sharedSetupService, McStatusGaugeFactory, $timeout, McWidgetsSharedFactory, translationService) {
    var ctrl = this;
    ctrl.closeIcon = false;

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 3);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.device.deviceId, windowId: $scope.windowId });
        var _statusGauge = new McStatusGaugeFactory(ctrl.accountInfo.customerId, $scope.stickyProperties.device.deviceId, ctrl.accountInfo.timeZone, 2, 2, $scope.stickyProperties.device.channel); //Category: Status, Widget: 'Single Needle Gauge'
        ctrl.translation = translationService.translation;

        _statusGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            var device = _statusGauge.list.device;
            var deviceDigitalData = _statusGauge.list.digitalData;
            var defaultSetting = _statusGauge.list.defaultSetting;
            // if _statusGauge.list.statusGauge is not available, set default values to empty object
            var statusGauge = _statusGauge.list.statusGauge.length == 0 ? {} : _statusGauge.list.statusGauge[0].statusGauge;
            var statusWidgetSetting = _statusGauge.list.statusGauge.length == 0 ? {} : _statusGauge.list.statusGauge[0].statusWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: true,
                displaySettingOn: true,
                defaultSetting: false
            };
            ctrl.statusGauge = {
                device: device,
                deviceDigitalData: deviceDigitalData,
                defaultSetting: defaultSetting,
                statusGauge: statusGauge,
                statusWidgetSetting: statusWidgetSetting,
                setting: setting
            };

            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.additionalSetting();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.fnChangeWidgetTitle = function (titleOption) {
        var _device = { channel: titleOption.channel, deviceId: titleOption.deviceId, deviceName: titleOption.name, serialNumber: titleOption.serialNumber };
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: titleOption.deviceId, device: _device, windowId: $scope.windowId });
        ctrl.mcWidgetsSharedFactory.setTitle($element, titleOption.name, titleOption.channelDescription, titleOption.titleId);
    };

    ctrl.additionalSetting = function () {

        ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.popup.dialog({ resizable: false });

        //if ctrl.statusGauge.statusGauge is set to empty object, then description is "NOT SETUP"
        ctrl.mcWidgetsSharedFactory.setTitle($element, ctrl.statusGauge.device.name, Object.keys(ctrl.statusGauge.statusGauge).length !== 0 ? ctrl.statusGauge.statusGauge.description : ctrl.translation.text.NOT_SETUP, ctrl.statusGauge.statusWidgetSetting.titleId);

        ctrl.popup.parent().find("div.ui-widget-content ").css('overflow', 'visible');

        ctrl.closeWidget = function () {
            ctrl.popup.dialog("close");
        };

        ctrl.setSize(ctrl.statusGauge.statusWidgetSetting.sizeId);
        ctrl.popup.parent().addClass("ui-widget-content-mc");

        $timeout(function () {
            var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
            ctrl.popup.parent().css("height", svgH + "px");
            ctrl.popup.parent().css("width", svgH + 25 + "px");
            ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
        }, 0);

        ctrl.popup.parent().on("mouseover", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().addClass("x-resize");
                ctrl.closeIcon = true;
            });
        });

        ctrl.popup.parent().on("mouseout", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().removeClass("x-resize");
                if (ctrl.isTouchSupported()) {
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 3000);
                } else {
                    ctrl.closeIcon = true;
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 500);
                }
            });
        });

        ctrl.isTouchSupported = function () {
            var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
            var generalTouchEnabled = "ontouchstart" in document.createElement("div");

            if (msTouchEnabled || generalTouchEnabled) {
                return true;
            }
            return false;
        };

        $scope.$on("$destroy", function (event) {
            ctrl.popup.parent().off("mouseover");
            ctrl.popup.parent().off("mouseout");
        });
    };
}

McStatusWidgetController.$inject = ["$", "$rootScope", "$scope", "$sce", "$element", "authenticationService", "sharedSetupService", "McStatusGaugeFactory", "$timeout", "McWidgetsSharedFactory", "translationService"];
'use strict';

angular.module('mc.status-widget').component('mcStatusWidget', {
    controller: McStatusWidgetController,
    templateUrl: 'ui/digital/mcstatuswidget/mc-status-widget-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.status-gauge", []);
'use strict';

function McStatusGaugeFactory(HOST, $http) {

    // instantiate our initial object
    var McStatusGauge = function McStatusGauge(customerId, deviceId, timeZone, categoryId, widgetId, channel) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.channel = channel;
    };

    McStatusGauge.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/DigitalWidget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&channel=' + this.channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McStatusGauge.prototype.getWidgetData = function (channelId) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channelId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McStatusGauge.prototype.prepareGaugeData = function () {
        var self = this;
        var tmpStatusGauges = [],
            device = void 0,
            deviceDigitalData = void 0,
            statusGauge = void 0,
            statusWidgetSetting = void 0,
            setting = void 0,
            defaultSetting = void 0;

        for (var i = 0; i <= self.list.statusGauge.length - 1; i++) {
            device = self.list.device;
            deviceDigitalData = self.list.digitalData;
            defaultSetting = self.list.defaultSetting;
            statusGauge = self.list.statusGauge[i].statusGauge;
            statusWidgetSetting = self.list.statusGauge[i].statusWidgetSetting;

            setting = {
                customerId: this.customerId,
                displaySetting: false,
                displaySettingOn: false,
                defaultSetting: true
            };
            tmpStatusGauges.push({
                device: device,
                deviceDigitalData: deviceDigitalData,
                defaultSetting: defaultSetting,
                statusGauge: statusGauge,
                statusWidgetSetting: statusWidgetSetting,
                setting: setting,
                channel: statusGauge.channel
            });
        }
        self.statusGauges = angular.copy(tmpStatusGauges);
    };

    return McStatusGauge;
}

McStatusGaugeFactory.$inject = ['HOST', '$http'];

angular.module('mc.analog-gauge').factory('McStatusGaugeFactory', McStatusGaugeFactory);
"use strict";

function McStatusGaugeController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, openViewService, $timeout, McStatusGaugeFactory, $filter, $element, McWidgetsSharedFactory) {
    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
            $element.off("mouseover.mcStatusGauge");
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.buildGauges(ctrl.deviceSelected);
        }
    };

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
    };

    ctrl.buildGauges = function (deviceSelected) {
        $scope.alerts = [];
        var _statusGauges = new McStatusGaugeFactory(ctrl.accountInfo.customerId, deviceSelected, ctrl.accountInfo.timeZone, 2, 2); //Category: Status, Widget: 'Status Gauge'

        _statusGauges.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            ctrl.deviceSelectedSn = _statusGauges.list.device.serialNumber;
            ctrl.deviceSelectedName = _statusGauges.list.device.name;
            ctrl.m110Runtime = _statusGauges.list.device.type === 8 || _statusGauges.list.device.type === 18 ? true : false;

            var _device = { deviceId: deviceSelected, deviceName: ctrl.deviceSelectedName, serialNumber: ctrl.deviceSelectedSn };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: deviceSelected, device: _device, windowId: $scope.windowId });

            $scope.$emit('rtuStatusDone_' + $scope.windowId, { message: _statusGauges.list.digitalData === null || _statusGauges.list.statusGauge.length === 0 ? 0 : _statusGauges.list.statusGauge.length });

            if (_statusGauges.list.digitalData === null) {
                $scope.alerts.push({ msg: ctrl.translation.text.NO_DATA, type: "info" });
                ctrl.statusGauges = [];
                return;
            }

            if (_statusGauges.list.statusGauge.length === 0) {
                $scope.alerts.push({ msg: ctrl.translation.message.DIGITAL_SETUP_INCOMPLETE, type: "info" });
                ctrl.statusGauges = [];
                return;
            }

            _statusGauges.prepareGaugeData();
            ctrl.statusGauges = angular.copy(_statusGauges.statusGauges);
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });

        $element.on("mouseover.mcStatusGauge", ".upWidget", function (event) {
            if ($(event.currentTarget).is(".upWidget") && event.target.tagName !== "DIV" && !$scope.mobile && !$scope.classicView && !$scope.classicView && !ctrl.mobile && !ctrl.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    zIndex: 9999,
                    disabled: false,
                    stop: function stop(event, ui) {
                        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(ui.helper.attr("mc-size"), 3);
                        var mcDevice = { deviceId: deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: ctrl.deviceSelectedSn, deviceName: ctrl.deviceSelectedName };
                        var optionsStickyProperties = {
                            deviceId: deviceSelected,
                            device: mcDevice
                        };
                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        openViewService.openWidget('Mc Status Widget', { width: tmpSize.width, height: tmpSize.height }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                        $scope.$apply();
                    }
                });
            } else {
                $(event.currentTarget).draggable({ disabled: true });
            }
        });
    };

    $scope.$on("$destroy", function (event) {
        $element.off("mouseover.mcStatusGauge");
    });
}

McStatusGaugeController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "translationService", "sharedSetupService", "datetimeService", "openViewService", "$timeout", "McStatusGaugeFactory", "$filter", "$element", "McWidgetsSharedFactory"];
'use strict';

angular.module('mc.status-gauge').component('mcStatusGauge', {
    controller: McStatusGaugeController,
    templateUrl: ['$element', '$attrs', function ($element, $attrs) {
        var _template = angular.isUndefined($attrs.templateUrl) ? "mc-status-gauge-template.html" : $attrs.templateUrl;
        return "ui/digital/mcstatusgauge/" + _template;
    }],
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.runtime-widget", []);
'use strict';

function McRuntimeWidgetController($, $rootScope, $scope, $sce, $element, authenticationService, sharedSetupService, McRuntimeGaugeFactory, $timeout, McWidgetsSharedFactory, toaster, translationService) {
    var ctrl = this;
    ctrl.closeIcon = false;

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 3);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.device.deviceId, windowId: $scope.windowId });
        ctrl.translation = translationService.translation;
        ctrl.getData();
    };

    ctrl.getData = function () {
        var _runtimeGauge = new McRuntimeGaugeFactory(ctrl.accountInfo.customerId, $scope.stickyProperties.device.deviceId, ctrl.accountInfo.timeZone, 3, 3, $scope.stickyProperties.device.channel); //Category: Runtime, Widget: 'Single Needle Gauge'
        _runtimeGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            var device = _runtimeGauge.list.device;
            var deviceDigitalData = _runtimeGauge.list.digitalData;
            var defaultSetting = _runtimeGauge.list.defaultSetting;
            var runtimeGauge = _runtimeGauge.list.runtimeGauge.length == 0 ? {} : _runtimeGauge.list.runtimeGauge[0].runtimeGauge;
            var runtimeWidgetSetting = _runtimeGauge.list.runtimeGauge.length == 0 ? {} : _runtimeGauge.list.runtimeGauge[0].runtimeWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: true,
                displaySettingOn: true,
                defaultSetting: false
            };
            ctrl.runtimeGauge = {
                device: device,
                deviceDigitalData: deviceDigitalData,
                defaultSetting: defaultSetting,
                runtimeGauge: runtimeGauge,
                runtimeWidgetSetting: runtimeWidgetSetting,
                setting: setting
            };

            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.additionalSetting();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.runtimeGauge.device.name, 'View reloading');
        ctrl.getData();
    };

    ctrl.fnChangeWidgetTitle = function (titleOption) {
        var _device = { channel: titleOption.channel, deviceId: titleOption.deviceId, deviceName: titleOption.name, serialNumber: titleOption.serialNumber };
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: titleOption.deviceId, device: _device, windowId: $scope.windowId });
        ctrl.mcWidgetsSharedFactory.setTitle($element, titleOption.name, titleOption.channelDescription, titleOption.titleId);
    };

    ctrl.additionalSetting = function () {

        ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.popup.dialog({ resizable: false });

        ctrl.mcWidgetsSharedFactory.setTitle($element, ctrl.runtimeGauge.device.name, Object.keys(ctrl.runtimeGauge.runtimeGauge).length !== 0 ? ctrl.runtimeGauge.runtimeGauge.description : ctrl.translation.text.NOT_SETUP, ctrl.runtimeGauge.runtimeWidgetSetting.titleId);

        ctrl.popup.parent().find("div.ui-widget-content ").css('overflow', 'visible');

        ctrl.closeWidget = function () {
            ctrl.popup.dialog("close");
        };

        ctrl.setSize(ctrl.runtimeGauge.runtimeWidgetSetting.sizeId);
        ctrl.popup.parent().addClass("ui-widget-content-mc");

        $timeout(function () {
            var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
            ctrl.popup.parent().css("height", svgH + "px");
            ctrl.popup.parent().css("width", svgH + 25 + "px");
            ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
        }, 0);

        ctrl.popup.parent().on("mouseover", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().addClass("x-resize");
                ctrl.closeIcon = true;
            });
        });

        ctrl.popup.parent().on("mouseout", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().removeClass("x-resize");
                if (ctrl.isTouchSupported()) {
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 3000);
                } else {
                    ctrl.closeIcon = false;
                }
            });
        });

        ctrl.isTouchSupported = function () {
            var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
            var generalTouchEnabled = "ontouchstart" in document.createElement("div");

            if (msTouchEnabled || generalTouchEnabled) {
                return true;
            }
            return false;
        };

        $scope.$on("$destroy", function (event) {
            ctrl.popup.parent().off("mouseover");
            ctrl.popup.parent().off("mouseout");
        });
    };
}

McRuntimeWidgetController.$inject = ["$", "$rootScope", "$scope", "$sce", "$element", "authenticationService", "sharedSetupService", "McRuntimeGaugeFactory", "$timeout", "McWidgetsSharedFactory", "toaster", "translationService"];
'use strict';

angular.module('mc.runtime-widget').component('mcRuntimeWidget', {
    controller: McRuntimeWidgetController,
    templateUrl: 'ui/digital/mcruntimewidget/mc-runtime-widget-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.pump-gauge", []);
'use strict';

function McPumpGaugeFactory(HOST, $http, McWidgetsSharedFactory) {

    // instantiate our initial object
    var McPumpGauge = function McPumpGauge(customerId, deviceId, timeZone, categoryId, widgetId, channel) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.channel = channel;
    };

    McPumpGauge.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/DigitalWidget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&channel=' + this.channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McPumpGauge.prototype.getWidgetData = function (channelId) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channelId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McPumpGauge.prototype.prepareGaugeData = function () {
        var self = this;
        var tmpRuntimeGauges = [],
            device = void 0,
            deviceUnitState = void 0,
            deviceDigitalData = void 0,
            enteredStateTime = void 0,
            runtimeGauge = void 0,
            runtimeWidgetSetting = void 0,
            setting = void 0,
            defaultSetting = void 0;
        var defaultSettings = self.list.defaultSettings;
        var mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        self.runtimeGaugeChannel = [];

        for (var i = 0; i <= self.list.runtimeGauge.length - 1; i++) {
            device = self.list.device;
            deviceUnitState = self.list.deviceUnitState;
            deviceDigitalData = self.list.digitalData;
            enteredStateTime = self.list.enteredStateTime;
            runtimeGauge = self.list.runtimeGauge[i].runtimeGauge;
            runtimeWidgetSetting = self.list.runtimeGauge[i].runtimeWidgetSetting;
            defaultSetting = defaultSettings.filter(function (item) {
                return item.widgetId === runtimeGauge.widgetId;
            })[0];

            setting = {
                customerId: this.customerId,
                displaySetting: false,
                displaySettingOn: false,
                defaultSetting: true
            };
            tmpRuntimeGauges.push({
                device: device,
                deviceUnitState: deviceUnitState,
                deviceDigitalData: deviceDigitalData,
                enteredStateTime: enteredStateTime,
                defaultSetting: defaultSetting,
                runtimeGauge: runtimeGauge,
                runtimeWidgetSetting: runtimeWidgetSetting,
                setting: setting,
                pumpType: mcWidgetsSharedFactory.getPumpTypeByWidgetId(runtimeGauge.widgetId),
                channel: runtimeGauge.channel
            });
            self.runtimeGaugeChannel.push(runtimeGauge.channel);
        }
        self.runtimeGauges = angular.copy(tmpRuntimeGauges);

        return;
    };

    return McPumpGauge;
}

McPumpGaugeFactory.$inject = ['HOST', '$http', 'McWidgetsSharedFactory'];

angular.module('mc.pump-gauge').factory('McPumpGaugeFactory', McPumpGaugeFactory);
"use strict";

function McPumpGaugeController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, openViewService, $timeout, McPumpGaugeFactory, $filter, $element, McWidgetsSharedFactory) {
    var _this = this;

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
            $element.off("mouseover.mcPumpGauge");
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.buildGauges(ctrl.deviceSelected);
        }
    };

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
    };

    ctrl.buildGauges = function (deviceSelected) {
        _this.alerts = [];
        var _runtimeGauges = new McPumpGaugeFactory(ctrl.accountInfo.customerId, deviceSelected, ctrl.accountInfo.timeZone, 0, ctrl.mcWidgetsSharedFactory.getWidgetIdByPumpType(ctrl.pumpType)); //Category: Runtime, Widget: 'Pump Gauge'

        _runtimeGauges.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            ctrl.deviceSelectedSn = _runtimeGauges.list.device.serialNumber;
            ctrl.deviceSelectedName = _runtimeGauges.list.device.name;
            ctrl.m110Runtime = _runtimeGauges.list.device.type === 8 || _runtimeGauges.list.device.type === 18 ? true : false;

            var _device = { deviceId: deviceSelected, deviceName: ctrl.deviceSelectedName, serialNumber: ctrl.deviceSelectedSn };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: deviceSelected, device: _device, windowId: $scope.windowId });

            $scope.$emit('rtuRuntimeDone_' + $scope.windowId, { message: _runtimeGauges.list.digitalData === null || _runtimeGauges.list.runtimeGauge.length === 0 ? 0 : _runtimeGauges.list.runtimeGauge.length });
            if (_runtimeGauges.list.device.type === 15 || _runtimeGauges.list.device.type === 20) {
                _this.alerts.push({ msg: ctrl.translation.text.DEVICE_UNSUPPORTED, type: "info" });
                ctrl.runtimeGauges = [];
                return;
            }

            if (_runtimeGauges.list.digitalData === null) {
                $scope.alerts.push({ msg: ctrl.translation.text.NO_DATA, type: "info" });
                ctrl.runtimeGauges = [];
                return;
            }

            if (_runtimeGauges.list.runtimeGauge.length === 0) {
                $scope.alerts.push({ msg: ctrl.translation.message.DIGITAL_SETUP_INCOMPLETE, type: "info" });
                ctrl.runtimeGauges = [];
                return;
            }

            _runtimeGauges.prepareGaugeData();
            ctrl.runtimeGauges = angular.copy(_runtimeGauges.runtimeGauges);
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
            ctrl.m110Runtime = false;
        });

        $element.on("mouseover.mcPumpGauge", ".upWidget", function (event) {
            if ($(event.currentTarget).is(".upWidget") && event.target.tagName !== "DIV" && !$scope.mobile && !$scope.classicView && !ctrl.mobile && !ctrl.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    zIndex: 9999,
                    disabled: false,
                    stop: function stop(event, ui) {
                        var tmpSize = ctrl.mcWidgetsSharedFactory.getSizeNew(ui.helper.attr("mc-size"), 1, ctrl.pumpType);
                        var mcDevice = { deviceId: deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: ctrl.deviceSelectedSn, deviceName: ctrl.deviceSelectedName };
                        var optionsStickyProperties = {
                            deviceId: deviceSelected,
                            device: mcDevice
                        };
                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        var vieName = "Mc " + ui.helper.attr("mc-pump-type") + " Widget";
                        openViewService.openWidget(vieName, { width: tmpSize.width, height: tmpSize.height }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));

                        $scope.$apply();
                    }
                });
            } else {
                $(event.currentTarget).draggable({ disabled: true });
            }
        });
    };

    $scope.$on("$destroy", function (event) {
        $element.off("mouseover.mcPumpGauge");
    });
}

McPumpGaugeController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "translationService", "sharedSetupService", "datetimeService", "openViewService", "$timeout", "McPumpGaugeFactory", "$filter", "$element", "McWidgetsSharedFactory"];
'use strict';

angular.module('mc.pump-gauge').component('mcPumpGauge', {
    controller: McPumpGaugeController,
    templateUrl: ['$element', '$attrs', function ($element, $attrs) {
        var _template = angular.isUndefined($attrs.templateUrl) ? "mc-pump-gauge-template.html" : $attrs.templateUrl;
        return "ui/digital/mcpumpgauge/" + _template;
    }],
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        pumpType: '<'
    }
});
"use strict";

angular.module("mc.runtime-gauge", []);
'use strict';

function McRuntimeGaugeFactory(HOST, $http) {

    // instantiate our initial object
    var McRuntimeGauge = function McRuntimeGauge(customerId, deviceId, timeZone, categoryId, widgetId, channel) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.channel = channel;
    };

    McRuntimeGauge.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/DigitalWidget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&channel=' + this.channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McRuntimeGauge.prototype.getWidgetData = function (channelId) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channelId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McRuntimeGauge;
}

McRuntimeGaugeFactory.$inject = ['HOST', '$http'];

angular.module('mc.analog-gauge').factory('McRuntimeGaugeFactory', McRuntimeGaugeFactory);
"use strict";

function McRuntimeGaugeController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, openViewService, $timeout, McRuntimeGaugeFactory, $filter, $element, McWidgetsSharedFactory) {
    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
            $element.off("mouseover.mcRuntimeGauge");
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.buildGauges(ctrl.deviceSelected);
        }
    };

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
    };

    ctrl.buildGauges = function (deviceSelected) {
        $scope.alerts = [];
        var _runtimeGauges = new McRuntimeGaugeFactory(ctrl.accountInfo.customerId, deviceSelected, ctrl.accountInfo.timeZone, 3, 3); //Category: Runtime, Widget: 'Runtime Gauge'

        _runtimeGauges.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            ctrl.deviceSelectedSn = _runtimeGauges.list.device.serialNumber;
            ctrl.deviceSelectedName = _runtimeGauges.list.device.name;
            ctrl.m110Runtime = _runtimeGauges.list.device.type === 8 || _runtimeGauges.list.device.type === 18 ? true : false;

            var _device = { deviceId: deviceSelected, deviceName: ctrl.deviceSelectedName, serialNumber: ctrl.deviceSelectedSn };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: deviceSelected, device: _device, windowId: $scope.windowId });

            $scope.$emit('rtuRuntimeDone_' + $scope.windowId, { message: _runtimeGauges.list.digitalData === null || _runtimeGauges.list.runtimeGauge.length === 0 ? 0 : _runtimeGauges.list.runtimeGauge.length });

            if (_runtimeGauges.list.digitalData === null) {
                $scope.alerts.push({ msg: ctrl.translation.text.NO_DATA, type: "info" });
                ctrl.runtimeGauges = [];
                return;
            }

            if (_runtimeGauges.list.runtimeGauge.length === 0) {
                $scope.alerts.push({ msg: ctrl.translation.message.DIGITAL_SETUP_INCOMPLETE, type: "info" });
                ctrl.runtimeGauges = [];
                return;
            }

            var tmpRuntimeGauges = [],
                device,
                deviceDigitalData,
                runtimeGauge,
                runtimeWidgetSetting,
                setting,
                defaultSetting;
            var defaultSettings = _runtimeGauges.list.defaultSettings;

            for (var i = 0; i <= _runtimeGauges.list.runtimeGauge.length - 1; i++) {
                device = _runtimeGauges.list.device;
                deviceDigitalData = _runtimeGauges.list.digitalData;
                runtimeGauge = _runtimeGauges.list.runtimeGauge[i].runtimeGauge;
                runtimeWidgetSetting = _runtimeGauges.list.runtimeGauge[i].runtimeWidgetSetting;
                defaultSetting = defaultSettings.filter(function (item) {
                    return item.widgetId === 3;
                })[0]; //_runtimeGauges.list.defaultSetting;

                setting = {
                    customerId: ctrl.accountInfo.customerId,
                    displaySetting: false,
                    displaySettingOn: false,
                    defaultSetting: true
                };
                tmpRuntimeGauges.push({
                    device: device,
                    deviceDigitalData: deviceDigitalData,
                    defaultSetting: defaultSetting,
                    runtimeGauge: runtimeGauge,
                    runtimeWidgetSetting: runtimeWidgetSetting,
                    setting: setting
                });
            }

            ctrl.runtimeGauges = angular.copy(tmpRuntimeGauges);
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
            ctrl.m110Runtime = false;
        });

        $element.on("mouseover.mcRuntimeGauge", ".upWidget", function (event) {
            if (!ctrl.m110Runtime && $(event.currentTarget).is(".upWidget") && event.target.tagName !== "DIV" && !$scope.mobile && !$scope.classicView && !ctrl.mobile && !ctrl.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    zIndex: 9999,
                    disabled: false,
                    stop: function stop(event, ui) {
                        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(ui.helper.attr("mc-size"), 3);
                        var mcDevice = { deviceId: deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: ctrl.deviceSelectedSn, deviceName: ctrl.deviceSelectedName };
                        var optionsStickyProperties = {
                            deviceId: deviceSelected,
                            device: mcDevice
                        };
                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        openViewService.openWidget('Mc Runtime Widget', { width: tmpSize.width, height: tmpSize.height }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                        $scope.$apply();
                    }
                });
            } else {
                $(event.currentTarget).draggable({ disabled: true });
            }
        });
    };

    $scope.$on("$destroy", function (event) {
        $element.off("mouseover.mcRuntimeGauge");
    });
}

McRuntimeGaugeController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "translationService", "sharedSetupService", "datetimeService", "openViewService", "$timeout", "McRuntimeGaugeFactory", "$filter", "$element", "McWidgetsSharedFactory"];
'use strict';

angular.module('mc.runtime-gauge').component('mcRuntimeGauge', {
    controller: McRuntimeGaugeController,
    templateUrl: ['$element', '$attrs', function ($element, $attrs) {
        var _template = angular.isUndefined($attrs.templateUrl) ? "mc-runtime-gauge-template.html" : $attrs.templateUrl;
        return "ui/digital/mcruntimegauge/" + _template;
    }],
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.rtu-view-gauge", []);
"use strict";

function McRtuViewGaugeController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, openViewService, $timeout, McPumpGaugeFactory, $filter, $element, McWidgetsSharedFactory, McStatusGaugeFactory) {
    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
            $scope.rtuGauge = false;
            ctrl.gauges = [];
            ctrl.runtimeGauges = [];
            ctrl.statusGauges = [];
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
            $element.off("mouseover.mcPumpGauge");
            $element.off("mouseover.mcStatusGauge");
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.buildGauges(ctrl.deviceSelected);
        }
    };

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.gauges = [];
        ctrl.runtimeGauges = [];
        ctrl.statusGauges = [];
        ctrl.runtimeGaugeChannel = [];
        $scope.rtuGauge = false;
    };

    ctrl.mergeTwo = function (arr1, arr2) {
        var merged = [];
        var index1 = 0;
        var index2 = 0;
        var current = 0;

        while (current < arr1.length + arr2.length) {

            var isArr1Depleted = index1 >= arr1.length;
            var isArr2Depleted = index2 >= arr2.length;

            if (!isArr1Depleted && (isArr2Depleted || arr1[index1].channel < arr2[index2].channel)) {
                merged[current] = arr1[index1];
                index1++;
            } else {
                merged[current] = arr2[index2];
                index2++;
            }

            current++;
        }

        return merged;
    };

    ctrl.buildGauges = function (deviceSelected) {
        var _runtimeGauges = new McPumpGaugeFactory(ctrl.accountInfo.customerId, deviceSelected, ctrl.accountInfo.timeZone, 0, ctrl.mcWidgetsSharedFactory.getWidgetIdByPumpType(ctrl.pumpType)); //Category: Runtime, Widget: 'Pump Gauge'
        var _statusGauges = new McStatusGaugeFactory(ctrl.accountInfo.customerId, deviceSelected, ctrl.accountInfo.timeZone, 2, 2); //Category: Status, Widget: 'Status Gauge'

        // Start both async calls
        var runtimePromise = _runtimeGauges.getGaugeData();
        var statusPromise = _statusGauges.getGaugeData();

        Promise.all([runtimePromise, statusPromise]).then(function () {
            // ------------------------
            // Runtime gauges
            // ------------------------
            if (_runtimeGauges.list.digitalData !== null && _runtimeGauges.list.runtimeGauge.length > 0) {
                _runtimeGauges.prepareGaugeData();
                ctrl.runtimeGauges = angular.copy(_runtimeGauges.runtimeGauges);
                ctrl.runtimeGaugeChannel = _runtimeGauges.runtimeGaugeChannel;
                ctrl.runtimeGaugesLoaded = true;

                ctrl.deviceSelectedSn = _runtimeGauges.list.device.serialNumber;
                ctrl.deviceSelectedName = _runtimeGauges.list.device.name;
                ctrl.m110Runtime = _runtimeGauges.list.device.type === 8 || _runtimeGauges.list.device.type === 18;

                var _device = {
                    deviceId: deviceSelected,
                    deviceName: ctrl.deviceSelectedName,
                    serialNumber: ctrl.deviceSelectedSn
                };
                sharedSetupService.setStickyProperties($scope.stickyProperties, {
                    deviceId: deviceSelected,
                    device: _device,
                    windowId: $scope.windowId
                });

                $scope.$emit("rtuRuntimeDone_" + $scope.windowId, {
                    message: _runtimeGauges.list.runtimeGauge.length
                });
            } else {
                ctrl.runtimeGauges = [];
                ctrl.runtimeGaugeChannel = [];
                ctrl.runtimeGaugesLoaded = false;

                $scope.$emit("rtuRuntimeDone_" + $scope.windowId, { message: 0 });
            }

            // ------------------------
            // Status gauges
            // ------------------------
            if (_statusGauges.list.digitalData !== null && _statusGauges.list.statusGauge.length > 0) {
                _statusGauges.prepareGaugeData();
                ctrl.statusGauges = angular.copy(_statusGauges.statusGauges);
                ctrl.statusGaugesLoaded = true;

                $scope.$emit("rtuStatusDone_" + $scope.windowId, {
                    message: _statusGauges.list.statusGauge.length
                });
            } else {
                ctrl.statusGauges = [];
                ctrl.statusGaugesLoaded = false;

                $scope.$emit("rtuStatusDone_" + $scope.windowId, { message: 0 });
            }

            // ------------------------
            // Merge logic (runs only once, after both are ready)
            // ------------------------
            if (ctrl.runtimeGaugesLoaded && ctrl.statusGaugesLoaded) {
                ctrl.gauges = ctrl.mergeTwo(ctrl.runtimeGauges, ctrl.statusGauges);
            } else if (ctrl.runtimeGaugesLoaded) {
                ctrl.gauges = ctrl.runtimeGauges;
            } else if (ctrl.statusGaugesLoaded) {
                ctrl.gauges = ctrl.statusGauges;
            } else {
                ctrl.gauges = [];
            }
        }).catch(function (error) {
            console.error("Error loading gauges:", error);
            ctrl.m110Runtime = false;
            ctrl.gauges = [];
        });

        //_runtimeGauges.getGaugeData().then(() => {            
        //    ctrl.runtimeGaugesLoaded = false;
        //    ctrl.deviceSelectedSn = _runtimeGauges.list.device.serialNumber;
        //    ctrl.deviceSelectedName = _runtimeGauges.list.device.name;
        //    ctrl.m110Runtime = _runtimeGauges.list.device.type === 8 || _runtimeGauges.list.device.type === 18 ? true : false;

        //    var _device = { deviceId: deviceSelected, deviceName: ctrl.deviceSelectedName, serialNumber: ctrl.deviceSelectedSn };
        //    sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: deviceSelected, device: _device, windowId: $scope.windowId });

        //    $scope.$emit('rtuRuntimeDone_' + $scope.windowId, { message: (_runtimeGauges.list.digitalData === null) || (_runtimeGauges.list.runtimeGauge.length === 0) ? 0 : _runtimeGauges.list.runtimeGauge.length });

        //    if (_runtimeGauges.list.digitalData === null) {                
        //        ctrl.runtimeGauges = [];
        //        ctrl.runtimeGaugeChannel = [];
        //        return;
        //    }

        //    if (_runtimeGauges.list.runtimeGauge.length === 0) {               
        //        ctrl.runtimeGauges = [];
        //        ctrl.runtimeGaugeChannel = [];
        //        return;
        //    }            

        //    _runtimeGauges.prepareGaugeData();
        //    ctrl.runtimeGauges = angular.copy(_runtimeGauges.runtimeGauges);
        //    ctrl.runtimeGaugeChannel = _runtimeGauges.runtimeGaugeChannel;
        //    ctrl.runtimeGaugesLoaded = true;

        //}, error => {
        //    console.log(error);            
        //    ctrl.m110Runtime = false;
        //});

        //_statusGauges.getGaugeData().then(() => {            
        //    ctrl.statusGaugesLoaded = false;                                    

        //    $scope.$emit('rtuStatusDone_' + $scope.windowId, { message: (_statusGauges.list.digitalData === null) || (_statusGauges.list.statusGauge.length === 0) ? 0 : _statusGauges.list.statusGauge.length });

        //    if (_statusGauges.list.digitalData === null) {                
        //        ctrl.statusGauges = [];
        //        if (ctrl.runtimeGaugesLoaded) {
        //            ctrl.gauges = ctrl.runtimeGauges;
        //        }
        //        else {
        //            ctrl.gauges = [];
        //        }
        //        return;
        //    }

        //    if (_statusGauges.list.statusGauge.length === 0) {                
        //        ctrl.statusGauges = [];
        //        if (ctrl.runtimeGaugesLoaded) {
        //            ctrl.gauges = ctrl.runtimeGauges;
        //        } else {
        //            ctrl.gauges = [];
        //        }
        //        return;
        //    }

        //    _statusGauges.prepareGaugeData();
        //    ctrl.statusGauges = angular.copy(_statusGauges.statusGauges);                        
        //    ctrl.statusGaugesLoaded = true;

        //    if (ctrl.runtimeGaugesLoaded && ctrl.statusGaugesLoaded) {
        //        ctrl.gauges = ctrl.mergeTwo(ctrl.runtimeGauges, ctrl.statusGauges);
        //    }
        //    else if (ctrl.runtimeGaugesLoaded) {
        //        ctrl.gauges = ctrl.runtimeGauges;
        //    }
        //    else {
        //        ctrl.gauges = ctrl.statusGauges;
        //    }
        //}, error => {
        //    console.log(error);            
        //});               

        $element.on("mouseover.mcStatusGauge", ".upWidget", function (event) {
            if ($(event.currentTarget).is(".upWidget") && event.target.tagName !== "DIV" && !$scope.mobile && !$scope.classicView && !$scope.classicView && !ctrl.mobile && !ctrl.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    zIndex: 9999,
                    disabled: false,
                    stop: function stop(event, ui) {
                        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(ui.helper.attr("mc-size"), 3);
                        var mcDevice = { deviceId: deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: ctrl.deviceSelectedSn, deviceName: ctrl.deviceSelectedName };
                        var optionsStickyProperties = {
                            deviceId: deviceSelected,
                            device: mcDevice
                        };
                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        if (ctrl.runtimeGaugeChannel.includes(parseInt(mcDevice.channel))) {
                            var viewName = "Mc " + ui.helper.attr("mc-pump-type") + " Widget";
                            openViewService.openWidget(viewName, { width: tmpSize.width, height: tmpSize.height }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                        } else {
                            openViewService.openWidget('Mc Status Widget', { width: tmpSize.width, height: tmpSize.height }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                        }
                        $scope.$apply();
                    }
                });
            } else {
                $(event.currentTarget).draggable({ disabled: true });
            }
        });
    };

    $scope.rtuGaugeSectionShowHide = function () {
        $scope.rtuGauge = !$scope.rtuGauge;
    };

    $scope.$on('rtuViewRefreshButtonClicked', function (event, args) {
        if (ctrl.deviceSelected == args) {
            $scope.rtuGauge = false;
        }
    });

    $scope.$on("$destroy", function (event) {
        $element.off("mouseover.mcStatusGauge");
    });
}

McRtuViewGaugeController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "translationService", "sharedSetupService", "datetimeService", "openViewService", "$timeout", "McPumpGaugeFactory", "$filter", "$element", "McWidgetsSharedFactory", "McStatusGaugeFactory"];
'use strict';

angular.module('mc.rtu-view-gauge').component('mcRtuViewGauge', {
    controller: McRtuViewGaugeController,
    templateUrl: 'ui/digital/mcrtuviewgauge/mc-rtu-view-gauge-view.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.relay-widget", []);
"use strict";

function McRelayWidgetController($, $rootScope, $scope, $sce, $element, authenticationService, sharedSetupService, McStatusGaugeFactory, $timeout, McWidgetsSharedFactory, translationService, deviceService, McWidgetRelayDisplayFactory) {
    var ctrl = this;
    ctrl.closeIcon = false;

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 3);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.device.deviceId, windowId: $scope.windowId });
        ctrl.translation = translationService.translation;

        ctrl.relayWidget = {
            device: ctrl.stickyProperties.device
        };

        if (!$rootScope.mobile && !$rootScope.classicView) ctrl.additionalSetting();
    };

    ctrl.fnChangeWidgetTitle = function (titleOption) {
        var _device = { channel: titleOption.channel, deviceId: titleOption.deviceId, deviceName: titleOption.name, serialNumber: titleOption.serialNumber };
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: titleOption.deviceId, device: _device, windowId: $scope.windowId });
        ctrl.mcWidgetsSharedFactory.setTitle($element, titleOption.name, titleOption.channelDescription, titleOption.titleId);
    };

    ctrl.getDevice = function (device) {
        deviceService.getDeviceLookup(ctrl.accountInfo.customerId, device.deviceId).then(function (datafromFactory) {
            ctrl.device = datafromFactory.data;
            var mcWidgetRelayDisplayFactory = new McWidgetRelayDisplayFactory(ctrl.accountInfo.customerId, device.deviceId, ctrl.accountInfo.timeZone);
            mcWidgetRelayDisplayFactory.getRelayData(ctrl.device.hasAdamsRelayModule).then(function (result) {
                var tmpData = {
                    "deviceId": device.deviceId,
                    "channel": device.channel,
                    "serialNumber": device.serialNumber,
                    "deviceName": ctrl.device.name,
                    "relay": ctrl.findRelayByChannel(device.channel, result.data.availableRelays),
                    "imei": ctrl.device.imei,
                    "deviceInfo": {
                        "deviceType": ctrl.device.deviceModel,
                        "protocolVersion": ctrl.device.protocolVersion
                    }
                };
                var tmpWidgetData = {
                    "device": tmpData
                };
                ctrl.mcWidgetsSharedFactory.setTitle($element, tmpWidgetData.device.deviceName, tmpWidgetData.device.relay.description, 2);
            }, function (error) {});
        });
    };

    ctrl.findRelayByChannel = function (channel, relays) {
        return relays.find(function (relay) {
            return relay.channel === Number(channel);
        });
    };

    ctrl.additionalSetting = function () {

        ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.popup.dialog({ resizable: false });

        //if ctrl.statusGauge.statusGauge is set to empty object, then description is "NOT SETUP"
        if (ctrl.stickyProperties.device.deviceName == null) {
            ctrl.getDevice(ctrl.stickyProperties.device);
        } else {
            ctrl.mcWidgetsSharedFactory.setTitle($element, ctrl.stickyProperties.device.deviceName, ctrl.stickyProperties.device.relay.description, 2);
        }

        ctrl.popup.parent().find("div.ui-widget-content ").css('overflow', 'visible');

        ctrl.closeWidget = function () {
            ctrl.popup.dialog("close");
        };

        ctrl.setSize(2);
        ctrl.popup.parent().addClass("ui-widget-content-mc");

        $timeout(function () {
            var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
            ctrl.popup.parent().css("height", svgH + "px");
            ctrl.popup.parent().css("width", svgH + 25 + "px");
            ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
        }, 0);

        ctrl.popup.parent().on("mouseover", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().addClass("x-resize");
                ctrl.closeIcon = true;
            });
        });

        ctrl.popup.parent().on("mouseout", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().removeClass("x-resize");
                if (ctrl.isTouchSupported()) {
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 3000);
                } else {
                    ctrl.closeIcon = true;
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 500);
                }
            });
        });

        ctrl.isTouchSupported = function () {
            var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
            var generalTouchEnabled = "ontouchstart" in document.createElement("div");

            if (msTouchEnabled || generalTouchEnabled) {
                return true;
            }
            return false;
        };

        $scope.$on("$destroy", function (event) {
            ctrl.popup.parent().off("mouseover");
            ctrl.popup.parent().off("mouseout");
        });
    };
}

McRelayWidgetController.$inject = ["$", "$rootScope", "$scope", "$sce", "$element", "authenticationService", "sharedSetupService", "McStatusGaugeFactory", "$timeout", "McWidgetsSharedFactory", "translationService", "deviceService", "McWidgetRelayDisplayFactory"];
'use strict';

angular.module('mc.relay-widget').component('mcRelayWidget', {
    controller: McRelayWidgetController,
    templateUrl: 'ui/digital/mcrelaywidget/mc-relay-widget-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

mcapp.factory("websocketService", ["$http", "$rootScope", "$timeout", "authenticationService", "datetimeService", "$interval", "$window", "$q", "$sanitize", "$uibModal", "translationService", "debounceService", function ($http, $rootScope, $timeout, authenticationService, datetimeService, $interval, $window, $q, $sanitize, $uibModal, translationService, debounceService) {
    var websocketFactory = {};
    var listenerArray = [];
    var connected = false;
    var _delay = false;
    var attempts = 1;
    var forceToClose = false;
    var attemptsMax = 1000;
    var _writeToConsole = true;
    var _resetConnectionAfterItFailedTimeout;
    var _resetConnectionInProgressTimeout;
    var _tryingToConnect;
    $rootScope.socketOn = connected;
    $rootScope.recievedSN = "";
    $rootScope.recievedRegTime = new Date();

    var _getTimeStamp = function _getTimeStamp() {

        var currentDateTime = new Date(),
            day = currentDateTime.getDate(),
            month = currentDateTime.getMonth() + 1,
            year = currentDateTime.getFullYear(),
            hours = currentDateTime.getHours(),
            minutes = currentDateTime.getMinutes(),
            seconds = currentDateTime.getSeconds();

        if (minutes < 10) {
            minutes = "0" + minutes;
        }

        if (seconds < 10) {
            seconds = "0" + seconds;
        }

        var suffix = "AM";
        if (hours >= 12) {
            suffix = "PM";
            hours = hours - 12;
        }
        if (hours == 0) {
            hours = 12;
        }

        return day + "/" + month + "/" + year + " " + hours + ":" + minutes + ":" + seconds + " " + suffix;
    };

    var _siteResetInProgress = false;
    var _siteResetInProgressTimeout;

    $.connection.hub.disconnected(function () {
        console.log(_getTimeStamp() + "\n\t" + "WebSocket Disconnected!");
        connected = false;
        $rootScope.socketOn = connected;

        if ($.connection.hub.lastError) {
            console.log(_getTimeStamp() + "\n\t" + "Disconnected. Reason: " + $.connection.hub.lastError.message);
            _resetSiteConnection();
        }

        if (attempts <= attemptsMax && forceToClose === false) {
            _resetSiteConnection();
        }
    });

    $.connection.hub.connectionSlow(function () {
        if (_writeToConsole) console.log(_getTimeStamp() + "\n\t" + "We are currently experiencing difficulties with the connection.");
    });

    $.connection.hub.reconnecting(function () {
        console.log(_getTimeStamp() + "\n\t" + "hub, reconnecting...");
        _resetSiteConnection();
    });

    $.connection.hub.reconnected(function () {
        console.log(_getTimeStamp() + "\n\t" + "hub, reconnected!");
    });

    $.connection.hub.logging = true;
    $.connection.hub.error(function (error) {
        console.log(_getTimeStamp() + "\n\t" + "SignalR error: " + error);
        connected = false;
        $rootScope.socketOn = connected;
        //console.log(_getTimeStamp() + "\n\t" + "Calling _close() function!");
        _close();
    });

    var chatHubProxy = $.connection.hub.proxies.chathub;

    chatHubProxy.on('Stop', function (message) {
        $.connection.hub.stop().done(function () {
            console.log('stopped connection with message ' + message);
        });
    });

    var _connect = function _connect() {
        if (_tryingToConnect) return;
        _tryingToConnect = true;
        var deferred = $q.defer();
        if (!connected) {
            //build new connection

            if (!angular.isUndefined(_resetConnectionAfterItFailedTimeout)) {
                _cancelAllTimers();
                _siteResetInProgress = true;
                _siteResetInProgressTimeout = _allowReconnectShortly();
            }

            var accountInfo = authenticationService.getAccountInfo();
            // Add auth token to headerdestr
            console.log(_getTimeStamp() + "\n\t" + "Websocket connecting...");
            var authData = JSON.parse($window.sessionStorage.authorizationInfo);
            $.connection.ajaxDefaults.headers = {
                Authorization: "Bearer " + authData.token
            };

            var localUnixTime = new Date(datetimeService.localToUtcTimeStampByTime(new Date(), accountInfo.timeZone));
            authData.expires = new Date(authData.expires);

            if (authData.token == null || authData.expires < localUnixTime) {
                openTokenExpiredModal("Token expired. Please logout and login back.");
                return;
            }

            // Add timezone to query string
            $.connection.hub.qs = {
                'customerId': accountInfo.customerId,
                'timezone': accountInfo.timeZone
            };
            $.connection.hub.url = '/Mc.Services/signalr';

            ////////////////////////////////////////////////////////////////////////////////
            ////////////////////////////////////////////////////////////////////////////////

            var cChatHub = $.connection.chatHub;

            if (cChatHub && cChatHub.client) {
                cChatHub.client.newMessage = function (message) {
                    _processMsg(message);
                };
            } else {
                console.log(_getTimeStamp() + "\n\t" + "SignalR error: cChatHub is " + cChatHub);
                connected = false;
                $rootScope.socketOn = connected;
            }

            ////////////////////////////////////////////////////////////////////////////////
            var cInfoHub = $.connection.infoHub;

            if (cInfoHub && cInfoHub.client) {
                cInfoHub.client.newMessage = function (message) {
                    _processMsg(message);
                };
            } else {
                console.log(_getTimeStamp() + "\n\t" + "SignalR error: cInfoHub is " + cInfoHub);
                connected = false;
                $rootScope.socketOn = connected;
            }

            ////////////////////////////////////////////////////////////////////////////////

            var cStatusHub = $.connection.statusHub;

            if (cStatusHub && cStatusHub.client) {
                cStatusHub.client.newLiveStatus = function (message) {
                    _processNewLiveStatusMsg(message);
                };
            } else {
                console.log(_getTimeStamp() + "\n\t" + "SignalR error: cStatusHub is " + cStatusHub);
                connected = false;
                $rootScope.socketOn = connected;
            }

            ////////////////////////////////////////////////////////////////////////////////

            var cOverviewHub = $.connection.overviewHub;

            if (cOverviewHub && cOverviewHub.client) {
                cOverviewHub.client.listDeviceStateMsg = function (message) {
                    _processListDeviceStateMsg(message);
                };
            } else {
                console.log(_getTimeStamp() + "\n\t" + "SignalR error: cOverviewHub is " + cOverviewHub);
                connected = false;
                $rootScope.socketOn = connected;
            }

            ////////////////////////////////////////////////////////////////////////////////

            var cEventHub = $.connection.eventHub;

            if (cEventHub && cEventHub.client) {
                cEventHub.client.newMessage = function (message) {
                    _processEventMsg(message);
                };
            } else {
                console.log(_getTimeStamp() + "\n\t" + "SignalR error: cEventHub is " + cEventHub);
                connected = false;
                $rootScope.socketOn = connected;
            }

            ////////////////////////////////////////////////////////////////////////////////

            var cHeartbeatHub = $.connection.heartbeatHub;

            if (cHeartbeatHub && cHeartbeatHub.client) {
                cHeartbeatHub.client.newMessage = function (message) {
                    _processHeartbeatMsg(message);
                };
            } else {
                console.log(_getTimeStamp() + "\n\t" + "SignalR error: cHeartbeatHub is " + cHeartbeatHub);
                connected = false;
                $rootScope.socketOn = connected;
            }

            ////////////////////////////////////////////////////////////////////////////////
            ////////////////////////////////////////////////////////////////////////////////


            // Start the connection.
            var _startConnection = function _startConnection() {
                $.connection.hub.start({ pingInterval: 300000, transport: 'webSockets' }).done(function () {
                    if (_writeToConsole)
                        //console.log(_getTimeStamp() + "\n\t" + "Now connected, connection ID = " +
                        //    $.connection.hub.id +
                        //    " transport = " +
                        //    $.connection.hub.transport.name);
                        connected = true;
                    $rootScope.socketOn = connected;
                    if (attempts > 1) {
                        console.log(_getTimeStamp() + "\n\t" + "Reconnected after " + (attempts - 1) + " attempt(s)");
                        _resetSiteConnection();
                    } else {
                        console.log(_getTimeStamp() + "\n\t" + "WebSocket Connected!");
                    }
                    attempts = 1;
                    forceToClose = false;
                    _tryingToConnect = false;
                    deferred.resolve("Connected");
                }).fail(function () {
                    console.log(_getTimeStamp() + "\n\t" + "Could not connect");
                    console.log(_getTimeStamp() + "\n\t" + "Will try again in 2 minutes...");
                    _resetConnectionAfterItFailedTimeout = $timeout(function () {
                        _resetSiteConnection();
                    }, 120000);
                    _tryingToConnect = false;
                    deferred.reject('Connection failed');
                });
            };

            if (!connected) _startConnection();
        } else {
            _tryingToConnect = false;
            deferred.resolve("Connected");
        }

        return deferred.promise;
    };

    var _resetSiteConnection = function _resetSiteConnection(force) {

        var accountInfo = authenticationService.getAccountInfo();
        if (accountInfo === null) return;

        if (force) _cancelAllTimers();

        if (_siteResetInProgress) return;

        _siteResetInProgress = true;
        $rootScope.online = false;
        $rootScope.$broadcast('onOnlineStatus', { online: $rootScope.online });

        if (!angular.isUndefined(_siteResetInProgressTimeout)) $timeout.cancel(_siteResetInProgressTimeout);
        _siteResetInProgressTimeout = _allowReconnectShortly();

        if ($.connection.hub && $.connection.hub.state !== $.signalR.connectionState.disconnected) {
            _close();
        }

        _resetConnectionInProgressTimeout = $timeout(function () {
            var accInf = authenticationService.getAccountInfo();
            if (accInf === null) return;
            var promise = _connect();
            promise.then(function (data) {
                console.log(_getTimeStamp() + "\n\t" + "Connection reset!");
            }, function (reason) {
                console.log(_getTimeStamp() + "\n\t" + "Connection issue");
            });
        }, 10000);
    };

    var _cancelAllTimers = function _cancelAllTimers() {
        _siteResetInProgress = false;
        if (!angular.isUndefined(_siteResetInProgressTimeout)) $timeout.cancel(_siteResetInProgressTimeout);
        if (!angular.isUndefined(_resetConnectionAfterItFailedTimeout)) $timeout.cancel(_resetConnectionAfterItFailedTimeout);
        if (!angular.isUndefined(_resetConnectionInProgressTimeout)) $timeout.cancel(_resetConnectionInProgressTimeout);
    };

    var _allowReconnectShortly = function _allowReconnectShortly() {
        return $timeout(function () {
            _siteResetInProgress = false;
        }, 80000); //give it 80 seconds to reconnect and get HEARTBEAT
    };

    var _startLiveStatus = function _startLiveStatus() {
        var promise = _connect();
        if (_tryingToConnect) return;
        promise.then(function (data) {
            $.connection.statusHub.server.startMessages();
        }, function (reason) {
            console.log(_getTimeStamp() + "\n\t" + "Connection issue");
        });
    };

    var _startLiveStatusDebounce = debounceService(_startLiveStatus, 200, false);

    var _stopLiveStatus = function _stopLiveStatus() {
        if (connected) {
            $.connection.statusHub.server.stopMessages();
            $rootScope.$broadcast('StopLiveStatus', {
                stop: true
            });
        }
    };

    var _stopLiveStatusDebounce = debounceService(_stopLiveStatus, 200, false);

    var _startOverview = function _startOverview() {
        var promise = _connect();
        if (_tryingToConnect) return;
        promise.then(function (data) {
            $.connection.overviewHub.server.startMessages();
        }, function (reason) {
            console.log(_getTimeStamp() + "\n\t" + "Connection issue");
        });
    };

    var _startOverviewDebounce = debounceService(_startOverview, 200, false);

    var _stopOverview = function _stopOverview() {
        if (connected) {
            $.connection.overviewHub.server.stopMessages();
            $rootScope.$broadcast('StopOverview', {
                stop: true
            });
        }
    };

    var _stopOverviewDebounce = debounceService(_stopOverview, 200, false);

    var _close = function _close() {
        forceToClose = true;
        //if (connected) {
        //console.log(_getTimeStamp() + "\n\t" + "_close() function was called!");
        $.connection.hub.stop();
        connected = false;
        //console.log(_getTimeStamp() + "\n\t" + "WebSocket connection closed!");
        //}
    };

    var _generateInteval = function _generateInteval(k) {
        var maxInterval = (Math.pow(2, k) - 1) * 1000;
        if (maxInterval > 30 * 1000) {
            maxInterval = 30 * 1000; // If the generated interval is more than 30 seconds, truncate it down to 30 seconds.
        }
        // generate the interval to a random number between 0 and the maxInterval determined from above
        return Math.random() * maxInterval;
    };

    var _register = function _register(type, sn, channel, callback, reconnect) {
        // add to _listenerArray
        var lsn = {
            Type: type, SN: sn, Channel: channel, Callback: callback, Reconnect: reconnect
        };
        var inArray = false;
        for (var i = 0; i < listenerArray.length; i++) {
            if (listenerArray[i].Type == type && listenerArray[i].SN == sn && listenerArray[i].Channel == channel && listenerArray[i].Callback == callback && listenerArray[i].Reconnect == reconnect) {
                //remove from array
                inArray = true;
            }
        }

        if (listenerArray.indexOf(lsn) == -1 && !inArray) {
            listenerArray.push(lsn);
        }
    };

    var _unRegister = function _unRegister(type, sn, channel, callback, reconnect) {
        //loop through _listenerArray
        for (var i = 0; i < listenerArray.length; i++) {
            if (listenerArray[i].Type == type && listenerArray[i].SN == sn && listenerArray[i].Channel == channel && listenerArray[i].Callback == callback && listenerArray[i].Reconnect == reconnect) {
                //remove from array
                listenerArray.splice(i, 1);
            }
        }
    };

    var _processMsg = function _processMsg(message) {
        //var _startDate = new Date();
        $rootScope.keepAlive = new Date();
        $rootScope.messageIn = true;
        var msg = message;
        $rootScope.$broadcast('WebSocketService', {
            message: msg
        });

        //need it for new digital widgets
        if (msg.Type === "INPUTS" || msg.Type === "OPTIONDIGITAL" || msg.Type === "FAULTS") {
            var brData = { Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, CH: msg.Ch, RepID: msg.ScaledValue, Type: msg.Type, UtcDateTime: msg.RegTime };
            if ($rootScope.recievedSN == msg.Sn && $rootScope.recievedRegTime == msg.RegTime && msg.Type === "INPUTS") {
                $rootScope.$broadcast("OPTIONDIGITAL", { data: brData });
            } else $rootScope.$broadcast(msg.Type, { data: brData });
            if (msg.Type === "INPUTS") {
                $rootScope.recievedSN = msg.Sn;
                $rootScope.recievedRegTime = msg.RegTime;
            }
        } else if (msg.Type === "DIGITALINPUT" || msg.Type === "DIGITALOUTPUT") {
            var brDataDO = { Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, CH: msg.Ch, RepID: msg.ScaledValue, Type: msg.Type, UtcDateTime: msg.RegTime };
            $rootScope.$broadcast(msg.Type, { data: brDataDO });
        }

        //loop through _listenerArray
        for (var i = 0; i < listenerArray.length; i++) {

            if (listenerArray[i].Type == 'CURRENTSTATUSVIEW' && listenerArray[i].SN == msg.Sn) {
                if (listenerArray[i].Callback != null) listenerArray[i].Callback(msg);
            }

            if (listenerArray[i].Type == 'ALL' && listenerArray[i].SN == msg.Sn) {
                data = {
                    Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, CH: msg.Ch, RepID: msg.ScaledValue, Type: msg.Type
                };
                if (listenerArray[i].Callback != null) listenerArray[i].Callback(data);
            }

            if (listenerArray[i].Type == msg.Type && listenerArray[i].SN == msg.Sn && msg.Type == 'VOLCALC') {
                var data = { ComputeTime: msg.LocalTime, Pump: msg.Ch, Runtime: msg.Value, StartLevel: msg.ScaledValue, EndLevel: msg.Status, Gallons: msg.Field9, PumpGPM: msg.Field10, PrevComputeTime: msg.Field11, AvgFlow: msg.Field12
                };
                listenerArray[i].Callback(data);
            }

            if (listenerArray[i].Type == msg.Type && listenerArray[i].SN == msg.Sn && (msg.Type == "DIGITALINTERTIE" || msg.Type == "ANALOGINTERTIE")) {
                var data = {
                    Time: msg.LocalTime, InterconnectId: msg.Ch, SourceOnline: msg.Value, DestOnline: msg.ScaledValue, Status: msg.Status
                };
                listenerArray[i].Callback(data);
            }

            if (listenerArray[i].Type == msg.Type && listenerArray[i].SN == msg.Sn && msg.Type == 'KEY') {
                var data = {};
                data = { Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, CH: msg.Ch, RepID: msg.ScaledValue, Type: msg.Type
                };
                if (listenerArray[i].Callback != null) listenerArray[i].Callback(data);
            }
            if (listenerArray[i].Type == msg.Type && listenerArray[i].SN == msg.Sn && (msg.Type == 'DIGITALINPUT' || msg.Type == 'DIGITALOUTPUT')) {
                var data = {};
                data = { Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, CH: msg.Ch, RepID: msg.ScaledValue, Type: msg.Type
                };
                if (listenerArray[i].Callback != null) listenerArray[i].Callback(data);
            }
            if (listenerArray[i].Type == msg.Type && listenerArray[i].SN == (msg.Sn === null ? '' : msg.Sn)) {
                if (msg.Type == "PUMPRUNTIME" || msg.Type == "PUMPSTART") {
                    if (listenerArray[i].Callback != null) {
                        var tmpdata = {
                            Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, CH: msg.Ch, Type: msg.Type
                        };
                        listenerArray[i].Callback(tmpdata);
                    }
                }
            }

            if (listenerArray[i].Type == msg.Type && listenerArray[i].SN == (msg.Sn === null ? '' : msg.Sn) && listenerArray[i].Channel == (msg.Ch === null ? '' : msg.Ch)) {
                var data = {};
                if (msg.Type == "ANALOG") {
                    data = {
                        Time: msg.LocalTime, Value: msg.ScaledValue, SN: msg.Sn, CH: msg.Ch, UtcDateTime: msg.RegTime, RawValue: msg.Value, Type: msg.Type
                    };
                } else if (msg.Type == "INFO") {
                    data = {
                        Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, CH: msg.Ch, RepID: msg.Field10, Type: msg.Type
                    };
                } else if (msg.Type == "PULSE" || msg.Type == "DIGITALASPULSE") {
                    data = { //ScaledValue: msg.ScaledValue -> need to change
                        Time: msg.LocalTime, RawCount: msg.Value, SN: msg.Sn, CH: msg.Ch, ScaledValue: msg.ScaledValue, Delta: msg.Field9, Type: msg.Type, UtcDateTime: msg.RegTime
                    };
                }
                // else if (msg.Type == "DIGITALASPULSE") {
                //     data = {
                //         Time: msg.LocalTime, RawCount: msg.Value, SN: msg.Sn, CH: msg.Ch, ScaledValue: msg.ScaledValue, Delta: msg.Field9, Type: msg.Type
                //     };
                // }
                else if (msg.Type == "ANALOG_G2") {
                        data = {
                            Time: msg.LocalTime, Value: msg.ScaledValue, SN: msg.Sn, CH: msg.Ch, UtcDateTime: msg.RegTime, RawValue: msg.Value, Type: msg.Type
                        };
                    } else if (msg.Type == "CALLINSCOUNT") {
                        data = {
                            Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, UtcDateTime: msg.RegTime, Type: msg.Type
                        };
                    } else if (msg.Type == "LASTHEARDTIME") {
                        data = {
                            Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, UtcDateTime: msg.RegTime, Type: msg.Type
                        };
                    } else {
                        data = {
                            Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, CH: msg.Ch, RepID: msg.ScaledValue, Type: msg.Type, RegTime: msg.RegTime
                        };
                    }
                if (listenerArray[i].Callback != null) {
                    listenerArray[i].Callback(data);
                }
            }
        }

        if (_delay === false && $rootScope.messageIn === true) {
            _delay = true;
            $timeout(function () {
                $rootScope.messageIn = false;_delay = false;
            }, 6000);
        }
        //console.log(_getTimeStamp() + "\n\t" + " _processMsg() in and out in " + _getTimeSpan(_startDate) + " seconds");
    };

    var _processHeartbeatMsg = function _processHeartbeatMsg(message) {
        if (message.Type == 'HEARTBEAT') $rootScope.$broadcast('Heartbeat', { message: message });
        if (_siteResetInProgress) {
            $rootScope.$broadcast('processReconnect', { localDateTime: message.LocalDateTime });
            _processReconnect(message.LocalDateTime);
            if (!angular.isUndefined(_siteResetInProgressTimeout)) $timeout.cancel(_siteResetInProgressTimeout);
            _siteResetInProgress = false;
            console.log(_getTimeStamp() + "\n\t" + "Process reconnect!");
        }

        if (!$rootScope.online) {
            $rootScope.online = true;
            $rootScope.$broadcast('onOnlineStatus', { online: $rootScope.online });
        }
    };

    var _processEventMsg = function _processEventMsg(message) {
        // 20200716103431, 20200716063431, 725621DEMO, ANALOGOUTPUTSOURCE, 0, null, 1, null, null, null, null, null, E
        // 14395, 2020-07-16T10:46:03.4620082Z, 2020-07-16T06:46:03.433589, QA10133412, ANALOGOUTPUTSOURCE, 1, 228
        // Channel: 1
        // CustomerId: 14395
        // LocalTime: "2020-07-16T06:59:47.6186778"
        // NewSettingRaw: 219
        // PageTime: "2020-07-16T10:59:47.640428Z"
        // SerialNumber: "QA10133412"
        // Type: "ANALOGOUTPUTSOURCE" { Time: msg.LocalTime, Value: msg.Value, SN: msg.Sn, CH: msg.Ch, RepID: msg.ScaledValue, Type: msg.Type };
        //2020-07-16T07:30:13
        var strLt = message.LocalTime;
        var strPt = message.PageTime;
        var _localTime = strLt.substr(0, 4) + strLt.substr(5, 2) + strLt.substr(8, 2) + strLt.substr(11, 2) + strLt.substr(14, 2) + strLt.substr(17, 2);
        var _pageTime = strPt.substr(0, 4) + strPt.substr(5, 2) + strPt.substr(8, 2) + strPt.substr(11, 2) + strPt.substr(14, 2) + strPt.substr(17, 2);

        if (message.type == 'ANALOGOUTPUTSOURCE') {
            var _messageAO = {
                UtcDateTime: _pageTime, Time: _localTime, SN: message.SerialNumber, Type: message.Type, Value: message.NewSettingRaw, CH: message.Channel
            };

            $rootScope.$broadcast('WebSocketService', {
                message: _messageAO
            });
        } else {
            if (angular.isUndefined(message.Patch.value)) {
                message.Patch = $sanitize(message.Patch);
            } else {
                message.Patch.value = $sanitize(message.Patch.value);
            }

            var _message = {
                UtcDateTime: _pageTime, Time: _localTime, SN: message.SerialNumber, Type: message.Type, Value: message.Patch, CH: message.Channel, UserName: message.UserName, UniqueWebID: message.UniqueWebID
            };

            $rootScope.$broadcast('WebSocketService', {
                message: _message
            });
        }

        //loop through _listenerArray
        for (var i = 0; i < listenerArray.length; i++) {

            if (listenerArray[i].Type === _message.Type && listenerArray[i].SN === _message.SN && listenerArray[i].Channel == _message.CH) {
                listenerArray[i].Callback(_message);
            }
        }
    };

    var _processNewLiveStatusMsg = function _processNewLiveStatusMsg(message) {
        //{ServiceMode: 0, IsOffline: 0, IsDisabled: 0, HasAlarm: 0, Connection: "100"}
        var tmpMessage = angular.copy(message);
        tmpMessage.type = "S-O-D-A-C";
        $rootScope.$broadcast('WebSocketService', {
            message: tmpMessage
        });

        for (var i = 0; i < listenerArray.length; i++) {
            if (listenerArray[i].Type == "NEWLIVESTATUSMSG") {
                if (listenerArray[i].Callback != null) listenerArray[i].Callback(message);
            }
        }
    };

    var _processListDeviceStateMsg = function _processListDeviceStateMsg(message) {
        var tmpMessage = angular.copy(message);
        tmpMessage.type = "L-D-S";
        $rootScope.$broadcast('WebSocketService', {
            message: tmpMessage
        });

        for (var i = 0; i < listenerArray.length; i++) {
            if (listenerArray[i].Type == "LISTDEVICESTATEMSG") {
                if (listenerArray[i].Callback != null) listenerArray[i].Callback(message);
            }
        }
    };

    var _processReconnect = function _processReconnect(varLocalDateTime) {
        var tmpListenerArray = listenerArray.slice();
        listenerArray = []; //unregister all
        for (var i = 0; i < tmpListenerArray.length; i++) {
            var lsn = {
                Type: tmpListenerArray[i].Type, SN: tmpListenerArray[i].SN, Channel: tmpListenerArray[i].Channel, LocalDateTime: varLocalDateTime
            };
            if (tmpListenerArray[i].Reconnect !== null) tmpListenerArray[i].Reconnect(lsn);
        }
    };

    var _resetListenerArray = function _resetListenerArray() {
        listenerArray = [];
    };

    var _getWebsocketListenerCount = function _getWebsocketListenerCount() {
        return listenerArray.length;
    };

    var openTokenExpiredModal = function openTokenExpiredModal(message) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.popoverMessage = message;

            this.ok = function () {
                $uibModalInstance.close();
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/ok-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return translationService.translation;
                }
            }
        });
    };

    websocketFactory.connect = _connect;
    websocketFactory.close = _close;
    websocketFactory.register = _register;
    websocketFactory.unRegister = _unRegister;
    websocketFactory.resetSiteConnection = _resetSiteConnection;
    websocketFactory.resetListenerArray = _resetListenerArray;
    websocketFactory.getWebsocketListenerCount = _getWebsocketListenerCount;
    websocketFactory.startLiveStatus = _startLiveStatusDebounce;
    websocketFactory.stopLiveStatus = _stopLiveStatusDebounce;
    websocketFactory.startOverview = _startOverviewDebounce;
    websocketFactory.stopOverview = _stopOverviewDebounce;

    return websocketFactory;
}]);
//SCADA-5768: SignalR >> Fix empty claim being sent by JS client
//SCADA-5841: SignalR Client >> Add a delay when reconnecting to WebSocket
// * Improved the logic in websocket-services-es6.js ->
// * When disconnected after successfully connected, service will try to reconnect within 10 seconds (boot server working, we are deploying one of them. Or internet connection lost briefly)
// * Any time service tries to connect, if it fails, we will try reconnecting in 2 minutes
// * We now offer "Reset Connection" button. Once connection is lost and we try within 10 seconds to reconnect, if it fails, we will display "Reconnect Now" button on the popup below the message. Connection to the server is lost. Attempting to reconnect."
// * The button "Reconnect Now" has some logic which makes the button visible or hidden depending on if the service is in the process of restarting or not.
// * All logic for reestablishing web-socket connection is in websocket-services-es6.js. The old logic we had in "desktop-module.js" has been removed.
// * Added logic to check if �accountInfo� is NULL, and if it is then stop trying.This is complimentary to the logic Sindhu added a couple of months ago, and it should work better with recent changes.
mcapp.factory("userMessageService", ["authenticationService", function (authenticationService) {

    var userMessageFactory = {};
    
    _errorGeneral = "Error: please try again!";
    _errorDeviceId = "Error: invalid DeviceId!";
    _errorCustomerId = "Error: invalid CustomerId!";

    var _getUiErrorMessage = function (apiError) {
        if (apiError.indexOf("deviceId") >= 0)
            return _errorDeviceId;
        else if (apiError.indexOf("customerId") >= 0)
            return _errorCustomerId;
        else
            return _errorGeneral;
    };

    userMessageFactory.errorGeneral = _errorGeneral;
    userMessageFactory.errorDeviceId = _errorDeviceId;
    userMessageFactory.errorCustomerId = _errorCustomerId;
    userMessageFactory.getUiErrorMessage = _getUiErrorMessage;

    return userMessageFactory;
}]);
angular.module('mc.update-device-info', []);

function UpdateDeviceInfoFactory($rootScope, deviceMenuService, websocketService) { 

    // instantiate our initial object
    var UpdateDeviceInfo = function (customerId, deviceId, elementContainer, windowTitle, scope) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.windowTitle = windowTitle;
        this.elementContainer = elementContainer;
        this.device;
        this.getDeviceInfo(deviceId);
        scope.$on("$destroy", function () {
            _unRegisterListener();
        });
    };

    var wsDataReceivedDEVICEBASICINFO = function(data) {
        if (data.Type == 'DEVICEBASICINFO' && data.Value.path == "name") {
            var name = data.Value.value;

            //Update Device Menu
            deviceMenuService.resetDeviceMenuList();
            $rootScope.$broadcast('rtuBasicInfoUpdate');

            //Update title
            if (!$rootScope.mobile && !$rootScope.classicView) {
                this.elementContainer.dialog("option", "title", this.windowTitle + ", " + name);
            }
        }        
    };

    UpdateDeviceInfo.prototype.unRegisterListener = function () {
        websocketService.unRegister("DEVICEBASICINFO", this.device.serialNumber, 0, wsDataReceivedDEVICEBASICINFO, null);
    };

    var registerListener = function (serialNumber) {
        websocketService.connect();
        websocketService.register("DEVICEBASICINFO", serialNumber, 0, wsDataReceivedDEVICEBASICINFO, null);
    };

    UpdateDeviceInfo.prototype.getDeviceInfo = function (deviceId) {
        deviceMenuService.getDeviceMenuList(this.customerId)
        .then(function (datafromFactory) {
            var device = datafromFactory.data.devices.filter(function(dev){return dev.deviceId == deviceId});
            console.log(datafromFactory.data.devices)
            registerListener(device[0].serialNumber);
        }, function (error) {
            //error
        });
    };

    return UpdateDeviceInfo;
}

UpdateDeviceInfoFactory.$inject = ['$rootScope', 'deviceMenuService', 'websocketService'];

angular.module('mc.update-device-info').factory('UpdateDeviceInfoFactory', UpdateDeviceInfoFactory);
"use strict";

mcapp.factory("unsavedChangesService", ["modalService", function (modalService) {

  var unsavedChangesFactory = {};

  var _checkUnsavedChanges = function _checkUnsavedChanges(event, popup, _this, hasNewRecord) {
    if (hasNewRecord && !_this.canClose) {
      event.preventDefault();
      return modalService.navigateAway("EXIT_WITHOUT_SAVE").then(function () {
        _this.canClose = true;
        $(popup).dialog('close');
      }, function () {
        // Do nothing!
      });
    } else {
      return true;
    }
  };

  unsavedChangesFactory.checkUnsavedChanges = _checkUnsavedChanges;

  return unsavedChangesFactory;
}]);
angular.module("mc.ui-error-counter", []);
function UiErrorCounterService() {

    var uiErrorCounter = 0;

    return {
        incrementCounter: incrementCounter,
        getCounter: getCounter,
        resetCounter: resetCounter
    };

    function incrementCounter() {
        uiErrorCounter++;
    }

    function getCounter() {
        return uiErrorCounter;
    }

    function resetCounter() {
        uiErrorCounter = 0;
    }
}

UiErrorCounterService.$inject = [];

angular.module('mc.ui-error-counter').service('uiErrorCounterService', UiErrorCounterService);

mcapp.factory('translationService', ["$resource", "$http", "$q", "$rootScope", "authenticationService", "preferencesService", "highchartsOptionsService", "HOST"
, function ($resource, $http, $q, $rootScope, authenticationService, preferencesService, highchartsOptionsService, HOST) {
    var translationFactory = {};
    var _translation = {};
    var _userLanguage = undefined;

        var _loadLanguage = function (flag) {

        var deferred = $q.defer();
        var userlanguage = "en"; //default language
        var accountInfo = authenticationService.getAccountInfo();
        var mobile = $rootScope.mobile;

        if (typeof accountInfo !== 'undefined' && accountInfo !== null && accountInfo.preferenceUser.i18nCode !== null && accountInfo.preferenceUser.i18nCode !== "")
            userlanguage = accountInfo.preferenceUser.i18nCode;

        highchartsOptionsService.setHighchartsOptions(userlanguage, mobile);

        if (flag == null && (Object.keys(translationFactory).length > 0 && _userLanguage === userlanguage)) {
            //Language files remain the same, no need to read them again
            return translationFactory;
        }
        _userLanguage = userlanguage;

        var messageFileName = "messages-translation-" + userlanguage + ".json";
        var messageFilePath = 'translations/' + messageFileName;

        $http({
            method: 'GET',
            url: HOST + '/api/Translations?language=' + _userLanguage
        }).then(function (textResult) {
            _translation.text = textResult.data;
            translationFactory.translation = _translation;
            $resource(messageFilePath).get(function (messageResult) {
                _translation.message = messageResult;
                translationFactory.translation = _translation;
                deferred.resolve(translationFactory.data);
            },
                function (error) {
                    deferred.reject(error);
                });
        },
            function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    translationFactory.loadLanguage = _loadLanguage;
    return translationFactory;

}]);
mcapp.factory("timeLapseService", ["$interval", "$http", "authenticationService", "datetimeService", "HOST", "$window", "$timeout", "$rootScope", "sharedSetupService", function ($interval, $http, authenticationService, datetimeService, HOST, $window, $timeout, $rootScope, sharedSetupService) {
    var timeLapseFactory = {};
    var tl;
    var listenerArray = [];
    var localListenerArray = [];
    var _timeLapseInterval = 60000; //15000 = 15 seconds 
    var _timeLapseIntervalCount = 0;
    var _start;

    var _oneDayMs = 1000 * 60 * 60 * 24;
    var _minutesInDay = _oneDayMs / 1000 / 60; // equivalent to 1440
    var _heartBeat = true;
    var _heartBeatInterval = 1;

    var isNoU = sharedSetupService.isNullOrUndefined;

    var _checkStart = function () {
        // Don't start if already started
        if (angular.isDefined(_start)) return;
        _start = $interval(function () {
            _connect();
        }, _timeLapseInterval);
    };

    var _stop = function () {
        if (angular.isDefined(_start)) {
            $interval.cancel(_start);
            _start = undefined;
        }
    };

    _checkStart();

    var _connect = function () {
        var accountInfo = authenticationService.getAccountInfo();
        if (accountInfo === null)
            return;

        _timeLapseIntervalCount++;

        _adjustHeartBeat();
        
        _heartBeat = (_timeLapseIntervalCount == 1 || _timeLapseIntervalCount % _heartBeatInterval == 0) ? true : false;

        $http({ method: 'GET', url: HOST + '/api/CurrentTime?customerID=' + accountInfo.customerId + '&timeZone=' + accountInfo.timeZone + '&heartBeat=' + _heartBeat, cache: false }).then(function (result) {
            _broadcastMessage(result.data.unixTimeStamp, result.data.utcUnixTimeStamp);
            _broadcastLocal(result.data.localDateTime);
        },
            function (error) {
                if (!isNoU(error) && !isNoU(error.data) && !isNoU(error.data.message) && error.data.message === "SYSTEM_LOG_OUT")
                    throw new Error(error.data.message);
            });
    };

    var _register = function (type, sn, channel, callback, interval) {
        var _interval = (interval % 1 === 0) ? interval === 1 ? 1 : (interval % 4 === 0 ? interval / 4 : Math.floor(interval / 4) + 1) : 1;
        // add to _listenerArray
        var lsn = { Type: type, SN: sn, Channel: channel, Callback: callback, interval: _interval };

        var inArray = false;

        for (var i = 0; i < listenerArray.length; i++) {
            if (listenerArray[i].Type == type && listenerArray[i].SN == sn && listenerArray[i].Channel == channel && listenerArray[i].Callback == callback && listenerArray[i].interval == _interval) {
                //remove from array
                inArray = true;
            }
        }

        if ((listenerArray.indexOf(lsn) == - 1) && !inArray) {
            listenerArray.push(lsn);
            //console.log("--> added: " + type + " | " + sn + " | " + channel + " | " + "callbackFunction");
        }
        _checkStart();
    };

    var _registerLocal = function (type, sn, channel, callback, interval) {
        var _interval = (interval % 1 === 0) ? interval === 1 ? 1 : (interval % 4 === 0 ? interval / 4 : Math.floor(interval / 4) + 1) : 1;
        // add to _listenerArray
        var lsn = { Type: type, SN: sn, Channel: channel, Callback: callback, interval: _interval };
        if (localListenerArray.indexOf(lsn) == -1) {
            localListenerArray.push(lsn);
            //console.log("--> added: " + type + " | " + sn + " | " + channel + " | " + "callbackFunction");
        }
        _checkStart();
    };

    var _unRegister = function (type, sn, channel, callback) {
        //loop through _listenerArray
        for (var i = 0; i < listenerArray.length; i++) {
            if (listenerArray[i].Type == type && listenerArray[i].SN == sn && listenerArray[i].Channel == channel && listenerArray[i].Callback == callback) {
                //remove from array
                listenerArray.splice(i, 1);
                //console.log("--> removed: " + type + " | " + sn + " | " + channel + " | " + "callbackFunction");
            }
        }
        if (listenerArray.length <= 0)
            _stop();
    };

    var _unRegisterLocal = function (type, sn, channel, callback) {
        //loop through _listenerArray
        for (var i = 0; i < localListenerArray.length; i++) {
            if (localListenerArray[i].Type == type && localListenerArray[i].SN == sn && localListenerArray[i].Channel == channel && localListenerArray[i].Callback == callback) {
                //remove from array
                localListenerArray.splice(i, 1);
                //console.log("--> removed: " + type + " | " + sn + " | " + channel + " | " + "callbackFunction");
            }
        }
        if (localListenerArray.length <= 0)
            _stop();
    };

    var _broadcastMessage = function (unixstamp, utcUnixstamp) {
        //loop through _listenerArray
        for (var i = 0; i < listenerArray.length; i++) {
            var data = { Unix: unixstamp, Value: null, SN: listenerArray[i].SN, CH: listenerArray[i].Channel, UtcUnix: utcUnixstamp };
            if (_timeLapseIntervalCount % listenerArray[i].interval == 0)
                listenerArray[i].Callback(data);
        }
    };

    var _broadcastLocal = function (unixstamp) {
        //loop through _listenerArray
        for (var i = 0; i < localListenerArray.length; i++) {
            var data = { localDateTime: unixstamp, Value: null, SN: localListenerArray[i].SN, CH: localListenerArray[i].Channel };
            if (_timeLapseIntervalCount % localListenerArray[i].interval == 0)
                localListenerArray[i].Callback(data);
        }
    };

    var _getLocalDateTime = function () {
        var accountInfo = authenticationService.getAccountInfo();
        return $http({ method: 'GET', url: HOST + '/api/CurrentTime?customerID=' + accountInfo.customerId + '&timeZone=' + accountInfo.timeZone, cache: false });
    };

    var _adjustHeartBeat = function () {
        
        var hasRunOnce = _timeLapseIntervalCount === 1;
        var hasPassedOneDay = _timeLapseIntervalCount > _minutesInDay;

        if (hasRunOnce) {
            _heartBeatInterval = 1;
            return;
        }

        if (hasPassedOneDay) {
            _heartBeatInterval = 4;
            return;
        }

        _heartBeatInterval = 2;
    };

    timeLapseFactory.register = _register;
    timeLapseFactory.registerLocal = _registerLocal;
    timeLapseFactory.unRegister = _unRegister;
    timeLapseFactory.unRegisterLocal = _unRegisterLocal;
    timeLapseFactory.getLocalDateTime = _getLocalDateTime;
    timeLapseFactory.stop = _stop;

    return timeLapseFactory;
}
]);
mcapp.factory('textToSpeechService', ["$rootScope", "authenticationService", function ($rootScope, authenticationService) {

    var accountInfo, voice, voiceVolume, voiceRate, voicePitch, voiceLanguageCode, voiceLanguageDescription;
    var _overwriteVoiceIfNeededStatus = false;
    var _voices = [];

    function _getVoices() {

        if (_voices.length > 0) return _voices;

        var _windowVoices;        
        var _ch = "_";

        _windowVoices = window.speechSynthesis.getVoices();

        // Android returns (perhaps some other browsers too) 
        // 0: SpeechSynthesisVoice { voiceURI: "German Germany", name: "German Germany", lang: "de_DE", localService: true, default: true }
        // 1: SpeechSynthesisVoice { voiceURI: "English United Kingdom", name: "English United Kingdom", lang: "en_GB", localService: true, default: false }
        // 2: SpeechSynthesisVoice { voiceURI: "English United States", name: "English United States", lang: "en_US", localService: true, default: false }
        // 3: SpeechSynthesisVoice { voiceURI: "Spanish Spain", name: "Spanish Spain", lang: "es_ES", localService: true, default: false }
        // 4: SpeechSynthesisVoice { voiceURI: "French France", name: "French France", lang: "fr_FR", localService: true, default: false }
        // 5: SpeechSynthesisVoice { voiceURI: "Italian Italy", name: "Italian Italy", lang: "it_IT", localService: true, default: false }
        // 6: SpeechSynthesisVoice { voiceURI: "Russian Russia", name: "Russian Russia", lang: "ru_RU", localService: true, default: false }

        if (_windowVoices.length > 0) {
            for (var i = 0; i < _windowVoices.length; i++) {
                
                
                if (_windowVoices[i].lang.indexOf(_ch) < 0) {
                    _voices = _windowVoices;
                    break;
                }

                var updateLang = { default: _windowVoices[i].false, lang: _windowVoices[i].lang, localService: _windowVoices[i].localService, name: _windowVoices[i].name, voiceURI: _windowVoices[i].voiceURI };
                updateLang.lang = (updateLang.lang).replace(_ch, "-");
                _voices.push(updateLang);
            }
        }

        return _voices;
    }

    function _getSpeechSynthesisUtterance() {
        var _msg = null;

        if (window.speechSynthesis) {
            _msg = new SpeechSynthesisUtterance();

            var voices = _getVoices();

            if(!_overwriteVoiceIfNeededStatus) _overwriteVoiceIfNeeded(voices);

            //get settings /or/ use default setting if unavailable
            _msg.voice = voices[voice || 0];
            _msg.volume = voiceVolume || 1;
            _msg.rate = voiceRate     || 1;
            _msg.pitch = voicePitch   || 1;
        }

        return _msg;
    }

    function _overwriteVoiceIfNeeded(voices) {

        _getVoicePreferences(); //get voice preferences

        var _match = false;

        //Match voice Language Code & Name 
        for (i = 0; i < voices.length; i++) {
            if (voices[i].lang == voiceLanguageCode && voices[i].name == voiceLanguageDescription) {
                voice = voice == i ? voice : i;
                _match = true;
                break;
            }
        } 
        //If needed match voice Language Code only
        if (!_match) {
            for (i = 0; i < voices.length; i++) {
                if (voices[i].lang == voiceLanguageCode) {
                    voice = voice == i ? voice : i;
                    _match = true;
                    break;
                }
            }
        }
        //If needed set default to "en-US"
        if (!_match) {
            for (i = 0; i < voices.length; i++) {
                if (voices[i].lang == "en-US") {
                    voice = voice == i ? voice : i;
                    _match = true;
                    break;
                }
            }
        }
        _overwriteVoiceIfNeededStatus = true;
    }

    function _speak(text, config) {

        if ($rootScope.mobileApp) {
            TTS.speak({
                text: text,
                locale: 'en-US',
                    rate: 1.5
                }).then(function () {
                    //
                }, function (reason) {
                    //
                });
            return;
        }

        var msg = _getSpeechSynthesisUtterance();
        if (!msg) return; // if browser is not capable of SpeechSynthesis then return

        //message for speech
        msg.text = text;

        window.speechSynthesis.speak(msg);
    }

    function _getVoicePreferences(){
        accountInfo = authenticationService.getAccountInfo();
        voice = accountInfo.preferenceUser.voice;
        voiceVolume = accountInfo.preferenceUser.voiceVolume;
        voiceRate = accountInfo.preferenceUser.voiceRate;
        voicePitch = accountInfo.preferenceUser.voicePitch;
        voiceLanguageCode = accountInfo.preferenceUser.voiceLanguageCode;
        voiceLanguageDescription = accountInfo.preferenceUser.voiceLanguageDescription;
    }

    function _updateUserVoice() {
        _overwriteVoiceIfNeededStatus = false;
    }

    return {
        speak: _speak,
        getVoices: _getVoices,
        isCapable: (!!window.speechSynthesis),
        updateUserVoice: _updateUserVoice

    };
}]);
//Keyboard support to move a gauge widget's dialog without the mouse:
//Tab to focus, Space/Enter to pick up / drop, arrow keys to move (Shift+arrow moves further), Escape to drop.
//Usage from any gauge widget component (cleanup on $destroy is handled here):
//    tabButtonGaugeService.register($scope, $element);
//Usage from a gauge list, as the keyboard alternative to dragging a gauge out:
//    tabButtonGaugeService.registerList($scope, $element, '.upWidget', ($gauge) => openGaugeWidget($gauge, left, top));
mcapp.factory("tabButtonGaugeService", ['$rootScope', '$timeout', 'sharedSetupService', function ($rootScope, $timeout, sharedSetupService) {

    //Checks if the key is Tab and prevents the event from travelling farther through the DOM event propagation path
    var releaseTab = function (event) {
        if (event.key === 'Tab') event.stopPropagation();
    };

    //Tracks how many widgets have enabled keyboard movement
    var enabledCount = 0;
    var releasedViews = [];

    var onDocumentTab = function (event) {
        if (event.key !== 'Tab') return;
        var view = $(event.target).closest('.ui-dialog');
        if (view.length === 0 || view.data('mcTabReleased')) return;
        //closed widgets are only hidden, so count the visible ones
        if ($('.ui-dialog[aria-roledescription="movable widget"]:visible').length === 0) return;
        view.data('mcTabReleased', true);
        view.children().each(function () {
            this.addEventListener('keydown', releaseTab);
        });
        releasedViews.push(view);
    };

    var installViewTabRelease = function () {
        //capture phase runs before the event reaches the view, so the listeners added here still apply to this Tab
        if (enabledCount++ === 0) document.addEventListener('keydown', onDocumentTab, true);
    };

    var uninstallViewTabRelease = function () {
        if (--enabledCount > 0) return;
        document.removeEventListener('keydown', onDocumentTab, true);
        releasedViews.forEach(function (view) {
            view.removeData('mcTabReleased');
            view.children().each(function () {
                this.removeEventListener('keydown', releaseTab);
            });
        });
        releasedViews = [];
    };

    //checks two application settings $rootScope.mobile & $rootScope.classicView if either is true, keyboard movement is not enabled
    var enable = function (element) {
        if ($rootScope.mobile || $rootScope.classicView) return angular.noop;
        var dialogWidget = $(element).closest('.ui-dialog');
        if (dialogWidget.length === 0) return angular.noop;

        //Wire a dialog once: a second enable on the same dialog would stack another set of handlers,
        //each with its own isSelected, and one arrow press would move the widget once per handler
        //Preventing duplicate keyboard handlers
        if (dialogWidget.data('mcKeyboardMove')) return angular.noop;
        dialogWidget.data('mcKeyboardMove', true);
        installViewTabRelease();

        var dialogElement = dialogWidget[0];
        var dialogContent = dialogWidget.find('.ui-dialog-content').first();
        var dialogChildren = dialogWidget.children();
        var isSelected = false;
        var step = 10, largeStep = 50;

        var setFocusStyle = function (focused) {
            dialogElement.style.outline = focused ? (isSelected ? '3px dashed #0056b3' : '2px solid #0056b3') : '';
            dialogElement.style.outlineOffset = focused ? '2px' : '';
        };

        var setSelected = function (selected) {
            isSelected = selected;
            dialogElement.setAttribute('aria-pressed', selected ? 'true' : 'false');
            dialogWidget.css('opacity', selected ? '.70' : '1');
            setFocusStyle(true);
            //keep the position the same way a mouse drag does
            if (!selected) sharedSetupService.adjustPopupTopPosition(dialogContent);
        };

        var onFocus = function (event) {
            if (event.target === dialogElement) setFocusStyle(true);
        };

        var onBlur = function (event) {
            if (event.target !== dialogElement) return;
            if (isSelected) setSelected(false);
            setFocusStyle(false);
        };

        var onKeydown = function (event) {
            //only when the widget itself has focus, not its inner controls
            if (event.target !== dialogElement) return;
            var key = event.key;

            if (key === 'Tab') {
                //same as releaseTab, for when the widget itself has focus
                event.stopImmediatePropagation();
                return;
            }

            if (key === ' ' || key === 'Spacebar' || key === 'Enter') {
                event.preventDefault();
                setSelected(!isSelected);
                if (isSelected) dialogContent.dialog('moveToTop');
                dialogElement.focus();
                return;
            }
            if (!isSelected) return;

            if (key === 'Escape' || key === 'Esc') {
                event.preventDefault();
                setSelected(false);
                return;
            }

            var dx = 0, dy = 0, distance = event.shiftKey ? largeStep : step;
            if (key === 'ArrowLeft' || key === 'Left') dx = -distance;
            else if (key === 'ArrowRight' || key === 'Right') dx = distance;
            else if (key === 'ArrowUp' || key === 'Up') dy = -distance;
            else if (key === 'ArrowDown' || key === 'Down') dy = distance;
            else return;
            event.preventDefault();

            var offset = dialogWidget.offset();
            var scrollLeft = $(document).scrollLeft(), scrollTop = $(document).scrollTop();
            var maxLeft = Math.max(0, $(window).width() - dialogWidget.outerWidth());
            var maxTop = Math.max(0, $(window).height() - dialogWidget.outerHeight());
            var left = Math.min(maxLeft, Math.max(0, offset.left - scrollLeft + dx));
            var top = Math.min(maxTop, Math.max(0, offset.top - scrollTop + dy));

            //update the dialog position option, same as jQuery UI does at the end of a mouse drag
            dialogContent.dialog('option', 'position', { my: 'left+' + Math.round(left) + ' top+' + Math.round(top), at: 'left top', of: window });
        };

        //remember what the dialog had before, so disable can put it back
        var addedAttributes = ['tabindex', 'aria-roledescription', 'aria-pressed', 'title'];
        var originalAttributes = {};
        addedAttributes.forEach(function (name) {
            originalAttributes[name] = dialogElement.getAttribute(name);
        });

        dialogElement.setAttribute('tabindex', '0');
        dialogElement.setAttribute('aria-roledescription', 'movable widget');
        dialogElement.setAttribute('aria-pressed', 'false');
        dialogElement.setAttribute('title', 'Press Space or Enter to select, then use the arrow keys to move');

        dialogElement.addEventListener('focus', onFocus);
        dialogElement.addEventListener('blur', onBlur);

        //jQuery UI dialog wraps Tab back to its first element even when not modal, which traps focus in the first widget.
        //Stop Tab before it reaches the dialog's own keydown handler so the browser moves focus on to the next widget.
        dialogChildren.each(function () {
            this.addEventListener('keydown', releaseTab);
        });

        //capture phase so Escape is handled before jQuery UI dialog's closeOnEscape
        dialogElement.addEventListener('keydown', onKeydown, true);

        //opened from a list with the keyboard: focus the new widget and pick it up, so the arrow keys move it right away
        //(Space/Enter or Escape drops it, same as when it is picked up by hand)
        if (Date.now() < focusNextWidgetUntil) {
            focusNextWidgetUntil = 0;
            dialogElement.focus();
            setSelected(true);
            dialogContent.dialog('moveToTop');
            dialogElement.focus();
        }

        var disabled = false;
        return function disable() {
            if (disabled) return;
            disabled = true;

            dialogElement.removeEventListener('focus', onFocus);
            dialogElement.removeEventListener('blur', onBlur);
            dialogElement.removeEventListener('keydown', onKeydown, true);
            dialogChildren.each(function () {
                this.removeEventListener('keydown', releaseTab);
            });

            addedAttributes.forEach(function (name) {
                if (originalAttributes[name] === null) dialogElement.removeAttribute(name);
                else dialogElement.setAttribute(name, originalAttributes[name]);
            });
            setFocusStyle(false);
            if (isSelected) dialogWidget.css('opacity', '1');

            dialogWidget.removeData('mcKeyboardMove');
            uninstallViewTabRelease();
        };
    };

    //scope: the widget component's $scope, everything is undone when it is destroyed
    //element: the widget component's $element
    var register = function (scope, element) {
        var disable = angular.noop;
        //the dialog wrapping the widget is created by openViewService, wait for it to be in the DOM
        var enableTimer = $timeout(function () { disable = enable(element); }, 0, false);

        scope.$on('$destroy', function () {
            $timeout.cancel(enableTimer);
            disable();
        });
    };

    //The widget opened from a list is enabled only after its data has loaded, so remember (for a short while)
    //that the next widget enabled should take focus.
    var focusNextWidgetUntil = 0;
    var focusNextWidgetTimeout = 10000;

    //Status icon (bell) on a gauge. What hovering it shows depends on the gauge state:
    // - in alarm (rtuAlarm class on the gauge): the alarm tooltip from ng-mouseenter="$ctrl.pwMouseEnter($event)"
    // - otherwise: the browser's native tooltip from its SVG <title> (All Normal, Communication Failure, Service Mode),
    //   which browsers never show on keyboard focus, so it is shown here in a jQuery UI tooltip instead
    var alarmIconSelector = '.iconCircleRight';
    var alarmItemClass = 'rtuAlarm';
    var alarmIconMarker = 'data-mc-tab-alarm';

    //Same events a real mouse fires, so the existing hover handlers (ng-mouseenter / ng-mouseleave) run unchanged
    var dispatchHover = function (target, type) {
        target.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window, relatedTarget: null }));
    };

    //Shared by registerList and registerAlarmIcon: what the status icon does on focus, blur and Enter/Space
    var closeIconTooltip = function (icon) {
        if ($(icon).is(':ui-tooltip')) {
            $(icon).tooltip('close');
            $(icon).tooltip('destroy');
        }
        $(".loading-need-to-remove").remove();
    };

    //isInAlarm: the gauge has the rtuAlarm class
    var showIconFocus = function (icon, isInAlarm) {
        icon.style.outline = '2px solid #0056b3';

        if (isInAlarm) {
            //in alarm: same as hovering, the gauge's own handler opens the alarm tooltip
            dispatchHover(icon, 'mouseover');
            return;
        }

        //not in alarm: show the text of its SVG <title>, the same text hovering shows
        var text = $.trim($(icon).children('title').text());
        if (!text) return;
        $(icon).tooltip({
            items: icon,
            content: $('<div>').text(text).html(),
            position: { my: 'left top+20', at: 'left bottom', collision: 'flip flip' },
            tooltipClass: 'panel panel-default overview-tooltipborder'
        }).tooltip('open');
    };

    var hideIconFocus = function (icon) {
        icon.style.outline = '';
        //same as leaving with the mouse (closes the alarm tooltip), then close whatever is still open,
        //e.g. the state changed while the icon had focus
        dispatchHover(icon, 'mouseout');
        closeIconTooltip(icon);
    };

    //Clicking the icon opens another view (ng-click="$ctrl.openView()"): Enter/Space sends the same click
    var clickIconOnKey = function (event, icon) {
        if (event.key !== ' ' && event.key !== 'Spacebar' && event.key !== 'Enter') return;
        event.preventDefault();
        event.stopPropagation();
        closeIconTooltip(icon);
        icon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    };

    //Keyboard alternative to dragging a gauge out of a list: Tab to a gauge, Space/Enter calls onSelect($item).
    //While a gauge is in alarm its bell is a Tab stop too, and focusing it shows the same tooltip as hovering it.
    //scope: the list component's $scope, the handlers are removed when it is destroyed
    //element: the list component's $element
    //itemSelector: the gauge elements inside it (made focusable here when their template does not do it)
    var registerList = function (scope, element, itemSelector, onSelect) {
        var onItemKeydown = function (event) {
            if ($rootScope.mobile || $rootScope.classicView) return;
            //only when the gauge itself has focus, not its inner controls
            if (event.target !== event.currentTarget) return;
            if (event.key !== ' ' && event.key !== 'Spacebar' && event.key !== 'Enter') return;
            event.preventDefault();
            focusNextWidgetUntil = Date.now() + focusNextWidgetTimeout;
            scope.$applyAsync(function () { onSelect($(event.currentTarget)); });
        };

        $(element).on('keydown', itemSelector, onItemKeydown);

        //Make the gauges Tab stops when their template does not already do it.
        //They are rendered later by ng-repeat (after the data loads), so watch the list for new ones.
        var makeItemsFocusable = function () {
            $(element).find(itemSelector).each(function () {
                if (this.hasAttribute('tabindex')) return;
                this.setAttribute('tabindex', '0');
                this.setAttribute('role', 'button');
                this.setAttribute('aria-label', 'Press Enter to open as widget');
            });
        };

        //Status icon is a Tab stop on every gauge: each state shows something on hover
        var updateAlarmIcons = function () {
            $(element).find(itemSelector).find(alarmIconSelector).each(function () {
                if (this.hasAttribute('tabindex')) return;
                this.setAttribute('tabindex', '0');
                this.setAttribute('aria-label', 'Status details');
                this.setAttribute(alarmIconMarker, 'true');
            });
        };

        var onAlarmIconFocus = function () {
            if (!this.hasAttribute(alarmIconMarker)) return;
            showIconFocus(this, $(this).closest(itemSelector).hasClass(alarmItemClass));
        };
        var onAlarmIconBlur = function () {
            if (!this.hasAttribute(alarmIconMarker)) return;
            hideIconFocus(this);
        };
        var onAlarmIconKeydown = function (event) {
            if (!this.hasAttribute(alarmIconMarker)) return;
            clickIconOnKey(event, this);
        };

        $(element).on('focusin', alarmIconSelector, onAlarmIconFocus);
        $(element).on('focusout', alarmIconSelector, onAlarmIconBlur);
        $(element).on('keydown', alarmIconSelector, onAlarmIconKeydown);

        makeItemsFocusable();
        updateAlarmIcons();
        //live data keeps changing the gauges, so check at most once per frame
        var frameRequested = false;
        var observer = new MutationObserver(function () {
            if (frameRequested) return;
            frameRequested = true;
            window.requestAnimationFrame(function () {
                frameRequested = false;
                makeItemsFocusable();
                updateAlarmIcons();
            });
        });
        observer.observe($(element)[0], { childList: true, subtree: true });

        scope.$on('$destroy', function () {
            $(element).off('keydown', itemSelector, onItemKeydown);
            $(element).off('focusin', alarmIconSelector, onAlarmIconFocus);
            $(element).off('focusout', alarmIconSelector, onAlarmIconBlur);
            $(element).off('keydown', alarmIconSelector, onAlarmIconKeydown);
            observer.disconnect();
        });
    };

    //Status icon (bell) on a single gauge widget, e.g. one dragged out of a list: Tab to the bell shows the same
    //tooltip as hovering it, Enter/Space opens the same view as clicking it (same behavior registerList gives the list).
    //scope: the widget component's $scope, the handlers are removed when it is destroyed
    //element: the widget component's $element
    //afterSelector (optional): the element the bell should follow in the Tab order (e.g. '.gaugeDataBox').
    //  The bell comes before it in the page, so the browser would reach the bell first: while that element is a
    //  Tab stop, the bell is left out of the natural order and Tab / Shift+Tab are moved here instead.
    var registerAlarmIcon = function (scope, element, afterSelector) {
        if ($rootScope.mobile || $rootScope.classicView) return;
        var root = $(element)[0];
        if (!root) return;

        var getIcon = function () {
            return $(root).find(alarmIconSelector)[0] || null;
        };

        //the element the bell follows, only while it is a Tab stop (in edit mode the HUD box is not)
        var getAfterElement = function () {
            if (!afterSelector) return null;
            var after = $(root).find(afterSelector)[0];
            if (!after || !after.hasAttribute('tabindex') || after.getAttribute('tabindex') === '-1') return null;
            return after;
        };

        var prepareIcon = function (icon) {
            if (!icon) return;
            var tabindex = getAfterElement() ? '-1' : '0';
            if (icon.getAttribute('tabindex') !== tabindex) icon.setAttribute('tabindex', tabindex);
            if (icon.hasAttribute(alarmIconMarker)) return;
            icon.setAttribute('aria-label', 'Status details');
            icon.setAttribute(alarmIconMarker, 'true');
        };

        var onAlarmIconFocus = function () {
            if (!this.hasAttribute(alarmIconMarker)) return;
            showIconFocus(this, $(this).closest('.' + alarmItemClass).length > 0);
        };
        var onAlarmIconBlur = function () {
            if (!this.hasAttribute(alarmIconMarker)) return;
            hideIconFocus(this);
        };

        //Capture phase on the widget: runs before the HUD box's own handlers and before anything above the widget
        //(e.g. the dialog) can stop or wrap the Tab
        var onKeydownCapture = function (event) {
            var icon = getIcon();
            if (!icon) return;

            if (event.key === 'Tab') {
                var after = getAfterElement();
                if (!after) return;
                if (event.target === after && !event.shiftKey) {
                    //Tab on the HUD box: go to the bell
                    prepareIcon(icon);
                    event.preventDefault();
                    icon.focus();
                } else if (event.target === icon && event.shiftKey) {
                    //Shift+Tab on the bell: back to the HUD box
                    event.preventDefault();
                    after.focus();
                } else if (event.target === icon) {
                    //Tab on the bell: go to whatever comes after the HUD box. The HUD box is not focused on the way,
                    //its focus handler would open the HUD info (same as hovering) and leave it open on this gauge.
                    var tabbables = $(':tabbable').not(icon);
                    var next = tabbables.get(tabbables.index(after) + 1);
                    if (next) {
                        event.preventDefault();
                        next.focus();
                    }
                }
                return;
            }

            //Clicking the icon opens another view (ng-click="$ctrl.openView()"): Enter/Space sends the same click
            if (event.target !== icon || !icon.hasAttribute(alarmIconMarker)) return;
            if (event.key !== ' ' && event.key !== 'Spacebar' && event.key !== 'Enter') return;
            event.preventDefault();
            event.stopPropagation();
            closeIconTooltip(icon);
            icon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        };

        root.addEventListener('keydown', onKeydownCapture, true);
        $(root).on('focusin', alarmIconSelector, onAlarmIconFocus);
        $(root).on('focusout', alarmIconSelector, onAlarmIconBlur);

        //the bell is inside the gauge template (ng-include), which renders later; the HUD box stops being a Tab stop
        //in edit mode, then the bell is a normal Tab stop again
        var frameRequested = false;
        var observer = new MutationObserver(function () {
            if (frameRequested) return;
            frameRequested = true;
            window.requestAnimationFrame(function () {
                frameRequested = false;
                prepareIcon(getIcon());
            });
        });
        observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['tabindex'] });
        prepareIcon(getIcon());

        scope.$on('$destroy', function () {
            root.removeEventListener('keydown', onKeydownCapture, true);
            $(root).off('focusin', alarmIconSelector, onAlarmIconFocus);
            $(root).off('focusout', alarmIconSelector, onAlarmIconBlur);
            observer.disconnect();
        });
    };

    return {
        register: register,
        registerList: registerList,
        registerAlarmIcon: registerAlarmIcon
    };
}]);

mcapp.factory("sharedSetupService", ['$rootScope', '$cookies', 'authenticationService', '$timeout', '$location', '$filter', '$window', 'datetimeService', 'translationService', 'toaster', function ($rootScope, $cookies, authenticationService, $timeout, $location, $filter, $window, datetimeService, translationService, toaster) {
    var sharedSetupFactory = {};
    
    _accountInfo = authenticationService.getAccountInfo();
    _translation = translationService.translation;
    _isFromUpdatePassword = false;
    _currentUrl = "";

    _unixDay = 86400000; // one day
    _liveDataOffset = 2 * 3600 * 1000; //two hours
    _liveDataOffsetAdj = 10; // 10px
    _minPadding = 2 * 60 * 1000; //two minutes
    _maxPadding = 2 * 60 * 1000; //two minutes
    _pagingViewHeightAdjustment = 80; //35 per tab
    _stickyPropertiesInterface = {
        on: null,
        deviceId: null,
        analogIntertieId: null,
        dateMin: null,
        dateMax: null,
        zoomMin: null,
        zoomMax: null,
        channel: null,
        dataFormat: null,
        runtimeType: null,
        device: {
            deviceId: null,
            deviceName: null,
            channel: null,
            serialNumber: null
        },
        view: {
            type: null,
            expanded: null
        },
        liveData: false,
        downloadOptions: {
            reportType: null,
            resolution: null,
            rainfall: {
                metarStationId: null
            }
        },
        chartRecorderZoom: null,
        adminPortal: {
            customerId: null,
            customerName: null
        },
        mapPushpin: {
            id: -1,
            customerId: null,
            latitude: null,
            longitude: null
        },
        setting: null
    };

    // used to raise the popup message to save the data when tab lose focus
    var  _checkUnsavedChanges = false;
    var _tabPopupWarningOn = false;

    var _mouseWheelZoom = function (event, chart, value, scrollingSpeed) {
        if (value === null || isNaN(value) || typeof value == "undefined")
            return;
        var speedFactor = typeof scrollingSpeed !== 'undefined' ? scrollingSpeed : 1;
        var extremes = chart.xAxis[0].getExtremes();
        var zoomParameter = (extremes.max - extremes.min) / 86400000 * 6000000;
        zoomParameter = speedFactor * zoomParameter;
        var zoomParameterMax = 1000 * 1000000;
        if (speedFactor == 1) {
            zoomParameter = zoomParameter < zoomParameterMax ? zoomParameter : zoomParameterMax;
        }
        var zoomMin = extremes.min + event.deltaY * zoomParameter;
        var tmpZoomMax = ((value - zoomMin) * (extremes.max - value) / (value - extremes.min)) + value;
        var zoomMax = tmpZoomMax > extremes.dataMax ? extremes.dataMax : tmpZoomMax;
        chart.xAxis[0].setExtremes(zoomMin, zoomMax);
    };

    var _maximize = function (varObj) {
        $(varObj).parent().find(".ui-dialog-titlebar").dblclick(function () {
            var dialog = $(varObj).parent().find(".ui-dialog-content");
            if ($(this).find("a[class='ui-dialog-titlebar-maximize ui-corner-all ui-state-default']").is(":visible")) {
                $(dialog).height("auto");
                $(dialog).dialogExtend("maximize");
            } else {
                $(dialog).dialogExtend("restore");
            }
        });
    };

    var _hideHeaderMobi = function () {
        $("#header_login").toggle();
    };

    var _viewAutoHeight = function (windowId) {
        //Replace Space with underscore in windowId
        var formattedWindowId = windowId.replace(/ /g, "_");

        var desktopTemplate = "." + formattedWindowId + " .desktop-template";
        $("." + formattedWindowId).height("auto");
        $(desktopTemplate).height("auto");

        setTimeout(function () {
            var minHeightWindow = $("." + formattedWindowId).height();
            var minHeightDesktop = $(desktopTemplate).height();

            $("." + formattedWindowId).css('min-height', minHeightWindow);
            $(desktopTemplate).css('min-height', minHeightDesktop);
        }, 0);


    };

    var _updateElement = function (propValue, varObject) {
        for (var i = 0; i < $rootScope.arrPopup.length; i++) {
            if ($rootScope.arrPopup[i]["desktopIndex"] == propValue) {
                $rootScope.arrPopup[i]["desktopValue"] = varObject;
                break;
            }
        }
    }

    var _getNumberOfDecimals = function (varMax, varMin) {
        _accountInfo = authenticationService.getAccountInfo();
        var delta = Math.abs(varMax - varMin || 0);
        if (_accountInfo != null && _accountInfo.customerId === 12520) return 1; //Palm Coast FL request Ticket #45089
        if (_accountInfo != null && _accountInfo.customerId === 12317) return 3; //Ruidoso NM, Village of
        if (delta < 10) return 3;
        if (_accountInfo != null && _accountInfo.customerId === 11316) return 2; //Livingston County Dams, MI
        if (delta < 100) return 2;
        if (delta < 1000) return 1;
        return 0;
    };

    var _getWindowId = function (parm) { //parm: $scope, this, ctrl, etc...
        parm.windowId = parm.windowId || angular.element('page-title-mobile').attr('mobile-title') || ($filter('filterCapitalizeFirstLetterEachWord')
            ((decodeURIComponent($location.path().substr($location.path().lastIndexOf('/') + 1)))
                .replace(/\-/g, ' ')).replace(/ Partial| View| Template/g, ''));
    };

    var _broadcastAllDeviceSelected = function ($scope) {
        $scope.$on('broadcastAllDeviceSelected', function (event, args) {
            $scope.deviceSelected = args.deviceSelected;
            $scope.deviceSelectedSn = args.deviceSelectedSn;
            $scope.deviceSelectedName = args.deviceSelectedName;
        });
    };

    var _hideElements = function ($element) {
        $element.find('.page-title-mobile').hide();
    };

    //var _openLargeView = function (varViewName) {
    //    openLargeView();
    // };
    var _disableButtons = function () {
        $(".fc-prev-button").prop('disabled', true);
        $(".fc-prev-button").addClass('fc-state-disabled');
        $(".fc-next-button").prop('disabled', true);
        $(".fc-next-button").addClass('fc-state-disabled');
    };

    var _enableButtons = function () {
        $(".fc-prev-button").removeClass('fc-state-disabled');
        $(".fc-prev-button").prop('disabled', false);
        $(".fc-next-button").removeClass('fc-state-disabled');
        $(".fc-next-button").prop('disabled', false);
    };
    var _setStickyProperties = function (object, options) {
        if (!angular.isUndefined(options.deviceId) && options.deviceId != null)
            object.deviceId = options.deviceId;
        if (options.analogIntertieId)
            object.analogIntertieId = options.analogIntertieId;
        if (options.dataMin)
            object.dateMin = options.dataMin;
        if (options.dataMax)
            object.dateMax = options.dataMax;
        if (options.zoomMin)
            object.zoomMin = options.zoomMin;
        if (options.zoomMax)
            object.zoomMax = options.zoomMax;
        if (options.dataFormat)
            object.dataFormat = options.dataFormat;
        if (options.runtimeType)
            object.runtimeType = options.runtimeType;

        if (options.device) {
            if (!angular.isUndefined(options.device.deviceId) && options.device.deviceId != null)
                object.device.deviceId = options.device.deviceId;
            if (options.device.channel)
                object.device.channel = options.device.channel;
            if (options.device.serialNumber)
                object.device.serialNumber = options.device.serialNumber;
            if (options.device.deviceName)
                object.device.deviceName = options.device.deviceName;
            if (options.device.protocolVersion)
                object.device.protocolVersion = options.device.protocolVersion;
            if (options.device.authorizationTypeId)
                object.device.authorizationTypeId = options.device.authorizationTypeId;
        }

        if (options.view) {
            if (options.view.type)
                object.view.type = options.view.type;
            if (options.view.expanded || typeof options.view.expanded != "undefined")
                object.view.expanded = options.view.expanded;
        }

        if (options.liveData === true || options.liveData === false) {
            object.liveData = options.liveData;
        }

        if (options.setting)
            object.setting = options.setting;

        if (options.windowId)
            _updateElement(options.windowId, object); //This has to be a very last parameter;
    };

    var _getIcon = function (varTitle, varMode) {
        if (varTitle === "Tank And Well" || varTitle === "Tank And Well Overview" || varTitle === "Tank And Well Detail") return _getIconImg(varTitle, varMode);
        var modeClass = varMode != null ? 'nav-menu-icon' : 'ui-title-MS';
        //THE-51582: always rendered next to the view title / menu text, so decorative
        return "<i class='" + _getIconClass(varTitle) + " sss " + modeClass + "' aria-hidden='true'></i>";
    };

    var _getIconClass = function (varTitle) {
        switch (varTitle) {
            case "Analog Chart":
            case "Analog Output Chart":
            case "Signal Chart":
            case "Signal Connect Chart":
            case "Temperature Chart":
            case "Digital Chart":
            case "Pump Chart":
            case "Voltage Chart":
            case "Analog Interconnect Chart":
            case "Digital Intertie Chart":
            case "Digital Interconnect Chart":
            //case "Rainfall Chart": 
            case "Rainfall Data Chart":
            case "Solar Chart":
            case "Tank And Well Chart":
            case "Pulse Flow Chart":
            case "Volumetric Flow Chart":
            case "Pump Duty Cycle Plot":
            case "Runtime Variance Chart":
            case "Humidity Chart":
                return "fa fa-line-chart";
            case "Analog Table":
            case "Analog Output Table":
            case "Signal Table":
            case "Signal Connect Table":
            case "Temperature Table":
            case "Digital Table":
            case "Pump Table":
            case "Voltage Table":
            case "Analog Intertie Table":
            case "Digital Intertie Log":
            case "Rainfall Data Table":
            case "Solar Table":
            case "Pulse Flow Table":
            case "Volumetric Flow Table":
            case "Daily Volumetric Flow Summary":
            case "Tank And Well Log":
            case "Humidity Table":
            case "Sequence Number Table":
            case "MM Plus Config History":
            case "MM Plus Network History":
            case "MM Plus Channel History":
            case "Runtime Data":
            case "All Devices":
            case "Station Notes":
                return "fa fa-table";
            case "Tech Support Assign Customer":
                return "fa fa-user-plus";
            case "Analog Gauge":
            case "Analog Output Gauge":
            case "Mc Analog Gauge":
            case "Mc Analog Output Gauge":
            case "Mc Analog Output Widget":
            case "Mc Status Gauge":
            case "Mc Switch Gauge":
            case "Mc Runtime Gauge":
            case "Mc Digital Gauge":
            case "Signal Gauge":
            case "Temperature Gauge":
            case "Digital Gauge":
            case "Voltage Gauge":
            case 'Pulse Flow Gauge':
            case "Analog Widget":
            case "Mc Analog Widget":
            case "Mc Status Widget":
            case "Mc Switch Widget":
            case "Mc Runtime Widget":
            case "Signal Widget":
            case "Connection Widget":
            case "Temperature Widget":
            case "Digital Widget":
            case "Voltage Widget":
            case 'Pulse Flow Widget':
            case "Humidity Gauge":
            case "Humidity Widget":
            case "Mc Pump Gauge":
            case "Mc Pump Widget":
            case "Pump Gauge":
            case "Pump Widget":
            case "Mc Pump Gauge View":
            case "Mc Pump Gauge View Submersible":
            case "Mc Pump Gauge View Blower":
            case "Mc Pump Gauge View Booster":
                return "fa fa-tachometer";
            case "Reports":
            case "User Login":
            case "Site Access":
            case "Disabled Inputs":
            case "Management":
            case "Management Report":
            case "Alert History":
            case "Delayed Alarm History":
            case "Live Demo":
            case "Runtime Daily":
            case "Runtime Multi Day":
            case "Runtime Monthly":
            case 'Runtime Variance':
            case "Unit Check In Report":
            case "Unit Check In":
            case "User Login Report":
            case "Live User":
            case "Live User Report":
            case "Site Access Report":
            case "Disabled Inputs Report":
            case "Alert History Report":
            case "Delayed Alarm History Report":
            case "Integrated Flow":
            case "Integrated Flow Report":
            case "Runtime Daily Report":
            case "Runtime Multi Day Report":
            case "Pulse Flow Multi Day Report":
            case "Runtime Monthly Report":
            case "Web User Login":
            case "Paging Log":
            case "Safe Water Report":
            case "WTS Usage Log":
            case "Mission Reports":
            case 'Untested Wet Well Inputs':
            case 'SSO CSO Report':
            case 'Daily Station Summary':
            case 'Cumulative Flow Reading':
            case 'Pump Service Report':
            case 'Manage User Accounts':
            case 'Tech Support Assignment':
            case 'Signal Connect':
            case 'Style Guide':
            case 'Monthly Flow Summary':
            case 'Contact Information':
            case 'Pump Alarm Data':
            case 'Documents':
            case 'Help Documents':
            case 'Radio Upgrades':
            case 'Spare Radio Report':
            case 'Customer Notes':
            case 'Rain Analysis Report':
                return "fa fa-file-text-o";
            case 'Tech Support Assign RTU to Customer':
                return "fa fa-arrows";
            case "Signal Calendar":
            case "Signal Connect Calendar":
            case "Pulse Flow Calendar":
                return "fa fa-calendar-o";
            case "Dashboard":
            case "RTU Migrate Settings":
                return "fa fa-clipboard";
            case "Raw Data":
                return "fa fa-database";
            case "Notification Rules":
            case 'WTS Customer Management':
            case 'WTS Key Management':
            case 'Bulk Water Management':
                return "fa fa-book";
            case "Notification Rules CG":
                return "fa fa-book";
            case "Notification Schedule":
                return "fa fa-calendar-o";
            case "Notification Destinations":
                return "fa fa-calendar-o";
            case "Destinations":
                return "fa fa-map-signs";
            case "Preferences":
            case "Customer Preferences":
            case "User Preferences":
            case "Alarm Rule Test":
                return "fa fa-cogs";
            case "Notifications":
                return "fa fa-volume-control-phone";
            case "Map":
            case "Marker Customer":
            case "Marker Distributor":
            case "Marker Rural Water Association":
                return "fa fa-map-marker";
            case "Tank And Well":
            case "Tank And Well Overview":
            case 'Tank And Well Detail':
                return "fa fa-hourglass-end";
            case "Interconnect":
            case 'Interconnect Setup':
            case "Analog Interconnect List":
            case "Digital Interconnect List":
            case 'Analog Interconnect Setup':
            case 'Digital Interconnect Setup':
                return "fa fa-link";
            case "Alarm":
            case "Alarm History":
                return "fa fa-bell";
            case "Manage Desktops":
            case "Saved Desktop":
            case "Device Status":
            case "Distributor Device Info List":
                return "fa fa-desktop";
            case "Logout":
                return "fa fa-sign-out";
            case "Close All Views":
                return "fa fa-object-group";
            case "Commands":
                return "fa fa-angle-double-up";
            case "Setup":
            case "Manage Schedule":
            case "Migrate Notification":
            case "Tank And Well Setup":
                return "fa fa-wrench";
            case "RTU View":
                return "fa fa-signal";
            case "RTU Info":
            case "Device Info":
                return "fa fa-info-circle";
            case "RTU Configuration":
            case "RTU Setting":
            case "MM Plus RTU Setting":
                return "fa fa-cog";
            case "Search Customer":
            case "Customer List":
            case "Customer Search":
            case "Customer Lookup":
            case "User Accounts":
            case "Memory Cache Manager":
            case "Blocked Access":
                return "fa fa-users";
            case "Upload Logo":
                return "fa fa-upload";
            case "Weather":
                return "wi wi-sprinkle";
            case "Rainfall":
                return "fa fa-tint";
            //case 'Rainfall Calendar':
            case 'Rainfall Data Calendar':
                return 'wi wi-sprinkle';
            case "Paging":
            case "Paging Option":
                return "fa fa-keyboard-o";
            case "Home":
                return "fa fa-home";
            case "Communication":
                return "fa fa-plug";
            case 'Overview':
                return 'fa fa-heartbeat';
            case 'Electronic Keys':
                return 'fa fa-key';
            case 'Alerts':
                return 'fa fa-bell';
            case 'Ticket System':
                return 'fa fa-folder-o';
            case 'View Ticket':
                return 'fa fa-folder-open';
            case 'Create Ticket':
                return 'fa fa-plus-square';
            case 'Audit History':
                return 'fa fa-history';
            case 'Send Feedback':
            case "Toaster Messages":                
                return 'fa fa-commenting';
            case 'Video Player':
                return 'fa fa-film';
            case "Supergraph":
                return "fa fa-area-chart";
            case 'Download':
                return 'fa fa-download';
            case 'Analog Chart Recorder':
                return 'fa fa-bullseye';
            case 'Revision Log':
                return "fa fa-list-alt";
            case 'Carrier Data Usage':
            case 'Sim Data Usage':
            case 'Data Usage':
                return "fa fa-mobile fa-lg";
            case 'Carrier Rate Plan':
                return "fa fa-book";
            case 'Mission Tech Support':
            case 'Technical Support':
                return "fa fa-life-ring";
            case 'Pump Peak Flow Capacity Estimator':
                return "fa fa-calculator";
            case 'Current Status':
            case 'Radio Upgrade Data':
                return "fa fa-exclamation";
            case 'SVG Elements':
                return "fa fa-cubes";
            case 'Help':
                return "fa fa-question-circle fa-lg";
            case 'Documentation':
                return "fa fa-file-text";
            case 'Update Username':
            case 'Update Password':
            case 'Register Webinar':
            case 'Customers':
                return "fa fa-address-book";
            case 'WTS Usage Log Print':
                return "fa fa-print fa-lg";
            case 'User Terms':
                return "fa fa-file-text-o";
            case 'Admin Portal':
            case 'McAdmin Portal':
            case 'Customer Portal':
            case 'Distributor Portal':
            case 'RSM Portal':
                return "fa fa-home fa-lg";
            case 'Go To Portal':
                return "fa fa-laptop";
            case 'Map Marker':
                return "fa fa-thumb-tack";
            case 'Pump Station':
            case 'Mc Pump Station Widget':
                return "fa fa-industry";
            case 'MyLevel':
            case 'Mc MyLevel Widget':
                return "fa fa-building-o";
            case 'Enable Two Factor Authentication':
            case 'Site Security Portal':
                return "fa fa-lock";
            case 'Welcome To Scada':
            case 'Welcome to 123Scada':
                return "fa fa-handshake-o";
            case 'Device Management':
                return "fa fa-server";
            default: //case 'undefined': 
                return "";
        }
    }


    var _getIconImg = function (varTitle, varMode) {
        var modeClass = varMode != null ? 'nav-menu-icon' : 'ui-title-MS';
        return "<i class='img-filter sss " + modeClass + "' aria-hidden='true'>" + _getIconImgTag(varTitle, varMode) + "</i>";
    };

    var _getIconImgTag = function (varTitle, varMode) {
        switch (varTitle) {
            case "Tank And Well":
            case "Tank And Well Overview":
            case 'Tank And Well Detail':
                return "<img src='images/tankandwelltitle.png' alt=''/>";
            default: //case 'undefined':
                return "";
        }
    }

    var _isAlarmUser = function (accountInfo) {
        if (accountInfo.userRole === 'AlarmUser')
            return true;
        return false;
    };

    var _mcAdmin = function () {
         var adminWebUser = $cookies.get('AdminUser1') != null ? true : false;
         if(adminWebUser) { 
            var mcAdminId = $cookies.get('AdminUser1');
            var inActiveMcUsers = [179, 215, 113, 186, 231, 226, 222, 175];
            if(inActiveMcUsers.includes(parseInt(mcAdminId)))
            {
            authenticationService.logout().then(function (result) {
                        $location.path(result.loginPath);
                    }, function (error) {
                        $window.alert("logout error");
            });
            }
         }
        _accountInfo = authenticationService.getAccountInfo();
        return !angular.isUndefined(_accountInfo.mcAdmin) && _accountInfo.mcAdmin;
    };

    var _isAdmin = function (accountInfo) {
        return accountInfo.userRole.indexOf("Administrator") >= 0;
    };

    var _isSuperAdmin = function (accountInfo) {
        return accountInfo.userRole.indexOf("SuperAdministrator") >= 0;
    };

    var _isInvestorOwnedUtility = function (accountInfo) {
        if (accountInfo.userType === 'InvestorOwnedUtility')
            return true;
        return false;
    };

    var _adminPortal = function () {
        return ($location.path().indexOf("/admin/portal") === -1) ? false : true;
    };

    var _securityPortal = function () {
        return ($location.path().indexOf("/security/portal") === -1) ? false : true;
    };

    var _getViewPropery = function (varViewType, varProperty) {
        if (varProperty === "minimumWidth")
            switch (varViewType) {
                case 0:
                    return { minimumWidth: 400, minimumHeight: 400 };
                    break;
                case 1:
                    return { minimumWidth: 120, minimumHeight: 120 };
                    break;
                case 2:
                    return { minimumWidth: 340, minimumHeight: 110 };
                    break;
                case 3:
                    return { minimumWidth: 640, minimumHeight: 130 }
                    break;
                default:
                    return { minimumWidth: 400, minimumHeight: 400 }
            }
    };

    var _getChartSeriesVisibility = function (varChart, varChartSeriesVisibility) {
        $timeout(function () {
            for (var i = 0; i < varChart.series.length - 1; i++) {
                if (varChartSeriesVisibility.length > 0) {
                    varChartSeriesVisibility[i] = (varChart.series[i].visible);
                }
                else {
                    varChartSeriesVisibility.push(varChart.series[i].visible);
                }
            }
        }, 0);
    };

    var _setChartSeriesVisibility = function (varChart, varChartSeriesVisibility) {
        if (varChartSeriesVisibility.length === 0) return;
        for (var i = 0; i < varChart.series.length - 1; i++) {
            varChart.series[i].update({
                visible: (varChartSeriesVisibility.length > 0) ? varChartSeriesVisibility[i] : true
            });
            varChart.yAxis[i].update({
                labels: {
                    enabled: varChartSeriesVisibility[i] ? true : false
                },
                title: {
                    text: varChartSeriesVisibility[i] ? varChart.series[i].name : null
                },
                lineWidth: varChartSeriesVisibility[i] ? 2 : 0
            });
        }
    };

    _getWindowSize = function () {
        var w = angular.element($window);
        return {
            width: w.width(),
            height: w.height()
        };
    };

    _getLiveDates = function () {
        var intDay = 86400000;
        var intSecond = 1000;
        var tmpDate = new Date();
        tmpDate.setHours(0, 0, 0, 0);
        tmpDate = tmpDate.getTime();

        return { 'startDate': tmpDate - (1 * intDay), 'endDate': tmpDate + (intDay - intSecond) };
    };

    _checkStickyProperties = function (obj) {
        var intDay = 86400000;
        var intSecond = 1000;
        var tmpDate = new Date();
        tmpDate.setHours(0, 0, 0, 0);
        tmpDate = tmpDate.getTime();

        if (!(new Date(obj.dateMin).getTime() > 0 && new Date(obj.dateMax).getTime() > 0)) {
            obj.dateMin = tmpDate - (1 * intDay);
            obj.dateMax = tmpDate + (intDay - intSecond);
        }
    };

    _processReconnect = function (obj) {
        //obj = {
        //    stickyProperties: scope.stickyProperties,
        //    localDateTime: args.localDateTime,
        //    dateRangeOption: 0,
        //    windowTitle: scope.windowTitle,
        //    fnUnregister: _unRegisterListener,
        //    fnGetData: _getData,
        //    viewType: "Chart/Table/Widget"
        //};
        if (obj.stickyProperties.liveData === true) {
            obj.stickyProperties.on = true;
            toaster.pop('success',
                (angular.isUndefined(obj.stickyProperties.device.deviceName)
                    ? (angular.isUndefined(obj.windowTitle) ? "" : obj.windowTitle)
                    : (angular.isUndefined(obj.windowTitle) ? obj.stickyProperties.device.deviceName : obj.windowTitle + " -- " + obj.stickyProperties.device.deviceName)),
                _translation.text.VIEW_RELOADING);

            switch (obj.viewType) {
                default:
                case "Chart":
                    var tmpDates = datetimeService.getStartEndDatesForReconnect(obj.localDateTime, obj.dateRangeOption);
                    if (angular.isUndefined(obj.dataType))
                        obj.fnGetData(obj.stickyProperties.deviceId, tmpDates.startDate, tmpDates.endDate);
                    else if (obj.dataType === "Pulse")
                        obj.fnGetData(tmpDates.startDate, tmpDates.endDate, false);
                    break;

                case "Table":
                    obj.fnGetData(obj.localDateTime);
                    break;
                case "Chart Recorder":
                    obj.fnGetData(obj.stickyProperties.deviceId, new Date(obj.stickyProperties.dateMax));
                    break;
                case "Gauges":
                case "Widget":
                    obj.fnGetData();
                    break;
            }

        } else {
            if (angular.isDefined(obj.stickyProperties.device.serialNumber)) obj.fnUnregister(obj.stickyProperties.device.serialNumber);
        }
    };

    _getUserTypeParms = function (varPortal, varAdminPortal) {
        var name, path;
        switch (varPortal && varAdminPortal) {
            case true:
                name = "Admin";
                path = "/admin/portal";
                break;
            default:
                name = "";
                path = "/";
        }
        return { name: name, path: path };
    };


    var _adjustPopupTopPosition = function (popup) {
        if (angular.isUndefined(popup))
            return;
        var cssInset = popup.dialog('widget').css("inset");
        var cssLeft = popup.dialog('widget').css("left");
        if (!angular.isUndefined(cssInset) && cssInset.length > 0 && cssInset.charAt(0) == "-") {
            popup.dialog('widget').css("inset", "unset").css("top", 0);
            popup.dialog('widget').css("left", cssLeft);
        }  
    };

    var _isNullOrUndefined = function (value) {
        return value === undefined || value === null;
    }

    var _getClassicViewState = function () {
        var tmp = $window.sessionStorage.getItem("state");
        var obj = $.parseJSON(tmp);
        return (obj === null || typeof obj === "undefined") ? false : obj.classicView;
    };

    var _keepVisibleOnlyCloseButton = function (element) {
        //the titlebar buttons live in <li> items, so hide the item along with the button
        element.closest(".ui-dialog").find(".ui-dialog-titlebar-minimize").css("display", "none").parent("li").css("display", "none");
        element.closest(".ui-dialog").find(".ui-dialog-titlebar-maximize").css("display", "none").parent("li").css("display", "none");
        element.closest(".ui-dialog").find(".ui-dialog-titlebar-collapse").css("display", "none").parent("li").css("display", "none");
    };

    var _adjustBrowserHistoryForLoginPath = function (historyAction) {
        var loginPath = $window.sessionStorage.getItem('loginPath');

        if (!loginPath) {
            return;
        }

        var applicationUrl = $location.absUrl().split('#!')[0];
        var targetUrl = applicationUrl + '#!' + loginPath;

        if (historyAction === 'push') {
            $window.history.pushState(null, '', targetUrl);
            return;
        }

        $window.history.replaceState(null, '', targetUrl);
    };

    _usStateList = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AS": "American Samoa",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "DC": "District Of Columbia",
        "FM": "Federated States Of Micronesia",
        "FL": "Florida",
        "GA": "Georgia",
        "GU": "Guam",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MH": "Marshall Islands",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "MP": "Northern Mariana Islands",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PW": "Palau",
        "PA": "Pennsylvania",
        "PR": "Puerto Rico",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VI": "Virgin Islands",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming",
        "AB": "Alberta",
        "BC": "British Columbia",
        "MB": "Manitoba",
        "NB": "New Brunswick",
        "ON": "Ontario",
        "QC": "Quebec",
        "SK": "Saskatchewan"
    };

    _canadaProvinceList = ["AB", , "BC", "MB", "NB", "ON", "QC", "SK"];

    sharedSetupFactory.usStateList = _usStateList;
    sharedSetupFactory.canadaProvinceList = _canadaProvinceList;
    sharedSetupFactory.accountInfo = _accountInfo;
    sharedSetupFactory.unixDay = _unixDay;
    sharedSetupFactory.liveDataOffset = _liveDataOffset;
    sharedSetupFactory.liveDataOffsetAdj = _liveDataOffsetAdj;
    sharedSetupFactory.minPadding = _minPadding;
    sharedSetupFactory.maxPadding = _maxPadding;
    sharedSetupFactory.pagingViewHeightAdjustment = _pagingViewHeightAdjustment;
    sharedSetupFactory.stickyPropertiesInterface = _stickyPropertiesInterface;
    sharedSetupFactory.mouseWheelZoom = _mouseWheelZoom;
    sharedSetupFactory.broadcastAllDeviceSelected = _broadcastAllDeviceSelected;
    sharedSetupFactory.hideElements = _hideElements;
    sharedSetupFactory.updateElement = _updateElement;
    sharedSetupFactory.setStickyProperties = _setStickyProperties;
    sharedSetupFactory.getIcon = _getIcon;
    sharedSetupFactory.getIconImg = _getIconImg;
    sharedSetupFactory.mcAdmin = _mcAdmin;
    sharedSetupFactory.isAdmin = _isAdmin;
    sharedSetupFactory.isAlarmUser = _isAlarmUser;
    sharedSetupFactory.isInvestorOwnedUtility = _isInvestorOwnedUtility;
    sharedSetupFactory.isSuperAdmin = _isSuperAdmin;
    sharedSetupFactory.adminPortal = _adminPortal;
    sharedSetupFactory.securityPortal = _securityPortal;
    sharedSetupFactory.maximize = _maximize;
    sharedSetupFactory.hideHeaderMobi = _hideHeaderMobi;
    sharedSetupFactory.getViewPropery = _getViewPropery;
    sharedSetupFactory.getNumberOfDecimals = _getNumberOfDecimals;
    sharedSetupFactory.getWindowSize = _getWindowSize;
    sharedSetupFactory.getLiveDates = _getLiveDates;
    sharedSetupFactory.checkStickyProperties = _checkStickyProperties;
    sharedSetupFactory.getChartSeriesVisibility = _getChartSeriesVisibility;
    sharedSetupFactory.setChartSeriesVisibility = _setChartSeriesVisibility;
    sharedSetupFactory.disableButtons = _disableButtons;
    sharedSetupFactory.enableButtons = _enableButtons;
    sharedSetupFactory.getWindowId = _getWindowId;
    sharedSetupFactory.processReconnect = _processReconnect;
    sharedSetupFactory.viewAutoHeight = _viewAutoHeight;
    sharedSetupFactory.getUserTypeParms = _getUserTypeParms;
    sharedSetupFactory.adjustPopupTopPosition = _adjustPopupTopPosition;
    sharedSetupFactory.isNullOrUndefined = _isNullOrUndefined;
    sharedSetupFactory.getClassicViewState = _getClassicViewState;
    sharedSetupFactory.isFromUpdatePassword = _isFromUpdatePassword;
    sharedSetupFactory.currentUrl = _currentUrl;
    sharedSetupFactory.keepVisibleOnlyCloseButton = _keepVisibleOnlyCloseButton;
    sharedSetupFactory.checkUnsavedChanges = _checkUnsavedChanges;
    sharedSetupFactory.tabPopupWarningOn = _tabPopupWarningOn;
    sharedSetupFactory.adjustBrowserHistoryForLoginPath = _adjustBrowserHistoryForLoginPath;

    return sharedSetupFactory;
}]);
function buildMultiTbodyTables($element) {
    var tables = [];
    $element.find('tbody.multi-table.pdf').each(function () {
        var columns = [];
        var data = [];

        var $tbody = $(this);
        var $rows = $tbody.children('tr');

        $rows.first().find('th').each(function (index) {
            columns.push({
                title: $(this).text().trim(),
                dataKey: index
            });
        });
        var columnCount = columns.length;

        $rows.slice(1).each(function () {
            var $tds = $(this).children('td');
            // "No reports" row detection
            if ($tds.length === 1 && Number($tds.attr('colspan')) > 1) {
                var noRow = new Array(columnCount).fill('');
                noRow[0] = '---- No reports ----';
                data.push(noRow);
                return;
            }

            var row = new Array(columnCount).fill('');
            // Date column
            row[0] = $tds.first().text().trim();

            // Channel values (nested table span)
            $tds.slice(1).each(function (i) {
                var val = $(this).find('span').text().trim();
                row[i + 1] = val || '';
            });

            data.push(row);
        });

        tables.push({
            columns: columns,
            data: data
        });
    });

    return tables;
}

mcapp.factory('savePulseflowMultiDayPdfService', ["datetimeService", function (datetimeService) {
    var savePulseflowMultiDayPdfService = {};
    savePulseflowMultiDayPdfService.savePDF = function (pdfParams) {

        //Check for values and set defaults
        var windowTitle = !angular.isUndefined(pdfParams.windowTitle) ? pdfParams.windowTitle : null;
        var pdfTitle = !angular.isUndefined(pdfParams.pdfTitle) ? pdfParams.pdfTitle : null;
        var customerName = !angular.isUndefined(pdfParams.customerName) ? pdfParams.customerName : null;
        var customerId = !angular.isUndefined(pdfParams.customerId) ? pdfParams.customerId : null;
        var dateTranslate = !angular.isUndefined(pdfParams.dateTranslate) ? pdfParams.dateTranslate : null;
        var $scope = !angular.isUndefined(pdfParams.$scope) ? pdfParams.$scope : null;
        var $element = !angular.isUndefined(pdfParams.$element) ? pdfParams.$element : null;

        var doc = new jsPDF('l', 'pt');
        doc.setFontSize(7);

        if (customerName && customerId) {
            doc.text(40, 15, customerName + ' (#' + customerId + ')');
        }

        if (dateTranslate) {
            var today = datetimeService.formatDate(new Date(), 'MM/dd/yyyy');
            doc.text(40, 25, dateTranslate + ': ' + today);
        }

        if (pdfTitle) {
            doc.setFontSize(14);
            doc.text(300, 35, pdfTitle);
            doc.setFontSize(7);
        }

        var tables = buildMultiTbodyTables($element);
        var startY = 40;

        tables.forEach(function (tbl, index) {
            doc.autoTable(
                tbl.columns,
                tbl.data,
                {
                    startY: startY,
                    styles: {
                        overflow: 'linebreak'
                    },
                    headStyles: {
                        fillColor: [32, 178, 170],
                    },
                    bodyStyles: {
                        fillColor: [226, 239, 248]
                    },
                    alternateRowStyles: {
                        fillColor: [245, 245, 245]
                    }
                }
            );
            // Start next table below previous table
            startY = doc.autoTable.previous.finalY + 10;
        });

        setTimeout(function () {
            $scope.topMenuPdfProgress = false;
            $scope.$apply();
            doc.save(windowTitle + '.pdf');
        }, 1000);
    };
    return savePulseflowMultiDayPdfService;
}]);
mcapp.factory('savePdfService',["datetimeService", function (datetimeService) { 
    var savePdfService = {};
    savePdfService.savePDF = function (pdfParams) {
         
        //Check for values and set defaults
        var windowTitle = !angular.isUndefined(pdfParams.windowTitle) ? pdfParams.windowTitle : null;
        var pdfTitle = !angular.isUndefined(pdfParams.pdfTitle) ? pdfParams.pdfTitle : null;
        var customerName = !angular.isUndefined(pdfParams.customerName) ? pdfParams.customerName : null;
        var customerId = !angular.isUndefined(pdfParams.customerId) ? pdfParams.customerId : null;
        var dateTranslate = !angular.isUndefined(pdfParams.dateTranslate) ? pdfParams.dateTranslate : null;
        var dateRangeStart = !angular.isUndefined(pdfParams.dateRangeStart) ? pdfParams.dateRangeStart : null;
        var dateRangeEnd = !angular.isUndefined(pdfParams.dateRangeEnd) ? pdfParams.dateRangeEnd : null;
        var $scope = !angular.isUndefined(pdfParams.$scope) ? pdfParams.$scope : null;
        var $element = !angular.isUndefined(pdfParams.$element) ? pdfParams.$element : null;
        var columnStyles = !angular.isUndefined(pdfParams.columnStyles) ? pdfParams.columnStyles : null;
        var drawCell = !angular.isUndefined(pdfParams.drawCell) ? pdfParams.drawCell : null;

        var doc = new jsPDF('l', 'pt');
        doc.setFontSize(7);

        //Check for date parameters provided
        if(dateRangeEnd && dateRangeStart){
            var dateStart = datetimeService.formatDate(new Date(dateRangeStart), 'MM/dd/yyyy');
            var dateEnd =  datetimeService.formatDate(new Date(dateRangeEnd), 'MM/dd/yyyy');
        }

        if(dateTranslate){
            var todayDate = datetimeService.formatDate(new Date(), 'MM/dd/yyyy');
            doc.text(40, 25, dateTranslate + ': ' + todayDate);
        }

        doc.text(40, 15, customerName + " (#" + customerId + ")");
        doc.setFontSize(16);

        if(dateStart && dateEnd){
            doc.text((280 - pdfTitle.length), 35, pdfTitle + ': ' + dateStart + ' - ' + dateEnd);
        }
        else{doc.text((280 - pdfTitle.length), 35, pdfTitle)}

        var elem = $element.find(".table.pdf");
        var header = $element.find(".excel-pdf-header");
        var requiredElement = elem[0];
        var requiredHeader = header[0];
        
        //Copy html elements
        var requiredHeaderCopy = angular.copy(requiredHeader);
        var requiredElementCopy = angular.copy(requiredElement);

        //Remove undesired html
        $(requiredElementCopy).find(".mc-remove-extra-column").remove();
        $(requiredHeaderCopy).find(".mc-remove-extra-column").remove();
        $(requiredHeaderCopy).find(".mc-extra-column-excel-only").remove();
        $(requiredHeaderCopy).find(".dropdown-menu").remove();

        //Prepend Header to table
        $(requiredElementCopy).prepend(requiredHeaderCopy);
        
        var res = doc.autoTableHtmlToJson(requiredElementCopy);
        doc.autoTable(res.columns, res.data, {
            startY: 40,
            tableWidth: 'auto',
            styles: {
                overflow: 'linebreak' 
            }, 
            columnStyles : columnStyles,
            drawCell: drawCell
        });

        setTimeout(function () {
            $scope.topMenuPdfProgress = false;
            $scope.$apply();
            doc.save(windowTitle + '.pdf');
        }, 1000);
    };
    return savePdfService; 
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SaveDesktopSettingService(sharedSetupService, rangeSelectorService) {
    var SaveDesktopSettingService = function () {
        function SaveDesktopSettingService(deviceId, viewName) {
            _classCallCheck(this, SaveDesktopSettingService);

            this.deviceId = deviceId;
            this.viewName = viewName;
        }

        _createClass(SaveDesktopSettingService, [{
            key: 'getObject',
            value: function getObject() {
                var settingObject = {};
                if (typeof this.viewName !== "undefined") {
                    var tmpviewName = this.viewName.replace(/[0-9]/g, '').replace(/_/g, ' ').trim();
                    switch (tmpviewName) {
                        case "Voltage Chart":
                        case "Analog Output Chart":
                        case "Solar Chart":
                        case "Pulse Flow Chart":
                        case "Signal Chart":
                        case "Signal Connect Chart":
                            settingObject = {
                                savedDesktop: false,
                                deviceId: this.deviceId,
                                viewName: tmpviewName,
                                hiddenSerieById: [
                                    //    { id: 1},
                                    //    { id: 3}
                                ]
                            };
                            break;
                        case "Analog Chart":
                            settingObject = {
                                savedDesktop: false,
                                deviceId: this.deviceId,
                                viewName: tmpviewName,
                                hiddenSerieById: [
                                    //    { id: 1},
                                    //    { id: 3}
                                ],
                                autoScale: true,
                                hiddenThresholdsById: [
                                    //    { id: 1},
                                    //    { id: 3}
                                ],
                                hiddenLevelReferencesById: [
                                    //    { id: 1},
                                    //    { id: 3}
                                ],
                                sidebarLegend: true
                            };
                            break;
                        case "Digital Chart":
                            settingObject = {
                                savedDesktop: false,
                                deviceId: this.deviceId,
                                viewName: tmpviewName,
                                hiddenSerieById: [
                                    //    { id: 1},
                                    //    { id: 3}
                                ],
                                zoomAdjust: 0.5
                            };
                            break;
                        case "Pump Chart":
                            settingObject = {
                                savedDesktop: false,
                                deviceId: this.deviceId,
                                viewName: tmpviewName,
                                hiddenSerieById: [
                                    //    { id: 1},
                                    //    { id: 3}
                                ],
                                zoomAdjust: 0.5,
                                isHourlyData: true
                            };
                            break;
                        case "Supergraph":
                            settingObject = {
                                savedDesktop: false,
                                deviceId: this.deviceId,
                                viewName: tmpviewName,
                                serieSettingByName: [
                                    // {}
                                ],
                                selectedPulseFlowGrouping: 1
                            };
                            break;
                        default:
                            settingObject = null;
                            break;
                    }
                }
                return settingObject;
            }
        }, {
            key: 'setSerieVisibilitySetting',
            value: function setSerieVisibilitySetting(id, visible, ctrl) {
                if (!visible) {
                    if (ctrl.savedDesktopSetting.hiddenSerieById.filter(function (item) {
                        return item.id == id;
                    }).length == 0) ctrl.savedDesktopSetting.hiddenSerieById.push({ id: id });
                } else {

                    ctrl.savedDesktopSetting.hiddenSerieById = ctrl.savedDesktopSetting.hiddenSerieById.filter(function (item) {
                        return item.id !== id;
                    });
                    if (angular.isUndefined(ctrl.savedDesktopSetting.hiddenSerieById)) ctrl.savedDesktopSetting.hiddenSerieById = [];
                }

                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { setting: ctrl.savedDesktopSetting, windowId: ctrl.windowId });
            }
        }, {
            key: 'setVisibilitySetting',
            value: function setVisibilitySetting(type, id, visible, ctrl) {
                var objName = void 0;

                switch (type) {
                    case "t":
                        objName = "hiddenThresholdsById";
                        break;
                    case "l":
                        objName = "hiddenLevelReferencesById";
                        break;
                    default:
                        objName = null;
                        break;
                }

                if (!visible) {
                    if (ctrl.savedDesktopSetting[objName].filter(function (item) {
                        return item.id == id;
                    }).length == 0) ctrl.savedDesktopSetting[objName].push({ id: id });
                } else {

                    ctrl.savedDesktopSetting[objName] = ctrl.savedDesktopSetting[objName].filter(function (item) {
                        return item.id !== id;
                    });
                    if (angular.isUndefined(ctrl.savedDesktopSetting[objName])) ctrl.savedDesktopSetting[objName] = [];
                }

                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { setting: ctrl.savedDesktopSetting, windowId: ctrl.windowId });
            }
        }, {
            key: 'applySavedDesktopSetting',
            value: function applySavedDesktopSetting(chart, ctrl, yAxisUpdate) {

                if (ctrl.stickyProperties.setting == null || !ctrl.stickyProperties.setting.savedDesktop) return;

                ctrl.stickyProperties.setting.savedDesktop = false;

                for (var i = 0; i < chart.series.length - 1; i++) {
                    //chart.series.length - 1 -> exclude Navigator serie!

                    var isHidden = ctrl.savedDesktopSetting.hiddenSerieById.filter(function (item) {
                        return item.id == chart.series[i].options.id;
                    }).length > 0;

                    chart.series[i].setVisible(!isHidden, false);

                    if (yAxisUpdate) chart.yAxis[i].update({
                        labels: {
                            enabled: isHidden ? false : true
                        },
                        title: {
                            enabled: isHidden ? false : true
                        },
                        lineWidth: isHidden ? 0 : 2
                    });

                    if (isHidden) {
                        ++ctrl.numberOfHiddenSeries;
                    }

                    {
                        if (angular.isUndefined(ctrl.savedDesktopSetting.hiddenThresholdsById)) ctrl.savedDesktopSetting.hiddenThresholdsById = [];
                        var isHiddenT = ctrl.savedDesktopSetting.hiddenThresholdsById.filter(function (item) {
                            return item.id == chart.series[i].options.id;
                        }).length > 0;

                        if (isHiddenT) {
                            ctrl.series[i].tVisible = false;
                            ctrl.togglePlotLines(ctrl.series[i].tVisible, ctrl.series[i].id, "Threshold");
                        }
                    }

                    {
                        if (angular.isUndefined(ctrl.savedDesktopSetting.hiddenLevelReferencesById)) ctrl.savedDesktopSetting.hiddenLevelReferencesById = [];
                        var isHiddenL = ctrl.savedDesktopSetting.hiddenLevelReferencesById.filter(function (item) {
                            return item.id == chart.series[i].options.id;
                        }).length > 0;

                        if (isHiddenL) {
                            ctrl.series[i].lVisible = false;
                            ctrl.togglePlotLines(ctrl.series[i].lVisible, ctrl.series[i].id, "Lake");
                        }
                    }

                    {
                        if (!angular.isUndefined(ctrl.savedDesktopSetting.sidebarLegend) && !angular.isUndefined(ctrl.toggleSidebarLegend)) ctrl.toggleSidebarLegend(ctrl.savedDesktopSetting.sidebarLegend);
                    }
                }
                if (ctrl.stickyProperties.setting.zoomAdjust != null) {
                    ctrl.zoomAdjust(ctrl.stickyProperties.setting.zoomAdjust);
                }
                if (ctrl.stickyProperties.setting.isHourlyData != null) {
                    //In order for pump chart to load the correct data interval, here toggle should be set as the state before clicking on the button
                    ctrl.varTopMenuToggle = ctrl.stickyProperties.setting.isHourlyData ? "D" : "H";
                    ctrl.fnTopMenuToggle();
                }
                if (ctrl.stickyProperties.setting.autoScale != null) {
                    if (ctrl.stickyProperties.setting == null) return;
                    for (var i = 0; i < chart.series.length - 1; i++) {
                        if (ctrl.stickyProperties.setting.autoScale === false) {
                            if (ctrl.analogSetting[i].minimumValue > ctrl.analogSetting[i].maximumValue) {
                                chart.yAxis[i].setExtremes(ctrl.analogSetting[i].maximumValue, ctrl.analogSetting[i].minimumValue);
                            } else {
                                chart.yAxis[i].setExtremes(ctrl.analogSetting[i].minimumValue, ctrl.analogSetting[i].maximumValue);
                            }
                            if (!angular.isUndefined(chart.exportSVGElements)) {
                                if (!angular.isUndefined(chart.exportSVGElements[0])) {
                                    var button = chart.exportSVGElements[0];
                                    button.attr({
                                        x: -200
                                    });
                                }
                                if (!angular.isUndefined(chart.exportSVGElements[2])) {
                                    var button2 = chart.exportSVGElements[2];
                                    button2.attr({
                                        x: -200 //-5
                                    });
                                }
                            }
                        } else {
                            chart.yAxis[i].setExtremes(null, null);
                            if (!angular.isUndefined(chart.exportSVGElements)) {
                                if (!angular.isUndefined(chart.exportSVGElements[0])) {
                                    var button = chart.exportSVGElements[0];
                                    button.attr({
                                        x: -200 //-5
                                    });
                                }
                                if (!angular.isUndefined(chart.exportSVGElements[2])) {
                                    var button2 = chart.exportSVGElements[2];
                                    button2.attr({
                                        x: -200
                                    });
                                }
                            }
                        }
                    }
                    var extremes = chart.xAxis[0].getExtremes();
                    chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
                    ctrl.varToggle = !ctrl.stickyProperties.setting.autoScale;
                }
            }
        }, {
            key: 'setSerieVisibilityAndScaleSettingSupergraph',
            value: function setSerieVisibilityAndScaleSettingSupergraph(varID, visible, autoScale, plotlines, ctrl) {
                var alarmVisible = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

                if (ctrl.savedDesktopSetting.serieSettingByName.filter(function (item) {
                    return item.varID == varID;
                }).length == 0) {

                    ctrl.savedDesktopSetting.serieSettingByName.push({ varID: varID, visible: visible, autoScale: autoScale, plotlines: plotlines, alarmVisible: alarmVisible });
                } else if (angular.isUndefined(ctrl.savedDesktopSetting.serieSettingByName)) {
                    ctrl.savedDesktopSetting.serieSettingByName = [{ varID: varID, visible: visible, autoScale: autoScale, plotlines: plotlines, alarmVisible: alarmVisible }];
                } else {

                    var serieIndex = ctrl.savedDesktopSetting.serieSettingByName.findIndex(function (x) {
                        return x.varID == varID;
                    });
                    if (serieIndex >= 0) {
                        ctrl.savedDesktopSetting.serieSettingByName[serieIndex].visible = visible;
                        ctrl.savedDesktopSetting.serieSettingByName[serieIndex].autoScale = autoScale;
                        ctrl.savedDesktopSetting.serieSettingByName[serieIndex].plotlines = plotlines;
                        ctrl.savedDesktopSetting.serieSettingByName[serieIndex].alarmVisible = alarmVisible;
                    }
                }

                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { setting: ctrl.savedDesktopSetting, windowId: ctrl.windowId });
            }
        }, {
            key: 'setSupergraphPulseFlowGrouping',
            value: function setSupergraphPulseFlowGrouping(selectedPulseFlowGrouping, ctrl) {
                ctrl.savedDesktopSetting.selectedPulseFlowGrouping = selectedPulseFlowGrouping;
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { setting: ctrl.savedDesktopSetting, windowId: ctrl.windowId });
            }
        }, {
            key: 'applySavedDesktopSettingSupergraph',
            value: function applySavedDesktopSettingSupergraph(chart, ctrl, yAxisUpdate) {

                if ((ctrl.stickyProperties.setting == null || !ctrl.stickyProperties.setting.savedDesktop) && !ctrl.dateSelected) return;

                if (ctrl.stickyProperties.setting != null && ctrl.stickyProperties.setting.savedDesktop == true) ctrl.stickyProperties.setting.savedDesktop = false;

                if (ctrl.dateSelected) ctrl.dateSelected = false;

                var _loop = function _loop(j) {
                    var serieIndex = ctrl.savedDesktopSetting.serieSettingByName.findIndex(function (x) {
                        return x.varID == chart.series[j].options.id;
                    });
                    if (serieIndex >= 0) {
                        var varID = ctrl.savedDesktopSetting.serieSettingByName[serieIndex].varID;
                        var visibility = ctrl.savedDesktopSetting.serieSettingByName[serieIndex].visible;
                        var autoScale = ctrl.savedDesktopSetting.serieSettingByName[serieIndex].autoScale;
                        var plotLines = ctrl.savedDesktopSetting.serieSettingByName[serieIndex].plotlines;
                        var alarmVisible = ctrl.savedDesktopSetting.serieSettingByName[serieIndex].alarmVisible;
                        if (chart.series[j].options.id === varID || chart.series[j].options.id === 'flg-' + varID) {
                            chart.series[j].setVisible(visibility, false);
                            chart.series[j].yAxis.plotlines = plotLines;
                            ctrl.chartData[varID].visible = visibility;
                            ctrl.chartData[varID].alarmThresholdsVisibleTemp = alarmVisible;
                        }
                        if (autoScale) {
                            for (var k = 0; k < chart.yAxis.length; k++) {

                                var tmpId = typeof chart.yAxis[k].options.id != "undefined" ? chart.yAxis[k].options.id.replace("yx-", "") : "";

                                switch (tmpId) {
                                    case "vbatt":
                                    case "vac":
                                    case "vaux":
                                    case "sign":
                                    case "signalQuality":
                                    case "signalPower":
                                    case "temp":
                                    case "rainT":
                                    case "rainR":
                                    case "ch1":
                                    case "ch2":
                                    case "ch3":
                                    case "ch4":
                                    case "ch5":
                                    case "ch6":
                                    case "out1":
                                    case "out2":
                                        if (tmpId == varID) ctrl.chartData[tmpId].autoScale = !ctrl.chartData[tmpId].autoScale;
                                        if (ctrl.chartData[tmpId].autoScale === true) {
                                            chart.yAxis[k].options.min = null;
                                            chart.yAxis[k].options.max = null;
                                            chart.yAxis[k].setExtremes(null, null);
                                        } else {
                                            chart.yAxis[k].setExtremes(ctrl.chartData[tmpId].min, ctrl.chartData[tmpId].max);
                                        }
                                        break;
                                }
                                if (tmpId == varID) {
                                    var extremes = chart.xAxis[0].getExtremes();
                                    chart.xAxis[0].setExtremes(extremes.min + ctrl.minPadding, extremes.max + ctrl.maxPadding);
                                    break;
                                }
                            }

                            if (varID == null) {
                                var _extremes = chart.xAxis[0].getExtremes();
                                chart.xAxis[0].setExtremes(_extremes.min + ctrl.minPadding, _extremes.max + ctrl.maxPadding);
                            }
                        }
                        for (var _j = 0; _j < chart.series.length; _j++) {
                            if (chart.series[_j].options.id == varID && !angular.isUndefined(plotLines)) {
                                for (var i = 0; i < plotLines.length; i++) {
                                    if (alarmVisible) chart.series[_j].yAxis.addPlotLine(plotLines[i]);
                                }
                            }
                        }
                    }
                    chart.redraw();
                };

                for (var j = 0; j < chart.series.length; j++) {
                    _loop(j);
                }

                if (ctrl.savedDesktopSetting.serieSettingByName.findIndex(function (x) {
                    return x.varID == "siteAccess" && x.visible == false;
                }) >= 0) {
                    ctrl.removeSiteAccess();
                    ctrl.chartData["siteAccess"].visible = false;
                }

                if (ctrl.savedDesktopSetting.serieSettingByName.findIndex(function (x) {
                    return x.varID == "alarm" && x.visible == false;
                }) >= 0) {
                    ctrl.chartData["alarm"].visible = true;
                    ctrl.removeSiteAlarm();
                }

                return;
            }
        }, {
            key: 'setZoomAdjustSetting',
            value: function setZoomAdjustSetting(zoomAdjust, ctrl) {
                ctrl.savedDesktopSetting.zoomAdjust = zoomAdjust;
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { setting: ctrl.savedDesktopSetting, windowId: ctrl.windowId });
            }
        }, {
            key: 'setPumpChartHourlyDailySetting',
            value: function setPumpChartHourlyDailySetting(isHourlyData, ctrl) {
                ctrl.savedDesktopSetting.isHourlyData = isHourlyData;
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { setting: ctrl.savedDesktopSetting, windowId: ctrl.windowId });
            }
        }, {
            key: 'setAnalogChartAutoScalingSetting',
            value: function setAnalogChartAutoScalingSetting(autoScale, ctrl) {
                ctrl.savedDesktopSetting.autoScale = autoScale;
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { setting: ctrl.savedDesktopSetting, windowId: ctrl.windowId });
            }
        }, {
            key: 'setAnalogChartSidebarLegend',
            value: function setAnalogChartSidebarLegend(sidebarLegend, ctrl) {
                ctrl.savedDesktopSetting.sidebarLegend = sidebarLegend;
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, { setting: ctrl.savedDesktopSetting, windowId: ctrl.windowId });
            }
        }]);

        return SaveDesktopSettingService;
    }();

    return SaveDesktopSettingService;
}

SaveDesktopSettingService.$inject = ['sharedSetupService', 'rangeSelectorService'];
angular.module('mcapp').service('SaveDesktopSettingService', SaveDesktopSettingService);
mcapp.factory('getDateRangeService', function () {
    var range;
    return {
        getRange: function(reportName){
        switch(reportName) {
            case "Analog":
            case "Signal":
            case "Temperature":
            case "Digital":
            case "Voltage":
            case "PumpPerformance":
            case "Pulseflow":
            case "Volumetricflow":
            case "Integratedflow":
            case "RainfallAirport":
            case "RainfallRTU":
            case "SiteAccess":
            case "UserLoginHistory":
                range = 90;
                break;
            case "Solar":
            case "AlarmHistory":
            case "DispatchHistory":
            case "AlertHistory":
            case "DelayedAlarmHistory":
                range = 7;
                break;
            case "WtsUsageLog":
            case "VolumetricFlowTable":
                range = 31;
                break;
            } 
            return range;
        }
      }; 

});
mcapp.factory('QRCode', function () {
	/**
	 * @fileoverview
	 * - Using the 'QRCode for Javascript library'
	 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
	 * - this library has no dependencies.
	 * 
	 * @author davidshimjs
	 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
	 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
	 */
	var QRCode;

	(function () {
		//---------------------------------------------------------------------
		// QRCode for JavaScript
		//
		// Copyright (c) 2009 Kazuhiko Arase
		//
		// URL: http://www.d-project.com/
		//
		// Licensed under the MIT license:
		//   http://www.opensource.org/licenses/mit-license.php
		//
		// The word "QR Code" is registered trademark of 
		// DENSO WAVE INCORPORATED
		//   http://www.denso-wave.com/qrcode/faqpatent-e.html
		//
		//---------------------------------------------------------------------
		function QR8bitByte(data) {
			this.mode = QRMode.MODE_8BIT_BYTE;
			this.data = data;
			this.parsedData = [];

			// Added to support UTF-8 Characters
			for (var i = 0, l = this.data.length; i < l; i++) {
				var byteArray = [];
				var code = this.data.charCodeAt(i);

				if (code > 0x10000) {
					byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
					byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
					byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
					byteArray[3] = 0x80 | (code & 0x3F);
				} else if (code > 0x800) {
					byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
					byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
					byteArray[2] = 0x80 | (code & 0x3F);
				} else if (code > 0x80) {
					byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
					byteArray[1] = 0x80 | (code & 0x3F);
				} else {
					byteArray[0] = code;
				}

				this.parsedData.push(byteArray);
			}

			this.parsedData = Array.prototype.concat.apply([], this.parsedData);

			if (this.parsedData.length != this.data.length) {
				this.parsedData.unshift(191);
				this.parsedData.unshift(187);
				this.parsedData.unshift(239);
			}
		}

		QR8bitByte.prototype = {
			getLength: function (buffer) {
				return this.parsedData.length;
			},
			write: function (buffer) {
				for (var i = 0, l = this.parsedData.length; i < l; i++) {
					buffer.put(this.parsedData[i], 8);
				}
			}
		};

		function QRCodeModel(typeNumber, errorCorrectLevel) {
			this.typeNumber = typeNumber;
			this.errorCorrectLevel = errorCorrectLevel;
			this.modules = null;
			this.moduleCount = 0;
			this.dataCache = null;
			this.dataList = [];
		}

		QRCodeModel.prototype = {
			addData: function (data) { var newData = new QR8bitByte(data); this.dataList.push(newData); this.dataCache = null; }, isDark: function (row, col) {
				if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) { throw new Error(row + "," + col); }
				return this.modules[row][col];
			}, getModuleCount: function () { return this.moduleCount; }, make: function () { this.makeImpl(false, this.getBestMaskPattern()); }, makeImpl: function (test, maskPattern) {
				this.moduleCount = this.typeNumber * 4 + 17; this.modules = new Array(this.moduleCount); for (var row = 0; row < this.moduleCount; row++) { this.modules[row] = new Array(this.moduleCount); for (var col = 0; col < this.moduleCount; col++) { this.modules[row][col] = null; } }
				this.setupPositionProbePattern(0, 0); this.setupPositionProbePattern(this.moduleCount - 7, 0); this.setupPositionProbePattern(0, this.moduleCount - 7); this.setupPositionAdjustPattern(); this.setupTimingPattern(); this.setupTypeInfo(test, maskPattern); if (this.typeNumber >= 7) { this.setupTypeNumber(test); }
				if (this.dataCache == null) { this.dataCache = QRCodeModel.createData(this.typeNumber, this.errorCorrectLevel, this.dataList); }
				this.mapData(this.dataCache, maskPattern);
			}, setupPositionProbePattern: function (row, col) { for (var r = -1; r <= 7; r++) { if (row + r <= -1 || this.moduleCount <= row + r) continue; for (var c = -1; c <= 7; c++) { if (col + c <= -1 || this.moduleCount <= col + c) continue; if ((0 <= r && r <= 6 && (c == 0 || c == 6)) || (0 <= c && c <= 6 && (r == 0 || r == 6)) || (2 <= r && r <= 4 && 2 <= c && c <= 4)) { this.modules[row + r][col + c] = true; } else { this.modules[row + r][col + c] = false; } } } }, getBestMaskPattern: function () {
				var minLostPoint = 0; var pattern = 0; for (var i = 0; i < 8; i++) { this.makeImpl(true, i); var lostPoint = QRUtil.getLostPoint(this); if (i == 0 || minLostPoint > lostPoint) { minLostPoint = lostPoint; pattern = i; } }
				return pattern;
			}, createMovieClip: function (target_mc, instance_name, depth) {
				var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth); var cs = 1; this.make(); for (var row = 0; row < this.modules.length; row++) { var y = row * cs; for (var col = 0; col < this.modules[row].length; col++) { var x = col * cs; var dark = this.modules[row][col]; if (dark) { qr_mc.beginFill(0, 100); qr_mc.moveTo(x, y); qr_mc.lineTo(x + cs, y); qr_mc.lineTo(x + cs, y + cs); qr_mc.lineTo(x, y + cs); qr_mc.endFill(); } } }
				return qr_mc;
			}, setupTimingPattern: function () {
				for (var r = 8; r < this.moduleCount - 8; r++) {
					if (this.modules[r][6] != null) { continue; }
					this.modules[r][6] = (r % 2 == 0);
				}
				for (var c = 8; c < this.moduleCount - 8; c++) {
					if (this.modules[6][c] != null) { continue; }
					this.modules[6][c] = (c % 2 == 0);
				}
			}, setupPositionAdjustPattern: function () {
				var pos = QRUtil.getPatternPosition(this.typeNumber); for (var i = 0; i < pos.length; i++) {
					for (var j = 0; j < pos.length; j++) {
						var row = pos[i]; var col = pos[j]; if (this.modules[row][col] != null) { continue; }
						for (var r = -2; r <= 2; r++) { for (var c = -2; c <= 2; c++) { if (r == -2 || r == 2 || c == -2 || c == 2 || (r == 0 && c == 0)) { this.modules[row + r][col + c] = true; } else { this.modules[row + r][col + c] = false; } } }
					}
				}
			}, setupTypeNumber: function (test) {
				var bits = QRUtil.getBCHTypeNumber(this.typeNumber); for (var i = 0; i < 18; i++) { var mod = (!test && ((bits >> i) & 1) == 1); this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod; }
				for (var i = 0; i < 18; i++) { var mod = (!test && ((bits >> i) & 1) == 1); this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod; }
			}, setupTypeInfo: function (test, maskPattern) {
				var data = (this.errorCorrectLevel << 3) | maskPattern; var bits = QRUtil.getBCHTypeInfo(data); for (var i = 0; i < 15; i++) { var mod = (!test && ((bits >> i) & 1) == 1); if (i < 6) { this.modules[i][8] = mod; } else if (i < 8) { this.modules[i + 1][8] = mod; } else { this.modules[this.moduleCount - 15 + i][8] = mod; } }
				for (var i = 0; i < 15; i++) { var mod = (!test && ((bits >> i) & 1) == 1); if (i < 8) { this.modules[8][this.moduleCount - i - 1] = mod; } else if (i < 9) { this.modules[8][15 - i - 1 + 1] = mod; } else { this.modules[8][15 - i - 1] = mod; } }
				this.modules[this.moduleCount - 8][8] = (!test);
			}, mapData: function (data, maskPattern) {
				var inc = -1; var row = this.moduleCount - 1; var bitIndex = 7; var byteIndex = 0; for (var col = this.moduleCount - 1; col > 0; col -= 2) {
					if (col == 6) col--; while (true) {
						for (var c = 0; c < 2; c++) {
							if (this.modules[row][col - c] == null) {
								var dark = false; if (byteIndex < data.length) { dark = (((data[byteIndex] >>> bitIndex) & 1) == 1); }
								var mask = QRUtil.getMask(maskPattern, row, col - c); if (mask) { dark = !dark; }
								this.modules[row][col - c] = dark; bitIndex--; if (bitIndex == -1) { byteIndex++; bitIndex = 7; }
							}
						}
						row += inc; if (row < 0 || this.moduleCount <= row) { row -= inc; inc = -inc; break; }
					}
				}
			}
		}; QRCodeModel.PAD0 = 0xEC; QRCodeModel.PAD1 = 0x11; QRCodeModel.createData = function (typeNumber, errorCorrectLevel, dataList) {
			var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel); var buffer = new QRBitBuffer(); for (var i = 0; i < dataList.length; i++) { var data = dataList[i]; buffer.put(data.mode, 4); buffer.put(data.getLength(), QRUtil.getLengthInBits(data.mode, typeNumber)); data.write(buffer); }
			var totalDataCount = 0; for (var i = 0; i < rsBlocks.length; i++) { totalDataCount += rsBlocks[i].dataCount; }
			if (buffer.getLengthInBits() > totalDataCount * 8) {
				throw new Error("code length overflow. ("
					+ buffer.getLengthInBits()
					+ ">"
					+ totalDataCount * 8
					+ ")");
			}
			if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) { buffer.put(0, 4); }
			while (buffer.getLengthInBits() % 8 != 0) { buffer.putBit(false); }
			while (true) {
				if (buffer.getLengthInBits() >= totalDataCount * 8) { break; }
				buffer.put(QRCodeModel.PAD0, 8); if (buffer.getLengthInBits() >= totalDataCount * 8) { break; }
				buffer.put(QRCodeModel.PAD1, 8);
			}
			return QRCodeModel.createBytes(buffer, rsBlocks);
		}; QRCodeModel.createBytes = function (buffer, rsBlocks) {
			var offset = 0; var maxDcCount = 0; var maxEcCount = 0; var dcdata = new Array(rsBlocks.length); var ecdata = new Array(rsBlocks.length); for (var r = 0; r < rsBlocks.length; r++) {
				var dcCount = rsBlocks[r].dataCount; var ecCount = rsBlocks[r].totalCount - dcCount; maxDcCount = Math.max(maxDcCount, dcCount); maxEcCount = Math.max(maxEcCount, ecCount); dcdata[r] = new Array(dcCount); for (var i = 0; i < dcdata[r].length; i++) { dcdata[r][i] = 0xff & buffer.buffer[i + offset]; }
				offset += dcCount; var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount); var rawPoly = new QRPolynomial(dcdata[r], rsPoly.getLength() - 1); var modPoly = rawPoly.mod(rsPoly); ecdata[r] = new Array(rsPoly.getLength() - 1); for (var i = 0; i < ecdata[r].length; i++) { var modIndex = i + modPoly.getLength() - ecdata[r].length; ecdata[r][i] = (modIndex >= 0) ? modPoly.get(modIndex) : 0; }
			}
			var totalCodeCount = 0; for (var i = 0; i < rsBlocks.length; i++) { totalCodeCount += rsBlocks[i].totalCount; }
			var data = new Array(totalCodeCount); var index = 0; for (var i = 0; i < maxDcCount; i++) { for (var r = 0; r < rsBlocks.length; r++) { if (i < dcdata[r].length) { data[index++] = dcdata[r][i]; } } }
			for (var i = 0; i < maxEcCount; i++) { for (var r = 0; r < rsBlocks.length; r++) { if (i < ecdata[r].length) { data[index++] = ecdata[r][i]; } } }
			return data;
		}; var QRMode = { MODE_NUMBER: 1 << 0, MODE_ALPHA_NUM: 1 << 1, MODE_8BIT_BYTE: 1 << 2, MODE_KANJI: 1 << 3 }; var QRErrorCorrectLevel = { L: 1, M: 0, Q: 3, H: 2 }; var QRMaskPattern = { PATTERN000: 0, PATTERN001: 1, PATTERN010: 2, PATTERN011: 3, PATTERN100: 4, PATTERN101: 5, PATTERN110: 6, PATTERN111: 7 }; var QRUtil = {
			PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]], G15: (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0), G18: (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0), G15_MASK: (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1), getBCHTypeInfo: function (data) {
				var d = data << 10; while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) { d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15))); }
				return ((data << 10) | d) ^ QRUtil.G15_MASK;
			}, getBCHTypeNumber: function (data) {
				var d = data << 12; while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) { d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18))); }
				return (data << 12) | d;
			}, getBCHDigit: function (data) {
				var digit = 0; while (data != 0) { digit++; data >>>= 1; }
				return digit;
			}, getPatternPosition: function (typeNumber) { return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1]; }, getMask: function (maskPattern, i, j) { switch (maskPattern) { case QRMaskPattern.PATTERN000: return (i + j) % 2 == 0; case QRMaskPattern.PATTERN001: return i % 2 == 0; case QRMaskPattern.PATTERN010: return j % 3 == 0; case QRMaskPattern.PATTERN011: return (i + j) % 3 == 0; case QRMaskPattern.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0; case QRMaskPattern.PATTERN101: return (i * j) % 2 + (i * j) % 3 == 0; case QRMaskPattern.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 == 0; case QRMaskPattern.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 == 0; default: throw new Error("bad maskPattern:" + maskPattern); } }, getErrorCorrectPolynomial: function (errorCorrectLength) {
				var a = new QRPolynomial([1], 0); for (var i = 0; i < errorCorrectLength; i++) { a = a.multiply(new QRPolynomial([1, QRMath.gexp(i)], 0)); }
				return a;
			}, getLengthInBits: function (mode, type) { if (1 <= type && type < 10) { switch (mode) { case QRMode.MODE_NUMBER: return 10; case QRMode.MODE_ALPHA_NUM: return 9; case QRMode.MODE_8BIT_BYTE: return 8; case QRMode.MODE_KANJI: return 8; default: throw new Error("mode:" + mode); } } else if (type < 27) { switch (mode) { case QRMode.MODE_NUMBER: return 12; case QRMode.MODE_ALPHA_NUM: return 11; case QRMode.MODE_8BIT_BYTE: return 16; case QRMode.MODE_KANJI: return 10; default: throw new Error("mode:" + mode); } } else if (type < 41) { switch (mode) { case QRMode.MODE_NUMBER: return 14; case QRMode.MODE_ALPHA_NUM: return 13; case QRMode.MODE_8BIT_BYTE: return 16; case QRMode.MODE_KANJI: return 12; default: throw new Error("mode:" + mode); } } else { throw new Error("type:" + type); } }, getLostPoint: function (qrCode) {
				var moduleCount = qrCode.getModuleCount(); var lostPoint = 0; for (var row = 0; row < moduleCount; row++) {
					for (var col = 0; col < moduleCount; col++) {
						var sameCount = 0; var dark = qrCode.isDark(row, col); for (var r = -1; r <= 1; r++) {
							if (row + r < 0 || moduleCount <= row + r) { continue; }
							for (var c = -1; c <= 1; c++) {
								if (col + c < 0 || moduleCount <= col + c) { continue; }
								if (r == 0 && c == 0) { continue; }
								if (dark == qrCode.isDark(row + r, col + c)) { sameCount++; }
							}
						}
						if (sameCount > 5) { lostPoint += (3 + sameCount - 5); }
					}
				}
				for (var row = 0; row < moduleCount - 1; row++) { for (var col = 0; col < moduleCount - 1; col++) { var count = 0; if (qrCode.isDark(row, col)) count++; if (qrCode.isDark(row + 1, col)) count++; if (qrCode.isDark(row, col + 1)) count++; if (qrCode.isDark(row + 1, col + 1)) count++; if (count == 0 || count == 4) { lostPoint += 3; } } }
				for (var row = 0; row < moduleCount; row++) { for (var col = 0; col < moduleCount - 6; col++) { if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) { lostPoint += 40; } } }
				for (var col = 0; col < moduleCount; col++) { for (var row = 0; row < moduleCount - 6; row++) { if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) { lostPoint += 40; } } }
				var darkCount = 0; for (var col = 0; col < moduleCount; col++) { for (var row = 0; row < moduleCount; row++) { if (qrCode.isDark(row, col)) { darkCount++; } } }
				var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5; lostPoint += ratio * 10; return lostPoint;
			}
		}; var QRMath = {
			glog: function (n) {
				if (n < 1) { throw new Error("glog(" + n + ")"); }
				return QRMath.LOG_TABLE[n];
			}, gexp: function (n) {
				while (n < 0) { n += 255; }
				while (n >= 256) { n -= 255; }
				return QRMath.EXP_TABLE[n];
			}, EXP_TABLE: new Array(256), LOG_TABLE: new Array(256)
		}; for (var i = 0; i < 8; i++) { QRMath.EXP_TABLE[i] = 1 << i; }
		for (var i = 8; i < 256; i++) { QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8]; }
		for (var i = 0; i < 255; i++) { QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i; }
		function QRPolynomial(num, shift) {
			if (num.length == undefined) { throw new Error(num.length + "/" + shift); }
			var offset = 0; while (offset < num.length && num[offset] == 0) { offset++; }
			this.num = new Array(num.length - offset + shift); for (var i = 0; i < num.length - offset; i++) { this.num[i] = num[i + offset]; }
		}
		QRPolynomial.prototype = {
			get: function (index) { return this.num[index]; }, getLength: function () { return this.num.length; }, multiply: function (e) {
				var num = new Array(this.getLength() + e.getLength() - 1); for (var i = 0; i < this.getLength(); i++) { for (var j = 0; j < e.getLength(); j++) { num[i + j] ^= QRMath.gexp(QRMath.glog(this.get(i)) + QRMath.glog(e.get(j))); } }
				return new QRPolynomial(num, 0);
			}, mod: function (e) {
				if (this.getLength() - e.getLength() < 0) { return this; }
				var ratio = QRMath.glog(this.get(0)) - QRMath.glog(e.get(0)); var num = new Array(this.getLength()); for (var i = 0; i < this.getLength(); i++) { num[i] = this.get(i); }
				for (var i = 0; i < e.getLength(); i++) { num[i] ^= QRMath.gexp(QRMath.glog(e.get(i)) + ratio); }
				return new QRPolynomial(num, 0).mod(e);
			}
		}; function QRRSBlock(totalCount, dataCount) { this.totalCount = totalCount; this.dataCount = dataCount; }
		QRRSBlock.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]]; QRRSBlock.getRSBlocks = function (typeNumber, errorCorrectLevel) {
			var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel); if (rsBlock == undefined) { throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel); }
			var length = rsBlock.length / 3; var list = []; for (var i = 0; i < length; i++) { var count = rsBlock[i * 3 + 0]; var totalCount = rsBlock[i * 3 + 1]; var dataCount = rsBlock[i * 3 + 2]; for (var j = 0; j < count; j++) { list.push(new QRRSBlock(totalCount, dataCount)); } }
			return list;
		}; QRRSBlock.getRsBlockTable = function (typeNumber, errorCorrectLevel) { switch (errorCorrectLevel) { case QRErrorCorrectLevel.L: return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0]; case QRErrorCorrectLevel.M: return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1]; case QRErrorCorrectLevel.Q: return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2]; case QRErrorCorrectLevel.H: return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3]; default: return undefined; } }; function QRBitBuffer() { this.buffer = []; this.length = 0; }
		QRBitBuffer.prototype = {
			get: function (index) { var bufIndex = Math.floor(index / 8); return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) == 1; }, put: function (num, length) { for (var i = 0; i < length; i++) { this.putBit(((num >>> (length - i - 1)) & 1) == 1); } }, getLengthInBits: function () { return this.length; }, putBit: function (bit) {
				var bufIndex = Math.floor(this.length / 8); if (this.buffer.length <= bufIndex) { this.buffer.push(0); }
				if (bit) { this.buffer[bufIndex] |= (0x80 >>> (this.length % 8)); }
				this.length++;
			}
		}; var QRCodeLimitLength = [[17, 14, 11, 7], [32, 26, 20, 14], [53, 42, 32, 24], [78, 62, 46, 34], [106, 84, 60, 44], [134, 106, 74, 58], [154, 122, 86, 64], [192, 152, 108, 84], [230, 180, 130, 98], [271, 213, 151, 119], [321, 251, 177, 137], [367, 287, 203, 155], [425, 331, 241, 177], [458, 362, 258, 194], [520, 412, 292, 220], [586, 450, 322, 250], [644, 504, 364, 280], [718, 560, 394, 310], [792, 624, 442, 338], [858, 666, 482, 382], [929, 711, 509, 403], [1003, 779, 565, 439], [1091, 857, 611, 461], [1171, 911, 661, 511], [1273, 997, 715, 535], [1367, 1059, 751, 593], [1465, 1125, 805, 625], [1528, 1190, 868, 658], [1628, 1264, 908, 698], [1732, 1370, 982, 742], [1840, 1452, 1030, 790], [1952, 1538, 1112, 842], [2068, 1628, 1168, 898], [2188, 1722, 1228, 958], [2303, 1809, 1283, 983], [2431, 1911, 1351, 1051], [2563, 1989, 1423, 1093], [2699, 2099, 1499, 1139], [2809, 2213, 1579, 1219], [2953, 2331, 1663, 1273]];

		function _isSupportCanvas() {
			return typeof CanvasRenderingContext2D != "undefined";
		}

		// android 2.x doesn't support Data-URI spec
		function _getAndroid() {
			var android = false;
			var sAgent = navigator.userAgent;

			if (/android/i.test(sAgent)) { // android
				android = true;
				var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);

				if (aMat && aMat[1]) {
					android = parseFloat(aMat[1]);
				}
			}

			return android;
		}

		var svgDrawer = (function () {

			var Drawing = function (el, htOption) {
				this._el = el;
				this._htOption = htOption;
			};

			Drawing.prototype.draw = function (oQRCode) {
				var _htOption = this._htOption;
				var _el = this._el;
				var nCount = oQRCode.getModuleCount();
				var nWidth = Math.floor(_htOption.width / nCount);
				var nHeight = Math.floor(_htOption.height / nCount);

				this.clear();

				function makeSVG(tag, attrs) {
					var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
					for (var k in attrs)
						if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
					return el;
				}

				var svg = makeSVG("svg", { 'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight });
				svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
				_el.appendChild(svg);

				svg.appendChild(makeSVG("rect", { "fill": _htOption.colorLight, "width": "100%", "height": "100%" }));
				svg.appendChild(makeSVG("rect", { "fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template" }));

				for (var row = 0; row < nCount; row++) {
					for (var col = 0; col < nCount; col++) {
						if (oQRCode.isDark(row, col)) {
							var child = makeSVG("use", { "x": String(col), "y": String(row) });
							child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template")
							svg.appendChild(child);
						}
					}
				}
			};
			Drawing.prototype.clear = function () {
				while (this._el.hasChildNodes())
					this._el.removeChild(this._el.lastChild);
			};
			return Drawing;
		})();

		var useSVG = document.documentElement.tagName.toLowerCase() === "svg";

		// Drawing in DOM by using Table tag
		var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? (function () {
			var Drawing = function (el, htOption) {
				this._el = el;
				this._htOption = htOption;
			};

			/**
			 * Draw the QRCode
			 * 
			 * @param {QRCode} oQRCode
			 */
			Drawing.prototype.draw = function (oQRCode) {
				var _htOption = this._htOption;
				var _el = this._el;
				var nCount = oQRCode.getModuleCount();
				var nWidth = Math.floor(_htOption.width / nCount);
				var nHeight = Math.floor(_htOption.height / nCount);
				var aHTML = ['<table style="border:0;border-collapse:collapse;">'];

				for (var row = 0; row < nCount; row++) {
					aHTML.push('<tr>');

					for (var col = 0; col < nCount; col++) {
						aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
					}

					aHTML.push('</tr>');
				}

				aHTML.push('</table>');
				_el.innerHTML = aHTML.join('');

				// Fix the margin values as real size.
				var elTable = _el.childNodes[0];
				var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
				var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;

				if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
					elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";
				}
			};

			/**
			 * Clear the QRCode
			 */
			Drawing.prototype.clear = function () {
				this._el.innerHTML = '';
			};

			return Drawing;
		})() : (function () { // Drawing in Canvas
			function _onMakeImage() {
				this._elImage.src = this._elCanvas.toDataURL("image/png");
				this._elImage.style.display = "block";
				this._elCanvas.style.display = "none";
			}

			// Android 2.1 bug workaround
			// http://code.google.com/p/android/issues/detail?id=5141
			if (this._android && this._android <= 2.1) {
				var factor = 1 / window.devicePixelRatio;
				var drawImage = CanvasRenderingContext2D.prototype.drawImage;
				CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
					if (("nodeName" in image) && /img/i.test(image.nodeName)) {
						for (var i = arguments.length - 1; i >= 1; i--) {
							arguments[i] = arguments[i] * factor;
						}
					} else if (typeof dw == "undefined") {
						arguments[1] *= factor;
						arguments[2] *= factor;
						arguments[3] *= factor;
						arguments[4] *= factor;
					}

					drawImage.apply(this, arguments);
				};
			}

			/**
			 * Check whether the user's browser supports Data URI or not
			 * 
			 * @private
			 * @param {Function} fSuccess Occurs if it supports Data URI
			 * @param {Function} fFail Occurs if it doesn't support Data URI
			 */
			function _safeSetDataURI(fSuccess, fFail) {
				var self = this;
				self._fFail = fFail;
				self._fSuccess = fSuccess;

				// Check it just once
				if (self._bSupportDataURI === null) {
					var el = document.createElement("img");
					var fOnError = function () {
						self._bSupportDataURI = false;

						if (self._fFail) {
							self._fFail.call(self);
						}
					};
					var fOnSuccess = function () {
						self._bSupportDataURI = true;

						if (self._fSuccess) {
							self._fSuccess.call(self);
						}
					};

					el.onabort = fOnError;
					el.onerror = fOnError;
					el.onload = fOnSuccess;
					el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
					return;
				} else if (self._bSupportDataURI === true && self._fSuccess) {
					self._fSuccess.call(self);
				} else if (self._bSupportDataURI === false && self._fFail) {
					self._fFail.call(self);
				}
			};

			/**
			 * Drawing QRCode by using canvas
			 * 
			 * @constructor
			 * @param {HTMLElement} el
			 * @param {Object} htOption QRCode Options 
			 */
			var Drawing = function (el, htOption) {
				this._bIsPainted = false;
				this._android = _getAndroid();

				this._htOption = htOption;
				this._elCanvas = document.createElement("canvas");
				this._elCanvas.width = htOption.width;
				this._elCanvas.height = htOption.height;
				el.appendChild(this._elCanvas);
				this._el = el;
				this._oContext = this._elCanvas.getContext("2d");
				this._bIsPainted = false;
				this._elImage = document.createElement("img");
				this._elImage.alt = "Scan me!";
				this._elImage.style.display = "none";
				this._el.appendChild(this._elImage);
				this._bSupportDataURI = null;
			};

			/**
			 * Draw the QRCode
			 * 
			 * @param {QRCode} oQRCode 
			 */
			Drawing.prototype.draw = function (oQRCode) {
				var _elImage = this._elImage;
				var _oContext = this._oContext;
				var _htOption = this._htOption;

				var nCount = oQRCode.getModuleCount();
				var nWidth = _htOption.width / nCount;
				var nHeight = _htOption.height / nCount;
				var nRoundedWidth = Math.round(nWidth);
				var nRoundedHeight = Math.round(nHeight);

				_elImage.style.display = "none";
				this.clear();

				for (var row = 0; row < nCount; row++) {
					for (var col = 0; col < nCount; col++) {
						var bIsDark = oQRCode.isDark(row, col);
						var nLeft = col * nWidth;
						var nTop = row * nHeight;
						_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
						_oContext.lineWidth = 1;
						_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
						_oContext.fillRect(nLeft, nTop, nWidth, nHeight);

						// 안티 앨리어싱 방지 처리
						_oContext.strokeRect(
							Math.floor(nLeft) + 0.5,
							Math.floor(nTop) + 0.5,
							nRoundedWidth,
							nRoundedHeight
						);

						_oContext.strokeRect(
							Math.ceil(nLeft) - 0.5,
							Math.ceil(nTop) - 0.5,
							nRoundedWidth,
							nRoundedHeight
						);
					}
				}

				this._bIsPainted = true;
			};

			/**
			 * Make the image from Canvas if the browser supports Data URI.
			 */
			Drawing.prototype.makeImage = function () {
				if (this._bIsPainted) {
					_safeSetDataURI.call(this, _onMakeImage);
				}
			};

			/**
			 * Return whether the QRCode is painted or not
			 * 
			 * @return {Boolean}
			 */
			Drawing.prototype.isPainted = function () {
				return this._bIsPainted;
			};

			/**
			 * Clear the QRCode
			 */
			Drawing.prototype.clear = function () {
				this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
				this._bIsPainted = false;
			};

			/**
			 * @private
			 * @param {Number} nNumber
			 */
			Drawing.prototype.round = function (nNumber) {
				if (!nNumber) {
					return nNumber;
				}

				return Math.floor(nNumber * 1000) / 1000;
			};

			return Drawing;
		})();

		/**
		 * Get the type by string length
		 * 
		 * @private
		 * @param {String} sText
		 * @param {Number} nCorrectLevel
		 * @return {Number} type
		 */
		function _getTypeNumber(sText, nCorrectLevel) {
			var nType = 1;
			var length = _getUTF8Length(sText);

			for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
				var nLimit = 0;

				switch (nCorrectLevel) {
					case QRErrorCorrectLevel.L:
						nLimit = QRCodeLimitLength[i][0];
						break;
					case QRErrorCorrectLevel.M:
						nLimit = QRCodeLimitLength[i][1];
						break;
					case QRErrorCorrectLevel.Q:
						nLimit = QRCodeLimitLength[i][2];
						break;
					case QRErrorCorrectLevel.H:
						nLimit = QRCodeLimitLength[i][3];
						break;
				}

				if (length <= nLimit) {
					break;
				} else {
					nType++;
				}
			}

			if (nType > QRCodeLimitLength.length) {
				throw new Error("Too long data");
			}

			return nType;
		}

		function _getUTF8Length(sText) {
			var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
			return replacedText.length + (replacedText.length != sText ? 3 : 0);
		}

		/**
		 * @class QRCode
		 * @constructor
		 * @example 
		 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
		 *
		 * @example
		 * var oQRCode = new QRCode("test", {
		 *    text : "http://naver.com",
		 *    width : 128,
		 *    height : 128
		 * });
		 * 
		 * oQRCode.clear(); // Clear the QRCode.
		 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
		 *
		 * @param {HTMLElement|String} el target element or 'id' attribute of element.
		 * @param {Object|String} vOption
		 * @param {String} vOption.text QRCode link data
		 * @param {Number} [vOption.width=256]
		 * @param {Number} [vOption.height=256]
		 * @param {String} [vOption.colorDark="#000000"]
		 * @param {String} [vOption.colorLight="#ffffff"]
		 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H] 
		 */
		QRCode = function (el, vOption) {
			this._htOption = {
				width: 256,
				height: 256,
				typeNumber: 4,
				colorDark: "#000000",
				colorLight: "#ffffff",
				correctLevel: QRErrorCorrectLevel.H
			};

			if (typeof vOption === 'string') {
				vOption = {
					text: vOption
				};
			}

			// Overwrites options
			if (vOption) {
				for (var i in vOption) {
					this._htOption[i] = vOption[i];
				}
			}

			if (typeof el == "string") {
				el = document.getElementById(el);
			}

			if (this._htOption.useSVG) {
				Drawing = svgDrawer;
			}

			this._android = _getAndroid();
			this._el = el;
			this._oQRCode = null;
			this._oDrawing = new Drawing(this._el, this._htOption);

			if (this._htOption.text) {
				this.makeCode(this._htOption.text);
			}
		};

		/**
		 * Make the QRCode
		 * 
		 * @param {String} sText link data
		 */
		QRCode.prototype.makeCode = function (sText) {
			this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
			this._oQRCode.addData(sText);
			this._oQRCode.make();
			this._el.title = sText;
			this._oDrawing.draw(this._oQRCode);
			this.makeImage();
		};

		/**
		 * Make the Image from Canvas element
		 * - It occurs automatically
		 * - Android below 3 doesn't support Data-URI spec.
		 * 
		 * @private
		 */
		QRCode.prototype.makeImage = function () {
			if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
				this._oDrawing.makeImage();
			}
		};

		/**
		 * Clear the QRCode
		 */
		QRCode.prototype.clear = function () {
			this._oDrawing.clear();
		};

		/**
		 * @name QRCode.CorrectLevel
		 */
		QRCode.CorrectLevel = QRErrorCorrectLevel;
	})();
	return QRCode;
});

'use strict';

angular.module('mc.overview', []);
'use strict';

function PopupFactory(_, $rootScope, HOST, $http, datetimeService, timeLapseService, translationService, $sanitize, $q, digitalGaugeService) {
    var _this = this;

    var translation = translationService.translation;
    var currentTime = 0;

    timeLapseService.getLocalDateTime().then(function (resp) {
        currentTime = new Date(resp.data.localDateTime).getTime();
    });

    $rootScope.$on('Heartbeat', function (event, args) {
        if (args.message.Type === "HEARTBEAT") {
            currentTime = new Date(args.message.LocalDateTime).getTime();
        }
    });

    var Popup = function Popup(accountInfo) {
        _this.uiDigitalDataArray = [];
        _this.accountInfo = accountInfo;
    };

    Popup.prototype.fetchMarkerTooltipData = function (customerId, markerId) {
        var deffered = $q.defer();
        fetchMarkerRespData(customerId, markerId).then(function (resp) {
            var tooltip = '';
            var pushpin = resp.data;
            tooltip += '<div style=\'font-weight: bold; text-align: center; color: #157fcc;\'>' + pushpin.name + '</div>';
            tooltip += '<div style=\'text-align: left;\'><b>' + translation.text.LATITUDE + ':</b> ' + pushpin.latitude + '</div>';
            tooltip += '<div style=\'text-align: left;\'><b>' + translation.text.LONGITUDE + ':</b> ' + pushpin.longitude + '</div>';
            tooltip += '<div style=\'text-align: left;\'><b>' + translation.text.DESCRIPTION + ':</b> ' + pushpin.description + '</div>';

            deffered.resolve(tooltip);
        });
        return deffered.promise;
    };

    Popup.prototype.fetchRwaTooltipData = function (rwaId) {
        var deffered = $q.defer();
        fetchRwaRespData(rwaId).then(function (resp) {
            var tooltip = '';
            var pushpin = resp.data;
            tooltip += '<div style=\'font-weight: bold; text-align: center; color: #1a75bb;\'>' + pushpin.memberName + '</div>';

            tooltip += '<div style=\'text-align: left; padding-top: 10px;\'><b>Organization:</b> ' + pushpin.organization + '</div>';
            tooltip += '<img src=\'scripts/map/icons/Map-Marker-RWA' + (pushpin.hasNotes == true ? '-notes-icon.gif' : '-icon.png') + '\' style=\'width: 20px; height: 20px; position: absolute; top: 36px; right: 7px;\'\'>';

            if (pushpin.rwaDistrict != null && pushpin.rwaDistrict != "") tooltip += '<div style=\'text-align: left; padding-top: 10px;\'><b>RWA District:</b> ' + pushpin.rwaDistrict + '</div>';

            if (pushpin.waterConnections != null && pushpin.waterConnections != "") tooltip += '<div style=\'text-align: left;\'><b>Water Connections:</b> ' + pushpin.waterConnections + '</div>';
            if (pushpin.wastewaterConnections != null && pushpin.wastewaterConnections != "") tooltip += '<div style=\'text-align: left;\'><b>Wastewater Connections:</b> ' + pushpin.wastewaterConnections + '</div>';
            if (pushpin.totalConnections != null && pushpin.totalConnections != "") tooltip += '<div style=\'text-align: left;\'><b>Total Connections:</b> ' + pushpin.totalConnections + '</div>';
            if (pushpin.populationServed != null && pushpin.populationServed != "") tooltip += '<div style=\'text-align: left;\'><b>Population Served:</b> ' + pushpin.populationServed + '</div>';

            tooltip += '<hr style=\'margin-top: 8px; margin-bottom: 8px;\'>';

            tooltip += '<div style=\'text-align: left;\'><b>Address:</b></div>';
            tooltip += '<div style=\'text-align: left; padding-left: 20px;\'> ';
            if (pushpin.address1 != null) tooltip += pushpin.address1 + '<br>';
            if (pushpin.address2 != null) tooltip += pushpin.address2 + '<br>';
            tooltip += pushpin.city + ', ' + pushpin.state + ' ' + pushpin.zip + '</div>';
            tooltip += '<hr style=\'margin-top: 8px; margin-bottom: 8px;\'>';

            if (pushpin.phone != null && pushpin.phone.length > 3 || pushpin.email != null && pushpin.email.length > 4) {
                tooltip += '<div style=\'text-align: left;\'>';

                if (pushpin.phone != null && pushpin.phone.length > 3) tooltip += '<b>Phone#:</b> ' + pushpin.phone + '<br>';
                if (pushpin.email != null && pushpin.email.length > 4) tooltip += '<b>E-mail:</b> ' + pushpin.email + '<br>';
                if (pushpin.contact != null && pushpin.contact != "") tooltip += '<b>Contact:</b> ' + pushpin.contact;

                tooltip += '</div>';

                tooltip += '<hr style=\'margin-top: 8px; margin-bottom: 8px;\'>';
            }

            tooltip += '<div style=\'text-align: left;\'><b>' + translation.text.DISTRIBUTOR + ':</b> ' + pushpin.distributorName + '</div>';
            tooltip += '<div style=\'text-align: left;\'><b>RSM:</b> ' + pushpin.regionalManagerName + '</div>';

            deffered.resolve(tooltip);
        });
        return deffered.promise;
    };

    Popup.prototype.fetchCustomerTooltipData = function (customerId) {
        var deffered = $q.defer();
        fetchCustomerRespData(customerId).then(function (resp) {
            var tooltip = '';
            var pushpin = resp.data;
            tooltip += '<div style=\'font-weight: bold; text-align: center; color: #bb1a1a;\'>' + pushpin.name + '</div>';

            tooltip += '<div style=\'text-align: left; padding-top: 10px;\'><b>CustomerId#:</b> ' + pushpin.customerId + '</div>';
            tooltip += '<img src=\'scripts/map/icons/Map-Marker-Customer-icon.png\' style=\'width: 20px; height: 20px; position: absolute; top: 27px; right: 5px;\'>';
            tooltip += '<hr style=\'margin-top: 8px; margin-bottom: 8px;\'>';

            tooltip += '<div style=\'text-align: left;\'><b>Address:</b></div>';
            tooltip += '<div style=\'text-align: left; padding-left: 20px;\'> ' + pushpin.address1 + '<br>';
            tooltip += pushpin.city + ', ' + pushpin.state + ' ' + pushpin.zip + '</div>';
            tooltip += '<hr style=\'margin-top: 8px; margin-bottom: 8px;\'>';

            if (pushpin.phone != null && pushpin.phone.length > 3 || pushpin.email != null && pushpin.email.length > 4) {
                tooltip += '<div style=\'text-align: left;\'>';

                if (pushpin.phone != null && pushpin.phone.length > 3) tooltip += '<b>Phone#:</b> ' + pushpin.phone + '<br>';
                if (pushpin.email != null && pushpin.email.length > 4) tooltip += '<b>E-mail:</b> ' + pushpin.email;

                tooltip += '</div>';

                tooltip += '<hr style=\'margin-top: 8px; margin-bottom: 8px;\'>';
            }

            tooltip += '<div style=\'text-align: left;\'><b>' + translation.text.DISTRIBUTOR + ':</b> ' + pushpin.distributorName + '</div>';
            tooltip += '<div style=\'text-align: left;\'><b>RSM:</b> ' + pushpin.regionalManagerName + '</div>';

            tooltip += '<hr style=\'margin-top: 8px; margin-bottom: 8px;\'>';
            tooltip += '<div style=\'text-align: left;\'><b>' + translation.text.DEVICES + ' #:</b> ' + pushpin.numberOfDevices + '</div>';

            deffered.resolve(tooltip);
        });
        return deffered.promise;
    };

    Popup.prototype.fetchDistributorTooltipData = function (distributorId) {
        var deffered = $q.defer();
        fetchDistributorRespData(distributorId).then(function (resp) {
            var tooltip = '';
            var pushpin = resp.data;
            tooltip += '<div style=\'font-weight: bold; text-align: center; color: #6ba608;\'>' + pushpin.name + '</div>';
            tooltip += '<div style=\'text-align: left; padding-top: 10px;\'><b>DistributorId#:</b> ' + pushpin.distributorId + '</div>';
            tooltip += '<div style=\'text-align: left;\'><b>Region Code:</b> ' + pushpin.regionCode + '</div>';
            tooltip += '<img src=\'scripts/map/icons/Map-Marker-Distributor-icon.png\' style=\'width: 20px; height: 20px; position: absolute; top: 36px; right: 7px;\'>';
            tooltip += '<hr style=\'margin-top: 8px; margin-bottom: 8px;\'>';

            tooltip += '<div style=\'text-align: left;\'><b>Address:</b></div>';
            tooltip += '<div style=\'text-align: left; padding-left: 20px;\'> ' + pushpin.address + '<br>';
            tooltip += pushpin.city + ', ' + pushpin.state + ' ' + pushpin.zip + '</div>';
            tooltip += '<hr style=\'margin-top: 8px; margin-bottom: 8px;\'>';

            if (pushpin.phone != null && pushpin.phone.length > 3 || pushpin.email != null && pushpin.email.length > 4 || pushpin.contact != null && pushpin.contact.length > 2) {
                tooltip += '<div style=\'text-align: left;\'>';

                if (pushpin.phone != null && pushpin.phone.length > 3) tooltip += '<b>Phone#:</b> ' + pushpin.phone + '<br>';
                if (pushpin.email != null && pushpin.email.length > 4) tooltip += '<b>E-mail:</b> ' + pushpin.email + '<br>';
                if (pushpin.contact != null && pushpin.contact.length > 2) tooltip += '<b>Contact:</b> ' + pushpin.contact;

                tooltip += '</div>';

                tooltip += '<hr style=\'margin-top: 8px; margin-bottom: 8px;\'>';
            }

            tooltip += '<div style=\'text-align: left;\'><b>RSM:</b> ' + pushpin.regionalManagerName + '</div>';

            deffered.resolve(tooltip);
        });
        return deffered.promise;
    };

    Popup.prototype.fetchTooltipData = function (deviceId, tz, deviceModel) {
        var deffered = $q.defer();

        fetchTooltipRespData(deviceId, tz, deviceModel).then(function (resp) {
            var tooltip = '';
            var statusExt = [];
            deviceModel = deviceModel != null ? deviceModel : resp.data.deviceUnitState.deviceType;
            statusExt = getStatusExt(resp.data);
            var status = getStatus(resp.data.deviceUnitState, _this.accountInfo, resp.data.isOffline, resp.data.deviceUnitState.acFail && !resp.data.deviceUnitState.solar, statusExt.length > 0 || resp.data.overviewAlarmList.length > 0);
            tooltip += '<div style=\'font-weight: bold; text-align: center; color: #157fcc;\'>' + $sanitize(resp.data.deviceUnitState.deviceName) + '</div>';
            tooltip += '<div style=\'font-weight: bold; text-align: left;\'>' + status + '</div>';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = statusExt[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var msg = _step.value;

                    tooltip += '<div style=\'font-weight: bold; text-align: left;\'>' + $sanitize(msg);
                    tooltip += '</div>';
                }
                // adding Alarms to the tooltip
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = resp.data.overviewAlarmList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var alarm = _step2.value;

                    if (alarm.input === -1000) {
                        // hide
                    } else if (alarm.input > 0) {
                        tooltip += '<div style=\'font-weight: bold;text-align: left;\'>' + translation.text.INPUT + ' #' + alarm.input + ' => ' + $sanitize(alarm.description) + '</div>';
                    } else {
                        tooltip += '<div style=\'font-weight: bold; text-align: left;\'>' + $sanitize(alarm.description) + '</div>';
                    }
                }

                //last heard time
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            tooltip += '<div style=\'text-align: left;\'><b>' + translation.text.LAST_HEARD + ':</b> ' + getTime(resp.data.deviceUnitState.lastTimeHeard) + '</div>';

            //adding analogGauge related information
            if (resp.data.analogGaugeList.length > 0) {
                tooltip += '<div style=\'text-align: left;\'><b>' + translation.text.ANALOG + ':</b></div>'; //TODO: delete Analog-Data text or translate it based on feedback from Dave
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = resp.data.analogGaugeList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var analogItem = _step3.value;

                        tooltip += '<div style=\'text-align: left;\'>' + $sanitize(analogItem.name) + ': ';
                        var tip = analogItem.latestData + ' ' + $sanitize(analogItem.unit) + ' ';
                        if (deviceModel != null && deviceModel == 20) {
                            tip += _this.accountInfo.preferenceUser.engineeringUnitDisplay === 1 ? ' (' + analogItem.rawValMmPlus + ' ' + analogItem.unit + ')</br>' : '</br>';
                        } else if (deviceModel != null && deviceModel == 21) {
                            tip += _this.accountInfo.preferenceUser.engineeringUnitDisplay === 1 ? ' (' + analogItem.rawValMmPlus + ' ' + getEnggUnitDesc(analogItem.analogMode) + ')</br>' : '</br>';
                        } else {
                            tip += _this.accountInfo.preferenceUser.engineeringUnitDisplay === 1 ? ' (' + getEnggUnit(analogItem) + ')</br>' : '</br>';
                        }
                        tooltip += tip;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }

            // adding Relay Settings to the tooltip
            if (!!resp.data.relayData) {
                var isRelayTitleEnable = false;
                for (var rowNum = 0; rowNum < resp.data.relaySettings.length; rowNum++) {
                    var strOpen = translation.text.OPEN;
                    var strClose = translation.text.CLOSED;
                    var strFault = translation.text.FAULT;
                    if (resp.data.relaySettings[rowNum].showOnPopup === 1) {
                        // 0:Not Show on Popup, 1:Show on Popup
                        if (isRelayTitleEnable == false) {
                            tooltip += '<div style=\'text-align: left;\'><b>' + translation.text.RELAY + ':</b></div>';
                            isRelayTitleEnable = true;
                        }
                        if (resp.data.relaySettings[rowNum].deviceId === 29203 && rowNum < resp.data.relaySettings.length) {
                            // it is only applicable to Channel 1 or 2
                            strOpen = translation.text.OFF; //TODO: may be these values should reverse based on whether it is NormalClose or not? Verify with Peter or Dev
                            strClose = translation.text.ON; //TODO: may be these values should reverse based on whether it is NormalClose or not? Verify with Peter or Dev
                        }
                        var isRelayOpen = false;
                        var isRelayClosed = false;
                        switch (rowNum) {
                            case 0:
                                if (resp.data.relayData.relay1Value === "True") {
                                    isRelayOpen = true;
                                } else if (resp.data.relayData.relay1Value === "False") {
                                    isRelayClosed = true;
                                }
                                break;
                            case 1:
                                if (resp.data.relayData.relay2Value === "True") {
                                    isRelayOpen = true;
                                } else if (resp.data.relayData.relay2Value === "False") {
                                    isRelayClosed = true;
                                }
                                break;
                            case 2:
                                if (resp.data.relayData.relay3Value === "True") {
                                    isRelayOpen = true;
                                } else if (resp.data.relayData.relay3Value === "False") {
                                    isRelayClosed = true;
                                }
                                break;
                            case 3:
                                if (resp.data.relayData.relay4Value === "True") {
                                    isRelayOpen = true;
                                } else if (resp.data.relayData.relay4Value === "False") {
                                    isRelayClosed = true;
                                }
                                break;
                            case 4:
                                if (resp.data.relayData.relay5Value === "True") {
                                    isRelayOpen = true;
                                } else if (resp.data.relayData.relay5Value === "False") {
                                    isRelayClosed = true;
                                }
                                break;
                            case 5:
                                if (resp.data.relayData.relay6Value === "True") {
                                    isRelayOpen = true;
                                } else if (resp.data.relayData.relay6Value === "False") {
                                    isRelayClosed = true;
                                }
                                break;
                            case 6:
                                if (resp.data.relayData.relay7Value === "True") {
                                    isRelayOpen = true;
                                } else if (resp.data.relayData.relay7Value === "False") {
                                    isRelayClosed = true;
                                }
                                break;
                            case 7:
                                if (resp.data.relayData.relay8Value === "True") {
                                    isRelayOpen = true;
                                } else if (resp.data.relayData.relay8Value === "False") {
                                    isRelayClosed = true;
                                }
                                break;
                            case 8:
                                if (resp.data.relayData.relay9Value === "True") {
                                    isRelayOpen = true;
                                } else if (resp.data.relayData.relay9Value === "False") {
                                    isRelayClosed = true;
                                }
                                break;
                        };

                        if (isRelayOpen) {
                            //'curText = curText & "Relay " & I & ": Open <br/>"  ' hfeng 07/11/2014
                            tooltip += '<div style=\'text-align: left;\'>' + resp.data.relaySettings[rowNum].description + ': ' + strClose + '</div>';
                        } else if (isRelayClosed) {
                            //'curText = curText & "Relay " & I & ": Closed <br/>"  ' hfeng 07/11/2014
                            tooltip += '<div style=\'text-align: left;\'>' + resp.data.relaySettings[rowNum].description + ': ' + strOpen + '</div>';
                        } else {
                            tooltip += '<div style=\'text-align: left;\'>' + resp.data.relaySettings[rowNum].description + ': ' + strFault + '</div>';
                        }
                    }
                }
            }

            // massage the digitalGaugeModel 
            tooltip += processDigitalGaugeData(resp.data.digitalGauge, resp.data.digitalDescriptions, resp.data.overviewAlarmList);

            deffered.resolve(tooltip);
        }, function (resp) {
            console.log(resp);
        });

        return deffered.promise;
    };

    var fetchTooltipRespData = function fetchTooltipRespData(deviceId, tz, deviceModel) {
        return $http.get(HOST + '/api/RtuDetail?deviceId=' + deviceId + '&customerId=' + _this.accountInfo.customerId + '&timeZone=' + tz);
    };

    var fetchMarkerRespData = function fetchMarkerRespData(customerId, pushpinId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/Map/Marker',
            params: {
                'customerId': customerId,
                'pushpinId': pushpinId
            }
        });
    };

    var fetchRwaRespData = function fetchRwaRespData(rwaId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/Map/Marker/RuralWaterAssociations/get',
            params: {
                'rwaId': rwaId
            }
        });
    };

    var fetchCustomerRespData = function fetchCustomerRespData(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/Map/Marker/Customer/get',
            params: {
                'customerId': customerId
            }
        });
    };

    var fetchDistributorRespData = function fetchDistributorRespData(distributorId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/Map/Marker/Distributor/get',
            params: {
                'distributorId': distributorId
            }
        });
    };

    var processDigitalGaugeData = function processDigitalGaugeData(digitalGauge, digitalDescriptions, alarmList) {
        var uiDigitalDataArray = [];

        for (var i = 0; i < digitalGauge.digitalSettings.length; i++) {
            var inputChannel = digitalGauge.digitalSettings[i].channel;
            var digValue = 0;
            if (digitalGauge.digitalData !== null) {
                switch (inputChannel) {
                    case 1:
                        digValue = digitalGauge.digitalData.d1;
                        break;
                    case 2:
                        digValue = digitalGauge.digitalData.d2;
                        break;
                    case 3:
                        digValue = digitalGauge.digitalData.d3;
                        break;
                    case 4:
                        digValue = digitalGauge.digitalData.d4;
                        break;
                    case 5:
                        digValue = digitalGauge.digitalData.d5;
                        break;
                    case 6:
                        digValue = digitalGauge.digitalData.d6;
                        break;
                    case 7:
                        digValue = digitalGauge.digitalData.d7;
                        break;
                    case 8:
                        digValue = digitalGauge.digitalData.d8;
                        break;
                    case 9:
                        digValue = digitalGauge.digitalData.d9;
                        break;
                    case 10:
                        digValue = digitalGauge.digitalData.d10;
                        break;
                    case 11:
                        digValue = digitalGauge.digitalData.d11;
                        break;
                    case 12:
                        digValue = digitalGauge.digitalData.d12;
                        break;
                    case 13:
                        digValue = digitalGauge.digitalData.d13;
                        break;
                    case 14:
                        digValue = digitalGauge.digitalData.d14;
                        break;
                    case 15:
                        digValue = digitalGauge.digitalData.d15;
                        break;
                    case 16:
                        digValue = digitalGauge.digitalData.d16;
                        break;

                }
            }
            if (digValue === "True") digValue = "1"; //input is OPEN, per Ned, these are saved in this fashion sometime ago
            if (digValue === "False") digValue = "0"; //input is CLOSE, per Ned, these are saved in this fashion sometime ago
            if (digValue === "NULL") digValue = null; //input is wiring fault

            var oldDigValue = digValue;
            //digValue = this.updateValue(digValue, inputChannel, digitalGauge.digitalSettings[i].normalClosed);
            var digitalMode = digitalGauge.digitalSettings[i].digitalMode;
            //DO NOT add to DigitalData list to be displayed on pop-up for pumps that are NOT MyDro M850 (Model=19) or Model 800 (Model=9) or Ranger M50 (Model=21)
            if (digitalMode == 'P' && !(digitalGauge.device.model == 9 || digitalGauge.device.model == 19 || digitalGauge.device.model == 21)) continue;
            // DO NOT add Disabled, Alarms to the list. and Add Status type to the list, if digitalValue and NormalState is same.
            if (digitalMode == 'D' || digitalMode == 'A')
                // Removing below line from if clause to resolve SCADA-6513(SCADA Map pop up >> Show all Input Status Description)
                //|| (digitalMode == 'S' && oldDigValue !== String(digitalGauge.digitalSettings[i].normalClosed)))
                continue;
            var status = convertStatus(digValue, digitalMode, digitalGauge.digitalSettings[i], getDigitalDescriptionByChannel(digitalDescriptions, inputChannel, 'channel'));
            var des = digitalGauge.digitalSettings[i].description + ": " + (digitalGauge.digitalData !== null ? status.statusMessage : translation.text.NO_DATA);
            var name = digitalGauge.digitalSettings[i].description;
            var uidigitaldata = { description: des, digitalMode: digitalMode, input: inputChannel, digitalData: digitalGauge.digitalData }; //, image: status.statusImage, input: inputChannel, name: name, currentVal: digValue };
            // _drawDigitalGauge(digitaldata)
            uiDigitalDataArray.push(uidigitaldata);
        }

        var tooltip = '';
        //adding digitalGaugeModel related information
        if (uiDigitalDataArray.length > 0) {
            tooltip += '<div style=\'text-align: left;\'><b>' + translation.text.DIGITAL + ':</b> </br> ' + getDigitalDataTooltip(alarmList, uiDigitalDataArray, digitalGauge.lastDigitals) + '</div>'; //TODO: delete Digital-Data text or translate it based on feedback from Dave
        }

        return tooltip;
    };

    var getDigitalDescriptionByChannel = function getDigitalDescriptionByChannel(arr, val, prop) {
        for (var k = 0; k < arr.length; k++) {
            if (arr[k][prop] === val) {
                return arr[k];
            }
        }
        return undefined;
    };

    var getDigitalRuntime = function getDigitalRuntime(lastData) {
        var runtime = void 0; // = translation.text.UNKNOWN;
        if (lastData === undefined || lastData.regTime === '0001-01-01T00:00:00') {
            runtime = "30+ " + translation.text.DAYS;
        } else {
            runtime = ' ' + millisecondsToStr(moment.utc().valueOf() - (lastData.livePoint === true ? moment(lastData.regTime).valueOf() : moment.utc(lastData.regTime).valueOf()));
        }

        return runtime;
    };

    var getDigitalDataTooltip = function getDigitalDataTooltip(overviewAlarmList, uiDigitalDataArray, lastDigitals) {
        var retVal = '';
        //var separatorAdded = false;

        for (var i = 0; i < uiDigitalDataArray.length; i++) {
            var digitalDataItem = uiDigitalDataArray[i];
            //if (digitalDataItem.digitalMode != 'D' && digitalDataItem.digitalMode != 'A' && !this.contains(overviewAlarmList, digitalDataItem)) { //Disabled inputs should not be displayed on the pop-up info, and Alarm inputs should not be displayed on bottom part of pop-up info
            var lastData = _.find(lastDigitals, function (item) {
                return item === null ? undefined : item.channel === digitalDataItem.input;
            });
            var now = new Date();
            retVal += digitalDataItem.description; //adding channel name and status
            var dt = (uiDigitalDataArray[i].digitalData !== null ? getDigitalRuntime(lastData) : '') + '</br>';
            retVal += digitalDataItem.digitalMode == 'P' ? ' ' + dt : '</br>'; //adding duration if it is pump
            //}
        }

        //clear the uiDigitalData after use
        //this.uiDigitalDataArray = [];
        return retVal;
    };

    var convertStatus = function convertStatus(statusCode, digitalMode, digitalSetting, digitalDescription) {
        var statusMsg = null;
        switch (statusCode) {
            default:
            case "0":
                //Close
                if (digitalMode === "P") {
                    if (digitalSetting.normalClosed) {
                        statusMsg = { statusImage: "pump_off_a.gif", statusMessage: translation.text.STOPPED };
                    } else {
                        statusMsg = { statusImage: "pump_run_a.gif", statusMessage: translation.text.RUNNING };
                    }
                } else if (digitalMode === "S") {
                    if (digitalSetting.normalClosed) {
                        statusMsg = { statusImage: "input_close_a.png", statusMessage: digitalDescription.en.normal };
                    } else {
                        statusMsg = { statusImage: "input_close_a.png", statusMessage: digitalDescription.en.offNormal };
                    }
                }
                break;
            case "1":
                //Open
                if (digitalMode === "P") {
                    if (digitalSetting.normalClosed) {
                        statusMsg = { statusImage: "pump_run_a.gif", statusMessage: translation.text.RUNNING };
                    } else {
                        statusMsg = { statusImage: "pump_off_a.gif", statusMessage: translation.text.STOPPED };
                    }
                } else if (digitalMode === "S") {
                    if (digitalSetting.normalClosed) {
                        statusMsg = { statusImage: "input_open_a.png", statusMessage: digitalDescription.en.offNormal };
                    } else {
                        statusMsg = { statusImage: "input_open_a.png", statusMessage: digitalDescription.en.normal };
                    }
                }
                break;
            case null: //fault
            case "":
                if (digitalMode === "P") {
                    statusMsg = { statusImage: "pump_fault_a.gif", statusMessage: translation.text.FAULT };
                } else if (digitalMode === "S") {
                    statusMsg = { statusImage: "input_fault_a.png", statusMessage: translation.text.FAULT };
                }
                break;
        }
        return statusMsg;
    };

    var getEnggUnit = function getEnggUnit(item) {
        if (!(item.analogMode === 1 || item.analogMode === 0)) {
            return '';
        }

        //var unitMin = 0;
        var unitMax = 0;
        var unit = '';
        var scaledValue = undefined;

        if (item.analogMode === 1) {
            //translate to 4 - 20 mA
            //unitMin = 4;
            unitMax = 20;
            unit = 'mA';
            //Formula --> FormatNumber(20 * RAW_VALUE / 1023,1)
            scaledValue = (unitMax * item.rawVal / 1023).toFixed(1);
        } else if (item.analogMode === 0) {
            //translate to 0 - 5 Volts
            //unitMin = 0;
            unitMax = 5;
            unit = 'Volts';

            //Formula --> FormatNumber(5 * RAW_VALUE / 1023,2) 
            scaledValue = (unitMax * item.rawVal / 1023).toFixed(2);
        }

        //var factor = (unitMax - unitMin) * item.latestData / (item.maxVal - item.minVal);
        //engineering Unit value = factor + unitMin --> per Dave's feedback, no need to add unit Min below.
        //factor = (factor + unitMin).toFixed(2);
        //factor = (factor).toFixed(2);
        //return factor + ' ' + unit;
        return scaledValue + ' ' + unit;
    };

    var getEnggUnitDesc = function getEnggUnitDesc(analogMode) {
        var unit = '';
        if (analogMode === 1) {
            unit = 'mA';
        } else if (analogMode === 0) {
            unit = 'Volts';
        }
        return unit;
    };

    var getTime = function getTime(time) {
        //handling null values for last heard time.
        var mydate = new Date(1970, 1, 1);
        if (time < mydate) return translation.text.NEVER;

        var formatedTime = datetimeService.formatDateAgentText(time, 'yyyy-MM-ddTHH:mm:ss', false, _this.accountInfo.preferenceUser.timeFormat);
        return formatedTime === '0001-01-01T00:00:00' || formatedTime === 'Jan 01 1901 12:00:00 AM' ? translation.text.UNKNOWN : formatedTime;
    };

    var getBatteryVoltage = function getBatteryVoltage(data) {
        if (data && data.rtuDataList && data.rtuDataList.length > 0) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = data.rtuDataList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var rtuData = _step4.value;

                    if (rtuData.name === 'Battery') {
                        return ' => ' + rtuData.value.toFixed(2) + ' ' + rtuData.unit;
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        } else {
            if (data && data.deviceUnitState && angular.isDefined(data.deviceUnitState.lastBatt)) {
                return ' => ' + data.deviceUnitState.lastBatt;
            }
        }
        return '';
    };

    var getStatus = function getStatus(device, accountInfo, isOffline, acFailure, alertOrAlarm) {
        if (device.isDisabled) {
            var disabledUntil = '';

            if (device.disabledUntil) {
                disabledUntil = ' Until: ' + datetimeService.formatDateAgentText(device.disabledUntil, 'yyyy-MM-ddTHH:mm:ss', false, accountInfo.preferenceUser.timeFormat);
            } else {
                disabledUntil = ' ' + translation.text.INDEFINITELY;
            }
            return translation.text.DISABLED + disabledUntil;
        }

        if (device.inServiceMode) {
            var serviceModeEnd = '';

            if (device.serviceModeEnd) {
                serviceModeEnd = ' Until: ' + datetimeService.formatDateAgentText(device.serviceModeEnd, 'yyyy-MM-ddTHH:mm:ss', false, accountInfo.preferenceUser.timeFormat);
            } else {
                serviceModeEnd = ' ' + translation.text.INDEFINITELY;
            }
            return translation.text.SERVICE_MODE + serviceModeEnd;
        }

        // this variable specifies whether we have heard from the device within last 24 hours, 
        // especially for manhole monitor devices which will send communication for every 24 hours
        var nextelOnline = false;
        if (device.lastTimeHeard) {
            var tmpLastHeard = device.lastTimeHeard.replace('T', ' ').replace(/-/g, '/');
            // timeout represents no. of minutes for which given device will send status signal
            var timeout = device.timeout;
            if (timeout <= 5) timeout = 15;
            var _nowDate = currentTime / 1000 / 60 / 60 / 24;
            var _lastHeard = new Date(tmpLastHeard).getTime() / 1000 / 60 / 60 / 24;
            if (_lastHeard > _nowDate - timeout / 1440) nextelOnline = true;
        }

        if (device.lastTimeHeard && (device.deviceType == 20 || device.deviceType == 21)) {
            var nowDate = currentTime / 1000 / 60 / 60 / 24;
            var lastHeard = moment(device.lastTimeHeard).valueOf() / 1000 / 60 / 60 / 24;
            if (lastHeard < nowDate - device.reportingInterval / 1440 - 0.0138) return translation.text.COMM_FAIL;
        } else if (isOffline || !nextelOnline) {
            return translation.text.COMM_FAIL;
        }

        if (acFailure) return !device.solar ? translation.text.AC_FAILURE : translation.text.SOLAR_POWER;

        if (alertOrAlarm) {
            return translation.text.ONLINE;
        }

        if ((device.deviceType === 15 || device.deviceType === 20) && nextelOnline) return translation.text.DEVICE + ' ' + translation.text.OFFLINE;

        return translation.text.ALL_NORMAL;
    };

    var getStatusExt = function getStatusExt(data) {

        var list = [];

        //if (data.deviceUnitState.acFail && !data.deviceUnitState.solar) {
        //    list.push(translation.text.AC_FAILURE);
        //}

        switch (data.deviceUnitState.deviceType) {
            case 10:
            case 15:
            case 20:
                if (data.deviceUnitState.lastBatt < 4.5) {
                    list.push(translation.text.LOW_BATTERY + " " + getBatteryVoltage(data));
                }
                break;
            case 21:
                if (data.deviceUnitState.lastBatt < 3.5) {
                    list.push(translation.text.LOW_BATTERY + " " + getBatteryVoltage(data));
                }
                break;
            default:
                if (data.deviceUnitState.deviceID !== 13822 && data.deviceUnitState.lastBatt < 11.50) {
                    list.push(translation.text.LOW_BATTERY + " " + getBatteryVoltage(data));
                }
                break;
        }

        if (data.deviceUnitState.lastTemp > 120 && data.deviceUnitState.tempUnit === 1) {
            list.push(translation.text.HIGH_TEMP);
        }

        if (data.deviceUnitState.lastTemp > 50 && data.deviceUnitState.tempUnit === 0) {
            list.push(translation.text.HIGH_TEMP);
        }

        return list;
    };

    var millisecondsToStr = function millisecondsToStr(milliseconds) {
        // TIP: to find current time in milliseconds, use:
        // var  current_time_milliseconds = new Date().getTime();

        function numberEnding(number) {
            return number > 1 ? 's' : '';
        }

        var temp = Math.floor(milliseconds / 1000);
        var years = Math.floor(temp / 31536000);
        if (years > 0) {
            return years + ' ' + translation.text.YEAR + numberEnding(years);
        }
        //TODO: Months! Maybe weeks? 
        var days = Math.floor((temp %= 31536000) / 86400);
        if (days) {

            temp = temp - days * 86400;
            var rhours = Math.floor((temp %= 86400) / 3600);
            if (rhours > 0) return days + ' ' + translation.text.DAY + numberEnding(days) + ' ' + rhours + ' ' + translation.text.HOUR + numberEnding(rhours);else return days + ' ' + translation.text.DAY + numberEnding(days);
        }
        var hours = Math.floor((temp %= 86400) / 3600);
        if (hours) {
            temp = temp - hours * 3600;
            var rminutes = Math.floor((temp %= 3600) / 60);
            if (rminutes > 0) return hours + ' ' + translation.text.HOUR + numberEnding(hours) + ' ' + rminutes + ' ' + translation.text.MINUTE + numberEnding(rminutes);else return hours + ' ' + translation.text.HOUR + numberEnding(hours);
        }
        var minutes = Math.floor((temp %= 3600) / 60);
        if (minutes) {
            return minutes + ' ' + translation.text.MINUTE + numberEnding(minutes);
        }
        var seconds = temp % 60;
        if (seconds) {
            return seconds + ' ' + translation.text.SECOND + numberEnding(seconds);
        }
        return translation.text.LESS_THAN_A_SECOND; //'just now' //or other string you like;
    };

    Popup.prototype.getTooltip = function (deviceId, event, top, deviceModel) {
        var _adjTop = angular.isUndefined(top) ? 0 : top;
        var _target = angular.isUndefined(event.currentTarget) ? event.element : event.currentTarget;
        $(".loading-need-to-remove").remove();
        $(event.currentTarget || event.element).tooltip({
            position: { my: 'left top+' + _adjTop, at: 'left bottom', collision: "flip flip" },
            tooltipClass: 'panel panel-default overview-tooltipborder',
            items: ":not([disabled])",
            content: function content() {
                var title = $('<div class="loading-need-to-remove">' + translation.text.LOADING + '...</div>');
                title.appendTo("body");
                return title.html();
            }
        }).tooltip('open');

        // fetch tooltip from the service and attach to the tooltip content.
        Popup.prototype.fetchTooltipData(deviceId, _this.accountInfo.timeZone, deviceModel).then(function (resp) {
            $(_target).tooltip({
                content: resp
            });
            var offset = $('.ui-tooltip').offset();
            if (!angular.isUndefined(offset) || !angular.isUndefined($('.ui-tooltip').css("height"))) {
                var w = angular.element(window);
                if (offset.top + parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) >= w.height()) {
                    $('.ui-tooltip').css("top", w.height() - parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) - 10);
                }
            }
        });
    };
    Popup.prototype.getMarkerTooltip = function (customerId, markerId, event, top) {
        var _adjTop = angular.isUndefined(top) ? 0 : top;
        var _target = angular.isUndefined(event.currentTarget) ? event.element : event.currentTarget;
        $(".loading-need-to-remove").remove();
        $(event.currentTarget || event.element).tooltip({
            position: { my: 'left top+' + _adjTop, at: 'left bottom', collision: "flip flip" },
            tooltipClass: 'panel panel-default overview-tooltipborder',
            items: ":not([disabled])",
            content: function content() {
                var title = $('<div class="loading-need-to-remove">' + translation.text.LOADING + '...</div>');
                title.appendTo("body");
                return title.html();
            }
        }).tooltip('open');

        // fetch tooltip from the service and attach to the tooltip content.
        Popup.prototype.fetchMarkerTooltipData(customerId, markerId).then(function (resp) {
            $(_target).tooltip({
                content: resp
            });
            var offset = $('.ui-tooltip').offset();
            if (!angular.isUndefined(offset) || !angular.isUndefined($('.ui-tooltip').css("height"))) {
                var w = angular.element(window);
                if (offset.top + parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) >= w.height()) {
                    $('.ui-tooltip').css("top", w.height() - parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) - 10);
                }
            }
        });
    };
    Popup.prototype.getRwaTooltip = function (rwaId, event, top) {
        var _adjTop = angular.isUndefined(top) ? 0 : top;
        var _target = angular.isUndefined(event.currentTarget) ? event.element : event.currentTarget;
        $(".loading-need-to-remove").remove();
        $(event.currentTarget || event.element).tooltip({
            position: { my: 'left top+' + _adjTop, at: 'left bottom', collision: "flip flip" },
            tooltipClass: 'panel panel-default overview-tooltipborder',
            items: ":not([disabled])",
            content: function content() {
                var title = $('<div class="loading-need-to-remove">' + translation.text.LOADING + '...</div>');
                title.appendTo("body");
                return title.html();
            }
        }).tooltip('open');

        // fetch tooltip from the service and attach to the tooltip content.
        Popup.prototype.fetchRwaTooltipData(rwaId).then(function (resp) {
            $(_target).tooltip({
                content: resp
            });
            var offset = $('.ui-tooltip').offset();
            if (!angular.isUndefined(offset) || !angular.isUndefined($('.ui-tooltip').css("height"))) {
                var w = angular.element(window);
                if (offset.top + parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) >= w.height()) {
                    $('.ui-tooltip').css("top", w.height() - parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) - 10);
                }
            }
        });
    };
    Popup.prototype.getCustomerTooltip = function (customerId, event, top) {
        var _adjTop = angular.isUndefined(top) ? 0 : top;
        var _target = angular.isUndefined(event.currentTarget) ? event.element : event.currentTarget;
        $(".loading-need-to-remove").remove();
        $(event.currentTarget || event.element).tooltip({
            position: { my: 'left top+' + _adjTop, at: 'left bottom', collision: "flip flip" },
            tooltipClass: 'panel panel-default overview-tooltipborder',
            items: ":not([disabled])",
            content: function content() {
                var title = $('<div class="loading-need-to-remove">' + translation.text.LOADING + '...</div>');
                title.appendTo("body");
                return title.html();
            }
        }).tooltip('open');

        // fetch tooltip from the service and attach to the tooltip content.
        Popup.prototype.fetchCustomerTooltipData(customerId).then(function (resp) {
            $(_target).tooltip({
                content: resp
            });
            var offset = $('.ui-tooltip').offset();
            if (!angular.isUndefined(offset) || !angular.isUndefined($('.ui-tooltip').css("height"))) {
                var w = angular.element(window);
                if (offset.top + parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) >= w.height()) {
                    $('.ui-tooltip').css("top", w.height() - parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) - 10);
                }
            }
        });
    };

    Popup.prototype.getDistributorTooltip = function (distributorId, event, top) {
        var _adjTop = angular.isUndefined(top) ? 0 : top;
        var _target = angular.isUndefined(event.currentTarget) ? event.element : event.currentTarget;
        $(".loading-need-to-remove").remove();
        $(event.currentTarget || event.element).tooltip({
            position: { my: 'left top+' + _adjTop, at: 'left bottom', collision: "flip flip" },
            tooltipClass: 'panel panel-default overview-tooltipborder',
            items: ":not([disabled])",
            content: function content() {
                var title = $('<div class="loading-need-to-remove">' + translation.text.LOADING + '...</div>');
                title.appendTo("body");
                return title.html();
            }
        }).tooltip('open');

        // fetch tooltip from the service and attach to the tooltip content.
        Popup.prototype.fetchDistributorTooltipData(distributorId).then(function (resp) {
            $(_target).tooltip({
                content: resp
            });
            var offset = $('.ui-tooltip').offset();
            if (!angular.isUndefined(offset) || !angular.isUndefined($('.ui-tooltip').css("height"))) {
                var w = angular.element(window);
                if (offset.top + parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) >= w.height()) {
                    $('.ui-tooltip').css("top", w.height() - parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) - 10);
                }
            }
        });
    };

    Popup.prototype.getStatusTooltip = function (gaugeWidget, event, top) {
        var deviceModel = angular.isDefined(gaugeWidget.device) ? gaugeWidget.device.model : 0;
        var flipBit = deviceModel >= 20;
        var _gaugeType;
        if (angular.isDefined(gaugeWidget.statusGauge)) _gaugeType = gaugeWidget.statusGauge;
        if (angular.isDefined(gaugeWidget.runtimeGauge)) _gaugeType = gaugeWidget.runtimeGauge;
        if (angular.isDefined(gaugeWidget.switchGauge)) _gaugeType = gaugeWidget.switchGauge;
        if (angular.isUndefined(_gaugeType)) return;

        var _adjTop = angular.isUndefined(top) ? 0 : top;
        var _target = angular.isUndefined(event.currentTarget) ? event.element : event.currentTarget;
        $(".loading-need-to-remove").remove();
        $(event.currentTarget || event.element).tooltip({
            position: { my: 'left top+' + _adjTop, at: 'left bottom', collision: "flip flip" },
            tooltipClass: 'tooltip-jq-popup-service-I',
            items: ":not([disabled])",
            //track: true,
            content: function content() {
                var title = $('<div class="loading-need-to-remove">' + translation.text.LOADING + '...</div>');
                title.appendTo("body");
                return title.html();
            }
        }).tooltip('open');

        // build tooltip and attach to the tooltip content.

        var inputState;
        switch (gaugeWidget.deviceDigitalData["d" + _gaugeType.channel]) {
            case "True":
                inputState = translation.text.OPEN;
                break;

            case "False":
                inputState = translation.text.CLOSE;
                break;
            case "NULL":
            case "Fault":
                inputState = translation.text.FAULT;
                break;
            default:
                inputState = translation.text.UNKNOWN;

        }

        var _calculateDuration = function _calculateDuration(_utcNow, resp) {
            var _duration = millisecondsToStr(new Date(_utcNow).getTime() - new Date(resp.data.replace(/-/g, '/').replace('T', ' ')).getTime());
            if (new Date(_utcNow).getTime() - new Date(resp.data.replace(/-/g, '/').replace('T', ' ')).getTime() < 0) {
                return "1" + ' ' + translation.text.SECOND;
            } else {
                return _duration;
            }
        };

        digitalGaugeService.getMostRecentData(gaugeWidget.device.deviceId, _gaugeType.channel, _this.accountInfo.timeZone, _convertValueToInt(gaugeWidget.deviceDigitalData["d" + _gaugeType.channel], flipBit)).then(function (resp) {
            var _utcNow = $rootScope.heartbeatUtcDateTime || moment().utc().format('MM/DD/YY, h:mm:ss a').valueOf();
            //https://stackoverflow.com/questions/13363673/javascript-date-is-invalid-on-ios
            var _duration = resp.data === "0001-01-01T00:00:00" ? "6+ " + translation.text.MONTHS : _calculateDuration(_utcNow, resp);
            var tooltip = '';
            tooltip += '<div style=\'text-align: left;\'>' + (translation.text.INPUT + " " + _gaugeType.channel) + ': ' + _gaugeType.description + '</div>';
            tooltip += '<div style=\'text-align: left;\'>' + (translation.text.STATUS + ": " + inputState) + '</div>';
            tooltip += '<div style=\'text-align: left;\'>' + (translation.text.DURATION + ": " + _duration) + '</div>';
            $(_target).tooltip({
                content: tooltip
            });
            var offset = $('.ui-tooltip').offset();
            if (!angular.isUndefined(offset) || !angular.isUndefined($('.ui-tooltip').css("height"))) {
                var w = angular.element(window);
                if (offset.top + parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) >= w.height()) {
                    $('.ui-tooltip').css("top", w.height() - parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) - 10);
                }
            }
        });
    };

    Popup.prototype.getWidgetStatusTooltip = function (gaugeWidget, event, top, hudObj) {
        var _gaugeType;
        if (angular.isDefined(gaugeWidget.statusGauge)) _gaugeType = gaugeWidget.statusGauge;
        if (angular.isDefined(gaugeWidget.runtimeGauge)) _gaugeType = gaugeWidget.runtimeGauge;
        if (angular.isDefined(gaugeWidget.switchGauge)) _gaugeType = gaugeWidget.switchGauge;
        if (angular.isDefined(gaugeWidget.pumpStationGauge)) _gaugeType = gaugeWidget.pumpStationGauge;
        if (angular.isUndefined(_gaugeType)) return;

        var _adjTop = angular.isUndefined(top) ? 0 : top;
        var _target = angular.isUndefined(event.currentTarget) ? event.element : event.currentTarget;
        $(".loading-need-to-remove").remove();
        $(event.currentTarget || event.element).tooltip({
            position: { my: 'left top+' + _adjTop, at: 'left bottom', collision: "flip flip" },
            tooltipClass: 'tooltip-jq-popup-service-I' + (hudObj.theme != null ? ' ' + 'mc-widget-theme-' + hudObj.theme : ''),
            items: ":not([disabled])",
            //track: true,
            content: function content() {
                var title = $('<div class="loading-need-to-remove">' + translation.text.LOADING + '...</div>');
                title.appendTo("body");
                return title.html();
            }
        }).tooltip('open');

        // build tooltip and attach to the tooltip content.

        var tooltip = '';
        tooltip += '<div style=\'text-align: center;\'>' + hudObj.inputStatus + '</div>';
        tooltip += '<div style=\'text-align: left;\'>&nbsp;</div>';
        tooltip += '<div style=\'text-align: center;\'>' + hudObj.timeStampA + '</div>';
        tooltip += '<div style=\'text-align: center;\'>' + hudObj.timeStampB + '</div>';

        $(_target).tooltip({
            content: tooltip
        });
        var offset = $('.ui-tooltip').offset();
        if (!angular.isUndefined(offset) || !angular.isUndefined($('.ui-tooltip').css("height"))) {
            var w = angular.element(window);
            if (offset.top + parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) >= w.height()) {
                $('.ui-tooltip').css("top", w.height() - parseInt($('.ui-tooltip').css("height").replace(/[^0-9.]+/g, "")) - 10);
            }
        }
    };

    Popup.prototype.destroyTooltip = function (event) {
        var _target = angular.isUndefined(event.currentTarget) ? event.element : event.currentTarget;
        if ($(_target).is(':ui-tooltip')) {
            $(_target).tooltip('close');
            $(_target).tooltip('destroy');
        }
        $(".loading-need-to-remove").remove();
    };

    var _convertValueToInt = function _convertValueToInt(value, flipBit) {
        return flipBit ? _convertValueToIntegerFlip(value) : _convertValueToInteger(value);
    };

    var _convertValueToInteger = function _convertValueToInteger(value) {
        switch (value) {
            case "False":
                return 0;
            case "True":
                return 1;
            case "NULL":
                return null;
        }
        return null;
    };

    var _convertValueToIntegerFlip = function _convertValueToIntegerFlip(value) {
        switch (value) {
            case "False":
                return 1;
            case "True":
                return 0;
            case "NULL":
                return null;
        }
        return null;
    };

    var isValidDate = function isValidDate(d) {
        return d instanceof Date && !isNaN(d);
    };

    Popup.prototype.datetime_difference = function (date1, date2) {

        if (date1 === "0001-01-01T00:00:00") return "6+ " + translation.text.MONTHS;

        var unixDate1 = new Date(date1).getTime();
        var unixDate2 = new Date(date2).getTime();
        var difference = unixDate2 - unixDate1;

        var secondsDifference = (difference / 1000).toFixed(1);
        if (secondsDifference < 60) {
            if (secondsDifference > 1) return _checkIfDecimalIsNeeded(secondsDifference) + ' ' + translation.text.SECONDS;
            if (secondsDifference > 0 && secondsDifference <= 1) return _checkIfDecimalIsNeeded(secondsDifference) + ' ' + translation.text.SECOND;
            if (secondsDifference <= 0) return '0 ' + translation.text.SECOND;
            return translation.text.LOADING;
        }

        var minutesDifference = (difference / 1000 / 60).toFixed(1);
        if (minutesDifference < 60) {
            if (minutesDifference > 1) return _checkIfDecimalIsNeeded(minutesDifference) + ' ' + translation.text.MINUTES;
            if (minutesDifference <= 1) return _checkIfDecimalIsNeeded(minutesDifference) + ' ' + translation.text.MINUTE;
        }

        var hoursDifference = (difference / 1000 / 60 / 60).toFixed(1);
        if (hoursDifference < 60) {
            if (hoursDifference > 1) return _checkIfDecimalIsNeeded(hoursDifference) + ' ' + translation.text.HOURS;
            if (hoursDifference <= 1) return _checkIfDecimalIsNeeded(hoursDifference) + ' ' + translation.text.HOUR;
        }

        var daysDifference = (difference / 1000 / 60 / 60 / 24).toFixed(1);
        return '' + (daysDifference <= 1 ? _checkIfDecimalIsNeeded(daysDifference) + ' ' + translation.text.DAY : _checkIfDecimalIsNeeded(daysDifference) + ' ' + translation.text.DAYS);
    };

    var _checkIfDecimalIsNeeded = function _checkIfDecimalIsNeeded(number) {
        if (Math.round(number) != number) {
            return number;
        }
        return parseInt(number);
    };

    return Popup;
}

PopupFactory.$inject = ['_', '$rootScope', 'HOST', '$http', 'datetimeService', 'timeLapseService', 'translationService', '$sanitize', '$q', 'digitalGaugeService'];

angular.module('mc.overview').factory('PopupFactory', PopupFactory);
mcapp.directive('onFinishRender', ["$timeout", function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$first === true) {
                $timeout(function () {
                    scope.$emit('ngRepeatFinished');
                    if (typeof scope.adjustSize == 'function')
                        scope.adjustSize();
                    if (typeof scope.setSorting == 'function')
                        scope.setSorting();
                });
            }
        }
    };
    }]);
/*
 * native-bridge-service.js
 * ------------------------
 * Suggested location: app/src/ui/components/services/native-bridge-service.js
 * (alongside text-to-speech-service.js), and add it to whatever bundle
 * produces min/ui.min.js.
 *
 * One place that knows how to talk to the device, so controllers do not.
 *
 * The same deployed web app is loaded by three different clients and all three
 * have to keep working:
 *
 *   1. The Capacitor app (2.x)      - window.Capacitor is present
 *   2. The Cordova app (1.1.91)     - still installed in the field, and it
 *                                     loads cordovadist/<platform>/cordova.js
 *                                     exactly as it always has
 *   3. A desktop browser            - no native bridge at all
 *
 * Detection is per call, not cached at load, because the Capacitor bridge is
 * injected before page scripts but Cordova's arrives asynchronously with
 * deviceready.
 *
 * Button indices follow the Cordova convention throughout - 1-based, with 0
 * for a dismissal - so existing callbacks such as dismissedFoundDevice keep
 * their switch statements unchanged.
 */
mcapp.factory('nativeBridge', ['$q', function ($q) {

    function capPlugins() {
        var C = window.Capacitor;
        if (C && C.Plugins && typeof C.isNativePlatform === 'function' && C.isNativePlatform()) {
            return C.Plugins;
        }
        return null;
    }

    function cordovaNotification() {
        // Only trust this once the Cordova bridge has actually initialised.
        return window.cordova && navigator.notification ? navigator.notification : null;
    }

    /* ----------------------------------------------------------------
     * beep
     *
     * Capacitor has no beep. Synthesised with Web Audio rather than a native
     * audio plugin on purpose: a bundled sound file would live inside the
     * native binary, so changing the alert tone would need an app store
     * release for every platform.
     * -------------------------------------------------------------- */
    var audioCtx = null;

    function tone() {
        try {
            var Ctx = window.AudioContext || window.webkitAudioContext;
            if (!Ctx) return;
            if (!audioCtx) audioCtx = new Ctx();
            if (audioCtx.state === 'suspended') audioCtx.resume();

            var osc = audioCtx.createOscillator();
            var gain = audioCtx.createGain();
            osc.type = 'sine';
            osc.frequency.value = 880;
            gain.gain.setValueAtTime(0.0001, audioCtx.currentTime);
            gain.gain.exponentialRampToValueAtTime(0.25, audioCtx.currentTime + 0.01);
            gain.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 0.22);
            osc.connect(gain).connect(audioCtx.destination);
            osc.start();
            osc.stop(audioCtx.currentTime + 0.24);
        } catch (e) {
            /* an alert tone must never break an alarm screen */
        }
    }

    // A WebView will not start an AudioContext without a user gesture.
    ['touchend', 'click'].forEach(function (evt) {
        document.addEventListener(evt, function primer() {
            try {
                var Ctx = window.AudioContext || window.webkitAudioContext;
                if (Ctx && !audioCtx) audioCtx = new Ctx();
                if (audioCtx && audioCtx.state === 'suspended') audioCtx.resume();
            } catch (e) { /* ignore */ }
            document.removeEventListener(evt, primer);
        }, { once: true });
    });

    return {

        /** True when running inside either native shell. */
        isNative: function () {
            return !!(capPlugins() || cordovaNotification());
        },

        beep: function (times) {
            var n = Math.max(1, times || 1);
            var cordovaNotif = cordovaNotification();
            if (cordovaNotif && !capPlugins()) {
                cordovaNotif.beep(n);
                return;
            }
            for (var i = 0; i < n; i++) {
                setTimeout(tone, i * 450);
            }
        },

        /**
         * @returns promise resolved when the dialog is dismissed.
         */
        alert: function (message, title, buttonName) {
            var P = capPlugins();
            if (P) {
                return $q.when(
                    P.Dialog.alert({
                        title: title || 'Alert',
                        message: String(message),
                        buttonTitle: buttonName || 'OK'
                    })
                );
            }

            var cordovaNotif = cordovaNotification();
            if (cordovaNotif) {
                var d = $q.defer();
                cordovaNotif.alert(message, function () { d.resolve(); }, title, buttonName || 'OK');
                return d.promise;
            }

            window.alert((title ? title + '\n\n' : '') + message);
            return $q.when();
        },

        /**
         * Two or more choices.
         *
         * @param labels array of button captions, in display order
         * @returns promise resolved with a 1-based index, or 0 if dismissed
         *
         * Capacitor's Dialog.confirm only supports two buttons, so anything
         * with three or more goes to the action sheet instead. That is the
         * case for mobileAppFoundDevice - Info / Data / Config - which would
         * silently lose its third option on Dialog.confirm.
         */
        confirm: function (message, title, labels) {
            labels = labels && labels.length ? labels : ['OK', 'Cancel'];

            var P = capPlugins();
            if (P) {
                if (labels.length > 2) {
                    return $q.when(
                        P.ActionSheet.showActions({
                            title: title || '',
                            message: String(message),
                            options: labels.map(function (l) { return { title: l }; }),
                            cancelable: true
                        })
                    ).then(function (r) {
                        // Cordova gave 0 for a dismissal; preserve that so the
                        // existing switch statements behave the same way.
                        return r && r.canceled ? 0 : r.index + 1;
                    });
                }

                return $q.when(
                    P.Dialog.confirm({
                        title: title || 'Confirm',
                        message: String(message),
                        okButtonTitle: labels[0],
                        cancelButtonTitle: labels[1]
                    })
                ).then(function (r) {
                    return r.value ? 1 : 2;
                });
            }

            var cordovaNotif = cordovaNotification();
            if (cordovaNotif) {
                var d = $q.defer();
                cordovaNotif.confirm(message, function (i) { d.resolve(i); }, title, labels);
                return d.promise;
            }

            // Browser: only two outcomes are possible, so offer the first
            // choice and treat anything else as the second.
            var ok = window.confirm((title ? title + '\n\n' : '') + message + '\n\n' + labels[0] + '?');
            return $q.when(ok ? 1 : 2);
        }
    };
}]);

"use strict";

angular.module("mc.gauges-shared", []);
"use strict";

function McWidgetsSharedFactory(translationService, authenticationService, $timeout, McGaugesSharedFactory) {

    /////////////////////////////////////////////////////////////////////////////
    var _hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");

    var _getHex = function _getHex(x) {
        return isNaN(x) ? "00" : _hexDigits[(x - x % 16) / 16] + _hexDigits[x % 16];
    };

    /////////////////////////////////////////////////////////////////////////////

    var McWidget = function McWidget() {
        //this.colorPalet = [{ name: "Lime", color: "#a4c400" }, { name: "Green", color: "#60a917" }, { name: "Emerald", color: "#008a00" }, { name: "Teal", color: "#00aba9" }, { name: "Cyan", color: "#1ba1e2" }, { name: "Cobalt", color: "#0050ef" }, { name: "Indigo", color: "#6a00ff" }, { name: "Violet", color: "#aa00ff" }, { name: "Pink", color: "#f472d0" }, { name: "Magenta", color: "#d80073" }, { name: "Crimson", color: "#a20025" }, { name: "Red", color: "#e51400" }, { name: "Orange", color: "#fa6800" }, { name: "Amber", color: "#f0a30a" }, { name: "Yellow", color: "#e3c800" }, { name: "Brown", color: "#825a2c" }, { name: "Olive", color: "#6d8764" }, { name: "Steel", color: "#647687" }, { name: "Mauve", color: "#76608a" }, { name: "Sienna", color: "#a0522d" }];
        //this.customerId = customerId;
    };

    /////////////////////////////////////////////////////////////////////////////
    ///////////////////        Setting - <start>       //////////////////////////
    /////////////////////////////////////////////////////////////////////////////
    McWidget.prototype.getColorPalet = function () {
        return [{ name: "Lime", color: "#a4c400" }, { name: "Green", color: "#60a917" }, { name: "Emerald", color: "#008a00" }, { name: "Teal", color: "#00aba9" }, { name: "Cyan", color: "#1ba1e2" }, { name: "Cobalt", color: "#0050ef" }, { name: "Indigo", color: "#6a00ff" }, { name: "Violet", color: "#aa00ff" }, { name: "Pink", color: "#f472d0" }, { name: "Magenta", color: "#d80073" }, { name: "Crimson", color: "#a20025" }, { name: "Red", color: "#e51400" }, { name: "Orange", color: "#fa6800" }, { name: "Amber", color: "#f0a30a" }, { name: "Yellow", color: "#e3c800" }, { name: "Brown", color: "#825a2c" }, { name: "Olive", color: "#6d8764" }, { name: "Steel", color: "#647687" }, { name: "Mauve", color: "#76608a" }, { name: "Sienna", color: "#a0522d" }];
    };

    //Function to convert rgb color to hex format
    McWidget.prototype.rgb2hex = function (rgb) {
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return "#" + _getHex(rgb[1]) + _getHex(rgb[2]) + _getHex(rgb[3]);
    };

    McWidget.prototype.showTab = function (parm, element, ctrl) {

        element.find("a").removeClass("active");

        switch (parm) {
            case "source":
                ctrl.tabSource_Style = ctrl.w_tabpaneIsOpen;
                ctrl.tabGraphic_Style = ctrl.w_tabpaneIsClosed;
                ctrl.tabOptions_Style = ctrl.w_tabpaneIsClosed;
                ctrl.tabColor_Style = ctrl.w_tabpaneIsClosed;
                break;
            case "graphic":
                ctrl.tabSource_Style = ctrl.w_tabpaneIsClosed;
                ctrl.tabGraphic_Style = ctrl.w_tabpaneIsOpen;
                ctrl.tabOptions_Style = ctrl.w_tabpaneIsClosed;
                ctrl.tabColor_Style = ctrl.w_tabpaneIsClosed;
                break;
            case "options":
                ctrl.tabSource_Style = ctrl.w_tabpaneIsClosed;
                ctrl.tabGraphic_Style = ctrl.w_tabpaneIsClosed;
                ctrl.tabOptions_Style = ctrl.w_tabpaneIsOpen;
                ctrl.tabColor_Style = ctrl.w_tabpaneIsClosed;
                break;
            case "color":
                ctrl.tabSource_Style = ctrl.w_tabpaneIsClosed;
                ctrl.tabGraphic_Style = ctrl.w_tabpaneIsClosed;
                ctrl.tabOptions_Style = ctrl.w_tabpaneIsClosed;
                ctrl.tabColor_Style = ctrl.w_tabpaneIsOpen;
                break;
            default:
            // code block
        }

        element.find(".w_" + parm).addClass("active");
    };

    /////////////////////////////////////////////////////////////////////////////
    ///////////////////        Setting - <end>       ////////////////////////////
    /////////////////////////////////////////////////////////////////////////////


    /////////////////////////////////////////////////////////////////////////////
    ///////////////////        Get/Update UI Data - <start>       ///////////////
    /////////////////////////////////////////////////////////////////////////////

    McWidget.prototype.getUiData = function (settingOptions, uiOptions, ctrl) {
        var _mcGaugesSharedFactory = new McGaugesSharedFactory(uiOptions);
        ctrl[settingOptions] = _mcGaugesSharedFactory.get();
        if (ctrl[settingOptions].length === 0) {
            _mcGaugesSharedFactory.getUiData().then(function () {
                ctrl.loadingInProgress = false;
                ctrl[settingOptions] = _mcGaugesSharedFactory.list;
                ctrl.setOptions();
                ctrl.translateOptions();
                ctrl.getSetting();
            }, function (error) {
                console.log(error);
                ctrl.loadingInProgress = false;
            });
        } else {
            ctrl.setOptions();
            ctrl.translateOptions();
            ctrl.getSetting();
        }
    };

    McWidget.prototype.updateUiData = function (param, naws, uiType, uiNewOptions, ctrl) {
        var _mcWidgetSettingFactory = new McGaugesSharedFactory(uiType);

        _mcWidgetSettingFactory.putUiData(ctrl.accountInfo.customerId, naws).then(function () {
            ctrl.loadingInProgress = false;
            ctrl[uiNewOptions] = _mcWidgetSettingFactory.list;
            ctrl.changeDisplayOptions(param);
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };
    /////////////////////////////////////////////////////////////////////////////
    ///////////////////        Get/Update UI Data - <end>       /////////////////
    /////////////////////////////////////////////////////////////////////////////

    McWidget.prototype.runTranslator = function (text, translator) {
        if (!angular.isDefined(text)) return;
        return translator.text[text.toUpperCase().replace(/ /g, "_")];
    };

    McWidget.prototype.setTitle = function (element, deviceName, channelDescription, titleId) {
        var _titleDsc = channelDescription.length > 0 ? deviceName + ", " + channelDescription : deviceName;
        var _spanColor = "";
        if (titleId === 1) {
            _titleDsc = "&nbsp;";
            _spanColor = "transparent";
        }
        element.closest(".ui-dialog").find(".ui-dialog-title").html(_titleDsc).css({ 'background-color': _spanColor, 'border-color': _spanColor });
    };

    McWidget.prototype.editSetting = function (element, event, ctrl) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            if (ctrl.action_EditMode === 'Yes') return;
        }
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        element.removeClass("dragwidget");
        ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleEdit;
        ctrl.action_EditMode = 'Yes';
        //ctrl.settingShow();
        $timeout(function () {
            var minWidthHeight = 350;
            if (minWidthHeight > ctrl.svgSizeW) {
                ctrl.w_gaugeDataBoxStyleEdit["margin-left"] = -(minWidthHeight - ctrl.svgSizeW) / 2 + "px";
                ctrl.w_gaugeDataBoxStyleEdit["margin-right"] = -(minWidthHeight - ctrl.svgSizeW) / 2 + "px";
                ctrl.w_gaugeDataBoxStyleEdit["min-width"] = minWidthHeight + "px";
                ctrl.w_gaugeDataBoxStyleEdit["min-height"] = minWidthHeight + "px";
            }

            $timeout(function () {
                var offset = element.find('.gaugeDataBox').offset();
                if (!angular.isUndefined(offset) || !angular.isUndefined(element.find('.gaugeDataBox').css("height"))) {
                    var w = angular.element(window);
                    if (offset.top + parseInt(element.find('.gaugeDataBox').css("height")) >= w.height()) {
                        element.find('.gaugeDataBox').css("bottom", "unset").animate({
                            top: w.height() - offset.top - parseInt(element.find('.gaugeDataBox').css("height")) + "px"
                        }, 0, "easeOutExpo");
                    }
                    if (offset.left + parseInt(element.find('.gaugeDataBox').css("width")) >= w.width()) {
                        element.find('.gaugeDataBox').css("left", "unset").animate({
                            right: offset.left + parseInt(element.find('.gaugeDataBox').css("width")) - w.width() + "px"
                        }, 0, "easeOutExpo");
                    }
                    if (offset.left < 0) {
                        element.find('.gaugeDataBox').animate({
                            left: -offset.left + "px"
                        }, 0, "easeOutExpo");
                    }
                }
            }, 500);
        }, 200);
    };

    McWidget.prototype.closeSetting = function (element, ctrl) {
        element.addClass("dragwidget");
        ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleRead;
        ctrl.action_EditMode = 'No';

        $timeout(function () {
            element.find('.gaugeDataBox').css("bottom", "unset").css("right", "unset").css("top", 0).css("left", 0);
            if (angular.isFunction(ctrl.resize_HUDBoxes)) ctrl.resize_HUDBoxes(); //Analog Widget only
        }, 0);
    };

    McWidget.prototype.resizeHud = function (w_svgSizeW, w_svgSizeH, ctrl, callback) {

        // Setup HUD Outer Container Box Height (Display Mode)
        // ------------------------------------------------------------------------------------------
        ctrl.w_hudWidth = 38 / 100; // Set the fractional width of outer container (gaugeDataBox - Default)
        ctrl.w_hudWidth_Editmode = '400'; // Set the pixel width of outer container (gaugeDataBox - EditMode)

        ctrl.w_hudWidthPX = w_svgSizeW * ctrl.w_hudWidth; // Calc pixel width of outer container (gaugeDataBox)
        ctrl.w_hudSidesPX = (w_svgSizeW - ctrl.w_hudWidthPX) / 2; // Calc HUD side margins (Used to center HUD)

        // Setup HUD Outer Container Box Height (Edit Mode)
        // ------------------------------------------------------------------------------------------
        ctrl.w_hudWidth_EditmodePX = ctrl.w_hudWidth_Editmode;
        ctrl.w_hudSides_EditmodePX = (w_svgSizeW - ctrl.w_hudWidth_EditmodePX) / 2;

        // Setup HUD Outer Container Box Width (Display Mode - Default)
        // ------------------------------------------------------------------------------------------        
        ctrl.w_hudHeight_Default = 40 / 100; // set fractional height of outer container (gaugeDataBox - Default)               
        ctrl.w_hudHeight_DefaultPX = w_svgSizeH * ctrl.w_hudHeight_Default; // Calc HUD outer height
        if (ctrl.analogType == "Standpipe Storage Tank" || ctrl.analogType == "Hydro Pneumatic Tank") {
            ctrl.w_hudTop_DefaultPX = w_svgSizeH - ctrl.w_hudHeight_DefaultPX + 0.08 * w_svgSizeH; // Calc HUD top margin
        } else {
            ctrl.w_hudTop_DefaultPX = w_svgSizeH - ctrl.w_hudHeight_DefaultPX; // Calc HUD top margin
        }

        // Setup HUD Outer Container Box Width (Display Mode - Default / Active)
        // ------------------------------------------------------------------------------------------
        ctrl.w_hudHeight_Active = 60 / 100; // set fractional height of outer container (gaugeDataBox - MouseOver)
        ctrl.w_hudHeight_ActivePX = w_svgSizeH * ctrl.w_hudHeight_Active; // Calc HUD outer height
        ctrl.w_hudTop_ActivePX = w_svgSizeH - ctrl.w_hudHeight_ActivePX; // Calc HUD top margin

        // Setup HUD Outer Container Box Width an Height (Edit Mode)
        // ------------------------------------------------------------------------------------------
        ctrl.w_hudHeight_Editmode = 100 / 100; // set fractional height of outer container (gaugeDataBox - EditMode)
        ctrl.w_hudHeight_EditmodePX = w_svgSizeH * ctrl.w_hudHeight_Editmode; // Calc HUD outer height
        ctrl.w_hudTop_EditmodePX = (w_svgSizeH - ctrl.w_hudHeight_EditmodePX) / 2; // Calc HUD top margin

        // Create NG-Styles from above logic
        // ------------------------------------------------------------------------------------------
        ctrl.w_gaugeDataBoxStyleEdit = {
            "width": 100 + "%",
            "margin-left": 0 + "px",
            "margin-right": 0 + "px",
            "height": ctrl.w_hudHeight_EditmodePX + "px",
            "margin-top": ctrl.w_hudTop_EditmodePX + "px",
            "min-width": "0",
            "min-height": "0"
        };
        ctrl.w_gaugeDataBoxStyleOver = {
            "width": ctrl.w_hudWidthPX + "px",
            "margin-left": ctrl.w_hudSidesPX + "px",
            "margin-right": ctrl.w_hudSidesPX + "px",
            "height": ctrl.w_hudHeight_ActivePX + "px",
            "margin-top": ctrl.w_hudTop_ActivePX + "px",
            "min-width": "0",
            "min-height": "0"
        }; //{ "height": ctrl.w_hudHeight_ActivePX + "px", "margin-top": ctrl.w_hudTop_ActivePX + "px" };
        ctrl.w_gaugeDataBoxStyleOff = {
            "width": ctrl.w_hudWidthPX + "px",
            "margin-left": ctrl.w_hudSidesPX + "px",
            "margin-right": ctrl.w_hudSidesPX + "px",
            "height": ctrl.w_hudHeight_DefaultPX + "px",
            "margin-top": ctrl.w_hudTop_DefaultPX + "px",
            "min-width": "0",
            "min-height": "0"
        }; //{ "height": ctrl.w_hudHeight_DefaultPX + "px", "margin-top": ctrl.w_hudTop_DefaultPX + "px" };

        if (angular.isFunction(callback)) {
            //Analog only for now
            ctrl.w_gaugeDataBoxStyleRead = {
                "width": ctrl.w_hudWidthPX + "px",
                "margin-left": ctrl.w_hudSidesPX + "px",
                "margin-right": ctrl.w_hudSidesPX + "px",
                "height": ctrl.w_hudHeight_DefaultPX + "px",
                "margin-top": ctrl.w_hudTop_DefaultPX + "px",
                "min-width": "0",
                "min-height": "0"
            };
        } else {
            ctrl.w_gaugeDataBoxStyleRead = { "display": "none" };
        }

        ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleRead;
        if (angular.isFunction(callback)) callback(w_svgSizeW); //Analog only for now
    };

    McWidget.prototype.getSize = function (sizeId, sizeFactor) {
        switch (parseInt(sizeId)) {
            case 1:
                //"Extra Small":
                return { width: Math.round(150 / sizeFactor), height: Math.round(150 / sizeFactor) };
            case 2:
                //"Small":
                return { width: Math.round(230 / sizeFactor), height: Math.round(230 / sizeFactor) };
            case 3:
                //"Medium":
                return { width: Math.round(350 / sizeFactor), height: Math.round(350 / sizeFactor) };
            case 4:
                //"Large":
                return { width: Math.round(450 / sizeFactor), height: Math.round(450 / sizeFactor) };
            case 5:
                //"Extra Large":
                return { width: Math.round(600 / sizeFactor), height: Math.round(600 / sizeFactor) };
            case 88:
                //"TEST TEST TEST TEST":
                return { width: Math.round(300 / sizeFactor / 3), height: Math.round(350 / sizeFactor / 3) };
            default:
                return { width: Math.round(230 / sizeFactor), height: Math.round(230 / sizeFactor) };
        }
    };

    McWidget.prototype.getSizeNew = function (sizeId, sizeFactor, pumpType) {
        sizeFactor = pumpType === "Vertical Turbine Pump" ? .8 : sizeFactor;
        switch (parseInt(sizeId)) {
            case 1:
                //"Extra Small": 
                switch (pumpType) {
                    case "Booster Pump":
                        return { width: Math.round(28 / sizeFactor), height: Math.round(28 / sizeFactor) };
                    case "Blower Pump":
                        return { width: Math.round(30 / sizeFactor), height: Math.round(30 / sizeFactor) };
                    case "Submersible Pump":
                        return { width: Math.round(40 / sizeFactor), height: Math.round(40 / sizeFactor) };
                    case "Vane Pump":
                        return { width: Math.round(48 / sizeFactor), height: Math.round(48 / sizeFactor) };
                    case "Centrifugal Pump":
                        return { width: Math.round(55 / sizeFactor), height: Math.round(55 / sizeFactor) };
                    case "In Line Pump":
                        return { width: Math.round(55 / sizeFactor), height: Math.round(55 / sizeFactor) };
                    case "Waste Water Submersible Pump":
                        return { width: Math.round(52 / sizeFactor), height: Math.round(52 / sizeFactor) };
                    case "Vertical Turbine Pump":
                        return { width: Math.round(25.6 / sizeFactor), height: Math.round(16 / sizeFactor) };
                    case "Grinder Pump":
                        return { width: Math.round(32 / sizeFactor), height: Math.round(20 / sizeFactor) };
                    case "Standby Generator":
                        return { width: Math.round(32 / sizeFactor), height: Math.round(32 / sizeFactor) };
                    case "Control Valve":
                        return { width: Math.round(32 / sizeFactor), height: Math.round(32 / sizeFactor) };
                    case "Altitude Valve":
                        return { width: Math.round(32 / sizeFactor), height: Math.round(32 / sizeFactor) };
                    default:
                        return { width: Math.round(50 / sizeFactor), height: Math.round(50 / sizeFactor) };
                }
            case 2:
                //"Small":
                return { width: Math.round(100 / sizeFactor), height: Math.round(100 / sizeFactor) };
            case 3:
                //"Medium":
                return { width: Math.round(200 / sizeFactor), height: Math.round(200 / sizeFactor) };
            case 4:
                //"Large":
                return { width: Math.round(250 / sizeFactor), height: Math.round(250 / sizeFactor) };
            case 5:
                //"Extra Large":
                return { width: Math.round(300 / sizeFactor), height: Math.round(300 / sizeFactor) };
            case 88:
                //"TEST TEST TEST TEST":
                return { width: Math.round(200 / sizeFactor), height: Math.round(350 / sizeFactor) };
            default:
                return { width: Math.round(200 / sizeFactor), height: Math.round(200 / sizeFactor) };
        }
    };

    McWidget.prototype.getSizeTemperatureWidget = function (sizeId, sizeFactor) {
        switch (parseInt(sizeId)) {
            case 1:
                //"Extra Small":
                return { width: Math.round(50 / sizeFactor), height: Math.round(50 / sizeFactor) };
            case 2:
                //"Small":
                return { width: Math.round(130 / sizeFactor), height: Math.round(130 / sizeFactor) };
            case 3:
                //"Medium":
                return { width: Math.round(200 / sizeFactor), height: Math.round(200 / sizeFactor) };
            case 4:
                //"Large":
                return { width: Math.round(250 / sizeFactor), height: Math.round(250 / sizeFactor) };
            case 5:
                //"Extra Large":
                return { width: Math.round(300 / sizeFactor), height: Math.round(300 / sizeFactor) };
            default:
                return { width: Math.round(200 / sizeFactor), height: Math.round(200 / sizeFactor) };
        }
    };

    McWidget.prototype.getPumpStationSize = function (sizeId, sizeFactor) {
        switch (parseInt(sizeId)) {
            case 1:
                //"Extra Small":
                return { width: Math.round(300 / sizeFactor), height: Math.round(300 / sizeFactor) };
            case 2:
                //"Small":
                return { width: Math.round(350 / sizeFactor), height: Math.round(350 / sizeFactor) };
            case 3:
                //"Medium":
                return { width: Math.round(400 / sizeFactor), height: Math.round(400 / sizeFactor) };
            case 4:
                //"Large":
                return { width: Math.round(430 / sizeFactor), height: Math.round(430 / sizeFactor) };
            case 5:
                //"Extra Large":
                return { width: Math.round(460 / sizeFactor), height: Math.round(460 / sizeFactor) };
            case 6:
                //"Pump Station View":
                return { width: Math.round(380 / sizeFactor), height: Math.round(460 / sizeFactor) };
            default:
                return { width: Math.round(350 / sizeFactor), height: Math.round(350 / sizeFactor) };
        }
    };

    McWidget.prototype.getWidgetCategoryIdByPumpType = function (pumpType) {

        var _pumpType = angular.isUndefined(pumpType) ? "" : pumpType;

        switch (_pumpType.toUpperCase()) {
            case "STANDBY GENERATOR":
                return 7;
            case "CONTROL VALVE":
            case "ALTITUDE VALVE":
                return 8;
            default:
                return 3;
        }
    };

    McWidget.prototype.getWidgetIdByPumpType = function (pumpType) {

        var _pumpType = angular.isUndefined(pumpType) ? "" : pumpType;

        switch (_pumpType.toUpperCase()) {
            case "BOOSTER PUMP":
                return 3;
            case "SUBMERSIBLE PUMP":
                return 5;
            case "BLOWER PUMP":
                return 6;
            case "VERTICAL TURBINE PUMP":
                return 7;
            case "VANE PUMP":
                return 8;
            case "CENTRIFUGAL PUMP":
                return 9;
            case "IN LINE PUMP":
                return 10;
            case "WASTE WATER SUBMERSIBLE PUMP":
                return 11;
            case "GRINDER PUMP":
                return 15;
            case "STANDBY GENERATOR":
                return 20;
            case "CONTROL VALVE":
                return 22;
            case "ALTITUDE VALVE":
                return 23;
            default:
                return 0; //Dynamic view having different type of pumps
        }
    };

    McWidget.prototype.getWidgetIdByPumpStationType = function (pumpStationType) {

        var _pumpStationType = angular.isUndefined(pumpStationType) ? "" : pumpStationType;

        switch (_pumpStationType.toUpperCase()) {
            case "PUMP STATION":
            case "SUBMERSIBLE PUMP STATION":
                return 16;
            case "WET WELL PUMP STATION":
                return 18;
            case "DRY WELL PUMP STATION":
                return 19;
            default:
                return 0;
        }
    };

    McWidget.prototype.getPumpStationTypeByWidgetId = function (widgetId) {

        var _widgetId = angular.isUndefined(widgetId) ? 0 : widgetId;

        switch (_widgetId) {
            case 16:
                return "Submersible Pump Station";
            case 18:
                return "Wet Well Pump Station";
            case 19:
                return "Dry Well Pump Station";
            case 0:
            default:
                return "Submersible Pump Station";
        }
    };

    McWidget.prototype.getMmPlusSize = function (sizeId, sizeFactor) {
        switch (parseInt(sizeId)) {
            case 1:
                //Extra Small: 350 610 * .5
                return { width: Math.round(190 / sizeFactor), height: Math.round(230 / sizeFactor) };
            case 2:
                //Small: 350 610 * .6
                return { width: Math.round(210 / sizeFactor), height: Math.round(366 / sizeFactor) };
            case 3:
                //Medium: 350 610 * .8
                return { width: Math.round(266 / sizeFactor), height: Math.round(466 / sizeFactor) };
            case 4:
                //Large: 350 610 * .9
                return { width: Math.round(315 / sizeFactor), height: Math.round(549 / sizeFactor) };
            case 5:
                //Extra Large: 350 610
                return { width: Math.round(350 / sizeFactor), height: Math.round(610 / sizeFactor) };
            case 6:
                //"From Desktop Icon 350 610 * .76:
                return { width: Math.round(266 / sizeFactor), height: Math.round(466 / sizeFactor) };
            default:
                return { width: Math.round(350 / sizeFactor), height: Math.round(610 / sizeFactor) };
        }
    };

    McWidget.prototype.getMmPlusTypeByWidgetId = function (widgetId) {

        var _widgetId = angular.isUndefined(widgetId) ? 0 : widgetId;

        switch (_widgetId) {
            case 25:
                return "MyLevel with Level Sensor";
            case 0:
            default:
                return "MyLevel with Level Sensor";
        }
    };

    McWidget.prototype.getWidgetIdByMmPlusType = function (mmPlusType) {

        var _mmPlusType = angular.isUndefined(mmPlusType) ? "" : mmPlusType;

        switch (_mmPlusType.toUpperCase()) {
            case "MYLEVEL WITH LEVEL SENSOR":
                return 25;
            default:
                return 0;
        }
    };

    McWidget.prototype.getPumpTypeByWidgetId = function (widgetId) {

        var _widgetId = angular.isUndefined(widgetId) ? 0 : widgetId;

        switch (_widgetId) {
            case 3:
                return "Booster Pump";
            case 5:
                return "Submersible Pump";
            case 6:
                return "Blower Pump";
            case 7:
                return "Vertical Turbine Pump";
            case 8:
                return "Vane Pump";
            case 9:
                return "Centrifugal Pump";
            case 10:
                return "In Line Pump";
            case 11:
                return "Waste Water Submersible Pump";
            case 15:
                return "Grinder Pump";
            case 20:
                return "Standby Generator";
            case 22:
                return "Control Valve";
            case 23:
                return "Altitude Valve";
            default:
                return "Booster Pump"; //TODO: WidgetId = 3 -> this setting needs to come from database!!!
        }
    };

    McWidget.prototype.getWidgetIdByAnalogType = function (analogType) {

        var _analogType = angular.isUndefined(analogType) ? "" : analogType;

        switch (_analogType.toUpperCase()) {
            case "SINGLE NEEDLE GAUGE":
                return 1;
            case "ELEVATED WATER TANK":
                return 12;
            case "STANDPIPE STORAGE TANK":
                return 13;
            case "HYDRO PNEUMATIC TANK":
                return 14;
            case "WIND SPEED":
                return 21;
            case "LAKE LEVEL":
                return 26;
            case "STAFF GAUGE":
                return 27;
            default:
                return 0; //Dynamic view having different type of pumps
        }
    };

    McWidget.prototype.getAnalogTypeByWidgetId = function (widgetId) {

        var _widgetId = angular.isUndefined(widgetId) ? 0 : widgetId;

        switch (_widgetId) {
            case 1:
                return "Single Needle Gauge";
            case 12:
                return "Elevated Water Tank";
            case 13:
                return "Standpipe Storage Tank";
            case 14:
                return "Hydro Pneumatic Tank";
            case 21:
                return "Wind Speed";
            case 24:
                return "Single Needle Gauge";
            case 26:
                return "Lake Level";
            case 27:
                return "Staff Gauge";
            default:
                return "Single Needle Gauge"; //TODO: WidgetId = 3 -> this setting needs to come from database!!!
        }
    };

    McWidget.prototype.checkForEmptyObject = function (object) {
        return object && Object.keys(object).length ? false : true;
    };

    return McWidget;
}

McWidgetsSharedFactory.$inject = ['translationService', 'authenticationService', '$timeout', 'McGaugesSharedFactory'];

angular.module('mc.gauges-shared').factory('McWidgetsSharedFactory', McWidgetsSharedFactory);
'use strict';

function McGaugesSharedFactory(HOST, $http) {

    var uiData = [];
    // instantiate our initial object
    var McGauge = function McGauge(element) {
        this.element = element;
    };

    McGauge.prototype.getUiData = function () {
        var self = this;
        return $http.get(HOST + '/api/GaugeUi/DefaultSetting' + '?element=' + this.element).then(function (response) {

            response.data.dateTimeFormat.forEach(function (option) {
                return option.languageTag = option.type;
            });
            response.data.size.forEach(function (option) {
                return option.languageTag = option.description;
            });
            response.data.state.forEach(function (option) {
                return option.languageTag = option.description;
            });
            response.data.theme.forEach(function (option) {
                return option.languageTag = option.name;
            });
            response.data.tickMarks.forEach(function (option) {
                return option.languageTag = option.state;
            });
            response.data.title.forEach(function (option) {
                return option.languageTag = option.state;
            });

            self.list = response.data;
            uiData = angular.copy(self.list);

            self.loading = false;
            return response;
        });
    };

    McGauge.prototype.putUiData = function (customerId, newSetting) {
        var self = this;
        return $http.put(HOST + '/api/GaugeUi/' + this.element + '/' + '?customerId=' + customerId, newSetting).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McGauge.prototype.get = function () {
        return uiData;
    };

    return McGauge;
}

McGaugesSharedFactory.$inject = ['HOST', '$http'];

angular.module('mc.gauges-shared').factory('McGaugesSharedFactory', McGaugesSharedFactory);
mcapp.factory('locationFactory', ['authenticationService', 'HOST', '$http', '$timeout', function (authenticationService, HOST, $http, $timeout) {

    var locationFactory = {};

    var mobileAppWatchLocation, lastUpdateTime, mobileAppWatchLocationPreventBatch,
        minFrequency = 30 * 1000, //30 seconds
        watchOptions = {
            timeout: 20 * 1000, //20 seconds,
            maxAge: 0,
            enableHighAccuracy: true
        };

    locationFactory.mobileAppShareMyLocation = function () {

        if (angular.isDefined(mobileAppWatchLocation)) {
            navigator.geolocation.clearWatch(mobileAppWatchLocation);
            mobileAppWatchLocation = undefined;
        }

        var accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(accountInfo.preferenceUser.shareUserLocation) || accountInfo.preferenceUser.shareUserLocation !== 1) return;

        function onSuccess(position) {
            var now = new Date();
            if (lastUpdateTime && now.getTime() - lastUpdateTime.getTime() < minFrequency) {
                //console.log("Ignoring position update");
                return;
            }
            lastUpdateTime = now;

            if (angular.isDefined(mobileAppWatchLocationPreventBatch)) {
                $timeout.cancel(mobileAppWatchLocationPreventBatch);
                mobileAppWatchLocationPreventBatch = undefined;
            }

            var _dataPositions = { loginsId: accountInfo.userId, latitude: position.coords.latitude, Longitude: position.coords.longitude };
            mobileAppWatchLocationPreventBatch = $timeout(function() {
                $http.post(HOST + '/api/DataPositions?customerId=' + accountInfo.customerId, _dataPositions).then(function (resp) {
                    //console.log("ok");
                }, function (resp) {
                    console.log(resp);
                });
            }, 1000);
        };

        function onError(error) {
            console.log(error);
        }

        mobileAppWatchLocation = navigator.geolocation.watchPosition(onSuccess, onError, watchOptions);
    };

    locationFactory.mobileAppClearShareMyLocation = function () {
        if (angular.isDefined(mobileAppWatchLocation)) {
            navigator.geolocation.clearWatch(mobileAppWatchLocation);
            mobileAppWatchLocation = undefined;
        }
    };

    return locationFactory;
}]);
mcapp.directive('input', ["$sanitize", function ($sanitize) {
    return {
        restrict: 'E',
        require: '?ngModel',
        link: function (scope, element, attrs, ngModel) {

            if (attrs.mcInputSanitize !== undefined && attrs.mcInputSanitize === "false")
                return false;

            if (ngModel !== undefined && ngModel !== null) {
                ngModel.$parsers.push(function (value) {
                    return (typeof value === "boolean" || typeof value === "number" || typeof value === "object") ? value : isFrenchCharExists(value) ? value : $sanitize(value.replace(/["']/g, ""));
                });
            }

            // if French language specific character exists, then we dont want to sanitize, 
            // bcoz, we dont want to save numerical code of the French charater, rather actual character itself
            // TODO: may be sanitize all chars except French chars
            var isFrenchCharExists = function (inputStr) {
                var frChars = ['À', 'à', 'Â', 'â', 'Æ', 'æ', 'Ç', 'ç', 'È', 'è', 'É', 'é', 'Ê', 'ê', 'Ë', 'ë', 'Î', 'î', 'Ï', 'ï', 'Ô', 'ô', 'Œ', 'œ', 'Ù', 'ù', 'Û', 'û', 'Ü', 'ü', '«', '»', '€', '₣'];
                for (var i = 0; i < inputStr.length; i++) {
                    if (frChars.indexOf(inputStr[i]) > -1)
                        return true;
                }
                return false;
            };
        }
    };
}]);
mcapp.factory("highchartsOptionsService", [function () {
    var highchartsOptionsFactory = {};
    var _languageSetting = {};

    /* Highcharts plugin to handle text symbols */
    (function (H) {
        function symbolWrap(proceed, symbol, x, y, w, h, options) {
            if (symbol.indexOf('text:') === 0) {
                var text = symbol.split(':')[1],
                    svgElem = this.text(text, x, y + h)
                    .css({
                        fontFamily: 'FontAwesome',
                        fontSize: h * 2
                    });

                if (svgElem.renderer.isVML) {
                    svgElem.fillSetter = function (value, key, element) {
                        element.style.color = H.Color(value).get('rgb');
                    };
                }
                return svgElem;
            }
            return proceed.apply(this, [].slice.call(arguments, 1));
        }
        H.wrap(H.SVGRenderer.prototype, 'symbol', symbolWrap);
        if (H.VMLRenderer) {
            H.wrap(H.VMLRenderer.prototype, 'symbol', symbolWrap);
        }

        // Load the font for SVG files also
        H.wrap(H.Chart.prototype, 'getSVG', function (proceed) {
            var svg = proceed.call(this);
            svg = '<?xml-stylesheet type="text/css" ' +
                'href="../../assets/fonts/font-awesome/css/font-awesome.min.css" ?>' +
                svg;
            return svg;
        });
    }(Highcharts));
    /* Highcharts plugin to handle text symbols */


    /**
* Experimental Highcharts plugin to implement chart.alignThreshold option. This primary axis
* will be computed first, then all following axes will be aligned to the threshold.
* Author: Torstein Hønsi
* Last revision: 2016-11-02
*/
    (function (H) {
        var Axis = H.Axis,
            inArray = H.inArray,
            wrap = H.wrap;

        wrap(Axis.prototype, 'adjustTickAmount', function (proceed) {
            var chart = this.chart,
                primaryAxis = chart[this.coll][0],
                primaryThreshold,
                primaryIndex,
                index,
                newTickPos,
                threshold;

            // Find the index and return boolean result
            function isAligned(axis) {
                index = inArray(threshold, axis.tickPositions); // used in while-loop
                return axis.tickPositions.length === axis.tickAmount && index === primaryIndex;
            }

            if (chart.options.chart.alignThresholds && this !== primaryAxis) {
                primaryThreshold = (primaryAxis.series[0]&& primaryAxis.series[0].options.threshold) || 0;
                threshold = (this.series[0]&& this.series[0].options.threshold) || 0;

                primaryIndex = primaryAxis.tickPositions && inArray(primaryThreshold, primaryAxis.tickPositions);

                if (this.tickPositions && this.tickPositions.length &&
                    primaryIndex > 0 &&
                    primaryIndex < primaryAxis.tickPositions.length -1 &&
                    this.tickAmount) {

                    // Add tick positions to the top or bottom in order to align the threshold
                    // to the primary axis threshold
                    while(!isAligned(this)) {

                        if (index < primaryIndex) {
                            newTickPos = this.tickPositions[0]-this.tickInterval;
                            this.tickPositions.unshift(newTickPos);
                            this.min = newTickPos;
                        } else {
                            newTickPos = this.tickPositions[this.tickPositions.length -1]+this.tickInterval;
                            this.tickPositions.push(newTickPos);
                            this.max = newTickPos;
                        }
                        proceed.call(this);
                    }
                }

            } else {
                proceed.call(this);
            }
        });
    }(Highcharts));


    (function (H) {
        function collide(a, b) {
            return !(b.x > a.x + a.width || b.x + b.width < a.x || b.y > a.y + a.height || b.y + b.height < a.y);
        }

        H.wrap(H.seriesTypes.flags.prototype, 'drawPoints', function (p) {
            var series = this,
                chart = series.chart,
                overlap = true,
                counter = 0,
                index,
                offset = series.options.stackDistance,
                currentBBox,
                compareBBox,
                compareSeries;

            p.call(this);

            while (overlap && counter < 100) { // as long as flags do overlap, move them. Extra limiter up to 100 iterations.
                overlap = false;
                H.each(series.points, function (currentPoint) {
                    if (currentPoint.graphic) { // only existing point with label

                        index = 0;
                        currentBBox = {
                            x: currentPoint.graphic.translateX,
                            y: currentPoint.graphic.translateY,
                            width: currentPoint.graphic.width,
                            height: currentPoint.graphic.height
                        };

                        for (; series.index - index >= 0; index++) { // compare only with previous series

                            compareSeries = chart.series[index];

                            if (compareSeries.options.type === "flags" && compareSeries.options.shape === "flag") { // only flag type seires

                                H.each(compareSeries.points, function (comparePoint) { // compare current label with all others
                                    if (compareSeries === series && comparePoint.index >= currentPoint.index ) {
                                    	return; // perf
                                    }
                                    
                                    if (comparePoint.graphic) { // only existing point with label
                                        
                                        compareBBox = {
                                            x: comparePoint.graphic.translateX,
                                            y: comparePoint.graphic.translateY,
                                            width: comparePoint.graphic.width,
                                            height: comparePoint.graphic.height
                                        };

                                        if (collide(currentBBox, compareBBox)) { // when collide, move current label to top
                                            overlap = true;
                                            currentPoint.graphic.attr({
                                                y: currentPoint.graphic.attr("y") - offset,
                                                anchorY: currentPoint.plotY
                                            });
                                            currentPoint.tooltipPos[1] -= offset;
                                        }
                                    }
                                });
                            }
                        }
                    }
                });
                counter++;
            }
        });
    })(Highcharts);

        /**
     * Highcharts Linear-Gauge series plugin
     */
    (function (H) {
    H.seriesType('lineargauge', 'column', null, {
        setVisible: function () {
            H.seriesTypes.column.prototype.setVisible.apply(this, arguments);
            if (this.markLine) {
                this.markLine[this.visible ? 'show' : 'hide']();
            }
        },
        drawPoints: function () {
            // Draw the Column like always
            H.seriesTypes.column.prototype.drawPoints.apply(this, arguments);

            // Add a Marker
            var series = this,
                chart = this.chart,
                inverted = chart.inverted,
                xAxis = this.xAxis,
                yAxis = this.yAxis,
                point = this.points[0], // we know there is only 1 point
                markLine = this.markLine,
                ani = markLine ? 'animate' : 'attr';

            // Hide column
            point.graphic.hide();

            if (!markLine) {
                var path = inverted ? ['M', 0, 0, 'L', -5, -5, 'L', 5, -5, 'L', 0, 0, 'L', 0, 0 + xAxis.len] : ['M', 0, 0, 'L', -5, -5, 'L', -5, 5, 'L', 0, 0, 'L', xAxis.len, 0];
                markLine = this.markLine = chart.renderer.path(path)
                    .attr({
                        fill: series.color,
                        stroke: series.color,
                        'stroke-width': 1
                    }).add();
            }
            markLine[ani]({
                translateX: inverted ? xAxis.left + yAxis.translate(point.y) : xAxis.left,
                translateY: inverted ? xAxis.top : yAxis.top + yAxis.len -  yAxis.translate(point.y)
            });
        }
    });
}(Highcharts));

    var _setHighchartsOptions = function (varLanguage, mobile) {
        switch (varLanguage) {
            case "en":
                _languageSetting = {
                    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                    weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                    decimalPoint: ".",
                    downloadJPEG: "Download JPEG image",
                    downloadPDF: "Download PDF document",
                    downloadPNG: "Download PNG image",
                    downloadSVG: "Download SVG vector image",
                    exportButtonTitle: 'Export Chart',
                    loading: '<div class="imgtxtlod"><i class="fa fa-spinner fa-spin fa-3x imglodred"></i> <span class="txtlodblk">Loading data...</span></div>',
                    rangeSelectorZoom: '',
                    printButtonTitle: "Print chart",
                    resetZoom: "Reset zoom",
                    resetZoomTitle: "Reset zoom level 1:1",
                    thousandsSep: ","
                };
                break;
            case "fr":
                _languageSetting = {
                    months: [
                        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
                        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
                    ],
                    weekdays: [
                        'Dimanche', 'Lundi', 'Mardi', 'Mercredi',
                        'Jeudi', 'Vendredi', 'Samedi'
                    ],
                    shortMonths: [
                        'Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil',
                        'Aout', 'Sept', 'Oct', 'Nov', 'Déc'
                    ],
                    decimalPoint: ',',
                    downloadPNG: 'Télécharger en image PNG',
                    downloadJPEG: 'Télécharger en image JPEG',
                    downloadPDF: 'Télécharger en document PDF',
                    downloadSVG: 'Télécharger en document Vectoriel',
                    exportButtonTitle: 'Export du graphique',
                    loading: '<i class="fa fa-spinner fa-spin fa-3x red imglodred"></i> Chargement en cours...',
                    rangeSelectorZoom: '',
                    printButtonTitle: 'Imprimer le graphique',
                    resetZoom: 'Réinitialiser le zoom',
                    resetZoomTitle: 'Réinitialiser le zoom au niveau 1:1',
                    thousandsSep: ' '
                };
                break;
            case "es":
                _languageSetting = {
                  months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubure', 'Noviembre', 'Diciembre'],
                    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
                    shortMonths: ['Enero', 'Feb', 'Marzo', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'],
                    exportButtonTitle: "Exportar",
                    loading: '<i class="fa fa-spinner fa-spin fa-3x red imglodred"></i> Cargando datos...',
                    rangeSelectorZoom: '',
                    printButtonTitle: "Imprimir",
                    rangeSelectorFrom: "De",
                    rangeSelectorTo: "Hasta",
                    downloadPNG: 'Download imagen PNG',
                    downloadJPEG: 'Download imagen JPEG',
                    downloadPDF: 'Download documento PDF',
                    downloadSVG: 'Download imagen SVG'
                    // resetZoom: "Reset",
                    // resetZoomTitle: "Reset,
                    // thousandsSep: ".",
                    // decimalPoint: ','
                };
                break;
            case "de":
                _languageSetting = {
                    months: [
                        'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
                        'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
                    ],
                    weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                    shortMonths: [
                        'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'
                    ],
                    decimalPoint: ',',
                    downloadPNG: 'Laden Sie PNG-Bild',
                    downloadJPEG: 'Laden Sie JPEG-Bild',
                    downloadPDF: 'Laden Sie PDF-Dokument',
                    downloadSVG: 'Laden Sie SVG-Vektor-Bild ',
                    exportButtonTitle: 'Raster-oder Vektor-Bild Export',
                    loading: 'Loading...',
                    printButtonTitle: 'Drucken Sie das Diagramm',
                    rangeSelectorFrom: "Von",
                    rangeSelectorTo: "Bis",
                    resetZoom: 'Zoom zurücksetzen',
                    resetZoomTitle: 'Stellen Sie die Zoomstufe auf 1:1',
                    thousandsSep: ' '
                };
                break;
            case "pt-br":
                _languageSetting = {
                    loading: 'Aguarde...',
                    months: ['Janeiro', 'Fevereiro', 'Marco', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                    weekdays: ['Domingo', 'Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'],
                    shortMonths: ['Jan', 'Feb', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    exportButtonTitle: "Exportar",
                    printButtonTitle: "Imprimir",
                    rangeSelectorFrom: "De",
                    rangeSelectorTo: "At&#233;",
                    rangeSelectorZoom: "Periodo",
                    downloadPNG: 'Download imagem PNG',
                    downloadJPEG: 'Download imagem JPEG',
                    downloadPDF: 'Download documento PDF',
                    downloadSVG: 'Download imagem SVG'
                    // resetZoom: "Reset",
                    // resetZoomTitle: "Reset,
                    // thousandsSep: ".",
                    // decimalPoint: ','
                };
                break;
            case "zh-cn":
                _languageSetting = {
                    months: ["一月",  "二月",  "三月", "月", "月", "月", "七五", "八五",  "九五", "十月", "月", "月"],
                    weekdays: [ "星期日", "星期一",  "星期二",  "星期三", "星期四",  "星期五",  "星期六" ],
                    shortMonths: ["一月", "二月", "三月", "月", "月", "月", "七五", "八五", "九五", "十月", "月", "月"],
                    decimalPoint: ".",
                    downloadJPEG: "Download JPEG image",
                    downloadPDF: "Download PDF document",
                    downloadPNG: "Download PNG image",
                    downloadSVG: "Download SVG vector image",
                    exportButtonTitle: 'Export Chart',
                    loading: '<div class="imgtxtlod"><i class="fa fa-spinner fa-spin fa-3x imglodred"></i> <span class="txtlodblk">Loading data...</span></div>',
                    rangeSelectorZoom: '',
                    printButtonTitle: "Print chart",
                    resetZoom: "Reset zoom",
                    resetZoomTitle: "Reset zoom level 1:1",
                    thousandsSep: " "
                };
                break;
        }

        Highcharts.setOptions({
            chart: {
                style: {
                    fontFamily: 'Roboto'
                }
            },
            loading: {
                labelStyle: {
                    color: 'black'
                },
                style: {
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    opacity: 1,
                    textAlign: 'center'
                }
            },
            xAxis: {
                minRange: 3600 / 4 * 1000, //15 minutes
                minTickInterval: 3600 * 1000,
                dateTimeLabelFormats: {
                    day: '%b %e',
                    week: '%b %e'
                },
                minRange: 6300 * 1000 //1 hour and 45 minutes
            },
            navigator: {
                series: {
                    includeInCSVExport: false
                },
                xAxis: {
                    dateTimeLabelFormats: {
                        //millisecond: '%H:%M:%S.%L',
                        //second: '%H:%M:%S',
                        //minute: '%H:%M',
                        //hour: '%H:%M',
                        day: '%b %e',
                        week: '%b %e'
                        //month: '%b \'%y',
                        //year: '%Y'
                    }
                }
            },
            plotOptions: {
                series: {
                    states: {
                        inactive: {
                            opacity: 1 
                        }
                    }
                }
            },
            tooltip: {
                animation: false,
                shadow: false,
                positioner: mobile && function (labelWidth, labelHeight, point) {
                    var chart = this.chart;
                    var x = point.plotX + chart.plotLeft + 10;
                    var y = point.plotY + chart.plotTop - labelHeight - 10;

                    // Keep inside chart horizontally
                    if (x + labelWidth > chart.chartWidth) x = chart.chartWidth - labelWidth - 10;
                    if (x < 0) x = 0;

                    // Keep inside chart vertically
                    if (y < 0) y = point.plotY + chart.plotTop + 20;

                    return {
                        x: x,
                        y: y
                    };
                }
            },
            exporting: {
                //enabled: false
                //chartOptions: { // specific options for the exported image
                //    navigator: {
                //        enabled: false
                //    },
                //    plotOptions: {
                //        series: {
                //            dataLabels: {
                //                enabled: false
                //            }
                //        }
                //    }
                //},
                //sourceWidth: 1800,
                //sourceHeight: 1200,
                //scale: 2,
                //fallbackToExportServer: false,
                //width: 1800
            },
            lang: _languageSetting
        });
 };

    highchartsOptionsFactory.setHighchartsOptions = _setHighchartsOptions;
    return highchartsOptionsFactory;
}]);
'use strict';

mcapp.factory("rangeSelectorService", ["datetimeService", "translationService", function (datetimeService, translationService) {

        function _getRangeSelectorButtons() {
                return [{ type: 'day', count: 1, text: '1 ' + translationService.translation.text.DAY }, { type: 'day', count: 3, text: '3 ' + translationService.translation.text.DAYS.toLowerCase() }, { type: 'day', count: 7, text: '7 ' + translationService.translation.text.DAYS.toLowerCase() }, { type: 'month', count: 1, text: '1 ' + translationService.translation.text.MONTH }];
        }

        function _getrangeExtremes(dataMax, dataMin, rangeSelected, dataGroupingInterval) {

                var now = moment.utc().valueOf();
                var oldCenter = (dataMax + dataMin) / 2;
                var newRange = rangeSelected._range;

                newMax = oldCenter + newRange / 2;
                newMax = dataGroupingInterval === 24 ? moment.utc(newMax).endOf('day').valueOf() : moment.utc(newMax).endOf('hour').valueOf();
                if (newMax > now) newMax = now;

                newMin = newMax - newRange;
                newMin = dataGroupingInterval === 24 ? moment.utc(newMin).startOf('day').valueOf() : moment.utc(newMin).startOf('hour').valueOf();

                var dataPad = Math.floor((newMax - newMin) / 8);
                newDataMin = moment.utc(newMin - dataPad).startOf('hour');
                newDataMax = moment.utc(newMax + dataPad).startOf('hour');
                if (newDataMax > now) newDataMax = now;

                return { newMin: newMin, newMax: newMax, newDataMin: newDataMin, newDataMax: newDataMax };
        }

        function _getChartExtremes(dataMax, dataMin, varDay, heartbeatLocalDateTime) {

                var maxData = dataMax;
                var minData = dataMin;
                var interval = 3600 * 1000 * 24 * varDay;

                return { extremeMin: maxData - interval, extremeMax: maxData };
        };

        function _getChartExtremesSupergraph(dataMax, dataMin, varDay, heartbeatLocalDateTime) {

                var _tmpPadding = 10 * 60 * 1000;

                var maxData = dataMax;
                var minData = dataMin;

                var realRange = maxData - minData;

                var midPoint = minData + (maxData - minData) / 2;
                var interval = 3600 * 1000 * 24 * varDay;

                interval = interval > realRange ? realRange : interval;

                var tmpExtremeMin = minData;
                var tmpExtremeMax = maxData;

                tmpExtremeMin = midPoint - interval / 2;

                if (!(midPoint + interval / 2 > heartbeatLocalDateTime)) {
                        tmpExtremeMax = midPoint + interval / 2;
                }

                tmpExtremeMax = tmpExtremeMax > maxData ? maxData - _tmpPadding : tmpExtremeMax;
                tmpExtremeMin = tmpExtremeMin <= minData ? minData + _tmpPadding * 6 : tmpExtremeMin;

                return { extremeMin: tmpExtremeMin, extremeMax: tmpExtremeMax };
        };

        return {
                getRangeSelectorButtons: _getRangeSelectorButtons,
                getrangeExtremes: _getrangeExtremes,
                getChartExtremes: _getChartExtremes,
                getChartExtremesSupergraph: _getChartExtremesSupergraph
        };
}]);
'use strict';

function GetDeviceNameService() {

    var DeviceType = function DeviceType() {
        this.setDeviceName = setDeviceName;
    };

    var setDeviceName = function setDeviceName(deviceNumber) {
        var devices = {};
        devices = {
            5: 'Nextel 800',
            8: 'Model 110',
            9: 'Model 800',
            10: 'Model M80',
            15: 'Manhole Monitor',
            17: 'MyDro M120',
            18: 'Mydro M150',
            19: 'Mydro M850',
            20: 'M84',
            21: 'M50'
        };
        this.deviceName = devices[deviceNumber];
        return this.deviceName;
    };
    return DeviceType;
}

GetDeviceNameService.$inject = [];
angular.module('mcapp').factory('GetDeviceNameService', GetDeviceNameService);
mcapp.factory("filterService", ["datetimeService", function (datetimeService) {
    return {
        filterDateAgentText: function (input) {
            return datetimeService.formatDateAgentText(input, 'yyyy-MM-ddTHH:mm:ss');
        },
        filterUnixTime: function (input) {
            return datetimeService.toUnixtime(input.replace(/\D/g, ''));
        }
    };
}]);
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('customFilters', []).filter('filterDateAgentText', ["datetimeService", function (datetimeService) {
    return function (input) {
        if (typeof input === "undefined") return '';
        return datetimeService.formatDateAgentText(input, 'yyyy-MM-ddTHH:mm:ss');
    };
}]).filter('filterDateAgentTextTimeFormat', ["datetimeService", function (datetimeService) {
    return function (input, format) {
        if (typeof input === "undefined") return '';
        return datetimeService.formatDateAgentText(input.replace(/\.\d+/, ""), 'yyyy-MM-ddTHH:mm:ss', false, format);
    };
}]).filter('filterDateAgentTextTimeFormatCurrentStatus', ["datetimeService", function (datetimeService) {
    return function (input, format) {
        if (typeof input === "undefined" || input === null || input.substring(0, 4) == "0001") return '---';
        return datetimeService.formatDateAgentText(input.replace(/\.\d+/, ""), 'yyyy-MM-ddTHH:mm:ss', false, format);
    };
}]).filter('filterDateAgentTextTimeFormatDashboard', function () {
    return function (input, format, isCurrent) {
        if (!input || input.substring(0, 4) === "0001") {
            return '---';
        }

        var date = new Date(input);
        var current = isCurrent === true || isCurrent === 'true';
        var day = date.getDate().toString().padStart(2, '0');
        var year = date.getFullYear();
        var month = date.toLocaleString('en-US', { month: current ? 'short' : 'long' });
        var hours = date.getHours();
        var minutes = date.getMinutes().toString().padStart(2, '0');

        if (format == 2) {
            hours = hours.toString().padStart(2, '0');
        } else {
            var modifier = hours >= 12 ? 'PM' : 'AM';
            hours = (hours % 12 || 12).toString().padStart(2, '0');
            minutes += ' ' + modifier;
        }

        return current ? month + ' ' + day + ' at ' + hours + ':' + minutes : month + ' ' + day + ', ' + year + ', ' + hours + ':' + minutes;
    };
}).filter('filterDateTextHourFormatRuntime', function () {
    return function (input, format) {
        if (!input || input.substring(0, 4) === "0001") {
            return '---';
        }

        var date = new Date(input);
        var hours = date.getHours();
        var minutes = date.getMinutes().toString().padStart(2, '0');
        var modifier = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12; // Convert 24-hour format to 12-hour format

        if (format == 2) {
            return date.getHours().toString().padStart(2, '0') + ':00';
        } else {
            return hours.toString().padStart(2, '0') + ':' + minutes + ' ' + modifier;
        }
    };
}).filter('filterDateTextHourFormatPumpTable', function () {
    return function (input, format) {
        if (typeof input === "undefined" || input === null || input.substring(0, 4) == "0001") return '---';
        if (format == 2) {
            var _input$split = input.split(' '),
                _input$split2 = _slicedToArray(_input$split, 2),
                time = _input$split2[0],
                modifier = _input$split2[1];

            var _time$split = time.split(':'),
                _time$split2 = _slicedToArray(_time$split, 3),
                hours = _time$split2[0],
                minutes = _time$split2[1],
                sec = _time$split2[2];

            if (hours === '12') {
                hours = '00';
            }
            if (modifier === 'PM') {
                hours = parseInt(hours, 10) + 12;
            }
            return hours + ':' + minutes + ':' + sec;
        } else return input;
    };
}).filter('filterDateAgentTextMonth', function () {
    return function (input) {
        if (!input) return '';

        var date = new Date(input);
        var day = date.getDate().toString().padStart(2, '0'); // Ensure two-digit format
        var month = date.toLocaleString('en-US', { month: 'long' }); // Get full month name

        return day + ' ' + month;
    };
}).filter('filterDateAgentTextNoTime', ["datetimeService", function (datetimeService) {
    return function (input) {
        if (typeof input === "undefined") return '';
        return datetimeService.formatDateAgentText(input, 'yyyy-MM-ddTHH:mm:ss', true);
    };
}]).filter('filterDateAgentTextPaging', ["datetimeService", "translationService", function (datetimeService, translationService) {
    return function (input, format) {
        if (typeof input === "undefined" || input == '0001-01-01T00:00:00') return translationService.translation.text.NOT_COMPLETED;
        if (input == "Completed") return translationService.translation.text.COMPLETED;
        return datetimeService.formatDateAgentText(input.replace(/\.\d+/, ""), 'yyyy-MM-ddTHH:mm:ss', false, format);
    };
}]).filter('filterUnixTime', ["datetimeService", function (datetimeService) {
    return function (input) {
        if (typeof input === "undefined") return '';
        return datetimeService.toUnixtime(input.replace(/\D/g, ''));
    };
}]).filter('filterDateLastUpdateAt', ["datetimeService", function (datetimeService) {
    return function (input) {
        if (typeof input === "undefined") return '';
        return "Updated at: " + datetimeService.formatDateAgentText(input, 'yyyy-MM-ddTHH:mm:ss');
    };
}]).filter('filterCapitalizeFirst', ["datetimeService", function (datetimeService) {
    return function (input, scope) {
        if (input !== null) input = input.toLowerCase();
        return input.substring(0, 1).toUpperCase() + input.substring(1);
    };
}]).filter('filterCapitalizeFirstLetterEachWord', function () {
    return function (input) {
        if (!input) return '';

        input = input.split(" ");

        for (var i = 0, x = input.length; i < x; i++) {
            input[i] = input[i][0].toUpperCase() + input[i].substr(1);
        }

        return input.join(" ");
    };
}).filter('filterLimitLengthNS', ["$sce", function ($sce) {
    return function (input, arg1) {
        //arg1 = string length
        if (typeof input === "undefined") return '';
        if (input.trim().length > arg1) return $sce.trustAsHtml(input.trim().substring(0, arg1) + "<mcspan>...</mcspan>" + "<mcspan class='ng-hide'>" + input.trim().substring(arg1, input.trim().length) + "</mcspan>");
        return input;
    };
}]).filter('filterLimitLength', function () {
    return function (input, arg1) {
        //arg1 = string length
        if (typeof input === "undefined") return '';
        if (input.trim().length > arg1) return input.trim().substring(0, arg1 - 3) + "...";
        return input;
    };
}).filter('html2', ["$sce", function ($sce) {
    return function (input) {
        return $sce.trustAsHtml(input);
    };
}]).filter('iif', function () {
    return function (input, trueValue, falseValue) {
        return input ? trueValue : falseValue;
    };
}).filter('rainPrecipitation', function () {
    return function (input) {
        //arg1 = string length
        if (typeof input === "undefined") return '';
        if (input == 0) return "Trace";
        if (input < 0) return "None";
    };
}).filter('textOrNumber', function () {
    return function (input, fractionSize) {
        if (isNaN(input)) {
            return input;
        } else {
            return $filter('number')(input, fractionSize);
        };
    };
}).filter('airportRainfall', function () {
    return function (rainfallInches, rainfallUnit) {
        if (typeof rainfallInches === "undefined") return '';
        if (rainfallInches < 0) return "0";
        if (rainfallUnit == 2) return (rainfallInches * 2.54).toFixed(3);
        return rainfallInches.toFixed(2);
    };
}).filter('temperature', function () {
    return function (temperatureFahrenheit, temperatureUnit) {
        if (typeof temperatureFahrenheit === "undefined") return '';
        if (temperatureUnit == 2) return ((temperatureFahrenheit - 32) * 5 / 9).toFixed(0);
        return temperatureFahrenheit.toFixed(0);
    };
}).filter('reverse', function () {
    return function (items) {
        return items.slice().reverse();
    };
})
//   | filterGreaterThan: 'sumDeviceAnalog': '0'   --- ngOptions issue with one-time bindings, using function in controller
.filter('filterGreaterThan', function () {
    return function (items, prop, value) {
        if (typeof items === "undefined") return '';
        var arrayToReturn = [];
        for (var i = 0; i < items.length; i++) {
            if (items[i][prop] != value) {
                arrayToReturn.push(items[i]);
            }
        }

        return arrayToReturn;
    };
}).filter('numberOrDash', ["$filter", function ($filter) {
    return function (input, fractionSize) {
        if (input == null) {
            return "-";
        } else {
            return $filter('number')(input, fractionSize);
        };
    };
}]).filter('groupBy', ['$parse', function ($parse) {
    return function (list, group_by) {

        var filtered = [];
        var prev_item = null;
        var group_changed = false;
        // this is a new field which is added to each item where we append "_CHANGED"
        // to indicate a field change in the list
        //was var new_field = group_by + '_CHANGED'; - JB 12/17/2013
        var new_field = 'group_by_CHANGED';

        // loop through each item in the list
        angular.forEach(list, function (item) {

            group_changed = false;

            // if not the first item
            if (prev_item !== null) {

                // check if any of the group by field changed

                //force group_by into Array
                group_by = angular.isArray(group_by) ? group_by : [group_by];

                //check each group by parameter
                for (var i = 0, len = group_by.length; i < len; i++) {
                    if ($parse(group_by[i])(prev_item) !== $parse(group_by[i])(item)) {
                        group_changed = true;
                    }
                }
            } // otherwise we have the first item in the list which is new
            else {
                    group_changed = true;
                }

            // if the group changed, then add a new field to the item
            // to indicate this
            if (group_changed) {
                item[new_field] = true;
            } else {
                item[new_field] = false;
            }

            filtered.push(item);
            prev_item = item;
        });

        return filtered;
    };
}]);
mcapp.service('detectBrowserService', ['$window', function ($window) {

    return function () {

        var userAgent = $window.navigator.userAgent;

        var browsers = { opera: /OPR/i, edge: /edge/i, chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i, blink: /blink/i };

        for (var key in browsers) {
            if (browsers[key].test(userAgent)) {
                return key;
            }
        }

       // // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
       // isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
       // // Firefox 1.0+
       // isFirefox = typeof InstallTrigger !== 'undefined';
       // // Safari 3.0+
       // isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
       // // Internet Explorer 6-11
       // isIE = /*@cc_on!@*/false || !!document.documentMode;
       // // Edge 20+
       // isEdge = !isIE && !!window.StyleMedia;
       // // Chrome 1+
       // isChrome = !!window.chrome && !!window.chrome.webstore;
       // // Blink engine detection
       // isBlink = (isChrome || isOpera) && !!window.CSS;

       //var browser =  isOpera ? 'opera' :
       //isFirefox ? 'firefox' :
       //isSafari ? 'safari' :
       //isChrome ? 'chrome' :
       //isIE ? 'ie' :
       //isEdge ? 'edge' :
       //isBlink ? 'blink' :
       //'unknown';

       //return browser;
       return 'ie'; //'unknown';
    };

}]);
mcapp.factory('debounceService', ["$timeout", "$q", function ($timeout, $q) {
    return function (func, wait, immediate) {
        var timeout;
        var deferred = $q.defer();
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) {
                    deferred.resolve(func.apply(context, args));
                    deferred = $q.defer();
                }
            };
            var callNow = immediate && !timeout;
            if (timeout) {
                $timeout.cancel(timeout);
            }
            timeout = $timeout(later, wait);
            if (callNow) {
                deferred.resolve(func.apply(context, args));
                deferred = $q.defer();
            }
            return deferred.promise;
        };
    };
}]);
mcapp.factory("datetimeService", ["$http", "$filter", "authenticationService", function ($http, $filter, authenticationService) {
    var datetimeFactory = {};

    //var _formatDateAgentText = function (str, strformat) {
    //    var regtime = new Date(_getDateFromFormat(str, strformat));
    //    var today = new Date();
    //    var yesterday = new Date(today);
    //    yesterday.setDate(today.getDate() - 1);
    //    var formateddate = null;
    //    if (_formatDate(regtime, 'yyyyMMdd') == _formatDate(today, 'yyyyMMdd'))
    //        formateddate = _formatDate(regtime, 'hh:mm:ss a');
    //    //else if (_formatDate(regtime, 'yyyyMMdd') == _formatDate(yesterday, 'yyyyMMdd'))
    //    //    formateddate = "Yesterday " + _formatDate(regtime, 'hh:mm:ss a');
    //    else if (regtime.getFullYear() == today.getFullYear())
    //        formateddate = _formatDate(regtime, 'NNN dd hh:mm:ss a');
    //    else
    //        formateddate = formateddate = _formatDate(regtime, 'NNN dd yyyy hh:mm:ss a');
    //    return formateddate;
    //};

    var _formatDateAgentText = function (str, strformat, noTime, timeFormat) {
        var accountInfo = authenticationService.getAccountInfo();
        var regtime = new Date(_getDateFromFormat(str, strformat));
        var today = new Date();
        var yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        var formateddate = null;

        var timeFormatString = timeFormat === 2 ? 'HH:mm:ss' : 'hh:mm:ss a';

        if (typeof accountInfo === "undefined" || accountInfo === null) return; //RTU View issue when changing customer; need to check scope.getTime()
            if (_formatDate(regtime, 'yyyyMMdd') == _formatDate(today, 'yyyyMMdd'))
                formateddate = $filter('date')(regtime, timeFormatString);
                //formateddate = $filter('date')(regtime, 'mediumTime');
            else if (regtime.getFullYear() == today.getFullYear())
                formateddate = $filter('date')(regtime, 'MMM dd ' + timeFormatString);
                //formateddate = $filter('date')(regtime, 'medium');
            if (regtime.getFullYear() == today.getFullYear())
                formateddate = $filter('date')(regtime, 'MMM dd ' + timeFormatString);
                //formateddate = $filter('date')(regtime, 'medium');
            else
                formateddate = $filter('date')(regtime, 'MMM dd yyyy ' + timeFormatString);

        if (!noTime && timeFormat !== 2) {
            //If time is present in the formatted date, insert a non-breaking space between the time and the 'AM/PM' so that it wraps cleanly
            var timeSpace = formateddate.lastIndexOf(' ');
            formateddate = formateddate.substring(0, timeSpace) + String.fromCharCode(160) + formateddate.substring(timeSpace + 1);
        }

        return formateddate;
    };

    var _formatDateAgentTextOld = function (str, strformat, noTime, timeFormat) {
        var accountInfo = authenticationService.getAccountInfo();
        var regtime = new Date(_getDateFromFormat(str, strformat));
        var today = new Date();
        var yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        var formateddate = null;

        var timeFormatString = timeFormat === 2 ? 'HH:mm:ss' : 'hh:mm:ss a';

        if (typeof accountInfo === "undefined" || accountInfo === null) return; //RTU View issue when changing customer; need to check scope.getTime()

        if (accountInfo.preferenceUser.i18nCode === "en" || accountInfo.preferenceUser.i18nCode === "en-us") {
            if (_formatDate(regtime, 'yyyyMMdd') == _formatDate(today, 'yyyyMMdd'))
                formateddate = noTime ? "Today" : _formatDate(regtime, timeFormatString);
            else if (_formatDate(regtime, 'yyyyMMdd') == _formatDate(yesterday, 'yyyyMMdd'))
                formateddate = noTime ? "Yesterday " : "Yesterday " + _formatDate(regtime, timeFormatString);
            else if (regtime.getFullYear() == today.getFullYear())
                formateddate = noTime ? _formatDate(regtime, 'NNN dd') : _formatDate(regtime, 'NNN dd ' + timeFormatString);
            else
                formateddate = _formatDate(regtime, 'NNN dd yyyy ' + timeFormatString);
        } else {
            if (_formatDate(regtime, 'yyyyMMdd') == _formatDate(today, 'yyyyMMdd'))
                formateddate = $filter('date')(regtime, timeFormatString);
                //formateddate = $filter('date')(regtime, 'mediumTime');
            else if (regtime.getFullYear() == today.getFullYear())
                formateddate = $filter('date')(regtime, 'MMM dd ' + timeFormatString);
                //formateddate = $filter('date')(regtime, 'medium');
            else
                formateddate = $filter('date')(regtime, 'MMM dd yyyy ' + timeFormatString);
            //formateddate = $filter('date')(regtime, 'medium');
        }

        if (!noTime && timeFormat !== 2) {
            //If time is present in the formatted date, insert a non-breaking space between the time and the 'AM/PM' so that it wraps cleanly
            var timeSpace = formateddate.lastIndexOf(' ');
            formateddate = formateddate.substring(0, timeSpace) + String.fromCharCode(160) + formateddate.substring(timeSpace + 1);
        }

        return formateddate;
    };

    var MONTH_NAMES = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec');
    var DAY_NAMES = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat');

    var _getDateFromFormat = function (val, format) {
        val = val + "";
        format = format + "";
        var i_val = 0;
        var i_format = 0;
        var c = "";
        var token = "";
        var token2 = "";
        var x, y;
        var now = new Date();
        var year = now.getYear();
        var month = now.getMonth() + 1;
        var date = 1;
        var hh = now.getHours();
        var mm = now.getMinutes();
        var ss = now.getSeconds();
        var ampm = "";
        while (i_format < format.length) {
            c = format.charAt(i_format);
            token = "";
            while ((format.charAt(i_format) == c) && (i_format < format.length)) {
                token += format.charAt(i_format++);
            }
            if (token == "yyyy" || token == "yy" || token == "y") {
                if (token == "yyyy") {
                    x = 4;
                    y = 4;
                }
                if (token == "yy") {
                    x = 2;
                    y = 2;
                }
                if (token == "y") {
                    x = 2;
                    y = 4;
                }
                year = _getInt(val, i_val, x, y);
                if (year === null) {
                    return 0;
                }
                i_val += year.length;
                if (year.length == 2) {
                    if (year > 70) {
                        year = 1900 + (year - 0);
                    } else {
                        year = 2000 + (year - 0);
                    }
                }
            } else if (token == "MMM" || token == "NNN") {
                month = 0;
                for (var i = 0; i < MONTH_NAMES.length; i++) {
                    var month_name = MONTH_NAMES[i];
                    if (val.substring(i_val, i_val + month_name.length).toLowerCase() == month_name.toLowerCase()) {
                        if (token == "MMM" || (token == "NNN" && i > 11)) {
                            month = i + 1;
                            if (month > 12) {
                                month -= 12;
                            }
                            i_val += month_name.length;
                            break;
                        }
                    }
                }
                if ((month < 1) || (month > 12)) {
                    return 0;
                }
            } else if (token == "EE" || token == "E") {
                for (var j = 0; j < DAY_NAMES.length; j++) {
                    var day_name = DAY_NAMES[j];
                    if (val.substring(i_val, i_val + day_name.length).toLowerCase() == day_name.toLowerCase()) {
                        i_val += day_name.length;
                        break;
                    }
                }
            } else if (token == "MM" || token == "M") {
                month = _getInt(val, i_val, token.length, 2);
                if (month === null || (month < 1) || (month > 12)) {
                    return 0;
                }
                i_val += month.length;
            } else if (token == "dd" || token == "d") {
                date = _getInt(val, i_val, token.length, 2);
                if (date === null || (date < 1) || (date > 31)) {
                    return 0;
                }
                i_val += date.length;
            } else if (token == "hh" || token == "h") {
                hh = _getInt(val, i_val, token.length, 2);
                if (hh === null || (hh < 1) || (hh > 12)) {
                    return 0;
                }
                i_val += hh.length;
            } else if (token == "HH" || token == "H") {
                hh = _getInt(val, i_val, token.length, 2);
                if (hh === null || (hh < 0) || (hh > 23)) {
                    return 0;
                }
                i_val += hh.length;
            } else if (token == "KK" || token == "K") {
                hh = _getInt(val, i_val, token.length, 2);
                if (hh === null || (hh < 0) || (hh > 11)) {
                    return 0;
                }
                i_val += hh.length;
            } else if (token == "kk" || token == "k") {
                hh = _getInt(val, i_val, token.length, 2);
                if (hh === null || (hh < 1) || (hh > 24)) {
                    return 0;
                }
                i_val += hh.length;
                hh--;
            } else if (token == "mm" || token == "m") {
                mm = _getInt(val, i_val, token.length, 2);
                if (mm === null || (mm < 0) || (mm > 59)) {
                    return 0;
                }
                i_val += mm.length;
            } else if (token == "ss" || token == "s") {
                ss = _getInt(val, i_val, token.length, 2);
                if (ss === null || (ss < 0) || (ss > 59)) {
                    return 0;
                }
                i_val += ss.length;
            } else if (token == "a") {
                if (val.substring(i_val, i_val + 2).toLowerCase() == "am") {
                    ampm = "AM";
                } else if (val.substring(i_val, i_val + 2).toLowerCase() == "pm") {
                    ampm = "PM";
                } else {
                    return 0;
                }
                i_val += 2;
            } else {
                if (val.substring(i_val, i_val + token.length) != token) {
                    return 0;
                } else {
                    i_val += token.length;
                }
            }
        }
        if (i_val != val.length) {
            return 0;
        }
        if (month == 2) {
            if (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) {
                if (date > 29) {
                    return 0;
                }
            } else {
                if (date > 28) {
                    return 0;
                }
            }
        }
        if ((month == 4) || (month == 6) || (month == 9) || (month == 11)) {
            if (date > 30) {
                return 0;
            }
        }
        if (hh < 12 && ampm == "PM") {
            hh = hh - 0 + 12;
        } else if (hh > 11 && ampm == "AM") {
            hh -= 12;
        }
        var newdate = new Date(year, month - 1, date, hh, mm, ss);
        return newdate.getTime();
    };

    var _formatDate = function (date, format) {
        format = format + "";
        var result = "";
        var i_format = 0;
        var c = "";
        var token = "";
        var y = date.getYear() + "";
        var M = date.getMonth() + 1;
        var d = date.getDate();
        var E = date.getDay();
        var H = date.getHours();
        var m = date.getMinutes();
        var s = date.getSeconds();
        var yyyy, yy, MMM, MM, dd, hh, h, mm, ss, ampm, HH, KK, K, kk, k;
        var value = {};
        if (y.length < 4) {
            y = "" + (y - 0 + 1900);
        }
        value.y = "" + y;
        value.yyyy = y;
        value.yy = y.substring(2, 4);
        value.M = M;
        value.MM = LZ(M);
        value.MMM = MONTH_NAMES[M - 1];
        value.NNN = MONTH_NAMES[M + 11];
        value.d = d;
        value.dd = LZ(d);
        value.E = DAY_NAMES[E + 7];
        value.EE = DAY_NAMES[E];
        value.H = H;
        value.HH = LZ(H);
        if (H === 0) {
            value.h = 12;
        } else if (H > 12) {
            value.h = H - 12;
        } else {
            value.h = H;
        }
        value.hh = LZ(value.h);
        if (H > 11) {
            value.K = H - 12;
        } else {
            value.K = H;
        }
        value.k = H + 1;
        value.KK = LZ(value.K);
        value.kk = LZ(value.k);
        if (H > 11) {
            value.a = "PM";
        } else {
            value.a = "AM";
        }
        value.m = m;
        value.mm = LZ(m);
        value.s = s;
        value.ss = LZ(s);
        while (i_format < format.length) {
            c = format.charAt(i_format);
            token = "";
            while ((format.charAt(i_format) == c) && (i_format < format.length)) {
                token += format.charAt(i_format++);
            }
            if (typeof value[token] !== "undefined" && value[token] !== null) {
                result = result + value[token];
            } else {
                result = result + token;
            }
        }
        return result;
    };

    var _getInt = function (str, i, minlength, maxlength) {
        for (var x = maxlength; x >= minlength; x--) {
            var token = str.substring(i, i + x);
            if (token.length < minlength) {
                return null;
            }
            if (_isInteger(token)) {
                return token;
            }
        }
        return null;
    };

    var _isInteger = function (val) {
        var digits = "1234567890";
        for (var i = 0; i < val.length; i++) {
            if (digits.indexOf(val.charAt(i)) == -1) {
                return false;
            }
        }
        return true;
    };

    var LZ = function LZ(x) {
        return (x < 0 || x > 9 ? "" : "0") + x;
    };

    var _getStartEndDatesForReconnect = function (localDateTime, option) {
        var tmpDates = new Date(localDateTime);
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = _dateToUnixtime(tmpDates);
        return _getNewStartEndDates(tmpDates, option);
    };

    var _getNewStartEndDates = function (date, option) {   //option: -1 (scroll left), 0 (selected date), 1 (scroll right)
        var intDay = 86400000;
        var intSecond = 1000;
        var tmpDate = date;
        var tmpStartDate, tmpEndDate;
        switch (option) {
            case -1:
                tmpStartDate = tmpDate - (3 * intDay);
                tmpEndDate = tmpDate - intSecond;
                break;
            case 1:
                tmpStartDate = tmpDate + intSecond;
                tmpEndDate = tmpDate + (3 * intDay);
                break;
            case -11: //ANALOG
                tmpStartDate = tmpDate - (intDay);
                tmpEndDate = tmpDate - intSecond;
                break;
            case 11: //ANALOG
                tmpStartDate = tmpDate + intSecond;
                tmpEndDate = tmpDate + (intDay);
                break;
            case -12: //3 days ANALOG
                tmpStartDate = tmpDate - (3 * intDay);
                tmpEndDate = tmpDate - intSecond;
                break;
            case 0:
                tmpStartDate = tmpDate - (1 * intDay);
                tmpEndDate = tmpDate + (2 * intDay);
                break;
            case -3:
                tmpStartDate = tmpDate - (3 * intDay);
                tmpEndDate = tmpDate + (2 * intDay);
                break;
            case 10:
                tmpStartDate = tmpDate - (4 * intDay);
                tmpEndDate = tmpDate + (5 * intDay);
                break;
            case 9: // CHART RECORDER - DAY
                tmpStartDate = tmpDate - (1 * intDay);
                tmpEndDate = tmpDate - intSecond;
                break;
            case -7: // CHART RECORDER - WEEK
                tmpStartDate = tmpDate - (7 * intDay);
                tmpEndDate = tmpDate - intSecond;
                break;
            case 90: // Voltage table for Manhole Monitor - 3 MONTHS
                tmpStartDate = tmpDate - (90 * intDay);
                tmpEndDate = tmpDate + (91 * intDay);
                break;
            case -95: // Voltage chart for Manhole Monitor - 3 MONTHS
                tmpStartDate = tmpDate - (10 * intDay);
                tmpEndDate = tmpDate - intSecond;
                break;
            case 95: // Voltage chart for Manhole Monitor - 3 MONTHS
                tmpStartDate = tmpDate + intSecond;
                tmpEndDate = tmpDate + (10 * intDay);
                break;
            case 180: // Pump Alarm and Alerts- 6 MONTHS
                tmpStartDate = tmpDate - (180 * intDay);
                tmpEndDate = tmpDate - intSecond;
                break;
            case 50:
                tmpStartDate = tmpDate - (10 * intDay);
                tmpEndDate = tmpDate + (40 * intDay);
                break;
            case 51:
                tmpStartDate = tmpDate;
                tmpEndDate = tmpDate - (0.25 * intDay);
                break;
            default:
                tmpStartDate = tmpDate - (1 * intDay);
                tmpEndDate = tmpDate + (2 * intDay);
                break;
        }
        return { 'startDate': tmpStartDate, 'endDate': tmpEndDate };
    };

    var _toUnixtime = function (str) {
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        return unixtime;
    };

    var _toUnixtimeMs = function (str) {
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2), str.substr(14, 3)); //1404751962000
        return unixtime;
    };

    var _strToUnixtime = function (str) { //2015-06-08T18:16:15
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(5, 2)) - 1, str.substr(8, 2), str.substr(11, 2), str.substr(14, 2), str.substr(17, 2)); //1404751962000
        return unixtime;
    };

    var _dateToUnixtime = function (date) {
        var unixtime = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()); //1404751962000
        return unixtime;
    };

    var _socketStrToServerStrTime = function (_str) {
        var _strTime = _str.substr(0, 4) + "-" + _str.substr(4, 2) + "-" + _str.substr(6, 2) + "T" + _str.substr(8, 2) + ":" + _str.substr(10, 2) + ":" + _str.substr(12, 2); //2014-10-31T10:30:07
        return _strTime;
    };

    var _utcToLocalByTimeZoneOffset = function (dateTime, timeZoneOffset) {
        var _localReportDateTime = (new Date(dateTime).getTime() - timeZoneOffset * 60 * 1000);
        return moment(new Date(_localReportDateTime)).format('YYYY-MM-DDTHH:mm:ss');
    };

    var _utcToLocalByTimeZone = function (dateTime, timeZone) {
        return _utcToLocalByTimeZoneOffset(dateTime, -moment.tz(dateTime, _getTimeZoneId(timeZone)).utcOffset());
    };
    var _utcToLocalTimeStampByTimeZone = function (dateTime, timeZone) {
        var timeZoneOffset = -moment.tz(dateTime, _getTimeZoneId(timeZone)).utcOffset();
        var _localReportDateTime = (new Date(dateTime).getTime() - timeZoneOffset * 60 * 1000);
        return _localReportDateTime;
    };
    var _localToUtcTimeStampByTime = function (dateTime, timeZone) {
        var timeZoneOffset = -moment.tz(dateTime, _getTimeZoneId(timeZone)).utcOffset();
        var unixDate = new Date(dateTime);
        //Because of Newfoundland, India, etc... where Time Offset is not whole number/hour
        //but rather 3.5, or 12.5 we will keep the offset in minutes rather than in hours
        var timeOffSet = timeZoneOffset; // / 60;
        unixDate.setMinutes(unixDate.getMinutes() + timeOffSet);
        return  unixDate.getTime();
    };
    var _currentTimeLocal = function () {
        var momenttz = _convertTimezone();
        var currentTime = moment().tz(momenttz).format('YYYY-MM-DD hh:mm:ss');
        return currentTime;
    };

    var _currentTimeLocalUnix = function () {
        var momenttz = _convertTimezone();
        var currentTimeUnix = _toUnixtime(moment().tz(momenttz).format('YYYYMMDDhhmmss'));
        return currentTimeUnix;
    };

    var _startEndLocalToUtc = function (tmpDates, timeZone) {
        tmpDates.startDate = _localToUtcTimeStampByTime(tmpDates.startDate, timeZone);
        tmpDates.endDate = _localToUtcTimeStampByTime(tmpDates.endDate, timeZone);
        return tmpDates;
    };

    var _getTimeZoneOffset = function (zoneCode) {
        switch (zoneCode) {
            case "E": return -5;
            case "C": return -6;
            case "M": return -7;
            case "P": return -8;
            case "K": return -9;
            case "H": return -10;
        }
    }

    var _getTimeZoneId = function (timeZone) {
        switch (timeZone.toLowerCase()) {
            case "a":
                return "Canada/Atlantic";
            case "c":
                return "US/Central";
            case "e":
                return "US/Eastern";
            case "g":
                return "Pacific/Guam";
            case "h":
                return "US/Hawaii";
            case "i":
                return "US/East-Indiana";
            case "k":
                return "US/Alaska";
            case "m":
                return "US/Mountain";
            case "n":
                return "Canada/Newfoundland";
            case "p":
                return "America/Los_Angeles";
            case "r":
                return "America/Caracas";
            case "z":
                return "America/Phoenix";
            default:
                return "US/Eastern";
        }
    }

    datetimeFactory.formatDateAgentText = _formatDateAgentText;
    datetimeFactory.getDateFromFormat = _getDateFromFormat;
    datetimeFactory.formatDate = _formatDate;
    datetimeFactory.getNewStartEndDates = _getNewStartEndDates;
    datetimeFactory.getStartEndDatesForReconnect = _getStartEndDatesForReconnect;
    datetimeFactory.toUnixtime = _toUnixtime;
    datetimeFactory.toUnixtimeMs = _toUnixtimeMs;
    datetimeFactory.dateToUnixtime = _dateToUnixtime;
    datetimeFactory.currentTimeLocal = _currentTimeLocal;
    datetimeFactory.currentTimeLocalUnix = _currentTimeLocalUnix;
    datetimeFactory.socketStrToServerStrTime = _socketStrToServerStrTime;
    datetimeFactory.strToUnixtime = _strToUnixtime;
    datetimeFactory.GetTimeZoneOffset = _getTimeZoneOffset;
    datetimeFactory.UtcToLocalByTimeZoneOffset = _utcToLocalByTimeZoneOffset;
    datetimeFactory.UtcToLocalByTimeZone = _utcToLocalByTimeZone;
    datetimeFactory.getTimeZoneId = _getTimeZoneId;
    datetimeFactory.utcToLocalTimeStampByTimeZone = _utcToLocalTimeStampByTimeZone;
    datetimeFactory.localToUtcTimeStampByTime = _localToUtcTimeStampByTime;
    datetimeFactory.startEndLocalToUtc = _startEndLocalToUtc;
    return datetimeFactory;
}]
);
mcapp.factory("analogSettingValidationService", function () {

    var service = {};

    service.validateGaugeRange = function (options) {

        var minValue = Number(options.minValue);
        var maxValue = Number(options.maxValue);
        var gaugeMin = angular.isUndefined(options.gaugeMinValue) ||  options.gaugeMinValue === null || options.gaugeMinValue === "" ? 0 : Number(options.gaugeMinValue);
        var gaugeMax = angular.isUndefined(options.gaugeMaxValue) ||  options.gaugeMaxValue === null || options.gaugeMaxValue === "" ? 0 : Number(options.gaugeMaxValue);
        var changedField = options.changedField;

        var reverseScaling = minValue > maxValue;

        var hasGaugeMin = gaugeMin !== 0 && !isNaN(gaugeMin);
        var hasGaugeMax = gaugeMax !== 0 && !isNaN(gaugeMax);

        // Lower Range Value
        if (hasGaugeMin) {
            if (!reverseScaling && gaugeMin < minValue) {
                return {
                    valid: false,
                    field: "gaugeMinValue",
                    message: "Lower Range Value must be greater than or equal to Minimum Value."
                };
            }

            if (reverseScaling && gaugeMin > minValue) {
                return {
                    valid: false,
                    field: "gaugeMinValue",
                    message: "For Reverse Scaling, Lower Range Value must be less than or equal to Minimum Value."
                };
            }
        }

        // Lower Range vs Upper Range
        if (hasGaugeMin && hasGaugeMax) {
            if (!reverseScaling && gaugeMin >= gaugeMax) {
                return {
                    valid: false,
                    field: changedField || "gaugeMinValue",
                    message: changedField === "gaugeMaxValue"
                        ? "Upper Range Value must be greater than Lower Range Value."
                        : "Lower Range Value must be less than Upper Range Value."
                };
            }

            if (reverseScaling && gaugeMin <= gaugeMax) {
                return {
                    valid: false,
                    field: changedField || "gaugeMinValue",
                    message: changedField === "gaugeMaxValue"
                        ? "For Reverse Scaling, Upper Range Value must be less than Lower Range Value."
                        : "For Reverse Scaling, Lower Range Value must be greater than Upper Range Value."
                };
            }
        }

        // Only Upper Range configured
        if (!hasGaugeMin && hasGaugeMax) {
            if (!reverseScaling && gaugeMax <= minValue) {
                return {
                    valid: false,
                    field: "gaugeMaxValue",
                    message: "Upper Range Value must be greater than Minimum Value."
                };
            }

            if (reverseScaling && gaugeMax >= minValue) {
                return {
                    valid: false,
                    field: "gaugeMaxValue",
                    message: "For Reverse Scaling, Upper Range Value must be less than Minimum Value."
                };
            }
        }

        // Only Lower Range configured
        if (hasGaugeMin && !hasGaugeMax) {
            if (!reverseScaling && gaugeMin >= maxValue) {
                return {
                    valid: false,
                    field: "gaugeMinValue",
                    message: "Lower Range Value must be less than Maximum Value."
                };
            }

            if (reverseScaling && gaugeMin <= maxValue) {
                return {
                    valid: false,
                    field: "gaugeMinValue",
                    message: "For Reverse Scaling, Lower Range Value must be greater than Maximum Value."
                };
            }
        }

        // Upper Range Value
        if (hasGaugeMax) {

            if (!reverseScaling && gaugeMax > maxValue) {
                return {
                    valid: false,
                    field: "gaugeMaxValue",
                    message: "Upper Range Value must be less than or equal to Maximum Value."
                };
            }

            if (reverseScaling && gaugeMax < maxValue) {
                return {
                    valid: false,
                    field: "gaugeMaxValue",
                    message: "For Reverse Scaling, Upper Range Value must be greater than or equal to Maximum Value."
                };
            }
        }

        return {
            valid: true,
            gaugeMinValue: gaugeMin,
            gaugeMaxValue: gaugeMax
        };
    };

    service.validateAnalogRange = function (options) {

        var oldMinValue = Number(options.oldMinValue);
        var oldMaxValue = Number(options.oldMaxValue);
        var newValue = Number(options.newValue);
        var changedField = options.changedField;

        var displayRangeEnabled = options.displayRangeEnabled;
        var gaugeMin = options.gaugeMinValue;
        var gaugeMax = options.gaugeMaxValue;

        var hasGaugeMin = gaugeMin !== null &&  gaugeMin !== undefined && gaugeMin !== "" &&  Number(gaugeMin) !== 0;
        var hasGaugeMax = gaugeMax !== null &&  gaugeMax !== undefined && gaugeMax !== "" &&  Number(gaugeMax) !== 0;
        gaugeMin = Number(gaugeMin);
        gaugeMax = Number(gaugeMax);

        // No Display Range validation required if Display Range Checkbox is disabled
        if (!displayRangeEnabled || (!hasGaugeMin && !hasGaugeMax)) {
            return {
                valid: true
            };
        }

        if (changedField === "minimumValue") {
            // Normal scaling
            if (oldMinValue < oldMaxValue) {
                // New Minimum cannot cross LRV
                if (hasGaugeMin && newValue > gaugeMin) {
                    return {
                        valid: false,
                        field: "minimumValue",
                        message: "Please clear Lower Range Value before updating Minimum Value."
                    };
                }

                // New Minimum cannot cross URV
                if (hasGaugeMax && newValue > gaugeMax) {
                    return {
                        valid: false,
                        field: "minimumValue",
                        message: "Please clear Upper Range Value before updating Minimum Value."
                    };
                }

                // New Minimum cannot cross Maximum
                if (newValue > oldMaxValue) {
                    return {
                        valid: false,
                        field: "minimumValue",
                        message: "For Reverse Scaling, please disable Display Range Checkbox before updating Minimum Value."
                    };
                }
            }

            // Reverse scaling
            if (oldMinValue > oldMaxValue) {
                // New Minimum cannot cross LRV
                if (hasGaugeMin && newValue < gaugeMin) {
                    return {
                        valid: false,
                        field: "minimumValue",
                        message: "Please clear Lower Range Value before updating Minimum Value."
                    };
                }

                // New Minimum cannot cross URV
                if (hasGaugeMax && newValue < gaugeMax) {
                    return {
                        valid: false,
                        field: "minimumValue",
                        message: "Please clear Upper Range Value before updating Minimum Value."
                    };
                }

                // Existing reverse scaling validation
                if (newValue < oldMaxValue) {
                    return {
                        valid: false,
                        field: "minimumValue",
                        message: "For Normal Scaling, please disable Display Range Checkbox before updating Minimum Value."
                    };
                }
            }
        }

        if (changedField === "maximumValue") {
            // Normal scaling
            if (oldMinValue < oldMaxValue) {
                // New Maximum cannot cross URV
                if (hasGaugeMax && newValue < gaugeMax) {
                    return {
                        valid: false,
                        field: "maximumValue",
                        message: "Please clear Upper Range Value before updating Maximum Value."
                    };
                }

                // New Maximum cannot cross LRV
                if (hasGaugeMin && newValue < gaugeMin) {
                    return {
                        valid: false,
                        field: "maximumValue",
                        message: "Please clear Lower Range Value before updating Maximum Value."
                    };
                }

                // Existing normal scaling validation
                if (newValue < oldMinValue) {
                    return {
                        valid: false,
                        field: "maximumValue",
                        message: "For Reverse Scaling, please disable Display Range Checkbox before updating Maximum Value."
                    };
                }
            }

            // Reverse scaling
            if (oldMinValue > oldMaxValue) {
                // New Maximum cannot cross URV
                if (hasGaugeMax && newValue > gaugeMax) {
                    return {
                        valid: false,
                        field: "maximumValue",
                        message: "Please clear Upper Range Value before updating Maximum Value."
                    };
                }
                // New Maximum cannot cross LRV
                if (hasGaugeMin && newValue > gaugeMin) {
                    return {
                        valid: false,
                        field: "maximumValue",
                        message: "Please clear Lower Range Value before updating Maximum Value."
                    };
                }

                // Existing reverse scaling validation
                if (newValue > oldMinValue) {
                    return {
                        valid: false,
                        field: "maximumValue",
                        message: "For Normal Scaling, please disable Display Range Checkbox before updating Maximum Value."
                    };
                }
            }
        }
        return {
            valid: true
        };
    };

    return service;
});
mcapp.factory("AccountInfoService", ["HOST", "LOCALHOST", function (HOST, LOCALHOST) {
    var acccountInfoFactory = {};

    var _getAccountInfo = function (accountInfo, newInfo, customerSwitch) {

        //set default customer preferences if not setup yet
        if (newInfo.preferenceCustomer === null) {
            newInfo.lookupRuntimeScale = {
                lookupRuntimeScale: 'H',
                metarStationID: 1
            };
        }
        
        //customer
        accountInfo.customerId = newInfo.customer.customerId;
        accountInfo.customerName = newInfo.customer.name;
        accountInfo.timeZone = newInfo.customer.timeZone;
        accountInfo.timeZoneOffset = newInfo.customer.timeZoneOffset;
        accountInfo.customerCountry = newInfo.customer.country;
        accountInfo.tankAndWell = newInfo.customer.tankAndWell;
        accountInfo.allowMigration = newInfo.customer.allowToMigrateNotification;
        accountInfo.analogInterconnect = newInfo.customer.analogInterconnect;
        accountInfo.digitalInterconnect = newInfo.customer.digitalInterconnect;
        accountInfo.fips = newInfo.customer.fips;
        accountInfo.dispatcherVersion = newInfo.customer.dispatcherVersion;
        accountInfo.logoName = (newInfo.customer.logoName == null) ? "" : (document.location.hostname === "localhost" ? LOCALHOST + HOST : HOST) + "/images/cust/" + newInfo.customer.logoName;
        accountInfo.logoSizeId = newInfo.customer.logoSizeId;
        accountInfo.notificationMode = newInfo.customer.notificationMode;
        accountInfo.numberOfDevices = newInfo.customer.numberOfDevices;
        accountInfo.numberOfLegacyDevices = newInfo.customer.numberOfLegacyDevices;
        accountInfo.integratedFlow = newInfo.customer.integratedFlow;
        accountInfo.hasChlorineReport = newInfo.customer.hasChlorineReport;
        accountInfo.hasSsoCsoReport = newInfo.customer.hasSsoCsoReport;
        accountInfo.hasVolumetricFlow = newInfo.customer.hasVolumetricFlow;
        accountInfo.hasPumpStation = newInfo.customer.hasPumpStation;
        accountInfo.hasMyLevel = newInfo.customer.hasMyLevel;
        accountInfo.address1 = newInfo.customer.address1;
        accountInfo.address2 = newInfo.customer.address2;
        accountInfo.city = newInfo.customer.city;
        accountInfo.state = (newInfo.customer.state == null) ? " " : newInfo.customer.state;
        accountInfo.zip = newInfo.customer.zip;
        accountInfo.country = newInfo.customer.country;
        accountInfo.customerPhone = newInfo.customer.phone;
        accountInfo.daysPastDue = newInfo.customer.daysPastDue;

        //customer preferences
        accountInfo.preferenceCustomer = newInfo.preferenceCustomer;

        //menu items
        accountInfo.menuItems = newInfo.menuItems;

        if (!customerSwitch) {

            //set default user preferences if not setup yet
            if (newInfo.preferenceUser === null) {
                newInfo.preferenceUser = {
                    audioEnabled: 1,
                    engineeringUnitDisplay: 1,
                    lookupLanguageID: 1,
                    lookupMeasurementID: 1,
                    i18nCode: 'en'
                };
            }

            //user
            accountInfo.accessToken = newInfo.user.accessToken;
            accountInfo.userId = newInfo.user.userId;
            accountInfo.userName = newInfo.user.userName;
            accountInfo.name = newInfo.user.name;
            accountInfo.email = newInfo.user.email;
            accountInfo.phone = newInfo.user.phone;
            accountInfo.spf = newInfo.user.password;
            accountInfo.userRole = newInfo.user.userRole;
            accountInfo.ticketSystemSessionId = newInfo.user.ticketSystemSessionId;
            accountInfo.updateFlag = newInfo.user.updateFlag;
            accountInfo.updateUsernameFlag = newInfo.user.updateUsernameFlag;
            accountInfo.updatePasswordFlag = newInfo.user.updatePasswordFlag;
            accountInfo.oldUsername = newInfo.user.oldUsername;
            accountInfo.userType = newInfo.user.userType;
            accountInfo.portal = newInfo.user.portal;
            accountInfo.managedSites = newInfo.user.managedSites;
            accountInfo.distributorOus = newInfo.user.distributorOus;
            accountInfo.missionEmployeeOus = newInfo.user.missionEmployeeOus;
            accountInfo.termsAgreed = newInfo.user.termsAgreed;
            accountInfo.termsAgreedFlag = newInfo.user.termsAgreedFlag;
            accountInfo.alreadyRegisteredWebinar = newInfo.user.alreadyRegisteredWebinar;
            accountInfo.optOutWebinar = newInfo.user.optOutWebinar;
            accountInfo.optOutTASIToaster = newInfo.user.optOutTASIToaster;
            accountInfo.twoFactorAuthentication = newInfo.user.twoFactorAuthentication;
            accountInfo.turnOn2FaFlag = newInfo.user.turnOn2FaFlag;
            accountInfo.optOutPricingToaster = newInfo.user.optOutPricingToaster;
            accountInfo.mfaMigrationStatus = newInfo.user.mfaMigrationStatus;
            accountInfo.mfaMigrationExpiryDate = newInfo.user.mfaMigrationExpiryDate;
            accountInfo.mfaMigrationRequired = newInfo.user.mfaMigrationRequired;
            accountInfo.hasPasswordHash = newInfo.user.hasPasswordHash;
            accountInfo.passwordChangedDate = newInfo.user.passwordChangedDate;
            accountInfo.securityPortalRequired = newInfo.user.securityPortalRequired;
            accountInfo.passwordResetEveryNDays = newInfo.user.passwordResetEveryNDays;
            accountInfo.mcAdmin = newInfo.user.mcAdmin;
            

            //user preferences
            accountInfo.preferenceUser = newInfo.preferenceUser;

            //active documents
            accountInfo.activeDocumentationList = newInfo.activeDocumentationList;

            //wizard status
            accountInfo.wizardStatusId = newInfo.wizardStatusId;
        }
    };

    var _updateAccountInfoUserData = function (accountInfo, newUserInfo) {
            //user
        accountInfo.userRole = newUserInfo.userRole;
    };

    acccountInfoFactory.getAccountInfo = _getAccountInfo;
    acccountInfoFactory.updateAccountInfoUserData = _updateAccountInfoUserData;
    return acccountInfoFactory;
}]);
"use strict";

angular.module("mc.digital-gauge", []);
'use strict';

function McDigitalGaugeFactory(HOST, $http) {

    // instantiate our initial object
    var McDigitalGauge = function McDigitalGauge(customerId, deviceId, timeZone, categoryId, widgetId, channel) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.channel = channel;
    };

    McDigitalGauge.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/DigitalWidget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&channel=' + this.channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McDigitalGauge.prototype.getWidgetData = function (channelId) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channelId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McDigitalGauge;
}

McDigitalGaugeFactory.$inject = ['HOST', '$http'];

angular.module('mc.analog-gauge').factory('McDigitalGaugeFactory', McDigitalGaugeFactory);
'use strict';

function McDigitalGaugeController($, $rootScope, $scope, $sce, authenticationService, translationService, deviceMenuService, $timeout, toaster) {
    var ctrl = this;
    ctrl.digitalReady = true;
    //ctrl.$onChanges = (changes) => {
    //    if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
    //        ctrl.deviceSelected = changes.deviceSelected.currentValue;
    //        ctrl.getDeviceType(ctrl.deviceSelected);
    //    }
    //};

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        $scope.downloadViewTypeOptions = [0];

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;

        $scope.$on('rtuStatusDone_' + $scope.windowId, function (event, args) {
            ctrl.digitalReady = true;
            $scope.rtuStatusDone = args.message;
            ctrl.getDeviceType($scope.deviceSelected);
        });
    };

    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
        ctrl.digitalReady = false;
        $timeout(function () {
            ctrl.digitalReady = true;
            ctrl.getDeviceType($scope.deviceSelected);
        }, 0);
    };

    ctrl.getDeviceType = function (deviceId) {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            var _devices = result.data.devices;

            for (var index = 0; index < _devices.length; ++index) {
                if (_devices[index].deviceId === deviceId) {
                    ctrl.m110Runtime = _devices[index].model === 8 || _devices[index].model === 18 ? true : false;
                    break;
                }
            }
        }, function (error) {
            ctrl.m110Runtime = false;
        });
    };
}

McDigitalGaugeController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "translationService", "deviceMenuService", "$timeout", "toaster"];
'use strict';

angular.module('mc.digital-gauge').component('mcDigitalGauge', {
    controller: McDigitalGaugeController,
    templateUrl: 'ui/digital/mcdigitalgauge/mc-digital-gauge-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

function SavePdfChartExcelPrintController($, $rootScope, $scope, $sce, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, openViewService, $location, $window) {
    var _this2 = this;

    var ctrl = this;
    this.popupOffset = 0;
    ctrl.initLoad = true;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.$onInit = function () {
        ctrl.exportItems = angular.isDefined(ctrl.dmViewType) ? ctrl.exportItemsAllOptions.filter(function (i) {
            return ctrl.dmViewType.includes(i.viewType);
        }) : null;
        ctrl.showMenu = false;
    };

    //viewType: 0: advanced; 1: chart; 2: table
    ctrl.exportItemsAllOptions = [{ name: "Print", icon: 'fa-print', viewType: 0 }, { name: "Download PDF document", icon: 'fa-file-pdf-o', viewType: 1 }, { name: "Download spreadsheet", icon: 'fa-file-excel-o', viewType: 2 }, { name: "Advance Download", icon: 'fa-arrow-down', viewType: 4 }];

    ctrl.exportAction = function (viewType) {

        switch (viewType) {
            case 0:
                $timeout(function () {
                    ctrl.printWidget();
                }, 500);
                break;
            case 1:
                ctrl.savePdf();
                break;
            case 2:
                ctrl.saveExcel();
                break;
            case 3:
                ctrl.dmViewFunction();
                break;
            case 4:
                ctrl.openDownload();
                break;
        }
        ctrl.showMenu = false;
    };

    ctrl.printWidget = function () {
        var mywindow = $window.open('', 'MyWindow', 'width=750,height=650,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes');

        // SCADA-13178: On Runtime Variance Report Chart is not displayed in printed PDF. 
        // Convert charts to images
        convertChartsToImages();
        $timeout(function () {
            window.dispatchEvent(new Event('resize'));
            var elementToPrint = void 0;
            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
                elementToPrint = ctrl.popup.parent();
            } else {
                elementToPrint = $("div").parent(".content-classic");
            }

            html2canvas2(elementToPrint[0], { timeout: 333 }).then(function (canvas) {
                restoreCharts();
                var img = canvas.toDataURL("image/png");
                var html = "\n                <!DOCTYPE html>\n                <html>\n                <body>\n                    <img src=\"" + img + "\">\n                    <script>\n                        setTimeout(function(){\n                            window.print();\n                            window.close();\n                        },500);\n                    </script>\n                </body>\n                </html>\n                ";
                mywindow.document.open();
                mywindow.document.write(html);
                mywindow.document.close();
                mywindow.focus();
            });
        }, 600);
    };

    function restoreCharts() {
        document.querySelectorAll(".chart-print-img").forEach(function (el) {
            return el.remove();
        });
        if (!window.Highcharts) return;
        Highcharts.charts.forEach(function (chart) {
            if (!chart) return;
            chart.container.style.display = chart.container.dataset.originalDisplay || "";
            var cardsView = document.getElementById("cards-view");
            if (!chart.renderTo.dataset.originalHeight) {
                chart.renderTo.dataset.originalHeight = chart.chartHeight;
            }
            var originalHeight = parseInt(chart.renderTo.dataset.originalHeight, 10);
            var height = originalHeight;
            if (ctrl.windowId === "Integrated Flow Report" && cardsView) {
                height = originalHeight - cardsView.offsetHeight;
            }
            chart.setSize(null, height, false);
            chart.reflow();
            chart.redraw();
        });
    }

    function convertChartsToImages() {
        document.querySelectorAll(".chart-print-img").forEach(function (el) {
            return el.remove();
        });
        if (!window.Highcharts) return;
        Highcharts.charts.forEach(function (chart) {
            if (!chart) return;
            var container = chart.renderTo;
            chart.reflow();
            chart.redraw();
            var svg = chart.getSVG({
                chart: {
                    width: chart.chartWidth,
                    height: chart.chartHeight
                }
            });
            var width = container.offsetWidth;
            var height = container.offsetHeight;
            var cardsView = document.getElementById("cards-view");
            // Fix for Integrated Flow Report card section
            if (ctrl.windowId === "Integrated Flow Report" && cardsView) {
                height -= cardsView.offsetHeight;
            }

            var canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;

            var ctx = canvas.getContext("2d");
            var img = new Image();

            img.onload = function () {

                ctx.drawImage(img, 0, 0, width, height);
                var chartImage = document.createElement("img");
                chartImage.src = canvas.toDataURL("image/png");
                chartImage.className = "chart-print-img";
                chartImage.style.cssText = "\n                width:" + width + "px;\n                height:" + height + "px;\n                display:block;\n                ";
                container.style.position = "relative";
                container.appendChild(chartImage);
                chart.container.dataset.originalDisplay = chart.container.style.display;
                chart.container.style.display = "none";
            };

            img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
        });
    }

    ctrl.openDownload = function () {

        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;

        if (typeof ctrl.options != "undefined") {
            if (typeof ctrl.options.resolution != "undefined") optionsStickyProperties.downloadOptions.resolution = ctrl.options.resolution;
        } else optionsStickyProperties.downloadOptions.resolution = 0;

        var windowname = "Analog";
        if (ctrl.windowId !== undefined && ctrl.windowId !== null) {
            //Get first word from string EX: 'Analog Chart' = Analog
            windowname = ctrl.windowId.substr(0, ctrl.windowId.indexOf(' '));
            //Format string so First letter Cap, and all rest lowercase
            windowname = windowname.charAt(0).toUpperCase() + windowname.slice(1).toLowerCase();
        }
        //Set downloadOptions.reportType so downloadController knows which to choose by default / select from ctrl.reportList by value in downloadController
        optionsStickyProperties.downloadOptions.reportType = windowname;

        if (_this2.classicView || _this2.mobile) {
            $location.path('/download/download-partial');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;
            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };

            newPopupPosition.at = "left+" + (popup.offset().left + _this2.popupOffset) + " top+" + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 10;

            openViewService.openView('Download', { width: 400, height: 200 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 200, minimumHeight: 100 });
        }
    };

    ctrl.dynamicPopover = {
        templateUrl: 'savePdfChartExcelSelectionTemplate.html'
    };
}

SavePdfChartExcelPrintController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'HOST', '$http', 'translationService', 'sharedSetupService', 'datetimeService', 'deviceService', '$timeout', '$filter', '$element', 'openViewService', '$location', '$window'];
"use strict";

angular.module("mc.download-menu", []);
'use strict';

angular.module('mc.download-menu').component('savePdfChartExcelPrint', {
    controller: SavePdfChartExcelPrintController,
    templateUrl: 'ui/components/savepdfchartexcelprint/save-pdf-chart-excel-print-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        dmChart: '<',
        dmViewType: '<',
        dmViewFunction: '&',
        metarStationId: '<',
        options: '<',
        savePdf: '&',
        saveExcel: '&'
    }
});
mcapp.controller('additionalMenuAController', ['$rootScope', '$scope', 'deviceMenuService',
function ($rootScope, $scope, deviceMenuService) {
    $scope.$on('resetDeviceMenuList', function (event, args) {
      deviceMenuService.getDeviceMenuList(args.customerId);
        // $scope.deviceList();
    });
    
}]);
"use strict";

angular.module("mc.help-icon", []);
'use strict';

function HelpIconController($rootScope, openViewService, translationService, $element, authenticationService, $window, $scope) {
    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;

    if ($rootScope.mobile) return;

    ctrl.$onChanges = function (changes) {

        if (changes.windowId && changes.tabName) {
            //changes.windowId.currentValue = undefined for Classic View
            ctrl.hasHelpIcon = false;
            ctrl.hasHelpIconCheck();

            ctrl.windowId = changes.windowId.currentValue;
            ctrl.tabName = changes.tabName.currentValue;
            ctrl.viewName = ctrl.windowId || ctrl.windowName;

            if (ctrl.windowId) {
                if ($rootScope.classicView) {
                    var _view = angular.element('.page-title-mobile');
                    var _helpIconElement = $element;
                    $element.remove();
                    _view.find("help-icon").remove();
                    _view.append(_helpIconElement);
                } else {
                    {
                        var _view = angular.element('.ui-dialog.ui-widget.ui-widget-content.' + ctrl.windowId.replace(/ /g, '_'));
                        ctrl.viewName = _view.attr("mc-view-name");
                        var _helpIconElement = $element;
                        //the titlebar button pane is a <ul> (WCAG 1.3.1), so the help icon gets its own <li>
                        //and any wrapper left behind by a previous placement is removed with the icon
                        var _previousItem = $element.parent("li.help-icon-item");
                        $element.remove();
                        _previousItem.remove();
                        _view.find("help-icon").each(function () {
                            var _item = angular.element(this).parent("li.help-icon-item");
                            (_item.length ? _item : angular.element(this)).remove();
                        });
                        var _listItem = angular.element('<li class="ui-dialog-titlebar-buttonpane-item help-icon-item" role="listitem"></li>').append(_helpIconElement);
                        _view.find(".ui-dialog-titlebar-buttonpane").append(_listItem);
                        ctrl.syncListItem();
                    }
                }
            }
        }
    };

    ctrl.$onInit = function () {
        ctrl.translation = translationService.translation;
    };

    ctrl.hasHelpIconCheck = function () {
        var windowId = ctrl.windowId || ctrl.windowName;
        if (angular.isUndefined(windowId)) return;
        var split = windowId.split("_");
        windowId = split[0];
        ctrl.accountInfo = JSON.parse($window.sessionStorage.accountInfo);
        for (var i = 0; i < ctrl.accountInfo.activeDocumentationList.length; i++) {
            if (ctrl.accountInfo.activeDocumentationList[i].viewName.toLowerCase() === windowId.toLowerCase() && ctrl.accountInfo.activeDocumentationList[i].active && !ctrl.accountInfo.activeDocumentationList[i].isDeleted) {
                return ctrl.hasHelpIcon = true;
            }
        }
        ctrl.hasHelpIcon = false;
    };

    //when the icon is not shown its <li> must be hidden too, otherwise assistive technology
    //counts an empty list item in the titlebar button list
    ctrl.syncListItem = function () {
        $element.parent("li.help-icon-item").toggle(!!ctrl.hasHelpIcon);
    };

    ctrl.openHelpPanel = function () {
        if (angular.isDefined(ctrl.viewName)) openViewService.openHelpPanel(ctrl.viewName, ctrl.tabName);
    };

    //THE-51638: the help icon is a <span role="button">, so it has to answer
    //Enter/Space the way a real button would
    ctrl.onHelpKeydown = function ($event) {
        if ($event.key === "Enter" || $event.key === " " || $event.key === "Spacebar") {
            $event.preventDefault(); //stop Space from scrolling the view behind it
            ctrl.openHelpPanel();
        }
    };

    $scope.$on('updateActiveDocumentationList', function () {
        ctrl.hasHelpIconCheck();
        ctrl.syncListItem();
    });
};

HelpIconController.$inject = ['$rootScope', 'openViewService', 'translationService', '$element', 'authenticationService', '$window', '$scope'];
'use strict';

angular.module('mc.help-icon').component('helpIcon', {
    controller: HelpIconController,
    templateUrl: 'ui/components/helpicon/help-icon-template.html',
    bindings: {
        windowId: '<',
        windowName: '@',
        tabName: '<'
    }
});
"use strict";

angular.module("mc.date-month-picker", []);
"use strict";

function DateMonthPickerController(translationService, $rootScope, $scope, $timeout, $element) {

    var ctrl = this;
    var previousValueToWatch;

    ctrl.$onInit = function () {
        ctrl.translation = translationService.translation;
        ctrl.dynamicDatePopover = { templateUrl: 'monthPopoverTemplate.html' };
        ctrl.mobile = $rootScope.mobile;
        ctrl.classicView = $rootScope.classicView;
    };

    ctrl.getBackToToday = function () {
        if (ctrl.hideCalButtons) {
            $timeout(function () {
                $($scope.$parent.$ctrl.element).find(".fc-today-button").click();
                $($element).find(".quickdate-button").click();
            }, 0);
        }
    };

    ctrl.prevMonth = function () {
        if (ctrl.hideCalButtons) {
            $timeout(function () {
                $($scope.$parent.$ctrl.element).find(".fc-prev-button").click();
                $($element).find(".quickdate-button").click();
            }, 0);
        }
    };

    ctrl.nextMonth = function () {
        if (ctrl.hideCalButtons) {
            $timeout(function () {
                $($scope.$parent.$ctrl.element).find(".fc-next-button").click();
                $($element).find(".quickdate-button").click();
            }, 0);
        }
    };

    //keyboard access: move focus into the popover when it opens, back to the trigger when it closes
    $scope.$watch('datePopoverVisible', function (open, was) {
        if (open === was) {
            return;
        }
        $timeout(function () {
            if (open) {
                var first = $element[0].querySelector('.popover button:not([disabled])');
                if (first) {
                    first.focus();
                }
            } else {
                var trigger = $element[0].querySelector('button.quickdate-button');
                if (trigger) {
                    trigger.focus();
                }
            }
        });
    });

    ctrl.onKeydown = function ($event) {
        if ($scope.datePopoverVisible && ($event.key === 'Escape' || $event.key === 'Esc')) {
            $event.preventDefault();
            $scope.datePopoverVisible = false;
        }
    };

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translation = args;
    });
};

DateMonthPickerController.$inject = ['translationService', '$rootScope', '$scope', '$timeout', '$element'];
'use strict';

angular.module('mc.date-month-picker').component('dateMonthPicker', {
    controller: DateMonthPickerController,
    templateUrl: 'ui/components/datemonthpicker/date-month-picker-template.html',
    bindings: {
        ytd: '<',
        hideCalButtons: '<',
        currentDate: '<',
        reportDate: '<',
        setReportDate: '&',
        getYearlyData: '&',
        todaysDate: '<',
        nextDate: '<'
    }
});
"use strict";

angular.module("mc.refresh-live-data", []);
'use strict';

function RefreshLiveDataController($, $rootScope, $scope, $sce, authenticationService, translationService, $interval, $timeout) {
    var ctrl = this;
    this.popupOffset = 0;
    ctrl.initLoad = true;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.isButtonDisabled = false; // Initially, the button is enabled
    ctrl.countdown = 0;

    var _countdownInterval = undefined;

    ctrl.$onInit = function () {
        //console.log(ctrl.isInsideWidget);
    };

    ctrl.refreshLiveData = function () {

        // Disable the button immediately
        ctrl.isButtonDisabled = true;
        ctrl.countdown = 30; // Set the initial countdown time

        // Re-enable the button after 30 seconds
        $timeout(function () {
            ctrl.isButtonDisabled = false;
            ctrl.countdown = 0;
        }, 30000); // 30000 milliseconds = 30 seconds

        // Optional: Update the countdown timer every second
        _countdownInterval = $interval(function () {
            if (ctrl.countdown > 0) {
                ctrl.countdown--;
            } else {
                $interval.cancel(_countdownInterval); // Stop the interval when countdown reaches 0
                _countdownInterval = undefined;
            }
        }, 1000); // Update every 1 second

        ctrl.refreshDataFunction();
    };

    $scope.$on("$destroy", function () {
        if (angular.isDefined(_countdownInterval)) {
            $interval.cancel(_countdownInterval);
            _countdownInterval = undefined;
        }
    });
}

RefreshLiveDataController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', '$interval', '$timeout'];
'use strict';

angular.module('mc.refresh-live-data').component('refreshLiveData', {
    controller: RefreshLiveDataController,
    templateUrl: 'ui/components/refreshlivedata/refresh-live-data-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        isInsideWidget: '<',
        refreshDataFunction: '&'
    }
});
"use strict";

angular.module("mc.month-picker-range", []);
'use strict';

function MonthPickerRangeController(translationService, $rootScope, $scope, $timeout, $element) {

    var ctrl = this;
    var previousValueToWatch;
    ctrl.translation = translationService.translation;

    ctrl.months = [];
    ctrl.months.push({ value: 0, text: ctrl.translation.text.JANUARY });
    ctrl.months.push({ value: 1, text: ctrl.translation.text.FEBRUARY });
    ctrl.months.push({ value: 2, text: ctrl.translation.text.MARCH });
    ctrl.months.push({ value: 3, text: ctrl.translation.text.APRIL });
    ctrl.months.push({ value: 4, text: ctrl.translation.text.MAY });
    ctrl.months.push({ value: 5, text: ctrl.translation.text.JUNE });
    ctrl.months.push({ value: 6, text: ctrl.translation.text.JULY });
    ctrl.months.push({ value: 7, text: ctrl.translation.text.AUGUST });
    ctrl.months.push({ value: 8, text: ctrl.translation.text.SEPTEMBER });
    ctrl.months.push({ value: 9, text: ctrl.translation.text.OCTOBER });
    ctrl.months.push({ value: 10, text: ctrl.translation.text.NOVEMBER });
    ctrl.months.push({ value: 11, text: ctrl.translation.text.DECEMBER });

    ctrl.years = [];
    for (var i = moment().year(); i >= 2010; i--) {
        ctrl.years.push({ value: i });
    }

    ctrl.$onInit = function () {
        ctrl.translation = translationService.translation;
        ctrl.dynamicDatePopover = { templateUrl: 'monthPopoverTemplate.html' };
        ctrl.mobile = $rootScope.mobile;
        ctrl.classicView = $rootScope.classicView;
        ctrl.selectedYear = String(moment().year());
        ctrl.selectedMonth = String(moment().month());
    };

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translation = args;
    });
};

MonthPickerRangeController.$inject = ['translationService', '$rootScope', '$scope', '$timeout', '$element'];
'use strict';

angular.module('mc.month-picker-range').component('monthPickerRange', {
    controller: MonthPickerRangeController,
    templateUrl: 'ui/components/monthpickerrange/month-picker-range-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        todaysDate: '<',
        selectedMonth: '=',
        selectedYear: '=',
        setReportMonth: '&',
        setCurrentMonth: '&'
    }
});
"use strict";

angular.module("mc.att-rate-plan", []);
'use strict';

function AttRatePlanFactory(HOST, $http) {

    var _attRatePlan = function _attRatePlan() {};

    _attRatePlan.prototype.GetDeviceTypesCurrentPlansCustomers = function (wirelessCarrier) {
        return $http({
            method: 'GET',
            url: HOST + '/api/CarrierRatePlan/GetDeviceTypeCarrierPlanAndCustomer/',
            params: { wirelessCarrier: wirelessCarrier }
        });
    };

    _attRatePlan.prototype.GetRtuByDeviceTypeCarrierPlanCustomer = function (wirelessCarrier, deviceTypeId, ratePlan, customer) {
        return $http({
            method: 'GET',
            url: HOST + '/api/CarrierRatePlan/GetRtuByDeviceTypeCarrierPlanCustomer/',
            params: { wirelessCarrier: wirelessCarrier, deviceTypeId: deviceTypeId, ratePlan: ratePlan, customer: customer }
        });
    };

    _attRatePlan.prototype.GetRtuBySimOrSerialNumber = function (wirelessCarrier, simNumber, serialNumber) {
        return $http({
            method: 'GET',
            url: HOST + '/api/CarrierRatePlan/GetRtuBySimOrSerialNumber/',
            params: { wirelessCarrier: wirelessCarrier, simNumber: simNumber, serialNumber: serialNumber }
        });
    };

    _attRatePlan.prototype.GetRtuProvisionLog = function (simNumber, meid) {
        return $http({
            method: 'GET',
            url: HOST + '/api/CarrierRatePlan/GetRtuProvisionLog/',
            params: { simNumber: simNumber, meid: meid }
        });
    };

    _attRatePlan.prototype.ActivateSim = function (activateSimInformation, customerId, wirelessCarrier) {
        return $http.post(HOST + "/api/CarrierSimManagement?customerId=" + customerId + "&wirelessCarrier=" + wirelessCarrier, activateSimInformation);
    };

    _attRatePlan.prototype.BulkActivateSim = function (activateModel) {
        return $http.post(HOST + "/api/CarrierSimManagement", activateModel);
    };

    _attRatePlan.prototype.DeactivateSim = function (rtuList, wirelessCarrier) {
        return $http.post(HOST + "/api/CarrierSimManagement?wirelessCarrier=" + wirelessCarrier, rtuList);
    };

    _attRatePlan.prototype.UpdateRtuRatePlan = function (rtuList, ratePlan, wirelessCarrier) {
        return $http.post(HOST + "/api/CarrierRatePlan?ratePlan=" + ratePlan + "&wirelessCarrier=" + wirelessCarrier, rtuList);
    };

    return _attRatePlan;
}

AttRatePlanFactory.$inject = ['HOST', '$http'];

angular.module('mc.att-rate-plan').factory('AttRatePlanFactory', AttRatePlanFactory);
"use strict";

function AttRatePlanController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, AttRatePlanFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, $q, $uibModal, savePdfService) {
    var _this2 = this;

    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    ctrl.ratePlanSummary = [];
    ctrl.deviceTypes = [];
    ctrl.currentPlans = [];
    ctrl.customers = [];
    ctrl.customersCopy = [];
    ctrl.requiredRtus = [];
    ctrl.selectedRtus = [];
    ctrl.deactivateRtus = [];
    ctrl.activateRtus = [];
    ctrl.initialLetters = [];
    ctrl.updatePlanResult = [];
    ctrl.provisionLogs = [];
    ctrl.displayMode = 0; //0 for displaying RTU search result, 1 for displaying carrier rate plan update result
    ctrl.initialLetterSelected = null;
    ctrl.customerName = null;
    ctrl._attRatePlan = null;
    ctrl.allRtuSelected = false;
    ctrl.defaultAddress = false;
    ctrl.activateSimInformation = {
        date: null,
        sim: null,
        ratePlan: null,
        profileName: null,
        street1: null,
        street2: null,
        city: null,
        state: null,
        zip: null,
        customerField1: null,
        customerField2: null,
        customerField3: null,
        customerField4: null,
        customerField5: null
    };

    ctrl.$onInit = function () {
        ctrl._attRatePlan = new AttRatePlanFactory();
        ctrl.reverse = true;
        //ctrl.provisionLogLoading = false;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.firstOpen = true; //to select the customer of the current site the user is in
        ctrl.deviceType = null;
        ctrl.currentPlan = null;
        ctrl.selectedPlan = null;
        ctrl.numberOfDevices = 0;
        ctrl.initialLetterSelected = ctrl.accountInfo.customerName.charAt(0);
        ctrl.getDeviceTypesCurrentPlansCustomers(); //Get device types and current carrier rate plans for dropdown list

        ctrl.profileNames = [{ id: 1, name: "19 NATL" }, { id: 2, name: "20 INTL" }, { id: 3, name: "33 NATL" }];

        ctrl.initialLetters = {
            "A": "A",
            "B": "B",
            "C": "C",
            "D": "D",
            "E": "E",
            "F": "F",
            "G": "G",
            "H": "H",
            "I": "I",
            "J": "J",
            "K": "K",
            "L": "L",
            "M": "M",
            "N": "N",
            "O": "O",
            "P": "P",
            "Q": "Q",
            "R": "R",
            "S": "S",
            "T": "T",
            "U": "U",
            "V": "V",
            "W": "W",
            "X": "X",
            "Y": "Y",
            "Z": "Z"
        };
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for       

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }
    };

    //Get device types and carrier rate plans for dropdown list
    ctrl.getDeviceTypesCurrentPlansCustomers = function () {
        ctrl._attRatePlan.GetDeviceTypesCurrentPlansCustomers("ATT").then(function (resp) {
            ctrl.deviceTypes = resp.data.deviceTypes;
            ctrl.currentPlans = resp.data.carrierRatePlans;
            ctrl.customers = resp.data.ratePlanCustomers;
            ctrl.filterCustomers(ctrl.initialLetterSelected);
        });
    };

    //Get RTU by provided device type, carrier rate plan and customer name
    ctrl.getRtuByDeviceTypeCarrierPlanCustomer = function (deviceTypeId, ratePlan, customer) {
        ctrl.requiredRtus = [];
        ctrl.numberOfDevices = 0; //clear selected RTU count when search for new RTU
        ctrl.displayMode = 0;
        ctrl.selectedPlan = null;
        ctrl._attRatePlan.GetRtuByDeviceTypeCarrierPlanCustomer("A", deviceTypeId, ratePlan, customer).then(function (resp) {
            ctrl.requiredRtus = resp.data;
            for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                if (ctrl.requiredRtus[i].simNumber === null || ctrl.requiredRtus[i].simNumber === "") {
                    ctrl.requiredRtus.splice(i, 1);
                };
            }
        });
    };

    //Get RTU by provided SIM number or serial number
    ctrl.getRtuBySimOrSerialNumber = function (simNumber, serialNumber) {
        ctrl.requiredRtus = [];
        ctrl.numberOfDevices = 0; //clear selected RTU count when search for new RTU
        ctrl.displayMode = 0;
        ctrl.selectedPlan = null;
        ctrl._attRatePlan.GetRtuBySimOrSerialNumber("A", simNumber, serialNumber).then(function (resp) {
            if (resp.data !== null) {
                ctrl.requiredRtus.push(resp.data);
                ctrl.numberOfDevices = 1;
            }
        });
    };

    //Filter customers based on the initial letter selected 
    ctrl.filterCustomers = function (initialLetter) {
        ctrl.customersCopy = ctrl.customers.filter(function (el) {
            return el.name.startsWith(initialLetter);
        });
        if (ctrl.firstOpen) {
            for (var i = 0; i < ctrl.customersCopy.length; i++) {
                if (ctrl.customersCopy[i].name == ctrl.accountInfo.customerName) ctrl.customerName = ctrl.customersCopy[i];
            }
        };
        ctrl.firstOpen = false;
    };

    ctrl.cleanInputFields = function () {
        ctrl.simNumber = null;
        ctrl.serialNumber = null;
    };

    //Select all RTUs
    ctrl.selectAll = function () {
        var i;
        if (ctrl.allRtuSelected) {
            for (i = 0; i < ctrl.requiredRtus.length; i++) {
                ctrl.requiredRtus[i].isSelected = true;
            }
            ctrl.numberOfDevices = ctrl.requiredRtus.length;
        } else {
            for (i = 0; i < ctrl.requiredRtus.length; i++) {
                ctrl.requiredRtus[i].isSelected = false;
            }
            ctrl.numberOfDevices = 0;
        }
    };

    //Update selected RTUs' carrier rate plan
    ctrl.updateRtuRatePlan = function (selectedPlan) {
        ctrl.selectedRtus = [];
        if (ctrl.allRtuSelected) {
            ctrl.selectedRtus = ctrl.requiredRtus;
        } else {
            for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                if (ctrl.requiredRtus[i].isSelected == true) ctrl.selectedRtus.push(ctrl.requiredRtus[i]);
            }
        }
        var data = {
            rtuList: ctrl.selectedRtus,
            ratePlan: selectedPlan
        };
        console.log(ctrl.selectedRtus);
        ctrl._attRatePlan.UpdateRtuRatePlan(ctrl.selectedRtus, selectedPlan, "ATT").then(function (resp) {
            ctrl.displayMode = 1;
            ctrl.updatePlanResult = resp.data;
        });
    };

    ctrl.showProvisionLog = function (simNumber, provisionLogs) {
        if (provisionLogs) {
            for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                if (ctrl.requiredRtus[i].simNumber == simNumber) ctrl.requiredRtus[i].provisionLogs = null;
            }
        } else {
            //ctrl.provisionLogLoading = true;
            ctrl._attRatePlan.GetRtuProvisionLog(simNumber, null).then(function (resp) {
                for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                    if (ctrl.requiredRtus[i].simNumber == simNumber) ctrl.requiredRtus[i].provisionLogs = resp.data;
                }
                //ctrl.provisionLogLoading = false;
            });
        }
    };

    //used to determine whether to disable activate and deactivate buttons based on the number of RTUs selected
    ctrl.countSelectedDevices = function (isSelected) {
        if (isSelected) {
            ctrl.numberOfDevices += 1;
        } else {
            ctrl.numberOfDevices -= 1;
        }
    };

    ctrl.deactivateSim = function () {
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            //this.tmpConfirmMessageA = item.inUse ? _translation.text.DELETE_SERVICE_USER2 : "";
            this.tmpConfirmMessageB = _translation.text.DEACTIVATE_SIM_CONFIRMATION + '?';

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        };

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            ctrl.deactivateRtus = []; //a list of RTUs that would get deactivated
            if (ctrl.allRtuSelected) {
                ctrl.deactivateRtus = ctrl.requiredRtus;
            } else {
                for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                    if (ctrl.requiredRtus[i].isSelected == true) ctrl.deactivateRtus.push(ctrl.requiredRtus[i]);
                }
            }

            ctrl._attRatePlan.DeactivateSim(ctrl.deactivateRtus, "ATT").then(function (resp) {});
        }, function () {
            // cancel button
        });
    };

    ctrl.activateSim = function () {
        ctrl.activateRtus = []; //a list of RTUs that would get activated
        if (ctrl.allRtuSelected) {
            ctrl.activateRtus = ctrl.requiredRtus;
        } else {
            for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                if (ctrl.requiredRtus[i].isSelected == true) ctrl.activateRtus.push(ctrl.requiredRtus[i]);
            }
        }

        ctrl.activateSimInformation = {
            date: null,
            sim: null,
            ratePlan: null,
            profileName: null,
            street1: null,
            street2: null,
            city: null,
            state: null,
            zip: null,
            customerField1: null,
            customerField2: null,
            customerField3: null,
            customerField4: null,
            customerField5: null
        };

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        today = mm + '/' + dd + '/' + yyyy;

        function modalController($uibModalInstance, translation) {
            var _this3 = this;

            this.ratePlan = null;
            this.profileName = null;
            this.street1 = null;
            this.street2 = null;
            this.city = null;
            this.state = null;
            this.zip = null;
            this.customerField1 = null;
            this.customerField2 = null;
            this.customerField3 = null;
            this.customerField4 = null;
            this.customerField5 = null;
            this.showSimInput = true;

            if (ctrl.activateRtus.length == 1) {
                for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                    if (ctrl.requiredRtus[i].isSelected == true) {
                        this.sim = ctrl.requiredRtus[i].simNumber;
                    };
                }
            } else {
                this.showSimInput = false;
            }

            this.date = today;
            this.defaultAddress = false;

            this.translation = translation;
            //this.tmpConfirmMessageA = item.inUse ? _translation.text.DELETE_SERVICE_USER2 : "";
            this.tmpConfirmMessageB = _translation.text.DEACTIVATE_SIM_CONFIRMATION + '?';
            this.ratePlans = ctrl.currentPlans;
            this.profileNames = ctrl.profileNames;
            this.street1 = "3060 C Business Pk Dr";
            this.street2 = null;
            this.city = "Norcross";
            this.state = "GA";
            this.zip = "30071";

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            this.gatherInformation = function (property) {
                switch (property) {
                    case "date":
                        ctrl.activateSimInformation.date = _this3.date;
                        break;
                    case "sim":
                        ctrl.activateSimInformation.sim = _this3.sim;
                        break;
                    case "ratePlan":
                        ctrl.activateSimInformation.ratePlan = _this3.ratePlan.ratePlan;
                        break;
                    case "profileName":
                        if (_this3.profileName.id == 3) _this3.profileName.name = "36 NATL";
                        ctrl.activateSimInformation.profileName = _this3.profileName.name;
                        break;
                    case "street1":
                        ctrl.activateSimInformation.street1 = _this3.street1;
                        break;
                    case "street2":
                        ctrl.activateSimInformation.street2 = _this3.street2;
                        break;
                    case "city":
                        ctrl.activateSimInformation.city = _this3.city;
                        break;
                    case "state":
                        ctrl.activateSimInformation.state = _this3.state;
                        break;
                    case "zip":
                        ctrl.activateSimInformation.zip = _this3.zip;
                        break;
                    case "customerField1":
                        ctrl.activateSimInformation.customerField1 = _this3.customerField1;
                        break;
                    case "customerField2":
                        ctrl.activateSimInformation.customerField2 = _this3.customerField2;
                        break;
                    case "customerField3":
                        ctrl.activateSimInformation.customerField3 = _this3.customerField3;
                        break;
                    case "customerField4":
                        ctrl.activateSimInformation.customerField4 = _this3.customerField4;
                        break;
                    case "customerField5":
                        ctrl.activateSimInformation.customerField5 = _this3.customerField5;
                        break;
                    case "defaultAddress":
                        ctrl.defaultAddress = _this3.defaultAddress;
                        ctrl.activateSimInformation.sim = _this3.sim;
                        ctrl.activateSimInformation.date = _this3.date;
                        break;
                }
            };
        };

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/carrierrateplan/activate-modal-template.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function () {

            if (ctrl.defaultAddress) {
                ctrl.activateSimInformation.street1 = "3060 C Business Pk Dr";
                ctrl.activateSimInformation.street2 = "";
                ctrl.activateSimInformation.city = "Norcross";
                ctrl.activateSimInformation.state = "GA";
                ctrl.activateSimInformation.zip = "30071";
            }
            //console.log(ctrl.activateSimInformation);
            if (ctrl.activateRtus.length == 1) {
                ctrl._attRatePlan.ActivateSim(ctrl.activateSimInformation, ctrl.accountInfo.customerId, "ATT").then(function (resp) {});
            } else {
                var activateModel = { rtuList: ctrl.activateRtus, information: ctrl.activateSimInformation };
                ctrl._attRatePlan.BulkActivateSim(activateModel).then(function (resp) {});
            }
        }, function () {
            // cancel button
        });
    };

    //Helper to convert large KB values to readable formats
    function byteToString(val) {
        var kb = val;
        kb = +kb.toFixed(0);
        var mb = val / 1000;
        mb = +mb.toFixed(1);
        var gb = val / (1000 * 1000);
        gb = +gb.toFixed(2);

        if (gb >= 1 || gb <= -1) return (gb.toString() + " GB").toString();else if (mb >= 1 || mb <= -1) return (mb.toString() + " MB").toString();else return (kb.toString() + " KB").toString();
    }

    ///
    ///
    /// All of the below methods are left over and I do not use / do not know if they work.
    ///
    ///

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                0: { columnWidth: 70 },
                1: { columnWidth: 100 },
                2: { columnWidth: 100 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshData();
    });

    ctrl.refreshData = function () {
        ctrl.carrierDataUsage = angular.copy(ctrl.carrierDataUsage);
    };
}

AttRatePlanController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'AttRatePlanFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', '$uibModal', 'savePdfService'];
'use strict';

angular.module('mc.att-rate-plan').component('attRatePlan', {
    controller: AttRatePlanController,
    templateUrl: 'ui/carrierrateplan/att/att-rate-plan-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function DownloadMenuController($, $rootScope, $scope, $sce, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, openViewService, $location, $window, analogIntertieDetailsService, interconnectListService) {
    var _this2 = this;

    var ctrl = this;
    this.popupOffset = 0;
    ctrl.initLoad = true;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.$onInit = function () {
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        ctrl.exportItems = angular.isDefined(ctrl.dmViewType) ? ctrl.exportItemsAllOptions.filter(function (i) {
            return ctrl.dmViewType.includes(i.viewType);
        }) : null;
        ctrl.showMenu = false;
    };

    //viewType: 0: advanced; 1: chart; 2: table
    ctrl.exportItemsAllOptions = [{ actionId: "print", name: "Print chart", icon: 'fa-print', viewType: 1 },
    //{ actionId: "print", name: "Print table", icon: 'fa-print', viewType: 2 },
    {
        actionId: "image/png", name: "Download PNG image", icon: 'fa-file-image-o', viewType: 1
    },
    //{ actionId: "image/jpeg", name: "Download JPEG image", icon: 'fa-file-image-o', viewType: 1 },
    {
        actionId: "application/pdf", name: "Download PDF document", icon: 'fa-file-pdf-o', viewType: 1
    }, {
        actionId: "abc", name: "Download PDF document", icon: 'fa-file-pdf-o', viewType: 3
    },
    //{ actionId: "image/svg+xml", name: "Download SVG vector image", icon: 'fa-file-code-o', viewType: 1 },
    //{ actionId: "text/csv", name: "Download CSV", icon: 'fa-file-text-o', viewType: 1 },
    //{ actionId: "application/vnd.ms-excel", name: "Download XLS", icon: 'fa-file-excel-o', viewType: 1 },
    // { actionId: "application/vnd.ms-excel", name: "Download spreadsheet", icon: 'fa-file-excel-o', viewType: 1 },
    { actionId: "print", name: "Print", icon: 'fa-print', viewType: 4 },
    //for supergraph download options
    { actionId: "print", name: "Print chart", icon: 'fa-print', viewType: 5 }, {
        actionId: "image/png", name: "Download PNG image", icon: 'fa-file-image-o', viewType: 5
    }, {
        actionId: "application/pdf", name: "Download PDF document", icon: 'fa-file-pdf-o', viewType: 5
    }];

    if (ctrl.accountInfo.userRole !== "PublicUser") {
        ctrl.exportItemsAllOptions.push({ actionId: "xyz", name: "Advanced Download", icon: 'fa-arrow-down', viewType: 0 });
    }

    ctrl.closeSidebarLegend = function () {
        ctrl.dmChart.legend.update({ enabled: false });

        // Hide the legend toggle button inside .highcharts-legend
        var legendToggleDiv = document.querySelector('.highcharts-legend > div');
        if (legendToggleDiv) {
            legendToggleDiv.style.display = 'none';
        }

        ctrl.dmChart.print();
    };

    ctrl.exportAction = function (actionId, viewType) {

        switch (viewType) {
            case 0:
                ctrl.openDownload();
                break;
            case 1:
                if (!ctrl.dmChart) return false;
                if (actionId === "print") {
                    // Below condition is applicable for when print is used for Analog/Digital Interconnect Chart.
                    // For Analog/Digital Interconnect the title contains 2 devices From and To, hence service is called to fetch data.
                    if (ctrl.windowId == "Analog Interconnect Chart") {
                        analogIntertieDetailsService.getData('customerID=' + ctrl.accountInfo.customerId + '&analogIntertieId=' + (ctrl.stickyProperties.deviceId ? ctrl.stickyProperties.deviceId : ctrl.stickyPropertiesInterface.deviceId)).then(function (resp) {
                            var datafromfactory = resp.data;

                            var getInputName = function getInputName(status) {
                                if (status.sourceChannelName) {
                                    return status.sourceChannelName;
                                }
                                return ctrl.translation.text.CHANNEL + ' ' + status.sourceAnalogChannel;
                            };

                            var getOutputName = function getOutputName(status) {
                                if (status.destinationChannelName) {
                                    return status.destinationChannelName;
                                }
                                return ctrl.translation.text.CHANNEL + ' ' + status.destinationOutputChannel;
                            };
                            ctrl.windowTitle = ctrl.translation.text.ANALOG_INTERCONNECT_OPERATION + ', ' + datafromfactory.sourceDeviceName + ', ' + getInputName(datafromfactory) + ' to ' + datafromfactory.destinationDeviceName + ', ' + getOutputName(datafromfactory);

                            $("title").text(ctrl.windowTitle);
                            $timeout(function () {
                                ctrl.dmChart.print();
                            }, 500);
                        });
                    } else if (ctrl.windowId == "Digital Intertie Chart") {
                        interconnectListService.getDigitalIntertieDetails(ctrl.stickyProperties.deviceId ? ctrl.stickyProperties.deviceId : ctrl.stickyPropertiesInterface.deviceId).then(function (resp) {
                            var datafromfactory = resp.data;

                            var getInputName = function getInputName(digitalStatus) {
                                if (digitalStatus.sourceChannelName) {
                                    return digitalStatus.sourceChannelName;
                                } else if (digitalStatus.sourceChannelDescriptionParmDigital) {
                                    return digitalStatus.sourceChannelDescriptionParmDigital;
                                } else if (digitalStatus.sourceChannelDescriptionChannelConfig) {
                                    return digitalStatus.sourceChannelDescriptionChannelConfig;
                                }
                                return ctrl.translation.text.INPUT + ' ' + digitalStatus.input;
                            };

                            var getOutputName = function getOutputName(digitalStatus) {
                                if (digitalStatus.destinationChannelName) {
                                    return digitalStatus.destinationChannelName;
                                }
                                return ctrl.translation.text.RELAY + ' ' + digitalStatus.output;
                            };
                            //TODO: This can be way too long
                            ctrl.windowTitle = ctrl.translation.text.DIGITAL_INTERCONNECT_CHART + ", " + datafromfactory.sourceName + ', ' + getInputName(datafromfactory) + " -> " + datafromfactory.destinationName + ', ' + getOutputName(datafromfactory);

                            $("title").text(ctrl.windowTitle);
                            $timeout(function () {
                                ctrl.dmChart.print();
                            }, 500);
                        });
                    } else {
                        //adding broadcast so that the title updates on the Print Screen based on the view and device selected
                        $rootScope.$broadcast('addDeviceNameToPrintChart', ctrl);
                        // Commenting the below line that closes legend while printing if it is open
                        // (ctrl.windowId.indexOf("Analog Chart") !== -1) ? ctrl.closeSidebarLegend() : ctrl.dmChart.print();

                        $timeout(function () {
                            ctrl.dmChart.print();
                        }, 500);
                    }
                } else {
                    ctrl.dmChart.exportChart({
                        type: actionId,
                        chartOptions: {
                            title: {
                                text: ctrl.windowId + ", " + ctrl.stickyProperties.device.deviceName
                            }
                        }
                    });
                }
                break;
            case 2:
                alert("table");
                break;
            case 3:
                ctrl.dmViewFunction();
                break;
            case 4:
                $timeout(function () {
                    ctrl.printWidget();
                }, 500);
                break;
            //for supergraph download options
            case 5:
                if (!ctrl.dmChart) return false;
                if (actionId === "print") {
                    $timeout(function () {
                        ctrl.dmChart.print();
                    }, 500);
                } else {
                    ctrl.dmChart.exportChart({
                        type: actionId
                    });
                }
                break;
        }
        ctrl.showMenu = false;
    };

    //THE-51638: the export items are <li role="button">, so they have to answer
    //Enter/Space the way a real button would
    ctrl.exportKeydown = function ($event, item) {
        if ($event.key === 'Enter' || $event.key === ' ' || $event.key === 'Spacebar') {
            $event.preventDefault(); //stop Space scrolling the view behind the popover
            ctrl.exportAction(item.actionId, item.viewType);
        }
    };

    ctrl.openDownload = function () {

        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        var startDate;
        var endDate;
        if (typeof ctrl.options != "undefined") {
            if (typeof ctrl.options.resolution != "undefined") optionsStickyProperties.downloadOptions.resolution = ctrl.options.resolution;
        } else optionsStickyProperties.downloadOptions.resolution = 0;
        if (!angular.isUndefined(ctrl.stickyProperties) && !angular.isUndefined(ctrl.stickyProperties.device) && typeof ctrl.stickyProperties.device.deviceId != "undefined") optionsStickyProperties.downloadOptions.deviceId = ctrl.stickyProperties.deviceId;
        if (!angular.isUndefined(ctrl.stickyProperties) && !angular.isUndefined(ctrl.stickyProperties.device) && typeof ctrl.stickyProperties.device.deviceName != "undefined") optionsStickyProperties.downloadOptions.deviceName = ctrl.stickyProperties.device.deviceName;
        if (ctrl.windowId !== undefined && ctrl.windowId !== null) {
            if (ctrl.windowId.indexOf("Chart") !== -1 && ctrl.windowId.indexOf("Recorder") === -1) {
                //Chart
                if (ctrl.stickyProperties.zoomMin !== undefined && ctrl.stickyProperties.zoomMin !== null) {
                    startDate = moment(ctrl.stickyProperties.zoomMin).utc().toDate().toDateString();
                    if (startDate !== 'Invalid Date') {
                        optionsStickyProperties.downloadOptions.startDate = new Date(startDate);
                    }
                }
                if (ctrl.stickyProperties.zoomMax !== undefined && ctrl.stickyProperties.zoomMax !== null) {
                    endDate = moment(ctrl.stickyProperties.zoomMax).utc().toDate().toDateString();

                    if (endDate !== 'Invalid Date') {
                        optionsStickyProperties.downloadOptions.endDate = new Date(endDate);
                    }
                }
            } else if (ctrl.windowId.indexOf("Calendar") !== -1) {
                if (ctrl.stickyProperties.dateMin !== undefined && ctrl.stickyProperties.dateMin !== null) {
                    startDate = moment(ctrl.stickyProperties.dateMin).utc().toDate().toDateString();
                    var startDatedt = new Date(startDate);
                    var y = startDatedt.getFullYear();
                    var m = startDatedt.getMonth();
                    var firstDay = new Date(y, m, 1);
                    var lastDay = new Date(y, m + 1, 0);
                    optionsStickyProperties.downloadOptions.startDate = new Date(firstDay);
                    optionsStickyProperties.downloadOptions.endDate = new Date(lastDay);
                }
            } else if (ctrl.windowId.indexOf("Analog Chart Recorder") !== -1) {
                if (ctrl.stickyProperties.dateMin !== undefined && ctrl.stickyProperties.dateMin !== null) {
                    startDate = moment(ctrl.stickyProperties.dateMin).add('days', 1).utc().toDate().toDateString();
                    if (startDate !== 'Invalid Date') {
                        optionsStickyProperties.downloadOptions.startDate = new Date(startDate);
                    }
                }
                if (ctrl.stickyProperties.dateMax !== undefined && ctrl.stickyProperties.dateMax !== null) {
                    endDate = moment(ctrl.stickyProperties.dateMax).utc().toDate().toDateString();

                    if (endDate !== 'Invalid Date') {
                        optionsStickyProperties.downloadOptions.endDate = new Date(endDate);
                    }
                }
            } else {
                if (!angular.isUndefined(ctrl.stickyProperties) && ctrl.stickyProperties.dateMin !== undefined && ctrl.stickyProperties.dateMin !== null) {
                    startDate = moment(ctrl.stickyProperties.dateMin).utc().toDate().toDateString();
                    if (startDate !== 'Invalid Date') {
                        optionsStickyProperties.downloadOptions.startDate = new Date(startDate);
                    }
                }
                if (!angular.isUndefined(ctrl.stickyProperties) && ctrl.stickyProperties.dateMax !== undefined && ctrl.stickyProperties.dateMax !== null) {
                    endDate = moment(ctrl.stickyProperties.dateMax).utc().toDate().toDateString();

                    if (endDate !== 'Invalid Date') {
                        optionsStickyProperties.downloadOptions.endDate = new Date(endDate);
                    }
                }
            }
        }

        var windowname = "Analog";
        if (ctrl.windowId !== undefined && ctrl.windowId !== null) {
            //Get first word from string EX: 'Analog Chart' = Analog
            windowname = ctrl.windowId.substr(0, ctrl.windowId.indexOf(' '));
            //Format string so First letter Cap, and all rest lowercase
            windowname = windowname.charAt(0).toUpperCase() + windowname.slice(1).toLowerCase();
        }
        //Set downloadOptions.reportType so downloadController knows which to choose by default / select from ctrl.reportList by value in downloadController
        if (typeof ctrl.options != "undefined" && typeof ctrl.options.reportType != "undefined") {
            optionsStickyProperties.downloadOptions.reportType = ctrl.options.reportType;
        } else {
            optionsStickyProperties.downloadOptions.reportType = windowname;
        }

        if (_this2.classicView || _this2.mobile) {
            $location.path('/download/download-partial');
        } else {
            var popup = _this.getExistingDialog(_this2.windowId).ref;
            var popupPosition = popup.dialog('option', 'position');
            var newPopupPosition = {
                at: popupPosition.at,
                my: popupPosition.my,
                collision: popupPosition.collision,
                of: popupPosition.of,
                using: popupPosition.using
            };

            newPopupPosition.at = "left+" + (popup.offset().left + _this2.popupOffset) + " top+" + (popup.offset().top + _this2.popupOffset);
            _this2.popupOffset += 10;

            openViewService.openView('Download', { width: 400, height: 200 }, newPopupPosition, optionsStickyProperties, { minimumWidth: 200, minimumHeight: 100 });
        }
    };

    ctrl.printWidget = function () {
        var $target = $('#' + "dataPane");
        if ($target.length == 0) $target = $('div[class*="' + ctrl.windowId + '"]');
        var mywindow = $window.open('', 'MyWindow', 'width=750,height=650,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes');

        $timeout(function () {
            var elementToPrint;
            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
                elementToPrint = ctrl.popup.parent();
            } else {
                elementToPrint = $("div").parent(".content-classic");
            }

            html2canvas2(elementToPrint, { timeout: 333 }).then(function (canvas) {
                var img = canvas.toDataURL("image\png");
                var strHtml = "<!DOCTYPE HTML>\n<html>\n<head>\n<script>function onLoadFn(){var myImg = document.getElementById('imgid'); myImg.src='" + img + "';}<\/script></head>\n<body onload='onLoadFn();'>\n<div>\n<img src='' id='imgid' alt='No Image Found'>\n</div>\n<script>setTimeout(function(){window.print();window.close();}, 500);<\/script></body>\n</html>";
                mywindow.document.open();
                mywindow.document.write(strHtml);
                mywindow.document.close();
                mywindow.focus();
            });
        }, null);
    };

    ctrl.dynamicPopover = {
        templateUrl: 'downloadSelectionTemplate.html'
    };
}

DownloadMenuController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'HOST', '$http', 'translationService', 'sharedSetupService', 'datetimeService', 'deviceService', '$timeout', '$filter', '$element', 'openViewService', '$location', '$window', 'analogIntertieDetailsService', 'interconnectListService'];
'use strict';

angular.module('mc.download-menu').component('downloadMenu', {
    controller: DownloadMenuController,
    templateUrl: 'ui/components/downloadmenu/download-menu-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        dmChart: '<',
        dmViewType: '<',
        dmViewFunction: '&',
        metarStationId: '<',
        options: '<'
    }
});
"use strict";

angular.module("mc.datetime-picker-range", []);
"use strict";

function DatetimePickerRangeController(translationService, $rootScope, $scope, $timeout, $element) {

    var ctrl = this;
    var previousValueToWatch;

    ctrl.$onInit = function () {
        ctrl.translation = translationService.translation;
        ctrl.dynamicDatePopover = { templateUrl: 'datetimePickerRangePopoverTemplate.html' };
        ctrl.mobile = $rootScope.mobile;
        ctrl.classicView = $rootScope.classicView;
        ctrl.datePopoverVisible = false;
        ctrl.ctrlActive = $scope.$ctrl ? true : false;
        ctrl.disableTime = ctrl.disableTime == "true" ? true : false;
        ctrl.boxHide = ctrl.boxHide == "true" ? true : false;
    };

    ctrl.hideDatePopover = function () {
        ctrl.datePopoverVisible = false;
    };

    //Adding validation to automatically update To date if From Date is greater than To Date
    $scope.validateEndDate = function (startDate) {
        if (startDate && $scope.$ctrl) {
            $scope.$ctrl.myDateRangeStart = startDate;
            $scope.$ctrl.myDateRangeEnd = $scope.$ctrl.myDateRangeEnd < $scope.$ctrl.myDateRangeStart ? $scope.$ctrl.myDateRangeStart : $scope.$ctrl.myDateRangeEnd;
        } else if (startDate) {
            $scope.myDateRangeStart = startDate;
            $scope.myDateRangeEnd = $scope.myDateRangeEnd < $scope.myDateRangeStart ? $scope.myDateRangeStart : $scope.myDateRangeEnd;
        }
    };

    //Adding validation to automatically update From date if To Date is smaller than From Date
    $scope.validateStartDate = function (endDate) {
        if (endDate && $scope.$ctrl) {
            $scope.$ctrl.myDateRangeEnd = endDate;
            $scope.$ctrl.myDateRangeStart = $scope.$ctrl.myDateRangeEnd < $scope.$ctrl.myDateRangeStart ? $scope.$ctrl.myDateRangeEnd : $scope.$ctrl.myDateRangeStart;
        } else if (endDate) {
            $scope.myDateRangeEnd = endDate;
            $scope.myDateRangeStart = $scope.myDateRangeEnd < $scope.myDateRangeStart ? $scope.myDateRangeEnd : $scope.myDateRangeStart;
        }
    };

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translation = args;
    });

    $scope.$on('uibDatePopoverHide', function () {
        ctrl.datePopoverVisible = false;
        //trigger that opened the popover.
        var btn = $element[0].querySelector('button.quickdate-button');
        if (btn) btn.focus();
    });
};

DatetimePickerRangeController.$inject = ['translationService', '$rootScope', '$scope', '$timeout', '$element'];
'use strict';

angular.module('mc.datetime-picker-range').component('datetimePickerRange', {
    controller: DatetimePickerRangeController,
    templateUrl: 'ui/components/datetimepickerrange/datetime-picker-range-template.html',
    bindings: {
        myDateRangeStart: '=',
        myDateRangeEnd: '=',
        goSelectReportData: '&',
        disableTime: '@',
        boxHide: '@'
    }
});
"use strict";

angular.module("mc.enable-checkbox", []);
'use strict';

function EnableCheckboxController($, $rootScope, $scope, $sce, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, openViewService, $location, $window) {
    var ctrl = this;
    ctrl.initLoad = true;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.$onInit = function () {
        //console.log(ctrl.isInsideWidget);
    };

    ctrl.enableCheckboxes = function () {
        ctrl.enableCheckboxFunction();
    };
}

EnableCheckboxController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'HOST', '$http', 'translationService', 'sharedSetupService', 'datetimeService', 'deviceService', '$timeout', '$filter', '$element', 'openViewService', '$location', '$window'];
'use strict';

angular.module('mc.enable-checkbox').component('enableCheckbox', {
    controller: EnableCheckboxController,
    templateUrl: 'ui/components/enablecheckbox/enable-checkbox-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        enableCheckboxFunction: '&'
    }
});
"use strict";

angular.module("mc.date-range-picker", []);
"use strict";

function DatePickerRangeController(translationService, $rootScope, $scope, $timeout, $element) {

    var ctrl = this;
    var previousValueToWatch;

    ctrl.$onInit = function () {
        ctrl.translation = translationService.translation;
        ctrl.dynamicDatePopover = { templateUrl: 'dateRangePopoverTemplate.html' };
        ctrl.mobile = $rootScope.mobile;
        ctrl.classicView = $rootScope.classicView;
        ctrl.datePopoverVisible = false;
        ctrl.ctrlActive = $scope.$ctrl ? true : false;
        ctrl.disableTime = ctrl.disableTime == "true" ? true : false;
        ctrl.boxHide = ctrl.boxHide == "true" ? true : false;
    };

    ctrl.hideDatePopover = function () {
        ctrl.datePopoverVisible = false;
    };

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translation = args;
    });

    $scope.$on('uibDatePopoverHide', function () {
        ctrl.datePopoverVisible = false;
        //trigger that opened the popover.
        var btn = $element[0].querySelector('button.quickdate-button');
        if (btn) btn.focus();
    });
};

DatePickerRangeController.$inject = ['translationService', '$rootScope', '$scope', '$timeout', '$element'];
'use strict';

angular.module('mc.date-range-picker').component('datePickerRange', {
    controller: DatePickerRangeController,
    templateUrl: 'ui/components/daterangepicker/date-picker-range-template.html',
    bindings: {
        myDateRangeStart: '=',
        myDateRangeEnd: '=',
        goSelectReportData: '&',
        disableTime: '@',
        boxHide: '@'
    }
});
"use strict";

angular.module("mc.alert-messages", []);
"use strict";

function AlertMessagesController() {

    var ctrl = this;
    var previousAlerts;

    ctrl.$onInit = function () {
        //optional logic
    };

    //$onChanges will not fire just because a bindable object changes.
    //If you need to know every time the object changes, you will have
    //to pass in a new /copied version of the object, or use $doCheck.

    //ctrl.$onChanges = (changes) => {
    //    //optional logic
    //    if (changes.alerts && changes.alerts.currentValue !== changes.alerts.previousValue) {
    //        if (ctrl.alerts.length > 0) {
    //            ctrl.hasAlerts();
    //        }
    //        else {
    //            ctrl.noAlerts();
    //        }
    //    }
    //}

    ctrl.$doCheck = function () {
        if (!angular.equals(ctrl.alerts, previousAlerts)) {
            ctrl.handleAlertsChange();
            previousAlerts = angular.copy(ctrl.alerts);
        }
    };

    ctrl.closeAlert = function (index) {
        ctrl.alerts.splice(index, 1);
    };

    ctrl.handleAlertsChange = function () {
        if (ctrl.alerts.length) {
            ctrl.hasAlerts();
        } else {
            ctrl.noAlerts();
        }
    };

    ctrl.hasAlerts = function () {
        //console.log("hasAlerts: ", ctrl.alerts);
    };

    ctrl.noAlerts = function () {
        //console.log("noAlerts: ", ctrl.alerts);
    };
};

AlertMessagesController.$inject = [];
'use strict';

angular.module('mc.alert-messages').component('alertMessages', {
    controller: AlertMessagesController,
    templateUrl: 'ui/components/alertmessages/alert-messages-template.html',
    bindings: {
        alerts: '<',
        needClose: '@'
    }
});
"use strict";

angular.module("mc.sim-data-usage", []);
'use strict';

function SimDataUsageFactory(HOST, $http) {
    var _simdatausage = function _simdatausage() {};

    _simdatausage.prototype.GetList = function GetList(deviceId, startDate, endDate) {
        var self = this;
        return $http({
            method: 'GET',
            url: HOST + '/api/DeviceDataUsageSummary',
            params: { deviceId: deviceId, startDate: startDate, endDate: endDate }
        });
    };

    _simdatausage.prototype.GetRatePlanKB = function GetList(ratePlan) {
        {

            return $http({
                method: 'GET',
                url: HOST + '/api/CarrierRatePlan',
                params: { ratePlan: ratePlan }
            });
        }
    };

    return _simdatausage;
}

SimDataUsageFactory.$inject = ['HOST', '$http'];

angular.module('mc.sim-data-usage').factory('SimDataUsageFactory', SimDataUsageFactory);
"use strict";

/// <reference path="../att/att-data-usage-controller-es6.js" />
function SimDataUsageController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, SimDataUsageFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, $q, savePdfService) {
    var _this = this;

    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    ctrl.ratePlanSummary = [];
    var element = $element.find(".chart");
    var chart = void 0;

    ctrl.$onInit = function () {
        ctrl.reverse = true;
        _this.selectedDeviceSN = null;
        //ctrl.deviceId = ctrl.stickyProperties.deviceId;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for

        $scope.adjustSize = function () {
            var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            $scope.popup.parent().css("height", _tmpHeight);
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
        };

        $scope.$watch(function () {
            return $scope.deviceSelected;
        }, function (newVal, oldVal) {
            if (newVal) {
                ctrl.deviceId = newVal;
                ctrl.deviceName = $scope.deviceSelectedName;
                ctrl.setReportDate(0);
            }
        }, true);
    };

    ctrl.goSelectReportData = function (varClick) {
        var deferred = $q.defer();
        ctrl.viewLoading = true;
        var tabPromise = $q.defer();
        var _tmpStartMonth, _tmpStartYear;
        ctrl.daysInMonth = new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0).getDate();
        ctrl.numberDaysOfMonth = Array.apply(null, { length: ctrl.daysInMonth + 1 }).map(Number.call, Number);
        ctrl.numberDaysOfMonth.shift(); //numberDayOfMonth = {1, 2, 3, 4, 5, 6, 7,..... daysInMonth}. Used for the X-axis.


        if (varClick) {
            _tmpStartMonth = ctrl.reportDate.getMonth();
            _tmpStartYear = ctrl.reportDate.getFullYear();
        } else if (ctrl.stickyProperties.on === true) {
            ctrl.stickyProperties.on = false;
            _tmpStartMonth = new Date(ctrl.stickyProperties.dateMin).getMonth();
            _tmpStartYear = new Date(ctrl.stickyProperties.dateMin).getFullYear();
            ctrl.reportDate = new Date(_tmpStartYear, _tmpStartMonth, 1);
            ctrl.adjustButtons();
        } else {
            _tmpStartMonth = new Date().getMonth();
            _tmpStartYear = new Date().getFullYear();
            ctrl.reportDate = new Date(_tmpStartYear, _tmpStartMonth, 1);
            ctrl.adjustButtons();
        }
        ctrl.startDate = datetimeService.dateToUnixtime(new Date(_tmpStartYear, _tmpStartMonth, 1));
        ctrl.endDate = datetimeService.dateToUnixtime(new Date(_tmpStartYear, _tmpStartMonth + 1, 0)); //0th day of next month is last day of current month
        //---------*Get Data and Spilt it into correspodning Variables for Use*---------

        var _simdatausage = new SimDataUsageFactory();
        _simdatausage.GetList(ctrl.deviceId, ctrl.startDate, ctrl.endDate).then(function (resp) {
            tabPromise.resolve();
            $timeout(function () {
                ctrl.viewLoading = false;
            });
            if (resp.data == null || resp.data.length == 0) {
                ctrl.planDaysOfData = 0;
                deferred.resolve();
            } else {
                ctrl.planName = resp.data != null ? resp.data[0].ratePlan : null;
                ctrl.usageData = new Array(ctrl.daysInMonth).fill(0);
                ctrl.planDaysOfData = resp.data.length;

                for (var i = 0; i < resp.data.length; i++) {
                    var index = new Date(resp.data[i].reportDate).getDate() - 1;
                    ctrl.usageData[index] = resp.data[i].totalUsage;
                }
                _simdatausage.GetRatePlanKB(ctrl.planName).then(function (resp) {
                    ctrl.planRate = resp.data.includedKB;
                    deferred.resolve();
                }, function (resp) {
                    deferred.reject();
                    console.log(resp);
                });
            }
        }, function (resp) {
            deferred.reject();
            console.log(resp);
        });
        return deferred.promise;
    };

    ctrl.setReportDate = function (months) {

        if (months === 0) ctrl.reportDate = new Date();
        var d = new Date(ctrl.reportDate || new Date());
        d.setMonth(d.getMonth() + (months || 0), d.getDate());
        ctrl.reportDate = d;
        ctrl.adjustButtons();
        var promise = ctrl.goSelectReportData(true);
        promise.then(function (data) {
            $timeout(function () {
                if (ctrl.planDaysOfData > 0) {
                    var message = "There is " + ctrl.planDaysOfData + " days of data for " + ctrl.deviceName + " on " + ctrl.reportDate.toLocaleString("en-us", { month: "long" });
                    ctrl.headerInfoColor = "lightgreen";
                    ctrl.headerInfoPanel = message;
                    _drawRatePlanChart();
                } else {
                    var message = "There is <u>NO</u> data for " + ctrl.deviceName + " on " + ctrl.reportDate.toLocaleString("en-us", { month: "long" });
                    ctrl.headerInfoColor = "lightcoral";
                    ctrl.headerInfoPanel = message;
                    if (chart) {
                        chart.destroy();
                        chart = null;
                    }
                }
            }, 0);
            ctrl.viewLoading = false;
        }, function (reason) {
            console.log(reason);
        });
    };

    ctrl.adjustButtons = function () {
        if (new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0).getTime() === new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime()) {
            ctrl.todaysDate = true;
            ctrl.nextDate = true;
        } else {
            ctrl.todaysDate = false;
            ctrl.nextDate = false;
        }
    };

    var _drawRatePlanChart = function _drawRatePlanChart() {
        //Sum Columns
        var boughtKBADay = ctrl.planRate / ctrl.daysInMonth;
        var boughtUsageArrSum = new Array(ctrl.numberDaysOfMonth.length).fill(0);
        var consumedUsageArrSum = new Array(ctrl.numberDaysOfMonth.length).fill(0);

        for (var i = 0; i < ctrl.numberDaysOfMonth.length; i++) {
            if (i === 0) consumedUsageArrSum[i] = ctrl.usageData[i];else consumedUsageArrSum[i] = ctrl.usageData[i] + consumedUsageArrSum[i - 1]; //sum

            boughtUsageArrSum[i] = boughtKBADay * (i + 1);
        }

        var avrgUsageConsumed = Math.round(ctrl.usageData.reduce(function (a, b) {
            return a + b;
        }, 0) / ctrl.daysInMonth);

        chart = Highcharts.chart({
            chart: {
                renderTo: element[0],
                type: 'column'
            },
            credits: {
                enabled: false
            },
            rangeSelector: {
                enabled: false
            },
            navigator: {
                enabled: false
            },
            scrollbar: {
                enabled: false
            },
            title: {
                text: ctrl.deviceName + " - " + ctrl.planName + " - " + ctrl.planRate + "KB"
            },
            plotOptions: {
                column: {
                    groupPadding: 0.5, // Exactly overlap
                    pointWidth: 19
                }
            },
            xAxis: {
                title: {
                    text: "Days of " + ctrl.reportDate.toLocaleString("en-us", { month: "long" })
                },
                categories: ctrl.numberDaysOfMonth,
                dateTimeLabelFormats: {
                    day: null,
                    week: null
                },
                minRange: null,
                type: 'category',
                labels: {
                    rotation: -45,
                    style: {
                        fontSize: '10px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Data Usage (KB)'
                }
            },
            tooltip: {
                headerFormat: '<div style="font-size:14px; width: 200px;"><b>Day {point.key}</b></div><table>',
                pointFormatter: function pointFormatter() {
                    var s = '<tr><td style="font-size:13px; color: ' + this.series.color + ';">' + this.series.name + ' ' + byteToString(this.y) + '</td></tr>';
                    return s;
                },
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                backgroundColor: 'white'
            },
            series: [{
                name: 'Bought (Running)', //line
                type: 'spline',
                lineWidth: 4,
                color: 'blue',
                dashstyle: 'shortDashDot',
                connectNulls: true,
                pointStart: 0,
                pointInterval: ctrl.numberDaysOfMonth.length - 1,
                data: [boughtUsageArrSum[0], boughtUsageArrSum[boughtUsageArrSum.length - 1]],
                marker: {
                    enabled: false
                },
                zIndex: 2,
                enableMouseTracking: false,
                showInLegend: true
            }, {
                name: 'Consumed (Running)', //line
                type: 'spline',
                lineWidth: 4,
                color: '#ff4500',
                dashstyle: 'shortDashDot',
                connectNulls: true,
                data: consumedUsageArrSum,
                marker: {
                    enabled: false
                },
                zIndex: 3,
                enableMouseTracking: false,
                showInLegend: true
            }, {
                name: 'Consumed (Daily)',
                data: ctrl.usageData,
                color: 'rgb(255,165,0,1)',
                zIndex: 2

            }, {
                name: 'Consumed (Running)',
                data: consumedUsageArrSum,
                color: 'rgb(220,20,60,1)',
                marker: {
                    enabled: false
                },
                zIndex: consumedUsageArrSum[consumedUsageArrSum.length - 1] < boughtUsageArrSum[boughtUsageArrSum.length - 1] ? 1 : 0,
                showInLegend: false
            }, {
                name: 'Bought (Running)',
                data: boughtUsageArrSum,
                color: 'rgb(0,0,220,0.8)',
                zIndex: consumedUsageArrSum[consumedUsageArrSum.length - 1] < boughtUsageArrSum[boughtUsageArrSum.length - 1] ? 0 : 1,
                showInLegend: false
            }]
        });
    };

    //Helper to convert large KB values to readable formats
    function byteToString(val) {
        var kb = val;
        kb = +kb.toFixed(0);
        var mb = val / 1000;
        mb = +mb.toFixed(1);
        var gb = val / (1000 * 1000);
        gb = +gb.toFixed(2);

        if (gb >= 1 || mb <= -1) return (gb.toString() + " GB").toString();else if (mb >= 1 || mb <= -1) return (mb.toString() + " MB").toString();else return (kb.toString() + " KB").toString();
    }

    ///
    ///
    /// All of the below methods are left over and I do not use / do not know if they work.
    ///
    ///

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                0: { columnWidth: 70 },
                1: { columnWidth: 100 },
                2: { columnWidth: 100 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshData();
    });

    ctrl.refreshData = function () {
        ctrl.carrierDataUsage = angular.copy(ctrl.carrierDataUsage);
    };
}

SimDataUsageController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'SimDataUsageFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', 'savePdfService'];
'use strict';

angular.module('mc.sim-data-usage').component('simDataUsage', {
    controller: SimDataUsageController,
    templateUrl: 'ui/carrierdatausage/simdatausage/sim-data-usage-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        myDate: '<'
    }
});
"use strict";

angular.module("mc.analog-widget", []);
'use strict';

function McAnalogWidgetController($, $rootScope, $scope, $timeout, authenticationService, sharedSetupService, McAnalogGaugeFactory, McWidgetsSharedFactory, toaster, translationService) {
    var ctrl = this;
    ctrl.closeIcon = false;

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 1);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.$onInit = function () {
        ctrl.showWidget = true;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.device.deviceId, windowId: $scope.windowId });
        ctrl.translation = translationService.translation;
        ctrl.getData();
    };

    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.analogGauge.device.name, 'View reloading');
        ctrl.getData();
    };

    ctrl.getData = function () {
        var _analogGauge = new McAnalogGaugeFactory(ctrl.accountInfo.customerId, $scope.stickyProperties.device.deviceId, ctrl.accountInfo.timeZone, 1, ctrl.mcWidgetsSharedFactory.getWidgetIdByAnalogType(ctrl.analogType), $scope.stickyProperties.device.channel); //Category: Analog, Widget: 'Single Needle Gauge'
        _analogGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            var device = _analogGauge.list.device;
            var deviceUnitState = _analogGauge.list.deviceUnitState;
            var defaultSetting = _analogGauge.list.defaultSetting;

            // if _analogGauge.list.analogGauge is not available, set default values to empty object
            var analogGauge = _analogGauge.list.analogGauge.length == 0 ? {} : _analogGauge.list.analogGauge[0].analogGauge;
            var analogWidgetSetting = _analogGauge.list.analogGauge.length == 0 ? {} : _analogGauge.list.analogGauge[0].analogWidgetSetting;
            var levelReferences = _analogGauge.list.analogGauge.length == 0 ? {} : _analogGauge.list.analogGauge[0].levelReferences;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: true,
                displaySettingOn: true,
                defaultSetting: false
            };
            ctrl.analogGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                defaultSetting: defaultSetting,
                analogGauge: analogGauge,
                analogWidgetSetting: analogWidgetSetting,
                setting: setting,
                levelReferences: levelReferences
            };

            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.additionalSetting();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.fnChangeWidgetTitle = function (titleOption) {
        var _device = { channel: titleOption.channel, deviceId: titleOption.deviceId, deviceName: titleOption.name, serialNumber: titleOption.serialNumber };
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: titleOption.deviceId, device: _device, windowId: $scope.windowId });
        ctrl.setTitle(titleOption.name, titleOption.channelDescription);
    };

    ctrl.setTitle = function (deviceName, channelDescription) {
        ctrl.deviceName = deviceName;
        ctrl.popup.dialog("option", "title", ctrl.deviceName + ", " + channelDescription);
    };

    ctrl.additionalSetting = function () {

        ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.popup.dialog({ resizable: false });

        ctrl.setTitle(ctrl.analogGauge.device.name, Object.keys(ctrl.analogGauge.analogGauge).length !== 0 ? ctrl.analogGauge.analogGauge.name : ctrl.translation.text.NOT_SETUP);

        ctrl.popup.parent().find("div.ui-widget-content ").css('overflow', 'visible');

        ctrl.closeWidget = function () {
            ctrl.popup.dialog("close");
        };

        ctrl.setSize(ctrl.analogGauge.analogWidgetSetting.sizeId);

        ctrl.popup.dialog('widget').css("width", ctrl.svgSizeH + "px");
        ctrl.popup.dialog("option", "width", ctrl.svgSizeH);

        ctrl.popup.dialog('widget').css("height", ctrl.svgSizeH + 25 + "px");
        ctrl.popup.dialog("option", "height", ctrl.svgSizeH + 25);

        ctrl.popup.parent().addClass("ui-widget-content-mc");

        ctrl.popup.parent().on("mouseover", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().addClass("x-resize");
                ctrl.closeIcon = true;
            });
        });

        ctrl.popup.parent().on("mouseout", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().removeClass("x-resize");
                if (ctrl.isTouchSupported()) {
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 3000);
                } else {
                    ctrl.closeIcon = true;
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 500);
                }
            });
        });

        ctrl.isTouchSupported = function () {
            var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
            var generalTouchEnabled = "ontouchstart" in document.createElement("div");

            if (msTouchEnabled || generalTouchEnabled) {
                return true;
            }
            return false;
        };

        ctrl.recreateWidget = function () {
            ctrl.showWidget = false;

            $timeout(function () {
                ctrl.showWidget = true;
                ctrl.getData();
            });
        };

        var handleWidgetUpdate = function handleWidgetUpdate(event, args) {
            if (args.deviceId == $scope.stickyProperties.device.deviceId && args.channel == $scope.stickyProperties.device.channel) {
                //Display Range saved from this widget's own settings: mcwidget-display redraws in place, settings stay open
                if (args.settingDialog && args.settingDialog === ctrl.popup.closest('.ui-dialog')[0]) return;
                ctrl.recreateWidget();
            }
        };

        var handleWidgetUpdateDeviceName = function handleWidgetUpdateDeviceName(event, args) {
            if (args && args.deviceId == ctrl.analogGauge.device.deviceId) {
                ctrl.analogGauge.device.name = args.name;

                ctrl.setTitle(args.name, Object.keys(ctrl.analogGauge.analogGauge).length !== 0 ? ctrl.analogGauge.analogGauge.name : ctrl.translation.text.NOT_SETUP);
            }
        };

        $scope.$on('rtuAnalogUpdate', handleWidgetUpdate);
        $scope.$on('updateGuageMinMaxforGauges', handleWidgetUpdate);
        $scope.$on('rtuBasicInfoUpdate', handleWidgetUpdateDeviceName);

        $scope.$on("$destroy", function (event) {
            ctrl.popup.parent().off("mouseover");
            ctrl.popup.parent().off("mouseout");
        });
    };
}

McAnalogWidgetController.$inject = ["$", "$rootScope", "$scope", "$timeout", "authenticationService", "sharedSetupService", "McAnalogGaugeFactory", "McWidgetsSharedFactory", "toaster", "translationService"];
'use strict';

angular.module('mc.analog-widget').component('mcAnalogWidget', {
    controller: McAnalogWidgetController,
    templateUrl: 'ui/analog/mcanalogwidget/mc-analog-widget-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        analogType: '<'
    }
});
'use strict';

function McAnalogGaugeFactory(HOST, $http) {

    // instantiate our initial object
    var McAnalogGauge = function McAnalogGauge(customerId, deviceId, timeZone, categoryId, widgetId, channel, isFromWidget) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.channel = channel;
        this.isFromWidget = isFromWidget;
    };

    McAnalogGauge.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&channel=' + this.channel + '&isFromWidget=' + this.isFromWidget).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McAnalogGauge.prototype.getWidgetData = function (channelId) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channelId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McAnalogGauge;
}

McAnalogGaugeFactory.$inject = ['HOST', '$http'];

angular.module('mc.analog-gauge').factory('McAnalogGaugeFactory', McAnalogGaugeFactory);
'use strict';

function McAnalogGaugeController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, openViewService, $timeout, McAnalogGaugeFactory, $filter, $element, McWidgetsSharedFactory, toaster, tabButtonGaugeService) {
    var ctrl = this;

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        sharedSetupService.getWindowId($scope);

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();

        $scope.mostRecentData = function () {
            $scope.alerts = [];
            toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
            var _analogGauges = new McAnalogGaugeFactory(ctrl.accountInfo.customerId, $scope.currentDeviceId, ctrl.accountInfo.timeZone, 1, ctrl.mcWidgetsSharedFactory.getWidgetIdByAnalogType(ctrl.analogType)); //Category: Analog, Widget: 'Single Needle Gauge'

            _analogGauges.getGaugeData().then(function () {
                ctrl.loadingInProgress = false;
                //ctrl.analogGauges = _analogGauges.list;
                var tmpAnalogGauges = [],
                    device,
                    deviceUnitState,
                    analogGauge,
                    analogWidgetSetting,
                    setting,
                    defaultSetting;

                for (var i = 0; i <= _analogGauges.list.analogGauge.length - 1; i++) {
                    device = _analogGauges.list.device;
                    deviceUnitState = _analogGauges.list.deviceUnitState;
                    defaultSetting = _analogGauges.list.defaultSetting;
                    analogGauge = _analogGauges.list.analogGauge[i].analogGauge;
                    analogWidgetSetting = _analogGauges.list.analogGauge[i].analogWidgetSetting;
                    var levelReferences = _analogGauges.list.analogGauge[i].levelReferences;

                    setting = {
                        customerId: ctrl.accountInfo.customerId,
                        //deviceId: ctrl.analogGauges[i].deviceId,
                        //deviceName: ctrl.analogGauges[i].deviceName,
                        //channel: ctrl.analogGauges[i].channel,
                        //channelName: ctrl.analogGauges[i].channelName,
                        displaySetting: false,
                        displaySettingOn: false,
                        defaultSetting: true
                    };
                    tmpAnalogGauges.push({
                        device: device,
                        deviceUnitState: deviceUnitState,
                        defaultSetting: defaultSetting,
                        analogGauge: analogGauge,
                        analogWidgetSetting: analogWidgetSetting,
                        setting: setting,
                        analogType: ctrl.mcWidgetsSharedFactory.getAnalogTypeByWidgetId(analogGauge.widgetId),
                        levelReferences: levelReferences
                    });
                }

                ctrl.analogGauges = angular.copy(tmpAnalogGauges);
                if (device.deviceModel == 20 && device.skuId <= 1) $scope.alerts.push({ msg: ctrl.translation.text.DEVICE_UNSUPPORTED, type: "info" });
                if (_analogGauges.list.analogGauge.length === 0) $scope.alerts.push({ msg: ctrl.translation.message.ANALOG_SETUP_INCOMPLETE, type: "info" });
            }, function (error) {
                console.log(error);
                ctrl.loadingInProgress = false;
            });
        };

        $scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                $scope.alerts = [];
                $scope.currentDeviceId = newValue;
                var _analogGauges = new McAnalogGaugeFactory(ctrl.accountInfo.customerId, newValue, ctrl.accountInfo.timeZone, 1, ctrl.mcWidgetsSharedFactory.getWidgetIdByAnalogType(ctrl.analogType)); //Category: Analog, Widget: 'Single Needle Gauge'

                _analogGauges.getGaugeData().then(function () {
                    ctrl.loadingInProgress = false;
                    //ctrl.analogGauges = _analogGauges.list;
                    var tmpAnalogGauges = [],
                        device,
                        deviceUnitState,
                        analogGauge,
                        analogWidgetSetting,
                        setting,
                        defaultSetting;
                    device = _analogGauges.list.device;
                    deviceUnitState = _analogGauges.list.deviceUnitState;
                    defaultSetting = _analogGauges.list.defaultSetting;
                    for (var i = 0; i <= _analogGauges.list.analogGauge.length - 1; i++) {
                        analogGauge = _analogGauges.list.analogGauge[i].analogGauge;
                        analogWidgetSetting = _analogGauges.list.analogGauge[i].analogWidgetSetting;
                        var levelReferences = _analogGauges.list.analogGauge[i].levelReferences;

                        setting = {
                            customerId: ctrl.accountInfo.customerId,
                            //deviceId: ctrl.analogGauges[i].deviceId,
                            //deviceName: ctrl.analogGauges[i].deviceName,
                            //channel: ctrl.analogGauges[i].channel,
                            //channelName: ctrl.analogGauges[i].channelName,
                            displaySetting: false,
                            displaySettingOn: false,
                            defaultSetting: true
                        };
                        tmpAnalogGauges.push({
                            device: device,
                            deviceUnitState: deviceUnitState,
                            defaultSetting: defaultSetting,
                            analogGauge: analogGauge,
                            analogWidgetSetting: analogWidgetSetting,
                            setting: setting,
                            analogType: ctrl.mcWidgetsSharedFactory.getAnalogTypeByWidgetId(analogWidgetSetting.widgetId),
                            levelReferences: levelReferences
                        });
                    }

                    ctrl.analogGauges = angular.copy(tmpAnalogGauges);
                    if (device.deviceModel == 20 && device.skuId <= 1) {
                        $scope.alerts.push({ msg: ctrl.translation.text.DEVICE_UNSUPPORTED, type: "info" });
                    } else if (_analogGauges.list.analogGauge.length === 0) {
                        $scope.alerts.push({ msg: ctrl.translation.message.ANALOG_SETUP_INCOMPLETE, type: "info" });
                    }
                }, function (error) {
                    console.log(error);
                    ctrl.loadingInProgress = false;
                });
            }
        }, true);

        $element.on("mouseover.mcAnalogGauge", ".upWidget", function (event) {
            if ($(event.currentTarget).is(".upWidget") && event.target.tagName !== "DIV" && !$scope.mobile && !$scope.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    zIndex: 9999,
                    disabled: false,
                    stop: function stop(event, ui) {
                        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(ui.helper.attr("mc-size"), 1);
                        var mcDevice = { deviceId: $scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: $scope.deviceSelectedSn, deviceName: $scope.deviceSelectedName };
                        var optionsStickyProperties = {
                            deviceId: $scope.deviceSelected,
                            device: mcDevice
                        };
                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        var viewName = 'Mc ' + ui.helper.attr("mc-analog-type") + ' Analog Widget';
                        openViewService.openWidget(viewName, { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                        $scope.$apply();
                    }
                });
            } else {
                $(event.currentTarget).draggable({ disabled: true });
            }
        });

        $scope.$on('rtuAnalogUpdate', function (event, args) {
            var _dataChanged = "name, unit, minimumValue, maximumValue, gaugeMinValue, gaugeMaxValue";
            if (args.deviceId == ctrl.analogGauges[args.channel - 1].device.deviceId && args.channel == ctrl.analogGauges[args.channel - 1].analogWidgetSetting.channel && _dataChanged.indexOf(args.fieldName) > -1) {
                ctrl.analogGauges[args.channel - 1].analogWidgetSetting.gaugeMinValue = args.newSetting[args.channel - 1].analogGaugeSetting.gaugeMinValue;
                ctrl.analogGauges[args.channel - 1].analogWidgetSetting.gaugeMaxValue = args.newSetting[args.channel - 1].analogGaugeSetting.gaugeMaxValue;
            }
        });

        //When gaugeMin and gaugeMax is updated under Gauge-->Options Tab
        $scope.$on('updateGuageMinMaxforGauges', function (event, args) {
            if (args.deviceId == ctrl.analogGauges[args.channel - 1].device.deviceId && args.channel == ctrl.analogGauges[args.channel - 1].analogWidgetSetting.channel) {
                ctrl.analogGauges[args.channel - 1].analogWidgetSetting.gaugeMinValue = args.gaugeMinValue;
                ctrl.analogGauges[args.channel - 1].analogWidgetSetting.gaugeMaxValue = args.gaugeMaxValue;
            }
        });

        //Keyboard alternative to dragging a gauge out: Tab to a gauge, Space/Enter opens it as a widget next to it
        tabButtonGaugeService.registerList($scope, $element, ".upWidget", function ($gauge) {
            var rect = $gauge[0].getBoundingClientRect();
            var tmpSize = ctrl.mcWidgetsSharedFactory.getSize($gauge.attr("mc-size"), 1);
            var mcDevice = { deviceId: $scope.deviceSelected, channel: $gauge.attr("mc-channel"), serialNumber: $scope.deviceSelectedSn, deviceName: $scope.deviceSelectedName };
            var optionsStickyProperties = {
                deviceId: $scope.deviceSelected,
                device: mcDevice
            };
            var position = { my: "left+" + Math.round(rect.left + 30) + " top+" + Math.round(rect.top + 30), at: "left top", of: window };
            var viewName = 'Mc ' + $gauge.attr("mc-analog-type") + ' Analog Widget';
            openViewService.openWidget(viewName, { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
        });

        $scope.$on("$destroy", function (event) {
            $element.off("mouseover.mcAnalogGauge");
        });
    };
}

McAnalogGaugeController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "translationService", "sharedSetupService", "datetimeService", "openViewService", "$timeout", "McAnalogGaugeFactory", "$filter", "$element", "McWidgetsSharedFactory", "toaster", "tabButtonGaugeService"];
'use strict';

angular.module('mc.analog-gauge').component('mcAnalogGauge', {
    controller: McAnalogGaugeController,
    templateUrl: 'ui/analog/mcanaloggauge/mc-analog-gauge-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        analogType: '<'
    }
});
"use strict";

angular.module("mc.analog-chart-recorder", []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AnalogChartRecorderFactory(HOST, $http) {
    // instantiate our initial object
    var analogChartRecorder = function () {
        function analogChartRecorder(customerId, deviceId, startDate, endDate, stickyProperties, isAnalogChartRecorder) {
            _classCallCheck(this, analogChartRecorder);

            this.customerId = customerId;
            this.deviceId = deviceId;
            this.startDate = startDate;
            this.endDate = endDate;
            this.stickyProperties = stickyProperties;
            this.isAnalogChartRecorder = isAnalogChartRecorder;
        }

        _createClass(analogChartRecorder, [{
            key: 'getData',
            value: function getData() {
                var self = this;
                return $http.get(HOST + '/api/Analog/Chart?customerId=' + this.customerId + '&deviceid=' + this.deviceId + '&StartDate=' + this.startDate + '&EndDate=' + this.endDate + '&isAnalogChartRecorder=' + this.isAnalogChartRecorder).then(function (response) {
                    self.list = response.data;
                    self.loading = false;
                    return response;
                });
            }
        }]);

        return analogChartRecorder;
    }();

    return analogChartRecorder;
}

AnalogChartRecorderFactory.$inject = ['HOST', '$http'];

angular.module('mc.analog-chart-recorder').factory('AnalogChartRecorderFactory', AnalogChartRecorderFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AnalogChartRecorderController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, websocketService, AnalogChartRecorderFactory, timeLapseService, openViewService, toaster, $timeout, $filter, $element) {
    var _this2 = this;

    var __this = this;
    $scope.myDate = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
    $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = 20 * 60 * 1000;
    $scope.minPadding = 0;
    $scope.maxPadding = 0;
    $scope.dataGroupingInterval = 0;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
    $scope.alerts = [];
    $scope.loadingInProgress = true;
    $scope.downloadViewTypeOptions = [0, 1]; //[0, 1];

    sharedSetupService.broadcastAllDeviceSelected($scope);

    $scope.openView = openViewService.openView;

    if ($scope.classicView && $element.parent('div').parent('div').parent('div').attr('class') && $element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") == 0) {
        $scope.largeChart = true;
        $element.height(700);
    }

    $scope.selectMyDate = function (date) {
        $scope.myDate = date;
        $scope.selectMyDateC();
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.fnChangeLanguage = function () {
        if ($scope.alerts.length > 0) {
            var _msg = eval('$scope.translation.message.' + $scope.alerts[0].languageCode.toUpperCase());
            var _type = $scope.alerts[0].type;
            var _languageCode = $scope.alerts[0].languageCode;
            if (_languageCode.toUpperCase() === 'NO_DATA') {
                _msg += ': ' + moment($scope.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
            } else {
                _msg = $scope.translation.message.ANALOG_SETUP_INCOMPLETE;
            }
            $scope.alerts = [];
            $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        }
    };

    this.$onInit = function () {
        $scope.windowId = _this2.windowId;
        $scope.windowTitle = _this2.windowTitle;
        $scope.mobile = _this2.mobile;
        $scope.classicView = _this2.classicView;
        $scope.deviceSelected = _this2.deviceSelected;
        $scope.stickyProperties = _this2.stickyProperties;
        sharedSetupService.getWindowId(_this2);
        var element = $element.find(".analog-chart-recorder-container");

        var chart = void 0;
        var zoomLevelCurrent = "day";
        var chartMin = void 0;
        var chartMax = 0;
        var dayColors = ["#ed561b", "#dddf00", "#24cbe5", "#64e572", "#ff9655", "#fff263", "#6af9c4"];
        __this.selectedChannel = { id: 0 };
        $scope.channels = [];

        // maximize view if on desktop
        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);
        }

        element.attr("class", "chart");

        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        // #region REST API

        // TODO: refactor to always get one week of data and just show one day if that is all that is needed.
        // Get data from REST API
        var getDataFromApi = function getDataFromApi(deviceId, startDate, endDate) {
            chartMin = startDate;
            chartMax = endDate;
            $scope.liveDataEndDate = endDate;

            var analogChartRecorder = new AnalogChartRecorderFactory($scope.accountInfo.customerId, deviceId, startDate, endDate, $scope.stickyProperties, true);

            analogChartRecorder.getData().then(function () {
                var dataFromFactory = analogChartRecorder.list;
                $scope.analogSetting = dataFromFactory.setting;
                $scope.yAxis = dataFromFactory.yAxis;
                $scope.series = dataFromFactory.series;
                $scope.alerts = [];
                $scope.channels = [];

                var device = { deviceName: $scope.deviceSelectedName };

                if (dataFromFactory.series && dataFromFactory.series[0].data.length >= 1) {
                    // get channel names
                    for (var i = 0; i < $scope.yAxis.length; i++) {
                        $scope.channels.push({ id: i, name: $scope.yAxis[i].title.text, channel: $scope.analogSetting[i].channel });
                    }

                    if (!__this.selectedChannel) __this.selectedChannel = { id: 0 };

                    if (angular.isUndefined(__this.selectedChannel.id) || __this.selectedChannel.id == null || __this.selectedChannel.id >= $scope.yAxis.length) __this.selectedChannel.id = 0;

                    $scope.devicename = dataFromFactory.device.name;

                    sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: deviceId, device: device, dataMin: startDate, dataMax: $scope.myDate ? $scope.myDate : endDate, windowId: $scope.windowId });

                    liveDataSetStatus(endDate);
                    drawChart();
                } else {
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: deviceId, device: device, dataMin: startDate, dataMax: endDate, zoomMin: $scope.stickyProperties.zoomMin || startDate, zoomMax: $scope.stickyProperties.zoomMax || endDate, windowId: $scope.windowId });
                    element.empty();
                    $scope.chart = null;
                    $scope.loadingInProgress = false;
                    $scope.lastStart = startDate;
                    $scope.lastEnd = endDate;
                    var errormsg = void 0;
                    if ($scope.analogSetting.length > 0) {
                        errormsg = $scope.translation.message.NO_DATA + ': ' + moment(startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(endDate).utc().format('MM/DD/YY, h:mm:ss a');
                        $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                    } else if (dataFromFactory.device.model == 20 && dataFromFactory.device.skuId <= 1) {
                        errormsg = $scope.translation.text.DEVICE_UNSUPPORTED;
                        $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "DEVICE_UNSUPPORTED" });
                    } else {
                        errormsg = $scope.translation.message.ANALOG_SETUP_INCOMPLETE;
                        $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
                    }
                }
            }, function (error) {
                $scope.alerts = [];
                element.empty();
                $scope.chart = null;
                $scope.loadingInProgress = false;
                var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            });
        };

        // #endregion REST API

        // Triggered when first opening the chart or when changing the device while the chart is open
        $scope.$watch('deviceSelected', function (newDeviceId, oldDeviceId) {
            if (newDeviceId) {
                $scope.loadingInProgress = true;

                if (!zoomLevelCurrent) zoomLevelCurrent = 'day';

                if (!$scope.stickyProperties.charRecorderZoom) $scope.stickyProperties.charRecorderZoom = zoomLevelCurrent;

                __this.selectedChannel.id = 0;

                var tmpDates = void 0;

                // Either get the day from the last chart of from current time
                // Chart recorder can only display whole day or whole week
                if ($scope.stickyProperties.on !== null && $scope.stickyProperties.dateMax !== null && $scope.stickyProperties.savedDesktop) {
                    $scope.stickyProperties.on = true;
                    tmpDates = new Date($scope.stickyProperties.dateMax);

                    tmpDates.setHours(0, 0, 0, 0);
                    tmpDates = datetimeService.dateToUnixtime(tmpDates);

                    // adjust the day because the device was changed on the same chart
                    if (newDeviceId !== oldDeviceId) tmpDates = tmpDates + $scope.unixDay;

                    getDataFromApiForZoom(newDeviceId, tmpDates);
                } else {
                    $scope.stickyProperties.on = false;
                }

                if (!angular.isDefined(tmpDates)) {
                    timeLapseService.getLocalDateTime().then(function (result) {
                        tmpDates = new Date(result.data.localDateTime);

                        tmpDates.setHours(0, 0, 0, 0);
                        tmpDates = datetimeService.dateToUnixtime(tmpDates);

                        // adjust the day because the device was changed on the same chart
                        if (newDeviceId !== oldDeviceId) tmpDates = tmpDates + $scope.unixDay;

                        getDataFromApiForZoom(newDeviceId, tmpDates);
                    });
                }
            }
        }, true);

        // Unregister old RTU from live data if changing RTU view
        $scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                $scope.stickyProperties.device.serialNumber = newValue;
                if (oldValue) {
                    liveDataUnregisterListener(oldValue);
                    liveDataUnregisterAnalogSettings(oldValue);
                }
            }
        }, true);

        // Triggered when the calendar date is changed, need to get new data from the API
        $scope.selectMyDateC = function () {
            var tmpDates = $scope.myDate;

            getDataFromApiForDates($scope.deviceSelected, tmpDates);
        };

        // Get range selector buttons for the chart
        var getRangeSelectorButtons = function getRangeSelectorButtons() {
            return [{
                text: $scope.translation.text.DAY.charAt(0).toUpperCase() + $scope.translation.text.DAY.slice(1),
                events: {
                    click: function click() {
                        switchZoomLevel('day');
                    }
                }
            }, {
                text: $scope.translation.text.WEEK,
                events: {
                    click: function click() {
                        switchZoomLevel('week');
                    }
                }
            }, {
                text: $scope.translation.text.WEEK_BY_DAY,
                events: {
                    click: function click() {
                        switchZoomLevel('weekByDay');
                    }
                }
            }];
        };

        // Switches zoom level on the chart recorder based on the selector button pressed.
        function switchZoomLevel(newZoomLevel) {
            zoomLevelCurrent = newZoomLevel;
            sharedSetupService.setStickyProperties($scope.stickyProperties, { charRecorderZoom: zoomLevelCurrent });

            liveDataUnregisterListener($scope.deviceSelectedSn);

            var tmpDates = new Date($scope.stickyProperties.dateMax);

            getDataFromApiForDates($scope.deviceSelected, tmpDates);
        }

        // Get REST API data based on dates
        function getDataFromApiForDates(deviceId, dates) {
            dates.setHours(0, 0, 0, 0);

            dates = datetimeService.dateToUnixtime(dates);
            dates = datetimeService.getNewStartEndDates(dates, 0);
            dates.endDate = getEndDate(dates.endDate);
            dates.startDate = getStartDate(dates.endDate);
            dates.endDate = dates.endDate - 1000;

            getDataFromApi(deviceId, dates.startDate, dates.endDate);
        }

        // Get REST API data based on zoom level
        function getDataFromApiForZoom(deviceId, dates) {
            switch (zoomLevelCurrent) {
                case 'day':
                    dates = datetimeService.getNewStartEndDates(dates, 9);
                    break;
                case 'week':
                case 'weekByDay':
                    dates = datetimeService.getNewStartEndDates(dates, -7);
                    break;
                default:
                    dates = datetimeService.getNewStartEndDates(dates, 9);
                    break;
            }

            getDataFromApi(deviceId, dates.startDate, dates.endDate);
        }

        // Get the end date for REST API call
        function getEndDate(endDate) {
            return endDate - $scope.unixDay * 1;
        }

        // Get the start date for REST API call
        function getStartDate(endDate) {
            var startDate = void 0;
            switch (zoomLevelCurrent) {
                case 'day':
                    startDate = endDate - $scope.unixDay;
                    break;
                case 'week':
                case 'weekByDay':
                    startDate = endDate - $scope.unixDay * 7;
                    break;
                default:
                    startDate = endDate - $scope.unixDay;
                    break;
            }

            return startDate;
        }

        // Get the name of the daily series based on the timestamp
        function getSeriesName(unixTimestamp) {
            var date = new Date(unixTimestamp);
            var gtmDateStr = date.toGMTString();
            var localDateStr = gtmDateStr.substring(0, gtmDateStr.length - 3);
            var gtmDate = new Date(localDateStr);
            var name = datetimeService.formatDate(gtmDate, 'yyyy-MM-dd ');

            switch (date.getUTCDay()) {
                case 0:
                    name += $scope.translation.text.SUNDAY;
                    break;
                case 1:
                    name += $scope.translation.text.MONDAY;
                    break;
                case 2:
                    name += $scope.translation.text.TUESDAY;
                    break;
                case 3:
                    name += $scope.translation.text.WEDNESDAY;
                    break;
                case 4:
                    name += $scope.translation.text.THURSDAY;
                    break;
                case 5:
                    name += $scope.translation.text.FRIDAY;
                    break;
                case 6:
                    name += $scope.translation.text.SATURDAY;
                    break;
            }
            return name;
        }

        // Separate channel data into single days based on the zoom level selected
        function getSeries(input) {
            var numberofDays = zoomLevelCurrent !== 'day' ? 7 : 1;
            var series = [];

            for (var i = 0; i < numberofDays; i++) {
                var day = { data: [], type: 'line', boostThreshold: 2000, connectEnds: false, marker: { enabled: false }, color: dayColors[i] };
                for (var j = 0; j < $scope.series[input].data.length; j++) {
                    if ($scope.series[input].data[j][0] >= chartMin + $scope.unixDay * i && $scope.series[input].data[j][0] < chartMin + $scope.unixDay * (i + 1)) {
                        day.data.push($scope.series[input].data[j]);
                    }
                }
                day.name = getSeriesName(chartMin + $scope.unixDay * i);
                series.push(day);
            }

            // go through each day series and convert it to latest day
            if (zoomLevelCurrent === 'weekByDay') {
                for (var k = 0; k < series.length; k++) {
                    for (var l = 0; l < series[k].data.length; l++) {
                        series[k].data[l][0] = series[k].data[l][0] + $scope.unixDay * (6 - k);
                    }
                }
            }

            return series;
        }

        // Get the original timestamp of the point based on series color (WeekByDay only)
        function getToolTipDate(timestamp, color) {
            if (zoomLevelCurrent !== 'weekByDay') return timestamp;

            var day = dayColors.indexOf(color);

            return day === -1 ? timestamp : timestamp - $scope.unixDay * (6 - day);
        }

        // Redraw chart after the input channel change
        $scope.channelChange = function (newChannel, oldChannel) {
            if (!angular.isDefined(newChannel)) return;

            __this.selectedChannel.id = newChannel;
            drawChart();
        };

        // Modify the Y axis since it is configured for the line graph and not the chart recorder
        function modifyYaxis() {
            for (var i = 0; i < $scope.yAxis.length; i++) {
                $scope.yAxis[i].gridLineWidth = 1;
                $scope.yAxis[i].title.text = null;
                $scope.yAxis[i].lineWidth = 0;
            }
        }

        // Adjust the chart size to fill the whole window
        var onChartLoad = function onChartLoad(object, event) {
            if (!$rootScope.mobile && !$rootScope.classicView) openViewService.adjustContentSize($scope.popup);
        };

        // #region DRAW CHART

        // Draw the chart recorder
        var drawChart = function drawChart() {
            var chartXaxisHourFormat = $scope.preferredTimeFormat === $scope.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
            var chartToolTipHourFormat = $scope.preferredTimeFormat === $scope.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

            modifyYaxis();

            var series = getSeries(__this.selectedChannel.id || 0);

            chart = new Highcharts.StockChart({
                credits: {
                    enabled: false
                },
                legend: {
                    enabled: true,
                    backgroundColor: '#f9f9f9',
                    borderColor: '#cccccc',
                    borderWidth: 1
                },
                boost: {
                    enabled: true,
                    useGPUTranslations: false // do not use for timestamps
                },
                chart: {
                    polar: true,
                    renderTo: element[0],
                    backgroundColor: '#ebebeb',
                    plotBackgroundColor: '#f9f9f9',
                    borderColor: '#d3d3d3',
                    borderWidth: 1,
                    borderRadius: 2,
                    plotBorderWidth: 1,
                    marginTop: 10,
                    marginRight: 10,
                    marginLeft: 10,
                    spacingBottom: 10,
                    spacingTop: 0,
                    spacingLeft: 2,
                    spacingRight: 5,
                    animation: false,
                    reflow: true,
                    events: {
                        load: function load(e) {
                            return onChartLoad(this, e);
                        }
                    }
                },
                title: {
                    text: null, //zoomLevelCurrent === 'day' ? series[0].name : series[0].name + ' - ' + series[series.length - 1].name,
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '.7em'
                    },
                    y: 30
                },
                subtitle: {
                    text: null
                },
                exporting: {
                    enabled: true,
                    buttons: {
                        contextButton: {
                            enabled: false
                        }
                    }
                },
                pane: {
                    size: $scope.mobile ? '75%' : '85%' // dynamically control the radius or size of the radial grid
                },
                xAxis: {
                    min: zoomLevelCurrent === 'weekByDay' ? chartMax - $scope.unixDay + 1000 : chartMin,
                    max: chartMax,
                    type: 'datetime',
                    tickInterval: zoomLevelCurrent === 'week' ? $scope.unixDay : $scope.unixDay / 24,
                    showLastLabel: true,
                    showFirstLabel: true,
                    startOnTick: zoomLevelCurrent === 'weekByDay' ? true : false,
                    labels: {
                        distance: 15, // Increase distance from axis line (for polar only)
                        formatter: function formatter() {
                            var str;
                            if (this.isFirst && zoomLevelCurrent === 'weekByDay') {
                                str = '12:00 AM';
                            } else {
                                if (zoomLevelCurrent === 'day' && this.isFirst || zoomLevelCurrent === 'week') str = moment(this.value).utc().format('MMM DD');else str = moment(this.value).utc().format('h:mm a');
                            }
                            return str;
                        }
                    },
                    ordinal: false,
                    minorGridLineColor: '#ebebeb',
                    minorTickInterval: 'auto',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    }
                },
                yAxis: $scope.yAxis,
                tooltip: {
                    useHTML: true,
                    formatter: function formatter() {
                        var s = '';

                        if (angular.isDefined(__this.selectedChannel) && __this.selectedChannel !== null && angular.isDefined(__this.selectedChannel.id)) {
                            s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';

                            $.each(this.points, function (i, point) {
                                s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, getToolTipDate(this.x, point.series.color)) + '</td></tr>';
                                var numDecimals = sharedSetupService.getNumberOfDecimals($scope.analogSetting[__this.selectedChannel.id || 0].maximumValue, $scope.analogSetting[__this.selectedChannel.id || 0].minimumValue);
                                s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, numDecimals) + '</td></tr>';
                            });
                            s += '</table>';
                        }
                        return s;
                    },

                    crosshairs: true,
                    shared: true,
                    valueDecimals: 1,
                    backgroundColor: '#FFFFFF',
                    borderColor: 'gray',
                    borderWidth: 1
                },
                navigator: {
                    enabled: false
                },
                scrollbar: {
                    enabled: false
                },
                rangeSelector: {
                    enabled: true,
                    buttonTheme: {
                        stroke: '#ccc',
                        'stroke-width': 1,
                        r: 4,
                        width: 76, //fit to contents
                        padding: 4
                    },
                    inputEnabled: false,
                    allButtonsEnabled: true,
                    buttons: getRangeSelectorButtons()
                },
                plotOptions: {
                    series: {
                        softThreshold: false,
                        dataGrouping: {
                            enabled: false
                        },
                        visible: true,
                        connectEnds: false,
                        marker: {
                            fillColor: '#FFFFFF',
                            lineWidth: 2,
                            lineColor: null // inherit from series
                        },
                        events: {
                            legendItemClick: function legendItemClick() {
                                var seriesIndex = this.index;
                                var chartSeries = this.chart.series;

                                if (!chartSeries[seriesIndex].visible) {
                                    chartSeries[seriesIndex].show();
                                } else {
                                    chartSeries[seriesIndex].hide();
                                }

                                return false;
                            }
                        }
                    }
                },
                series: series
            });

            $scope.chart = chart;
            $scope.loadingInProgress = false;
        };

        // #endregion DRAW CHART

        // #region LIVE DATA

        // Register listener for each analog channel to server to receive live data for a specific RTU
        var liveDataRegisterListener = function liveDataRegisterListener(varSelectedSn) {
            websocketService.connect();

            sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: true, windowId: $scope.windowId });
            for (var i = 0; i < 9; i++) {
                //chart.series.length - 1
                if ($scope.series[i] && parseInt($scope.series[i].id) <= 9) {
                    websocketService.register("ANALOG", varSelectedSn, $scope.series[i].id, liveDataReceived, null);
                    websocketService.register("ANALOG_G2", varSelectedSn, $scope.series[i].id, _wsUpdateAnalogG2, null);
                    websocketService.register("ANALOGSETTING", varSelectedSn, $scope.series[i].id, liveDataReceivedAnalogSetting, null);
                }
            }
            $scope.liveData = true;
        };

        // Unregister listener from server to stop receiving live data
        var liveDataUnregisterListener = function liveDataUnregisterListener(varSelectedSn) {
            for (var i = 0; i < 9; i++) {
                //chart.series.length - 1
                websocketService.unRegister("ANALOG", varSelectedSn, i + 1, liveDataReceived, null);
                websocketService.unRegister("ANALOG_G2", varSelectedSn, i + 1, _wsUpdateAnalogG2, null);
            }
            $scope.liveData = false;
        };

        // Unregister listener from server to stop receiving live data
        var liveDataUnregisterAnalogSettings = function liveDataUnregisterAnalogSettings(varSelectedSn) {
            for (var i = 0; i < 9; i++) {
                //chart.series.length - 1
                websocketService.unRegister("ANALOGSETTING", varSelectedSn, i + 1, liveDataReceivedAnalogSetting, null);
            }
        };

        // Receive live analog channel data from the server and add it to both $scope and chart
        var liveDataReceived = function liveDataReceived(data) {
            if ($scope.liveData === false) {
                liveDataUnregisterListener($scope.deviceSelectedSn);
                return;
            }

            var str = '' + data.Time;
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000            
            var varValue = parseFloat(data.Value);

            for (var i = 0; i < 9; i++) {
                if ($scope.series[i] && parseInt($scope.series[i].id) <= 9 && data.CH) {
                    if (data.CH == $scope.series[i].id) {
                        // add new point to the $scope so that it is available if the user displays this series
                        $scope.series[i].data.push([unixtime, varValue]);

                        // check if the data is for the channel that is currently displayed in the chart and add it to the chart
                        if (__this.selectedChannel.id == i) {
                            // add new point directly to the chart to the last series since it will be the most current for week or weekByDay
                            var series = chart.series[chart.series.length - 1];

                            // add point if in the same day or refresh the chart if in a new day
                            var lastPoint = series.data[series.data.length - 1];

                            if (lastPoint) {
                                var oldDate = new Date(lastPoint.x);
                                var newDate = new Date(unixtime);

                                if (oldDate.getUTCDay() !== newDate.getUTCDay()) {
                                    // refresh the entire chart to get a new day
                                    $scope.stickyProperties.on = true;
                                    liveDataUnregisterListener($scope.deviceSelectedSn);

                                    getDataFromApiForZoom($scope.stickyProperties.deviceId, newDate);
                                } else {
                                    series.addPoint([unixtime, varValue]);
                                }
                            } else {
                                series.addPoint([unixtime, varValue]);
                            }
                        }
                    }
                }
            }
        };

        var _wsUpdateAnalogG2 = function _wsUpdateAnalogG2(message) {

            if ($scope.liveData === false) {
                liveDataUnregisterListener($scope.deviceSelectedSn);
                return;
            }

            if ($scope.deviceSelectedType < 21) return;

            //if (angular.isUndefined(ctrl.currentStatus.analog)) return;

            //if (scope.deviceSelectedType == 20 && message.Ch != 1) return;

            var str = '' + message.Time;
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000            
            var varValue = parseFloat(message.Value);

            for (var i = 0; i < 9; i++) {
                if ($scope.series[i] && parseInt($scope.series[i].id) <= 9 && message.CH) {
                    if (message.CH == $scope.series[i].id) {
                        // add new point to the $scope so that it is available if the user displays this series
                        $scope.series[i].data.push([unixtime, varValue]);

                        // check if the data is for the channel that is currently displayed in the chart and add it to the chart
                        if (__this.selectedChannel.id == i) {
                            // add new point directly to the chart to the last series since it will be the most current for week or weekByDay
                            var series = chart.series[chart.series.length - 1];

                            // add point if in the same day or refresh the chart if in a new day
                            var lastPoint = series.data[series.data.length - 1];

                            if (lastPoint) {
                                var oldDate = new Date(lastPoint.x);
                                var newDate = new Date(unixtime);

                                if (oldDate.getUTCDay() !== newDate.getUTCDay()) {
                                    // refresh the entire chart to get a new day
                                    $scope.stickyProperties.on = true;
                                    liveDataUnregisterListener($scope.deviceSelectedSn);

                                    getDataFromApiForZoom($scope.stickyProperties.deviceId, newDate);
                                } else {
                                    series.addPoint([unixtime, varValue]);
                                }
                            } else {
                                series.addPoint([unixtime, varValue]);
                            }
                        }
                    }
                }
            }
        };

        // Receive live analog channel data from the server and add it to both $scope and chart
        var liveDataReceivedAnalogSetting = function liveDataReceivedAnalogSetting(data) {
            for (var i = 0; i < 9; i++) {
                if ($scope.series[i] && parseInt($scope.series[i].id) <= 9 && data.CH && data.Type == 'ANALOGSETTING') {
                    if (data.CH == $scope.series[i].id) {
                        resetViewFromLive(data.CH, data.Value);
                    }
                }
            }
        };

        // Reconnect to server if live data connection is broken
        //var liveDataReconnect = data => {
        //    if ($scope.liveData === false) {
        //        liveDataUnregisterListener($scope.deviceSelectedSn);
        //    } else if (data.Channel != 1) {
        //        toaster.pop('success', `${$scope.windowTitle} -- ${$scope.devicename}`, 'View reloading');

        //        $scope.stickyProperties.on = true;

        //        const tmpDates = new Date($scope.stickyProperties.dateMax);

        //        getDataFromApiForZoom($scope.stickyProperties.deviceId, tmpDates);
        //    }
        //};

        $scope.$on('processReconnect', function (event, args) {
            $scope.mostRecentData(event, args);
        });

        $scope.mostRecentData = function (event, args) {
            sharedSetupService.processReconnect({
                stickyProperties: $scope.stickyProperties,
                localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
                dateRangeOption: null,
                windowTitle: $scope.windowTitle,
                fnUnregister: liveDataUnregisterListener,
                fnGetData: getDataFromApiForZoom,
                viewType: "Chart Recorder"
            });
        };

        // Set status to get or not to get live data - need to change to only get when on current date
        var liveDataSetStatus = function liveDataSetStatus(varEndDate) {
            $scope.liveDataEndDate = varEndDate != null ? varEndDate : $scope.liveDataEndDate;
            timeLapseService.getLocalDateTime().then(function (result) {
                if ($scope.liveDataEndDate >= result.data.unixTimeStamp) {
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: true, windowId: $scope.windowId });
                    liveDataRegisterListener($scope.deviceSelectedSn);
                } else {
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: $scope.windowId });
                    liveDataUnregisterListener($scope.deviceSelectedSn);
                }
            });
        };

        // #endregion LIVE DATA

        // #region SETTINGS CHANGE

        // Get new channel settings
        var getArgsFromNewSetting = function getArgsFromNewSetting(channel, newSetting) {
            for (var i = 0; i < newSetting.length; i++) {
                if (newSetting[i].channel == channel) {
                    return newSetting[i];
                }
            }
            return null;
        };

        // Reset chart if the settings for any of the analog channels have changed
        var resetView = function resetView(args) {
            $scope.stickyProperties.on = true;
            for (var i = 0; i < $scope.series.length; i++) {
                if ($scope.series[i].id == args.channel) {
                    var newData = getArgsFromNewSetting(args.channel, args.newSetting);
                    var newDataValue = newData.name + ' (' + newData.unit + ')';
                    $scope.series[i].name = newDataValue;
                    $scope.yAxis[i].title.text = newDataValue;
                }
            }
            drawChart();
        };

        // Reset chart if the settings for any of the analog channels have changed
        var resetViewFromLive = function resetViewFromLive(channel, patch) {
            $scope.stickyProperties.on = true;
            for (var i = 0; i < $scope.series.length; i++) {
                if ($scope.series[i].id == channel) {

                    var newLiveValue;

                    switch (patch.path) {
                        case 'name':
                            newLiveValue = patch.value + ' (' + $scope.analogSetting[i].unit + ')';
                            $scope.analogSetting[i].name = patch.value;
                            break;
                        case 'unit':
                            newLiveValue = $scope.analogSetting[i].name + ' (' + patch.value + ')';
                            $scope.analogSetting[i].unit = patch.value;
                            break;
                        case 'minimumValue':
                            $scope.analogSetting[i].minimumValue = parseInt(patch.value);
                            break;
                        case 'maximumValue':
                            $scope.analogSetting[i].maximumValue = parseInt(patch.value);
                            break;
                    }
                    $scope.channels[i].name = newLiveValue;
                    $scope.series[i].name = newLiveValue;
                    $scope.yAxis[i].title.text = newLiveValue;
                }
            }
            drawChart();
        };

        // Triggered when analog channel settings are changed
        $scope.$on('rtuAnalogUpdate', function (event, args) {
            var dataChanged = "name, unit";
            if (args.deviceId == $scope.deviceSelected && dataChanged.includes(args.fieldName)) {
                //resetView(args);
            }
        });

        // #endregion SETTINGS CHANGE

        $scope.$on('updatePreferencesLanguage', function () {
            if ($scope.alerts.length === 0) {
                drawChart();
            }
            $scope.fnChangeLanguage();
        });

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            $scope.applyTimeFormat(timeFormat);
            if ($scope.alerts.length === 0) {
                drawChart();
            }
        });

        $scope.applyTimeFormat = function (timeFormat) {
            $scope.preferredTimeFormat = parseInt(timeFormat);
        };

        $scope.$on("$destroy", function () {
            liveDataUnregisterListener($scope.deviceSelectedSn);
            liveDataUnregisterAnalogSettings($scope.deviceSelectedSn);
            if (chart) chart.destroy();
        });
    };
};

AnalogChartRecorderController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'datetimeService', 'websocketService', 'AnalogChartRecorderFactory', 'timeLapseService', 'openViewService', 'toaster', '$timeout', '$filter', '$element'];
'use strict';

angular.module('mc.analog-chart-recorder').component('analogChartRecorder', {
    controller: AnalogChartRecorderController,
    templateUrl: 'ui/analog/chartrecorder/analog-chart-recorder-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.output-widget", []);
'use strict';

function McAnalogOutputWidgetController($, $rootScope, $scope, $sce, authenticationService, sharedSetupService, McAnalogOutputGaugeFactory, McWidgetsSharedFactory, toaster, translationService) {
    var ctrl = this;
    ctrl.closeIcon = false;

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 1);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.stickyProperties.device.deviceId, windowId: $scope.windowId });
        ctrl.translation = translationService.translation;
        ctrl.getData();
    };

    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.analogOutputGauge.device.name, 'View reloading');
        ctrl.getData();
    };

    ctrl.getData = function () {
        var _analogOutputGauge = new McAnalogOutputGaugeFactory(ctrl.accountInfo.customerId, $scope.stickyProperties.device.deviceId, ctrl.accountInfo.timeZone, 1, 24, $scope.stickyProperties.device.channel); //Category: Analog, Widget: 'Single Needle Gauge'
        _analogOutputGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            var device = _analogOutputGauge.list.device;
            var deviceUnitState = _analogOutputGauge.list.deviceUnitState;
            var defaultSetting = _analogOutputGauge.list.defaultSetting;

            // if _analogGauge.list.analogGauge is not available, set default values to empty object
            var analogOutputGauge = _analogOutputGauge.list.analogOutputGauge.length == 0 ? {} : _analogOutputGauge.list.analogOutputGauge[0].analogOutputGauge;
            var analogOutputWidgetSetting = _analogOutputGauge.list.analogOutputGauge.length == 0 ? {} : _analogOutputGauge.list.analogOutputGauge[0].analogOutputWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: true,
                displaySettingOn: true,
                defaultSetting: false
            };
            ctrl.analogOutputGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                defaultSetting: defaultSetting,
                analogOutputGauge: analogOutputGauge,
                analogOutputWidgetSetting: analogOutputWidgetSetting,
                setting: setting
            };

            if (!$rootScope.mobile && !$rootScope.classicView) ctrl.additionalSetting();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.fnChangeWidgetTitle = function (titleOption) {
        var _device = { channel: titleOption.channel, deviceId: titleOption.deviceId, deviceName: titleOption.name, serialNumber: titleOption.serialNumber };
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: titleOption.deviceId, device: _device, windowId: $scope.windowId });
        ctrl.setTitle(titleOption.name, titleOption.channelDescription);
    };

    ctrl.setTitle = function (deviceName, channelDescription) {
        ctrl.deviceName = deviceName;
        ctrl.popup.dialog("option", "title", ctrl.deviceName + ", " + channelDescription);
    };

    ctrl.additionalSetting = function () {

        ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.popup.dialog({ resizable: false });

        ctrl.setTitle(ctrl.analogOutputGauge.device.name, Object.keys(ctrl.analogOutputGauge.analogOutputGauge).length !== 0 ? ctrl.analogOutputGauge.analogOutputGauge.name : ctrl.translation.text.NOT_SETUP);

        ctrl.popup.parent().find("div.ui-widget-content ").css('overflow', 'visible');

        ctrl.closeWidget = function () {
            ctrl.popup.dialog("close");
        };

        ctrl.setSize(ctrl.analogOutputGauge.analogOutputWidgetSetting.sizeId);

        ctrl.popup.dialog('widget').css("width", ctrl.svgSizeH + "px");
        ctrl.popup.dialog("option", "width", ctrl.svgSizeH);

        ctrl.popup.dialog('widget').css("height", ctrl.svgSizeH + 25 + "px");
        ctrl.popup.dialog("option", "height", ctrl.svgSizeH + 25);

        ctrl.popup.parent().addClass("ui-widget-content-mc");

        ctrl.popup.parent().on("mouseover", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().addClass("x-resize");
                ctrl.closeIcon = true;
            });
        });

        ctrl.popup.parent().on("mouseout", function (event) {
            event.preventDefault();
            var localScope = $(event.target).scope();
            localScope.$apply(function () {
                ctrl.popup.parent().removeClass("x-resize");
                if (ctrl.isTouchSupported()) {
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 3000);
                } else {
                    ctrl.closeIcon = true;
                    setTimeout(function () {
                        ctrl.closeIcon = false;
                    }, 500);
                }
            });
        });

        ctrl.isTouchSupported = function () {
            var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
            var generalTouchEnabled = "ontouchstart" in document.createElement("div");

            if (msTouchEnabled || generalTouchEnabled) {
                return true;
            }
            return false;
        };

        $scope.$on("$destroy", function (event) {
            ctrl.popup.parent().off("mouseover");
            ctrl.popup.parent().off("mouseout");
        });
    };
}

McAnalogOutputWidgetController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "sharedSetupService", "McAnalogOutputGaugeFactory", "McWidgetsSharedFactory", "toaster", "translationService"];
'use strict';

angular.module('mc.output-widget').component('mcOutputWidget', {
    controller: McAnalogOutputWidgetController,
    templateUrl: 'ui/analogoutput/mcanalogoutputwidget/mc-analog-output-widget-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        analogType: '<'
    }
});
"use strict";

angular.module("mc.analog-output-gauge", []);
'use strict';

function McAnalogOutputGaugeFactory(HOST, $http) {

    // instantiate our initial object
    var McAnalogOutputGauge = function McAnalogOutputGauge(customerId, deviceId, timeZone, categoryId, widgetId, channel) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
        this.categoryId = categoryId;
        this.widgetId = widgetId;
        this.channel = channel;
    };

    McAnalogOutputGauge.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/AnalogOutputGauge' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone + '&categoryId=' + this.categoryId + '&widgetId=' + this.widgetId + '&channel=' + this.channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McAnalogOutputGauge.prototype.getWidgetData = function (channelId) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channelId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McAnalogOutputGauge;
}

McAnalogOutputGaugeFactory.$inject = ['HOST', '$http'];

angular.module('mc.analog-output-gauge').factory('McAnalogOutputGaugeFactory', McAnalogOutputGaugeFactory);
'use strict';

function McAnalogOutputGaugeController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, datetimeService, openViewService, $timeout, McAnalogOutputGaugeFactory, $filter, $element, McWidgetsSharedFactory, toaster) {
    var ctrl = this;

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;
        sharedSetupService.getWindowId($scope);

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();

        $scope.mostRecentData = function () {
            toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
            var _analogOutputGauges = new McAnalogOutputGaugeFactory(ctrl.accountInfo.customerId, $scope.currentDeviceId, ctrl.accountInfo.timeZone, 1, 24); //Category: Analog, Widget: 'Single Needle Gauge'

            _analogOutputGauges.getGaugeData().then(function () {
                ctrl.loadingInProgress = false;
                //ctrl.analogGauges = _analogGauges.list;
                var tmpAnalogOutputGauges = [],
                    device,
                    deviceUnitState,
                    analogOutputGauge,
                    analogOutputWidgetSetting,
                    setting,
                    defaultSetting;

                for (var i = 0; i <= _analogOutputGauges.list.analogOutputGauge.length - 1; i++) {
                    device = _analogOutputGauges.list.device;
                    deviceUnitState = _analogOutputGauges.list.deviceUnitState;
                    defaultSetting = _analogOutputGauges.list.defaultSetting;
                    analogOutputGauge = _analogOutputGauges.list.analogOutputGauge[i].analogOutputGauge;
                    analogOutputWidgetSetting = _analogOutputGauges.list.analogOutputGauge[i].analogOutputWidgetSetting;

                    setting = {
                        customerId: ctrl.accountInfo.customerId,
                        //deviceId: ctrl.analogGauges[i].deviceId,
                        //deviceName: ctrl.analogGauges[i].deviceName,
                        //channel: ctrl.analogGauges[i].channel,
                        //channelName: ctrl.analogGauges[i].channelName,
                        displaySetting: false,
                        displaySettingOn: false,
                        defaultSetting: true
                    };
                    tmpAnalogOutputGauges.push({
                        device: device,
                        deviceUnitState: deviceUnitState,
                        defaultSetting: defaultSetting,
                        analogOutputGauge: analogOutputGauge,
                        analogOutputWidgetSetting: analogOutputWidgetSetting,
                        setting: setting,
                        analogType: ctrl.mcWidgetsSharedFactory.getAnalogTypeByWidgetId(analogOutputGauge.widgetId)
                    });
                }

                ctrl.analogOutputGauges = angular.copy(tmpAnalogOutputGauges);
                $scope.alerts = [];
                if (_analogOutputGauges.list.analogOutputGauge.length === 0) $scope.alerts.push({ msg: ctrl.translation.message.ANALOG_SETUP_INCOMPLETE, type: "info" });
                if (_analogOutputGauges.list.device.deviceModel == 20 || !_analogOutputGauges.list.device.hasAnalogOutputBoard) $scope.alerts.push({ msg: ctrl.translation.message.ANALOG_SETUP_INCOMPLETE, type: "info" });
            }, function (error) {
                console.log(error);
                ctrl.loadingInProgress = false;
            });
        };

        $scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                $scope.currentDeviceId = newValue;
                var _analogOutputGauges = new McAnalogOutputGaugeFactory(ctrl.accountInfo.customerId, newValue, ctrl.accountInfo.timeZone, 1, 24); //Category: Analog, Widget: 'Single Needle Gauge'

                _analogOutputGauges.getGaugeData().then(function () {
                    ctrl.loadingInProgress = false;
                    //ctrl.analogGauges = _analogGauges.list;
                    var tmpAnalogOutputGauges = [],
                        device,
                        deviceUnitState,
                        analogOutputGauge,
                        analogOutputWidgetSetting,
                        setting,
                        defaultSetting;

                    for (var i = 0; i <= _analogOutputGauges.list.analogOutputGauge.length - 1; i++) {
                        device = _analogOutputGauges.list.device;
                        deviceUnitState = _analogOutputGauges.list.deviceUnitState;
                        defaultSetting = _analogOutputGauges.list.defaultSetting;
                        analogOutputGauge = _analogOutputGauges.list.analogOutputGauge[i].analogOutputGauge;
                        analogOutputWidgetSetting = _analogOutputGauges.list.analogOutputGauge[i].analogOutputWidgetSetting;

                        setting = {
                            customerId: ctrl.accountInfo.customerId,
                            //deviceId: ctrl.analogGauges[i].deviceId,
                            //deviceName: ctrl.analogGauges[i].deviceName,
                            //channel: ctrl.analogGauges[i].channel,
                            //channelName: ctrl.analogGauges[i].channelName,
                            displaySetting: false,
                            displaySettingOn: false,
                            defaultSetting: true
                        };
                        tmpAnalogOutputGauges.push({
                            device: device,
                            deviceUnitState: deviceUnitState,
                            defaultSetting: defaultSetting,
                            analogOutputGauge: analogOutputGauge,
                            analogOutputWidgetSetting: analogOutputWidgetSetting,
                            setting: setting,
                            analogType: ctrl.mcWidgetsSharedFactory.getAnalogTypeByWidgetId(analogOutputWidgetSetting.widgetId)
                        });
                    }

                    ctrl.analogOutputGauges = angular.copy(tmpAnalogOutputGauges);
                    $scope.alerts = [];
                    if (_analogOutputGauges.list.analogOutputGauge.length === 0) $scope.alerts.push({ msg: ctrl.translation.message.ANALOG_SETUP_INCOMPLETE, type: "info" });
                    if (_analogOutputGauges.list.device.deviceModel == 20 || !_analogOutputGauges.list.device.hasAnalogOutputBoard) $scope.alerts.push({ msg: ctrl.translation.message.ANALOG_SETUP_INCOMPLETE, type: "info" });
                }, function (error) {
                    console.log(error);
                    ctrl.loadingInProgress = false;
                });
            }
        }, true);

        $element.on("mouseover.mcAnalogOutputGauge", ".upWidget", function (event) {
            if ($(event.currentTarget).is(".upWidget") && event.target.tagName !== "DIV" && !$scope.mobile && !$scope.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    zIndex: 9999,
                    disabled: false,
                    stop: function stop(event, ui) {
                        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(ui.helper.attr("mc-size"), 1);
                        var mcDevice = { deviceId: $scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: $scope.deviceSelectedSn, deviceName: $scope.deviceSelectedName };
                        var optionsStickyProperties = {
                            deviceId: $scope.deviceSelected,
                            device: mcDevice
                        };
                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        var viewName = 'Mc ' + ui.helper.attr("mc-analog-type") + ' Analog Output Widget';
                        //var viewName = `Mc Analog Output Widget`;
                        openViewService.openWidget(viewName, { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                        $scope.$apply();
                    }
                });
            } else {
                $(event.currentTarget).draggable({ disabled: true });
            }
        });

        $scope.$on("$destroy", function (event) {
            $element.off("mouseover.mcAnalogGauge");
        });
    };
}

McAnalogOutputGaugeController.$inject = ["$", "$rootScope", "$scope", "$sce", "authenticationService", "translationService", "sharedSetupService", "datetimeService", "openViewService", "$timeout", "McAnalogOutputGaugeFactory", "$filter", "$element", "McWidgetsSharedFactory", "toaster"];
'use strict';

angular.module('mc.analog-output-gauge').component('mcAnalogOutputGauge', {
    controller: McAnalogOutputGaugeController,
    templateUrl: 'ui/analogoutput/mcanalogoutputgauge/mc-analog-output-gauge-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        analogType: '<'
    }
});
"use strict";

angular.module("mc.att-data-usage", []);
'use strict';

function AttDataUsageFactory(HOST, $http) {
    function GetList(carrierId, startDate, endDate) {
        return $http({
            method: 'GET',
            url: HOST + '/api/CarrierRatePlanSummary',
            params: { carrierId: carrierId, startDate: startDate, endDate: endDate }
        });
    }
    return { GetList: GetList };
}

AttDataUsageFactory.$inject = ['HOST', '$http'];

angular.module('mc.att-data-usage').factory('AttDataUsageFactory', AttDataUsageFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AttDataUsageController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, AttDataUsageFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, $q, savePdfService) {
    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    ctrl.ratePlanSummary = [];

    ctrl.$onChanges = function (changes) {
        if (changes.carrierTab.currentValue === ctrl.carrierId) {
            ctrl.setReportDate(0); //keep same month but load new tab
        }
    };

    ctrl.$onInit = function () {
        ctrl.reverse = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.goSelectReportData = function (varClick) {
        var deferred = $q.defer();
        ctrl.viewLoading = true;
        var tabPromise = $q.defer();
        var _tmpStartMonth, _tmpStartYear;
        ctrl.daysInMonth = new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0).getDate();
        ctrl.numberDaysOfMonth = Array.apply(null, { length: ctrl.daysInMonth + 1 }).map(Number.call, Number);
        ctrl.numberDaysOfMonth.shift(); //numberDayOfMonth = {1, 2, 3, 4, 5, 6, 7,..... daysInMonth}. Used for the X-axis.

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;

        //------Date Logic-------
        if (_typeof(ctrl.stickyProperties) !== 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }

        if (varClick) {
            _tmpStartMonth = ctrl.reportDate.getMonth();
            _tmpStartYear = ctrl.reportDate.getFullYear();
        } else if (ctrl.stickyProperties.on === true) {
            ctrl.stickyProperties.on = false;
            _tmpStartMonth = new Date(ctrl.stickyProperties.dateMin).getMonth();
            _tmpStartYear = new Date(ctrl.stickyProperties.dateMin).getFullYear();
            ctrl.reportDate = new Date(_tmpStartYear, _tmpStartMonth, 1);
            ctrl.adjustButtons();
        } else {
            _tmpStartMonth = new Date().getMonth();
            _tmpStartYear = new Date().getFullYear();
            ctrl.reportDate = new Date(_tmpStartYear, _tmpStartMonth, 1);
            ctrl.adjustButtons();
        }
        ctrl.startDate = datetimeService.dateToUnixtime(new Date(_tmpStartYear, _tmpStartMonth, 1));
        ctrl.endDate = datetimeService.dateToUnixtime(new Date(_tmpStartYear, _tmpStartMonth + 1, 0)); //0th day of next month is last day of current month

        //---------*Get Data and Spilt it into correspodning Variables for Use*---------
        AttDataUsageFactory.GetList(ctrl.carrierId, ctrl.startDate, ctrl.endDate).then(function (resp) {
            tabPromise.resolve();
            $timeout(function () {
                ctrl.viewLoading = false;
            });
            ctrl.viewLoading = true;

            ctrl.ratePlanKBs = {};
            for (var i = 0; i < resp.data.ratePlans.length; i++) {
                var key = resp.data.ratePlans[i].ratePlan;
                var value = resp.data.ratePlans[i].includedKB;
                ctrl.ratePlanKBs[key] = value;
            }

            ctrl.ratePlanUniqueDevices = {};
            ctrl.numActivePlans = 0;
            for (var j = 0; j < resp.data.ratePlanUniqueDevices.length; j++) {
                var key = resp.data.ratePlanUniqueDevices[j].ratePlan;
                var value = resp.data.ratePlanUniqueDevices[j].uniqueDevices;
                ctrl.ratePlanUniqueDevices[key] = value;
                ctrl.numActivePlans = ctrl.numActivePlans + 1;
            }

            var planDaysOfData = []; //1-D array corresponding to a number representing how many days had reports with them, length = # of plans
            var planConsumedReportUsage = []; //2-D array [#Plans][#Days in the Month] where the value is total usage on that plan on that date.

            for (var i = 0, currentPlanName, tmpConsumedPlanUsageArr; i < resp.data.dailyUsages.length; i++) {
                if (i === 0) {
                    //First Report
                    currentPlanName = resp.data.dailyUsages[i].ratePlan;
                    planDaysOfData.push(0);
                    tmpConsumedPlanUsageArr = new Array(ctrl.daysInMonth).fill(0);
                }

                //Converts the current data item' in (resp.data.dailusages[i])'s report to data to the corresponding index for the tmpArrays.
                var index = new Date(resp.data.dailyUsages[i].reportDate).getDate() - 1;
                if (i + 1 == resp.data.dailyUsages.length) //Last Element
                    {
                        tmpConsumedPlanUsageArr[index] = resp.data.dailyUsages[i].totalUsage;
                        planConsumedReportUsage.push(tmpConsumedPlanUsageArr);
                    } else if (currentPlanName === resp.data.dailyUsages[i].ratePlan) //On the Same RatePlan as previous report
                    {
                        tmpConsumedPlanUsageArr[index] = resp.data.dailyUsages[i].totalUsage;
                    } else if (!(currentPlanName === resp.data.dailyUsages[i].ratePlan)) //Different plan from the previous.
                    {
                        planConsumedReportUsage.push(tmpConsumedPlanUsageArr);
                        planDaysOfData.push(0);

                        //Re-zero them.
                        tmpConsumedPlanUsageArr = new Array(ctrl.daysInMonth).fill(0);

                        //Add new rate plan name, and new KB
                        currentPlanName = resp.data.dailyUsages[i].ratePlan;

                        //Add new data to the new tmps
                        tmpConsumedPlanUsageArr[index] = resp.data.dailyUsages[i].totalUsage;
                    }
                planDaysOfData[planDaysOfData.length - 1] = planDaysOfData[planDaysOfData.length - 1] + 1;
            }
            ctrl.planReportConsumedUsage2D = planConsumedReportUsage; //2-D
            ctrl.planDaysOfData = planDaysOfData;

            ctrl.viewLoading = false;
            deferred.resolve();
        }, function (resp) {
            deferred.reject();
            console.log(resp);
        });
        return deferred.promise;
    };

    ctrl.setReportDate = function (months) {
        if (months === 0) ctrl.reportDate = new Date();
        var d = new Date(ctrl.reportDate || new Date());
        d.setMonth(d.getMonth() + (months || 0), d.getDate());
        ctrl.reportDate = d;
        ctrl.adjustButtons();
        var promise = ctrl.goSelectReportData(true);
        promise.then(function (data) {
            ctrl.buildGraphics();
        }, function (reason) {
            console.log(reason);
        });
    };

    ctrl.buildGraphics = function () {
        if (ctrl.numActivePlans == 0) {
            var message = "There is <u>NO</u> data for " + ctrl.reportDate.toLocaleString("en-us", { month: "long" });
            ctrl.headerInfoColor = "lightcoral";
            ctrl.headerInfoPanel = message;
        } else {
            var message = ctrl.numActivePlans + " Active Rate Plans for " + ctrl.reportDate.toLocaleString("en-us", { month: "long" });
            ctrl.headerInfoColor = "lightgreen";
            ctrl.headerInfoPanel = message;
            ctrl.ratePlanSummary = []; //get rid of old summaries
            $timeout(function () {
                for (var k = 0; k < ctrl.numActivePlans; k++) {
                    _drawRatePlanChart(k);
                    _drawRatePlanSummary(k);
                }
            }, 0);
        }
    };

    ctrl.adjustButtons = function () {
        if (new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0).getTime() === new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime()) {
            ctrl.todaysDate = true;
            ctrl.nextDate = true;
        } else {
            ctrl.todaysDate = false;
            ctrl.nextDate = false;
        }
    };

    var _drawRatePlanSummary = function _drawRatePlanSummary(ratePlanIndex) {
        var planName = Object.keys(ctrl.ratePlanUniqueDevices)[ratePlanIndex];
        var lastDayInMonth = new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0);
        var monthRemainingPercent = Math.round(new Date() > lastDayInMonth ? 0 : (lastDayInMonth.getDate() - new Date().getDate()) / ctrl.daysInMonth * 100).toString();
        var uniqueDeviceCount = ctrl.ratePlanUniqueDevices[planName];

        var totalUsageConsumed = ctrl.planReportConsumedUsage2D[ratePlanIndex].reduce(function (a, b) {
            return a + b;
        }, 0);
        var totalUsageBought = uniqueDeviceCount * ctrl.ratePlanKBs[planName];
        var totalUsageRemaining = Math.round(totalUsageBought - totalUsageConsumed);
        var totalUsageRemainingPercentage = totalUsageRemaining / totalUsageBought * 100;
        totalUsageRemainingPercentage = +totalUsageRemainingPercentage.toFixed(1);

        var avrgConsRateColor = Math.round(totalUsageConsumed / uniqueDeviceCount) > ctrl.ratePlanKBs[planName] ? '#C70039' : '	#006400';
        var head = '<font size="2"><strong><center>' + planName + " - " + ctrl.ratePlanKBs[planName] + " KB</center></strong>" + "Days of Data: <i>" + ctrl.planDaysOfData[ratePlanIndex].toString() + "</i><br>" + "Days of Missing Data: <i>" + (ctrl.daysInMonth - ctrl.planDaysOfData[ratePlanIndex]).toString() + "</i><br>" + "Days in Month: <i>" + ctrl.numberDaysOfMonth.length.toString() + "</i><br>" + "Month Remaining: <i>" + monthRemainingPercent + "%</i><br>" + "Unique Device Count: <i>" + uniqueDeviceCount + "</i><br>" + 'Average Device Consumption over ' + ctrl.planDaysOfData[ratePlanIndex].toString() + ' Days: <i><b><font color="' + avrgConsRateColor + '">' + byteToString(Math.round(totalUsageConsumed / uniqueDeviceCount)) + "</font></b></i><br><br>" + "<i>" + byteToString(totalUsageBought) + "</i> have been bought for the month.<br>" + "<i>" + byteToString(totalUsageConsumed) + "</i> have been consumed over the month.<br>" + '<i><b><font color="' + avrgConsRateColor + '">' + byteToString(totalUsageRemaining) + '</b></font></i> or <i><b><font color="' + avrgConsRateColor + '">' + Math.max(0, totalUsageRemainingPercentage) + "%</font></b></i> of data is left." + "<br>" + "</font>";
        var tail;
        var expectedConsumptionRate = Math.round(totalUsageConsumed / uniqueDeviceCount / ctrl.planDaysOfData[ratePlanIndex]) * ctrl.numberDaysOfMonth.length;

        if (ctrl.daysInMonth - ctrl.planDaysOfData[ratePlanIndex] > 0) {
            avrgConsRateColor = expectedConsumptionRate > ctrl.ratePlanKBs[planName] ? '#C70039' : '	#006400';
            tail = '<br><font size="2">With ' + (ctrl.daysInMonth - ctrl.planDaysOfData[ratePlanIndex]).toString() + " days of missing data you can predict a monthly consumption " + ' rate of <i><b><font color="' + avrgConsRateColor + '">' + byteToString(expectedConsumptionRate) + "</b></font></i> per a device if devices continue to consume at their current rate." + "</font>";
        } else {
            //Expected Consumption rate - rate plan (kb) = how much data 1 device adds/takes away
            var deviceRateContribution = expectedConsumptionRate - ctrl.ratePlanKBs[planName];
            var numRatePlansToChange = totalUsageRemaining / deviceRateContribution;
            //Case 1... totalRemain is Neg
            //deviceRateContribution must also be negative.
            //Case 2... totalRemain is Pos
            //deviceRateContribution must be pos.

            avrgConsRateColor = deviceRateContribution > 0 ? '#C70039' : '	#006400';
            tail = '<br><font size="2"> On average every device could use about ' + '<i><b><font color="' + avrgConsRateColor + '">' + byteToString(Math.abs(deviceRateContribution)) + "</b></font></i>" + (deviceRateContribution < 0 ? " of more" : " of less") + " data. You should adjust rate plans acordingly. " + "</font>";
        }
        ctrl.ratePlanSummary.push(head + tail);
    };

    var _drawRatePlanChart = function _drawRatePlanChart(ratePlanIndex) {

        var planName = Object.keys(ctrl.ratePlanUniqueDevices)[ratePlanIndex];
        var boughtKBADay = ctrl.ratePlanKBs[planName] / ctrl.daysInMonth;

        //Sum Columns
        var boughtUsageArrSum = new Array(ctrl.numberDaysOfMonth.length).fill(0);
        var consumedUsageArrSum = new Array(ctrl.numberDaysOfMonth.length).fill(0);

        //ctrl.planReportConsumedUsage2D[ratePlanIndex]
        for (var i = 0; i < boughtUsageArrSum.length; i++) {
            if (i === 0) consumedUsageArrSum[i] = ctrl.planReportConsumedUsage2D[ratePlanIndex][i];else consumedUsageArrSum[i] = ctrl.planReportConsumedUsage2D[ratePlanIndex][i] + consumedUsageArrSum[i - 1]; //sum
            boughtUsageArrSum[i] = boughtKBADay * (i + 1) * ctrl.ratePlanUniqueDevices[planName];
        }

        var elementId = "#chart" + planName;
        ctrl.element = $element.find(elementId);

        Highcharts.chart({
            chart: {
                renderTo: ctrl.element[0],
                type: 'column'
            },
            credits: {
                enabled: false
            },
            rangeSelector: {
                enabled: false
            },
            navigator: {
                enabled: false
            },
            scrollbar: {
                enabled: false
            },
            title: {
                text: planName + " - " + ctrl.ratePlanKBs[planName] + "KB"
            },
            plotOptions: {
                column: {
                    groupPadding: 0.5, // Exactly overlap
                    pointWidth: 19
                }
            },
            xAxis: {
                title: {
                    text: "Days of " + ctrl.reportDate.toLocaleString("en-us", { month: "long" })
                },
                categories: ctrl.numberDaysOfMonth,
                dateTimeLabelFormats: {
                    day: null,
                    week: null
                },
                minRange: null,
                type: 'category',
                labels: {
                    rotation: -45,
                    style: {
                        fontSize: '10px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }

            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Data Usage (KB)'
                }
            },
            tooltip: {
                headerFormat: '<div style="font-size:14px; width: 200px;"><b>Day {point.key}</b></div><table>',
                pointFormatter: function pointFormatter() {
                    var s = '<tr><td style="font-size:13px; color: ' + this.series.color + ';">' + this.series.name + ' ' + byteToString(this.y) + '</td></tr>';
                    return s;
                },
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                backgroundColor: 'white'
            },
            series: [{
                name: 'Bought (Running)', //line
                type: 'spline',
                lineWidth: 4,
                color: 'blue',
                dashstyle: 'shortDashDot',
                connectNulls: true,
                pointStart: 0,
                pointInterval: ctrl.numberDaysOfMonth.length - 1,
                data: [boughtUsageArrSum[0], boughtUsageArrSum[boughtUsageArrSum.length - 1]],
                marker: {
                    enabled: false
                },
                zIndex: 2,
                enableMouseTracking: false,
                showInLegend: true
            }, {
                name: 'Consumed (Running)', //line
                type: 'spline',
                lineWidth: 4,
                color: '#ff4500',
                dashstyle: 'shortDashDot',
                connectNulls: true,
                data: consumedUsageArrSum,
                marker: {
                    enabled: false
                },
                zIndex: 3,
                enableMouseTracking: false,
                showInLegend: true
            }, {
                name: 'Consumed (Daily)',
                data: ctrl.planReportConsumedUsage2D[ratePlanIndex],
                color: 'rgb(255,165,0,1)',
                zIndex: 2

            }, {
                name: 'Consumed (Running)',
                data: consumedUsageArrSum,
                color: 'rgb(220,20,60,1)',
                marker: {
                    enabled: false
                },
                zIndex: consumedUsageArrSum[consumedUsageArrSum.length - 1] < boughtUsageArrSum[boughtUsageArrSum.length - 1] ? 1 : 0,
                showInLegend: false
            }, {
                name: 'Bought (Running)',
                data: boughtUsageArrSum,
                color: 'rgb(0,0,220,0.8)',
                zIndex: consumedUsageArrSum[consumedUsageArrSum.length - 1] < boughtUsageArrSum[boughtUsageArrSum.length - 1] ? 0 : 1,
                showInLegend: false
            }]
        });
    };

    //Helper to convert large KB values to readable formats
    function byteToString(val) {
        var kb = val;
        kb = +kb.toFixed(0);
        var mb = val / 1000;
        mb = +mb.toFixed(1);
        var gb = val / (1000 * 1000);
        gb = +gb.toFixed(2);

        if (gb >= 1 || gb <= -1) return (gb.toString() + " GB").toString();else if (mb >= 1 || mb <= -1) return (mb.toString() + " MB").toString();else return (kb.toString() + " KB").toString();
    }

    ///
    ///
    /// All of the below methods are left over and I do not use / do not know if they work.
    ///
    ///

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                0: { columnWidth: 70 },
                1: { columnWidth: 100 },
                2: { columnWidth: 100 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshData();
    });

    ctrl.refreshData = function () {
        ctrl.carrierDataUsage = angular.copy(ctrl.carrierDataUsage);
    };
}

AttDataUsageController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'AttDataUsageFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', 'savePdfService'];
'use strict';

angular.module('mc.att-data-usage').component('attDataUsage', {
    controller: AttDataUsageController,
    templateUrl: 'ui/carrierdatausage/att/att-data-usage-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        carrierId: '<',
        carrierTab: '<'
    }
});
"use strict";

angular.module("mc.verizon-rate-plan", []);
'use strict';

function VerizonRatePlanFactory(HOST, $http) {

    var _verizonRatePlan = function _verizonRatePlan() {};

    _verizonRatePlan.prototype.GetDeviceTypesCurrentPlansCustomers = function (wirelessCarrier) {
        return $http({
            method: 'GET',
            url: HOST + '/api/CarrierRatePlan/GetDeviceTypeCarrierPlanAndCustomer/',
            params: { wirelessCarrier: wirelessCarrier }
        });
    };

    _verizonRatePlan.prototype.GetRtuByDeviceTypeCarrierPlanCustomer = function (wirelessCarrier, deviceTypeId, ratePlan, customer) {
        return $http({
            method: 'GET',
            url: HOST + '/api/CarrierRatePlan/GetRtuByDeviceTypeCarrierPlanCustomer/',
            params: { wirelessCarrier: wirelessCarrier, deviceTypeId: deviceTypeId, ratePlan: ratePlan, customer: customer }
        });
    };

    _verizonRatePlan.prototype.GetRtuBySimOrSerialNumber = function (wirelessCarrier, simNumber, serialNumber) {
        return $http({
            method: 'GET',
            url: HOST + '/api/CarrierRatePlan/GetRtuBySimOrSerialNumber/',
            params: { wirelessCarrier: wirelessCarrier, simNumber: simNumber, serialNumber: serialNumber }
        });
    };

    _verizonRatePlan.prototype.GetRtuProvisionLog = function (simNumber, meid) {
        return $http({
            method: 'GET',
            url: HOST + '/api/CarrierRatePlan/GetRtuProvisionLog/',
            params: { simNumber: simNumber, meid: meid }
        });
    };

    _verizonRatePlan.prototype.SuspendSim = function (rtuList) {
        return $http.post(HOST + "/api/CarrierRatePlan/SuspendVerizonRtu/", rtuList);
    };

    _verizonRatePlan.prototype.RestoreSim = function (rtuList) {
        return $http.post(HOST + "/api/CarrierRatePlan/RestoreVerizonRtu/", rtuList);
    };

    _verizonRatePlan.prototype.ActivateSim = function (activateSimInformation) {
        return $http.post(HOST + "/api/CarrierRatePlan/ActivateVerizonRtu/", activateSimInformation);
    };

    _verizonRatePlan.prototype.DeactivateSim = function (rtuList) {
        return $http.post(HOST + "/api/CarrierRatePlan/DeactivateVerizonRtu/", rtuList);
    };

    _verizonRatePlan.prototype.UpdateRtuRatePlan = function (rtuList, ratePlan, wirelessCarrier) {
        return $http.post(HOST + "/api/CarrierRatePlan?ratePlan=" + ratePlan + "&wirelessCarrier=" + wirelessCarrier, rtuList);
    };

    return _verizonRatePlan;
}

VerizonRatePlanFactory.$inject = ['HOST', '$http'];

angular.module('mc.verizon-rate-plan').factory('VerizonRatePlanFactory', VerizonRatePlanFactory);
"use strict";

function VerizonRatePlanController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, VerizonRatePlanFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, $q, $uibModal) {
    var _this2 = this;

    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    ctrl.ratePlanSummary = [];
    ctrl.deviceTypes = [];
    ctrl.currentPlans = [];
    ctrl.customers = [];
    ctrl.customersCopy = [];
    ctrl.requiredRtus = [];
    ctrl.selectedRtus = [];
    ctrl.deactivateRtus = [];
    ctrl.suspendRtus = [];
    ctrl.restoreRtus = [];
    ctrl.initialLetters = [];
    ctrl.updatePlanResult = [];
    ctrl.provisionLogs = [];
    ctrl.displayMode = 0; //0 for displaying RTU search result, 1 for displaying carrier rate plan update result
    ctrl.initialLetterSelected = null;
    ctrl.customerName = null;
    ctrl._verizonRatePlan = null;
    ctrl.allRtuSelected = false;
    ctrl.defaultAddress = false;
    ctrl.tieredAccountDeviceSelected = 0;
    ctrl.activateSimInformation = {
        date: null,
        sim: null,
        ratePlan: null,
        profileName: null,
        street1: null,
        street2: null,
        city: null,
        state: null,
        zip: null,
        customerField1: null,
        customerField2: null,
        customerField3: null,
        customerField4: null,
        customerField5: null
    };

    ctrl.$onInit = function () {
        ctrl._verizonRatePlan = new VerizonRatePlanFactory();
        ctrl.reverse = true;
        //ctrl.provisionLogLoading = false;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.firstOpen = true; //to select the customer of the current site the user is in
        ctrl.deviceType = null;
        ctrl.currentPlan = null;
        ctrl.selectedPlan = null;
        ctrl.numberOfDevices = 0;
        ctrl.initialLetterSelected = ctrl.accountInfo.customerName.charAt(0);
        ctrl.getDeviceTypesCurrentPlansCustomers(); //Get device types and current carrier rate plans for dropdown list

        ctrl.planOptions = ["M2MTIEREDDATA", "1MBSHARE5", "5MBSHARE7"];

        ctrl.profileNames = [{ id: 1, name: "19 NATL" }, { id: 2, name: "20 INTL" }, { id: 3, name: "23 NATL_NOCANMEX" }, { id: 4, name: "(Old)05 NATL" }, { id: 5, name: "(Old)06 INTL" }, { id: 6, name: "(Old)09 NATL_NOCANMEX" }];

        ctrl.initialLetters = {
            "A": "A",
            "B": "B",
            "C": "C",
            "D": "D",
            "E": "E",
            "F": "F",
            "G": "G",
            "H": "H",
            "I": "I",
            "J": "J",
            "K": "K",
            "L": "L",
            "M": "M",
            "N": "N",
            "O": "O",
            "P": "P",
            "Q": "Q",
            "R": "R",
            "S": "S",
            "T": "T",
            "U": "U",
            "V": "V",
            "W": "W",
            "X": "X",
            "Y": "Y",
            "Z": "Z"
        };
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for       

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }
    };

    //Get device types and carrier rate plans for dropdown list
    ctrl.getDeviceTypesCurrentPlansCustomers = function () {
        ctrl._verizonRatePlan.GetDeviceTypesCurrentPlansCustomers("VERIZON").then(function (resp) {
            ctrl.deviceTypes = resp.data.deviceTypes;
            ctrl.currentPlans = resp.data.carrierRatePlans;
            ctrl.customers = resp.data.ratePlanCustomers;
            ctrl.filterCustomers(ctrl.initialLetterSelected);
        });
    };

    //Get RTU by provided device type, carrier rate plan and customer name
    ctrl.getRtuByDeviceTypeCarrierPlanCustomer = function (deviceTypeId, ratePlan, customer) {
        ctrl.requiredRtus = [];
        ctrl.numberOfDevices = 0; //clear selected RTU count when search for new RTU
        ctrl.displayMode = 0;
        ctrl.selectedPlan = null;
        ctrl._verizonRatePlan.GetRtuByDeviceTypeCarrierPlanCustomer("V", deviceTypeId, ratePlan, customer).then(function (resp) {
            ctrl.requiredRtus = resp.data;
            //for (var i = 0; i < ctrl.requiredRtus.length; i++) {
            //    if (ctrl.requiredRtus[i].simNumber === null || ctrl.requiredRtus[i].simNumber === "") {
            //        ctrl.requiredRtus.splice(i, 1);
            //    };
            //}
        });
    };

    //Get RTU by provided SIM number or serial number
    ctrl.getRtuBySimOrSerialNumber = function (simNumber, serialNumber) {
        ctrl.requiredRtus = [];
        ctrl.numberOfDevices = 0; //clear selected RTU count when search for new RTU
        ctrl.displayMode = 0;
        ctrl.selectedPlan = null;
        ctrl._verizonRatePlan.GetRtuBySimOrSerialNumber("V", simNumber, serialNumber).then(function (resp) {
            if (resp.data !== null) {
                ctrl.requiredRtus.push(resp.data);
                ctrl.numberOfDevices = 1;
            }
        });
    };

    //Filter customers based on the initial letter selected 
    ctrl.filterCustomers = function (initialLetter) {
        ctrl.customersCopy = ctrl.customers.filter(function (el) {
            return el.name.startsWith(initialLetter);
        });
        if (ctrl.firstOpen) {
            for (var i = 0; i < ctrl.customersCopy.length; i++) {
                if (ctrl.customersCopy[i].name == ctrl.accountInfo.customerName) ctrl.customerName = ctrl.customersCopy[i];
            }
        };
        ctrl.firstOpen = false;
    };

    ctrl.cleanInputFields = function () {
        ctrl.simNumber = null;
        ctrl.serialNumber = null;
    };

    //Select all RTUs
    ctrl.selectAll = function () {
        var i;
        if (ctrl.allRtuSelected) {
            for (i = 0; i < ctrl.requiredRtus.length; i++) {
                ctrl.requiredRtus[i].isSelected = true;
            }
            ctrl.numberOfDevices = ctrl.requiredRtus.length;
        } else {
            for (i = 0; i < ctrl.requiredRtus.length; i++) {
                ctrl.requiredRtus[i].isSelected = false;
            }
            ctrl.numberOfDevices = 0;
        }
    };

    //Update selected RTUs' carrier rate plan
    ctrl.updateRtuRatePlan = function (selectedPlan) {
        ctrl.selectedRtus = [];
        if (ctrl.allRtuSelected) {
            ctrl.selectedRtus = ctrl.requiredRtus;
        } else {
            for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                if (ctrl.requiredRtus[i].isSelected == true) ctrl.selectedRtus.push(ctrl.requiredRtus[i]);
            }
        }
        var data = {
            rtuList: ctrl.selectedRtus,
            ratePlan: selectedPlan
        };
        ctrl._verizonRatePlan.UpdateRtuRatePlan(ctrl.selectedRtus, selectedPlan, "VERIZON").then(function (resp) {
            ctrl.displayMode = 1;
            ctrl.updatePlanResult = resp.data;
        });
    };

    ctrl.showProvisionLog = function (device, provisionLogs) {
        if (provisionLogs) {
            for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                if (ctrl.requiredRtus[i].simNumber == device.simNumber) ctrl.requiredRtus[i].provisionLogs = null;
            }
        } else {
            //ctrl.provisionLogLoading = true;
            ctrl._verizonRatePlan.GetRtuProvisionLog(device.simNumber, device.meid).then(function (resp) {
                for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                    if (ctrl.requiredRtus[i].simNumber == device.simNumber) ctrl.requiredRtus[i].provisionLogs = resp.data;
                }
                //ctrl.provisionLogLoading = false;
            });
        }
    };

    //used to determine whether to disable activate and deactivate buttons based on the number of RTUs selected
    ctrl.countSelectedDevices = function (item) {
        if (item.isSelected) {
            ctrl.numberOfDevices += 1;
        } else {
            ctrl.numberOfDevices -= 1;
        }
        if (item.ratePlan == "M2MTIEREDDATA" && item.isSelected) {
            ctrl.tieredAccountDeviceSelected += 1;
        } else if (item.ratePlan == "M2MTIEREDDATA" && !item.isSelected) {
            ctrl.tieredAccountDeviceSelected -= 1;
        }
    };

    ctrl.deactivateSim = function () {
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            //this.tmpConfirmMessageA = item.inUse ? _translation.text.DELETE_SERVICE_USER2 : "";
            this.tmpConfirmMessageB = _translation.text.DEACTIVATE_SIM_CONFIRMATION + '?';

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        };

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            ctrl.deactivateRtus = []; //a list of RTUs that would get suspended
            if (ctrl.allRtuSelected) {
                ctrl.deactivateRtus = ctrl.requiredRtus;
            } else {
                for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                    if (ctrl.requiredRtus[i].isSelected == true) ctrl.deactivateRtus.push(ctrl.requiredRtus[i]);
                }
            }

            ctrl._verizonRatePlan.DeactivateSim(ctrl.deactivateRtus).then(function (resp) {
                if (resp.data == true) {
                    alert("Success!");
                } else {
                    alert("Error!");
                }
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.suspendSim = function () {
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            //this.tmpConfirmMessageA = item.inUse ? _translation.text.DELETE_SERVICE_USER2 : "";
            this.tmpConfirmMessageB = _translation.text.SUSPEND_SIM_CONFIRMATION + '?';

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        };

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            ctrl.suspendRtus = []; //a list of RTUs that would get suspended
            if (ctrl.allRtuSelected) {
                ctrl.suspendRtus = ctrl.requiredRtus;
            } else {
                for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                    if (ctrl.requiredRtus[i].isSelected == true) ctrl.suspendRtus.push(ctrl.requiredRtus[i]);
                }
            }

            ctrl._verizonRatePlan.SuspendSim(ctrl.suspendRtus).then(function (resp) {
                if (resp.data == true) {
                    alert("Success!");
                } else {
                    alert("Error!");
                }
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.restoreSim = function () {
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            //this.tmpConfirmMessageA = item.inUse ? _translation.text.DELETE_SERVICE_USER2 : "";
            this.tmpConfirmMessageB = _translation.text.RESTORE_SIM_CONFIRMATION + '?';

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        };

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            ctrl.restoreRtus = []; //a list of RTUs that would get restored
            if (ctrl.allRtuSelected) {
                ctrl.restoreRtus = ctrl.requiredRtus;
            } else {
                for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                    if (ctrl.requiredRtus[i].isSelected == true) ctrl.restoreRtus.push(ctrl.requiredRtus[i]);
                }
            }

            ctrl._verizonRatePlan.RestoreSim(ctrl.restoreRtus).then(function (resp) {
                if (resp.data == true) {
                    alert("Success!");
                } else {
                    alert("Error!");
                }
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.activateSim = function () {
        ctrl.activateSimInformation = {
            date: null,
            sim: null,
            imei: null,
            ratePlan: null,
            profileName: null,
            street1: null,
            street2: null,
            city: null,
            state: null,
            zip: null,
            customerField1: null,
            customerField2: null,
            customerField3: null,
            customerField4: null,
            customerField5: null
        };

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        today = mm + '/' + dd + '/' + yyyy;

        function modalController($uibModalInstance, translation) {
            var _this3 = this;

            this.activateSimInformationArray = [];
            for (var i = 0; i < ctrl.requiredRtus.length; i++) {
                if (ctrl.requiredRtus[i].isSelected == true) {
                    ctrl.activateSimIdentifier = {
                        sim: ctrl.requiredRtus[i].simNumber,
                        imei: ctrl.requiredRtus[i].imei,
                        serialNumber: ctrl.requiredRtus[i].serialNumber,
                        meid: ctrl.requiredRtus[i].meid
                    };
                    this.activateSimInformationArray.push(ctrl.activateSimIdentifier);
                };
            }
            this.date = today;
            this.defaultAddress = false;

            this.translation = translation;
            //this.tmpConfirmMessageA = item.inUse ? _translation.text.DELETE_SERVICE_USER2 : "";
            this.tmpConfirmMessageB = _translation.text.DEACTIVATE_SIM_CONFIRMATION + '?';
            this.ratePlans = ctrl.currentPlans;
            this.profileNames = ctrl.profileNames;
            this.street1 = "3060 C Business Pk Dr";
            this.street2 = null;
            this.city = "Norcross";
            this.state = "GA";
            this.zip = "30071";

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            this.gatherInformation = function (property) {
                switch (property) {
                    case "date":
                        ctrl.activateSimInformation.date = _this3.date;
                        break;
                    case "sim":
                        ctrl.activateSimInformation.sim = _this3.sim;
                        break;
                    case "imei":
                        ctrl.activateSimInformation.imei = _this3.imei;
                        break;
                    case "ratePlan":
                        ctrl.activateSimInformation.ratePlan = _this3.ratePlan.ratePlan;
                        break;
                    //case "profileName":
                    //    ctrl.activateSimInformation.profileName = this.profileName.name;
                    //    break;
                    case "street1":
                        ctrl.activateSimInformation.street1 = _this3.street1;
                        break;
                    case "street2":
                        ctrl.activateSimInformation.street2 = _this3.street2;
                        break;
                    case "city":
                        ctrl.activateSimInformation.city = _this3.city;
                        break;
                    case "state":
                        ctrl.activateSimInformation.state = _this3.state;
                        break;
                    case "zip":
                        ctrl.activateSimInformation.zip = _this3.zip;
                        break;
                    case "customerField1":
                        ctrl.activateSimInformation.customerField1 = _this3.customerField1;
                        break;
                    case "customerField2":
                        ctrl.activateSimInformation.customerField2 = _this3.customerField2;
                        break;
                    case "customerField3":
                        ctrl.activateSimInformation.customerField3 = _this3.customerField3;
                        break;
                    case "customerField4":
                        ctrl.activateSimInformation.customerField4 = _this3.customerField4;
                        break;
                    case "customerField5":
                        ctrl.activateSimInformation.customerField5 = _this3.customerField5;
                        break;
                    case "defaultAddress":
                        ctrl.defaultAddress = _this3.defaultAddress;
                        // ctrl.activateSimInformation.sim = this.sim;
                        // ctrl.activateSimInformation.imei = this.imei;
                        ctrl.activateSimInformation.date = _this3.date;
                        // ctrl.activateSimInformation.serialNumber =  this.serialNumber;
                        ctrl.activateSimInformation.deviceIdentifiers = _this3.activateSimInformationArray;
                        break;
                }
            };
        };

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/carrierrateplan/verizon/verizon-activate-modal-template.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'md',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function () {

            if (ctrl.defaultAddress) {
                ctrl.activateSimInformation.street1 = "3060 C Business Pk Dr";
                ctrl.activateSimInformation.street2 = "";
                ctrl.activateSimInformation.city = "Norcross";
                ctrl.activateSimInformation.state = "GA";
                ctrl.activateSimInformation.zip = "30071";
            }

            ctrl._verizonRatePlan.ActivateSim(ctrl.activateSimInformation).then(function (resp) {
                if (resp.data == true) {
                    alert("Success!");
                } else {
                    alert("Error!");
                }
            });
        }, function () {
            // cancel button
        });
    };

    //Helper to convert large KB values to readable formats
    function byteToString(val) {
        var kb = val;
        kb = +kb.toFixed(0);
        var mb = val / 1000;
        mb = +mb.toFixed(1);
        var gb = val / (1000 * 1000);
        gb = +gb.toFixed(2);

        if (gb >= 1 || gb <= -1) return (gb.toString() + " GB").toString();else if (mb >= 1 || mb <= -1) return (mb.toString() + " MB").toString();else return (kb.toString() + " KB").toString();
    }

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshData();
    });

    ctrl.refreshData = function () {
        ctrl.carrierDataUsage = angular.copy(ctrl.carrierDataUsage);
    };
}

VerizonRatePlanController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'VerizonRatePlanFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', '$uibModal'];
'use strict';

angular.module('mc.verizon-rate-plan').component('verizonRatePlan', {
    controller: VerizonRatePlanController,
    templateUrl: 'ui/carrierrateplan/verizon/verizon-rate-plan-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.blocked-access', []);
'use strict';

angular.module('mc.blocked-access').factory('BlockedUsersFactory', ['$http', 'HOST', function ($http, HOST) {
    var BlockedUsersFactory = {};

    var _getBlockedUsers = function _getBlockedUsers() {
        return $http({
            method: "Get",
            url: HOST + "/api/BlockedUsers",
            cache: false
        });
    };

    BlockedUsersFactory.getBlockedUsersList = _getBlockedUsers;
    return BlockedUsersFactory;
}]);
'use strict';

function BlockedUsersController($, $rootScope, $scope, $location, $element, sharedSetupService, translationService, authenticationService, BlockedUsersFactory, savePdfService) {
    var ctrl = this;
    ctrl.isMcAdmin = false;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.isSuperAdmin = sharedSetupService.isSuperAdmin(ctrl.accountInfo);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.alerts = [];
        ctrl.mobile = $rootScope.mobile;
        ctrl.classicView = $rootScope.classicView;
        var _host = $location.host().toLowerCase();
        ctrl.isProdEvn = _host.startsWith("123Scada") ? true : false;

        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(ctrl);

        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = true;
        ctrl.getBlockedUsers();
    };

    ctrl.getBlockedUsers = function () {
        ctrl.blockedUsers = [];
        BlockedUsersFactory.getBlockedUsersList().then(function (dataFromFactory) {
            ctrl._loading = false;
            ctrl.alerts = [];
            ctrl.blockedUsers = dataFromFactory.data;

            // If we didn't get any items back 
            if (ctrl.blockedUsers.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                ctrl.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        }, function (error) {
            //error
        }).then(function (data) {
            ctrl._loading = false;
        });
    };

    ctrl.savePdf = function () {
        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: 'Blocked Users',
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };
}
angular.module('mc.blocked-access').controller('blockedUsersController', BlockedUsersController);
BlockedUsersController.$inject = ['$', '$rootScope', '$scope', '$location', '$element', 'sharedSetupService', 'translationService', 'authenticationService', 'BlockedUsersFactory', 'savePdfService'];
'use strict';

angular.module('mc.blocked-access').component('blockedUsers', {
    controller: BlockedUsersController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/blockedaccess/blockedusers/blocked-users-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.blocked-access').factory('BlockedMcAdminFactory', ['$http', 'HOST', function ($http, HOST) {
    var BlockedMcAdminFactory = {};

    var _listMcAdmins = function _listMcAdmins(active) {
        return $http({
            method: "Get",
            url: HOST + "/api/BlockedMcAdmins?active=" + active,
            cache: false
        });
    };

    var _blockMcAdmin = function _blockMcAdmin(id) {
        return $http({
            method: "Put",
            url: HOST + "/api/BlockedMcAdmins?id=" + id,
            cache: false
        });
    };

    BlockedMcAdminFactory.listMcAdmins = _listMcAdmins;
    BlockedMcAdminFactory.blockMcAdmin = _blockMcAdmin;
    return BlockedMcAdminFactory;
}]);
'use strict';

function BlockedMcAdminController($, $rootScope, $scope, $element, $location, sharedSetupService, translationService, authenticationService, BlockedMcAdminFactory, savePdfService) {
    var ctrl = this;
    ctrl.isMcAdmin = false;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.isSuperAdmin = sharedSetupService.isSuperAdmin(ctrl.accountInfo);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        var _host = $location.host().toLowerCase();
        ctrl.isProdEvn = _host.startsWith("123Scada") ? true : false;
        ctrl.translation = translationService.translation;
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.alerts = [];
        ctrl.mobile = $rootScope.mobile;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = true;
        ctrl.getBlockedMcAdmin();
        ctrl.getMcAdminActiveUsersList();
    };

    ctrl.getBlockedMcAdmin = function () {
        ctrl.blockedMcAdmin = [];
        BlockedMcAdminFactory.listMcAdmins(false).then(function (dataFromFactory) {
            ctrl._loading = false;
            ctrl.alerts = [];
            ctrl.blockedMcAdmin = dataFromFactory.data;

            // If we didn't get any items back 
            if (ctrl.blockedMcAdmin.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                ctrl.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        }, function (error) {
            //error
        }).then(function (data) {
            ctrl._loading = false;
        });
    };

    ctrl.getMcAdminActiveUsersList = function () {
        ctrl.mcAdminActiveUsers = [];
        BlockedMcAdminFactory.listMcAdmins(true).then(function (dataFromFactory) {
            ctrl.mcAdminActiveUsers = dataFromFactory.data;
        }, function (error) {
            //error
        }).then(function (data) {});
    };

    ctrl.mcAdminInactiveToUser = function () {
        if (ctrl.selectedMcAdminUser && ctrl.selectedMcAdminUser.id) {
            BlockedMcAdminFactory.blockMcAdmin(ctrl.selectedMcAdminUser.id).then(function (dataFromFactory) {
                ctrl._loading = true;
                ctrl.getMcAdminActiveUsersList();
                ctrl.getBlockedMcAdmin();
                ctrl.selectedMcAdminUser = null;
            }, function (error) {
                //error
            }).then(function (data) {});
        }
    };

    ctrl.savePdf = function () {
        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: 'Blocked McAdmin',
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };
}
angular.module('mc.blocked-access').controller('blockedMcAdminController', BlockedMcAdminController);
BlockedMcAdminController.$inject = ['$', '$rootScope', '$scope', '$element', '$location', 'sharedSetupService', 'translationService', 'authenticationService', 'BlockedMcAdminFactory', 'savePdfService'];
'use strict';

angular.module('mc.blocked-access').component('blockedMcAdmin', {
    controller: BlockedMcAdminController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/blockedaccess/blockedmcadmin/blocked-mcadmin-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.blocked-access').factory('BlockedCustomersFactory', ['$http', 'HOST', function ($http, HOST) {
    var BlockedCustomersFactory = {};

    var _fetchAllCustomersList = function _fetchAllCustomersList() {
        return $http({
            method: 'GET',
            url: HOST + '/api/CustomersList/GetAll/'
        });
    };

    var _blockCustomer = function _blockCustomer(customerId) {
        return $http.post(HOST + "/api/BlockedCustomers?customerId=" + customerId);
    };

    var _getBlockedCustomersList = function _getBlockedCustomersList() {
        return $http({
            method: "Get",
            url: HOST + "/api/BlockedCustomers",
            cache: false
        });
    };

    var _updateBlockedCustomer = function _updateBlockedCustomer(customerId) {
        return $http.put(HOST + "/api/BlockedCustomers?customerId=" + customerId);
    };

    BlockedCustomersFactory.fetchAllCustomersList = _fetchAllCustomersList;
    BlockedCustomersFactory.blockCustomer = _blockCustomer;
    BlockedCustomersFactory.getBlockedCustomersList = _getBlockedCustomersList;
    BlockedCustomersFactory.updateBlockedCustomer = _updateBlockedCustomer;
    return BlockedCustomersFactory;
}]);
'use strict';

function BlockedCustomersController($, $rootScope, $scope, $element, $location, sharedSetupService, translationService, authenticationService, BlockedCustomersFactory, savePdfService, $uibModal, toaster) {
    var _this = this;

    var ctrl = this;
    ctrl.isMcAdmin = false;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.isSuperAdmin = sharedSetupService.isSuperAdmin(ctrl.accountInfo);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.alerts = [];
        ctrl.mobile = $rootScope.mobile;

        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(ctrl);

        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = true;
        var _host = $location.host().toLowerCase();
        ctrl.isProdEvn = _host.startsWith("123Scada") ? true : false;
        ctrl.deactivateCustomerButton = document.getElementById('deactivateCustomerButton');
        ctrl.deactivateCustomerButton.disabled = true; //Suspend Button to be disabled  
        ctrl.getCustomersList();
        ctrl.getBlockedCustomersList();
    };

    ctrl.getCustomersList = function () {
        BlockedCustomersFactory.fetchAllCustomersList().then(function (resp) {
            ctrl.customersList = resp.data;
            ctrl._loading = false;
        });
    };

    ctrl.getBlockedCustomersList = function () {
        ctrl.blockedCustomers = [];
        BlockedCustomersFactory.getBlockedCustomersList().then(function (dataFromFactory) {
            ctrl._loading = false;
            ctrl.alerts = [];
            ctrl.blockedCustomers = dataFromFactory.data;

            // If we didn't get any items back 
            if (ctrl.blockedCustomers.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                ctrl.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        }, function (error) {
            //error
        }).then(function (data) {
            ctrl._loading = false;
        });
    };

    // Function to show the dropdown when Customer Name input/select button is clicked
    var showDropdown = function showDropdown() {
        ctrl.customerName.setAttribute("placeholder", "Search ..."); // once drowndown is seen input placeholder should display Filter
        var filter = ctrl.customerName.value.toLowerCase();
        var filteredOptions = ctrl.customersList.filter(function (option) {
            return option.name.toLowerCase().includes(filter);
        });
        ctrl.renderOptions(filteredOptions); // Render filtered options
    };

    // Function to render options in the dropdown list
    ctrl.renderOptions = function (options) {
        ctrl.customerNameDropdownList.innerHTML = ''; // Clear the existing options
        // Assigning customerId and name to optionElement for it to display value in
        options.forEach(function (option) {
            var optionElement = document.createElement('div');
            optionElement.classList.add('dropdownOption');
            optionElement.textContent = option.name;
            optionElement.id = option.customerId; // Store the ID in data attribute
            optionElement.onclick = function () {
                return ctrl.selectOption(option); // returning selected option on selecting value from dropdown
            };
            ctrl.customerNameDropdownList.appendChild(optionElement); // adding each option in the dropdown list
        });
        ctrl.customerNameDropdownList.style.display = options.length ? 'block' : 'none'; // Show or hide dropdown based on options
    };

    ctrl.clearSearchField = function () {
        ctrl.selectedCustomer = null; //Make value null so input field is empty
        ctrl.customerName.value = null; //Make value null so input field is empty
        ctrl.clearFilter = false; // once field is empty Clear Filter icon should hide
    };

    ctrl.filterOptions = function () {
        ctrl.customerName = document.getElementById('customerName'); //calling getElementById here instead of oninit because Customer Name dropdown is seen after selecting Device
        ctrl.customerNameDropdownList = document.getElementById('customerNameDropdownList'); //calling getElementById here instead of oninit because Customer Name dropdown is seen after selecting Device
        //After clicking clear filter icon the input field should open just like it is opened for first time
        ctrl.selectedCustomer = null;
        ctrl.customerName.value = null;
        // ctrl.deactivateCustomerButton = document.getElementById('deactivateCustomerButton');
        ctrl.deactivateCustomerButton.disabled = true; //Suspend Button to be disabled  

        //Call showDropdown() to show list once the input field is clicked
        ctrl.customerName.addEventListener('click', showDropdown);

        // Function to filter options based on search input
        ctrl.filterOption = function (searchText) {
            var filter = searchText.toLowerCase();
            var filteredOptions = ctrl.customersList.filter(function (option) {
                return option.name.toLowerCase().includes(filter);
            });
            ctrl.renderOptions(filteredOptions);
        };

        // Function to handle option selected from the dropdown
        ctrl.selectOption = function (option) {
            ctrl.customerName.value = option.name; // Set search input to selected option name
            ctrl.selectedCustomer = option; //assign option to ctrl.selectedCustomer
            ctrl.customerName.style.backgroundColor = "#f6ff95"; //set the color of the selected value
            ctrl.customerNameDropdownList.style.display = 'none'; // Hide dropdown after selection
            ctrl.deactivateCustomerButton.disabled = false; //Suspend Button to be enabled
        };

        // Alternate way without using oninput by creating event listener to listen everytime we enter something in input box
        ctrl.customerName.addEventListener('input', function () {
            // Adding clear filter icon if length more than 0
            if (ctrl.customerName.value.length > 3) {
                ctrl.clearFilter = true; //Clear Filter icon should be visible if length exceeds 3
            } else {
                ctrl.clearFilter = false; //Clear Filter icon should not be visible if length is below 3
            }
            ctrl.filterOption(ctrl.customerName.value);
        });

        // Hide dropdown if clicked outside of the input and dropdown
        document.addEventListener('click', function (e) {
            if (!e.target.closest('#customerName') && !e.target.closest('#customerNameDropdownList')) {
                // Hide the dropdown and change the input placeholder when clicked outside without selecting value
                ctrl.customerNameDropdownList.style.display = 'none';
                ctrl.customerName.setAttribute("placeholder", "Select");
                ctrl.customerName.style.backgroundColor = "#f6ff95";
            }
        });
    };

    ctrl.blockCustomer = function () {
        if (ctrl.selectedCustomer) {
            BlockedCustomersFactory.blockCustomer(ctrl.selectedCustomer.customerId).then(function (dataFromFactory) {
                ctrl._loading = false;
                ctrl.alerts = [];
                if (dataFromFactory.data == 1) {
                    ctrl.tempObject = {
                        "customerId": ctrl.selectedCustomer.customerId,
                        "customerName": ctrl.selectedCustomer.name,
                        "suspendedBy": ctrl.accountInfo.name,
                        "globalDictionary": true,
                        "createdDate": new Date().toISOString().substring(0, 19)
                    };
                    ctrl.blockedCustomers.unshift(ctrl.tempObject);
                    // ctrl.getBlockedCustomersList();
                    ctrl.clearDropdownValues();
                } else if (dataFromFactory.data == 0) {
                    toaster.pop('warning', translationService.translation.text.WARNING, "Customer Name already exists");
                }
                // ctrl.deactivateCustomerButton = document.getElementById('deactivateCustomerButton');
                ctrl.deactivateCustomerButton.disabled = true; //Suspend Button to be disabled           
            }, function (error) {
                //error
            }).then(function (data) {
                ctrl._loading = false;
            });
        }
    };

    ctrl.unBlockCustomer = function (customer, index) {
        ctrl.alerts = [];
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            this.tmpConfirmMessageA = "Are you sure you want to resume access for " + customer.customerName + "?";

            this.ok = function () {
                $uibModalInstance.close(customer);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this.translation;
                }
            }
        });

        modalInstance.result.then(function (customer) {
            customer.blockStatus = false;
            BlockedCustomersFactory.updateBlockedCustomer(customer.customerId).then(function (dataFromFactory) {
                if (dataFromFactory.data == 1) {
                    ctrl.blockedCustomers.splice(index, 1);
                    if (ctrl.blockedCustomers.length === 0) {
                        ctrl.alerts.push({ msg: "No Data", type: 'info', languageCode: 'NO_DATA' });
                    } else {
                        ctrl.alerts = [];
                    }
                } else if (dataFromFactory.data == 0) {
                    ctrl.getBlockedCustomersList();
                }
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.REMOVE, "Remove Error!");
            });
        }, function () {
            // cancel button
        });
    };

    ctrl.clearDropdownValues = function () {
        ctrl.selectedCustomer = null; //Make value null so input field is empty
        ctrl.customerName = document.getElementById('customerName'); //calling getElementById here instead of oninit because Customer Name dropdown is seen after selecting Device
        ctrl.customerName.value = null; //Make value null so input field is empty
        ctrl.clearFilter = false; // once field is empty Clear Filter icon should hide
    };

    ctrl.savePdf = function () {
        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: 'Blocked Customers',
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };
}
angular.module('mc.blocked-access').controller('blockedCustomersController', BlockedCustomersController);
BlockedCustomersController.$inject = ['$', '$rootScope', '$scope', '$element', '$location', 'sharedSetupService', 'translationService', 'authenticationService', 'BlockedCustomersFactory', 'savePdfService', '$uibModal', 'toaster'];
'use strict';

angular.module('mc.blocked-access').component('blockedCustomers', {
    controller: BlockedCustomersController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/blockedaccess/blockedcustomers/blocked-customers-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.user-info', []);
'use strict';

function UpdateUsernameFactory(HOST, $http) {

    var UpdateUsername = function UpdateUsername(customerId, loginId, username) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/Contact',
            params: { customerId: customerId, loginId: loginId, username: username }
        });
    };

    return {
        UpdateUsername: UpdateUsername
    };
}

UpdateUsernameFactory.$inject = ['HOST', '$http'];

angular.module('mc.user-info').factory('updateUsernameService', UpdateUsernameFactory);
"use strict";

function UpdateUsernameController($, $rootScope, $scope, $location, $timeout, $element, sharedSetupService, openViewService, translationService, authenticationService, updateUsernameService, accountWorkflowService, $window, $uibModal) {
    var ctrl = this;
    ctrl.showLoading = false;
    ctrl.email = { val: "", isValid: false, isMatch: false, matchVal: "" };
    //$scope.alerts = [];
    ctrl.updateUsernameHeading = '';
    ctrl.btnTitle = '';
    ctrl.viewStatus = undefined;

    ctrl.$onChanges = function (changes) {
        if (changes.mobile.currentValue !== changes.mobile.previousValue) {
            // need to hide mobile page-title when in popup mode in classic view
            ctrl.modalMode = angular.isUndefined($element.parents('.ui-widget-content').html()) ? false : true;
        }
    };

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        fetchHeadiingText();

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            //sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({ resizable: false });

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });
        }
        //hiding all the titlebar buttons except 'close'
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-minimize").css("display", "none").parent("li").css("display", "none");
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-maximize").css("display", "none").parent("li").css("display", "none");
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-collapse").css("display", "none").parent("li").css("display", "none");

        angular.element(document).ready(function () {
            $('[rel="uutooltip"]').tooltip({
                animated: 'fade',
                //placement: 'bottom',
                position: { my: "right-5 top", at: "left top" },
                tooltipClass: "custom-tooltip-styling"
            });
        });

        sharedSetupService.viewAutoHeight(ctrl.windowId);
    };

    $scope.adjustSize = function () {
        $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
        $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
    };

    var reset = function reset() {
        ctrl.email = {
            val: ctrl.email.val,
            isValid: false
        };
    };

    ctrl.validate = function () {
        reset();

        //validate email
        var regExpn = /^[a-zA-Z0-9.'_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
        if (regExpn.test(ctrl.email.val)) {
            ctrl.email.isValid = true;
            $('[rel="uutooltip"]').tooltip("disable");
        } else {
            $('[rel="uutooltip"]').tooltip("enable");
        }
    };

    ctrl.validateMatch = function () {

        //validate email Match
        if (ctrl.email.matchVal && ctrl.email.matchVal.length > 0) {
            var regExpn = /^[a-zA-Z0-9.'_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
            //Check Valid
            if (regExpn.test(ctrl.email.matchVal)) {
                //If valid check is match
                ctrl.email.isMatch = ctrl.email.val.toLowerCase() === ctrl.email.matchVal.toLowerCase() ? true : false;
            } else {
                ctrl.email.isMatch = false;
            }
        } else {
            ctrl.email.isMatch = false;
        }
    };

    ctrl.updateUsername = function () {
        if (!ctrl.email.isValid || !ctrl.email.isMatch) return;
        ctrl.email.val = ctrl.email.val.toLowerCase();
        ctrl.showLoading = true;
        updateUsernameService.UpdateUsername(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, ctrl.email.val).then(function (resp) {
            //update accountInfo, as username is updated to email.val
            ctrl.accountInfo.userName = ctrl.email.val;
            ctrl.accountInfo = authenticationService.getAccountInfo(true);
            ctrl.viewStatus = "success";

            //Update Session Info
            var currentSessionInfo = JSON.parse($window.sessionStorage.accountInfo);
            currentSessionInfo.updateUsernameFlag = false;
            $window.sessionStorage.accountInfo = JSON.stringify(currentSessionInfo);

            accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "success");
        }, function (error) {
            $('[rel="uutooltip"]').tooltip("enable");
            if (error.status == 422) {
                //NOTE: HttpStatusCode:422 is custom status code for validating username/password at server side
                ctrl.btnTitle = error.data.message;
            } else {
                ctrl.btnTitle = 'error processing the request.';
            }
            ctrl.showLoading = true;
        });
    };

    $scope.$on('updatePreferencesLanguage', function () {
        fetchHeadiingText();
    });

    var fetchHeadiingText = function fetchHeadiingText() {
        var trnsTxt = ctrl.translation.text.UPDATE_USERNAME_HEADING;
        var conditionTxt = ctrl.accountInfo.updateUsernameFlag == 1 ? ctrl.translation.text.RECOMMENDS : ctrl.accountInfo.updateUsernameFlag == 2 ? ctrl.translation.text.REQUIRES : '';
        ctrl.updateUsernameHeading = trnsTxt.replace('{0}', conditionTxt);
    };

    ctrl.$onDestroy = function () {
        if (ctrl.mobile) return; //we use ctrl.continue() in mobile mode
        accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "close");
    };

    ctrl.continue = function () {
        accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "close");
    };

    ctrl.openCommonModal = function (email, saveUsername) {
        if (!email.isValid || !email.isMatch) return;

        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            if (saveUsername) {
                var usernameChangedToText = ctrl.translation.text.USERNAME_CHANGED_TO;
                var emailHtml = "<b>" + email.val + "</b>";
                usernameChangedToText = usernameChangedToText.replace('{0}', emailHtml);
                this.email = usernameChangedToText;
            }
            this.ok = function () {
                $uibModalInstance.close();
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/account/username/update-username-modal-template.html',
            controller: modalController,
            controllerAs: '$ctrl',
            //size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function () {
            if (saveUsername) {
                ctrl.updateUsername();
            }
        }, function () {
            // cancel button
        });
    };
};

UpdateUsernameController.$inject = ['$', '$rootScope', '$scope', '$location', '$timeout', '$element', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'updateUsernameService', 'accountWorkflowService', '$window', '$uibModal'];
'use strict';

angular.module('mc.user-info').component('updateUsername', {
    controller: UpdateUsernameController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/account/username/update-username-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function RegisterWebinarFactory(HOST, $http) {

    var GetWebinarHeading = function GetWebinarHeading(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/Webinar',
            params: { customerId: customerId }
        });
    };
    var RegisterForWebinar = function RegisterForWebinar(customerId, fields) {
        return $http({
            method: 'POST',
            url: HOST + '/api/Webinar',
            data: fields,
            contentType: 'application/json',
            params: { customerId: customerId }
        });
    };
    var UnRegisterForWebinar = function UnRegisterForWebinar(customerId, email) {
        return $http({
            method: 'DELETE',
            url: HOST + '/api/Webinar',
            params: { customerId: customerId, email: email }
        });
    };
    var OptOutWebinarPopup = function OptOutWebinarPopup(userId, customerId) {
        return $http({
            method: 'POST',
            url: HOST + '/api/Webinar',
            params: { userId: userId, customerId: customerId }
        });
    };

    var userRegisteredToWebinar = {
        "fullName": "",
        "email": ""
    };

    var isPopup = true;

    return {
        GetWebinarHeading: GetWebinarHeading,
        RegisterForWebinar: RegisterForWebinar,
        UnRegisterForWebinar: UnRegisterForWebinar,
        OptOutWebinarPopup: OptOutWebinarPopup,
        userRegisteredToWebinar: userRegisteredToWebinar,
        isPopup: isPopup
    };
}

RegisterWebinarFactory.$inject = ['HOST', '$http'];

angular.module('mc.user-info').factory('registerWebinarService', RegisterWebinarFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RegisterWebinarController($, $rootScope, $scope, $location, $anchorScroll, $timeout, $element, sharedSetupService, openViewService, translationService, authenticationService, registerWebinarService, accountWorkflowService, $window) {
    var ctrl = this;
    ctrl.email = { val: "", isValid: false, isMatch: false, matchVal: "" };
    //$scope.alerts = [];
    ctrl.registerWebinarHeading = '';
    ctrl.btnTitle = '';
    ctrl.viewStatus = undefined;
    ctrl.isValidPhone = true;
    ctrl.isValidEmail = false;
    ctrl.isValidFirstName = false;
    ctrl.isValidLastName = false;
    ctrl.ifError = false; //helps to handle if error occured while registration
    ctrl.isMcAdmin = false;
    ctrl.showOptOutButton = true;

    ctrl.fields = {
        "firstName": "",
        "lastName": "",
        "email": "",
        "city": "",
        "state": "",
        "postalCode": "",
        "phone": "",
        "jobTitle": "",
        "organization": "",
        "responses": []
    };

    ctrl.$onChanges = function (changes) {
        if (changes.mobile.currentValue !== changes.mobile.previousValue) {
            // need to hide mobile page-title when in popup mode in classic view
            ctrl.modalMode = angular.isUndefined($element.parents('.ui-widget-content').html()) ? false : true;
        }
    };

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl._loading = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        if (ctrl.accountInfo.alreadyRegisteredWebinar || ctrl.accountInfo.optOutWebinar) ctrl.showOptOutButton = false;
        if (!registerWebinarService.isPopup) ctrl.showOptOutButton = false;

        fetchHeadingText();

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            //sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({ resizable: false });

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });
        }
        //hiding all the titlebar buttons except 'close'
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-minimize").css("display", "none").parent("li").css("display", "none");
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-maximize").css("display", "none").parent("li").css("display", "none");
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-collapse").css("display", "none").parent("li").css("display", "none");

        loadLoginUserDetails();
        loadStates();
        loadJobDuties();
        validate();

        $timeout(function () {
            $scope.adjustSize();
            ctrl._loading = false;
        }, 2000);
    };

    var loadLoginUserDetails = function loadLoginUserDetails() {
        if (registerWebinarService.userRegisteredToWebinar.email && registerWebinarService.userRegisteredToWebinar.fullName) {
            ctrl.fields.email = registerWebinarService.userRegisteredToWebinar.email;
            ctrl.fields.phone = "";
            ctrl.fields.city = "";
            ctrl.fields.state = "";
            var names = registerWebinarService.userRegisteredToWebinar.fullName.split(" ");
            if (!!names && names.length >= 2) {
                ctrl.fields.firstName = names[0];
                ctrl.fields.lastName = names[1];
            }
            ctrl.fields.zip = "";

            //clear the fields so normal register window won't get affected
            registerWebinarService.userRegisteredToWebinar.email = "";
            registerWebinarService.userRegisteredToWebinar.fullName = "";
        } else {
            ctrl.fields.email = ctrl.accountInfo.email;
            ctrl.fields.phone = ctrl.accountInfo.phone;
            ctrl.fields.city = ctrl.accountInfo.city;
            ctrl.fields.state = ctrl.accountInfo.state;
            var names = ctrl.accountInfo.name.split(" ");
            if (!!names && names.length >= 2) {
                ctrl.fields.firstName = names[0];
                ctrl.fields.lastName = names[1];
            }
            ctrl.fields.zip = ctrl.accountInfo.zip;
        }
    };
    var loadJobDuties = function loadJobDuties() {
        ctrl.jobDuties = [{ "name": "Electrician/Integrator/Installer", "value": "9322342" }, { "name": "Engineer", "value": "9322343" }, { "name": "Field Service/Operations", "value": "9322344" }, { "name": "Management/Purchasing", "value": "9322345" }, { "name": "Sales/Distributor", "value": "9322346" }];
    };
    var loadStates = function loadStates() {
        ctrl.states = [{ "id": "AL", "value": "Alabama" }, { "id": "AK", "value": "Alaska" }, { "id": "AZ", "value": "Arizona" }, { "id": "AR", "value": "Arkansas" }, { "id": "CA", "value": "California" }, { "id": "CO", "value": "Colorado" }, { "id": "CT", "value": "Connecticut" }, { "id": "DE", "value": "Delaware" }, { "id": "DC", "value": "District of Columbia" }, { "id": "FL", "value": "Florida" }, { "id": "GA", "value": "Georgia" }, { "id": "HI", "value": "Hawaii" }, { "id": "ID", "value": "Idaho" }, { "id": "IL", "value": "Illinois" }, { "id": "IN", "value": "Indiana" }, { "id": "IA", "value": "Iowa" }, { "id": "KS", "value": "Kansas" }, { "id": "KY", "value": "Kentucky" }, { "id": "LA", "value": "Louisiana" }, { "id": "ME", "value": "Maine" }, { "id": "MD", "value": "Maryland" }, { "id": "MA", "value": "Massachusetts" }, { "id": "MI", "value": "Michigan" }, { "id": "MN", "value": "Minnesota" }, { "id": "MS", "value": "Mississippi" }, { "id": "MO", "value": "Missouri" }, { "id": "MT", "value": "Montana" }, { "id": "NE", "value": "Nebraska" }, { "id": "NV", "value": "Nevada" }, { "id": "NH", "value": "New Hampshire" }, { "id": "NJ", "value": "New Jersey" }, { "id": "NM", "value": "New Mexico" }, { "id": "NY", "value": "New York" }, { "id": "NC", "value": "North Carolina" }, { "id": "ND", "value": "North Dakota" }, { "id": "OH", "value": "Ohio" }, { "id": "OK", "value": "Oklahoma" }, { "id": "OR", "value": "Oregon" }, { "id": "PA", "value": "Pennsylvania" }, { "id": "RI", "value": "Rhode Island" }, { "id": "SC", "value": "South Carolina" }, { "id": "SD", "value": "South Dakota" }, { "id": "TN", "value": "Tennessee" }, { "id": "TX", "value": "Texas" }, { "id": "UT", "value": "Utah" }, { "id": "VT", "value": "Vermont" }, { "id": "VA", "value": "Virginia" }, { "id": "WA", "value": "Washington" }, { "id": "WV", "value": "West Virginia" }, { "id": "WI", "value": "Wisconsin" }, { "id": "WY", "value": "Wyoming" }, { "id": "PR", "value": "Puerto Rico" }, { "id": "VI", "value": "Virgin Islands" }, { "id": "GU", "value": "Guam" }, { "id": "AB", "value": "Alberta" }, { "id": "BC", "value": "British Columbia" }, { "id": "MB", "value": "Manitoba" }, { "id": "NB", "value": "New Brunswick" }, { "id": "NL", "value": "Newfoundland" }, { "id": "NT", "value": "Northwest Territories" }, { "id": "NS", "value": "Nova Scotia" }, { "id": "NU", "value": "Nunavut" }, { "id": "ON", "value": "Ontario" }, { "id": "PE", "value": "Prince Edward Island" }, { "id": "QC", "value": "Quebec" }, { "id": "SK", "value": "Saskatchewan" }, { "id": "YT", "value": "Yukon" }];
    };

    $scope.adjustSize = function () {
        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            $scope.popup.parent().find('.register-webinar-html-container').css("height", 560);
        }
    };

    var validate = function validate() {
        ctrl.validateName();
        ctrl.validateEmail();
        ctrl.validatePhone();

        //isValid = ctrl.isValidFirstName && ctrl.isValidLastName && ctrl.isValidEmail && ctrl.isValidPhone;
    };

    ctrl.validateName = function () {
        ctrl.isValidFirstName = false;
        ctrl.isValidLastName = false;
        if (angular.isString(ctrl.fields.firstName) && ctrl.fields.firstName.length > 0) ctrl.isValidFirstName = true;
        if (angular.isString(ctrl.fields.lastName) && ctrl.fields.lastName.length > 0) ctrl.isValidLastName = true;
    };
    ctrl.validateEmail = function () {
        ctrl.isValidEmail = false;
        //validate email
        var regExpn = /^[a-zA-Z0-9.'_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
        if (regExpn.test(ctrl.fields.email)) {
            ctrl.isValidEmail = true;
        }
    };
    ctrl.validatePhone = function () {
        ctrl.isValidPhone = false;
        //Check is input is Number, and its length >=10
        if (!ctrl.fields.phone || ctrl.fields.phone.length >= 10 && !isNaN(ctrl.fields.phone)) {

            ctrl.isValidPhone = true;
        }
    };

    ctrl.registerForWebinar = function () {
        if (!!ctrl.selectedState) ctrl.fields.state = ctrl.selectedState.value;
        if (!!ctrl.selectedJobDuty) {
            ctrl.fields.responses = []; //clearing the array
            ctrl.fields.responses.push({
                questionKey: "9322341", //My Primary Job Duty
                answerKey: ctrl.selectedJobDuty.value
            });
        }
        registerWebinarService.RegisterForWebinar(ctrl.accountInfo.customerId, ctrl.fields).then(function (resp) {
            $scope.alerts = [];
            ctrl.ifError = false;
            //console.log(resp.data);
            if (!ctrl.mobile && !ctrl.classicView) {
                //mobile do not have popup to close
                openViewService.closeView("Register Webinar");
            } else if (ctrl.mobile) {
                $location.path("/desktop/desktop");
            } else if (ctrl.classicView) {
                //$scope.alerts.push({ msg: ctrl.duplicateEntryMsg, type: "danger" });
                $location.path("/map/map");
            }
        }, function (error) {
            $scope.alerts = [];
            if (error.status === 409) {
                ctrl.ifError = true;
                if (ctrl.isMcAdmin) {
                    $scope.alerts.push({ msg: ctrl.translation.text.WEBINAR_DUPLICATE_REG_MSG, type: "danger" });
                } else {
                    $scope.alerts.push({ msg: ctrl.translation.text.WEBINAR_DUPLICATE_REG_MSG_NON_ADMIN, type: "danger" });
                }
            } else if (error.status === 403) {
                $scope.alerts.push({ msg: ctrl.translation.text.WEBINAR_NOT_REGISTER + ctrl.translation.text.SERVICE_UNAVAILABLE, type: "danger" });
            } else {
                $scope.alerts.push({ msg: ctrl.translation.text.WEBINAR_NOT_REGISTER, type: "danger" });
            }
            console.log(error.data);

            $timeout(function () {
                $element.find('.register-webinar-html').animate({
                    scrollTop: 0
                }, 'slow');
            }, 0);
        });
    };

    ctrl.unRegisterForWebinar = function () {
        if (!!ctrl.selectedState) ctrl.fields.state = ctrl.selectedState.value;

        registerWebinarService.UnRegisterForWebinar(ctrl.accountInfo.customerId, ctrl.fields.email).then(function (resp) {
            //console.log(resp.data); // do not close, allow user to re-register for webinar
            $scope.alerts = [];
            ctrl.ifError = false;
            $scope.alerts.push({ msg: ctrl.translation.text.WEBINAR_REG_CANCEL_SUC_MSG, type: "success" });
        }, function (error) {
            $scope.alerts = [];
            $scope.alerts.push({ msg: ctrl.translation.text.WEBINAR_UNREGISTER, type: "danger" });
        });
    };

    ctrl.optOutWebinarPopup = function () {
        registerWebinarService.OptOutWebinarPopup(ctrl.accountInfo.userId, ctrl.accountInfo.customerId).then(function (resp) {
            //Update Session Info
            var currentSessionInfo = JSON.parse($window.sessionStorage.accountInfo);
            currentSessionInfo.optOutWebinar = true;
            $window.sessionStorage.accountInfo = JSON.stringify(currentSessionInfo);

            if (!ctrl.mobile && !ctrl.classicView) {
                //mobile do not have popup to close
                openViewService.closeView("Register Webinar");
            } else if (ctrl.mobile) {
                $location.path("/desktop/desktop");
            } else if (ctrl.classicView) {
                //$scope.alerts.push({ msg: ctrl.duplicateEntryMsg, type: "danger" });
                $location.path("/map/map");
            }
        }, function (error) {});
    };

    $scope.$on('updatePreferencesLanguage', function () {
        fetchHeadingText();
    });

    //var getTotalWeekCount = (year, month_number) => {

    //    // month_number is in the range 1..12

    //    var firstOfMonth = new Date(year, month_number - 1, 1);
    //    var lastOfMonth = new Date(year, month_number, 0);

    //    var used = firstOfMonth.getDay() + lastOfMonth.getDate();

    //    return Math.ceil(used / 7);
    //}

    var getWeekNumber = function getWeekNumber(startTime) {
        var d = new Date(startTime);
        var date = d.getDate();
        var day = d.getDay();
        return Math.ceil((date - 1 - day) / 7) + 1;
    };

    var fetchHeadingText = function fetchHeadingText() {

        registerWebinarService.GetWebinarHeading(ctrl.accountInfo.customerId).then(function (resp) {
            if (resp.data.schedule.length > 0) {
                ctrl.registerWebinarHeading = "<u>Upcoming Webinars</u><br>";
                for (var i = 0; i < resp.data.schedule.length; i++) {
                    var weekNumber = GetNthWednesdayOfMonth(resp.data.schedule[i].startTime);
                    ctrl.registerWebinarHeading = ctrl.registerWebinarHeading + (resp.data.schedule[i].startTime + " - " + resp.data.schedule[i].endTime + " EST (Week " + weekNumber + ")<br>");

                    if (i === resp.data.schedule.length - 1) {
                        ctrl.registerWebinarHeading = ctrl.registerWebinarHeading + "<u>Weekly Schedule</u><br>" + resp.data.description.replace(/\n/g, "<br>") + "<hr>";
                    }
                    // let weekNumberFirst = GetNthWednesdayOfMonth(resp.data.schedule[0].startTime);
                    // let weekNumberSecond = GetNthWednesdayOfMonth(resp.data.schedule[1].startTime);
                    // let weekNumberThird = GetNthWednesdayOfMonth(resp.data.schedule[2].startTime);
                    // ctrl.registerWebinarHeading = `<u>Upcoming Webinars</u><br>` +
                    //     `${resp.data.schedule[0].startTime} - ${resp.data.schedule[0].endTime} EST (Week ${weekNumberFirst})<br>` +
                    //     `${resp.data.schedule[1].startTime} - ${resp.data.schedule[1].endTime} EST (Week ${weekNumberSecond})<br>` +
                    //     `${resp.data.schedule[2].startTime} - ${resp.data.schedule[2].endTime} EST (Week ${weekNumberThird})<hr>` +
                    //     `<u>Weekly Schedule</u><br>` +
                    //     resp.data.description.replace(/\n/g, "<br>") + "<hr>";
                }
            }
        }, function (error) {
            $scope.alerts = [];
            $scope.alerts.push({ msg: ctrl.translation.text.WEBINAR_UNAVAILABLE, type: "danger" });
            console.log(error.data);
        });
    };

    var GetNthWednesdayOfMonth = function GetNthWednesdayOfMonth(date) {
        var currtDate = new Date(date);
        var i = 1;
        var d = new Date(date),
            month = d.getMonth(),
            wednesday = [];

        d.setDate(1);

        // Get the first Monday in the month
        while (d.getDay() !== 3) {
            d.setDate(d.getDate() + 1);
        }

        // Get all the other Mondays in the month
        while (d.getMonth() === month) {
            if (d.getDate() == currtDate.getDate()) {
                return i;
            }
            wednesday.push(new Date(d.getTime()));
            d.setDate(d.getDate() + 7);
            i = i + 1;
        }
        return 0;
    };

    ctrl.$onDestroy = function () {
        if (ctrl.mobile) return; //we use ctrl.continue() in mobile mode
        accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "close");
    };

    ctrl.continue = function () {
        accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "close");
    };
};

RegisterWebinarController.$inject = ['$', '$rootScope', '$scope', '$location', '$anchorScroll', '$timeout', '$element', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'registerWebinarService', 'accountWorkflowService', '$window'];
'use strict';

angular.module('mc.user-info').component('registerWebinar', {
    controller: RegisterWebinarController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/account/webinar/register-webinar-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function UpdatePasswordFactory(HOST, $http) {

    var UpdatePassword = function UpdatePassword(customerId, loginId, username, currentPassword, newPassword) {
        currentPassword = rot13(currentPassword + 'sAlTsTrInG');
        newPassword = rot13(newPassword + 'sAlTsTrInG');
        return $http({
            method: 'PUT',
            url: HOST + '/api/Contact',
            params: { customerId: customerId, loginId: loginId, username: username, currentPassword: currentPassword, newPassword: newPassword }
        });
    };

    var rot13 = function rot13(rot13text) {
        var rot13text_rotated = ""; //' the function will return this string
        for (var i = 0, len = rot13text.length; i < len; i++) {
            //' take the next character in the string
            var j = rot13text[i];
            var k = j.charCodeAt(0); // ' find out the character code
            if (k >= 97 && k <= 109) {
                k = k + 13; //' a ... m inclusive become n ... z
            } else if (k >= 110 && k <= 122) {
                k = k - 13; //' n ... z inclusive become a ... m
            } else if (k >= 65 && k <= 77) {
                k = k + 13; //' A ... M inclusive become N ... Z
            } else if (k >= 78 && k <= 90) {
                k = k - 13; //' N ... Z inclusive become A ... M
            }
            rot13text_rotated = rot13text_rotated + String.fromCharCode(k); //'add the current character
        }
        return rot13text_rotated;
    };

    return {
        UpdatePassword: UpdatePassword
    };
}

UpdatePasswordFactory.$inject = ['HOST', '$http'];

angular.module('mc.user-info').factory('updatePasswordService', UpdatePasswordFactory);
"use strict";

function UpdatePasswordController($, $rootScope, $scope, $location, $timeout, $element, sharedSetupService, openViewService, translationService, authenticationService, updatePasswordService, accountWorkflowService, $window) {
    var _this2 = this;

    var ctrl = this;
    ctrl.showLoading = false;
    ctrl.updatePasswordHeading = '';
    ctrl.isValid = false;
    ctrl.viewStatus = undefined;
    ctrl.password = {
        val: "",
        show: false,
        oldPassword: { val: "", show: false },
        confirmPassword: { val: "", show: false }
    };

    ctrl.btnTitle = ""; // save button title is populated with Error Messages
    ctrl.serverErrorMessage = "";

    ctrl.$onChanges = function (changes) {
        // need to hide mobile page-title when in popup mode in classic view
        if (changes.mobile.currentValue !== changes.mobile.previousValue) {
            ctrl.modalMode = angular.isUndefined($element.parents('.ui-widget-content').html()) ? false : true;
        }
    };

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(_this2);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        fetchHeadiingText();

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            //sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({ resizable: false });

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            };
        }
        //hiding all the titlebar buttons except 'close'
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-minimize").css("display", "none").parent("li").css("display", "none");
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-maximize").css("display", "none").parent("li").css("display", "none");
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-collapse").css("display", "none").parent("li").css("display", "none");

        angular.element(document).ready(function () {
            $('[rel="uutooltip"]').tooltip({
                animated: 'fade',
                //placement: 'bottom',
                position: { my: "right-5 top", at: "left top" },
                tooltipClass: "custom-tooltip-styling"
            });
        });
    };

    var reset = function reset() {
        ctrl.isValid = false;
        ctrl.password = {
            val: ctrl.password.val,
            show: ctrl.password.show,
            isValid: false,
            isValidLength: false,
            isValidLetter: false,
            isValidNumber: false,
            isValidNonEmail: false,
            isValidIdentical: false,
            isValidUpperCase: false,
            isValidSpecialCharacter: false,

            oldPassword: {
                val: ctrl.password.oldPassword.val,
                show: ctrl.password.oldPassword.show
            },
            confirmPassword: {
                val: ctrl.password.confirmPassword.val,
                show: ctrl.password.confirmPassword.show
            }
        };
    };

    ctrl.validate = function () {
        reset();
        //$scope.alerts = [];
        ctrl.errorMsg = "";
        ctrl.serverErrorMessage = "";
        var regExpn = void 0;

        var pwdVal = ctrl.password.val;
        if (!pwdVal) return;

        //Validation based on customerId
        if (ctrl.accountInfo.customerId == 546 || ctrl.accountInfo.customerId == 14615) {
            regExpn = /^\s*(?:\S\s*){10,50}$/; //at least 10 to 50 chars
            if (regExpn.test(pwdVal)) {
                ctrl.password.isValidLength = true;
            }
            regExpn = /^(?=.*[A-Z]).*$/; //Validate Uppercase
            if (regExpn.test(pwdVal)) {
                ctrl.password.isValidUpperCase = true;
            }
            regExpn = /\W|_/g; //Validate Special Character
            if (regExpn.test(pwdVal)) {
                ctrl.password.isValidSpecialCharacter = true;
            }
        } else {
            regExpn = /^\s*(?:\S\s*){6,20}$/; //at least 6 to 20 chars
            if (regExpn.test(pwdVal)) {
                ctrl.password.isValidLength = true;
            }
        }

        regExpn = /^(?=.*[a-z]|[A-Z]).*$/; // /^[A-Za-z]+$/; //at least one letter
        if (regExpn.test(pwdVal)) {
            ctrl.password.isValidLetter = true;
        }

        regExpn = /^(?=.*[0-9]).*$/; //at least one number number  
        if (regExpn.test(pwdVal)) {
            ctrl.password.isValidNumber = true;
        }

        if (pwdVal === ctrl.password.confirmPassword.val) {
            //validate both passwords match
            ctrl.password.isValidIdentical = true;
        } else {
            ctrl.errorMsg += ctrl.translation.text.PASSWORD_MATCH_MSG;
        }

        if (pwdVal != ctrl.accountInfo.email) {
            //validate password is not same as Email
            ctrl.password.isValidNonEmail = true;
        }

        //Validate overall password based on customerId
        if (ctrl.accountInfo.customerId == 546 || ctrl.accountInfo.customerId == 14615) {
            if (ctrl.password.isValidLength && ctrl.password.isValidUpperCase && ctrl.password.isValidNumber && ctrl.password.isValidSpecialCharacter && ctrl.password.isValidIdentical) {
                ctrl.password.isValid = true;
            }
        } else {
            regExpn = /^(?=.*[a-z]|[A-Z])(?=.*[0-9])(?=.{6,20}$).*$/; //Validate overall password 
            if (regExpn.test(pwdVal) && ctrl.password.isValidNonEmail && ctrl.password.isValidIdentical) {
                ctrl.password.isValid = true;
            }
        }

        //finally make sure all the input fields on the view are valid 
        if (!angular.isUndefined(ctrl.password.oldPassword.val) && ctrl.password.oldPassword.val.length > 0 && ctrl.password.isValid) {
            ctrl.isValid = true;

            $('[rel="uutooltip"]').tooltip("disable");
        } else {
            ctrl.btnTitle = ctrl.errorMsg;
            $('[rel="uutooltip"]').tooltip("enable");
        }
    };

    ctrl.toggleShowPassword = function () {
        ctrl.password.oldPassword.show = !ctrl.password.oldPassword.show;
        ctrl.password.show = !ctrl.password.show;
        ctrl.password.confirmPassword.show = !ctrl.password.confirmPassword.show;
    };

    ctrl.updatePassword = function () {
        if (!ctrl.isValid) return;
        ctrl.showLoading = true;
        updatePasswordService.UpdatePassword(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, ctrl.accountInfo.userName, ctrl.password.oldPassword.val, ctrl.password.val).then(function (resp) {
            ctrl.viewStatus = "success";
            //Update Session Info
            var currentSessionInfo = JSON.parse($window.sessionStorage.accountInfo);
            currentSessionInfo.updatePasswordFlag = false;
            $window.sessionStorage.accountInfo = JSON.stringify(currentSessionInfo);

            accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "success");
        }, function (error) {
            if (error.status == 422) {
                //NOTE: HttpStatusCode:422 is custom status code for validating username/password at server side
                ctrl.btnTitle = error.data.message;
                ctrl.serverErrorMessage = error.data.message;
            } else {
                ctrl.btnTitle = "error processing the request.";
            }
            ctrl.showLoading = false;
        });
    };

    $scope.$on('updatePreferencesLanguage', function () {
        fetchHeadiingText();
    });

    var fetchHeadiingText = function fetchHeadiingText() {
        var trnsTxt = ctrl.translation.text.UPDATE_PASSWORD_HEADING;
        var conditionTxt = ctrl.accountInfo.updatePasswordFlag == 1 ? ctrl.translation.text.RECOMMENDS : ctrl.accountInfo.updatePasswordFlag == 2 ? ctrl.translation.text.REQUIRES : '';
        ctrl.updatePasswordHeading = ctrl.accountInfo.updatePasswordFlag !== 0 ? trnsTxt.replace('{0}', conditionTxt) : ctrl.translation.text.UPDATE_PASSWORD_HEADING_B;
    };

    ctrl.$onDestroy = function () {
        if (ctrl.mobile) return; //we use ctrl.continue() in mobile mode
        accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "close");
    };

    ctrl.continue = function () {
        accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "close");
    };
};

UpdatePasswordController.$inject = ['$', '$rootScope', '$scope', '$location', '$timeout', '$element', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'updatePasswordService', 'accountWorkflowService', '$window'];
'use strict';

angular.module('mc.user-info').component('updatePassword', {
    controller: UpdatePasswordController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/account/password/update-password-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function UserAccountsController($rootScope, $scope, $location, authenticationService, translationService, sharedSetupService, openViewService, $uibModal, AuthorizedUsersFactory, AuthorizedPortalsFactory) {
    var ctrl = this;
    sharedSetupService.getWindowId(ctrl);
    ctrl.tabConfiguration = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        $scope.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        ctrl.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.stickyProperties.device.title = undefined;
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { windowId: $scope.windowId });

        if (ctrl.accountInfo.userRole !== 'Administrator' && ctrl.accountInfo.userRole !== 'SuperAdministrator') {
            ctrl.readOnlyTW = true;
        }
        ctrl.initializeSetting();
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }

        AuthorizedUsersFactory.getAuthorizedUsers(ctrl.accountInfo.customerId).then(function (dataFromFactory) {
            ctrl.authorizedUsers = dataFromFactory.data;
            // If we get any items then adding it into the existing array.
            if (ctrl.authorizedUsers.length > 0) {
                ctrl.tabConfiguration.splice(1, 0, {
                    "id": "Authorized Users",
                    "name": "Authorized Users",
                    "templateName": "authorized-users-template",
                    "templateUrl": "ui/account/useraccounts/authorizedusers/authorized-users-template.html",
                    "height": 135
                });
            }
            ctrl.userAccountsTabs = ctrl.tabConfiguration;
        }, function (error) {
            //error
        }).then(function (data) {});

        AuthorizedPortalsFactory.getAuthorizedPortals(ctrl.accountInfo.customerId).then(function (dataFromFactory) {
            ctrl.authorizedPortals = dataFromFactory.data;
            // If we get any items then adding it into the existing array.
            if (ctrl.authorizedPortals.length > 0) {
                ctrl.tabConfiguration.splice(1, 0, {
                    "id": "Authorized Portals",
                    "name": "Authorized Portals",
                    "templateName": "authorized-portals-template",
                    "templateUrl": "ui/account/useraccounts/authorizedportals/authorized-portals-template.html",
                    "height": 135
                });
            }
            ctrl.userAccountsTabs = ctrl.tabConfiguration;
        }, function (error) {
            //error
        }).then(function (data) {});
    };

    ctrl.initializeSetting = function () {

        _tabConfiguration({
            "id": "Manage User",
            "name": $scope.translation.text.MANAGE_USER,
            "templateName": "manage-user-template",
            "templateUrl": "ui/account/useraccounts/manageuser/manage-user-template.html",
            "height": 135
        }, {
            "id": "Manage Site Security",
            "name": $scope.translation.text.MANAGE_SITE_SECURITY,
            "templateName": "manage-security-template",
            "templateUrl": "ui/account/useraccounts/managesecurity/manage-security-template.html",
            "height": 135
        });

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.dialog('option', 'title', $scope.translation.text.USER_ACCOUNTS, '[USER NAME]');

            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                ctrl.popup.parent().find('.tab-content').css("height", 'auto');
                ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        } else {
            $location.path('/account/useraccounts/user-accounts-template');
        }
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }
        return 'ui/account/useraccount/' + tab.templateName.toLowerCase().replace(' ', '-') + '-tab.html';
    };

    ctrl.exitWithoutSavingConfirmation = function ($event, $selectedIndex) {

        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            this.tmpConfirmHeader = _translation.text.CONFIRM;
            this.tmpConfirmMessageA = _translation.text.EXIT_WITHOUT_SAVE;
            //this.tmpConfirmMessageB = _translation.text.EXIT_WITHOUT_SAVE;

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        };

        modalController.$inject = ['$uibModalInstance', 'translation'];
    };

    ctrl.selectTab = function (index) {
        ctrl.activeTab = index;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    ctrl.getContainerHeight = function () {
        if ($rootScope.classicView) {
            return 'calc(100% - 15px)';
        } else if ($rootScope.mobile) {
            return 'calc(100% - 38px)';
        }
        return '100%';
    };
};

angular.module('mc.user-accounts').controller('userAccountsController', UserAccountsController);
UserAccountsController.$inject = ['$rootScope', '$scope', '$location', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$uibModal', 'AuthorizedUsersFactory', 'AuthorizedPortalsFactory'];
'use strict';

angular.module('mc.user-accounts').component('userAccounts', {
    controller: 'userAccountsController',
    templateUrl: 'ui/account/useraccounts/user-accounts-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

function UserTermsController($, $rootScope, $scope, $location, $timeout, $element, sharedSetupService, openViewService, translationService, authenticationService, updateUserTermsService, accountWorkflowService, $window) {
    var ctrl = this;
    ctrl.updatePasswordHeading = '';
    ctrl.isValid = false;
    ctrl.viewStatus = undefined;
    ctrl.password = {
        val: "",
        show: false,
        oldPassword: { val: "", show: false },
        confirmPassword: { val: "", show: false }
    };

    ctrl.btnTitle = ''; // save button title is populated with Error Messages

    ctrl.$onChanges = function (changes) {
        // need to hide mobile page-title when in popup mode in classic view
        if (changes.mobile.currentValue !== changes.mobile.previousValue) {
            ctrl.modalMode = angular.isUndefined($element.parents('.ui-widget-content').html()) ? false : true;
        }
    };

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //fetchHeadiingText();

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            //sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({ resizable: false });

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            };
        }
        //hiding all the titlebar buttons except 'close'
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-minimize").css("display", "none").parent("li").css("display", "none");
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-maximize").css("display", "none").parent("li").css("display", "none");
        $element.closest(".ui-dialog").find(".ui-dialog-titlebar-collapse").css("display", "none").parent("li").css("display", "none");

        angular.element(document).ready(function () {
            $('[rel="uutooltip"]').tooltip({
                animated: 'fade',
                //placement: 'bottom',
                position: { my: "right-5 top", at: "left top" },
                tooltipClass: "custom-tooltip-styling"
            });
        });
    };

    ctrl.updateTerms = function () {

        updateUserTermsService.UpdateTerms(ctrl.accountInfo.customerId, ctrl.accountInfo.userId).then(function (resp) {
            //Update Session Info
            var currentSessionInfo = JSON.parse($window.sessionStorage.accountInfo);
            currentSessionInfo.termsAgreedFlag = false;
            $window.sessionStorage.accountInfo = JSON.stringify(currentSessionInfo);

            ctrl.viewStatus = "success";
            accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "success");
        }, function (error) {
            if (error.status == 422) {
                ctrl.btnTitle = error.data.message;
            } else {
                ctrl.btnTitle = "error processing the request.";
            }
        });
    };

    ctrl.$onDestroy = function () {
        if (ctrl.mobile) return; //we use ctrl.continue() in mobile mode
        accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "close");
    };

    ctrl.continue = function () {
        accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "close");
    };

    ctrl.cancel = function () {
        if ($rootScope.mobile) return;
        accountWorkflowService.launchNextView(ctrl.windowId, ctrl.viewStatus, "close");
    };
};

UserTermsController.$inject = ['$', '$rootScope', '$scope', '$location', '$timeout', '$element', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'updateUserTermsService', 'accountWorkflowService', "$window"];
'use strict';

angular.module('mc.user-terms', []);
'use strict';

angular.module('mc.user-terms').component('userTerms', {
    controller: UserTermsController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/account/terms/user-terms-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function UpdateUserTermsFactory(HOST, $http) {

    var UpdateTerms = function UpdateTerms(customerId, loginId) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/account',
            params: { customerId: customerId, loginId: loginId }
        });
    };

    return {
        UpdateTerms: UpdateTerms
    };
}

UpdateUserTermsFactory.$inject = ['HOST', '$http'];

angular.module('mc.user-terms').factory('updateUserTermsService', UpdateUserTermsFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function ManageUserAccountController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, LoginsFactory, $uibModal, $element, $timeout, datetimeService, savePdfService, registerWebinarService, unsavedChangesService, desktopViewListService, toaster) {
    var _this2 = this;

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.isMcAdmin = false;
    ctrl.availableDesktopsOnly = [];

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.editModeIndex = null;
        ctrl.editMode = null;
        ctrl.addMode = null;
        ctrl.myModalTemplate = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.isSuperAdmin = sharedSetupService.isSuperAdmin(ctrl.accountInfo);
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.logins = [];

        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(ctrl);

        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = true;
        ctrl.getLogins();
        ctrl.getDesktops();
        ctrl.validEmail = true;
        ctrl.showTooltip = false;

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    ctrl.dynamicPopover = {
        templateUrl: 'ManageUserAccountPopoverTemplate.html'
    };

    ctrl.getAccessLevelName = function (item) {
        var data = ctrl.roles.filter(function (login) {
            if (login.id == item.accessLevel) {
                //assign lastAccessLevel if unassigned
                item.lastAccessLevel = item.lastAccessLevel ? item.lastAccessLevel : login.id;
                return login;
            }
        });
        //Return Translation for role
        return data.length ? _this2.translation.text['USER_ROLE_' + data[0].id] : _this2.translation.text['USER_ROLE_100'];
    };

    ctrl.getDesktopName = function (item) {
        var data = ctrl.desktops.filter(function (login) {
            if (login.desktopId == item.defaultDesktopID) {
                return login;
            }
        });
        //Return Desktop Name
        return data.length ? data[0].desktopName : _this2.translation.text.NO_DEFAULT;
    };

    ctrl.updateAccessLevel = function (item) {
        _this2._prevName = item.lastAccessLevel;
        //Alert user if accessLevel is being lowered from admin status
        if (item.lastAccessLevel >= 255 & item.accessLevel < 255) {
            ctrl.openCommonModal(item, false);
        } else if (item.lastAccessLevel <= 255 & item.accessLevel == 511 && item.userId != -1) {
            ctrl.openCommonModal(item, false, true);
        }
        //else run patch
        else {
                ctrl.patchData(item, 'accessLevel');
            }

        ctrl.filterOutavailableDesktopsOnly(item);
    };

    ctrl.editingTo = function (name) {
        _this2._prevName = name;
    };

    ctrl.hasOverflow = function () {
        var element = document.getElementById('useraccount-rows');
        if (element.offsetHeight < element.scrollHeight) {
            return true;
        }
        return false;
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    ctrl.getLogins = function () {

        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.getLogins().then(function () {
            ctrl.roles = ctrl.getRoles(_loginsFactory.data.userRoleList);
            ctrl.logins = _loginsFactory.data.loginsInfo;
            ctrl.logins.forEach(function (element) {
                element.invalidEmail = false;
                element.invalidPhone = false;
                element.invalidPin = false;
                element.requirePhone = false;
                element.requirePin = false;
                element.pinStartsWithZero = false;
                element.phonePinDuplicate = false;
                element.pinFailsChecks = false;
                element.phoneFailsChecks = false;
                element.phoneAlertMessage = "";
                element.pinAlertMessage = "";
                element.passwordResetEmailSent = false;
            });
            //Enable View tooltips
            $(document).ready(function () {
                $('.useraccount-container [data-toggle="tooltip"]').tooltip();
            });
        });
    };

    ctrl.getDesktops = function () {
        desktopViewListService.getData(ctrl.accountInfo.customerId).then(function (result) {
            ctrl._loading = false;
            ctrl.desktops = result.data.desktopViews;
            ctrl.desktops.unshift({ desktopId: 0, desktopName: $scope.translation.text.NO_DEFAULT });
        }, function (error) {});
    };

    ctrl.getRoles = function (roles) {
        return ctrl.isMcAdmin ? roles : roles.filter(function (role) {
            return role.id != 100;
        });
    };

    ctrl.patchData = function (item, propertyName) {
        if (item.vxmlPhone == "") {
            item.vxmlPhone = null;
        };
        if (item.vxmlPsw == "") {
            item.vxmlPsw = null;
        };
        //Conditions to not patch Data
        if (item.userId === -1 || item[propertyName] == _this2._prevName) return false;
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;
        if (item.invalidEmail) return false;

        //All conditions passed, patch data
        var tmpServiceUserPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        ctrl.updateValue(item, propertyName);
    };

    ctrl.putData = function (item, propertyName, index) {

        //Conditions to not Put Data
        if (item.userId === -1 || item[propertyName] == _this2._prevName) return false;
        if (item.invalidEmail) return false;
        if (item.invalidPhone || item.requirePhone) return false;
        if (item.invalidPin || item.requirePin) return false;
        if (item.phonePinDuplicate) return false;
        if (item.pinStartsWithZero) return false;

        //All conditions passed, put data
        ctrl.updateUserAccount(item, index);
    };

    ctrl.addNewUser = function () {
        if (ctrl.addMode === -1) return false;

        $timeout(function () {
            $element.find("div[class^='tabular-data-container']").animate({
                scrollTop: 0
            }, 'slow');
        }, 0);

        var newUser = {
            customerId: ctrl.accountInfo.customerId,
            userId: -1,
            email: "",
            fullName: "",
            vxmlPhone: "",
            vxmlPsw: "",
            invalidEmail: false,
            invalidPhone: false,
            invalidPin: false,
            pinStartsWithZero: false,
            requirePhone: false,
            requirePin: false,
            pinFailsChecks: false,
            phoneFailsChecks: false,
            phoneAlertMessage: "",
            pinAlertMessage: "",
            phonePinDuplicate: false,
            superAdministrator: false,
            accessLevel: 63,
            lastAccessLevel: 63,
            sendWelcomeEmail: true,
            defaultDesktopID: 0
        };
        ctrl.logins.unshift(newUser);
        ctrl.editModeIndex = 0;
        ctrl.addMode = -1;
        ctrl.editMode = null;
        ctrl.filterOutavailableDesktopsOnly(ctrl.logins[0]);
    };

    ctrl.saveUserAccount = function (item) {
        if (item.accessLevel == 511) {
            ctrl.openCommonModal(item, false, false, true);
        } else {
            ctrl.postAccount(item);
        }
    };

    ctrl.postAccount = function (item) {
        item.userName = item.email;
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.post(item).then(function (resp) {
            ctrl.logins = resp.data.loginsInfo;
        });
        ctrl.editModeIndex = null;
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.updateUserAccount = function (item, index) {
        item.userName = item.email;
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.put(item).then(function (resp) {
            //If Phone Pin combo is already in use
            if (resp.data == null) {
                item.phonePinDuplicate = true;
                ctrl.pinPhoneAlerts(index);
            };
        });
    };

    ctrl.cancelUser = function (destination) {

        ctrl.editModeIndex = null;
        if (destination.userId === -1) ctrl.logins.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.setEditMode = function (index) {
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = ctrl.editModeIndex === index ? null : index;
        if (ctrl.logins[0].userId === -1) ctrl.logins.splice(0, 1);

        if (ctrl.editModeIndex == null) {
            ctrl.availableDesktopsOnly = ctrl.desktops;
        } else {
            ctrl.filterOutavailableDesktopsOnly(ctrl.logins[index]);
        }
    };

    ctrl.filterOutavailableDesktopsOnly = function (user) {
        if (user.accessLevel > 127) {
            ctrl.availableDesktopsOnly = ctrl.desktops;
        } else {

            desktopViewListService.getDesktopViewUserAccessByLoginId(ctrl.accountInfo.customerId, user.userId).then(function (result) {
                var _tmpList = result.data;
                var _availableDesktopsOnly = ctrl.desktops.filter(function (i, n) {
                    return i.desktopId === 0 || i.createdByLoginId == user.userId || _tmpList.find(function (p) {
                        return p.desktopId == i.desktopId;
                    });
                });

                ctrl.availableDesktopsOnly = _availableDesktopsOnly;
            }, function (error) {
                //error
            });
        }
    };

    ctrl.openRegisterWebinar = function (loginUser) {
        registerWebinarService.isPopup = false;
        registerWebinarService.userRegisteredToWebinar.fullName = loginUser.fullName;
        registerWebinarService.userRegisteredToWebinar.email = loginUser.email;
        var optionsStickyProperties = { windowId: ctrl.windowId };
        var position = null;
        position = { my: 'top+120', at: 'center top', of: window };
        if (!$rootScope.mobile && !$rootScope.classicView) {
            openViewService.openView('Register Webinar', { width: 700, height: 600 }, position, optionsStickyProperties, { minimumWidth: 700, minimumHeight: 600 });
        } else {
            $location.path('/account/webinar/register-webinar-template');
        }
    };

    ctrl.sendResetEmail = function (loginUser, field) {
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        switch (field) {
            case "Username":
                _loginsFactory.sendResetEmail(loginUser, "Username").then(function (resp) {});
                break;
            case "Password":
                _loginsFactory.sendResetEmail(loginUser, "Password").then(function (resp) {
                    toaster.pop('success', 'Request Password Reset', 'Email sent');
                });
                break;
        }
    };
    ctrl.sendWelcomeEmail = function (loginUser) {
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.sendWelcomeEmail(loginUser.userId).then(function (resp) {
            //success
            toaster.pop('success', 'Send Welcome', 'Email sent');
        }, function (error) {
            console.log("failed to send email");
        });
    };

    ctrl.updateDatabaseFlag = function (field, flag, loginUser) {
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.updateDatabaseFlag(field, flag, loginUser).then(function (resp) {
            //success
            var title = "";
            var action = "";

            switch (field) {
                case "2Fa":
                    title = "Two-factor Authentication (2FA) Change";
                    break;
                case "Password":
                    title = "Password Change";
                    break;
                case "Username":
                    title = "Username Change";
                    break;
            }

            switch (field) {
                case "0":
                    action = "No Action";
                    break;
                case "1":
                    action = "Recommended";
                    break;
                case "2":
                    action = "Required";
                    break;
            }
            toaster.pop('success', title, loginUser.fullName + ' (' + loginUser.userName + ')' + action);
        }, function (error) {
            console.log("Failed to updateDatabaseFlag()");
        });
    };

    ctrl.clearSecret = function (loginUser) {

        {
            var fn = function modalController($uibModalInstance, translation) {
                this.translation = _translation;
                this.tmpConfirmMessageA = "Are you sure you want to clear Two-factor Authentication" + "?";

                this.ok = function () {
                    $uibModalInstance.close(event);
                };

                this.cancel = function () {
                    $uibModalInstance.dismiss(event);
                };
            };

            fn.$inject = ['$uibModalInstance', 'translation'];

            var modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
                controller: fn,
                controllerAs: '$ctrl',
                size: 'sm',
                resolve: {
                    translation: function translation() {
                        ctrl.translation;
                    }
                }
            });

            modalInstance.result.then(function (event) {
                event.preventDefault();
                event.stopPropagation();
                var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
                _loginsFactory.clearSecret(loginUser.userId).then(function (resp) {
                    //success
                    toaster.pop('success', 'Two-factor Authentication (2FA)', loginUser.fullName + ' (' + loginUser.userName + ')' + ', Cleared!');
                }, function (error) {
                    console.log("Failed to Clear Two-factor Authentication (2FA)");
                });
            }, function (event) {
                event.preventDefault();
                event.stopPropagation();
                //cancel button
                console.log("cancel");
            });
        }
    };

    ctrl.suspend2Fa = function (loginUser, suspend2FaHours) {
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.suspend2Fa(loginUser.userId, suspend2FaHours).then(function (resp) {
            //success
            toaster.pop('success', 'Two-factor Authentication (2FA)', loginUser.fullName + ' (' + loginUser.userName + ')' + ', Suspended for ' + suspend2FaHours + 'hrs!');
        }, function (error) {
            console.log("Failed to Suspend Two-factor Authentication (2FA)");
        });
    };

    ctrl.checkData = function (propertyName, value) {
        switch (propertyName) {
            case "fullName":
            case "email":
            case "vxmlPhone":
            case "vxmlPsw":
            case "userName":
                return value.length > 0;
            case "administrator":
            case "isMerlin":
            case "accessLevel":
            case "defaultDesktopID":
                return true;
            default:
                return false;
        }
    };

    ctrl.updateValue = function (item, propertyName) {
        var tmpServiceUserPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
        _loginsFactory.patchData(item.userId, tmpServiceUserPatch).then(function (resp) {
            ctrl.resp = resp.data;
            for (var i = 0; i < ctrl.logins.length; i++) {
                if (ctrl.logins[i].userId == resp.data.userId) {
                    ctrl.logins[i].userName = resp.data.userName;
                    ctrl.logins[i].lastAccessLevel = resp.data.accessLevel;
                }
            };
        });
    };

    ctrl.onKeyUpValidate = function (idx) {

        var regExpn = /^("(?:[!#-\[\]-~]|\\[\t -~])*"|[!#-'*+\-/-9=?A-Z\^-~](?:\.?[!#-'*+\-/-9=?A-Z\^-~])*)@([!#-'*+\-/-9=?A-Z\^-~](?:\.?[!#-'*+\-/-9=?A-Z\^-~])*|\[[!-Z\^-~]*\])$/;

        if (ctrl.logins[idx].email.length === 0) {
            ctrl.logins[idx].invalidEmail = false;
        } else if (regExpn.test(String(ctrl.logins[idx].email).toLowerCase())) {

            ctrl.logins[idx].invalidEmail = false;
        } else {

            ctrl.logins[idx].invalidEmail = true;
        }
    };

    ctrl.onKeyUpValidatePhonePin = function (idx) {
        ctrl.onKeyUpValidatePhone(idx);
        ctrl.onKeyUpValidatePin(idx);
        ctrl.isPhonePinDuplicate(idx);
    };

    ctrl.onKeyUpValidatePhone = function (idx) {

        //Set vxmlPhone to "" if value is Null
        if (ctrl.logins[idx].vxmlPhone == null) {
            ctrl.logins[idx].vxmlPhone = "";
        };

        //Check if Pin field is required
        ctrl.onKeyUpValidateRequirePhone(idx);
        ctrl.onKeyUpValidateRequirePin(idx);

        //Check is input is Number, and its length >=10
        if (ctrl.logins[idx].vxmlPhone.toString().length >= 10 && !isNaN(ctrl.logins[idx].vxmlPhone)) {

            ctrl.logins[idx].invalidPhone = false;
        }
        //If phone not required and is empty, no alert displayed
        else if (!ctrl.logins[idx].requirePhone && ctrl.logins[idx].vxmlPhone.toString().length === 0) {

                ctrl.logins[idx].invalidPhone = false;
            }
            //If phone is required and is empty
            else if (ctrl.logins[idx].requirePhone && ctrl.logins[idx].vxmlPhone.toString().length === 0) {

                    ctrl.logins[idx].invalidPhone = false;
                } else {
                    ctrl.logins[idx].invalidPhone = true;
                }

        ctrl.pinPhoneAlerts(idx);
    };

    ctrl.onKeyUpValidateRequirePhone = function (idx) {

        //Set vxmlPsw to "" if value is Null
        if (ctrl.logins[idx].vxmlPsw == null) {
            ctrl.logins[idx].vxmlPsw = "";
        };

        //Check if pin is completed, then require Phone
        if (ctrl.logins[idx].vxmlPsw.toString().length >= 4 && !isNaN(ctrl.logins[idx].vxmlPsw)) {

            //if both are complete require completion of neither
            if (ctrl.logins[idx].vxmlPhone.toString().length >= 10 && !isNaN(ctrl.logins[idx].vxmlPhone)) {
                ctrl.logins[idx].requirePhone = false;
            }
            //else require user to complete phone
            else {
                    ctrl.logins[idx].requirePhone = true;
                }
        } else {
            ctrl.logins[idx].requirePhone = false;
        }
    };

    ctrl.onKeyUpValidatePin = function (idx) {

        //Set vxmlPin to "" if value is Null
        if (ctrl.logins[idx].vxmlPsw == null) {
            ctrl.logins[idx].vxmlPsw = "";
        };

        //Check if Phone field is required
        ctrl.onKeyUpValidateRequirePhone(idx);
        ctrl.onKeyUpValidateRequirePin(idx);
        ctrl.isPhonePinDuplicate(idx);

        //Check pin starts with 0
        if (ctrl.logins[idx].vxmlPsw.toString().length > 0 && ctrl.logins[idx].vxmlPsw.toString()[0] == '0') {

            ctrl.logins[idx].pinStartsWithZero = true;
        } else {
            ctrl.logins[idx].pinStartsWithZero = false;
        }

        //Check is input is Number, and its length = 5
        if (ctrl.logins[idx].vxmlPsw.toString().length >= 4 && !isNaN(ctrl.logins[idx].vxmlPsw)) {

            ctrl.logins[idx].invalidPin = false;
        }
        //If pin not required and is empty, no alert displayed
        else if (!ctrl.logins[idx].requirePin && ctrl.logins[idx].vxmlPsw.toString().length === 0) {

                ctrl.logins[idx].invalidPin = false;
            }
            //If pin is required and is empty
            else if (ctrl.logins[idx].requirePin && ctrl.logins[idx].vxmlPsw.toString().length === 0) {

                    ctrl.logins[idx].invalidPin = false;
                } else {
                    ctrl.logins[idx].invalidPin = true;
                }

        ctrl.pinPhoneAlerts(idx);
    };

    ctrl.onKeyUpValidateRequirePin = function (idx) {

        //Set vxmlPhone to "" if value is Null
        if (ctrl.logins[idx].vxmlPhone == null) {
            ctrl.logins[idx].vxmlPhone = "";
        };

        //Check if phone is completed, then require pin
        if (ctrl.logins[idx].vxmlPhone.toString().length >= 10 && !isNaN(ctrl.logins[idx].vxmlPhone)) {

            //if both are complete require completion of neither
            if (ctrl.logins[idx].vxmlPsw.toString().length >= 4 && !isNaN(ctrl.logins[idx].vxmlPsw)) {
                ctrl.logins[idx].requirePin = false;
            }
            //else require user to complete pin
            else {
                    ctrl.logins[idx].requirePin = true;
                }
        } else {
            ctrl.logins[idx].requirePin = false;
        }
    };

    ctrl.isPhonePinDuplicate = function (idx) {

        //Ensure Values are not Null or empty
        if (ctrl.logins[idx].vxmlPhone && ctrl.logins[idx].vxmlPsw) {

            var duplicateCount = 0;

            //Check for Duplicate Phone/Pin combinations
            ctrl.logins.map(function (login) {
                if (login.vxmlPhone == ctrl.logins[idx].vxmlPhone && login.vxmlPsw == ctrl.logins[idx].vxmlPsw) {
                    duplicateCount++;
                }
            });

            if (duplicateCount >= 2) {
                ctrl.logins[idx].phonePinDuplicate = true;
            }
            //No duplicates
            else {
                    ctrl.logins[idx].phonePinDuplicate = false;
                }
        }
        //No duplicates
        else {
                ctrl.logins[idx].phonePinDuplicate = false;
            }
    };

    //Returns Alert Message
    ctrl.pinPhoneAlerts = function (idx) {

        //Phone Alert Message
        ctrl.logins[idx].phoneFailsChecks = ctrl.logins[idx].invalidPhone || ctrl.logins[idx].requirePhone || ctrl.logins[idx].phonePinDuplicate ? true : true;
        if (ctrl.logins[idx].invalidPhone) {
            ctrl.logins[idx].phoneAlertMessage = ctrl.translation.text.INVALID_PHONE;
        } else if (ctrl.logins[idx].requirePhone) {
            ctrl.logins[idx].phoneAlertMessage = ctrl.translation.text.PHONE_NEEDED;
        } else if (ctrl.logins[idx].phonePinDuplicate) {
            ctrl.logins[idx].phoneAlertMessage = ctrl.translation.text.DUPLICATE_PHONE_PIN;
        } else {
            ctrl.logins[idx].phoneFailsChecks = false;
            ctrl.logins[idx].phoneAlertMessage = "";
        }

        //Pin Alert Message
        ctrl.logins[idx].pinFailsChecks = ctrl.logins[idx].invalidPin || ctrl.logins[idx].requirePin || ctrl.logins[idx].phonePinDuplicate || ctrl.logins[idx].pinStartsWithZero ? true : false;
        if (ctrl.logins[idx].invalidPin) {
            ctrl.logins[idx].pinAlertMessage = ctrl.translation.text.INVALID_PIN;
        } else if (ctrl.logins[idx].requirePin) {
            ctrl.logins[idx].pinAlertMessage = ctrl.translation.text.PIN_NEEDED;
        } else if (ctrl.logins[idx].pinStartsWithZero) {
            ctrl.logins[idx].pinAlertMessage = ctrl.translation.text.PIN_STARTS_WITH_INT;
        } else if (ctrl.logins[idx].phonePinDuplicate) {
            ctrl.logins[idx].pinAlertMessage = ctrl.translation.text.DUPLICATE_PHONE_PIN;
        } else {
            ctrl.logins[idx].pinAlertMessage = "";
            ctrl.logins[idx].pinFailsChecks = false;
        }
    };

    ctrl.formatPhoneNumberDisplay = function (f_val) {
        if (typeof f_val === "undefined" || !f_val) return f_val;
        f_val = f_val.replace(/\D/g, '');
        //f_val = f_val.substring(0, 1) == "1" ? f_val.substring(1, f_val.lenght) : f_val;
        f_val = f_val.length > 10 ? f_val.replace(/(\d{3})(\d{3})(\d{4})(\d{4})/, "($1) $2-$3 ext. $4") : f_val.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        return f_val;
    };

    ctrl.openCommonModal = function (item, deleteUser, superAdminUpdate, newSuperAdmin) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            if (deleteUser) {
                this.tmpConfirmMessageA = this.translation.text.DELETE_ACCOUNT_MESSAGE_A + item.fullName + this.translation.text.DELETE_ACCOUNT_MESSAGE_B;
            } else if (superAdminUpdate) {
                this.tmpConfirmMessageA = this.translation.text.READONLY_ACCOUNT_MESSAGE_A + item.fullName + (' ' + this.translation.text.TO + ' ') + this.translation.text['USER_ROLE_' + item.accessLevel] + ", " + this.translation.text.NEW_SUPER_ADMIN + ".";
            } else if (newSuperAdmin) {
                this.tmpConfirmMessageA = this.translation.text.NEW_USER_PRIVILEGES + " " + item.fullName + (' ' + this.translation.text.TO + ' ') + this.translation.text['USER_ROLE_' + item.accessLevel] + ", " + this.translation.text.NEW_SUPER_ADMIN + ".";
            } else {
                this.tmpConfirmMessageA = this.translation.text.READONLY_ACCOUNT_MESSAGE_A + item.fullName + (' ' + this.translation.text.TO + ' ') + this.translation.text['USER_ROLE_' + item.accessLevel];
            }
            this.tmpConfirmMessageB = this.translation.text.DELETE_ACCOUNT_MESSAGE_C;
            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                if (!deleteUser && !newSuperAdmin) {
                    var index = ctrl.logins.findIndex(function (l) {
                        return l.userId == item.userId;
                    });
                    //Reset access to last value
                    ctrl.logins[index].accessLevel = ctrl.logins[index].lastAccessLevel;
                }

                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            if (deleteUser) {
                var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
                _loginsFactory.delete(item.userId, item.userName).then(function (resp) {
                    var index = ctrl.logins.indexOf(item);
                    if (index !== -1) {
                        ctrl.logins.splice(index, 1);
                    }
                    ctrl.addMode = null;
                    ctrl.editMode = null;
                });
            } else if (newSuperAdmin) {
                ctrl.postAccount(item);
            } else {
                ctrl.patchData(item, 'accessLevel');
            }
        }, function () {
            // cancel button
        });
    };
}

ManageUserAccountController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'LoginsFactory', '$uibModal', '$element', '$timeout', 'datetimeService', 'savePdfService', 'registerWebinarService', 'unsavedChangesService', 'desktopViewListService', 'toaster'];
'use strict';

angular.module('mc.user-info').component('manageUseraccount', {
    controller: ManageUserAccountController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/account/manageusers/manage-useraccount-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.web-user-login', []);
"use strict";

function WebUserLoginFactory(HOST, $http) {

    var WebUserLogin = function WebUserLogin(customerId) {
        this.customerId = customerId;
    };

    WebUserLogin.prototype.getData = function (startDate, endDate) {
        var self = this;
        return $http.get(HOST + "/api/WebUserLogin" + "?customerId=" + this.customerId + "&startDate=" + startDate + "&endDate=" + endDate).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return WebUserLogin;
}

WebUserLoginFactory.$inject = ['HOST', '$http'];

angular.module('mc.web-user-login').factory('WebUserLoginFactory', WebUserLoginFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function WebUserLoginController($scope, $filter, WebUserLoginFactory, sharedSetupService, openViewService, toaster, freeGeoIpService, authenticationService, translationService, $element, savePdfService) {
    var ctrl = this;

    $scope.alerts = [];

    ctrl.$onInit = function () {
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        ctrl.reverse = true;
        ctrl.downloadViewTypeOptions = [1, 2];
        ctrl.customerId = ctrl.accountInfo.customerId;
        ctrl.items = [];
        ctrl.busy = false;
        ctrl.deviceName = '';
        $scope.windowTitle = ctrl.windowTitle;

        ctrl.goSelectReportData(false);

        if (!ctrl.classicView && !ctrl.mobile) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        $scope.updateLanguage();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        $scope.updateLanguage();

        if ($scope.alerts.length > 0) {
            var _msg = eval("ctrl.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
            var _type = $scope.alerts[0].type;
            var _languageCode = $scope.alerts[0].languageCode;
            if (_languageCode.toUpperCase() === 'NO_DATA') {
                // _msg += ': ' + moment($scope.webUserLoginService.start).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.webUserLoginService.end).format('MM/DD/YY, h:mm:ss a');
            }
            $scope.alerts = [];
            $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        }
    });

    $scope.updateLanguage = function () {
        ctrl.items = angular.copy(ctrl.items);
    };

    ctrl.savePdf = function () {

        var windowTitle = $scope.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    var _registerIpAddress = [];
    $scope.getIpLocation = function (obj, $event) {
        //{"ip":"107.7.246.204","country_code":"US","country_name":"United States","region_code":"CA","region_name":"California",
        //"city":"San Francisco","zip_code":"94107","time_zone":"America/Los_Angeles","latitude":37.77,"longitude":-122.394,"metro_code":807}

        ctrl.busy = true;

        if (typeof $($event.target).attr("title") !== "undefined") {
            ctrl.busy = false;
            return;
        }

        var ipExists = _fnIfExistIpAddress(obj.ipAddress);

        if (ipExists >= 0) {
            var dataArr = _registerIpAddress[ipExists];
            ctrl.busy = false;
            $($event.target).attr("title", _fnSetTitle(dataArr));
            return;
        }

        freeGeoIpService.getData(obj.ipAddress).then(function (result) {
            ctrl.busy = false;
            $($event.target).attr("title", _fnSetTitle(result.data));
            _fnRegisterIpAddress(result.data);
        }, function (error) {
            ctrl.busy = false;
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
            $($event.target).attr("title", errormsg);
        });
    };

    var _fnRegisterIpAddress = function _fnRegisterIpAddress(data) {
        var inArray = false;
        for (var i = 0; i < _registerIpAddress.length; i++) {
            if (_registerIpAddress[i].ip == data.ip) {
                //already in
                inArray = true;
            }
        }

        if (inArray == false) {
            _registerIpAddress.push(data);
        }
    };

    var _fnIfExistIpAddress = function _fnIfExistIpAddress(ipAddress) {
        for (var i = 0; i < _registerIpAddress.length; i++) {
            if (_registerIpAddress[i].ip == ipAddress) {
                return i;
            }
        }
        return -1;
    };

    var _fnSetTitle = function _fnSetTitle(dataArr) {
        tmpTxt = "IP Address:   " + "\t" + dataArr.ip;
        tmpTxt = tmpTxt + "\n" + "Country:   " + "\t" + dataArr.country_code + ", " + dataArr.country_name;
        tmpTxt = tmpTxt + "\n" + "Region:    " + "\t" + dataArr.region_code + ", " + dataArr.region_name;
        tmpTxt = tmpTxt + "\n" + "City, Zip:   " + "\t" + dataArr.city + ", " + dataArr.zip_code;
        tmpTxt = tmpTxt + "\n" + "Time Zone: " + "\t" + dataArr.time_zone;

        //https://www.telize.com/geoip/ var tmpTxt = "IP Address:   " + "\t" + dataArr.ip;
        //https://www.telize.com/geoip/ var tmpTxt = tmpTxt + "\n" + "Country:   " + "\t" + dataArr.country_code + ", " + dataArr.country;
        //https://www.telize.com/geoip/ var tmpTxt = tmpTxt + "\n" + "Region:    " + "\t" + dataArr.region_code + ", " + dataArr.region;
        //https://www.telize.com/geoip/ var tmpTxt = tmpTxt + "\n" + "City, Zip:   " + "\t" + dataArr.city + ", " + dataArr.postal_code;
        //https://www.telize.com/geoip/ var tmpTxt = tmpTxt + "\n" + "Time Zone: " + "\t" + dataArr.timezone;
        return tmpTxt;
    };

    $scope.toggle = function ($event) {
        if ($($event.currentTarget).hasClass("active-row")) {
            $($event.currentTarget).removeClass("active-row");
        } else {
            $($event.currentTarget).addClass("active-row");
        }
    };

    $scope.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle + " -- " + ctrl.deviceName, 'View reloading');
        ctrl.goSelectReportData(true);
    };

    ctrl.goSelectReportData = function (isRefresh) {
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }

        ctrl.busy = true;

        if (ctrl.stickyProperties.on != true) {
            //set new start date to be 7 days before end date
            ctrl.stickyProperties.dateMin = new Date(ctrl.stickyProperties.dateMax).setDate(new Date(ctrl.stickyProperties.dateMax).getDate() - 7);
        }

        var numberOfDays = 7,
            varDateRangeStart,
            varDateRangeEnd,
            varDateRangeEndTmp;

        if (ctrl.stickyProperties.on == true) {
            ctrl.stickyProperties.on = false;
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
            varDateRangeEnd = ctrl.myDateRangeEnd;
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeStart = ctrl.myDateRangeStart;
            varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
        } else {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }

        //used for refresh button to reload newest data
        if (isRefresh) {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }

        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: ctrl.windowId });

        ctrl.webUserLoginData = new WebUserLoginFactory(ctrl.customerId);
        ctrl.webUserLoginData.getData(varDateRangeStart, varDateRangeEnd).then(function (result) {
            var tmpItems = result.data;

            tmpItems.forEach(function (item) {
                item.loginTimeSort = new Date(item.loginTime);
                item.duration = ("0" + (item.duration / 24 / 60).toFixed(0)).slice(-2) + ':' + ("0" + parseInt(item.duration / 60 % 24)).slice(-2) + ':' + ("0" + item.duration % 60).slice(-2);
                item.userLocation = (item.userLocation.country + ", " + item.userLocation.city + ", " + item.userLocation.region).replace(", , ", "");
                if (item.userLocation.substr(0, 4) === "US, ") item.userLocation = item.userLocation.substring(4);
                item.missionUserId = item.missionUserId == 0 ? "" : item.missionUserId;
            });

            ctrl.items = tmpItems;
            ctrl.busy = false;
        });
    };

    var orderBy = $filter('orderBy');

    ctrl.order = function (predicate, reverse) {
        switch (predicate) {
            case "userName":
            case "customerName":
            case "missionUserId":
            case "missionUserName":
                $scope.sortLoginTime = reverse ? 'loginTimeSort' : '-loginTimeSort';
                ctrl.items = orderBy(ctrl.items, [predicate, $scope.sortLoginTime], reverse);
                break;
            default:
                ctrl.items = orderBy(ctrl.items, predicate, reverse);
                break;
        }
        $scope.predicate = predicate;
    };

    $scope.setSorting = function () {
        ctrl.order('loginTimeSort', ctrl.reverse);
    };
};

WebUserLoginController.$inject = ['$scope', '$filter', 'WebUserLoginFactory', 'sharedSetupService', 'openViewService', 'toaster', 'freeGeoIpService', 'authenticationService', 'translationService', '$element', 'savePdfService'];

mcapp.factory('freeGeoIpService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function getData(varParm) {
            return $http({
                method: 'GET',
                url: 'http://api.ipstack.com/' + varParm + '&access_key=6f4282bee48a7d4d9e635b5040ba2b86',
                cache: false
            });
        }
    };
}]);
'use strict';

angular.module('mc.web-user-login').component('webUserLogin', {
    controller: WebUserLoginController,
    templateUrl: 'ui/webuserlogin/web-user-login-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
angular.module('webSocketModule', [])
.controller('web-socket-controller', ["$scope", "$rootScope", "$interval", function ($scope, $rootScope, $interval) {
    $scope.myForm = {};
    $scope.myForm.userid = "nedn";
    $scope.myForm.password = "nedn";
    $scope.myForm.serialnumber = "689M810585";
    $scope.socketOn = false;
    $interval(function () {
        if (typeof $rootScope.ws != "undefined") {
            $scope.socketOn = true;
        }
    }, 5000);
}])
 .directive('drawWebSocket', function() {
     return {
         templateUrl: 'ui/websocket/web-socket-directive-template.html'
     };
 });


angular.module("mc.wizard", []);
function WizardController($scope, $rootScope, deviceMenuService, rtuDataService, authenticationService) {
    var ctrl = this;
    var DEBUG = false;
    ctrl.stepObject = {};
    ctrl.stepObject.step1 = {'active':true, 'done':false};
    ctrl.stepObject.step2 = {'active':false, 'done':false};
    ctrl.stepObject.step3 = {'active':false, 'done':false};
    ctrl.stepObject.step4 = {'active':false, 'done':false};
    ctrl.stepObject.step5 = {'active':false, 'done':false};
    ctrl.stepObject.step6 = {'active':false, 'done':false};
    ctrl.blEditCalendar = true;
    ctrl.stage = 'stage1';
    ctrl.availableDevices = [];
    ctrl.selectedDevice = '';
    var staticStep = 1;
    ctrl.accountInfo = authenticationService.getAccountInfo();

    ctrl.getDevices = function(arg) {

     deviceMenuService.getDeviceMenuList(arg)
                  .then(function (datafromFactory) {
                		ctrl.availableDevices = datafromFactory.data.devices;
                  },function (error) {

                  });

       console.log(ctrl.availableDevices);

    }

    ctrl.selectDevice = function() {
      var hello = rtuDataService.getData(ctrl.accountInfo.customerId, ctrl.selectedDevice)
    }

    ctrl.nextStep = function(stage, currentNumber, stepNumber) {
      ctrl.stepObject['step'+currentNumber].done = true;
      if(stepNumber <= 6){
        ctrl.stepObject['step'+stepNumber].active = true;
      }
      ctrl.direction = 1;
      ctrl.stage = stage;
    }

    ctrl.backStep = function(stage, backNumber, currentNumber) {
      if(currentNumber <=6){
        ctrl.stepObject['step'+currentNumber].active = false;
        ctrl.stepObject['step'+currentNumber].done = false;
      }
      ctrl.stepObject['step'+backNumber].done = false;
      ctrl.stepObject['step'+backNumber].active = true;
      ctrl.direction = 0;
      ctrl.stage = stage;

    }

    ctrl.complete = function () {
      $rootScope.wizard = false;
       _this.getExistingDialog(ctrl.windowId).ref.dialog("close");
    }

    ctrl.getDevices(ctrl.accountInfo.customerId);
};

WizardController.$inject = ['$scope', '$rootScope', 'deviceMenuService', 'rtuDataService','authenticationService']
angular.module('mc.wizard').component('wizard', {
    controller: WizardController,
    templateUrl: 'ui/wizard/wizard-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<'
    }
});
mcapp.controller('weatherController', ['$scope', '$rootScope', 'authenticationService', 'openViewService', 'sharedSetupService', 'translationService', function ($scope, $rootScope, authenticationService, openViewService, sharedSetupService, translationService) {
    $scope.weatherViewMode = openViewService.getWeatherViewMode();
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.translation = translationService.translation;
    $scope.languageID = $scope.accountInfo.preferenceUser.lookupLanguageID;
    $scope.country = $scope.accountInfo.customerCountry;
    $scope.flgWeatherForecasts = $scope.country == "US" ? true : false;
    $scope.alerts = [];
    $scope.loadingInProgress = true;
    $scope.toggleForecasts = false;
    $scope.scroll = 0;
    $scope.popup = _this.getExistingDialog($scope.windowId).ref;
    $scope.weatherCodeInfoIconPath = "images/metarweathercodes/";
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;

    $scope.fontSize = "larger";
    $scope.borderWidth = "auto";
    $scope.divHtmlWidth1 = "30%";
    $scope.divHtmlWidth2 = "70%";
    $scope.divHtmlWidth3 = "0%";
    $scope.divHtmlWidth4 = "0%";
    $scope.divForecastHeight = "120px";
    $scope.adjustViewHeight = 50;
    if ($scope.weatherViewMode == "Lg") {
        $scope.fontSize = "";
        $scope.borderWidth = "0px";
        $scope.divHtmlWidth1 = "20%";
        $scope.divHtmlWidth2 = "26%";
        $scope.divHtmlWidth3 = "30%";
        $scope.divHtmlWidth4 = "24%";
        $scope.divForecastHeight = "170px";
        $scope.adjustViewHeight = 200;
    }

    $scope.getText = function (text) {
        if (!angular.isDefined(text)) return;
        return typeof eval("$scope.translation.text." + text.toUpperCase().replace(/ /g, "_")) !== 'undefined' ? eval("$scope.translation.text." + text.toUpperCase().replace(/ /g, "_")) : text;
    };

    $scope.closeWeather = function () {
        openViewService.setWeatherViewMode();
        $scope.popup.dialog("close");
    };

    $scope.fnChangeLanguage = function () {
        $scope.findDays = $scope.fnFindDays($scope.forecasts.forecastText);
    };
}]);

mcapp.directive('drawWeatherSm', ['$rootScope', '$timeout', 'weatherSmService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'sharedSetupService', '$sce', 'weatherShareService', 'translationService', function ($rootScope, $timeout, weatherSmService, datetimeService, websocketService, timeLapseService, toaster, sharedSetupService, $sce, weatherShareService, translationService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        var myVar;
        var titleHiding = false;
        var _expanded = scope.stickyProperties.view.expanded;
        function myFunction() {
            myVar = setTimeout(function () {
                titleHiding = true;
                if (scope.weatherViewMode == "Lg")
                    element.next().find('div:eq(1)').css("height", parseInt(element.next().find('div:eq(1)').css("height").replace(/[^0-9.]+/g, "")) + 20);
                scope.popup.parent().find(".ui-dialog-titlebar").hide("slow");
            }, 1000);
        }
        function myStopFunction() {
            clearTimeout(myVar);
        }
        scope.popup.parent().css("overflow", "hidden");
        scope.popup.parent().find(".ui-dialog-content").css("padding", "0px");
        //scope.popup.parent().find(".ui-dialog-titlebar").hide();
        //scope.popup.parent().find(".ui-dialog-content,.ui-dialog-titlebar").mouseenter(function () {
        //        myStopFunction();
        //        if (scope.weatherViewMode == "Lg" && scope.toggleForecasts && (scope.popup.parent().find(".ui-dialog-titlebar").css("display") == 'none' || titleHiding))
        //            element.next().find('div:eq(1)').css("height", parseInt(element.next().find('div:eq(1)').css("height").replace(/[^0-9.]+/g, "")) - 20);
        //        scope.popup.parent().find(".ui-dialog-titlebar").show("fast");
        //        titleHiding = false;
        //    }).mouseleave(function () {
        //        //if (!scope.toggleForecasts)
        //            myFunction();
        //        });

        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

        var _getData = function () {
              //scope.loadingInProgress = true;
              weatherSmService.getData('customerID=' + scope.accountInfo.customerId).then(function (datafromFactory) {
                scope.metarStationInfo = datafromFactory.data.metarStationInfo;
                scope.metarStationReport = datafromFactory.data.metarStationReport;
                if (scope.metarStationReport == null) scope.closeWeather();
                scope.forecasts = datafromFactory.data.forecasts;
                scope.flgWeatherForecasts = scope.forecasts.forecastText == null ? false : scope.flgWeatherForecasts;
                scope.findDays = scope.fnFindDays(scope.forecasts.forecastText);
                scope.findForecast = scope.fnFindForecast(scope.forecasts.forecastText);
                scope.weatherLeftFloaterWidth = scope.popup.parent().css("width").replace(/[^0-9.]+/g, "")/3;
                if (scope.findDays)
                    scope.weatherFloatWrapWidth = scope.findDays.length * scope.weatherLeftFloaterWidth; // + 2;
                var _forecastText = scope.forecasts.forecastText;
                if (_forecastText != null) {
                    var _testRxTime = _forecastText.match(/<br>.*<hr>/);
                    if (_testRxTime[0].length > 32) {  //Dave's new URL fetching - different time format
                        _testRxTime = _testRxTime[0].replace(/<br> /, '').replace(/<hr>/, '');
                        var _testRxTime_four = _testRxTime.substring(0, 3).trim();
                        var a = _testRxTime_four;
                        var b = ":";
                        var position = _testRxTime_four.length == 3 ? 1 : 2;
                        a = [a.slice(0, position), b, a.slice(position)].join('');
                        _forecastText = _forecastText.replace(/:<\/b><br>.*<hr>/, ':<\/b><br>' + _testRxTime.replace(_testRxTime_four, a) + '<hr>');
                    }
                }
                scope.htmlForecastText = $sce.trustAsHtml(_forecastText);
                scope.weatherCodeInfo = datafromFactory.data.weatherCodeInfo;
                if (scope.weatherCodeInfo != null)
                    scope.weatherCodeInfoIcon = scope.weatherCodeInfoIconPath + weatherShareService.getWeatherCodeInfoIcon(scope.weatherCodeInfo.dayTimeIcon, scope.weatherCodeInfo.nightTimeIcon);
                if (scope.metarStationReport != null) {
                    scope.metarStationReport.wind = scope.metarStationReport.wind.replace(/ *\([^)]*\) */g, " ");
                    scope.loadingInProgress = false;
                } else {
                    scope.loadingInProgress = true;
                }
                if (scope.weatherCodeInfo != null && scope.metarStationReport != null)
                    weatherShareService.setWeatherData(scope.metarStationReport.temperature, scope.weatherCodeInfoIcon);
                if (_expanded == 1) {
                    _expanded = 0;
                    $timeout(function () { scope.toggleForecastsFn(); }, 0);
                }

            },function (error) {
                scope.alerts = [];
                element.empty();
                scope.loadingInProgress = false;
                var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                scope.alerts.push({ msg: errormsg, type: "danger" });
                scope.loadingInProgress = false;
            });
        };

         scope.toggleForecastsFn = function () {
             scope.toggleForecasts = !scope.toggleForecasts;
             var _view = { expanded: (scope.toggleForecasts ? 1 : 0) };
             sharedSetupService.setStickyProperties(scope.stickyProperties, { view: _view, windowId: scope.windowId });
            if (scope.toggleForecasts) {
                element.css("height", parseInt(element.css("height").replace(/[^0-9.]+/g, "")));
                scope.popup.parent().css("height", parseInt(scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")) + scope.adjustViewHeight).css("height", "auto");
                scope.popup.parent().find(".ui-dialog-content").css("height", parseInt(scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")) + scope.adjustViewHeight).css("height", "auto");
            }
            else {
                element.css("height", parseInt(element.css("height").replace(/[^0-9.]+/g, "")));
                scope.popup.parent().find(".ui-dialog-content").css("height", parseInt(scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")) - scope.adjustViewHeight).css("height", "auto");
                scope.popup.parent().css("height", parseInt(scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")) - scope.adjustViewHeight).css("height", "auto");
            }
        };

        //Run when initialized to ensure height is correct on sm & lg
        scope.toggleForecasts = true;
        scope.toggleForecastsFn();

         scope.fnFindDays = function (varHtml) {
            if (varHtml == null) return;
            var result = varHtml.match(/<b>(.*?)<\/b>\.\.\./g).map(function (val) {
                return scope.getText(val.replace(/<\/?b>/g, '').replace("...", ''));
            });
            return result;
        };

         scope.fnFindForecast = function (varHtml) {
            if (varHtml == null) return;
            varHtml = varHtml + "<br>";
            var result = varHtml.match(/<\/b>\.\.\.(.*?)\<br>/g).map(function (val) {
                return val.replace(/<\/b>\.\.\./g, '').replace("<br>", '');
            });
            return result;
        };


        scope.fnScrollForecastLeft = function () {
            $('.weather-outer').animate({
                scrollLeft: '0'
            }, 700, 'easeOutQuad');
            scope.scroll = 0;
        };

        scope.fnScrollForecastRight = function () {
            $('.weather-outer').animate({
                scrollLeft: '+=' + (scope.weatherLeftFloaterWidth + 1.5)
            }, 700, 'easeOutQuad');
            scope.scroll++;
        };

        //scope.getWeatherCodeInfoIcon = function () {
        //    return scope.weatherCodeInfo.dayTimeIcon;
        //    return scope.weatherCodeInfo.nightTimeIcon;
        //};

        scope.getForecastIcon = function (varIndex) {
            var g = null;
            if (scope.findDays[varIndex].toLowerCase().indexOf("night") > -1) {
                g = "wxclearnight.gif";
            }
            else {
                g = "wxclearday.gif";
            }

            if (scope.findForecast[varIndex].toLowerCase().indexOf("shower") > -1 && scope.findForecast[varIndex].toLowerCase().indexOf("thunderstorm") > -1) {
                if (scope.findDays[varIndex].toLowerCase().indexOf("night") > -1) {
                    g = "wxthundernight.gif";
                }
                else {
                    g = "wxthunderday.gif";
                }
            } else if (scope.findForecast[varIndex].toLowerCase().indexOf("partly cloudy") > -1) {
                if (scope.findDays[varIndex].toLowerCase().indexOf("night") > -1) {
                    g = "wxcloudnight.gif";
                }
                else {
                    g = "wxpartcloudyday.gif";
                }
            } else if (scope.findForecast[varIndex].toLowerCase().indexOf("decreasing clouds") > -1) {
                if (scope.findDays[varIndex].toLowerCase().indexOf("night") > -1) {
                    g = "wxcloudnight.gif";
                }
                else {
                    g = "wxmostcloud.gif";
                }
            } else if (scope.findForecast[varIndex].toLowerCase().indexOf("increasing clouds") > -1) {
                if (scope.findDays[varIndex].toLowerCase().indexOf("night") > -1) {
                    g = "wxcloudnight.gif";
                }
                else {
                    g = "wxcloudyday.gif";
                }
            } else if (scope.findForecast[varIndex].toLowerCase().indexOf("mostly cloudy") > -1) {
                if (scope.findDays[varIndex].toLowerCase().indexOf("night") > -1) {
                    g = "wxcloudnight.gif";
                }
                else {
                    g = "wxmostcloud.gif";
                }
            } else if (scope.findForecast[varIndex].toLowerCase().indexOf("mostly clear") > -1) {
                if (scope.findDays[varIndex].toLowerCase().indexOf("night") > -1) {
                    g = "wxclearnight.gif";
                }
                else {
                    g = "wxpartsunnyday.gif";
                }
            } else if (scope.findForecast[varIndex].toLowerCase().indexOf("cloudy") > -1 && scope.findForecast[varIndex].toLowerCase().indexOf("rain") > -1) {
                if (scope.findDays[varIndex].toLowerCase().indexOf("night") > -1) {
                    g = "wxrainnight.gif";
                }
                else {
                    g = "wxrainday.gif";
                }
            } else if (scope.findForecast[varIndex].toLowerCase().indexOf("cloudy") > -1) {
                if (scope.findDays[varIndex].toLowerCase().indexOf("night") > -1) {
                    g = "wxcloudnight.gif";
                }
                else {
                    g = "wxcloudyday.gif";
                }
            } else if (scope.findForecast[varIndex].toLowerCase().indexOf("rain") > -1) {
                if (scope.findDays[varIndex].toLowerCase().indexOf("night") > -1) {
                    g = "wxrainnight.gif";
                }
                else {
                    g = "wxrainday.gif";
                }
            }
            //switch (varIndex) {
            //    case 0:
            //        g = "wxclearday.gif";
            //        break;
            //    case 1:
            //        g = "wxmostcloud.gif";
            //        break;
            //    case 2:
            //        g = "wxthunderday.gif";
            //        break;
            //    case 3:
            //        g = "wxclearday.gif";
            //        break;
            //    case 4:
            //        g = "wxthunderday.gif";
            //        break;
            //    case 5:
            //        g = "wxclearday.gif";
            //        break;
            //    default: //case 'undefined':
            //        g = "wxclearday.gif"
            //}

            //if (varIndex == 0 || varIndex == 4) {
            //return scope.weatherCodeInfoIconPath + "316.GIF";
            //}
            //if (varIndex == 1 || varIndex == 5) {
            //    return scope.weatherCodeInfoIconPath + "314.GIF";
            //}
            //if (varIndex == 3) {
            //    return scope.weatherCodeInfoIconPath + "310.GIF";
            //}
            //if (varIndex == 2) {
            //    return scope.weatherCodeInfoIconPath + "315.GIF";
            //}
            //else {
            //    return scope.weatherCodeInfoIconPath + "310.GIF";
            //}

            return scope.weatherCodeInfoIconPath + g;
        };

        setTimeout(function () {
            $(element).siblings().find("img").tooltip();
        }, 1000);

        scope.fnForecastDayNight = function (varDay) {
            if (varDay.toLowerCase().indexOf("night") > -1) {
                return "forecast-night-bg";
            }
            else {
                return "forecast-day-bg";
            }
        };

        var tlDataReceivedWEATHER = function (data) {
            _getData();
        };


        var _registerListener = function () {
            timeLapseService.register("WEATHER", 0, "", tlDataReceivedWEATHER, 10);
        };

        var _unRegisterListener = function () {
            timeLapseService.unRegister("WEATHER", 0, "", tlDataReceivedWEATHER, 10);
        };

        scope.$on('updatePreferenceWeather', function (event, args) {
            _getData();
        });

        _getData();
        _registerListener();

        scope.$on("$destroy", function () {
            _unRegisterListener();
        });
    };
}]);

mcapp.factory('weatherSmService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/WeatherSm?' + varParm + "&" + new Date().getTime(),
                cache: false
            });
        }
    };
}]);

mcapp.factory('weatherShareService', function () {
    var data = {
        temperature: '',
        weatherCodeInfoIcon: ''

    };
    return {
        getWeatherData: function () {
            return data;
        },
        setWeatherData: function (temperature, weatherCodeInfoIcon) {
            data.temperature = temperature;
            data.weatherCodeInfoIcon = weatherCodeInfoIcon;
        },
        getWeatherCodeInfoIcon: function (varDayIcon, varNightIcon) {
            var m = moment();
            var g = null; //return g

            if (!m || !m.isValid()) { return; } //if we can't find a valid or filled moment, we return.

            var split_night = 6 //24hr time to split the night
            var split_afternoon = 12 //24hr time to split the afternoon
            var split_evening = 17 //24hr time to split the evening
            var currentHour = parseFloat(m.format("HH"));

            if (currentHour >= split_night && currentHour <= split_afternoon) {
                //"morning"
                g = varDayIcon;
            } else if (currentHour >= split_afternoon && currentHour <= split_evening) {
                //"afternoon"
                g = varDayIcon;
            } else if (currentHour >= split_evening && currentHour <= split_night) {
                //"evening"
                g = varNightIcon;
            } else {
                //"night"
                g = varNightIcon;
            }
            return g;//"315.GIF";
        }
    };
});

mcapp.factory('weatherSevereService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/SevereWeather?' + varParm,
                cache: false
            });
        }
    };
}]);
"use strict";

function VolumetricFlowSummaryFactory(HOST, $http) {

    // instantiate our initial object
    var VolumetricFlowSummary = function VolumetricFlowSummary(customerId, deviceId, startDate, endDate, timeZone) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.startDate = startDate;
        this.endDate = endDate;
        this.timeZone = timeZone;
        this.deviceId = deviceId;
    };

    VolumetricFlowSummary.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + "/api/VolumetricFlowTable" + "?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&startDate=" + this.startDate + "&endDate=" + this.endDate).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    VolumetricFlowSummary.prototype.getChartData = function () {
        var self = this;
        return $http.get(HOST + "/api/VolumetricFlowSummaryChart" + "?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&startDate=" + this.startDate + "&endDate=" + this.endDate).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return VolumetricFlowSummary;
}

VolumetricFlowSummaryFactory.$inject = ['HOST', '$http'];

angular.module('mc.volumetricflowsummary').factory('VolumetricFlowSummaryFactory', VolumetricFlowSummaryFactory);
'use strict';

function VolumetricFlowSummaryDeviceController($, $scope, authenticationService, translationService, deviceMenuService, sharedSetupService) {
    var _this = this;

    var ctrl = this;
    this.$onInit = function () {
        _this.translation = translationService.translation;
        _this.windowId = _this.windowId;
        $scope.windowId = _this.windowId;
        _this.accountInfo = authenticationService.getAccountInfo();
        ctrl.deviceList = [];
        ctrl.dynamicPopover = { templateUrl: 'volFlowDeviceSelectionTemplate.html' };
        ctrl.showMenu = false;

        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            angular.forEach(result.data.devices, function (value, key) {
                if (!ctrl.mobile && !ctrl.classicView) {
                    if (ctrl.stickyProperties.deviceId !== undefined && ctrl.stickyProperties.deviceId !== null && value.deviceId === ctrl.stickyProperties.deviceId) {
                        ctrl.currentSelectedDevice = value;
                    }
                }

                if (value.hasVolumetricFlow) {
                    ctrl.deviceList.push(value);
                }
            });
            if (ctrl.deviceList.length === 0) {
                ctrl.deviceList.push({ deviceId: "", name: ctrl.translation.text.NO_DEVICES });
            } else if (!ctrl.mobile && !ctrl.classicView && !!ctrl.stickyProperties.deviceId) {
                ctrl.callback(ctrl.currentSelectedDevice);
                return;
            }

            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {

                ctrl.currentSelectedDevice = ctrl.deviceList[0];
                ctrl.callback(ctrl.currentSelectedDevice);
            }
        }, function (error) {});
    };
}

VolumetricFlowSummaryDeviceController.$inject = ['$', '$scope', 'authenticationService', 'translationService', 'deviceMenuService', 'sharedSetupService'];

angular.module('mc.volumetricflowsummary').component('volumetricflowSummaryDeviceMenu', {
    controller: VolumetricFlowSummaryDeviceController,
    transclude: true,
    templateUrl: 'ui/volumetricflowsummary/volumetricflow-summary-device-menu.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<',
        callback: '='
    }
});
mcapp.controller("voltageWidgetController", ["$scope", "$rootScope", "translationService", "sharedSetupService", "authenticationService", "$element",
    function ($scope, $rootScope, translationService, sharedSetupService, authenticationService, $element) {
        $scope.fontSizeDefault = ".95em";
        $scope.closeIcon = false;
        $scope.time = null;
        $scope.translation = translationService.translation;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        sharedSetupService.getWindowId($scope);
        if (typeof $scope.stickyProperties != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        $scope.setSetting = function () {
            $scope.deviceSelectedId = { "deviceId": $scope.stickyProperties.device.deviceId };
            $scope.preDeviceSelected = $scope.stickyProperties.device;
            $scope.deviceChannel = $scope.stickyProperties.device.channel;
        };

        $scope.setSetting();

        $scope.filterOut = function (obj) {
            return !(obj.type === 15 && $scope.deviceChannel !== 'Battery');
        };

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            $scope.closeWidget = function () {
                $element.find(".flip-container").hide();
                $scope.popup.dialog("close");
            };

            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.resizeContent();
                    $scope.$apply();
                }
            });

            $scope.resizeContent = function () {
                if (!$element.find(".gauge-widget-icon").highcharts())
                    return;

                $element.find('circle:not(:last)').each(function () {
                    $(this).remove();
                });

                var _newWidth = $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "");
                var _newHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $element.find('.widgetSettingNew').css("width", _newWidth < 240 ? 240 : _newWidth)
                    .css("margin-left", _newWidth < 240 ? -(240 - _newWidth) / 2 : "auto");

                $scope.popup.parent().find('.gauge-widget-icon')
                    .css("width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.gauge-widget-icon')
                    .css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")); //25: total padding
                var _char = $element.find(".gauge-widget-icon").highcharts();
                _char.setSize(
                    $scope.popup.parent().find('.gauge-widget-icon').css("width").replace(/[^0-9.]+/g, "") * 1,
                    ($scope.popup.parent().find('.gauge-widget-icon').css("height").replace(/[^0-9.]+/g, "") -
                        $scope.popup.parent().find('.widget-title').css("height").replace(/[^0-9.]+/g, "")) *
                    .95,
                    false
                );
                var _fontSize = _newWidth < _newHeight ? _newWidth / 12 : _newHeight / 12;
                _fontSize = _fontSize < 12 ? 12 : _fontSize > 35 ? 35 : _fontSize;
                _char.container.parentNode.style.fontSize = _fontSize + "px";
                _char.reflow();
            };
        } else {
            $scope.popup = $(".flip-container");
            $scope.resizeContent = function () {
                if (!$element.find(".gauge-widget-icon").highcharts())
                    return;
                $element.find('circle:not(:last)').each(function () {
                    $(this).remove();
                });

                var _char = $element.find(".gauge-widget-icon").highcharts();

                var _fontSize = 25;
                _char.container.parentNode.style.fontSize = _fontSize + "px";
                _char.reflow();
            }
        }

    }]);
mcapp.directive('voltageWidgetDirective', ['$rootScope', "authenticationService", "websocketService", "voltageGaugeService", "deviceService", "datetimeService", "toaster", "openViewService", "$document", "sharedSetupService", "$timeout",
    function ($rootScope, authenticationService, websocketService, voltageGaugeService, deviceService, datetimeService, toaster, openViewService, $document, sharedSetupService, $timeout) {
        function link(scope, element, attrs) {

            var chart;
            var indexI;
            if (scope.deviceChannel == "Battery") {
                indexI = 0;
            }
            else if (scope.deviceChannel == "ACSupply" || scope.deviceChannel == "Solar Panel") {
                indexI = 1;
            }
            else {
                indexI = 2;
            }
            var liveDataId = scope.deviceChannel == "Battery" ? "VBATT" : "VAC";

            scope.getVoltageData = function (DeviceID) {

                voltageGaugeService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + DeviceID)
                    .then(function (result) {
                        scope.gaugeData = result.data;
                        scope.time = result.data.measurement[indexI].unixTime;
                        scope.device = result.data.device;
                        scope.solar = result.data.device.solar;
                        scope.deviceModel = result.data.device.model;
                        if (scope.deviceChannel !== "VAux") {
                            websocketService.connect();
                            websocketService.unRegister(liveDataId, scope.preDeviceSelected.serialNumber, '', wsDataReceivedVOLTAGE, wsReconnectVOLTAGE);
                            websocketService.register(liveDataId, scope.device.serialNumber, '', wsDataReceivedVOLTAGE, wsReconnectVOLTAGE);
                        }
                        scope.preDeviceSelected = result.data.device;
                        _drawVoltageGauge(scope.gaugeData.device, scope.gaugeData.setting[indexI], scope.gaugeData.measurement[indexI], indexI);
                    }).then(function () {
                        scope.resizeContent();
                        $timeout(function () {
                            scope.resizeContent();
                        }, 0); //need second call to adjust alignment
                    });
            };

            element.attr("class", "gauge-widget-icon");

            var _drawVoltageGauge = function (device, setting, measurement, indexI) {
                var title = device.name;
                //var newDiv = document.createElement('div');
                //newDiv.setAttribute("class", "voltage-widget-title widgetText");
                //var newContent = document.createTextNode(title);
                //newDiv.appendChild(newContent);

                var varAlignment = '';
                varAlignment = scope.deviceChannel == "Battery" ? varAlignment.concat(Array(5).join('\u00a0'), ' ') : varAlignment.concat(Array(2).join('\u00a0'), ' ');

                var _device = { deviceId: scope.deviceSelectedId.deviceId, channel: scope.deviceChannel, serialNumber: scope.device.serialNumber };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: device, device: _device, windowId: scope.windowId });
                if (scope.popup.selector !== ".flip-container") scope.popup.dialog("option", "title", scope.device.name);
                scope.deviceSelectedName = scope.device.name;
                chart = new Highcharts.Chart({
                    chart: {
                        renderTo: element[0],
                        type: 'gauge',
                        plotBackgroundColor: null,
                        plotBackgroundImage: null,
                        backgroundColor: 'rgba(0,0,0,0)',
                        plotBorderWidth: 0,
                        plotShadow: false,
                        spacing: [0, 0, 0, 0],
                        marginTop: -5,
                        spacingTop: -15,
                        style: {
                            fontSize: '1em'
                        }
                    },
                    title: {
                        useHTML: true,
                        text: '',
                        align: 'center',
                        y: 30
                    },
                    exporting: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    tooltip: {
                        enabled: true,
                        followPointer: true,
                        followTouchMove: true,
                        formatter: function () {
                            return Highcharts.dateFormat('%b %e, %Y %H:%M:%S', scope.time) + ': <br><b>' + this.y.toFixed(2) + " " + setting.unit + "</b>";
                        }
                    },
                    pane: {
                        startAngle: -150,
                        endAngle: 150
                    },
                    yAxis: [{
                        min: setting.minimumValue,
                        max: setting.maximumValue,
                        minorTickWidth: 0,
                        tickWidth: 1,
                        tickLength: 10,
                        tickColor: '#666',
                        tickPositions: [setting.minimumValue, setting.lowAlarmValue, scope.deviceModel != 21 ? setting.highAlarmValue : parseFloat(measurement.value.toFixed(2)), setting.maximumValue],
                        labels: {
                            style: {
                                fontSize: '.5em'
                            }

                        },
                        plotBands: [{
                            from: setting.minimumValue,
                            to: setting.lowAlarmValue,
                            color: '#DF5353' // red
                        }, {
                            from: setting.lowAlarmValue,
                            to: scope.deviceModel != 21 ? setting.highAlarmValue : measurement.value,
                            color: '#55BF3B'// green
                        }, {
                            from: scope.deviceModel != 21 ? setting.highAlarmValue : measurement.value,
                            to: setting.maximumValue,
                            color: '#DDDF0D'// yellow
                        }],
                        title: {
                            text: setting.name,
                            y: 15,
                            style: {
                                fontSize: '.7em'
                            }
                        },
                        lineColor: '#000000'
                    }],
                    plotOptions: {
                        gauge: {
                            dataLabels: {
                                y: -10,
                                borderWidth: 0,
                                useHTML: true
                            }
                        }
                    },
                    series: [{
                        data: [measurement.value],
                        dataLabels: {
                            enabled: true,
                            borderWidth: 0,
                            style: {
                                fontSize: '.8em'
                            },

                            format: '<div style="text-align:center; margin-top:16px;"><span style="font-size:120%; color:' +
                                ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y:.2f}</span><br/>' +
                                '<span style="font-size:100%;">' + setting.unit + '</span></div>'

                        }
                    }]
                });
                //element.append(newDiv);
            };

            var wsDataReceivedVOLTAGE = function (data) {
                var varValue = parseFloat(data.Value);
                var varType = data.Type;
                var varVBATT = null;
                var varVAC = null;

                scope.time = datetimeService.toUnixtime(data.Time);

                if (varType == "VBATT") {
                    varVBATT = varValue;
                }
                else {
                    if (scope.solar && scope.deviceModel != 18 && scope.deviceModel != 19) {
                        varVAC = (100 * varValue + 140) / 100;
                    }
                    else if (scope.solar) {
                        varVAC = (100 * varValue) / 100;
                    }
                    else {
                        varVAC = (100 * varValue * .707) / 100;
                    }
                }

                if (varType == "VBATT") {
                    chart.series[0].points[0].update(varVBATT);
                }
                if (varType == "VAC") {
                    chart.series[0].points[0].update(varVAC);
                }

                var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                scope.lastUpdateAt = varTime;
            };

            scope.mostRecentData = function () {
                wsReconnectVOLTAGE();
            }

            var wsReconnectVOLTAGE = function (data) {
                toaster.pop('success', scope.windowTitle + " -- " + scope.device.name, 'View reloading');
                scope.getVoltageData(scope.deviceSelectedId.deviceId);
            };

            scope.isTouchSupported = function () {
                var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
                var generalTouchEnabled = "ontouchstart" in document.createElement("div");

                if (msTouchEnabled || generalTouchEnabled) {
                    return true;
                }
                return false;
            };

            scope.getVoltageData(scope.deviceSelectedId.deviceId);
            if (scope.popup.selector !== ".flip-container") scope.popup.dialog("option", "dialogClass", "ui-widget-content-new");

            scope.replaceSpaces = function (str) {
                return str.replace(/ /g, '_');
            }

            scope.$on('document_click', function (e, event) {
                var $tgt = $(event.target);
                if ($tgt.closest('#voltage-widget-' + scope.replaceSpaces(scope.windowId)).length === 0 || ($tgt.closest('.back').length === 0 && $tgt.closest('.front').length === 0)) {

                    if (scope.isTouchSupported()) {
                        scope.popup.parent().find(".front").toggle(true);
                        scope.popup.parent().find(".back").toggle(false);
                    } else {
                        $('#voltage-widget-' + scope.replaceSpaces(scope.windowId)).offsetParent().offsetParent().find('.flip-container').toggleClass('flip', false);
                    }

                    scope.setSetting();
                    scope.resizeContent();
                }
            });

            scope.popup.parent().on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            if (scope.popup.parent().is('.ui-draggable-dragging, .ui-resizable-resizing') || event.target.nodeName === 'SELECT') {
                                return;
                            }

                            $rootScope.$broadcast('document_click', event);

                            if (scope.isTouchSupported()) {
                                scope.popup.parent().find(".back").toggle();
                                scope.popup.parent().find(".front").toggle();
                            } else {
                                scope.popup.parent().find('.flip-container').toggleClass('flip');
                            }

                            scope.setSetting();
                            scope.resizeContent();
                        }
                    );
                }
            );

            scope.popup.parent().find("select").on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            );

            scope.popup.parent().on(
                "mouseover",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            scope.popup.parent().addClass("x-resize");
                            scope.closeIcon = true;
                        }
                    );
                }
            );

            scope.popup.parent().on(
                "mouseout",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            scope.popup.parent().removeClass("x-resize");
                            if (scope.isTouchSupported()) {
                                setTimeout(function () {
                                    scope.closeIcon = false;
                                }, 3000);
                            }
                            else {
                                scope.closeIcon = false;
                            }
                        }
                    );
                }
            );

            scope.$on(
                "$destroy",
                function (event) {
                    if (scope.deviceChannel !== "VAux") {
                        websocketService.unRegister(liveDataId, scope.device.serialNumber, '', wsDataReceivedVOLTAGE, wsReconnectVOLTAGE);
                    }
                    scope.popup.parent().off();
                    scope.popup.parent().find("select").off();
                    if (chart) chart.destroy();
                }
            );

            //$(element).find('.widget').addClass('translateAnimationClass');
        }


        return {
            restrict: 'A',
            replace: false,
            link: link
        };
    }]);

mcapp.directive('voltageSettingDirective', ["authenticationService", "websocketService", "deviceMenuService", "deviceService", "toaster",
    function (authenticationService, websocketService, deviceMenuService, deviceService, toaster) {
        function link(scope, element, attrs) {
            scope.notfirst = false;
            deviceMenuService.getDeviceMenuList(scope.accountInfo.customerId)
                .then(function (result) {
                    scope.Devices = result.data.devices;
                    if (scope.deviceChannel === "VAux") {
                        var myDroDevices = [];
                        for (var i = 0; i < scope.Devices.length; i++) {
                            if (scope.Devices[i].model === 17 || scope.Devices[i].model === 18 || scope.Devices[i].model === 19) {
                                myDroDevices.push(scope.Devices[i]);
                            }
                        }
                        scope.Devices = myDroDevices;
                    }
                }, function (error) {
                });

            scope.getBackToVoltageData = function (DeviceID) {

                if (DeviceID != null)
                    scope.getVoltageData(DeviceID);
                scope.popup.parent().find('.flip-container').toggleClass('flip');
                if (scope.isTouchSupported()) {
                    scope.popup.parent().find(".back").toggle();
                    scope.popup.parent().find(".front").toggle();
                }

                scope.resizeContent();
            };

        }
        return {
            link: link
        };


    }]);
mcapp.controller('voltageTableController', ['$scope', '$rootScope', 'translationService', 'sharedSetupService', 'openViewService', '$timeout', '$element', 'authenticationService', function ($scope, $rootScope, translationService, sharedSetupService, openViewService, $timeout, $element, authenticationService) {
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
    $scope.translation = translationService.translation;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.alerts = [];
    $scope.downloadViewTypeOptions = [0, 4];
    sharedSetupService.broadcastAllDeviceSelected($scope);
    sharedSetupService.getWindowId($scope);
    $scope.liveTable = $element.find(".headertable");

    $scope.liveDataLine = function (varLiveData) {
        if (varLiveData) {
            $scope.liveTable.addClass("live-data-line");
        } else {
            $scope.liveTable.removeClass("live-data-line");
        }
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
        $scope.updateLanguage();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        $scope.updateLanguage();
    });

    $scope.updateLanguage = function () {
        $scope.voltageTableService.items = angular.copy($scope.voltageTableService.items);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);
        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            //$scope.adjustDeviceIdMenuSize();
        };

        $scope.adjustDeviceIdMenuSize = function () {
            var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")
            if (spph < 450) {
                $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            }
            else {
                $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        };
    }
}]);

mcapp.directive('drawVoltageData', ['$rootScope', '$timeout', 'voltageTableService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', function ($rootScope, $timeout, voltageTableService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }
        scope.dateAgentText = function (input) {
            return datetimeService.formatDateAgentText(input, 'yyyy-MM-ddTHH:mm:ss', false, scope.timeFormat);
        }
        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        scope.trgScroll = function () {
            $timeout(function () {
                var $rowFirst = element.contents().find("tr:first");
                var _firstRow = $rowFirst.attr("name");
                if (typeof $rowFirst.position() !== "undefined") {
                    var _tableTop = element.offset().top;
                    var _rowTop = $rowFirst.offset().top;
                    _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
                }
            }, 0);
        }

        scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            if (scope.alerts.length > 0) {
                var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
                var _type = scope.alerts[0].type;
                var _languageCode = scope.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(scope.voltageTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.voltageTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                }
                scope.alerts = [];
                scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });

        element.on('scroll', function (event) {
            var $rowFirst = element.contents().find("tr:first");
            var $rowLast = element.contents().find("tr:last");
            if (typeof $rowFirst.position() !== "undefined") {
                scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
                scope.trgScroll();
                previousScrollbarPosition = currentScrollbarPosition;
                currentScrollbarPosition = element[0].scrollTop;
            }

            if (scope.infiniteScrollOn === true) {
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;

                if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
                    $rowLast.addClass("active-row");
                    scope.voltageTableService.alerts = [];
                    scope.voltageTableService.nextPage();
                }
                if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
                    $rowFirst.addClass("active-row");
                    scope.voltageTableService.alerts = [];
                    scope.voltageTableService.previousPage();
                }
            }

            var rows = element.children().children().children().children();
            var scrollpos = 40;
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos)
                    start = mid + 1;
                else
                    end = mid;
            }
            _updateZoom(parseFloat($($(rows[start])).attr("name")));
        });

        var _updateZoom = function (currentRow) {
            if (isNaN(currentRow))
                return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            }
            else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('voltageTableService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        scope.newVoltageTableService = function () {
            scope.voltageTableService = new voltageTableService();
            scope.voltageTableService.customerId = scope.accountInfo.customerId;
			scope.voltageTableService.timeZone = scope.accountInfo.timeZone;
            scope.voltageTableService.deviceId = scope.deviceSelected;
            scope.voltageTableService.windowTitle = scope.windowTitle;
            scope.voltageTableService.startRow = 1;
            scope.voltageTableService.pageSize = 50;
        };

        var _openTableInLiveMode = function () {
            scope.stickyProperties.on = false;
            timeLapseService.getLocalDateTime().then(function (result) {
                /////////////////////////////////////////////////////////////
                var tmpDates = new Date(result.data.localDateTime);
                var tmpDatesA = tmpDates;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, scope.deviceSelectedType === 10 || scope.deviceSelectedType === 15 ? 90 : 10);
                tmpDatesA.setHours(23, 59, 59, 0);
                tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
                /////////////////////////////////////////////////////////////
                scope.newVoltageTableService();
                scope.voltageTableService.start = tmpDates.startDate;
                scope.voltageTableService.end = tmpDatesA;
                sharedSetupService.setStickyProperties(scope.stickyProperties,
                    {
                        deviceId: scope.deviceSelected,
                        dataMin: tmpDates.startDate,
                        dataMax: tmpDates.endDate,
                        zoomMin: (tmpDates.startDate + scope.unixDay),
                        zoomMax: (tmpDates.endDate - scope.unixDay),
                        windowId: scope.windowId
                    });
                scope.voltageTableService.nextPage();
                /////////////////////////////////////////////////////////////
            });
        };

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                /////////////////////////////////////////////////////////////
                currentScrollbarPosition = 0;
                previousScrollbarPosition = 0;
                scope.checkFirstRowLiveStatus = null;
                /////////////////////////////////////////////////////////////
                scope.alerts = [];
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });

                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMin !== null) {
                    scope.stickyProperties.on = true;
                    timeLapseService.getLocalDateTime().then(function (result) {
                        if (scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && scope.stickyProperties.zoomMax + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                            scope.newVoltageTableService();
                            scope.voltageTableService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
                            scope.voltageTableService.end = scope.stickyProperties.dateMax;
                            scope.voltageTableService.nextPage();
                        }
                        else {
                            scope.newVoltageTableService();
                            scope.voltageTableService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
                            scope.voltageTableService.end = Math.round((scope.stickyProperties.zoomMax + scope.stickyProperties.zoomMin) / 2);
                            scope.voltageTableService.nextPage();
                        }
                    });
                }
                else {
                    _openTableInLiveMode();
                }
            }
        }, true);

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.stickyProperties.device.serialNumber = newValue;
                if (oldValue) {
                    _unRegisterListener(oldValue);
                }
            }
        }, true);

        scope.selectMyDate = function (date) {
            scope.myDate = date;
            scope.voltageTableService = new voltageTableService();
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            _unRegisterListener(scope.deviceSelectedSn);
            /////////////////////////////////////////////////////////////
            var tmpDates = scope.myDate;
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, scope.deviceSelectedType === 10 || scope.deviceSelectedType === 15 ? 90 : 10);
            tmpDatesA.setHours(12, 0, 0, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            scope.voltageTableService.start = tmpDates.startDate;
            if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                scope.voltageTableService.end = tmpDatesA;
            }
            else {
                scope.voltageTableService.end = tmpDates.endDate;
            }
            /////////////////////////////////////////////////////////////
            scope.voltageTableService.startRow = 1;
            scope.voltageTableService.pageSize = 50;
            scope.voltageTableService.customerId = scope.accountInfo.customerId;
			scope.voltageTableService.timeZone = scope.accountInfo.timeZone;
            scope.voltageTableService.deviceId = scope.deviceSelected;
            scope.voltageTableService.windowTitle = scope.windowTitle;
            scope.alerts = [];
            scope.voltageTableService.nextPage();
            /////////////////////////////////////////////////////////////
            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
        };

        var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            }
            else if (scope.checkFirstRowLiveStatus === null) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.checkFirstRowLiveStatus = true;
                        _checkTopOffset(liveDataStatusOn);
                    }
                    else {
                        scope.checkFirstRowLiveStatus = false;
                    }
                });
            }
        };

        var _checkTopOffset = function (liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListener(scope.deviceSelectedSn);
            }
            else {
                _unRegisterListener(scope.deviceSelectedSn);
            }
        };

        var wsDataReceivedVOLTAGE = function (data) {
            var i = 0;
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            var varValue = parseFloat(data.Value);
            var varType = data.Type;
            var varVBATT = null;
            var varVAC = null;
            var varVAux = null;

            scope.voltageTableService.end = datetimeService.toUnixtime(data.Time) + scope.unixDay;

            if (varType == "VBATT") {
                varVBATT = varValue;
            }
            else if(varType == "VAUX")
            {
                varVAux = varValue;
            }
            else {
                if (scope.voltageTableService.deviceSolar && scope.voltageTableService.deviceModel != 18 && scope.voltageTableService.deviceModel != 19) {
                    varVAC = (100 * varValue + 140) / 100;
                }
                else if (scope.voltageTableService.deviceSolar) {
                    varVAC = (100 * varValue) / 100;
                }
                else {
                    varVAC = (100 * varValue * .707) / 100;
                }
            }

            var _newRecord;
            var _recordExistAtIndex = null;
            var _channelIndex = null;

            for (i = 0; i < scope.voltageTableService.items.length; i++) {
                if (scope.voltageTableService.items[i].localDateTime == varTime) {
                    _recordExistAtIndex = i;
                    if (varType == "VBATT") {
                        scope.voltageTableService.items[i].battery = varVBATT;
                    }
                    else if(varType == "VAUX"){
                        scope.voltageTableService.items[i].vAux = varVAux;
                    }
                    else {
                        scope.voltageTableService.items[i].acSupply = varVAC;
                    }
                    break;
                }
            }

            if (_recordExistAtIndex === null) {
                _newRecord = { localDateTime: varTime, battery: varVBATT, acSupply: varVAC, vAux : varVAux };
                scope.voltageTableService.items.unshift(_newRecord);
                _recordExistAtIndex = 0;
            }

            scope.lastUpdateAt = varTime;
        };
        
        scope.$on('processReconnect', function (event, args) {
            scope.reconnectData(event, args);
        });

        scope.reconnectData = function (event, args) {
            sharedSetupService.processReconnect({
                stickyProperties: scope.stickyProperties,
                localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
                dateRangeOption: null,
                windowTitle: scope.windowTitle,
                fnUnregister: _unRegisterListener,
                fnGetData: _openTableInLiveMode,
                viewType: "Table"
            });            
        }

        scope.mostRecentData = function (event, args) {
            scope.stickyProperties.liveData = true;
            scope.myDate = null;
            scope.reconnectData(event, args);
        }

        var _registerListener = function (varSelectedSN) {
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
            scope.liveData = true;
            scope.liveDataLine(scope.liveData);
            scope.voltageTableService.numberOfNewRecordsPrevious = -1;
            websocketService.connect();
            websocketService.register("VBATT", varSelectedSN, "", wsDataReceivedVOLTAGE, null); //one call-back to reconnect is enough
            websocketService.register("VAC", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
            websocketService.register("VAUX", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
        };

        var _unRegisterListener = function (varSelectedSN) {
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
            if (scope.liveData === false)
                return;
            scope.liveData = false;
            scope.liveDataLine(scope.liveData);
            scope.lastUpdateAt = undefined;
            websocketService.unRegister("VBATT", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
            websocketService.unRegister("VAC", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
            websocketService.register("VAUX", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
        };

        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll();
            scope.checkFirstRowLiveStatus = null;
            scope.trgScroll();
        });

        var _autoScroll = function () {
            //if (scope.savedDesktopRow) {
            //    var trRow = element.find("tr[name='" + scope.savedDesktopRow + "']");
            //    var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 10;
            //    element.scrollTop(yPosition);
            //    scope.savedDesktopRow = null;
            //}
            if (scope.voltageTableService.numberOfNewRecordsPrevious > 0) {
                var trRow = element.find('tr').eq(scope.voltageTableService.numberOfNewRecordsPrevious - 1);
                var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
                element.scrollTop(yPosition);
            }
            else {
                $timeout(function () {
                    element.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
        });
    };
}]);

mcapp.factory('voltageTableService', ['$http', 'datetimeService', 'translationService', 'HOST', function ($http, datetimeService, translationService, HOST) {
    var voltageTableService = function () {
        this.items = [];
        this.setting = [];
        this.deviceName = '';
        this.deviceType = '';
        this.deviceSolar = '';
        this.deviceModel = '';
        this.customerId = null;
        this.deviceId = null;
		this.timeZone = "Z";
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.tdWidth = null;
        this.alerts = [];
        this.translation = translationService.translation;
		this.scrollUp = "";
        this.scrollDown = "";
        this.isMyDroDevice = false;
    };

    voltageTableService.prototype.previousPage = function () {
        if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
        this.busy = true;
        this.pageSize = -50;
        //from is: very top record
		var url = HOST + "/api/VoltageTable?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end + "&fromDate=" + this.scrollUp + "&timeZone=" + this.timeZone;
        $http.get(url).then(function (result) {
            /////////////////////////
            var intDayWindow = 10;
            var intDay = 86400000;
            /////////////////////////
            var deviceName = result.data.device.name;
            var deviceType = result.data.device.type;
            var deviceSolar = result.data.device.solar;
            var deviceModel = result.data.device.model;
            var setting = result.data.setting;
            if (this.setting.length === 0) {
                for (var i = 0; i < setting.length; i++) {
                    this.setting.push(setting[i]);
                }
                this.tdWidth = parseInt(100 / (setting.length + 1)) + "%";
            }
            var items = result.data.voltageMeasurements;
            if (items.length > 0)
                var tmpstart = new Date(items[items.length - 1].localDateTime);
            for (var j = 0; j < items.length; j++) {
                items[j].localDateTime = items[j].localDateTime;
                items[j].battery = items[j].battery;
                items[j].acSupply = items[j].acSupply;
                this.items.unshift(items[j]);
            }
            this.numberOfNewRecordsPrevious = items.length;
            this.numberOfRecords = this.items.length;
            this.deviceName = deviceName;
            this.deviceType = deviceType;
            this.deviceSolar = deviceSolar;
            this.deviceModel = deviceModel;
            this.isMyDroDevice =  deviceType == 17 || deviceType == 18 || deviceType == 19 ? true : false;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) { //if there are records returned
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
            }

            if (this.items.length > 0) {
                this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
                this.scrollDown = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localDateTime.replace(/\D/g, ''));
            } else {
                this.scrollUp = "";
                this.scrollDown = "";
            }

            this.pageSize = 50;
            this.busy = false;

        }.bind(this),
            function (error) {
                this.alerts = [];
                var errorMessage = eval("this.translation.message." + error.data.message);
                this.alerts.push({ msg: errorMessage, type: "danger" });
                this.pageSize = 50;
                this.busy = false;
            }.bind(this));
    };

    voltageTableService.prototype.nextPage = function () {
        if (this.busy || this.numberOfReturnedRecords === 0) return;
        this.busy = true;

        //from is: very bottom record
		var url = HOST + "/api/VoltageTable?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end + "&fromDate=" + this.scrollDown + "&timeZone=" + this.timeZone;
        $http.get(url).then(function (result) {
            /////////////////////////
            var intDayWindow = 10;
            var intDay = 86400000;
            /////////////////////////
            var deviceName = result.data.device.name;
            var deviceType = result.data.device.type;
            var deviceSolar = result.data.device.solar;
            var deviceModel = result.data.device.model;
            var setting = result.data.setting;
            if (this.setting.length === 0) {
                for (var i = 0; i < setting.length; i++) {
                    this.setting.push(setting[i]);
                }
                this.tdWidth = parseInt(100 / (setting.length + 1)) + "%";
            }
            var items = result.data.voltageMeasurements;
            if (items.length > 0)
                var tmpstart = new Date(items[items.length - 1].localDateTime);
            for (var j = 0; j < items.length; j++) {
                items[j].localDateTime = items[j].localDateTime;
                items[j].battery = items[j].battery;
                items[j].acSupply = items[j].acSupply;
                this.items.push(items[j]);
            }
            this.numberOfReturnedRecords = items.length;
            this.deviceName = deviceName;
            this.deviceType = deviceType;
            this.deviceSolar = deviceSolar;
            this.deviceModel = deviceModel;
            this.isMyDroDevice = deviceType == 17 || deviceType == 18 || deviceType == 19 ? true : false;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) { //if there are records returned
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
            }
            else {
                // If we didn't get any items back AND there aren't already any items
                if (this.items.length === 0) {
                    this.alerts = [];
                    var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                    this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            }

            if (this.items.length > 0) {
                this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
                this.scrollDown = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, ''));
            } else {
                this.scrollUp = "";
                this.scrollDown = "";
            }

            this.pageSize = 50;
            this.busy = false;

        }.bind(this),
            function (error) {
                this.alerts = [];
                var errorMessage = eval("this.translation.message." + error.data.message);
                this.alerts.push({ msg: errorMessage, type: "danger" });
                this.pageSize = 50;
                this.busy = false;
            }.bind(this));
    };

    return voltageTableService;
}]);

"use strict";

angular.module("mc.voltage-table", []);
"use strict";

function VoltageTableFactory($http, HOST) {
    var voltageTable = function voltageTable(customerId) {
        this.customerId = customerId;
    };

    voltageTable.prototype.getData = function (deviceId, startRow, pageSize, start, end, scrollUp, timeZone) {
        var self = this;
        var url = HOST + "/api/VoltageTable?customerId=" + this.customerId + "&deviceId=" + deviceId + "&StartRow=" + startRow + "&PageSize=" + pageSize + "&StartDate=" + start + "&EndDate=" + end + "&fromDate=" + scrollUp + "&timeZone=" + timeZone;
        return $http.get(url).then(function (response) {
            self.data = response.data;
            self.pageSize = 50;
            self.busy = false;
            return response;
        });
    };
    return voltageTable;
}
VoltageTableFactory.$inject = ['$http', 'HOST'];

angular.module('mc.voltage-table').factory('VoltageTableFactory', VoltageTableFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function VoltageTableController($scope, $rootScope, translationService, sharedSetupService, openViewService, $timeout, $element, authenticationService, timeLapseService, datetimeService, websocketService, VoltageTableFactory) {
  var ctrl = this;
  $scope.alerts = [];
  ctrl.myDate = null;
  ctrl.infiniteScrollOn = false;
  ctrl.infiniteScrollUpOn = false;
  ctrl.infiniteScrollDownOn = false;
  var element = $element.find("#voltage-table-comp");
  var currentScrollbarPosition = 0;
  var previousScrollbarPosition = 0;
  var paddingZoom = void 0;
  ctrl.$onInit = function () {
    sharedSetupService.getWindowId(ctrl);
    ctrl.startRow = 1;
    ctrl.checkFirstRowLiveStatus = null;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.numberOfReturnedRecords = -1;
    ctrl.numberOfNewRecordsPrevious = -1;
    ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
    ctrl.unixDay = sharedSetupService.unixDay;
    ctrl.liveDataOffset = sharedSetupService.liveDataOffset;
    ctrl.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
    ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    if (_typeof(ctrl.stickyProperties) != "object") {
      ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
    }
    ctrl.customerId = ctrl.accountInfo.customerId;
    ctrl.items = [];
    ctrl.setting = [];
    ctrl.busy = false;
    ctrl.alerts = [];
    ctrl.hasvAux = false;
    paddingZoom = Math.round((ctrl.stickyProperties.zoomMax - ctrl.stickyProperties.zoomMin) / 2);
    $scope.windowTitle = ctrl.windowTitle;
    sharedSetupService.broadcastAllDeviceSelected($scope);

    sharedSetupService.getWindowId($scope);
    ctrl.liveTable = $element.find(".headertable");
    ctrl.openTableInLiveMode();

    $scope.getIcon = function (varTitle, varMode) {
      return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on("updatePreferencesTimeFormat", function (event, timeFormat) {
      ctrl.timeFormat = timeFormat;
      ctrl.updateLanguage();
    });

    $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
      if (ctrl.alerts.length > 0) {
        var _msg = eval("scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
        var _type = ctrl.alerts[0].type;
        var _languageCode = ctrl.alerts[0].languageCode;
        if (_languageCode.toUpperCase() === 'NO_DATA') {
          _msg += ': ' + moment($scope.userLoginReportService.start).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.userLoginReportService.end).format('MM/DD/YY, h:mm:ss a');
        }
        ctrl.alerts = [];
        ctrl.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
      }
    });

    ctrl.updateLanguage = function () {
      ctrl.items = angular.copy(ctrl.items);
    };

    if (!ctrl.mobile && !ctrl.classicView) {
      ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
      sharedSetupService.maximize(ctrl.popup);
      ctrl.popup.dialog({
        resize: function resize(event, ui) {
          ctrl.adjustSize();
        }
      });

      ctrl.popup.dialogExtend({
        maximize: function maximize(event, ui) {
          openViewService.adjustContentSizeStart(ctrl.popup);
          ctrl.adjustSize();
        },
        restore: function restore(event, ui) {
          openViewService.adjustContentSizeStart(ctrl.popup);
          ctrl.adjustSize();
        }
      });

      ctrl.adjustSize = function () {
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
      };
    }
  };

  ctrl.liveDataLine = function (varLiveData) {
    if (varLiveData) {
      ctrl.liveTable.addClass("live-data-line");
    } else {
      ctrl.liveTable.removeClass("live-data-line");
    }
  };

  if (_typeof(ctrl.stickyProperties) != "object") {
    ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
  }

  ctrl.dateAgentText = function (input) {
    return datetimeService.formatDateAgentText(input, "yyyy-MM-ddTHH:mm:ss", false, ctrl.timeFormat);
  };

  ctrl.trgScroll = function () {
    $timeout(function () {
      var $rowFirst = element.contents().find("tr:first");
      var _firstRow = $rowFirst.attr("name");
      if (typeof $rowFirst.position() !== "undefined") {
        var _tableTop = element.offset().top;
        var _rowTop = $rowFirst.offset().top;
        _setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);
      }
    }, 0);
  };

  element.on("scroll", function (event) {
    var $rowFirst = element.contents().find("tr:first");
    var $rowLast = element.contents().find("tr:last");
    var _firstRow = $rowFirst.attr("name");
    if (typeof $rowFirst.position() !== "undefined") {
      ctrl.infiniteScrollOn = true;
      ctrl.infiniteScrollUpOn = true;
      ctrl.infiniteScrollDownOn = true;
      ctrl.trgScroll();
      var _topOffset = $rowFirst.position().top;
      previousScrollbarPosition = currentScrollbarPosition;
      currentScrollbarPosition = element[0].scrollTop;
    }

    if (ctrl.infiniteScrollOn === true) {
      ctrl.infiniteScrollUpOn = true;
      ctrl.infiniteScrollDownOn = true;
      if (ctrl.infiniteScrollDownOn === true && element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight) {
        $rowLast.addClass("active-row");
        ctrl.alerts = [];
        ctrl.pullData(true, ctrl.scrollDown);
      }
      if (ctrl.infiniteScrollUpOn === true && element[0].scrollTop < 5 && currentScrollbarPosition < previousScrollbarPosition) {
        $rowFirst.addClass("active-row");
        ctrl.alerts = [];
        ctrl.pullData(false, ctrl.scrollUp);
      }
    }

    var rows = element.children().children().children().children();
    var scrollpos = 40;
    var start = 0;
    var end = rows.length;
    var count = 0;

    while (start != end) {
      count++;
      var mid = start + Math.floor((end - start) / 2);
      if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
    }
    _updateZoom(parseFloat($($(rows[start])).attr("name")));
  });

  var _updateZoom = function _updateZoom(currentRow) {
    if (isNaN(currentRow)) return;

    var zoomMin = currentRow - paddingZoom;
    var zoomMax = currentRow + paddingZoom;

    var dateMin = ctrl.stickyProperties.dateMin;
    var dateMax = ctrl.stickyProperties.dateMax;

    if (zoomMin < ctrl.stickyProperties.dateMin) {
      dateMin = zoomMin;
    }
    if (zoomMax > ctrl.stickyProperties.dateMax) {
      dateMax = zoomMax;
    }

    sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
      dataMin: dateMin,
      dataMax: dateMax,
      zoomMin: zoomMin,
      zoomMax: zoomMax,
      windowId: ctrl.windowId
    });
  };

  ctrl.toggle = function ($event) {
    if ($($event.currentTarget).hasClass("active-row")) {
      $($event.currentTarget).removeClass("active-row");
    } else {
      $($event.currentTarget).addClass("active-row");
    }
  };

  $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
    if (newValue && newValue != oldValue) {
      ctrl.liveDataIn = !ctrl.liveDataIn;
      $timeout(function () {
        ctrl.liveDataIn = !ctrl.liveDataIn;
      }, 3000);
    }
  }, true);

  $scope.$watch('voltageTablealerts', function (newValue, oldValue) {
    if (newValue && newValue.length > 0 && newValue != oldValue) {
      ctrl.alerts = newValue;
    }
  }, true);

  ctrl.$onChanges = function (changes) {
    if (!angular.isUndefined(changes.deviceSelected) && !angular.isUndefined(changes.deviceSelected.currentValue) && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
      ctrl.items = [];
      ctrl.setting = [];
      ctrl.hasvAux = false;
      currentScrollbarPosition = 0;
      previousScrollbarPosition = 0;
      ctrl.currentDeviceId = changes.deviceSelected.currentValue;
      sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
        deviceId: ctrl.currentDeviceId,
        windowId: ctrl.windowId
      });

      if (ctrl.stickyProperties.on !== null && ctrl.stickyProperties.zoomMin !== null) {
        ctrl.stickyProperties.on = true;
        ctrl.openTableInLiveMode();
      } else {
        ctrl.stickyProperties.on = false;
        ctrl.openTableInLiveMode();
      }
    }

    if (!angular.isUndefined(changes.myDate) && !angular.isUndefined(changes.myDate.currentValue) && changes.myDate.currentValue !== changes.myDate.previousValue) {
      $scope.myDate = changes.myDate.currentValue;
      ctrl.myDate = changes.myDate.currentValue;
      _updateZoom(datetimeService.dateToUnixtime(changes.myDate.currentValue));
      ctrl.items = [];
      $timeout(function () {
        var tmpDates = changes.myDate.currentValue == null ? new Date() : changes.myDate.currentValue;
        ctrl.selectMyDate(tmpDates);
      }, 0);
    }
  };

  ctrl.pullData = function (next, scroll) {
    var intDayWindow = 10;
    var intDay = 86400000;
    var pgSize = 50;
    if (!next) pgSize = -50;
    if (!ctrl.busy) {
      ctrl.busy = true;
      ctrl.alerts = [];
      ctrl.voltageTable = new VoltageTableFactory(ctrl.accountInfo.customerId);
      ctrl.voltageTable.getData(ctrl.deviceSelected, ctrl.startRow, pgSize, ctrl.start, ctrl.end, scroll, ctrl.accountInfo.timeZone).then(function (result) {
        ctrl.deviceName = result.data.device.name;
        ctrl.onDeviceNameChange({ deviceName: ctrl.deviceName });
        ctrl.deviceType = result.data.device.type;
        ctrl.deviceSolar = result.data.device.solar;
        ctrl.deviceModel = result.data.device.model;
        if (ctrl.setting.length === 0) {
          for (var i = 0; i < result.data.setting.length; i++) {
            ctrl.setting.push(result.data.setting[i]);
          }
          ctrl.tdWidth = parseInt(100 / (result.data.setting.length + 1)) + "%";
        }
        var hasvAuxIdx = ctrl.setting.findIndex(function (x) {
          return x.id == "VAux";
        });
        if (hasvAuxIdx > -1) {
          ctrl.hasvAux = true;
        }
        ctrl.isMyDroDevice = result.data.device.type == 17 || result.data.device.type == 18 || result.data.device.type == 19 ? true : false;
        var items = result.data.voltageMeasurements;
        for (var j = 0; j < items.length; j++) {
          items[j].localDateTime = items[j].localDateTime;
          items[j].battery = items[j].battery;
          items[j].acSupply = items[j].acSupply;
          if (!next) ctrl.items.unshift(items[j]);else ctrl.items.push(items[j]);
        }
        if (!next) ctrl.numberOfNewRecordsPrevious = items.length;else ctrl.numberOfReturnedRecords = items.length;
        ctrl.startRow = ctrl.startRow + items.length;

        if (items.length > 0) {
          //if there are records returned
          ctrl.start = datetimeService.toUnixtime(ctrl.items[ctrl.items.length - 1].localDateTime.replace(/\D/g, '')) - intDayWindow * intDay;
          ctrl.end = datetimeService.toUnixtimeMs(ctrl.items[0].localDateTime.replace(/\D/g, ''));
        } else {
          // If we didn't get any items back AND there aren't already any items
          if (ctrl.items.length === 0) {
            ctrl.alerts = [];
            var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(ctrl.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.end).utc().format('MM/DD/YY, h:mm:ss a');
            ctrl.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
          }
        }
        if (ctrl.items.length > 0) {
          if (!next) {
            ctrl.scrollUp = datetimeService.toUnixtimeMs(ctrl.items[0].localDateTime.replace(/\D/g, ''));
            ctrl.scrollDown = datetimeService.toUnixtimeMs(ctrl.items[ctrl.items.length - 1].localDateTime.replace(/\D/g, ''));
          } else {
            ctrl.scrollUp = datetimeService.toUnixtimeMs(ctrl.items[0].localDateTime.replace(/\D/g, ''));
            ctrl.scrollDown = datetimeService.toUnixtime(ctrl.items[ctrl.items.length - 1].localDateTime.replace(/\D/g, ''));
          }
        } else {
          ctrl.scrollUp = "";
          ctrl.scrollDown = "";
        }
        ctrl.busy = false;
      });
    }
  };

  ctrl.openTableInLiveMode = function () {
    ctrl.stickyProperties.on = false;
    timeLapseService.getLocalDateTime().then(function (result) {
      /////////////////////////////////////////////////////////////
      var intDayWindow = 10;
      var intDay = 86400000;
      var tmpDates = new Date(result.data.localDateTime);
      var tmpDatesA = tmpDates;
      tmpDates.setHours(0, 0, 0, 0);
      tmpDates = datetimeService.dateToUnixtime(tmpDates);
      tmpDates = datetimeService.getNewStartEndDates(tmpDates, ctrl.deviceSelectedType === 10 || ctrl.deviceSelectedType === 15 ? 90 : 10);
      tmpDatesA.setHours(23, 59, 59, 0);
      tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
      /////////////////////////////////////////////////////////////
      ctrl.start = tmpDates.startDate;
      ctrl.end = tmpDatesA;
      if (!ctrl.busy) {
        ctrl.voltageTable = new VoltageTableFactory(ctrl.accountInfo.customerId);
        ctrl.busy = true;
        ctrl.alerts = [];
        ctrl.voltageTable.getData(ctrl.deviceSelected, 1, 50, ctrl.start, ctrl.end, "", ctrl.accountInfo.timeZone).then(function (result) {
          ctrl.deviceName = result.data.device.name;
          ctrl.onDeviceNameChange({ deviceName: ctrl.deviceName });
          ctrl.deviceType = result.data.device.type;
          ctrl.deviceSolar = result.data.device.solar;
          ctrl.deviceModel = result.data.device.model;
          if (ctrl.setting.length === 0) {
            for (var i = 0; i < result.data.setting.length; i++) {
              ctrl.setting.push(result.data.setting[i]);
            }
            var hasvAuxIdx = ctrl.setting.findIndex(function (x) {
              return x.id == "VAux";
            });
            if (hasvAuxIdx > -1) {
              ctrl.hasvAux = true;
            }
            ctrl.tdWidth = parseInt(100 / (result.data.setting.length + 1)) + "%";
          }
          ctrl.isMyDroDevice = result.data.device.type == 17 || result.data.device.type == 18 || result.data.device.type == 19 ? true : false;
          var items = result.data.voltageMeasurements;
          for (var j = 0; j < items.length; j++) {
            items[j].localDateTime = items[j].localDateTime;
            items[j].battery = items[j].battery;
            items[j].acSupply = items[j].acSupply;
            ctrl.items.push(items[j]);
          }
          ctrl.numberOfReturnedRecords = items.length;
          ctrl.numberOfRecords = ctrl.items.length;
          ctrl.startRow = ctrl.startRow + items.length;
          if (items.length > 0) {
            //if there are records returned
            ctrl.start = datetimeService.toUnixtime(ctrl.items[ctrl.items.length - 1].localDateTime.replace(/\D/g, '')) - intDayWindow * intDay;
            ctrl.end = datetimeService.toUnixtimeMs(ctrl.items[0].localDateTime.replace(/\D/g, ''));
          } else {
            // If we didn't get any items back AND there aren't already any items
            if (ctrl.items.length === 0) {
              ctrl.alerts = [];
              var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(ctrl.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.end).utc().format('MM/DD/YY, h:mm:ss a');
              ctrl.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
          }

          if (ctrl.items.length > 0) {
            ctrl.scrollUp = datetimeService.toUnixtimeMs(ctrl.items[0].localDateTime.replace(/\D/g, ''));
            ctrl.scrollDown = datetimeService.toUnixtime(ctrl.items[ctrl.items.length - 1].localDateTime.replace(/\D/g, ''));
          } else {
            ctrl.scrollUp = "";
            ctrl.scrollDown = "";
          }
          ctrl.busy = false;
        });
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
          deviceId: ctrl.deviceSelected,
          dataMin: tmpDates.startDate,
          dataMax: tmpDates.endDate,
          zoomMin: tmpDates.startDate + ctrl.unixDay,
          zoomMax: tmpDates.endDate - ctrl.unixDay,
          windowId: ctrl.windowId
        });
      }
    });
  };

  ctrl.selectMyDate = function (date) {
    ctrl.myDate = date;
    /////////////////////////////////////////////////////////////
    currentScrollbarPosition = 0;
    previousScrollbarPosition = 0;
    ctrl.checkFirstRowLiveStatus = null;
    _unRegisterListener(ctrl.deviceSelected);
    /////////////////////////////////////////////////////////////
    var tmpDates = ctrl.myDate;
    var tmpDatesA = tmpDates;
    tmpDates.setHours(0, 0, 0, 0);
    tmpDates = datetimeService.dateToUnixtime(tmpDates);
    tmpDates = datetimeService.getNewStartEndDates(tmpDates, ctrl.deviceSelectedType === 10 || ctrl.deviceSelectedType === 15 ? 90 : 10);
    tmpDatesA.setHours(12, 0, 0, 0);
    tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
    /////////////////////////////////////////////////////////////
    ctrl.start = tmpDates.startDate;
    if (new Date(ctrl.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
      ctrl.end = tmpDatesA;
    } else {
      ctrl.end = tmpDates.endDate;
    }
    /////////////////////////////////////////////////////////////
    ctrl.startRow = 1;
    ctrl.pageSize = 50;
    ctrl.customerId = ctrl.accountInfo.customerId;
    ctrl.timeZone = ctrl.accountInfo.timeZone;
    ctrl.deviceId = ctrl.deviceSelected;
    ctrl.windowTitle = ctrl.windowTitle;
    ctrl.alerts = [];
    ctrl.pullData(true, "");
    /////////////////////////////////////////////////////////////
    sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
      deviceId: ctrl.deviceSelected,
      dataMin: tmpDates.startDate,
      dataMax: tmpDates.endDate,
      zoomMin: tmpDates.startDate + ctrl.unixDay,
      zoomMax: tmpDates.endDate - ctrl.unixDay,
      windowId: ctrl.windowId
    });
  };

  var _setLiveDataStatus = function _setLiveDataStatus(firstRow, liveDataStatusOn) {
    if (ctrl.checkFirstRowLiveStatus === true) {
      _checkTopOffset(liveDataStatusOn);
    } else if (ctrl.checkFirstRowLiveStatus === null) {
      timeLapseService.getLocalDateTime().then(function (result) {
        if (parseFloat(firstRow) + parseFloat(ctrl.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
          ctrl.checkFirstRowLiveStatus = true;
          _checkTopOffset(liveDataStatusOn);
        } else {
          ctrl.checkFirstRowLiveStatus = false;
        }
      });
    }
  };

  var _checkTopOffset = function _checkTopOffset(liveDataStatusOn) {
    if (liveDataStatusOn) {
      _registerListener(ctrl.deviceSelected);
    } else {
      _unRegisterListener(ctrl.deviceSelected);
    }
  };

  var wsDataReceivedVOLTAGE = function wsDataReceivedVOLTAGE(data) {
    var i = 0;
    if (ctrl.liveData === false) {
      _unRegisterListener(ctrl.deviceSelected);
      return;
    }

    var varTime = datetimeService.socketStrToServerStrTime(data.Time);
    var varValue = parseFloat(data.Value);
    var varType = data.Type;
    var varVBATT = null;
    var varVAC = null;

    ctrl.end = datetimeService.toUnixtime(data.Time) + ctrl.unixDay;

    if (varType == "VBATT") {
      varVBATT = varValue;
    } else {
      if (ctrl.deviceSolar && ctrl.deviceModel != 18 && ctrl.voltageTableService.deviceModel != 19) {
        varVAC = (100 * varValue + 140) / 100;
      } else if (ctrl.voltageTableService.deviceSolar) {
        varVAC = 100 * varValue / 100;
      } else {
        varVAC = 100 * varValue * 0.707 / 100;
      }
    }

    var _newRecord;
    var _recordExistAtIndex = null;
    var _channelIndex = null;

    for (i = 0; i < ctrl.items.length; i++) {
      if (ctrl.items[i].localDateTime == varTime) {
        _recordExistAtIndex = i;
        if (varType == "VBATT") {
          ctrl.items[i].battery = varVBATT;
        } else {
          ctrl.items[i].acSupply = varVAC;
        }
        break;
      }
    }

    if (_recordExistAtIndex === null) {
      _newRecord = {
        localDateTime: varTime,
        battery: varVBATT,
        acSupply: varVAC
      };
      ctrl.items.unshift(_newRecord);
      _recordExistAtIndex = 0;
    }

    ctrl.lastUpdateAt = varTime;
  };

  $scope.$on("processReconnect", function (event, args) {
    ctrl.reconnectData(event, args);
  });

  ctrl.reconnectData = function (event, args) {
    sharedSetupService.processReconnect({
      stickyProperties: ctrl.stickyProperties,
      localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
      dateRangeOption: null,
      windowTitle: ctrl.windowTitle,
      fnUnregister: _unRegisterListener,
      fnGetData: ctrl.openTableInLiveMode(),
      viewType: "Table"
    });
  };

  ctrl.mostRecentData = function (event, args) {
    ctrl.stickyProperties.liveData = true;
    ctrl.myDate = null;
    ctrl.reconnectData(event, args);
  };

  var _registerListener = function _registerListener(varSelectedSN) {
    sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
      liveData: true,
      windowId: ctrl.windowId
    });
    ctrl.liveData = true;
    ctrl.liveDataLine(ctrl.liveData);
    ctrl.numberOfNewRecordsPrevious = -1;
    websocketService.connect();
    websocketService.register("VBATT", varSelectedSN, "", wsDataReceivedVOLTAGE, null); //one call-back to reconnect is enough
    websocketService.register("VAC", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
  };

  var _unRegisterListener = function _unRegisterListener(varSelectedSN) {
    sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
      liveData: false,
      windowId: ctrl.windowId
    });
    if (ctrl.liveData === false) return;
    ctrl.liveData = false;
    ctrl.liveDataLine(ctrl.liveData);
    ctrl.lastUpdateAt = undefined;
    websocketService.unRegister("VBATT", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
    websocketService.unRegister("VAC", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
  };

  $scope.$on("ngRepeatFinished", function (ngRepeatFinishedEvent) {
    _autoScroll();
    ctrl.checkFirstRowLiveStatus = null;
    ctrl.trgScroll();
  });

  var _autoScroll = function _autoScroll() {
    if (ctrl.numberOfNewRecordsPrevious > 0) {
      var trRow = element.find("tr").eq(ctrl.numberOfNewRecordsPrevious - 1);
      var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
      element.scrollTop(yPosition);
    } else {
      $timeout(function () {
        element.animate({
          scrollTop: 5
        }, 500);
      }, 0);
    }
  };

  $scope.$on("$destroy", function () {
    _unRegisterListener(ctrl.deviceSelected);
  });
}
VoltageTableController.$inject = ["$scope", "$rootScope", "translationService", "sharedSetupService", "openViewService", "$timeout", "$element", "authenticationService", "timeLapseService", "datetimeService", "websocketService", "VoltageTableFactory"];
'use strict';

angular.module('mc.voltage-table').component('voltageTable', {
    controller: VoltageTableController,
    templateUrl: 'ui/voltage/voltage-table-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<',
        myDate: '<',
        onDeviceNameChange: '&'
    }
});
mcapp.controller('voltageGaugeController', ['$scope', '$rootScope', 'sharedSetupService', 'openViewService', 'authenticationService', function ($scope, $rootScope, sharedSetupService, openViewService, authenticationService) {
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.minPadding = sharedSetupService.minPadding;
    $scope.maxPadding = sharedSetupService.maxPadding;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
    $scope.alerts = [];
    $scope.loadingInProgress = true;
    $scope.time = null;
    $scope.deviceName = null;
    sharedSetupService.getWindowId($scope);
    $scope.downloadViewTypeOptions = [0];

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);

        $scope.popup.dialog({
            resize: function(event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function(event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function(event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function() {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)')
                .css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height",
                $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") -
                $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.voltage-gauge-container').css("height",
                $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") -
                $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") -
                $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") -
                20);
            //$scope.adjustDeviceIdMenuSize();
        };

        $scope.adjustDeviceIdMenuSize = function() {
            var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")
            if (spph < 450) {
                $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            } else {
                $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        };
    }
}]);

mcapp.directive('drawVoltageGauge', ['$rootScope', '$timeout', 'voltageGaugeService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'openViewService', 'sharedSetupService', function ($rootScope, $timeout, voltageGaugeService, datetimeService, websocketService, timeLapseService, toaster, openViewService, sharedSetupService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {

        element.on(
                    "mouseover.drawVoltageGauge",
                    ".hcolVoltage",
                    function (event) {
                        var localScope = $(event.target).scope();
                        if ($(event.currentTarget).is(".hcolVoltage") && !scope.mobile && !scope.classicView) {
                            $(event.currentTarget).draggable({
                                helper: "clone",
                                revert: false,
                                appendTo: "body",
                                containment: "body",
                                opacity: 0.35,
                                stop: function (event, ui) {
                                    var mcDevice = { deviceId: scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: scope.deviceSelectedSn };

                                    var optionsStickyProperties = {
                                        device: mcDevice
                                    };

                                    var $newPosX = ui.offset.left;
                                    var $newPosY = ui.offset.top;
                                    var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                                    openViewService.openWidget('Voltage Widget', { width: 240, height: 240 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                    //throw 500;
                                    scope.$apply();

                                }
                            });
                        }
                    }
                );

        scope.$on(
                   "$destroy",
                   function (event) {
                       element.off("mouseover.drawVoltageGauge");
                   }
               );

        var chart;
        var voltageGauges = [];
        var xValue = null;
        var scrollingInProgress = false;
        var zoomLevelCurrent, zoomLevelPrevious = 0;
        element.attr("class", "chart voltage-gauge-container");

        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                element.empty();
                var _device = { deviceName: scope.deviceSelectedName };
                scope.loadingInProgress = true;
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                scope.stickyProperties.on = false;
                _getData(newValue);
            }
        }, true);

        var _getData = function (deviceId) {
            voltageGaugeService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + deviceId)
                .then(function (datafromFactory) {
                    scope.gaugeData = datafromFactory.data;
                    scope.deviceModel = datafromFactory.data.device.model;
                    scope.alerts = [];
                    voltageGauges = [];
                    if (scope.gaugeData.setting && scope.gaugeData.setting.length >= 1) {
                        for (var j = 0; j < scope.gaugeData.setting.length; j++) {
                            // Check if measurement data exists
                            if (!scope.gaugeData.measurement || !scope.gaugeData.measurement[j]) {
                                continue;
                            }
                            scope.time = scope.gaugeData.measurement[j].unixTime;
                            scope.deviceName = scope.gaugeData.device.name;
                            _drawGauge(scope.gaugeData.device, scope.gaugeData.setting[j], scope.gaugeData.measurement[j]);
                        }
                    }
                    else {
                        element.empty();
                        scope.loadingInProgress = false;
                        scope.alerts.push({ msg: "No data available!", type: "danger" });
                    }
            });
        };

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                if (oldValue) {
                    _unRegisterListener(oldValue);
                }
            }
        }, true);


        var _drawGauge = function (device, setting, measurement) {

            var liveDataId = setting.id == "Battery" ? "VBATT" : "VAC";
            var reconnectFn = setting.id == "Battery" ? wsReconnectVOLTAGE : null;
            var container = document.createElement('div');
            container.setAttribute("class", "hcolVoltage");
            container.setAttribute("mc-deviceid", device.deviceId);
            container.setAttribute("mc-channel", setting.id);
            element.append(container);

            _registerListener(liveDataId, scope.deviceSelectedSn, reconnectFn)

            var varAlignment = '';
            varAlignment = setting.id == "Battery" ? varAlignment.concat(Array(5).join('\u00a0'), ' ') : varAlignment.concat(Array(2).join('\u00a0'), ' ');


            chart = new Highcharts.Chart({
                chart: {
                    renderTo: container,
                    type: 'gauge',
                    plotBackgroundColor: null,
                    plotBackgroundImage: null,
                    backgroundColor: 'rgba(0,0,0,0)',
                    plotBorderWidth: 0,
                    plotShadow: false,
                    spacing: [0, 0, 0, 0]
                },
                title: {
                    text: null
                },
                exporting: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    enabled: true,
                    followPointer: true,
                    followTouchMove: true,
                    formatter: function () {
                        return Highcharts.dateFormat('%b %e, %Y %H:%M:%S', scope.time) + ': <br><b>' + this.y.toFixed(2) + " " + setting.unit + "</b>";
                    }
                },
                pane: {
                    startAngle: -150,
                    endAngle: 150

                },
                yAxis: [{
                    min: setting.minimumValue,
                    max: setting.maximumValue,
                    minorTickWidth: 0,
                    tickWidth: 1,
                    tickLength: 10,
                    tickColor: '#666',
                    tickPositions: [setting.minimumValue, setting.lowAlarmValue, scope.deviceModel !=21 ? setting.highAlarmValue : parseFloat(measurement.value.toFixed(2)), setting.maximumValue],
                    plotBands: [{
                        from: setting.minimumValue,
                        to: setting.lowAlarmValue,
                        color: '#DF5353' // red
                    }, {
                        from: setting.lowAlarmValue,
                        to: scope.deviceModel !=21 ? setting.highAlarmValue : measurement.value,
                        color: '#55BF3B'// green
                    }, {
                        from: scope.deviceModel !=21 ?setting.highAlarmValue : measurement.value,
                        to: setting.maximumValue,
                        color: '#DDDF0D'// yellow
                    }],
                    title: {
                        text: '<p style="text-align:center;">' + setting.name + '</p>',
                        y: 15
                    },
                    lineColor: '#000000'
                }],
                plotOptions: {
                    gauge: {
                        dataLabels: {
                            y: -10,
                            borderWidth: 0,
                            useHTML: true
                        }
                    }
                },
                series: [{
                    data: [measurement.value],
                    dataLabels: {
                        enabled: true,
                        borderWidth: 0,

                        format: '<div style="text-align:center; margin-top:20px;"><span style="font-size:120%; color:' +
               ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y:.2f}</span><br/>' +
                  '<span style="font-size:100%;">' + setting.unit + '</span></div>'

                    }
                }]
            });

            var agg = { Type: liveDataId, Chart: chart };
            voltageGauges.push(agg);

        };
        //==========================socket data================================
        var wsDataReceivedVOLTAGE = function (data) {
            var varValue = parseFloat(data.Value);
            var varType = data.Type;
            var varVBATT = null;
            var varVAC = null;

            scope.time = datetimeService.toUnixtime(data.Time);

            if (varType == "VBATT") {
                varVBATT = varValue;
            }
            else {


                if (scope.solar && scope.deviceModel != 18 && scope.deviceModel != 19) {
                    varVAC = (100 * varValue + 140) / 100;
                }
                else if (scope.solar) {
                    varVAC = (100 * varValue) / 100;
                }
                else {
                    varVAC = (100 * varValue * .707) / 100;
                }
            }

            if (varType == "VBATT") {
                voltageGauges[0].Chart.series[0].points[0].update(varVBATT);
            }
            if (varType == "VAC") {
                voltageGauges[1].Chart.series[0].points[0].update(varVAC);
            }

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            scope.lastUpdateAt = varTime;
        };

        scope.mostRecentData = function () {
            element.empty();
            toaster.pop('success', scope.windowTitle + " -- " + scope.deviceName, 'View reloading');
            _getData(scope.deviceSelected);
        }

        var wsReconnectVOLTAGE = function (data) {
            _unRegisterListener(scope.deviceSelected);
            element.empty();
            toaster.pop('success', scope.windowTitle + " -- " + scope.deviceName, 'View reloading');
            scope.stickyProperties.on = true;
            _getData(scope.deviceSelected);
        };

        var _registerListener = function (varLiveDataId, varSelectedSN, varReconnectFn) {
            websocketService.connect();
            websocketService.register(varLiveDataId, varSelectedSN, "", wsDataReceivedVOLTAGE, varReconnectFn);
            scope.liveData = true;
        };

        var _unRegisterListener = function (varSelectedSN) {
            websocketService.unRegister("VBATT", varSelectedSN, "", wsDataReceivedVOLTAGE, wsReconnectVOLTAGE);
            websocketService.unRegister("VAC", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
            scope.liveData = false;
            scope.lastUpdateAt = undefined;
        };

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
            angular.forEach(voltageGauges, function (value, key) {
                if (value.Chart) value.Chart.destroy();
            });
        });

    };
}]);

mcapp.factory('voltageGaugeService', ['$http', 'HOST', function ($http, HOST) {
    var voltageGaugeFatory = {};

    var _getData = function (varParm) {
        return $http({
            method: 'Get',
            url: HOST + '/api/VoltageGauge?' + varParm,
            cache: false
        });
    };
    voltageGaugeFatory.getData = _getData;
    return voltageGaugeFatory;
}]);

"use strict";

angular.module("mc.welcome-to-scada", []);
"use strict";

mcapp.factory("welcomeToScadaService", ["$http", "HOST", function ($http, HOST) {
    var welcomeToScadaFactory = {};

    var _removeWelcomeMessage = function _removeWelcomeMessage(customerId, loginId) {
        return $http.put(HOST + '/api/preferenceUser/RemoveWelcomeMessage?customerId=' + customerId + "&loginId=" + loginId + "&" + new Date().getTime());
    };

    var _listUserWithLastLogin = function _listUserWithLastLogin(customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/UserLoginReport/LastLogin?customerId=' + customerId + "&" + new Date().getTime(),
            cache: false,
            async: false
        });
    };
    welcomeToScadaFactory.removeWelcomeMessage = _removeWelcomeMessage;
    welcomeToScadaFactory.listUserWithLastLogin = _listUserWithLastLogin;
    return welcomeToScadaFactory;
}]);
"use strict";

function WelcomeToScadaController($, $rootScope, $scope, welcomeToScadaService, authenticationService, translationService, sharedSetupService, $location, $window, openViewService, $interval) {
    var ctrl = this;
    var timer; // Variable to hold the $interval promise


    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.customerName = ctrl.accountInfo.customerName;
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        ctrl.mobile = $rootScope.mobile;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.showMsg = false;
        ctrl.displayAll = null;
        ctrl.loading = true;

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
        }

        if (ctrl.mobile) $window.sessionStorage.setItem("msr", true); //Mission Security Reminder August, 2026//

        ctrl.listUserWithLastLogin();

        ctrl.counter = ctrl.isMcAdmin || ctrl.accountInfo.userType == "TechSupport" ? 1 : 10;
        ctrl.buttonDisabled = true;
        ctrl.startTimer();
    };

    ctrl.goToHomePage = function () {
        var tmpHome = "/";
        $location.path(tmpHome);
    };

    ctrl.closeView = function () {
        ctrl.popup.dialog("close");
    };

    ctrl.removeWelcomeMessage = function () {
        welcomeToScadaService.removeWelcomeMessage(ctrl.accountInfo.customerId, ctrl.accountInfo.userId).then(function (result) {
            ctrl.accountInfo.preferenceUser.defaultDesktopID = result.data.defaultDesktopID;
            authenticationService.setAccountInfo(ctrl.accountInfo);
            ctrl.closeView();
        }, function (error) {
            console.log("Unable to remove Welcome Message");
        });
    };

    ctrl.listUserWithLastLogin = function () {
        welcomeToScadaService.listUserWithLastLogin(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.loading = false;
            if (ctrl.mobile) {
                angular.forEach(result.data, function (user) {
                    if (user.loginStatus == 1) {
                        user.statusLabel = 'Logged in within 30 days';
                    }
                });
            }
            ctrl.listUserLastLogin = result.data;
            ctrl.usersToDisplay = ctrl.getUsersToDisplay(ctrl.listUserLastLogin);
            ctrl.displayAll = ctrl.listUserLastLogin.length > 4 ? true : null;
        }, function (error) {
            //
        });
    };

    ctrl.seeAll = function () {
        ctrl.usersToDisplay = ctrl.displayAll ? ctrl.listUserLastLogin : ctrl.getUsersToDisplay(ctrl.listUserLastLogin);
        ctrl.displayAll = !ctrl.displayAll;
    };

    ctrl.getLoginStatusIcon = function (loginStatus) {
        switch (loginStatus) {
            case 1:
                return '🟢 ';
            case 2:
            case 3:
                return '🟡 ';
            default:
                return '🔴 ';
        }
    };

    ctrl.manageUsers = function () {
        sharedSetupService.setStickyProperties($scope.stickyProperties, { device: { deviceId: $scope.deviceSelected }, deviceId: $scope.deviceSelected, windowId: $scope.windowId });
        if (!$rootScope.mobile && !$rootScope.classicView) {
            openViewService.openView('User Accounts', { width: 900, height: 590 }, undefined, $scope.stickyProperties, { minimumWidth: 900, minimumHeight: 590 });
        } else {
            $location.path('/account/useraccounts/user-accounts-template');
        }
    };

    //Turn off/disable popup on mobile view
    ctrl.removeWelcomeMessageMobile = function () {
        $window.localStorage.setItem("msr", true); //Mission Security Reminder August, 2026//
        ctrl.goToHomePage();
    };

    ctrl.startTimer = function () {
        // Start the timer if it's not already running
        if (angular.isDefined(timer)) return;

        timer = $interval(function () {
            ctrl.counter--; // Decrement the counter every second
            if (ctrl.counter == 0) {
                ctrl.stopTimer();
                ctrl.counter = "OK";
                ctrl.buttonDisabled = false;
            }
        }, ctrl.isMcAdmin || ctrl.accountInfo.userType == "TechSupport" ? 0 : 1000); // 1000 milliseconds = 1 second
    };

    ctrl.stopTimer = function () {
        // Stop the timer
        if (angular.isDefined(timer)) {
            $interval.cancel(timer);
            timer = undefined;
        }
    };

    ctrl.getUsersToDisplay = function (users) {
        var maxUsers = 4;
        var groups = [1,, 2, 3, 4];
        var selected = [];
        var selectedIds = {};

        // Assumes users are already sorted in the order you want displayed.
        // First: select one user from each login-status group.
        angular.forEach(groups, function (group) {
            var user = users.find(function (item) {
                return item.loginStatus === group && !selectedIds[item.userId];
            });

            if (user) {
                selected.push(user);
                selectedIds[user.userId] = true;
            }
        });

        // Then: if a group had no users, fill remaining positions
        // with the next available users from any group.
        angular.forEach(users, function (user) {
            if (selected.length >= maxUsers) {
                return;
            }

            if (!selectedIds[user.userId]) {
                selected.push(user);
                selectedIds[user.userId] = true;
            }
        });

        return selected;
    };

    // Clean up the listener when the modal is closed or destroyed
    $scope.$on('$destroy', function () {
        ctrl.stopTimer();
    });
};

WelcomeToScadaController.$inject = ['$', '$rootScope', '$scope', 'welcomeToScadaService', 'authenticationService', 'translationService', 'sharedSetupService', '$location', '$window', 'openViewService', '$interval'];
'use strict';

angular.module('mc.welcome-to-scada').component('welcomeToScada', {
    controller: WelcomeToScadaController,
    templateUrl: 'ui/welcometoscada/welcome-to-scada-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.controller("uploadLogoController", ['$scope', 'fileUpload', 'HOST', '$interval', 'authenticationService', "translationService", '$window', '$rootScope',
function ($scope, fileUpload, HOST, $interval, authenticationService, translationService, $window, $rootScope) {
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.popup = _this.getExistingDialog($scope.windowId).ref;
    $scope.translation = translationService.translation;
    $scope.dynamic = 0;
    $scope.max = 100;
    $scope.stopTime = undefined;
    $scope.tmpErrorExt = false;

    $scope.uploadFile = function () {
        //$scope.stopTime = $interval($scope.updateTime(), 40);
        var file = $scope.myFile;
        //console.log('file is ');
        //console.dir(file);
        var uploadUrl = HOST + "/api/uploadFile?CustomerId=" + $scope.accountInfo.customerId;
        fileUpload.uploadFileToUrl(file, uploadUrl, $scope.uploadDone);
    };

    $scope.cancelUpload = function () {
        $scope.myFile = {};
        //setTimeout(function () {
        //    $("#yourLogoControll").trigger("change");
        //}, 500);
        $scope.dynamic = 0;
        $interval.cancel($scope.stopTime);
        if (angular.isDefined($scope.stopTime)) {
            $interval.cancel($scope.stopTime);
            $scope.stopTime = undefined;
        }
        $scope.popup.dialog("close");
    };

    $scope.updateTime = function () {
        $scope.dynamic = $scope.dynamic + 5;
        if ($scope.dynamic >= 99)
            $interval.cancel($scope.stopTime);
    }

    $scope.uploadDone = function () {
        $scope.dynamic = 100;
        $scope.accountInfo.logoName = $rootScope.backgroundLogo
        authenticationService.setAccountInfo($scope.accountInfo);
        //$interval.cancel($scope.stopTime);
        $scope.popup.dialog("close");
    }

    $scope.readURL = function (input) {
        var allowExt = ["png", "gif", "jpg", "jpeg"];

        if (input.files && input.files[0]) {
            var tmpExt = input.files[0].name.split('.').pop();
            if (allowExt.indexOf(tmpExt.toLowerCase()) < 0) {
                $scope.tmpErrorExt = true;
                return;
            } else {
                $scope.tmpErrorExt = false;
            }
            $scope.reader = new FileReader();

            $scope.reader.onload = function (e) {
                $('#yourLogoImage').attr('src', e.target.result);
                var w = parseInt($('#yourLogoImage').css('width').replace(/[^0-9.]+/g, ""));
                var h = parseInt($('#yourLogoImage').css('height').replace(/[^0-9.]+/g, ""));
                if (w > h) {
                    $('#yourLogoImage').attr('width', '180px');
                    $('#yourLogoImage').attr('height', null);
                    }
                else {
                    $('#yourLogoImage').attr('height', '180px');
                    $('#yourLogoImage').attr('width', null);
                }
            }
            $scope.reader.readAsDataURL(input.files[0]);
        }
    }

    $("#yourLogoControll").change(function () {
        $scope.readURL(this);
    });

}]);


mcapp.directive('fileModel', ['$parse', '$interval', function ($parse, $interval) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var model = $parse(attrs.fileModel);
            var modelSetter = model.assign;

            element.bind('change', function () {
                scope.$apply(function () {
                    modelSetter(scope, element[0].files[0]);
                });
            });

            element.on('$destroy', function () {
                $interval.cancel(scope.stopTime);
            });
        }
    };
}]);

mcapp.service('fileUpload', ['$http', '$rootScope', 'HOST', 'LOCALHOST', function ($http, $rootScope, HOST, LOCALHOST) {
    this.uploadFileToUrl = function (file, uploadUrl, cb) {
        var fd = new FormData();
        fd.append('file', file);
        $http.post(uploadUrl, fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        })
        .then(function (result) {
            $rootScope.backgroundLogo = (document.location.hostname === "localhost" ? LOCALHOST + HOST : HOST) + "/images/cust/" + result.data.toString(),//"/mc.services/images/" + result.data.toString();
            cb();
        }, function (data) {
            console.log("Error");
            $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
            cb();
        });
    }
}]);

angular.module('mc.video-player', []);

'use strict';

function VideoPlayerController($scope, $timeout, $window, sharedSetupService) {
  var _this2 = this;

  this.replaceSpaces = function (str) {
    if (str) {
      return str.replace(new RegExp(' ', 'g'), '_');
    }

    return '';
  };

  this.$onInit = function () {
    $scope.mobile = _this2.mobile;
    $scope.classicView = _this2.classicView;
    $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
    _this2.windowId = _this2.windowId || 'VIDEO PLAYER';
    $scope.windowId = JSON.parse(JSON.stringify(_this2.windowId));
    sharedSetupService.setStickyProperties($scope.stickyProperties, { windowId: _this2.windowId });

    var width = void 0;
    var height = void 0;

    if ($window.innerWidth <= 480) {
      width = 300;
      height = 300 * .563;
    } else if ($window.innerWidth <= 768) {
      width = 500;
      height = 500 * .563;
    } else if ($window.innerWidth <= 992) {
      width = 700;
      height = 700 * .563;
    } else {
      width = 1000;
      height = 1000 * .563;
    }

    var options = {
      id: _this2.stickyProperties.deviceId,
      autoplay: true,
      width: width,
      height: height
    };

    $timeout(function () {
      var player = new Vimeo.Player('video-' + _this2.replaceSpaces(_this2.windowId), options);

      $timeout(function () {
        player.element.style.width = width;
        player.element.style.height = height;
      }, 200);

      if (!_this2.mobile && !_this2.classicView) {
        _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
        _this2._popup.dialog({
          resize: function resize(event, ui) {
            _this2.adjustSize(ui);
          },
          resizeStop: function resizeStop(event, ui) {
            $('#map').removeClass('no-events');
            _this2.adjustSize(ui);
          }
        });

        _this2._popup.dialogExtend({
          maximize: function maximize(event, ui) {
            _this2.adjustSize();
          },
          restore: function restore(event, ui) {
            _this2.adjustSize({ size: { width: _this2._popup[0].clientWidth }, originalSize: { width: 0 } });
          }
        });

        _this2.adjustSize = function (ui) {
          if (ui === undefined) {
            player.element.style.width = _this2._popup[0].clientWidth;
            player.element.style.height = _this2._popup[0].clientHeight;
          } else {
            //scada-1251: perform following actions, if ui != undefined 
            if (ui.originalSize.width !== ui.size.width) {
              // Update height to match new width
              _this2._popup.parent().css('height', ui.size.width * .563 + 38);
              //this._popup.parent().find('div:eq(2)')[0].style.height = (ui.size.width * .563) + 38;
              //this._popup.parent().find('div:eq(2)')[0].style.width = ui.size.width;
              _this2._popup.parent().find('div:eq(2)').css('height', ui.size.width * .563 + 38);
              _this2._popup.parent().find('div:eq(2)').css('width', ui.size.width);
              player.element.style.width = ui.size.width - 12;
              player.element.style.height = ui.size.width * .563;
            } else if (ui.originalSize.height !== ui.size.height) {
              // Update width to match new height
              _this2._popup.parent().css('width', ui.size.height * (1 / .563) + 12);
              _this2._popup.parent().find('div:eq(2)').css('height', ui.size.height);
              _this2._popup.parent().find('div:eq(2)').css('width', ui.size.height * (1 / .563) + 12);
              player.element.style.width = ui.size.height * (1 / .563);
              player.element.style.height = ui.size.height - 38;
            }
          }
        };
      }
    });
  };
}

VideoPlayerController.$inject = ['$scope', '$timeout', '$window', 'sharedSetupService'];

angular.module('mc.video-player').component('videoPlayer', {
  controller: VideoPlayerController,
  transclude: true,
  templateUrl: 'ui/videoplayer/video-player-partial.html',
  bindings: {
    windowId: '<',
    mobile: '<',
    classicView: '<',
    stickyProperties: '<'
  }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function UserLoginReportController($scope, $rootScope, $filter, sharedSetupService, openViewService, datetimeService, authenticationService, translationService, savePdfService, $element, $timeout, UserLoginReportFactory, timeLapseService, websocketService, toaster, getDateRangeService) {
  var _this2 = this;

  var ctrl = this;
  $scope.alerts = [];
  ctrl.$onInit = function () {
    if (_typeof(ctrl.stickyProperties) != 'object') {
      ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
    }
    sharedSetupService.getWindowId(ctrl);
    ctrl.reverse = true;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
    ctrl.unixDay = sharedSetupService.unixDay;
    ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    ctrl.downloadViewTypeOptions = [1, 2];
    ctrl.customerId = ctrl.accountInfo.customerId;
    ctrl.items = [];
    ctrl.busy = false;
    ctrl.showMsg = false;
    ctrl.deviceName = '';
    $scope.windowTitle = ctrl.windowTitle;
    ctrl.goSelectReportData(false);

    if (!ctrl.mobile && !ctrl.classicView) {
      ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
      sharedSetupService.maximize(ctrl.popup);

      $scope.adjustSize = function () {
        ctrl.adjustSize();
      };

      ctrl.popup.dialog({
        resize: function resize(event, ui) {
          ctrl.adjustSize();
        }
      });

      ctrl.popup.dialogExtend({
        maximize: function maximize(event, ui) {
          openViewService.adjustContentSizeStart(ctrl.popup);
          ctrl.adjustSize();
        },
        restore: function restore(event, ui) {
          openViewService.adjustContentSizeStart(ctrl.popup);
          ctrl.adjustSize();
        }
      });

      ctrl.adjustSize = function () {
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
      };
    }
  };
  $scope.$on("updatePreferencesTimeFormat", function (event, timeFormat) {
    ctrl.timeFormat = timeFormat;
    ctrl.updateLanguage();
  });

  $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
    if ($scope.alerts.length > 0) {
      var _msg = eval("scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
      var _type = scope.alerts[0].type;
      var _languageCode = $scope.alerts[0].languageCode;
      if (_languageCode.toUpperCase() === 'NO_DATA') {
        _msg += ': ' + moment($scope.userLoginReportService.start).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.userLoginReportService.end).format('MM/DD/YY, h:mm:ss a');
      }
      $scope.alerts = [];
      $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
    }
  });

  ctrl.updateLanguage = function () {
    ctrl.items = angular.copy(ctrl.items);
  };

  ctrl.savePdf = function () {
    var windowTitle = $scope.windowTitle.toUpperCase().replace(/ /g, "_");
    var pdfParams = {
      windowTitle: windowTitle,
      pdfTitle: eval("$scope.translation.text." + windowTitle),
      customerName: ctrl.accountInfo.customerName,
      customerId: ctrl.accountInfo.customerId,
      dateTranslate: ctrl.translation.text.DATE_CREATED,
      dateRangeStart: ctrl.myDateRangeStart,
      dateRangeEnd: ctrl.myDateRangeEnd,
      $scope: $scope,
      $element: $element
    };

    savePdfService.savePDF(pdfParams);
  };

  ctrl.toggle = function ($event) {
    if ($($event.currentTarget).hasClass("active-row")) {
      $($event.currentTarget).removeClass("active-row");
    } else {
      $($event.currentTarget).addClass("active-row");
    }
  };

  ctrl.mostRecentData = function () {
    toaster.pop('success', $scope.windowTitle + " -- " + ctrl.deviceName, 'View reloading');
    ctrl.goSelectReportData(true);
  };

  ctrl.goSelectReportData = function (isRefresh) {
    if (_typeof(ctrl.stickyProperties) != 'object') {
      ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
    }
    ctrl.busy = true;
    ctrl.alerts = [];
    ctrl.maxDateRange = getDateRangeService.getRange("UserLoginHistory");
    if (ctrl.stickyProperties.on != true) {
      //set new start date to be 7 days before end date
      ctrl.stickyProperties.dateMin = new Date(ctrl.stickyProperties.dateMax).setDate(new Date(ctrl.stickyProperties.dateMax).getDate() - 7);
    }

    var numberOfDays = 7,
        varDateRangeStart,
        varDateRangeEnd,
        varDateRangeEndTmp;

    if (ctrl.stickyProperties.on == true) {
      ctrl.stickyProperties.on = false;
      varDateRangeStart = ctrl.stickyProperties.dateMin;
      varDateRangeEnd = ctrl.stickyProperties.dateMax;
      ctrl.myDateRangeStart = new Date(varDateRangeStart);
      ctrl.myDateRangeEnd = new Date(varDateRangeEnd);
    } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
      ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
      ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
      varDateRangeEnd = ctrl.myDateRangeEnd;
      varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
      varDateRangeStart = ctrl.myDateRangeStart;
      varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
    } else {
      ctrl.myDateRangeEnd = new Date();
      ctrl.myDateRangeStart = new Date();
      ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

      varDateRangeEnd = new Date();
      varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
      ///////// needed to calculate varDateRangeStart
      varDateRangeEndTmp = new Date();
      varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
      ///////// needed to calculate varDateRangeStart
      varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
    }
    //used for refresh button to reload newest data
    if (isRefresh) {
      ctrl.myDateRangeEnd = new Date();
      ctrl.myDateRangeStart = new Date();
      ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

      varDateRangeEnd = new Date();
      varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
      ///////// needed to calculate varDateRangeStart
      varDateRangeEndTmp = new Date();
      varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
      ///////// needed to calculate varDateRangeStart
      varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
    }
    _this2.start = varDateRangeStart;
    _this2.end = varDateRangeEnd;
    sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
      dataMin: varDateRangeStart,
      dataMax: varDateRangeEnd,
      zoomMin: varDateRangeStart,
      zoomMax: varDateRangeEnd,
      windowId: ctrl.windowId
    });
    // /////////////////////////////////////////////////////////////
    ctrl.checkFirstRowLiveStatus = null;
    // /////////////////////////////////////////////////////////////
    ctrl.showMsg = false;
    ctrl.UserLoginReport = new UserLoginReportFactory(ctrl.accountInfo.customerId);

    ctrl.UserLoginReport.getData(varDateRangeStart, varDateRangeEnd).then(function (result) {
      var tmpItems = result.data;
      tmpItems.forEach(function (item) {
        item.loginTime = item.loginTime;
        item.loginTimeSort = new Date(item.loginTime);
        item.duration = ("0" + (item.duration / 24 / 60).toFixed(0)).slice(-2) + ':' + ("0" + parseInt(item.duration / 60 % 24)).slice(-2) + ':' + ("0" + item.duration % 60).slice(-2);
        item.userLocation = (item.userLocation.country + ", " + item.userLocation.city + ", " + item.userLocation.region).replace(", , ", "");
        item.ipAddress = item.ipAddress;
        item.userName = item.userName;
      });
      ctrl.items = tmpItems;
      ctrl.busy = false;
    });
  };

  var orderBy = $filter("orderBy");
  ctrl.order = function (predicate, reverse) {
    switch (predicate) {
      case "userName":
        $scope.sortLoginTime = reverse ? "loginTimeSort" : "-loginTimeSort";
        ctrl.items = orderBy(ctrl.items, [predicate, ctrl.sortLoginTime], reverse);
        break;
      case "duration":
        ctrl.items = orderBy(ctrl.items, predicate, reverse);
        break;
      default:
        ctrl.items = orderBy(ctrl.items, predicate, reverse);
        break;
    }
    ctrl.predicate = predicate;
  };

  ctrl.setSorting = function () {
    ctrl.order("loginTimeSort", ctrl.reverse);
  };

  $scope.$watch("lastUpdateAt", function (newValue, oldValue) {
    if (newValue && newValue != oldValue) {
      ctrl.liveDataIn = !ctrl.liveDataIn;
      $timeout(function () {
        ctrl.liveDataIn = !ctrl.liveDataIn;
      }, 3000);
    }
  }, true);

  $scope.$watch("UserLoginReportFactory.alerts", function (newValue, oldValue) {
    if (newValue && newValue.length > 0 && newValue != oldValue) {
      ctrl.alerts = newValue;
    }
  }, true);

  $scope.$watch("deviceSelectedSn", function (newValue, oldValue) {
    if (newValue && newValue != oldValue) {
      if (oldValue) {
        _unRegisterListener(oldValue);
      }
    }
  }, true);

  $scope.$on("$destroy", function () {
    //_unRegisterListener(ctrl.deviceSelectedSn);
  });

  $scope.$on("ngRepeatFinished", function (ngRepeatFinishedEvent) {
    //_autoScroll();
    ctrl.checkFirstRowLiveStatus = null;
  });
};

UserLoginReportController.$inject = ["$scope", "$rootScope", "$filter", "sharedSetupService", "openViewService", "datetimeService", "authenticationService", "translationService", "savePdfService", "$element", "$timeout", "UserLoginReportFactory", "timeLapseService", "websocketService", "toaster", "getDateRangeService"];
mcapp.controller('userLoginReportController', ['$scope', '$rootScope', '$filter', 'sharedSetupService', 'openViewService', 'datetimeService', 'authenticationService', 'translationService', 'savePdfService', '$element', function ($scope, $rootScope, $filter, sharedSetupService, openViewService, datetimeService, authenticationService, translationService, savePdfService, $element) {
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.translation = translationService.translation;
    $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.alerts = [];
    $scope.oneTimeOnly = 0;
    $scope.reverse = true;
    $scope.downloadViewTypeOptions = [0, 1, 2];

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
    });

    $scope.savePdf = function () {

        var windowTitle = $scope.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: (eval("$scope.translation.text." + windowTitle)),
            customerName: $scope.accountInfo.customerName,
            customerId: $scope.accountInfo.customerId,
            dateTranslate: $scope.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        }

        savePdfService.savePDF(pdfParams);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {

        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);

        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
        };
    }
}]);

mcapp.directive('drawUserLoginReport', ['$timeout', 'userLoginReportService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', '$filter', 'getDateRangeService', function ($timeout, userLoginReportService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService, $filter, getDateRangeService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        scope.$ctrl = scope;
        scope.showMsg = false;

        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            if (scope.alerts.length > 0) {
                var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
                var _type = scope.alerts[0].type;
                var _languageCode = scope.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(scope.userLoginReportService.start).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.userLoginReportService.end).format('MM/DD/YY, h:mm:ss a');
                }
                scope.alerts = [];
                scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });

        element.on('scrollOff', function (event) {
            var $rowFirst = element.contents().find("tr:first");
            var $rowLast = element.contents().find("tr:last");
            var _firstRow = $rowFirst.attr("name");
            if (typeof $rowFirst.position() !== "undefined") {
                scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
                var _tableTop = element.offset().top;
                var _rowTop = $rowFirst.offset().top;
                _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
                previousScrollbarPosition = currentScrollbarPosition;
                currentScrollbarPosition = element[0].scrollTop;
            }

            if (scope.infiniteScrollOn === true) {
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;

                if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
                    //$rowLast.addClass("active-row");
                    scope.userLoginReportService.alerts = [];
                    scope.userLoginReportService.nextPage();
                }
                if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
                    //$rowFirst.addClass("active-row");
                    scope.userLoginReportService.alerts = [];
                    scope.userLoginReportService.previousPage();
                }
            }

            var rows = element.children().children().children().children();
            var scrollpos = 40;
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos)
                    start = mid + 1;
                else
                    end = mid;
            }
            _updateZoom(parseFloat($($(rows[start])).attr("name")));
        });

        var _updateZoom = function (currentRow) {
            if (isNaN(currentRow))
                return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            }
            else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('userLoginReportService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                if (oldValue) {
                    _unRegisterListener(oldValue);
                }
            }
        }, true);

        scope.mostRecentData = function () {
            toaster.pop('success', scope.windowTitle + " -- " + scope.userLoginReportService.deviceName, 'View reloading');
            scope.goSelectReportData(true);
        }

        scope.goSelectReportData = function (isRefresh) {
            scope.alerts = [];
            scope.maxDateRange = getDateRangeService.getRange("UserLoginHistory");

            //set new start date to be 7 days before end date
            scope.stickyProperties.dateMin = new Date(scope.stickyProperties.dateMax).setDate(new Date(scope.stickyProperties.dateMax).getDate() - 7);

            var numberOfDays = 7, varDateRangeStart, varDateRangeEnd, varDateRangeEndTmp;
            if (scope.stickyProperties.on == true) {
                scope.stickyProperties.on = false;
                varDateRangeStart = scope.stickyProperties.dateMin;
                varDateRangeEnd = scope.stickyProperties.dateMax;
                scope.myDateRangeStart = new Date(varDateRangeStart);
                scope.myDateRangeEnd = new Date(varDateRangeEnd - scope.unixDay);
            }
            else if (new Date(scope.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeEnd)) && new Date(scope.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeStart))) {
                scope.myDateRangeEnd = (new Date(scope.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeEnd))) ? scope.myDateRangeEnd : new Date();
                scope.myDateRangeStart = (new Date(scope.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeStart))) ? scope.myDateRangeStart : new Date();
                varDateRangeEnd = scope.myDateRangeEnd;
                varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999)
                varDateRangeStart = scope.myDateRangeStart;
                varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
            }
            else {
                scope.myDateRangeEnd = new Date();
                scope.myDateRangeStart = new Date();
                scope.myDateRangeStart.setDate(scope.myDateRangeStart.getDate() - numberOfDays)

                varDateRangeEnd = new Date();
                varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                ///////// needed to calculate varDateRangeStart
                varDateRangeEndTmp = new Date();
                varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
                ///////// needed to calculate varDateRangeStart
                varDateRangeStart = varDateRangeEndTmp - ((numberOfDays + 0) * scope.unixDay);
            }
            //used for refresh button to reload newest data
            if (isRefresh) {
                scope.myDateRangeEnd = new Date();
                scope.myDateRangeStart = new Date();
                scope.myDateRangeStart.setDate(scope.myDateRangeStart.getDate() - numberOfDays)

                varDateRangeEnd = new Date();
                varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                ///////// needed to calculate varDateRangeStart
                varDateRangeEndTmp = new Date();
                varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
                ///////// needed to calculate varDateRangeStart
                varDateRangeStart = varDateRangeEndTmp - ((numberOfDays + 0) * scope.unixDay);
            }
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            /////////////////////////////////////////////////////////////
            scope.showMsg = false;
            scope.userLoginReportService = new userLoginReportService();
            scope.userLoginReportService.customerId = scope.accountInfo.customerId;
            scope.userLoginReportService.deviceId = scope.deviceSelected;
            scope.userLoginReportService.windowTitle = scope.windowTitle;
            scope.userLoginReportService.startRow = 1;
            scope.userLoginReportService.pageSize = 50;
            scope.userLoginReportService.alerts = [];

            scope.userLoginReportService.start = varDateRangeStart
            scope.userLoginReportService.end = varDateRangeEnd;
            scope.userLoginReportService.nextPage();
            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: scope.windowId });
        };


        var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            }
            else if (scope.checkFirstRowLiveStatus === null) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.checkFirstRowLiveStatus = true;
                        _checkTopOffset(liveDataStatusOn);
                    }
                    else {
                        scope.checkFirstRowLiveStatus = false;
                    }
                });
            }
        };

        var _checkTopOffset = function (liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListener(scope.deviceSelectedSn);
            }
            else {
                _unRegisterListener(scope.deviceSelectedSn);
            }
        };

        var wsDataReceivedSIGNAL = function (data) {
            var i = 0;
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            var varValue = parseInt(data.Value);
            var _newMeasurements = { "localDateTime": varTime, "value": varValue };

            scope.userLoginReportService.items.unshift(_newMeasurements);
            scope.lastUpdateAt = varTime;
        };

        var wsReconnectSIGNAL = function (data) {
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }
            toaster.pop('success', scope.windowTitle + " -- " + scope.userLoginReportService.deviceName, 'View reloading');
            scope.stickyProperties.on = true;
            scope.userLoginReportService.start = scope.stickyProperties.dateMin;
            scope.userLoginReportService.end = scope.stickyProperties.dateMax;
            scope.userLoginReportService.items = [];
            scope.userLoginReportService.numberOfReturnedRecords = -1;
            scope.userLoginReportService.startRow = 1;
            scope.userLoginReportService.pageSize = 10000;
            scope.userLoginReportService.windowTitle = scope.windowTitle;
            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.stickyProperties.deviceId, windowId: scope.windowId });
            scope.userLoginReportService.alerts = [];
            scope.userLoginReportService.nextPage();
        };

        var _registerListener = function (varSelectedSN) {
            if (scope.liveData === true)
                return;
            scope.liveData = true;
            scope.userLoginReportService.numberOfNewRecordsPrevious = -1;
            websocketService.connect();
            websocketService.register("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, wsReconnectSIGNAL);
        };

        var _unRegisterListener = function (varSelectedSN) {
            if (scope.liveData === false)
                return;
            scope.liveData = false;
            scope.lastUpdateAt = undefined;
            websocketService.unRegister("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, wsReconnectSIGNAL);
        };

        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            //_autoScroll();
            scope.checkFirstRowLiveStatus = null;
        });

        var _autoScroll = function () {
            if (scope.userLoginReportService.numberOfNewRecordsPrevious > 0) {
                var trRow = element.find('tr').eq(scope.userLoginReportService.numberOfNewRecordsPrevious - 1);
                var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 10;
                element.scrollTop(yPosition);
            }
            else if (element[0].scrollTop <= 1)
                element.animate({
                    scrollTop: element.scrollTop() + 10
                }, 500);
        };

        var orderBy = $filter('orderBy');
        scope.order = function (predicate, reverse) {
            switch (predicate) {
                case "userName":
                    scope.sortLoginTime = reverse ? 'loginTimeSort' : '-loginTimeSort';
                    scope.userLoginReportService.items = orderBy(scope.userLoginReportService.items, [predicate, scope.sortLoginTime], reverse);
                    break;
                case "duration":
                    scope.userLoginReportService.items = orderBy(scope.userLoginReportService.items, predicate, reverse);
                    break;
                default:
                    scope.userLoginReportService.items = orderBy(scope.userLoginReportService.items, predicate, reverse);
                    break;
            }
            scope.predicate = predicate;
        };

        scope.setSorting = function () {
            scope.order('loginTimeSort', scope.reverse);
        };

        scope.goSelectReportData(false);

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
        });
    };
}]);

mcapp.factory('userLoginReportService', ['$http', 'datetimeService', 'toaster', 'userMessageService', 'translationService', 'REPORTS', function ($http, datetimeService, toaster, userMessageService, translationService, REPORTS) {
    var userLoginReportService = function () {
        this.items = [];
        this.deviceName = '';
        this.customerId = null;
        this.deviceId = null;
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.windowTitle = null;
        this.alerts = [];
        this.translation = translationService.translation;
    };

    userLoginReportService.prototype.previousPage = function () {
        if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
        this.busy = true;
        this.pageSize = -50;
        var url = REPORTS + "/api/UserLoginReport?customerId=" + this.customerId + "&StartDate=" + this.start + "&EndDate=" + this.end;
        $http.get(url).then(function (result) {
            /////////////////////////
            var intDayWindow = 365;
            var intDay = 86400000;
            /////////////////////////
            var items = result.data;
            for (var i = 0; i < items.length; i++) {
                items[i].loginTime = items[i].loginTime;
                items[i].userName = items[i].userName;
                items[i].duration = items[i].duration;
                items[i].ipAddress = items[i].ipAddress;
                this.items.unshift(items[i]);
            }
            this.numberOfNewRecordsPrevious = items.length;
            this.numberOfRecords = this.items.length;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) { //if there are records returned
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].loginTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = datetimeService.toUnixtime(this.items[0].loginTime.replace(/\D/g, ''));
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this), function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.message);
            this.alerts.push({ msg: errorMessage, type: "danger" });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };

    userLoginReportService.prototype.nextPage = function () {
        if (this.busy || this.numberOfReturnedRecords === 0) return;
        this.busy = true;
        var url = REPORTS + "/api/UserLoginReport?customerId=" + this.customerId + "&StartDate=" + this.start + "&EndDate=" + this.end;
        $http.get(url, { cache: false }).then(function (result) {
            /////////////////////////
            var intDayWindow = 365;
            var intDay = 86400000;
            /////////////////////////
            var items = result.data;
            for (var i = 0; i < items.length; i++) {
                items[i].loginTime = items[i].loginTime;//moment(items[i].loginTime).format('MM/DD/YYYY hh:mm:ss A');
                items[i].loginTimeSort = new Date(items[i].loginTime);
                items[i].userName = items[i].userName;
                items[i].duration = ("0" + (items[i].duration / 24 / 60).toFixed(0)).slice(-2) + ':' + ("0" + parseInt(items[i].duration / 60 % 24)).slice(- 2) + ':' + ("0" + (items[i].duration % 60)).slice(- 2);
                items[i].ipAddress = items[i].ipAddress;
                items[i].userLive = items[i].userLive;
                items[i].userLocation = (items[i].userLocation.country + ", " + items[i].userLocation.city + ", " + items[i].userLocation.region).replace(", , ", "");
                if (items[i].userLocation.substr(0, 4) === "US, ") items[i].userLocation = items[i].userLocation.substring(4);
                this.items.push(items[i]);
            }
            this.numberOfReturnedRecords = items.length;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) { //if there are records returned
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].loginTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = datetimeService.toUnixtime(this.items[0].loginTime.replace(/\D/g, ''));
            }
            else {
                this.alerts = [];
                var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).format('MM/DD/YY, h:mm:ss a');
                this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this), function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.message);
            this.alerts.push({ msg: errorMessage, type: "danger" });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };

    return userLoginReportService;
}]);


"use strict";

angular.module("mc.user-login-report", []);
"use strict";

function UserLoginReportFactory(HOST, $http, datetimeService, toaster, userMessageService, translationService, REPORTS) {
  var UserLoginReport = function UserLoginReport(customerId) {
    this.customerId = customerId;
  };

  UserLoginReport.prototype.getData = function (startDate, endDate) {
    var self = this;
    var intDayWindow = 365;
    var intDay = 86400000;
    return $http.get(REPORTS + "/api/UserLoginReport?customerId=" + this.customerId + "&StartDate=" + startDate + "&EndDate=" + endDate).then(function (response) {
      self.data = response.data;
      self.pageSize = 50;
      self.busy = false;
      return response;
    });
  };
  return UserLoginReport;
}

UserLoginReportFactory.$inject = ["HOST", "$http", "datetimeService", "toaster", "userMessageService", "translationService", "REPORTS"];

angular.module("mc.user-login-report").factory("UserLoginReportFactory", UserLoginReportFactory);
'use strict';

angular.module('mc.user-login-report').component('userLoginReport', {
    controller: UserLoginReportController,
    templateUrl: 'ui/userlogin/user-login-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.controller('liveUserReportController', ['$scope', '$rootScope', '$filter', 'sharedSetupService', 'openViewService', 'datetimeService', 'authenticationService', 'translationService','savePdfService', '$element', function ($scope, $rootScope, $filter, sharedSetupService, openViewService, datetimeService, authenticationService, translationService, savePdfService, $element) {
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.translation = translationService.translation;
    $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.alerts = [];
    $scope.oneTimeOnly = 0;
    $scope.reverse = true;
    $scope.initialLoad = true;
    $scope.downloadViewTypeOptions = [0, 1, 2]; 

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
    });

    $scope.savePdf = function() {

        var windowTitle =  $scope.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams ={
            windowTitle: windowTitle,
            pdfTitle: (eval("$scope.translation.text." + windowTitle)),
            customerName: $scope.accountInfo.customerName,
            customerId: $scope.accountInfo.customerId,
            dateTranslate: $scope.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd, 
            $scope: $scope,
            $element: $element
        }

        savePdfService.savePDF(pdfParams);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {

        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);

        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.fnAdjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.fnAdjustSize();
            },
            restore: function (event, ui) {
				openViewService.adjustContentSizeStart($scope.popup);
                $scope.fnAdjustSize();
            }
        });

        $scope.fnAdjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
        };

        $scope.adjustSize = function () {
            if ($scope.initialLoad) $scope.fnAdjustSize();
            $scope.initialLoad = false;
        };
    }
}]);

mcapp.directive('drawLiveUserReport', ['$timeout', 'liveUserReportService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', '$filter', '$interval', function ($timeout, liveUserReportService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService, $filter, $interval) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        scope.$ctrl = scope;
        var _timeLapseInterval = 20000; //20000 = 20 seconds
        var _start;
        var _checkStart = function () {
            // Don't start if already started
            if (angular.isDefined(_start)) return;
            _start = $interval(function () {
                scope.goSelectReportData();
            }, _timeLapseInterval);
        };

        var _stop = function () {
            if (angular.isDefined(_start)) {
                $interval.cancel(_start);
                _start = undefined;
            }
        };

        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        element.on('scrollOff', function (event) {
            var $rowFirst = element.contents().find("tr:first");
            var $rowLast = element.contents().find("tr:last");
            var _firstRow = $rowFirst.attr("name");
            if (typeof $rowFirst.position() !== "undefined") {
                scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
                var _tableTop = element.offset().top;
                var _rowTop = $rowFirst.offset().top;
                _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
                previousScrollbarPosition = currentScrollbarPosition;
                currentScrollbarPosition = element[0].scrollTop;
            }

            if (scope.infiniteScrollOn === true) {
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;

                if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
                    //$rowLast.addClass("active-row");
                    scope.liveUserReportService.alerts = [];
                    scope.liveUserReportService.nextPage();
                }
                if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
                    //$rowFirst.addClass("active-row");
                    scope.liveUserReportService.alerts = [];
                    scope.liveUserReportService.previousPage();
                }
            }

            var rows = element.children().children().children().children();
            var scrollpos = 40;
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos)
                    start = mid + 1;
                else
                    end = mid;
            }
            _updateZoom(parseFloat($($(rows[start])).attr("name")));
        });

        var _updateZoom = function (currentRow) {
            if (isNaN(currentRow))
                return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            }
            else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('liveUserReportService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                if (oldValue) {
                    _unRegisterListener(oldValue);
                }
            }
        }, true);

        scope.goSelectReportData = function () {
            scope.alerts = [];
            var numberOfDays = 183, varDateRangeStart, varDateRangeEnd, varDateRangeEndTmp;
            if (scope.stickyProperties.on == true) {
                scope.stickyProperties.on = false;
                varDateRangeStart = scope.stickyProperties.dateMin;
                varDateRangeEnd = scope.stickyProperties.dateMax;
                scope.myDateRangeStart = new Date(varDateRangeStart);
                scope.myDateRangeEnd = new Date(varDateRangeEnd - scope.unixDay);
            }
            else if (new Date(scope.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeEnd)) && new Date(scope.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeStart))) {
                scope.myDateRangeEnd = (new Date(scope.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeEnd))) ? scope.myDateRangeEnd : new Date();
                scope.myDateRangeStart = (new Date(scope.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeStart))) ? scope.myDateRangeStart : new Date();
                varDateRangeEnd = scope.myDateRangeEnd;
                varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999)
                varDateRangeStart = scope.myDateRangeStart;
                varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
            }
            else {
                scope.myDateRangeEnd = new Date();
                scope.myDateRangeStart = new Date();
                scope.myDateRangeStart.setDate(scope.myDateRangeStart.getDate() - numberOfDays);

                varDateRangeEnd = new Date();
                varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                ///////// needed to calculate varDateRangeStart
                varDateRangeEndTmp = new Date();
                varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
                ///////// needed to calculate varDateRangeStart
                varDateRangeStart = varDateRangeEndTmp - ((numberOfDays + 0) * scope.unixDay);
            }

            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            /////////////////////////////////////////////////////////////
            scope.liveUserReportService = new liveUserReportService();
            scope.liveUserReportService.customerId = scope.accountInfo.customerId;
            scope.liveUserReportService.deviceId = scope.deviceSelected;
            scope.liveUserReportService.windowTitle = scope.windowTitle;
            scope.liveUserReportService.startRow = 1;
            scope.liveUserReportService.pageSize = 50;
            scope.liveUserReportService.alerts = [];

            scope.liveUserReportService.start = varDateRangeStart;
            scope.liveUserReportService.end = varDateRangeEnd;
            scope.liveUserReportService.nextPage();
            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: scope.windowId });
        };


        var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            }
            else if (scope.checkFirstRowLiveStatus === null) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.checkFirstRowLiveStatus = true;
                        _checkTopOffset(liveDataStatusOn);
                    }
                    else {
                        scope.checkFirstRowLiveStatus = false;
                    }
                });
            }
        };

        var _checkTopOffset = function (liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListener(scope.deviceSelectedSn);
            }
            else {
                _unRegisterListener(scope.deviceSelectedSn);
            }
        };

        var wsDataReceivedSIGNAL = function (data) {
            var i = 0;
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            var varValue = parseInt(data.Value);
            var _newMeasurements = { "localDateTime": varTime, "value": varValue };

            scope.liveUserReportService.items.unshift(_newMeasurements);
            scope.lastUpdateAt = varTime;
        };

        var wsReconnectSIGNAL = function (data) {
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }
            toaster.pop('success', scope.windowTitle + " -- " + scope.liveUserReportService.deviceName, 'View reloading');
            scope.stickyProperties.on = true;
            scope.liveUserReportService.start = scope.stickyProperties.dateMin;
            scope.liveUserReportService.end = scope.stickyProperties.dateMax;
            scope.liveUserReportService.items = [];
            scope.liveUserReportService.numberOfReturnedRecords = -1;
            scope.liveUserReportService.startRow = 1;
            scope.liveUserReportService.pageSize = 10000;
            scope.liveUserReportService.windowTitle = scope.windowTitle;
            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.stickyProperties.deviceId, windowId: scope.windowId });
            scope.liveUserReportService.alerts = [];
            scope.liveUserReportService.nextPage();
        };

        var _registerListener = function (varSelectedSN) {
            if (scope.liveData === true)
                return;
            scope.liveData = true;
            scope.liveUserReportService.numberOfNewRecordsPrevious = -1;
            websocketService.connect();
            websocketService.register("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, wsReconnectSIGNAL);
        };

        var _unRegisterListener = function (varSelectedSN) {
            if (scope.liveData === false)
                return;
            scope.liveData = false;
            scope.lastUpdateAt = undefined;
            websocketService.unRegister("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, wsReconnectSIGNAL);
        };

        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            //_autoScroll();
            scope.checkFirstRowLiveStatus = null;
        });

        var _autoScroll = function () {
            if (scope.liveUserReportService.numberOfNewRecordsPrevious > 0) {
                var trRow = element.find('tr').eq(scope.liveUserReportService.numberOfNewRecordsPrevious - 1);
                var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 10;
                element.scrollTop(yPosition);
            }
            else if (element[0].scrollTop <= 1)
                element.animate({
                    scrollTop: element.scrollTop() + 10
                }, 500);
        };

        var orderBy = $filter('orderBy');
        scope.order = function (predicate, reverse) {
            switch (predicate) {
                case "customerName":
                    scope.sortLoginTime = reverse ? 'loginTimeSort' : '-loginTimeSort';
                    scope.liveUserReportService.items = orderBy(scope.liveUserReportService.items, [predicate, scope.sortLoginTime], reverse);
                    break;
                case "userName":
                    scope.sortLoginTime = reverse ? 'loginTimeSort' : '-loginTimeSort';
                    scope.liveUserReportService.items = orderBy(scope.liveUserReportService.items, [predicate, scope.sortLoginTime], reverse);
                    break;
                case "duration":
                    scope.liveUserReportService.items = orderBy(scope.liveUserReportService.items, predicate, reverse);
                    break;
                default:
                    scope.liveUserReportService.items = orderBy(scope.liveUserReportService.items, predicate, reverse);
                    break;
            }
            scope.predicate = predicate;
        };

        scope.setSorting = function () {
            scope.order('loginTimeSort', scope.reverse);
        };

        scope.goSelectReportData();
        _checkStart();

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
            _stop();
        });
    };
}]);

mcapp.factory('liveUserReportService', ['$http', 'datetimeService', 'toaster', 'userMessageService', 'translationService', 'HOST', function ($http, datetimeService, toaster, userMessageService, translationService, HOST) {
    var liveUserReportService = function () {
        this.items = [];
        this.deviceName = '';
        this.customerId = null;
        this.deviceId = null;
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.windowTitle = null;
        this.alerts = [];
        this.translation = translationService.translation;
    };

    liveUserReportService.prototype.previousPage = function () {
        if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
        this.busy = true;
        this.pageSize = -50;
        var url = HOST + "/api/UserLoginReport?customerId=" + this.customerId + "&StartDate=" + this.start + "&EndDate=" + this.end;
        $http.get(url).then(function (result) {
            /////////////////////////
            var intDayWindow = 365;
            var intDay = 86400000;
            /////////////////////////
            var items = result.data;
            for (var i = 0; i < items.length; i++) {
                items[i].loginTime = items[i].loginTime;
                items[i].customerName = items[i].customerName;
                items[i].userName = items[i].userName;
                items[i].duration = items[i].duration;
                items[i].ipAddress = items[i].ipAddress;
                this.items.unshift(items[i]);
            }
            this.numberOfNewRecordsPrevious = items.length;
            this.numberOfRecords = this.items.length;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) { //if there are records returned
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].loginTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = datetimeService.toUnixtime(this.items[0].loginTime.replace(/\D/g, ''));
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this), function (error) {
                this.alerts = [];
                var errorMessage = eval("this.translation.message." + error.message);
                this.alerts.push({ msg: errorMessage, type: "danger" });
                this.pageSize = 50;
                this.busy = false;
            }.bind(this));
    };

    liveUserReportService.prototype.nextPage = function () {
        if (this.busy || this.numberOfReturnedRecords === 0) return;
        this.busy = true;
        var url = HOST + "/api/UserLoginReport?customerId=" + this.customerId + "&StartDate=" + this.start + "&EndDate=" + this.end + "&Live=" + true;
        $http.get(url, { cache: false }).then(function (result) {
            /////////////////////////
            var intDayWindow = 365;
            var intDay = 86400000;
            /////////////////////////
            var items = result.data;
            for (var i = 0; i < items.length; i++) {
                items[i].loginTime = items[i].loginTime;//moment(items[i].loginTime).format('MM/DD/YYYY hh:mm:ss A');
                items[i].loginTimeSort = new Date(items[i].loginTime);
                items[i].customerName = items[i].customerName;
                items[i].userName = items[i].userName;
                items[i].duration = ("0" + (items[i].duration / 24 / 60).toFixed(0)).slice(-2) + ':' + ("0" + parseInt(items[i].duration / 60 % 24)).slice(-2) + ':' + ("0" + (items[i].duration % 60)).slice(-2);
                items[i].ipAddress = items[i].ipAddress;
                items[i].userLive = items[i].userLive;
                items[i].userLocation = (items[i].userLocation.country + ", " + items[i].userLocation.city + ", " + items[i].userLocation.region).replace(", , ", "");
                if (items[i].userLocation.substr(0, 4) === "US, ") items[i].userLocation = items[i].userLocation.substring(4);
                this.items.push(items[i]);
            }
            this.numberOfReturnedRecords = items.length;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) { //if there are records returned
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].loginTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = datetimeService.toUnixtime(this.items[0].loginTime.replace(/\D/g, ''));
            }
            else {
                this.alerts = [];
                var errorMessage = "No data available";
                this.alerts.push({ msg: errorMessage, type: "danger" });
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this), function (error) {
                this.alerts = [];
                var errorMessage = eval("this.translation.message." + error.message);
                this.alerts.push({ msg: errorMessage, type: "danger" });
                this.pageSize = 50;
                this.busy = false;
            }.bind(this));
    };

    return liveUserReportService;
}]);


'use strict';

function VolumetricFlowMenuController($, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, openViewService) {
    var _this2 = this;

    this.dynamicPopover = {
        templateUrl: 'myVolumetricFlowPopoverTemplate.html'
    };

    this.$onInit = function () {
        _this2.translation = translationService.translation;
        _this2.windowId = _this2.windowId;
        $scope.windowId = _this2.windowId;
        _this2.checkedVolumetricFlow = _this2.windowId;
        updateViews();

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            updateViews();
        });
    };

    var updateViews = function updateViews() {
        _this2.views = [{
            "master": "Volumetric Flow", "id": "Volumetric Flow Chart", "name": _this2.translation.text.VOLUMETRIC_FLOW, "detail": [{ "id": "Volumetric Flow Table", "name": _this2.translation.text.VOLUMETRIC_FLOW_TABLE, "icon": "fa-table" }, { "id": "Volumetric Flow Chart", "name": _this2.translation.text.VOLUMETRIC_FLOW_CHART, "icon": "fa-line-chart" }]
        }, {
            "master": "Pump Duty Cycle Plot", "id": "Pump Duty Cycle Plot", "name": _this2.translation.text.PUMP_DUTY_CYCLE_PLOT, "detail": [{ "id": "Pump Duty Cycle Plot", "name": _this2.translation.text.PUMP_DUTY_CYCLE_PLOT, "icon": "fa-line-chart" }]
        }, {
            "master": "Daily Volumetric Flow Summary", "id": "Daily Volumetric Flow Summary", "name": _this2.translation.text.DAILY_VOLUMETRIC_FLOW_SUMMARY, "detail": [{ "id": "Daily Volumetric Flow Summary", "name": _this2.translation.text.DAILY_VOLUMETRIC_FLOW_SUMMARY, "icon": "fa-table" }]
        }];
    };

    this.checkedVolumetricFlowView = function (view) {
        if (view.id == "Volumetric Flow Chart") {
            if (this.checkedVolumetricFlow == "Volumetric Flow Chart" || this.checkedVolumetricFlow == "Volumetric Flow Table") {
                return true;
            } else {
                return false;
            }
        }
        return this.checkedVolumetricFlow === view.id ? true : false;
    };

    this.setVolumetricFlowView = function (id, name) {
        if (id !== null && id !== this.checkedVolumetricFlow) {
            this.checkedVolumetricFlow = '';
            this.checkedVolumetricFlow = id;
            this.selected = id;
            this.viewSelected = id;
            var _popup = _this.getExistingDialog(this.windowId).ref;
            var _popupPosition = _popup.dialog("option", "position");
            var _popupWidth = _popup.dialog("option", "width");
            var _popupHeight = _popup.dialog("option", "height");

            var _popupSize = {};
            _popupSize.width = _popupWidth;
            _popupSize.height = _popupHeight;

            openViewService.openView(id, _popupSize, _popupPosition, this.stickyProperties);
            _popup.dialog("close");
        } else {
            return false;
        }
    };
}

VolumetricFlowMenuController.$inject = ['$', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'openViewService'];

angular.module('mc.volumetricflow').component('volumetricFlowMenu', {
    controller: VolumetricFlowMenuController,
    transclude: true,
    templateUrl: 'ui/volumetricflow/volumetricflow-menu.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.style-guide", []);
'use strict';

function McStyleGuideController($, $rootScope, $scope, sharedSetupService, translationService, authenticationService) {

  var ctrl = this;
  ctrl.mobile = $rootScope.mobile;
  ctrl.classicView = $rootScope.classicView;

  ctrl.$onInit = function () {
    sharedSetupService.getWindowId(ctrl);
    ctrl.myModalTemplate = null;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
    ctrl.translation = translationService.translation;
    $scope.windowId = ctrl.windowId;
    $scope.windowTitle = ctrl.windowTitle;
    ctrl._loading = true;

    // ---------------------------------------------
    // STYLE GUIDE: JAVASCRIPT


    // ---------------------------------------------
    // STYLE GUIDE: DUPLICATE DEMO EXAMPLES IN CODE BLOCKS

    // Escape HTML
    //  - Parameters:
    //    - str {string} : Takes a string and returns it with HTML entities escaped
    // Example:
    // >>> escapeHtml("<div>Foo & Bar</div>")
    // "&lt;div&gt;Foo &amp; Bar&lt;/div&gt;"
    function escapeHtml(str) {
      var div = document.createElement("div");
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    // Trim whitespace and preserve indentation
    //  - Parameters:
    //    - code {string} : Takes a string and trims extra whitespace

    function reIndentCode(code) {
      var lines = [];
      var linesArr = code.split("\n");

      linesArr.forEach(function (line, index) {
        if (line.trim() === "" && index === 0) {
          return;
        }

        if (line.trim() === "" && index === linesArr.length - 1) {
          return;
        }

        lines.push(line);
      });

      var line1 = lines[0];

      // Get the number of whitespace indentation characters on the first line
      // by comparing the length of the string with and without trimmed whitespace
      var whitespaceLen = line1.length - line1.trimLeft().length;

      // Loop through all lines and remove conditionally whitespace to the left equal to the whitespace on line 1
      return lines.map(function (line) {
        return line.length - line.trimLeft().length >= whitespaceLen ? line.substring(whitespaceLen, line.length) : line;
      }).join("\n");
    }

    // Append style guide demos to code blocks
    function styleBlockAppendCode() {
      var styleBlocks = document.querySelectorAll(".styleguide-demo-block");

      styleBlocks.forEach(function (styleBlock) {
        var demo = styleBlock.querySelector(".styleguide-demo-each");
        var code = reIndentCode(escapeHtml(demo.innerHTML));
        var container = document.createElement("div");
        container.classList.add("styleguide-code-block", "js-styleguide-code-block");
        var preBlock = document.createElement("pre");
        var codeBlock = document.createElement("code");
        codeBlock.innerHTML = code;
        preBlock.appendChild(codeBlock);
        container.appendChild(preBlock);
        styleBlock.appendChild(container);
      });
    }

    styleBlockAppendCode();

    var btnCode = document.querySelectorAll(".js-btn-styleguide-code");
    var btnCodeArray = Array.from(btnCode);

    // Toggle style guide demos on clicking "Code" button
    function btnToggleCode(element) {
      var parentCode = element.parentNode.querySelector(".js-styleguide-code-block");
      parentCode.classList.toggle("styleguide-code-block--show");
    }

    btnCodeArray.forEach(function (button) {
      button.addEventListener("click", function () {
        btnToggleCode(this);
      });
    });

    // ---------------------------------------------
    // STYLE GUIDE: NAVIGATION

    // Navigation: Toggle style guide menu on button click
    var navTrigger = document.getElementById("js-btn-styleguide-menu");
    var toggleElement = document.getElementById("js-styleguide-sidebar");
    var sidebarLinks = document.querySelectorAll("#js-styleguide-sidebar a");

    var toggleSidebar = function toggleSidebar() {
      toggleElement.classList.toggle("styleguide-sidebar--show");
    };

    var hideSidebar = function hideSidebar() {
      toggleElement.classList.remove("styleguide-sidebar--show");
    };

    navTrigger.addEventListener("click", toggleSidebar);

    // Navigation: Hide styleguide menu on clicking sidebar links
    sidebarLinks.forEach(function (item) {
      item.addEventListener("click", hideSidebar);
    });
  };

  ctrl.scrollTo = function (id) {
    var contactTopPosition = $('' + id).position().top;
    $('#style-guide-main').animate({ scrollTop: contactTopPosition });
    //document.getElementById(id).scrollIntoView(true);
  };
}

McStyleGuideController.$inject = ['$', '$rootScope', '$scope', 'sharedSetupService', 'translationService', 'authenticationService'];
'use strict';

angular.module('mc.style-guide').component('styleGuide', {
    controller: McStyleGuideController,
    templateUrl: 'ui/styleguide/style-guide-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function TicketSystemFactory(HOST, $http, translationService) {

    function GetPriorities(customerId, userId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/Severity',
            params: { customerId: customerId, userId: userId }
        });
    }

    function GetTicketModel(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TicketSystem',
            params: { customerId: customerId }
        });
    }

    function GetTicketEditModel(customerId, ticketId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TicketSystemEdit',
            params: { customerId: customerId, ticketId: ticketId }
        });
    }

    function GetTicketAttachments(customerId, ticketId, onlyAttachments) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TicketSystemEdit',
            params: { customerId: customerId, ticketId: ticketId, onlyAttachments: onlyAttachments }
        });
    }

    function UpdateTicket(customerId, ticketSystem) {
        return $http({
            method: 'POST',
            url: HOST + '/api/TicketSystemEdit',
            data: ticketSystem,
            contentType: 'application/json',
            params: { customerId: customerId }
        });
    }

    function SaveAttachment(customerId, ticketId, ticketAttachment) {
        return $http({
            method: 'POST',
            url: HOST + '/api/TicketAttachment',
            data: ticketAttachment,
            contentType: 'application/json',
            params: { customerId: customerId, ticketId: ticketId }
        });
    }

    function SaveTicket(customerId, ticketSystem) {

        return $http({
            method: 'POST',
            url: HOST + '/api/TicketSystem',
            data: ticketSystem,
            contentType: 'application/json',
            params: { customerId: customerId }
        });
    }

    function ValidateFile(fileInput) {
        var filename = fileInput.name;
        var validFilesTypes = ["bmp", "gif", "png", "jpg", "jpeg", "doc", "docx", "rtf", "xls", "xlsx", "csv", "zip", "txt", "pdf", "wav", "mp3", "mp4"];

        var isValidFile = false;
        var ext = filename.slice(filename.lastIndexOf('.') + 1).toLowerCase();
        for (var i = 0; i < validFilesTypes.length; i++) {
            if (ext == validFilesTypes[i]) {
                isValidFile = true;
                break;
            }
        }
        return isValidFile;
    }

    function GetTicketIssueTypes(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TicketIssueType',
            params: { customerId: customerId }
        });
    }

    function GetProblemCategories() {
        return [{
            label: translationService.translation.text.NO_CATEGORY_SELECTED, id: '1'
        }, {
            label: 'Customer Equipment', id: '00000',
            children: [{ label: 'Analog', id: '01000' }, { label: 'Digital', id: '02000' }, { label: 'Pulse', id: '03000' }, { label: 'Relay Outputs', id: '04000' }]
        }, {
            label: 'RTU', id: '10000',
            children: [
            /* { label: 'M80', id: '11000' },*/
            {
                label: 'M110/M800', id: '12000',
                children: [
                /*{ label: 'Display', id: '12100' },*/
                { label: 'Firmware', id: '12200' }, { label: 'Radio', id: '12300' }, { label: 'Antenna', id: '12400' }, { label: 'Key Reader', id: '12500' }, { label: 'Main Board', id: '12600' }, {
                    label: 'Expansion', id: '12700',
                    children: [{ label: 'Digital', id: '12710' }, { label: 'Analog Input', id: '12720' }, { label: 'Analog Output', id: '12730' }, { label: 'Pulse', id: '12740' }]
                }]
            }, {
                label: 'Manhole Monitor', id: '13000',
                children: [{ label: 'Display', id: '13100' }, { label: 'FOTA', id: '13200' }, { label: 'Radio', id: '13300' }, { label: 'Battery', id: '13400' }]
            }, {
                label: 'MyDro 150/850', id: '14000',
                children: [{ label: 'Display', id: '14100' }, { label: 'FOTA', id: '14200' }, { label: 'Radio', id: '14300' }, { label: 'Antenna', id: '14400' }, { label: 'Main Board', id: '14500' }, {
                    label: 'Expansion', id: '14600',
                    children: [{ label: 'Relays', id: '14610' }, { label: 'Digital', id: '14620' }, { label: 'Analog Input', id: '14630' }, { label: 'Analog Output', id: '14640' }, { label: 'SMP', id: '14650' }]
                }]
            }]
        }, {
            label: 'Carrier', id: '20000',
            children: [{
                label: 'Connectivity', id: '21000',
                children: [{ label: 'AT&T', id: '21100' }, { label: 'Sprint', id: '21200' }, { label: 'Nextel', id: '21300' }, { label: 'Verizon', id: '21400' }, { label: 'Telenor', id: '21500' }]
            }, { label: 'Radio Swap', id: '22000' }]
        }, {
            label: 'Web Display', id: '30000',
            children: [{ label: 'Marketing', id: '31000' }, {
                label: 'User', id: '32000',
                children: [{
                    label: 'Login', id: '32100',
                    children: [{ label: 'Add New User', id: '32110' }, { label: 'Password Change', id: '32120' }, { label: 'Forgot Password', id: '32130' }]
                }, { label: 'Map', id: '32200' }, {
                    label: 'Data', id: '32300',
                    children: [{ label: 'Analog', id: '32310' }, { label: 'Digital', id: '32320' }, { label: 'Runtime', id: '32330' }, { label: 'Runtime', id: '32340' }, { label: 'Graphs', id: '32350' }, { label: 'Volumetric calcs', id: '32360' }]
                }, { label: 'Commands', id: '32400' }, {
                    label: 'Notifications', id: '32500',
                    children: [{ label: 'Destinations', id: '32510' }, { label: 'Schedules', id: '32520' }, { label: 'Conditionals', id: '32530' }, { label: 'Presrcipts', id: '32540' }]
                }, {
                    label: 'Special Features', id: '32600',
                    children: [{ label: 'Tank and Well', id: '32610' }, { label: 'Digital Intertie', id: '32620' }, { label: 'Analog Intertie', id: '32630' }]
                }, { label: 'Language Translations', id: '32700' }]
            }, { label: 'Admin', id: '33000' }, { label: 'WAP', id: '34000' }, { label: 'MOBI', id: '35000' }, { label: 'RTV', id: '36000' }]
        }, {
            label: 'Notification', id: '40000',
            children: [{
                label: 'Reports', id: '45000',
                children: [{ label: 'Runtime Alerts', id: '45100' }, { label: 'Daily Summary', id: '45200' }, { label: 'Daily Detailed', id: '45300' }, { label: 'Management (Weekly)', id: '45400' }, { label: 'Monthly Spreadsheet', id: '45500' }]
            }, { label: 'Voice', id: '41000' }, { label: 'Email', id: '42000' }, { label: 'Text', id: '43000' }, { label: 'Pager', id: '44000' }, { label: 'FAX', id: '46000' }, { label: 'OPC', id: '47000' }]
        }, {
            label: 'RMA', id: '50000',
            children: [{ label: 'Complete RTU', id: '51000' }, { label: 'Mainboard', id: '52000' }, { label: 'Radio', id: '53000' }, { label: 'WWM', id: '54000' }, { label: 'Other Accessory', id: '55000' }, {
                label: 'Mydro', id: '56000',
                children: [{ label: 'Display', id: '56100' }, { label: 'Main Board', id: '56200' }, { label: 'Radio', id: '56300' }, { label: 'Accessory', id: '56400' }]
            }, {
                label: 'Legacy', id: '57000',
                children: [{ label: 'Main Board', id: '57100' }, { label: 'Radio', id: '57200' }, { label: 'Accessory', id: '57300' }]
            }]
        }, {
            label: 'Invoiced Not Heard', id: '60000'
        }, {
            label: 'ATT LTE Upgrade', id: '65000'
        }, {
            label: 'Mission QA', id: '70000'
        }, {
            label: 'On going customer issue', id: '80000'
        }, {
            label: 'Office IT Request', id: '90000'
        }];
    }

    return {
        GetTicketModel: GetTicketModel,
        GetPriorities: GetPriorities,
        GetTicketEditModel: GetTicketEditModel,
        SaveTicket: SaveTicket,
        UpdateTicket: UpdateTicket,
        SaveAttachment: SaveAttachment,
        GetTicketAttachments: GetTicketAttachments,
        ValidateFile: ValidateFile,
        GetTicketIssueTypes: GetTicketIssueTypes,
        GetProblemCategories: GetProblemCategories
    };
}

TicketSystemFactory.$inject = ['HOST', '$http', 'translationService'];

angular.module('mc.ticket-system').factory('ticketSystemService', TicketSystemFactory);
"use strict";

function TicketSystemController($, $location, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, TICKETURL, $timeout) {
    var ctrl = this;
    ctrl.tabs = [];
    var custsWithAccess2CreateEdit = [14600, 14388, 14395, 14398, 13480]; //TODO: remove following method after the Jan 17th 2019 Release, we are trying to hide Create/Edit tabs from customers, but using for QA testing.
    ctrl.tabName = "view"; // default tab to be displayed
    $scope.ticketId = undefined;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for1 mi
        $scope.downloadViewTypeOptions = [0];

        initialize();
    };

    //var _tabConfiguration = function () {
    //    //this function is used to update the tabs list in the initial stage OR
    //    //when external events (like language change by User etc) are triggered to update the tabs names
    //    var len = arguments.length,
    //    i = 0;
    //    var tmpLength = ctrl.tabs.length;
    //    for (i = 0; i < len; i++) {
    //        if (tmpLength == 0 && _CanPushTab(arguments[i])) {
    //            ctrl.tabs.push(arguments[i]);
    //            //resizeTabIdString += resizeTabIdString.length === 0 ? "#" + arguments[i].id : ", #" + arguments[i].id;
    //        } else {
    //            ctrl.tabs[i].name = arguments[i].name;
    //        }
    //    }
    //};

    //TODO: remove following method after the Jan 17th 2019 Release, we are trying to hide Create/Edit tabs from customers, but using for QA testing.
    //var _CanPushTab = (arrayItem) => {
    //    let retVal = false;

    //    if ($location.host().startsWith("localhost") || $location.host().startsWith("qa.123scada.com")) return true;

    //    if (arrayItem.id == "View Ticket") retVal = true;
    //    else if (arrayItem.id == "Create Ticket" || arrayItem.id == "Edit Ticket") {
    //        if (custsWithAccess2CreateEdit.indexOf(ctrl.accountInfo.customerId) > -1) retVal = true;
    //    }

    //    return retVal;
    //}

    var initialize = function initialize() {

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                //var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                //ctrl.popup.parent().css("height", _tmpHeight);
                //ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                //ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                //ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                //ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                //ctrl.popup.parent().find('.tab-content-wrapper').css("height", 'auto');
                //ctrl.popup.parent().find('.tab-content-wrapper').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        }
    };

    ctrl.editTicket = function (ticketId) {
        $scope.ticketId = ticketId;
        var isMcAdmin = sharedSetupService.mcAdmin();
        if (ticketId == -1) {
            if (isMcAdmin) ctrl.tabName = "adminCreate";else ctrl.tabName = "create";
        } else {
            if (isMcAdmin) ctrl.tabName = "adminEdit";else ctrl.tabName = "edit";
        }
    };

    ctrl.onCancel = function () {
        $scope.ticketId = undefined;
        ctrl.tabName = "view";
    };

    ctrl.getDisplayName = function (tabName) {
        var displayName = "";
        switch (tabName) {
            case "view":
            case "adminView":
                displayName = ctrl.translation.text.VIEW_TICKETS;
                break;
            case "edit":
            case "adminEdit":
                displayName = ctrl.translation.text.EDIT_TICKET;
                break;
            case "create":
            case "adminCreate":
                displayName = ctrl.translation.text.CREATE_TICKET;
                break;
        }
        return displayName;
    };

    ctrl.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return 'ticketsystem';
    };

    ctrl.isUndefinedOrNull = function (val) {
        return angular.isUndefined(val) || val === null;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        _initialize();
    });
};

TicketSystemController.$inject = ['$', '$location', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'TICKETURL', '$timeout'];
'use strict';

angular.module('mc.ticket-system').component('ticketSystem', {
    controller: TicketSystemController,
    templateUrl: 'ui/ticketsystem/ticket-system.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function TicketSystemAdminFactory(HOST, $http) {

    function GetAdminTicketModel(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TicketSystemAdminCreate',
            params: { customerId: customerId }
        });
    }

    function GetAdminTicketEditModel(customerId, ticketId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TicketSystemAdminEdit',
            params: { customerId: customerId, ticketId: ticketId }
        });
    }

    function GetDeviceList(customerId, actualCustomerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/DeviceList',
            params: { customerId: customerId, actualCustomerId: actualCustomerId },
            cache: false
        });
    };

    //function SaveAttachment(customerId, ticketId, ticketAttachment) {
    //    return $http({
    //        method: 'POST',
    //        url: `${HOST}/api/TicketAttachment`,
    //        data: ticketAttachment,
    //        contentType: 'application/json',
    //        params: { customerId, ticketId },
    //    });
    //}

    function CreateTicket(customerId, ticketSystem) {

        return $http({
            method: 'POST',
            url: HOST + '/api/TicketSystemAdminCreate',
            data: ticketSystem,
            contentType: 'application/json',
            params: { customerId: customerId }
        });
    }

    function UpdateTicket(customerId, ticketSystem) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/TicketSystemAdminEdit',
            data: ticketSystem,
            contentType: 'application/json',
            params: { customerId: customerId }
        });
    }

    //function ValidateFile(fileInput) {
    //    let filename = fileInput.name;
    //    var validFilesTypes = ["bmp", "gif", "png", "jpg",
    //         "jpeg", "doc", "docx", "rtf", "xls", "xlsx", "csv",
    //         "zip", "txt", "pdf", "wav", "mp3", "mp4"];

    //    var isValidFile = false;
    //    let ext = filename.slice(filename.lastIndexOf('.') + 1).toLowerCase();
    //    for (var i = 0; i < validFilesTypes.length; i++) {
    //        if (ext == validFilesTypes[i]) {
    //            isValidFile = true;
    //            break;
    //        }
    //    }
    //    return isValidFile;
    //}

    return {
        GetAdminTicketModel: GetAdminTicketModel,
        GetAdminTicketEditModel: GetAdminTicketEditModel,
        GetDeviceList: GetDeviceList,
        CreateTicket: CreateTicket,
        UpdateTicket: UpdateTicket
        //SaveAttachment,
        //ValidateFile
    };
}

TicketSystemAdminFactory.$inject = ['HOST', '$http'];

angular.module('mc.ticket-system').factory('ticketSystemAdminService', TicketSystemAdminFactory);
"use strict";

angular.module("mc.supergraph", []);
'use strict';

function SupergraphFactory(HOST, $http) {

    // instantiate our initial object
    var Supergraph = function Supergraph(customerId, deviceId, deviceType, startDate, endDate, id, element, timeZone, stickyProperties, pulseFlowGrouping) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.deviceType = deviceType;
        this.startDate = startDate;
        this.endDate = endDate;
        this.id = angular.isUndefined(id) ? null : id;
        this.element = angular.isUndefined(element) ? "All" : element;
        this.timeZone = timeZone;
        this.stickyProperties = stickyProperties;
        this.pulseFlowGrouping = pulseFlowGrouping;
    };

    Supergraph.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + '/api/Supergraph/SgChart' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&deviceType=' + this.deviceType + '&startDate=' + this.startDate + '&endDate=' + this.endDate + '&timeZone=' + this.timeZone + '&id=' + this.id + '&element=' + this.element + '&group=' + this.pulseFlowGrouping).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return Supergraph;
}

SupergraphFactory.$inject = ['HOST', '$http'];

angular.module('mc.supergraph').factory('SupergraphFactory', SupergraphFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SupergraphController($, $rootScope, $scope, authenticationService, translationService, sharedSetupService, datetimeService, openViewService, $timeout, $filter, $element, timeLapseService, websocketService, SupergraphFactory, toaster, detectBrowserService, rangeSelectorService, SaveDesktopSettingService, debounceService, HOST, $http) {
    var _this2 = this;

    var ctrl = this;
    var __this = this;
    __this.mobile = $rootScope.mobile;
    __this.Object = Object;
    var element = $element.find(".sg-supergraph-chart");
    __this.autoScale = false;
    var connectedColor = "Green";
    var connectColorCode = "#00ff00";

    // Series colors come from the server palette (McShared.GetColorPalete) so chart lines and sidebar controls stay in sync;
    // the fallback is used when the response carries no palette.
    var getPaletteColor = function getPaletteColor(data, index, fallback) {
        return data && data.colorPalette && data.colorPalette[index] || fallback;
    };

    // Text drawn on a series-colored background (e.g. flag labels): pick white or black, whichever has the higher WCAG contrast.
    var getContrastTextColor = function getContrastTextColor(background) {
        var hex = /^#([0-9a-f]{6})$/i.exec(background || '');
        if (!hex) return 'white';

        var _map$map = [0, 2, 4].map(function (k) {
            return parseInt(hex[1].substr(k, 2), 16) / 255;
        }).map(function (c) {
            return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
        }),
            _map$map2 = _slicedToArray(_map$map, 3),
            r = _map$map2[0],
            g = _map$map2[1],
            b = _map$map2[2];

        var luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        return 1.05 / (luminance + 0.05) >= (luminance + 0.05) / 0.05 ? 'white' : '#000000';
    };
    var curentBrowser = detectBrowserService();
    __this.ieEdge = curentBrowser === 'ie' || curentBrowser === 'edge';
    __this.plotLines = [];
    __this.siteAccessData = [];
    __this.plotBandsYAxis = [];
    __this.reverseScale = false;
    var toggleSeries = true;
    var scrollChartEnabled = true;
    var _popup = void 0;
    var _navigatorOrPan = false;
    var _scrollingInProgress = false;
    var chart = void 0;
    var _yAxes = [];
    var _series = [];
    var _maxChannel = void 0;
    var _liveDataEndDate = void 0;
    var initialLoad = false;
    var xValue = null;
    var xValueMousePoint = null;
    var zoomLevelCurrent = void 0;
    var zoomLevelPrevious = 0;
    __this.deviceType = 0;
    var endPlotBand = void 0;
    // let plotBandsYAxis = [];
    __this.hasRMDTRadio = false;

    var _liveData = false;
    var _liveDataIn = false;
    var _liveDataOffset = 20 * 60 * 1000;

    var callInCountTimeout;

    var _isZoomOut = false;

    var _liveAnalogSetting = false;
    var _liveDigitalSetting = false;
    var _startData = null;
    var _endDate = null;

    var _faultData = [];
    var _preparedForTimeLaps = false;

    var _lastRainfallDate = void 0;

    var tmpData = [];

    var _digitalSetting = [];

    var _tmpTimer = void 0;
    var _startBroadcast = void 0;

    __this.metarStationToUnregister = null;

    var _getNormalClosed = function _getNormalClosed(channel) {
        for (var i = 0; i < _digitalSetting.length; i++) {
            if (channel === _digitalSetting[i].channel) return _digitalSetting[i].normalClosed;
        }
        return "0";
    };

    __this.uiGroup = [];
    __this.uiGroup[1] = true;
    __this.uiGroup[2] = true;
    __this.uiGroup[3] = true;
    __this.uiGroup[4] = true;
    __this.uiGroup[5] = true;
    __this.uiGroup[6] = false;
    __this.uiGroup[7] = true;
    __this.uiGroup[8] = true;

    __this.charDataDetail = { x: null, y: null, color: null, name: null, unit: null, min: null, max: null, autoScale: false, visible: true, decimal: 0, uiGroup: 0, translationKey: '', alarmThresholdsVisibleTemp: null, isAlarmThreshold: true };

    __this.chartData = {};

    var _initChart = function _initChart() {

        __this.hasAnalog = false;
        __this.skuId = 0;
        __this.hasAnalogOutput = false;
        __this.hasPulseFlow = false;
        __this.hasDigital = false;
        __this.plotBandsYAxis = [];
        __this.selectedPulseFlowGrouping = "1";

        __this.chartData = {
            ch1: angular.copy(__this.charDataDetail),
            ch2: angular.copy(__this.charDataDetail),
            ch3: angular.copy(__this.charDataDetail),
            ch4: angular.copy(__this.charDataDetail),
            ch5: angular.copy(__this.charDataDetail),
            ch6: angular.copy(__this.charDataDetail),
            ch7: angular.copy(__this.charDataDetail),
            ch8: angular.copy(__this.charDataDetail),
            ch9: angular.copy(__this.charDataDetail),
            out1: angular.copy(__this.charDataDetail),
            out2: angular.copy(__this.charDataDetail),
            out3: angular.copy(__this.charDataDetail),
            out4: angular.copy(__this.charDataDetail),
            sign: angular.copy(__this.charDataDetail),
            signalQuality: angular.copy(__this.charDataDetail),
            signalPower: angular.copy(__this.charDataDetail),
            conn: angular.copy(__this.charDataDetail),
            temp: angular.copy(__this.charDataDetail),
            vbatt: angular.copy(__this.charDataDetail),
            vac: angular.copy(__this.charDataDetail),
            vaux: angular.copy(__this.charDataDetail),
            rainT: angular.copy(__this.charDataDetail),
            rainR: angular.copy(__this.charDataDetail),
            pmp1: angular.copy(__this.charDataDetail),
            pmp2: angular.copy(__this.charDataDetail),
            pmp3: angular.copy(__this.charDataDetail),
            pmp4: angular.copy(__this.charDataDetail),
            pmp5: angular.copy(__this.charDataDetail),
            pmp6: angular.copy(__this.charDataDetail),
            pmp7: angular.copy(__this.charDataDetail),
            pmp8: angular.copy(__this.charDataDetail),
            pulseFlow1: angular.copy(__this.charDataDetail),
            pulseFlow2: angular.copy(__this.charDataDetail),
            pulseFlow3: angular.copy(__this.charDataDetail),
            pulseFlow4: angular.copy(__this.charDataDetail),
            pulseFlow5: angular.copy(__this.charDataDetail),
            pulseFlow6: angular.copy(__this.charDataDetail),
            alarm: angular.copy(__this.charDataDetail),
            siteAccess: angular.copy(__this.charDataDetail)
        };

        __this.chartData.siteAccess.uiGroup = 2;
    };

    var _adjustSize = function _adjustSize() {
        if (_popup.parent().find(".chart").highcharts()) {
            _popup.parent().find('div:eq(2)').css("width", _popup.parent().css("width"));
            _popup.parent().find('div:eq(2)').css("min-width", _popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            _popup.parent().find('div:eq(2)').css("height", _popup.parent().css("height").replace(/[^0-9.]+/g, "") - _popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            _popup.parent().find('div:eq(2)').css("min-height", _popup.parent().css("height").replace(/[^0-9.]+/g, "") - _popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            _popup.parent().find('.chart').css("height", _popup.parent().css("height").replace(/[^0-9.]+/g, "") - _popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - _popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - (_popup.parent().find('.additional-heading').css("height") ? _popup.parent().find('.additional-heading').css("height").replace(/[^0-9.]+/g, "") : 0) - 10);
            var _char = _popup.parent().find(".chart").highcharts();
            _char.reflow();
            var _slidebar = _popup.parent().find(".wrapper-supergraph").find(".sidebar-supergraph");
            var _content = _popup.parent().find(".chart").find(".highcharts-container ");
            _slidebar.css("height", _content.css("height"));
        }
    };

    __this.sidebarSupergraph = true;
    __this.toggleSidebarSupergraph = function () {
        var _parent = $(element).parents(".wrapper-supergraph");
        var _parentSpacer = _parent.parent(".supergraph-template").find(".top-menu-spacer");
        switch (__this.sidebarSupergraph) {
            case true:
                _parent.css("margin-left", "0");
                _parentSpacer.css("width", "2.1875rem");
                _parent.find(".sidebar-supergraph").css("width", "0");
                _parent.find(".content-supergraph").css("width", "100%");
                if (!$rootScope.mobile && !$rootScope.classicView) {
                    _adjustSize();
                } else {
                    chart.reflow();
                }
                break;
            case false:
                _parent.css("margin-left", "15.625rem");
                _parentSpacer.css("width", $rootScope.mobile || $rootScope.classicView ? "2.1875rem" : "15.625rem");
                _parent.find(".sidebar-supergraph").css("width", "15.4375rem");
                _parent.find(".content-supergraph").css("width", "100%");
                if (!$rootScope.mobile && !$rootScope.classicView) {
                    _adjustSize();
                } else {
                    chart.reflow();
                }
                break;
        }
        __this.sidebarSupergraph = !__this.sidebarSupergraph;
    };

    __this.adjustSupergraphForMobile = function () {
        var _slidebar = $(element).parents(".wrapper-supergraph").find(".sidebar-supergraph");
        $timeout(function () {
            var _content = $(element).parents(".wrapper-supergraph").find(".content-supergraph").find(".chart").find(".highcharts-container ");
            _slidebar.css("height", _content.css("height"));
        }, 300);
    };

    $scope.$on('windowDimensions', function () {
        if ($rootScope.mobile || $rootScope.classicView) {
            __this.adjustSupergraphForMobile();
        }
    });

    __this.toggleAlarmThresholds = function (data) {
        if (__this.chartData[data].visible) {
            var plotlines = [];
            for (var j = 0; j < chart.series.length; j++) {
                switch (chart.series[j].options.id) {
                    case "ch1":
                    case "ch2":
                    case "ch3":
                    case "ch4":
                    case "ch5":
                    case "ch6":
                    case "ch7":
                    case "ch8":
                    case "ch9":
                        for (var z = 0; z < __this.plotLines.length; z++) {
                            if (data == chart.series[j].options.id && __this.plotLines[z].yAxis === "yx-" + data) {
                                if (!__this.chartData[data].alarmThresholdsVisibleTemp) {
                                    plotlines.push(__this.plotLines[z]);
                                    chart.series[j].yAxis.addPlotLine(__this.plotLines[z]);
                                } else {
                                    chart.series[j].yAxis.removePlotLine(__this.plotLines[z].id);
                                }
                            }
                        }
                        break;
                }
            }
            __this.chartData[data].alarmThresholdsVisibleTemp = !__this.chartData[data].alarmThresholdsVisibleTemp;
            __this.saveDesktopSettingService.setSerieVisibilityAndScaleSettingSupergraph(data, true, __this.chartData[data].autoScale, plotlines, __this, __this.chartData[data].alarmThresholdsVisibleTemp);
        }
        toggleSeries = false;
    };

    __this.buildSiteAccessData = function (newSiteAccessData, varDirection) {
        for (var i = 0; i < newSiteAccessData.length; i++) {
            var _item = {
                id: datetimeService.strToUnixtime(newSiteAccessData[i].localDateTime),
                color: "gray",
                dashStyle: "ShortDot",
                label: {
                    text: newSiteAccessData[i].userName + " - " + newSiteAccessData[i].keyHex,
                    verticalAlign: 'top',
                    y: 5,
                    x: -10
                },
                value: datetimeService.strToUnixtime(newSiteAccessData[i].localDateTime),
                width: 1,
                zIndex: 1
            };

            switch (varDirection) {
                case "left":
                    __this.siteAccessData.unshift(_item);
                    break;

                case "right":
                default:
                    __this.siteAccessData.push(_item);
                    break;
            }
        }
    };

    __this.removeSiteAccess = function () {
        for (var z = 0; z < __this.siteAccessData.length; z++) {
            chart.xAxis[0].removePlotLine(__this.siteAccessData[z].id);
        }
    };

    __this.addSiteAccess = function () {
        __this.removeSiteAccess();
        for (var z = 0; z < __this.siteAccessData.length; z++) {
            chart.xAxis[0].addPlotLine(__this.siteAccessData[z]);
        }
    };

    __this.removeSiteAlarm = function () {
        __this.toggleSerie("alarm");
    };

    __this.toggleSerie = function (varId) {
        if (toggleSeries == true) {
            if (__this.chartData[varId].visible == false) {
                _showSerie(varId);
                __this.saveDesktopSettingService.setSerieVisibilityAndScaleSettingSupergraph(varId, true, __this.chartData[varId].autoScale, [], __this);
            } else {
                if (__this.chartData[varId].alarmThresholdsVisibleTemp) __this.toggleAlarmThresholds(varId);
                _hideSerie(varId);
                __this.saveDesktopSettingService.setSerieVisibilityAndScaleSettingSupergraph(varId, false, __this.chartData[varId].autoScale, [], __this);
            }
        } else toggleSeries = true;
    };

    // Sidebar checkbox/toggle icons are colored with the series color (which can come from the server palette).
    // WCAG 1.4.11 needs 3:1 against the white sidebar, so darken any hex color that falls short; the chart line keeps its own color.
    var _controlColorCache = {};
    var _relativeLuminance = function _relativeLuminance(rgb) {
        var _rgb$map = rgb.map(function (c) {
            c /= 255;return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
        }),
            _rgb$map2 = _slicedToArray(_rgb$map, 3),
            r = _rgb$map2[0],
            g = _rgb$map2[1],
            b = _rgb$map2[2];

        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    __this.controlColor = function (color) {
        if (typeof color !== 'string') return color;
        if (_controlColorCache[color] !== undefined) return _controlColorCache[color];
        var hex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(color.trim());
        if (!hex) return color;
        hex = hex[1].length === 3 ? hex[1].replace(/./g, '$&$&') : hex[1];
        var rgb = [0, 2, 4].map(function (i) {
            return parseInt(hex.substr(i, 2), 16);
        });
        for (var step = 0; step < 40 && 1.05 / (_relativeLuminance(rgb) + 0.05) < 3.1; step++) {
            rgb = rgb.map(function (c) {
                return Math.floor(c * 0.93);
            });
        }
        return _controlColorCache[color] = '#' + rgb.map(function (c) {
            return ('0' + c.toString(16)).slice(-2);
        }).join('');
    };

    // Keyboard support for the sidebar's clickable table cells (checkbox/switch style controls):
    // Space and Enter invoke the same $ctrl function the cell's ng-click would call, matching native checkbox/switch behaviour.
    __this.activateOnKey = function ($event, fn) {
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
        }

        var key = $event.key || $event.keyCode;
        var isSpace = key === ' ' || key === 'Spacebar' || key === 32;
        var isEnter = key === 'Enter' || key === 13;

        if (isSpace || isEnter) {
            $event.preventDefault();
            __this[fn].apply(__this, args);
        }
    };

    // Keyboard support for elements (e.g. popover triggers) whose only handler is a native click
    // listener attached by a directive, rather than an ng-click bound to a $ctrl function.
    __this.activateClickOnKey = function ($event) {
        var key = $event.key || $event.keyCode;
        var isSpace = key === ' ' || key === 'Spacebar' || key === 32;
        var isEnter = key === 'Enter' || key === 13;

        if (isSpace || isEnter) {
            $event.preventDefault();
            $event.target.click();
        }
    };

    // Keyboard-accessible alternative to the mouse-only ".dragAnalog" jQuery UI draggable set up
    // in _renderChart: Space/Enter "grabs" the drag handle and shows a floating preview, the arrow
    // keys move that preview, Space/Enter again "drops" it (opening the widget exactly like a mouse
    // drop would), and Escape cancels the grab. $ctrl.keyboardDragStatusMessage drives an aria-live
    // region so screen reader users get the same feedback sighted/mouse users get from the drag.
    var _keyboardDragStep = 15;
    var _keyboardDragHelper = null;
    __this.keyboardDragVarId = null;
    __this.keyboardDragStatusMessage = '';

    var _cancelKeyboardDrag = function _cancelKeyboardDrag() {
        if (_keyboardDragHelper) {
            _keyboardDragHelper.remove();
            _keyboardDragHelper = null;
        }
        __this.keyboardDragVarId = null;
    };

    var _keyboardDragArrowSteps = {
        ArrowUp: { x: 0, y: -_keyboardDragStep }, 38: { x: 0, y: -_keyboardDragStep },
        ArrowDown: { x: 0, y: _keyboardDragStep }, 40: { x: 0, y: _keyboardDragStep },
        ArrowLeft: { x: -_keyboardDragStep, y: 0 }, 37: { x: -_keyboardDragStep, y: 0 },
        ArrowRight: { x: _keyboardDragStep, y: 0 }, 39: { x: _keyboardDragStep, y: 0 }
    };

    __this.dragAnalogKeydown = function ($event, varId) {
        if ($scope.mobile || $scope.classicView) {
            return;
        }

        var key = $event.key || $event.keyCode;
        var isSpace = key === ' ' || key === 'Spacebar' || key === 32;
        var isEnter = key === 'Enter' || key === 13;
        var isEscape = key === 'Escape' || key === 27;
        var itemName = __this.chartData[varId] ? __this.chartData[varId].name : 'Analog Output Widget';

        if (isEscape && __this.keyboardDragVarId) {
            $event.preventDefault();
            _cancelKeyboardDrag();
            __this.keyboardDragStatusMessage = itemName + ' drag cancelled.';
            return;
        }

        if (isSpace || isEnter) {
            $event.preventDefault();
            if (__this.keyboardDragVarId !== varId) {
                _cancelKeyboardDrag();
                var $handle = $($event.currentTarget).find(".dragAnalog");
                var offset = $handle.offset();
                _keyboardDragHelper = $handle.clone().css({
                    position: "absolute",
                    top: offset.top,
                    left: offset.left,
                    opacity: 0.6,
                    zIndex: 10000,
                    pointerEvents: "none",
                    backgroundColor: "#fff",
                    outline: "2px dashed #337ab7"
                }).appendTo("body");
                __this.keyboardDragVarId = varId;
                __this.keyboardDragStatusMessage = itemName + ' grabbed. Use the arrow keys to move it, Spacebar or Enter to drop it, Escape to cancel.';
            } else {
                var _offset = _keyboardDragHelper.offset();
                var mcDevice = { deviceId: $scope.deviceSelected, channel: _keyboardDragHelper.attr("mc-channel"), serialNumber: $scope.deviceSelectedSn };
                var optionsStickyProperties = { device: mcDevice };
                var position = { my: "left+" + _offset.left + " top+" + _offset.top, at: "left top", of: window };
                _cancelKeyboardDrag();
                __this.keyboardDragStatusMessage = itemName + ' dropped.';
                openViewService.openWidget('Mc Single Needle Gauge Analog Output Widget', { width: 240, height: 240 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                $scope.$apply();
            }
            return;
        }

        if (__this.keyboardDragVarId === varId && _keyboardDragArrowSteps[key]) {
            $event.preventDefault();
            var step = _keyboardDragArrowSteps[key];
            var _offset2 = _keyboardDragHelper.offset();
            _keyboardDragHelper.offset({ left: _offset2.left + step.x, top: _offset2.top + step.y });
        }
    };

    __this.toggleSerieGroup = function (uiGroup) {
        for (var prop in __this.chartData) {
            if (__this.chartData.hasOwnProperty(prop) && __this.chartData[prop].uiGroup == uiGroup) {
                if (__this.uiGroup[uiGroup] == false) {
                    _showSerie(prop);
                    __this.saveDesktopSettingService.setSerieVisibilityAndScaleSettingSupergraph(prop, true, __this.chartData[prop].autoScale, [], __this);
                } else {
                    _hideSerie(prop);
                    __this.saveDesktopSettingService.setSerieVisibilityAndScaleSettingSupergraph(prop, false, __this.chartData[prop].autoScale, [], __this);
                }
            }
        }
        __this.uiGroup[uiGroup] = !__this.uiGroup[uiGroup];
    };

    var _showSerie = function _showSerie(varId) {

        for (var j = 0; j < chart.series.length; j++) {
            if ((chart.series[j].options.id === varId || chart.series[j].options.id === "flg-" + varId) && !chart.series[j].visible) {
                chart.series[j].setVisible(true, false);
                __this.chartData[varId].visible = true;
            }
        }

        if (varId == "siteAccess") {
            __this.addSiteAccess();
            __this.chartData[varId].visible = true;
        }
        if (chart.xAxis && chart.xAxis[0] && chart.xAxis[0].hasVisibleSeries && scrollChartEnabled == false) {
            scrollChartEnabled = true;
            chart.update({ navigator: { enabled: true } });
            _scrollingInProgress = false;
        }
        chart.redraw();
        _restartBroadcast();
    };

    var _hideSerie = function _hideSerie(varId) {
        for (var j = 0; j < chart.series.length; j++) {
            if ((chart.series[j].options.id === varId || chart.series[j].options.id === "flg-" + varId) && chart.series[j].visible) {
                chart.series[j].setVisible(false, false);
                __this.chartData[varId].visible = false;
            }
        }

        if (varId == "siteAccess") {
            __this.removeSiteAccess();
            __this.chartData[varId].visible = false;
        }
        if (chart.series.filter(function (s) {
            return s.visible == false;
        }).length == chart.series.length) {
            chart.update({ navigator: { enabled: false } });
            scrollChartEnabled = false;
            _scrollingInProgress = true;
        } else {
            scrollChartEnabled = true;
            chart.update({ navigator: { enabled: true } });
        }
    };

    var _clearChartData = function _clearChartData() {
        _yAxes = [];
        _series = [];
        __this.plotLines = [];
        __this.plotBandsYAxis = [];
        __this.siteAccessData = [];
    };

    var _checkStartBroadcast = function _checkStartBroadcast() {
        // Don't start if already started
        if (angular.isDefined(_startBroadcast) || _scrollingInProgress === true) return;
        if (!_liveData) _clearFlags();
        _startBroadcast = $timeout(function () {
            _startBroadcast = undefined; // will revisit this line of code (has to do with Alert())
            _updateFlags();
        }, 300);
    };

    var _stop = function _stop() {
        if (angular.isDefined(_startBroadcast)) {
            $timeout.cancel(_startBroadcast);
            _startBroadcast = undefined;
        }
    };

    var _restartBroadcast = function _restartBroadcast() {
        if (angular.isDefined(_startBroadcast)) _stop();
        _checkStartBroadcast();
    };

    var _addConnectivityBandFromLive = function _addConnectivityBandFromLive(connectivityData) {
        if (connectivityData.length > 0 && connectivityData[connectivityData.length - 1].segmentColor == "Transparent") {
            chart.xAxis[0].plotLinesAndBands[chart.xAxis[0].plotLinesAndBands.length - 1].options.to = _liveDataEndDate;
        }
    };

    var _buildConnectivityBands = function _buildConnectivityBands(connectivityData, addToChart) {
        if (__this.deviceType != 15 && __this.deviceType != 20) {
            for (var k = 0; k + 1 < connectivityData.length; k++) {
                if (connectivityData[k].segmentColor == "Transparent") {
                    var start = void 0,
                        end = void 0;
                    if (connectivityData[k + 1].segmentColor == "Transparent") {
                        start = connectivityData[k].x;
                        end = _liveData ? _liveDataEndDate : connectivityData[k + 1].x;
                    } else {
                        start = connectivityData[k].x;
                        end = connectivityData[k + 1].x;
                    }
                    if (addToChart) {
                        chart.xAxis[0].addPlotBand({
                            from: start,
                            to: end,
                            color: 'rgba(227, 227, 227)',
                            label: "White",
                            zIndex: 5
                        });
                    } else {
                        __this.plotBandsYAxis.push({
                            from: start,
                            to: end,
                            color: 'rgba(227, 227, 227)',
                            label: "White",
                            zIndex: 5
                        });
                    }
                    //continue;
                }
            }
        }
    };

    var _updateFlags = function _updateFlags() {
        if (angular.isUndefined(chart.series)) return;
        for (var j = 0; j < chart.series.length; j++) {
            var varId = chart.series[j].options.onSeries;
            if (varId) {
                switch (varId) {
                    case "vbatt":
                    case "vac":
                    case "vaux":
                    case "sign":
                    case "signalQuality":
                    case "signalPower":
                    case "temp":
                    case "rainT":
                    case "rainR":
                    case "ch1":
                    case "ch2":
                    case "ch3":
                    case "ch4":
                    case "ch5":
                    case "ch6":
                    case "ch7":
                    case "ch8":
                    case "ch9":
                    case "out1":
                    case "out2":
                    case "out3":
                    case "out4":
                    case "pulseFlow1":
                    case "pulseFlow2":
                    case "pulseFlow3":
                    case "pulseFlow4":
                    case "pulseFlow5":
                    case "pulseFlow6":
                        if (_liveData && chart.series[j].data.length > 0 && chart.series[j].data[0].x === __this.chartData[varId].x) chart.series[j].data[0].remove();
                        if (!angular.isDefined(__this.chartData[varId].y)) break;
                        if (!__this.chartData[varId].visible) break;
                        if (chart.series[j].data.length === 0 && new Date(__this.chartData[varId].x).getTime() > 0) {
                            chart.series[j].addPoint({
                                x: __this.chartData[varId].x - 1,
                                title: __this.chartData[varId].y.toFixed(__this.chartData[varId].decimal) + " " + __this.chartData[varId].unit,
                                text: __this.chartData[varId].y.toFixed(__this.chartData[varId].decimal) + " " + __this.chartData[varId].unit,
                                name: "" + __this.chartData[varId].name,
                                color: __this.chartData[varId].color,
                                fillColor: __this.chartData[varId].color
                            });
                        } else if (new Date(__this.chartData[varId].x).getTime() > 0) {
                            chart.series[j].data[0].update({
                                x: __this.chartData[varId].x - 1,
                                title: __this.chartData[varId].y.toFixed(__this.chartData[varId].decimal) + " " + __this.chartData[varId].unit,
                                text: __this.chartData[varId].y.toFixed(__this.chartData[varId].decimal) + " " + __this.chartData[varId].unit,
                                name: "" + __this.chartData[varId].name
                            });
                        }
                        break;
                }
            }
            var seriedId = chart.series[j].options.id;
            switch (seriedId) {
                case "conn":
                    _addConnectivityBandFromLive(chart.series[j].data);
                    // _buildConnectivityBands( chart.series[j].data, true);
                    break;
            }
        }
    };

    var _clearFlags = function _clearFlags() {
        if (!angular.isDefined(chart.series)) return;
        for (var j = 0; j < chart.series.length; j++) {
            var varId = chart.series[j].options.onSeries;
            if (varId) {
                switch (varId) {
                    case "vbatt":
                    case "vac":
                    case "vaux":
                    case "sign":
                    case "signalQuality":
                    case "signalPower":
                    case "temp":
                    case "rainT":
                    case "rainR":
                    case "ch1":
                    case "ch2":
                    case "ch3":
                    case "ch4":
                    case "ch5":
                    case "ch6":
                    case "ch7":
                    case "ch8":
                    case "ch9":
                    case "out1":
                    case "out2":
                    case "out3":
                    case "out4":
                    case "pulseFlow1":
                    case "pulseFlow2":
                    case "pulseFlow3":
                    case "pulseFlow4":
                    case "pulseFlow5":
                    case "pulseFlow6":
                        if (!__this.chartData[varId].visible) break;
                        if (chart.series[j].data.length > 0) {
                            if (chart.series[j].data.length > 0) {
                                chart.series[j].data[0].remove();
                            }
                        }
                        break;
                }
            }
        }
    };

    var _crosshairOnYaxis = function _crosshairOnYaxis(varId) {
        return false;
        switch (varId) {
            case "vbatt":
            case "vac":
            case "vaux":
            case "sign":
            case "signalQuality":
            case "signalPower":
            case "temp":
                return {
                    interpolate: true,
                    label: {
                        enabled: true,
                        format: '{value:.2f}' // Two decimals
                    }
                };
            default:
                return {
                    interpolate: false,
                    color: __this.chartData[varId].color
                };
        }
    };

    var _pushYaxis = function _pushYaxis(varId, varMin, varMax) {
        switch (varId) {
            case "conn":
                _yAxes.push({
                    reversed: true,
                    align: 'left',
                    endOnTick: false,
                    showLastLabel: true,
                    showFirstLabel: true,
                    startOnTick: false,
                    minTickInterval: 1,
                    tickInterval: 1,
                    step: 1,
                    min: 0.5,
                    max: _maxChannel + 0.5,
                    id: "yx-" + varId,
                    alignTicks: false,
                    gridLineWidth: 0,
                    labels: {
                        enabled: false,
                        align: 'left',
                        useHTML: true,
                        style: {
                            color: '#52667d',
                            fontWeight: 'bold'
                        }
                    },
                    top: "0%",
                    height: "1%"
                });
                break;
            case "vbatt":
            case "vac":
            case "vaux":
            case "sign":
            case "signalQuality":
            case "signalPower":
            case "temp":
            case "rainT":
            case "rainR":
            case "ch1":
            case "ch2":
            case "ch3":
            case "ch4":
            case "ch5":
            case "ch6":
            case "ch7":
            case "ch8":
            case "ch9":
            case "out1":
            case "out2":
            case "out3":
            case "out4":
            case "pulseFlow1":
            case "pulseFlow2":
            case "pulseFlow3":
            case "pulseFlow4":
            case "pulseFlow5":
            case "pulseFlow6":
                _yAxes.push({
                    id: "yx-" + varId,
                    alignTicks: false,
                    gridLineWidth: varId === "vac" ? .75 : 0,
                    gridLineColor: '#ececec',
                    labels: {
                        enabled: false,
                        align: null,
                        format: "{value:.2f}"
                    },
                    top: "1%",
                    height: _digitalSetting.length == 0 ? "99%" : _digitalSetting.length <= 4 ? "89%" : "84%",
                    resize: {
                        enabled: false
                    },
                    reversed: __this.reverseScale,
                    //min: varMin, - need for exporting support
                    //max: varMax, - need for exporting support
                    crosshair: _crosshairOnYaxis(varId)
                });
                break;
            case "digital":
                _yAxes.push({
                    reversed: true,
                    align: 'left',
                    endOnTick: false,
                    showLastLabel: true,
                    showFirstLabel: true,
                    startOnTick: false,
                    minTickInterval: 1,
                    tickInterval: 1,
                    step: 1,
                    min: 0.5,
                    max: _maxChannel + 0.5,
                    id: "yx-" + varId,
                    alignTicks: false,
                    gridLineWidth: 0,
                    labels: {
                        enabled: false,
                        align: 'left',
                        useHTML: true,
                        style: {
                            color: '#52667d',
                            fontWeight: 'bold'
                        }
                    },
                    top: _digitalSetting.length == 0 ? "100%" : _digitalSetting.length <= 4 ? "90%" : "85%",
                    height: _digitalSetting.length == 0 ? "0%" : _digitalSetting.length <= 4 ? "10%" : "15%",
                    plotBands: [{
                        from: 0.5,
                        to: _maxChannel + 0.5,
                        color: '#edffff',
                        borderColor: '#d1fdfd',
                        borderWidth: 1,
                        zIndex: -1
                    }]
                });
                break;
            case "tickPositioner":
                _yAxes.push({
                    linkedTo: null,
                    opposite: true,
                    labels: {
                        enabled: false
                    },
                    tickPositioner: function tickPositioner(min, max) {
                        var extremes = this.chart.xAxis[0].getExtremes();
                        for (var i = 0; i < this.chart.series.length; i++) {
                            var dataY = this.chart.series[i].processedYData;
                            var dataX = this.chart.series[i].processedXData;

                            switch (this.chart.series[i].options.id) {
                                case "vbatt1":
                                case "vac1":
                                case "sign1":
                                //case "conn":
                                case "temp1":
                                case "rainT1":
                                case "rainR1":
                                    //??? issue extracting extremes.max
                                    if (_liveData && angular.isDefined(this.chart.series[i].data[this.chart.series[i].data.length - 1])) {
                                        for (var z = this.chart.series[i].data.length - 1; z >= 0; z--) {
                                            if (this.chart.series[i].data[z].y !== null) {
                                                __this.chartData[this.chart.series[i].options.id].y = this.chart.series[i].data[z].y;
                                                __this.chartData[this.chart.series[i].options.id].x = this.chart.series[i].data[z].x;
                                                __this.chartData[this.chart.series[i].options.id].color = this.chart.series[i].options.color;
                                                break;
                                            }
                                        }
                                        break;
                                    }
                                    for (var _z = 0; _z < this.chart.series[i].data.length; _z++) {
                                        if (angular.isDefined(this.chart.series[i].data[_z]) && this.chart.series[i].data[_z].x > extremes.max) {
                                            __this.chartData[this.chart.series[i].options.id].y = this.chart.series[i].data[_z].y;
                                            __this.chartData[this.chart.series[i].options.id].x = extremes.max;
                                            __this.chartData[this.chart.series[i].options.id].color = this.chart.series[i].options.color;
                                            break;
                                        }
                                    }
                                    break;
                                case "ch1":
                                case "ch2":
                                case "ch3":
                                case "ch4":
                                case "ch5":
                                case "ch6":
                                case "ch7":
                                case "ch8":
                                case "ch9":
                                case "out1":
                                case "out2":
                                case "out3":
                                case "out4":
                                case "vbatt":
                                case "vac":
                                case "vaux":
                                case "sign":
                                case "signalQuality":
                                case "signalPower":
                                case "temp":
                                case "rainT":
                                case "rainR":
                                case "pulseFlow1":
                                case "pulseFlow2":
                                case "pulseFlow3":
                                case "pulseFlow4":
                                case "pulseFlow5":
                                case "pulseFlow6":
                                    __this.chartData[this.chart.series[i].options.id].color = this.chart.series[i].options.color;
                                    if (_liveData && angular.isDefined(this.chart.series[i].data[this.chart.series[i].data.length - 1]) || _isZoomOut) {
                                        for (var _z2 = this.chart.series[i].data.length - 1; _z2 >= 0; _z2--) {
                                            if (this.chart.series[i].data[_z2] != null && this.chart.series[i].data[_z2].y !== null) {
                                                __this.chartData[this.chart.series[i].options.id].y = this.chart.series[i].data[_z2].y;
                                                __this.chartData[this.chart.series[i].options.id].x = this.chart.series[i].data[_z2].x;
                                                break;
                                            }
                                        }
                                        break;
                                    }
                                    __this.chartData[this.chart.series[i].options.id].y = dataY[dataY.length - 1];
                                    __this.chartData[this.chart.series[i].options.id].x = extremes.max;
                                    break;
                            }
                        }
                        //return null;//[data[data.length - 1]];
                    }
                });
                break;
        }
    };

    var _getFlagText = function _getFlagText(item) {
        var _txt = item.alarmDescription + "<br>" + item.repStateDesc;
        var _timeMeasureUnit = "";
        if (item.ackName) {
            if (item.duration > 120) {
                _timeMeasureUnit = "hours";
                _txt = _txt + ": " + item.ackName + " (" + (item.duration / 60).toFixed(2) + " " + _timeMeasureUnit + ")";
            } else {
                _timeMeasureUnit = "minutes";
                _txt = _txt + ": " + item.ackName + " (" + item.duration + " " + _timeMeasureUnit + ")";
            }
        }
        //_txt = item.ackName ? `${_txt}: ${item.ackName} (${item.duration})` : _txt;         
        return _txt;
    };

    var _getData = function _getData(deviceId, StartDate, EndDate, id) {
        var dataCategorySG = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "All";
        var zoomAdjustDays = arguments[5];

        if (deviceId == null) return;
        _startData = StartDate;
        _endDate = EndDate;
        _liveDataEndDate = EndDate;
        if (dataCategorySG == "All") _clearChartData();
        var _supergraph = new SupergraphFactory(__this.accountInfo.customerId, deviceId, $scope.deviceSelectedType, Math.floor(StartDate), Math.floor(EndDate), id, dataCategorySG, __this.accountInfo.timeZone, __this.stickyProperties, parseInt(__this.selectedPulseFlowGrouping));
        _supergraph.getData().then(function () {

            var _datafromFactory = { data: _supergraph.list };

            switch (dataCategorySG) {
                case "PulseFlow":
                    if (_datafromFactory.data.pulseFlow) {

                        //Adding new pulse data to Supergraph
                        for (var i = 0; i < _datafromFactory.data.pulseFlow.setting.length; i++) {
                            __this.chartData["pulseFlow" + _datafromFactory.data.pulseFlow.setting[i].channel].name = _datafromFactory.data.pulseFlow.setting[i].channelName;
                            __this.chartData["pulseFlow" + _datafromFactory.data.pulseFlow.setting[i].channel].unit = _datafromFactory.data.pulseFlow.setting[i].unit;
                            __this.chartData["pulseFlow" + _datafromFactory.data.pulseFlow.setting[i].channel].flowScale = _datafromFactory.data.pulseFlow.setting[i].flowScale;
                            __this.chartData["pulseFlow" + _datafromFactory.data.pulseFlow.setting[i].channel].uiGroup = 8;
                            __this.hasPulseFlow = true;
                        }
                        if (!_datafromFactory.data.pulseFlow.series) _datafromFactory.data.pulseFlow.series = [];
                        for (var _i = 0; _i < _datafromFactory.data.pulseFlow.series.length; _i++) {
                            _datafromFactory.data.pulseFlow.series[_i].id = "pulseFlow" + _datafromFactory.data.pulseFlow.series[_i].id;
                            _datafromFactory.data.pulseFlow.series[_i].yAxis = "yx-" + _datafromFactory.data.pulseFlow.series[_i].id;
                            _datafromFactory.data.pulseFlow.series[_i].lineWidth = 2;
                            _datafromFactory.data.pulseFlow.series[_i].states = {
                                hover: {
                                    enabled: true
                                }
                            };
                            _datafromFactory.data.pulseFlow.series[_i].marker = {
                                enabled: null,
                                radius: 2.5,
                                fillColor: '#FFFFFF',
                                lineWidth: 1.5,
                                lineColor: null // inherit from series
                            };

                            delete _datafromFactory.data.pulseFlow.series[_i].downsample;

                            for (var j = 0; j < _series.length; j++) {
                                if (_series[j].id == _datafromFactory.data.pulseFlow.series[_i].id) {
                                    _series[j] = _datafromFactory.data.pulseFlow.series[_i];
                                    chart.series[j].setData(_series[j].data, false);
                                }
                            }
                        }
                        __this.reverseScale = false;
                    }
                    break;

                case "All":

                    __this.reverseScale = false;
                    __this.dataIsInFormat = 1;
                    __this.deviceType = _datafromFactory.data.analog.device.type;
                    __this.hasRMDTRadio = _datafromFactory.data.analog.device.hasRMDTRadio;

                    //need the following for _pushYaxis("digital")
                    _digitalSetting = _datafromFactory.data.digital.digitalSettings;
                    _maxChannel = _digitalSetting.length > 0 ? _digitalSetting[_digitalSetting.length - 1].channel : 0;
                    //need the above for _pushYaxis("digital")
                    _buildConnectivityBands(_datafromFactory.data.connectivity.data, false);
                    __this.skuId = _datafromFactory.data.analog.device.skuId;
                    _pushYaxis("tickPositioner");
                    for (var _i2 = 0; _i2 < _datafromFactory.data.analog.setting.length; _i2++) {
                        __this.chartData["ch" + _datafromFactory.data.analog.setting[_i2].channel].name = _datafromFactory.data.analog.setting[_i2].name;
                        __this.chartData["ch" + _datafromFactory.data.analog.setting[_i2].channel].unit = _datafromFactory.data.analog.setting[_i2].unit;
                        __this.chartData["ch" + _datafromFactory.data.analog.setting[_i2].channel].min = _datafromFactory.data.analog.setting[_i2].minimumValue;
                        __this.chartData["ch" + _datafromFactory.data.analog.setting[_i2].channel].max = _datafromFactory.data.analog.setting[_i2].maximumValue;
                        __this.chartData["ch" + _datafromFactory.data.analog.setting[_i2].channel].uiGroup = 1;
                        __this.chartData["ch" + _datafromFactory.data.analog.setting[_i2].channel].decimal = sharedSetupService.getNumberOfDecimals(__this.chartData["ch" + _datafromFactory.data.analog.setting[_i2].channel].max, __this.chartData["ch" + _datafromFactory.data.analog.setting[_i2].channel].min);
                        __this.hasAnalog = true;
                    }

                    if (_datafromFactory.data.analog) {
                        if (!_datafromFactory.data.analog.series) _datafromFactory.data.analog.series = [];
                        for (var _i3 = 0; _i3 < _datafromFactory.data.analog.series.length; _i3++) {
                            _datafromFactory.data.analog.series[_i3].id = "ch" + _datafromFactory.data.analog.series[_i3].id;
                            _datafromFactory.data.analog.series[_i3].yAxis = "yx-" + _datafromFactory.data.analog.series[_i3].id;
                            _datafromFactory.data.analog.series[_i3].lineWidth = 2;
                            _datafromFactory.data.analog.series[_i3].states = {
                                hover: {
                                    enabled: true
                                }
                            };
                            _datafromFactory.data.analog.series[_i3].marker = {
                                enabled: null,
                                radius: 2.5,
                                fillColor: '#FFFFFF',
                                lineWidth: 1.5,
                                lineColor: null // inherit from series
                            };
                            if (_datafromFactory.data.analog != null && _datafromFactory.data.analog.thresholds != null && _datafromFactory.data.analog.thresholds.length > 0) {
                                var thresholdsLowFault = _datafromFactory.data.analog.thresholds[_i3].lowFault;
                                if (thresholdsLowFault !== null) __this.plotLines.push({
                                    id: "lf", yAxis: "yx-" + _datafromFactory.data.analog.series[_i3].id, color: _datafromFactory.data.analog.series[_i3].color, dashStyle: "ShortDash",
                                    label: { text: _datafromFactory.data.analog.thresholds[_i3].thresholdDescriptions.en.lowFault + '(' + thresholdsLowFault.toFixed(2) + '' + _datafromFactory.data.analog.setting[_i3].unit + ')' }, value: thresholdsLowFault, width: 1, zIndex: 0
                                });
                                var thresholdsLowRestore = _datafromFactory.data.analog.thresholds[_i3].lowRestore;
                                if (thresholdsLowRestore !== null) __this.plotLines.push({
                                    id: "lr", yAxis: "yx-" + _datafromFactory.data.analog.series[_i3].id, color: _datafromFactory.data.analog.series[_i3].color, dashStyle: "Dash",
                                    label: { text: _datafromFactory.data.analog.thresholds[_i3].thresholdDescriptions.en.lowRestore + '(' + thresholdsLowRestore.toFixed(2) + '' + _datafromFactory.data.analog.setting[_i3].unit + ')' }, value: thresholdsLowRestore, width: 1, zIndex: 0
                                });
                                var thresholdsHighRestore = _datafromFactory.data.analog.thresholds[_i3].highRestore;
                                if (thresholdsHighRestore !== null) __this.plotLines.push({
                                    id: "hr", yAxis: "yx-" + _datafromFactory.data.analog.series[_i3].id, color: _datafromFactory.data.analog.series[_i3].color, dashStyle: "Dash",
                                    label: { text: _datafromFactory.data.analog.thresholds[_i3].thresholdDescriptions.en.highRestore + '(' + thresholdsHighRestore.toFixed(2) + '' + _datafromFactory.data.analog.setting[_i3].unit + ')' }, value: thresholdsHighRestore, width: 1, zIndex: 0
                                });
                                var thresholdsHighFault = _datafromFactory.data.analog.thresholds[_i3].highFault;
                                if (thresholdsHighFault !== null) __this.plotLines.push({
                                    id: "hf", yAxis: "yx-" + _datafromFactory.data.analog.series[_i3].id, color: _datafromFactory.data.analog.series[_i3].color, dashStyle: "ShortDash",
                                    label: { text: _datafromFactory.data.analog.thresholds[_i3].thresholdDescriptions.en.highFault + '(' + thresholdsHighFault.toFixed(2) + '' + _datafromFactory.data.analog.setting[_i3].unit + ')' }, value: thresholdsHighFault, width: 1, zIndex: 0
                                });
                                var thresholdsHighHighRestore = _datafromFactory.data.analog.thresholds[_i3].highHighRestore;
                                if (thresholdsHighHighRestore !== null) __this.plotLines.push({
                                    id: "hhr", yAxis: "yx-" + _datafromFactory.data.analog.series[_i3].id, color: _datafromFactory.data.analog.series[_i3].color, dashStyle: "Dash",
                                    label: { text: _datafromFactory.data.analog.thresholds[_i3].thresholdDescriptions.en.highHighRestore + '(' + thresholdsHighHighRestore.toFixed(2) + '' + _datafromFactory.data.analog.setting[_i3].unit + ')' }, value: thresholdsHighHighRestore, width: 1, zIndex: 0
                                });
                                var thresholdsHighHighFault = _datafromFactory.data.analog.thresholds[_i3].highHighFault;
                                if (thresholdsHighHighFault !== null) __this.plotLines.push({
                                    id: "hhf", yAxis: "yx-" + _datafromFactory.data.analog.series[_i3].id, color: _datafromFactory.data.analog.series[_i3].color, dashStyle: "ShortDash",
                                    label: { text: _datafromFactory.data.analog.thresholds[_i3].thresholdDescriptions.en.highHighFault + '(' + thresholdsHighHighFault.toFixed(2) + '' + _datafromFactory.data.analog.setting[_i3].unit + ')' }, value: thresholdsHighHighFault, width: 1, zIndex: 0
                                });
                                __this.chartData[_datafromFactory.data.analog.series[_i3].id].isAlarmThreshold = thresholdsLowFault || thresholdsLowRestore || thresholdsHighRestore || thresholdsHighFault;
                            }
                            if (__this.chartData[_datafromFactory.data.analog.series[_i3].id].min > __this.chartData[_datafromFactory.data.analog.series[_i3].id].max) {
                                __this.reverseScale = true;
                            } else {
                                __this.reverseScale = false;
                            }
                            _pushYaxis(_datafromFactory.data.analog.series[_i3].id, __this.chartData[_datafromFactory.data.analog.series[_i3].id].min, __this.chartData[_datafromFactory.data.analog.series[_i3].id].max);
                            _series.push(_datafromFactory.data.analog.series[_i3]);
                            _series.push({
                                type: 'flags',
                                data: [],
                                id: "flg-" + _datafromFactory.data.analog.series[_i3].id,
                                onSeries: _datafromFactory.data.analog.series[_i3].id,
                                shape: 'flag',
                                lineColor: _datafromFactory.data.analog.series[_i3].color,
                                fillColor: _datafromFactory.data.analog.series[_i3].color,
                                lineWidth: 1,
                                zIndex: 10,
                                style: {
                                    color: getContrastTextColor(_datafromFactory.data.analog.series[_i3].color)
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    }
                                },
                                shadow: true,
                                // y: -30,
                                includeInCSVExport: false
                            });
                        }
                        __this.reverseScale = false;
                    }

                    if (_datafromFactory.data.analogOutput) {

                        for (var _i4 = 0; _i4 < _datafromFactory.data.analogOutput.outputSetting.length; _i4++) {
                            __this.chartData["out" + _datafromFactory.data.analogOutput.outputSetting[_i4].channel].name = _datafromFactory.data.analogOutput.outputSetting[_i4].channelName;
                            __this.chartData["out" + _datafromFactory.data.analogOutput.outputSetting[_i4].channel].unit = _datafromFactory.data.analogOutput.outputSetting[_i4].unit;
                            __this.chartData["out" + _datafromFactory.data.analogOutput.outputSetting[_i4].channel].min = _datafromFactory.data.analogOutput.outputSetting[_i4].minimumValue;
                            __this.chartData["out" + _datafromFactory.data.analogOutput.outputSetting[_i4].channel].max = _datafromFactory.data.analogOutput.outputSetting[_i4].maximumValue;
                            __this.chartData["out" + _datafromFactory.data.analogOutput.outputSetting[_i4].channel].uiGroup = 7;
                            __this.chartData["out" + _datafromFactory.data.analogOutput.outputSetting[_i4].channel].decimal = sharedSetupService.getNumberOfDecimals(__this.chartData["out" + _datafromFactory.data.analogOutput.outputSetting[_i4].channel].max, __this.chartData["out" + _datafromFactory.data.analogOutput.outputSetting[_i4].channel].min);
                            __this.hasAnalogOutput = true;
                        }

                        __this.deviceType = _datafromFactory.data.analogOutput.device.type;
                        if (!_datafromFactory.data.analogOutput.series) _datafromFactory.data.analogOutput.series = [];
                        for (var _i5 = 0; _i5 < _datafromFactory.data.analogOutput.series.length; _i5++) {
                            _datafromFactory.data.analogOutput.series[_i5].id = "out" + _datafromFactory.data.analogOutput.series[_i5].id;
                            _datafromFactory.data.analogOutput.series[_i5].yAxis = "yx-" + _datafromFactory.data.analogOutput.series[_i5].id;
                            _datafromFactory.data.analogOutput.series[_i5].lineWidth = 2;
                            _datafromFactory.data.analogOutput.series[_i5].states = {
                                hover: {
                                    enabled: true
                                }
                            };
                            _datafromFactory.data.analogOutput.series[_i5].marker = {
                                enabled: null,
                                radius: 2.5,
                                fillColor: '#FFFFFF',
                                lineWidth: 1.5,
                                lineColor: null // inherit from series
                            };

                            if (__this.chartData[_datafromFactory.data.analogOutput.series[_i5].id].min > __this.chartData[_datafromFactory.data.analogOutput.series[_i5].id].max) {
                                __this.reverseScale = true;
                            } else {
                                __this.reverseScale = false;
                            }

                            _pushYaxis(_datafromFactory.data.analogOutput.series[_i5].id, __this.chartData[_datafromFactory.data.analogOutput.series[_i5].id].min, __this.chartData[_datafromFactory.data.analogOutput.series[_i5].id].max);
                            delete _datafromFactory.data.analogOutput.series[_i5].downsample;
                            _series.push(_datafromFactory.data.analogOutput.series[_i5]);

                            _series.push({
                                type: 'flags',
                                data: [],
                                id: "flg-" + _datafromFactory.data.analogOutput.series[_i5].id,
                                onSeries: _datafromFactory.data.analogOutput.series[_i5].id,
                                shape: 'flag',
                                lineColor: _datafromFactory.data.analogOutput.series[_i5].color,
                                fillColor: _datafromFactory.data.analogOutput.series[_i5].color,
                                lineWidth: 1,
                                zIndex: 10,
                                style: {
                                    color: getContrastTextColor(_datafromFactory.data.analogOutput.series[_i5].color)
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    }
                                },
                                shadow: true,
                                y: -30,
                                includeInCSVExport: false
                            });
                        }
                        __this.reverseScale = false;
                    }

                    if (_datafromFactory.data.pulseFlow && _datafromFactory.data.pulseFlow.setting && _datafromFactory.data.pulseFlow.setting.length > 0) {

                        //Adding new pulse data to Supergraph
                        for (var _i6 = 0; _i6 < _datafromFactory.data.pulseFlow.setting.length; _i6++) {
                            __this.chartData["pulseFlow" + _datafromFactory.data.pulseFlow.setting[_i6].channel].name = _datafromFactory.data.pulseFlow.setting[_i6].channelName;
                            __this.chartData["pulseFlow" + _datafromFactory.data.pulseFlow.setting[_i6].channel].unit = _datafromFactory.data.pulseFlow.setting[_i6].unit;
                            __this.chartData["pulseFlow" + _datafromFactory.data.pulseFlow.setting[_i6].channel].flowScale = _datafromFactory.data.pulseFlow.setting[_i6].flowScale;
                            __this.chartData["pulseFlow" + _datafromFactory.data.pulseFlow.setting[_i6].channel].uiGroup = 8;
                            __this.hasPulseFlow = true;
                        }
                        if (!_datafromFactory.data.pulseFlow.series) _datafromFactory.data.pulseFlow.series = [];
                        for (var _i7 = 0; _i7 < _datafromFactory.data.pulseFlow.series.length; _i7++) {
                            _datafromFactory.data.pulseFlow.series[_i7].id = "pulseFlow" + _datafromFactory.data.pulseFlow.series[_i7].id;
                            _datafromFactory.data.pulseFlow.series[_i7].yAxis = "yx-" + _datafromFactory.data.pulseFlow.series[_i7].id;
                            _datafromFactory.data.pulseFlow.series[_i7].lineWidth = 2;
                            _datafromFactory.data.pulseFlow.series[_i7].states = {
                                hover: {
                                    enabled: true
                                }
                            };
                            _datafromFactory.data.pulseFlow.series[_i7].marker = {
                                enabled: null,
                                radius: 2.5,
                                fillColor: '#FFFFFF',
                                lineWidth: 1.5,
                                lineColor: null // inherit from series
                            };

                            _pushYaxis(_datafromFactory.data.pulseFlow.series[_i7].id, __this.chartData[_datafromFactory.data.pulseFlow.series[_i7].id].min, __this.chartData[_datafromFactory.data.pulseFlow.series[_i7].id].max);
                            delete _datafromFactory.data.pulseFlow.series[_i7].downsample;
                            _series.push(_datafromFactory.data.pulseFlow.series[_i7]);

                            _series.push({
                                type: 'flags',
                                data: [],
                                id: "flg-" + _datafromFactory.data.pulseFlow.series[_i7].id,
                                onSeries: _datafromFactory.data.pulseFlow.series[_i7].id,
                                shape: 'flag',
                                lineColor: _datafromFactory.data.pulseFlow.series[_i7].color,
                                fillColor: _datafromFactory.data.pulseFlow.series[_i7].color,
                                lineWidth: 1,
                                zIndex: 10,
                                style: {
                                    color: getContrastTextColor(_datafromFactory.data.pulseFlow.series[_i7].color)
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    }
                                },
                                shadow: true,
                                y: -30,
                                includeInCSVExport: false
                            });
                        }
                        __this.reverseScale = false;
                    }

                    $scope.alerts = [];
                    var _device = { deviceName: $scope.deviceSelectedName };

                    var _seriesRainfall = [{}, {}];
                    //if meterGauge is configured then use it as the name to display
                    __this.metarStation = _datafromFactory.data.rainfall.metarStation;
                    __this.weatherName = _datafromFactory.data.rainfall.metarStation != null ? _datafromFactory.data.rainfall.metarStation.gaugeName != null ? _datafromFactory.data.rainfall.metarStation.gaugeName : _datafromFactory.data.rainfall.metarStation.displayName : __this.translation.text.WEATHER_STATION_NOT_SETUP;
                    __this.metarStationID = _datafromFactory.data.rainfall.metarStation != null ? _datafromFactory.data.rainfall.metarStation.metarStationID : 0;

                    __this.chartData.rainR.name = "Rainfall";
                    __this.chartData.rainR.unit = "in";
                    __this.chartData.rainR.color = getPaletteColor(_datafromFactory.data, 12, "#1f8a1f");
                    __this.chartData.rainR.min = 0;
                    __this.chartData.rainR.max = 10;
                    __this.chartData.rainR.uiGroup = 4;
                    __this.chartData.rainR.translationKey = "RAINFALL";
                    __this.chartData.rainR.decimal = sharedSetupService.getNumberOfDecimals(__this.chartData.rainR.max, __this.chartData.rainR.min);

                    _seriesRainfall[0].name = __this.chartData.rainR.name + "(" + __this.chartData.rainR.unit + ")";
                    _seriesRainfall[0].data = _datafromFactory.data.rainfall.seriesData[0];
                    _seriesRainfall[0].color = __this.chartData.rainR.color;
                    _seriesRainfall[0].id = "rainR";
                    _seriesRainfall[0].yAxis = "yx-rainR";
                    _seriesRainfall[0].tooltip = {
                        valueDecimals: 2
                    };
                    _seriesRainfall[0].zIndex = 6;
                    _seriesRainfall[0].lineWidth = 1;
                    _seriesRainfall[0].states = {
                        hover: {
                            enabled: false
                        }
                    };
                    _seriesRainfall[0].marker = {
                        enabled: null,
                        symbol: 'circle',
                        radius: 2,
                        fillColor: '#FFFFFF',
                        lineWidth: 1,
                        lineColor: null // inherit from series
                    };

                    _pushYaxis("rainR", __this.chartData.rainR.min, __this.chartData.rainR.max);
                    _series.push(_seriesRainfall[0]);

                    _series.push({
                        type: 'flags',
                        data: [],
                        id: "flg-rainR",
                        onSeries: 'rainR',
                        shape: 'flag',
                        lineColor: __this.chartData.rainR.color,
                        fillColor: __this.chartData.rainR.color,
                        lineWidth: 1,
                        zIndex: 10,
                        style: {
                            color: getContrastTextColor(__this.chartData.rainR.color)
                        },
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        shadow: true,
                        y: -30,
                        includeInCSVExport: false,
                        downsample: {
                            threshold: 0 // 0 disables downsampling
                        }
                    });

                    __this.chartData.rainT.name = "Temperature";
                    __this.chartData.rainT.unit = __this.unit;
                    __this.chartData.rainT.color = getPaletteColor(_datafromFactory.data, 6, "#8f7300");
                    __this.chartData.rainT.min = -10;
                    __this.chartData.rainT.max = 120;
                    __this.chartData.rainT.uiGroup = 4;
                    __this.chartData.rainT.translationKey = "TEMPERATURE";

                    var seriesRainfallData = _datafromFactory.data.rainfall.seriesData && _datafromFactory.data.rainfall.seriesData.length > 1 && _datafromFactory.data.rainfall.seriesData[1].length > 0 ? _convertData(_datafromFactory.data.rainfall.seriesData[1]) : [];
                    _seriesRainfall[1].name = __this.chartData.rainT.name + "(" + __this.chartData.rainT.unit + ")";
                    _seriesRainfall[1].data = seriesRainfallData;
                    _seriesRainfall[1].color = __this.chartData.rainT.color;
                    _seriesRainfall[1].id = "rainT";
                    _seriesRainfall[1].yAxis = "yx-rainT";
                    _seriesRainfall[1].tooltip = {
                        valueDecimals: 2
                    };
                    _seriesRainfall[1].zIndex = 6;
                    _seriesRainfall[1].lineWidth = 1;
                    _seriesRainfall[1].states = {
                        hover: {
                            enabled: false
                        }
                    };
                    _seriesRainfall[1].marker = {
                        enabled: null,
                        symbol: 'circle',
                        radius: 2,
                        fillColor: '#FFFFFF',
                        lineWidth: 1,
                        lineColor: null // inherit from series
                    };

                    _pushYaxis("rainT", __this.chartData.rainT.min, __this.chartData.rainT.max);
                    _series.push(_seriesRainfall[1]);

                    _series.push({
                        type: 'flags',
                        data: [],
                        id: "flg-rainT",
                        onSeries: 'rainT',
                        shape: 'flag',
                        lineColor: __this.chartData.rainT.color,
                        fillColor: __this.chartData.rainT.color,
                        lineWidth: 1,
                        zIndex: 10,
                        style: {
                            color: getContrastTextColor(__this.chartData.rainT.color)
                        },
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        shadow: true,
                        y: -30,
                        includeInCSVExport: false
                    });

                    _lastRainfallDate = _seriesRainfall[0].data.length > 0 ? _seriesRainfall[0].data[_seriesRainfall[0].data.length - 1][0] : null;

                    //": {
                    //"metarStationID": 59,
                    //"city": "Houston",
                    //"state": "TX",
                    //"icao": "KIAH",
                    //"displayName": "Houston, TX (KIAH)"
                    //}

                    var _seriesVoltage = _datafromFactory.data.voltage.series;
                    for (var _i8 = 0; _i8 < _seriesVoltage.length; _i8++) {
                        switch (_i8) {
                            case 0:
                                __this.chartData.vbatt.name = "Battery";
                                __this.chartData.vbatt.unit = "VDC";
                                __this.chartData.vbatt.color = getPaletteColor(_datafromFactory.data, 5, "#808000");
                                __this.chartData.vbatt.min = 0;
                                __this.chartData.vbatt.max = 20;
                                __this.chartData.vbatt.uiGroup = 2;
                                __this.chartData.vbatt.translationKey = "BATTERY";
                                __this.chartData.vbatt.decimal = sharedSetupService.getNumberOfDecimals(__this.chartData.vbatt.max, __this.chartData.vbatt.min);

                                _seriesVoltage[_i8].color = __this.chartData.vbatt.color;
                                _seriesVoltage[_i8].id = "vbatt";
                                _seriesVoltage[_i8].yAxis = "yx-vbatt";
                                _seriesVoltage[_i8].tooltip = {
                                    valueDecimals: 2
                                };
                                _seriesVoltage[_i8].lineWidth = 1;
                                _seriesVoltage[_i8].states = {
                                    hover: {
                                        enabled: false
                                    }
                                };
                                _seriesVoltage[_i8].marker = {
                                    enabled: null,
                                    symbol: 'circle',
                                    radius: 2,
                                    fillColor: '#FFFFFF',
                                    lineWidth: 1,
                                    lineColor: null // inherit from series
                                };

                                _pushYaxis("vbatt", __this.chartData.vbatt.min, __this.chartData.vbatt.max);
                                delete _seriesVoltage[_i8].downsample;
                                _series.push(_seriesVoltage[_i8]);

                                _series.push({
                                    type: 'flags',
                                    data: [],
                                    id: "flg-vbatt",
                                    onSeries: 'vbatt',
                                    shape: 'flag',
                                    lineColor: __this.chartData.vbatt.color,
                                    fillColor: __this.chartData.vbatt.color,
                                    lineWidth: 1,
                                    zIndex: 10,
                                    style: {
                                        color: getContrastTextColor(__this.chartData.vbatt.color)
                                    },
                                    states: {
                                        hover: {
                                            enabled: false
                                        }
                                    },
                                    shadow: true,
                                    y: -30,
                                    includeInCSVExport: false
                                });

                                break;
                            case 1:
                                if (__this.deviceType !== 20 && __this.deviceType !== 21) {
                                    __this.chartData.vac.name = _datafromFactory.data.voltage.device.solar ? "DC Voltage" : "AC Power";
                                    __this.chartData.vac.unit = _datafromFactory.data.voltage.device.solar ? "VDC" : "VAC";
                                    __this.chartData.vac.color = getPaletteColor(_datafromFactory.data, 13, "#c2185b");
                                    __this.chartData.vac.min = 0;
                                    __this.chartData.vac.max = 20;
                                    __this.chartData.vac.uiGroup = 2;
                                    __this.chartData.vac.translationKey = _datafromFactory.data.voltage.device.solar ? "DC_VOLTAGE" : "AC_POWER";
                                    __this.chartData.vac.decimal = sharedSetupService.getNumberOfDecimals(__this.chartData.vac.max, __this.chartData.vac.min);

                                    _seriesVoltage[_i8].color = __this.chartData.vac.color;
                                    _seriesVoltage[_i8].id = "vac";
                                    _seriesVoltage[_i8].yAxis = "yx-vac";
                                    _seriesVoltage[_i8].tooltip = {
                                        valueDecimals: 2
                                    };
                                    _seriesVoltage[_i8].lineWidth = 1;
                                    _seriesVoltage[_i8].states = {
                                        hover: {
                                            enabled: false
                                        }
                                    };
                                    _seriesVoltage[_i8].marker = {
                                        enabled: null,
                                        symbol: 'circle',
                                        radius: 2,
                                        fillColor: '#FFFFFF',
                                        lineWidth: 1,
                                        lineColor: null // inherit from series
                                    };

                                    _pushYaxis("vac", __this.chartData.vac.min, __this.chartData.vac.max);
                                    delete _seriesVoltage[_i8].downsample;
                                    _series.push(_seriesVoltage[_i8]);

                                    _series.push({
                                        type: 'flags',
                                        data: [],
                                        id: "flg-vac",
                                        onSeries: 'vac',
                                        shape: 'flag',
                                        lineColor: __this.chartData.vac.color,
                                        fillColor: __this.chartData.vac.color,
                                        lineWidth: 1,
                                        zIndex: 10,
                                        style: {
                                            color: getContrastTextColor(__this.chartData.vac.color)
                                        },
                                        states: {
                                            hover: {
                                                enabled: false
                                            }
                                        },
                                        shadow: true,
                                        y: -30,
                                        includeInCSVExport: false
                                    });
                                }

                                break;
                            case 2:
                                __this.chartData.vaux.name = "Aux Power Supply";
                                __this.chartData.vaux.unit = "VDC";
                                __this.chartData.vaux.color = getPaletteColor(_datafromFactory.data, 1, "#1a8a7a");
                                __this.chartData.vaux.min = 0;
                                __this.chartData.vaux.max = 24;
                                __this.chartData.vaux.uiGroup = 2;
                                __this.chartData.vaux.translationKey = "VAUX";
                                __this.chartData.vaux.decimal = sharedSetupService.getNumberOfDecimals(__this.chartData.vaux.max, __this.chartData.vaux.min);

                                _seriesVoltage[_i8].color = __this.chartData.vaux.color;
                                _seriesVoltage[_i8].id = "vaux";
                                _seriesVoltage[_i8].yAxis = "yx-vaux";
                                _seriesVoltage[_i8].tooltip = {
                                    valueDecimals: 2
                                };
                                _seriesVoltage[_i8].lineWidth = 1;
                                _seriesVoltage[_i8].states = {
                                    hover: {
                                        enabled: false
                                    }
                                };
                                _seriesVoltage[_i8].marker = {
                                    enabled: null,
                                    symbol: 'circle',
                                    radius: 2,
                                    fillColor: '#FFFFFF',
                                    lineWidth: 1,
                                    lineColor: null // inherit from series
                                };

                                _pushYaxis("vaux", __this.chartData.vaux.min, __this.chartData.vaux.max);
                                delete _seriesVoltage[_i8].downsample;
                                _series.push(_seriesVoltage[_i8]);

                                _series.push({
                                    type: 'flags',
                                    data: [],
                                    id: "flg-vaux",
                                    onSeries: 'vaux',
                                    shape: 'flag',
                                    lineColor: __this.chartData.vaux.color,
                                    fillColor: __this.chartData.vaux.color,
                                    lineWidth: 1,
                                    zIndex: 10,
                                    style: {
                                        color: getContrastTextColor(__this.chartData.vaux.color)
                                    },
                                    states: {
                                        hover: {
                                            enabled: false
                                        }
                                    },
                                    shadow: true,
                                    y: -30,
                                    includeInCSVExport: false
                                });

                                break;
                        }
                    }
                    ////////Begin// Signal Series ////////////////////////////////
                    if (!__this.hasRMDTRadio) {
                        var _serieSignal = _datafromFactory.data.signal;

                        __this.chartData.sign.name = "Signal";
                        __this.chartData.sign.unit = "dBm";
                        __this.chartData.sign.color = getPaletteColor(_datafromFactory.data, 0, "#1565c0");
                        __this.chartData.sign.min = -128;
                        __this.chartData.sign.max = -65;
                        __this.chartData.sign.uiGroup = 2;
                        __this.chartData.sign.translationKey = "SIGNAL";
                        __this.chartData.sign.decimal = sharedSetupService.getNumberOfDecimals(__this.chartData.sign.max, __this.chartData.sign.min);

                        var _tmpSignalSerie = {
                            name: __this.translation.text.SIGNAL + " (dBm)",
                            color: __this.chartData.sign.color,
                            shadow: false,
                            id: 'sign',
                            yAxis: "yx-sign",
                            data: _serieSignal.data,
                            lineWidth: 1,
                            states: {
                                hover: {
                                    enabled: false
                                }
                            },
                            marker: {
                                enabled: null,
                                symbol: 'circle',
                                radius: 2,
                                fillColor: '#FFFFFF',
                                lineWidth: 1,
                                lineColor: null // inherit from series
                            }
                        };
                        _pushYaxis("sign", __this.chartData.sign.min, __this.chartData.sign.max);
                        _series.push(_tmpSignalSerie);

                        _series.push({
                            type: 'flags',
                            data: [],
                            id: "flg-sign",
                            onSeries: 'sign',
                            shape: 'flag',
                            lineColor: __this.chartData.sign.color,
                            fillColor: __this.chartData.sign.color,
                            lineWidth: 1,
                            zIndex: 10,
                            style: {
                                color: getContrastTextColor(__this.chartData.sign.color)
                            },
                            states: {
                                hover: {
                                    enabled: false
                                }
                            },
                            shadow: true,
                            y: -30,
                            includeInCSVExport: false
                        });
                    }

                    ////////End// Signal Series ////////////////////////////////

                    ////////Begin// Signal Quality Series////////////////////////////////
                    var _serieSignalQualityData = _datafromFactory.data.signal.signalQualityData && __this.hasRMDTRadio ? _datafromFactory.data.signal.signalQualityData : [];

                    __this.chartData.signalQuality.name = "SignalQuality";
                    __this.chartData.signalQuality.unit = "dB";
                    __this.chartData.signalQuality.color = getPaletteColor(_datafromFactory.data, 16, "#660000");
                    __this.chartData.signalQuality.min = -30;
                    __this.chartData.signalQuality.max = -1;
                    __this.chartData.signalQuality.uiGroup = 2;
                    __this.chartData.signalQuality.translationKey = "SIGNAL_QUALITY";
                    __this.chartData.signalQuality.decimal = sharedSetupService.getNumberOfDecimals(__this.chartData.signalQuality.max, __this.chartData.signalQuality.min);

                    var _tmpSignalQualitySerie = {
                        name: __this.translation.text.SIGNAL_QUALITY + " (dB)",
                        color: __this.chartData.signalQuality.color,
                        shadow: false,
                        id: 'signalQuality',
                        yAxis: "yx-signalQuality",
                        data: _serieSignalQualityData,
                        lineWidth: 1,
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        marker: {
                            enabled: null,
                            symbol: 'circle',
                            radius: 2,
                            fillColor: '#FFFFFF',
                            lineWidth: 1,
                            lineColor: null // inherit from series
                        }
                    };
                    _pushYaxis("signalQuality", __this.chartData.signalQuality.min, __this.chartData.signalQuality.max);
                    _series.push(_tmpSignalQualitySerie);

                    _series.push({
                        type: 'flags',
                        data: [],
                        id: "flg-signalQuality",
                        onSeries: 'signalQuality',
                        shape: 'flag',
                        lineColor: __this.chartData.signalQuality.color,
                        fillColor: __this.chartData.signalQuality.color,
                        lineWidth: 1,
                        zIndex: 10,
                        style: {
                            color: getContrastTextColor(__this.chartData.signalQuality.color)
                        },
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        shadow: true,
                        y: -30,
                        includeInCSVExport: false
                    });
                    ////////End// Signal Quality Series ////////////////////////////////

                    ////////Begin// Signal Power Series////////////////////////////////
                    var _serieSignalPowerData = _datafromFactory.data.signal.signalPowerData && __this.hasRMDTRadio ? _datafromFactory.data.signal.signalPowerData : [];

                    __this.chartData.signalPower.name = "SignalPower";
                    __this.chartData.signalPower.unit = "dBm";
                    __this.chartData.signalPower.color = getPaletteColor(_datafromFactory.data, 3, "#c45500");
                    __this.chartData.signalPower.min = -128;
                    __this.chartData.signalPower.max = -65;
                    __this.chartData.signalPower.uiGroup = 2;
                    __this.chartData.signalPower.translationKey = "SIGNAL_POWER";
                    __this.chartData.signalPower.decimal = sharedSetupService.getNumberOfDecimals(__this.chartData.signalPower.max, __this.chartData.signalPower.min);

                    var _tmpSignalPowerSerie = {
                        name: __this.translation.text.SIGNAL_POWER + " (dBm)",
                        color: __this.chartData.signalPower.color,
                        shadow: false,
                        id: 'signalPower',
                        yAxis: "yx-signalPower",
                        data: _serieSignalPowerData,
                        lineWidth: 1,
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        marker: {
                            enabled: null,
                            symbol: 'circle',
                            radius: 2,
                            fillColor: '#FFFFFF',
                            lineWidth: 1,
                            lineColor: null // inherit from series
                        }
                    };
                    _pushYaxis("signalPower", __this.chartData.signalPower.min, __this.chartData.signalPower.max);
                    _series.push(_tmpSignalPowerSerie);

                    _series.push({
                        type: 'flags',
                        data: [],
                        id: "flg-signalPower",
                        onSeries: 'signalPower',
                        shape: 'flag',
                        lineColor: __this.chartData.signalPower.color,
                        fillColor: __this.chartData.signalPower.color,
                        lineWidth: 1,
                        zIndex: 10,
                        style: {
                            color: getContrastTextColor(__this.chartData.signalPower.color)
                        },
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        shadow: true,
                        y: -30,
                        includeInCSVExport: false
                    });
                    ////////End// Signal Power Series ////////////////////////////////


                    var _serieConnectivity = _datafromFactory.data.connectivity;
                    __this.chartData.conn.name = "Connectivity";
                    __this.chartData.conn.unit = "-";
                    __this.chartData.conn.color = getPaletteColor(_datafromFactory.data, 8, "#3d8a00");
                    __this.chartData.conn.min = 1;
                    __this.chartData.conn.max = 1;
                    __this.chartData.conn.uiGroup = 2;
                    __this.chartData.conn.translationKey = "ONLINE";
                    __this.chartData.conn.y = _serieConnectivity.data.length > 0 && _serieConnectivity.data[_serieConnectivity.data.length - 1].segmentColor === connectColorCode ? __this.translation.text.CONNECTED : __this.translation.text.DISCONNECTED;
                    var _tmpConnectivitySerie = {
                        type: 'line',
                        name: "" + __this.translation.text.ONLINE,
                        color: __this.chartData.conn.color,
                        shadow: false,
                        id: 'conn',
                        yAxis: "yx-conn",
                        data: _serieConnectivity.data,
                        lineWidth: 3,
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        marker: {
                            enabled: null,
                            symbol: 'circle',
                            radius: 2,
                            fillColor: '#FFFFFF',
                            lineWidth: 1,
                            lineColor: null // inherit from series
                        }
                    };
                    _pushYaxis("conn", __this.chartData.conn.min, __this.chartData.conn.max);
                    _series.push(_tmpConnectivitySerie);
                    /////////////////////////////////////////////////////////

                    var _serieTemperature = _datafromFactory.data.temperature;

                    __this.chartData.temp.name = "Temperature";
                    __this.chartData.temp.unit = __this.unit;
                    __this.chartData.temp.color = getPaletteColor(_datafromFactory.data, 4, "#9a05df");
                    __this.chartData.temp.min = 0;
                    __this.chartData.temp.max = 120;
                    __this.chartData.temp.uiGroup = 2;
                    __this.chartData.temp.translationKey = "TEMPERATURE";

                    var _tmpTemperatureSerie = {
                        name: __this.translation.text.TEMPERATURE + " (" + __this.unit + ")",
                        color: __this.chartData.temp.color,
                        shadow: false,
                        id: 'temp',
                        yAxis: "yx-temp",
                        data: _convertData(_serieTemperature.data),
                        lineWidth: 1,
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        marker: {
                            enabled: null,
                            symbol: 'circle',
                            radius: 2,
                            fillColor: '#FFFFFF',
                            lineWidth: 1,
                            lineColor: null // inherit from series
                        }
                    };
                    _pushYaxis("temp", __this.chartData.temp.min, __this.chartData.temp.max);
                    _series.push(_tmpTemperatureSerie);

                    _series.push({
                        type: 'flags',
                        data: [],
                        id: "flg-temp",
                        onSeries: 'temp',
                        shape: 'flag',
                        lineColor: __this.chartData.temp.color,
                        fillColor: __this.chartData.temp.color,
                        lineWidth: 1,
                        zIndex: 10,
                        style: {
                            color: getContrastTextColor(__this.chartData.temp.color)
                        },
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        shadow: true,
                        y: -30,
                        includeInCSVExport: false
                    });

                    $scope.nodigital = false;
                    var _seriesDigital = _datafromFactory.data.digital.series;

                    _pushYaxis("digital");

                    if (_seriesDigital.length > 0) {
                        for (var _i9 = 0; _i9 < 8 && _i9 < _digitalSetting.length; _i9++) {
                            // four pumps max
                            if (_digitalSetting[_i9].digitalMode == 'P' && __this.deviceType !== 20) {
                                __this.chartData["pmp" + _digitalSetting[_i9].channel].name = _digitalSetting[_i9].description;
                                __this.chartData["pmp" + _digitalSetting[_i9].channel].color = _seriesDigital[_i9].color;
                                __this.chartData["pmp" + _digitalSetting[_i9].channel].uiGroup = 3;
                                _seriesDigital[_i9].id = "pmp" + _digitalSetting[_i9].channel;
                                _seriesDigital[_i9].yAxis = "yx-digital";
                                _seriesDigital[_i9].marker = {
                                    symbol: "circle"
                                };
                                _series.push(_seriesDigital[_i9]);
                                __this.hasDigital = true;
                            }
                        }
                    }

                    var _seriesAlarm = _datafromFactory.data.alarm;
                    var _seriesAlarmData = [];

                    for (var _i10 = 0; _i10 < _seriesAlarm.length; _i10++) {
                        _seriesAlarmData.push({
                            x: _seriesAlarm[_i10].arrivalDateTimeUnix,
                            title: _seriesAlarm[_i10].alarmDescription ? _seriesAlarm[_i10].alarmDescription.charAt(0) : "!",
                            text: _getFlagText(_seriesAlarm[_i10]),
                            color: _seriesAlarm[_i10].repStateDescColor,
                            fillColor: _seriesAlarm[_i10].repStateDescColor,
                            reportId: _seriesAlarm[_i10].reportID
                        });
                    }
                    __this.chartData.alarm.name = "Alarms";
                    __this.chartData.alarm.color = "red";
                    __this.chartData.alarm.uiGroup = 5;
                    __this.chartData.alarm.translationKey = "ALARMS";

                    _series.push({
                        type: 'flags',
                        id: "flg-alarm",
                        data: _seriesAlarmData,
                        shape: "circlepin",
                        lineWidth: 1,
                        zIndex: 10,
                        textAlign: 'right',
                        useHTML: !__this.ieEdge,
                        style: {
                            color: "white"
                        },
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        shadow: true,
                        includeInCSVExport: false,
                        allowOverlapX: false
                    });

                    if (_datafromFactory.data.siteAccess !== null) __this.buildSiteAccessData(_datafromFactory.data.siteAccess, null);

                    if (_datafromFactory.data.analog.series.length > 0 || _datafromFactory.data.rainfall.seriesData.length > 0 || _datafromFactory.data.voltage.series > 0) {
                        $scope.devicename = _datafromFactory.data.analog.device.name;
                        sharedSetupService.setStickyProperties(__this.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, windowId: $scope.windowId });
                        _lastRainfallDate = _lastRainfallDate || EndDate;
                        _drawChart(null, zoomAdjustDays);
                    } else {
                        sharedSetupService.setStickyProperties(__this.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, zoomMin: __this.stickyProperties.zoomMin || StartDate, zoomMax: __this.stickyProperties.zoomMax || EndDate, windowId: $scope.windowId });
                        if (angular.isDefined(element)) {
                            element.empty();
                        }
                        $scope.chart = null;
                        __this.loadingInProgress = false;
                        $scope.lastStart = StartDate;
                        $scope.lastEnd = EndDate;
                        var errormsg = __this.translation.message.NO_DATA + ": " + moment(StartDate).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(EndDate).utc().format('MM/DD/YY, h:mm:ss a');
                        $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                    }
                    $scope.deviceChangeInProgress = false;
            }
        }, function (error) {
            $scope.alerts = [];
            if (angular.isDefined(element)) {
                element.empty();
            }
            $scope.chart = null;
            __this.loadingInProgress = false;
            var errormsg = __this.translation.message.GENERAL_SERVER_ERROR;
            $scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            $scope.deviceChangeInProgress = false;
        });
    };

    __this.groupingChange = function () {

        var tmpDates = null;
        var tmpStartDate = null;
        var tmpEndDate = null;

        if (__this.stickyProperties.on !== null && __this.stickyProperties.zoomMin !== null) {
            __this.stickyProperties.on = true;
            tmpStartDate = __this.stickyProperties.dateMin;
            tmpEndDate = __this.stickyProperties.dateMax;
        } else {
            __this.stickyProperties.on = false;
        }

        if (!tmpStartDate) {
            timeLapseService.getLocalDateTime().then(function (resp) {
                var result = resp.data;

                tmpDates = new Date(result.localDateTime);
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                tmpStartDate = tmpDates.startDate;
                tmpEndDate = tmpDates.endDate;
            });
        }

        __this.saveDesktopSettingService.setSupergraphPulseFlowGrouping(__this.selectedPulseFlowGrouping, __this);

        var extremes = chart.xAxis[0].getExtremes();

        _getData($scope.deviceSelected, extremes.dataMin, extremes.dataMax, null, "PulseFlow");
    };

    var _getAnalogData20 = function _getAnalogData20(extremes) {

        var lastUnixTimeFormat = void 0;
        for (var i = 0; i < chart.series.length; i++) {
            var varId = chart.series[i].options.id;
            if (varId && varId == "ch1") {
                var data = chart.series[i].options.data;
                var tmpObj = data[data.length - 1];
                lastUnixTimeFormat = tmpObj[0] - -moment.tz(tmpObj[0], datetimeService.getTimeZoneId(__this.accountInfo.timeZone)).utcOffset() * 60 * 1000;
                break;
            }
        }

        var tmpDates = { startDate: lastUnixTimeFormat, endDate: lastUnixTimeFormat + __this.unixDay };
        _scrollChart("right", extremes, tmpDates, tmpData, null, "Analog");
    };

    var _getDataDebounced = debounceService(_getAnalogData20, 400, false);

    __this.getTooltipValue = function (point) {
        switch (point.series.options.id) {
            case "conn":
                return point.point.segmentColor === connectedColor || point.point.segmentColor === connectColorCode ? __this.translation.text.CONNECTED : __this.translation.text.DISCONNECTED;
            case "pmp1":
            case "pmp2":
            case "pmp3":
            case "pmp4":
            case "pmp5":
            case "pmp6":
            case "pmp7":
            case "pmp8":
                if (!Number.isInteger(point.y)) return __this.translation.text.FAULT;
                var connSeries = chart.get(point.series.options.id);
                return connSeries.data[point.point.index].y != null && (connSeries.data.length === point.point.index + 1 || connSeries.data.length >= point.point.index + 2 && connSeries.data[point.point.index + 1].y != null) ? __this.translation.text.RUNNING : __this.translation.text.STOPPED;
            default:
                return Highcharts.numberFormat(point.y, __this.chartData[point.series.options.id].decimal);
        }
    };

    var _validateExtremes = function _validateExtremes(extremes) {
        if (extremes != null && extremes.dataMin != null && extremes.dataMax != null && extremes.min < extremes.max && extremes.min >= extremes.dataMin && extremes.min <= extremes.dataMax && extremes.max >= extremes.dataMin && extremes.max <= extremes.dataMax) {
            return true;
        } else {
            return false;
        }
    };

    var _drawChart = function _drawChart(resetView, zoomAdjustDays) {
        var _xAxis;

        tmpData = _series;
        //  $scope.myDate = null;
        var chartDrawn = false;
        var numberOfSeries = void 0;
        var numberOfHiddenSeries = 0;
        __this.chartXaxisHourFormat = __this.preferredTimeFormat === __this.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
        __this.chartToolTipHourFormat = __this.preferredTimeFormat === __this.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

        //// Snippet to interpolate crosshair on the value axis
        //(function (H) {
        //    var Axis = H.Axis,
        //        wrap = H.wrap;

        //    wrap(Axis.prototype, 'drawCrosshair', function (proceed, e, point) {
        //        var series = point && point.series,
        //            points = series && series.points,
        //            prev,
        //            next,
        //            i,
        //            interpolate,
        //            xAxisPos = series && series.xAxis.pos;
        //        if (series && !this.isXAxis && this.options.crosshair && this.options.crosshair.interpolate) {
        //            for (i = 0; i < points.length; i++) {
        //                if (points[i].plotX +xAxisPos > e.chartX) {
        //                    prev = points[i -1];
        //                    next = points[i];
        //                    break;
        //                }
        //            }

        //            if (prev && next) {
        //                interpolate = function (prop) {
        //                    var factor = (e.chartX -prev.plotX -xAxisPos) / (next.plotX -prev.plotX);
        //                    return prev[prop]+(next[prop]-prev[prop]) * factor;
        //                };

        //                point = {
        //                    series: series,
        //                    x: interpolate('x'),
        //                    y: interpolate('y'),
        //                    plotX: interpolate('plotX'),
        //                    plotY: interpolate('plotY')
        //                };
        //            }
        //        }

        //        proceed.call(this, e, point);
        //    });

        //}(Highcharts));


        // Drop-in fix for Highcharts issue #8477 on older Highcharts versions. The
        // issue is fixed since Highcharts v6.1.1.
        Highcharts.wrap(Highcharts.Axis.prototype, 'getPlotLinePath', function (proceed) {
            var path = proceed.apply(this, Array.prototype.slice.call(arguments, 1));
            if (path) {
                path.flat = false;
            }
            return path;
        });

        Highcharts.wrap(Highcharts.PlotLineOrBand.prototype, 'render', function (proceed) {
            var chart = this.axis.chart;
            chart.xAxis[0].plotLinesAndBands.forEach(function (element) {
                if (element.options.label == "Green") {
                    element.svgElem.attr({ zIndex: -1 }).add();
                }
            });
            proceed.call(this);

            if (!chart.seriesGroup) {
                chart.seriesGroup = chart.renderer.g('series-group').attr({ zIndex: 3 }).add();
            }

            if (this.svgElem.parentGroup !== chart.seriesGroup) {
                this.svgElem.attr({ zIndex: this.options.zIndex }).add(chart.seriesGroup);
            }
            return this;
        });

        var cloneToolTip = null;

        chart = new Highcharts.StockChart({
            credits: {
                enabled: false
            },
            legend: {
                enabled: false,
                backgroundColor: '#f9f9f9',
                borderColor: '#cccccc',
                borderWidth: 1
            },
            time: {
                getTimezoneOffset: function getTimezoneOffset(timestamp) {
                    return -moment.tz(timestamp, datetimeService.getTimeZoneId(__this.accountInfo.timeZone)).utcOffset();
                }
            },
            chart: {
                renderTo: element[0],
                //ignoreHiddenSeries: false,
                backgroundColor: '#ebebeb',
                plotBackgroundColor: '#f9f9f9',
                plotShadow: false,
                borderColor: '#d3d3d3',
                borderWidth: 1,
                borderRadius: 2,
                panning: true,
                panKey: 'shift',
                pinchType: 'x',
                plotBorderWidth: 1,
                marginTop: 10,
                spacingTop: 10,
                marginRight: 82,
                spacingRight: 82,
                spacingBottom: 10,
                marginLeft: 10,
                spacingLeft: 10,
                animation: false,
                reflow: true,
                events: {
                    redraw: function redraw(event) {
                        if (angular.isDefined(this.options.chart) && this.options.chart.forExport) return false;
                        var tmpDates = void 0;
                        //let i;
                        //const analogData = [];
                        //const digitalData = [];
                        //const rainfallData = [];
                        //const voltageData = [];
                        //const signalData = [];
                        //const temperatureData = [];

                        if (this.xAxis && chartDrawn === true && _scrollingInProgress === false) {
                            //this.xAxis[0].plotBands = _this.plotBandsYAxis;
                            var _extremes = this.xAxis[0].getExtremes();

                            if (!_validateExtremes(_extremes)) return;

                            if (_extremes && _extremes.dataMin >= _extremes.min - _liveDataOffset) {
                                _scrollingInProgress = true;
                                this.showLoading();
                                tmpDates = datetimeService.getNewStartEndDates(_extremes.dataMin, -11);
                                _scrollChart("left", _extremes, tmpDates, tmpData);
                            } else if (_navigatorOrPan && _liveData === false && _extremes && _extremes.max + _liveDataOffset >= _extremes.dataMax) {
                                //_navigatorOrPan: addressing Highcharts error #15: www.highcharts.com/errors/15
                                _navigatorOrPan = false;
                                _scrollingInProgress = true;
                                this.showLoading();
                                tmpDates = datetimeService.getNewStartEndDates(_extremes.dataMax, 11);
                                _scrollChart("right", _extremes, tmpDates, tmpData);
                            }
                        }

                        // $.each(this.xAxis[0].plotLinesAndBands, function(i, L) {
                        //     var band = L.svgElem;
                        //     if (typeof band.d === 'undefined') {
                        //         return;
                        //     }
                        // if(this.options.label == "White")
                        // {
                        // var path = band.d.split(' ');
                        // var pathR = path;
                        // pathR[2] = 530;
                        // pathR[9] = 530;
                        // pathR[13] = 535;
                        // pathR[20] = 535;
                        // band.attr('d', pathR);  
                        // band.attr('fill', 'Red');

                        // path[16] = 250;
                        // path[18] = 250;
                        // path[24] = 250;
                        // path[27] = 250;
                        // path[29] = 250;
                        // path[31] = 250;
                        // band.attr('d', path);
                        // band.attr('fill', 'Blue');
                        // }
                        // });
                    },
                    load: function load(event) {
                        if (angular.isDefined(this.options.chart) && !this.options.chart.forExport) {
                            // Highcharts' core renderer doesn't add image semantics to the SVG root
                            // on its own (the accessibility module isn't loaded here), so set them
                            // directly on the generated <svg> once the chart has rendered.
                            $(this.container).find('svg').attr({
                                role: 'img',
                                'aria-label': 'Supergraph provides a view of the RTU data series in one location'
                            });
                            if (!$rootScope.mobile && !$rootScope.classicView) {
                                _adjustSize();
                            } else {
                                this.reflow();
                            }
                            $timeout(function () {
                                __this.addSiteAccess();
                                __this.saveDesktopSettingService.applySavedDesktopSettingSupergraph(chart, __this, true);
                            }, 0);
                            initialLoad = false;
                            __this.adjustSerieScale(null, this, false);
                            return true;
                        } else {
                            return false;
                        }
                    },
                    render: function render(event) {
                        if (!chartDrawn) return true;
                        if (angular.isDefined(this.options.chart) && this.options.chart.forExport) return false;
                        if (!angular.isUndefined(_tmpTimer)) $timeout.cancel(_tmpTimer);
                        _tmpTimer = $timeout(function () {
                            __this.getZoomRange();
                        }, 1000);
                        return true;
                    }
                }
            },
            title: {
                style: {
                    color: '#52667d',
                    fontWeight: 'bold'
                }
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: false
            },
            xAxis: (_xAxis = {
                crosshair: {
                    width: 1.5,
                    snap: true // false when interpolate
                },
                minRange: 3600 / 4 * 1000, //15 minutes
                title: {
                    text: null,
                    style: {
                        color: '#52667d',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }
                },
                plotLines: [{ //plot lines
                    value: 0,
                    width: 3,
                    color: 'green',
                    dashStyle: "solid",
                    label: "Green",
                    zIndex: 1
                }],
                plotBands: __this.plotBandsYAxis
            }, _defineProperty(_xAxis, "minRange", 3600 / 4 * 1000), _defineProperty(_xAxis, "minTickInterval", 3600 * 1000), _defineProperty(_xAxis, "endOnTick", true), _defineProperty(_xAxis, "showLastLabel", true), _defineProperty(_xAxis, "startOnTick", true), _defineProperty(_xAxis, "ordinal", false), _defineProperty(_xAxis, "gridLineWidth", .75), _defineProperty(_xAxis, "gridLineColor", '#ececec'), _defineProperty(_xAxis, "dateTimeLabelFormats", {
                hour: __this.chartXaxisHourFormat
            }), _defineProperty(_xAxis, "labels", {
                style: {
                    color: '#52667d',
                    fontWeight: 'bold'
                }
            }), _defineProperty(_xAxis, "events", {
                afterSetExtremes: function afterSetExtremes(e) {
                    if (chartDrawn === true) {
                        var _extremes2 = chart.xAxis[0].getExtremes();
                        _navigatorOrPan = e.trigger == "navigator" || e.trigger == "pan";
                        _isZoomOut = e.trigger == "navigator" || e.trigger == "pan" ? false : true;
                        if (_liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) {
                            //typeof e.trigger == "undefined" doesn't know about mouse scroll
                            if (_extremes2.max + _liveDataOffset <= _extremes2.dataMax) {
                                sharedSetupService.setStickyProperties(__this.stickyProperties, { liveData: false, windowId: $scope.windowId });
                                _unRegisterListener($scope.deviceSelectedSn);
                            }
                        }
                        sharedSetupService.setStickyProperties(__this.stickyProperties, { zoomMin: _extremes2.min, zoomMax: _extremes2.max, windowId: $scope.windowId });
                        _downsampleSeries(_extremes2.min, _extremes2.max);
                    }
                    if (chart) _restartBroadcast(); //_updateFlags();
                }
            }), _xAxis),
            yAxis: _yAxes,
            tooltip: {
                borderWidth: 1,
                shadow: true,
                xDateFormat: "%A, %b %e, %Y " + __this.chartXaxisHourFormat,
                useHTML: true,
                formatter: function formatter() {
                    // The first returned item is the header, subsequent items are the
                    // points
                    if (!!this.points) {
                        return [Highcharts.dateFormat('%A, %b %e, %Y ' + __this.chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, __this.accountInfo.timeZone))].concat(this.points.map(function (point) {
                            if (!angular.isUndefined(point.y)) {
                                if (!angular.isUndefined(point.colorIndex)) {
                                    //Flags (Last data point)
                                    return point.point.name + ': ' + "<b>" + point.point.text + "</b>";
                                } else {
                                    return point.series.name + ': ' + "<b>" + __this.getTooltipValue(point) + "</b>";
                                }
                            }
                        }));
                    } else if (angular.isUndefined(this.point.options.name)) {
                        //Flags (Alarms)
                        return [Highcharts.dateFormat('%A, %b %e, %Y ' + __this.chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, __this.accountInfo.timeZone))].concat(this.point.options.text);
                    } else {
                        return "";
                    }
                },
                split: true
            },
            navigator: {
                enabled: true,
                adaptToUpdatedData: true,
                series: {
                    lineWidth: 0,
                    color: 'transparent',
                    includeInCSVExport: false
                },
                maskFill: 'rgba(255, 255, 255, 0.35)',
                maskInside: true,
                handles: {
                    backgroundColor: '#a4a7a9',
                    borderColor: '#384450'
                },
                height: 22,
                margin: 0,
                xAxis: {
                    tickWidth: 2,
                    lineWidth: 1,
                    gridLineWidth: 0,
                    tickLength: 15,
                    tickPosition: 'inside',
                    tickColor: '#98b3d1',
                    dateTimeLabelFormats: {
                        hour: __this.chartXaxisHourFormat
                    },
                    labels: {
                        align: 'left',
                        style: {
                            color: '#52667d',
                            fontWeight: 'bold'
                        },
                        x: 8,
                        y: -8
                    }
                }
            },
            scrollbar: {
                enabled: true,
                height: 0,
                barBackgroundColor: '#959595',
                barBorderRadius: 2,
                barBorderWidth: 0,
                buttonBackgroundColor: '#959595',
                buttonBorderWidth: 0,
                buttonBorderRadius: 2,
                trackBackgroundColor: 'none',
                trackBorderWidth: 1,
                trackBorderRadius: 3,
                trackBorderColor: '#CCC',
                liveRedraw: true
            },
            rangeSelector: {
                enabled: false
            },
            // scrollbar: {
            //     barBackgroundColor: 'gray',
            //     barBorderRadius: 7,
            //     barBorderWidth: 0,
            //     buttonBackgroundColor: 'gray',
            //     buttonBorderWidth: 0,
            //     buttonArrowColor: 'yellow',
            //     buttonBorderRadius: 7,
            //     rifleColor: 'yellow',
            //     trackBackgroundColor: 'white',
            //     trackBorderWidth: 1,
            //     trackBorderColor: 'silver',
            //     trackBorderRadius: 7
            // },
            // rangeSelector: {
            //     selected: 1
            // },
            plotOptions: {
                series: {
                    stickyTracking: false,
                    //cursor: 'pointer',
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                xValue = this.x;
                            }
                        }
                    },
                    //marker: {
                    //    fillColor: '#FFFFFF',
                    //    lineWidth: 2,
                    //    lineColor: null // inherit from series
                    //},
                    events: {
                        legendItemClick: function legendItemClick() {
                            numberOfSeries = this.chart.series.length - 1;
                            var visibility = this.visible ? 'visible' : 'hidden';
                            numberOfHiddenSeries = visibility == 'hidden' ? $scope.chartSeriesVisibility.filter(function (v) {
                                return !v;
                            }).length - 1 : $scope.chartSeriesVisibility.filter(function (v) {
                                return !v;
                            }).length + 1;
                            numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                            if (numberOfHiddenSeries < numberOfSeries) {
                                this.chart.yAxis[this.index].update({
                                    labels: {
                                        enabled: visibility == 'visible' ? false : true
                                    },
                                    title: {
                                        text: visibility == 'visible' ? null : _series[this.index].name
                                    },
                                    lineWidth: visibility == 'visible' ? 0 : 2
                                });
                                sharedSetupService.getChartSeriesVisibility(this.chart, $scope.chartSeriesVisibility);
                                return true;
                            }
                            return false;
                        },

                        mouseOver: function mouseOver() {
                            if (xValue == null) return;
                            this.update({
                                marker: {
                                    enabled: true
                                }
                            });
                        }, mouseOut: function mouseOut() {
                            xValue = null;
                            this.update({
                                marker: {
                                    enabled: null
                                }
                            });
                        }
                    }
                },
                flags: {
                    crop: false,
                    overflow: "none",
                    allowOverlapX: true,
                    clip: false
                }
            },
            series: _series

        });

        $scope.chart = chart;
        var tmpNewDateA = void 0;
        var tmpNewDateB = void 0;
        var extremes = chart.xAxis[0].getExtremes();
        endPlotBand = extremes.max;

        if (__this.stickyProperties.on === true) {
            tmpNewDateA = __this.stickyProperties.zoomMin >= extremes.dataMin ? __this.stickyProperties.zoomMin : extremes.dataMin; //extremes.dataMin + __this.unixDay / 24 * 3;
            tmpNewDateB = __this.stickyProperties.zoomMax <= extremes.dataMax + _liveDataOffset ? __this.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - __this.unixDay / 24 * 3;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + __this.unixDay / 24 ? tmpNewDateB : extremes.dataMax - __this.unixDay / 24 * 12;
            __this.stickyProperties.on = false;
        } else {
            tmpNewDateA = $scope.myDate !== null ? extremes.dataMin + __this.unixDay : extremes.dataMax - __this.unixDay / 24 * 6;
            tmpNewDateB = $scope.myDate !== null ? tmpNewDateA + __this.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - __this.unixDay;
            }
            tmpNewDateA = tmpNewDateA + __this.minPadding;
            tmpNewDateB = tmpNewDateB + __this.maxPadding;
        }

        if (!angular.isUndefined(zoomAdjustDays)) {
            $scope.zoomAdjust(zoomAdjustDays);
        } else {
            chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
        }

        if (_series !== null) {
            //only for analog chart if no setup
            sharedSetupService.setStickyProperties(__this.stickyProperties, { deviceId: $scope.deviceSelected, zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: $scope.windowId });
        } else {
            chart.showLoading(__this.translation.text.ANALOG_SETUP_UNAVAILABLE);
        }

        if (!resetView) {
            _setLiveDataStatusDebounced();
        }
        __this.loadingInProgress = false;
        $timeout(function () {
            chartDrawn = true;
            if ($rootScope.mobile || $rootScope.classicView) {
                __this.adjustSupergraphForMobile();
            }
        }, 0);

        $element.on("mouseover.supergraph", ".dragAnalog", function (event) {
            var localScope = $(event.target).scope();
            if ($(event.currentTarget).is(".dragAnalog") && !$scope.mobile && !$scope.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    stop: function stop(event, ui) {
                        var mcDevice = { deviceId: $scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: $scope.deviceSelectedSn };

                        var optionsStickyProperties = {
                            device: mcDevice
                        };

                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        openViewService.openWidget('Mc Single Needle Gauge Analog Output Widget', { width: 240, height: 240 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                        $scope.$apply();
                    }
                });
            }
        });

        $element.on("mouseover.supergraph", ".hcolPulseFlow", function (event) {
            var localScope = $(event.target).scope();
            if ($(event.currentTarget).is(".hcolPulseFlow") && !$scope.mobile && !$scope.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    stop: function stop(event, ui) {
                        var mcDevice = { deviceId: $scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: $scope.deviceSelectedSn, deviceName: $scope.devicename, group: parseInt(ui.helper.attr('mc-group'), 10) };

                        var optionsStickyProperties = {
                            device: mcDevice
                        };

                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        openViewService.openWidget('Pulse Flow Widget', { width: 250, height: 100 }, position, optionsStickyProperties, { minimumWidth: 180, minimumHeight: 100 });
                        $scope.$apply();
                    }
                });
            }
        });
        // When the supergraph loads initally the bell icon which is not filled should display data
        Object.keys(__this.chartData).forEach(function (key) {
            __this.toggleAlarmThresholds(key);
        });
    };

    var _scrollChart = function _scrollChart(varDirection, extremes, objDate, chartSeries, id, element) {
        var i = void 0;
        var analogData = [];
        var analogOutputData = [];
        var digitalData = [];
        var rainfallData = [];
        var voltageData = [];
        var signalData = [];
        var signalQualityData = [];
        var signalPowerData = [];
        var connectivityData = [];
        var temperatureData = [];
        var alarmData = [];
        var pulseFlow = [];
        endPlotBand = objDate.endDate;

        var _supergraph = new SupergraphFactory(__this.accountInfo.customerId, $scope.deviceSelected, $scope.deviceSelectedType, Math.floor(objDate.startDate), Math.floor(objDate.endDate), id, element, __this.accountInfo.timeZone, __this.stickyProperties, parseInt(__this.selectedPulseFlowGrouping));
        _supergraph.getData().then(function () {
            __this.dataIsInFormat = 1;
            var _datafromFactory = { data: _supergraph.list };
            //endPlotBand = new Date(objDate.endDate);
            //SupergraphFactory.getData('customerID=' + __this.accountInfo.customerId + '&deviceId=' + $scope.deviceSelected + '&StartDate=' + Math.floor(objDate.startDate) + '&EndDate=' + Math.floor(objDate.endDate) + '&timeZone=' + __this.accountInfo.timeZone).then(function (_datafromFactory) {

            for (var z = 0; z < chart.series.length; z++) {

                switch (chart.series[z].options.id) {

                    case "vbatt":
                        if (_datafromFactory.data.voltage && _datafromFactory.data.voltage.series && _datafromFactory.data.voltage.series.length > 0) {
                            for (i = 0; i < _datafromFactory.data.voltage.series.length; i++) {
                                if (i == 0) {
                                    voltageData.push(_datafromFactory.data.voltage.series[i].data);
                                    if (varDirection == "right") {
                                        chartSeries[z].data = chartSeries[z].data.concat(voltageData[i]);
                                    } else if (varDirection == "left") {
                                        chartSeries[z].data = voltageData[i].concat(chartSeries[z].data);
                                    }
                                    chart.series[z].setData(chartSeries[z].data, false);
                                }
                            }
                        }
                        break;
                    case "vac":
                        if (_datafromFactory.data.voltage && _datafromFactory.data.voltage.series && _datafromFactory.data.voltage.series.length > 0) {
                            for (i = 0; i < _datafromFactory.data.voltage.series.length; i++) {
                                if (i == 1) {
                                    voltageData.push(_datafromFactory.data.voltage.series[i].data);
                                    if (varDirection == "right") {
                                        chartSeries[z].data = chartSeries[z].data.concat(voltageData[i]);
                                    } else if (varDirection == "left") {
                                        chartSeries[z].data = voltageData[i].concat(chartSeries[z].data);
                                    }
                                    chart.series[z].setData(chartSeries[z].data, false);
                                }
                            }
                        }
                        break;
                    case "vaux":
                        if (_datafromFactory.data.voltage && _datafromFactory.data.voltage.series && _datafromFactory.data.voltage.series.length > 0) {
                            for (i = 0; i < _datafromFactory.data.voltage.series.length; i++) {
                                if (i == 2) {
                                    voltageData.push(_datafromFactory.data.voltage.series[i].data);
                                    if (varDirection == "right") {
                                        chartSeries[z].data = chartSeries[z].data.concat(voltageData[i]);
                                    } else if (varDirection == "left") {
                                        chartSeries[z].data = voltageData[i].concat(chartSeries[z].data);
                                    }
                                    chart.series[z].setData(chartSeries[z].data, false);
                                }
                            }
                        }
                        break;
                    case "sign":
                        if (!__this.hasRMDTRadio && _datafromFactory.data.signal && _datafromFactory.data.signal.data && _datafromFactory.data.signal.data.length > 0) {
                            signalData = _datafromFactory.data.signal.data;
                            if (varDirection == "right") {
                                chartSeries[z].data = chartSeries[z].data.concat(signalData);
                            } else if (varDirection == "left") {
                                chartSeries[z].data = signalData.concat(chartSeries[z].data);
                            }
                            chart.series[z].setData(chartSeries[z].data, false);
                        }
                        break;
                    case "signalQuality":
                        if (__this.hasRMDTRadio && _datafromFactory.data.signal !== null && _datafromFactory.data.signal.signalQualityData !== null) {
                            if (_datafromFactory.data.signal.signalQualityData && _datafromFactory.data.signal.signalQualityData.length > 0) {
                                signalQualityData = _datafromFactory.data.signal.signalQualityData;
                                if (varDirection == "right") {
                                    chartSeries[z].data = chartSeries[z].data.concat(signalQualityData);
                                } else if (varDirection == "left") {
                                    chartSeries[z].data = signalQualityData.concat(chartSeries[z].data);
                                }
                                chart.series[z].setData(chartSeries[z].data, false);
                            }
                        }
                        break;
                    case "signalPower":
                        if (__this.hasRMDTRadio && _datafromFactory.data.signal !== null) {
                            if (_datafromFactory.data.signal.signalPowerData && _datafromFactory.data.signal.signalPowerData.length > 0) {
                                signalPowerData = _datafromFactory.data.signal.signalPowerData;
                                if (varDirection == "right") {
                                    chartSeries[z].data = chartSeries[z].data.concat(signalPowerData);
                                } else if (varDirection == "left") {
                                    chartSeries[z].data = signalPowerData.concat(chartSeries[z].data);
                                }
                                chart.series[z].setData(chartSeries[z].data, false);
                            }
                        }
                        break;
                    case "conn":
                        if (_datafromFactory.data.connectivity && _datafromFactory.data.connectivity.data && _datafromFactory.data.connectivity.data.length > 0) {
                            connectivityData = _datafromFactory.data.connectivity.data;
                            if (varDirection == "right") {

                                if (connectivityData[0].tmp) connectivityData.shift();
                                var lastDataPoint = chartSeries[z].data[chartSeries[z].data.length - 1];
                                if (lastDataPoint.tmp && chart.series[z].data.length > 0) {
                                    chart.series[z].data[chartSeries[z].data.length - 1].remove();
                                }

                                chartSeries[z].data = chartSeries[z].data.concat(connectivityData);
                            } else if (varDirection == "left") {

                                if (connectivityData[connectivityData.length - 1].tmp) connectivityData.pop();
                                var firstDataPoint = chartSeries[z].data[0];
                                if (firstDataPoint.tmp && chart.series[z].data.length > 0) {
                                    chart.series[z].data[0].remove();
                                }

                                chartSeries[z].data = connectivityData.concat(chartSeries[z].data);
                            }
                            chart.series[z].setData(chartSeries[z].data, false);
                            _buildConnectivityBands(chartSeries[z].data, true);
                        }
                        break;
                    case "temp":
                        if (_datafromFactory.data.temperature && _datafromFactory.data.temperature.data && _datafromFactory.data.temperature.data.length > 0) {
                            temperatureData = _convertData(_datafromFactory.data.temperature.data);
                            if (varDirection == "right") {
                                chartSeries[z].data = chartSeries[z].data.concat(temperatureData);
                            } else if (varDirection == "left") {
                                chartSeries[z].data = temperatureData.concat(chartSeries[z].data);
                            }
                            chart.series[z].setData(chartSeries[z].data, false);
                        }
                        break;
                    case "rainR":
                        if (_datafromFactory.data.rainfall && _datafromFactory.data.rainfall.seriesData && _datafromFactory.data.rainfall.seriesData[0].length > 0) {
                            for (i = 0; i < _datafromFactory.data.rainfall.seriesData.length; i++) {
                                if (i == 0) {
                                    rainfallData.push(_datafromFactory.data.rainfall.seriesData[i]);
                                    if (varDirection == "right" || varDirection == "livePool") {
                                        chartSeries[z].data = chartSeries[z].data.concat(rainfallData[i]);
                                    } else if (varDirection == "left") {
                                        chartSeries[z].data = rainfallData[i].concat(chartSeries[z].data);
                                    }
                                    chart.series[z].setData(chartSeries[z].data, false);
                                }
                            }
                            _lastRainfallDate = rainfallData[0][rainfallData[0].length - 1][0] > _lastRainfallDate ? rainfallData[0][rainfallData[0].length - 1][0] : _lastRainfallDate;
                        }
                        break;
                    case "rainT":
                        if (_datafromFactory.data.rainfall && _datafromFactory.data.rainfall.seriesData && _datafromFactory.data.rainfall.seriesData.length > 1 && _datafromFactory.data.rainfall.seriesData[1].length > 0) {
                            var rainfallT = _convertData(_datafromFactory.data.rainfall.seriesData[1]);
                            for (i = 0; i < rainfallT.length; i++) {
                                if (i == 1) {
                                    rainfallData.push(rainfallT[i]);
                                    if (varDirection == "right" || varDirection == "livePool") {
                                        chartSeries[z].data = chartSeries[z].data.concat(angular.isUndefined(rainfallData[i]) ? rainfallData[0] : rainfallData[i]);
                                    } else if (varDirection == "left") {
                                        chartSeries[z].data = angular.isUndefined(rainfallData[i]) ? rainfallData[0].concat(chartSeries[z].data) : rainfallData[i].concat(chartSeries[z].data);
                                    }
                                    chart.series[z].setData(chartSeries[z].data, false);
                                }
                            }
                        }
                        break;

                    case "ch1":
                    case "ch2":
                    case "ch3":
                    case "ch4":
                    case "ch5":
                    case "ch6":
                    case "ch7":
                    case "ch8":
                    case "ch9":
                        if (_datafromFactory.data.analog && _datafromFactory.data.analog.series && _datafromFactory.data.analog.series.length > 0) {
                            for (i = 0; i < _datafromFactory.data.analog.series.length; i++) {
                                if ("ch" + _datafromFactory.data.analog.series[i].id == chart.series[z].options.id) {
                                    analogData.push(_datafromFactory.data.analog.series[i].data);
                                    if (varDirection == "right") {
                                        chartSeries[z].data = chartSeries[z].data.concat(analogData[i]);
                                    } else if (varDirection == "left") {
                                        chartSeries[z].data = analogData[i].concat(chartSeries[z].data);
                                    }
                                    chart.series[z].setData(chartSeries[z].data, false);
                                }
                            }
                        }
                        break;
                    case "out1":
                    case "out2":
                    case "out3":
                    case "out4":
                        if (_datafromFactory.data.analogOutput && _datafromFactory.data.analogOutput.series && _datafromFactory.data.analogOutput.series.length > 0) {
                            for (i = 0; i < _datafromFactory.data.analogOutput.series.length; i++) {
                                if ("out" + _datafromFactory.data.analogOutput.series[i].id == chart.series[z].options.id) {
                                    analogOutputData.push(_datafromFactory.data.analogOutput.series[i].data);
                                    if (varDirection == "right") {
                                        chartSeries[z].data = chartSeries[z].data.concat(analogOutputData[i]);
                                    } else if (varDirection == "left") {
                                        chartSeries[z].data = analogOutputData[i].concat(chartSeries[z].data);
                                    }
                                    chart.series[z].setData(chartSeries[z].data, false);
                                }
                            }
                        }
                        break;
                    case "pmp1":
                    case "pmp2":
                    case "pmp3":
                    case "pmp4":
                    case "pmp5":
                    case "pmp6":
                    case "pmp7":
                    case "pmp8":
                        if (_datafromFactory.data.digital && _datafromFactory.data.digital.series && _datafromFactory.data.digital.series.length > 0) {
                            for (i = 0; i < _datafromFactory.data.digital.series.length; i++) {
                                if ("pmp" + _datafromFactory.data.digital.series[i].id == chart.series[z].options.id) {
                                    if (varDirection == "right") {
                                        if (_datafromFactory.data.digital.series[i].data.length > 3) _datafromFactory.data.digital.series[i].data.shift();
                                        _removeNull("pmp" + _datafromFactory.data.digital.series[i].id);
                                        digitalData.push(_datafromFactory.data.digital.series[i].data);
                                        chartSeries[z].data = chartSeries[z].data.concat(digitalData[i]);
                                    } else if (varDirection == "left") {
                                        if (_datafromFactory.data.digital.series[i].data.length > 3) _datafromFactory.data.digital.series[i].data.pop();
                                        _removeNull("pmp" + _datafromFactory.data.digital.series[i].id, true);
                                        digitalData.push(_datafromFactory.data.digital.series[i].data);
                                        chartSeries[z].data = digitalData[i].concat(chartSeries[z].data);
                                    }
                                    chart.series[z].setData(chartSeries[z].data, false);
                                    _preparedForTimeLaps = false;
                                }
                            }
                        }
                        break;
                    case "pulseFlow1":
                    case "pulseFlow2":
                    case "pulseFlow3":
                    case "pulseFlow4":
                    case "pulseFlow5":
                    case "pulseFlow6":
                        if (_datafromFactory.data.pulseFlow && _datafromFactory.data.pulseFlow.series && _datafromFactory.data.pulseFlow.series.length > 0) {
                            for (i = 0; i < _datafromFactory.data.pulseFlow.series.length; i++) {
                                if ("pulseFlow" + _datafromFactory.data.pulseFlow.series[i].id == chart.series[z].options.id) {
                                    pulseFlow.push(_datafromFactory.data.pulseFlow.series[i].data);
                                    if (varDirection == "right") {
                                        chartSeries[z].data = chartSeries[z].data.concat(pulseFlow[i]);
                                    } else if (varDirection == "left") {
                                        chartSeries[z].data = pulseFlow[i].concat(chartSeries[z].data);
                                    }
                                    chart.series[z].setData(chartSeries[z].data, false);
                                }
                            }
                        } //_datafromFactory.data.pulseFlow.series
                        break;
                    case "flg-alarm":
                        //////////if (_datafromFactory.data.alarm && _datafromFactory.data.alarm.length > 0) {
                        //////////    for (let i = 0; i < _datafromFactory.data.alarm.length ; i++) {
                        //////////        alarmData.push(
                        //////////            {
                        //////////                x:  _datafromFactory.data.alarm[i].arrivalDateTimeUnix,
                        //////////                title:  _datafromFactory.data.alarm[i].alarmDescription ? ( _datafromFactory.data.alarm[i].alarmDescription).charAt(0) : "!",
                        //////////                text: _getFlagText( _datafromFactory.data.alarm[i]),
                        //////////                color:  _datafromFactory.data.alarm[i].repStateDescColor,
                        //////////                fillColor:  _datafromFactory.data.alarm[i].repStateDescColor,
                        //////////                reportId:  _datafromFactory.data.alarm[i].reportID
                        //////////            }
                        //////////        );
                        //////////    }
                        //////////    if (varDirection == "right") {
                        //////////        chartSeries[z].data = chartSeries[z].data.concat(alarmData);
                        //////////    }
                        //////////    else if (varDirection == "livePool") {
                        //////////        for (let i = 0; i < alarmData.length ; i++) {
                        //////////            let _flagUpdated = false;

                        //////////            for (let j = 0; j < chartSeries[z].data.length ; j++) {
                        //////////                if (chartSeries[z].data[j].reportId == alarmData[i].reportId) {
                        //////////                    chartSeries[z].data[j] = {
                        //////////                        x: alarmData[i].x,
                        //////////                        title: alarmData[i].title,
                        //////////                        text: alarmData[i].text,
                        //////////                        color: alarmData[i].color,
                        //////////                        fillColor: alarmData[i].fillColor,
                        //////////                        reportId: alarmData[i].reportId
                        //////////                    }

                        //////////                    break;
                        //////////                }
                        //////////            }
                        //////////        }
                        //////////    }
                        //////////    else if (varDirection == "left") {
                        //////////        chartSeries[z].data = alarmData.concat(chartSeries[z].data);
                        //////////    }
                        //////////    chart.series[z].setData(chartSeries[z].data, true);
                        //////////}
                        if (_datafromFactory.data.alarm && _datafromFactory.data.alarm.length > 0) {
                            alarmData = _datafromFactory.data.alarm;
                            for (var _i11 = 0; _i11 < alarmData.length; _i11++) {
                                var _flagUpdated = false;
                                if (varDirection === "livePool") {
                                    for (var j = 0; j < chart.series[z].data.length; j++) {
                                        if (chart.series[z].data[j].reportId == alarmData[_i11].reportID) {
                                            chart.series[z].data[j].remove();
                                            _flagUpdated = false; //true;
                                            break;
                                        }
                                    }
                                }
                                if (!_flagUpdated) {
                                    chart.series[z].addPoint({
                                        x: alarmData[_i11].arrivalDateTimeUnix,
                                        title: alarmData[_i11].alarmDescription ? alarmData[_i11].alarmDescription.charAt(0) : "!",
                                        text: _getFlagText(alarmData[_i11]),
                                        color: alarmData[_i11].repStateDescColor,
                                        fillColor: alarmData[_i11].repStateDescColor,
                                        reportId: alarmData[_i11].reportID
                                    });
                                }
                            }
                        }
                        break;
                }
            }

            if (_datafromFactory.data.siteAccess !== null) {
                __this.buildSiteAccessData(_datafromFactory.data.siteAccess, varDirection);
                __this.addSiteAccess();
            }

            if (_datafromFactory.data.analog) $scope.devicename = _datafromFactory.data.analog.device.name;

            if (varDirection == "right") {
                sharedSetupService.setStickyProperties(__this.stickyProperties, { deviceId: $scope.deviceSelected, dataMax: objDate.endDate, windowId: $scope.windowId });
            } else if (varDirection == "left") {
                sharedSetupService.setStickyProperties(__this.stickyProperties, { deviceId: $scope.deviceSelected, dataMin: objDate.startDate, windowId: $scope.windowId });
            }

            if (varDirection != "livePool") {
                chart.xAxis[0].setExtremes(extremes.min + __this.minPadding, extremes.max + __this.maxPadding);
                chart.redraw();
                _setLiveDataStatusDebounced(objDate.endDate);

                $timeout(function () {
                    _restartBroadcast();
                }, 500);

                $timeout(function () {
                    _scrollingInProgress = false;
                }, 1000);

                chart.hideLoading();
            }
        }, function (error) {
            $scope.alerts = [];
            if (angular.isDefined(element)) {
                element.empty();
            }
            $scope.chart = null;
            __this.loadingInProgress = false;
            var errormsg = __this.translation.message.GENERAL_SERVER_ERROR;
            $scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
        });
    };

    var _setLiveDataStatus = function _setLiveDataStatus(varEndDate) {
        _liveDataEndDate = varEndDate != null ? varEndDate : _liveDataEndDate;
        timeLapseService.getLocalDateTime().then(function (result) {
            __this.heartbeatLocalDateTime = result.data.unixTimeStamp;
            var extremes = chart.xAxis[0].getExtremes();
            if (_liveDataEndDate > result.data.unixTimeStamp && __this.stickyProperties.zoomMax + _liveDataOffset >= extremes.dataMax) {
                _registerListener($scope.deviceSelectedSn);
                var data = { Unix: result.data.unixTimeStamp, Value: null, SN: null, CH: null };
                tlDataReceivedTIMELAPS(data);
            } else {
                sharedSetupService.setStickyProperties(__this.stickyProperties, { liveData: false, windowId: $scope.windowId });
                _unRegisterListener($scope.deviceSelectedSn);
            }
        });
    };

    var _setLiveDataStatusDebounced = debounceService(_setLiveDataStatus, 100, false);

    var _downsampleSeries = function _downsampleSeries(varMin, varMax) {
        zoomLevelCurrent = varMax - varMin;
        var dssDone = false;

        for (var i = 0; i < chart.series.length - 1; i++) {
            switch (chart.series[i].options.id) {
                case "ch1":
                case "ch2":
                case "ch3":
                case "ch4":
                case "ch5":
                case "ch6":
                case "ch7":
                case "ch8":
                case "ch9":
                    if (zoomLevelCurrent <= __this.unixDay && zoomLevelPrevious > __this.unixDay) {
                        chart.series[i].update({ downsample: { threshold: 0 } }, false);
                        chart.series[i].setData(_series[i].data, false);
                        dssDone = true;
                    } else if (zoomLevelCurrent > __this.unixDay && zoomLevelPrevious <= __this.unixDay) {
                        chart.series[i].update({ downsample: { threshold: 500 } }, false);
                        dssDone = true;
                    }
                    break;
            }
        }

        if (dssDone) chart.redraw();
        zoomLevelPrevious = zoomLevelCurrent;
    };

    var _removeNull = function _removeNull(serieId, front) {

        var pointindex = 0;
        if (front) {
            for (var j = 0; j < chart.series.length; j++) {
                var varId = chart.series[j].options.id;
                if (varId == serieId) {
                    if (chart.series[j].options.data.length > 3) {
                        if (chart.series[j].options.data[pointindex][2] === 0) {
                            if (chart.series[j].options.data[pointindex]) chart.series[j].data[pointindex].remove();
                        }
                        return;
                    }
                }
            }
        }

        for (var _j = 0; _j < chart.series.length; _j++) {
            var _varId = chart.series[_j].options.id;
            if (_varId == serieId) {
                if (chart.series[_j].options.data.length > 3) {
                    var curLength = chart.series[_j].options.data.length > 50 ? 50 : chart.series[_j].options.data.length;
                    for (var i = 1; i < curLength; i++) {
                        pointindex = chart.series[_j].options.data.length - 1;
                        if (chart.series[_j].options.data[pointindex][2] === 0) {
                            if (chart.series[_j].data[pointindex]) {
                                chart.series[_j].data[pointindex].remove();
                            }
                            chart.series[_j].options.data.splice(pointindex, 1);
                        }
                    }
                }
            }
        }
    };

    //==========================socket data================================
    var wsDataReceivedANALOG = function wsDataReceivedANALOG(data) {

        //Catch empty data in old ANALOG message for GENII/SparkPlug device
        if (data.Type == "ANALOG" && $scope.deviceSelectedType == 21) {
            console.log(data);
            return;
        }

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        if ($scope.deviceSelectedType == 20) {
            _getDataDebounced(extremes);
            return;
        }

        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        var varValue = parseFloat(data.Value);
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, __this.accountInfo.timeZone);

        for (var j = 0; j < chart.series.length; j++) {
            var varId = chart.series[j].options.id;
            if (varId) {
                switch (varId) {
                    case "ch1":
                    case "ch2":
                    case "ch3":
                    case "ch4":
                    case "ch5":
                    case "ch6":
                    case "ch7":
                    case "ch8":
                    case "ch9":
                        if (varId.charAt(2) == data.CH) {
                            var tmpObjColor;

                            (function () {

                                var series = chart.series[j];
                                for (var _j2 = 1; _j2 <= 3; _j2++) {
                                    if (series && series.data && series.data[series.data.length - _j2] && series.data[series.data.length - _j2].marker && series.data[series.data.length - _j2].marker.enabled == true) {
                                        series.data[series.data.length - _j2].update({
                                            marker: {
                                                enabled: undefined
                                            }
                                        });
                                    }
                                }
                                series.addPoint([unixtime, varValue]);

                                var tmpObj = series.data[series.data.length - 1];
                                tmpObjColor = tmpObj.color;

                                tmpObj.update({
                                    marker: {
                                        enabled: true,
                                        fillColor: '#d4eacf',
                                        lineWidth: 4,
                                        lineColor: '#299610', // inherit from series
                                        radius: 6
                                    },
                                    color: '#659355'
                                }, $timeout(function () {
                                    if (tmpObj.series != null) {
                                        tmpObj.update({
                                            marker: {
                                                enabled: undefined,
                                                lineColor: tmpObjColor
                                            }
                                        });
                                    }
                                }, 2000));
                            })();
                        }
                        break;
                }
            }
        }

        if (data.CH == 1) _restartAfterWsDataReceived(unixtime);
    };

    var wsDataReceivedCALLINSCOUNT = function wsDataReceivedCALLINSCOUNT(data) {

        if ($scope.deviceSelectedType != 21) {
            return;
        }

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        callInCountTimeout = $timeout(function () {

            var str = data.Time + "";
            var time = datetimeService.socketStrToServerStrTime(data.Time);
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
            unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, $scope.accountInfo.timeZone);

            for (var i = 0; i < chart.series.length; i++) {
                var varId = chart.series[i].options.id;
                switch (varId) {
                    case "ch1":
                    case "ch2":
                    case "ch3":
                    case "ch4":
                    case "ch5":
                    case "ch6":
                    case "ch7":
                    case "ch8":
                    case "ch9":

                        var serieData = chart.series[i].options.data;
                        var tmpObj = serieData[serieData.length - 1];

                        var tmpUnixtime = angular.isUndefined(tmpObj.x) ? tmpObj[0] : tmpObj.x;
                        var tmpValue = angular.isUndefined(tmpObj.y) ? tmpObj[1] : tmpObj.y;

                        if (tmpUnixtime != unixtime) {
                            data.Type = "ANALOG_G2";
                            data.Value = tmpValue;
                            data.CH = varId.charAt(2);
                            wsDataReceivedANALOG(data);
                        }
                        break;
                }
            }
        }, 300);
    };

    //==========================socket data================================
    var wsDataReceivedANALOGOUT = function wsDataReceivedANALOGOUT(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        var varValue = parseFloat(data.Value);
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, __this.accountInfo.timeZone);

        for (var j = 0; j < chart.series.length; j++) {
            var varId = chart.series[j].options.id;
            if (varId) {
                switch (varId) {
                    case "out1":
                    case "out2":
                    case "out3":
                    case "out4":
                        if (varId.charAt(3) == data.CH) {
                            var series = chart.series[j];
                            for (var _j3 = 1; _j3 <= 3; _j3++) {
                                if (series && series.data && series.data[series.data.length - _j3] && series.data[series.data.length - _j3].marker && series.data[series.data.length - _j3].marker.enabled == true) {
                                    series.data[series.data.length - _j3].update({
                                        marker: {
                                            enabled: undefined
                                        }
                                    });
                                }
                            }
                            var scaledValue = __this.chartData[varId].min + varValue / 255 * (__this.chartData[varId].max - __this.chartData[varId].min);
                            series.addPoint([unixtime, scaledValue]);
                            if (series.data.length > 0) {
                                var tmpObjColor;

                                (function () {
                                    var tmpObj = series.data[series.data.length - 1];
                                    tmpObjColor = tmpObj.color;

                                    tmpObj.update({
                                        marker: {
                                            enabled: true,
                                            fillColor: '#d4eacf',
                                            lineWidth: 4,
                                            lineColor: '#299610', // inherit from series
                                            radius: 6
                                        },
                                        color: '#659355'
                                    }, $timeout(function () {
                                        if (tmpObj.series != null) {
                                            tmpObj.update({
                                                marker: {
                                                    enabled: undefined,
                                                    lineColor: tmpObjColor
                                                }
                                            });
                                        }
                                    }, 2000));
                                })();
                            }
                        }
                        break;
                }
            }
        }

        if (data.CH == 1) _restartAfterWsDataReceived(unixtime);
    };

    var wsDataReceivedANALOSETTINGSG = function wsDataReceivedANALOSETTINGSG(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        if (data.Type == 'ANALOGSETTING' && $scope.deviceSelectedSn == data.SN) {
            if (_liveData) {
                var tmpDates = void 0;
                var tmpStartDate = null;
                var tmpEndDate = null;
                __this.loadingInProgress = true;

                timeLapseService.getLocalDateTime().then(function (result) {
                    tmpDates = new Date(result.data.localDateTime);
                    tmpDates.setHours(0, 0, 0, 0);
                    tmpDates = datetimeService.dateToUnixtime(tmpDates);
                    tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                    tmpStartDate = tmpDates.startDate;
                    tmpEndDate = tmpDates.endDate;
                    _getData($scope.deviceSelected, tmpStartDate, tmpEndDate);
                });
            } else {
                _resetViewFromLive(data.CH, data.Value);
            }
        }
    };
    var wsDataReceivedDIGITALSETTINGSG = function wsDataReceivedDIGITALSETTINGSG(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            //  return;
        };
        if (data.Type == 'DIGITALSETTING' && $scope.deviceSelectedSn == data.SN && data.CH <= 8) {
            if (_liveData) {
                var tmpDates = void 0;
                var tmpStartDate = null;
                var tmpEndDate = null;
                __this.loadingInProgress = true;

                timeLapseService.getLocalDateTime().then(function (result) {
                    tmpDates = new Date(result.data.localDateTime);
                    tmpDates.setHours(0, 0, 0, 0);
                    tmpDates = datetimeService.dateToUnixtime(tmpDates);
                    tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                    tmpStartDate = tmpDates.startDate;
                    tmpEndDate = tmpDates.endDate;
                    _getData($scope.deviceSelected, tmpStartDate, tmpEndDate);
                });
            } else {
                _getData($scope.deviceSelected, _startData, _endDate);
            }
        }
    };

    var wsDataReceivedSITEACCESS = function wsDataReceivedSITEACCESS(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, __this.accountInfo.timeZone);

        var _item = {
            id: unixtime,
            color: "gray",
            dashStyle: "ShortDot",
            label: {
                text: data.RepID + " - " + data.Value, //newSiteAccessData[i].userName + " - " + newSiteAccessData[i].keyHex,
                verticalAlign: 'top',
                y: 5,
                x: -10
            },
            value: unixtime,
            width: 1,
            zIndex: 1
        };

        __this.siteAccessData.push(_item);
        __this.addSiteAccess();
    };

    var wsDataReceivedTEMPERATURE = function wsDataReceivedTEMPERATURE(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        var varValue = parseInt(data.Value);
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, __this.accountInfo.timeZone);

        chart.get('temp').addPoint([unixtime, __this.preferredMeasurementFormat === 1 ? Math.round(9 / 5 * varValue + 32) : varValue]); //, true, false, true

        _restartAfterWsDataReceived(unixtime);
    };

    var wsDataReceivedSIGNAL = function wsDataReceivedSIGNAL(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        var varValue = parseFloat(data.Value);
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, __this.accountInfo.timeZone);

        chart.get('sign').addPoint([unixtime, varValue]); //, true, false, true

        _restartAfterWsDataReceived(unixtime);
    };

    var wsDataReceivedSIGNALPOWER = function wsDataReceivedSIGNALPOWER(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        var varValue = parseFloat(data.Value);
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, __this.accountInfo.timeZone);

        chart.get('signalPower').addPoint([unixtime, varValue]); //, true, false, true

        _restartAfterWsDataReceived(unixtime);
    };

    var wsDataReceivedSIGNALQUALITY = function wsDataReceivedSIGNALQUALITY(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        var varValue = parseFloat(data.Value);
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, __this.accountInfo.timeZone);

        chart.get('signalQuality').addPoint([unixtime, varValue]); //, true, false, true

        _restartAfterWsDataReceived(unixtime);
    };

    var wsDataReceivedVOLTAGE = function wsDataReceivedVOLTAGE(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        var varValue = parseFloat(data.Value);
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, __this.accountInfo.timeZone);
        var varType = data.Type;
        var varVBATT = null;
        var varVAC = null;

        if (varType == "VBATT") {
            varVBATT = varValue;
        } else {
            if ($scope.solar) {
                varVAC = (100 * varValue + 140) / 100;
            } else {
                varVAC = 100 * varValue * .707 / 100;
            }
        }

        if (varType == "VBATT") {
            chart.get('vbatt').addPoint([unixtime, varVBATT]);
        }
        if (varType == "VAC") {
            chart.get('vac').addPoint([unixtime, varVAC]);
        }

        _restartAfterWsDataReceived(unixtime);
    };

    var wsDataReceivedDI = function wsDataReceivedDI(data) {
        //DIGITAL - DIGITAL
        $timeout(function () {
            //-- need to compare: const unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
            var x = datetimeService.toUnixtime(data.Time);
            x = datetimeService.localToUtcTimeStampByTime(x, __this.accountInfo.timeZone);
            var channelDI = 1;
            var value = 0;
            var y = null;
            //const chArray = data.Value.replace(/[[\]]/g, '').split(',');
            var chValue = data.Value;
            var channel = parseInt(data.CH);

            for (var i = 0; i < _faultData.length; i++) {
                if (_faultData[i] === '1' && i + 1 == channel) {
                    chValue = "null";
                }
            }

            for (var _i12 = 1; _i12 <= 8; _i12++) {
                // four pumps max
                if (__this.chartData['pmp' + _i12].name !== null && __this.chartData['pmp' + _i12].name.length > 0) {
                    _removeNull('pmp' + _i12);
                    channelDI = _i12;
                    if (channel == channelDI) {
                        value = _updateValue(chValue, channel, _getNormalClosed(channel));
                        var cutSeries = chart.get('pmp' + _i12);
                        var preValue = cutSeries.data[cutSeries.data.length - 1].y; //last value
                        y = value === null ? null : parseFloat(value);
                        if (preValue !== null && y !== null && y !== preValue) {
                            //from fault to close or from close to fault
                            cutSeries.addPoint([x - 100, null], false, false, false); //insert a null to break the line
                            //---data.push??? - cutSeries.data.push([x - 100, null, 1]);
                            //chart.series[i].data.push([x - 100, null, 1]);
                        }
                        cutSeries.addPoint([x, y], false, false, false);
                    }
                    //---data.push??? - cutSeries.data.push([x, y, 1]);
                }
            }
            //chart.redraw();
            _restartAfterWsDataReceived(x); //need review
        }, 200);
    };

    var wsDataReceivedFAULTS = function wsDataReceivedFAULTS(data) {
        var faultBinary = [];
        if (isNaN(data.Value)) {
            faultBinary = data.Value.replace(/[[\]]/g, '').split(',').join('');
        } else {
            faultBinary = (data.Value >>> 0).toString(2);
            //while (faultBinary.length < _digitalSetting.length) {
            while (faultBinary.length < 8) {
                faultBinary = "0" + faultBinary;
            }
        }
        _faultData = faultBinary;
    };

    var wsDataReceivedPULSE = function wsDataReceivedPULSE(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, __this.accountInfo.timeZone);

        for (var j = 0; j < chart.series.length; j++) {
            var varId = chart.series[j].options.id;
            if (varId) {
                switch (varId) {
                    case "pulseFlow1":
                    case "pulseFlow2":
                    case "pulseFlow3":
                    case "pulseFlow4":
                    case "pulseFlow5":
                    case "pulseFlow6":
                        if (varId.charAt(9) == data.CH) {
                            var series = chart.series[j];
                            var scaledValue = Number(data.ScaledValue);
                            switch (__this.selectedPulseFlowGrouping) {
                                case "1":
                                    series.addPoint([unixtime, scaledValue]);
                                    break;
                                case "2":
                                    if (moment(series.data[series.data.length - 1].x).valueOf() === moment(unixtime).minute(15 * Math.floor(moment(unixtime).startOf('minute').minute() / 15)).startOf('minute').valueOf()) {
                                        series.data[series.data.length - 1].update(series.data[series.data.length - 1].y += varValue);
                                    } else {
                                        unixtime = moment(unixtime).minute(15 * Math.floor(moment(unixtime).startOf('minute').minute() / 15)).startOf('minute').valueOf();
                                        series.addPoint([unixtime, varValue]);
                                    }
                                    break;
                                case "3":
                                    if (moment(series.data[series.data.length - 1].x).valueOf() === moment(unixtime).startOf('hour').valueOf()) {
                                        series.data[series.data.length - 1].update(series.data[series.data.length - 1].y += varValue);
                                    } else {
                                        unixtime = moment(unixtime).startOf('hour').valueOf();
                                        series.addPoint([unixtime, varValue]);
                                    }
                                    break;
                                case "4":
                                    if (moment.utc(series.data[series.data.length - 1].x).valueOf() === moment.utc(unixtime).startOf('day').valueOf()) {
                                        series.data[series.data.length - 1].update(series.data[series.data.length - 1].y += varValue);
                                    } else {
                                        unixtime = moment.utc(unixtime).startOf('day').valueOf();
                                        series.addPoint([unixtime, varValue]);
                                    }
                                    break;
                            }
                        }
                        break;
                }
            }
        }
    };

    var wsDataReceivedRainfallDIGITALASPULSE = function wsDataReceivedRainfallDIGITALASPULSE(data) {

        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var str = "" + data.Time;
        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, __this.accountInfo.timeZone);

        for (var j = 0; j < chart.series.length; j++) {
            var varId = chart.series[j].options.id;
            if (varId) {
                switch (varId) {
                    case "rainR":

                        var series = chart.series[j];
                        var scaledValue = Number(data.ScaledValue);
                        series.addPoint([unixtime, scaledValue]);

                        break;
                }
            }
        }
    };

    var _updateValue = function _updateValue(value, channel, nomalState) {
        if (value === "null") //falut
            return parseFloat(channel) - 0.3;else if (value === String(nomalState)) return channel;else return null;
    };

    var _startAfterWsDataReceived = void 0;

    var _checkStartAfterWsDataReceived = function _checkStartAfterWsDataReceived(unixTime) {
        // Don't start if already started
        if (angular.isDefined(_startAfterWsDataReceived)) return;
        _startAfterWsDataReceived = $timeout(function () {
            _startAfterWsDataReceived = undefined;
            afterWsDataReceived(unixTime);
        }, 300);
    };

    var _stopAfterWsDataReceived = function _stopAfterWsDataReceived() {
        if (angular.isDefined(_startAfterWsDataReceived)) {
            $timeout.cancel(_startAfterWsDataReceived);
            _startAfterWsDataReceived = undefined;
        }
    };

    var _restartAfterWsDataReceived = function _restartAfterWsDataReceived(unixTime) {
        if (angular.isDefined(_startAfterWsDataReceived)) _stopAfterWsDataReceived();
        _checkStartAfterWsDataReceived(unixTime);
    };

    var afterWsDataReceived = function afterWsDataReceived(dataTime) {
        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;
        chart.xAxis[0].setExtremes(dataTime - tmpRange + __this.minPadding, dataTime + __this.maxPadding);
    };

    var tlDataReceivedTIMELAPS = function tlDataReceivedTIMELAPS(data) {
        data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, __this.accountInfo.timeZone);
        if (_liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var extremes = chart.xAxis[0].getExtremes();
        var tmpRange = extremes.max - extremes.min;

        //DIGITAL - DIGITAL
        var x = data.Unix + __this.maxPadding;
        for (var t = 1; t <= 8; t++) {
            if (__this.chartData['pmp' + t].name !== null && __this.chartData['pmp' + t].name.length > 0) {
                if (!_preparedForTimeLaps) _removeNull("pmp" + t);
                var series = chart.get("pmp" + t);
                var y = series.options.data[series.options.data.length - 1][1];
                series.addPoint([x, y], false, false, false);
            }
        }
        _preparedForTimeLaps = true;

        //CONNECTIVITY - online
        var connSeries = chart.get("conn");
        if (typeof connSeries != "undefined") {
            var lastDataPoint = connSeries.options.data[connSeries.options.data.length - 1];

            if (!!lastDataPoint && lastDataPoint.tmp && typeof connSeries.data[connSeries.options.data.length - 1] != "undefined") {
                lastDataPoint.x = data.Unix + __this.maxPadding;
                connSeries.data[connSeries.options.data.length - 1].update(lastDataPoint);
            } else if (!!lastDataPoint) {
                var newDataPoint = angular.copy(lastDataPoint);
                newDataPoint.x = data.Unix + __this.maxPadding;
                newDataPoint.tmp = true;
                connSeries.addPoint(newDataPoint, false, false, false);
            }
        }
        //CONNECTIVITY - online


        var liveDataLine = chart.xAxis[0].plotLinesAndBands;
        liveDataLine[0].options.value = data.Unix + __this.maxPadding;

        chart.xAxis[0].setExtremes(data.Unix - tmpRange + __this.minPadding, data.Unix + __this.maxPadding);
    };

    $scope.mostRecentData = function () {
        toaster.pop('success', "Supergraph" + " -- " + $scope.deviceSelectedName, 'View reloading');
        $scope.myDate = null;
        var tmpDates = new Date();
        __this.loadingInProgress = true;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
        endPlotBand = tmpDates.endDate;
        _getData($scope.deviceSelected, tmpDates.startDate, tmpDates.endDate);
    };

    $scope.$on('processReconnect', function (event, args) {

        if (__this.stickyProperties.liveData === true) {
            __this.autoScale = false;
            $scope.deviceChangeInProgress = true;
            __this.loadingInProgress = true;
            _initChart();
        }

        sharedSetupService.processReconnect({
            stickyProperties: __this.stickyProperties,
            localDateTime: args.localDateTime,
            dateRangeOption: 0,
            windowTitle: $scope.windowTitle,
            fnUnregister: _unRegisterListener,
            fnGetData: _getData,
            viewType: "Chart"
        });
    });

    var _registerListener = function _registerListener(varSelectedSN) {
        websocketService.connect();
        sharedSetupService.setStickyProperties(__this.stickyProperties, { liveData: true, windowId: $scope.windowId });

        for (var j = 0; j < chart.series.length; j++) {
            var varId = chart.series[j].options.onSeries;
            if (varId) {
                switch (varId) {
                    case "ch1":
                    case "ch2":
                    case "ch3":
                    case "ch4":
                    case "ch5":
                    case "ch6":
                    case "ch7":
                    case "ch8":
                    case "ch9":
                        websocketService.register("ANALOG", varSelectedSN, varId.charAt(2), wsDataReceivedANALOG, null);
                        websocketService.register("ANALOG_G2", varSelectedSN, varId.charAt(2), wsDataReceivedANALOG, null);
                        if (!_liveAnalogSetting) websocketService.register("ANALOGSETTING", varSelectedSN, varId.charAt(2), wsDataReceivedANALOSETTINGSG, null);
                        break;
                    case "out1":
                    case "out2":
                    case "out3":
                    case "out4":
                        websocketService.register("ANALOGOUT", varSelectedSN, varId.charAt(3), wsDataReceivedANALOGOUT, null);
                        break;
                    case "vbatt":
                    case "vac":
                        websocketService.register(varId.toUpperCase(), varSelectedSN, "", wsDataReceivedVOLTAGE, null);
                        break;
                    case "sign":
                        if (!__this.hasRMDTRadio) websocketService.register("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, null);
                        break;
                    case "signalPower":
                        if (__this.hasRMDTRadio) websocketService.register("SIGNALPOWER", varSelectedSN, "", wsDataReceivedSIGNALPOWER, null);
                        break;
                    case "signalQuality":
                        if (__this.hasRMDTRadio) websocketService.register("SIGNALQUALITY", varSelectedSN, "", wsDataReceivedSIGNALQUALITY, null);
                        break;
                    case "temp":
                        websocketService.register("TEMPERATURE", varSelectedSN, "", wsDataReceivedTEMPERATURE, null);
                        break;
                    case "pulseFlow1":
                    case "pulseFlow2":
                    case "pulseFlow3":
                    case "pulseFlow4":
                    case "pulseFlow5":
                    case "pulseFlow6":
                        __this.deviceType == 21 ? websocketService.register("DIGITALASPULSE", varSelectedSN, varId.charAt(9), wsDataReceivedPULSE, null) : websocketService.register("PULSE", varSelectedSN, varId.charAt(9), wsDataReceivedPULSE, null);
                        break;

                }
            }
        }

        if (__this.metarStation && __this.metarStation.deviceModel == 21) {
            __this.metarStationToUnregister = angular.copy(__this.metarStation);
            websocketService.register("DIGITALASPULSE", __this.metarStation.serialNumber, __this.metarStation.channel, wsDataReceivedRainfallDIGITALASPULSE, null);
        } else {
            timeLapseService.register("RAINFALL", 0, "", _pollForLiveData, _pollInterval);
        }

        websocketService.register("KEY", varSelectedSN, "", wsDataReceivedSITEACCESS, null);

        websocketService.register("DIGITALINPUT", varSelectedSN, '', wsDataReceivedDI, null);
        websocketService.register("FAULTS", varSelectedSN, '', wsDataReceivedFAULTS, null);
        websocketService.register("INFO", "", "", wsInfoDataReceived, null);

        timeLapseService.register("TIMELAPS", varSelectedSN, "", tlDataReceivedTIMELAPS);
        websocketService.register("CALLINSCOUNT", varSelectedSN, "", wsDataReceivedCALLINSCOUNT, null);

        if (!_liveDigitalSetting) {
            for (var l = 1; l <= 8; l++) {
                websocketService.register("DIGITALSETTING", varSelectedSN, l, wsDataReceivedDIGITALSETTINGSG, null);
            }
        }
        _liveData = true;
        _liveAnalogSetting = true;
        _liveDigitalSetting = true;
    };

    var _unRegisterListener = function _unRegisterListener(varSelectedSN) {
        var _numberOfSeries = _typeof(chart !== 'undefined') && _typeof(chart.series !== 'undefined') ? chart.series.length : 0;
        for (var j = 0; j < _numberOfSeries; j++) {
            var varId = chart.series[j].options.onSeries;
            if (varId) {
                switch (varId) {
                    case "ch1":
                    case "ch2":
                    case "ch3":
                    case "ch4":
                    case "ch5":
                    case "ch6":
                    case "ch7":
                    case "ch8":
                    case "ch9":
                        websocketService.unRegister("ANALOG", varSelectedSN, varId.charAt(2), wsDataReceivedANALOG, null);
                        websocketService.unRegister("ANALOG_G2", varSelectedSN, varId.charAt(2), wsDataReceivedANALOG, null);
                        break;
                    case "out1":
                    case "out2":
                    case "out3":
                    case "out4":
                        websocketService.unRegister("ANALOGOUT", varSelectedSN, varId.charAt(3), wsDataReceivedANALOGOUT, null);
                        break;
                    case "vbatt":
                    case "vac":
                        websocketService.unRegister(varId.toUpperCase(), varSelectedSN, "", wsDataReceivedVOLTAGE, null);
                        break;
                    case "sign":
                        websocketService.unRegister("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, null);
                        break;
                    case "signalPower":
                        websocketService.unRegister("SIGNALPOWER", varSelectedSN, "", wsDataReceivedSIGNALPOWER, null);
                        break;
                    case "signalQuality":
                        websocketService.unRegister("SIGNALQUALITY", varSelectedSN, "", wsDataReceivedSIGNALQUALITY, null);
                        break;
                    case "temp":
                        websocketService.unRegister("TEMPERATURE", varSelectedSN, "", wsDataReceivedTEMPERATURE, null);
                        break;
                    case "pulseFlow1":
                    case "pulseFlow2":
                    case "pulseFlow3":
                    case "pulseFlow4":
                    case "pulseFlow5":
                    case "pulseFlow6":
                        __this.deviceType == 21 ? websocketService.unRegister("DIGITALASPULSE", varSelectedSN, varId.charAt(9), wsDataReceivedPULSE, null) : websocketService.unRegister("PULSE", varSelectedSN, varId.charAt(9), wsDataReceivedPULSE, null);
                        break;
                }
            }
        }

        if (__this.metarStationToUnregister && __this.metarStationToUnregister.deviceModel == 21) {
            websocketService.unRegister("DIGITALASPULSE", __this.metarStationToUnregister.serialNumber, __this.metarStationToUnregister.channel, wsDataReceivedRainfallDIGITALASPULSE, null);
        } else {
            timeLapseService.unRegister("RAINFALL", 0, "", _pollForLiveData, _pollInterval);
        }

        websocketService.unRegister("KEY", varSelectedSN, "", wsDataReceivedSITEACCESS, null);

        websocketService.unRegister("DIGITALINPUT", varSelectedSN, '', wsDataReceivedDI, null);
        websocketService.unRegister("FAULTS", varSelectedSN, '', wsDataReceivedFAULTS, null);
        websocketService.unRegister("INFO", "", "", wsInfoDataReceived, null);

        timeLapseService.unRegister("TIMELAPS", varSelectedSN, "", tlDataReceivedTIMELAPS);

        if (angular.isDefined(callInCountTimeout)) {
            $timeout.cancel(callInCountTimeout);
            callInCountTimeout = undefined;
        }

        websocketService.unRegister("CALLINSCOUNT", varSelectedSN, "", wsDataReceivedCALLINSCOUNT, null);

        _liveData = false;
        $scope.lastUpdateAt = undefined;
    };

    var _unRegisterListenerAnalogSetting = function _unRegisterListenerAnalogSetting(varSelectedSN) {
        _liveAnalogSetting = false;
        for (var i = 0; i < 6; i++) {
            //chart.series.length - 1
            websocketService.unRegister("ANALOGSETTING", varSelectedSN, i + 1, wsDataReceivedANALOSETTINGSG, null);
        }
    };

    var _unRegisterListenerDigitalSetting = function _unRegisterListenerDigitalSetting(varSelectedSN) {
        _liveDigitalSetting = false;
        for (var k = 1; k <= 8; k++) {
            websocketService.unRegister("DIGITALSETTING", varSelectedSN, k, wsDataReceivedDIGITALSETTINGSG, null);
        }
    };

    var _resetView = function _resetView(args) {
        __this.stickyProperties.on = true;
        for (var i = 0; i < _series.length; i++) {
            if (_series[i].id == "ch" + args.channel) {
                var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
                _series[i].name = _newData.name + " (" + _newData.unit + ")";
                __this.chartData["ch" + args.channel].name = _newData.name;
                __this.chartData["ch" + args.channel].unit = _newData.unit;
                __this.chartData["ch" + args.channel].min = _newData.minimumValue;
                __this.chartData["ch" + args.channel].max = _newData.maximumValue;
                __this.chartData["ch" + args.channel].decimal = sharedSetupService.getNumberOfDecimals(_newData.maximumValue, _newData.minimumValue);
            }
        }
        _drawChart(true);
    };

    var _resetAOView = function _resetAOView(args) {
        __this.stickyProperties.on = true;
        for (var i = 0; i < _series.length; i++) {
            if (_series[i].id == "out" + args.channel) {
                var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
                _series[i].name = _newData.channelName + " (" + _newData.unit + ")";
                __this.chartData["out" + args.channel].name = _newData.channelName;
                __this.chartData["out" + args.channel].unit = _newData.unit;
                __this.chartData["out" + args.channel].min = _newData.minimumValue;
                __this.chartData["out" + args.channel].max = _newData.maximumValue;
                __this.chartData["out" + args.channel].uiGroup = 7;
                __this.chartData["out" + args.channel].decimal = sharedSetupService.getNumberOfDecimals(_newData.maximumValue, _newData.minimumValue);
            }
        }
        _drawChart(true);
    };

    var _resetPulseView = function _resetPulseView(args) {
        __this.stickyProperties.on = true;
        for (var i = 0; i < _series.length; i++) {
            if (_series[i].id == "pulseFlow" + args.channel) {
                var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
                __this.chartData["pulseFlow" + args.channel].name = _newData.channelName;
                __this.chartData["pulseFlow" + args.channel].unit = _newData.unit;
                __this.chartData["pulseFlow" + args.channel].flowScale = _newData.flowScale;
                __this.chartData["pulseFlow" + args.channel].uiGroup = 8;
                __this.hasPulseFlow = true;
            }
        }
    };

    var _resetViewFromLive = function _resetViewFromLive(channel, patch) {
        __this.stickyProperties.on = true;
        for (var i = 0; i < _series.length; i++) {
            if (_series[i].id == "ch" + channel) {
                switch (patch.path) {
                    case 'minimumValue':
                        __this.chartData["ch" + args.channel].min = parseInt(patch.value);
                        __this.chartData["ch" + args.channel].decimal = sharedSetupService.getNumberOfDecimals(__this.chartData["ch" + args.channel].max, parseInt(patch.value));
                        break;
                    case 'maximumValue':
                        __this.chartData["ch" + args.channel].max = parseInt(patch.value);
                        __this.chartData["ch" + args.channel].decimal = sharedSetupService.getNumberOfDecimals(parseInt(patch.value), __this.chartData["ch" + args.channel].min);
                        break;
                    case 'name':
                        __this.chartData["ch" + args.channel].name = patch.value;
                        _series[i].name = patch.value + " (" + __this.chartData["ch" + args.channel].unit + ")";
                        break;
                    case 'unit':
                        __this.chartData["ch" + args.channel].unit = patch.value;
                        _series[i].name = __this.chartData["ch" + args.channel].name + " (" + patch.value + ")";
                        break;
                }
            }
        }
        _drawChart(true);
    };

    var _getArgsFromNewSetting = function _getArgsFromNewSetting(channel, newSetting) {
        for (var i = 0; i < newSetting.length; i++) {
            if (newSetting[i].channel == channel) {
                return newSetting[i];
                break;
            }
        }
        return null;
    };

    var _convertData = function _convertData(varData) {
        if (__this.preferredMeasurementFormat === 2 && __this.dataIsInFormat !== 2) for (var j = 0; j < varData.length; j++) {
            varData[j][1] = Math.round((varData[j][1] - 32) * (5 / 9));
        }
        if (__this.preferredMeasurementFormat === 1 && __this.dataIsInFormat !== 1) for (var _j4 = 0; _j4 < varData.length; _j4++) {
            varData[_j4][1] = Math.round(9 / 5 * varData[_j4][1] + 32);
        }
        return varData;
    };

    __this.adjustSerieScale = function (varSerie, ch, savetoDesktop) {
        chart = ch ? ch : chart;
        for (var j = 0; j < chart.yAxis.length; j++) {

            var tmpId = typeof chart.yAxis[j].options.id != "undefined" ? chart.yAxis[j].options.id.replace("yx-", "") : "";

            switch (tmpId) {
                case "vbatt":
                case "vac":
                case "vaux":
                case "sign":
                case "signalQuality":
                case "signalPower":
                case "temp":
                case "rainT":
                case "rainR":
                case "ch1":
                case "ch2":
                case "ch3":
                case "ch4":
                case "ch5":
                case "ch6":
                case "ch7":
                case "ch8":
                case "ch9":
                case "out1":
                case "out2":
                case "out3":
                case "out4":
                case "pulseFlow1":
                case "pulseFlow2":
                case "pulseFlow3":
                case "pulseFlow4":
                case "pulseFlow5":
                case "pulseFlow6":
                    if (tmpId == varSerie) __this.chartData[tmpId].autoScale = !__this.chartData[tmpId].autoScale;
                    if (__this.chartData[tmpId].autoScale === true) {
                        chart.yAxis[j].options.min = null;
                        chart.yAxis[j].options.max = null;
                        chart.yAxis[j].setExtremes(null, null);
                    } else {
                        chart.yAxis[j].setExtremes(__this.chartData[tmpId].min, __this.chartData[tmpId].max);
                    }
                    if (savetoDesktop) __this.saveDesktopSettingService.setSerieVisibilityAndScaleSettingSupergraph(tmpId, __this.chartData[tmpId].visible, __this.chartData[tmpId].autoScale, chart.yAxis[j].plotLines, __this);
                    break;
            }
            if (tmpId == varSerie) {
                $scope.setXaxisExtremes();
                break;
            }
        }

        if (varSerie == null) $scope.setXaxisExtremes();

        // After updated the state of individual toggle and update the "Select All" toggle to ON or OFF accordingly
        $timeout(function () {
            checkSelectedAllToggle();
        }, 0);
    };

    __this.adjustSerieScaleAll = function (autoScale, ch) {

        chart = ch ? ch : chart;
        __this.autoScale = autoScale;
        for (var prop in __this.chartData) {
            if (__this.chartData.hasOwnProperty(prop)) {
                __this.chartData[prop].autoScale = __this.autoScale;
            }
        }

        for (var j = 0; j < chart.yAxis.length; j++) {
            var tmpId = typeof chart.yAxis[j].options.id != "undefined" ? chart.yAxis[j].options.id.replace("yx-", "") : "";

            switch (tmpId) {
                case "vbatt":
                case "vac":
                case "vaux":
                case "sign":
                case "signalQuality":
                case "signalPower":
                case "temp":
                case "rainT":
                case "rainR":
                case "ch1":
                case "ch2":
                case "ch3":
                case "ch4":
                case "ch5":
                case "ch6":
                case "ch7":
                case "ch8":
                case "ch9":
                case "out1":
                case "out2":
                case "out3":
                case "out4":
                case "pulseFlow1":
                case "pulseFlow2":
                case "pulseFlow3":
                case "pulseFlow4":
                case "pulseFlow5":
                case "pulseFlow6":
                    if (__this.autoScale) {
                        chart.yAxis[j].options.min = null;
                        chart.yAxis[j].options.max = null;
                        chart.yAxis[j].setExtremes(null, null);
                    } else {
                        chart.yAxis[j].setExtremes(__this.chartData[tmpId].min, __this.chartData[tmpId].max);
                    }
                    break;
            }
        }

        $scope.setXaxisExtremes();
    };

    var checkSelectedAllToggle = function checkSelectedAllToggle() {
        var allToggleBtn = document.querySelectorAll('.toggle-cls');

        // Check if all elements have 'toggle-on' or 'toggle-off'
        var allOn = Array.from(allToggleBtn).every(function (ele) {
            return ele.classList.contains('fa-toggle-on');
        });

        __this.autoScale = allOn;
    };

    var _pollInterval = 60; //1.5;
    var _pollForLiveData = function _pollForLiveData(data) {
        var tmpDates = { startDate: _lastRainfallDate + 1001, endDate: data.UtcUnix };
        _scrollChart("livePool", null, tmpDates, tmpData, null, "Rainfall");
    };

    var wsInfoDataReceived = function wsInfoDataReceived(data) {
        if (parseFloat(data.RepID) > 0) {
            //let unixtime = Date.UTC(data.Time.substr(0, 4), parseInt(data.Time.substr(4, 2)) -1, data.Time.substr(6, 2), data.Time.substr(8, 2), data.Time.substr(10, 2), data.Time.substr(12, 2)); //1404751962000
            var extremes = chart.xAxis[0].getExtremes();
            //let tmpDates = { startDate: extremes.min - 3600, endDate: extremes.max + 3600 * 1000 };
            var tmpDates = { startDate: extremes.dataMin - 3600, endDate: extremes.dataMax + 3600 * 1000 };
            _scrollChart("livePool", null, tmpDates, tmpData, data.RepID, "Alarm");
            return;
            //if it doesn't work will do "Plan B"
            _scrollChartArrSCA.push({ dates: tmpDates, data: tmpData, repId: data.RepID });
            _restartBroadcastSCA();
            //if it doesn't work will do "Plan B"
        }
    };

    ///////////////////// 
    ////// "Plan B" /////
    ///////////////////// 
    var _scrollChartArrSCA = [];
    var _startBroadcastSCA = void 0;

    var _restartBroadcastSCA = function _restartBroadcastSCA() {
        if (angular.isDefined(_startBroadcastSCA)) {
            $timeout.cancel(_startBroadcastSCA);
            _startBroadcastSCA = undefined;
        }
        _startBroadcastSCA = $timeout(function () {
            var _tmpArr = angular.copy(_scrollChartArrSCA);
            _scrollChartArrSCA = [];
            if (_tmpArr.length < 5) {
                for (var i = 0; i < _tmpArr.length; i++) {
                    _scrollChart("livePool", null, _tmpArr[i].dates, _tmpArr[i].data, _tmpArr[i].repId, "Alarm");
                }
            } else {
                alert("new...");
            }
        }, 3000);
    };
    ///////////////////// 
    ////// "Plan B" /////
    ///////////////////// 


    __this.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = __this.windowId;
        $scope.windowTitle = __this.windowTitle;
        $scope.deviceSelected = __this.deviceSelected;
        if (__this.mobile && _typeof(__this.stickyProperties) != 'object') __this.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = __this.stickyProperties;
        $scope.isSupergraph = true;

        if (__this.mobile) {
            //only needed for mobile mode where the chart gets too small if not in landscape mode and starts throwing a bunch of errors!
            $scope.$watch(function () {
                return $(element).parents(".mobi-page-landscape-wrapper").css("display");
            }, function (newValue, oldValue) {
                if (newValue === "none") {
                    __this.stopChart = true;
                    $scope.tmpDeviceSelected = $scope.deviceSelected;
                    if (chart) _unRegisterListener($scope.deviceSelectedSn);
                    if (chart) _unRegisterListenerAnalogSetting($scope.deviceSelectedSn);
                    if (chart) _unRegisterListenerDigitalSetting($scope.deviceSelectedSn);
                    if (angular.isDefined(_startBroadcast)) $timeout.cancel(_startBroadcast);
                    if (angular.isDefined(_startAfterWsDataReceived)) $timeout.cancel(_startAfterWsDataReceived);
                    if (chart) chart.destroy();
                    chart = null;
                    $scope.deviceSelected = null;
                } else {
                    __this.stopChart = false;
                    if ($scope.tmpDeviceSelected) $scope.deviceSelected = $scope.tmpDeviceSelected;
                }
            }, true);
        }

        sharedSetupService.getWindowId(__this);

        //Need for old directives/services: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);

        __this.accountInfo = authenticationService.getAccountInfo();
        __this.translation = translationService.translation;

        __this.preferredMeasurementFormat = __this.accountInfo.preferenceUser.lookupMeasurementID;
        __this.unit = __this.preferredMeasurementFormat === 2 ? "°C" : "°F";

        $scope.myDate = null;

        __this.TimeFormatEnum = { Civilian: 1, Military: 2 };
        __this.preferredTimeFormat = __this.accountInfo.preferenceUser.timeFormat;

        __this.chartXaxisHourFormat = __this.preferredTimeFormat === __this.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
        __this.chartToolTipHourFormat = __this.preferredTimeFormat === __this.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

        __this.unixDay = sharedSetupService.unixDay;

        __this.minPadding = 0;
        __this.maxPadding = 0;
        __this.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;

        $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.alerts = [];
        __this.loadingInProgress = true;
        $scope.deviceChangeInProgress = true;

        //__this.autoScale = true;

        $scope.selectedButton = 0;

        sharedSetupService.broadcastAllDeviceSelected($scope);
        $scope.openView = openViewService.openView;

        if ($scope.classicView && $element.parent('div').parent('div').parent('div').attr('class') && $element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") == 0) {
            $scope.largeChart = true;
            $element.height(500);
        }

        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        $scope.fnChangeLanguage = function () {
            if ($scope.alerts.length > 0) {
                var _msg = eval("__this.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ": " + moment($scope.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment($scope.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                }
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        };

        if (!$rootScope.mobile && !$rootScope.classicView) {
            _popup = _this.getExistingDialog(_this2.windowId).ref;
            sharedSetupService.maximize(_popup);

            _popup.dialog({
                resize: function resize(event, ui) {
                    _adjustSize();
                }
            });

            _popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(_popup);
                    _adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(_popup);
                    _adjustSize();
                }
            });
        }

        $scope.downloadViewTypeOptions = [5];

        $scope.chartSeriesVisibility = [];

        element.attr("class", "chart");

        element.on('mouseover', function (event) {
            var normalizedEvent = chart.pointer.normalize(event);
            xValueMousePoint = Math.trunc(chart.xAxis[0].toValue(normalizedEvent.chartX));
        });

        element.on('mousewheel', function (event) {
            if (!_scrollingInProgress) {
                var xvalue = xValue != null ? xValue : xValueMousePoint;
                $scope.mouseWheelZoom(event, chart, xvalue);
            }
        });

        if (_typeof(__this.stickyProperties) != 'object') {
            __this.stickyProperties = __this.stickyPropertiesInterface;
        }

        $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                _liveDataIn = !_liveDataIn;
                $timeout(function () {
                    _liveDataIn = !_liveDataIn;
                }, 3000);
            }
        }, true);

        var _adjustCalendar = function _adjustCalendar() {

            // Get the current date and time.
            var currentDate = new Date();

            // Compare the input date with the current date.
            if (ctrl.myDateRangeStart > currentDate) {
                // If the date is in the future, set it to the current date.
                ctrl.myDateRangeStart.setTime(currentDate.getTime());
            }

            if (ctrl.myDateRangeEnd > currentDate) {
                // If the date is in the future, set it to the current date.
                ctrl.myDateRangeEnd.setTime(currentDate.getTime());
            }
        };

        $scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {

                __this.saveDesktopSettingService = new SaveDesktopSettingService(newValue, __this.windowId);

                //need for mobi only
                if (__this.stopChart) {
                    $scope.tmpDeviceSelected = $scope.deviceSelected;
                    $scope.deviceSelected = null;
                    return false;
                }
                //need for mobi only

                __this.autoScale = false;
                $scope.deviceChangeInProgress = true;
                var tmpDates = void 0;
                var tmpStartDate = null;
                var tmpEndDate = null;
                __this.loadingInProgress = true;
                __this.uiGroup = [];
                __this.uiGroup[1] = true;
                __this.uiGroup[2] = true;
                __this.uiGroup[3] = true;
                __this.uiGroup[4] = true;
                __this.uiGroup[5] = true;
                __this.uiGroup[6] = false;
                __this.uiGroup[7] = true;
                __this.uiGroup[8] = true;
                _initChart();

                //   let saveDesktopSettingService = new SaveDesktopSettingService(newValue, $scope.windowId);

                if (__this.stickyProperties.setting && __this.stickyProperties.setting.savedDesktop) {
                    __this.savedDesktopSetting = __this.stickyProperties.setting;
                    if (!angular.isUndefined(__this.stickyProperties.setting.selectedPulseFlowGrouping)) __this.selectedPulseFlowGrouping = __this.stickyProperties.setting.selectedPulseFlowGrouping;
                } else {
                    __this.savedDesktopSetting = __this.saveDesktopSettingService.getObject();
                }
                if (__this.stickyProperties.on !== null && __this.stickyProperties.dateMax !== null) {
                    __this.stickyProperties.on = true;
                    tmpStartDate = __this.stickyProperties.dateMin;
                    tmpEndDate = __this.stickyProperties.dateMax;

                    ctrl.myDateRangeStart = new Date(tmpStartDate);
                    ctrl.myDateRangeEnd = new Date(tmpEndDate);

                    _adjustCalendar();
                } else {
                    __this.stickyProperties.on = false;
                }

                if (!tmpStartDate) {
                    timeLapseService.getLocalDateTime().then(function (result) {
                        tmpDates = new Date(result.data.localDateTime);
                        tmpDates.setHours(0, 0, 0, 0);
                        tmpDates = datetimeService.dateToUnixtime(tmpDates);
                        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                        tmpDates = datetimeService.startEndLocalToUtc(tmpDates, __this.accountInfo.timeZone);
                        tmpStartDate = tmpDates.startDate;
                        tmpEndDate = tmpDates.endDate;
                        ctrl.myDateRangeStart = new Date(tmpStartDate);
                        ctrl.myDateRangeEnd = new Date(tmpEndDate);
                        _adjustCalendar();
                        _getData(newValue, tmpStartDate, tmpEndDate);
                    });
                } else {
                    _getData(newValue, tmpStartDate, tmpEndDate);
                }
            }
        }, true);

        $scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                $scope.chartSeriesVisibility = [];
                __this.stickyProperties.device.serialNumber = newValue;
                if (oldValue) {
                    _unRegisterListener(oldValue);
                    _unRegisterListenerAnalogSetting(oldValue);
                    _unRegisterListenerDigitalSetting(oldValue);
                }
            }
        }, true);

        ctrl.goSelectReportData = function (isRefresh) {
            var tmpDates = [];
            __this.loadingInProgress = true;
            tmpDates.startDate = datetimeService.dateToUnixtime(ctrl.myDateRangeStart);
            tmpDates.endDate = datetimeService.dateToUnixtime(ctrl.myDateRangeEnd);

            var _dateRangeEnd = ctrl.myDateRangeEnd;
            _dateRangeEnd = _dateRangeEnd.setHours(23, 59, 59, 999);
            var _dateRangeStart = ctrl.myDateRangeStart;
            _dateRangeStart = _dateRangeStart.setHours(0, 0, 0, 0);

            if (_dateRangeEnd - _dateRangeStart > __this.unixDay * 6) {
                toaster.pop('error', "Please select End date less than or equal to 6 days");
                _dateRangeEnd = _dateRangeStart + __this.unixDay * 5;
                ctrl.myDateRangeEnd = new Date(_dateRangeEnd);
            }

            var msInDay = 86400000;
            var diffMs = Math.abs(_dateRangeEnd - _dateRangeStart + 1);
            var zoomAdjustDays = Math.floor(diffMs / msInDay);

            __this.dateSelected = true;
            _getData($scope.deviceSelected, _dateRangeStart, _dateRangeEnd, null, "All", zoomAdjustDays);
        };

        $scope.setXaxisExtremes = function () {
            var extremes = chart.xAxis[0].getExtremes();
            chart.xAxis[0].setExtremes(extremes.min + __this.minPadding, extremes.max + __this.maxPadding);
            __this.maxDataRange = extremes.dataMax - extremes.dataMin;
            __this.maxDataRangeHours = Math.floor(__this.maxDataRange / 1000 / 3600);
        };

        $scope.zoomAdjust = function (varDay) {
            $scope.selectButton(varDay);
            var extremes = chart.xAxis[0].getExtremes();
            var extremeMinMax = rangeSelectorService.getChartExtremesSupergraph(extremes.dataMax, extremes.dataMin, varDay, __this.heartbeatLocalDateTime);
            chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
            _setLiveDataStatusDebounced();
        };

        $scope.selectButton = function (index) {
            $scope.selectedButton = index;
        };

        $scope.exportAction = function (actionId) {

            if (actionId == "print") {
                chart.print();
            } else {
                chart.exportChart({
                    type: actionId
                });
            }
        };

        $scope.$on('skuidChanged', function (event, args) {
            if ($scope.deviceSelected !== args) return;
            toaster.pop('success', "Supergraph" + " -- " + $scope.deviceSelectedName, 'View reloading');
            $scope.myDate = null;
            var tmpDates = new Date();
            __this.loadingInProgress = true;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            endPlotBand = tmpDates.endDate;
            _getData($scope.deviceSelected, tmpDates.startDate, tmpDates.endDate);
        });

        var getTooltip = function getTooltip(channel) {
            var tmpFontSize = "12px";
            tmpFontSize = element.height() < 400 && _digitalSetting.length > 8 ? "8px" : tmpFontSize;
            tmpFontSize = element.height() < 330 && _digitalSetting.length > 8 ? "4px" : tmpFontSize;
            for (var i = 0; i < _digitalSetting.length; i++) {
                if (_digitalSetting[i].channel === channel) return "<span style='font-size: " + tmpFontSize + ";' title='" + _digitalSetting[i].description + "'>" + channel + "</span>";
            }
            return "<span>" + channel + "</span>";
        };

        // Reloads Supergraph view when there is a digital setting change.
        var configChangeReload = function configChangeReload() {
            var tmpDeviceSelected = $scope.deviceSelected;
            $scope.deviceSelected = null;
            $timeout(function () {
                $scope.deviceSelected = tmpDeviceSelected;
            }, 0);
        };

        // Calls function to reload super graph view when digital settings are changed.
        $scope.$on('updateDigitalSetting', function (event, args) {
            configChangeReload();
        });

        $scope.$on('rtuAnalogUpdate', function (event, args) {
            var _dataChanged = "name, unit";
            if (args.deviceId == $scope.deviceSelected && _dataChanged.includes(args.fieldName)) {
                _resetView(args);
            }
        });

        $scope.$on('rtuAnalogOutputUpdate', function (event, args) {
            var _dataChanged = "channelName, unit";
            if (args.deviceId == $scope.deviceSelected && _dataChanged.includes(args.fieldName)) {
                _resetAOView(args);
            }
        });

        $scope.$on('rtuPulseUpdate', function (event, args) {
            var _dataChanged = "channelName, unit, flowScale";
            if (args.deviceId == $scope.deviceSelected && _dataChanged.includes(args.fieldName)) {
                _resetPulseView(args);
            }
        });

        $scope.$on('updatePreferencesLanguage', function () {
            if ($scope.alerts.length === 0) {
                _drawChart();
            }
        });

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            $scope.applyTimeFormat(timeFormat);
            if ($scope.alerts.length === 0) {
                _drawChart();
            }
        });

        $scope.applyTimeFormat = function (timeFormat) {
            __this.preferredTimeFormat = parseInt(timeFormat);
        };

        $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            var _tmpFormat = parseInt(measurementSystem);
            if (__this.preferredMeasurementFormat === _tmpFormat) return;
            __this.preferredMeasurementFormat = parseInt(measurementSystem);
            __this.dataIsInFormat = parseInt(measurementSystem);
            __this.unit = __this.preferredMeasurementFormat === 2 ? "°C" : "°F";
            if ($scope.alerts.length === 0) {
                $scope.mostRecentData();
            }
        });

        __this.getZoomRange = function () {
            if (chart.xAxis && chart.xAxis[0] && chart.xAxis[0].hasVisibleSeries) {
                chart.update({ navigator: { enabled: true } });
                var extremes = chart.xAxis[0].getExtremes();
                if (!isNaN(extremes.min) && !isNaN(extremes.max)) {
                    extremes.min = datetimeService.utcToLocalTimeStampByTimeZone(extremes.min, __this.accountInfo.timeZone);
                    extremes.max = datetimeService.utcToLocalTimeStampByTimeZone(extremes.max, __this.accountInfo.timeZone);
                    var _min = new Date(extremes.min); //.format('MMMM Do YYYY, h:mm:ss a');
                    var _max = new Date(extremes.max); //.format('MMMM Do YYYY, h:mm:ss a')
                    $scope.zoomPeriod = millisecondsToStr(moment.utc(_max).valueOf() - moment.utc(_min).valueOf()).replace('a day', '1 day');
                    __this.zoomRange = $filter('filterDateAgentTextTimeFormat')(new Date(extremes.min).toISOString().substring(0, 19), __this.preferredTimeFormat) + ' - ' + $filter('filterDateAgentTextTimeFormat')(new Date(extremes.max).toISOString().substring(0, 19), __this.preferredTimeFormat) + ' (' + $scope.zoomPeriod + ')';
                    $scope.selectButton(0); //check the buttons
                }
            } else {
                chart.update({ navigator: { enabled: false } });
                _scrollingInProgress = true;
            }
        };

        var millisecondsToStr = function millisecondsToStr(milliseconds) {
            // TIP: to find current time in milliseconds, use:
            // var  current_time_milliseconds = new Date().getTime();

            function numberEnding(number) {
                return number > 1 ? 's' : '';
            }

            var temp = Math.floor(milliseconds / 1000);
            var years = Math.floor(temp / 31536000);
            if (years) {
                return years + " " + __this.translation.text.YEAR + numberEnding(years);
            }
            //TODO: Months! Maybe weeks?
            var days = Math.floor((temp %= 31536000) / 86400);
            if (days) {

                temp = temp - days * 86400;
                var rhours = Math.floor((temp %= 86400) / 3600);
                if (rhours > 0) return days + " " + __this.translation.text.DAY + numberEnding(days) + " " + rhours + " " + __this.translation.text.HOUR + numberEnding(rhours);else return days + " " + __this.translation.text.DAY + numberEnding(days);
            }
            var hours = Math.floor((temp %= 86400) / 3600);
            if (hours) {
                temp = temp - hours * 3600;
                var rminutes = Math.floor((temp %= 3600) / 60);
                if (rminutes > 0) return hours + " " + __this.translation.text.HOUR + numberEnding(hours) + " " + rminutes + " " + __this.translation.text.MINUTE + numberEnding(rminutes);else return hours + " " + __this.translation.text.HOUR + numberEnding(hours);
            }
            var minutes = Math.floor((temp %= 3600) / 60);
            if (minutes) {
                return minutes + " " + __this.translation.text.MINUTE + numberEnding(minutes);
            }
            var seconds = temp % 60;
            if (seconds) {
                return seconds + " " + __this.translation.text.SECOND + numberEnding(seconds);
            }
            return __this.translation.text.LESS_THAN_A_SECOND; //'just now' //or other string you like;
        };

        $scope.$on("$destroy", function () {
            if (chart) _unRegisterListener($scope.deviceSelectedSn);
            if (chart) _unRegisterListenerAnalogSetting($scope.deviceSelectedSn);
            if (chart) _unRegisterListenerDigitalSetting($scope.deviceSelectedSn);
            if (angular.isDefined(_startBroadcast)) $timeout.cancel(_startBroadcast);
            if (angular.isDefined(_startAfterWsDataReceived)) $timeout.cancel(_startAfterWsDataReceived);
            if (chart) chart.destroy();
            $element.off("mouseover.supergraph");
            $element.off(".dragAnalog");
            $timeout.cancel(_tmpTimer);
            $timeout.cancel(_startBroadcast);
        });
    };

    __this.dynamicPopover = {
        templateUrl: 'PulseFlowGroupByOptionPopoverTemplate.html'
    };
};

SupergraphController.$inject = ['$', '$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'datetimeService', 'openViewService', '$timeout', '$filter', '$element', 'timeLapseService', 'websocketService', 'SupergraphFactory', 'toaster', 'detectBrowserService', 'rangeSelectorService', 'SaveDesktopSettingService', 'debounceService', 'HOST', '$http'];
'use strict';

angular.module('mc.supergraph').component('supergraph', {
    controller: SupergraphController,
    templateUrl: 'ui/supergraph/supergraph-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
// mcapp.controller('untestedWetWellInputReportController', ['$scope', '$rootScope', '$filter', 'sharedSetupService', 'openViewService', 'datetimeService', 'authenticationService', 'translationService', '$element', 'savePdfService', function ($scope, $rootScope, $filter, sharedSetupService, openViewService, datetimeService, authenticationService, translationService, $element, savePdfService) {
//     sharedSetupService.getWindowId($scope);
//     $scope.myDate = null;
//     $scope.infiniteScrollOn = false;
//     $scope.infiniteScrollUpOn = false;
//     $scope.infiniteScrollDownOn = false;
//     $scope.checkFirstRowLiveStatus = null;
//     $scope.accountInfo = authenticationService.getAccountInfo();
//     $scope.languageID = $scope.accountInfo.preferenceUser.lookupLanguageID;
//     $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
//     $scope.unixDay = sharedSetupService.unixDay;
//     $scope.liveDataOffset = sharedSetupService.liveDataOffset;
//     $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
//     $scope.alerts = [];
//     $scope.oneTimeOnly = 0;
//     $scope.reverse = false;
//     $scope.translation = translationService.translation;
//     $scope.downloadViewTypeOptions = [0, 1, 2]; 

//     $scope.getIcon = function (varTitle, varMode) {
//         return sharedSetupService.getIcon(varTitle, varMode);
//     };

//     $scope.fnChangeLanguage = function () {
//         if ($scope.alerts.length > 0) {
//             var _msg = eval("$scope.translation.message." + $scope.untestedWetWellInputReportService.alerts[0].languageCode.toUpperCase());
//             var _type = $scope.untestedWetWellInputReportService.alerts[0].type;
//             var _languageCode = $scope.untestedWetWellInputReportService.alerts[0].languageCode;
//             $scope.untestedWetWellInputReportService.alerts = [];
//             $scope.untestedWetWellInputReportService.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
//         }
//     };

//     $scope.savePdf = function() {

//         var windowTitle =  $scope.windowTitle.toUpperCase().replace(/ /g, "_");
//         var pdfParams ={
//             windowTitle: windowTitle,
//             pdfTitle: (eval("$scope.translation.text." + windowTitle)),
//             customerName: $scope.accountInfo.customerName,
//             customerId: $scope.accountInfo.customerId,
//             dateTranslate: $scope.translation.text.DATE_CREATED,
//             dateRangeStart: $scope.myDateRangeStart,
//             dateRangeEnd: $scope.myDateRangeEnd, 
//             $scope: $scope,
//             $element: $element
//         }

//         savePdfService.savePDF(pdfParams);
//     };


//     if (!$rootScope.mobile && !$rootScope.classicView) {

//         $scope.popup = _this.getExistingDialog($scope.windowId).ref;
//         sharedSetupService.maximize($scope.popup);

//         $scope.popup.dialog({
//             resize: function (event, ui) {
//                 $scope.adjustSize();
//             }
//         });

//         $scope.popup.dialogExtend({
//             maximize: function (event, ui) {
//                 openViewService.adjustContentSizeStart($scope.popup);
//                 $scope.adjustSize();
//             },
//             restore: function (event, ui) {
// 				openViewService.adjustContentSizeStart($scope.popup);
//                 $scope.adjustSize();
//             }
//         });

//         $scope.adjustSize = function () {
//             $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
//             $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
//             $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
//             $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
//             $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
//         };
//     }

//     $scope.$on('updatePreferencesLanguage', function () {
//         $scope.languageID = $scope.accountInfo.preferenceUser.lookupLanguageID;
//         $scope.goSelectReportData();

//         //$scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
//         //  if ($scope.alerts.length > 0) {
//         //    var _msg = eval("scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
//         //    var _type = $scope.alerts[0].type;
//         //    var _languageCode = $scope.alerts[0].languageCode;
//         //    if (_languageCode.toUpperCase() === 'NO_DATA') {
//         //      _msg += ': ' + moment($scope.disabledInputReportService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.disabledInputReportService.end).utc().format('MM/DD/YY, h:mm:ss a');
//         //    }
//         //    $scope.alerts = [];
//         //    $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
//         //  }
//         //});
//     });

//     $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
//         $scope.timeFormat = preferredTimeFormat;
//         $scope.goSelectReportData();
//     });

// }]);

// mcapp.directive('drawUntestedWetWellInputReport', ['$timeout', 'untestedWetWellInputReportService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', '$filter', function ($timeout, untestedWetWellInputReportService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService, $filter) {
//     // return the directive link function. (compile function not needed)
//     return function (scope, element, attrs) {
//         scope.$ctrl = scope;
//         if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

//         var currentScrollbarPosition = 0;
//         var previousScrollbarPosition = 0;
//         var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
//         paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

//         element.on('scrollOff', function (event) {
//             var $rowFirst = element.contents().find("tr:first");
//             var $rowLast = element.contents().find("tr:last");
//             var _firstRow = $rowFirst.attr("name");
//             if (typeof $rowFirst.position() !== "undefined") {
//                 scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
//                 var _tableTop = element.offset().top;
//                 var _rowTop = $rowFirst.offset().top;
//                 _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
//                 previousScrollbarPosition = currentScrollbarPosition;
//                 currentScrollbarPosition = element[0].scrollTop;
//             }

//             if (scope.infiniteScrollOn === true) {
//                 scope.infiniteScrollUpOn = true;
//                 scope.infiniteScrollDownOn = true;

//                 if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
//                     //$rowLast.addClass("active-row");
//                     scope.untestedWetWellInputReportService.alerts = [];
//                     scope.untestedWetWellInputReportService.nextPage();
//                 }
//                 if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
//                     //$rowFirst.addClass("active-row");
//                     scope.untestedWetWellInputReportService.alerts = [];
//                     scope.untestedWetWellInputReportService.previousPage();
//                 }
//             }

//             var rows = element.children().children().children().children();
//             var scrollpos = 40;
//             var start = 0;
//             var end = rows.length;
//             var count = 0;

//             while (start != end) {
//                 count++;
//                 var mid = start + Math.floor((end - start) / 2);
//                 if ($(rows[mid]).position().top < scrollpos)
//                     start = mid + 1;
//                 else
//                     end = mid;
//             }
//             _updateZoom(parseFloat($($(rows[start])).attr("name")));
//         });

//         var _updateZoom = function (currentRow) {
//             if (isNaN(currentRow))
//                 return;

//             var zoomMin = currentRow - paddingZoom;
//             var zoomMax = currentRow + paddingZoom;

//             var dateMin = scope.stickyProperties.dateMin;
//             var dateMax = scope.stickyProperties.dateMax;

//             if (zoomMin < scope.stickyProperties.dateMin) {
//                 dateMin = zoomMin;
//             }
//             if (zoomMax > scope.stickyProperties.dateMax) {
//                 dateMax = zoomMax;
//             }

//             sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
//         };

//         scope.toggle = function ($event) {
//             if ($($event.currentTarget).hasClass("active-row")) {
//                 $($event.currentTarget).removeClass("active-row");
//             }
//             else {
//                 $($event.currentTarget).addClass("active-row");
//             }
//         };

//         scope.$watch('lastUpdateAt', function (newValue, oldValue) {
//             if (newValue && newValue != oldValue) {
//                 scope.liveDataIn = !scope.liveDataIn;
//                 $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
//             }
//         }, true);

//         scope.$watch('untestedWetWellInputReportService.alerts', function (newValue, oldValue) {
//             if (newValue && newValue.length > 0 && newValue != oldValue) {
//                 scope.alerts = newValue;
//             }
//         }, true);

//         scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
//             if (newValue && newValue != oldValue) {
//                 if (oldValue) {
//                     _unRegisterListener(oldValue);
//                 }
//             }
//         }, true);

//         scope.goSelectReportData = function () {
//             scope.alerts = [];
//             var numberOfDays = 30, varDateRangeStart, varDateRangeEnd, varDateRangeEndTmp;

//             if (new Date(scope.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeEnd)) && new Date(scope.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeStart))) {
//                 scope.myDateRangeEnd = (new Date(scope.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeEnd))) ? scope.myDateRangeEnd : new Date();
//                 scope.myDateRangeStart = (new Date(scope.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeStart))) ? scope.myDateRangeStart : new Date();
//                 varDateRangeEnd = scope.myDateRangeEnd;
//                 varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
//                 varDateRangeStart = scope.myDateRangeStart;
//                 varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
//             }
//             else {
//                 scope.myDateRangeEnd = new Date();
//                 scope.myDateRangeStart = new Date();
//                 scope.myDateRangeStart.setDate(scope.myDateRangeStart.getDate() - numberOfDays);

//                 varDateRangeEnd = new Date();
//                 varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
//                 ///////// needed to calculate varDateRangeStart
//                 varDateRangeEndTmp = new Date();
//                 varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
//                 ///////// needed to calculate varDateRangeStart
//                 varDateRangeStart = varDateRangeEndTmp - ((numberOfDays + 0) * scope.unixDay);
//             }
//             /////////////////////////////////////////////////////////////
//             currentScrollbarPosition = 0;
//             previousScrollbarPosition = 0;
//             scope.checkFirstRowLiveStatus = null;
//             /////////////////////////////////////////////////////////////
//             scope.untestedWetWellInputReportService = new untestedWetWellInputReportService();
//             scope.untestedWetWellInputReportService.customerId = scope.accountInfo.customerId;
//             scope.untestedWetWellInputReportService.languageId = scope.languageID;
//             scope.untestedWetWellInputReportService.timeZone = scope.accountInfo.timeZone;
//             scope.untestedWetWellInputReportService.timeFormat = scope.timeFormat;
//             scope.untestedWetWellInputReportService.deviceId = scope.deviceSelected;
//             scope.untestedWetWellInputReportService.windowTitle = scope.windowTitle;
//             scope.untestedWetWellInputReportService.startRow = 1;
//             scope.untestedWetWellInputReportService.pageSize = 50;
//             scope.untestedWetWellInputReportService.alerts = [];

//             if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) {
//                 scope.stickyProperties.on = true;
//                 scope.untestedWetWellInputReportService.start = varDateRangeStart;
//                 scope.untestedWetWellInputReportService.end = varDateRangeEnd;
//                 scope.untestedWetWellInputReportService.nextPage();
//             }
//             else {
//                 scope.stickyProperties.on = false;
//                 timeLapseService.getLocalDateTime().then(function (result) {
//                     /////////////////////////////////////////////////////////////
//                     var tmpDates = new Date(result.data.localDateTime);
//                     var tmpDatesA = tmpDates;
//                     tmpDates.setHours(0, 0, 0, 0);
//                     tmpDates = datetimeService.dateToUnixtime(tmpDates);
//                     tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
//                     tmpDates.startDate = tmpDates.startDate - (365 * scope.unixDay); //adjustment for report
//                     tmpDatesA.setHours(12, 0, 0, 0);
//                     tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
//                     /////////////////////////////////////////////////////////////
//                     scope.untestedWetWellInputReportService.start = varDateRangeStart;
//                     scope.untestedWetWellInputReportService.end = varDateRangeEnd;
//                     /////////////////////////////////////////////////////////////
//                     scope.untestedWetWellInputReportService.nextPage();
//                 });
//             }
//         };

//         var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
//             if (scope.checkFirstRowLiveStatus === true) {
//                 _checkTopOffset(liveDataStatusOn);
//             }
//             else if (scope.checkFirstRowLiveStatus === null) {
//                 timeLapseService.getLocalDateTime().then(function (result) {
//                     if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
//                         scope.checkFirstRowLiveStatus = true;
//                         _checkTopOffset(liveDataStatusOn);
//                     }
//                     else {
//                         scope.checkFirstRowLiveStatus = false;
//                     }
//                 });
//             }
//         };

//         var _checkTopOffset = function (liveDataStatusOn) {
//             if (liveDataStatusOn) {
//                 _registerListener(scope.deviceSelectedSn);
//             }
//             else {
//                 _unRegisterListener(scope.deviceSelectedSn);
//             }
//         };

//         var wsDataReceivedSIGNAL = function (data) {
//             var i = 0;
//             if (scope.liveData === false) {
//                 _unRegisterListener(scope.deviceSelectedSn);
//                 return;
//             }

//             var varTime = datetimeService.socketStrToServerStrTime(data.Time);
//             var varValue = parseInt(data.Value);
//             var _newMeasurements = { "localDateTime": varTime, "value": varValue };

//             scope.untestedWetWellInputReportService.items.unshift(_newMeasurements);
//             scope.lastUpdateAt = varTime;
//         };

//         var wsReconnectSIGNAL = function (data) {
//             if (scope.liveData === false) {
//                 _unRegisterListener(scope.deviceSelectedSn);
//                 return;
//             }
//             toaster.pop('success', scope.windowTitle + " -- " + scope.untestedWetWellInputReportService.siteName, 'View reloading');
//             scope.stickyProperties.on = true;
//             scope.untestedWetWellInputReportService.start = scope.stickyProperties.dateMin;
//             scope.untestedWetWellInputReportService.end = scope.stickyProperties.dateMax;
//             scope.untestedWetWellInputReportService.items = [];
//             scope.untestedWetWellInputReportService.numberOfReturnedRecords = -1;
//             scope.untestedWetWellInputReportService.startRow = 1;
//             scope.untestedWetWellInputReportService.pageSize = 10000;
//             scope.untestedWetWellInputReportService.windowTitle = scope.windowTitle;
//             sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.stickyProperties.deviceId, windowId: scope.windowId });
//             scope.untestedWetWellInputReportService.alerts = [];
//             scope.untestedWetWellInputReportService.nextPage();
//         };

//         var _registerListener = function (varSelectedSN) {
//             if (scope.liveData === true)
//                 return;
//             scope.liveData = true;
//             scope.untestedWetWellInputReportService.numberOfNewRecordsPrevious = -1;
//             websocketService.connect();
//             websocketService.register("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, wsReconnectSIGNAL);
//         };

//         var _unRegisterListener = function (varSelectedSN) {
//             if (scope.liveData === false)
//                 return;
//             scope.liveData = false;
//             scope.lastUpdateAt = undefined;
//             websocketService.unRegister("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, wsReconnectSIGNAL);
//         };

//         scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
//             //_autoScroll();
//             scope.checkFirstRowLiveStatus = null;
//         });

//         var _autoScroll = function () {
//             if (scope.untestedWetWellInputReportService.numberOfNewRecordsPrevious > 0) {
//                 var trRow = element.find('tr').eq(scope.untestedWetWellInputReportService.numberOfNewRecordsPrevious - 1);
//                 var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 10;
//                 element.scrollTop(yPosition);
//             }
//             else if (element[0].scrollTop <= 1)
//                 element.animate({
//                     scrollTop: element.scrollTop() + 10
//                 }, 500);
//         };

//         var orderBy = $filter('orderBy');
//         scope.order = function (predicate, reverse) {
//             switch (predicate) {
//                 case "deviceName":
//                 case "description":
//                 case "arivalDateTime":
//                     scope.input = reverse ? '-input' : 'input';
//                     scope.untestedWetWellInputReportService.items = orderBy(scope.untestedWetWellInputReportService.items, [predicate, scope.input], reverse);
//                     break;
//                 default:
//                     scope.untestedWetWellInputReportService.items = orderBy(scope.untestedWetWellInputReportService.items, predicate, reverse);
//                     break;
//             }
//             scope.predicate = predicate;
//         };

//         scope.setSorting = function () {
//             scope.order('deviceName', scope.reverse);
//         };

//         scope.goSelectReportData();

//         scope.mostRecentData = function () {
//             toaster.pop('success', scope.windowTitle + " -- " + scope.untestedWetWellInputReportService.siteName, 'View reloading');
//             scope.goSelectReportData();
//         }

//         scope.$on("$destroy", function () {
//             _unRegisterListener(scope.deviceSelectedSn);
//         });
//     };
// }]);

// mcapp.factory('untestedWetWellInputReportService', ['$http', 'datetimeService', 'toaster', 'userMessageService', 'translationService', 'REPORTS', '$filter', function ($http, datetimeService, toaster, userMessageService, translationService, REPORTS, $filter) {
//     var untestedWetWellInputReportService = function () {
//         this.items = [];
//         this.siteName = '';
//         this.customerId = null;
//         this.deviceId = null;
//         this.languageId = null;
//         this.timeFormat = null;
//         this.timeZone = null;
//         this.startRow = 1;
//         this.pageSize = 50;
//         this.start = '19000101';
//         this.end = '19000101';
//         this.busy = false;
//         this.numberOfReturnedRecords = -1;
//         this.numberOfNewRecordsPrevious = -1;
//         this.windowTitle = null;
//         this.alerts = [];
//         this.translation = translationService.translation;
//     };

//     untestedWetWellInputReportService.prototype.previousPage = function () {
//         if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
//         this.busy = true;
//         this.pageSize = -50;
//         var url = REPORTS + "/api/UntestedWetWellInputReport?customerId=" + this.customerId + "&timeZone=" + this.timeZone;
//         $http.get(url).then(function (result) {
//             /////////////////////////
//             var intDayWindow = 365;
//             var intDay = 86400000;
//             /////////////////////////
//             var items = result.data;
//             for (var i = 0; i < items.length; i++) {
//                 items[i].localDateTime = items[i].localDateTime;
//                 items[i].siteName = items[i].siteName;
//                 items[i].userName = items[i].userName;
//                 items[i].keyHex = items[i].keyHex;
//                 this.items.unshift(items[i]);
//             }
//             this.numberOfNewRecordsPrevious = items.length;
//             this.numberOfRecords = this.items.length;
//             this.startRow = this.startRow + items.length;
//             if (items.length > 0) { //if there are records returned
//                 this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
//                 this.end = datetimeService.toUnixtime(this.items[0].localDateTime.replace(/\D/g, ''));
//             }
//             this.pageSize = 50;
//             this.busy = false;
//         }.bind(this),function (error) {
//                 this.alerts = [];
//                 var errorMessage = eval("this.translation.message." + error.message);
//                 this.alerts.push({ msg: errorMessage, type: "danger" });
//                 this.pageSize = 50;
//                 this.busy = false;
//             }.bind(this));
//     };

//     untestedWetWellInputReportService.prototype.nextPage = function () {
//         if (this.busy || this.numberOfReturnedRecords === 0) return;
//         this.busy = true;
//         var url = REPORTS + "/api/UntestedWetWellInputReport?customerId=" + this.customerId + "&timeZone=" + this.timeZone;
//         $http.get(url).then(function (result) {
//             /////////////////////////
//             var intDayWindow = 365;
//             var intDay = 86400000;
//             /////////////////////////
//             var items = result.data;
//             for (var i = 0; i < items.length; i++) {
//                 delete items[i].customerId;
//                 delete items[i].deviceId;
//                 delete items[i].state;
//                 items[i].deviceName = items[i].deviceName;
//                 items[i].input = items[i].input;
//                 items[i].inputDescription = items[i].inputDescription != "" ? items[i].inputDescription : "- - -";
//                 items[i].enableTime = new Date(items[i].enableTime).getFullYear() > 1 ? $filter('date')(items[i].enableTime, this.timeFormat) : this.translation.text.INDEFINITELY;
//                 this.items.push(items[i]);
//             }
//             this.numberOfReturnedRecords = items.length;
//             this.startRow = this.startRow + items.length;
//             if (items.length > 0) { //if there are records returned
//                 //
//             }
//             else {
//                 this.alerts = [];
//                 var errorMessage = this.translation.text.NO_UNTESTED_WET_WELL;
//                 this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_UNTESTED_WET_WELL' });
//             }
//             this.pageSize = 50;
//             this.busy = false;
//         }.bind(this), function (error) {
//                 this.alerts = [];
//                 var errorMessage = eval("this.translation.message." + error.message);
//                 this.alerts.push({ msg: errorMessage, type: "danger" });
//                 this.pageSize = 50;
//                 this.busy = false;
//             }.bind(this));
//     };

//     return untestedWetWellInputReportService;
// }]);


"use strict";

angular.module("mc.untested-wet-well-input-report", []);
'use strict';

function UntestedWetWellInputReportFactory(HOST, $http, translationService, REPORTS, $filter) {
    var untestedWetWellInputReportService = function untestedWetWellInputReportService() {
        this.items = [];
        this.siteName = '';
        this.customerId = null;
        this.deviceId = null;
        this.languageId = null;
        this.timeFormat = null;
        this.timeZone = null;
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.windowTitle = null;
        this.alerts = [];
        this.translation = translationService.translation;
    };

    // previousPage = function () {
    //     if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
    //     this.busy = true;
    //     this.pageSize = -50;
    //     var url = REPORTS + "/api/UntestedWetWellInputReport?customerId=" + this.customerId + "&timeZone=" + this.timeZone;
    //     $http.get(url).then(function (result) {
    //         /////////////////////////
    //         var intDayWindow = 365;
    //         var intDay = 86400000;
    //         /////////////////////////
    //         var items = result.data;
    //         for (var i = 0; i < items.length; i++) {
    //             items[i].localDateTime = items[i].localDateTime;
    //             items[i].siteName = items[i].siteName;
    //             items[i].userName = items[i].userName;
    //             items[i].keyHex = items[i].keyHex;
    //             this.items.unshift(items[i]);
    //         }
    //         this.numberOfNewRecordsPrevious = items.length;
    //         this.numberOfRecords = this.items.length;
    //         this.startRow = this.startRow + items.length;
    //         if (items.length > 0) { //if there are records returned
    //             this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
    //             this.end = datetimeService.toUnixtime(this.items[0].localDateTime.replace(/\D/g, ''));
    //         }
    //         this.pageSize = 50;
    //         this.busy = false;
    //     }.bind(this),function (error) {
    //             this.alerts = [];
    //             var errorMessage = eval("this.translation.message." + error.message);
    //             this.alerts.push({ msg: errorMessage, type: "danger" });
    //             this.pageSize = 50;
    //             this.busy = false;
    //         }.bind(this));
    // };

    var _getData = function _getData(customerId, timeZone) {
        return $http({
            method: 'Get',
            url: REPORTS + "/api/UntestedWetWellInputReport?customerId=" + customerId + "&timeZone=" + timeZone,
            cache: false
        });
    };

    untestedWetWellInputReportService.getData = _getData;

    return untestedWetWellInputReportService;
}

UntestedWetWellInputReportFactory.$inject = ['HOST', '$http', 'translationService', 'REPORTS', '$filter'];

angular.module('mc.untested-wet-well-input-report').factory('UntestedWetWellInputReportFactory', UntestedWetWellInputReportFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function UntestedWetWellInputReportController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, UntestedWetWellInputReportFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, savePdfService, toaster, textToSpeechService, websocketService, timeLapseService) {
    var ctrl = this;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        ctrl.reverse = false;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.languageID = ctrl.accountInfo.preferenceUser.lookupLanguageID;
        $scope.languageID = ctrl.languageID;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        ctrl.alerts = [];
        $scope.alerts = [];
        ctrl.items = [];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        ctrl.goSelectReportData(false);
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.busy = true;

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });
            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
            ctrl.adjustSize = function () {
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }

        ctrl.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        ctrl.fnChangeLanguage = function () {
            if ($scope.alerts.length > 0) {
                var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        };
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.languageID = ctrl.accountInfo.preferenceUser.lookupLanguageID;
        ctrl.goSelectReportData();

        // $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
        //  if ($scope.alerts.length > 0) {
        //    var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
        //    var _type = $scope.alerts[0].type;
        //    var _languageCode = $scope.alerts[0].languageCode;
        //    if (_languageCode.toUpperCase() === 'NO_DATA') {
        //      _msg += ': ' + moment(ctrl.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.end).utc().format('MM/DD/YY, h:mm:ss a');
        //    }
        //    $scope.alerts = [];
        //    $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        //  }
        // });
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        $scope.timeFormat = preferredTimeFormat;
        ctrl.goSelectReportData();
    });

    $scope.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.goSelectReportData();
    };

    ctrl.goSelectReportData = function () {
        ctrl.busy = true;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        $scope.alerts = [];
        ctrl.items = [];
        ctrl.stickyProperties.on = false;
        UntestedWetWellInputReportFactory.getData(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone).then(function (dataFromFactory) {
            $scope.alerts = [];
            ctrl.items = dataFromFactory.data;
            // If we didn't get any items back 
            if (ctrl.items.length === 0) {
                $scope.alerts = [];
                var errorMessage = ctrl.translation.text.NO_UNTESTED_WET_WELL;
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_UNTESTED_WET_WELL' });
            }
            ctrl.busy = false;
        }, function (error) {
            $scope.alerts = [];
            var errorMessage = eval("$scope.translation.message." + error.message);
            $scope.alerts.push({ msg: errorMessage, type: "danger" });
            ctrl.pageSize = 50;
            ctrl.busy = false;
        }).then(function (data) {
            ctrl.loadingInProgress = false;
            ctrl.busy = false;
        });
    };

    ctrl.savePdf = function () {
        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: ctrl.translation.text.DISABLED_INPUTS_REPORT,
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };
        savePdfService.savePDF(pdfParams);
    };

    $scope.toggle = function ($event) {
        if ($($event.currentTarget).hasClass("active-row")) {
            $($event.currentTarget).removeClass("active-row");
        } else {
            $($event.currentTarget).addClass("active-row");
        }
    };

    $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            ctrl.liveDataIn = !ctrle.liveDataIn;
            $timeout(function () {
                ctrl.liveDataIn = !ctrl.liveDataIn;
            }, 3000);
        }
    }, true);

    $scope.$watch('$ctrl.alerts', function (newValue, oldValue) {
        if (newValue && newValue.length > 0 && newValue != oldValue) {
            ctrl.alerts = newValue;
        }
    }, true);

    var orderBy = $filter('orderBy');
    ctrl.order = function (predicate, reverse) {
        switch (predicate) {
            case "deviceName":
            case "description":
            case "arivalDateTime":
                ctrl.input = reverse ? '-input' : 'input';
                ctrl.items = orderBy(ctrl.items, [predicate, ctrl.input], reverse);
                break;
            default:
                ctrl.items = orderBy(ctrl.items, predicate, reverse);
                break;
        }
        ctrl.predicate = predicate;
    };

    ctrl.setSorting = function () {
        ctrl.order('deviceName', ctrl.reverse);
    };
}

UntestedWetWellInputReportController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'UntestedWetWellInputReportFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', 'savePdfService', 'toaster', 'textToSpeechService', 'websocketService', 'timeLapseService'];
'use strict';

angular.module('mc.untested-wet-well-input-report').component('untestedWetWellInputReport', {
    controller: UntestedWetWellInputReportController,
    templateUrl: 'ui/untestedwetwellinput/untested-wet-well-input-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.two-factor-authentication', []);
'use strict';

function TwoFactorAuthenticationFactory(HOST, $http) {

    // instantiate our initial object
    var TwoFactorAuthenticationService = function TwoFactorAuthenticationService(customerId) {
        this.customerId = customerId;
    };

    TwoFactorAuthenticationService.prototype.generateSecret = function () {
        var self = this;
        return $http.get(HOST + '/api/TwoFactorAuthentication/GenerateSecret' + '?customerId=' + this.customerId).then(function (response) {
            self.secretKey = response.data;
            self.loading = false;
            return response;
        });
    };

    TwoFactorAuthenticationService.prototype.verifyCode = function (secret2FA, authenticatorCode) {
        var self = this;
        return $http.get(HOST + '/api/TwoFactorAuthentication/VerifyCode' + '?customerId=' + this.customerId + '&secret2FA=' + secret2FA + '&authenticatorCode=' + authenticatorCode).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    TwoFactorAuthenticationService.prototype.updateSecret = function (updated2FASecret, accountWorkflow) {
        var self = this;
        return $http.put(HOST + '/api/TwoFactorAuthentication/UpdateSecret' + '?customerId=' + this.customerId + '&updated2FASecret=' + updated2FASecret + '&accountWorkflow=' + accountWorkflow).then(function (response) {
            //self.newDestination = response.data;
            self.loading = false;
            return response;
        });
    };

    TwoFactorAuthenticationService.prototype.deleteSecret = function () {
        var self = this;
        return $http.delete(HOST + '/api/TwoFactorAuthentication/DeleteSecret' + '?customerId=' + this.customerId).then(function (response) {
            self.dataBack = response.data;
            self.loading = false;
            return response;
        });
    };

    return TwoFactorAuthenticationService;
}

TwoFactorAuthenticationFactory.$inject = ['HOST', '$http'];

angular.module('mc.two-factor-authentication').factory('TwoFactorAuthenticationFactory', TwoFactorAuthenticationFactory);
"use strict";

angular.module("mc.toaster-message-timestamp", []);
'use strict';

function ToasterMessageTimestampFactory(HOST, $http) {

    var GetExistingRecord = function GetExistingRecord(customerId, loginId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/ToasterMessageTimestamp/',
            params: { customerId: customerId, loginId: loginId }
        });
    };

    var InsertNewRecord = function InsertNewRecord(customerId, loginId, email, twitterNotificationDate) {
        return $http({
            method: 'POST',
            url: HOST + '/api/ToasterMessageTimestamp/',
            params: { customerId: customerId, loginId: loginId, email: email, twitterNotificationDate: twitterNotificationDate }
        });
    };

    var UpdateExistingRecord = function UpdateExistingRecord(customerId, loginId, twitterNotificationDate) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/ToasterMessageTimestamp/',
            params: { customerId: customerId, loginId: loginId, twitterNotificationDate: twitterNotificationDate }
        });
    };

    return {
        GetExistingRecord: GetExistingRecord,
        InsertNewRecord: InsertNewRecord,
        UpdateExistingRecord: UpdateExistingRecord
    };
}

ToasterMessageTimestampFactory.$inject = ['HOST', '$http'];

angular.module('mc.toaster-message-timestamp').factory('ToasterMessageTimestampFactory', ToasterMessageTimestampFactory);
mcapp.controller("temperatureWidgetController", ["$scope", "$rootScope", "authenticationService", "translationService", "sharedSetupService", "$element",
    function ($scope, $rootScope, authenticationService, translationService, sharedSetupService, $element) {
        $scope.liveData = true;
        $scope.Channel = [];


        $scope.alerts = [];
        $scope.translation = translationService.translation;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.preferencesMeasurement = $scope.accountInfo.preferenceUser.lookupMeasurementID !== 2 ? 1 : 2;

        sharedSetupService.getWindowId($scope);

        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (typeof $scope.stickyProperties != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        $scope.setSetting = function () {
            $scope.deviceSelectedId = { "deviceId": $scope.stickyProperties.device.deviceId };
            $scope.preSerialNumber = $scope.stickyProperties.device.serialNumber;
        };

        $scope.setSetting();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            $scope.closeWidget = function () {
                $element.find(".flip-container").hide();
                $scope.popup.dialog("close");
            };

            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.resizeContent();
                    $scope.$apply();
                }
            });

            $scope.resizeContent = function () {
                if (!$element.find(".widgetNew"))
                    return;
                var _newWidth = $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "");
                var _newHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $element.find('.widgetSettingNew').css("width", _newWidth < 240 ? 240 : _newWidth)
                    .css("margin-left", _newWidth < 240 ? -(240 - _newWidth) / 2 : "auto");
                $scope.popup.parent().find("svg[id^='raphael-paper']").css("background-color", "rgb(255, 255, 255, 0)");
                var _fontSize = (_newWidth < _newHeight) && (_newHeight < 150) ? _newWidth / 12 : _newHeight / 12;
                _fontSize = _fontSize < 12 ? 12 : _fontSize > 35 ? 35 : _fontSize;
                if ($scope.tempchart !== null)
                    $scope.tempchart.setChartAttribute({
                        baseFontSize: _fontSize,
                        outCnvBaseFontSize: _fontSize - 6
                    });
                //$scope.tempchart.resizeTo(_newWidth, _newHeight - 5);
            };
        } else {
            $scope.popup = $(".flip-container");
            $scope.resizeContent = function () {
                if (!$element.find(".widgetNew"))
                    return;
                var _fontSize = 25;

                if (!angular.isUndefined($scope.tempchart) && $scope.tempchart !== null)
                    $scope.tempchart.setChartAttribute({
                        baseFontSize: _fontSize,
                        outCnvBaseFontSize: _fontSize - 10
                    });
            }
        }

        var timer;
        var firstover = true;

    }]);

mcapp.directive('temperatureWidgetDirective', ["authenticationService", "websocketService", "temperatureGaugeService", "deviceService", "toaster", "$filter", "$document", "sharedSetupService",
    function (authenticationService, websocketService, temperatureGaugeService, deviceService, toaster, $filter, $document, sharedSetupService) {
        function link($scope, $element, attrs) {
            $scope.chartId = "thermometer" + Math.floor((Math.random() * 10000) + 1);
            $scope.getData = function (deviceID) {
                temperatureGaugeService.getData('customerID=' + $scope.accountInfo.customerId + '&deviceID=' + deviceID)
                    .then(function (datafromFactory) {
                        $scope.alerts = [];
                        $scope.device = datafromFactory.data.device;
                        $scope.devicename = datafromFactory.data.device.name;

                        $scope.title = datafromFactory.data.gauges[0].name;
                        $scope.gaugeMinVal = datafromFactory.data.gauges[0].setting[0].value;
                        $scope.gaugeMaxVal = datafromFactory.data.gauges[0].setting[1].value;
                        $scope.currentDateTime = datafromFactory.data.gauges[0].currentData !== null ? datafromFactory.data.gauges[0].currentData.localDateTime : null;
                        $scope.currentValue = datafromFactory.data.gauges[0].currentData !== null ? datafromFactory.data.gauges[0].currentData.value : null;

                        var _device = { deviceId: $scope.device.deviceId, channel: 0, serialNumber: $scope.device.serialNumber };
                        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.device.deviceId, device: _device, windowId: $scope.windowId });
                        if ($scope.popup.selector !== ".flip-container") $scope.popup.dialog("option", "title", $scope.device.name);
                        $scope.deviceSelectedName = $scope.device.name;
                        if (datafromFactory.data.gauges[0].currentData == null) {
                            if ($scope.tempchart) {
                                $scope.tempchart.dispose();
                                $scope.tempchart = null;
                            }
                            $scope.alerts.push({ msg: $scope.translation.message.NO_DATA, type: "info" });
                        }
                        else {
                            websocketService.connect();
                            websocketService.register("TEMPERATURE", $scope.device.serialNumber, '', wsDataReceivedWT, wsReconnectWT);
                            $scope.liveData = true;
                            _drawGaugeTemp();
                        }

                    }).then(function () {
                        //$scope.resizeContent();
                    });
            };

            var _drawGaugeTemp = function () {

                $scope.tempchart = new FusionCharts({

                    type: 'thermometer',
                    renderAt: $scope.chartId,
                    width: '100%',
                    height: '100%',
                    dataFormat: 'json',
                    dataSource: {
                        "chart": {
                            // "caption": Central cold storag,
                            "baseFont": "Roboto",
                            "showToolTip": 0,
                            "manageResize": 1,
                            "autoScale": 1,
                            "decimals": 0,
                            "lowerLimit": $scope.preferencesMeasurement === 1 ? 0 : -10,
                            "upperLimit": $scope.preferencesMeasurement === 1 ? 120 : 50,
                            "majorTMNumber": 7,
                            "numberSuffix": $scope.preferencesMeasurement === 1 ? " °F" : " °C",
                            "valueFontColor": ($scope.popup.selector !== ".flip-container") ? "#ffffff" : "#000000",
                            "gaugeBorderColor": ($scope.popup.selector !== ".flip-container") ? "#ffffff" : "#000000",
                            "thmFillColor": "#ff0000",
                            "canvasBgAlpha": "0",
                            "legendBgAlpha": "0",
                            "borderAlpha": "0",
                            "bgAlpha": "0,0",
                            "majorTMColor": ($scope.popup.selector !== ".flip-container") ? "#ffffff" : "#000000",
                            "minorTMColor": ($scope.popup.selector !== ".flip-container") ? "#ffffff" : "#000000",
                            "baseFontColor": ($scope.popup.selector !== ".flip-container") ? "#ffffff" : "#000000",
                            "animation": 0
                        },
                        "value": $scope.preferencesMeasurement === 1 ? (9 / 5) * $scope.currentValue + 32 : $scope.currentValue
                    }
                }).render();
                $scope.tempchart.setTransparent(true);
                $scope.popup.parent().find("svg[id^='raphael-paper']").css("background-color", "rgb(255, 255, 255, 0)");
                $scope.resizeContent();
            };

            $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
                $scope.preferencesMeasurement = measurementSystem;
                _drawGaugeTemp();
            });

            var wsDataReceivedWT = function (data) {
                if ($scope.device.serialNumber === data.SN) {
                    $scope.currentValue = parseFloat(data.Value);
                    if ($scope.tempchart !== undefined || $scope.tempchart !== null) {
                        $scope.tempchart.setData($scope.preferencesMeasurement === 1 ? (9 / 5) * $scope.currentValue + 32 : $scope.currentValue);
                    }
                }
            };

            $scope.mostRecentData = function () {
                toaster.pop('success', "Temperature Widget" + " -- " + $scope.deviceSelectedName, 'View reloading');
                $scope.getData($scope.deviceSelectedId.deviceId);
            }

            var wsReconnectWT = function (data) {
                $scope.getData($scope.deviceSelected);
            };

            $scope.isTouchSupported = function () {
                var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
                var generalTouchEnabled = "ontouchstart" in document.createElement("div");

                if (msTouchEnabled || generalTouchEnabled) {
                    return true;
                }
                return false;
            };

            $scope.getData($scope.deviceSelectedId.deviceId);
            if ($scope.popup.selector !== ".flip-container") $scope.popup.dialog("option", "dialogClass", "ui-widget-content-new");

            $scope.replaceSpaces = function (str) {
                return str.replace(/ /g, '_');
            };

            $scope.$on('document_click', function (e, event) {
                var $tgt = $(event.target);
                if ($tgt.closest('#temperature-widget-' + $scope.replaceSpaces($scope.windowId)).length === 0 || ($tgt.closest('.back').length === 0 && $tgt.closest('.front').length === 0)) {

                    if ($scope.isTouchSupported()) {
                        $scope.popup.parent().find(".front").toggle(true);
                        $scope.popup.parent().find(".back").toggle(false);
                    } else {
                        $('#temperature-widget-' + $scope.replaceSpaces($scope.windowId)).offsetParent().offsetParent().find('.flip-container').toggleClass('flip', false);
                    }

                    $scope.setSetting();
                }
            });

            $scope.popup.parent().on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            if ($scope.popup.parent().is('.ui-draggable-dragging, .ui-resizable-resizing') || event.target.nodeName === 'SELECT') {
                                return;
                            }

                            if ($scope.isTouchSupported()) {
                                $scope.popup.parent().find(".back").toggle();
                                $scope.popup.parent().find(".front").toggle();
                            } else {
                                $scope.popup.parent().find('.flip-container').toggleClass('flip');
                            }

                            $scope.setSetting();
                        }
                    );
                }
            );

            $scope.popup.parent().find("select").on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            );

            $scope.popup.parent().on(
                "mouseover",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            $scope.popup.parent().addClass("x-resize");
                            $scope.closeIcon = true;
                        }
                    );
                }
            );

            $scope.popup.parent().on(
                "mouseout",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            $scope.popup.parent().removeClass("x-resize");
                            if ($scope.isTouchSupported()) {
                                setTimeout(function () {
                                    $scope.closeIcon = false;
                                }, 3000);
                            }
                            else {
                                $scope.closeIcon = false;
                            }
                        }
                    );
                }
            );

            $scope.$on(
                "$destroy",
                function (event) {
                    websocketService.unRegister("TEMPERATURE", $scope.serialNumber, '', wsDataReceivedWT, wsReconnectWT);
                    $scope.popup.parent().off();
                    $scope.popup.parent().find("select").off();
                    if ($scope.tempchart && $scope.tempchart.dispose) {
                        $scope.tempchart.dispose();
                        $scope.tempchart = null;
                    }
                }
            );
        }
        return {
            link: link
        };

    }
]);

mcapp.directive('temperatureSettingDirective', ["authenticationService", "websocketService", "deviceMenuService", "deviceService", "toaster",
    function (authenticationService, websocketService, deviceMenuService, deviceService, toaster) {
        function link(scope, element, attrs) {
            scope.notfirst = false;
            deviceMenuService.getDeviceMenuList(scope.accountInfo.customerId)
                .then(function (result) {
                    scope.Devices = result.data.devices;
                }, function (error) {
                });

            scope.focus = function () {
                $(element).find('.btn-primary').focus();
                $(element).find('.devicesdl').focus();
            };

            scope.focusChannel = function () {
                $(element).find('.btn-primary').focus();
                $(element).find('.channeldl').focus();
            };

            scope.getBackToTemperatureData = function (DeviceID) {

                if (DeviceID != null)
                    scope.getData(DeviceID);
                scope.popup.parent().find('.flip-container').toggleClass('flip');
                if (scope.isTouchSupported()) {
                    scope.popup.parent().find(".back").toggle();
                    scope.popup.parent().find(".front").toggle();
                }
            };


        }
        return {
            link: link
        };
    }
]);

mcapp.controller('temperatureDataController', ['$scope', '$rootScope', 'translationService', 'sharedSetupService', 'openViewService', '$element', 'authenticationService', function ($scope, $rootScope, translationService, sharedSetupService, openViewService, $element, authenticationService) {
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.preferredMeasurementFormat = $scope.accountInfo.preferenceUser.lookupMeasurementID;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
    $scope.translation = translationService.translation;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.alerts = [];

    sharedSetupService.broadcastAllDeviceSelected($scope);

    sharedSetupService.getWindowId($scope);
    $scope.liveTable = $element.find(".headertable");

    $scope.liveDataLine = function (varLiveData) {
        if (varLiveData) {
            $scope.liveTable.addClass("live-data-line");
        } else {
            $scope.liveTable.removeClass("live-data-line");
        }
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
        $scope.updateLanguage();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        $scope.updateLanguage();
    });

    $scope.updateLanguage = function () {
        $scope.temperatureDataService.items = angular.copy($scope.temperatureDataService.items);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);
        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
				openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            //$scope.adjustDeviceIdMenuSize();
        };

        $scope.adjustDeviceIdMenuSize = function () {
            var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")
            if (spph < 450) {
                $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            }
            else {
                $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        };
    }
}]);

mcapp.directive('drawTemperatureData', ['$rootScope', '$timeout', 'temperatureDataService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', function ($rootScope, $timeout, temperatureDataService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;
        scope.downloadViewTypeOptions = [0, 4];
        scope.trgScroll = function () {
            $timeout(function () {
                var $rowFirst = element.contents().find("tr:first");
                var _firstRow = $rowFirst.attr("name");
                if (typeof $rowFirst.position() !== "undefined") {
                    var _tableTop = element.offset().top;
                    var _rowTop = $rowFirst.offset().top;
                    _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
                }
            }, 0);
        }

        scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
          if (scope.alerts.length > 0) {
            var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
            var _type = scope.alerts[0].type;
            var _languageCode = scope.alerts[0].languageCode;
            if (_languageCode.toUpperCase() === 'NO_DATA') {
              _msg += ': ' + moment(scope.temperatureDataService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.temperatureDataService.end).utc().format('MM/DD/YY, h:mm:ss a');
            }
            scope.alerts = [];
            scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
          }
        });

        element.on('scroll', function (event) {
            var $rowFirst = element.contents().find("tr:first");
            var $rowLast = element.contents().find("tr:last");
            if (typeof $rowFirst.position() !== "undefined") {
                scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
                scope.trgScroll();
                previousScrollbarPosition = currentScrollbarPosition;
                currentScrollbarPosition = element[0].scrollTop;
            }

            if (scope.infiniteScrollOn === true) {
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;

                if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
                    $rowLast.addClass("active-row");
                    scope.temperatureDataService.alerts =[];
                    scope.temperatureDataService.nextPage();
                }
                if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
                    $rowFirst.addClass("active-row");
                    scope.temperatureDataService.alerts =[];
                    scope.temperatureDataService.previousPage();
                }
            }

            var rows = element.children().children().children().children();
            var scrollpos = 40;
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos)
                    start = mid + 1;
                else
                    end = mid;
            }
            _updateZoom(parseFloat($($(rows[start])).attr("name")));
        });

        var _updateZoom = function (currentRow) {
            if (isNaN(currentRow))
                return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            }
            else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('temperatureDataService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        scope.newTemperatureTableService = function () {
            scope.temperatureDataService = new temperatureDataService();
            scope.temperatureDataService.customerId = scope.accountInfo.customerId;
			scope.temperatureDataService.timeZone = scope.accountInfo.timeZone;
            scope.temperatureDataService.deviceId = scope.deviceSelected;
            scope.temperatureDataService.windowTitle = scope.windowTitle;
            scope.temperatureDataService.startRow = 1;
            scope.temperatureDataService.pageSize = 50;
        };

        var _openTableInLiveMode = function () {
            scope.stickyProperties.on = false;
            timeLapseService.getLocalDateTime().then(function (result) {
                /////////////////////////////////////////////////////////////
                var tmpDates = new Date(result.data.localDateTime);
                var tmpDatesA = tmpDates;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
                tmpDatesA.setHours(23, 59, 59, 0);
                tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
                /////////////////////////////////////////////////////////////
                scope.newTemperatureTableService();
                scope.temperatureDataService.start = tmpDates.startDate;
                scope.temperatureDataService.end = tmpDatesA;
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
                scope.temperatureDataService.nextPage();
                /////////////////////////////////////////////////////////////
            });
        }

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                /////////////////////////////////////////////////////////////
                currentScrollbarPosition = 0;
                previousScrollbarPosition = 0;
                scope.checkFirstRowLiveStatus = null;
                /////////////////////////////////////////////////////////////
                scope.alerts = [];
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });

                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMin !== null) {
                    scope.stickyProperties.on = true;
                    timeLapseService.getLocalDateTime().then(function (result) {
                        if (scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && scope.stickyProperties.zoomMax + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                            scope.newTemperatureTableService();
                            scope.temperatureDataService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
                            scope.temperatureDataService.end = scope.stickyProperties.dateMax;
                            scope.temperatureDataService.nextPage();
                        }
                        else {
                            scope.newTemperatureTableService();
                            scope.temperatureDataService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
                            scope.temperatureDataService.end = Math.round((scope.stickyProperties.zoomMax + scope.stickyProperties.zoomMin) / 2);
                            scope.temperatureDataService.nextPage();
                        }
                    });
                }
                else {
                    _openTableInLiveMode();
                }
            }
        }, true);

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.stickyProperties.device.serialNumber = newValue;
                if (oldValue) {
                    _unRegisterListener(oldValue);
                }
            }
        }, true);

        scope.selectMyDate = function (date) {
            scope.myDate = date;
            scope.temperatureDataService = new temperatureDataService();
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            _unRegisterListener(scope.deviceSelectedSn);
            /////////////////////////////////////////////////////////////
            var tmpDates = scope.myDate;
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
            tmpDatesA.setHours(12, 0, 0, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            scope.temperatureDataService.start = tmpDates.startDate;
            if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                scope.temperatureDataService.end = tmpDatesA;
            }
            else {
                scope.temperatureDataService.end = tmpDates.endDate;
            }
            /////////////////////////////////////////////////////////////
            scope.temperatureDataService.startRow = 1;
            scope.temperatureDataService.pageSize = 50;
            scope.temperatureDataService.customerId = scope.accountInfo.customerId;
			scope.temperatureDataService.timeZone = scope.accountInfo.timeZone;
            scope.temperatureDataService.deviceId = scope.deviceSelected;
            scope.temperatureDataService.windowTitle = scope.windowTitle;
            scope.alerts = [];
            scope.temperatureDataService.nextPage();
            /////////////////////////////////////////////////////////////
            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
        };

        var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            }
            else if (scope.checkFirstRowLiveStatus === null) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.checkFirstRowLiveStatus = true;
                        _checkTopOffset(liveDataStatusOn);
                    }
                    else {
                        scope.checkFirstRowLiveStatus = false;
                    }
                });
            }
        };

        var _checkTopOffset = function (liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListener(scope.deviceSelectedSn);
            }
            else {
                _unRegisterListener(scope.deviceSelectedSn);
            }
        };

        var wsDataReceivedTEMPERATURE = function (data) {
            var i = 0;
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            var varValue = parseInt(data.Value);
            var _newMeasurements = { "localDateTime": varTime, "value": Math.round((9 / 5) * varValue + 32) };

            scope.temperatureDataService.end = datetimeService.toUnixtime(data.Time) + scope.unixDay;

            scope.temperatureDataService.items.unshift(_newMeasurements);
            scope.lastUpdateAt = varTime;
        };

        scope.$on('processReconnect', function (event, args) {
            scope.reconnectData(event, args);
        });

        scope.reconnectData = function (event, args) {
            sharedSetupService.processReconnect({
                stickyProperties: scope.stickyProperties,
                localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
                dateRangeOption: null,
                windowTitle: scope.windowTitle,
                fnUnregister: _unRegisterListener,
                fnGetData: _openTableInLiveMode,
                viewType: "Table"
            });
        }

        scope.mostRecentData = function (event, args) {
            scope.stickyProperties.liveData = true;
            scope.myDate = null;
            scope.reconnectData(event, args);
        }

        var _registerListener = function (varSelectedSN) {
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
            scope.liveData = true;
            scope.liveDataLine(scope.liveData);
            scope.temperatureDataService.numberOfNewRecordsPrevious = -1;
            websocketService.connect();
            websocketService.register("TEMPERATURE", varSelectedSN, "", wsDataReceivedTEMPERATURE, null);
        };

        var _unRegisterListener = function (varSelectedSN) {
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
            if (scope.liveData === false)
                return;
            scope.liveData = false;
            scope.liveDataLine(scope.liveData);
            scope.lastUpdateAt = undefined;
            websocketService.unRegister("TEMPERATURE", varSelectedSN, "", wsDataReceivedTEMPERATURE, null);
        };

        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll();
            scope.checkFirstRowLiveStatus = null;
            scope.trgScroll();
        });

        var _autoScroll = function () {
            if (scope.temperatureDataService.numberOfNewRecordsPrevious > 0) {
                var trRow = element.find('tr').eq(scope.temperatureDataService.numberOfNewRecordsPrevious -1);
                var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
                element.scrollTop(yPosition);
            }
            else {
                $timeout(function () {
                    element.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            scope.preferredMeasurementFormat = parseInt(measurementSystem);
            scope.temperatureDataService.items = angular.copy(scope.temperatureDataService.items);
        });

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
        });
    };
}]);

mcapp.factory('temperatureDataService', ['$http', 'datetimeService', 'toaster', 'userMessageService', 'translationService', 'HOST', function ($http, datetimeService, toaster, userMessageService, translationService, HOST) {
    var temperatureDataService = function () {
        this.items = [];
        this.deviceName = '';
        this.unit = '';
        this.customerId = null;
		this.timeZone = "Z";
        this.deviceId = null;
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.windowTitle = null;
        this.alerts =[];
        this.translation = translationService.translation;
		this.scrollUp = "";
        this.scrollDown = "";
    };

    temperatureDataService.prototype.previousPage = function () {
        if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
        this.busy = true;
        this.pageSize = -50;
        
		//from is: very top record
		var url = HOST + "/api/TemperatureTable?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end + "&fromDate=" + this.scrollUp + "&timeZone=" + this.timeZone;
        $http.get(url)
            .then(function (result) {
                    /////////////////////////
                    var intDayWindow = 10;
                    var intDay = 86400000;
                    /////////////////////////
                    var deviceName = result.data.device.name;
                    var unit = result.data.setting.unit === 0 ? "C" : "F";
                    this.unit = unit;
                    var items = result.data.data.measurements;
                    for (var i = 0; i < items.length; i++) {
                        items[i].localDateTime = items[i].localDateTime;
                        items[i].value = items[i].value;
                        this.items.unshift(items[i]);
                    }
                    this.numberOfNewRecordsPrevious = items.length;
                    this.numberOfRecords = this.items.length;
                    this.deviceName = deviceName;
                    this.startRow = this.startRow + items.length;
                    if (items.length > 0) { //if there are records returned
                        this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                        this.end = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
                    }

		            if (this.items.length > 0) {
                        this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
                        this.scrollDown = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localDateTime.replace(/\D/g, ''));
		            } else {
		                this.scrollUp = "";
		                this.scrollDown = "";
		            }

                    this.pageSize = 50;
                    this.busy = false;
                }.bind(this),function (error) {
                        this.alerts =[];
                        var errorMessage = eval("this.translation.message." + error.message);
                        this.alerts.push({ msg: errorMessage, type: "danger"});
                        this.pageSize = 50;
                    	this.busy = false;
                }.bind(this));
    };

    temperatureDataService.prototype.nextPage = function () {
        if (this.busy || this.numberOfReturnedRecords === 0) return;
        this.busy = true;
        //from is: very bottom record
		var url = HOST + "/api/TemperatureTable?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end + "&fromDate=" + this.scrollDown + "&timeZone=" + this.timeZone;
        $http.get(url)
            .then(function (result) {
                    /////////////////////////
                    var intDayWindow = 10;
                    var intDay = 86400000;
                    /////////////////////////
                    var deviceName = result.data.device.name;
                    var unit = result.data.setting.unit === 0 ? "C" : "F";
                    this.unit = unit;
                    var items = result.data.data.measurements;
                    for (var i = 0; i < items.length; i++) {
                        items[i].localDateTime = items[i].localDateTime;
                        items[i].value = items[i].value;
                        this.items.push(items[i]);
                    }
                    this.numberOfReturnedRecords = items.length;
                    this.deviceName = deviceName;
                    this.startRow = this.startRow + items.length;
                    if (items.length > 0) { //if there are records returned
                        this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                        this.end = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
                    }
                    else {
                      // If we didn't get any items back AND there aren't already any items
                      if (this.items.length === 0) {
                        this.alerts = [];
                          var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                          this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                      }
                    }

	                if (this.items.length > 0) {
                        this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
                        this.scrollDown = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localDateTime.replace(/\D/g, ''));
	                } else {
	                    this.scrollUp = "";
	                    this.scrollDown = "";
	                }

                    this.pageSize = 50;
                    this.busy = false;
                }.bind(this), function (error) {
                    this.alerts = [];
                    var errorMessage = eval("this.translation.message." + error.message);
                    this.alerts.push({ msg: errorMessage, type: "danger" });
                    this.pageSize = 50;
                    this.busy = false;
                }.bind(this));
        };

    return temperatureDataService;
}]);

mcapp.controller("temperatureGaugeController", ['$scope', '$rootScope', '$element', 'temperatureGaugeService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'sharedSetupService', 'openViewService', 'authenticationService',
    function ($scope, $rootScope, $element, temperatureGaugeService, datetimeService, websocketService, timeLapseService, toaster, sharedSetupService, openViewService, authenticationService) {
        sharedSetupService.getWindowId($scope);
        $scope.devicename = null;
        $scope.unit = null;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.preferencesMeasurement = $scope.accountInfo.preferenceUser.lookupMeasurementID !== 2 ? 1 : 2;
        sharedSetupService.getWindowId($scope);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)')
                    .css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height",
                    $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") -
                    $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.temperature-gauge-container').css("height",
                    $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") -
                    $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") -
                    $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") -
                    20);
                //$scope.adjustDeviceIdMenuSize();
            };

            $scope.adjustDeviceIdMenuSize = function () {
                var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                if (spph < 450) {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
                } else {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
                }
            };
        }

    }]);

mcapp.directive('drawTemperatureGauge', ['$rootScope', '$timeout', 'temperatureGaugeService', 'datetimeService', 'websocketService', 'timeLapseService', 'openViewService', "sharedSetupService", "toaster",
    function ($rootScope, $timeout, temperatureGaugeService, datetimeService, websocketService, timeLapseService, openViewService, sharedSetupService, toaster) {
        function link($scope, $element, attrs) {
            $scope.downloadViewTypeOptions = [0];
            $scope.chartId = "thermometer" + Math.floor((Math.random() * 10000) + 1);
            if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }

            $scope.$watch('deviceSelected', function (newValue, oldValue) {
                if (newValue) {
                    $scope.currentDeviceId = newValue;
                    var _device = { deviceName: $scope.deviceSelectedName };
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });
                    _getData(newValue);
                }
            }, true);

            $scope.mostRecentData = function () {
                toaster.pop('success', "Temperature Gauge" + " -- " + $scope.deviceSelectedName, 'View reloading');
                _getData($scope.currentDeviceId);
            }

            var _getData = function (deviceID) {
                temperatureGaugeService.getData('customerID=' + $scope.accountInfo.customerId + '&deviceID=' + deviceID)
                    .then(function (datafromFactory) {
                        $scope.alerts = [];
                        if (datafromFactory.data.gauges[0].currentData === null) {
                            $scope.tempchart = new FusionCharts({
                                type: 'thermometer',
                                renderAt: $scope.chartId,
                                width: '2',
                                height: '2',
                                dataFormat: 'json',
                                dataSource: {
                                    "chart": {
                                        "manageresize": 1,
                                        "decimals": 0,
                                        "thmFillColor": "#ff0000",
                                        "canvasBgAlpha": "0",
                                        "legendBgAlpha": "0",
                                        "borderAlpha": "0",
                                        "bgAlpha": "0,0"
                                    },
                                    "value": 0
                                }
                            }).render();
                            $scope.alerts.push({ msg: $scope.translation.text.NO_DATA, type: "info" });
                            return false;
                        }
                        websocketService.connect();
                        $scope.devicename = datafromFactory.data.device.name;
                        $scope.unit = " °F";
                        $scope.title = datafromFactory.data.gauges[0].name;
                        $scope.gaugeMinVal = datafromFactory.data.gauges[0].setting[0].value;
                        $scope.gaugeMaxVal = datafromFactory.data.gauges[0].setting[1].value;
                        $scope.currentDateTime = datafromFactory.data.gauges[0].currentData.localDateTime;
                        $scope.currentValue = datafromFactory.data.gauges[0].currentData.value;
                        $scope.liveData = true;
                        _drawGaugeTemp();
                        websocketService.register("TEMPERATURE", $scope.deviceSelectedSn, '', wsDataReceivedGT, wsReconnectGT);
                    });
            };

            var _drawGaugeTemp = function () {

                $scope.tempchart = new FusionCharts({
                    type: 'thermometer',
                    renderAt: $scope.chartId,
                    width: '120',
                    height: '210',
                    dataFormat: 'json',
                    dataSource: {
                        "chart": {
                            "manageresize": 1,
                            "lowerLimit": $scope.preferencesMeasurement === 1 ? 0 : -10,
                            "upperLimit": $scope.preferencesMeasurement === 1 ? 120 : 50,
                            "majorTMNumber": 7,
                            "numberSuffix": $scope.preferencesMeasurement === 1 ? " °F" : " °C",
                            "decimals": 0,
                            "thmFillColor": "#ff0000",
                            "canvasBgAlpha": "0",
                            "legendBgAlpha": "0",
                            "borderAlpha": "0",
                            "bgAlpha": "0,0"
                        },
                        "value": $scope.preferencesMeasurement === 1 ? (9 / 5) * $scope.currentValue + 32 : $scope.currentValue
                    }
                }).render();

                if (!$scope.mobile && !$scope.classicView) $scope.popup.parent().find("svg[id^='raphael-paper']").css("background-color", "rgb(255, 255, 255, 0)");

            };

            $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
                $scope.preferencesMeasurement = measurementSystem;
                _drawGaugeTemp();
            });

            var wsDataReceivedGT = function (data) {
                if ($scope.deviceSelectedSn === data.SN) {
                    $scope.currentValue = parseFloat(data.Value);
                    $scope.tempchart.setData($scope.preferencesMeasurement === 1 ? (9 / 5) * $scope.currentValue + 32 : $scope.currentValue);
                }
            };

            var wsReconnectGT = function (data) {
                _getData(scope.deviceSelected);
            };

            $element.on(
                "mouseover.drawTemperatureGauge",
                ".hcolTemp",
                function (event) {
                    var localScope = $(event.target).scope();
                    if ($(event.currentTarget).is(".hcolTemp") && !$scope.mobile && !$scope.classicView) {
                        $(event.currentTarget).draggable({
                            helper: "clone",
                            revert: false,
                            appendTo: "body",
                            containment: "body",
                            opacity: 0.35,
                            stop: function (event, ui) {
                                var mcDevice = { deviceId: $scope.deviceSelected, serialNumber: $scope.deviceSelectedSn };
                                var optionsStickyProperties = {
                                    device: mcDevice
                                };
                                var $newPosX = ui.offset.left;
                                var $newPosY = ui.offset.top;
                                var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                                openViewService.openWidget('Temperature Widget', { width: 240, height: 240 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                $scope.$apply();
                            }
                        });
                    }
                }
            );

            $scope.$on("$destroy", function () {
                websocketService.unRegister("TEMPERATURE", $scope.deviceSelectedSn, '', wsDataReceivedGT, wsReconnectGT);
                $element.off("mouseover.drawTemperatureGauge");
                if ($scope.tempchart && $scope.tempchart.dispose) {
                    $scope.tempchart.dispose();
                    $scope.tempchart = null;
                }
            });
        }
        return {
            restrict: 'A',
            replace: false,
            link: link
        };
    }]);

mcapp.factory('temperatureGaugeService', ['$http', 'HOST', function ($http, HOST) {
    var temperatureGaugeFatory = {};

    var _getData = function (varParm) {
        return $http({
            method: 'Get',
            url: HOST + '/api/TemperatureGauge?' + varParm,
            cache: false
        });
    };
    temperatureGaugeFatory.getData = _getData;
    return temperatureGaugeFatory;
}]);

"use strict";

angular.module("mc.toaster-master", []);
'use strict';

function ToasterMasterFactory(HOST, $http) {

    function ListToasterMessages(loginId, isToasterMasterView) {
        return $http({
            method: 'GET',
            url: HOST + '/api/ToasterMaster',
            params: { loginId: loginId, isToasterMasterView: isToasterMasterView }
        });
    }

    function UnsubscribeFromToasterMessage(toasterMessageId, loginId, customerId) {
        return $http({
            method: 'POST',
            url: HOST + '/api/ToasterMaster',
            params: { toasterMessageId: toasterMessageId, loginId: loginId, customerId: customerId }
        });
    }

    function UpdateToasterMessageByID(customerId, toasterMessage) {
        return $http.put(HOST + '/api/ToasterMaster?customerId=' + customerId, toasterMessage).then(function (response) {
            return response;
        });
    }

    function InsertToasterMessage(customerId, toasterMessage) {
        return $http.post(HOST + '/api/ToasterMaster?customerId=' + customerId, toasterMessage).then(function (response) {
            return response;
        });
    }

    //function ValidateFile(fileInput) {
    //    let filename = fileInput.name;
    //    var validFilesTypes = ["bmp", "gif", "png", "jpg",
    //        "jpeg", "doc", "docx", "rtf", "xls", "xlsx", "csv",
    //        "zip", "txt", "pdf", "wav", "mp3", "mp4"];

    //    var isValidFile = false;
    //    let ext = filename.slice(filename.lastIndexOf('.') + 1).toLowerCase();
    //    for (var i = 0; i < validFilesTypes.length; i++) {
    //        if (ext == validFilesTypes[i]) {
    //            isValidFile = true;
    //            break;
    //        }
    //    }
    //    return isValidFile;
    //}

    return {
        ListToasterMessages: ListToasterMessages,
        UnsubscribeFromToasterMessage: UnsubscribeFromToasterMessage,
        UpdateToasterMessageByID: UpdateToasterMessageByID,
        InsertToasterMessage: InsertToasterMessage
        /*ValidateFile*/
    };
}

ToasterMasterFactory.$inject = ['HOST', '$http'];

angular.module('mc.toaster-master').factory('toasterMasterService', ToasterMasterFactory);
'use strict';

function ToasterMasterController(_, $, $rootScope, $scope, $sce, authenticationService, translationService, modalService, wizardSplashService, sharedSetupService, unsavedChangesService, toasterMasterService) {
    var ctrl = this;
    ctrl.$onInit = function () {
        ctrl._ = _;
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.addingNewToaster = false;
        ctrl.showActiveToasters = true;
        ctrl.isLoading = false;
        ctrl.allToasterMessages = [];
        ctrl.toasterMessages = [];
        ctrl.listToasterMessages();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog(ctrl.windowId).ref;
            $(ctrl._popup).on('dialogbeforeclose', function (event) {
                //unsavedChangesService.checkUnsavedChanges(event, ctrl._popup, ctrl, ctrl.newKey())
            });
        }
    };

    ctrl.addToasterMessage = function () {
        var newToasterMessage = {
            toasterMessageID: -1,
            messageHeader: '',
            messageContent: '',
            isActive: true,
            internalLink: { id: 0 },
            iconClass: { id: 2 },
            externalLink: '',
            externalLinkLabel: '',
            startDate: null,
            endDate: null,
            canAcknowledge: false,
            displayTimer: { id: 0 },
            addingNew: true
        };
        ctrl.addingNewToaster = true;
        ctrl.toasterMessages.unshift(newToasterMessage);
    };

    ctrl.cancelAdd = function () {
        ctrl.toasterMessages.splice(0, 1);
        ctrl.addingNewToaster = false;
    };

    ctrl.listToasterMessages = function () {
        ctrl.isLoading = true;
        toasterMasterService.ListToasterMessages(ctrl.accountInfo.userId, true).then(function (result) {
            result.data.forEach(function (element) {
                element.iconClass = { id: element.iconClassID };
                element.internalLink = { id: element.internalLinkID };
                element.displayTimer = { id: element.displayTimerID };
                if (element.startDate !== null) element.startDate = new Date(element.startDate);
                if (element.endDate !== null) element.endDate = new Date(element.endDate);
            });
            ctrl.allToasterMessages = result.data;
            ctrl.filterToasterMessages();
            ctrl.isLoading = false;
            //ctrl.toasterMessages = result.data;
            //ctrl.toasterMessages.forEach((element) => {
            //    element.iconClass = { id: element.iconClassID };
            //});            
        }, function (error) {
            console.log("error");
        });
    };

    ctrl.updateToasterMessageById = function (toasterMessage, propertyName, propertyNameOld) {
        if (propertyName == 'iconClassID') ctrl.getIconImage(toasterMessage.iconClass.id);
        if (toasterMessage.toasterMessageID === -1) return;
        if (typeof propertyNameOld !== 'undefined' && toasterMessage[propertyName] == toasterMessage[propertyNameOld]) return;
        ctrl.isLoading = true;
        if (toasterMessage.iconClass !== null) toasterMessage.iconClassID = toasterMessage.iconClass.id;
        if (toasterMessage.internalLink !== null) toasterMessage.internalLinkID = toasterMessage.internalLink.id;
        if (toasterMessage.displayTimer !== null) toasterMessage.displayTimerID = toasterMessage.displayTimer.id;
        toasterMasterService.UpdateToasterMessageByID(ctrl.accountInfo.customerId, toasterMessage).then(function (result) {
            if (propertyName == 'isActive') ctrl.filterToasterMessages();
            ctrl.isLoading = false;
        }, function (error) {
            console.log("error");
        });
    };

    ctrl.insertToasterMessage = function (toasterMessage) {
        ctrl.isLoading = true;
        if (toasterMessage.iconClass !== null) {
            toasterMessage.iconClassID = toasterMessage.iconClass.id;
        } else {
            toasterMessage.iconClassID = 2;
        }
        if (toasterMessage.internalLink !== null) {
            toasterMessage.internalLinkID = toasterMessage.internalLink.id;
        } else {
            toasterMessage.internalLinkID = null;
        }
        if (toasterMessage.displayTimer !== null) {
            toasterMessage.displayTimerID = toasterMessage.displayTimer.id;
        }
        toasterMasterService.InsertToasterMessage(ctrl.accountInfo.customerId, toasterMessage).then(function (result) {
            toasterMessage.addingNew = false;
            ctrl.addingNewToaster = false;
            result.data.iconClass = { id: result.data.iconClassID };
            result.data.internalLink = { id: result.data.internalLinkID };
            result.data.displayTimer = { id: result.data.displayTimerID };
            if (result.data.startDate !== null) result.data.startDate = new Date(result.data.startDate);
            if (result.data.endDate !== null) result.data.endDate = new Date(result.data.endDate);
            ctrl.allToasterMessages.push(result.data);
            ctrl.getIconImage(result.data.iconClassID);
            ctrl.filterToasterMessages();
            ctrl.isLoading = false;
        }, function (error) {
            console.log("error");
        });
    };

    ctrl.toggleActiveInactiveToasters = function () {
        ctrl.isLoading = true;
        ctrl.showActiveToasters = !ctrl.showActiveToasters;
        ctrl.filterToasterMessages();
        ctrl.isLoading = false;
    };

    ctrl.filterToasterMessages = function () {
        ctrl.toasterMessages = [];
        ctrl.allToasterMessages.forEach(function (element) {
            if (ctrl.showActiveToasters) {
                if (element.isActive) {
                    ctrl.toasterMessages.push(element);
                }
            } else {
                if (!element.isActive) {
                    ctrl.toasterMessages.push(element);
                }
            }
        });
    };

    ctrl.iconClasses = [{
        "id": 1,
        "description": "error",
        "background-color": "#e75a5a"
    }, {
        "id": 2,
        "description": "info",
        "background-color": "#348bc6"
    }, {
        "id": 3,
        "description": "wait",
        "background-color": "#2f96b4"
    }, {
        "id": 4,
        "description": "success",
        "background-color": "#138a72"
    }, {
        "id": 5,
        "description": "warning",
        "background-color": "#ee8536"
    }, {
        "id": 6,
        "description": "weather_warning",
        "background-color": "#d61011"
    }, {
        "id": 7,
        "description": "weather_watch",
        "background-color": "#E0AF0B"
    }, {
        "id": 8,
        "description": "weather_advisory",
        "background-color": "#E0AF0B"
    }, {
        "id": 9,
        "description": "ticket_warning",
        "background-color": "#1436c6"
    }, {
        "id": 10,
        "description": "offline_warning",
        "background-color": "#3569f9"
    }, {
        "id": 11,
        "description": "announcement",
        "background-color": "#138a72"
    }];

    ctrl.internalViews = [{
        "id": 0,
        "viewname": "None",
        "description": "None"
    }, {
        "id": 1,
        "viewname": "Alarm History",
        "description": "Alarm History"
    }, {
        "id": 2,
        "viewname": "Alert History Report",
        "description": "Alert History"
    }, {
        "id": 3,
        "viewname": "Audit History",
        "description": "Audit History"
    }, {
        "id": 4,
        "viewname": "Paging Log",
        "description": "Command Log"
    }, {
        "id": 5,
        "viewname": "Cumulative Flow Reading",
        "description": "Cumulative Flow Reading"
    }, {
        "id": 6,
        "viewname": "Daily Station Summary",
        "description": "Daily Station Summary"
    }, {
        "id": 7,
        "viewname": "Delayed Alarm History Report",
        "description": "Delayed Alarm History"
    }, {
        "id": 8,
        "viewname": "Disabled Inputs Report",
        "description": "Disabled Input"
    }, {
        "id": 9,
        "viewname": "Integrated Flow Report",
        "description": "Integrated Flow"
    }, {
        "id": 10,
        "viewname": "Management Report",
        "description": "Management Report"
    }, {
        "id": 11,
        "viewname": "Pump Alarm Data",
        "description": "Pump Alarm Data"
    }, {
        "id": 12,
        "viewname": "Pump Service Report",
        "description": "Pump Service Report"
    }, {
        "id": 13,
        "viewname": "Radio Upgrades",
        "description": "Radio Upgrades Report"
    }, {
        "id": 14,
        "viewname": "Runtime Daily Report",
        "description": "Runtime Daily"
    }, {
        "id": 15,
        "viewname": "Runtime Multi Day Report",
        "description": "All RTU Multi Day"
    }, {
        "id": 16,
        "viewname": "Runtime Monthly Report",
        "description": "Runtime Monthly"
    }, {
        "id": 17,
        "viewname": "Runtime Variance",
        "description": "Runtime Variance"
    }, {
        "id": 18,
        "viewname": "Site Access Report",
        "description": "Site Access"
    }, {
        "id": 19,
        "viewname": "SSO CSO Report",
        "description": "SSO CSO Report"
    }, {
        "id": 20,
        "viewname": "Unit Check In Report",
        "description": "Unit Check In"
    }, {
        "id": 21,
        "viewname": "Untested Wet Well Inputs",
        "description": "Untested Wet Well Inputs"
    }, {
        "id": 22,
        "viewname": "User Login Report",
        "description": "User Login"
    }, {
        "id": 23,
        "viewname": "Pulseflow Multi Day Report",
        "description": "Pulseflow Multi Day Report"
    }];

    ctrl.displayTimers = [{
        "id": 0,
        "description": "None"
    }, {
        "id": 15000,
        "description": "15 Seconds"
    }, {
        "id": 30000,
        "description": "30 Seconds"
    }];

    ctrl.getIconImage = function (iconClassId) {
        var iconClassPng = void 0,
            iconClassColor = void 0;
        switch (iconClassId) {
            case 1:
                iconClassPng = "toast_error.png";
                iconClassColor = "#e75a5a";
                break;
            case 2:
                iconClassPng = "toast_info.png";
                iconClassColor = "#348bc6";
                break;
            case 3:
                iconClassPng = "toast_wait.gif";
                iconClassColor = "#2f96b4";
                break;
            case 4:
                iconClassPng = "toast_success.png";
                iconClassColor = "#138a72";
                break;
            case 5:
                iconClassPng = "toast_warning.png";
                iconClassColor = "#ee8536";
                break;
            case 6:
                iconClassPng = "weather_warning.png";
                iconClassColor = "#d61011";
                break;
            case 7:
                iconClassPng = "weather_watch.png";
                iconClassColor = "#E0AF0B";
                break;
            case 8:
                iconClassPng = "weather_advisory.png";
                iconClassColor = "#E0AF0B";
                break;
            case 9:
                iconClassPng = "ticket_warning.png";
                iconClassColor = "#1436c6";
                break;
            case 10:
                iconClassPng = "offline_warning.png";
                iconClassColor = "#3569f9";
                break;
            case 11:
                iconClassPng = "toast_info.png";
                iconClassColor = "#138a72";
                break;
        }
        var urlImageIconClass = 'url(images/' + iconClassPng + ')';
        return { 'background-image': urlImageIconClass, 'background-color': iconClassColor };
    };

    ctrl.getHeight = function () {
        if (!ctrl.mobile && !ctrl.classicView) {
            return ctrl._popup.parent().find('.electronic-keys-container')[0].clientHeight - 23;
        }

        //return $('.electronic-keys-container')[0].clientHeight - 65;
    };

    $scope.$on('$routeChangeStart', function (event) {
        if (ctrl.newKey()) {
            if (confirm(ctrl.translation.text.EXIT_WITHOUT_SAVE) !== true) {
                console.log(event);
                event.preventDefault();
                $rootScope.loadingView = false;
            }
        }
    });

    ctrl.isAdmin = function () {
        return ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator';
    };

    ctrl.$onDestroy = function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    };
}

ToasterMasterController.$inject = ['_', '$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'modalService', 'wizardSplashService', 'sharedSetupService', 'unsavedChangesService', 'toasterMasterService'];
'use strict';

angular.module('mc.toaster-master').component('toasterMaster', {
    controller: ToasterMasterController,
    templateUrl: 'ui/toastermaster/toaster-master-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function TankAndWellFactory(HOST, $http) {
    function GetList(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellListAll',
            params: { customerId: customerId }
        });
    }

    function GetBasicInfo(WSDeviceId, customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellBasic',
            params: { WSDeviceId: WSDeviceId, customerId: customerId }
        });
    }

    function GetTank(customerId, WSDeviceId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellListAll/Tank',
            params: { customerId: customerId, WSDeviceId: WSDeviceId }
        });
    }

    function GetSetup(customerId, WSDeviceId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellListAll/GetSetup',
            params: { customerId: customerId, WSDeviceId: WSDeviceId }
        });
    }

    function GetSetupData(WSDeviceId, timeZone, customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellGroundTank',
            params: { WSDeviceId: WSDeviceId, timeZone: timeZone, customerId: customerId }
        });
    }

    function GetGroundTankData(WSDeviceId, timeZone, customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellGroundTank',
            params: { WSDeviceId: WSDeviceId, timeZone: timeZone, customerId: customerId }
        });
    }

    function GetPumpData(customerId, deviceId, channel, timeZone) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellPump',
            params: { customerId: customerId, deviceId: deviceId, channel: channel, timeZone: timeZone }
        });
    }

    function GetChartData(WSDeviceId, startDate, endDate, customerId, timeZone) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellChart',
            params: { WSDeviceId: WSDeviceId, customerId: customerId, startDate: startDate, endDate: endDate, timeZone: timeZone }
        });
    }

    function GetOperationLog(WSDeviceId, timeZone, startDate, endDate, direction) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellEventLog',
            params: { WSDeviceId: WSDeviceId, timeZone: timeZone, startDate: startDate, endDate: endDate, direction: direction }
        });
    }

    function CalculateRelay(relay, polarity) {
        if (relay === '' || relay === 'null') {
            return '';
        }

        return relay ^ polarity;
    }

    function GetDisplaySetup(WSDeviceId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellDisplaySetup',
            params: { WSDeviceId: WSDeviceId }
        });
    }

    function PatchDisplaySetup(customerId, WSDeviceId, patches) {
        return $http.patch(HOST + "/api/v2/TankAndWellDisplaySetup?customerId=" + customerId + "&WSDeviceId=" + WSDeviceId + "&isCollection=" + true, patches);
    };

    function GetLabelsSetup(WSDeviceId, customerId, optionsTab) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellLabelsSetup',
            params: { WSDeviceId: WSDeviceId, customerId: customerId, optionsTab: optionsTab }
        });
    }

    function PatchLabelsSetup(customerId, WSDeviceId, displayPatch) {
        return $http.patch(HOST + "/api/TankAndWellLabelsSetup?customerId=" + customerId + "&WSDeviceId=" + WSDeviceId, displayPatch);
    };

    function GetSetPointsSetup(WSDeviceId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/TankAndWellSetPointsSetup',
            params: { WSDeviceId: WSDeviceId }
        });
    }

    function PatchSetPointsSetup(customerId, WSDeviceId, displayPatch) {
        return $http.patch(HOST + "/api/TankAndWellSetPointsSetup?customerId=" + customerId + "&WSDeviceId=" + WSDeviceId, displayPatch);
    };

    function UpdateSetPointsSetupNOP(customerId, WSDeviceId, patches) {
        return $http.put(HOST + "/api/TankAndWellSetPointsSetup?customerId=" + customerId + "&WSDeviceId=" + WSDeviceId, patches);
    };

    function GetConfigOptionsSetup(customerId, WSDeviceId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/v2/TankAndWellConfigOptionsSetup/GetAll',
            params: { customerId: customerId, WSDeviceId: WSDeviceId }
        });
    }

    function PatchConfigOptionsSetup(customerId, WSDeviceId, patchColl) {
        return $http.put(HOST + "/api/v2/TankAndWellConfigOptionsSetup?customerId=" + customerId + "&WSDeviceId=" + WSDeviceId, patchColl);
    };

    function UpdateDisplayOrder(tankAndWells) {
        return $http.put(HOST + "/api/TankAndWellListAll", tankAndWells);
    }

    function PatchBasicInfoList(customerId, WSDeviceId, patchColl) {
        return $http.patch(HOST + "/api/TankAndWellBasic?customerId=" + customerId + "&WSDeviceId=" + WSDeviceId + "&isCollection=" + true, patchColl);
    }

    function PatchAlternateSource(customerId, WSDeviceId, patchColl) {
        return $http.patch(HOST + "/api/TankAndWellConfigOptionsSetup?customerId=" + customerId + "&WSDeviceId=" + WSDeviceId + "&isCollection=" + true, patchColl);
    }

    //function GetOffPeakProfiles(customerId, wsDeviceId) {
    //  return $http({
    //      method: 'GET',
    //      url: HOST + '/api/TankAndWellOffPeakProfileSetup',
    //      params: { customerId, wsDeviceId },
    //  });
    //}

    //function AddOffPeakProfile(customerId, offPeakProfile) {
    //    return $http({
    //        method: 'POST',
    //        url: `${HOST}/api/TankAndWellOffPeakProfileSetup`,
    //        data: offPeakProfile,
    //        contentType: 'application/json',
    //        params: { customerId }
    //    });
    //  }

    //function DeleteOffPeakProfile(customerId, offPeakProfileId) {
    //    return $http({
    //        method: 'DELETE',
    //        url: `${HOST}/api/TankAndWellOffPeakProfileSetup`,
    //        params: { customerId, offPeakProfileId }
    //    });
    //  }

    //// Patch the Profile property (Includes Lead pump info, NOTE: NO Lag pump info)
    //function PatchOffPeakLeadProfile(customerId, offPeakProfileId, profilePatch) {
    //    return $http({
    //        method: 'PATCH',
    //        url: `${HOST}/api/TankAndWellOffPeakProfileSetup`,
    //        data: profilePatch,
    //        params: { customerId, offPeakProfileId }
    //    });
    //  }

    //// Patch the Lag pump property
    //  function PatchOffPeakLagPumpProfile(customerId, offPeakLagProfileId, lagProfilePatch) {
    //    return $http({
    //        method: 'PATCH',
    //        url: `${HOST}/api/TankAndWellOffPeakProfileSetup/PatchLagProfile`,
    //        data: lagProfilePatch,
    //        params: { customerId, offPeakLagProfileId }
    //    });
    //}

    // Patch the Profile property (Includes Lead pump info, NOTE: NO Lag pump info)
    function PatchProfile(profileId, profilePatch) {
        return $http({
            method: 'PATCH',
            url: HOST + '/api/WsProfile',
            data: profilePatch,
            params: { profileId: profileId }
        });
    }

    // Patch the Profile property (Includes Lead pump info, NOTE: NO Lag pump info)
    function PatchLevel(customerId, levelId, profilePatch) {
        return $http({
            method: 'PATCH',
            url: HOST + '/api/WsProfile',
            data: profilePatch,
            params: { customerId: customerId, levelId: levelId }
        });
    }
    //create new profile => Add operation
    function PostProfile(customerId, wsProfile) {
        return $http({
            method: 'POST',
            url: HOST + '/api/WsProfile',
            data: wsProfile,
            params: { customerId: customerId }
        });
    }
    //update existing profile => Edit operation
    function UpdateProfile(customerId, wsProfile) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/WsProfile',
            data: wsProfile,
            params: { customerId: customerId }
        });
    }

    function GetProfiles(customerId, wsDeviceId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/WsProfile',
            params: { customerId: customerId, wsDeviceId: wsDeviceId }
        });
    }

    // used to raise the popup message to save the data when tab lose focus
    var checkUnsavedChanges = false;

    var tabPopupWarningOn = false;

    return {
        GetList: GetList,
        GetBasicInfo: GetBasicInfo,
        GetSetupData: GetSetupData,
        GetGroundTankData: GetGroundTankData,
        GetPumpData: GetPumpData,
        GetChartData: GetChartData,
        GetOperationLog: GetOperationLog,
        CalculateRelay: CalculateRelay,
        GetDisplaySetup: GetDisplaySetup,
        PatchDisplaySetup: PatchDisplaySetup,
        GetLabelsSetup: GetLabelsSetup,
        PatchLabelsSetup: PatchLabelsSetup,
        GetSetPointsSetup: GetSetPointsSetup,
        PatchSetPointsSetup: PatchSetPointsSetup,
        UpdateSetPointsSetupNOP: UpdateSetPointsSetupNOP,
        GetConfigOptionsSetup: GetConfigOptionsSetup,
        PatchConfigOptionsSetup: PatchConfigOptionsSetup,
        //PatchBasicInfo,
        PatchBasicInfoList: PatchBasicInfoList,
        PatchAlternateSource: PatchAlternateSource,
        UpdateDisplayOrder: UpdateDisplayOrder,
        //GetOffPeakProfiles,
        //AddOffPeakProfile,
        //PatchOffPeakLeadProfile,
        //PatchOffPeakLagPumpProfile,
        //DeleteOffPeakProfile,
        PatchProfile: PatchProfile,
        PatchLevel: PatchLevel,
        PostProfile: PostProfile,
        UpdateProfile: UpdateProfile,
        GetProfiles: GetProfiles,
        checkUnsavedChanges: checkUnsavedChanges,
        tabPopupWarningOn: tabPopupWarningOn,
        GetTank: GetTank,
        GetSetup: GetSetup
    };
}

TankAndWellFactory.$inject = ['HOST', '$http'];

angular.module('mc.tankandwell').factory('tankAndWellService', TankAndWellFactory);
'use strict';

function TankAndWellOffPeakWizardFactory(HOST, $http) {
  function Post(customerId, tankAndWellOffPeakProfileAndSchedule) {
    return $http({
      method: 'POST',
      url: HOST + '/api/WsWizard',
      data: tankAndWellOffPeakProfileAndSchedule,
      params: { customerId: customerId }
    });
  }

  return { Post: Post };
}

TankAndWellOffPeakWizardFactory.$inject = ['HOST', '$http'];

angular.module('mc.tankandwell').factory('tankAndWellOffPeakWizardService', TankAndWellOffPeakWizardFactory);
'use strict';

function TankAndWellOffPeakScheduleFactory(HOST, $http) {
    function GetList(wsDeviceId, customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/WsSchedule',
            params: { wsDeviceId: wsDeviceId, customerId: customerId }
        });
    }

    //function Patch(customerId, scheduleId, wsDeviceId, profilePatch) {
    //    return $http({
    //        method: 'PATCH',
    //        url: `${HOST}/api/WsSchedule`,
    //        data: profilePatch,
    //        params: { customerId, scheduleId, wsDeviceId }
    //    });
    //}

    //function Put(customerId, scheduleId, wsDeviceId, schedulePatch) {
    //    return $http({
    //        method: 'PUT',
    //        url: `${HOST}/api/WsSchedule`,
    //        data: schedulePatch,
    //        params: { customerId, scheduleId, wsDeviceId }
    //    });
    //}

    //function Post(customerId, wsDeviceId, isLast, offPeakSchedule) {
    //    return $http({
    //        method: 'POST',
    //        url: `${HOST}/api/WsSchedule`,
    //        data: offPeakSchedule,
    //        params: { customerId, wsDeviceId, isLast }
    //    });
    //}
    function PostSchedules(customerId, wsDeviceId, offPeakSchedules) {
        return $http({
            method: 'POST',
            url: HOST + '/api/WsSchedule',
            data: offPeakSchedules,
            params: { customerId: customerId, wsDeviceId: wsDeviceId }
        });
    }
    function PutSchedules(customerId, wsDeviceId, offPeakSchedulesOldNew) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/WsSchedule',
            data: offPeakSchedulesOldNew,
            params: { customerId: customerId, wsDeviceId: wsDeviceId }
        });
    }
    function UpdateSchedules(customerId, wsDeviceId, startDate, endDate, updateSchedules) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/WsSchedule',
            data: updateSchedules,
            params: { customerId: customerId, startDate: startDate, endDate: endDate, wsDeviceId: wsDeviceId }
        });
    }
    function DeleteSchedules(customerId, wsDeviceId, startDate, endDate, profileIds) {
        //as there are challenges passing array to webapi, so we are sending profileIds as separate parameters
        var profile1Id = profileIds[0];
        var profile2Id = profileIds[1];
        //return $http({
        //    method: 'DELETE',
        //    url: `${HOST}/api/WsSchedule`,
        //    //data: profileIds,
        //    params: { customerId, startDate, endDate, wsDeviceId, profile1Id, profile2Id }
        //});

        return $http.delete(HOST + "/api/WsSchedule?customerId=" + customerId + "&startDate=" + startDate + "&endDate=" + endDate + "&wsDeviceId=" + wsDeviceId + "&profile1Id=" + profile1Id + "&profile2Id=" + profile2Id);
    }

    return {
        GetList: GetList,
        //Patch,
        //Post,
        //Put,
        PostSchedules: PostSchedules,
        PutSchedules: PutSchedules,
        UpdateSchedules: UpdateSchedules,
        DeleteSchedules: DeleteSchedules
    };
}

TankAndWellOffPeakScheduleFactory.$inject = ['HOST', '$http'];

angular.module('mc.tankandwell').factory('tankAndWellOffPeakScheduleService', TankAndWellOffPeakScheduleFactory);
"use strict";

angular.module("mc.tech-support-assign-rtu-to-customer", []);
'use strict';

function TechSupportAssignRtuToCustomerFactory(HOST, $http) {

    var _assignRtuToCustomer = function _assignRtuToCustomer() {};

    _assignRtuToCustomer.prototype.isUserMissionManager = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupport/IsUserMissionManager/'
        });
    };

    _assignRtuToCustomer.prototype.fetchAllCustomersList = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/CustomersList/GetAll/'
        });
    };

    _assignRtuToCustomer.prototype.moveRTUToNewCustomer = function (deviceId, customerId, deviceName, custName) {

        return $http.post(HOST + "/api/Device/MoveRTU/" + "?deviceId=" + deviceId + "&customerId=" + customerId + "&deviceName=" + deviceName + "&custName=" + custName).then(function (response) {
            return response.data;
        });
    };

    return _assignRtuToCustomer;
}

TechSupportAssignRtuToCustomerFactory.$inject = ['HOST', '$http'];

angular.module('mc.tech-support-assign-rtu-to-customer').factory('TechSupportAssignRtuToCustomerFactory', TechSupportAssignRtuToCustomerFactory);
"use strict";

function TechSupportAssignRtuToCustomerController($rootScope, $scope, authenticationService, translationService, sharedSetupService, openViewService, TechSupportAssignRtuToCustomerFactory, deviceMenuService, toaster) {
    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    //ctrl.requiredCustomers = [];
    //ctrl.selectedCustomers = [];
    //ctrl.allCustomerSelected = false;

    ctrl.$onInit = function () {
        ctrl._assignRtuToCustomer = new TechSupportAssignRtuToCustomerFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.customerId = ctrl.accountInfo.customerId;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.alerts = [];
        //--------------------------------------------------------------------------------------------------
        ctrl.loading = false;
        ctrl.isMissionManager = false;
        ctrl.reqRefresh = false;

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for   
        $scope.alerts = [];

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }
        ctrl.getDevices();
        ctrl.getCustomersList();
        ctrl.moveRTU = document.getElementById('moveRTU');
        ctrl.moveRTU.disabled = true;
        ctrl.clearDropdown = document.getElementById('clearDropdown');
        ctrl.clearDropdown.disabled = true;
    };

    // Function to show the dropdown when Customer Name input/select button is clicked
    var showDropdown = function showDropdown() {
        ctrl.customerName.setAttribute("placeholder", "Search ..."); // once drowndown is seen input placeholder should display Filter
        var filter = ctrl.customerName.value.toLowerCase();
        var filteredOptions = ctrl.customersList.filter(function (option) {
            return option.name.toLowerCase().includes(filter);
        });
        ctrl.renderOptions(filteredOptions); // Render filtered options
    };

    // Function to render options in the dropdown list
    ctrl.renderOptions = function (options) {
        ctrl.customerNameDropdownList.innerHTML = ''; // Clear the existing options
        // Assigning customerId and name to optionElement for it to display value in
        options.forEach(function (option) {
            var optionElement = document.createElement('div');
            optionElement.classList.add('dropdownOption');
            if (option.customerId == ctrl.accountInfo.customerId) {
                optionElement.textContent = option.name;
                optionElement.id = option.customerId;
                //Graying out the Customer Name which login user is logged in from
                optionElement.style.color = "darkgrey";
                optionElement.style.cursor = "not-allowed";
            } else {
                optionElement.textContent = option.name;
                optionElement.id = option.customerId; // Store the ID in data attribute
                optionElement.onclick = function () {
                    return ctrl.selectOption(option); // returning selected option on selecting value from dropdown
                };
            }
            ctrl.customerNameDropdownList.appendChild(optionElement); // adding each option in the dropdown list
        });
        ctrl.customerNameDropdownList.style.display = options.length ? 'block' : 'none'; // Show or hide dropdown based on options
    };

    ctrl.getDevices = function () {
        ctrl.loading = true;
        deviceMenuService.getDeviceMenuList(ctrl.customerId).then(function (result) {
            ctrl.devices = result.data.devices;
            var tmp = [];
            for (var i = 0; i < ctrl.devices.length; i++) {
                tmp.push({ id: i, label: ctrl.devices[i].name, deviceId: ctrl.devices[i].deviceId });
            }
            ctrl.deviceData = tmp;
            ctrl.loading = false;
        }, function (error) {});
    };

    ctrl.getCustomersList = function () {
        ctrl._assignRtuToCustomer.fetchAllCustomersList().then(function (resp) {
            ctrl.customersList = resp.data;
        });
    };

    //Select Device
    ctrl.selectDevice = function (selectedDevice) {
        if (selectedDevice == null) {
            //    ctrl.customersList = [];
            ctrl.moveRTU.disabled = true; //disable Move RTU button when select device dropdown is empty
            ctrl.clearDropdown.disabled = true; //disable Cancel button when select device dropdown is empty as it is not needed
        } else {
            ctrl.clearDropdown.disabled = false; //enable Cancel button when select device has value
        }
    };

    ctrl.moveRTUToSelectedCustomer = function () {
        if (ctrl.selectedCustomer != -1 && ctrl.selectedDevice != -1) {
            ctrl._assignRtuToCustomer.moveRTUToNewCustomer(ctrl.selectedDevice.deviceId, ctrl.selectedCustomer.customerId, ctrl.selectedDevice.label, ctrl.selectedCustomer.name).then(function (resp) {
                ctrl.refreshData();
                ctrl.getDevices(); // Clears the dropdown values after clicking Move RTU
                toaster.pop('success', "", "Successfully moved RTU to " + ctrl.selectedCustomer.name);
            });
        }
    };

    // Cancel button
    ctrl.clearDropdownValues = function () {
        ctrl.selectedDevice = null;
        ctrl.selectedCustomer = null; //Make value null so input field is empty
        ctrl.customerName = document.getElementById('customerName'); //calling getElementById here instead of oninit because Customer Name dropdown is seen after selecting Device
        ctrl.customerName.value = null; //Make value null so input field is empty
        ctrl.clearFilter = false; // once field is empty Clear Filter icon should hide
        ctrl.moveRTU.disabled = true;
        ctrl.clearDropdown.disabled = true;
    };

    ctrl.refreshData = function () {
        //Update Device Menu
        deviceMenuService.resetDeviceMenuList();
        $rootScope.$broadcast('rtuBasicInfoUpdate');
    };

    //set timeout not needed as toaster.pop is being used
    // ctrl.setTimeOut = function () {
    //     setTimeout(function () {
    //         ctrl.alerts = [];
    //         $scope.alerts = [];
    //     }, 5000); // 5 Seconds
    // };

    ctrl.clearSearchField = function () {
        ctrl.selectedCustomer = null; //Make value null so input field is empty
        ctrl.customerName.value = null; //Make value null so input field is empty
        ctrl.clearFilter = false; // once field is empty Clear Filter icon should hide
        ctrl.moveRTU.disabled = true; //disable Move RTU button when when Customer Name dropdown is empty
    };

    ctrl.filterOptions = function () {
        ctrl.customerName = document.getElementById('customerName'); //calling getElementById here instead of oninit because Customer Name dropdown is seen after selecting Device
        ctrl.customerNameDropdownList = document.getElementById('customerNameDropdownList'); //calling getElementById here instead of oninit because Customer Name dropdown is seen after selecting Device
        //After clicking clear filter icon the input field should open just like it is opened for first time
        ctrl.selectedCustomer = null;
        ctrl.customerName.value = null;
        ctrl.moveRTU.disabled = true; //disable Move RTU button when when Customer Name dropdown is empty

        //Call showDropdown() to show list once the input field is clicked
        ctrl.customerName.addEventListener('click', showDropdown);

        // Function to filter options based on search input
        ctrl.filterOption = function (searchText) {
            var filter = searchText.toLowerCase();
            var filteredOptions = ctrl.customersList.filter(function (option) {
                return option.name.toLowerCase().includes(filter);
            });
            ctrl.renderOptions(filteredOptions);
        };

        // Function to handle option selected from the dropdown
        ctrl.selectOption = function (option) {
            ctrl.customerName.value = option.name; // Set search input to selected option name
            ctrl.selectedCustomer = option; //assign option to ctrl.selectedCustomer
            ctrl.customerName.style.backgroundColor = "#f6ff95"; //set the color of the selected value
            ctrl.customerNameDropdownList.style.display = 'none'; // Hide dropdown after selection

            if (ctrl.selectedCustomer == null) {
                ctrl.moveRTU.disabled = true; //disable Move RTU button when when Customer Name dropdown is empty
            } else {
                ctrl.moveRTU.disabled = false; //enable Move RTU button when when Customer Name dropdown is not empty
            }
        };

        // Alternate way without using oninput by creating event listener to listen everytime we enter something in input box
        ctrl.customerName.addEventListener('input', function () {
            // Adding clear filter icon if length more than 0
            if (ctrl.customerName.value.length > 3) {
                ctrl.clearFilter = true; //Clear Filter icon should be visible if length exceeds 3
            } else {
                ctrl.clearFilter = false; //Clear Filter icon should not be visible if length is below 3
            }
            ctrl.filterOption(ctrl.customerName.value);
        });

        // Hide dropdown if clicked outside of the input and dropdown
        document.addEventListener('click', function (e) {
            if (!e.target.closest('#customerName') && !e.target.closest('#customerNameDropdownList')) {
                // Hide the dropdown and change the input placeholder when clicked outside without selecting value
                ctrl.customerNameDropdownList.style.display = 'none';
                ctrl.customerName.setAttribute("placeholder", "Select");
                ctrl.customerName.style.backgroundColor = "#f6ff95";
            }
        });
    };

    $scope.$on("$destroy", function () {
        ctrl.customerName.removeEventListener('click', showDropdown);
        document.removeEventListener('click', function (e) {
            if (!e.target.closest('#customerName') && !e.target.closest('#customerNameDropdownList')) {
                // Hide the dropdown and change the input placeholder when clicked outside without selecting value
                ctrl.customerNameDropdownList.style.display = 'none';
                ctrl.customerName.setAttribute("placeholder", "Select");
                ctrl.customerName.style.backgroundColor = "#f6ff95";
            }
        });
    });
}

TechSupportAssignRtuToCustomerController.$inject = ['$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'TechSupportAssignRtuToCustomerFactory', 'deviceMenuService', 'toaster'];
'use strict';

angular.module('mc.tech-support-assign-rtu-to-customer').component('techSupportAssignRtuToCustomer', {
    controller: TechSupportAssignRtuToCustomerController,
    templateUrl: 'ui/techsupportassignrtutocustomer/tech-support-assign-rtu-to-customer-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.tech-support-assign-customer", []);
'use strict';

function TechSupportAssignCustomerFactory(HOST, $http) {

    var _techSupportAssignCustomer = function _techSupportAssignCustomer() {};

    _techSupportAssignCustomer.prototype.isUserMissionManager = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupport/IsUserMissionManager/'
        });
    };

    _techSupportAssignCustomer.prototype.fetchAllCustomersList = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/CustomersList/Get/'
        });
    };

    return _techSupportAssignCustomer;
}

TechSupportAssignCustomerFactory.$inject = ['HOST', '$http'];

angular.module('mc.tech-support-assign-customer').factory('TechSupportAssignCustomerFactory', TechSupportAssignCustomerFactory);
'use strict';

function TechSupportAssignCustomerController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, TechSupportAssignCustomerFactory, $timeout, $filter, toaster, $uibModal) {
    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl._techSupportAssignCustomer = new TechSupportAssignCustomerFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.translation = translationService.translation;
        ctrl.isMissionManager = false;
        ctrl.initializeSetting();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
                //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        }
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        ctrl._techSupportAssignCustomer.isUserMissionManager().then(function (resp) {
            ctrl.isMissionManager = resp.data;
            if (ctrl.isMissionManager) {
                _tabConfiguration(
                //   {
                //         "id": "RTU to Customer",
                //         "name": "RTU to Customer",
                //         "templateName": "RTU to Customer",
                //         "templateUrl": "ui/techsupportassigncustomer/assignrtutocustomer/tech-support-assign-rtu-to-customer-template.html",
                //         "height": 135
                //   },
                {
                    "id": "Customer Access List",
                    "name": "Customer Access List",
                    "templateName": "Customer Access List",
                    "templateUrl": "ui/techsupportassigncustomer/assignusertocustomer/tech-support-assign-user-to-customer-template.html",
                    "height": 135
                });
            } else {
                _tabConfiguration(
                //   {
                //       "id": "RTU to Customer",
                //       "name": "RTU to Customer",
                //       "templateName": "RTU to Customer",
                //      "templateUrl": "ui/techsupportassigncustomer/assignrtutocustomer/tech-support-assign-rtu-to-customer-template.html",
                //       "height": 135
                //   },
                {
                    "id": "Customer Access List",
                    "name": "Customer Access List",
                    "templateName": "Customer Access List",
                    "templateUrl": "ui/techsupportassigncustomer/assignusertocustomer/tech-support-assign-user-to-customer-template.html",
                    "height": 135
                });
            }
        });
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }
    };

    ctrl.techAssignCustomerTabs = ctrl.tabConfiguration;

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });
};

TechSupportAssignCustomerController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'TechSupportAssignmentFactory', '$timeout', '$filter', 'toaster', '$uibModal'];
'use strict';

angular.module('mc.tech-support-assign-customer').component('techSupportAssignCustomer', {
    controller: TechSupportAssignCustomerController,
    templateUrl: 'ui/techsupportassigncustomer/tech-support-assign-customer-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.tech-support-assignment", []);
'use strict';

function TechSupportAssignmentFactory(HOST, $http) {

    var _techSupportAssignment = function _techSupportAssignment() {};

    _techSupportAssignment.prototype.isUserMissionManager = function () {
        return $http({
            method: 'GET',
            url: HOST + '/api/TechSupport/IsUserMissionManager/'
        });
    };

    return _techSupportAssignment;
}

TechSupportAssignmentFactory.$inject = ['HOST', '$http'];

angular.module('mc.tech-support-assignment').factory('TechSupportAssignmentFactory', TechSupportAssignmentFactory);
'use strict';

function TechSupportAssignmentController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, TechSupportAssignmentFactory, $timeout, $filter, toaster, $uibModal) {
    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl._techSupportAssignment = new TechSupportAssignmentFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.translation = translationService.translation;
        ctrl.isMissionManager = false;
        ctrl.initializeSetting();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
                //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        }
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        ctrl._techSupportAssignment.isUserMissionManager().then(function (resp) {
            ctrl.isMissionManager = resp.data;
            if (ctrl.isMissionManager) {
                _tabConfiguration({
                    "id": "Assign",
                    "name": "Assign",
                    "templateName": "Assign",
                    "templateUrl": "ui/techsupportassignment/assign/tech-support-assign-template.html",
                    "height": 135
                }, {
                    "id": "Summary",
                    "name": "Summary",
                    "templateName": "Summary",
                    "templateUrl": "ui/techsupportassignment/summary/tech-support-summary-template.html",
                    "height": 135
                }, {
                    "id": "Summary By Agent",
                    "name": "Summary By Agent",
                    "templateName": "Summary By Agent",
                    "templateUrl": "ui/techsupportassignment/summarybyagent/tech-support-summary-by-agent-template.html",
                    "height": 135
                });
            } else {
                _tabConfiguration({
                    "id": "Summary By Agent",
                    "name": "Summary By Agent",
                    "templateName": "Summary By Agent",
                    "templateUrl": "ui/techsupportassignment/summarybyagent/tech-support-summary-by-agent-template.html",
                    "height": 135
                });
            }
        });
    };

    ctrl.alertMe = function (id) {
        switch (id) {
            case 0:
                ctrl.carrierTab = "ATT";
                break;
            case 1:
                ctrl.carrierTab = "VERIZON";
                break;
            case 2:
                ctrl.carrierTab = "TELENOR";
                break;
            default:
                ctrl.carrierTab = "ATT";
                break;
        }
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/carrierdatausage/' + tab.templateName.toLowerCase().replace(' ', '-') + '-tab.html';
    };

    ctrl.carrierDataUsageTabs = ctrl.tabConfiguration;

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });
};

TechSupportAssignmentController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'TechSupportAssignmentFactory', '$timeout', '$filter', 'toaster', '$uibModal'];
'use strict';

angular.module('mc.tech-support-assignment').component('techSupportAssignment', {
    controller: TechSupportAssignmentController,
    templateUrl: 'ui/techsupportassignment/tech-support-assignment-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.controller('solarTableController', ['$scope', '$rootScope', 'translationService', 'sharedSetupService', 'openViewService', '$timeout', '$element', 'authenticationService', function ($scope, $rootScope, translationService, sharedSetupService, openViewService, $timeout, $element, authenticationService) {
    $scope.myDate = null;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
    $scope.translation = translationService.translation;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.alerts = [];

    sharedSetupService.broadcastAllDeviceSelected($scope);

    $scope.liveTable = $element.find(".headertable");

    $scope.liveDataLine = function (varLiveData) {
        if (varLiveData) {
            $scope.liveTable.addClass("live-data-line");
        } else {
            $scope.liveTable.removeClass("live-data-line");
        }
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
    });

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);
        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
				openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            //$scope.adjustDeviceIdMenuSize();
        };

        $scope.adjustDeviceIdMenuSize = function () {
            var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            if (spph < 450) {
                $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            }
            else {
                $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        };
    }
}]);

mcapp.directive('drawSolarData', ['$timeout', 'solarTableService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', function ($timeout, solarTableService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }
        scope.dateAgentText = function (input) {
            return datetimeService.formatDateAgentText(input, 'yyyy-MM-ddTHH:mm:ss', false, scope.timeFormat);
        }
        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        element.on('scroll', function (event) {
            var $rowFirst = element.contents().find("tr:first");
            var $rowLast = element.contents().find("tr:last");
            var _firstRow = $rowFirst.attr("name");
            if (typeof $rowFirst.position() !== "undefined") {
                scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
                var _tableTop = element.offset().top;
                var _rowTop = $rowFirst.offset().top;
                _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
                previousScrollbarPosition = currentScrollbarPosition;
                currentScrollbarPosition = element[0].scrollTop;
            }

            if (scope.infiniteScrollOn === true) {
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;

                if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
                    $rowLast.addClass("active-row");
                    scope.solarTableService.alerts = [];
                    scope.solarTableService.nextPage();
                }
                if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
                    $rowFirst.addClass("active-row");
                    scope.solarTableService.alerts = [];
                    scope.solarTableService.previousPage();
                }
            }

            var rows = element.children().children().children().children();
            var scrollpos = 40;
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos)
                    start = mid + 1;
                else
                    end = mid;
            }
            _updateZoom(parseFloat($($(rows[start])).attr("name")));
        });

        var _updateZoom = function (currentRow) {
            if (isNaN(currentRow))
                return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            }
            else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('solarTableService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        scope.newSolarTableService = function () {
            scope.solarTableService = new solarTableService();
            scope.solarTableService.customerId = scope.accountInfo.customerId;
            scope.solarTableService.deviceId = scope.deviceSelected;
            scope.solarTableService.windowTitle = scope.windowTitle;
            scope.solarTableService.startRow = 1;
            scope.solarTableService.pageSize = 50;
        };

        var _openTableInLiveMode = function () {
            scope.stickyProperties.on = false;
            timeLapseService.getLocalDateTime().then(function (result) {
                /////////////////////////////////////////////////////////////
                var tmpDates = new Date(result.data.localDateTime);
                var tmpDatesA = tmpDates;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
                tmpDatesA.setHours(23, 59, 59, 0);
                tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
                /////////////////////////////////////////////////////////////
                scope.newSolarTableService();
                scope.solarTableService.start = tmpDates.startDate;
                scope.solarTableService.end = tmpDatesA;
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
                scope.solarTableService.nextPage();
                /////////////////////////////////////////////////////////////
            });
        }

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                /////////////////////////////////////////////////////////////
                currentScrollbarPosition = 0;
                previousScrollbarPosition = 0;
                scope.checkFirstRowLiveStatus = null;
                /////////////////////////////////////////////////////////////
                scope.alerts = [];
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });

                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) {
                    scope.stickyProperties.on = true;
                    timeLapseService.getLocalDateTime().then(function (result) {
                        if (scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && scope.stickyProperties.zoomMax + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                            scope.newSolarTableService();
                            scope.solarTableService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
                            scope.solarTableService.end = scope.stickyProperties.dateMax;
                            scope.solarTableService.nextPage();
                        }
                        else {
                            scope.newSolarTableService();
                            scope.solarTableService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
                            scope.solarTableService.end = Math.round((scope.stickyProperties.zoomMax + scope.stickyProperties.zoomMin) / 2);
                            scope.solarTableService.nextPage();
                        }
                    });
                }
                else {
                    _openTableInLiveMode();
                }
            }
        }, true);

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                if (oldValue) {
                    _unRegisterListener(oldValue);
                }
            }
        }, true);

        scope.selectMyDate = function () {
            scope.solarTableService = new solarTableService();
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            _unRegisterListener(scope.deviceSelectedSn);
            /////////////////////////////////////////////////////////////
            var tmpDates = scope.myDate;
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
            tmpDatesA.setHours(12, 0, 0, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            scope.solarTableService.start = tmpDates.startDate;
            if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                scope.solarTableService.end = tmpDatesA;
            }
            else {
                scope.solarTableService.end = tmpDates.endDate;
            }
            /////////////////////////////////////////////////////////////
            scope.solarTableService.startRow = 1;
            scope.solarTableService.pageSize = 50;
            scope.solarTableService.customerId = scope.accountInfo.customerId;
            scope.solarTableService.deviceId = scope.deviceSelected;
            scope.solarTableService.windowTitle = scope.windowTitle;
            scope.alerts = [];
            scope.solarTableService.nextPage();
            /////////////////////////////////////////////////////////////
            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
        };

        var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            }
            else if (scope.checkFirstRowLiveStatus === null) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.checkFirstRowLiveStatus = true;
                        _checkTopOffset(liveDataStatusOn);
                    }
                    else {
                        scope.checkFirstRowLiveStatus = false;
                    }
                });
            }
        };

        var _checkTopOffset = function (liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListener(scope.deviceSelectedSn);
            }
            else {
                _unRegisterListener(scope.deviceSelectedSn);
            }
        };

        var wsDataReceivedSOLAR = function (data) {
            var i = 0;
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            var varValue = parseFloat(data.Value);
            var varType = data.Type;
            var varVBATT = null;
            var varVAC = null;

            scope.solarTableService.end = datetimeService.toUnixtime(data.Time) + scope.unixDay;

            if (varType == "VBATT") {
                varVBATT = varValue;
            }
            else {
                if(scope.solarTableService.deviceSolar){
                    varVAC = (100 * varValue + 140) / 100;
                }
                else {
                    varVAC = (100 * varValue * .707) / 100;
                }
            }

            var _newRecord;
            var _recordExistAtIndex = null;
            var _channelIndex = null;

            for (i = 0; i < scope.solarTableService.items.length; i++) {
                if (scope.solarTableService.items[i].localDateTime == varTime) {
                    _recordExistAtIndex = i;
                    if (varType == "VBATT") {
                        scope.solarTableService.items[i].battery = varVBATT;
                    }
                    else {
                        scope.solarTableService.items[i].acSupply = varVAC;
                    }
                    break;
                }
            }

            if (_recordExistAtIndex === null) {
                _newRecord = { localDateTime: varTime, battery: varVBATT, acSupply: varVAC };
                scope.solarTableService.items.unshift(_newRecord);
                _recordExistAtIndex = 0;
            }

            scope.lastUpdateAt = varTime;
        };

        var wsReconnectSOLAR = function (data) {
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            toaster.pop('success', scope.windowTitle + " -- " + scope.solarTableService.deviceName, scope.translation.text.VIEW_RELOADING);
            _openTableInLiveMode();
        };

        var _registerListener = function (varSelectedSN) {
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
            if (scope.liveData === true)
                return;
            scope.liveData = true;
            scope.liveDataLine(scope.liveData);
            scope.solarTableService.numberOfNewRecordsPrevious = -1;
            websocketService.connect();
            websocketService.register("VBATT", varSelectedSN, "", wsDataReceivedSOLAR, null); //one call-back to reconnect is enough
            websocketService.register("VAC", varSelectedSN, "", wsDataReceivedSOLAR, wsReconnectSOLAR);
        };

        var _unRegisterListener = function (varSelectedSN) {
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
            if (scope.liveData === false)
                return;
            scope.liveData = false;
            scope.liveDataLine(scope.liveData);
            scope.lastUpdateAt = undefined;
            websocketService.unRegister("VBATT", varSelectedSN, "", wsDataReceivedSOLAR, null);
            websocketService.unRegister("VAC", varSelectedSN, "", wsDataReceivedSOLAR, wsReconnectSOLAR);
        };

        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll();
            scope.checkFirstRowLiveStatus = null;
        });

        var _autoScroll = function () {
            //if (scope.savedDesktopRow) {
            //    var trRow = element.find("tr[name='" + scope.savedDesktopRow + "']");
            //    var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 10;
            //    element.scrollTop(yPosition);
            //    scope.savedDesktopRow = null;
            //}
            if (scope.solarTableService.numberOfNewRecordsPrevious > 0) {
                var trRow = element.find('tr').eq(scope.solarTableService.numberOfNewRecordsPrevious - 1);
                var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
                element.scrollTop(yPosition);
            }
            else {
                $timeout(function () {
                    element.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
        });
    };
}]);

mcapp.factory('solarTableService', ['$http', 'datetimeService', 'translationService', 'HOST', function ($http, datetimeService, translationService, HOST) {
    var SolarTableService = function () {
        this.items = [];
        this.setting = [];
        this.deviceName = '';
        this.deviceType = '';
        this.deviceSolar = '';
        this.customerId = null;
        this.deviceId = null;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.tdWidth = null;
        this.alerts = [];
        this.translation = translationService.translation;

        this.pageSize = 50;
        this.startRow = 1;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
    };

    function lowerCaseFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }

    SolarTableService.prototype.setData = function(data, isPrev) {
        var intDayWindow = 10;
        var intDay = 86400000;
        /////////////////////////
        var deviceName = data.device.name;
        var deviceType = data.device.type;
        var deviceSolar = data.device.solar;
        var setting = data.setting;
        if (this.setting.length === 0) {
            for (var i = 0; i < setting.length; i++) {
                this.setting.push(setting[i]);
            }
            this.tdWidth = parseInt(100 / (setting.length + 1)) + "%";
        }
        for(var i=0; i<setting.length; i++) {
            var set = setting[i];
            set.id = lowerCaseFirstLetter(set.id);
        }
        var items = data.solarReadings;
        if (isPrev) {
            for (var j = 0; j < items.length; j++) {
                this.items.unshift(items[j]);
            }
        }
        else {
            for (var j = 0; j < items.length; j++) {
                this.items.push(items[j]);
            }
        }
        this.deviceName = deviceName;
        this.deviceType = deviceType;
        this.deviceSolar = deviceSolar;
        this.startRow = this.startRow + items.length;
        if (items.length > 0) { //if there are records returned
            this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
            this.end = datetimeService.toUnixtime(this.items[0].localDateTime.replace(/\D/g, ''));
        }
        else if (!isPrev) {
          // If we didn't get any items back AND there aren't already any items
          if (this.items.length === 0) {
            this.alerts = [];
            var errorMessage = "No data available";
            this.alerts.push({ msg: errorMessage, type: "info" });
          }
        }
        return items.length;
    }

    SolarTableService.prototype.fetchData = function() {
        var url = HOST + "/api/SolarTable?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end;
        return $http.get(url).then(function (result) {
			    this.pageSize = 50;
                this.busy = false;
                return result.data;
            }
            .bind(this), function (error) {
                this.alerts = [];
                var errorMessage = eval("this.translation.message." + error.data.message);
                this.alerts.push({ msg: errorMessage, type: "danger" });
                this.pageSize = 50;
                this.busy = false;
            }.bind(this));
    };

    SolarTableService.prototype.previousPage = function () {
        if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
        var self = this;
        this.busy = true;
        this.pageSize = -50;
        this.fetchData().then(function(data) {
            self.numberOfNewRecordsPrevious = self.setData(data, true);
        });
    };

    SolarTableService.prototype.nextPage = function () {
        if (this.busy || this.numberOfReturnedRecords === 0) return;
        var self = this;
        this.busy = true;
        this.fetchData().then(function(data) {
            self.numberOfReturnedRecords = self.setData(data, false);
        });
    };

    return SolarTableService;
}]);

mcapp.controller('solarChartController', ['$scope', 'sharedSetupService', 'openViewService', '$element', 'authenticationService', function ($scope, sharedSetupService, openViewService, $element, authenticationService) {
    $scope.myDate = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
    $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = 20 * 60 * 1000;
    $scope.minPadding = 0;
    $scope.maxPadding = 0;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
    $scope.alerts = [];
    $scope.loadingInProgress = true;

    sharedSetupService.broadcastAllDeviceSelected($scope);
    $scope.openView = openViewService.openView;

    sharedSetupService.getWindowId($scope); 

    if ($scope.classicView && $element.parent('div').parent('div').parent('div').attr('class') && $element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") == 0) {
        $scope.largeChart = true;
        $element.height(500);
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.fnChangeLanguage = function () {
        if ($scope.alerts.length > 0) {
            var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
            var _type = $scope.alerts[0].type;
            var _languageCode = $scope.alerts[0].languageCode;
            $scope.alerts = [];
            $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        }
    };

}]);

mcapp.directive('drawSolarChart', ['$rootScope', '$timeout', 'solarChartService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'sharedSetupService', 'openViewService', 'SaveDesktopSettingService',
    function ($rootScope, $timeout, solarChartService, datetimeService, websocketService, timeLapseService, toaster, sharedSetupService, openViewService, SaveDesktopSettingService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        var chart;
        var varToggle = false;
        var xValue = null;
        var scrollingInProgress = false;
        var zoomLevelCurrent, zoomLevelPrevious = 0;
        var initialLoad = true;

        if (!$rootScope.mobile && !$rootScope.classicView) {
            scope.popup = _this.getExistingDialog(scope.windowId).ref;
            sharedSetupService.maximize(scope.popup);
        }
        element.attr("class", "chart");

        element.on('mousewheel', function (event) {
            if (!scrollingInProgress)
                scope.mouseWheelZoom(event, chart, xValue);
        });

        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                var tmpDates, tmpStartDate = null, tmpEndDate = null;
                scope.loadingInProgress = true;

                scope.saveDesktopSettingService = new SaveDesktopSettingService(newValue, scope.windowId);

                if (scope.stickyProperties.setting && scope.stickyProperties.setting.savedDesktop) {
                    scope.savedDesktopSetting = scope.stickyProperties.setting;
                }
                else {
                    scope.savedDesktopSetting = scope.saveDesktopSettingService.getObject();
                }

                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) {
                    scope.stickyProperties.on = true;
                    tmpStartDate = scope.stickyProperties.dateMin;
                    tmpEndDate = scope.stickyProperties.dateMax;
                }
                else {
                    scope.stickyProperties.on = false;
                }

                if (!tmpStartDate) {
                    timeLapseService.getLocalDateTime().then(function (result) {
                        tmpDates = new Date(result.data.localDateTime);
                        tmpDates.setHours(0, 0, 0, 0);
                        tmpDates = datetimeService.dateToUnixtime(tmpDates);
                        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                        tmpStartDate = tmpDates.startDate;
                        tmpEndDate = tmpDates.endDate;
                        _getData(newValue, tmpStartDate, tmpEndDate);
                    });
                }
                else {
                    _getData(newValue, tmpStartDate, tmpEndDate);
                }
            }
        }, true);

        var _getData = function (deviceId, StartDate, EndDate) {
            scope.liveDataEndDate = EndDate;
            var _device = { deviceName: scope.deviceSelectedName };
            solarChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + deviceId + '&StartDate=' + StartDate + '&EndDate=' + EndDate).then(function (datafromFactory) {
                scope.yAxis = datafromFactory.data.yAxis;
                scope.series = datafromFactory.data.series;
                scope.solar = datafromFactory.data.device.solar;
                scope.alerts = [];
                if (datafromFactory.data.series && datafromFactory.data.series[0].data.length >= 1) {
                    scope.devicename = datafromFactory.data.device.name;
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, windowId: scope.windowId });
                    _drawChart();
                }
                else {
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, zoomMin: scope.stickyProperties.zoomMin || StartDate, zoomMax: scope.stickyProperties.zoomMax || EndDate, windowId: scope.windowId });
                    element.empty();
                    scope.loadingInProgress = false;
                    var errormsg = scope.translation.message.NO_DATA;
                    scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                }
            });
        };

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                if (oldValue) {
                    _unRegisterListener(oldValue);
                }
            }
        }, true);

        scope.selectMyDate = function () {
            var tmpDates = scope.myDate;
            scope.loadingInProgress = true;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            solarChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromFactory) {
                scope.series = datafromFactory.data.series;
                scope.devicename = datafromFactory.data.device.name;
                scope.alerts = [];
                if (datafromFactory.data.series && datafromFactory.data.series[0].data.length >= 1) {
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, windowId: scope.windowId });
                    _drawChart();
                }
                else {
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, windowId: scope.windowId });
                    element.empty();
                    var errormsg = scope.translation.message.NO_DATA;
                    scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                    scope.loadingInProgress = false;
                }
            });
        };

        var _drawChart = function () {
            varToggle = false;
            var tmpData = scope.series, chartDrawn = false;
            var numberOfSeries, numberOfHiddenSeries = 0;

            scope.series[0].name = scope.translation.text.SOLAR_SERIE1;
            scope.series[1].name = scope.translation.text.SOLAR_SERIE2;
            scope.yAxis[0].title.text = scope.translation.text.SOLAR_SERIE1;
            scope.yAxis[1].title.text = scope.translation.text.SOLAR_SERIE2;

            var chartXaxisHourFormat = scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
            var chartToolTipHourFormat = scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

            chart = new Highcharts.StockChart({
                credits: {
                    enabled: false
                },
                legend: {
                    enabled: true,
                    backgroundColor: '#f9f9f9',
                    borderColor: '#cccccc',
                    borderWidth: 1
                },
                chart: {
                    renderTo: element[0],
                    backgroundColor: '#ebebeb',
                    plotBackgroundColor: '#f9f9f9',
                    borderColor: '#cccccc',
                    borderWidth: 1,
                    borderRadius: 2,
                    type: 'line',
                    panning: true,
                    panKey: 'shift',
                    pinchType: 'x',
                    plotBorderWidth: 1,
                    marginTop: 10,
                    marginRight: 10,
                    spacingBottom: 10,
                    spacingTop: 0,
                    spacingLeft: 2,
                    spacingRight: 5,
                    animation: false,
                    reflow: true,
                    events: {
                        redraw: function (event) {

                            var tmpDates, i,
                                solarData = [],
                                extremes = this.xAxis[0].getExtremes();

                            if (this.xAxis && chartDrawn === true && scrollingInProgress === false) {
                                if (extremes && extremes.dataMin >= extremes.min - scope.liveDataOffset) {
                                    scrollingInProgress = true;
                                    this.showLoading();

                                    tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -11);

                                    solarChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromFactory) {
                                        if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                            for (i = 0; i < datafromFactory.data.series.length; i++) {
                                                solarData.push(datafromFactory.data.series[i].data);
                                            }
                                        }

                                        if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                            for (i = 0; i < datafromFactory.data.series.length; i++) {
                                                tmpData[i].data = solarData[i].concat(tmpData[i].data);
                                                chart.series[i].setData(tmpData[i].data);
                                            }
                                        }

                                        scope.devicename = datafromFactory.data.device.name;
                                        sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, windowId: scope.windowId });
                                        chart.xAxis[0].setExtremes(extremes.min + scope.minPadding, extremes.max + scope.maxPadding);
                                        _setLiveDataStatus();

                                        $timeout(function () {
                                            scrollingInProgress = false;
                                        }, 1000);

                                        chart.hideLoading();
                                    });
                                }
                                else if (scope.liveData === false && extremes && extremes.max + scope.liveDataOffset >= extremes.dataMax) {
                                    scrollingInProgress = true;
                                    this.showLoading();

                                    tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 11);

                                    solarChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromFactory) {
                                        if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                            for (i = 0; i < datafromFactory.data.series.length; i++) {
                                                solarData.push(datafromFactory.data.series[i].data);
                                            }
                                        }

                                        if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                            for (i = 0; i < datafromFactory.data.series.length; i++) {
                                                tmpData[i].data = tmpData[i].data.concat(solarData[i]);
                                                chart.series[i].setData(tmpData[i].data);
                                            }
                                        }

                                        scope.devicename = datafromFactory.data.device.name;
                                        sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMax: tmpDates.endDate, windowId: scope.windowId });
                                        chart.xAxis[0].setExtremes(extremes.min + scope.minPadding, extremes.max + scope.maxPadding);
                                        _setLiveDataStatus(tmpDates.endDate);

                                        $timeout(function () {
                                            scrollingInProgress = false;
                                        }, 1000);

                                        chart.hideLoading();
                                    });
                                }
                            }
                        },
                        load: function (event) {
                            if (initialLoad) openViewService.adjustContentSize(scope.popup);
                            initialLoad = false;
                            $timeout(function () { scope.saveDesktopSettingService.applySavedDesktopSetting(chart, scope, false); }, 0);
                        }
                    }
                },
                title: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    text: null
                },
                exporting: {
                    enabled: true,
                    buttons: {
                        contextButton: {
                            enabled: false
                        }
                    }
                },
                xAxis: {
                    title: {
                        text: scope.translation.text.TIME,
                        style: {
                            color: '#6D869F',
                            fontWeight: 'bold',
                            fontSize: '15px'
                        }
                    },
                    plotLines: [{
                        value: 0,
                        width: 3,
                        color: 'green',
                        dashStyle: "solid",
                        zIndex: 1
                    }],
                    endOnTick: true,
                    showLastLabel: true,
                    startOnTick: true,
                    ordinal: false,
                    minTickInterval: 3600 * 1000,
                    minorGridLineColor: '#ebebeb',
                    minorTickInterval: 'auto',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        style: {
                            color: '#6D869F',
                            fontWeight: 'bold'
                        }
                    },
                    events: {
                        afterSetExtremes: function (e) {
                            if (chartDrawn === true) {
                                var extremes = chart.xAxis[0].getExtremes();
                                if (scope.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) { //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                    if (extremes.max + scope.liveDataOffset <= extremes.dataMax) {
                                        sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                                        _unRegisterListener(scope.deviceSelectedSn);
                                    }
                                }
                                sharedSetupService.setStickyProperties(scope.stickyProperties, { zoomMin: extremes.min, zoomMax: extremes.max, windowId: scope.windowId });
                                _downsampleSeries(extremes.min, extremes.max);

                            }
                        }
                    }
                },
                yAxis: scope.yAxis,
                tooltip: {
                    useHTML: true,
                    formatter: function () {
                        var d = new Date(this.x);
                        var s = '';
                        s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                        s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, this.x) + '</td></tr>';
                        $.each(this.points, function (i, point) {
                            s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, 2) + '</td></tr>';
                            xValue = point.x;
                        });
                        s += '</table>';
                        return s;
                    },
                    crosshairs: true,
                    shared: true,
                    valueDecimals: 1,
                    backgroundColor: '#FFFFFF',
                    borderColor: 'gray',
                    borderWidth: 1
                },
                navigator: {
                    enabled: true,
                    adaptToUpdatedData: true,
                    series: {
                        lineWidth: 0,
                        color: 'transparent'
                    },
                    maskFill: 'rgba(255, 255, 255, 0.35)',
                    maskInside: true,
                    handles: {
                        backgroundColor: '#a4a7a9',
                        borderColor: '#384450'
                    },
                    height: 22,
                    margin: 0,
                    xAxis: {
                        tickWidth: 2,
                        lineWidth: 1,
                        gridLineWidth: 0,
                        tickLength: 15,
                        tickPosition: 'inside',
                        tickColor: '#98b3d1',
                        dateTimeLabelFormats: {
                            hour: chartXaxisHourFormat
                        },
                        labels: {
                            align: 'left',
                            style: {
                                color: '#61768f',
                                fontWeight: 'bold'
                            },
                            x: 8,
                            y: -8
                        }
                    }
                },
                scrollbar: {
                    enabled: true,
		    		height: 0,
                    barBackgroundColor: '#959595',
                    barBorderRadius: 2,
                    barBorderWidth: 0,
                    buttonBackgroundColor: '#959595',
                    buttonBorderWidth: 0,
                    buttonBorderRadius: 2,
                    trackBackgroundColor: 'none',
                    trackBorderWidth: 1,
                    trackBorderRadius: 3,
                    trackBorderColor: '#CCC',
                    liveRedraw: true
                },
                rangeSelector: {
                    enabled: false,
                    inputEnabled: false,
                    allButtonsEnabled: true,
                    selected: 3,
                    buttons: [
                    {
                        type: 'hour',
                        count: 1,
                        text: '1h'
                    },
                    {
                        type: 'hour',
                        count: 6,
                        text: '6h'
                    },
                    {
                        type: 'hour',
                        count: 12,
                        text: '12h'
                    },
                    {
                        type: 'day',
                        count: 1,
                        text: '1d'
                    }]
                },
                plotOptions: {
                    series: {
                        dataGrouping: {
                            enabled: false
                        },
                        point: {
                            events: {
                                mouseOver: function () {
                                    xValue = this.x;
                                }
                            }
                        },
                        borderColor: 'red',
                        borderWidth: 1,
                        marker: {
                            fillColor: '#FFFFFF',
                            lineWidth: 2,
                            lineColor: null // inherit from series
                        },
                        events: {
                            legendItemClick: function () {
                                numberOfSeries = this.chart.series.length - 1;
                                var visibility = this.visible ? 'visible' : 'hidden';
                                numberOfHiddenSeries = visibility == 'hidden' ? numberOfHiddenSeries - 1 : numberOfHiddenSeries + 1;
                                numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;

                                if (numberOfHiddenSeries < numberOfSeries) {
                                    scope.saveDesktopSettingService.setSerieVisibilitySetting(this.options.id, this.visible ? false : true, scope);
                                    return true;
                                }
                                    
                                numberOfHiddenSeries = numberOfHiddenSeries - 1;
                                return false;
                            },
                            mouseOut: function () {
                                xValue = null;
                            }
                        }
                    }
                },
                series: scope.series

            });

            var tmpNewDateA;
            var tmpNewDateB;
            var extremes = chart.xAxis[0].getExtremes();

            if (scope.stickyProperties.on === true) {
                tmpNewDateA = scope.stickyProperties.zoomMin >= extremes.dataMin ? scope.stickyProperties.zoomMin : extremes.dataMin;//extremes.dataMin + scope.unixDay / 24 * 3;
                tmpNewDateB = scope.stickyProperties.zoomMax <= extremes.dataMax + scope.liveDataOffset ? scope.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
                tmpNewDateB = tmpNewDateB >= tmpNewDateA + scope.unixDay / 24 ? tmpNewDateB : extremes.dataMax - scope.unixDay / 24 * 12;
                scope.stickyProperties.on = false;
            }
            else {
                tmpNewDateA = scope.myDate !== null ? extremes.dataMin + scope.unixDay : extremes.dataMax - scope.unixDay / 24 * 12;
                tmpNewDateB = scope.myDate !== null ? tmpNewDateA + scope.unixDay : extremes.dataMax;
                if (tmpNewDateB > extremes.dataMax) {
                    tmpNewDateB = extremes.dataMax;
                    tmpNewDateA = tmpNewDateB - scope.unixDay;
                }
                tmpNewDateA = tmpNewDateA + scope.minPadding;
                tmpNewDateB = tmpNewDateB + scope.maxPadding;
            }

            chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
            if (scope.series !== null) { //only for solar chart if no setup
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: scope.windowId });
            }
            else {
                chart.showLoading('Solar Setup not available!');
            }
            _setLiveDataStatus();
            chartDrawn = true;
            scope.loadingInProgress = false;

        };
        //==========================socket data================================
        var wsDataReceivedVOLTAGE = function (data) {

            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var extremes = chart.xAxis[0].getExtremes();
            var tmpRange = extremes.max - extremes.min;

            var str = data.Time + "";
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
            var varValue = parseFloat(data.Value);
            var varType = data.Type;
            var varVBATT = null;
            var varVAC = null;

            if (varType == "VBATT") {
                varVBATT = varValue;
            }
            else {
                if (scope.solar) {
                    varVAC = (100 * varValue + 140) / 100;
                }
                else {
                    varVAC = (100 * varValue * .707) / 100;
                }
            }

            if (varType == "VBATT") {
                series = chart.get("0");
                series.addPoint([unixtime, varVBATT]);
            }
            if (varType == "VAC") {
                series = chart.get("1");
                series.addPoint([unixtime, varVAC]);
            }

            if ((extremes.max + scope.liveDataOffset > extremes.dataMax) && varType == "VBATT")
                chart.xAxis[0].setExtremes(unixtime - tmpRange + scope.minPadding, unixtime + scope.maxPadding);
            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            scope.lastUpdateAt = varTime;
        };

        var wsReconnectVOLTAGE = function (data) {
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            toaster.pop('success', scope.windowTitle + " -- " + scope.devicename, 'View reloading');
            var tmpStartDate = null, tmpEndDate = null;
            scope.stickyProperties.on = true;
            tmpStartDate = scope.stickyProperties.dateMin;
            tmpEndDate = scope.stickyProperties.dateMax;
            _getData(scope.stickyProperties.deviceId, tmpStartDate, tmpEndDate);
        };

        var tlDataReceivedVOLTAGE = function (data) {
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var extremes = chart.xAxis[0].getExtremes();
            var tmpRange = extremes.max - extremes.min;

            if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - scope.unixDay / 2) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var liveDataLine = chart.xAxis[0].plotLinesAndBands;
            liveDataLine[0].options.value = data.Unix + scope.maxPadding;

            if (extremes.max + scope.liveDataOffset > extremes.dataMax)
                chart.xAxis[0].setExtremes(data.Unix - tmpRange + scope.minPadding, data.Unix + scope.maxPadding);
        };

        var _setLiveDataStatus = function (varEndDate) {
            scope.liveDataEndDate = varEndDate != null ? varEndDate : scope.liveDataEndDate;
            timeLapseService.getLocalDateTime().then(function (result) {
                var extremes = chart.xAxis[0].getExtremes();
                if (scope.liveDataEndDate > result.data.unixTimeStamp && (scope.stickyProperties.zoomMax + scope.liveDataOffset >= extremes.dataMax)) {
                    _registerListener(scope.deviceSelectedSn);
                    var data = { Unix: result.data.unixTimeStamp, Value: null, SN: null, CH: null }
                    tlDataReceivedVOLTAGE(data);
                }
                else {
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                    _unRegisterListener(scope.deviceSelectedSn);
                }
            });
        };

        var _registerListener = function (varSelectedSN) {
            websocketService.connect();
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
            for (var i = 0; i <= 1; i++) {
                if (chart.series[i] && parseInt(chart.series[i].options.id) <= 1) {
                    if (i == 0) {
                        websocketService.register("VBATT", varSelectedSN, "", wsDataReceivedVOLTAGE, wsReconnectVOLTAGE);
                        timeLapseService.register("VBATT", varSelectedSN, "", tlDataReceivedVOLTAGE);
                    }
                    if (i == 1)
                        websocketService.register("VAC", varSelectedSN, "", wsDataReceivedVOLTAGE, null); //one call-back to reconnect is enough
                }
            }
            scope.liveData = true;
        };

        var _unRegisterListener = function (varSelectedSN) {
            websocketService.unRegister("VBATT", varSelectedSN, "", wsDataReceivedVOLTAGE, wsReconnectVOLTAGE);
            timeLapseService.unRegister("VBATT", varSelectedSN, "", tlDataReceivedVOLTAGE);
            websocketService.unRegister("VAC", varSelectedSN, "", wsDataReceivedVOLTAGE, null);
            scope.liveData = false;
            scope.lastUpdateAt = undefined;
        };

        var _downsampleSeries = function (varMin, varMax) {
            zoomLevelCurrent = varMax - varMin;
            if (zoomLevelCurrent <= scope.unixDay && zoomLevelPrevious > scope.unixDay) {
                for (var i = 0; i < chart.series.length - 1; i++) {
                    chart.series[i].update({ downsample: { threshold: 0 } }, false);
                    chart.series[i].setData(scope.series[i].data, false);
                }
                chart.redraw();
            }
            else if (zoomLevelCurrent > scope.unixDay && zoomLevelPrevious <= scope.unixDay) {
                for (var i = 0; i < chart.series.length - 1; i++) {
                    chart.series[i].update({ downsample: { threshold: 1000 } }, false);
                }
                chart.redraw();
            }
            zoomLevelPrevious = zoomLevelCurrent;
        };

        scope.$on('updatePreferencesLanguage', function () {
            _drawChart();
        });

        scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            scope.applyTimeFormat(timeFormat);
            _drawChart();
        });

        scope.applyTimeFormat = function (timeFormat) {
            scope.preferredTimeFormat = parseInt(timeFormat);
        };

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
            if (chart) chart.destroy();
            if (!angular.isUndefined(scope.stickyProperties.setting)) scope.stickyProperties.setting = null;
        });

    };
}]);

mcapp.factory('solarChartService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/SolarChart?' + varParm,
                cache: false
            });
        }
    };
}]);

"use strict";

angular.module("mc.technical-support", []);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function TechnicalSupportController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, $timeout, $filter, toaster, $uibModal) {
    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.showDatePicker = false;
    ctrl.myDate = new Date();
    ctrl.activeTab = 0;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        if (_typeof(ctrl.stickyProperties) !== 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        $scope.portalCustomerId = ctrl.stickyProperties.adminPortal.customerId;
        //ctrl.initializeSetting();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        }
    };

    ctrl.adjustSize = function () {
        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        var _tmpTopmenuHeight = 0; //ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - _tmpTopmenuHeight);
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - _tmpTopmenuHeight);

        //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
        //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
    };

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.activeTab = 0;
            ctrl.tabConfiguration = [];
            ctrl.initializeSetting();
            ctrl.technicalSupportTabs = ctrl.tabConfiguration;
        }
    }, true);

    $scope.$watch('$ctrl.myDate', function (newValue, oldValue) {
        if (newValue) {
            ctrl.myDate = newValue;
        }
    }, true);

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            ctrl.tabConfiguration.push(arguments[i]);
            // if (tmpLength == 0) {
            //     ctrl.tabConfiguration.push(arguments[i]);
            // } 
            // else {
            //     ctrl.tabConfiguration[i].name = arguments[i].name;
            // }
        }
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": "CurrentStatus",
            "name": ctrl.translation.text.CURRENT_STATUS,
            "templateName": "Current Status",
            "templateUrl": "ui/technicalsupport/currentstatus/current-status.html",
            "height": 135,
            "active": true
        });
        if ($scope.hasRMDTRadio) {
            _tabConfiguration({
                "id": "RadioUpgardeData",
                "name": 'Radio Data',
                "templateName": "Radio Upgrade Data",
                "templateUrl": "ui/technicalsupport/radioupgradedata/radio-upgrade-data.html",
                "height": 135,
                "active": false
            });
        }
        if ($scope.deviceSelectedType == 20) {
            _tabConfiguration({
                "id": "MmplusTransactionData",
                "name": 'Transaction Data',
                "templateName": "Mmpus Transaction Data",
                "templateUrl": "ui/technicalsupport/mmplustransactiondata/mmplus-transaction-data.html",
                "height": 135,
                "active": false
            });
        }
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/technicalsupport/' + tab.templateName.toLowerCase().replace(' ', '-') + '-tab.html';
    };

    ctrl.modifyTopMenu = function (tab, index) {
        ctrl.activeTab = index;
        if (tab.id == "MmplusTransactionData") {
            ctrl.showDatePicker = true;
        } else {
            ctrl.showDatePicker = false;
        }
        $rootScope.$broadcast('change_current_status_top_menu', ctrl.showDatePicker);
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });
};

TechnicalSupportController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$timeout', '$filter', 'toaster', '$uibModal'];
'use strict';

angular.module('mc.technical-support').component('technicalSupport', {
    controller: TechnicalSupportController,
    templateUrl: 'ui/technicalsupport/technical-support-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
'use strict';

angular.module('mc.station-notes', []);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function StationNotesListController($, $sce, $scope, $rootScope, $uibModal, $element, $timeout, authenticationService, translationService, StationNotesFactory, savePdfService, sharedSetupService, deviceMenuService, LoginsFactory, openViewService) {
    var ctrl = this;
    ctrl.isMcAdmin = false;
    $scope.downloadViewTypeOptions = [0];

    $scope.infiniteScroll = false;
    $scope.infiniteScrollUp = false;
    ctrl.selectNewDate = false;
    $scope.numberOfNewRecordsPrevious = -1;

    ctrl.stationNotes = [];
    ctrl.originalStationNotes = [];
    ctrl.shrinkUI = false;

    ctrl.deviceModel = [];
    ctrl.deviceData = [];
    ctrl.filterDeviceId = null;
    ctrl.deviceModelLength = null;

    ctrl.userModel = [];
    ctrl.userData = [];
    ctrl.filterUserId = null;
    ctrl.userModelLength = null;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole == 'Administrator' || ctrl.accountInfo.userRole == 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for

        ctrl.mobile = $rootScope.mobile;
        ctrl.classicView = $rootScope.classicView;

        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(this);
        $scope.downloadViewTypeOptions = [0, 2];
        if (_typeof(ctrl.stickyProperties) !== 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.myDate = new Date();
        sharedSetupService.getWindowId($scope);
        ctrl.timeOffset = ctrl.accountInfo.timeZoneOffset;

        ctrl.editModeIndex = null;
        ctrl.editMode = null;
        ctrl.addMode = null;

        ctrl.getDevices();
        ctrl.getUsers();
        ctrl.getStationNotes(ctrl.myDate);

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    adjustSize();
                }
            });
        };
    };

    var adjustSize = function adjustSize() {
        if (ctrl.shrinkUI == false && ctrl.popup.parent().width() < 725) {
            ctrl.shrinkUI = true;
        } else if (ctrl.shrinkUI == true && ctrl.popup.parent().width() >= 725) {
            ctrl.shrinkUI = false;
        }

        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

        //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
        //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
    };

    //handling infinite scrolling
    var stationNotesContainer = $element.find('#station-notes-scroll-identifier');
    stationNotesContainer.on('scroll', function (event) {
        if (stationNotesContainer[0].scrollTop + stationNotesContainer[0].offsetHeight >= stationNotesContainer[0].scrollHeight - 1 && !ctrl.selectNewDate) {
            $scope.infiniteScroll = true;
            ctrl.getStationNotes(new Date(ctrl.originalStationNotes[ctrl.originalStationNotes.length - 1].noteTime));
            return;
        }
        if (stationNotesContainer[0].scrollTop <= 0 && !ctrl.selectNewDate) {
            var today = new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate();
            var currentDate = ctrl.myDate.getFullYear() + "/" + (ctrl.myDate.getMonth() + 1) + "/" + ctrl.myDate.getDate();
            if (today == currentDate) return;
            $scope.infiniteScrollUp = true;
            ctrl.getStationNotes(new Date(ctrl.originalStationNotes[0].noteTime));
            return;
        }
    });

    $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
        var today = new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate();
        var currentDate = ctrl.myDate.getFullYear() + "/" + (ctrl.myDate.getMonth() + 1) + "/" + ctrl.myDate.getDate();
        if (today == currentDate) return;
        _autoScroll();
        //scope.checkFirstRowLiveStatus = null;
        // scope.trgScroll();
    });

    var _autoScroll = function _autoScroll() {
        if ($scope.numberOfNewRecordsPrevious > 0) {
            var trRow = stationNotesContainer.find('tr').eq($scope.numberOfNewRecordsPrevious - 1);
            var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
            stationNotesContainer.scrollTop(yPosition);
        } else {
            $timeout(function () {
                stationNotesContainer.animate({
                    scrollTop: 5
                }, 500);
            }, 0);
        }
    };

    ctrl.getStationNotes = function (endDate) {
        ctrl._loading = true;
        var varDateRangeEnd = new Date(endDate);
        // var utcEndDate = new Date(Date.UTC(
        //     varDateRangeEnd.getUTCFullYear(),
        //     varDateRangeEnd.getUTCMonth(),
        //     varDateRangeEnd.getUTCDate(),
        //     varDateRangeEnd.getUTCHours(),
        //     varDateRangeEnd.getUTCMinutes(),
        //     varDateRangeEnd.getUTCSeconds()
        // ));
        var utcEndDate = new Date(varDateRangeEnd.getTime() + ctrl.timeOffset * 60000);

        if ($scope.infiniteScroll) {
            $scope.infiniteScroll = false;

            StationNotesFactory.ListStationNotes(utcEndDate, ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone, 1).then(function (dataFromFactory) {
                $scope.alerts = [];
                ctrl.originalStationNotes = ctrl.originalStationNotes.concat(dataFromFactory.data);
                ctrl.stationNotes = ctrl.originalStationNotes.slice();

                ctrl.filterStationNotes();
                ctrl._loading = false;

                // If we didn't get any items back 
                if (ctrl.stationNotes.length == 0) {
                    var errorMessage = ctrl.translation.text.NO_DATA;
                    $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
                //     if (ctrl.stationNotes.length > 0) {
                //         for (let i = 0; i < ctrl.stationNotes.length; i++) {
                //         ctrl.stationNotes[i].regTime = ctrl.convertWithOffset(ctrl.stationNotes[i].regTime, ctrl.timeOffset);
                //     }
                // }
            }, function (error) {
                //error
            }).then(function (data) {
                ctrl._loading = false;
            });
            return;
        }

        if ($scope.infiniteScrollUp) {
            $scope.infiniteScrollUp = false;

            StationNotesFactory.ListStationNotes(utcEndDate, ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone, 0).then(function (dataFromFactory) {
                $scope.alerts = [];
                var items = dataFromFactory.data;

                if (items.every(function (element) {
                    return ctrl.originalStationNotes.indexOf(element) !== -1;
                })) {
                    ctrl._loading = false;
                    $scope.numberOfNewRecordsPrevious = -1;
                    return;
                }
                $scope.numberOfNewRecordsPrevious = items.length;
                ctrl.originalStationNotes = items.concat(ctrl.originalStationNotes);

                ctrl.stationNotes = ctrl.originalStationNotes.slice();
                ctrl.filterStationNotes();
                ctrl._loading = false;

                // If we didn't get any items back 
                if (ctrl.stationNotes.length == 0) {
                    var errorMessage = ctrl.translation.text.NO_DATA;
                    $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
                //     if (ctrl.stationNotes.length > 0) {
                //         for (let i = 0; i < ctrl.stationNotes.length; i++) {
                //             ctrl.stationNotes[i].regTime = ctrl.convertWithOffset(ctrl.stationNotes[i].regTime, ctrl.timeOffset);
                //         }
                // }
            }, function (error) {
                //error
            }).then(function (data) {
                ctrl._loading = false;
            });
            return;
        }

        StationNotesFactory.ListStationNotes(utcEndDate, ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone, 1).then(function (dataFromFactory) {
            $scope.alerts = [];
            ctrl.originalStationNotes = dataFromFactory.data;
            ctrl.stationNotes = ctrl.originalStationNotes.slice();
            ctrl.filterStationNotes();
            ctrl._loading = false;
            ctrl.selectNewDate = false;

            // If we didn't get any items back 
            if (ctrl.stationNotes.length == 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
            // if (ctrl.stationNotes.length > 0) {
            //     for (let i = 0; i < ctrl.stationNotes.length; i++) {
            //         ctrl.stationNotes[i].regTime = ctrl.convertWithOffset(ctrl.stationNotes[i].regTime, ctrl.timeOffset);
            //     }
            // }
        }, function (error) {
            //error
        }).then(function (data) {
            ctrl._loading = false;
        });
    };

    ctrl.filterStationNotes = function () {
        ctrl.stationNotes = [];
        if (ctrl.filterDeviceId == null && ctrl.filterUserId == null) {
            ctrl.stationNotes = ctrl.originalStationNotes.slice();
            return;
        }
        if (ctrl.filterDeviceId !== null && ctrl.filterUserId == null) {
            for (var i = 0; i < ctrl.originalStationNotes.length; i++) {
                if (ctrl.originalStationNotes[i].deviceId == ctrl.filterDeviceId) ctrl.stationNotes.push(ctrl.originalStationNotes[i]);
            }
            return;
        }
        if (ctrl.filterDeviceId == null && ctrl.filterUserId !== null) {
            for (var _i = 0; _i < ctrl.originalStationNotes.length; _i++) {
                if (ctrl.originalStationNotes[_i].userId == ctrl.filterUserId) ctrl.stationNotes.push(ctrl.originalStationNotes[_i]);
            }
            return;
        }
        if (ctrl.filterDeviceId !== null && ctrl.filterUserId !== null) {
            for (var _i2 = 0; _i2 < ctrl.originalStationNotes.length; _i2++) {
                if (ctrl.originalStationNotes[_i2].userId == ctrl.filterUserId && ctrl.originalStationNotes[_i2].deviceId == ctrl.filterDeviceId) ctrl.stationNotes.push(ctrl.originalStationNotes[_i2]);
            }
            return;
        }
    };

    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.devices = result.data.devices;
            var tmp = [];
            for (var i = 0; i < ctrl.devices.length; i++) {
                tmp.push({ id: ctrl.devices[i].deviceId, label: ctrl.devices[i].name });
            }
            ctrl.deviceData = tmp;
        }, function (error) {});
    };

    ctrl.deviceSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.deviceEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id == ctrl.filterDeviceId) {
                ctrl.filterDeviceId = null;
                ctrl.deviceModel = [];
            } else {
                ctrl.filterDeviceId = item.id;
            }
            ctrl.deviceModelLength = ctrl.deviceModel.length;
            ctrl.filterStationNotes();
        }
    };

    ctrl.getLdapUserInfo = function (item) {
        if (item.userType.toLowerCase().indexOf("customer") !== -1) {
            //Targeting Customer(s) and customer(s)
            return $sce.trustAsHtml(item.userFullName);
        } else {
            return $sce.trustAsHtml(item.userFullName + "<br/>(" + item.userType + ")");
        }
    };

    ctrl.getUsers = function () {
        var _logins = new LoginsFactory(ctrl.accountInfo.customerId);
        _logins.getData().then(function () {
            ctrl.logins = _logins.data;
            var tmp = [];
            for (var i = 0; i < ctrl.logins.length; i++) {
                tmp.push({ id: ctrl.logins[i].userId, label: ctrl.logins[i].fullName });
            }
            ctrl.userData = tmp;
        });
    };

    ctrl.userSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.userEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id == ctrl.filterUserId) {
                ctrl.filterUserId = null;
                ctrl.userModel = [];
            } else {
                ctrl.filterUserId = item.id;
            }
            ctrl.userModelLength = ctrl.userModel.length;
            ctrl.filterStationNotes();
        }
    };

    ctrl.findUserById = function (userId) {
        return ctrl.userData.find(function (u) {
            return u.id == userId;
        });
    };

    ctrl.removeStationNote = function (id) {
        var _this2 = this;

        ctrl.editModeIndex = null;
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = translation.text.REMOVE + " Station Note.";
            this.ok = function () {
                StationNotesFactory.DeleteStationNote(ctrl.accountInfo.customerId, id).then(function (dataFromFactory) {
                    if (dataFromFactory.data == 1) {
                        ctrl.getStationNotes(ctrl.myDate);
                        // After Removing a Latest Note the New Latest note should be updated if device selected on RTU View is same as note deleted for that device from the Table, 
                        // if not no Latest Note should be seen for the same Device
                        $rootScope.$broadcast('getLatestStationNote');
                        $uibModalInstance.close();
                    }
                }, function (error) {
                    //error
                });
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });
    };

    ctrl.addNote = function () {
        if (ctrl.addMode == -1) return false;

        $timeout(function () {
            $element.find("div[class^='tabular-data-container']").animate({
                scrollTop: 0
            }, 'slow');
        }, 0);

        var newNote = {
            noteId: -1,
            custId: ctrl.accountInfo.customerId,
            userId: ctrl.accountInfo.userId,
            deviceId: 0,
            deviceName: "",
            noteText: "",
            regTime: ctrl.currentRegTime()
        };
        ctrl.stationNotes.unshift(newNote);
        ctrl.editModeIndex = 0;
        ctrl.addMode = -1;
        ctrl.editMode = null;
        // ctrl.filterOutavailableDesktopsOnly(ctrl.logins[0]);
    };

    ctrl.currentRegTime = function () {
        var d = new Date();
        return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0') + 'T' + String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0') + ':' + String(d.getSeconds()).padStart(2, '0');
    };

    ctrl.cancelNote = function (item) {
        ctrl.editModeIndex = null;
        if (item.noteId == -1) ctrl.stationNotes.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.convertWithOffset = function (regTimeUtc, offsetMinutes) {
        var date = new Date(regTimeUtc);
        var localDate = new Date(date.getTime() - offsetMinutes * 60 * 1000);
        return localDate.getFullYear() + '-' + String(localDate.getMonth() + 1).padStart(2, '0') + '-' + String(localDate.getDate()).padStart(2, '0') + 'T' + String(localDate.getHours()).padStart(2, '0') + ':' + String(localDate.getMinutes()).padStart(2, '0') + ':' + String(localDate.getSeconds()).padStart(2, '0');
    };

    ctrl.saveNote = function (item) {
        StationNotesFactory.AddStationNotes(item.custId, item.deviceId, item.userId, item.noteText).then(function (response) {
            if (response.data == "Successfully noted") {
                ctrl.editModeIndex = null;
                ctrl.addMode = null;
                ctrl.editMode = null;
                $scope.mostRecentData();
            }
        }).catch(function (error) {
            console.error(error);
        });
    };

    ctrl.editingTo = function (name) {
        ctrl._prevName = name;
    };

    ctrl.updateStationNote = function (item) {
        StationNotesFactory.UpdateStationNote(item.noteId, item.custId, item.deviceId, item.noteText).then(function (dataFromFactory) {
            if (dataFromFactory.data) {
                ctrl.getStationNotes(ctrl.myDate);
            }
            ctrl.editModeIndex = null;
        }, function (error) {
            //error
        });
    };

    ctrl.patchData = function (item, propertyName) {
        if (item.deviceId > 0 && item[propertyName] != ctrl._prevName) {
            var device = ctrl.deviceData.find(function (u) {
                return u.id == item.deviceId;
            });
            if (device) item.deviceName = device.label;
        }
        if (!item.deviceId || item.deviceId == 0) {
            ctrl.reqDevice = true;
        } else {
            ctrl.reqDevice = false;
        };
        if (!item.noteText || item.noteText == '') {
            ctrl.reqNoteText = true;
        } else {
            ctrl.reqNoteText = false;
        };
        if (item.noteId == -1 || item[propertyName] == ctrl._prevName) return false;

        ctrl.updateValue(item, propertyName);
    };

    ctrl.updateValue = function (item, propertyName) {
        ctrl.updateStationNote(item);
    };

    $scope.$watch(function () {
        return ctrl.myDate;
    }, function (newVal, oldVal) {
        if (newVal && moment(newVal).format("YYYY/MM/DD") != moment(oldVal).format("YYYY/MM/DD")) {
            var endDate = new Date(newVal.setHours(23, 59, 59, 999));
            ctrl.stationNotes = [];
            ctrl.deviceModel = [];
            ctrl.userModel = [];
            ctrl.filterDeviceId = null;
            ctrl.filterUserId = null;
            ctrl.selectNewDate = true;
            ctrl.getStationNotes(endDate);
        }
    });

    $scope.mostRecentData = function () {
        ctrl.stationNotes = [];
        ctrl.deviceModel = [];
        ctrl.userModel = [];
        ctrl.filterDeviceId = null;
        ctrl.filterUserId = null;
        ctrl.myDate = new Date();
        ctrl.getStationNotes(ctrl.myDate);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.preferredTimeFormat = timeFormat;
        ctrl.getStationNotes(ctrl.myDate);
    });
}

StationNotesListController.$inject = ['$', '$sce', '$scope', '$rootScope', '$uibModal', '$element', '$timeout', 'authenticationService', 'translationService', 'StationNotesFactory', 'savePdfService', 'sharedSetupService', 'deviceMenuService', 'LoginsFactory', 'openViewService'];

angular.module('mc.station-notes').component('stationNotesList', {
    controller: StationNotesListController,
    transclude: true,
    templateUrl: 'ui/stationnotes/station-notes-table.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<',
        deviceSelected: '<',
        windowTitle: '<'
    }
});
'use strict';

function StationNotesFactory(HOST, $http) {

    return {
        ListStationNotes: function ListStationNotes(endDate, custId, timeZone, direction) {
            return $http({
                method: 'GET',
                url: HOST + '/api/StationNotes',
                params: { endDate: endDate, custId: custId, timeZone: timeZone, direction: direction }
            });
        },

        AddStationNotes: function AddStationNotes(custId, deviceId, userId, noteText) {
            return $http({
                method: 'POST',
                url: HOST + '/api/StationNotes/AddNote',
                params: { custId: custId, deviceId: deviceId, userId: userId, noteText: noteText }
            });
        },

        DeleteStationNote: function DeleteStationNote(custId, noteId) {
            return $http({
                method: 'DELETE',
                url: HOST + '/api/StationNotes/DeleteNote',
                params: { custId: custId, noteId: noteId }
            });
        },

        GetLatestStationNote: function GetLatestStationNote(deviceId, timeZone) {
            return $http({
                method: 'GET',
                url: HOST + '/api/StationNotes/LatestNote',
                params: { deviceId: deviceId, timeZone: timeZone }
            });
        }
    };
}

StationNotesFactory.$inject = ['HOST', '$http'];

angular.module('mc.station-notes').factory('StationNotesFactory', StationNotesFactory);
'use strict';

function StationNotesAddController($, $scope, $rootScope, $location, authenticationService, translationService, StationNotesFactory, openViewService, sharedSetupService) {
    var ctrl = this;
    ctrl.noteText = "";

    ctrl.dynamicPopover = {
        templateUrl: 'myStationNotesPopoverTemplate.html'
    };

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.isPopoverOpen = false;
        ctrl.mobile = $rootScope.mobile;
        ctrl.classicView = $rootScope.classicView;
        ctrl.translation = translationService.translation;
        ctrl.windowId = ctrl.windowId;
        $scope.windowId = ctrl.windowId;

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.deviceSelected = $scope.deviceSelected;
        ctrl.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
    };

    ctrl.$onChanges = function (changes) {
        if (changes.deviceSelected.currentValue && changes.deviceSelected.currentValue !== changes.deviceSelected.previousValue) {
            ctrl.deviceSelected = changes.deviceSelected.currentValue;
        }
    };

    ctrl.openList = function () {
        if (!ctrl.mobile && !ctrl.classicView) {
            var optionsStickyProperties = { windowId: ctrl.windowId };
            openViewService.openView('Station Notes', { width: 600, height: 500 }, undefined, optionsStickyProperties, { minimumWidth: 350, minimumHeight: 350 });
        } else {
            $location.path('/stationnotes/station-notes-template');
        }
    };

    ctrl.saveSationNotes = function () {
        StationNotesFactory.AddStationNotes(ctrl.accountInfo.customerId, ctrl.deviceSelected, ctrl.accountInfo.userId, ctrl.noteText.trim()).then(function (response) {
            ctrl.noteText = "";
            ctrl.getStationNotes();
            ctrl.openClose();
        }).catch(function (error) {
            console.error(error);
        });
    };

    // When RTU View loads/Refresh ctrl.getStationNotes() gets called to get Latest Note
    $scope.$on('getLatestStationNote', function () {
        ctrl.getStationNotes();
    });

    ctrl.getStationNotes = function () {
        StationNotesFactory.GetLatestStationNote(ctrl.deviceSelected, ctrl.accountInfo.timeZone).then(function (dataFromFactory) {
            ctrl.latestNote = dataFromFactory.data;
        }).catch(function (error) {
            console.error(error);
        });
    };

    ctrl.openClose = function () {
        ctrl.isPopoverOpen = !ctrl.isPopoverOpen;
    };
}

StationNotesAddController.$inject = ['$', '$scope', '$rootScope', '$location', 'authenticationService', 'translationService', 'StationNotesFactory', 'openViewService', 'sharedSetupService'];

angular.module('mc.station-notes').component('stationNotesAdd', {
    controller: StationNotesAddController,
    transclude: true,
    templateUrl: 'ui/stationnotes/station-notes-add.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<',
        deviceSelected: '<',
        windowTitle: '<'
    }
});
//mcapp.factory("tankAndWellService", function ($http, HOST) {
//  var tankAndWellService = {};

//  var _groundTankGetData = function (WSDeviceId,  timeZone, customerId) {
//    return $http({
//      method: 'GET',
//      url: HOST + '/api/TankAndWellGroundTank',
//      params: { WSDeviceId: WSDeviceId,  timeZone: timeZone, customerId: customerId }
//    });
//  };

//  var _getBasic = function (WSDeviceId, customerId) {
//    return $http({
//      method: 'GET',
//      url: HOST + '/api/TankAndWellBasic',
//      params: { WSDeviceId: WSDeviceId, customerId: customerId }
//    });
//  };

//  var _getPumpData = function (customerId, deviceId, channel) {
//    return $http({
//      method: 'GET',
//      url: HOST + '/api/TankAndWellPump',
//      params: { customerId: customerId, deviceId: deviceId, channel: channel }
//    });
//  };

//  var _listAll = function (customerId) {
//    return $http({
//      method: 'GET',
//      url: HOST + '/api/TankAndWellListAll',
//      params: { customerId: customerId }
//    });
//  };

//  var _getOperationLog = function (WSDeviceId, timeZone,endDate) {
//    return $http({
//      method: 'GET',
//      url: HOST + '/api/TankAndWellEventLog',
//      params: { WSDeviceId: WSDeviceId, timeZone: timeZone,endDate:endDate }
//    });
//  };

//  var _getChartData = function (WSDeviceId, startDate, endDate, customerId, timeZone) {
//    return $http({
//      method: 'GET',
//      url: HOST + '/api/TankAndWellChart',
//      params: { WSDeviceId: WSDeviceId,customerId:customerId, startDate: startDate, endDate: endDate || "null", timeZone: timeZone }
//    });
//  };

//  var _calculateRelay = function (relay, polarity) {
//    if (relay === "" || relay === "null")
//      return "";
//    else
//      return relay ^ polarity;
//  };

//  tankAndWellService.groundTankGetData = _groundTankGetData;
//  tankAndWellService.getBasic = _getBasic;
//  tankAndWellService.getPumpData = _getPumpData;
//  tankAndWellService.listAll = _listAll;
//  tankAndWellService.getOperationLog = _getOperationLog;
//  tankAndWellService.getChartData = _getChartData;
//  tankAndWellService.calculateRelay = _calculateRelay;
//  return tankAndWellService;
//});

mcapp.directive('tankAndWellPump', ["authenticationService", "datetimeService", "translationService", "tankAndWellService", "websocketService", "digitalGaugeService", "timeLapseService", '$filter',
    function (authenticationService, datetimeService, translationService, tankAndWellService, websocketService, digitalGaugeService, timeLapseService, $filter) {
        return {
            templateUrl: 'ui/tankandwell/tankandwell-pump-directive.html',
            scope: {
              destpump: '='
            },
            link: function ($scope, element, attrs) {
                $scope.accountInfo = authenticationService.getAccountInfo();
                $scope.translation = translationService.translation;
                $scope.listAll = $scope.destpump.listAll;
                $scope.showChart = $scope.destpump.showChart;
                websocketService.connect();
                $scope.pumpBusy = true;
                $scope.counter = 0;
                $scope.$on('updatePreferencesLanguage', function () {
                  $scope.pump.position = _getPumpCurrentPosition($scope.destpump.pumpId);
                  $scope.pump.modeLabel = _getMode($scope.destpump.mode);
                  _updateDuration();
                })

                var _getPumpCurrentPosition = function (pumpId) {
                  if (parseInt($scope.$parent.basic.currentLeadPump) === parseInt(pumpId))
                    return $scope.translation.text.LEAD;
                  if (parseInt($scope.$parent.basic.currentLagPump) === parseInt(pumpId))
                    return $scope.translation.text.LAG;
                  if (parseInt($scope.$parent.basic.currentLag2Pump) === parseInt(pumpId))
                    return $scope.translation.text.LAG + "2";
                  if (parseInt($scope.$parent.basic.currentLag3Pump) === parseInt(pumpId))
                    return $scope.translation.text.LAG + "3";
                  if (parseInt($scope.$parent.basic.currentLag4Pump) === parseInt(pumpId))
                    return $scope.translation.text.LAG + "4";
                }

                $scope.showDuration = function () {
                  return $scope.$parent.showDuration;
                }

                tankAndWellService.getPumpData($scope.accountInfo.customerId, $scope.destpump.deviceId, $scope.destpump.channel).then(function (resp) {
                  var data = resp.data;

                  $scope.data = data;
                  $scope.pump = {};
                  $scope.feedback = { hasfeedback: false };
                  $scope.lastStatusRegTimeUnix = datetimeService.strToUnixtime($scope.data.relayData.lastStatusRegTime);
                  $scope.lastStatusLocalTimeUnix = $scope.data.relayData.lastStatusLocalUnixTime;

                  $scope.relayReading = _UpdateValue($scope.data.relayData.latestReading, $scope.destpump.polarity);
                  var pumpName = _getPumpName($scope.destpump.label);
                  var statusMessage = _convertStatus($scope.relayReading, pumpName, $scope.destpump.wsdeviceid);
                  var modeLabel = _getMode($scope.destpump.mode);
                  $scope.pump = { pumpId: $scope.destpump.pumpId, label: pumpName, icon: statusMessage.statusImage, color: statusMessage.statusColor, status: statusMessage.statusMessage, position: $scope.destpump.position, modeLabel: modeLabel };
                  if ($scope.data.relayData.changed === 1) {
                      _updateDuration();
                  } else {
                      $scope.pump.duration = '>3 ' + $scope.translation.text.MONTH;
                  }
                  //================================================================

                  $scope.wsIdforWebS = "TW" + Array(8 - $scope.destpump.wsDeviceId.length + 1).join("0") + $scope.destpump.wsDeviceId;

                  websocketService.register("RELAYS", $scope.data.deviceLookup.serialNumber, '', wsDataReceivedTWP, wsReconnectTWP);
                  websocketService.register("ALTERNATOR", $scope.wsIdforWebS, '', wsDataReceivedAlternator, wsReconnectTWP);

                  if (!$scope.listAll) {
                      timeLapseService.register("RELAYS", $scope.data.deviceLookup.serialNumber, $scope.destpump.channel, tlDataReceivedTWP, wsReconnectTWP);
                  }
                  //=============relayPositiveFeedback=============================
                  if ($scope.data.relayPositiveFeedback !== null) {
                      digitalGaugeService.getData($scope.accountInfo.customerId, $scope.data.relayPositiveFeedback.feedbackDeviceId, $scope.accountInfo.timeZone).then(function (resp) {
                        var data2 = resp.data;

                        $scope.RPF = data2;
                        element.tooltip({
                            track: true,
                            tooltipClass: 'tooltip-jq'
                        });
                        for (var i = 0; i < $scope.RPF.digitalSettings.length; i++) {
                          var inputChannel = $scope.RPF.digitalSettings[i].channel;
                          if (inputChannel === $scope.data.relayPositiveFeedback.feedbackInputId) {
                            var digValue = $scope.RPF.digitalData['d' + inputChannel];

                            if (digValue === "True")
                              digValue = "1";
                            if (digValue === "False")
                              digValue = "0";
                            $scope.digitalReading = _convertDigital(digValue, $scope.RPF.digitalSettings[i].normalClosed);
                            $scope.digitalLocalTimeUnix = datetimeService.strToUnixtime($scope.RPF.digitalData.localTime);

                            if ($scope.digitalReading !== $scope.relayReading) {
                              var timeDiffseconds = Math.abs(parseInt($scope.digitalLocalTimeUnix - $scope.lastStatusLocalTimeUnix));
                              var duration = _millisecondsToStr(timeDiffseconds);
                              $scope.feedback = { hasFeedback: true };
                              if (timeDiffseconds <= $scope.data.relayPositiveFeedback.tripDelay * 60 * 1000) {//yellow
                                $scope.feedback.image = 'light_truetrue.png';
                                $scope.feedback.duration = $scope.translation.text.DIGITAL_MISMTCH_RELAY + ':' + duration;
                              }
                              else {//red
                                $scope.feedback.image = 'input_fault.png';
                                $scope.feedback.duration = $scope.translation.text.DIGITAL_MISMTCH_RELAY + ':' + duration;
                              }
                            }
                          };
                        }
                      })
                  };
                }, function (resp) {
                  var error = resp.data;
                  var errormsg = eval("scope.translation.message." + error.message);
                  $scope.alerts.push({ msg: errormsg, type: "danger" });
                })
                .finally(function (error) {
                  $scope.pumpBusy = false;
                });

                $scope.getPumpStyle = function () {
                  return "{'color': 'green'}"
                }

                var _getPumpName = function (label) {
                  if (label !== "" && label !== null)
                    return label;
                  else
                    return ($scope.data.deviceLookup.name + ' ' + $scope.translation.text.PUMP + ' ' + $scope.destpump.channel);
                };

                var _updateDuration = function () {
                  var duration = null;
                  timeLapseService.getLocalDateTime().then(function (resp) {
                    duration = _millisecondsToStr(resp.data.unixTimeStamp + 10000 - $scope.lastStatusLocalTimeUnix);
                    $scope.pump.duration = duration;
                  });
                };

                var _timergetDuration = function (currentTime) {
                  currentTime = parseInt(currentTime)
                  var duration = null;

                  duration = _millisecondsToStr(currentTime + 60000 - $scope.lastStatusLocalTimeUnix);
                  return duration;
                };

                var _millisecondsToStr = function (milliseconds) {
                  if (milliseconds > 0) {
                    function numberEnding(number) {
                      return (number > 1) ? 's' : '';
                    }

                    var temp = Math.floor(milliseconds / 1000);
                    var years = Math.floor(temp / 31536000);
                    if (years) {
                      return years + ' ' + $scope.translation.text.YEAR + numberEnding(years);
                    }

                    var days = Math.floor((temp %= 31536000) / 86400);
                    if (days) {
                      temp = temp - days * 86400;
                      var rhours = Math.floor((temp %= 86400) / 3600);
                      days = days + $filter('number')(rhours / 24, 1);
                      return days + ' ' + $scope.translation.text.DAY + numberEnding(days);
                    }

                    var hours = Math.floor((temp %= 86400) / 3600);
                    if (hours) {
                      temp = temp - hours * 3600;
                      var rminutes = Math.floor((temp %= 3600) / 60);
                      hours = hours + $filter('number')(rminutes / 60, 1);
                      return hours + ' ' + $scope.translation.text.HOUR + numberEnding(hours);
                    }

                    var minutes = Math.floor((temp %= 3600) / 60);
                    if (minutes) {
                      return minutes + ' ' + $scope.translation.text.MINUTE + numberEnding(minutes);
                    }

                    var seconds = temp % 60;
                    if (seconds) {
                      return seconds + ' ' + $scope.translation.text.SECOND + numberEnding(seconds);
                    }

                    return $scope.translation.text.LESS_THAN_A_SECOND;
                  } else {
                      //TODO: Does a duration of '0' make sense? Should it say something else?
                      return '0'
                  }
                };

                var _UpdateValue = function (relay, polarity) {
                  if (relay === "" || relay === "null")
                    return "";
                  else
                    return relay ^ polarity;
                };

                var _convertStatus = function (statusCode, pumpName, wsdeviceid) {
                    statusMsg = null;
                    switch (parseInt(statusCode)) {
                        default:
                        case 0: //open
                            if (pumpName.toLowerCase().indexOf("valve") >= 0) {
                                if (parseInt(wsdeviceid) !== 94)
                                    statusMsg = { statusColor: "#404040", statusImage: "valve_closed.gif", statusMessage: $scope.translation.text.STOPPED };
                                else
                                    statusMsg = { statusColor: "rgb(162, 200, 53)", statusImage: "valve_open.gif", statusMessage: $scope.translation.text.STOPPED };
                            }
                            else
                                statusMsg = { statusColor: "#404040", statusImage: "pump_off_a.gif", statusMessage: $scope.translation.text.STOPPED };
                            break;
                        case 1: //close
                            if (pumpName.toLowerCase().indexOf("valve") >= 0) {
                                if (parseInt(wsdeviceid) !== 94)
                                    statusMsg = { statusColor: "rgb(162, 200, 53)", statusImage: "valve_open.gif", statusMessage: $scope.translation.text.RUNNING };
                                else
                                    statusMsg = { statusColor: "#404040", statusImage: "valve_close.gif", statusMessage: $scope.translation.text.RUNNING };
                            }
                            else
                                statusMsg = { statusColor: "rgb(162, 200, 53)", statusImage: "pump_run_a.gif", statusMessage: $scope.translation.text.RUNNING };
                            break;
                        case null: //fault
                        case "":
                            if (pumpName.toLowerCase().indexOf("valve") >= 0)
                                statusMsg = { statusColor: "red", statusImage: "valve_fault.gif", statusMessage: $scope.translation.text.FAULT };

                            else
                                statusMsg = { statusColor: "red", statusImage: "pump_fault_a.gif", statusMessage: $scope.translation.text.FAULT };
                            break;
                    }
                    return statusMsg;
                };
                var _getMode = function (modeCode) {
                    switch (parseInt(modeCode)) {
                        default:
                        case 0:
                            return $scope.translation.text.OFF;
                            break;
                        case 1:
                            return $scope.translation.text.ON;
                            break;
                        case 2:
                            return $scope.translation.text.AUTO;
                            break;

                    }

                };

                var _convertDigital = function (Value, NomalState) {
                    if (Value === null || Value === "")
                        return null;
                    if (parseInt(Value) === parseInt(NomalState))
                        return 1;
                    else
                        return 0
                };

                var wsDataReceivedTWP = function (data) {
                    if ($scope.data.deviceLookup.serialNumber === data.SN) {
                        channel = $scope.destpump.channel;
                        var chArray = data.Value.replace(/[[\]]/g, '').split('');
                        var rawValue = chArray[channel - 1] === "C" ? 1 : 0;
                        if (rawValue !== $scope.data.relayData.latestReading) {
                            $scope.data.relayData.latestReading = rawValue;
                            $scope.relayReading = _UpdateValue($scope.data.relayData.latestReading, $scope.destpump.polarity);

                            var pumpName = _getPumpName($scope.destpump.label);
                            var statusMessage = _convertStatus($scope.relayReading, pumpName, $scope.destpump.wsdeviceid);

                            $scope.pump.color = statusMessage.statusColor;
                            $scope.pump.icon = statusMessage.statusImage;
                            $scope.pump.status = statusMessage.statusMessage;
                            $scope.lastStatusLocalTimeUnix = datetimeService.toUnixtime(data.Time);
                            _updateDuration();
                        }
                    }
                };

                var wsDataReceivedAlternator = function (data) {
                    if ($scope.wsIdforWebS === data.SN) {
                        var positionArray = data.Value.replace(/[[\]]/g, '').split(',');
                        var position = positionArray.indexOf($scope.destpump.pumpId);
                        if (position > -1) {
                            switch (position) {
                                case 0:
                                    $scope.pump.position = $scope.translation.text.LEAD;
                                    break;
                                case 1:
                                    $scope.pump.position = $scope.translation.text.LAG;
                                    break;
                                case 2:
                                    $scope.pump.position = $scope.translation.text.LAG + "2";
                                    break;
                                case 3:
                                    $scope.pump.position = $scope.translation.text.LAG + "3";
                                    break;
                                case 4:
                                    $scope.pump.position = $scope.translation.text.LAG + "4";
                                    break;
                            }
                        }
                    }
                };

                var tlDataReceivedTWP = function (data) {

                };

                var wsReconnectTWP = function () {

                }

                $scope.$watch('destpump', function (newValue, oldValue) {
                    if (newValue && newValue != oldValue) {
                        $scope.pump.label = _getPumpName(newValue.label);
                    }

                }, true);

                $scope.$on("$destroy", function () {
                    websocketService.unRegister("RELAYS", $scope.data.deviceLookup.serialNumber, '', wsDataReceivedTWP, wsReconnectTWP);
                    websocketService.unRegister("ALTERNATOR", $scope.wsIdforWebS, '', wsDataReceivedAlternator, wsReconnectTWP);
                    if (!$scope.listAll) {
                        timeLapseService.unRegister("RELAYS", $scope.data.deviceLookup.serialNumber, $scope.destpump.channel, tlDataReceivedTWP, wsReconnectTWP);
                    }
                });

                element.tooltip({
                    track: true,
                    tooltipClass: 'tooltip-jq',
                    content: function () {
                        return $(this).prop('title');
                    }
                });
            }
        };
    }]);

mcapp.controller("tankAndWellOperationlogController", ["$scope", "authenticationService", "translationService", "tankAndWellService", "sharedSetupService",
  function ($scope, authenticationService, translationService, tankAndWellService, sharedSetupService) {
    if (typeof $scope.stickyProperties != 'object') {
      $scope.stickyProperties = $scope.stickyPropertiesInterface;
    }
    sharedSetupService.setStickyProperties($scope.stickyProperties, {windowId: $scope.windowId});
    $scope.translation = translationService.translation;
    $scope.popup = _this.getExistingDialog($scope.windowId).ref;
    $scope.WSDeviceId = $scope.stickyProperties.deviceId;
    $scope.title = $scope.stickyProperties.device.title || $scope.stickyProperties.device.channel;
    $scope.popup.dialog("option", "title", $scope.translation.text.TANK_AND_WELL_LOG + ", " + $scope.title);
  }
]);

mcapp.directive('tankAndWellOperationLog', ["authenticationService", "sharedSetupService", "openViewService", "translationService", "tankAndWellService", "websocketService", "datetimeService",
  function (authenticationService, sharedSetupService, openViewService, translationService, tankAndWellService, websocketService, datetimeService) {
    return {
      restrict: 'E',
      templateUrl: 'ui/tankandwell/tankandwell-operationlog-directive.html',
      replace: false,
      transclude: true,
      link: function ($scope, element, attrs) {
        var accountInfo = authenticationService.getAccountInfo();
        var endTime = (new Date).getTime();

        $scope.liveTable = element.find(".headertable");

        if (!$scope.mobile && !$scope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);
        }

        $scope.liveDataLine = function (varLiveData) {
            if (varLiveData) {
                $scope.liveTable.addClass("live-data-line");
            } else {
                $scope.liveTable.removeClass("live-data-line");
            }
        };

        $scope.operationLogs = [];
        $scope.pageloading = true;
        $scope.translation = translationService.translation;

        var logdiv = element.find('#operations-log-table');
        logdiv.on('scroll', function (event) {
          if(logdiv[0].scrollTop + logdiv[0].offsetHeight + 5 > logdiv[0].scrollHeight)
            getData();
        });

        $scope.$on("$destroy", function () {
            _unRegisterListener();
        });

        $scope.dateAgentText = function (date) {
            return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, accountInfo.preferenceUser.timeFormat);
        }

        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
				openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            open: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 25); //25: total padding

        };

        function getData() {
          if ($scope.busy) return;
          $scope.busy = true;

          tankAndWellService.getOperationLog($scope.WSDeviceId, accountInfo.timeZone, endTime).then(function (resp) {
            var data = resp.data;

            $scope.pageloading = false;
            $scope.operationLogs = $scope.operationLogs.concat(data);
            endTime = datetimeService.strToUnixtime(data[data.length - 1].localTime);
            if ($scope.operationLogs.length <= 0) {
              var errormsg = $scope.translation.message.NO_DATA;
              $scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            }
            _registerListener();
          }).finally(function () {
            $scope.busy = false;
          });
        };

        getData();

        var wsDataReceivedEventLog = function (data) {
            if ($scope.liveData === false) {
                _unRegisterListener();
                return;
            }

            _newRecord = { localTime: datetimeService.socketStrToServerStrTime(data.Time), eventInfo: data.Value };
            $scope.operationLogs.unshift(_newRecord);
            $scope.lastUpdateAt = datetimeService.socketStrToServerStrTime(data.Time);
        };

        var wsReconnectEventLog = function (data) {
            if ($scope.liveData === false) {
                _unRegisterListener();
                return;
            }
        };

        var _registerListener = function () {
            if ($scope.liveData === true)
                return;
            $scope.liveData = true;
            $scope.liveDataLine($scope.liveData);
            websocketService.connect();

            websocketService.register("EVENTLOG", generateWSID($scope.WSDeviceId), "", wsDataReceivedEventLog, wsReconnectEventLog);
        };

        var _unRegisterListener = function () {
            if ($scope.liveData === false)
                return;
            $scope.liveData = false;
            $scope.liveDataLine($scope.liveData);
            this.lastUpdateAt = undefined;

            websocketService.unRegister("EVENTLOG", generateWSID($scope.WSDeviceId), "", wsDataReceivedEventLog, wsReconnectEventLog);
        };

        var generateWSID = function (wsid) {
          var WSID = "TW";
          var length = 8 - wsid.toString().length;

          for (var i = 0; i < length; i++)
            WSID += "0";

          WSID += wsid;

          return WSID;
        }
      }
  };
}]);

angular.module('tank-and-well', []);

mcapp.controller("tankAndWellListAllController", ["$scope", "$rootScope", "authenticationService", "translationService", "tankAndWellService", "sharedSetupService", "openViewService",
  function ($scope, $rootScope, authenticationService, translationService, tankAndWellService, sharedSetupService, openViewService) {
    //login mission/missionalle 605 has 6 tank and wells
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.translation = translationService.translation;
    $scope.popup = _this.getExistingDialog($scope.windowId).ref;
    tankAndWellService.listAll( $scope.accountInfo.customerId).then(function (resp) {
      var data = resp.data;
      if (data.length <= 0) {
        this.alerts = [];
        this.alerts.push({ msg: this.translation.message.NO_DATA, type: "info" });
      }
      else {
        $scope.listTankAndWell = data;
      }
    }, function (resp) {
      var error = resp.data;
      var errormsg = eval("scope.translation.message." + error.message);
      scope.alerts.push({ msg: errormsg, type: "danger" });
    });

      $scope.sortableOptions = {
          handle: '.sort-yes'
      };

      if (!$rootScope.mobile && !$rootScope.classicView) {
      $scope.popup = _this.getExistingDialog($scope.windowId).ref;
      $scope.popup.dialog({
        resize: function (event, ui) {
          $scope.adjustSize();
        }
      });

      $scope.popup.dialogExtend({
        maximize: function (event, ui) {
          openViewService.adjustContentSizeStart($scope.popup);
          $scope.adjustSize();
        },
        restore: function (event, ui) {
		  openViewService.adjustContentSizeStart($scope.popup);
          $scope.adjustSize();
        }
      });

      $scope.adjustSize = function () {
        $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
        $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        //$scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 25); //25: total padding
        //$scope.adjustDeviceIdMenuSize();
      };

      $scope.adjustDeviceIdMenuSize = function () {
        var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        if (spph < 450) {
          $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
        }
        else {
          $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
        }
      };
    }
  }
]);

mcapp.directive('tankAndWell', ["authenticationService", "translationService", "tankAndWellService", "websocketService", "sharedSetupService", "openViewService", "$timeout",
  function (authenticationService, translationService, tankAndWellService, websocketService, sharedSetupService, openViewService, $timeout) {
    return {
      templateUrl: 'ui/tankandwell/tankandwell-directive.html',
      replace: false,
      scope: {
        WSDeviceId: '@wsdeviceid',
        viewType: '@viewtype',
        popup: '=popup'
      },
      link: function ($scope, element, attrs) {
        $scope.showDuration = true;
        $scope.listAll = false;
        $scope.showChart = false;
        $scope.showGroundTank = false;
        //Default sort by name
        $scope.sortBy = "name";

        //element.tooltip({
        //  track: true,
        //  tooltipClass: 'tooltip-jq'
        //});

        switch ($scope.viewType) {
          default:
          case "listall":
            $scope.listAll = true;
          case "chart":
            $scope.showChart = true;
            break;
          case "tank":
            $scope.showGroundTank = true;
            break;
        }

        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.translation = translationService.translation;
        $scope.popupOffset = 0;
        $scope.destPumpArray = [];

        var _getTitle = function (deviceName, sourceName, channel, channelName) {
          var title = null;
          title = "";
          if (sourceName !== null && sourceName != "")
            title += sourceName;
          else
            title += deviceName;
          if (channelName !== null && channelName !== "")
            title += " : " + channelName;
          else
            title += " : Channel " + channel;

          return title;
        };

        var _getPumpCurrentPosition = function (pumpId) {
          if (parseInt($scope.basic.currentLeadPump) === parseInt(pumpId))
            return $scope.translation.text.LEAD;
          if (parseInt($scope.basic.currentLagPump) === parseInt(pumpId))
            return $scope.translation.text.LAG;
          if (parseInt($scope.basic.currentLag2Pump) === parseInt(pumpId))
            return $scope.translation.text.LAG + "2";
          if (parseInt($scope.basic.currentLag3Pump) === parseInt(pumpId))
            return $scope.translation.text.LAG + "3";
          if (parseInt($scope.basic.currentLag4Pump) === parseInt(pumpId))
            return $scope.translation.text.LAG + "4";
        }

        var _getPumpPositionIndex = function (pumpId) {
          if (parseInt($scope.basic.currentLeadPump) === parseInt(pumpId))
            return 0;
          if (parseInt($scope.basic.currentLagPump) === parseInt(pumpId))
            return 1;
          if (parseInt($scope.basic.currentLag2Pump) === parseInt(pumpId))
            return 2;
          if (parseInt($scope.basic.currentLag3Pump) === parseInt(pumpId))
            return 3;
          if (parseInt($scope.basic.currentLag4Pump) === parseInt(pumpId))
            return 4;
        }

        $scope.sortByPosition = function () {
          $scope.sortBy = "position";
        }

        $scope.sortByName = function () {
          $scope.sortBy = "name";
        }

        $scope.sortPumps = function (pump) {
          if ($scope.sortBy === "position")
            return pump.positionIdx;
          else {
            return pump.pumpId;
          }
        }

        var _resizeWhenLog = function () {
          // $scope.showDuration = true;
          // var showDuration = true;
          // $timeout(function () {
          //   for (var i = 1; i <= 5; i++) {
          //     var span = document.getElementById('pumplabel_'+i);
          //     if (span != null && span.getClientRects().length > 1) {
          //       showDuration = false;
          //     }
          //   }
          //   $scope.showDuration = showDuration;
          // })
          // if ($scope.showGroundTank) {
          //   $scope.wheight = $scope.popup.outerHeight() - 30;
          //   $scope.tankpumpheight = $scope.wheight - 30;
          //   $scope.popup.find('.toptank').css("height", $scope.wheight);
          //   $scope.popup.find('.toptank').css("width", ($scope.popup.outerWidth() - 10) * .40);
          //   $scope.popup.find('.TopPump').css("width", ($scope.popup.outerWidth() - 10) * .60);
          //   $scope.popup.find('.TopPump').css("height", $scope.wheight);
          // }
          // if ($scope.showChart) {
          //   // $scope.pumpheight = 60 * $scope.destPumpArray.length;
          //   // $scope.chartheight = ($scope.popup.outerHeight() - 10);// - $scope.pumpheight;
          //   //
          //   // //$scope.popup.find('.BottomPump').css("height", $scope.pumpheight);
          //   // $scope.chartwidth = $scope.popup.outerWidth() - 10;
          //   // $scope.popup.find('.tankchart').css("height", $scope.chartheight);
          //   // $scope.popup.find('.tankchart').css("width", $scope.chartwidth);
          //   // var _char = $scope.popup.find(".tankchart").highcharts();
          //   // _char.reflow();
          // }
          // $scope.$apply();
        };

        tankAndWellService.getBasic($scope.WSDeviceId, $scope.accountInfo.customerId).then(function (resp) {
          var data = resp.data;

          //=============ground tank ===========================
          $scope.basic = data.tankAndWellBasic;
          $scope.sourceDevice = data.sourceDevice;
          $scope.tankAndWellLabels = data.tankAndWellLabels;
          $scope.analogSetting = data.analogSetting;
          $scope.sourceDeviceId = $scope.basic.sourceDeviceId;
          $scope.sourceChannel = $scope.basic.sourceAnalogChannel;

          $scope.title = _getTitle($scope.sourceDevice.name, $scope.tankAndWellLabels.labelSource, $scope.basic.sourceAnalogChannel, $scope.analogSetting === null ? '' : $scope.analogSetting.name);

          if (!$scope.listAll) {
            $scope.popup.dialog("option", "title", $scope.translation.text.TANK_AND_WELL + ", " + $scope.title);
          }
          //=============ground tank ===========================

          //=============pumps ===========================
          var pumpColors = ["#2288cc", "#dd3322", "#22aa99", "#bb4488", "#ddaa00", "#6655cc", "#99aa00", "#dd7722"];
          if ($scope.basic.destPump1DeviceId !== 0) {
            var pumpCurrentPosition = _getPumpCurrentPosition(1);
            var pumpPositionIdx = _getPumpPositionIndex(1);
            var pump = { wsDeviceId: $scope.WSDeviceId, deviceId: $scope.basic.destPump1DeviceId, pumpId: 1, color: pumpColors[0], position: pumpCurrentPosition, positionIdx: pumpPositionIdx, mode: $scope.basic.destPump1Mode, polarity: $scope.basic.destPump1Polarity, channel: $scope.basic.destPump1Relay, label: data.tankAndWellLabels.labelPump1, listAll: $scope.listAll, showChart: $scope.showChart };
            $scope.destPumpArray.push(pump);
          }
          if ($scope.basic.destPump2DeviceId !== 0) {
            var pumpCurrentPosition = _getPumpCurrentPosition(2);
            var pumpPositionIdx = _getPumpPositionIndex(2);
            var pump = { wsDeviceId: $scope.WSDeviceId, deviceId: $scope.basic.destPump2DeviceId, pumpId: 2, color: pumpColors[1], position: pumpCurrentPosition, positionIdx: pumpPositionIdx, mode: $scope.basic.destPump2Mode, polarity: $scope.basic.destPump2Polarity, channel: $scope.basic.destPump2Relay, label: data.tankAndWellLabels.labelPump2, listAll: $scope.listAll, showChart: $scope.showChart };
            $scope.destPumpArray.push(pump);
          }
          if ($scope.basic.destPump3DeviceId !== 0) {
            var pumpCurrentPosition = _getPumpCurrentPosition(3);
            var pumpPositionIdx = _getPumpPositionIndex(3);
            var pump = { wsDeviceId: $scope.WSDeviceId, deviceId: $scope.basic.destPump3DeviceId, pumpId: 3, color: pumpColors[2], position: pumpCurrentPosition, positionIdx: pumpPositionIdx, mode: $scope.basic.destPump3Mode, polarity: $scope.basic.destPump3Polarity, channel: $scope.basic.destPump3Relay, label: data.tankAndWellLabels.labelPump3, listAll: $scope.listAll, showChart: $scope.showChart };
            $scope.destPumpArray.push(pump);
          }
          if ($scope.basic.destPump4DeviceId !== 0) {
            var pumpCurrentPosition = _getPumpCurrentPosition(4);
            var pumpPositionIdx = _getPumpPositionIndex(4);
            var pump = { wsDeviceId: $scope.WSDeviceId, deviceId: $scope.basic.destPump4DeviceId, pumpId: 4, color: pumpColors[3], position: pumpCurrentPosition, positionIdx: pumpPositionIdx, positionIdx: pumpPositionIdx, mode: $scope.basic.destPump4Mode, polarity: $scope.basic.destPump4Polarity, channel: $scope.basic.destPump4Relay, label: data.tankAndWellLabels.labelPump4, listAll: $scope.listAll, showChart: $scope.showChart };
            $scope.destPumpArray.push(pump);
          }
          if ($scope.basic.destPump5DeviceId !== 0) {
            var pumpCurrentPosition = _getPumpCurrentPosition(5);
            var pumpPositionIdx = _getPumpPositionIndex(5);
            var pump = { wsDeviceId: $scope.WSDeviceId, deviceId: $scope.basic.destPump5DeviceId, pumpId: 5, color: pumpColors[4], position: pumpCurrentPosition, positionIdx: pumpPositionIdx, mode: $scope.basic.destPump5Mode, polarity: $scope.basic.destPump5Polarity, channel: $scope.basic.destPump5Relay, label: data.tankAndWellLabels.labelPump5, listAll: $scope.listAll, showChart: $scope.showChart };
            $scope.destPumpArray.push(pump);
          }

          if ($scope.destPumpArray.length > 0)
            $scope.hasPump = true;
          else
            $scope.hasPump = false;
          //=============pumps ===========================

          if (!$scope.listAll) {
            $scope.logheight = 40;
            $scope.wheight = $scope.popup.dialog("option", "height") - 50;
            $scope.tankpumpheight = $scope.wheight - 30;
            $scope.pumpheight = 60 * $scope.destPumpArray.length;
            $scope.chartheight = ($scope.popup.outerHeight() - 10);// - $scope.pumpheight;
            $scope.popup.dialog({
              resizeStop: function (event, ui) {
                $('#map').removeClass('no-events');
                _resizeWhenLog();
              }
            });

            $scope.popup.dialogExtend({
              maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                _resizeWhenLog();
              },
              restore: function (event, ui) {
				  openViewService.adjustContentSizeStart($scope.popup);
                _resizeWhenLog();
              }
            });
          }
        }, function (resp) {
          var error = resp.data;
          var errormsg = eval("$scope.translation.message." + error.message);
          $scope.alerts.push({ msg: errormsg, type: "danger" });
        }).finally(function () {
          $scope.pageloading = false;
        });

        $scope.getStyle = function (index) {
          if (index !== 0)
            return "border-top: 1px solid #ccc;";
        };

        $scope.openDetail = function (chartType) {
          //var mcDevice = { wsDeviceId: $scope.WSDeviceId, chartType: chartType };

          // var optionsStickyProperties = {
          //   device: mcDevice
          // };
          // optionsStickyProperties.deviceId = $scope.WSDeviceId;
          var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
          //optionsStickyProperties.analogIntertieId = analogIntertieId;
          optionsStickyProperties.deviceId = $scope.WSDeviceId;
          optionsStickyProperties.device = { wsDeviceId: $scope.WSDeviceId, chartType: chartType, channel: chartType };
          var popheight = 500;
          var minwidth = 500;
          if (chartType == 'tank') {
            popheight = 400;
            minwidth = 625;
          }
          $scope.popupPosition = $scope.popup.dialog("option", "position");
          $scope.newPopupPosition = {
            at: $scope.popupPosition.at,
            my: $scope.popupPosition.my,
            collision: $scope.popupPosition.collision,
            of: $scope.popupPosition.of,
            using: $scope.popupPosition.using
          };
          var x = $scope.popup.offset().left;
          var y = $scope.popup.offset().top;
          var dialogWidth = $scope.popup.dialog("option", "width");
          var windowWidth = window.innerWidth;
          $scope.newPopupPosition.at = "left+" + (x + dialogWidth + $scope.popupOffset) + " top+" + (y + $scope.popupOffset);
          $scope.popupOffset = $scope.popupOffset + 10;
          openViewService.openView('Tank And Well', { width: 650, height: popheight }, $scope.newPopupPosition, optionsStickyProperties, { minimumWidth: minwidth, minimumHeight: 300 });
        };

        $scope.openLog = function () {
          // var mcDevice = { wsDeviceId: $scope.WSDeviceId, title: $scope.title };
          //
          // var optionsStickyProperties = {
          //     device: mcDevice
          // };
          var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
          optionsStickyProperties.deviceId = $scope.WSDeviceId;
          optionsStickyProperties.device = { wsDeviceId: $scope.WSDeviceId, title: $scope.title, channel: $scope.title };
          $scope.popupPosition = $scope.popup.dialog("option", "position");
          $scope.newPopupPosition = {
            at: $scope.popupPosition.at,
            my: $scope.popupPosition.my,
            collision: $scope.popupPosition.collision,
            of: $scope.popupPosition.of,
            using: $scope.popupPosition.using
          };
          var x = $scope.popup.offset().left;
          var y = $scope.popup.offset().top;
          var dialogWidth = $scope.popup.dialog("option", "width");
          var windowWidth = window.innerWidth;
          $scope.newPopupPosition.at = "left+" + (x + dialogWidth + $scope.popupOffset) + " top+" + (y + $scope.popupOffset);
          $scope.popupOffset = $scope.popupOffset + 10;

          openViewService.openView('Tank And Well Log', { width: 600, height: 400 }, $scope.newPopupPosition, optionsStickyProperties);
        };

        $scope.openChart = function () {
          var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
          optionsStickyProperties.deviceId = $scope.WSDeviceId;
          optionsStickyProperties.device = { wsDeviceId: $scope.WSDeviceId, title: $scope.title, channel: $scope.title };
          $scope.popupPosition = $scope.popup.dialog("option", "position");
          $scope.newPopupPosition = {
            at: $scope.popupPosition.at,
            my: $scope.popupPosition.my,
            collision: $scope.popupPosition.collision,
            of: $scope.popupPosition.of,
            using: $scope.popupPosition.using
          };
          var x = $scope.popup.offset().left;
          var y = $scope.popup.offset().top;
          var dialogWidth = $scope.popup.dialog("option", "width");
          var windowWidth = window.innerWidth;
          $scope.newPopupPosition.at = "left+" + (x + dialogWidth + $scope.popupOffset) + " top+" + (y + $scope.popupOffset);
          $scope.popupOffset = $scope.popupOffset + 10;

          openViewService.openView('Tank And Well Chart', { width: 600, height: 550 }, $scope.newPopupPosition, optionsStickyProperties);
        }
      }
    }
  }
]);

mcapp.controller("tankAndWellController", ["$scope", "authenticationService", "translationService", "tankAndWellService", "sharedSetupService",
  function ($scope, authenticationService, translationService, tankAndWellService, sharedSetupService) {
    if (typeof $scope.stickyProperties != 'object') {
      $scope.stickyProperties = $scope.stickyPropertiesInterface;
    }
    sharedSetupService.setStickyProperties($scope.stickyProperties, {windowId: $scope.windowId});

    $scope.wsDeviceId = $scope.stickyProperties.deviceId;
    $scope.popup = _this.getExistingDialog($scope.windowId).ref;
    $scope.viewType = $scope.stickyProperties.device.chartType || $scope.stickyProperties.device.channel;
  }
]);

mcapp.controller("tankAndWellChartController", ["$scope", "authenticationService", "translationService", "tankAndWellService", "sharedSetupService",
  function ($scope, authenticationService, translationService, tankAndWellService, sharedSetupService) {
    if (typeof $scope.stickyProperties != 'object') {
      $scope.stickyProperties = $scope.stickyPropertiesInterface;
    }
    sharedSetupService.setStickyProperties($scope.stickyProperties, {windowId: $scope.windowId});
    $scope.translation = translationService.translation;
    $scope.popup = _this.getExistingDialog($scope.windowId).ref;
    $scope.WSDeviceId = $scope.stickyProperties.deviceId;
    $scope.title = $scope.stickyProperties.device.title || $scope.stickyProperties.device.channel;
    $scope.popup.dialog("option", "title", $scope.translation.text.TANK_AND_WELL + " " + $scope.translation.text.CHART + ", " + $scope.title);
  }
]);

mcapp.directive('tankAndWellChartOld', ["authenticationService", "toaster", "translationService", "tankAndWellService", "websocketService", "datetimeService", "timeLapseService", "sharedSetupService", "$timeout",
  function (authenticationService, toaster, translationService, tankAndWellService, websocketService, datetimeService, timeLapseService, sharedSetupService, $timeout) {
      return {
          link: function ($scope, element, attrs) {
              websocketService.connect();
              var chart;
              $scope.chartBusy = true;
              $scope.pageloading = true;
              $scope.$parent.loadingInProgress = true;
              $scope.accountInfo = authenticationService.getAccountInfo();
              $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
              $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
              $scope.translation = translationService.translation;
              $scope.unixDay = sharedSetupService.unixDay;
              $scope.scrollingInProgress = false;
              $scope.liveDataOffset = 20 * 60 * 1000;
              $scope.minPadding = 0;
              $scope.maxPadding = 0;
              $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
              var xValue = null;
              if (!$scope.mobile && !$scope.classicView) {
                  $scope.popup = _this.getExistingDialog($scope.windowId).ref;
                  sharedSetupService.maximize($scope.popup);
              }
              element.attr("class", "chart");

              element.on('mousewheel', function (event) {
                  if (!$scope.scrollingInProgress)
                      $scope.mouseWheelZoom(event, chart, xValue);
              });

              $scope.$on('updatePreferencesLanguage', function () {
                  _drawChart();
              })

              $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
                  $scope.applyTimeFormat(timeFormat);
                  _drawChart();
              });

              $scope.applyTimeFormat = function (timeFormat) {
                  $scope.preferredTimeFormat = parseInt(timeFormat);
              };

              timeLapseService.getLocalDateTime().then(function (result) {
                  tmpDates = new Date(result.data.localDateTime);
                  $scope.currentUnixTime = datetimeService.dateToUnixtime(tmpDates);//current date time 2015/7/1 10:00:00
                  tmpDates.setHours(0, 0, 0, 0);
                  tmpDates = datetimeService.dateToUnixtime(tmpDates);//current date from midnight eg2015/7/1 00:00:00
                  $scope.currentUnixDate = tmpDates;
                  tmpDates = datetimeService.getNewStartEndDates(tmpDates, -3);
                  tmpStartDate = tmpDates.startDate;
                  tmpEndDate = tmpDates.endDate;
                  _getData(tmpStartDate, tmpEndDate);
              });

              var _getData = function (startDate, endDate) {
                  $scope.liveDataEndDate = endDate;
                  tankAndWellService.getChartData($scope.WSDeviceId, startDate, endDate, $scope.accountInfo.customerId, $scope.accountInfo.timeZone).then(function(resp) {
                      var data = resp.data;

                      $scope.series = data.series;
                      $scope.tankAndWellAnalog = data.tankAndWellAnalog;
                      $scope.tankAndWellRelay = data.tankAndWellRelay;
                      $scope.tankAndWellBasic = data.tankAndWellBasic;
                      $scope.flagSeries = data.flagSeries;
                      $scope.allSeries = $scope.series;
                      $scope.yAxis = data.yAxis;
                      $scope.plotLines = data.plotLines;
                      $scope.tankAndWellDisplay = data.tankAndWellDisplay;
                      $scope.analogName = data.tankAndWellAnalog.analogSetting.name + " (" + data.tankAndWellAnalog.analogSetting.unit + ")";
                      $scope.tickInterval = ($scope.tankAndWellDisplay.chartTop - $scope.tankAndWellDisplay.chartBottom) / $scope.tankAndWellDisplay.chartGrid;
                      _drawChart();
                      //_registerListener();
                  }, function(resp) {
                      var error = resp.data;

                      var errormsg = eval("$scope.translation.message." + error.message);
                      $scope.alerts.push({ msg: errormsg, type: "danger" });
                  }).finally(function() {
                      $scope.pageloading = false;
                      $scope.$parent.loadingInProgress = false;
                      $scope.chartBusy = false;
                  });
              };

              var _drawChart = function () {
                  $scope.chartDrawn = false;
                  //element.find('.tankchart').css("height", $scope.chartheight);

                  var chartXaxisHourFormat =
                      $scope.preferredTimeFormat === $scope.TimeFormatEnum.Civilian
                      ? '%l:%M %P'
                      : '%H:%M';

                  Highcharts.setOptions({
                      chart: {
                          style: {
                              fontFamily: 'arial'
                          }
                      },
                      loading: {
                          labelStyle: {
                              color: 'black'
                          },
                          style: {
                              position: 'absolute',
                              backgroundColor: 'transparent',
                              opacity: 1,
                              textAlign: 'center'
                          }
                      },
                      lang: {
                          loading: '<div class="imgtxtlod" title="Loading data..."><i class="fa fa-spinner fa-spin fa-3x red imglodred"></i> <span class="txtlodblk">Loading data...</span></div>',
                          rangeSelectorZoom: ''
                      }
                  });

                  chart = new Highcharts.StockChart({
                      alignTicks: false,
                      credits: {
                          enabled: false
                      },
                      legend: {
                          enabled: true,
                          backgroundColor: '#f9f9f9',
                          borderColor: '#cccccc',
                          borderWidth: 1,
                          itemHoverStyle: {
                          	cursor: 'default'
                          }
                      },
                      yAxis: [
                        {
                            //height: '90%',
                            gridLineWidth: 0,
                            min: $scope.tankAndWellDisplay.chartBottom,
                            max: $scope.tankAndWellDisplay.chartTop,
                            lineWidth: 2,
                            opposite: false,
                            startOnTick: true,
                            endOnTick: true,
                            minPadding: 0,
                            showLastLabel: false,
                            showFirstLabel: true,
                            labels: {
                                format: "{value:.2f}"
                            },
                            title: { text: $scope.analogName, style: { color: "#000" } },
                            plotLines: $scope.plotLines
                        },
                      {
                          top: '90%',
                          height: '10%',
                          offset: 0,
                          gridLineWidth: 0,
                          lineWidth: 0,
                          showLastLabel: true,
                          showFirstLabel: true,
                          startOnTick: true,
                          endOnTick: true,
                          opposite: false,
                          min: -5,
                          max: 0,
                          steps: 1,
                          labels: {
                              enabled: false
                          }
                      },
                      {
                          height: '90%',
                          gridLineWidth: 0,
                          minorGridLineWidth: 0,
                          lineWidth: 2,
                          opposite: true,
                          startOnTick: true,
                          endOnTick: true,
                          labels: {
                              enabled: false
                          }
                      }
                      ],
                      chart: {
                          renderTo: element[0],
                          backgroundColor: '#ebebeb',
                          plotBackgroundColor: '#f9f9f9',
                          borderColor: '#cccccc',
                          borderWidth: 1,
                          borderRadius: 2,
                          panning: true,
                          panKey: 'shift',
                          pinchType: 'x',
                          plotBorderWidth: 1,
                          marginTop: 10,
                          marginRight: 10,
                          spacingBottom: 10,
                          spacingTop: 0,
                          spacingLeft: 2,
                          spacingRight: 5,
                          animation: true,
                          reflow: true,
                          events: {
                              redraw: function (event) {
                                  var tmpDates, i,
                                      analogData = [],
                                      extremes = this.xAxis[0].getExtremes();

                                  if (this.xAxis && $scope.chartDrawn === true && $scope.scrollingInProgress === false) {
                                      //drag to left
                                      if (extremes && extremes.dataMin >= extremes.min - $scope.liveDataOffset) {
                                          $scope.scrollingInProgress = true;
                                          this.showLoading();

                                          tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -11);
                                          tankAndWellService.getChartData($scope.WSDeviceId, tmpDates.startDate, tmpDates.endDate, $scope.accountInfo.customerId, $scope.accountInfo.timeZone).then(function (resp) {
                                              var data = resp.data;
                                              for (var i = 0; i < data.series.length; i++) {
                                                  $scope.series[i].data = data.series[i].data.concat($scope.series[i].data);
                                                  chart.series[i].setData($scope.series[i].data);
                                              }
                                          }).finally(function () {
                                              chart.hideLoading();
                                              $scope.scrollingInProgress = false;
                                              _setLiveDataStatus();
                                          });
                                      } else if ($scope.liveData === false && extremes && extremes.max + $scope.liveDataOffset >= extremes.dataMax) {
                                          $scope.scrollingInProgress = true;
                                          this.showLoading();

                                          tmpDates = datetimeService.getNewStartEndDates(parseInt(extremes.dataMax), 11);

                                          tankAndWellService.getChartData($scope.WSDeviceId, tmpDates.startDate, null, $scope.accountInfo.customerId, $scope.accountInfo.timeZone).then(function (resp) {
                                              var data = resp.data;
                                              for (var i = 0; i < data.series.length; i++) {
                                                  if (data.series[i].data.length > 0) {
                                                      $scope.series[i].data = $scope.series[i].data.concat(data.series[i].data);
                                                      chart.series[i].setData($scope.series[i].data, true);
                                                  }
                                              }
                                          }).finally(function () {
                                              chart.hideLoading();
                                              $scope.scrollingInProgress = false;
                                              _setLiveDataStatus(tmpDates.endDate);
                                              timeLapseService.getLocalDateTime().then(function (result) {
                                                  tmpDates = new Date(result.data.localDateTime);
                                                  $scope.currentUnixTime = datetimeService.dateToUnixtime(tmpDates);//current date time 2015/7/1 10:00:00
                                                  tlDataReceivedTA({ Unix: $scope.currentUnixTime });
                                              });
                                          });
                                      }
                                  }
                              }
                          }
                      },
                      title: {
                          style: {
                              color: '#6D869F',
                              fontWeight: 'bold'
                          }
                      },
                      subtitle: {
                          text: null
                      },
                      exporting: {
                          enabled: false
                      },
                      xAxis: {
                          title: {
                              text: $scope.translation.text.TIME,
                              style: {
                                  color: '#6D869F',
                                  fontWeight: 'bold',
                                  fontSize: '15px'
                              }
                          },
                          plotLines: [{
                              value: 0,
                              width: 3,
                              color: 'green',
                              dashStyle: "solid",
                              zIndex: 10
                          }],
                          endOnTick: true,
                          showLastLabel: true,
                          startOnTick: true,
                          ordinal: false,
                          dateTimeLabelFormats: {
                              hour: chartXaxisHourFormat
                          },
                          labels: {
                              style: {
                                  color: '#6D869F',
                                  fontWeight: 'bold'
                              }
                          },
                          events: {
                              afterSetExtremes: function (e) {
                                  if ($scope.chartDrawn === true) {
                                      var extremes = chart.xAxis[0].getExtremes();
                                      if ($scope.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) { //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                          if (extremes.max + $scope.liveDataOffset <= extremes.dataMax) {
                                              _unRegisterListener();
                                          }
                                      }
                                  }
                              }
                          }
                      },
                      tooltip: {
                          useHTML: true,
                          formatter: function () {
                              xValue = this.x;
                              if (this.series.options.id.toLowerCase().indexOf("analogseries") > -1) //analog data
                              {
                                  var s = '';
                                  s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                                  s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y %I:%M:%S %p', this.x) + '</td></tr>';
                                  s += '<tr><td style="color: ' + this.series.color + ';">' + $scope.analogName + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(this.y, 2) + '</td></tr>';
                                  s += '</table>';
                                  return s;
                              }
                              else if (this.series.options.id.toLowerCase().indexOf("relayseries") > -1) {
                                  var s = "";

                                  var status = $scope.translation.text.CLOSE;

                                  if ((this.point.index == this.series.data.length - 1) && this.point.y != null) {//last point and in close status
                                      status = $scope.translation.text.STARTED;
                                  }
                                  else if (this.series.data[this.point.index + 1].y == null) {
                                      status = $scope.translation.text.STOPPED;
                                  }
                                  else {
                                      status = $scope.translation.text.STARTED;
                                  }
                                  s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                                  s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y %I:%M:%S %p', this.x) + '</td></tr>';
                                  s += '<tr><td style="color: ' + this.series.color + ';">' + this.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + status + '</td></tr>';
                                  s += '<tr><td style="color: ' + this.series.color + ';">' + status + ' ' + $scope.translation.text.FOR + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + getDuration(this.series.index, this.point.index) + '</td></tr>';

                                  s += '</table>';

                                  return s;
                              }
                              else if (this.series.options.id.toLowerCase().indexOf("flagseries") > -1) {
                                  var tip = "";
                                  tip += Highcharts.dateFormat('%A, %b %e, %Y %I:%M:%S %p', this.x);
                                  tip += '<br><span style="color: ' + this.series.color + ';">' + this.point.text + "</span>";
                                  return tip;
                              }
                          },
                          shared: false,
                          valueDecimals: 1,
                          backgroundColor: '#FFFFFF',
                          borderColor: 'gray',
                          borderWidth: 1
                      },
                      navigator: {
                          enabled: true,
                          adaptToUpdatedData: true,
                          series: {
                              lineWidth: 0,
                              color: 'transparent'
                          },
                          maskFill: 'rgba(255, 255, 255, 0.35)',
                          maskInside: true,
                          handles: {
                              backgroundColor: '#a4a7a9',
                              borderColor: '#384450'
                          },
                          height: 22,
                          margin: 0,
                          xAxis: {
                              tickWidth: 2,
                              lineWidth: 1,
                              gridLineWidth: 0,
                              tickLength: 15,
                              tickPosition: 'inside',
                              tickColor: '#98b3d1',
                              dateTimeLabelFormats: {
                                  hour: '%l:%M %p',
                              },
                              labels: {
                                  align: 'left',
                                  style: {
                                      color: '#61768f',
                                      fontWeight: 'bold'
                                  },
                                  x: 8,
                                  y: -8
                              }
                          }
                      },
                      scrollbar: {
                          enabled: true,
		    			  height: 0,
                          barBackgroundColor: '#959595',
                          barBorderRadius: 2,
                          barBorderWidth: 0,
                          buttonBackgroundColor: '#959595',
                          buttonBorderWidth: 0,
                          buttonBorderRadius: 2,
                          trackBackgroundColor: 'none',
                          trackBorderWidth: 1,
                          trackBorderRadius: 3,
                          trackBorderColor: '#CCC',
                    	  liveRedraw: true
                      },
                      rangeSelector: {
                          enabled: false
                      },
                      plotOptions: {
                          series: {
                              dataGrouping: {
                                  enabled: false
                              },
                              point: {
                                  events: {
                                    mouseOver: function () {
                                        xValue = this.x;
                                    }
                                  }
                              },
                              events: {
                                legendItemClick: function () {
                                    return false;
                                },
                              }
                          }
                      },
                      series: $scope.allSeries
                  });
                  _setLiveDataStatus();
                  chart.xAxis[0].setExtremes($scope.currentUnixTime - $scope.tankAndWellDisplay.chartDurationHrs * 3600 * 1000, $scope.currentUnixTime);
                  $scope.chartDrawn = true;
              }

              var getDuration = function (serieNumber, index) {
                  var duration = null;
                  var rightX = getRightX(serieNumber, index);
                  var leftX = getLeftX(serieNumber, index);
                  if (rightX - leftX >= 0)
                      duration = millisecondsToStr(rightX - leftX);
                  else
                      duration = 0;
                  return duration;
              };

              var getRightX = function (serieNumber, index) {
                  var cutSeries = chart.series[serieNumber];
                  var curLength = cutSeries.data.length;
                  var rightX = null;
                  rightX = cutSeries.data[curLength - 1].x;
                  //if go right, didn't find null, use the very right point
                  if (typeof cutSeries.data[index + 1] === "undefined") {
                      rightX = cutSeries.data[index].x;
                  }
                      //if the one on the right one is null//it is the very left point, then look for the next not null
                  else if (cutSeries.data[index + 1].y === null) {
                      for (var i = index + 1; i < curLength; i++) {
                          if (cutSeries.data[i].y !== null) {
                              rightX = cutSeries.data[i].x;
                              break;
                          }
                      }
                  }
                  else {
                      // look for the right
                      for (var i = index + 1; i < curLength; i++) {
                          if (cutSeries.data[i].y === null) {
                              rightX = cutSeries.data[i - 1].x;
                              break;
                          }
                      }
                  }

                  return rightX;
              };

              var getLeftX = function (serieNumber, index) {
                  var cutSeries = chart.series[serieNumber];
                  var leftX = null;

                  leftX = cutSeries.data[0].x;
                  //if the point is the very left point, use itself
                  if (typeof cutSeries.data[index - 1] === "undefined") {
                      leftX = cutSeries.data[index].x;
                  }
                  else if (typeof cutSeries.data[index + 1] === "undefined") {//last data
                      for (var t = index - 1; t >= 0; t--) {
                          if (cutSeries.data[t].y === null) {
                              leftX = cutSeries.data[t + 1].x;
                              break;
                          }
                      }
                  }
                      //if the one on the left is null//it is the very right point, use the point itself
                  else if (cutSeries.data[index + 1].y === null) {
                      leftX = cutSeries.data[index].x;
                  }
                  else {
                      for (var t = index - 1; t >= 0; t--) {
                          if (cutSeries.data[t].y === null) {
                              leftX = cutSeries.data[t + 1].x;
                              break;
                          }
                      }
                  }

                  return leftX;
              };

              var millisecondsToStr = function (milliseconds) {
                  function numberEnding(number) {
                      return (number > 1) ? 's' : '';
                  }

                  var temp = Math.floor(milliseconds / 1000);
                  var years = Math.floor(temp / 31536000);
                  if (years) {
                      return years + ' ' + $scope.translation.text.YEAR + numberEnding(years);
                  }

                  var days = Math.floor((temp %= 31536000) / 86400);
                  if (days) {
                      temp = temp - days * 86400;
                      var rhours = Math.floor((temp %= 86400) / 3600);
                      if (rhours > 0)
                          return days + ' ' + $scope.translation.text.DAY + numberEnding(days) + ' ' + rhours + ' ' + $scope.translation.text.HOUR + numberEnding(rhours);
                      else
                          return days + ' ' + $scope.translation.text.DAY + numberEnding(days);
                  }

                  var hours = Math.floor((temp %= 86400) / 3600);
                  if (hours) {
                      temp = temp - hours * 3600;
                      var rminutes = Math.floor((temp %= 3600) / 60);
                      if (rminutes > 0)
                          return hours + ' ' + $scope.translation.text.HOUR + numberEnding(hours) + ' ' + rminutes + ' ' + $scope.translation.text.MINUTE + numberEnding(rminutes);
                      else
                          return hours + ' ' + $scope.translation.text.HOUR + numberEnding(hours);
                  }

                  var minutes = Math.floor((temp %= 3600) / 60);
                  if (minutes) {
                      return minutes + ' ' + $scope.translation.text.MINUTE + numberEnding(minutes);
                  }

                  var seconds = temp % 60;
                  if (seconds) {
                      return seconds + ' ' + $scope.translation.text.SECOND + numberEnding(seconds);
                  }

                  return $scope.translation.text.LESS_THAN_A_SECOND;
              };

              var wsDataReceivedTA = function (data) {
                  if ($scope.liveData === false) {
                      _unRegisterListener();
                      return;
                  }

                  if (data.SN === $scope.tankAndWellAnalog.analogDevice.serialNumber) {
                      var unixtime = datetimeService.toUnixtime(data.Time);
                      var varValue = parseFloat(data.Value);
                      chart.series[0].addPoint([unixtime, varValue], false, false, false);
                      $scope.series[0].data.push([unixtime, varValue]);
                      ////==digital=====
                      for (var i = 1; i < $scope.series.length; i++) {
                          var y = chart.series[i].data[chart.series[i].data.length - 1].y;
                          if (y !== null) {
                              removeNull(i, chart);
                              chart.series[i].addPoint([unixtime, y], false, false, false);
                              $scope.series[i].data.push([unixtime, y, 0]);
                          }
                      }

                      var extremes = chart.xAxis[0].getExtremes();
                      var tmpRange = extremes.max - extremes.min;
                      if (extremes.max + $scope.liveDataOffset > extremes.dataMax)
                          chart.xAxis[0].setExtremes(unixtime - tmpRange + $scope.minPadding, unixtime + $scope.maxPadding);
                      chart.redraw();
                  }
              };

              var wsDataReceivedTD = function (data) {
                  var unixtime = datetimeService.toUnixtime(data.Time);
                  for (var i = 0; i < $scope.tankAndWellRelay.length; i++) {
                      var rDevice = $scope.tankAndWellRelay[i].relayDevice;
                      var rSetting = $scope.tankAndWellRelay[i].relaySetting;
                      var rBasic = $scope.tankAndWellBasic;
                      var polarity = 1;
                      var pumpId = 1;
                      if (data.SN === rDevice.serialNumber) {
                          removeNull(i + 1, chart);
                          var chArray = data.Value.replace(/[[\]]/g, '').split('');
                          channel = rSetting.channel;

                          if (rBasic.destPump1DeviceId === rDevice.deviceId && rBasic.destPump1Relay === rSetting.channel) {
                              polarity = parseInt(rBasic.destPump1Polarity);
                              pumpId = 1;
                          }
                          if (rBasic.destPump2DeviceId === rDevice.deviceId && rBasic.destPump2Relay === rSetting.channel) {
                              polarity = parseInt(rBasic.destPump2Polarity);
                              pumpId = 2;
                          }
                          if (rBasic.destPump3DeviceId === rDevice.deviceId && rBasic.destPump3Relay === rSetting.channel) {
                              polarity = parseInt(rBasic.destPump3Polarity);
                              pumpId = 3;
                          }
                          if (rBasic.destPump4DeviceId === rDevice.deviceId && rBasic.destPump4Relay === rSetting.channel) {
                              polarity = parseInt(rBasic.destPump4Polarity);
                              pumpId = 4;
                          }
                          if (rBasic.destPump5eviceId === rDevice.deviceId && rBasic.destPump5Relay === rSetting.channel) {
                              polarity = parseInt(rBasic.destPump5Polarity);
                              pumpId = 5;
                          }
                          var rawValue = chArray[channel - 1] === "C" ? 1 : 0;
                          var calValue = tankAndWellService.calculateRelay(rawValue, polarity);
                          value = parseInt(calValue) === 1 ? parseInt(calValue) * pumpId * -1 : null;

                          chart.series[i + 1].addPoint([unixtime, value], false, false, false);
                          $scope.series[i + 1].data.push([unixtime, value, 1]);
                      }
                      else {
                          var value = chart.series[i + 1].data[chart.series[i + 1].data.length - 1].y;
                          if (value !== null) {
                              removeNull(i + 1, chart);
                              chart.series[i + 1].addPoint([unixtime, value], false, false, false);
                              $scope.series[i + 1].data.push([unixtime, value, 0]);
                          }
                      }
                  }

                  var extremes = chart.xAxis[0].getExtremes();
                  var tmpRange = extremes.max - extremes.min;
                  if (extremes.max + $scope.liveDataOffset > extremes.dataMax)
                      chart.xAxis[0].setExtremes(unixtime - tmpRange + $scope.minPadding, unixtime + $scope.maxPadding);
                  chart.redraw();
              };

              var tlDataReceivedTA = function (data) {
                  if ($scope.liveData === false) {
                      _unRegisterListener();
                      return;
                  }
                  var extremes = chart.xAxis[0].getExtremes();
                  var tmpRange = extremes.max - extremes.min;

                  var liveDataLine = chart.xAxis[0].plotLinesAndBands;
                  liveDataLine[0].options.value = data.Unix + $scope.maxPadding;

                  if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - $scope.unixDay / 2) {
                      _unRegisterListener();
                      return;
                  }

                  if (extremes.max + $scope.liveDataOffset > extremes.dataMax) {

                      x = data.Unix + $scope.maxPadding;

                      for (var t = 1; t < $scope.series.length; t++) {

                          //removeNull(t);
                          var series = chart.series[t];
                          var dataseries = $scope.series[t];
                          var y = dataseries.data[series.data.length - 1][1];

                          // thinik about add it back later
                          //if (!scope.firsttime) {
                          //    if (typeof series.points[series.data.length - 1] !== "undefined")
                          //        series.points[series.data.length - 1].remove();
                          //}

                          series.addPoint([x, y], false, false, false);
                      }
                      $scope.firsttime = false;
                      chart.xAxis[0].setExtremes(data.Unix - tmpRange + $scope.minPadding, data.Unix + $scope.maxPadding);
                  }
              };

              var wsReconnect = function (data) {
                  // if ($scope.liveData === false) {
                  //     _unRegisterListener();
                  //     return;
                  // }
                $timeout(function () {
                  var tmpStartDate = null, tmpEndDate = null;

                  var extremes = chart.xAxis[0].getExtremes();
                  tmpDates = datetimeService.getNewStartEndDates(parseInt(extremes.dataMax), 11);
                  chart.showLoading();

                  tankAndWellService.getChartData($scope.WSDeviceId, ($scope.series[0].data[$scope.series[0].data.length - 1][0] + 1), null, $scope.accountInfo.customerId, $scope.accountInfo.timeZone).then(function (resp) {
                      var data = resp.data;
                      for (var i = 0; i < data.series.length; i++) {
                          if (data.series[i].data.length > 0) {
                              $scope.series[i].data = $scope.series[i].data.concat(data.series[i].data);
                              chart.series[i].setData($scope.series[i].data, true);
                          }
                      }
                  }).finally(function () {
                      chart.hideLoading();
                      $scope.scrollingInProgress = false;
                      _setLiveDataStatus();
                      timeLapseService.getLocalDateTime().then(function (result) {
                          tmpDates = new Date(result.data.localDateTime);
                          $scope.currentUnixTime = datetimeService.dateToUnixtime(tmpDates);//current date time 2015/7/1 10:00:00
                          tlDataReceivedTA({ Unix: $scope.currentUnixTime });
                      });
                  });
                }, 10000);

                  // tmpStartDate = scope.stickyProperties.dateMin;
                  // tmpEndDate = scope.stickyProperties.dateMax;
                  // _getData(scope.stickyProperties.deviceId, tmpStartDate, tmpEndDate);
              }

              var removeNull = function (serieNumber, chart) {
                  var cutSeries = chart.series[serieNumber];
                  if (cutSeries.data.length > 3) {
                      var curLength = cutSeries.data.length > 50 ? 50 : cutSeries.data.length;
                      for (var i = 1; i < curLength; i++) {
                          var pointindex = $scope.series[serieNumber].data.length - 1;
                          if ($scope.series[serieNumber].data[pointindex][2] === 0) {
                              if (cutSeries.data[pointindex])
                                  cutSeries.data[pointindex].remove();
                              $scope.series[serieNumber].data.splice(pointindex, 1);
                          }
                      }
                  }
              };

              var _registerListener = function () {
                  //This way we can be sure that extras of the listeners don't exist
                  _unRegisterListener();
                  $scope.liveData = true;
                  websocketService.register("ANALOG", $scope.tankAndWellAnalog.analogDevice.serialNumber, $scope.tankAndWellAnalog.analogSetting.channel, wsDataReceivedTA, wsReconnect);
                  timeLapseService.register("ANALOG", $scope.tankAndWellAnalog.analogDevice.serialNumber, $scope.tankAndWellAnalog.analogSetting.channel, tlDataReceivedTA, function () { });

                  for (var i = 1; i < $scope.tankAndWellRelay.length; i++) {
                      websocketService.register("RELAYS", $scope.tankAndWellRelay[i].relayDevice.serialNumber, "", wsDataReceivedTD, function () { });
                  }
              };

              var _unRegisterListener = function () {
                  websocketService.unRegister("ANALOG", $scope.tankAndWellAnalog.analogDevice.serialNumber, $scope.tankAndWellAnalog.analogSetting.channel, wsDataReceivedTA, wsReconnect);
                  timeLapseService.unRegister("ANALOG", $scope.tankAndWellAnalog.analogDevice.serialNumber, $scope.tankAndWellAnalog.analogSetting.channel, tlDataReceivedTA, function () { });
                  for (var i = 1; i < $scope.tankAndWellRelay.length; i++) {
                      websocketService.unRegister("RELAYS", $scope.tankAndWellRelay[i].relayDevice.serialNumber, "", wsDataReceivedTD, function () { });
                  }
                  $scope.liveData = false;
              };

              var _setLiveDataStatus = function (varEndDate) {
                  $scope.liveDataEndDate = varEndDate != null ? varEndDate : $scope.liveDataEndDate;
                  timeLapseService.getLocalDateTime().then(function (result) {
                      var extremes = chart.xAxis[0].getExtremes();
                      if ($scope.liveDataEndDate > result.data.unixTimeStamp && (extremes.max + $scope.liveDataOffset >= extremes.dataMax)) {
                          _registerListener();
                          tlDataReceivedTA({ Unix: result.data.unixTimeStamp });
                      }
                      else {
                          _unRegisterListener();
                      }
                  });
              };

              $scope.$on("$destroy", function () {
                  //  websocketService.unRegister("ANALOG", $scope.device.serialNumber, $scope.sourceChannel, wsDataReceivedGT, wsDataReceivedGT);
                  _unRegisterListener();
                  if (chart) chart.destroy();
              });
          }
      };
  }
]);

mcapp.directive('groundTank', ["authenticationService", "translationService", "tankAndWellService", "websocketService", "$timeout",
  function (authenticationService, translationService, tankAndWellService, websocketService, $timeout) {
    return {
      templateUrl: 'ui/tankandwell/groundtank-directive.html',
      replace: false,
      scope: {
        WSDeviceId: "@wsdeviceid",
        listAll: "@listall"
      },
      link: function ($scope, element, attrs) {
        websocketService.connect();
        $scope.groundTankBusy = true;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.translation = translationService.translation;
        $scope.chartId = "groundchartContainer" + Math.floor((Math.random() * 10000) + 1);
        $scope.fuelWidget = {};
        $scope.showTick = $scope.listAll === "true" ? 0 : 1;

        tankAndWellService.groundTankGetData($scope.WSDeviceId, $scope.accountInfo.timeZone, $scope.accountInfo.customerId).then(function (resp) {
          var data = resp.data;

          $scope.data = data;
          $scope.device = data.device;
          websocketService.register("ANALOG", $scope.device.serialNumber, $scope.data.sourceChannel, wsDataReceivedGT, wsDataReceivedGT);
          $scope.groundTankBusy = false;
          $timeout(function () {
            _drawGroundTank();
          });
        });

        if ($scope.listAll === "true") {
          $scope.tankheight = "100%";
        } else {
          $scope.tankheight = "95%";
        }

        var _drawGroundTank = function () {
          if ($scope.listAll === "true") {
            var value;
            var tenPercentDiff = (($scope.data.tankYellowAbove - $scope.data.tankRedBelow) / .9) - ($scope.data.tankYellowAbove - $scope.data.tankRedBelow);
            var upperLimit = $scope.data.tankYellowAbove + tenPercentDiff;
            var lowerLimit = $scope.data.tankRedBelow - tenPercentDiff;

            if ($scope.data.currentReading < lowerLimit)
              value = lowerLimit;
            else if ($scope.data.currentReading > upperLimit)
              value = upperLimit;
            else
              value = $scope.data.currentReading;

            $scope.fuelWidget = new FusionCharts({
              type: 'hlineargauge',
              renderAt: $scope.chartId,
              width: '100%',
              height: 30,
              dataFormat: 'json',
              dataSource: {
                "chart": {
                  "theme": "fint",
                  "lowerLimit": lowerLimit,
                  "upperLimit": upperLimit,
                  "numberSuffix": " " + $scope.data.unit,
                  "chartTopMargin": "5",
                  "chartBottomMargin": "5",
                  "valueFontSize": "11",
                  "valueFontBold": "0",
                  "manageresize": 1,
                  "showhovereffect": "0",
                  "showTickValues": $scope.showTick,
                  "showTickMarks": $scope.showTick,
                  "showValue": "0",
                  "pointerOnTop": "0",
                  "showTooltip": "0",
                  "canvasBgAlpha": "0",
                  "bgAlpha": 0
                },
                "colorRange": {
                  "color": [{
                    "minValue": lowerLimit,
                    "maxValue": $scope.data.tankRedBelow,
                    "code": "#FF8472"
                  }, {
                    "minValue": $scope.data.tankRedBelow,
                    "maxValue": $scope.data.tankYellowAbove,
                    "code": "#A2C833"
                  }, {
                    "minValue": $scope.data.tankYellowAbove,
                    "maxValue": upperLimit,
                    "code": "#F8CA3F"
                  }]
                },
                "pointers": {
                  "pointer": [{
                    "value": value,
                    "sides": "2",
                    "radius": "6"
                  }]
                }
              }
            }).render();
          } else {
            $scope.waterColor = _getWaterColor();
            $scope.fuelWidget = new FusionCharts({
              type: 'cylinder',
              dataFormat: 'json',
              renderAt: $scope.chartId,
              width: '100%',
              height: $scope.tankheight,
              dataSource: {
                "chart": {
                  "manageresize": 1,
                  "lowerLimit": $scope.data.tankBottom,
                  "upperLimit": $scope.data.tankTop,
                  "numberSuffix": " " + $scope.data.unit,
                  "showhovereffect": "0",
                  "chartTopMargin": "5",
                  "chartBottomMargin": "5",
                  "cylFillColor": $scope.waterColor,
                  "showTickValues": $scope.showTick,
                  "showTickMarks": $scope.showTick,
                  "adjustTM": 1,
                  "canvasBgAlpha": "0",
                  "legendBgAlpha": "0",
                  "borderAlpha": "0",
                  "bgAlpha": "0,0",
                  "showToolTip": 0
                },
                "value": $scope.data.currentReading
              }
            }).render();
          }

          $scope.fuelWidget.setTransparent(true);

          element.find("svg[id^='raphael-paper']").css("background-color", "rgb(255, 255, 255, 0)");

        };
        var _getWaterColor = function () {
          if ($scope.data.currentReading <= $scope.data.tankRedBelow)
            return "#ff0000";
          if ($scope.data.currentReading >= $scope.data.tankYellowAbove)
            return "#ffff00";
          else
            return "#008ee4";
        };

        var wsDataReceivedGT = function (data) {
          if ($scope.data.sourceChannel == data.CH && $scope.device.serialNumber === data.SN) {
            $scope.data.currentReading = data.Value;
            $scope.fuelWidget.setData($scope.data.currentReading);
            var newColor = _getWaterColor();
            if ($scope.waterColor !== newColor) {
              $scope.waterColor = newColor;
              $scope.fuelWidget.setChartAttribute("cylFillColor", $scope.waterColor);
            }
          }
        };

        $scope.$on("$destroy", function () {
          websocketService.unRegister("ANALOG", $scope.device.serialNumber, $scope.data.sourceChannel, wsDataReceivedGT, wsDataReceivedGT);
          if ($scope.fuelWidget && $scope.fuelWidget.dispose) {
            $scope.fuelWidget.dispose();
            $scope.fuelWidget = null;
          }
        });
      }
    };
  }]);

// mcapp.controller('siteAccessReportController', ['$scope', '$rootScope', '$filter', '$timeout', 'sharedSetupService', 'openViewService', 'datetimeService', 'authenticationService', '$element', 'translationService', 'savePdfService', function ($scope, $rootScope, $filter, $timeout, sharedSetupService, openViewService, datetimeService, authenticationService, $element, translationService, savePdfService) {
//     sharedSetupService.getWindowId($scope);
//     $scope.myDate = null;
//     $scope.infiniteScrollOn = false;
//     $scope.infiniteScrollUpOn = false;
//     $scope.infiniteScrollDownOn = false;
//     $scope.checkFirstRowLiveStatus = null;
//     $scope.accountInfo = authenticationService.getAccountInfo();
//     $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
//     $scope.unixDay = sharedSetupService.unixDay;
//     $scope.liveDataOffset = sharedSetupService.liveDataOffset;
//     $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
//     $scope.alerts = [];
//     $scope.oneTimeOnly = 0;
//     $scope.reverse = true;
//     $scope.translation = translationService.translation;
//     $scope.downloadViewTypeOptions = [0, 1, 2];

//     $scope.getIcon = function (varTitle, varMode) {
//         return sharedSetupService.getIcon(varTitle, varMode);
//     };

//     $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
//         $scope.timeFormat = timeFormat;
//     });

//     $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
//         if ($scope.alerts.length > 0) {
//             var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
//             var _type = $scope.alerts[0].type;
//             var _languageCode = $scope.alerts[0].languageCode;
//             if (_languageCode.toUpperCase() === 'NO_DATA') {
//                 _msg += ': ' + moment($scope.siteAccessReportService.start).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.siteAccessReportService.end).format('MM/DD/YY, h:mm:ss a');
//             }
//             $scope.alerts = [];
//             $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
//         }
//     });

//     $scope.savePdf = function () {

//         var windowTitle = $scope.windowTitle.toUpperCase().replace(/ /g, "_");
//         var pdfParams = {
//             windowTitle: windowTitle,
//             pdfTitle: (eval("$scope.translation.text." + windowTitle)),
//             customerName: $scope.accountInfo.customerName,
//             customerId: $scope.accountInfo.customerId,
//             dateTranslate: $scope.translation.text.DATE_CREATED,
//             dateRangeStart: $scope.myDateRangeStart,
//             dateRangeEnd: $scope.myDateRangeEnd,
//             $scope: $scope,
//             $element: $element
//         }

//         savePdfService.savePDF(pdfParams);
//     };


//     if (!$rootScope.mobile && !$rootScope.classicView) {

//         $scope.popup = _this.getExistingDialog($scope.windowId).ref;
//         sharedSetupService.maximize($scope.popup);

//         $scope.popup.dialog({
//             resize: function (event, ui) {
//                 $scope.adjustSize();
//             }
//         });

//         $scope.popup.dialogExtend({
//             maximize: function (event, ui) {
//                 openViewService.adjustContentSizeStart($scope.popup);
//                 $scope.adjustSize();
//             },
//             restore: function (event, ui) {
//                 openViewService.adjustContentSizeStart($scope.popup);
//                 $scope.adjustSize();
//             }
//         });

//         $scope.adjustSize = function () {
//             $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
//             $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
//             $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
//             $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
//             $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
//         };
//     }
// }]);

// mcapp.directive('drawSiteAccessReport', ['$timeout', 'siteAccessReportService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', '$filter', 'getDateRangeService', function ($timeout, siteAccessReportService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService, $filter, getDateRangeService) {
//     // return the directive link function. (compile function not needed)
//     return function (scope, element, attrs) {
//         scope.$ctrl = scope;
//         if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

//         var currentScrollbarPosition = 0;
//         var previousScrollbarPosition = 0;
//         var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
//         paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;
//         scope.showMsg = false;

//         element.on('scrollOff', function (event) {
//             var $rowFirst = element.contents().find("tr:first");
//             var $rowLast = element.contents().find("tr:last");
//             var _firstRow = $rowFirst.attr("name");
//             if (typeof $rowFirst.position() !== "undefined") {
//                 scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
//                 var _tableTop = element.offset().top;
//                 var _rowTop = $rowFirst.offset().top;
//                 _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
//                 previousScrollbarPosition = currentScrollbarPosition;
//                 currentScrollbarPosition = element[0].scrollTop;
//             }

//             if (scope.infiniteScrollOn === true) {
//                 scope.infiniteScrollUpOn = true;
//                 scope.infiniteScrollDownOn = true;

//                 if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
//                     //$rowLast.addClass("active-row");
//                     scope.siteAccessReportService.alerts = [];
//                     scope.siteAccessReportService.nextPage();
//                 }
//                 if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
//                     //$rowFirst.addClass("active-row");
//                     scope.siteAccessReportService.alerts = [];
//                     scope.siteAccessReportService.previousPage();
//                 }
//             }

//             var rows = element.children().children().children().children();
//             var scrollpos = 40;
//             var start = 0;
//             var end = rows.length;
//             var count = 0;

//             while (start != end) {
//                 count++;
//                 var mid = start + Math.floor((end - start) / 2);
//                 if ($(rows[mid]).position().top < scrollpos)
//                     start = mid + 1;
//                 else
//                     end = mid;
//             }
//             _updateZoom(parseFloat($($(rows[start])).attr("name")));
//         });

//         var _updateZoom = function (currentRow) {
//             if (isNaN(currentRow))
//                 return;

//             var zoomMin = currentRow - paddingZoom;
//             var zoomMax = currentRow + paddingZoom;

//             var dateMin = scope.stickyProperties.dateMin;
//             var dateMax = scope.stickyProperties.dateMax;

//             if (zoomMin < scope.stickyProperties.dateMin) {
//                 dateMin = zoomMin;
//             }
//             if (zoomMax > scope.stickyProperties.dateMax) {
//                 dateMax = zoomMax;
//             }

//             sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
//         };

//         scope.toggle = function ($event) {
//             if ($($event.currentTarget).hasClass("active-row")) {
//                 $($event.currentTarget).removeClass("active-row");
//             }
//             else {
//                 $($event.currentTarget).addClass("active-row");
//             }
//         };

//         scope.$watch('lastUpdateAt', function (newValue, oldValue) {
//             if (newValue && newValue != oldValue) {
//                 scope.liveDataIn = !scope.liveDataIn;
//                 $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
//             }
//         }, true);

//         scope.$watch('siteAccessReportService.alerts', function (newValue, oldValue) {
//             if (newValue && newValue.length > 0 && newValue != oldValue) {
//                 scope.alerts = newValue;
//             }
//         }, true);

//         scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
//             if (newValue && newValue != oldValue) {
//                 if (oldValue) {
//                     _unRegisterListener(oldValue);
//                 }
//             }
//         }, true);

//         scope.mostRecentData = function () {
//             toaster.pop('success', scope.windowTitle + " -- " + scope.siteAccessReportService.siteName, 'View reloading');
//             scope.goSelectReportData(true);
//         }

//         scope.goSelectReportData = function (isRefresh) {

//             scope.maxDateRange = getDateRangeService.getRange("SiteAccess");
//             scope.alerts = [];
//             var numberOfDays = 30, varDateRangeStart, varDateRangeEnd, varDateRangeEndTmp;
//             if (scope.stickyProperties.on == true && scope.stickyProperties.dateMax && scope.stickyProperties.dateMin) {
//                 scope.stickyProperties.on = false;
//                 varDateRangeStart = scope.stickyProperties.dateMin;
//                 varDateRangeEnd = scope.stickyProperties.dateMax;
//                 scope.myDateRangeStart = new Date(varDateRangeStart);
//                 scope.myDateRangeEnd = new Date(varDateRangeEnd - scope.unixDay);
//             }
//             else if (new Date(scope.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeEnd)) && new Date(scope.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeStart))) {
//                 scope.myDateRangeEnd = (new Date(scope.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeEnd))) ? scope.myDateRangeEnd : new Date();
//                 scope.myDateRangeStart = (new Date(scope.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeStart))) ? scope.myDateRangeStart : new Date();
//                 varDateRangeEnd = scope.myDateRangeEnd;
//                 varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999)
//                 varDateRangeStart = scope.myDateRangeStart;
//                 varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0)
//             }
//             else {
//                 scope.myDateRangeEnd = new Date();
//                 scope.myDateRangeStart = new Date();
//                 scope.myDateRangeStart.setDate(scope.myDateRangeStart.getDate() - numberOfDays)

//                 varDateRangeEnd = new Date();
//                 varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
//                 ///////// needed to calculate varDateRangeStart
//                 varDateRangeEndTmp = new Date();
//                 varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
//                 ///////// needed to calculate varDateRangeStart
//                 varDateRangeStart = varDateRangeEndTmp - ((numberOfDays + 0) * scope.unixDay);
//             }
//             //used for refresh button to reload newest data
//             if (isRefresh) {
//                 scope.myDateRangeEnd = new Date();
//                 scope.myDateRangeStart = new Date();
//                 scope.myDateRangeStart.setDate(scope.myDateRangeStart.getDate() - numberOfDays)

//                 varDateRangeEnd = new Date();
//                 varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
//                 ///////// needed to calculate varDateRangeStart
//                 varDateRangeEndTmp = new Date();
//                 varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
//                 ///////// needed to calculate varDateRangeStart
//                 varDateRangeStart = varDateRangeEndTmp - ((numberOfDays + 0) * scope.unixDay);
//             }
//             /////////////////////////////////////////////////////////////
//             currentScrollbarPosition = 0;
//             previousScrollbarPosition = 0;
//             scope.checkFirstRowLiveStatus = null;
//             /////////////////////////////////////////////////////////////

//             scope.showMsg = false;
//             scope.siteAccessReportService = new siteAccessReportService();
//             scope.siteAccessReportService.customerId = scope.accountInfo.customerId;
//             if (scope.siteAccessReportService.devices.length == 0) scope.siteAccessReportService.getDevices(scope.accountInfo.customerId);

//             scope.siteAccessReportService.deviceId = scope.deviceSelected;
//             scope.siteAccessReportService.windowTitle = scope.windowTitle;
//             scope.siteAccessReportService.startRow = 1;
//             scope.siteAccessReportService.pageSize = 50;
//             scope.siteAccessReportService.alerts = [];

//             scope.siteAccessReportService.start = varDateRangeStart
//             scope.siteAccessReportService.end = varDateRangeEnd;
//             scope.siteAccessReportService.nextPage();
//             _registerListener();
//             sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: scope.windowId });

//         };

//         var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
//             if (scope.checkFirstRowLiveStatus === true) {
//                 _checkTopOffset(liveDataStatusOn);
//             }
//             else if (scope.checkFirstRowLiveStatus === null) {
//                 timeLapseService.getLocalDateTime().then(function (result) {
//                     if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
//                         scope.checkFirstRowLiveStatus = true;
//                         _checkTopOffset(liveDataStatusOn);
//                     }
//                     else {
//                         scope.checkFirstRowLiveStatus = false;
//                     }
//                 });
//             }
//         };

//         var _checkTopOffset = function (liveDataStatusOn) {
//             if (liveDataStatusOn) {
//                 _registerListener();
//             }
//             else {
//                 _unRegisterListener();
//             }
//         };

//         var wsDataReceivedKEY = function (data) {
//             if (scope.liveData === false) {
//                 _unRegisterListener();
//                 return;
//             }

//             var varTime = datetimeService.socketStrToServerStrTime(data.Time);
//             var varValue = parseInt(data.Value);
//             var idx = _.findIndex(scope.siteAccessReportService.devices, function (device) {
//                 return device.serialNumber == data.SN
//             });
//             var siteName = data.SN;
//             if (idx > -1) {
//                 siteName = scope.siteAccessReportService.devices[idx].name;
//             }

//             var _newMeasurements = { "localDateTime": varTime, "userName": data.Value, "siteName": siteName, "keyHex": data.CH };
//             console.log(_newMeasurements);

//             scope.siteAccessReportService.items.unshift(_newMeasurements);
//             scope.lastUpdateAt = varTime;
//         };

//         var wsReconnectKEY = function (data) {
//             if (scope.liveData === false) {
//                 _unRegisterListener(scope.deviceSelectedSn);
//                 return;
//             }
//             toaster.pop('success', scope.windowTitle + " -- " + scope.siteAccessReportService.siteName, 'View reloading');
//             scope.stickyProperties.on = true;
//             scope.siteAccessReportService.start = scope.stickyProperties.dateMin;
//             scope.siteAccessReportService.end = scope.stickyProperties.dateMax;
//             scope.siteAccessReportService.items = [];
//             scope.siteAccessReportService.numberOfReturnedRecords = -1;
//             scope.siteAccessReportService.startRow = 1;
//             scope.siteAccessReportService.pageSize = 10000;
//             scope.siteAccessReportService.windowTitle = scope.windowTitle;
//             sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.stickyProperties.deviceId, windowId: scope.windowId });
//             scope.siteAccessReportService.alerts = [];
//             scope.siteAccessReportService.nextPage();
//         };

//         var _registerListener = function () {
//             if (scope.liveData === true)
//                 return;
//             scope.liveData = true;
//             scope.siteAccessReportService.numberOfNewRecordsPrevious = -1;

//             websocketService.connect();
//             scope.siteAccessReportService.getDevices(scope.accountInfo.customerId).then(function (resp) {
//                 for (var i = 0; i < resp.data.devices.length; i++) {
//                     websocketService.register("KEY", resp.data.devices[i].serialNumber, "", wsDataReceivedKEY, wsReconnectKEY);
//                 }
//             });
//         };

//         var _unRegisterListener = function () {
//             if (scope.liveData === false)
//                 return;
//             scope.liveData = false;
//             scope.lastUpdateAt = undefined;
//             for (var i = 0; i < scope.siteAccessReportService.devices.length; i++) { //scada-1252
//                 websocketService.unRegister("KEY", scope.siteAccessReportService.devices[i].serialNumber, "", wsDataReceivedKEY, wsReconnectKEY);
//             }
//         };

//         scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
//             //_autoScroll();
//             scope.checkFirstRowLiveStatus = null;
//         });

//         var _autoScroll = function () {
//             if (scope.siteAccessReportService.numberOfNewRecordsPrevious > 0) {
//                 var trRow = element.find('tr').eq(scope.siteAccessReportService.numberOfNewRecordsPrevious - 1);
//                 var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 10;
//                 element.scrollTop(yPosition);
//             }
//             else if (element[0].scrollTop <= 1)
//                 element.animate({
//                     scrollTop: element.scrollTop() + 10
//                 }, 500);
//         };

//         var orderBy = $filter('orderBy');
//         scope.order = function (predicate, reverse) {
//             switch (predicate) {
//                 case "siteName":
//                 case "userName":
//                 case "keyHex":
//                     scope.sortLocalDateTime = reverse ? 'localDateTime' : '-localDateTime';
//                     scope.siteAccessReportService.items = orderBy(scope.siteAccessReportService.items, [predicate, scope.sortLocalDateTime], reverse);
//                     break;
//                 default:
//                     scope.siteAccessReportService.items = orderBy(scope.siteAccessReportService.items, predicate, reverse);
//                     break;
//             }
//             scope.predicate = predicate;
//         };

//         scope.setSorting = function () {
//             scope.order('localDateTime', scope.reverse);
//         };

//         scope.goSelectReportData(false);

//         scope.$on("$destroy", function () {
//             _unRegisterListener(scope.deviceSelectedSn);
//         });
//     };
// }]);

// mcapp.factory('siteAccessReportService', ['$http', 'datetimeService', 'toaster', 'userMessageService', 'translationService', 'REPORTS', function ($http, datetimeService, toaster, userMessageService, translationService, REPORTS) {
//     var siteAccessReportService = function () {
//         this.items = [];
//         this.devices = [];
//         this.siteName = '';
//         this.customerId = null;
//         this.deviceId = null;
//         this.startRow = 1;
//         this.pageSize = 50;
//         this.start = '19000101';
//         this.end = '19000101';
//         this.busy = false;
//         this.numberOfReturnedRecords = -1;
//         this.numberOfNewRecordsPrevious = -1;
//         this.windowTitle = null;
//         this.alerts = [];
//         this.translation = translationService.translation;
//     };

//     siteAccessReportService.prototype.getDevices = function (customerId) {
//         var self = this;
//         return $http.get(REPORTS + '/api/DeviceList?customerId=' + customerId).then(function (resp) {
//             self.devices = resp.data.devices;
//             return resp;
//         });
//     }

//     siteAccessReportService.prototype.previousPage = function () {
//         if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
//         this.busy = true;
//         this.pageSize = -50;
//         var url = REPORTS + "/api/SiteAccessReport?customerId=" + this.customerId + "&StartDate=" + this.start + "&EndDate=" + this.end;
//         $http.get(url).then(function (result) {
//             /////////////////////////
//             var intDayWindow = 365;
//             var intDay = 86400000;
//             /////////////////////////
//             var items = result.data;
//             for (var i = 0; i < items.length; i++) {
//                 items[i].localDateTime = items[i].localDateTime;
//                 items[i].siteName = items[i].siteName;
//                 items[i].userName = items[i].userName;
//                 items[i].keyHex = items[i].keyHex;
//                 this.items.unshift(items[i]);
//             }
//             this.numberOfNewRecordsPrevious = items.length;
//             this.numberOfRecords = this.items.length;
//             this.startRow = this.startRow + items.length;
//             if (items.length > 0) { //if there are records returned
//                 this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
//                 this.end = datetimeService.toUnixtime(this.items[0].localDateTime.replace(/\D/g, ''));
//             }
//             this.pageSize = 50;
//             this.busy = false;
//         }.bind(this), function (error) {
//             this.alerts = [];
//             var errorMessage = eval("this.translation.message." + error.data.message);
//             this.alerts.push({ msg: errorMessage, type: "danger" });
//             this.pageSize = 50;
//             this.busy = false;
//         }.bind(this));
//     };

//     siteAccessReportService.prototype.nextPage = function () {
//         if (this.busy || this.numberOfReturnedRecords === 0) return;
//         this.busy = true;
//         var url = REPORTS + "/api/SiteAccessReport?customerId=" + this.customerId + "&StartDate=" + this.start + "&EndDate=" + this.end;
//         $http.get(url).then(function (result) {
//             /////////////////////////
//             var intDayWindow = 365;
//             var intDay = 86400000;
//             /////////////////////////
//             var items = result.data;
//             for (var i = 0; i < items.length; i++) {
//                 items[i].localDateTime = items[i].localDateTime;//datetimeService.formatDate(new Date(items[i].localDateTime), 'MM/dd/yyyy hh:mm:ss a');
//                 items[i].siteName = items[i].siteName;
//                 items[i].userName = items[i].userName;
//                 items[i].keyHex = items[i].keyHex;
//                 this.items.push(items[i]);
//             }
//             this.numberOfReturnedRecords = items.length;
//             this.startRow = this.startRow + items.length;
//             if (items.length > 0) { //if there are records returned
//                 this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
//                 this.end = datetimeService.toUnixtime(this.items[0].localDateTime.replace(/\D/g, ''));
//             }
//             else {
//                 this.alerts = [];
//                 var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).format('MM/DD/YY, h:mm:ss a');
//                 this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
//             }
//             this.pageSize = 50;
//             this.busy = false;
//         }.bind(this), function (error) {
//             this.alerts = [];
//             var errorMessage = eval("this.translation.message." + error.data.message);
//             this.alerts.push({ msg: errorMessage, type: "danger" });
//             this.pageSize = 50;
//             this.busy = false;
//         }.bind(this));
//     };

//     return siteAccessReportService;
// }]);


"use strict";

angular.module("mc.site-access", []);
"use strict";

function SiteAccessFactory($http, REPORTS) {
    var SiteAccessFactory = {};
    var _getData = function _getData(customerId, start, end) {
        return $http({
            method: 'Get',
            url: REPORTS + "/api/SiteAccessReport?customerId=" + customerId + "&StartDate=" + start + "&EndDate=" + end,
            cache: false
        });
    };

    SiteAccessFactory.getData = _getData;
    return SiteAccessFactory;
}

SiteAccessFactory.$inject = ['$http', 'REPORTS'];

angular.module('mc.site-access').factory('SiteAccessFactory', SiteAccessFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function siteAccessReportController($, $scope, $rootScope, $filter, sharedSetupService, openViewService, authenticationService, $element, translationService, SiteAccessFactory, getDateRangeService, savePdfService, toaster) {
    var ctrl = this;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.alerts = [];
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        ctrl.reverse = true;
        ctrl.translation = translationService.translation;
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.goSelectReportData(false);

        if (!$rootScope.mobile && !$rootScope.classicView) {

            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    // openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    // openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }

        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            $scope.timeFormat = timeFormat;
            ctrl.goSelectReportData(false);
        });

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            if ($scope.alerts.length > 0) {
                var _msg = ctrl.translation.text.NO_DATA;
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                if (ctrl.items.length !== 0) {
                    var _msg = ctrl.translation.text.MAXDATE + ": " + ctrl.maxDateRange + " " + ctrl.translation.text.DAYS;
                }
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
            ctrl.goSelectReportData(false);
        });

        //Clean up when dialog is closed
        $scope.$on("$destroy", function () {
            ctrl.items = null;
        });
    };

    var orderBy = $filter('orderBy');
    ctrl.order = function (predicate, reverse) {
        switch (predicate) {
            case "siteName":
            case "userName":
            case "keyHex":
                $scope.sortLocalDateTime = reverse ? 'localDateTime' : '-localDateTime';
                ctrl.items = orderBy(ctrl.items, [predicate, $scope.sortLocalDateTime], reverse);
                break;
            default:
                ctrl.items = orderBy(ctrl.items, predicate, reverse);
                break;
        }
        ctrl.predicate = predicate;
    };

    $scope.setSorting = function () {
        ctrl.order('localDateTime', ctrl.reverse);
    };

    ctrl.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.goSelectReportData(true);
    };

    ctrl.goSelectReportData = function (isRefresh) {
        ctrl.loading = true;
        ctrl.maxDateRange = getDateRangeService.getRange("SiteAccess");
        $scope.alerts = [];
        $scope.showMsg = false;

        var numberOfDays = 30,
            varDateRangeStart,
            varDateRangeEnd,
            varDateRangeEndTmp;
        if (ctrl.stickyProperties.on == true && ctrl.stickyProperties.dateMax && ctrl.stickyProperties.dateMin) {
            ctrl.stickyProperties.on = false;
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
            varDateRangeEnd = ctrl.myDateRangeEnd;
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeStart = ctrl.myDateRangeStart;
            varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
        } else {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }

        //used for refresh button to reload newest data
        if (isRefresh) {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }

        if (new Date(ctrl.myDateRangeEnd - ctrl.myDateRangeStart) / 86400000 > ctrl.maxDateRange) {
            ctrl.loading = false;
            $scope.showMsg = true;
            var errorMessage = ctrl.translation.text.MAXDATE + ": " + ctrl.maxDateRange + " " + ctrl.translation.text.DAYS;
            $scope.alerts.push({ msg: errorMessage, type: "danger" });
        } else {
            if (ctrl.accountInfo === null) return;
            ctrl.items = [];

            SiteAccessFactory.getData(ctrl.accountInfo.customerId, varDateRangeStart, varDateRangeEnd).then(function (dataFromFactory) {
                ctrl.loading = false;
                $scope.alerts = [];
                ctrl.items = dataFromFactory.data;

                // If we didn't get any items back 
                if (ctrl.items.length === 0) {
                    var errorMessage = ctrl.translation.text.NO_DATA;
                    $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            }, function (error) {
                //error
            }).then(function (data) {
                ctrl.loading = false;
            });
        }
    };

    ctrl.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    ctrl.savePdf = function () {
        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("$scope.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };
};

siteAccessReportController.$inject = ['$', '$scope', '$rootScope', '$filter', 'sharedSetupService', 'openViewService', 'authenticationService', '$element', 'translationService', 'SiteAccessFactory', 'getDateRangeService', 'savePdfService', 'toaster'];
'use strict';

angular.module('mc.site-access').component('siteAccessReport', {
    controller: siteAccessReportController,
    templateUrl: 'ui/siteaccess/site-access-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.controller("signalWidgetController", ["$scope", "$rootScope", "translationService", "sharedSetupService", "authenticationService", "$element",
    function ($scope, $rootScope, translationService, sharedSetupService, authenticationService, $element) {
        $scope.Time = null;
        $scope.translation = translationService.translation;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.downloadViewTypeOptions = [0];
        sharedSetupService.getWindowId($scope);
        if (typeof $scope.stickyProperties != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }

        $scope.setSetting = function () {
            var categoryId;
            var signalStrength = $scope.stickyProperties.device.channel == "Signal" ? true : false;
            $scope.deviceSelectedId = { "deviceId": $scope.stickyProperties.device.deviceId };
            $scope.signalStrength =  signalStrength || $scope.stickyProperties.device.signalStrength;

            // Opening widget from signal gauge view
            if (typeof $scope.stickyProperties.device.dataCategoryId !== "undefined") {
                categoryId = $scope.stickyProperties.device.dataCategoryId
            } 
            // Opening widget from saved desktop
            else {
                switch($scope.stickyProperties.device.channel) {
                    case "Signal":
                        categoryId = 15;
                        break;
                    case "Signal Quality":
                        categoryId = 17;
                        break;
                    case "Signal Power":
                        categoryId = 42;
                        break;
                    default: 
                        categoryId = 15;
                        break;
                }
            }

            $scope.dataCategoryId = categoryId;
            $scope.preDeviceSelected = $scope.stickyProperties.device;
        };
        $scope.setSetting();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            $scope.closeWidget = function () {
                $element.find(".flip-container").hide();
                $scope.popup.dialog("close");
            };

            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.resizeContent();
                    $scope.$apply();
                }
            });

            $scope.resizeContent = function () {
                if (!$element.find(".gauge-widget-icon").highcharts())
                    return;

                $element.find('circle:not(:last)').each(function () {
                    $(this).remove();
                });

                var _newWidth = $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "");
                var _newHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $element.find('.widgetSettingNew').css("width", _newWidth < 240 ? 240 : _newWidth)
                    .css("margin-left", _newWidth < 240 ? -(240 - _newWidth) / 2 : "auto");

                $scope.popup.parent().find('.gauge-widget-icon')
                    .css("width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.gauge-widget-icon')
                    .css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")); //25: total padding
                var _char = $element.find(".gauge-widget-icon").highcharts();
                _char.setSize(
                    $scope.popup.parent().find('.gauge-widget-icon').css("width").replace(/[^0-9.]+/g, "") * 1,
                    ($scope.popup.parent().find('.gauge-widget-icon').css("height").replace(/[^0-9.]+/g, "") -
                        $scope.popup.parent().find('.widget-title').css("height").replace(/[^0-9.]+/g, "")) *
                    .95,
                    false
                );
                var _fontSize = _newWidth < _newHeight ? _newWidth / 12 : _newHeight / 12;
                _fontSize = _fontSize < 12 ? 12 : _fontSize > 35 ? 35 : _fontSize;
                _char.container.parentNode.style.fontSize = _fontSize + "px";
                _char.reflow();
            };
        } else {
            $scope.popup = $(".flip-container");
            $scope.resizeContent = function () {
                if (!$element.find(".gauge-widget-icon").highcharts())
                    return;
                $element.find('circle:not(:last)').each(function () {
                    $(this).remove();
                });

                var _char = $element.find(".gauge-widget-icon").highcharts();

                var _fontSize = 25;
                _char.container.parentNode.style.fontSize = _fontSize + "px";
                _char.reflow();
            }
        }

    }]);
mcapp.directive('signalWidgetDirective', ['$rootScope', "websocketService", "signalGaugeService", "deviceService", "datetimeService", "toaster", "sharedSetupService", "$timeout",
    function ($rootScope, websocketService, signalGaugeService, deviceService, datetimeService, toaster, sharedSetupService, $timeout) {
        function link(scope, element, attrs) {

            var chart;
            element.attr("class", "gauge-widget-icon");

            scope.getGaugeData = function (deviceId) {

                scope.setSetting();

                var gaugeData;

                switch(scope.dataCategoryId)
                {
                    case 15:
                        gaugeData = signalGaugeService.getData(scope.accountInfo.customerId, deviceId, scope.accountInfo.timeZone);
                        break;
                    case 17:
                        gaugeData = signalGaugeService.getSignalCategoryData(scope.accountInfo.customerId, deviceId, scope.accountInfo.timeZone, scope.dataCategoryId);
                        break;
                    case 42:
                        gaugeData = signalGaugeService.getSignalCategoryData(scope.accountInfo.customerId, deviceId, scope.accountInfo.timeZone, scope.dataCategoryId);
                        break;
                }

                _processGaugeData(gaugeData, scope.dataCategoryId);
            };

            var _processGaugeData = function (gaugeData, dataCategoryId) {

                gaugeData.then(function (result) {

                    scope.alerts = [];
                    scope.device = result.data.device;
                    scope.signalStrengthParam = result.data.device.signalStrengthParameter;

                    var _device = {
                        deviceId: scope.device.deviceId,
                        channel: dataCategoryId == 15 ? 'Signal' : (dataCategoryId == 17 ? 'Signal Quality': 'Signal Power'),
                        serialNumber: scope.device.serialNumber
                    };

                    sharedSetupService.setStickyProperties(scope.stickyProperties,
                        {
                            deviceId: scope.device.deviceId,
                            device: _device,
                            windowId: scope.windowId
                        });

                    if (scope.popup.selector !== ".flip-container")
                        scope.popup.dialog("option", "title", scope.device.name);

                    scope.deviceSelectedName = scope.device.name;
                    if (result.data.signalMeasurement == null) {
                        if (chart) {
                            chart.destroy();
                            chart = null;
                        }
                        scope.alerts.push({ msg: scope.translation.message.NO_DATA, type: "info" });
                    } else {
                        scope.Time = result.data.signalMeasurement.unixTime;

                        if (scope.dataCategoryId != 15) {
                            websocketService.connect();
                            websocketService.unRegister("SIGNAL",
                                scope.preDeviceSelected.serialNumber,
                                '',
                                wsDataReceivedSIGNAL,
                                wsReconnectSIGNAL);
                            websocketService.register("SIGNAL",
                                scope.device.serialNumber,
                                '',
                                wsDataReceivedSIGNAL,
                                wsReconnectSIGNAL);
                        }

                        scope.preDeviceSelected = result.data.device;
                        _drawSignalGauge(result.data, scope.dataCategoryId);
                    }
                },
                    function (error) {
                        scope.alerts = [];
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                    }).then(function () {
                        scope.resizeContent();
                        $timeout(function () {
                            scope.resizeContent();
                        },
                            0); //need second call to adjust alignment
                    });
            }; 
            
            var _drawSignalGauge = function (data, dataCategoryId) {
                var signalMeasurement = dataCategoryId == 17 ? "db": "dBm";
                title = '<br><br>' + data.device.name + (dataCategoryId ==15) ? (''): (dataCategoryId == 17 ? ' (Signal Quality)' : ' (Signal Power)' );
                var gaugeTitle = (dataCategoryId ==15) ? ('Signal') : (dataCategoryId == 17 ? 'Signal Quality' : 'Signal Power');
                chart = new Highcharts.Chart({

                    chart: {
                        renderTo: element[0],
                        type: 'gauge',
                        plotBackgroundColor: null,
                        plotBackgroundImage: null,
                        backgroundColor: 'rgba(0,0,0,0)',
                        plotBorderWidth: 0,
                        plotShadow: false,
                        spacing: [0, 0, 0, 0],
                        style: {
                            fontSize: '1em'
                        }
                    },

                    title: {
                        text: null
                    },
                    exporting: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    pane: {
                        startAngle: -150,
                        endAngle: 150

                    },
                    xAxis: {
                        labels: {
                            formatter: function () {
                                return this.value.toString().substring(0, 2);
                            }
                        },

                    },
                    tooltip: {
                        enabled: true,
                        formatter: function () {
                            return Highcharts.dateFormat('%b %e, %Y %H:%M:%S', scope.Time) + ': <br><b>' + this.y + signalMeasurement +"</b>";

                        }

                    },
                    yAxis: {
                        min: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -115 : -140) 
                                                    :(dataCategoryId == 42 ? -140 : -20) ,
                        max: (dataCategoryId ==15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -65 : -44) 
                                                   :(dataCategoryId == 42 ? -44 : 0),

                        minorTickWidth: 0,

                        //   tickPixelInterval: 30,
                        tickWidth: 1,
                        tickLength: 10,
                        tickColor: '#666',
                        tickPositions: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? [-115, -105, -95, -65] : [-140, -120, -90, -44]) 
                                                            : ( dataCategoryId == 42 ? [-140, -120, -90, -44] : [-20, -15, -10, -5, 0]),
                        labels: {
                            style: {
                                fontSize: '.5em'
                            }

                        },
                        title: {
                            text: '<p style="text-align:center;">' + gaugeTitle+ '</p>',
                            style:{
                                fontSize: '.7em'
                            }
                        },

                        plotBands: [{
                            from: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -115 : -140) : (dataCategoryId == 42 ? -140 : -20),
                            to: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -105 : -120):(dataCategoryId == 42 ? -120 : -15),
                            color: '#DF5353' // red
                        }, {
                            from: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -105 : -120):(dataCategoryId == 42 ? -120 : -15),
                            to: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -95 : -90): (dataCategoryId == 42 ? -90 : -5),
                            color: '#E8DB4F' // yellow
                        }, {
                            from: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -95 : -90):(dataCategoryId == 42 ? -90 : -5),
                            to: (dataCategoryId == 15) ?  (scope.signalStrengthParam.toLowerCase() == "rssi" ? -65 : -44): (dataCategoryId == 42 ? -44 : 0),
                            color: '#55BF3B' // green
                        }]
                    },
                    plotOptions: {
                        gauge: {
                            dataLabels: {
                                y: -10,
                                borderWidth: 0,
                                useHTML: true
                            }
                        }
                    },

                    series: [{
                        data: [data.signalMeasurement.value],
                        dataLabels: {
                            enabled: true,
                            borderWidth: 0,
                            style: {
                                fontSize: '.8em'
                            },
                            format: '<div style="text-align:center;margin-top:16px;"><span style="font-size:120%;color:' +
                                ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y:.2f}</span><br/>' +
                                '<span style="font-size:100%;">' + signalMeasurement +'</span></div>'

                        }
                    }]

                });

            };

            var wsDataReceivedSIGNAL = function (data) {
                scope.Time = datetimeService.toUnixtime(data.Time);
                chart.series[0].points[0].update(parseFloat(data.Value));
                scope.lastUpdateAt = datetimeService.socketStrToServerStrTime(data.Time);
            };

            scope.mostRecentData = function () {
                toaster.pop('success', "Signal Widget" + " -- " + scope.deviceSelectedName, 'View reloading');
                wsReconnectSIGNAL();
            }

            var wsReconnectSIGNAL = function (data) {
                scope.getGaugeData(scope.deviceSelectedId.deviceId);
            };

            scope.isTouchSupported = function () {
                var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
                var generalTouchEnabled = "ontouchstart" in document.createElement("div");

                if (msTouchEnabled || generalTouchEnabled) {
                    return true;
                }
                return false;
            };

            scope.replaceSpaces = function (str) {
                return str.replace(/ /g, '_');
            };

            scope.$on('document_click', function (e, event) {
                var $tgt = $(event.target);
                if ($tgt.closest('#signal-widget-' + scope.replaceSpaces(scope.windowId)).length === 0 || ($tgt.closest('.back').length === 0 && $tgt.closest('.front').length === 0)) {

                    if (scope.isTouchSupported()) {
                        scope.popup.parent().find(".front").toggle(true);
                        scope.popup.parent().find(".back").toggle(false);
                    } else {
                        $('#signal-widget-' + scope.replaceSpaces(scope.windowId)).offsetParent().offsetParent().find('.flip-container').toggleClass('flip', false);
                    }

                    scope.setSetting();
                    scope.resizeContent();
                }
            });

            scope.popup.parent().on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            if (scope.popup.parent().is('.ui-draggable-dragging, .ui-resizable-resizing') || event.target.nodeName === 'SELECT') {
                                return;
                            }

                            $rootScope.$broadcast('document_click', event);

                            if (scope.isTouchSupported()) {
                                scope.popup.parent().find(".back").toggle();
                                scope.popup.parent().find(".front").toggle();
                            } else {
                                scope.popup.parent().find('.flip-container').toggleClass('flip');
                            }

                            scope.setSetting();
                            scope.resizeContent();
                        }
                    );
                }
            );

            scope.popup.parent().find("select").on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            );

            scope.popup.parent().on(
                "mouseover",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            scope.popup.parent().addClass("x-resize");
                            scope.closeIcon = true;
                        }
                    );
                }
            );

            scope.popup.parent().on(
                "mouseout",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            scope.popup.parent().removeClass("x-resize");
                            if (scope.isTouchSupported()) {
                                setTimeout(function () {
                                    scope.closeIcon = false;
                                }, 3000);
                            }
                            else {
                                scope.closeIcon = false;
                            }
                        }
                    );
                }
            );

            scope.$on(
                "$destroy",
                function (event) {
                    websocketService.unRegister("SIGNAL", scope.device.serialNumber, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                    scope.popup.parent().off();
                    scope.popup.parent().find("select").off();
                    if (chart) chart.destroy();
                }
            );

            scope.getGaugeData(scope.deviceSelectedId.deviceId);
            if (scope.popup.selector !== ".flip-container") scope.popup.dialog("option", "dialogClass", "ui-widget-content-new");
        }


        return {
            restrict: 'A',
            replace: false,
            link: link 
        };
    }]);

mcapp.directive('signalSettingDirective', ["authenticationService", "websocketService", "deviceMenuService", "deviceService", "toaster",
    function (authenticationService, websocketService, deviceMenuService, deviceService, toaster) {
        function link(scope, element, attrs) {
            scope.notfirst = false;

            var signalStrength = scope.stickyProperties.device.channel == "Signal" ? true : false; 
            signalStrength = signalStrength || scope.stickyProperties.device.signalStrength;

            deviceMenuService.getDeviceMenuList(scope.accountInfo.customerId)
                .then(function (result) {
                   var _devices = result.data.devices;

                    scope.Devices = signalStrength ? _devices : _devices.filter(function (item) {
                        return item.model >= 19;
                    });

                }, function (error) {
                });

            scope.getBackToSignalData = function (deviceId) {
                if (deviceId != null)
                    scope.getGaugeData(deviceId);
                scope.popup.parent().find('.flip-container').toggleClass('flip');
                if (scope.isTouchSupported()) {
                    scope.popup.parent().find(".back").toggle();
                    scope.popup.parent().find(".front").toggle();
                }

                scope.resizeContent();
            };

        }
        return {
            link: link
        };


    }]);
// mcapp.controller('signalDataController', ['$scope', '$rootScope', 'translationService', 'sharedSetupService', 'openViewService', '$element', 'authenticationService', '$timeout', function ($scope, $rootScope, translationService, sharedSetupService, openViewService, $element, authenticationService, $timeout) {
//     sharedSetupService.getWindowId($scope);
//     $scope.myDate = null;
//     $scope.infiniteScrollOn = false;
//     $scope.infiniteScrollUpOn = false;
//     $scope.infiniteScrollDownOn = false;
//     $scope.checkFirstRowLiveStatus = null;
//     $scope.accountInfo = authenticationService.getAccountInfo();
//     $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
//     $scope.preferredMeasurementFormat = $scope.accountInfo.preferenceUser.lookupMeasurementID;
//     $scope.unixDay = sharedSetupService.unixDay;
//     $scope.liveDataOffset = sharedSetupService.liveDataOffset;
//     $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
//     $scope.translation = translationService.translation;
//     $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
//     $scope.alerts = [];
//     $scope.downloadViewTypeOptions = [0, 4];
//     sharedSetupService.broadcastAllDeviceSelected($scope);
//     sharedSetupService.getWindowId($scope);
//     $scope.liveTable = $element.find(".headertable");

//     $scope.liveDataLine = function (varLiveData) {
//         if (varLiveData) {
//             $scope.liveTable.addClass("live-data-line");
//         } else {
//             $scope.liveTable.removeClass("live-data-line");
//         }
//     };

//     $scope.getIcon = function (varTitle, varMode) {
//         return sharedSetupService.getIcon(varTitle, varMode);
//     };

//     $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
//         $scope.timeFormat = timeFormat;
//         $scope.updateLanguage();
//     });

//     $scope.$on('updatePreferencesLanguage', function () {
//         $scope.updateLanguage();
//     });

//     $scope.updateLanguage = function () {
//         $scope.signalDataService.items = angular.copy($scope.signalDataService.items);
//     };

//     if (!$rootScope.mobile && !$rootScope.classicView) {
//         $scope.popup = _this.getExistingDialog($scope.windowId).ref;
//         sharedSetupService.maximize($scope.popup);
//         $scope.popup.dialog({
//             resize: function (event, ui) {
//                 $scope.adjustSize();
//             }
//         });

//         $scope.popup.dialogExtend({
//             maximize: function (event, ui) {
//                 openViewService.adjustContentSizeStart($scope.popup);
//                 $scope.adjustSize();
//             },
//             restore: function (event, ui) {
//                 $scope.adjustSize();
//                 openViewService.adjustContentSizeStart($scope.popup);
//             }
//         });

//         $scope.adjustSize = function () {
//             $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
//             $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
//             $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
//             $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
//             $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
//             //$scope.adjustDeviceIdMenuSize();
//         };

//         $scope.adjustDeviceIdMenuSize = function () {
//             var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
//             if (spph < 450) {
//                 $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
//             }
//             else {
//                 $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
//             }
//         };
//     }
// }]);

// mcapp.directive('drawSignalData', ['$rootScope', '$timeout', 'signalDataService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', function ($rootScope, $timeout, signalDataService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService) {
//     // return the directive link function. (compile function not needed)
//     return function (scope, element, attrs) {
//         if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

//         var currentScrollbarPosition = 0;
//         var previousScrollbarPosition = 0;
//         var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
//         paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

//         scope.trgScroll = function () {
//             $timeout(function() {
//                 var $rowFirst = element.contents().find("tr:first");
//                 var _firstRow = $rowFirst.attr("name");
//                 if (typeof $rowFirst.position() !== "undefined") {
//                     var _tableTop = element.offset().top;
//                     var _rowTop = $rowFirst.offset().top;
//                     _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
//                 }
//             }, 0);
//         };

//         scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
//           if (scope.alerts.length > 0) {
//             var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
//             var _type = scope.alerts[0].type;
//             var _languageCode = scope.alerts[0].languageCode;
//             if (_languageCode.toUpperCase() === 'NO_DATA') {
//               _msg += ': ' + moment(scope.signalDataService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.signalDataService.end).utc().format('MM/DD/YY, h:mm:ss a');
//             }
//             scope.alerts = [];
//             scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
//           }
//         });

//         element.on('scroll', function (event) {
//             var $rowFirst = element.contents().find("tr:first");
//             var $rowLast = element.contents().find("tr:last");
//             if (typeof $rowFirst.position() !== "undefined") {
//                 scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
//                 scope.trgScroll();
//                 previousScrollbarPosition = currentScrollbarPosition;
//                 currentScrollbarPosition = element[0].scrollTop;
//             }

//             if (scope.infiniteScrollOn === true) {
//                 scope.infiniteScrollUpOn = true;
//                 scope.infiniteScrollDownOn = true;

//                 if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
//                     $rowLast.addClass("active-row");
// 	                scope.signalDataService.alerts =[];
//                     scope.signalDataService.nextPage();
//                 }
//                 if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
//                     $rowFirst.addClass("active-row");
//                     scope.signalDataService.alerts =[];
// 	                scope.signalDataService.previousPage();
//                 }
//             }

//             var rows = element.children().children().children().children();
//             var scrollpos = 40;
//             var start = 0;
//             var end = rows.length;
//             var count = 0;

//             while (start != end) {
//                 count++;
//                 var mid = start + Math.floor((end - start) / 2);
//                 if ($(rows[mid]).position().top < scrollpos)
//                     start = mid + 1;
//                 else
//                     end = mid;
//             }
//             _updateZoom(parseFloat($($(rows[start])).attr("name")));
//         });

//         var _updateZoom = function (currentRow) {
//             if (isNaN(currentRow))
//                 return;

//             var zoomMin = currentRow - paddingZoom;
//             var zoomMax = currentRow + paddingZoom;

//             var dateMin = scope.stickyProperties.dateMin;
//             var dateMax = scope.stickyProperties.dateMax;

//             if (zoomMin < scope.stickyProperties.dateMin) {
//                 dateMin = zoomMin;
//             }
//             if (zoomMax > scope.stickyProperties.dateMax) {
//                 dateMax = zoomMax;
//             }

//             sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
//         };

//         scope.toggle = function ($event) {
//             if ($($event.currentTarget).hasClass("active-row")) {
//                 $($event.currentTarget).removeClass("active-row");
//             }
//             else {
//                 $($event.currentTarget).addClass("active-row");
//             }
//         };

//         scope.$watch('lastUpdateAt', function (newValue, oldValue) {
//             if (newValue && newValue != oldValue) {
//                 scope.liveDataIn = !scope.liveDataIn;
//                 $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
//             }
//         }, true);

//         scope.$watch('signalDataService.alerts', function (newValue, oldValue) {
//             if (newValue && newValue.length > 0 && newValue != oldValue) {
//                 scope.alerts = newValue;
//             }
//         }, true);

//         scope.newSignalTableService = function () {
//             scope.signalDataService = new signalDataService();
//             scope.signalDataService.customerId = scope.accountInfo.customerId;
//             scope.signalDataService.timeZone = scope.accountInfo.timeZone;
//             scope.signalDataService.deviceId = scope.deviceSelected;
//             scope.signalDataService.deviceType = scope.deviceSelectedType;
//             scope.signalDataService.hasRMDTRadio = scope.hasRMDTRadio;
//             scope.signalDataService.windowTitle = scope.windowTitle;
//             scope.signalDataService.startRow = 1;
//             scope.signalDataService.pageSize = 50;
//         };

//         var _openTableInLiveMode = function () {
//             scope.stickyProperties.on = false;
//             timeLapseService.getLocalDateTime().then(function (result) {
//                 /////////////////////////////////////////////////////////////
//                 var tmpDates = new Date(result.data.localDateTime);
//                 var tmpDatesA = tmpDates;
//                 tmpDates.setHours(0, 0, 0, 0);
//                 tmpDates = datetimeService.dateToUnixtime(tmpDates);
//                 tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
//                 tmpDatesA.setHours(23, 59, 59, 0);
//                 tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
//                 /////////////////////////////////////////////////////////////
//                 scope.newSignalTableService();
//                 scope.signalDataService.start = tmpDates.startDate;
//                 scope.signalDataService.end = tmpDatesA;
//                 scope.signalDataService.deviceType = scope.deviceSelectedType;
//                 scope.signalDataService.hasRMDTRadio = scope.hasRMDTRadio;
//                 sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
//                 scope.signalDataService.nextPage();
//                 /////////////////////////////////////////////////////////////
//             });
//         }

//         scope.$watch('deviceSelected', function (newValue, oldValue) {
//             if (newValue) {
//                 /////////////////////////////////////////////////////////////
//                 currentScrollbarPosition = 0;
//                 previousScrollbarPosition = 0;
//                 scope.checkFirstRowLiveStatus = null;
//                 /////////////////////////////////////////////////////////////
//                 scope.alerts = [];
//                 var _device = { deviceName: scope.deviceSelectedName };
//                 sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId, hasRMDTRadio: scope.hasRMDTRadio });

//                 if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMin !== null) {
//                     scope.stickyProperties.on = true;
//                     timeLapseService.getLocalDateTime().then(function (result) {
//                         if (scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && scope.stickyProperties.zoomMax + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
//                             scope.newSignalTableService();
//                             scope.signalDataService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range;
//                             scope.signalDataService.end = scope.stickyProperties.dateMax;
//                             scope.signalDataService.deviceType = scope.deviceSelectedType;
//                             scope.signalDataService.hasRMDTRadio = scope.hasRMDTRadio;
//                             scope.signalDataService.nextPage();
//                         }
//                         else {
//                             scope.newSignalTableService();
//                             scope.signalDataService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range;
//                             scope.signalDataService.end = Math.round((scope.stickyProperties.zoomMax + scope.stickyProperties.zoomMin) / 2);
//                             scope.signalDataService.deviceType = scope.deviceSelectedType;
//                             scope.signalDataService.hasRMDTRadio = scope.hasRMDTRadio;
//                             scope.signalDataService.nextPage();
//                         }
//                     });
//                 }
//                 else {
//                     _openTableInLiveMode();
//                 }
//             }
//         }, true);

//         scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
//             if (newValue && newValue != oldValue) {
//                 scope.stickyProperties.device.serialNumber = newValue;
//                 if (oldValue) {
//                     _unRegisterListener(oldValue);
//                 }
//             }
//         }, true);

//         scope.selectMyDate = function (date) {
//             scope.myDate = date;
//             scope.signalDataService = new signalDataService();
//             /////////////////////////////////////////////////////////////
//             currentScrollbarPosition = 0;
//             previousScrollbarPosition = 0;
//             scope.checkFirstRowLiveStatus = null;
//             _unRegisterListener(scope.deviceSelectedSn);
//             /////////////////////////////////////////////////////////////
//             var tmpDates = scope.myDate;
//             var tmpDatesA = tmpDates;
//             tmpDates.setHours(0, 0, 0, 0);
//             tmpDates = datetimeService.dateToUnixtime(tmpDates);
//             tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
//             tmpDatesA.setHours(12, 0, 0, 0);
//             tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
//             /////////////////////////////////////////////////////////////
//             scope.signalDataService.start = tmpDates.startDate;
//             if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
//                 scope.signalDataService.end = tmpDatesA;
//             }
//             else {
//                 scope.signalDataService.end = tmpDates.endDate;
//             }
//             /////////////////////////////////////////////////////////////
//             scope.signalDataService.startRow = 1;
//             scope.signalDataService.pageSize = 50;
//             scope.signalDataService.customerId = scope.accountInfo.customerId;
//             scope.signalDataService.timeZone = scope.accountInfo.timeZone;
//             scope.signalDataService.deviceId = scope.deviceSelected;
//             scope.signalDataService.windowTitle = scope.windowTitle;
//             scope.signalDataService.deviceType = scope.deviceSelectedType;
//             scope.signalDataService.hasRMDTRadio = scope.hasRMDTRadio;
//             scope.alerts = [];
//             scope.signalDataService.nextPage();
//             /////////////////////////////////////////////////////////////
//             sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
//         };

//         var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
//             if (scope.checkFirstRowLiveStatus === true) {
//                 _checkTopOffset(liveDataStatusOn);
//             }
//             else if (scope.checkFirstRowLiveStatus === null) {
//                 timeLapseService.getLocalDateTime().then(function (result) {
//                     if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
//                         scope.checkFirstRowLiveStatus = true;
//                         _checkTopOffset(liveDataStatusOn);
//                     }
//                     else {
//                         scope.checkFirstRowLiveStatus = false;
//                     }
//                 });
//             }
//         };

//         var _checkTopOffset = function (liveDataStatusOn) {
//             if (liveDataStatusOn) {
//                 _registerListener(scope.deviceSelectedSn);
//             }
//             else {
//                 _unRegisterListener(scope.deviceSelectedSn);
//             }
//         };

//         var wsDataReceivedSIGNAL = function (data) {
//             var i = 0;
//             var _recordExistAtIndex = null;
//             if (scope.liveData === false) {
//                 _unRegisterListener(scope.deviceSelectedSn);
//                 return;
//             }

//             var varTime = datetimeService.socketStrToServerStrTime(data.Time);
//             var varValue = parseFloat(data.Value);

//             for (i = 0; i < scope.signalDataService.items.length; i++) {
//                 if (scope.signalDataService.items[i].localDateTime === varTime) {
//                   _recordExistAtIndex = i;
//                   break;
//                 }
//               }
  
//             if (_recordExistAtIndex !== null) {
//             //console.log('New row in input at: ' + varTime);
//             scope.signalDataService.items[_recordExistAtIndex].value = varValue;
//             } 
//             else {
//             var _newMeasurements = { "localDateTime": varTime, "value": varValue };
//             scope.signalDataService.items.unshift(_newMeasurements);
//             }
//             scope.signalDataService.end = datetimeService.toUnixtime(data.Time) + scope.unixDay;
//             scope.lastUpdateAt = varTime;
//         };
//         var wsDataReceivedSIGNALPOWER = function (data) {
//             var i = 0;
//             var _recordExistAtIndex = null;
//             if (scope.liveData === false) {
//                 _unRegisterListener(scope.deviceSelectedSn);
//                 return;
//             }

//             var varTime = datetimeService.socketStrToServerStrTime(data.Time);
//             var varValue = parseFloat(data.Value);
//             for (i = 0; i < scope.signalDataService.items.length; i++) {
//                 if (scope.signalDataService.items[i].localDateTime === varTime) {
//                   _recordExistAtIndex = i;
//                   break;
//                 }
//               }
//               console.log('_recordExistAtIndex Power' + _recordExistAtIndex);
//             if (_recordExistAtIndex !== null) {
//             scope.signalDataService.items[_recordExistAtIndex].signalPower = varValue;
//             } 
//             else {
//             var _newMeasurements = { "localDateTime": varTime, "signalPower": varValue };
//             scope.signalDataService.items.unshift(_newMeasurements);
//             }
//             console.log('scope.signalDataService.items P' + scope.signalDataService.items);
//             scope.signalDataService.end = datetimeService.toUnixtime(data.Time) + scope.unixDay;
//             scope.lastUpdateAt = varTime;
//         };
//         var wsDataReceivedSIGNALQUALITY = function (data) {
//             var i = 0;
//             var _recordExistAtIndex = null;
//             if (scope.liveData === false) {
//                 _unRegisterListener(scope.deviceSelectedSn);
//                 return;
//             }

//             var varTime = datetimeService.socketStrToServerStrTime(data.Time);
//             var varValue = parseFloat(data.Value);

//             for (i = 0; i < scope.signalDataService.items.length; i++) {
//                 if (scope.signalDataService.items[i].localDateTime === varTime) {
//                   _recordExistAtIndex = i;
//                   break;
//                 }
//               }
//               console.log('_recordExistAtIndex Quality' + _recordExistAtIndex);
//             if (_recordExistAtIndex !== null) {
//             //console.log('New row in input at: ' + varTime);
//             scope.signalDataService.items[_recordExistAtIndex].signalQuality = varValue;
//             } 
//             else {
//             var _newMeasurements = { "localDateTime": varTime, "signalQuality": varValue };
//             scope.signalDataService.items.unshift(_newMeasurements);
//             }
//             console.log('scope.signalDataService.items Q' + scope.signalDataService.items);
//             scope.signalDataService.end = datetimeService.toUnixtime(data.Time) + scope.unixDay;
//             scope.lastUpdateAt = varTime;
//         };

//         scope.$on('processReconnect', function (event, args) {
//             scope.reconnectData(event, args);
//         });

//         scope.reconnectData = function (event, args) {
//             sharedSetupService.processReconnect({
//                 stickyProperties: scope.stickyProperties,
//                 localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
//                 dateRangeOption: null,
//                 windowTitle: scope.windowTitle,
//                 fnUnregister: _unRegisterListener,
//                 fnGetData: _openTableInLiveMode,
//                 viewType: "Table"
//             });
//         }

//         scope.mostRecentData = function (event, args) {
//             scope.stickyProperties.liveData = true;
//             scope.myDate = null;
//             scope.reconnectData(event, args);
//         }

//         var _registerListener = function (varSelectedSN) {
//             sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
//             scope.liveData = true;
//             scope.liveDataLine(scope.liveData);
//             scope.signalDataService.numberOfNewRecordsPrevious = -1;
//             websocketService.connect();
//             websocketService.register("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, null);
//             websocketService.register("SIGNALPOWER", varSelectedSN, "", wsDataReceivedSIGNALPOWER, null);
//             websocketService.register("SIGNALQUALITY", varSelectedSN, "", wsDataReceivedSIGNALQUALITY, null);
//         };

//         var _unRegisterListener = function (varSelectedSN) {
//             sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
//             if (scope.liveData === false)
//                 return;
//             scope.liveData = false;
//             scope.liveDataLine(scope.liveData);
//             scope.lastUpdateAt = undefined;
//             websocketService.unRegister("SIGNAL", varSelectedSN, "", wsDataReceivedSIGNAL, null);
//             websocketService.unRegister("SIGNALPOWER", varSelectedSN, "", wsDataReceivedSIGNALPOWER, null);
//             websocketService.unRegister("SIGNALQUALITY", varSelectedSN, "", wsDataReceivedSIGNALQUALITY, null);
//         };

//         scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
//             _autoScroll();
//             scope.checkFirstRowLiveStatus = null;
//             scope.trgScroll();
//         });

//         var _autoScroll = function () {
//             if (scope.signalDataService.numberOfNewRecordsPrevious > 0) {
//                 var trRow = element.find('tr').eq(scope.signalDataService.numberOfNewRecordsPrevious - 1);
//                 var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
//                 element.scrollTop(yPosition);
//             }
//             else {
//                 $timeout(function () {
//                     element.animate({
//                         scrollTop: 5
//                     }, 500);
//                 }, 0);
//             }
//         };

//         scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
//             scope.preferredMeasurementFormat = parseInt(measurementSystem);
//         });

//         scope.$on("$destroy", function () {
//             _unRegisterListener(scope.deviceSelectedSn);
//         });

//     };
// }]);

// mcapp.factory('signalDataService', ['$http', 'datetimeService', 'toaster', 'userMessageService', 'translationService', 'HOST', function ($http, datetimeService, toaster, userMessageService, translationService, HOST) {
//     var signalDataService = function () {
//         this.items = [];
//         this.deviceName = '';
//         this.customerId = null;
//         this.deviceId = null;
//         this.timeZone = "Z";
//         this.startRow = 1;
//         this.pageSize = 50;
//         this.start = '19000101';
//         this.end = '19000101';
//         this.busy = false;
//         this.numberOfReturnedRecords = -1;
//         this.numberOfNewRecordsPrevious = -1;
//         this.windowTitle = null;
//         this.alerts =[];
//         this.translation = translationService.translation;
//         this.scrollUp = "";
//         this.scrollDown = "";
//         this.deviceType = null;
//         this.deviceRadioTypeId = null;
//     };

//     signalDataService.prototype.previousPage = function () {
//         if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
//         this.busy = true;
//         this.pageSize = -50;

//         //from is: very top record
//         var url = HOST + "/api/SignalTable?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end + "&fromDate=" + this.scrollUp + "&timeZone=" + this.timeZone;
//         $http.get(url).then(function (result) {
//             /////////////////////////
//             var intDayWindow = 10;
//             var intDay = 86400000;
//             /////////////////////////
//             var deviceName = result.data.device.name;
//             var items = result.data.data.measurements;
//             for (var i = 0; i < items.length; i++) {
//                 items[i].localDateTime = items[i].localDateTime;
//                 items[i].value = items[i].value;
//                 this.items.unshift(items[i]);
//             }
//             this.numberOfNewRecordsPrevious = items.length;
//             this.numberOfRecords = this.items.length;
//             this.deviceName = deviceName;
//             this.startRow = this.startRow + items.length;
//             if (items.length > 0) { //if there are records returned
//                 this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
//                 this.end = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
//             }

//             if (this.items.length > 0) {
//                 this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
//                 this.scrollDown = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localDateTime.replace(/\D/g, ''));
//             } else {
//                 this.scrollUp = "";
//                 this.scrollDown = "";
//             }

//             this.pageSize = 50;
//             this.busy = false;
//         }.bind(this), function (error) {
// 				this.alerts =[];
// 				var errorMessage = eval("this.translation.message." + error.data.message);
// 				this.alerts.push({ msg: errorMessage, type: "danger"});
// 				this.pageSize = 50;
//                 this.busy = false;
//             }.bind(this));
//     };

//     signalDataService.prototype.nextPage = function () {
//         if (this.busy || this.numberOfReturnedRecords === 0) return;
//         this.busy = true;
//         //from is: very bottom record
//         var url = HOST + "/api/SignalTable?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end + "&fromDate=" + this.scrollDown + "&timeZone=" + this.timeZone;
//         $http.get(url).then(function (result) {
//             /////////////////////////
//             var intDayWindow = 10;
//             var intDay = 86400000;
//             /////////////////////////
//             var deviceName = result.data.device.name;
//             var items = result.data.data.measurements;
//             for (var i = 0; i < items.length; i++) {
//                 items[i].localDateTime = items[i].localDateTime;
//                 items[i].value = items[i].value;
//                 items[i].value.signalQuality = items[i].signalQuality;
//                 this.items.push(items[i]);
//             }
//             this.numberOfReturnedRecords = items.length;
//             this.deviceName = deviceName;
//             this.startRow = this.startRow + items.length;
// 				if (items.length > 0) { //if there are records returned
// 					this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
//                     this.end = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
// 				}
// 				else {
// 				  // If we didn't get any items back AND there aren't already any items
// 				  if (this.items.length === 0) {
// 					this.alerts = [];
// 					  var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
// 					  this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
// 				  }
// 				}
            
//                 if (this.items.length > 0) {
//                     this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
//                     this.scrollDown = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localDateTime.replace(/\D/g, ''));
//                 } else {
//                     this.scrollUp = "";
//                     this.scrollDown = "";
//                 }

// 				this.pageSize = 50;
//                 this.busy = false;
// 			}.bind(this), function (error) {
// 					this.alerts =[];
// 					var errorMessage = eval("this.translation.message." + error.data.message);
// 					this.alerts.push({ msg: errorMessage, type: "danger"});
// 					this.pageSize = 50;
//                 	this.busy = false;
// 			}.bind(this));
//     };

//     return signalDataService;
// }]);

mcapp.controller("signalGaugeController", ["$scope","$rootScope", "translationService", "sharedSetupService", "openViewService",
    function ($scope, $rootScope, translationService, sharedSetupService, openViewService) {
        $scope.Time = null;
        $scope.translation = translationService.translation;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.downloadViewTypeOptions = [0];
        sharedSetupService.getWindowId($scope);

        $scope.signalStrenghtDataCategoryID = 15;
        $scope.signalQualityDataCategoryID = 17;
        $scope.signalPowerDataCategoryID = 42;

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function() {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)')
                    .css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height",
                    $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") -
                    $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.signal-gauge-container').css("height",
                    $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") -
                    $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") -
                    $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") -
                    20);
                //$scope.adjustDeviceIdMenuSize();
            };

            $scope.adjustDeviceIdMenuSize = function() {
                var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")
                if (spph < 450) {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
                } else {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
                }
            };
        }
    }]);
mcapp.directive('signalGaugeDirective', ["authenticationService", "websocketService", "signalGaugeService", "deviceService", "datetimeService", "toaster", "openViewService", "sharedSetupService",
    function (authenticationService, websocketService, signalGaugeService, deviceService, datetimeService, toaster, openViewService, sharedSetupService) {
        function link(scope, element, attrs) {
            var chart;
            var signalQualitychart;
            var signalPowerchart;
            scope.accountInfo = authenticationService.getAccountInfo();
            if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

            scope.$watch('deviceSelected', function (newValue, oldValue) {
                if (newValue) {
                    element.empty();
                    var _device = { deviceName: scope.deviceSelectedName };
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                    if (scope.deviceSelectedType === 17 || scope.deviceSelectedType === 18 || scope.deviceSelectedType === 19 || scope.deviceSelectedType === 20 || scope.deviceSelectedType === 21) {
                        _getSignalCategoryData(newValue, scope.signalQualityDataCategoryID);
                        _getSignalCategoryData(newValue, scope.signalPowerDataCategoryID);
                    }
                    else if (scope.hasRMDTRadio) {
                        //Draw Signal Strength Quality and Power Gauges
                        _getSignalCategoryData(newValue, scope.signalStrenghtDataCategoryID);
                        _getSignalCategoryData(newValue, scope.signalQualityDataCategoryID);
                        _getSignalCategoryData(newValue, scope.signalPowerDataCategoryID);
                    }
                    else {
                        _getSignalData(newValue);
                    }
                }
            }, true);

            scope.$on("$destroy", function () {
                //distroyScopeChannel();
                element.empty();
                websocketService.unRegister("SIGNAL", scope.deviceSelectedSn, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                websocketService.unRegister("SIGNALPOWER", scope.deviceSelectedSn, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                websocketService.unRegister("SIGNALQUALITY", scope.deviceSelectedSn, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
            });

            var _getSignalData = function (DeviceID) {
                var _device = { deviceName: scope.deviceSelectedName };
                websocketService.connect();
                websocketService.register("SIGNAL", scope.deviceSelectedSn, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                websocketService.register("SIGNALPOWER", scope.deviceSelectedSn, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                websocketService.register("SIGNALQUALITY", scope.deviceSelectedSn, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: DeviceID, device: _device, windowId: scope.windowId });
                scope.liveData = true;
                scope.alerts = [];

                signalGaugeService.getData(scope.accountInfo.customerId,DeviceID, scope.accountInfo.timeZone)
                    .then(function (result) {
                        scope.signalStrengthParam = result.data.device.signalStrengthParameter;
                        if (result.data.signalMeasurement == null) {
                            if (chart) {
                                chart.destroy();
                                chart = null;
                            }
                            scope.alerts.push({ msg: scope.translation.message.NO_DATA, type: "info" });
                        }
                        else {
                        //websocketService.connect();
                        scope.Time = result.data.signalMeasurement.unixTime;
                        //    var data = {Value: result.data.Value, Time: time}
                        _drawSignalGauge(result.data, scope.signalStrenghtDataCategoryID);
                        }
                    }, function (error) {
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                    });
            };

            var _getSignalCategoryData = function (DeviceID, dataCategoryId ) {
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: DeviceID, device: _device, windowId: scope.windowId });
                scope.alerts = [];
                scope.signalStrengthParam  = "RSSI";

                signalGaugeService.getSignalCategoryData(scope.accountInfo.customerId,DeviceID, scope.accountInfo.timeZone, dataCategoryId )
                    .then(function (result) {
                        if (result.data.signalMeasurement == null) {
                            if (chart) {
                                chart.destroy();
                                chart = null;
                            }
                            scope.alerts.push({ msg: scope.translation.message.NO_DATA, type: "info" });
                        }
                        else {
                        //websocketService.connect();
                        scope.Time = result.data.signalMeasurement.unixTime;
                        //    var data = {Value: result.data.Value, Time: time}
                        _drawSignalGauge(result.data, dataCategoryId );
                        }
                    }, function (error) {
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                    });
            };

            var _drawSignalGauge = function (data, dataCategoryId) {
                var signalMeasurement = dataCategoryId == 17 ? "db": "dBm";
                var container = document.createElement('div');
                var gaugeTitle = '';

                switch(dataCategoryId)
                {
                    case 15:
                        container.setAttribute("class", "hcolAnalog");
                        gaugeTitle = 'Signal';
                        break;
                    case 17:
                        container.setAttribute("class", "hcolSignalQuality");
                        gaugeTitle = 'Signal Quality';
                        break;
                    case 42:
                        container.setAttribute("class", "hcolSignalPower");
                        gaugeTitle = 'Signal Power';
                        break;
                }
                element.append(container);
                chartNew = new Highcharts.Chart({

                    chart: {
                        renderTo: container,
                        type: 'gauge',
                        plotBackgroundColor: null,
                        plotBackgroundImage: null,
                        backgroundColor: 'rgba(0,0,0,0)',
                        plotBorderWidth: 0,
                        plotShadow: false,
                        spacing: [0, 0, 0, 0]
                    },

                    title: {
                        text: null
                    },
                    exporting: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    pane: {
                        startAngle: -150,
                        endAngle: 150

                    },
                    xAxis: {
                        labels: {
                            formatter: function () {
                                return this.value.toString().substring(0, 2);
                            }
                        },

                    },
                    tooltip: {
                        enabled: true,
                        formatter: function () {
                            return Highcharts.dateFormat('%b %e, %Y %H:%M:%S', scope.Time) + ': <br><b>' + this.y + signalMeasurement + "</b>";

                        }

                    },
                    yAxis: {
                        min: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -115 : -140) 
                                                    :(dataCategoryId == 42 ? -140 : -20) ,
                        max: (dataCategoryId ==15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -65 : -44) 
                                                   :(dataCategoryId == 42 ? -44 : 0),

                        minorTickWidth: 0,

                        //   tickPixelInterval: 30,
                        tickWidth: 1,
                        tickLength: 10,
                        tickColor: '#666',
                        tickPositions: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? [-115, -105, -95, -65] : [-140, -120, -90, -44]) 
                                                              : ( dataCategoryId == 42 ? [-140, -120, -90, -44] : [-20, -15, -10, -5, 0]),

                        title: {
                               text: '<p style="text-align:center;">' + gaugeTitle+ '</p>'
                        },

                        plotBands: [{
                            from: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -115 : -140) : (dataCategoryId == 42 ? -140 : -20),
                            to: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -105 : -120):(dataCategoryId == 42 ? -120 : -15),
                            color: '#DF5353' // red
                        }, {
                            from: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -105 : -120):(dataCategoryId == 42 ? -120 : -15),
                            to: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -95 : -90): (dataCategoryId == 42 ? -90 : -5),
                            color: '#E8DB4F' // yellow
                        }, {
                            from: (dataCategoryId == 15) ? (scope.signalStrengthParam.toLowerCase() == "rssi" ? -95 : -90):(dataCategoryId == 42 ? -90 : -5),
                            to: (dataCategoryId == 15) ?  (scope.signalStrengthParam.toLowerCase() == "rssi" ? -65 : -44): (dataCategoryId == 42 ? -44 : 0),
                            color: '#55BF3B' // green
                        }]
                    },
                    plotOptions: {
                        gauge: {
                            dataLabels: {
                                y: -10,
                                borderWidth: 0,
                                useHTML: true
                            }
                        }
                    },

                    series: [{
                        name: gaugeTitle,
                        data: [data.signalMeasurement.value],
                        dataLabels: {
                            enabled: true,
                            borderWidth: 0,
                            format: '<div style="text-align:center;margin-top:16px;"><span style="font-size:120%;color:' +
                        ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y:.2f}</span><br/>' +
                           '<span style="font-size:12px;">' + signalMeasurement +'</span></div>'

                        }
                    }]

                });
                switch(dataCategoryId)
                {
                    case 15:
                        chart = chartNew;
                        break;
                    case 17:
                        signalQualitychart = chartNew;
                        break;
                    case 42:
                        signalPowerchart = chartNew;
                        break;
                }
            };

            var wsDataReceivedSIGNAL = function (data) {
                scope.Time = datetimeService.toUnixtime(data.Time);
                var signlaMsgType = data.Type;
                var seriesType = ( chart.series[0].name.replace(/\s/g, '').toUpperCase());
                if(signlaMsgType == seriesType)
                {
                  chart.series[0].points[0].update(parseFloat(data.Value));
                }
                scope.lastUpdateAt = datetimeService.socketStrToServerStrTime(data.Time);
            };

            scope.mostRecentData = function () {
                element.empty();
                toaster.pop('success', "Signal Gauge" + " -- " + scope.deviceSelectedName, 'View reloading');
                wsReconnectSIGNAL();
            }

            var wsReconnectSIGNAL = function (data) {
                _getSignalData(scope.deviceSelected);
            };

            scope.$on("$destroy", function () {
                distroySignalGauge();
                if (chart) chart.destroy();
            });
            var distroySignalGauge = function () {
            //    element.empty();
                websocketService.unRegister("SIGNAL", scope.deviceSelectedSn, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                websocketService.unRegister("SIGNALPOWER", scope.deviceSelectedSn, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);
                websocketService.unRegister("SIGNALQUALITY", scope.deviceSelectedSn, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);

            };

            _mouseoverFunction = function (signalType, dataCategoryId) {
                return function (event) {
                    var localScope = $(event.target).scope();
                    if ($(event.currentTarget).is("." + signalType) && !scope.mobile && !scope.classicView) {
                        $(event.currentTarget).draggable({
                            helper: "clone",
                            revert: false,
                            appendTo: "body",
                            containment: "body",
                            opacity: 0.35,
                            stop: function (event, ui) {
                                var mcDevice = {
                                    deviceId: scope.deviceSelected,
                                    serialNumber: scope.deviceSelectedSn,
                                    signalStrength: signalType === "hcolSignalQuality" ? false : true,
                                    dataCategoryId: dataCategoryId
                                };

                                var optionsStickyProperties = {
                                    device: mcDevice
                                };

                                var $newPosX = ui.offset.left;
                                var $newPosY = ui.offset.top;
                                var position = {
                                    my: "left+" + $newPosX + " top+" + $newPosY,
                                    at: "left top",
                                    of: window
                                };
                                openViewService.openWidget('Signal Widget',
                                    { width: 240, height: 240 },
                                    position,
                                    optionsStickyProperties,
                                    sharedSetupService.getViewPropery(1, "minimumWidth"));

                                scope.$apply();
                            }
                        });
                    }
                };
            };

            element.on(
                "mouseover.signalGaugeDirective",
                ".hcolAnalog",
                _mouseoverFunction("hcolAnalog", scope.signalStrenghtDataCategoryID)
            );

            element.on(
                "mouseover.signalGaugeDirective",
                ".hcolSignalQuality",
                _mouseoverFunction("hcolSignalQuality" , scope.signalQualityDataCategoryID)
            );

            element.on(
                "mouseover.signalGaugeDirective",
                ".hcolSignalPower",
                _mouseoverFunction("hcolSignalPower",scope.signalPowerDataCategoryID)
            );

            scope.$on(
                       "$destroy",
                       function (event) {
                           element.off("mouseover.signalGaugeDirective");
                       }
                   );
        }


        return {
            restrict: 'A',
            replace: false,
            link: link
        };
    }]);

mcapp.directive('connectGaugeDirective', ["authenticationService", "websocketService", "connectGaugeService", "deviceService", "toaster","openViewService", "sharedSetupService",
    function (authenticationService, websocketService, connectGaugeService, deviceService, toaster, openViewService, sharedSetupService) {
        function link(scope, element, attrs) {

            var accountInfo = authenticationService.getAccountInfo();

            scope.$watch('deviceSelected', function (newValue, oldValue) {
                if (newValue) {

                    _getConnectData(newValue);
                }
            }, true);

            scope.$on("$destroy", function () {
                element.empty();
                distroyConnectGauge();
            });
            var distroyConnectGauge = function () {
              //  element.empty();
                // websocketService.unRegister("SIGNAL", scope.deviceSelectedSn, '', wsDataReceivedSIGNAL, wsReconnectSIGNAL);

            };
            var _getConnectData = function (DeviceID) {
                distroyConnectGauge();
                connectGaugeService.getData(scope.accountInfo.customerId,DeviceID)
                    .then(function (result) {
                        //websocketService.connect();
                         var deviceType = result.data.device.type;
                         scope.signalStrengthParam = result.data.device.signalStrengthParameter;
                        _drawConnectGauge(result.data.measurement.connectPctLast24Hrs, deviceType);
                    }, function (error) {
                        scope.alerts = [];
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                    });
            };
            var _drawConnectGauge = function (data, deviceType) {
                if(deviceType == 15 || deviceType == 20)
                {
                    if (data > 0)  {
                        scope.connectThumb = "fa fa-thumbs-up fagreen";
                        scope.connectValue =  "100%";
                    }
                    else {
                        scope.connectThumb = "fa fa-thumbs-down fared";
                        scope.connectValue = data + "%";
                    }
                }
                else
                {
                if (data < 90)
                    scope.connectThumb = "fa fa-thumbs-down fared";
                if (data >= 90 && data < 98.333)
                    scope.connectThumb = "fa fa-thumbs-o-up fayellow";
                if (data >= 98.333)
                    scope.connectThumb = "fa fa-thumbs-up fagreen";
                scope.connectValue = data + "%";
                }
            };


            element.on(
                    "mouseover.connectGaugeDirective",
                    ".hcolAnalog",
                    function (event) {
                        var localScope = $(event.target).scope();
                        if ($(event.currentTarget).is(".hcolAnalog")) {
                            $(event.currentTarget).draggable({
                                helper: "clone",
                                revert: false,
                                appendTo: "body",
                                containment: "body",
                                opacity: 0.35,
                                stop: function (event, ui) {
                                    var mcDevice = { deviceId: scope.deviceSelected };

                                    var optionsStickyProperties = {
                                        device: mcDevice
                                    };

                                    var $newPosX = ui.offset.left;
                                    var $newPosY = ui.offset.top;
                                    var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                                    openViewService.openWidget('Connection Widget', { width: 240, height: 240 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                    scope.$apply();

                                }
                            });
                        }
                    }
                );
            scope.$on(
                       "$destroy",
                       function (event) {
                           element.off("mouseover.connectGaugeDirective");
                       }
                   );
        }

        return {
            link: link
        };
    }]);
mcapp.factory("signalGaugeService", ["$http", "HOST", function ($http, HOST) {
    var signalGaugeFatory = {};

    var _getData = function (customerId,deviceId, timezone) {
        return $http({
            method: 'Get',
            url: HOST + '/api/SignalGauge?customerId=' + customerId + '&deviceId=' + deviceId+ '&Timezone=' + timezone,
            cache: false
        });
    };

    var _getSignalCategoryData = function (customerId,deviceId, timezone, dataCategoryId ) {
        return $http({
            method: 'Get',
            url: HOST + '/api/SignalGauge?customerId=' + customerId + '&deviceId=' + deviceId+ '&Timezone=' + timezone+ '&signalDataCategory=' + dataCategoryId ,
            cache: false
        });
    };

    signalGaugeFatory.getData = _getData;
    signalGaugeFatory.getSignalCategoryData = _getSignalCategoryData;
    return signalGaugeFatory;

}]);
mcapp.factory("connectGaugeService", ["$http", "HOST", function ($http, HOST) {
    var connectGaugeService = {};

    var _getData = function (customerId,deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DeviceConnectPct?customerId=' + customerId + '&deviceId=' + deviceId,
            cache: false
        });
    };
    connectGaugeService.getData = _getData;
    return connectGaugeService;

}]);

mcapp.controller("signalCalendarController", ["$scope", '$rootScope', "translationService", "authenticationService", "datetimeService", "signalCalendarService", "uiCalendarConfig", "$element", "sharedSetupService", "openViewService",
    function ($scope, $rootScope, translationService, authenticationService, datetimeService, signalCalendarService, uiCalendarConfig, $element, sharedSetupService, openViewService) {
        sharedSetupService.getWindowId($scope);
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.downloadViewTypeOptions = [0, 4];
        $scope.downloadOptions = { resolution: 5 }
        $scope.lang = $scope.accountInfo.preferenceUser.i18nCode;
        $scope.translation = translationService.translation;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.calendarHeight = "auto";
        $scope.startDateAlreadySet = false;

        $scope.chartId = "signalCalendarContainer" + Math.floor((Math.random() * 10000) + 1);
        sharedSetupService.getWindowId($scope);
      
        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);
            $scope.calendarHeight = $scope.popup.outerHeight() - 90;
            $scope.popup.dialog({
                resizeStop: function(event, ui) {
                    $('#map').removeClass('no-events');
                    _resize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    _resize();
                },
                restore: function(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    _resize();
                }
            });
            var _resize = function() {
                $scope.calendarHeight = $scope.popup.outerHeight() - 90;
                //$scope.fullCalendar.fullCalendar('option', 'height', $scope.calendarHeight);
                //$scope.fullCalendar.fullCalendar('refresh');
                // $scope.$apply();
                $scope.popup.find('.fc-time-grid').css("height", $scope.calendarHeight / 6);
                $scope.popup.find('.fc-slats td').css("height", $scope.calendarHeight / 6);
                $scope.fullCalendar.fullCalendar('refresh');
                $scope.$apply();
            };
        }
        $scope.setHideLegend = function ($event) {
            $scope.hideLegend = !$scope.hideLegend;
        };

        $scope.fnChangeLanguage = function () {
            $scope.lang = $scope.accountInfo.preferenceUser.i18nCode;
            $scope.fnDrawCalendar($scope.deviceSelected);
        };
    }]);

mcapp.directive('signalCalendar', ["$timeout", '$rootScope', "authenticationService", "signalCalendarService", "datetimeService", "toaster", "sharedSetupService", "openViewService", "$window",
    function ($timeout, $rootScope, authenticationService, signalCalendarService, datetimeService, toaster, sharedSetupService, openViewService, $window) {
        function link($scope, element, attrs) {
            $scope.onSignalConnectView = false; // enables to determine whether this component is on SignalConnect view or RtuData view
            if (attrs.manualDeviceSelected) { // this is valid on Signal Connect view only
                $scope.manualDeviceSelected = attrs.manualDeviceSelected;
                $scope.signalCalendarData = JSON.parse(attrs.signalCalendarData);
                $scope.signalCalendarData ? $scope.onSignalConnectView = true : $scope.onSignalConnectView = false;
            }

            if ($rootScope.mobile && !$scope.manualDeviceSelected) {
                var tmpCurrentWindow = angular.element($window);
                tmpCurrentWindow.bind('resize', function () {

                    //this is a trick to refresh the calendar on resize
                    //this is a trick to refresh the calendar on resize
                    //this is a trick to refresh the calendar on resize
                    var origin = location.origin;
                    var path = location.pathname;
                    var queryString = $rootScope.mobileApp ? "?" + location.href.split("?")[1] : "";
                    var angJs = "#!/";
                    var newPage = "pleasewait/please-wait";
                    location.replace(origin + path + angJs + newPage + queryString);
                    newPage = "signal/signal-calendar";
                    location.replace(origin + path + angJs + newPage + queryString);

                    $scope.$apply();
                });
            }
            var resize = function () {
                $timeout(function () {
                    if (!$rootScope.mobile && !$rootScope.classicView) {
                        $scope.calendarHeight = $scope.popup.outerHeight() - 127;
                        $scope.popup.find('.fc-time-grid').css('height', $scope.calendarHeight / 6);
                        $scope.popup.find('.fc-slats td').css('height', $scope.calendarHeight / 6);
                        $(element).find('.fc-sat').css('text-decoration', 'underline');
                        $(element).find('.fc-sat').css('font-weight', 'bold');
                        $(element).find('.fc-sat').css('cursor', 'pointer');
                    }
                    if ($scope.fullCalendar) {
                        $scope.fullCalendar.fullCalendar('option', 'contentHeight', $scope.calendarHeight -26);
                        $scope.fullCalendar.fullCalendar('refresh');
                    }
                });
            };
            //build and append radio swap section, if radio swap happend
            var appendRadioSwapSection = function (radioSwapList, device) {
                if ($scope.onSignalConnectView === false) return; // if parent is not SignalConnect view then return (DO NOT build RadioSwap section)

                if (element.length > 0 && element[0].childNodes.length > 1) {
                    var divQuery = "div[class^='radio-swap-class-" + device.deviceId + "']";
                    $(divQuery).remove();
                }
                var parentDiv = document.createElement('div');
                parentDiv.classList.add("radio-swap-class-" + device.deviceId);
                parentDiv.style.cssText = "max-height:200px;overflow-y:auto;"; //enabling scrolling for radioswap section
                angular.forEach(radioSwapList, function (value, key) {
                    var div = document.createElement('div');
                    var para = document.createElement('P');

                    // NOTE: NO translations for Property Names
                    // all the "null" or "undefined" values are replaced by "***"
                    var innerText = '<b>' + value.radioSwapUtcDate.replace(/T/g, ' ') + '</b>';
                    innerText = innerText + '</br><b> Unit:</b> ' + device.name;
                    innerText = innerText + '</br><b> TXID1:</b> ' + (value.rsTXID1Old ? value.rsTXID1Old : '***') + ' >> ' + (value.rsTxId1 ? value.rsTxId1 : '***');
                    if (value.rsTXID2Old)
                        innerText = innerText + '</br><b> TXID2:</b> ' + (value.rsTXID2Old ? value.rsTXID2Old : '***') + ' >> ' + (value.rsTxId2 ? value.rsTxId2 : '***');
                    if (value.rsTXID3Old)
                        innerText = innerText + '</br><b> TXID3:</b> ' + (value.rsTXID3Old ? value.rsTXID3Old : '***') + ' >> ' + (value.rsTxId3 ? value.rsTxId3 : '***');
                    if (value.rsRadioEsnOld)
                        innerText = innerText + '</br><b> RadioESN:</b> ' + (value.rsRadioEsnOld ? value.rsRadioEsnOld : '***') + ' >> ' + (value.rsRadioEsn ? value.rsRadioEsn : '***');
                    innerText = innerText + '</br><b> Software Version:</b> ' + (value.rsSoftwareVersionOld ? value.rsSoftwareVersionOld : '***') + ' >> ' + (value.rsSoftwareVersion ? value.rsSoftwareVersion : '***');
                    innerText = innerText + '</br><b> Wireless Carrier:</b> ' + (value.rsWirelessCarrierOld ? value.rsWirelessCarrierOld : '***') + ' >> ' + (value.rsWirelessCarrier ? value.rsWirelessCarrier : '***');
                    innerText = innerText + '</br><b> IMEI:</b> ' + (value.rsIMEIOld ? value.rsIMEIOld : '***') + ' >> ' + (value.rsImei ? value.rsImei : '***');
                    innerText = innerText + '</br><b> SIMNumber:</b> ' + (value.rsSimNumberOld ? value.rsSimNumberOld : '***') + ' >> ' + (value.rsSimNumber ? value.rsSimNumber : '***');
                    para.innerHTML = innerText;
                    div.append(para);
                    parentDiv.append(div);
                });
                element[0].append(parentDiv);
            };
            $scope.$watch('deviceSelected', function (newValue, oldValue) { 
                if (newValue) {
                    element.empty();
                    $scope.currentDeviceId = newValue;
                    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
                    if (typeof $scope.stickyProperties != 'object') {
                        $scope.stickyProperties = $scope.stickyPropertiesInterface;
                    }

                    if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
                        $scope.stickyProperties.on = true;
                        var zoomDate = new Date($scope.stickyProperties.zoomMin); // datetimeService.unixtimeToDate($scope.stickyProperties.zoomMin);
                        var firstDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth(), 1);
                        var lastDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth() + 1, 0);
                        $scope.startDateUnix = datetimeService.dateToUnixtime(firstDay);
                        $scope.endDateUnix = datetimeService.dateToUnixtime(lastDay);
                    }
                    else {
                        $scope.stickyProperties.on = false;
                    }
                    signalCalendarService.getData(newValue,
                                        $scope.accountInfo.customerId,
                                        datetimeService.dateToUnixtime(firstDay),
                                        datetimeService.dateToUnixtime(lastDay),
                                        $scope.accountInfo.timeZone)
                                    .then(function (result) {
                                        $scope.signalCalendarData = result.data;
                                        _drawCalendar(newValue);
                                        resize();
                                    });
                }
            }, true);

            if (!$rootScope.mobile && !$rootScope.classicView) {
                //$scope.popup = _this.getExistingDialog($scope.windowId).ref;
                $scope.calendarHeight = $scope.popup.outerHeight() - 127;

                $scope.popup.dialogExtend({
                    maximize: function() {
                        resize();
                    },
                    restore: function() {
                        openViewService.adjustContentSizeStart($scope.popup);
                        resize();
                    },
                });

                $scope.popup.dialog('option', 'minHeight', 515);
                if ($scope.popup.dialog('option', 'height') < 515) {
                    $scope.popup.dialog('option', 'height', 515);
                }
            }
            resize();

            $scope.$on('contentAdjusted', function () {
                resize();
            });

            //following method is used when top-menu refresh button is clicked
            $scope.mostRecentData = function() {
                element.empty();
                toaster.pop('success', "Signal Calendar" + " -- " + $scope.deviceSelectedName, 'View reloading');
                _drawCalendar($scope.currentDeviceId);
            };

            // on initial load, we highlight LAST 7 days from date passed (backward)
            // but if user selects particular date, then we highlight NEXT 7 days from date passed. (forward)
            // so we are passing direction to identify forward or backward
            $scope.addDateRangeBackgroundColor = function (date, direction, noOfDays) {
                $scope.initalialized = true;
                var el, shortDate, dataDate;
                //Remove previous highlighted range
                $(element).find('[data-date]').removeClass("fc-date-range-selected");

                // calculate how many days it has to highlight background
                var noOfDaysToHighlight = 7; // default 7 days
                if (noOfDays)
                    noOfDaysToHighlight = noOfDays;

                var today = new Date();

                //Add highlighted range 7 days from date
                for (var i = 0; i < noOfDaysToHighlight; i++) {
                    //creating date from unix format of the date
                    date = new Date(date);

                    //highlight the date if it is less than tomorrow
                    if ((date.getMonth() === today.getMonth() && date.getDate() <= today.getDate()) || (date.getMonth() < today.getMonth())) {
                        shortDate = moment(date).format("YYYY-MM-DD");
                        //Add range-selected class based on 'data-date'
                        dataDate = "[data-date=" + "'" + shortDate + "']";
                        el = $(element).find(dataDate);
                        $(el).addClass("fc-date-range-selected");
                    }
                    //console.log("After Set --> index: " + i +" Dt: " + date);

                    if (direction === 'forward') {
                        //increment to next day
                        date = date.setDate(date.getDate() + 1);
                        // do not highlight if date is after today
                        var nextDate = new Date(date);
                        if (nextDate.getMonth() === today.getMonth() && nextDate.getDate() > today.getDate())
                            break;
                        //console.log("Forward --> Dt: " + new Date(date));
                    } else if (direction === 'backward') {
                        //decrement to prev day
                        date = date.setDate(date.getDate() - 1);
                        //console.log("backward --> Dt: " + new Date(date));
                    }
                }
            };

            //Runs on initial load to addDateRangeBackgroundColor based on current day
            $scope.getRangeStartDate = function() {
                if (!$scope.initalialized) {
                    //console.log("Before Initialized st.Dt: " + new Date() );
                    $scope.addDateRangeBackgroundColor(new Date(), 'backward');
                    $scope.initalialized = true;
                }
            };

            var container;
            var _drawCalendar = function (deviceID) {
                container = document.createElement('div');

                 if (!$scope.startDateAlreadySet && !$scope.startDateUnix) {
                    //defaulting startDate to Today, which will enable the calendar to display current month
                    $scope.startDateUnix = datetimeService.dateToUnixtime(new Date());
                }
                //container.setAttribute("Id", $scope.chartId);
                // container.setAttribute("style","height:200px;");
                element.append(container);

                $scope.fullCalendar = $(container).fullCalendar({
                    fixedWeekCount: false,
                    contentHeight: $scope.calendarHeight,
                    defaultDate: $scope.startDateUnix,
                    ignoreTimezone: true,
                    lang: $scope.lang,
                    header: {
                        left: 'title',
                        center: '',
                        right: 'today prev,next'
                    },
                    buttonText: {
                        today: $scope.translation.text.CURRENT_MONTH
                    },
                    businessHours: false, // display business hours
                    editable: false,
                    // events: calendarModel,
                    dayClick: function(date, jsEvent, view) {  
                        var curr = new Date(date); // get current date
                        if (curr.getDay() === 5) {
                            var lastT = new Date(date);
                            var firstT = new Date(date);
                            lastT = new Date(lastT.setDate(lastT.getDate() + 1)).setHours(23, 59, 59, 999);
                            firstT = new Date(firstT.setDate(firstT.getDate() - 5)).setHours(0, 0, 0, 0);
                            //console.log("Calendar day clicked --> : st.Dt: " + new Date(firstT) + "ed.Dt: " + new Date(lastT));
                            $scope.addDateRangeBackgroundColor(new Date(lastT), 'backward'); // highlight last 7 days

                            //broadcast only if date range is within next 7 days
                            //var today = new Date();
                            //var stDate = new Date(firstT);
                            //if ((stDate.getMonth() === today.getMonth() && stDate.getDate() <= today.getDate()) ||
                            //    (stDate.getMonth() < today.getMonth())) {
                                $rootScope.$broadcast('onSignalConectCalendarDateSelect', { start: new Date(firstT), end: new Date(lastT), deviceId: attrs.manualDeviceSelected });
                            //}
                        }
                    },
                    viewRender: function (view, element) {
                        if (view.start !== $scope.viewstart) {
                            $scope.disableButtons();
                            $scope.viewstart = view.start;
                            $scope.pageloading = true;
                            $(container).fullCalendar('removeEvents');
                            //$timeout(function() {

                            if (!$scope.initalialized) {
                                if ($(container).fullCalendar('getView').intervalEnd) {

                                    var NewEvents = $scope.signalCalendarData.calendarModel; //result.data.calendarModel; //$scope.signalCalendarData; //
                                    for (var i = 0; i < new Date($(container).fullCalendar('getView').intervalEnd.year(), $(container).fullCalendar('getView').intervalEnd.month(), 0).getDate(); i++) {
                                        var newEvent = {};
                                        if (NewEvents[i]) {
                                            var eventDate = new Date(NewEvents[i].start);

                                            if ((i + 1) !== eventDate.getDate()) {
                                                newEvent = {
                                                    allDay: true,
                                                    className: 'signal-calendar',
                                                    start: (eventDate.getMonth() + 1) + '/' + (i + 1) + '/' + eventDate.getFullYear(),
                                                    color: '#ff0000',
                                                    title: '0%/0'
                                                };

                                                NewEvents.splice(i, 0, newEvent);
                                            }
                                        } else {
                                            if (new Date($(container).fullCalendar('getView').intervalEnd.year(), $(container).fullCalendar('getView').intervalEnd.month() - 1, i + 1) <= new Date()) {
                                                newEvent = {
                                                    allDay: true,
                                                    className: 'signal-calendar',
                                                    start: $(container).fullCalendar('getView').intervalEnd.month() + '/' + (i + 1) + '/' + $(container).fullCalendar('getView').intervalEnd.year(),
                                                    color: '#ff0000',
                                                    title: '0%/0'
                                                };

                                                NewEvents.push(newEvent);
                                            }
                                        }
                                    }

                                    var clientEvents = $(container).fullCalendar('clientEvents');
                                    for (var i = 0; i < clientEvents.length; i++) {
                                        $(container).fullCalendar('removeEventSource', clientEvents[i].source);
                                    }
                                    $(container).fullCalendar('addEventSource', NewEvents);
                                    var d = $(container).fullCalendar('getView').intervalEnd;
                                    var month = d.month() === 1 ? 0 : d.month() - 1;
                                    var middledate = new Date(d.year(), month, 15);
                                    if (new Date() < middledate) {
                                        middledate = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate());
                                    }
                                    var middleUnix = datetimeService.dateToUnixtime(middledate);
                                    var tmpDataMin = middleUnix - 24 * 3600 * 1000,
                                        tmpDataMax = middleUnix + 48 * 3600 * 1000,
                                        tmpZoomMin = middleUnix,
                                        tmpZoomMax = middleUnix + 24 * 3600 * 1000;
                                    var _device = { deviceName: $scope.deviceSelectedName };
                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: deviceID, device: _device, dataMin: tmpDataMin, dataMax: tmpDataMax, zoomMin: tmpZoomMin, zoomMax: tmpZoomMax, windowId: $scope.windowId });
                                    $scope.enableButtons();
                                    appendRadioSwapSection($scope.signalCalendarData.radioSwapList, $scope.signalCalendarData.device);
                                }
                                //get initial date range for selected calendar to add background color
                                $scope.getRangeStartDate();
                            } else {
                            signalCalendarService.getData(deviceID, $scope.accountInfo.customerId, view.start, view.end, $scope.accountInfo.timeZone)
                                .then(function (result) {
                                if ($(container).fullCalendar('getView').intervalEnd) {
                                    $scope.pageloading = false;
                                    $scope.signalCalendarData = result.data;
                                    var NewEvents = result.data.calendarModel;
                                    //var NewEvents = $scope.signalCalendarData;//.calendarModel; //result.data.calendarModel; //$scope.signalCalendarData; //
                                    for (var i = 0; i < new Date($(container).fullCalendar('getView').intervalEnd.year(), $(container).fullCalendar('getView').intervalEnd.month(), 0).getDate(); i++) {
                                        var newEvent = {};
                                        if (NewEvents[i]) {
                                            var eventDate = new Date(NewEvents[i].start);

                                            if ((i + 1) !== eventDate.getDate()) {
                                                newEvent = {
                                                    allDay: true,
                                                    className: 'signal-calendar',
                                                    start: (eventDate.getMonth() + 1) + '/' + (i + 1) + '/' + eventDate.getFullYear(),
                                                    color: '#ff0000',
                                                    title: '0%/0'
                                                };

                                                NewEvents.splice(i, 0, newEvent);
                                            }
                                        } else {
                                            if (new Date($(container).fullCalendar('getView').intervalEnd.year(), $(container).fullCalendar('getView').intervalEnd.month() - 1, i + 1) <= new Date()) {
                                                newEvent = {
                                                    allDay: true,
                                                    className: 'signal-calendar',
                                                    start: $(container).fullCalendar('getView').intervalEnd.month() + '/' + (i + 1) + '/' + $(container).fullCalendar('getView').intervalEnd.year(),
                                                    color: '#ff0000',
                                                    title: '0%/0'
                                                };

                                                NewEvents.push(newEvent);
                                            }
                                        }
                                    }

                                    var clientEvents = $(container).fullCalendar('clientEvents');
                                    for (var i = 0; i < clientEvents.length; i++) {
                                        $(container).fullCalendar('removeEventSource', clientEvents[i].source);
                                    }
                                    $(container).fullCalendar('addEventSource', NewEvents);
                                    var d = $(container).fullCalendar('getView').intervalEnd;
                                    var month = d.month() === 1 ? 0 : d.month() - 1;
                                    var middledate = new Date(d.year(), month, 15);
                                    if (new Date() < middledate) {
                                        middledate = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate());
                                    }
                                    var middleUnix = datetimeService.dateToUnixtime(middledate);
                                    var tmpDataMin = middleUnix - 24 * 3600 * 1000,
                                        tmpDataMax = middleUnix + 48 * 3600 * 1000,
                                        tmpZoomMin = middleUnix,
                                        tmpZoomMax = middleUnix + 24 * 3600 * 1000;
                                    var _device = { deviceName: $scope.deviceSelectedName };
                                    sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: deviceID, device: _device, dataMin: tmpDataMin, dataMax: tmpDataMax, zoomMin: tmpZoomMin, zoomMax: tmpZoomMax, windowId: $scope.windowId });
                                    $scope.enableButtons();
                                    appendRadioSwapSection($scope.signalCalendarData.radioSwapList, $scope.signalCalendarData.device);
                                }
                                //get initial date range for selected calendar to add background color
                                    $scope.getRangeStartDate();
                                    //$scope.calendarLoading = false;
                            },
                                function (error) {
                                $scope.pageloading = false;
                                $scope.enableButtons();
                            });
                            }
                            $scope.pageloading = false;
                        //});

                        }
                        $(element).find('.fc-sat').css('text-decoration', 'underline');
                        $(element).find('.fc-sat').css('font-weight', 'bold');
                        $(element).find('.fc-sat').css('cursor', 'pointer');
                    }
                });

                $(container).fullCalendar('gotoDate', $scope.startDateUnix);
                addMonthButtonListeners();
            };

            var addMonthButtonListeners = function(){
                //Add Listener for Prev Month
                var prevMonth = $(element).find('.fc-prev-button');
                $( prevMonth ).click(function() {
                    console.log("prev");
                    //Add Logic Here
                });

                //Add Listener for Next Month
                var nextMonth = $(element).find('.fc-next-button');
                $( nextMonth ).click(function() {
                    console.log("next");
                    //Add Logic Here
                });

                //Add Listener for Current Month
                var currentMonth = $(element).find('.fc-today-button');
                $( currentMonth ).click(function() {
                    console.log("current month");
                    //Add Logic Here
                });
            }

            $scope.fnDrawCalendar = function (varDeviceId) {
                $(container).fullCalendar('destroy');
                _drawCalendar(varDeviceId);
            };

            $scope.disableButtons = function() {
                $(element).find(".fc-prev-button").prop('disabled', true);
                $(element).find(".fc-prev-button").addClass('fc-state-disabled');
                $(element).find(".fc-next-button").prop('disabled', true);
                $(element).find(".fc-next-button").addClass('fc-state-disabled');
            };

            $scope.enableButtons = function () {
                $(element).find(".fc-prev-button").removeClass('fc-state-disabled');
                $(element).find(".fc-prev-button").prop('disabled', false);
                $(element).find(".fc-next-button").removeClass('fc-state-disabled');
                $(element).find(".fc-next-button").prop('disabled', false);
            };

            //if Manual input from directive exists
            if($scope.manualDeviceSelected){
                element.empty();
                $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
                if (typeof $scope.stickyProperties != 'object') {
                    $scope.stickyProperties = $scope.stickyPropertiesInterface;
                }

                if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
                    $scope.stickyProperties.on = true;
                    var zoomDate = new Date($scope.stickyProperties.zoomMin); // datetimeService.unixtimeToDate($scope.stickyProperties.zoomMin);
                    var firstDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth(), 1);
                    var lastDay = new Date(zoomDate.getFullYear(), zoomDate.getMonth() + 1, 0);
                    $scope.startDateUnix = datetimeService.dateToUnixtime(firstDay);
                    $scope.endDateUnix = datetimeService.dateToUnixtime(lastDay);
                }
                else {
                    $scope.stickyProperties.on = false;
                }
                _drawCalendar($scope.manualDeviceSelected);
                resize();
            }

            $scope.$on('onSignalConnectDateSelect', function (event, opt) {
                if (opt.action === 'date' && opt.startDate && opt.endDate) {
                    //use date range that is passed as event args
                    var noOfDays = Math.round((opt.endDate.getTime() - opt.startDate.getTime()) / (1000 * 3600 * 24))+1;


                    $scope.startDateUnix = new Date(opt.startDate.getFullYear(), opt.startDate.getMonth(), 1);
                    $scope.startDateAlreadySet = true;
                    $scope.fnDrawCalendar($scope.manualDeviceSelected);
                    //console.log("Calendar on PARENT Date Select --> : st.Dt: " + opt.startDate + "ed.Dt: " + opt.endDate + " days: " + noOfDays);
                    $scope.addDateRangeBackgroundColor(opt.startDate, 'forward', noOfDays); // highlight next no. of days
                }
            });

            // when Chart component date is selected
            $rootScope.$on('onSignalConectChartDateSelect', function (event, opt) {
                if ($scope.manualDeviceSelected == opt.deviceId) {
                    $scope.startDateUnix = new Date(opt.start.getFullYear(), opt.start.getMonth(), 1);
                    $scope.startDateAlreadySet = true;
                    $scope.fnDrawCalendar($scope.manualDeviceSelected);
                    var noOfDays = Math.floor((opt.end.getTime() - opt.start.getTime()) / (1000 * 3600 * 24)) + 1;
                    //console.log("Calendar on CHART Date Select --> : st.Dt: " + opt.startDate + "ed.Dt: " + opt.endDate + " days: " + noOfDays);
                    $scope.addDateRangeBackgroundColor(opt.start, 'forward', noOfDays);
                }
            });

            $scope.$on("$destroy", function () {
                if ($scope.fullCalendar) $(container).fullCalendar('destroy');
            });

        };

        return {
            link: link
        };
    }]);

mcapp.factory('signalCalendarService', ['$http', 'HOST',
    function ($http, HOST) {
        var signalCalendarFatory = {};
        var _getData = function (deviceId, customerId, startDate, endDate, timeZone) {
            return $http({
                method: 'Get',
                url: HOST + '/api/SignalCalendar?deviceId=' + deviceId + '&customerId=' + customerId + '&startDate=' + startDate + '&endDate=' + endDate + '&timeZone=' + timeZone,
                cache: false
            });
        };
        signalCalendarFatory.getData = _getData;
        return signalCalendarFatory;

    }]);

mcapp.controller("connectionWidgetController", ["$scope", "$rootScope", "translationService", "sharedSetupService", "authenticationService", "$element",
    function ($scope, $rootScope, translationService, sharedSetupService, authenticationService, $element) {
        $scope.Time = null;
        $scope.translation = translationService.translation;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.downloadViewTypeOptions = [0];
        sharedSetupService.getWindowId($scope);
        if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }

        $scope.setSetting = function () {
            $scope.deviceSelectedId = { "deviceId": $scope.stickyProperties.device.deviceId };
            $scope.preDeviceSelected = $scope.stickyProperties.device;
        };

        $scope.setSetting();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            $scope.closeWidget = function () {
                $scope.popup.dialog("close");
            };

            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.resizeContent();
                    $scope.$apply();
                }
            });

            $scope.resizeContent = function () {
                if ($element.find(".connection")) {
                    var _newSize;
                    var _newWidth = $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "");
                    var _newHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");

                    $element.find('.widgetSettingNew').css("width", _newWidth < 240 ? 240 : _newWidth)
                        .css("margin-left", _newWidth < 240 ? -(240 - _newWidth) / 2 : "auto");

                    if (_newWidth > _newHeight) {
                        _newSize = _newHeight - 80;
                        $element.find(".connection").css("font-size", (_newSize < 30 ? 30 : _newSize) + "px");
                    } else {
                        _newSize = _newWidth - 80;
                        $element.find(".connection").css("font-size", (_newSize < 30 ? 30 : _newSize) + "px");
                    }
                }
            };
        } else {
            $scope.popup = $(".flip-container");
            $scope.resizeContent = function () {
                return;
            }
        }

        var timer;
        var firstover = true;

}]);

mcapp.directive('connectionWidgetDirective', ["authenticationService", "websocketService", "connectGaugeService", "deviceService", "datetimeService", "toaster", "openViewService", "$document", "sharedSetupService",
    function (authenticationService, websocketService, connectGaugeService, deviceService, datetimeService, toaster, openViewService, $document, sharedSetupService) {
      function link(scope, element, attrs) {

        scope.getConnectData = function (DeviceID) {
          sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: DeviceID, windowId: scope.windowId });
          connectGaugeService.getData(scope.accountInfo.customerId, DeviceID)
              .then(function (result) {
                scope.alerts = [];
                scope.device = result.data.device;
                var deviceType = scope.device.type;
                var _device = { deviceId: scope.device.deviceId, channel: "Connection", serialNumber: scope.device.serialNumber };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.device.deviceId, device: _device, windowId: scope.windowId });
                if (scope.popup.selector !== ".flip-container") scope.popup.dialog("option", "title", scope.device.name);
                  scope.deviceSelectedName = scope.device.name;
                _drawConnectGauge(result.data.measurement.connectPctLast24Hrs, deviceType);
              }, function (error) {
                scope.alerts = [];
                var errormsg = eval("scope.translation.message." + error.data.message);
                scope.alerts.push({ msg: errormsg, type: "danger" });
              });
        };
        var _drawConnectGauge = function (data, deviceType) {
          if(deviceType == 15 || deviceType == 20)
          {
            if (data > 0)  {
                scope.connectThumb = "fa fa-thumbs-up fagreen";
                scope.connectValue =  "100%";
            }
            else {
                scope.connectThumb = "fa fa-thumbs-down fared";
                scope.connectValue = data + "%";
            }
          }
          else
          {
            if (data < 90)
              scope.connectThumb = "fa fa-thumbs-down fared";
            if (data >= 90 && data < 98.333)
              scope.connectThumb = "fa fa-thumbs-o-up fayellow";
            if (data >= 98.333)
              scope.connectThumb = "fa fa-thumbs-up fagreen";
            scope.connectValue = data + "%";
          }
        };

        scope.isTouchSupported = function () {
          var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
          var generalTouchEnabled = "ontouchstart" in document.createElement("div");

          if (msTouchEnabled || generalTouchEnabled) {
            return true;
          }
          return false;
        };

        scope.replaceSpaces = function (str) {
          return str.replace(/ /g, '_');
        }

        scope.$on('document_click', function (e, event) {
          var $tgt = $(event.target);
          if ($tgt.closest('#connection-widget-' + scope.replaceSpaces(scope.windowId)).length === 0 || ($tgt.closest('.back').length === 0 && $tgt.closest('.front').length === 0)) {
            $('#connection-widget-' + scope.replaceSpaces(scope.windowId)).offsetParent().offsetParent().find('.flip-container').toggleClass('flip', false);

            if (scope.isTouchSupported()) {
              scope.popup.parent().find(".back").toggle(false);
            }

            scope.setSetting();
            scope.resizeContent();
          }
        });

        scope.popup.parent().on(
                   "mouseup",
                   function (event) {
                     event.preventDefault();
                     var localScope = $(event.target).scope();
                     localScope.$apply(
                         function () {
                           if (scope.popup.parent().is('.ui-draggable-dragging, .ui-resizable-resizing') || event.target.nodeName === 'SELECT') {
                             return;
                           }

                           scope.popup.parent().find('.flip-container').toggleClass('flip');
                           if (scope.isTouchSupported()) {
                             scope.popup.parent().find(".back").toggle();
                             scope.popup.parent().find(".front").toggle();
                           }

                           scope.setSetting();
                           scope.resizeContent();
                         }
                     );
                   }
               );

        scope.popup.parent().find("select").on(
                   "mouseup",
                   function (event) {
                     event.preventDefault();
                     event.stopPropagation();
                   }
               );

        scope.popup.parent().on(
                   "mouseover",
                   function (event) {
                     event.preventDefault();
                     var localScope = $(event.target).scope();
                     localScope.$apply(
                         function () {
                           scope.popup.parent().addClass("x-resize");
                           scope.closeIcon = true;
                         }
                     );
                   }
               );

        scope.popup.parent().on(
                   "mouseout",
                   function (event) {
                     event.preventDefault();
                     var localScope = $(event.target).scope();
                     localScope.$apply(
                         function () {
                           scope.popup.parent().removeClass("x-resize");
                           if (scope.isTouchSupported()) {
                             setTimeout(function () {
                               scope.closeIcon = false;
                             }, 3000);
                           }
                           else {
                             scope.closeIcon = false;
                           }
                         }
                     );
                   }
               );

        scope.$on(
            "$destroy",
            function (event) {
              scope.popup.parent().off();
              scope.popup.parent().find("select").off();
            }
        );

        scope.getConnectData(scope.deviceSelectedId.deviceId);
          if (scope.popup.selector !== ".flip-container") scope.popup.dialog("option", "dialogClass", "ui-widget-content-new");
        scope.resizeContent();
      }


      return {
        restrict: 'A',
        replace: false,
        link: link
      };
    }]);

mcapp.directive('connectionSettingDirective', ["authenticationService", "websocketService", "deviceMenuService", "deviceService", "toaster",
    function (authenticationService, websocketService, deviceMenuService, deviceService, toaster) {
      function link(scope, element, attrs) {
        scope.notfirst = false;
        deviceMenuService.getDeviceMenuList(scope.accountInfo.customerId)
            .then(function (result) {
              scope.Devices = result.data.devices;
            }, function (error) {
            });

        scope.getBackToConnectionData = function (DeviceID) {

          if (DeviceID != null)
            scope.getConnectData(DeviceID);
          scope.popup.parent().find('.flip-container').toggleClass('flip');
          if (scope.isTouchSupported()) {
            scope.popup.parent().find(".back").toggle();
            scope.popup.parent().find(".front").toggle();
          }

          scope.resizeContent();
        };
      }
      return {
        link: link
      };


    }]);
'use strict';

angular.module('mc.sso-cso-report', []);
"use strict";

function SsoCsoReportFactory(REPORTS, $http) {
    var _this = this;

    // instantiate our initial object
    var SsoCsoReport = function SsoCsoReport(customerId, startDate, timeZone, runtimeScale, measurementId, stickyProperties) {
        this.customerId = customerId;
        this.startDate = startDate;
        this.timeZone = timeZone;
        this.runtimeScale = runtimeScale;
        this.measurementId = measurementId;
        this.stickyProperties = stickyProperties;
    };

    SsoCsoReport.prototype.getReport = function (deviceId, hideYearlyButton, isManhole, skuId, model) {
        var self = this;
        return $http.get(REPORTS + "/api/SsoCsoReport" + "?customerId=" + this.customerId + "&deviceId=" + deviceId + "&model=" + model + "&date=" + this.startDate + "&timeZone=" + this.timeZone + "&isYTD=" + hideYearlyButton + "&isManhole=" + isManhole + "&skuId=" + skuId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    SsoCsoReport.prototype.getRain = function (customerId, metarStationId, rainfallSite, startDate, endDate) {
        if (rainfallSite > 0) {
            return $http.get(REPORTS + "/api/MetarRainfallCalendar?customerId=" + customerId + "&deviceId=" + rainfallSite + "&startDate=" + startDate + "&endDate=" + endDate).then(function (resp) {
                _this.loading = false;
                return resp;
            });
        } else if (metarStationId > 0) {
            return $http.get(REPORTS + "/api/MetarRainfallCalendar?customerId=" + customerId + "&startDate=" + startDate + "&endDate=" + endDate + "&metarStationId=" + metarStationId).then(function (resp) {
                _this.loading = false;
                return resp;
            });
        } else {
            return $http.get(REPORTS + "/api/MetarRainfallCalendar?customerId=" + customerId + "&startDate=" + startDate + "&endDate=" + endDate).then(function (resp) {
                _this.loading = false;
                return resp;
            });
        }
    };

    return SsoCsoReport;
}

SsoCsoReportFactory.$inject = ['REPORTS', '$http'];

angular.module('mc.sso-cso-report').factory('SsoCsoReportFactory', SsoCsoReportFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function SsoCsoReportController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, SsoCsoReportFactory, $timeout, $filter, $element, savePdfService, toaster) {
    var ctrl = this;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurementId = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? 1 : 3.78541;
        ctrl.runtimeScale = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? 1 : 1.00 / 60.00;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        ctrl.reportDate = new Date();
        ctrl.adjustButtons();
        //ctrl.goSelectReportData();
        ctrl.hideYearlyButton = false;
        ctrl.alarmTypeOne = null;
        ctrl.alarmTypeTwo = null;
        ctrl.durationDaysTypeOne = null;
        ctrl.durationHoursTypeOne = null;
        ctrl.durationMinutesTypeOne = null;
        ctrl.durationSecondsTypeOne = null;
        ctrl.durationDaysTypeTwo = null;
        ctrl.durationHoursTypeTwo = null;
        ctrl.durationMinutesTypeTwo = null;
        ctrl.durationSecondsTypeTwo = null;
        ctrl.rainfallStart = null;
        ctrl.rainfallEnd = null;
        ctrl.rainfallTotal = 0;
        ctrl.firstSetDeviceData = true;
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.isRefresh = false;
        ctrl.rainfallSite = 0;
        ctrl.metarStationId = 0;
        ctrl.skuId = 0;

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.getRainfallData = function () {
        ctrl.ssoCsoReport.getRain(ctrl.accountInfo.customerId, ctrl.metarStationId, ctrl.rainfallSite, ctrl.rainfallStart, ctrl.rainfallEnd).then(function (response) {
            ctrl.rainfallTotal = 0;
            for (var i = 0; i < response.data.calendarDays.length; i++) {
                ctrl.rainfallTotal += parseFloat(response.data.calendarDays[i].title);
            }
        });
    };

    ctrl.mostRecentData = function () {
        ctrl.isRefresh = true;
        toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
        ctrl.reportDate = new Date();
        $scope.resetData();
        ctrl.goSelectReportData();
    };

    ctrl.getDuration = function (item) {
        var _duration = "";

        if (item.durationDays !== 0) _duration = _duration + item.durationDays + " " + ctrl.translation.text.DAYS;

        if (item.durationHours !== 0) _duration = _duration + " " + item.durationHours + " " + ctrl.translation.text.HOURS;

        if (item.durationMinutes !== 0) _duration = _duration + " " + item.durationMinutes + " " + ctrl.translation.text.MINUTES;

        if (item.durationSeconds !== 0) _duration = _duration + " " + item.durationSeconds + " " + ctrl.translation.text.SECONDS;

        return _duration;
    };

    ctrl.mergeData = function (dataA, dataB) {
        var _mergedData = dataA.concat(dataB);
        return _mergedData;
    };

    ctrl.goSelectReportData = function (varClick) {
        //sharedSetupService.disableButtons();
        ctrl.alerts = [];
        var numberOfDays = 30,
            _tmpStartDate,
            _tmpEndDate,
            _rainfallStart,
            _rainfallEnd;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        }
        if (varClick && ctrl.ssoCsoReport) {
            ctrl.ssoCsoReport.loading = true;
            _tmpStartDate = ctrl.reportDate;
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        } else if (ctrl.stickyProperties && ctrl.stickyProperties.on == true) {
            ctrl.stickyProperties.on = false;
            _tmpStartDate = new Date(ctrl.stickyProperties.dateMin);
            ctrl.startDate = ctrl.stickyProperties.dateMin;
            ctrl.reportDate = _tmpStartDate;
            //ctrl.hideYearlyButton = ctrl.stickyProperties.device.channel == 1 ? true : false;
            ctrl.adjustButtons();
        } else {
            _tmpStartDate = new Date();
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        }

        if (ctrl.isRefresh) {
            _tmpStartDate = new Date();
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
            ctrl.isRefresh = false;
        }

        if (ctrl.hideYearlyButton) {
            _rainfallStart = new Date(_tmpStartDate.getFullYear(), 0, 1);
        } else {
            _rainfallStart = new Date(_tmpStartDate.getFullYear(), _tmpStartDate.getMonth(), 1);
        }

        _rainfallEnd = new Date(_tmpStartDate.getFullYear(), _tmpStartDate.getMonth() + 1, 0, 23, 59, 59, 999);

        //var timeOffset = datetimeService.GetTimeZoneOffset(ctrl.accountInfo.timeZone);
        //_rainfallStart.setHours(_rainfallStart.getHours() + timeOffset);
        //_rainfallEnd.setHours(_rainfallEnd.getHours() + timeOffset);

        ctrl.rainfallStart = datetimeService.dateToUnixtime(_rainfallStart);
        ctrl.rainfallEnd = datetimeService.dateToUnixtime(_rainfallEnd);

        ctrl.endDate = new Date(_tmpStartDate.getTime());
        ctrl.ssoCsoReport = new SsoCsoReportFactory(ctrl.accountInfo.customerId, ctrl.startDate, ctrl.accountInfo.timeZone, ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale, ctrl.accountInfo.preferenceUser.lookupMeasurementID, ctrl.stickyProperties); //varDateRangeEndTmp - is StartDate
        ctrl.ssoCsoReport.loading = true;
        ctrl.ssoCsoReport.getReport(ctrl.deviceSelected, ctrl.hideYearlyButton, $scope.deviceSelectedisManhole, ctrl.skuId, $scope.deviceSelectedType).then(function () {

            ctrl.ssoCsoReport.data.reportData = ctrl.mergeData(ctrl.ssoCsoReport.data.reportData, ctrl.ssoCsoReport.data.reportDataByAnalog);
            ctrl.ssoCsoReport.data.reportDataByAnalog = [];

            ctrl.getRainfallData();
            if (ctrl.ssoCsoReport.data.reportData.length !== 0) {
                ctrl.events = [];
                ctrl.getChannelsDescriptions();

                for (var i = 0; i < ctrl.ssoCsoReport.data.reportData.length; i++) {
                    ctrl.events.map(function (event) {
                        if (ctrl.ssoCsoReport.data.reportData[i].eventDescription == event.description) {
                            event.duration += 24 * 60 * 60 * ctrl.ssoCsoReport.data.reportData[i].durationDays + 60 * 60 * ctrl.ssoCsoReport.data.reportData[i].durationHours + 60 * ctrl.ssoCsoReport.data.reportData[i].durationMinutes + ctrl.ssoCsoReport.data.reportData[i].durationSeconds;
                        }
                    });
                }

                ctrl.events.map(function (event) {
                    event.durationDays = Math.floor(event.duration / (3600 * 24));
                    event.duration -= event.durationDays * 3600 * 24;
                    event.durationHours = Math.floor(event.duration / 3600);
                    event.duration -= event.durationHours * 3600;
                    event.durationMinutes = Math.floor(event.duration / 60);
                    event.durationSeconds = event.duration - event.durationMinutes * 60;
                });
            }
            ctrl.daysInMonth = ctrl.getDaysInMonth();
            sharedSetupService.setStickyProperties(ctrl.ssoCsoReport.stickyProperties, {
                deviceId: ctrl.deviceSelected /*, device: { channel: ctrl.hideYearlyButton == true ? 1 : 0 }*/, dataMin: ctrl.startDate, dataMax: null, zoomMin: ctrl.startDate, zoomMax: null, windowId: ctrl.windowId
            });
        }).finally(function () {
            //sharedSetupService.enableButtons();
        });
    };

    ctrl.getChannelsDescriptions = function () {
        ctrl.ssoCsoReport.data.reportData.map(function (data, i) {
            if (ctrl.events.length == 0) {
                ctrl.events.push({
                    description: data.eventDescription,
                    duration: 0,
                    durationDays: 0,
                    durationHours: 0,
                    durationMinutes: 0,
                    durationSeconds: 0
                });
            } else {
                var repeatCount = 0;
                ctrl.events.map(function (ch, i) {
                    if (ch.description == data.eventDescription) repeatCount++;
                });
                if (repeatCount == 0) {
                    ctrl.events.push({
                        description: data.eventDescription,
                        duration: 0,
                        durationDays: 0,
                        durationHours: 0,
                        durationMinutes: 0,
                        durationSeconds: 0
                    });
                }
                repeatCount = 0;
            }
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");

        var drawCell = function drawCell(row, data) {
            if (typeof data.row.raw[1] == "undefined") {
                data.doc.setFillColor(226, 239, 248);
            }
            if (data.row.cells[0].text[0] == "Total Gallons:") {
                data.doc.setFontStyle('bold');
                data.doc.setFillColor(226, 239, 248);
            }
        };

        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle) + ", " + $scope.deviceSelectedName,
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            drawCell: drawCell
        };

        savePdfService.savePDF(pdfParams);
    };

    ctrl.getDaysInMonth = function () {
        var d = new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0);
        return d.getDate();
    };

    ctrl.setReportDate = function (months) {
        if (months == 0) ctrl.reportDate = new Date();
        var d = new Date(ctrl.reportDate || new Date());
        d.setMonth(d.getMonth() + (months || 0), d.getDate());
        ctrl.reportDate = d;
        $scope.resetData();
        ctrl.hideYearlyButton = false;
        ctrl.adjustButtons();
        ctrl.goSelectReportData(true);
    };

    ctrl.getYearlyData = function () {
        ctrl.hideYearlyButton = true;
        ctrl.nextDate = true;
        ctrl.prevDate = true;
        ctrl.todaysDate = false;
        ctrl.goSelectReportData(true);
    };

    ctrl.adjustButtons = function () {
        if (new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0).getTime() === new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime()) {
            ctrl.todaysDate = true;
            ctrl.nextDate = true;
            ctrl.prevDate = false;
        } else {
            ctrl.todaysDate = false;
            ctrl.nextDate = false;
            ctrl.prevDate = false;
        }
    };

    $scope.$on('updatePreferencesMeasurement', function (event, message) {
        ctrl.measurementId = message === 1 ? 1 : 3.78541;
    });

    $scope.$on('updatePreferenceRuntime', function (event, message) {
        ctrl.runtimeScale = message.runtimeScale === "M" ? 1 : 1.00 / 60.00;
    });

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            var tmpNewValue;
            $scope.resetData();
            if (ctrl.stickyProperties && ctrl.stickyProperties.on == true) {
                tmpNewValue = $scope.findFirstDeviceWithManhole(ctrl.stickyProperties.deviceId);
                $scope.setDeviceData(tmpNewValue);
                ctrl.goSelectReportData();
            } else {
                tmpNewValue = $scope.findFirstDeviceWithManhole(newValue);
                $scope.setDeviceData(tmpNewValue);
                ctrl.goSelectReportData(true);
            }
        }
    }, true);

    $scope.resetData = function () {
        ctrl.durationDaysTypeOne = 0;
        ctrl.durationHoursTypeOne = 0;
        ctrl.durationMinutesTypeOne = 0;
        ctrl.durationSecondsTypeOne = 0;

        ctrl.durationDaysTypeTwo = 0;
        ctrl.durationHoursTypeTwo = 0;
        ctrl.durationMinutesTypeTwo = 0;
        ctrl.durationSecondsTypeTwo = 0;
    };

    $scope.setDeviceData = function (value) {
        var newValue = value;
        ctrl.rainfallSite = value.rainfallSite;
        ctrl.metarStationId = value.metarStationId;
        ctrl.skuId = value.skuId;

        if (ctrl.firstSetDeviceData) {
            if (value.model == 15 || value.model == 20) {
                $scope.currentSelectedDevice = value;
                newValue = value;
            } else if (value.model != 15 && value.ssoCso) {
                $scope.currentSelectedDevice = value;
                newValue = value;
            } else {
                var deviceSelected = false;
                $scope.devices.map(function (item) {
                    if (item.model != 15 && item.ssoCso && !deviceSelected) {
                        $scope.currentSelectedDevice = item;
                        newValue = item;
                        deviceSelected = true;
                    } else if ((item.model == 15 || item.model === 20) && !deviceSelected) {
                        $scope.currentSelectedDevice = item;
                        newValue = item;
                        deviceSelected = true;
                    }
                });
            }
            ctrl.firstSetDeviceData = false;
        }

        ctrl.deviceSelected = newValue.deviceId;
        $scope.deviceSelectedSn = newValue.serialNumber;
        $scope.deviceSelectedType = newValue.type;
        $scope.deviceSelectedName = newValue.name;
        $scope.deviceSelectedisManhole = newValue.model == 15 || newValue.model == 20 ? true : false;

        if (!$rootScope.mobile && !$rootScope.classicView) $scope.popup.dialog("option", "title", $scope.windowTitle + ", " + newValue.name);
    };

    $scope.findFirstDeviceWithManhole = function (deviceId) {
        for (var i = 0; i < $scope.devices.length; ++i) {
            if ($scope.devices[i].deviceId === deviceId && ($scope.devices[i].model == 15 || $scope.devices[i].model == 20 || $scope.devices[i].model != 15 && $scope.devices[i].ssoCso)) {
                return $scope.devices[i];
            }
        }
        for (var j = 0; j < $scope.devices.length; ++j) {
            if ($scope.devices[j].model == 15 || $scope.devices[i].model == 20 || $scope.devices[j].model != 15 && $scope.devices[j].ssoCso) {
                return $scope.devices[j];
            }
        }
        return 0;
    };
};

SsoCsoReportController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'SsoCsoReportFactory', '$timeout', '$filter', '$element', 'savePdfService', 'toaster'];
'use strict';

angular.module('mc.sso-cso-report').component('ssoCsoReport', {
    controller: SsoCsoReportController,
    templateUrl: 'ui/ssocsoreport/sso-cso-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.runtime-daily", []);
"use strict";

function RuntimeMultiDayFactory(REPORTS, $http) {

    // instantiate our initial object
    var RuntimeMultiDay = function RuntimeMultiDay(customerId, startDate, endDate, timeZone, runtimeScale, measurementId) {
        this.customerId = customerId;
        this.startDate = startDate;
        this.endDate = endDate;
        this.timeZone = timeZone;
        this.runtimeScale = runtimeScale;
        this.measurementId = measurementId;
        //this.stickyProperties = stickyProperties;
    };

    RuntimeMultiDay.prototype.getData = function () {
        var self = this;
        return $http.get(REPORTS + "/api/Reports/GetRuntimeByDateRange" + "?customerId=" + this.customerId + "&startDate=" + this.startDate + "&endDate=" + this.endDate + "&timeZone=" + this.timeZone + "&runtimeScale=" + this.runtimeScale + "&measurementId=" + this.measurementId).then(function (response) {
            self.data = response.data;
            //self.loading = false;
            return response;
        });
    };

    return RuntimeMultiDay;
}

RuntimeMultiDayFactory.$inject = ['REPORTS', '$http'];

angular.module('mc.runtime-daily').factory('RuntimeMultiDayFactory', RuntimeMultiDayFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RuntimeMultiDayController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, RuntimeMultiDayFactory, $timeout, $filter, $element, savePdfService, preferencesService, toaster) {
    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurementId = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? 1 : 3.78541;
        ctrl.runtimeScale = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? 1 : 1.00 / 60.00;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.isRefresh = false;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.downloadViewTypeOptions = [0, 2];

        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        ctrl.goSelectReportData();
        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.mostRecentData = function () {
        ctrl.isRefresh = true;
        ctrl.myDate = null;
        toaster.pop('success', ctrl.windowTitle, 'View reloading');
        ctrl.runtimeMultiDay.loading = true;
        ctrl.goSelectReportData();
    };

    ctrl.selectMyDate = function () {
        ctrl.goSelectReportData(true);
        return;
    };

    ctrl.goSelectReportData = function (varClick) {
        ctrl.alerts = [];
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }

        var numberOfDays = 3,
            dateRangeStart = void 0,
            dateRangeEnd = void 0,
            dateRangeStartUnix = void 0,
            dateRangeEndUnix = void 0;
        if (ctrl.stickyProperties.on === true) {
            ctrl.stickyProperties.on = false;
            dateRangeStartUnix = ctrl.stickyProperties.dateMin;
            dateRangeEndUnix = ctrl.stickyProperties.dateMax;
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            dateRangeStart = new Date(ctrl.myDateRangeStart);
            dateRangeEnd = new Date(ctrl.myDateRangeEnd);

            // IMPORTANT: use complete calendar days
            dateRangeStart.setHours(0, 0, 0, 0);
            dateRangeEnd.setHours(23, 59, 59, 999);

            dateRangeStartUnix = dateRangeStart.getTime(); //datetimeService.dateToUnixtime(dateRangeStart);
            dateRangeEndUnix = dateRangeEnd.getTime(); //datetimeService.dateToUnixtime(dateRangeEnd);
        } else {
            //on initial load
            dateRangeStart = new Date(); // endDate to today
            dateRangeStart.setDate(dateRangeStart.getDate() - numberOfDays); //start date => today - 3days
            dateRangeStartUnix = dateRangeStart.setHours(0, 0, 0, 0); // setHours converts datetime object to Unix format

            dateRangeEnd = new Date();
            dateRangeEndUnix = dateRangeEnd.setHours(23, 59, 59, 999); // setHours converts datetime object to Unix format
        }
        //used for refresh button to reload newest data
        if (ctrl.isRefresh) {
            dateRangeStart = new Date(); // endDate to today
            dateRangeStart.setDate(dateRangeStart.getDate() - numberOfDays); //start date => today - 3days
            dateRangeStartUnix = dateRangeStart.setHours(0, 0, 0, 0); // setHours converts datetime object to Unix format

            dateRangeEnd = new Date();
            dateRangeEndUnix = dateRangeEnd.setHours(23, 59, 59, 999); // setHours converts datetime object to Unix format
            ctrl.isRefresh = false;
        }
        //TODO: will come back to reconsider sharedSetupService.regenerateDates()
        if ((ctrl.mobile || ctrl.classicView) && !(new Date(dateRangeStartUnix).getTime() > 0 && new Date(dateRangeEndUnix).getTime() > 0)) {
            var tmpDates = sharedSetupService.getLiveDates();
            dateRangeStartUnix = tmpDates.startDate;
            dateRangeEndUnix = tmpDates.endDate;
        }
        dateRangeStart = new Date(dateRangeStartUnix);
        dateRangeEnd = new Date(dateRangeEndUnix);

        var currentDate = new Date(Date.now());
        if (dateRangeEnd > currentDate) dateRangeEnd = currentDate;

        ctrl.myDateRangeStart = ctrl.viewStDate = dateRangeStart;
        ctrl.myDateRangeEnd = ctrl.viewEndDate = dateRangeEnd;

        //it might have modified, so convert back to unix format
        dateRangeEndUnix = dateRangeEnd.getTime(); //datetimeService.dateToUnixtime(dateRangeEnd);
        dateRangeStartUnix = dateRangeStart.getTime();

        ctrl.runtimeMultiDay = new RuntimeMultiDayFactory(ctrl.accountInfo.customerId, dateRangeStartUnix, dateRangeEndUnix, ctrl.accountInfo.timeZone, ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale, ctrl.accountInfo.preferenceUser.lookupMeasurementID); //varDateRangeEndTmp - is StartDate
        ctrl.runtimeMultiDay.loading = true;
        ctrl.runtimeMultiDay.getData().then(function () {
            ctrl.calculateTotalGallons();
            $timeout(function () {
                if (typeof $scope.adjustSize == 'function') $scope.adjustSize();
            });
            //sharedSetupService.setStickyProperties(ctrl.runtimeMultiDay.stickyProperties, { dateMin: dateRangeStartUnix, dateMax: null, zoomMin: dateRangeStartUnix, zoomMax: null, windowId: ctrl.windowId });
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");

        var drawCell = function drawCell(row, data) {
            if (typeof data.row.raw[1] == "undefined") {
                data.doc.setFillColor(226, 239, 248);
            }
            if (data.row.cells[0].text[0] == "Total Gallons:") {
                data.doc.setFontStyle('bold');
                data.doc.setFillColor(226, 239, 248);
            }
        };

        if (ctrl.timeFormat == 1) {
            var pdfParams = {
                windowTitle: windowTitle,
                pdfTitle: eval("ctrl.translation.text." + windowTitle) + (" (" + moment(ctrl.viewEndDate).format("MMMM D, YYYY h:mm a") + " - " + moment(ctrl.viewStDate).format("MMMM D, YYYY h:mm a") + ")"),
                customerName: ctrl.accountInfo.customerName,
                customerId: ctrl.accountInfo.customerId,
                dateTranslate: ctrl.translation.text.DATE_CREATED,
                dateRangeStart: $scope.myDateRangeStart,
                dateRangeEnd: $scope.myDateRangeEnd,
                $scope: $scope,
                $element: $element,
                drawCell: drawCell
            };
        } else {
            var pdfParams = {
                windowTitle: windowTitle,
                pdfTitle: eval("ctrl.translation.text." + windowTitle) + (" (" + moment(ctrl.viewEndDate).format("MMMM D, YYYY HH:mm") + " - " + moment(ctrl.viewStDate).format("MMMM D, YYYY HH:mm") + ")"),
                customerName: ctrl.accountInfo.customerName,
                customerId: ctrl.accountInfo.customerId,
                dateTranslate: ctrl.translation.text.DATE_CREATED,
                dateRangeStart: $scope.myDateRangeStart,
                dateRangeEnd: $scope.myDateRangeEnd,
                $scope: $scope,
                $element: $element,
                drawCell: drawCell
            };
        }

        savePdfService.savePDF(pdfParams);
    };

    ctrl.searchFieldChanged = function (varInput) {
        ctrl.calculateTotalGallons();
    };

    ctrl.avgPerStart = function (runtime, starts) {
        return starts ? (runtime / starts).toFixed(1) : "-";
    };

    ctrl.dayStarts = function (dataDay) {
        if (dataDay.totalStarts != null) return dataDay.totalStarts;
        return (dataDay.runtimeChannelDataList || []).reduce(function (sum, ch) {
            return sum + (ch.starts || 0);
        }, 0);
    };

    ctrl.calculateTotalGallons = function () {
        var total = 0;
        if (angular.isUndefined(ctrl.runtimeMultiDay)) return 0;
        for (var i = 0; i < ctrl.runtimeMultiDay.data.length; i++) {
            //loop through the array
            if (ctrl.runtimeMultiDay.data[i].device.deviceName.toLowerCase().indexOf($scope.search.undefined.toLowerCase()) >= 0) {
                if (!angular.isUndefined(ctrl.runtimeMultiDay.data[i].runtimeDataList)) {
                    for (var j = 0; j < ctrl.runtimeMultiDay.data[i].runtimeDataList.length; j++) {
                        //loop through the array
                        total += ctrl.runtimeMultiDay.data[i].runtimeDataList[j].gallons;
                    }
                }
            }
        }
        ctrl.totalGallons = total;
        ctrl.runtimeMultiDay.loading = false;
    };

    $scope.$on('updatePreferencesMeasurement', function (event, message) {
        ctrl.measurementId = message === 1 ? 1 : 3.78541;
    });

    $scope.$on('updatePreferenceRuntime', function (event, message) {
        ctrl.runtimeScale = message.runtimeScale === "M" ? 1 : 1.00 / 60.00;
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
    });
};

RuntimeMultiDayController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'RuntimeMultiDayFactory', '$timeout', '$filter', '$element', 'savePdfService', 'preferencesService', 'toaster'];
'use strict';

angular.module('mc.runtime-daily').component('runtimeMultiDay', {
    controller: RuntimeMultiDayController,
    templateUrl: 'ui/runtime/runtime-multi-day-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.runtime-monthly", []);
"use strict";

function RuntimeMonthlyFactory(REPORTS, $http) {

    // instantiate our initial object
    var RuntimeMonthly = function RuntimeMonthly(customerId, startDate, timeZone, runtimeScale, measurementId, stickyProperties) {
        this.customerId = customerId;
        this.startDate = startDate;
        this.timeZone = timeZone;
        this.runtimeScale = runtimeScale;
        this.measurementId = measurementId;
        this.stickyProperties = stickyProperties;
    };

    RuntimeMonthly.prototype.getData = function () {
        var self = this;
        return $http.get(REPORTS + "/api/RuntimeMonthlyReport" + "?customerId=" + this.customerId + "&startDate=" + this.startDate + "&timeZone=" + this.timeZone + "&runtimeScale=" + this.runtimeScale + "&measurementId=" + this.measurementId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return RuntimeMonthly;
}

RuntimeMonthlyFactory.$inject = ['REPORTS', '$http'];

angular.module('mc.runtime-monthly').factory('RuntimeMonthlyFactory', RuntimeMonthlyFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RuntimeMonthlyController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, RuntimeMonthlyFactory, $timeout, $filter, $element, savePdfService, toaster) {
    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurementId = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? 1 : 3.78541;
        ctrl.runtimeScale = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? 1 : 1.00 / 60.00;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        ctrl.reportDate = new Date();
        ctrl.currentMonth = new Date().getMonth();
        ctrl.currentYear = new Date().getFullYear();
        ctrl.adjustButtons();
        ctrl.goSelectReportData();
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.selectMyDate = function () {
        ctrl.goSelectReportData(true);
        return;
        //var tmpDates = scope.myDate;
        //$scope.loadingInProgress = true;
        //tmpDates.setHours(0, 0, 0, 0);
        //tmpDates = datetimeService.dateToUnixtime(tmpDates);
        //tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
        //_getData(scope.deviceSelected, tmpDates.startDate, tmpDates.endDate);
    };

    ctrl.mostRecentData = function () {
        ctrl.isRefresh = true;
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.goSelectReportData();
    };

    ctrl.goSelectReportData = function (varClick) {
        ctrl.alerts = [];
        var numberOfDays = 30,
            _tmpStartDate,
            _tmpEndDate;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        }
        if (varClick) {
            ctrl.runtimeMonthly.loading = true;
            _tmpStartDate = ctrl.reportDate;
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        } else if (ctrl.stickyProperties.on == true) {
            ctrl.stickyProperties.on = false;
            _tmpStartDate = new Date(ctrl.stickyProperties.dateMin);
            ctrl.startDate = ctrl.stickyProperties.dateMin;
            ctrl.reportDate = _tmpStartDate;
            ctrl.adjustButtons();
        } else {
            _tmpStartDate = new Date();
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.reportDate = _tmpStartDate;
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        }

        if (ctrl.isRefresh) {
            ctrl.runtimeMonthly.loading = true;
            _tmpStartDate = new Date();
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
            ctrl.isRefresh = false;
        }

        ctrl.endDate = new Date(_tmpStartDate.getTime());
        ctrl.runtimeMonthly = new RuntimeMonthlyFactory(ctrl.accountInfo.customerId, ctrl.startDate, ctrl.accountInfo.timeZone, ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale, ctrl.accountInfo.preferenceUser.lookupMeasurementID, ctrl.stickyProperties); //varDateRangeEndTmp - is StartDate
        ctrl.runtimeMonthly.loading = true;
        ctrl.runtimeMonthly.getData().then(function () {
            ctrl.daysInMonth = ctrl.getDaysInMonth();
            ctrl.calculateTotalGallons();
            sharedSetupService.setStickyProperties(ctrl.runtimeMonthly.stickyProperties, { dataMin: ctrl.startDate, dataMax: null, zoomMin: ctrl.startDate, zoomMax: null, windowId: ctrl.windowId });
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");

        var drawCell = function drawCell(row, data) {
            if (typeof data.row.raw[1] == "undefined") {
                data.doc.setFillColor(226, 239, 248);
            }
            if (data.row.cells[0].text[0] == "Total Gallons:") {
                data.doc.setFontStyle('bold');
                data.doc.setFillColor(226, 239, 248);
            }
        };

        var pdfParams = {
            windowTitle: eval("ctrl.translation.text." + windowTitle) + (": " + moment(ctrl.reportDate).format("MMM YYYY")),
            pdfTitle: eval("ctrl.translation.text." + windowTitle) + (": " + moment(ctrl.reportDate).format("MMMM YYYY")),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            drawCell: drawCell
        };

        savePdfService.savePDF(pdfParams);
    };
    // This is view specific save excel implementation.
    ctrl.saveExcel = function () {
        $scope.topMenuExcelProgress = true;

        //Copy html elements
        var requiredElementCopy = angular.copy($element.parents("div").find("div.save-excel"));
        var requiredHeaderCopy = angular.copy($element.parents("div").find(".excel-pdf-header"));
        var reportTitle = $scope.windowTitle.trim();
        if (!/Report$/.test(reportTitle)) {
            reportTitle += " Report";
        }
        $(requiredElementCopy).prepend("<h4>" + reportTitle + (": " + moment(ctrl.reportDate).format("MMMM YYYY")) + "</h4>");

        //Remove Undesired html
        $(requiredElementCopy).find(".mc-remove-extra-column").remove();
        $(requiredElementCopy).find(".mc-remove-extra-data-pdf-only").remove();
        $(requiredElementCopy).find(".img-excel-download-remove").remove();
        $(requiredHeaderCopy).find(".mc-remove-extra-column").remove();
        $(requiredHeaderCopy).find(".dropdown-menu").remove();

        //Prepend Header to table
        $(requiredElementCopy).find("tbody:first").prepend(requiredHeaderCopy);

        var blob = new Blob([requiredElementCopy.html()], {
            type: "application/vnd.ms-excel;charset=utf-8"
        });
        //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        if ($scope.curentBrowser == "ie") $scope.ieFileSuffix = " (" + new Date().getTime() + ")";
        setTimeout(function () {
            $scope.topMenuExcelProgress = false;
            $scope.$apply();
            saveAs(blob, $scope.windowTitle.replace(/ /g, "_") + (": " + moment(ctrl.reportDate).format("MMM YYYY")) + $scope.ieFileSuffix + ".xls");
        }, 1000);
    };

    ctrl.calculateTotalGallons = function () {
        var total = 0;
        if (angular.isUndefined(ctrl.runtimeMonthly)) return 0;
        for (var i = 0; i < ctrl.runtimeMonthly.data.length; i++) {
            //loop through the array
            if (ctrl.runtimeMonthly.data[i].device.deviceName.toLowerCase().indexOf($scope.search.undefined) >= 0) {
                if (!angular.isUndefined(ctrl.runtimeMonthly.data[i].runtimeDataList)) {
                    for (var j = 0; j < ctrl.runtimeMonthly.data[i].runtimeDataList.length; j++) {
                        //loop through the array
                        if (ctrl.runtimeMonthly.data[i].runtimeDataList[j].description != "Total") {
                            total += ctrl.runtimeMonthly.data[i].runtimeDataList[j].gallons;
                        }
                    }
                }
            }
        }
        ctrl.totalGallons = total;
    };

    ctrl.getDaysInMonth = function () {
        var d = new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0);
        return d.getDate();
    };

    // ctrl.setReportDate = function (months) {
    //     if (months == 0) ctrl.reportDate = new Date();
    //     var d = new Date(ctrl.reportDate || new Date());
    //     d.setMonth(d.getMonth() + (months || 0), d.getDate());
    //     ctrl.reportDate = d;
    //     ctrl.adjustButtons();
    //     ctrl.goSelectReportData(true);
    // }

    //replacing above method to get report only after clicking GO Button
    ctrl.setReportMonth = function (month, year) {
        var d = new Date(ctrl.reportDate || new Date());
        d = new Date(year, month);
        if (month > ctrl.currentMonth && year == ctrl.currentYear) {
            toaster.pop('error', translationService.translation.text.ALERTS, "Invalid Date");
        } else {
            ctrl.reportDate = d;
            ctrl.adjustButtons();
            ctrl.goSelectReportData(true);
        }
    };

    // method after clicking today button
    ctrl.setCurrentMonth = function () {
        //assigning the dropdown the current month and year
        ctrl.selectedMonth = ctrl.currentMonth.toString();
        ctrl.selectedYear = ctrl.currentYear.toString();
        var d = new Date(ctrl.reportDate || new Date());
        d = new Date(ctrl.currentYear, ctrl.currentMonth);
        ctrl.reportDate = d;
        ctrl.adjustButtons();
        ctrl.goSelectReportData(true);
    };

    ctrl.adjustButtons = function () {
        if (new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0).getTime() === new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime()) {
            ctrl.todaysDate = true;
            //using dropdowns so next date icon is not needed
            // ctrl.nextDate = true;
        } else {
            ctrl.todaysDate = false;
            //using dropdowns so next date icon is not needed
            // ctrl.nextDate = false;
        }
    };

    $scope.$on('updatePreferencesMeasurement', function (event, message) {
        ctrl.measurementId = message === 1 ? 1 : 3.78541;
    });

    $scope.$on('updatePreferenceRuntime', function (event, message) {
        ctrl.runtimeScale = message.runtimeScale === "M" ? 1 : 1.00 / 60.00;
    });

    //var orderBy = $filter('orderBy');
    //ctrl.order = (predicate, reverse) => {
    //    switch (predicate) {
    //        case "repTypeDescription":
    //            ctrl.sortLoginTime = reverse ? 'localDateTime' : '-localDateTime';
    //            ctrl.runtimeMonthly.list = orderBy(ctrl.runtimeMonthly.list, [predicate, ctrl.sortLoginTime], reverse);
    //            break;
    //        case "deviceName":
    //        case "sendToPath":
    //            ctrl.runtimeMonthly.list = orderBy(ctrl.runtimeMonthly.list, predicate, reverse);
    //            break;
    //        default:
    //            ctrl.runtimeMonthly.list = orderBy(ctrl.runtimeMonthly.list, predicate, reverse);
    //            break;
    //    }
    //    ctrl.predicate = predicate;
    //};

    //$scope.setSorting = () => {
    //    ctrl.order('localDateTime', ctrl.reverse);
    //};
};

RuntimeMonthlyController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'RuntimeMonthlyFactory', '$timeout', '$filter', '$element', 'savePdfService', 'toaster'];
'use strict';

angular.module('mc.runtime-monthly').component('runtimeMonthly', {
    controller: RuntimeMonthlyController,
    templateUrl: 'ui/runtime/runtime-monthly-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

function RuntimeDailyFactory(REPORTS, $http) {

    // instantiate our initial object
    var RuntimeDaily = function RuntimeDaily(customerId, startDate, startTimeHour, timeZone, runtimeScale, measurementId, stickyProperties) {
        this.customerId = customerId;
        this.startDate = startDate;
        this.startTimeHour = startTimeHour;
        this.timeZone = timeZone;
        this.runtimeScale = runtimeScale;
        //NOTE: always fetch data in Imperial Measurement System (Gallons). UI is going to perform gallons/Liters and vice-versa conversion based on user preferences
        this.measurementId = 1; //measurementId;
        this.stickyProperties = stickyProperties;
    };

    RuntimeDaily.prototype.getData = function () {
        var self = this;
        return $http.get(REPORTS + "/api/RuntimeDailyReport" + "?customerId=" + this.customerId + "&startDate=" + this.startDate + "&startTimeHour=" + this.startTimeHour + "&timeZone=" + this.timeZone + "&runtimeScale=" + this.runtimeScale + "&measurementId=" + this.measurementId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return RuntimeDaily;
}

RuntimeDailyFactory.$inject = ['REPORTS', '$http'];

angular.module('mc.runtime-daily').factory('RuntimeDailyFactory', RuntimeDailyFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RuntimeDailyController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, RuntimeDailyFactory, $timeout, $filter, $element, savePdfService, preferencesService, toaster) {
    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurementId = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? 1 : 3.78541;
        ctrl.runtimeScale = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? 1 : 1.00 / 60.00;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.isRefresh = false;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.downloadViewTypeOptions = [0, 1, 2];

        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        ctrl.goSelectReportData();
        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.noData = function (runtime, starts) {
        return (runtime == null || runtime == 0) && (starts == null || starts == 0);
    };

    ctrl.mostRecentData = function () {
        ctrl.isRefresh = true;
        ctrl.myDate == null;
        toaster.pop('success', ctrl.windowTitle, 'View reloading');
        ctrl.runtimeDaily.loading = true;
        ctrl.goSelectReportData();
    };

    ctrl.selectMyDate = function () {
        ctrl.goSelectReportData(true);
        return;
        var tmpDates = scope.myDate;
        scope.loadingInProgress = true;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
        _getData(scope.deviceSelected, tmpDates.startDate, tmpDates.endDate);
    };

    ctrl.goSelectReportData = function (varClick) {
        ctrl.alerts = [];
        var numberOfDays = 30,
            _tmpStartDate,
            _tmpEndDate;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        }
        if (varClick) {
            ctrl.runtimeDaily.loading = true;
            _tmpStartDate = ctrl.myDate;
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        } else if (ctrl.stickyProperties.on == true) {
            ctrl.stickyProperties.on = false;
            _tmpStartDate = new Date(ctrl.stickyProperties.dateMin + ctrl.unixDay);
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.myDate = _tmpStartDate;
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        } else {
            _tmpStartDate = new Date();
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.myDate = _tmpStartDate;
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        }

        if (ctrl.isRefresh) {
            _tmpStartDate = new Date();
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.myDate = _tmpStartDate;
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
            ctrl.isRefresh = false;
        }

        ctrl.endDate = new Date(_tmpStartDate.getTime());
        //Set dates for view
        ctrl.date = new Date(_tmpStartDate);
        ctrl.yesterday = angular.copy(ctrl.date);
        ctrl.yesterday.setDate(ctrl.yesterday.getDate() + 1);
        ctrl.yesterday = moment(ctrl.yesterday).format();

        ctrl.runtimeDaily = new RuntimeDailyFactory(ctrl.accountInfo.customerId, ctrl.startDate, _tmpStartDate.getHours(), ctrl.accountInfo.timeZone, ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale, ctrl.accountInfo.preferenceUser.lookupMeasurementID, ctrl.stickyProperties); //varDateRangeEndTmp - is StartDate
        ctrl.runtimeDaily.loading = true;
        //NOTE: always fetch data in Imperial Measurement System (Gallons). UI is going to perform gallons/Liters and vice-versa conversion based on user preferences
        ctrl.runtimeDaily.getData().then(function () {
            ctrl.calculateTotalGallons();
            sharedSetupService.setStickyProperties(ctrl.runtimeDaily.stickyProperties, { dataMin: ctrl.startDate, dataMax: null, zoomMin: ctrl.startDate, zoomMax: null, windowId: ctrl.windowId });
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");

        var drawCell = function drawCell(row, data) {
            if (typeof data.row.raw[1] == "undefined") {
                data.doc.setFillColor(226, 239, 248);
            }
            if (data.row.cells[0].text[0] == "Total Gallons:") {
                data.doc.setFontStyle('bold');
                data.doc.setFillColor(226, 239, 248);
            }
        };

        if (ctrl.timeFormat == 1) {
            var pdfParams = {
                windowTitle: windowTitle,
                pdfTitle: eval("ctrl.translation.text." + windowTitle) + (" (" + moment(ctrl.yesterday).format("MMMM D, YYYY h:mm a") + " - " + moment(ctrl.date).format("MMMM D, YYYY h:mm a") + ")"),
                customerName: ctrl.accountInfo.customerName,
                customerId: ctrl.accountInfo.customerId,
                dateTranslate: ctrl.translation.text.DATE_CREATED,
                dateRangeStart: $scope.myDateRangeStart,
                dateRangeEnd: $scope.myDateRangeEnd,
                $scope: $scope,
                $element: $element,
                drawCell: drawCell
            };
        } else {
            var pdfParams = {
                windowTitle: windowTitle,
                pdfTitle: eval("ctrl.translation.text." + windowTitle) + (" (" + moment(ctrl.yesterday).format("MMMM D, YYYY HH:mm") + " - " + moment(ctrl.date).format("MMMM D, YYYY HH:mm") + ")"),
                customerName: ctrl.accountInfo.customerName,
                customerId: ctrl.accountInfo.customerId,
                dateTranslate: ctrl.translation.text.DATE_CREATED,
                dateRangeStart: $scope.myDateRangeStart,
                dateRangeEnd: $scope.myDateRangeEnd,
                $scope: $scope,
                $element: $element,
                drawCell: drawCell
            };
        }

        savePdfService.savePDF(pdfParams);
    };

    ctrl.searchFieldChanged = function (varInput) {
        ctrl.calculateTotalGallons();
    };

    ctrl.calculateTotalGallons = function () {
        var total = 0;
        if (angular.isUndefined(ctrl.runtimeDaily)) return 0;
        for (var i = 0; i < ctrl.runtimeDaily.data.length; i++) {
            //loop through the array
            if (ctrl.runtimeDaily.data[i].device.deviceName.toLowerCase().indexOf($scope.search.undefined.toLowerCase()) >= 0) {
                if (!angular.isUndefined(ctrl.runtimeDaily.data[i].runtimeDataList)) {
                    for (var j = 0; j < ctrl.runtimeDaily.data[i].runtimeDataList.length; j++) {
                        //loop through the array
                        if (ctrl.runtimeDaily.data[i].runtimeDataList[j].description != "Total") {
                            total += ctrl.runtimeDaily.data[i].runtimeDataList[j].gallons;
                        }
                    }
                }
            }
        }
        ctrl.totalGallons = total;
    };

    $scope.$on('updatePreferencesMeasurement', function (event, message) {
        ctrl.measurementId = message === 1 ? 1 : 3.78541;
    });

    $scope.$on('updatePreferenceRuntime', function (event, message) {
        ctrl.runtimeScale = message.runtimeScale === "M" ? 1 : 1.00 / 60.00;
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
    });
};

RuntimeDailyController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'RuntimeDailyFactory', '$timeout', '$filter', '$element', 'savePdfService', 'preferencesService', 'toaster'];
'use strict';

angular.module('mc.runtime-daily').component('runtimeDaily', {
    controller: RuntimeDailyController,
    templateUrl: 'ui/runtime/runtime-daily-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.saved-desktop", []);
"use strict";

function SavedDesktopController($scope, $rootScope, deviceMenuService, translationService, $timeout, $templateCache, sharedSetupService, desktopViewService, authenticationService, $location) {
    var ctrl = this;

    ctrl.mobile = $rootScope.mobile;
    $scope.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;
    ctrl.fullScreenModeAvailable = $rootScope.fullScreenModeAvailable;
    ctrl.mobileApp = $rootScope.mobileApp;
    ctrl.slides = { id: 0 };

    ctrl.noMobile = ["Alarm Rule Test", "Carrier Rate Plan", "Communication", "Download", "Live User Report", "Map", "Paging Option", "Precipitation", "Weather"];

    ctrl.specialSavedDesktop = ["All RTUs", "All MyLevels", "All Pump Stations"];

    ctrl.includeDevice = function (device, specialView) {
        switch (specialView) {

            case "All MyLevels":
                return device.model === 20 && device.hasLevelSensor;

            case "All Pump Stations":
                return device.pumpStationWidgetId > 0 && (device.type == 8 || device.type == 9 || device.type == 17 || device.type == 18 || device.type == 19 || device.type == 21);

            case "All RTUs":
            default:
                return true;
        }
    };

    ctrl.savedDesktops = [];
    ctrl.savedDesktopsInfo = [];
    ctrl.deviceData = [];

    ctrl.$onInit = function () {
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
    };

    ctrl.getText = function (text) {
        if (!angular.isDefined(text)) return;
        return ctrl.translation.text[text.toUpperCase().replace(/ /g, "_")];
    };

    var _correctViewNameMobile = function _correctViewNameMobile(varViewName) {
        var viewName = varViewName;
        if (varViewName === "User Preferences") {
            viewName = "Preferences";
        } else if (varViewName === "Customer Preferences") {
            viewName = "Preferences";
        }
        return viewName;
    };

    var _getViewsReady = function _getViewsReady(desktopViews) {

        angular.forEach(desktopViews, function (dataView, idx) {
            var _optionsStickyProperties = {};
            var _mcDevice = { deviceId: dataView.deviceId, deviceName: null, channel: dataView.channel, serialNumber: dataView.serialNumber };
            var _view = { type: null, expanded: dataView.expanded };

            switch (dataView.widget) {
                case false:

                    _optionsStickyProperties = {
                        on: true,
                        savedDesktop: true,
                        deviceId: dataView.deviceId,
                        device: _mcDevice,
                        dateMin: dataView.liveData ? null : dataView.dateMinimum,
                        dateMax: dataView.liveData ? null : dataView.dateMaximum,
                        zoomMin: dataView.liveData ? null : dataView.zoomMinimum,
                        zoomMax: dataView.liveData ? null : dataView.zoomMaximum,
                        dataFormat: null,
                        view: _view,
                        setting: dataView.setting != "" ? JSON.parse(dataView.setting) : null
                    };
                    break;
                case true:
                    _optionsStickyProperties = {
                        on: true,
                        savedDesktop: true,
                        device: _mcDevice
                    };
                    break;
            }

            dataView.viewName = desktopViewService.correctViewName(dataView.viewName, _optionsStickyProperties.device.channel);
            dataView.viewName = _correctViewNameMobile(dataView.viewName);
            if (!ctrl.noMobile.includes(dataView.viewName)) ctrl.savedDesktops.push({ id: dataView.viewName, stickyProperties: _optionsStickyProperties });
        });
    };

    ctrl.$onChanges = function (changes) {

        if (changes.windowId && changes.mobile) {
            //changes.windowId.currentValue = undefined for Classic View
            ctrl.accountInfo = authenticationService.getAccountInfo();
            ctrl.translation = translationService.translation;
            ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;

            ctrl.windowId = changes.windowId.currentValue;
            ctrl.mobile = changes.mobile.currentValue;

            ctrl.savedDesktopName = ctrl.specialSavedDesktop.includes(ctrl.stickyProperties.device.deviceName) ? ctrl.stickyProperties.device.deviceName : window.localStorage.getItem("savedDesktop");
            ctrl.specialView = ctrl.accountInfo.customerId > 0 && ctrl.stickyProperties.device.deviceId == null && ctrl.specialSavedDesktop.includes(ctrl.savedDesktopName);

            ctrl.dynamicPopover = {
                templateUrl: ctrl.specialView ? "SavedDesktopPopoverSpecialTemplate.html" : "SavedDesktopPopoverTemplate.html"
            };

            // if (!(ctrl.specialView || (ctrl.accountInfo.customerId > 0 && ctrl.stickyProperties.device.deviceId > 0))) {
            //     ctrl.openSavedDesktopPrep();
            //     return;
            // }

            switch (ctrl.specialView) {

                case true:
                    deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
                        var specialViews = [];
                        result.data.devices.forEach(function (device, i) {
                            if (ctrl.includeDevice(device, ctrl.savedDesktopName)) specialViews.push(ctrl.getRtuViewsObj(i + 1, device.deviceId, ctrl.savedDesktopName, device.serialNumber));
                        });

                        _getViewsReady(specialViews);
                        ctrl.openSavedDesktopPrep();
                    }, function (error) {
                        console.log("Error");
                    });
                    break;

                case false:
                default:
                    desktopViewService.getData(ctrl.accountInfo.customerId, ctrl.stickyProperties.device.deviceId).then(function (result) {
                        result.data.views.sort(function (a, b) {
                            return a.zIndex - b.zIndex;
                        });

                        _getViewsReady(result.data.views);

                        ctrl.openSavedDesktopPrep();
                    }, function (error) {
                        console.log("Error");
                        ctrl.goToHomePage();
                    });
                    break;
            }
        }
    };

    ctrl.goToHomePage = function () {
        var tmpHome = "/";
        $location.path(tmpHome);
    };

    ctrl.getAllRtuViewsReady = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            result.data.devices.forEach(function (device) {
                ctrl.deviceData.push({ id: device.deviceId, name: device.name });
            });
            ctrl.openSavedDesktop();
        }, function (error) {
            ctrl.openSavedDesktop();
        });
    };

    ctrl.getRtuViewsObj = function (index, deviceId, specialView, serialNumber) {

        switch (specialView) {

            case "All RTUs":
                return {
                    "desktopId": 0,
                    "viewId": index,
                    "viewName": "RTU View",
                    "deviceId": deviceId,
                    "serialNumber": serialNumber,
                    "widget": false,
                    "zIndex": 999,
                    "setting": ""
                };

            case "All MyLevels":
                return {
                    "desktopId": 0,
                    "viewId": index,
                    "viewName": "Mc MyLevel Widget",
                    "deviceId": deviceId,
                    "serialNumber": serialNumber,
                    "widget": true,
                    "zIndex": 999,
                    "setting": ""
                };

            case "All Pump Stations":
                return {
                    "desktopId": 0,
                    "viewId": index,
                    "viewName": "Mc Pump Station Widget",
                    "deviceId": deviceId,
                    "serialNumber": serialNumber,
                    "widget": true,
                    "zIndex": 999,
                    "setting": ""
                };
        }
    };

    ctrl.openSavedDesktopPrep = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            result.data.devices.forEach(function (device) {
                ctrl.deviceData.push({ id: device.deviceId, name: device.name });
            });
            ctrl.openSavedDesktop();
        }, function (error) {
            ctrl.openSavedDesktop();
        });
    };

    ctrl.openSavedDesktop = function () {
        ctrl.errorMessage = false;
        // if (ctrl.savedDesktops.length === 0) {
        //     ctrl.errorMessage = true;
        //     return;
        // }
        $timeout(function () {
            ctrl.savedDesktops.forEach(function (template) {

                var templateId = template.id;
                if (!angular.isDefined(templateId)) console.log("No such template: " + templateId);
                var viewTemplate = $templateCache.get(templateId);
                if (!angular.isDefined(viewTemplate)) console.log("$templateCache, template missing: " + templateId);
                viewTemplate = viewTemplate.trim();
                var myUrl = $($.parseHTML(viewTemplate)).find('div').attr('ng-include');

                var deviceInfo = void 0,
                    channel = void 0,
                    serialNumber = void 0;
                deviceInfo = ctrl.deviceData.filter(function (x) {
                    return x.id == template.stickyProperties.device.deviceId;
                });
                deviceInfo = deviceInfo.length > 0 ? deviceInfo[0].name : "";
                channel = template.stickyProperties.device.channel != null ? template.stickyProperties.device.channel : "";
                serialNumber = template.stickyProperties.device.serialNumber != null ? template.stickyProperties.device.serialNumber : "";

                deviceInfo = ctrl.specialView ? "" + (deviceInfo.length > 0) ? "" + deviceInfo + (serialNumber.length > 0 ? " - " + serialNumber : "") : "" : "" + (deviceInfo.length > 0) ? "" + deviceInfo + (channel.length > 0 ? " (ch: " + channel + ")" : "") : "";

                ctrl.savedDesktopsInfo.push({ name: templateId, stickyProperties: template.stickyProperties, url: myUrl.replace(/'/g, ""), deviceInfo: deviceInfo });
            });
            $scope.stickyProperties = ctrl.savedDesktops[0].stickyProperties;
            //sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: ctrl.savedDesktopsInfo[0].stickyProperties.device.deviceId, windowId: ctrl.savedDesktopsInfo[0].id });
        }, 0);
    };

    ctrl.prev = function () {
        $(".slide-arrows-l,.slide-arrows-r,.slide-arrows-c").addClass("slide-arrows-opacity");
        $(".slide").addClass("slide-to-right").removeClass("slide-to-left");

        $timeout(function () {
            var $radios = $('input[type="radio"][name="slides"]');
            var $checked = $radios.filter(':checked');
            var $next = $radios.eq($radios.index($checked) - 1);
            if ($radios.index($checked) === 0) {
                ctrl.slides.id = $radios.index($checked);
                //$next = $radios.last();
            } else {
                $next.prop("checked", true);
                ctrl.slides.id = $radios.index($checked) - 1;
            }

            $scope.stickyProperties = ctrl.savedDesktops[ctrl.slides.id].stickyProperties;
        }, 0);
    };

    ctrl.next = function () {
        $(".slide-arrows-l,.slide-arrows-r,.slide-arrows-c").addClass("slide-arrows-opacity");
        $(".slide").addClass("slide-to-left").removeClass("slide-to-right");

        $timeout(function () {
            var $radios = $('input[type="radio"][name="slides"]');
            var $checked = $radios.filter(':checked');
            var $next = $radios.eq($radios.index($checked) + 1);
            if (!$next.length) {
                ctrl.slides.id = $radios.index($checked);
                //$next = $radios.first();
            } else {
                $next.prop("checked", true);
                ctrl.slides.id = $radios.index($checked) + 1;
            }

            $scope.stickyProperties = ctrl.savedDesktops[ctrl.slides.id].stickyProperties;
        }, 0);
    };

    ctrl.selectSlide = function (index) {

        $timeout(function () {
            $('.saved-desktop-paging').trigger('click');
        }, 0);

        if (index === ctrl.slides.id) {} else if (index < ctrl.slides.id) {
            $(".slide-arrows-l,.slide-arrows-r,.slide-arrows-c").addClass("slide-arrows-opacity");
            $(".slide").addClass("slide-to-right").removeClass("slide-to-left");
            $timeout(function () {
                ctrl.slides.id = index;
                $scope.stickyProperties = ctrl.savedDesktops[ctrl.slides.id].stickyProperties;
            }, 0);
        } else {
            $(".slide-arrows-l,.slide-arrows-r,.slide-arrows-c").addClass("slide-arrows-opacity");
            $(".slide").addClass("slide-to-left").removeClass("slide-to-right");
            $timeout(function () {
                ctrl.slides.id = index;
                $scope.stickyProperties = ctrl.savedDesktops[ctrl.slides.id].stickyProperties;
            }, 0);
        }
    };
};

SavedDesktopController.$inject = ['$scope', '$rootScope', 'deviceMenuService', 'translationService', '$timeout', '$templateCache', 'sharedSetupService', 'desktopViewService', 'authenticationService', '$location'];
'use strict';

angular.module('mc.saved-desktop').component('savedDesktop', {
    controller: SavedDesktopController,
    templateUrl: 'ui/saveddesktop/saved-desktop-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
"use strict";

angular.module("mc.safewater", []);
'use strict';

function SafewaterFactory(REPORTS, $http, GetDeviceNameService) {

    var SafewaterReportData = function SafewaterReportData(deviceId, deviceType, startDate, timeZone, stickyProperties) {
        this.deviceId = deviceId;
        this.deviceType = deviceType;
        this.startDate = startDate;
        this.timeZone = timeZone;
        this.stickyProperties = stickyProperties;
    };

    SafewaterReportData.prototype.getData = function () {
        var self = this;
        return $http.get(REPORTS + '/api/SafeWaterReport' + '?deviceId=' + this.deviceId + '&deviceType=' + this.deviceType + '&startDate=' + this.startDate + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;

            return response;
        });
    };
    return SafewaterReportData;
}

SafewaterFactory.$inject = ['REPORTS', '$http', 'GetDeviceNameService'];

angular.module('mc.safewater').factory('SafewaterFactory', SafewaterFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function SafewaterController($, $rootScope, $scope, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, SafewaterFactory, $timeout, $filter, $element, savePdfService, toaster) {
    var ctrl = this;

    ctrl.$onInit = function () {
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        $scope.windowId = ctrl.windowId; //need for
        ctrl.translation = translationService.translation;
        ctrl.reportDate = new Date();
        $scope.windowTitle = ctrl.windowTitle; //need for
        //ctrl.goSelectReportData();

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.mostRecentData = function () {
        ctrl.isRefresh = true;
        toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
        ctrl.goSelectReportData();
    };

    ctrl.goSelectReportData = function (varClick) {
        ctrl.alerts = [];
        ctrl.loadingInProgress = true;
        sharedSetupService.disableButtons();
        var numberOfDays = 30,
            _tmpStartDate,
            _tmpEndDate;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        }
        if (varClick) {
            // ctrl.runtimeMonthly.loading = true;
            _tmpStartDate = ctrl.reportDate;
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        } else if (ctrl.stickyProperties && ctrl.stickyProperties.on == true) {
            ctrl.stickyProperties.on = false;
            _tmpStartDate = new Date(ctrl.stickyProperties.dateMin);
            ctrl.startDate = ctrl.stickyProperties.dateMin;
            ctrl.reportDate = _tmpStartDate;
            ctrl.adjustButtons();
        } else {
            _tmpStartDate = new Date();
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.reportDate = _tmpStartDate;
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        }

        if (ctrl.isRefresh) {
            _tmpStartDate = new Date();
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
            ctrl.isRefresh = false;
        }

        ctrl.endDate = new Date(_tmpStartDate.getTime());
        var _safewaterFactory = new SafewaterFactory(ctrl.deviceSelected, $scope.deviceSelectedType, ctrl.startDate, ctrl.accountInfo.timeZone, ctrl.stickyProperties); //varDateRangeEndTmp - is StartDate

        _safewaterFactory.getData().then(function () {
            ctrl.loadingInProgress = false;
            sharedSetupService.enableButtons();
            ctrl.safewaterData = _safewaterFactory;
            if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.setStickyProperties(ctrl.safewaterData.stickyProperties, { deviceId: ctrl.deviceSelected, dataMin: ctrl.startDate, dataMax: null, zoomMin: ctrl.startDate, zoomMax: null, windowId: ctrl.windowId });
            // ctrl.refreshAlerts();
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle) + ", " + $scope.deviceSelectedName,
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    ctrl.getDaysInMonth = function () {
        var d = new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0);
        return d.getDate();
    };

    ctrl.setReportDate = function (months) {
        if (months == 0) ctrl.reportDate = new Date();
        var d = new Date(ctrl.reportDate || new Date());
        d.setMonth(d.getMonth() + (months || 0), d.getDate());
        ctrl.reportDate = d;
        ctrl.adjustButtons();
        ctrl.goSelectReportData(true);
    };

    ctrl.adjustButtons = function () {
        if (new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0).getTime() === new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime()) {
            ctrl.todaysDate = true;
            ctrl.nextDate = true;
        } else {
            ctrl.todaysDate = false;
            ctrl.nextDate = false;
        }
    };

    ctrl.deviceEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === ctrl.filterDeviceId) {
                ctrl.filterDeviceId = null;
                ctrl.deviceModel = [];
            } else {
                ctrl.filterDeviceId = item.id;
            }
            ctrl.deviceModelLength = ctrl.deviceModel.length;
            ctrl.goSelectReportData(ctrl.filterDeviceId);
        }
    };

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            var tmpNewValue;
            if (ctrl.stickyProperties && ctrl.stickyProperties.on == true) {
                tmpNewValue = $scope.findFirstDeviceWithChlorine(ctrl.stickyProperties.deviceId);
                ctrl.reportDate = new Date(ctrl.stickyProperties.dateMin);
                ctrl.stickyProperties.on = false;
            } else {
                tmpNewValue = $scope.findFirstDeviceWithChlorine(newValue);
            }
            ctrl.deviceSelected = tmpNewValue.deviceId;
            $scope.deviceSelectedSn = tmpNewValue.serialNumber;
            $scope.deviceSelectedType = tmpNewValue.type;
            $scope.deviceSelectedName = tmpNewValue.name;
            $scope.currentSelectedDevice = tmpNewValue;
            ctrl.goSelectReportData(true);
        }
    }, true);

    $scope.findFirstDeviceWithChlorine = function (deviceId) {
        for (var i = 0; i < $scope.devices.length; ++i) {
            if ($scope.devices[i].deviceId === deviceId && $scope.devices[i].hasChlorineReport) {
                return $scope.devices[i];
            }
        }

        for (var j = 0; j < $scope.devices.length; ++j) {
            if ($scope.devices[j].hasChlorineReport) {
                return $scope.devices[j];
            }
        }
    };
}

SafewaterController.$inject = ['$', '$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'SafewaterFactory', '$timeout', '$filter', '$element', 'savePdfService', 'toaster'];
'use strict';

angular.module('mc.safewater').component('safewater', {
    controller: SafewaterController,
    templateUrl: 'ui/safewater/safewater-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.site-security-portal', []);
'use strict';

function SiteSecurityPortalFactory(HOST, $http) {

    function GetSiteSecuritySetting(customerId, loginId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/SiteSecurityPortal',
            params: { customerId: customerId, loginId: loginId }
        });
    }

    function UpdateLoginsPasswordHash(loginId, password) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/SiteSecurityPortal',
            params: { loginId: loginId, password: password }
        });
        //return $http.put(HOST + '/api/ToasterMaster?customerId=' + customerId, toasterMessage

        //).then(function (response) {
        //    return response;
        //});
    }

    return {
        GetSiteSecuritySetting: GetSiteSecuritySetting,
        UpdateLoginsPasswordHash: UpdateLoginsPasswordHash
    };
}

SiteSecurityPortalFactory.$inject = ['HOST', '$http'];

angular.module('mc.site-security-portal').factory('SiteSecurityPortalFactory', SiteSecurityPortalFactory);
"use strict";

function SiteSecurityPortalController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, $location, desktopViewService, AdminPortalService, $window, modalService, mcApplicationVersionAlertService, timeLapseService, toaster, websocketService, siteSecurityModalService, SiteSecurityPortalFactory) {
    var ctrl = this;
    $scope.alerts = [];
    var _uiUpToDate = $rootScope.uiUpToDate;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        $rootScope.CustomerNameStart = ""; // need for removing customer menu

        ctrl.translation = translationService.translation;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.isFromUpdatePassword = sharedSetupService.isFromUpdatePassword;

        ctrl.portalInfoName = "Site Security Portal";

        websocketService.close();

        var _initViews = function _initViews() {
            //if (!$rootScope.mobile && !$rootScope.classicView)
            //    $timeout(() => { $scope.popup.hide(); }, 0);

            SiteSecurityPortalFactory.GetSiteSecuritySetting(ctrl.accountInfo.customerId, ctrl.accountInfo.userId).then(function (result) {
                ctrl.securitySetting = result.data;
                ctrl.securityUser = ctrl.accountInfo;
                sharedSetupService.isFromUpdatePassword = false;
                siteSecurityModalService.siteSecurity('SITE_SECURITY', ctrl).then(function () {
                    //if (!$rootScope.mobile && !$rootScope.classicView)
                    //    $timeout(() => { $scope.popup.dialog("close"); }, 0);                   
                }, function (error) {
                    //close modal
                    //if (!$rootScope.mobile && !$rootScope.classicView)
                    //    $timeout(() => { $scope.popup.show(); }, 0);                        
                });
            }, function (error) {
                console.log("error");
            });
        };

        if (angular.isDefined($scope.translation)) {
            _initViews();
            _tlDataReceivedUIVERSION();
        } else {
            translationService.loadLanguage(true).then(function (result) {
                $scope.translation = translationService.translation;
                _initViews();
                _tlDataReceivedUIVERSION();
            }, function (error) {
                console.log("error");
            });
        }
    };

    $scope.$on("$destroy", function () {
        desktopViewService.closeAllViews();
    });

    var _tlDataReceivedUIVERSION = function _tlDataReceivedUIVERSION() {

        var _displayMessage = false;

        mcApplicationVersionAlertService.getData('customerId=' + ctrl.accountInfo.customerId + '&applicationId=1' + '&timeZone=' + ctrl.accountInfo.timeZone).then(function (datafromfactory) {

            var _type, _title, _message, _duration;

            if (datafromfactory.data.buildNumber > $('meta[name=build]').attr("content")) {
                _displayMessage = true;
                _uiUpToDate = false;
                _type = "error";
                _title = $scope.translation.text.NEW_123SCADA_AVAILABLE;
                _message = "<br>" + $scope.translation.text.SAVE_YOUR_WORK + "<a href='#' onclick='location.reload(true); return false;' style='text-decoration: underline;'>" + $scope.translation.text.CLICK_HERE + "</a>" + $scope.translation.text.TO_UPDATE;
                _duration = 15000;
            } else if (!$rootScope.uiUpToDate) {
                _displayMessage = true;
                _uiUpToDate = true;
                _type = "success";
                _title = $scope.translation.text.UP_TO_DATE_123SCADA;
                _message = "";
                _duration = 5000;
            }

            if (_displayMessage) toaster.pop(_type, _title, _message, _duration, 'trustedHtml');
            $rootScope.uiUpToDate = _uiUpToDate;
            _displayMessage = false;
        }, function (error) {
            console.log("error");
        });
    };
}

SiteSecurityPortalController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$location', 'desktopViewService', 'AdminPortalService', '$window', 'modalService', 'mcApplicationVersionAlertService', 'timeLapseService', 'toaster', 'websocketService', 'siteSecurityModalService', 'SiteSecurityPortalFactory'];
'use strict';

angular.module('mc.site-security-portal').component('siteSecurityPortal', {
    controller: SiteSecurityPortalController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/sitesecurityportal/site-security-portal-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.signal-connect-data-chart', []);
"use strict";

function SignalConnectDataChartFactory(HOST, $http) {

    function GetData(customerId, deviceId, startDate, endDate, timeZone) {
        return $http.get(HOST + "/api/SignalChart" + "?customerId=" + customerId + "&deviceId=" + deviceId + "&startDate=" + startDate + "&endDate=" + endDate + "&element=" + "All" + "&timeZone=" + timeZone).then(function (response) {
            return response;
        });
    }
    return {
        GetData: GetData
    };
}

SignalConnectDataChartFactory.$inject = ['HOST', '$http'];

angular.module('mc.signal-connect-data-chart').factory('SignalConnectDataChartFactory', SignalConnectDataChartFactory);
"use strict";

function SignalConnectDataChartController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, timeLapseService, datetimeService, $timeout, $filter, $element, deviceMenuService, SignalConnectDataChartFactory) {
    var _this2 = this;

    var ctrl = this;
    ctrl.noOfDays = 7; // default 7 days of chart data
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;
    sharedSetupService.broadcastAllDeviceSelected($scope);
    ctrl.seriesData = [];
    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;

        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        $scope.currentYear = new Date().getFullYear();
        ctrl.xValue = null;
        $scope.initialLoad = true;
        $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
        ctrl.MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        ctrl.element = $element.find('.vfs-chart');
        ctrl.element.addClass('chart');
        ctrl.element.addClass('chart' + ctrl.deviceId);

        //ctrl._chartLoading = true;
        //getInitData(); // data will be loaded only on "onSignalConnectDateSelect" event handler

        // setting default start & end dates during initial load
        //var date = new Date();
        //ctrl.myDateRangeStart = new Date(date.getTime() - (6 * 24 * 60 * 60 * 1000)); // we are considering both the days included, that means difference is 6 days
        //ctrl.myDateRangeEnd = new Date();


        //loadData();

        if (!ctrl.mobile && !ctrl.classicView && ctrl.windowId != ctrl.deviceId) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                var _char = $scope.popup.parent().find('.chart').highcharts();
                if ($scope.popup.parent().find(".chart").highcharts()) {
                    _char.reflow();
                }
            };
        }
        //ctrl._chartLoading = false;
    };

    ctrl.$onChanges = function (changes) {

        if (!angular.isUndefined(changes.dateTime) && changes.dateTime.currentValue && changes.dateTime.currentValue != changes.dateTime.previousValue) {
            if (angular.isUndefined($scope.translation)) $scope.translation = translationService.translation;
            //console.log(changes.dateTime.currentValue);
            ctrl.myDateRangeStart = changes.dateTime.currentValue.startDate;
            ctrl.myDateRangeEnd = changes.dateTime.currentValue.endDate;

            loadData();
        }
    };

    // when calendar component date is selected
    $rootScope.$on('onSignalConectCalendarDateSelect', function (event, opt) {
        ctrl.alerts = [];
        if (ctrl.deviceId == opt.deviceId) {
            ctrl.myDateRangeStart = opt.start;
            ctrl.myDateRangeEnd = opt.end;
            ctrl.noOfDays = Math.floor((opt.end.getTime() - opt.start.getTime()) / (1000 * 3600 * 24)) + 1;
            //console.log("chart on CALENDAR Date Select --> : st.Dt: " + opt.start + "ed.Dt: " + opt.end);
            ctrl.getData();
        }
    });

    // parent component will raise this event, to initiate children components loading process
    $scope.$on('onSignalConnectDateSelect', function (event, opt) {
        // there are two event arguments: 1-> action: "init" or "date"; --> init: initial load or refresh load; date: load on date selection
        //                                2 -> myDate
        //console.log("Chart --> action: " + opt.action + " stDt: " + opt.startDate + ", edDt: " + opt.endDate);
        if (ctrl.signalChartData) {
            ctrl.myDateRangeStart = opt.startDate;
            ctrl.myDateRangeEnd = opt.endDate;

            loadData();
            return;
        }

        // on date select, fetch up to next 7 days data
        if (opt.action === 'date' && opt.startDate && opt.endDate) {
            //use date range that is passed as event args
            ctrl.myDateRangeStart = opt.startDate;
            ctrl.myDateRangeEnd = opt.endDate;
            //noOfdays is required to display on chart title
            ctrl.noOfDays = Math.floor((opt.endDate.getTime() - opt.startDate.getTime()) / (1000 * 3600 * 24)) + 1;
            //console.log("chart on PARENT Date Select --> : st.Dt: " + opt.startDate + "ed.Dt: " + opt.endDate);
            ctrl.getData();
        } else if (opt.action === 'init') {
            // it is loading the component while init or refresh action
            //create date range with last 7 days
            getInitData();
        }
    });

    var getInitData = function getInitData() {
        var date = new Date();
        ctrl.myDateRangeStart = new Date(date.getTime() - 6 * 24 * 60 * 60 * 1000); // we are considering both the days included, that means difference is 6 days
        ctrl.myDateRangeEnd = new Date();
        //console.log("Chart Init-->  stDt: " + ctrl.myDateRangeStart + ", edDt: " + ctrl.myDateRangeEnd);
        //noOfdays is required to display on chart title
        ctrl.noOfDays = Math.floor((ctrl.myDateRangeEnd.getTime() - ctrl.myDateRangeStart.getTime()) / (1000 * 3600 * 24)) + 1;
        ctrl.getData();
    };

    ctrl.getData = function () {
        //ctrl._chartLoading = true;

        var startDate = datetimeService.dateToUnixtime(ctrl.myDateRangeStart);
        var endDate = datetimeService.dateToUnixtime(ctrl.myDateRangeEnd);

        //adjust the status of date buttons "<" & ">"
        adjustButtons();

        //console.log("Chart GetData--> device: " + ctrl.deviceId + " stDt: " + ctrl.myDateRangeStart + ", edDt: " + ctrl.myDateRangeEnd);
        SignalConnectDataChartFactory.GetData(ctrl.accountInfo.customerId, ctrl.deviceId, startDate, endDate, ctrl.accountInfo.timeZone).then(function (resp) {
            ctrl.alerts = [];
            //if (resp.data.signal.data.length === 0) {
            if ((!resp.data.signal.data || resp.data.signal.data.length === 0) && (!resp.data.signal.signalQualityData || resp.data.signal.signalQualityData.length === 0) && (!resp.data.signal.signalPowerData || resp.data.signal.signalPowerData.length === 0)) {
                var errorMessage = "No Data to display";
                ctrl.alerts = [];
                ctrl.alerts.push({
                    msg: errorMessage,
                    type: "info"
                });
                if (ctrl.chart && ctrl.chart.series && ctrl.chart.series.length > 0) {
                    ctrl.chart.destroy();
                }
            } else {
                if (resp.data.signal.device.hasRMDTRadio) {
                    ctrl.seriesData[1] = { "name": $scope.translation.text.SIGNAL + ' Power', "color": "#ddaa00", "shadow": false, "data": resp.data.signal.signalPowerData };
                    ctrl.seriesData[0] = { "name": $scope.translation.text.SIGNAL + ' Quality', "color": "#660000", "shadow": false, "data": resp.data.signal.signalQualityData, "yAxis": 1 };
                } else if (resp.data.signal.device.model == 20) {
                    $scope.chartData = resp.data.signal.data;
                    ctrl.seriesData[0] = { "name": $scope.translation.text.SIGNAL, "color": "#2288cc", "shadow": false, "data": $scope.chartData };
                    ctrl.seriesData[1] = { "name": $scope.translation.text.SIGNAL + ' Quality', "color": "#660000", "shadow": false, "data": resp.data.signal.signalQualityData, "yAxis": 1 };
                } else {
                    $scope.chartData = resp.data.signal.data;
                    ctrl.seriesData[0] = { "name": $scope.translation.text.SIGNAL, "color": "#2288cc", "shadow": false, "data": $scope.chartData };
                }
                $scope.signalConnectivityModel = resp.data.signalConnectivityModel.signalLogConnects;
                if (ctrl.chart && ctrl.chart.series && ctrl.chart.series.length > 0) {
                    ctrl.chart.destroy();
                }
                $timeout(function () {
                    ctrl._drawChart();
                    //if (!$rootScope.mobile && !$rootScope.classicView)
                    // $scope.adjustSize();
                    //ctrl._chartLoading = false;
                }, 0);
            }
        });
    };

    //NEW
    var loadData = function loadData() {
        //var date = new Date();
        //ctrl.myDateRangeStart = new Date(date.getTime() - (6 * 24 * 60 * 60 * 1000)); // we are considering both the days included, that means difference is 6 days
        //ctrl.myDateRangeEnd = new Date();
        //console.log("Chart Init-->  stDt: " + ctrl.myDateRangeStart + ", edDt: " + ctrl.myDateRangeEnd);
        //noOfdays is required to display on chart title
        ctrl.noOfDays = Math.floor((ctrl.myDateRangeEnd.getTime() - ctrl.myDateRangeStart.getTime()) / (1000 * 3600 * 24)) + 1;
        //adjust the status of date buttons "<" & ">"
        adjustButtons();

        //if (ctrl.signalChartData.signal.data.length === 0) {
        if ((!ctrl.signalChartData.signal.data || ctrl.signalChartData.signal.data.length === 0) && (!ctrl.signalChartData.signal.signalQualityData || ctrl.signalChartData.signal.signalQualityData.length === 0) && (!ctrl.signalChartData.signal.signalPowerData || ctrl.signalChartData.signal.signalPowerData.length === 0)) {
            var errorMessage = "No Data to display";
            ctrl.alerts = [];
            ctrl.alerts.push({
                msg: errorMessage,
                type: "info"
            });
            if (ctrl.chart && ctrl.chart.series && ctrl.chart.series.length > 0) {
                ctrl.chart.destroy();
            }
        } else {
            if (ctrl.signalChartData.signal.device.hasRMDTRadio) {
                ctrl.seriesData[1] = { "name": $scope.translation.text.SIGNAL + ' Power', "color": "#ddaa00", "shadow": false, "data": ctrl.signalChartData.signal.signalPowerData };
                ctrl.seriesData[0] = { "name": $scope.translation.text.SIGNAL + ' Quality', "color": "#660000", "shadow": false, "data": ctrl.signalChartData.signal.signalQualityData, "yAxis": 1 };
            } else if (ctrl.signalChartData.signal.device.model == 20) {
                $scope.chartData = ctrl.signalChartData.signal.data;
                ctrl.seriesData[0] = { "name": $scope.translation.text.SIGNAL, "color": "#2288cc", "shadow": false, "data": $scope.chartData };
                ctrl.seriesData[1] = { "name": $scope.translation.text.SIGNAL + ' Quality', "color": "#660000", "shadow": false, "data": ctrl.signalChartData.signal.signalQualityData, "yAxis": 1 };
            } else {
                $scope.chartData = ctrl.signalChartData.signal.data;
                ctrl.seriesData[0] = { "name": $scope.translation.text.SIGNAL, "color": "#2288cc", "shadow": false, "data": $scope.chartData };
            }

            $scope.signalConnectivityModel = ctrl.signalChartData.signalConnectivityModel.signalLogConnects;
            if (ctrl.chart && ctrl.chart.series && ctrl.chart.series.length > 0) {
                ctrl.chart.destroy();
            }
            $timeout(function () {
                ctrl._drawChart();
                //if (!$rootScope.mobile && !$rootScope.classicView)
                // $scope.adjustSize();
                //ctrl._chartLoading = false;
            }, 0);
        }
    };
    // when < & > arrow buttons are selected
    ctrl.setReportDate = function (num) {
        //-1: backward, 1: forward
        if (num < 0) {
            //go backward
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeStart.getTime() - 1 * 24 * 60 * 60 * 1000); // setting to previous day
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart.getTime() - 7 * 24 * 60 * 60 * 1000);
        } else {
            //go forward
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeEnd.getTime() + 1 * 24 * 60 * 60 * 1000); // setting to next day
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd.getTime() + 7 * 24 * 60 * 60 * 1000);
        }

        //console.log("chart day clicked --> : st.Dt: " + ctrl.myDateRangeStart + "ed.Dt: " + ctrl.myDateRangeEnd);
        if (new Date(ctrl.myDateRangeStart) > new Date()) {
            ctrl.alerts = [];
            var errorMessage = "Date is out of range";
            ctrl.alerts.push({
                msg: errorMessage,
                type: "info"
            });
            if (ctrl.chart && ctrl.chart.series && ctrl.chart.series.length > 0) {
                ctrl.chart.destroy();
            }
        } else {
            ctrl.getData();

            //Notify calendar to refresh the date range
            $rootScope.$broadcast('onSignalConectChartDateSelect', { start: ctrl.myDateRangeStart, end: ctrl.myDateRangeEnd, deviceId: ctrl.deviceId });
        }
    };

    var adjustButtons = function adjustButtons() {
        var endOfToday = new Date();
        //comparing YYYYMMDD part only (not considering hh:s etc)
        if (new Date(ctrl.myDateRangeEnd.getFullYear(), ctrl.myDateRangeEnd.getMonth(), ctrl.myDateRangeEnd.getDate()) >= new Date(endOfToday.getFullYear(), endOfToday.getMonth(), endOfToday.getDate())) {
            ctrl.disableNextDate = true;
        } else {
            ctrl.disableNextDate = false;
        }
    };
    ctrl._drawChart = function () {
        var tmpData = $scope.chartData;
        var chartDrawn = false;
        var chartToolTipHourFormat = '%l:%M:%S %p';
        $scope.plotBands = [];
        var plotBands = [];

        var i = 0;
        while (i < $scope.signalConnectivityModel.length - 1) {
            plotBands.push({
                from: $scope.signalConnectivityModel[i].start,
                to: new Date($scope.signalConnectivityModel[i + 1].start),
                percentage: $scope.signalConnectivityModel[i].percentage / 100,
                color: $scope.signalConnectivityModel[i].color
            });
            i++;
        }

        ctrl.chart = new Highcharts.Chart({
            chart: {
                renderTo: ctrl.element[0],
                events: {
                    load: function load(event) {
                        // if ($scope.initialLoad) openViewService.adjustContentSize($scope.popup);
                        $scope.initialLoad = false;
                    },
                    redraw: function redraw() {
                        if (ctrl.seriesData.length > 1) {
                            $.each(this.xAxis[0].plotLinesAndBands, function (i, L) {

                                var band = L.svgElem;
                                if (!band) {
                                    return;
                                }
                                var path = band.d.split(' ');
                                var boxY1 = this.axis.chart.yAxis[0].top + this.axis.chart.series[1].yAxis.translate(-60 - 80 * this.options.percentage);
                                var boxY2 = this.axis.chart.yAxis[0].top + this.axis.chart.series[1].yAxis.translate(-60);

                                path[2] = boxY1;
                                path[11] = boxY1;
                                path[5] = boxY2;
                                path[8] = boxY2;
                                band.attr('d', path);
                            });
                        } else {
                            $.each(this.xAxis[0].plotLinesAndBands, function (i, L) {

                                var band = L.svgElem;
                                if (!band) {
                                    return;
                                }
                                var path = band.d.split(' ');
                                var boxY1 = this.axis.chart.yAxis[0].top + this.axis.chart.series[0].yAxis.translate(-60 - 80 * this.options.percentage);
                                var boxY2 = this.axis.chart.yAxis[0].top + this.axis.chart.series[0].yAxis.translate(-60);

                                path[2] = boxY1;
                                path[11] = boxY1;
                                path[5] = boxY2;
                                path[8] = boxY2;
                                band.attr('d', path);
                            });
                        }
                    }
                }
            },
            title: {
                text: "Signal and Connect (" + ctrl.noOfDays + " Days)",
                style: {
                    color: '#6D869F',
                    fontWeight: 'bold',
                    fontSize: "12px"
                }
            },
            credits: {
                enabled: false
            },
            subtitle: {
                text: null
            },
            exporting: {
                enabled: false
            },
            xAxis: {
                plotBands: plotBands,
                gridLineWidth: 1,
                type: 'datetime',
                endOnTick: false,
                showLastLabel: true,
                startOnTick: false,
                ordinal: false,
                slantedText: true,
                labels: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        crosshairs: true
                    },
                    rotation: -50
                },
                tickInterval: 24 * 3600 * 1000,
                dateTimeLabelFormats: {
                    day: '%Y-%m-%d'
                },
                events: {}
            },
            yAxis: [{
                min: -130,
                max: -65,
                title: {
                    text: ctrl.seriesData[0].name == 'Signal' ? $scope.translation.text.SIGNAL + ' (dBm)' : $scope.translation.text.SIGNAL_POWER + ' (dBm)',
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '10px'
                    }
                },
                opposite: ctrl.seriesData[0].name == 'Signal' ? false : true,
                allowDecimals: false,
                showFirstLabel: true,
                showLastLabel: true,
                labels: {
                    align: 'right',
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    },
                    formatter: function formatter() {
                        return this.value;
                    }
                }
                //visible: ctrl.seriesData[0].name == 'Signal' ? true : false
            }, {
                min: -20,
                max: 0,
                title: {
                    text: $scope.translation.text.SIGNAL_QUALITY + ' (db)',
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold',
                        fontSize: '10px'
                    }
                },
                opposite: false,
                allowDecimals: false,
                showFirstLabel: true,
                showLastLabel: true,
                labels: {
                    align: 'right',
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    },
                    formatter: function formatter() {
                        return this.value;
                    }
                },
                visible: ctrl.seriesData.length == 2 ? true : false
            }],
            tooltip: {
                useHTML: false,
                formatter: function formatter() {
                    var s = '';
                    var lastPointIndex = this.points.length - 1;
                    $.each(this.points, function (i, point) {
                        s += point.series.name + ' ' + Highcharts.numberFormat(point.y, 0) + ' dBm ' + ' ' + '<br/><br/>';
                        if (i == lastPointIndex) {
                            s += ' ' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, this.x) + '<br/><br/>';
                        }
                        if ($scope.signalConnectivityModel.length > 0) {
                            var index = $scope.signalConnectivityModel.findIndex(function (x) {
                                return new Date(x.start).getDate() === new Date(point.x).getDate() & new Date(x.start).getMonth() === new Date(point.x).getMonth() & new Date(x.start).getHours() === new Date(point.x).getHours();
                            });
                            if (index >= 0 && i == lastPointIndex) {
                                s += ' ' + $scope.signalConnectivityModel[index].percentage + '% ' + $scope.signalConnectivityModel[index].reconnects + ' reconnects' + '<br/><br/>';
                            }
                        }
                    });
                    return s;
                },
                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            plotOptions: {
                series: [{
                    dataGrouping: {
                        enabled: false
                    },
                    point: {
                        events: {
                            mouseOver: function mouseOver() {
                                xValue = this.x;
                            }
                        }
                    },
                    events: {
                        mouseOut: function mouseOut() {
                            xValue = this.x;
                        }
                    }
                }]
            },
            series: ctrl.seriesData
        });

        $scope.chart = ctrl.chart;

        var tmpNewDateA;
        var tmpNewDateB;
        var extremes = ctrl.chart.xAxis[0].getExtremes();

        if ($scope.stickyProperties.on === true) {
            tmpNewDateA = $scope.stickyProperties.zoomMin >= extremes.dataMin ? $scope.stickyProperties.zoomMin : extremes.dataMin; //extremes.dataMin + $scope.unixDay / 24 * 3;
            tmpNewDateB = $scope.stickyProperties.zoomMax <= extremes.dataMax + $scope.liveDataOffset ? $scope.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - $scope.unixDay / 24 * 3;
            tmpNewDateB = tmpNewDateB >= tmpNewDateA + $scope.unixDay / 24 ? tmpNewDateB : extremes.dataMax - $scope.unixDay / 24 * 12;
            $scope.stickyProperties.on = false;
        } else {
            tmpNewDateA = $scope.myDate !== null ? extremes.dataMin + $scope.unixDay : extremes.dataMax - $scope.unixDay / 24 * 12;
            tmpNewDateB = $scope.myDate !== null ? tmpNewDateA + $scope.unixDay : extremes.dataMax;
            if (tmpNewDateB > extremes.dataMax) {
                tmpNewDateB = extremes.dataMax;
                tmpNewDateA = tmpNewDateB - $scope.unixDay;
            }
            tmpNewDateA = tmpNewDateA + $scope.minPadding;
            tmpNewDateB = tmpNewDateB + $scope.maxPadding;
        }
        chartDrawn = true;
    };

    $scope.$on("$destroy", function () {
        if (ctrl.chart) ctrl.chart.destroy();
    });
}

SignalConnectDataChartController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'timeLapseService', 'datetimeService', '$timeout', '$filter', '$element', 'deviceMenuService', 'SignalConnectDataChartFactory'];
'use strict';

angular.module('mc.signal-connect-data-chart').component('signalConnectDataChart', {
    controller: SignalConnectDataChartController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/signalconnectdatachart/signal-connect-data-chart-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceId: '<',
        signalChartData: '<',
        dateTime: '<'
    }
});
'use strict';

angular.module('mc.sim-transmission-count', []);
'use strict';

function SimTransmissionCountFactory(HOST, $http) {
    function GetSimData(deviceId, startDate, endDate, timeZone) {
        return $http({
            method: 'GET',
            url: HOST + '/api/SimTransmissionCount?deviceId=' + deviceId + '&startDate=' + startDate + '&endDate=' + endDate + '&timeZone=' + timeZone
        });
    }
    return { GetSimData: GetSimData };
}

SimTransmissionCountFactory.$inject = ['HOST', '$http'];

angular.module('mc.sim-transmission-count').factory('SimTransmissionCountFactory', SimTransmissionCountFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SimTransmissionCountController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, SimTransmissionCountFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, $q, savePdfService) {
    var ctrl = this;
    ctrl.viewLoading = true;

    ctrl.$onInit = function () {
        ctrl.reverse = true;
        ctrl.dateChangedCount = 0;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        ctrl.chartId = ctrl.windowId.toUpperCase().replace(/ /g, "_");
        ctrl.alerts = [];
        ctrl.downloadViewTypeOptions = [1];
        ctrl.setDate(0);

        //Resize chart
        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding

                if (ctrl.hasValues) {
                    ctrl.resizeGraph();
                    ctrl.viewLoading = true;
                }
            };
        }
    };

    ctrl.resizeGraph = function () {
        //resize graph / wait .5sec between resize to improve performance and UX
        $timeout.cancel(ctrl.timeOut);
        ctrl.timeOut = $timeout(function () {
            ctrl.drawRateChart();
        }, 500);
    };

    ctrl.getSimData = function () {

        SimTransmissionCountFactory.GetSimData(ctrl.deviceId, ctrl.startDate, ctrl.endDate, ctrl.accountInfo.timeZone).then(function (resp) {

            ctrl.simData = resp.data;
            ctrl.checkDataValues();
            ctrl.alerts = [];

            //If data is available
            if (ctrl.simData.length > 0 && ctrl.hasValues) {
                ctrl.assignDataToDates();
            } else {
                ctrl.createMessage();
            }
        }, function (error) {
            //Error with data / display message to user
            ctrl.createMessage();
        });
    };

    ctrl.checkDataValues = function () {
        //Check if data has values
        for (var i = 0; i < ctrl.simData.length; i++) {
            if (ctrl.simData[i].regsAnalog > 0 || ctrl.simData[i].regsDigital > 0 || ctrl.simData[i].regsStatus > 0) {
                return ctrl.hasValues = true;
            }
        }
        return ctrl.hasValues = false;
    };

    ctrl.createMessage = function () {
        var _msg = eval("ctrl.translation.message.NO_DATA");
        var _type = "info";
        var _languageCode = "NO_DATA";
        _msg += ': ' + moment(ctrl.startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.endDate).utc().format('MM/DD/YY, h:mm:ss a');
        ctrl.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        ctrl.viewLoading = false;
    };

    ctrl.assignDataToDates = function () {
        ctrl.statusData = [];
        ctrl.digitalData = [];
        ctrl.analogData = [];
        var hasValue = void 0;

        var _loop = function _loop(i) {
            //Set boolean at start of loop
            hasValue = false;

            //if day has value push to arrays based on correct index
            ctrl.simData.map(function (sim) {
                if (sim.day == ctrl.numberDaysOfMonth[i] && !hasValue) {
                    ctrl.statusData.push(sim.regsStatus);
                    ctrl.digitalData.push(sim.regsDigital);
                    ctrl.analogData.push(sim.regsAnalog);
                    hasValue = true;
                }
            });
            //if no value push 0
            if (!hasValue) {
                ctrl.statusData.push(0);
                ctrl.digitalData.push(0);
                ctrl.analogData.push(0);
            }
        };

        for (var i = 0; i < ctrl.daysInMonth; i++) {
            _loop(i);
        }
        //Draw Chart with Data
        ctrl.drawRateChart();
    };

    ctrl.selectData = function (varClick) {
        var _tmpStartMonth, _tmpStartYear;
        ctrl.daysInMonth = new Date(ctrl.currentDate.getFullYear(), ctrl.currentDate.getMonth() + 1, 0).getDate();
        ctrl.numberDaysOfMonth = Array.apply(null, { length: ctrl.daysInMonth + 1 }).map(Number.call, Number);
        ctrl.numberDaysOfMonth.shift(); //numberDayOfMonth = {1, 2, 3, 4, 5, 6, 7,..... daysInMonth}. Used for the X-axis.

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;

        //------Date Logic-------
        if (_typeof(ctrl.stickyProperties) !== 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }

        //Assign deviceId based passed in stickProps
        if (ctrl.stickyProperties.device && ctrl.stickyProperties.device.deviceId) {
            ctrl.deviceId = ctrl.stickyProperties.device.deviceId;
        }

        if (varClick) {
            _tmpStartMonth = ctrl.currentDate.getMonth();
            _tmpStartYear = ctrl.currentDate.getFullYear();
        } else if (ctrl.stickyProperties.on === true) {
            ctrl.stickyProperties.on = false;
            _tmpStartMonth = new Date(ctrl.stickyProperties.dateMin).getMonth();
            _tmpStartYear = new Date(ctrl.stickyProperties.dateMin).getFullYear();
            ctrl.currentDate = new Date(_tmpStartYear, _tmpStartMonth, 1);
            ctrl.adjustButtons();
        } else {
            _tmpStartMonth = new Date().getMonth();
            _tmpStartYear = new Date().getFullYear();
            ctrl.currentDate = new Date(_tmpStartYear, _tmpStartMonth, 1);
            ctrl.adjustButtons();
        }
        ctrl.startDate = datetimeService.dateToUnixtime(new Date(_tmpStartYear, _tmpStartMonth, 1));
        ctrl.endDate = datetimeService.dateToUnixtime(new Date(_tmpStartYear, _tmpStartMonth + 1, 0)); //0th day of next month is last day of current month

        //Get data from API
        ctrl.getSimData();
    };

    ctrl.setDate = function (months) {
        ctrl.viewLoading = true;
        if (months === 0) ctrl.currentDate = new Date();
        var d = new Date(ctrl.currentDate || new Date());
        //d.setMonth(d.getMonth() + (months || 0), d.getDate());
        ctrl.currentDate = moment(ctrl.currentDate).add(months, 'months')._d;
        ctrl.adjustButtons();
        ctrl.selectData(true);
    };

    ctrl.adjustButtons = function () {
        if (new Date(ctrl.currentDate.getFullYear(), ctrl.currentDate.getMonth() + 1, 0).getTime() === new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime()) {
            ctrl.todaysDate = true;
            ctrl.nextDate = true;
        } else {
            ctrl.todaysDate = false;
            ctrl.nextDate = false;
        }
    };

    ctrl.drawRateChart = function () {
        var _Highcharts$chart;

        ctrl.dateChangedCount++;
        ctrl.chart = Highcharts.chart("chart" + ctrl.chartId, (_Highcharts$chart = {
            chart: {
                type: 'column'
            },
            credits: {
                enabled: false
            },
            rangeSelector: {
                enabled: false
            },
            navigator: {
                enabled: false
            },
            scrollbar: {
                enabled: false
            },
            title: {
                text: ctrl.translation.text.DATA_USAGE + " (" + ctrl.translation.text.TRANSMISSION_COUNT + ") - SIM"
            },
            plotOptions: {
                column: {
                    groupPadding: 0.5, // Exactly overlap
                    pointWidth: 19
                }
            },
            xAxis: {
                title: {
                    text: ""
                },
                categories: ctrl.numberDaysOfMonth,
                dateTimeLabelFormats: {
                    day: null,
                    week: null
                },
                minRange: null,
                type: 'category',
                labels: {
                    rotation: -45,
                    style: {
                        fontSize: '10px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }

            },
            yAxis: {
                min: 0,
                title: {
                    text: "" + ctrl.translation.text.WR_TOTALMESSAGE
                }
            },
            tooltip: {
                headerFormat: '<div style="font-size:14px; width: 200px;"><b>' + ctrl.translation.text.DAY_CAP + ' {point.key}</b></div><table>',
                pointFormatter: function pointFormatter() {
                    var s = '<tr><td style="font-size:13px; color: ' + this.series.color + ';">' + this.series.name + ' ' + this.y + '</td></tr>';
                    return s;
                },
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                backgroundColor: 'white'
            }
        }, _defineProperty(_Highcharts$chart, "plotOptions", {
            column: {
                stacking: 'normal'
            }
        }), _defineProperty(_Highcharts$chart, "series", [{
            name: "RTU " + ctrl.translation.text.STATUS,
            data: ctrl.statusData,
            color: '#58D549',
            zIndex: 3,
            showInLegend: true
        }, {
            name: "" + ctrl.translation.text.DIGITAL,
            data: ctrl.digitalData,
            color: '#FEE101',
            zIndex: 2,
            showInLegend: true
        }, {
            name: "" + ctrl.translation.text.ANALOG,
            data: ctrl.analogData,
            color: 'rgb(124,181,236)',
            zIndex: 1,
            showInLegend: true
        }]), _Highcharts$chart));
        ctrl.viewLoading = false;
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.resizeGraph();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.resizeGraph();
    });
}

SimTransmissionCountController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'SimTransmissionCountFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', 'savePdfService'];
'use strict';

angular.module('mc.sim-transmission-count').component('simTransmissionCount', {
    controller: SimTransmissionCountController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/simtransmissioncount/sim-transmission-count-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceId: '<'
    }
});
mcapp.factory("signalConnectService", ["$http", "authenticationService", "HOST", function ($http, authenticationService, HOST) {
    var signalConnectFactory = {};

    var _getListSignalConnect = function (customerId, timeZone) {
        var self = this;
        return $http({
            method: 'Get',
            url: HOST + '/api/SignalConnect?customerId=' + customerId + '&timeZone=' + timeZone
        });
    };

    //Fetch Signal Connect Data for last 7 days from date provided for given customer.
    var _getListSignalConnectByDate = function (customerId, timeZone, stDateUnix, endDateUnix) {
        var self = this;
        return $http({
            method: 'Get',
            url: HOST + '/api/SignalConnect?customerId=' + customerId + '&timeZone=' + timeZone + '&startDate=' + stDateUnix + '&endDate=' + endDateUnix
        });
    };
    //Fetch Signal Connect Data for last 7 days from date provided for given customer.
    var _getSignalConnectModelByDate = function(customerId, timeZone, stDateUnix, endDateUnix) {
        var self = this;
        return $http({
            method: 'Get',
            url: HOST + '/api/SignalConnect/GetSignalConnectGeneralListByDate?customerId=' + customerId + '&timeZone=' + timeZone + '&startDate=' + stDateUnix + '&endDate=' + endDateUnix
        });
    };
    //Fetch Signal Connect Data by DeviceId and Date range.
    var _getListSignalConnectByDeviceId = function (customerId, deviceId, timeZone, stDateUnix, endDateUnix) {
        var self = this;
        return $http({
            method: 'Get',
            url: HOST + '/api/SignalConnect?customerId=' + customerId + '&deviceId=' + deviceId+ '&timeZone=' + timeZone + '&startDate=' + stDateUnix + '&endDate=' + endDateUnix
        });
    };
    signalConnectFactory.getListSignalConnect = _getListSignalConnect;
    signalConnectFactory.getListSignalConnectByDate = _getListSignalConnectByDate;
    signalConnectFactory.getSignalConnectModelByDate = _getSignalConnectModelByDate;
    signalConnectFactory.getListSignalConnectByDeviceId = _getListSignalConnectByDeviceId;

    return signalConnectFactory;
}
]);
'use strict';

angular.module('mc.signal-connect', []);
'use strict';

function SignalConnectController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, LoginsFactory, $uibModal, $element, $timeout, datetimeService, savePdfService, signalConnectService, toaster, websocketService) {

    var ctrl = this;
    ctrl.action = "init"; // there are two actions "init" or "date" --> init: initial load or refresh load; date: load on date selection
    ctrl.broadcastToChildren = true;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;

    ctrl.isElementVisible = function (el) {

        //console.log(ctrl.element[0].scrollTop);
        //console.log(el.offsetTop);
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.element = $element.find('.tabular-data-container');
        } else {
            ctrl.element = $element.find('.tabular-data-container-mobile');
        }

        var _element = document.getElementById(el);

        var v = Math.abs(_element.offsetTop - ctrl.element[0].scrollTop);

        if (v <= 3000) {
            return true;
        } else {
            return false;
        }
    };

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.myModalTemplate = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = true;
        ctrl.selectedDevices = [];
        getSignalConnectDataModel();
        //getSignalConnectData();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });
            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    $scope.adjustSize();
                }
            });
        }
    };

    $scope.adjustSize = function () {
        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
    };

    //following method is used when top-menu refresh button is clicked
    ctrl.mostRecentData = function () {
        $scope.alerts = [];
        ctrl.broadcastToChildren = true;

        ctrl.action = "init";
        ctrl.myDate = new Date();

        toaster.pop('success', $scope.windowTitle, 'View reloading');
        //ctrl.unRegisterListeners();
        $scope.$broadcast('updateSignalConnectDeviceList');

        //getSignalConnectData();
        getSignalConnectDataModel();
    };

    //NEW this method is called during init & refresh scenarios
    var getSignalConnectDataModel = function getSignalConnectDataModel() {
        if (!ctrl.broadcastToChildren) return;
        ctrl._loading = true;

        ctrl.myDateRangeEnd = new Date();
        ctrl.myDateRangeStart = new Date(ctrl.myDateRangeEnd.getTime() - 6 * 24 * 60 * 60 * 1000); // dates range is 7 days (includes start & end dates), end date = start date = 6 days

        var stDateUnix = datetimeService.dateToUnixtime(ctrl.myDateRangeStart);
        var endDateUnix = datetimeService.dateToUnixtime(ctrl.myDateRangeEnd);
        getSignalConnectModelByDate(stDateUnix, endDateUnix);
    };

    //OLD this method is called during init & refresh scenarios
    //var getSignalConnectData = () => {
    //    if (!ctrl.broadcastToChildren) return;
    //    ctrl._loading = true;
    //    //this call fetches signalconnect duration data
    //    signalConnectService.getListSignalConnect(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone).then(
    //        function (response) {
    //            ctrl.SignalConnectivityData = response.data;
    //            ctrl.mapSignalConnectivityData();

    //            ctrl._loading = false;
    //        });
    //};

    //following method is used when top-menu calendar Date selection is made
    var getListSignalConnectDurationDataByDate = function getListSignalConnectDurationDataByDate(stDateUnix, endDateUnix) {
        //ctrl._loading = true;
        //signalConnectService.getListSignalConnectByDate(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone, stDateUnix, endDateUnix).then(function (response) {
        //    ctrl.SignalConnectivityData = response.data;

        //    // display NO DATA message
        //    if (ctrl.SignalConnectivityData.length === 0) {
        //        $scope.alerts = [];
        //        $scope.alerts.push({
        //            msg: "No Data to display",
        //            type: "info"
        //        });
        //    }

        //    ctrl.mapSignalConnectivityData();

        //    ctrl._loading = false;
        //});

        //getSignalConnectModelByDate(stDateUnix, endDateUnix);
    };
    //following method is used to fetch device specific date
    var fetchAndLoadSignalConnectDurationDataByDevice = function fetchAndLoadSignalConnectDurationDataByDevice(deviceId, stDateUnix, endDateUnix) {
        //ctrl._loading = true;
        signalConnectService.getListSignalConnectByDeviceId(ctrl.accountInfo.customerId, deviceId, ctrl.accountInfo.timeZone, stDateUnix, endDateUnix).then(function (response) {
            ctrl.deviceSignalConnectivityData = response.data[0];

            mapDeviceSignalConnectivityData();

            //ctrl._loading = false;
        });
    };

    $scope.$on('ngRepeatFinished', function (event, opt) {
        //we are broadcasting to enable other components (chart & calendar) to fetch and load the data
        // there are two actions "init" or "date" --> init: initial load or refresh load; date: load on date selection
        if (ctrl.broadcastToChildren) {
            $scope.$broadcast('onSignalConnectDateSelect', { action: ctrl.action, startDate: ctrl.myDateRangeStart, endDate: ctrl.myDateRangeEnd });
            ctrl.dateTime = { startDate: ctrl.myDateRangeStart, endDate: ctrl.myDateRangeEnd };
        }
    });

    // when calendar component date is selected
    $rootScope.$on('onSignalConectCalendarDateSelect', function (event, opt) {

        ctrl.broadcastToChildren = false;
        var stDateUnix = datetimeService.dateToUnixtime(opt.start);
        var endDateUnix = datetimeService.dateToUnixtime(opt.end);
        fetchAndLoadSignalConnectDurationDataByDevice(opt.deviceId, stDateUnix, endDateUnix);
    });
    // when Chart component date is selected
    $rootScope.$on('onSignalConectChartDateSelect', function (event, opt) {
        ctrl.broadcastToChildren = false;
        var stDateUnix = datetimeService.dateToUnixtime(opt.start);
        var endDateUnix = datetimeService.dateToUnixtime(opt.end);
        fetchAndLoadSignalConnectDurationDataByDevice(opt.deviceId, stDateUnix, endDateUnix);
    });

    //NOTE: could not find any valid references to this function
    ctrl.mapSignalConnectivityData = function () {
        ctrl.SignalConnectivityData.map(function (device) {

            //Assign Logo for wirelessCarrier
            device.wirelessCarrierLogo = device.wirelessCarrier == "Verizon" ? "images/Verizon-Logo.png" : device.wirelessCarrier == "AT&T" ? "images/AT&T-Logo.png" : "images/Telenor-Logo.png";

            //Format Dates
            device.data.map(function (data) {
                data.connect = moment('' + data.connect).format('DD MMM YYYY, h:mm:ss a');
                if (data.disconnect) {
                    data.disconnect = moment('' + data.disconnect).format('DD MMM YYYY, h:mm:ss a');
                } //else {
                //    data.timeRange = null;
                //}
            });
        });
    };

    var mapDeviceSignalConnectivityData = function mapDeviceSignalConnectivityData() {
        ctrl.SignalConnectivityModel.map(function (signalConnect) {
            if (signalConnect.deviceSignalConnectList.deviceId == ctrl.deviceSignalConnectivityData.deviceId) {
                ctrl.deviceSignalConnectivityData.data.map(function (data) {
                    data.connect = moment('' + data.connect).format('DD MMM YYYY, h:mm:ss a');
                    if (data.disconnect) {
                        data.disconnect = moment('' + data.disconnect).format('DD MMM YYYY, h:mm:ss a');
                    } //else {
                    //    data.timeRange = null;
                    //}
                });

                signalConnect.deviceSignalConnectList.data = ctrl.deviceSignalConnectivityData.data;
            }
        });
    };

    ctrl.durationDataTableHeightCheck = function (i) {
        var tableHeight = $(".duration-data-table")[i];
        if ($(tableHeight).height() > 320) {
            return true;
        }
    };

    ctrl.hasOverflow = function () {
        var element = document.getElementById('useraccount-rows');
        if (element.offsetHeight < element.scrollHeight) {
            return true;
        }
        return false;
    };

    ctrl.openCommonModal = function (item, deleteUser) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            if (deleteUser) {
                this.tmpConfirmMessageA = this.translation.text.DELETE_ACCOUNT_MESSAGE_A + item.fullName + this.translation.text.DELETE_ACCOUNT_MESSAGE_B;
            } else {
                this.tmpConfirmMessageA = this.translation.text.READONLY_ACCOUNT_MESSAGE_A + item.fullName + this.translation.text.READONLY_ACCOUNT_MESSAGE_B;
            }
            this.tmpConfirmMessageB = this.translation.text.DELETE_ACCOUNT_MESSAGE_C;
            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                if (!deleteUser) {
                    var index = ctrl.logins.findIndex(function (l) {
                        return l.userId == item.userId;
                    });
                    ctrl.logins[index].administrator = true;
                }

                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            if (deleteUser) {
                var _loginsFactory = new LoginsFactory(ctrl.accountInfo.customerId);
                _loginsFactory.delete(item.userId, item.userName).then(function (resp) {
                    var index = ctrl.logins.indexOf(item);
                    if (index !== -1) {
                        ctrl.logins.splice(index, 1);
                    }
                    ctrl.addMode = null;
                    ctrl.editMode = null;
                });
            } else {

                var propertyName = 'administrator';
                ctrl.updateValue(item, propertyName);
            }
        }, function () {
            // cancel button
        });
    };

    // this method is called when top-menu calendar Date is selected
    ctrl.selectMyDate = function () {
        ctrl.action = "date";
        //var unixDate = datetimeService.dateToUnixtime(ctrl.myDate);

        //logic for date range values (start and end date)
        ctrl.myDateRangeStart = ctrl.myDate;
        ctrl.myDateRangeEnd = new Date(ctrl.myDate.getTime() + 6 * 24 * 60 * 60 * 1000); // dates range is 7 days (includes start & end dates), end date = start date = 6 days

        var stDateUnix = datetimeService.dateToUnixtime(ctrl.myDateRangeStart);
        var endDateUnix = datetimeService.dateToUnixtime(ctrl.myDateRangeEnd);

        //validate if date range is after today, if YES, then reset end date to today
        var today = new Date();
        if (ctrl.myDateRangeEnd > today) {
            //then set end date as today 11:59PM midnight
            endDateUnix = today.setHours(23, 59, 59, 0);
            ctrl.myDateRangeEnd = today;
        }

        //getListSignalConnectDurationDataByDate(stDateUnix, endDateUnix);

        //NEW
        ctrl.broadcastToChildren = true;
        getSignalConnectModelByDate(stDateUnix, endDateUnix);
        return;
    };

    // NEW: this method is called during init & refresh scenarios
    var getSignalConnectModelByDate = function getSignalConnectModelByDate(stDateUnix, endDateUnix) {
        //if (!ctrl.broadcastToChildren) return;
        ctrl._loading = true;
        //this call fetches signalconnect duration data
        signalConnectService.getSignalConnectModelByDate(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone, stDateUnix, endDateUnix).then(function (response) {
            //$timeout(() => {
            ctrl.SignalConnectivityModel = response.data;
            mapSignalConnectivityModel();
            ctrl.setDevicesSelected(ctrl.selectedDevices);

            ctrl._loading = false;
            //ctrl.registerListeners();
            //});
        });
    };

    //NEW
    var mapSignalConnectivityModel = function mapSignalConnectivityModel() {
        ctrl.SignalConnectivityModel.map(function (signalConnect) {

            //Assign Logo for wirelessCarrier
            signalConnect.deviceSignalConnectList.wirelessCarrierLogo = signalConnect.deviceSignalConnectList.wirelessCarrier == "Verizon" ? "images/Verizon-Logo.png" : signalConnect.deviceSignalConnectList.wirelessCarrier == "AT&T" ? "images/AT&T-Logo.png" : "images/Telenor-Logo.png";

            //Format Dates
            signalConnect.deviceSignalConnectList.data.map(function (data) {
                data.connect = moment('' + data.connect).format('DD MMM YYYY, h:mm:ss a');
                if (data.disconnect) {
                    data.disconnect = moment('' + data.disconnect).format('DD MMM YYYY, h:mm:ss a');
                } //else {
                //    data.timeRange = null;
                //}
            });
        });
    };

    //New 
    //Get Devices Selected called via device-list directive
    ctrl.setDevicesSelected = function (deviceIds) {
        ctrl.selectedDevices = deviceIds;
        if (typeof ctrl.SignalConnectivityModel !== 'undefined') {
            for (var i = 0; i < ctrl.SignalConnectivityModel.length; i++) {
                ctrl.SignalConnectivityModel[i].hideRow = false;
                if (ctrl.selectedDevices.indexOf(ctrl.SignalConnectivityModel[i].deviceSignalConnectList.deviceId) == -1) {
                    ctrl.SignalConnectivityModel[i].hideRow = true;
                    //ctrl.filteredSignalConnectivityModel.push(ctrl.SignalConnectivityModel[i]);
                }
            }
        }
    };

    //ctrl.registerListeners = () => {
    //    websocketService.connect();
    //    for (var i = 0; i < ctrl.SignalConnectivityModel.length; i++) {
    //        websocketService.register("DEVICEBASICINFO", ctrl.SignalConnectivityModel[i].deviceSignalConnectList.serialNumber, 0, ctrl.wsDataReceivedRTUBASICINFOSETTING, null);
    //    }        
    //    websocketService.startOverview();
    //};

    //ctrl.unRegisterListeners = () => {
    //    for (var k = 0; k < ctrl.SignalConnectivityModel.length; k++) {
    //        websocketService.unRegister("DEVICEBASICINFO", ctrl.SignalConnectivityModel[k].deviceSignalConnectList.serialNumber, 0, ctrl.wsDataReceivedRTUBASICINFOSETTING, null);
    //    }        
    //    websocketService.stopOverview();
    //};

    //$scope.$on("$destroy", function () {
    //    ctrl.unRegisterListeners();
    //});

    //ctrl.wsDataReceivedRTUBASICINFOSETTING = (data) => {
    //    if (data.Type == 'DEVICEBASICINFO') {
    //        for (var i = 0; i < ctrl.SignalConnectivityModel.length; i++) {
    //            if (ctrl.SignalConnectivityModel[i].deviceSignalConnectList.serialNumber == data.SN && data.Value.path == "name") {
    //                ctrl.SignalConnectivityModel[i].deviceSignalConnectList.deviceName = data.Value.value;
    //            }
    //        }
    //    }
    //};

    $scope.$on("$destroy", function () {
        ctrl.SignalConnectivityModel = undefined;
        $scope.$destroy();
    });
}

SignalConnectController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'LoginsFactory', '$uibModal', '$element', '$timeout', 'datetimeService', 'savePdfService', 'signalConnectService', 'toaster', 'websocketService'];
'use strict';

angular.module('mc.signal-connect').component('signalConnect', {
    controller: SignalConnectController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/signalconnect/signal-connect-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.controller("searchCustomerController", ["$scope", "$rootScope", "$http", "authenticationService", "translationService", "sharedSetupService", "openViewService", "toaster", "searchCustomerService", "$element",
function ($scope, $rootScope, $http, authenticationService, translationService, sharedSetupService, openViewService, toaster, searchCustomerService, $element) {
    $scope.translation = translationService.translation;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.selectedCustomerId = null;
    $scope.searchCustomerBusy = false;
    $scope.alerts = [];
    $scope.editModeId = 0;
    $scope.checkBoxBeforeChange = null;
    $scope.newViewTxt = '';
    $scope.fieldNameToSearch = 'name';
    $scope.alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    $scope.mcSetFocusHide = true;
    $scope.searchType = false;
    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
				openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.filterCustomer = function (varLetter) {
            return false;
            $scope.popup.parent().find('span').removeClass("alphabet-selected");
            $scope.popup.parent().find('.' + varLetter).addClass("alphabet-selected");
            $scope.searchCustomers = $scope.searchCustomersAll.filter(function (el) {
                if (varLetter == "A")
                    return el.name.toUpperCase().indexOf(varLetter) == 0 || !isNaN(parseInt(el.name.charAt(0)));
                return el.name.toUpperCase().indexOf(varLetter) == 0;
            });
            $scope.popup.parent().find('.input-group-addon').html('<i class="fa fa-filter"></i> <span style="font-weight: bold;">' + varLetter + '...</span>');
        };

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.search_customer_div').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 20); //25: total padding
        };
    }

}]);

mcapp.directive('searchCustomerDropdown', ['$rootScope', '$location', 'websocketService', 'searchCustomerService', 'adminAccessService', 'desktopViewService', 'toaster', '$window', '$timeout', 'authenticationService',
    function ($rootScope, $location, websocketService, searchCustomerService, adminAccessService, desktopViewService, toaster, $window, $timeout, authenticationService) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.needSearchBox = true; //display search box
            scope.$ctrl = scope;
            scope.mcSetFocusHide = false;

            scope.$ctrl.searchFieldChanged = function(t) {
                if (typeof t === 'undefined' || (typeof t !== 'undefined' && t.search.name.length < 4)) {
                    scope.searchCustomersAll = null;
                    scope.searchCustomers = null;
                }
                else {
                    scope.getCustomers(t.search.name, scope.searchType);
                }
            };

            scope.powerSarchChanged = function (p) {
                scope.searchType = p.powerSearch;
                if (typeof scope.search !== 'undefined' && typeof scope.search.name !== 'undefined' && scope.search.name.length > 3) {
                    scope.getCustomers(scope.search.name, p.powerSearch);
                }
                else {
                    scope.searchCustomersAll = null;
                    scope.searchCustomers = null;
                }
            };

            scope.getCustomers = function (searchQuery, searchType) {
                scope.alerts =[];
                scope.searchCustomersAll = null;
                scope.searchCustomers = null;
                scope.searchCustomerBusy = true;
                searchCustomerService.getData(searchQuery, searchType)
                .then(function (response) {
                    scope.mcSetFocusHide = false;
                    $timeout(function () {
                        if (!$rootScope.mobile && !$rootScope.classicView) scope.popup.parent().find('input[focus-on=mcSetFocus]').focus(); //firefox issue
                    }, 300);
                    scope.$broadcast('mcSetFocus');
                    scope.searchCustomersAll = response.data;
                    scope.searchCustomers = response.data;
                    //scope.filterCustomer("A");
                    scope.selectedCustomerId = response.data.length > 0 ? scope.searchCustomersAll[0].customerId : scope.selectedCustomerId;
                    scope.searchCustomerBusy = false;

                    if (scope.searchCustomers.length === 0) {
                        var errorMessage = scope.translation.message.NO_RESULTS_FOUND;
                        scope.alerts.push({ msg: errorMessage, type: "info" });
                    }
                },
                function (error) {
                    scope.searchCustomerBusy = false;
                    var errormsg = eval("scope.translation.message." + error.message);
                    scope.alerts.push({ msg: errormsg, type: "danger" });
                    toaster.pop('error', scope.windowTitle, errormsg);
                });
            };

            //searchCustomerService.getData()
            //.then(function (result) {
            //    scope.mcSetFocusHide = false;
            //    $timeout(function () {
            //        if(!$rootScope.mobile) scope.popup.parent().find('input[focus-on=mcSetFocus]').focus(); //firefox issue
            //    }, 300);
            //    scope.$broadcast('mcSetFocus');
            //    scope.searchCustomersAll = data;
            //    //scope.filterCustomer("A");
            //    scope.selectedCustomerId = data.length > 0 ? scope.searchCustomersAll[0].customerId : scope.selectedCustomerId;
            //    scope.searchCustomerBusy = false;
            //},function (error) {
            //    scope.searchCustomerBusy = false;
            //    var errormsg = eval("scope.translation.message." + error.message);
            //    scope.alerts.push({ msg: errormsg, type: "danger" });
            //    toaster.pop('error', scope.windowTitle, errormsg);
            //});

            element.on(
                       "click.searchCustomerOpenDropdown",
                       "span",
                       function (event) {
                           event.preventDefault();
                           var localScope = $(event.target).scope();
                           if (typeof localScope == 'undefined')
                               return true;
                           localScope.$apply(
                               function () {
                                   var varActionName = $(event.currentTarget).attr("action-name");
                                   switch (varActionName) {
                                       case "Login":
                                           scope.selectedCustomerId = $(event.currentTarget).parent().closest('li').attr("customer-id");
                                               adminAccessService.getData(scope.selectedCustomerId)
                                               .then(function (response) {
                                                   desktopViewService.closeAllViews();
                                                   websocketService.close();
                                                   $rootScope.adminUserName = "mission";
                                                   $rootScope.adminPassword = response.data.accessId;
                                                   authenticationService.setAuthorizationInfoNull();
                                                   authenticationService.setAccountInfoNull();
                                                   $location.path("/account/userlogin");
                                                   $rootScope.CustomerNameStart = "";
                                                   scope.accountInfo = null;
                                                   $rootScope.login = false;
                                                   $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
                                                   $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
                                                   $rootScope.logoSizeId = $rootScope.defaultFontAndColorId;
                                                   $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
                                                   authenticationService.logout()
                                                  .then(function (result) {
                                                    $location.path("/account/userlogin");
                                                    $timeout(function () {
                                                      $rootScope.$broadcast('switchedCustomers');
                                                    }, 1000);

                                                  }, function (error) {
                                                    $window.alert("logout error");
                                                    console.log(error);
                                                  });
                                                   return true;
                                               },
                                               function (error) {
                                                   scope.selectedCustomerId = null;
                                                   return false;
                                               });
                                           break;
                                       default:
                                           return;
                                   }
                               }
                           );
                       }
                   );

             scope.$on(
                       "$destroy",
                       function (event) {
                           element.off("click.searchCustomerOpenDropdown");
                       }
                   );

            // scope.$watch('search', function (newValue, oldValue) {
            //        if (!newValue || newValue.name.length < 4) {
            //            scope.searchCustomers = null;
            //            return;
            //        }
            //            scope.searchCustomers = scope.searchCustomersAll.filter(function (el) {
            //                return el.name.toUpperCase().indexOf(newValue.name.toUpperCase()) >= 0;
            //            });
            //}, true);
        }
    };
}]);

mcapp.factory('searchCustomerService', ['$http', 'HOST', function ($http, HOST) {
    var searchCustomerFactory = {};

    var _getData = function (searchQuery, powerSearch) {
        return $http({
            method: 'Get',
            url: HOST + '/api/SearchCustomer?searchQuery=' + encodeURIComponent(searchQuery) + '&powerSearch=' + powerSearch + '&' + new Date().getTime(),
            cache: false
        });
    };

    searchCustomerFactory.getData = _getData;
    return searchCustomerFactory;
}]);

mcapp.factory('adminAccessService', ['$http', 'HOST', function ($http, HOST) {
    var adminAccessFactory = {};

    var _getData = function (customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/AdminAccess?customerID=' + customerId + "&" + new Date().getTime(),
            cache: false
        });
    };

    adminAccessFactory.getData = _getData;
    return adminAccessFactory;
}]);

(function() {

    angular.module('sampleModule', [])
        .factory('sampleService', SampleService);

    SampleService.$inject = ['$http', '$q'];

    function SampleService($http, $q) {

        function getPeople() {

            var url = "/app/api/people";
            return $http.get(url).then(function(result) {
                for (var i=0; i<result.data.length; i++) {
                    var obj = result.data[i];
                    obj.fullName = obj.firstName + " " + obj.lastName;
                }
                return result.data;
            });
        }

        return {
            getPeople: getPeople
        }
    }

})();
/* This module is mainly for introducing unit testing with mocha
* */
(function() {

    angular.module('sampleModule', []);

})();
(function() {

    angular.module('sampleModule', [])
        .controller('sampleController', SampleController)

    function SampleController() {

        this.songs = [];
        this.getFullName = function() {
            return this.firstName + " " + this.lastName;
        }

        this.addSong = function(song) {
            this.songs.push(song);
        }

    }

})();
"use strict";

angular.module("mc.runtime-data", []);
'use strict';

function RuntimeDataFactory(HOST, $http) {
    var RuntimeDataFactory = {};
    var _get72HoursData = function _get72HoursData(customerId, deviceId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/PumpTable/Get72Hours/' + "?customerId=" + customerId + "&deviceId=" + deviceId,
            cache: false
        });
    };
    RuntimeDataFactory.get72HoursData = _get72HoursData;
    return RuntimeDataFactory;
}

RuntimeDataFactory.$inject = ['HOST', '$http'];

angular.module('mc.runtime-data').factory('RuntimeDataFactory', RuntimeDataFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RuntimeDataController($, $rootScope, $scope, $timeout, $sce, sharedSetupService, openViewService, translationService, authenticationService, RuntimeDataFactory, deviceMenuService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.searchBusy = false;
    $scope.needSearchBox = true; //display search box
    var toolTipTimer = void 0;
    var toolTipWaitTime = 1000;
    var requestCounter = 0; // Track API request order
    ctrl.runtimeDataList = [];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        ctrl.isAdmin = sharedSetupService.isAdmin(ctrl.accountInfo);
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        $scope.stickyProperties = ctrl.stickyProperties;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(_this2);
        ctrl.initializeSetting();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        };
    };

    ctrl.adjustSize = function () {
        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
    };

    ctrl.initializeSetting = function () {
        ctrl.searchBusy = true;
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.devices = result.data.devices;
            var myDroDevices = [];
            for (var i = 0; i < ctrl.devices.length; i++) {
                if (ctrl.devices[i].model === 5 || ctrl.devices[i].model === 8 || ctrl.devices[i].model === 9 || ctrl.devices[i].model === 17 || ctrl.devices[i].model === 18 || ctrl.devices[i].model === 19 || ctrl.devices[i].model === 21 || ctrl.devices[i].model === 17) {
                    ctrl.devices[i].showDispatch = false;
                    myDroDevices.push(ctrl.devices[i]);
                }
            }
            ctrl.devices = myDroDevices;
            ctrl.searchBusy = false;
        }, function (error) {
            ctrl.searchBusy = false;
        });
    };

    ctrl.toggleDispatch = function (device) {
        ctrl.showDispatchData = false; //Showing loading message before new data fetch
        var data = ctrl.devices;
        // If the current device is open, close it
        if (device.showDispatch) {
            device.showDispatch = false;
        } else {
            // Cancel any ongoing timeout
            if (toolTipTimer) {
                $timeout.cancel(toolTipTimer);
            }
            // Otherwise, close all devices and open the selected one
            data.forEach(function (item) {
                item.showDispatch = false;
            });

            // Increment request counter before making a new request
            var currentRequest = ++requestCounter;
            toolTipTimer = $timeout(function () {
                RuntimeDataFactory.get72HoursData(ctrl.accountInfo.customerId, device.deviceId).then(function (resp) {
                    // Ensure only the latest request updates the UI
                    if (currentRequest === requestCounter) {
                        ctrl.runtimeDataList = resp.data;
                        var processedData = processData(resp.data.pumpMeasurements);
                        ctrl.selectedDeviceData = Object.keys(processedData).length == 0 ? null : processedData;

                        for (var i = 0; i < ctrl.runtimeDataList.setting.length; i++) {
                            //logic to determine whether it is Multiple or Simultaneous column
                            //if device is 800 series, channel 8 as Alarm (inputMode = 'A') --> Multiple
                            //OR all other devices (mostly 100 series), channel 3 description as 'both' --> Simultaneous
                            if ([5, 9, 19].indexOf(resp.data.device.type) > -1 && ctrl.runtimeDataList.setting[i].channel === 8 && ctrl.runtimeDataList.setting[i].digitalMode === 'A') ctrl.runtimeDataList.setting[i].description = ctrl.translation.text.MULTIPLE;else if (ctrl.runtimeDataList.setting[i].channel === 3 && ctrl.runtimeDataList.setting[i].description === 'both') ctrl.runtimeDataList.setting[i].description = ctrl.translation.text.SIMULTANEOUS;
                        }
                        ctrl.showDispatchData = true;
                    }
                });
            }, toolTipWaitTime);

            $timeout(function () {
                device.showDispatch = true;
            });
        }

        // Update the overview data after changes
        $timeout(function () {
            ctrl.devices = data;
        });
    };

    function processData(entries) {
        var result = {};
        entries.forEach(function (entry) {
            // Extract the date (YYYY-MM-DD) from localDateTime
            var dateKey = entry.localDateTimeStart.split("T")[0] + "T00:00:00";
            // If the date key doesn't exist, initialize it
            if (!result[dateKey]) {
                result[dateKey] = [];
            }
            // Push entry into the respective date array
            result[dateKey].push(entry);
        });
        return result;
    }

    ctrl.getTotalMinutesBasedOnCol = function (entries, index) {
        var result = entries.reduce(function (sum, row) {
            return sum + (row.runtime[index].value || 0);
        }, 0); // Initialize sum as 0
        return result;
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {});

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
    });
};

RuntimeDataController.$inject = ['$', '$rootScope', '$scope', '$timeout', '$sce', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'RuntimeDataFactory', 'deviceMenuService'];
'use strict';

angular.module('mc.runtime-data').component('runtimeData', {
    controller: RuntimeDataController,
    templateUrl: 'ui/runtimedata/runtimedata-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.controller("rtuViewController", ["$scope", "$q", "$timeout", "$rootScope", "sharedSetupService", "openViewService", "authenticationService", "translationService", "datetimeService", "$filter", "rtuDataService", "websocketService", "$window", 'timeLapseService', '$location', '$cookies', 'toaster', 'relaysSettingService', 'commandOptionsService', 'pageRequestsService', 'deviceMenuService', 'CommandOptionsFactory', '$interval', '$element',
    function ($scope, $q, $timeout, $rootScope, sharedSetupService, openViewService, authenticationService, translationService, datetimeService, $filter, rtuDataService, websocketService, $window, timeLapseService, $location, $cookies, toaster, relaysSettingService, commandOptionsService, pageRequestsService, deviceMenuService, CommandOptionsFactory, $interval, $element) {
        sharedSetupService.getWindowId($scope);
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.alerts = [];
        $scope.topMenuMarginLeft = $rootScope.mobile ? '-206px' : '-240px';
        $scope.downloadViewTypeOptions = [4];
        $scope.Channel = [];
        $scope.analogData = [];
        $scope.rtuData = [];
        $scope.translation = translationService.translation;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.isPublicUser = $scope.accountInfo.userRole.indexOf("PublicUser") > -1 ? true : false;
        $scope.restrictedRelayAccess = $scope.accountInfo.userRole.indexOf("PublicUser") > -1 ||
            $scope.accountInfo.userRole.indexOf("User") > -1 ||
            $scope.accountInfo.userRole.indexOf("AlarmUser") > -1;
        $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
        $scope.rtuAnalog = null;
        $scope.rtuAnalogOutput = null;
        $scope.rtuDigital = null;
        $scope.windowId = $scope.windowId || 'RTU View';
        $scope.isMcAdmin = $cookies.get('AdminInfo') != null ? true : false;
        //This is the Device ID for the PC3000X going to WEFTEC ID=43611
        $scope.pc3000Value = 43611;
        //Test Device
        $scope.pc3000ValueII = 43390;//38746;//43390;//38741;
        $scope.analogIIIData = null;
        $scope.relays = [];
        $scope.commandOptions = [];
        $scope.CommandOptionsFactory = new CommandOptionsFactory();
        $scope.errorMessage = $scope.translation.text.PAGE_IS_DEFERRED_UNTIL_DEVICE_IS_ONLINE + ' ' + $scope.deviceSelectedName + ' ' + 'as device is currently offline. This command will be queued for 3 days.';
        $scope.refreshRTUView = false;
        $scope.pulseFlowCount = 0;
        $scope.mobileSavedDesktop = $location.path().indexOf("/saveddesktop/saved-desktop-view") > -1;
        $scope.analogSection = false;
        $scope.analogOutputSection = false;
        $scope.relaySection = false;
        $scope.rtuDataSection = false;

        $scope.setHasAdamsRelayModule = function (varHasAdamsRelayModule) {
            $scope.hasAdamsRelayModule = varHasAdamsRelayModule;
        };

        $scope.setEbpcPurchased = function (varEbpcPurchased) {
            $scope.ebpcPurchased = varEbpcPurchased;
        };

        $scope.setsoftwareVersion = function (varSoftwareVersion) {
            $scope.softwareVersion = varSoftwareVersion;
        };

        sharedSetupService.broadcastAllDeviceSelected($scope);       

        $scope.currentTime = 0;
        var setTimestamp = function (data) {
            $scope.currentTime = moment(data.localDateTime).valueOf();
        };

        timeLapseService.getLocalDateTime().then(function (resp) {
            $scope.currentTime = moment(resp.data.localDateTime).valueOf();
        });

        timeLapseService.registerLocal('DEVICE_ONLINE', null, null, setTimestamp);

        $scope.isButtonDisabled = false; // Initially, the button is enabled
        $scope.countdown = 0;
        $scope.buttonText = "Click Me";

        $scope.mostRecentData = function () {
            // Disable the button immediately
            $scope.isButtonDisabled = true;
            $scope.buttonText = "Wait...";
            $scope.countdown = 30; // Set the initial countdown time

            // Re-enable the button after 30 seconds
            $timeout(function () {
                $scope.isButtonDisabled = false;
                $scope.countdown = 0;
            }, 30000); // 30000 milliseconds = 30 seconds

            // Optional: Update the countdown timer every second
            var countdownInterval = $interval(function () {
                if ($scope.countdown > 0) {
                    $scope.countdown--;
                } else {
                    $interval.cancel(countdownInterval); // Stop the interval when countdown reaches 0
                }
            }, 1000); // Update every 1 second

            toaster.pop('success', "RTU View", 'View reloading');
            _getData($scope.stickyProperties.deviceId);
            //trigger refresh for analog widget and analog output widget
            $rootScope.$broadcast('rtuViewRefreshButtonClicked', $scope.stickyProperties.deviceId);
            // For getting Latest Note from Station Notes
            $rootScope.$broadcast('getLatestStationNote');
            $scope.resizeModal();
        }

        $scope.resizeModal = function () {
            $scope.analogSection = false;
            $scope.analogOutputSection = false;
            $scope.relaySection = false;
            $scope.rtuDataSection = false;
            $rootScope.$broadcast('rtuViewRefreshButtonClicked', $scope.stickyProperties.deviceId);
            if(!$rootScope.mobile && !$rootScope.classicView){
                $scope.tmpTitle = parseInt($scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.tmpMenu = !$scope.isPublicUser ? parseInt($scope.popup.parent().find('.rtu-table-legacy-menu').css("height").replace(/[^0-9.]+/g, "")) : 0;
                // Wait until the browser finishes rendering/resizing/zooming, then measure and adjust the container height
                requestAnimationFrame(function () {
                    $scope.newHeight = $scope.popup.parent().find('.rtu-view-container')[0].clientHeight + 55;
                    // $scope.calculateHeight($scope.newHeight);
                    $scope.popup.parent().find('div:eq(2)').css("height", $scope.newHeight);
                    $scope.popup.parent().css("height", $scope.tmpTitle + $scope.tmpMenu + $scope.newHeight);
                    $scope.popup.dialog('widget').css("height", ($scope.tmpTitle + $scope.tmpMenu + $scope.newHeight) + "px");
                    $scope.popup.dialog("option", "height", ($scope.tmpTitle + $scope.tmpMenu + $scope.newHeight));
                    $scope.popup.parent().animate({ opacity: 1 }, 75);
                    sharedSetupService.adjustPopupTopPosition($scope.popup); 
                });
            }  else if ($rootScope.classicView) {
                var classicViewStyle = document.getElementsByClassName('rtu-view-container');
                classicViewStyle[0].style.height = "100%";
            }
            $scope.rtuViewBusy = false;
        };
        
        // Commenting below code as the rtu-view should not cross taskbar and the same is handled by using css
       //reverted changes to how the $scope.resizeModal() had been written and added $scope.calculateHeight() to $scope.resizeModal() to resolve scroll issue
        // $scope.calculateHeight = function (tempNewHeight) {
        //     $scope.rtuViewContainer = $scope.popup.parent().find('.rtu-view-container')[0];
        //     $scope.screenHeight = window.innerHeight;
        //     $scope.maxAllowedHeight = $scope.screenHeight - 50;
        //      if (tempNewHeight > $scope.maxAllowedHeight) {
        //             angular.element($scope.rtuViewContainer).css({
        //                 "height": "86%",
        //                 "overflow-y": "auto"
        //             });
        //             tempNewHeight = $scope.maxAllowedHeight;
        //         } else {
        //             angular.element($scope.rtuViewContainer).css({
        //                 "height": "auto",
        //                 "overflow-y": "visible"
        //             });
        //         }
        //     return $scope.newHeight = tempNewHeight;
        // }

        // adding below code to adjust the rtu-view when screen size is decreased or inscreased
        var resizeTimer;
        angular.element($window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                if ($scope.popup && $scope.popup.is(':visible')) {
                    $scope.$apply(function () {
                        $scope.resizeModal();
                    });
                }
            }, 150);
        });

        $scope.resetRelaySettings = function () {
            $scope.relays = [];
            $scope.commandOptions = [];
            $scope.commandsAssigned = false;
        }

        $scope.processRelaysSetting = function (rtuViewRelayState) {
            if ($scope.accountInfo === null)
                return;
            $scope.resetRelaySettings();
            
            $scope.relays = rtuViewRelayState.availableRelays;

            if (rtuViewRelayState.availableRelays.length > 0) {
                $scope.relayStateSettings = rtuViewRelayState.relaySettingState;
                if (rtuViewRelayState.relaySettingState) {
                    $scope.assignRelayMode(rtuViewRelayState.relaySettingState);
                    $scope.assignRelayState(rtuViewRelayState.relaySettingState);
                    $scope.commandOptions = rtuViewRelayState.commandOptions;
                    if ($scope.commandOptions != null && $scope.commandOptions.length > 0) {
                        $scope.assignPagingCommands($scope.commandOptions);
                    }
                    //Resize when complete
                    $timeout(function () { $scope.resizeModal() }, 0);
                }
                else { $timeout(function () { $scope.resizeModal() }, 0); }
            }
            else {
                $timeout(function () { $scope.resizeModal() }, 0);
            }
        };

        $scope.assignRelayState = function (relayStateSettings) {
            angular.forEach($scope.relays,
                function (value, key) {                    
                    var isRelayOpen;
                    var isRelayClosed;                    
                    var currentChannel = relayStateSettings.filter(function (relay) {
                        return relay.channel == $scope.relays[key].channel;
                    })[0];

                    if (!angular.isUndefined(currentChannel)) {
                        if (currentChannel.value === 1) {
                            isRelayOpen = 1;
                        }
                        else if (currentChannel.value === 0) {
                            isRelayClosed = 1;
                        }                        
                    }
                    
                    $scope.relays[key].isRelayOpen = isRelayOpen;
                    $scope.relays[key].isRelayClosed = isRelayClosed;                    
                });
        };

        $scope.assignRelayMode = function (relayStateSettings) {
            angular.forEach($scope.relays,
                function (value, key) {
                    var mode;                    
                    if ($scope.getValueFromRelay($scope.relays[key].channel, relayStateSettings)) {
                        mode = 1;                        
                    } else {
                        mode = 0;
                    }
                    $scope.relays[key].mode = mode;

                    //assign disable message if device is a MyDro device, software version >= 18.2 and has EBPC purchased and is relay 1/2
                    if ($scope.relays[key].channel == 1 || $scope.relays[key].channel == 2) {
                        if ($scope.isMyDroDevice && $scope.softwareVersion >= 18.2 && $scope.ebpcPurchased) {
                            $scope.relays[key].disableMessage = $scope.translation.text.RELAY_DISABLED_FOR_EBPC;
                        }
                    }
                });
        };

        $scope.getValueFromRelay = function (channel, relayStateSettings) {
            var currentChannel = relayStateSettings.filter(function (relay) {
                return relay.channel == channel;
            })[0];

            if (!angular.isUndefined(currentChannel)) {
                return currentChannel.value === 1 ? true : false;
            }
            return false;
        };

        $scope.assignPagingCommands = function (commandOptions) {
            $scope.relays.map(function(relay){
                commandOptions.map(function(command){
                    //Match string ending
                    if(command.commandDescription.toLowerCase().endsWith(" open")){
                        relay.openCommand = command;
                        $scope.commandsAssigned = true;
                    }
                    //Match string ending
                    if(command.commandDescription.toLowerCase().endsWith(" close")){
                        relay.closeCommand = command;
                        $scope.commandsAssigned = true;
                    }

                    //Match string
                    if (command.commandDescription.toLowerCase().endsWith("set digital output channel value")) {
                        relay.closeCommand = command;
                        relay.openCommand = command;
                        $scope.commandsAssigned = true;
                    }                    
                })
                //Set updating status for relay
                relay.updating = false;
            })            
        }

        $scope.updateDisableMessage = function (disableMessage) {
            var tankDisableMessage = $scope.translation.text.PLEASE_CHANGE_STATE_AT + " " + $scope.translation.text.TANK_AND_WELL;
            var interconnectDisableMessage = $scope.translation.text.PLEASE_CHANGE_STATE_AT + " " + $scope.translation.text.INTERCONNECT;

                if(disableMessage.toLowerCase().includes('tank')){
                    return tankDisableMessage;
                }
                else if(disableMessage.toLowerCase().includes('interconnect')){
                    return interconnectDisableMessage;
                }
                return disableMessage;
        }

        $scope.postPageCommand = function (relay) {
            //prevent Command if restricted access, updating already or disableMessage
            if ($scope.restrictedRelayAccess || relay.updating || relay.disableMessage) return;
            //turn off deferred relay page request indicator
            relay.hasDeferredRelayPageRequest = false;
            relay.updating = true;
            //update mode
            relay.mode = relay.mode == 1 ? 0 : 1;
            var varCommand;
            //Select Command based on mode
            if (relay.mode == 0) {
                varCommand = relay.openCommand;
            }
            else {
                varCommand = relay.closeCommand;
            }

            //var varCommand;
            var _tmpCommandDescription = varCommand.commandDescription;
            var _tmpCommandDetails = {};
            if (varCommand.commandId == 170) {
                _tmpCommandDetails = { channel: null, value: null, valueDetail: null };
                _tmpCommandDetails.channel = relay.channel;
                _tmpCommandDetails.value = 0;
                $scope.tmpPageRequest = {
                    deviceId: $scope.deviceSelected, commandDescription: _tmpCommandDescription, commandDetails: _tmpCommandDetails, electricModes: $scope.selectedElectricModes
                };
            }
            else if (varCommand.commandId == 171) {
                _tmpCommandDetails = { channel: null, value: null, valueDetail: null };
                _tmpCommandDetails.channel = relay.channel;
                _tmpCommandDetails.value = 1;
                $scope.tmpPageRequest = {
                    deviceId: $scope.deviceSelected, commandDescription: _tmpCommandDescription, commandDetails: _tmpCommandDetails, electricModes: $scope.selectedElectricModes
                };
            }
            else if (varCommand.commandId == 311) {
                _tmpCommandDetails = { chanNum: null, mode: null };
                _tmpCommandDetails.chanNum = relay.channel;
                _tmpCommandDetails.mode = relay.mode == 1 ? "close" : "open";
                $scope.tmpPageRequest = {
                    deviceId: $scope.deviceSelected, commandDescription: _tmpCommandDescription, commandDetails: _tmpCommandDetails, commandId: varCommand.commandId, imei: $scope.deviceImei
                };
            }

            pageRequestsService.postData($scope.accountInfo.customerId, varCommand.commandId, $scope.deviceInfo.deviceType, $scope.deviceInfo.protocolVersion, $scope.accountInfo.timeZone, $scope.tmpPageRequest).then(function (result) {
                relay.updating = false;
                //Command did not complete revert relay state in UI with error message
                if (result.data.item2 == 2) {
                    relay.errorMessage = true;
                    //relay.mode = relay.mode == 1 ? 0 : 1;
                    return;
                }
                relay.errorMessage = false;
                $rootScope.$broadcast('commandPaging', {
                    deviceId: $scope.deviceSelected, deviceName: $scope.deviceSelectedName, deviceSn: $scope.deviceSelectedSn, data: result.data.item1
                });

            }, function (error) {
                relay.updating = false;
                var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({
                    msg: errormsg, type: "danger"
                });
            });
        }

        $element.on(
            "mouseover.rtuViewRelayWidget",
            "div.col-xs-12.hcolRelay i",
            function (event) {
                var $target = $(event.currentTarget);
                var isToggleIcon = $target.hasClass('fa-toggle-off') || $target.hasClass('fa-toggle-on');

                // Only proceed if the hovered element is actually the toggle icon
                if (isToggleIcon) {
                    // Check your scope variables (removed the duplicate !$scope.classicView)
                    if (!$scope.mobile && !$scope.classicView) {

                        // Only initialize draggable if it hasn't been initialized yet
                        if (!$target.hasClass('ui-draggable')) {
                            $target.draggable({
                                // Use a custom function to clone the icon and remove the margin
                                helper: function () {
                                    return $target.clone().css({
                                        'margin-left': '0',
                                        'margin-right': '0'
                                    });
                                },
                                // Optional but recommended: centers the mouse on the dragged icon
                                cursorAt: { top: 10, left: 10 },
                                revert: false,
                                appendTo: "body",
                                containment: "body",
                                opacity: 0.35,
                                stop: function (event, ui) {
                                    // 1. Get the index from the dragged element's attributes
                                    var relayIndex = ui.helper.attr("data-index");

                                    // 2. Fetch the actual relay object from your scope array
                                    var actualRelay = $scope.relays[relayIndex];

                                    var tmpSize = $scope.mcWidgetsSharedFactory.getSize(ui.helper.attr("mc-size"), 1);
                                    var mcDevice = {
                                        deviceId: $scope.deviceSelected,
                                        channel: ui.helper.attr("mc-channel"),
                                        serialNumber: $scope.deviceSelectedSn,
                                        deviceName: $scope.deviceSelectedName,
                                        relay: actualRelay,
                                        imei: $scope.deviceImei,
                                        deviceInfo: $scope.deviceInfo
                                    };
                                    var optionsStickyProperties = {
                                        deviceId: $scope.deviceSelected,
                                        device: mcDevice
                                    };
                                    var $newPosX = ui.offset.left;
                                    var $newPosY = ui.offset.top;
                                    var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                                    openViewService.openWidget('Mc Relay Widget', { width: tmpSize.width, height: tmpSize.height }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));                                    
                                    $scope.$apply();
                                }
                            });
                        } else {
                            // If it is already initialized, just make sure it's enabled
                            $target.draggable("enable");
                        }
                    } else {
                        // Disable dragging for mobile/classic views if it was previously initialized
                        if ($target.hasClass('ui-draggable')) {
                            $target.draggable("disable");
                        }
                    }
                }
            }
        );

        $scope.prepToOpen = function () {
            var mobileStickyProperties = sharedSetupService.stickyPropertiesInterface;
            mobileStickyProperties.deviceId = $scope.deviceSelected;
            mobileStickyProperties.device = { deviceId: $scope.deviceSelected };
        };

        $scope.openPaging = function() {
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('Paging', { width: 600, height: (210 + pagingViewHeightAdjustment) }, { my: 'right-10 top+6', at: 'right top', of: window }, $scope.stickyProperties, { minimumWidth: 600, minimumHeight: (210 + pagingViewHeightAdjustment) });
            }
            else {
                $location.path('/paging/paging');
            }
        };

        $scope.openSupergraph = function() {
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { device: { deviceId: $scope.deviceSelected }, deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('Supergraph', { width: 950, height: 600 }, undefined, $scope.stickyProperties, { minimumWidth: 600, minimumHeight: 500 });
            }
            else {
                $scope.prepToOpen();
                $location.path('/supergraph/supergraph-view');
            }
        };

        $scope.openRtuInfo = function () {
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('RTU Setting', { width: 850, height: 600 }, undefined, $scope.stickyProperties, { minimumWidth: 800, minimumHeight: 600 });
            }
            else {
                $scope.prepToOpen();
                $location.path('/rtusetting/rtu-setting');
            }
        };

        $scope.openPumpData = function () {
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, dataFormat: 'D', windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('Pump Table', { width: 625, height: 500 }, undefined, $scope.stickyProperties, { minimumWidth: 350, minimumHeight: 350 });
            }
            else {
                $scope.prepToOpen();
                $location.path('/pump/pump-table');
            }
        };

        $scope.openDashboard = function () {
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('Dashboard', { width: 750, height: 450 }, undefined, $scope.stickyProperties, { minimumWidth: 500, minimumHeight: 100 });
            }
            else {
                $location.path('/dashboard/dashboard');
            }
        };


        $scope.openAlarmHistory = function () {
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('Alarm History', { width: 850, height: 500 }, undefined, $scope.stickyProperties, { minimumWidth: 625, minimumHeight: 240 });
            }
            else {
                $location.path('/alarmhistory/alarm-history');
            }
        };

        $scope.openDallasKey = function () { 
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('Site Access Report', { width: 900, height: 600 }, { my: 'right-10 top+10', at: 'right top', of: window }, $scope.stickyProperties, { minimumWidth: 500, minimumHeight: 300 });
            }
            else {
                $location.path('/siteaccess/site-access-report');
            }
        };

        $scope.openRainfallTable = function () {
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('Rainfall Data Table', { width: 750, height: 450 }, undefined, $scope.stickyProperties, { minimumWidth: 400, minimumHeight: 300 });
            }
            else {
                $location.path('/rainfall/table/rainfall-data-table-view');
            }
        };

        $scope.openRtuData = function () {
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('Analog Chart', { width: 625, height: 500 }, undefined, $scope.stickyProperties, { minimumWidth: 350, minimumHeight: 350 });
            }
            else {
                $location.path('/analog/analog-chart');
            }
        };

        $scope.openMyLevel = function () {
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                    openViewService.openView('MyLevel', { width: 340, height: 530 }, undefined, $scope.stickyProperties, { minimumWidth: 340, minimumHeight: 530 });
            }
            else {
                    $location.path('/mmplus/mmplus');
            }
        };

        $scope.openPumpStation = function () {
            var pagingViewHeightAdjustment = 0;
            if ($scope.mcAdminAccess) {
                pagingViewHeightAdjustment = sharedSetupService.pagingViewHeightAdjustment;
            }
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                    openViewService.openView('Pump Station', { width: 390, height: 530 }, undefined, $scope.stickyProperties, { minimumWidth: 390, minimumHeight: 530 });
            }
            else {
                    $location.path('/pumpstation/pump-station');
            }
        };

        $scope.getSigFig = function (item) {
            if (typeof item == 'undefined') return;
            return $filter('number')(item.latestData, sharedSetupService.getNumberOfDecimals(item.maxVal, item.minVal));
        };

        $scope.getAnalogIII = function () {
            if ($scope.analogData.length > 0) {
                for (var i = 0; i < $scope.analogData.length; i++) {
                    if ($scope.analogData[i].channel === 3) {
                        $scope.analogIIIData = $filter('number')($scope.analogData[i].latestData, 1);
                        break;
                    }
                }
            }
        }

        $scope.getEnggUnit = function (item) {
            if (!(item.analogMode === 1 || item.analogMode === 0)) {
                return '';
            }
                        //var unitMin = 0;
            var unitMax = 0;
            var unit = '';
            var scaledValue = undefined;


            if (item.analogMode === 1) { //translate to 4 - 20 mA
                //unitMin = 4;
                unitMax = 20;
                unit = 'mA';
                //Formula --> FormatNumber(20 * RAW_VALUE / 1023,1)
                scaledValue = (unitMax * item.rawVal / 1023).toFixed(1);
            }
            else if (item.analogMode === 0) { //translate to 0 - 5 Volts
                //unitMin = 0;
                unitMax = 5;
                unit = 'Volts';

                //Formula --> FormatNumber(5 * RAW_VALUE / 1023,2)
                scaledValue = (unitMax * item.rawVal / 1023).toFixed(2);
            }
            if($scope.deviceInfo.deviceType >= 21) 
            {
                 return  item.rawValMmPlus + ' ' + unit;
            }

            return scaledValue + ' ' + unit;
        }

        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        //TODO:  --- we need to make certain to unbind event handler when the scope is destroyed. If we don't do this, every time when the scope is recreated (the controller is rerun), there will be 1 more handler added causing unexpected behavior and leaking.
        angular.element($window).bind('orientationchange', function () {
            drawCharts();
        });

        $scope.openBangPage = function () {
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('Current Status', { width: 700, height: 500 }, { my: 'right-10 top+6', at: 'right top', of: window }, $scope.stickyProperties, { minimumWidth: 600, minimumHeight: 350 });
            }
            else {
                $location.path('/technicalsupport/technical-support');
            }
        };

        if ($rootScope.mobile || $rootScope.classicView) {
            $scope.$on("SendPulseFlowCountUp", function (event, args) {
                $scope.pulseFlowCount = args;
            });
            
            //adding below 'rtuRuntimeDone_' and 'rtuStatusDone_' to mobile and classic view for fetching details for hiding <hr> when no data 
            $scope.$on('rtuRuntimeDone_' +$scope.windowId, function (event, args) {
                $scope.rtuRuntimeDone = args.message;
            });

            $scope.$on('rtuStatusDone_' +$scope.windowId, function (event, args) {
                $scope.rtuStatusDone = args.message;
            });
        }
   
        //adding below 'rtuRuntimeDone_' and 'rtuStatusDone_' to mobile and classic view for fetching details for hiding <hr> when no data 
        $scope.$on('rtuRuntimeDone_' +$scope.windowId, function (event, args) {
            $scope.rtuRuntimeDone = args.message;
        });

        $scope.$on('rtuStatusDone_' +$scope.windowId, function (event, args) {
            $scope.rtuStatusDone = args.message;
        });

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            //THE-51575: jQuery UI renders the window title as a plain <span>; role/aria-level expose
            //it as an <h2> without Bootstrap's h2 styling. children() so a .ui-dialog-title inside
            //the view content is never matched
            $scope.popup.dialog('widget').children(".ui-dialog-titlebar").children(".ui-dialog-title").attr({ "role": "heading", "aria-level": "2" });
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialogExtend({
                maximize: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                },
                restore: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                }
            });

            $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
                $scope.timeFormat = timeFormat;
            });

            //Code to prevent view size from adjusting until all loading events are complete
            var analogPromise = $q.defer();
            var digitalPromise = $q.defer();
            var rtuDataPromise = $q.defer();

            var rtuDigitalDone = function (message) {
                $scope.messageDigital = message;
                digitalPromise.resolve(true);
            };
            
            $scope.$on("SendPulseFlowCountUp", function (event, args) {
                $scope.pulseFlowCount = args;
            });

            //Need to use window id to keep it unique, otherwise they all listen for each other's events
            $scope.$on('rtuAnalogDone_' + $scope.windowId, function (event, args) {
                $scope.messageAnalog = args.message;
                analogPromise.resolve(true);
            });

            $scope.$on('rtuAnalogOutputDone_' + $scope.windowId, function (event, args) {
                $scope.messageAnalog = args.message;
                analogPromise.resolve(true);
            });

            $scope.$on('rtuRuntimeDone_' +$scope.windowId, function (event, args) {
                $scope.rtuRuntimeDone = args.message;
                rtuDigitalDone(args.message);
            });

            $scope.$on('rtuStatusDone_' +$scope.windowId, function (event, args) {
                $scope.rtuStatusDone = args.message;
                rtuDigitalDone(args.message);
            });
            
            $scope.$on('skuidChanged', function (event, args) {                
                if ($scope.deviceSelected !== args) return;
                _getData($scope.deviceSelected);            
            });

            $scope.prepResize = function () {
                $q.all([analogPromise.promise, digitalPromise.promise, rtuDataPromise.promise]).then(function () {
                    $timeout(function () {
                        $scope.rtuAnalog = null;
                        $scope.rtuAnalogOutput = null;
                        $scope.rtuDigital = null;
                        analogPromise = $q.defer();
                        digitalPromise = $q.defer();
                        rtuDataPromise = $q.defer();
                        $scope.resizeModal();
                        //$scope.adjustDeviceIdMenuSize();
                    });
                });
            }

            $scope.adjustDeviceIdMenuSize = function () {
                var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                if (spph < 450) {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
                }
                else {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
                }
            };
        }
        
        $scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                $scope.isPc3000 = ($scope.deviceSelected == $scope.pc3000Value || $scope.deviceSelected == $scope.pc3000ValueII) ? true : false;
                $scope.currentDevice = newValue;
                deviceMenuService.getDeviceMenuList($scope.accountInfo.customerId)
                    .then(function (response) {

                        $scope.devices = response.data.devices;
                        for (var i = 0; i < $scope.devices.length; ++i) {
                            if ($scope.devices[i].deviceId === newValue) {
                                $scope.setHasAdamsRelayModule($scope.devices[i].hasAdamsRelayModule);
                                $scope.deviceImei = $scope.devices[i].imei;
                                $scope.setEbpcPurchased($scope.devices[i].ebpcPurchased);
                                $scope.setsoftwareVersion($scope.devices[i].softwareVersion);
                                break;
                            }
                        }

                        _getData(newValue);

                        // For getting Latest Note from Station Notes
                        $rootScope.$broadcast('getLatestStationNote');
                        if (!$scope.mobile && !$scope.classicView) {
                            $scope.popup.parent().animate({ opacity: .15 }, 75);
                            $scope.prepResize();
                        }

                    }, function (error) {
                        //error
                        });
            }
        }, true);

        $scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                _unRegisterListener(oldValue);
            }
        });

        $scope.$watch('accountInfo.preferenceUser.lookupMeasurementID', function (newVal, oldVal) {
            for (i = 0; i < $scope.rtuData.length; i++) {
                if ($scope.rtuData[i].name == 'Temperature') {
                    $scope.rtuData[i].value = newVal == 1 ? Math.round((9 / 5) * $scope.rtuData[i].value + 32) : Math.round((5 / 9) * ($scope.rtuData[i].value - 32));
                    $scope.rtuData[i].unit = newVal == 1 ? "°F" : "°C";
                }
            }
            drawCharts();
        });

        $scope.analogSectionShowHide = function () {
            $scope.analogSection = !$scope.analogSection;
        };

        $scope.analogOutputSectionShowHide = function () {
            $scope.analogOutputSection = !$scope.analogOutputSection;
        };

        $scope.relaySectionShowHide = function () {
            $scope.relaySection = !$scope.relaySection;
        };

        $scope.rtuDataSectionShowHide = function () {
            $scope.rtuDataSection = !$scope.rtuDataSection;
        };

        var _getData = function (deviceID) {
            rtuDataService.getRtuModel(deviceID, $scope.accountInfo.customerId, $scope.hasAdamsRelayModule, $scope.accountInfo.timeZone).then(function (resp) {
                $scope.deviceInfo = resp.data.deviceUnitState;
                $scope.m110Runtime = $scope.deviceInfo.deviceType === 8 || $scope.deviceInfo.deviceType === 17 || $scope.deviceInfo.deviceType === 18 ? true : false;
                $scope.isMyDroDevice = $scope.deviceInfo.deviceType === 17 || $scope.deviceInfo.deviceType === 18 || $scope.deviceInfo.deviceType === 19 ? true : false;
                $scope.noPumps = $scope.deviceInfo.deviceType !== 10 && $scope.deviceInfo.deviceType !== 15 && $scope.deviceInfo.deviceType !== 20;
                if (angular.isObject($scope.deviceInfo)) { //ref: scada-1207
                    $scope.$parent.$parent.deviceName = $scope.deviceInfo.deviceName;
                }

                var result = resp.data.listRtuData;
                var randomNum = Math.floor((Math.random() * 1000000) + 1);
                $scope.rtuData = result;

                $scope.getSignalStrengthParameter();
                //If manhole monitor A/C does not apply Add Logic for Gen 2 Manhole Monitor
                if ($scope.deviceInfo.deviceType == 15 || $scope.deviceInfo.deviceType == 20) {
                    var idx = _.findIndex($scope.rtuData, { name: 'A.C.' });
                    if (idx != -1)
                        $scope.rtuData.splice(idx, 1);
                }

                for (var i = 0; i < $scope.rtuData.length; i++) {
                    $scope.rtuData[i].chartId = $scope.rtuData[i].name + "_" + randomNum;
                    $scope.rtuData[i].name = $scope.rtuData[i].name; // == 'RSSI' ? 'Signal' : $scope.rtuData[i].name;
                    $scope.rtuData[i].originalUnit = $scope.rtuData[i].unit;
                    $scope.rtuData[i].unit = $scope.rtuData[i].name == 'Temperature' ? ($scope.accountInfo.preferenceUser.lookupMeasurementID == 1 ? "°F" : "°C") : $scope.rtuData[i].unit
                    //$scope.rtuData[i].unit = $scope.rtuData[i].unit == "0" || $scope.rtuData[i].unit == "1" ? $scope.rtuData[i].unit == "0" ? "°C" : "°F" : $scope.rtuData[i].unit;
                    $scope.rtuData[i].value = $scope.rtuData[i].name == 'Battery' || $scope.rtuData[i].name == 'A.C.' || $scope.rtuData[i].name == 'D.C.' ? parseFloat($scope.rtuData[i].value).toFixed(1) : $scope.rtuData[i].name == 'VAux' ? parseFloat($scope.rtuData[i].value).toFixed(2) : parseFloat($scope.rtuData[i].value).toFixed(0);
                    if ($scope.rtuData[i].name == 'Temperature') {
                        //If the data was in Celsius but the customer is asking for it in Fahrenheit
                        if ($scope.rtuData[i].originalUnit == "0" && $scope.accountInfo.preferenceUser.lookupMeasurementID == 1) {
                            $scope.rtuData[i].value = Math.round((9 / 5) * $scope.rtuData[i].value + 32);
                        }

                        //If the data was in Fahrenheit but the customer is asking for it in Celsius
                        if ($scope.rtuData[i].originalUnit == "1" && $scope.accountInfo.preferenceUser.lookupMeasurementID == 2) {
                            $scope.rtuData[i].value = Math.round((5 / 9) * ($scope.rtuData[i].value - 32));
                        }
                    }
                }

                $scope.processRelaysSetting(resp.data.relayData);

                $timeout(function () {
                    drawCharts();
                    if (rtuDataPromise)
                        rtuDataPromise.resolve(true);
                }, 0);

            }, function (resp) {
                //scada-1253 --> resp object has two results [resp[0].data || resp[1].data]
                if (resp && resp.length > 0) {
                    var error = resp.data.message; //when error is thrown, one of the object should have message [resp[0].data || resp[1].data]
                    $scope.alerts = [];
                    var errormsg = eval("$scope.translation.message." + error.message);
                    $scope.alerts.push({ msg: errormsg, type: "danger" });
                }
                $scope.m110Runtime = false;
            });
        };

        //Assign SignalStrengthParameter to variable $scope.signalStrengthParam
        $scope.getSignalStrengthParameter = function () {
                $scope.rtuData.map(function(data){
                    if(data.name.toLowerCase() == "rssi"){
                        $scope.signalStrengthParam = data.name;
                    }
                })
        }

        $scope.replaceSpaces = function (str) {
            if (str) {
                return str.replace(new RegExp(' ', 'g'), '_');
            }

            return '';
        };

        var drawCharts = function (type) {
            if ($scope.rtuData.length > 0) {
                for (var i = 0; i < $scope.rtuData.length; i++) {
                    if (!type || type === $scope.rtuData[i].name) {
                        var tenPercentDiff = 0;
                        var upperLimit = null;
                        var lowerLimit = null;
                        if ($scope.rtuData[i].name == 'A.C.') {
                            tenPercentDiff = .5;
                            lowerLimit = 10.5;
                            upperLimit = 14.5;
                        } else if ($scope.rtuData[i].name == 'D.C.') {
                            tenPercentDiff = .5;
                            lowerLimit = 11;
                            upperLimit = 15;
                        } else if ($scope.rtuData[i].name == 'VAux') {
                            tenPercentDiff = 2.5;
                            lowerLimit = 0;
                            upperLimit = 24;
                        } else if ($scope.rtuData[i].name == 'RSSI') {
                            tenPercentDiff = 2.7778;
                            lowerLimit = -105;
                            upperLimit = -80;
                        } else if ($scope.rtuData[i].name == 'RSRQ') {
                            tenPercentDiff = 2.3333;
                            lowerLimit = -20;
                            upperLimit = 0;
                        } else if ($scope.rtuData[i].name == 'RSRP') {
                            tenPercentDiff = 7.3333;
                            lowerLimit = -140;
                            upperLimit = -44;
                        } else if ($scope.rtuData[i].name == 'Battery') {
                            //Manhole monitor batteries are smaller
                            if ($scope.deviceInfo.deviceType == 15 || $scope.deviceInfo.deviceType == 20) {
                                tenPercentDiff = 0.2;
                                lowerLimit = 4.5;
                                upperLimit = 6.5;
                            } else if($scope.deviceInfo.deviceType == 21){
                                tenPercentDiff = .5;
                                lowerLimit = 3.3;
                                upperLimit = 5;
                            }                         
                            else {
                                tenPercentDiff = .5;
                                lowerLimit = 11;
                                upperLimit = 15;
                            }
                        } else if ($scope.rtuData[i].name == 'Temperature') {
                            if ($scope.rtuData[i].unit == "°C") {
                                tenPercentDiff = 8.75;
                                lowerLimit = -20;
                                upperLimit = 50;
                            } else if ($scope.rtuData[i].unit == "°F") {
                                tenPercentDiff = 15;
                                lowerLimit = 0;
                                upperLimit = 120;
                            }
                        }

                        var value = $scope.rtuData[i].value;
                        if (value < lowerLimit - tenPercentDiff)
                            value = lowerLimit - tenPercentDiff;
                        else if (value > ($scope.rtuData[i].name == 'RSSI' || $scope.rtuData[i].name == 'RSRP' ? upperLimit : upperLimit + tenPercentDiff))
                            value = ($scope.rtuData[i].name == 'RSSI' || $scope.rtuData[i].name == 'RSRP' ? upperLimit : upperLimit + tenPercentDiff);

                        var rtuDatas = $('#' + $scope.replaceSpaces($scope.windowId)).find('.var-value-text');
                        var maxWidth = 0;
                        for (var j = 0; j < rtuDatas.length; j++) {
                            if ((rtuDatas[j].clientWidth + 1) > maxWidth)
                                maxWidth = rtuDatas[j].clientWidth + 1;
                        }
                        maxWidth += 10;

                        if ($scope.rtuData[i].chart && $scope.rtuData[i].chart.dispose) {
                            var oldChart = $scope.rtuData[i].chart;
                            $timeout(function (oldChart) {
                                oldChart.dispose();
                            }, 0, true, oldChart);
                            $scope.rtuData[i].chart = null;
                        }

                        //if (!$('.chart-container')[0]) return false;
                        if (!$('#' + $scope.replaceSpaces($scope.windowId)).find('.chart-container')[0]) return false;
                       
                        var minValue = lowerLimit - tenPercentDiff;
                        var maxValue = $scope.rtuData[i].name == 'RSSI' || $scope.rtuData[i].name == 'RSRP' ? upperLimit : upperLimit + tenPercentDiff;
                        var valuePercent = (Number(value) - minValue)/(maxValue - minValue) * 100;
                        var lowerLimitPercent = (lowerLimit - minValue)/(maxValue - minValue) * 100;
                        var upperLimitPercent = (upperLimit - minValue)/(maxValue - minValue) * 100;
                        var seriesData = [valuePercent];

                        $scope.rtuData[i].chart = function () {
                            Highcharts.chart( $scope.rtuData[i].chartId, {
                                chart: {
                                    type: 'lineargauge',
                                    inverted: true,
                                    height: 100,
                                    width: 100
                                },
                                title: {
                                    text: null
                                },
                                exporting: { enabled: false },
                                xAxis: {
                                    lineColor: '#C0C0C0',
                                    labels: {
                                        enabled: false
                                    },
                                },
                                yAxis: {
                                    min: 0,
                                    max: 100,
                                    title: null,
                                    labels: {
                                        enabled: false,
                                        format: '{value}%'
                                    },
                                    plotBands: [{
                                        from: 0,
                                        to: lowerLimitPercent,
                                        color: $scope.rtuData[i].name == 'Temperature' ? "#F8CA3F" : "#FF8472"
                                    }, {
                                        from: lowerLimitPercent,
                                        to: upperLimitPercent,
                                        color: "#A2C833"
                                    }, {
                                        from: upperLimitPercent,
                                        to: 100,
                                        color: $scope.rtuData[i].name == 'RSRQ' ? "#A2C833" : "#F8CA3F"
                                    }]
                                },
                                legend: {
                                    enabled: false
                                },
                                credits: {
                                    enabled: false
                                  },
                                series: [{
                                    data: seriesData,
                                    color: '#000000',
                                    dataLabels: {
                                        enabled: true,
                                        align: 'center',
                                        format: '{point.y}%'
                                    }
                                }]
                            });
                        };
                        $scope.rtuData[i].chart();
                    }

                }
                _registerListener($scope.deviceSelectedSn);
            }
            else {
                $scope.alerts = [];
                $scope.alerts.push({ msg: $scope.translation.message.NO_ANALOG_SETUP, type: "info" });
            }
        }

        $scope.getDeviceStatus = function () {
            if (!$scope.deviceInfo) {
                return;
            } else {
                if ($scope.deviceInfo.disabled)
                    return $scope.translation.text.DISABLED;

                if ($scope.deviceInfo.inServiceMode)
                    return $scope.translation.text.SERVICE_MODE;

                // this variable specifies whether we have heard from the device within last 24 hours, 
                // especially for manhole monitor devices which will send communication for every 24 hours
                var nextelOnline = false;
                if ($scope.deviceInfo.lastTimeHeard) {
                     // timeout represents no. of minutes for which given device will send status signal
                    var timeout = $scope.deviceInfo.timeout;
                    if (timeout <= 5) timeout = 15;
                    //for M50 - Ranger -> we set timeout back to 3 minutes
                    timeout = $scope.deviceInfo.deviceType == 21 ? 3 : timeout;
                    var nowDate = ($scope.currentTime / 1000 / 60 / 60 / 24);
                    var lastHeard = moment($scope.deviceInfo.lastTimeHeard).valueOf() / 1000 / 60 / 60 / 24;
                    if (lastHeard > (nowDate - (timeout / 1440))) nextelOnline = true;
                }
                if ($scope.deviceInfo.lastTimeHeard && ($scope.deviceInfo.deviceType == 20 || $scope.deviceInfo.deviceType == 21)) {
                    var nowDate = ($scope.currentTime / 1000 / 60 / 60 / 24);
                    var lastHeard = moment($scope.deviceInfo.lastTimeHeard).valueOf() / 1000 / 60 / 60 / 24;
                    if (lastHeard < (nowDate - ($scope.deviceInfo.reportingInterval / 1440) - 0.0138))
                        return $scope.translation.text.COMM_FAIL;
                }

                if (($scope.deviceInfo.deviceType == 5 || $scope.deviceInfo.deviceType == 8 || $scope.deviceInfo.deviceType == 9 ||  $scope.deviceInfo.deviceType == 17 ||$scope.deviceInfo.deviceType == 18 || $scope.deviceInfo.deviceType == 19) && !nextelOnline)
                    return $scope.translation.text.COMM_FAIL;
                if (($scope.deviceInfo.deviceType == 2 || $scope.deviceInfo.deviceType == 4 || $scope.deviceInfo.deviceType == 7 || $scope.deviceInfo.deviceType == 10 || $scope.deviceInfo.deviceType == 15) && $scope.deviceInfo.commsFault) {
                    if ($scope.deviceInfo.deviceType == 15 || $scope.deviceInfo.deviceType == 20) {
                        var nowDate = ($scope.currentTime / 1000 / 60 / 60 / 24);
                        var lastHeard = moment($scope.deviceInfo.lastTimeHeard).valueOf() / 1000 / 60 / 60 / 24;
                        if (lastHeard <= (nowDate - 1.1)) return $scope.translation.text.COMM_FAIL;
                    } else if ($scope.deviceInfo.deviceType == 10) {
                        var nowDate = ($scope.currentTime / 1000 / 60 / 60 / 24);
                        var lastHeard = moment($scope.deviceInfo.lastTimeHeard).valueOf() / 1000 / 60 / 60 / 24;
                        if (lastHeard <= (nowDate - 3.1)) return $scope.translation.text.COMM_FAIL;
                    } else {
                        return $scope.translation.text.COMM_FAIL;
                    }
                }

                if ($scope.deviceInfo.acFail && !$scope.deviceInfo.solar)
                    return $scope.translation.text.AC_FAILURE;

                var battery = _.findWhere($scope.rtuData, { name: "Battery" });
                if (battery) {
                    // for ManholeMonitors, if battery level < 4.5V then display low battery
                    if ($scope.deviceInfo.deviceType === 10 || $scope.deviceInfo.deviceType === 15 || $scope.deviceInfo.deviceType === 20) {
                        if (battery.value < 4.50) {
                            return $scope.translation.text.LOW_BATTERY;
                        }
                    }
                    else if ($scope.deviceInfo.deviceType === 21) {
                        // for all devices, if battery level < 11.5V then display low battery
                        if ($scope.deviceInfo.deviceId !== 13822 && battery.value < 3.3) {
                            return $scope.translation.text.LOW_BATTERY;
                        }
                    }
                    else {
                        // for all devices, if battery level < 11.5V then display low battery
                        if ($scope.deviceInfo.deviceId !== 13822 &&  battery.value < 11.50) {
                            return $scope.translation.text.LOW_BATTERY;
                        }
                    }
                }

                var temp = _.findWhere($scope.rtuData, { name: "Temperature" });
                if (temp) {
                    if (temp.value > 120 && temp.unit == "°F")
                        return $scope.translation.text.HIGH_TEMP;
                    if (temp.value > 50 && temp.unit == "°C")
                        return $scope.translation.text.HIGH_TEMP;
                }

                if (($scope.deviceInfo.deviceType === 15 || $scope.deviceInfo.deviceType === 20) && nextelOnline)
                    return $scope.translation.text.DEVICE + " " + $scope.translation.text.OFFLINE;

                return $scope.translation.text.ALL_NORMAL;
            }
        };

        var _onINPUTS = $rootScope.$on('DIGITALINPUT', function (event, args) {
            if ($scope.deviceSelectedSn !== args.data.SN) return;
            if (typeof $scope.deviceInfo != "undefined") $scope.deviceInfo.lastTimeHeard = Date.now(); //used in RTU View;
        });

        var wsDataReceivedDATA = function (data) {
            if ($scope.liveData === false) {
                _unRegisterListener($scope.deviceSelectedSn);
                return;
            }

            if (data.Type == "VBATT") {
                wsDataReceivedDATAUpdate("Battery", parseFloat(data.Value).toFixed(1));
                drawCharts('Battery');
            }

            if (data.Type == "VAC") {
                if ($scope.deviceInfo.solar) {
                    wsDataReceivedDATAUpdate("D.C.", ((100 * parseFloat(data.Value) + 140) / 100).toFixed(1));
                    drawCharts('D.C.');
                } else {
                    wsDataReceivedDATAUpdate("A.C.", ((100 * parseFloat(data.Value) * .707) / 100).toFixed(1));
                    drawCharts('A.C.');
                }

            }

            if (data.Type == "SIGNAL") {
                wsDataReceivedDATAUpdate($scope.signalStrengthParam, parseFloat(data.Value).toFixed(0));
                drawCharts($scope.signalStrengthParam);
            }

            if (data.Type == "TEMPERATURE") {
                wsDataReceivedDATAUpdate("Temperature", parseFloat(data.Value).toFixed(0));
                drawCharts('Temperature');
            }

            if (data.Type === 'OFFLINE') {
                return;
            }

            if (data.Type === 'OFFLINE') {
                return;
            }
            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            $scope.deviceInfo.lastTimeHeard = varTime;
            $scope.lastUpdateAt = varTime;
        };

        var wsInfoDataReceived = function (data) {
            var agentText = stripAgentText(data.Value);
            //Talking about our RTU
            if (agentText.indexOf($scope.deviceInfo.deviceName) > -1) {
                //No longer disabled
                if (agentText.indexOf('reenabled') !== -1) {
                    $scope.deviceInfo.disabled = 0;
                    $scope.deviceInfo.disabledUntil = null;
                } else if (agentText.indexOf('disabled until') > -1) { //Disabled, until a specific time
                    $scope.deviceInfo.disabled = 1;
                    var date = new Date(agentText.substring(agentText.indexOf('until ') + 6, agentText.indexOf(' by')));
                    $scope.deviceInfo.disabledUntil = moment(date).format('YYYY-MM-DDTHH:mm:ss');
                } else if (agentText.indexOf('disabled indefinitely') > -1) { //Disabled indefinitely
                    $scope.deviceInfo.disabled = 1;
                }

                //In service mode
                if (agentText.indexOf('service mode') > -1) {
                    $scope.deviceInfo.inServiceMode = 1;
                } else if (agentText.indexOf('back online') > -1) { //Leaving service mode
                    $scope.deviceInfo.inServiceMode = 0;
                    $scope.deviceInfo.serviceModeEnd = null;
                }
            }
        };

        var wsRelayInfoDataReceived = function (data) {
            if ($scope.deviceSelectedSn === data.SN) {
                var chArray = data.Value.replace(/[[\]]/g, '').split('');
                if(chArray.length == 3 && $scope.relays.length == 3){
                    for(var i = 0; i < 3; i++){
                        $scope.relays[i].mode = chArray[i] === "C" ? 1 : 0;
                    }
                }
            }
        };
        var wsDataReceivedDIOutputs = function(data) {
            if ($scope.deviceSelectedSn === data.SN) {
                var DOValue = data.Value;
                var DOCh = parseInt(data.CH);
                if ($scope.relays.length === 0 || DOCh > 9) return;
                for (var i = 0; i < $scope.relays.length; i++) {
                    if ($scope.relays[i].channel == DOCh) {
                        $scope.relays[i].mode = parseInt(DOValue);
                        break;
                    }
                }
            }
        };

        var wsDataReceivedLastHeardTime = function(data) {
            if ($scope.deviceSelectedSn === data.SN) {
                var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                $scope.lastUpdateAt = varTime;
                $scope.deviceInfo.lastTimeHeard = varTime;
            }
        };

        var stripAgentText = function (text) {
            if (text.indexOf("[") >= 0 && text.indexOf("]") >= 0)
                return text.replace(/\[(.+?)\]/g, "");
            else
                return text;
        };

        var wsDataReceivedDATAUpdate = function (param, value) {
            var i;
            for (i = 0; i < $scope.rtuData.length; i++) {
                if ($scope.rtuData[i].name == param) {
                    $scope.rtuData[i].value = param === "Temperature" ? ($scope.accountInfo.preferenceUser.lookupMeasurementID == 1 ? Math.round((9 / 5) * value + 32) : value) : value;
                }
            }
        };

        var wsReloadInfoData = function () {

        }

        var _registerListener = function (varSelectedSN) {
            websocketService.connect();
            websocketService.register("VBATT", varSelectedSN, "", wsDataReceivedDATA, null);
            websocketService.register("VAC", varSelectedSN, "", wsDataReceivedDATA, null);
            websocketService.register("SIGNAL", varSelectedSN, "", wsDataReceivedDATA, null);
            websocketService.register("TEMPERATURE", varSelectedSN, "", wsDataReceivedDATA, null);
            websocketService.register("ALL", varSelectedSN, "", wsDataReceivedDATA, null);
            websocketService.register("INFO", "", "", wsInfoDataReceived, wsReloadInfoData);
            websocketService.register("DIGITALOUTPUT", varSelectedSN, '', wsDataReceivedDIOutputs, null);
            websocketService.register("LASTHEARDTIME", varSelectedSN, '', wsDataReceivedLastHeardTime, null);
            $scope.liveData = true;
        };

        var _unRegisterListener = function (varSelectedSN) {
            websocketService.unRegister("VBATT", varSelectedSN, "", wsDataReceivedDATA, null);
            websocketService.unRegister("VAC", varSelectedSN, "", wsDataReceivedDATA, null);
            websocketService.unRegister("SIGNAL", varSelectedSN, "", wsDataReceivedDATA, null);
            websocketService.unRegister("TEMPERATURE", varSelectedSN, "", wsDataReceivedDATA, null);
            websocketService.unRegister("ALL", varSelectedSN, "", wsDataReceivedDATA, null);
            websocketService.unRegister("INFO", "", "", wsInfoDataReceived, wsReloadInfoData);
            websocketService.unRegister("DIGITALOUTPUT", varSelectedSN, '', wsDataReceivedDIOutputs, null);
            websocketService.unRegister("LASTHEARDTIME", varSelectedSN, '', wsDataReceivedLastHeardTime, null);
            $scope.liveData = false;
            $scope.lastUpdateAt = undefined;
        };

        $scope.$on("$destroy", function () {
            _unRegisterListener($scope.deviceSelectedSn);
            _onINPUTS();
            timeLapseService.unRegisterLocal('DEVICE_ONLINE', null, null, setTimestamp);
            angular.element($window).off('orientationchange');
            for (var i = 0; i < $scope.rtuData.length; i++) {
                if ($scope.rtuData[i].chart && $scope.rtuData[i].chart.dispose) {
                    $scope.rtuData[i].chart.dispose();
                }
            }
        });
    }]);
mcapp.directive('rtuViewAnalogDirective', ["$timeout", "authenticationService", "websocketService", "analogGaugeService", "deviceService", "toaster", "openViewService", "datetimeService", "sharedSetupService", "McWidgetsSharedFactory", "debounceService", "McWidgetDisplayFactory",
    function ($timeout, authenticationService, websocketService, analogGaugeService, deviceService, toaster, openViewService, datetimeService, sharedSetupService, McWidgetsSharedFactory, debounceService, McWidgetDisplayFactory) {
        function link(scope, element, attrs) {
            scope.rtuViewBusy = true;
            scope.liveAnalogSetting = false;
            element.closest('.ui-dialog-content').css("overflow", "inherit"); //Device Select menu is cut off

            var _convertFromMeters = function (unitId, analogValue) {
                switch (unitId) {
                    case 3: //Feet
                        return (analogValue * 3.280839895);
                    case 4: //Inches
                        return (analogValue * 39.37007874);
                    case 5: //Meters
                        return analogValue;
                    case 6: // mm
                        return (analogValue * 1000);
                    case 23: // Centimeters
                        return (analogValue * 100);
                    default:
                        return analogValue;
                }
            };

            if (angular.isUndefined(scope.mcWidgetsSharedFactory)) scope.mcWidgetsSharedFactory = new McWidgetsSharedFactory();

            var _tooltipInit = function () {
                element
                    .tooltip({
                        track: true,
                        tooltipClass: 'tooltip-jq',
                        content: function () {
                            return $(this).prop('title');
                        }
                    });
            };

            _tooltipInit();

            element.on(
                "mouseover.rtuViewAnalogDirective",
                ".hcolAnalogRtu",
                function (event) {
                    var localScope = $(event.target).scope();
                    if ($(event.currentTarget).is(".hcolAnalogRtu")) {
                        if (!scope.mobile && !scope.classicView) {
                            $(event.currentTarget).draggable({
                                helper: "clone",
                                revert: false,
                                appendTo: "body",
                                containment: "body",
                                opacity: 0.35,
                                stop: function (event, ui) {
                                    var tmpSize = scope.mcWidgetsSharedFactory.getSize(ui.helper.attr("mc-size"), 1);
                                    var mcDevice = { deviceId: scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: scope.deviceSelectedSn, deviceName: scope.deviceSelectedName };
                                    var optionsStickyProperties = {
                                        deviceId: scope.deviceSelected,
                                        device: mcDevice
                                    };
                                    var $newPosX = ui.offset.left;
                                    var $newPosY = ui.offset.top;
                                    var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };

                                    if (angular.isUndefined(scope.mcWidgetDisplayFactory)) scope.mcWidgetDisplayFactory = new McWidgetDisplayFactory(scope.accountInfo.customerId, scope.deviceSelected, scope.accountInfo.timeZone);
                                    scope.mcWidgetDisplayFactory.getWidgetData(ui.helper.attr("mc-channel")).then(function (result) {
                                        var analogType = scope.mcWidgetsSharedFactory.getAnalogTypeByWidgetId(result.data.analogGauge.widgetId);
                                        switch (analogType) {
                                            case "Single Needle Gauge":
                                                openViewService.openWidget('Mc Single Needle Gauge Analog Widget', { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                                break;
                                            case "Elevated Water Tank":
                                                openViewService.openWidget('Mc Elevated Water Tank Analog Widget', { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                                break;
                                            case "Standpipe Storage Tank":
                                                openViewService.openWidget('Mc Standpipe Storage Tank Analog Widget', { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                                break;
                                            case "Hydro Pneumatic Tank":
                                                openViewService.openWidget('Mc Hydro Pneumatic Tank Analog Widget', { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                                break;
                                            case "Wind Speed":
                                                openViewService.openWidget('Mc Wind Speed Analog Widget', { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                                break;
                                            case "Lake Level":
                                                openViewService.openWidget('Mc Lake Level Analog Widget', { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                                break;
                                            case "Staff Gauge":
                                                openViewService.openWidget('Mc Staff Gauge Analog Widget', { width: tmpSize.width, height: tmpSize.height + 25 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                                break;
                                        }
                                    }, function (error) {
                                        
                                    });

                                    
                                    scope.$apply();
                                }
                            });
                        }
                    }
                }
            );

            if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }
            
            // This ensures the RTU View always displays live data and avoids the issue when start and end dates are the same.
            scope.stickyProperties.liveData = true;
            scope.stickyProperties.dateMin = null;
            scope.stickyProperties.dateMax = null;

            scope.$watch('lastUpdateAt', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    scope.liveDataIn = !scope.liveDataIn;
                    $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
                }
            }, true);

            var isMyLevelOrPumpStation = function (deviceId) {
                scope.isMyLevel = false;
                scope.isPumpStation = false;
                for (var i = 0; i < scope.devices.length; ++i) {
                    if (scope.devices[i].deviceId === deviceId) {
                        scope.isMyLevel = scope.devices[i].hasLevelSensor && scope.devices[i].model === 20;
                        scope.isPumpStation = scope.devices[i].pumpStationWidgetId > 0 && (scope.devices[i].type === 8 || scope.devices[i].type === 9 || scope.devices[i].type === 17 || scope.devices[i].type === 18 || scope.devices[i].type === 19);
                        break;
                    }
                }
            };

            scope.$watch('deviceSelected', function (newValue, oldValue) {
                if (newValue) {
                    isMyLevelOrPumpStation(newValue);
                    scope.isPc3000 = (scope.deviceSelected == scope.pc3000Value || scope.deviceSelected == scope.pc3000ValueII) ? true : false;
                    scope.rtuViewBusy = true;
                    scope.alerts = [];
                    scope.lastUpdateAt = undefined;
                    var _device = { deviceName: scope.deviceSelectedName };
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                    scope.stickyProperties.on = scope.stickyProperties.on !== null ? true : false;

                    if (scope.isPc3000) {
                        scope.activateWatch = scope.$watch('analogData',
                            function (newValue, oldValue) {
                                if (newValue && newValue != oldValue) {
                                    scope.getAnalogIII();
                                }
                            },
                            true);
                    } else {
                        if (angular.isFunction(scope.activateWatch)) scope.activateWatch();
                    }

                    _getData(newValue);
                }
            }, true);

            var _getData = function (deviceID) {
                analogGaugeService.getData(deviceID, scope.accountInfo.customerId)
                    .then(function (result) {
                        scope.analogData = result.data;
                        scope.rtuAnalog = scope.analogData.length;
                        scope.$emit('rtuAnalogDone_' + scope.windowId, { message: scope.rtuAnalog });
                        if (scope.analogData.length > 0) {
                            /*  Removing this item so that time is not formatted so we can apply time format from preferences :JS 9/19/17
                            for (var i = 0; i < scope.analogData.length; i++) {
                                scope.analogData[i].localDateTime = datetimeService.formatDateAgentText(scope.analogData[i].localDateTime, 'yyyy-MM-ddTHH:mm:ss');
                              } */
                            _scaleValues();
                            _registerListener(scope.deviceSelectedSn);
                        }
                        else {
                            scope.alerts.push({ msg: scope.translation.message.NO_ANALOG_SETUP, type: "info" });
                        }
                    }, function (error) {
                        scope.alerts = [];
                        if (!error) error = { data: { message: "GENERAL_SERVER_ERROR" } };
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                    });
            };

            scope.getDataLiveModeDebounced = debounceService(_getData, 400, false);

            var _scaleValues = function () {
                for (var i = 0; i < scope.analogData.length; i++) {
                    if (scope.analogData[i].maxVal < scope.analogData[i].minVal) {
                        scope.analogData[i].tempMaxVal = scope.analogData[i].minVal - scope.analogData[i].maxVal;
                        scope.analogData[i].tempValue = (scope.analogData[i].tempMaxVal - scope.analogData[i].latestData) + scope.analogData[i].maxVal;
                    }
                    else {
                        scope.analogData[i].tempMaxVal = scope.analogData[i].maxVal - scope.analogData[i].minVal;
                        scope.analogData[i].tempValue  = scope.analogData[i].latestData - scope.analogData[i].minVal;
                    }                    
                }
            };
            scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    if (oldValue) {
                        _unRegisterListener(oldValue);
                       _unRegisterListenerAnlogSetting(oldValue);
                       _unRegisterListenerDigitalSetting(oldValue);
                    }
                }
            }, true);

            var wsDataReceivedANALOG = function (data) {
                //Catch empty data in old ANALOG message for GENII/SparkPlug device
                if (data.Type == "ANALOG" && scope.deviceSelectedType == 21) {
                    console.log(data);
                    return;
                }

                if (scope.liveData === false) {
                    _unRegisterListener(scope.deviceSelectedSn);
                    return;
                }

                if (scope.deviceSelectedType == 20) {
                    scope.getDataLiveModeDebounced(scope.deviceSelected);
                    return;
                }

                for (var i = 0; i < scope.analogData.length; i++) {
                    if (scope.analogData[i].channel == data.CH) {
                        scope.analogData[i].latestData = parseFloat(data.Value);
                        scope.analogData[i].rawVal = parseInt(data.RawValue);
                        scope.analogData[i].localDateTime = datetimeService.socketStrToServerStrTime(data.Time);
                    }
                    _scaleValues();
                }
                var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                scope.lastUpdateAt = varTime;
                scope.deviceInfo.lastTimeHeard = varTime;

                element.tooltip("destroy");
                _tooltipInit();

                scope.$apply();
            };

            var _wsUpdateAnalogG2 = function (message) {

                if (scope.liveData === false) {
                    _unRegisterListener(scope.deviceSelectedSn);
                    return;
                }

                if (scope.deviceSelectedType < 21) return;

                //if (angular.isUndefined(ctrl.currentStatus.analog)) return;

                //if (scope.deviceSelectedType == 20 && message.Ch != 1) return;

                for (var i = 0; i < scope.analogData.length; i++) {
                    if (scope.analogData[i].channel == message.CH) {
                        var tmpValue;
                        switch (scope.deviceSelectedType) {
                            case 20:
                                tmpValue = _convertFromMeters(ctrl.currentStatus.analog[i].unitOfValueID, parseFloat(message.Value));
                                break;
                            default:
                                tmpValue = parseFloat(message.Value);
                                break;
                        }
                        scope.analogData[i].localDateTime = datetimeService.socketStrToServerStrTime(message.Time);
                        scope.analogData[i].latestData = tmpValue;
                        break;
                    }
                }

                var varTime = datetimeService.socketStrToServerStrTime(message.Time);
                scope.lastUpdateAt = varTime;
                scope.deviceInfo.lastTimeHeard = varTime;

                element.tooltip("destroy");
                _tooltipInit();

                $timeout(function () {
                    _scaleValues();
                    scope.$apply();
                }, 500);
            };

            var _wsUpdateAnalogRaw = function (message) {

                if (scope.liveData === false) {
                    _unRegisterListener(scope.deviceSelectedSn);
                    return;
                }

                if (scope.deviceSelectedType < 21) return;

                //if (angular.isUndefined(ctrl.currentStatus.analog)) return;

                //if (scope.deviceSelectedType == 20 && message.Ch != 1) return;

                for (var i = 0; i < scope.analogData.length; i++) {
                    if (scope.analogData[i].channel == message.CH) {
                        var tmpValue;                        
                        switch (scope.deviceSelectedType) {
                            case 20:
                                tmpValue = _convertFromMeters(ctrl.currentStatus.analog[i].unitOfValueID, parseFloat(message.Value));
                                break;
                            default:
                                tmpValue = parseFloat(message.Value);
                                break;
                        }
                        scope.analogData[i].localDateTime = datetimeService.socketStrToServerStrTime(message.Time);
                        scope.analogData[i].rawVall = tmpValue;
                        break;
                    }
                }

                var varTime = datetimeService.socketStrToServerStrTime(message.Time);
                scope.lastUpdateAt = varTime;
                scope.deviceInfo.lastTimeHeard = varTime;
            };
            
            var wsDataReceivedANALOGSETTINGRV = function (data) {
                if (scope.liveData === false) {
                    _unRegisterListener(scope.deviceSelectedSn);
                    return;
                }
                if(data.Type == 'ANALOGSETTING' && data.SN == scope.deviceSelectedSn )
                {
                    for (var i = 0; i < scope.analogData.length; i++) {
                        if (scope.analogData[i].channel == data.CH) {
                            toaster.pop('success', scope.windowTitle, 'View reloading');
                            _getData(scope.deviceSelected);
                        }
                    }
                }
                scope.$apply();
            };

            var wsDataReceivedDIGITALSETTINGRV = function (data) {
                if (scope.liveData === false) {
                    _unRegisterListener(scope.deviceSelectedSn);
                    return;
                }
                if(data.Type == 'DIGITALSETTING' && data.SN == scope.deviceSelectedSn )
                {
                    for (var i = 1; i <= 8; i++) {
                        if (i == data.CH) {
                            toaster.pop('success', scope.windowTitle, 'View reloading');
                            _getData(scope.deviceSelected);
                        }
                    }
                }
                scope.$apply();
            };

            var wsReconnectANALOG = function (data) {
                if (scope.liveData === false) {
                    _unRegisterListener(scope.deviceSelectedSn);
                    return;
                }
                if (data.Channel == scope.analogData[0].channel) {
                    toaster.pop('success', scope.windowTitle, 'View reloading');
                    _getData(scope.deviceSelected);
                }
            };

            scope.getTime = function (time) {
                return (time === '0001-01-01T00:00:00' || time === 'Jan 01 1901 12:00:00 AM') ? scope.translation.text.UNKNOWN : datetimeService.formatDateAgentText(time, 'yyyy-MM-ddTHH:mm:ss', false, scope.timeFormat);
            };

            var _registerListener = function (varSelectedSN) {
                websocketService.connect();
                for (var i = 0; i < scope.analogData.length; i++) {
                    websocketService.register("ANALOG", varSelectedSN, scope.analogData[i].channel, wsDataReceivedANALOG, wsReconnectANALOG);
                    websocketService.register("ANALOG_G2", varSelectedSN, scope.analogData[i].channel, _wsUpdateAnalogG2, wsReconnectANALOG);
                     websocketService.register("ANALOGRAW", varSelectedSN, scope.analogData[i].channel, _wsUpdateAnalogRaw, wsReconnectANALOG);
                    if (!scope.liveAnalogSetting) websocketService.register("ANALOGSETTING", varSelectedSN, scope.analogData[i].channel, wsDataReceivedANALOGSETTINGRV, null);
                }
                for (var j = 1; j <= 8; j++) {
                    websocketService.register("DIGITALSETTING", varSelectedSN, j, wsDataReceivedDIGITALSETTINGRV, null);
                }
                scope.liveData = true;
                scope.liveAnalogSetting = true;
            };

            var _unRegisterListener = function (varSelectedSN) {
                for (var i = 1; i <= 9; i++) {
                    websocketService.unRegister("ANALOG", varSelectedSN, i, wsDataReceivedANALOG, wsReconnectANALOG);
                    websocketService.unRegister("ANALOG_G2", varSelectedSN, i, _wsUpdateAnalogG2, wsReconnectANALOG);
                    websocketService.unRegister("ANALOGRAW", varSelectedSN, i, _wsUpdateAnalogRaw, wsReconnectANALOG);
                }
                scope.liveData = false;
                scope.lastUpdateAt = undefined;
            };

            var _unRegisterListenerAnlogSetting = function (varSelectedSN) {
                for (var i = 1; i <= 9; i++) {
                    websocketService.unRegister("ANALOGSETTING", varSelectedSN, i, wsDataReceivedANALOGSETTINGRV, null);
                }
                scope.liveAnalogSetting = false;
            };
            var _unRegisterListenerDigitalSetting = function (varSelectedSN) {
                for (var k = 1; k <= 6; k++) {
                    websocketService.unRegister("DIGITALSETTING", varSelectedSN, k, wsDataReceivedDIGITALSETTINGRV, null);
                }
            };

            scope.$on("$destroy", function () {
                _unRegisterListener(scope.deviceSelectedSn);
                _unRegisterListenerAnlogSetting(scope.deviceSelectedSn);
                _unRegisterListenerDigitalSetting(scope.deviceSelectedSn);
            });

            scope.$on('rtuViewRefreshButtonClicked', function (event, args) {
                if (scope.deviceSelected !== args) return;
                _getData(scope.deviceSelected);
            });
        }
        return {
            link: link
        };
    }
]);

mcapp.directive('rtuViewAnalogOutputDirective', ["$timeout", "authenticationService", "websocketService", "rtuDataService", "deviceService", "toaster", "openViewService", "datetimeService", "sharedSetupService", "McWidgetsSharedFactory",
    function ($timeout, authenticationService, websocketService, rtuDataService, deviceService, toaster, openViewService, datetimeService, sharedSetupService, McWidgetsSharedFactory) {
        function link(scope, element, attrs) {
            scope.rtuViewBusy = true;
            scope.liveAnalogSetting = false;
            element.closest('.ui-dialog-content').css("overflow", "inherit"); //Device Select menu is cut off

            if (angular.isUndefined(scope.mcWidgetsSharedFactory)) scope.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            element
                .tooltip({
                    track: true,
                    tooltipClass: 'tooltip-jq',
                    content: function () {
                        return $(this).prop('title');
                    }
                });

            element.on(
                "mouseover.rtuViewAnalogOutputDirective",
                ".hcolAnalogOutputRtu",
                function (event) {
                    var localScope = $(event.target).scope();
                    if ($(event.currentTarget).is(".hcolAnalogOutputRtu")) {
                        if (!scope.mobile && !scope.classicView) {
                            $(event.currentTarget).draggable({
                                helper: "clone",
                                revert: false,
                                appendTo: "body",
                                containment: "body",
                                opacity: 0.35,
                                stop: function (event, ui) {
                                    //var tmpSize = scope.mcWidgetsSharedFactory.getSize(ui.helper.attr("mc-size"), 1);
                                    var mcDevice = { deviceId: scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: scope.deviceSelectedSn, deviceName: scope.deviceSelectedName };
                                    var optionsStickyProperties = {
                                        deviceId: scope.deviceSelected,
                                        device: mcDevice
                                    };
                                    var $newPosX = ui.offset.left;
                                    var $newPosY = ui.offset.top;
                                    var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                                    openViewService.openWidget('Mc Single Needle Gauge Analog Output Widget', { width: 240, height: 240 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                    scope.$apply();
                                }
                            });
                        }
                    }
                }
            );

            if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

            scope.$watch('lastUpdateAt', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    scope.liveDataIn = !scope.liveDataIn;
                    $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
                }
            }, true);

            scope.$watch('deviceSelected', function (newValue, oldValue) {
                if (newValue) {                    
                    scope.rtuViewBusy = true;
                    scope.alerts = [];
                    scope.lastUpdateAt = undefined;
                    var _device = { deviceName: scope.deviceSelectedName };
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                    scope.stickyProperties.on = scope.stickyProperties.on !== null ? true : false;
                    
                    _getData(newValue);
                }
            }, true);

            var _getData = function (deviceID, adjustView) {                
                rtuDataService.getRTUViewAnalogOutputData(deviceID, scope.accountInfo.customerId, scope.deviceSelectedType, scope.accountInfo.timeZone)
                    .then(function (result) {
                        scope.analogOutputData = result.data;
                        scope.rtuAnalogOutput = scope.analogOutputData.length;
                        scope.$emit('rtuAnalogOutputDone_' + scope.windowId, { message: scope.rtuAnalogOutput });
                        if (scope.analogOutputData.length > 0) {
                            /*  Removing this item so that time is not formatted so we can apply time format from preferences :JS 9/19/17
                            for (var i = 0; i < scope.analogData.length; i++) {
                                scope.analogData[i].localDateTime = datetimeService.formatDateAgentText(scope.analogData[i].localDateTime, 'yyyy-MM-ddTHH:mm:ss');
                              } */
                            _scaleValues();
                            _registerListener(scope.deviceSelectedSn);
                        }
                        else {
                            scope.alerts.push({ msg: scope.translation.message.NO_ANALOG_SETUP, type: "info" });
                        }
                        scope.rtuViewBusy = false;

                        if (adjustView)
                            $timeout(function () { scope.resizeModal() }, 0);

                    }, function (error) {
                        scope.alerts = [];
                        if (!error) error = { data: { message: "GENERAL_SERVER_ERROR" } };
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                    });
            };

            var _scaleValues = function () {
                for (var i = 0; i < scope.analogOutputData.length; i++) {
                    if (scope.analogOutputData[i].maxVal < scope.analogOutputData[i].minVal) {
                        scope.analogOutputData[i].tempMaxVal = scope.analogOutputData[i].minVal - scope.analogOutputData[i].maxVal;
                        scope.analogOutputData[i].tempValue = (scope.analogOutputData[i].tempMaxVal - scope.analogOutputData[i].latestData) + scope.analogOutputData[i].maxVal;
                    }
                    else {
                        scope.analogOutputData[i].tempMaxVal = scope.analogOutputData[i].maxVal - scope.analogOutputData[i].minVal;
                        scope.analogOutputData[i].tempValue = scope.analogOutputData[i].latestData - scope.analogOutputData[i].minVal;
                    }                    
                }
            };
            scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    if (oldValue) {
                        _unRegisterListener(oldValue);                        
                    }
                }
            }, true);

            var wsDataReceivedANALOGOUT = function(data) {
                if (scope.liveData === false) {
                    _unRegisterListener(scope.deviceSelectedSn);
                    return;
                }

                for (var i = 0; i < scope.analogOutputData.length; i++) {
                    if (scope.analogOutputData[i].channel == data.CH) {
                        var rawLatestData = parseFloat(data.Value);
                        scope.analogOutputData[i].latestData = scope.analogOutputData[i].minVal + (rawLatestData / 255 * (scope.analogOutputData[i].maxVal - scope.analogOutputData[i].minVal));                        
                        scope.analogOutputData[i].localDateTime = datetimeService.socketStrToServerStrTime(data.Time);
                    }
                    _scaleValues();
                }
                var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                scope.lastUpdateAt = varTime;
                scope.deviceInfo.lastTimeHeard = varTime;
                scope.$apply();                            
            };
            
            var wsReconnectANALOGOUT = function (data) {
                if (scope.liveData === false) {
                    _unRegisterListener(scope.deviceSelectedSn);
                    return;
                }
                if (data.Channel == scope.analogOutputData[0].channel) {
                    toaster.pop('success', scope.windowTitle, 'View reloading');
                    _getData(scope.deviceSelected);
                }
            };

            scope.getTimeAnalogOutput = function (time) {
                return (time === '0001-01-01T00:00:00' || time === 'Jan 01 1901 12:00:00 AM') ? scope.translation.text.UNKNOWN : datetimeService.formatDateAgentText(time, 'yyyy-MM-ddTHH:mm:ss', false, scope.timeFormat);
            };

            var _registerListener = function (varSelectedSN) {
                websocketService.connect();
                for (var i = 0; i < scope.analogOutputData.length; i++) {
                    websocketService.register("ANALOGOUT", varSelectedSN, scope.analogOutputData[i].channel, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);                    
                }                
                scope.liveData = true;
                scope.liveAnalogSetting = true;
            };

            var _unRegisterListener = function (varSelectedSN) {
                for (var i = 1; i <= 6; i++) {
                    websocketService.unRegister("ANALOGOUT", varSelectedSN, i, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);
                }
                scope.liveData = false;
                scope.lastUpdateAt = undefined;
            };
            
            scope.$on("$destroy", function () {
                _unRegisterListener(scope.deviceSelectedSn);               
            });

            scope.$on('rtuViewRefreshButtonClicked', function (event, args) {
                if (scope.deviceSelected !== args) return;
                _getData(scope.deviceSelected);
            });

            scope.$on('rtuAnalogOutputUpdate', function (event, args) {                
                if (scope.deviceSelected !== args.deviceId) return;
                _getData(scope.deviceSelected, true); 
            });            
        }
        return {
            link: link
        };
    }
]);

mcapp.factory('rtuDataService', ['$http', 'HOST', function ($http, HOST) {
    var rtuDataFactory = {};

    var _getData = function (customerId, deviceId, solar, lastHeardTime, hasRMDTRadio, model, timeZone) {
        return $http({
            method: 'Get',
            url: HOST + '/api/RtuData?customerId=' + customerId + '&deviceId=' + deviceId +
                        '&Solar=' + solar + '&LastHeardTime=' + lastHeardTime + '&HasRMDTRadio=' + hasRMDTRadio + '&Model=' + model+ '&TimeZone=' + timeZone,
            cache: false
        });
    };

    var _getDeviceData = function (customerId, deviceId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/Device?deviceId=' + deviceId + '&customerId=' + customerId,
            cache: false
        });
    };

    var _getDeviceUnitState = function (deviceId, customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/DeviceUnitState?deviceId=' + deviceId + '&customerId=' + customerId,
            cache: false
        });
    }
    var _getRTUViewRelayData = function (deviceId, customerId, hasAdamsRelayModule, timeZone) {
        return $http({
            method: 'GET',
            url: HOST + '/api/RTUView?customerId=' + customerId + '&deviceId=' + deviceId + '&hasAdamsRelayModule=' + hasAdamsRelayModule + '&timeZone=' + timeZone,
            cache: false
        });
    }

    var _getRTUViewAnalogOutputData = function (deviceId, customerId, deviceType, timeZone) {
        return $http({
            method: 'Get',
            url: HOST + '/api/AnalogOutputRtuView?customerId=' + customerId + '&deviceId=' + deviceId + '&deviceType=' + deviceType + '&timeZone=' + timeZone,
            cache: false
        });
    }

    var _getRtuModel = function (deviceId, customerId, hasAdamsRelayModule, timeZone) {
        return $http({
            method: 'Get',
            url: HOST + '/api/RTUView/Model/?deviceId=' + deviceId + '&customerId=' + customerId + '&hasAdamsRelayModule=' + hasAdamsRelayModule + '&timeZone=' + timeZone,
            cache: false
        });
    }

    rtuDataFactory.getData = _getData;
    rtuDataFactory.getDeviceData = _getDeviceData; 
    rtuDataFactory.getDeviceUnitState = _getDeviceUnitState;
    rtuDataFactory.getRTUViewRelayData = _getRTUViewRelayData;
    rtuDataFactory.getRTUViewAnalogOutputData = _getRTUViewAnalogOutputData;
    rtuDataFactory.getRtuModel = _getRtuModel;
    return rtuDataFactory;
}]);

'use strict';

angular.module("mc.rtu-setting", ['mc.rtu-configuration', 'mc.rtu-info']);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RtuSettingController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, UpdateDeviceInfoFactory, deviceMenuService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.firstLoad = true;
    ctrl.gen2Tabs = false;
    ctrl.ourMmPlusDevice = false;
    ctrl.isRangerDevice = false;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        ctrl.isAdmin = sharedSetupService.isAdmin(ctrl.accountInfo);
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        $scope.stickyProperties = ctrl.stickyProperties;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        if (ctrl.accountInfo.numberOfDevices == 0) ctrl.selectedTab = 5;
        sharedSetupService.getWindowId(_this2);
        ctrl.initializeSetting();
        //ctrl.updateDeviceInfoFactory = new UpdateDeviceInfoFactory(ctrl.accountInfo.customerId, $scope.stickyProperties.device.deviceId, $element, ctrl.windowTitle, $scope);

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        };
    };

    ctrl.adjustSize = function () {
        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": "RtuInfo",
            "name": ctrl.translation.text.RTU_INFO,
            "templateName": "RTU Info",
            "templateUrl": "ui/rtuinfo/rtu-info.html",
            "height": 135
        }, {
            "id": "RtuConfiguration",
            "name": ctrl.translation.text.RTU_CONFIGURATION,
            "templateName": "RTU Configuration",
            "templateUrl": "ui/rtuconfiguration/rtu-configuration.html",
            "height": 150
        }, {
            "id": "RtuConfigurationGenTwo",
            "name": ctrl.translation.text.RTU_CONFIGURATION,
            "templateName": "RTU Configuration",
            "templateUrl": "ui/mmplusrtusetting/configuration/mm-plus-configuration-rtu-setting.html",
            "height": 135
        }, {
            "id": "RtuNetwork",
            "name": ctrl.translation.text.RTU_NETWORK,
            "templateName": "RTU Network",
            "templateUrl": "ui/mmplusrtusetting/network/mm-plus-network-rtu-setting.html",
            "height": 150
        }, {
            "id": "RtuChannel",
            "name": "RTU " + ctrl.translation.text.CHANNEL,
            "templateName": "RTU Channel",
            "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/mm-plus-channel-rtu-setting.html",
            "height": 150
        }, {
            "id": "RtuList",
            "name": "RTU List",
            "templateName": "RTU List",
            "templateUrl": "ui/rtulist/rtu-list.html",
            "height": 150
        }, {
            "id": "EbpcConfig",
            "name": "EBPC " + ctrl.translation.text.CONFIGURATION,
            "templateName": "EBPC Config",
            "templateUrl": "ui/ebpcconfigrtusetting/ebpc-config-rtu-setting.html",
            "height": 150
        }
        // {
        //     "id": "RadioSwap",
        //     "name": "Radio Swap",
        //     "templateName": "Radio Swap",
        //     "templateUrl": "ui/rtulist/rtu-list.html",
        //     "height": 150
        // }
        );
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/missionreportssetup/' + tab.templateName.toLowerCase().replace(' ', '-') + '-tab.html';
    };

    ctrl.switchTab = function (tabName) {
        // if (tabName == "Radio Swap") {
        //     ctrl.selectedTab = 6;
        // }
        if (tabName == "EBPC Configuration") {
            ctrl.selectedTab = 6;
        } else if (tabName == "RTU List") {
            ctrl.selectedTab = 5;
        } else if (tabName == "Channel") {
            ctrl.selectedTab = 4;
        } else if (tabName == "Network") {
            ctrl.selectedTab = 3;
        } else if (tabName == "Config") {
            ctrl.selectedTab = 2;
        } else if (tabName == "RTU Configuration") {
            ctrl.selectedTab = 1;
        } else {
            ctrl.selectedTab = 0;
        }
    };

    $scope.$watch('stickyProperties', function (newValue, oldValue) {
        if (newValue && (ctrl.firstLoad || newValue.device.deviceId != oldValue.device.deviceId)) {
            ctrl.deviceId = newValue.device.deviceId;

            //ctrl.ourMmPlusDevice = ctrl.deviceId == 50007 ? true : false;

            deviceMenuService.isMmPlusOrGenII(ctrl.accountInfo.customerId, ctrl.deviceId).then(function (isMmPlusOrGenIIDevice) {
                if (isMmPlusOrGenIIDevice) {
                    ctrl.alertMessage = null;
                    $timeout(function () {
                        ctrl.allTabs(true);
                        ctrl.isRangerDevice = deviceMenuService.getIsRanger();
                    }, 0);
                } else {
                    $timeout(function () {
                        ctrl.allTabs(false);
                    }, 0);
                }
            });

            ctrl.firstLoad = false;
        }
    }, true);

    ctrl.allTabs = function (all) {
        $timeout(function () {
            ctrl.selectedTab = 0;
        }, 0);
        if (!ctrl.isMcAdmin) return;
        ctrl.gen2Tabs = all;
    };

    ctrl.checkGen2Tabs = function (args) {
        if (args.id == 15) {
            ctrl.gen2Tabs = false;
            ctrl.ourMmPlusDevice = true;
        } else if (args.id == 20) {
            ctrl.gen2Tabs = true;
            ctrl.ourMmPlusDevice = false;
        } else if (args.id == 21) {
            ctrl.gen2Tabs = true;
            ctrl.ourMmPlusDevice = false;
            ctrl.isRangerDevice = true;
        }
    };

    ctrl.rtuSettingTabs = ctrl.tabConfiguration;

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on('updateGen2Tabs', function (event, args) {
        ctrl.checkGen2Tabs(args);
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });
};

RtuSettingController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'UpdateDeviceInfoFactory', 'deviceMenuService'];
'use strict';

angular.module('mc.rtu-setting').component('rtuSetting', {
    controller: RtuSettingController,
    templateUrl: 'ui/rtusetting/rtu-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

mcapp.controller('rtuListTabController', ['$rootScope', '$scope', 'sharedSetupService', 'translationService', 'authenticationService', '$timeout', 'deviceRtuListSettingService', "modalService", "datetimeService", "deviceMenuService", "checkDeviceDataService", "$q", "$window", function ($rootScope, $scope, sharedSetupService, translationService, authenticationService, $timeout, deviceRtuListSettingService, modalService, datetimeService, deviceMenuService, checkDeviceDataService, $q, $window) {
    var ctrl = this;
    $scope.devicename = null;
    $scope.unit = null;
    $scope.updateStatusProperty = undefined;
    $scope.alerts = [];
    $scope.rtuDataConfiguration = [];
    $scope.accountInfo = authenticationService.getAccountInfo();
    var _targetField = null;
    var _errorCheck = "<i class='fa fa-exclamation-circle fa-2x fa-red'></i>";
    var _resetIndicator = "<i class='fa fa-fw fa-2x'>&nbsp;</i>";
    //$scope.loadingInProgress = true;
    //only McAdmin users has access to feature to Add New Device
    $scope.isMcAdmin = sharedSetupService.mcAdmin();
    $scope.isAdmin = sharedSetupService.isAdmin($scope.accountInfo);
    $scope.mapIcons = [];
    $scope.hasRequiredValues = false;
    var _latitude = 0;
    var _longitude = 0;
    var _suppressFocusCallback = false;
    var _focusTimeout = 0;

    //No Duplicates are allowed for following fields
    //"serialNumber"
    //"radioEsn"
    //"imei"
    //"simNumber"
    //"txId1"
    //"txId2"

    /////////////////***Default setup***/////////////////
    /////////////////***Default setup***/////////////////
    /////////////////***Default setup***/////////////////
    var tmpWirelessCarrier = {
        "id": "C",
        "name": "AT&T"
    };

    var tmpDeviceModel = {
        "id": 8,
        "name": "Model 110"
    };

    if ($window.sessionStorage.addNewRtu !== null && $window.sessionStorage.addNewRtu !== "null" && $window.sessionStorage.addNewRtu !== undefined) {
        var currentSessionAddNewRtu = JSON.parse($window.sessionStorage.addNewRtu);

        tmpWirelessCarrier = {
            "id": currentSessionAddNewRtu.wirelessCarrier.id,
            "name": currentSessionAddNewRtu.wirelessCarrier.name
        };

        tmpDeviceModel = {
            "id": parseInt(currentSessionAddNewRtu.deviceModel.id),
            "name": currentSessionAddNewRtu.deviceModel.name
        };
    }
    /////////////////***Default setup***/////////////////
    /////////////////***Default setup***/////////////////
    /////////////////***Default setup***/////////////////

    $scope.deviceModel = [{
        "id": 8,
        "name": "Model 110"
    }, {
        "id": 9,
        "name": "Model 800"
    }, {
        "id": 10,
        "name": "Model M80"
    }, {
        "id": 15,
        "name": "Manhole Monitor"
    }, {
        "id": 17,
        "name": "MyDro M120(*New)"
    }, {
        "id": 18,
        "name": "MyDro M150"
    }, {
        "id": 19,
        "name": "MyDro M850"
    }, {
        "id": 20,
        "name": "M84"
    }, {
        "id": 21,
        "name": "M50"
    }];
    $scope.skus = [{ SKUID: 0, SKUName: 'M84-O' }, { SKUID: 1, SKUName: 'M84-F' }, { SKUID: 2, SKUName: 'M84-L' }];

    $scope.wirelessCarrier = [{
        "id": "C",
        "name": "AT&T"
    }, {
        "id": "K",
        "name": "Sprint Socket"
    }, {
        "id": "N",
        "name": "Nextel"
    }, {
        "id": "R",
        "name": "Rogers"
    }, {
        "id": "T",
        "name": "T-Mobile"
    }, {
        "id": "Z",
        "name": "Verizon Socket"
    }, {
        "id": "L",
        "name": "Telenor"
    }];
    $scope.simModeOptions = [{
        "id": 0, //false
        "name": $scope.translation.text.AUTO //"Automatic"
    }, {
        "id": 1, //true
        "name": $scope.translation.text.MANUAL //"Manual"
    }];
    $scope.simPriorityOptions = [{
        "id": 1,
        "name": $scope.translation.text.EMBEDDED_SIM //"Embedded"
    }, {
        "id": 2,
        "name": $scope.translation.text.REMOVABLE_SIM //"Removable"
    }];

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            $scope.ntfTabUpdate = false;
            $timeout(function () {
                $scope.ntfTabUpdate = true;
            }, 0);

            var _device = { deviceId: newValue, deviceName: $scope.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });
        }
    }, true);

    var _rtuDataConfiguration = function _rtuDataConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = $scope.rtuDataConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                $scope.rtuDataConfiguration.push(arguments[i]);
            } else {
                $scope.rtuDataConfiguration[i].name = arguments[i].name;
                $scope.rtuDataConfiguration[i].validationRequirement = arguments[i].validationRequirement;
            }
        }
    };
    var initializeDummyDeviceProperties = function initializeDummyDeviceProperties() {
        var today = new Date().toUTCString();
        _rtuDataConfiguration({
            "id": "serialNumber",
            "label": $scope.translation.text.SERIAL_NUMBER,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^\S{10,10}$/,
            "validationRequirement": $scope.translation.text.SERIAL_NUMBER_ERR,
            "floatRight": false,
            "maxLength": 10,
            "required": true,
            "duplicateAllowed": false,
            "isValid": false,
            "isDuplicate": false,
            "value": "",
            "disabled": false,
            "isChanged": false
        }, {
            "id": "name",
            "label": $scope.translation.text.DEVICE_NAME,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^.{1,100}$/,
            "validationRequirement": $scope.translation.text.SITE_NAME_ERR,
            "floatRight": false,
            "maxLength": 100,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": "",
            "disabled": false,
            "isChanged": false
        }, {
            "id": "location",
            "label": $scope.translation.text.LOCATION_DESCRIPTION,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^.{0,150}$/,
            "validationRequirement": $scope.translation.text.LOCATION_DESCRIPTION_ERR,
            "floatRight": false,
            "maxLength": 150,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": "",
            "disabled": false,
            "isChanged": false
        }, {
            "id": "ttsLocation",
            "label": "TTS Device Location",
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^.{0,150}$/,
            "validationRequirement": $scope.translation.text.LOCATION_DESCRIPTION_ERR,
            "floatRight": false,
            "maxLength": 150,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": "",
            "disabled": false,
            "isChanged": false
        }, {
            "id": "model",
            "label": $scope.translation.text.DEVICE_TYPE,
            "type": "selectModel",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": "",
            "validationRequirement": $scope.translation.text.DEVICE_TYPE_ERR,
            "floatRight": false,
            "maxLength": 1,
            "required": true,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": tmpDeviceModel,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "sku",
            "label": "M84 SKU",
            "type": "selectSKU",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": "",
            "validationRequirement": $scope.translation.text.DEVICE_TYPE_ERR,
            "floatRight": false,
            "maxLength": 1,
            "required": false,
            "duplicateAllowed": false,
            "isValid": true,
            "value": null,
            "isDuplicate": false,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "softwareVersion",
            "label": $scope.translation.text.SOFTWARE_VERSION,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^[0-9]+(\.[0-9]+)?$/,
            "validationRequirement": $scope.translation.text.SOFTWARE_VERSION_ERR,
            "floatRight": false,
            "maxLength": 6,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": null,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "wirelessCarrier",
            "label": $scope.translation.text.WIRELESS_CARRIER,
            "type": "selectCarrier",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": "",
            "validationRequirement": $scope.translation.text.WIRELESS_CARRIER_ERR,
            "floatRight": false,
            "maxLength": 1,
            "required": true,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": tmpWirelessCarrier,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "txId1",
            "label": $scope.translation.text.TXID1_MSID,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^\d{0,15}$/,
            "validationRequirement": $scope.translation.text.TXID1_MSID_IN_SPRINT_ERR,
            "floatRight": false,
            "maxLength": 15,
            "required": true,
            "duplicateAllowed": false,
            "isValid": false,
            "isDuplicate": false,
            "value": null,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "txId2",
            "label": $scope.translation.text.TXID2_MDN,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^\d{0,15}$/,
            "validationRequirement": $scope.translation.text.TXID2_MDN_IN_SPRINT_ERR,
            "floatRight": false,
            "maxLength": 15,
            "required": false,
            "duplicateAllowed": false,
            "isValid": true,
            "isDuplicate": false,
            "value": null,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "installDate",
            "label": $scope.translation.text.INSTALL_DATE,
            "type": "date",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": "", ///(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
            "validationRequirement": "[Install Date Error]",
            "floatRight": true,
            "maxLength": 10,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": null,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "motherboardSerialNumber",
            "label": $scope.translation.text.MOTHERBOARD_SN,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^\S{0,15}$/,
            "validationRequirement": $scope.translation.text.MOTHERBOARD_SN_ERR,
            "floatRight": true,
            "maxLength": 15,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": null,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "daughterBoardSerialNumber",
            "label": $scope.translation.text.DAUGHTERBOARD_SN,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^\S{0,15}$/,
            "validationRequirement": $scope.translation.text.DAUGHTERBOARD_SN_ERR,
            "floatRight": true,
            "maxLength": 15,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": null,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "imei",
            "label": $scope.translation.text.IMEI,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^\d{0,15}$/,
            "validationRequirement": $scope.translation.text.IMEI_ERR,
            "floatRight": true,
            "maxLength": 15,
            "required": true,
            "duplicateAllowed": false,
            "isValid": false,
            "isDuplicate": false,
            "value": null,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "simNumber",
            "label": $scope.translation.text.REMOVABLE_SIM,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^\S{0,20}$/,
            "validationRequirement": $scope.translation.text.SIM_NUMBER_ERR,
            "floatRight": true,
            "maxLength": 20,
            "required": false,
            "duplicateAllowed": false,
            "isValid": true,
            "isDuplicate": false,
            "value": null,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "secondarySIMNumber",
            "label": $scope.translation.text.EMBEDDED_SIM,
            "type": "text",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": /^\S{0,20}$/,
            "validationRequirement": $scope.translation.text.SIM_NUMBER_ERR,
            "floatRight": true,
            "maxLength": 20,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": null,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "simPriority",
            "label": $scope.translation.text.SIM_PRIORITY,
            "type": "selectSimPriority",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": "",
            "validationRequirement": "[Sim Priority Error]",
            "floatRight": true,
            "maxLength": 1,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": {
                "id": "1",
                "name": $scope.translation.text.EMBEDDED_SIM //"Embedded"
            },
            "disabled": false,
            "isChanged": false
        }, {
            "id": "simMode",
            "label": $scope.translation.text.SIM_MODE,
            "type": "selectSimMode",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": "",
            "validationRequirement": "[Sim Mode Error]",
            "floatRight": true,
            "maxLength": 1,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": {
                "id": "0",
                "name": $scope.translation.text.AUTO //"Automatic"
            },
            "disabled": false,
            "isChanged": false
        }, {
            "id": "manufactureDate",
            "label": $scope.translation.text.MANUFACTURE_DATE,
            "type": "date",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": "", ///(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
            "validationRequirement": $scope.translation.text.MANUFACTURE_DATE_ERR,
            "floatRight": true,
            "maxLength": 10,
            "required": true,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": today,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "programDate",
            "label": $scope.translation.text.PROGRAM_DATE,
            "type": "date",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": "", ///(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
            "validationRequirement": $scope.translation.text.PROGRAM_DATE_ERR,
            "floatRight": true,
            "maxLength": 10,
            "required": true,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": today,
            "disabled": false,
            "isChanged": false
        }, {
            "id": "iconId",
            "label": $scope.translation.text.ICON,
            "type": "selectIcon",
            "status": _resetIndicator,
            "statusMessage": "",
            "regEx": "",
            "validationRequirement": "[Icon Error]",
            "floatRight": true,
            "maxLength": 1,
            "required": false,
            "duplicateAllowed": true,
            "isValid": true,
            "isDuplicate": false,
            "value": null,
            "disabled": false,
            "isChanged": false
        });
    };

    $scope.addDummyDevice = function () {
        $scope.addMode = true;
        initializeDummyDeviceProperties();

        var mapIconsPromise = deviceRtuListSettingService.getMapIcons($scope.accountInfo.customerId);
        var menuListPromise = deviceMenuService.getDeviceMenuList($scope.accountInfo.customerId);
        $q.all([mapIconsPromise, menuListPromise]).then(function (results) {
            var mapIconsResult = results[0];
            var menuListResult = results[1];
            $scope.mapIcons = mapIconsResult.data;
            $scope.deviceMenuList = menuListResult.data.devices;
            //filter device list with selected device model
            $scope.filterDeviceList(_findItem("model").value.id);
            // Initialize the object
            $scope.formData = {};
            // Set the specific property to null to trigger the default option
            $scope.formData.migrateFromDevice = null;
        }).catch(function (error) {
            console.error(error);
        });
    };

    $scope.isM84Selected = function () {
        var model = _findItem("model");
        return !!(model && model.value && model.value.id === 20);
    };

    $scope.filterDeviceList = function (selectedModel) {
        if (!selectedModel) {
            return $scope.deviceMenuList; // Return original list if no model is passed
        }

        // Returns a new array containing only devices that match the model number
        var filteredList = $scope.deviceMenuList.filter(function (device) {
            return device.model === selectedModel;
        });

        $scope.filteredDeviceList = filteredList;
    };

    var _resetErrorStatus = function _resetErrorStatus() {
        for (var i = 0; i < $scope.rtuDataConfiguration.length; i++) {
            $scope.rtuDataConfiguration[i].status = _resetIndicator;
            $scope.rtuDataConfiguration[i].statusMessage = "";
        }
        return true;
    };

    var _getErrorClass = function _getErrorClass() {
        return "val-error";
    };

    //var _getElement = function () {
    //    return (typeof e !== "undefined") ? e.target : _targetField;
    //};

    var resetItemsStatus = function resetItemsStatus() {
        for (var i = 0; i < $scope.rtuDataConfiguration.length; i++) {
            $scope.rtuDataConfiguration[i].disabled = false;
            $scope.rtuDataConfiguration[i].status = $scope.resetIndicator;
            $scope.rtuDataConfiguration[i].statusMessage = "";
            //$('.tooltip-error-message').hide().remove();
        }
    };

    var disableItemsStatus = function disableItemsStatus(item) {
        for (var i = 0; i < $scope.rtuDataConfiguration.length; i++) {
            if ($scope.rtuDataConfiguration[i].id !== item.id) $scope.rtuDataConfiguration[i].disabled = true;
        }
    };

    $scope.validate = function (item, event) {
        if (event.target !== _targetField) {
            _targetField.focus();
            return;
        }
        item.isChanged = true;

        var _errorClass = _getErrorClass();

        if (!_isValid(item)) {
            //NOT valid
            _throwError(item.id, event);
            _setIsValidProperty(item.id, false);
            return false;
        }
        if (item.isDuplicate) {
            //check again whether it is still Duplicate
            checkDeviceDataService.checkData(item.id, -1, item.value).then(function (result) {
                if (result.data !== null) {
                    //already exists
                    _setIsDuplicateProperty(item.id, true);
                    _throwError(item.id, event, true);
                    return false;
                } else {
                    //DO NOT exists
                    _setIsDuplicateProperty(item.id, false);
                    _resetErrorStatus();
                    $('.tooltip-error-message').hide(100);
                    $(_targetField).removeClass(_errorClass);
                    resetItemsStatus();
                    return true;
                }
            }, function (error) {});
        }
        //It is Valid
        _resetErrorStatus();
        $('.tooltip-error-message').hide(100);
        $(_targetField).removeClass(_errorClass);
        _setIsValidProperty(item.id, true);
        if (_suppressFocusCallback) _suppressFocusCallback = false;
        return true;
    };

    var _isValid = function _isValid(item) {
        var letTest = true;
        var retVal = true;
        //required & empty
        if (item.required && (!item.value || typeof item.value === "string" && item.value.trim() === "")) {
            retVal = false;
            letTest = false;
        }
        //NOT required & empty
        if (!item.required && (!item.value || typeof item.value === "string" && item.value.trim() === "")) {
            retVal = true;
            letTest = false;
        }
        if (item.id === "sku") {
            retVal = false;
        }
        //test against regex
        if (letTest && item.regEx && item.regEx.test(item.value) === false) {
            retVal = false;
        }

        return retVal;
    };

    var _setIsValidProperty = function _setIsValidProperty(propertyName, isValid) {
        angular.forEach($scope.rtuDataConfiguration, function (item, index) {
            if (item.id === propertyName) item.isValid = isValid;
        });
        _IsAllRequiredFieldsValid();
    };
    var _setIsDuplicateProperty = function _setIsDuplicateProperty(propertyName, isDuplicate) {
        angular.forEach($scope.rtuDataConfiguration, function (item, index) {
            if (item.id === propertyName) item.isDuplicate = isDuplicate;
        });
        _IsAllRequiredFieldsValid();
    };

    var _IsAllRequiredFieldsValid = function _IsAllRequiredFieldsValid() {
        //$scope.hasRequiredValues = !$scope.rtuDataConfiguration.some(item => !item.isValid);
        $scope.hasRequiredValues = !$scope.rtuDataConfiguration.some(function (item) {
            var duplicateExists = item.isDuplicate && !item.duplicateAllowed;
            return !item.isValid || duplicateExists;
        });
    };

    var _throwError = function _throwError(propertyName, $event, serverCheck) {
        var errorClass = _getErrorClass();

        for (var i = 0; i < $scope.rtuDataConfiguration.length; i++) {
            if ($scope.rtuDataConfiguration[i].id == propertyName) {
                $scope.rtuDataConfiguration[i].status = _errorCheck;
                $scope.rtuDataConfiguration[i].statusMessage = serverCheck ? $scope.rtuDataConfiguration[i].id.toUpperCase() + " already exists!" : $scope.rtuDataConfiguration[i].validationRequirement; //Test Error Message!!! Description: ???
            }
        }

        $timeout(function () {
            $(_targetField).addClass(errorClass);
            $(_targetField).parent().find(".tooltip-error-message." + propertyName).show(100);
            $(_targetField).focus();
        }, 150);
    };

    $scope.isExists = function (item, $event) {
        return checkIsExists(item, $event).then(function (result) {
            return result;
        }, function () {});
    };
    // check against backend/database whether device exists with the given property value
    var checkIsExists = function checkIsExists(item, $event) {
        var deferred = $q.defer();

        if ($event && $event.target.id !== item.id) {
            deferred.resolve(false);
            return deferred.promise;
        }

        if (!item.duplicateAllowed) {
            // && (item.id == "serialNumber" || item.id == "radioEsn" || item.id == "imei" || item.id == "simNumber" || item.id == "txId1" || item.id == "txId2")) {
            _focusTimeout = 100;
            checkDeviceDataService.checkData(item.id, -1, item.value).then(function (result) {
                if (result.data == null) {
                    // no duplicate exists
                    _setIsDuplicateProperty(item.id, false);

                    if (item.id === "txId1") {
                        //set imei value same as txId1 for device types (8,9,15,18,19, 20) -- added MM+ to the list
                        var deviceTypeId = _findItem("model").value.id; // $scope.dummyDevice.model.id;
                        if ([8, 9, 15, 18, 19, 20].indexOf(deviceTypeId) > -1) {
                            angular.forEach($scope.rtuDataConfiguration, function (thisItem, index) {
                                if (thisItem.id === "imei") {
                                    thisItem.value = item.value;
                                    _setIsValidProperty("imei", true);
                                    _setIsDuplicateProperty("imei", false);
                                }
                            });
                        }
                    }
                    _focusTimeout = 0;
                    resetItemsStatus();
                    $timeout(function () {
                        deferred.resolve(false);
                    });
                } else {
                    //already exists
                    _setIsDuplicateProperty(item.id, true);
                    //popup error and do not allow user to navigate away from current field
                    $timeout(function () {
                        if ($event !== null) _throwError(item.id, $event, true);
                        _focusTimeout = 0;
                        deferred.resolve(true);
                    });
                }
            }, function (error) {
                deferred.reject(error);
            });
        } else {
            _focusTimeout = 0;
            resetItemsStatus();
            deferred.resolve(false);
        }

        return deferred.promise;
    };

    $scope.focusCallback = function ($event) {
        $timeout(function () {
            if ($event.target) {
                _targetField = $event.target;
            }
            var currentItem = _findItem(_targetField.id);
            if (currentItem && currentItem.required && !currentItem.duplicateAllowed) disableItemsStatus(currentItem);

            _targetField.focus();
        }, _focusTimeout);
    };

    // this is callback function passed to device-location component
    // to return the latitude & longitude to parent component
    $scope.setCoordinates = function (mapOptions) {
        _latitude = mapOptions.latitude;
        _longitude = mapOptions.longitude;
    };

    var _validateAllProperties = function _validateAllProperties() {
        var _loop = function _loop(i) {
            //validate each field
            var propertyName = $scope.rtuDataConfiguration[i].id;
            if (_isValid($scope.rtuDataConfiguration[i])) {
                _setIsValidProperty(propertyName, true);
                //check whether a device with this field value exists
                if (!$scope.rtuDataConfiguration[i].duplicateAllowed) {
                    checkDeviceDataService.checkData(propertyName, -1, $scope.rtuDataConfiguration[i].value).then(function (result) {
                        if (result.data == null) {
                            // no duplicate exists
                            _setIsDuplicateProperty(propertyName, false);
                        } else {
                            _setIsDuplicateProperty(propertyName, true);
                        }
                    }, function (error) {});
                }
            } else if (propertyName === "sku") {
                _setIsValidProperty(propertyName, true);
            } else {
                _setIsValidProperty(propertyName, false);
            }
        };

        for (var i = 0; i < $scope.rtuDataConfiguration.length; i++) {
            _loop(i);
        }
    };

    var _findItem = function _findItem(propertyName) {
        return $scope.rtuDataConfiguration.find(function (item) {
            return item.id === propertyName;
        });
    };

    $scope.getCarrierColor = function (carrierName) {

        if (carrierName.includes('AT&T')) {
            return { 'color': 'blue' };
        } else if (carrierName.includes('Verizon')) {
            return { 'color': 'red' };
        } else if (carrierName.includes('T-Mobile')) {
            return { 'color': 'deeppink' };
        } else if (carrierName.includes('Telenor')) {
            return { 'color': 'darkorange' };
        }
    };
    $scope.saveDevice = function () {
        // Array to hold the promises from our API calls
        var validationPromises = [];

        // 1. Queue up duplicate checks ONLY for items that changed and don't allow duplicates
        angular.forEach($scope.rtuDataConfiguration, function (item) {
            if (item.isChanged && !item.duplicateAllowed) {
                // Push the promise returned by isExists into our array
                validationPromises.push($scope.isExists(item, null));
            }
        });

        // 2. Wait for all queued API calls to finish
        $q.all(validationPromises).then(function () {

            // 3. Check if ANY item was flagged as an illegal duplicate by the server
            var hasForbiddenDuplicate = $scope.rtuDataConfiguration.some(function (item) {
                return item.isDuplicate && !item.duplicateAllowed;
            });

            // 4. If an illegal duplicate exists, exit the function immediately
            if (hasForbiddenDuplicate) {
                console.warn("Save aborted: One or more changed fields have disallowed duplicate values.");
                return;
            }

            // --- Build new device from user input data ---
            var newDevice = {
                "deviceId": -1,
                "customerId": $scope.accountInfo.customerId,
                "name": _findItem("name").value,
                "serialNumber": _findItem("serialNumber").value,
                "model": _findItem("model").value.id,
                "hasLevelSensor": _findItem("sku").value == 2 ? true : false,
                "skuid": _findItem("sku").value,
                "location": _findItem("location").value,
                "motherboardSerialNumber": _findItem("motherboardSerialNumber").value,
                "daughterBoardSerialNumber": _findItem("daughterBoardSerialNumber").value,
                "txId1": _findItem("txId1").value,
                "txId2": _findItem("txId2").value,
                "softwareVersion": _findItem("softwareVersion").value,
                "manufactureDate": _findItem("manufactureDate").value,
                "programDate": _findItem("programDate").value,
                "installDate": _findItem("installDate").value,
                "wirelessCarrier": _findItem("wirelessCarrier").value.id,
                "imei": _findItem("imei").value,
                "timezone": $scope.accountInfo.timeZone,
                "simNumber": _findItem("simNumber").value,
                "disabled": false,
                "latitude": _latitude,
                "longitude": _longitude,
                "ttsLocation": _findItem("ttsLocation").value,
                "secondarySIMNumber": _findItem("secondarySIMNumber").value,
                "iconId": _findItem("iconId").value ? _findItem("iconId").value.id : null,
                "simMode": _findItem("simMode").value.id,
                "simPriority": _findItem("simPriority").value.id,
                "deviceModel": _findItem("model").value.id,
                "migrateFromDeviceId": $scope.formData.migrateFromDevice ? $scope.formData.migrateFromDevice.deviceId : null
            };

            tmpWirelessCarrier = {
                "id": _findItem("wirelessCarrier").value.id,
                "name": _findItem("wirelessCarrier").value.name
            };

            tmpDeviceModel = {
                "id": _findItem("model").value.id,
                "name": _findItem("model").value.name
            };

            $window.sessionStorage.addNewRtu = JSON.stringify({ "wirelessCarrier": tmpWirelessCarrier, "deviceModel": tmpDeviceModel });

            _validateAllProperties();

            if ($scope.hasRequiredValues) {
                deviceRtuListSettingService.postData($scope.accountInfo.customerId, newDevice).then(function (newDeviceResult) {
                    //clean top-menu device list, so that it will forcefully fetch latest device list
                    deviceMenuService.resetDeviceMenuList();
                    //so, first we need to clear the list, then broadcast event to load updated list
                    $rootScope.$broadcast('rtuBasicInfoUpdate');
                    $scope.addMode = false;
                    $scope.hasRequiredValues = false;
                    $scope.rtuDataConfiguration = [];
                    $rootScope.$broadcast('onRtuListDeviceAdd');
                });
            }
        }).catch(function (error) {
            // Handle the scenario where the duplicate check API call itself fails (e.g., network timeout)
            console.error("Failed to validate duplicates via server:", error);
        });
    };
    $scope.cancelDevice = function () {
        //cancel new device
        $scope.rtuDataConfiguration = [];
        $scope.addMode = false;
    };
}]);

mcapp.directive('rtuListTab', ['$timeout', 'deviceRtuListSettingService', '$filter', 'timeLapseService', "$rootScope", "modalService", "$uibModal", function ($timeout, deviceRtuListSettingService, $filter, timeLapseService, $rootScope, modalService, $uibModal) {
    return function (scope, element, attrs) {
        scope.listLoading = true;
        var _getData = function _getData() {
            deviceRtuListSettingService.getData(scope.accountInfo.customerId, scope.accountInfo.customerId).then(function (result) {
                scope.rtuListData = result.data;
                scope.listLoading = false;
            });
        };
        _getData();

        //Log tab access event to NLog
        deviceRtuListSettingService.postUserAction2Nlog(scope.accountInfo.customerId, -1).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        var _selectTab = function _selectTab(id, element, location) {

            var parent = $(element.currentTarget).closest(".rtu-setting-html");

            if (scope.deviceSelected == id) {
                //Select RTU Info Tab
                $timeout(function () {
                    element = !$rootScope.mobile && !$rootScope.classicView ? $(parent).find("#RTU-INFO-TAB") : $("#RTU-INFO-TAB");
                    $(element).click();
                }, 0);
            } else {
                //Select RTU Info Tab
                $timeout(function () {
                    scope.deviceSelected = id;
                }, 0);
            }

            if (!location) return;

            //Select Location Tab
            $timeout(function () {
                element = !$rootScope.mobile && !$rootScope.classicView ? $(parent).find("#Location-rtu-list-selector a") : $("#Location-rtu-list-selector a");
                $(element).click();
            }, 1000);
        };

        scope.editDevice = function (id, element) {
            _selectTab(id, element, false);
        };

        scope.editMap = function (id, element) {
            _selectTab(id, element, true);
        };

        scope.serviceMode = function () {
            modalService.updateRtusServiceMode().then(function () {

                var serviceModeVal = $("#update-all-rtu-timeouts").val();
                var serviceModeVal = parseInt(serviceModeVal);

                deviceRtuListSettingService.putData(scope.accountInfo.customerId, serviceModeVal).then(function (result) {
                    // Sucess!
                });
            }, function () {
                // Do nothing!
            });
        };
        scope.$on('onRtuListDeviceAdd', function () {
            $timeout(function () {
                _getData();
            }, 100);
        });

        scope.openCommonModal = function (device, deleteDevice) {

            scope.rtuListData.forEach(function (item) {
                item.message = null;
            });

            function modalController($uibModalInstance, translation) {
                this.translation = translation;
                if (deleteDevice) {
                    this.tmpConfirmMessageA = this.translation.text.DELETE_DEVICE_MESSAGE_A + device.name + this.translation.text.DELETE_ACCOUNT_MESSAGE_B;
                }
                this.tmpConfirmMessageB = this.translation.text.DELETE_ACCOUNT_MESSAGE_C;

                this.ok = function () {
                    device.progress = true;
                    $uibModalInstance.close(device);
                };

                this.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }

            modalController.$inject = ['$uibModalInstance', 'translation'];

            var modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
                controller: modalController,
                controllerAs: '$ctrl',
                size: 'sm',
                resolve: {
                    translation: function translation() {
                        return scope.translation;
                    }
                }
            });

            modalInstance.result.then(function (device) {
                if (deleteDevice) {
                    deviceRtuListSettingService.deleteDevice(scope.accountInfo.customerId, device.deviceId).then(function (result) {
                        if (result.data) {
                            _getData(); //update device list
                        } else {
                            device.progress = false;
                            device.message = "Could not delete device. Device is still online.";
                        }
                    }, function (error) {
                        device.progress = false;
                    });
                }
            });
        };
    };
}]);

mcapp.factory("deviceRtuListSettingService", ["$http", "HOST", function ($http, HOST) {
    var deviceRtuListSettingFactory = {};
    var _getData = function _getData(customerId, actualCustomerId) {
        var getNetworkOperator = true;
        customerId = actualCustomerId;
        return $http({
            method: 'GET',
            url: HOST + '/api/DeviceStatus',
            params: { customerId: customerId, getNetworkOperator: getNetworkOperator },
            cache: false
        });
    };

    var _putData = function _putData(customerId, serviceModeEnd) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/DeviceNotificationSetting',
            params: { customerId: customerId, serviceModeEnd: serviceModeEnd },
            cache: false
        });
    };

    var _postData = function _postData(customerId, newDevice) {
        return $http({
            method: 'POST',
            url: HOST + '/api/Device',
            data: newDevice,
            params: { customerId: customerId }
        });
    };

    var _getMapIcons = function _getMapIcons(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/Map/Marker/icons',
            params: {
                'customerId': customerId
            }
        });
    };

    var _deleteDevice = function _deleteDevice(customerId, deviceId) {
        return $http({
            method: 'DELETE',
            url: HOST + '/api/Device',
            params: { customerId: customerId, deviceId: deviceId }
        });
    };

    var _postUserAction2Nlog = function _postUserAction2Nlog(customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Rtu List";

        return $http({
            method: 'POST',
            url: HOST + '/api/SwapRadioView',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };
    deviceRtuListSettingFactory.getData = _getData;
    deviceRtuListSettingFactory.putData = _putData;
    deviceRtuListSettingFactory.postData = _postData;
    deviceRtuListSettingFactory.deleteDevice = _deleteDevice;
    deviceRtuListSettingFactory.getMapIcons = _getMapIcons;
    deviceRtuListSettingFactory.postUserAction2Nlog = _postUserAction2Nlog;
    return deviceRtuListSettingFactory;
}]);
mcapp.controller('rtuListController', ['$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', function ($rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService) {
    $scope.devicename = null;
    $scope.unit = null;
    $scope.myDate = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.minPadding = sharedSetupService.minPadding;
    $scope.maxPadding = sharedSetupService.maxPadding;
    $scope.topMenuMarginLeft = $rootScope.mobile ? '-206px' : '-278px';
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
    $scope.loadingInProgress = true;
    $scope.translation = translationService.translation;
    $scope.spinner = "<i class='fa fa-spinner fa-2x fa-spin'></i>";
    $scope.okCheck = ""; //"<i class='fa fa-check fa-2x fa-green' ></i>";
    $scope.errorCheck = "<i class='fa fa-exclamation-circle fa-2x fa-red'></i>";
    $scope.resetIndicator = "<i class='fa fa-fw fa-2x'>&nbsp;</i>";
    $scope.activeTab = 0; 
    $scope.insideRtuSetting = !angular.isUndefined($element.parents('.mc-combined-view').html());

    var myReadOnlyDiv = $($element).find(".loading-data-read-only")[0];
    var mouseWheelHandler = function(e) {
        $(myReadOnlyDiv).css("pointer-events", "none");
        $timeout(function() {
                $(myReadOnlyDiv).css("pointer-events", "auto");
            },
            100);
        return false;
    };

    if (!sharedSetupService.isAdmin($scope.accountInfo)) {
        $scope.readOnly = true;
        if (myReadOnlyDiv.addEventListener) {
            // IE9, Chrome, Safari, Opera
            myReadOnlyDiv.addEventListener("mousewheel", mouseWheelHandler, false);
            // Firefox
            myReadOnlyDiv.addEventListener("DOMMouseScroll", mouseWheelHandler, false);
        }
    }

    if (/Edge\/\d./i.test(navigator.userAgent)) {
        $scope.isEdge = true;
    }

    $scope.getContainerHeight = function () {
        if ($scope.popup && $scope.isEdge) {
            return $scope.popup[0].clientHeight - 70;
        } else {
            return '100%';
        }
    }

    sharedSetupService.broadcastAllDeviceSelected($scope);

    if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }

    var tabList = [];
    var resizeTabIdString = "";

    var _tabList = function () {
        var len = arguments.length,
        i = 0;
        var tmpLength = tabList.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                tabList.push(arguments[i]);
                resizeTabIdString += resizeTabIdString.length === 0 ? "#" + arguments[i].id : ", #" + arguments[i].id;
            } else {
                tabList[i].name = arguments[i].name;
            }
        }
    };


    var _initializeSetting = function () {
        _tabList(
             {
                 "id": "rtu-list",
                 "name": "rtu-list",
                 "templateName": "rtu-list",
                 "height": 180
             }
        );
    };

    _initializeSetting();

    $scope.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }
        var x = 'ui/rtulist/' + (tab.templateName).toLowerCase().replace(' ', '-') + '-tab.html'

        return 'ui/rtulist/' + (tab.templateName).toLowerCase().replace(' ', '-') + '-tab.html';
    }

    $scope.rtuListTabs = tabList;

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        _initializeSetting();
    });

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);
        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            //var _topMenu = typeof $scope.popup.parent().find('.top-menu').css("height") !== "undefined" ? $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") : 20;
            var _title = $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "");
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            $scope.popup.parent().find('.form-group').css("width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "") - 40);
            $scope.popup.parent().find('.ui-tabs-panel, .form-group').css("height", _tmpHeight - 150 - _title + 28); //28 title height
            $scope.popup.parent().find('.form-group').css("overflow-y", "auto").css("overflow-x", "hidden");

            //will think about this
            //if ($scope.typeId == 2 || $scope.typeId == 3) {
            $scope.popup.parent().find('' + resizeTabIdString + '').css("height", _tmpHeight - 150 - _title + 28 + 52); //28 title height
            $scope.popup.parent().find('' + resizeTabIdString + '').css("overflow-y", "auto").css("overflow-x", "hidden");
            //}
            //will think about this

            // $scope.tabsSize(_tmpHeight - 70 - _title + 28); //28 title height
            $rootScope.$broadcast('contentAdjusted');
            //form-group
        };

        $scope.adjustViewheight = function (varHeight) {
            if (!angular.isUndefined($element.parents('.mc-combined-view').html())) return;            
            varHeight = varHeight + 20;
            var tmpTitle = parseInt($scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", varHeight + tmpTitle + 170);
            $scope.popup.parent().css("height", varHeight + tmpTitle + 200);
            $scope.adjustSize();
        };

    }

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            var _device = { deviceName: $scope.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });
            $scope.$emit('deviceSelectedDone', { message: $scope.deviceSelectedName });

            $timeout(function () {
                $scope.activeTab = 0;
            }, 0);

        }
    }, true);

    $scope.$on("$destroy", function () {
        if (angular.isDefined(myReadOnlyDiv) && myReadOnlyDiv.addEventListener) {
            myReadOnlyDiv.removeEventListener("mousewheel", mouseWheelHandler, false);
            myReadOnlyDiv.removeEventListener("DOMMouseScroll", mouseWheelHandler, false);
        }

        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus($scope.accountInfo.customerId, $scope.accountInfo.userId, $rootScope.wizardId, $scope.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });
}]);

'use strict';

angular.module('mc.rtu-list', []);
'use strict';

mcapp.factory("swapRadioViewService", ["$http", "HOST", function ($http, HOST) {
    var swapRadioViewFactory = {};
    var _getData = function _getData(customerId, deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/SwapRadioView?customerId=' + customerId + "&deviceId=" + deviceId,
            cache: false
        });
    };

    var _postUserAction2Nlog = function _postUserAction2Nlog(customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Radio Swap";

        return $http({
            method: 'POST',
            url: HOST + '/api/SwapRadioView',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };
    swapRadioViewFactory.getData = _getData;
    swapRadioViewFactory.postUserAction2Nlog = _postUserAction2Nlog;
    return swapRadioViewFactory;
}]);
'use strict';

//OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_
//OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_
mcapp.factory("OLD_DELETE_rtuPopupService", ['$http', '$filter', 'authenticationService', 'translationService', 'datetimeService', 'HOST', function ($http, $filter, authenticationService, translationService, datetimeService, HOST) {
    var rtuPopupInfoFactory = {};
    var translation = translationService.translation;

    var accountInfo = authenticationService.getAccountInfo();
    var uiDigitalDataArray = [];

    var getRtuDetail = function getRtuDetail(deviceID, customerID, tz) {
        return $http.get(HOST + '/api/RtuDetail?deviceId=' + deviceID + '&customerId=' + customerID + '&timeZone=' + tz);
    };

    var _getTooltip = function _getTooltip(device, customerID, timezone) {
        getRtuDetail(device.deviceID, customerID, timezone).then(function (resp) {
            var lastDigitals = resp.data.digitalGauge.lastDigitals;
            var alarms = resp.data.overviewAlarmList;
            var lastHeardTime = resp.data.deviceUnitState.lastTimeHeard;
            var analogList = resp.data.analogGaugeList;
            var digitalGauge = resp.data.digitalGauge;
            var digitalDescs = resp.data.digitalDescriptions;

            var tooltip = '';
            tooltip += "<div style='font-weight: bold; text-align: center; color: #157fcc;'>${device.deviceName}</div>";
            tooltip += "<div style='font-weight: bold; text-align: left;'>${(device, accountInfo, resp.data.isOffline)}";
            if (getStatus(device, accountInfo, resp.data.isOffline).indexOf(translation.text.LOW_BATTERY) > -1) {
                tooltip += ' ' + getBatteryVoltage(resp.data);
            }
            tooltip += "</div>";

            // adding Alarms to the tooltip
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = alarms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var alarm = _step.value;

                    if (alarm.input > 0) {
                        tooltip += "<div style='font-weight: bold;text-align: left;'>Input #${alarm.input} => ${alarm.description}</div>";
                    } else {
                        tooltip += "<div style='font-weight: bold; text-align: left;'>${alarm.description}</div>";
                    }
                }

                //last heard time
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            tooltip += "<div style='text-align: left;'><b>${translation.text.LAST_HEARD}:</b> ${getTime(lastHeardTime)}</div>";

            //adding analogGauge related information
            if (analogList.length > 0) {
                tooltip += "<div style='text-align: left;'><b>${translation.text.ANALOG}:</b></div>"; //TODO: delete Analog-Data text or translate it based on feedback from Dave
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = analogList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var analogItem = _step2.value;

                        tooltip += "<div style='text-align: left;'>${analogItem.name}: ";
                        //var tip = this.getTime(analogItem.localDateTime) + ': ';
                        var tip = analogItem.latestData + ' ' + analogItem.unit + ' ';
                        tip += accountInfo.preferenceUser.engineeringUnitDisplay === 1 ? ' (' + getEnggUnit(analogItem) + ')</br>' : '</br>';
                        //tip += '&emsp;&emsp;&emsp;&emsp;&emsp;' + this.translation.text.SCALE + ': ' + analogItem.minVal + '' + analogItem.unit + '-' + analogItem.maxVal + '' + analogItem.unit + `</div>`;
                        tooltip += tip;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }

            // massage the digitalGaugeModel 
            processDigitalGaugeData(digitalGauge, digitalDescs);

            //adding digitalGaugeModel related information
            if (uiDigitalDataArray.length > 0) {
                tooltip += "<div style='text-align: left;'><b>${translation.text.DIGITAL}:</b> </br> ${getDigitalDataTooltip(alarms)}</div>"; //TODO: delete Digital-Data text or translate it based on feedback from Dave
            }

            return tooltip;
        }, function (error) {
            return "getTooltip FAILURE";
        });
    };

    var processDigitalGaugeData = function processDigitalGaugeData(digitalGauge, digitalDescriptions) {
        for (var i = 0; i < digitalGauge.digitalSettings.length; i++) {
            var inputChannel = digitalGauge.digitalSettings[i].channel;
            var digValue = 0;
            if (digitalGauge.digitalData !== null) {
                switch (inputChannel) {
                    case 1:
                        digValue = digitalGauge.digitalData.d1;
                        break;
                    case 2:
                        digValue = digitalGauge.digitalData.d2;
                        break;
                    case 3:
                        digValue = digitalGauge.digitalData.d3;
                        break;
                    case 4:
                        digValue = digitalGauge.digitalData.d4;
                        break;
                    case 5:
                        digValue = digitalGauge.digitalData.d5;
                        break;
                    case 6:
                        digValue = digitalGauge.digitalData.d6;
                        break;
                    case 7:
                        digValue = digitalGauge.digitalData.d7;
                        break;
                    case 8:
                        digValue = digitalGauge.digitalData.d8;
                        break;
                    case 9:
                        digValue = digitalGauge.digitalData.d9;
                        break;
                    case 10:
                        digValue = digitalGauge.digitalData.d10;
                        break;
                    case 11:
                        digValue = digitalGauge.digitalData.d11;
                        break;
                    case 12:
                        digValue = digitalGauge.digitalData.d12;
                        break;
                    case 13:
                        digValue = digitalGauge.digitalData.d13;
                        break;
                    case 14:
                        digValue = digitalGauge.digitalData.d14;
                        break;
                    case 15:
                        digValue = digitalGauge.digitalData.d15;
                        break;
                    case 16:
                        digValue = digitalGauge.digitalData.d16;
                        break;

                }
            }
            if (digValue === "True") digValue = "1";
            if (digValue === "False") digValue = "0";
            digValue = updateValue(digValue, inputChannel, digitalGauge.digitalSettings[i].normalClosed);
            var digitalMode = digitalGauge.digitalSettings[i].digitalMode;
            var status = convertStatus(digValue, digitalMode, digitalGauge.digitalSettings[i], digitalDescriptions[i]);
            var des = digitalGauge.digitalSettings[i].description + ": " + status.statusMessage;
            var name = digitalGauge.digitalSettings[i].description;
            var uidigitaldata = { description: des, digitalMode: digitalMode, input: inputChannel }; //, image: status.statusImage, input: inputChannle, name: name, currentVal: digValue };
            // _drawDigitalGauge(digitaldata)
            uiDigitalDataArray.push(uidigitaldata);
        }
    };

    var getDigitalDataTooltip = function getDigitalDataTooltip(overviewAlarmList) {
        var retVal = '';
        //var separatorAdded = false;

        for (var i = 0; i < uiDigitalDataArray.length; i++) {
            var digitalDataItem = uiDigitalDataArray[i];
            if (digitalDataItem.digitalMode != 'D' && digitalDataItem.digitalMode != 'A' && !contains(overviewAlarmList, digitalDataItem)) {
                //Disabled inputs should not be displayed on the popup info, and Alarm inputs should not be displyed on bottom part of popup info
                var lastData = _.find(lastDigitals, function (item) {
                    return item === null ? undefined : item.channel === digitalDataItem.input;
                });
                var now = new Date();
                retVal += digitalDataItem.description; //adding channel name and status
                var dt = (lastData === undefined || lastData.regTime === '0001-01-01T00:00:00' ? translation.text.UNKNOWN : ' ' + millisecondsToStr(moment.utc().valueOf() - (lastData.livePoint === true ? moment(lastData.regTime).valueOf() : moment.utc(lastData.regTime).valueOf()))) + '</br>';
                retVal += digitalDataItem.digitalMode == 'P' ? ' ' + dt : '</br>'; //adding duration if it is pump
                //if (!separatorAdded && 'P' != digitalDataItem.digitalMode) {
                //    retVal += '</br>'; //adding separator between Pump and other inputs
                //    separatorAdded = true;
                //}
            }
        }

        //clear the uiDigitalData after use
        uiDigitalDataArray = [];
        return retVal;
    };

    var contains = function contains(overviewAlarmList, digitalDataItem) {
        var retVal = false;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = overviewAlarmList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var alarm = _step3.value;

                if (alarm.input == digitalDataItem.input) {
                    retVal = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        return retVal;
    };

    var millisecondsToStr = function millisecondsToStr(milliseconds) {
        // TIP: to find current time in milliseconds, use:
        // var  current_time_milliseconds = new Date().getTime();

        function numberEnding(number) {
            return number > 1 ? 's' : '';
        }

        var temp = Math.floor(milliseconds / 1000);
        var years = Math.floor(temp / 31536000);
        if (years) {
            return years + ' ' + translation.text.YEAR + numberEnding(years);
        }
        //TODO: Months! Maybe weeks? 
        var days = Math.floor((temp %= 31536000) / 86400);
        if (days) {

            temp = temp - days * 86400;
            var rhours = Math.floor((temp %= 86400) / 3600);
            if (rhours > 0) return days + ' ' + translation.text.DAY + numberEnding(days) + ' ' + rhours + ' ' + translation.text.HOUR + numberEnding(rhours);else return days + ' ' + translation.text.DAY + numberEnding(days);
        }
        var hours = Math.floor((temp %= 86400) / 3600);
        if (hours) {
            temp = temp - hours * 3600;
            var rminutes = Math.floor((temp %= 3600) / 60);
            if (rminutes > 0) return hours + ' ' + translation.text.HOUR + numberEnding(hours) + ' ' + rminutes + ' ' + translation.text.MINUTE + numberEnding(rminutes);else return hours + ' ' + translation.text.HOUR + numberEnding(hours);
        }
        var minutes = Math.floor((temp %= 3600) / 60);
        if (minutes) {
            return minutes + ' ' + translation.text.MINUTE + numberEnding(minutes);
        }
        var seconds = temp % 60;
        if (seconds) {
            return seconds + ' ' + translation.text.SECOND + numberEnding(seconds);
        }
        return translation.text.LESS_THAN_A_SECOND; //'just now' //or other string you like;
    };

    var updateValue = function updateValue(Value, Channel, NomalState) {
        var ReturnValue = "0";
        if (Value === String(NomalState)) ReturnValue = "1";else if (Value === null || Value === "") ReturnValue = null;

        return ReturnValue;
    };

    var convertStatus = function convertStatus(statusCode, digitalMode, digitalSetting, digitalDescription) {
        var statusMsg = null;
        switch (statusCode) {
            default:
            case "0":
                //open
                if (digitalMode === "P") {
                    statusMsg = { statusImage: "pump_off_a.gif", statusMessage: translation.text.STOPPED };
                } else if (digitalMode === "S") {
                    //if (digitalSetting.normalClosed == 0) //Normal
                    //{
                    //    statusMsg = { statusImage: "input_open_a.png", statusMessage: digitalDescription.en.normal };
                    //    console.log(digitalDescription.en.normal);
                    //}
                    //else if(digitalSetting.normalClosed == 1) //Off-Normal
                    //{
                    statusMsg = { statusImage: "input_open_a.png", statusMessage: digitalDescription.en.offNormal };
                    //    console.log(digitalDescription.en.offNormal);
                    //}
                } else statusMsg = { statusImage: "input_open_a.png", statusMessage: translation.text.OPEN };
                break;
            case "1":
                //close
                if (digitalMode === "P") {
                    statusMsg = { statusImage: "pump_run_a.gif", statusMessage: translation.text.RUNNING };
                } else if (digitalMode === "S") {
                    //if (digitalSetting.normalClosed == 1) //Normal
                    //{
                    statusMsg = { statusImage: "input_open_a.png", statusMessage: digitalDescription.en.normal };
                    //    console.log(digitalDescription.en.normal);
                    //}
                    //else if(digitalSetting.normalClosed == 0) //Off-Normal
                    //{
                    //    statusMsg = { statusImage: "input_open_a.png", statusMessage: digitalDescription.en.offNormal };
                    //    console.log(digitalDescription.en.offNormal);
                    //}
                } else statusMsg = { statusImage: "input_close_a.png", statusMessage: translation.text.CLOSE };
                break;
            case null: //fault
            case "":
                if (digitalMode === "P") statusMsg = { statusImage: "pump_fault_a.gif", statusMessage: translation.text.FAULT };else statusMsg = { statusImage: "input_fault_a.png", statusMessage: translation.text.FAULT };
                break;
        }
        return statusMsg;
    };

    var getEnggUnit = function getEnggUnit(item) {
        if (!(item.analogMode === 1 || item.analogMode === 0)) {
            return '';
        }

        var unitMin = 0;
        var unitMax = 0;
        var unit = '';

        if (item.analogMode === 1) {
            //translate to 4 - 20 mA
            unitMin = 4;
            unitMax = 20;
            unit = 'mA';
        } else if (item.analogMode === 0) {
            //translate to 0 - 5 Volts
            //unitMin = 0;
            unitMax = 5;
            unit = 'Volts';
        }

        var factor = (unitMax - unitMin) * item.latestData / (item.maxVal - item.minVal);
        //engineering Unit value = factor + unitMin
        factor = (factor + unitMin).toFixed(2);
        return factor + ' ' + unit;
    };

    var getTime = function getTime(time) {
        var formatedTime = datetimeService.formatDateAgentText(time, 'yyyy-MM-ddTHH:mm:ss', false, accountInfo.preferenceUser.timeFormat);
        return formatedTime === '0001-01-01T00:00:00' || formatedTime === 'Jan 01 1901 12:00:00 AM' ? translation.text.UNKNOWN : formatedTime;
    };

    this.getBatteryVoltage = function (data) {
        if (data && data.rtuDataList && data.rtuDataList.length > 0) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = data.rtuDataList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var rtuData = _step4.value;

                    if (rtuData.name === 'Battery') {
                        return ' => ' + rtuData.value + ' ' + rtuData.unit;
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        } else {
            if (data && data.deviceUnitState && angular.isDefined(data.deviceUnitState.lastBatt)) {
                return ' => ' + data.deviceUnitState.lastBatt;
            }
        }
        return '';
    };

    var getStatus = function getStatus(device, accountInfo, isOffline) {
        if (device.isDisabled) {
            var disabledUntil = '';

            if (device.disabledUntil) {
                disabledUntil = ' Until: ' + datetimeService.formatDateAgentText(device.disabledUntil, 'yyyy-MM-ddTHH:mm:ss', false, accountInfo.preferenceUser.timeFormat);
            } else {
                disabledUntil = ' ' + translation.text.INDEFINITELY;
            }
            return translation.text.DISABLED + disabledUntil;
        }

        // this variable specifies whether we have heard from the device within last 24 hours, 
        // especially for manhole monitor devices which will send communication for every 24 hours
        var nextelOnline = false;
        if (device.lastTimeHeard) {
            // timeout represents no. of minutes for which given device will send status signal
            var timeout = device.timeout;
            if (timeout <= 5) timeout = 15;
            var nowDate = Date.now() / 1000 / 60 / 60 / 24;
            var lastHeard = new Date(device.lastTimeHeard).getTime() / 1000 / 60 / 60 / 24;
            if (lastHeard > nowDate - timeout / 1440) nextelOnline = true;
        }

        if (isOffline) {
            return translation.text.COMM_FAIL;
        }

        if (device.inServiceMode) {
            return translation.text.SERVICE_MODE;
        }

        if (device.acFail && !device.solar) {
            return translation.text.AC_FAILURE;
        }

        if (device.deviceType === 15 && device.lastBatt < 4.5) {
            return translation.text.LOW_BATTERY;
        } else if (device.deviceType !== 15 && device.lastBatt < 11) {
            return translation.text.LOW_BATTERY;
        }

        if (device.lastTemp > 120 && device.tempUnit === 1) {
            return translation.text.HIGH_TEMP;
        }

        if (device.lastTemp > 50 && temp.unit === 0) {
            return translation.text.HIGH_TEMP;
        }

        return translation.text.ALL_NORMAL;
    };

    rtuPopupInfoFactory.getTooltip = _getTooltip;

    return rtuPopupInfoFactory;

    //return {
    //    getTooltip: _getTooltip
    //};

}]);
//OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_
//OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_OLD_DELETE_
mcapp.controller('rtuInfoController',
    ['$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'checkDeviceDataService', 'deviceService', 'deviceMenuService', 'detectBrowserService', '$element', 'wizardSplashService', 'digitalSettingService', '$uibModal', 'websocketService', 'debounceService', 'unsavedChangesService', 'MMPlusRtuSettingFactory',
        function ($rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, checkDeviceDataService, deviceService, deviceMenuService, detectBrowserService, $element, wizardSplashService, digitalSettingService, $uibModal, websocketService, debounceService, unsavedChangesService, MMPlusRtuSettingFactory)
        {
    $scope.devicename = null;
    $scope.unit = null;
    $scope.myDate = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.activeTab = 0;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.minPadding = sharedSetupService.minPadding;
    $scope.maxPadding = sharedSetupService.maxPadding;
    $scope.topMenuMarginLeft = $rootScope.mobile ? '-206px' : '-278px';
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
    $scope.translation = translationService.translation;
    $scope.commandAdminAccess = sharedSetupService.mcAdmin();  
    $scope.targetField = null;
    $scope.spinner = "<i class='fa fa-spinner fa-2x fa-spin'></i>";
    $scope.okCheck = ""; //"<i class='fa fa-check fa-2x fa-green' ></i>";
    $scope.errorCheck = "<i class='fa fa-exclamation-circle fa-2x fa-red'></i>";
    $scope.resetIndicator = "<i class='fa fa-fw fa-2x'>&nbsp;</i>";
    $scope.loadingInProgress = true;
    $scope.typeId = 1; //1: default
    $scope.modelId = 9; //M800
    $scope.hasAnalogOutputBoard = false;
    $scope.hasMydroExpansion = false;
    $scope.lastFlowTime = false;
    $scope.curentBrowser = detectBrowserService();
    $scope.tabStatus = [true, true, true, true, true, true, true, true, true, true, true];
    $scope.insideRtuSetting = !angular.isUndefined($element.parents('.mc-combined-view').html());
    $scope.isChromeOrFirefox = false;
    $scope.ourMmPlusDevice = false;
    $scope.hasLevelSensor = false;
    $scope.isMyDroOrMmplus = false

    $scope.fnBrowser = function () {
        $scope.isChromeOrFirefox = ($scope.curentBrowser == "chrome" || $scope.curentBrowser == "firefox");
        return $scope.isChromeOrFirefox;
    };

    if ($scope.accountInfo.userRole == 'Administrator' || $scope.accountInfo.userRole == 'SuperAdministrator') {
        $scope.isAdmin = true;
    }


    if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }

    var tabConfiguration = [];
    var rtuDataConfiguration = [];
    var resizeTabIdString = "";

    var _updateBasicInfoInputs = function () {
       // if ($scope.isMyDroOrMmplus && rtuDataConfiguration.length == 23) return;
      // if (!$scope.isMyDroOrMmplus && rtuDataConfiguration.length == 22) return;
        rtuDataConfiguration = [];
        _initializeSetting();
        _initializeSettingforEBPC();
        //$scope.rtuDataConfig = rtuDataConfiguration;
        $scope.rtuDataConfig = $scope.isMyDroOrMmplus || $scope.ourMmPlusDevice ? rtuDataConfiguration : rtuDataConfiguration.filter(function (item) {
            return item.id != "prioritySim";
        });
        if($scope.modelId != 20)
        {
            $scope.rtuDataConfig = $scope.rtuDataConfig.filter(function (item) {
                return item.id != "skuId";
            });
        }
        if($scope.modelId == 17) 
        {
            $scope.rtuDataConfig = $scope.rtuDataConfig.filter(function (item) {
                return item.id != "wetWellModule";
            });
        }
    };

    var _tabConfiguration = function () {
        var len = arguments.length,
            i = 0;
        var tmpLength = tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                tabConfiguration.push(arguments[i]);
                resizeTabIdString += resizeTabIdString.length === 0 ? "#" + arguments[i].id : ", #" + arguments[i].id;
            } else {
                tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    var _rtuDataConfiguration = function () {
        var len = arguments.length,
            i = 0;
        var tmpLength = rtuDataConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                rtuDataConfiguration.push(arguments[i]);
            } else {
                rtuDataConfiguration[i].name = arguments[i].name;
                rtuDataConfiguration[i].validationRequirement = arguments[i].validationRequirement;
            }
        }
    };

    var _initializeSetting = function () {
        _tabConfiguration(
            {
                "id": "BasicInfo",
                "name": $scope.translation.text.BASIC_INFO,
                'templateUrl': 'ui/rtuinfo/basic-info-tab.html' 
            },
            {
                "id": "Location",
                "name": $scope.translation.text.LOCATION,
                "templateName": "Location",
                'templateUrl': 'ui/rtuinfo/location/location-template.html'
            },
            {
                "id": "Analog",
                "name": $scope.hasLevelSensor ? "MyLevel" : $scope.translation.text.ANALOG,
                "templateName": "Analog"
            },
            {
                "id": "Digital",
                "name": $scope.translation.text.DIGITAL,
                "templateName": "Digital"
            },
            {
                "id": "Relays",
                "name": $scope.translation.text.RELAYS,
                "templateName": "Relays"
            },
            {
                "id": "Pumps",
                "name": $scope.translation.text.PUMPS,
                "templateName": "Pumps"
            },
            {
                "id": "OptionBoard",
                "name": $scope.translation.text.OPTION_BOARD,
                "templateName": "Option Board"
            },
            {
                'id': 'VolumetricCalc',
                'name': $scope.translation.text.VOLUMETRIC_CALC,
                'templateName': 'Volumetric Calc',
                'templateUrl': 'ui/rtuinfo/volumetriccalc/volumetric-calc-template.html'
            },
            {
                "id": "RainfallSite",
                "name": $scope.translation.text.RAINFALL_SITE,
                "templateName": "Rainfall Site"
            },
            {
                "id": "RadioSwap",
                "name": $scope.translation.text.RADIO_SWAP,
                "templateName": "Radio Swap"
            },
            {
                "id": "DeviceConfig",
                "name": $scope.translation.text.DEVICE_CONFIG,
                "templateName": "Config",
                'templateUrl': 'ui/rtuinfo/config/device-config-tab.html'
            }
        );

        if ($scope.isMyDroOrMmplus) {
            _rtuDataConfiguration(
                {
                    "id": "serialNumber",
                    "name": $scope.translation.text.SERIAL_NUMBER,
                    "type": "readOnly",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{10,10}$/,
                    "validationRequirement": $scope.translation.text.SERIAL_NUMBER_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 10
                },
                {
                    "id": "name",
                    "name": $scope.translation.text.SITE_NAME,
                    "type": "text",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^.{1,100}$/,
                    "validationRequirement": $scope.translation.text.SITE_NAME_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 100
                },
                {
                    "id": "ttsDeviceName",
                    "name": $scope.translation.text.TTS_DEVICE_NAME,
                    "type": "text",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^.{1,100}$/,
                    "validationRequirement": $scope.translation.text.TTS_DEVICE_NAME_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 100
                },
                {
                    "id": "location",
                    "name": $scope.translation.text.LOCATION_DESCRIPTION,
                    "type": "text",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^.{0,150}$/,
                    "validationRequirement": $scope.translation.text.LOCATION_DESCRIPTION_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 150
                },
                {
                    "id": "ttsLocation",
                    "name": "TTS Device Location",
                    "type": "text",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^.{0,150}$/,
                    "validationRequirement": $scope.translation.text.LOCATION_DESCRIPTION_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 150
                },
                {
                    "id": "model",
                    "name": $scope.translation.text.DEVICE_TYPE,
                    "type": "selectModel",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.DEVICE_TYPE_ERR,
                    "adminOnly": false,
                    "disabled": $scope.modelId >= 20 ? true : false,
                    "maxLength": 1
                },
                {
                    "id": "radioEsn",
                    "name": $scope.translation.text.ESN_SPRINT_ONLY,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^[a-zA-Z0-9]{0,15}$/,
                    "validationRequirement": $scope.translation.text.ESN_SPRINT_ONLY_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "softwareVersion",
                    "name": $scope.translation.text.SOFTWARE_VERSION,
                    "type": "readOnly",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^[0-9]+(\.[0-9]+)?$/,
                    "validationRequirement": $scope.translation.text.SOFTWARE_VERSION_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 6
                },
                {
                    "id": "wirelessCarrier",
                    "name": $scope.translation.text.WIRELESS_CARRIER,
                    "type": "selectCarrier",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.WIRELESS_CARRIER_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 1
                },
                {
                    "id": "imei",
                    "name": $scope.translation.text.IMEI,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{15,15}$/,
                    "validationRequirement": $scope.translation.text.IMEI_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "simNumber",
                    "name": $scope.translation.text.REMOVABLE_SIM,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{20,20}$/,
                    "validationRequirement": $scope.translation.text.SIM_NUMBER_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 20
                },
                {
                    "id": "secondarySIMNumber",
                    "name": $scope.translation.text.EMBEDDED_SIM,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{20,20}$/,
                    "validationRequirement": $scope.translation.text.SIM_NUMBER_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 20
                },
                {
                    "id": "prioritySim",
                    "name": "Priority SIM",
                    "type": "selectPrioritySim",
                    "access": $scope.ourMmPlusDevice ? 1 : 0,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": "Error",
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 1
                },
                {
                    "id": "installDate",
                    "name": $scope.translation.text.INSTALL_DATE,
                    "type": "date",
                    "access": -1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "", ///(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
                    "validationRequirement": $scope.translation.text.ERROR,
                    "adminOnly": true,
                    "disabled": true,
                    "maxLength": 10
                },
                {
                    "id": "motherboardSerialNumber",
                    "name": $scope.translation.text.MOTHERBOARD_SN,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{0,15}$/,
                    "validationRequirement": $scope.translation.text.MOTHERBOARD_SN_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "daughterBoardSerialNumber",
                    "name": $scope.translation.text.DAUGHTERBOARD_SN,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{0,15}$/,
                    "validationRequirement": $scope.translation.text.DAUGHTERBOARD_SN_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "txId1",
                    "name": $scope.translation.text.TXID1_MSID_IN_SPRINT,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": $scope.translation.text.TXID1_MSID_IN_SPRINT_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "txId2",
                    "name": $scope.translation.text.TXID2_MDN_IN_SPRINT,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": $scope.translation.text.TXID2_MDN_IN_SPRINT_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "txId3",
                    "name": $scope.translation.text.TXID3_MSL_IN_SPRINT,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": $scope.translation.text.TXID3_MSL_IN_SPRINT_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "manufactureDate",
                    "name": $scope.translation.text.MANUFACTURE_DATE,
                    "type": "date",
                    "access": -1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "", ///(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
                    "validationRequirement": $scope.translation.text.MANUFACTURE_DATE_ERR,
                    "adminOnly": true,
                    "disabled": true,
                    "maxLength": 10
                },
                {
                    "id": "programDate",
                    "name": $scope.translation.text.PROGRAM_DATE,
                    "type": "date",
                    "access": -1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "", ///(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
                    "validationRequirement": $scope.translation.text.PROGRAM_DATE_ERR,
                    "adminOnly": true,
                    "disabled": true,
                    "maxLength": 10
                },
                {
                    "id": "wetWellModule",
                    "name": $scope.translation.text.WET_WELL_MODULE,
                    "type": "selectWetWellModule",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.WET_WELL_MODULE_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 1
                },
                {
                    "id": "smp",
                    "name": "SMP",
                    "type": "selectSMP",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.WET_WELL_MODULE_ERR,
                    "adminOnly": true,
                    "disabled": true,
                    "maxLength": 1

                },
                {
                    "id": "pumpStationWidgetId",
                    "name": $scope.translation.text.PUMP_STATION,
                    "type": "selectWidgetId",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.WET_WELL_MODULE_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 1
                },
                {
                    "id": "skuId",
                    "name": "SKU",
                    "type": "selectSkuId",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.DEVICE_TYPE_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 1
                }
            );
        }
        else {
            _rtuDataConfiguration(
                {
                    "id": "serialNumber",
                    "name": $scope.translation.text.SERIAL_NUMBER,
                    "type": "readOnly",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{10,10}$/,
                    "validationRequirement": $scope.translation.text.SERIAL_NUMBER_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 10
                },
                {
                    "id": "name",
                    "name": $scope.translation.text.SITE_NAME,
                    "type": "text",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^.{1,100}$/,
                    "validationRequirement": $scope.translation.text.SITE_NAME_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 100
                },
                {
                    "id": "ttsDeviceName",
                    "name": $scope.translation.text.TTS_DEVICE_NAME,
                    "type": "text",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^.{1,100}$/,
                    "validationRequirement": $scope.translation.text.TTS_DEVICE_NAME_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 100
                },
                {
                    "id": "location",
                    "name": $scope.translation.text.LOCATION_DESCRIPTION,
                    "type": "text",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^.{0,150}$/,
                    "validationRequirement": $scope.translation.text.LOCATION_DESCRIPTION_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 150
                },
                {
                    "id": "ttsLocation",
                    "name": "TTS Device Location",
                    "type": "text",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^.{0,150}$/,
                    "validationRequirement": $scope.translation.text.LOCATION_DESCRIPTION_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 150
                },
                {
                    "id": "model",
                    "name": $scope.translation.text.DEVICE_TYPE,
                    "type": "selectModel",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.DEVICE_TYPE_ERR,
                    "adminOnly": false,
                    "disabled": $scope.modelId >= 20 ? true : false,
                    "maxLength": 1
                },
                {
                    "id": "radioEsn",
                    "name": $scope.translation.text.ESN_SPRINT_ONLY,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^[a-zA-Z0-9]{0,15}$/,
                    "validationRequirement": $scope.translation.text.ESN_SPRINT_ONLY_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "softwareVersion",
                    "name": $scope.translation.text.SOFTWARE_VERSION,
                    "type": "readOnly",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^[0-9]+(\.[0-9]+)?$/,
                    "validationRequirement": $scope.translation.text.SOFTWARE_VERSION_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 6
                },
                {
                    "id": "wirelessCarrier",
                    "name": $scope.translation.text.WIRELESS_CARRIER,
                    "type": "selectCarrier",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.WIRELESS_CARRIER_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 1
                },
                {
                    "id": "imei",
                    "name": $scope.translation.text.IMEI,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{15,15}$/,
                    "validationRequirement": $scope.translation.text.IMEI_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "simNumber",
                    "name": $scope.translation.text.SIM_NUMBER,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{0,20}$/,
                    "validationRequirement": $scope.translation.text.SIM_NUMBER_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 20
                },
                {
                    "id": "installDate",
                    "name": $scope.translation.text.INSTALL_DATE,
                    "type": "date",
                    "access": -1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "", ///(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
                    "validationRequirement": $scope.translation.text.ERROR,
                    "adminOnly": true,
                    "disabled": true,
                    "maxLength": 10
                },
                {
                    "id": "motherboardSerialNumber",
                    "name": $scope.translation.text.MOTHERBOARD_SN,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{0,15}$/,
                    "validationRequirement": $scope.translation.text.MOTHERBOARD_SN_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "daughterBoardSerialNumber",
                    "name": $scope.translation.text.DAUGHTERBOARD_SN,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{0,15}$/,
                    "validationRequirement": $scope.translation.text.DAUGHTERBOARD_SN_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "txId1",
                    "name": $scope.translation.text.TXID1_MSID_IN_SPRINT,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": $scope.translation.text.TXID1_MSID_IN_SPRINT_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "txId2",
                    "name": $scope.translation.text.TXID2_MDN_IN_SPRINT,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": $scope.translation.text.TXID2_MDN_IN_SPRINT_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "txId3",
                    "name": $scope.translation.text.TXID3_MSL_IN_SPRINT,
                    "type": "text",
                    "access": 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": $scope.translation.text.TXID3_MSL_IN_SPRINT_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15
                },
                {
                    "id": "manufactureDate",
                    "name": $scope.translation.text.MANUFACTURE_DATE,
                    "type": "date",
                    "access": -1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "", ///(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
                    "validationRequirement": $scope.translation.text.MANUFACTURE_DATE_ERR,
                    "adminOnly": true,
                    "disabled": true,
                    "maxLength": 10
                },
                {
                    "id": "programDate",
                    "name": $scope.translation.text.PROGRAM_DATE,
                    "type": "date",
                    "access": -1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "", ///(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
                    "validationRequirement": $scope.translation.text.PROGRAM_DATE_ERR,
                    "adminOnly": true,
                    "disabled": true,
                    "maxLength": 10
                },
                {
                    "id": "wetWellModule",
                    "name": $scope.translation.text.WET_WELL_MODULE,
                    "type": "selectWetWellModule",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.WET_WELL_MODULE_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 1
                },
                {
                    "id": "smp",
                    "name": "SMP",
                    "type": "selectSMP",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.WET_WELL_MODULE_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 1
                },
                {
                    "id": "pumpStationWidgetId",
                    "name": $scope.translation.text.PUMP_STATION,
                    "type": "selectWidgetId",
                    "access": $scope.isAdmin ? 0 : 1,
                    "status": $scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": $scope.translation.text.WET_WELL_MODULE_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 1
                }
            );
        }
    };

    var _initializeSettingforEBPC = function () {
        if ($scope.hasEBPC) rtuDataConfiguration.push(
            {
                "id": "ebpcPurchased",
                "name": $scope.translation.text.EBPC_PURCHASED,
                "type": "ebpcPurchased",
                "access": 1,
                "status": $scope.resetIndicator,
                "statusMessage": "",
                "regEx": "",
                "validationRequirement": "Error",
                "adminOnly": false,
                "disabled": false,
                "maxLength": 1
            }
        );
    };

    $scope.getWidgetLibrary = function (widgetTypeCharId) {
        if (!$scope.isAdmin) return false;
        setPopupTitle(widgetTypeCharId);
        $scope.listOfWidgets = [];
        digitalSettingService.getWidgetLibraryList(widgetTypeCharId)
            .then(function (result) {
                $scope.listOfWidgets = result.data;
                $scope.listOfWidgets.forEach(function (item) {
                    item.description = item.name.replace(" Pump Station", "");
                });
            }, function (error) {
                // error
                // log error or return JS
            });
    };

    var setPopupTitle = function (widgetId) {
        if (widgetId === 'PS') {
            $scope.popoverHeaderTitle = $scope.translation.text.PUMP_STATION;
        }
    };

    $scope.getPumpStationImage = function (pumpStationWidgetId) {
        var pumpStationWidgetPng, pumpStationDescription;
        switch (pumpStationWidgetId) {
            case 0:
                pumpStationWidgetPng = "di/edit-find-5.png";
                pumpStationDescription = "--" + $scope.translation.text.SELECT + "--";
                break;
            case 16:
                pumpStationWidgetPng = "SubmersiblePumpStation.png";
                pumpStationDescription = "Submersible";
                break;
            case 18:
                pumpStationWidgetPng = "WetWellPumpStation.png"; 
                pumpStationDescription = "Wet Well";
                break;
            case 19:
                pumpStationWidgetPng = "DryWellPumpStation.png";
                pumpStationDescription = "Dry Well";
                break;
            default:
                pumpStationWidgetPng = "di/edit-find-5.png";
                pumpStationDescription = "--" + $scope.translation.text.SELECT + "--"; 
                break;
        }
        $scope.pumpStationDescription = pumpStationDescription;
        var urlImagePumpStation = 'url(images/' + pumpStationWidgetPng + ')';
        return { 'background-image': urlImagePumpStation };
    };

    $scope.dynamicPopoverWidget = {
        templateUrl: 'myPopoverTemplate.html'
    };

    var setTimeOut = function () {
        setTimeout(function () {
            $scope.liveUpdateItem = null;
            $scope.liveUpdated = null;
            $scope.liveMessage = null;
        }, 20000); // 20 Seconds
    };

    var refreshDeviceBasicInfoLive = function (patch, userName) {
        switch (patch.path) {
            case "model":
                $scope.basicInfoOldValue = $scope.getDeviceModel($scope.deviceOld[patch.path]);
                $scope.deviceOld[patch.path] = patch.value;
                $scope.device[patch.path] = { "id": patch.value };
                $scope.basicInfoNewValue = $scope.getDeviceModel(patch.value);
                break;
            case "wirelessCarrier":
                $scope.basicInfoOldValue = $scope.getWirelessCarrier($scope.deviceOld[patch.path]);
                $scope.deviceOld[patch.path] = patch.value;
                $scope.device[patch.path] = { "id": patch.value };
                $scope.basicInfoNewValue = $scope.getWirelessCarrier(patch.value);
                break;
            case "prioritySim":
                $scope.basicInfoOldValue = $scope.getPrioritySim($scope.deviceOld[patch.path]);
                $scope.deviceOld[patch.path] = patch.value;
                $scope.device[patch.path] = { "id": patch.value };
                $scope.basicInfoNewValue = $scope.getPrioritySim(patch.value);
                break;
            case "wetWellModule":
                $scope.basicInfoOldValue = $scope.getWetWellModule($scope.deviceOld[patch.path]);
                $scope.deviceOld[patch.path] = patch.value;
                $scope.device[patch.path] = { "id": patch.value };
                $scope.basicInfoNewValue = $scope.getWetWellModule(patch.value);
                break;
            case "smp":
                $scope.basicInfoOldValue = $scope.getSmp($scope.deviceOld[patch.path]);
                $scope.deviceOld[patch.path] = patch.value;
                $scope.device[patch.path] = { "id": patch.value };
                $scope.basicInfoNewValue = $scope.getSmp(patch.value);
                break;                
            case "manufactureDate":
            case "programDate":
            case "installDate":
                var patchDate = new Date(patch.value);
                var oldValue = new Date($scope.deviceOld[patch.path]);
                $scope.basicInfoOldValue = (oldValue.getMonth() + 1) + '/' + oldValue.getDate() + '/' + (oldValue.getFullYear());
                $scope.deviceOld[patch.path] = patch.value;
                $scope.device[patch.path] = $scope.deviceOld[patch.path];
                $scope.basicInfoNewValue = (patchDate.getMonth() + 1) + '/' + patchDate.getDate() + '/' + (patchDate.getFullYear());
                break;
            default:
                $scope.basicInfoOldValue = $scope.deviceOld[patch.path];
                $scope.deviceOld[patch.path] = patch.value;
                $scope.device[patch.path] = $scope.deviceOld[patch.path];
                $scope.basicInfoNewValue = patch.value;
                break;
        }
        $scope.liveUpdateItem = patch.path;
        $scope.liveUpdated = true;
        $scope.liveMessage = " " + userName + " changed " + patch.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + $scope.basicInfoOldValue + " to " + $scope.basicInfoNewValue;
        setTimeOut();
    };

    var wsDataReceivedDEVICEBASICINFO = function (data) {

        if (data.Type == 'DEVICEBASICINFO' && data.UniqueWebID != $rootScope.uniqueWebID) {
            refreshDeviceBasicInfoLive(data.Value, data.UserName);
        }
    };

    var _registerListener = function () {
        websocketService.connect();
        websocketService.register("DEVICEBASICINFO", $scope.deviceSerialNumber, 0, wsDataReceivedDEVICEBASICINFO, null);
    };

    var _unRegisterListener = function () {
        websocketService.unRegister("DEVICEBASICINFO", $scope.deviceSerialNumber, 0, wsDataReceivedDEVICEBASICINFO, null);
    };

   // _initializeSetting();


    var deviceModel = [
        {
            "id": 8,
            "name": "Model 110"
        },
        {
            "id": 9,
            "name": "Model 800"
        },
        {
            "id": 10,
            "name": "Model M80"
        },
        {
            "id": 15,
            "name": "Manhole Monitor"
        },
        {
            "id": 17,
            "name": "MyDro M120"
        },
        {
            "id": 18,
            "name": "MyDro M150"
        },
        {
            "id": 19,
            "name": "MyDro M850"
        },
        {
            "id": 20,
            "name": "M84"
        },
        {
            "id": 21,
            "name": "M50"
        },
            ];

    var wirelessCarrier = [
        {
            "id": "C",
            "name": "AT&T"
        },
        {
            "id": "K",
            "name": "Sprint Socket"
        },
        {
            "id": "N",
            "name": "Nextel"
        },
        {
            "id": "R",
            "name": "Rogers"
        },
        {
            "id": "T",
            "name": "T-Mobile"
        },
        {
            "id": "Z",
            "name": "Verizon Socket"
        },
        {
            "id": "L",
            "name": "Telenor"
        }
    ];

    var prioritySim = [
        {
            "id": "1",
            "name": $scope.translation.text.EMBEDDED_SIM
        },
        {
            "id": "2",
            "name": $scope.translation.text.REMOVABLE_SIM
        }
    ];

    var wetWellModule = [
        {
            "id": 0,
            "name": "Unknown"
        },
        {
            "id": 1,
            "name": "None"
        },
        {
            "id": 2,
            "name": "Old Type"
        },
        {
            "id": 3,
            "name": "New Type"
        },
    ];

    var smp = [
        {
            "id": 0,
            "name": $scope.translation.text.UNKNOWN
        },
        {
            "id": 1,
            "name": $scope.translation.text.SMP_PULSE
        },
        {
            "id": 2,
            "name": $scope.translation.text.SMP_FLOAT
        },
        {
            "id": 3,
            "name": $scope.translation.text.SG_BOTH
        }
    ];

    var skuIds = [
        {
            "id": 0,
            "name": "MM+ Legacy"
        },
        {
            "id": 1,
            "name": "MyLevel-F"
        },
        {
            "id": 2,
            "name": "MyLevel-L"
        }
    ];    
    
    $scope.rtuSetupTabs = tabConfiguration;
    $scope.rtuDataConfig = rtuDataConfiguration;
    $scope.rtuDeviceModel = deviceModel;
    $scope.rtuWirelessCarrier = wirelessCarrier;
    $scope.rtuPrioritySim = prioritySim;
    $scope.rtuWetWellModule = wetWellModule;
    $scope.rtuSMP = smp;
    $scope.skus = skuIds;    

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        _initializeSetting();
    });

    $scope.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/rtuinfo/' + (tab.templateName).toLowerCase().replace(' ', '-') + '-tab.html';
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.formData = {
    };

    $scope.checkLoadingOnDemand = function () {
        return "Loading on demand ok!";
    };

    $scope.reValidate = function (oldVal, newVal, item, e, regEx) {
        console.log("Re-Validate");
    };

    $scope.postData = function (oldVal, newVal, item, e, regEx) {
        if (newVal !== null && (newVal.id == 8 || newVal.id == 18) && (!$scope.allowM100 || $scope.rtuRuntimeCount > 3)) {
            $scope.openCommonModal(oldVal);
            return;
        }
        $scope.prePost();        

        var _errorClass = $scope.getErrorClass();
        var _element = $scope.getElement();
        if (typeof oldVal == "undefined" || oldVal === newVal || (!isNaN(oldVal) && oldVal == newVal)) {
            $('.tooltip-error-message').hide(100);//.remove();
            $(_element).removeClass(_errorClass);
            for (var i = 0; i < $scope.rtuDataConfig.length; i++) {
                if ($scope.rtuDataConfig[i].id == item) {
                    $scope.rtuDataConfig[i].status = $scope.resetIndicator;
                    $scope.rtuDataConfig[i].statusMessage = "";
                }
            }
            $scope.loadingInProgress = false;
            return;
        }

        //$scope.loadingInProgress = true;

        if (!$scope.isValid(newVal, regEx)) {
            $scope.throwError(_element, item, _errorClass);
            return;
        }

        if (item == "serialNumber" || item == "radioEsn" || item == "imei" || item == "simNumber" || item == "txId1" || item == "txId2") {
            checkDeviceDataService.checkData(item, $scope.deviceSelected, newVal)
                .then(function (result) {
                    $scope.resultCheck = result;
                    if ($scope.resultCheck.data !== null) {
                        $scope.throwError(_element, item, _errorClass, true);
                        return;
                    }
                    $scope.validationOk(oldVal, newVal, _element, item, _errorClass);
                    $scope.postDataDone(oldVal, newVal, _element, item, _errorClass);
                    return;
                }, function (error) {
                    //error
                });
        } else {
            if (item == "manufactureDate" || item == "programDate" || item == "installDate") {
                newVal = moment(new Date(newVal)).format("YYYY-MM-DD");
            }            
            $scope.validationOk(oldVal, newVal, _element, item, _errorClass);
            $scope.postDataDone(oldVal, newVal, _element, item, _errorClass);
        }

        if (item == 'model') {
            $rootScope.$broadcast('updateGen2Tabs', newVal);
        }        

    };

    $scope.checkIfValid = function (oldVal, newVal, item, e, regEx) {

        var _errorClass = $scope.getErrorClass();
        var _element = $scope.getElement();

        $scope.setLoadingInProgress(true);
        if (!$scope.isValid(newVal, regEx)) {
            $scope.throwError(_element, item, _errorClass);
            return;
        }

        $scope.prePost();

        $('.tooltip-error-message').hide(100);
        $(_element).removeClass(_errorClass);
        $scope.setLoadingInProgress(false);
    };

    $scope.prePost = function () {
        for (var i = 0; i < $scope.rtuDataConfig.length; i++) {
            $scope.rtuDataConfig[i].disabled = false;
            $scope.rtuDataConfig[i].status = $scope.resetIndicator;
            $scope.rtuDataConfig[i].statusMessage = "";
            //$('.tooltip-error-message').hide().remove();
        }
        return true;
    };

    $scope.throwError = function (_element, item, _errorClass, serverCheck) {
        $(_element).addClass(_errorClass);
        for (var i = 0; i < $scope.rtuDataConfig.length; i++) {
            if ($scope.rtuDataConfig[i].id == item) {
                $scope.rtuDataConfig[i].status = $scope.errorCheck;
                $scope.rtuDataConfig[i].disabled = false;
                $scope.rtuDataConfig[i].statusMessage = serverCheck ? $scope.rtuDataConfig[i].id.toUpperCase() + " already exists!" : $scope.rtuDataConfig[i].validationRequirement;//Test Error Message!!! Description: ???
            }
            else {
                $scope.rtuDataConfig[i].status = $scope.resetIndicator;
                $scope.rtuDataConfig[i].disabled = true;
            }
        }
        $(_element).focus();
        $(_element).parent().find(".tooltip-error-message." + item).show(100);
    };

    $scope.selectTab = function (index) {
        var prevTab = $scope.activeTab;
        $scope.activeTab = index;
        if (index === 0 && prevTab == 9 || index === 0) {
            $scope.getDeviceData($scope._deviceId);
        }
    };

    $scope.validationOk = function (oldVal, newVal, _element, item, _errorClass) {
        $scope.deviceOld[item] = newVal;
        $(_element).removeClass(_errorClass);
        for (var i = 0; i < $scope.rtuDataConfig.length; i++) {
            if ($scope.rtuDataConfig[i].id == item) {
                $scope.rtuDataConfig[i].status = $scope.spinner;
                $scope.rtuDataConfig[i].statusMessage = "";
            }
            else {
                $scope.rtuDataConfig[i].status = $scope.resetIndicator;
            }
            $scope.rtuDataConfig[i].disabled = false;
        }
    };

    $scope.postOk = function (oldVal, newVal, _element, item, _errorClass) {
        $scope.deviceOld[item] = newVal;
        $scope.device[item] = newVal;
        $(_element).removeClass(_errorClass);
        for (var i = 0; i < $scope.rtuDataConfig.length; i++) {
            if ($scope.rtuDataConfig[i].id == item) {
                $scope.rtuDataConfig[i].status = $scope.okCheck;
                $scope.rtuDataConfig[i].statusMessage = "";
                break;
            }
        }
    };

    $scope.postDataDone = function (oldVal, newVal, _element, item, _errorClass) {
        var tmpDevice = { "op": "replace", "path": item, "value": (typeof newVal == "object" && newVal != null && typeof newVal.id != "undefined" ? newVal.id : newVal) };
        deviceService.patchDevice($scope.deviceSelected, $scope.accountInfo.customerId, tmpDevice)
            .then(function (result) {
                $scope.loadingInProgress = false;
                $('.tooltip-error-message').hide(100); //.remove();
                $scope.postOk(oldVal, newVal, _element, item, _errorClass);
                if (item === "name" || item === "pumpStationWidgetId" || item === "model" || item === "ebpcPurchased") {

                    deviceMenuService.resetDeviceMenuList();
                    brdMsg = { deviceId: result.data.deviceId, name: result.data.name};
                    $rootScope.$broadcast('rtuBasicInfoUpdate', brdMsg);
                    if (item === "pumpStationWidgetId" && tmpDevice.value > 0) {
                        $rootScope.$emit('ItHasPumpStation', { message: true });
                    }
                    if (item == "ebpcPurchased") {
                        $rootScope.$broadcast('updateEbpc', {
                            deviceId: result.data.deviceId,
                            ebpcPurchased: result.data.ebpcPurchased
                        });
                    }
                }
            }, function (error) {
                //error
            });
    };

    $scope.isValid = function (newVal, regEx) {
        if (regEx == "") return true;
        var myregEx = regEx;
        if (myregEx.test(newVal) == false) {
            return false;
        }
        return true;
    };

    $scope.focusCallback = function ($event) {
        if ($event.target === null) {
            return;
        }
        $scope.targetField = $event.target;
    };

    $scope.checkSerialNumber = function (varSN) {
        if ($scope.accountInfo === null)
            return;
        serialNumberService.getData(varSN)
            .then(function (result) {
                //
            }, function (error) {
                //error
            });
    };

    $scope.getHtmlElement = function (varType, varobj) { //item.type, device[item.id]
        return "<input type='text' value='" + varobj + "' style='width: 220px;' required>";
    };

    $scope.refreshBasicInfoData = function (varItemId) {
        var _errorClass = "val-error";
        $scope.device[varItemId] = $scope.deviceOld[varItemId];
        $(".tooltip-error-message").hide(100);//.remove();
        $($scope.targetField).removeClass(_errorClass);
        $scope.prePost();
        $scope.loadingInProgress = false;
    };

    $scope.setLoadingInProgress = function (varBl) {
        $scope.loadingInProgress = varBl;
    };

    $scope.setTypeId = function (varTypeId) {
        $scope.typeId = varTypeId;
    };

    $scope.setModelId = function (varModelId) {
        $scope.modelId = varModelId;
    };

    $scope.setHasAnalogOutputBoard = function (varHasAnalogOutputBoard) {
        $scope.hasAnalogOutputBoard = varHasAnalogOutputBoard;
    };

    $scope.setHasMydroExpansion = function (varHasMydroExpansion) {
        $scope.hasMydroExpansion = varHasMydroExpansion;
    };

    $scope.setLastFlowTime = function (varLastFlowTime) {
        $scope.lastFlowTime = varLastFlowTime == null ? false : true;
    };

    $scope.setRainfallSite = function (varRainfallSite) {
        $scope.rainfallSite = varRainfallSite;
    };

    $scope.setHasAdamsRelayModule = function (varHasAdamsRelayModule) {
        $scope.hasAdamsRelayModule = varHasAdamsRelayModule;
    };

    $scope.setHasLevelSensor = function (varHasLevelSensor) {
        $scope.hasLevelSensor = varHasLevelSensor;
    };

    $scope.setSoftwareVersion = function (varSoftwareVersion) {
        $scope.softwareVersion = varSoftwareVersion;
    };

    $scope.setLoadingDataModal = function (varLoadingDataModal) {
        $scope.loadingDataModal = varLoadingDataModal == null ? false : true;
            };

    $scope.setAuthorizationTypeId = function (varAuthorizationTypeId) {
        $scope.authorizationTypeId = varAuthorizationTypeId;
    };
    $scope.loadingDataModal = false;

    $scope.getDeviceModel = function (varId) {
        if (!Number.isInteger(varId)) varId = varId.id;
        for (var i = 0; i < $scope.rtuDeviceModel.length; i++) {
            if (parseInt(varId) === $scope.rtuDeviceModel[i].id) return $scope.rtuDeviceModel[i].name;
        }
    };

    $scope.getDeviceModelId = function (varName) {
        for (var i = 0; i < $scope.rtuDeviceModel.length; i++) {
            if (varName === $scope.rtuDeviceModel[i].name) return $scope.rtuDeviceModel[i].id;
        }
    };

    $scope.getWirelessCarrier = function (varId) {
        if (typeof varId != 'string') varId = varId.id;
        for (var i = 0; i < $scope.rtuWirelessCarrier.length; i++) {
            if (varId === $scope.rtuWirelessCarrier[i].id) return $scope.rtuWirelessCarrier[i].name;
        }
    };

    $scope.getWirelessCarrierId = function (varName) {
        for (var i = 0; i < $scope.rtuWirelessCarrier.length; i++) {
            if (varName === $scope.rtuWirelessCarrier[i].name) return $scope.rtuWirelessCarrier[i].id;
        }
    };

    $scope.getprioritySimId = function (varName) {
        for (var i = 0; i < $scope.rtuPrioritySim.length; i++) {
            if (varName === $scope.rtuPrioritySim[i].name) return $scope.rtuPrioritySim[i].id;
        }
    };

    $scope.getWetWellModule = function (varId) {
        if (!Number.isInteger(varId)) varId = varId.id;
        for (var i = 0; i < $scope.rtuWetWellModule.length; i++) {
            if (varId === $scope.rtuWetWellModule[i].id) return $scope.rtuWetWellModule[i].name;
        }
    };

    $scope.getSmp = function (varId) {
        if (!Number.isInteger(varId)) varId = varId.id;
        for (var i = 0; i < $scope.rtuSMP.length; i++) {
            if (varId === $scope.rtuSMP[i].id) return $scope.rtuSMP[i].name;
        }
    };
    ///////////////////////////////////////////////////////////////////////
    $scope.preventInput = function (e, varKeyCode) {
        var charCode = (e.which) ? e.which : e.keyCode;
        if (charCode === varKeyCode) e.preventDefault();
    };

    $scope.getErrorClass = function () {
        return "val-error";
    };

    $scope.getElement = function () {
        return (typeof e !== "undefined") ? e.target : $scope.targetField;
    };
    ///////////////////////////////////////////////////////////////////////
    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);
        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            //var _topMenu = typeof $scope.popup.parent().find('.top-menu').css("height") !== "undefined" ? $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") : 20;
            var _title = $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "");
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            $scope.popup.parent().find('.form-group').css("width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "") - 40);
            $scope.popup.parent().find('.ui-tabs-panel, .form-group').css("height", _tmpHeight - 150 - _title + 28); //28 title height
            $scope.popup.parent().find('.form-group').css("overflow-y", "auto").css("overflow-x", "hidden");

            //will think about this
            //if ($scope.typeId == 2 || $scope.typeId == 3) {
            $scope.popup.parent().find('' + resizeTabIdString + '').css("height", _tmpHeight - 150 - _title + 28 + 52); //28 title height
            $scope.popup.parent().find('' + resizeTabIdString + '').css("overflow-y", "auto").css("overflow-x", "hidden");
            //}
            //will think about this

            // $scope.tabsSize(_tmpHeight - 70 - _title + 28); //28 title height
            //form-group
            $scope.popup.parent().find('.ff-map-parent-container').css("height", _tmpHeight - 110);
        };
        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        $($scope.popup).on('dialogbeforeclose', function (event) {
            unsavedChangesService.checkUnsavedChanges(event,
                $scope.popup,
                this,
                sharedSetupService.tabPopupWarningOn);
        });
    }

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            _unRegisterListener();
            $scope.hasLevelSensor = false;
            $scope.isMyDroOrMmplus = false
            //$scope.ourMmPlusDevice = newValue == 50007 ? true : false;
            deviceMenuService.getDeviceMenuList($scope.accountInfo.customerId)
                .then(function (datafromFactory) {
                    $scope.devices = datafromFactory.data.devices;
                    var tmpSelected = false;
                    var tmpSelectedIndex = -1;
                    for (var index = 0; index < $scope.devices.length; ++index) {
                        if ($scope.devices[index].deviceId == newValue) {
                            $scope.deviceSerialNumber = $scope.devices[index].serialNumber;
                            $scope.deviceProtocolVersion = $scope.devices[index].protocolVersion;
                            $scope.setTypeId($scope.devices[index].typeId);
                            $scope.setModelId($scope.devices[index].model);
                            $scope.setHasAnalogOutputBoard($scope.devices[index].hasAnalogOutputBoard);
                            $scope.setHasMydroExpansion($scope.devices[index].hasMydroExpansion);
                            $scope.setLastFlowTime($scope.devices[index].lastFlowTime);
                            $scope.setRainfallSite($scope.devices[index].rainfallSite);
                            $scope.setHasAdamsRelayModule($scope.devices[index].hasAdamsRelayModule);
                            $scope.setHasLevelSensor($scope.devices[index].hasLevelSensor);
                            $scope.setSoftwareVersion($scope.devices[index].softwareVersion);
                            $scope.setAuthorizationTypeId($scope.devices[index].authorizationTypeID);
                            break;
                        }
                    }

                    $scope.isMyDroOrMmplus = [17, 18, 19, 20].indexOf($scope.modelId) > -1 ? true : false;
                    $scope.isMyDro = [18, 19].indexOf($scope.modelId) > -1 ? true : false;
                    //only MyDro devices with software version >= 18.2 have the capabiliy to use EBPC
                    $scope.hasEBPC = $scope.isMyDro && $scope.softwareVersion >= 18.2 ? true : false;
                    
                    _updateBasicInfoInputs();

                    if ($scope.modelId == 20 || $scope.modelId == 21) {
                        $scope.rtuDataConfig = rtuDataConfiguration.filter(function (item) {
                            return item.id != "pumpStationWidgetId" && item.id != "wetWellModule";
                        });
                    }

                    $scope.determineTabStatus();
                    _registerListener();

                    $scope._deviceId = newValue;
                    var _device = { deviceId: newValue, deviceName: $scope.deviceSelectedName, serialNumber: $scope.deviceSerialNumber, protocolVersion: $scope.deviceProtocolVersion, authorizationTypeId: $scope.authorizationTypeId };
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });
                    $scope.$emit('deviceSelectedDone', { message: $scope.deviceSelectedName });
                    $timeout(function () {
                        $scope.activeTab = 0;                        
                        $scope.prePost();
                        $scope.getDeviceData(newValue);
                    }, 0);
                }, function (error) {
                    //error
                });
        }
    }, true);

    $scope.$watch('device["imei"]', function (newValue, oldValue) {
        if (typeof $scope.device !== "undefined") {
            $scope.device["txId1"] = newValue;
        }
    }, true);

    $scope.$watch('device["txId1"]', function (newValue, oldValue) {
        if (typeof $scope.device !== "undefined") {
            $scope.device["imei"] = newValue;
        }
    }, true);
    
    $scope.getDevice = function (varDeviceId) {
        if ($scope.accountInfo === null || !varDeviceId)
            return;
        $scope.toggleDeviceTypeSelect($scope.spinner, true);
        deviceService.getDevice(varDeviceId, $scope.accountInfo.customerId)
            .then(function (datafromFactory) {
                var installDate = datafromFactory.data.installDate == "0001-01-01T00:00:00" ? null : datafromFactory.data.installDate;
                datafromFactory.data.manufactureDate = $rootScope.mobile ? new Date(datafromFactory.data.manufactureDate.substring(0, 4) + "-" + datafromFactory.data.manufactureDate.substring(5, 7) + "-" + datafromFactory.data.manufactureDate.substring(8, 10)) : datafromFactory.data.manufactureDate.substring(5, 7) + "/" + datafromFactory.data.manufactureDate.substring(8, 10) + "/" + datafromFactory.data.manufactureDate.substring(0, 4); //new Date(datafromFactory.data.manufactureDate.substring(0, 10));
                datafromFactory.data.programDate = $rootScope.mobile ? new Date(datafromFactory.data.programDate.substring(0, 4) + "-" + datafromFactory.data.programDate.substring(5, 7) + "-" + datafromFactory.data.programDate.substring(8, 10)) : datafromFactory.data.programDate.substring(5, 7) + "/" + datafromFactory.data.programDate.substring(8, 10) + "/" + datafromFactory.data.programDate.substring(0, 4); //new Date(datafromFactory.data.programDate.substring(0, 10));
                datafromFactory.data.installDate = installDate == null ? installDate : ($rootScope.mobile ? new Date(installDate.substring(0, 4) + "-" + installDate.substring(5, 7) + "-" + installDate.substring(8, 10)) : installDate.substring(5, 7) + "/" + installDate.substring(8, 10) + "/" + installDate.substring(0, 4));
                datafromFactory.data.softwareVersion = parseFloat(datafromFactory.data.softwareVersion).toFixed(2);
                $scope.device = datafromFactory.data;
                //used for disabling EBPCPurchased checkbox, determined by checking whether relay channel is used in tank and well or digital interconnect
                $scope.canEnableEBPC = $scope.device.canEnableEBPC;
                $scope.deviceOld = angular.copy($scope.device);                
                $scope.device["wirelessCarrier"] = { "id": datafromFactory.data.wirelessCarrier };
                // if RMDT radio, then wireless carrier is determined based on first 4-digits of the SIM in-use
                if ($scope.device.hasRMDTRadio && $scope.device.carrierInUse) {
                    $scope.device["wirelessCarrier"] = { "id": $scope.getWirelessCarrierId($scope.device.carrierInUse) };
                }
                $scope.device["model"] = { "id": datafromFactory.data.model };
                $scope.device["prioritySim"] = { "id": datafromFactory.data.simPriority };
                $scope.device["wetWellModule"] = { "id": datafromFactory.data.wetWellModule };
                $scope.device["smp"] = { "id": datafromFactory.data.smp };
                $scope.device["skuId"] = { "id": datafromFactory.data.skuId };                            
                $scope.deviceSerialNumber = datafromFactory.data.serialNumber;
                $scope.getDigitalRuntimeCount(varDeviceId);
                $scope.simInUse = datafromFactory.data.simInUse;
                $scope.simMode = datafromFactory.data.simMode;
            }, function (error) {
                //error

            }).then(function (data) {
                $scope.loadingInProgress = false;
            });
    };

    $scope.getDeviceData = debounceService($scope.getDevice, 200, false);

    $scope.determineTabStatus = function () {
        $timeout(function () {  
            if ($scope.modelId !== 8 && $scope.modelId !== 9 &&  $scope.modelId !== 17 && $scope.modelId !== 18 && $scope.modelId !== 19) {
                $scope.tabStatus[1] = $scope.ourMmPlusDevice ? false : true;
                $scope.tabStatus[2] = false;
                $scope.tabStatus[4] = false;
                $scope.tabStatus[5] = false;
                $scope.tabStatus[6] = false;
                $scope.tabStatus[8] = false;

            } else {
                $scope.tabStatus[1] = true;
                $scope.tabStatus[2] =  $scope.modelId == 17 ? false :true;
                $scope.tabStatus[4] = true;
                $scope.tabStatus[5] = true;
                $scope.tabStatus[8] = true;
                if ($scope.typeId > 1 || $scope.hasAnalogOutputBoard || $scope.hasAdamsRelayModule) {
                    $scope.tabStatus[6] = true;
                }
                else if ($scope.lastFlowTime && ($scope.modelId !== 18 || $scope.modelId !== 19)) {
                    $scope.tabStatus[6] = true;
                } 
                else {
                    $scope.tabStatus[6] = false;
                }
            }

            if (!sharedSetupService.mcAdmin() || true) {
                $scope.tabStatus[9] = false;
            }
            if ($scope.modelId == 21) {
                $scope.tabStatus[2] = true;
                $scope.tabStatus[4] = true;
                $scope.tabStatus[5] = true;
                $scope.tabStatus[8] = true;
                $scope.tabStatus[10] = $scope.isAdmin;
            } else {
                $scope.tabStatus[10] = false;
            }

            if ($scope.modelId == 20) {
                $scope.tabStatus[2] = ($scope.hasLevelSensor && $scope.deviceSKUId == 2 )? true : false;
                $scope.tabStatus[7] = false;
            }
            else if ($scope.modelId == 15 || $scope.modelId == 21) {
                $scope.tabStatus[7] = false;
            }
            else {
                $scope.tabStatus[7] = true;
            }
        });
    };

    //Enable & disabled device type select option until device digital setting have loaded
    $scope.toggleDeviceTypeSelect = function (status, disabled) {
        for (var i = 0; i < $scope.rtuDataConfig.length; i++) {
            if ($scope.rtuDataConfig[i].id == "model") {
                $scope.rtuDataConfig[i].status = status;
                $scope.rtuDataConfig[i].statusMessage = "";
                $scope.rtuDataConfig[i].disabled = disabled;
            }
        }
    }

    $scope.getDigitalRuntimeCount = function (varDeviceId) {
        if ($scope.accountInfo === null || !varDeviceId)
            return;
        digitalSettingService.getData($scope.accountInfo.customerId, varDeviceId, $scope.device.type, true, 'Basic Info')
            .then(function (dataFromFactory) {
                $scope.digitalDeviceData = dataFromFactory.data;
                $scope.M100enabledCheck();
                $scope.toggleDeviceTypeSelect($scope.resolve, false);
            }, function (error) {
                //error
                $scope.toggleDeviceTypeSelect($scope.resolve, false);
            });
    };

    $scope.M100enabledCheck = function () {
        $scope.allowM100 = true;
        $scope.rtuRuntimeCount = 0;
        $scope.digitalDeviceData.forEach(function (digital) {
            if (digital.digitalMode.toLowerCase() == 'p') {
                $scope.rtuRuntimeCount++;
                if (digital.channel > 3) {
                    $scope.allowM100 = false;
                }
            }
        });
    };

    $scope.openCommonModal = function (oldVal) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.tmpConfirmMessageA = $scope.rtuRuntimeCount > 3 ? this.translation.text.M800_TO_M100_WARNING + "." : "";
            this.tmpConfirmMessageB = !$scope.allowM100 && $scope.rtuRuntimeCount <= 3 ? this.translation.text.M100_UNAVAILABLE_CHANNELS + "." : "";
            this.tmpConfirmHeader = this.translation.text.ATTENTION;
            this.tmpConfirmFooter = this.translation.text.OK;
            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function () { return $scope.translation }
            }
        });

        modalInstance.result.then(function (item) {
            //Run success
            $uibModalInstance.dismiss('cancel');

        }, function () {
            // cancel button
            $scope.device.model.id = oldVal.id ? oldVal.id : oldVal;
            $scope.device.model.name = oldVal.name ? oldVal.name : oldVal;
        });
    };

            $scope.deselectTab = function($event, $selectedIndex) {
        if (sharedSetupService.tabPopupWarningOn) {
            $event.preventDefault();
            $scope.exitWithoutSavingConfirmation($event, $selectedIndex);
        }
    }

    //add or remove expansion module
            $scope.exitWithoutSavingConfirmation = function ($event, $selectedIndex) {
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            this.tmpConfirmHeader = _translation.text.CONFIRM;
            this.tmpConfirmMessageA = _translation.text.EXIT_WITHOUT_SAVE;
            //this.tmpConfirmMessageB = _translation.text.EXIT_WITHOUT_SAVE;

            this.ok = function() {
                $uibModalInstance.close();
            };

            this.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };
        };

        modalController.$inject = ['$uibModalInstance', 'translation'];

        const modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/tankandwell/setup/switching-tab-warning-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function() { this.translation }
            }
        });

                modalInstance.result.then(function(item) {
            $scope.activeTab = $selectedIndex;
            sharedSetupService.tabPopupWarningOn = false;
                }, function() {
            $event.preventDefault();// cancel button
        });
    }

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus($scope.accountInfo.customerId, $scope.accountInfo.userId, $rootScope.wizardId, $scope.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
        _unRegisterListener();
    });

}]);

mcapp.directive('numbersOnlyValidation', ['$timeout', function ($timeout) {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, modelCtrl) {
            modelCtrl.$parsers.push(function (inputValue) {
                var transformedInput = inputValue.replace(/\D/g, '');
                if (transformedInput != inputValue) {
                    element.next("span").show(0).delay(2000).hide(0);
                    modelCtrl.$setViewValue(transformedInput);
                    modelCtrl.$render();
                }
                return transformedInput;
            });
        }
    };
}]);

mcapp.factory('checkDeviceDataService', ['$http', 'HOST', function ($http, HOST) {
    var checkDeviceDataFactory = {};
    var _checkData = function (item, deviceId, newVal) {
        switch (item) {
            case "serialNumber":
            case "rsSerialNumber":
                return _checkSerialNumber(deviceId, newVal);

            case "radioEsn":
            case "rsRadioEsn":
                return _checkRadioEsn(deviceId, newVal);

            case "imei":
            case "rsImei":
                return _checkImei(deviceId, newVal);

            case "simNumber":
            case "rsSimNumber":
                return _checkSimNumber(deviceId, newVal);
            case "txId1":
            case "rsTxId1":
                return _checkTxId1(deviceId, newVal);
            case "txId2":
            case "rsTxId2":
                return _checkTxId2(deviceId, newVal);
        }
    };

    var _checkSerialNumber = function (deviceId, serialNumber) {
        return $http({
            method: 'Get',
            url: HOST + '/api/SerialNumber?deviceId=' + deviceId + '&serialNumber=' + serialNumber,
            cache: false
        });
    };

    var _checkRadioEsn = function (deviceId, radioEsn) {
        return $http({
            method: 'Get',
            url: HOST + '/api/RadioEsn?deviceId=' + deviceId + '&radioEsn=' + radioEsn,
            cache: false
        });
    };

    var _checkImei = function (deviceId, imei) {
        return $http({
            method: 'Get',
            url: HOST + '/api/Imei?deviceId=' + deviceId + '&imei=' + imei,
            cache: false
        });
    };

    var _checkSimNumber = function (deviceId, simNumber) {
        return $http({
            method: 'Get',
            url: HOST + '/api/SimNumber?deviceId=' + deviceId + '&simNumber=' + simNumber,
            cache: false
        });
    };

    var _checkTxId1 = function (deviceId, txId1) {
        return $http({
            method: 'Get',
            url: HOST + '/api/TxId1?deviceId=' + deviceId + '&txId1=' + txId1,
            cache: false
        });
    };

    var _checkTxId2 = function (deviceId, txId2) {
        return $http({
            method: 'Get',
            url: HOST + '/api/TxiD2?deviceId=' + deviceId + '&txId2=' + txId2,
            cache: false
        });
    };

    checkDeviceDataFactory.checkData = _checkData;
    return checkDeviceDataFactory;
}]);
'use strict';

angular.module('mc.rtu-info', ['mc.volumetric-calc', 'mc.location']);
'use strict';

mcapp.directive('relaysTab', ['$timeout', 'toaster', 'sharedSetupService', 'relaysSettingService', 'smrtsService', 'translationService', 'deviceMenuService', 'relayPositiveFeedbackService', 'modalService', 'unsavedChangesService', '$rootScope', function ($timeout, toaster, sharedSetupService, relaysSettingService, smrtsService, translationService, deviceMenuService, relayPositiveFeedbackService, modalService, unsavedChangesService, $rootScope) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        scope.translation = translationService.translation;
        scope.relaysTabData = [];
        scope.relaysConfig = [];
        scope.relaysConfigFields = ["description", "normalClosed", "showOnPopup"];
        scope.setLoadingInProgress(true);
        scope.optionBoard = attrs.optionBoard ? true : false;
        scope.blSt = false;
        scope.availableRelays = false;
        scope.showPositiveRelayFeedback = false;
        scope.showAddButton = true;
        scope.hasMydroExpansion = false;
        scope.serviceModeTimeout = [];
        scope.relayChannelInUse = false;

        scope.devices = [];

        //availale relays for positive feedback
        scope.availablePositiveFeedbacks = [];

        scope.relayFeedbacks = [];

        scope.existingRelayFeedbacks = [];

        scope.feedbackDelays = [];

        //scope.feedbackInputs = [];

        var _availablePositiveFeedbacks = function _availablePositiveFeedbacks() {
            var len = arguments.length,
                i = 0;
            var tmpLength = scope.availablePositiveFeedbacks.length;
            for (i = 0; i < len; i++) {
                if (tmpLength == 0) {
                    scope.availablePositiveFeedbacks.push(arguments[i]);
                } else {
                    scope.availablePositiveFeedbacks[i].description = arguments[i].description;
                }
            }
            scope.originalPositiveFeedbacks = angular.copy(scope.availablePositiveFeedbacks);
        };

        //var _feedbackInputs = function () {
        //    var len = arguments.length,
        //        i = 0;
        //    var tmpLength = scope.feedbackInputs.length;
        //    for (i = 0; i < len; i++) {
        //        if (tmpLength == 0) {
        //            scope.feedbackInputs.push(arguments[i]);
        //        } else {
        //            scope.feedbackInputs[i].description = arguments[i].description;
        //        }
        //    }
        //};

        var _feedbackDelays = function _feedbackDelays() {
            var len = arguments.length,
                i = 0;
            var tmpLength = scope.feedbackDelays.length;
            for (i = 0; i < len; i++) {
                if (tmpLength == 0) {
                    scope.feedbackDelays.push(arguments[i]);
                } else {
                    scope.feedbackDelays[i].description = arguments[i].description;
                }
            }
        };

        var _serviceModeTimeout = function _serviceModeTimeout() {
            var len = arguments.length,
                i = 0;
            var tmpLength = scope.serviceModeTimeout.length;
            for (i = 0; i < len; i++) {
                if (tmpLength == 0) {
                    scope.serviceModeTimeout.push(arguments[i]);
                } else {
                    scope.serviceModeTimeout[i].description = arguments[i].description;
                }
            }
        };

        scope.smrtsStatus = scope.resetIndicator;

        var _initializeSetting = function _initializeSetting() {
            _serviceModeTimeout({ "id": 15, "description": "15 " + scope.translation.text.MINUTES }, { "id": 30, "description": "30 " + scope.translation.text.MINUTES }, { "id": 45, "description": "45 " + scope.translation.text.MINUTES }, { "id": 60, "description": "1 " + scope.translation.text.HOUR }, { "id": 90, "description": "1 " + scope.translation.text.HOUR + " & 30 " + scope.translation.text.MINUTES }, { "id": 120, "description": "2 " + scope.translation.text.HOURS }, { "id": 150, "description": "2 " + scope.translation.text.HOURS + " & 30 " + scope.translation.text.MINUTES }, { "id": 180, "description": "3 " + scope.translation.text.HOURS }, { "id": 210, "description": "3 " + scope.translation.text.HOURS + " & 30 " + scope.translation.text.MINUTES }, { "id": 240, "description": "4 " + scope.translation.text.HOURS }, { "id": 300, "description": "5 " + scope.translation.text.HOURS }, { "id": 360, "description": "6 " + scope.translation.text.HOURS }, { "id": 420, "description": "7 " + scope.translation.text.HOURS }, { "id": 480, "description": "8 " + scope.translation.text.HOURS }, { "id": 540, "description": "9 " + scope.translation.text.HOURS }, { "id": 600, "description": "10 " + scope.translation.text.HOURS }, { "id": 660, "description": "11 " + scope.translation.text.HOURS }, { "id": 720, "description": "12 " + scope.translation.text.HOURS }, { "id": 1080, "description": "18 " + scope.translation.text.HOURS }, { "id": 1440, "description": "24 " + scope.translation.text.HOURS });

            _feedbackDelays({ "id": 1, "description": "1 " + scope.translation.text.MINUTE }, { "id": 2, "description": "2 " + scope.translation.text.MINUTES }, { "id": 3, "description": "3 " + scope.translation.text.MINUTES }, { "id": 4, "description": "4 " + scope.translation.text.MINUTES }, { "id": 5, "description": "5 " + scope.translation.text.MINUTES }, { "id": 6, "description": "6 " + scope.translation.text.MINUTES }, { "id": 7, "description": "7 " + scope.translation.text.MINUTES }, { "id": 8, "description": "8 " + scope.translation.text.MINUTES }, { "id": 9, "description": "9 " + scope.translation.text.MINUTES }, { "id": 10, "description": "10 " + scope.translation.text.MINUTES });

            //_feedbackInputs(
            //    { "id": 1, "description": scope.translation.text.INPUT + ' ' + "#1" },
            //    { "id": 2, "description": scope.translation.text.INPUT + ' ' + "#2" },
            //    { "id": 3, "description": scope.translation.text.INPUT + ' ' + "#3" },
            //    { "id": 4, "description": scope.translation.text.INPUT + ' ' + "#4" },
            //    { "id": 5, "description": scope.translation.text.INPUT + ' ' + "#5" },
            //    { "id": 6, "description": scope.translation.text.INPUT + ' ' + "#6" },
            //    { "id": 7, "description": scope.translation.text.INPUT + ' ' + "#7" },
            //    { "id": 8, "description": scope.translation.text.INPUT + ' ' + "#8" },
            //    { "id": 9, "description": scope.translation.text.INPUT + ' ' + "#9" },
            //    { "id": 10, "description": scope.translation.text.INPUT + ' ' + "#10" },
            //    { "id": 11, "description": scope.translation.text.INPUT + ' ' + "#11" },
            //    { "id": 12, "description": scope.translation.text.INPUT + ' ' + "#12" },
            //    { "id": 13, "description": scope.translation.text.INPUT + ' ' + "#13" },
            //    { "id": 14, "description": scope.translation.text.INPUT + ' ' + "#14" },
            //    { "id": 15, "description": scope.translation.text.INPUT + ' ' + "#15" },
            //    { "id": 16, "description": scope.translation.text.INPUT + ' ' + "#16" }
            //);

            //M50 only supports one relay
            if (scope.deviceSelectedType == 21) {
                _availablePositiveFeedbacks({ "relayId": 1, "description": scope.translation.text.RELAY + ' ' + '1' });
            } else {
                _availablePositiveFeedbacks({ "relayId": 1, "description": scope.translation.text.RELAY + ' ' + '1' }, { "relayId": 2, "description": scope.translation.text.RELAY + ' ' + '2' }, { "relayId": 3, "description": scope.translation.text.RELAY + ' ' + '3' });
            }

            //get 800 series devices
            deviceMenuService.getDeviceMenuList(scope.accountInfo.customerId).then(function (result) {
                for (var index = 0; index < result.data.devices.length; ++index) {
                    if (result.data.devices[index].type === 9 || result.data.devices[index].type === 19 || result.data.devices[index].type === 21) scope.devices.push(result.data.devices[index]);
                }
            });
        };

        _initializeSetting();
        //Log tab access event to NLog
        relayPositiveFeedbackService.postRpfNlog(scope.accountInfo.customerId, scope.deviceSelected).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        scope.$on('updatePreferencesLanguage', function (event, args) {
            _initializeSetting();
        });

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {

                //Changing Device, back to "Basic Info" tab
                if (!angular.isUndefined(scope.currentDevice)) return;

                scope.currentDevice = newValue;
                var _device = { deviceName: scope.deviceSelectedName };
                var _deviceType = scope.deviceSelectedType;
                if (_deviceType == 9 || _deviceType == 19 || _deviceType == 21) {
                    scope.showPositiveRelayFeedback = true;
                    //get relay positive feeback data
                    scope.getRelayFeedbacks(newValue);
                }

                //When user changes device, we don't want the following to happen
                //since we take user back to Basic Info tab!
                scope.tmpStopCall = $timeout(function () {
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                    scope.getRelaysSetting(newValue);
                }, 0);
            }
        }, true);

        scope.$on("$destroy", function () {
            $timeout.cancel(scope.tmpStopCall);
        });

        //validation for inserting new relay positive feedback
        scope.validateSetting = function (relayFeedback) {
            if (relayFeedback.relayId === null || relayFeedback.feedbackDeviceId === null || relayFeedback.feedbackInputId === null || relayFeedback.tripDelay === null) {
                return false;
            }
            if (relayFeedback.relayId.relayId == 0 || relayFeedback.feedbackDeviceId.deviceId == 0 || relayFeedback.feedbackInputId.id == 0 || relayFeedback.tripDelay.id == 0) {
                return false;
            }
            return true;
        };

        scope.cancelAdd = function () {
            scope.relayFeedbacks.splice(0, 1);
            scope.showAddButton = true;
        };

        scope.addPositiveRelay = function () {
            scope.showAddButton = false;
            var newPositiveRelay = {
                id: 0,
                relayId: { relayId: 0 },
                feedbackDeviceId: { deviceId: 0 },
                feedbackInputId: { id: 0 },
                tripDelay: { id: 0 },
                invertState: 0
            };

            if (scope.relayFeedbacks) {
                scope.availablePositiveFeedbacks = angular.copy(scope.originalPositiveFeedbacks);
                for (var i = 0; i < scope.relayFeedbacks.length; i++) {
                    for (var j = 0; j < scope.availablePositiveFeedbacks.length; j++) {
                        if (scope.relayFeedbacks[i].relayId.relayId === scope.availablePositiveFeedbacks[j].relayId) scope.availablePositiveFeedbacks.splice(j, 1);
                    }
                }
            }
            scope.relayFeedbacks.unshift(newPositiveRelay);
        };

        //save relay positive feedback setting
        scope.savePositiveRelay = function (newRelayFeedback) {
            if (scope.validateSetting(newRelayFeedback)) {
                var relaySetting = {
                    relayDeviceIdNumber: scope.deviceSelected,
                    relayIdNumber: newRelayFeedback.relayId.relayId,
                    FeedbackDeviceIdNumber: newRelayFeedback.feedbackDeviceId.deviceId,
                    FeedbackInputIdNumber: newRelayFeedback.feedbackInputId.id,
                    TripDelay: newRelayFeedback.tripDelay.id,
                    InvertState: newRelayFeedback.invertState
                };
                relayPositiveFeedbackService.postRpf(scope.accountInfo.customerId, relaySetting).then(function (result) {
                    scope.getRelayFeedbacks(scope.deviceSelected);
                    scope.showAddButton = true;
                    if (scope.accountInfo.notificationMode == 1) {
                        modalService.saveNotification().then(function () {});
                    }
                }, function (error) {
                    //error handling
                });
            }
        };

        //update existing relay positive feedback setting
        var _timeout = [];

        scope.updateFeedbackDevice = function (item) {
            item.feedbackDeviceModel = item.feedbackDeviceId.deviceModel;
            item.feedbackDeviceHasMydroExpansion = item.feedbackDeviceId.hasMydroExpansion;
            item.feedbackInputOptions = scope.getFeedbackInputOptions(item);

            if (item.feedbackInputId.id > item.feedbackInputOptions.length) {
                item.feedbackInputId = { id: 0 };
            } else {
                scope.updateDelay(item);
            }
        };

        scope.updateDelay = function (updatedSetting) {
            $timeout.cancel(_timeout[updatedSetting.relayId.relayId]);
            _timeout[updatedSetting.relayId.relayId] = $timeout(function () {
                scope.updatePositiveRelay(updatedSetting);
            }, 3000);
        };

        scope.updatePositiveRelay = function (newRelayFeedback) {
            if (scope.validateSetting(newRelayFeedback)) {
                if (newRelayFeedback.id == 0) return;
                var relaySetting = {
                    relayDeviceIdNumber: scope.deviceSelected,
                    relayIdNumber: newRelayFeedback.relayId.relayId,
                    FeedbackDeviceIdNumber: newRelayFeedback.feedbackDeviceId.deviceId,
                    FeedbackInputIdNumber: newRelayFeedback.feedbackInputId.id,
                    TripDelay: newRelayFeedback.tripDelay.id,
                    InvertState: newRelayFeedback.invertState
                };
                relayPositiveFeedbackService.putRpf(scope.accountInfo.customerId, relaySetting).then(function (result) {}, function (error) {
                    //error handling
                });
            }
        };

        //check for eligibility to delete selected positive relay feedback
        scope.checkBeforeDelete = function (relay) {
            relayPositiveFeedbackService.checkRpfBeforeDelete(relay, scope.accountInfo.timeZone).then(function (result) {
                var relayInput = "r" + relay.relayIdNumber;
                var digitalInput = "d" + relay.feedbackInputIdNumber;
                if (result != null && result.data != null) {
                    if (result.data[digitalInput] == "NULL") result.data[digitalInput] = "False";
                    if (result.data[relayInput] == "NULL") {
                        scope.deletePositiveRelay(relay.relayId.relayId);
                    } else if (result.data[relayInput] != result.data[digitalInput]) {
                        console.log('IN Delete');
                        modalService.prfDeleteErrorNotification('PRF_DELETE_ERROR').then(function () {});
                    } else {
                        scope.deletePositiveRelay(relay.relayId.relayId);
                    }
                } else {
                    scope.deletePositiveRelay(relay.relayId.relayId);
                }
            }, function (error) {
                //error handling
            });
        };

        //delete existing relay positive feedback setting
        scope.deletePositiveRelay = function (relayId) {
            modalService.confirmDelete('DELETE_POSITIVE_RELAY').then(function () {
                relayPositiveFeedbackService.deleteRpf(scope.accountInfo.customerId, scope.deviceSelected, relayId).then(function (result) {
                    scope.getRelayFeedbacks(scope.deviceSelected);
                }, function (error) {
                    //error handling
                });
            });
        };

        //get relay positive feedback data
        scope.getRelayFeedbacks = function (varDeviceId) {
            if (scope.accountInfo === null || !varDeviceId) return;
            scope.langId = scope.accountInfo.preferenceUser.i18nCode === 'fr' ? scope.accountInfo.preferenceUser.i18nCode : 'en';
            var languageId = scope.langId === 'fr' ? 2 : 1;
            relayPositiveFeedbackService.getRpf(varDeviceId, scope.accountInfo.customerId, languageId).then(function (result) {
                scope.relayFeedbacks = result.data.relayPositiveFeedbacks;
                if (scope.devices.length > 0) {
                    var deviceIndex = scope.devices.findIndex(function (d) {
                        return d.deviceId == scope.currentDevice;
                    });
                    var hasMydroExpansion = scope.devices[deviceIndex].hasMydroExpansion;
                    scope.hasMydroExpansion = hasMydroExpansion;
                    if (hasMydroExpansion && scope.originalPositiveFeedbacks.length != 9 && scope.deviceSelectedType != 21) {
                        scope.availablePositiveFeedbacks.push({ "relayId": 4, "description": scope.translation.text.RELAY + ' ' + '4' }, { "relayId": 5, "description": scope.translation.text.RELAY + ' ' + '5' }, { "relayId": 6, "description": scope.translation.text.RELAY + ' ' + '6' }, { "relayId": 7, "description": scope.translation.text.RELAY + ' ' + '7' }, { "relayId": 8, "description": scope.translation.text.RELAY + ' ' + '8' }, { "relayId": 9, "description": scope.translation.text.RELAY + ' ' + '9' });
                        scope.originalPositiveFeedbacks = angular.copy(scope.availablePositiveFeedbacks);
                    }
                }
                scope.positiveRelayFeedbackDescriptions = result.data.positiveRelayFeedbackDescriptions;
                for (var i = 0; i < scope.relayFeedbacks.length; i++) {
                    scope.relayFeedbacks[i].relayId = { relayId: result.data.relayPositiveFeedbacks[i].relayIdNumber };
                    scope.relayFeedbacks[i].feedbackDeviceId = { deviceId: result.data.relayPositiveFeedbacks[i].feedbackDeviceIdNumber };
                    scope.relayFeedbacks[i].feedbackInputId = { id: result.data.relayPositiveFeedbacks[i].feedbackInputIdNumber };
                    scope.relayFeedbacks[i].tripDelay = { id: result.data.relayPositiveFeedbacks[i].tripDelay };
                    //dynamically assign feedback input options based on device type
                    scope.relayFeedbacks[i].feedbackInputOptions = scope.getFeedbackInputOptions(scope.relayFeedbacks[i]);
                    //Get descriptions for positive relays
                    scope.relayFeedbacks[i].relayNormal = scope.positiveRelayFeedbackDescriptions[i].relayNormal;
                    scope.relayFeedbacks[i].relayOffNormal = scope.positiveRelayFeedbackDescriptions[i].relayOffNormal;
                    scope.relayFeedbacks[i].pumpFailedToStop = scope.positiveRelayFeedbackDescriptions[i].pumpFailedToStop;
                    scope.relayFeedbacks[i].pumpFailedToRun = scope.positiveRelayFeedbackDescriptions[i].pumpFailedToRun;
                    scope.relayFeedbacks[i].pumpStartedPrematurely = scope.positiveRelayFeedbackDescriptions[i].pumpStartedPrematurely;
                    scope.relayFeedbacks[i].pumpStoppedPrematurely = scope.positiveRelayFeedbackDescriptions[i].pumpStoppedPrematurely;
                    scope.relayFeedbacks[i].returnToNormalFromPumpStartedPrematurely = scope.positiveRelayFeedbackDescriptions[i].returnToNormalFromPumpStartedPrematurely;
                    scope.relayFeedbacks[i].returnToNormalFromPumpStoppedPrematurely = scope.positiveRelayFeedbackDescriptions[i].returnToNormalFromPumpStoppedPrematurely;
                    scope.relayFeedbacks[i].entryType = scope.positiveRelayFeedbackDescriptions[i].entryType;
                }
                scope.existingRelayFeedbacks = angular.copy(scope.relayFeedbacks);
            });
        };

        scope.isDescriptionValid = function (description) {
            if (description === null || description === undefined || description.length === 0) {
                return false;
            }
            return true;
        };

        scope.storeCurrentDescription = function (description) {
            scope.storedFieldValue = description;
        };

        scope.saveDescription = function (prfDescription, relayNumber, state) {
            // Only perform a save if the description in question is valid            
            var input = 69 + relayNumber; //relay 1: 70 relay 2: 71 relay 3: 72
            var description = "";
            switch (state) {
                case 0:
                    description = prfDescription.relayNormal;
                    break;
                case 1:
                    description = prfDescription.relayOffNormal;
                    break;
                case 6:
                    description = prfDescription.pumpFailedToStop;
                    break;
                case 7:
                    description = prfDescription.pumpFailedToRun;
                    break;
                case 16:
                    description = prfDescription.pumpStartedPrematurely;
                    break;
                case 17:
                    description = prfDescription.pumpStoppedPrematurely;
                    break;
                case 26:
                    description = prfDescription.returnToNormalFromPumpStartedPrematurely;
                    break;
                case 27:
                    description = prfDescription.returnToNormalFromPumpStoppedPrematurely;
                    break;
            }
            if (scope.isDescriptionValid(description)) {
                if (description !== scope.storedFieldValue) {
                    var languageId = scope.langId === 'fr' ? 2 : 1;
                    relayPositiveFeedbackService.updateRpfDescription(scope.accountInfo.customerId, scope.deviceSelected, encodeURIComponent(scope.deviceSelectedName), state, languageId, input, prfDescription).then(function (resp) {
                        if (resp.data !== 1) {
                            toaster.pop('error', scope.translation.text.RTU_CONFIGURATION, scope.translation.text.ERROR_REOPEN_WINDOW);
                        }
                    }, function (resp) {
                        toaster.pop('error', scope.translation.text.RTU_CONFIGURATION, resp.data);
                    });
                }
            }
        };

        scope.updateSMRTS = function () {
            scope.relayChannelInUse = false;
            scope.smrtsStatus = scope.spinner;
            scope.setLoadingInProgress(true);
            var _smrts = { "deviceId": scope.deviceSelected, "serviceModeRelay": scope.serviceRelay !== null ? scope.serviceRelay.channel : null, "serviceModeTimeout": scope.serviceTimeout.id };
            smrtsService.putSmrts(scope.accountInfo.customerId, scope.deviceSelected, _smrts).then(function (result) {
                scope.setLoadingInProgress(false);
                scope.smrtsStatus = scope.okCheck;
            }, function (error) {
                // error
                //add console.log or return error JS
                scope.setLoadingInProgress(false);
                scope.smrtsStatus = scope.okCheck;
                scope.relayChannelInUse = true;
                scope.relayChannelInUseErrorMessage = scope.translation.text.SERVICE_MODE_RELAY + ' ' + scope.translation.text.IN_USE + ': ' + scope.translation.text[error.data];
            });
        };

        scope.getRelaysSetting = function (varDeviceId) {
            if (scope.accountInfo === null || !varDeviceId) return;
            relaysSettingService.getData(scope.accountInfo.customerId, varDeviceId, scope.optionBoard ? 1 : 0).then(function (dataFromFactory) {

                for (var i = 0; i < dataFromFactory.data.availableRelays.length; i++) {
                    if (scope.optionBoard || !dataFromFactory.data.availableRelays[i].inUseBy) scope.availableRelays = true;
                    scope.relaysConfig.push({
                        "description": { "statusMessage": "", "regEx": /^.{1,40}$/, "validationRequirement": scope.translation.text.DESCRIPTION_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                        "normalClosed": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                        "showOnPopup": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true }
                    });
                }

                if (!scope.optionBoard) {
                    for (var j = 0; j < scope.serviceModeTimeout.length; j++) {
                        if (scope.serviceModeTimeout[j].id === dataFromFactory.data.setting.serviceModeTimeout) {
                            scope.serviceTimeout = { "id": dataFromFactory.data.setting.serviceModeTimeout };
                            scope.blSt = true;
                            break;
                        }
                    }

                    if (!scope.blSt) {
                        var _item = { "id": dataFromFactory.data.setting.serviceModeTimeout, "description": dataFromFactory.data.setting.serviceModeTimeout + " minutes" };
                        scope.serviceModeTimeout.unshift(_item);
                        scope.serviceTimeout = { "id": dataFromFactory.data.setting.serviceModeTimeout };
                    }

                    scope.serviceRelay = { "channel": dataFromFactory.data.setting.serviceModeRelay };
                    scope.serviceModeSetting = dataFromFactory.data.setting;
                }

                scope.relaysTabData = dataFromFactory.data.availableRelays;
                scope.relaysTabOld = angular.copy(scope.relaysTabData);
                scope.setLoadingInProgress(false);
            }, function (error) {
                scope.setLoadingInProgress(false);
                //error
            });
        };

        scope.postRelaysData = function (oldVal, newVal, item, index, e, regEx, channel) {
            scope.prePostRelays();
            var _errorClass = "val-error";
            var _element = typeof e !== "undefined" ? e.target : scope.targetField;
            if (typeof oldVal == "undefined" || oldVal == newVal) {
                $('.tooltip-error-message').hide(100);
                $(_element).removeClass(_errorClass);
                scope.relaysConfig[index][item].status = scope.resetIndicator;
                scope.relaysConfig[index][item].statusMessage = "";
                scope.setLoadingInProgress(false);
                return;
            }

            //scope.setLoadingInProgress(true);

            if (!scope.isValid(newVal, regEx)) {
                scope.throwRelaysError(_element, item, index, _errorClass);
                return;
            }

            scope.validationRelaysOk(oldVal, newVal, _element, item, index, _errorClass);
            scope.postRelaysDataDone(oldVal, newVal, _element, item, index, _errorClass, channel);
        };

        scope.checkIfValid = function (oldVal, newVal, item, index, e, regEx, channel) {

            var _errorClass = scope.getErrorClass();
            var _element = scope.getElement();

            scope.setLoadingInProgress(true);
            if (!scope.isValid(newVal, regEx)) {
                scope.throwRelaysError(_element, item, index, _errorClass);
                return;
            }

            scope.prePostRelays();

            $('.tooltip-error-message').hide(100);
            $(_element).removeClass(_errorClass);
            scope.setLoadingInProgress(false);
        };

        scope.prePostRelays = function () {
            for (var i = 0; i < scope.relaysTabData.length; i++) {
                for (var j = 0; j < scope.relaysConfigFields.length; j++) {
                    scope.relaysConfig[i][scope.relaysConfigFields[j]].disabled = false;
                    scope.relaysConfig[i][scope.relaysConfigFields[j]].status = scope.resetIndicator;
                    scope.relaysConfig[i][scope.relaysConfigFields[j]].statusMessage = "";
                }
            }
            return true;
        };

        scope.validationRelaysOk = function (oldVal, newVal, _element, item, index, _errorClass) {
            scope.relaysTabOld[index][item] = newVal;
            $(_element).removeClass(_errorClass);
            for (var i = 0; i < scope.relaysTabData.length; i++) {
                for (var j = 0; j < scope.relaysConfigFields.length; j++) {
                    if (i == index && scope.relaysConfigFields[j] == item) {
                        scope.relaysConfig[i][scope.relaysConfigFields[j]].status = scope.spinner;
                        scope.relaysConfig[i][scope.relaysConfigFields[j]].statusMessage = "";
                    } else {
                        scope.relaysConfig[i][scope.relaysConfigFields[j]].status = scope.resetIndicator;
                    }
                    scope.relaysConfig[i][scope.relaysConfigFields[j]].disabled = false;
                }
            }
        };

        scope.throwRelaysError = function (_element, item, index, _errorClass, serverCheck) {
            $(_element).addClass(_errorClass);
            for (var i = 0; i < scope.relaysTabData.length; i++) {
                for (var j = 0; j < scope.relaysConfigFields.length; j++) {
                    if (i == index && scope.relaysConfigFields[j] == item) {
                        scope.relaysConfig[i][item].status = scope.errorCheck;
                        scope.relaysConfig[i][item].disabled = false;
                        scope.relaysConfig[i][item].statusMessage = scope.relaysConfig[i][item].validationRequirement;
                    } else {
                        scope.relaysConfig[i][scope.relaysConfigFields[j]].status = scope.resetIndicator;
                        scope.relaysConfig[i][scope.relaysConfigFields[j]].disabled = true;
                    }
                }
            }
            $(_element).focus();
            $(_element).parent().find(".tooltip-error-message." + item + index).show(100);
        };

        scope.postRelaysOk = function (oldVal, newVal, _element, item, index, _errorClass) {
            scope.relaysTabOld[index][item] = newVal;
            $(_element).removeClass(_errorClass);
            scope.relaysConfig[index][item].status = scope.okCheck;
            scope.relaysConfig[index][item].statusMessage = "";
        };

        scope.postRelaysDataDone = function (oldVal, newVal, _element, item, index, _errorClass, channel) {
            var tmpRelaysData = { "op": "replace", "path": item, "value": newVal };
            relaysSettingService.patchRelaysSetting(scope.accountInfo.customerId, scope.deviceSelected, scope.deviceSelectedType, channel, scope.hasMydroExpansion, tmpRelaysData).then(function (result) {
                scope.setLoadingInProgress(false);
                $('.tooltip-error-message').hide(100); //.remove();
                scope.postRelaysOk(oldVal, newVal, _element, item, index, _errorClass);
            }, function (error) {
                //  error
                // error should be logged or returned JS
            });
        };

        scope.refreshRelaysData = function (item, index) {
            var _errorClass = "val-error";
            scope.relaysTabData[index][item] = scope.relaysTabOld[index][item];
            $(".tooltip-error-message").hide(100);
            $(scope.targetField).removeClass(_errorClass);
            scope.prePostRelays();
            scope.setLoadingInProgress(false);
        };

        if (scope.optionBoard !== true) $timeout(function () {
            scope.accordionActive = 0;
            element.accordion({
                heightStyle: "content",
                collapsible: true,
                active: scope.accordionActive,
                activate: function activate(event, ui) {
                    scope.accordionActive = $(this).accordion("option", "active");
                }
            });
        }, 0);

        //Check for unsaved Changes
        if (!$rootScope.mobile && !$rootScope.classicView) {
            scope._popup = _this.getExistingDialog(scope.windowId).ref;
            $(scope._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, scope._popup, scope, !scope.showAddButton);
            });
        }

        scope.getFeedbackInputOptions = function (relayFeedback) {

            if (relayFeedback.feedbackDeviceModel == 21) {
                return [{ "id": 1, "description": scope.translation.text.INPUT + ' ' + "#1" }, { "id": 2, "description": scope.translation.text.INPUT + ' ' + "#2" }, { "id": 3, "description": scope.translation.text.INPUT + ' ' + "#3" }];
            } else if (relayFeedback.feedbackDeviceHasMydroExpansion) {
                return [{ "id": 1, "description": scope.translation.text.INPUT + ' ' + "#1" }, { "id": 2, "description": scope.translation.text.INPUT + ' ' + "#2" }, { "id": 3, "description": scope.translation.text.INPUT + ' ' + "#3" }, { "id": 4, "description": scope.translation.text.INPUT + ' ' + "#4" }, { "id": 5, "description": scope.translation.text.INPUT + ' ' + "#5" }, { "id": 6, "description": scope.translation.text.INPUT + ' ' + "#6" }, { "id": 7, "description": scope.translation.text.INPUT + ' ' + "#7" }, { "id": 8, "description": scope.translation.text.INPUT + ' ' + "#8" }, { "id": 9, "description": scope.translation.text.INPUT + ' ' + "#9" }, { "id": 10, "description": scope.translation.text.INPUT + ' ' + "#10" }, { "id": 11, "description": scope.translation.text.INPUT + ' ' + "#11" }, { "id": 12, "description": scope.translation.text.INPUT + ' ' + "#12" }, { "id": 13, "description": scope.translation.text.INPUT + ' ' + "#13" }, { "id": 14, "description": scope.translation.text.INPUT + ' ' + "#14" }, { "id": 15, "description": scope.translation.text.INPUT + ' ' + "#15" }, { "id": 16, "description": scope.translation.text.INPUT + ' ' + "#16" }];
            } else {
                return [{ "id": 1, "description": scope.translation.text.INPUT + ' ' + "#1" }, { "id": 2, "description": scope.translation.text.INPUT + ' ' + "#2" }, { "id": 3, "description": scope.translation.text.INPUT + ' ' + "#3" }, { "id": 4, "description": scope.translation.text.INPUT + ' ' + "#4" }, { "id": 5, "description": scope.translation.text.INPUT + ' ' + "#5" }, { "id": 6, "description": scope.translation.text.INPUT + ' ' + "#6" }, { "id": 7, "description": scope.translation.text.INPUT + ' ' + "#7" }, { "id": 8, "description": scope.translation.text.INPUT + ' ' + "#8" }];
            }
        };
    };
}]);

mcapp.factory('relaysSettingService', ['$http', 'HOST', function ($http, HOST) {
    var relaysSettingFactory = {};

    var _getData = function _getData(customerId, deviceId, relayGroup) {
        return $http({
            method: 'Get',
            url: HOST + '/api/ServiceModeRelaySetting?customerId=' + customerId + '&deviceId=' + deviceId + '&relayGroup=' + relayGroup,
            cache: false
        });
    };

    var _getStateData = function _getStateData(deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/RelaySetting?deviceId=' + deviceId,
            cache: false
        });
    };

    var _patchRelaysSetting = function _patchRelaysSetting(customerId, deviceId, deviceTypeId, channel, hasMyDroExpansion, relaysSettingPatch) {
        return $http.patch(HOST + "/api/RelaySetting?customerId=" + customerId + "&deviceId=" + deviceId + "&deviceTypeId=" + deviceTypeId + "&channel=" + channel + "&hasMyDroExpansion=" + hasMyDroExpansion, relaysSettingPatch);
    };

    relaysSettingFactory.getData = _getData;
    relaysSettingFactory.getStateData = _getStateData;
    relaysSettingFactory.patchRelaysSetting = _patchRelaysSetting;
    return relaysSettingFactory;
}]);

mcapp.factory('smrtsService', ['$http', 'HOST', function ($http, HOST) {
    var smrtsFactory = {};

    var _putSmrts = function _putSmrts(customerId, deviceId, smrts) {
        return $http.put(HOST + "/api/ServiceModeRelayAndTimeoutSetting?customerId=" + customerId + "&deviceId=" + deviceId, smrts);
    };

    smrtsFactory.putSmrts = _putSmrts;
    return smrtsFactory;
}]);

mcapp.factory('relayPositiveFeedbackService', ['$http', 'HOST', function ($http, HOST) {
    var relayPositiveFeedbackFactory = {};

    var _getRpf = function _getRpf(relayDeviceId, customerId, langId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/RelayPositiveFeedback?deviceId=' + relayDeviceId + '&customerId=' + customerId + '&languageId=' + langId,
            cache: false
        });
    };

    var _checkRpfBeforeDelete = function _checkRpfBeforeDelete(relay, timeZone) {
        if (relay.relayDeviceIdNumber == relay.feedbackDeviceIdNumber) {
            return $http({
                method: 'Get',
                url: HOST + '/api/RelayPositiveFeedback?deviceId=' + relay.relayDeviceIdNumber + '&timeZone=' + timeZone,
                cache: false
            });
        } else {
            return $http({
                method: 'Get',
                url: HOST + '/api/RelayPositiveFeedback?relayDeviceId=' + relay.relayDeviceIdNumber + '&feedbackDeviceId=' + relay.feedbackDeviceIdNumber + '&timeZone=' + timeZone,
                cache: false
            });
        }
    };

    var _deleteRpf = function _deleteRpf(customerId, relayDeviceId, relayId) {
        return $http.delete(HOST + '/api/RelayPositiveFeedback?customerId=' + customerId + '&deviceId=' + relayDeviceId + '&relayId=' + relayId);
    };

    var _postRpf = function _postRpf(customerId, rpfs) {
        return $http.post(HOST + "/api/RelayPositiveFeedback?customerId=" + customerId, rpfs);
    };

    var _postRpfNlog = function _postRpfNlog(customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Relay";
        return $http({
            method: 'POST',
            url: HOST + '/api/RelayPositiveFeedback',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName }
        });
    };

    var _putRpf = function _putRpf(customerId, rpfs) {
        return $http.put(HOST + "/api/RelayPositiveFeedback?customerId=" + customerId, rpfs);
    };

    var _updateRpfDescription = function _updateRpfDescription(customerId, deviceId, deviceName, state, languageId, input, prfDescription) {
        return $http.put(HOST + "/api/PositiveRelayFeedbacckDescription?customerId=" + customerId + '&deviceId=' + deviceId + '&deviceName=' + deviceName + '&state=' + state + '&languageId=' + languageId + '&input=' + input, prfDescription);
    };

    relayPositiveFeedbackFactory.getRpf = _getRpf;
    relayPositiveFeedbackFactory.checkRpfBeforeDelete = _checkRpfBeforeDelete;
    relayPositiveFeedbackFactory.deleteRpf = _deleteRpf;
    relayPositiveFeedbackFactory.postRpf = _postRpf;
    // post the RelayPositiveFeedback tab access event to NLog
    relayPositiveFeedbackFactory.postRpfNlog = _postRpfNlog;
    relayPositiveFeedbackFactory.putRpf = _putRpf;
    relayPositiveFeedbackFactory.updateRpfDescription = _updateRpfDescription;
    return relayPositiveFeedbackFactory;
}]);
"use strict";

mcapp.controller("rainfallTabController", ["$scope", "$rootScope", "authenticationService", "rainGaugeListService", "rtuRainfallSiteService", "translationService", "$sce", "tmhDynamicLocale", "sharedSetupService", function ($scope, $rootScope, authenticationService, rainGaugeListService, rtuRainfallSiteService, translationService, $sce, tmhDynamicLocale, sharedSetupService) {
    $scope.translation = translationService.translation;
    $scope.availableTags_L = [];
    $scope.availableTags = [];
    $scope.availableTagsTmp = [];
    $scope.tmpI = "ABCDE";
    $scope.tmpII = "FGHIJKLM";
    $scope.tmpIII = "NOPQ";
    $scope.tmpIV = "RSTUVWXYZ";
    $scope.availableTagsI = [];
    $scope.availableTagsII = [];
    $scope.availableTagsIII = [];
    $scope.availableTagsIV = [];
    $scope.avtLevel = 0;
    $scope.alerts = [];
    $scope.metarStationSetting = { value: 1 };
    // 1- Customer Rainfal Metar Stations, 2- Device Specific Rainfall Station, 3- RTU Rainfall gauage

    //$scope.popup = _this.getExistingDialog($scope.windowId).ref;
    $scope.updateStatusProperty = undefined;
    $scope.spinner = "<i class='fa fa-spinner fa-2x fa-spin'></i>";
    $scope.okCheck = "<i class='fa fa-check fa-2x fa-green' ></i>";
    $scope.errorCheck = "<i class='fa fa-exclamation-circle fa-2x fa-red'></i>";
    $scope.resetIndicator = "<i class='fa fa-fw fa-2x'>&nbsp;</i>";
    $scope.wsModeOff = false;
    $scope.usStateList = sharedSetupService.usStateList;
    $scope.canadaProvinceList = sharedSetupService.canadaProvinceList;

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.setWsModeOff = function () {
        $scope.wsModeOff = !$scope.wsModeOff;
    };

    $scope.stateList = [];
    $scope.stateListTop = [];
    $scope.stateListMidd = [];
    $scope.stateListBottom = [];
    $scope.stateListDisabledA = [];
    $scope.stateListDisabledB = [];

    var accountInfo = authenticationService.getAccountInfo();
    $scope.updateAccess = accountInfo.userRole == 'Administrator' || accountInfo.userRole == 'SuperAdministrator' ? true : true;

    $scope.autoUpdate = function (varProperty) {
        //if (angular.isDefined($scope.updateStatusProperty) || ((varProperty == "rtuRadio" || varProperty == "weatherRadio") && $scope.rainfallSiteOption.value == $scope.rainfallSite)) return;
        $scope.updateStatusProperty = varProperty;
        $scope.resetUpdateIndicator();
        switch (varProperty) {
            case "rtu":
            case "rtuRadio":
                $scope.updateStatusRtu = $scope.spinner;
                _updateRainfallSiteSetting(varProperty);
                $scope.metarStationSetting = { value: 3 };
                break;
            case "weather":
            case "weatherRadio":
                if ($scope.metarStationIDSelectedOption == null) {
                    $scope.updateStatusProperty = undefined;
                    return;
                }
                $scope.updateStatusWeather = $scope.spinner;
                _updateRainfallSiteSetting(varProperty);
                $scope.metarStationSetting = { value: 2 };
                break;
            case "customerWeatherRadio":
                $scope.updateStatusCustomer = $scope.spinner;
                _updateRainfallSiteSetting(varProperty);
                $scope.metarStationSetting = { value: 1 };
                break;
        }
    };

    $scope.resetUpdateIndicator = function () {
        $scope.updateStatusRtu = $scope.resetIndicator;
        $scope.updateStatusWeather = $scope.resetIndicator;
        $scope.updateStatusCustomer = $scope.resetIndicator;
    };

    $scope.resetUpdateIndicator();

    $scope.getText = function (text) {
        if (!angular.isDefined(text)) return;
        return eval("$scope.translation.text." + text.toUpperCase());
    };

    rtuRainfallSiteService.getData(accountInfo.customerId, $scope.deviceSelected).then(function (result) {
        $scope.rainfallSiteSetting = result.data.setting;
        $scope.metarStationID = $scope.rainfallSiteSetting.metarStationId;
        $scope.rainfallSite = $scope.rainfallSiteSetting.rainfallSite;
        $scope.alternateMetarStationID = $scope.rainfallSiteSetting.alternateMetarStationID;

        if (parseInt($scope.alternateMetarStationID) != 0) {
            $scope.metarStationIDSelectedOption = { metarStationID: $scope.rainfallSiteSetting.alternateMetarStationID, city: result.data.city, state: result.data.state, icao: result.data.icao };
            $scope.metarStationSetting = { value: 2 };
        } else if (parseInt($scope.rainfallSite) != 0) {
            $scope.metarStationSetting = { value: 3 };
        } else {
            $scope.metarStationSetting = { value: 1 };
        }

        $scope.metarStations = result.data.metarStations;

        $scope.selectedStation();
        $scope.customerMetarStation = $scope.rainfallSiteSetting.customerRainfallSiteName;

        $scope.rainGaugeList = result.data.rainGauges;
        $scope.rainGauge = { deviceId: $scope.rainGaugeList.length > 0 && $scope.rainfallSite == 0 ? $scope.rainGaugeList[0].deviceId : $scope.rainfallSite };
        $scope.rainfallSiteOption = $scope.rainfallSite == 0 ? { value: 0 } : { value: 1 };
    }, function (result) {});

    //Log tab access event to NLog
    rtuRainfallSiteService.postUserActionRainfallSite2Nlog(accountInfo.customerId, $scope.deviceSelected).then(function (result) {
        //console.log(result);
    }, function (error) {
        // console.log(error);
    });

    $scope._getMetarStationHTML = function () {
        return $sce.trustAsHtml($scope.metarStationHTML);
    };

    function _updateRainfallSiteSetting(varProperty) {
        switch (varProperty) {
            case "rtu":
            case "rtuRadio":
                $scope.rainfallSiteSetting.rainfallSite = $scope.rainGauge.deviceId;
                $scope.rainfallSiteSetting.metarStationId = $scope.metarStationID;
                $scope.rainfallSiteSetting.alternateMetarStationID = 0;
                $scope.rainfallSiteSetting.rtuRainfallSettingID = 3;
                $scope.rainfallSite = 1;
                break;
            case "weather":
            case "weatherRadio":
                $scope.rainfallSiteSetting.rainfallSite = 0;
                $scope.rainfallSiteSetting.metarStationId = $scope.metarStationID;
                $scope.rainfallSiteSetting.alternateMetarStationID = $scope.metarStationIDSelectedOption.metarStationID;
                $scope.rainfallSiteSetting.rtuRainfallSettingID = 2;
                $scope.rainfallSite = 0;
                break;
            case "customerWeatherRadio":
                $scope.rainfallSiteSetting.rainfallSite = 0;
                $scope.rainfallSiteSetting.alternateMetarStationID = 0;
                $scope.rainfallSiteSetting.metarStationId = $scope.metarStationID;
                $scope.rainfallSiteSetting.rtuRainfallSettingID = 1;
                $scope.rainfallSite = 0;
                break;
        }

        $scope.rainfallSiteOption = $scope.rainfallSite == 0 ? { value: 0 } : { value: 1 };

        rtuRainfallSiteService.updateSetting(accountInfo.customerId, $scope.deviceSelected, $scope.rainfallSiteSetting).then(function (data) {
            switch ($scope.updateStatusProperty) {
                case "rtu":
                case "rtuRadio":
                    $scope.metarStationIDSelectedOption = null;
                    $scope.stateListSelectedOption = null;
                    $scope.updateStatusRtu = $scope.okCheck;
                    break;
                case "weather":
                case "weatherRadio":
                    $scope.metarStationID = $scope.rainfallSiteSetting.metarStationId;
                    $scope.updateStatusWeather = $scope.okCheck;
                    break;
                case "customerWeatherRadio":
                    $scope.metarStationIDSelectedOption = null;
                    $scope.stateListSelectedOption = null;
                    $scope.metarStationID = $scope.rainfallSiteSetting.metarStationId;
                    $scope.updateStatusCustomer = $scope.okCheck;
                    break;
            }
            $scope.updateStatusProperty = undefined;
            $scope.alerts = [];
            $scope.alerts.push({ msg: "Success", type: "info" });
            //$scope.rainfallSiteSetting = data;
        }, function (error) {
            $scope.status = 'Unable to update setting: ' + error.data.message;
            switch ($scope.updateStatusProperty) {
                case "rtu":
                    $scope.updateStatusRtu = $scope.errorCheck;
                    break;
                case "weather":
                    $scope.updateStatusWeather = $scope.errorCheck;
                    break;
                case "customerWeatherRadio":
                    $scope.updateStatusCustomer = $scope.errorCheck;
                    break;
            }
        });
    }

    $scope.$on('updatePreferenceWeather', function (event, args) {
        $scope.metarStationID = args.metarStationId;
        $scope.customerMetarStation = args.displayName;
    });

    $scope.selectedStation = function () {
        for (var i = 0; i < $scope.metarStations.length; i++) {
            if (parseInt($scope.alternateMetarStationID) === $scope.metarStations[i].metarStationID) {
                $scope.metarStationIDSelectedOption = { metarStationID: $scope.alternateMetarStationID };
                return;
            }
        }
    };
}]);

mcapp.factory("rainGaugeListService", ["$http", "HOST", function ($http, HOST) {
    var rainGaugeListFactory = {};
    var _getData = function _getData(customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/rainGaugeList?customerId=' + customerId,
            cache: false
        });
    };
    rainGaugeListFactory.getData = _getData;
    return rainGaugeListFactory;
}]);

mcapp.factory("rtuRainfallSiteService", ["$http", "HOST", function ($http, HOST) {
    var rtuRainfallSiteFactory = {};
    var _getData = function _getData(customerId, deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/RtuRainfallSite?customerId=' + customerId + "&deviceId=" + deviceId,
            cache: false
        });
    };

    var _updateSetting = function _updateSetting(customerId, deviceId, rtuRainfallSiteSetting) {
        return $http.put(HOST + "/api/RtuRainfallSiteSetting?customerId=" + customerId + "&deviceId=" + deviceId, rtuRainfallSiteSetting);
    };

    var _postUserActionRainfallSite2Nlog = function _postUserActionRainfallSite2Nlog(customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Rainfall Site";

        return $http({
            method: 'POST',
            url: HOST + "/api/RtuRainfallSite",
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    rtuRainfallSiteFactory.getData = _getData;
    rtuRainfallSiteFactory.updateSetting = _updateSetting;
    rtuRainfallSiteFactory.postUserActionRainfallSite2Nlog = _postUserActionRainfallSite2Nlog;
    return rtuRainfallSiteFactory;
}]);
mcapp.directive('radioSwapTab', ['$timeout', 'temperatureDataService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'swapRadioViewService', 'radioSwapDataService', 'checkDeviceDataService',
    function ($timeout, temperatureDataService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, swapRadioViewService, radioSwapDataService, checkDeviceDataService) {
    // return the directive link function. (compile function not needed)
        return function (scope, element, attrs) {

            scope.radioSwap = {};
            scope.setLoadingInProgress(false);
            var _color = "#b9b9b9";
            scope.stageProcess = true;
            scope.inProcess = function () {
                $(element).parents("span").find(".stageProcess").stop().animate({ color: "#000000" }, 250)
                .animate({
                    color: _color
                }, 250)
                .animate({
                    color: "#000000"
                }, 250)
                .animate({
                    color: _color
                }, 250)
                .animate({
                    color: "#000000"
                }, 250)
                .animate({ color: "#ffffff" }, 250);

                //for (var j = 0; j < scope.radioSwapDataConfig.length; j++) {
                //    //if (scope.radioSwap[scope.radioSwapDataConfig[j].id] != null) {
                //        var _id = scope.radioSwapDataConfig[j].id.substring(2);
                //        _id = _id.charAt(0).toLowerCase() + _id.substring(1);
                //        switch(_id) {
                //            case "wirelessCarrier":
                //                scope.device[_id] = scope.getWirelessCarrier(scope.radioSwap[scope.radioSwapDataConfig[j].id].id);
                //                break;
                //            case "model":
                //                //
                //                break;
                //            case "serialNumber":
                //                //nothing
                //                break;
                //            default:
                //                scope.device[_id] = scope.radioSwap[scope.radioSwapDataConfig[j].id];
                //                //scope.radioSwap[scope.radioSwapDataConfig[j].id] = null;
                //        }

                //    //}
                //}

                scope.stageProcess = true;
                scope.swapDoneBefore = true;


                scope.radioSwapPutData = angular.copy(scope.radioSwap);
                scope.radioSwapPutData["rsWirelessCarrier"] = scope.radioSwapPutData["rsWirelessCarrier"].id;
                scope.radioSwapPutData["rsModel"] = scope.getDeviceModelId(scope.radioSwapPutData["rsModel"]);

                radioSwapDataService.swapRadio(scope.deviceSelected, scope.accountInfo.customerId, scope.radioSwapPutData)
                .then(function (result) {
                    scope.processSwapRadioViewData(result.data);
                    scope.newSwap();
                    }, function (error) {
                    console.log("error");//error
                });
        };

        var radioSwapDataConfig = [];
        var rtuDataConfiguration = [];

        var _radioSwapDataConfig = function () {
            var len = arguments.length,
            i = 0;
            var tmpLength = radioSwapDataConfig.length;
            for (i = 0; i < len; i++) {
                if (tmpLength == 0) {
                    radioSwapDataConfig.push(arguments[i]);
                } else {
                    radioSwapDataConfig[i].name = arguments[i].name;
                    radioSwapDataConfig[i].validationRequirement = arguments[i].validationRequirement;
                }
            }
        };

        var _rtuDataConfiguration = function () {
            var len = arguments.length,
            i = 0;
            var tmpLength = rtuDataConfiguration.length;
            for (i = 0; i < len; i++) {
                if (tmpLength == 0) {
                    rtuDataConfiguration.push(arguments[i]);
                } else {
                    rtuDataConfiguration[i].name = arguments[i].name;
                    rtuDataConfiguration[i].validationRequirement = arguments[i].validationRequirement;
                }
            }
        };

        var _initializeRadioSwapSetting = function () {
            _radioSwapDataConfig(
                {
                    "id": "rsModel",
                    "name": scope.translation.text.DEVICE_TYPE,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": scope.translation.text.DEVICE_TYPE_ERR,
                    "adminOnly": true,
                    "disabled": true,
                    "maxLength": 1,
                    "placeholder": ""
                },
                {
                    "id": "rsSerialNumber",
                    "name": scope.translation.text.SERIAL_NUMBER,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{10,10}$/,
                    "validationRequirement": scope.translation.text.SERIAL_NUMBER_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 10,
                    "placeholder": ""
                },
               {
                   "id": "rsMotherboardSerialNumber",
                   "name": scope.translation.text.MOTHERBOARD_SN,
                   "type": "text",
                   "access": 0,
                   "status": scope.resetIndicator,
                   "statusMessage": "",
                   "regEx": /^\S{0,15}$/,
                   "validationRequirement": scope.translation.text.MOTHERBOARD_SN_ERR,
                   "adminOnly": true,
                   "disabled": false,
                   "maxLength": 15,
                   "placeholder": ""
               },
                {
                    "id": "rsDaughterBoardSerialNumber",
                    "name": scope.translation.text.DAUGHTERBOARD_SN,
                    "type": "text",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{0,15}$/,
                    "validationRequirement": scope.translation.text.DAUGHTERBOARD_SN_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15,
                    "placeholder": ""
                },
                {
                    "id": "rsTxId1",
                    "name": scope.translation.text.TXID1_MSID_IN_SPRINT,
                    "type": "text",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": scope.translation.text.TXID1_MSID_IN_SPRINT_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15,
                    "placeholder": "*"
                },
                {
                    "id": "rsTxId2",
                    "name": scope.translation.text.TXID2_MDN_IN_SPRINT,
                    "type": "text",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": scope.translation.text.TXID2_MDN_IN_SPRINT_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15,
                    "placeholder": ""
                },
                {
                    "id": "rsTxId3",
                    "name": scope.translation.text.TXID3_MSL_IN_SPRINT,
                    "type": "text",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": scope.translation.text.TXID3_MSL_IN_SPRINT_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15,
                    "placeholder": ""
                },
                {
                    "id": "rsRadioEsn",
                    "name": scope.translation.text.ESN_SPRINT_ONLY,
                    "type": "text",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^[a-zA-Z0-9]{0,15}$/,
                    "validationRequirement": scope.translation.text.ESN_SPRINT_ONLY_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15,
                    "placeholder": ""
                },
                {
                    "id": "rsSoftwareVersion",
                    "name": scope.translation.text.SOFTWARE_VERSION,
                    "type": "text",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^[0-9]+(\.[0-9]+)?$/,
                    "validationRequirement": scope.translation.text.SOFTWARE_VERSION_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 6,
                    "placeholder": "*"
                },
                {
                    "id": "rsWirelessCarrier",
                    "name": scope.translation.text.WIRELESS_CARRIER,
                    "type": "selectCarrier",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": scope.translation.text.WIRELESS_CARRIER_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 1,
                    "placeholder": ""
                },
                {
                    "id": "rsImei",
                    "name": scope.translation.text.IMEI,
                    "type": "text",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": scope.translation.text.IMEI_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 15,
                    "placeholder": "*"
                },
                {
                    "id": "rsSimNumber",
                    "name": scope.translation.text.SIM_NUMBER,
                    "type": "text",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{0,20}$/,
                    "validationRequirement": scope.translation.text.SIM_NUMBER_ERR,
                    "adminOnly": true,
                    "disabled": false,
                    "maxLength": 20,
                    "placeholder": ""
                }
            );

            _rtuDataConfiguration(
                {
                    "id": "model",
                    "name": scope.translation.text.DEVICE_TYPE,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": scope.translation.text.DEVICE_TYPE_ERR,
                    "adminOnly": false,
                    "disabled": false,
                    "maxLength": 1
                },
                {
                    "id": "serialNumber",
                    "name": scope.translation.text.SERIAL_NUMBER,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{10,10}$/,
                    "validationRequirement": scope.translation.text.SERIAL_NUMBER_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 10
                },
               {
                   "id": "motherboardSerialNumber",
                   "name": scope.translation.text.MOTHERBOARD_SN,
                   "type": "readOnly",
                   "access": 0,
                   "status": scope.resetIndicator,
                   "statusMessage": "",
                   "regEx": /^\S{0,15}$/,
                   "validationRequirement": scope.translation.text.MOTHERBOARD_SN_ERR,
                   "adminOnly": false,
                   "disabled": true,
                   "maxLength": 15
               },
                {
                    "id": "daughterBoardSerialNumber",
                    "name": scope.translation.text.DAUGHTERBOARD_SN,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{0,15}$/,
                    "validationRequirement": scope.translation.text.DAUGHTERBOARD_SN_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 15
                },
                {
                    "id": "txId1",
                    "name": scope.translation.text.TXID1_MSID_IN_SPRINT,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": scope.translation.text.TXID1_MSID_IN_SPRINT_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 15
                },
                {
                    "id": "txId2",
                    "name": scope.translation.text.TXID2_MDN_IN_SPRINT,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": scope.translation.text.TXID2_MDN_IN_SPRINT_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 15
                },
                {
                    "id": "txId3",
                    "name": scope.translation.text.TXID3_MSL_IN_SPRINT,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": scope.translation.text.TXID3_MSL_IN_SPRINT_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 15
                },
                {
                    "id": "radioEsn",
                    "name": scope.translation.text.ESN_SPRINT_ONLY,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^[a-zA-Z0-9]{0,15}$/,
                    "validationRequirement": scope.translation.text.ESN_SPRINT_ONLY_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 15
                },
                {
                    "id": "softwareVersion",
                    "name": scope.translation.text.SOFTWARE_VERSION,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^[0-9]+(\.[0-9]+)?$/,
                    "validationRequirement": scope.translation.text.SOFTWARE_VERSION_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 6
                },
                {
                    "id": "wirelessCarrier",
                    "name": scope.translation.text.WIRELESS_CARRIER,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": "",
                    "validationRequirement": scope.translation.text.WIRELESS_CARRIER_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 1
                },
                {
                    "id": "imei",
                    "name": scope.translation.text.IMEI,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\d{0,15}$/,
                    "validationRequirement": scope.translation.text.IMEI_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 15
                },
                {
                    "id": "simNumber",
                    "name": scope.translation.text.SIM_NUMBER,
                    "type": "readOnly",
                    "access": 0,
                    "status": scope.resetIndicator,
                    "statusMessage": "",
                    "regEx": /^\S{0,20}$/,
                    "validationRequirement": scope.translation.text.SIM_NUMBER_ERR,
                    "adminOnly": false,
                    "disabled": true,
                    "maxLength": 20
                }
        );
        };

        _initializeRadioSwapSetting();

        //Log tab access event to NLog
            swapRadioViewService.postUserAction2Nlog(scope.accountInfo.customerId, scope.deviceSelected).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        scope.radioSwapDataConfig = radioSwapDataConfig;
        scope.rtuDataConfig = rtuDataConfiguration;


        scope.$on('updatePreferencesLanguage', function (event, args) {
            _initializeRadioSwapSetting();
        });


        scope.getDevice = function (varDeviceId) {
            if (scope.accountInfo === null || !varDeviceId)
                return;
            swapRadioViewService.getData(scope.accountInfo.customerId, varDeviceId)
            .then(function (dataFromFactory) {
                scope.processSwapRadioViewData(dataFromFactory.data);
                }, function (error) {
                //error

            }).then(function (data) {
                scope.setLoadingInProgress(false);
            });
        };

        scope.getDevice(scope.deviceSelected);


        scope.processSwapRadioViewData = function (varServerData) {
            varServerData.deviceData.softwareVersion = varServerData.deviceData ? parseFloat(varServerData.deviceData.softwareVersion).toFixed(2) : '';
            scope.device = varServerData.deviceData;
            scope.device["wirelessCarrier"] = scope.getWirelessCarrier(scope.device["wirelessCarrier"]);//{ "id": varServerData.deviceData.wirelessCarrier };
            scope.device["model"] = scope.getDeviceModel(scope.device["model"]);//{ "id": varServerData.deviceData.model };
            if (varServerData.radioSwapData) {
                scope.radioSwap = varServerData.radioSwapData;
            }
            else {
                scope.ifNullRadioSwap();
            }
            scope.radioSwap.softwareVersion = scope.radioSwap.softwareVersion ? parseFloat(scope.radioSwap.softwareVersion).toFixed(2) : null;
            scope.sharedData();
            scope.setSwapOldData();
            scope.swapDoneBefore = scope.radioSwap.radioSwapUtcDate ? true : false;
        };

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

        scope.postRadioSwapData = function (oldVal, newVal, item, e, regEx) {
            scope.prePostRadioSwap();
            var _errorClass = scope.getErrorClass();
            var _element = scope.getElement();
            if (typeof oldVal == "undefined" || oldVal === newVal || (!isNaN(oldVal) && oldVal == newVal)) {
                $('.tooltip-error-message').hide(100);//.remove();
                $(_element).removeClass(_errorClass);
                for (var i = 0; i < scope.radioSwapDataConfig.length; i++) {
                    if (scope.radioSwapDataConfig[i].id == item) {
                        scope.radioSwapDataConfig[i].status = scope.resetIndicator;
                        scope.radioSwapDataConfig[i].statusMessage = "";
                    }
                }
                scope.setLoadingInProgress(false);
                return;
            }

            //scope.setLoadingInProgress(true);

            if (!scope.isValid(newVal, regEx)) {
                scope.throwRadioSwapError(_element, item, _errorClass);
                return;
            }

            if (item == "rsSerialNumber" || item == "rsRadioEsn" || item == "rsImei" || item == "rsSimNumber" || item == "rsTxId1" || item == "rsTxId2") {
                checkDeviceDataService.checkData(item, scope.deviceSelected, newVal)
                    .then(function (result) {
                        scope.resultCheck = result.data;
                        if (scope.resultCheck !== null) {
                            scope.throwRadioSwapError(_element, item, _errorClass, true);
                            return;
                        }
                        scope.validationOk(oldVal, newVal, _element, item, _errorClass);
                        scope.postRadioSwapDataDone(oldVal, newVal, _element, item, _errorClass);
                        return;
                    },function (error) {
                        //error
                    });
            } else {
                scope.validationOk(oldVal, newVal, _element, item, _errorClass);
                scope.postRadioSwapDataDone(oldVal, newVal, _element, item, _errorClass);
            }

        };

        scope.checkIfValid = function (oldVal, newVal, item, e, regEx) {

            var _errorClass = scope.getErrorClass();
            var _element = scope.getElement();

            scope.setLoadingInProgress(true);
            if (!scope.isValid(newVal, regEx)) {
                scope.throwRadioSwapError(_element, item, _errorClass);
                return;
            }

            scope.prePostRadioSwap();

            $('.tooltip-error-message').hide(100);
            $(_element).removeClass(_errorClass);
            scope.setLoadingInProgress(false);
        };

        scope.prePostRadioSwap = function () {
            for (var i = 0; i < scope.radioSwapDataConfig.length; i++) {
                scope.radioSwapDataConfig[i].disabled = false;
                scope.radioSwapDataConfig[i].status = scope.resetIndicator;
                scope.radioSwapDataConfig[i].statusMessage = "";
                //$('.tooltip-error-message').hide().remove();
            }
            return true;
        };

        scope.throwRadioSwapError = function (_element, item, _errorClass, serverCheck) {
            $(_element).addClass(_errorClass);
            for (var i = 0; i < scope.radioSwapDataConfig.length; i++) {
                if (scope.radioSwapDataConfig[i].id == item) {
                    scope.radioSwapDataConfig[i].status = scope.errorCheck;
                    scope.radioSwapDataConfig[i].disabled = false;
                    scope.radioSwapDataConfig[i].statusMessage = serverCheck ? scope.radioSwapDataConfig[i].id.toUpperCase() + " already exists!" : scope.radioSwapDataConfig[i].validationRequirement;//Test Error Message!!! Description: ???
                }
                else {
                    scope.radioSwapDataConfig[i].status = scope.resetIndicator;
                    scope.radioSwapDataConfig[i].disabled = true;
                }
            }
            $(_element).focus();
            $(_element).parent().find(".tooltip-error-message." + item).show(100);
        };

        scope.validationOk = function (oldVal, newVal, _element, item, _errorClass) {
            scope.radioSwapOld[item] = newVal;
            $(_element).removeClass(_errorClass);
            for (var i = 0; i < scope.radioSwapDataConfig.length; i++) {
                if (scope.radioSwapDataConfig[i].id == item) {
                    scope.radioSwapDataConfig[i].status = scope.spinner;
                    scope.radioSwapDataConfig[i].statusMessage = "";
                }
                else {
                    scope.radioSwapDataConfig[i].status = scope.resetIndicator;
                }
                scope.radioSwapDataConfig[i].disabled = false;
            }
        };

        scope.postOk = function (oldVal, newVal, _element, item, _errorClass) {
            scope.radioSwapOld[item] = newVal;
            $(_element).removeClass(_errorClass);
            for (var i = 0; i < scope.radioSwapDataConfig.length; i++) {
                if (scope.radioSwapDataConfig[i].id == item) {
                    scope.radioSwapDataConfig[i].status = scope.okCheck;
                    scope.radioSwapDataConfig[i].statusMessage = "";
                    break;
                }
            }
        };

        scope.postRadioSwapDataDone = function (oldVal, newVal, _element, item, _errorClass) {
            var tmpDevice = { "op": "replace", "path": item, "value": (typeof newVal == "object" && newVal != null && typeof newVal.id != "undefined" ? newVal.id : newVal) };
            radioSwapDataService.patchRadioSwap(scope.deviceSelected, scope.accountInfo.customerId, tmpDevice)
                .then(function (result) {
                    scope.setLoadingInProgress(false);
                    $('.tooltip-error-message').hide(100); //.remove();
                    scope.postOk(oldVal, newVal, _element, item, _errorClass);
                    if (item == "name") {
                        deviceMenuService.resetDeviceMenuList();
                        $rootScope.$broadcast('rtuBasicInfoUpdate');
                    }
                },function (error) {
                    //error
                });
        };

        scope.refreshRadioSwapData = function (varItemId) {
            var _errorClass = "val-error";
            scope.radioSwap[varItemId] = scope.radioSwapOld[varItemId];
            $(".tooltip-error-message").hide(100);//.remove();
            $(scope.targetField).removeClass(_errorClass);
            scope.prePostRadioSwap();
            scope.setLoadingInProgress(false);
        };

        scope.ifNullRadioSwap = function () {
            for (var i = 0; i < scope.radioSwapDataConfig.length; i++) {
                scope.radioSwap[scope.radioSwapDataConfig[i].id] = null;
            }
            scope.swapDoneBefore = false;
        };

        scope.sharedData = function () {
            scope.radioSwap["rsModel"] = scope.device["model"];
            scope.radioSwap["rsWirelessCarrier"] = { "id": scope.radioSwap.rsWirelessCarrier };
            scope.radioSwap["rsSerialNumber"] = scope.device["serialNumber"];
        };

        scope.setSwapOldData = function () {
            scope.radioSwapOld = angular.copy(scope.radioSwap);
        };

        scope.newSwap = function () {
            scope.ifNullRadioSwap();
            scope.sharedData();
            scope.setSwapOldData();
        };

        scope.setSwapRadioData = function (varItemId) {
            console.log(varItemId);
        };

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

        scope.$watch('radioSwap["rsImei"]', function (newValue, oldValue) {
            if (newValue != oldValue) {
                if (typeof scope.radioSwap !== "undefined") {
                    scope.radioSwap["rsTxId1"] = newValue;
                    scope.setStageProcess();
                }
            } else {
                scope.stageProcess = true;
            }
        }, true);

        scope.$watch('radioSwap["rsTxId1"]', function (newValue, oldValue) {
            if (newValue != oldValue) {
                if (typeof scope.radioSwap !== "undefined") {
                    scope.radioSwap["rsImei"] = newValue;
                    scope.setStageProcess();
                }
            } else {
                scope.stageProcess = true;
            }
        }, true);

        scope.$watch('radioSwap["rsSoftwareVersion"]', function (newValue, oldValue) {
            if (newValue != oldValue) {
                if (typeof scope.radioSwap !== "undefined") {
                    scope.setStageProcess();
                }
            } else {
                scope.stageProcess = true;
            }
        }, true);

        scope.setStageProcess = function () {
            scope.stageProcess = (scope.radioSwap["rsImei"] && scope.radioSwap["rsImei"].length > 0 && scope.radioSwap["rsTxId1"] && scope.radioSwap["rsTxId1"].length > 0 && scope.isNumber(scope.radioSwap["rsSoftwareVersion"])) ? false : true;
        };

        scope.isNumber = function (n) {
            var myregEx = /^[0-9]+(\.[0-9]+)?$/;
            return myregEx.test(n) === true;
        };
    };

}]);

mcapp.factory("radioSwapDataService", ["$http", "authenticationService", "HOST", function ($http, authenticationService, HOST) {
    var radioSwapDataFactory = {};

    var _patchRadioSwap = function (deviceId, customerId, radioSwapPatch) {
        return $http.patch(HOST + "/api/RadioSwapData?deviceId=" + deviceId + "&customerId=" + customerId, radioSwapPatch);
    };

    var _swapRadio = function (deviceId, customerId, radioSwap) {
        return $http.put(HOST + "/api/RadioSwapData?deviceId=" + deviceId + "&customerId=" + customerId, radioSwap);
    };

    radioSwapDataFactory.patchRadioSwap = _patchRadioSwap;
    radioSwapDataFactory.swapRadio = _swapRadio;

    return radioSwapDataFactory;
}
]);

"use strict";

function PumpsTabController($rootScope, $scope, $timeout, $element, sharedSetupService, pumpSettingService, authenticationService, translationService) {
    var ctrl = this;

    //following variables available through binding
    //ctrl.modelId
    //ctrl.mobile
    //ctrl.stickyProperties
    //ctrl.isAdmin
    //ctrl.isChromeOrFirefox
    //ctrl.optionBoard

    ctrl.$onInit = function () {
        ctrl.targetField = null;
        ctrl.disableTimepicker = true;
        ctrl.noPumps = true;
        ctrl.pumpTabData = [];
        ctrl.pumpVarianceAlertData = [];
        ctrl.pumpConfig = [];
        ctrl.pumpConfigFields = ["description", "model", "pumpCapacity", "serviceTime", "serviceHours"];
        setLoadingInProgress(true);

        ctrl.isOptionBoard = ctrl.optionBoard ? true : false;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        //by now parent view (RtuInfo) should set the device to stickyproperties
        ctrl.selectedDevice = ctrl.stickyProperties.device; // this object contains deviceId & deviceName properties only

        ctrl.timeFormatTimePicker = getTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);

        ctrl.getPumpSetting(ctrl.selectedDevice.deviceId);
        ctrl.getPumpVarianceAlert(ctrl.selectedDevice.deviceId);

        $timeout(function () {
            ctrl.tabElement = $element.find(".rtuinfo-pumps-tab-container");
            // let mytabElement = angular.element(myelement);
            ctrl.accordionActive = 0;
            ctrl.tabElement.accordion({
                heightStyle: "content",
                collapsible: true,
                active: ctrl.accordionActive,
                activate: function activate(event, ui) {
                    ctrl.accordionActive = ctrl.tabElement.accordion("option", "active");
                }
            });
            setLoadingInProgress(false);
        }, 100);

        //Log tab access event to NLog
        pumpSettingService.postUserActionPumpsSetting2Nlog(ctrl.accountInfo.customerId, ctrl.selectedDevice.deviceId).then(function (result) {
            //console.log(result);
        }, function (error) {
            //console.log(error);
        });
    };

    // internal functions -- Start

    // Methods from parent component >>"Rtu-Info-Module" ----- Start

    var setLoadingInProgress = function setLoadingInProgress(status) {
        ctrl.loadingInProgress = status;
    };

    var getTimeFormat = function getTimeFormat(timeFormat) {
        return timeFormat == 1 ? "h:mm a" : "H:mm";
    };
    var getErrorClass = function getErrorClass() {
        return "val-error";
    };

    var getElement = function getElement(event) {
        return typeof event !== "undefined" ? event.target : ctrl.targetField;
    };
    var isValid = function isValid(newVal, regEx) {
        if (regEx == "") return true;
        var myregEx = regEx;
        if (myregEx.test(newVal) == false) {
            return false;
        }
        return true;
    };
    // rounds the number to 2 decimal places
    var roundToTwo = function roundToTwo(num, decimals) {
        return +Number(Math.round(num + 'e' + decimals) + 'e-' + decimals);
    };
    // Methods from parent component >>"Rtu-Info-Module" ----- End

    var prePostPump = function prePostPump() {
        for (var i = 0; i < ctrl.pumpTabData.length; i++) {
            for (var j = 0; j < ctrl.pumpConfigFields.length; j++) {
                ctrl.pumpConfig[i][ctrl.pumpConfigFields[j]].disabled = false;
                ctrl.pumpConfig[i][ctrl.pumpConfigFields[j]].status = ctrl.resetIndicator;
                ctrl.pumpConfig[i][ctrl.pumpConfigFields[j]].statusMessage = "";
            }
        }
        return true;
    };

    var validationPumpOk = function validationPumpOk(oldVal, newVal, _element, item, index, _errorClass) {
        if (item == 'pumpCapacity') {
            //as pumpCapacity as additional uiPumpCapacity property, we are forced to have workaround to handle it
            ctrl.pumpTabOld[index].uiPumpCapacity = newVal;
        } else {
            ctrl.pumpTabOld[index][item] = newVal;
        }
        $(_element).removeClass(_errorClass);
        for (var i = 0; i < ctrl.pumpTabData.length; i++) {
            for (var j = 0; j < ctrl.pumpConfigFields.length; j++) {
                if (i == index && ctrl.pumpConfigFields[j] == item) {
                    ctrl.pumpConfig[i][ctrl.pumpConfigFields[j]].status = ctrl.spinner;
                    ctrl.pumpConfig[i][ctrl.pumpConfigFields[j]].statusMessage = "";
                } else {
                    ctrl.pumpConfig[i][ctrl.pumpConfigFields[j]].status = ctrl.resetIndicator;
                }
                ctrl.pumpConfig[i][ctrl.pumpConfigFields[j]].disabled = false;
            }
        }
    };

    var throwPumpError = function throwPumpError(_element, item, index, _errorClass, serverCheck) {
        $(_element).addClass(_errorClass);
        for (var i = 0; i < ctrl.pumpTabData.length; i++) {
            for (var j = 0; j < ctrl.pumpConfigFields.length; j++) {
                if (i == index && ctrl.pumpConfigFields[j] == item) {
                    ctrl.pumpConfig[i][item].status = ctrl.errorCheck;
                    ctrl.pumpConfig[i][item].disabled = false;
                    ctrl.pumpConfig[i][item].statusMessage = ctrl.pumpConfig[i][item].validationRequirement;
                } else {
                    ctrl.pumpConfig[i][ctrl.pumpConfigFields[j]].status = ctrl.resetIndicator;
                    ctrl.pumpConfig[i][ctrl.pumpConfigFields[j]].disabled = true;
                }
            }
        }
        $(_element).focus();
        $(_element).parent().find(".tooltip-error-message." + item + index).show(100);
    };

    var postPumpOk = function postPumpOk(newVal, _element, item, index, _errorClass) {
        ctrl.pumpTabOld[index][item] = newVal;
        $(_element).removeClass(_errorClass);
        ctrl.pumpConfig[index][item].status = ctrl.okCheck;
        ctrl.pumpConfig[index][item].statusMessage = "";
    };

    function convertToCustomerLocalTimeIfNeeded(inputDate, customerOffset) {
        var dateObj = new Date(inputDate);
        var systemOffset = dateObj.getTimezoneOffset(); // local system offset in minutes

        // Only apply conversion if system and customer timezone offsets are different
        if (systemOffset !== customerOffset) {
            var utcTimestamp = dateObj.getTime();
            var customerLocalTimestamp = utcTimestamp + customerOffset * 60 * 1000;
            return new Date(customerLocalTimestamp);
        }

        // No conversion needed
        return dateObj;
    }

    var postPumpDataDone = function postPumpDataDone(oldVal, newVal, _element, item, index, _errorClass, channel) {
        //MeasurementId => 1: Imperial; 2: Metric
        if (item == 'pumpCapacity' && ctrl.accountInfo.preferenceUser.lookupMeasurementID == 2) {
            //if measurement system is metric, then convert back capacity from LPM (Liters/Minute) to GPM (Gallons/Minute)
            newVal /= 3.78541;
            newVal = roundToTwo(newVal, 2);
        }

        if (item == 'serviceTime') {
            var serviceTime = convertToCustomerLocalTimeIfNeeded(newVal, ctrl.accountInfo.timeZoneOffset);
            newVal = moment(serviceTime).format('YYYY-MM-DDTHH:mm:ss');
        }

        var tmpPumpData = { "op": "replace", "path": item, "value": newVal };
        pumpSettingService.patchPumpSetting(ctrl.accountInfo.customerId, ctrl.selectedDevice.deviceId, channel, ctrl.accountInfo.timeZone, tmpPumpData).then(function (result) {
            setLoadingInProgress(false);
            $('.tooltip-error-message').hide(100); //.remove();
            postPumpOk(newVal, _element, item, index, _errorClass);
            var _dataChanged = "model, pumpCapacity, serviceTime, serviceHours";
            if (_dataChanged.indexOf(item) > -1) {
                var _device = { deviceId: ctrl.selectedDevice.deviceId, channel: channel, fieldName: item, newSetting: result };
                $rootScope.$broadcast('rtuPumpUpdate', _device);
            }
        }, function (error) {
            // error
            // JS should return error or use console log
        });
    };

    // internal functions -- End

    // Isolated scope functions -- Start
    ctrl.focusCallback = function ($event) {
        if ($event.target === null) {
            return;
        }
        ctrl.targetField = $event.target;
    };

    ctrl.getPumpVarianceAlert = function (varDeviceId) {
        pumpSettingService.getPumpVarianceAlert(varDeviceId).then(function (dataFromFactory) {
            ctrl.pumpVarianceAlertData = dataFromFactory.data;
            //for ranger device, check which channel is used as runtime.
            //and for ranger device, only 1 channel can be used as runtime so no need to loop
            if (ctrl.modelId == 21) {
                if (!ctrl.noPumps) {
                    ctrl.pumpVarianceAlertData = ctrl.pumpVarianceAlertData.filter(function (item) {
                        return item.pumpNumber == ctrl.pumpTabData[0].channel;
                    });
                } else {
                    ctrl.pumpVarianceAlertData = [];
                }
            }
            //console.log(ctrl.pumpVarianceAlertData);
        }, function (error) {
            //error
        });
    };

    ctrl.getPumpSetting = function (varDeviceId) {
        if (ctrl.accountInfo === null) return;
        pumpSettingService.getData(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone, varDeviceId, ctrl.isOptionBoard).then(function (dataFromFactory) {
            for (var i = 0; i < dataFromFactory.data.length; i++) {
                ctrl.pumpConfig.push({
                    "description": { "statusMessage": "", "regEx": "", "validationRequirement": ctrl.translation.text.DESCRIPTION_ERR, "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                    "model": { "statusMessage": "", "regEx": /^.{0,150}$/, "validationRequirement": ctrl.translation.text.PUMP_MODEL_ERR, "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                    "pumpCapacity": { "statusMessage": "", "regEx": /^[0-9]+(\.[0-9]+)?$/, "validationRequirement": ctrl.translation.text.GPM_ERR, "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                    "serviceTime": { "statusMessage": "", "regEx": "", "validationRequirement": ctrl.translation.text.LAST_SERVICED_DATE_TIME_ERR, "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                    "serviceHours": { "statusMessage": "", "regEx": /^[0-9]+(\.[0-9]+)?$/, "validationRequirement": ctrl.translation.text.ET_AT_LAST_SERVICE_ERR, "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true }
                });
                //dataFromFactory.data[i].serviceTime = dataFromFactory.data[i].serviceTime != null ? ($rootScope.mobile ? new Date(dataFromFactory.data[i].serviceTime.substring(0, 4) + "-" + dataFromFactory.data[i].serviceTime.substring(5, 7) + "-" + dataFromFactory.data[i].serviceTime.substring(8, 10)) : dataFromFactory.data[i].serviceTime.substring(5, 7) + "/" + dataFromFactory.data[i].serviceTime.substring(8, 10) + "/" + dataFromFactory.data[i].serviceTime.substring(0, 4) + " " + dataFromFactory.data[i].serviceTime.substring(11, 19)) : null;
                dataFromFactory.data[i].serviceTime = dataFromFactory.data[i].serviceTime != null ? $rootScope.mobile ? new Date(dataFromFactory.data[i].serviceTime) : dataFromFactory.data[i].serviceTime.substring(5, 7) + "/" + dataFromFactory.data[i].serviceTime.substring(8, 10) + "/" + dataFromFactory.data[i].serviceTime.substring(0, 4) + " " + dataFromFactory.data[i].serviceTime.substring(11, 19) : null;
            }
            ctrl.pumpTabData = dataFromFactory.data;

            for (var j = 0; j < ctrl.pumpTabData.length; j++) {
                //if measurement system is metric, then convert capacity from GPM (Gallons/Minute) to LPM (Liters/Minute)
                var tmpPumpCapacity = ctrl.pumpTabData[j].pumpCapacity;

                //MeasurementId => 1: Imperial; 2: Metric
                if (ctrl.accountInfo.preferenceUser.lookupMeasurementID == 2) {
                    tmpPumpCapacity *= 3.78541;
                }
                ctrl.pumpTabData[j].uiPumpCapacity = roundToTwo(tmpPumpCapacity, 2);
            }

            ctrl.pumpTabOld = angular.copy(ctrl.pumpTabData);
            ctrl.noPumps = ctrl.pumpTabData.length > 0 ? false : true;
            setLoadingInProgress(false);
        }, function (error) {
            //error

        }).then(function (data) {
            setLoadingInProgress(false);
        });
    };

    ctrl.postPumpData = function (oldVal, newVal, item, index, e, regEx, channel) {
        //reset pump status and error messages etc
        prePostPump();

        var _errorClass = "val-error";
        var _element = typeof e !== "undefined" ? e.target : ctrl.targetField;
        if (typeof oldVal == "undefined" || oldVal === newVal || !isNaN(oldVal) && oldVal == newVal) {
            $('.tooltip-error-message').hide(100);
            $(_element).removeClass(_errorClass);
            ctrl.pumpConfig[index][item].status = ctrl.resetIndicator;
            ctrl.pumpConfig[index][item].statusMessage = "";
            setLoadingInProgress(false);
            return;
        }

        if (!isValid(newVal, regEx)) {
            throwPumpError(_element, item, index, _errorClass);
            return;
        }

        validationPumpOk(oldVal, newVal, _element, item, index, _errorClass);
        postPumpDataDone(oldVal, newVal, _element, item, index, _errorClass, channel);
    };

    ctrl.checkIfValid = function (oldVal, newVal, item, index, e, regEx, channel) {
        //if input type is NUMBER, and number decimals are more than step specified in html, then it is going to return undefined.
        if (!newVal) {
            ctrl.pumpTabData[index].uiPumpCapacity = oldVal;
            return true;
        }
        var with2Decimals = newVal.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        if (newVal != with2Decimals) {
            ctrl.pumpTabData[index].uiPumpCapacity = oldVal;
            return true;
        }

        var _errorClass = getErrorClass();
        var _element = getElement(e);

        setLoadingInProgress(true);
        if (isValid(newVal, regEx)) {//if valid
            //ctrl.pumpTabOld[index].uiPumpCapacity = newVal;
        } else {
            // if not valid
            throwPumpError(_element, item, index, _errorClass);
            return;
        }
        //reset pump status and error messages etc
        prePostPump();

        $('.tooltip-error-message').hide(100);
        $(_element).removeClass(_errorClass);
        setLoadingInProgress(false);
    };

    ctrl.refreshPumpData = function (item, index) {
        var _errorClass = "val-error";
        ctrl.pumpTabData[index][item] = ctrl.pumpTabOld[index][item];
        //following code is workaround to handle metric pumpCapacity
        if (item == 'pumpCapacity' && ctrl.accountInfo.preferenceUser.lookupMeasurementID == 2) {
            ctrl.pumpTabData[index].uiPumpCapacity = ctrl.pumpTabOld[index].uiPumpCapacity;
        }
        $(".tooltip-error-message").hide(100);
        $(ctrl.targetField).removeClass(_errorClass);
        prePostPump();
        setLoadingInProgress(false);
    };

    ctrl.togglePumpVarianceAlert = function (pumpNumber, alertState) {
        pumpSettingService.togglePumpVarianceAlert(ctrl.selectedDevice.deviceId, pumpNumber, alertState, ctrl.accountInfo.customerId).then(function (result) {
            //console.log(result);
        });
    };

    ctrl.removeLeadingZeros = function (event) {
        var number = event.target.value;
        event.target.value = number.replace(/^0+/, '');
    };

    // scope functions -- End

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormatTimePicker = false;
        $timeout(function () {
            ctrl.timeFormatTimePicker = getTimeFormat(timeFormat);
        }, 1000);
    });
}
PumpsTabController.$inject = ['$rootScope', '$scope', '$timeout', '$element', 'sharedSetupService', 'pumpSettingService', 'authenticationService', 'translationService'];
'use strict';

mcapp.component('pumpsTabComponent', {
    controller: PumpsTabController,
    templateUrl: 'ui/rtuinfo/pumps-tab-template.html',
    bindings: {
        stickyProperties: '<',
        //windowId: '<',
        mobile: '<',
        //windowTitle: '<',
        //classicView: '<',
        isAdmin: '<',
        isChromeOrFirefox: '<',
        modelId: '<'
    }
});
'use strict';

var PumpSettingService = function PumpSettingService($http, HOST) {
    var pumpSettingFactory = {};

    var _getData = function _getData(customerId, timeZone, deviceId, optionBoard) {
        return $http({
            method: 'Get',
            url: HOST + '/api/PumpSetting?customerId=' + customerId + "&timeZone=" + timeZone + '&deviceId=' + deviceId,
            cache: false
        });
    };

    var _patchPumpSetting = function _patchPumpSetting(customerId, deviceId, channel, timeZone, pumpSettingPatch) {
        return $http.patch(HOST + "/api/pumpSetting?customerId=" + customerId + "&deviceId=" + deviceId + "&channel=" + channel + "&timeZone=" + timeZone, pumpSettingPatch);
    };

    var _togglePumpVarianceAlert = function _togglePumpVarianceAlert(deviceId, pumpNumber, alertState, customerId) {
        return $http.post(HOST + "/api/PumpSetting/TogglePumpVarianceAlert?deviceId=" + deviceId + "&pumpNumber=" + pumpNumber + "&alertState=" + alertState + "&customerId=" + customerId);
    };

    var _getPumpVarianceAlert = function _getPumpVarianceAlert(deviceId) {
        return $http.get(HOST + "/api/PumpSetting/GetPumpVarianceAlert?deviceId=" + deviceId);
    };

    var _postUserActionPumpsSetting2Nlog = function _postUserActionPumpsSetting2Nlog(customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Pumps";
        return $http({
            method: 'POST',
            url: HOST + '/api/PumpSetting',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    pumpSettingFactory.getData = _getData;
    pumpSettingFactory.patchPumpSetting = _patchPumpSetting;
    pumpSettingFactory.togglePumpVarianceAlert = _togglePumpVarianceAlert;
    pumpSettingFactory.getPumpVarianceAlert = _getPumpVarianceAlert;
    pumpSettingFactory.postUserActionPumpsSetting2Nlog = _postUserActionPumpsSetting2Nlog;
    return pumpSettingFactory;
};

PumpSettingService.$inject = ['$http', 'HOST'];
mcapp.factory('pumpSettingService', PumpSettingService);
mcapp.directive('optionBoardTab', ['$timeout', function ($timeout) {
    return function (scope, element, attrs) {
        $timeout(function () {
            switch (scope.typeId) {
                case 2:
                case 4:
                    scope.accordionActive = 0;
                    break;
                case 3:
                    scope.accordionActive = 1;
                    break;
                default:
                    scope.accordionActive = 2;
                    break;
            }
            element.accordion({
                heightStyle: "content",
                collapsible: true,
                active: scope.accordionActive,
                activate: function (event, ui) {
                    scope.accordionActive = $(this).accordion("option", "active");
                }
            });
        }, 0);
     };
}]);
mcapp.directive('pulseTab', ['$rootScope', '$timeout', 'toaster', 'sharedSetupService', 'pulseSettingService', 'cumulativeFlowService', '$filter', 'authenticationService', function ($rootScope, $timeout, toaster, sharedSetupService, pulseSettingService, cumulativeFlowService, $filter, authenticationService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        //scope.setLoadingDataModal(true);
        scope.accountInfo = authenticationService.getAccountInfo();
        if (scope.accountInfo.userRole == 'Administrator' || scope.accountInfo.userRole == 'SuperAdministrator') {
            scope.isAdmin = true;
        } else {
            scope.isAdmin = false;
        }
        scope.pulseTabData = [];
        scope.pulseConfig = [];
        scope.pulseConfigFields = ["channelName", "unit", "flowScale", "snapshotLocalDateTime", "snapshotReading"];
        scope.optionBoard = attrs.optionBoard ? true : false;
        scope.unitOfValueList = [
            { id: -1, name: 'None' },
            { id: 4, name: 'Inches' },
            { id: 23, name: 'Centimeters'},
            { id: 6, name: 'mm' },
            { id: 3, name: 'Feet' }
        ];

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {

                //Changing Device, back to "Basic Info" tab
                if (!angular.isUndefined(scope.currentDevice)) return;

                scope.currentDevice = newValue;
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                scope.getPulseSetting(newValue);
            }
        }, true);

        scope.getPulseSetting = function (varDeviceId) {
            if (scope.accountInfo === null || !varDeviceId)
                return;
            pulseSettingService.getData(scope.accountInfo.customerId, varDeviceId, scope.deviceSelectedType, scope.accountInfo.timeZone)
            .then(function (dataFromFactory) {
                scope.setLoadingInProgress(true);
                for (var i = 0; i < dataFromFactory.data.length; i++) {
                    scope.pulseConfig.push({
                        "channelName": { "statusMessage": "", "regEx": /^.{1,50}$/, "validationRequirement": scope.translation.text.DESCRIPTION_ERR, "status": scope.resetIndicator, "disabled": false },
                        "unit": { "statusMessage": "", "regEx": /^.{1,50}$/, "validationRequirement": scope.translation.text.UNIT_ERR, "status": scope.resetIndicator, "disabled": false },
                        "flowScale": { "statusMessage": "", "regEx": /^[0-9]+(\.[0-9]+)?$/, "validationRequirement": scope.translation.text.FLOWSCALE_ERR, "status": scope.resetIndicator, "disabled": false },
                        "snapshotLocalDateTime": { "statusMessage": "", "regEx": "", "validationRequirement": scope.translation.text.DATE_READ_ERR, "status": scope.resetIndicator, "disabled": false },
                        "snapshotReading": { "statusMessage": "", "regEx": /^[0-9]+(\.[0-9]+)?$/, "validationRequirement": scope.translation.text.READING_ERR, "status": scope.resetIndicator, "disabled": false },
                        "digitMeter": { "statusMessage": "", "regEx": '', "validationRequirement": scope.translation.text.DESCRIPTION_ERR, "status": scope.resetIndicator, "disabled": false },
                        "unitOfValueID": { "statusMessage": "", "regEx": /^-?[0-9]\d*(\.\d+)?$/, "validationRequirement": scope.translation.text.UNIT_ERR, "status": scope.resetIndicator, "disabled": false },
                    });

                    //dataFromFactory[i].snapshotLocalDateTime = dataFromFactory[i].snapshotLocalDateTime.replace("T", " "); //2016-05-03T16:53:00
                    //dataFromFactory[i].snapshotReading = $filter('number')(dataFromFactory[i].snapshotReading, 2);
                }

                scope.pulseTabData = dataFromFactory.data;

                scope.pulseTabOld = angular.copy(scope.pulseTabData);
            }, function (error) {
                //error
            }).then(function (data) {
                scope.setLoadingInProgress(false);
            });
        };

        scope.postPulseData = function (oldVal, newVal, item, index, e, regEx, channel) {
            if (String(newVal)[0] == '.' && String(newVal).length > 1) newVal = parseFloat(newVal);
            scope.prePostPulse();
            var _errorClass = "val-error";
            var _element = typeof e !== "undefined" ? e.target : scope.targetField;
            if (typeof oldVal == "undefined" || oldVal === newVal || (!isNaN(oldVal) && oldVal == newVal)) {
                $('.tooltip-error-message').hide(100);
                $(_element).removeClass(_errorClass);
                scope.pulseConfig[index][item].status = scope.resetIndicator;
                scope.pulseConfig[index][item].statusMessage = "";
                scope.setLoadingInProgress(false);
                return;
            }

            //scope.setLoadingInProgress(true);

            if (!scope.isValid(newVal, regEx)) {
                scope.throwPulseError(_element, item, index, _errorClass);
                return;
            }
            
            scope.validationPulseOk(oldVal, newVal, _element, item, index, _errorClass);
            scope.postPulseDataDone(oldVal, newVal, _element, item, index, _errorClass, channel);          
        };

        scope.checkIfValid = function (oldVal, newVal, item, index, e, regEx, channel) {
            if (String(newVal)[0] == '.' && String(newVal).length > 1) newVal = parseFloat(newVal);
            var _errorClass = scope.getErrorClass();
            var _element = scope.getElement();

            scope.setLoadingInProgress(true);
            if (!scope.isValid(newVal, regEx)) {
                scope.throwPulseError(_element, item, index, _errorClass);
                return;
            }

            scope.prePostPulse();

            $('.tooltip-error-message').hide(100);
            $(_element).removeClass(_errorClass);
            scope.setLoadingInProgress(false);
        };

        scope.prePostPulse = function () {
            for (var i = 0; i < scope.pulseTabData.length; i++) {
                for (var j = 0; j < scope.pulseConfigFields.length; j++) {
                    scope.pulseConfig[i][scope.pulseConfigFields[j]].disabled = false;
                    scope.pulseConfig[i][scope.pulseConfigFields[j]].status = scope.resetIndicator;
                    scope.pulseConfig[i][scope.pulseConfigFields[j]].statusMessage = "";
                }
            }
            return true;
        };

        scope.validationPulseOk = function (oldVal, newVal, _element, item, index, _errorClass) {
            scope.pulseTabOld[index][item] = newVal;
            $(_element).removeClass(_errorClass);
            for (var i = 0; i < scope.pulseTabData.length; i++) {
                for (var j = 0; j < scope.pulseConfigFields.length; j++) {
                    if (i == index && scope.pulseConfigFields[j] == item) {
                        scope.pulseConfig[i][scope.pulseConfigFields[j]].status = scope.spinner;
                        scope.pulseConfig[i][scope.pulseConfigFields[j]].statusMessage = "";
                    }
                    else {
                        scope.pulseConfig[i][scope.pulseConfigFields[j]].status = scope.resetIndicator;
                    }
                    scope.pulseConfig[i][scope.pulseConfigFields[j]].disabled = false;
                }
            }
        };

        scope.throwPulseError = function (_element, item, index, _errorClass, serverCheck) {
            $(_element).addClass(_errorClass);
            for (var i = 0; i < scope.pulseTabData.length; i++) {
                for (var j = 0; j < scope.pulseConfigFields.length; j++) {
                    if (i == index && scope.pulseConfigFields[j] == item) {
                        scope.pulseConfig[i][item].status = scope.errorCheck;
                        scope.pulseConfig[i][item].disabled = false;
                        scope.pulseConfig[i][item].statusMessage = scope.pulseConfig[i][item].validationRequirement;
                    }
                    else {
                        scope.pulseConfig[i][scope.pulseConfigFields[j]].status = scope.resetIndicator;
                        scope.pulseConfig[i][scope.pulseConfigFields[j]].disabled = true;
                    }
                }
            }
            $(_element).focus();
            $(_element).parent().find(".tooltip-error-message." + item + index).show(100);
        };

        scope.postPulseOk = function (oldVal, newVal, _element, item, index, _errorClass) {
            scope.pulseTabOld[index][item] = newVal;
            scope.pulseTabData[index][item] = newVal;
            $(_element).removeClass(_errorClass);
            scope.pulseConfig[index][item].status = scope.okCheck;
            scope.pulseConfig[index][item].statusMessage = "";
        };

        scope.postPulseDataDone = function (oldVal, newVal, _element, item, index, _errorClass, channel) {
            if (item == "snapshotReading" || item == "snapshotLocalDateTime") {
                var _cumulativeFlow = { "deviceId": scope.deviceSelected, "channel": channel, "snapshotLocalDateTime": (scope.pulseTabData[index].snapshotLocalDateTime + "").substring(0, 21), "snapshotReading": scope.pulseTabData[index].snapshotReading };
                cumulativeFlowService.postData(scope.accountInfo.customerId, scope.deviceSelected, scope.accountInfo.timeZone, _cumulativeFlow)
                .then(function (result) {
                    scope.setLoadingInProgress(false);
                    $('.tooltip-error-message').hide(100); //.remove();
                    scope.postPulseOk(oldVal, newVal, _element, item, index, _errorClass);
                }, function (error) {
                    // error
                    // log error or return JS
                }).then(function (data) {
                    return;
                });
                return;
            }
            var tmpPulseData = { "op": "replace", "path": item, "value": newVal };
            pulseSettingService.patchPulseSetting(scope.accountInfo.customerId, scope.deviceSelected,scope.deviceSelectedType, channel, tmpPulseData)
            .then(function (result) {
                scope.setLoadingInProgress(false);
                $('.tooltip-error-message').hide(100); //.remove();
                scope.postPulseOk(oldVal, newVal, _element, item, index, _errorClass);
                var _dataChanged = "channelName, unit, flowScale";
                if (_dataChanged.indexOf(item) > -1) {
                    var _device = { deviceId: scope.deviceSelected, channel: channel, fieldName: item, newSetting: result.data };
                    $rootScope.$broadcast('rtuPulseUpdate', _device);
                }
            }, function (error) {
                // error
                // log error or return JS
            });
        };

        scope.setPulseSettingsToDefault = function (channel, index, e) {
            pulseSettingService.putPulseSettingsToDefault(scope.accountInfo.customerId, scope.deviceSelected, channel,scope.deviceSelectedType)
            .then(function (result) {
                scope.pulseTabData[index].channelName = result.data.channelName;
                scope.pulseTabData[index].flowScale = result.data.flowScale;
                scope.pulseTabData[index].unit = result.data.unit;
                scope.pulseTabData[index].unitOfValueID = result.data.unitOfValueID;
                var _element = typeof e !== "undefined" ? e.target : scope.targetField;
                var _errorClass = "val-error";
                scope.postPulseOk(scope.pulseTabOld[index].channelName, scope.pulseTabData[index].channelName, _element, 'channelName', index, _errorClass);
                scope.postPulseOk(scope.pulseTabOld[index].flowScale, scope.pulseTabData[index].flowScale, _element, 'flowScale', index, _errorClass);
                scope.postPulseOk(scope.pulseTabOld[index].unit, scope.pulseTabData[index].unit, _element, 'unit', index, _errorClass);

                var _device = { deviceId: scope.deviceSelected, channel: channel, fieldName: 'channelName', newSetting: [{ channel: channel, channelName: scope.pulseTabData[index].channelName, unit: scope.pulseTabData[index].unit, flowScale: scope.pulseTabData[index].flowScale }] };
                $rootScope.$broadcast('rtuPulseUpdate', _device);
            }, function (error) {
                console.log(error);
            });
        };

        scope.refreshPulseData = function (item, index) {
            var _errorClass = "val-error";
            scope.pulseTabData[index][item] = scope.pulseTabOld[index][item];
            $(".tooltip-error-message").hide(100);
            $(scope.targetField).removeClass(_errorClass);
            scope.prePostPulse();
            scope.setLoadingInProgress(false);
        };

        scope.getTimeFormat = function(timeFormat) { return (timeFormat == 1) ? "h:mm a" : "H:mm"; };
        scope.timeFormatTimePicker = scope.getTimeFormat(scope.accountInfo.preferenceUser.timeFormat);
        scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            scope.timeFormatTimePicker = false;
            $timeout(function () { scope.timeFormatTimePicker = scope.getTimeFormat(timeFormat); }, 1000);
        });
    };
}]);

mcapp.factory('pulseSettingService', ['$http', 'HOST', function ($http, HOST) {
    var pulseSettingFactory = {};

    var _getData = function (customerId, deviceId, deviceType, timeZone) {
        return $http({
            method: 'Get',
            url: HOST + '/api/OptionBoardPulse?customerId=' + customerId + '&deviceId=' + deviceId + '&deviceType=' + deviceType + '&timeZone=' + timeZone,
            cache: false
        });
    };

    var _patchPulseSetting = function (customerId, deviceId, deviceSelectedType, channel, pulseSettingPatch) {
        return $http.patch(HOST + "/api/PulseSetting?customerId=" + customerId +  "&deviceId=" + deviceId + '&deviceType=' + deviceSelectedType + "&channel=" + channel, pulseSettingPatch);
    };

    var _putPulseSettingsToDefault = function (customerId, deviceId, channel, deviceType) {
        return $http.put(HOST + "/api/PulseSetting?customerId=" + customerId +  "&deviceId=" + deviceId + "&channel=" + channel  + "&deviceType=" + deviceType);
    };

    pulseSettingFactory.getData = _getData;
    pulseSettingFactory.patchPulseSetting = _patchPulseSetting;
    pulseSettingFactory.putPulseSettingsToDefault = _putPulseSettingsToDefault;
    return pulseSettingFactory;
}]);

mcapp.factory('cumulativeFlowService', ['$http', 'HOST', function ($http, HOST) {
    var cumulativeFlowFactory = {};

    var _postData = function (customerId, deviceId, timeZone, cumulativeFlow) {
        return $http.post(HOST + '/api/CumulativeFlow?customerId=' + customerId + '&deviceId=' + deviceId + '&timeZone=' + timeZone, cumulativeFlow);
    };

    cumulativeFlowFactory.postData = _postData;
    return cumulativeFlowFactory;
}]);
'use strict';

mcapp.directive('analogOutputTab', ['$rootScope', '$timeout', 'toaster', 'sharedSetupService', 'analogOutputSettingService', function ($rootScope, $timeout, toaster, sharedSetupService, analogOutputSettingService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {

        scope.analogOutputTabData = [];
        scope.analogOutputConfig = [];
        scope.analogOutputConfigFields = ["channelName", "unit", "minimumValue", "maximumValue"];
        scope.unitOfValue = [];
        scope.setLoadingInProgress(true);
        scope.optionBoard = attrs.optionBoard ? true : false;

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {

                //Changing Device, back to "Basic Info" tab
                if (!angular.isUndefined(scope.currentDevice)) return;

                scope.currentDevice = newValue;
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                scope.getAnalogOutputSetting(newValue);
                scope.getUnitsList();
            }
        }, true);

        scope.getAnalogOutputSetting = function (varDeviceId) {
            if (scope.accountInfo === null || !varDeviceId) return;
            analogOutputSettingService.getData(scope.accountInfo.customerId, varDeviceId, scope.optionBoard, scope.deviceSelectedType).then(function (dataFromFactory) {
                for (var i = 0; i < dataFromFactory.data.length; i++) {
                    scope.analogOutputConfig.push({
                        "channelName": { "statusMessage": "", "regEx": /^.{1,50}$/, "validationRequirement": scope.translation.text.DESCRIPTION_ERR, "status": scope.resetIndicator, "disabled": false },
                        "unit": { "statusMessage": "", "regEx": /^.{1,50}$/, "validationRequirement": scope.translation.text.UNIT_ERR, "status": scope.resetIndicator, "disabled": false },
                        "minimumValue": { "statusMessage": "", "regEx": /^-?[0-9]\d*(\.\d+)?$/, "validationRequirement": scope.translation.text.MINIMUM_ERR, "status": scope.resetIndicator, "disabled": false },
                        "maximumValue": { "statusMessage": "", "regEx": /^-?[0-9]\d*(\.\d+)?$/, "validationRequirement": scope.translation.text.MAXIMUM_ERR, "status": scope.resetIndicator, "disabled": false }
                    });
                }
                scope.analogOutputTabData = dataFromFactory.data;
                scope.analogOutputTabOld = angular.copy(scope.analogOutputTabData);
                scope.setLoadingInProgress(false);
            }, function (error) {
                //error
                scope.setLoadingInProgress(false);
            });
        };

        scope.getUnitsList = function () {
            analogOutputSettingService.getUnitListData().then(function (dataFromFactory) {

                if (dataFromFactory.data.length === 0) {
                    scope.alerts.push({ msg: scope.translation.text.CONTACT_MISSION_SETUP, type: 'info', languageCode: 'CONTACT_MISSION_SETUP' });
                } else {
                    scope.unitOfValue = dataFromFactory.data;
                    var tmpUnitOfValueArr = [];
                    scope.unitOfValue.forEach(function (item) {
                        tmpUnitOfValueArr.push(item.unitOfValueDesc);
                    });

                    scope.analogOutputTabData.forEach(function (analogOutputData, i) {

                        var validUnit = tmpUnitOfValueArr.includes(analogOutputData.unit);

                        if (validUnit == false) {
                            analogOutputData.invalidUnit = true;
                        }
                    });
                }
            }, function (error) {
                //error
                console.log(error);
                scope.setLoadingInProgress(false);
            });
        };

        scope.postAnalogOutputData = function (oldVal, newVal, item, index, e, regEx, channel) {
            scope.prePostAnalogOutput();
            var _errorClass = "val-error";
            var _element = typeof e !== "undefined" ? e.target : scope.targetField;
            if (typeof oldVal == "undefined" || oldVal === newVal || !isNaN(oldVal) && oldVal == newVal) {
                $('.tooltip-error-message').hide(100);
                $(_element).removeClass(_errorClass);
                scope.analogOutputConfig[index][item].status = scope.resetIndicator;
                scope.analogOutputConfig[index][item].statusMessage = "";
                scope.setLoadingInProgress(false);
                return;
            }

            //scope.setLoadingInProgress(true);

            if (!scope.isValid(newVal, regEx)) {
                scope.throwAnalogOutputError(_element, item, index, _errorClass);
                return;
            }

            scope.validationAnalogOutputOk(oldVal, newVal, _element, item, index, _errorClass);
            scope.postAnalogOutputDataDone(oldVal, newVal, _element, item, index, _errorClass, channel);
        };

        scope.checkIfValid = function (oldVal, newVal, item, index, e, regEx, channel) {

            var _errorClass = scope.getErrorClass();
            var _element = scope.getElement();

            scope.setLoadingInProgress(true);
            if (!scope.isValid(newVal, regEx)) {
                scope.throwAnalogOutputError(_element, item, index, _errorClass);
                return;
            }

            scope.prePostAnalogOutput();

            $('.tooltip-error-message').hide(100);
            $(_element).removeClass(_errorClass);
            scope.setLoadingInProgress(false);
        };

        scope.prePostAnalogOutput = function () {
            for (var i = 0; i < scope.analogOutputTabData.length; i++) {
                for (var j = 0; j < scope.analogOutputConfigFields.length; j++) {
                    scope.analogOutputConfig[i][scope.analogOutputConfigFields[j]].disabled = false;
                    scope.analogOutputConfig[i][scope.analogOutputConfigFields[j]].status = scope.resetIndicator;
                    scope.analogOutputConfig[i][scope.analogOutputConfigFields[j]].statusMessage = "";
                }
            }
            return true;
        };

        scope.validationAnalogOutputOk = function (oldVal, newVal, _element, item, index, _errorClass) {
            scope.analogOutputTabOld[index][item] = newVal;
            $(_element).removeClass(_errorClass);
            for (var i = 0; i < scope.analogOutputTabData.length; i++) {
                for (var j = 0; j < scope.analogOutputConfigFields.length; j++) {
                    if (i == index && scope.analogOutputConfigFields[j] == item) {
                        scope.analogOutputConfig[i][scope.analogOutputConfigFields[j]].status = scope.spinner;
                        scope.analogOutputConfig[i][scope.analogOutputConfigFields[j]].statusMessage = "";
                    } else {
                        scope.analogOutputConfig[i][scope.analogOutputConfigFields[j]].status = scope.resetIndicator;
                    }
                    scope.analogOutputConfig[i][scope.analogOutputConfigFields[j]].disabled = false;
                }
            }
        };

        scope.throwAnalogOutputError = function (_element, item, index, _errorClass, serverCheck) {
            $(_element).addClass(_errorClass);
            for (var i = 0; i < scope.analogOutputTabData.length; i++) {
                for (var j = 0; j < scope.analogOutputConfigFields.length; j++) {
                    if (i == index && scope.analogOutputConfigFields[j] == item) {
                        scope.analogOutputConfig[i][item].status = scope.errorCheck;
                        scope.analogOutputConfig[i][item].disabled = false;
                        scope.analogOutputConfig[i][item].statusMessage = scope.analogOutputConfig[i][item].validationRequirement;
                    } else {
                        scope.analogOutputConfig[i][scope.analogOutputConfigFields[j]].status = scope.resetIndicator;
                        scope.analogOutputConfig[i][scope.analogOutputConfigFields[j]].disabled = true;
                    }
                }
            }
            $(_element).focus();
            $(_element).parent().find(".tooltip-error-message." + item + index).show(100);
        };

        scope.postAnalogOutputOk = function (oldVal, newVal, _element, item, index, _errorClass) {
            scope.analogOutputTabOld[index][item] = newVal;
            $(_element).removeClass(_errorClass);
            scope.analogOutputConfig[index][item].status = scope.okCheck;
            scope.analogOutputConfig[index][item].statusMessage = "";
        };

        scope.postAnalogOutputDataDone = function (oldVal, newVal, _element, item, index, _errorClass, channel) {
            var tmpAnalogOutputData = { "op": "replace", "path": item, "value": newVal };
            analogOutputSettingService.patchAnalogOutputSetting(scope.deviceSelected, channel, scope.deviceSelectedType, tmpAnalogOutputData).then(function (result) {
                scope.setLoadingInProgress(false);
                $('.tooltip-error-message').hide(100); //.remove();
                scope.postAnalogOutputOk(oldVal, newVal, _element, item, index, _errorClass);

                if (scope.unitOfValue.length > 0) {
                    var tmpUnitOfValueArr = [];
                    scope.unitOfValue.forEach(function (item) {
                        tmpUnitOfValueArr.push(item.unitOfValueDesc);
                    });
                    scope.analogOutputTabData.forEach(function (analogOutputData, i) {

                        var validUnit = tmpUnitOfValueArr.includes(analogOutputData.unit);

                        if (validUnit == false) {
                            analogOutputData.invalidUnit = true;
                        } else {
                            analogOutputData.invalidUnit = false;
                        }
                    });
                }

                var _dataChanged = "channelName, unit, minimumValue, maximumValue";
                if (_dataChanged.indexOf(item) > -1) {
                    var _device = { deviceId: scope.deviceSelected, channel: channel, fieldName: item, newSetting: result.data };
                    $rootScope.$broadcast('rtuAnalogOutputUpdate', _device);
                }
            }, function (error) {
                // error
                // JS should return error or use console log
            });
        };

        scope.refreshAnalogOutputData = function (item, index) {
            var _errorClass = "val-error";
            scope.analogOutputTabData[index][item] = scope.analogOutputTabOld[index][item];
            $(".tooltip-error-message").hide(100);
            $(scope.targetField).removeClass(_errorClass);
            scope.prePostAnalogOutput();
            scope.setLoadingInProgress(false);
        };

        //Log tab access event to NLog
        analogOutputSettingService.postUserActionOptionBoard2Nlog(scope.accountInfo.customerId, scope.deviceSelected).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });
    };
}]);

mcapp.factory('analogOutputSettingService', ['$http', 'HOST', function ($http, HOST) {
    var analogOutputSettingFactory = {};

    var _getData = function _getData(customerId, deviceId, optionBoard, deviceType) {
        return $http({
            method: 'Get',
            url: HOST + '/api/AnalogOutputSetting?customerId=' + customerId + '&deviceId=' + deviceId + '&deviceType=' + deviceType + '&optionBoard=' + optionBoard,
            cache: false
        });
    };

    var _getUnitListData = function _getUnitListData() {
        return $http({
            method: 'Get',
            url: HOST + '/api/Analog/Units',
            cache: false
        });
    };

    var _patchAnalogOutputSetting = function _patchAnalogOutputSetting(deviceId, channel, deviceType, analogOutputSettingPatch) {
        return $http.patch(HOST + "/api/AnalogOutputSetting?deviceId=" + deviceId + "&channel=" + channel + "&deviceType=" + deviceType, analogOutputSettingPatch);
    };

    var _postUserActionOptionBoard2Nlog = function _postUserActionOptionBoard2Nlog(customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Option Board";
        return $http({
            method: 'POST',
            url: HOST + '/api/AnalogOutputSetting',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };
    analogOutputSettingFactory.getData = _getData;
    analogOutputSettingFactory.getUnitListData = _getUnitListData;
    analogOutputSettingFactory.patchAnalogOutputSetting = _patchAnalogOutputSetting;
    analogOutputSettingFactory.postUserActionOptionBoard2Nlog = _postUserActionOptionBoard2Nlog;
    return analogOutputSettingFactory;
}]);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

mcapp.directive('digitalTab', ['$timeout', 'toaster', 'sharedSetupService', 'digitalSettingService', '$rootScope', '$cookies', 'commandOptionsService', 'pageRequestsService', 'websocketService', function ($timeout, toaster, sharedSetupService, digitalSettingService, $rootScope, $cookies, commandOptionsService, pageRequestsService, websocketService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        scope.optionBoard = attrs.optionBoard === "true" ? true : null;
        scope.digitalTabData = [];
        scope.digitalConfig = [];
        scope.digitalConfigFields = ["description", "digitalMode", "normalClosed"];
        scope.listOfWidgets = [];
        scope.setLoadingInProgress(true);
        scope.optionBoard = attrs.optionBoard ? true : false;
        scope.alerts = [];
        scope.popoverHeaderTitle = '';
        scope.liveData = false;

        scope.toggleIVR = function (channel, ivrPumpState) {
            digitalSettingService.updateIVRPumpState(scope.deviceSelected, channel, scope.accountInfo.customerId, scope.accountInfo.userName, scope.deviceSelectedName, scope.deviceSerialNumber, ivrPumpState, $rootScope.uniqueWebID);
            this.getDigitalSetting(scope.deviceSelected);
        };

        //Update SsoCso to false if device is not in alarm digital mode
        scope.ssoCsoCheck = function (item, newVal, channel) {
            if (item == "digitalMode" && newVal.name != "Alarm") {
                //Set value false in UI
                scope.digitalTabData.map(function (item) {
                    item.ssoCso = item.channel == channel ? false : item.ssoCso;
                });
                //Set value false in DB
                var newTmpDigitalData = { op: "replace", path: "ssoCso", value: false };
                digitalSettingService.patchDigitalSetting(scope.deviceSelected, channel, scope.accountInfo.customerId, newTmpDigitalData, $rootScope.uniqueWebID, encodeURIComponent(scope.deviceSelectedName), scope.deviceSerialNumber, scope.deviceSelectedType);
            }
        };

        //Update exclude from runtime report to false if device is not in runtime mode
        scope.excludeRuntimeReportsCheck = function (item, newVal, channel) {
            if (item == "digitalMode" && newVal.name != "Runtime") {
                //Set value false in UI
                scope.digitalTabData.map(function (item) {
                    item.excludeRuntimeReports = item.channel == channel ? false : item.excludeRuntimeReports;
                });
                //Set value false in DB
                var newTmpDigitalData = { op: "replace", path: "excludeRuntimeReports", value: false };
                digitalSettingService.patchDigitalSetting(scope.deviceSelected, channel, scope.accountInfo.customerId, newTmpDigitalData, $rootScope.uniqueWebID, encodeURIComponent(scope.deviceSelectedName), scope.deviceSerialNumber, scope.deviceSelectedType);
            }
        };

        var digitalMode = [];
        var alarmType = [];
        var digitalModeFiltered = [];
        var statusActAsAlarmOption = [];

        var _setPumpModeOptions = function _setPumpModeOptions() {
            digitalMode = [{
                "id": "A",
                "name": scope.translation.text.ALARM
            }, {
                "id": "D",
                "name": scope.translation.text.DISABLED
            }, {
                "id": "P",
                "name": scope.translation.text.PUMP_RUNTIME
            }, {
                "id": "S",
                "name": scope.translation.text.STATUS
            }];

            digitalModeFiltered = [{
                "id": "A",
                "name": scope.translation.text.ALARM
            }, {
                "id": "D",
                "name": scope.translation.text.DISABLED
            }, {
                "id": "S",
                "name": scope.translation.text.STATUS
            }];

            alarmType = [{
                "id": 0,
                "name": scope.translation.text.ALARM_ON_CLOSE
            }, {
                "id": 1,
                "name": scope.translation.text.ALARM_ON_OPEN
            }, {
                "id": 2,
                "name": scope.translation.text.NO_ALARM
            }];

            statusActAsAlarmOption = [{
                "id": 0,
                "name": scope.translation.text.NORMAL
            }, {
                "id": 1,
                "name": scope.translation.text.ACT_AS_ALARM
            }];
            scope.rtuDigitalMode = digitalMode;
            scope.rtuDigitalModeFiltered = digitalModeFiltered;
            scope.pumpAlarmOption = alarmType;
            scope.statusActAsAlarmOption = statusActAsAlarmOption;
        };

        _setPumpModeOptions();

        scope.isMcAdmin = $cookies.get('AdminInfo') != null ? true : false;

        if (scope.optionBoard) scope.rtuDigitalMode.splice(2, 1); //REMOVE id: "P"

        scope.dynamicPopover = {
            templateUrl: 'myPopoverTemplateB.html'
        };

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {

                //Changing Device, back to "Basic Info" tab
                if (!angular.isUndefined(scope.currentDevice)) return;

                scope.currentDevice = newValue;
                scope.liveData = false;
                if (oldValue && newValue !== oldValue) {
                    if (!angular.isUndefined(scope.pagingInputsTimer) && scope.pagingFinished != 1) {
                        scope.pagingFinished = 1;
                        $timeout.cancel(scope.pagingInputsTimer);
                        scope.pagingInputMode(oldValue);
                    }
                }

                scope.showAlarmType = [8, 9, 18, 19].indexOf(scope.deviceSelectedType) > -1 ? true : false;
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                scope.getDigitalSetting(newValue);

                for (var index = 0; index < scope.devices.length; ++index) {
                    if (scope.devices[index].deviceId == scope.deviceSelected) {
                        scope.deviceType = scope.devices[index].type;
                        scope.protocolVersion = scope.devices[index].protocolVersion;
                        break;
                    }
                }

                //Get paging commands
                commandOptionsService.getData(scope.accountInfo.customerId, newValue).then(function (dataFromFactory) {
                    scope.commandOptions = dataFromFactory.data;
                    scope.commandOptionsInputMode = scope.commandOptions.filter(function (el) {
                        return el.commandGroupId == 3;
                    });
                    //Get input modes  
                    for (var i = 0; i < scope.digitalTabData.length; i++) {
                        switch (scope.digitalTabData[i].digitalMode.id) {
                            case "A":
                                scope["mode" + (i + 1) + "SelectedOption"] = { id: "A", desc: "A" };
                                break;
                            case "D":
                                scope["mode" + (i + 1) + "SelectedOption"] = { id: "D", desc: "D" };
                                break;
                            case "P":
                                scope["mode" + (i + 1) + "SelectedOption"] = { id: "R", desc: "R" };
                                break;
                            case "S":
                                scope["mode" + (i + 1) + "SelectedOption"] = { id: "S", desc: "S" };
                        }
                    }
                }, function (error) {});
            }
        }, true);

        scope.$on('updatePreferencesLanguage', function () {
            _setPumpModeOptions();
        });

        scope.getWidgetDescription = function (widgetId) {
            console.log("Widget Id", widgetId);
            switch (widgetId) {
                case 1:
                    return "Alarm";
                case 2:
                    return "Disabled";
                case 3:
                    return "Submersible Pump - waste water";
                case 4:
                    return "Submersible pump - waste water";
                case 5:
                    return "Status";
                case 6:
                    return "In line / Vane pump";
                case 7:
                    return "Centrifugal Pump - Water or Waste water";
                case 8:
                    return "In line Pump";
                case 9:
                    return "Lobe Pump";
                default:
                    return "Pump";
            }
        };
        scope.getDigitalSetting = function (varDeviceId) {
            if (scope.accountInfo === null || varDeviceId === null) return;
            digitalSettingService.getData(scope.accountInfo.customerId, varDeviceId, scope.deviceSelectedType, scope.optionBoard).then(function (dataFromFactory) {
                if (dataFromFactory.data.length === 0) {
                    scope.alerts.push({ msg: scope.translation.text.CONTACT_MISSION_SETUP, type: 'info', languageCode: 'CONTACT_MISSION_SETUP' });
                } else {
                    for (var l = 0; l < dataFromFactory.data.length; l++) {
                        scope._registerListener(dataFromFactory.data[l].channel);
                    }
                    scope.liveData = true;
                }
                scope.digitalTabData = buildDigitalObject(dataFromFactory.data);
                scope.digitalTabOld = angular.copy(scope.digitalTabData);
                scope.setLoadingInProgress(false);
            }, function (error) {
                //error
                scope.setLoadingInProgress(false);
            });
        };

        scope.changeInputMode = function (id, obj) {
            switch (obj.id) {
                case "S":
                case "A":
                    scope["mode" + id + "SelectedOption"] = { id: "A", desc: "A" };
                    break;
                case "D":
                    scope["mode" + id + "SelectedOption"] = { id: "D", desc: "D" };
                    break;
                case "P":
                    scope["mode" + id + "SelectedOption"] = { id: "R", desc: "R" };
                    break;
            }
            //scope["mode" + id + "SelectedOption"] = angular.copy(obj);
        };

        scope.getCommandDetails = function () {
            return {
                channel: null, value: null, valueDetail: scope.mode1SelectedOption.id + scope.mode2SelectedOption.id + scope.mode3SelectedOption.id + scope.mode4SelectedOption.id + scope.mode5SelectedOption.id + scope.mode6SelectedOption.id + scope.mode7SelectedOption.id + scope.mode8SelectedOption.id
            };
        };

        scope.pagingInputMode = function (deviceId) {
            scope.selectedElectricModes = [];
            var _tmpCommandDescription = scope.commandOptionsInputMode[0].commandDescription;
            var _tmpCommandDetails = scope.getCommandDetails();
            scope.tmpPageRequest = {
                deviceId: deviceId || scope.deviceSelected, commandDescription: _tmpCommandDescription, commandDetails: _tmpCommandDetails, electricModes: scope.selectedElectricModes
            };
            pageRequestsService.postData(scope.accountInfo.customerId, scope.commandOptionsInputMode[0].commandId, scope.deviceType, scope.protocolVersion, scope.accountInfo.timeZone, scope.tmpPageRequest).then(function (data) {
                scope.pagingFinished = 1;
                //if paging command is deferred                    
                if (data.data.item2 == 2) {
                    var message = scope.translation.text.PAGE_IS_DEFERRED_UNTIL_DEVICE_IS_ONLINE + ' ' + scope.deviceSelectedName + ' ' + 'as device is currently offline. This command will be queued for 3 days.';
                    if (scope.tabClosed) {
                        toaster.pop('error', 'Digital setting deferred', message, 30000, 'trustedHtml');
                        scope.tabClosed = false;
                    } else {
                        scope.pagingInfo = message;
                        scope.setTimeOutForPagingInfo();
                    }
                }
            });
        };

        scope.setUpTimer = function () {
            scope.pagingInputsTimer = $timeout(function () {
                scope.pagingInputMode();
            }, 15000);
        };

        scope.$on('$destroy', function () {
            if (!angular.isUndefined(scope.pagingInputsTimer) && scope.pagingFinished != 1) {
                $timeout.cancel(scope.pagingInputsTimer);
                scope.tabClosed = true;
                scope.pagingInputMode();
            }

            for (var k = 0; k < scope.digitalTabData.length; k++) {
                websocketService.unRegister("DIGITALSETTING", scope.deviceSerialNumber, scope.digitalTabData[k].channel, scope.wsDataReceivedDIGITALSETTING, scope.wsReconnectDIGITALSETTING);
            }
        });

        scope.postDigitalData = function (oldVal, newVal, item, index, e, regEx, channel) {
            if (item == "statusInputAsAlarm") {
                if (oldVal.id == 0) {
                    oldVal = false;
                } else {
                    oldVal = true;
                }
                if (newVal.id == 0) {
                    newVal = false;
                } else {
                    newVal = true;
                }
                scope["mode" + channel + "SelectedOption"] = { id: "A", desc: "A" };
            }

            scope.prePostDigital();
            //prepare paging copmmand detail
            scope.changeInputMode(channel, newVal);
            //clear previous timer for paging
            if (!angular.isUndefined(scope.pagingInputsTimer)) $timeout.cancel(scope.pagingInputsTimer);
            //set up timer for paging            
            scope.setUpTimer();
            //set up flag for paging finished
            scope.pagingFinished = 0;

            var _errorClass = "val-error";
            var _element = typeof e !== "undefined" ? e.target : scope.targetField;
            if (typeof oldVal == "undefined" || oldVal == newVal) {
                $('.tooltip-error-message').hide(100);
                $(_element).removeClass(_errorClass);
                scope.digitalConfig[index][item].status = scope.resetIndicator;
                scope.digitalConfig[index][item].statusMessage = "";
                scope.setLoadingInProgress(false);
                return;
            }

            //scope.setLoadingInProgress(true);

            if (!scope.isValid(newVal, regEx)) {
                scope.throwDigitalError(_element, item, index, _errorClass);
                return;
            }

            scope.validationDigitalOk(oldVal, newVal, _element, item, index, _errorClass);
            scope.postDigitalDataDone(oldVal, newVal, _element, item, index, _errorClass, channel);
        };

        scope.checkIfValid = function (oldVal, newVal, item, index, e, regEx, channel) {

            var _errorClass = scope.getErrorClass();
            var _element = scope.getElement();

            scope.setLoadingInProgress(true);
            if (!scope.isValid(newVal, regEx)) {
                scope.throwDigitalError(_element, item, index, _errorClass);
                return;
            }

            scope.prePostDigital();

            $('.tooltip-error-message').hide(100);
            $(_element).removeClass(_errorClass);
            scope.setLoadingInProgress(false);
        };

        scope.prePostDigital = function () {
            for (var i = 0; i < scope.digitalTabData.length; i++) {
                for (var j = 0; j < scope.digitalConfigFields.length; j++) {
                    scope.digitalConfig[i][scope.digitalConfigFields[j]].disabled = false;
                    scope.digitalConfig[i][scope.digitalConfigFields[j]].status = scope.resetIndicator;
                    scope.digitalConfig[i][scope.digitalConfigFields[j]].statusMessage = "";
                }
            }
            return true;
        };

        scope.validationDigitalOk = function (oldVal, newVal, _element, item, index, _errorClass) {
            scope.digitalTabOld[index][item] = newVal;
            $(_element).removeClass(_errorClass);
            for (var i = 0; i < scope.digitalTabData.length; i++) {
                for (var j = 0; j < scope.digitalConfigFields.length; j++) {
                    if (i == index && scope.digitalConfigFields[j] == item) {
                        scope.digitalConfig[i][scope.digitalConfigFields[j]].status = scope.spinner;
                        scope.digitalConfig[i][scope.digitalConfigFields[j]].statusMessage = "";
                    } else {
                        scope.digitalConfig[i][scope.digitalConfigFields[j]].status = scope.resetIndicator;
                    }
                    scope.digitalConfig[i][scope.digitalConfigFields[j]].disabled = false;
                }
            }
        };

        scope.throwDigitalError = function (_element, item, index, _errorClass, serverCheck) {
            $(_element).addClass(_errorClass);
            for (var i = 0; i < scope.digitalTabData.length; i++) {
                for (var j = 0; j < scope.digitalConfigFields.length; j++) {
                    if (i == index && scope.digitalConfigFields[j] == item) {
                        scope.digitalConfig[i][item].status = scope.errorCheck;
                        scope.digitalConfig[i][item].disabled = false;
                        scope.digitalConfig[i][item].statusMessage = scope.digitalConfig[i][item].validationRequirement;
                    } else {
                        scope.digitalConfig[i][scope.digitalConfigFields[j]].status = scope.resetIndicator;
                        scope.digitalConfig[i][scope.digitalConfigFields[j]].disabled = true;
                    }
                }
            }
            $(_element).focus();
            $(_element).parent().find(".tooltip-error-message." + item + index).show(100);
        };

        scope.postDigitalOk = function (oldVal, newVal, _element, item, index, _errorClass) {
            scope.digitalTabOld[index][item] = newVal;
            $(_element).removeClass(_errorClass);
            scope.digitalConfig[index][item].status = scope.okCheck;
            scope.digitalConfig[index][item].statusMessage = "";
        };

        scope.getWidgetLibrary = function (widgetTypeCharId) {

            if (!scope.isAdmin) return false;

            var tmpWidgetTypeCharId = widgetTypeCharId;

            switch (widgetTypeCharId) {
                case "P":
                    scope.dynamicPopover = {
                        templateUrl: 'myPopoverTemplateA.html'
                    };
                    tmpWidgetTypeCharId = "P,G,V";
                    break;

                case "S":
                case "A":
                case "D":
                    scope.dynamicPopover = {
                        templateUrl: 'myPopoverTemplateB.html'
                    };
                    tmpWidgetTypeCharId = "S";
                    break;
                default:
                    scope.dynamicPopover = {
                        templateUrl: 'myPopoverTemplateB.html'
                    };
                    break;
            }

            setPopupTitle(widgetTypeCharId);
            scope.listOfWidgets = [];
            digitalSettingService.getWidgetLibraryList(tmpWidgetTypeCharId).then(function (result) {
                scope.listOfWidgets = result.data.filter(function (item) {
                    item.description = item.name.replace(" Pump", "");
                    return item;
                });
            }, function (error) {
                // error
                // log error or return JS
            });
        };

        scope.updateWidgetLibrary = function (widgetId, channel) {
            var currentWidgetId = widgetId;
            var tmpDigitalData = { "op": "replace", "path": "widgetId", "value": widgetId };

            digitalSettingService.patchDigitalSetting(scope.deviceSelected, channel, scope.accountInfo.customerId, tmpDigitalData, $rootScope.uniqueWebID, encodeURIComponent(scope.deviceSelectedName), scope.deviceSerialNumber, scope.deviceSelectedType).then(function (result) {
                scope.setLoadingInProgress(false);
                scope.digitalTabData = buildDigitalObject(result.data);
                var brdMsg = {};
                for (var i = 0; i < result.data.length; i++) {
                    if (result.data[i].channel == channel) {
                        brdMsg = { deviceId: result.data[i].deviceId, channel: channel, image: result.data[i].image, digitalMode: result.data[i].digitalMode, normalClosed: result.data[i].normalClosed };
                        break;
                    };
                }
                $rootScope.$broadcast('updateDigitalWidgetImage', brdMsg);
            }, function (error) {
                // error
                // log error or return JS
            });
        };

        scope.postPumpAlarmOption = function (channel, alarmType) {
            var oldAlarmType = scope.digitalTabOld.find(function (x) {
                return x.channel == channel;
            }).alarmType.id;
            digitalSettingService.postPumpAlarmOption(scope.deviceSelected, channel, alarmType.id, scope.deviceSelectedName, scope.deviceSerialNumber, $rootScope.uniqueWebID, oldAlarmType).then(function (result) {
                scope.setLoadingInProgress(false);
                $('.tooltip-error-message').hide(100); //.remove();
                scope.digitalTabData = buildDigitalObject(result.data);
                scope.digitalTabOld = angular.copy(scope.digitalTabData);
                //scope.postDigitalOk(oldVal, newVal, _element, item, index, _errorClass);
                var brdMsg = { deviceId: scope.deviceSelected, channel: channel };
                $rootScope.$broadcast('updateDigitalSetting', brdMsg);
            }, function (error) {
                // error
                // log error or return JS
            });
        };

        scope.setToDefault = function (deviceId, channel) {
            digitalSettingService.setDescriptionToDefault(deviceId, channel, scope.deviceSelectedType).then(function (result) {
                scope.setLoadingInProgress(false);
                $('.tooltip-error-message').hide(100); //.remove();
                scope.digitalTabData = buildDigitalObject(result.data);
                scope.digitalTabOld = angular.copy(scope.digitalTabData);
                //scope.postDigitalOk(oldVal, newVal, _element, item, index, _errorClass);
                brdMsg = { deviceId: scope.deviceSelected, channel: channel };
                $rootScope.$broadcast('updateDigitalSetting', brdMsg);
            }, function (error) {
                // error
                // log error or return JS
            });
        };

        scope.postDigitalDataDone = function (oldVal, newVal, _element, item, index, _errorClass, channel) {
            var tmpDigitalData = { "op": "replace", "path": item, "value": (typeof newVal === 'undefined' ? 'undefined' : _typeof(newVal)) == "object" && newVal != null && typeof newVal.id != "undefined" ? newVal.id : newVal };
            digitalSettingService.patchDigitalSetting(scope.deviceSelected, channel, scope.accountInfo.customerId, tmpDigitalData, $rootScope.uniqueWebID, encodeURIComponent(scope.deviceSelectedName), scope.deviceSerialNumber, scope.deviceSelectedType).then(function (result) {
                scope.setLoadingInProgress(false);
                $('.tooltip-error-message').hide(100); //.remove();
                scope.digitalTabData = buildDigitalObject(result.data);
                scope.digitalTabOld = angular.copy(scope.digitalTabData);
                scope.postDigitalOk(oldVal, newVal, _element, item, index, _errorClass);
                var brdMsg = { deviceId: scope.deviceSelected, channel: channel };
                $rootScope.$broadcast('updateDigitalSetting', brdMsg);
                scope.ssoCsoCheck(item, newVal, channel);
                scope.excludeRuntimeReportsCheck(item, newVal, channel);
            }, function (error) {
                // error
                // log error or return JS
            });
        };

        scope.refreshDigitalData = function (item, index) {
            var _errorClass = "val-error";
            scope.digitalTabData[index][item] = scope.digitalTabOld[index][item];
            $(".tooltip-error-message").hide(100);
            $(scope.targetField).removeClass(_errorClass);
            scope.prePostDigital();
            scope.setLoadingInProgress(false);
        };

        scope._registerListener = function (varSelectedChannel) {

            if (!scope.liveData) {
                websocketService.connect();

                websocketService.register("DIGITALSETTING", scope.deviceSerialNumber, varSelectedChannel, scope.wsDataReceivedDIGITALSETTING, scope.wsReconnectDIGITALSETTING);
            }
        };

        scope.wsDataReceivedDIGITALSETTING = function (data) {

            if (data.Type == 'DIGITALSETTING' && data.UniqueWebID != $rootScope.uniqueWebID) {
                scope.postDigitalLiveOk(data.CH, data.Value, data.UserName);
            }
        };

        scope.wsReconnectDIGITALSETTING = function (data) {
            if (scope.liveData === false) {
                _unRegisterListener();
                return;
            }
        };
        scope.postDigitalLiveOk = function (channel, liveDigitalUpdate, userName) {

            for (var i = 0; i < scope.digitalTabOld.length; i++) {
                if (scope.digitalTabOld[i].channel == channel) {
                    scope.liveUpdated = "true";
                    if (liveDigitalUpdate.path == "defaultSetting") {
                        scope.digitalConfigFields.forEach(function (element) {
                            scope.digitalTabOld[i][element] = liveDigitalUpdate.value[element.charAt(0).toUpperCase() + element.substring(1)];
                            scope.digitalTabOld[i][element] = liveDigitalUpdate.value[element.charAt(0).toUpperCase() + element.substring(1)];
                        });

                        scope.digitalTabData[i].liveUpdatedItem = liveDigitalUpdate.path;

                        scope.liveMessage = " " + userName + "  has changed Digital Settings to Default";
                    } else {
                        switch (liveDigitalUpdate.path) {
                            case "ivrPumpState":
                                scope.settingOldValue = scope.digitalTabOld[i][liveDigitalUpdate.path] ? "OFF" : "ON";
                                scope.digitalTabOld[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                                scope.digitalTabData[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                                scope.settingNewValue = liveDigitalUpdate.value ? "OFF" : "ON";
                                break;
                            case "digitalMode":
                                scope.settingOldValue = digitalMode.find(function (x) {
                                    return x.id == scope.digitalTabOld[i][liveDigitalUpdate.path].id;
                                }).name;
                                scope.digitalTabOld[i][liveDigitalUpdate.path] = digitalMode.find(function (x) {
                                    return x.id == liveDigitalUpdate.value;
                                });
                                scope.digitalTabData[i][liveDigitalUpdate.path] = digitalMode.find(function (x) {
                                    return x.id == liveDigitalUpdate.value;
                                });
                                scope.settingNewValue = digitalMode.find(function (x) {
                                    return x.id == liveDigitalUpdate.value;
                                }).name;
                                scope.digitalTabData[i].image = liveDigitalUpdate.Image;
                                scope.digitalTabData[i].widgetId = liveDigitalUpdate.WidgetId;
                                var urlImage = 'url(images/' + liveDigitalUpdate.Image + ')';
                                scope.digitalTabData[i].widgetStyle = { 'background-image': urlImage };
                                if (liveDigitalUpdate.value == "P") {
                                    scope.digitalTabData[i].ivrPumpState = false;
                                    scope.digitalTabData[i].alarmType = { "id": 2 };
                                }
                                break;
                            case "ssoCso":
                                scope.settingOldValue = scope.digitalTabOld[i][liveDigitalUpdate.path];
                                scope.digitalTabOld[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                                scope.digitalTabData[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                                scope.settingNewValue = liveDigitalUpdate.value;
                                scope.digitalTabData[i].liveUpdatedItemSso = liveDigitalUpdate.path;
                                scope.liveMessageSso = " " + userName + " changed " + liveDigitalUpdate.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + scope.settingOldValue + " to " + scope.settingNewValue;
                                scope.setTimeOut(i);
                                break;
                            case "alarmType":
                                scope.settingOldValue = alarmType.find(function (x) {
                                    return x.id == scope.digitalTabOld[i][liveDigitalUpdate.path].id;
                                }).name;
                                scope.digitalTabOld[i][liveDigitalUpdate.path] = alarmType.find(function (x) {
                                    return x.id == liveDigitalUpdate.value;
                                });
                                scope.digitalTabData[i][liveDigitalUpdate.path] = alarmType.find(function (x) {
                                    return x.id == liveDigitalUpdate.value;
                                });
                                scope.settingNewValue = alarmType.find(function (x) {
                                    return x.id == liveDigitalUpdate.value;
                                }).name;
                                break;
                            case "normalClosed":
                                scope.settingOldValue = scope.digitalTabOld[i][liveDigitalUpdate.path] == "0" ? "(NO) normally-open" : "(NC) normally-close";
                                scope.digitalTabOld[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                                scope.digitalTabData[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                                scope.settingNewValue = liveDigitalUpdate.value == "0" ? "(NO) normally-open" : "(NC) normally-close";
                                liveDigitalUpdate.path = "normalState";
                                break;
                            case "widgetId":
                                scope.settingOldValue = scope.getWidgetDescription(scope.digitalTabOld[i][liveDigitalUpdate.path]);
                                scope.digitalTabOld[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                                scope.digitalTabData[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                                scope.settingNewValue = scope.getWidgetDescription(liveDigitalUpdate.value);
                                scope.digitalTabData[i].image = liveDigitalUpdate.Image;
                                var urlImageW = 'url(images/' + liveDigitalUpdate.Image + ')';
                                scope.digitalTabData[i].widgetStyle = { 'background-image': urlImageW, 'border': '2px solid #e67e00' };
                                break;
                            default:
                                scope.settingOldValue = scope.digitalTabOld[i][liveDigitalUpdate.path];
                                scope.digitalTabOld[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                                scope.digitalTabData[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                                scope.settingNewValue = liveDigitalUpdate.value;
                                break;
                        }

                        if (liveDigitalUpdate.path != "ssoCso") {
                            scope.digitalTabData[i].liveUpdatedItem = liveDigitalUpdate.path;
                            if (liveDigitalUpdate.path == "widgetId") liveDigitalUpdate.path = "Pump icon";
                            scope.liveMessage = " " + userName + " changed " + liveDigitalUpdate.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + scope.settingOldValue + " to " + scope.settingNewValue;
                            scope.setTimeOut(i);
                        }
                        scope.liveUpdated = "true";
                    }
                }
            }
        };

        scope.setTimeOut = function (index) {
            setTimeout(function () {
                if (scope.digitalTabData[index].liveUpdatedItem == "widgetId") {
                    var urlImageW = 'url(images/' + scope.digitalTabData[index].image + ')';
                    scope.digitalTabData[index].widgetStyle = { 'background-image': urlImageW };
                }
                scope.digitalTabData[index].liveUpdatedItem = null;
                scope.liveUpdated = null;
                scope.liveMessage = null;
                scope.liveMessageSso = null;
            }, 20000); // 20 Seconds
        };

        scope.setTimeOutForPagingInfo = function () {
            setTimeout(function () {
                scope.pagingInfo = null;
            }, 20000); // 20 Seconds
        };

        // private function for this file to build the digital object when getting data from service :JS
        function buildDigitalObject(results) {
            for (var i = 0; i < results.length; i++) {
                scope.digitalConfig.push({
                    "description": { "statusMessage": "", "regEx": /^.{1,40}$/, "validationRequirement": scope.translation.text.DESCRIPTION_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "digitalMode": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "normalClosed": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "ssoCso": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "excludeRuntimeReports": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "statusInputAsAlarm": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true }
                });
                results[i].digitalMode = { "id": results[i].digitalMode };
                results[i].alarmType = { "id": results[i].alarmType };
                results[i].image = results[i].image;
                var urlImage = 'url(images/' + results[i].image + ')';
                results[i].widgetStyle = { 'background-image': urlImage };
                if (results[i].statusInputAsAlarm == true) {
                    results[i].statusInputAsAlarm = { "id": 1 };
                } else {
                    results[i].statusInputAsAlarm = { "id": 0 };
                }
            }
            return results;
        }

        function setPopupTitle(widgetId) {
            if (widgetId === 'A') {
                scope.popoverHeaderTitle = scope.translation.text.ALARM;
            } else if (widgetId === 'D') {
                scope.popoverHeaderTitle = scope.translation.text.DISABLED;
            } else if (widgetId === 'P') {
                scope.popoverHeaderTitle = scope.translation.text.RUNTIME;
            } else if (widgetId === 'S') {
                scope.popoverHeaderTitle = scope.translation.text.STATUS;
            }
        }
    };
}]);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function DigitalTabController($timeout, toaster, sharedSetupService, digitalSettingService, $rootScope, $scope, $cookies, commandOptionsService, pageRequestsService, websocketService, authenticationService, translationService, deviceService, pulseSettingService, cumulativeFlowService) {
    var ctrl = this;

    //following variables available through binding
    //ctrl.modelId
    //ctrl.mobile
    //ctrl.stickyProperties
    //ctrl.isAdmin
    //ctrl.isChromeOrFirefox
    //ctrl.optionBoard 

    var digitalConfigFields = ["description", "digitalMode", "normalClosed"];
    var liveData = false;
    var tabClosed = false;
    var modeSelectedOptions = {};
    var commandOptionsInputMode = [];

    // DigitalAsFlow related fields
    ctrl.isFlow = 0; // 0:DigitalInput, 1:PulseInput (FLOW)
    ctrl.isRainfall = 0; // 0:DigitalInput, 1:Rainfall (Rainfall)
    ctrl.isDigital = 1; // 0:PulseInput (FLOW), 1:DigitalInput
    ctrl.dataAsFlow = [];
    ctrl.dataAsFlowOld = [];
    ctrl.pulseConfig = [];
    ctrl.pulseConfigFields = ["channelName", "unitOfValueID", "flowScale", "snapshotLocalDateTime", "snapshotReading"];

    ctrl.$onInit = function () {
        $scope.alerts = [];
        ctrl.targetField = null;

        //following variables are borrowed from parent rtu-info module
        ctrl.spinner = "<i class='fa fa-spinner fa-2x fa-spin'></i>";
        ctrl.okCheck = ""; //"<i class='fa fa-check fa-2x fa-green' ></i>";
        ctrl.errorCheck = "<i class='fa fa-exclamation-circle fa-2x fa-red'></i>";
        ctrl.resetIndicator = "<i class='fa fa-fw fa-2x'>&nbsp;</i>";

        //IMP: make sure declare all the Isolated scope variables here, so that developer will have clear picture upfront rather declaring them on particular function
        ctrl.digitalTabData = [];
        ctrl.digitalConfig = [];
        ctrl.listOfWidgets = [];

        ctrl.liveUpdated = null;
        ctrl.liveMessage = null;
        ctrl.liveMessageSso = null;
        ctrl.pagingInfo = null;
        ctrl.disableChannel1 = false; //if it is M84 with SkuId = 2 (MM+ with SkuId = L), device type or Model = 20

        ctrl.showRuntimeOptions = false;

        ctrl.unitOfValueListForRainfall = [
        //{ id: 0, name: 'Volts' },
        //{ id: 1, name: 'mA' },
        //{ id: 2, name: 'Amps' },
        { id: 3, name: 'Feet (ft)' }, { id: 4, name: 'Inches (in)' }, { id: 5, name: 'Meters (m)' }, { id: 6, name: 'Millimeters (mm)' },
        //{ id: 7, name: 'GPM' },
        //{ id: 8, name: 'PSI' },
        //{ id: 9, name: 'pH' },
        //{ id: 10, name: 'NTU' },
        //{ id: 11, name: '%' },
        //{ id: 12, name: 'ppm' },
        //{ id: 13, name: 'MGD' },
        //{ id: 14, name: 'mg/l' },
        //{ id: 15, name: 'Hz' },
        //{ id: 16, name: 'C' },
        //{ id: 17, name: 'F' },
        //{ id: 18, name: 'gal' },
        //{ id: 19, name: 'KGal' },
        //{ id: 20, name: 'lbs' },
        //{ id: 21, name: 'uS' },
        { id: 23, name: 'Centimeters (cm)' }, { id: 36, name: 'count' }];

        ctrl.unitOfValueListForFlow = [
        //{ id: 0, name: 'Volts' },
        //{ id: 1, name: 'mA' },
        //{ id: 2, name: 'Amps' },
        { id: 3, name: 'Feet (ft)' }, { id: 4, name: 'Inches (in)' }, { id: 5, name: 'Meters (m)' }, { id: 6, name: 'Millimeters (mm)' }, { id: 7, name: 'Gallons per minute (GPM)' },
        //{ id: 8, name: 'PSI' },
        //{ id: 9, name: 'pH' },
        //{ id: 10, name: 'NTU' },
        //{ id: 11, name: '%' },
        //{ id: 12, name: 'ppm' },
        { id: 13, name: 'Million gallons per day (MGD)' },
        //{ id: 14, name: 'mg/l' },
        //{ id: 15, name: 'Hz' },
        //{ id: 16, name: 'C' },
        //{ id: 17, name: 'F' },
        { id: 18, name: 'Gallons (gal)' }, { id: 19, name: 'Kilo Gallons (KGal)' },
        //{ id: 20, name: 'lbs' },
        //{ id: 21, name: 'uS' },
        { id: 25, name: 'Cubic Centimeters (cm³)' }, { id: 26, name: 'Liters (L)' }, { id: 27, name: 'Cubic meters (m³)' }, { id: 28, name: 'Cubic feet (ft³)' }, { id: 29, name: 'Million gallons (Mgal)' }, { id: 32, name: 'Million Liters (ML)' }, { id: 36, name: 'count' }];

        setLoadingInProgress(true);
        //ctrl.optionBoard = attrs.optionBoard ? true : false;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        //by now parent view (RtuInfo) should set the device to stickyproperties
        // device object has deviceId, deviceName, serialNumber and protocolVersion properties
        ctrl.selectedDevice = ctrl.stickyProperties.device; // this object contains deviceId & deviceName properties only
        ctrl.selectedDeviceId = ctrl.selectedDevice.deviceId; //TODO: remove this variable as it is part of selectedDevice

        //M120 and M150 does nor report current state - Disable Pump Alarms
        ctrl.showAlarmType = [8, 9, 19, 21].indexOf(ctrl.modelId) > -1 ? true : false;
        ctrl.popoverHeaderTitle = '';

        setPumpModeOptions();
        getDigitalSetting(ctrl.selectedDevice.deviceId);
        getPagingCommands();

        if (ctrl.optionBoard) ctrl.rtuDigitalMode.splice(2, 1); //REMOVE id: "P"

        ctrl.SetDisableChannel1();

        ctrl.timeFormatTimePicker = ctrl.getTimeFormat(ctrl.accountInfo.preferenceUser.timeFormat);

        //disabling all the elements under readonly group to prevent from tab order
        $timeout(function () {
            $(".data-read-only").find("*").prop("disabled", true);
            setLoadingInProgress(false);
        }, 1000);
    };

    //if it is M84 with SkuId = 2 (MM+ with SkuId = L), device type or Model = 20
    ctrl.SetDisableChannel1 = function () {
        deviceService.getDevice(ctrl.selectedDevice.deviceId, ctrl.accountInfo.customerId).then(function (result) {
            if (result.data.model == 20 && result.data.skuId == 2) ctrl.disableChannel1 = true;
        }, function (error) {
            //error
        });
    };

    // Isolated scope functions -- Start
    //TODO: move this method to shared service in RTUInfo folder
    ctrl.focusCallback = function ($event) {
        if ($event.target === null) {
            return;
        }
        ctrl.targetField = $event.target;
    };
    // Isolated scope functions -- End

    // Methods from parent component >>"Rtu-Info-Module" ----- Start
    var getElement = function getElement(event) {
        return typeof event !== "undefined" ? event.target : ctrl.targetField;
    };
    var isValid = function isValid(newVal, regEx) {
        if (regEx == "") return true;
        var myregEx = regEx;
        if (myregEx.test(newVal) == false) {
            return false;
        }
        return true;
    };
    var setLoadingInProgress = function setLoadingInProgress(status) {
        ctrl.loadingInProgress = status;
    };
    // Methods from parent component >>"Rtu-Info-Module" ----- End

    ctrl.toggleIVR = function (channel, ivrPumpState) {
        setLoadingInProgress(true);

        digitalSettingService.updateIVRPumpState(ctrl.selectedDevice.deviceId, channel, ctrl.accountInfo.customerId, ctrl.accountInfo.userName, ctrl.selectedDevice.deviceName, ctrl.selectedDevice.serialNumber, ivrPumpState, $rootScope.uniqueWebID);
        getDigitalSetting(ctrl.selectedDevice.deviceId);

        $timeout(function () {
            setLoadingInProgress(false);
        }, 1000);
    };

    //Update SsoCso to false if device is not in alarm digital mode
    var ssoCsoCheck = function ssoCsoCheck(item, newVal, channel) {
        if (item == "digitalMode" && newVal.name != "Alarm") {
            //Set value false in UI
            ctrl.digitalTabData.map(function (item) {
                item.ssoCso = item.channel == channel ? false : item.ssoCso;
            });
            //Set value false in DB
            var newTmpDigitalData = { op: "replace", path: "ssoCso", value: false };
            digitalSettingService.patchDigitalSetting(ctrl.selectedDevice.deviceId, channel, ctrl.accountInfo.customerId, newTmpDigitalData, $rootScope.uniqueWebID, encodeURIComponent(ctrl.selectedDevice.deviceName), ctrl.selectedDevice.serialNumber, ctrl.modelId);
        }
    };

    //Update exclude from runtime report to false if device is not in runtime mode
    var excludeRuntimeReportsCheck = function excludeRuntimeReportsCheck(item, newVal, channel) {
        if (item == "digitalMode" && newVal.name != "Runtime") {
            //Set value false in UI
            ctrl.digitalTabData.map(function (item) {
                item.excludeRuntimeReports = item.channel == channel ? false : item.excludeRuntimeReports;
            });
            //Set value false in DB
            var newTmpDigitalData = { op: "replace", path: "excludeRuntimeReports", value: false };
            digitalSettingService.patchDigitalSetting(ctrl.selectedDevice.deviceId, channel, ctrl.accountInfo.customerId, newTmpDigitalData, $rootScope.uniqueWebID, encodeURIComponent(ctrl.selectedDevice.deviceName), ctrl.selectedDevice.serialNumber, ctrl.modelId);
        }
    };

    var setPumpModeOptions = function setPumpModeOptions() {

        ctrl.rtuDigitalMode = [{
            "id": "A",
            "name": ctrl.translation.text.ALARM,
            "disabled": false
        }, {
            "id": "D",
            "name": ctrl.translation.text.DISABLED,
            "disabled": false
        }, {
            "id": "P",
            "name": ctrl.translation.text.PUMP_RUNTIME,
            "disabled": false
        }, {
            "id": "S",
            "name": ctrl.translation.text.STATUS,
            "disabled": false
        }];

        ctrl.rtuDigitalMode = ctrl.modelId !== 15 && ctrl.modelId !== 20 ? ctrl.rtuDigitalMode : ctrl.rtuDigitalMode.filter(function (item) {
            return item.id != "P";
        });

        if (ctrl.modelId != 15 && ctrl.modelId != 20) ctrl.showRuntimeOptions = true;

        ctrl.rtuDigitalMode = ctrl.modelId !== 21 ? ctrl.rtuDigitalMode : ctrl.rtuDigitalMode.filter(function (item) {
            return item.id != "D";
        });
        ctrl.rtuDigitalModeFiltered = [{
            "id": "A",
            "name": ctrl.translation.text.ALARM
        }, {
            "id": "D",
            "name": ctrl.translation.text.DISABLED
        }, {
            "id": "S",
            "name": ctrl.translation.text.STATUS
        }];

        ctrl.pumpAlarmOption = [{
            "id": 0,
            "name": ctrl.translation.text.ALARM_ON_CLOSE
        }, {
            "id": 1,
            "name": ctrl.translation.text.ALARM_ON_OPEN
        }, {
            "id": 2,
            "name": ctrl.translation.text.NO_ALARM
        }];

        ctrl.statusActAsAlarmOption = [{
            "id": 0,
            "name": ctrl.translation.text.NORMAL
        }, {
            "id": 1,
            "name": ctrl.translation.text.ACT_AS_ALARM
        }];
    };

    ctrl.dynamicPopover = {
        templateUrl: 'myPopoverTemplateB.html'
    };

    //TODO:VENKAT: following event should not be handled here as parent is taking care of it.
    //$scope.$watch('deviceSelected', function (newValue, oldValue) {
    //         if (newValue) {
    //             liveData = false;
    //             if (oldValue && newValue !== oldValue) {
    //                 if (!angular.isUndefined(ctrl.pagingInputsTimer) && ctrl.pagingFinished != 1) {
    //                     ctrl.pagingFinished = 1;
    //                     $timeout.cancel(ctrl.pagingInputsTimer);
    //                     pagingInputMode(oldValue);
    //                 }
    //             }

    //             ctrl.showAlarmType = [8, 9, 18, 19].indexOf(ctrl.modelId) > -1 ? true : false;
    //             var _device = { deviceName: ctrl.selectedDevice.deviceName };
    //             //sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
    //             getDigitalSetting(newValue);

    //             for (var index = 0; index < scope.devices.length; ++index) {
    //                 if (scope.devices[index].deviceId == ctrl.selectedDevice.deviceId) {
    //                     scope.deviceType = scope.devices[index].type;
    //                     scope.protocolVersion = scope.devices[index].protocolVersion;
    //                     break;
    //                 }
    //             }

    //             //Get paging commands
    //             commandOptionsService.getData(scope.accountInfo.customerId, newValue).then(function (dataFromFactory) {
    //                 scope.commandOptions = dataFromFactory.data;
    //                 scope.commandOptionsInputMode = scope.commandOptions.filter(function (el) {
    //                     return el.commandGroupId == 3;
    //                 });
    //                 //Get input modes  
    //                 for (var i = 0; i < scope.digitalTabData.length; i++) {
    //                     switch (scope.digitalTabData[i].digitalMode.id) {
    //                         case "A":
    //                             scope["mode" + (i + 1) + "SelectedOption"] = { id: "A", desc: "A" };
    //                             break;
    //                         case "D":
    //                             scope["mode" + (i + 1) + "SelectedOption"] = { id: "D", desc: "D" };
    //                             break;
    //                         case "P":
    //                             scope["mode" + (i + 1) + "SelectedOption"] = { id: "R", desc: "R" };
    //                             break;
    //                         case "S":
    //                             scope["mode" + (i + 1) + "SelectedOption"] = { id: "S", desc: "S" };
    //                     }
    //                 }
    //             }, function (error) {
    //             });

    //         }
    //     }, true);

    //$scope.$on('updatePreferencesLanguage', function () {
    //    _setPumpModeOptions();
    //});

    var getWidgetDescription = function getWidgetDescription(widgetId) {
        //console.log("Widget Id", widgetId);
        switch (widgetId) {
            case 1:
                return "Alarm";
            case 2:
                return "Disabled";
            case 3:
                return "Submersible Pump - waste water";
            case 4:
                return "Submersible pump - waste water";
            case 5:
                return "Status";
            case 6:
                return "In line / Vane pump";
            case 7:
                return "Centrifugal Pump - Water or Waste water";
            case 8:
                return "In line Pump";
            case 9:
                return "Lobe Pump";
            default:
                return "Pump";
        }
    };
    var getDigitalSetting = function getDigitalSetting(varDeviceId) {
        if (ctrl.accountInfo === null || varDeviceId === null) return;
        digitalSettingService.getData(ctrl.accountInfo.customerId, varDeviceId, ctrl.modelId, ctrl.optionBoard, 'Digital').then(function (dataFromFactory) {
            ctrl.isFlow = 0;
            ctrl.isDigital = 1;
            if (dataFromFactory.data.length === 0) {
                $scope.alerts.push({ msg: ctrl.translation.text.CONTACT_MISSION_SETUP, type: 'info', languageCode: 'CONTACT_MISSION_SETUP' });
            } else {
                for (var l = 0; l < dataFromFactory.data.length; l++) {
                    _registerListener(dataFromFactory.data[l].channel);
                }

                liveData = true;
            }

            //if it is M50 device (21) then fetch digitalAsFlow data
            if (ctrl.modelId == 21) {
                digitalSettingService.getDigitalAsFlowData(ctrl.accountInfo.customerId, varDeviceId, ctrl.modelId).then(function (dataAsFlow) {
                    //clear the array
                    ctrl.pulseConfig = [];
                    for (var i = 0; i < dataAsFlow.data.length; i++) {
                        ctrl.pulseConfig.push({
                            "channelName": { "statusMessage": "", "regEx": /^.{1,50}$/, "validationRequirement": ctrl.translation.text.DESCRIPTION_ERR, "status": ctrl.resetIndicator, "disabled": false },
                            //"unit": { "statusMessage": "", "regEx": /^.{1,50}$/, "validationRequirement": ctrl.translation.text.UNIT_ERR, "status": ctrl.resetIndicator, "disabled": false },
                            "flowScale": { "statusMessage": "", "regEx": /^[0-9]+(\.[0-9]+)?$/, "validationRequirement": ctrl.translation.text.FLOWSCALE_ERR, "status": ctrl.resetIndicator, "disabled": false },
                            "snapshotLocalDateTime": { "statusMessage": "", "regEx": "", "validationRequirement": ctrl.translation.text.DATE_READ_ERR, "status": ctrl.resetIndicator, "disabled": false },
                            "snapshotReading": { "statusMessage": "", "regEx": /^[0-9]+(\.[0-9]+)?$/, "validationRequirement": ctrl.translation.text.READING_ERR, "status": ctrl.resetIndicator, "disabled": false },
                            //"digitMeter": { "statusMessage": "", "regEx": '', "validationRequirement": ctrl.translation.text.DESCRIPTION_ERR, "status": ctrl.resetIndicator, "disabled": false },
                            "unitOfValueID": { "statusMessage": "", "regEx": /^-?[0-9]\d*(\.\d+)?$/, "validationRequirement": ctrl.translation.text.UNIT_ERR, "status": ctrl.resetIndicator, "disabled": false }
                        });
                    }

                    ctrl.dataAsFlow = dataAsFlow.data;
                    if (ctrl.dataAsFlow.length > 0) ctrl.isFlow = 1;else ctrl.isFlow = 0;
                    ctrl.dataAsFlowOld = angular.copy(ctrl.dataAsFlow);
                }, function (error) {
                    //error
                    //setLoadingInProgress(false);
                });
            }
            ctrl.digitalTabData = buildDigitalObject(dataFromFactory.data);
            ctrl.digitalTabOld = angular.copy(ctrl.digitalTabData);
            //setLoadingInProgress(false);
        }, function (error) {
            //error
            setLoadingInProgress(false);
        });
    };
    var getPagingCommands = function getPagingCommands() {
        //Get paging commands
        commandOptionsService.getData(ctrl.accountInfo.customerId, ctrl.selectedDevice.deviceId).then(function (dataFromFactory) {
            //scope.commandOptions = dataFromFactory.data;
            commandOptionsInputMode = dataFromFactory.data.filter(function (el) {
                return el.commandGroupId == 3;
            });
            //Get input modes  
            for (var i = 0; i < ctrl.digitalTabData.length; i++) {
                switch (ctrl.digitalTabData[i].digitalMode.id) {
                    case "A":
                        modeSelectedOptions["mode" + (i + 1) + "SelectedOption"] = { id: "A", desc: "A" };
                        break;
                    case "D":
                        modeSelectedOptions["mode" + (i + 1) + "SelectedOption"] = { id: "D", desc: "D" };
                        break;
                    case "P":
                        modeSelectedOptions["mode" + (i + 1) + "SelectedOption"] = { id: "R", desc: "R" };
                        break;
                    case "S":
                        modeSelectedOptions["mode" + (i + 1) + "SelectedOption"] = { id: "S", desc: "S" };
                }
            }
        }, function (error) {});
    };

    var changeInputMode = function changeInputMode(id, obj) {
        switch (obj.id) {
            case "S":
            case "A":
                modeSelectedOptions["mode" + id + "SelectedOption"] = { id: "A", desc: "A" };
                break;
            case "D":
                modeSelectedOptions["mode" + id + "SelectedOption"] = { id: "D", desc: "D" };
                break;
            case "P":
                modeSelectedOptions["mode" + id + "SelectedOption"] = { id: "R", desc: "R" };
                break;
        }
        //scope["mode" + id + "SelectedOption"] = angular.copy(obj);
    };

    var getCommandDetails = function getCommandDetails() {
        return {
            channel: null, value: null, valueDetail: modeSelectedOptions.mode1SelectedOption.id + modeSelectedOptions.mode2SelectedOption.id + modeSelectedOptions.mode3SelectedOption.id + modeSelectedOptions.mode4SelectedOption.id + modeSelectedOptions.mode5SelectedOption.id + modeSelectedOptions.mode6SelectedOption.id + modeSelectedOptions.mode7SelectedOption.id + modeSelectedOptions.mode8SelectedOption.id
        };
    };

    var pagingInputMode = function pagingInputMode(deviceId) {
        //scope.selectedElectricModes = [];
        if (commandOptionsInputMode.length > 0) {
            var _tmpCommandDescription = commandOptionsInputMode[0].commandDescription;
            var _tmpCommandDetails = getCommandDetails();
            var tmpPageRequest = {
                deviceId: deviceId || ctrl.selectedDevice.deviceId, commandDescription: _tmpCommandDescription, commandDetails: _tmpCommandDetails, electricModes: []
            };
            pageRequestsService.postData(ctrl.accountInfo.customerId, commandOptionsInputMode[0].commandId, ctrl.modelId, ctrl.selectedDevice.protocolVersion, ctrl.accountInfo.timeZone, tmpPageRequest).then(function (data) {
                ctrl.pagingFinished = 1;
                //if paging command is deferred                    
                if (data.data.item2 == 2) {
                    var message = ctrl.translation.text.PAGE_IS_DEFERRED_UNTIL_DEVICE_IS_ONLINE + ' ' + ctrl.selectedDevice.deviceName + ' ' + 'as device is currently offline. This command will be queued for 3 days.';
                    if (tabClosed) {
                        toaster.pop('error', 'Digital setting deferred', message, 30000, 'trustedHtml');
                        tabClosed = false;
                    } else {
                        ctrl.pagingInfo = message;
                        setTimeOutForPagingInfo();
                    }
                }
            });
        }
    };

    var setUpTimer = function setUpTimer() {
        ctrl.pagingInputsTimer = $timeout(function () {
            pagingInputMode();
        }, 15000);
    };

    $scope.$on('$destroy', function () {
        if (!angular.isUndefined(ctrl.pagingInputsTimer) && ctrl.pagingFinished != 1) {
            $timeout.cancel(ctrl.pagingInputsTimer);
            tabClosed = true;
            pagingInputMode();
        }

        for (var k = 0; k < ctrl.digitalTabData.length; k++) {
            websocketService.unRegister("DIGITALSETTING", ctrl.selectedDevice.serialNumber, ctrl.digitalTabData[k].channel, wsDataReceivedDIGITALSETTING, wsReconnectDIGITALSETTING);
        }
    });

    ctrl.postDigitalData = function (oldVal, newVal, item, index, e, regEx, channel) {
        setLoadingInProgress(true);
        if (item == "statusInputAsAlarm") {
            if (oldVal.id == 0) {
                oldVal = false;
            } else {
                oldVal = true;
            }
            if (newVal.id == 0) {
                newVal = false;
            } else {
                newVal = true;
            }
            modeSelectedOptions["mode" + channel + "SelectedOption"] = { id: "A", desc: "A" };
        }

        prePostDigital();
        //prepare paging copmmand detail
        changeInputMode(channel, newVal);
        //clear previous timer for paging
        if (!angular.isUndefined(ctrl.pagingInputsTimer)) $timeout.cancel(ctrl.pagingInputsTimer);
        //set up timer for paging            
        setUpTimer();
        //set up flag for paging finished
        ctrl.pagingFinished = 0;

        var _errorClass = "val-error";
        //var _element = typeof e !== "undefined" ? e.target : scope.targetField;
        var _element = getElement(e);
        if (typeof oldVal == "undefined" || oldVal == newVal) {
            $('.tooltip-error-message').hide(100);
            $(_element).removeClass(_errorClass);
            ctrl.digitalConfig[index][item].status = ctrl.resetIndicator;
            ctrl.digitalConfig[index][item].statusMessage = "";
            setLoadingInProgress(false);
            return;
        }

        if (!isValid(newVal, regEx)) {
            throwDigitalError(_element, item, index, _errorClass);
            setLoadingInProgress(false);
            return;
        }

        //Rainfall setting button should be displayed when dropdown value is changed to Runtime
        if (ctrl.modelId == 21 && newVal.id == "P") {
            ctrl.setDefaultRainfallSetting(channel);
        }

        validationDigitalOk(oldVal, newVal, _element, item, index, _errorClass);
        postDigitalDataDone(oldVal, newVal, _element, item, index, _errorClass, channel);

        $timeout(function () {
            setLoadingInProgress(false);
        }, 2000);
    };

    ctrl.checkIfValid = function (oldVal, newVal, item, index, e, regEx, channel) {

        var _errorClass = ctrl.getErrorClass();
        var _element = getElement();

        setLoadingInProgress(true);
        if (!isValid(newVal, regEx)) {
            throwDigitalError(_element, item, index, _errorClass);
            setLoadingInProgress(false);
            return;
        }

        prePostDigital();

        $('.tooltip-error-message').hide(100);
        $(_element).removeClass(_errorClass);
        setLoadingInProgress(false);
    };

    ctrl.getErrorClass = function () {
        return "val-error";
    };

    // digitalMode is held as { id: "A" } once the data is built, but as a plain string while building it :JS
    var getDigitalModeId = function getDigitalModeId(digitalMode) {
        return digitalMode && (typeof digitalMode === "undefined" ? "undefined" : _typeof(digitalMode)) === "object" ? digitalMode.id : digitalMode;
    };

    // normalClosed is admin only, always locked on model 17 and 18, and locked on any channel in P/R (pump runtime) mode :JS
    var isNormalClosedDisabled = function isNormalClosedDisabled(digitalMode) {
        var mode = getDigitalModeId(digitalMode);
        return !ctrl.isAdmin || (ctrl.modelId == 17 || ctrl.modelId == 18) && mode == "P";
    };

    var defaultDisabled = function defaultDisabled(item, index) {
        return item === "normalClosed" ? isNormalClosedDisabled(ctrl.digitalTabData[index].digitalMode) : false;
    };

    var prePostDigital = function prePostDigital() {
        for (var i = 0; i < ctrl.digitalTabData.length; i++) {
            for (var j = 0; j < digitalConfigFields.length; j++) {
                ctrl.digitalConfig[i][digitalConfigFields[j]].disabled = defaultDisabled(digitalConfigFields[j], i);
                ctrl.digitalConfig[i][digitalConfigFields[j]].status = ctrl.resetIndicator;
                ctrl.digitalConfig[i][digitalConfigFields[j]].statusMessage = "";
            }
        }
        return true;
    };

    var validationDigitalOk = function validationDigitalOk(oldVal, newVal, _element, item, index, _errorClass) {
        ctrl.digitalTabOld[index][item] = newVal;
        $(_element).removeClass(_errorClass);
        for (var i = 0; i < ctrl.digitalTabData.length; i++) {
            for (var j = 0; j < digitalConfigFields.length; j++) {
                if (i == index && digitalConfigFields[j] == item) {
                    ctrl.digitalConfig[i][digitalConfigFields[j]].status = ctrl.spinner;
                    ctrl.digitalConfig[i][digitalConfigFields[j]].statusMessage = "";
                } else {
                    ctrl.digitalConfig[i][digitalConfigFields[j]].status = ctrl.resetIndicator;
                }
                ctrl.digitalConfig[i][digitalConfigFields[j]].disabled = defaultDisabled(digitalConfigFields[j], i);
            }
        }
    };

    var throwDigitalError = function throwDigitalError(_element, item, index, _errorClass, serverCheck) {
        $(_element).addClass(_errorClass);
        for (var i = 0; i < ctrl.digitalTabData.length; i++) {
            for (var j = 0; j < digitalConfigFields.length; j++) {
                if (i == index && digitalConfigFields[j] == item) {
                    ctrl.digitalConfig[i][item].status = ctrl.errorCheck;
                    ctrl.digitalConfig[i][item].disabled = defaultDisabled(item, i);
                    ctrl.digitalConfig[i][item].statusMessage = ctrl.digitalConfig[i][item].validationRequirement;
                } else {
                    ctrl.digitalConfig[i][digitalConfigFields[j]].status = ctrl.resetIndicator;
                    ctrl.digitalConfig[i][digitalConfigFields[j]].disabled = true;
                }
            }
        }
        $(_element).focus();
        $(_element).parent().find(".tooltip-error-message." + item + index).show(100);
    };

    var postDigitalOk = function postDigitalOk(oldVal, newVal, _element, item, index, _errorClass) {
        ctrl.digitalTabOld[index][item] = newVal;
        $(_element).removeClass(_errorClass);
        ctrl.digitalConfig[index][item].status = ctrl.okCheck;
        ctrl.digitalConfig[index][item].statusMessage = "";
    };

    ctrl.getWidgetLibrary = function (widgetTypeCharId) {

        if (!ctrl.isAdmin) return false;

        var tmpWidgetTypeCharId = widgetTypeCharId;

        switch (widgetTypeCharId) {
            case "P":
                ctrl.dynamicPopover = {
                    templateUrl: 'myPopoverTemplateA.html'
                };
                tmpWidgetTypeCharId = "P,G,V";
                break;

            case "S":
            case "A":
            case "D":
                ctrl.dynamicPopover = {
                    templateUrl: 'myPopoverTemplateB.html'
                };
                tmpWidgetTypeCharId = "S";
                break;
            default:
                ctrl.dynamicPopover = {
                    templateUrl: 'myPopoverTemplateB.html'
                };
                break;
        }

        setPopupTitle(widgetTypeCharId);
        ctrl.listOfWidgets = [];
        digitalSettingService.getWidgetLibraryList(tmpWidgetTypeCharId).then(function (result) {
            ctrl.listOfWidgets = result.data.filter(function (item) {
                item.description = item.name.replace(" Pump", "");
                return item;
            });
        }, function (error) {
            // error
            // log error or return JS
        });
    };

    ctrl.updateWidgetLibrary = function (widgetId, channel) {
        //var currentWidgetId = widgetId;
        var tmpDigitalData = { "op": "replace", "path": "widgetId", "value": widgetId };

        digitalSettingService.patchDigitalSetting(ctrl.selectedDevice.deviceId, channel, ctrl.accountInfo.customerId, tmpDigitalData, $rootScope.uniqueWebID, encodeURIComponent(ctrl.selectedDevice.deviceName), ctrl.selectedDevice.serialNumber, ctrl.modelId).then(function (result) {
            setLoadingInProgress(false);
            ctrl.digitalTabData = buildDigitalObject(result.data);
            var brdMsg = {};
            for (var i = 0; i < result.data.length; i++) {
                if (result.data[i].channel == channel) {
                    brdMsg = { deviceId: result.data[i].deviceId, channel: channel, image: result.data[i].image, digitalMode: result.data[i].digitalMode, normalClosed: result.data[i].normalClosed };
                    break;
                };
            }
            $rootScope.$broadcast('updateDigitalWidgetImage', brdMsg);
        }, function (error) {
            // error
            // log error or return JS
        });
    };

    ctrl.postPumpAlarmOption = function (channel, alarmType) {
        var oldAlarmType = ctrl.digitalTabOld.find(function (x) {
            return x.channel == channel;
        }).alarmType.id;
        digitalSettingService.postPumpAlarmOption(ctrl.selectedDevice.deviceId, ctrl.modelId, channel, alarmType.id, ctrl.selectedDevice.deviceName, ctrl.selectedDevice.serialNumber, $rootScope.uniqueWebID, oldAlarmType).then(function (result) {
            setLoadingInProgress(false);
            $('.tooltip-error-message').hide(100); //.remove();
            ctrl.digitalTabData = buildDigitalObject(result.data);
            ctrl.digitalTabOld = angular.copy(ctrl.digitalTabData);
            var brdMsg = { deviceId: ctrl.selectedDevice.deviceId, channel: channel };
            $rootScope.$broadcast('updateDigitalSetting', brdMsg);
        }, function (error) {
            // error
            // log error or return JS
        });
    };

    ctrl.setToDefault = function (deviceId, channel) {
        digitalSettingService.setDescriptionToDefault(deviceId, channel, ctrl.modelId).then(function (result) {
            setLoadingInProgress(false);
            $('.tooltip-error-message').hide(100); //.remove();
            ctrl.digitalTabData = buildDigitalObject(result.data);
            ctrl.digitalTabOld = angular.copy(ctrl.digitalTabData);
            var brdMsg = { deviceId: ctrl.selectedDevice.deviceId, channel: channel };
            $rootScope.$broadcast('updateDigitalSetting', brdMsg);
            if (ctrl.modelId == 21) {
                ctrl.setDefaultRainfallSetting(channel);
            }
        }, function (error) {
            // error
            // log error or return JS
        });
    };

    //calling this method while using default button or while changing the dropdown value to Runtime
    //this will set the Units to Inches and Rain Scale/Per Click to 0 which will display Rainfall Setting Button
    ctrl.setDefaultRainfallSetting = function (channel) {
        var tmpDigitalDataPerClick = { "op": "replace", "path": "perClick", "value": "0" };
        digitalSettingService.patchM50RainfallSettings(ctrl.selectedDevice.deviceId, channel, ctrl.accountInfo.customerId, tmpDigitalDataPerClick, $rootScope.uniqueWebID, encodeURIComponent(ctrl.selectedDevice.deviceName), ctrl.selectedDevice.serialNumber, ctrl.modelId).then(function (result) {
            setLoadingInProgress(false);
            $('.tooltip-error-message').hide(100); //.remove();
            ctrl.digitalTabData = buildDigitalObject(result.data);
            ctrl.digitalTabOld = angular.copy(ctrl.digitalTabData);
            var brdMsg = { deviceId: ctrl.selectedDevice.deviceId, channel: channel };
            $rootScope.$broadcast('updateDigitalSetting', brdMsg);
        }, function (error) {
            ctrl.digitalTabData[index].perClick = item.perClick;
        });
    };

    var postDigitalDataDone = function postDigitalDataDone(oldVal, newVal, _element, item, index, _errorClass, channel) {
        var tmpDigitalData = { "op": "replace", "path": item, "value": (typeof newVal === "undefined" ? "undefined" : _typeof(newVal)) == "object" && newVal != null && typeof newVal.id != "undefined" ? newVal.id : newVal };
        //calling patch twice
        // digitalSettingService.patchDigitalSetting(ctrl.selectedDevice.deviceId, channel, ctrl.accountInfo.customerId, tmpDigitalData, $rootScope.uniqueWebID, encodeURIComponent(ctrl.selectedDevice.deviceName), ctrl.selectedDevice.serialNumber, ctrl.modelId)
        if (item == "perClick" || item == "unitOfValueID") {
            digitalSettingService.patchM50RainfallSettings(ctrl.selectedDevice.deviceId, channel, ctrl.accountInfo.customerId, tmpDigitalData, $rootScope.uniqueWebID, encodeURIComponent(ctrl.selectedDevice.deviceName), ctrl.selectedDevice.serialNumber, ctrl.modelId).then(function (result) {
                setLoadingInProgress(false);
                $('.tooltip-error-message').hide(100); //.remove();
                ctrl.digitalTabData = buildDigitalObject(result.data);
                ctrl.digitalTabOld = angular.copy(ctrl.digitalTabData);
                postDigitalOk(oldVal, newVal, _element, item, index, _errorClass);
                var brdMsg = { deviceId: ctrl.selectedDevice.deviceId, channel: channel };
                $rootScope.$broadcast('updateDigitalSetting', brdMsg);
            }, function (error) {
                // error
                // log error or return JS
            });
        } else {
            digitalSettingService.patchDigitalSetting(ctrl.selectedDevice.deviceId, channel, ctrl.accountInfo.customerId, tmpDigitalData, $rootScope.uniqueWebID, encodeURIComponent(ctrl.selectedDevice.deviceName), ctrl.selectedDevice.serialNumber, ctrl.modelId).then(function (result) {
                setLoadingInProgress(false);
                $('.tooltip-error-message').hide(100); //.remove();
                ctrl.digitalTabData = buildDigitalObject(result.data);
                ctrl.digitalTabOld = angular.copy(ctrl.digitalTabData);
                postDigitalOk(oldVal, newVal, _element, item, index, _errorClass);
                var brdMsg = { deviceId: ctrl.selectedDevice.deviceId, channel: channel };
                $rootScope.$broadcast('updateDigitalSetting', brdMsg);
                ssoCsoCheck(item, newVal, channel);
                excludeRuntimeReportsCheck(item, newVal, channel);
            }, function (error) {
                // error
                // log error or return JS
            });
        }
    };

    ctrl.refreshDigitalData = function (item, index) {
        var _errorClass = "val-error";
        ctrl.digitalTabData[index][item] = ctrl.digitalTabOld[index][item];
        $(".tooltip-error-message").hide(100);
        $(ctrl.targetField).removeClass(_errorClass);
        prePostDigital();
        setLoadingInProgress(false);
    };

    var _registerListener = function _registerListener(varSelectedChannel) {

        if (!liveData) {
            websocketService.connect();

            websocketService.register("DIGITALSETTING", ctrl.selectedDevice.serialNumber, varSelectedChannel, wsDataReceivedDIGITALSETTING, wsReconnectDIGITALSETTING);
        }
    };

    var wsDataReceivedDIGITALSETTING = function wsDataReceivedDIGITALSETTING(data) {

        if (data.Type == 'DIGITALSETTING' && data.UniqueWebID != $rootScope.uniqueWebID) {
            postDigitalLiveOk(data.CH, data.Value, data.UserName);
        }
    };

    var wsReconnectDIGITALSETTING = function wsReconnectDIGITALSETTING(data) {
        if (liveData === false) {
            _unRegisterListener();
            return;
        }
    };

    var typeMap = {
        number: function number(val) {
            return Number(val);
        },
        boolean: function boolean(val) {
            return val.toLowerCase() === 'true';
        },
        json: function json(val) {
            return JSON.parse(val);
        }
    };
    //converts string to target type
    var convert = function convert(str, targetType) {
        return typeMap[targetType](str);
    };

    var postDigitalLiveOk = function postDigitalLiveOk(channel, liveDigitalUpdate, userName) {
        var _loop = function _loop(i) {
            if (ctrl.digitalTabOld[i].channel == channel) {
                ctrl.liveUpdated = "true";
                if (liveDigitalUpdate.path == "defaultSetting") {
                    digitalConfigFields.forEach(function (element) {
                        ctrl.digitalTabOld[i][element] = liveDigitalUpdate.value[element.charAt(0).toUpperCase() + element.substring(1)];
                        ctrl.digitalTabOld[i][element] = liveDigitalUpdate.value[element.charAt(0).toUpperCase() + element.substring(1)];
                    });

                    ctrl.digitalTabData[i].liveUpdatedItem = liveDigitalUpdate.path;

                    ctrl.liveMessage = " " + userName + "  has changed Digital Settings to Default";
                } else {
                    var settingOldValue = "";
                    var settingNewValue = "";
                    switch (liveDigitalUpdate.path) {
                        case "ivrPumpState":
                            settingOldValue = ctrl.digitalTabOld[i][liveDigitalUpdate.path] ? "OFF" : "ON";
                            ctrl.digitalTabOld[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                            ctrl.digitalTabData[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                            settingNewValue = liveDigitalUpdate.value ? "OFF" : "ON";
                            break;
                        case "digitalMode":
                            settingOldValue = ctrl.rtuDigitalMode.find(function (x) {
                                return x.id == ctrl.digitalTabOld[i][liveDigitalUpdate.path].id;
                            }).name;
                            ctrl.digitalTabOld[i][liveDigitalUpdate.path] = ctrl.rtuDigitalMode.find(function (x) {
                                return x.id == liveDigitalUpdate.value;
                            });
                            ctrl.digitalTabData[i][liveDigitalUpdate.path] = ctrl.rtuDigitalMode.find(function (x) {
                                return x.id == liveDigitalUpdate.value;
                            });
                            settingNewValue = ctrl.rtuDigitalMode.find(function (x) {
                                return x.id == liveDigitalUpdate.value;
                            }).name;
                            //normal open/closed follows the new mode :JS
                            ctrl.digitalConfig[i].normalClosed.disabled = isNormalClosedDisabled(ctrl.digitalTabData[i].digitalMode);
                            ctrl.digitalTabData[i].image = liveDigitalUpdate.Image;
                            ctrl.digitalTabData[i].widgetId = liveDigitalUpdate.WidgetId;

                            ctrl.digitalTabData[i].widgetStyle = { 'background-image': 'url(images/' + liveDigitalUpdate.Image + ')' };
                            if (liveDigitalUpdate.value == "P") {
                                ctrl.digitalTabData[i].ivrPumpState = false;
                                ctrl.digitalTabData[i].alarmType = { "id": 2 };
                            }
                            break;
                        case "ssoCso":
                            settingOldValue = ctrl.digitalTabOld[i][liveDigitalUpdate.path];
                            ctrl.digitalTabOld[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                            ctrl.digitalTabData[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                            settingNewValue = liveDigitalUpdate.value;
                            ctrl.digitalTabData[i].liveUpdatedItemSso = liveDigitalUpdate.path;
                            //add message if value is changed
                            if (settingOldValue != convert(settingNewValue, typeof settingOldValue === "undefined" ? "undefined" : _typeof(settingOldValue))) ctrl.liveMessageSso = " " + userName + " changed " + liveDigitalUpdate.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + settingOldValue + " to " + settingNewValue;
                            _setTimeOut(i);
                            break;
                        case "alarmType":
                            settingOldValue = alarmType.find(function (x) {
                                return x.id == ctrl.digitalTabOld[i][liveDigitalUpdate.path].id;
                            }).name;
                            ctrl.digitalTabOld[i][liveDigitalUpdate.path] = alarmType.find(function (x) {
                                return x.id == liveDigitalUpdate.value;
                            });
                            ctrl.digitalTabData[i][liveDigitalUpdate.path] = alarmType.find(function (x) {
                                return x.id == liveDigitalUpdate.value;
                            });
                            settingNewValue = alarmType.find(function (x) {
                                return x.id == liveDigitalUpdate.value;
                            }).name;
                            break;
                        case "normalClosed":
                            settingOldValue = ctrl.digitalTabOld[i][liveDigitalUpdate.path] == "0" ? "(NO) normally-open" : "(NC) normally-close";
                            ctrl.digitalTabOld[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                            ctrl.digitalTabData[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                            settingNewValue = liveDigitalUpdate.value == "0" ? "(NO) normally-open" : "(NC) normally-close";
                            liveDigitalUpdate.path = "normalState";
                            break;
                        case "widgetId":
                            settingOldValue = getWidgetDescription(ctrl.digitalTabOld[i][liveDigitalUpdate.path]);
                            ctrl.digitalTabOld[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                            ctrl.digitalTabData[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                            settingNewValue = getWidgetDescription(liveDigitalUpdate.value);
                            ctrl.digitalTabData[i].image = liveDigitalUpdate.Image;

                            ctrl.digitalTabData[i].widgetStyle = { 'background-image': 'url(images/' + liveDigitalUpdate.Image + ')', 'border': '2px solid #e67e00' };
                            break;
                        default:
                            settingOldValue = ctrl.digitalTabOld[i][liveDigitalUpdate.path];
                            ctrl.digitalTabOld[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                            ctrl.digitalTabData[i][liveDigitalUpdate.path] = liveDigitalUpdate.value;
                            settingNewValue = liveDigitalUpdate.value;
                            break;
                    }

                    if (liveDigitalUpdate.path != "ssoCso") {
                        ctrl.digitalTabData[i].liveUpdatedItem = liveDigitalUpdate.path;
                        if (liveDigitalUpdate.path == "widgetId") liveDigitalUpdate.path = "Pump icon";
                        //ctrl.liveMessage = " " + userName + " changed " + liveDigitalUpdate.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + settingOldValue + " to " + settingNewValue;
                        //updating with generic message for digital settings changes. if user needs exact change to the digital setting, then they should review AuditHistory
                        ctrl.liveMessage = " " + userName + " has updated the Digital Settings. Please avoid making any further changes until the UI has fully reloaded.";
                        _setTimeOut(i);
                    }
                    ctrl.liveUpdated = "true";
                }
            }
        };

        for (var i = 0; i < ctrl.digitalTabOld.length; i++) {
            _loop(i);
        }
    };

    var _setTimeOut = function _setTimeOut(index) {
        setTimeout(function () {
            if (ctrl.digitalTabData[index].liveUpdatedItem == "widgetId") {
                ctrl.digitalTabData[index].widgetStyle = { 'background-image': 'url(images/' + ctrl.digitalTabData[index].image + ')' };
            }
            ctrl.digitalTabData[index].liveUpdatedItem = null;
            ctrl.liveUpdated = null;
            ctrl.liveMessage = null;
            ctrl.liveMessageSso = null;
            //following code for reloading the digital settings 
            getDigitalSetting(ctrl.selectedDevice.deviceId);
            $timeout(function () {
                setLoadingInProgress(false);
            }, 1000);
        }, 20000); // 20 Seconds
    };

    var setTimeOutForPagingInfo = function setTimeOutForPagingInfo() {
        setTimeout(function () {
            ctrl.pagingInfo = null;
        }, 20000); // 20 Seconds
    };

    // private function for this file to build the digital object when getting data from service :JS
    var buildDigitalObject = function buildDigitalObject(results) {
        var _isRainfall = 0;
        for (var i = 0; i < results.length; i++) {
            if (results[i].perClick > 0) {
                _isRainfall = 1;
            }
        }
        ctrl.isRainfall = _isRainfall;

        for (var _i = 0; _i < results.length; _i++) {
            ctrl.digitalConfig.push({
                "description": { "statusMessage": "", "regEx": /^.{1,40}$/, "validationRequirement": ctrl.translation.text.DESCRIPTION_ERR, "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                "digitalMode": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                "normalClosed": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": ctrl.resetIndicator, "disabled": isNormalClosedDisabled(results[_i].digitalMode) },
                "ssoCso": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                "excludeRuntimeReports": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                "statusInputAsAlarm": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                "unitOfValueID": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                //"unit": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                "perClick": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true },
                "rainfallCheck": { "statusMessage": "", "regEx": "", "validationRequirement": "", "status": ctrl.resetIndicator, "disabled": ctrl.isAdmin ? false : true }
            });
            results[_i].digitalMode = { "id": results[_i].digitalMode };
            results[_i].alarmType = { "id": results[_i].alarmType };
            results[_i].image = results[_i].image;
            results[_i].widgetStyle = { 'background-image': 'url(images/' + results[_i].image + ')' };
            if (results[_i].statusInputAsAlarm == true) {
                results[_i].statusInputAsAlarm = { "id": 1 };
            } else {
                results[_i].statusInputAsAlarm = { "id": 0 };
            }
        }
        //Disable Runtime options - One Runtime is allowed for M50
        if (ctrl.modelId == 21) {
            var pumpIndex = results.findIndex(function (x) {
                return x.digitalMode.id === "P";
            });
            if (pumpIndex > -1) {
                ctrl.rtuDigitalMode[1].disabled = true;
            } else {
                ctrl.rtuDigitalMode[1].disabled = false;
            }
        }
        return results;
    };

    var setPopupTitle = function setPopupTitle(widgetId) {
        if (widgetId === 'A') {
            ctrl.popoverHeaderTitle = ctrl.translation.text.ALARM;
        } else if (widgetId === 'D') {
            ctrl.popoverHeaderTitle = ctrl.translation.text.DISABLED;
        } else if (widgetId === 'P') {
            ctrl.popoverHeaderTitle = ctrl.translation.text.RUNTIME;
        } else if (widgetId === 'S') {
            ctrl.popoverHeaderTitle = ctrl.translation.text.STATUS;
        }
    };
    //};
    ctrl.updateToRainfall = function (index, item) {
        setLoadingInProgress(true);
        ctrl.isRainfall = 1;
        // ctrl.digitalTabData[index].displayInput = false;
        // ctrl.digitalTabData[index].perClick = 0.01;
        // ctrl.digitalTabData[index].unit = "Inches";
        var tmpDigitalDataPerClick = { "op": "replace", "path": "perClick", "value": "0.01" };
        digitalSettingService.patchM50RainfallSettings(ctrl.selectedDevice.deviceId, item.channel, ctrl.accountInfo.customerId, tmpDigitalDataPerClick, $rootScope.uniqueWebID, encodeURIComponent(ctrl.selectedDevice.deviceName), ctrl.selectedDevice.serialNumber, ctrl.modelId).then(function (result) {
            //setLoadingInProgress(false);
            $('.tooltip-error-message').hide(100); //.remove();
            ctrl.digitalTabData = buildDigitalObject(result.data);
            ctrl.digitalTabOld = angular.copy(ctrl.digitalTabData);
            var brdMsg = { deviceId: ctrl.selectedDevice.deviceId, channel: item.channel };
            $rootScope.$broadcast('updateDigitalSetting', brdMsg);
        }, function (error) {
            ctrl.digitalTabData[index].perClick = item.perClick;
        });
        var tmpDigitalDataUnit = { "op": "replace", "path": "unitOfValueID", "value": "4" };
        digitalSettingService.patchM50RainfallSettings(ctrl.selectedDevice.deviceId, item.channel, ctrl.accountInfo.customerId, tmpDigitalDataUnit, $rootScope.uniqueWebID, encodeURIComponent(ctrl.selectedDevice.deviceName), ctrl.selectedDevice.serialNumber, ctrl.modelId).then(function (result) {
            //setLoadingInProgress(false);
            $('.tooltip-error-message').hide(100); //.remove();
            ctrl.digitalTabData = buildDigitalObject(result.data);
            ctrl.digitalTabOld = angular.copy(ctrl.digitalTabData);
            var brdMsg = { deviceId: ctrl.selectedDevice.deviceId, channel: item.channel };
            $rootScope.$broadcast('updateDigitalSetting', brdMsg);
        }, function (error) {
            ctrl.digitalTabData[index].unitOfValueID = item.unitOfValueID;
        });

        $timeout(function () {
            setLoadingInProgress(false);;
        }, 2000);
    };

    // ******* DigitalDataAsFlow ********** Logic *******************//
    ctrl.updateToFlow = function (channel) {
        setLoadingInProgress(true);
        ctrl.isFlow = 1; // digitalsetting type is PulseInput ;
        ctrl.isDigital = 0;
        digitalSettingService.updateDigitalAsFlow(ctrl.accountInfo.customerId, ctrl.selectedDevice.deviceId, channel);
        //fetch and reload updated data
        getDigitalSetting(ctrl.selectedDeviceId);
        $timeout(function () {
            setLoadingInProgress(false);;
        }, 1000);
    };
    ctrl.updateToDigital = function (channel) {
        setLoadingInProgress(true);
        ctrl.isFlow = 0; // digitalsetting type is DigitalInput 
        ctrl.isDigital = 1;
        digitalSettingService.updateFlowAsDigital(ctrl.accountInfo.customerId, ctrl.selectedDevice.deviceId, channel);
        //fetch updated data
        getDigitalSetting(ctrl.selectedDeviceId);
        $timeout(function () {
            setLoadingInProgress(false);;
        }, 1000);
    };
    ctrl.postDigitalAsFlowData = function (oldVal, newVal, item, index, e, regEx, channel) {
        if (String(newVal)[0] == '.' && String(newVal).length > 1) newVal = parseFloat(newVal);
        ctrl.prePostPulse();
        var _errorClass = "val-error";
        //var _element = typeof e !== "undefined" ? e.target : scope.targetField;
        var _element = getElement(e);
        if (typeof oldVal == "undefined" || oldVal === newVal || !isNaN(oldVal) && oldVal == newVal) {
            $('.tooltip-error-message').hide(100);
            $(_element).removeClass(_errorClass);
            ctrl.pulseConfig[index][item].status = ctrl.resetIndicator;
            ctrl.pulseConfig[index][item].statusMessage = "";
            setLoadingInProgress(false);
            return;
        }

        //setLoadingInProgress(true);

        if (!isValid(newVal, regEx)) {
            ctrl.throwPulseError(_element, item, index, _errorClass);
            return;
        }

        ctrl.validationPulseOk(oldVal, newVal, _element, item, index, _errorClass);
        ctrl.postPulseDataDone(oldVal, newVal, _element, item, index, _errorClass, channel);
    };

    ctrl.prePostPulse = function () {
        for (var i = 0; i < ctrl.dataAsFlow.length; i++) {
            for (var j = 0; j < ctrl.pulseConfigFields.length; j++) {
                ctrl.pulseConfig[i][ctrl.pulseConfigFields[j]].disabled = false;
                ctrl.pulseConfig[i][ctrl.pulseConfigFields[j]].status = ctrl.resetIndicator;
                ctrl.pulseConfig[i][ctrl.pulseConfigFields[j]].statusMessage = "";
            }
        }
        return true;
    };

    ctrl.validationPulseOk = function (oldVal, newVal, _element, item, index, _errorClass) {
        ctrl.dataAsFlowOld[index][item] = newVal;
        $(_element).removeClass(_errorClass);
        for (var i = 0; i < ctrl.dataAsFlow.length; i++) {
            for (var j = 0; j < ctrl.pulseConfigFields.length; j++) {
                if (i == index && ctrl.pulseConfigFields[j] == item) {
                    ctrl.pulseConfig[i][ctrl.pulseConfigFields[j]].status = ctrl.spinner;
                    ctrl.pulseConfig[i][ctrl.pulseConfigFields[j]].statusMessage = "";
                } else {
                    ctrl.pulseConfig[i][ctrl.pulseConfigFields[j]].status = ctrl.resetIndicator;
                }
                ctrl.pulseConfig[i][ctrl.pulseConfigFields[j]].disabled = false;
            }
        }
    };

    ctrl.checkIfPulseValid = function (oldVal, newVal, item, index, e, regEx, channel) {
        var _errorClass = ctrl.getErrorClass();
        var _element = getElement();

        //setLoadingInProgress(true);
        if (!isValid(newVal, regEx)) {
            ctrl.throwPulseError(_element, item, index, _errorClass);
            return;
        }

        ctrl.prePostPulse();

        $('.tooltip-error-message').hide(100);
        $(_element).removeClass(_errorClass);
        //setLoadingInProgress(false);
    };

    ctrl.throwPulseError = function (_element, item, index, _errorClass, serverCheck) {
        $(_element).addClass(_errorClass);
        for (var i = 0; i < ctrl.dataAsFlow.length; i++) {
            for (var j = 0; j < ctrl.pulseConfigFields.length; j++) {
                if (i == index && ctrl.pulseConfigFields[j] == item) {
                    ctrl.pulseConfig[i][item].status = ctrl.errorCheck;
                    ctrl.pulseConfig[i][item].disabled = false;
                    ctrl.pulseConfig[i][item].statusMessage = ctrl.pulseConfig[i][item].validationRequirement;
                } else {
                    ctrl.pulseConfig[i][ctrl.pulseConfigFields[j]].status = ctrl.resetIndicator;
                    ctrl.pulseConfig[i][ctrl.pulseConfigFields[j]].disabled = true;
                }
            }
        }
        $(_element).focus();
        $(_element).parent().find(".tooltip-error-message." + item + index).show(100);
    };

    ctrl.postPulseOk = function (oldVal, newVal, _element, item, index, _errorClass) {
        ctrl.dataAsFlowOld[index][item] = newVal;
        ctrl.dataAsFlow[index][item] = newVal;
        $(_element).removeClass(_errorClass);
        ctrl.pulseConfig[index][item].status = ctrl.okCheck;
        ctrl.pulseConfig[index][item].statusMessage = "";
    };

    ctrl.postPulseDataDone = function (oldVal, newVal, _element, item, index, _errorClass, channel) {
        if (item == "snapshotReading" || item == "snapshotLocalDateTime") {
            var _cumulativeFlow = { "deviceId": ctrl.selectedDeviceId, "channel": channel, "snapshotLocalDateTime": (ctrl.dataAsFlow[index].snapshotLocalDateTime + "").substring(0, 21), "snapshotReading": ctrl.dataAsFlow[index].snapshotReading };
            cumulativeFlowService.postData(ctrl.accountInfo.customerId, ctrl.selectedDeviceId, ctrl.accountInfo.timeZone, _cumulativeFlow).then(function (result) {
                setLoadingInProgress(false);
                $('.tooltip-error-message').hide(100); //.remove();
                ctrl.postPulseOk(oldVal, newVal, _element, item, index, _errorClass);
            }, function (error) {
                // error
                // log error or return JS
            }).then(function (data) {
                return;
            });
            return;
        }
        var tmpPulseData = { "op": "replace", "path": item, "value": newVal };
        digitalSettingService.patchDigitalAsFlowSetting(ctrl.accountInfo.customerId, ctrl.selectedDeviceId, ctrl.modelId, channel, tmpPulseData).then(function (result) {
            //setLoadingInProgress(false);
            $('.tooltip-error-message').hide(100); //.remove();
            ctrl.postPulseOk(oldVal, newVal, _element, item, index, _errorClass);
            var _dataChanged = "channelName, unitOfValueID, flowScale";
            if (_dataChanged.indexOf(item) > -1) {
                var _device = { deviceId: ctrl.selectedDeviceId, channel: channel, fieldName: item, newSetting: result.data };
                $rootScope.$broadcast('rtuPulseUpdate', _device);
            }
        }, function (error) {
            // error
            // log error or return JS
        });
    };

    ctrl.setPulseSettingsToDefault = function (channel, index, e) {
        pulseSettingService.putPulseSettingsToDefault(ctrl.accountInfo.customerId, ctrl.selectedDeviceId, channel, ctrl.modelId).then(function (result) {
            ctrl.dataAsFlow[index].channelName = result.data.channelName;
            ctrl.dataAsFlow[index].flowScale = result.data.flowScale;
            //ctrl.dataAsFlow[index].unit = result.data.unit;
            ctrl.dataAsFlow[index].unitOfValueID = result.data.unitOfValueID;
            //var _element = typeof e !== "undefined" ? e.target : scope.targetField;
            var _element = getElement(e);
            var _errorClass = "val-error";
            ctrl.postPulseOk(ctrl.dataAsFlowOld[index].channelName, ctrl.dataAsFlow[index].channelName, _element, 'channelName', index, _errorClass);
            ctrl.postPulseOk(ctrl.dataAsFlowOld[index].flowScale, ctrl.dataAsFlow[index].flowScale, _element, 'flowScale', index, _errorClass);
            //ctrl.postPulseOk(ctrl.dataAsFlowOld[index].unit, ctrl.dataAsFlow[index].unit, _element, 'unit', index, _errorClass);
            ctrl.postPulseOk(ctrl.dataAsFlowOld[index].unit, ctrl.dataAsFlow[index].unitOfValueID, _element, 'unitOfValueID', index, _errorClass);

            var _device = { deviceId: ctrl.selectedDeviceId, channel: channel, fieldName: 'channelName', newSetting: [{ channel: channel, channelName: ctrl.dataAsFlow[index].channelName, unit: ctrl.dataAsFlow[index].unitOfValueID, flowScale: ctrl.dataAsFlow[index].flowScale }] };
            $rootScope.$broadcast('rtuPulseUpdate', _device);
        }, function (error) {
            console.log(error);
        });
    };

    ctrl.getTimeFormat = function (timeFormat) {
        return timeFormat == 1 ? "h:mm a" : "H:mm";
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormatTimePicker = false;
        $timeout(function () {
            ctrl.timeFormatTimePicker = ctrl.getTimeFormat(timeFormat);
        }, 1000);
    });
};

DigitalTabController.$inject = ['$timeout', 'toaster', 'sharedSetupService', 'digitalSettingService', '$rootScope', '$scope', '$cookies', 'commandOptionsService', 'pageRequestsService', 'websocketService', 'authenticationService', 'translationService', 'deviceService', 'pulseSettingService', 'cumulativeFlowService'];
mcapp.controller('DigitalTabController', DigitalTabController);
'use strict';

mcapp.component('digitalTabComponent', {
    controller: DigitalTabController,
    templateUrl: 'ui/rtuinfo/digital-tab-template.html',
    bindings: {
        stickyProperties: '<',
        //windowId: '<',
        mobile: '<',
        //windowTitle: '<',
        //classicView: '<',
        isAdmin: '<',
        isChromeOrFirefox: '<',
        modelId: '<'
    }
});
'use strict';

var DigitalSettingService = function DigitalSettingService($http, HOST) {
    var digitalSettingFactory = {};

    var _getData = function _getData(customerId, deviceId, deviceType, optionBoard, tabName) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DigitalSettingRtuInfo?customerId=' + customerId + '&deviceId=' + deviceId + '&deviceType=' + deviceType + '&optionBoard=' + optionBoard + '&tabName=' + tabName,
            cache: false
        });
    };

    var _getDigitalAsFlowData = function _getDigitalAsFlowData(customerId, deviceId, deviceType) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DigitalSettingAsFlow?customerId=' + customerId + '&deviceId=' + deviceId + '&deviceType=' + deviceType,
            cache: false
        });
    };

    var _getRuntimeCountData = function _getRuntimeCountData(deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DigitalSettingRtuInfo?deviceId=' + deviceId,
            cache: false
        });
    };

    var _getWidgetLibraryList = function _getWidgetLibraryList(widgetTypeCharId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/WidgetLibrary?widgetTypeCharId=' + widgetTypeCharId,
            cache: false
        });
    };

    var _postPumpAlarmOption = function _postPumpAlarmOption(deviceId, deviceType, channel, alarmType, deviceName, serialNumber, uniqueWebID, oldAlarmType) {
        return $http({
            method: 'Post',
            url: HOST + '/api/DigitalSetting?deviceId=' + deviceId + '&deviceType=' + deviceType + '&channel=' + channel + '&alarmType=' + alarmType + "&deviceName=" + deviceName + "&serialNumber=" + serialNumber + "&uniqueWebID=" + uniqueWebID + "&oldAlarmType=" + oldAlarmType,
            cache: false
        });
    };

    var _patchDigitalSetting = function _patchDigitalSetting(deviceId, channel, customerId, digitalSettingPatch, uniqueWebID, deviceName, serialNumber, deviceType) {
        return $http.patch(HOST + "/api/DigitalSetting?deviceId=" + deviceId + "&channel=" + channel + "&customerId=" + customerId + "&deviceName=" + deviceName + "&serialNumber=" + serialNumber + "&deviceType=" + deviceType + "&uniqueWebID=" + uniqueWebID, digitalSettingPatch);
    };

    var _patchM50RainfallSettings = function _patchM50RainfallSettings(deviceId, channel, customerId, digitalSettingPatch, uniqueWebID, deviceName, serialNumber, deviceType) {
        return $http.patch(HOST + "/api/DigitalSetting/PatchM50Rainfall?deviceId=" + deviceId + "&channel=" + channel + "&customerId=" + customerId + "&deviceName=" + deviceName + "&serialNumber=" + serialNumber + "&deviceType=" + deviceType + "&uniqueWebID=" + uniqueWebID, digitalSettingPatch);
    };

    var _updateIVRPumpState = function _updateIVRPumpState(deviceId, channel, custID, user, deviceName, serialNumber, ivrPumpState, uniqueWebID) {
        var ivrPatch = { deviceName: deviceName, serialNumber: serialNumber, setting: "ivrPumpState", value: ivrPumpState, uniqueWebID: uniqueWebID };
        return $http.put(HOST + "/api/IVRTogglePumpMessage?deviceId=" + deviceId + "&channel=" + channel + "&custID=" + custID + "&user=" + user, ivrPatch);
    };

    var _setDescriptionToDefault = function _setDescriptionToDefault(deviceId, channel, deviceType) {
        return $http.put(HOST + "/api/DigitalSetting?deviceId=" + deviceId + "&channel=" + channel + "&deviceType=" + deviceType);
    };

    var _updateDigitalAsFlow = function _updateDigitalAsFlow(custID, deviceId, channel) {
        return $http.put(HOST + "/api/DigitalSettingAsFlow/UpdateDigitalChannelSettingAsFlow?deviceId=" + deviceId + "&channel=" + channel + "&customerId=" + custID);
    };

    var _updateFlowAsDigital = function _updateFlowAsDigital(custID, deviceId, channel) {
        return $http.put(HOST + "/api/DigitalSettingAsFlow/UpdateDigitalChannelSettingAsDigital?deviceId=" + deviceId + "&channel=" + channel + "&customerId=" + custID);
    };

    var _patchDigitalAsFlowSetting = function _patchDigitalAsFlowSetting(customerId, deviceId, deviceSelectedType, channel, pulseSettingPatch) {
        return $http.patch(HOST + "/api/DigitalSettingAsFlow?customerId=" + customerId + "&deviceId=" + deviceId + '&deviceType=' + deviceSelectedType + "&channel=" + channel, pulseSettingPatch);
    };

    digitalSettingFactory.getData = _getData;
    digitalSettingFactory.getRuntimeCountData = _getRuntimeCountData;
    digitalSettingFactory.patchDigitalSetting = _patchDigitalSetting;
    digitalSettingFactory.getWidgetLibraryList = _getWidgetLibraryList;
    digitalSettingFactory.postPumpAlarmOption = _postPumpAlarmOption;
    digitalSettingFactory.updateIVRPumpState = _updateIVRPumpState;
    digitalSettingFactory.setDescriptionToDefault = _setDescriptionToDefault;
    digitalSettingFactory.patchM50RainfallSettings = _patchM50RainfallSettings;
    digitalSettingFactory.updateDigitalAsFlow = _updateDigitalAsFlow;
    digitalSettingFactory.updateFlowAsDigital = _updateFlowAsDigital;
    digitalSettingFactory.getDigitalAsFlowData = _getDigitalAsFlowData;
    digitalSettingFactory.patchDigitalAsFlowSetting = _patchDigitalAsFlowSetting;

    return digitalSettingFactory;
};

DigitalSettingService.$inject = ['$http', 'HOST'];
mcapp.factory('digitalSettingService', DigitalSettingService);
'use strict';

mcapp.directive('analogTab', ['$rootScope', '$timeout', 'toaster', 'sharedSetupService', 'analogSettingService', 'digitalSettingService', 'websocketService', '$uibModal', 'deviceService', 'MMPlusRtuSettingFactory', 'McWidgetsSharedFactory', 'analogSettingValidationService', function ($rootScope, $timeout, toaster, sharedSetupService, analogSettingService, digitalSettingService, websocketService, $uibModal, deviceService, MMPlusRtuSettingFactory, McWidgetsSharedFactory, analogSettingValidationService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        var _this = this;

        scope.analogTabData = [];
        scope.analogConfig = [];
        scope.analogConfigFields = ["name", "unit", "minimumValue", "maximumValue", "analogMode", "integrate", "ssoCso", "gaugeMinValue", "gaugeMaxValue"];
        scope.setLoadingInProgress(true);
        scope.optionBoard = attrs.optionBoard ? true : false;
        scope.alerts = [];
        scope.liveUpdated = null;
        scope.selectedChannel = { channel: 1 };
        scope.channelTypeID = 0; //Analog Input Data   
        scope.levelSensorUnit = 'Meters'; //Unit for level sensor SVG
        scope.firstMarker = 0; //Marker for level sensor SVG
        scope.secondMarker = 0; //Marker for level sensor SVG
        scope.thirdMarker = 0; //Marker for level sensor SVG
        scope.pageM50Channels = [];
        scope.resverseScallingOff = false;
        //Marker for level sensor marker for SVG
        scope.sensorLineMarker = 7.7;
        scope.oldSensorLineMarker = 7.7;
        scope.sensorDepthMetersContainer = 7.7;
        scope.oldSensorDepthMetersContainer = 7.7;
        scope.sensorDepthMetersText = 7.7;
        scope.oldSensorDepthMetersText = 7.7;
        //scope.sensorImage = "matrix(0.2381 0 0 0.2381 195.243 159.6983)";
        scope.sensorCable = 7.7;
        scope.oldSensorCable = 7.7;
        scope.floatCable = 7.7;
        scope.oldFloatCable = 7.7;
        scope.sensorImageHeight = 7.7;
        scope.oldSensorImageHeight = 7.7;
        scope.floatImageHeight = 7.7;
        scope.oldFloatImageHeight = 7.7;
        scope.sensorCableStart = 71.9;
        scope.floatCableStart = 72.3;
        scope.maxInMeters = 150;
        scope.maxLength = 150;

        var _sensorYmax = 382.3;
        scope.sensorSpanMeters = 0; //5.7;
        scope.sensorBlankingMeters = 0; //0.3;

        scope.sensorViewArea = "206," + (scope.sensorImageHeight + 20) + " 225," + _sensorYmax + " 177," + _sensorYmax;
        scope.sensorViewArea2 = "206," + (scope.sensorImageHeight + 40) + " 221," + _sensorYmax + " 181," + _sensorYmax;
        scope.sensorViewAreaLx1 = 206;
        scope.sensorViewAreaLy1 = scope.sensorImageHeight + 60;
        scope.sensorViewAreaLx2 = 206;
        scope.sensorViewAreaLy2 = _sensorYmax;

        scope.unitOfValues = [{ id: 3, name: 'Feet', symbol: 'ft' }, { id: 4, name: 'Inches', symbol: 'in' }, { id: 5, name: 'Meters', symbol: 'm' },
        //{ id: 6, name: 'mm' },
        { id: 23, name: 'Centimeters', symbol: 'cm' }];

        scope.unitOfValueList = [{ id: 0, name: 'Volts' }, { id: 1, name: 'mA' }, { id: 2, name: 'Amps' }, { id: 3, name: 'Feet' }, { id: 4, name: 'Inches' }, { id: 5, name: 'Meters' }, { id: 6, name: 'mm' }, { id: 7, name: 'GPM' }, { id: 8, name: 'PSI' }, { id: 9, name: 'pH' }, { id: 10, name: 'NTU' }, { id: 11, name: '%' }, { id: 12, name: 'ppm' }, { id: 13, name: 'MGD' }, { id: 14, name: 'mg/l' }, { id: 15, name: 'Hz' }, { id: 16, name: 'C' }, { id: 17, name: 'F' }, { id: 18, name: 'gal' }, { id: 19, name: 'KGal' }, { id: 20, name: 'lbs' }, { id: 21, name: 'uS' }, { id: 22, name: 'Reading' }, { id: 23, name: 'Centimeters' }];

        scope.callInIntervals = [{ id: 1, IntervalValueHrs: '1 Hour', IntervalValueMin: 60 }, { id: 2, IntervalValueHrs: '2 Hours', IntervalValueMin: 120 }, { id: 3, IntervalValueHrs: '4 Hours', IntervalValueMin: 240 }, { id: 4, IntervalValueHrs: '12 Hours', IntervalValueMin: 720 }, { id: 5, IntervalValueHrs: '24 Hours', IntervalValueMin: 1440 }];
        scope.sampleIntervals = [{ id: 1, name: '4 Minutes', IntervalValueMin: 4 }, { id: 2, name: '5 Minutes', IntervalValueMin: 5 }, { id: 3, name: '6 Minutes', IntervalValueMin: 6 }, { id: 4, name: '10 Minutes', IntervalValueMin: 10 }, { id: 5, name: '15 Minutes', IntervalValueMin: 15 }, { id: 6, name: '20 Minutes', IntervalValueMin: 20 }, { id: 7, name: '30 Minutes', IntervalValueMin: 30 }, { id: 8, name: '60 Minutes', IntervalValueMin: 60 }];

        scope.ourMmPlusDevice = false;

        scope.sensorModes = ["0-5V", "4-20mA", "Function Scaling", "No Contact"];
        scope.unitOfValue = [];

        scope.showSVG = false;

        var _convertFromMeters = function _convertFromMeters(unitId, analogValue) {
            switch (unitId) {
                case 3:
                    //Feet
                    return analogValue * 3.280839895;
                case 4:
                    //Inches
                    return analogValue * 39.37007874;
                case 5:
                    //Meters
                    return analogValue;
                case 6:
                    // mm
                    return analogValue * 1000;
                case 23:
                    // Centimeters
                    return analogValue * 100;
                default:
                    return analogValue;
            }
        };

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                scope.optionBoard = scope.typeId == 2 || scope.typeId == 4 ? true : false;
                //Changing Device, back to "Basic Info" tab
                if (!angular.isUndefined(scope.currentDevice)) return;

                scope.currentDevice = newValue;
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                scope.getAnalogSetting(newValue);
                scope.getUnitsList();
                //fetch value from different table when device has level sensor
                if (scope.hasLevelSensor) {
                    scope.levelSensorDeviceId = newValue;
                    scope.getAnalogChannelAndDeviceConfigForLevelSensor(newValue);
                }
                //scope.ourMmPlusDevice = newValue == 50007 ? true : false;
            }
        }, true);

        scope.getAnalogSetting = function (varDeviceId) {
            if (scope.accountInfo === null || varDeviceId === null) return;
            if (scope.deviceSelectedType === 21) scope.resverseScallingOff = true;
            analogSettingService.getData(scope.accountInfo.customerId, varDeviceId, scope.deviceSelectedType, scope.optionBoard, scope.hasMydroExpansion).then(function (dataFromFactory) {
                if (dataFromFactory.data.length === 0) {
                    scope.alerts.push({ msg: scope.translation.text.CONTACT_MISSION_SETUP, type: 'info', languageCode: 'CONTACT_MISSION_SETUP' });
                } else {
                    scope.showSVG = true;
                    for (var l = 0; l < dataFromFactory.data.length; l++) {
                        //Register to Websocket to get live Analog Setting Changes
                        scope._registerListener(dataFromFactory.data[l].channel);
                    }
                }

                //for (var i = 0; i < dataFromFactory.data.length; i++) {
                //    scope.analogConfig.push({
                //        "name": { "statusMessage": "", "regEx": /^.{1,30}$/, "validationRequirement": scope.translation.text.DESCRIPTION_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                //        "unit": { "statusMessage": "", "regEx": /^.{1,24}$/, "validationRequirement": scope.translation.text.UNIT_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                //        "minimumValue": { "statusMessage": "", "regEx": /^-?[0-9]\d*(\.\d+)?$/, "validationRequirement": scope.translation.text.MINIMUM_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                //        "maximumValue": { "statusMessage": "", "regEx": /^-?[0-9]\d*(\.\d+)?$/, "validationRequirement": scope.translation.text.MAXIMUM_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                //        "analogMode": { "statusMessage": "", "regEx": "", "validationRequirement": scope.translation.text.ANALOG_MODE_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                //        "integrate": { "statusMessage": "", "regEx": "", "validationRequirement": scope.translation.text.INTEGRATE_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true }
                //    });

                //    //Register to Websocket to get live Analog Setting Changes

                //    scope._registerListener(dataFromFactory.data[i].channel);
                //    var urlImage = 'url(images/' + dataFromFactory.data[i].image + ')';
                //    dataFromFactory.data[i].widgetStyle = { 'background-image': urlImage };
                //    if (dataFromFactory.data[i].widgetId == 0) dataFromFactory.data[i].widgetId = 1;
                //}
                //scope.analogTabData = dataFromFactory.data;
                scope.analogTabData = buildAnalogObject(dataFromFactory.data);

                scope.analogTabOld = angular.copy(scope.analogTabData);

                // Set Display Range checkbox status
                scope.analogTabOld.forEach(function (item) {
                    if (!item.analogGaugeSetting) {
                        item.analogGaugeSetting = {};
                    }
                    var gaugeSetting = item.analogGaugeSetting;
                    // True when both values are 0 or null
                    gaugeSetting.displayRange = (gaugeSetting.gaugeMinValue == null || gaugeSetting.gaugeMinValue === 0) && (gaugeSetting.gaugeMaxValue == null || gaugeSetting.gaugeMaxValue === 0);
                    // Checkbox should be unchecked when displayRange is true
                    gaugeSetting.displayRangeEnabled = !gaugeSetting.displayRange;
                });
                scope.setLoadingInProgress(false);
            }, function (error) {
                //error
                scope.setLoadingInProgress(false);
            });
        };

        scope.getUnitsList = function () {
            analogSettingService.getUnitListData().then(function (dataFromFactory) {

                if (dataFromFactory.data.length === 0) {
                    scope.alerts.push({ msg: scope.translation.text.CONTACT_MISSION_SETUP, type: 'info', languageCode: 'CONTACT_MISSION_SETUP' });
                } else {
                    scope.unitOfValue = dataFromFactory.data;
                    var tmpUnitOfValueArr = [];
                    scope.unitOfValue.forEach(function (item) {
                        tmpUnitOfValueArr.push(item.unitOfValueDesc);
                    });

                    scope.analogTabData.forEach(function (analogData, i) {

                        var validUnit = tmpUnitOfValueArr.includes(analogData.unit);

                        if (validUnit == false) {
                            analogData.invalidUnit = true;
                        }
                    });
                }
            }, function (error) {
                //error
                console.log(error);
                scope.setLoadingInProgress(false);
            });
        };

        //Get unit name from unitOfValues array and calculate markers for level sensor SVG
        scope.setUnitandMarkersForLevelSensor = function () {
            var unitObject = scope.unitOfValues.filter(function (x) {
                return x.id === scope.data.unitOfValueID;
            });
            scope.levelSensorUnit = unitObject[0].name;
            scope.levelSensorUnitId = unitObject[0].id;
            scope.levelSensorUnitSymbol = unitObject[0].symbol;

            scope.sensorSpan = _convertFromMeters(scope.levelSensorUnitId, scope.sensorSpanMeters);
            scope.sensorBlanking = _convertFromMeters(scope.levelSensorUnitId, scope.sensorBlankingMeters);

            scope.sensorSpan = scope.sensorSpan + scope.sensorBlanking;

            var difference = scope.data.manholeDepth;
            scope.firstMarker = difference - difference / 4;
            scope.secondMarker = difference / 2;
            scope.thirdMarker = difference / 2 - difference / 4;

            var totalDepth = 382 - 7.7;
            scope.oldSensorLineMarker = scope.sensorLineMarker;
            scope.oldSensorDepthMetersContainer = scope.sensorDepthMetersContainer;
            scope.oldSensorDepthMetersText = scope.sensorDepthMetersText;
            scope.oldSensorImageHeight = scope.sensorImageHeight;
            scope.oldFloatImageHeight = scope.floatImageHeight;
            scope.oldSensorCable = scope.sensorCable;
            scope.oldFloatCable = scope.floatCable;
            var sensorDepthPercentage = scope.data.sensorDepth / scope.data.manholeDepth;

            var sensorSpanPercentage = scope.sensorSpan / scope.data.manholeDepth;
            scope.sensorSpanHeight = sensorSpanPercentage * totalDepth + 7.7;

            var sensorBlankingPercentage = scope.sensorBlanking / scope.data.manholeDepth;
            scope.sensorBlankingHeight = sensorBlankingPercentage * totalDepth + 7.7;

            scope.sensorLineMarker = 7.7 + totalDepth * sensorDepthPercentage;
            scope.sensorDepthMetersContainer = scope.sensorLineMarker - 30; //scope.sensorLineMarker / 2;
            if (scope.sensorDepthMetersContainer < 31.5) {
                scope.sensorDepthMetersContainer = scope.sensorLineMarker + 5;
                scope.sensorDepthMetersText = scope.sensorDepthMetersContainer + 17;
            } else {
                scope.sensorDepthMetersText = scope.sensorDepthMetersContainer + 17;
            }

            scope.sensorImageHeight = scope.sensorLineMarker - 27;

            var sensor1Y = scope.sensorImageHeight + 20 + scope.sensorSpanHeight;
            if (sensor1Y > _sensorYmax) sensor1Y = _sensorYmax;
            var sensor2Y = scope.sensorImageHeight + 50 + scope.sensorSpanHeight - 20;
            if (sensor2Y > _sensorYmax) sensor2Y = _sensorYmax;
            var sensor3Y = scope.sensorImageHeight + 160 + scope.sensorSpanHeight - 140;
            if (sensor3Y > _sensorYmax) sensor3Y = _sensorYmax;

            scope.sensorViewArea = "206," + (scope.sensorImageHeight + 20 + scope.sensorBlankingHeight) + " 225," + sensor1Y + " 187," + sensor1Y;
            scope.sensorViewArea2 = "206," + (scope.sensorImageHeight + 50 + scope.sensorBlankingHeight) + " 221," + sensor2Y + " 191," + sensor2Y;
            scope.sensorViewAreaLx1 = 206;
            scope.sensorViewAreaLy1 = scope.sensorImageHeight + 160;
            scope.sensorViewAreaLx2 = 206;
            scope.sensorViewAreaLy2 = sensor3Y;

            if (scope.sensorImageHeight < 7.7) scope.sensorImageHeight = 7.7;
            if (scope.sensorImageHeight > 101.9475) {
                scope.floatImageHeight = 101.9475;
            } else if (scope.sensorImageHeight <= 7.7) {
                scope.floatImageHeight = 7.7;
            } else {
                scope.floatImageHeight = scope.sensorImageHeight - 15;
            }
            //scope.sensorImage = "matrix(0.2381 0 0 0.2381 195.243 " + (scope.sensorLineMarker - 27) + ")";
            //if (scope.sensorImage < 7.7) scope.sensorImage = 7.7;
            scope.sensorCable = scope.sensorLineMarker;
            if (scope.sensorCable > 105.1) {
                scope.floatCable = 105.1;
            } else if (scope.sensorCable <= 7.7) {
                scope.floatCable = 7.7;
            } else {
                scope.floatCable = scope.sensorCable - 15;
            }
            scope.sensorCableStart = 71.9;
            scope.floatCableStart = 72.3;
            if (scope.sensorCable < 71.9) {
                scope.sensorCableStart = 7.7;
                //scope.sensorCable = 71.9;
            }
            if (scope.floatCable < 72.3) {
                scope.floatCableStart = 7.7;
            }

            _addAnimation();
        };

        var _addAnimation = function _addAnimation() {
            document.getElementById("sensorLineMarkerAnimation1").beginElement();
            document.getElementById("sensorLineMarkerAnimation2").beginElement();
            document.getElementById("sensorDepthMetersContainer").beginElement();
            document.getElementById("sensorDepthMetersText").beginElement();
            document.getElementById("sensorImageAnimation").beginElement();
            document.getElementById("sensorCableAnimation").beginElement();
            document.getElementById("floatImageAnimation").beginElement();
            document.getElementById("floatCableAnimation").beginElement();
        };

        scope.getAnalogChannelAndDeviceConfigForLevelSensor = function (varDeviceId) {
            var MMPlusRtuSettingService = new MMPlusRtuSettingFactory(scope.accountInfo.customerId);
            MMPlusRtuSettingService.getChannelAndDeviceConfig(varDeviceId, scope.selectedChannel.channel, scope.channelTypeID).then(function (result) {
                scope.data = result.data.channelConfig;
                scope.dataOld = angular.copy(scope.data);
                scope.dataOriginal = angular.copy(scope.data); //used for check whether we configure device or not
                scope.deviceConfigData = result.data.deviceConfig;
                scope.deviceConfigDataOld = angular.copy(scope.deviceConfigData);
                scope.deviceConfigDataOriginal = angular.copy(scope.deviceConfigData); //used for check whether we configure device or not
                scope.sensorDescriptionRegex = /^.{1,30}$/;
                scope.networkDeviceConfigID = scope.data.networkDeviceConfigID;
                scope.sensorBlankingMeters = result.data.networkDeviceType.nearBlankingMeters;
                scope.sensorSpanMeters = result.data.networkDeviceType.spanMeters;

                scope.numberOfDecimals = sharedSetupService.getNumberOfDecimals(scope.data.manholeDepth, 0);
                scope.numberStep = scope.numberOfDecimals == 0 ? 1 : scope.numberOfDecimals == 1 ? .1 : scope.numberOfDecimals == 2 ? .01 : scope.numberOfDecimals == 3 ? .001 : .001;

                scope.loading = false;
                scope.getImei(varDeviceId);
                if (!scope.data) {
                    scope.dataAvailable = false;
                    scope.setDefaultData(varDeviceId);
                    scope.configButtonVisible = false;
                    //MMPlusRtuSettingFactory.PostChannelConfig(scope.accountInfo.customerId, varDeviceId, scope.selectedChannel.channel, scope.data);
                } else {
                    scope.dataAvailable = true;
                    scope.configButtonVisible = true;
                    //get settings and markers for level sensor SVG
                    scope.setUnitandMarkersForLevelSensor();
                }
            }, function (error) {
                //error
            });
        };

        scope.getImei = function (varDeviceId) {
            deviceService.getDevice(varDeviceId, scope.accountInfo.customerId).then(function (datafromFactory) {
                scope.imei = datafromFactory.data.imei;
            }, function (error) {
                //error

            }).then(function (data) {});
        };

        scope.setDefaultData = function (varDeviceId) {
            scope.data = {
                networkDeviceConfigID: scope.networkDeviceConfigID,
                deviceID: varDeviceId,
                channelNo: scope.selectedChannel.channel,
                channelTypeID: 0,
                registerAddr: 40001,
                accessModeID: 0,
                alarmHighRestore: 0,
                alarmHighThreshold: 0,
                alarmLowRestore: 0,
                alarmLowThreshold: 0,
                analogFilterID: 0,
                analogInputHWSetupID: 0,
                bitOfInterest: 0,
                cfgValue: 0,
                deEnergizeOnCommLoss: false,
                debounceTimeSecs: 0,
                electModeID: 0,
                floatToIntegerScale: 0,
                msgTransmitRate: 2,
                pulseTimeSecs: 0,
                regAddressModeID: 1,
                runtimeModeID: 0,
                scalingOffset: 0,
                scalingRange: 0,
                sendOnPercentageChg: 0,
                startUpValue: 0,
                unitOfValueID: 0,
                sampleInterval: 5,
                sensorDepthMeters: 0,
                manholeDepthMeters: 0,
                sensorDepth: 0,
                manholeDepth: 0,
                nonc: false
            };
            scope.dataAvailable = true;
        };

        scope.postLevelSensorAnalogData = function (path) {
            if (path == "sensorDepth" || path == "manholeDepth") {
                if (scope.data[path] < 0) scope.data[path] = 0;
            }
            if (path == "sensorDepth") {
                if (scope.data[path] > scope.data.manholeDepth) scope.data[path] = scope.data.manholeDepth;
            }
            if (path == "manholeDepth") {
                if (scope.data[path] < scope.data.sensorDepth) scope.data[path] = scope.data.sensorDepth;
            }
            var tmpDevice = { "op": "replace", "path": path, "value": scope.data[path] };
            var MMPlusRtuSettingService = new MMPlusRtuSettingFactory(scope.accountInfo.customerId);
            scope.maxLength = _convertFromMeters(scope.data.unitOfValueID, scope.maxInMeters);
            if (scope.data.sensorDepth == undefined & path == "sensorDepth") {
                var _element = scope.getElement();
                var _errorClass = scope.getErrorClass();
                $(_element).addClass(_errorClass);
            } else {
                var _element = scope.getElement();
                var _errorClass = scope.getErrorClass();
                $(_element).removeClass(_errorClass);
            }
            MMPlusRtuSettingService.PatchChannelConfig(scope.accountInfo.customerId, scope.levelSensorDeviceId, scope.selectedChannel.channel, scope.channelTypeID, scope.networkDeviceConfigID, tmpDevice).then(function (result) {
                scope.data = result.data;
                scope.dataOld = angular.copy(scope.data);
                scope.dataAvailable = true;
                scope.configButtonVisible = true;
                scope.setUnitandMarkersForLevelSensor();
                var unitData = scope.unitOfValues.find(function (s) {
                    return s.id == result.data.unitOfValueID;
                });
                var mmPlusData = {
                    deviceId: scope.deviceSelected,
                    channel: result.data.channelNo,
                    name: result.data.channelDesc,
                    fieldName: path,
                    unit: unitData.name,
                    maximumValue: result.data.manholeDepth,
                    minimumValue: 0
                };
                $rootScope.$broadcast('rtuAnalogUpdateMMPlus', mmPlusData);
            }, function (error) {
                //error
            });
        };

        scope.configure = function () {
            var MMPlusRtuSettingService = new MMPlusRtuSettingFactory(scope.accountInfo.customerId);
            $timeout(function () {
                if (scope.deviceConfigData.callInInterval !== scope.deviceConfigDataOriginal.callInInterval || scope.deviceConfigData.sampleInterval !== scope.deviceConfigDataOriginal.sampleInterval) {
                    MMPlusRtuSettingService.configMMPlusDevice(scope.levelSensorDeviceId, scope.imei).then(function (result) {
                        //success
                        var configResult = String(result.data).match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
                        scope.deviceConfigAlertMessage = "Device Config " + configResult[0] + ": " + configResult[1];
                        scope.setMessageTimeOut("Device Config");
                    }, function (error) {
                        //error
                        scope.deviceConfigAlertMessage = "Something went wrong while processing device config request";
                        scope.setMessageTimeOut("Device Config");
                    });
                }
                if (scope.data.sensorDepth !== scope.dataOriginal.sensorDepth || scope.data.manholeDepth !== scope.dataOriginal.manholeDepth) {
                    MMPlusRtuSettingService.configMMPlusChannel(scope.levelSensorDeviceId, scope.imei, scope.selectedChannel.channel, scope.channelTypeID).then(function (result) {
                        //success
                        var configResult = result.data.result.match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
                        scope.channelConfigAlertMessage = "Channel Config " + configResult[0] + ": " + configResult[1];
                        scope.setMessageTimeOut("Channel Config");
                    }, function (error) {
                        //error
                        scope.channelConfigAlertMessage = "Something went wrong while processing channel config request";
                        scope.setMessageTimeOut("Channel Config");
                    });
                }
            }, 500);
        };

        scope.setMessageTimeOut = function (type) {
            if (type == "Device Config") {
                setTimeout(function () {
                    scope.deviceConfigAlertMessage = null;
                }, 10000); // 10 Seconds
            } else if (type == "Analog Thresholds") {
                setTimeout(function () {
                    scope.updateThresholdAlertMessage = null;
                }, 5000); // 5 Seconds
            } else {
                setTimeout(function () {
                    scope.channelConfigAlertMessage = null;
                }, 10000); // 10 Seconds
            }
        };

        scope.postDeviceConfigData = function (path) {
            var MMPlusRtuSettingService = new MMPlusRtuSettingFactory(scope.accountInfo.customerId);
            var tmpDevice = { "op": "replace", "path": path, "value": scope.deviceConfigData[path] };
            MMPlusRtuSettingService.patchDeviceG2ConfigPatch(scope.levelSensorDeviceId, tmpDevice).then(function (result) {
                scope.deviceConfigData = result.data;
                scope.configButtonVisible = true;
            }, function (error) {
                //error
            });
        };

        scope.postAnalogData = function (oldVal, newVal, item, index, e, regEx, channel) {
            scope.prePostAnalog();
            var _errorClass = scope.getErrorClass();
            var _element = scope.getElement();
            if (typeof oldVal == "undefined" || oldVal === newVal || !isNaN(oldVal) && oldVal == newVal) {
                $('.tooltip-error-message').hide(100);
                $(_element).removeClass(_errorClass);
                scope.analogConfig[index][item].status = scope.resetIndicator;
                scope.analogConfig[index][item].statusMessage = "";
                scope.setLoadingInProgress(false);
                return;
            }

            //scope.setLoadingInProgress(true);

            if (!scope.isValid(newVal, regEx)) {
                scope.throwAnalogError(_element, item, index, _errorClass);
                return;
            }
            var _deviceId = scope.analogTabData[0].deviceId; //extracting deviceId
            deviceService.getDevice(_deviceId, scope.accountInfo.customerId).then(function (datafromFactory) {
                var volCalcChannel = datafromFactory.data.volCalcLevelChannel;
                scope.validationAnalogOk(oldVal, newVal, _element, item, index, _errorClass);
                if (volCalcChannel === channel) {
                    //notify user to make selection for correct Vol Calc channel on Vol Calc Tab
                    //if property modified is 'unit' and old/new Val is one of the following unit
                    var unitsArray = ['meters', 'meter', 'inch', 'inches', 'mètre', 'metre', 'feet', 'mm'];
                    if (item === 'unit' && (unitsArray.indexOf(oldVal) > -1 || unitsArray.indexOf(newVal) > -1)) {
                        scope.openCommonModal(item);
                    }
                }
                scope.postAnalogDataDone(oldVal, newVal, _element, item, index, _errorClass, channel);
            }, function (error) {
                //error
            });
        };
        scope.setDefaultAnalogData = function (channel, deviceId) {
            analogSettingService.updateAnalogSetting(scope.accountInfo.customerId, channel, deviceId, scope.deviceSelectedType, scope.deviceSerialNumber, scope.optionBoard, $rootScope.uniqueWebID).then(function (resp) {
                scope.analogTabData = buildAnalogObject(resp.data);
                scope.analogTabOld = angular.copy(scope.analogTabData);
                scope.setLoadingInProgress(false);
            }, function (error) {
                //error
                scope.setLoadingInProgress(false);
            });
        };

        scope.checkIfValid = function (oldVal, newVal, item, index, e, regEx, channel) {

            var _errorClass = scope.getErrorClass();
            var _element = scope.getElement();
            if (scope.resverseScallingOff && (item === 'minimumValue' || item === 'maximumValue')) {
                switch (item) {
                    case 'minimumValue':
                        if (newVal > scope.analogTabData[index].maximumValue) {
                            scope.throwAnalogError(_element, item, index, _errorClass, true);
                            return;
                        }
                        break;
                    case 'maximumValue':
                        if (newVal < scope.analogTabData[index].minimumValue) {
                            scope.throwAnalogError(_element, item, index, _errorClass, true);
                            return;
                        }
                        break;
                }
            }
            if (item === "minimumValue" || item === "maximumValue") {
                if (!scope.validateMinimumMaximumRange(index, oldVal, newVal, item, _element, _errorClass)) {
                    scope.analogTabData[index][item] = oldVal;
                    return;
                }
            }
            scope.setLoadingInProgress(true);
            if (!scope.isValid(newVal, regEx)) {
                scope.throwAnalogError(_element, item, index, _errorClass);
                return;
            }

            scope.prePostAnalog();

            $('.tooltip-error-message').hide(100);
            $(_element).removeClass(_errorClass);
            scope.setLoadingInProgress(false);
        };

        scope.prePostAnalog = function () {
            for (var i = 0; i < scope.analogTabData.length; i++) {
                for (var j = 0; j < scope.analogConfigFields.length; j++) {
                    scope.analogConfig[i][scope.analogConfigFields[j]].disabled = false;
                    scope.analogConfig[i][scope.analogConfigFields[j]].status = scope.resetIndicator;
                    scope.analogConfig[i][scope.analogConfigFields[j]].statusMessage = "";
                }
            }
            return true;
        };

        scope.validationAnalogOk = function (oldVal, newVal, _element, item, index, _errorClass) {
            scope.analogTabOld[index][item] = newVal;
            $(_element).removeClass(_errorClass);
            for (var i = 0; i < scope.analogTabData.length; i++) {
                for (var j = 0; j < scope.analogConfigFields.length; j++) {
                    if (i == index && scope.analogConfigFields[j] == item) {
                        scope.analogConfig[i][scope.analogConfigFields[j]].status = scope.spinner;
                        scope.analogConfig[i][scope.analogConfigFields[j]].statusMessage = "";
                    } else {
                        scope.analogConfig[i][scope.analogConfigFields[j]].status = scope.resetIndicator;
                    }
                    scope.analogConfig[i][scope.analogConfigFields[j]].disabled = false;
                }
            }
        };

        scope.throwAnalogError = function (_element, item, index, _errorClass, reverseScaleOffErrMsg, serverCheck) {
            $(_element).addClass(_errorClass);
            for (var i = 0; i < scope.analogTabData.length; i++) {
                for (var j = 0; j < scope.analogConfigFields.length; j++) {
                    if (i == index && scope.analogConfigFields[j] == item) {
                        scope.analogConfig[i][item].status = scope.errorCheck;
                        scope.analogConfig[i][item].disabled = false;
                        scope.analogConfig[i][item].statusMessage = reverseScaleOffErrMsg ? "MyDro 50 does not support reverse scale." : scope.analogConfig[i][item].validationRequirement;
                    } else {
                        scope.analogConfig[i][scope.analogConfigFields[j]].status = scope.resetIndicator;
                        scope.analogConfig[i][scope.analogConfigFields[j]].disabled = true;
                    }
                }
            }
            $(_element).focus();
            $(_element).parent().find(".tooltip-error-message." + item + index).show(100);
        };

        scope.postAnalogOk = function (oldVal, newVal, _element, item, index, _errorClass) {
            scope.analogTabOld[index][item] = newVal;
            $(_element).removeClass(_errorClass);
            scope.analogConfig[index][item].status = scope.okCheck;
            scope.analogConfig[index][item].statusMessage = "";
        };

        scope.postAnalogLiveOk = function (channel, liveAnalogUpdate, userName) {

            for (var i = 0; i < scope.analogTabOld.length; i++) {
                if (scope.analogTabOld[i].channel == channel) {
                    scope.liveUpdated = "true";
                    if (liveAnalogUpdate.path == "defaultSetting") {
                        scope.analogConfigFields.forEach(function (element) {
                            scope.analogTabOld[i][element] = liveAnalogUpdate.value[element.charAt(0).toUpperCase() + element.substring(1)];
                            scope.analogTabData[i][element] = liveAnalogUpdate.value[element.charAt(0).toUpperCase() + element.substring(1)];
                        });

                        scope.analogTabData[i].liveUpdatedItem = liveAnalogUpdate.path;

                        scope.liveMessage = " " + userName + "  has changed Analog Settings to Default";
                    } else {
                        scope.settingOldValue = scope.analogTabOld[i][liveAnalogUpdate.path];
                        scope.analogTabOld[i][liveAnalogUpdate.path] = liveAnalogUpdate.value;
                        scope.analogTabData[i][liveAnalogUpdate.path] = liveAnalogUpdate.value;

                        scope.analogConfig[i][liveAnalogUpdate.path].status = scope.okCheck;
                        scope.analogConfig[i][liveAnalogUpdate.path].statusMessage = "";

                        scope.analogTabData[i].liveUpdatedItem = liveAnalogUpdate.path;
                        scope.liveUpdated = "true";

                        if (scope.analogTabData[i].liveUpdatedItem == "analogMode") {
                            scope.liveMessage = " " + userName + "  changed " + liveAnalogUpdate.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + scope.sensorModes[scope.settingOldValue] + " to " + scope.sensorModes[liveAnalogUpdate.value];
                        } else if (scope.analogTabData[i].liveUpdatedItem == "integrate") {
                            var integrateMsg = liveAnalogUpdate.value ? "Enabled" : "Disabled";

                            scope.liveMessage = " " + userName + " has " + integrateMsg + " " + liveAnalogUpdate.path;
                        } else if (scope.analogTabData[i].liveUpdatedItem == "ssoCso") {
                            var ssoCsoMsg = liveAnalogUpdate.value ? "Enabled" : "Disabled";

                            scope.liveMessage = " " + userName + " has " + ssoCsoMsg + " " + liveAnalogUpdate.path;
                        } else {
                            scope.liveMessage = " " + userName + "  changed " + liveAnalogUpdate.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + scope.settingOldValue + " to " + liveAnalogUpdate.value;
                        }
                        if (liveAnalogUpdate.path == "widgetId") {
                            scope.settingOldValue = scope.getWidgetDescription(scope.analogTabOld[i][liveAnalogUpdate.path]);
                            scope.settingNewValue = scope.getWidgetDescription(liveAnalogUpdate.value);
                            scope.analogTabData[i].image = liveAnalogUpdate.Image;
                            var urlImageW = 'url(images/' + liveAnalogUpdate.Image + ')';
                            scope.analogTabData[i].widgetStyle = { 'background-image': urlImageW, 'border': '2px solid #e67e00' };
                        }
                    }
                    scope.setTimeOut(i);
                }
            }
        };

        scope.getWidgetDescription = function (widgetId) {
            switch (widgetId) {
                case 1:
                    return "Alarm";
                case 2:
                    return "Disabled";
                case 3:
                    return "Submersible Pump - waste water";
                case 4:
                    return "Submersible pump - waste water";
                case 5:
                    return "Status";
                case 6:
                    return "In line / Vane pump";
                case 7:
                    return "Centrifugal Pump - Water or Waste water";
                case 8:
                    return "In line Pump";
                case 9:
                    return "Lobe Pump";
                default:
                    return "Pump";
            }
        };

        scope.getWidgetLibrary = function () {
            if (!scope.isAdmin) return false;
            scope.popoverHeaderTitle = "Analog";
            scope.listOfWidgets = [];
            digitalSettingService.getWidgetLibraryList("AL").then(function (result) {
                scope.listOfWidgets = result.data;
                for (var i = 0; i < scope.listOfWidgets.length; i++) {
                    if (scope.listOfWidgets[i].name == "Temperature Gauge") scope.listOfWidgets.splice(i, 1);
                    //filter the widget option dropdown so only M150, M850, M50 devices have access to the Lake Level widget
                    if (scope.listOfWidgets[i].name == "Lake Level" && scope.deviceSelectedType !== 18 && scope.deviceSelectedType !== 19 && scope.deviceSelectedType !== 21) scope.listOfWidgets.splice(i, 1);
                }
            }, function (error) {
                // error
                // log error or return JS
            });
        };

        var _checkIfIntegrateDisabled = function _checkIfIntegrateDisabled(channel, analogSetting) {

            var disabled = false;

            switch (scope.deviceSelectedType) {
                case 21:
                    //M50 Ranger Device
                    var shouldDisable = analogSetting.filter(function (item) {
                        return item.channel !== channel && item.integrate;
                    });
                    disabled = shouldDisable.length > 0 ? true : false;
                    if (disabled) scope.integrateDisabled = { channel: shouldDisable[0].channel, msg: "Channel " + shouldDisable[0].channel + " already selected." };
                    if (disabled) break;
                    disabled = scope.isAdmin ? false : true;
                    break;
                default:
                    disabled = scope.isAdmin ? false : true;
                    break;
            }

            return disabled;
        };

        // private function for this file to build the analog object when getting data from service :JS
        function buildAnalogObject(results) {
            scope.analogConfig = [];
            scope.integrateDisabled = { channel: 0, msg: "" };
            for (var i = 0; i < results.length; i++) {
                scope.analogConfig.push({
                    "name": { "statusMessage": "", "regEx": /^.{1,30}$/, "validationRequirement": scope.translation.text.DESCRIPTION_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "unit": { "statusMessage": "", "regEx": /^.{1,24}$/, "validationRequirement": scope.translation.text.UNIT_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "unitOfValueID": { "statusMessage": "", "regEx": /(100)|(0*\d{1,2})/, "validationRequirement": scope.translation.text.UNIT_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "minimumValue": { "statusMessage": "", "regEx": /^-?[0-9]\d*(\.\d+)?$/, "validationRequirement": scope.translation.text.MINIMUM_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "maximumValue": { "statusMessage": "", "regEx": /^-?[0-9]\d*(\.\d+)?$/, "validationRequirement": scope.translation.text.MAXIMUM_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "analogMode": { "statusMessage": "", "regEx": "", "validationRequirement": scope.translation.text.ANALOG_MODE_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin && scope.deviceSelectedType != 21 ? false : true },
                    "integrate": { "statusMessage": "", "regEx": "", "validationRequirement": scope.translation.text.INTEGRATE_ERR, "status": scope.resetIndicator, "disabled": _checkIfIntegrateDisabled(results[i].channel, results) },
                    "ssoCso": { "statusMessage": "", "regEx": "", "validationRequirement": scope.translation.text.INCLUDE_IN_SS0_CSO, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "gaugeMinValue": { "statusMessage": "", "regEx": /^-?[0-9]\d*(\.\d+)?$/, "validationRequirement": scope.translation.text.MINIMUM_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true },
                    "gaugeMaxValue": { "statusMessage": "", "regEx": /^-?[0-9]\d*(\.\d+)?$/, "validationRequirement": scope.translation.text.MAXIMUM_ERR, "status": scope.resetIndicator, "disabled": scope.isAdmin ? false : true }
                });
                results[i].image = results[i].image;
                var urlImage = 'url(images/' + results[i].image + ')';
                results[i].widgetStyle = { 'background-image': urlImage };
                //if (dataFromFactory.data[i].widgetId == 0) dataFromFactory.data[i].widgetId = 1;
            }
            return results;
        }

        scope.updateWidgetLibrary = function (widgetId, channel) {
            var gaugeSettings = {
                widgetId: widgetId,
                gaugeMinValue: scope.analogTabData[channel - 1].analogGaugeSetting.gaugeMinValue,
                gaugeMaxValue: scope.analogTabData[channel - 1].analogGaugeSetting.gaugeMaxValue
            };
            var tmpAnalogData = { "op": "replace", "path": "widgetId", "value": gaugeSettings };
            analogSettingService.patchAnalogSetting(scope.accountInfo.customerId, scope.deviceSelected, encodeURIComponent(scope.deviceSelectedName), channel, scope.deviceSelectedType, scope.deviceSerialNumber, $rootScope.uniqueWebID, tmpAnalogData).then(function (result) {
                scope.setLoadingInProgress(false);
                var brdMsg = {};
                var findIndexAnalogChannel = scope.analogTabData.findIndex(function (x) {
                    return x.channel == channel;
                });
                var findIndexResultAnalogChannel = result.data.findIndex(function (x) {
                    return x.channel == channel;
                });
                if (findIndexResultAnalogChannel > -1) {
                    brdMsg = { deviceId: result.data[findIndexResultAnalogChannel].deviceId, channel: channel, image: result.data[findIndexResultAnalogChannel].image };
                };
                if (findIndexAnalogChannel > -1 && findIndexResultAnalogChannel > -1) {
                    scope.analogTabData[findIndexAnalogChannel] = result.data[findIndexResultAnalogChannel];
                }
                $rootScope.$broadcast('rtuAnalogUpdate', brdMsg);
                scope.analogTabData = buildAnalogObject(scope.analogTabData);
            }, function (error) {
                // error
                // log error or return JS
            });
        };

        scope.dynamicPopover = {
            templateUrl: 'myAnalogPopoverTemplate.html'
        };

        scope.setTimeOut = function (index) {
            setTimeout(function () {
                if (scope.analogTabData[index].liveUpdatedItem == "widgetId") {
                    var urlImageW = 'url(images/' + scope.analogTabData[index].image + ')';
                    scope.analogTabData[index].widgetStyle = { 'background-image': urlImageW };
                }
                scope.analogTabData[index].liveUpdatedItem = null;
                scope.liveUpdated = null;
            }, 20000); // 20 Seconds
        };

        scope.postAnalogDataDone = function (oldVal, newVal, _element, item, index, _errorClass, channel) {
            if (scope.resverseScallingOff & (item === 'minimumValue' || item === 'maximumValue')) {
                switch (item) {
                    case 'minimumValue':
                        if (newVal > scope.analogTabData[index].maximumValue) newVal = oldVal;
                        break;
                    case 'maximumValue':
                        if (newVal < scope.analogTabData[index].minimumValue) newVal = oldVal;
                        break;
                }
            }
            if (item === "gaugeMinValue" || item === "gaugeMaxValue") {
                if (!scope.validateGaugeRange(index, oldVal, item, _element, _errorClass)) {
                    scope.analogTabData[index].analogGaugeSetting[item] = oldVal;
                    return;
                }
            }
            var tmpAnalogData = { "op": "replace", "path": item, "value": newVal };
            analogSettingService.patchAnalogSetting(scope.accountInfo.customerId, scope.deviceSelected, encodeURIComponent(scope.deviceSelectedName), channel, scope.deviceSelectedType, scope.deviceSerialNumber, $rootScope.uniqueWebID, tmpAnalogData).then(function (result) {
                scope.setLoadingInProgress(false);
                $('.tooltip-error-message').hide(100); //.remove();
                var newResult = [];

                for (var i = 0; i < result.data.length; i++) {
                    newResult.push(result.data[i]);
                }

                scope.analogTabData = buildAnalogObject(newResult);
                scope.analogTabOld = angular.copy(scope.analogTabData);

                // if (scope.unitOfValue.length > 0) {
                //     var tmpUnitOfValueArr = [];
                //     scope.unitOfValue.forEach((item) => {
                //         tmpUnitOfValueArr.push(item.unitOfValueDesc);
                //     });
                //     scope.analogTabData.forEach((analogData, i) => {

                //         var validUnit = tmpUnitOfValueArr.includes(analogData.unit);

                //         if (validUnit == false) {
                //             analogData.invalidUnit = true;
                //         }

                //     });     
                // }
                if (scope.deviceSelectedType === 21 & (item == 'minimumValue' || item == 'maximumValue')) // If channel Settings change - Page M50 Ranger Device to save the settings
                    {
                        var channelPageIndex = scope.pageM50Channels.length == 0 ? -1 : scope.pageM50Channels.findIndex(function (x) {
                            return x == channel;
                        });
                        if (channelPageIndex == -1) scope.pageM50Channels.push(channel);
                    }
                scope.postAnalogOk(oldVal, newVal, _element, item, index, _errorClass);
                var _dataChanged = "name, unit, minimumValue, maximumValue, gaugeMinValue, gaugeMaxValue";
                if (_dataChanged.indexOf(item) > -1) {
                    var _device = { deviceId: scope.deviceSelected, channel: channel, fieldName: item, newSetting: result.data };
                    $rootScope.$broadcast('rtuAnalogUpdate', _device);
                }

                //Warning to user to update thresholds and tank and well tank display
                if (item == 'minimumValue' || item == 'maximumValue') {
                    scope.updateThresholdAlertMessage = "Please adjust Analog Thresholds and T&W Tank Display to the new analog scaling";
                    scope.setMessageTimeOut("Analog Thresholds");
                }
                // Checkbox conditon to checked once gaugeMinValue, gaugeMaxValue is updated
                var gaugeSetting = scope.analogTabOld[index].analogGaugeSetting;
                var displayRange = (gaugeSetting.gaugeMinValue == null || gaugeSetting.gaugeMinValue === 0) && (gaugeSetting.gaugeMaxValue == null || gaugeSetting.gaugeMaxValue === 0);
                scope.displayRangeCheckBox(index, !displayRange);
            }, function (error) {
                //error
                // JS should return error or use console log
            });
        };

        scope.refreshAnalogData = function (item, index) {
            var _errorClass = "val-error";
            scope.analogTabData[index][item] = scope.analogTabOld[index][item];
            $(".tooltip-error-message").hide(100);
            $(scope.targetField).removeClass(_errorClass);
            scope.prePostAnalog();
            scope.setLoadingInProgress(false);
        };

        scope.configureAnalogInput = function (channel) {
            var index = scope.pageM50Channels.indexOf(channel);
            if (index > -1) {
                scope.pageM50Channels.splice(index, 1);
            }
            var channelArray = [];
            channelArray.push(channel);
            analogSettingService.pageAnalogSetting(scope.accountInfo.customerId, scope.deviceSelected, channelArray).then(function (result) {
                //success
                scope.channelConfigAlertMessage = "Analog Settings have been successfully sent to M50 Ranger";
                scope.setMessageTimeOut("Channel Config");
            }, function (error) {
                //error
                scope.channelConfigAlertMessage = "Something went wrong while processing channel config request";
                scope.setMessageTimeOut("Channel Config");
            });
        };
        scope._registerListener = function (varSelectedChannel) {

            // if (scope.liveData === true)
            //     return;

            scope.liveData = true;
            websocketService.connect();

            websocketService.register("ANALOGSETTING", scope.deviceSerialNumber, varSelectedChannel, scope.wsDataReceivedANALOGSETTING, scope.wsReconnectANALOGOUTSETTING);
        };

        scope.wsDataReceivedANALOGSETTING = function (data) {

            if (data.Type == 'ANALOGSETTING' && data.UniqueWebID != $rootScope.uniqueWebID) {

                scope.postAnalogLiveOk(data.CH, data.Value, data.UserName);
            }
        };

        scope.wsReconnectANALOGOUTSETTING = function (data) {
            if (scope.liveData === false) {
                _unRegisterListener();
                return;
            }
        };

        scope.openCommonModal = function (item) {
            function modalController($uibModalInstance, translationService) {
                this.translation = translationService.translation;
                this.tmpConfirmHeader = this.translation.text.CAUTION;
                this.tmpConfirmFooter = item == "Config Channels" ? this.translation.text.CONFIRM : "Configure Modfied Channels";
                this.tmpConfirmMessageA = item == "Config Channels" ? "Scaling is not sent to the M50 Ranger. Please confirm to send all modfied analog settings to M50 Ranger" : this.translation.text.UPDATE_SETTINGS_VOLCALC_TAB;
                this.cancel = function () {
                    $uibModalInstance.close(item);
                };
            }

            modalController.$inject = ['$uibModalInstance', 'translationService'];

            var modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
                controller: modalController,
                controllerAs: '$ctrl',
                size: 'sm',
                resolve: {
                    translation: function translation() {
                        return _this.translation;
                    }
                }
            });

            modalInstance.result.then(function (item) {
                if (scope.pageM50Channels.length > 0) analogSettingService.pageAnalogSetting(scope.accountInfo.customerId, scope.deviceSelected, scope.pageM50Channels);
            }, function () {
                // cancel button
            });
        };

        scope.validateGaugeRange = function (index, oldVal, item, element, errorClass) {
            var gaugeSetting = scope.analogTabData[index].analogGaugeSetting;
            var validationResult = analogSettingValidationService.validateGaugeRange({
                minValue: scope.analogTabData[index].minimumValue,
                maxValue: scope.analogTabData[index].maximumValue,
                gaugeMinValue: gaugeSetting.gaugeMinValue,
                gaugeMaxValue: gaugeSetting.gaugeMaxValue,
                changedField: item
            });

            if (!validationResult.valid) {
                var field = validationResult.field;
                scope.analogConfig[index][field].validationRequirement = validationResult.message;
                scope.throwAnalogError(element, field, index, errorClass);
                scope.setLoadingInProgress(false);
                return false;
            }
            gaugeSetting.gaugeMinValue = validationResult.gaugeMinValue;
            gaugeSetting.gaugeMaxValue = validationResult.gaugeMaxValue;
            return true;
        };

        scope.validateMinimumMaximumRange = function (index, oldVal, newVal, item, element, errorClass) {
            var gaugeSetting = scope.analogTabOld[index].analogGaugeSetting;
            var validationResult = analogSettingValidationService.validateAnalogRange({
                oldMinValue: item === "minimumValue" ? oldVal : scope.analogTabOld[index].minimumValue,
                oldMaxValue: item === "maximumValue" ? oldVal : scope.analogTabOld[index].maximumValue,
                newValue: newVal,
                changedField: item,
                displayRangeEnabled: gaugeSetting.displayRangeEnabled,
                gaugeMinValue: gaugeSetting.gaugeMinValue,
                gaugeMaxValue: gaugeSetting.gaugeMaxValue
            });

            if (!validationResult.valid) {
                var field = validationResult.field;
                scope.analogConfig[index][field].validationRequirement = validationResult.message;
                scope.throwAnalogError(element, field, index, errorClass);
                scope.setLoadingInProgress(false);
                return false;
            }
            return true;
        };

        scope.displayRangeCheckBox = function (index, isChecked) {
            var gaugeSetting = scope.analogTabOld[index].analogGaugeSetting;
            gaugeSetting.displayRangeEnabled = isChecked;
            // displayRange is the opposite of the checkbox value
            gaugeSetting.displayRange = !isChecked;

            var channelCheckBox = index + 1;
            // The api should only be called when either gaugeMinValue or gaugeMaxValue has value not equal to 0 and Display Range is unchecked
            if (gaugeSetting.displayRange == true && (gaugeSetting.gaugeMinValue === "" || gaugeSetting.gaugeMaxValue === "" || gaugeSetting.gaugeMinValue != 0 || gaugeSetting.gaugeMaxValue != 0)) {
                // Update UI immediately                
                gaugeSetting.gaugeMinValue = scope.analogTabData[index].analogGaugeSetting.gaugeMinValue = 0;
                gaugeSetting.gaugeMaxValue = scope.analogTabData[index].analogGaugeSetting.gaugeMaxValue = 0;
                scope.setLoadingInProgress(true);
                var tmpAnalogData = { "op": "replace", "path": "displayRange", "value": gaugeSetting };
                analogSettingService.patchAnalogSetting(scope.accountInfo.customerId, scope.deviceSelected, encodeURIComponent(scope.deviceSelectedName), channelCheckBox, scope.deviceSelectedType, scope.deviceSerialNumber, $rootScope.uniqueWebID, tmpAnalogData).then(function (result) {
                    scope.setLoadingInProgress(false);
                    $('.tooltip-error-message').hide(100); //.remove();
                    var newResult = [];

                    for (var i = 0; i < result.data.length; i++) {
                        newResult.push(result.data[i]);
                    }

                    // Save Display Range state for every channel before rebuilding
                    var displayRangeStates = {};
                    scope.analogTabOld.forEach(function (item) {
                        if (item.analogGaugeSetting) {
                            displayRangeStates[item.channel] = {
                                displayRangeEnabled: item.analogGaugeSetting.displayRangeEnabled,
                                displayRange: item.analogGaugeSetting.displayRange
                            };
                        }
                    });

                    scope.analogTabData = buildAnalogObject(newResult);
                    // Restore Display Range state for every channel
                    scope.analogTabData.forEach(function (item) {
                        if (item.analogGaugeSetting && displayRangeStates[item.channel]) {
                            item.analogGaugeSetting.displayRangeEnabled = displayRangeStates[item.channel].displayRangeEnabled;
                            item.analogGaugeSetting.displayRange = displayRangeStates[item.channel].displayRange;
                        }
                    });

                    scope.analogTabOld = angular.copy(scope.analogTabData);

                    var _device = { deviceId: scope.deviceSelected, channel: channelCheckBox, fieldName: "gaugeMinValue", newSetting: result.data };
                    $rootScope.$broadcast('rtuAnalogUpdate', _device);
                }, function (error) {
                    //error
                    // JS should return error or use console log
                });
            }
        };

        scope.$on("$destroy", function () {
            for (var i = 0; i < scope.analogTabData.length; i++) {
                websocketService.unRegister("ANALOGSETTING", scope.deviceSerialNumber, scope.analogTabData[i].channel, scope.wsDataReceivedANALOGSETTING, scope.wsReconnectANALOGOUTSETTING);
            }
            if (scope.pageM50Channels.length > 0) scope.openCommonModal("Config Channels");
        });
    };
}]);

mcapp.factory('analogSettingService', ['$http', 'HOST', 'deviceMenuService', function ($http, HOST, deviceMenuService) {
    var analogSettingFactory = {};

    var _getData = function _getData(customerId, deviceId, deviceType, optionBoard, hasMydroExpansion) {
        return $http({
            method: 'Get',
            url: HOST + '/api/Analog/Setting?customerId=' + customerId + '&deviceId=' + deviceId + '&deviceType=' + deviceType + '&optionBoard=' + optionBoard + '&hasMydroExpansion=' + hasMydroExpansion,
            cache: false
        });
    };

    var _getUnitListData = function _getUnitListData() {
        return $http({
            method: 'Get',
            url: HOST + '/api/Analog/Units',
            cache: false
        });
    };

    var _patchAnalogSetting = function _patchAnalogSetting(customerId, deviceId, deviceName, channel, deviceType, serialNumber, uniqueWebID, analogSettingPatch) {
        if (analogSettingPatch.path == "integrate") deviceMenuService.resetDeviceMenuList();
        return $http.patch(HOST + "/api/Analog/Setting?customerId=" + customerId + "&deviceId=" + deviceId + "&deviceName=" + deviceName + "&channel=" + channel + "&deviceType=" + deviceType + "&serialNumber=" + serialNumber + "&uniqueWebID=" + uniqueWebID, analogSettingPatch);
    };

    var _updateAnalogSetting = function _updateAnalogSetting(customerId, channel, deviceId, deviceType, serialNumber, optionBoard, uniqueWebID) {
        return $http.put(HOST + "/api/Analog/Setting?customerId=" + customerId + "&deviceId=" + deviceId + '&deviceType=' + deviceType + "&channel=" + channel + "&serialNumber=" + serialNumber + '&optionBoard=' + optionBoard + "&uniqueWebID=" + uniqueWebID);
    };

    var _pageAnalogSetting = function _pageAnalogSetting(customerId, deviceId, channelList) {
        return $http.post(HOST + "/api/Analog/Setting/PageChannelConfig?customerId=" + customerId + "&deviceId=" + deviceId, channelList);
    };

    analogSettingFactory.getData = _getData;
    analogSettingFactory.getUnitListData = _getUnitListData;
    analogSettingFactory.patchAnalogSetting = _patchAnalogSetting;
    analogSettingFactory.updateAnalogSetting = _updateAnalogSetting;
    analogSettingFactory.pageAnalogSetting = _pageAnalogSetting;
    return analogSettingFactory;
}]);
"use strict";

angular.module("mc.revision-log", []);
'use strict';

function RevisionLogFactory(HOST, $http) {
    function GetList(applicationId, startDate, endDate, timeZone) {
        return $http({
            method: 'GET',
            url: HOST + '/api/McApplicationVersion',
            params: { applicationId: applicationId, startDate: startDate, endDate: endDate, timeZone: timeZone }
        });
    }

    function patchData(logItem, logPatch) {
        var self = this;
        return $http.patch(HOST + '/api/McApplicationVersion' + '?ID=' + logItem.id + '&timeZone=' + logItem.timeZone, logPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    function saveRevisionLog(logInfo) {
        return $http.post(HOST + "/api/McApplicationVersion", logInfo);
    }

    function deleteRevisionLog(logInfo) {
        return $http.delete(HOST + "/api/McApplicationVersion?ID=" + logInfo.id);
    }

    return {
        GetList: GetList,
        patchData: patchData,
        saveRevisionLog: saveRevisionLog,
        deleteRevisionLog: deleteRevisionLog
    };
}

RevisionLogFactory.$inject = ['HOST', '$http'];

angular.module('mc.revision-log').factory('RevisionLogFactory', RevisionLogFactory);
'use strict';

angular.module('mc.revision-log').directive('ckeditor', ['RevisionLogFactory', '$timeout', function (RevisionLogFactory, $timeout) {
    return {
        restrict: "A",
        require: '?ngModel',
        scope: {
            logObject: '='
        },
        link: function link(scope, element, attrs, ngModel) {
            var editor, updateModel, patch, selectionChange, focusFunction;
            var inlineToolbar = [{ name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] }, { name: 'editing', items: ['RemoveFormat'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }];
            var inlineOptions = {
                toolbar: inlineToolbar
            };
            editor = CKEDITOR.inline(element[0], inlineOptions);
            if (!ngModel) {
                return;
            }
            editor.on('instanceReady', function () {
                return editor.setData(ngModel.$viewValue);
            });
            updateModel = function updateModel() {
                return scope.$apply(function () {
                    return ngModel.$setViewValue(editor.getData());
                });
            };
            selectionChange = function selectionChange() {
                return scope.$apply(function () {
                    return ngModel.$setViewValue(editor.getData());
                });
            };
            focusFunction = function focusFunction(event) {
                var topContainer = document.getElementById(event.editor.id + '_top');
                topContainer.style.display = '';
            };
            patch = function patch(event) {
                var data = event.editor.getData();
                var strObj = event.editor.element.$.attributes.logrecord.nodeValue;
                var selection = editor.getSelection();
                var selectedElement = selection.getSelectedElement();
                var jsonObj = JSON.parse(strObj);
                var topContainer = document.getElementById(event.editor.id + '_top');
                if (jsonObj.id == -1) {
                    topContainer.style.display = 'none';
                    return false;
                }
                var fieldName = event.editor.element.$.attributes.ckeditor.nodeValue;
                var patchObj = { "op": "replace", "path": fieldName, "value": data };
                topContainer.style.display = 'none';
                RevisionLogFactory.patchData(jsonObj, patchObj).then(function (resp) {
                    //Update logObject ID
                    if (resp.data.id > 0) {
                        scope.logObject.id = resp.data.id;
                    }
                    //else{ Add Toaster Message }
                });
            };

            editor.on('change', updateModel);
            editor.on('dataReady', updateModel);
            editor.on('key', updateModel);
            editor.on('paste', updateModel);
            editor.on('mouseup', updateModel);
            editor.on('mousedown', updateModel);
            editor.on('selectionChange', selectionChange);
            editor.on('blur', patch);
            editor.on('focus', focusFunction);
            return ngModel.$render = function () {
                return editor.setData(ngModel.$viewValue);
            };
        }
    };
}]);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RevisionLogController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, RevisionLogFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, $q, $uibModal, $cookies, savePdfService, unsavedChangesService) {
    var _this2 = this;

    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;
    $scope.trustAsHtml = $sce.trustAsHtml;
    ctrl.adminUser = $cookies.get('AdminUser1') != null ? true : false;
    ////////////////////////////////////////////////
    ////////////////////////////////////////////////
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        ctrl.goSelectReportData();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl._popup);

            ctrl._popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl._popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl._popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl._popup);
                    ctrl.adjustSize();
                }
            });

            // binding 'dialogbeforeclose' event to Check for unsaved Changes function
            $(ctrl._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, ctrl._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    ctrl.adjustSize = function () {
        var _tmpHeight = ctrl._popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl._popup.parent().css("height", _tmpHeight);
        ctrl._popup.parent().find('div:eq(2)').css("width", ctrl._popup.parent().css("width"));
        ctrl._popup.parent().find('div:eq(2)').css("min-width", ctrl._popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl._popup.parent().find('div:eq(2)').css("height", ctrl._popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl._popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl._popup.parent().find('div:eq(2)').css("min-height", ctrl._popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl._popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl._popup.parent().find('.tabular-data-container').css("height", ctrl._popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl._popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl._popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - ctrl._popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
    };

    ctrl.goSelectReportData = function () {
        ctrl.viewLoading = true;
        var tabPromise = $q.defer();

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        var numberOfDays = 90,
            varDateRangeStart,
            varDateRangeEnd,
            varDateRangeEndTmp;
        if (ctrl.stickyProperties.on === true) {
            ctrl.stickyProperties.on = false;
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
            varDateRangeEnd = ctrl.myDateRangeEnd;
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeStart = ctrl.myDateRangeStart;
            varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
        } else {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }

        RevisionLogFactory.GetList(1, varDateRangeStart, varDateRangeEnd, ctrl.accountInfo.timeZone).then(function (resp) {
            tabPromise.resolve();
            $timeout(function () {
                ctrl.viewLoading = false;
            });

            ctrl.viewLoading = true;
            ctrl.setEditMode();
            ctrl.revisionLog = resp.data;

            if (!ctrl.mobile && !ctrl.classicView) {
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                    dataMin: varDateRangeStart,
                    dataMax: varDateRangeEnd,
                    zoomMin: varDateRangeStart,
                    zoomMax: varDateRangeEnd,
                    windowId: ctrl.windowId
                });
            }
            ctrl.refreshAlerts();

            ctrl.viewLoading = false;
        }, function (resp) {
            console.log(resp);
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                0: { columnWidth: 150 },
                1: { columnWidth: 70 },
                2: { columnWidth: 425 },
                3: { columnWidth: 100 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    ctrl.refreshAlerts = function () {
        $scope.alerts = [];
        if (ctrl.revisionLog.length === 0) {
            var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(ctrl.revisionLog.startDate).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.revisionLog.endDate).format('MM/DD/YY, h:mm:ss a');
            $scope.alerts.push({
                msg: errorMessage,
                type: "info"
            });
        }
    };

    ctrl.refreshData = function () {
        ctrl.revisionLog = angular.copy(ctrl.revisionLog);
    };

    ctrl.setEditMode = function (index) {
        ctrl.readMode = null;
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = ctrl.editModeIndex === index ? null : index;
    };

    ctrl.addNewRevisionLog = function () {
        ctrl.readMode = null;

        $element.find("div[class^='tabular-data-container']").animate({
            scrollTop: 0
        }, 'slow');

        if (ctrl.addMode === -1) return false;

        ctrl.editModeIndex = 0;
        var utcDate = new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0];
        var newRevisionLog = {
            id: -1,
            applicationId: ctrl.revisionLog.length > 0 ? ctrl.revisionLog[0].applicationId : 1,
            createDate: utcDate,
            version: 0,
            versionActive: true,
            versionDescription: "",
            timeZone: ctrl.revisionLog.length > 0 ? ctrl.revisionLog[0].timeZone : "E"
        };
        ctrl.revisionLog.unshift(newRevisionLog);
        ctrl.refreshAlerts();
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveRevisionLog = function (item) {

        RevisionLogFactory.saveRevisionLog(item).then(function (resp) {

            $timeout(function () {
                ctrl.viewLoading = false;
            });

            ctrl.viewLoading = true;
            resp.data.createDate = resp.data.createDate.split('.')[0];
            ctrl.revisionLog[0] = resp.data;

            var startDate = ctrl.myDateRangeStart.setHours(0, 0, 0, 0);
            var endDate = ctrl.myDateRangeEnd.setHours(23, 59, 59, 999);

            if (!ctrl.mobile && !ctrl.classicView) {
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                    dataMin: startDate,
                    dataMax: endDate,
                    zoomMin: startDate,
                    zoomMax: endDate,
                    windowId: ctrl.windowId
                });
            }
            ctrl.refreshAlerts();

            ctrl.viewLoading = false;
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = null;
    };

    ctrl.cancelAddLog = function (destination) {
        ctrl.revisionLog.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = null;
    };

    ctrl.openCommonModal = function (item, deleteLog) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            var warningMessage = "You are about to permanently delete this log record into the system.";
            if (deleteLog) {
                this.tmpConfirmMessageA = warningMessage;
            } else {
                this.tmpConfirmMessageA = warningMessage;
            }
            this.tmpConfirmMessageB = this.translation.text.DELETE_ACCOUNT_MESSAGE_C;
            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                if (!deleteLog) {
                    var index = ctrl.logins.findIndex(function (l) {
                        return l.userId == item.userId;
                    });
                    ctrl.logins[index].administrator = true;
                }

                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            if (deleteLog) {
                RevisionLogFactory.deleteRevisionLog(item).then(function (resp) {
                    var index = ctrl.revisionLog.indexOf(item);
                    if (index !== -1) {
                        ctrl.revisionLog.splice(index, 1);
                    }
                    ctrl.addMode = null;
                    ctrl.editMode = null;
                });
            } else {

                var propertyName = 'administrator';
                ctrl.updateValue(item, propertyName);
            }
        });
    };

    ctrl.updateValue = function (item, propertyName) {

        var tmpServiceCustomerPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        RevisionLogFactory.patchData(item, tmpServiceCustomerPatch).then(function (resp) {
            ctrl.resp = resp;
        });
    };

    ctrl.editingTo = function (name) {
        _this2._prevName = name;
    };

    ctrl.patchData = function (item, propertyName) {

        if (item[propertyName] == _this2._prevName || item.id == -1) return false;

        if (!ctrl.validateData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName])) return false;

        var tmpServiceUserPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };

        ctrl.updateValue(item, propertyName);
    };

    ctrl.validateData = function (propertyName, value) {
        var versionValidationRegex = /^[0-9.,]+$/;
        switch (propertyName) {
            case "versionDescription":
                return value.length > 0;
            case "version":
                return versionValidationRegex.test(value);
            case "internalNote":
                return true;
            default:
                return false;
        }
    };
}

RevisionLogController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'RevisionLogFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', '$uibModal', '$cookies', 'savePdfService', 'unsavedChangesService'];
'use strict';

angular.module('mc.revision-log').component('revisionLog', {
    controller: RevisionLogController,
    templateUrl: 'ui/revisionlog/revision-log-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.rtu-migrate-settings", []);
"use strict";

function RtuMigrateSettingsFactory(HOST, $http) {

    var _rtuMigrateSettings = function _rtuMigrateSettings() {};

    _rtuMigrateSettings.prototype.migrateSettings = function (sourceDeviceId, targetDeviceId, migrateAnalogSettings, migrateDigitalSettings, migrateAnalogOutputSettings, migrateDigitalOutputSettings) {

        return $http.post(HOST + "/api/RtuMigrateSettings/MigrateSettings/" + "?sourceDeviceId=" + sourceDeviceId + "&targetDeviceId=" + targetDeviceId + "&migrateAnalogSettings=" + migrateAnalogSettings + "&migrateDigitalSettings=" + migrateDigitalSettings + "&migrateAnalogOutputSettings=" + migrateAnalogOutputSettings + "&migrateDigitalOutputSettings=" + migrateDigitalOutputSettings).then(function (response) {
            return response.data;
        });
    };

    return _rtuMigrateSettings;
}

RtuMigrateSettingsFactory.$inject = ['HOST', '$http'];

angular.module('mc.rtu-migrate-settings').factory('RtuMigrateSettingsFactory', RtuMigrateSettingsFactory);
"use strict";

function RtuMigrateSettingsController($rootScope, $scope, authenticationService, translationService, sharedSetupService, openViewService, RtuMigrateSettingsFactory, deviceMenuService, toaster) {
    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;

    ctrl.$onInit = function () {
        ctrl._rtuMigrateSettings = new RtuMigrateSettingsFactory();
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.customerId = ctrl.accountInfo.customerId;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.alerts = [];
        //--------------------------------------------------------------------------------------------------
        ctrl.loading = false;
        ctrl.isMissionManager = false;
        ctrl.reqRefresh = false;

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for   
        $scope.alerts = [];

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }
        ctrl.getDevices();
        ctrl.migrateRtuSettings = document.getElementById('migrateRtuSettings');
        ctrl.clearDropdown = document.getElementById('clearDropdown');
        ctrl.clearDropdown.disabled = true;

        ctrl.disableAnalogSettingsOption = false;
        ctrl.disableDigitalSettingsOption = false;
        ctrl.disableAnalogOutputSettingsOption = false;
        ctrl.disableDigitalOutputSettingsOption = false;
    };

    // Function to show the dropdown when Customer Name input/select button is clicked
    //const showDropdown = () => {
    //    ctrl.customerName.setAttribute("placeholder", "Search ..."); // once drowndown is seen input placeholder should display Filter
    //    const filter = ctrl.customerName.value.toLowerCase();
    //    const filteredOptions = ctrl.customersList.filter(function (option) { return option.name.toLowerCase().includes(filter) });
    //    ctrl.renderOptions(filteredOptions); // Render filtered options
    //}

    // Function to render options in the dropdown list
    //ctrl.renderOptions = (options) => {
    //    ctrl.customerNameDropdownList.innerHTML = ''; // Clear the existing options
    //    // Assigning customerId and name to optionElement for it to display value in
    //    options.forEach(option => {
    //        const optionElement = document.createElement('div');
    //        optionElement.classList.add('dropdownOption');
    //        if (option.customerId == ctrl.accountInfo.customerId) {
    //            optionElement.textContent = option.name;
    //            optionElement.id = option.customerId;
    //            //Graying out the Customer Name which login user is logged in from
    //            optionElement.style.color = "darkgrey";
    //            optionElement.style.cursor = "not-allowed";
    //        } else {
    //            optionElement.textContent = option.name;
    //            optionElement.id = option.customerId; // Store the ID in data attribute
    //            optionElement.onclick = function () {
    //                return ctrl.selectOption(option); // returning selected option on selecting value from dropdown
    //            };
    //        }
    //        ctrl.customerNameDropdownList.appendChild(optionElement); // adding each option in the dropdown list
    //    });
    //    ctrl.customerNameDropdownList.style.display = options.length ? 'block' : 'none';  // Show or hide dropdown based on options
    //}

    ctrl.getDevices = function () {
        ctrl.loading = true;
        deviceMenuService.getDeviceMenuList(ctrl.customerId).then(function (result) {
            ctrl.devices = result.data.devices;
            var tmp = [];
            for (var i = 0; i < ctrl.devices.length; i++) {
                tmp.push({
                    id: i,
                    label: ctrl.devices[i].name,
                    deviceId: ctrl.devices[i].deviceId,
                    deviceModel: ctrl.devices[i].deviceModel
                });
            }
            ctrl.sourceDevicesList = tmp.slice();
            ctrl.targetDevicesList = tmp.slice();
            ctrl.loading = false;
        }, function (error) {});
    };

    //Select Source Device
    ctrl.selectSourceDevice = function (sourceDevice) {
        ctrl.targetDevice = null;
        ctrl.clearDropdown.disabled = sourceDevice == null;

        ctrl.filterTargetDevicesList(sourceDevice);
        ctrl.configureSettingsForDevice(sourceDevice);
    };

    //filter target devices list
    ctrl.filterTargetDevicesList = function (sourceDevice) {
        if (sourceDevice == null) {
            ctrl.targetDevicesList = ctrl.sourceDevicesList.slice();
            return;
        }

        var modelCompatibility = {
            8: [8, 18, 19],
            9: [9, 18, 19]
        };

        var sourceModel = Number(sourceDevice.deviceModel);
        var allowedModels = modelCompatibility[sourceModel] || [sourceModel];

        ctrl.targetDevicesList = ctrl.sourceDevicesList.filter(function (device) {
            var targetModel = Number(device.deviceModel);

            return allowedModels.indexOf(targetModel) !== -1 && device.deviceId !== sourceDevice.deviceId;
        });
    };

    ctrl.setSettingsAvailability = function (availability) {
        availability = availability || {};

        ctrl.disableAnalogSettingsOption = !availability.analog;

        ctrl.disableDigitalSettingsOption = !availability.digital;

        ctrl.disableAnalogOutputSettingsOption = !availability.analogOutput;

        ctrl.disableDigitalOutputSettingsOption = !availability.digitalOutput;

        // Clear selections that are no longer available
        if (ctrl.disableAnalogSettingsOption) {
            ctrl.migrateAnalogSettings = false;
        }

        if (ctrl.disableDigitalSettingsOption) {
            ctrl.migrateDigitalSettings = false;
        }

        if (ctrl.disableAnalogOutputSettingsOption) {
            ctrl.migrateAnalogOutputSettings = false;
        }

        if (ctrl.disableDigitalOutputSettingsOption) {
            ctrl.migrateDigitalOutputSettings = false;
        }
    };

    ctrl.configureSettingsForDevice = function (selectedDevice) {
        if (!selectedDevice) {
            ctrl.setSettingsAvailability({});
            return;
        }

        switch (selectedDevice.deviceModel) {

            case 8:
            case 9:
            case 18:
            case 19:
                ctrl.setSettingsAvailability({
                    analog: true,
                    digital: true,
                    analogOutput: true,
                    digitalOutput: true
                });
                break;

            case 20:
                ctrl.setSettingsAvailability({
                    analog: false,
                    digital: true,
                    analogOutput: false,
                    digitalOutput: false
                });
                break;

            case 21:
                ctrl.setSettingsAvailability({
                    analog: true,
                    digital: true,
                    analogOutput: false,
                    digitalOutput: true
                });
                break;

            default:
                // Unknown models have no migration settings available
                ctrl.setSettingsAvailability({});
                break;
        }
    };

    ctrl.migrateSettings = function () {
        if (!ctrl.sourceDevice || !ctrl.targetDevice) {
            toaster.pop('warning', '', 'Please select a source and target RTU.');
            return;
        }

        var migrateAnalogSettings = !!ctrl.migrateAnalogSettings;

        var migrateDigitalSettings = !!ctrl.migrateDigitalSettings;

        var migrateAnalogOutputSettings = !!ctrl.migrateAnalogOutputSettings;

        var migrateDigitalOutputSettings = !!ctrl.migrateDigitalOutputSettings;

        if (!migrateAnalogSettings && !migrateDigitalSettings && !migrateAnalogOutputSettings && !migrateDigitalOutputSettings) {

            toaster.pop('warning', '', 'Please select at least one setting to migrate.');
            return;
        }

        ctrl.loading = true;

        return ctrl._rtuMigrateSettings.migrateSettings(ctrl.sourceDevice.deviceId, ctrl.targetDevice.deviceId, migrateAnalogSettings, migrateDigitalSettings, migrateAnalogOutputSettings, migrateDigitalOutputSettings).then(function (response) {
            toaster.pop('success', '', 'Settings migrated successfully.');

            ctrl.clearDropdownValues();
            ctrl.refreshData();

            return response;
        }).catch(function (error) {
            var message = error.data && error.data.message ? error.data.message : 'Unable to migrate settings.';

            toaster.pop('error', '', message);
        }).finally(function () {
            ctrl.loading = false;
        });
    };

    // Reset the view to its initial state
    ctrl.clearDropdownValues = function () {
        // Clear device selections
        ctrl.sourceDevice = null;
        ctrl.targetDevice = null;

        // Restore the complete target list
        ctrl.targetDevicesList = (ctrl.sourceDevicesList || []).slice();

        // Clear migration selections
        ctrl.migrateAnalogSettings = false;
        ctrl.migrateDigitalSettings = false;
        ctrl.migrateAnalogOutputSettings = false;
        ctrl.migrateDigitalOutputSettings = false;

        // Restore option availability
        ctrl.disableAnalogSettingsOption = false;
        ctrl.disableDigitalSettingsOption = false;
        ctrl.disableAnalogOutputSettingsOption = false;
        ctrl.disableDigitalOutputSettingsOption = false;

        // Restore button states        
        ctrl.clearDropdown.disabled = true;

        // Clear alerts
        ctrl.alerts = [];
        $scope.alerts = [];

        ctrl.setSettingsAvailability({});
    };

    ctrl.isMigrateSettingsDisabled = function () {
        var hasSourceAndTarget = !!ctrl.sourceDevice && !!ctrl.targetDevice;

        var hasSelectedSetting = !!ctrl.migrateAnalogSettings || !!ctrl.migrateDigitalSettings || !!ctrl.migrateAnalogOutputSettings || !!ctrl.migrateDigitalOutputSettings;

        return !hasSourceAndTarget || !hasSelectedSetting;
    };

    ctrl.refreshData = function () {
        //Update Device Menu
        deviceMenuService.resetDeviceMenuList();
        $rootScope.$broadcast('rtuBasicInfoUpdate');
    };

    //set timeout not needed as toaster.pop is being used
    // ctrl.setTimeOut = function () {
    //     setTimeout(function () {
    //         ctrl.alerts = [];
    //         $scope.alerts = [];
    //     }, 5000); // 5 Seconds
    // };

    //ctrl.clearSearchField = () => {
    //    ctrl.selectedCustomer = null; //Make value null so input field is empty
    //    ctrl.customerName.value = null; //Make value null so input field is empty
    //    ctrl.clearFilter = false; // once field is empty Clear Filter icon should hide
    //    ctrl.migrateRtuSettings.disabled = true; //disable Move RTU button when when Customer Name dropdown is empty
    //};

    //ctrl.filterOptions = () => {
    //    ctrl.customerName = document.getElementById('customerName'); //calling getElementById here instead of oninit because Customer Name dropdown is seen after selecting Device
    //    ctrl.customerNameDropdownList = document.getElementById('customerNameDropdownList'); //calling getElementById here instead of oninit because Customer Name dropdown is seen after selecting Device
    //    //After clicking clear filter icon the input field should open just like it is opened for first time
    //    ctrl.selectedCustomer = null;
    //    ctrl.customerName.value = null;
    //    ctrl.migrateRtuSettings.disabled = true; //disable Move RTU button when when Customer Name dropdown is empty

    //    //Call showDropdown() to show list once the input field is clicked
    //    ctrl.customerName.addEventListener('click', showDropdown);

    //    // Function to filter options based on search input
    //    ctrl.filterOption = (searchText) => {
    //        const filter = searchText.toLowerCase();
    //        const filteredOptions = ctrl.customersList.filter(function (option) {
    //            return option.name.toLowerCase().includes(filter)
    //        });
    //        ctrl.renderOptions(filteredOptions);
    //    }

    //    // Function to handle option selected from the dropdown
    //    ctrl.selectOption = (option) => {
    //        ctrl.customerName.value = option.name; // Set search input to selected option name
    //        ctrl.selectedCustomer = option; //assign option to ctrl.selectedCustomer
    //        ctrl.customerName.style.backgroundColor = "#f6ff95"; //set the color of the selected value
    //        ctrl.customerNameDropdownList.style.display = 'none'; // Hide dropdown after selection

    //        if (ctrl.selectedCustomer == null) {
    //            ctrl.migrateRtuSettings.disabled = true; //disable Move RTU button when when Customer Name dropdown is empty
    //        } else {
    //            ctrl.migrateRtuSettings.disabled = false; //enable Move RTU button when when Customer Name dropdown is not empty
    //        }
    //    }

    //    // Alternate way without using oninput by creating event listener to listen everytime we enter something in input box
    //    ctrl.customerName.addEventListener('input', () => {
    //        // Adding clear filter icon if length more than 0
    //        if (ctrl.customerName.value.length > 3) {
    //            ctrl.clearFilter = true; //Clear Filter icon should be visible if length exceeds 3
    //        } else {
    //            ctrl.clearFilter = false; //Clear Filter icon should not be visible if length is below 3
    //        }
    //        ctrl.filterOption(ctrl.customerName.value);
    //    });

    //    // Hide dropdown if clicked outside of the input and dropdown
    //    document.addEventListener('click', (e) => {
    //        if (!e.target.closest('#customerName') && !e.target.closest('#customerNameDropdownList')) {
    //            // Hide the dropdown and change the input placeholder when clicked outside without selecting value
    //            ctrl.customerNameDropdownList.style.display = 'none';
    //            ctrl.customerName.setAttribute("placeholder", "Select");
    //            ctrl.customerName.style.backgroundColor = "#f6ff95"
    //        }
    //    });
    //}

    $scope.$on("$destroy", function () {
        //ctrl.customerName.removeEventListener('click', showDropdown);
        document.removeEventListener('click', function (e) {
            if (!e.target.closest('#customerName') && !e.target.closest('#customerNameDropdownList')) {
                // Hide the dropdown and change the input placeholder when clicked outside without selecting value
                ctrl.customerNameDropdownList.style.display = 'none';
                ctrl.customerName.setAttribute("placeholder", "Select");
                ctrl.customerName.style.backgroundColor = "#f6ff95";
            }
        });
    });
}

RtuMigrateSettingsController.$inject = ['$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'RtuMigrateSettingsFactory', 'deviceMenuService', 'toaster'];
'use strict';

angular.module('mc.rtu-migrate-settings').component('rtuMigrateSettings', {
    controller: RtuMigrateSettingsController,
    templateUrl: 'ui/rtumigratesettings/rtu-migrate-settings-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.radio-upgrade', []);
'use strict';

function RadioUpgradeFactory(HOST, $http) {

    var _radioUpgrade = function _radioUpgrade() {
        var getSpares = false;
        var getStatus = false;
    };

    _radioUpgrade.prototype.ListRadioUpgradeDevicesByCustomerId = function (customerId, getSpares, getStatus, getNetworkOperator) {
        return $http({
            method: 'GET',
            url: HOST + '/api/DeviceStatus/GetSwappedOutDevices/',
            params: { customerId: customerId, getSpares: getSpares, getStatus: getStatus, getNetworkOperator: getNetworkOperator }
        });
    };

    return _radioUpgrade;
}

RadioUpgradeFactory.$inject = ['HOST', '$http'];

angular.module('mc.radio-upgrade').factory('RadioUpgradeFactory', RadioUpgradeFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RadioUpgradeController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, RadioUpgradeFactory, $uibModal, $location, deviceMenuService, timeLapseService, datetimeService, deviceNotificationSettingService, savePdfService, toaster, documentService) {
    var _this2 = this;

    var ctrl = this;
    var _customerId;
    ctrl.customerName = "";
    ctrl.swappedOutDevicesList = [];
    ctrl.shrinkUI = false;
    ctrl.loadingInProgress = false;
    ctrl.displaySpareRadioMessage = null;

    ctrl._radioUpgrade = null;
    ctrl.$onInit = function () {
        ctrl.displaySpareRadioMessage = null;
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this2);
        ctrl.adminPortal = sharedSetupService.adminPortal();
        ctrl.deviceTypes = [8, 9, 18, 19];
        $scope.downloadViewTypeOptions = [0, 2];
        ctrl._radioUpgrade = new RadioUpgradeFactory();
        if (_typeof(ctrl.stickyProperties) !== 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        _customerId = ctrl.stickyProperties.adminPortal.customerId || ctrl.accountInfo.customerId;
        ctrl.customerName = ctrl.accountInfo.customerName;
        ctrl.getSwappedOutDevicesList(_customerId);
        sharedSetupService.getWindowId($scope);
    };

    ctrl.getSwappedOutDevicesList = function (customerId) {
        ctrl.loadingInProgress = true;
        ctrl._radioUpgrade.ListRadioUpgradeDevicesByCustomerId(customerId, true, true, false).then(function (resp) {
            ctrl.swappedOutDevicesList = resp.data;
            ctrl.spareRadios = ctrl.swappedOutDevicesList.filter(function (f) {
                return f.isSpareRadio == true;
            });
            ctrl.RTUDevices = ctrl.swappedOutDevicesList.filter(function (f) {
                return f.isSpareRadio != true;
            });
            if (ctrl.RTUDevices.length == 0 && ctrl.spareRadios.length > 0) {
                ctrl.displaySpareRadioMessage = true;
            } else {
                ctrl.displaySpareRadioMessage = false;
            }
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.downloadDocument = function () {
        documentService.downloadFile(ctrl.accountInfo.customerId, 132, "RTU Upgrade Options - Updated 2/5/21").finally(function (resp) {
            ctrl.inProgressDownloadFile = false;
        });
    };
    $scope.mostRecentData = function () {
        ctrl.swappedOutDevicesList = [];
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.getSwappedOutDevicesList(_customerId);
    };

    $scope.savePdf = function () {

        var windowTitle = $scope.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: $scope.translation.text.DISABLED_INPUTS_REPORT,
            customerName: $scope.accountInfo.customerName,
            customerId: $scope.accountInfo.customerId,
            dateTranslate: $scope.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getDeviceStatusList(_customerId);
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });

    if (!ctrl.mobile && !ctrl.classicView) {
        ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
        sharedSetupService.maximize(ctrl.popup);

        $scope.adjustSize = function () {
            ctrl.adjustSize();
        };

        ctrl.popup.dialog({
            resize: function resize(event, ui) {
                ctrl.adjustSize();
            }
        });

        ctrl.popup.dialogExtend({
            maximize: function maximize(event, ui) {
                openViewService.adjustContentSizeStart(ctrl.popup);
                ctrl.adjustSize();
            },
            restore: function restore(event, ui) {
                openViewService.adjustContentSizeStart(ctrl.popup);
                ctrl.adjustSize();
            }
        });

        ctrl.adjustSize = function () {
            if (ctrl.shrinkUI === false && ctrl.popup.parent().width() < 725) {
                ctrl.shrinkUI = true;
            } else if (ctrl.shrinkUI === true && ctrl.popup.parent().width() >= 725) {
                ctrl.shrinkUI = false;
            }

            var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            ctrl.popup.parent().css("height", _tmpHeight);
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
            //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");

            //setting the height of data container for scrolling purpose
            var ht = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            var popupHt = parseInt(ht);
            //console.log("popup height: " + ht);
            ht = ctrl.popup.parent().find('.data-pane .multi-radio-msg').css("height").replace(/[^0-9.]+/g, "");
            //console.log("msg height: " + ht);
            var misc_height = parseInt(ht);
            ht = ctrl.popup.parent().find('.data-pane .headertable').css("height").replace(/[^0-9.]+/g, "");
            //console.log("header height: " + ht);
            misc_height += parseInt(ht);
            ht = ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "");
            //console.log("top-menu height: " + ht);
            misc_height += parseInt(ht);
            //console.log("total misc height: " + misc_height);
            //console.log("container height: " + (popupHt - misc_height));
            ctrl.popup.parent().find('.tabular-data-container').css("height", popupHt - misc_height - 37);
        };
    };
};

RadioUpgradeController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'RadioUpgradeFactory', '$uibModal', '$location', 'deviceMenuService', 'timeLapseService', 'datetimeService', 'deviceNotificationSettingService', 'savePdfService', 'toaster', 'documentService'];
'use strict';

angular.module('mc.radio-upgrade').component('radioUpgrade', {
    controller: RadioUpgradeController,
    templateUrl: 'ui/radioupgrade/radio-upgrade-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

function RuntimeRainfallMenuController($, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, openViewService, sharedSetupService, timeLapseService, Rainfall) {
    var _this2 = this;

    var ctrl = this;

    this.dynamicPopover = {
        templateUrl: 'myPopoverTemplate.html'
    };

    this.$onInit = function () {
        ctrl.translation = translationService.translation;
        _this2.windowId = _this2.windowId;
        $scope.windowId = _this2.windowId;
        _this2.checkedRainfall = _this2.windowId;
        updateViews();
        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            updateViews();
        });
    };

    var updateViews = function updateViews() {
        _this2.views = [{ "id": "Rainfall vs Runtime Table", "name": ctrl.translation.text.VS_RUNTIME_TABLE, "icon": "fa-table" }, { "id": "Rainfall vs Runtime Chart", "name": ctrl.translation.text.VS_RUNTIME_CHART, "icon": "fa-line-chart" }, { "id": "Rainfall vs Runtime Calendar", "name": ctrl.translation.text.VS_RUNTIME_CALENDAR, "icon": "fa-calendar-o" }];
    };

    this.setRainfallView = function (id, name) {
        if (id !== null && id !== this.checkedRainfall) {
            this.checkedRainfall = '';
            this.checkedRainfall = id;
            this.selected = id;
            this.viewSelected = id;
            var _popup = _this.getExistingDialog(this.windowId).ref;
            var _popupPosition = _popup.dialog("option", "position");
            var _popupWidth = _popup.dialog("option", "width");
            var _popupHeight = _popup.dialog("option", "height");

            var _popupSize = {};
            _popupSize.width = _popupWidth;
            _popupSize.height = _popupHeight;

            var _popupMinSize = {};
            _popupMinSize.minimumHeight = 500;
            _popupMinSize.minimumWidth = 600;

            openViewService.openView(id, _popupSize, _popupPosition, this.stickyProperties, _popupMinSize);
            _popup.dialog("close");
        } else {
            return false;
        }
    };
}

RuntimeRainfallMenuController.$inject = ['$', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'openViewService', 'sharedSetupService', 'timeLapseService', 'rainfallModel'];

angular.module('mc.rainfall').component('runtimeRainfallMenu', {
    controller: RuntimeRainfallMenuController,
    transclude: true,
    templateUrl: 'ui/rainfall/runtime-rainfall-menu.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<'
    }
});
mcapp.controller('rainfallTableController', ['$scope', '$rootScope', 'sharedSetupService', 'openViewService', 'translationService', 'timeLapseService', '$timeout', 'authenticationService', '$element',
    function ($scope, $rootScope, sharedSetupService, openViewService, translationService, timeLapseService, $timeout, authenticationService, $element) {
        $scope.myDate = null;
        $scope.qdpLeft = -237;
        $scope.infiniteScrollOn = false;
        $scope.infiniteScrollUpOn = false;
        $scope.infiniteScrollDownOn = false;
        $scope.checkFirstRowLiveStatus = null;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.unixDay = sharedSetupService.unixDay;
        $scope.liveDataOffset = sharedSetupService.liveDataOffset;
        $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.translation = translationService.translation;
        sharedSetupService.getWindowId($scope);
        $scope.alerts = [];
        $scope.downloadViewTypeOptions = [0];
        $scope.downloadOptions = { resolution: 0 }
        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);
        }

        $scope.windowTitle = eval("translationService.translation.text.AIRPORT_RAINFALL"); 

        $scope.liveTable = $element.find(".headertable");

        $scope.liveDataLine = function (varLiveData) {
            if (varLiveData) {
                $scope.liveTable.addClass("live-data-line");
            } else {
                $scope.liveTable.removeClass("live-data-line");
            }
        };

        $scope.setDevice = function (rainfallData) {
            //$scope.deviceId = rainfallData.deviceId;
            $scope.currentSelectedDevice = rainfallData;
            $scope.deviceId = rainfallData.deviceId;
            $scope.popup.dialog("option", "title", $scope.windowTitle + ", " + rainfallData.deviceName);
            //if ($scope.deviceId == 0) {
                $scope.GetRainA();
            //} else if ($scope.deviceId > 0) {
            //    $scope.GetRainB();
            //}

            //$scope.$broadcast('rainfallDeviceChanged', { data: rainfallData });
        }

        $scope.selectMyDate = function (date) {
            $scope.myDate = date;
            $scope.passedDate = ctrl.myDate;
            //if ($scope.deviceId == 0) {
                $scope.selectMyDateA();
            //} else if ($scope.deviceId > 0) {
            //    $scope.selectMyDateB();
            //}
        }

        //Get my icon based on my title
        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        //Change the title when the service changes the weather station name
        $scope.$watch('rainfallTableService.metarStationName', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue !== oldValue) {
                if (!$rootScope.mobile && !$rootScope.classicView)
                    $scope.popup.dialog("option", "title", $scope.windowTitle + ", " + newValue);
            }
        }, true);

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                	$scope.adjustSize();
                },
                restore: function (event, ui) {
					openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                //$scope.adjustDeviceIdMenuSize();
            };

            $scope.adjustDeviceIdMenuSize = function () {
                var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                if (spph < 450) {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
                }
                else {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
                }
            };


        }
    }]);

mcapp.directive('drawRainfallData', ['$timeout', 'rainfallTableService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService',
 function ($timeout, rainfallTableService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService) {
     // return the directive link function. (compile function not needed)
     return function (scope, element, attrs) {

         //Init
         var pollInterval = 60;  //poll interval seconds = pollInterval/15
         var currentScrollbarPosition = 0;
         var previousScrollbarPosition = 0;
         if (typeof scope.stickyProperties != 'object') scope.stickyProperties = scope.stickyPropertiesInterface;
         var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
         scope.checkFirstRowLiveStatus = null;
         paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

         //dateAgentText filter called from html
         scope.dateAgentText = function (date, timeFormat) {
             return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
         }

         //Handle infinite scrolling
         element.on('scroll', function (event) {
             var $rowFirst = element.contents().find("tr:first");
             var $rowLast = element.contents().find("tr:last");
             if (typeof $rowFirst.position() !== "undefined") {
                 scope.infiniteScrollOn = true;
                 scope.infiniteScrollUpOn = true;
                 scope.infiniteScrollDownOn = true;
                 scope.calculateLiveDataStatus();
                 previousScrollbarPosition = currentScrollbarPosition;
                 currentScrollbarPosition = element[0].scrollTop;
             }

             if (scope.infiniteScrollOn === true) {
                 scope.infiniteScrollUpOn = true;
                 scope.infiniteScrollDownOn = true;

                 if (currentScrollbarPosition <= 35 && previousScrollbarPosition > 35)
                     scope.checkFirstRowLiveStatus = null;

                 if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
                     $rowLast.addClass("active-row");
                     scope.rainfallTableService.alerts = [];
                     scope.rainfallTableService.NextPage();
                 }
                 if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
                     $rowFirst.addClass("active-row");
                     scope.rainfallTableService.alerts = [];
                     scope.rainfallTableService.PreviousPage();
                 }
             }

             var rows = element.children().children().children().children();
             var scrollpos = 40;
             var start = 0;
             var end = rows.length;
             var count = 0;

             while (start != end) {
                 count++;
                 var mid = start + Math.floor((end - start) / 2);
                 if ($(rows[mid]).position().top < scrollpos)
                     start = mid + 1;
                 else
                     end = mid;
             }
             _updateZoom(parseFloat($($(rows[start])).attr("name")));
             //console.log("scope.stickyProperties: " +
             //    "currRow: " + new Date(parseFloat($($(rows[start])).attr("name"))).toLocaleString() + ", " +
             //    "dateMin: " + new Date(scope.stickyProperties.dateMin).toLocaleString() + ", " +
             //    "dateMax: " + new Date(scope.stickyProperties.dateMax).toLocaleString() + ", " +
             //    "zoomMin: " + new Date(scope.stickyProperties.zoomMin).toLocaleString() + ", " +
             //    "zoomMax: " + new Date(scope.stickyProperties.zoomMax).toLocaleString());
         });

         //Toggle the active row when user clicks
         scope.toggle = function ($event) {
             if ($($event.currentTarget).hasClass("active-row")) {
                 $($event.currentTarget).removeClass("active-row");
             } else {
                 $($event.currentTarget).addClass("active-row");
             }
         };

         //Call me when the user changes the date
         scope.selectMyDateA = function () {
             scope.rainfallTableService = new rainfallTableService();
             currentScrollbarPosition = 0;
             previousScrollbarPosition = 0;

             scope.checkFirstRowLiveStatus = null;
             scope.setLiveDataStatus(false);


             var tmpDates = scope.passedDate;//scope.myDate;
             var tmpDatesA = tmpDates;
             tmpDates.setHours(0, 0, 0, 0);
             tmpDates = datetimeService.dateToUnixtime(tmpDates);
             tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
             tmpDatesA.setHours(12, 0, 0, 0);
             tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
             scope.rainfallTableService.start = tmpDates.startDate;
             if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                 scope.rainfallTableService.end = tmpDatesA;
             } else {
                 scope.rainfallTableService.end = tmpDates.endDate;
             }
             scope.rainfallTableService.startRow = 1;
             scope.rainfallTableService.pageSize = 50;
             scope.rainfallTableService.customerId = scope.accountInfo.customerId;
             scope.rainfallTableService.deviceId = scope.deviceId;//scope.metarStationSelected;
             scope.rainfallTableService.windowTitle = scope.windowTitle;
             scope.alerts = [];
             scope.rainfallTableService.temperatureUnit = scope.accountInfo.preferenceUser.lookupMeasurementID;
             scope.rainfallTableService.rainfallUnit = scope.accountInfo.preferenceUser.lookupMeasurementID;
             scope.rainfallTableService.timeFormat = scope.accountInfo.preferenceUser.timeFormat;
             scope.rainfallTableService.NextPage();

             sharedSetupService.setStickyProperties(scope.stickyProperties,
             {
                 deviceId: scope.deviceId,
                 dataMin: tmpDates.startDate,
                 dataMax: tmpDates.endDate,
                 zoomMin: (tmpDates.startDate + scope.unixDay),
                 zoomMax: (tmpDates.endDate - scope.unixDay),
                 windowId: scope.windowId
             });
         };

         //Blink the light when data received
         scope.$watch('rainfallTableService.lastUpdateAt', function (newValue, oldValue) {
             if (newValue && newValue !== oldValue) {
                 scope.lastUpdateAt = newValue;
                 scope.liveDataIn = !scope.liveDataIn;
                 $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
             }
         }, true);

         //Listen for alerts
         scope.$watch('rainfallTableService.alerts', function (newValue, oldValue) {
             if (newValue && newValue.length > 0 && newValue !== oldValue) {
                 scope.alerts = newValue;
             }
         }, true);

         //Listen for DeviceID change
         //scope.$watch('deviceId', function (newValue, oldValue) {
         //    if (scope.deviceId == 0 && newValue && newValue !== oldValue) {
         //        scope.selectMyDateA();
         //    }
         //}, true);

         //Handle Preferences:Weather station was changed
         scope.$on('updatePreferenceWeather', function (event, args) {
             currentScrollbarPosition = 0;
             previousScrollbarPosition = 0;
             scope.checkFirstRowLiveStatus = null;
             scope.rainfallTableService.items = [];
             scope.rainfallTableService.startRow = 1;
             scope.rainfallTableService.pageSize = 50;
             scope.alerts = [];
             scope.rainfallTableService.start = scope.stickyProperties.zoomMin;
             scope.rainfallTableService.end = scope.stickyProperties.zoomMax;
             scope.rainfallTableService.Reload();
         });

         //Handle Preferences:MeasurementSystem changed
         scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
             //ToDo: put these in some common place
             scope.MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
             scope.RainfallUnitEnum = { Inches: 1, Centimeters: 2 };
             scope.TemperatureUnitEnum = { Fahrenheit: 1, Celsius: 2 };

             switch (measurementSystem) {
                 case scope.MeasurementSystemEnum.Imperial:
                     scope.rainfallTableService.rainfallUnit = scope.RainfallUnitEnum.Inches;
                     scope.rainfallTableService.temperatureUnit = scope.TemperatureUnitEnum.Fahrenheit;
                     break;
                 case scope.MeasurementSystemEnum.Metric:
                     scope.rainfallTableService.rainfallUnit = scope.RainfallUnitEnum.Centimeters;
                     scope.rainfallTableService.temperatureUnit = scope.TemperatureUnitEnum.Celsius;
                     break;
             }
         });

         //Handle Preferences:TimeFormat (12/24) changed
         scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
             scope.rainfallTableService.timeFormat = timeFormat;
         });

         scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
             if (scope.alerts.length > 0) {
                 var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
                 var _type = scope.alerts[0].type;
                 var _languageCode = scope.alerts[0].languageCode;
                 if (_languageCode.toUpperCase() === 'NO_DATA') {
                     _msg += ': ' + moment(scope.rainfallTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.rainfallTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                 }
                 scope.alerts = [];
                 scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
             }
         });

         //Scroll to the right place after the table is finished drawing
         scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
             _autoScroll();
             scope.checkFirstRowLiveStatus = null;
         });

         //Clean up when dialog is closed
         scope.$on("$destroy", function () {
             scope.setLiveDataStatus(false);
         });

         // remember where I'm scrolled to in StickyProps, for use when switching to chart
         var _updateZoom = function (currentRow) {
             if (isNaN(currentRow))
                 return;

             var zoomMin = currentRow - paddingZoom;
             var zoomMax = currentRow + paddingZoom;

             var dateMin = scope.stickyProperties.dateMin;
             var dateMax = scope.stickyProperties.dateMax;

             if (zoomMin < scope.stickyProperties.dateMin) {
                 dateMin = zoomMin;
             }
             if (zoomMax > scope.stickyProperties.dateMax) {
                 dateMax = zoomMax;
             }

             sharedSetupService.setStickyProperties(scope.stickyProperties,
             {
                 dataMin: dateMin,
                 dataMax: dateMax,
                 zoomMin: zoomMin,
                 zoomMax: zoomMax,
                 windowId: scope.windowId
             });

         };

         // Only enable live data if the top visible row is within the past 24 hours

         //Look for new data
         var tlGetNewRainfallData = function () {
             //console.log('Polling');
             scope.rainfallTableService.Poll();
         };

         scope.calculateLiveDataStatus = function () {
             if (scope.checkFirstRowLiveStatus === false) return;
             var $rowFirst = element.contents().find("tr:first");
             if (typeof $rowFirst.position() == "undefined") return;
             var firstRowTicks = parseFloat($rowFirst.attr("name"));
             var topOffset = $rowFirst.position().top;
             if (scope.checkFirstRowLiveStatus === true) {
                 scope.setLiveDataStatus((topOffset > 35));
                 return;
             }
             timeLapseService.getLocalDateTime().then(function (result) {
                 scope.setLiveDataStatus((firstRowTicks + scope.liveDataOffset >= result.data.unixTimeStamp) && (topOffset > 35));
             });
         };

         scope.setLiveDataStatus = function (isEnable) {
             if (scope.liveData === isEnable) return;
             scope.liveData = isEnable;
             scope.checkFirstRowLiveStatus = scope.liveData;
             scope.liveDataLine(scope.liveData);
             if (scope.liveData) {
                 sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
                 timeLapseService.register("RainfallListener", 0, "", tlGetNewRainfallData, pollInterval);
             } else {
                 sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                 timeLapseService.unRegister("RainfallListener", 0, "", tlGetNewRainfallData, pollInterval);
             }
         }
         //Initialize the scroll position after the data are first loaded
         var _autoScroll = function () {
             if (scope.rainfallTableService.numberOfNewRecordsPrevious > 0) {
                 var trRow = element.find('tr').eq(scope.rainfallTableService.numberOfNewRecordsPrevious - 1);
                 var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
                 element.scrollTop(yPosition);
             }
             else {
                 $timeout(function () {
                     element.animate({
                         scrollTop: 5
                     }, 500);
                 }, 0);
             }
         };

         var addDays = function (date, days) {
             return new Date(date.valueOf() + (days * 86400000));
         };

         //Get Data and draw
         scope.GetRainA = function () {
             //scope.popup.dialog("option", "title", scope.windowTitle + ", " + scope.currentSelectedDevice.deviceName);
             currentScrollbarPosition = 0;
             previousScrollbarPosition = 0;
             scope.checkFirstRowLiveStatus = null;
             scope.rainfallTableService = new rainfallTableService();
             scope.rainfallTableService.customerId = scope.accountInfo.customerId;
             scope.rainfallTableService.deviceId = scope.deviceId;

             scope.rainfallTableService.windowTitle = scope.windowTitle;
             scope.rainfallTableService.startRow = 1;
             scope.rainfallTableService.pageSize = 50;
             scope.alerts = [];

             if (scope.stickyProperties.dateMin && scope.stickyProperties.dateMax) {
                 scope.rainfallTableService.start = scope.stickyProperties.dateMin;
                 scope.rainfallTableService.end = scope.stickyProperties.dateMax;
                 scope.rainfallTableService.Reload();
             } else {
                 scope.stickyProperties.on = false;
                 timeLapseService.getLocalDateTime()
                     .then(function (result) {
                         var endDate = new Date(result.data.localDateTime).setHours(4, 0, 0, 0);
                         endDate = addDays(endDate, 1);
                         var startDate = addDays(endDate, -3);
                         scope.rainfallTableService.start = datetimeService.dateToUnixtime(startDate);
                         scope.rainfallTableService.end = datetimeService.dateToUnixtime(endDate);
                         scope.rainfallTableService.Reload();
                     });
             }

             scope.rainfallTableService.temperatureUnit = scope.accountInfo.preferenceUser.lookupMeasurementID;
             scope.rainfallTableService.rainfallUnit = scope.accountInfo.preferenceUser.lookupMeasurementID;
             scope.rainfallTableService.timeFormat = scope.accountInfo.preferenceUser.timeFormat;
         };


         scope.GetRainA();


     };
 }]);

mcapp.factory('rainfallTableService', ['$http', 'datetimeService', 'translationService', 'HOST',
    function ($http, datetimeService, translationService, host) {
        var rainfallTableService = function () {
            this.items = [];
            this.setting = [];
            this.metarStationName = 'loading...';
            this.customerId = null;
            this.temperatureUnit = 1;
            this.rainfallUnit = 1;
            this.timeFormat = 1;
            this.startRow = 1;
            this.pageSize = 50;
            this.start = '19000101';
            this.end = '19000101';
            this.busy = false;
            this.numberOfReturnedRecords = -1;
            this.numberOfNewRecordsPrevious = -1;
            this.tdWidth = null;
            this.alerts = [];
            this.translation = translationService.translation;
            this.lastUpdateAt = null;
        };

        rainfallTableService.prototype.Poll = function () {
            this.LoadData(-this.pageSize, true);
        };

        rainfallTableService.prototype.PreviousPage = function () {
            this.LoadData(-this.pageSize);
        };

        rainfallTableService.prototype.NextPage = function () {
            this.LoadData(this.pageSize);
        };

        rainfallTableService.prototype.Reload = function () {
            this.items = [];
            this.alerts = [];
            this.startRow = 1;
            this.LoadData(this.pageSize);
        };

        rainfallTableService.prototype.LoadData = function (pageSize, blinkTheLight) {
            this.pageSize = pageSize;
            if (this.busy) return;
            this.busy = true;
            var url = '';
            if (!angular.isDefined(this.deviceId)) return;

            if (this.deviceId === 0) {
                url = host + "/api/MetarRainfallTable" +
                    "?customerId=" + this.customerId +
                    "&StartRow=" + this.startRow +
                    "&PageSize=" + this.pageSize +
                    "&StartDate=" + this.start +
                    "&EndDate=" + this.end;
            } else if (this.deviceId > 0) {
                url = host + "/api/MetarRainfallTable" +
                    "?deviceId=" + this.deviceId +
                    "&StartRow=" + this.startRow +
                    "&PageSize=" + this.pageSize +
                    "&StartDate=" + this.start +
                    "&EndDate=" + this.end;
            }

            $http.get(url).then(function (result) {
                //console.log('Request:');
                //console.log('   start: [' + this.start + ']' + new Date(this.start));
                //console.log('   end:   [' + this.end + ']' + new Date(this.end));

                this.numberOfReturnedRecords = result.data.reports.length;

                if (this.startRow === 1)
                    this.startRow = result.data.reports.length;
                else
                    this.startRow = this.startRow + result.data.reports.length;

                if (this.deviceId === 0) {
                    this.metarStationName = _formatMetarStationName(result.data.metarStation);
                }
                //add new records to the beginning or end:
                if (pageSize > 0) this.items = this.items.concat(result.data.reports);
                if (pageSize < 0) this.items = result.data.reports.reverse().concat(this.items);
                this.numberOfRecords = this.items.length;

                //Get the first and last date, so I know how to get prev/next records in the future
                if (this.numberOfRecords > 0) {
                    this.start = _getFirstDate(this.items);
                    this.end = _getLastDate(this.items);
                }

                //if (result.data.reports && result.data.reports.length > 0) {
                //    console.log('Response');
                //    console.log('   result.data.reports.length:' + result.data.reports.length);
                //    console.log('   First: [' + this.start + ']' + new Date(this.start));
                //    console.log('   Last:  [' + this.end + ']' + new Date(this.end));
                //}

                if (this.numberOfReturnedRecords > 0 && blinkTheLight)
                    this.lastUpdateAt = this.items[0].localDateTime;

                //Make toast if next page has no result
                if (this.numberOfReturnedRecords === 0 && pageSize > 0) {
                    // If we didn't get any items back AND there aren't already any items
                    if (this.items.length === 0) {
                        this.alerts = [];
                        var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                        this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                    }
                }
                this.pageSize = 50;
                this.busy = false;
            }.bind(this), function (error) {
                this.alerts = [];
                var errorMessage = eval("this.translation.message." + error.data.message);
                this.alerts.push({
                    msg: errorMessage, type: "danger"
                });
                this.pageSize = 50;
                this.busy = false;
            }.bind(this));
        }

        var _getFirstDate = function (array) {
            var intDayWindow = 10;
            var intDay = 86400000;
            return datetimeService.toUnixtime(array[array.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
        };

        var _getLastDate = function (array) {
            return datetimeService.toUnixtime(array[0].localDateTime.replace(/\D/g, ''));
        };

        var _formatMetarStationName = function (metarStation) {
            var result = '';
            if (metarStation.city.length > 0) result += metarStation.city;
            if (metarStation.state.length > 0 && result.length > 0) result += ', ';
            if (metarStation.state.length > 0) result += metarStation.state;
            if (metarStation.icao.length > 0) result += ' (' + metarStation.icao + ')';
            return result;
        }

        return rainfallTableService;
    }]);

'use strict';

function RainfallMenuController($, $scope, $filter, $timeout, authenticationService, translationService, datetimeService, openViewService, sharedSetupService, timeLapseService, Rainfall) {
    var _this2 = this;

    this.dynamicPopover = {
        templateUrl: 'myPopoverTemplate.html'
    };

    this.$onInit = function () {
        _this2.translation = translationService.translation;
        _this2.windowId = _this2.windowId;
        $scope.windowId = _this2.windowId;
        _this2.checkedRainfall = _this2.windowId;
        updateViews();
        //this.views = [
        //    //{ "id": "Rainfall Table", "name": this.translation.text.TABLE, "icon": "fa-table" },
        //    //{ "id": "Rainfall Chart", "name": this.translation.text.CHART, "icon": "fa-line-chart" },
        //    //{ "id": "Rainfall Calendar", "name": this.translation.text.CALENDAR, "icon": "fa-calendar-o" },
        //    //TODO: delete above 3 lines later and update the names appropriately
        //    //{ "id": "Rainfall Data Table", "name": "[Rainfall Data Table]", "icon": "fa-table" },
        //    //{ "id": "Rainfall Data Chart", "name": "[Rainfall Data Chart]", "icon": "fa-line-chart" },
        //    //{ "id": "Rainfall Data Calendar", "name": "[Rainfall Data Calendar]", "icon": "fa-calendar-o" }
        //    { "id": "Rainfall Data Table", "name": this.translation.text.RAINFALL_DATA_TABLE, "icon": "fa-table" },
        //    { "id": "Rainfall Data Chart", "name": this.translation.text.RAINFALL_DATA_CHART, "icon": "fa-line-chart" },
        //    { "id": "Rainfall Data Calendar", "name": this.translation.text.RAINFALL_DATA_CALENDAR, "icon": "fa-calendar-o" }
        //];

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            updateViews();
        });
    };

    var updateViews = function updateViews() {
        _this2.views = [{ "id": "Rainfall Data Table", "name": _this2.translation.text.TABLE, "icon": "fa-table" }, { "id": "Rainfall Data Chart", "name": _this2.translation.text.CHART, "icon": "fa-line-chart" }, { "id": "Rainfall Data Calendar", "name": _this2.translation.text.CALENDAR, "icon": "fa-calendar-o" }];
    };

    this.setRainfallView = function (id, name) {
        if (id !== null && id !== this.checkedRainfall) {
            this.checkedRainfall = '';
            this.checkedRainfall = id;
            this.selected = id;
            this.viewSelected = id;
            var _popup = _this.getExistingDialog(this.windowId).ref;
            var _popupPosition = _popup.dialog("option", "position");
            var _popupWidth = _popup.dialog("option", "width");
            var _popupHeight = _popup.dialog("option", "height");

            var _popupSize = {};
            _popupSize.width = _popupWidth;
            _popupSize.height = _popupHeight;

            var _popupMinSize = {};
            _popupMinSize.minimumHeight = 500;
            _popupMinSize.minimumWidth = 600;

            openViewService.openView(id, _popupSize, _popupPosition, this.stickyProperties, _popupMinSize);
            _popup.dialog("close");
        } else {
            return false;
        }
    };
}

RainfallMenuController.$inject = ['$', '$scope', '$filter', '$timeout', 'authenticationService', 'translationService', 'datetimeService', 'openViewService', 'sharedSetupService', 'timeLapseService', 'rainfallModel'];

angular.module('mc.rainfall').component('rainfallMenu', {
    controller: RainfallMenuController,
    transclude: true,
    templateUrl: 'ui/rainfall/rainfall-menu.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<'
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RainfallDevicesMenuController($, $scope, authenticationService, translationService, Rainfall, deviceMenuService, sharedSetupService) {
    var _this = this;

    var ctrl = this;
    this.$onInit = function () {
        _this.translation = translationService.translation;
        _this.windowId = _this.windowId;
        $scope.windowId = _this.windowId;
        _this.accountInfo = authenticationService.getAccountInfo();
        deviceMenuService.resetRainfallDeviceMenuList(); //clear the list before making call.
        ctrl.dynamicPopover = { templateUrl: 'rainfallDeviceSelectionTemplate.html' };
        ctrl.showMenu = false;

        if (_this.rainfall == "true") {
            deviceMenuService.getRainfallDeviceMenuList(_this.accountInfo.customerId).then(function (result) {
                //ctrl.devices = [];
                //ctrl.devices.push(result.data[0]);
                ctrl.devices = result.data;
                ctrl.currentSelectedDevice = ctrl.devices[0];

                if (_typeof($scope.stickyProperties) != 'object') $scope.stickyProperties = sharedSetupService.stickyPropertiesInterface;

                //if deviceId is not set earlier
                if (!$scope.stickyProperties.deviceId) {
                    //Assuming atleast Airport station will be returned as part of RainfallDevices list.
                    //$scope.stickyProperties.deviceId = ctrl.currentSelectedDevice.deviceId;
                    $scope.deviceId = ctrl.currentSelectedDevice.deviceId;
                } else if (!!$scope.stickyProperties.deviceId) {
                    $scope.deviceId = $scope.stickyProperties.deviceId;
                    for (var idx = 0; idx < ctrl.devices.length; idx++) {
                        if (ctrl.devices[idx].deviceId == $scope.deviceId) {
                            ctrl.currentSelectedDevice = ctrl.devices[idx];
                        }
                    }
                }
                ctrl.callback(ctrl.currentSelectedDevice);
            }, function (error) {
                console.log(error);
            });
        } else {
            deviceMenuService.getRAllDevicesRainfallMenuList(_this.accountInfo.customerId).then(function (result) {
                //ctrl.devices = [];
                //ctrl.devices.push(result.data[0]);
                ctrl.devices = result.data;

                ctrl.currentSelectedDevice = ctrl.devices[0];

                if (_typeof($scope.stickyProperties) != 'object') $scope.stickyProperties = sharedSetupService.stickyPropertiesInterface;

                //if deviceId is not set earlier
                if (!$scope.stickyProperties.deviceId) {
                    //Assuming atleast Airport station will be returned as part of RainfallDevices list.
                    //$scope.stickyProperties.deviceId = ctrl.currentSelectedDevice.deviceId;
                    $scope.deviceId = ctrl.currentSelectedDevice.deviceId;
                } else if (!!$scope.stickyProperties.deviceId) {
                    $scope.deviceId = $scope.stickyProperties.deviceId;
                    for (var idx = 0; idx < ctrl.devices.length; idx++) {
                        if (ctrl.devices[idx].deviceId == $scope.deviceId) {
                            ctrl.currentSelectedDevice = ctrl.devices[idx];
                        }
                    }
                }
                ctrl.callback(ctrl.currentSelectedDevice);
            }, function (error) {
                console.log(error);
            });
        }
    };
}

RainfallDevicesMenuController.$inject = ['$', '$scope', 'authenticationService', 'translationService', 'rainfallModel', 'deviceMenuService', 'sharedSetupService'];

mcapp.component('rainfallDevicesMenu', {
    controller: RainfallDevicesMenuController,
    transclude: true,
    templateUrl: 'ui/rainfall/rainfall-devices-menu.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<',
        callback: '=',
        rainfall: '@'
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

mcapp.directive('drawDeviceRainfallData', ['$timeout', 'deviceRainfallTableService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', function ($timeout, deviceRainfallTableService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {

        //Init
        var pollInterval = 60; //poll interval seconds = pollInterval/15
        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        if (_typeof(scope.stickyProperties) != 'object') scope.stickyProperties = scope.stickyPropertiesInterface;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        scope.checkFirstRowLiveStatus = null;
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        //dateAgentText filter called from html
        scope.dateAgentText = function (date, timeFormat) {
            return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
        };

        //Handle infinite scrolling
        element.on('scroll', function (event) {
            var $rowFirst = element.contents().find("tr:first");
            var $rowLast = element.contents().find("tr:last");
            if (typeof $rowFirst.position() !== "undefined") {
                scope.infiniteScrollOn = true;
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;
                scope.calculateLiveDataStatus();
                previousScrollbarPosition = currentScrollbarPosition;
                currentScrollbarPosition = element[0].scrollTop;
            }

            if (scope.infiniteScrollOn === true) {
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;

                if (currentScrollbarPosition <= 35 && previousScrollbarPosition > 35) scope.checkFirstRowLiveStatus = null;

                if (scope.infiniteScrollDownOn === true && element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight) {
                    $rowLast.addClass("active-row");
                    scope.deviceRainfallTableService.alerts = [];
                    scope.deviceRainfallTableService.NextPage();
                }
                if (scope.infiniteScrollUpOn === true && element[0].scrollTop < 5 && currentScrollbarPosition < previousScrollbarPosition) {
                    $rowFirst.addClass("active-row");
                    scope.deviceRainfallTableService.alerts = [];
                    scope.deviceRainfallTableService.PreviousPage();
                }
            }

            var rows = element.children().children().children().children();
            var scrollpos = 40;
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
            }
            _updateZoom(parseFloat($($(rows[start])).attr("name")));
            //console.log("scope.stickyProperties: " +
            //    "currRow: " + new Date(parseFloat($($(rows[start])).attr("name"))).toLocaleString() + ", " +
            //    "dateMin: " + new Date(scope.stickyProperties.dateMin).toLocaleString() + ", " +
            //    "dateMax: " + new Date(scope.stickyProperties.dateMax).toLocaleString() + ", " +
            //    "zoomMin: " + new Date(scope.stickyProperties.zoomMin).toLocaleString() + ", " +
            //    "zoomMax: " + new Date(scope.stickyProperties.zoomMax).toLocaleString());
        });

        //Toggle the active row when user clicks
        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            } else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        //Call me when the user changes the date
        scope.selectMyDateB = function () {
            scope.deviceRainfallTableService = new deviceRainfallTableService();
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;

            scope.checkFirstRowLiveStatus = null;
            scope.setLiveDataStatus(false);

            var tmpDates = scope.passedDate; //scope.myDate;
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 10);
            tmpDatesA.setHours(12, 0, 0, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            scope.deviceRainfallTableService.start = tmpDates.startDate;
            if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                scope.deviceRainfallTableService.end = tmpDatesA;
            } else {
                scope.deviceRainfallTableService.end = tmpDates.endDate;
            }
            scope.deviceRainfallTableService.startRow = 1;
            scope.deviceRainfallTableService.pageSize = 50;
            scope.deviceRainfallTableService.customerId = scope.accountInfo.customerId;
            scope.deviceRainfallTableService.deviceId = scope.deviceId; //scope.metarStationSelected;
            scope.deviceRainfallTableService.windowTitle = scope.windowTitle;
            scope.alerts = [];
            scope.deviceRainfallTableService.temperatureUnit = scope.accountInfo.preferenceUser.lookupMeasurementID;
            scope.deviceRainfallTableService.rainfallUnit = scope.accountInfo.preferenceUser.lookupMeasurementID;
            scope.deviceRainfallTableService.timeFormat = scope.accountInfo.preferenceUser.timeFormat;
            scope.deviceRainfallTableService.NextPage();

            sharedSetupService.setStickyProperties(scope.stickyProperties, {
                deviceId: scope.deviceId, //scope.metarStationSelected,
                dataMin: tmpDates.startDate,
                dataMax: tmpDates.endDate,
                zoomMin: tmpDates.startDate + scope.unixDay,
                zoomMax: tmpDates.endDate - scope.unixDay,
                windowId: scope.windowId
            });
        };

        //Blink the light when data received
        scope.$watch('deviceRainfallTableService.lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                scope.lastUpdateAt = newValue;
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () {
                    scope.liveDataIn = !scope.liveDataIn;
                }, 3000);
            }
        }, true);

        //Listen for alerts
        scope.$watch('deviceRainfallTableService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue !== oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        //Listen for DeviceID change
        //scope.$watch('deviceId', function (newValue, oldValue) {
        //    if (scope.deviceId > 0 && newValue && newValue !== oldValue) {
        //        scope.selectMyDateB();
        //    }
        //}, true);

        //Handle Preferences:Weather station was changed
        scope.$on('updatePreferenceWeather', function (event, args) {
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            scope.deviceRainfallTableService.items = [];
            scope.deviceRainfallTableService.startRow = 1;
            scope.deviceRainfallTableService.pageSize = 50;
            scope.alerts = [];
            scope.deviceRainfallTableService.start = scope.stickyProperties.zoomMin;
            scope.deviceRainfallTableService.end = scope.stickyProperties.zoomMax;
            scope.deviceRainfallTableService.Reload();
        });

        //Handle Preferences:MeasurementSystem changed
        scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            //ToDo: put these in some common place
            scope.MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
            scope.RainfallUnitEnum = { Inches: 1, Centimeters: 2 };
            scope.TemperatureUnitEnum = { Fahrenheit: 1, Celsius: 2 };

            switch (measurementSystem) {
                case scope.MeasurementSystemEnum.Imperial:
                    scope.deviceRainfallTableService.rainfallUnit = scope.RainfallUnitEnum.Inches;
                    //scope.deviceRainfallTableService.temperatureUnit = scope.TemperatureUnitEnum.Fahrenheit;
                    break;
                case scope.MeasurementSystemEnum.Metric:
                    scope.deviceRainfallTableService.rainfallUnit = scope.RainfallUnitEnum.Centimeters;
                    //scope.deviceRainfallTableService.temperatureUnit = scope.TemperatureUnitEnum.Celsius;
                    break;
            }
        });

        //Handle Preferences:TimeFormat (12/24) changed
        scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            scope.deviceRainfallTableService.timeFormat = timeFormat;
        });

        scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            if (scope.alerts.length > 0) {
                var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
                var _type = scope.alerts[0].type;
                var _languageCode = scope.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(scope.deviceRainfallTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.deviceRainfallTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                }
                scope.alerts = [];
                scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });

        //Scroll to the right place after the table is finished drawing
        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll();
            scope.checkFirstRowLiveStatus = null;
        });

        //Clean up when dialog is closed
        scope.$on("$destroy", function () {
            scope.setLiveDataStatus(false);
        });

        // remember where I'm scrolled to in StickyProps, for use when switching to chart
        var _updateZoom = function _updateZoom(currentRow) {
            if (isNaN(currentRow)) return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, {
                dataMin: dateMin,
                dataMax: dateMax,
                zoomMin: zoomMin,
                zoomMax: zoomMax,
                windowId: scope.windowId
            });
        };

        // Only enable live data if the top visible row is within the past 24 hours

        //Look for new data
        var tlGetNewRainfallData = function tlGetNewRainfallData() {
            //console.log('Polling');
            scope.deviceRainfallTableService.Poll();
        };

        scope.calculateLiveDataStatus = function () {
            if (scope.checkFirstRowLiveStatus === false) return;
            var $rowFirst = element.contents().find("tr:first");
            if (typeof $rowFirst.position() == "undefined") return;
            var firstRowTicks = parseFloat($rowFirst.attr("name"));
            var topOffset = $rowFirst.position().top;

            var _tableTop = element.offset().top;
            var _rowTop = $rowFirst.offset().top;

            if (scope.checkFirstRowLiveStatus === true) {
                scope.setLiveDataStatus(_tableTop < _rowTop + 10);
                return;
            }
            timeLapseService.getLocalDateTime().then(function (result) {
                scope.setLiveDataStatus(firstRowTicks + scope.liveDataOffset >= result.data.unixTimeStamp && _tableTop < _rowTop + 10);
            });
        };

        scope.setLiveDataStatus = function (isEnable) {
            if (scope.liveData === isEnable) return;
            scope.liveData = isEnable;
            scope.checkFirstRowLiveStatus = scope.liveData;
            scope.liveDataLine(scope.liveData);
            if (scope.liveData) {
                sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
                timeLapseService.register("RainfallListener", 0, "", tlGetNewRainfallData, pollInterval);
            } else {
                sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                timeLapseService.unRegister("RainfallListener", 0, "", tlGetNewRainfallData, pollInterval);
            }
        };
        //Initialize the scroll position after the data are first loaded
        var _autoScroll = function _autoScroll() {
            if (scope.deviceRainfallTableService.numberOfNewRecordsPrevious > 0) {
                var trRow = element.find('tr').eq(scope.deviceRainfallTableService.numberOfNewRecordsPrevious - 1);
                var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
                element.scrollTop(yPosition);
            } else {
                $timeout(function () {
                    element.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        var addDays = function addDays(date, days) {
            return new Date(date.valueOf() + days * 86400000);
        };

        //Get Data and draw
        scope.GetRainB = function () {
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            scope.deviceRainfallTableService = new deviceRainfallTableService();
            scope.deviceRainfallTableService.customerId = scope.accountInfo.customerId;
            scope.deviceRainfallTableService.deviceId = scope.deviceId; //scope.metarStationSelected;

            scope.deviceRainfallTableService.windowTitle = scope.windowTitle;
            scope.deviceRainfallTableService.startRow = 1;
            scope.deviceRainfallTableService.pageSize = 50;
            scope.alerts = [];

            if (scope.stickyProperties.dateMin && scope.stickyProperties.dateMax) {
                scope.deviceRainfallTableService.start = scope.stickyProperties.dateMin;
                scope.deviceRainfallTableService.end = scope.stickyProperties.dateMax;
                scope.deviceRainfallTableService.Reload();
            } else {
                scope.stickyProperties.on = false;
                timeLapseService.getLocalDateTime().then(function (result) {
                    var endDate = new Date(result.data.localDateTime).setHours(4, 0, 0, 0);
                    endDate = addDays(endDate, 1);
                    var startDate = addDays(endDate, -3);
                    scope.deviceRainfallTableService.start = datetimeService.dateToUnixtime(startDate);
                    scope.deviceRainfallTableService.end = datetimeService.dateToUnixtime(endDate);
                    scope.deviceRainfallTableService.Reload();
                });
            }

            scope.deviceRainfallTableService.temperatureUnit = scope.accountInfo.preferenceUser.lookupMeasurementID;
            scope.deviceRainfallTableService.rainfallUnit = scope.accountInfo.preferenceUser.lookupMeasurementID;
            scope.deviceRainfallTableService.timeFormat = scope.accountInfo.preferenceUser.timeFormat;
        };

        scope.GetRainB();
    };
}]);

mcapp.factory('deviceRainfallTableService', ['$http', 'datetimeService', 'translationService', 'HOST', function ($http, datetimeService, translationService, host) {
    var deviceRainfallTableService = function deviceRainfallTableService() {
        this.items = [];
        this.setting = [];
        this.metarStationName = 'loading...';
        this.customerId = null;
        this.deviceId = null;
        this.temperatureUnit = 1;
        this.rainfallUnit = 1;
        this.timeFormat = 1;
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.tdWidth = null;
        this.alerts = [];
        this.translation = translationService.translation;
        this.lastUpdateAt = null;
    };

    deviceRainfallTableService.prototype.Poll = function () {
        this.LoadData(-this.pageSize, true);
    };

    deviceRainfallTableService.prototype.PreviousPage = function () {
        this.LoadData(-this.pageSize);
    };

    deviceRainfallTableService.prototype.NextPage = function () {
        this.LoadData(this.pageSize);
    };

    deviceRainfallTableService.prototype.Reload = function () {
        this.items = [];
        this.alerts = [];
        this.startRow = 1;
        this.LoadData(this.pageSize);
    };

    deviceRainfallTableService.prototype.LoadData = function (pageSize, blinkTheLight) {
        this.pageSize = pageSize;
        if (this.busy || !this.deviceId) return;
        this.busy = true;
        var url = host + "/api/MetarRainfallTable" + "?deviceId=" + this.deviceId +
        //"&Channel=2" + //this.channel +
        //"&TimeZone=E" + //this.timeZone +
        "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end;

        $http.get(url).then(function (result) {
            //console.log('Request:');
            //console.log('   start: [' + this.start + ']' + new Date(this.start));
            //console.log('   end:   [' + this.end + ']' + new Date(this.end));

            this.numberOfReturnedRecords = result.data.reports.length;

            if (this.startRow === 1) this.startRow = result.data.reports.length;else this.startRow = this.startRow + result.data.reports.length;

            //this.metarStationName = _formatMetarStationName(result.data.metarStation);
            //add new records to the beginning or end:
            if (pageSize > 0) this.items = this.items.concat(result.data.reports);
            if (pageSize < 0) this.items = result.data.reports.reverse().concat(this.items);
            this.numberOfRecords = this.items.length;

            //Get the first and last date, so I know how to get prev/next records in the future
            if (this.numberOfRecords > 0) {
                this.start = _getFirstDate(this.items);
                this.end = _getLastDate(this.items);
            }

            //if (result.data.reports && result.data.reports.length > 0) {
            //    console.log('Response');
            //    console.log('   result.data.reports.length:' + result.data.reports.length);
            //    console.log('   First: [' + this.start + ']' + new Date(this.start));
            //    console.log('   Last:  [' + this.end + ']' + new Date(this.end));
            //}

            if (this.numberOfReturnedRecords > 0 && blinkTheLight) this.lastUpdateAt = this.items[0].localDateTime;

            //Make toast if next page has no result
            if (this.numberOfReturnedRecords === 0 && pageSize > 0) {
                // If we didn't get any items back AND there aren't already any items
                if (this.items.length === 0) {
                    this.alerts = [];
                    var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                    this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this), function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({
                msg: errorMessage, type: "danger"
            });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };

    var _getFirstDate = function _getFirstDate(array) {
        var intDayWindow = 10;
        var intDay = 86400000;
        return datetimeService.toUnixtime(array[array.length - 1].localDateTime.replace(/\D/g, '')) - intDayWindow * intDay;
    };

    var _getLastDate = function _getLastDate(array) {
        return datetimeService.toUnixtime(array[0].localDateTime.replace(/\D/g, ''));
    };

    var _formatMetarStationName = function _formatMetarStationName(metarStation) {
        var result = '';
        if (metarStation.city.length > 0) result += metarStation.city;
        if (metarStation.state.length > 0 && result.length > 0) result += ', ';
        if (metarStation.state.length > 0) result += metarStation.state;
        if (metarStation.icao.length > 0) result += ' (' + metarStation.icao + ')';
        return result;
    };

    return deviceRainfallTableService;
}]);
mcapp.directive('drawDeviceRainfallChart',
    ['$rootScope', '$timeout', 'rainfallDeviceChartService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'sharedSetupService', 'openViewService',
    function ($rootScope, $timeout, rainfallDeviceChartService, datetimeService, websocketService, timeLapseService, toaster, sharedSetupService, openViewService) {
        return function (scope, element, attrs) {
            //ToDo: put these in some common place
            scope.MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
            scope.RainfallUnitEnum = { Inches: 1, Centimeters: 2 };
            scope.TemperatureUnitEnum = { Fahrenheit: 1, Celsius: 2 };
            scope.TimeFormatEnum = { Civilian: 1, Military: 2 };

            scope.preferredRainfallUnit = scope.RainfallUnitEnum.Inches;
            scope.preferredTemperatureUnit = scope.TemperatureUnitEnum.Fahrenheit;
            scope.preferredTimeFormat = scope.accountInfo.preferenceUser.timeFormat;
            scope.windowSubtitle = "Loading...";
            scope.SeriesData = null;

            //create the structure required for the chart: red:
            var seriesIndex = { Rain: 0, Temp: 1 };
            var seriesColors = ["#2288CC", "#DD3221", "#00CC00", "#660066", "#FF6600", "#00CCFF", "#d74375", "#618a13"];
            var chart;
            var xValue = null;
            var scrollingInProgress = false;
            var zoomLevelCurrent, zoomLevelPrevious = 0;
            var initialLoad = true;
            var pollInterval = 60;
            var scrollInProgressTimer;
            var chartFirstDrawn = true;

            var getSeriesLabelText = function () {
                return [
                    scope.translation.text.RAINFALL + " (" +
                        (scope.preferredRainfallUnit === scope.RainfallUnitEnum.Inches
                            ? scope.translation.text.INCHES
                            : scope.translation.text.CENTIMETERS) + ")",
                    scope.translation.text.TEMPERATURE + " (" +
                        (scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
                            ? scope.translation.text.FAHRENHEIT
                            : scope.translation.text.CELSIUS) + ")"];
            };

            //forward method declarations
            var setStickyZoomRange, setStickyDateRange, debugShowStickies, debugShowChartExtents, debugLogDates;
            element.attr("class", "chart");
            if (typeof scope.stickyProperties != 'object') scope.stickyProperties = scope.stickyPropertiesInterface;

            //Manage Geometry
            if (!$rootScope.mobile && !$rootScope.classicView) {
                scope.popup = _this.getExistingDialog(scope.windowId).ref;
                sharedSetupService.maximize(scope.popup);
            }

            //Mouse wheel zoom
            element.on('mousewheel', function (event) {
                if (!scrollingInProgress)
                    scope.mouseWheelZoom(event, chart, xValue);
            });

            //Change the title when the service changes the weather station name
            scope.$watch('rainfallTableService.metarStationName', function (newValue, oldValue) {
                if (newValue && newValue.length > 0 && newValue !== oldValue) {
                    scope.initializeChartB();
                }
            }, true);

            //Handle user selected a date from the calendar
            scope.selectMyDateB = function () {
                var today = Date.now();
                var selectedUnixDate = scope.myDate.setHours(0, 0, 0, 0).valueOf();
                if ((today - selectedUnixDate) < 86400000) { chartFirstDrawn = true; }
                var dateMax = selectedUnixDate + (4 * scope.unixDay);
                var zoomMax = selectedUnixDate + (1 * scope.unixDay);
                var zoomMin = selectedUnixDate;
                var dateMin = selectedUnixDate - (3 * scope.unixDay);

                zoomMin = _subtractZoneOffset(zoomMin, scope.accountInfo.timeZone);
                zoomMax = _subtractZoneOffset(zoomMax, scope.accountInfo.timeZone);

                setStickyDateRange(dateMin, dateMax);
                setStickyZoomRange(zoomMin, zoomMax);
                scope.getInitialPage(dateMin, dateMax);
            };

            // Handle Language Change Event
            scope.fnChangeLanguage = function () {
                if (scope.alerts.length > 0) {
                    var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
                    var _type = scope.alerts[0].type;
                    var _languageCode = scope.alerts[0].languageCode;

                    if (_languageCode.toUpperCase() === 'NO_DATA') {
                        _msg += ': ' + moment(scope.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                    }

                    scope.alerts = [];
                    scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
                }
                scope.drawChart();
                if (!$rootScope.mobile && !$rootScope.classicView)
                    scope.popup.dialog("option", "title", scope.translation.text.AIRPORT_RAINFALL + ", " + scope.windowSubtitle);
            };

            //Handle Preferences:MeasurementSystem changed
            scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
                scope.applyMeasurementSystem(measurementSystem);
                if (scope.alerts.length === 0) {
                    scope.drawChart();
                }
            });

            //Handle Preferences:TimeFormat (12/24) changed
            scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
                scope.applyTimeFormat(timeFormat);
                if (scope.alerts.length === 0) {
                    scope.drawChart();
                }
            });

            //Handle Preferences:Weather station was changed
            scope.$on('updatePreferenceWeather', function (event, args) {
                scope.initializeChartB();
            });

            //blink the light when data recieved
            scope.$watch('lastUpdateAt', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    scope.liveDataIn = !scope.liveDataIn;
                    $timeout(function () {
                        scope.liveDataIn = !scope.liveDataIn;
                    }, 3000);
                }
            }, true);

            //stop all listeners and pollers when the window is closed
            scope.$on("$destroy", function () {
                scope.enableLiveData(false);
                if (chart) chart.destroy();
            });

            scope.applyTimeFormat = function (timeFormat) {
                scope.preferredTimeFormat = parseInt(timeFormat);
            };

            //Update the chart When user preference:MeasurementSystem is changed
            scope.applyMeasurementSystem = function (measurementSystem) {
                var newRainfallUnit = scope.preferredRainfallUnit;
                var newTemperatureUnit = scope.preferredTemperatureUnit;
                switch (parseInt(measurementSystem)) {
                    case scope.MeasurementSystemEnum.Imperial:
                        newRainfallUnit = scope.RainfallUnitEnum.Inches;
                        newTemperatureUnit = scope.TemperatureUnitEnum.Fahrenheit;
                        break;
                    case scope.MeasurementSystemEnum.Metric:
                        newRainfallUnit = scope.RainfallUnitEnum.Centimeters;
                        newTemperatureUnit = scope.TemperatureUnitEnum.Celsius;
                        break;
                }

                if (typeof scope.SeriesData != 'undefined' && scope.SeriesData != null) {
                    if (scope.SeriesData.length > 0)
                        scope.ConvertRainfallSeriesMeasurementUnit(scope.SeriesData[seriesIndex.Rain], scope.preferredRainfallUnit, newRainfallUnit);
                    if (scope.SeriesData.length > 1)
                        scope.ConvertTemperatureSeriesMeasurementUnit(scope.SeriesData[seriesIndex.Temp], scope.preferredTemperatureUnit, newTemperatureUnit);
                }

                scope.preferredRainfallUnit = newRainfallUnit;
                scope.preferredTemperatureUnit = newTemperatureUnit;
            };

            //convert a single value between centimeters and inches
            var convertLengthUnit = function (value, fromUnit, toUnit) {
                if (typeof value === "undefined" || value === null) return 0;
                if (value < 0) return 0;
                if (fromUnit === scope.RainfallUnitEnum.Inches && toUnit === scope.RainfallUnitEnum.Centimeters)
                    return (value * 2.54);
                if (fromUnit === scope.RainfallUnitEnum.Centimeters && toUnit === scope.RainfallUnitEnum.Inches)
                    return (value / 2.54);
                return value.toFixed(2);
            };

            //convert a single point between F and C
            var convertTemperatureUnit = function (value, fromUnit, toUnit) {
                if (typeof value === "undefined" || value === null) return 0;
                if (fromUnit === scope.TemperatureUnitEnum.Fahrenheit && toUnit === scope.TemperatureUnitEnum.Celsius)
                    return ((value - 32) * 5 / 9);
                if (fromUnit === scope.TemperatureUnitEnum.Celsius && toUnit === scope.TemperatureUnitEnum.Fahrenheit)
                    return ((value * 9 / 5) + 32);
                return value.toFixed(2);
            };

            //convert an [x,y] series between inches and centimeters
            scope.ConvertRainfallSeriesMeasurementUnit = function (series, fromUnit, toUnit) {
                if (fromUnit === toUnit || typeof series === 'undefined' || series == null) return;
                for (var i = 0; i < series.length; i++)
                    series[i][1] = convertLengthUnit(series[i][1], fromUnit, toUnit);
            };

            //convert an [x,y] series between C & F
            scope.ConvertTemperatureSeriesMeasurementUnit = function (series, fromUnit, toUnit) {
                if (fromUnit === toUnit || typeof series === 'undefined' || series == null) return;
                for (var i = 0; i < series.length; i++)
                    series[i][1] = convertTemperatureUnit(series[i][1], fromUnit, toUnit);
            };

            //Set start and end date sticky properties convenience function
            setStickyDateRange = function (startDate, endDate) {
                if (typeof startDate !== 'undefined' && startDate != null) {
                    scope.stickyProperties.on = true;
                    sharedSetupService.setStickyProperties(scope.stickyProperties,
                    {
                        dataMin: startDate,
                        windowId: scope.windowId
                    });
                }
                if (typeof endDate !== 'undefined' && endDate != null) {
                    scope.stickyProperties.on = true;
                    sharedSetupService.setStickyProperties(scope.stickyProperties,
                    {
                        dataMax: endDate, //wtf?!
                        windowId: scope.windowId
                    });
                }
                debugShowStickies('stickDateRange');
            };

            //Set zoom range sticky properties convenience function
            setStickyZoomRange = function (startDate, endDate) {
                if (typeof startDate !== 'undefined' && startDate != null) {
                    scope.stickyProperties.on = true;
                    sharedSetupService.setStickyProperties(scope.stickyProperties,
                    {
                        zoomMin: startDate,
                        windowId: scope.windowId
                    });
                }
                if (typeof endDate !== 'undefined' && endDate != null) {
                    scope.stickyProperties.on = true;
                    sharedSetupService.setStickyProperties(scope.stickyProperties,
                    {
                        zoomMax: endDate,
                        windowId: scope.windowId
                    });
                }
                debugShowStickies('stickZoomRange');
            };

            //Set the ScrollingInProgress flag or clear it after 1 sec
            var setScrollingInProgressFlag = function (value) {
                if (scrollInProgressTimer != null && scrollingInProgress)
                    clearTimeout(scrollInProgressTimer);
                if (value === true)
                    scrollingInProgress = true;
                else
                    scrollInProgressTimer = $timeout(function () {
                        scrollingInProgress = false;
                    }, 1000);
            };

            // Turn live polling on or off based on where the user has scrolled
            var setLiveDataStatus = function (varEndDate) {
                scope.liveDataEndDate = varEndDate != null ? varEndDate : scope.liveDataEndDate;
                timeLapseService.getLocalDateTime().then(
                    function (result) {
                        //console.log('zoomMax:' + new Date(scope.stickyProperties.zoomMax));
                        //console.log('zoom+:  ' + new Date(scope.stickyProperties.zoomMax + scope.liveDataOffset));
                        //console.log('result: ' + new Date(result.data.unixTimeStamp));
                        var extremes = chart.xAxis[0].getExtremes();
                        var shouldEnableLiveData = (scope.liveDataEndDate > result.data.unixTimeStamp && (scope.stickyProperties.zoomMax + scope.liveDataOffset >= extremes.dataMax));
                        scope.enableLiveData(shouldEnableLiveData);
                    });
            };

            //reset the chart, get the first page of data and render it.
            scope.getInitialPage = function (startDate, endDate) {
                scope.loadingInProgress = true;
                scope.getData(startDate, endDate)
                    .then(
                        function (response) { //GetData.SuccessCallback:
                            scope.alerts = [];
                            //scope.windowSubtitle = response.data.metarStation.displayName;
                            //ToDo: Fix this:
                            //if (!$rootScope.mobile && !$rootScope.classicView)
                            //    scope.popup.dialog("option", "title", scope.translation.text.AIRPORT_RAINFALL + ", " + scope.windowSubtitle);
                            if (response.data.seriesData && response.data.seriesData[0].length > 0) {
                                scope.SeriesData = response.data.seriesData;
                                scope.drawChart();
                            } else {
                                element.empty();
                                scope.chart = null;
                                scope.lastStart = startDate;
                                scope.lastEnd = endDate;
                                var errormsg = scope.translation.message.NO_DATA + ": " + moment(startDate).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(endDate).utc().format('MM/DD/YY, h:mm:ss a');
                                scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                                chartFirstDrawn = false;
                            }
                            scope.loadingInProgress = false;
                        },
                    function (response) {//GetData.ErrorCallback:
                        element.empty();
                        scope.chart = null;
                        scope.loadingInProgress = false;
                        scope.alerts.push({ msg: scope.translation.message.ERROR, type: "error", languageCode: "ERROR" });
                    });
            };

            //get and display data when user scrolls right to a new page:
            var pageRight = function (callback) {
                chart.showLoading();
                var extremes = chart.xAxis[0].getExtremes();
                var requestDateRange = datetimeService.getNewStartEndDates(extremes.dataMax, 1);
                scope.getData(requestDateRange.startDate, requestDateRange.endDate)
                    .then(function (response) {
                        if (response.data.seriesData) {
                            for (var i = 0; i < response.data.seriesData.length; i++) { //2
                                scope.SeriesData[i] = scope.SeriesData[i].concat(response.data.seriesData[i]);
                                chart.series[i].setData(scope.SeriesData[i]);
                            }
                            setStickyDateRange(null, requestDateRange.endDate);
                        }
                        setLiveDataStatus(requestDateRange.endDate);
                        chart.hideLoading();
                        if (typeof (callback) === "function")
                            callback();
                    });
            };

            //get and display data when user scrolls right to a new page:
            var pageLeft = function (callback) {
                chart.showLoading();
                var extremes = chart.xAxis[0].getExtremes();
                var requestDateRange = datetimeService.getNewStartEndDates(extremes.dataMin, -1);
                scope.getData(requestDateRange.startDate, requestDateRange.endDate)
                    .then(function (response) {
                        if (response.data.seriesData) {
                            for (var i = 0; i < response.data.seriesData.length; i++) { //2
                                scope.SeriesData[i] = response.data.seriesData[i].concat(scope.SeriesData[i]);
                                chart.series[i].setData(scope.SeriesData[i]);
                            }
                        }
                        setStickyDateRange(requestDateRange.startDate, null);
                        setLiveDataStatus();
                        chart.hideLoading();
                        if (typeof (callback) === "function")
                            callback();
                    });
            };

            // Ask the service to fetch the data
            scope.getData = function (startDate, endDate, startRow, pageSize) {
                scope.liveDataEndDate = endDate;
                return rainfallDeviceChartService.GetData(
                    "/api/MetarRainfallChart" +
                    "?customerId=" + scope.accountInfo.customerId +
                    "&deviceId=" + scope.deviceId +
                    "&StartRow=" + (startRow || 1) +
                    "&PageSize=" + (pageSize || 500) +
                    "&StartDate=" + startDate +
                    "&EndDate=" + endDate).then(
                    function (response) { //GetData.SuccessCallback:
                        //debugLogDates(startDate, endDate, response);
                        //convert to preferred units
                        if (response.data.seriesData && response.data.seriesData.length > seriesIndex.Rain)
                            scope.ConvertRainfallSeriesMeasurementUnit(
                                response.data.seriesData[seriesIndex.Rain],
                                scope.RainfallUnitEnum.Inches,
                                scope.preferredRainfallUnit);
                        if (response.data.seriesData && response.data.seriesData.length > seriesIndex.Temp)
                            scope.ConvertTemperatureSeriesMeasurementUnit(
                                response.data.seriesData[seriesIndex.Temp],
                                scope.TemperatureUnitEnum.Fahrenheit,
                                scope.preferredTemperatureUnit);
                        return response;
                    });
            };


            //(re)draw the chart
            scope.drawChart = function () {
                var chartDrawn = false;
                var numberOfSeries, numberOfHiddenSeries = 0;

                var rainfallLabelText = scope.translation.text.RAINFALL +
                    " (" +
                    (scope.preferredRainfallUnit === scope.RainfallUnitEnum.Inches
                        ? scope.translation.text.INCHES
                        : scope.translation.text.CENTIMETERS) +
                    ")";

                var temperatureLabelText = scope.translation.text.TEMPERATURE +
                    " (" +
                    (scope.preferredTemperatureUnit === 1
                        ? scope.translation.text.FAHRENHEIT
                        : scope.translation.text.CELSIUS) +
                    ")";

                var chartXaxisHourFormat =
                    scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian
                    ? '%l:%M %P'
                    : '%H:%M';

                Highcharts.setOptions({
                    chart: {
                        style: {
                            fontFamily: 'arial'
                        }
                    },
                    loading: {
                        labelStyle: {
                            color: 'black'
                        },
                        style: {
                            position: 'absolute',
                            backgroundColor: 'transparent',
                            opacity: 1,
                            textAlign: 'center'
                        }
                    },
                    lang: {
                        loading: '<div class="imgtxtlod" title="' + scope.translation.text.LOADING_DATA + '"><i class="fa fa-spinner fa-spin fa-3x red imglodred"></i> <span class="txtlodblk">' + scope.translation.text.LOADING_DATA + '</span></div>',
                        rangeSelectorZoom: ''
                    }
                });

                chart = new Highcharts.StockChart({
                    credits: {
                        enabled: false
                    },
                    legend: {
                        enabled: true,
                        backgroundColor: '#f9f9f9',
                        borderColor: '#cccccc',
                        borderWidth: 1
                    },
                    chart: {
                        renderTo: element[0],
                        backgroundColor: '#ebebeb',
                        plotBackgroundColor: '#f9f9f9',
                        borderColor: '#cccccc',
                        borderWidth: 1,
                        borderRadius: 2,
                        type: 'line',
                        panning: true,
                        panKey: 'shift',
                        pinchType: 'x',
                        plotBorderWidth: 1,
                        marginTop: 10,
                        marginRight: 10,
                        spacingBottom: 10,
                        spacingTop: 0,
                        spacingLeft: 2,
                        spacingRight: 5,
                        animation: false,
                        reflow: true,
                        events: {
                            redraw: function (event) {

                                //exit maybe
                                if (!this.xAxis || !chartDrawn || scrollingInProgress) return;
                                var extremes = this.xAxis[0].getExtremes();
                                if (!extremes) return;

                                //We need to get another page of infinite data for the left
                                if (extremes.dataMin >= extremes.min - scope.liveDataOffset) {
                                    setScrollingInProgressFlag(true);
                                    pageLeft(function () {
                                        setLiveDataStatus();
                                        setScrollingInProgressFlag(false);
                                    });
                                }
                                    //We need to get another page of infinite data for the right
                                else if (scope.liveData === false &&
                                    extremes.max + scope.liveDataOffset >= extremes.dataMax) {
                                    setScrollingInProgressFlag(true);
                                    pageRight(function () {
                                        setLiveDataStatus();
                                        setScrollingInProgressFlag(false);
                                    });
                                }
                            },
                            load: function (event) {
                                if (initialLoad && !$rootScope.mobile && !$rootScope.classicView) openViewService.adjustContentSize(scope.popup);
                                initialLoad = false;
                            }
                        }
                    },
                    title: {
                        style: {
                            color: '#6D869F',
                            fontWeight: 'bold'
                        }
                    },
                    subtitle: {
                        text: null
                    },
                    exporting: {
                        enabled: false
                    },
                    xAxis: {
                        title: {
                            text: scope.translation.text.TIME,
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold',
                                fontSize: '15px'
                            }
                        },
                        plotLines: [{
                            value: 0,
                            width: 3,
                            color: 'green',
                            dashStyle: "solid",
                            zIndex: 1
                        }],
                        endOnTick: true,
                        showLastLabel: true,
                        startOnTick: true,
                        ordinal: false,
                        minTickInterval: 3600 * 1000,
                        minorGridLineColor: '#ebebeb',
                        minorTickInterval: 'auto',
                        dateTimeLabelFormats: {
                            hour: chartXaxisHourFormat
                        },
                        labels: {
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold'
                            }
                        },
                        events: {
                            afterSetExtremes: function (e) {
                                if (chartDrawn === true) {
                                    var extremes = chart.xAxis[0].getExtremes();
                                    if (scope.liveData === true &&
                                    (e.trigger === "navigator" ||
                                        e.trigger === "pan" ||
                                        typeof e
                                        .trigger ==
                                        "undefined")) { //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                        setLiveDataStatus();
                                    }
                                    setStickyZoomRange(extremes.min, extremes.max);
                                    scope.downsampleSeries(extremes.min, extremes.max);
                                }
                            }
                        }
                    },
                    yAxis: [
                    {
                        showEmpty: false,
                        gridLineWidth: 0,
                        gridLineColor: "#dedede",
                        opposite: false,
                        startOnTick: true,
                        endOnTick: true,
                        lineWidth: 2,
                        lineColor: seriesColors[seriesIndex.Rain],
                        title: {
                            text: getSeriesLabelText()[0],
                            style: { color: "#000" }
                        },
                        labels: {
                            format: "{value:.2f}"
                        },
                        tickPositioner: function () {
                            var positions = [];
                            var firstTick = 0;
                            //Only whole units, starting at 1
                            var lastTick = Math.max(Math.ceil(this.dataMax), 1);
                            //Only zoom out, not in:
                            if (this.tickPositions && this.dataMin >= this.tickPositions[0] && this.dataMax <= this.tickPositions[this.tickPositions.length - 1])
                                return this.tickPositions;
                            //console.log('Rain first:' + firstTick + ', min:' + this.dataMin + ', max:' + this.dataMax + ', last:' + lastTick);
                            //Ten labels
                            var increment = (lastTick - firstTick) / 10;
                            for (var tick = firstTick; tick <= lastTick + increment; tick += increment)
                                positions.push(tick);
                            return positions;
                        }
                    },
                    {
                        showEmpty: false,
                        allowDecimals: false,
                        gridLineWidth: 0,
                        gridLineColor: "#dedede",
                        opposite: false,
                        startOnTick: true,
                        endOnTick: true,
                        lineWidth: 2,
                        lineColor: seriesColors[seriesIndex.Temp],
                        title: {
                            text: getSeriesLabelText()[1],
                            style: { color: "#000" }
                        },
                        tickPositioner: function () {
                            var positions = [];
                            var median = (this.dataMin + this.dataMax) / 2;
                            var swing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
                                ? 10
                                : 10 * 5 / 9;
                            var firstTick = Math.floor(Math.min(median - swing, this.dataMin) / 10) * 10;
                            var lastTick = Math.ceil(Math.max(median + swing, this.dataMax) / 10) * 10;
                            var step = Math.ceil((lastTick - firstTick) / 10);

                            var freezing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
                                ? 32
                                : 0;

                            //Dont let the scale get smaller
                            if (this.tickPositions && this.dataMin >= this.tickPositions[0] && this.dataMax <= this.tickPositions[this.tickPositions.length - 1])
                                return this.tickPositions;

                            for (var tick = firstTick; tick <= lastTick; tick += step)
                                //if (tick > (freezing - step) && tick < freezing) {
                                //    positions.push(freezing);
                                //    tick += step;
                                //} else
                                positions.push(tick);
                            //console.log('Temp first:' + firstTick + ', min:' + this.dataMin + ', max:' + this.dataMax + ', last:' + lastTick + ', positions:' + positions);

                            return positions;
                        }

                    }
                    ],
                    tooltip: {
                        useHTML: true,
                        formatter: function () {
                            var s = '';
                            s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                            s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' +
                                Highcharts.dateFormat('%A, %b %e, %Y ' + chartXaxisHourFormat, this.x) +
                                                        '</td></tr>';
                            $.each(this.points,
                                function (i, point) {
                                    s += '<tr><td style="color: ' + point.series.color + ';">' +
                                        point.series.name +
                                        ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' +
                                        Highcharts.numberFormat(point.y, 2) +
                                        '</td></tr>';
                                    xValue = point.x;
                                });
                            s += '</table>';
                            return s;
                        },
                        crosshairs: true,
                        shared: true,
                        valueDecimals: 1,
                        backgroundColor: '#FFFFFF',
                        borderColor: 'gray',
                        borderWidth: 1
                    },
                    navigator: {
                        enabled: true,
                        adaptToUpdatedData: true,
                        series: {
                            lineWidth: 0,
                            color: 'transparent'
                        },
                        maskFill: 'rgba(255, 255, 255, 0.35)',
                        maskInside: true,
                        handles: {
                            backgroundColor: '#a4a7a9',
                            borderColor: '#384450'
                        },
                        height: 22,
                        margin: 0,
                        xAxis: {
                            tickWidth: 2,
                            lineWidth: 1,
                            gridLineWidth: 0,
                            tickLength: 15,
                            tickPosition: 'inside',
                            tickColor: '#98b3d1',
                            dateTimeLabelFormats: {
                                hour: chartXaxisHourFormat
                            },
                            labels: {
                                align: 'left',
                                style: {
                                    color: '#61768f',
                                    fontWeight: 'bold'
                                },
                                x: 8,
                                y: -8
                            }
                        }
                    },
                    scrollbar: {
                        enabled: true,
                        height: 0,
                        barBackgroundColor: '#959595',
                        barBorderRadius: 2,
                        barBorderWidth: 0,
                        buttonBackgroundColor: '#959595',
                        buttonBorderWidth: 0,
                        buttonBorderRadius: 2,
                        trackBackgroundColor: 'none',
                        trackBorderWidth: 1,
                        trackBorderRadius: 3,
                        trackBorderColor: '#CCC',
                        liveRedraw: true
                    },
                    rangeSelector: {
                        enabled: false,
                        inputEnabled: false,
                        allButtonsEnabled: true,
                        selected: 3,
                        buttons: [
                            {
                                type: 'hour',
                                count: 1,
                                text: '1h'
                            },
                            {
                                type: 'hour',
                                count: 6,
                                text: '6h'
                            },
                            {
                                type: 'hour',
                                count: 12,
                                text: '12h'
                            },
                            {
                                type: 'day',
                                count: 1,
                                text: '1d'
                            }
                        ]
                    },
                    plotOptions: {
                        series: {
                            dataGrouping: {
                                enabled: false
                            },
                            point: {
                                events: {
                                    mouseOver: function () {
                                        xValue = this.x;
                                    }
                                }
                            },
                            borderColor: 'red',
                            borderWidth: 1,
                            marker: {
                                enabled: null, //If null, the markers are hidden when the data is dense, and shown for more widespread data points.
                                fillColor: '#FFFFFF',
                                lineWidth: 2,
                                lineColor: null // inherit from series
                            },
                            events: {
                                legendItemClick: function (e) {
                                    numberOfSeries = this.chart.series.length - 1;
                                    var visibility = this.visible ? 'visible' : 'hidden';
                                    numberOfHiddenSeries = visibility === 'hidden'
                                        ? numberOfHiddenSeries - 1
                                        : numberOfHiddenSeries + 1;
                                    if (numberOfHiddenSeries < numberOfSeries) {
                                        this.chart.yAxis[this.index].update({
                                            labels: { enabled: visibility === 'visible' ? false : true },
                                            title: { text: visibility === 'visible' ? null : getSeriesLabelText()[this.index] },
                                            lineWidth: visibility === 'visible' ? 0 : 2
                                        });
                                        return true;
                                    }
                                    numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                                    if (numberOfHiddenSeries < numberOfSeries) {
                                        this.yAxis.update({ visible: !this.visible });
                                        return true;
                                    }
                                    numberOfHiddenSeries = numberOfHiddenSeries - 1;
                                    return false;
                                },
                                mouseOut: function () {
                                    xValue = null;
                                }
                            }
                        }
                    },
                    series: [
                        {
                            name: rainfallLabelText,
                            id: "0",
                            yAxis: 0,
                            type: "line",
                            color: seriesColors[seriesIndex.Rain],
                            marker: { symbol: "circle", radius: 4 },
                            shadow: false,
                            data: scope.SeriesData[seriesIndex.Rain]
                        },
                        {
                            name: temperatureLabelText,
                            id: "1",
                            yAxis: 1,
                            type: "line",
                            color: seriesColors[seriesIndex.Temp],
                            marker: { symbol: "circle", radius: 4 },
                            shadow: false,
                            data: scope.SeriesData[seriesIndex.Temp]
                        }
                    ]
                });

                scope.chart = chart;

                //This only happens after chart is first drawn:
                if (scope.stickyProperties.on === true) {
                    var extremes = chart.xAxis[0].getExtremes();
                    var zoomMin = Math.max(scope.stickyProperties.zoomMin, extremes.min);
                    var zoomMax = Math.min(scope.stickyProperties.zoomMax, extremes.max);

                    var liveDataLine = chart.xAxis[0].plotLinesAndBands;
                    if (chartFirstDrawn) {
                        liveDataLine[0].options.value = extremes.max + scope.maxPadding;
                        chartFirstDrawn = false;
                    }
                    chart.xAxis[0].setExtremes(zoomMin, zoomMax);
                    debugShowChartExtents();
                }

                setLiveDataStatus();
                chartDrawn = true;
                scope.loadingInProgress = false;
            };

            scope.enableLiveData = function (enable) {
                if (scope.liveData === enable) return;
                scope.liveData = enable;
                sharedSetupService.setStickyProperties(scope.stickyProperties,
                {
                    liveData: scope.liveData,
                    windowId: scope.windowId
                });

                if (enable) {
                    timeLapseService.register("RainfallListener", 0, "", scope.pollForLiveData, pollInterval);
                    timeLapseService.register("RainfallLive", 0, "", scope.tlDataReceivedRAINFALL, 1);
                }

                else {
                    timeLapseService.unRegister("RainfallListener", 0, "", scope.pollForLiveData, pollInterval);
                    timeLapseService.unRegister("RainfallLive", 0, "", scope.tlDataReceivedRAINFALL, 1);
                    scope.lastUpdateAt = undefined;
                }
            };
            scope.pollForLiveData = function () {
                pageRight();
            };

            scope.tlDataReceivedRAINFALL = function (data) {
                if (scope.liveData === false) {
                    timeLapseService.unRegister(scope.deviceSelectedSn);
                    return;
                }

                var extremes = chart.xAxis[0].getExtremes();
                var tmpRange = extremes.max - extremes.min;

                //if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - scope.unixDay / 2) {
                //    timeLapseService.unRegister(scope.deviceSelectedSn);
                //    return;
                //}

                var liveDataLine = chart.xAxis[0].plotLinesAndBands;
                liveDataLine[0].options.value = data.Unix + scope.maxPadding;

                if (extremes.max + scope.liveDataOffset > extremes.dataMax)
                    chart.xAxis[0].setExtremes(data.Unix - tmpRange + scope.minPadding, data.Unix + scope.maxPadding);
            };

            // Downsample logic for zooming
            scope.downsampleSeries = function (varMin, varMax) {
                zoomLevelCurrent = varMax - varMin;
                var i;
                if (zoomLevelCurrent <= scope.unixDay && zoomLevelPrevious > scope.unixDay) {
                    for (i = 0; i < chart.series.length - 1; i++) {
                        chart.series[i].update({
                            downsample: {
                                threshold: 0
                            }
                        }, false);
                        chart.series[i].setData(scope.SeriesData[i], false);
                    }
                    chart.redraw();
                }
                else if (zoomLevelCurrent > scope.unixDay && zoomLevelPrevious <= scope.unixDay) {
                    for (i = 0; i < chart.series.length - 1; i++) {
                        chart.series[i].update({
                            downsample: {
                                threshold: 1000
                            }
                        }, false);
                    }
                    chart.redraw();
                }
                zoomLevelPrevious = zoomLevelCurrent;
            };

            //Start the process of loading data
            scope.initializeChartB = function () {
                var tmpStartDate = null, tmpEndDate = null;
                scope.loadingInProgress = true;
                scope.applyMeasurementSystem(scope.accountInfo.preferenceUser.lookupMeasurementID);
                scope.applyTimeFormat(scope.accountInfo.preferenceUser.timeFormat);
                debugShowStickies('initializeChart');
                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) {
                    scope.stickyProperties.on = true;
                    tmpStartDate = scope.stickyProperties.dateMin;
                    tmpEndDate = scope.stickyProperties.dateMax;
                } else {
                    scope.stickyProperties.on = false;
                }

                //Page is displaying for the first time, so get today
                if (!tmpStartDate) {
                    timeLapseService.getLocalDateTime()
                        .then(function (result) {
                            var nowTicks = new Date(result.data.localDateTime).valueOf();
                            var todayTicks = new Date(result.data.localDateTime).setHours(0, 0, 0, 0).valueOf();
                            var endTicks = todayTicks + scope.unixDay;
                            var startTicks = endTicks - (3 * scope.unixDay);
                            var zoomMinTicks = todayTicks;
                            var zoomMaxTicks = nowTicks;

                            zoomMinTicks = _subtractZoneOffset(zoomMinTicks, scope.accountInfo.timeZone);
                            zoomMaxTicks = _subtractZoneOffset(zoomMaxTicks, scope.accountInfo.timeZone);

                            setStickyDateRange(startTicks, endTicks);
                            setStickyZoomRange(zoomMinTicks, zoomMaxTicks);
                            scope.getInitialPage(startTicks, endTicks);
                        });
                } else {
                    scope.getInitialPage(tmpStartDate, tmpEndDate);
                }
            };


            //This is a kludge:
            var _subtractZoneOffset = function (timestamp, zoneCode) {
                var offset = 0;
                if (zoneCode === 'E') offset = -4;
                if (zoneCode === 'C') offset = -5;
                if (zoneCode === 'M') offset = -6;
                if (zoneCode === 'P') offset = -7;
                if (zoneCode === 'A') offset = -8;
                return moment(timestamp).add(offset, 'hours').format('X') * 1000;
            };


            debugShowStickies = function (msg) {
                //console.log(msg);
                //console.log('   on:' + scope.stickyProperties.on);
                //console.log('   dateMin: [' + scope.stickyProperties.dateMin + ']' + new Date(scope.stickyProperties.dateMin));
                //console.log('   zoomMin: [' + scope.stickyProperties.zoomMin + ']' + new Date(scope.stickyProperties.zoomMin));
                //console.log('   zoomMax: [' + scope.stickyProperties.zoomMax + ']' + new Date(scope.stickyProperties.zoomMax));
                //console.log('   dateMax: [' + scope.stickyProperties.dateMax + ']' + new Date(scope.stickyProperties.dateMax));
            };

            debugShowChartExtents = function () {
                //var extremes = chart.xAxis[0].getExtremes();
                //console.log('debugShowChartExtents:');
                //console.log('   datMin: ' + extremes.dataMin);
                //console.log('   min:     ' + extremes.min);
                //console.log('   max:     ' + extremes.max);
                //console.log('   dataMax: ' + extremes.dataMax);
            };

            debugLogDates = function (start, end, response) {
                console.log('Request:');
                console.log('   start: [' + start + ']' + new Date(start));
                console.log('   end:   [' + end + ']' + new Date(end));
                if (response.data.series && response.data.series.length > 0 && response.data.series[0].data.length > 0) {
                    console.log('Response');
                    console.log('   First: [' + response.data.series[0].data[0][0] + ']' + new Date(response.data.series[0].data[0][0]));
                    console.log('   Last:  [' + response.data.series[0].data[response.data.series[0].data.length - 1][0] + ']' + new Date(response.data.series[0].data[response.data.series[0].data.length - 1][0]));
                }
            };

            scope.initializeChartB();
        };
    }]);

mcapp.factory('rainfallDeviceChartService', ['$http', 'HOST',
    function ($http, host) {
        return {
            GetData: function (query) {
                return $http({
                    method: 'GET',
                    url: host + query,
                    cache: false
                });
            }
        };
    }]);



//var getMinY = function (a) {
//    var min = a[0].y;
//    for (var i = 0; i < a.length; i++)
//        if (a[i].y < min) min = a[i].y;
//    return min;
//};

//var getMaxY = function (a) {
//    var max = a[0].y;
//    for (var i = 0; i < a.length; i++)
//        if (a[i].y > max) max = a[i].y;
//    return min;
//};

//var setRainfallExtremes = function (e) {
//    if (!chart) return;
//    var min = 0;
//    var zoomSteps = 1;
//    var max = Math.max(Math.ceil(chart.yAxis[0].getExtremes().dataMax), zoomSteps);
//    var increment = (max - min) / 10;
//    chart.yAxis[seriesIndex.Rain].setExtremes(min, max);
//    chart.yAxis[seriesIndex.Rain].tickPositions = [];
//    for (var tick = min; tick <= max; tick += increment)
//        chart.yAxis[0].tickPositions.push(tick);
//    console.log('Rain min:' + min + ', max:' + max + ', positions:' + chart.yAxis[0].tickPositions);
//};

//var setTemperatureExtremes = function () {
//    if (!chart) return;
//    var swing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
//        ? 10
//        : 10 * 5 / 9;
//    var freezing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
//        ? 32
//        : 0;
//    var increment = 5;
//    var min = chart.series[seriesIndex.Temp].getExtremes().dataMin;
//    var max = chart.series[seriesIndex.Temp].getExtremes().dataMax;
//    var med = (max + min) / 2;
//    min = Math.floor(Math.min(med - swing, min - swing / 4) / 10) * 10;
//    max = (Math.ceil(Math.max(med + swing, max + swing / 4) / 10) * 10);
//    chart.series[0].setExtremes(min, max);
//    chart.series[0].tickPositions = [];
//    for (var tick = min; tick <= max; tick += increment)
//        chart.series[0].tickPositions.push(tick);
//};



////Calculate the Rainfall Y Axis:
////defaults to 0 to 1 (applies to inches and cm)
////max y axis value goes up or down by a whole unit
//scope.yAxis[0].tickPositioner = function () {
//    var positions = [];
//    var firstTick = 0;
//    var lastTick = Math.max(Math.ceil(this.dataMax), 1);
//    //console.log('first:' + firstTick + ', min:' + this.dataMin + ', max:' + this.dataMax + ', last:' + lastTick);
//    var increment = (lastTick - firstTick) / 10;
//    for (var tick = firstTick; tick <= lastTick + increment; tick += increment)
//        positions.push(tick);
//    return positions;
//}

////Calculate the temperature Y axis ticks
//scope.yAxis[1].tickPositioner = function () {
//    var positions = [];
//    var increment = 5;
//    var median = (this.dataMin + this.dataMax) / 2;
//    var swing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
//        ? 10
//        : 10 * 5 / 9;
//    var freezing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
//        ? 32
//        : 0;
//    var firstTick = Math.floor(Math.min(median - swing, this.dataMin - swing / 4) / 10) * 10;
//    var lastTick = (Math.ceil(Math.max(median + swing, this.dataMax + swing / 4) / 10) * 10) + increment;
//    if (lastTick > 100 && this.dataMax <= 100) lastTick = 100;

//    if (this.tickPositions && this.dataMin >= this.tickPositions[0] && this.dataMax <= this.tickPositions[this.tickPositions.length - 1])
//        return this.tickPositions;

//    for (var tick = firstTick; tick <= lastTick; tick += increment)
//        if (tick > (freezing - increment) && tick < freezing)
//            positions.push(freezing);
//        else
//            positions.push(tick);


//    console.log('first:' + firstTick + ', min:' + this.dataMin + ', max:' + this.dataMax + ', last:' + lastTick + ', positions:' + positions);
//    return positions;
//}



//chart.yAxis[0].setExtremes = function (e) {
//    var min = 0;
//    var zoomSteps = 1;
//    var max = Math.max(Math.ceil(chart.series[0].getExtremes().dataMax), zoomSteps);
//    var increment = (max - min) / 10;
//    chart.series[0].setExtremes(min, max);
//    chart.series[0].tickPositions = [];
//    for (var tick = min; tick <= max; tick += increment)
//        chart.series[0].tickPositions.push(tick);
//    console.log('Rain min:' + min + ', max:' + max + ', positions:' + positions);
//}

// setRainfallExtremes();
//setTemperatureExtremes();


mcapp.controller('rainfallChartController',
    ['$scope', 'sharedSetupService', 'openViewService', 'translationService', '$element', 'authenticationService',
    function ($scope, sharedSetupService, openViewService, translationService, $element, authenticationService) {
        $scope.myDate = null;
        $scope.qdpLeft = -237;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.unixDay = sharedSetupService.unixDay;
        $scope.liveDataOffset = 20 * 60 * 1000;
        $scope.minPadding = 0;
        $scope.maxPadding = 0;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.openView = openViewService.openView;
        $scope.alerts = [];
        $scope.translation = translationService.translation;
        $scope.loadingInProgress = true;

        $scope.downloadViewTypeOptions = [0, 1];
        sharedSetupService.getWindowId($scope);
        //Get my icon based on my title
        $scope.getIcon = function (varTitle, varMode) { return sharedSetupService.getIcon(varTitle, varMode); };

        $scope.downloadOptions = { resolution: 0 }

        $scope.setDevice = function (rainfallData) {
            //$scope.deviceId = rainfallData.deviceId;
            //$scope.currentSelectedDevice = rainfallData;
            $scope.deviceId = rainfallData.deviceId;
            $scope.popup.dialog("option", "title", $scope.windowTitle + ", " + rainfallData.deviceName);
            //if ($scope.deviceId == 0) {
                $scope.initializeChartA();
            //} else if ($scope.deviceId > 0) {
            //    $scope.initializeChartB();
            //}

            //$scope.$broadcast('rainfallDeviceChanged', { data: rainfallData });
        }

        $scope.selectMyDate = function (date) {
            $scope.myDate = date;
            $scope.passedDate = $scope.myDate;
            //if ($scope.deviceId == 0) {
                $scope.selectMyDateA();
            //} else if ($scope.deviceId > 0) {
            //    $scope.selectMyDateB();
            //}
        }

        //Manage Dialog Geometry
        if ($scope.classicView && $element.parent('div').parent('div').parent('div').attr('class') && $element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") === 0) {
            $scope.largeChart = true;
            $element.height(500);
        }
    }]);

mcapp.directive('drawRainfallChart',
    ['$rootScope', '$timeout', 'rainfallChartService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'sharedSetupService', 'openViewService',
    function ($rootScope, $timeout, rainfallChartService, datetimeService, websocketService, timeLapseService, toaster, sharedSetupService, openViewService) {
        return function (scope, element, attrs) {
            //ToDo: put these in some common place
            scope.MeasurementSystemEnum = { Imperial: 1, Metric: 2 };
            scope.RainfallUnitEnum = { Inches: 1, Centimeters: 2 };
            scope.TemperatureUnitEnum = { Fahrenheit: 1, Celsius: 2 };
            scope.TimeFormatEnum = { Civilian: 1, Military: 2 };

            scope.preferredRainfallUnit = scope.RainfallUnitEnum.Inches;
            scope.preferredTemperatureUnit = scope.TemperatureUnitEnum.Fahrenheit;
            scope.preferredTimeFormat = scope.accountInfo.preferenceUser.timeFormat;
            scope.windowSubtitle = "Loading...";
            scope.SeriesData = null;

            //create the structure required for the chart: red:
            var seriesIndex = { Rain: 0, Temp: 1 };
            var seriesColors = ["#2288CC", "#DD3221", "#00CC00", "#660066", "#FF6600", "#00CCFF", "#d74375", "#618a13"];
            var chart;
            var xValue = null;
            var scrollingInProgress = false;
            var zoomLevelCurrent, zoomLevelPrevious = 0;
            var initialLoad = true;
            var pollInterval = 60;
            var scrollInProgressTimer;
            var chartFirstDrawn = true;

            var getSeriesLabelText = function () {
                return [
                    scope.translation.text.RAINFALL + " (" +
                        (scope.preferredRainfallUnit === scope.RainfallUnitEnum.Inches
                            ? scope.translation.text.INCHES
                            : scope.translation.text.CENTIMETERS) + ")",
                    scope.translation.text.TEMPERATURE + " (" +
                        (scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
                            ? scope.translation.text.FAHRENHEIT
                            : scope.translation.text.CELSIUS) + ")"];
            };

            //forward method declarations
            var setStickyZoomRange, setStickyDateRange, debugShowStickies, debugShowChartExtents, debugLogDates;
            element.attr("class", "chart");
            if (typeof scope.stickyProperties != 'object') scope.stickyProperties = scope.stickyPropertiesInterface;

            //Manage Geometry
            if (!$rootScope.mobile && !$rootScope.classicView) {
                scope.popup = _this.getExistingDialog(scope.windowId).ref;
                sharedSetupService.maximize(scope.popup);
            }

            //Mouse wheel zoom
            element.on('mousewheel', function (event) {
                if (!scrollingInProgress)
                    scope.mouseWheelZoom(event, chart, xValue);
            });

            //Change the title when the service changes the weather station name
            scope.$watch('rainfallTableService.metarStationName', function (newValue, oldValue) {
                if (newValue && newValue.length > 0 && newValue !== oldValue) {
                    scope.initializeChartA();
                }
            }, true);

            //Handle user selected a date from the calendar
            scope.selectMyDateA = function () {
                var today = Date.now();
                var selectedUnixDate = scope.myDate.setHours(0, 0, 0, 0).valueOf();
                if ((today - selectedUnixDate) < 86400000) { chartFirstDrawn = true; }
                var dateMax = selectedUnixDate + (4 * scope.unixDay);
                var zoomMax = selectedUnixDate + (1 * scope.unixDay);
                var zoomMin = selectedUnixDate;
                var dateMin = selectedUnixDate - (3 * scope.unixDay);

                zoomMin = _subtractZoneOffset(zoomMin, scope.accountInfo.timeZone);
                zoomMax = _subtractZoneOffset(zoomMax, scope.accountInfo.timeZone);

                setStickyDateRange(dateMin, dateMax);
                setStickyZoomRange(zoomMin, zoomMax);
                scope.getInitialPage(dateMin, dateMax);
            };

            // Handle Language Change Event
            scope.fnChangeLanguage = function () {
                if (scope.alerts.length > 0) {
                    var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
                    var _type = scope.alerts[0].type;
                    var _languageCode = scope.alerts[0].languageCode;

                    if (_languageCode.toUpperCase() === 'NO_DATA') {
                        _msg += ': ' + moment(scope.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                    }

                    scope.alerts = [];
                    scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
                }
                scope.drawChart();
                if (!$rootScope.mobile && !$rootScope.classicView)
                    scope.popup.dialog("option", "title", scope.translation.text.AIRPORT_RAINFALL + ", " + scope.windowSubtitle);
            };

            //Handle Preferences:MeasurementSystem changed
            scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
                scope.applyMeasurementSystem(measurementSystem);
                if (scope.alerts.length === 0) {
                    scope.drawChart();
                }
            });

            //Handle Preferences:TimeFormat (12/24) changed
            scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
                scope.applyTimeFormat(timeFormat);
                if (scope.alerts.length === 0) {
                    scope.drawChart();
                }
            });

            //Handle Preferences:Weather station was changed
            scope.$on('updatePreferenceWeather', function (event, args) {
                scope.initializeChartA();
            });

            //blink the light when data recieved
            scope.$watch('lastUpdateAt', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    scope.liveDataIn = !scope.liveDataIn;
                    $timeout(function () {
                        scope.liveDataIn = !scope.liveDataIn;
                    }, 3000);
                }
            }, true);

            //stop all listeners and pollers when the window is closed
            scope.$on("$destroy", function () {
                scope.enableLiveData(false);
                if (chart) chart.destroy();
            });

            scope.applyTimeFormat = function (timeFormat) {
                scope.preferredTimeFormat = parseInt(timeFormat);
            };

            //Update the chart When user preference:MeasurementSystem is changed
            scope.applyMeasurementSystem = function (measurementSystem) {
                var newRainfallUnit = scope.preferredRainfallUnit;
                var newTemperatureUnit = scope.preferredTemperatureUnit;
                switch (parseInt(measurementSystem)) {
                    case scope.MeasurementSystemEnum.Imperial:
                        newRainfallUnit = scope.RainfallUnitEnum.Inches;
                        newTemperatureUnit = scope.TemperatureUnitEnum.Fahrenheit;
                        break;
                    case scope.MeasurementSystemEnum.Metric:
                        newRainfallUnit = scope.RainfallUnitEnum.Centimeters;
                        newTemperatureUnit = scope.TemperatureUnitEnum.Celsius;
                        break;
                }

                if (typeof scope.SeriesData != 'undefined' && scope.SeriesData != null) {
                    if (scope.SeriesData.length > 0)
                        scope.ConvertRainfallSeriesMeasurementUnit(scope.SeriesData[seriesIndex.Rain], scope.preferredRainfallUnit, newRainfallUnit);
                    if (scope.SeriesData.length > 1)
                        scope.ConvertTemperatureSeriesMeasurementUnit(scope.SeriesData[seriesIndex.Temp], scope.preferredTemperatureUnit, newTemperatureUnit);
                }

                scope.preferredRainfallUnit = newRainfallUnit;
                scope.preferredTemperatureUnit = newTemperatureUnit;
            };

            //convert a single value between centimeters and inches
            var convertLengthUnit = function (value, fromUnit, toUnit) {
                if (typeof value === "undefined" || value === null) return 0;
                if (value < 0) return 0;
                if (fromUnit === scope.RainfallUnitEnum.Inches && toUnit === scope.RainfallUnitEnum.Centimeters)
                    return (value * 2.54);
                if (fromUnit === scope.RainfallUnitEnum.Centimeters && toUnit === scope.RainfallUnitEnum.Inches)
                    return (value / 2.54);
                return value.toFixed(2);
            };

            //convert a single point between F and C
            var convertTemperatureUnit = function (value, fromUnit, toUnit) {
                if (typeof value === "undefined" || value === null) return 0;
                if (fromUnit === scope.TemperatureUnitEnum.Fahrenheit && toUnit === scope.TemperatureUnitEnum.Celsius)
                    return ((value - 32) * 5 / 9);
                if (fromUnit === scope.TemperatureUnitEnum.Celsius && toUnit === scope.TemperatureUnitEnum.Fahrenheit)
                    return ((value * 9 / 5) + 32);
                return value.toFixed(2);
            };

            //convert an [x,y] series between inches and centimeters
            scope.ConvertRainfallSeriesMeasurementUnit = function (series, fromUnit, toUnit) {
                if (fromUnit === toUnit || typeof series === 'undefined' || series == null) return;
                for (var i = 0; i < series.length; i++)
                    series[i][1] = convertLengthUnit(series[i][1], fromUnit, toUnit);
            };

            //convert an [x,y] series between C & F
            scope.ConvertTemperatureSeriesMeasurementUnit = function (series, fromUnit, toUnit) {
                if (fromUnit === toUnit || typeof series === 'undefined' || series == null) return;
                for (var i = 0; i < series.length; i++)
                    series[i][1] = convertTemperatureUnit(series[i][1], fromUnit, toUnit);
            };

            //Set start and end date sticky properties convenience function
            setStickyDateRange = function (startDate, endDate) {
                if (typeof startDate !== 'undefined' && startDate != null) {
                    scope.stickyProperties.on = true;
                    sharedSetupService.setStickyProperties(scope.stickyProperties,
                    {
                        dataMin: startDate,
                        windowId: scope.windowId
                    });
                }
                if (typeof endDate !== 'undefined' && endDate != null) {
                    scope.stickyProperties.on = true;
                    sharedSetupService.setStickyProperties(scope.stickyProperties,
                    {
                        dataMax: endDate, //wtf?!
                        windowId: scope.windowId
                    });
                }
                debugShowStickies('stickDateRange');
            };

            //Set zoom range sticky properties convenience function
            setStickyZoomRange = function (startDate, endDate) {
                if (typeof startDate !== 'undefined' && startDate != null) {
                    scope.stickyProperties.on = true;
                    sharedSetupService.setStickyProperties(scope.stickyProperties,
                    {
                        zoomMin: startDate,
                        windowId: scope.windowId
                    });
                }
                if (typeof endDate !== 'undefined' && endDate != null) {
                    scope.stickyProperties.on = true;
                    sharedSetupService.setStickyProperties(scope.stickyProperties,
                    {
                        zoomMax: endDate,
                        windowId: scope.windowId
                    });
                }
                debugShowStickies('stickZoomRange');
            };

            //Set the ScrollingInProgress flag or clear it after 1 sec
            var setScrollingInProgressFlag = function (value) {
                if (scrollInProgressTimer != null && scrollingInProgress)
                    clearTimeout(scrollInProgressTimer);
                if (value === true)
                    scrollingInProgress = true;
                else
                    scrollInProgressTimer = $timeout(function () {
                        scrollingInProgress = false;
                    }, 1000);
            };

            // Turn live polling on or off based on where the user has scrolled
            var setLiveDataStatus = function (varEndDate) {
                scope.liveDataEndDate = varEndDate != null ? varEndDate : scope.liveDataEndDate;
                timeLapseService.getLocalDateTime().then(
                    function (result) {
                        //console.log('zoomMax:' + new Date(scope.stickyProperties.zoomMax));
                        //console.log('zoom+:  ' + new Date(scope.stickyProperties.zoomMax + scope.liveDataOffset));
                        //console.log('result: ' + new Date(result.data.unixTimeStamp));
                        var extremes = chart.xAxis[0].getExtremes();
                        var shouldEnableLiveData = (scope.liveDataEndDate > result.data.unixTimeStamp && (scope.stickyProperties.zoomMax + scope.liveDataOffset >= extremes.dataMax));
                        scope.enableLiveData(shouldEnableLiveData);
                    });
            };

            //reset the chart, get the first page of data and render it.
            scope.getInitialPage = function (startDate, endDate) {
                scope.loadingInProgress = true;
                scope.getData(startDate, endDate)
                    .then(
                        function (response) { //GetData.SuccessCallback:
                            scope.alerts = [];
                            scope.windowSubtitle = response.data.metarStation.displayName;
                            //ToDo: Fix this:
                            if (!$rootScope.mobile && !$rootScope.classicView)
                                scope.popup.dialog("option", "title", scope.translation.text.AIRPORT_RAINFALL + ", " + scope.windowSubtitle);
                            if (response.data.seriesData && response.data.seriesData[0].length > 0) {
                                scope.SeriesData = response.data.seriesData;
                                scope.drawChart();
                            } else {
                                element.empty();
                                scope.chart = null;
                                scope.lastStart = startDate;
                                scope.lastEnd = endDate;
                                var errormsg = scope.translation.message.NO_DATA + ": " + moment(startDate).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(endDate).utc().format('MM/DD/YY, h:mm:ss a');
                                scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                                chartFirstDrawn = false;
                            }
                            scope.loadingInProgress = false;
                        },
                    function (response) {//GetData.ErrorCallback:
                        element.empty();
                        scope.chart = null;
                        scope.loadingInProgress = false;
                        scope.alerts.push({ msg: scope.translation.message.ERROR, type: "error", languageCode: "ERROR" });
                    });
            };

            //get and display data when user scrolls right to a new page:
            var pageRight = function (callback) {
                chart.showLoading();
                var extremes = chart.xAxis[0].getExtremes();
                var requestDateRange = datetimeService.getNewStartEndDates(extremes.dataMax, 1);
                scope.getData(requestDateRange.startDate, requestDateRange.endDate)
                    .then(function (response) {
                        if (response.data.seriesData) {
                            for (var i = 0; i < response.data.seriesData.length; i++) { //2
                                scope.SeriesData[i] = scope.SeriesData[i].concat(response.data.seriesData[i]);
                                chart.series[i].setData(scope.SeriesData[i]);
                            }
                            setStickyDateRange(null, requestDateRange.endDate);
                        }
                        setLiveDataStatus(requestDateRange.endDate);
                        chart.hideLoading();
                        if (typeof (callback) === "function")
                            callback();
                    });
            };

            //get and display data when user scrolls right to a new page:
            var pageLeft = function (callback) {
                chart.showLoading();
                var extremes = chart.xAxis[0].getExtremes();
                var requestDateRange = datetimeService.getNewStartEndDates(extremes.dataMin, -1);
                scope.getData(requestDateRange.startDate, requestDateRange.endDate)
                    .then(function (response) {
                        if (response.data.seriesData) {
                            for (var i = 0; i < response.data.seriesData.length; i++) { //2
                                scope.SeriesData[i] = response.data.seriesData[i].concat(scope.SeriesData[i]);
                                chart.series[i].setData(scope.SeriesData[i]);
                            }
                        }
                        setStickyDateRange(requestDateRange.startDate, null);
                        setLiveDataStatus();
                        chart.hideLoading();
                        if (typeof (callback) === "function")
                            callback();
                    });
            };

            // Ask the service to fetch the data
            scope.getData = function (startDate, endDate, startRow, pageSize) {
                scope.liveDataEndDate = endDate;
                return rainfallChartService.GetData(
                    "/api/MetarRainfallChart" +
                    "?customerId=" + scope.accountInfo.customerId +
                    "&StartRow=" + (startRow || 1) +
                    "&PageSize=" + (pageSize || 500) +
                    "&StartDate=" + startDate +
                    "&EndDate=" + endDate).then(
                    function (response) { //GetData.SuccessCallback:
                        //debugLogDates(startDate, endDate, response);
                        //convert to preferred units
                        if (response.data.seriesData && response.data.seriesData.length > seriesIndex.Rain)
                            scope.ConvertRainfallSeriesMeasurementUnit(
                                response.data.seriesData[seriesIndex.Rain],
                                scope.RainfallUnitEnum.Inches,
                                scope.preferredRainfallUnit);
                        if (response.data.seriesData && response.data.seriesData.length > seriesIndex.Temp)
                            scope.ConvertTemperatureSeriesMeasurementUnit(
                                response.data.seriesData[seriesIndex.Temp],
                                scope.TemperatureUnitEnum.Fahrenheit,
                                scope.preferredTemperatureUnit);
                        return response;
                    });
            };


            //(re)draw the chart
            scope.drawChart = function () {
                var chartDrawn = false;
                var numberOfSeries, numberOfHiddenSeries = 0;

                var rainfallLabelText = scope.translation.text.RAINFALL +
                    " (" +
                    (scope.preferredRainfallUnit === scope.RainfallUnitEnum.Inches
                        ? scope.translation.text.INCHES
                        : scope.translation.text.CENTIMETERS) +
                    ")";

                var temperatureLabelText = scope.translation.text.TEMPERATURE +
                    " (" +
                    (scope.preferredTemperatureUnit === 1
                        ? scope.translation.text.FAHRENHEIT
                        : scope.translation.text.CELSIUS) +
                    ")";

                var chartXaxisHourFormat =
                    scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian
                    ? '%l:%M %P'
                    : '%H:%M';

                Highcharts.setOptions({
                    chart: {
                        style: {
                            fontFamily: 'arial'
                        }
                    },
                    loading: {
                        labelStyle: {
                            color: 'black'
                        },
                        style: {
                            position: 'absolute',
                            backgroundColor: 'transparent',
                            opacity: 1,
                            textAlign: 'center'
                        }
                    },
                    lang: {
                        loading: '<div class="imgtxtlod" title="' + scope.translation.text.LOADING_DATA + '"><i class="fa fa-spinner fa-spin fa-3x red imglodred"></i> <span class="txtlodblk">' + scope.translation.text.LOADING_DATA + '</span></div>',
                        rangeSelectorZoom: ''
                    }
                });

                chart = new Highcharts.StockChart({
                    credits: {
                        enabled: false
                    },
                    legend: {
                        enabled: true,
                        backgroundColor: '#f9f9f9',
                        borderColor: '#cccccc',
                        borderWidth: 1
                    },
                    chart: {
                        renderTo: element[0],
                        backgroundColor: '#ebebeb',
                        plotBackgroundColor: '#f9f9f9',
                        borderColor: '#cccccc',
                        borderWidth: 1,
                        borderRadius: 2,
                        type: 'line',
                        panning: true,
                        panKey: 'shift',
                        pinchType: 'x',
                        plotBorderWidth: 1,
                        marginTop: 10,
                        marginRight: 10,
                        spacingBottom: 10,
                        spacingTop: 0,
                        spacingLeft: 2,
                        spacingRight: 5,
                        animation: false,
                        reflow: true,
                        events: {
                            redraw: function (event) {

                                //exit maybe
                                if (!this.xAxis || !chartDrawn || scrollingInProgress) return;
                                var extremes = this.xAxis[0].getExtremes();
                                if (!extremes) return;

                                //We need to get another page of infinite data for the left
                                if (extremes.dataMin >= extremes.min - scope.liveDataOffset) {
                                    setScrollingInProgressFlag(true);
                                    pageLeft(function () {
                                        setLiveDataStatus();
                                        setScrollingInProgressFlag(false);
                                    });
                                }
                                    //We need to get another page of infinite data for the right
                                else if (scope.liveData === false &&
                                    extremes.max + scope.liveDataOffset >= extremes.dataMax) {
                                    setScrollingInProgressFlag(true);
                                    pageRight(function () {
                                        setLiveDataStatus();
                                        setScrollingInProgressFlag(false);
                                    });
                                }
                            },
                            load: function (event) {
                                if (initialLoad && !$rootScope.mobile && !$rootScope.classicView) openViewService.adjustContentSize(scope.popup);
                                initialLoad = false;
                            }
                        }
                    },
                    title: {
                        style: {
                            color: '#6D869F',
                            fontWeight: 'bold'
                        }
                    },
                    subtitle: {
                        text: null
                    },
                    exporting: {
                        enabled: false
                    },
                    xAxis: {
                        title: {
                            text: scope.translation.text.TIME,
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold',
                                fontSize: '15px'
                            }
                        },
                        plotLines: [{
                            value: 0,
                            width: 3,
                            color: 'green',
                            dashStyle: "solid",
                            zIndex: 1
                        }],
                        endOnTick: true,
                        showLastLabel: true,
                        startOnTick: true,
                        ordinal: false,
                        minTickInterval: 3600 * 1000,
                        minorGridLineColor: '#ebebeb',
                        minorTickInterval: 'auto',
                        dateTimeLabelFormats: {
                            hour: chartXaxisHourFormat
                        },
                        labels: {
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold'
                            }
                        },
                        events: {
                            afterSetExtremes: function (e) {
                                if (chartDrawn === true) {
                                    var extremes = chart.xAxis[0].getExtremes();
                                    if (scope.liveData === true &&
                                    (e.trigger === "navigator" ||
                                        e.trigger === "pan" ||
                                        typeof e
                                        .trigger ==
                                        "undefined")) { //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                        setLiveDataStatus();
                                    }
                                    setStickyZoomRange(extremes.min, extremes.max);
                                    scope.downsampleSeries(extremes.min, extremes.max);
                                }
                            }
                        }
                    },
                    yAxis: [
                    {
                        showEmpty: false,
                        gridLineWidth: 0,
                        gridLineColor: "#dedede",
                        opposite: false,
                        startOnTick: true,
                        endOnTick: true,
                        lineWidth: 2,
                        lineColor: seriesColors[seriesIndex.Rain],
                        title: {
                            text: getSeriesLabelText()[0],
                            style: { color: "#000" }
                        },
                        labels: {
                            format: "{value:.2f}"
                        },
                        tickPositioner: function () {
                            var positions = [];
                            var firstTick = 0;
                            //Only whole units, starting at 1
                            var lastTick = Math.max(Math.ceil(this.dataMax), 1);
                            //Only zoom out, not in:
                            if (this.tickPositions && this.dataMin >= this.tickPositions[0] && this.dataMax <= this.tickPositions[this.tickPositions.length - 1])
                                return this.tickPositions;
                            //console.log('Rain first:' + firstTick + ', min:' + this.dataMin + ', max:' + this.dataMax + ', last:' + lastTick);
                            //Ten labels
                            var increment = (lastTick - firstTick) / 10;
                            for (var tick = firstTick; tick <= lastTick + increment; tick += increment)
                                positions.push(tick);
                            return positions;
                        }
                    },
                    {
                        showEmpty: false,
                        allowDecimals: false,
                        gridLineWidth: 0,
                        gridLineColor: "#dedede",
                        opposite: false,
                        startOnTick: true,
                        endOnTick: true,
                        lineWidth: 2,
                        lineColor: seriesColors[seriesIndex.Temp],
                        title: {
                            text: getSeriesLabelText()[1],
                            style: { color: "#000" }
                        },
                        tickPositioner: function () {
                            var positions = [];
                            var median = (this.dataMin + this.dataMax) / 2;
                            var swing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
                                ? 10
                                : 10 * 5 / 9;
                            var firstTick = Math.floor(Math.min(median - swing, this.dataMin) / 10) * 10;
                            var lastTick = Math.ceil(Math.max(median + swing, this.dataMax) / 10) * 10;
                            var step = Math.ceil((lastTick - firstTick) / 10);

                            var freezing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
                                ? 32
                                : 0;

                            //Dont let the scale get smaller
                            if (this.tickPositions && this.dataMin >= this.tickPositions[0] && this.dataMax <= this.tickPositions[this.tickPositions.length - 1])
                                return this.tickPositions;

                            for (var tick = firstTick; tick <= lastTick; tick += step)
                                //if (tick > (freezing - step) && tick < freezing) {
                                //    positions.push(freezing);
                                //    tick += step;
                                //} else
                                positions.push(tick);
                            //console.log('Temp first:' + firstTick + ', min:' + this.dataMin + ', max:' + this.dataMax + ', last:' + lastTick + ', positions:' + positions);

                            return positions;
                        }

                    }
                    ],
                    tooltip: {
                        useHTML: true,
                        formatter: function () {
                            var s = '';
                            s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                            s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' +
                                Highcharts.dateFormat('%A, %b %e, %Y ' + chartXaxisHourFormat, this.x) +
                                                        '</td></tr>';
                            $.each(this.points,
                                function (i, point) {
                                    s += '<tr><td style="color: ' + point.series.color + ';">' +
                                        point.series.name +
                                        ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' +
                                        Highcharts.numberFormat(point.y, 2) +
                                        '</td></tr>';
                                    xValue = point.x;
                                });
                            s += '</table>';
                            return s;
                        },
                        crosshairs: true,
                        shared: true,
                        valueDecimals: 1,
                        backgroundColor: '#FFFFFF',
                        borderColor: 'gray',
                        borderWidth: 1
                    },
                    navigator: {
                        enabled: true,
                        adaptToUpdatedData: true,
                        series: {
                            lineWidth: 0,
                            color: 'transparent'
                        },
                        maskFill: 'rgba(255, 255, 255, 0.35)',
                        maskInside: true,
                        handles: {
                            backgroundColor: '#a4a7a9',
                            borderColor: '#384450'
                        },
                        height: 22,
                        margin: 0,
                        xAxis: {
                            tickWidth: 2,
                            lineWidth: 1,
                            gridLineWidth: 0,
                            tickLength: 15,
                            tickPosition: 'inside',
                            tickColor: '#98b3d1',
                            dateTimeLabelFormats: {
                                hour: chartXaxisHourFormat
                            },
                            labels: {
                                align: 'left',
                                style: {
                                    color: '#61768f',
                                    fontWeight: 'bold'
                                },
                                x: 8,
                                y: -8
                            }
                        }
                    },
                    scrollbar: {
                        enabled: true,
                        height: 0,
                        barBackgroundColor: '#959595',
                        barBorderRadius: 2,
                        barBorderWidth: 0,
                        buttonBackgroundColor: '#959595',
                        buttonBorderWidth: 0,
                        buttonBorderRadius: 2,
                        trackBackgroundColor: 'none',
                        trackBorderWidth: 1,
                        trackBorderRadius: 3,
                        trackBorderColor: '#CCC',
                        liveRedraw: true
                    },
                    rangeSelector: {
                        enabled: false,
                        inputEnabled: false,
                        allButtonsEnabled: true,
                        selected: 3,
                        buttons: [
                            {
                                type: 'hour',
                                count: 1,
                                text: '1h'
                            },
                            {
                                type: 'hour',
                                count: 6,
                                text: '6h'
                            },
                            {
                                type: 'hour',
                                count: 12,
                                text: '12h'
                            },
                            {
                                type: 'day',
                                count: 1,
                                text: '1d'
                            }
                        ]
                    },
                    plotOptions: {
                        series: {
                            dataGrouping: {
                                enabled: false
                            },
                            point: {
                                events: {
                                    mouseOver: function () {
                                        xValue = this.x;
                                    }
                                }
                            },
                            borderColor: 'red',
                            borderWidth: 1,
                            marker: {
                                enabled: null, //If null, the markers are hidden when the data is dense, and shown for more widespread data points.
                                fillColor: '#FFFFFF',
                                lineWidth: 2,
                                lineColor: null // inherit from series
                            },
                            events: {
                                legendItemClick: function (e) {
                                    numberOfSeries = this.chart.series.length - 1;
                                    var visibility = this.visible ? 'visible' : 'hidden';
                                    numberOfHiddenSeries = visibility === 'hidden'
                                        ? numberOfHiddenSeries - 1
                                        : numberOfHiddenSeries + 1;
                                    if (numberOfHiddenSeries < numberOfSeries) {
                                        this.chart.yAxis[this.index].update({
                                            labels: { enabled: visibility === 'visible' ? false : true },
                                            title: { text: visibility === 'visible' ? null : getSeriesLabelText()[this.index] },
                                            lineWidth: visibility === 'visible' ? 0 : 2
                                        });
                                        return true;
                                    }
                                    numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                                    if (numberOfHiddenSeries < numberOfSeries) {
                                        this.yAxis.update({ visible: !this.visible });
                                        return true;
                                    }
                                    numberOfHiddenSeries = numberOfHiddenSeries - 1;
                                    return false;
                                },
                                mouseOut: function () {
                                    xValue = null;
                                }
                            }
                        }
                    },
                    series: [
                        {
                            name: rainfallLabelText,
                            id: "0",
                            yAxis: 0,
                            type: "line",
                            color: seriesColors[seriesIndex.Rain],
                            marker: { symbol: "circle", radius: 4 },
                            shadow: false,
                            data: scope.SeriesData[seriesIndex.Rain]
                        },
                        {
                            name: temperatureLabelText,
                            id: "1",
                            yAxis: 1,
                            type: "line",
                            color: seriesColors[seriesIndex.Temp],
                            marker: { symbol: "circle", radius: 4 },
                            shadow: false,
                            data: scope.SeriesData[seriesIndex.Temp]
                        }
                    ]
                });

                scope.chart = chart;

                //This only happens after chart is first drawn:
                if (scope.stickyProperties.on === true) {
                    var extremes = chart.xAxis[0].getExtremes();
                    var zoomMin = Math.max(scope.stickyProperties.zoomMin, extremes.min);
                    var zoomMax = Math.min(scope.stickyProperties.zoomMax, extremes.max);

                    var liveDataLine = chart.xAxis[0].plotLinesAndBands;
                    if (chartFirstDrawn) {
                        liveDataLine[0].options.value = extremes.max + scope.maxPadding;
                        chartFirstDrawn = false;
                    }
                    chart.xAxis[0].setExtremes(zoomMin, zoomMax);
                    debugShowChartExtents();
                }

                setLiveDataStatus();
                chartDrawn = true;
                scope.loadingInProgress = false;
            };

            scope.enableLiveData = function (enable) {
                if (scope.liveData === enable) return;
                scope.liveData = enable;
                sharedSetupService.setStickyProperties(scope.stickyProperties,
                {
                    liveData: scope.liveData,
                    windowId: scope.windowId
                });

                if (enable) {
                    timeLapseService.register("RainfallListener", 0, "", scope.pollForLiveData, pollInterval);
                    timeLapseService.register("RainfallLive", 0, "", scope.tlDataReceivedRAINFALL, 1);
                }

                else {
                    timeLapseService.unRegister("RainfallListener", 0, "", scope.pollForLiveData, pollInterval);
                    timeLapseService.unRegister("RainfallLive", 0, "", scope.tlDataReceivedRAINFALL, 1);
                    scope.lastUpdateAt = undefined;
                }
            };
            scope.pollForLiveData = function () {
                pageRight();
            };

            scope.tlDataReceivedRAINFALL = function (data) {
                if (scope.liveData === false) {
                    timeLapseService.unRegister(scope.deviceSelectedSn);
                    return;
                }

                var extremes = chart.xAxis[0].getExtremes();
                var tmpRange = extremes.max - extremes.min;

                //if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - scope.unixDay / 2) {
                //    timeLapseService.unRegister(scope.deviceSelectedSn);
                //    return;
                //}

                var liveDataLine = chart.xAxis[0].plotLinesAndBands;
                liveDataLine[0].options.value = data.Unix + scope.maxPadding;

                if (extremes.max + scope.liveDataOffset > extremes.dataMax)
                    chart.xAxis[0].setExtremes(data.Unix - tmpRange + scope.minPadding, data.Unix + scope.maxPadding);
            };

            // Downsample logic for zooming
            scope.downsampleSeries = function (varMin, varMax) {
                zoomLevelCurrent = varMax - varMin;
                var i;
                if (zoomLevelCurrent <= scope.unixDay && zoomLevelPrevious > scope.unixDay) {
                    for (i = 0; i < chart.series.length - 1; i++) {
                        chart.series[i].update({
                            downsample: {
                                threshold: 0
                            }
                        }, false);
                        chart.series[i].setData(scope.SeriesData[i], false);
                    }
                    chart.redraw();
                }
                else if (zoomLevelCurrent > scope.unixDay && zoomLevelPrevious <= scope.unixDay) {
                    for (i = 0; i < chart.series.length - 1; i++) {
                        chart.series[i].update({
                            downsample: {
                                threshold: 1000
                            }
                        }, false);
                    }
                    chart.redraw();
                }
                zoomLevelPrevious = zoomLevelCurrent;
            };

            //Start the process of loading data
            scope.initializeChartA = function () {
                var tmpStartDate = null, tmpEndDate = null;
                scope.loadingInProgress = true;
                scope.applyMeasurementSystem(scope.accountInfo.preferenceUser.lookupMeasurementID);
                scope.applyTimeFormat(scope.accountInfo.preferenceUser.timeFormat);
                debugShowStickies('initializeChart');
                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) {
                    scope.stickyProperties.on = true;
                    tmpStartDate = scope.stickyProperties.dateMin;
                    tmpEndDate = scope.stickyProperties.dateMax;
                } else {
                    scope.stickyProperties.on = false;
                }

                //Page is displaying for the first time, so get today
                if (!tmpStartDate) {
                    timeLapseService.getLocalDateTime()
                        .then(function (result) {
                            var nowTicks = new Date(result.data.localDateTime).valueOf();
                            var todayTicks = new Date(result.data.localDateTime).setHours(0, 0, 0, 0).valueOf();
                            var endTicks = todayTicks + scope.unixDay;
                            var startTicks = endTicks - (3 * scope.unixDay);
                            var zoomMinTicks = todayTicks;
                            var zoomMaxTicks = nowTicks;

                            zoomMinTicks = _subtractZoneOffset(zoomMinTicks, scope.accountInfo.timeZone);
                            zoomMaxTicks = _subtractZoneOffset(zoomMaxTicks, scope.accountInfo.timeZone);

                            setStickyDateRange(startTicks, endTicks);
                            setStickyZoomRange(zoomMinTicks, zoomMaxTicks);
                            scope.getInitialPage(startTicks, endTicks);
                        });
                } else {
                    scope.getInitialPage(tmpStartDate, tmpEndDate);
                }
            };


            //This is a kludge:
            var _subtractZoneOffset = function (timestamp, zoneCode) {
                var offset = 0;
                if (zoneCode === 'E') offset = -4;
                if (zoneCode === 'C') offset = -5;
                if (zoneCode === 'M') offset = -6;
                if (zoneCode === 'P') offset = -7;
                if (zoneCode === 'A') offset = -8;
                return moment(timestamp).add(offset, 'hours').format('X') * 1000;
            };


            debugShowStickies = function (msg) {
                //console.log(msg);
                //console.log('   on:' + scope.stickyProperties.on);
                //console.log('   dateMin: [' + scope.stickyProperties.dateMin + ']' + new Date(scope.stickyProperties.dateMin));
                //console.log('   zoomMin: [' + scope.stickyProperties.zoomMin + ']' + new Date(scope.stickyProperties.zoomMin));
                //console.log('   zoomMax: [' + scope.stickyProperties.zoomMax + ']' + new Date(scope.stickyProperties.zoomMax));
                //console.log('   dateMax: [' + scope.stickyProperties.dateMax + ']' + new Date(scope.stickyProperties.dateMax));
            };

            debugShowChartExtents = function () {
                //var extremes = chart.xAxis[0].getExtremes();
                //console.log('debugShowChartExtents:');
                //console.log('   datMin: ' + extremes.dataMin);
                //console.log('   min:     ' + extremes.min);
                //console.log('   max:     ' + extremes.max);
                //console.log('   dataMax: ' + extremes.dataMax);
            };

            debugLogDates = function (start, end, response) {
                console.log('Request:');
                console.log('   start: [' + start + ']' + new Date(start));
                console.log('   end:   [' + end + ']' + new Date(end));
                if (response.data.series && response.data.series.length > 0 && response.data.series[0].data.length > 0) {
                    console.log('Response');
                    console.log('   First: [' + response.data.series[0].data[0][0] + ']' + new Date(response.data.series[0].data[0][0]));
                    console.log('   Last:  [' + response.data.series[0].data[response.data.series[0].data.length - 1][0] + ']' + new Date(response.data.series[0].data[response.data.series[0].data.length - 1][0]));
                }
            };

            scope.initializeChartA();
        };
    }]);

mcapp.factory('rainfallChartService', ['$http', 'HOST',
    function ($http, host) {
        return {
            GetData: function (query) {
                return $http({
                    method: 'GET',
                    url: host + query,
                    cache: false
                });
            }
        };
    }]);



//var getMinY = function (a) {
//    var min = a[0].y;
//    for (var i = 0; i < a.length; i++)
//        if (a[i].y < min) min = a[i].y;
//    return min;
//};

//var getMaxY = function (a) {
//    var max = a[0].y;
//    for (var i = 0; i < a.length; i++)
//        if (a[i].y > max) max = a[i].y;
//    return min;
//};

//var setRainfallExtremes = function (e) {
//    if (!chart) return;
//    var min = 0;
//    var zoomSteps = 1;
//    var max = Math.max(Math.ceil(chart.yAxis[0].getExtremes().dataMax), zoomSteps);
//    var increment = (max - min) / 10;
//    chart.yAxis[seriesIndex.Rain].setExtremes(min, max);
//    chart.yAxis[seriesIndex.Rain].tickPositions = [];
//    for (var tick = min; tick <= max; tick += increment)
//        chart.yAxis[0].tickPositions.push(tick);
//    console.log('Rain min:' + min + ', max:' + max + ', positions:' + chart.yAxis[0].tickPositions);
//};

//var setTemperatureExtremes = function () {
//    if (!chart) return;
//    var swing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
//        ? 10
//        : 10 * 5 / 9;
//    var freezing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
//        ? 32
//        : 0;
//    var increment = 5;
//    var min = chart.series[seriesIndex.Temp].getExtremes().dataMin;
//    var max = chart.series[seriesIndex.Temp].getExtremes().dataMax;
//    var med = (max + min) / 2;
//    min = Math.floor(Math.min(med - swing, min - swing / 4) / 10) * 10;
//    max = (Math.ceil(Math.max(med + swing, max + swing / 4) / 10) * 10);
//    chart.series[0].setExtremes(min, max);
//    chart.series[0].tickPositions = [];
//    for (var tick = min; tick <= max; tick += increment)
//        chart.series[0].tickPositions.push(tick);
//};



////Calculate the Rainfall Y Axis:
////defaults to 0 to 1 (applies to inches and cm)
////max y axis value goes up or down by a whole unit
//scope.yAxis[0].tickPositioner = function () {
//    var positions = [];
//    var firstTick = 0;
//    var lastTick = Math.max(Math.ceil(this.dataMax), 1);
//    //console.log('first:' + firstTick + ', min:' + this.dataMin + ', max:' + this.dataMax + ', last:' + lastTick);
//    var increment = (lastTick - firstTick) / 10;
//    for (var tick = firstTick; tick <= lastTick + increment; tick += increment)
//        positions.push(tick);
//    return positions;
//}

////Calculate the temperature Y axis ticks
//scope.yAxis[1].tickPositioner = function () {
//    var positions = [];
//    var increment = 5;
//    var median = (this.dataMin + this.dataMax) / 2;
//    var swing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
//        ? 10
//        : 10 * 5 / 9;
//    var freezing = scope.preferredTemperatureUnit === scope.TemperatureUnitEnum.Fahrenheit
//        ? 32
//        : 0;
//    var firstTick = Math.floor(Math.min(median - swing, this.dataMin - swing / 4) / 10) * 10;
//    var lastTick = (Math.ceil(Math.max(median + swing, this.dataMax + swing / 4) / 10) * 10) + increment;
//    if (lastTick > 100 && this.dataMax <= 100) lastTick = 100;

//    if (this.tickPositions && this.dataMin >= this.tickPositions[0] && this.dataMax <= this.tickPositions[this.tickPositions.length - 1])
//        return this.tickPositions;

//    for (var tick = firstTick; tick <= lastTick; tick += increment)
//        if (tick > (freezing - increment) && tick < freezing)
//            positions.push(freezing);
//        else
//            positions.push(tick);


//    console.log('first:' + firstTick + ', min:' + this.dataMin + ', max:' + this.dataMax + ', last:' + lastTick + ', positions:' + positions);
//    return positions;
//}



//chart.yAxis[0].setExtremes = function (e) {
//    var min = 0;
//    var zoomSteps = 1;
//    var max = Math.max(Math.ceil(chart.series[0].getExtremes().dataMax), zoomSteps);
//    var increment = (max - min) / 10;
//    chart.series[0].setExtremes(min, max);
//    chart.series[0].tickPositions = [];
//    for (var tick = min; tick <= max; tick += increment)
//        chart.series[0].tickPositions.push(tick);
//    console.log('Rain min:' + min + ', max:' + max + ', positions:' + positions);
//}

// setRainfallExtremes();
//setTemperatureExtremes();


angular.module('reportsModule', ['ngAnimate', 'ngSanitize', 'ui.bootstrap']);
angular.module('reportsModule').controller('AccordionDemoCtrl', ["$scope", "authenticationService", function ($scope, authenticationService) {
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.oneAtATime = true;

    $scope.groups = [
        {
            title: 'Dynamic Group Header - 1',
            content: 'Dynamic Group Body - 1'
        },
        {
            title: 'Dynamic Group Header - 2',
            content: 'Dynamic Group Body - 2'
        }
    ];

    $scope.items = ['Item 1', 'Item 2', 'Item 3'];

    $scope.addItem = function () {
        var newItemNo = $scope.items.length + 1;
        $scope.items.push('Item ' + newItemNo);
    };

    $scope.status = {
        isCustomHeaderOpen: false,
        isFirstOpen: false,
        isFirstDisabled: false
    };

    var reportMenu = $scope.accountInfo.menuItems.find(function (menu) {
        if ('Reports' == menu.name && 'REPORTS' == menu.translationText) return menu;
    });

    $scope.reportMenuLists = $scope.accountInfo.menuItems.filter(function (report) {
        if (reportMenu.menuID == report.parentID) return report;
    });
}]);
"use strict";

angular.module("mc.pump-station", []);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function PumpStationController($, $scope, authenticationService, translationService, sharedSetupService, openViewService, $element, McWidgetsSharedFactory, debounceService, PopupFactory, $timeout, toaster, $location) {
    var ctrl = this;
    ctrl.isLoading = true;
    $scope.alerts = [];

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        $scope.mobileSavedDesktop = $location.path().indexOf("/saveddesktop/saved-desktop-view") > -1;
        ctrl.loadingInProgress = false;

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;

        ctrl.mainClass = [];

        if (angular.isUndefined(ctrl.popupWindow)) {
            ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
            ctrl.getPopupWindowDateTimeDifference = debounceService(ctrl.popupWindow.datetime_difference, 200, false);
        }

        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();

        $element.closest('.ui-dialog-content').css("overflow", "inherit"); //Device Select menu is cut off

        $scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                ctrl.isLoading = true;
                $element.off("mouseover.mcPumpStationGauge");

                ctrl.deviceSelected = newValue;
                ctrl.deviceSelectedSn = $scope.deviceSelectedSn;
                ctrl.deviceSelectedName = $scope.deviceSelectedName;

                ctrl.buildGauges(newValue);
            }
        }, true);

        $scope.$on('pumpStationWidgetDone_' + $scope.windowId, function (event, args) {
            //console.log(args.message);
            ctrl.isLoading = false;
        });
    };

    ctrl.buildGauges = function (deviceSelected) {
        $scope.alerts = [];

        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        }
        var _device = { deviceId: deviceSelected, deviceName: ctrl.deviceSelectedName, serialNumber: ctrl.deviceSelectedSn };
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceSelected, device: _device, windowId: $scope.windowId });

        $element.on("mouseover.mcPumpStationGauge", ".upWidget", function (event) {
            if (!ctrl.m110Runtime && $(event.currentTarget).is(".upWidget") && event.target.tagName !== "DIV" && !$scope.mobile && !$scope.classicView && !ctrl.mobile && !ctrl.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    zIndex: 9999,
                    disabled: false,
                    stop: function stop(event, ui) {
                        var tmpSize = ctrl.mcWidgetsSharedFactory.getSizeNew(ui.helper.attr("mc-size"), 1, ctrl.pumpType);
                        var mcDevice = { deviceId: deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: ctrl.deviceSelectedSn, deviceName: ctrl.deviceSelectedName };
                        var optionsStickyProperties = {
                            deviceId: deviceSelected,
                            device: mcDevice
                        };
                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        var vieName = "Mc Pump Station Widget";
                        openViewService.openWidget(vieName, { width: tmpSize.width, height: tmpSize.height }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));

                        $scope.$apply();
                    }
                });
            } else {
                $(event.currentTarget).draggable({ disabled: true });
            }
        });
    };

    ctrl.mostRecentData = function () {
        ctrl.isLoading = true;
        var _deviceSelected = $scope.deviceSelected;
        $scope.deviceSelected = null;
        $timeout(function () {
            $scope.deviceSelected = angular.copy(_deviceSelected);
            toaster.pop('success', $scope.windowTitle + " -- " + ctrl.deviceSelectedName, 'View reloading');
        }, 0);
    };

    $scope.$on("$destroy", function (event) {
        $element.off("mouseover.mcPumpStationGauge");
    });
}

PumpStationController.$inject = ["$", "$scope", "authenticationService", "translationService", "sharedSetupService", "openViewService", "$element", "McWidgetsSharedFactory", "debounceService", "PopupFactory", "$timeout", "toaster", "$location"];
'use strict';

angular.module('mc.pump-station').component('pumpStation', {
    controller: PumpStationController,
    templateUrl: 'ui/pumpstation/pump-station-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
'use strict';

mcapp.factory("temperatureThresholdsService", ["$http", "HOST", function ($http, HOST) {
    var temperatureThresholdsFactory = {};
    var _getData = function _getData(customerId, deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/TemperatureThresholds?customerId=' + customerId + "&deviceId=" + deviceId,
            cache: false
        });
    };

    var _putTemperatureThresholds = function _putTemperatureThresholds(customerId, deviceId, _temperatureThresholds) {
        return $http.put(HOST + "/api/TemperatureThresholds?customerId=" + customerId + "&deviceId=" + deviceId, _temperatureThresholds);
    };

    var _postUserAction2Nlog = function _postUserAction2Nlog(customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Temperature Thresholds";

        return $http({
            method: 'POST',
            url: HOST + '/api/TemperatureThresholds',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    temperatureThresholdsFactory.putTemperatureThresholds = _putTemperatureThresholds;
    temperatureThresholdsFactory.getData = _getData;
    temperatureThresholdsFactory.postUserAction2Nlog = _postUserAction2Nlog;
    return temperatureThresholdsFactory;
}]);
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  mcapp.controller('temperatureTabController', ['$rootScope', '$scope', '$timeout', 'sharedSetupService', 'translationService', 'authenticationService',
 function ($rootScope, $scope, $timeout, sharedSetupService, translationService, authenticationService) {
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.devicename = null;
    $scope.unit = null;
    $scope.updateStatusProperty = undefined;
    $scope.alerts = [];
     $scope.restoreOffSet = 5;
 }]);

mcapp.directive('drawTemperatureTab', ['$timeout', 'temperatureThresholdsService', 'sharedSetupService',
function ($timeout, temperatureThresholdsService, sharedSetupService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        scope.preferredMeasurementFormat = scope.accountInfo.preferenceUser.lookupMeasurementID;
        scope.unit = scope.preferredMeasurementFormat === 2 ? "°C" : "°F";

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {

                //Changing Device, back to "Basic Info" tab
                if (!angular.isUndefined(scope.currentDevice)) return;

                scope.currentDevice = newValue;
                scope.getData();
            }
        }, true);

        scope.getData = function (){
            temperatureThresholdsService.getData(scope.accountInfo.customerId, scope.currentDevice)
                    .then(function (dataFromFactory) {
                        scope.temperatureThresholds = dataFromFactory.data;
                        scope.applyUnitConversion(dataFromFactory.data);
                    },function (error) {
                        //error

                    }).then(function (data) {
                        //scope.setLoadingInProgress(false);
                        scope.$emit('notificationTabDone', { message: 1 });
                    });
        }

        scope.applyUnitConversion = function (data){
            scope.hMin = scope.convertThresholdData(data.lowFault);//10;
            scope.hMax = scope.convertThresholdData(data.highFault);//60;

            scope.highAlarm = scope.hMax != null && scope.hMax > -100 ? true : false; 
            scope.lowAlarm = scope.hMin != null && scope.hMin > -100 ? true : false; 

            scope.hLvalue = scope.hMax;
            scope.hHvalue = scope.hMin;

            scope.sliderV = {
                min: scope.hMin || -20,
                max: scope.hMax || 200,
                options: {
                    // Accessibility: low pointer = Low Alarm, high pointer = High Alarm
                    ariaLabel: scope.alarmLabel('low'),
                    ariaLabelHigh: scope.alarmLabel('high'),
                    ariaValueText: function (value, sliderId, label) {
                        if (label === 'model') return scope.ariaValueText('low', value);
                        if (label === 'high') return scope.ariaValueText('high', value);
                        return String(value);
                    },
                    floor: -20,
                    ceil: 200,
                    minRange: 15,
                    noSwitching: true,
                    vertical: true,
                    showTicksValues: false,
                    disabled: false,
                    hidePointerLabels: true,
                    hideLimitLabels: true,
                    getPointerColor: function (value, pointerType) {
                        return (pointerType === "min" || pointerType === "max") ? 'transparent' : '#df5353';
                    },
                    getSelectionBarColor: function (value, pointerType) {
                        if (pointerType === "min" && value <= scope.sliderV.min) return '#ff0200';
                        if (pointerType === "max" && value >= scope.sliderV.max)
                            return '#ff0200';
                            return '#005F00;';
                    }
                }
            };

            scope.sliderVL = {
                value: scope.hLvalue,
                options: {
                    // Accessibility (this slider edits the High Alarm value)
                    ariaLabel: scope.alarmLabel('high'),
                    ariaValueText: function (value, sliderId, label) {
                        return label === 'model' ? scope.ariaValueText('high', value) : String(value);
                    },
                    floor: -20,
                    ceil: 200,
                    vertical: true,
                    showSelectionBar: true,
                    disabled: scope.lowAlarm,
                    hidePointerLabels: true,
                    hideLimitLabels: true,
                    getPointerColor: function (value) {
                        return 'transparent';
                    },
                    getSelectionBarColor: function (value) {
                        return '#005F00';
                    }
                }
            };

            scope.sliderVH = {
                value: scope.hHvalue,
                options: {
                    // Accessibility (this slider edits the Low Alarm value)
                    ariaLabel: scope.alarmLabel('low'),
                    ariaValueText: function (value, sliderId, label) {
                        return label === 'model' ? scope.ariaValueText('low', value) : String(value);
                    },
                    floor: -20,
                    ceil: 200,
                    vertical: true,
                    showSelectionBar: true,
                    disabled: scope.highAlarm,
                    hidePointerLabels: true,
                    hideLimitLabels: true,
                    getPointerColor: function (value) {
                        return 'transparent';
                    },
                    getSelectionBarColor: function (value) {
                        return '#ff0200';
                    }
                }
            };

            scope.sliderInit('LowAlarm');
            scope.sliderInit('HighAlarm');
            $timeout(function () {
                scope.$broadcast('rzSliderForceRender');
            });
        }

        // ---- Accessibility helpers (aria-label / aria-valuetext for the slider pointers) ----
        scope.alarmLabel = function (which) {
            return which === 'high' ? 'High Alarm' : 'Low Alarm';
        };

        // e.g. "High Alarm temperature, 200 °F"
        scope.ariaValueText = function (which, value) {
            return scope.alarmLabel(which) + ' temperature, ' + value + ' ' + scope.unit;
        };

        scope.toBackendValue = function (value) {
            if (scope.preferredMeasurementFormat === 2) {
                return scope.toFahrenheit(value); // C → F
            }
            return value; // already F
        };

        scope.convertThresholdData = function (value) {
            if (scope.preferredMeasurementFormat === 2) {
                return scope.toCelsius(value); // F -> C
            }
            return value;
        };
        
        scope.toCelsius = function (f) {
            return Math.round((f - 32) * 5 / 9);
        };

        scope.toFahrenheit = function (c) {
            return Math.round((c * 9 / 5) + 32);
        };

        scope.$watch('sliderV.max', function (newValue, oldValue) {
            if (newValue) {
                scope.sliderVL.value = newValue;
            }
        }, true);

        scope.$watch('sliderV.min', function (newValue, oldValue) {
            if (newValue) {
                scope.sliderVH.value = newValue;
            }
        }, true);


        scope.$watch('sliderVH.value', function (newValue, oldValue) {
            if (newValue) {
                scope.sliderV.min = newValue;
            }
        }, true);

        scope.$watch('sliderVL.value', function (newValue, oldValue) {
            if (newValue) {
                scope.sliderV.max = newValue;
            }
        }, true);

        scope.resetUpdateIndicator = function () {
            scope.updateStatus = scope.resetIndicator;
        };

        scope.resetUpdateIndicator();

        scope.clickSwitch = function (varProperty) {
            scope.sliderInit(varProperty);
            _restartUpdate();
        };

        scope.sliderInit = function (varProperty) {
            switch (varProperty) {
                case "HighAlarm":
                    scope.sliderVH.options.disabled = scope.highAlarm;
                    scope.sliderV.options.disabled = !scope.highAlarm;
                    if (!scope.highAlarm) scope.sliderV.max = scope.sliderV.options.ceil;
                    $timeout(function () {
                        scope.$broadcast('rzSliderForceRender');
                    });
                    break;
                case "LowAlarm":
                    scope.sliderVL.options.disabled = scope.lowAlarm;
                    scope.sliderV.options.disabled = !scope.lowAlarm;
                    if (!scope.lowAlarm) scope.sliderV.min = scope.sliderV.options.floor;
                    $timeout(function () {
                        scope.$broadcast('rzSliderForceRender');
                    });
                    break;
            }

        };

        var _startUpdate;

        var _checkStartUpdate = function () {
            // Don't start if already started
            if (angular.isDefined(_startUpdate)) return;
            _startUpdate = $timeout(function () {
                scope.updateStatus = scope.spinner;
                _startUpdate = undefined; // will revisit this line of code (has to do with Alert())
                scope.preparePutData();
                scope.putTemperatureThresholds();
            }, 4000);
        };

        var _stop = function () {
            if (angular.isDefined(_startUpdate)) {
                $timeout.cancel(_startUpdate);
                _startUpdate = undefined;
            }
        };

        var _restartUpdate = function () {
            if (angular.isDefined(_startUpdate))
                _stop();
            _checkStartUpdate();
        };

        scope.$on("slideEnded", function () {
            _restartUpdate();
        });

        scope.$on("$destroy", function () {
            if (angular.isDefined(_startUpdate)) {
                $timeout.cancel(_startUpdate);
                scope.preparePutData();
                scope.putTemperatureThresholds();
            }
        });

        scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
            scope.preferredMeasurementFormat = parseInt(measurementSystem);
            scope.unit = scope.preferredMeasurementFormat === 2 ? "°C" : "°F";
            scope.applyUnitConversion(scope.temperatureThresholds);
        });

        scope.putTemperatureThresholds = function () {
            temperatureThresholdsService.putTemperatureThresholds(scope.accountInfo.customerId, scope.deviceSelected, scope.temperatureThresholds)
            .then(function (result) {
                scope.updateStatus = scope.okCheck;

            }, function (error) {
                error
            });
        };

        scope.preparePutData = function() {
            if (!scope.sliderVL.options.disabled && !scope.sliderVH.options.disabled) {
                scope.temperatureThresholds.lowFault = null;
                scope.temperatureThresholds.lowRestore = null;
                scope.temperatureThresholds.highFault = null;
                scope.temperatureThresholds.highRestore = null;
                return;
            }

            if (scope.sliderVL.options.disabled && scope.sliderVH.options.disabled) { //if (!scope.sliderV.options.disabled)
                scope.temperatureThresholds.lowFault = scope.toBackendValue(scope.sliderV.min);
                scope.temperatureThresholds.lowRestore = scope.toBackendValue(scope.sliderV.min) + scope.restoreOffSet;
                scope.temperatureThresholds.highFault = scope.toBackendValue(scope.sliderV.max)
                scope.temperatureThresholds.highRestore = scope.toBackendValue(scope.sliderV.max) - scope.restoreOffSet;
                return;
                //"lowFault": 38.0,
                //"lowRestore": 48.0,
                //"highRestore": null,
                //"highFault": null
            }

            if (!scope.sliderVL.options.disabled)
            {
                scope.temperatureThresholds.lowFault = null;
                scope.temperatureThresholds.lowRestore = null;
                scope.temperatureThresholds.highFault = scope.toBackendValue(scope.sliderVL.value);
                scope.temperatureThresholds.highRestore = scope.toBackendValue(scope.sliderVL.value) - scope.restoreOffSet;
                return;
            }

            if (!scope.sliderVH.options.disabled)
            {
                scope.temperatureThresholds.lowFault = scope.toBackendValue(scope.sliderVH.value);
                scope.temperatureThresholds.lowRestore = scope.toBackendValue(scope.sliderVH.value) + scope.restoreOffSet;
                scope.temperatureThresholds.highFault = null;
                scope.temperatureThresholds.highRestore = null;
                return;
            }
        };

        //Log tab access event to NLog
        temperatureThresholdsService.postUserAction2Nlog(scope.accountInfo.customerId, scope.deviceSelected).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });
    };
}]);

mcapp.controller('rtuConfigurationController', ['$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', '$uibModal', 'digitalSettingService', function ($rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, $uibModal, digitalSettingService) {
    $scope.devicename = null;
    $scope.unit = null;
    $scope.myDate = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.minPadding = sharedSetupService.minPadding;
    $scope.maxPadding = sharedSetupService.maxPadding;
    $scope.topMenuMarginLeft = $rootScope.mobile ? '-206px' : '-278px';
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
    $scope.loadingInProgress = true;
    $scope.translation = translationService.translation;
    $scope.spinner = "<i aria-hidden='true' class='fa fa-spinner fa-2x fa-spin'></i>";
    $scope.okCheck = ""; //"<i class='fa fa-check fa-2x fa-green' ></i>";
    $scope.errorCheck = "<i role='img' aria-label='" + $scope.translation.text.ERROR_REOPEN_WINDOW + "' class='fa fa-exclamation-circle fa-2x fa-red'></i>";
    $scope.resetIndicator = "<i aria-hidden='true' class='fa fa-fw fa-2x'>&nbsp;</i>";
    $scope.activeTab = 0; 
    $scope.insideRtuSetting = !angular.isUndefined($element.parents('.mc-combined-view').html());
    $scope.tabStatus = [true, true, true, true, true, true, true, true];
    $scope.hasPendingPaging = false;
    $scope.isPulseSettingExists = false;

    var myReadOnlyDiv = $($element).find(".loading-data-read-only")[0];
    var mouseWheelHandler = function(e) {
        $(myReadOnlyDiv).css("pointer-events", "none");
        $timeout(function() {
                $(myReadOnlyDiv).css("pointer-events", "auto");
            },
            100);
        return false;
    };

    if ($scope.accountInfo.userRole !== 'Administrator' && $scope.accountInfo.userRole !== 'SuperAdministrator') {
        $scope.readOnly = true;
        if (myReadOnlyDiv.addEventListener) {
            // IE9, Chrome, Safari, Opera
            myReadOnlyDiv.addEventListener("mousewheel", mouseWheelHandler, false);
            // Firefox
            myReadOnlyDiv.addEventListener("DOMMouseScroll", mouseWheelHandler, false);
        }
    }

    if (/Edge\/\d./i.test(navigator.userAgent)) {
        $scope.isEdge = true;
    }

    $scope.getContainerHeight = function () {
        if ($scope.popup && $scope.isEdge) {
            return $scope.popup[0].clientHeight - 70;
        } else {
            return '100%';
        }
    }

    $scope.isAdmin = $scope.accountInfo.userRole === 'Administrator' || $scope.accountInfo.userRole === 'SuperAdministrator' ? true : false;

    sharedSetupService.broadcastAllDeviceSelected($scope);

    if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }

    var tabConfiguration = [];
    var resizeTabIdString = "";

    var _tabConfiguration = function () {
        var len = arguments.length,
        i = 0;
        var tmpLength = tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                tabConfiguration.push(arguments[i]);
                resizeTabIdString += resizeTabIdString.length === 0 ? "#" + arguments[i].id : ", #" + arguments[i].id;
            } else {
                tabConfiguration[i].name = arguments[i].name;
            }
        }
    };


    var _initializeSetting = function () {
        _tabConfiguration(
             {
                 "id": "Notification",
                 "name": $scope.translation.text.NOTIFICATION,
                 "templateName": "Notification",
                 "height": 180
             },
            //{
            //    "id": "Analog",
            //    "name": $scope.translation.text.ANALOG,
            //    "templateName": "Analog",
            //    "height": 400
            //},
            {
                "id": "Pumps",
                "name": $scope.translation.text.PUMP_THRESHOLDS,
                "templateName": "Pumps",
                "height": 135
            },
            {
                "id": "Temperature",
                "name": $scope.translation.text.TEMPERATURE_THRESHOLDS,
                "templateName": "Temperature",
                "height": 330
            },
            {
                'id': 'AnalogThresholds',
                'name': $scope.translation.text.ANALOG_THRESHOLDS,
                'templateName': 'Analog Thresholds',
                'templateUrl': 'ui/rtuconfiguration/analogthresholds/analog-thresholds-template.html',
                'height': 400
            },
            {
                'id': 'DigitalDescriptions',
                'name': $scope.translation.text.DIGITAL_DESCRIPTIONS,
                'templateName': 'Digital Descriptions',
                'templateUrl': 'ui/rtuconfiguration/digitaldescriptions/digital-descriptions-template.html',
                'height': 400
            },
            {
                'id': 'PulseDescriptions',
                'name': 'Flow Descriptions',
                'templateName': 'Pulse Descriptions',
                'templateUrl': 'ui/rtuconfiguration/pulsedescriptions/pulse-descriptions-template.html',
                'height': 400
            },            
            {
                'id': 'RelayAlarmDescriptions',
                'name': 'Relay Alarm Descriptions',
                'templateName': 'Relay Alarm Descriptions',
                'templateUrl': 'ui/rtuconfiguration/relayalarmdescriptions/relay-alarm-descriptions-template.html',
                'height': 400
            },
            //{
            //    'id': 'PositiveRelayFeedbackDescriptions',
            //    'name': 'PRF Descriptions',
            //    'templateName': 'PRF Descriptions',
            //    'templateUrl': 'ui/rtuconfiguration/positiverelayfeedbackdescriptions/positive-relay-feedback-description-template.html',
            //    'height': 400
            //},
            {
                'id': 'Other',
                'name': $scope.translation.text.WR_OTHER,
                'templateName': 'Other',
                'templateUrl': 'ui/rtuconfiguration/accommsalarm/ac-comms-alarm-template.html',
                'height': 400
            }
        );
    };

    _initializeSetting();

    $scope.setSelectedTab = function (tab) {
        $scope.selectedTab = tab;
    }
    
    $scope.checkTab = function ($event, index, tab) {
        if (index == 3 && $scope.hasPendingPaging) { // last tab is non-switchable
            $event.preventDefault();
            function modalController($uibModalInstance, translation) {

                this.translation = _translation;

                this.tmpConfirmMessageB = "Exit without paging device?";

                this.ok = function() {
                    $uibModalInstance.close();
                };

                this.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };
            };

            modalController.$inject = ['$uibModalInstance', 'translation'];

            const modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
                controller: modalController,
                controllerAs: '$ctrl',
                size: 'sm',
                resolve: {
                    translation: function () { $scope.translation }
                }
            });

            modalInstance.result.then(function() {
                $scope.hasPendingPaging = false;
                $scope.activeTab = $scope.rtuConfigurationTabs.findIndex(function (x) { return x.id === $scope.selectedTab.id });
            }, function() {                
                // cancel button
            });            
        }
    }

    $scope.$on('has_pending_paging', function (e, obj) {
        if ($scope.currentDeviceId == obj.deviceId) {
            $scope.hasPendingPaging = obj.hasPendingPaging;
        }        
    });

    $scope.getTemplateSource = function (tab) {        
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/rtuconfiguration/' + (tab.templateName).toLowerCase().replace(' ', '-') + '-tab.html';
    }

    $scope.rtuConfigurationTabs = tabConfiguration;

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        _initializeSetting();
    });

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.determineTabStatus = function () {
            if ($scope.deviceSelectedType == 20) {
                $scope.tabStatus[1] = false;
                $scope.tabStatus[3] = true;
                $scope.tabStatus[5] = false;
                $scope.tabStatus[6] = false;
            } else if ($scope.deviceSelectedType == 21) {
                // hide pump thresholds tab for M50 device
                //$scope.tabStatus[1] = false;
                $scope.tabStatus[3] = true;
                if ($scope.isPulseSettingExists)
                    $scope.tabStatus[5] = true;
                else
                    $scope.tabStatus[5] = false;
            }
            else if ($scope.deviceSelectedType == 17) {
                $scope.tabStatus[3] = false;
            }
            else {
                $scope.tabStatus[1] = true;
                $scope.tabStatus[3] = true;
                $scope.tabStatus[5] = true;
            }
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);
        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
                openViewService.adjustContentSize($scope.popup);
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            //var _topMenu = typeof $scope.popup.parent().find('.top-menu').css("height") !== "undefined" ? $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") : 20;
            var _title = $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "");
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            $scope.popup.parent().find('.form-group').css("width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "") - 40);
            $scope.popup.parent().find('.ui-tabs-panel, .form-group').css("height", _tmpHeight - 150 - _title + 28); //28 title height
            $scope.popup.parent().find('.form-group').css("overflow-y", "auto").css("overflow-x", "hidden");

            //will think about this
            //if ($scope.typeId == 2 || $scope.typeId == 3) {
            $scope.popup.parent().find('' + resizeTabIdString + '').css("height", _tmpHeight - 150 - _title + 28 + 52); //28 title height
            $scope.popup.parent().find('' + resizeTabIdString + '').css("overflow-y", "auto").css("overflow-x", "hidden");
            //}
            //will think about this

            // $scope.tabsSize(_tmpHeight - 70 - _title + 28); //28 title height
            $rootScope.$broadcast('contentAdjusted');
            //form-group
        };

        $scope.adjustViewheight = function (varHeight) {
            if (!angular.isUndefined($element.parents('.mc-combined-view').html())) return;            
            varHeight = varHeight + 20;
            var tmpTitle = parseInt($scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", varHeight + tmpTitle + 170);
            $scope.popup.parent().css("height", varHeight + tmpTitle + 200);
            $scope.adjustSize();
        };

        $scope.$on('notificationTabDone', function (event, args) {
            return;//no need for adjustViewheight()
            $scope.adjustViewheight(args.message * tabConfiguration[$scope.activeTab].height);
        });
    }

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            $scope.loadingInProgress = true;
            var _device = { deviceId: newValue, deviceName: $scope.deviceSelectedName };
            $scope.currentDeviceId = newValue;
            $scope.getPulseSettingExists($scope.currentDeviceId, $scope.deviceSelectedType);
            $scope.devicename = $scope.deviceSelectedName;
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });

            $scope.$emit('deviceSelectedDone', { message: $scope.deviceSelectedName });

            $timeout(function () {
                $scope.determineTabStatus();
                $scope.loadingInProgress = false;
            }, 1000);

        }
    }, true);

    $scope.$on("$destroy", function () {
        if (angular.isDefined(myReadOnlyDiv) && myReadOnlyDiv.addEventListener) {
            myReadOnlyDiv.removeEventListener("mousewheel", mouseWheelHandler, false);
            myReadOnlyDiv.removeEventListener("DOMMouseScroll", mouseWheelHandler, false);
        }

        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus($scope.accountInfo.customerId, $scope.accountInfo.userId, $rootScope.wizardId, $scope.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });

    $scope.getPulseSettingExists = function(varDeviceId, varModelId) {
        if ($scope.accountInfo === null || varDeviceId === null)
            return;
        // helps to determine Digital As Flow/Pulse settings exists
        digitalSettingService.getDigitalAsFlowData($scope.accountInfo.customerId, varDeviceId, varModelId)
            .then(function (resp) {
                if (resp.data.length > 0) {
                    $scope.isPulseSettingExists = true;
                } 
            }, function (error) {
                //error
            });
    };
}]);

'use strict';

mcapp.service('pumpTabService', ['$http', 'HOST', function ($http, host) {
    return {
        getPumpStarts: function getPumpStarts(customerId, deviceId) {
            return $http({
                method: 'GET',
                url: host + '/api/PumpStartNotificationThresholds' + '?customerId=' + customerId + '&deviceId=' + deviceId,
                cache: false
            });
        },

        putPumpStarts: function putPumpStarts(customerId, deviceId, alertsEnabled, alarmsEnabled, alertThreshold, alarmThreshold) {
            var pumpStartNotificationPutRequest = {
                customerId: customerId,
                deviceId: deviceId,
                alertsEnabled: alertsEnabled,
                alarmsEnabled: alarmsEnabled,
                alertThreshold: alertThreshold,
                alarmThreshold: alarmThreshold
            };
            return $http.put(host + "/api/PumpStartNotificationThresholds", pumpStartNotificationPutRequest);
        },
        PatchPumpStartThresholds: function PatchPumpStartThresholds(customerId, deviceId, name, value) {
            return $http.put(host + "/api/PumpStartNotificationThresholds?customerId=" + customerId + "&deviceId=" + deviceId, { path: name, value: value });
        },
        getPumpRuntimes: function getPumpRuntimes(customerId, deviceId) {
            return $http.get(host + '/api/PumpRuntimeNotificationThresholds' + '?customerId=' + customerId + '&deviceId=' + deviceId + '&channelNumber=0');
        },

        putPumpRuntime: function putPumpRuntime(customerId, deviceId, channelNumber, lowRuntimeEnabled, highRuntimeEnabled, lowRuntimeThreshold, highRuntimeThreshold) {
            var pumpStartNotificationPutRequest = {
                customerId: customerId,
                deviceId: deviceId,
                channelNumber: channelNumber,
                lowRuntimeEnabled: lowRuntimeEnabled,
                highRuntimeEnabled: highRuntimeEnabled,
                lowRuntimeThreshold: lowRuntimeThreshold,
                highRuntimeThreshold: highRuntimeThreshold
            };
            return $http.put(host + "/api/PumpRuntimeNotificationThresholds", pumpStartNotificationPutRequest);
        },

        postUserAction2Nlog: function postUserAction2Nlog(customerId, deviceId) {
            var action = "access RTU Setting";
            var tabName = "Pump Thresholds";

            return $http({
                method: 'POST',
                url: host + '/api/PumpStartNotificationThresholds',
                params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
                } });
        }
    };
}]);
mcapp.controller('pumpTabController', ['$rootScope', '$scope', '$timeout', 'pumpTabService', 'sharedSetupService', 'translationService', 'authenticationService', '$sce',
 function ($rootScope, $scope, $timeout, pumpTabService, sharedSetupService, translationService, authenticationService, $sce) {

     //Common:
     $scope.accountInfo = authenticationService.getAccountInfo();
     $scope.selectedDevice = null;
     $scope.unit = null;
     $scope.updateStatusProperty = undefined;
     $scope.autoSaveDelay = 4000;
     $scope.autoSaveAnimationSteps = 1;
     $scope.countdownToSave = 0;
     $scope.alerts = [];
     //$scope.isHelpVisible = false;

     //Hide saving and saved indicators:
     $scope.okCheck = $scope.resetIndicator;
     $scope.spinner = $scope.resetIndicator;

     //$scope.pumpNotifications = [];
     var saveTimer = null;

     var startSaveTimer = function () {
         cancelSaveTimer();
         $scope.countdownToSave = $scope.autoSaveDelay;
         saveTimer = setInterval(function () {
             $scope.countdownToSave -= $scope.autoSaveDelay / $scope.autoSaveAnimationSteps;
             $scope.$apply();
             if ($scope.countdownToSave > 0) return;
             cancelSaveTimer();
             console.log("saving");
             saveData();
         }, $scope.autoSaveDelay / $scope.autoSaveAnimationSteps);
     }

     var cancelSaveTimer = function () {
         if (saveTimer != null) clearInterval(saveTimer);
         //$scope.countdownToSave = 0;
         saveTimer = null;
     }

     var toTitleCase = function (s) {
         s = s.trimLeft();
         return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
     }

     var saveData = function () {
         savePumpStarts();
         savePumpRuntimes();
         $scope.rzSliderForceRender();
     }

     var loadData = function () {
         loadPumpStarts($scope.accountInfo.customerId, $scope.selectedDevice);
         loadPumpRuntimes($scope.accountInfo.customerId, $scope.selectedDevice);
         $scope.rzSliderForceRender();

         //Log tab access event to NLog
         pumpTabService.postUserAction2Nlog($scope.accountInfo.customerId, $scope.selectedDevice).then(function (result) {
             //console.log(result);
         }, function (error) {
             // console.log(error);
         });
     }

     $scope.rzSliderForceRender = function () {
         $timeout(function () { $scope.$broadcast('rzSliderForceRender'); }, 10);
     }



     $scope.$on("$destroy", function () {
         if (saveTimer == null) return;
         cancelSaveTimer();
         saveData();
     });

     // Handle Language Change Event
     $scope.$on('updatePreferencesLanguage', function (event, args) {
         $scope.rzSliderForceRender();
     });

     $scope.$watch('deviceSelected', function (newValue, oldValue) {
         if (newValue && newValue !== $scope.selectedDevice) {
             //Changing Device, back to "Basic Info" tab
             if (!angular.isUndefined($scope.currentDevice)) return;

             $scope.currentDevice = newValue;
             $scope.selectedDevice = newValue;
             loadData();
         }
     }, true);

     //Pump Starts:----------------------------------------
     $scope.pumpStartMin = 1;
     $scope.pumpStartMax = 30;
     $scope.pumpStartDeltaMin = 3;
     $scope.pumpStartAlertDefault = 9;
     $scope.pumpStartAlarmDefault = 12;
     $scope.pumpStarts = [];
     $scope.pumpStartInitialValues = [];
     $scope.pumpStartStatusIndicators = [];
     $scope.pumpStartAlarmAlertMinimumDifference = 1;

     // Plain-text name of a pump-starts slider handle ('model' = low handle, 'high' = high handle), used for aria attributes
     function pumpStartPointerName(label, alertsEnabled, alarmsEnabled) {
         if (label === 'high' || (alarmsEnabled && !alertsEnabled))
             return $scope.translation.text.ALARM;
         return $scope.translation.text.ALERT;
     }

     // Plain-text name of a pump-runtime slider handle ('model' = low handle, 'high' = high handle), used for aria attributes
     function pumpRuntimePointerName(label, lowRuntimeEnabled, highRuntimeEnabled) {
         var level = (label === 'high' || (!lowRuntimeEnabled && highRuntimeEnabled)) ? $scope.translation.text.HIGH : $scope.translation.text.LOW;
         return level + ' ' + $scope.translation.text.ALERT;
     }

     $scope.getPumpStartsSliderOptions = function (idx, alertsEnabled, alarmsEnabled) {
         return {
             id: { index: idx, alertsEnabled: alertsEnabled, alarmsEnabled: alarmsEnabled },
             floor: $scope.pumpStartMin,
             ceil: $scope.pumpStartMax,
             step: 1,
             draggableRange: true,
             showSelectionBar: true,
             showSelectionBarEnd: true,
             showTicks: false,
             noSwitching: true,
             minRange: $scope.pumpStartDeltaMin,
             pushRange: true,
             showSelectionBarMax: (alertsEnabled && alarmsEnabled),
             // Accessibility: plain-text name and descriptive value for each slider handle.
             // The low handle is the Alert threshold unless only alarms are enabled; the high handle is always the Alarm threshold.
             ariaLabel: pumpStartPointerName('model', alertsEnabled, alarmsEnabled),
             ariaLabelHigh: pumpStartPointerName('high', alertsEnabled, alarmsEnabled),
             ariaValueText: function (value, sliderId, label) {
                 // e.g. "Alert, 8 starts / hour"
                 return pumpStartPointerName(label, sliderId.alertsEnabled, sliderId.alarmsEnabled) + ', ' + value + ' ' +
                     $scope.translation.text.STARTS.toLowerCase() + ' / ' + $scope.translation.text.HOUR;
             },
             translate: function (value, sliderId, label) {
                 if (sliderId.alarmsEnabled && !sliderId.alertsEnabled && label === 'model')
                     return '<b>' + $scope.translation.text.ALARM + ':</b> ' + value;
                 if (label === 'model')
                     return '<b>' + $scope.translation.text.ALERT + ':</b> ' + value;
                 if (label === 'high')
                     return '<b>' + $scope.translation.text.ALARM + ':</b> ' + value;
                 if (label === 'floor')
                     return value + ' ' + toTitleCase(value === 1 ? $scope.translation.text.START : $scope.translation.text.STARTS)+ '/'+$scope.translation.text.START_HRS;
                 if (label === 'ceil')
                     return value + ' ' + toTitleCase($scope.translation.text.STARTS) + '/'+$scope.translation.text.START_HRS;
                 return value;
             },
             onChange: function (sliderId, modelValue, highValue, pointerType) {
                 $scope.pumpStartStatusIndicators[sliderId.index] = $scope.resetIndicator;
                 cancelSaveTimer();
             },
             onEnd: function (sliderId, modelValue, highValue, pointerType) {
                //  console.log("Starts sliderId:" + sliderId + ", modelValue:" + modelValue + ", highValue:" + highValue + ", pointerType:" + pointerType);
                 if (isPumpStartDirty(sliderId.index))
                     startSaveTimer();
             }
         }
     }

     $scope.pumpStartSwitchValuesChanged = function (idx, type) {
         var pump = $scope.pumpStarts[idx];
         if (type === 'alert' && pump.alertsEnabled === true) {
             if (pump.alertThreshold === 0)
                 pump.alertThreshold = $scope.pumpStartAlertDefault;
             if (pump.alarmsEnabled && pump.alertThreshold >= pump.alarmThreshold - $scope.pumpStartDeltaMin)
                 pump.alertThreshold = Math.max($scope.pumpRuntimeMin, pump.alarmThreshold - $scope.pumpStartDeltaMin);
             if (pump.alertThreshold >= pump.alarmThreshold - $scope.pumpStartDeltaMin)
                 pump.alarmThreshold = Math.min($scope.pumpRuntimeMax, pump.alertThreshold + $scope.pumpStartDeltaMin);
         }
         if (type === 'alarm' && pump.alarmsEnabled === true) {
             if (pump.alarmThreshold === 0)
                 pump.alarmThreshold = $scope.pumpStartAlarmDefault;
             if (pump.alertThreshold >= pump.alarmThreshold - $scope.pumpStartDeltaMin)
                 pump.alarmThreshold = Math.min($scope.pumpRuntimeMax, pump.alertThreshold + $scope.pumpStartDeltaMin);
             if (pump.alertThreshold >= pump.alarmThreshold - $scope.pumpStartDeltaMin)
                 pump.alertThreshold = Math.max($scope.pumpRuntimeMin, pump.alarmThreshold - $scope.pumpStartDeltaMin);
         }

         $scope.pumpStartStatusIndicators[idx] = $scope.resetIndicator;

         startSaveTimer();
         $scope.rzSliderForceRender();
     }

     var loadPumpStarts = function (customerId, deviceId) {
         return pumpTabService.getPumpStarts(customerId, deviceId)
             .then(
                 function (response) {
                     for (var i = 0; i < response.data.length; i++) {
                         var pumpStart = createPumpStart(response.data[i]);
                         $scope.pumpStarts.push(pumpStart);
                         $scope.pumpStartInitialValues.push(angular.toJson(pumpStart));
                     }
                     $scope.rzSliderForceRender();
                     return response;
                 });
     }

     var createPumpStart = function (data) {
         var pump = {
             customerId: data.customerId,
             deviceId: data.deviceId,
             deviceName: data.deviceName,
             alertsEnabled: data.alertsEnabled,
             alarmsEnabled: data.alarmsEnabled,
             alertThreshold: Math.min(data.alertThreshold, $scope.pumpStartMax),
             alarmThreshold: Math.min(data.alarmThreshold, $scope.pumpStartMax)
         };
         return pump;
     }

     var savePumpStarts = function () {
         for (var i = 0; i < $scope.pumpStarts.length; i++) {
             if (isPumpStartDirty(i)) {
                 $scope.pumpStartStatusIndicators[i] = $scope.spinner;
                 pumpTabService.putPumpStarts(
                         $scope.pumpStarts[i].customerId,
                         $scope.pumpStarts[i].deviceId,
                         $scope.pumpStarts[i].alertsEnabled,
                         $scope.pumpStarts[i].alarmsEnabled,
                         $scope.pumpStarts[i].alertThreshold,
                         $scope.pumpStarts[i].alarmThreshold
                     )
                     .then(function (response) {
                         updatePumpStart(response.data);
                         $scope.rzSliderForceRender();
                     });
             }
         }
     }

     var updatePumpStart = function (data) {
         for (var i = 0; i < $scope.pumpStarts.length; i++)
             if ($scope.pumpStarts[i].deviceId === data.deviceId) {
                 $scope.pumpStarts[i] = createPumpStart(data);
                 $scope.pumpStartInitialValues[i] = angular.toJson($scope.pumpStarts[i]);
                 $scope.pumpStartStatusIndicators[i] = $scope.okCheck;
                 return $scope.pumpStarts[i];
             }
         return null;
     };

     var isPumpStartDirty = function (index) {
         return (angular.toJson($scope.pumpStarts[index]) !== $scope.pumpStartInitialValues[index]);
     }

     //Pump Runtimes:--------------------------------------
     $scope.pumpRuntimeMin = 1;
     $scope.pumpRuntimeMax = 1439;
     $scope.pumpRuntimeDeltaMin = 1;
     $scope.pumpRuntimeLowAlertDefault = 3;
     $scope.pumpRuntimeHighAlertDefault = 57;
     $scope.pumpRuntimes = [];
     $scope.pumpRuntimeInitialValues = [];
     $scope.pumpRuntimeStatusIndicators = [];
     
     $scope.getPumpRuntimeSliderOptions = function (idx, lowRuntimeEnabled, highRuntimeEnabled) {
         return {
             id: { index: idx, lowRuntimeEnabled: lowRuntimeEnabled, highRuntimeEnabled: highRuntimeEnabled },
             floor: $scope.pumpRuntimeMin,
             ceil: $scope.pumpRuntimeMax,
             step: 1,
             draggableRange: true,
             showSelectionBar: true,
             showSelectionBarEnd: true,
             showTicks: false,
             noSwitching: true,
             minRange: $scope.pumpRuntimeDeltaMin,
             pushRange: true,
             // Accessibility: plain-text name and descriptive value for each slider handle.
             // The low handle is the Low Alert unless only the high runtime is enabled; the high handle is always the High Alert.
             ariaLabel: pumpRuntimePointerName('model', lowRuntimeEnabled, highRuntimeEnabled) + ' - ' + $scope.pumpRuntimes[idx].channelName,
             ariaLabelHigh: pumpRuntimePointerName('high', lowRuntimeEnabled, highRuntimeEnabled) + ' - ' + $scope.pumpRuntimes[idx].channelName,
             ariaValueText: function (value, sliderId, label) {
                 // e.g. "Low Alert, 12 minutes"
                 var unit = value === 1 ? $scope.translation.text.MINUTE : $scope.translation.text.MINUTES;
                 return pumpRuntimePointerName(label, sliderId.lowRuntimeEnabled, sliderId.highRuntimeEnabled) + ', ' + value + ' ' + unit.toLowerCase();
             },
             translate: function (value, sliderId, label) {
                 if (!sliderId.lowRuntimeEnabled && sliderId.highRuntimeEnabled && label === 'model')
                     return '<b>' + $scope.translation.text.HIGH + ' ' + $scope.translation.text.ALERT + ':</b> ' + value;
                 if (label === 'model')
                     return '<b>' + $scope.translation.text.LOW + ' ' + $scope.translation.text.ALERT + ':</b> ' + value;
                 if (label === 'high')
                     return '<b>' + $scope.translation.text.HIGH + ' ' + $scope.translation.text.ALERT + ':</b> ' + value;
                 if (label === 'floor')
                     return value + ' '+ toTitleCase(value === 1 ? toTitleCase( $scope.translation.text.MINUTE) : toTitleCase($scope.translation.text.MINUTES));
                 if (label === 'ceil')
                     return value + ' ' + toTitleCase($scope.translation.text.MINUTES);
                 return value;
             },
             onChange: function (sliderId, modelValue, highValue, pointerType) {
                 $scope.pumpRuntimeStatusIndicators[sliderId.index] = $scope.resetIndicator;
                 cancelSaveTimer();
             },
             onEnd: function (sliderId, modelValue, highValue, pointerType) {
                //  console.log("Runs sliderId:" + sliderId + ", modelValue:" + modelValue + ", highValue:" + highValue + ", pointerType:" + pointerType);
                 if (isPumpRuntimeDirty(sliderId.index))
                     startSaveTimer();
             }
         }
     }

     $scope.pumpRuntimeSwitchValuesChanged = function (idx, type) {
         var pump = $scope.pumpRuntimes[idx];
         if (type === 'low' && pump.lowRuntimeEnabled === true) {
             if (pump.lowRuntimeThreshold === 0)
                 pump.lowRuntimeThreshold = $scope.pumpRuntimeDeltaMin;
             if (pump.lowRuntimeThreshold >= pump.highRuntimeThreshold - $scope.pumpRuntimeDeltaMin)
                 pump.lowRuntimeThreshold = Math.max($scope.pumpRuntimeMin, pump.highRuntimeThreshold - $scope.pumpRuntimeDeltaMin);
             if (pump.lowRuntimeThreshold >= pump.highRuntimeThreshold - $scope.pumpRuntimeDeltaMin)
                 pump.highRuntimeThreshold = Math.min($scope.pumpRuntimeMax, pump.lowRuntimeThreshold + $scope.pumpRuntimeDeltaMin);
         }
         if (type === 'high' && pump.highRuntimeEnabled === true) {
             if (pump.highRuntimeThreshold === 0)
                 pump.highRuntimeThreshold = $scope.pumpRuntimeMax - $scope.pumpRuntimeDeltaMin;
             if (pump.lowRuntimeThreshold >= pump.highRuntimeThreshold - $scope.pumpRuntimeDeltaMin)
                 pump.highRuntimeThreshold = Math.min($scope.pumpRuntimeMax, pump.lowRuntimeThreshold + $scope.pumpRuntimeDeltaMin);
             if (pump.lowRuntimeThreshold >= pump.highRuntimeThreshold - $scope.pumpRuntimeDeltaMin)
                 pump.lowRuntimeThreshold = Math.max($scope.pumpRuntimeMin, pump.highRuntimeThreshold - $scope.pumpRuntimeDeltaMin);
         }
         $scope.pumpRuntimeStatusIndicators[idx] = $scope.resetIndicator;

         startSaveTimer();
         $scope.rzSliderForceRender();
     }

     var loadPumpRuntimes = function (customerId, deviceId) {
         return pumpTabService.getPumpRuntimes(customerId, deviceId)
             .then(
                 function (response) {
                     for (var i = 0; i < response.data.length; i++) {
                         var pumpRuntimeConfig = createPumpRuntime(response.data[i]);
                         $scope.pumpRuntimes.push(pumpRuntimeConfig);
                         $scope.pumpRuntimeInitialValues.push(angular.toJson(pumpRuntimeConfig));
                     }
                     $scope.$emit('notificationTabDone', { message: response.data.length });
                     return response;
                 });
     }

     var createPumpRuntime = function (data) {
         var runtimeThreshold = {
             customerId: data.customerId,
             deviceId: data.deviceId,
             deviceName: data.deviceName,
             channelNumber: data.channelNumber,
             channelName: data.channelName,
             lowRuntimeEnabled: data.lowRuntimeEnabled,
             highRuntimeEnabled: data.highRuntimeEnabled,
             lowRuntimeThreshold: data.lowRuntimeThreshold,
             highRuntimeThreshold: data.highRuntimeThreshold
         }
         return runtimeThreshold;
     }

     var savePumpRuntimes = function () {
         for (var i = 0; i < $scope.pumpRuntimes.length; i++) {
             if (isPumpRuntimeDirty(i)) {
                 $scope.pumpRuntimeStatusIndicators[i] = $scope.spinner;
                 pumpTabService.putPumpRuntime(
                    $scope.pumpRuntimes[i].customerId,
                    $scope.pumpRuntimes[i].deviceId,
                    $scope.pumpRuntimes[i].channelNumber,
                    $scope.pumpRuntimes[i].lowRuntimeEnabled,
                    $scope.pumpRuntimes[i].highRuntimeEnabled,
                    $scope.pumpRuntimes[i].lowRuntimeThreshold,
                    $scope.pumpRuntimes[i].highRuntimeThreshold
                ).then(function (response) {
                    updatePumpRuntime(response.data);
                    $scope.rzSliderForceRender();
                });
             }
         }
     }

     var updatePumpRuntime = function (data) {
         for (var i = 0; i < $scope.pumpRuntimes.length; i++)
             if ($scope.pumpRuntimes[i].deviceId === data.deviceId && $scope.pumpRuntimes[i].channelNumber === data.channelNumber) {
                 //$scope.pumpRuntimes[i] = createPumpRuntime(data);                 
                 $scope.pumpRuntimeInitialValues[i] = angular.toJson($scope.pumpRuntimes[i]);
                 $scope.pumpRuntimeStatusIndicators[i] = $scope.okCheck;
                 return $scope.pumpRuntimes[i];
             }
         return null;
     };

     var isPumpRuntimeDirty = function (index) {
         return (angular.toJson($scope.pumpRuntimes[index]) !== $scope.pumpRuntimeInitialValues[index]);
     }

     $scope.$on('contentAdjusted', function (){
        $timeout(function () { $scope.$broadcast('rzSliderForceRender'); }, 10);
      });

 }]);
mcapp.controller('notificationTabController', ['$rootScope', '$scope', 'sharedSetupService', 'translationService', 'authenticationService', '$timeout', function ($rootScope, $scope, sharedSetupService, translationService, authenticationService, $timeout) {

    $scope.devicename = null;
    $scope.unit = null;
    $scope.updateStatusProperty = undefined;
    $scope.alerts = [];
    $scope.mcAdmin = sharedSetupService.mcAdmin();

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {

            $scope.currentDevice = angular.isUndefined(oldValue) ? newValue : (oldValue !== newValue) ? null : oldValue;
            
            $scope.ntfTabUpdate = false;
            $timeout(function () {
                $scope.ntfTabUpdate = true;
            }, 0);
        }
    }, true);

}]);

mcapp.directive('notificationTab', ['$timeout', 'deviceNotificationSettingService', '$filter', 'timeLapseService', '$rootScope', 'deviceMenuService', function ($timeout, deviceNotificationSettingService, $filter, timeLapseService, $rootScope, deviceMenuService) {
    return function (scope, element, attrs) {

        scope.currentTime = 0;
        var batteryPoweredDevices = [10, 15, 20, 21];
        var setTimestamp = function (data) {
            scope.currentTime = moment(data.localDateTime).valueOf();

            if (!scope.disabled && scope.disabledUntilTime) {
                if (scope.currentTime > moment(scope.disabledUntilTime).valueOf()) {
                    scope.disabled = true;
                    scope.disabledUntilTime = null;
                }
            }
        };

        timeLapseService.getLocalDateTime().then(function (resp) {
            scope.currentTime = moment(resp.data.localDateTime).valueOf();

            if (!scope.disabled && scope.disabledUntilTime) {
                if (scope.currentTime > moment(scope.disabledUntilTime).valueOf()) {
                    scope.disabled = true;
                    scope.disabledUntilTime = null;
                }
            }
        });

        timeLapseService.registerLocal('CALLOUT_STATUS', null, null, setTimestamp);

        scope.calloutStatusTimeout = [];

        scope._calloutStatusTimeout = function () {
            var len = arguments.length,
                i = 0;
            var tmpLength = scope.calloutStatusTimeout.length;
            for (i = 0; i < len; i++) {
                if (tmpLength == 0) {
                    scope.calloutStatusTimeout.push(arguments[i]);
                } else {
                    scope.calloutStatusTimeout[i].description = arguments[i].description;
                }
            }
        };

        scope.serviceModeEndTimeout = [];

        scope._serviceModeEndTimeout = function () {
            var len = arguments.length,
                i = 0;
            var tmpLength = scope.serviceModeEndTimeout.length;
            for (i = 0; i < len; i++) {
                if (tmpLength == 0) {
                    scope.serviceModeEndTimeout.push(arguments[i]);
                } else {
                    scope.serviceModeEndTimeout[i].description = arguments[i].description;
                }
            }
        };

        scope._initializeSetting = function () {

            scope._calloutStatusTimeout(
                { "id": 30, "description": "30 " + scope.translation.text.MINUTES },
                { "id": 60, "description": "1 " + scope.translation.text.HOUR },
                { "id": 120, "description": "2 " + scope.translation.text.HOURS },
                { "id": 180, "description": "3 " + scope.translation.text.HOURS },
                { "id": 240, "description": "4 " + scope.translation.text.HOURS },
                { "id": 300, "description": "5 " + scope.translation.text.HOURS },
                { "id": 360, "description": "6 " + scope.translation.text.HOURS },
                { "id": 420, "description": "7 " + scope.translation.text.HOURS },
                { "id": 480, "description": "8 " + scope.translation.text.HOURS },
                { "id": 540, "description": "9 " + scope.translation.text.HOURS },
                { "id": 600, "description": "10 " + scope.translation.text.HOURS },
                { "id": 660, "description": "11 " + scope.translation.text.HOURS },
                { "id": 720, "description": "12 " + scope.translation.text.HOURS },
                { "id": 1440, "description": "24 " + scope.translation.text.HOURS },
                { "id": 2880, "description": "48 " + scope.translation.text.HOURS },
                { "id": 4320, "description": "72 " + scope.translation.text.HOURS },
                { "id": 5760, "description": "4 " + scope.translation.text.DAYS },
                { "id": 7200, "description": "5 " + scope.translation.text.DAYS },
                { "id": 8640, "description": "6 " + scope.translation.text.DAYS },
                { "id": 10080, "description": "7 " + scope.translation.text.DAYS },
                { "id": 0, "description": scope.translation.text.INDEFINITELY }
            );

            scope._serviceModeEndTimeout(
                { "id": 30, "description": "30 " + scope.translation.text.MINUTES },
                { "id": 60, "description": "1 " + scope.translation.text.HOUR },
                { "id": 120, "description": "2 " + scope.translation.text.HOURS },
                { "id": 180, "description": "3 " + scope.translation.text.HOURS },
                { "id": 240, "description": "4 " + scope.translation.text.HOURS },
                { "id": 300, "description": "5 " + scope.translation.text.HOURS },
                { "id": 360, "description": "6 " + scope.translation.text.HOURS },
                { "id": 420, "description": "7 " + scope.translation.text.HOURS },
                { "id": 480, "description": "8 " + scope.translation.text.HOURS },
                { "id": 540, "description": "9 " + scope.translation.text.HOURS },
                { "id": 600, "description": "10 " + scope.translation.text.HOURS },
                { "id": 660, "description": "11 " + scope.translation.text.HOURS },
                { "id": 720, "description": "12 " + scope.translation.text.HOURS },
                { "id": 1440, "description": "24 " + scope.translation.text.HOURS },
                { "id": 2880, "description": "48 " + scope.translation.text.HOURS },
                { "id": 4320, "description": "72 " + scope.translation.text.HOURS },
                { "id": 5760, "description": "4 " + scope.translation.text.DAYS },
                { "id": 7200, "description": "5 " + scope.translation.text.DAYS },
                { "id": 8640, "description": "6 " + scope.translation.text.DAYS },
                { "id": 10080, "description": "7 " + scope.translation.text.DAYS },
                { "id": 0, "description": scope.translation.text.INDEFINITELY }
            );
        };

        scope._initializeSetting();

        //Log tab access event to NLog
        deviceNotificationSettingService.postUserAction2Nlog(scope.accountInfo.customerId, scope.deviceSelected).then(function (result) {
            //console.log(result);
        }, function (error) {
            // console.log(error);
        });

        scope.$on('updatePreferencesLanguage', function (event, args) {
            scope._initializeSetting();
        });

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {

                //Changing Device, back to "Basic Info" tab
                if (scope.currentDevice != newValue) return;

                scope.currentDevice = newValue;
                deviceNotificationSettingService.getData(scope.accountInfo.customerId, newValue)
                    .then(function (dataFromFactory) {
                        scope._getData(dataFromFactory.data);

                        deviceMenuService.getDeviceMenuList(scope.accountInfo.customerId)
                            .then(function (result) {
                                for (var index = 0; index < result.data.devices.length; ++index) {
                                    if (result.data.devices[index].deviceId === newValue) {
                                        scope.model = result.data.devices[index].model;
                                        break;
                                    }
                                }

                                scope.notBatteryPowered = batteryPoweredDevices.indexOf(scope.model) === -1;

                            }, function (error) {
                               //
                            });

                    });
            }
        }, true);

        scope._updateSwitchLabel = function () {
            scope.disabledLabel = scope.disabled == true ? scope.translation.text.OFF : scope.translation.text.ON;  
            scope.swingerLabel = scope.swinger == true ? scope.translation.text.OFF : scope.translation.text.ON; 
            scope.swingerAutoEnableLabel = scope.swingerAutoEnable == true ? scope.translation.text.OFF : scope.translation.text.ON; 
            scope.watchDogDisabledLabel = scope.watchDogDisabled == true ? scope.translation.text.OFF : scope.translation.text.ON; 
            scope.serviceModeEndLabel = scope.serviceModeEnd == true ? scope.translation.text.OFF : scope.translation.text.ON; 
            scope.serviceModeNotificationLabel = scope.serviceModeNotification == true ? scope.translation.text.OFF : scope.translation.text.ON;
            scope.sleepLabel = scope.sleep == true ? scope.translation.text.OFF : scope.translation.text.ON;
            $(".bootstrap-switch-label").css("color", "grey");
        }

        scope._getData = function (ntfData) {

            for (var i = 0; i < scope.calloutStatusTimeout.length; i++) {
                if (scope.calloutStatusTimeout[i].id === -1) {
                    scope.calloutStatusTimeout.splice(i, 1);
                    break;
                }
            }

            for (var i = 0; i < scope.serviceModeEndTimeout.length; i++) {
                if (scope.serviceModeEndTimeout[i].id === -1) {
                    scope.serviceModeEndTimeout.splice(i, 1);
                    break;
                }
            }

            scope.numberOfServiceUsers = ntfData.numberOfServiceUsers;
            scope.disabled = !ntfData.disabled;
            scope.disabledUntilTime = ntfData.disabledUntil;
            scope.calloutStatusApplicable = ntfData.disabledUntilApplicable; //determines whether the property should displayed on UI

            if (!scope.disabled && scope.disabledUntilTime) {
                if (scope.currentTime > moment(scope.disabledUntilTime).valueOf()) {
                    scope.disabled = true;
                    scope.disabledUntilTime = null;
                }
            }

            scope.serviceModeEnd = ntfData.serviceModeEnd != null ? true : false;
            scope.serviceModeEndUntilTime = ntfData.serviceModeEnd;
            scope.swinger = ntfData.swinger;
            scope.swingerModeApplicable = ntfData.swingerApplicable; //determines whether the property should displayed on UI
            scope.swingerAutoEnable = ntfData.swingerAutoEnable;
            scope.autoSwingerEnableApplicable = ntfData.swingerAutoEnableApplicable; //determines whether the property should displayed on UI
            scope.watchDogDisabled = !ntfData.watchDogDisabled;
            scope.watchDogAlertsApplicable = ntfData.watchDogDisabledApplicable; //determines whether the property should displayed on UI
            scope.serviceModeNotification = ntfData.serviceModeNotification;
            scope.serviceModeNotificationApplicable = ntfData.serviceModeNotificationApplicable; //determines whether the property should displayed on UI
            scope.sleep = ntfData.sleep; //Solar = 1 => Sleep; Solar = 0 => Awake
            scope._updateSwitchLabel();
            if (moment(scope.disabledUntilTime, moment.ISO_8601, true).isValid()) {
                var _tmpDataDisabledUntil = { "id": -1, "description": "Disabled Until " + $filter('filterDateAgentText')(scope.disabledUntilTime) }
                scope.calloutStatusTimeout.unshift(_tmpDataDisabledUntil);
                scope.disabledUntil = { "id": -1 };
                // Set the "disabledUntil" dropdown selection to the first option
                $timeout(function () {
                var selectDisabledUntil = document.getElementById("disabledUntilSelect");
                    if (selectDisabledUntil) selectDisabledUntil.selectedIndex = 0;
                });
            }
            else {
                // Set default value for "disabledUntil"
                scope.disabledUntil = scope.calloutStatusTimeout.find(function (item) {
                return item.id === ((!scope.disabled && scope.disabledUntilTime === null) ? 0 : -1);
                });
            }
            if (moment(scope.serviceModeEndUntilTime, moment.ISO_8601, true).isValid()) {                
                const inputDate = moment(scope.serviceModeEndUntilTime); 
                const today = moment();
                const diffDays = inputDate.startOf('day').diff(today.startOf('day'), 'days');                

                if (diffDays > 7) {
                    var _tmpData = { "id": -1, "description": "Indefinitely" }
                }
                else {
                    var _tmpData = { "id": -1, "description": "Service Mode Until " + $filter('filterDateAgentText')(scope.serviceModeEndUntilTime) }
                }
                
                scope.serviceModeEndTimeout.unshift(_tmpData);
                scope.serviceModeEndUntil = { "id": -1 };
                // Set the "serviceModeEndUntil" dropdown selection to the first option
                $timeout(function () {
                    var select = document.getElementById("serviceModeEndUntilSelect");
                    if (select) select.selectedIndex = 0;
                });
            }
            else {
                // Set default value for "serviceModeEndUntil"
                const targetId = (!scope.disabled && scope.serviceModeEndUntilTime === null) ? 0 : -1;
                scope.serviceModeEndUntil =  scope.serviceModeEndTimeout.find(function (item) {return item.id === targetId;});
            }
            scope.serviceModeApplicable = ntfData.serviceModeEndApplicable; //determines whether the property should displayed on UI

            scope.$emit('notificationTabDone', { message: 1 });            
        };

        scope.updateNotificationSetting = function (varValue, varProperty) {
            if (varProperty === "disabledUntil" && (!varValue || varValue.id === -1)) return;
            if (varProperty === "serviceModeEndUntil" && (!varValue || varValue.id === -1)) return;
            if (angular.isDefined(scope.updateStatusProperty)) return;
            scope.updateStatusProperty = varProperty;
            scope.resetUpdateIndicator();
            switch (varProperty) {
                case "disabled":
                    scope._updateSwitchLabel();
                    scope.updateStatusDisabled = scope.spinner;
                    varValue = !varValue;
                    break;
                case "disabledUntil":
                    scope.updateStatusDisabled = scope.spinner;
                    varValue = varValue.id;
                    break;
                case "swinger":
                    scope._updateSwitchLabel();
                    scope.updateStatusSwinger = scope.spinner;
                    break;
                case "swingerAutoEnable":
                    scope._updateSwitchLabel();
                    scope.updateStatusSwingerAutoEnable = scope.spinner;
                    break;
                case "watchDogDisabled":
                    scope._updateSwitchLabel();
                    scope.updateStatusWatchDogDisabled = scope.spinner;
                    varValue = !varValue;
                    break;
                case "serviceModeNotification":
                    scope._updateSwitchLabel();
                    scope.updateStatusServiceModeNotification = scope.spinner;
                    break;
                case "serviceModeEnd":
                    scope._updateSwitchLabel();
                    scope.updateStatusServiceModeEnd = scope.spinner;
                    varValue = varValue;
                    break;
                case "serviceModeEndUntil":
                    scope.updateStatusServiceModeEnd = scope.spinner;
                    varValue = varValue.id;
                    break;
                case "sleep":
                    scope._updateSwitchLabel();
                    scope.updateStatusSleep = scope.spinner;
            }

            var tmpDeviceNotificationSetting = { "op": "replace", "path": varProperty, "value": varValue };
            deviceNotificationSettingService.patchDeviceNotificationSetting(scope.accountInfo.customerId, scope.deviceSelected, scope.deviceSelectedName, tmpDeviceNotificationSetting)
                .then(function (results) {

                    switch (scope.updateStatusProperty) {
                        case "disabled":
                        case "disabledUntil":
                            scope.updateStatusDisabled = scope.okCheck;
                            break;
                        case "swinger":
                            scope.updateStatusSwinger = scope.okCheck;
                            break;
                        case "swingerAutoEnable":
                            scope.updateStatusSwingerAutoEnable = scope.okCheck;
                            break;
                        case "watchDogDisabled":
                            scope.updateStatusWatchDogDisabled = scope.okCheck;
                            break;
                        case "serviceModeNotification":
                            scope.updateStatusServiceModeNotification = scope.okCheck;
                            $rootScope.$broadcast('serviceModeNotificationUpdate', { deviceId: scope.deviceSelected, serviceModeNotification: scope.serviceModeNotification });
                            break;
                        case "serviceModeEnd":
                        case "serviceModeEndUntil":
                            scope.updateStatusServiceModeEnd = scope.okCheck;
                            break;
                        case "sleep":
                            scope.updateStatusSleep = scope.okChek;
                            break;
                    }

                    scope._getData(results.data);

                    scope.updateStatusProperty = undefined;
                    scope.alerts = [];
                    scope.alerts.push({ msg: "Success", type: "info" });

                }, function (error) {
                    switch (scope.updateStatusProperty) {
                        case "disabled":
                            scope.updateStatusDisabled = scope.errorCheck;
                            break;
                        case "swinger":
                            scope.updateStatusSwinger = scope.errorCheck;
                            break;
                        case "swingerAutoEnable":
                            scope.updateStatusSwingerAutoEnable = scope.errorCheck;
                            break;
                        case "watchDogDisabled":
                            scope.updateStatusWatchDogDisabled = scope.errorCheck;
                            break;
                        case "serviceModeNotification":
                            scope.updateStatusServiceModeNotification = scope.errorCheck;
                            break;
                        case "sleep":
                            scope.updateStatusSleep = scope.errorCheck;
                            break;
                    }
                });
        }

        scope.resetUpdateIndicator = function () {
            scope.updateStatusDisabled = scope.resetIndicator;
            scope.updateStatusSwinger = scope.resetIndicator;
            scope.updateStatusSwingerAutoEnable = scope.resetIndicator;
            scope.updateStatusWatchDogDisabled = scope.resetIndicator;
            scope.updateStatusServiceModeNotification = scope.resetIndicator;
            scope.updateStatusSleep = scope.reseteIndicator;
        };

        scope.resetUpdateIndicator();

        scope.$on('pagingServiceMode', function (event, args) {
            if (scope.deviceSelected == args.deviceId) {
                scope.updateStatusServiceModeEnd = scope.spinner;
                scope.updateStatusServiceModeEnd = scope.okCheck;
                scope._getData(args.data);
            }           
        });
    };
}]);

'use strict';

mcapp.factory("deviceNotificationSettingService", ["$http", "HOST", function ($http, HOST) {
    var deviceNotificationSettingFactory = {};
    var _getData = function _getData(customerId, deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DeviceNotificationSetting?customerId=' + customerId + "&deviceId=" + deviceId,
            cache: false
        });
    };

    var _getAllDeviceServiceModeNotifications = function _getAllDeviceServiceModeNotifications(customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DeviceNotificationSetting?customerId=' + customerId,
            cache: false
        });
    };

    var _patchDeviceNotificationSetting = function _patchDeviceNotificationSetting(customerId, deviceId, deviceName, deviceNotificationSetting) {
        return $http.patch(HOST + "/api/DeviceNotificationSetting?customerId=" + customerId + "&deviceId=" + deviceId + "&deviceName=" + deviceName, deviceNotificationSetting);
    };

    var _postUserAction2Nlog = function _postUserAction2Nlog(customerId, deviceId) {
        var action = "access RTU Setting";
        var tabName = "Notification";

        return $http({
            method: 'POST',
            url: HOST + '/api/DeviceNotificationSetting',
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    deviceNotificationSettingFactory.patchDeviceNotificationSetting = _patchDeviceNotificationSetting;
    deviceNotificationSettingFactory.getData = _getData;
    deviceNotificationSettingFactory.getAllDeviceServiceModeNotifications = _getAllDeviceServiceModeNotifications;
    deviceNotificationSettingFactory.postUserAction2Nlog = _postUserAction2Nlog;
    return deviceNotificationSettingFactory;
}]);
"use strict";

angular.module("mc.rep-schedule-legacy", []);
'use strict';

function RepScheduleLegacyFactory(HOST, $http) {

    // Instantiate the initial object
    var RepScheduleLegacy = function RepScheduleLegacy(customerId) {
        this.customerId = customerId;
        this.list = [];
    };

    // GET: Retrieve schedule data
    RepScheduleLegacy.prototype.getScheduleData = function () {
        var self = this;

        return $http.get(HOST + '/api/Notifications/RepScheduleLegacy', {
            params: {
                customerId: this.customerId
            }
        }).then(function (response) {
            self.list = response.data;
            return response;
        });
    };

    // PUT: Update cycle delay
    RepScheduleLegacy.prototype.updateCycleDelay = function (groupId, cycle, value) {
        return $http.put(HOST + '/api/Notifications/RepScheduleLegacy', null, {
            params: {
                customerId: this.customerId,
                groupId: groupId,
                cycle: cycle,
                value: value
            }
        });
    };

    // PATCH: Update on-duty status
    RepScheduleLegacy.prototype.updateOnDuty = function (id, onDuty) {
        return $http.patch(HOST + '/api/Notifications/RepScheduleLegacy', null, {
            params: {
                id: id,
                onDuty: onDuty
            }
        });
    };

    // PATCH: Update the team of a single schedule record
    RepScheduleLegacy.prototype.updateTeam = function (id, team) {
        return $http.post(HOST + '/api/Notifications/RepScheduleLegacy/UpdateTeam/', null, {
            params: {
                id: id,
                team: team
            }
        });
    };

    // POST: Add a service user + notify type to a cycle of a group
    RepScheduleLegacy.prototype.addContact = function (reportClass, cycle, notifyType, serviceUserId, team, onDuty) {
        return $http.post(HOST + '/api/Notifications/RepScheduleLegacy/AddContact/', null, {
            params: {
                customerId: this.customerId,
                reportClass: reportClass,
                cycle: cycle,
                notifyType: notifyType,
                serviceUserId: serviceUserId,
                team: team,
                onDuty: onDuty
            }
        });
    };

    // POST: Add Group a service user + notify type to a cycle of a group
    RepScheduleLegacy.prototype.addGroupAndSchedule = function (newGroupName, cycle, notifyType, serviceUserId, team, onDuty) {
        return $http.post(HOST + '/api/Notifications/RepScheduleLegacy/AddGroupAndSchedule/', null, {
            params: {
                customerId: this.customerId,
                newGroupName: newGroupName,
                cycle: cycle,
                notifyType: notifyType,
                serviceUserId: serviceUserId,
                team: team,
                onDuty: onDuty
            }
        });
    };

    // PUT: Set team on duty
    RepScheduleLegacy.prototype.setTeamOnDuty = function (dutyTeam) {
        return $http.put(HOST + '/api/Notifications/RepScheduleLegacy/SetTeamOnDuty/', null, {
            params: {
                customerId: this.customerId,
                dutyTeam: dutyTeam
            }
        });
    };

    // DELETE: Delete schedule record
    RepScheduleLegacy.prototype.deleteSchedule = function (id) {
        return $http.delete(HOST + '/api/Notifications/RepScheduleLegacy', {
            params: {
                id: id,
                customerId: this.customerId
            }
        });
    };

    // POST: Insert a new group
    RepScheduleLegacy.prototype.insertNewGroup = function (newGroupName) {
        return $http.post(HOST + '/api/Notifications/RepScheduleLegacy', null, {
            params: {
                customerId: this.customerId,
                newGroupName: newGroupName
            }
        });
    };

    // POST: Update group name
    RepScheduleLegacy.prototype.updateGroupName = function (reportClassId, group, groupName) {
        return $http.post(HOST + '/api/Notifications/RepScheduleLegacy/UpdateGroupName/', null, {
            params: {
                reportClassId: reportClassId,
                customerId: this.customerId,
                group: group,
                groupName: groupName
            }
        });
    };

    return RepScheduleLegacy;
}

RepScheduleLegacyFactory.$inject = ['HOST', '$http'];

angular.module('mc.rep-schedule-legacy').factory('RepScheduleLegacyFactory', RepScheduleLegacyFactory);
'use strict';

function RepScheduleLegacyController($, $rootScope, $scope, $timeout, $http, HOST, authenticationService, translationService, sharedSetupService, openViewService, RepScheduleLegacyFactory, unsavedChangesService, DestinationsFactory) {
    var ctrl = this;

    ctrl.scheduleGroups = [];
    ctrl.loading = false;
    ctrl.scheduleData = [];
    ctrl.loading = true;
    ctrl.translation = translationService.translation;
    var getNotifyTypes = function getNotifyTypes() {
        var t = ctrl.translation.text;
        return {
            11: { label: t.VOICE_STANDARD_NAME, icon: 'fa fa-phone' },
            12: { label: t.VOICE_SHORT_NAME, icon: 'fa fa-phone' },
            13: { label: t.VOICE_SHORT_9_NAME, icon: 'fa fa-phone' },
            14: { label: t.VOICE_SHORT_NO_ACK_NAME, icon: 'fa fa-phone' },
            15: { label: t.VOICE_SHORT_STAR_NAME, icon: 'fa fa-phone' },
            2: { label: t.EMAIL, icon: 'fa fa-envelope' },
            4: { label: t.FAX, icon: 'fa fa-fax' },
            17: { label: t.NUMERIC_PAGER, icon: 'fa fa-hdd-o' },
            8: { label: t.VOICE_PAGER, icon: 'fa fa-volume-up' },
            18: { label: 'SMS', icon: '' }
        };
    };
    var LANGUAGES = { 1: 'EN', 2: 'FR' };

    // voice type text shown after the number; same ids/translation keys as _voiceTypes in destinations-controller-es6.js
    var getVoiceTypeText = function getVoiceTypeText(notifyType) {
        var t = ctrl.translation.text;
        var names = {
            11: t.VOICE_STANDARD_NAME,
            12: t.VOICE_SHORT_NAME,
            13: t.VOICE_SHORT_9_NAME,
            14: t.VOICE_SHORT_NO_ACK_NAME,
            15: t.VOICE_SHORT_STAR_NAME
        };
        return names[notifyType] || '';
    };

    ctrl.timeoutOptions = [];
    for (var m = 1; m <= 60; m++) {
        ctrl.timeoutOptions.push(m);
    }ctrl.timeoutOptions.push(90, 120);

    ctrl.timeoutLabel = function (minutes) {
        if (minutes === 60) return '1 ' + ctrl.translation.text.HOUR;
        if (minutes === 90) return '1.5 ' + ctrl.translation.text.HOURS;
        if (minutes === 120) return '2 ' + ctrl.translation.text.HOURS;
        return minutes + ' ' + ctrl.translation.text.MINUTES;
    };

    ctrl.dynamicPopover = { templateUrl: 'repScheduleLegacyTeams.html' };
    ctrl.availableTeams = [];
    ctrl.tmpTeam = 0;
    ctrl.teamMode = 'contact';
    ctrl._teamContact = null;
    var NEW_GROUP_NAME = 'New Group';
    ctrl.newGroup = null;
    ctrl.cyclePopover = { templateUrl: 'repScheduleLegacyCycle.html' };
    ctrl._cycleGroup = null;
    ctrl.tmpCycle = 0;
    ctrl.serviceUsers = null;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.advancedMode = angular.isDefined(ctrl.accountInfo.notificationMode) ? ctrl.accountInfo.notificationMode : 1;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;

        ctrl.getData();

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            var px = function px(el, prop) {
                var v = el.length ? el.css(prop) : '';
                return parseFloat(String(v || '').replace(/[^0-9.]+/g, '')) || 0;
            };

            $scope.adjustSize = function () {
                var dlg = $scope.popup.parent();
                var _tmpHeight = px(dlg, "height");
                dlg.css("height", _tmpHeight);
                dlg.find('div:eq(2)').css("width", dlg.css("width"));
                dlg.find('div:eq(2)').css("min-width", px(dlg, "width"));
                dlg.find('div:eq(2)').css("height", px(dlg, "height") - px(dlg.find('div:eq(0)'), "height"));
                dlg.find('div:eq(2)').css("min-height", px(dlg, "height") - px(dlg.find('div:eq(0)'), "height"));
                dlg.find('.tabular-data-container').css("height", px(dlg, "height") - px(dlg.find('div:eq(0)'), "height") - 15); //15: total padding (this view has no fixed header/top-menu above the scroll area, so nothing else is subtracted)
            };

            if (window.ResizeObserver) {
                var lastWidth = 0;
                ctrl._resizeObserver = new ResizeObserver(function (entries) {
                    var w = Math.round(entries[0].contentRect.width);
                    if (w === lastWidth) return;
                    lastWidth = w;
                    $scope.adjustSize();
                });
                ctrl._resizeObserver.observe($scope.popup.parent()[0]);
            }
        }
    };

    // ---- keyboard / focus helpers ----
    function focusById(id) {
        $timeout(function () {
            var el = document.getElementById(id);
            if (el && !el.disabled) el.focus();
        }, 0);
    }

    ctrl._popoverTrigger = null;

    function rememberTrigger() {
        ctrl._popoverTrigger = document.activeElement;
    }

    function focusPopover() {
        $timeout(function () {
            var btn = $('.popover-team-selection button:not([disabled])').first();
            if (btn.length) btn.focus();
        }, 50);
    }

    ctrl.onPopoverKeydown = function ($event) {
        if ($event.key !== 'Escape') return;
        $event.stopPropagation();
        $timeout(function () {
            $(document.body).trigger('click');
        }, 0);
        var trigger = ctrl._popoverTrigger;
        if (trigger && document.body.contains(trigger)) $timeout(function () {
            trigger.focus();
        }, 0);
    };

    ctrl.onGroupNameKeydown = function ($event, group) {
        if ($event.key === 'Enter') {
            $event.preventDefault();
            ctrl.updateGroupName(group);
            if (!group.isNew) focusById('group-edit-btn-' + group.reportClass);
        } else if ($event.key === 'Escape') {
            $event.preventDefault();
            if (group.isNew) {
                ctrl.newGroup = null;focusById('rep-legacy-new-group-btn');return;
            }
            ctrl.cancelGroupNameEdit(group);
            focusById('group-edit-btn-' + group.reportClass);
        }
    };

    function api() {
        return new RepScheduleLegacyFactory(ctrl.accountInfo.customerId);
    }

    ctrl.getData = function () {
        ctrl.loading = true;
        api().getScheduleData().then(function (dataFromFactory) {
            ctrl.scheduleData = dataFromFactory.data || [];
            ctrl.scheduleGroups = ctrl.processScheduleData(ctrl.scheduleData);
            ctrl.loading = false;
            if (!ctrl.mobile && !ctrl.classicView) $timeout(function () {
                if ($scope.adjustSize) $scope.adjustSize();
            }, 0);
        }, function (error) {
            ctrl.loading = false;
            showError('GENERAL_SERVER_ERROR');
        });
    };

    ctrl.processScheduleData = function (rows) {
        var groups = [];
        var groupIndex = {};

        (rows || []).forEach(function (row) {
            var group = groupIndex[row.reportClass];
            if (!group) {
                group = {
                    reportClass: row.reportClass,
                    reportClassName: row.reportClassName,
                    reportClassID: row.reportClassID,
                    attempts: [],
                    _attemptIndex: {}
                };
                groupIndex[row.reportClass] = group;
                groups.push(group);
            }

            var attempt = group._attemptIndex[row.cycle];
            if (!attempt) {
                attempt = {
                    cycle: row.cycle,
                    timeout: row.cycleDelayValue,
                    repScheduleIDs: [],
                    contacts: []
                };
                group._attemptIndex[row.cycle] = attempt;
                group.attempts.push(attempt);
            }
            attempt.repScheduleIDs.push(row.repScheduleID);

            if (row.scheduleCustomerID !== 0) attempt.timeout = row.cycleDelayValue;
            if (row.serviceUserID > 0) attempt.contacts.push(ctrl.mapContact(row));
        });

        // sort attempts, make sure every timeout is in the dropdown, drop helper index
        groups.forEach(function (group) {
            group.attempts.sort(function (a, b) {
                return a.cycle - b.cycle;
            });
            group.attempts.forEach(function (a) {
                if (ctrl.timeoutOptions.indexOf(a.timeout) === -1) ctrl.timeoutOptions.push(a.timeout);
            });
            delete group._attemptIndex;
        });
        ctrl.timeoutOptions.sort(function (a, b) {
            return a - b;
        });

        return groups;
    };

    // pick the detail from the field that matches the notify type (same field mapping as notification-schedule-module)
    var getContactValue = function getContactValue(row) {
        var nt = row.notifyType;
        if (nt > 10 && nt < 16 || nt === 5 || nt === 6 || nt === 9) return row.voiceNumber1;
        switch (nt) {
            case 2:
                return row.eMail;
            case 4:
                return row.fax;
            case 17:
                return row.vPagerNum;
            case 8:
                return row.vvPagerNum;
            case 18:
                return row.smsNumber;
            default:
                return '';
        }
    };

    // 6789690541,,,,1005 -> 678-969-0541,,,,1005 (same look as the already formatted fax numbers); emails and non 10 digit values stay as they are
    var formatPhoneDetail = function formatPhoneDetail(value) {
        return (value || '').replace(/^(\d{3})(\d{3})(\d{4})(?=\D|$)/, '$1-$2-$3');
    };

    ctrl.mapContact = function (row) {
        var type = getNotifyTypes()[row.notifyType] || { label: 'Unknown', icon: 'fa fa-question' };
        var value = getContactValue(row);
        if (row.notifyType !== 2) value = formatPhoneDetail(value);

        return {
            repScheduleID: row.repScheduleID,
            serviceUserID: row.serviceUserID,
            notifyType: row.notifyType,
            onDuty: row.onDuty,
            disabled: row.disabled,
            firstName: row.fName || '',
            lastName: row.lName || '',
            methodLabel: type.label,
            methodIcon: type.icon,
            detail: value || '',
            voiceType: getVoiceTypeText(row.notifyType),
            language: LANGUAGES[row.languageID] ? '(' + LANGUAGES[row.languageID] + ')' : '',
            team: row.team !== '0' ? 'Team ' + row.team : '',
            teamNumber: parseInt(row.team, 10) || 0,
            isDefault: row.scheduleCustomerID === 0
        };
    };

    var ALERT_TIMEOUT_MS = 5000;
    var alertTimer = null;

    function clearAlerts() {
        if (alertTimer) $timeout.cancel(alertTimer);
        alertTimer = null;
        $scope.alerts = [];
    }

    // show the error at the top, then hide it again after a few seconds
    function showError(code, customMessage) {
        clearAlerts();
        $scope.alerts.push({ msg: customMessage || ctrl.translation.message[code || 'GENERAL_SERVER_ERROR'], type: 'danger', languageCode: code || 'GENERAL_SERVER_ERROR' });
        alertTimer = $timeout(clearAlerts, ALERT_TIMEOUT_MS);
    }

    // on failure: tell the user and reload so the UI matches the server again
    function onSaveError() {
        showError('GENERAL_SERVER_ERROR');
        ctrl.getData();
    }

    ctrl.onTimeoutChange = function (group, attempt) {
        api().updateCycleDelay(group.reportClass, attempt.cycle, attempt.timeout).catch(onSaveError);
    };

    ctrl.onDutyChange = function (contact) {
        api().updateOnDuty(contact.repScheduleID, !!contact.onDuty).catch(onSaveError);
    };

    function allContacts() {
        var list = [];
        ctrl.scheduleGroups.forEach(function (g) {
            g.attempts.forEach(function (a) {
                list = list.concat(a.contacts);
            });
        });
        return list;
    }

    ctrl.getTeam = function (contact) {
        ctrl.teamMode = 'contact';
        ctrl._teamContact = contact;
        ctrl.tmpTeam = contact.teamNumber;
        rememberTrigger();
        focusPopover();
    };

    ctrl.prePlaceTeamOnDuty = function () {
        ctrl.teamMode = 'place';
        ctrl._teamContact = null;
        ctrl.tmpTeam = -1;
        ctrl.availableTeams = [];
        rememberTrigger();
        focusPopover();
        allContacts().forEach(function (c) {
            if (c.teamNumber > 0 && ctrl.availableTeams.indexOf(c.teamNumber) === -1) ctrl.availableTeams.push(c.teamNumber);
        });
    };

    ctrl.selectTeam = function (team) {
        if (ctrl.teamMode === 'place') ctrl.placeTeamOnDuty(team);else ctrl.updateTeam(ctrl._teamContact, team);
    };

    ctrl.updateTeam = function (contact, team) {
        if (!contact) return;
        contact.teamNumber = contact.teamNumber === team ? 0 : team;
        contact.team = contact.teamNumber > 0 ? 'Team ' + contact.teamNumber : '';
        ctrl.onTeamChange(contact);
    };

    ctrl.placeTeamOnDuty = function (team) {
        ctrl.loading = true;
        api().setTeamOnDuty(team).then(function () {
            ctrl.getData();
        }, function () {
            ctrl.loading = false;
            showError('GENERAL_SERVER_ERROR');
        });
    };

    ctrl.removeContact = function (contact) {
        ctrl.loading = true;
        api().deleteSchedule(contact.repScheduleID).then(function () {
            ctrl.getData();
        }, function () {
            ctrl.loading = false;
            showError('GENERAL_SERVER_ERROR');
        });
    };

    ctrl.onTeamChange = function (contact) {
        if (contact.isDraft) return;
        api().updateTeam(contact.repScheduleID, contact.teamNumber).catch(onSaveError);
    };

    function isGroupNameTaken(name, self) {
        var wanted = (name || '').trim().toLowerCase();
        return (ctrl.scheduleGroups || []).some(function (g) {
            return g !== self && (g.reportClassName || '').trim().toLowerCase() === wanted;
        });
    }

    ctrl.editGroupName = function (group) {
        group.editName = group.reportClassName;
        group.editing = true;
        $timeout(function () {
            $('#group-name-input-' + group.reportClass).focus().select();
        }, 0);
    };

    ctrl.cancelGroupNameEdit = function (group) {
        if (group.isNew) return;
        group.editing = false;
        group.editName = group.reportClassName;
    };

    ctrl.updateGroupName = function (group) {
        if (!group || !group.editing) return;
        group.editing = false;

        var newName = (group.editName || '').trim();
        if (!newName || newName === group.reportClassName) {
            group.editName = group.reportClassName;
            return;
        }

        if (isGroupNameTaken(newName, group)) {
            group.editName = group.reportClassName;
            showError('GENERAL_SERVER_ERROR', 'A group with this name already exists.');
            return;
        }

        var firstAttempt = group.attempts[0];
        var recordId = firstAttempt && firstAttempt.repScheduleIDs[0];
        if (!recordId) return;

        api().updateGroupName(group.reportClassID, group.reportClass, newName).then(function () {
            group.reportClassName = newName;
        }, function () {
            group.editName = group.reportClassName;
            showError('GENERAL_SERVER_ERROR');
        });
    };

    function nextNewGroupName() {
        var used = {};
        ctrl.scheduleGroups.forEach(function (g) {
            used[(g.reportClassName || '').trim().toLowerCase()] = true;
        });
        var n = 1;
        while (used[(NEW_GROUP_NAME + ' ' + n).toLowerCase()]) {
            n++;
        }return NEW_GROUP_NAME + ' ' + n;
    }

    ctrl.addNewGroup = function () {
        if (ctrl.newGroup) return;
        loadServiceUsers();
        ctrl.newGroup = {
            reportClass: 'new',
            reportClassName: '',
            editName: nextNewGroupName(),
            isNew: true,
            attempts: [{
                cycle: 1,
                isNew: true,
                repScheduleIDs: [],
                contacts: [],
                draft: { isDraft: true, serviceUserId: null, notifyType: null, methods: [], teamNumber: 0, onDuty: true, saving: false }
            }]
        };
        $timeout(function () {
            $('#group-name-input-new').focus().select();
        }, 0);
    };

    ctrl.preSelectCycle = function (group) {
        ctrl._cycleGroup = group;
        ctrl.tmpCycle = 0;
        rememberTrigger();
        focusPopover();
    };

    ctrl.isCycleDisabled = function (cycle) {
        var group = ctrl._cycleGroup;
        if (!group) return true;
        return group.attempts.some(function (a) {
            return a.cycle === cycle && !a.isNew;
        });
    };

    ctrl.selectCycle = function (cycle) {
        var group = ctrl._cycleGroup;
        if (!group || ctrl.isCycleDisabled(cycle)) return;

        group.attempts = group.attempts.filter(function (a) {
            return !a.isNew;
        });

        ctrl.tmpCycle = cycle;
        loadServiceUsers();
        group.attempts.push({
            cycle: cycle,
            isNew: true, // not on the BE yet, created together with its first contact on Save
            repScheduleIDs: [],
            contacts: [],
            draft: { isDraft: true, serviceUserId: null, notifyType: null, methods: [], teamNumber: 0, onDuty: true, saving: false }
        });
        group.attempts.sort(function (a, b) {
            return a.cycle - b.cycle;
        });
        $timeout(function () {
            $(document.body).trigger('click');
        }, 0); // close the popover
        focusById('draft-method-' + group.reportClass + '-' + cycle);
    };

    function loadServiceUsers() {
        if (ctrl.serviceUsers) return;
        ctrl.serviceUsers = [];
        new DestinationsFactory(ctrl.accountInfo.customerId).getData().then(function (response) {
            ctrl.serviceUsers = (response.data.serviceUsers || []).filter(function (u) {
                return u.disabled !== 1;
            });
        }, function () {
            ctrl.serviceUsers = null;
            showError('GENERAL_SERVER_ERROR');
        });
    }

    // notify types a user can actually be notified by (same ids the notification schedule uses)
    ctrl.getMethodOptions = function (user) {
        var t = ctrl.translation.text;
        var list = [];
        if (!user) return list;
        if (user.voiceNumber) {
            // every voice type is selectable (same order as _voiceTypes in destinations); the user's own type goes first
            var defaultType = user.voiceType > 10 && user.voiceType < 16 ? user.voiceType : 12;
            var voiceTypeIds = [12, 11, 13, 15, 14];
            voiceTypeIds.splice(voiceTypeIds.indexOf(defaultType), 1);
            voiceTypeIds.unshift(defaultType);
            var notifyTypes = getNotifyTypes();
            voiceTypeIds.forEach(function (id) {
                list.push({ notifyType: id, label: notifyTypes[id].label, detail: user.voiceNumber });
            });
        }
        if (user.email) list.push({ notifyType: 2, label: t.EMAIL, detail: user.email });
        if (user.fax) list.push({ notifyType: 4, label: t.FAX, detail: user.fax });
        if (user.numericPager) list.push({ notifyType: 17, label: t.NUMERIC_PAGER, detail: user.numericPager });
        if (user.voicePager) list.push({ notifyType: 8, label: t.VOICE_PAGER, detail: user.voicePager });
        if (user.smsNumber) list.push({ notifyType: 18, label: 'SMS', detail: (user.countryCode ? user.countryCode + '-' : '') + user.smsNumber });
        return list;
    };

    ctrl.userName = function (user) {
        return user.firstName + ' ' + user.lastName;
    };

    function findUser(id) {
        return (ctrl.serviceUsers || []).filter(function (u) {
            return u.serviceUserId === id;
        })[0];
    }

    // user changed -> method list changes, preselect the first method
    ctrl.onDraftUserChange = function (draft) {
        var options = ctrl.getMethodOptions(findUser(draft.serviceUserId));
        draft.methods = options;
        draft.notifyType = options.length ? options[0].notifyType : null;
    };

    ctrl.draftDetail = function (draft) {
        var m = (draft.methods || []).filter(function (o) {
            return o.notifyType === draft.notifyType;
        })[0];
        return m ? m.notifyType === 2 ? m.detail : formatPhoneDetail(m.detail) : '';
    };

    ctrl.addCycle = function (group, attempt) {
        if (attempt.draft) return;
        loadServiceUsers();
        attempt.draft = { isDraft: true, serviceUserId: null, notifyType: null, methods: [], teamNumber: 0, onDuty: true, saving: false };
        focusById('draft-method-' + group.reportClass + '-' + attempt.cycle);
    };

    ctrl.cancelDraft = function (attempt, group) {
        attempt.draft = null;
        if (group && group.isNew) {
            ctrl.newGroup = null;focusById('rep-legacy-new-group-btn');return;
        } // back to the normal list
        if (attempt.isNew && group) group.attempts = group.attempts.filter(function (a) {
            return a !== attempt;
        });
        if (group) focusById('group-edit-btn-' + group.reportClass);
    };

    ctrl.isDraftValid = function (attempt) {
        var d = attempt.draft;
        return !!(d && d.serviceUserId && d.notifyType);
    };

    ctrl.saveDraft = function (group, attempt) {
        var d = attempt.draft;
        if (!ctrl.isDraftValid(attempt) || d.saving) return;
        if (group.isNew) {
            group.reportClassName = (group.editName || '').trim();
            if (!group.reportClassName) return;
            if (isGroupNameTaken(group.reportClassName, group)) {
                showError('GENERAL_SERVER_ERROR', 'A group with this name already exists.');
                return;
            }
        }

        var duplicate = attempt.contacts.some(function (c) {
            return c.serviceUserID === d.serviceUserId && c.notifyType === d.notifyType;
        });
        if (duplicate) {
            showError('GENERAL_SERVER_ERROR', 'This user and method already exist in this notification attempt.');
            return;
        }

        d.saving = true;
        var request = group.isNew ? api().addGroupAndSchedule(group.reportClassName, attempt.cycle, d.notifyType, d.serviceUserId, d.teamNumber || 0, !!d.onDuty) : api().addContact(group.reportClass, attempt.cycle, d.notifyType, d.serviceUserId, d.teamNumber || 0, !!d.onDuty);
        request.then(function () {
            ctrl.newGroup = null;
            ctrl.getData();
        }, function () {
            d.saving = false;
            showError('GENERAL_SERVER_ERROR');
        });
    };

    $scope.$on('updateNotificationMode', function (event, msg) {
        ctrl.advancedMode = msg;
    });

    $scope.$on('updatePreferencesLanguage', function () {});

    $scope.$on("$destroy", function () {
        if (ctrl._resizeObserver) ctrl._resizeObserver.disconnect();
        if (alertTimer) $timeout.cancel(alertTimer);
    });
};

RepScheduleLegacyController.$inject = ['$', '$rootScope', '$scope', '$timeout', '$http', 'HOST', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'RepScheduleLegacyFactory', 'unsavedChangesService', 'DestinationsFactory'];
'use strict';

angular.module('mc.rep-schedule-legacy').component('repScheduleLegacyComp', {
    controller: RepScheduleLegacyController,
    transclude: true,
    templateUrl: 'ui/repScheduleLegacy/rep-schedule-legacy-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.controller('pumpTableController', ['$scope', '$rootScope', 'sharedSetupService', 'openViewService', 'translationService', '$element', 'detectBrowserService', 'authenticationService', function ($scope, $rootScope, sharedSetupService, openViewService, translationService, $element, detectBrowserService, authenticationService) {
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.runtimeScale = $scope.accountInfo.preferenceCustomer.lookupRuntimeScale;
    $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.alerts = [];
    $scope.fontSizeDefault = ".95em";
    $scope.fontSize = ".95em";
    $scope.dataFormat = $scope.stickyProperties && $scope.stickyProperties.dataFormat == "D" ? "D" : "H";
    $scope.runtimeType = $scope.stickyProperties && $scope.stickyProperties.runtimeType == "R" ? 'R' : 'G';
    $scope.varTopMenuToggle = $scope.dataFormat;
    $scope.dataFormatDailyAdjustment = 0;//15 * $scope.unixDay;
    $scope.hoverDblClick = false;
    $scope.varTopMenuToggleA = undefined;

    $scope.currentRecord = NaN;
    $scope.curentBrowser = detectBrowserService();

    $scope.$on('updatePreferenceRuntime', function (event, message) {
        $scope.pumpTableService.runtimeScale = message.runtimeScale;
        $scope.runtimeScale = message.runtimeScale;
        $scope.mostRecentData();
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
    });

    loadTranslations = function () {
        $scope.lblDialy = $rootScope.mobile ? ($scope.translation.text.DAILY).substring(0, 1) : $scope.translation.text.DAILY;
        $scope.lblHourly = $rootScope.mobile ? ($scope.translation.text.HOURLY).substring(0, 1) : $scope.translation.text.HOURLY;
        $scope.lblGallons = $rootScope.mobile ? ($scope.translation.text.PUMP_GALLONS).substring(0, 1) : $scope.translation.text.PUMP_GALLONS;
        $scope.lblLiters = $rootScope.mobile ? ($scope.translation.text.PUMP_LITERS).substring(0, 1) : $scope.translation.text.PUMP_LITERS;
        $scope.lblRuntime = $rootScope.mobile ? ($scope.translation.text.PUMP_RUNTIME).substring(0, 1) : $scope.translation.text.PUMP_RUNTIME;
        $scope.lblSimultaneous = $scope.translation.text.SIMULTANEOUS;
        $scope.lblMultiple = $scope.translation.text.MULTIPLE;
    };

    loadTranslations();

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);
        $scope.popup.dialog({
            resize: function (event, ui) {
                //$scope.setFontSize();
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                //$scope.setFontSize();
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
                //$scope.setFontSize();
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            //$scope.adjustDeviceIdMenuSize();
        };

        $scope.adjustDeviceIdMenuSize = function () {
            var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")
            if (spph < 450) {
                $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            }
            else {
                $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        };
    }

    $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
        if (measurementSystem === 1) {
            $scope.pumpTableService.measurementUnit = 'Gallon';
            if ($scope.pumpTableService.pumpToggle === 'L') {
                $scope.pumpTableService.pumpToggle = 'G';
                $scope.pumpTableService.settingColumns = [];
                for (var i = 0; i < $scope.pumpTableService.setting.length; i++) {
                    $scope.pumpTableService.settingColumns.push({ id: $scope.translation.text.PUMP_GALLONS.charAt(0), name: $scope.translation.text.PUMP_GALLONS, unit: '' }, { id: $scope.translation.text.PUMP_STARTS.charAt(0), name: $scope.translation.text.PUMP_STARTS, unit: '' });
                }

                for (var i = 0; i < $scope.pumpTableService.items.length; i++) {
                    for (var j = 0; j < $scope.pumpTableService.items[i].gallons.length; j++) {
                        $scope.pumpTableService.items[i].gallons[j].value = $scope.pumpTableService.items[i].gallons[j].value / 3.78541;
                    }
                }
                console.log($scope.pumpTableService.items);
            }
        } else if (measurementSystem === 2) {
            $scope.pumpTableService.measurementUnit = 'Liter';
            if ($scope.pumpTableService.pumpToggle === 'G') {
                $scope.pumpTableService.pumpToggle = 'L';
                $scope.pumpTableService.settingColumns = [];
                for (var i = 0; i < $scope.pumpTableService.setting.length; i++) {
                    $scope.pumpTableService.settingColumns.push({ id: $scope.translation.text.PUMP_LITERS.charAt(0), name: $scope.translation.text.PUMP_LITERS, unit: '' }, { id: $scope.translation.text.PUMP_STARTS.charAt(0), name: $scope.translation.text.PUMP_STARTS, unit: '' });
                }

                for (var i = 0; i < $scope.pumpTableService.items.length; i++) {
                    for (var j = 0; j < $scope.pumpTableService.items[i].gallons.length; j++) {
                        $scope.pumpTableService.items[i].gallons[j].value = $scope.pumpTableService.items[i].gallons[j].value * 3.78541;
                    }
                }
                console.log($scope.pumpTableService.items);
            }
        }
    });

    $scope.fnTopMenuToggleA = function () {
        $scope.pumpTableService.settingColumns = [];
        switch ($scope.pumpTableService.pumpToggle) {
            case "R":
                for (var i = 0; i < $scope.pumpTableService.setting.length; i++) {
                    switch ($scope.pumpTableService.measurementUnit) {
                        case "Gallon":
                            $scope.pumpTableService.settingColumns.push({ id: $scope.translation.text.PUMP_GALLONS.charAt(0), name: $scope.translation.text.PUMP_GALLONS, unit: '' }, { id: $scope.translation.text.PUMP_STARTS.charAt(0), name: $scope.translation.text.PUMP_STARTS, unit: '' });
                            $scope.pumpTableService.pumpToggle = "G";
                            break;
                        case "Liter":
                            $scope.pumpTableService.settingColumns.push({ id: $scope.translation.text.PUMP_LITERS.charAt(0), name: $scope.translation.text.PUMP_LITERS, unit: '' }, { id: $scope.translation.text.PUMP_STARTS.charAt(0), name: $scope.translation.text.PUMP_STARTS, unit: '' });
                            $scope.pumpTableService.pumpToggle = "L";
                            break;
                    }
                }
                break;
            case "G":
            case "L":
                $scope.pumpTableService.pumpToggle = "R";
                for (var i = 0; i < $scope.pumpTableService.setting.length; i++) {
                    $scope.pumpTableService.settingColumns.push({ id: $scope.translation.text.PUMP_RUNTIME.charAt(0), name: $scope.translation.text.PUMP_RUNTIME, unit: '(' + $scope.pumpTableService.runtimeScale + ')' }, { id: $scope.translation.text.PUMP_STARTS.charAt(0), name: $scope.translation.text.PUMP_STARTS, unit: '' });
                }
                break;
        }
    };

    $scope.$on('updatePreferencesLanguage', function () {
        $scope.pumpTableService.items = angular.copy($scope.pumpTableService.items);
        $scope.fnTopMenuToggleA();
        loadTranslations();
    });
}]);

mcapp.directive('drawPumpData', ['$timeout', 'pumpTableService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', function ($timeout, pumpTableService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        scope.downloadViewTypeOptions = [0, 4];
        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

        scope.setFontSize = function () {
            //var dialogWidth = scope.popup.dialog("option", "width");
            var cellWidth = element.find('td:eq(0)').css("width");
            scope.fontSize = (parseFloat(cellWidth) / 10) < 8 ? 8 : (parseFloat(cellWidth) / 10) > 12 ? scope.fontSizeDefault : (parseFloat(cellWidth) / 10);
            scope.$apply();
        };

        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        element.on('scroll', function (event) {
            var $rowFirst = element.contents().find("tr:first");
            var $rowLast = element.contents().find("tr:last");
            var _firstRow = $rowFirst.attr("name");
            if (typeof $rowFirst.position() !== "undefined") {
                scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
                var _tableTop = element.offset().top;
                var _rowTop = $rowFirst.offset().top;
                _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
                previousScrollbarPosition = currentScrollbarPosition;
                currentScrollbarPosition = element[0].scrollTop;
            }

            if (scope.infiniteScrollOn === true) {
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;

                if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
                    $rowLast.addClass("active-row");
                    scope.pumpTableService.alerts = [];
                    scope.pumpTableService.nextPage();
                }
                if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
                    $rowFirst.addClass("active-row");
                    scope.pumpTableService.alerts = [];
                    scope.pumpTableService.previousPage();
                }
            }

            var rows = element.children().children().children().children();
            var scrollpos = 40;
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos)
                    start = mid + 1;
                else
                    end = mid;
            }
            _updateZoom(parseFloat($($(rows[start])).attr("name")));
        });

        var _updateZoom = function (currentRow) {
            if (isNaN(currentRow))
                return;
            scope.currentRecord = new Date(currentRow).toISOString();
            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            }
            else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('pumpTableService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        scope.newPumpTableService = function () {
            scope.pumpTableService = new pumpTableService();
            scope.pumpTableService.customerId = scope.accountInfo.customerId;
            scope.pumpTableService.deviceId = scope.deviceSelected;
            scope.pumpTableService.windowTitle = scope.windowTitle;
            scope.pumpTableService.startRow = 1;
            scope.pumpTableService.pumpToggle = scope.varTopMenuToggleA;
            scope.dataFormat = scope.stickyProperties.dataFormat == "D" ? "D" : "H";//(scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) > scope.unixDay ? "D" : "H";
            scope.dataFormatDailyAdjustment = scope.dataFormat == "H" ? 0 : 60 * scope.unixDay;
            scope.pumpTableService.pageSize = scope.dataFormat == "D" ? 50 : 50;
            scope.pumpTableService.dataFormat = scope.dataFormat;
            scope.pumpTableService.alerts = [];
            scope.runtimeType = scope.stickyProperties.runtimeType == "R" ? "R" : 'G';
            scope.pumpTableService.runtimeType = scope.runtimeType;
            scope.pumpTableService.runtimeScale = scope.runtimeScale;
        };

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                scope.alerts = [];
                /////////////////////////////////////////////////////////////
                currentScrollbarPosition = 0;
                previousScrollbarPosition = 0;
                scope.checkFirstRowLiveStatus = null;
                /////////////////////////////////////////////////////////////
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, dataFormat: scope.dataFormat, runtimeType: scope.runtimeType,  windowId: scope.windowId });

                if (scope.stickyProperties.savedDesktop === true && scope.stickyProperties.on === true && scope.stickyProperties.device.channel !== "1" && scope.stickyProperties.dateMin !== null) {
                    scope.savedDesktopRow = scope.stickyProperties.zoomMax;
                    scope.stickyProperties.on = true;
                    scope.stickyProperties.savedDesktop = false;
                    scope.newPumpTableService();
                    scope.pumpTableService.pageSize = 500;
                    if (scope.curentBrowser == "ie")
                        scope.pumpTableService.pageSize = 100;
                    scope.pumpTableService.start = scope.stickyProperties.dateMin;
                    scope.pumpTableService.end = scope.stickyProperties.dateMax;
                    scope.pumpTableService.nextPage();
                }
                else if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMin !== null) {
                    scope.stickyProperties.on = true;
                    timeLapseService.getLocalDateTime().then(function (result) {
                        if ((scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && scope.stickyProperties.zoomMax + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) || scope.stickyProperties.device.channel == "1") {
                            scope.newPumpTableService();

                            var start = new Date();
                            start.setDate(start.getDate() - 2);
                            start.setHours(20, 0, 0, 0);
                            var startUnix = start.getTime();
                            var end = new Date();
                            end.setDate(end.getDate() + 1);
                            end.setHours(20, 0, 0, 0);
                            var endUnix = end.getTime();

                            //scope.pumpTableService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay) - scope.dataFormatDailyAdjustment; //need to extend data range
                            //scope.pumpTableService.end = scope.stickyProperties.dateMax;
                            scope.pumpTableService.start = startUnix - (3 * scope.unixDay) - scope.dataFormatDailyAdjustment;
                            scope.pumpTableService.end = endUnix;
                            scope.pumpTableService.nextPage();
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { device: { channel: 1 } }); //set channel to 1 to indicate current data is live
                        }
                        else {
                            scope.newPumpTableService();
                            scope.pumpTableService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay) - scope.dataFormatDailyAdjustment; //need to extend data range
                            scope.pumpTableService.end = Math.round((scope.stickyProperties.zoomMax + scope.stickyProperties.zoomMin) / 2);
                            scope.pumpTableService.nextPage();
                        }
                    });
                }
                else {
                    scope.stickyProperties.on = false;
                    timeLapseService.getLocalDateTime().then(function (result) {
                        /////////////////////////////////////////////////////////////
                        var tmpDates = new Date(result.data.localDateTime);
                        var tmpDatesA = tmpDates;
                        tmpDates.setHours(0, 0, 0, 0);
                        tmpDates = datetimeService.dateToUnixtime(tmpDates);
                        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                        tmpDatesA.setHours(23, 59, 59, 0);
                        tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
                        /////////////////////////////////////////////////////////////
                        scope.newPumpTableService();
                        scope.pumpTableService.start = tmpDates.startDate - scope.dataFormatDailyAdjustment;
                        scope.pumpTableService.end = tmpDatesA;
                        scope.pumpTableService.nextPage();
                        /////////////////////////////////////////////////////////////
                    });
                }
            }
        }, true);

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                if (oldValue) {
                    _unRegisterListener(oldValue);
                }
            }
        }, true);

        scope.selectMyDate = function (date) {
            scope.myDate = date;
            scope.alerts = [];
            scope.pumpTableService = new pumpTableService();
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            _unRegisterListener(scope.deviceSelectedSn);
            /////////////////////////////////////////////////////////////
            var isLiveData = 1; //1 indicates the data is live, 2 indicates the data is not live
            var tmpDates = new Date(scope.myDate.getTime());
            tmpDates.setDate(tmpDates.getDate());
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            tmpDatesA.setHours(23, 59, 59, 0); //this is tricky ...
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            scope.dataFormat = scope.stickyProperties.dataFormat == "D" ? "D" : "H";//(scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) > scope.unixDay ? "D" : "H";
            scope.dataFormatDailyAdjustment = scope.dataFormat == "H" ? 0 : 60 * scope.unixDay;
            scope.pumpTableService.dataFormat = scope.dataFormat;
            scope.runtimeType = scope.stickyProperties.runtimeType == "R" ? "R" : 'G';
            scope.pumpTableService.runtimeType = scope.runtimeType;
            /////////////////////////////////////////////////////////////
            scope.pumpTableService.start = tmpDates.startDate - scope.dataFormatDailyAdjustment;
            if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                scope.pumpTableService.end = tmpDatesA;
                isLiveData = 2;
            }
            else {
                scope.pumpTableService.end = tmpDates.endDate;
            }
            /////////////////////////////////////////////////////////////
            scope.pumpTableService.startRow = 1;
            scope.pumpTableService.pageSize = scope.dataFormat == "D" ? 50 : 50;
            scope.pumpTableService.pumpToggle = scope.varTopMenuToggleA;
            scope.pumpTableService.customerId = scope.accountInfo.customerId;
            scope.pumpTableService.deviceId = scope.deviceSelected;
            scope.pumpTableService.windowTitle = scope.windowTitle;
            scope.pumpTableService.runtimeScale = scope.runtimeScale;
            scope.pumpTableService.alerts = [];
            scope.pumpTableService.nextPage();
            /////////////////////////////////////////////////////////////
            sharedSetupService.setStickyProperties(scope.stickyProperties, { device: { channel: isLiveData }, deviceId: scope.deviceSelected, dataFormat: scope.dataFormat, runtimeType: scope.runtimeType, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
        };

        var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            }
            else if (scope.checkFirstRowLiveStatus === null) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.checkFirstRowLiveStatus = true;
                        _checkTopOffset(liveDataStatusOn);
                    }
                    else {
                        scope.checkFirstRowLiveStatus = false;
                    }
                });
            }
        };

        var _checkTopOffset = function (liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListener(scope.deviceSelectedSn);
            }
            else {
                _unRegisterListener(scope.deviceSelectedSn);
            }
        };

        scope.mostRecentData = function () {
            scope.liveData = true;
            wsReconnectPUMP(true);
        }

        var wsReconnectPUMP = function (isRefresh) {
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            if (isRefresh) {
                var start = new Date();
                start.setDate(start.getDate() - 2);
                start.setHours(20, 0, 0, 0);
                var startUnix = start.getTime();
                var end = new Date();
                end.setDate(end.getDate() + 1);
                end.setHours(20, 0, 0, 0);
                var endUnix = end.getTime();

                scope.pumpTableService.start = startUnix - (3 * scope.unixDay) - scope.dataFormatDailyAdjustment;
                scope.pumpTableService.end = endUnix;
            } else {
                scope.pumpTableService.start = scope.stickyProperties.dateMin;
                scope.pumpTableService.end = scope.stickyProperties.dateMax;
            }

            toaster.pop('success', scope.windowTitle + " -- " + scope.pumpTableService.deviceName, 'View reloading');
            scope.stickyProperties.on = true;
            scope.pumpTableService.items = [];
            scope.pumpTableService.setting = [];
            scope.pumpTableService.settingColumns = [];
            scope.pumpTableService.numberOfReturnedRecords = -1;
            scope.pumpTableService.numberOfNewRecordsPrevious = -1;
            scope.pumpTableService.startRow = 1;
            scope.pumpTableService.pageSize = 10000;
            scope.pumpTableService.pumpToggle = scope.varTopMenuToggleA;
            scope.pumpTableService.runtimeScale = scope.runtimeScale;
            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.stickyProperties.deviceId, windowId: scope.windowId });
            scope.pumpTableService.alerts = [];
            scope.pumpTableService.nextPage();
        };

        var _registerListener = function (varSelectedSN) {
            if (scope.liveData === true)
                return;
            scope.liveData = true;
            scope.pumpTableService.numberOfNewRecordsPrevious = -1;
            websocketService.connect();
            websocketService.register("PUMP", varSelectedSN, "", null, wsReconnectPUMP);
        };

        var _unRegisterListener = function (varSelectedSN) {
            if (scope.liveData === false)
                return;
            scope.liveData = false;
            scope.lastUpdateAt = undefined;
            websocketService.unRegister("PUMP", varSelectedSN, "", null, wsReconnectPUMP);
        };

        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            //scope.setFontSize();
            _autoScroll();
            scope.checkFirstRowLiveStatus = null;
        });

        var _autoScroll = function () {
            if (scope.pumpTableService.numberOfNewRecordsPrevious > 0) {
                // newer rows were added on top: keep the previously first row in view, a little below the top
                var trRow = element.find('tr').eq(scope.pumpTableService.numberOfNewRecordsPrevious);
                if (trRow.length > 0) {
                    var rowTop = trRow.offset().top - element.offset().top + element[0].scrollTop;
                    element.scrollTop(Math.max(rowTop - 90, 6));
                }
            }
            else {
                $timeout(function () {
                    element.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        scope.toggleDateFormat = function (e) {
            if (isNaN(e))
                e = new Date().toISOString();
            var tmpDates = datetimeService.toUnixtime(e.replace(/\D/g, ''));
            var tmpStart, tmpEnd;
            scope.pumpTableService = new pumpTableService();
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            _unRegisterListener(scope.deviceSelectedSn);
            scope.myDate = null;

            switch (scope.dataFormat) {
                case "H":
                    tmpStart = tmpDates - (90 * scope.unixDay);
                    var end = new Date(tmpDates);
                    end.setDate(end.getDate() + 1);
                    end.setHours(20, 0, 0, 0);
                    tmpEnd = end.getTime();
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataFormat: "D", runtimeType: scope.runtimeType, dataMin: tmpStart, dataMax: tmpEnd, zoomMin: (tmpEnd - (2 * scope.unixDay)), zoomMax: tmpEnd, windowId: scope.windowId });
                    scope.dataFormat = "D";
                    scope.varTopMenuToggle = "D";
                    break;
                default:
                    tmpStart = tmpDates - (29 * scope.unixDay);
                    tmpEnd = tmpDates + scope.unixDay;
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataFormat: "H", runtimeType: scope.runtimeType, dataMin: tmpStart, dataMax: tmpEnd, zoomMin: tmpDates, zoomMax: tmpEnd, windowId: scope.windowId });
                    scope.dataFormat = "H";
                    scope.varTopMenuToggle = "H";
                    break;
            }
            /////////////////////////////////////////////////////////////
            //scope.dataFormat = (scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) > scope.unixDay ? "D" : "H";
            scope.pumpTableService.dataFormat = scope.dataFormat;
            scope.pumpTableService.customerId = scope.accountInfo.customerId;
            scope.pumpTableService.deviceId = scope.deviceSelected;
            scope.pumpTableService.pumpToggle = scope.varTopMenuToggleA;
            scope.pumpTableService.runtimeScale = scope.runtimeScale;
            scope.pumpTableService.start = tmpStart;
            scope.pumpTableService.end = tmpEnd;
            scope.pumpTableService.alerts = [];
            scope.pumpTableService.nextPage();
        };

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
        });

        scope.fnTopMenuToggle = function () {
            scope.stickyProperties.on = true;
            scope.varTopMenuToggle = scope.varTopMenuToggle == "D" ? "H" : "D";
            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataFormat: scope.varTopMenuToggle, windowId: scope.windowId });
            scope.toggleDateFormat(scope.currentRecord);
        };

        scope.$on('updatePreferencesLanguage', function () {
            if (scope.alerts.length > 0) {
                var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
                var _type = scope.alerts[0].type;
                var _languageCode = scope.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(scope.pumpTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.pumpTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                }
                scope.alerts = [];
                scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        })
    };
}]);

mcapp.factory('pumpTableService', ['$http', 'datetimeService', 'translationService', 'HOST', function ($http, datetimeService, translationService, HOST) {
    var pumpTableService = function () {
        this.items = [];
        this.setting = [];
        this.settingColumns = [];
        this.deviceName = '';
        this.customerId = null;
        this.deviceId = null;
        this.dataFormat = 'H'; //H - hourly, D - daily
        this.runtimeType = null;
        this.runtimeScale = '';
        this.measurementUnit = null;
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.tdWidth = null;
        this.initColSpanSRG = 2;
        this.initTdWidthSRG = '50%';
        this.colSpanSRG = this.initColSpanSRG;
        this.tdWidthSRG = this.initTdWidthSRG;
        this.pumpToggle = undefined;
        this.alerts = [];
        this.translation = translationService.translation;
        this.showHourlyRange = false;
    };


    var itemKey = function (item) {
        return datetimeService.toUnixtime(item.localDateTime.replace(/\D/g, ''));
    };

    // Single entry point for adding rows to the table (scroll up, scroll down, reload):
    // never adds a row that is already shown and keeps the whole list in descending order (newest first).
    // Returns the number of rows added.
    pumpTableService.prototype.mergeItems = function (incoming) {
        var existing = {};
        for (var e = 0; e < this.items.length; e++) {
            existing[itemKey(this.items[e])] = this.items[e];
        }
        var added = 0;
        for (var j = 0; j < incoming.length; j++) {
            var key = itemKey(incoming[j]);
            var match = existing[key];
            if (match) {
                // daily rows: refresh the values of a day that was partial when first loaded
                if (this.dataFormat === "D") {
                    for (var k = 0; k < match.gallons.length; k++) {
                        match.gallons[k]["value"] = incoming[j].gallons[k]["value"];
                    }
                    for (var l = 0; l < match.runtime.length; l++) {
                        match.runtime[l]["value"] = incoming[j].runtime[l]["value"];
                    }
                    for (var m = 0; m < match.starts.length; m++) {
                        match.starts[m]["value"] = incoming[j].starts[m]["value"];
                    }
                }
                continue;
            }
            existing[key] = incoming[j];
            this.items.push(incoming[j]);
            added++;
        }
        if (added > 0) {
            this.items.sort(function (x, y) { return itemKey(y) - itemKey(x); });
        }
        return added;
    };

    pumpTableService.prototype.previousPage = function () {
        if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
        this.busy = true;
        this.pageSize = -50;
        var url = HOST + "/api/PumpTable?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&dataFormat=" + this.dataFormat + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end + "&runtimeScale=" + this.runtimeScale;
        $http.get(url).then(function (result) {
            /////////////////////////
            var intDayWindow = 20;
            var intDay = 86400000;
            /////////////////////////
            var deviceName = result.data.device.name;
            var setting = result.data.setting;
            var items = result.data.pumpMeasurements;
            var deviceType = result.data.device.model;

            var firstBefore = this.items.length > 0 ? this.items[0] : null;
            var added = this.mergeItems(items);
            // rows that now sit above the row that was first before the merge
            var addedOnTop = firstBefore ? this.items.indexOf(firstBefore) : added;
            this.numberOfNewRecordsPrevious = addedOnTop;
            this.numberOfRecords = this.items.length;
            this.deviceName = deviceName;
            this.showHourlyRange = (deviceType === 5 || deviceType === 9 || deviceType === 19 || deviceType === 21);
            this.startRow = this.startRow + added;
            if (added > 0) { //if new records were added
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = datetimeService.toUnixtime(this.items[0].localDateTime.replace(/\D/g, ''));
            }
            for (var i = 0; i < setting.length; i++) {
                //logic to determine whether it is Multiple or Simultaneous column
                //if device is 800 series, channel 8 as Alarm (inputMode = 'A') --> Multiple
                //OR for all other devices (mostly 100 series), channel 3 description as 'both' --> Simultaneous
                if ([5, 9, 19].indexOf(result.data.device.type) > -1 && setting[i].channel === 8 && setting[i].digitalMode === 'A')
                    setting[i].description = this.translation.text.MULTIPLE;
                else if (setting[i].channel === 3 && setting[i].description === 'both')
                    setting[i].description = this.translation.text.SIMULTANEOUS;
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this), function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({ msg: errorMessage, type: "danger", languageCode: error.data.message });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };

    pumpTableService.prototype.nextPage = function () {
        if (this.busy || this.numberOfReturnedRecords === 0) return;
        this.busy = true;
        var tmpNoPumpSetup = false;
        var tmpNoPumpData = false;
        var tmpCapacity = false;

        var url = HOST + "/api/PumpTable?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&dataFormat=" + this.dataFormat + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end + "&runtimeScale=" + this.runtimeScale;
        $http.get(url).then(function (result) {
            /////////////////////////
            var intDayWindow = 20;
            var intDay = 86400000;
            /////////////////////////
            var deviceName = result.data.device.name;
            var deviceType = result.data.device.model;
            this.showHourlyRange = (deviceType === 5 || deviceType === 9 || deviceType === 19 || deviceType === 21);
            var setting = result.data.setting;
            if (this.setting.length === 0) {
                this.runtimeScale = result.data.runtimeScale == "Minute" ? 'M' : 'H';
                this.measurementUnit = result.data.measurementUnit;

                if (setting.length === 0)
                    tmpNoPumpSetup = true;
                for (var i = 0; i < setting.length; i++) {
                    if (this.runtimeType != "R" && (typeof this.pumpToggle == "undefined") && setting[i].pumpCapacity > 0) {
                        tmpCapacity = true;
                        this.pumpToggle = this.measurementUnit == "Gallon" ? "G" : "L";
                    }
                    //logic to determine whether it is Multiple or Simultaneous column
                    //if device is 800 series, channel 8 as Alarm (inputMode = 'A') --> Multiple
                    //OR all other devices (mostly 100 series), channel 3 description as 'both' --> Simultaneous
                    if ([5, 9, 19].indexOf(result.data.device.type) > -1 && setting[i].channel === 8 && setting[i].digitalMode === 'A')
                        setting[i].description = this.translation.text.MULTIPLE;
                    else if (setting[i].channel === 3 && setting[i].description === 'both')
                        setting[i].description = this.translation.text.SIMULTANEOUS;
                }
                this.pumpToggle = (typeof this.pumpToggle == "undefined") ? "R" : this.pumpToggle;
                for (var i = 0; i < setting.length; i++) {
                    this.setting.push(setting[i]);
                    if (this.pumpToggle != "R") {
                        switch (this.measurementUnit) {
                            case "Gallon":
                                this.settingColumns.push({ id: this.translation.text.PUMP_GALLONS.charAt(0), name: this.translation.text.PUMP_GALLONS, unit: '' }, { id: "S", name: this.translation.text.PUMP_STARTS, unit: '' });
                                break;
                            case "Liter":
                                this.settingColumns.push({ id: this.translation.text.PUMP_LITERS.charAt(0), name: this.translation.text.PUMP_LITERS, unit: '' }, { id: "S", name: this.translation.text.PUMP_STARTS, unit: '' });
                                break;
                        }
                    }
                    else {
                        this.settingColumns.push({ id: this.translation.text.PUMP_RUNTIME.charAt(0), name: this.translation.text.PUMP_RUNTIME, unit: '(' + this.runtimeScale + ')' }, { id: "S", name: this.translation.text.PUMP_STARTS, unit: '' });
                    }
                }
                this.tdWidth = (100 / (setting.length + 1)) + "%";
            }

            var items = result.data.pumpMeasurements;

            this.mergeItems(items);
            // numberOfReturnedRecords / startRow follow what the server returned (paging offset), not what was added
            this.numberOfReturnedRecords = items.length;
            this.deviceName = deviceName;
            this.deviceType = deviceType;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) { //if there are records returned
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = this.end; //datetimeService.toUnixtime(this.items[0].localDateTime.replace(/\D/g, ''));
            }
            else {
                // If we didn't get any items back AND there aren't already any items
                if (this.items.length === 0) {
                    tmpNoPumpData = true;
                }
            }
        }.bind(this), function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({ msg: errorMessage, type: "danger", languageCode: error.data.message });
        }.bind(this))
            .then(function () {
                this.pageSize = 50;
                this.busy = false;
                if (this.deviceType === 15 || this.deviceType === 20) {
                    this.alerts = [];
                    this.alerts.push({ msg: this.translation.text.DEVICE_UNSUPPORTED, type: "info", languageCode: 'DEVICE_UNSUPPORTED' });
                }
                else if (tmpNoPumpSetup) { 
                    this.alerts = [];
                    this.alerts.push({ msg: this.translation.message.NO_PUMP_SETUP, type: "info", languageCode: 'NO_PUMP_SETUP' });
                }
                else if (tmpNoPumpData) {
                    this.alerts = [];
                    var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                    this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            }.bind(this));
    };

    return pumpTableService;
}]);

mcapp.controller('pumpChartController', ['$scope', 'sharedSetupService', 'translationService', '$element', 'authenticationService', 'rangeSelectorService',
    function ($scope, sharedSetupService, translationService, $element, authenticationService, rangeSelectorService) {
        sharedSetupService.getWindowId($scope);
        $scope.myDate = null;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.unixDay = sharedSetupService.unixDay;
        $scope.unixHour = 3600000;
        $scope.liveDataOffset = sharedSetupService.liveDataOffset;
        $scope.minPadding = sharedSetupService.minPadding;
        $scope.maxPadding = sharedSetupService.maxPadding;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.alerts = [];
        $scope.loadingInProgress = true;
        $scope.varTopMenuToggle = $scope.stickyProperties && $scope.stickyProperties.dataFormat === "D" ? "D" : "H";
        $scope.dataGroupingSetting = "";
        $scope.dataGroupingInterval = "";
        $scope.dataGroupingTooltip = "";
        $scope.stacking = false;
    }]);

mcapp.directive('drawPumpChart', ['$rootScope', '$timeout', 'pumpChartService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'sharedSetupService', 'openViewService', 'rangeSelectorService', 'SaveDesktopSettingService',
    function ($rootScope, $timeout, pumpChartService, datetimeService, websocketService, timeLapseService, toaster, sharedSetupService, openViewService, rangeSelectorService, SaveDesktopSettingService) {
        return function (scope, element, attrs) {
            scope.downloadViewTypeOptions = [0,1];
            var chart;
            var xValue = null;
            var chartDrawn = false;
            var scrollingInProgress = false;
            var zoomLevelCurrent, zoomLevelPrevious = 0;
            var initialLoad = true;
            var afterSetExtremesTimer = 0;
            var numberOfHiddenSeries = 0;

            var drawChart = null;
            var onChartRedraw = null;
            var onChartLoad = null;
            var onChartSetExtremes = null;
            var onChartAfterSetExtremes = null;
            var getRangeSelectorButtons = null;
            var onChartTooltipFormatter = null;
            var onChartLegendItemClick = null;
            var getInitialData = null;
            var logGetData = null;
            var chartSetupGrouping = null;
            var registerListener = null;
            var unregisterListener = null;
            var alignZoomToDayBoundaries = null;
            var tlDataReceivedPump = null;
            var wsReconnectPump = null;
            var wsDataReceivedPump = null;
            var setLiveDataStatus = null;
            var downsampleSeries = null;
            var applyNlsToDataSeriesNames = null;
            var applyNls = null;

            scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
            scope.preferredTimeFormat = scope.accountInfo.preferenceUser.timeFormat;
            scope.runtimeScale = scope.accountInfo.preferenceCustomer.lookupRuntimeScale;

            var chartXaxisHourFormat =
                scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian
                ? '%l:%M %P'
                : '%H:%M';

            if (!$rootScope.mobile && !$rootScope.classicView) {
                scope.popup = _this.getExistingDialog(scope.windowId).ref;
                sharedSetupService.maximize(scope.popup);
            }

            element.attr("class", "chart");

            element.on('mousewheel', function (event) {
                if (!scrollingInProgress)
                    scope.mouseWheelZoom(event, chart, xValue);
            });

            if (typeof scope.stickyProperties != 'object') {
                scope.stickyProperties = scope.stickyPropertiesInterface;
            }

            scope.$watch('lastUpdateAt', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    scope.liveDataIn = !scope.liveDataIn;
                    $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
                }
            }, true);

            scope.$watch('deviceSelected', function (newValue, oldValue) {
                if (newValue) {
                    var tmpDates, tmpStartDate = null, tmpEndDate = null;
                    scope.loadingInProgress = true;

                    scope.saveDesktopSettingService = new SaveDesktopSettingService(newValue, scope.windowId);

                    if (scope.stickyProperties.setting && scope.stickyProperties.setting.savedDesktop) {
                        scope.savedDesktopSetting = scope.stickyProperties.setting;
                    }
                    else {
                        scope.savedDesktopSetting = scope.saveDesktopSettingService.getObject();
                    }

                    if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) {
                        scope.stickyProperties.on = true;
                        tmpStartDate = scope.stickyProperties.dateMin;
                        tmpEndDate = scope.stickyProperties.dateMax;
                        if (scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin > 3 * scope.unixDay) {
                            scope.varTopMenuToggle = "D";
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataFormat: scope.varTopMenuToggle, windowId: scope.windowId });
                            chartSetupGrouping();
                        }
                    }
                    else {
                        scope.stickyProperties.on = false;
                    }

                    if (!tmpStartDate) {
                        timeLapseService.getLocalDateTime().then(function (result) {
                            tmpDates = new Date(result.data.localDateTime);
                            tmpDates.setHours(0, 0, 0, 0);
                            tmpDates = datetimeService.dateToUnixtime(tmpDates);
                            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                            tmpStartDate = tmpDates.startDate;
                            tmpEndDate = tmpDates.endDate;
                            getInitialData(newValue, tmpStartDate, tmpEndDate);
                        });
                    }
                    else {
                        getInitialData(newValue, tmpStartDate, tmpEndDate);
                    }
                }
            }, true);

            scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
                if (newValue && oldValue && newValue !== oldValue)
                    unregisterListener(oldValue);
            }, true);

            //Handle Preferences: Language
            scope.fnChangeLanguage = function () {
                if (scope.alerts.length > 0) {
                    var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
                    var _type = scope.alerts[0].type;
                    var _languageCode = scope.alerts[0].languageCode;

                    if (_languageCode === 'NO_DATA') {
                        _msg += ': ' + moment(scope.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                    }
                    scope.alerts = [];
                    scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
                }
                // drawChart();
                if (!$rootScope.mobile && !$rootScope.classicView)
                    scope.popup.dialog("option", "title", scope.translation.text.PUMP + ", " + scope.devicename);
            };

            //Handle Preferences:TimeFormat (12/24) changed
            scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
                scope.applyTimeFormat(timeFormat);
                if (scope.alerts.length === 0) {
                    drawChart();
                }
            });

            scope.$on('updatePreferenceRuntime', function (event, message) {
                scope.runtimeScale = message.runtimeScale;
                scope.mostRecentData();
            });

            scope.applyTimeFormat = function (timeFormat) {
                scope.preferredTimeFormat = parseInt(timeFormat);
            };
  
            scope.selectMyDate = function (date) {
                scope.myDate = date;
                var tmpDates = scope.myDate;
                scope.loadingInProgress = true;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);

                logGetData('scope.selectMyDate:', tmpDates.startDate, tmpDates.endDate);
                pumpChartService.getData(
                    'customerID=' + scope.accountInfo.customerId +
                    '&deviceId=' + scope.deviceSelected +
                    '&StartDate=' + tmpDates.startDate +
                    '&EndDate=' + tmpDates.endDate +
                    '&runtimeScale=' + scope.runtimeScale).then(function (dataFromFactory) {
                        scope.series = dataFromFactory.data.series;
                        scope.devicename = dataFromFactory.data.device.name;
                        scope.deviceType = dataFromFactory.data.device.model;
                        scope.alerts = [];
                        scope.loadingInProgress = false;
                        if (dataFromFactory.data.series && dataFromFactory.data.series[0].data.length >= 1) {
                            applyNlsToDataSeriesNames(scope.series);
                            scope.stickyProperties.on = true;
                            sharedSetupService.setStickyProperties(scope.stickyProperties,
                            {
                                deviceId: scope.deviceSelected,
                                dataMin: tmpDates.startDate,
                                dataMax: tmpDates.endDate,
                                zoomMin: (tmpDates.startDate + scope.unixDay), //moment.utc(scope.myDate).startOf('day'),
                                zoomMax: (tmpDates.endDate - scope.unixDay),//moment.utc(scope.myDate).endOf('day'),
                                windowId: scope.windowId
                            });
                            drawChart();
                        }
                        else if(scope.deviceType === 15 || scope.deviceType === 20) {
                            scope.alerts = [];
                            scope.alerts.push({ msg: scope.translation.text.DEVICE_UNSUPPORTED, type: "info", languageCode: 'DEVICE_UNSUPPORTED' });
                        }
                        else {
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
                            element.empty();
                            scope.chart = null;
                            scope.lastStart = tmpDates.startDate;
                            scope.lastEnd = tmpDates.endDate;
                            var errorMessage = scope.translation.message.NO_DATA + ': ' + moment(tmpDates.startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(tmpDates.endDate).utc().format('MM/DD/YY, h:mm:ss a');
                            scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                        }
                    }
                );
            };

            scope.zoomAdjust = function(varDay){
                var extremes = scope.chart.xAxis[0].getExtremes();
                var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, scope.heartbeatLocalDateTime);
                scope.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
                scope.saveDesktopSettingService.setZoomAdjustSetting(varDay, scope);
                setLiveDataStatus();
            }

            scope.fnTopMenuToggle = function () {
                scope.stickyProperties.on = true;
                //debugger;
                //console.log(scope.varTopMenuToggle);
                scope.varTopMenuToggle = scope.varTopMenuToggle === "D" ? "H" : "D";
                var isHourlyData = scope.varTopMenuToggle === "H" ? true : false;
                scope.saveDesktopSettingService.setPumpChartHourlyDailySetting(isHourlyData, scope);
                var extremes = chart.xAxis[0].getExtremes();
                sharedSetupService.setStickyProperties(
                    scope.stickyProperties,
                    {
                        dataFormat: scope.varTopMenuToggle,
                        windowId: scope.windowId,
                        zoomMin: extremes.min,
                        zoomMax: extremes.max
                    });
                //show the right buttons
                chartSetupGrouping();
                drawChart();
            };

            sortData = function (a, b) {
                if (a[0] === b[0]) {
                    return 0;
                }
                else {
                    return (a[0] < b[0]) ? -1 : 1;
                }
            };

            drawChart = function () {

                chartSetupGrouping();
                scope.numberOfSeries = scope.series.length;
                scope.numberOfHiddenSeries = 0;

                chart = new Highcharts.StockChart({
                    credits: { enabled: false },
                    legend: {
                        enabled: true,
                        backgroundColor: '#f9f9f9',
                        borderColor: '#cccccc',
                        borderWidth: 1
                    },
                    time: {
                        getTimezoneOffset: function (timestamp) {
                           return -moment.tz(timestamp, datetimeService.getTimeZoneId(scope.accountInfo.timeZone)).utcOffset();
                       }
                   },
                    chart: {
                        renderTo: element[0],
                        backgroundColor: '#ebebeb',
                        plotBackgroundColor: '#f9f9f9',
                        borderColor: '#cccccc',
                        borderWidth: 1,
                        borderRadius: 2,
                        panning: true,
                        panKey: 'shift',
                        pinchType: 'x',
                        plotBorderWidth: 1,
                        marginTop: 10,
                        spacingRight: 5,
                        spacingBottom: 10,
                        spacingTop: 0,
                        spacingLeft: 2,
                        animation: false,
                        reflow: true,
                        events: {
                            redraw: function (e) { return onChartRedraw(this, e); },
                            load: function (e) { return onChartLoad(this, e); }
                        }
                    },
                    title: {
                        style: {
                            color: '#6D869F',
                            fontWeight: 'bold'
                        }
                    },
                    subtitle: { text: null },
                    exporting: { enabled: false },
                    xAxis: {
                        title: {
                            text: scope.translation.text.TIME,
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold',
                                fontSize: '15px'
                            }
                        },
                        endOnTick: false,
                        showLastLabel: true,
                        startOnTick: true,
                        ordinal: false,
                        minorTickInterval: scope.dataGroupingInterval * scope.unixHour,
                        minTickInterval: scope.dataGroupingInterval * scope.unixHour,
                        minRange: scope.dataGroupingInterval * scope.unixHour,
                        minorGridLineColor: '#ffffff',
                        dateTimeLabelFormats: { hour: chartXaxisHourFormat },
                        labels: {
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold'
                            }
                        },
                        events: {
                            setExtremes: function (e) { return onChartSetExtremes(this, e); },
                            afterSetExtremes: function (e) { return onChartAfterSetExtremes(this, e); }
                        }
                    },
                    yAxis: [
                            {
                                gridLineWidth: 1,
                                gridLineColor: '#c0c0c0',
                                opposite: true,
                                endOnTick: true,
                                lineWidth: 1,
                                min: 0,
                                title: {
                                    text: scope.translation.text.PUMP + ' ' + scope.translation.text.PUMP_STARTS,
                                    style: { color: '#000' }
                                },
                                labels: { align: 'left' },
                                allowDecimals: false
                            },
                            {
                                gridLineWidth: 1,
                                gridLineColor: '#c0c0c0',
                                opposite: false,
                                endOnTick: true,
                                lineWidth: 1,
                                min: 0,
                                title: {
                                    text: scope.translation.text.PUMP + ' ' + scope.translation.text.PUMP_RUNTIME + ' (' + (scope.runtimeScale === "M" ? scope.translation.text.MINUTES : scope.translation.text.HOURS) + ')',
                                    style: { color: '#000' }
                                },
                                labels: { align: 'right' }
                            }],
                    tooltip: {
                        useHTML: true,
                        formatter: function (e) { return onChartTooltipFormatter(this, e); },
                        crosshairs: true,
                        shared: true,
                        valueDecimals: 1,
                        backgroundColor: '#FFFFFF',
                        borderColor: 'gray',
                        borderWidth: 1
                    },
                    navigator: {
                        enabled: true,
                        adaptToUpdatedData: true,
                        series: {
                            lineWidth: 0,
                            color: 'transparent'
                        },
                        maskFill: 'rgba(255, 255, 255, 0.35)',
                        maskInside: true,
                        handles: {
                            backgroundColor: '#a4a7a9',
                            borderColor: '#384450'
                        },
                        height: 22,
                        margin: 0,
                        xAxis: {
                            tickWidth: 2,
                            lineWidth: 1,
                            gridLineWidth: 0,
                            tickLength: 15,
                            tickPosition: 'inside',
                            tickColor: '#98b3d1',
                            dateTimeLabelFormats: { hour: '%l:%M %p' },
                            labels: {
                                align: 'left',
                                style: {
                                    color: '#61768f',
                                    fontWeight: 'bold'
                                },
                                x: 8,
                                y: -8
                            }
                        }
                    },
                    scrollbar: {
                        enabled: true,
                        height: 0,
                        barBackgroundColor: '#959595',
                        barBorderRadius: 2,
                        barBorderWidth: 0,
                        buttonBackgroundColor: '#959595',
                        buttonBorderWidth: 0,
                        buttonBorderRadius: 2,
                        trackBackgroundColor: 'none',
                        trackBorderWidth: 1,
                        trackBorderRadius: 3,
                        trackBorderColor: '#CCC',
                        liveRedraw: true
                    },
                    rangeSelector: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            dataGrouping: scope.dataGroupingSetting,
                            point: {
                                events: {
                                    mouseOver: function () {
                                        xValue = chart.x;
                                    },
                                }
                            },
                            borderColor: '#303030',
                            borderWidth: 1,
                            marker: {
                                enabled: null, //auto-hide when too dense
                                fillColor: '#FFFFFF',
                                lineWidth: 2,
                                lineColor: null // inherit from series
                            },
                            pointWidth: 12,
                            events: {
                                legendItemClick: function () {
                                    if (this.visible) {
                                        if (scope.numberOfHiddenSeries < (scope.numberOfSeries - 1)) {
                                            scope.numberOfHiddenSeries = scope.numberOfHiddenSeries + 1;
                                        } else {
                                            return false;
                                        }
                                    } else {
                                        scope.numberOfHiddenSeries = scope.numberOfHiddenSeries - 1;
                                    }

                                    scope.saveDesktopSettingService.setSerieVisibilitySetting(this.options.id, this.visible ? false : true, scope);
                                },
                                mouseOut: function () { xValue = null; }
                            }
                        }
                    },
                    series: scope.series
                });

                scope.chart = chart;

                var tmpNewDateA;
                var tmpNewDateB;
                var extremes = chart.xAxis[0].getExtremes();

                if (scope.stickyProperties.on === true) {
                    logGetData('drawChart.stickies', scope.stickyProperties.zoomMin, scope.stickyProperties.zoomMax);
                    tmpNewDateA = scope.stickyProperties.zoomMin >= extremes.dataMin ? scope.stickyProperties.zoomMin : extremes.dataMin;//extremes.dataMin + scope.unixDay / 24 * 3;
                    tmpNewDateB = scope.stickyProperties.zoomMax <= extremes.dataMax + scope.liveDataOffset ? scope.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
                    //tmpNewDateB = tmpNewDateB >= tmpNewDateA + scope.unixDay / 24 ? tmpNewDateB : extremes.dataMax - scope.unixDay / 24 * 12;
                    scope.stickyProperties.on = false;
                    logGetData('drawChart.setExtremes', tmpNewDateA, tmpNewDateB);
                    chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
                }
                //else {
                //    tmpNewDateA = scope.myDate !== null ? extremes.dataMin + scope.unixDay : extremes.dataMax - scope.unixDay / 24 * 12;
                //    tmpNewDateB = scope.myDate !== null ? tmpNewDateA + scope.unixDay : extremes.dataMax;
                //    if (tmpNewDateB > extremes.dataMax) {
                //        tmpNewDateB = extremes.dataMax;
                //        tmpNewDateA = tmpNewDateB - scope.unixDay;
                //    }
                //    tmpNewDateA = tmpNewDateA + scope.minPadding;
                //    tmpNewDateB = tmpNewDateB + scope.maxPadding;
                //}

                if (scope.series !== null) { //only for pump chart if no setup
                    sharedSetupService.setStickyProperties(
                        scope.stickyProperties,
                        {
                            deviceId: scope.deviceSelected,
                            zoomMin: tmpNewDateA,
                            zoomMax: tmpNewDateB,
                            windowId: scope.windowId
                        });
                }
                else {
                    chart.showLoading(scope.translation.message.NO_DATA);
                }
                setLiveDataStatus();
                chartDrawn = true;
                scope.loadingInProgress = false;
            };

            //Chart Events
            onChartLoad = function (object, event) {
                if (initialLoad && !$rootScope.mobile && !$rootScope.classicView)
                    openViewService.adjustContentSize(scope.popup);
                initialLoad = false;
                $timeout(function () { scope.saveDesktopSettingService.applySavedDesktopSetting(chart, scope, false); }, 0);
            };

            onChartRedraw = function (object, event) {
                var tmpDates, i,
                    pumpData = [],
                    extremes = object.xAxis[0].getExtremes();

                if (object.xAxis && chartDrawn === true && scrollingInProgress === false) {
                    if (extremes && extremes.dataMin >= extremes.min - scope.liveDataOffset) {
                        scrollingInProgress = true;
                        object.showLoading();

                        tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -1);

                        logGetData('events.redraw left', tmpDates.startDate, tmpDates.endDate);
                        pumpChartService.getData(
                            'customerID=' + scope.accountInfo.customerId +
                            '&deviceId=' + scope.deviceSelected +
                            '&StartDate=' + tmpDates.startDate +
                            '&EndDate=' + tmpDates.endDate +
                            '&runtimeScale=' + scope.runtimeScale).then(function (dataFromFactory) {
                                var tmpData = scope.series;
                                applyNlsToDataSeriesNames(tmpData);
                                if (dataFromFactory.data.series && dataFromFactory.data.series.length > 0) {
                                    for (i = 0; i < dataFromFactory.data.series.length; i++) {
                                        pumpData.push(dataFromFactory.data.series[i].data);
                                    }
                                }
                                if (dataFromFactory.data.series && dataFromFactory.data.series.length > 0) {
                                    for (i = 0; i < dataFromFactory.data.series.length; i++) {
                                        tmpData[i].data = pumpData[i].concat(tmpData[i].data);
                                        object.series[i].setData(tmpData[i].data);
                                    }
                                }

                                scope.devicename = dataFromFactory.data.device.name;
                                sharedSetupService.setStickyProperties(
                                    scope.stickyProperties,
                                    {
                                        deviceId: scope.deviceSelected,
                                        dataMin: tmpDates.startDate,
                                        windowId: scope.windowId
                                    });
                                setLiveDataStatus();

                                $timeout(function () { scrollingInProgress = false; }, 1000);

                                object.hideLoading();

                            });
                    }
                    else if (scope.liveData === false && extremes && extremes.max + scope.liveDataOffset >= extremes.dataMax) {
                        scrollingInProgress = true;
                        object.showLoading();

                        tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 1);

                        logGetData('events.redraw right', tmpDates.startDate, tmpDates.endDate);
                        pumpChartService.getData(
                            'customerID=' + scope.accountInfo.customerId +
                            '&deviceId=' + scope.deviceSelected +
                            '&StartDate=' + tmpDates.startDate +
                            '&EndDate=' + tmpDates.endDate +
                            '&runtimeScale=' + scope.runtimeScale).then(function (dataFromFactory) {
                                    var tmpData = scope.series;
                                    applyNlsToDataSeriesNames(tmpData);
                                    if (dataFromFactory.data.series && dataFromFactory.data.series.length > 0) {
                                        for (i = 0; i < dataFromFactory.data.series.length; i++) {
                                            pumpData.push(dataFromFactory.data.series[i].data);
                                        }
                                    }

                                    if (dataFromFactory.data.series && dataFromFactory.data.series.length > 0) {
                                        for (i = 0; i < dataFromFactory.data.series.length; i++) {
                                            tmpData[i].data = tmpData[i].data.concat(pumpData[i]);
                                            tmpData[i].data.sort(sortData);
                                            if (object.series !== undefined) {
                                                object.series[i].setData(tmpData[i].data);
                                            }                                               
                                        }
                                    }

                                    scope.devicename = dataFromFactory.data.device.name;
                                    sharedSetupService.setStickyProperties(
                                        scope.stickyProperties,
                                        {
                                            deviceId: scope.deviceSelected,
                                            dataMax: tmpDates.endDate,
                                            windowId: scope.windowId
                                        });
                                    setLiveDataStatus();

                                    $timeout(function () { scrollingInProgress = false; }, 1000);

                                    object.hideLoading();
                                });
                    }
                }
            };

            onChartSetExtremes = function (object, event) {
                if (scope.dataGroupingInterval !== 24) return;
                if (event.trigger === 'navigator' || event.trigger === 'pan' || typeof event.trigger === "undefined") {
                    //e.preventDefault();
                    if (afterSetExtremesTimer != null)
                        clearTimeout(afterSetExtremesTimer);
                    afterSetExtremesTimer = setTimeout(alignZoomToDayBoundaries, 100, event);
                }
            };

            onChartAfterSetExtremes = function (object, event) {
                if (chartDrawn !== true) return;
                var newMin, newMax, newDataMin, newDataMax;

                //If we've scrolled too far left then exit "Live" mode:
                if (scope.liveData === true && (event.trigger === "navigator" || event.trigger === "pan" || typeof event.trigger === "undefined")) {
                    if (event.max + scope.liveDataOffset <= event.dataMax) {
                        sharedSetupService
                            .setStickyProperties(scope.stickyProperties,
                            { liveData: false, windowId: scope.windowId });
                        unregisterListener(scope.deviceSelectedSn);
                    }
                }
                sharedSetupService.setStickyProperties(
                    scope.stickyProperties,
                    { zoomMin: newMin, zoomMax: newMax, windowId: scope.windowId });
                downsampleSeries(newMin, newMax);
            };

            onChartTooltipFormatter = function (object, event) {
                var row = 0;
                var s = '';
                s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px; border-bottom: 1px solid #e4e9db;">';
                s += Highcharts.dateFormat(scope.dataGroupingTooltip, datetimeService.utcToLocalTimeStampByTimeZone(object.x,scope.accountInfo.timeZone));
                s += '</td></tr>';
                $.each(object.points, function (i, point) {
                    if (point.series.name.indexOf(scope.translation.text.PUMP_STARTS) >= 0) {
                        if (row++ === 0) {
                            s += '<tr><td style="color: ' + point.series.color + '; padding-top: 3px; border-top: 1px solid #e4e9db;">';
                            s += point.series.name + ': </td>';
                            s += '<td style="text-align: right; color: #000000; font-weight: bold; padding-top: 3px; border-top: 1px solid #e4e9db;">';
                            s += Highcharts.numberFormat(point.y, 0) + '</td></tr>';
                        }
                        else {
                            s += '<tr><td style="color: ' + point.series.color + ';">';
                            s += point.series.name + ': </td>';
                            s += '<td style="text-align: right; color: #000000; font-weight: bold;">';
                            s += Highcharts.numberFormat(point.y, 0) + '</td></tr>';
                        }
                    }
                    else {
                        s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td>';
                        s += '<td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, 2) + '</td></tr>';
                    }
                    xValue = point.x;
                });
                s += '</table>';
                return s;
            };

            //onChartLegendItemClick = function (object, event) {
            //    var numberOfSeries = object.chart.series.length - 1;
            //    var visibility = object.visible ? 'visible' : 'hidden';
            //    numberOfHiddenSeries = visibility === 'hidden' ? numberOfHiddenSeries - 1 : numberOfHiddenSeries + 1;
            //    numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
            //    if (numberOfHiddenSeries < numberOfSeries)
            //        return true;
            //    numberOfHiddenSeries = numberOfHiddenSeries - 1;
            //    return false;
            //};

            alignZoomToDayBoundaries = function (extremes) {
                if (scope.dataGroupingInterval !== 24) return;

                //if user selected time is after 6:00PM then round to next day, else round to beginning of day:
                var newMin = moment.utc(extremes.min).add(0, 'hours').startOf('day').valueOf();

                // if user selected time is before 6:00AM then round to end of yesterday, else round to end of day:
                var newMax = moment.utc(extremes.max).add(-6, 'hours').endOf('day').valueOf();

                if (newMax > extremes.dataMax) newMax = extremes.dataMax;
                //console.log(
                //    "alignZoom:" +
                //    "  min:" + moment.utc(extremes.min).format("M/DD HH:mm") +
                //    ", newMin:" + moment.utc(newMin).format("M/DD HH:mm") +
                //    ", max:" + moment.utc(extremes.max).format("M/DD HH:mm") +
                //    ", newMax:" + moment.utc(newMax).format("M/DD HH:mm") +
                //    ", dataMax:" + moment.utc(extremes.dataMax).format("M/DD HH:mm"));
                if (newMin !== extremes.min || newMax !== extremes.max)
                    chart.xAxis[0].setExtremes(newMin, newMax, true, true, { trigger: 'adjExtremes' });
            };

            chartSetupGrouping = function () {
                var dataGroupingD = {
                    enabled: true,
                    forced: true,
                    approximation: "sum",
                    units: [['day', [1]]]
                };

                var dataGroupingH = {
                    enabled: false
                };

                scope.varTopMenuToggle = scope.stickyProperties.dataFormat === "D" ? "D" : "H";

                if (scope.varTopMenuToggle === "D") {
                    scope.dataGroupingSetting = dataGroupingD;
                    scope.dataGroupingInterval = 24;
                    scope.dataGroupingTooltip = '%A, %b %e, %Y';
                    scope.stickyProperties.dataFormat = "D";
                }
                else {
                    scope.dataGroupingSetting = dataGroupingH;
                    scope.dataGroupingInterval = 1;
                    scope.dataGroupingTooltip = '%A, %b %e, %Y ' + chartXaxisHourFormat;
                    scope.stickyProperties.dataFormat = "H";
                }
            };

            //==========================socket data================================

            setLiveDataStatus = function () {
                timeLapseService.getLocalDateTime().then(function (result) {
                    scope.heartbeatLocalDateTime = result.data.unixTimeStamp;
                    if (scope.stickyProperties.zoomMax + scope.liveDataOffset >= result.data.unixTimeStamp) {
                        registerListener(scope.deviceSelectedSn);
                    }
                    else {
                        sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                        unregisterListener(scope.deviceSelectedSn);
                    }
                });
            };

            registerListener = function (deviceSn) {
                websocketService.connect();
                sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
                websocketService.register("PUMPRUNTIME", deviceSn, "", wsDataReceivedPump, wsReconnectPump);
                timeLapseService.register("PUMPRUNTIME", deviceSn, "", tlDataReceivedPump);
                websocketService.register("PUMPSTART", deviceSn, "", wsDataReceivedPump, wsReconnectPump);
                timeLapseService.register("PUMPSTART", deviceSn, "", tlDataReceivedPump);
                scope.liveData = true;
            };

            unregisterListener = function (deviceSn) {
                websocketService.unRegister("PUMPRUNTIME", deviceSn, "", wsDataReceivedPump, wsReconnectPump);
                timeLapseService.unRegister("PUMPRUNTIME", deviceSn, "", tlDataReceivedPump);
                websocketService.unRegister("PUMPSTART", deviceSn, "", wsDataReceivedPump, wsReconnectPump);
                timeLapseService.unRegister("PUMPSTART", deviceSn, "", tlDataReceivedPump);
                scope.liveData = false;
                scope.lastUpdateAt = undefined;
            };

            wsDataReceivedPump = function (data) {
                if (scope.liveData === false) {
                    unregisterListener(scope.deviceSelectedSn);
                    return;
                }

                var extremes = chart.xAxis[0].getExtremes();
                var tmpRange = extremes.max - extremes.min;

                var str = data.Time + "";
                var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
                var varValue = parseFloat(data.Value);
                unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, scope.accountInfo.timeZone);

                // update value for Pump Runtime / Starts
                for (var i = 0; i < chart.series.length; i++) {
                    var series = chart.series[i];
                    if (data.Type == 'PUMPRUNTIME') {
                        if (series && parseInt(series.options.id) === parseInt(data.CH)) {
                                series.addPoint([unixtime, varValue]);
                        }
                    } else if (data.Type == 'PUMPSTART') {
                        if (series && parseInt(series.options.id) === (parseInt(data.CH)+100)) {
                            series.addPoint([unixtime, varValue]);
                        }
                    }
                }

                if ((extremes.max + scope.liveDataOffset > extremes.dataMax) && data.CH === 1)
                    chart.xAxis[0].setExtremes(unixtime - tmpRange + scope.minPadding, unixtime + scope.maxPadding);
                var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                scope.lastUpdateAt = varTime;
            };

            scope.mostRecentData = function () {
                toaster.pop('success', scope.windowTitle + " -- " + scope.stickyProperties.device.deviceName, 'View reloading');                
                //toaster.pop('success', scope.windowTitle + " -- " + scope.devicename, 'View reloading');
                scope.stickyProperties.on = true;
                var tmpStartDate = scope.stickyProperties.dateMin;
                var tmpEndDate = scope.stickyProperties.dateMax;
                getInitialData(scope.stickyProperties.deviceId, tmpStartDate, tmpEndDate);
            }

            wsReconnectPump = function (data) {
                if (scope.liveData === false) {
                    unregisterListener(scope.deviceSelectedSn);
                    return;
                }
                if (data.Channel !== 1)
                    return;
                toaster.pop('success', scope.windowTitle + " -- " + scope.devicename, 'View reloading');
                scope.stickyProperties.on = true;
                var tmpStartDate = scope.stickyProperties.dateMin;
                var tmpEndDate = scope.stickyProperties.dateMax;
                getInitialData(scope.stickyProperties.deviceId, tmpStartDate, tmpEndDate);
            };

            downsampleSeries = function (varMin, varMax) {
                var i;
                zoomLevelCurrent = varMax - varMin;
                if (zoomLevelCurrent <= scope.unixDay && zoomLevelPrevious > scope.unixDay) {
                    for (i = 0; i < chart.series.length - 1; i++) {
                        chart.series[i].update({ downsample: { threshold: 0 } }, false);
                        chart.series[i].setData(scope.series[i].data, false);
                    }
                    chart.redraw();
                }
                else if (zoomLevelCurrent > scope.unixDay && zoomLevelPrevious <= scope.unixDay) {
                    for (i = 0; i < chart.series.length - 1; i++) {
                        chart.series[i].update({ downsample: { threshold: 1000 } }, false);
                    }
                    chart.redraw();
                }
                zoomLevelPrevious = zoomLevelCurrent;
            };

            tlDataReceivedPump = function (data) {
                data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, scope.accountInfo.timeZone);
                if (scope.liveData === false) {
                    unregisterListener(scope.deviceSelectedSn);
                    return;
                }

                var extremes = chart.xAxis[0].getExtremes();
                var tmpRange = extremes.max - extremes.min;

                if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - scope.unixDay / 2) {
                    unregisterListener(scope.deviceSelectedSn);
                    return;
                }

                if (extremes.max + scope.liveDataOffset > extremes.dataMax)
                    chart.xAxis[0].setExtremes(data.Unix - tmpRange + scope.minPadding, data.Unix + scope.maxPadding);
            };

            scope.$on("$destroy", function () {
                unregisterListener(scope.deviceSelectedSn);
                if (chart) chart.destroy();
                if (!angular.isUndefined(scope.stickyProperties.setting)) scope.stickyProperties.setting = null;
            });

            getInitialData = function (deviceId, startDate, endDate) {
                logGetData('getInitialData', startDate, endDate);
                var device = { deviceName: scope.deviceSelectedName };
                pumpChartService.getData(
                    'customerID=' + scope.accountInfo.customerId +
                    '&deviceId=' + deviceId +
                    '&StartDate=' + startDate +
                    '&EndDate=' + endDate +
                    '&runtimeScale=' + scope.runtimeScale).then(function (dataFromFactory) {
                        scope.series = dataFromFactory.data.series;
                        scope.alerts = [];
                        scope.deviceType = dataFromFactory.data.device.model;
                        if (dataFromFactory.data.series && dataFromFactory.data.series[0].data.length >= 1) {
                            applyNlsToDataSeriesNames(scope.series);
                            scope.devicename = dataFromFactory.data.device.name;
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: device, dataMin: startDate, dataMax: endDate, windowId: scope.windowId });
                            drawChart();
                        }
                        else {
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: device, dataMin: startDate, dataMax: endDate, windowId: scope.windowId });
                            element.empty();
                            scope.chart = null;
                            scope.loadingInProgress = false;
                            scope.lastStart = startDate;
                            scope.lastEnd = endDate;
                            if(scope.deviceType === 15 || scope.deviceType === 20)
                            {
                                scope.alerts.push({ msg: scope.translation.text.DEVICE_UNSUPPORTED, type: "info", languageCode: 'DEVICE_UNSUPPORTED' });
                            }
                            else
                            {
                                var errorMessage = scope.translation.message.NO_DATA + ': ' + moment(startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(endDate).utc().format('MM/DD/YY, h:mm:ss a');
                                scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                            }

                        }
                    }
                );
            };

            applyNlsToDataSeriesNames = function (arrSeries) {
                for (var i = 0; i < arrSeries.length; i++) {
                    if (!arrSeries[i].origName) {
                        arrSeries[i].origName = arrSeries[i].name;
                    }
                    arrSeries[i].name = applyNls(arrSeries[i].origName);
                }
            };

            applyNls = function (s) {
                // TODO: Replace this quick hack with a more general solution:
                s = s.replace("{Starts}", scope.translation.text.PUMP_STARTS);
                s = s.replace("{Runtime}", scope.translation.text.PUMP_RUNTIME);
                return s;
            };

            logGetData = function (src, startDate, endDate) {
                //console.log(('getData@' + src + ':                              ').substring(0, 30) +
                //    ' Start=' + moment.utc(startDate).format("M/DD HH:mm") +
                //    ', End=' + moment.utc(endDate).format("M/DD HH:mm"));
            };

            scope.$on('updatePreferencesLanguage', function () {
                $timeout(function () {
                    applyNlsToDataSeriesNames(scope.series);
                    if (scope.alerts.length === 0) {
                        drawChart();
                    }
                }, 100);
            });
        };
    }]);

mcapp.factory('pumpChartService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/PumpChart?' + varParm,
                cache: false
            });
        }
    };
}]);
'use strict';

angular.module('mc.pumpalarm', []);
function PumpAlarmFactory(REPORTS, datetimeService, $http, translationService) {

  // instantiate our initial object
  var pumpAlarm = function (customerId, model) {
      this.customerId = customerId;
      this.deviceId = -1;
      this.items = [];
      this.timeFormat = 1;
      this.pageSize = 50;
      this.start = '19000101';
      this.end = '19000101';
      this.busy = false;
      this.numberOfReturnedRecords = -1;
      this.numberOfNewRecordsPrevious = -1;
      this.tdWidth = null;
      this.alerts = [];
      this.lastUpdateAt = null;
      this.translation = translationService.translation;
      this.errorMessage = null;
      this.maxPumps = 3;
      this.model = model;
      this.pumpArray = [];
      this.pumpDescription = [];
  };

  
  pumpAlarm.prototype.Poll = function () {
      this.LoadData(-this.pageSize, true);

  };

  pumpAlarm.prototype.PreviousPage = function () {
      this.LoadData(-this.pageSize);
  };

  pumpAlarm.prototype.NextPage = function () {

      this.LoadData(this.pageSize);
  };

  pumpAlarm.prototype.Reload = function () {
      this.items = [];
      this.alerts = [];
      this.LoadData(this.pageSize);
  };

  pumpAlarm.prototype.LoadData = function (pageSize) {
      if (this.busy) return;
      this.busy = true;
      if (!angular.isDefined(this.deviceId)) return;

      if(pageSize > 0 && this.items.length > 0)
      {
        this.end = datetimeService.toUnixtime(this.items[this.items.length -1].receivedTime.replace(/\D/g, ''));
      }
      else if(pageSize < 0 && this.items.length > 0)
      {
        this.end = datetimeService.toUnixtime(this.items[0].receivedTime.replace(/\D/g, ''));
      }

      $http.get(REPORTS  + "/api/PumpStartAlarmsAlerts" 
                      + "?customerId=" + this.customerId 
                      + "&deviceId=" + this.deviceId 
                      + "&model=" + this.model
                      + "&PageSize=" + pageSize 
                      + "&EndDate=" + this.end).then (function (result) {
          
          self.loading = false;
          this.maxPumps = result.data.maxPumps;
          this.pumpArray = result.data.pumpArray;
          this.pumpDescription = result.data.pumpDescription;
          var items = result.data.pumpAlarmsAlertDataList;
          this.numberOfReturnedRecords = result.data.pumpAlarmsAlertDataList.length;

          if (pageSize > 0) {
            this.items = this.items.concat(result.data.pumpAlarmsAlertDataList);
            this.numberOfReturnedRecords = items.length;
            
          }
          if (pageSize < 0) {
            var resultItems =  result.data.pumpAlarmsAlertDataList.reverse();
            this.items = resultItems.concat(this.items);
            this.numberOfNewRecordsPrevious = items.length;
          }
          
  
          if (items.length > 0) { //if there are records returned
            this.alerts.length = 0;
          }
          if (!(this.items.length > 0)) {
            this.alerts = [];
            if(this.start === '19000101' && this.end === '19000101')
            {
              var intDay = 86400000;
              var tmpDate = new Date();
              this.errorMessage =  moment(tmpDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(tmpDate - (180 * intDay)).utc().format('MM/DD/YY, h:mm:ss a');
            }
           else {
              this.errorMessage =  moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
           }
          }
          this.busy = false;
          this.pageSize = 50;
      }.bind(this), function (error) {
          this.alerts = [];
          this.pageSize = 50;
          this.busy = false;
      }.bind(this));
  };
  return pumpAlarm;
}


PumpAlarmFactory.$inject = ['REPORTS', 'datetimeService', '$http', 'translationService'];

angular.module('mc.pumpalarm').factory('PumpAlarmFactory', PumpAlarmFactory);

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function PumpAlarmDataController($, $q, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, $timeout, $element, timeLapseService, PumpAlarmFactory, toaster) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    ctrl.popup = null;
    ctrl.downloadViewTypeOptions = [0];
    ctrl.downloadOptions = { resolution: 0 };

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();

        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.infiniteScrollOn = true;
        ctrl.infiniteScrollUpOn = true;
        ctrl.infiniteScrollDownOn = true;
        ctrl.checkFirstRowLiveStatus = null;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.translation = translationService.translation;
        ctrl.currentScrollbarPosition = 0;
        ctrl.previousScrollbarPosition = 0;
        ctrl.windowSubtitle = "Loading...";
        if (_typeof($scope.stickyProperties) != 'object') $scope.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        ctrl.paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
        ctrl.checkFirstRowLiveStatus = null;
        ctrl.paddingZoom = ctrl.paddingZoom === 0 ? ctrl.unixDay / 2 : ctrl.paddingZoom;
        ctrl.downloadViewTypeOptions = [0];

        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        $scope.alerts = [];

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        //Get my icon based on my title
        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };
    };

    // Listen to DeviceID change
    ctrl.setDevice = function (selectedDevice) {
        ctrl.model = selectedDevice.deviceId > 0 ? selectedDevice.model : -1;
        $scope.pumpAlarmService = new PumpAlarmFactory(ctrl.accountInfo.customerId, ctrl.model);
        $scope.pumpAlarmService.deviceId = selectedDevice.deviceId;
        $scope.deviceId = selectedDevice.deviceId;
        $scope.pumpAlarmService.Reload();
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: selectedDevice.deviceId, windowId: ctrl.windowId });
    };
    //Handle infinite scrolling
    $timeout(function () {

        //find the element of the chart class
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.element = $element.find('.tabular-data-container');
        } else {
            ctrl.element = $element.find('.tabular-data-container-mobile');
        }
        ctrl.element.on('scroll', function (event) {
            var $rowFirst = ctrl.element.contents().find("tr:first");
            var $rowLast = ctrl.element.contents().find("tr:last");

            if (typeof $rowFirst.position() !== "undefined") {
                ctrl.infiniteScrollOn = true;
                ctrl.infiniteScrollUpOn = true;
                ctrl.infiniteScrollDownOn = true;
                ctrl.previousScrollbarPosition = ctrl.currentScrollbarPosition;
                ctrl.currentScrollbarPosition = ctrl.element[0].scrollTop;
            }

            if (ctrl.infiniteScrollOn === true) {
                ctrl.infiniteScrollUpOn = true;
                ctrl.infiniteScrollDownOn = true;

                if (ctrl.currentScrollbarPosition <= 35 && ctrl.previousScrollbarPosition > 35) ctrl.checkFirstRowLiveStatus = null;

                if (ctrl.infiniteScrollDownOn === true && ctrl.element[0].scrollTop + ctrl.element[0].offsetHeight + 5 > ctrl.element[0].scrollHeight) {
                    $rowLast.addClass("active-row");
                    $scope.pumpAlarmService.NextPage();
                }
                if (ctrl.infiniteScrollUpOn === true && ctrl.element[0].scrollTop < 5 && ctrl.currentScrollbarPosition < ctrl.previousScrollbarPosition) {
                    $rowFirst.addClass("active-row");
                    $scope.pumpAlarmService.PreviousPage();
                }
            }
            var rows = ctrl.element.children().children().children().children();
            var scrollpos = 40;
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
            }
        });
    });

    ctrl.mostRecentData = function () {
        ctrl.passedDate = new Date();
        toaster.pop('success', "Pump Alarm Data", 'View reloading');
        ctrl.selectPumpAlarmDate();
        ctrl.myDate = null;
    };

    ctrl.selectMyDate = function () {
        ctrl.passedDate = ctrl.myDate;
        ctrl.selectPumpAlarmDate();
    };

    ctrl.selectPumpAlarmDate = function () {

        $scope.pumpAlarmService = new PumpAlarmFactory(ctrl.accountInfo.customerId, ctrl.model);
        $scope.pumpAlarmService.deviceId = $scope.deviceId;
        ctrl.currentScrollbarPosition = 0;
        ctrl.previousScrollbarPosition = 0;

        if (ctrl.passedDate == null) {
            var tmpDates = new Date();
        } else {
            var tmpDates = ctrl.passedDate;
        }
        //var tmpDates = ctrl.passedDate;

        //Making sure that data is fetched upto end of selected date
        var tmpDatesA = new Date(tmpDates.valueOf() + 1 * 86400000);
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 180);
        tmpDatesA.setHours(12, 0, 0, 0);
        tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
        $scope.pumpAlarmService.start = tmpDates.startDate;
        if (new Date(ctrl.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
            $scope.pumpAlarmService.end = tmpDatesA;
        } else {
            $scope.pumpAlarmService.end = tmpDates.endDate;
        }
        $scope.pumpAlarmService.startRow = 1;
        $scope.pumpAlarmService.pageSize = 50;
        $scope.pumpAlarmService.customerId = ctrl.accountInfo.customerId;

        $scope.pumpAlarmService.windowTitle = $scope.windowTitle;
        $scope.alerts = [];

        sharedSetupService.setStickyProperties($scope.stickyProperties, {
            deviceId: ctrl.deviceId,
            dataMin: tmpDates.startDate,
            dataMax: tmpDates.endDate,
            zoomMin: tmpDates.startDate + ctrl.unixDay,
            zoomMax: tmpDates.endDate - ctrl.unixDay,
            windowId: ctrl.windowId
        });
        $scope.pumpAlarmService.Reload();
    };
}

PumpAlarmDataController.$inject = ['$', '$q', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', '$timeout', '$element', 'timeLapseService', 'PumpAlarmFactory', 'toaster'];
'use strict';

angular.module('mc.pumpalarm').component('pumpAlarmData', {
    controller: PumpAlarmDataController,
    templateUrl: 'ui/pumpalarm/pumpalarm-data-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.rain-analysis-report", []);
"use strict";

function RainAnalysisReportFactory(REPORTS, $http) {

    // instantiate our initial object
    var RainAnalysisReport = function RainAnalysisReport(customerId, startDate, endDate) {
        this.customerId = customerId;
        this.startDate = startDate;
        this.endDate = endDate;
    };

    RainAnalysisReport.prototype.getData = function () {
        var self = this;
        return $http.get(REPORTS + "/api/Reports/RainAnalysisReport" + "?customerId=" + this.customerId + "&startDate=" + this.startDate + "&endDate=" + this.endDate).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return RainAnalysisReport;
}

RainAnalysisReportFactory.$inject = ['REPORTS', '$http'];

angular.module('mc.rain-analysis-report').factory('RainAnalysisReportFactory', RainAnalysisReportFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function RainAnalysisReportController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, RainAnalysisReportFactory, $timeout, $filter, $element, savePdfService, preferencesService, toaster) {
    var _this2 = this;

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurementId = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? 1 : 3.78541;
        ctrl.runtimeScale = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? 1 : 1.00 / 60.00;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.isRefresh = false;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = "Rain Analysis Report"; //need for
        $scope.downloadViewTypeOptions = [0, 2, 4];
        $scope.alerts = [];
        _this2.alerts = [];
        ctrl.airportRainfallData = [];
        ctrl.rainfallIntensityDataObj = [];
        ctrl.rainfallTenYearEventsDataObj = [];
        ctrl.totalRainfallDataObj = [];
        ctrl.showTenYearEvents = false;

        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        ctrl.goSelectReportData();
        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 20); //25: total padding
            };
        }
    };

    ctrl.mostRecentData = function () {
        ctrl.isRefresh = true;
        ctrl.myDate == null;
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.rainAnalysisReport.loading = true;
        ctrl.goSelectReportData();
    };

    ctrl.selectMyDate = function () {
        ctrl.goSelectReportData(true);
        return;
    };

    ctrl.goSelectReportData = function (varClick) {
        ctrl.alerts = [];
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }

        var numberOfDays = 3,
            dateRangeStart = void 0,
            dateRangeEnd = void 0,
            dateRangeStartUnix = void 0,
            dateRangeEndUnix = void 0;
        if (ctrl.stickyProperties.on === true) {
            ctrl.stickyProperties.on = false;
            dateRangeStartUnix = ctrl.stickyProperties.dateMin;
            dateRangeEndUnix = ctrl.stickyProperties.dateMax;
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            dateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            dateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();

            dateRangeStartUnix = dateRangeStart.getTime(); //datetimeService.dateToUnixtime(dateRangeStart);
            dateRangeEndUnix = dateRangeEnd.getTime(); //datetimeService.dateToUnixtime(dateRangeEnd);
        } else {
            //on initial load
            dateRangeStart = new Date(); // endDate to today
            dateRangeStart.setDate(dateRangeStart.getDate() - numberOfDays); //start date => today - 3days
            dateRangeStartUnix = dateRangeStart.setHours(0, 0, 0, 0); // setHours converts datetime object to Unix format

            dateRangeEnd = new Date();
            dateRangeEndUnix = dateRangeEnd.setHours(23, 59, 59, 999); // setHours converts datetime object to Unix format
        }
        //used for refresh button to reload newest data
        if (ctrl.isRefresh) {
            dateRangeStart = new Date(); // endDate to today
            dateRangeStart.setDate(dateRangeStart.getDate() - numberOfDays); //start date => today - 3days
            dateRangeStartUnix = dateRangeStart.setHours(0, 0, 0, 0); // setHours converts datetime object to Unix format

            dateRangeEnd = new Date();
            dateRangeEndUnix = dateRangeEnd.setHours(23, 59, 59, 999); // setHours converts datetime object to Unix format
        }
        //TODO: will come back to reconsider sharedSetupService.regenerateDates()
        if ((ctrl.mobile || ctrl.classicView) && !(new Date(dateRangeStartUnix).getTime() > 0 && new Date(dateRangeEndUnix).getTime() > 0)) {
            var tmpDates = sharedSetupService.getLiveDates();
            dateRangeStartUnix = tmpDates.startDate;
            dateRangeEndUnix = tmpDates.endDate;
        }
        dateRangeStart = new Date(dateRangeStartUnix);
        dateRangeEnd = new Date(dateRangeEndUnix);

        var currentDate = new Date(Date.now());
        if (dateRangeEnd > currentDate) dateRangeEnd = currentDate;

        ctrl.myDateRangeStart = ctrl.viewStDate = dateRangeStart;
        ctrl.myDateRangeEnd = ctrl.viewEndDate = dateRangeEnd;

        //it might have modified, so convert back to unix format
        dateRangeEndUnix = dateRangeEnd.getTime(); //datetimeService.dateToUnixtime(dateRangeEnd);

        ctrl.rainAnalysisReport = new RainAnalysisReportFactory(ctrl.accountInfo.customerId, dateRangeStartUnix, dateRangeEndUnix); //varDateRangeEndTmp - is StartDate
        ctrl.rainAnalysisReport.loading = true;
        ctrl.rainAnalysisReport.getData().then(function () {
            ctrl.totalRainfallDataObj = ctrl.rainAnalysisReport.data.totalRainfallDataObj;
            ctrl.airportRainfallData = ctrl.rainAnalysisReport.data.airportRainfallData;
            ctrl.rainfallIntensityDataObj = ctrl.rainAnalysisReport.data.rainfallIntensityDataObj;
            ctrl.rainfallTenYearEventsDataObj = ctrl.rainAnalysisReport.data.rainfallTenYearEventsDataObj;
            if (ctrl.rainfallTenYearEventsDataObj != null) {
                ctrl.showTenYearEvents = true;
            }
            //sharedSetupService.setStickyProperties(ctrl.rainAnalysisReport.stickyProperties, { dateMin: dateRangeStartUnix, dateMax: null, zoomMin: dateRangeStartUnix, zoomMax: null, windowId: ctrl.windowId });
        }, function (error) {
            //error
            ctrl.rainAnalysisReport.loading = false;
            ctrl.alerts.push({ msg: "An error occurred while loading the report.", type: 'error', languageCode: 'NO_ELIGIBLE_DEVICES' });
            //this.alerts.push({ msg: "An error occurred while loading the report.", type: 'error', languageCode: 'NO_ELIGIBLE_DEVICES' });
        });
    };

    $scope.$on('updatePreferencesMeasurement', function (event, message) {
        ctrl.measurementId = message === 1 ? 1 : 3.78541;
    });

    $scope.$on('updatePreferenceRuntime', function (event, message) {
        ctrl.runtimeScale = message.runtimeScale === "M" ? 1 : 1.00 / 60.00;
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
    });
};

RainAnalysisReportController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'RainAnalysisReportFactory', '$timeout', '$filter', '$element', 'savePdfService', 'preferencesService', 'toaster'];
'use strict';

angular.module('mc.rain-analysis-report').component('rainAnalysisReport', {
    controller: RainAnalysisReportController,
    templateUrl: 'ui/rainanalysisreport/rain-analysis-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.paging-log", []);
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PagingLogFactory = function PagingLogFactory(HOST, $http) {
    var PagingLog = function () {
        function PagingLog() {
            _classCallCheck(this, PagingLog);
        }

        _createClass(PagingLog, [{
            key: "getData",
            value: function getData(deviceId, deviceTye, timeZone, startDate, endDate, direction) {
                var self = this;
                return $http.get(HOST + '/api/PageRequests?deviceId=' + deviceId + "&deviceType=" + deviceTye + "&timeZone=" + timeZone + "&startDate=" + startDate + "&endDate=" + endDate + "&direction=" + direction + "&" + new Date().getTime()).then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                    return response;
                });
            }
        }, {
            key: "getDataById",
            value: function getDataById(deviceId, deviceTye, startDate, timeZone) {
                var self = this;
                return $http.get(HOST + '/api/PageRequests?deviceId=' + deviceId + "&deviceType=" + deviceTye + "&startDate=" + startDate + "&timeZone=" + timeZone + "&" + new Date().getTime()).then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                    return response;
                });
            }
        }, {
            key: "deleteDataById",
            value: function deleteDataById(id, deviceId, deviceTye, timeZone) {
                var self = this;
                return $http.delete(HOST + '/api/PageRequests?pageRequestId=' + id + '&deviceId=' + deviceId + "&deviceType=" + deviceTye + "&timeZone=" + timeZone + "&" + new Date().getTime()).then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                    return response;
                });
            }
        }, {
            key: "getRecordById",
            value: function getRecordById(timeZone, id, commandId) {
                var self = this;
                if (commandId == 101) {
                    return $http.get(HOST + '/api/AnalogOutputLog?timeZone=' + timeZone + "&id=" + id + "&" + new Date().getTime()).then(function (response) {
                        self.data = response.data;
                        self.loading = false;
                        return response;
                    });
                } else {
                    return $http.get(HOST + '/api/PageRequests?timeZone=' + timeZone + "&id=" + id + "&" + new Date().getTime()).then(function (response) {
                        self.data = response.data;
                        self.loading = false;
                        return response;
                    });
                }
            }
        }, {
            key: "postData",
            value: function postData(customerId, commandId, deviceTye, protocolVersion, timeZone, varPageRequests) {
                var self = this;
                if (commandId >= 300) return $http.post(HOST + '/api/Gen2/DeviceConfig/PageGenTwo?customerId=' + customerId + '&commandId=' + commandId + '&protocolVersion=' + protocolVersion + "&" + new Date().getTime(), varPageRequests);

                return $http.post(HOST + '/api/PageRequests/PostAndFetch/?customerId=' + customerId + '&commandId=' + commandId + "&deviceType=" + deviceTye + "&timeZone=" + timeZone + "&" + new Date().getTime(), varPageRequests);
            }
        }]);

        return PagingLog;
    }();

    return PagingLog;
};

PagingLogFactory.$inject = ['HOST', '$http'];

angular.module('mc.paging-log').factory('PagingLogFactory', PagingLogFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function pagingLogController($rootScope, $scope, sharedSetupService, openViewService, authenticationService, translationService, datetimeService, pageRequestsService, commandOptionsService, $filter, $element, savePdfService, $timeout, toaster, PagingLogFactory) {
    var ctrl = this;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.popoverConfigHistoryListIsOpen = false;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(ctrl);
        ctrl.PagingLogFactory = new PagingLogFactory();
        $scope.alerts = [];
        ctrl.pageRequests = [];
        $scope.topMenuMarginLeft = $rootScope.mobile ? '-206px' : '-278px';
        ctrl.translation = translationService.translation;
        if (!$rootScope.mobile && !$rootScope.classicView) $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        ctrl.prId = null;
        ctrl.startDate = null;
        ctrl.removeOption = true;
        ctrl.scrollingInProgress = false;
        ctrl.currentDevice = null;
        ctrl.currentDate = null;
        ctrl.dateStart = null;
        ctrl.dateEnd = null;
        ctrl.infiniteScroll = false;
        ctrl.infiniteScrollUp = false;
        ctrl.numberOfNewRecordsPrevious = -1;
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.isRefresh = false;

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.qdpLeft = -237; //added to modify datepicker's position
            sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    ctrl.adjustSize();
                },
                open: function open(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    sharedSetupService.broadcastAllDeviceSelected($scope);

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: ctrl.windowTitle + ': ' + $scope.deviceSelectedSn,
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    ctrl.fnRemovePageRequest = function (varPageRequestId) {
        if (varPageRequestId == null) return false;
        $scope.alerts = [];
        ctrl.removeOption = true;
        ctrl.loadingInProgress = true;
        ctrl.PagingLogFactory.deleteDataById(varPageRequestId, ctrl.deviceSelected, $scope.deviceSelectedType, ctrl.accountInfo.timeZone).then(function (dataFromFactory) {
            ctrl.loadingInProgress = false;
            ctrl.pageRequests = dataFromFactory.data;
            ctrl.formatData();
        }, function (error) {
            ctrl.loadingInProgress = false;
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
            $scope.alerts.push({ msg: errormsg, type: "danger" });
        });
        return false;
    };

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.changeDeviceOrDate = true;
            ctrl.infiniteScroll = false;
            ctrl.infiniteScrollUp = false;
            ctrl.pageRequests = [];
            ctrl.currentDevice = newValue;
            var _device = { deviceName: ctrl.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });
            ctrl.getData(newValue);
        }
    }, true);

    $scope.$watch('$ctrl.myDate', function (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
            ctrl.changeDeviceOrDate = true;
            ctrl.infiniteScroll = false;
            ctrl.infiniteScrollUp = false;
            ctrl.pageRequests = [];
            ctrl.currentDate = newVal;
            ctrl.currentDate = datetimeService.dateToUnixtime(ctrl.currentDate);

            //below is the date range we send to Mc.Services to get paging command log data
            var dateSelected = new Date(newVal.getTime());
            dateSelected.setDate(dateSelected.getDate() + 1);
            dateSelected.setHours(5, 0, 0, 0);
            ctrl.dateEnd = datetimeService.dateToUnixtime(dateSelected);
            ctrl.dateStart = ctrl.dateEnd - 90 * 86400 * 1000;

            ctrl.getData(ctrl.currentDevice);
        }
    });

    $scope.mostRecentData = function () {
        toaster.pop('success', ctrl.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');
        //$scope.infiniteScroll = false;
        //$scope.infiniteScrollUp = false;
        ctrl.pageRequests = [];
        ctrl.isRefresh = true;
        ctrl.currentDate = null;
        ctrl.myDate = null;
        ctrl.getData(ctrl.currentDevice);
    };

    ctrl.getData = function (varDeviceId) {
        if (!ctrl.infiniteScroll && !ctrl.infiniteScrollUp || ctrl.changeDeviceOrDate) {
            $scope.alerts = [];
            ctrl.removeOption = true;
            ctrl.loadingInProgress = true;
            if (ctrl.currentDate == null) {
                ctrl.currentDate = new Date();

                //below is the date range we send to Mc.Services to get paging command log data
                var dateSelected = new Date(ctrl.currentDate.getTime());
                dateSelected.setDate(dateSelected.getDate() + 1);
                dateSelected.setHours(5, 0, 0, 0);
                ctrl.dateEnd = datetimeService.dateToUnixtime(dateSelected);
                ctrl.dateStart = ctrl.dateEnd - 90 * 86400 * 1000;

                ctrl.currentDate = datetimeService.dateToUnixtime(ctrl.currentDate);
            }
            ctrl.PagingLogFactory.getData(varDeviceId, $scope.deviceSelectedType, ctrl.accountInfo.timeZone, ctrl.dateStart, ctrl.dateEnd, 0).then(function (dataFromFactory) {
                ctrl.loadingInProgress = false;
                ctrl.changeDeviceOrDate = false;
                ctrl.infiniteScroll = false;
                ctrl.infiniteScrollUp = false;
                ctrl.isRefresh = false;
                ctrl.pageRequests = dataFromFactory.data;
                ctrl.formatData();
                if (ctrl.pageRequests.length > 0) {
                    ctrl.prId = ctrl.pageRequests[ctrl.pageRequests.length - 1].pageRequestId;
                    ctrl.startDate = ctrl.pageRequests[ctrl.pageRequests.length - 1].localDateTimeEntered;
                }
            }, function (error) {
                ctrl.loadingInProgress = false;
                var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({ msg: errormsg, type: "danger" });
            });
        } else if (ctrl.infiniteScroll && !ctrl.infiniteScrollUp) {
            ctrl.loadingInProgress = true;
            var newEndDate = new Date(ctrl.pageRequests[ctrl.pageRequests.length - 1].localDateTimeEntered);
            var newEnd = datetimeService.dateToUnixtime(newEndDate);
            newEnd = newEnd + 5 * 3600 * 1000; //added to avoid data gap when infinite scrolling
            var newStart = newEnd - 7 * 86400 * 1000;
            ctrl.PagingLogFactory.getData(varDeviceId, $scope.deviceSelectedType, ctrl.accountInfo.timeZone, newStart, newEnd, 0).then(function (dataFromFactory) {
                ctrl.loadingInProgress = false;
                ctrl.infiniteScroll = false;
                ctrl.infiniteScrollUp = false;
                ctrl.pageRequests = ctrl.pageRequests.concat(dataFromFactory.data);
                ctrl.formatData();
                if (ctrl.pageRequests.length > 0) {
                    ctrl.prId = ctrl.pageRequests[ctrl.pageRequests.length - 1].pageRequestId;
                    ctrl.startDate = ctrl.pageRequests[ctrl.pageRequests.length - 1].localDateTimeEntered;
                }
            }, function (error) {
                ctrl.loadingInProgress = false;
                var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({ msg: errormsg, type: "danger" });
            });
        } else {
            ctrl.loadingInProgress = true;
            var newStartDate = new Date(ctrl.pageRequests[0].localDateTimeEntered);
            var _newStart = datetimeService.dateToUnixtime(newStartDate);
            _newStart = _newStart + 5 * 3600 * 1000; //added to avoid data gap when infinite scrolling
            var _newEnd = _newStart + 7 * 86400 * 1000;

            ctrl.PagingLogFactory.getData(varDeviceId, $scope.deviceSelectedType, ctrl.accountInfo.timeZone, _newStart, _newEnd, 1).then(function (dataFromFactory) {
                ctrl.loadingInProgress = false;
                ctrl.infiniteScroll = false;
                ctrl.infiniteScrollUp = false;
                var items = dataFromFactory.data;
                ctrl.numberOfNewRecordsPrevious = dataFromFactory.data.length;
                for (var i = 0; i < items.length; i++) {
                    items[i].localDateTime = items[i].localDateTime;
                    items[i].value = items[i].value;
                    ctrl.pageRequests.unshift(items[i]);
                }

                ctrl.formatData();
                if (ctrl.pageRequests.length > 0) {
                    ctrl.prId = ctrl.pageRequests[ctrl.pageRequests.length - 1].pageRequestId;
                    ctrl.startDate = ctrl.pageRequests[ctrl.pageRequests.length - 1].localDateTimeEntered;
                }
            }, function (error) {
                ctrl.loadingInProgress = false;
                var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({ msg: errormsg, type: "danger" });
            });
        }
    };

    $scope.$on('changeDevicePaging', function (event, args) {
        if (ctrl.deviceSelected == args.deviceId) {
            ctrl.getData(args.deviceId);
            return;
        }
        ctrl.setDevice(args.deviceId, args.deviceName, args.deviceSn);
    });

    $scope.$on('doneTransmitting', function (event, args) {
        if (ctrl.deviceSelected == args.deviceId) {
            ctrl.removeOption = true;
            ctrl.getData(args.deviceId);
            return;
        }
    });

    $scope.$on('doneResponding', function (event, args) {
        if (ctrl.deviceSelected == args.deviceId) {
            ctrl.removeOption = true;
            ctrl.getData(args.deviceId);
            return;
        }
    });

    $scope.$on('commandPaging', function (event, args) {
        if (ctrl.deviceSelected == args.deviceId) {
            ctrl.removeOption = false;
            $scope.alerts = [];
            //$scope.pageRequests = args.data;
            //$scope.formatData();
            ctrl.getData(args.deviceId);
        }
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.loadingInProgress = true;
        ctrl.pageRequests = angular.copy(ctrl.pageRequests);
        ctrl.loadingInProgress = false;
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
    });
    //handling infinite scrolling
    var pagingLogContainer = $element.find('#paging-log-scroll-identifier');
    pagingLogContainer.on('scroll', function (event) {
        if (pagingLogContainer[0].scrollTop + pagingLogContainer[0].offsetHeight >= pagingLogContainer[0].scrollHeight - 1 && !ctrl.isRefresh) {
            ctrl.infiniteScroll = true;
            ctrl.getData(ctrl.currentDevice);
        }
        if (pagingLogContainer[0].scrollTop <= 0) {
            var today = new Date();
            today.setDate(today.getDate() + 1);
            today.setHours(5, 0, 0, 0);
            today = datetimeService.dateToUnixtime(today);
            if (ctrl.currentDate == null || ctrl.currentDate == today) return;
            ctrl.infiniteScrollUp = true;
            ctrl.getData(ctrl.currentDevice);
        }
    });

    $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
        var today = new Date();
        today.setDate(today.getDate() + 1);
        today.setHours(5, 0, 0, 0);
        today = datetimeService.dateToUnixtime(today);
        if (ctrl.currentDate == null || ctrl.currentDate == today) return;
        _autoScroll();
        //scope.checkFirstRowLiveStatus = null;
        // scope.trgScroll();
    });

    var _autoScroll = function _autoScroll() {
        if (ctrl.numberOfNewRecordsPrevious > 0) {
            var trRow = pagingLogContainer.find('tr').eq(ctrl.numberOfNewRecordsPrevious - 1);
            var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
            pagingLogContainer.scrollTop(yPosition);
        } else {
            $timeout(function () {
                pagingLogContainer.animate({
                    scrollTop: 5
                }, 500);
            }, 0);
        }
    };

    var logdiv = $element.find('.tabular-data-container');
    logdiv.on('scroll', function (event) {
        if (ctrl.scrollingInProgress == false && logdiv[0].scrollTop + logdiv[0].offsetHeight + 10 > logdiv[0].scrollHeight && !ctrl.loadingInProgress && ctrl.startDate !== null) {
            ctrl.scrollingInProgress = true;
            $scope.alerts = [];
            ctrl.loadingInProgress = true;
            ctrl.PagingLogFactory.getDataById(ctrl.deviceSelected, $scope.deviceSelectedType, ctrl.startDate, ctrl.accountInfo.timeZone).then(function (dataFromFactory) {
                ctrl.pageRequestsTmp = dataFromFactory.data;
                for (var i = 0; i < dataFromFactory.data.length; i++) {
                    ctrl.pageRequestsTmp[i].localDateTimeEnteredFiltered = $filter("filterDateAgentText")(ctrl.pageRequestsTmp[i].localDateTimeEntered);
                    ctrl.pageRequestsTmp[i].localDateTimeCompletedFiltered = $filter("filterDateAgentTextPaging")(ctrl.pageRequestsTmp[i].localDateTimeCompleted);
                    ctrl.pageRequestsTmp[i].removePageRequest = new Date(ctrl.pageRequestsTmp[i].localDateTimeCompleted).getTime() < 0 ? true : false;
                    ctrl.pageRequests.push(ctrl.pageRequestsTmp[i]);
                }
                ctrl.loadingInProgress = false;
                if (ctrl.pageRequestsTmp.length == 0) {
                    ctrl.prId = null;
                } else {
                    ctrl.prId = ctrl.pageRequestsTmp[ctrl.pageRequestsTmp.length - 1].pageRequestId;
                    ctrl.startDate = ctrl.pageRequestsTmp[ctrl.pageRequestsTmp.length - 1].localDateTimeEntered;
                }
            }, function (error) {
                ctrl.loadingInProgress = false;
                var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({ msg: errormsg, type: "danger" });
            });
            ctrl.scrollingInProgress = false;
        }
    });

    ctrl.formatData = function () {
        if (ctrl.pageRequests.length == 0) {
            var errormsg = ctrl.translation.message.NO_RECENT_DATA;
            $scope.alerts.push({ msg: errormsg, type: "info" });
        } else {
            for (var i = 0; i < ctrl.pageRequests.length; i++) {
                ctrl.pageRequests[i].localDateTimeEnteredFiltered = $filter("filterDateAgentText")(ctrl.pageRequests[i].localDateTimeEntered);
                ctrl.pageRequests[i].localDateTimeCompletedFiltered = $filter("filterDateAgentTextPaging")(ctrl.pageRequests[i].localDateTimeCompleted);
                ctrl.pageRequests[i].removePageRequest = new Date(ctrl.pageRequests[i].localDateTimeCompleted).getTime() < 0 ? true : false;
            }
        }
    };
};

pagingLogController.$inject = ['$rootScope', '$scope', 'sharedSetupService', 'openViewService', 'authenticationService', 'translationService', 'datetimeService', 'pageRequestsService', 'commandOptionsService', '$filter', '$element', 'savePdfService', '$timeout', 'toaster', 'PagingLogFactory'];
'use strict';

angular.module('mc.paging-log').component('pagingLog', {
    controller: pagingLogController,
    templateUrl: 'ui/paginglog/paging-log-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

mcapp.factory("preferencesService", ["$http", "HOST", "$rootScope", function ($http, HOST, $rootScope) {
    var preferencesFactory = {};
    var _getLookups = function _getLookups(customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/preferencelookup' + "?" + new Date().getTime(),
            cache: false
        });
    };

    var _updatePreferenceUser = function _updatePreferenceUser(customerId, preferenceUser) {
        return $http.put(HOST + '/api/preferenceUser?customerId=' + customerId + "&uniqueWebID=" + $rootScope.uniqueWebID + "&" + new Date().getTime(), preferenceUser);
    };

    var _updatePreferenceCustomer = function _updatePreferenceCustomer(preferenceCustomer) {
        return $http.put(HOST + '/api/preferenceCustomer?customerId=' + preferenceCustomer.customerId + "&" + new Date().getTime(), preferenceCustomer);
    };

    var _getPreferenceUser = function _getPreferenceUser(loginId, customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/preferenceUser?loginId=' + loginId + "&" + "customerId=" + customerId + "&" + new Date().getTime(),
            cache: false
        });
    };

    var _getPreferenceCustomer = function _getPreferenceCustomer(customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/preferenceCustomer?customerId=' + customerId + "&" + new Date().getTime(),
            cache: false
        });
    };
    preferencesFactory.getLookups = _getLookups;
    preferencesFactory.updatePreferenceUser = _updatePreferenceUser;
    preferencesFactory.updatePreferenceCustomer = _updatePreferenceCustomer;
    preferencesFactory.getPreferenceUser = _getPreferenceUser;
    preferencesFactory.getPreferenceCustomer = _getPreferenceCustomer;
    return preferencesFactory;
}]);
'use strict';

mcapp.factory("customerExtService", ["$http", "HOST", function ($http, HOST) {
    var customerExtFactory = {};

    var _deleteData = function _deleteData(customerId) {
        return $http.delete(HOST + '/api/CustomerExt?customerId=' + customerId);
    };
    var _updateLogoSize = function _updateLogoSize(customerId, logoSizeId) {
        return $http.put(HOST + '/api/CustomerExt?customerId=' + customerId + '&logoSizeId=' + logoSizeId);
    };
    var _updateNotificationMode = function _updateNotificationMode(customerId, notificationMode, logoSizeId) {
        return $http.put(HOST + '/api/CustomerExt?customerId=' + customerId + '&notificationMode=' + notificationMode + '&logoSizeId=' + logoSizeId);
    };
    customerExtFactory.updateLogoSize = _updateLogoSize;
    customerExtFactory.updateNotificationMode = _updateNotificationMode;
    customerExtFactory.deleteData = _deleteData;
    return customerExtFactory;
}]);
"use strict";

mcapp.controller("preferencesController", ["$scope", "$rootScope", "authenticationService", "preferencesService", "translationService", "customerExtService", "$sce", "tmhDynamicLocale", "sharedSetupService", "openViewService", "$location", "$window", "locationFactory", "desktopViewListService", "$timeout", "textToSpeechService", "websocketService", "modalService", "TwoFactorAuthenticationFactory", "$uibModal", "accountWorkflowService", function ($scope, $rootScope, authenticationService, preferencesService, translationService, customerExtService, $sce, tmhDynamicLocale, sharedSetupService, openViewService, $location, $window, locationFactory, desktopViewListService, $timeout, textToSpeechService, websocketService, modalService, TwoFactorAuthenticationFactory, $uibModal, accountWorkflowService) {
    var _this2 = this;

    var ctrl = this;
    sharedSetupService.getWindowId($scope);
    var adminPortal = sharedSetupService.adminPortal();
    ctrl.translation = translationService.translation;
    ctrl.tabConfiguration = [];

    ctrl.alerts = [];
    ctrl.updateStatusProperty = undefined;
    ctrl.spinner = "<i class='fa fa-spinner fa-2x fa-spin'></i>";
    ctrl.okCheck = ""; //"<i class='fa fa-check fa-2x fa-green' ></i>";
    ctrl.errorCheck = "<i class='fa fa-exclamation-circle fa-2x fa-red'></i>";
    ctrl.resetIndicator = "<i class='fa fa-fw fa-2x'>&nbsp;</i>";

    ctrl.colorSchemeId = 2;
    ctrl.fontSizeId = 2;
    ctrl.openView = openViewService.openView;

    ctrl.voices = textToSpeechService.isCapable ? textToSpeechService.getVoices() : [];

    ctrl.voiceUnavailable;
    ctrl.voice = 0;
    ctrl.voiceVolume = 1;
    ctrl.voiceRate = 1;
    ctrl.voicePitch = 1;
    ctrl.voiceLanguageCode = "en-US"; //This default is likely redundant but doesnt hurt.
    ctrl.voiceLanguageDescription = "English (United States)";

    //// --> need windowId for Wiki/Help for the Classic View
    sharedSetupService.getWindowId($scope);

    ctrl.viewStatus = undefined;

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.initializeSetting = function () {
        _tabConfiguration({
            "id": "PreferenceUser",
            "name": ctrl.translation.text.USER_PREFERENCES,
            "templateName": "Preference User",
            "templateUrl": "ui/preferences/preferences-user.html",
            "height": 150
        }, {
            "id": "PreferenceCustomer",
            "name": ctrl.translation.text.CUSTOMER_PREFERENCES,
            "templateName": "Preference Customer",
            "templateUrl": "ui/preferences/preferences-customer.html",
            "height": 135
        });
    };

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        $scope.initializeSetting();
        $scope.savedDesktops[0].desktopName = ctrl.translation.text.NO_DEFAULT;
    });

    $scope.initializeSetting();

    var accountInfo = authenticationService.getAccountInfo();

    $scope.hasPortal = accountInfo.portal;
    $scope.updateAccess = accountInfo.userRole === 'Administrator' || accountInfo.userRole === 'SuperAdministrator' ? true : false;
    $scope.twoFactorAuthentication = accountInfo.twoFactorAuthentication;

    $scope.updateDefaultDesktop = function (desktop) {
        $scope.defaultDesktopSelected = desktop;
        $scope.autoUpdate('defaultDesktop');
    };

    //Update voice if its not set to "voice unavailable"
    $scope.updateVoice = function () {
        if (ctrl.voice != null) $scope.autoUpdate("voice");else ctrl.voice = 0;
    };

    var _twoFactorAuthenticationFactory = new TwoFactorAuthenticationFactory(accountInfo.customerId);
    $scope.twoFactorAuthenticationPopover = function (accountWorkflow) {
        $scope.updateStatusTwoFactorAuthentication = ctrl.spinner;
        if ($scope.twoFactorAuthentication) {

            if (!$rootScope.mobile && !$rootScope.classicView && accountWorkflow) $timeout(function () {
                $scope.popup.hide();
            }, 0);

            modalService.enableTwoFactorAuthentication('ENABLE_TWO_AUTHENTICATOR', _this2, accountWorkflow).then(function () {
                if (!$rootScope.mobile && !$rootScope.classicView && accountWorkflow) $timeout(function () {
                    $scope.popup.dialog("close");
                }, 0);
                $scope.updateStatusTwoFactorAuthentication = ctrl.okCheck;
                _updateSwitchLabel();
                accountWorkflowService.launchNextView($scope.windowId, ctrl.viewStatus, "success");
            }, function (error) {
                //close modal
                if (!$rootScope.mobile && !$rootScope.classicView && accountWorkflow) $timeout(function () {
                    $scope.popup.show();
                }, 0);
                $scope.updateStatusTwoFactorAuthentication = ctrl.okCheck;
                $scope.twoFactorAuthentication = false;
                _updateSwitchLabel();
            });
        } else {
            var modalController = function modalController($uibModalInstance, translation) {
                ctrl.translation = _translation;
                this.tmpConfirmMessageA = "Are you sure you want to turn off Two-factor Authentication" + "?";

                this.ok = function () {
                    $uibModalInstance.close();
                };

                this.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            };

            modalController.$inject = ['$uibModalInstance', 'translation'];

            var modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
                controller: modalController,
                controllerAs: '$ctrl',
                size: 'sm',
                resolve: {
                    translation: function translation() {
                        ctrl.translation;
                    }
                }
            });

            modalInstance.result.then(function () {
                _twoFactorAuthenticationFactory.deleteSecret().then(function () {
                    $scope.twoFactorAuthentication = false;
                    var tmpAccountInfo = angular.copy(accountInfo);
                    tmpAccountInfo.twoFactorAuthentication = false;
                    accountInfoChanged = angular.copy(tmpAccountInfo);
                    $window.sessionStorage.accountInfo = JSON.stringify(accountInfoChanged);
                    $scope.updateStatusTwoFactorAuthentication = ctrl.okCheck;
                    _updateSwitchLabel();
                });
            }, function () {
                //cancel button
                $scope.twoFactorAuthentication = true;
                $scope.updateStatusTwoFactorAuthentication = ctrl.okCheck;
                _updateSwitchLabel();
            });
        }
    };

    $scope.autoUpdate = function (varProperty) {
        $scope.updateProperty = varProperty;
        if (angular.isDefined(ctrl.updateStatusProperty)) return;
        ctrl.updateStatusProperty = varProperty;
        $scope.resetUpdateIndicator();
        switch (varProperty) {
            case "adminPortal":
                _updateSwitchLabel();
                $scope.updateStatusAdminPortal = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "audio":
                _updateSwitchLabel();
                $scope.updateStatusAudio = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "time":
                _updateSwitchLabel();
                $scope.updateStatusTime = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "toaster":
                _updateSwitchLabel();
                $scope.updateStatusToaster = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "weatherNotification":
                _updateSwitchLabel();
                $scope.updateStatusWeatherNotification = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "managementAndAlert":
                _updateSwitchLabel();
                $scope.updateStatusManagementAndAlert = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "mode":
                _updateSwitchLabel();
                $scope.updateStatusMode = ctrl.spinner;
                _updatePreferenceUser(varProperty);
                break;
            case "engineering":
                _updateSwitchLabel();
                $scope.updateStatusEngineering = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "location":
                $scope.updateStatusLocation = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "measurement":
                _updateSwitchLabel();
                $scope.updateStatusMeasurement = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "language":
                $scope.updateStatusLanguage = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "runtime":
                if ($scope.metarStationIDSelectedOption == null) {
                    ctrl.updateStatusProperty = undefined;
                    return;
                }
                _updateSwitchLabel();
                $scope.updateStatusRuntime = ctrl.spinner;
                _updatePreferenceCustomer();
                break;
            case "weather":
                if ($scope.metarStationIDSelectedOption == null) {
                    ctrl.updateStatusProperty = undefined;
                    return;
                }
                $scope.updateStatusWeather = ctrl.spinner;
                _updatePreferenceCustomer();
                break;
            case "defaultDesktop":
                $scope.updateStatusDefaultDesktop = ctrl.spinner;
                _updatePreferenceUser();
                break;
            case "voice":
                $scope.updateStatusVoice = ctrl.spinner;
                _updatePreferenceUser("voice");
                break;
            case "voiceVolume":
                $scope.updateStatusVoiceVolume = ctrl.spinner;
                _updatePreferenceUser("voiceVolume");
                break;
            case "voiceRate":
                $scope.updateStatusVoiceRate = ctrl.spinner;
                _updatePreferenceUser("voiceRate");
                break;
            case "voicePitch":
                $scope.updateStatusVoicePitch = ctrl.spinner;
                _updatePreferenceUser("voicePitch");
                break;
        }
    };

    $scope.resetUpdateIndicator = function () {
        $scope.updateStatusAudio = ctrl.resetIndicator;
        $scope.updateStatusAdminPortal = ctrl.resetIndicator;
        $scope.updateStatusTime = ctrl.resetIndicator;
        $scope.updateStatusToaster = ctrl.resetIndicator;
        $scope.updateStatusWeatherNotification = ctrl.resetIndicator;
        $scope.updateStatusManagementAndAlert = ctrl.resetIndicator;
        $scope.updateStatusMode = ctrl.resetIndicator;
        $scope.updateStatusEngineering = ctrl.resetIndicator;
        $scope.updateStatusLocation = ctrl.resetIndicator;
        $scope.updateStatusMeasurement = ctrl.resetIndicator;
        $scope.updateStatusLanguage = ctrl.resetIndicator;
        $scope.updateStatusRuntime = ctrl.resetIndicator;
        $scope.updateStatusWeather = ctrl.resetIndicator;
        $scope.updateStatusNotificationMode = ctrl.resetIndicator;
        $scope.updateStatusTwoFactorAuthentication = ctrl.resetIndicator;
    };

    $scope.resetUpdateIndicator();

    $scope.getText = function (text) {
        if (!angular.isDefined(text)) return;
        return eval("ctrl.translation.text." + text.toUpperCase());
    };

    $scope.getSavedDesktops = function () {
        $scope.getSavedDesktopsCompleted = true;
        desktopViewListService.getData(accountInfo.customerId).then(function (result) {
            $scope.savedDesktops = result.data.desktopViews;
            if ($scope.savedDesktops.length > 0) $scope.savedDesktops.unshift({ desktopId: '', desktopName: '-----------------------', notAnOption: true });

            $scope.savedDesktops.unshift({ desktopId: -3, desktopName: ctrl.translation.text.WELCOME_TO_SCADA });
            $scope.savedDesktops.unshift({ desktopId: -2, desktopName: ctrl.translation.text.MAP });
            $scope.savedDesktops.unshift({ desktopId: -1, desktopName: ctrl.translation.text.DASHBOARD });

            $scope.savedDesktops.unshift({ desktopId: 0, desktopName: ctrl.translation.text.NO_DEFAULT });
            if ($scope.defaultDesktopID) {
                $scope.savedDesktops.map(function (desktop) {
                    if (desktop.desktopId == $scope.defaultDesktopID) {
                        return $scope.defaultDesktopSelected = desktop;
                    }
                });
                if ($scope.defaultDesktopSelected == null) {
                    for (var i = 0; i < result.data.desktopViews.length; i++) {
                        if (result.data.desktopViews[i].desktopId == accountInfo.preferenceUser.defaultDesktopID) {
                            $scope.defaultDesktopSelected = result.data.desktopViews[i];
                        }
                    }
                    if ($scope.defaultDesktopSelected == null) {
                        $scope.defaultDesktopSelected = $scope.savedDesktops[0];
                    }
                }
                // for (let i = 0; i < result.data.desktopViews.length; i++) {
                //     if (result.data.desktopViews[i].desktopId == accountInfo.preferenceUser.defaultDesktopID) {
                //         $scope.defaultDesktopSelected = result.data.desktopViews[i];
                //     }
                // }
            } else if (accountInfo.preferenceUser.defaultDesktopID < 0) {
                $scope.defaultDesktopSelected = $scope.savedDesktops[Math.abs(accountInfo.preferenceUser.defaultDesktopID)];
            } else {
                for (var j = 0; j < $scope.savedDesktops.length; j++) {
                    if ($scope.savedDesktops[j].defaultDesktop) {
                        $scope.defaultDesktopSelected = $scope.savedDesktops[j];
                    }
                }
                if ($scope.defaultDesktopSelected == null) {
                    $scope.defaultDesktopSelected = $scope.savedDesktops[0];
                }
            }
        }, function (error) {});
    };

    preferencesService.getLookups().then(function (result) {
        _getPreferenceUser();
        $scope.deviceInfos = result.data.lookupDeviceInfo;
        $scope.measurements = result.data.lookupMeasurement;
        $scope.runtimeScales = result.data.lookupRuntimeScale;
        $scope.languages = result.data.lookupLanguage;
        $scope.metarStations = result.data.metarStation;
        if (!$scope.getSavedDesktopsCompleted) {
            $scope.getSavedDesktops();
        }
    }, function (result) {});

    function _updateSwitchLabel() {
        $scope.displayAdminPortal == true ? $scope.displayAdminPortalLabel = ctrl.translation.text.OFF : $scope.displayAdminPortalLabel = ctrl.translation.text.ON;
        $scope.audioEnabled == true ? $scope.audioEnabledLabel = ctrl.translation.text.OFF : $scope.audioEnabledLabel = ctrl.translation.text.ON;
        $scope.timeFormat == true ? $scope.timeFormatLabel = ctrl.translation.text.A24_HOUR : $scope.timeFormatLabel = ctrl.translation.text.A12_HOUR;
        $scope.websiteMode == true ? $scope.websiteModeLabel = ctrl.translation.text.CLASSIC : $scope.websiteModeLabel = ctrl.translation.text.DESKTOP;
        $scope.engineeringUnitDisplay == true ? $scope.engineeringUnitDisplayLabel = ctrl.translation.text.OFF : $scope.engineeringUnitDisplayLabel = ctrl.translation.text.ON;
        $scope.lookupMeasurementID == true ? $scope.lookupMeasurementIDLabel = ctrl.translation.text.METRIC : $scope.lookupMeasurementIDLabel = ctrl.translation.text.IMPERIAL;
        $scope.displayWebinarToaster == true ? $scope.displayWebinarToasterLabel = ctrl.translation.text.OFF : $scope.displayWebinarToasterLabel = ctrl.translation.text.ON;
        $scope.displayWeatherNotification == true ? $scope.displayWeatherNotificationLabel = ctrl.translation.text.OFF : $scope.displayWeatherNotificationLabel = ctrl.translation.text.ON;
        $scope.twoFactorAuthentication == true ? $scope.twoFactorAuthenticationLabel = ctrl.translation.text.OFF : $scope.twoFactorAuthenticationLabel = ctrl.translation.text.ON;
        $scope.optOutManagementAndAlert == true ? $scope.optOutManagementAndAlertLabel = ctrl.translation.text.NO : $scope.optOutManagementAndAlertLabel = ctrl.translation.text.YES;
        $(".bootstrap-switch-label").css("color", "grey");
    }

    function _getPreferenceUser() {

        preferencesService.getPreferenceUser(accountInfo.userId, accountInfo.customerId).then(function (result) {
            $scope.displayAdminPortal = result.data.adminPortal;
            $scope.audioEnabled = result.data.audioEnabled;
            $scope.timeFormat = result.data.timeFormat;
            $scope.websiteMode = result.data.websiteMode;
            $scope.engineeringUnitDisplay = result.data.engineeringUnitDisplay;
            $scope.shareUserLocation = result.data.shareUserLocation;
            $scope.lookupLanguageID = result.data.lookupLanguageID;
            $scope.languageSelectedOption = { "lookupLanguageID": result.data.lookupLanguageID, "i18n": result.data.i18nCode };
            $scope.lookupMeasurementID = result.data.lookupMeasurementID;
            ctrl.colorSchemeId = result.data.colorSchemeId;
            ctrl.fontSizeId = result.data.fontSizeId;
            $scope.displayWebinarToaster = result.data.displayWebinarToaster;
            $scope.displayWeatherNotification = result.data.displayWeatherNotification;
            $scope.defaultDesktopID = result.data.defaultDesktopID;
            $scope.optOutManagementAndAlert = result.data.optOutManagementAndAlert;
            $scope.initialVoice = result.data.voice;
            _updateSwitchLabel();
            $timeout(function () {
                ctrl.voices = textToSpeechService.isCapable ? textToSpeechService.getVoices() : []; //FIREFOX FIX
                ctrl.voice = _checkVoiceAvailability(result.data.voice);
                ctrl.voiceVolume = result.data.voiceVolume;
                ctrl.voiceRate = result.data.voiceRate;
                ctrl.voicePitch = result.data.voicePitch;
                ctrl.voiceLanguageCode = result.data.voiceLanguageCode != null ? result.data.voiceLanguageCode : "en-US";
                ctrl.voiceLanguageDescription = result.data.voiceLanguageDescription != null ? result.data.voiceLanguageDescription : "Google US English";

                //LOOK FOR LANGUAGE CODE MATCH AND POSSIBLE MUTLIPLE MATCHES, REDIFINE ctrl.voice WITH THE CORRECT INDEX
                var languageCodeMatches = [];
                var englishIndex = void 0;
                for (var i = 0; i < ctrl.voices.length; i++) {
                    if (ctrl.voices[i].lang == ctrl.voiceLanguageCode) {
                        ctrl.voice = i;
                        ctrl.voices[i].index = i;
                        languageCodeMatches.push(ctrl.voices[i]);
                    }
                    //SET ENGLISH DEFAULT
                    if (ctrl.voices[i].lang == "en-US") {
                        englishIndex = i;
                    }
                }
                //IF MORE THAN ONE LANGUAGE CODE MATCE EXISTS... LOOK FOR A FULL-NAME MATCH.  OTHERWISE, ASSIGN THE FIRST LANGUAGE IN THE LIST
                if (languageCodeMatches.length > 0) {
                    ctrl.voice = languageCodeMatches[0].index;
                    for (var j = 0; j < languageCodeMatches.length; j++) {
                        if (languageCodeMatches[j].name == ctrl.voiceLanguageDescription) {
                            ctrl.voice = languageCodeMatches[j].index;
                        }
                    }
                } else {
                    // IF NO LANGUAGE MATCHES EXIST, DEFAULT TO US ENGLISH
                    ctrl.voice = englishIndex;
                }
            }, 0);
            _getPreferenceCustomer();
            $scope.adjustSliderSize();
        }, function (error) {
            //$scope.status = 'Unable to load customer data: ' + error.message;
        });
    }

    function _getPreferenceCustomer() {
        preferencesService.getPreferenceCustomer(accountInfo.customerId).then(function (result) {
            $scope.lookupRuntimeScale = result.data.lookupRuntimeScale;
            $scope.lookupRuntimeScaleLabel = $scope.lookupRuntimeScale == "M" ? ctrl.translation.text.HOURS : ctrl.translation.text.MINUTES;
            $scope.notificationModeLabel = $scope.notificationMode == 1 ? ctrl.translation.text.ADVANCED : ctrl.translation.text.BASIC;
            $scope.metarStationID = result.data.metarStationID;
            $scope.metarStationIDSelectedOption = { metarStationID: result.data.metarStationID, city: result.data.city, state: result.data.state, icao: result.data.icao };
            $scope.selectedStation($scope.metarStationID);
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }

    // returns voice index if available / else returns 0 as unavailable default
    function _checkVoiceAvailability(voice) {
        if (voice >= ctrl.voices.length) {
            ctrl.voices.unshift({ name: ctrl.translation.text.VOICE_UNAVAILABLE, disabled: true });
            ctrl.voiceUnavailable = true;
            return 0;
        }
        ctrl.voiceUnavailable = false;
        return voice;
    }

    $scope.setNotificationMode = function () {
        $scope.notificationModeLabel = $scope.notificationMode == 1 ? ctrl.translation.text.ADVANCED : ctrl.translation.text.BASIC;
        $scope.updateStatusNotificationMode = ctrl.spinner;
        customerExtService.updateNotificationMode(accountInfo.customerId, $scope.notificationMode, accountInfo.logoSizeId).then(function (datafromFactory) {
            $scope.updateStatusNotificationMode = ctrl.okCheck;
            $rootScope.notificationMode = datafromFactory.data.notificationMode;
            accountInfo.notificationMode = datafromFactory.data.notificationMode;
            authenticationService.setAccountInfo(accountInfo);
            $rootScope.$broadcast('updateNotificationMode', datafromFactory.data.notificationMode);
        }, function (error) {
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
        });
    };

    $scope.setColorScheme = function (colorSchemeId) {
        ctrl.colorSchemeId = colorSchemeId;
        _updatePreferenceUser();
        //  $rootScope.colorSchemeId = colorSchemeId;
    };

    $scope.setFontSize = function (fontSizeId) {
        ctrl.fontSizeId = fontSizeId;
        _updatePreferenceUser();
        // $rootScope.fontSizeId = fontSizeId;
    };

    $scope.setLogoSize = function (logoSizeId) {
        customerExtService.updateLogoSize(accountInfo.customerId, logoSizeId).then(function (datafromFactory) {
            $rootScope.logoSizeId = logoSizeId;
            accountInfo.logoSizeId = logoSizeId;
            authenticationService.setAccountInfo(accountInfo);
        }, function (error) {
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
        });
    };

    $scope.uploadLogo = function () {
        $("#font-color-menu").hide("slow");
        ctrl.openView('Upload Logo', { width: 450, height: 350 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 450, minimumHeight: 350 }, true);
    };

    $scope.removeLogo = function () {
        customerExtService.deleteData(accountInfo.customerId).then(function (datafromFactory) {
            accountInfo.logoName = "";
            $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
            authenticationService.setAccountInfo(accountInfo);
        }, function (error) {
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
            toaster.pop('error', $scope.windowTitle, errormsg);
        }).then(function (result) {
            $("#font-color-menu").hide("slow");
        });
    };

    $scope._getMetarStationHTML = function () {

        return $scope.trustAsHtml($scope.metarStationHTML);
    };
    function _updatePreferenceUser(preferenceToUpdate) {
        var preferenceUser = {
            loginId: accountInfo.userId,
            adminPortal: $scope.displayAdminPortal,
            audioEnabled: preferenceToUpdate == "voice" || preferenceToUpdate == "voiceVolume" || preferenceToUpdate == "voiceRate" || preferenceToUpdate == "voicePitch" ? 1 : $scope.audioEnabled,
            timeFormat: $scope.timeFormat,
            displayWebinarToaster: $scope.displayWebinarToaster,
            displayWeatherNotification: $scope.displayWeatherNotification,
            websiteMode: $scope.websiteMode,
            engineeringUnitDisplay: $scope.engineeringUnitDisplay,
            shareUserLocation: $scope.shareUserLocation,
            lookupLanguageID: $scope.languageSelectedOption.lookupLanguageID,
            lookupMeasurementID: $scope.lookupMeasurementID,
            i18nCode: $scope.languageSelectedOption.i18n,
            colorSchemeId: ctrl.colorSchemeId,
            fontSizeId: ctrl.fontSizeId,
            defaultDesktopID: $scope.defaultDesktopSelected.desktopId,
            optOutManagementAndAlert: $scope.optOutManagementAndAlert,
            //Get voice - based on the property updated & if the initial voice was available
            voice: ctrl.voiceUnavailable && $scope.updateProperty == "voice" ? ctrl.voice - 1 : ctrl.voiceUnavailable && $scope.updateProperty != "voice" ? $scope.initialVoice : ctrl.voice,
            voiceVolume: ctrl.voiceVolume,
            voiceRate: ctrl.voiceRate,
            voicePitch: ctrl.voicePitch,
            voiceLanguageCode: typeof ctrl.voices[ctrl.voice] !== "undefined" ? ctrl.voices[ctrl.voice].lang : $scope.updateProperty == "voice" ? "en-US" : null,
            voiceLanguageDescription: typeof ctrl.voices[ctrl.voice] !== "undefined" ? ctrl.voices[ctrl.voice].name : $scope.updateProperty == "voice" ? "English (United States)" : null
        };
        preferencesService.updatePreferenceUser(accountInfo.customerId, preferenceUser).then(function (result) {
            $scope.displayAdminPortal = result.data.adminPortal;
            $scope.audioEnabled = result.data.audioEnabled;
            $scope.timeFormat = result.data.timeFormat;
            $scope.displayWebinarToaster = result.data.displayWebinarToaster;
            $scope.displayWeatherNotification = result.data.displayWeatherNotification;
            $scope.websiteMode = result.data.websiteMode;
            $scope.engineeringUnitDisplay = result.data.engineeringUnitDisplay;
            $scope.shareUserLocation = result.data.shareUserLocation;
            $scope.lookupLanguageID = result.data.lookupLanguageID;
            $scope.lookupMeasurementID = result.data.lookupMeasurementID;
            $rootScope.colorSchemeId = result.data.colorSchemeId;

            $scope.defaultDesktopID = result.data.defaultDesktopID;
            $scope.optOutManagementAndAlert = result.data.optOutManagementAndAlert;
            accountInfo.fontSizeId = result.data.fontSizeId;
            $rootScope.fontSizeId = result.data.fontSizeId;
            //Set voice - based on the property updated & if the initial voice was available
            ctrl.voice = ctrl.voiceUnavailable && $scope.updateProperty == "voice" ? result.data.voice + 1 : result.data.voice;
            ctrl.voiceVolume = result.data.voiceVolume;
            ctrl.voiceRate = result.data.voiceRate;
            ctrl.voicePitch = result.data.voicePitch;
            textToSpeechService.updateUserVoice();

            var previousWebsiteMode = $window.sessionStorage != null && $window.sessionStorage.state != null && !!JSON.parse($window.sessionStorage.state).classicView ? 2 : 1;
            //Refresh menu only if the user changes the website mode
            if (preferenceToUpdate === 'mode' && $scope.websiteMode != previousWebsiteMode) accountInfo.menuItems = result.data.menuItems;

            accountInfo.preferenceUser = preferenceUser;
            authenticationService.setAccountInfo(accountInfo);

            switch (ctrl.updateStatusProperty) {
                case "adminPortal":
                    $scope.updateStatusAdminPortal = ctrl.okCheck;
                    break;
                case "audio":
                    $scope.updateStatusAudio = ctrl.okCheck;
                    $rootScope.$broadcast('updatePreferencesAudio', $scope.audioEnabled);
                    break;
                case "time":
                    $scope.updateStatusTime = ctrl.okCheck;
                    $rootScope.$broadcast('updatePreferencesTimeFormat', $scope.timeFormat);
                    break;
                case "toaster":
                    $scope.updateStatusToaster = ctrl.okCheck;
                    $rootScope.$broadcast('updatePreferencesWebinarToaster', $scope.displayWebinarToaster);
                    break;
                case "weatherNotification":
                    $scope.updateStatusWeatherNotification = ctrl.okCheck;
                    $rootScope.$broadcast('updatePreferencesWeatherNotification', $scope.displayWeatherNotification);
                    break;
                case "managementAndAlert":
                    $scope.updateStatusManagementAndAlert = ctrl.okCheck;
                    break;
                case "mode":
                    $scope.updateStatusMode = ctrl.okCheck;
                    $scope.classicViewToggle($scope.websiteMode);
                    break;
                case "engineering":
                    $scope.updateStatusEngineering = ctrl.okCheck;
                    $rootScope.$broadcast('updatePreferencesEngineering', $scope.engineeringUnitDisplay);
                    break;
                case "location":
                    $scope.updateStatusLocation = ctrl.okCheck;
                    if ($rootScope.mobileApp) locationFactory.mobileAppShareMyLocation();
                    //$rootScope.$broadcast('updatePreferencesLocation', $scope.shareLocation);
                    break;
                case "measurement":
                    $scope.updateStatusMeasurement = ctrl.okCheck;
                    $rootScope.$broadcast('updatePreferencesMeasurement', $scope.lookupMeasurementID);
                    break;
                case "language":
                    $scope.updateStatusLanguage = ctrl.okCheck;
                    tmhDynamicLocale.set(accountInfo.preferenceUser.i18nCode);
                    break;
                case "defaultDesktop":
                    $scope.updateStatusDefaultDesktop = ctrl.okCheck;
                    break;
                case "voice":
                    $scope.updateStatusVoice = ctrl.okCheck;
                    break;
                case "voiceVolume":
                    $scope.updateStatusVoiceVolume = ctrl.okCheck;
                    break;
                case "voiceRate":
                    $scope.updateStatusVoiceRate = ctrl.okCheck;
                    break;
                case "voicePitch":
                    $scope.updateStatusVoicePitch = ctrl.okCheck;
                    break;
            }

            ctrl.updateStatusProperty = undefined;
            ctrl.alerts = [];
            ctrl.alerts.push({ msg: "Success", type: "info" });
        }, function (result) {
            $scope.status = 'Unable to update customer: ' + error.message;
            switch (ctrl.updateStatusProperty) {
                case "adminPortal":
                    $scope.updateStatusAdminPortal = ctrl.errorCheck;
                    break;
                case "audio":
                    $scope.updateStatusAudio = ctrl.errorCheck;
                    break;
                case "time":
                    $scope.updateStatusTime = ctrl.errorCheck;
                    break;
                case "toaster":
                    $scope.updateStatusToaster = ctrl.errorCheck;
                    break;
                case "weatherNotification":
                    $scope.updateStatusWeatherNotification = ctrl.errorCheck;
                    break;
                case "managementAndAlert":
                    $scope.updateStatusManagementAndAlert = ctrl.errorCheck;
                    break;
                case "mode":
                    $scope.updateStatusMode = ctrl.errorCheck;
                    break;
                case "engineering":
                    $scope.updateStatusEngineering = ctrl.errorCheck;
                    break;
                case "location":
                    $scope.updateStatusLocation = ctrl.errorCheck;
                    break;
                case "measurement":
                    $scope.updateStatusMeasurement = ctrl.errorCheck;
                    break;
                case "language":
                    $scope.updateStatusLanguage = ctrl.errorCheck;
                    break;
            }
        });
        //Update Slider UI
        $scope.adjustSliderSize();
    }

    $scope.classicViewToggle = function (varWebsiteMode) {
        if ($rootScope.mobile) return;
        if (varWebsiteMode === 1) {
            $scope.setState(false);
            if (!adminPortal) {
                $location.path("/");
                $window.location.reload(false);
            }
        } else if (varWebsiteMode === 2) {
            $scope.setState(true);
            if (!adminPortal) {
                $rootScope.classicView = true;
                $location.path("/preferences/preferences");
            }
        }
    };

    $scope.setState = function (varClassicView) {
        var state = {
            classicView: varClassicView || false
        };
        $window.sessionStorage.state = JSON.stringify(state);
    };

    $scope.$on('$localeChangeSuccess', function (event, arargs) {
        translationService.loadLanguage(true).then(function (result) {
            ctrl.translation = translationService.translation;
            moment.locale(arargs);
            $rootScope.$broadcast('updatePreferencesLanguage', ctrl.translation, arargs);
        });
    });

    function _updatePreferenceCustomer() {
        var preferenceCustomer = {
            customerId: accountInfo.customerId,
            metarStationID: $scope.metarStationIDSelectedOption.metarStationID,
            lookupRuntimeScale: $scope.lookupRuntimeScale
        };
        $scope.lookupRuntimeScaleLabel = $scope.lookupRuntimeScale == "M" ? ctrl.translation.text.HOURS : ctrl.translation.text.MINUTES;
        preferencesService.updatePreferenceCustomer(preferenceCustomer).then(function (result) {
            $scope.lookupRuntimeScale = result.data.lookupRuntimeScale;
            $scope.metarStationID = result.data.metarStationID;
            accountInfo.preferenceCustomer = preferenceCustomer;
            authenticationService.setAccountInfo(accountInfo);
            switch (ctrl.updateStatusProperty) {
                case "runtime":
                    $scope.updateStatusRuntime = ctrl.okCheck;
                    $rootScope.$broadcast('updatePreferenceRuntime', { runtimeScale: $scope.lookupRuntimeScale });
                    break;
                case "weather":
                    $scope.updateStatusWeather = ctrl.okCheck;
                    $rootScope.$broadcast('updatePreferenceWeather', { metarStationId: $scope.metarStationID, displayName: $scope.metarStationIDSelectedOption.displayName });
                    break;
            }
            ctrl.updateStatusProperty = undefined;
            ctrl.alerts = [];
            ctrl.alerts.push({ msg: "Success", type: "info" });
        }, function (error) {
            $scope.status = 'Unable to update customer: ' + error.message;
            switch (ctrl.updateStatusProperty) {
                case "runtime":
                    $scope.updateStatusRuntime = ctrl.errorCheck;
                    break;
                case "weather":
                    $scope.updateStatusWeather = ctrl.errorCheck;
                    break;
            }
        });
    }

    function _tabConfiguration() {
        var len = adminPortal ? 1 : arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    $scope.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        //return 'ui/missionreportssetup/' + (tab.templateName).toLowerCase().replace(' ', '-') + '-tab.html';
    };

    $scope.$on('updatePreferenceWeather', function (event, args) {
        $scope.metarStationID = args.metarStationId;
        $scope.selectedStation(args.metarStationId);
    });

    $scope.selectedStation = function (metarStationID) {
        for (var i = 0; i < $scope.metarStations.length; i++) {
            if (parseInt(metarStationID) === $scope.metarStations[i].metarStationID) {
                $scope.metarStationIDSelectedOption = { metarStationID: metarStationID };
                return;
            }
        }
    };
    if (!$rootScope.wizard) {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                //let _topMenu = typeof $scope.popup.parent().find('.top-menu').css("height") !== "undefined" ? $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") : 20;
                var _title = $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                $scope.popup.parent().find('.form-group').css("width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "") - 50);
                $scope.popup.parent().find('.ui-tabs-panel, .form-group').css("height", _tmpHeight - 160 - _title + 28); //28 title height
                $scope.popup.parent().find('.form-group').css("overflow-y", "auto").css("overflow-x", "hidden");
            };
        }
    }

    $scope.voiceVolumeSliderOptions = {
        id: ctrl.voiceVolume,
        floor: 0.1,
        ceil: 1.0,
        step: 0.1,
        precision: 2,
        disabled: false,
        onEnd: patchVolumeSliderLevel,
        translate: function translate(value, sliderId, label) {
            if (label == "model") return Math.trunc(value * 100) + '%';else if (label == "ceil") return '100%';else if (label == "floor") return '10%';
        }
    };

    $scope.voiceRateSliderOptions = {
        id: ctrl.voiceRate,
        floor: 0.1,
        ceil: 2.0,
        step: 0.1,
        precision: 2,
        disabled: false,
        onEnd: patchRateSliderLevel,
        translate: translateRateAndPitch
    };

    $scope.voicePitchSliderOptions = {
        id: ctrl.voicePitch,
        floor: 0.1,
        ceil: 2.0,
        step: 0.1,
        precision: 2,
        disabled: false,
        onEnd: patchPitchSliderLevel,
        translate: translateRateAndPitch
    };

    function translateRateAndPitch(value, sliderId, label) {
        if (label == "model") return Math.trunc(value * 100) + '%';else if (label == "ceil") return '200%';else if (label == "floor") return '10%';
    }

    function patchVolumeSliderLevel(id, sliderValue) {
        ctrl.voiceVolume = sliderValue;
        $scope.autoUpdate('voiceVolume');
    };

    function patchRateSliderLevel(id, sliderValue) {
        ctrl.voiceRate = sliderValue;
        $scope.autoUpdate('voiceRate');
    };

    function patchPitchSliderLevel(id, sliderValue) {
        ctrl.voicePitch = sliderValue;
        $scope.autoUpdate('voicePitch');
    };

    $scope.adjustSliderSize = function () {
        $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');
        }, 10);
    };

    $scope.$on('contentAdjusted', function () {
        $scope.adjustSliderSize();
    });

    $scope.$on("$destroy", function () {
        if ($scope.mobile) return; //we use $scope.continue() in mobile mode
        accountWorkflowService.launchNextView($scope.windowId, ctrl.viewStatus, "close");
    });

    $scope.continue = function () {
        accountWorkflowService.launchNextView($scope.windowId, ctrl.viewStatus, "close");
    };
}]);
"use strict";

angular.module("mc.sso-validation", []);
'use strict';

function SsoValidationFactory(HOST, $http) {

    // instantiate our initial object
    var SsoValidation = function SsoValidation() {};

    SsoValidation.prototype.getToken = function (authorizationCode, codeChallenge) {
        var self = this;
        return $http.get(HOST + '/api/SSO/Authentication' + '?authorizationCode=' + authorizationCode + '&codeChallenge=' + codeChallenge).then(function (response) {
            self.status = response.data;
            self.loading = false;
            return response;
        });
    };

    return SsoValidation;
}

SsoValidationFactory.$inject = ['HOST', '$http'];

angular.module('mc.sso-validation').factory('SsoValidationFactory', SsoValidationFactory);
'use strict';

function SsoValidationController($, $scope, sharedSetupService, $location, SsoValidationFactory, $window) {
    var ctrl = this;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        ctrl.processAuthorizationCode();
    };

    ctrl.processAuthorizationCode = function () {
        var absUrl = decodeURIComponent($location.absUrl().split('?')[1]);
        var paramUrlWithCode = absUrl.split('&')[0];
        var paramCode = !angular.isUndefined(paramUrlWithCode) ? paramUrlWithCode.split('=')[0] : undefined;
        var paramCodeValue = !angular.isUndefined(paramUrlWithCode) ? paramUrlWithCode.split('=')[1] : undefined;

        if (!angular.isUndefined(paramCode) && paramCode == "code" && !angular.isUndefined(paramCodeValue)) {
            ctrl.authorizationCode = paramCodeValue;
            ctrl.codeChallenge = $window.sessionStorage.getItem("codeChallenge");
            $window.sessionStorage.removeItem("codeChallenge");
            ctrl.processToken(ctrl.authorizationCode, ctrl.codeChallenge);
        } else {
            //error

        }
    };

    ctrl.processToken = function (authorizationCode, codeChallenge) {
        var _ssoValidationFactory = new SsoValidationFactory();
        _ssoValidationFactory.getToken(authorizationCode, codeChallenge).then(function (resp) {
            var splitUrl = "#!";
            var defaultPath = "/account/userlogin";
            var uri = $location.absUrl().split(splitUrl)[0] + splitUrl;

            if (resp.data.isSuccess) {
                uri = uri + defaultPath + "?" + resp.data.value;
            } else {
                var loginPath = window.sessionStorage.getItem("loginPath");
                loginPath = loginPath == null ? defaultPath : loginPath;
                uri = uri + loginPath + "?error=" + resp.data.errorMessage;
            }
            $window.location.href = uri;
        });
    };
};

SsoValidationController.$inject = ['$', '$scope', 'sharedSetupService', '$location', 'SsoValidationFactory', '$window'];
'use strict';

angular.module('mc.sso-validation').component('ssoValidation', {
    controller: SsoValidationController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/oidc/sso-validation-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.sso-authentication", []);
"use strict";

function SsoAuthenticationFactory(HOST, $http) {

    // instantiate our initial object
    var SsoAuthentication = function SsoAuthentication() {};

    SsoAuthentication.prototype.getData = function (id) {
        var self = this;
        return $http.get(HOST + "/api/SSO/Configuration" + "?id=" + id).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    SsoAuthentication.prototype.getUtilityData = function (loginPortalName) {
        var self = this;
        return $http.get(HOST + "/api/SSO/Configuration/GetOrganizationUnit/" + "?loginPortalName=" + loginPortalName).then(function (response) {
            self.loading = false;
            return response.data;
        });
    };

    return SsoAuthentication;
}

SsoAuthenticationFactory.$inject = ['HOST', '$http'];

angular.module('mc.sso-authentication').factory('SsoAuthenticationFactory', SsoAuthenticationFactory);
"use strict";

function SsoAuthenticationController(_, $scope, $rootScope, SsoAuthenticationFactory, $location, $window, sharedSetupService, toaster) {

    var ctrl = this;
    ctrl.authenticationUri = "";
    ctrl.config = null;
    ctrl.errorMessage = undefined;
    var popStateHandler = undefined;

    // Detect pages restored from the back-forward cache
    $window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            // Page was loaded from bfcache; force a reload
            $window.location.reload();
        }
    });

    ctrl.$onInit = function () {

        ctrl.config = null;

        ///////////////////////////////////////////////////////////////////
        //Support for sharedSetupService.adjustBrowserHistoryForLoginPath()
        ///////////////////////////////////////////////////////////////////
        var mainUrl = decodeURIComponent($location.absUrl().split("#!")[0]);
        var otherUrl = window.sessionStorage.getItem("loginPath");
        var historyPushUrl = otherUrl == null ? $window.location.href : mainUrl + "#!" + otherUrl;

        var exists = $window.location.href.includes(otherUrl + "?code=");

        if (!exists) {
            // Push a state when this view/controller is initialized
            $window.history.pushState(null, null, historyPushUrl);

            // If needed reset loginPath
            var resetLoginPath = function resetLoginPath(loginPath) {
                if (loginPath != null) $window.sessionStorage.setItem("loginPath", loginPath);
            };

            // Prevent back navigation while this controller is active
            popStateHandler = function popStateHandler(event) {
                resetLoginPath(otherUrl);
                $window.history.pushState(null, null, historyPushUrl);
            };

            $window.addEventListener('popstate', popStateHandler);
        }
        ///////////////////////////////////////////////////////////////////
        //Support for sharedSetupService.adjustBrowserHistoryForLoginPath()
        ///////////////////////////////////////////////////////////////////

        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;

        var absUrl = decodeURIComponent($location.absUrl().split('?')[1]);
        var paramUrlWithCode = absUrl.split('&')[0];
        var paramCode = !angular.isUndefined(paramUrlWithCode) ? paramUrlWithCode.split('=')[0] : undefined;
        var paramCodeValue = !angular.isUndefined(paramUrlWithCode) ? paramUrlWithCode.split('=')[1] : undefined;

        if (paramCode && paramCodeValue) {
            switch (paramCode) {
                case "error":
                    ctrl.errorMessage = paramCodeValue;
                    $window.sessionStorage.clear();
                    break;

                case "code":
                    $location.path("/sso/validation");
                    return;

                default:
                    ctrl.orgUnitSsoConfigID = $window.sessionStorage.getItem("orgUnitSsoConfigID");
                    $window.sessionStorage.clear();
                    break;
            }
        } else {
            ctrl.orgUnitSsoConfigID = $window.sessionStorage.getItem("orgUnitSsoConfigID");
            $window.sessionStorage.clear();
        }

        ctrl.getUtilityData();
    };

    ctrl.authenticate = function (id) {

        if (id == null) {
            toaster.pop('error', 'Single Sign-On (SSO)', 'Incomplete setup, contact administrator!');
            return;
        }

        var _ssoAuthenticationFactory = new SsoAuthenticationFactory();

        _ssoAuthenticationFactory.getData(id).then(function (resp) {
            ctrl.config = resp.data.config;
            ctrl.pkce = resp.data.pkce;
            ctrl.authorizationUrl = ctrl.config.authorizationUrl;

            if (ctrl.config != null && ctrl.config.tenantID.length > 0) {
                $window.sessionStorage.setItem("loginPath", $location.path());
                $window.sessionStorage.setItem("orgUnitSsoConfigID", ctrl.selectedItem.orgUnitSsoConfigID);
                $window.sessionStorage.setItem("codeChallenge", ctrl.pkce.codeChallenge);
                var authenticate = ctrl.authorizationUrl + "?client_id=" + ctrl.config.clientID + "&response_type=" + "code" + "&redirect_uri=" + ctrl.config.redirectUrl + "&response_mode=" + "query" + "&scope=" + "user.read openid email profile offline_access" + "&code_challenge=" + ctrl.pkce.codeChallenge + "&nonce=" + ctrl.pkce.nonce + "&code_challenge_method=" + "S256";

                $window.location.href = authenticate;
            }
        });
    };

    ctrl.getUtilityData = function () {
        var _ssoAuthenticationFactory = new SsoAuthenticationFactory();
        _ssoAuthenticationFactory.getUtilityData(ctrl.windowId).then(function (resp) {
            ctrl.options = resp;
            if (ctrl.options.length == 0) {
                ctrl.errorMessage = "Nothing to find here. Perhaps you misspelled the URL!";
            } else {
                var foundIndex = ctrl.options.findIndex(function (item) {
                    return item.orgUnitSsoConfigID === ctrl.orgUnitSsoConfigID;
                });
                ctrl.selectedItem = ctrl.options[foundIndex < 0 ? 0 : foundIndex];
                ctrl.selectedLogo = "images/sso/utility/" + ctrl.selectedItem.logoFileName;
            }
        });
    };

    ctrl.selectUtility = function (selectedOption) {
        ctrl.selectedLogo = "images/sso/utility/" + selectedOption.logoFileName;
    };

    // Clean up when scope is destroyed (e.g., route change)
    $scope.$on('$destroy', function () {
        ctrl.config = null;
        if (!angular.isUndefined(popStateHandler)) $window.removeEventListener('popstate', popStateHandler);
    });
};

SsoAuthenticationController.$inject = ['_', "$scope", "$rootScope", "SsoAuthenticationFactory", "$location", "$window", "sharedSetupService", "toaster"];
'use strict';

mcapp.component('ssoAuthenticationComponent', {
    controller: SsoAuthenticationController,
    templateUrl: ['$element', '$attrs', function ($element, $attrs) {
        //attribute required: template-url="utility-template.html"
        var _template = angular.isUndefined($attrs.templateUrl) ? "missing-template.html" : $attrs.templateUrl;
        return "ui/oidc/" + _template;
    }],
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        ssoId: '<'
    }
});
'use strict';

function OverviewFactory(HOST, $http, $sce, websocketService, authenticationService) {
    var _this = this;

    this.predicate = "state";
    var accountInfo = authenticationService.getAccountInfo();
    var deviceStateEnum = {
        Ok: 1,
        Alarm: 2,
        Offline: 3,
        Service: 4,
        Disabled: 5,
        StatusAckAsAlarm: 6
    };

    var Overview = function Overview(customerId, callBack) {
        if (callBack) _this.items = [];
        _this.customerId = customerId;
        if (callBack) _this.loading = true;
        $http.get(HOST + '/api/DeviceState?customerId=' + customerId + '&timeZone=' + accountInfo.timeZone).then(function (resp) {
            _this.items = resp.data;
            _this.loading = false;
            if (callBack) callBack();
        });
    };

    Overview.prototype.get = function () {
        return _this.items;
    };

    Overview.prototype.set = function (data) {
        var newObj = angular.copy(data);
        _this.items = newObj;
    };

    Overview.prototype.isLoading = function () {
        return _this.loading;
    };

    Overview.prototype.getDeviceStateIcon = function (state, acFail) {

        var icon = {
            color: '#16A085',
            class: 'fa-check-circle'
        };

        switch (state) {
            case deviceStateEnum.Disabled:
                icon.class = 'fa-minus-circle';
                icon.color = 'blue';
                break;
            case deviceStateEnum.Offline:
                icon.class = 'fa-minus-circle';
                icon.color = '#BC00BC';
                break;
            case deviceStateEnum.Service:
                icon.color = '#FFD800';
                icon.class = 'fa-minus-circle';
                break;
            case deviceStateEnum.Alarm:
                icon.class = 'fa-times-circle';
                icon.color = '#E75A5A';
                break;
            case deviceStateEnum.StatusAckAsAlarm:
                icon.class = 'fa-times-circle';
                icon.color = '#4cb3ff';
                break;
            default:
                if (acFail) {
                    icon.class = 'fa-times-circle';
                    icon.color = '#E75A5A';
                }
                break;
        }

        return $sce.trustAsHtml('<i style="color: ' + icon.color + '" class="fa fa-lg ' + icon.class + '"></i>');
    };

    //Get device status count 
    Overview.prototype.getDeviceStateCount = function (type) {
        var data = Overview.prototype.get();
        data = data.filter(function (device) {
            if (device.acFail && device.type == 1 && type == 2) {
                return device;
            } else if (device.state == type) {
                return device;
            }
        });
        return data.length;
    };

    Overview.prototype.destroy = function () {
        unregisterListeners(_this.items);
    };

    Overview.prototype.getPredicate = function () {
        return _this.predicate;
    };

    Overview.prototype.setPredicate = function (data) {
        var newObj = angular.copy(data);
        _this.predicate = newObj;
    };

    return Overview;
}

OverviewFactory.$inject = ['HOST', '$http', '$sce', 'websocketService', 'authenticationService'];

angular.module('mc.overview').factory('OverviewFactory', OverviewFactory);
"use strict";

function OverviewController(_, $scope, $sce, $location, authenticationService, translationService, openViewService, sharedSetupService, websocketService, PopupFactory, OverviewFactory, $timeout, toaster, $filter) {
    var _this = this;

    var ctrl = this;

    var toolTipTimer = void 0;
    var toolTipWaitTime = 1000;
    var requestCounter = 0; // Track API request order
    this.$onInit = function () {
        _this._ = _;
        sharedSetupService.getWindowId(_this);
        _this.accountInfo = authenticationService.getAccountInfo();
        _this.translation = translationService.translation;
        ctrl.popupWindow = new PopupFactory(_this.accountInfo);
        ctrl.overview = new OverviewFactory(_this.accountInfo.customerId, _this.registerListeners);
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this);
        _this.sortDesc = null;
        _this.activeStatus = null;
        _this.lastActiveStatus = null;
        _this.getStatusList();
        _this.showMenu = false;
        ctrl.reverse = false;
    };

    this.getStatusList = function () {
        _this.statusList = [{ type: 1, translation: _this.translation.text.OK, icon: "fa fa-check-circle", color: "rgb(22, 160, 133)" }, { type: 2, translation: _this.translation.text.ALARM, icon: "fa fa-times-circle", color: "rgb(231, 90, 90)" }, { type: 3, translation: _this.translation.text.OFFLINE, icon: "fa fa-minus-circle", color: "rgb(188, 0, 188)" }, { type: 4, translation: _this.translation.text.SERVICE, icon: "fa fa-minus-circle", color: "rgb(255, 216, 0)" }, { type: 5, translation: _this.translation.text.DISABLED, icon: "fa fa-minus-circle", color: "blue" }, { type: 6, translation: _this.translation.text.STATUS_ACK_AS_ALARM, icon: "fa fa-times-circle", color: "rgb(76, 179, 255)" }];
    };

    this.dynamicPopover = {
        templateUrl: 'overviewTemplate.html'
    };

    this.filterStatus = function (device) {
        if (!_this.activeStatus || device.acFail && _this.activeStatus == 2 && device.state == 1 || device.state == _this.activeStatus) return true;
        return false;
    };

    //unselect radio button option is selected twice / select radio option by div click
    this.radioCheck = function (type) {
        $timeout(function () {
            if (_this.activeStatus == null) {
                _this.lastActiveStatus = type;_this.activeStatus = type;
            } else if (type != _this.lastActiveStatus) {
                _this.lastActiveStatus = type;_this.activeStatus = type;
            } else {
                _this.activeStatus = null;_this.lastActiveStatus = null;
            }
        }, 0);
    };

    this.getColumnWidth = function () {
        return 100 / _this.getNumColumns() + "%";
    };

    this.getNumColumns = function () {
        if (ctrl.mobile) {
            return 1;
        };
        var nonFillingSpace = 20;
        var overviewContainer = angular.element('.overview-container')[0];

        if (overviewContainer.scrollHeight > overviewContainer.clientHeight) {
            nonFillingSpace += 17;
        }

        var columns = Math.floor((angular.element('.overview-template-html')[0].clientWidth - nonFillingSpace) / 250);
        if (columns > _this.overview.get().length) {
            columns = _this.overview.get().length;
        }

        return columns;
    };

    this.openRTUView = function (device) {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = device.id;

        if (_this.mobile || _this.classicView) {
            $location.path('/rtuview/rtu-view');
        } else {
            openViewService.openView('RTU View', { width: 425, height: 400 }, undefined, optionsStickyProperties);
        }
    };

    this.wsListDeviceStateMsgReceived = function (data) {
        _this.overview.set(data);
    };

    this.mostRecentData = function () {
        toaster.pop('success', "Overview", 'View reloading');
        _this.wsReconnect();
    };

    this.showTooltip = function (deviceId, $event) {
        toolTipTimer = $timeout(function () {
            toolTipTimer = null;
            ctrl.popupWindow.getTooltip(deviceId, $event);
        }, toolTipWaitTime);
    };

    this.hideTooltip = function ($event) {
        if (toolTipTimer !== null && toolTipTimer !== undefined) {
            $timeout.cancel(toolTipTimer);
        } else {
            ctrl.popupWindow.destroyTooltip($event);
        }
    };

    this.wsDataReceivedRTUBASICINFOSETTING = function (data) {
        if (data.Type == 'DEVICEBASICINFO') {
            for (var i = 0; i < _this.overview.get().length; i++) {
                if (_this.overview.get()[i].serialNumber == data.SN && data.Value.path == "name") {
                    _this.overview.get()[i].name = data.Value.value;
                }
            }
        }
    };

    this.wsReconnect = function () {
        _this.unregisterListeners();
        _this.overview = new OverviewFactory(_this.accountInfo.customerId, _this.registerListeners);
    };

    this.registerListeners = function () {
        websocketService.connect();
        websocketService.register('LISTDEVICESTATEMSG', '', '', _this.wsListDeviceStateMsgReceived, _this.wsReconnect);
        for (var i = 0; i < _this.overview.get().length; i++) {
            websocketService.register("DEVICEBASICINFO", _this.overview.get()[i].serialNumber, 0, _this.wsDataReceivedRTUBASICINFOSETTING, null);
        }
        websocketService.startOverview();
    };

    this.unregisterListeners = function () {
        websocketService.unRegister('LISTDEVICESTATEMSG', '', '', _this.wsListDeviceStateMsgReceived, _this.wsReconnect);
        for (var k = 0; k < _this.overview.get().length; k++) {
            websocketService.unRegister("DEVICEBASICINFO", _this.overview.get()[k].serialNumber, 0, _this.wsDataReceivedRTUBASICINFOSETTING, null);
        }
        websocketService.stopOverview();
    };

    this.$onDestroy = function () {
        _this.unregisterListeners();
    };

    this.toggleDispatch = function (device) {
        ctrl.showDispatchData = null; //Showing loading message before new data fetch
        var data = ctrl.overview.get();
        // If the current device is open, close it
        if (device.showDispatch) {
            device.showDispatch = false;
        } else {
            // Cancel any ongoing timeout
            if (toolTipTimer) {
                $timeout.cancel(toolTipTimer);
            }
            // Otherwise, close all devices and open the selected one
            data.forEach(function (item) {
                item.showDispatch = false;
            });

            // Increment request counter before making a new request
            var currentRequest = ++requestCounter;
            toolTipTimer = $timeout(function () {
                ctrl.popupWindow.fetchTooltipData(device.id, ctrl.accountInfo.timeZone, null).then(function (resp) {
                    // Ensure only the latest request updates the UI
                    if (currentRequest === requestCounter) {
                        var updatedData = resp.substring(resp.indexOf("</div>") + 6);
                        ctrl.showDispatchData = $sce.trustAsHtml(updatedData);
                    }
                });
            }, toolTipWaitTime);

            $timeout(function () {
                device.showDispatch = true;
            });
        }

        // Update the overview data after changes
        $timeout(function () {
            ctrl.overview.set(data);
        });
    };

    ctrl.orderSelect = function (predicate, reverse) {
        ctrl.overview.setPredicate(predicate);
        ctrl.reverse = !reverse;
    };

    var orderBy = $filter('orderBy');
    ctrl.order = function () {
        var items = ctrl.overview.get();
        var predicate = ctrl.overview.getPredicate();
        if (!items || !Array.isArray(items)) return items;
        if (predicate == 'name') {
            ctrl.input = ctrl.reverse ? '-name' : 'name';
            items = orderBy(items, [predicate, ctrl.input], ctrl.reverse);
            // ctrl.overview.set(items);
        } else {
            //Sort RTUs on Alarm status >> Alarm/ Offline/ Service Mode/ Status/ Disabled/ OK.
            var order = [2, 3, 4, 6, 5, 1];
            items = items.sort(function (a, b) {
                var indexA = order.indexOf(a.state);
                var indexB = order.indexOf(b.state);

                // If status is not in the order list, push it to the end
                indexA = indexA === -1 ? order.length : indexA;
                indexB = indexB === -1 ? order.length : indexB;

                return ctrl.reverse ? indexB - indexA : indexA - indexB;
            });
            // ctrl.overview.set(items);
        }
        return items;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        _this.getStatusList();
    });

    $scope.$on("StopOverview", function (event, args) {
        if ($scope.$$destroyed) {
            // The scope is already destroyed, skip further processing.
            return;
        } else if (args.stop) {
            websocketService.connect();
            websocketService.startOverview();
        }
    });
}

OverviewController.$inject = ['_', '$scope', '$sce', '$location', 'authenticationService', 'translationService', 'openViewService', 'sharedSetupService', 'websocketService', 'PopupFactory', 'OverviewFactory', '$timeout', 'toaster', '$filter'];
'use strict';

angular.module('mc.overview').component('overview', {
    controller: OverviewController,
    transclude: true,
    templateUrl: 'ui/overview/overview-partial.html',
    bindings: {
        windowId: '<',
        mobile: '<',
        classicView: '<'
    }
});
//const UnitStateFactory = (HOST, $http) => {
//    class UnitState {

//        constructor() {

//        }

//        getData(customerId, deviceId) {
//            var self = this;
//            return $http.get(HOST + '/api/UnitState?customerId=' + customerId + '&deviceId=' + deviceId + "&" + new Date().getTime()
//            ).then(function (response) {
//                self.data = response.data;
//                self.loading = false;
//                return response;
//            });
//        };
//    }

//    return UnitState;
//}

//UnitStateFactory.$inject = ['HOST', '$http'];

//angular.module('mc.paging').factory('UnitStateFactory', UnitStateFactory);
"use strict";
mcapp.directive('pagingOperationDirective', ['$timeout', function ($timeout) {
    //ticket 53710: jQuery UI marks the accordion up as a tab widget (tablist/tab/tabpanel,
    //aria-selected), but each section just expands/collapses, so screen readers announced the
    //wrong kind of control. Each <h3> stays a heading and the button semantics move to a <span>
    //inside it (a <div> isn't allowed inside an <h3>). jQuery UI rewrites the header attributes
    //on every toggle, so this has to be re-applied after each one. The triangle icon must stay a
    //direct child of the <h3>: jQuery UI finds it with .children() to flip it on toggle.
    function fixAccordionSemantics(accordion) {
        accordion.removeAttr('role');
        accordion.children('.ui-accordion-header').each(function () {
            var header = $(this);
            var panel = header.next();
            var toggle = header.children('.paging-accordion-toggle');

            if (!toggle.length) {
                header.contents()
                    .filter(function () { return !$(this).hasClass('ui-accordion-header-icon'); })
                    .wrapAll('<span class="paging-accordion-toggle" role="button" tabindex="0"></span>');
                toggle = header.children('.paging-accordion-toggle');
                toggle.on('keydown', onToggleKeydown);
            }

            header.children('.ui-accordion-header-icon').attr('aria-hidden', 'true');
            toggle.attr({
                'aria-expanded': header.hasClass('ui-accordion-header-active') ? 'true' : 'false',
                'aria-controls': panel.attr('id')
            });
            header.removeAttr('role aria-selected aria-expanded aria-controls tabindex');
            panel.removeAttr('role');
        });
    }

    function onToggleKeydown(event) {
        switch (event.key) {
            case 'Enter':
            case ' ':
            case 'Spacebar':
                event.preventDefault(); //stop Space from scrolling the view behind it
                event.stopPropagation(); //otherwise jQuery UI's header keydown toggles it a second time
                $(this).parent().trigger('click');
                break;
            //jQuery UI's arrow/Home/End handling is the tab pattern's roving focus; it reads the
            //target's index among the headers, which is -1 for this span, and would then set the
            //span's tabindex to -1 and drop it out of the tab order
            case 'ArrowUp':
            case 'ArrowDown':
            case 'ArrowLeft':
            case 'ArrowRight':
            case 'Up':
            case 'Down':
            case 'Left':
            case 'Right':
            case 'Home':
            case 'End':
                event.stopPropagation();
                break;
        }
    }

    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        angular.element(document).ready(function () {
            $timeout(function () {
                var accordion = $("#paging-accordion");
                accordion.accordion({
                    heightStyle: "content",
                    collapsible: true,
                    active: scope.accordionActive,
                    activate: function (event, ui) {
                        scope.accordionActive = $(this).accordion("option", "active");
                        if (scope.accordionActive == scope.accordionInputMode) {
                            scope.getInputMode();
                            scope.selectedAnalogThresholds = false;
                            $timeout(function () {
                                scope.selectedInputMode = true;
                            }, 0);
                        }
                        else if (scope.accordionActive == scope.accordionAnalogThresholds) {
                            scope.getAnalogThresholds();
                            scope.selectedInputMode = false;
                        }
                        else {
                            scope.selectedInputMode = false;
                            scope.selectedAnalogThresholds = false;
                        }

                        $timeout(function () { scope.resizeModalFunction(); }, 0);

                    }
                });

                fixAccordionSemantics(accordion);
                //delegated, so it runs after jQuery UI's own click handler on the header has
                //toggled the section and reset the header's tab attributes
                accordion.on('click', '.ui-accordion-header', function () {
                    fixAccordionSemantics(accordion);
                });
            }, 0);
        });

    };
}]);

"use strict";

angular.module("mc.paging", []);
mcapp.controller("pagingLogController", ["$rootScope", "$scope", "sharedSetupService", "openViewService", "authenticationService", "translationService", "datetimeService", "pageRequestsService", "commandOptionsService", "$filter", "$element", 'savePdfService', '$timeout', 'toaster',
    function ($rootScope, $scope, sharedSetupService, openViewService, authenticationService, translationService, datetimeService, pageRequestsService, commandOptionsService, $filter, $element, savePdfService, $timeout, toaster) {
        sharedSetupService.getWindowId($scope);
        $scope.$ctrl = $scope;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }
        $scope.alerts = [];
        $scope.pageRequests = [];
        $scope.topMenuMarginLeft = $rootScope.mobile ? '-206px' : '-278px';
        $scope.translation = translationService.translation;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
        if (!$rootScope.mobile && !$rootScope.classicView) $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        $scope.prId = null;
        $scope.startDate = null;
        $scope.removeOption = true;
        $scope.scrollingInProgress = false;
        $scope.currentDevice = null;
        $scope.currentDate = null;
        $scope.dateStart = null;
        $scope.dateEnd = null;
        $scope.infiniteScroll = false;
        $scope.infiniteScrollUp = false;
        $scope.numberOfNewRecordsPrevious = -1;
        $scope.downloadViewTypeOptions = [0, 1, 2];
        $scope.isRefresh = false;

        sharedSetupService.broadcastAllDeviceSelected($scope);

        $scope.savePdf = function () {

            var windowTitle = $scope.windowTitle.toUpperCase().replace(/ /g, "_");
            var pdfParams = {
                windowTitle: windowTitle,
                pdfTitle: $scope.windowTitle + ': ' + $scope.deviceSelectedSn,
                customerName: $scope.accountInfo.customerName,
                customerId: $scope.accountInfo.customerId,
                dateTranslate: $scope.translation.text.DATE_CREATED,
                dateRangeStart: $scope.myDateRangeStart,
                dateRangeEnd: $scope.myDateRangeEnd,
                $scope: $scope,
                $element: $element
            }

            savePdfService.savePDF(pdfParams);
        };

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.qdpLeft = -237;      //added to modify datepicker's position
            sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                open: function (event, ui) {
                    $scope.adjustSize();
                }
            });


            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }

        $scope.fnRemovePageRequest = function (varPageRequestId) {
            if (varPageRequestId == null) return false;
            $scope.alerts = [];
            $scope.removeOption = true;
            $scope.loadingInProgress = true;
            pageRequestsService.deleteDataById(varPageRequestId, $scope.deviceSelected, $scope.deviceSelectedType, $scope.accountInfo.timeZone).then(function (dataFromFactory) {
                $scope.loadingInProgress = false;
                $scope.pageRequests = dataFromFactory.data;
                $scope.formatData();
            }, function (error) {
                $scope.loadingInProgress = false;
                var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                $scope.alerts.push({ msg: errormsg, type: "danger" });
            });
            return false;
        };

        $scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                $scope.changeDeviceOrDate = true;
                $scope.infiniteScroll = false;
                $scope.infiniteScrollUp = false;
                $scope.pageRequests = [];
                $scope.currentDevice = newValue;
                var _device = { deviceName: $scope.deviceSelectedName };
                sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });
                $scope.getData(newValue);
            }
        }, true);

        $scope.$watch('myDate', function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                $scope.changeDeviceOrDate = true;
                $scope.infiniteScroll = false;
                $scope.infiniteScrollUp = false;
                $scope.pageRequests = [];
                $scope.currentDate = newVal;
                $scope.currentDate.setDate($scope.currentDate.getDate() + 1);
                $scope.currentDate.setHours(5, 0, 0, 0);
                $scope.dateEnd = datetimeService.dateToUnixtime($scope.currentDate);
                $scope.dateStart = $scope.dateEnd - 90 * 86400 * 1000;
                $scope.currentDate = datetimeService.dateToUnixtime($scope.currentDate);

                $scope.getData($scope.currentDevice);
            }
        });

        $scope.mostRecentData = function () {
            toaster.pop('success', $scope.windowTitle + " -- " + $scope.deviceSelectedName, 'View reloading');                                 
            //$scope.infiniteScroll = false;
            //$scope.infiniteScrollUp = false;
            $scope.pageRequests = [];
            $scope.isRefresh = true;
            $scope.currentDate = null;    
            $scope.myDate = null;
            $scope.getData($scope.currentDevice);
        }

        $scope.getData = function (varDeviceId) {
            if ((!$scope.infiniteScroll && !$scope.infiniteScrollUp) || $scope.changeDeviceOrDate) {
                $scope.alerts = [];
                $scope.removeOption = true;
                $scope.loadingInProgress = true;
                if ($scope.currentDate == null) {
                    $scope.currentDate = new Date();
                    $scope.currentDate.setDate($scope.currentDate.getDate() + 1);
                    $scope.currentDate.setHours(5, 0, 0, 0);
                    $scope.dateEnd = datetimeService.dateToUnixtime($scope.currentDate);
                    $scope.dateStart = $scope.dateEnd - 90 * 86400 * 1000;
                    $scope.currentDate = datetimeService.dateToUnixtime($scope.currentDate);
                }
                pageRequestsService.getData(varDeviceId, $scope.deviceSelectedType, $scope.accountInfo.timeZone, $scope.dateStart, $scope.dateEnd, 0).then(function (dataFromFactory) {
                    $scope.loadingInProgress = false;
                    $scope.changeDeviceOrDate = false;
                    $scope.infiniteScroll = false;
                    $scope.infiniteScrollUp = false;
                    $scope.isRefresh = false;
                    $scope.pageRequests = dataFromFactory.data;
                    $scope.formatData();
                    if ($scope.pageRequests.length > 0) {
                        $scope.prId = $scope.pageRequests[$scope.pageRequests.length - 1].pageRequestId;
                        $scope.startDate = $scope.pageRequests[$scope.pageRequests.length - 1].localDateTimeEntered;
                    }
                }, function (error) {
                    $scope.loadingInProgress = false;
                    var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                    $scope.alerts.push({ msg: errormsg, type: "danger" });
                });
            }
            else if ($scope.infiniteScroll && !$scope.infiniteScrollUp) {
                $scope.loadingInProgress = true;
                var newEndDate = new Date($scope.pageRequests[$scope.pageRequests.length - 1].localDateTimeEntered);
                var newEnd = datetimeService.dateToUnixtime(newEndDate);
                newEnd = newEnd + 5 * 3600 * 1000;      //added to avoid data gap when infinite scrolling
                var newStart = newEnd - 7 * 86400 * 1000;
                pageRequestsService.getData(varDeviceId, $scope.deviceSelectedType, $scope.accountInfo.timeZone, newStart, newEnd, 0).then(function (dataFromFactory) {
                    $scope.loadingInProgress = false;
                    $scope.infiniteScroll = false;
                    $scope.infiniteScrollUp = false;
                    $scope.pageRequests = $scope.pageRequests.concat(dataFromFactory.data);
                    $scope.formatData();
                    if ($scope.pageRequests.length > 0) {
                        $scope.prId = $scope.pageRequests[$scope.pageRequests.length - 1].pageRequestId;
                        $scope.startDate = $scope.pageRequests[$scope.pageRequests.length - 1].localDateTimeEntered;
                    }
                }, function (error) {
                    $scope.loadingInProgress = false;
                    var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                    $scope.alerts.push({ msg: errormsg, type: "danger" });
                });
            }
            else {
                $scope.loadingInProgress = true;
                var newStartDate = new Date($scope.pageRequests[0].localDateTimeEntered);
                var newStart = datetimeService.dateToUnixtime(newStartDate);
                newStart = newStart + 5 * 3600 * 1000;      //added to avoid data gap when infinite scrolling
                var newEnd = newStart + 7 * 86400 * 1000;

                pageRequestsService.getData(varDeviceId, $scope.deviceSelectedType, $scope.accountInfo.timeZone, newStart, newEnd, 1).then(function (dataFromFactory) {
                    $scope.loadingInProgress = false;
                    $scope.infiniteScroll = false;
                    $scope.infiniteScrollUp = false;
                    var items = dataFromFactory.data;
                    $scope.numberOfNewRecordsPrevious = dataFromFactory.data.length;
                    for (var i = 0; i < items.length; i++) {
                        items[i].localDateTime = items[i].localDateTime;
                        items[i].value = items[i].value;
                        $scope.pageRequests.unshift(items[i]);
                    }

                    $scope.formatData();
                    if ($scope.pageRequests.length > 0) {
                        $scope.prId = $scope.pageRequests[$scope.pageRequests.length - 1].pageRequestId;
                        $scope.startDate = $scope.pageRequests[$scope.pageRequests.length - 1].localDateTimeEntered;
                    }
                }, function (error) {
                    $scope.loadingInProgress = false;
                    var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                    $scope.alerts.push({ msg: errormsg, type: "danger" });
                });
            }
        };

        $scope.$on('changeDevicePaging', function (event, args) {
            if ($scope.deviceSelected == args.deviceId) {
                $scope.getData(args.deviceId);
                return;
            }
            $scope.setDevice(args.deviceId, args.deviceName, args.deviceSn);
        });

        $scope.$on('doneTransmitting', function (event, args) {
            if ($scope.deviceSelected == args.deviceId) {
                $scope.removeOption = true;
                $scope.getData(args.deviceId);
                return;
            }
        });

        $scope.$on('doneResponding', function (event, args) {
            if ($scope.deviceSelected == args.deviceId) {
                $scope.removeOption = true;
                $scope.getData(args.deviceId);
                return;
            }
        });

        $scope.$on('commandPaging', function (event, args) {
            if ($scope.deviceSelected == args.deviceId) {
                $scope.removeOption = false;
                $scope.alerts = [];
                //$scope.pageRequests = args.data;
                //$scope.formatData();
                $scope.getData(args.deviceId);
            }
        });

        $scope.$on('updatePreferencesLanguage', function () {
            $scope.loadingInProgress = true;
            $scope.pageRequests = angular.copy($scope.pageRequests);
            $scope.loadingInProgress = false;
        });
        
        $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            $scope.timeFormat = timeFormat;
        });
        //handling infinite scrolling
        var pagingLogContainer = $element.find('#paging-log-scroll-identifier');
        pagingLogContainer.on('scroll', function (event) {
            if ((pagingLogContainer[0].scrollTop + pagingLogContainer[0].offsetHeight >= pagingLogContainer[0].scrollHeight - 1) && !$scope.isRefresh) {
                $scope.infiniteScroll = true;
                $scope.getData($scope.currentDevice);
            }
            if (pagingLogContainer[0].scrollTop <= 0) {
                var today = new Date();
                today.setDate(today.getDate() + 1);
                today.setHours(5, 0, 0, 0);
                today = datetimeService.dateToUnixtime(today);
                if ($scope.currentDate == null || $scope.currentDate == today) return;
                $scope.infiniteScrollUp = true;
                $scope.getData($scope.currentDevice);
            }
        });

        $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            var today = new Date();
            today.setDate(today.getDate() + 1);
            today.setHours(5, 0, 0, 0);
            today = datetimeService.dateToUnixtime(today);
            if ($scope.currentDate == null || $scope.currentDate == today) return;
            _autoScroll();
            //scope.checkFirstRowLiveStatus = null;
            // scope.trgScroll();
        });

        var _autoScroll = function () {
            if ($scope.numberOfNewRecordsPrevious > 0) {
                var trRow = pagingLogContainer.find('tr').eq($scope.numberOfNewRecordsPrevious - 1);
                var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
                pagingLogContainer.scrollTop(yPosition);
            }
            else {
                $timeout(function () {
                    pagingLogContainer.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        var logdiv = $element.find('.tabular-data-container');
        logdiv.on('scroll', function (event) {
            if ($scope.scrollingInProgress == false && logdiv[0].scrollTop + logdiv[0].offsetHeight + 10 > logdiv[0].scrollHeight && !$scope.loadingInProgress && $scope.startDate !== null) {
                $scope.scrollingInProgress = true;
                $scope.alerts = [];
                $scope.loadingInProgress = true;
                pageRequestsService.getDataById($scope.deviceSelected, $scope.deviceSelectedType, $scope.startDate, $scope.accountInfo.timeZone).then(function (dataFromFactory) {
                    $scope.pageRequestsTmp = dataFromFactory.data;
                    for (var i = 0; i < dataFromFactory.data.length; i++) {
                        $scope.pageRequestsTmp[i].localDateTimeEnteredFiltered = $filter("filterDateAgentText")($scope.pageRequestsTmp[i].localDateTimeEntered);
                        $scope.pageRequestsTmp[i].localDateTimeCompletedFiltered = $filter("filterDateAgentTextPaging")($scope.pageRequestsTmp[i].localDateTimeCompleted);
                        $scope.pageRequestsTmp[i].removePageRequest = (new Date($scope.pageRequestsTmp[i].localDateTimeCompleted)).getTime() < 0 ? true : false;
                        $scope.pageRequests.push($scope.pageRequestsTmp[i]);
                    }
                    $scope.loadingInProgress = false;
                    if ($scope.pageRequestsTmp.length == 0) {
                        $scope.prId = null;
                    }
                    else {
                        $scope.prId = $scope.pageRequestsTmp[$scope.pageRequestsTmp.length - 1].pageRequestId;
                        $scope.startDate = $scope.pageRequestsTmp[$scope.pageRequestsTmp.length - 1].localDateTimeEntered;
                    }
                }, function (error) {
                    $scope.loadingInProgress = false;
                    var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                    $scope.alerts.push({ msg: errormsg, type: "danger" });
                });
                $scope.scrollingInProgress = false;
            }
        });

        $scope.formatData = function () {
            if ($scope.pageRequests.length == 0) {
                var errormsg = $scope.translation.message.NO_RECENT_DATA;
                $scope.alerts.push({ msg: errormsg, type: "info" });
            }
            else {
                for (var i = 0; i < $scope.pageRequests.length; i++) {
                    $scope.pageRequests[i].localDateTimeEnteredFiltered = $filter("filterDateAgentText")($scope.pageRequests[i].localDateTimeEntered);
                    $scope.pageRequests[i].localDateTimeCompletedFiltered = $filter("filterDateAgentTextPaging")($scope.pageRequests[i].localDateTimeCompleted);
                    $scope.pageRequests[i].removePageRequest = (new Date($scope.pageRequests[i].localDateTimeCompleted)).getTime() < 0 ? true : false;
                }
            }
        };

    }]);

mcapp.factory('pageRequestsService', ['$http', 'HOST', function ($http, HOST) {
    var pageRequestsFactory = {};

    var _getData = function (deviceId, deviceTye, timeZone, startDate, endDate, direction) {
        return $http({
            method: 'Get',
            url: HOST + '/api/PageRequests?deviceId=' + deviceId + "&deviceType=" + deviceTye + "&timeZone=" + timeZone + "&startDate=" + startDate + "&endDate=" + endDate + "&direction=" + direction + "&" + new Date().getTime(),
            cache: false
        });
    };

    var _getDataById = function (deviceId, deviceTye, startDate, timeZone) {
        return $http({
            method: 'Get',
            url: HOST + '/api/PageRequests?deviceId=' + deviceId + "&deviceType=" + deviceTye + "&startDate=" + startDate + "&timeZone=" + timeZone + "&" + new Date().getTime(),
            cache: false
        });
    };

    var _deleteDataById = function (id, deviceId, deviceTye, timeZone) {
        return $http({
            method: 'Delete',
            url: HOST + '/api/PageRequests?pageRequestId=' + id + '&deviceId=' + deviceId + "&deviceType=" + deviceTye + "&timeZone=" + timeZone + "&" + new Date().getTime(),
            cache: false
        });
    };

    var _getRecordById = function (timeZone, id, commandId) {
        if (commandId == 101) {
            return $http({
                method: 'Get',
                url: HOST + '/api/AnalogOutputLog?timeZone=' + timeZone + "&id=" + id + "&" + new Date().getTime(),
                cache: false
            });
        }
        else {
            return $http({
                method: 'Get',
                url: HOST + '/api/PageRequests?timeZone=' + timeZone + "&id=" + id + "&" + new Date().getTime(),
                cache: false
            });
        }
    };

    var _postData = function (customerId, commandId, deviceTye, protocolVersion, timeZone, varPageRequests) {
        if (commandId >= 300)
            return $http.post(HOST + '/api/Gen2/DeviceConfig/PageGenTwo?customerId=' + customerId + '&commandId=' + commandId + '&protocolVersion=' + protocolVersion + "&" + new Date().getTime(), varPageRequests);

        return $http.post(HOST + '/api/PageRequests/PostAndFetch/?customerId=' + customerId + '&commandId=' + commandId + "&deviceType=" + deviceTye + "&timeZone=" + timeZone + "&" + new Date().getTime(), varPageRequests);
    };

    pageRequestsFactory.getData = _getData;
    pageRequestsFactory.getDataById = _getDataById;
    pageRequestsFactory.deleteDataById = _deleteDataById;
    pageRequestsFactory.getRecordById = _getRecordById;
    pageRequestsFactory.postData = _postData;
    return pageRequestsFactory;
}]);

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function pagingComponentController($rootScope, $scope, sharedSetupService, authenticationService, translationService, datetimeService, pageRequestsService, CommandOptionsFactory, openViewService, AnalogOutputPagingFactory, websocketService, $timeout, unitStateService, deviceMenuService, AnalogThresholdsFactory, deviceService, deviceNotificationSettingService, relaysSettingService) {
    var ctrl = this;

    ctrl.$onInit = function () {
        $scope.windowId = ctrl.windowId; //need for
        ctrl.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { windowId: $scope.windowId });
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
    };

    sharedSetupService.getWindowId($scope);
    $scope.alerts = [];
    $scope.topMenuMarginLeft = '-278px';
    $scope.Channel = [];
    $scope.analogData = [];
    $scope.rtuData = [];
    ctrl.commandOptionsTargetHours = [];
    ctrl.commandOptionsTargetMinutes = [];
    ctrl.translation = translationService.translation;
    $scope.accountInfo = authenticationService.getAccountInfo();
    ctrl.isSuperAdmin = sharedSetupService.isSuperAdmin($scope.accountInfo);
    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        //THE-51575: jQuery UI renders the window title as a plain <span>; role/aria-level expose
        //it as an <h2> without Bootstrap's h2 styling. children() so a .ui-dialog-title inside
        //the view content is never matched
        $scope.popup.dialog('widget').children(".ui-dialog-titlebar").children(".ui-dialog-title").attr({ "role": "heading", "aria-level": "2" });
    }
    $scope.rtuAnalog = null;
    $scope.rtuDigital = null;
    $scope.commandRequestCounter = 0;
    $scope.commandRequestCounterRTU = 0;
    $scope.progressBarStart = 2;
    $scope.numberOfCalls = 12;
    $scope.commandRequestInterval = 5000;
    $scope.fnCommandRequest;
    $scope.numberOfCallsRTU = 12;
    $scope.fnRtuRequestInterval = 5000;
    $scope.rtuMinimumResponseTime = 4000;
    $scope.fnRtuRequest;
    $scope.currentRegister = { deviceSn: null, messageType: '', channel: '' };
    ctrl.inputModes = [1, 2, 3, 4, 5, 6, 7, 8];
    ctrl.smpAddressCommands = [147, 148, 149, 150, 151, 155, 156];
    ctrl.isSmpAddressCommand = false;
    //ctrl.electricModes = [{ "id": 0, "Name": "Dry Contact" },
    //{ "id": 1, "Name": "Dry Contact(No Fault)" },
    //{ "id": 2, "Name": "Current Sensor" },
    //{ "id": 3, "Name": "Current Sensor(No Fault)" }];
    ctrl.electricModes = [{ "id": 0, "Name": "Dry Contact" }, { "id": 1, "Name": "Dry Contact(No Fault)" }, { "id": 2, "Name": "OP400 Sensor" }];
    ctrl.eletricModeTabSelected = false;
    ctrl.selectedElectricModes = [];
    ctrl.modeSelectedOptions = [];
    ctrl.modbusAddress = 200;
    ctrl.notValidModbusAddress = false;
    ctrl.modbusAddressErrorMsg = ctrl.translation.text.VALID_MODBUS_ADDRESS + ': ' + '0 - 247';
    sharedSetupService.broadcastAllDeviceSelected($scope);
    ctrl.relayOpenOptions = [];
    ctrl.relayCloseOptions = [];
    ctrl.numberOfChannels = 16;

    ctrl.CommandOptionsFactory = new CommandOptionsFactory();
    ctrl.AnalogOutputPagingFactory = new AnalogOutputPagingFactory();
    ctrl.AnalogThresholdsFactory = new AnalogThresholdsFactory();

    //set up dropdown list options for manhole monitor float debounce and checkin time commands
    ctrl.setUpManholeMonitorOptions = function () {
        for (var i = 1; i <= 12; i++) {
            ctrl.commandOptionsTargetHours.push({ "id": i, "commandDescription": i });
        };
        for (var _i = 0; _i <= 59; _i++) {
            ctrl.commandOptionsTargetMinutes.push({ "id": _i, "commandDescription": _i });
        };
        ctrl.commandOptionsTargetMeridians = [{ "id": 1, "commandDescription": "AM" }, { "id": 2, "commandDescription": "PM" }];
    };

    $scope.adjustWindowHeight = function (pagingViewHeight) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);
        var _viewHeight = parseInt($scope.popup.parent().css("height").replace(/[^0-9.]+/g, ""));
        var _adjHeight = parseInt(pagingViewHeight);

        $scope.popup.parent().find('div:eq(2)').css("height", _viewHeight + _adjHeight).css("opacity", 1);
        $scope.popup.parent().css("height", _viewHeight + _adjHeight);
    };

    $scope.adjustHeight = function (electricMode) {
        if (electricMode == 1) {
            $scope.eletricModeTabSelected = !$scope.eletricModeTabSelected;
            if ($scope.eletricModeTabSelected) {
                $scope.pagingHeight = 195;
            } else {
                $scope.pagingHeight = -195;
            }
            $scope.adjustWindowHeight($scope.pagingHeight);
        } else if (electricMode == 0 && $scope.eletricModeTabSelected) {
            $scope.eletricModeTabSelected = !$scope.eletricModeTabSelected;
            $scope.adjustWindowHeight(-195);
        }
    };

    $scope.resizeModal = function (delay) {
        var waitDelay = angular.isUndefined(delay) ? 700 : delay;
        $timeout(function () {
            $scope.resizeModalFunction();
        }, waitDelay);
    };

    $scope.resizeModalFunction = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            var tmpTitle = parseInt($scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            if (typeof $scope.popup.parent().find('.paging-accordion-container')[0] !== 'undefined') {
                var newHeight = $scope.popup.parent().find('.paging-accordion-container')[0].clientHeight + 45;
                //Adjusting the height to minmum of 200px so that the view is not breaking for M84 Devices
                if (newHeight < 200) {
                    newHeight = 200;
                };
                $scope.popup.parent().find('div:eq(2)').css("height", newHeight);
                $scope.popup.parent().css("height", tmpTitle + newHeight);
                $scope.popup.dialog('widget').css("height", tmpTitle + newHeight + "px");
                $scope.popup.dialog("option", "height", tmpTitle + newHeight);
                $scope.popup.parent().animate({ opacity: 1 }, 75);
            }
        }
        $scope.rtuViewBusy = false;
    };

    ctrl.setUpFloatDebounceOptions = function () {
        ctrl.commandOptionsFloatLDebounce = [{ "id": 0, "commandDescription": "Disabled" }, { "id": 1, "commandDescription": "5 Seconds" }, { "id": 2, "commandDescription": "15 Seconds" }, { "id": 3, "commandDescription": "30 Seconds" }, { "id": 4, "commandDescription": "60 Seconds" }];

        ctrl.commandOptionsFloatHDebounce = [{ "id": 0, "commandDescription": "Disabled" }, { "id": 1, "commandDescription": "5 Seconds" }, { "id": 2, "commandDescription": "15 Seconds" }, { "id": 3, "commandDescription": "30 Seconds" }, { "id": 4, "commandDescription": "60 Seconds" }];
    };

    ctrl.chanTypeOptions = [{ id: 0, chanType: "ai", chanTypeDsc: "Analog Input channel" }, { id: 1, chanType: "di", chanTypeDsc: "Digital Input channel" }, { id: 2, chanType: "pi", chanTypeDsc: "Pulse Input channel" },
    /*{ id: 3, chanType: "rio", chanTypeDsc: "Register I/O channel" },*/
    { id: 4, chanType: "ao", chanTypeDsc: "Analog Output channel" }, { id: 5, chanType: "do", chanTypeDsc: "Digital Output channel" }];
    ctrl.netTypeOptions = [{ id: 0, netType: "RTU" }];

    ctrl.relayModeOptions = [{ id: 0, mode: "Open" }, { id: 1, mode: "Close" }];

    ctrl.auxModeOptions = [{ id: 0, mode: "0V" }, { id: 1, mode: "12V" }, { id: 2, mode: "24V" }];

    $scope.sliderValue = 10;

    ctrl.modeList = [{ id: "R", desc: "R" }, { id: "A", desc: "A" }, { id: "D", desc: "D" }, { id: "S", desc: "S" }];
    ctrl.modeListForInputFourToEight = [{ id: "R", desc: "R" }, { id: "A", desc: "A" }, { id: "D", desc: "D" }, { id: "S", desc: "S" }];
    ctrl.debounceList = [{ id: "00", desc: "0" }, { id: "01", desc: "10" }, { id: "02", desc: "20" }, { id: "03", desc: "30" }, { id: "04", desc: "40" }, { id: "05", desc: "50" }, { id: "06", desc: "60" }, { id: "07", desc: "70" }, { id: "08", desc: "80" }, { id: "09", desc: "90" }];
    ctrl.lacPscAmmAfList1 = [{ id: "Y", description: "Send Large Analog Changes" }, {
        id: "N", description: "Dont Send Large Analog Changes"
    }];
    ctrl.lacPscAmmAfList2 = [{ id: "Y", description: "Enable Pump State Changes" }, {
        id: "N", description: "Disable Pump State Changes"
    }];
    ctrl.lacPscAmmAfList3 = [{ id: "N", description: "Dont Send Hourly Analog Min Max" }, {
        id: "Y", description: "Send Hourly Analog Min Max"
    }];
    ctrl.lacPscAmmAfList4 = [{ id: "N", description: "Disabled Analog Filter" }, {
        id: "Y", description: "Enabled Analog Filter"
    }];
    ctrl.simModeList = [{ id: "00", desc: "Automatic" }, { id: "01", desc: "Manual" }];
    ctrl.simPrioritySelectionList = [{ id: "01", desc: "Embedded SIM" }, { id: "02", desc: "Removable SIM" }];

    //$scope.debounceSelectedOptions = [$scope.debounce1SelectedOption, $scope.debounce2SelectedOption, $scope.debounce3SelectedOption, $scope.debounce4SelectedOption, $scope.debounce5SelectedOption, $scope.debounce6SelectedOption, $scope.debounce7SelectedOption, $scope.debounce8SelectedOption]

    ctrl.sendAnalogLargeChange = 'N';
    ctrl.sendPumpStateChange = 'N';
    ctrl.sendAnalogMinMax = 'N';
    ctrl.analogFilterEnabled = 'N';

    ctrl.spinner = "<i class='fa fa-spinner fa-lg fa-spin'></i>";
    ctrl.okCheck = "<i class='fa fa-check fa-lg fa-green' ></i>";
    ctrl.errorCheck = "<i class='fa fa-exclamation-circle fa-lg fa-red'></i>";
    ctrl.warningCheck = "<i class='fa fa-exclamation-triangle fa-lg fa-warning'></i>";

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.adjustWindowHeight(sharedSetupService.pagingViewHeightAdjustment);
        $scope.resizeModal();
    }

    ///////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////
    ctrl.customUi300 = false;
    ctrl.customUi310 = false;
    ctrl.customUi307 = false;
    ctrl.customUi311 = false;
    ctrl.customUi312 = false;
    ctrl.customUiMyDro = false;
    ctrl.customUiBusy = false;
    ctrl.customUi412413 = false;

    ctrl.setCustomUi300Data = function (value) {
        value = value === "" ? null : value;
        if (value != null) {
            $scope.customUi300Data.ver = value.softwareVersion.toString();
            $scope.customUi300Data.file = value.fileName;
        } else {
            $scope.customUi300Data.ver = null;
            $scope.customUi300Data.file = null;
        }
    };
    ctrl.setCustomUi310Data = function (value) {
        value = value === "" ? null : value;
        if (value != null) {
            $scope.customUi310Data.ver = value.softwareVersion.toString();
            $scope.customUi310Data.file = value.fileName;
        } else {
            $scope.customUi310Data.ver = null;
            $scope.customUi310Data.file = null;
        }
    };

    ctrl.setNumberOfChannelsForDevice = function (chanType) {
        switch (chanType) {
            case "ai":
                ctrl.numberOfChannels = ctrl.deviceSelected.maxAnalogInputs;
                break;
            case "di":
                ctrl.numberOfChannels = ctrl.deviceSelected.maxDigitalInputs;
                break;
            case "pi":
                ctrl.numberOfChannels = ctrl.deviceSelected.maxPulseInputs;
                break;
            case "ao":
                ctrl.numberOfChannels = ctrl.deviceSelected.maxAnalogOutputs;
                break;
            case "do":
                ctrl.numberOfChannels = ctrl.deviceSelected.maxDigitalOutputs;
                break;
        }
    };

    ctrl.setChannelTypeOptionsForDevice = function (deviceType) {
        switch (deviceType) {
            case 15:
                ctrl.chanTypeOptions = [{ id: 1, chanType: "di", chanTypeDsc: "Digital Input channel" }];
                break;
            case 20:
                ctrl.chanTypeOptions = [{ id: 0, chanType: "ai", chanTypeDsc: "Analog Input channel" }, { id: 1, chanType: "di", chanTypeDsc: "Digital Input channel" }];
                break;
            case 21:
                ctrl.chanTypeOptions = [{ id: 0, chanType: "ai", chanTypeDsc: "Analog Input channel" }, { id: 1, chanType: "di", chanTypeDsc: "Digital Input channel" }, { id: 2, chanType: "pi", chanTypeDsc: "Pulse Input channel" }, { id: 5, chanType: "do", chanTypeDsc: "Digital Output channel" }];
                break;
            default:
                break;
        }
    };

    ctrl.setCustomUi307Data = function (type, value) {
        value = value === "" ? null : value;
        switch (type) {
            case "netType":
                $scope.customUi307Data.netType = value;
                break;
            case "nodeAddr":
                $scope.customUi307Data.nodeAddr = value;
                break;
            case "chanType":
                $scope.customUi307Data.chanType = value;
                ctrl.setNumberOfChannelsForDevice(value);
                break;
            case "chanNum":
                $scope.customUi307Data.chanNum = value;
                break;
        }

        ctrl.genTwoCustomUiValid = !($scope.customUi307Data.netType === null || angular.isUndefined($scope.customUi307Data.netType)) && !($scope.customUi307Data.nodeAddr === null || angular.isUndefined($scope.customUi307Data.nodeAddr)) && !($scope.customUi307Data.chanType === null || angular.isUndefined($scope.customUi307Data.chanType)) && !($scope.customUi307Data.chanNum === null || angular.isUndefined($scope.customUi307Data.chanNum));
    };

    ctrl.setCustomUi311Data = function (type, value) {
        value = value === "" ? null : value;
        switch (type) {
            case "chanNum":
                $scope.customUi311Data.chanNum = value;
                break;
            case "mode":
                $scope.customUi311Data.mode = value.toLowerCase();
                break;

        }

        ctrl.genTwoCustomUiValid = !($scope.customUi311Data.chanNum === null || angular.isUndefined($scope.customUi311Data.chanNum)) && !($scope.customUi311Data.mode === null || angular.isUndefined($scope.customUi311Data.mode));
    };

    ctrl.setCustomUi312Data = function (value) {
        value = value === "" ? null : value;
        if (value != null) {
            $scope.customUi312Data.mqttPortID = value.mqttPortID;
            $scope.customUi312Data.mqttPortNum = value.mqttPortNum;
        }
        ctrl.genTwoCustomUiValid = !($scope.customUi312Data.mqttPortID === null || angular.isUndefined($scope.customUi312Data.mqttPortID)) && !($scope.customUi312Data.mqttPortNum === null || angular.isUndefined($scope.customUi312Data.mqttPortNum));
    };

    ctrl.setCustomUi412413Data = function (value) {
        value = value === "" ? null : value;
        if (value != null) {
            $scope.customUi412413Data.seconds = value;
        }
        ctrl.genTwoCustomUiValid = !($scope.customUi412413Data.seconds === null || angular.isUndefined($scope.customUi412413Data.seconds));
    };

    ctrl.setCustomUiMydro16Data = function (type, value) {
        value = value === "" ? null : value;
        switch (type) {
            case "netType":
                $scope.customUiMydro16Data.netType = value;
                break;
            case "nodeAddr":
                $scope.customUiMydro16Data.nodeAddr = value;
                break;
            case "chanType":
                $scope.customUiMydro16Data.chanType = value;
                ctrl.setNumberOfChannelsForDevice(value);
                break;
            case "chanNum":
                $scope.customUiMydro16Data.chanNum = value;
                break;
            case "mode":
                $scope.customUiMydro16Data.mode = value;
                break;
        }
        $scope.myDro16CustomUiValid = !($scope.customUiMydro16Data.netType === null || angular.isUndefined($scope.customUiMydro16Data.netType));
    };

    //$scope.analogOut = 8;
    ctrl.selectRelayOpenBusy = false;
    ctrl.selectedRelayOpen = false;
    ctrl.selectRelayCloseBusy = false;
    ctrl.selectedRelayClose = false;
    ctrl.analogOutChannel = 1;
    ctrl.selectAnalogOutputBusy = false;
    ctrl.selectedAnalogOutput = false;
    ctrl.analogValueChannel1 = null;
    ctrl.analogValueChannel2 = null;
    ctrl.analogValueChannel3 = null;
    ctrl.analogValueChannel4 = null;
    ctrl.analogOutputPagingSetting = {
        deviceId: null, channel: null, channelName: null, unit: null, minimumValue: null, maximumValue: null
    };
    ctrl.analogOutputPagingData = {
        deviceId: null, channel: null, data: null
    };
    ///////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////

    ctrl.commandInProcess = null;
    ctrl.inputModeBusy = false;
    $scope.selectedInputMode = false;
    ctrl.analogThresholdsBusy = false;
    $scope.selectedAnalogThresholds = false;
    $scope.accordionActive = 0;
    $scope.accordionAnalogThresholds = 3;
    $scope.accordionInputMode = 5;

    if (_typeof(ctrl.stickyProperties) != 'object') {
        ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
    }

    ctrl.commandAdminAccess = sharedSetupService.mcAdmin();

    ctrl.checkForSmpAddressCommand = function () {
        if (ctrl.smpAddressCommands.includes(ctrl.commandSmpPulsesSelected.commandId)) {
            ctrl.isSmpAddressCommand = true;
            ctrl.modbusAddress = 200;
        } else {
            ctrl.isSmpAddressCommand = false;
        }
    };

    $scope.openPagingLog = function () {
        var _popupPosition = $scope.popup.dialog("option", "position");
        openViewService.openView('Paging Log', { width: 600, height: 300 }, { my: 'top', at: 'bottom+10', of: $scope.popup }, ctrl.stickyProperties, {
            minimumWidth: 600, minimumHeight: 300
        });
    };

    //ticket 53660: the Command Log icon is a <div role="button">, so it has to answer
    //Enter/Space the way a real button would
    $scope.onPagingLogKeydown = function ($event) {
        if ($event.key === "Enter" || $event.key === " " || $event.key === "Spacebar") {
            $event.preventDefault(); //stop Space from scrolling the view behind it
            $scope.openPagingLog();
        }
    };

    ctrl.getText = function (text) {
        if (!angular.isDefined(text) || text === null) return;
        //if (text.indexOf("Open") > -1 || text.indexOf("Close") > -1) return $scope.getTextRelay(text);
        if (text.indexOf("Set Analog Output 1 to") > -1) return ctrl.translation.text.SET_ANALOG_OUTPUT_1_TO + text.substring(22);
        if (text.indexOf("Set Analog Output 2 to") > -1) return ctrl.translation.text.SET_ANALOG_OUTPUT_2_TO + text.substring(22);
        if (text.indexOf("Set Analog Output 3 to") > -1) return ctrl.translation.text.SET_ANALOG_OUTPUT_3_TO + text.substring(22);
        if (text.indexOf("Set Analog Output 4 to") > -1) return ctrl.translation.text.SET_ANALOG_OUTPUT_4_TO + text.substring(22);
        return typeof ctrl.translation.text[text.toUpperCase().replace(/ /g, "_").replace("/", "_")] !== 'undefined' ? ctrl.translation.text[text.toUpperCase().replace(/ /g, "_").replace("/", "_")] : text;
        //return typeof eval("$scope.translation.text['" + text.toUpperCase().replace(/ /g, "_").replace("/", "_") + "']") !== 'undefined' ? eval("$scope.translation.text['" + text.toUpperCase().replace(/ /g, "_").replace("/", "_") + "']") : text;
    };

    $scope.getTextRelay = function (text) {
        if (text.indexOf("1 Open") > -1) {
            return typeof eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_")) !== 'undefined' ? eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_") + " " + ctrl.translation.text.OPEN) : text;
        } else if (text.indexOf("1 Close") > -1) {
            return typeof eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_")) !== 'undefined' ? eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_") + " " + ctrl.translation.text.CLOSE) : text;
        } else if (text.indexOf("2 Open") > -1) {
            return typeof eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_")) !== 'undefined' ? eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_") + " " + ctrl.translation.text.OPEN) : text;
        } else if (text.indexOf("2 Close") > -1) {
            return typeof eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_")) !== 'undefined' ? eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_") + " " + ctrl.translation.text.CLOSE) : text;
        } else if (text.indexOf("3 Open") > -1) {
            return typeof eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_")) !== 'undefined' ? eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_") + " " + ctrl.translation.text.OPEN) : text;
        } else if (text.indexOf("3 Close") > -1) {
            return typeof eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_")) !== 'undefined' ? eval("ctrl.translation.text." + text.toUpperCase().replace(" Open", "").replace(/ /g, "_") + " " + ctrl.translation.text.CLOSE) : text;
        }
    };

    ctrl.getCheckinTime = function (object, text) {
        switch (text) {
            case "HOUR":
                ctrl.commandTargetTXHour = object;
                break;
            case "MINUTE":
                ctrl.commandTargetTXMinute = object;
                break;
            case "MERIDIAN":
                ctrl.commandTargetTXMeridian = object;
                break;
        }
    };

    ctrl.getFloatDebounce = function (object, text) {
        var tmpFloat = 0;
        switch (object.id) {
            case 0:
                tmpFloat = 0;
                break;
            case 1:
                tmpFloat = 5;
                break;
            case 2:
                tmpFloat = 15;
                break;
            case 3:
                tmpFloat = 30;
                break;
            case 4:
                tmpFloat = 60;
                break;
        }
        switch (text) {
            case "LOW":
                ctrl.commandFloatLDebounce = tmpFloat;
                break;
            case "HIGH":
                ctrl.commandFloatHDebounce = tmpFloat;
                break;
        }
    };

    ctrl.filterCommandOptions = function (varId) {
        if (ctrl.commandOptions == null) {
            ctrl.commandOptionsOperations = null;
            ctrl.commandOptionsAnalogSpeed = null;
            ctrl.commandOptionsFlowSpeed = null;
            ctrl.commandOptionsLargeAnalog = null;
            $scope.commandOptionsLacPscAmmAf = null;
            ctrl.commandOptionsPumpState = null;
            ctrl.commandOptionsAnalogThresholds = null;
            ctrl.commandOptionsElectricModes = null;
            ctrl.commandOptionsSmpPulses = null;
            ctrl.commandOptionsNewLteRadios = null;
            $scope.commandOptionsSIMPriorityMode = null;
            $scope.commandOptionsSIMPrioritySelection = null;
            return;
        }
        //get manhole monitor checkin time options
        ctrl.setUpManholeMonitorOptions();
        //get manhole monitor float debounce options
        ctrl.setUpFloatDebounceOptions();
        //get checkin time command object
        $scope.commandCheckinTimes = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 64;
        });
        ctrl.commandCheckinTime = $scope.commandCheckinTimes[0];
        //get float debounce command object
        $scope.commandFloatDebounces = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 65;
        });
        $scope.commandFloatDebounce = $scope.commandFloatDebounces[0];

        ctrl.commandOptionsOperations = ctrl.commandOptions.filter(function (el) {
            //remove extra commands if the device is MyDro
            //Disable Option Board
            //Enable Option Board Pulse Only
            //Enable Option Board Pulse and Analog
            //Enable Option Board Digital Expansion
            //Enable Option Board Analog Output
            //Enable Option Board Analog Outputand Pulse
            //Set PXS8 to GSM
            //Set PXS8 to CDMA
            //Verizon Activate        
            if (ctrl.deviceType == 18 || ctrl.deviceType == 19) {
                return el.commandGroupId != 1 && el.commandGroupId != 3 && el.commandGroupId != 4 && el.commandGroupId != 7 && el.commandGroupId != 9 && el.commandGroupId != 10 && el.commandGroupId != 11 && el.commandGroupId != 64 && el.commandGroupId != 65 && el.commandGroupId != 67 && el.commandGroupId != 58 && el.commandGroupId != 59 && el.commandGroupId != 80 && el.commandGroupId != 81 && el.commandGroupId != 2 && el.commandGroupId != 12 && el.commandGroupId != 47;
            } else if (ctrl.deviceType == 17) {
                return el.commandGroupId != 1 && el.commandGroupId != 2 && el.commandGroupId != 3 && el.commandGroupId != 4 && el.commandGroupId != 7 && el.commandGroupId != 9 && el.commandGroupId != 10 && el.commandGroupId != 11 && el.commandGroupId != 12 && el.commandGroupId != 14 && el.commandGroupId != 15 && el.commandGroupId != 16 && el.commandGroupId != 17 && el.commandGroupId != 46 && el.commandGroupId != 47 && el.commandGroupId != 54 && el.commandGroupId != 58 && el.commandGroupId != 59 && el.commandGroupId != 64 && el.commandGroupId != 65 && el.commandGroupId != 67 && el.commandGroupId != 80 && el.commandGroupId != 81;
            } else {
                return el.commandGroupId != 1 && el.commandGroupId != 3 && el.commandGroupId != 4 && el.commandGroupId != 7 && el.commandGroupId != 9 && el.commandGroupId != 10 && el.commandGroupId != 11 && el.commandGroupId != 64 && el.commandGroupId != 65 && el.commandGroupId != 67 && el.commandGroupId != 58 && el.commandGroupId != 59 && el.commandGroupId != 80 && el.commandGroupId != 81;
            }
            //el.commandGroupId != 14 &&
            //el.commandGroupId != 15 &&
            //el.commandGroupId != 16 &&
            //el.commandGroupId != 17;
        });
        ctrl.commandOptionsAnalogSpeed = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 1;
        });
        ctrl.commandOptionsInputMode = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 3;
        });
        ctrl.commandOptionsDebounce = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 4;
        });
        ctrl.commandOptionsFlowSpeed = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 7;
        });
        ctrl.commandOptionsLargeAnalog = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 9;
        });
        $scope.commandOptionsLacPscAmmAf = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 10;
        });
        ctrl.commandOptionsPumpState = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 11;
        });
        ctrl.commandOptionsElectricModes = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 67;
        });
        ctrl.commandOptionsSmpPulses = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 58 && !(ctrl.deviceType === 17 && [152, 154].includes(el.commandId));
        });
        ctrl.commandOptionsNewLteRadios = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 59;
        });
        $scope.commandOptionsSIMPriorityMode = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 80;
        });
        $scope.commandOptionsSIMPrioritySelection = ctrl.commandOptions.filter(function (el) {
            return el.commandGroupId == 81;
        });
        //$scope.commandOptionsAnalogThresholds = $scope.commandOptions.filter(function (el) {
        //    return el.commandGroupId == 14 ||
        //           el.commandGroupId == 15 ||
        //           el.commandGroupId == 16 ||
        //           el.commandGroupId == 17;
        //});        
        //remove relay commands if the user is not super administrator or administrator
        if ($scope.accountInfo.userRole !== "SuperAdministrator" && $scope.accountInfo.userRole !== "Administrator") {
            var relayCommands = [91, 92, 93, 94, 95, 96, 97, 129, 132, 170, 171];
            //remove extra Analog Out command when user is read only
            if ($scope.accountInfo.userRole == "User" || $scope.accountInfo.userRole == "AlarmUser") {
                relayCommands = [91, 92, 93, 94, 95, 96, 97, 101, 129, 132, 170, 171];
            }
            var tmpCommandOptionsOperations = [];
            for (var i = 0; i < ctrl.commandOptionsOperations.length; i++) {
                if (relayCommands.indexOf(ctrl.commandOptionsOperations[i].commandId) == -1) {
                    tmpCommandOptionsOperations.push(ctrl.commandOptionsOperations[i]);
                }
            }
            ctrl.commandOptionsOperations = tmpCommandOptionsOperations;
        }
        //remove one second pulse for relay 1 and 2 if device has EBPC purchased
        if (ctrl.hasEBPC) {
            var relayOneSecondPulseCommands = [97, 129];
            var _tmpCommandOptionsOperations = [];
            for (var _i2 = 0; _i2 < ctrl.commandOptionsOperations.length; _i2++) {
                if (relayOneSecondPulseCommands.indexOf(ctrl.commandOptionsOperations[_i2].commandId) == -1) {
                    _tmpCommandOptionsOperations.push(ctrl.commandOptionsOperations[_i2]);
                }
            }
            ctrl.commandOptionsOperations = _tmpCommandOptionsOperations;
        }
    };

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.analogValueChannel1 = null;
            ctrl.analogValueChannel2 = null;
            ctrl.analogValueChannel3 = null;
            ctrl.analogValueChannel4 = null;
            $scope.alerts = [];
            ctrl.loadingInProgress = true;
            var _device = {
                deviceName: $scope.deviceSelectedName
            };
            sharedSetupService.setStickyProperties(ctrl.stickyProperties, {
                deviceId: newValue, device: _device, windowId: $scope.windowId
            });
            for (var index = 0; index < $scope.devices.length; ++index) {
                if ($scope.devices[index].deviceId == $scope.deviceSelected) {
                    ctrl.deviceSelected = $scope.devices[index];
                    ctrl.deviceType = $scope.devices[index].type;
                    ctrl.hasRMDTRadio = $scope.devices[index].hasRMDTRadio;
                    ctrl.protocolVersion = $scope.devices[index].protocolVersion;
                    ctrl.hasAdamsRelayModule = $scope.devices[index].hasAdamsRelayModule;
                    ctrl.hasMydroExpansion = $scope.devices[index].hasMydroExpansion;
                    ctrl.skuId = $scope.devices[index].skuId;
                    ctrl.hasEBPC = ctrl.deviceType == 17 || ctrl.deviceType == 18 || ctrl.deviceType == 19 ? $scope.devices[index].softwareVersion >= 18.2 ? $scope.devices[index].ebpcPurchased ? true : false : false : false;
                    break;
                }
            }
            //Get channel type options based on device type
            ctrl.setChannelTypeOptionsForDevice(ctrl.deviceType);
            //Check whether relay is in use for tank and well for M50 device
            if (ctrl.deviceType == 21) {
                ctrl.m50RelayOneDisableMessage = "";
                ctrl.CommandOptionsFactory.getRelayCommandsDisableMessage($scope.deviceSelected, 1).then(function (data) {
                    ctrl.m50RelayOneDisableMessage = data.data;
                });
            }
            //Modify modeList by device type
            if (ctrl.deviceType == 17) {
                ctrl.modeList = [{ id: "R", desc: "R" }, { id: "A", desc: "A" }, { id: "D", desc: "D" }];
                ctrl.modeListForInputFourToEight = [{ id: "A", desc: "A" }, { id: "D", desc: "D" }];
            } else if (ctrl.deviceType == 8 || ctrl.deviceType == 18) {
                ctrl.modeListForInputFourToEight = [{ id: "A", desc: "A" }, { id: "D", desc: "D" }, { id: "S", desc: "S" }];
            } else {
                ctrl.modeListForInputFourToEight = [{ id: "R", desc: "R" }, { id: "A", desc: "A" }, { id: "D", desc: "D" }, { id: "S", desc: "S" }];
            }
            deviceService.getDevice(newValue, $scope.accountInfo.customerId).then(function (dataFromFactory) {
                $scope.deviceImei = dataFromFactory.data.imei;
                if (dataFromFactory.data.simPriority == 1) {
                    ctrl.simPrioritySelectionSelectedOption = { id: "01", desc: "Embedded SIM" };
                } else if (dataFromFactory.data.simPriority == 2) {
                    ctrl.simPrioritySelectionSelectedOption = { id: "02", desc: "Removable SIM" };
                }
                ctrl.currentSimInUse = angular.copy(ctrl.simPrioritySelectionSelectedOption);
            });

            var includeGen2Commands = ctrl.deviceType >= 20 ? true : false;

            ctrl.CommandOptionsFactory.getDataWithGenTwo($scope.accountInfo.customerId, newValue, includeGen2Commands, ctrl.protocolVersion).then(function (dataFromFactory) {
                ctrl.loadingInProgress = false;
                ctrl.commandOptions = dataFromFactory.data.commandOptionsGenOne;
                ctrl.commandOptionsGenTwo = dataFromFactory.data.commandOptionsGenTwo;
                ctrl.commandOptionsMyDro16 = dataFromFactory.data.commandOptionsMyDro16;
                //remove certain gen 2 commands for read only users
                if ($scope.accountInfo.userRole == "User" || $scope.accountInfo.userRole == "AlarmUser") {
                    var noReadOnlyUserCommands = [300, 303, 307, 308, 309, 310];
                    var tmpCommandOptionsGenTwo = [];
                    for (var i = 0; i < ctrl.commandOptionsGenTwo.length; i++) {
                        if (noReadOnlyUserCommands.indexOf(ctrl.commandOptionsGenTwo[i].commandId) == -1) {
                            tmpCommandOptionsGenTwo.push(ctrl.commandOptionsGenTwo[i]);
                        }
                    }
                    ctrl.commandOptionsGenTwo = tmpCommandOptionsGenTwo;
                }
                //hide Modem Firmware Over-The-Air (FOTA) command(command id 310) and Modem FOTA-R (command id 300) commands unless the user is mcAdmin or SuperAdministrator
                if (!ctrl.isMcAdmin && !ctrl.isSuperAdmin && ctrl.commandOptionsGenTwo !== null) {
                    var hiddenCommands = [300, 310];
                    ctrl.commandOptionsGenTwo = ctrl.commandOptionsGenTwo.filter(function (e) {
                        return !hiddenCommands.includes(e.commandId);
                    });
                }
                ctrl.softwareVersionsLkups = dataFromFactory.data.softwareVersionsLkups;
                ctrl.moduleSoftwareVersionsLkups = dataFromFactory.data.moduleSoftwareVersionsLkups;
                ctrl.mqttPortLkups = dataFromFactory.data.mqttPortLkups;
                ctrl.filterCommandOptions();

                ////////////////////////////////////////////////////////
                ////////////////////////////////////////////////////////
                ////////////////////////////////////////////////////////
                ctrl.selectedAnalogOutput = false;
                ctrl.selectedRelayOpen = false;
                ctrl.selectedRelayClose = false;
                ctrl.customUi300 = false;
                ctrl.customUi310 = false;
                ctrl.customUi307 = false;
                ctrl.customUi311 = false;
                ctrl.customUi312 = false;
                ctrl.customUiMyDro = false;
                ctrl.customUi412413 = false;
                ////////////////////////////////////////////////////////
                ////////////////////////////////////////////////////////
                ////////////////////////////////////////////////////////

                if ($scope.accordionActive == $scope.accordionInputMode) {
                    $scope.getInputMode();
                } else {
                    $scope.selectedInputMode = false;
                }
                if ($scope.accordionActive == $scope.accordionAnalogThresholds) {
                    $scope.getAnalogThresholds();
                } else {
                    $scope.selectedAnalogThresholds = false;
                }
                ctrl.commandOperationsSelected = null;
                ctrl.commandOperationsGenTwoSelected = null;
                ctrl.commandOperationsMyDro16Selected = null;

                if (ctrl.commandOptions == null) {
                    var errormsg = ctrl.translation.message.NO_PAGING;
                    $scope.alerts.push({
                        msg: errormsg, type: "info"
                    });
                    return;
                }
                if (ctrl.commandOptions.length == 0 && (ctrl.deviceType == 10 || ctrl.deviceType == 15)) {
                    var _errormsg = ctrl.translation.message.NO_PAGING;
                    $scope.alerts.push({
                        msg: _errormsg, type: "info"
                    });
                    return;
                }
                ctrl.commandAnalogSpeedSelected = null;
                ctrl.commandFlowSpeedSelected = null;
                ctrl.commandTargetTXHour = null;
                ctrl.commandTargetTXMinute = null;
                ctrl.commandTargetTXMeridian = null;
                ctrl.commandFloatLDebounce = null;
                ctrl.commandFloatHDebounce = null;
                ctrl.commandElectricModeSelected = null;
                ctrl.commandSmpPulsesSelected = null;
                ctrl.commandNewLteRadiosSelected = null;
                $scope.commandSIMPriorityModeSelected = null;
                $scope.commandSIMPrioritySelectionSelected = null;
                ctrl.commandLargeAnalogSelected = {
                    commandId: 33
                };
                ctrl.commandPumpStateSelected = {
                    commandId: 36
                };
                $scope.commandInputModeSelected = {
                    commandId: 16
                };

                ctrl.commandLacPscAmmAfList1Selected = { id: "Y", desc: "Y" };
                ctrl.commandLacPscAmmAfList2Selected = { id: "Y", desc: "Y" };
                ctrl.commandLacPscAmmAfList3Selected = { id: "N", desc: "N" };
                ctrl.commandLacPscAmmAfList4Selected = { id: "N", desc: "N" };

                if (ctrl.commandOperationsSelected && ctrl.commandOperationsSelected.commandId == 101) ctrl.selectAnalogOutput(101);

                $scope.getTemplateSource();
                $scope.resizeModal();
            }, function (error) {
                ctrl.loadingInProgress = false;
                var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
                $scope.resizeModal();
                $scope.alerts.push({
                    msg: errormsg, type: "danger"
                });
            });
        }
    }, true);

    $scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            if (oldValue) {
                _unRegisterListener($scope.currentRegister);
            }
        }
    }, true);

    $scope.findIndex = function (channel) {
        var index = -1;
        for (var i = 0; i < ctrl.selectedElectricModes.length; i++) {
            if (ctrl.selectedElectricModes[i].channel === channel) {
                index = i;
                break;
            }
        }
        return index;
    };

    ctrl.UpdateElectricMode = function (channel, mode) {
        var i = $scope.findIndex(channel);
        if (ctrl.selectedElectricModes.length > 0 && i != -1) {
            if (typeof mode != 'undefined') {
                ctrl.selectedElectricModes[i].mode = mode;
            } else {
                ctrl.selectedElectricModes.splice(i, 1);
            }
        } else {
            ctrl.selectedElectricModes.push({ "channel": channel, "mode": mode });
        }
    };

    $scope.getInputMode = function () {
        ctrl.inputModeBusy = true;
        unitStateService.getData($scope.accountInfo.customerId, $scope.deviceSelected).then(function (dataFromFactory) {
            $scope.inputModeElement = dataFromFactory.data;
            ctrl.mode1SelectedOption = { id: $scope.inputModeElement.inputMode.substring(0, 1), desc: $scope.inputModeElement.inputMode.substring(0, 1) };
            ctrl.mode2SelectedOption = { id: $scope.inputModeElement.inputMode.substring(1, 2), desc: $scope.inputModeElement.inputMode.substring(1, 2) };
            ctrl.mode3SelectedOption = { id: $scope.inputModeElement.inputMode.substring(2, 3), desc: $scope.inputModeElement.inputMode.substring(2, 3) };
            ctrl.mode4SelectedOption = { id: $scope.inputModeElement.inputMode.substring(3, 4), desc: $scope.inputModeElement.inputMode.substring(3, 4) };
            ctrl.mode5SelectedOption = { id: $scope.inputModeElement.inputMode.substring(4, 5), desc: $scope.inputModeElement.inputMode.substring(4, 5) };
            ctrl.mode6SelectedOption = { id: $scope.inputModeElement.inputMode.substring(5, 6), desc: $scope.inputModeElement.inputMode.substring(5, 6) };
            ctrl.mode7SelectedOption = { id: $scope.inputModeElement.inputMode.substring(6, 7), desc: $scope.inputModeElement.inputMode.substring(6, 7) };
            ctrl.mode8SelectedOption = { id: $scope.inputModeElement.inputMode.substring(7, 8), desc: $scope.inputModeElement.inputMode.substring(7, 8) };

            ctrl.modeSelectedOptions.mode1SelectedOption = ctrl.mode1SelectedOption;
            ctrl.modeSelectedOptions.mode2SelectedOption = ctrl.mode2SelectedOption;
            ctrl.modeSelectedOptions.mode3SelectedOption = ctrl.mode3SelectedOption;
            ctrl.modeSelectedOptions.mode4SelectedOption = ctrl.mode4SelectedOption;
            ctrl.modeSelectedOptions.mode5SelectedOption = ctrl.mode5SelectedOption;
            ctrl.modeSelectedOptions.mode6SelectedOption = ctrl.mode6SelectedOption;
            ctrl.modeSelectedOptions.mode7SelectedOption = ctrl.mode7SelectedOption;
            ctrl.modeSelectedOptions.mode8SelectedOption = ctrl.mode8SelectedOption;

            deviceMenuService.getDeviceMenuList($scope.accountInfo.customerId).then(function (result) {
                $scope.devices = result.data.devices;
                var _deviceType = void 0;
                var tmpSelectedIndex = -1;
                for (var index = 0; index < $scope.devices.length; ++index) {
                    if ($scope.devices[index].deviceId == $scope.deviceSelected) {
                        _deviceType = $scope.devices[index].type;
                        ctrl.deviceType = _deviceType;
                        break;
                    }
                }
                switch (_deviceType) {
                    case 8:
                    case 18:
                        ctrl.debounce1SelectedOption = { id: "01", desc: "10" };ctrl.debounce2SelectedOption = { id: "01", desc: "10" };ctrl.debounce3SelectedOption = { id: "01", desc: "10" };ctrl.debounce4SelectedOption = { id: "01", desc: "10" };ctrl.debounce5SelectedOption = { id: "01", desc: "10" };ctrl.debounce6SelectedOption = { id: "01", desc: "10" };ctrl.debounce7SelectedOption = { id: "01", desc: "10" };ctrl.debounce8SelectedOption = { id: "01", desc: "10" };
                        break;
                    case 9:
                    case 19:
                    default:
                        ctrl.debounce1SelectedOption = { id: "00", desc: "0" };ctrl.debounce2SelectedOption = { id: "00", desc: "0" };ctrl.debounce3SelectedOption = { id: "00", desc: "0" };ctrl.debounce4SelectedOption = { id: "00", desc: "0" };ctrl.debounce5SelectedOption = { id: "00", desc: "0" };ctrl.debounce6SelectedOption = { id: "00", desc: "0" };ctrl.debounce7SelectedOption = { id: "00", desc: "0" };ctrl.debounce8SelectedOption = { id: "00", desc: "0" };
                }

                ctrl.inputModeBusy = false;
                $scope.selectedInputMode = true;
                $scope.resizeModal();
            }, function (error) {
                ctrl.inputModeBusy = false;
                var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
                $scope.resizeModal();
                $scope.alerts.push({
                    msg: errormsg, type: "danger"
                });
            });
        }, function (error) {
            ctrl.inputModeBusy = false;
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
            $scope.resizeModal();
            $scope.alerts.push({
                msg: errormsg, type: "danger"
            });
        });
    };

    $scope.getAnalogThresholds = function () {
        ctrl.analogThresholdsBusy = true;
        ctrl.AnalogThresholdsFactory.getData($scope.accountInfo.customerId, $scope.deviceSelected).then(function (dataFromFactory) {
            ctrl.analogThresholdsElement = dataFromFactory.data;
            ctrl.analogThresholdsBusy = false;
            $scope.selectedAnalogThresholds = true;
            $scope.resizeModal();
        }, function (error) {
            ctrl.analogThresholdsBusy = false;
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
            $scope.resizeModal();
            $scope.alerts.push({
                msg: errormsg, type: "danger"
            });
        });
    };

    ctrl.selectAnalogOutputRelayOpenOrRelayClose = function (varCommandId) {
        ctrl.selectedAnalogOutput = false;
        ctrl.selectedRelayOpen = false;
        ctrl.selectedRelayClose = false;
        ctrl.commandRelayOpenSelected = null;
        ctrl.commandRelayCloseSelected = null;
        ctrl.relayOpenOptions = [];
        ctrl.relayCloseOptions = [];
        if (varCommandId != 101 && varCommandId != 170 && varCommandId != 171) return;
        if (varCommandId == 101) {
            ctrl.selectAnalogOutput(101);
        } else if (varCommandId == 170) {
            ctrl.selectRelayOpenBusy = true;
            relaysSettingService.getData($scope.accountInfo.customerId, $scope.deviceSelected, 0).then(function (dataFromFactory) {
                ctrl.relayOpenOptions.push({
                    id: 0,
                    description: ctrl.translation.text.SELECT_CHANNEL
                });
                ctrl.commandRelayOpenSelected = {
                    id: 0,
                    description: ctrl.translation.text.SELECT_CHANNEL
                };

                var _loop = function _loop() {
                    var channel = dataFromFactory.data.availableRelays[i].channel;
                    var description = dataFromFactory.data.availableRelays[i].description + " Open";
                    var disableMessage = "";
                    ctrl.CommandOptionsFactory.getRelayCommandsDisableMessage($scope.deviceSelected, dataFromFactory.data.availableRelays[i].channel).then(function (data) {
                        disableMessage = data.data;
                        ctrl.relayOpenOptions.push({
                            id: channel,
                            description: description,
                            disableMessage: ctrl.hasEBPC && (channel == 1 || channel == 2) ? "Relay 1/2 control is disabled as it is designated for energizing backup pumps." : disableMessage
                        });
                    });
                };

                for (var i = 0; i < dataFromFactory.data.availableRelays.length; i++) {
                    _loop();
                }
                ctrl.selectRelayOpenBusy = false;
                ctrl.selectedRelayOpen = true;
                $scope.resizeModal();
            }, function (error) {
                ctrl.selectRelayOpenBusy = false;
                var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
                $scope.resizeModal();
                $scope.alerts.push({
                    msg: errormsg, type: "danger"
                });
            });
        } else if (varCommandId == 171) {
            ctrl.selectRelayCloseBusy = true;
            relaysSettingService.getData($scope.accountInfo.customerId, $scope.deviceSelected, 0).then(function (dataFromFactory) {
                ctrl.relayCloseOptions.push({
                    id: 0,
                    description: ctrl.translation.text.SELECT_CHANNEL
                });
                ctrl.commandRelayCloseSelected = {
                    id: 0,
                    description: ctrl.translation.text.SELECT_CHANNEL
                };

                var _loop2 = function _loop2() {
                    var channel = dataFromFactory.data.availableRelays[i].channel;
                    var description = dataFromFactory.data.availableRelays[i].description + " Close";
                    var disableMessage = "";
                    ctrl.CommandOptionsFactory.getRelayCommandsDisableMessage($scope.deviceSelected, dataFromFactory.data.availableRelays[i].channel).then(function (data) {
                        disableMessage = data.data;
                        ctrl.relayCloseOptions.push({
                            id: channel,
                            description: description,
                            disableMessage: ctrl.hasEBPC && (channel == 1 || channel == 2) ? ctrl.translation.text.RELAY_DISABLED_FOR_EBPC : disableMessage
                        });
                    });
                };

                for (var i = 0; i < dataFromFactory.data.availableRelays.length; i++) {
                    _loop2();
                }
                ctrl.selectRelayCloseBusy = false;
                ctrl.selectedRelayClose = true;
                $scope.resizeModal();
            }, function (error) {
                ctrl.selectRelayCloseBusy = false;
                var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
                $scope.resizeModal();
                $scope.alerts.push({
                    msg: errormsg, type: "danger"
                });
            });
        }
    };

    ctrl.selectAnalogOutput = function (varCommandId) {
        ctrl.selectedAnalogOutput = false;
        if (varCommandId != 101) return;
        ctrl.selectAnalogOutputBusy = true;
        ctrl.AnalogOutputPagingFactory.getData($scope.accountInfo.customerId, $scope.deviceSelected, $scope.deviceSelectedType, $scope.accountInfo.timeZone).then(function (dataFromFactory) {
            ctrl.selectAnalogOutputBusy = false;
            ctrl.selectedAnalogOutput = true;
            $scope.analogOutputPagingElement = dataFromFactory.data;
            ctrl.selectAnalogForChannel();
            $scope.resizeModal();
        }, function (error) {
            ctrl.selectAnalogOutputBusy = false;
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
            $scope.resizeModal();
            $scope.alerts.push({
                msg: errormsg, type: "danger"
            });
        });
    };

    ctrl.checkForCustomUi = function (varCommandId) {
        ctrl.customUi300 = false;
        ctrl.customUi310 = false;
        ctrl.customUi307 = false;
        ctrl.customUi311 = false;
        ctrl.customUi312 = false;
        ctrl.customUiBusy = true;
        ctrl.customUiMyDro = false;
        ctrl.customUi412413 = false;

        if (varCommandId === 300) {

            $scope.customUi300Data = {
                ver: null,
                file: null
            };

            ctrl.customUi300 = true;
            ctrl.genTwoCustomUiValid = true;
        } else if (varCommandId === 307) {

            $scope.customUi307Data = {
                netType: null,
                nodeAddr: null,
                chanType: null,
                chanNum: null
            };
            ctrl.customUi307 = true;
            ctrl.genTwoCustomUiValid = false;
            if (ctrl.deviceType == 21) {
                ctrl.netTypeOptionsSelected = { id: 0, netType: "RTU" };
                $scope.customUi307Data.netType = 0;
                $scope.customUi307Data.nodeAddr = 1;
            }
        } else if (varCommandId === 310) {

            $scope.customUi310Data = {
                ver: null,
                file: null
            };

            ctrl.customUi310 = true;
            ctrl.genTwoCustomUiValid = true;
        } else if (varCommandId === 311) {

            $scope.customUi311Data = {
                chanNum: null,
                mode: null
            };
            ctrl.customUi311 = true;
            ctrl.genTwoCustomUiValid = false;
        } else if (varCommandId === 312) {

            $scope.customUi312Data = {
                mqttPortID: null,
                mqttPortNum: null
            };
            ctrl.customUi312 = true;
            ctrl.genTwoCustomUiValid = false;
        } else if (varCommandId >= 330 && varCommandId <= 337 || varCommandId == 402 || varCommandId == 403 || varCommandId == 415 || varCommandId == 416 || varCommandId == 419 || varCommandId == 424 || varCommandId == 425 || varCommandId == 426) {

            if (typeof $scope.customUiMydro16Data == 'undefined') {
                $scope.customUiMydro16Data = {
                    netType: null,
                    nodeAddr: null,
                    chanType: null,
                    chanNum: null,
                    mode: null
                };
            }

            ctrl.customUiMyDro = true;
            $scope.myDro16CustomUiValid = true;
        } else if (varCommandId === 412 || varCommandId === 413) {
            $scope.customUi412413Data = {
                seconds: null
            };
            ctrl.customUi412413 = true;
            ctrl.genTwoCustomUiValid = false;
        } else {
            ctrl.genTwoCustomUiValid = true;
        }

        ctrl.customUiBusy = false;
        $scope.resizeModal(0);
    };

    ctrl.updateAnalogOutputSlider = function () {
        if (ctrl.analogOutputPagingSetting.minimumValue > ctrl.analogOutputPagingSetting.maximumValue) {
            ctrl.analogOutputPagingData.data = -ctrl.analogOutputPagingData.sliderValue;
        } else {
            ctrl.analogOutputPagingData.data = ctrl.analogOutputPagingData.sliderValue;
        }
        ctrl.analogOutputPagingData.dataValue = ctrl.analogOutputPagingData.data;
    };

    ctrl.updateAnalogOutputText = function () {
        if (ctrl.analogOutputPagingSetting.minimumValue > ctrl.analogOutputPagingSetting.maximumValue) {
            ctrl.analogOutputPagingData.sliderValue = -ctrl.analogOutputPagingData.dataValue;
        } else {
            ctrl.analogOutputPagingData.sliderValue = ctrl.analogOutputPagingData.dataValue;
        }
        ctrl.analogOutputPagingData.data = ctrl.analogOutputPagingData.dataValue;
    };

    ctrl.selectAnalogForChannel = function (varChannelId) {
        var _step1 = void 0,
            _step2 = void 0;
        ctrl.analogOutChannel = typeof varChannelId !== 'undefined' ? varChannelId : 1;
        ctrl.analogOutputPagingSetting.channel1Name = $scope.analogOutputPagingElement.setting[0].channelName;
        ctrl.analogOutputPagingSetting.channel2Name = $scope.analogOutputPagingElement.setting[1].channelName;
        //Getting channel names for channel 3 and 4 for device with device type 19
        ctrl.hasMyDroAOExpansion = $scope.analogOutputPagingElement.setting.length > 2 && ctrl.hasMydroExpansion;
        if ($scope.deviceSelectedType == 19 && $scope.analogOutputPagingElement.setting.length > 2) {
            ctrl.analogOutputPagingSetting.channel3Name = $scope.analogOutputPagingElement.setting[2].channelName;
            ctrl.analogOutputPagingSetting.channel4Name = $scope.analogOutputPagingElement.setting[3].channelName;
        }
        ctrl.analogOutputPagingSetting.minimumValue = $scope.analogOutputPagingElement.setting[ctrl.analogOutChannel - 1].minimumValue;
        ctrl.analogOutputPagingSetting.maximumValue = $scope.analogOutputPagingElement.setting[ctrl.analogOutChannel - 1].maximumValue;
        _step1 = _getDecimal(ctrl.analogOutputPagingSetting.maximumValue - ctrl.analogOutputPagingSetting.minimumValue);
        ctrl.analogOutputPagingSetting.unit = $scope.analogOutputPagingElement.setting[ctrl.analogOutChannel - 1].unit;
        ctrl.analogOutputPagingData.dataValue = $scope.analogOutputPagingElement.data[ctrl.analogOutChannel - 1].data.toFixed(_step1);
        ctrl.analogOutputPagingData.data = $scope.analogOutputPagingElement.data[ctrl.analogOutChannel - 1].data.toFixed(_step1);

        switch (varChannelId) {
            case 1:
                if (ctrl.analogValueChannel1 != null) ctrl.analogOutputPagingData.dataValue = ctrl.analogValueChannel1;
                break;
            case 2:
                if (ctrl.analogValueChannel2 != null) ctrl.analogOutputPagingData.dataValue = ctrl.analogValueChannel2;
                break;
            case 3:
                if (ctrl.analogValueChannel3 != null) ctrl.analogOutputPagingData.dataValue = ctrl.analogValueChannel3;
                break;
            case 4:
                if (ctrl.analogValueChannel4 != null) ctrl.analogOutputPagingData.dataValue = ctrl.analogValueChannel4;
                break;
        }

        var numSteps = 255;
        if (ctrl.analogOutputPagingSetting.minimumValue > ctrl.analogOutputPagingSetting.maximumValue) {
            var outOfWhileA = false;
            ctrl.step = ((ctrl.analogOutputPagingSetting.minimumValue - ctrl.analogOutputPagingSetting.maximumValue) / 255).toFixed(_step1);
            //re-calculate step value when maximum cannot be evenly divided by the step value            
            while (outOfWhileA == false && !((ctrl.analogOutputPagingSetting.minimumValue - ctrl.analogOutputPagingSetting.maximumValue) / ctrl.step === Math.floor((ctrl.analogOutputPagingSetting.minimumValue - ctrl.analogOutputPagingSetting.maximumValue) / ctrl.step))) {
                if (numSteps > 150) {
                    numSteps = numSteps - 1;
                    ctrl.step = ((ctrl.analogOutputPagingSetting.minimumValue - ctrl.analogOutputPagingSetting.maximumValue) / numSteps).toFixed(_step1);
                } else {
                    outOfWhileA = true;
                    switch (_step1) {
                        case 0:
                            ctrl.step = 1;
                            break;
                        case 1:
                            ctrl.step = 0.1;
                            break;
                        case 2:
                            ctrl.step = 0.01;
                            break;
                    }
                }
            }
        } else {
            var outOfWhileB = false;
            ctrl.step = ((ctrl.analogOutputPagingSetting.maximumValue - ctrl.analogOutputPagingSetting.minimumValue) / 255).toFixed(_step1);
            //re-calculate step value when maximum cannot be evenly divided by the step value            
            while (outOfWhileB == false && !((ctrl.analogOutputPagingSetting.maximumValue - ctrl.analogOutputPagingSetting.minimumValue) / ctrl.step === Math.floor((ctrl.analogOutputPagingSetting.maximumValue - ctrl.analogOutputPagingSetting.minimumValue) / ctrl.step))) {
                if (numSteps > 150) {
                    numSteps = numSteps - 1;
                    ctrl.step = ((ctrl.analogOutputPagingSetting.maximumValue - ctrl.analogOutputPagingSetting.minimumValue) / numSteps).toFixed(_step1);
                } else {
                    outOfWhileB = true;
                    switch (_step1) {
                        case 0:
                            ctrl.step = 1;
                            break;
                        case 1:
                            ctrl.step = 0.1;
                            break;
                        case 2:
                            ctrl.step = 0.01;
                            break;
                    }
                }
            }
        }

        //use customized step value for UI slider if the difference between max value and min value are too small
        if (Math.abs(ctrl.analogOutputPagingSetting.maximumValue - ctrl.analogOutputPagingSetting.minimumValue) < 1.275 && Math.abs(ctrl.analogOutputPagingSetting.maximumValue - ctrl.analogOutputPagingSetting.minimumValue) != 0) {
            ctrl.step = 0.01;
        }

        if (ctrl.analogOutputPagingSetting.minimumValue > ctrl.analogOutputPagingSetting.maximumValue) {
            ctrl.minPage = -ctrl.analogOutputPagingSetting.minimumValue;
            ctrl.maxPage = -ctrl.analogOutputPagingSetting.maximumValue;
            ctrl.analogOutputPagingData.sliderValue = -$scope.analogOutputPagingElement.data[ctrl.analogOutChannel - 1].data.toFixed(_step1);
        } else {
            ctrl.minPage = ctrl.analogOutputPagingSetting.minimumValue;
            ctrl.maxPage = ctrl.analogOutputPagingSetting.maximumValue;
            ctrl.analogOutputPagingData.sliderValue = $scope.analogOutputPagingElement.data[ctrl.analogOutChannel - 1].data.toFixed(_step1);
        }
    };

    ctrl.changeDebounce = function (id, obj) {
        $scope["debounce" + id + "SelectedOption"] = angular.copy(obj);
    };

    ctrl.changeInputMode = function (id, obj) {
        switch (obj.id) {
            case "S":
            case "A":
                ctrl.modeSelectedOptions["mode" + id + "SelectedOption"] = { id: "A", desc: "A" };
                break;
            case "D":
                ctrl.modeSelectedOptions["mode" + id + "SelectedOption"] = { id: "D", desc: "D" };
                break;
            case "R":
                ctrl.modeSelectedOptions["mode" + id + "SelectedOption"] = { id: "R", desc: "R" };
                break;
        }
    };

    ctrl.checkModbusAddress = function () {
        if (ctrl.modbusAddress < 0 || ctrl.modbusAddress > 247 || typeof ctrl.modbusAddress == 'undefined') {
            ctrl.notValidModbusAddress = true;
        } else {
            ctrl.notValidModbusAddress = false;
        }
    };

    ctrl.changeLacPscAmmAfList = function (id, obj) {
        $scope["commandLacPscAmmAfList" + id + "Selected"] = angular.copy(obj);
    };

    ctrl.changeSIMMode = function (obj) {
        ctrl.simModeSelectedOption = angular.copy(obj);
    };

    ctrl.changeSIMPrioritySelection = function (obj) {
        ctrl.simPrioritySelectionSelectedOption = angular.copy(obj);
    };

    ctrl.pageOperations = function (varCommand) {
        $scope.alerts = [];
        if (varCommand.commandId == 101) {
            var _validate = ctrl.isValidNumber(ctrl.analogOutputPagingData.data, ctrl.analogOutputPagingSetting.maximumValue, ctrl.analogOutputPagingSetting.minimumValue);
            if (!_validate) return;
        }
        ctrl.loadingInProgress = true;
        ctrl.pageOperationsInProgress = true;
        ctrl.commandDateTimeCompleted = ctrl.spinner;
        ctrl.commandDateTimeCompletedInfo = "0001-01-01T00:00:00";
        var _tmpCommandDescription = varCommand.commandDescription;
        var _tmpCommandDetails = ctrl.getCommandDetails(varCommand.commandId);

        $scope.tmpPageRequest = varCommand.commandId >= 300 ? {
            deviceId: $scope.deviceSelected,
            commandId: varCommand.commandId,
            commandDescription: _tmpCommandDescription,
            commandDetails: _tmpCommandDetails,
            imei: $scope.deviceImei
        } : {
            deviceId: $scope.deviceSelected,
            commandDescription: _tmpCommandDescription,
            commandDetails: _tmpCommandDetails,
            electricModes: ctrl.selectedElectricModes
        };

        pageRequestsService.postData($scope.accountInfo.customerId, varCommand.commandId, ctrl.deviceType, ctrl.protocolVersion, $scope.accountInfo.timeZone, $scope.tmpPageRequest).then(function (result) {
            //if (result.data.item1.length == 0) {
            //    $scope.commandRequestCounter = $scope.numberOfCalls;
            //    $scope.commandDateTimeCompleted = $scope.errorCheck;
            //    $scope.progressBarClass = "error";
            //    $scope.updateStatus = "<strong>" + $scope.translation.text.GENERAL_SERVER_ERROR + " @ " + "</strong>";
            //    return;
            //}
            var date = new Date();
            var currentTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().substring(0, 19);
            if (result.data.item1 !== null && result.data.item1.length !== 0) {
                $scope.commandSent = result.data.item1[0].commandId === varCommand.commandId ? result.data.item1[0] : result.data.item1[1].commandId === varCommand.commandId ? result.data.item1[1] : result.data.item1[2];
                $scope.commandSentOriginal = $scope.commandSent;
                ctrl.updateStatusTime = $scope.commandSent.localDateTimeEntered;
            } else {
                ctrl.updateStatusTime = currentTime;
            }
            ctrl.commandInProcess = _tmpCommandDescription; //$scope.commandSent.commandDescription;
            $rootScope.$broadcast('commandPaging', {
                deviceId: $scope.deviceSelected, deviceName: $scope.deviceSelectedName, deviceSn: $scope.deviceSelectedSn, data: result.data.item1
            });
            ctrl.updateStatus = "<strong>" + moment(ctrl.updateStatusTime).format('hh:mm:ss A') + "</strong>";

            //var _timeStamp = moment($scope.updateStatusTime).add(($scope.progressBarStart + 1 - $scope.progressBarStart) * $scope.fnRtuRequestInterval / 1000, 's').format('hh:mm:ss A');            
            if (result.data.item2 == 1) {
                ctrl.commandDateTimeCompletedInfo = "Completed";
                ctrl.commandDateTimeCompleted = ctrl.okCheck;
                $scope.commandRequestCounterRTU = $scope.numberOfCallsRTU;
                ctrl.updateStatus = "<strong>" + ctrl.translation.text.PAGE_WAS_SENT_TO_DEVICE + " " + $scope.deviceImei + "</strong>";
            } else if (result.data.item2 == 2) {
                ctrl.commandDateTimeCompletedInfo = "Completed";
                ctrl.commandDateTimeCompleted = ctrl.okCheck;
                ctrl.progressBarClass = "warning";
                $scope.commandRequestCounterRTU = $scope.numberOfCallsRTU;
                ctrl.updateStatus = "<strong>" + ctrl.translation.text.PAGE_IS_DEFERRED_UNTIL_DEVICE_IS_ONLINE + " " + $scope.deviceImei + " " + ctrl.translation.text.UNTIL_ONLINE + "</strong>";
            } else if (result.data.item2 === 3) {
                ctrl.commandDateTimeCompletedInfo = "Completed";
                ctrl.commandDateTimeCompleted = ctrl.okCheck;
                ctrl.progressBarClass = "error";
                $scope.commandRequestCounterRTU = $scope.numberOfCallsRTU;
                ctrl.updateStatus = "<strong>" + result.data.item3 + "</strong>";
            }

            if (varCommand.commandId == 101) {
                switch (ctrl.analogOutChannel) {
                    case 1:
                        ctrl.analogValueChannel1 = ctrl.analogOutputPagingData.data;
                        break;
                    case 2:
                        ctrl.analogValueChannel2 = ctrl.analogOutputPagingData.data;
                        break;
                    case 3:
                        ctrl.analogValueChannel3 = ctrl.analogOutputPagingData.data;
                        break;
                    case 4:
                        ctrl.analogValueChannel4 = ctrl.analogOutputPagingData.data;
                        break;
                }

                ctrl.analogOutputPagingData.dataValue = ctrl.analogOutputPagingData.data;
            }

            //Manually enter/exit service mode 
            if (varCommand.commandId == 166 || varCommand.commandId == 167) {
                if (result.data.item2 == 1 || result.data.item2 == 2) {
                    var tmpDeviceNotificationSetting = { "op": "replace", "path": "serviceModeEnd", "value": varCommand.commandId == 166 ? true : false };
                    deviceNotificationSettingService.patchDeviceNotificationSetting($scope.accountInfo.customerId, $scope.deviceSelected, $scope.deviceSelectedName, tmpDeviceNotificationSetting).then(function (results) {
                        $rootScope.$broadcast('pagingServiceMode', {
                            deviceId: $scope.deviceSelected, data: results.data
                        });
                    }, function (error) {});
                }
            }
            //switch (varCommand.commandId) {
            //    case 86:
            //        $scope.responseCheck = "R";
            //        $scope.currentRegister = {
            //            deviceSn: $scope.deviceSelectedSn, messageType: "TEMPERATURE", channel: ''
            //        };
            //        _registerListener($scope.currentRegister);
            //        break;
            //    case 87:
            //        $scope.responseCheck = "R";
            //        $scope.currentRegister = {
            //            deviceSn: $scope.deviceSelectedSn, messageType: "INPUTS", channel: ''
            //        };
            //        _registerListener($scope.currentRegister);
            //        break;
            //    case 88:
            //        $scope.responseCheck = "R";
            //        $scope.currentRegister = {
            //            deviceSn: $scope.deviceSelectedSn, messageType: "ANALOG", channel: 1
            //        };
            //        _registerListener($scope.currentRegister);
            //        break;
            //    case 91: case 92: case 93: case 94: case 95: case 96: case 97:
            //        $scope.responseCheck = "R";
            //        $scope.currentRegister = {
            //            deviceSn: $scope.deviceSelectedSn, messageType: "RELAYS", channel: ''
            //        };
            //        _registerListener($scope.currentRegister);
            //        break;
            //    case 101:
            //        $scope.responseCheck = "R";
            //        $scope.currentRegister = {
            //            deviceSn: $scope.deviceSelectedSn, messageType: "ANALOGOUT", channel: $scope.analogOutChannel
            //        };
            //        _registerListener($scope.currentRegister);
            //        break;
            //    default:
            //        $scope.responseCheck = "T";
            //        $scope.currentRegister = {
            //            deviceSn: null, messageType: '', channel: ''
            //        }
            //        $scope.commandRequestCounter = $scope.progressBarStart;
            //        $scope.fnCommandRequest = $timeout(function () { $scope.getCommandStatus(result.data.item2, $scope.progressBarStart + 1, varCommand.commandId); }, $scope.commandRequestInterval);
            //        break;
            //}
        }, function (error) {
            ctrl.loadingInProgress = false;
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;

            $scope.alerts.push({
                msg: errormsg, type: "danger"
            });
        });
    };

    ctrl.getCommandDetails = function (varCommandId) {
        switch (varCommandId) {
            case 16:
                return {
                    channel: null, value: null, valueDetail: ctrl.modeSelectedOptions.mode1SelectedOption.id + ctrl.modeSelectedOptions.mode2SelectedOption.id + ctrl.modeSelectedOptions.mode3SelectedOption.id + ctrl.modeSelectedOptions.mode4SelectedOption.id + ctrl.modeSelectedOptions.mode5SelectedOption.id + ctrl.modeSelectedOptions.mode6SelectedOption.id + ctrl.modeSelectedOptions.mode7SelectedOption.id + ctrl.modeSelectedOptions.mode8SelectedOption.id
                };
            case 17:
                return {
                    channel: null, value: null, valueDetail: ctrl.debounce1SelectedOption.id + ctrl.debounce2SelectedOption.id + ctrl.debounce3SelectedOption.id + ctrl.debounce4SelectedOption.id + ctrl.debounce5SelectedOption.id + ctrl.debounce6SelectedOption.id + ctrl.debounce7SelectedOption.id + ctrl.debounce8SelectedOption.id
                };
            case 35:
                return {
                    channel: null, value: null, valueDetail: ctrl.commandLacPscAmmAfList1Selected.id + ctrl.commandLacPscAmmAfList2Selected.id + ctrl.commandLacPscAmmAfList3Selected.id + ctrl.commandLacPscAmmAfList4Selected.id
                };
            case 101:
                $scope.rawValue = Math.round(255 * (ctrl.analogOutputPagingData.data - ctrl.analogOutputPagingSetting.minimumValue) / (ctrl.analogOutputPagingSetting.maximumValue - ctrl.analogOutputPagingSetting.minimumValue));
                return {
                    channel: ctrl.analogOutChannel, value: ctrl.analogOutputPagingData.data, valueDetail: null
                };
            case 103:
                return {
                    channel: 1, value: null, valueDetail: null, analogThresholds: {
                        lowFault: ctrl.analogThresholdsElement[0].lowFault, lowRestore: ctrl.analogThresholdsElement[0].lowRestore, highRestore: ctrl.analogThresholdsElement[0].highRestore, highFault: ctrl.analogThresholdsElement[0].highFault
                    }
                };
            case 104:
                return {
                    channel: 2, value: null, valueDetail: null, analogThresholds: {
                        lowFault: ctrl.analogThresholdsElement[1].lowFault, lowRestore: ctrl.analogThresholdsElement[1].lowRestore, highRestore: ctrl.analogThresholdsElement[1].highRestore, highFault: ctrl.analogThresholdsElement[1].highFault
                    }
                };
            case 125:
                return {
                    targetTXHour: ctrl.commandTargetTXHour.commandDescription,
                    targetTXMinute: ctrl.commandTargetTXMinute.commandDescription,
                    targetTXMeridian: ctrl.commandTargetTXMeridian.commandDescription
                };
            case 126:
                return {
                    floatLDebounce: ctrl.commandFloatLDebounce,
                    floatHDebounce: ctrl.commandFloatHDebounce
                };
            case 147:
                return {
                    valueDetail: ctrl.modbusAddress
                };
            case 148:
                return {
                    valueDetail: ctrl.modbusAddress
                };
            case 149:
                return {
                    valueDetail: ctrl.modbusAddress
                };
            case 150:
                return {
                    valueDetail: ctrl.modbusAddress
                };
            case 151:
                return {
                    valueDetail: ctrl.modbusAddress
                };
            case 155:
                return {
                    valueDetail: ctrl.modbusAddress
                };
            case 156:
                return {
                    valueDetail: ctrl.modbusAddress
                };
            case 161:
                return {
                    simPriorityMode: ctrl.simModeSelectedOption === null || angular.isUndefined(ctrl.simModeSelectedOption) ? "" : ctrl.simModeSelectedOption.id,
                    simPrioritySelection: ctrl.simPrioritySelectionSelectedOption === null || angular.isUndefined(ctrl.simPrioritySelectionSelectedOption) ? "" : ctrl.simPrioritySelectionSelectedOption.id
                };
            case 163:
                return {
                    valueDetail: ctrl.simPrioritySelectionSelectedOption.id
                };
            case 170:
                return {
                    channel: ctrl.commandRelayOpenSelected.id, value: 0, valueDetail: null
                };
            case 171:
                return {
                    channel: ctrl.commandRelayCloseSelected.id, value: 1, valueDetail: null
                };
            case 300:
                return {
                    ver: $scope.customUi300Data.ver,
                    file: $scope.customUi300Data.file
                };
            case 310:
                return {
                    ver: $scope.customUi310Data.ver,
                    file: $scope.customUi310Data.file
                };
            case 307:
                return {
                    netType: $scope.customUi307Data.netType,
                    nodeAddr: $scope.customUi307Data.nodeAddr,
                    chanType: $scope.customUi307Data.chanType,
                    chanNum: $scope.customUi307Data.chanNum
                };
            case 311:
                return {
                    chanNum: $scope.customUi311Data.chanNum,
                    mode: $scope.customUi311Data.mode
                };
            case 312:
                return {
                    mqttPortID: $scope.customUi312Data.mqttPortID,
                    mqttPortNum: $scope.customUi312Data.mqttPortNum
                };
            case 330:
            case 424:
                return {
                    netType: $scope.customUiMydro16Data.netType
                };
            case 331:
            case 425:
                return {
                    netType: $scope.customUiMydro16Data.netType,
                    nodeAddr: $scope.customUiMydro16Data.nodeAddr
                };
            case 332:
            case 402:
                return {
                    chanType: $scope.customUiMydro16Data.chanType,
                    chanNum: $scope.customUiMydro16Data.chanNum
                };
            case 333:
            case 426:
                return {
                    chanNum: $scope.customUiMydro16Data.chanNum
                };
            case 334:
                return {
                    chanNum: $scope.customUiMydro16Data.chanNum,
                    mode: $scope.customUiMydro16Data.mode
                };
            case 335:
                return {
                    netType: $scope.customUiMydro16Data.netType,
                    nodeAddr: $scope.customUiMydro16Data.nodeAddr,
                    chanType: $scope.customUiMydro16Data.chanType,
                    chanNum: $scope.customUiMydro16Data.chanNum
                };
            case 336:
            case 415:
            case 416:
            case 419:
                return {
                    mode: $scope.customUiMydro16Data.mode
                };
            case 337:
            case 403:
                return {
                    chanNum: $scope.customUiMydro16Data.chanNum
                };
            case 412:
            case 413:
                return {
                    seconds: $scope.customUi412413Data.seconds
                };
            default:
                return {
                    channel: null, value: null, valueDetail: null
                };
        }
    };

    var _formatString = function _formatString(n) {
        return n > 9 ? "" + n : "0" + n;
    };

    var _getDecimal = function _getDecimal(tmpValue) {
        if (tmpValue < 25) {
            return 2;
        } else if (tmpValue < 255) {
            return 1;
        } else {
            return 0;
        }
    };

    ctrl.isValidNumber = function (varVal, varMax, varMin) {
        var isValid = varMax > varMin ? varVal <= varMax && varVal >= varMin ? true : false : varVal >= varMax && varVal <= varMin ? true : false;
        //var isValid = (varVal <= varMax && varVal >= varMin) ? true : false;
        if (!isValid) {
            ctrl.loadingInProgress = false;
            var errormsg = ctrl.translation.message.INVALID_INPUT;
            errormsg = errormsg + ". " + ctrl.translation.message.VALUE_BETWEEN + " " + varMin + " - " + varMax;
            $scope.alerts.push({
                msg: errormsg, type: "danger"
            });
            return false;
        } else {
            return true;
        }
    };

    ctrl.getCommandStatus = function (varId, intCounter, varCommandId) {
        var _timeStamp = moment(ctrl.updateStatusTime).add((intCounter - $scope.progressBarStart) * $scope.commandRequestInterval / 1000, 's').format('hh:mm:ss A');
        $scope.commandRequestCounter = intCounter;
        pageRequestsService.getRecordById($scope.accountInfo.timeZone, varId, varCommandId).then(function (dataFromFactory) {
            $scope.commandSent = dataFromFactory.data;
            ctrl.updateStatus = "<strong>" + _timeStamp + "</strong>";
            if ($scope.commandSent === null) {
                $rootScope.$broadcast('doneTransmitting', {
                    deviceId: $scope.deviceSelected, deviceName: $scope.deviceSelectedName, deviceSn: $scope.deviceSelectedSn
                });

                ctrl.commandDateTimeCompleted = ctrl.okCheck;

                ctrl.commandDateTimeCompletedInfo = $scope.commandSentOriginal.localDateTimeEntered;
                $scope.commandSent = {
                    localDateTimeCompleted: $scope.commandSentOriginal.localDateTimeEntered,
                    localDateTimeEntered: $scope.commandSentOriginal.localDateTimeEntered
                };

                $scope.commandRequestCounter = $scope.numberOfCalls;
                ctrl.updateStatus = "<strong>" + ctrl.translation.text.COMPLETED + " @ " + _timeStamp + "</strong>";
            } else if (intCounter < $scope.numberOfCalls) {
                $scope.fnCommandRequest = $timeout(function () {
                    ctrl.getCommandStatus($scope.commandSentOriginal.pageRequestId, ++intCounter, varCommandId);
                }, $scope.commandRequestInterval);
            } else {
                ctrl.commandDateTimeCompleted = ctrl.warningCheck;
                ctrl.progressBarClass = "warning";
                ctrl.updateStatus = "<strong>" + ctrl.translation.text.ERROR_DEVICE_DID_NOT_RESPOND + " @ " + _timeStamp + "</strong>";
            }
            $scope.resizeModal();
        }, function (error) {
            ctrl.loadingInProgress = false;
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
            $scope.resizeModal();
            $scope.alerts.push({
                msg: errormsg, type: "danger"
            });
        });
    };

    ctrl.clearCommandSent = function () {
        _unRegisterListener($scope.currentRegister);
        ctrl.pageOperationsInProgress = false;
        $scope.commandSent = null;
        ctrl.updateStatus = null;
        ctrl.updateStatusTime = null;
        $scope.commandRequestCounter = 0;
        $scope.commandRequestCounterRTU = 0;
        ctrl.progressBarClass = null;
        ctrl.commandInProcess = null;
        $timeout.cancel($scope.fnCommandRequest);
        $timeout.cancel($scope.fnRtuRequest);
    };

    ctrl.getRtuResponseClock = function (intCounter) {
        var _timeStamp = moment(ctrl.updateStatusTime).add((intCounter - $scope.progressBarStart) * $scope.fnRtuRequestInterval / 1000, 's').format('hh:mm:ss A');
        if ($scope.commandRequestCounterRTU < $scope.numberOfCallsRTU) {
            $scope.commandRequestCounterRTU = intCounter;
            ctrl.updateStatus = "<strong>" + _timeStamp + "</strong>";
            $scope.fnRtuRequest = $timeout(function () {
                ctrl.getRtuResponseClock(++intCounter);
            }, $scope.fnRtuRequestInterval);
        } else if (ctrl.commandDateTimeCompleted != ctrl.okCheck) {
            $rootScope.$broadcast('doneTransmitting', {
                deviceId: $scope.deviceSelected, deviceName: $scope.deviceSelectedName, deviceSn: $scope.deviceSelectedSn
            });
            ctrl.commandDateTimeCompleted = ctrl.warningCheck;
            ctrl.progressBarClass = "warning";
            ctrl.updateStatus = "<strong>" + ctrl.translation.text.ERROR_DEVICE_DID_NOT_RESPOND + " @ " + _timeStamp + "</strong>";
        }
    };

    ctrl.getElectricModes = function (inputNumber) {
        var excludeOp400 = (ctrl.deviceType === 17 || ctrl.deviceType === 18) && inputNumber >= 4 && inputNumber <= 8;

        if (excludeOp400) {
            return ctrl.electricModes.filter(function (mode) {
                return mode.id !== 2; // OP400 Sensor
            });
        }

        return ctrl.electricModes;
    };

    var wsDataReceivedPaging = function wsDataReceivedPaging(data) {
        var varTime = datetimeService.socketStrToServerStrTime(data.Time);
        var varTimePassed = Math.abs(new Date(varTime) - new Date($scope.commandSent.localDateTimeEntered));
        switch ($scope.commandSent.commandId) {
            case 91:case 93:case 95:
                if ($scope.commandSent.commandId == 91 && data.Value.substring(0, 1) != "O") return;
                if ($scope.commandSent.commandId == 93 && data.Value.substring(1, 2) != "O") return;
                if ($scope.commandSent.commandId == 95 && data.Value.substring(2, 3) != "O") return;
                break;
            case 92:case 94:case 96:
                if ($scope.commandSent.commandId == 92 && data.Value.substring(0, 1) != "C") return;
                if ($scope.commandSent.commandId == 94 && data.Value.substring(1, 2) != "C") return;
                if ($scope.commandSent.commandId == 96 && data.Value.substring(2, 3) != "C") return;
                break;
            case 101:
                if ($scope.rawValue != data.Value) return;
                break;
        }
        if (varTimePassed >= $scope.rtuMinimumResponseTime) {
            $scope.commandRequestCounterRTU = $scope.numberOfCallsRTU;
            $timeout.cancel($scope.fnRtuRequest);
            _unRegisterListener($scope.currentRegister);
            $rootScope.$broadcast('doneResponding', {
                deviceId: $scope.deviceSelected, deviceName: $scope.deviceSelectedName, deviceSn: $scope.deviceSelectedSn
            });
            ctrl.commandDateTimeCompleted = ctrl.okCheck;
            ctrl.commandDateTimeCompletedInfo = varTime;
            ctrl.updateStatus = "<strong>" + ctrl.translation.text.COMPLETED + " @ " + moment(varTime).format('hh:mm:ss A') + "</strong>";
        }
    };

    var _registerListener = function _registerListener(varRegister) {
        //$scope.currentRegister = { deviceSn: $scope.deviceSelectedSn, messageType: "ANALOG", channel: 1 };
        if (varRegister.deviceSn == null) return;
        websocketService.connect();
        $scope.commandRequestCounterRTU = $scope.progressBarStart;
        $scope.fnRtuRequest = $timeout(function () {
            ctrl.getRtuResponseClock($scope.progressBarStart + 1);
        }, $scope.fnRtuRequestInterval);
        websocketService.register(varRegister.messageType, varRegister.deviceSn, varRegister.channel, wsDataReceivedPaging);
    };

    var _unRegisterListener = function _unRegisterListener(varRegister) {
        if (varRegister.deviceSn == null) return;
        websocketService.unRegister(varRegister.messageType, varRegister.deviceSn, varRegister.channel, wsDataReceivedPaging);
    };

    $scope.$on("$destroy", function () {
        _unRegisterListener($scope.currentRegister);
    });

    $scope.getTemplateSource = function () {
        if (ctrl.deviceType == 10 || ctrl.deviceType == 15 || ctrl.deviceType == 20 || ctrl.deviceType == 21) {
            $scope.pagingOperationTemplate = "ui/paging/paging-operations-manhole.html";
        } else {
            $scope.pagingOperationTemplate = "ui/paging/paging-operations.html";
        }
    };
};

pagingComponentController.$inject = ["$rootScope", "$scope", "sharedSetupService", "authenticationService", "translationService", "datetimeService", "pageRequestsService", "CommandOptionsFactory", "openViewService", "AnalogOutputPagingFactory", "websocketService", "$timeout", "unitStateService", "deviceMenuService", "AnalogThresholdsFactory", "deviceService", "deviceNotificationSettingService", "relaysSettingService"];

mcapp.factory('commandOptionsService', ['$http', 'HOST', function ($http, HOST) {
    var commandOptionsFactory = {};

    var _getData = function _getData(customerId, deviceId, timeZone) {
        return $http({
            method: 'Get',
            url: HOST + '/api/CommandOptions?customerId=' + customerId + '&deviceId=' + deviceId + "&" + new Date().getTime(),
            cache: false
        });
    };

    var _getDataWithGenTwo = function _getDataWithGenTwo(customerId, deviceId, includeGen2, protocolVersion) {
        return $http({
            method: 'Get',
            url: HOST + '/api/CommandOptions?customerId=' + customerId + '&deviceId=' + deviceId + '&includeGen2=' + includeGen2 + '&protocolVersion=' + protocolVersion + "&" + new Date().getTime(),
            cache: false
        });
    };

    var _getMQTTBrokerPorts = function _getMQTTBrokerPorts() {
        return $http({
            method: 'Get',
            url: HOST + '/api/CommandOptions/' + "&" + new Date().getTime(),
            cache: false
        });
    };

    commandOptionsFactory.getData = _getData;
    commandOptionsFactory.getDataWithGenTwo = _getDataWithGenTwo;
    commandOptionsFactory.getMQTTBrokerPorts = _getMQTTBrokerPorts;
    return commandOptionsFactory;
}]);

mcapp.factory('analogOutputPagingService', ['$http', 'HOST', function ($http, HOST) {
    var analogOutputPagingFactory = {};

    var _getData = function _getData(customerId, deviceId, deviceType, timeZone) {
        return $http({
            method: 'Get',
            url: HOST + '/api/AnalogOutputPaging?customerId=' + customerId + '&deviceId=' + deviceId + '&deviceType=' + deviceType + '&timeZone=' + timeZone + "&" + new Date().getTime(),
            cache: false
        });
    };

    analogOutputPagingFactory.getData = _getData;
    return analogOutputPagingFactory;
}]);

mcapp.factory('unitStateService', ['$http', 'HOST', function ($http, HOST) {
    var unitStateFactory = {};

    var _getData = function _getData(customerId, deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/UnitState?customerId=' + customerId + '&deviceId=' + deviceId + "&" + new Date().getTime(),
            cache: false
        });
    };

    unitStateFactory.getData = _getData;
    return unitStateFactory;
}]);

mcapp.factory('analogThresholdsService', ['$http', 'HOST', function ($http, HOST) {
    var analogThresholdsFactory = {};

    var _getData = function _getData(customerId, deviceId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/AnalogThresholds?customerId=' + customerId + '&deviceId=' + deviceId + "&" + new Date().getTime(),
            cache: false
        });
    };

    analogThresholdsFactory.getData = _getData;
    return analogThresholdsFactory;
}]);
'use strict';

angular.module('mc.paging').component('pagingComponent', {
    controller: pagingComponentController,
    templateUrl: 'ui/paging/paging-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommandOptionsFactory = function CommandOptionsFactory(HOST, $http) {
    var CommandOptions = function () {
        function CommandOptions() {
            _classCallCheck(this, CommandOptions);
        }

        _createClass(CommandOptions, [{
            key: 'getData',
            value: function getData(customerId, deviceId, timeZone) {
                var self = this;
                return $http.get(HOST + '/api/CommandOptions?customerId=' + customerId + '&deviceId=' + deviceId + "&" + new Date().getTime()).then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                    return response;
                });
            }
        }, {
            key: 'getDataWithGenTwo',
            value: function getDataWithGenTwo(customerId, deviceId, includeGen2, protocolVersion) {
                var self = this;
                return $http.get(HOST + '/api/CommandOptions?customerId=' + customerId + '&deviceId=' + deviceId + '&includeGen2=' + includeGen2 + '&protocolVersion=' + protocolVersion + "&" + new Date().getTime()).then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                    return response;
                });
            }
        }, {
            key: 'getMQTTBrokerPorts',
            value: function getMQTTBrokerPorts() {
                var self = this;
                return $http.get(HOST + '/api/CommandOptions/' + "&" + new Date().getTime()).then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                    return response;
                });
            }
        }, {
            key: 'getRelayCommandsDisableMessage',
            value: function getRelayCommandsDisableMessage(deviceId, channel) {
                var self = this;
                return $http.get(HOST + '/api/CommandOptions/GetRelayCommandDisableMessage?deviceId=' + deviceId + '&channel=' + channel).then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                    return response;
                });
            }
        }]);

        return CommandOptions;
    }();

    return CommandOptions;
};

CommandOptionsFactory.$inject = ['HOST', '$http'];

angular.module('mc.paging').factory('CommandOptionsFactory', CommandOptionsFactory);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnalogThresholdsFactory = function AnalogThresholdsFactory(HOST, $http) {
    var AnalogThresholds = function () {
        function AnalogThresholds() {
            _classCallCheck(this, AnalogThresholds);
        }

        _createClass(AnalogThresholds, [{
            key: 'getData',
            value: function getData(customerId, deviceId) {
                var self = this;
                return $http.get(HOST + '/api/AnalogThresholds?customerId=' + customerId + '&deviceId=' + deviceId + "&" + new Date().getTime()).then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                    return response;
                });
            }
        }]);

        return AnalogThresholds;
    }();

    return AnalogThresholds;
};

AnalogThresholdsFactory.$inject = ['HOST', '$http'];

angular.module('mc.paging').factory('AnalogThresholdsFactory', AnalogThresholdsFactory);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnalogOutputPagingFactory = function AnalogOutputPagingFactory(HOST, $http) {
    var AnalogOutputPaging = function () {
        function AnalogOutputPaging() {
            _classCallCheck(this, AnalogOutputPaging);
        }

        _createClass(AnalogOutputPaging, [{
            key: 'getData',
            value: function getData(customerId, deviceId, deviceType, timeZone) {
                var self = this;
                return $http.get(HOST + '/api/AnalogOutputPaging?customerId=' + customerId + '&deviceId=' + deviceId + '&deviceType=' + deviceType + '&timeZone=' + timeZone + "&" + new Date().getTime()).then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                    return response;
                });
            }
        }]);

        return AnalogOutputPaging;
    }();

    return AnalogOutputPaging;
};

AnalogOutputPagingFactory.$inject = ['HOST', '$http'];

angular.module('mc.paging').factory('AnalogOutputPagingFactory', AnalogOutputPagingFactory);
mcapp.directive('notificationVoiceOption', function () {
    return {
        restrict: "E",
        replace: true,
        scope: {
            selectHide: '='
        },
        template: "<select size='1' ng-class=\"{'ns_select form-select': true, 'ng-hide': selectHide == true}\"><option value='12'>Voice (Short)</option><option value='11'>Voice (Standard)</option><option value='13'>Voice (Short Ack 9)</option><option value='15'>Voice (Short Ack *)</option><option value='14'>Voice (No Ack)</option><option value='5'>Old Voice (Standard)</option><option value='6'>Old Voice (Short Form)</option><option value='9'>Old Voice (Short Form Ack9)</option></select>",
        link: function (scope, element, attrs) {
            //
        }
    };
});
mcapp.controller("notificationScheduleController", ["$scope", "$http", "$location", "$window", "authenticationService", "$rootScope", "translationService", "sharedSetupService", "openViewService", "serviceUserService", "notificationGroupDestinationsService", "detectBrowserService", "$timeout", "notificationGroupsService", "toaster", "$element", "$uibModal",
    function ($scope, $http, $location, $window, authenticationService, $rootScope, translationService, sharedSetupService, openViewService, serviceUserService, notificationGroupDestinationsService, detectBrowserService, $timeout, notificationGroupsService, toaster, $element, $uibModal) {
        $scope.translation = translationService.translation;
        //$scope.accountInfo = sharedSetupService.accountInfo;
        //$scope.serviceUserData = null;
        $scope.mobile = $rootScope.mobile;
        $scope.classicView = $rootScope.classicView;
        $scope.notificationGroupsData = [];
        $scope.notificationGroupDestinations = null;
        $scope.notificationGroupCycles = [];
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.groupSelected = ("1").toString();
        $scope.dropShift247 = 0;
        $scope.droppDays = 0;
        $scope.droppNights = 0;
        $scope.droppWeekends = 0;
        $scope.checked = true; //false;
        $scope.shiftsEnabled = true; //false;
        $scope.toggleSchedule = false;
        $scope.cycles = [{ id: 3 }, { id: 5 }, { id: 10 }, { id: 15 }];
        $scope.threeShifts = [];//$scope.threeShifts = ["Days", "Nights", "Weekends"];
        $scope.threeNewShifts = [];//$scope.threeNewShifts = [9, 10, 11];
        //$scope.shifts = [];
        $scope.loadingInProgress = true;
        $scope.savingInProgress = false;
        $scope.shift247 = 0;
        $scope.shiftDays = 0;
        $scope.shiftNights = 0;
        $scope.shiftWeekends = 0;
        $scope.curentBrowser = detectBrowserService();
        $scope.checkMouseDown = false;
        $scope.dataChanged = false;
        $scope.intBrj = 0;
        $scope.activeTab;
        $scope.activeTabClassIndex;
        $scope.activeTabClass = ["Days", "Nights", "Weekends", "Shift247"];
        $scope.numberOfPhoneCallsPerCycle = 6;

        var _broadcastNotificationError = function (errorMessage) {
            $rootScope.$broadcast('notificationScheduleError', {
                message: errorMessage
            });
        };

        $scope.openErrorModal = function (errorMessage) {
            function modalController($uibModalInstance) {
                this.translation = $scope.translation;
                this.popoverMessage = "Oops! Something went wrong!<br><br>The application has encountered an error. It doesn't appear to have affected your data, but we will reload the schedule to sync it with the setting.";//message;

                this.ok = function () {
                    $uibModalInstance.close();
                };
            }

            modalController.$inject = ['$uibModalInstance'];

            const modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                templateUrl: 'ui/components/scadaviews/error-something-went-wrong-popover.html',
                controller: modalController,
                controllerAs: '$ctrl',
                size: 'sm'
            });

            modalInstance.result.then(function (event) {
                _broadcastNotificationError(errorMessage);

            }, function (event) {
                _broadcastNotificationError(errorMessage);
            });
        };

        $scope.dynamicPopover = {
            templateUrl: 'myPopoverTemplateTeams.html'
        };

        $scope.prePlaceTeamOnDuty = function (team) {
            $scope.availableTeams = [];
            var dataTeam = $(event.currentTarget).attr("data-team");
            var dataNotificationRecipientId = $(event.currentTarget).attr("data-notification-recipient-id");
            $scope.tmpTeam = dataTeam;
            $scope.dataNotificationRecipientId = dataNotificationRecipientId;

            var activeTabClassName = angular.isUndefined($scope.activeTab) ? $scope.activeTabClass[$scope.activeTabClassIndex] : $scope.activeTabClass[$scope.activeTab];
            $($element).find(".ns_schedule_tabs").find("." + activeTabClassName).find("li.destination").each(function (n, v) {
                var _li = $(this);
                var _team = _li.attr("data-team");
                if (_team > 0 && !$scope.availableTeams.includes(_team)) $scope.availableTeams.push(parseInt(_team));
            });
        };

        $scope.updateTeam = function (event, team) {
            $scope.placeTeamOnDuty(team);
        };

        $scope.placeTeamOnDuty = function (teamOnDuty) {
            var activeTabClassName = angular.isUndefined($scope.activeTab) ? $scope.activeTabClass[$scope.activeTabClassIndex] : $scope.activeTabClass[$scope.activeTab];
            var _length = $($element).find(".ns_schedule_tabs").find("." + activeTabClassName).find("li.destination").length;
            $($element).find(".ns_schedule_tabs").find("." + activeTabClassName).find("li.destination").each(function (n, v) {
                var _li = $(this);
                var _team = _li.attr("data-team");

                if (_team == teamOnDuty) {
                    if (_li.find('input').is(':checked') == false) {
                        _li.find('input').prop('checked', true);
                        _li.attr("data-changed", "true");
                    }
                }
                else if (_team > 0 && _team != teamOnDuty) {
                    if (_li.find('input').is(':checked') == true) {
                        _li.find('input').prop('checked', false);
                        _li.attr("data-changed", "true");
                    }
                }

                if (n === _length - 1) {
                    $timeout(function () {
                        _li.trigger("click", "input");
                    }, 0);
                }
            });
            return false;
        };

        $scope.userAgent = navigator.userAgent.toLowerCase();
        $scope.isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test($scope.userAgent);

        $scope.lockIt = function () {
            $scope.readOnlyStateOverlay = true;
            if ($scope.mobile) $('.ns-read-only-state-overlay').show();
        };

        $scope.unlockIt = function () {
            $scope.readOnlyStateOverlay = false;
            if ($scope.mobile) $('.ns-read-only-state-overlay').hide();
        };

        if ($scope.mobile && (!$scope.stickyProperties || $scope.stickyProperties.deviceId == undefined)) {
            $location.path('/desktop/desktop');
        }

        $scope.voiceNumberType = [
            { id: 11, description: "Voice (Standard)" },
            { id: 12, description: "Voice (Short)" },
            { id: 13, description: "Voice (Short Ack 9)" },
            { id: 14, description: "Voice (No Ack)" },
            { id: 15, description: "Voice (Short Ack *)" }
        ];

        $scope.getVoiceNumberType = function (varId) {
            var tmpDescription = varId;
            for (var j = 0; j < $scope.voiceNumberType.length; j++) {
                if ($scope.voiceNumberType[j].id == varId) {
                    tmpDescription = $scope.voiceNumberType[j].description;
                    break;
                }
            }
            return tmpDescription;
        };

        if ($scope.accountInfo.userRole === 'Administrator' || $scope.accountInfo.userRole === 'SuperAdministrator') {
            $scope.isAdmin = true;
        }

        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }

        $(document).mousedown(function () {
            $scope.checkMouseDown = true;
        });

        $(document).mouseup(function () {
            $scope.checkMouseDown = false;
        });

        $scope.getText = function (text) {
            if (!angular.isDefined(text)) return;
            return typeof eval("$scope.translation.text." + text.toUpperCase().replace(/-/g, "_")) !== 'undefined' ? eval("$scope.translation.text." + text.toUpperCase().replace(/-/g, "_")) : text;
        };

        $scope.scheduleSchemeCatchAll = "<span class='list-group' style='font-size: 12px;'>";
        $scope.scheduleSchemeCatchAll += "<div class='list-group-item' style='width: 300px; white-space:nowrap;'><div class='ui-corner-all dnw Days'>&nbsp;</div>&nbsp; " + $scope.getText('Days') + " <div style='float: right; width: 120px; font-size: 11px; text-align: center;'>07:00am - 07:00pm</div></div>";
        $scope.scheduleSchemeCatchAll += "<div class='list-group-item' style='width: 300px; white-space:nowrap;'><div class='ui-corner-all dnw Nights'>&nbsp;</div>&nbsp; " + $scope.getText('NIGHTS') + " <div style='float: right; width: 120px; font-size: 11px; margin-top: -7px; text-align: center;'>00:00am - 07:00am<br />07:00pm - 12:00pm</div></div>";
        $scope.scheduleSchemeCatchAll += "<div class='list-group-item' style='width: 300px; white-space:nowrap;'><div class='ui-corner-all dnw Weekends'>&nbsp;</div>&nbsp; " + $scope.getText('WEEKENDS') + " <div style='float: right; width: 120px; font-size: 11px; text-align: center;'>00:00am - 12:00pm</div></div>";
        $scope.scheduleSchemeCatchAll += "<div class='list-group-item' style='width: 300px; white-space:nowrap;'><div class='ui-corner-all dnw Shift247'>&nbsp;</div>&nbsp; " + $scope.getText('Catch-all') + " <div style='float: right; width: 120px; font-size: 11px; text-align: center;'>00:00am - 12:00pm</div></div>";
        $scope.scheduleSchemeCatchAll += "</span>";
        $scope.scheduleScheme247 = "<span class='list-group' style='font-size: 12px;'>";
        $scope.scheduleScheme247 += "<div class='list-group-item' style='width: 300px; white-space:nowrap;'><div class='ui-corner-all dnw Shift247'>&nbsp;</div>&nbsp; 24/7 <div style='float: right; width: 120px; font-size: 11px; text-align: center;'>00:00am - 12:00pm</div></div>";
        $scope.scheduleScheme247 += "</span>";
        $scope.scheduleScheme = $scope.scheduleSchemeCatchAll; //$scope.scheduleScheme247;

        serviceUserService.getData($scope.accountInfo.customerId)
            .then(function (dataFromFactory) {
                $scope.serviceUserData = dataFromFactory.data.serviceUsers;
            }, function (error) {
                var errormsg = eval("$scope.translation.message." + error.data.message);
                $scope.alerts.push({ msg: errormsg, type: "danger" });
                toaster.pop('error', $scope.windowTitle, errormsg);
                $scope.loadingInProgress = false;
                $scope.savingInProgress = false;
                $scope.openErrorModal("Error: 1.5")
            });

        $scope.$watch('groupSelected', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                $scope.loadingInProgress = true;
                $scope.checked = false;
                $scope.toggleSchedule = true;
                $scope.toggleScheduleFn();

                notificationGroupDestinationsService.getData($scope.accountInfo.customerId, newValue)
                    .then(function (dataFromFactory) {
                        $scope.notificationGroupDestinations = dataFromFactory.data.destinations;
                        $scope._getCheck();
                        $scope.notificationGroupCycles = dataFromFactory.data.cycles;
                        $scope.fnSubgroups(newValue);
                    }, function (error) {
                        var errormsg = eval("$scope.translation.message." + error.data.message);
                        $scope.alerts.push({ msg: errormsg, type: "danger" });
                        toaster.pop('error', $scope.windowTitle, errormsg);
                        $scope.loadingInProgress = false;
                        $scope.savingInProgress = false;
                        $scope.openErrorModal("Error: 1.6")
                    });
            }
        }, true);


        $scope.$watch('shiftsEnabled', function (newValue, oldValue) {
            if (newValue != oldValue) {
                $scope.checked = newValue;
            }
        }, true);

        $scope.$watch('checked', function (newValue, oldValue) {
            if (newValue != oldValue) {
                $scope.scheduleScheme = newValue ? $scope.scheduleSchemeCatchAll : $scope.scheduleScheme247;
                $scope.shiftsEnabled = newValue;
            }
        }, true);

        $scope.checkShifts = function ($event) {
            //var checkbox = $event.target;
        };

        $scope.fnBrowser = function () {
            return ($scope.curentBrowser == "chrome" || $scope.curentBrowser == "firefox");
        };

        $scope.fnDroppShift247 = function () {
            $scope.droppShift247++;
        };

        $scope.fnDroppDays = function () {
            $scope.droppDays++;
        };

        $scope.fnDroppNights = function () {
            $scope.droppNights++;
        };

        $scope.fnDroppWeekends = function () {
            $scope.droppWeekends++;
        };

        $scope.fnSubgroups = function (varSelected) {
            var _shiftRecord;
            var _brj = 0;
            $scope.shifts = [];

            for (var j = 0; j < $scope.notificationGroupsData.length; j++) {
                if ($scope.notificationGroupsData[j].subgroup == varSelected) {
                    _shiftRecord = { id: $scope.notificationGroupsData[j].id, name: $scope.threeShifts[_brj], description: $scope.threeShifts[_brj], descriptionAlternate: $scope.threeShifts[_brj] }; // + ' - ' + $scope.notificationGroupsData[j].description
                    _brj++;
                    $scope.shifts.push(_shiftRecord);
                }
            }

            if (_brj === 0) {
                for (var z = 0; z < $scope.threeNewShifts.length; z++) {
                    _shiftRecord = { id: $scope.threeNewShifts[z], name: $scope.threeShifts[_brj], description: $scope.threeShifts[_brj], descriptionAlternate: $scope.threeShifts[_brj] }; // + ' - ' + $scope.notificationGroupsData[j].description
                    _brj++;
                    $scope.shifts.push(_shiftRecord);
                }
            }

            for (var i = 0; i < $scope.notificationGroupsData.length; i++) {
                if ($scope.notificationGroupsData[i].id == varSelected) {
                    _shiftRecord = { id: varSelected, name: 'Shift247', description: '24/7', descriptionAlternate: 'Catch-all' }; // - ' + $scope.notificationGroupsData[j].description
                    $scope.shifts.push(_shiftRecord);
                }
            }
     
            $scope.shift247 = 0;
            $scope.shiftDays = 0;
            $scope.shiftNights = 0;
            $scope.shiftWeekends = 0;
            
        };

        $scope._getCycle = function (varGroup, varCycle) {
            for (var i = 0; i < $scope.notificationGroupCycles.length; i++) {
                if ($scope.notificationGroupCycles[i].groupId == varGroup && $scope.notificationGroupCycles[i].cycle == varCycle && $scope.notificationGroupCycles[i].customerId == $scope.accountInfo.customerId) {
                    return $scope.notificationGroupCycles[i].value;
                }
            }

            for (var j = 0; j < $scope.notificationGroupCycles.length; j++) {
                if ($scope.notificationGroupCycles[j].groupId == varGroup && $scope.notificationGroupCycles[j].cycle == varCycle && $scope.notificationGroupCycles[j].customerId === 0) {
                    return $scope.notificationGroupCycles[j].value;
                }
            }

            for (var z = 0; z < $scope.notificationGroupCycles.length; z++) {
                if ($scope.notificationGroupCycles[z].groupId === 0 && $scope.notificationGroupCycles[z].cycle === 0 && $scope.notificationGroupCycles[z].customerId === 0) {
                    return $scope.notificationGroupCycles[z].value;
                }
            }
        };

        $scope._getCycleMissing = function (varCycle) {
            for (var i = 0; i < $scope.cycles.length; i++) {
                if ($scope.cycles[i].id == varCycle) {
                    return false;
                }
            }
            return true;
        };

        $scope._getInputTypeNumber = function () {
            if ($scope.curentBrowser == "internet explorer") {
                return "text";
            } else {
                return "number";
            }
        };

        $scope._resetData = function () {
            $scope.loadingInProgress = true;
            $scope.checked = false;
            $scope.toggleSchedule = true;
            $scope.toggleScheduleFn();

            notificationGroupDestinationsService.getData($scope.accountInfo.customerId, $scope.groupSelected)
                .then(function (dataFromFactory) {
                    $scope.notificationGroupDestinations = dataFromFactory.data.destinations;
                    $scope.notificationGroupCycles = dataFromFactory.data.cycles;
                    $scope.fnSubgroups($scope.groupSelected);
                }, function (error) {
                    var errormsg = eval("$scope.translation.message." + error.data.message);
                    $scope.alerts.push({ msg: errormsg, type: "danger" });
                    toaster.pop('error', $scope.windowTitle, errormsg);
                    $scope.loadingInProgress = false;
                    $scope.savingInProgress = false;
                    $scope.openErrorModal("Error: 1.7")
                });
        };

        $scope._savingData = function () {
            //$scope.savingInProgress = true;
            //$timeout(callAtTimeout, 3000);
            $scope.checked = $scope.checked;
            $scope.toggleSchedule = true;
            $scope.toggleScheduleFn();

            notificationGroupsService.getData($scope.accountInfo.customerId)
                .then(function (dataFromFactory) {
                    $scope.notificationGroupsData = dataFromFactory.data.notificationGroups;
                    $scope.fnSubgroups($scope.groupSelected);
                }, function (error) {
                    var errormsg = eval("$scope.translation.message." + error.data.message);
                    $scope.alerts.push({ msg: errormsg, type: "danger" });
                    toaster.pop('error', $scope.windowTitle, errormsg);
                    $scope.loadingInProgress = false;
                    $scope.savingInProgress = false;
                    $scope.openErrorModal("Error: 1.8")
                });

        };

        function callAtTimeout() {
            $scope.savingInProgress = false;
        }

        $scope._formatPhone = function (text) {
            if (typeof text === "undefined" || text === null) return "";
            text = text.replace(/\D/g, '');
            text = text.substring(0, 1) == "1" ? text.substring(1, text.lenght) : text;
            text = text.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
            return text;
        };

        $scope._getCheck = function () {
            var lookup = {};
            var items = $scope.notificationGroupDestinations;
            var result = [];

            for (var item, i = 0; item = items[i++];) {
                var name = item.groupId

                if (!(name in lookup)) {
                    lookup[name] = 1;
                    result.push(name);
                }
            }

            if (result.length > 1) {
                $scope.activeTab = 0;
                $scope.checked = true;
            }
        };

        ////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////
        $scope.popup = !$rootScope.mobile ? _this.getExistingDialog($scope.windowId).ref : $element;

        if (!$rootScope.mobile) {
            sharedSetupService.maximize($scope.popup);

            $scope.setViewTitle = function (varRuleName) {
                $scope.tmpWindowTitle = $scope.translation.text.NOTIFICATION_SCHEDULE + ", " + varRuleName;
                $scope.popup.dialog("option", "title", $scope.tmpWindowTitle);
            }


            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                $scope.popup.parent().find('.ns_contentobj').find('span:first').css("height", _tmpHeight - 205).find('div:first').css("height", _tmpHeight - 205).find(".ns_tabs_div").css("height", _tmpHeight - 205 - 40);
                $scope.popup.parent().find('.ns_right_mc').find('.ui-widget-content_ns:first').css("max-height", _tmpHeight - 270);

            };

            $scope.nsBlockBHide = true;
            $scope.nsEditMode = function (varnsBlockBHide) {
                var _width = $scope.popup.dialog("option", "width");
                var _height = $scope.popup.dialog("option", "height");

                if (varnsBlockBHide) {
                    _width = _width <= 645 ? 1024 : (_width + 379);
                    _height = _height <= 580 ? 580 : _height;
                    $scope.popup.dialog("option", "minWidth", 1024).dialog("option", "minHeight", 480);
                    $scope.popup.dialog("option", "width", _width).dialog("option", "height", _height);
                    $scope.nsBlockBHide = false;
                    $scope.popup.parent().find(".mc-sortable").sortable("option", "disabled", false);
                } else {
                    $scope.nsBlockBHide = true;
                    _width = (_width - 379) <= 645 ? 645 : (_width - 379);
                    _height = _height <= 580 ? 580 : _height;
                    $scope.popup.dialog("option", "minWidth", 645).dialog("option", "minHeight", 480);
                    $scope.popup.dialog("option", "width", _width).dialog("option", "height", _height);
                    $scope.popup.parent().find(".mc-sortable").sortable("option", "disabled", true);
                }

                if (_width > $window.innerWidth) {
                    $scope.popup.dialog("option", "minWidth", 645);
                    $scope.popup.dialog("option", "width", $window.innerWidth);
                }
                $scope.adjustSize();
            };
        }
        else {
            $scope.setViewTitle = function (varRuleName) {
                $scope.tmpWindowTitle = $scope.translation.text.NOTIFICATION_SCHEDULE + ", " + varRuleName;
            }

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                //$scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                //$scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                //$scope.popup.parent().find('div:eq(2)').css("height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                //$scope.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

                $scope.popup.parent().find('.ns_contentobj').find('span:first').css("height", _tmpHeight - 205).find('div:first').css("height", _tmpHeight - 205).find(".ns_tabs_div").css("height", _tmpHeight - 205 - 40);
                $scope.popup.parent().find('.ns_right_mc').find('.ui-widget-content_ns:first').css("max-height", _tmpHeight - 270);

            };

            $scope.nsBlockBHide = true;
            
            $scope.nsEditMode = function (varnsBlockBHide) {
                var _width = $scope.popup.width();
                var _height = $scope.popup.height();
                $scope.mcSortable = $scope.popup.parent().find(".mc-sortable");

                if (varnsBlockBHide) {
                    _width = _width <= 645 ? 1024 : (_width + 379);
                    _height = _height <= 580 ? 580 : _height;
                    //$scope.popup.dialog("option", "minWidth", 1024).dialog("option", "minHeight", 480);
                    //$scope.popup.dialog("option", "width", _width).dialog("option", "height", _height);
                    $scope.nsBlockBHide = false;
                    $scope.mcSortable.sortable("option", "disabled", true);
                } else {
                    $scope.nsBlockBHide = true;
                    _width = (_width - 379) <= 645 ? 645 : (_width - 379);
                    _height = _height <= 580 ? 580 : _height;
                    //$scope.popup.dialog("option", "minWidth", 645).dialog("option", "minHeight", 480);
                    //$scope.popup.dialog("option", "width", _width).dialog("option", "height", _height);
                    $scope.mcSortable.sortable("option", "disabled", true);
                }

                if (_width > $window.innerWidth) {
                    //$scope.popup.dialog("option", "minWidth", 645);
                    //$scope.popup.dialog("option", "width", $window.innerWidth);
                }
                $scope.adjustSize();
            };
        }

        $scope.liMainMouseTouch = function (domElement) {
            //console.log("liMainMouseTouch(" + domElement + ")");

            switch (domElement) {
                case "li":
                    if ($scope.mcSortable.sortable("option", "disabled")) {
                        $scope.mcSortable.sortable("option", "disabled", false);
                        //console.log("sortable enable");
                    }
                    else {
                        //console.log("sortable already enable");
                    }                
                    break;

                default:
                    if (!$scope.mcSortable.sortable("option", "disabled")) {
                        $scope.mcSortable.sortable("option", "disabled", true);
                        //console.log("sortable disable");
                    }
                    else {
                        //console.log("sortable already disable");
                    }
                    break;
            }
        };
      
        ////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////

        $scope.manageSchedule = function (varShift) {
            var position = { my: 'top+120', at: 'center top', of: window };
            var optionsStickyProperties = { deviceId: varShift };
            openViewService.openView('Manage Schedule', { width: 900, height: 400 }, position, optionsStickyProperties, { minimumWidth: 900, minimumHeight: 400 }, true);
        };

        $scope.getNumberOfNotifyTypes = function (varServiceUserId) {
            var intBr = 0;
            for (var i = 0; i < $scope.serviceUserData.length; i++) {
                if ($scope.serviceUserData[i].serviceUserId === varServiceUserId) {
                    if ($scope.serviceUserData[i].voicePager) intBr++;
                    if ($scope.serviceUserData[i].numericPager) intBr++;
                    if ($scope.serviceUserData[i].fax) intBr++;
                    if ($scope.serviceUserData[i].email) intBr++;
                    if ($scope.serviceUserData[i].voiceNumber) intBr++;
                    if ($scope.serviceUserData[i].smsNumber) intBr++;
                    break;
                }
            }
            return intBr;
        };

        $scope.$on('updatePreferencesLanguage', function (event, args) {
            $scope.setViewTitle($scope.ruleName);
        });

        $scope.$on('reloadNotificationSchedule', function (event, args) {
            if (!$scope.mobile) {
                var position = { my: 'left+' + $($scope.popup).parent().position().left + ' top+' + $($scope.popup).parent().position().top, at: 'left top', of: window };
                $scope.popup.dialog("close");
                $timeout(function () {
                    var optionsStickyProperties = { deviceId: $scope.stickyProperties.deviceId }
                    openViewService.openView('Notification Schedule', { width: 645, height: 580 }, position, optionsStickyProperties, { minimumWidth: 645, minimumHeight: 480 });
                }, 1000);
            }
        })

        $scope.$on('destinationsPatch', function (event, args) {
            $scope.$emit('reloadNotificationSchedule', {
                message: args.message
            });
        })

        $scope.$on('notificationScheduleError', function (event, args) {

            if ($scope.mobile) {
                $location.path('/desktop/desktop');
                return;
            }

            $scope.$emit('reloadNotificationSchedule', {
                message: args.message
            });
        })

    }]);

mcapp.directive('notificationScheduleDraggable', function () {
    return {
        // A = attribute, E = Element, C = Class and M = HTML Comment
        restrict: 'A',
        //The link function is responsible for registering DOM listeners as well as updating the DOM.
        link: function (scope, element, attrs) {
            element.draggable({
                revert: function (event, ui) { return !event; },
                scroll: false,
                scope: "mc-dragdrop-" + scope.ruleId,
                stack: ".ns_container",
                cursor: "move",
                helper: "clone",

                connectToSortable: ".mc-sortable-" + scope.ruleId,
                // Very Important - will let the pointer events fire on the elements underneath the helper
                //which we need for "mouseover.notificationScheduleDroppable"
                start: function (event, ui) { newItem = ui.helper; newItem.addClass('cloned-item').css("width", $(ui.draggable).css("width")).css("pointer-events", "none"); }
                //stop: function (event, ui) { $(this).parent().addClass("ns_destinations_scroll");}
            })
                .parent().addClass("ns_destinations_scroll");
            //.tooltip({
            //    track: true,
            //    tooltipClass: 'tooltip-jq'
            //});

            element.on(
                "mouseover.notificationScheduleDraggable",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            if (scope.mobile)
                                scope.liMainMouseTouch("li");
                            $(event.currentTarget).addClass("pop-out-effect");
                        }
                    );
                }
            );

            element.on(
                "mouseout.notificationScheduleDraggable",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            $(event.currentTarget).removeClass("pop-out-effect");
                        }
                    );
                }
            );

            element.on(
                "mousedown.notificationScheduleDraggable",
                function (event) {
                    event.preventDefault();
                    //event.stopPropagation();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            var ntfType = $(event.target).attr("ntft");
                            $(event.currentTarget).attr("ntf-type", ntfType);
                        }
                    );
                }
            );

            scope.$on(
                "$destroy",
                function (event) {
                    element.off("mouseover.notificationScheduleDraggable");
                    element.off("mouseout.notificationScheduleDraggable");
                    element.off("mousedown.notificationScheduleDraggable");
                }
            );
        }
    };
});

mcapp.directive('notificationScheduleDroppable', ["$rootScope", "$interval", "toaster", "notificationRuleRecipientService", "$compile", "$timeout", "DestinationsFactory", "$uibModal", function ($rootScope, $interval, toaster, notificationRuleRecipientService, $compile, $timeout, DestinationsFactory, $uibModal) {
    return {
        // A = attribute, E = Element, C = Class and M = HTML Comment
        restrict: 'A',
        //The link function is responsible for registering DOM listeners as well as updating the DOM.
        link: function (scope, element, attrs) {
            var tmpLi;

            scope.$watch('nsBlockBHide', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    scope.strikeThrough(newValue);
                }
            }, true);

            element.droppable({
                accept: "mc-dragdrop-" + scope.ruleId,
                scope: "mc-dragdrop-" + scope.ruleId,
                drop: function (event, ui) {
                    var _shiftDNW, _thisUL = $(this), _thisLI = !(ui.draggable.text().indexOf(scope.translation.text.DELAY) > -1);
                    if ($(this).hasClass('Shift247') && _thisLI) {
                        scope.fnDroppShift247();
                        //scope._mark247();
                        _shiftDNW = "Shift247";
                    }
                    if ($(this).hasClass('Days') && _thisLI) {
                        scope.fnDroppDays();
                        //$(element).parents("span").find('[data-hour = 7am], [data-hour = 8am], [data-hour = 9am], [data-hour = 10am], [data-hour = 11am], [data-hour = 12pm]').not('[data-day = sun]').not('[data-day = sat]').addClass('selectedD');
                        //$(element).parents("span").find('[data-hour = 1pm], [data-hour = 2pm], [data-hour = 3pm], [data-hour = 4pm], [data-hour = 5pm], [data-hour = 6pm]').not('[data-day = sun]').not('[data-day = sat]').addClass('selectedD');
                        _shiftDNW = "Days";
                    }
                    if ($(this).hasClass('Nights') && _thisLI) {
                        scope.fnDroppNights();
                        //$(element).parents("span").find('[data-hour = 12am], [data-hour = 1am], [data-hour = 2am], [data-hour = 3am], [data-hour = 4am], [data-hour = 5am], [data-hour = 6am]').not('[data-day = sun]').not('[data-day = sat]').addClass('selectedN');
                        //$(element).parents("span").find('[data-hour = 7pm], [data-hour = 8pm], [data-hour = 9pm], [data-hour = 10pm], [data-hour = 11pm]').not('[data-day = sun]').not('[data-day = sat]').addClass('selectedN');
                        _shiftDNW = "Nights";

                    }
                    if ($(this).hasClass('Weekends') && _thisLI) {
                        scope.fnDroppWeekends();
                        //$(element).parents("span").find('[data-day = sun]').addClass('selectedW');
                        //$(element).parents("span").find('[data-day = sat]').addClass('selectedW');
                        _shiftDNW = "Weekends";
                    }

                    $(this).find(".placeholder").remove();
                }
            }).sortable({
                items: "li:not(.placeholder)",
                cursor: "move",
                scroll: false,
                placeholder: "sortable-space-highlight",
                disabled: true,
                receive: function (event, ui) {
                    var el, elCycle, intBr = 0, newItem = $(this).data().uiSortable.currentItem, ntfType = newItem.attr("ntf-type");
                    newItem.removeClass("pop-out-effect");
                    var higlightRow = function () {
                        intColor = newItem.css("border-color") == "" ? "#b9b9b9" : newItem.css("border-color");  //firefox issue
                        newItem.stop().animate({ borderColor: "#000000" }, 250)
                            .animate({
                                borderColor: intColor
                            }, 250)
                            .animate({
                                borderColor: "#000000"
                            }, 250)
                            .animate({
                                borderColor: intColor
                            }, 250)
                            .animate({
                                borderColor: "#000000"
                            }, 250)
                            .animate({ borderColor: intColor }, 250);
                    };

                    if (newItem.text().indexOf(scope.translation.text.DELAY) > -1) {
                        newItem.removeClass('cloned-item').css("width", "100%").css("height", "28px");
                        newItem.find('span').remove();
                        newItem.find('input, a').removeClass('ng-hide');
                        newItem.find('a').attr('ng-hide', 'nsBlockBHide');
                        newItem.find('input').attr('ng-disabled', 'nsBlockBHide');
                        newItem.find('input').removeAttr('ng-model');
                        newItem.find('input').removeAttr('ng-show');
                        $compile(newItem.find('input'))(scope);
                        $compile(newItem.find('a'))(scope);
                        newItem.css("padding", "2px 3px").css("margin", "10px 0px 1px 0px").css("box-shadow", "#515151 1px 1px 1px");
                        higlightRow();
                    }
                    else {
                        newItem.removeClass('cloned-item').css("width", "100%").css("height", "30px");
                        newItem.find('input, a, mcspan, button').removeClass('ng-hide');
                        newItem.find('input').attr('ng-hide', 'nsBlockBHide');
                        newItem.find('a').attr('ng-hide', 'nsBlockBHide');
                        if (newItem.attr("data-disabled") == "false") {
                            newItem.find('input').attr('checked', true);
                        } else {
                            newItem.find('input').attr('disabled', 'disabled');
                            newItem.find('mcspan').attr('title', scope.translation.text.INACTIVE_USER);
                        }
                        $compile(newItem.find('a, input'))(scope);
                        newItem.find('mcspan').filter(function () { return ($(this).text() === '...') }).remove();
                        newItem.find('mcspan:eq(0)').css('display', 'inline-block');
                        newItem.css("padding", "3px 3px 3px 0");
                        newItem.children('span').each(function () {
                            $(this).addClass("ng-hide");
                        });
                       
                        higlightRow();
                        newItem.children('span').each(function () {
                            if ($(this).attr("ntft") == ntfType) {
                                var isVoicePager =($(this).attr("ntft") == 17);                            
                                newItem.find("a").eq(1).css("opacity", isVoicePager ? "0.5" : "1").css("cursor",isVoicePager ?"Default":"Hand");
                                $(this).removeClass("ng-hide");
                                $(this).addClass("ng-show");
                                newItem.append("<mcspan style='padding-right: 10px; font-size: smaller; font-weight: bold; display: none; float: right;'>" + $(this).attr('title') + "</mcspan><br style='clear: both;'>");
                                intBr++;
                            }
                        });

                        if (intBr == 0) {
                            newItem.children('span:last').removeClass("ng-hide").addClass("ng-show");
                            newItem.attr("ntf-type", newItem.children('span:last').attr("ntft"));
                            newItem.append("<mcspan style='padding-right: 10px; font-size: smaller; font-weight: bold; display: none; float: right;'>" + newItem.children('span:last').attr('title') + "</mcspan><br style='clear: both;'>");
                        }
                    }


                },
                start: function (event, ui) {
                    newItem = ui.item; newItem.addClass('sorting-item').css("pointer-events", "none");
                },
                stop: function (event, ui) {
                    newItem = ui.item; newItem.removeClass('sorting-item').css("pointer-events", "visible");
                },
                sort: function () {
                    // gets added unintentionally by droppable interacting with sortable
                    // using connectWithSortable fixes this, but doesn't allow you to customize active/hoverClass options
                    $(this).removeClass("ui-state-default");
                },
                update: function () {
                    var _testOnly = scope.saveEverything("test-only");
                    if (!_testOnly) {
                        newItem.addClass("error");
                        newItem.hide(function () { newItem.remove(); scope.unlockIt(); });
                    } else {
                        scope.unlockIt();
                    }
                    if (_testOnly) scope.saveEverything(newItem.attr("data-item-action"));

                    $(this).find(".placeholder").remove();
                    $(this).append("<li class='placeholder sortable-space-highlight' style='background-color:transparent; text-align: center;' ng-hide='nsBlockBHide'>{{translation.text.DRAG_DESTINATION_HERE}}</li>");
                    $compile($(this).find('.placeholder'))(scope);
                }
            });

            element.on(
                "click.notificationScheduleDroppable",
                "span, a, input, li",
                function (event, triggered) {
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            var varSelector = $(event.currentTarget).is("span") ? "span" : $(event.currentTarget).is("a") ? "a" : $(event.currentTarget).is("input") ? "input" : $(event.currentTarget).is("li") ? "li" : false;
                            switch (varSelector) {
                                case "span":
                                    if (!scope.mobile)
                                        event.preventDefault();
                                    if ($(event.target).parents('li').find("a").hasClass("ng-hide")) return;
                                    var nextItem = $(event.currentTarget).next(varSelector);
                                    var prevItem = $(event.currentTarget).prev(varSelector);
                                    var lastItem = $(event.currentTarget).siblings(varSelector).last();
                                    if (prevItem.length) {
                                        $(event.currentTarget).removeClass("ng-show").addClass("ng-hide");
                                        prevItem.removeClass("ng-hide").addClass("ng-show");
                                        $(event.target).parents('li').attr("ntf-type", prevItem.attr("ntft"));
                                        $(event.target).parents('li').find('mcspan:last').text(prevItem.attr('title'));
                                    }
                                    else if (nextItem.length) {
                                        $(event.currentTarget).removeClass("ng-show").addClass("ng-hide");
                                        lastItem.removeClass("ng-hide").addClass("ng-show");
                                        $(event.target).parents('li').attr("ntf-type", lastItem.attr("ntft"));
                                        $(event.target).parents('li').find('mcspan:last').text(lastItem.attr('title'));
                                    }
                                    $(event.target).parents('li').attr("data-changed", "true");

                                    var isVoicePager = $(event.currentTarget).parent().attr("ntf-type") == 17 ? true : false;
                                    $(event.currentTarget).parent().find("a").eq(1).css("opacity", isVoicePager ? "0.5" : "1").css("cursor",isVoicePager ?"Default":"Hand");

                                    scope.saveEverything("Data Changed");
                                    break;
                                case "li":
                                    if (triggered) {
                                        event.preventDefault();
                                        if ($(event.target).find("a").hasClass("ng-hide")) return;

                                        if (triggered !== "input") {
                                            $(event.target).attr("data-changed", "true");
                                        }

                                        scope.saveEverything("Data Changed");
                                        return false;
                                    }
                                    break;
                                case "a":
                                    if (event.currentTarget.id != "") {
                                        event.preventDefault();
                                        var _li = $(event.target).parents('li');
                                        _tmpServiceUserId = _li.attr("data-service-user-id");
                                        _tmpNotificationType = _li.attr("ntf-type");           
                                        if(_tmpNotificationType != 17)  
                                        scope.checkMethod(_tmpServiceUserId, _tmpNotificationType);
                                    }
                                    else {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        var _ulParent = $(event.currentTarget).parents('ul');
                                        var _ulShift = _ulParent.attr('class').split(' ').pop();
                                        $(event.currentTarget).parent().remove();
                                        _tmpCustomerId = scope.accountInfo.customerId;
                                        _tmpNotificationRecipientId = $(event.target).parents('li').attr("data-notification-recipient-id");
                                        if (typeof _tmpNotificationRecipientId !== 'undefined' && _tmpNotificationRecipientId !== '') _notificationRuleRecipientDelete(_tmpCustomerId, _tmpNotificationRecipientId);
                                        scope.saveEverything("Delete");
                                        ///////////// no need for this since removing ng-repeat
                                        if (typeof $(event.currentTarget).attr("data-index") !== 'undefined')
                                            scope.notificationGroupDestinations.splice($(event.currentTarget).attr('data-index'), 1);
                                        ///////////// no need for this since removing ng-repeat

                                        if (_ulParent.children('li').find(':checkbox').size() === 0) {
                                            _ulParent.find(".placeholder").remove();
                                            _ulParent.append("<li class='placeholder sortable-space-highlight' style='background-color:transparent; text-align: center;' ng-hide='nsBlockBHide'>{{translation.text.DRAG_DESTINATION_HERE}}</li>");
                                            $compile(_ulParent.find('.placeholder'))(scope);
                                        }
                                    }
                                    break;
                                case "input":
                                    if ($(event.target).parents('li').find("a").hasClass("ng-hide")) {
                                        event.preventDefault();
                                        return false;
                                    }
                                    break;
                                default:
                                    return;
                            }
                        }
                    );
                }
            );

            if (scope.mobile)
                element.on(
                    "touchstart.notificationScheduleDroppable",
                    "span, a, input, li, button",
                    function (event, triggered) {
                        var localScope = $(event.target).scope();
                        localScope.$apply(
                            function () {
                                var varSelector = $(event.currentTarget).is("span") ? "span" : $(event.currentTarget).is("a") ? "a" : $(event.currentTarget).is("input") ? "input" : $(event.currentTarget).is("li") ? "li" : $(event.currentTarget).is("button") ? "button" : false;
                                switch (varSelector) {
                                    case "li":
                                        if (scope.nsBlockBHide) return;
                                        //console.log("<LI>");
                                        scope.liMainMouseTouch(varSelector);

                                        break;

                                    default:
                                        event.stopPropagation();
                                        if (scope.nsBlockBHide) return;
                                        //console.log("<" + varSelector + ">");
                                        scope.liMainMouseTouch(varSelector);
                                        break;
                                }
                            }
                        );
                    }
                );

            element.on(
                "mouseleave.notificationScheduleDroppable",
                "li",
                function (event) {
                    event.preventDefault();
                    //event.stopPropagation();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            $(event.target).find("input[type='number']").blur();
                        }
                    );
                }
            );

            element.on(
                "mouseover.notificationScheduleDroppable",
                function (event) {
                    //event.preventDefault();
                    event.stopPropagation();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            var parentHeight = element.parent().css("height");
                            if (scope.checkMouseDown == false || parseInt(parentHeight) <= 290) {
                                element.parent().stop();
                                $interval.cancel(_startDown);
                                _startDown = undefined;
                                $interval.cancel(_startUp);
                                _startUp = undefined;
                                return;
                            }

                            var parentOffset = element.parent().offset();
                            var y = event.pageY - parentOffset.top;

                            if (y > 0 && y < 50) {
                                element.parent().stop();
                                $interval.cancel(_startDown);
                                _startDown = undefined;
                                _checkStartUp();
                            }
                            else if (((parseInt(parentHeight) - y) > 0) && ((parseInt(parentHeight) - y) < 50)) {
                                element.parent().stop();
                                $interval.cancel(_startUp);
                                _startUp = undefined;
                                _checkStartDown();
                            }
                            else {
                                element.parent().stop();
                                $interval.cancel(_startDown);
                                _startDown = undefined;
                                $interval.cancel(_startUp);
                                _startUp = undefined
                            }
                        }
                    );
                }
            );

            element.on(
                "change.notificationScheduleDroppable, keyup.notificationScheduleDroppable",
                "input",
                function (event) {
                    var localScope = $(event.target).scope();
                    if ($(event.currentTarget).is("input")) {
                        var inputValue = $(event.currentTarget).val().replace(/\D/g, '');
                        inputValue = isNaN(inputValue) ? 5 : inputValue < 1 ? 5 : inputValue > 120 ? 10 : inputValue;
                        inputValue = parseInt(inputValue);
                        $(event.target).parents('li').attr("data-changed", "true");
                        $(event.currentTarget).val(inputValue);
                        scope.saveEverything("Data Changed");
                    }
                }
            );

            scope.$on(
                "$destroy",
                function (event) {
                    toaster.clear();
                    element.off("click.notificationScheduleDroppable");
                    if (scope.mobile)
                        element.off("touchstart.notificationScheduleDroppable");
                    element.off("mouseleave.notificationScheduleDroppable");
                    element.off("mouseover.notificationScheduleDroppable");
                    element.off("change.notificationScheduleDroppable, keyup.notificationScheduleDroppable");
                }
            );

            /////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////

            //var intBrj = 0; // only one time ng-repeat

            scope.getDestinationCycles = function (varShiftId, varShiftName) {

                if (scope.intBrj == 1)
                    return;

                var atLeastOneDestination = false;
                var tmpLi = "", preCycle = "", _printCycle, _tmpCycle, _cycle, intBr = 0;
                var destination = scope.notificationGroupDestinations;
                var tmpClass, tmpIndex, tmpChecked, tmpVoice, tmpVoiceShow, tmpFax, tmpFaxShow, tmpNumericPager, tmpNumericPagerShow,
                    tmpVoicePager, tmpVoicePagerShow, tmpEmail, tmpEmailShow, tmpInitialContact, tmpColor, tmpSms, tmpSmsShow;

                var _delay = 0, _cycleDelay = 0, _tmpDelay;

                for (var i = 0; i < destination.length; i++) {

                    if (destination[i].groupId == varShiftId) {
                        ////////////////////////////////
                        ////////////////////////////////
                        intBr++;
                        _printCycle = false;
                        _tmpDelay = parseInt(destination[i].delay);

                        if (_delay != _tmpDelay) {
                            _printCycle = true;
                            _cycleDelay = _tmpDelay - _delay;
                            _delay = _tmpDelay;
                        }
                        ////////////////////////////////
                        ////////////////////////////////
                        preCycle = preCycle == "" ? destination[i].cycle : preCycle;
                        tmpClass = "";
                        tmpIndex = 0;
                        tmpChecked = destination[i].onDuty == 1 && !destination[i].disabled ? " checked" : "";

                        tmpVoice = scope._formatPhone(destination[i].voiceNumber);
                        tmpFax = scope._formatPhone(destination[i].fax);
                        tmpEmail = destination[i].email;
                        tmpVoicePager = scope._formatPhone(destination[i].voicePager);
                        tmpNumericPager = scope._formatPhone(destination[i].numericPager);
                        tmpSms = destination[i].smsNumber.length > 0 ? destination[i].countryCode + "-" + scope._formatPhone(destination[i].smsNumber) : "";

                        tmpVoiceShow = " class = 'ng-hide'";
                        tmpFaxShow = " class = 'ng-hide'";
                        tmpEmailShow = " class = 'ng-hide'";
                        tmpVoicePagerShow = " class = 'ng-hide'";
                        tmpNumericPagerShow = " class = 'ng-hide'";
                        tmpSmsShow = " class = 'ng-hide'";

                        if (destination[i].notifyType > 10 && destination[i].notifyType < 16) {
                            tmpVoiceShow = " class = 'ng-show'";
                            tmpInitialContact = "Phone: " + tmpVoice;
                        }
                        else if (destination[i].notifyType == 2) {
                            tmpEmailShow = " class = 'ng-show'";
                            tmpInitialContact = "Email: " + tmpEmail;
                        }
                        else if (destination[i].notifyType == 4) {
                            tmpFaxShow = " class = 'ng-show'";
                            tmpInitialContact = "Fax: " + tmpFax;
                        }
                        else if (destination[i].notifyType == 17) {
                            tmpNumericPagerShow = " class = 'ng-show'";
                            tmpInitialContact = "Numeric Pager: " + tmpNumericPager;
                        }
                        else if (destination[i].notifyType == 8) {
                            tmpVoicePagerShow = " class = 'ng-show'";
                            tmpInitialContact = "Voice Pager: " + tmpVoicePager;
                        }
                        else if (destination[i].notifyType == 18) {
                            tmpSmsShow = " class = 'ng-show'";
                            tmpInitialContact = "SMS: " + tmpSms;
                        }

                        if (tmpVoice.length > 0 || (destination[i].notifyType > 10 && destination[i].notifyType < 16)) {
                            tmpColor = tmpVoice.length > 0 ? '' : " style='color: #e75a5a;'";
                            tmpVoice = "<span ntft='" + destination[i].voiceNumberType + "' title='{{translation.text.PHONE}}: " + (tmpVoice.length > 0 ? tmpVoice + '\nType: ' + scope.getVoiceNumberType(destination[i].voiceNumberType) : "{{translation.text.MISSING}}!") + "'" + tmpVoiceShow + "><i ntft='" + destination[i].voiceNumberType + "' class='fa fa-phone fa-lg'" + tmpColor + "></i></span>";
                        }
                        if (tmpEmail.length > 0 || destination[i].notifyType == 2) {
                            tmpColor = tmpEmail.length > 0 ? '' : " style='color: #e75a5a;'";
                            tmpEmail = "<span ntft='2' title='{{translation.text.EMAIL}}: " + (tmpEmail.length > 0 ? tmpEmail : "{{translation.text.MISSING}}!") + "'" + tmpEmailShow + "><i ntft='2' class='fa fa-envelope fa-lg'" + tmpColor + "></i></span>";
                        }
                        if (tmpFax.length > 0 || destination[i].notifyType == 4) {
                            tmpColor = tmpFax.length > 0 ? '' : " style='color: #e75a5a;'";
                            tmpFax = "<span ntft='4' title='{{translation.text.FAX}}: " + (tmpFax.length > 0 ? tmpFax : "{{translation.text.MISSING}}!") + "'" + tmpFaxShow + "><i ntft='4' class='fa fa-fax fa-lg'" + tmpColor + "></i></span>";
                        }
                        if (tmpNumericPager.length > 0 || destination[i].notifyType == 17) {
                            tmpColor = tmpNumericPager.length > 0 ? '' : " style='color: #e75a5a;'";
                            tmpNumericPager = "<span ntft='17' title='{{translation.text.NUMERIC_PAGER}}: " + (tmpNumericPager.length > 0 ? tmpNumericPager : "{{translation.text.MISSING}}!") + "'" + tmpNumericPagerShow + "><i ntft='17' class='fa fa-hdd-o fa-lg'" + tmpColor + "></i></span>";
                        }
                        if (tmpVoicePager.length > 0 || destination[i].notifyType == 8) {
                            tmpColor = tmpVoicePager.length > 0 ? '' : " style='color: #e75a5a;'";
                            tmpVoicePager = "<span ntft='8' title='{{translation.text.VOICE_PAGER}}: " + (tmpVoicePager.length > 0 ? tmpVoicePager : "{{translation.text.MISSING}}!") + "'" + tmpVoicePagerShow + "><i ntft='8' class='fa fa-volume-up fa-lg'" + tmpColor + "></i></span>";
                        }
                        if (tmpSms.length > 0 || destination[i].notifyType == 18) {
                            tmpColor = tmpSms.length > 0 ? '' : " style='color: #e75a5a;'";
                            tmpSms = "<span ntft='18' title='{{translation.text.SMS}}: " + (tmpSms.length > 0 ? tmpSms : "{{translation.text.MISSING}}!") + "'" + tmpSmsShow + " style='width: 24px; height: 23px; padding: 1px;'><i class='fa-stack' style='font-size: x-small; top: -2px;'" + tmpColor + " ntft='18'><i class='fa fa-stack-1x' style='font-size: 7px;'>SMS</i><i class='fa fa-comment-o fa-stack-2x' style='font-size: 20px;'></i></i></span>";
                        }
                        if (destination[i].disabled == 1 || destination[i].onDuty != 1)
                            tmpClass = " destination-disabled";

                        if (_printCycle && _cycleDelay !== 0) {
                            tmpLi = tmpLi + "<li style='width: 100%; padding: 2px 3px; margin: " + (intBr === 0 ? 1 : 10) + "px 0px 1px 0px; font-weight: normal; box-shadow: #515151 1px 1px 1px; text-align: center;' class='cycle' data-item-action='sort'><img src='images/pixel.png' class='ns_pix_30'>-- {{translation.text.DELAY}} <input type='" + scope._getInputTypeNumber() + "' value='" + _cycleDelay + "' min='1' max='120' required ng-disabled='nsBlockBHide'/> {{translation.text.MINUTES_LC}} -- <a href='#' style='font-weight: normal; float: right;' ng-hide='nsBlockBHide'><i class='fa fa-trash clickable' style='font-size: 20px; padding-left: 10px; color: #e75a5a;'  title='{{translation.text.REMOVE}}'></i></a> </li>";
                        }

                        tmpLi = tmpLi + "<li style='width: 100%; padding: 3px 3px 3px 0px; margin-top: 1px;' class='destination" + tmpClass + "' ntf-type='" + destination[i].notifyType + "' data-service-user-id='" + destination[i].serviceUserId + "' data-team='" + destination[i].team + "' data-notification-recipient-id ='" + destination[i].notificationRecipientId + "' data-display-order ='" + destination[i].displayOrder + "' data-item-action='sort' data-delay='" + destination[i].delay + "' data-changed = ''  data-disabled = '" + (destination[i].disabled == 1) + "'><img src='images/pixel.png' class='ns_pix'><a href='#' style='font-size: smaller; float: right; padding: 0px;' data-group-id='" + destination[i].groupId + "' data-cycle='" + destination[i].cycle + "' data-service-user-id='" + destination[i].serviceUserId + "' data-index='" + tmpIndex + "' ng-hide='nsBlockBHide'><i class='fa fa-trash clickable' style='font-size: 20px; padding-left: 10px; color: #E75A5A;' title='{{translation.text.REMOVE}}'></i></a><input type='checkbox' class='form-checkbox' name='onDuty' style='float: right; margin: 2px 10px 0 0;'" + tmpChecked + " ng-hide='nsBlockBHide' title='{{translation.text.ON_DUTY}}'><a id='sendTest' href='#' style='font-size: smaller; float: right; padding: 0px; opacity: " + (destination[i].notifyType == 17 ? "0.5" : "b1lock") + ";' data-group-id='" + destination[i].groupId + "' data-cycle='" + destination[i].cycle + "' data-service-user-id='" + destination[i].serviceUserId + "' data-index='" + tmpIndex + "' ng-hide='nsBlockBHide'><i class='fa fa-telegram clickable' style='font-size: 20px; padding-right: 10px; color: lightslategrey;' title='{{translation.text.TEST}}'></i></a>" +
                           "<button class=\"btn btn-default\" style='float: right; height: 22px; margin: 0 10px 0 0; padding: 3px 6px 3px 6px;' ng-hide='nsBlockBHide'" +
                            "ng-click=\"getTeam()\"" +
                            "uib-popover-template=\"dynamicPopover.templateUrl\"" +
                            "popover-placement=\"left-top\"" +
                            "popover-append-to-body=\"true\"" +
                            "popover-trigger=\"outsideClick\"" +
                            "popover-class=\"popover-team-selection\"" +
                            "popover-title=\"Select Team\"" +
                            "popover-is-open=\"isOpen"+ destination[i].notificationRecipientId +"\"" +
                            "data-team=\"" + destination[i].team + "\"" +
                            "data-notification-recipient-id=\"" + destination[i].notificationRecipientId + "\">" +
                            "<i class=\"fa fa-users\" aria-hidden=\"true\" style=\"color: " + (!(destination[i].team > 0) ? 'lightslategrey' : '') + "\"></i> " +
                            (destination[i].team > 0 ? "Team #" + destination[i].team : '') +
                            " </button>" +
                            " <mcspan title='" + (destination[i].disabled == 1 ? "{{translation.text.INACTIVE_USER}}" : destination[i].onDuty == 1 ? "" : "{{translation.text.OFF_DUTY}}") + "' style='display: inline-block;'>" + destination[i].firstName + " " + destination[i].lastName + "</mcspan>" + tmpFax + tmpEmail + tmpVoice + tmpNumericPager + tmpVoicePager + tmpSms;
                        tmpLi = tmpLi + "<mcspan style='padding-right: 10px; font-size: smaller; font-weight: bold; display: none; float: right;'>" + tmpInitialContact + "</mcspan><br style='clear: both;'>";
                        tmpLi = tmpLi + "</li>";

                        atLeastOneDestination = tmpChecked.length > 0 ? true : atLeastOneDestination;
                    }

                    tmpIndex++;
                }
                //if (atLeastOneDestination)
                //tmpLi = tmpLi + "<li style='width: 100%; padding: 1px 5px; margin: 1px 0px 10px 0px; font-weight: bold; font-size: smaller; box-shadow: #515151 1px 1px 1px; text-align: center;' class='cycle'>---------- Delay <input type='" +scope._getInputTypeNumber() + "' value='" +scope._getCycle(varShiftId, preCycle) + "' min='1' max='120' required /> minutes ---------- <a href='#' style='font-weight: normal; float: right;'><i class='fa fa-times-circle' title='Remove' style='font-size: 16px;color: #e75a5a;'></i></a> </li>";
                tmpLi = tmpLi + "<li class='placeholder sortable-space-highlight' style='background-color:transparent; text-align: center;' ng-hide='nsBlockBHide'>{{translation.text.DRAG_DESTINATION_HERE}}</li>";

                element.append($compile(tmpLi)(scope));
                if (atLeastOneDestination) {
                    scope._markCalendar(varShiftName);
                }
                scope.intBrj++;
            };

            scope.updateTeam = function (event, team) {

                $(element).parents(".ns_schedule_tabs").find("li.destination").each(function (n, v) {
                    if ($(this).attr("data-notification-recipient-id") == scope.dataNotificationRecipientId) {

                        var _li = $(this);
                        var newTeam = _li.attr("data-team") == team ? 0 : team;
                        var buttonHtml = "<i class=\"fa fa-users\" aria-hidden=\"true\" style=\"color: " +
                            (!(newTeam > 0) ? 'lightslategrey' : '') + "\"></i> " +
                            (newTeam > 0 ? "Team #" + newTeam : '');

                        var _button = _li.find("button");
                        _button.html(buttonHtml).attr("data-team", newTeam);
                        _li.attr("data-team", newTeam);

                        scope["isOpen" + scope.dataNotificationRecipientId] = false;

                        $timeout(function () {
                            _li.trigger("click", true);
                        }, 0);

                        return false;
                    }
                });

            };

            scope.getTeam = function (team) {
                scope.availableTeams = [];
                var dataTeam = $(event.currentTarget).attr("data-team");
                var dataNotificationRecipientId = $(event.currentTarget).attr("data-notification-recipient-id");
                scope.tmpTeam = dataTeam;
                scope.dataNotificationRecipientId = dataNotificationRecipientId;
                for (var i = 0; i <= 12; i++) {
                    scope.availableTeams.push(parseInt(i));
                }
            };

            var _newDestinations = [];

            var _lockForEditing = function () {
                scope.lockForEditing = true;
                scope.popup.parent().find(".mc-sortable, .ns_destinations_scroll, .pre-place-team-on-duty").css("pointer-events", "none").css("opacity", ".5");
            };

            var _unlockForEditing = function () {
                scope.lockForEditing = false;
                scope.popup.parent().find(".mc-sortable, .ns_destinations_scroll, .pre-place-team-on-duty").css("pointer-events", "auto").css("opacity", "1");
            };

            _notificationRuleRecipientUpdate = function (newRecord, customerId, recipientId, notifyType, displayOrder, delay, onDuty, team) {

                _lockForEditing();

                notificationRuleRecipientService.putData(customerId, recipientId, notifyType, displayOrder, delay, onDuty, team)
                    .then(function (result) {
                        if (result.data != null) { //newObject (newRecord) gets deleted before it can be updated (specific to Notification Schedule view)
                            newRecord.attr("data-display-order", result.data.displayOrder);
                            newRecord.attr("data-delay", result.data.delay);
                        }
                        //Ok
                        _unlockForEditing();

                    }, function (error) {
                            _unlockForEditing();
                            scope.openErrorModal("Error: 1.1");
                    });
            };

            _notificationRuleRecipientInsert = function (newRecord, customerId, ruleId, scheduleId, serviceUserId, notifyType, displayOrder, delay, onDuty) {

                _lockForEditing();

                notificationRuleRecipientService.postData(customerId, ruleId, scheduleId, serviceUserId, notifyType, displayOrder, delay, onDuty)
                    .then(function (result) {
                        newRecord.attr("data-notification-recipient-id", result.data.id);
                        newRecord.attr("data-display-order", result.data.displayOrder);
                        newRecord.attr("data-delay", result.data.delay);
                        newRecord.find("button").attr("popover-is-open", "isOpen" + result.data.id);
                        newRecord.find("button").attr("data-notification-recipient-id", result.data.id);
                        $compile(newRecord.find("button"))(scope);
                        scope.newInsertedRecipient = result.data;
                        //Ok
                        _unlockForEditing();

                    }, function (error) {
                            _unlockForEditing();
                            scope.openErrorModal("Error: 1.2")
                    });
            };

            _notificationRuleRecipientDelete = function (customerId, recipientId) {

                _lockForEditing();

                notificationRuleRecipientService.deleteData(customerId, recipientId)
                    .then(function (result) {
                        //Ok
                        _unlockForEditing();
                    }, function (error) {
                        _unlockForEditing();
                        scope.openErrorModal("Error: 1.3")
                    });
            };            

            scope.strikeThrough = function (varStrikeThrough) {
                $(element).find("li").each(function (n, v) {

                    if ($(this).hasClass("destination")) {
                        if ($(this).attr("data-disabled") === "false" && !$(this).find('input:checkbox').is(':checked')) {
                            if (varStrikeThrough === true) {
                                $(this).addClass("destination-disabled");
                                $(this).find("mcspan").attr("title", scope.translation.text.OFF_DUTY);
                            } else {
                                $(this).removeClass("destination-disabled");
                                $(this).find("mcspan").attr("title", "");
                            }
                        } else if ($(this).attr("data-disabled") === "true") {
                            $(this).find('input:checkbox').attr("disabled", "true");
                            $(this).find("mcspan").attr("title", scope.translation.text.INACTIVE_USER);
                        }
                    }
                });
            };

            scope.saveEverything = function (varDataItemAction) {
                scope.lockIt();
                var _testOnly = varDataItemAction === "test-only" ? true : false;
                var _testOnlyValid = true;
                var currentDisplayOrder = 0, currentDelay = 0, currentValid;
                var _tmpOnDutyCount = 0;

                var outputTxt = '';
                _newDestinations = [];
                var _newCycles = [];
                var _validationErrors = [];
                var _validationWarnings = [];
                var _validationError4VoiceType = 0;
                var _intLoop = scope.shifts.length;
                var _newDestinationsRecord, _newCyclesRecord, _validationErrorsRecord, _validationWarningsRecord, _newNotificationGroupDestinationsCyclesRecord;
                var _tmpReportClass, _tmpShift, _tmpCycle, _tmpCycleDelay, _tmpNotifyType, _tmpServiceUserId, _tmpCustomerId, _tmpNotificationRecipientId, _tmpDelay, _tmpTeam, _tmpOnDuty, _tmpDisabled, _tmpValue, _tmpGroup, _numberOfRecordsInCycles;
                var _recordKind, _recordAlreadyExist;
                toaster.clear();

                //$(element).sortable({
                //    disabled: true
                //});

                _tmpReportClass = $(element).attr("data-group-id");
                _tmpShift = $(element).attr('class').split(' ').pop();


                $(element).find("li").each(function (n, v) {
                    currentValid = false;
                    _recordKind = "";
                    _tmpCycleDelay = 0;
                    _hasChanged = false;

                    _tmpServiceUserId = $(this).attr("data-service-user-id");
                    _tmpNotifyType = $(this).attr("ntf-type");
                    _tmpCustomerId = scope.accountInfo.customerId;
                    _tmpTeam = $(this).attr("data-team");
                    _tmpOnDuty = $(this).find('input:checkbox').is(':checked') ? true : false;
                    _tmpDisabled = $(this).hasClass('destination-disabled') ? true : false;
                    _tmpOnDutyCount = _tmpOnDuty && !_tmpDisabled ? ++_tmpOnDutyCount : _tmpOnDutyCount;
                    _tmpNotificationRecipientId = $(this).attr("data-notification-recipient-id");
                    _tmpDataChanged = $(this).attr("data-changed");

                    if ($(this).hasClass("cycle")) {
                        _recordKind = "Cycle";
                        _tmpCycleDelay = $(this).find('input').val().replace(/\D/g, '');
                        _tmpCycleDelay = isNaN(_tmpCycleDelay) ? 5 : _tmpCycleDelay < 1 ? 5 : _tmpCycleDelay > 120 ? 10 : _tmpCycleDelay;
                        _tmpCycleDelay = parseInt(_tmpCycleDelay);
                        $(this).find('input').val(_tmpCycleDelay);
                        currentValid = false;
                        _validationError4VoiceType = 0; //new cycle starts
                    } else if ($(this).hasClass("destination")) {
                        _recordKind = "Destination";
                        _displayOrder = $(this).attr("data-display-order");
                        _tmpDelay = $(this).attr("data-delay");
                        currentValid = true;
                    }

                    currentDelay = currentDelay + _tmpCycleDelay;

                    currentDisplayOrder = _recordKind == "Destination" ? currentDisplayOrder + 1 : currentDisplayOrder;

                    if (currentValid) {

                        _validationError4VoiceType = (_tmpNotifyType > 10 && _tmpNotifyType < 16 && _tmpOnDuty && !_tmpDisabled) ? ++_validationError4VoiceType : _validationError4VoiceType;
                        _recordAlreadyExist = scope._findDuplicates(_tmpServiceUserId, currentDelay, _tmpNotifyType, _tmpOnDuty);
                        _newDestinationsRecord = { serviceUserId: _tmpServiceUserId, delay: currentDelay, notifyType: _tmpNotifyType, onDuty: _tmpOnDuty, error: _recordAlreadyExist };
                        _newDestinations.push(_newDestinationsRecord);

                        if (_recordAlreadyExist) {
                            toaster.pop('error', scope.tmpWindowTitle, _testOnly ? scope.translation.text.DUPLICATE_NOTIFICATION_REMOVED : scope.translation.text.DUPLICATE_NOTIFICATION_CORRECT, _testOnly ? 3000 : 0, 'trustedHtml');
                            _testOnlyValid = false;
                            $(this).attr("data-changed", "yes");
                            if (_testOnly) return false;
                            if (!$(this).hasClass("error")) $(this).addClass("error");
                            if (typeof _tmpNotificationRecipientId !== 'undefined' && _tmpNotificationRecipientId !== '') {
                                _notificationRuleRecipientDelete(_tmpCustomerId, _tmpNotificationRecipientId);
                            }
                            $(this).attr("data-notification-recipient-id", "");
                            //$(this).attr("data-display-order", "");
                            //toaster.pop({
                            //    type: 'error',
                            //    title: scope.windowTitle,
                            //    body: "Duplicate user & notification type!<br>" + scope._findUser(_tmpServiceUserId, _tmpNotifyType),
                            //    timeout: 0,
                            //    bodyOutputType: 'trustedHtml',
                            //    toasterId: 1
                            //});
                        }
                        else if (_tmpNotifyType > 10 && _tmpNotifyType < 16 && _tmpOnDuty && !_tmpDisabled && _validationError4VoiceType > scope.numberOfPhoneCallsPerCycle) {
                            toaster.pop('error', scope.tmpWindowTitle, _testOnly ? scope.translation.text.VOICE_CALL_LIMIT_REMOVED : scope.translation.text.VOICE_CALL_LIMIT_CORRECT, _testOnly ? 3000 : 0, 'trustedHtml');
                            _testOnlyValid = false;
                            $(this).attr("data-changed", "yes");
                            if (_testOnly) return false;
                            if (!$(this).hasClass("error")) $(this).addClass("error");
                            if (typeof _tmpNotificationRecipientId !== 'undefined' && _tmpNotificationRecipientId !== '') {
                                _notificationRuleRecipientDelete(_tmpCustomerId, _tmpNotificationRecipientId);
                            }
                            $(this).attr("data-notification-recipient-id", "");
                            //$(this).attr("data-display-order", "");
                            //toaster.pop({
                            //    type: 'error',
                            //    title: scope.windowTitle,
                            //    body: "Duplicate user & notification type!<br>" + scope._findUser(_tmpServiceUserId, _tmpNotifyType),
                            //    timeout: 0,
                            //    bodyOutputType: 'trustedHtml',
                            //    toasterId: 1
                            //});
                        }
                        else {
                            _testOnlyValid = true;
                            if (_testOnly) return true;
                            if ($(this).hasClass("error")) $(this).removeClass("error");
                            if (_displayOrder != currentDisplayOrder) {
                                _hasChanged = true;
                            }
                            if (_tmpDelay != currentDelay) {
                                _hasChanged = true;
                            }
                            if (_tmpDataChanged) {
                                _hasChanged = true;
                            }

                            if (_hasChanged && (typeof _tmpNotificationRecipientId === 'undefined' || _tmpNotificationRecipientId == '')) {
                                _notificationRuleRecipientInsert($(this), _tmpCustomerId, scope.ruleId, _tmpReportClass, _tmpServiceUserId, _tmpNotifyType, currentDisplayOrder, currentDelay, _tmpOnDuty);
                            } else if (_hasChanged) {
                                _notificationRuleRecipientUpdate($(this), _tmpCustomerId, _tmpNotificationRecipientId, _tmpNotifyType, currentDisplayOrder, currentDelay, _tmpOnDuty, _tmpTeam);
                            }
                            
                            $(this).attr("data-changed", "");
                        }
                    }
                });

                if (_tmpOnDutyCount > 0) {
                    scope._markCalendar(_tmpShift);
                } else {
                    scope._checkSchedule(_tmpShift, _tmpOnDutyCount);
                }

                if (varDataItemAction !== 'test-only') {
                    $rootScope.$broadcast('changeNotificationScheduleOrRule', scope.ruleId);
                    scope.unlockIt();
                    $timeout(function () {
                        scope.getIfRuleIsWithNoSmsOrEmailInFront(scope.activeTab);
                    }, 2000);                    
                }
                return _testOnlyValid;

                if (scope.checked)
                    _intLoop = 1;

                var intBr = 0;
                var i;
                for (i = (_intLoop - 1); i < scope.shifts.length; i++) {
                    _tmpReportClass = $(element).parents("span").find(".mc-sortable." + scope.shifts[i].name).attr("data-group-id");
                    _tmpCycle = 1;
                    _numberOfRecordsInCycles = 0
                    $(element).each(function (n, v) {
                        if ($(this).hasClass("cycle")) {
                            _recordKind = "Cycle";
                            outputTxt += $(this).text() + '\n';
                            _tmpValue = $(this).find('input').val();
                            if (!(_tmpValue >= 1 && _tmpValue <= 120)) {
                                _tmpGroup = scope.checked ? scope.shifts[i].descriptionAlternate : scope.shifts[i].description;
                                _validationErrorsRecord = { group: _tmpGroup, cycle: _tmpCycle, errorDescription: "Expected Delay 1-120 minutes." };
                                _validationErrors.push(_validationErrorsRecord);
                            }
                            _newCyclesRecord = { customerId: scope.accountInfo.customerId, groupId: _tmpReportClass, cycle: _tmpCycle, value: _tmpValue };
                            _newCycles.push(_newCyclesRecord);
                            if (_validationError4VoiceType > 4) {
                                _tmpGroup = scope.checked ? scope.shifts[i].descriptionAlternate : scope.shifts[i].description;
                                _validationErrorsRecord = { group: _tmpGroup, cycle: _tmpCycle, errorDescription: "Four phone calls per cycle allowed!<br>You have setup <b>" + _validationError4VoiceType + "</b>." };
                                _validationErrors.push(_validationErrorsRecord);
                            }
                            _validationError4VoiceType = 0;
                            _tmpCycle++
                        }
                        else if ($(this).hasClass("placeholder")) {
                            // _tmpCycle++
                            // _recordKind = "Placeholder";
                        }
                        else {
                            _recordKind = "Destination";
                            outputTxt += $(this).text() + '\n';
                            _tmpNotifyType = $(this).attr("ntf-type");
                            if (_tmpNotifyType > 10 && _tmpNotifyType < 16)
                                _validationError4VoiceType++;
                            _tmpServiceUserId = $(this).attr("data-service-user-id");
                            _tmpTeam = $(this).attr("data-team");
                            _tmpOnDuty = $(this).find('input:checkbox').is(':checked') ? 1 : 0;
                            _tmpGroup = scope.checked ? scope.shifts[i].descriptionAlternate : scope.shifts[i].description;

                            if (scope._findDuplicates(_tmpReportClass, _tmpCycle, _tmpNotifyType, _tmpServiceUserId)) {
                                _validationErrorsRecord = { group: _tmpGroup, cycle: _tmpCycle, errorDescription: "Duplicate user & notification type!<br>" + scope._findUser(_tmpServiceUserId, _tmpNotifyType) };
                                var _varAddError = false;
                                for (var z = 0; z < _validationErrors.length; z++) {
                                    if (_validationErrors[z].group == _tmpGroup && _validationErrors[z].cycle == _tmpCycle && _validationErrors[z].errorDescription == "Duplicate user & notification type!<br>" + scope._findUser(_tmpServiceUserId, _tmpNotifyType)) {
                                        _varAddError = true;
                                        break;
                                    }
                                }
                                if (!_varAddError)
                                    _validationErrors.push(_validationErrorsRecord);
                            }

                            _newDestinationsRecord = { groupId: _tmpReportClass, cycle: _tmpCycle, notifyType: _tmpNotifyType, serviceUserId: _tmpServiceUserId, customerId: scope.accountInfo.customerId, team: _tmpTeam, onDuty: _tmpOnDuty };
                            _newDestinations.push(_newDestinationsRecord);
                            _numberOfRecordsInCycles++;
                            //console.log(_newDestinationsRecord);
                        }
                    });
                    intBr++;
                    outputTxt += '\n' + '###########################' + '\n' + '\n';

                    if (intBr > 0 && _recordKind != "Cycle") {
                        _tmpGroup = scope.checked ? scope.shifts[i].descriptionAlternate : scope.shifts[i].description;
                        if (_validationError4VoiceType > 4) {
                            _validationErrorsRecord = { group: _tmpGroup, cycle: _tmpCycle, errorDescription: "Four phone calls per cycle allowed!<br>You have setup <b>" + _validationError4VoiceType + "</b>." };
                            _validationErrors.push(_validationErrorsRecord);
                        }
                        if (_numberOfRecordsInCycles > 0) {
                            _validationErrorsRecord = { group: _tmpGroup, cycle: _tmpCycle, errorDescription: "Missing Cycle Delay value at the very end of group " + _tmpGroup + "!" };
                            _validationErrors.push(_validationErrorsRecord);
                        }
                        _validationError4VoiceType = 0;
                    }

                }

                if (!scope.checked) {
                    if (scope.shift247 == 0) {
                        _validationWarningsRecord = { warningDescription: "You don't have coverage for <b>" + scope.shifts[3].description + "</b>!" };
                        _validationWarnings.push(_validationWarningsRecord);
                    }
                }
                else {
                    if (scope.shift247 == 0) {
                        if (scope.shiftDays == 0) {
                            _validationWarningsRecord = { warningDescription: "You don't have coverage for <b>" + scope.shifts[0].descriptionAlternate + "</b>!" };
                            _validationWarnings.push(_validationWarningsRecord);
                        }
                        if (scope.shiftNights == 0) {
                            _validationWarningsRecord = { warningDescription: "You don't have coverage for <b>" + scope.shifts[1].descriptionAlternate + "</b>!" };
                            _validationWarnings.push(_validationWarningsRecord);
                        }
                        if (scope.shiftWeekends == 0) {
                            _validationWarningsRecord = { warningDescription: "You don't have coverage for <b>" + scope.shifts[2].descriptionAlternate + "</b>!" };
                            _validationWarnings.push(_validationWarningsRecord);
                        }
                    }
                }

                toaster.clear();

                for (var k = 0; k < _validationWarnings.length; k++) {
                    toaster.pop('warning', scope.windowTitle, _validationWarnings[k].warningDescription, 15000, 'trustedHtml');
                }
                scope.$apply();

                if (_validationErrors.length > 0) {
                    var varMessage = "";
                    for (var j = 0; j < _validationErrors.length; j++) {
                        varMessage += (j + 1) + ". Group: <b>" + _validationErrors[j].group + "</b>, " + "Cycle: <b>" + _validationErrors[j].cycle + "<br>" + _validationErrors[j].errorDescription;
                        varMessage += j != (_validationErrors.length - 1) ? "<hr>" : "";
                    }
                    toaster.pop('error', scope.windowTitle, varMessage, 0, 'trustedHtml');
                    scope.$apply();
                }
                else {
                    scope.$apply();
                }
            };

            scope._findDuplicates = function (varServiceUserId, varDelay, varNotifyType, varOnDuty) {
                for (var i = 0; i < _newDestinations.length; i++) {
                    if (_newDestinations[i].serviceUserId === varServiceUserId && _newDestinations[i].delay === varDelay && _newDestinations[i].notifyType === varNotifyType) {
                        return true;
                    }
                }
                return false;
            };

            scope._findUser = function (varServiceUserId, varNotifyType) {
                var _tmpNotyfyType = "(" + varServiceUserId + ", " + varNotifyType + ")";
                for (var i = 0; i < scope.serviceUserData.length; i++) {
                    if (scope.serviceUserData[i].serviceUserId == varServiceUserId) {
                        switch (varNotifyType) {
                            case "11":
                            case "12":
                            case "13":
                            case "14":
                            case "15":
                                _tmpNotyfyType = "Phone: " + scope.serviceUserData[i].voiceNumber;
                                break;
                            case "2":
                                _tmpNotyfyType = "Email: " + scope.serviceUserData[i].email;
                                break;
                            case "4":
                                _tmpNotyfyType = "Fax: " + scope.serviceUserData[i].fax;
                                break;
                            case "18":
                                _tmpNotyfyType = "SMS: " + scope.serviceUserData[i].countryCode + "-" + scope.serviceUserData[i].smsNumber;
                                break;
                            default:
                                _tmpNotyfyType = "?";
                        }
                        return scope.serviceUserData[i].firstName + " " + scope.serviceUserData[i].lastName + "<br>" + _tmpNotyfyType;
                        break;
                    }
                }
                return _tmpNotyfyType;
            };

            /////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////

            var step = 5;
            var parentHeight = element.parent().css("height");
            var _startDown, _startUp;
            var _checkStartDown = function () {
                // Don't start if already started
                if (angular.isDefined(_startDown)) return;
                _startDown = $interval(function () {
                    element.parent().animate({
                        scrollTop: "+=" + step + "px"
                    }, 50);
                }, 50);
            };
            var _checkStartUp = function () {
                // Don't start if already started
                if (angular.isDefined(_startUp)) return;
                _startUp = $interval(function () {
                    element.parent().animate({
                        scrollTop: "-=" + step + "px"
                    }, 50);
                }, 50);
            }; 

            scope.checkMethod = function (_tmpServiceUserId, _tmpNotificationType) {
                _tmpNotificationType = parseInt(_tmpNotificationType);
                var _voiceNumber, _fax, _voicePager, _email, _firstName, _lastName, _sms;

                for (var i = 0; i < scope.serviceUserData.length; i++) {
                    if (scope.serviceUserData[i].serviceUserId == _tmpServiceUserId) {
                        _voiceNumber = scope.serviceUserData[i].voiceNumber;
                        _fax = scope.serviceUserData[i].fax;
                        _voicePager = scope.serviceUserData[i].voicePager;
                        _email = scope.serviceUserData[i].email;
                        _firstName = scope.serviceUserData[i].firstName;
                        _lastName = scope.serviceUserData[i].lastName;
                        _sms = scope.serviceUserData[i].countryCode + "-" + scope.serviceUserData[i].smsNumber;
                        break;
                    }
                }
                
                var _sendType, _sendSubType, _sendData, _sendToPath, _methodDescription;

                switch (_tmpNotificationType) {
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15: //voiceNumber
                        _sendType = 4;
                        _sendSubType = 0;
                        _sendToPath = _voiceNumber;
                        _sendData = "This is a test message to verify your phone number.";
                        _methodDescription = "Phone";
                        break;
                    case 4: //fax
                        _sendType = 0;
                        _sendSubType = 1;
                        _sendToPath = _fax;
                        _sendData = "";
                        _methodDescription = "Fax";
                        break;
                    case 8: //voicePager
                        _sendType = 0;
                        _sendSubType = 1;
                        _sendToPath = _voicePager;
                        _sendData = "";
                        _methodDescription = "Voice Pager";
                        break;
                    case 2: //email
                        _sendType = 1;
                        _sendSubType = 1;
                        _sendToPath = _email;
                        _sendData = "This message is for " + _firstName + " " + _lastName + " at " + scope.accountInfo.customerName + ".";
                        _methodDescription = "Email";
                        break;
                    case 17: //numericPager, not available for testing 
                        toaster.pop('error', "Destination Method Check", "Numeric Pager testing is not supported.");
                        return;
                    case 18: //SMS, not available for testing 
                        _sendType = 18;
                        _sendSubType = 0;
                        _sendToPath = _sms.replace(/[^0-9]/g, '');
                        _sendData = "This is SMS test message to verify your phone number.";
                        _methodDescription = "SMS";
                        break;
                }
                
                var tmpDestinationMethodCheck = {
                    DestinationMethodId: 0,
                    CustomerId: scope.accountInfo.customerId,
                    SendType: _sendType,
                    SendSubType: _sendSubType,
                    RepType: 200,
                    SubRepType: 0,
                    AckRequired: 1,
                    SendData: _sendData,
                    SendTo: _firstName + " " + _lastName,
                    SendToPath: _sendToPath,
                    MethodDescription: _methodDescription
                };
                var _destinations = new DestinationsFactory(scope.accountInfo.customerId);
                _destinations.checkDm(tmpDestinationMethodCheck).then(function () {
                    toaster.pop('success', "Destination Method Check", "Destination Method Check Sent.");
                }, function (resp) {
                    toaster.pop('error', "Destination Method Check", "Error!");
                    scope.openErrorModal("Error: 1.9")
                });
            }

            scope.$watch('groupSelected', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    //element.empty();
                    //element.append("<li class='placeholder' style='background-color:transparent;'>Add your destinations here</li>");
                }
            }, true);

            scope.$watch('checked', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    //element.not(".Shift247").empty();
                    //element.not(".Shift247").append("<li class='placeholder' style='background-color:transparent;'>Add your destinations here</li>");
                }
            }, true);
        }
    };
}]);

mcapp.directive('notificationScheduleTabs', ["$document", "toaster", function ($document, toaster) {
    return {
        // A = attribute, E = Element, C = Class and M = HTML Comment
        restrict: 'A',
        //The link function is responsible for registering DOM listeners as well as updating the DOM.
        link: function (scope, element, attrs) {
            var _runTabs = 0;

            scope._getDestination = function (varGroup, varCycle, varServiceUserId) {
                for (var j = 0; j < scope.notificationGroupDestinations.length; j++) {
                    if (scope.notificationGroupDestinations[j].groupId == varGroup && scope.notificationGroupDestinations[j].cycle == varCycle && scope.notificationGroupDestinations[j].serviceUserId == varServiceUserId) {
                        var el = $("<li style='width: 100%; padding: 3px 3px 3px 0px;' class='ui-state-active'><input type='checkbox' name='onDuty' checked> " + scope.notificationGroupDestinations[j].firstName + " " + scope.notificationGroupDestinations[j].lastName + "&nbsp;</li>");
                        $("<a href='#' style='font-size: smaller; float: right; padding: 0px 0px 0px 20px;'><i class='fa fa-trash fa-fw'></i> Remove</a> ").click(function () { el.remove(); }).prependTo(el);
                        return el;
                    }
                }
            };

            scope.getShiftIndexByActiveTabId = function (activeTabId) {
                switch (activeTabId) {
                    case 0: //Days
                        return 1;
                        break;
                    case 1: //Nights
                        return 2;
                        break;
                    case 2: //Weekends
                        return 3
                        break;
                    case 3: //Catch-all (Default)
                        return 0;
                        break;
                    default: //Catch-all (Default)
                        return 0;
                }
            }

            scope.getShiftIdByActiveTabId = function (activeTabId) {
                switch (activeTabId) {
                    case 0: //Days
                        return 4;
                        break;
                    case 1: //Nights
                        return 3;
                        break;
                    case 2: //Weekends
                        return 2
                        break;
                    case 3: //Catch-all (Default)
                        return 1;
                        break;
                    default: //Catch-all (Default)
                        return 1;
                }
            }

            scope.getShiftNameByActiveTabId = function (activeTabId) {
                switch (activeTabId) {
                    case 0: //Days
                        return scope.translation.text.DAYS;
                        break;
                    case 1: //Nights
                        return scope.translation.text.NIGHTS;
                        break;
                    case 2: //Weekends
                        return scope.translation.text.WEEKENDS
                        break;
                    case 3: //Catch-all (Default)
                        return scope.translation.text.CATCH_ALL;
                        break;
                    default: //Catch-all (Default)
                        return scope.translation.text.CATCH_ALL;
                }
            }

            scope.getIfRuleIsWithNoSmsOrEmailInFront = function (activeTabIndex) {

                var activeTabId = !angular.isUndefined(activeTabIndex) ? activeTabIndex : scope.activeTabClassIndex;
                var recipients = [];
                var activeTabClassName = scope.activeTabClass[activeTabId];

                $(element).closest(".ns_schedule_tabs").find("." + activeTabClassName).find("li.destination").each(function (n, v) {

                    var _li = $(this);                    
                    var _disabled = (_li.attr("data-disabled") == "false") ? false : true;
                    var _onDuty = (_li.find('input').is(':checked') == false) ? false : true;
                    var _notifyType = _li.attr("ntf-type");
                    var _delay = _li.attr("data-delay");

                    recipients.push({
                        disabled: _disabled,
                        onDuty: _onDuty,
                        notifyType: _notifyType,
                        delay: _delay
                    });

                });

                var filterSmsOrEmail = [];
                var firstActiveDelay = 0

                function isActive(item) {
                    return item.disabled == false && item.onDuty == true;
                }

                function isSmsOrEmail(item) {
                    return item.delay == firstActiveDelay && (item.notifyType == 18 || item.notifyType == 2);
                }

                var filteredActive = recipients.filter(isActive); 

                if (filteredActive.length > 0) {
                    firstActiveDelay = filteredActive[0].delay;
                    filterSmsOrEmail = filteredActive.filter(isSmsOrEmail); 
                }

                if (filteredActive.length > 0 && filterSmsOrEmail.length == 0) {
                    var errormsg = "<b>" + scope.getShiftNameByActiveTabId(activeTabId) + "</b>" + ": SMS or Email needed!" + "<br>" + "SMS and email destinations supply the most rapid alarms and should be included in the first cycle. Other notification destinations, such as voice calls, are best used as secondary notifications.";
                    toaster.pop('warning', scope.tmpWindowTitle, errormsg, 30000, 'trustedHtml');
                }

            }; 

            element.tabs({
                activate: function (event, ui) {
                    scope.activeTab = ui.newTab.index();
                    //console.log(scope.activeTab);
                    scope.getIfRuleIsWithNoSmsOrEmailInFront(scope.activeTab);
                }
            });

            scope.toggleScheduleFn = function () {
                scope.toggleSchedule = !scope.toggleSchedule;
                switch (scope.toggleSchedule) {
                    case true:
                        if ($(element).hasClass('ns_schedule_tabs')) { 
                            $(element).addClass("ns_schedule_tabs_overwrite");
                            $(element).removeClass("ns_schedule_tabs");
                        }
                        $(element).find('.ns_tabs').addClass("ns_tabs_overwrite").removeClass("ns_tabs");
                        $(element).children('div').each(function () {
                            $(this).children('div').each(function () {
                                if ($(this).hasClass('ns_tabs_div')) {
                                    $(this).addClass("ns_tabs_div_overwrite");
                                    $(this).removeClass("ns_tabs_div");
                                }
                                $(this).children('ul').each(function () {
                                    if ($(this).hasClass('ui-state-default_ns')) {
                                        $(this).addClass("ui-state-default_ns_overwrite");
                                        $(this).removeClass("ui-state-default_ns");
                                    }
                                });
                            });
                        });
                        break;
                    case false:
                        if ($(element).hasClass('ns_schedule_tabs_overwrite')) {
                            $(element).addClass("ns_schedule_tabs");
                            $(element).removeClass("ns_schedule_tabs_overwrite");
                        }
                        $(element).find('.ns_tabs_overwrite').addClass("ns_tabs").removeClass("ns_tabs_overwrite");
                        $(element).children('div').each(function () {
                            $(this).children('div').each(function () {
                                if ($(this).hasClass('ns_tabs_div_overwrite')) {
                                    $(this).addClass("ns_tabs_div");
                                    $(this).removeClass("ns_tabs_div_overwrite");
                                }
                                $(this).children('ul').each(function () {
                                    if ($(this).hasClass('ui-state-default_ns_overwrite')) {
                                        $(this).addClass("ui-state-default_ns");
                                        $(this).removeClass("ui-state-default_ns_overwrite");
                                    }
                                });
                            });
                        });
                        break;
                    default:
                        return;
                }
                scope.adjustViewSize();
            };

            scope.fnRemoveLi = function ($event) {
                $(event.currentTarget).parent().remove();
            };

            scope.fnUpdateContactType = function ($event) {
                $event.stopPropagation();
                $document.children().find('span').bind('click', function (event) {
                    $event.stopPropagation();
                });
            };

            scope.$on('ngRepeatFinished', function () {
                if (typeof scope.shifts !== "undefined" && scope.shifts.length == 4) {
                    element.tabs({ heightStyle: "content" }).addClass("ui-widget-content_ns");
                    setTimeout(function () {
                        if (angular.isDefined(scope.activeTab)) {
                            element.tabs("option", "active", scope.activeTab);
                            scope.activeTab = undefined;
                        }
                        else {
                            element.tabs("option", "active", scope.activeTab);
                        }
                        scope.loadingInProgress = false;
                        scope.savingInProgress = false;
                        scope.$apply();
                    }, 0);
                    _runTabs++;
                }
                if (typeof element.tabs("instance") !== 'undefined') {
                    var tmpTricky = scope.activeTab;
                    element.tabs("refresh");
                    scope.activeTab = tmpTricky;
                }
            });

            //setTimeout(function () {
            //element.tabs({ heightStyle: "content" }).addClass("ui-widget-content_ns");
            //}, 0);


            scope.$watch('groupSelected', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    element.tabs("option", "active", 3);
                }
            }, true);

            scope.$watch('checked', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    if (!newValue) {
                        element.tabs("option", "active", 3);
                    }
                    else {
                        element.tabs("option", "active", 0);
                    }
                }
            }, true);
        }
    };
}]);

mcapp.directive('notificationScheduleDropdown', ["testFactory", "notificationGroupsService", "notificationGroupDestinationsService", "toaster", "notificationRuleService", "sharedSetupService", "openViewService", function (testFactory, notificationGroupsService, notificationGroupDestinationsService, toaster, notificationRuleService, sharedSetupService, openViewService) {
    return {
        // A = attribute, E = Element, C = Class and M = HTML Comment
        restrict: 'A',
        //The link function is responsible for registering DOM listeners as well as updating the DOM.
        link: function (scope, element, attrs) {
            scope.countF = testFactory.getDivId();
            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.stickyProperties.deviceId, windowId: scope.windowId });

            notificationRuleService.getData(scope.accountInfo.customerId, scope.stickyProperties.deviceId, false, true).then(function (result) {

                scope.ruleName = result.data.rules[0].ruleId == 0 ? scope.translation.text.ALL_ALARMS : result.data.rules[0].name;
                scope.setViewTitle(scope.ruleName);

                scope.ruleId = result.data.rules[0].ruleId;
                scope.recipientList = [];
                var _defaultShift;

                var _tmpActiveTab = -1;
                for (var j = 0; j < result.data.rules[0].shifts.length; j++) {
                    var _group = result.data.rules[0].shifts[j];
                    var _groupId = _group.shiftId;
                    var _scheduleType = _group.shiftId;

                    if (j === 0) {
                        _defaultShift = result.data.rules[0].shifts[j].shiftId;
                        scope.notificationGroupsData.push({ id: result.data.rules[0].shifts[j].shiftId, description: result.data.rules[0].shifts[j].name, subgroup: 0 });
                    }
                    if (j > 0) {
                        scope.threeShifts.push(result.data.rules[0].shifts[j].name); // = ["Days", "Nights", "Weekends"];
                        scope.threeNewShifts.push(result.data.rules[0].shifts[j].shiftId); // = [9, 10, 11];
                        scope.notificationGroupsData.push({ id: result.data.rules[0].shifts[j].shiftId, description: result.data.rules[0].shifts[j].name, subgroup: result.data.rules[0].shifts[0].shiftId });
                    }
                     
                    var _cycle = 0, _delay = 0, _serviceUserDelay = 0, _tmpDelay;
                    for (var i = 0; i < _group.destinations.length; i++) {
                        _tmpActiveTab = _tmpActiveTab > -1 ? _tmpActiveTab : (j == 0) ? 3 : j - 1;
                        var _recipient = _group.destinations[i];
                        _recipient["groupId"] = _groupId;
                        _recipient["scheduleType"] = _scheduleType;

                        _tmpDelay = _recipient["delay"];

                        if (_delay != _tmpDelay) {
                            _cycle++;
                            _serviceUserDelay = _serviceUserDelay + _tmpDelay;
                            _delay = _tmpDelay;
                        }

                        //-/console.log(_groupId, _serviceUserDelay, _tmpDelay);
                        //_recipient["delay"] = _serviceUserDelay;
                        _recipient["cycle"] = _cycle;
                        //_recipient["onDuty"] = 1;
                        _recipient["disabled"] = _recipient["disabled"];
                        _recipient["notificationRecipientId"] = _recipient["id"];

                        _recipient["voiceNumber"] = _recipient["voiceNumber1"] + '';
                        _recipient["voiceNumberType"] = _recipient["voiceNumber1Type"] + '';

                        _recipient["fax"] = _recipient["fax"] + '';
                        _recipient["email"] = _recipient["email"] + '';

                        _recipient["firstName"] = _recipient["firstName"];
                        _recipient["lastName"] = _recipient["lastName"];

                        _recipient["numericPager"] = _recipient["vPagerNum"];
                        _recipient["voicePager"] = _recipient["vvPagerNum"];

                        _recipient["countryCode"] = _recipient["countryCode"] + '';
                        _recipient["smsNumber"] = _recipient["smsNumber"] + '';


                        _recipient["notifyType"] = _recipient["notifyType"];

                        scope.recipientList.push(_recipient);

                        scope.notificationGroupCycles.push({
                            groupId: _groupId,
                            cycle: _cycle,
                            value: _delay,
                            customerId: 0
                        });
                    }
                }

                scope.notificationGroupDestinations = scope.recipientList;
                //console.log(scope.recipientList);
                //scope.notificationGroupCycles = [];
                scope.activeTab = _tmpActiveTab; //scope._getCheck();
                scope.activeTabClassIndex = scope.activeTab === -1 ? 3 : scope.activeTab;
                scope.fnSubgroups(_defaultShift); //scope.fnSubgroups(scope.notificationGroupsData[0].id);
            }, function (error) {
                scope.openErrorModal("Error: 1.4")
            });
        }
    };
}]);

mcapp.directive('notificationSchedule', ["toaster", "notificationGroupDestinationsService", "serviceUserService", "manageScheduleFactory", "scheduleGridFactory", "$filter", function (toaster, notificationGroupDestinationsService, serviceUserService, manageScheduleFactory, scheduleGridFactory, $filter) {
    return {
        // A = attribute, E = Element, C = Class and M = HTML Comment
        restrict: 'A',
        templateUrl: 'ui/notification/manageschedule/manage-schedule-template.html',
        //The link function is responsible for registering DOM listeners as well as updating the DOM.
        link: function (scope, element, attrs) {

            scope.$ctrl = scope;
            scope.$ctrl.blEditCalendar = false;
            var scheduleGrid = new scheduleGridFactory();
            scope.$ctrl.timeGrid = scheduleGrid.timeGrid;
            scope.$ctrl.days = scheduleGrid.days;
            scope.$ctrl.hours = scheduleGrid.hours;

            scope.$ctrl.preferredTimeFormat = scope.accountInfo.preferenceUser.timeFormat;
            scope.$ctrl.timeFormat = scope.$ctrl.preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
            scope.$ctrl.hourToSendLocalTimes = [];

            var _hourToSendLocalTimes = function () {
                var len = arguments.length,
                    i = 0;
                var tmpLength = scope.$ctrl.hourToSendLocalTimes.length;
                for (i = 0; i < len; i++) {
                    if (tmpLength == 0) {
                        scope.$ctrl.hourToSendLocalTimes.push(arguments[i]);
                    } else {
                        scope.$ctrl.hourToSendLocalTimes[i].name = arguments[i].name;
                    }
                }
            };

            scope.$ctrl.initializeSetting = function () {
                scope.$ctrl.dt = new Date();
                _hourToSendLocalTimes(
                    {
                        "id": 24,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(24, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 1,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(1, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 2,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(2, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 3,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(3, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 4,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(4, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 5,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(5, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 6,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(6, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 7,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(7, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 8,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(8, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 9,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(9, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 10,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(10, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 11,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(11, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 12,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(12, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 13,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(13, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 14,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(14, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 15,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(15, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 16,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(16, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 17,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(17, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 18,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(18, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 19,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(19, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 20,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(20, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 21,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(21, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 22,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(22, 0), scope.$ctrl.timeFormat)
                    },
                    {
                        "id": 23,
                        "name": $filter('date')(scope.$ctrl.dt.setHours(23, 0), scope.$ctrl.timeFormat)
                    }
                );
            };

            scope.$ctrl.initializeSetting();

            //$(element).tooltip({
            //    track : true,
            //    tooltipClass: 'tooltip-jq',
            //    content: function () {
            //        return $(this).prop('title');
            //    }
            //});

            scope.$watch('shift247', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    //console.log(newValue, oldValue);
                }
            }, true);

            // instantiate a new schedule
            var scheduleManager = new manageScheduleFactory(scope.accountInfo.customerId);

            scheduleManager.getCalendar().then(function () {
                scope.savedSchedule = scheduleManager.calendarSchedule;
            }, function (resp) {
                    scope.openErrorModal("Error: 1.10")
            });

            scope._markCalendar = function (varShiftName) {
                //if (scope.shift247 +scope.shiftDays +scope.shiftNights +scope.shiftWeekends == 4)
                //       return;
                switch (varShiftName) {
                    case "Shift247":
                        if (scope.shift247 === 0) {
                            scope.shift247 = 1;
                            for (var i = 0; i < scope.savedSchedule.events.length; i++) {
                                if (scope.savedSchedule.events[i].typeId === 1) scheduleGrid.paintGrid(element, scope.savedSchedule.events[i].dayOfWeek, scope.savedSchedule.events[i].typeId, scope.savedSchedule.events[i].startTime, scope.savedSchedule.events[i].endTime);
                            }
                            scope._markCalendarNewCorrect();
                        }
                        break;
                    case "Days":
                        if (scope.shiftDays === 0) {
                            scope.shiftDays = 1;
                            if (scope.checked === true) {
                                for (var i = 0; i < scope.savedSchedule.events.length; i++) {
                                    if (scope.savedSchedule.events[i].typeId === 2) scheduleGrid.paintGrid(element, scope.savedSchedule.events[i].dayOfWeek, scope.savedSchedule.events[i].typeId, scope.savedSchedule.events[i].startTime, scope.savedSchedule.events[i].endTime);
                                }
                            }
                        }
                        break;
                    case "Nights":
                        if (scope.shiftNights === 0) {
                            scope.shiftNights = 1;
                            if (scope.checked === true) {
                                //scope._markNights();
                                for (var i = 0; i < scope.savedSchedule.events.length; i++) {
                                    if (scope.savedSchedule.events[i].typeId === 3) scheduleGrid.paintGrid(element, scope.savedSchedule.events[i].dayOfWeek, scope.savedSchedule.events[i].typeId, scope.savedSchedule.events[i].startTime, scope.savedSchedule.events[i].endTime);
                                }
                            }
                        }
                        break;
                    case "Weekends":
                        if (scope.shiftWeekends === 0) {
                            scope.shiftWeekends = 1;
                            if (scope.checked === true) {
                                //scope._markWeekends();
                                for (var i = 0; i < scope.savedSchedule.events.length; i++) {
                                    if (scope.savedSchedule.events[i].typeId === 4) scheduleGrid.paintGrid(element, scope.savedSchedule.events[i].dayOfWeek, scope.savedSchedule.events[i].typeId, scope.savedSchedule.events[i].startTime, scope.savedSchedule.events[i].endTime);
                                }
                            }
                        }
                        break;
                    default:
                        return;
                }
            };

            scope._clearShifts = function () {
                $(element).find('[data-day]').removeClass('selectedD').removeClass('selectedN').removeClass('selectedW');
            };


            scope._markCalendarNewCorrect = function () {
                if (scope.shiftDays === 1) {
                    scope.shiftDays = 0;
                    scope._markCalendar("Days");
                }
                if (scope.shiftNights === 1) {
                    scope.shiftNights = 0;
                    scope._markCalendar("Nights");
                }
                if (scope.shiftWeekends === 1) {
                    scope.shiftWeekends = 0;
                    scope._markCalendar("Weekends");
                }
            };

            scope._markCalendarNewCorrect247 = function () {
                if (scope.shift247 === 1) {
                    scope.shift247 = 0;
                    scope._markCalendar("Shift247");
                }
            };

            scope._checkSchedule = function (varClass, varUL) {
                switch (varClass + "" + varUL) {
                    case "Shift2470":
                        $(element).find('[data-day]').removeClass('selected');
                        scope.shift247 = 0;
                        break;
                    case "Days0":
                        $(element).find('[data-day]').removeClass('selectedD');
                        scope.shiftDays = 0;
                        scope._markCalendarNewCorrect247();
                        break;
                    case "Nights0":
                        $(element).find('[data-day]').removeClass('selectedN');
                        scope.shiftNights = 0;
                        scope._markCalendarNewCorrect247();
                        break;
                    case "Weekends0":
                        $(element).find('[data-day]').removeClass('selectedW');
                        scope.shiftWeekends = 0;
                        scope._markCalendarNewCorrect247();
                        break;
                    default:
                        return;
                }
            };

            scope.$on('updateNotificationSchedule', function (event, args) {
                scope.savedSchedule = args;
                scope._clearShifts();
                if (scope.shift247 === 1) {
                    scope.shift247 = 0;
                    scope._markCalendar("Shift247");
                }
                scope._markCalendarNewCorrect();
            });

            scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
                scope.$ctrl.timeFormat = timeFormat === 1 ? "hh:mm a" : "HH:mm";
                scope.$ctrl.initializeSetting();

            });

            scope.$on('updatePreferencesLanguage', function () {
                scope.$ctrl.initializeSetting();
            });
        }
    };
}]);

mcapp.factory("notificationRuleRecipientService", ['$http', 'HOST', function ($http, HOST) {
    var notificationRuleRecipientFactory = {};

    var _getData = function (customerId, ruleId) {
        return $http({
            method: "Get",
            url: HOST + "/api/Notifications/NotificationRuleRecipient?" + "customerId=" + customerId + "&ruleId=" + ruleId,
            cache: false
        });
    };

    var _postData = function (customerId, ruleId, scheduleId, serviceUserId, notifyType, displayOrder, delay, onDuty) {
        return $http.post(HOST + "/api/Notifications/NotificationRuleRecipient?" + "customerId=" + customerId + "&ruleId=" + ruleId + "&scheduleId=" + scheduleId + "&serviceUserId=" + serviceUserId + "&notifyType=" + notifyType + "&displayOrder=" + displayOrder + "&delay=" + delay + "&onDuty=" + onDuty);
    };

    var _putData = function (customerId, recipientId, notifyType, displayOrder, delay, onDuty, team) {
        return $http.put(HOST + "/api/Notifications/NotificationRuleRecipient?" + "customerId=" + customerId + "&recipientId=" + recipientId + "&notifyType=" + notifyType + "&displayOrder=" + displayOrder + "&delay=" + delay + "&onDuty=" + onDuty + "&team=" + team);
    };

    var _deleteData = function (customerId, recipientId) {
        return $http.delete(HOST + "/api/Notifications/NotificationRuleRecipient?" + "customerId=" + customerId + "&recipientId=" + recipientId);
    };

    notificationRuleRecipientFactory.getData = _getData;
    notificationRuleRecipientFactory.postData = _postData;
    notificationRuleRecipientFactory.putData = _putData;
    notificationRuleRecipientFactory.deleteData = _deleteData;

    return notificationRuleRecipientFactory;
}
]);

mcapp.factory('serviceUserService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/ServiceUserList?customerId=' + varParm + "&" + new Date().getTime(),
                cache: false
            });
        }
    };
}]);

mcapp.factory('notificationGroupsService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/NotificationGroupList?customerId=' + varParm + "&" + new Date().getTime(),
                cache: false
            });
        }
    };
}]);

mcapp.factory('notificationGroupDestinationsService', ['$http', 'HOST', function ($http, HOST) {
    var notificationGroupDestinationsFactory = {};

    var _getData = function (varCustomerId, varGroupId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/NotificationGroupDestinationList?customerId=' + varCustomerId + '&groupId=' + varGroupId + "&" + new Date().getTime(),
            cache: false
        });
    };

    var _updateNotificationGroupDestinations = function (varCustomerId, varGroupId, notificationGroupDestinationList) {
        return $http.put(HOST + '/api/NotificationGroupDestinationList?customerId=' + varCustomerId + '&groupId=' + varGroupId + "&" + new Date().getTime(), notificationGroupDestinationList);
    };

    notificationGroupDestinationsFactory.getData = _getData;
    notificationGroupDestinationsFactory.updateNotificationGroupDestinations = _updateNotificationGroupDestinations;
    return notificationGroupDestinationsFactory;

}]);

mcapp.factory('testFactory', function () {
    var divId = 0;
    var numberOfTabs = 4;
    return {
        getNumberOfTabs: function () {

            return divnumberOfTabsId;
        },
        getDivId: function () {
            if (divId === 0) {
                divId++;
            }
            else {
                divId = divId + numberOfTabs;
            }
            return divId;
        }
    };
});

mcapp.service('notificationOpenService', ['authenticationService', '$rootScope', '$timeout', 'sharedSetupService', 'openViewService', function (authenticationService, $rootScope, $timeout, sharedSetupService, openViewService) {
    this.open = function (menuOption, importData) {

        var intBr = 0;
        if (importData) {
            for (var i = 0; i < $rootScope.arrPopup.length; i++) {
                if ($rootScope.arrPopup[i].desktopName === "Notification Rules" || $rootScope.arrPopup[i].desktopName === "Notification Schedule") {
                    if (!scope.mobile) {
                        var _popup = _this.getExistingDialog($rootScope.arrPopup[i].desktopIndex).ref;
                        _popup.dialog("close");
                    }
                    intBr++;
                }
            }
        }

        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        var position = null;
        var isAdmin = authenticationService.getAccountInfo().userRole.indexOf("Administrator") > -1;

        switch (menuOption) {
            case "Rules":
                position = { my: "left+100 top+10", at: "left top", of: window };
                $timeout(function () {
                    openViewService.openView('Notification Rules', { width: 900, height: 400 }, position, optionsStickyProperties, { minimumWidth: 850, minimumHeight: 350 });
                }, intBr > 0 ? 1000 : 0);
                break;
            case "Schedule":
                position = { my: 'top+120', at: 'center top', of: window };
                $timeout(function () {
                    openViewService.openView('Manage Schedule', { width: 900, height: isAdmin ? 400 : 360 }, position, optionsStickyProperties, {
                        minimumWidth: 900, minimumHeight: isAdmin ? 400 : 360
                    }, true);
                }, intBr > 0 ? 1000 : 0);
                break;
        }
    }
}]);

//Case cmt.ContactModeId
//    When 1  then su.VoiceNumber1
//    When 2  then su.EMail
//    When 4  then su.Fax
//    When 8  then su.VVPagerNum
//    When 11 then su.VoiceNumber1
//    When 12 then su.VoiceNumber1
//    When 13 then su.VoiceNumber1
//    When 14 then su.VoiceNumber1
//    When 15 then su.VoiceNumber1
//    When 17 then su.VPagerNum
//    When 18 then su.smsNumber
//    Else Null
//End
mcapp.directive('notificationRules', ['$rootScope', 'translationService', 'sharedSetupService', 'openViewService', 'deviceMenuService', 'authenticationService', 'notificationRuleService', '$timeout', 'notificationRuleDeviceService', 'notificationRuleScheduleService', '$filter',
                            function ($rootScope, translationService, sharedSetupService, openViewService, deviceMenuService, authenticationService, notificationRuleService, $timeout, notificationRuleDeviceService, notificationRuleScheduleService, $filter) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        scope.deviceListModel = [];
        scope.deviceListData = [];
        scope.notificationGroupsModel = [];
        scope.notificationStateGroupsModel =[];
        scope.notificationRules = [];
        scope.oldIndex = [];
        scope.validationError = false;
        scope.updateHappened = false;

        scope.Math = window.Math;

        scope.translation = translationService.translation;
        scope.accountInfo = authenticationService.getAccountInfo();

        if (scope.accountInfo.userRole === 'Administrator' || scope.accountInfo.userRole === 'SuperAdministrator') {
            scope.isAdmin = true;
        }

        var digitalMode = [
            {
                "id": "1",
                "name": scope.translation.text.SG_OFF_NORMAL
            },
            {
                "id": "2",
                "name": scope.translation.text.SG_RETURN_TO_NORMAL
            },
            {
                "id": "3",
                "name": scope.translation.text.SG_OFF_NORMAL_RETURN_TO_NORMAL
            }
        ];

        scope.rtuDigitalMode = digitalMode;

        scope.sortableOptions = {
            handle: ".sort-yes",
            items: "li:not(.not-sortable)",
            update: function (e, ui) {
                scope.oldIndex = [];
                for (var i = 0; i < scope.notificationRules.length; ++i) {
                   scope.oldIndex.push({ruleId: scope.notificationRules[i].ruleId, index: i});
                }
                scope.updateHappened = true;
            },
            stop: function (e, ui) {
                if (!scope.updateHappened) return false;
                scope.deviceListModelCopy = angular.copy(scope.deviceListModel) ;
                scope.notificationGroupsModelCopy = angular.copy(scope.notificationGroupsModel);
                scope.notificationStateGroupsModelCopy = angular.copy(scope.notificationStateGroupsModel);
                for (var i = 0; i < scope.notificationRules.length-1; ++i) {
                    notificationRuleService.putData(scope.accountInfo.customerId, scope.notificationRules[i].ruleId, scope.notificationRules[i].name, (scope.notificationRules.length - 1) - i);
                    scope.deviceListModel[i] = scope.deviceListModelCopy[scope.getOldIndex(scope.notificationRules[i].ruleId)];
                    scope.notificationGroupsModel[i] = scope.notificationGroupsModelCopy[scope.getOldIndex(scope.notificationRules[i].ruleId)];
                    scope.notificationStateGroupsModel[i]= scope.notificationStateGroupsModelCopy[scope.getOldIndex(scope.notificationRules[i].ruleId)];
                }
                _restartBroadcast();
                scope.updateHappened = false;
            }
        };

        scope.getOldIndex = function (varRuleId) {
            for (var i = 0; i < scope.oldIndex.length; i++) {
                if (parseInt(varRuleId) === scope.oldIndex[i].ruleId) {
                    return i;
                }
            }
            return 0;
        };

        /////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////

        scope.getTextToTranslate = function() {
            scope.textToTranslate = {
                checkAll: scope.translation.text.CHECK_ALL,
                uncheckAll: scope.translation.text.UNCHECK_ALL,
                selectionCount: scope.translation.text.CHECKED,
                selectionOf: '/',
                searchPlaceholder: scope.translation.text.SEARCH + '...',
                buttonDefaultText: scope.translation.text.SELECT,
                dynamicButtonTextSuffix: scope.translation.text.CHECKED,
                buttonDefaultTextAllDevices: scope.translation.text.ALL_DEVICES,
                buttonDefaultTextAllInputs: scope.translation.text.ALL_INPUTS
            };

            scope.languageChange = !scope.languageChange;
        };

        scope.$on('updatePreferencesLanguage', function () {
            scope.getTextToTranslate();
        });

        scope.languageChange = false;
        scope.getTextToTranslate();

        /////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////

        scope.openView = function (varRuleId) {
           var optionsStickyProperties = {
               deviceId: varRuleId // will need to fix, add RuleId
            };
            var position = { my: "left+" + 270 + " top+" + 50, at: "left top", of: window };
            openViewService.openView('Notification Schedule', { width: 645, height: 580 }, position, optionsStickyProperties, { minimumWidth: 645, minimumHeight: 480 });
        }

        scope.deviceEvents = {
            onItemSelect: function (item) {
                var _targetRuleId = scope.targetRuleId;
                notificationRuleDeviceService.postData(scope.accountInfo.customerId, _targetRuleId, item.id, null, null)
                .then(function (data) {
                    _restartBroadcast();
                    }, function(error) {
                        alert("Error");
                    });
                },
            onItemDeselect: function (item) {
                var _targetRuleId = scope.targetRuleId;
                notificationRuleDeviceService.deleteData(scope.accountInfo.customerId, _targetRuleId, item.id, null, null)
                .then(function (data) {
                    _restartBroadcast();
                    }, function (error) {
                        alert("Error");
                    });
            },
            onDeselectAll: function (selectedModel) {
                var _targetRuleId = scope.targetRuleId;
                for (var index = 0; index < selectedModel.length; ++index) {
                    notificationRuleDeviceService.deleteData(scope.accountInfo.customerId, _targetRuleId, selectedModel[index].id, null, null)
                    .then(function (data) {
                        _restartBroadcast();
                    }, function (error) {
                        alert("Error");
                    });
                }
            }
        };

        scope.inputEvents = {
            onItemSelect : function (item) {
                notificationRuleDeviceService.postData(scope.accountInfo.customerId, scope.targetRuleId, null, item.id, null)
                .then(function (data) {
                    _restartBroadcast();
                    }, function(error) {
                        alert("Error");
                    });
                },
            onItemDeselect: function (item) {
                notificationRuleDeviceService.deleteData(scope.accountInfo.customerId, scope.targetRuleId, null, item.id, null)
                .then(function (data) {
                    _restartBroadcast();
                    }, function (error) {
                        alert("Error");
                    });
            },
            onDeselectAll: function (selectedModel) {
                var _targetRuleId = scope.targetRuleId;
                for (var index = 0; index < selectedModel.length; ++index) {
                    notificationRuleDeviceService.deleteData(scope.accountInfo.customerId, _targetRuleId, null, selectedModel[index].id, null)
                    .then(function (data) {
                        _restartBroadcast();
                        }, function (error) {
                            alert("Error");
                        });
                }
            }
        };

        scope.stateEvents = {
            onItemSelect : function (item) {
                notificationRuleDeviceService.postData(scope.accountInfo.customerId, scope.targetRuleId, null, null, null, item.id)
                .then(function(data) {
                    _restartBroadcast();
                }, function(error) {
                        alert("Error");
                    });
            }
        };


        scope.updateStateGroups = function (item) {
            notificationRuleDeviceService.postData(scope.accountInfo.customerId, item.ruleId, null, null, null, item.stateGroups.id)
                .then(function (data) {
                    _restartBroadcast();
                    }, function(error) {
                        alert("Error");
                    });
        };

        scope.focusCallback = function (ruleid) {
            scope.targetRuleId = ruleid;
        };

        scope.checkIfUpdate = function (varItem, oldName, newName, varPriority) {
            if (oldName != newName && varItem.nameError === false) {
               notificationRuleService.putData(scope.accountInfo.customerId, scope.targetRuleId, newName, varPriority)
                    .then(function (data) {
                        _restartBroadcast();
                    }, function (error) {
                        alert("Error");
                    });
            }
        }

        scope.checkIfValid = function (varItem) {
            var varObj = scope.isValidRuleName(varItem.name, varItem.ruleId);
            varItem.nameError = varObj.hasMatch;

            //if (!varObj.hasMatch) return;

            for (var index = 0; index < scope.notificationRules.length; ++index) {
                var item = scope.notificationRules[index];
                if (item === varItem && varObj.hasMatch) {
                    item.disabled = false;
                    scope.validationError = true;
                    //break;
                }
                else if (varObj.hasMatch) {
                    item.disabled = true;
                }else {
                    item.disabled = false;
                    scope.validationError = false;
                }
            }
        };

        scope.isValidRuleName = function (name, ruleId) {
            var hasMatch = false, newPriority = 0;
            if (name.length <= 0) return { hasMatch: true, newPriority: newPriority };;
            for (var index = 0; index < scope.notificationRules.length; ++index) {
                var item = scope.notificationRules[index];
                newPriority = newPriority > item.priority ? newPriority : item.priority + 1;

                if (item.name === name && item.ruleId !== ruleId) {
                    hasMatch = true;
                    break;
                }
            }
            return { hasMatch: hasMatch, newPriority: newPriority };
        };

        scope.undoChanges = function () {
            $(".tooltip-error-message").hide(100);
            //$(_element).parent().find(".tooltip-error-message").show(100);
        }

        scope.deviceListSetting = {
            smartButtonMaxItems: 3,
            smartButtonTextConverter: function (itemText, originalItem) {
                return itemText;
            }
        };

        scope.notificationGroupsSetting = {
            smartButtonMaxItems: 3,
            showCheckAll: false,
            showUncheckAll: false,
            smartButtonTextConverter: function (itemText, originalItem) {
                return itemText;
            }
        };

        scope.notificationStateGroupsSetting = {
            smartButtonMaxItems: 1,
            selectionLimit: 1,
            closeOnSelect: true,
            showCheckAll: false,
            showUncheckAll: false,
                    smartButtonTextConverter : function (itemText, originalItem) {
                        return itemText;
            }
        };

        scope.add = function () {
            var _newRuleName, tmpNewRuleName = "", varObj = {};
            for (var i = 0; i <= 100; ++i) {
                tmpNewRuleName = tmpNewRuleName === "" ? scope.translation.text.NEW_RULE : tmpNewRuleName + "_";
                varObj = scope.isValidRuleName(tmpNewRuleName, 0);
                _newRuleName = varObj.hasMatch ? "" : tmpNewRuleName;
                if (_newRuleName != "") break;
            }
            if (_newRuleName == "") {
                alert("Error");
            }
            else {
                notificationRuleService.postData(scope.accountInfo.customerId, null, _newRuleName, varObj.newPriority)
                    .then(function (result) {
                        scope.notificationRules.unshift({
                            ruleId: result.data.ruleId,
                            name: result.data.name,
                            priority: result.data.priority,
                            disabled: false,
                            nameError: false,
                            nameMessage: translationService.translation.text.DUPLICATE_RULE_NAME
                        });
                        scope.notificationStateGroupsModel.unshift({ id: 3 }); //default value: "Off Normal and Return to Normal"
                        scope.notificationGroupsModel.unshift([]);
                        scope.deviceListModel.unshift([]);
                        _restartBroadcast();
                        ////When it was sorted the other way
                        //var objDiv = element.parent().find(".tabular-data-container")[0];
                        //$timeout(function () {
                        //    objDiv.scrollTop = objDiv.scrollHeight;
                        //}, 0);
                    }, function (error) {
                        alert("Error");
                    });
            }
        };

        scope.remove = function (index, ruleId) {
            if (confirm(translationService.translation.text.DELETE_RULE) === true) {
                notificationRuleService.deleteData(scope.accountInfo.customerId, ruleId)
                    .then(function (data) {
                        scope.notificationRules.splice(index, 1);
                        scope.notificationStateGroupsModel.splice(index, 1);
                        scope.notificationGroupsModel.splice(index, 1);
                        scope.deviceListModel.splice(index, 1);
                        _restartBroadcast();
                    }, function (error) {
                        alert("Error");
                    });
            }
        };


        if (!$rootScope.mobile && !$rootScope.classicView) {
            scope.popup = _this.getExistingDialog(scope.windowId).ref;
            sharedSetupService.maximize(scope.popup);

            scope.popup.dialog({
                resize: function (event, ui) {
                    scope.adjustSize();
                }
            });

            scope.popup.dialogExtend({
                maximize: function (event, ui) {
                    openViewService.adjustContentSizeStart(scope.popup);
                	scope.adjustSize();
                },
                restore: function (event, ui) {
					openViewService.adjustContentSizeStart(scope.popup);
                    scope.adjustSize();
                }
            });

            scope.adjustSize = function () {
                scope.popup.parent().find('div:eq(2)').css("width", scope.popup.parent().css("width"));
                scope.popup.parent().find('div:eq(2)').css("min-width", scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                scope.popup.parent().find('div:eq(2)').css("height", scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                scope.popup.parent().find('.tabular-data-container').css("height", scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }

        var _getStateGroup = function (stateGroups) {
            var _id = 3;
            $.each(stateGroups, function (i, obj) {
                if (obj.isSelected === true) {
                    _id = obj.id;
                }
            });
            return _id;//default value: "Off Normal and Return to Normal"
        };

        notificationRuleService.getData(scope.accountInfo.customerId, null, true, false).then(function (dataFromFactory) {
            scope.data = dataFromFactory.data;
            for (var index = 0; index < scope.data.rules[0].devices.length; ++index) {
                scope.deviceListData.push({
                    id: scope.data.rules[0].devices[index].deviceId,
                    label: scope.data.rules[0].devices[index].deviceName
                });
            }

            scope.notificationGroupsData = [];//{ id: 1, label: "Alarms" }, { id: 2, label: "Comms" }, { id: 3, label: "Digital Fault" }, { id: 4, label: "Pump Start" }];
            var tmpGroupsData = [];
            for (var z = 0; z < scope.data.rules[0].devices[0].inputStates.length; ++z) {
                if (scope.data.rules[0].devices[0].inputStates[z].input !== 0) //data has an extra record - will talk to Jeff
                    tmpGroupsData.push({ id: scope.data.rules[0].devices[0].inputStates[z].input, label: scope.data.rules[0].devices[0].inputStates[z].description });
            }

            scope.notificationGroupsData = tmpGroupsData;

            //////////////////////////////////////////////////////
            //////////////////////////////////////////////////////
            //////////////////////////////////////////////////////
            scope.notificationStateGroupsData =[];//{ id: 1, label: "Alarms" }, { id: 2, label: "Comms" }, { id: 3, label: "Digital Fault" }, { id: 4, label: "Pump Start" }];
            var tmpStateGroupsData =[];
            //for (var z = 0; z < scope.data.rules[0].devices[0].inputStates.length; ++z) {
            //    if (scope.data.rules[0].devices[0].inputStates[z].input !== 0) //data has an extra record - will talk to Jeff
            //        tmpStateGroupsData.push({ id: scope.data.rules[0].devices[0].inputStates[z].input, label: scope.data.rules[0].devices[0].inputStates[z].description});
            //}

            tmpStateGroupsData.push({ id: 3, label: scope.translation.text.SG_ALL_STATES  });
            tmpStateGroupsData.push({ id: 2, label: scope.translation.text.SG_OFF_NORMAL  });
            tmpStateGroupsData.push({ id: 1, label: scope.translation.text.SG_RETURN_TO_NORMAL });

            scope.notificationStateGroupsData = tmpStateGroupsData;
            //////////////////////////////////////////////////////
            //////////////////////////////////////////////////////
            //////////////////////////////////////////////////////

            for (var index = 0; index < scope.data.rules.length; ++index) {
                scope.notificationRules.unshift({
                    ruleId: scope.data.rules[index].ruleId,
                    name: scope.data.rules[index].name,
                    priority: scope.data.rules[index].priority,
                    stateGroupsOpt: scope.data.rules[index].stateGroups,
                    stateGroups: {id: _getStateGroup(scope.data.rules[index].stateGroups)},
                    disabled: false,
                    nameError: false,
                    nameMessage: translationService.translation.text.DUPLICATE_RULE_NAME

                });

                var tmp = [];
                for (var i = 0; i < scope.data.rules[index].devices.length; ++i) {
                    if (scope.data.rules[index].devices[i].deviceId != 0) //data has an extra record - will talk to Jeff
                        tmp.push({ id: scope.data.rules[index].devices[i].deviceId });
                }
                scope.deviceListModel.unshift(tmp);

                var tmpGroupsModel = [];
                for (var z = 0; z < scope.data.rules[index].devices[0].inputStates.length; ++z) {
                    if (scope.data.rules[index].devices[0].inputStates[z].input !== 0) //data has an extra record - will talk to Jeff
                        tmpGroupsModel.push({ id: scope.data.rules[index].devices[0].inputStates[z].input });
                }
                scope.notificationGroupsModel.unshift(tmpGroupsModel);

                //////////////////////////////////////////////////////
                //////////////////////////////////////////////////////
                //////////////////////////////////////////////////////
                for (var y = 0; y < scope.data.rules[index].stateGroups.length; ++y) {
                    if (scope.data.rules[index].stateGroups[y].isSelected === true)
                        scope.notificationStateGroupsModel.unshift({ id: scope.data.rules[index].stateGroups[y].id }); //one only selection
                }
                //////////////////////////////////////////////////////
                //////////////////////////////////////////////////////
                //////////////////////////////////////////////////////

            }

            scope.adjustSize();

            }, function (error) {
                scope.alerts = [];
                element.empty();
                scope.loadingInProgress = false;
                var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            });

        var _startBroadcast;

        var _checkStartBroadcast = function () {
            // Don't start if already started
            if (angular.isDefined(_startBroadcast)) return;
            _startBroadcast = $timeout(function () {
                _startBroadcast = undefined; // will revisit this line of code (has to do with Alert())
                $rootScope.$broadcast('changeNotificationScheduleOrRule', true);
            }, 1000);
        };

        var _stop = function () {
            if (angular.isDefined(_startBroadcast)) {
                $timeout.cancel(_startBroadcast);
                _startBroadcast = undefined;
            }
        };

        var _restartBroadcast = function () {
            if (angular.isDefined(_startBroadcast))
                _stop();
            _checkStartBroadcast();
        };

        scope.$on("$destroy", function () {
            if (angular.isDefined(_startBroadcast)) {
                $timeout.cancel(_startBroadcast);
            }
        });
    };

}]);

mcapp.factory("notificationRuleService", ['$http', 'HOST', function ($http, HOST) {
    var notificationRuleFactory = {};

    var _getData = function (customerId, ruleId, getDevices, getSchedules) {
        return $http({
                method: "Get",
                url: HOST + "/api/Notifications/NotificationRule?" + "customerId=" + customerId + "&ruleId=" + ruleId + "&getDevices=" + getDevices + "&getSchedules=" +getSchedules,
                cache: false
            });
        };

    var _getDataCoverage = function (customerId, ruleId) {
        return $http({
            method: "Get",
            url: HOST + "/api/Notifications/NotificationRule/Schedule/?" + "customerId=" + customerId + "&ruleId=" + ruleId,
            cache: false
        });
    };

    var _postData = function (customerId, ruleId, name, priority) {
        return $http.post(HOST + "/api/Notifications/NotificationRule?" + "customerId=" + customerId + "&ruleId=" + ruleId + "&name=" + name + "&priority=" + priority);
    };

    var _putData = function (customerId, ruleId, name, priority) {
        return $http.put(HOST + "/api/Notifications/NotificationRule?" + "customerId=" + customerId, { customerId: customerId, ruleId: ruleId, name: name, priority: priority });
    };

    var _deleteData = function (customerId, ruleId) {
        return $http.delete(HOST + "/api/Notifications/NotificationRule?" + "customerId=" + customerId + "&ruleId=" + ruleId);
    };

    notificationRuleFactory.getData = _getData;
    notificationRuleFactory.getDataCoverage = _getDataCoverage;
    notificationRuleFactory.postData = _postData;
    notificationRuleFactory.putData = _putData;
    notificationRuleFactory.deleteData = _deleteData;

    return notificationRuleFactory;
}
]);

mcapp.factory("notificationRuleDeviceService", ['$http', 'HOST', function ($http, HOST) {
    var notificationRuleDeviceFactory = {};

    var _getData = function (customerId, ruleId) {
        return $http({
            method: "Get",
            url: HOST + "/api/Notifications/notificationRuleDevice?" + "customerId=" + customerId + "&ruleId=" + ruleId,
            cache: false
        });
    };

    var _postData = function (customerId, ruleId, deviceId, input, state, stateGroupId) {
        return $http.post(HOST + "/api/Notifications/notificationRuleDevice?" + "customerId=" + customerId + "&ruleId=" + ruleId + "&deviceId=" + deviceId + "&input=" + input + "&state=" + state + "&stateGroupId=" + stateGroupId);
    };

    var _deleteData = function (customerId, ruleId, deviceId, input, state) {
        return $http.delete(HOST + "/api/Notifications/notificationRuleDevice?" + "customerId=" + customerId + "&ruleId=" + ruleId + "&deviceId=" + deviceId + "&input=" + input + "&state=" + state);
    };

    notificationRuleDeviceFactory.getData = _getData;
    notificationRuleDeviceFactory.postData = _postData;
    notificationRuleDeviceFactory.deleteData = _deleteData;

    return notificationRuleDeviceFactory;
}
]);

mcapp.factory("notificationRuleScheduleService", ['$http', 'HOST', function ($http, HOST) {
    var notificationRuleScheduleFactory = {};

    var _getData = function (customerId, ruleId, scheduleId, languageId) {
        return $http({
            method: "Get",
            url: HOST + "/api/Notifications/notificationRuleSchedule?" + "customerId=" + customerId + "&ruleId=" + ruleId + "&scheduleId=" + scheduleId + "&languageId=" + languageId,
            cache: false
        });
    };

    notificationRuleScheduleFactory.getData = _getData;

    return notificationRuleScheduleFactory;
}
]);

mcapp.controller('notificationInputStateController', ["$element", "$scope", "$http", "HOST", "authenticationService", "ivhTreeviewMgr", "ivhTreeviewBfs", "$templateCache", "translationService", function ($element, $scope, $http, HOST, authenticationService, ivhTreeviewMgr, ivhTreeviewBfs, $templateCache, translationService) {
    var vm = this;
    this.nsInputState = [];
    this.classExpanded = "fa-minus";
    this.classCollapsed = "fa-plus";
    this.classToggle = this.classCollapsed;
    this.tplExpanded = "<i class=\"fa " + this.classExpanded + "\" aria-hidden=\"true\"></i>";
    this.tplCollapsed = "<i class=\"fa " + this.classCollapsed + "\" aria-hidden=\"true\"></i>";
    this.ivhTreeviewBusy = true;
    this.accountInfo = authenticationService.getAccountInfo();
    this.nodeTemplate = $templateCache.get('my-node-template.html');
    vm.translation = translationService.translation;

    ///////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////
    this.onInit = function() {
        $scope.checkModel = {
            all: false,
            normal: false,
            offnormal: false,
            tamper: false
        };
        //console.log($scope.selectedModel);
    };
    ///////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////

    this.anythingSelected = function () {
        var _selectedCount = 0;
        ivhTreeviewBfs(vm.nsInputState,
            function (node) {
                if (node.selected) {
                    _selectedCount++;
                }
            });

        $scope.selectedModel = _selectedCount > 0 ? [{ id: 0, label: "Ok", count: _selectedCount }] : [];
        //console.log($scope.selectedModel);
    }

    this.toggleAll = function (all) {
        if (all) {
            ivhTreeviewMgr.selectAll(this.nsInputState);
            angular.forEach($scope.checkModel, function (value, key) {
                $scope.checkModel[key] = true;
                //$scope.selectedModel = [{ id: 5, label: "Aaa" }, { id: 6, label: "Bbb" }];
            });
            this.selectStates(null);
        }
        else {
            ivhTreeviewMgr.deselectAll(this.nsInputState);
            angular.forEach($scope.checkModel, function (value, key) {
                $scope.checkModel[key] = false;
            });
            $scope.selectedModel = [];
            this.deselectStates(null);

        }
        this.anythingSelected();
    };

    //    anotherred: node.inputStateId == 1 || node.inputStateId == 12 || node.inputStateId == 13,
    //    red: node.inputStateId == 2,
    //    anotheryellow: node.inputStateId == 5,
    //    green: node.inputStateId == 0 || node.inputStateId == 10 || node.inputStateId == 11

    this.toggleType = function (state, type) { //type: 0 | 1 | = normal | offnormal
        // selecting by node reference
        var _type = [];
        var tmpLoop = [];
        this.getType(_type, type);

        switch(type) {
        case 0:
            tmpLoop = [{ id: 0 }, { id: 10 }, { id: 11 }];
            break;
        case 1:
            tmpLoop = [{ id: 1 }, { id: 12 }, { id: 13 } ];
            break;
        default:
            tmpLoop = [{ id: type }];
        }

        if (state) {
            ivhTreeviewMgr.selectEach(vm.nsInputState, _type);
            for (var index = 0; index < tmpLoop.length; ++index) {
                this.selectStates(tmpLoop[index].id);
            }
        }
        else {
            ivhTreeviewMgr.deselectEach(vm.nsInputState, _type);
            for (var index = 0; index < tmpLoop.length; ++index) {
                this.deselectStates(tmpLoop[index].id);
            }
        }
        this.anythingSelected();
    };

    this.getType = function (_type, type) {
        angular.forEach(this.nsInputState,
            function (parent, pKey) {
                angular.forEach(parent.children,
                    function (child, cKey) {
                        if (child.inputStateId === type) {
                            _type.push(vm.nsInputState[pKey].children[cKey]);
                        }
                    });
            });
    }
    ///////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////



    this.stateChangeCallback = function (node, isSelected, tree) {
        // Do soemthing with node or tree based on isSelected
        //console.log(node, isSelected, tree);
        if (typeof node.id === "undefined") {
            //console.log("Rule Id: " + $scope.ntfRuleId);
            //console.log("Input Id: " + this.getParent(node.$$hashKey));
            //console.log("State:" + node.label);
            //console.log("Is Selected: " + isSelected);
            vm.putInputState(this.getParent(node.$$hashKey), node.inputStateId, node.severity, isSelected ? 0 : 1);
        } else {
            //console.log("Rule Id: " + $scope.ntfRuleId);
            //console.log("Input Id: " + node.id);
            //console.log("Input Name: " + node.label);
            //console.log("Is Selected: " + isSelected);
            angular.forEach(node.children,
                function (child) {
                    //console.log("State:" + child.label);
                    //console.log("Is Selected: " + child.selected);
                    vm.putInputState(node.id, child.inputStateId, child.severity, child.selected ? 0 : 1);
                });
        }
        this.anythingSelected();
    }

    this.getParent = function (hashKey) {
        var parentId = null;
        angular.forEach(this.nsInputState,
            function(parent) {
                angular.forEach(parent.children,
                    function(child) {
                        if (hashKey === child.$$hashKey) {
                            parentId = parent.id;
                            return parentId;
                        }
                        return parentId;
                    });
            });

        return parentId;
    }

    this.deselectStates = function (stateId) {
        if(stateId === null) this.onInit();
        this.ivhTreeviewBusy = true;
        var url = HOST + "/api/Notifications/NotificationRuleInputStateJsonTree?customerID=" + this.accountInfo.customerId + "&ruleId=" + $scope.ntfRuleId + "&stateId=" + stateId; //?customerId=" + ctrl.accountInfo.customerId + "&inline=true" + "&reportDate=" + _tmpTestEventDate;
        $http.delete(url).then(function (result) {
            vm.translateData(result.data);
            vm.nsInputState = result.data;
            ivhTreeviewMgr.validate(vm.nsInputState);
        }).then(function (result) {
            vm.classToggle = vm.classExpanded;
            vm.ivhTreeviewBusy = false;
            return;
        });
    }

    this.selectStates = function (stateId) {
        this.ivhTreeviewBusy = true;
        var url = HOST + "/api/Notifications/NotificationRuleInputStateJsonTree?customerID=" + this.accountInfo.customerId + "&ruleId=" + $scope.ntfRuleId + "&stateId=" + stateId; //?customerId=" + ctrl.accountInfo.customerId + "&inline=true" + "&reportDate=" + _tmpTestEventDate;
        $http.post(url).then(function (result) {
            vm.translateData(result.data);
            vm.nsInputState = result.data;
            ivhTreeviewMgr.validate(vm.nsInputState);
        }).then(function (result) {
            //vm.classToggle = vm.classExpanded;
            vm.ivhTreeviewBusy = false;
            return;
        });
    }

    this.getInputState = function () {
        this.onInit();
        this.ivhTreeviewBusy = true;
        var url = HOST + "/api/Notifications/NotificationRuleInputStateJsonTree?customerID=" + this.accountInfo.customerId + "&ruleId=" + $scope.ntfRuleId; //?customerId=" + ctrl.accountInfo.customerId + "&inline=true" + "&reportDate=" + _tmpTestEventDate;
        $http.get(url).then(function (result) {
            vm.translateData(result.data);
            vm.nsInputState = result.data;
            ivhTreeviewMgr.validate(vm.nsInputState);
        }).then(function (result) {
            vm.classToggle = vm.classExpanded;
            vm.ivhTreeviewBusy = false;
            return;
        });
    }

    this.putInputState = function (inputId, stateId, severity,  updateActionId) {
        this.ivhTreeviewBusy = true;
        var url = HOST + "/api/Notifications/NotificationRuleInputStateJsonTree?customerID=" + this.accountInfo.customerId + "&ruleId=" + $scope.ntfRuleId + "&inputId=" + inputId + "&stateId=" + stateId + "&severity=" + severity + "&updateActionId=" + updateActionId; //?customerId=" + ctrl.accountInfo.customerId + "&inline=true" + "&reportDate=" + _tmpTestEventDate;
        $http.put(url).then(function (data) {
            //console.log(data);
        }).then(function (result) {
            //console.log(result);
        });
    }

    this.clearInputState = function () {
        this.nsInputState = [];
        this.classToggle = this.classCollapsed;
    }

    this.toggleInputState = function() {
        if (this.nsInputState.length > 0) {
            this.clearInputState();
        } else {
            this.getInputState();
        }
    }

    this.toggleInputState();

    vm.translateData = function (varData) {
        angular.forEach(varData,
            function (parent, pKey) {
                parent.label = vm.getText(parent.label);
                angular.forEach(parent.children,
                    function (child, cKey) {
                        child.label = vm.getText(child.label);
                    });
            });
    };

    vm.getText = function (text) {
        var prm1 = "vm.translation.text." + "JT_" + text.toUpperCase().replace(/ /g, "_").replace(/#/g, "NR").replace(/-/g, "_").replace(/\//g, "_").replace(/&/g, "_").replace(/\./g, "");
        if (!angular.isDefined(text)) return;
        return typeof eval(prm1) !== 'undefined' ? eval(prm1) : text;
    };

    //$scope.$watch(function () {
    //    return $element.is(':visible');
    //}, angular.bind(this, function (newVal, oldVal) {
    //    if (newVal) {
    //        vm.getInputState();
    //    }
    //    else {
    //        this.clearInputState();
    //    }
    //}));
}]);

mcapp.directive('notificationInputState', ['$http', 'HOST', function ($http, HOST) {
    return {
        restrict: 'E',
        ntfRuleId: '=',
        selectedModel: '=',
        replace: true,
        templateUrl: 'ui/notification/notification-input-state.html',
        link: function (scope, element, attrs) {
            //http://localhost/Mc.Services/api/Notifications/NotificationRuleInputStateJsonTree?customerID=10860&ruleId=2

            //var url = HOST + "/api/Notifications/NotificationRuleInputStateJsonTree?customerID=10860&ruleId=2"; //?customerId=" + ctrl.accountInfo.customerId + "&inline=true" + "&reportDate=" + _tmpTestEventDate;
            //$http.get(url).then(function (data) {
            //    console.log(data);
            //}).then(function (result) {
            //    //
            //});

        }
    };
}]);
'use strict';

function NoDevicesController($cookies, $location, $rootScope, $window, authenticationService) {
  var _this = this;

  this.$onInit = function () {
    _this.adminUserName = $rootScope.adminUserName;
    _this.isMcAdmin = $cookies.get('AdminInfo') != null ? true : false;
    _this.mobile = $rootScope.mobile;
    _this.classicView = $rootScope.classicView;
  };

  this.adminOverride = function () {
    $rootScope.deviceOverride = true;
    $location.path('/');
  };

  this.logout = function () {
    $rootScope.CustomerNameStart = "";
    $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
    $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
    $rootScope.logoSizeId = $rootScope.defaultFontAndColorId;
    $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
    authenticationService.logout().then(function () {
      $location.path('/account/userlogin');
    }, function () {
      $window.alert('logout error');
    });
  };
}

NoDevicesController.$inject = ['$cookies', '$location', '$rootScope', '$window', 'authenticationService'];

angular.module('mcapp').component('noDevices', {
  controller: NoDevicesController,
  transclude: true,
  templateUrl: 'ui/nodevices/partial.html'
});
"use strict";

angular.module("mc.mmplus", []);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function MmPlusController($, $scope, authenticationService, translationService, sharedSetupService, openViewService, $element, McWidgetsSharedFactory, debounceService, PopupFactory, $timeout, toaster) {
    var ctrl = this;
    ctrl.isLoading = true;
    $scope.alerts = [];

    ctrl.$onInit = function () {
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loadingInProgress = false;

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;

        ctrl.mainClass = [];

        if (angular.isUndefined(ctrl.popupWindow)) {
            ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
            ctrl.getPopupWindowDateTimeDifference = debounceService(ctrl.popupWindow.datetime_difference, 200, false);
        }

        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();

        //THE-55471: the window content keeps jQuery UI's default overflow:auto. It used to be set to
        //"inherit" here (copied from pump station) so the Select Device menu wouldn't be cut off, but
        //that menu is appended to <body> and can't be clipped by the window, while switching the
        //scrollbar off cut the 464px-tall gauge off at small viewports / 400% zoom
        //$element.closest('.ui-dialog-content').css("overflow", "inherit"); //Device Select menu is cut off

        $scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                ctrl.isLoading = true;
                $element.off("mouseover.mcMmPlusGauge");

                ctrl.deviceSelected = newValue;
                ctrl.deviceSelectedSn = $scope.deviceSelectedSn;
                ctrl.deviceSelectedName = $scope.deviceSelectedName;

                ctrl.buildGauges(newValue);
            }
        }, true);

        $scope.$on('mmPlusWidgetDone_' + $scope.windowId, function (event, args) {
            //console.log(args.message);
            ctrl.isLoading = false;
        });
    };

    ctrl.buildGauges = function (deviceSelected) {
        $scope.alerts = [];

        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        }
        var _device = { deviceId: deviceSelected, deviceName: ctrl.deviceSelectedName, serialNumber: ctrl.deviceSelectedSn };
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceSelected, device: _device, windowId: $scope.windowId });

        $element.on("mouseover.mcMmPlusGauge", ".upWidget", function (event) {
            if (!ctrl.m110Runtime && $(event.currentTarget).is(".upWidget") && event.target.tagName !== "DIV" && !$scope.mobile && !$scope.classicView && !ctrl.mobile && !ctrl.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    zIndex: 9999,
                    disabled: false,
                    stop: function stop(event, ui) {
                        var tmpSize = ctrl.mcWidgetsSharedFactory.getSizeNew(88, 1, 0); //ctrl.mcWidgetsSharedFactory.getSizeNew(ui.helper.attr("mc-size"), 1, ctrl.pumpType);
                        var mcDevice = { deviceId: deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: ctrl.deviceSelectedSn, deviceName: ctrl.deviceSelectedName };
                        var optionsStickyProperties = {
                            deviceId: deviceSelected,
                            device: mcDevice
                        };
                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        var vieName = 'Mc MyLevel Widget';
                        openViewService.openWidget(vieName, { width: tmpSize.width, height: tmpSize.height }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));

                        $scope.$apply();
                    }
                });
            } else {
                $(event.currentTarget).draggable({ disabled: true });
            }
        });
    };

    ctrl.mostRecentData = function () {
        ctrl.isLoading = true;
        var _deviceSelected = $scope.deviceSelected;
        $scope.deviceSelected = null;
        $timeout(function () {
            $scope.deviceSelected = angular.copy(_deviceSelected);
            toaster.pop('success', $scope.windowTitle + " -- " + ctrl.deviceSelectedName, 'View reloading');
        }, 0);
    };

    $scope.$on('mmPlusWidgetSettingUpdate', function (event, args) {
        if ($scope.deviceSelected == args.deviceId) ctrl.mostRecentData();
    });

    //$scope.$on('rtuAnalogUpdateMMPlus', function (event, args) {
    //    var _dataChanged = "channelDesc, unitOfValueID, manholeDepth, sensorDepth";
    //    if (args.deviceId == $scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
    //        ctrl.mostRecentData();
    //    }
    //});

    $scope.$on("$destroy", function (event) {
        $element.off("mouseover.mcMmPlusGauge");
    });

    //THE-51575: jQuery UI renders the window title as a plain <span>; role/aria-level expose it
    //as an <h2> without Bootstrap's h2 styling. This controller keeps no reference to its window,
    //so find it from the component element (<mm-plus> is only ever used in the MyLevel window)
    ctrl.$postLink = function () {
        if (ctrl.mobile || ctrl.classicView) return;
        $element.closest(".ui-dialog").children(".ui-dialog-titlebar").children(".ui-dialog-title").attr({ "role": "heading", "aria-level": "2" });
    };
}

MmPlusController.$inject = ["$", "$scope", "authenticationService", "translationService", "sharedSetupService", "openViewService", "$element", "McWidgetsSharedFactory", "debounceService", "PopupFactory", "$timeout", "toaster"];
'use strict';

angular.module('mc.mmplus').component('mmPlus', {
    controller: MmPlusController,
    templateUrl: 'ui/mmplus/mmplus-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
//alert("more changes 2");

"use strict";

function MMPlusRtuSettingFactory(HOST, $http) {
    var _this = this;

    // instantiate our initial object
    var MMPlusRtuSetting = function MMPlusRtuSetting(customerId) {
        this.customerId = customerId;
    };

    MMPlusRtuSetting.prototype.getDeviceConfigData = function (deviceId, isNetwrokConfig) {
        var self = this;
        return $http.get(HOST + "/api/Gen2/DeviceConfig/GetDeviceConfig" + "?deviceId=" + deviceId + '&isNetwrokConfig=' + isNetwrokConfig).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.getData = function (deviceId, channel, channelTypeID) {
        var self = this;
        return $http.get(HOST + "/api/Gen2/ChannelConfig/GetChannelConfig" + "?deviceId=" + deviceId + '&channel=' + channel + '&channelTypeID=' + channelTypeID).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.updateDeviceG2Ext = function (customerId, deviceId, deviceG2Ext) {
        var self = this;
        return $http.put(HOST + "/api/Gen2/DeviceConfig/putDeviceConfig?customerId=" + customerId + "&deviceId=" + deviceId, deviceG2Ext).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.updateNetworkConfig = function (customerId, deviceId, networkConfig) {
        var self = this;
        return $http.put(HOST + "/api/Gen2/NetworkDeviceConfig/putNetworkConfig?customerId=" + customerId + "&deviceId=" + deviceId, networkConfig).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.updateChannelConfig = function (customerId, deviceId, channel, netwrokDeviceConfigID, channelConfig) {
        var self = this;
        return $http.put(HOST + "/api/Gen2/ChannelConfig/putChannelConfig?customerId=" + customerId + "&deviceId=" + deviceId + "&channel=" + channel + "&netwrokDeviceConfigID=" + netwrokDeviceConfigID, channelConfig).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.patchDeviceG2ConfigPatch = function (deviceId, deviceG2ConfigPatch) {
        var self = this;
        return $http.patch(HOST + "/api/Gen2/DeviceConfig" + "?id=" + deviceId, deviceG2ConfigPatch).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.patchNetworkDeviceConfig = function (deviceId, networkDeviceConfigID, deviceG2ConfigPatch) {
        var self = this;
        return $http.patch(HOST + "/api/Gen2/NetworkDeviceConfig/patchNetworkDeviceConfig" + "?id=" + deviceId + "&networkDeviceConfigID=" + networkDeviceConfigID, deviceG2ConfigPatch).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.PatchChannelConfig = function (customerId, deviceId, channel, channelTypeID, networkDeviceConfigId, deviceG2ConfigPatch) {
        var self = this;
        return $http.patch(HOST + "/api/Gen2/ChannelConfig" + "?customerId=" + customerId + "&id=" + deviceId + "&channel=" + channel + "&channelTypeID=" + channelTypeID + "&networkDeviceConfigID=" + (networkDeviceConfigId || 1), deviceG2ConfigPatch).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.PostChannelConfig = function (customerId, deviceId, channel, networkDeviceConfigId, channelConfig) {
        var self = this;
        return $http.post(HOST + "/api/Gen2/ChannelConfig/postChannelConfig" + "?customerId=" + customerId + "&deviceId=" + deviceId + "&networkDeviceConfigId" + networkDeviceConfigId + "&channel=" + channel, channelConfig).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response.data;
        });
    };

    MMPlusRtuSetting.prototype.configMMPlusDevice = function (deviceId, imei) {
        var self = this;
        return $http.post(HOST + "/api/Gen2/DeviceConfig/ConfigMMPlusDevice" + "?customerId=" + this.customerId + "&deviceId=" + deviceId + "&imei=" + imei).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.configMMPlusNetwork = function (deviceId, imei, networkType) {
        var self = this;
        return $http.post(HOST + "/api/Gen2/NetworkDeviceConfig/ConfigMMPlusNetwork" + "?deviceId=" + deviceId + "&imei=" + imei + "&networkType=" + networkType).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.configMMPlusChannel = function (deviceId, imei, channel, channelType) {
        var self = this;
        return $http.post(HOST + "/api/Gen2/ChannelConfig/ConfigMMPlusChannel" + "?deviceId=" + deviceId + "&imei=" + imei + "&channel=" + channel + "&channelType=" + channelType).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.postUserAction2Nlog = function (customerId, deviceId, tabName) {
        var action = "access RTU Setting";
        //let tabName = "GEN II >> Configuration";

        return $http({
            method: 'POST',
            url: HOST + "/api/Gen2/DeviceConfig/UserAction2NLog",
            params: { customerId: customerId, deviceId: deviceId, action: action, tabName: tabName //this will take care of url encoding
            } });
    };

    MMPlusRtuSetting.prototype.getNetworkDeviceTypes = function () {
        var self = _this;
        return $http.get(HOST + "/api/Gen2/NetworkDeviceConfig/GetNetworkDeviceTypes"
        //+ "?deviceId=" + deviceId
        //+ '&isNetwrokConfig=' + isNetwrokConfig
        ).then(function (response) {
            self.data = response.data;
            //self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.getCallInIntervals = function () {
        var self = _this;
        return $http.get(HOST + "/api/Gen2/DeviceConfig/GetIntervals").then(function (response) {
            self.data = response.data;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.getSKUs = function () {
        var self = _this;
        return $http.get(HOST + "/api/Gen2/DeviceConfig/GetSKUs").then(function (response) {
            self.data = response.data;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.getChannelAndDeviceConfig = function (deviceId, channel, channelTypeID) {
        var self = this;
        return $http.get(HOST + "/api/Gen2/DeviceConfig/GetChannelAndDeviceConfig" + "?deviceId=" + deviceId + '&channel=' + channel + '&channelTypeID=' + channelTypeID).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.getNetworkDeviceTypeExtLookUp = function () {
        var self = this;
        return $http.get(HOST + "/api/Gen2/NetworkDeviceConfig/GetNetworkDeviceTypeExtLookUp").then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };
    MMPlusRtuSetting.prototype.deleteNetworkDeviceConfig = function (deviceId, networkDeviceConfigID) {
        var self = this;
        return $http.delete(HOST + "/api/Gen2/NetworkDeviceConfig/deleteNetworkDeviceConfig" + "?deviceId=" + deviceId + '&networkDeviceConfigID=' + networkDeviceConfigID).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    MMPlusRtuSetting.prototype.DeviceConfigSave = function (deviceId, imei, deviceG2ConfigList) {
        var self = this;
        return $http.patch(HOST + "/api/Gen2/DeviceConfig/DeviceConfigSave" + "?deviceId=" + deviceId + "&imei=" + imei, deviceG2ConfigList).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return MMPlusRtuSetting;
}

MMPlusRtuSettingFactory.$inject = ['HOST', '$http'];

angular.module('mc.mm-plus-rtu-setting').factory('MMPlusRtuSettingFactory', MMPlusRtuSettingFactory);
'use strict';

function mmPlusRtuSettingController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, MMPlusRtuSettingFactory) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.stickyProperties = ctrl.stickyProperties;
        sharedSetupService.getWindowId(_this2);
        ctrl.initializeSetting();
        ctrl.MMPlusRtuSettingFactory = new MMPlusRtuSettingFactory(ctrl.accountInfo.customerId);
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": "RtuConfiguration",
            "name": ctrl.translation.text.RTU_CONFIGURATION,
            "templateName": "RTU Configuration",
            "templateUrl": "ui/mmplusrtusetting/configuration/mm-plus-configuration.html",
            "height": 135
        }, {
            "id": "RtuNetwork",
            "name": ctrl.translation.text.RTU_NETWORK,
            "templateName": "RTU Network",
            "templateUrl": "ui/mmplusrtusetting/network/mm-plus-network.html",
            "height": 150
        }, {
            "id": "RtuChannel",
            "name": "RTU " + ctrl.translation.text.CHANNEL,
            "templateName": "RTU Channel",
            "templateUrl": "ui/mmplusrtusetting/mmPlusChannel/mm-plus-channel.html",
            "height": 150
        });
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/missionreportssetup/' + tab.templateName.toLowerCase().replace(' ', '-') + '-tab.html';
    };

    ctrl.switchTab = function (tabName) {
        if (tabName == "Channel") {
            ctrl.selectedTab = 2;
        } else if (tabName == "Network") {
            ctrl.selectedTab = 1;
        } else {
            ctrl.selectedTab = 0;
        }
    };

    ctrl.rtuSettingTabs = ctrl.tabConfiguration;

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;
            var _device = { deviceName: $scope.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });
            $scope.$emit('deviceSelectedDone', { message: $scope.deviceSelectedName });
        }
    }, true);

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });

    if (!ctrl.mobile && !ctrl.classicView) {
        ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
        sharedSetupService.maximize(ctrl.popup);

        $scope.adjustSize = function () {
            ctrl.adjustSize();
        };

        ctrl.popup.dialog({
            resize: function resize(event, ui) {
                ctrl.adjustSize();
            }
        });

        ctrl.popup.dialogExtend({
            maximize: function maximize(event, ui) {
                openViewService.adjustContentSizeStart(ctrl.popup);
                ctrl.adjustSize();
            },
            restore: function restore(event, ui) {
                openViewService.adjustContentSizeStart(ctrl.popup);
                ctrl.adjustSize();
            }
        });

        ctrl.adjustSize = function () {
            var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            ctrl.popup.parent().css("height", _tmpHeight);
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
            //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
        };
    };
};

mmPlusRtuSettingController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'MMPlusRtuSettingFactory'];
'use strict';

angular.module('mc.mm-plus-rtu-setting').component('mmPlusRtuSetting', {
    controller: mmPlusRtuSettingController,
    templateUrl: 'ui/mmplusrtusetting/mm-plus-rtu-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

function MMPlusRtuConfigHistoryFactory(HOST, $http) {

      // instantiate our initial object
      var MMPlusRtuConfigHistory = function MMPlusRtuConfigHistory(customerId) {
            this.customerId = customerId;
      };

      MMPlusRtuConfigHistory.prototype.getDeviceConfigHistory = function (deviceId, startDate, endDate) {
            var self = this;
            return $http.get(HOST + "/api/Gen2/ConfigHistory/DeviceConfigHistory" + "?customerId=" + this.customerId + "&deviceId=" + deviceId + "&startDate=" + startDate + '&endDate=' + endDate).then(function (response) {
                  self.data = response.data;
                  self.loading = false;
                  return response;
            });
      };

      MMPlusRtuConfigHistory.prototype.getNetworkConfigHistory = function (deviceId, networkConfigId, startDate, endDate) {
            var self = this;
            return $http.get(HOST + "/api/Gen2/ConfigHistory/NetworkConfigHistory" + "?customerId=" + this.customerId + "&deviceId=" + deviceId + "&networkConfigId=" + networkConfigId + "&startDate=" + startDate + '&endDate=' + endDate).then(function (response) {
                  self.data = response.data;
                  self.loading = false;
                  return response;
            });
      };

      MMPlusRtuConfigHistory.prototype.getChannelConfigHistory = function (deviceId, channel, networkConfigId, startDate, endDate) {
            var self = this;
            return $http.get(HOST + "/api/Gen2/ConfigHistory/ChannelConfigHistory" + "?customerId=" + this.customerId + "&deviceId=" + deviceId + "&channel=" + channel + "&networkConfigId=" + networkConfigId + "&startDate=" + startDate + '&endDate=' + endDate).then(function (response) {
                  self.data = response.data;
                  self.loading = false;
                  return response;
            });
      };

      return MMPlusRtuConfigHistory;
}

MMPlusRtuConfigHistoryFactory.$inject = ['HOST', '$http'];

angular.module('mc.mm-plus-rtu-setting').factory('MMPlusRtuConfigHistoryFactory', MMPlusRtuConfigHistoryFactory);
"use strict";

angular.module("mc.widget-setting", []);
"use strict";

function McWidgetSettingController($, $timeout, $rootScope, $scope, $element, $interval, $compile, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, analogWidgetService, McWidgetsSharedFactory, analogSettingValidationService) {

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            ctrl.mcWidgetSetting = changes.widgetSetting.currentValue;
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.getUiData();
        }
    };

    ctrl.$onInit = function () {
        if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        ctrl.w_tabpaneIsOpen = { "height": "100%", "display": "block" };
        ctrl.w_tabpaneIsClosed = { "height": "0%", "display": "none" };
        ctrl.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };
        ctrl.showHighHighAlarmColorSelector = ctrl.mcWidgetSetting.device.deviceModel == 20 ? true : false;
        //hide tick mark options for lake level widget
        ctrl.showTickMarkOptionSelector = ctrl.mcWidgetSetting.analogGauge.widgetId == 26 ? false : true;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.colorPalet = ctrl.mcWidgetsSharedFactory.getColorPalet();
        ctrl.gaugeMinError = "";
        ctrl.gaugeMaxError = "";
    };

    ctrl.setModel = function (parm) {
        ctrl.clearModel();
        $timeout(function () {
            ctrl.parm = parm;
        }, 0);
    };

    ctrl.clearModel = function () {
        ctrl.parm = null;
    };

    ctrl.testNgChange = function () {
        ctrl.validateColors(true);
    };

    ctrl.selectColor = function (event) {
        switch (ctrl.parm) {
            case "lowAlarmColor":
                ctrl.lowAlarmColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "normalColor":
                ctrl.normalColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "highAlarmColor":
                ctrl.highAlarmColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "highHighAlarmColor":
                ctrl.highHighAlarmColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            default:
            // code block
        }

        ctrl.clearModel();
        ctrl.validateColors(true);
    };

    ctrl.updateDisplayOptions = function (param) {

        var tmpNewAnalogWidgetSetting = angular.copy(ctrl.mcWidgetSetting.analogWidgetSetting);
        // Update the gauge as soon as gaugeMinValue and gaugeMaxValue is updated
        tmpNewAnalogWidgetSetting.gaugeMinValue = ctrl.gaugeMinValue;
        tmpNewAnalogWidgetSetting.gaugeMaxValue = ctrl.gaugeMaxValue;
        tmpNewAnalogWidgetSetting.customerId = ctrl.accountInfo.customerId;
        tmpNewAnalogWidgetSetting.deviceId = ctrl.mcWidgetSetting.device.deviceId;
        tmpNewAnalogWidgetSetting.channel = ctrl.mcWidgetSetting.analogGauge.channel;

        if (!angular.isUndefined(param.settingOptions.marksType)) {
            tmpNewAnalogWidgetSetting.tickMarksId = param.settingOptions.marksType.id;
            ctrl.updateUiData(param, tmpNewAnalogWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.heardTypeOption)) {
            tmpNewAnalogWidgetSetting.dateTimeFormatId = param.settingOptions.heardTypeOption.id;
            ctrl.updateUiData(param, tmpNewAnalogWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.sizeOption)) {
            tmpNewAnalogWidgetSetting.sizeId = param.settingOptions.sizeOption.id;
            ctrl.updateUiData(param, tmpNewAnalogWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.themeOption)) {
            tmpNewAnalogWidgetSetting.themeId = param.settingOptions.themeOption.id;
            ctrl.updateUiData(param, tmpNewAnalogWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.colorOption)) {
            tmpNewAnalogWidgetSetting.lowAlarmColor = param.settingOptions.colorOption.low;
            tmpNewAnalogWidgetSetting.normalColor = param.settingOptions.colorOption.normal;
            tmpNewAnalogWidgetSetting.highAlarmColor = param.settingOptions.colorOption.high;
            tmpNewAnalogWidgetSetting.highHighAlarmColor = param.settingOptions.colorOption.highHigh;
            ctrl.updateUiData(param, tmpNewAnalogWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.rtuOption)) {

            ctrl.getChannels(param.settingOptions.rtuOption.deviceId, true);
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: param.settingOptions.rtuOption.deviceId, channel: ctrl.channelSelectedOption.channel } } });
        }

        if (!angular.isUndefined(param.settingOptions.channelOption) && param.settingOptions.channelOption !== null) {
            ctrl.channelSelectedOption = { channel: param.settingOptions.channelOption.channel };
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: ctrl.rtuSelectedOption.deviceId, channel: param.settingOptions.channelOption.channel } } });
        }

        if (!angular.isUndefined(param.settingOptions.gaugeMinValue) || !angular.isUndefined(param.settingOptions.gaugeMaxValue)) {
            if (!ctrl.validateGaugeRange(param, tmpNewAnalogWidgetSetting)) {
                return;
            }
            ctrl.updateUiData(param, tmpNewAnalogWidgetSetting);
        }
    };

    ctrl.updateUiData = function (param, naws) {
        ctrl.mcWidgetsSharedFactory.updateUiData(param, naws, "GaugeAnalogWidget", "newMcWidgetSettingOptions", ctrl);
        if (param.settingOptions.hasOwnProperty("gaugeMinValue") || param.settingOptions.hasOwnProperty("gaugeMaxValue")) {
            ctrl.broadcastToReloadGauges(naws);
        }
    };

    ctrl.getUiData = function () {
        ctrl.mcWidgetsSharedFactory.getUiData("mcWidgetSettingOptions", "All", ctrl);
    };

    ctrl.getSetting = function () {
        analogWidgetService.getSettings(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.rtuOptions = result.data.analogDevices;
            ctrl.analogSettings = result.data.analogSettings;

            ctrl.getChannels(ctrl.mcWidgetSetting.device.deviceId);

            ctrl.rtuSelectedOption = { deviceId: ctrl.mcWidgetSetting.device.deviceId, name: ctrl.mcWidgetSetting.device.name };
        }, function (error) {});
    };

    ctrl.getChannels = function (deviceId, firstChannel) {
        ctrl.channelOptions = [];

        angular.forEach(ctrl.analogSettings, function (analogSetting) {
            if (parseInt(deviceId) === parseInt(analogSetting.deviceId)) {
                ctrl.channelOptions.push(analogSetting);
            }
        });

        if (firstChannel) {
            ctrl.channelSelectedOption = { channel: ctrl.channelOptions.length != 0 ? ctrl.channelOptions[0].channel : 1, name: ctrl.channelOptions.length != 0 ? ctrl.channelOptions[0].name : "" };
        } else {
            ctrl.channelSelectedOption = { channel: ctrl.mcWidgetSetting.analogGauge.channel, name: ctrl.mcWidgetSetting.analogGauge.name };
        }
    };

    ctrl.setOptions = function () {
        ctrl.chartTimeOptions = ctrl.mcWidgetSettingOptions.trendingChart;
        ctrl.chartTimeSelectedOption = { option: "Off" }; //{ option: ctrl.mcWidgetSetting.analogWidgetSetting.trendingChart };

        ctrl.heardTypeOptions = ctrl.mcWidgetSettingOptions.dateTimeFormat;
        ctrl.heardTypeSelectedOption = { id: ctrl.mcWidgetSetting.analogWidgetSetting.dateTimeFormatId };

        ctrl.marksTypeOptions = ctrl.mcWidgetSettingOptions.tickMarks;
        ctrl.marksTypeSelectedOption = { id: ctrl.mcWidgetSetting.analogWidgetSetting.tickMarksId };

        ctrl.themeOptions = ctrl.mcWidgetSettingOptions.theme;
        ctrl.themeSelectedOption = { id: ctrl.mcWidgetSetting.analogWidgetSetting.themeId };

        ctrl.sizeOptions = ctrl.mcWidgetSettingOptions.size;
        ctrl.sizeSelectedOption = { id: ctrl.mcWidgetSetting.analogWidgetSetting.sizeId };

        ctrl.lowAlarmColor = ctrl.mcWidgetSetting.analogWidgetSetting.lowAlarmColor;
        ctrl.normalColor = ctrl.mcWidgetSetting.analogWidgetSetting.normalColor;
        ctrl.highAlarmColor = ctrl.mcWidgetSetting.analogWidgetSetting.highAlarmColor;
        ctrl.highHighAlarmColor = ctrl.mcWidgetSetting.analogWidgetSetting.highHighAlarmColor;

        // When gauge is populated 
        ctrl.gaugeMinValue = ctrl.mcWidgetSetting.analogWidgetSetting.gaugeMinValue;
        ctrl.gaugeMaxValue = ctrl.mcWidgetSetting.analogWidgetSetting.gaugeMaxValue;
        // ctrl.widgetId = ctrl.mcWidgetSetting.analogWidgetSetting.widgetId;
        ctrl.minVal = ctrl.mcWidgetSetting.analogGauge.minVal;
        ctrl.maxVal = ctrl.mcWidgetSetting.analogGauge.maxVal;
        ctrl.validateColors();
    };

    ctrl.validateColors = function (_dataChanged) {
        if (ctrl.lowAlarmColor.length !== 7 || ctrl.lowAlarmColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidLowAlarmColor = true;
        } else {
            ctrl.invalidLowAlarmColor = false;
        }
        if (ctrl.normalColor.length !== 7 || ctrl.normalColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidNormalColor = true;
        } else {
            ctrl.invalidNormalColor = false;
        }
        if (ctrl.highAlarmColor.length !== 7 || ctrl.highAlarmColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidHighAlarmColor = true;
        } else {
            ctrl.invalidHighAlarmColor = false;
        }
        if (ctrl.mcWidgetSetting.device.deviceModel == 20) {
            if (ctrl.highHighAlarmColor.length !== 7 || ctrl.highHighAlarmColor.charAt(0) !== "#") {
                ctrl.invalidColor = true;
                ctrl.invalidHighHighAlarmColor = true;
            } else {
                ctrl.invalidHighHighAlarmColor = false;
            }
        }

        ctrl.invalidColor = ctrl.mcWidgetSetting.device.deviceModel == 20 ? ctrl.invalidLowAlarmColor || ctrl.invalidNormalColor || ctrl.invalidHighAlarmColor || ctrl.invalidHighHighAlarmColor ? true : false : ctrl.invalidLowAlarmColor || ctrl.invalidNormalColor || ctrl.invalidHighAlarmColor ? true : false;

        if (_dataChanged && !ctrl.invalidColor) {
            ctrl.updateDisplayOptions({
                settingOptions: {
                    colorOption: {
                        low: ctrl.lowAlarmColor,
                        normal: ctrl.normalColor,
                        high: ctrl.highAlarmColor,
                        highHigh: ctrl.highHighAlarmColor
                    }
                }
            });
        }
    };

    ctrl.showTab = function (parm) {
        ctrl.clearModel();
        var element = $element.find(".w_tabbox");
        ctrl.mcWidgetsSharedFactory.showTab(parm, element, ctrl);
    };

    ctrl.translateOptions = function () {
        ctrl.themeOptions.forEach(function (option) {
            return option.name = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.sizeOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.heardTypeOptions.forEach(function (option) {
            return option.type = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.marksTypeOptions.forEach(function (option) {
            return option.state = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.chartTimeOptions.forEach(function (option) {
            return option.option = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
    };

    var _onUpdatePreferencesLanguage = $rootScope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translateOptions();
    });

    ctrl.validateGaugeRange = function (param, tmpNewAnalogWidgetSetting) {

        var validationResult = analogSettingValidationService.validateGaugeRange({
            minValue: ctrl.mcWidgetSetting.analogGauge.minVal,
            maxValue: ctrl.mcWidgetSetting.analogGauge.maxVal,
            gaugeMinValue: param.settingOptions.hasOwnProperty("gaugeMinValue") ? param.settingOptions.gaugeMinValue : tmpNewAnalogWidgetSetting.gaugeMinValue,
            gaugeMaxValue: param.settingOptions.hasOwnProperty("gaugeMaxValue") ? param.settingOptions.gaugeMaxValue : tmpNewAnalogWidgetSetting.gaugeMaxValue,
            changedField: param.settingOptions.hasOwnProperty("gaugeMinValue") ? "gaugeMinValue" : "gaugeMaxValue"
        });

        if (!validationResult.valid) {
            ctrl.gaugeMinError = validationResult.field === "gaugeMinValue" ? validationResult.message : "";
            ctrl.gaugeMaxError = validationResult.field === "gaugeMaxValue" ? validationResult.message : "";
            return false;
        }
        // Clear error messages
        ctrl.gaugeMinError = "";
        ctrl.gaugeMaxError = "";

        tmpNewAnalogWidgetSetting.gaugeMinValue = validationResult.gaugeMinValue;
        tmpNewAnalogWidgetSetting.gaugeMaxValue = validationResult.gaugeMaxValue;
        ctrl.mcWidgetSetting.analogWidgetSetting.gaugeMinValue = validationResult.gaugeMinValue;
        ctrl.mcWidgetSetting.analogWidgetSetting.gaugeMaxValue = validationResult.gaugeMaxValue;

        return true;
    };

    ctrl.broadcastToReloadGauges = function (options) {
        $rootScope.$broadcast("updateGuageMinMaxforGauges", {
            deviceId: options.deviceId,
            channel: options.channel,
            gaugeMinValue: options.gaugeMinValue,
            gaugeMaxValue: options.gaugeMaxValue,
            //the widget this settings panel belongs to redraws in place instead of being recreated (keeps Tab focus)
            settingDialog: $element.closest('.ui-dialog')[0]
        });
    };

    //Returns true when Enter/Space is pressed so keyboard users can activate tabs and buttons that only had ng-click
    ctrl.isActivationKey = function (event) {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return false;
        event.preventDefault();
        event.stopPropagation();
        return true;
    };

    $scope.$on("$destroy", function () {
        _onUpdatePreferencesLanguage();
    });
}

McWidgetSettingController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', '$interval', '$compile', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'analogWidgetService', 'McWidgetsSharedFactory', 'analogSettingValidationService'];
'use strict';

angular.module('mc.widget-setting').component('mcWidgetSetting', {
    controller: McWidgetSettingController,
    templateUrl: 'ui/mcwidgetsetting/mcwidget-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        changeDisplayOptions: '&'
    }
});
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function MemoryCacheController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, UpdateDeviceInfoFactory, deviceMenuService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.firstLoad = true;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        ctrl.isAdmin = sharedSetupService.isAdmin(ctrl.accountInfo);
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        $scope.stickyProperties = ctrl.stickyProperties;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(_this2);

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        };

        ctrl.initializeSetting();
    };

    ctrl.adjustSize = function () {
        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": 0,
            "name": ctrl.translation.text.CUSTOMERS,
            "templateName": "Customers",
            "templateUrl": "ui/memorycache/cachekey/cache-key-template.html",
            "height": 135
        });
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return tab.templateUrl;
    };

    ctrl.selectTab = function (id) {
        ctrl.selectedTab = id;
    };

    ctrl.memoryCacheTabs = ctrl.tabConfiguration;

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {});
};

MemoryCacheController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'UpdateDeviceInfoFactory', 'deviceMenuService'];
'use strict';

angular.module('mc.memory-cache').component('memoryCache', {
    controller: MemoryCacheController,
    templateUrl: 'ui/memorycache/memory-cache-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.widget-temperature-setting", []);
"use strict";

function McWidgetTemperatureSettingController($, $timeout, $rootScope, $scope, $element, $interval, $compile, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, digitalWidgetService, McWidgetsSharedFactory) {

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            ctrl.mcWidgetTemperatureSetting = changes.widgetSetting.currentValue;
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.getUiData();
        }
    };

    ctrl.$onInit = function () {
        if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        ctrl.w_tabpaneIsOpen = { "height": "100%", "display": "block" };
        ctrl.w_tabpaneIsClosed = { "height": "0%", "display": "none" };
        ctrl.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.colorPalet = ctrl.mcWidgetsSharedFactory.getColorPalet();
    };

    ctrl.setModel = function (parm) {
        ctrl.clearModel();
        $timeout(function () {
            ctrl.parm = parm;
        }, 0);
    };

    ctrl.clearModel = function () {
        ctrl.parm = null;
    };

    ctrl.testNgChange = function () {
        ctrl.validateColors(true);
    };

    ctrl.selectColor = function (event) {
        switch (ctrl.parm) {
            case "lowAlarmColor":
                ctrl.lowAlarmColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "normalColor":
                ctrl.normalColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "highAlarmColor":
                ctrl.highAlarmColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            default:
            // code block
        }

        ctrl.clearModel();
        ctrl.validateColors(true);
    };

    ctrl.updateDisplayOptions = function (param) {

        var tmpNewTemperatureWidgetSetting = angular.copy(ctrl.mcWidgetTemperatureSetting.temperatureWidgetSetting);
        tmpNewTemperatureWidgetSetting.customerId = ctrl.accountInfo.customerId;
        tmpNewTemperatureWidgetSetting.deviceId = ctrl.mcWidgetTemperatureSetting.device.deviceId;
        tmpNewTemperatureWidgetSetting.channel = 0;

        if (!angular.isUndefined(param.settingOptions.marksType)) {
            tmpNewTemperatureWidgetSetting.tickMarksId = param.settingOptions.marksType.id;
            ctrl.updateUiData(param, tmpNewTemperatureWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.heardTypeOption)) {
            tmpNewTemperatureWidgetSetting.dateTimeFormatId = param.settingOptions.heardTypeOption.id;
            ctrl.updateUiData(param, tmpNewTemperatureWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.sizeOption)) {
            tmpNewTemperatureWidgetSetting.sizeId = param.settingOptions.sizeOption.id;
            ctrl.updateUiData(param, tmpNewTemperatureWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.themeOption)) {
            tmpNewTemperatureWidgetSetting.themeId = param.settingOptions.themeOption.id;
            ctrl.updateUiData(param, tmpNewTemperatureWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.colorOption)) {
            tmpNewTemperatureWidgetSetting.lowAlarmColor = param.settingOptions.colorOption.low;
            tmpNewTemperatureWidgetSetting.normalColor = param.settingOptions.colorOption.normal;
            tmpNewTemperatureWidgetSetting.highAlarmColor = param.settingOptions.colorOption.high;
            ctrl.updateUiData(param, tmpNewTemperatureWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.rtuOption)) {

            //ctrl.getChannels(param.settingOptions.rtuOption.deviceId, true);
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: param.settingOptions.rtuOption.deviceId } } });
        }

        if (!angular.isUndefined(param.settingOptions.channelOption)) {
            ctrl.channelSelectedOption = { channel: param.settingOptions.channelOption.channel };
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: ctrl.rtuSelectedOption.deviceId, channel: param.settingOptions.channelOption.channel } } });
        }
    };

    ctrl.updateUiData = function (param, naws) {
        ctrl.mcWidgetsSharedFactory.updateUiData(param, naws, "GaugeAnalogWidget", "newMcWidgetSettingOptions", ctrl);
    };

    ctrl.getUiData = function () {
        ctrl.mcWidgetsSharedFactory.getUiData("mcWidgetSettingOptions", "All", ctrl);
    };

    ctrl.getSetting = function () {
        digitalWidgetService.getSettings(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.rtuOptions = result.data.digitalDevices;
            //ctrl.analogSettings = result.data.analogSettings;

            //ctrl.getChannels(ctrl.mcWidgetSetting.device.deviceId);

            ctrl.rtuSelectedOption = { deviceId: ctrl.mcWidgetTemperatureSetting.device.deviceId, name: ctrl.mcWidgetTemperatureSetting.device.name };
        }, function (error) {});
    };

    //ctrl.getChannels = function (deviceId, firstChannel) {
    //    ctrl.channelOptions = [];

    //    angular.forEach(ctrl.analogSettings, function (analogSetting) {
    //        if (parseInt(deviceId) === parseInt(analogSetting.deviceId)) {
    //            ctrl.channelOptions.push(analogSetting);
    //        }
    //    });

    //    if (firstChannel) {
    //        ctrl.channelSelectedOption = { channel: ctrl.channelOptions[0].channel, name: ctrl.channelOptions[0].name };
    //    } else {
    //        ctrl.channelSelectedOption = { channel: ctrl.mcWidgetSetting.analogGauge.channel, name: ctrl.mcWidgetSetting.analogGauge.name };
    //    }

    //};

    ctrl.setOptions = function () {
        ctrl.chartTimeOptions = ctrl.mcWidgetSettingOptions.trendingChart;
        ctrl.chartTimeSelectedOption = { option: "Off" }; //{ option: ctrl.mcWidgetSetting.analogWidgetSetting.trendingChart };

        ctrl.heardTypeOptions = ctrl.mcWidgetSettingOptions.dateTimeFormat;
        ctrl.heardTypeSelectedOption = { id: ctrl.mcWidgetTemperatureSetting.temperatureWidgetSetting.dateTimeFormatId };

        ctrl.marksTypeOptions = ctrl.mcWidgetSettingOptions.tickMarks;
        ctrl.marksTypeSelectedOption = { id: ctrl.mcWidgetTemperatureSetting.temperatureWidgetSetting.tickMarksId };

        ctrl.themeOptions = ctrl.mcWidgetSettingOptions.theme;
        ctrl.themeSelectedOption = { id: ctrl.mcWidgetTemperatureSetting.temperatureWidgetSetting.themeId };

        ctrl.sizeOptions = ctrl.mcWidgetSettingOptions.size;
        ctrl.sizeSelectedOption = { id: ctrl.mcWidgetTemperatureSetting.temperatureWidgetSetting.sizeId };

        ctrl.lowAlarmColor = ctrl.mcWidgetTemperatureSetting.temperatureWidgetSetting.lowAlarmColor;
        ctrl.normalColor = ctrl.mcWidgetTemperatureSetting.temperatureWidgetSetting.normalColor;
        ctrl.highAlarmColor = ctrl.mcWidgetTemperatureSetting.temperatureWidgetSetting.highAlarmColor;
        ctrl.validateColors();
    };

    ctrl.validateColors = function (_dataChanged) {
        if (ctrl.lowAlarmColor.length !== 7 || ctrl.lowAlarmColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidLowAlarmColor = true;
        } else {
            ctrl.invalidLowAlarmColor = false;
        }
        if (ctrl.normalColor.length !== 7 || ctrl.normalColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidNormalColor = true;
        } else {
            ctrl.invalidNormalColor = false;
        }
        if (ctrl.highAlarmColor.length !== 7 || ctrl.highAlarmColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidHighAlarmColor = true;
        } else {
            ctrl.invalidHighAlarmColor = false;
        }

        ctrl.invalidColor = ctrl.invalidLowAlarmColor || ctrl.invalidNormalColor || ctrl.invalidHighAlarmColor ? true : false;

        if (_dataChanged && !ctrl.invalidColor) {
            ctrl.updateDisplayOptions({
                settingOptions: {
                    colorOption: {
                        low: ctrl.lowAlarmColor,
                        normal: ctrl.normalColor,
                        high: ctrl.highAlarmColor
                    }
                }
            });
        }
    };

    ctrl.showTab = function (parm) {
        ctrl.clearModel();
        var element = $element.find(".w_tabbox");
        ctrl.mcWidgetsSharedFactory.showTab(parm, element, ctrl);
    };

    ctrl.translateOptions = function () {
        ctrl.themeOptions.forEach(function (option) {
            return option.name = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.sizeOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.heardTypeOptions.forEach(function (option) {
            return option.type = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.marksTypeOptions.forEach(function (option) {
            return option.state = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.chartTimeOptions.forEach(function (option) {
            return option.option = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
    };

    var _onUpdatePreferencesLanguage = $rootScope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translateOptions();
    });

    $scope.$on("$destroy", function () {
        _onUpdatePreferencesLanguage();
    });
}

McWidgetTemperatureSettingController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', '$interval', '$compile', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'digitalWidgetService', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-temperature-setting').component('mcWidgetTemperatureSetting', {
    controller: McWidgetTemperatureSettingController,
    templateUrl: 'ui/mcwidgettemperaturesetting/mcwidget-temperature-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        changeDisplayOptions: '&'
    }
});
"use strict";

angular.module("mc.mission-reports-setup", []);
mcapp.controller('missionReportsSetupController', ['$rootScope', '$scope', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', function ($rootScope, $scope, sharedSetupService, openViewService, translationService, authenticationService) {
    sharedSetupService.getWindowId($scope);
    $scope.devicename = null;
    $scope.unit = null;
    $scope.myDate = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.minPadding = sharedSetupService.minPadding;
    $scope.maxPadding = sharedSetupService.maxPadding;
    $scope.topMenuMarginLeft = $rootScope.mobile ? '-206px' : '-278px';
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
    $scope.loadingInProgress = true;
    $scope.translation = translationService.translation;
    $scope.spinner = "<i class='fa fa-spinner fa-2x fa-spin'></i>";
    $scope.okCheck = ""; //"<i class='fa fa-check fa-2x fa-green' ></i>";
    $scope.errorCheck = "<i class='fa fa-exclamation-circle fa-2x fa-red'></i>";
    $scope.resetIndicator = "<i class='fa fa-fw fa-2x'>&nbsp;</i>";
    $scope.activeTab = 0;

    $scope.isAdmin = $scope.accountInfo.userRole == 'Administrator' || $scope.accountInfo.userRole == 'SuperAdministrator' ? true : false;

    sharedSetupService.broadcastAllDeviceSelected($scope);

    if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }

    var tabConfiguration = [];
    var resizeTabIdString = "";

    var _tabConfiguration = function () {
        var len = arguments.length,
        i = 0;
        var tmpLength = tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                tabConfiguration.push(arguments[i]);
                resizeTabIdString += resizeTabIdString.length === 0 ? "#" + arguments[i].id : ", #" + arguments[i].id;
            } else {
                tabConfiguration[i].name = arguments[i].name;
            }
        }
    };


    var _initializeSetting = function () {
        _tabConfiguration(
            {
                "id": "DailyRuntime",
                "name": $scope.translation.text.DAILY_RUNTIME,
                "templateName": "Daily Runtime",
                "templateUrl": "ui/missionreportssetup/runtimereportsetup/runtime-report-setup-d.html",
                "height": 135
            },
            {
                "id": "DailyStation",
                "name": "Daily Station",
                "templateName": "Daily Station",
                "templateUrl": "ui/missionreportssetup/dailystationreport/daily-station-report.html",
                "height": 150
            },
            {
                'id': 'MonthlyRuntime',
                'name': $scope.translation.text.MONTHLY_RUNTIME,
                'templateName': 'Monthly Runtime',
                'templateUrl': 'ui/missionreportssetup/runtimereportsetup/runtime-report-setup-m.html',
                'height': 400
            },
            {
                "id": "WeeklyManagement",
                "name": $scope.translation.text.WEEKLY_MANAGEMENT,
                "templateName": "Weekly Management",
                "templateUrl": "ui/missionreportssetup/weeklymanagementreport/weekly-management-report.html",
                "height": 150
            },
            {
                "id": "DailyStation",
                "name": "Daily Station",
                "templateName": "Daily Station",
                "templateUrl": "ui/missionreportssetup/dailystationreport/daily-station-report.html",
                "height": 150
            }
        );
    };

    _initializeSetting();

    $scope.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/missionreportssetup/' + (tab.templateName).toLowerCase().replace(' ', '-') + '-tab.html';
    }

    $scope.missionReportsSetupTabs = tabConfiguration;

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        _initializeSetting();
    });

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);
        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
				openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            $scope.popup.parent().css("height", _tmpHeight);
            //var _topMenu = typeof $scope.popup.parent().find('.top-menu').css("height") !== "undefined" ? $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") : 20;
            var _title = $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "");
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            $scope.popup.parent().find('.form-group').css("width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "") - 40);
            $scope.popup.parent().find('.ui-tabs-panel, .form-group').css("height", _tmpHeight - 150 - _title + 28); //28 title height
            $scope.popup.parent().find('.form-group').css("overflow-y", "auto").css("overflow-x", "hidden");

            //will think about this
            //if ($scope.typeId == 2 || $scope.typeId == 3) {
            $scope.popup.parent().find('' + resizeTabIdString + '').css("height", _tmpHeight - 150 - _title + 28 + 52); //28 title height
            $scope.popup.parent().find('' + resizeTabIdString + '').css("overflow-y", "auto").css("overflow-x", "hidden");
            //}
            //will think about this
            $scope.tabsSize(_tmpHeight - 70 - _title + 28); //28 title height
            $rootScope.$broadcast('contentAdjusted');
            //form-group
        };
    }
}]);

mcapp.directive('missionReportsSetupTabs', ['$rootScope', '$timeout', 'temperatureDataService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', function ($rootScope, $timeout, temperatureDataService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        setTimeout(function () {
            element.tabs({
                active: 0,
                select: function (event) {
                    // You need Firebug or the developer tools on your browser open to see these
                    //console.log(event);
                    // This will get you the index of the tab you selected
                    //console.log(event.options.selected);
                    // And this will get you it's name
                    //console.log(event.tab.text);
                },
                activate: function (event, ui) {
                    scope.activeTab = ui.newTab.index();
                    scope.$apply();
                    if (scope.activeTab === 0) {
                        //
                    }
                    if (!$rootScope.mobile && !$rootScope.classicView) scope.adjustSize();
                },
                create: function (event, ui) {
                    scope.activeTab = 0;
                }
            });
            if (!$rootScope.mobile && !$rootScope.classicView) scope.adjustSize();
        }, 0);

        scope.tabsSize = function (varHeight) {
            $(element).find(".ui-tabs-panel").css("height", varHeight);
        };

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });

                setTimeout(function () {
                    element.tabs("option", "active", 0);
                }, 0);

            }
        }, true);

    };
}]);

'use strict';

function MissionReportsSetupController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, $timeout, $filter, toaster, $uibModal, wizardSplashService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this2);
        ctrl.initializeSetting();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        }
    };

    ctrl.adjustSize = function () {
        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
        ctrl.missionReportsSetupTabs = ctrl.tabConfiguration;
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": "Daily",
            "name": ctrl.translation.text.DAILY,
            "templateName": "dailyReports",
            "templateUrl": "ui/missionreportssetup/dailyreports/daily-reports.html",
            "height": 135
        }, {
            "id": "Weekly",
            "name": ctrl.translation.text.WEEKLY_MANAGMENT,
            "templateName": "Weekly",
            "templateUrl": "ui/missionreportssetup/weeklyreports/weekly-reports-setup.html",
            "height": 150
        }, {
            "id": "Monthly",
            "name": ctrl.translation.text.MONTHLY,
            "templateName": "Monthly",
            "templateUrl": "ui/missionreportssetup/dailyreports/dailyruntimereportsetup/runtime-report-setup-m.html",
            "height": 150
        }, {
            'id': 'SchedulingService',
            'name': ctrl.translation.text.SCHEDULING_SERVICE,
            'templateName': 'Scheduling Service',
            'templateUrl': 'ui/missionreportssetup/schedulingservice/scheduling-service.html',
            'height': 150
        }, {
            'id': 'ConfigSafeWaterReport',
            'name': ctrl.translation.text.CONFIG_SAFE_WATER_REPORT,
            'templateName': 'Config Safe Water Report',
            'templateUrl': 'ui/missionreportssetup/configsafewaterreport/config-safe-water-report.html',
            'height': 150
        });
    };

    ctrl.getTemplateSource = function (index) {
        var tab = ctrl.missionReportsSetupTabs[ctrl.selectedTab];
        return tab.templateUrl;
    };

    ctrl.switchTab = function (tabName) {
        if (tabName == "ConfigSafeWaterReport") {
            ctrl.selectedTab = 4;
        } else if (tabName == "SchedulingService") {
            ctrl.selectedTab = 3;
        } else if (tabName == "MonthlyReports") {
            ctrl.selectedTab = 2;
        } else if (tabName == "WeeklyReports") {
            ctrl.selectedTab = 1;
        } else {
            ctrl.selectedTab = 0;
        }
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });
};

MissionReportsSetupController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$timeout', '$filter', 'toaster', '$uibModal', 'wizardSplashService'];
'use strict';

angular.module('mc.mission-reports-setup').component('missionReportsSetup', {
    controller: MissionReportsSetupController,
    templateUrl: 'ui/missionreportssetup/mission-reports-setup-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mission-data-usage", []);
"use strict";

function MissionDataUsageFactory(HOST, $http) {

    function GetData(deviceId, month, year, timeZone) {
        return $http.get(HOST + "/api/DataUsageChart" + "?deviceId=" + deviceId + "&month=" + month + "&year=" + year + "&timeZone=" + timeZone).then(function (response) {
            return response;
        });
    }

    return {
        GetData: GetData
    };
}

MissionDataUsageFactory.$inject = ['HOST', '$http'];

angular.module('mission-data-usage').factory('MissionDataUsageFactory', MissionDataUsageFactory);
"use strict";

function MissionDataUsageController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, $timeout, $filter, $element, deviceMenuService, MissionDataUsageFactory) {
    var _this = this;

    var ctrl = this;
    $scope.alerts = [];
    sharedSetupService.broadcastAllDeviceSelected($scope);
    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        $scope.stickyProperties = _this.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.currentYear = new Date().getFullYear();
        $scope.totalInludedKB = [];
        ctrl.MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        ctrl.element = $element.find('.vfs-chart');
        ctrl.element.addClass('chart');
        //$scope.$watch(() => $scope.deviceSelected, (newVal, oldVal) => {
        //    if (newVal) {
        //        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newVal, windowId: this.windowId });
        //        if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
        //            $scope.stickyProperties.on = true;
        //        } else {
        //            $scope.stickyProperties.on = false;
        //        }
        //        ctrl.deviceId = newVal;
        //        ctrl.deviceName = $scope.deviceSelectedName;
        //        ctrl.setReportDate(0);
        //    }
        //}, true);

        if (ctrl.deviceId) ctrl.setReportDate(0); //


        //   if (!ctrl.mobile && !ctrl.classicView) {

        //       $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
        //       sharedSetupService.maximize($scope.popup);

        //       $scope.popup.dialog({
        //           resize: function (event, ui) {
        //               $scope.adjustSize();
        //           }
        //       });

        //       $scope.popup.dialogExtend({
        //           maximize: function (event, ui) {
        //               openViewService.adjustContentSizeStart($scope.popup);
        //           	$scope.adjustSize();
        //           },
        //           restore: function (event, ui) {
        //openViewService.adjustContentSizeStart($scope.popup);
        //               $scope.adjustSize();
        //           }
        //       });

        //       $scope.adjustSize = function () {
        //           var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        //           $scope.popup.parent().css("height", _tmpHeight);
        //           $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
        //           $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        //           $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        //           $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        //           var _char = $scope.popup.parent().find('.chart').highcharts();
        //           if ($scope.popup.parent().find(".chart").highcharts()) {
        //               _char.reflow();
        //           }
        //       };
        //   }
    };
    ctrl.getMonthTransaltion = function (month) {
        switch (month) {
            case "January":
                return ctrl.translation.text.JANUARY;
            case "February":
                return ctrl.translation.text.FEBRUARY;
            case "March":
                return ctrl.translation.text.MARCH;
            case "April":
                return ctrl.translation.text.APRIL;
            case "May":
                return ctrl.translation.text.MAY;
            case "June":
                return ctrl.translation.text.JUNE;
            case "July":
                return ctrl.translation.text.JULY;
            case "August":
                return ctrl.translation.text.AUGUST;
            case "September":
                return ctrl.translation.text.SEPTEMBER;
            case "October":
                return ctrl.translation.text.OCTOBER;
            case "November":
                return ctrl.translation.text.NOVEMBER;
            case "December":
                return ctrl.translation.text.DECEMBER;
        }
    };
    //Add this part after integration with other view

    // ctrl.$onChanges = (changes) => {
    //     if (changes.deviceId.currentValue && changes.deviceId.currentValue != changes.deviceId.previousValue) {
    //         if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
    //         console.log("Device Id on change", ctrl.deviceId);
    //         ctrl.getData();
    //     }
    // };

    ctrl.getData = function () {
        $scope.alerts = [];
        $scope.categories = [];
        $scope.dataSetTotalKB = [];
        $scope.dataSetOnNetworkKB = [];
        MissionDataUsageFactory.GetData(ctrl.deviceId, ctrl.monthSelect, ctrl.yearSelect, ctrl.accountInfo.timeZone).then(function (resp) {
            ctrl.missionDataUsage = resp.data.missionDataUsage;
            ctrl.ratePlan = resp.data.ratePlan;
            ctrl.ratePlanKB = resp.data.ratePlanKB;
            ctrl.simNumber = resp.data.simNumber;
            ctrl.deviceName = resp.data.deviceName;
            ctrl.wirelessCarrier = resp.data.wirelessCarrier;

            if (ctrl.missionDataUsage.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                $scope.alerts.push({
                    msg: errorMessage,
                    type: "info"
                });
                if (ctrl.chart) {
                    ctrl.chart.destroy();
                }
            } else {
                var totalUsage = 0;
                for (var i = 0; i < ctrl.missionDataUsage.length; i++) {
                    totalUsage = totalUsage + ctrl.missionDataUsage[i].totalKB;
                    $scope.dataSetTotalKB.push(totalUsage);
                    $scope.dataSetOnNetworkKB.push(ctrl.missionDataUsage[i].onNetworkKB);
                    var reportdate = new Date(ctrl.missionDataUsage[i].reportDate);
                    $scope.categories.push(ctrl.getMonthTransaltion(ctrl.MONTH_NAMES[reportdate.getMonth()]) + reportdate.getDate());
                }
                $timeout(function () {
                    ctrl.drawChart();
                    //if (!$rootScope.mobile && !$rootScope.classicView) $scope.adjustSize();
                    ctrl.loading = false;
                }, 10);
            }
        });
    };

    ctrl.setReportDate = function (months) {
        if (months == 0) ctrl.reportDate = new Date();
        var d = new Date(ctrl.reportDate || new Date());
        d.setMonth(d.getMonth() + (months || 0), d.getDate());
        ctrl.reportDate = d;
        ctrl.adjustButtons();
        ctrl.missionDataUsage = [];
        ctrl.monthSelect = d.getMonth() + 1;
        ctrl.yearSelect = d.getFullYear();
        ctrl.getData();
    };

    ctrl.adjustButtons = function () {
        if (new Date(ctrl.reportDate.getFullYear(), ctrl.reportDate.getMonth() + 1, 0).getTime() === new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime()) {
            ctrl.todaysDate = true;
            ctrl.nextDate = true;
        } else {
            ctrl.todaysDate = false;
            ctrl.nextDate = false;
        }
    };
    ctrl.drawChart = function () {
        ctrl.chart = new Highcharts.chart({
            chart: {
                renderTo: ctrl.element[0],
                events: {
                    load: function load(event) {
                        //if (initialLoad) 
                        //openViewService.adjustContentSize($scope.popup);
                    }
                }
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                }
            },
            credits: {
                enabled: false
            },
            title: {
                text: ctrl.translation.text.DATA_USAGE + "(" + ctrl.translation.text.ACCORDING_TO + " " + ctrl.wirelessCarrier + ") - SIM: " + ctrl.simNumber
            },
            subtitle: {
                text: ctrl.accountInfo.customerName + '/ ' + ctrl.deviceName
            },
            xAxis: [{
                title: {
                    text: ctrl.translation.text.DAY_OF_MONTH
                },
                categories: $scope.categories,
                slantedText: true,
                minRange: null,
                labels: {
                    rotation: 270
                }
            }],
            yAxis: {
                title: {
                    text: ctrl.translation.text.DATA_USAGE_KB
                },
                labels: {
                    formatter: function formatter() {

                        return this.value == 0 ? ctrl.translation.text.PLAN + ctrl.ratePlanKB : this.value;
                    }
                },
                min: 0,
                max: ctrl.ratePlanKB >= $scope.dataSetTotalKB[$scope.dataSetTotalKB.length - 1] ? ctrl.ratePlanKB : $scope.dataSetTotalKB[$scope.dataSetTotalKB.length - 1],
                lineWidth: 1 //shows vertical (y-axis) line
            },
            tooltip: {
                useHTML: true,
                formatter: function formatter() {
                    var s = '';
                    s += '<table style="width:auto;height:auto;white-space: nowrap !important; font-size:small;">'; // tooltip height/width are auto calculated and no text wrap allowed
                    $.each(this.points, function (i, point) {
                        s += '<tr><td style="color: ' + point.series.color + ";\">\u25CF " + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + point.y + '</td></tr>';
                    });
                    s += '</table>';
                    return s;
                },
                crosshairs: true,
                shared: true,
                valueDecimals: 1,
                backgroundColor: '#FFFFFF',
                borderColor: 'gray',
                borderWidth: 1
            },
            series: [{
                name: ctrl.translation.text.ON_NETWORK_KB,
                type: 'column',
                data: $scope.dataSetOnNetworkKB,
                color: '#0000FF',
                pointWidth: 30
            }, {
                name: ctrl.translation.text.TOTAL_KB,
                type: 'spline',
                data: $scope.dataSetTotalKB,
                color: '#FF0000'
            }, {
                type: 'line',
                name: ctrl.translation.text.AVERAGE_LINE,
                dashStyle: 'dot',
                color: '#AAAAAA',
                data: [[0, -1], [ctrl.missionDataUsage.length - 1, ctrl.ratePlanKB]]
            }]
        });
    };
}

MissionDataUsageController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', '$timeout', '$filter', '$element', 'deviceMenuService', 'MissionDataUsageFactory'];
'use strict';

angular.module('mission-data-usage').component('missionDataUsage', {
    controller: MissionDataUsageController,
    templateUrl: 'ui/missiondatausage/mission-data-usage-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceId: '<'
    }
});
"use strict";

angular.module("mc.widget-temperature-display", []);
"use strict";

function McWidgetTemperatureDisplayController($, $timeout, $rootScope, $scope, $element, McTemperatureGaugeFactory, $compile, websocketService, toaster, datetimeService, sharedSetupService, authenticationService, translationService, PopupFactory, detectBrowserService, McWidgetsSharedFactory, openViewService) {

    var ctrl = this;
    var chart = void 0;
    var tmpInit = true;

    var deviceStateEnum = {
        Ok: 1,
        Alarm: 2,
        Offline: 3,
        Service: 4,
        Disabled: 5
    };

    var getState = function getState(state) {
        //Options: AllNormal, Alarm, Alert, Service, CommFail
        switch (state) {
            case deviceStateEnum.Ok:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
            //case deviceStateEnum.Disabled:
            //    return "Disabled";
            case deviceStateEnum.Offline:
                //device.CommsFault
                ctrl.orbitTitle = ctrl.translation.text.COMM_FAIL;
                return "CommFail";
            case deviceStateEnum.Service:
                ctrl.orbitTitle = ctrl.translation.text.SERVICE_MODE;
                return "Service";
            case deviceStateEnum.Alarm:
                ctrl.orbitTitle = null; //ctrl.translation.text.ALARM;
                return "Alarm";
            default:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
        }
    };

    var getView = function getView(state) {
        switch (state) {
            //case deviceStateEnum.Service:
            //    return "RTU Configuration"; //"Service";
            //case deviceStateEnum.Alarm:
            //    return "Dashboard"; //"Alarm";
            default:
                return "Dashboard"; //"AllNormal";
        }
    };

    ctrl.$onInit = function () {
        ctrl.loadingInProgress = true;
        if (angular.isUndefined(ctrl.accountInfo)) {
            ctrl.accountInfo = authenticationService.getAccountInfo();
            ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
            ctrl.preferencesMeasurement = ctrl.accountInfo.preferenceUser.lookupMeasurementID; //1 is farenheit
        }
        if (angular.isUndefined(ctrl.popupWindow)) {
            ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
        }
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
    };

    ctrl.pwMouseEnterAlarm = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.getTooltip(ctrl.widgetSetting.device.deviceId, event, 20);
    };

    ctrl.pwMouseLeaveAlarm = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            tmpInit = true;
            if (angular.isUndefined(ctrl.accountInfo)) {
                ctrl.accountInfo = authenticationService.getAccountInfo();
                ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
                ctrl.preferencesMeasurement = ctrl.accountInfo.preferenceUser.lookupMeasurementID;
            }
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            ctrl.curentBrowser = detectBrowserService();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            if (angular.isUndefined(ctrl.popupWindow)) {
                ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
            }
            if (changes.widgetSetting.currentValue.temperatureGauge[0].currentData != null) ctrl.buildWidget(changes.widgetSetting.currentValue);
        }
    };

    ctrl.wsDataReceivedWT = function (data) {
        if (ctrl.widgetSetting.device.serialNumber === data.SN) {
            ctrl.widgetSetting.temperatureGauge[0].currentData.value = parseFloat(data.Value);
            _calcGaugeLevel(ctrl.widgetSetting.temperatureGauge[0].currentData.value);
            _getCurrentTemp(ctrl.widgetSetting.temperatureGauge[0].currentData.value);
        }
    };

    ctrl.wsReconnectWT = function (data) {
        ctrl.getData(ctrl.widgetSetting.device.deviceId);
    };

    ctrl.wsListDeviceStateMsgReceived = function (data) {
        ctrl.widgetSetting.deviceUnitState.state = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).state;
        ctrl.widgetSetting.deviceUnitState.acFail = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).acFail;
        ctrl.widgetSetting.deviceUnitState.lastTimeHeardUtc = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).lastTimeHeardUtc;
        ctrl.fnRtuStatusOptions(getState(ctrl.widgetSetting.deviceUnitState.state));
    };

    var _setTimeOut = function _setTimeOut() {
        $timeout(function () {
            ctrl.liveUpdateItem = null;
            ctrl.liveUpdated = null;
            ctrl.liveMessage = null;
        }, 20000); // 20 Seconds
    };

    //var _refreshDeviceLive = (data) => {
    //    var patch = data.Value, userName = data.UserName, uniqueWebID = data.UniqueWebID;
    //    var _oldValue, _newValue;
    //    switch (patch.path) {
    //        case "description":
    //            _oldValue = ctrl.widgetSetting.runtimeGauge.description;
    //            ctrl.widgetSetting.runtimeGauge.description = patch.value;
    //            _newValue = patch.value;
    //            ctrl.updateWidgetTitle();
    //            break;
    //    }

    //    if (uniqueWebID != $rootScope.uniqueWebID) {
    //        $scope.liveUpdateItem = patch.path;
    //        ctrl.liveUpdated = true;
    //        ctrl.liveMessage = " " + userName + " changed " + patch.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + _oldValue + " to " + _newValue;
    //        console.log(ctrl.liveMessage);
    //        _setTimeOut();
    //    }
    //};

    ctrl.registerListener = function (varSerialNum) {
        //subscribe for temperature changes
        websocketService.connect();
        websocketService.register('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.register("TEMPERATURE", varSerialNum, '', ctrl.wsDataReceivedWT, ctrl.wsReconnectWT);
        websocketService.startOverview();
    };

    ctrl.unRegisterListener = function (varSerialNum) {
        websocketService.connect();
        websocketService.unRegister('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.unRegister("TEMPERATURE", varSerialNum, '', ctrl.wsDataReceivedWT, ctrl.wsReconnectWT);
        websocketService.stopOverview();
    };

    ctrl.buildWidget = function (widgetData) {

        ctrl.widgetSetting = widgetData;

        ctrl.registerListener(ctrl.widgetSetting.device.serialNumber);

        ctrl.hudText = getState(ctrl.widgetSetting.deviceUnitState.state); // Options: AllNormal, Alarm, Alert, Service, CommFail        

        ctrl.w_BorderWidth = 2; // Set the inside solid border of the HUD
        ctrl.w_BorderPadding = 5; // Set the outside opaque border outline

        ctrl.show_chartdata = "No";

        ctrl.fnHeardTypeOptions(ctrl.widgetSetting.temperatureWidgetSetting.dateTimeFormat);
        ctrl.fnMarksTypeOptions(ctrl.widgetSetting.temperatureWidgetSetting.tickMarksId);
        ctrl.setSize(_returnSizeId());

        ctrl.buildMainClass();

        ctrl.fnSizeOptions(ctrl.widgetSetting.temperatureWidgetSetting.sizeId);

        _svgAttributsInitialization();

        _calcGaugeLevel(ctrl.widgetSetting.temperatureGauge[0].currentData.value);

        _getCurrentTemp(ctrl.widgetSetting.temperatureGauge[0].currentData.value);

        ctrl.loadingInProgress = false;

        _addAnimation();

        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);

        if (ctrl.widgetSetting.setting.displaySettingOn) {
            var newScope = $scope;
            var html = '<mc-widget-temperature-setting widget-setting="$ctrl.widgetSetting" ng-if="$ctrl.widgetSetting.setting.displaySetting" change-display-options="$ctrl.fnChangeDisplayOptions(settingOptions)"></mc-widget-temperature-setting>';
            var element = $element.find('.component-setting');
            if (element.is(':empty')) {
                element.append($compile(html)(newScope));
            }
        }

        ctrl.loadingInProgress = false;
    };

    ctrl.getData = function (deviceId, openSetting) {

        var _temperatureGauge = new McTemperatureGaugeFactory(ctrl.accountInfo.customerId, deviceId, ctrl.accountInfo.timeZone, 1, 17);

        _temperatureGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;

            var device = _temperatureGauge.list.device;
            var deviceUnitState = _temperatureGauge.list.deviceUnitState;
            var defaultSetting = _temperatureGauge.list.defaultSetting;
            var temperatureGauge = _temperatureGauge.list.temperatureGauge.gauges;
            var temperatureWidgetSetting = _temperatureGauge.list.temperatureGauge.temperatureWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.widgetSetting.setting.displaySetting,
                displaySettingOn: ctrl.widgetSetting.setting.displaySettingOn,
                defaultSetting: ctrl.widgetSetting.setting.defaultSetting
            };
            ctrl.temperatureGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                defaultSetting: defaultSetting,
                temperatureGauge: temperatureGauge,
                temperatureWidgetSetting: temperatureWidgetSetting,
                setting: setting
            };

            if (ctrl.temperatureGauge.temperatureGauge[0].currentData === null) {
                toaster.pop('warning', "Temperature Widget" + " -- " + ctrl.temperatureGauge.device.name, 'No data available');
            } else {
                ctrl.buildWidget(ctrl.temperatureGauge);
                ctrl.fnSizeOptions(ctrl.temperatureGauge.temperatureWidgetSetting.sizeId);

                if (!angular.isUndefined(openSetting)) {
                    $timeout(function () {
                        ctrl.mouseOverHUD();
                        ctrl.editSetting();
                    }, 0);
                }
                ctrl.updateWidgetTitle();
            }
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.updateWidgetTitle = function () {
        ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.widgetSetting.device.deviceId, name: ctrl.widgetSetting.device.name, serialNumber: ctrl.widgetSetting.device.serialNumber } });
    };

    ctrl.fnHeardTypeOptions = function (heardType) {
        ctrl.widgetSetting.temperatureWidgetSetting.dateTimeFormat = heardType;
        //ctrl.DisplayTimestamp();
    };

    ctrl.fnMarksTypeOptions = function (marksTypeId) {

        ctrl.widgetSetting.temperatureWidgetSetting.tickMarksId = marksTypeId;

        var Markers_Style_On = { 'opacity': '100%', 'display': 'block' };
        var Markers_Style_Off = { 'opacity': '0%', 'display': 'none' };

        if (marksTypeId === 1) {
            ctrl.Markers_Style = Markers_Style_On;
        } //"Show"
        if (marksTypeId === 2) {
            ctrl.Markers_Style = Markers_Style_Off;
        } //"Hide"
        if (marksTypeId === 3) {
            ctrl.Markers_Style = Markers_Style_Off;
        } //"Hover"
    };

    ctrl.fnMarksTypeOptionsHover = function (marksTypeId) {

        if (marksTypeId !== 3) return;
        ctrl.Markers_Style = { 'opacity': '100%', 'display': 'block' };
    };

    ctrl.fnMarksTypeOptionsLeave = function (marksTypeId) {

        if (marksTypeId !== 3) return;
        ctrl.Markers_Style = { 'opacity': '0%', 'display': 'none' };
    };

    ctrl.fnSizeOptions = function (sizeId, openSetting) {
        if (!ctrl.widgetSetting.setting.displaySetting) return;
        ctrl.widgetSetting.temperatureWidgetSetting.sizeId = sizeId;
        ctrl.setSize(sizeId);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.parent().addClass("ui-widget-content-mc");

            $timeout(function () {
                var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
                ctrl.popup.parent().css("height", svgH + "px");
                ctrl.popup.parent().css("width", svgH + 25 + "px");
                switch (sizeId) {
                    case 1:
                        ctrl.popup.parent().find('.widgetContainer').css("left", 60 / 2 + "px");
                        break;
                    case 2:
                        ctrl.popup.parent().find('.widgetContainer').css("left", 118 / 2 + "px");
                        break;
                    case 3:
                        ctrl.popup.parent().find('.widgetContainer').css("left", 156 / 2 + "px");
                        break;
                    case 4:
                        ctrl.popup.parent().find('.widgetContainer').css("left", 188 / 2 + "px");
                        break;
                    case 5:
                        ctrl.popup.parent().find('.widgetContainer').css("left", 220 / 2 + "px");
                        break;
                }
            }, 0);
        }
        ctrl.closeSetting();
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);
        ctrl.buildMainClass();

        if (!angular.isUndefined(openSetting)) {
            $timeout(function () {
                ctrl.mouseOverHUD();
                ctrl.editSetting();
            }, 0);
        }
    };

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSizeTemperatureWidget(sizeId, 1);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.fnRtuStatusOptions = function (rtuStatus) {
        ctrl.buildMainClass();
        ctrl.hudText = rtuStatus;
    };

    ctrl.fnChangeDisplayOptions = function (parSettingOptions) {
        if (!angular.isUndefined(parSettingOptions.marksType)) {
            ctrl.fnMarksTypeOptions(parSettingOptions.marksType.id);
        }
        if (!angular.isUndefined(parSettingOptions.sizeOption)) {
            ctrl.fnSizeOptions(parSettingOptions.sizeOption.id, true);
        }
        if (!angular.isUndefined(parSettingOptions.rtuOption)) {
            ctrl.getData(parSettingOptions.rtuOption.deviceId, true);
        }
    };

    ctrl.editSetting = function (event) {
        ctrl.mcWidgetsSharedFactory.editSetting($element, event, ctrl);
    };

    ctrl.closeSetting = function () {
        ctrl.mcWidgetsSharedFactory.closeSetting($element, ctrl);
    };

    ctrl.mouseOverHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOver;
        }
    };
    ctrl.mouseOffHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOff;
        }
    };

    ctrl.resize_HUD = function (w_svgSizeW, w_svgSizeH) {
        ctrl.mcWidgetsSharedFactory.resizeHud(w_svgSizeW, w_svgSizeH, ctrl);
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ctrl.buildMainClass = function () {

        var gaugeType = "TachGauge1"; // Options: TachGauge1 (Styled in mcwidgets.css)
        var pumpTransparentObj = "PumpTransparentObj";
        var mainClass = ["upWidget", gaugeType, "Dark", "rtu" + getState(ctrl.widgetSetting.deviceUnitState.state), "acfail" + ctrl.widgetSetting.deviceUnitState.acFail, pumpTransparentObj];
        ctrl.mainClass = angular.copy(mainClass);
    };

    var _getCurrentTemp = function _getCurrentTemp(rawValue) {
        ctrl.currentTemp = ctrl.preferencesMeasurement === 1 ? Math.round(9 / 5 * rawValue + 32) : Math.round(rawValue);
        if (rawValue < 15) {
            ctrl.currentTempLevel = 1; //Cold
        } else if (rawValue >= 15 && rawValue < 30) {
            ctrl.currentTempLevel = 2; //Normal
        } else {
            ctrl.currentTempLevel = 3; //Hot
        }
    };

    var _svgAttributsInitialization = function _svgAttributsInitialization() {
        ctrl.temperatureGaugeBodyPoints = "256.7,442 256.7,457.5 178.8,457.5 178.8,442  ";
    };

    var _calcGaugeLevel = function _calcGaugeLevel(rawValue) {
        var panelMinMaxDiff = 445.5 - 126.6;
        var currentTempPercent = (rawValue - -10) / 60; //calculation is based on celcius
        var gaugeLevel = "256.7," + (425.5 - panelMinMaxDiff * currentTempPercent) + " 256.7,457.5 178.8,457.5 178.8," + (425.5 - panelMinMaxDiff * currentTempPercent);
        ctrl.oldtemperatureGaugeBodyPoints = ctrl.temperatureGaugeBodyPoints;
        ctrl.temperatureGaugeBodyPoints = gaugeLevel;
    };

    var _returnSizeId = function _returnSizeId() {
        if (angular.isUndefined(ctrl.sizeIdOverride)) {
            return ctrl.widgetSetting.setting.defaultSetting ? ctrl.widgetSetting.defaultSetting.sizeId : ctrl.widgetSetting.temperatureWidgetSetting.sizeId;
        } else return parseInt(ctrl.sizeIdOverride);
    };

    var _addAnimation = function _addAnimation() {
        if (ctrl.windowId == undefined) {
            document.getElementById("gaugeLevelAnimation").beginElement();
        } else {
            document.getElementById("widgetLevelAnimation").beginElement();
        }
    };

    ctrl.openView = function ($event) {
        openViewService.openView(getView(ctrl.widgetSetting.deviceUnitState.state));
    };

    // from socket

    ctrl.updateValue = function (value) {

        switch (value) {
            case "1":
                return "True";
            case "0":
                return "False";
        }
        return "False";
    };

    var _customAdjustment = function _customAdjustment() {
        ////TODO: This is very specific for Vertical Turbine Pump -> I will need to revisit
        //if (angular.isUndefined(ctrl.svgStyle.top) && ctrl.pumpType === "Vertical Turbine Pump" && _returnSizeId() == 1) {
        //    ctrl.svgStyle = { "top": '-115px', "clip-path": 'polygon(42.8% 71.60%, 57.3% 71.60%, 58.14% 72.87%, 59.4348% 74.6%, 58.93% 78.8%, 58.8% 82.07%, 42.13% 82.07%, 41.87% 78.8%, 41.1% 75.06%, 42.13% 72.94%)' };
        //}
        ////TODO: This is very specific for Vertical Turbine Pump -> I will need to revisit
    };

    ctrl.webSocketReconnect = function () {
        //if widget then toaster message... if gauge then not
        if (angular.isUndefined(ctrl.additionalSize)) toaster.pop('success', "Temperature Widget" + " -- " + ctrl.widgetSetting.device.name, 'View reloading');
        ctrl.getData(ctrl.widgetSetting.device.deviceId);
    };

    var _onRECONNECT = $scope.$on('processReconnect', function (event, args) {
        ctrl.webSocketReconnect();
    });

    var _onDocumentClick = $rootScope.$on('document_click', function (event, args) {
        ctrl.closeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.buildMainClass();
    });

    $scope.$on('updatePreferencesMeasurement', function (event, measurementSystem) {
        ctrl.preferencesMeasurement = measurementSystem;
        _calcGaugeLevel(ctrl.widgetSetting.temperatureGauge[0].currentData.value);
        _getCurrentTemp(ctrl.widgetSetting.temperatureGauge[0].currentData.value);
    });

    $scope.$on("$destroy", function () {
        _onDocumentClick();
        _onRECONNECT();
        _setTimeOut();
        ctrl.unRegisterListener(ctrl.widgetSetting.device.serialNumber);
        if (chart) chart.destroy();
    });

    $scope.$on("StopOverview", function (event, args) {
        if ($scope.$$destroyed) {
            // The scope is already destroyed, skip further processing.
            return;
        } else if (args.stop) {
            websocketService.connect();
            websocketService.startOverview();
        }
    });
}

McWidgetTemperatureDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'McTemperatureGaugeFactory', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'authenticationService', 'translationService', 'PopupFactory', 'detectBrowserService', 'McWidgetsSharedFactory', 'openViewService'];
'use strict';

angular.module('mc.widget-temperature-display').component('mcWidgetTemperatureDisplay', {
    controller: McWidgetTemperatureDisplayController,
    templateUrl: 'ui/mcwidgettemperaturedisplay/mcwidget-temperature-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        settingShow: '&',
        changeWidgetTitle: '&'
    }
});
mcapp.controller("mapController", ["HOST", "$http", "$scope", "$rootScope", "$q", "$location", "translationService", "sharedSetupService", "authenticationService", "$element", "$timeout", "openViewService", "rtuDataService", 'datetimeService', 'deviceMenuService', 'PopupFactory', '$cookies', '$window', 'RWAID',
    function (HOST, $http, $scope, $rootScope, $q, $location, translationService, sharedSetupService, authenticationService, $element, $timeout, openViewService, rtuDataService, datetimeService, deviceMenuService, PopupFactory, $cookies, $window, RWAID) {
        $scope.loadMap = true;
        $scope.translation = translationService.translation;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.datetimeService = datetimeService;
        $scope.mapRestoreBtn = false;
        $scope.mapOffPix = 0;
        $scope.popupTracker = {};
        $scope.adminUser = $cookies.get('AdminUser1') != null ? true : false;
        $scope.mobile = $rootScope.mobile;
        $scope.siderShow = false;
        $scope.siderMarkerShow = false;
        $scope.showMapPanel = window.localStorage.getItem("showMapPanel");
        $scope.showMenu = false;
        $scope.isMcAdmin = sharedSetupService.mcAdmin();

        $scope.rwaMode = $scope.accountInfo.customerId == RWAID ? true : false;
        $scope.regionCode = "";

        $scope.distributorId = null;

        $scope.dynamicPopover = {
            templateUrl: 'DeviceFilterTemplate.html'
        };

        $scope.getStatusList = function ()  {
            $scope.statusList = [
                { type: 1, translation: $scope.translation.text.OK, icon: "fa fa-check-circle", color: "rgb(22, 160, 133)" },
                { type: 2, translation: $scope.translation.text.ALARM, icon: "fa fa-times-circle", color: "rgb(231, 90, 90)" },
                { type: 3, translation: $scope.translation.text.OFFLINE, icon: "fa fa-minus-circle", color: "rgb(188, 0, 188)" },
                { type: 4, translation: $scope.translation.text.SERVICE, icon: "fa fa-minus-circle", color: "rgb(255, 216, 0)" },
                { type: 5, translation: $scope.translation.text.DISABLED, icon: "fa fa-minus-circle", color: "blue" },
                { type: 6, translation: $scope.translation.text.STATUS_ACK_AS_ALARM, icon: "fa fa-times-circle", color: "rgb(76, 179, 255)" }
            ];
        };

        //unselect radio button option is selected twice / select radio option by div click
        $scope.radioCheck = function (type, color) {
            $scope.showMenu = !$scope.showMenu;
            if ($scope.activeStatus == null) { $scope.lastActiveStatus = type; $scope.activeStatus = type; $scope.filterColor = color;}
            else if (type != $scope.lastActiveStatus) { $scope.lastActiveStatus = type; $scope.activeStatus = type; $scope.filterColor = color; }
            else { $scope.activeStatus = null; $scope.lastActiveStatus = null; $scope.filterColor = "rgb(117, 117, 117)"; }

            $scope.getListAndFilter($scope.getIconColor($scope.activeStatus));
            getListAndFilter($scope.getIconColor($scope.activeStatus));
        }

        $scope.getListAndFilter = function (activeStatusColor) {
            var newList = [];
            var $clonedElement = $("#deviceTabPnl").clone();
            $("#deviceTabPnl").empty();

            $clonedElement.find('a').each(function (i, data) {
                if (activeStatusColor === "") {
                    var a = $(data.outerHTML).css('display', 'block');
                    $("#deviceTabPnl").append(a);
                }
                else {
                    var iconColor = $(data.outerHTML).find('img').attr('src').slice(-5, -4);
                    if (iconColor === activeStatusColor) {
                        var b = $(data.outerHTML).css('display', 'block');
                        $("#deviceTabPnl").append(b);
                    } else {
                        var c = $(data.outerHTML).css('display', 'none');
                        $("#deviceTabPnl").append(c);
                    }
                }

                newList.push(data.outerHTML);
            });

            $clonedElement.remove(); 
        }

        //Get device status count 
        $scope.getDeviceStateCount = function (type) {
            var counter = 0;
            $("#deviceTabPnl").find('a').each(function (i, data) {
                var iconColor = $(data.outerHTML).find('img').attr('src').slice(-5, -4);
                if (iconColor === $scope.getIconColor(type)) {
                    ++counter;
                }
            });
            return counter;
        };

        $scope.getStatusList();

        $scope.showDevicesPanel = function () {
            $scope.hideMarkersPanel();
            $scope.siderShow = true;
            $element.find('#sider').css("width", "260px").css("opacity", .8).css("box-shadow", "5px 0 4px -4px #515151").show(300);
            window.localStorage.setItem("showMapPanel", "D");
        };

        $scope.hideDevicesPanel = function () {
            $element.find('#sider').css("width", "0").css("opacity", 1).hide(300);
            $scope.siderShow = false;
            window.localStorage.setItem("showMapPanel", "hide");
        };

        $scope.showMarkersPanel = function () {
            $scope.hideDevicesPanel();
            $scope.siderMarkerShow = true;
            $element.find('#siderMarker').css("width", "260px").css("opacity", .8).css("box-shadow", "5px 0 4px -4px #515151").show(300);
            window.localStorage.setItem("showMapPanel", "M");
        };

        $scope.hideMarkersPanel = function () {
            $element.find('#siderMarker').css("width", "0").css("opacity", 1).hide(300);
            $scope.siderMarkerShow = false;
            window.localStorage.setItem("showMapPanel", "hide");
        };

        $scope.checkPanel = function () {
            if ($rootScope.mobile)
                return;
            if ($scope.siderMarkerShow)
                $scope.showMarkersPanel();
            if ($scope.siderShow)
                $scope.showDevicesPanel();
        };

        $timeout(function () {
            if ($rootScope.mobile)
                return;

            switch ($scope.showMapPanel) {
                case "D":
                    $scope.showDevicesPanel();
                    break;
                case "M":
                    $scope.showMarkersPanel();
                    break;
                case "hide":
                    //do nothing!
                    break;
                default:
                    $scope.showDevicesPanel();
                    break;
                }
        }, 1000);


        $scope.showRegionsPanel = function () {
            $element.find('#siderRegion').css("width", "260px").css("opacity", .8).css("box-shadow", "5px 0 4px -4px #515151").show(300);
        };

        $scope.hideRegionsPanel = function () {
            $element.find('#siderRegion').css("width", "0").css("opacity", 1).hide(300);
        };

        $scope.changeMap = function (type) {
            onToolBarAction(type);
            $timeout(function () {
                $scope.checkPanel();
            }, 1000);
        };

        var userAgent = navigator.userAgent.toLowerCase();
        var resizeEvent = new Event('resize');
        $scope.isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
        $scope.isTablet = $scope.isTablet ? $scope.isTablet : (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile')) !== -1;

        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId($scope);

        $scope.openDevicePopup = function(popupPos, url) {
            var deviceId = url.substring(url.lastIndexOf("deviceID=") + 9, url.length);
            var _device = { deviceId: deviceId };

            var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
            optionsStickyProperties.deviceId = deviceId;
            optionsStickyProperties.device = _device;


            deviceMenuService.getDeviceMenuList($scope.accountInfo.customerId)
                .then(function (datafromFactory) {
                    var _devices = datafromFactory.data.devices;
                    var _hasLevelSensor = false;
                    for (var index = 0; index < _devices.length; ++index) {
                        if (_devices[index].deviceId == deviceId) {
                            _hasLevelSensor = _devices[index].hasLevelSensor;
                            break;
                        }
                    }

                    if ($rootScope.mobile || $rootScope.classicView) {
                        switch (_hasLevelSensor) {
                            case true:
                                $location.path('/mmplus/mcwidgetmmplusdisplay/mcwidget-mmplus-display-template');
                                break;
                            default:
                                $location.path('/rtuview/rtu-view');
                                break;
                        }
                        
                    } else {
                        switch (_hasLevelSensor) {
                            case true:
                                openViewService.openView('MyLevel', { width: 340, height: 530 }, popupPos, optionsStickyProperties, { minimumWidth: 340, minimumHeight: 530 });
                                break;
                            default:
                                openViewService.openView('RTU View', { width: 425, height: 400 }, popupPos, optionsStickyProperties);
                                break;
                        }
                        
                    }

                }, function (error) {
                    //error
                });
        };

        $scope.openMarkerPopup = function (popupPos, pushpin) {
            var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
            optionsStickyProperties.pushpin = {
                id: pushpin.id,
                customerId: pushpin.customerId,
                latitude: pushpin.latitude,
                longitude: pushpin.longitude
            };

            if ($rootScope.mobile || $rootScope.classicView) {
                $location.path('/map/marker/map-marker-template');
            } else {
                openViewService.openView('Map Marker', { width: 250, height: 300 }, popupPos, optionsStickyProperties);
            }
        };

        $scope.openMarkerCustomerPopup = function (customerId, popupPos) {
            var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
            var _device = { deviceId: customerId };
            optionsStickyProperties.customerId = customerId;
            optionsStickyProperties.deviceId = customerId;
            optionsStickyProperties.device = _device;

            if ($rootScope.mobile || $rootScope.classicView) {
                $location.path('/map/markercustomer/marker-customer-view');
            } else {
                openViewService.openView('Marker Customer', { width: 250, height: 300 }, popupPos, optionsStickyProperties);
            }
        };

        $scope.openMarkerRwaPopup = function (marker, popupPos) {
            var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
            var _device = { deviceId: marker.id };
            optionsStickyProperties.rwaId = marker.id;
            optionsStickyProperties.markerIcon = marker.icon;
            optionsStickyProperties.setting = marker.icon;
            optionsStickyProperties.deviceId = marker.id;
            optionsStickyProperties.device = _device;

            if ($rootScope.mobile || $rootScope.classicView) {
                $location.path('/map/markerrwa/marker-rwa-view');
            } else {
                openViewService.openView('Marker Rural Water Association', { width: 250, height: 300 }, popupPos, optionsStickyProperties);
            }
        };

        $scope.openMarkerDistributorPopup = function (distributorId, popupPos) {
            var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
            var _device = { deviceId: distributorId };
            optionsStickyProperties.customerId = distributorId;
            optionsStickyProperties.deviceId = distributorId;
            optionsStickyProperties.device = _device;

            if ($rootScope.mobile || $rootScope.classicView) {
                $location.path('/map/markerdistributor/marker-distributor-view');
            } else {
                openViewService.openView('Marker Distributor', { width: 250, height: 300 }, popupPos, optionsStickyProperties);
            }
        };

        $scope.getRTUData = function(deviceId) {
            return $q.all([
                rtuDataService.getData($scope.accountInfo.customerId, deviceId),
                //rtuDataService.getDeviceUnitState(deviceId, $scope.accountInfo.customerId),
                //$http.get(HOST + '/api/OverviewAlarm?customerId=' + $scope.accountInfo.customerId + '&deviceId=' + deviceId)
                $http.get(HOST +
                    '/api/RtuDetail?customerId=' +
                    $scope.accountInfo.customerId +
                    '&deviceId=' +
                    deviceId +
                    '&timeZone=' +
                    $scope.accountInfo.timeZone)
            ]);
        };

    $scope.popupFactory = new PopupFactory($scope.accountInfo);

    if ($rootScope.classicView) {
        $timeout(function () {
            map.zoomOut();
        }, 0);
    }

    function getRuralWaterAssociations(regionCode) {
        if (regionCode.length > 0 && $scope.distributorId == null) {
            return $http({
                method: 'GET',
                url: HOST + '/api/Map/Marker/RuralWaterAssociations/region',
                params: {
                    'regionCode': regionCode
                }
            });
        }
        else {
            return $http({
                method: 'GET',
                url: HOST + '/api/Map/Marker/RuralWaterAssociations/distributor',
                params: {
                    'distributorId': $scope.distributorId
                },
            });
        }
    };

    function listDistributorRegions() {
        return $http({
            method: 'GET',
            url: HOST + '/api/Map/Marker/DistributorRegions/get',
            params: { }
        });
    };

    $scope.map2009GetDistributorRegions = function () {
        if (!$scope.rwaMode) {
            return $q.reject('RWA mode is disabled.');
        }

        if (!$scope.isMcAdmin) {
            return $q.when(true);
        }

        if ($scope.distributorRegions && $scope.distributorRegions.length > 0) {
            return $q.when($scope.distributorRegions);
        }

        return listDistributorRegions().then(function (resp) {
            $scope.distributorRegions = resp.data || [];
            $scope.regionCode = $scope.distributorRegions.length > 0
                ? $scope.distributorRegions[0].regionCode
                : "";

            return $scope.distributorRegions;
        });
    };

    $scope.map2009GetRuralWaterAssociations = function (regionCode) {

        var deferred = $q.defer();

        if (!$scope.rwaMode) {
            return deferred.promise;
            deferred.reject(error);
        }

        getRuralWaterAssociations(regionCode).then(function (resp) {
                var rwaPushpins = resp.data;
                var retRwaPushpins = { responseText: '' };
                var parmRwa = "";
                for (var i = 0; i <= rwaPushpins.length - 1; i++) {
                    var hasNotes = rwaPushpins[i].hasNotes;
                    if (parmRwa.length > 0) parmRwa = parmRwa + "^";
                    parmRwa = parmRwa +
                        rwaPushpins[i].id + "|" +
                        rwaPushpins[i].memberName + "|" +
                        rwaPushpins[i].latitude + "|" +
                        rwaPushpins[i].longitude + "|" +
                        (hasNotes == true ? "scripts/map/icons/Map-Marker-RWA-notes-icon.gif" : "scripts/map/icons/Map-Marker-RWA-icon.png");
                }
                retRwaPushpins.responseText = parmRwa;
                deferred.resolve(retRwaPushpins);
            },
            function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    $scope.getNewRegion = function (regionCode) {
        $scope.distributorId = null;
        $scope.distributors = null;
        $scope.regionCode = regionCode;
        $scope.loadMap = false;
        $timeout(function () {
            $scope.loadMap = true;
        }, 0);
    };

    $scope.getDistributorFromTheRegion = function (distributorId) {
        $scope.distributorId = distributorId;
        $scope.loadMap = false;
        $timeout(function () {
            $scope.loadMap = true;
        }, 0);
    };

    function getCustomers(regionCode) {
        if (regionCode.length > 0 && $scope.distributorId == null) {
            return $http({
                method: 'GET',
                url: HOST + '/api/Map/Marker/Customers/region',
                params: {
                    'regionCode': regionCode
                },
            });
        }
        else {
            return $http({
                method: 'GET',
                url: HOST + '/api/Map/Marker/Customer',
                params: {
                    'distributorId': $scope.distributorId
                },
            });
        }
    };

    $scope.map2009GetCustomers = function (regionCode) {

        var deferred = $q.defer();

        if (!$scope.rwaMode) {
            return deferred.promise;
            deferred.reject(error);
        }

        getCustomers(regionCode).then(function (resp) {
            var customerPushpins = resp.data;
            var retCustomerPushpins = { responseText: '' };
            var parmCustomer = "";
            for (var i = 0; i <= customerPushpins.length - 1; i++) {
                if (parmCustomer.length > 0) parmCustomer = parmCustomer + "^";
                parmCustomer = parmCustomer +
                    customerPushpins[i].customerId + "|" +
                    customerPushpins[i].name + "|" +
                    customerPushpins[i].latitude + "|" +
                    customerPushpins[i].longitude +
                    "|scripts/map/icons/Map-Marker-Customer-icon.png";
            }
            retCustomerPushpins.responseText = parmCustomer;
            deferred.resolve(retCustomerPushpins);
        },
            function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    function getDistributors(regionCode) {
        if (regionCode.length > 0 && $scope.distributorId == null) {
            return $http({
                method: 'GET',
                url: HOST + '/api/Map/Marker/Distributors/region',
                params: {
                    'regionCode': regionCode
                },
            });
        }
        else {
            return $http({
                method: 'GET',
                url: HOST + '/api/Map/Marker/Distributor',
                params: {
                    'distributorId': $scope.distributorId
                },
            });
        }
    };

    $scope.map2009GetDistributors = function (regionCode) {

        var deferred = $q.defer();

        if (!$scope.rwaMode) {
            return deferred.promise;
            deferred.reject(error);
        }

        getDistributors(regionCode).then(function (resp) {
            var distributorPushpins = resp.data;
            if ($scope.distributorId == null)
                $scope.distributors = distributorPushpins;
            var retDistributorPushpins = { responseText: '' };
            var parmDistributor = "";
            for (var i = 0; i <= distributorPushpins.length - 1; i++) {
                if (parmDistributor.length > 0) parmDistributor = parmDistributor + "^";
                parmDistributor = parmDistributor +
                    distributorPushpins[i].distributorId + "|" +
                    distributorPushpins[i].name + "|" +
                    distributorPushpins[i].latitude + "|" +
                    distributorPushpins[i].longitude +
                    "|scripts/map/icons/Map-Marker-Distributor-icon.png";
            }
            retDistributorPushpins.responseText = parmDistributor;
            deferred.resolve(retDistributorPushpins);
        },
            function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    $scope.map2009custVar = function (customerId, timeZone) {

        var deferred = $q.defer();

        if ($scope.rwaMode) {
            return deferred.promise;
            deferred.reject(error);
        }

        var dviceStatus = { responseText: '' };
        var parm1 = "", parm2 = "", tabMenuList = "";
        $http.get(HOST +
            '/api/Map/Locations?customerId=' +
            customerId +
            ($rootScope.mobileApp ? "&mobileApp=" + $rootScope.mobileApp : "")).then(function (resp) {

                var devices = resp.data.devices;
                var users = resp.data.users;

                if (devices !== null) {
                for (var i = 0; i <= devices.length - 1; i++) {
                    if (parm1.length > 0) parm1 = parm1 + " , ";
                    parm1 = parm1 +
                        devices[i].deviceId +
                        "|" +
                        devices[i].serialNumber +
                        "|" +
                        devices[i].latitude +
                        "|" +
                        devices[i].longitude +
                        "|" +
                        devices[i].icon +
                        "|" +
                        encodeURIComponent((devices[i].name).replace("|", "."));


                    tabMenuList = tabMenuList + 
                        "<a href='javascript:void(0)' onclick='openMapPopupByDeviceId(" + devices[i].deviceId + ")' onmouseover='mouseOverByDeviceId(" + devices[i].deviceId + ")' onmouseout='mouseLeaveByDeviceId(" + devices[i].deviceId + ")'>" +
                        "<img id='Img" + devices[i].deviceId + "' title='" + devices[i].name + "' alt='" + devices[i].name + "' src='scripts/map/icons/" + devices[i].icon + "'>" +
                        "<span>" + devices[i].name + "</span></a>";
                    }

                }

                if (users !== null && users.length > 0) {
                    for (var i = 0; i <= users.length - 1; i++) {
                        if (parm2.length > 0) parm2 = parm2 + " ,";
                        parm2 = parm2 +
                            "mal" +
                            users[i].id +
                            "|" +
                            users[i].name +
                            "|" +
                            users[i].latitude +
                            "|" +
                            users[i].longitude +
                            "|" +
                            users[i].icon +
                            "|" +
                            (users[i].name).replace("|", ".");
                    }

                    parm2 = " , " + parm2;

                }

                dviceStatus.responseText = (parm1 + parm2).replace("?", "") + ";" + tabMenuList;
                deferred.resolve(dviceStatus);
            },
            function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
        };
        
        function getPushpins(customerId) {
            return $http({
                method: 'GET',
                url: HOST +'/api/Map/Marker/list',
                params: {
                    'customerId': customerId
                }
            });
        }

        $scope.map2009GetPushpins = function (customerId) {

            var deferred = $q.defer();

            if ($scope.rwaMode) {
                deferred.resolve();
                return deferred.promise;
            }

            getPushpins(customerId).then(function (resp) {
                var pushpins = resp.data;
                var retPushpins = { responseText: '' };
                var parm1 = "";
                for (var i = 0; i <= pushpins.length - 1; i++) {
                    if (parm1.length > 0) parm1 = parm1 + ",";
                    parm1 = parm1 +
                        pushpins[i].id + "|" +
                        pushpins[i].name + "|" +
                        pushpins[i].latitude + "|" +
                        pushpins[i].longitude +
                        "|scripts/map/icons/" +
                        pushpins[i].icon;
                }
                retPushpins.responseText = parm1;
                deferred.resolve(retPushpins);
                },
                function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        };

        function getMapIcons(customerId) {
            return $http({
                method: 'GET',
                url: HOST + '/api/Map/Marker/icons',
                params: {
                    'customerId': customerId
                }
            });
        }
        $scope.map2009GetMapIcons = function (customerId) {

            var deferred = $q.defer();

            if ($scope.rwaMode) {
                deferred.resolve();
                return deferred.promise;
            }

            getMapIcons(customerId).then(function(resp) {
                    var icons = resp.data;
                    var retIcons = { responseText: '' };
                    var parm1 = "";
                    for (var i = 0; i <= icons.length - 1; i++) {
                        if (parm1.length > 0) parm1 = parm1 + ",";
                        parm1 = parm1 +
                            icons[i].iconFileName;
                    }
                    retIcons.responseText = parm1;
                    deferred.resolve(retIcons);
                },
                function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        };

        $scope.map2009statusVar = function (customerId, timeZone) {

            var deferred = $q.defer();

            if ($scope.rwaMode) {
                deferred.resolve();
                return deferred.promise;
            }

            var dviceStatus = { responseText: '' };
            var parm1 = "", parm2 = "";
            $http.get(HOST +
                '/api/Map/States?customerId=' +
                customerId +
                '&timeZone=' +
                timeZone +
                ($rootScope.mobileApp ? "&mobileApp=" + $rootScope.mobileApp : "")).then(function (resp) {

                    var devices = resp.data.devices;
                    var users = resp.data.users;

                    if (devices !== null) {
                        for (var i = 0; i <= devices.length - 1; i++) {
                            if (parm1.length > 0) parm1 = parm1 + " ,";
                            parm1 = parm1 +
                                devices[i].id +
                                "|" +
                                (devices[i].icon == ""
                                    ? ($scope.getIcon(devices[i].type, devices[i].state) + ".gif")
                                    : devices[i].icon) +
                                "|" +
                                encodeURIComponent((devices[i].name).replace("|", "."));
                            //devices[i].name;
                        }

                    }

                    if (users !== null && users.length > 0) {
                        for (var i = 0; i <= users.length - 1; i++) {
                            if (parm2.length > 0) parm2 = parm2 + " ,";
                            parm2 = parm2 +
                                "mal" +
                                users[i].id +
                                "|" +
                                users[i].name +
                                "|" +
                                users[i].latitude +
                                "|" +
                                users[i].longitude +
                                "|" +
                                users[i].icon +
                                "|" +
                                (users[i].name).replace("|", ".");
                        }

                        if (parm1.length > 0) parm2 = "," + parm2;

                    }

                    dviceStatus.responseText = (parm1 + parm2).replace("?", "");
                    deferred.resolve(dviceStatus);
                },
                    function (error) {
                        deferred.reject(error);
                    });

            return deferred.promise;

        };

        //Fetches Icon name
        $scope.getIcon = function(deviceType, state) {
            var icon;
            switch (deviceType) {
            case 19:
                icon = "h" + $scope.getIconColor(state); //h: Hexagon
                break;
            case 18:
                icon = "p" + $scope.getIconColor(state); //p: Pentagon
                break;
            case 9:
                icon = "s" + $scope.getIconColor(state); //s: Square
                break;
            case 8:
                icon = "d" + $scope.getIconColor(state); //d: Diamond
                break;
            case 15:
            case 10:
                icon = "c" + $scope.getIconColor(state); //c: Circle
                break;
            default:
                icon = "s" + $scope.getIconColor(state); //s: Square
                break;
            }
            return icon;
        };

        $scope.getIconColor = function(state) {
            var iconColor;
            switch (state) {
            case 1:
                iconColor = "g"; //green
                break;
            case 2:
                iconColor = "r"; //red
                break;
            case 3:
                iconColor = "p"; //purple
                break;
            case 4:
                iconColor = "y"; //yellow
                break;
            case 5:
                iconColor = "b"; //blue
                    break;
            case 6:
                iconColor = "l"; //light-blue
                break;
            default:
                iconColor = ""; //green
                break;
            }
            return iconColor;
        };

    $scope.bindZoomButtons = function ($elm) {
        $timeout(function () {
            $elm
                .find("#mcZoomBar_zoomout")
                .off("click.mapZoom")
                .on("click.mapZoom", function () {
                    onToolBarAction("zo");
                });

            $elm
                .find("#mcZoomBar_zoomin")
                .off("click.mapZoom")
                .on("click.mapZoom", function () {
                    onToolBarAction("zi");
                });
        }, 2000);
    }

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        var _popupPosition = $scope.popup.dialog("option", "position");
        sharedSetupService.maximize($scope.popup);

        $scope.restoreDialog = function () {
            $scope.popup.siblings('div.ui-dialog-titlebar').show();
            $scope.popup.dialogExtend("restore");
        };

        $scope.popup.dialog({
            resizeStop: function (event, ui) {
                $('#map').removeClass('no-events');

                var dialogHeight = $scope.popup.dialog("option", "height");
                var dialogWidth = $scope.popup.dialog("option", "width");

                $scope.popup.dialog('widget').find(".ui-widget-content").css("height", (parseInt(dialogHeight) - 30) + 3 + "px");
                $scope.popup.dialog('widget').find(".ui-widget-content").css("width", (parseInt(dialogWidth)) + "px");
                $scope.popup.dialog('widget').find("#container").css("height", (parseInt(dialogHeight) - 30) + 3 + "px");
                $scope.popup.dialog('widget').find("#container").css("width", (parseInt(dialogWidth)) + "px");

                $timeout(function () {
                    $window.dispatchEvent(resizeEvent);
                    map.zoomOut();
                    map.destroy();
                    setCustomerId($scope.accountInfo.customerId, $rootScope.mobile, $rootScope.mobileApp, $scope.isTablet, $scope.regionCode);
                    $scope.bindZoomButtons($element);
                }, 0);
            }
        });

        $scope.popup.dialog({
            resizeStart: function (event, ui) {
                $('#map').addClass('no-events');
                $(this).dialog('widget').css("height", $(this).dialog('widget').css("height"));
                $(this).dialog('widget').css("width", $(this).dialog('widget').css("width"));
                $scope.popup.dialog('widget').find("#container").css("width", "100%");
                $scope.popup.dialog('widget').find("#container").css("height", "100%");
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                $scope.popup.siblings('div.ui-dialog-titlebar').hide();
                $scope.popup.parents().css("z-index", "0 !important");
                $scope.popup.parents().eq(0).removeClass("ui-dialog ui-widget ui-widget-content ui-corner-all ui-front");
                $scope.popup.parents().eq(0).attr("style", "");
                var dialogHeight = $scope.popup.dialog("option", "height");
                var dialogWidth = $scope.popup.dialog("option", "width");
                $scope.popup.dialog('widget').find("#container").css("height", parseInt(dialogHeight) + "px");
                $scope.popup.dialog('widget').find("#container").css("width", parseInt(dialogWidth) + "px");
                $window.dispatchEvent(resizeEvent);
                map.zoomOut();
                $scope.mapRestoreBtn = true;
                $scope.mapOffPix = 30;
                $scope.$apply();
                onToolBarAction('ho');
                map.destroy();
                $timeout(function () {
                    setCustomerId($scope.accountInfo.customerId, $rootScope.mobile, $rootScope.mobileApp, $scope.isTablet, $scope.regionCode);
                    $scope.bindZoomButtons($element);
                }, 0);
            }
        });

            $scope.popup.dialogExtend({
                restore: function (event, ui) {
                    $scope.popup.parents().eq(0).addClass("ui-dialog ui-widget ui-widget-content ui-corner-all ui-front");
                    $scope.popup.dialog('widget').find(".ui-dialog-titlebar-buttonpane").css("width", "130px");
                    var dialogHeight = $scope.popup.dialog("option", "height");
                    var dialogWidth = $scope.popup.dialog("option", "width");
                    $scope.popup.dialog('widget').find("#container").css("height", (parseInt(dialogHeight) - 20) + "px");
                    $scope.popup.dialog('widget').find("#container").css("width", (parseInt(dialogWidth) - 0) + "px");

                $timeout(function () {
                    $window.dispatchEvent(resizeEvent);
                    map.zoomOut();
                    $scope.mapRestoreBtn = false;
                    $scope.mapOffPix = 0;
                    $scope.$apply();
                    onToolBarAction('ho');
                    map.destroy();
                    setCustomerId($scope.accountInfo.customerId, $rootScope.mobile, $rootScope.mobileApp, $scope.isTablet, $scope.regionCode);
                    $scope.bindZoomButtons($element);
                }, 0);

            }
        });

        if (_popupPosition.at == "left top" && _popupPosition.my == "left top") {
            $timeout(function () { $scope.popup.dialogExtend("maximize"); }, 0);
        }
    }
    }]);

mcapp.directive('mapDirective', ["authenticationService", "$window", "$rootScope", "$timeout",
    function (authenticationService, $window, $rootScope, $timeout) {
    function link(scope, element, attrs) {
        var timeoutResizeAdjustId = null;
        mapStopRefresh = false;
        setCustomerId(scope.accountInfo.customerId, $rootScope.mobile, $rootScope.mobileApp, scope.isTablet, scope.regionCode);

        var handleResize = function() {
            if ($rootScope.mobile || $rootScope.classicView) {
                //this is a trick to refresh the map on resize
                //this is a trick to refresh the map on resize
                //this is a trick to refresh the map on resize
                var origin = location.origin;
                var path = location.pathname;
                var queryString = $rootScope.mobileApp ? "?" + location.href.split("?")[1] : "";
                var angJs = "#!/";
                var newPage = "pleasewait/please-wait";
                location.replace(origin + path + angJs + newPage + queryString);
                newPage = "map/map";
                location.replace(origin + path + angJs + newPage + queryString);
                return;
            }

            refreshMapAfterResize();
        };

        var handleResizeAdjust = function (e) {
            scope.mapResizeDone = true;
            window.dispatchEvent(new Event('resize'));
        };

        function startResizeAdjustTimeout() {
            // If a timeout is already running, cancel it first
            if (timeoutResizeAdjustId !== null) {
                clearTimeout(timeoutResizeAdjustId);
            }

            // Start a new timeout
            timeoutResizeAdjustId = setTimeout(function () {
                window.dispatchEvent(new CustomEvent('mapResize'));
                timeoutResizeAdjustId = null; // optional: mark as finished
            }, 200);
        }

        function cancelResizeAdjustTimeout() {
            if (timeoutResizeAdjustId !== null) {
                clearTimeout(timeoutResizeAdjustId);
                timeoutResizeAdjustId = null;
            }
        }

        function refreshMapAfterResize() {

            resizeMapContrainer(true, "IM");

            $timeout(function () {

                if (!scope.mapResizeDone) {
                    startResizeAdjustTimeout();
                } else {
                    scope.mapResizeDone = false;
                    scope.checkPanel();
                }
            }, 1000);

            // Trigger digest cycle to update the view
            if (!scope.$$phase) {
                scope.$applyAsync();
            }
        }

        // Add the event listener
        $window.addEventListener('resize', handleResize);
        $window.addEventListener('mapResize', handleResizeAdjust);

        scope.bindZoomButtons($(element));

        scope.$on(
                   "$destroy",
                   function (event) {
                       //clear timers
                       clearTimeout(tAutoRefresh);
                       cancelResizeAdjustTimeout();
                       //Remove the event listener
                       $window.removeEventListener('resize', handleResize);
                       $window.removeEventListener('mapResize', handleResizeAdjust);
                       //remove Zoom Buttons binding
                       $(element).find("#mcZoomBar_zoomout").off("click.mapZoom");
                       $(element).find("#mcZoomBar_zoomin").off("click.mapZoom");
                       //close orphan popups
                       $(".tmpPopUpDevice").dialog("close");
                       $('div.ui-tooltip').remove();
                       //
                       $(".ui-helper-hidden-accessible").remove();
                       mapStopRefresh = true;
                   }
               );
    }
    return {
        restrict: 'A',
        replace: false,
        link: link
    };
    }]);
"use strict";

angular.module("mc.management-report", []);
'use strict';

function ManagementReportController($, $rootScope, $scope, $sce, $http, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, REPORTS, $timeout, $filter, $element, $window, detectBrowserService, $compile, $location, toaster) {
    var ctrl = this;
    ctrl.initLoad = true;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.isRefresh = false;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.curentBrowser = detectBrowserService();
        $scope.downloadViewTypeOptions = [3];
        $scope.openOverview = function () {
            if (!ctrl.mobile && !ctrl.classicView) {
                openViewService.openView('Overview', { width: 750, height: 450 }, void 0, void 0, { minimumWidth: 500, minimumHeight: 100 });
            } else {
                $location.path('/overview/overview-template');
            }
        };
        $scope.openUnitCheckIn = function () {
            if (!ctrl.mobile && !ctrl.classicView) {
                openViewService.openView('Unit Check In Report', { width: 900, height: 600 }, { my: 'right-10 top+10', at: 'right top', of: window }, void 0, { minimumWidth: 500, minimumHeight: 300 });
            } else {
                $location.path('/checkin/checkin-report');
            }
        };
        $scope.openAlarmHistory = function () {
            if (!ctrl.mobile && !ctrl.classicView) {
                openViewService.openView('Alarm History', { width: 850, height: 500 }, void 0, void 0, { minimumWidth: 625, minimumHeight: 240 });
            } else {
                $location.path('/alarmhistory/alarm-history');
            }
        };
        $scope.openDisabledInputs = function () {
            if (!ctrl.mobile && !ctrl.classicView) {
                openViewService.openView('Disabled Inputs Report', { width: 900, height: 600 }, { my: 'right-10 top+10', at: 'right top', of: window }, void 0, { minimumWidth: 500, minimumHeight: 300 });
            } else {
                $location.path('/disabledinput/disabled-input-report');
            }
        };
        $scope.openUntestedWetWellInputs = function () {
            if (!ctrl.mobile && !ctrl.classicView) {
                openViewService.openView('Untested Wet Well Inputs', { width: 900, height: 600 }, { my: 'right-10 top+10', at: 'right top', of: window }, void 0, { minimumWidth: 500, minimumHeight: 300 });
            } else {
                $location.path('/untestedwetwellinput/untested-wet-well-input-report');
            }
        };

        ctrl.goSelectReportData();
        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.mostRecentData = function () {
        ctrl.isRefresh = true;
        ctrl.myDate = null;
        toaster.pop('success', $scope.windowTitle + '--' + $scope.deviceSelectedName, 'View reloading');
        ctrl.managementReportLoading = true;
        ctrl.goSelectReportData();
    };

    ctrl.selectMyDate = function () {
        ctrl.goSelectReportData(true);
        return;
    };

    ctrl.goSelectReportData = function (varClick) {
        ctrl.alerts = [];
        var numberOfDays = 30,
            _tmpStartDate;
        ctrl.managementReportLoading = true;
        if (varClick) {
            if (ctrl.myDate == null) {
                _tmpStartDate = new Date();
            } else {
                _tmpStartDate = ctrl.myDate;
            }
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        } else if (!ctrl.mobile && !ctrl.classicView && ctrl.stickyProperties.on == true) {
            ctrl.stickyProperties.on = false;
            _tmpStartDate = new Date(ctrl.stickyProperties.dateMin + ctrl.unixDay);
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.myDate = _tmpStartDate;
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        } else {
            //_tmpStartDate = new Date();
            //_tmpStartDate.setHours(0, 0, 0, 0);
            //$scope.myDate = _tmpStartDate;
            //ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
            _tmpStartDate = null;
            ctrl.initLoad = false;
        }

        if (ctrl.isRefresh) {
            ctrl.isRefresh = false;
            _tmpStartDate = null;
            ctrl.startDate = undefined;
        }
        //ctrl.endDate = new Date(_tmpStartDate.getTime());

        var now = new Date(ctrl.startDate);
        var _tmpTestEventDate = now.getUTCFullYear().toString() + ("0" + (now.getUTCMonth() + 1)).slice(-2) + ("0" + now.getUTCDate()).slice(-2);

        var url;
        ctrl.reportDate = _tmpStartDate == null ? "" : _tmpTestEventDate;

        if ($scope.curentBrowser === "pdf-old-code-chrome") {
            url = REPORTS + "/api/Reports/ManagementReport?customerId=" + ctrl.accountInfo.customerId + "&display=pdf" + "&reportDate=" + ctrl.reportDate;
            $http.get(url, { responseType: 'arraybuffer' }).then(function (result) {
                var file = new Blob([result.data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                ctrl.fileURL = $sce.trustAsResourceUrl(fileURL);
                var _elm = $element.find(".mc-rpt-pdf");
                _elm.html('<object data="' + ctrl.fileURL + '#zoom=68" type="application/pdf" style="width: 100%; height: 100%"/></object>');
                if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: ctrl.startDate, dataMax: null, zoomMin: ctrl.startDate, zoomMax: null, windowId: ctrl.windowId });
            }).then(function (result) {
                ctrl.managementReportLoading = false;
            });
        } else {
            url = REPORTS + "/api/Reports/ManagementReport?customerId=" + ctrl.accountInfo.customerId + "&display=inlinehtml" + "&reportDate=" + ctrl.reportDate + "&langId=" + ctrl.accountInfo.preferenceUser.i18nCode;
            var _elm = $element.find(".mc-rpt-pdf");

            $http.get(url).then(function (result) {
                result.data = result.data.replace("RTU Count", "<span style='text-decoration:underline; cursor:pointer' ng-click='openOverview()'>RTU Count</span>");
                result.data = result.data.replace("RTU Connectivity", "<span style='text-decoration:underline; cursor:pointer' ng-click='openUnitCheckIn()'>RTU Connectivity</span>");
                result.data = result.data.replace("Acknowledgment Time", "<span style='text-decoration:underline; cursor:pointer' ng-click='openAlarmHistory()'>Acknowledgment Time</span>");
                result.data = result.data.replace("Disabled Inputs", "<span style='text-decoration:underline; cursor:pointer' ng-click='openDisabledInputs()'>Disabled Inputs</span>");
                result.data = result.data.replace("Untested Wet Well Inputs", "<span style='text-decoration:underline; cursor:pointer' ng-click='openUntestedWetWellInputs()'>Untested Wet Well Inputs</span>");
                result.data = result.data.replace("More di", "<span style='text-decoration:underline; cursor:pointer' ng-click='openDisabledInputs()'>More</span>");
                result.data = result.data.replace("More ww", "<span style='text-decoration:underline; cursor:pointer' ng-click='openUntestedWetWellInputs()'>More</span>");
                result.data = result.data.replace("de plus di", "<span style='text-decoration:underline; cursor:pointer' ng-click='openDisabledInputs()'>de plus</span>");
                result.data = result.data.replace("de plus ww", "<span style='text-decoration:underline; cursor:pointer' ng-click='openUntestedWetWellInputs()'>de plus</span>");
                result.data = result.data.replace("Nombre d’unité", "<span style='text-decoration:underline; cursor:pointer' ng-click='openOverview()'>Nombre d’unité</span>");
                result.data = result.data.replace("Pourcentage de temps en ligne", "<span style='text-decoration:underline; cursor:pointer' ng-click='openUnitCheckIn()'>Pourcentage de temps en ligne</span>");
                result.data = result.data.replace("Temps d’aquitement", "<span style='text-decoration:underline; cursor:pointer' ng-click='openAlarmHistory()'>Temps d’aquitement</span>");
                result.data = result.data.replace("Entrées désactivées", "<span style='text-decoration:underline; cursor:pointer' ng-click='openDisabledInputs()'>Entrées désactivées</span>");
                result.data = result.data.replace("Entrées non-testées", "<span style='text-decoration:underline; cursor:pointer' ng-click='openUntestedWetWellInputs()'>Entrées non-testées</span>");
                result.data = result.data.replace("More md", "<span style='text-decoration:underline; cursor:pointer' ng-click='openAlarmHistory()'>More</span>");
                result.data = result.data.replace("de plus md", "<span style='text-decoration:underline; cursor:pointer' ng-click='openAlarmHistory()'>de plus</span>");
                _elm.html($compile(result.data)($scope));
                if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: ctrl.startDate, dataMax: null, zoomMin: ctrl.startDate, zoomMax: null, windowId: ctrl.windowId });
            }).then(function (result) {
                ctrl.managementReportLoading = false;
                if (!ctrl.mobile && !ctrl.classicView) $scope.adjustSize();
            });
        }
    };

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.goSelectReportData();
    });

    ctrl.downloadWidget = function () {
        var url = REPORTS + "/api/Reports/ManagementReport?customerId=" + ctrl.accountInfo.customerId + "&display=pdf" + "&reportDate=" + ctrl.reportDate + "&langId=" + (ctrl.accountInfo.preferenceUser.i18nCode === "fr" ? "fr" : "en");
        $http.get(url, { responseType: 'arraybuffer' }).then(function (result) {
            var blob = new Blob([result.data], { type: 'application/pdf' });
            $timeout(function () {
                var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000),
                    day = beforeOneWeek.getDay(),
                    diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1),
                    lastMonday = new Date(beforeOneWeek.setDate(diffToMonday)),
                    lastSunday = new Date(beforeOneWeek.setDate(diffToMonday - 1));
                var date = ctrl.reportDate === "" ? datetimeService.formatDate(lastSunday, 'yyyyMMdd') : ctrl.reportDate;
                var name = "ManagementReport_" + date + ".pdf";
                saveAs(blob, name);
            }, 0);
        }).then(function (result) {
            ctrl.managementReportLoading = false;
        });
    };
};

ManagementReportController.$inject = ['$', '$rootScope', '$scope', '$sce', '$http', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'REPORTS', '$timeout', '$filter', '$element', '$window', 'detectBrowserService', '$compile', '$location', 'toaster'];
'use strict';

angular.module('mc.management-report').component('managementReport', {
    controller: ManagementReportController,
    transclude: true,
    templateUrl: 'ui/management/management-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.widget-switch-display", []);
"use strict";

angular.module("mc.widget-display", []);
'use strict';

function McWidgetSwitchDisplayFactory(HOST, $http) {

    // instantiate our initial object
    var McWidgetSwitchDisplay = function McWidgetSwitchDisplay(customerId, deviceId, timeZone) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
    };

    McWidgetSwitchDisplay.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/Analog/Gauge' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetSwitchDisplay.prototype.getDeviceState = function () {
        var self = this;
        return $http.get(HOST + '/api/DeviceState' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetSwitchDisplay.prototype.getWidgetData = function (channel) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McWidgetSwitchDisplay;
}

McWidgetSwitchDisplayFactory.$inject = ['HOST', '$http'];

angular.module('mc.widget-display').factory('McWidgetSwitchDisplayFactory', McWidgetSwitchDisplayFactory);
"use strict";

function McWidgetSwitchDisplayController($, $timeout, $rootScope, $scope, $element, McWidgetSwitchDisplayFactory, $compile, websocketService, toaster, datetimeService, sharedSetupService, McSwitchGaugeFactory, authenticationService, translationService, PopupFactory, McWidgetsSharedFactory) {

    var ctrl = this;
    var chart = void 0;
    var tmpInit = true;

    ctrl.$onInit = function () {
        ctrl.alerts = [];
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
    };

    ctrl.pwMouseEnter = function (event) {
        if (!angular.isUndefined(ctrl.widgetSetting)) ctrl.popupWindow.getStatusTooltip(ctrl.widgetSetting, event, angular.isUndefined(ctrl.additionalSize) ? ctrl.svgSizeH / 2.5 : ctrl.additionalSize - 5);
    };

    ctrl.pwMouseLeave = function (event) {
        if (!angular.isUndefined(ctrl.widgetSetting)) ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            tmpInit = true;
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.buildWidget(changes.widgetSetting.currentValue);
        }
    };

    ctrl.buildWidget = function (widgetData) {

        if (ctrl.mcWidgetsSharedFactory.checkForEmptyObject(widgetData.switchGauge)) {
            var errormsg = ctrl.translation.text.NOT_SETUP;
            ctrl.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            return;
        } else {
            ctrl.alerts = [];
        }

        ctrl.widgetSetting = widgetData;

        ctrl.w_BorderWidth = 2; // Set the inside solid border of the HUD
        ctrl.w_BorderPadding = 5; // Set the outside opaque border outline

        ctrl.show_chartdata = "No";

        ctrl.setSize(ctrl.widgetSetting.setting.defaultSetting ? ctrl.widgetSetting.defaultSetting.sizeId : ctrl.widgetSetting.switchWidgetSetting.sizeId);

        ctrl.buildMainClass();

        ctrl.loadingInProgress = false;

        ctrl.noDecimals = sharedSetupService.getNumberOfDecimals(ctrl.widgetSetting.switchGauge.maxVal, ctrl.widgetSetting.switchGauge.minVal);
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);

        if (ctrl.widgetSetting.setting.displaySettingOn) {
            var newScope = $scope;
            var html = '<mc-widget-switch-setting widget-setting="$ctrl.widgetSetting" ng-if="$ctrl.widgetSetting.setting.displaySetting" change-display-options="$ctrl.fnChangeDisplayOptions(settingOptions)"></mc-widget-switch-setting>';
            var element = $element.find('.component-setting');
            if (element.is(':empty')) {
                element.append($compile(html)(newScope));
            }
        }

        ctrl.loadingInProgress = false;
    };

    ctrl.getData = function (deviceId, channel, openSetting) {

        var _switchGauge = new McSwitchGaugeFactory(ctrl.accountInfo.customerId, deviceId, ctrl.accountInfo.timeZone, 2, 4, channel); //Category: Switch, Widget: 'Single Needle Gauge'

        _switchGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;

            var device = _switchGauge.list.device;
            var deviceDigitalData = _switchGauge.list.digitalData;
            var defaultSetting = _switchGauge.list.defaultSetting;
            var switchGauge = _switchGauge.list.switchGauge[0].switchGauge;
            var switchWidgetSetting = _switchGauge.list.switchGauge[0].switchWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.widgetSetting.setting.displaySetting,
                displaySettingOn: ctrl.widgetSetting.setting.displaySettingOn,
                defaultSetting: ctrl.widgetSetting.setting.defaultSetting
            };

            ctrl.switchGauge = {
                device: device,
                deviceDigitalData: deviceDigitalData,
                defaultSetting: defaultSetting,
                switchGauge: switchGauge,
                switchWidgetSetting: switchWidgetSetting,
                setting: setting
            };

            ctrl.buildWidget(ctrl.switchGauge);
            ctrl.fnSizeOptions(ctrl.switchGauge.switchWidgetSetting.sizeId);
            //ctrl.fnMakeFitTextWork();
            if (!angular.isUndefined(openSetting)) {
                $timeout(function () {
                    ctrl.mouseOverHUD();
                    ctrl.editSetting();
                }, 0);
            }

            ctrl.updateWidgetTitle();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.updateWidgetTitle = function () {
        ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.widgetSetting.device.deviceId, name: ctrl.widgetSetting.device.name, serialNumber: ctrl.widgetSetting.device.serialNumber, channel: ctrl.widgetSetting.switchGauge.channel, channelDescription: ctrl.widgetSetting.switchGauge.description, titleId: ctrl.widgetSetting.switchWidgetSetting.titleId } });
    };

    ctrl.fnMakeFitTextWork = function () {
        // $compile($element.find(".mc-fittext"))($scope);
    };

    ctrl.fnThemeOptions = function (themeName) {
        ctrl.widgetSetting.switchWidgetSetting.theme = themeName;
        ctrl.buildMainClass();
    };

    ctrl.fnTitleOptions = function (titleOption) {
        ctrl.widgetSetting.switchWidgetSetting.titleId = titleOption.id;
        ctrl.widgetSetting.switchWidgetSetting.titleState = titleOption.state;
        ctrl.updateWidgetTitle();
    };

    ctrl.fnStateOptions = function (stateOption) {
        ctrl.widgetSetting.switchWidgetSetting.stateId = stateOption.id;
        ctrl.widgetSetting.switchWidgetSetting.stateDescription = stateOption.description;
        ctrl.buildMainClass();
    };

    ctrl.fnSizeOptions = function (sizeId, openSetting) {

        if (!ctrl.widgetSetting.setting.displaySetting) return;
        ctrl.widgetSetting.switchWidgetSetting.sizeId = sizeId;
        ctrl.setSize(sizeId);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.parent().addClass("ui-widget-content-mc");

            $timeout(function () {
                var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
                ctrl.popup.parent().css("height", svgH + "px");
                ctrl.popup.parent().css("width", svgH + 25 + "px");
                ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
            }, 0);
        }
        ctrl.closeSetting();
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);
        ctrl.buildMainClass();

        if (!angular.isUndefined(openSetting)) {
            $timeout(function () {
                ctrl.mouseOverHUD();
                ctrl.editSetting();
            }, 0);
        }
    };

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 3);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.fnColorOptions = function (colorOption) {
        ctrl.widgetSetting.switchWidgetSetting.contactOpenColor = colorOption.contactOpenColor;
        ctrl.widgetSetting.switchWidgetSetting.contactClosedColor = colorOption.contactClosedColor;
        ctrl.widgetSetting.switchWidgetSetting.inputFaultColor = colorOption.inputFaultColor;
        ctrl.buildMainClass();
        //ctrl.closeSetting();
    };

    ctrl.fnRtuSwitchOptions = function (rtuswitch) {
        ctrl.buildMainClass();
        ctrl.hudText = rtuswitch;
    };

    ctrl.fnChangeDisplayOptions = function (parSettingOptions) {
        if (!angular.isUndefined(parSettingOptions.titleOption)) {
            ctrl.fnTitleOptions(parSettingOptions.titleOption);
        }
        if (!angular.isUndefined(parSettingOptions.stateOption)) {
            ctrl.fnStateOptions(parSettingOptions.stateOption);
        }
        if (!angular.isUndefined(parSettingOptions.sizeOption)) {
            ctrl.fnSizeOptions(parSettingOptions.sizeOption.id, true);
        }
        if (!angular.isUndefined(parSettingOptions.colorOption)) {
            ctrl.fnColorOptions(parSettingOptions.colorOption);
        }
        if (!angular.isUndefined(parSettingOptions.rtuOption)) {
            ctrl.getData(parSettingOptions.rtuOption.deviceId, parSettingOptions.rtuOption.channel, true);
        }
    };

    ctrl.editSetting = function (event) {
        ctrl.mcWidgetsSharedFactory.editSetting($element, event, ctrl);
    };

    ctrl.closeSetting = function () {
        ctrl.mcWidgetsSharedFactory.closeSetting($element, ctrl);
    };

    ctrl.mouseOverHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOver;
        }
    };
    ctrl.mouseOffHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOff;
        }
    };

    ctrl.resize_HUD = function (w_svgSizeW, w_svgSizeH) {
        ctrl.mcWidgetsSharedFactory.resizeHud(w_svgSizeW, w_svgSizeH, ctrl);
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ctrl.buildMainClass = function () {

        ctrl.colorFaultLayer = { 'fill': 'none' };

        switch (ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.switchGauge.channel]) {
            case "True":
                ctrl.colorLayer = { 'fill': ctrl.widgetSetting.switchWidgetSetting.contactOpenColor };
                ctrl.switchValue = "OffNormal";
                break;

            case "False":
                ctrl.colorLayer = { 'fill': ctrl.widgetSetting.switchWidgetSetting.contactClosedColor };
                ctrl.switchValue = "Normal";
                break;
            case "NULL":
            case "Fault":
                ctrl.colorLayer = { 'fill': ctrl.widgetSetting.switchWidgetSetting.contactClosedColor };
                ctrl.switchValue = "InputFault";
                ctrl.colorFaultLayer = { 'fill': ctrl.widgetSetting.switchWidgetSetting.inputFaultColor };
                break;
        }

        ctrl.bridgStateClass = ["BridgeUp" + " " + ctrl.switchValue];
    };

    // from socket

    ctrl.updateValue = function (value) {

        switch (value) {
            case "1":
                return "True";
            case "0":
                return "False";
            case "-1":
                return "Fault";
        }
        return "Fault";
    };

    ctrl.wsDataReceivedWD = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;
        // if (ctrl.widgetSetting.switchGauge.channel > 8) return;

        var chValue = data.Value;
        var channel = parseInt(data.CH);

        if (ctrl.widgetSetting.switchGauge.channel == channel) {
            var digValue = ctrl.updateValue(chValue);
            ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.switchGauge.channel] = digValue;
            ctrl.buildMainClass();
        }
    };

    ctrl.wsDataReceivedWOD = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;
        if (ctrl.widgetSetting.switchGauge.channel <= 8) return;

        var chArray = data.Value.replace(/[[\]]/g, '').split(',');
        var digValue = ctrl.updateValue(chArray[ctrl.widgetSetting.switchGauge.channel - 9]);
        ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.switchGauge.channel] = digValue;
        ctrl.buildMainClass();
    };

    ctrl.wsDataReceivedFAULTS = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;
        var faultBinary;
        if (isNaN(data.Value)) {
            faultBinary = data.Value.replace(/[[\]]/g, '').split(',').join('');
        } else {
            faultBinary = (data.Value >>> 0).toString(2);

            while (faultBinary.length < 16) {
                faultBinary = faultBinary.length < 8 ? "0" + faultBinary : faultBinary + "0";
            }
        }

        if (faultBinary[ctrl.widgetSetting.switchGauge.channel - 1] === '1') {
            //console.log('Got a fault for channel: ', channelId);
            ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.switchGauge.channel] = "NULL";
            ctrl.buildMainClass();
        }
    };

    ctrl.webSocketReconnect = function () {
        //if widget then toaster message... if gauge then not
        if (angular.isUndefined(ctrl.additionalSize)) toaster.pop('success', "Switch Widget" + " -- " + ctrl.widgetSetting.device.name, 'View reloading');
        ctrl.getData(ctrl.widgetSetting.device.deviceId, ctrl.widgetSetting.switchGauge.channel);
    };

    var _onINPUTS = $rootScope.$on('DIGITALINPUT', function (event, args) {
        ctrl.wsDataReceivedWD(args.data);
    });

    var _onOPTIONDIGITAL = $rootScope.$on('OPTIONDIGITAL', function (event, args) {
        ctrl.wsDataReceivedWOD(args.data);
    });

    var _onFAULTS = $rootScope.$on('FAULTS', function (event, args) {
        ctrl.wsDataReceivedFAULTS(args.data);
    });

    var _onRECONNECT = $scope.$on('processReconnect', function (event, args) {
        ctrl.webSocketReconnect();
    });

    var _onDocumentClick = $rootScope.$on('document_click', function (event, args) {
        ctrl.closeSetting();
    });

    $scope.$on("$destroy", function () {
        _onDocumentClick();
        _onINPUTS();
        _onOPTIONDIGITAL();
        _onFAULTS();
        _onRECONNECT();
        if (chart) chart.destroy();
    });
}

McWidgetSwitchDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'McWidgetSwitchDisplayFactory', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'McSwitchGaugeFactory', 'authenticationService', 'translationService', 'PopupFactory', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-switch-display').component('mcWidgetSwitchDisplay', {
    controller: McWidgetSwitchDisplayController,
    templateUrl: 'ui/mcwidgetswitchdisplay/mcwidget-switch-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        settingShow: '&',
        changeWidgetTitle: '&',
        labelMode: '@',
        additionalSize: '@'
    }
});
"use strict";

angular.module("mc.widget-switch-setting", []);
"use strict";

function McWidgetSwitchSettingController($, $timeout, $rootScope, $scope, $element, $interval, $compile, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, digitalWidgetService, McWidgetsSharedFactory) {

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            ctrl.mcWidgetSwitchSetting = changes.widgetSetting.currentValue;
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.getUiData();
        }
    };

    ctrl.$onInit = function () {
        if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        ctrl.w_tabpaneIsOpen = { "height": "100%", "display": "block" };
        ctrl.w_tabpaneIsClosed = { "height": "0%", "display": "none" };
        ctrl.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.colorPalet = ctrl.mcWidgetsSharedFactory.getColorPalet();
    };

    ctrl.setModel = function (parm) {
        ctrl.clearModel();
        $timeout(function () {
            ctrl.parm = parm;
        }, 0);
    };

    ctrl.clearModel = function () {
        ctrl.parm = null;
    };

    ctrl.testNgChange = function () {
        ctrl.validateColors(true);
    };

    ctrl.selectColor = function (event) {
        switch (ctrl.parm) {
            case "contactOpenColor":
                ctrl.contactOpenColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "inputFaultColor":
                ctrl.inputFaultColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "contactClosedColor":
                ctrl.contactClosedColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            default:
            // code block
        }
        ctrl.clearModel();
        ctrl.validateColors(true);
    };

    ctrl.updateDisplayOptions = function (param) {

        var tmpNewStateWidgetSetting = angular.copy(ctrl.mcWidgetSwitchSetting.switchWidgetSetting);
        tmpNewStateWidgetSetting.customerId = ctrl.accountInfo.customerId;
        tmpNewStateWidgetSetting.deviceId = ctrl.mcWidgetSwitchSetting.device.deviceId;
        tmpNewStateWidgetSetting.channel = ctrl.mcWidgetSwitchSetting.switchGauge.channel;

        if (!angular.isUndefined(param.settingOptions.titleOption)) {
            tmpNewStateWidgetSetting.titleId = param.settingOptions.titleOption.id;
            ctrl.updateUiData(param, tmpNewStateWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.stateOption)) {
            tmpNewStateWidgetSetting.stateId = param.settingOptions.stateOption.id;
            ctrl.updateUiData(param, tmpNewStateWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.sizeOption)) {
            tmpNewStateWidgetSetting.sizeId = param.settingOptions.sizeOption.id;
            ctrl.updateUiData(param, tmpNewStateWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.colorOption)) {
            tmpNewStateWidgetSetting.contactOpenColor = param.settingOptions.colorOption.contactOpenColor;
            tmpNewStateWidgetSetting.contactClosedColor = param.settingOptions.colorOption.contactClosedColor;
            tmpNewStateWidgetSetting.inputFaultColor = param.settingOptions.colorOption.inputFaultColor;

            ctrl.updateUiData(param, tmpNewStateWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.rtuOption)) {

            ctrl.getChannels(param.settingOptions.rtuOption.deviceId, true);
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: param.settingOptions.rtuOption.deviceId, channel: ctrl.channelSelectedOption.channel } } });
        }

        if (!angular.isUndefined(param.settingOptions.channelOption)) {
            ctrl.channelSelectedOption = { channel: param.settingOptions.channelOption.channel };
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: ctrl.rtuSelectedOption.deviceId, channel: param.settingOptions.channelOption.channel } } });
        }
    };

    ctrl.updateUiData = function (param, naws) {
        ctrl.mcWidgetsSharedFactory.updateUiData(param, naws, "GaugeSwitchWidget", "newMcWidgetSwitchSettingOptions", ctrl);
    };

    ctrl.getUiData = function () {
        ctrl.mcWidgetsSharedFactory.getUiData("mcWidgetSwitchSettingOptions", "All", ctrl);
    };

    ctrl.getSetting = function () {
        digitalWidgetService.getSettings(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.rtuOptions = result.data.digitalDevices;
            ctrl.switchSettings = result.data.digitalSettings;

            ctrl.getChannels(ctrl.mcWidgetSwitchSetting.device.deviceId);

            ctrl.rtuSelectedOption = { deviceId: ctrl.mcWidgetSwitchSetting.device.deviceId, name: ctrl.mcWidgetSwitchSetting.device.name };
        }, function (error) {});
    };

    ctrl.getChannels = function (deviceId, firstChannel) {
        ctrl.channelOptions = [];

        angular.forEach(ctrl.switchSettings, function (switchSetting) {
            if (parseInt(deviceId) === parseInt(switchSetting.deviceId) && switchSetting.digitalMode !== "P") {
                ctrl.channelOptions.push(switchSetting);
            }
        });

        if (firstChannel) {
            ctrl.channelSelectedOption = { channel: ctrl.channelOptions[0].channel, description: ctrl.channelOptions[0].description };
        } else {
            ctrl.channelSelectedOption = { channel: ctrl.mcWidgetSwitchSetting.switchGauge.channel, description: ctrl.mcWidgetSwitchSetting.switchGauge.description };
        }
    };

    ctrl.setOptions = function () {
        ctrl.chartTimeOptions = ctrl.mcWidgetSwitchSettingOptions.trendingChart;
        ctrl.chartTimeSelectedOption = { option: "Off" }; //{ option: ctrl.mcWidgetSwitchSetting.switchWidgetSetting.trendingChart };

        ctrl.titleOptions = ctrl.mcWidgetSwitchSettingOptions.title;
        ctrl.titleSelectedOption = { id: ctrl.mcWidgetSwitchSetting.switchWidgetSetting.titleId };

        ctrl.sizeOptions = ctrl.mcWidgetSwitchSettingOptions.size;
        ctrl.sizeSelectedOption = { id: ctrl.mcWidgetSwitchSetting.switchWidgetSetting.sizeId };

        ctrl.stateOptions = ctrl.mcWidgetSwitchSettingOptions.state;
        ctrl.stateSelectedOption = { id: ctrl.mcWidgetSwitchSetting.switchWidgetSetting.stateId };

        ctrl.contactOpenColor = ctrl.mcWidgetSwitchSetting.switchWidgetSetting.contactOpenColor;
        ctrl.contactClosedColor = ctrl.mcWidgetSwitchSetting.switchWidgetSetting.contactClosedColor;
        ctrl.inputFaultColor = ctrl.mcWidgetSwitchSetting.switchWidgetSetting.inputFaultColor;

        ctrl.validateColors();
    };

    ctrl.validateColors = function (_dataChanged) {

        if (ctrl.contactOpenColor.length !== 7 || ctrl.contactOpenColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidContactOpenColor = true;
        } else {
            ctrl.invalidContactOpenColor = false;
        }
        if (ctrl.inputFaultColor.length !== 7 || ctrl.inputFaultColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidInputFaultColor = true;
        } else {
            ctrl.invalidInputFaultColor = false;
        }
        if (ctrl.contactClosedColor.length !== 7 || ctrl.contactClosedColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidContactClosedColor = true;
        } else {
            ctrl.invalidContactClosedColor = false;
        }

        ctrl.invalidColor = ctrl.invalidContactOpenColor || ctrl.invalidInputFaultColor || ctrl.invalidContactClosedColor ? true : false;

        if (_dataChanged && !ctrl.invalidColor) {
            ctrl.updateDisplayOptions({
                settingOptions: {
                    colorOption: {
                        contactOpenColor: ctrl.contactOpenColor,
                        contactClosedColor: ctrl.contactClosedColor,
                        inputFaultColor: ctrl.inputFaultColor
                    }
                }
            });
        }
    };

    ctrl.showTab = function (parm) {
        ctrl.clearModel();
        var element = $element.find(".w_tabbox");
        ctrl.mcWidgetsSharedFactory.showTab(parm, element, ctrl);
    };

    ctrl.translateOptions = function () {
        ctrl.titleOptions.forEach(function (option) {
            return option.state = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.sizeOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.stateOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.chartTimeOptions.forEach(function (option) {
            return option.option = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
    };

    var _onUpdatePreferencesLanguage = $rootScope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translateOptions();
    });

    $scope.$on("$destroy", function () {
        _onUpdatePreferencesLanguage();
    });
}

McWidgetSwitchSettingController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', '$interval', '$compile', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'digitalWidgetService', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-switch-setting').component('mcWidgetSwitchSetting', {
    controller: McWidgetSwitchSettingController,
    templateUrl: 'ui/mcwidgetswitchsetting/mcwidget-switch-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        changeDisplayOptions: '&'
    }
});
"use strict";

angular.module("mc.widget-runtime-setting", []);
"use strict";

function McWidgetRuntimeSettingController($, $timeout, $rootScope, $scope, $element, $interval, $compile, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, digitalWidgetService, McWidgetsSharedFactory) {

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            ctrl.mcWidgetRuntimeSetting = changes.widgetSetting.currentValue;
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.getUiData();
        }
    };

    ctrl.$onInit = function () {
        if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        ctrl.w_tabpaneIsOpen = { "height": "100%", "display": "block" };
        ctrl.w_tabpaneIsClosed = { "height": "0%", "display": "none" };
        ctrl.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.colorPalet = ctrl.mcWidgetsSharedFactory.getColorPalet();
    };

    ctrl.setModel = function (parm) {
        ctrl.clearModel();
        $timeout(function () {
            ctrl.parm = parm;
        }, 0);
    };

    ctrl.clearModel = function () {
        ctrl.parm = null;
    };

    ctrl.testNgChange = function () {
        ctrl.validateColors(true);
    };

    ctrl.selectColor = function (event) {
        switch (ctrl.parm) {
            case "runningColor":
                ctrl.runningColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "notRunningColor":
                ctrl.notRunningColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "faultColor":
                ctrl.faultColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            default:
            // code block
        }
        ctrl.clearModel();
        ctrl.validateColors(true);
    };

    ctrl.updateDisplayOptions = function (param) {

        var tmpNewRuntimeWidgetSetting = angular.copy(ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting);
        tmpNewRuntimeWidgetSetting.customerId = ctrl.accountInfo.customerId;
        tmpNewRuntimeWidgetSetting.deviceId = ctrl.mcWidgetRuntimeSetting.device.deviceId;
        tmpNewRuntimeWidgetSetting.channel = ctrl.mcWidgetRuntimeSetting.runtimeGauge.channel;

        if (!angular.isUndefined(param.settingOptions.titleOption)) {
            tmpNewRuntimeWidgetSetting.titleId = param.settingOptions.titleOption.id;
            ctrl.updateUiData(param, tmpNewRuntimeWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.stateOption)) {
            tmpNewRuntimeWidgetSetting.stateId = param.settingOptions.stateOption.id;
            ctrl.updateUiData(param, tmpNewRuntimeWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.sizeOption)) {
            tmpNewRuntimeWidgetSetting.sizeId = param.settingOptions.sizeOption.id;
            ctrl.updateUiData(param, tmpNewRuntimeWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.colorOption)) {

            tmpNewRuntimeWidgetSetting.runningColor = param.settingOptions.colorOption.runningColor;
            tmpNewRuntimeWidgetSetting.runningBlink = param.settingOptions.colorOption.runningBlink;
            tmpNewRuntimeWidgetSetting.notRunningColor = param.settingOptions.colorOption.notRunningColor;
            tmpNewRuntimeWidgetSetting.notRunningBlink = param.settingOptions.colorOption.notRunningBlink;
            tmpNewRuntimeWidgetSetting.faultColor = param.settingOptions.colorOption.faultColor;
            tmpNewRuntimeWidgetSetting.faultBlink = param.settingOptions.colorOption.faultBlink;

            ctrl.updateUiData(param, tmpNewRuntimeWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.rtuOption)) {

            ctrl.getChannels(param.settingOptions.rtuOption.deviceId, true);
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: param.settingOptions.rtuOption.deviceId, channel: ctrl.channelSelectedOption.channel } } });
        }

        if (!angular.isUndefined(param.settingOptions.channelOption)) {
            ctrl.channelSelectedOption = { channel: param.settingOptions.channelOption.channel };
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: ctrl.rtuSelectedOption.deviceId, channel: param.settingOptions.channelOption.channel } } });
        }
    };

    ctrl.updateUiData = function (param, naws) {
        ctrl.mcWidgetsSharedFactory.updateUiData(param, naws, "GaugeRuntimeWidget", "newMcWidgetRuntimeSettingOptions", ctrl);
    };

    ctrl.getUiData = function () {
        ctrl.mcWidgetsSharedFactory.getUiData("mcWidgetRuntimeSettingOptions", "All", ctrl);
    };

    ctrl.getSetting = function () {
        digitalWidgetService.getSettings(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.rtuOptions = result.data.digitalDevices;
            ctrl.runtimeSettings = result.data.digitalSettings;

            ctrl.getChannels(ctrl.mcWidgetRuntimeSetting.device.deviceId);

            ctrl.rtuSelectedOption = { deviceId: ctrl.mcWidgetRuntimeSetting.device.deviceId, name: ctrl.mcWidgetRuntimeSetting.device.name };
        }, function (error) {});
    };

    ctrl.getChannels = function (deviceId, firstChannel) {
        ctrl.channelOptions = [];

        angular.forEach(ctrl.runtimeSettings, function (runtimeSetting) {
            if (parseInt(deviceId) === parseInt(runtimeSetting.deviceId) && runtimeSetting.digitalMode === "P") {
                ctrl.channelOptions.push(runtimeSetting);
            }
        });

        if (firstChannel) {
            ctrl.channelSelectedOption = { channel: ctrl.channelOptions[0].channel, description: ctrl.channelOptions[0].description };
        } else {
            ctrl.channelSelectedOption = { channel: ctrl.mcWidgetRuntimeSetting.runtimeGauge.channel, description: ctrl.mcWidgetRuntimeSetting.runtimeGauge.description };
        }
    };

    ctrl.setOptions = function () {
        ctrl.titleOptions = ctrl.mcWidgetRuntimeSettingOptions.title;
        ctrl.titleSelectedOption = { id: ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.titleId };

        ctrl.sizeOptions = ctrl.mcWidgetRuntimeSettingOptions.size;
        ctrl.sizeSelectedOption = { id: ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.sizeId };

        ctrl.runningColor = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.runningColor;
        ctrl.runningBlink = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.runningBlink;
        ctrl.notRunningColor = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.notRunningColor;
        ctrl.notRunningBlink = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.notRunningBlink;
        ctrl.faultColor = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.faultColor;
        ctrl.faultBlink = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.faultBlink;

        ctrl.validateColors();
    };

    ctrl.validateColors = function (_dataChanged) {
        if (ctrl.runningColor.length !== 7 || ctrl.runningColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidRunningColor = true;
        } else {
            ctrl.invalidRunningColor = false;
        }
        if (ctrl.notRunningColor.length !== 7 || ctrl.notRunningColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidNotRunningColor = true;
        } else {
            ctrl.invalidNotRunningColor = false;
        }
        if (ctrl.faultColor.length !== 7 || ctrl.faultColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidFaultColor = true;
        } else {
            ctrl.invalidFaultColor = false;
        }

        ctrl.invalidColor = ctrl.invalidRunningColor || ctrl.invalidNotRunningColor || ctrl.invalidFaultColor ? true : false;

        if (_dataChanged && !ctrl.invalidColor) {
            ctrl.updateDisplayOptions({
                settingOptions: {
                    colorOption: {
                        runningColor: ctrl.runningColor,
                        runningBlink: ctrl.runningBlink,
                        notRunningColor: ctrl.notRunningColor,
                        notRunningBlink: ctrl.notRunningBlink,
                        faultColor: ctrl.faultColor,
                        faultBlink: ctrl.faultBlink
                    }
                }
            });
        }
    };

    ctrl.checkRunningNotRunningAnimation = function (parm) {
        switch (parm) {
            case "Running":
                if (ctrl.runningBlink) ctrl.notRunningBlink = false;
                break;
            case "Not Running":
                if (ctrl.notRunningBlink) ctrl.runningBlink = false;
                break;
        }
        ctrl.validateColors(true);
    };

    ctrl.showTab = function (parm) {
        ctrl.clearModel();
        var element = $element.find(".w_tabbox");
        ctrl.mcWidgetsSharedFactory.showTab(parm, element, ctrl);
    };

    ctrl.translateOptions = function () {
        ctrl.titleOptions.forEach(function (option) {
            return option.state = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.sizeOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
    };

    var _onUpdatePreferencesLanguage = $rootScope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translateOptions();
    });

    $scope.$on("$destroy", function () {
        _onUpdatePreferencesLanguage();
    });
}

McWidgetRuntimeSettingController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', '$interval', '$compile', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'digitalWidgetService', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-runtime-setting').component('mcWidgetRuntimeSetting', {
    controller: McWidgetRuntimeSettingController,
    templateUrl: 'ui/mcwidgetruntimesetting/mcwidget-runtime-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        changeDisplayOptions: '&'
    }
});
"use strict";

angular.module("mc.widget-status-display", []);
'use strict';

function McWidgetStatusDisplayFactory(HOST, $http) {

    // instantiate our initial object
    var McWidgetStatusDisplay = function McWidgetStatusDisplay(customerId, deviceId, timeZone) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
    };

    McWidgetStatusDisplay.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/Analog/Gauge' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetStatusDisplay.prototype.getDeviceState = function () {
        var self = this;
        return $http.get(HOST + '/api/DeviceState' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetStatusDisplay.prototype.getWidgetData = function (channel) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McWidgetStatusDisplay;
}

McWidgetStatusDisplayFactory.$inject = ['HOST', '$http'];

angular.module('mc.widget-display').factory('McWidgetStatusDisplayFactory', McWidgetStatusDisplayFactory);
"use strict";

function McWidgetStatusDisplayController($, $timeout, $rootScope, $scope, $element, McWidgetStatusDisplayFactory, $compile, websocketService, toaster, datetimeService, sharedSetupService, McStatusGaugeFactory, authenticationService, translationService, PopupFactory, McWidgetsSharedFactory) {

    var ctrl = this;
    var chart = void 0;
    var tmpInit = true;

    ctrl.$onInit = function () {
        ctrl.alerts = [];
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
    };

    ctrl.pwMouseEnter = function (event) {
        if (!angular.isUndefined(ctrl.widgetSetting) && Object.keys(ctrl.widgetSetting.statusGauge).length !== 0) ctrl.popupWindow.getStatusTooltip(ctrl.widgetSetting, event, angular.isUndefined(ctrl.additionalSize) ? ctrl.svgSizeH / 2.5 : ctrl.additionalSize - 5);
    };

    ctrl.pwMouseLeave = function (event) {
        if (!angular.isUndefined(ctrl.widgetSetting) && Object.keys(ctrl.widgetSetting.statusGauge).length !== 0) ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.$onChanges = function (changes) {
        ctrl.alerts = [];
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            tmpInit = true;
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();

            if (!angular.isUndefined(changes.widgetSetting.previousValue) && !angular.isUndefined(changes.widgetSetting.previousValue.device)) ctrl.unRegisterListenerDigitalSetting(changes.widgetSetting.previousValue.device.serialNumber, changes.widgetSetting.previousValue.statusGauge.channel);

            ctrl.buildWidget(changes.widgetSetting.currentValue);
        }
    };

    ctrl.wsDataReceivedDIGITALSETTINGMCSW = function (data) {
        if (data.Type == 'DIGITALSETTING' && data.SN == ctrl.widgetSetting.device.serialNumber && data.CH == ctrl.widgetSetting.statusGauge.channel) {
            $timeout(function () {
                ctrl.getData(ctrl.widgetSetting.device.deviceId, ctrl.widgetSetting.statusGauge.channel);
            }, 200);
        }
    };

    ctrl.registerListenerDigitalSetting = function (varSerialNum, channel) {
        //subscribe for digital setting changes
        websocketService.connect();
        websocketService.register("DIGITALSETTING", varSerialNum, channel, ctrl.wsDataReceivedDIGITALSETTINGMCSW, null);
    };

    ctrl.unRegisterListenerDigitalSetting = function (varSerialNum, channel) {
        websocketService.connect();
        websocketService.unRegister("DIGITALSETTING", varSerialNum, channel, ctrl.wsDataReceivedDIGITALSETTINGMCSW, null);
    };

    ctrl.buildWidget = function (widgetData) {

        if (ctrl.mcWidgetsSharedFactory.checkForEmptyObject(widgetData.statusGauge)) {
            var errormsg = ctrl.translation.text.NOT_SETUP;
            ctrl.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            return;
        } else {
            ctrl.alerts = [];
        }

        ctrl.widgetSetting = widgetData;

        ctrl.unRegisterListenerDigitalSetting(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.statusGauge.channel);
        ctrl.registerListenerDigitalSetting(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.statusGauge.channel);

        ctrl.w_BorderWidth = 2; // Set the inside solid border of the HUD
        ctrl.w_BorderPadding = 5; // Set the outside opaque border outline

        ctrl.show_chartdata = "No";

        ctrl.setSize(ctrl.widgetSetting.setting.defaultSetting ? ctrl.widgetSetting.defaultSetting.sizeId : ctrl.widgetSetting.statusWidgetSetting.sizeId);

        ctrl.buildMainClass();

        ctrl.loadingInProgress = false;

        ctrl.noDecimals = sharedSetupService.getNumberOfDecimals(ctrl.widgetSetting.statusGauge.maxVal, ctrl.widgetSetting.statusGauge.minVal);
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);

        if (ctrl.widgetSetting.setting.displaySettingOn) {
            var newScope = $scope;
            var html = '<mc-widget-status-setting widget-setting="$ctrl.widgetSetting" ng-if="$ctrl.widgetSetting.setting.displaySetting" change-display-options="$ctrl.fnChangeDisplayOptions(settingOptions)"></mc-widget-status-setting>';
            var element = $element.find('.component-setting');
            if (element.is(':empty')) {
                element.append($compile(html)(newScope));
            }
        }

        ctrl.loadingInProgress = false;
    };

    ctrl.getData = function (deviceId, channel, openSetting) {

        var _statusGauge = new McStatusGaugeFactory(ctrl.accountInfo.customerId, deviceId, ctrl.accountInfo.timeZone, 2, 2, channel); //Category: Status, Widget: 'Single Needle Gauge'

        _statusGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;

            var device = _statusGauge.list.device;
            var deviceDigitalData = _statusGauge.list.digitalData;
            var defaultSetting = _statusGauge.list.defaultSetting;
            var statusGauge = _statusGauge.list.statusGauge[0].statusGauge;
            var statusWidgetSetting = _statusGauge.list.statusGauge[0].statusWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.widgetSetting.setting.displaySetting,
                displaySettingOn: ctrl.widgetSetting.setting.displaySettingOn,
                defaultSetting: ctrl.widgetSetting.setting.defaultSetting
            };

            ctrl.statusGauge = {
                device: device,
                deviceDigitalData: deviceDigitalData,
                defaultSetting: defaultSetting,
                statusGauge: statusGauge,
                statusWidgetSetting: statusWidgetSetting,
                setting: setting
            };

            ctrl.buildWidget(ctrl.statusGauge);
            ctrl.fnSizeOptions(ctrl.statusGauge.statusWidgetSetting.sizeId);
            //ctrl.fnMakeFitTextWork();
            if (!angular.isUndefined(openSetting)) {
                $timeout(function () {
                    ctrl.mouseOverHUD();
                    ctrl.editSetting();
                }, 0);
            }

            ctrl.updateWidgetTitle();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.updateWidgetTitle = function () {
        ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.widgetSetting.device.deviceId, name: ctrl.widgetSetting.device.name, serialNumber: ctrl.widgetSetting.device.serialNumber, channel: ctrl.widgetSetting.statusGauge.channel, channelDescription: ctrl.widgetSetting.statusGauge.description, titleId: ctrl.widgetSetting.statusWidgetSetting.titleId } });
    };

    ctrl.fnMakeFitTextWork = function () {
        // $compile($element.find(".mc-fittext"))($scope);
    };

    ctrl.fnThemeOptions = function (themeName) {
        ctrl.widgetSetting.statusWidgetSetting.theme = themeName;
        ctrl.buildMainClass();
    };

    ctrl.fnTitleOptions = function (titleOption) {
        ctrl.widgetSetting.statusWidgetSetting.titleId = titleOption.id;
        ctrl.widgetSetting.statusWidgetSetting.titleState = titleOption.state;
        ctrl.updateWidgetTitle();
    };

    ctrl.fnStateOptions = function (stateOption) {
        ctrl.widgetSetting.statusWidgetSetting.stateId = stateOption.id;
        ctrl.widgetSetting.statusWidgetSetting.stateDescription = stateOption.description;
        ctrl.buildMainClass();
    };

    ctrl.fnSizeOptions = function (sizeId, openSetting) {

        if (!ctrl.widgetSetting.setting.displaySetting) return;
        ctrl.widgetSetting.statusWidgetSetting.sizeId = sizeId;
        ctrl.setSize(sizeId);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.parent().addClass("ui-widget-content-mc");

            $timeout(function () {
                var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
                ctrl.popup.parent().css("height", svgH + "px");
                ctrl.popup.parent().css("width", svgH + 25 + "px");
                ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
            }, 0);
        }
        ctrl.closeSetting();
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);
        ctrl.buildMainClass();

        if (!angular.isUndefined(openSetting)) {
            $timeout(function () {
                ctrl.mouseOverHUD();
                ctrl.editSetting();
            }, 0);
        }
    };

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 3);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.fnColorOptions = function (colorOption) {
        ctrl.widgetSetting.statusWidgetSetting.physicalContactOpenColor = colorOption.physicalContactOpenColor;
        ctrl.widgetSetting.statusWidgetSetting.physicalContactOpenBlink = colorOption.physicalContactOpenBlink;
        ctrl.widgetSetting.statusWidgetSetting.physicalContactClosedColor = colorOption.physicalContactClosedColor;
        ctrl.widgetSetting.statusWidgetSetting.physicalContactClosedBlink = colorOption.physicalContactClosedBlink;
        ctrl.widgetSetting.statusWidgetSetting.physicalInputFaultColor = colorOption.physicalInputFaultColor;
        ctrl.widgetSetting.statusWidgetSetting.physicalInputFaultBlink = colorOption.physicalInputFaultBlink;
        ctrl.widgetSetting.statusWidgetSetting.logicalNormalColor = colorOption.logicalNormalColor;
        ctrl.widgetSetting.statusWidgetSetting.logicalNormalBlink = colorOption.logicalNormalBlink;
        ctrl.widgetSetting.statusWidgetSetting.logicalOffNormalNotifyingColor = colorOption.logicalOffNormalNotifyingColor;
        ctrl.widgetSetting.statusWidgetSetting.logicalOffNormalNotifyingBlink = colorOption.logicalOffNormalNotifyingBlink;
        ctrl.widgetSetting.statusWidgetSetting.logicalOffNormalAcknowledgedColor = colorOption.logicalOffNormalAcknowledgedColor;
        ctrl.widgetSetting.statusWidgetSetting.logicalOffNormalAcknowledgedBlink = colorOption.logicalOffNormalAcknowledgedBlink;
        ctrl.widgetSetting.statusWidgetSetting.logicalOffNormalExpiredColor = colorOption.logicalOffNormalExpiredColor;
        ctrl.widgetSetting.statusWidgetSetting.logicalOffNormalExpiredBlink = colorOption.logicalOffNormalExpiredBlink;
        ctrl.widgetSetting.statusWidgetSetting.logicalInputFaultColor = colorOption.logicalInputFaultColor;
        ctrl.widgetSetting.statusWidgetSetting.logicalInputFaultBlink = colorOption.logicalInputFaultBlink;
        ctrl.widgetSetting.statusWidgetSetting.logicalDisabledColor = colorOption.logicalDisabledColor;
        ctrl.widgetSetting.statusWidgetSetting.logicalDisabledBlink = colorOption.logicalDisabledBlink;
        ctrl.buildMainClass();
        //ctrl.closeSetting();
    };

    ctrl.fnRtuStatusOptions = function (rtuStatus) {
        ctrl.buildMainClass();
        ctrl.hudText = rtuStatus;
    };

    ctrl.fnChangeDisplayOptions = function (parSettingOptions) {
        if (!angular.isUndefined(parSettingOptions.titleOption)) {
            ctrl.fnTitleOptions(parSettingOptions.titleOption);
        }
        if (!angular.isUndefined(parSettingOptions.stateOption)) {
            ctrl.fnStateOptions(parSettingOptions.stateOption);
        }
        if (!angular.isUndefined(parSettingOptions.sizeOption)) {
            ctrl.fnSizeOptions(parSettingOptions.sizeOption.id, true);
        }
        if (!angular.isUndefined(parSettingOptions.colorOption)) {
            ctrl.fnColorOptions(parSettingOptions.colorOption);
        }
        if (!angular.isUndefined(parSettingOptions.rtuOption)) {
            ctrl.getData(parSettingOptions.rtuOption.deviceId, parSettingOptions.rtuOption.channel, true);
        }
    };

    ctrl.editSetting = function (event) {
        if (!angular.isUndefined(ctrl.widgetSetting) && Object.keys(ctrl.widgetSetting.statusGauge).length !== 0) {
            ctrl.mcWidgetsSharedFactory.editSetting($element, event, ctrl);
        }
    };

    ctrl.closeSetting = function () {
        ctrl.mcWidgetsSharedFactory.closeSetting($element, ctrl);
    };

    ctrl.mouseOverHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOver;
        }
    };
    ctrl.mouseOffHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOff;
        }
    };

    ctrl.resize_HUD = function (w_svgSizeW, w_svgSizeH) {
        ctrl.mcWidgetsSharedFactory.resizeHud(w_svgSizeW, w_svgSizeH, ctrl);
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ctrl.buildMainClass = function () {

        ctrl.blink = false;

        if (ctrl.widgetSetting.statusWidgetSetting.stateId === 2) {
            //Physical
            switch (ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.statusGauge.channel]) {
                case "True":
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.statusWidgetSetting.physicalContactOpenColor };
                    ctrl.blink = ctrl.widgetSetting.statusWidgetSetting.physicalContactOpenBlink;
                    break;

                case "False":
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.statusWidgetSetting.physicalContactClosedColor };
                    ctrl.blink = ctrl.widgetSetting.statusWidgetSetting.physicalContactClosedBlink;
                    break;
                case "NULL":
                case "Fault":
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.statusWidgetSetting.physicalInputFaultColor };
                    ctrl.blink = ctrl.widgetSetting.statusWidgetSetting.physicalInputFaultBlink;
                    break;

            }
        } else {
            //Logical
            if (ctrl.widgetSetting.statusGauge.digitalMode === "D") {
                ctrl.colorLayer = { 'fill': ctrl.widgetSetting.statusWidgetSetting.logicalDisabledColor };
                ctrl.blink = ctrl.widgetSetting.statusWidgetSetting.logicalDisabledBlink;
            } else {

                switch (ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.statusGauge.channel]) {
                    case "True":
                        if (ctrl.widgetSetting.statusGauge.normalClosed === 0) {
                            ctrl.colorLayer = { 'fill': ctrl.widgetSetting.statusWidgetSetting.logicalNormalColor };
                            ctrl.blink = ctrl.widgetSetting.statusWidgetSetting.logicalNormalBlink;
                        } else {
                            ctrl.colorLayer = { 'fill': ctrl.widgetSetting.statusWidgetSetting.logicalOffNormalNotifyingColor };
                            ctrl.blink = ctrl.widgetSetting.statusWidgetSetting.logicalOffNormalNotifyingBlink;
                        }
                        break;

                    case "False":
                        if (ctrl.widgetSetting.statusGauge.normalClosed === 0) {
                            ctrl.colorLayer = { 'fill': ctrl.widgetSetting.statusWidgetSetting.logicalOffNormalNotifyingColor };
                            ctrl.blink = ctrl.widgetSetting.statusWidgetSetting.logicalOffNormalNotifyingBlink;
                        } else {
                            ctrl.colorLayer = { 'fill': ctrl.widgetSetting.statusWidgetSetting.logicalNormalColor };
                            ctrl.blink = ctrl.widgetSetting.statusWidgetSetting.logicalNormalBlink;
                        }
                        break;
                    case "NULL":
                    case "Fault":
                        ctrl.colorLayer = { 'fill': ctrl.widgetSetting.statusWidgetSetting.logicalInputFaultColor };
                        ctrl.blink = ctrl.widgetSetting.statusWidgetSetting.logicalInputFaultBlink;
                        break;

                }
            }
        }

        ctrl.wLED = [ctrl.blink ? "blink" : ""];
    };

    // from socket

    ctrl.updateValue = function (value, deviceModel) {
        return ctrl.updateDIValue(value);
    };

    ctrl.updateDIValue = function (value) {

        switch (value) {
            case "1":
                return "True";
            case "0":
                return "False";
            case "-1":
                return "Fault";
        }
        return "Fault";
    };

    ctrl.wsDataReceivedWD = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;
        // if (ctrl.widgetSetting.statusGauge.channel > 8) return;

        var chValue = data.Value;
        var channel = parseInt(data.CH);

        if (ctrl.widgetSetting.statusGauge.channel == channel) {
            var digValue = ctrl.updateValue(chValue, ctrl.widgetSetting.device.model);
            ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.statusGauge.channel] = digValue;
            ctrl.buildMainClass();
        }
    };

    ctrl.wsDataReceivedWOD = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;
        if (ctrl.widgetSetting.statusGauge.channel <= 8) return;

        var chArray = data.Value.replace(/[[\]]/g, '').split(',');
        var digValue = ctrl.updateValue(chArray[ctrl.widgetSetting.statusGauge.channel - 9]);
        ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.statusGauge.channel] = digValue;
        ctrl.buildMainClass();
    };

    ctrl.wsDataReceivedFAULTS = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;
        var faultBinary;
        if (isNaN(data.Value)) {
            faultBinary = data.Value.replace(/[[\]]/g, '').split(',').join('');
        } else {
            faultBinary = (data.Value >>> 0).toString(2);

            while (faultBinary.length < 16) {
                faultBinary = faultBinary.length < 8 ? "0" + faultBinary : faultBinary + "0";
            }
        }

        if (faultBinary[ctrl.widgetSetting.statusGauge.channel - 1] === '1') {
            //console.log('Got a fault for channel: ', channelId);
            ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.statusGauge.channel] = "NULL";
            ctrl.buildMainClass();
        }
    };

    ctrl.webSocketReconnect = function () {
        //if widget then toaster message... if gauge then not
        if (angular.isUndefined(ctrl.additionalSize)) toaster.pop('success', "Status Widget" + " -- " + ctrl.widgetSetting.device.name, 'View reloading');
        ctrl.getData(ctrl.widgetSetting.device.deviceId, ctrl.widgetSetting.statusGauge.channel);
    };

    var _onINPUTS = $rootScope.$on('DIGITALINPUT', function (event, args) {
        ctrl.wsDataReceivedWD(args.data);
    });

    var _onOPTIONDIGITAL = $rootScope.$on('OPTIONDIGITAL', function (event, args) {
        ctrl.wsDataReceivedWOD(args.data);
    });

    var _onFAULTS = $rootScope.$on('FAULTS', function (event, args) {
        ctrl.wsDataReceivedFAULTS(args.data);
    });

    var _onRECONNECT = $scope.$on('processReconnect', function (event, args) {
        ctrl.webSocketReconnect();
    });

    var _onDocumentClick = $rootScope.$on('document_click', function (event, args) {
        ctrl.closeSetting();
    });

    $scope.$on("$destroy", function () {
        _onDocumentClick();
        _onINPUTS();
        _onOPTIONDIGITAL();
        _onFAULTS();
        _onRECONNECT();
        ctrl.unRegisterListenerDigitalSetting(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.statusGauge.channel);
        if (chart) chart.destroy();
    });
}

McWidgetStatusDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'McWidgetStatusDisplayFactory', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'McStatusGaugeFactory', 'authenticationService', 'translationService', 'PopupFactory', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-status-display').component('mcWidgetStatusDisplay', {
    controller: McWidgetStatusDisplayController,
    templateUrl: 'ui/mcwidgetstatusdisplay/mcwidget-status-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        settingShow: '&',
        changeWidgetTitle: '&',
        labelMode: '@',
        additionalSize: '@'
    }
});
"use strict";

angular.module("mc.widget-status-setting", []);
"use strict";

function McWidgetStatusSettingController($, $timeout, $rootScope, $scope, $element, $interval, $compile, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, digitalWidgetService, McWidgetsSharedFactory) {

    var ctrl = this;
    var noFaultModels = [7, 10, 15, 20, 21];
    var noDisabledModels = [21];

    ctrl.hideFault = false;

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            ctrl.mcWidgetStatusSetting = changes.widgetSetting.currentValue;
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            var deviceModel = changes.widgetSetting.currentValue.device.model;
            ctrl.deviceModel = deviceModel;

            ctrl.hideFault = noFaultModels.includes(deviceModel);
            ctrl.hideDisabled = noDisabledModels.includes(deviceModel);
            ctrl.getUiData();
        }
    };

    ctrl.$onInit = function () {
        if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        ctrl.w_tabpaneIsOpen = { "height": "100%", "display": "block" };
        ctrl.w_tabpaneIsClosed = { "height": "0%", "display": "none" };
        ctrl.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.colorPalet = ctrl.mcWidgetsSharedFactory.getColorPalet();
    };

    ctrl.setModel = function (parm) {
        ctrl.clearModel();
        $timeout(function () {
            ctrl.parm = parm;
        }, 0);
    };

    ctrl.clearModel = function () {
        ctrl.parm = null;
    };

    ctrl.testNgChange = function () {
        ctrl.validateColors(true);
    };

    ctrl.selectColor = function (event) {
        switch (ctrl.parm) {
            case "physicalContactOpenColor":
                ctrl.physicalContactOpenColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "physicalInputFaultColor":
                ctrl.physicalInputFaultColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "physicalContactClosedColor":
                ctrl.physicalContactClosedColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "logicalNormalColor":
                ctrl.logicalNormalColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "logicalOffNormalNotifyingColor":
                ctrl.logicalOffNormalNotifyingColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "logicalOffNormalAcknowledgedColor":
                ctrl.logicalOffNormalAcknowledgedColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "logicalOffNormalExpiredColor":
                ctrl.logicalOffNormalExpiredColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "logicalInputFaultColor":
                ctrl.logicalInputFaultColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "logicalDisabledColor":
                ctrl.logicalDisabledColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            default:
            // code block
        }
        ctrl.clearModel();
        ctrl.validateColors(true);
    };

    ctrl.updateDisplayOptions = function (param) {

        var tmpNewStateWidgetSetting = angular.copy(ctrl.mcWidgetStatusSetting.statusWidgetSetting);
        tmpNewStateWidgetSetting.customerId = ctrl.accountInfo.customerId;
        tmpNewStateWidgetSetting.deviceId = ctrl.mcWidgetStatusSetting.device.deviceId;
        tmpNewStateWidgetSetting.channel = ctrl.mcWidgetStatusSetting.statusGauge.channel;

        if (!angular.isUndefined(param.settingOptions.titleOption)) {
            tmpNewStateWidgetSetting.titleId = param.settingOptions.titleOption.id;
            ctrl.updateUiData(param, tmpNewStateWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.stateOption)) {
            tmpNewStateWidgetSetting.stateId = param.settingOptions.stateOption.id;
            ctrl.updateUiData(param, tmpNewStateWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.sizeOption)) {
            tmpNewStateWidgetSetting.sizeId = param.settingOptions.sizeOption.id;
            ctrl.updateUiData(param, tmpNewStateWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.colorOption)) {
            tmpNewStateWidgetSetting.physicalContactOpenColor = param.settingOptions.colorOption.physicalContactOpenColor;
            tmpNewStateWidgetSetting.physicalContactOpenBlink = param.settingOptions.colorOption.physicalContactOpenBlink;
            tmpNewStateWidgetSetting.physicalContactClosedColor = param.settingOptions.colorOption.physicalContactClosedColor;
            tmpNewStateWidgetSetting.physicalContactClosedBlink = param.settingOptions.colorOption.physicalContactClosedBlink;
            tmpNewStateWidgetSetting.physicalInputFaultColor = param.settingOptions.colorOption.physicalInputFaultColor;
            tmpNewStateWidgetSetting.physicalInputFaultBlink = param.settingOptions.colorOption.physicalInputFaultBlink;
            tmpNewStateWidgetSetting.logicalNormalColor = param.settingOptions.colorOption.logicalNormalColor;
            tmpNewStateWidgetSetting.logicalNormalBlink = param.settingOptions.colorOption.logicalNormalBlink;
            tmpNewStateWidgetSetting.logicalOffNormalNotifyingColor = param.settingOptions.colorOption.logicalOffNormalNotifyingColor;
            tmpNewStateWidgetSetting.logicalOffNormalNotifyingBlink = param.settingOptions.colorOption.logicalOffNormalNotifyingBlink;
            tmpNewStateWidgetSetting.logicalOffNormalAcknowledgedColor = param.settingOptions.colorOption.logicalOffNormalAcknowledgedColor;
            tmpNewStateWidgetSetting.logicalOffNormalAcknowledgedBlink = param.settingOptions.colorOption.logicalOffNormalAcknowledgedBlink;
            tmpNewStateWidgetSetting.logicalOffNormalExpiredColor = param.settingOptions.colorOption.logicalOffNormalExpiredColor;
            tmpNewStateWidgetSetting.logicalOffNormalExpiredBlink = param.settingOptions.colorOption.logicalOffNormalExpiredBlink;
            tmpNewStateWidgetSetting.logicalInputFaultColor = param.settingOptions.colorOption.logicalInputFaultColor;
            tmpNewStateWidgetSetting.logicalInputFaultBlink = param.settingOptions.colorOption.logicalInputFaultBlink;
            tmpNewStateWidgetSetting.logicalDisabledColor = param.settingOptions.colorOption.logicalDisabledColor;
            tmpNewStateWidgetSetting.logicalDisabledBlink = param.settingOptions.colorOption.logicalDisabledBlink;

            ctrl.updateUiData(param, tmpNewStateWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.rtuOption)) {

            ctrl.getChannels(param.settingOptions.rtuOption.deviceId, true);
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: param.settingOptions.rtuOption.deviceId, channel: ctrl.channelSelectedOption.channel } } });
        }

        if (!angular.isUndefined(param.settingOptions.channelOption)) {
            ctrl.channelSelectedOption = { channel: param.settingOptions.channelOption.channel };
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: ctrl.rtuSelectedOption.deviceId, channel: param.settingOptions.channelOption.channel } } });
        }
    };

    ctrl.updateUiData = function (param, naws) {
        ctrl.mcWidgetsSharedFactory.updateUiData(param, naws, "GaugeStatusWidget", "newMcWidgetStatusSettingOptions", ctrl);
    };

    ctrl.getUiData = function () {
        ctrl.mcWidgetsSharedFactory.getUiData("mcWidgetStatusSettingOptions", "All", ctrl);
    };

    ctrl.getSetting = function () {
        digitalWidgetService.getSettings(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.rtuOptions = result.data.digitalDevices;
            ctrl.statusSettings = result.data.digitalSettings;

            ctrl.getChannels(ctrl.mcWidgetStatusSetting.device.deviceId);

            ctrl.rtuSelectedOption = { deviceId: ctrl.mcWidgetStatusSetting.device.deviceId, name: ctrl.mcWidgetStatusSetting.device.name };
        }, function (error) {});
    };

    ctrl.getChannels = function (deviceId, firstChannel) {
        ctrl.channelOptions = [];

        angular.forEach(ctrl.statusSettings, function (statusSetting) {
            if (ctrl.deviceModel == 20) {
                if (parseInt(deviceId) === parseInt(statusSetting.deviceId) && statusSetting.digitalMode !== "P" && statusSetting.networkDeviceTypeID == 0) {
                    ctrl.channelOptions.push(statusSetting);
                }
            } else {
                if (parseInt(deviceId) === parseInt(statusSetting.deviceId) && statusSetting.digitalMode !== "P") {
                    ctrl.channelOptions.push(statusSetting);
                }
            }
        });

        if (firstChannel) {
            ctrl.channelSelectedOption = { channel: ctrl.channelOptions[0].channel, description: ctrl.channelOptions[0].description };
        } else {
            ctrl.channelSelectedOption = { channel: ctrl.mcWidgetStatusSetting.statusGauge.channel, description: ctrl.mcWidgetStatusSetting.statusGauge.description };
        }
    };

    ctrl.setOptions = function () {
        ctrl.chartTimeOptions = ctrl.mcWidgetStatusSettingOptions.trendingChart;
        ctrl.chartTimeSelectedOption = { option: "Off" }; //{ option: ctrl.mcWidgetStatusSetting.statusWidgetSetting.trendingChart };

        ctrl.titleOptions = ctrl.mcWidgetStatusSettingOptions.title;
        ctrl.titleSelectedOption = { id: ctrl.mcWidgetStatusSetting.statusWidgetSetting.titleId };

        ctrl.sizeOptions = ctrl.mcWidgetStatusSettingOptions.size;
        ctrl.sizeSelectedOption = { id: ctrl.mcWidgetStatusSetting.statusWidgetSetting.sizeId };

        ctrl.stateOptions = ctrl.mcWidgetStatusSettingOptions.state;
        ctrl.stateSelectedOption = { id: ctrl.mcWidgetStatusSetting.statusWidgetSetting.stateId };

        ctrl.physicalContactOpenColor = ctrl.mcWidgetStatusSetting.statusWidgetSetting.physicalContactOpenColor;
        ctrl.physicalContactOpenBlink = ctrl.mcWidgetStatusSetting.statusWidgetSetting.physicalContactOpenBlink;
        ctrl.physicalContactClosedColor = ctrl.mcWidgetStatusSetting.statusWidgetSetting.physicalContactClosedColor;
        ctrl.physicalContactClosedBlink = ctrl.mcWidgetStatusSetting.statusWidgetSetting.physicalContactClosedBlink;
        ctrl.physicalInputFaultColor = ctrl.mcWidgetStatusSetting.statusWidgetSetting.physicalInputFaultColor;
        ctrl.physicalInputFaultBlink = ctrl.mcWidgetStatusSetting.statusWidgetSetting.physicalInputFaultBlink;

        ctrl.logicalNormalColor = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalNormalColor;
        ctrl.logicalNormalBlink = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalNormalBlink;
        ctrl.logicalOffNormalNotifyingColor = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalOffNormalNotifyingColor;
        ctrl.logicalOffNormalNotifyingBlink = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalOffNormalNotifyingBlink;
        ctrl.logicalOffNormalAcknowledgedColor = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalOffNormalAcknowledgedColor;
        ctrl.logicalOffNormalAcknowledgedBlink = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalOffNormalAcknowledgedBlink;
        ctrl.logicalOffNormalExpiredColor = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalOffNormalExpiredColor;
        ctrl.logicalOffNormalExpiredBlink = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalOffNormalExpiredBlink;
        ctrl.logicalInputFaultColor = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalInputFaultColor;
        ctrl.logicalInputFaultBlink = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalInputFaultBlink;
        ctrl.logicalDisabledColor = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalDisabledColor;
        ctrl.logicalDisabledBlink = ctrl.mcWidgetStatusSetting.statusWidgetSetting.logicalDisabledBlink;

        ctrl.validateColors();
    };

    ctrl.validateColors = function (_dataChanged) {
        //if physicalContactOpenColor is invalid, stop execution and return invalidColor
        if (!ctrl.physicalContactOpenColor) return ctrl.invalidColor = true;

        if (ctrl.physicalContactOpenColor.length !== 7 || ctrl.physicalContactOpenColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidPhysicalContactOpenColor = true;
        } else {
            ctrl.invalidPhysicalContactOpenColor = false;
        }
        if (ctrl.physicalInputFaultColor.length !== 7 || ctrl.physicalInputFaultColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidPhysicalInputFaultColor = true;
        } else {
            ctrl.invalidPhysicalInputFaultColor = false;
        }
        if (ctrl.physicalContactClosedColor.length !== 7 || ctrl.physicalContactClosedColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidPhysicalContactClosedColor = true;
        } else {
            ctrl.invalidPhysicalContactClosedColor = false;
        }
        if (ctrl.logicalNormalColor.length !== 7 || ctrl.logicalNormalColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidLogicalNormalColor = true;
        } else {
            ctrl.invalidLogicalNormalColor = false;
        }
        if (ctrl.logicalOffNormalNotifyingColor.length !== 7 || ctrl.logicalOffNormalNotifyingColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidLogicalOffNormalNotifyingColor = true;
        } else {
            ctrl.invalidLogicalOffNormalNotifyingColor = false;
        }
        if (ctrl.logicalOffNormalAcknowledgedColor.length !== 7 || ctrl.logicalOffNormalAcknowledgedColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidLogicalOffNormalAcknowledgedColor = true;
        } else {
            ctrl.invalidLogicalOffNormalAcknowledgedColor = false;
        }
        if (ctrl.logicalOffNormalExpiredColor.length !== 7 || ctrl.logicalOffNormalExpiredColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidLogicalOffNormalExpiredColor = true;
        } else {
            ctrl.invalidLogicalOffNormalExpiredColor = false;
        }
        if (ctrl.logicalInputFaultColor.length !== 7 || ctrl.logicalInputFaultColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidLogicalInputFaultColor = true;
        } else {
            ctrl.invalidLogicalInputFaultColor = false;
        }
        if (ctrl.logicalDisabledColor.length !== 7 || ctrl.logicalDisabledColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidLogicalDisabledColor = true;
        } else {
            ctrl.invalidLogicalDisabledColor = false;
        }

        ctrl.invalidColor = ctrl.invalidPhysicalContactOpenColor || ctrl.invalidPhysicalInputFaultColor || ctrl.invalidPhysicalContactClosedColor || ctrl.invalidLogicalNormalColor || ctrl.invalidLogicalOffNormalNotifyingColor || ctrl.invalidLogicalOffNormalAcknowledgedColor || ctrl.invalidLogicalOffNormalExpiredColor || ctrl.invalidLogicalInputFaultColor || ctrl.invalidLogicalDisabledColor ? true : false;

        if (_dataChanged && !ctrl.invalidColor) {
            ctrl.updateDisplayOptions({
                settingOptions: {
                    colorOption: {
                        physicalContactOpenColor: ctrl.physicalContactOpenColor,
                        physicalContactOpenBlink: ctrl.physicalContactOpenBlink,
                        physicalContactClosedColor: ctrl.physicalContactClosedColor,
                        physicalContactClosedBlink: ctrl.physicalContactClosedBlink,
                        physicalInputFaultColor: ctrl.physicalInputFaultColor,
                        physicalInputFaultBlink: ctrl.physicalInputFaultBlink,
                        logicalNormalColor: ctrl.logicalNormalColor,
                        logicalNormalBlink: ctrl.logicalNormalBlink,
                        logicalOffNormalNotifyingColor: ctrl.logicalOffNormalNotifyingColor,
                        logicalOffNormalNotifyingBlink: ctrl.logicalOffNormalNotifyingBlink,
                        logicalOffNormalAcknowledgedColor: ctrl.logicalOffNormalAcknowledgedColor,
                        logicalOffNormalAcknowledgedBlink: ctrl.logicalOffNormalAcknowledgedBlink,
                        logicalOffNormalExpiredColor: ctrl.logicalOffNormalExpiredColor,
                        logicalOffNormalExpiredBlink: ctrl.logicalOffNormalExpiredBlink,
                        logicalInputFaultColor: ctrl.logicalInputFaultColor,
                        logicalInputFaultBlink: ctrl.logicalInputFaultBlink,
                        logicalDisabledColor: ctrl.logicalDisabledColor,
                        logicalDisabledBlink: ctrl.logicalDisabledBlink
                    }
                }
            });
        }
    };

    ctrl.showTab = function (parm) {
        ctrl.clearModel();
        var element = $element.find(".w_tabbox");
        ctrl.mcWidgetsSharedFactory.showTab(parm, element, ctrl);
    };

    ctrl.translateOptions = function () {
        ctrl.titleOptions.forEach(function (option) {
            return option.state = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.sizeOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.stateOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.chartTimeOptions.forEach(function (option) {
            return option.option = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
    };

    var _onUpdatePreferencesLanguage = $rootScope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translateOptions();
    });

    $scope.$on("$destroy", function () {
        _onUpdatePreferencesLanguage();
    });
}

McWidgetStatusSettingController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', '$interval', '$compile', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'digitalWidgetService', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-status-setting').component('mcWidgetStatusSetting', {
    controller: McWidgetStatusSettingController,
    templateUrl: 'ui/mcwidgetstatussetting/mcwidget-status-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        changeDisplayOptions: '&'
    }
});
"use strict";

angular.module("mc.widget-pump-setting", []);
"use strict";

function McWidgetPumpSettingController($, $timeout, $rootScope, $scope, $element, authenticationService, translationService, websocketService, digitalWidgetService, McWidgetsSharedFactory) {

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            ctrl.mcWidgetRuntimeSetting = changes.widgetSetting.currentValue;
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            if (!angular.isUndefined(changes.widgetSetting.previousValue.device)) ctrl.unRegisterListenerDigitalSetting(changes.widgetSetting.previousValue.device.serialNumber, changes.widgetSetting.previousValue.runtimeGauge.channel);
            ctrl.registerListenerDigitalSetting(changes.widgetSetting.currentValue.device.serialNumber, changes.widgetSetting.currentValue.runtimeGauge.channel);
            ctrl.getUiData();
        }
    };

    ctrl.$onInit = function () {
        if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        ctrl.w_tabpaneIsOpen = { "height": "100%", "display": "block" };
        ctrl.w_tabpaneIsClosed = { "height": "0%", "display": "none" };
        ctrl.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.colorPalet = ctrl.mcWidgetsSharedFactory.getColorPalet();
    };

    ctrl.setModel = function (parm) {
        ctrl.clearModel();
        $timeout(function () {
            ctrl.parm = parm;
        }, 0);
    };

    ctrl.clearModel = function () {
        ctrl.parm = null;
    };

    ctrl.testNgChange = function () {
        ctrl.validateColors(true);
    };

    ctrl.selectColor = function (event) {
        switch (ctrl.parm) {
            case "runningColor":
                ctrl.runningColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "notRunningColor":
                ctrl.notRunningColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "faultColor":
                ctrl.faultColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            default:
            // code block
        }
        ctrl.clearModel();
        ctrl.validateColors(true);
    };

    ctrl.updateDisplayOptions = function (param) {

        var tmpNewRuntimeWidgetSetting = angular.copy(ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting);
        tmpNewRuntimeWidgetSetting.customerId = ctrl.accountInfo.customerId;
        tmpNewRuntimeWidgetSetting.deviceId = ctrl.mcWidgetRuntimeSetting.device.deviceId;
        tmpNewRuntimeWidgetSetting.channel = ctrl.mcWidgetRuntimeSetting.runtimeGauge.channel;

        if (!angular.isUndefined(param.settingOptions.titleOption)) {
            tmpNewRuntimeWidgetSetting.titleId = param.settingOptions.titleOption.id;
            ctrl.updateUiData(param, tmpNewRuntimeWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.heardTypeOption)) {
            tmpNewRuntimeWidgetSetting.dateTimeFormatId = param.settingOptions.heardTypeOption.id;
            ctrl.updateUiData(param, tmpNewRuntimeWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.stateOption)) {
            tmpNewRuntimeWidgetSetting.stateId = param.settingOptions.stateOption.id;
            ctrl.updateUiData(param, tmpNewRuntimeWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.sizeOption)) {
            tmpNewRuntimeWidgetSetting.sizeId = param.settingOptions.sizeOption.id;
            ctrl.updateUiData(param, tmpNewRuntimeWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.themeOption)) {
            tmpNewRuntimeWidgetSetting.themeId = param.settingOptions.themeOption.id;
            ctrl.updateUiData(param, tmpNewRuntimeWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.colorOption)) {

            tmpNewRuntimeWidgetSetting.runningColor = param.settingOptions.colorOption.runningColor;
            tmpNewRuntimeWidgetSetting.runningBlink = param.settingOptions.colorOption.runningBlink;
            tmpNewRuntimeWidgetSetting.notRunningColor = param.settingOptions.colorOption.notRunningColor;
            tmpNewRuntimeWidgetSetting.notRunningBlink = param.settingOptions.colorOption.notRunningBlink;
            tmpNewRuntimeWidgetSetting.faultColor = param.settingOptions.colorOption.faultColor;
            tmpNewRuntimeWidgetSetting.faultBlink = param.settingOptions.colorOption.faultBlink;

            ctrl.updateUiData(param, tmpNewRuntimeWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.rtuOption)) {

            ctrl.getChannels(param.settingOptions.rtuOption.deviceId, true);
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: param.settingOptions.rtuOption.deviceId, channel: ctrl.channelSelectedOption.channel } } });
        }

        if (!angular.isUndefined(param.settingOptions.channelOption)) {
            ctrl.channelSelectedOption = { channel: param.settingOptions.channelOption.channel };
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: ctrl.rtuSelectedOption.deviceId, channel: param.settingOptions.channelOption.channel } } });
        }
    };

    ctrl.updateUiData = function (param, naws) {
        ctrl.mcWidgetsSharedFactory.updateUiData(param, naws, "GaugeRuntimeWidget", "newMcWidgetRuntimeSettingOptions", ctrl);
    };

    ctrl.getUiData = function () {
        ctrl.mcWidgetsSharedFactory.getUiData("mcWidgetRuntimeSettingOptions", "All", ctrl);
    };

    ctrl.getSetting = function () {
        digitalWidgetService.getSettings(ctrl.accountInfo.customerId, true).then(function (result) {
            ctrl.rtuOptions = result.data.digitalDevices;
            ctrl.runtimeSettings = result.data.digitalSettings;

            ctrl.getChannels(ctrl.mcWidgetRuntimeSetting.device.deviceId);

            ctrl.rtuSelectedOption = { deviceId: ctrl.mcWidgetRuntimeSetting.device.deviceId, name: ctrl.mcWidgetRuntimeSetting.device.name };
        }, function (error) {});
    };

    ctrl.getChannels = function (deviceId, firstChannel) {
        ctrl.channelOptions = [];

        angular.forEach(ctrl.runtimeSettings, function (runtimeSetting) {
            if (parseInt(deviceId) === parseInt(runtimeSetting.deviceId) && runtimeSetting.digitalMode === "P") {
                ctrl.channelOptions.push(runtimeSetting);
            }
        });

        if (firstChannel) {
            ctrl.channelSelectedOption = { channel: ctrl.channelOptions[0].channel, description: ctrl.channelOptions[0].description };
        } else {
            ctrl.channelSelectedOption = { channel: ctrl.mcWidgetRuntimeSetting.runtimeGauge.channel, description: ctrl.mcWidgetRuntimeSetting.runtimeGauge.description };
        }
    };

    ctrl.setOptions = function () {
        ctrl.titleOptions = ctrl.mcWidgetRuntimeSettingOptions.title;
        ctrl.titleSelectedOption = { id: ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.titleId };

        ctrl.heardTypeOptions = ctrl.mcWidgetRuntimeSettingOptions.dateTimeFormat;
        ctrl.heardTypeSelectedOption = { id: ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.dateTimeFormatId };

        ctrl.sizeOptions = ctrl.mcWidgetRuntimeSettingOptions.size;
        ctrl.sizeSelectedOption = { id: ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.sizeId };

        ctrl.themeOptions = ctrl.mcWidgetRuntimeSettingOptions.theme;
        ctrl.themeSelectedOption = { id: ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.themeId };

        ctrl.runningColor = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.runningColor;
        ctrl.runningBlink = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.runningBlink;
        ctrl.notRunningColor = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.notRunningColor;
        ctrl.notRunningBlink = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.notRunningBlink;
        ctrl.faultColor = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.faultColor;
        ctrl.faultBlink = ctrl.mcWidgetRuntimeSetting.runtimeWidgetSetting.faultBlink;

        ctrl.validateColors();
    };

    ctrl.validateColors = function (_dataChanged) {
        if (ctrl.runningColor.length !== 7 || ctrl.runningColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidRunningColor = true;
        } else {
            ctrl.invalidRunningColor = false;
        }
        if (ctrl.notRunningColor.length !== 7 || ctrl.notRunningColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidNotRunningColor = true;
        } else {
            ctrl.invalidNotRunningColor = false;
        }
        if (ctrl.faultColor.length !== 7 || ctrl.faultColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidFaultColor = true;
        } else {
            ctrl.invalidFaultColor = false;
        }

        ctrl.invalidColor = ctrl.invalidRunningColor || ctrl.invalidNotRunningColor || ctrl.invalidFaultColor ? true : false;

        if (_dataChanged && !ctrl.invalidColor) {
            ctrl.updateDisplayOptions({
                settingOptions: {
                    colorOption: {
                        runningColor: ctrl.runningColor,
                        runningBlink: ctrl.runningBlink,
                        notRunningColor: ctrl.notRunningColor,
                        notRunningBlink: ctrl.notRunningBlink,
                        faultColor: ctrl.faultColor,
                        faultBlink: ctrl.faultBlink
                    }
                }
            });
        }
    };

    ctrl.showTab = function (parm) {
        ctrl.clearModel();
        var element = $element.find(".w_tabbox");
        ctrl.mcWidgetsSharedFactory.showTab(parm, element, ctrl);
    };

    ctrl.translateOptions = function () {
        ctrl.titleOptions.forEach(function (option) {
            return option.state = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.heardTypeOptions.forEach(function (option) {
            return option.type = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.sizeOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.themeOptions.forEach(function (option) {
            return option.name = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
    };

    var _onUpdatePreferencesLanguage = $rootScope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translateOptions();
    });

    var setTimeOut = function setTimeOut() {
        setTimeout(function () {
            $scope.liveUpdateItem = null;
            $scope.liveUpdated = null;
            $scope.liveMessage = null;
        }, 20000); // 20 Seconds
    };

    var refreshDeviceBasicInfoLive = function refreshDeviceBasicInfoLive(patch, userName) {
        switch (patch.path) {
            case "description":
                $scope.basicInfoOldValue = $scope.deviceOld[patch.path];
                $scope.deviceOld[patch.path] = patch.value;
                $scope.device[patch.path] = $scope.deviceOld[patch.path];
                $scope.basicInfoNewValue = patch.value;
                break;
        }

        if ($scope.basicInfoOldValue != "") {
            $scope.liveUpdateItem = patch.path;
            $scope.liveUpdated = true;
            $scope.liveMessage = " " + userName + " changed " + patch.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + $scope.basicInfoOldValue + " to " + $scope.basicInfoNewValue;
            setTimeOut();
        }
    };

    ctrl.wsDataReceivedDIGITALSETTINGMCRW = function (data) {
        if (data.Type == 'DIGITALSETTING' && data.SN == ctrl.widgetSetting.device.serialNumber && data.CH == ctrl.widgetSetting.runtimeGauge.channel) {
            //console.log(data);
            //refreshDeviceBasicInfoLive(data.Value, data.UserName);
        }
    };

    ctrl.registerListenerDigitalSetting = function (varSerialNum, channel) {
        //subscribe for digital setting changes
        websocketService.connect();
        websocketService.register("DIGITALSETTING", varSerialNum, channel, ctrl.wsDataReceivedDIGITALSETTINGMCRW, null);
    };

    ctrl.unRegisterListenerDigitalSetting = function (varSerialNum, channel) {
        websocketService.connect();
        websocketService.unRegister("DIGITALSETTING", varSerialNum, channel, ctrl.wsDataReceivedDIGITALSETTINGMCRW, null);
    };

    $scope.$on("$destroy", function () {
        _onUpdatePreferencesLanguage();
        ctrl.unRegisterListenerDigitalSetting(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.runtimeGauge.channel);
    });
}

McWidgetPumpSettingController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'authenticationService', 'translationService', 'websocketService', 'digitalWidgetService', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-pump-setting').component('mcWidgetPumpSetting', {
    controller: McWidgetPumpSettingController,
    templateUrl: 'ui/mcwidgetpumpsetting/mcwidget-pump-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        changeDisplayOptions: '&'
    }
});
"use strict";

angular.module("mc.widget-runtime-display", []);
'use strict';

function McWidgetRuntimeDisplayFactory(HOST, $http) {

    // instantiate our initial object
    var McWidgetRuntimeDisplay = function McWidgetRuntimeDisplay(customerId, deviceId, timeZone) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
    };

    McWidgetRuntimeDisplay.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/Analog/Gauge' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetRuntimeDisplay.prototype.getDeviceState = function () {
        var self = this;
        return $http.get(HOST + '/api/DeviceState' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetRuntimeDisplay.prototype.getWidgetData = function (channel) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McWidgetRuntimeDisplay;
}

McWidgetRuntimeDisplayFactory.$inject = ['HOST', '$http'];

angular.module('mc.widget-display').factory('McWidgetRuntimeDisplayFactory', McWidgetRuntimeDisplayFactory);
"use strict";

function McWidgetRuntimeDisplayController($, $timeout, $rootScope, $scope, $element, McWidgetRuntimeDisplayFactory, $compile, websocketService, toaster, datetimeService, sharedSetupService, McRuntimeGaugeFactory, authenticationService, translationService, PopupFactory, detectBrowserService, McWidgetsSharedFactory) {

    var ctrl = this;
    var chart = void 0;
    var tmpInit = true;

    ctrl.$onInit = function () {
        ctrl.alerts = [];
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
    };

    ctrl.pwMouseEnter = function (event) {
        if (!angular.isUndefined(ctrl.widgetSetting)) ctrl.popupWindow.getStatusTooltip(ctrl.widgetSetting, event, angular.isUndefined(ctrl.additionalSize) ? ctrl.svgSizeH / 2 : ctrl.additionalSize - 5);
    };

    ctrl.pwMouseLeave = function (event) {
        if (!angular.isUndefined(ctrl.widgetSetting)) ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            tmpInit = true;
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            ctrl.curentBrowser = detectBrowserService();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.buildWidget(changes.widgetSetting.currentValue);
        }
    };

    ctrl.wsDataReceivedDIGITALSETTINGMCRW = function (data) {
        if (data.Type == 'DIGITALSETTING' && data.SN == ctrl.widgetSetting.device.serialNumber && data.CH == ctrl.widgetSetting.runtimeGauge.channel) {
            $timeout(function () {
                ctrl.getData(ctrl.widgetSetting.device.deviceId, ctrl.widgetSetting.runtimeGauge.channel);
            }, 200);
        }
    };

    ctrl.registerListenerDigitalSetting = function (varSerialNum, channel) {
        //subscribe for digital setting changes
        websocketService.connect();
        websocketService.register("DIGITALSETTING", varSerialNum, channel, ctrl.wsDataReceivedDIGITALSETTINGMCRW, null);
    };

    ctrl.unRegisterListenerDigitalSetting = function (varSerialNum, channel) {
        websocketService.connect();
        websocketService.unRegister("DIGITALSETTING", varSerialNum, channel, ctrl.wsDataReceivedDIGITALSETTINGMCRW, null);
    };

    ctrl.buildWidget = function (widgetData) {

        if (ctrl.mcWidgetsSharedFactory.checkForEmptyObject(widgetData.runtimeGauge)) {
            var errormsg = ctrl.translation.text.NOT_SETUP;
            ctrl.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            return;
        } else {
            ctrl.alerts = [];
        }

        ctrl.widgetSetting = widgetData;
        ctrl.unRegisterListenerDigitalSetting(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.runtimeGauge.channel);
        ctrl.registerListenerDigitalSetting(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.runtimeGauge.channel);
        ctrl.w_BorderWidth = 2; // Set the inside solid border of the HUD
        ctrl.w_BorderPadding = 5; // Set the outside opaque border outline

        ctrl.show_chartdata = "No";

        ctrl.setSize(ctrl.widgetSetting.setting.defaultSetting ? ctrl.widgetSetting.defaultSetting.sizeId : ctrl.widgetSetting.runtimeWidgetSetting.sizeId);

        ctrl.buildMainClass();

        ctrl.loadingInProgress = false;

        ctrl.noDecimals = sharedSetupService.getNumberOfDecimals(ctrl.widgetSetting.runtimeGauge.maxVal, ctrl.widgetSetting.runtimeGauge.minVal);
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);

        if (ctrl.widgetSetting.setting.displaySettingOn) {
            var newScope = $scope;
            var html = '<mc-widget-runtime-setting widget-setting="$ctrl.widgetSetting" ng-if="$ctrl.widgetSetting.setting.displaySetting" change-display-options="$ctrl.fnChangeDisplayOptions(settingOptions)"></mc-widget-runtime-setting>';
            var element = $element.find('.component-setting');
            if (element.is(':empty')) {
                element.append($compile(html)(newScope));
            }
        }

        ctrl.loadingInProgress = false;
    };

    ctrl.getData = function (deviceId, channel, openSetting) {

        var _runtimeGauge = new McRuntimeGaugeFactory(ctrl.accountInfo.customerId, deviceId, ctrl.accountInfo.timeZone, 3, 3, channel); //Category: Runtime, Widget: 'Single Needle Gauge'

        _runtimeGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;

            var device = _runtimeGauge.list.device;
            var deviceDigitalData = _runtimeGauge.list.digitalData;
            var defaultSetting = _runtimeGauge.list.defaultSetting;
            var runtimeGauge = _runtimeGauge.list.runtimeGauge[0].runtimeGauge;
            var runtimeWidgetSetting = _runtimeGauge.list.runtimeGauge[0].runtimeWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.widgetSetting.setting.displaySetting,
                displaySettingOn: ctrl.widgetSetting.setting.displaySettingOn,
                defaultSetting: ctrl.widgetSetting.setting.defaultSetting
            };

            ctrl.runtimeGauge = {
                device: device,
                deviceDigitalData: deviceDigitalData,
                defaultSetting: defaultSetting,
                runtimeGauge: runtimeGauge,
                runtimeWidgetSetting: runtimeWidgetSetting,
                setting: setting
            };

            ctrl.buildWidget(ctrl.runtimeGauge);
            ctrl.fnSizeOptions(ctrl.runtimeGauge.runtimeWidgetSetting.sizeId);
            //ctrl.fnMakeFitTextWork();
            if (!angular.isUndefined(openSetting)) {
                $timeout(function () {
                    ctrl.mouseOverHUD();
                    ctrl.editSetting();
                }, 0);
            }

            ctrl.updateWidgetTitle();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.updateWidgetTitle = function () {
        ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.widgetSetting.device.deviceId, name: ctrl.widgetSetting.device.name, serialNumber: ctrl.widgetSetting.device.serialNumber, channel: ctrl.widgetSetting.runtimeGauge.channel, channelDescription: ctrl.widgetSetting.runtimeGauge.description, titleId: ctrl.widgetSetting.runtimeWidgetSetting.titleId } });
    };

    ctrl.fnMakeFitTextWork = function () {
        // $compile($element.find(".mc-fittext"))($scope);
    };

    ctrl.fnThemeOptions = function (themeName) {
        ctrl.widgetSetting.runtimeWidgetSetting.theme = themeName;
        ctrl.buildMainClass();
    };

    ctrl.fnTitleOptions = function (titleOption) {
        ctrl.widgetSetting.runtimeWidgetSetting.titleId = titleOption.id;
        ctrl.widgetSetting.runtimeWidgetSetting.titleState = titleOption.state;
        ctrl.updateWidgetTitle();
    };

    ctrl.fnStateOptions = function (stateOption) {
        ctrl.widgetSetting.runtimeWidgetSetting.stateId = stateOption.id;
        ctrl.widgetSetting.runtimeWidgetSetting.stateDescription = stateOption.description;
        ctrl.buildMainClass();
    };

    ctrl.fnSizeOptions = function (sizeId, openSetting) {

        if (!ctrl.widgetSetting.setting.displaySetting) return;
        ctrl.widgetSetting.runtimeWidgetSetting.sizeId = sizeId;
        ctrl.setSize(sizeId);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.parent().addClass("ui-widget-content-mc");

            $timeout(function () {
                var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
                ctrl.popup.parent().css("height", svgH + "px");
                ctrl.popup.parent().css("width", svgH + 25 + "px");
                ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
            }, 0);
        }
        ctrl.closeSetting();
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);
        ctrl.buildMainClass();

        if (!angular.isUndefined(openSetting)) {
            $timeout(function () {
                ctrl.mouseOverHUD();
                ctrl.editSetting();
            }, 0);
        }
    };

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 3);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.fnColorOptions = function (colorOption) {
        ctrl.widgetSetting.runtimeWidgetSetting.runningColor = colorOption.runningColor;
        ctrl.widgetSetting.runtimeWidgetSetting.runningBlink = colorOption.runningBlink;
        ctrl.widgetSetting.runtimeWidgetSetting.notRunningColor = colorOption.notRunningColor;
        ctrl.widgetSetting.runtimeWidgetSetting.notRunningBlink = colorOption.notRunningBlink;
        ctrl.widgetSetting.runtimeWidgetSetting.faultColor = colorOption.faultColor;
        ctrl.widgetSetting.runtimeWidgetSetting.faultBlink = colorOption.faultBlink;
        ctrl.buildMainClass();
        //ctrl.closeSetting();
    };

    ctrl.fnRtuRuntimeOptions = function (rtuRuntime) {
        ctrl.buildMainClass();
        ctrl.hudText = rtuRuntime;
    };

    ctrl.fnChangeDisplayOptions = function (parSettingOptions) {
        if (!angular.isUndefined(parSettingOptions.titleOption)) {
            ctrl.fnTitleOptions(parSettingOptions.titleOption);
        }
        if (!angular.isUndefined(parSettingOptions.stateOption)) {
            ctrl.fnStateOptions(parSettingOptions.stateOption);
        }
        if (!angular.isUndefined(parSettingOptions.sizeOption)) {
            ctrl.fnSizeOptions(parSettingOptions.sizeOption.id, true);
        }
        if (!angular.isUndefined(parSettingOptions.colorOption)) {
            ctrl.fnColorOptions(parSettingOptions.colorOption);
        }
        if (!angular.isUndefined(parSettingOptions.rtuOption)) {
            ctrl.getData(parSettingOptions.rtuOption.deviceId, parSettingOptions.rtuOption.channel, true);
        }
    };

    ctrl.editSetting = function (event) {
        ctrl.mcWidgetsSharedFactory.editSetting($element, event, ctrl);
    };

    ctrl.closeSetting = function () {
        ctrl.mcWidgetsSharedFactory.closeSetting($element, ctrl);
    };

    ctrl.mouseOverHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOver;
        }
    };
    ctrl.mouseOffHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOff;
        }
    };

    ctrl.resize_HUD = function (w_svgSizeW, w_svgSizeH) {
        ctrl.mcWidgetsSharedFactory.resizeHud(w_svgSizeW, w_svgSizeH, ctrl);
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ctrl.buildMainClass = function () {

        ctrl.blink = false;

        switch (ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel]) {
            case "True":
                if (ctrl.widgetSetting.runtimeGauge.normalClosed === 0) {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.runtimeWidgetSetting.notRunningColor };
                    ctrl.blink = ctrl.widgetSetting.runtimeWidgetSetting.notRunningBlink ? "spin" : ctrl.blink;
                } else {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.runtimeWidgetSetting.runningColor };
                    ctrl.blink = ctrl.widgetSetting.runtimeWidgetSetting.runningBlink ? "spin" : ctrl.blink;
                }
                break;

            case "False":
                if (ctrl.widgetSetting.runtimeGauge.normalClosed === 0) {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.runtimeWidgetSetting.runningColor };
                    ctrl.blink = ctrl.widgetSetting.runtimeWidgetSetting.runningBlink ? "spin" : ctrl.blink;
                } else {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.runtimeWidgetSetting.notRunningColor };
                    ctrl.blink = ctrl.widgetSetting.runtimeWidgetSetting.notRunningBlink ? "spin" : ctrl.blink;
                }
                break;
            case "NULL":
            case "Fault":
                ctrl.colorLayer = { 'fill': ctrl.widgetSetting.runtimeWidgetSetting.faultColor };
                ctrl.blink = "fadeOp";
                break;

        }

        ctrl.pumpTextOverlayStyle = { "margin-top": "42.5%", "margin-left": "50%", "margin-right": "10%", "height": "15%", "color": "#000000", "font-size": ctrl.svgSizeW * .1 + "px" };
        ctrl.cog = ctrl.blink;
        ctrl.bladeStyle = ctrl.colorLayer; //{" style="fill: rgb(0, 0, 128);"}

        if (ctrl.curentBrowser === "ie") {
            var pumpSpin = $element.find('.wPump1 g').first()[0];
            var element = SVG.adopt(pumpSpin);
            if (ctrl.blink === "spin") {
                element.animate({ duration: 4000 }).rotate(360).loop();
            } else {
                element.stop(true);
            }
        }
    };

    // from socket

    ctrl.updateValue = function (value) {

        switch (value) {
            case "1":
                return "True";
            case "0":
                return "False";
            case "-1":
                return "Fault";
        }
        return "Fault";
    };

    ctrl.wsDataReceivedWD = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;
        // if (ctrl.widgetSetting.runtimeGauge.channel > 8) return;

        var chValue = data.Value;
        var channel = parseInt(data.CH);
        if (ctrl.widgetSetting.runtimeGauge.channel == channel) {
            var digValue = ctrl.updateValue(chValue);
            ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel] = digValue;
            ctrl.buildMainClass();
        }
    };

    ctrl.wsDataReceivedWOD = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;
        if (ctrl.widgetSetting.runtimeGauge.channel <= 8) return;

        var chArray = data.Value.replace(/[[\]]/g, '').split(',');
        var digValue = ctrl.updateValue(chArray[ctrl.widgetSetting.runtimeGauge.channel - 9]);
        ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel] = digValue;
        ctrl.buildMainClass();
    };

    ctrl.wsDataReceivedFAULTS = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;
        var faultBinary;
        if (isNaN(data.Value)) {
            faultBinary = data.Value.replace(/[[\]]/g, '').split(',').join('');
        } else {
            faultBinary = (data.Value >>> 0).toString(2);

            while (faultBinary.length < 16) {
                faultBinary = faultBinary.length < 8 ? "0" + faultBinary : faultBinary + "0";
            }
        }

        if (faultBinary[ctrl.widgetSetting.runtimeGauge.channel - 1] === '1') {
            //console.log('Got a fault for channel: ', channelId);
            ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel] = "NULL";
            ctrl.buildMainClass();
        }
    };

    ctrl.webSocketReconnect = function () {
        //if widget then toaster message... if gauge then not
        if (angular.isUndefined(ctrl.additionalSize)) toaster.pop('success', "Runtime Widget" + " -- " + ctrl.widgetSetting.device.name, 'View reloading');
        ctrl.getData(ctrl.widgetSetting.device.deviceId, ctrl.widgetSetting.runtimeGauge.channel);
    };

    var _onINPUTS = $rootScope.$on('DIGITALINPUT', function (event, args) {
        ctrl.wsDataReceivedWD(args.data);
    });

    var _onOPTIONDIGITAL = $rootScope.$on('OPTIONDIGITAL', function (event, args) {
        ctrl.wsDataReceivedWOD(args.data);
    });

    var _onFAULTS = $rootScope.$on('FAULTS', function (event, args) {
        ctrl.wsDataReceivedFAULTS(args.data);
    });

    var _onRECONNECT = $scope.$on('processReconnect', function (event, args) {
        ctrl.webSocketReconnect();
    });

    var _onDocumentClick = $rootScope.$on('document_click', function (event, args) {
        ctrl.closeSetting();
    });

    $scope.$on("$destroy", function () {
        _onDocumentClick();
        _onINPUTS();
        _onOPTIONDIGITAL();
        _onFAULTS();
        _onRECONNECT();
        ctrl.unRegisterListenerDigitalSetting(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.runtimeGauge.channel);
        if (chart) chart.destroy();
    });
}

McWidgetRuntimeDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'McWidgetRuntimeDisplayFactory', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'McRuntimeGaugeFactory', 'authenticationService', 'translationService', 'PopupFactory', 'detectBrowserService', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-runtime-display').component('mcWidgetRuntimeDisplay', {
    controller: McWidgetRuntimeDisplayController,
    templateUrl: 'ui/mcwidgetruntimedisplay/mcwidget-runtime-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        settingShow: '&',
        changeWidgetTitle: '&',
        labelMode: '@',
        additionalSize: '@'
    }
});
"use strict";

angular.module("mc.widget-relay-display", []);
'use strict';

function McWidgetRelayDisplayFactory(HOST, $http) {

    // instantiate our initial object
    var McWidgetRelayDisplay = function McWidgetRelayDisplay(customerId, deviceId, timeZone) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
    };

    McWidgetRelayDisplay.prototype.getRelayData = function (hasAdamsRelayModule) {
        var self = this;
        return $http.get(HOST + '/api/RelayWidget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&hasAdamsRelayModule=' + hasAdamsRelayModule + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McWidgetRelayDisplay;
}

McWidgetRelayDisplayFactory.$inject = ['HOST', '$http'];

angular.module('mc.widget-display').factory('McWidgetRelayDisplayFactory', McWidgetRelayDisplayFactory);
"use strict";

function McWidgetRelayDisplayController($, $timeout, $rootScope, $scope, $element, McWidgetRelayDisplayFactory, $compile, websocketService, toaster, datetimeService, sharedSetupService, McStatusGaugeFactory, authenticationService, translationService, PopupFactory, McWidgetsSharedFactory, pageRequestsService, deviceService) {

    var ctrl = this;
    ctrl.startX = 0;
    ctrl.startY = 0;
    var chart = void 0;
    var tmpInit = true;
    // Saved values take precedence over cached lookups for this controller's lifetime.
    var ebpcPurchasedByDeviceId = Object.create(null);

    var updateEbpcRelayState = function updateEbpcRelayState(relay, ebpcPurchased) {
        if (!relay || relay.channel != 1 && relay.channel != 2) return;

        var ebpcDisableMessage = ctrl.translation.text.RELAY_DISABLED_FOR_EBPC;
        if (ebpcPurchased) {
            // Preserve restrictions such as digital intertie or tank and well control.
            if (!relay.disableMessage) relay.disableMessage = ebpcDisableMessage;
        } else if (relay.disableMessage === ebpcDisableMessage) {
            relay.disableMessage = null;
        }
    };

    ctrl.$onInit = function () {
        ctrl.alerts = [];
        ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
    };

    ctrl.$onChanges = function (changes) {
        ctrl.alerts = [];
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.restrictedRelayAccess = ctrl.accountInfo.userRole.indexOf("PublicUser") > -1 || ctrl.accountInfo.userRole.indexOf("User") > -1 || ctrl.accountInfo.userRole.indexOf("AlarmUser") > -1;
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            tmpInit = true;
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();

            if (!angular.isUndefined(changes.widgetSetting.previousValue) && !angular.isUndefined(changes.widgetSetting.previousValue.device)) ctrl.unRegisterListener(changes.widgetSetting.previousValue.device.serialNumber, changes.widgetSetting.previousValue.channel);

            if (changes.widgetSetting.currentValue.device.deviceName == null) {
                ctrl.getData(changes.widgetSetting.currentValue);
            } else {
                ctrl.buildWidget(changes.widgetSetting.currentValue);
            }
        }
    };

    ctrl.getData = function (widgetSetting) {
        var device = widgetSetting.device;
        ctrl.getDeviceAndWidgetData(device.deviceId, device.channel);
    };

    ctrl.getDeviceAndWidgetData = function (deviceId, channel) {
        deviceService.getDeviceLookup(ctrl.accountInfo.customerId, deviceId).then(function (datafromFactory) {
            ctrl.device = angular.copy(datafromFactory.data);
            if (Object.prototype.hasOwnProperty.call(ebpcPurchasedByDeviceId, deviceId)) {
                ctrl.device.ebpcPurchased = ebpcPurchasedByDeviceId[deviceId];
            }
            ctrl.isMyDroDevice = ctrl.device.deviceModel === 18 || ctrl.device.deviceModel === 19 ? true : false;
            var mcWidgetRelayDisplayFactory = new McWidgetRelayDisplayFactory(ctrl.accountInfo.customerId, deviceId, ctrl.accountInfo.timeZone);
            mcWidgetRelayDisplayFactory.getRelayData(ctrl.device.hasAdamsRelayModule).then(function (result) {
                $scope.processRelaysSetting(result.data);
                var tmpData = {
                    "deviceId": deviceId,
                    "channel": channel,
                    "serialNumber": ctrl.device.serialNumber,
                    "deviceName": ctrl.device.name,
                    "relay": ctrl.findRelayByChannel(channel, $scope.relays),
                    "imei": ctrl.device.imei,
                    "deviceInfo": {
                        "deviceType": ctrl.device.deviceModel,
                        "protocolVersion": ctrl.device.protocolVersion
                    }
                };
                var tmpWidgetData = {
                    device: tmpData
                };

                ctrl.buildWidget(tmpWidgetData);
            }, function (error) {});
        });
    };

    ctrl.findRelayByChannel = function (channel, relays) {
        return relays.find(function (relay) {
            return relay.channel === Number(channel);
        });
    };

    $scope.resetRelaySettings = function () {
        $scope.relays = [];
        $scope.commandOptions = [];
        $scope.commandsAssigned = false;
    };

    $scope.processRelaysSetting = function (rtuViewRelayState) {
        if ($scope.accountInfo === null) return;
        $scope.resetRelaySettings();

        $scope.relays = rtuViewRelayState.availableRelays;

        if (rtuViewRelayState.availableRelays.length > 0) {
            $scope.relayStateSettings = rtuViewRelayState.relaySettingState;
            if (rtuViewRelayState.relaySettingState) {
                $scope.assignRelayMode(rtuViewRelayState.relaySettingState);
                $scope.assignRelayState(rtuViewRelayState.relaySettingState);
                $scope.commandOptions = rtuViewRelayState.commandOptions;
                if ($scope.commandOptions != null && $scope.commandOptions.length > 0) {
                    $scope.assignPagingCommands($scope.commandOptions);
                }
            }
        } else {}
    };

    $scope.assignRelayState = function (relayStateSettings) {
        angular.forEach($scope.relays, function (value, key) {
            var isRelayOpen;
            var isRelayClosed;
            var currentChannel = relayStateSettings.filter(function (relay) {
                return relay.channel == $scope.relays[key].channel;
            })[0];

            if (!angular.isUndefined(currentChannel)) {
                if (currentChannel.value === 1) {
                    isRelayOpen = 1;
                } else if (currentChannel.value === 0) {
                    isRelayClosed = 1;
                }
            }

            $scope.relays[key].isRelayOpen = isRelayOpen;
            $scope.relays[key].isRelayClosed = isRelayClosed;
        });
    };

    $scope.assignRelayMode = function (relayStateSettings) {
        angular.forEach($scope.relays, function (value, key) {
            var mode;
            if ($scope.getValueFromRelay($scope.relays[key].channel, relayStateSettings)) {
                mode = 1;
            } else {
                mode = 0;
            }
            $scope.relays[key].mode = mode;

            updateEbpcRelayState($scope.relays[key], ctrl.isMyDroDevice && ctrl.device.softwareVersion >= 18.2 && ctrl.device.ebpcPurchased);
        });
    };

    $scope.getValueFromRelay = function (channel, relayStateSettings) {
        var currentChannel = relayStateSettings.filter(function (relay) {
            return relay.channel == channel;
        })[0];

        if (!angular.isUndefined(currentChannel)) {
            return currentChannel.value === 1 ? true : false;
        }
        return false;
    };

    $scope.assignPagingCommands = function (commandOptions) {
        $scope.relays.map(function (relay) {
            commandOptions.map(function (command) {
                //Match string ending
                if (command.commandDescription.toLowerCase().endsWith(" open")) {
                    relay.openCommand = command;
                    $scope.commandsAssigned = true;
                }
                //Match string ending
                if (command.commandDescription.toLowerCase().endsWith(" close")) {
                    relay.closeCommand = command;
                    $scope.commandsAssigned = true;
                }

                //Match string
                if (command.commandDescription.toLowerCase().endsWith("set digital output channel value")) {
                    relay.closeCommand = command;
                    relay.openCommand = command;
                    $scope.commandsAssigned = true;
                }
            });
            //Set updating status for relay
            relay.updating = false;
        });
    };

    // Record the exact X/Y coordinates when the mouse is pressed down
    ctrl.onMouseDown = function (event) {
        ctrl.startX = event.clientX;
        ctrl.startY = event.clientY;
    };

    ctrl.handleToggleClick = function (event, relay) {
        // Calculate how far the mouse moved horizontally and vertically
        var deltaX = Math.abs(event.clientX - ctrl.startX);
        var deltaY = Math.abs(event.clientY - ctrl.startY);

        // If the mouse moved more than 5 pixels, it was a drag. Ignore the click!
        if (deltaX > 5 || deltaY > 5) {
            // Optional: console.log("Drag detected, ignoring click");
            return;
        }

        // If it moved less than 5 pixels, it's a legitimate click.
        ctrl.postPageCommand(relay);
    };

    ctrl.registerListener = function (varSerialNum, channel) {
        websocketService.connect();
        websocketService.register("DIGITALOUTPUT", varSerialNum, channel, ctrl.wsDataReceivedDIOutputs, null);
    };

    ctrl.unRegisterListener = function (varSerialNum, channel) {
        websocketService.unRegister("DIGITALOUTPUT", varSerialNum, channel, ctrl.wsDataReceivedDIOutputs, null);
    };

    ctrl.wsDataReceivedDIOutputs = function (data) {
        if (data.Type == 'DIGITALOUTPUT' && data.SN == ctrl.widgetSetting.device.serialNumber && data.CH == ctrl.widgetSetting.device.relay.channel) {
            var DOValue = data.Value;
            ctrl.widgetSetting.device.relay.mode = parseInt(DOValue);
        }
    };

    ctrl.buildWidget = function (widgetData) {

        ctrl.widgetSetting = widgetData;
        var device = ctrl.widgetSetting.device;
        if (Object.prototype.hasOwnProperty.call(ebpcPurchasedByDeviceId, device.deviceId)) {
            updateEbpcRelayState(device.relay, ebpcPurchasedByDeviceId[device.deviceId]);
        }
        ctrl.errorMessage = ctrl.translation.text.PAGE_IS_DEFERRED_UNTIL_DEVICE_IS_ONLINE + ' ' + ctrl.widgetSetting.device.deviceName + ' ' + 'as device is currently offline. This command will be queued for 3 days.';

        ctrl.unRegisterListener(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.device.relay.channel);
        ctrl.registerListener(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.device.relay.channel);
    };

    ctrl.postPageCommand = function (relay) {
        //prevent Command if restricted access, updating already or disableMessage
        if (ctrl.restrictedRelayAccess || relay.updating || relay.disableMessage) return;
        //turn off deferred relay page request indicator
        relay.hasDeferredRelayPageRequest = false;
        relay.updating = true;
        //update mode
        relay.mode = relay.mode == 1 ? 0 : 1;
        var varCommand;
        //Select Command based on mode
        if (relay.mode == 0) {
            varCommand = relay.openCommand;
        } else {
            varCommand = relay.closeCommand;
        }

        //var varCommand;
        var _tmpCommandDescription = varCommand.commandDescription;
        var _tmpCommandDetails = {};
        if (varCommand.commandId == 170) {
            _tmpCommandDetails = { channel: null, value: null, valueDetail: null };
            _tmpCommandDetails.channel = relay.channel;
            _tmpCommandDetails.value = 0;
            ctrl.tmpPageRequest = {
                deviceId: ctrl.widgetSetting.device.deviceId, commandDescription: _tmpCommandDescription, commandDetails: _tmpCommandDetails, electricModes: ctrl.selectedElectricModes
            };
        } else if (varCommand.commandId == 171) {
            _tmpCommandDetails = { channel: null, value: null, valueDetail: null };
            _tmpCommandDetails.channel = relay.channel;
            _tmpCommandDetails.value = 1;
            ctrl.tmpPageRequest = {
                deviceId: ctrl.widgetSetting.device.deviceId, commandDescription: _tmpCommandDescription, commandDetails: _tmpCommandDetails, electricModes: ctrl.selectedElectricModes
            };
        } else if (varCommand.commandId == 311) {
            _tmpCommandDetails = { chanNum: null, mode: null };
            _tmpCommandDetails.chanNum = relay.channel;
            _tmpCommandDetails.mode = relay.mode == 1 ? "close" : "open";
            ctrl.tmpPageRequest = {
                deviceId: ctrl.widgetSetting.device.deviceId, commandDescription: _tmpCommandDescription, commandDetails: _tmpCommandDetails, commandId: varCommand.commandId, imei: ctrl.widgetSetting.device.imei
            };
        }

        pageRequestsService.postData(ctrl.accountInfo.customerId, varCommand.commandId, ctrl.widgetSetting.device.deviceInfo.deviceType, ctrl.widgetSetting.device.deviceInfo.protocolVersion, ctrl.accountInfo.timeZone, ctrl.tmpPageRequest).then(function (result) {
            relay.updating = false;
            //Command did not complete revert relay state in UI with error message
            if (result.data.item2 == 2) {
                relay.errorMessage = true;
                //relay.mode = relay.mode == 1 ? 0 : 1;
                return;
            }
            relay.errorMessage = false;
            $rootScope.$broadcast('commandPaging', {
                deviceId: ctrl.widgetSetting.device.deviceId, deviceName: ctrl.widgetSetting.device.deviceName, deviceSn: ctrl.widgetSetting.device.serialNumber, data: result.data.item1
            });
        }, function (error) {
            relay.updating = false;
            var errormsg = ctrl.translation.message.GENERAL_SERVER_ERROR;
            ctrl.alerts.push({
                msg: errormsg, type: "danger"
            });
        });
    };

    ctrl.updateWidgetTitle = function () {
        ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.widgetSetting.device.deviceId, name: ctrl.widgetSetting.device.name, serialNumber: ctrl.widgetSetting.device.serialNumber, channel: ctrl.widgetSetting.statusGauge.channel, channelDescription: ctrl.widgetSetting.statusGauge.description, titleId: ctrl.widgetSetting.statusWidgetSetting.titleId } });
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////    
    var refreshIntertieRelay = function refreshIntertieRelay(interconnect, previousInterconnect) {
        var device = ctrl.widgetSetting && ctrl.widgetSetting.device;
        if (!device || !device.relay) return;

        var matchesRelay = function matchesRelay(intertie) {
            return intertie && intertie.destinationDeviceID == device.deviceId && intertie.output == device.relay.channel;
        };

        if (matchesRelay(interconnect) || matchesRelay(previousInterconnect)) {
            // Refresh this widget's channel, including the old destination after a move.
            ctrl.getDeviceAndWidgetData(device.deviceId, device.relay.channel);
        }
    };

    $scope.$on('digital_intertie_updated', function (e, interconnect, previousInterconnect) {
        refreshIntertieRelay(interconnect, previousInterconnect);
    });

    $scope.$on('digital_intertie_added', function (e, interconnect) {
        refreshIntertieRelay(interconnect);
    });

    $scope.$on('digital_intertie_deleted', function (e, interconnectId, deletedInterconnect) {
        refreshIntertieRelay(deletedInterconnect);
    });

    $scope.$on('updateEbpc', function (e, updatedDevice) {
        if (!updatedDevice || typeof updatedDevice.ebpcPurchased !== 'boolean') return;
        ebpcPurchasedByDeviceId[updatedDevice.deviceId] = updatedDevice.ebpcPurchased;

        var device = ctrl.widgetSetting && ctrl.widgetSetting.device;
        if (!device || updatedDevice.deviceId != device.deviceId) return;

        if (ctrl.device && ctrl.device.deviceId == updatedDevice.deviceId) {
            ctrl.device.ebpcPurchased = updatedDevice.ebpcPurchased;
        }
        updateEbpcRelayState(device.relay, updatedDevice.ebpcPurchased);
    });

    $scope.$on("$destroy", function () {
        ctrl.unRegisterListener(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.device.relay.channel);
        if (chart) chart.destroy();
    });
}

McWidgetRelayDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'McWidgetRelayDisplayFactory', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'McStatusGaugeFactory', 'authenticationService', 'translationService', 'PopupFactory', 'McWidgetsSharedFactory', 'pageRequestsService', 'deviceService'];
'use strict';

angular.module('mc.widget-relay-display').component('mcWidgetRelayDisplay', {
    controller: McWidgetRelayDisplayController,
    templateUrl: 'ui/mcwidgetrelaydisplay/mcwidget-relay-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        settingShow: '&',
        changeWidgetTitle: '&',
        labelMode: '@',
        additionalSize: '@'
    }
});
"use strict";

angular.module("mc.widget-pump-display", []);
'use strict';

function McWidgetPumpDisplayFactory(HOST, $http) {

    // instantiate our initial object
    var McWidgetPumpDisplay = function McWidgetPumpDisplay(customerId, deviceId, timeZone) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
    };

    McWidgetPumpDisplay.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/Analog/Gauge' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetPumpDisplay.prototype.getDeviceState = function () {
        var self = this;
        return $http.get(HOST + '/api/DeviceState' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetPumpDisplay.prototype.getWidgetData = function (channel) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McWidgetPumpDisplay;
}

McWidgetPumpDisplayFactory.$inject = ['HOST', '$http'];

angular.module('mc.widget-display').factory('McWidgetPumpDisplayFactory', McWidgetPumpDisplayFactory);
"use strict";

function McWidgetPumpDisplayController($, $timeout, $rootScope, $scope, $element, debounceService, $compile, websocketService, toaster, datetimeService, sharedSetupService, McPumpGaugeFactory, authenticationService, translationService, PopupFactory, detectBrowserService, McWidgetsSharedFactory, $filter, openViewService) {

    var ctrl = this;
    var chart = void 0;
    var tmpInit = true;
    ctrl.timestamp_DisplayStyle = { "font-size": '40px' };
    ctrl.inputStatusStyle = { "font-size": '40px' };

    ctrl.valveStateClosed = "valve-state-closed";
    ctrl.valveState = ctrl.valveStateClosed;

    var deviceStateEnum = {
        Ok: 1,
        Alarm: 2,
        Offline: 3,
        Service: 4,
        Disabled: 5
    };

    ctrl.testAnimation = function () {
        ctrl.valveState = ctrl.valveState === ctrl.valveStateClosed ? _getOpenValveClassByValveType(ctrl.pumpType) : ctrl.valveStateClosed;
    };

    var getState = function getState(state) {
        //Options: AllNormal, Alarm, Alert, Service, CommFail
        switch (state) {
            case deviceStateEnum.Ok:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
            //case deviceStateEnum.Disabled:
            //    return "Disabled";
            case deviceStateEnum.Offline:
                //device.CommsFault
                ctrl.orbitTitle = ctrl.translation.text.COMM_FAIL;
                return "CommFail";
            case deviceStateEnum.Service:
                ctrl.orbitTitle = ctrl.translation.text.SERVICE_MODE;
                return "Service";
            case deviceStateEnum.Alarm:
                ctrl.orbitTitle = null; //ctrl.translation.text.ALARM;
                return "Alarm";
            default:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
        }
    };

    var getView = function getView(state) {
        switch (state) {
            //case deviceStateEnum.Service:
            //    return "RTU Configuration"; //"Service";
            //case deviceStateEnum.Alarm:
            //    return "Dashboard"; //"Alarm";
            default:
                return "Dashboard"; //"AllNormal";
        }
    };

    ctrl.$onInit = function () {
        ctrl.alerts = [];
        if (angular.isUndefined(ctrl.accountInfo)) {
            ctrl.accountInfo = authenticationService.getAccountInfo();
            ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        }
        if (angular.isUndefined(ctrl.popupWindow)) {
            ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
            ctrl.getPopupWindowDateTimeDifference = debounceService(ctrl.popupWindow.datetime_difference, 200, false);
        }
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
    };

    ctrl.pwMouseEnter = function (event) {
        if (!angular.isUndefined(ctrl.widgetSetting) && ctrl.hideHudElements) {
            ctrl.getData(ctrl.widgetSetting.device.deviceId, ctrl.widgetSetting.runtimeGauge.channel);
            var _hudObj = {
                inputStatus: ctrl.inputStatus,
                timeStampA: ctrl.timestamp_DisplayPre,
                timeStampB: ctrl.timestamp_Display,
                theme: angular.isUndefined(ctrl.themeIdOverridePopupOnly) ? ctrl.widgetSetting.runtimeWidgetSetting.theme : ctrl.themeIdOverridePopupOnly
            };
            if (ctrl.widgetSetting.device.type !== 8 && ctrl.widgetSetting.device.type !== 18) {
                ctrl.popupWindow.getWidgetStatusTooltip(ctrl.widgetSetting, event, angular.isUndefined(ctrl.additionalSize) ? ctrl.svgSizeH / 2 : ctrl.additionalSize - 5, _hudObj);
            }
        }
    };

    ctrl.pwMouseLeave = function (event) {
        if (!angular.isUndefined(ctrl.widgetSetting) && ctrl.hideHudElements) ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.pwMouseEnterAlarm = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.getTooltip(ctrl.widgetSetting.device.deviceId, event, 20);
    };

    ctrl.pwMouseLeaveAlarm = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            tmpInit = true;
            if (angular.isUndefined(ctrl.accountInfo)) {
                ctrl.accountInfo = authenticationService.getAccountInfo();
                ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
            }
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            ctrl.curentBrowser = detectBrowserService();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            if (angular.isUndefined(ctrl.popupWindow)) {
                ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
                ctrl.getPopupWindowDateTimeDifference = debounceService(ctrl.popupWindow.datetime_difference, 200, false);
            }
            //ctrl.mcPumpType = ctrl.mcWidgetsSharedFactory.getPumpTypeByWidgetId(changes.widgetSetting.currentValue.runtimeGauge.widgetId);

            if (!angular.isUndefined(changes.widgetSetting.previousValue) && !angular.isUndefined(changes.widgetSetting.previousValue.device)) ctrl.unRegisterListenerDigitalSetting(changes.widgetSetting.previousValue.device.serialNumber, changes.widgetSetting.previousValue.runtimeGauge.channel);

            ctrl.buildWidget(changes.widgetSetting.currentValue);
        }
    };

    ctrl.wsListDeviceStateMsgReceived = function (data) {
        ctrl.widgetSetting.deviceUnitState.state = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).state;
        ctrl.widgetSetting.deviceUnitState.acFail = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).acFail;
        ctrl.widgetSetting.deviceUnitState.lastTimeHeardUtc = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).lastTimeHeardUtc;
        ctrl.fnRtuStatusOptions(getState(ctrl.widgetSetting.deviceUnitState.state));
    };

    var _setTimeOut = function _setTimeOut() {
        $timeout(function () {
            ctrl.liveUpdateItem = null;
            ctrl.liveUpdated = null;
            ctrl.liveMessage = null;
        }, 20000); // 20 Seconds
    };

    var _refreshDeviceLive = function _refreshDeviceLive(data) {
        var patch = data.Value,
            userName = data.UserName,
            uniqueWebID = data.UniqueWebID;
        var _oldValue, _newValue;
        switch (patch.path) {
            case "description":
                _oldValue = ctrl.widgetSetting.runtimeGauge.description;
                ctrl.widgetSetting.runtimeGauge.description = patch.value;
                _newValue = patch.value;
                ctrl.updateWidgetTitle();
                break;
            case "widgetId":
                _oldValue = ctrl.widgetSetting.runtimeGauge.widgetId;
                ctrl.widgetSetting.runtimeGauge.widgetId = parseInt(patch.value);
                ctrl.widgetSetting.runtimeGauge.image = patch.Image;
                _newValue = patch.value;
                ctrl.mcPumpType = ctrl.pumpType = ctrl.mcWidgetsSharedFactory.getPumpTypeByWidgetId(ctrl.widgetSetting.runtimeGauge.widgetId);
                ctrl.buildWidget(ctrl.widgetSetting);
                break;
        }

        if (uniqueWebID != $rootScope.uniqueWebID) {
            $scope.liveUpdateItem = patch.path;
            ctrl.liveUpdated = true;
            ctrl.liveMessage = " " + userName + " changed " + patch.path.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase() + " from " + _oldValue + " to " + _newValue;
            console.log(ctrl.liveMessage);
            _setTimeOut();
        }
    };

    ctrl.wsDataReceivedDIGITALSETTINGMCRW = function (data) {
        if (data.Type == 'DIGITALSETTING' && data.SN == ctrl.widgetSetting.device.serialNumber && data.CH == ctrl.widgetSetting.runtimeGauge.channel) {
            _refreshDeviceLive(data);
        }
    };

    ctrl.registerListenerDigitalSetting = function (varSerialNum, channel) {
        //subscribe for digital setting changes
        websocketService.connect();
        websocketService.register('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.startOverview();
        websocketService.register("DIGITALSETTING", varSerialNum, channel, ctrl.wsDataReceivedDIGITALSETTINGMCRW, null);
    };

    ctrl.unRegisterListenerDigitalSetting = function (varSerialNum, channel) {
        websocketService.connect();
        websocketService.unRegister('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.stopOverview();
        websocketService.unRegister("DIGITALSETTING", varSerialNum, channel, ctrl.wsDataReceivedDIGITALSETTINGMCRW, null);
    };

    ctrl.buildWidget = function (widgetData) {

        if (ctrl.mcWidgetsSharedFactory.checkForEmptyObject(widgetData.runtimeGauge)) {
            var errormsg = ctrl.translation.text.NOT_SETUP;
            ctrl.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            return;
        } else {
            ctrl.alerts = [];
        }

        ctrl.widgetSetting = widgetData;

        ctrl.registerListenerDigitalSetting(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.runtimeGauge.channel);

        ctrl.hudText = getState(ctrl.widgetSetting.deviceUnitState.state); // Options: AllNormal, Alarm, Alert, Service, CommFail

        ctrl.w_BorderWidth = 2; // Set the inside solid border of the HUD
        ctrl.w_BorderPadding = 5; // Set the outside opaque border outline

        ctrl.show_chartdata = "No";

        ctrl.DisplayTimestamp();
        ctrl.setSize(_returnSizeId());

        ctrl.buildMainClass();

        ctrl.loadingInProgress = false;

        ctrl.noDecimals = sharedSetupService.getNumberOfDecimals(ctrl.widgetSetting.runtimeGauge.maxVal, ctrl.widgetSetting.runtimeGauge.minVal);
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);

        if (ctrl.widgetSetting.setting.displaySettingOn) {
            var newScope = $scope;
            var html = '<mc-widget-pump-setting widget-setting="$ctrl.widgetSetting" ng-if="$ctrl.widgetSetting.setting.displaySetting" change-display-options="$ctrl.fnChangeDisplayOptions(settingOptions)"></mc-widget-pump-setting>';
            var element = $element.find('.component-setting');
            if (element.is(':empty')) {
                element.append($compile(html)(newScope));
            }
        }

        ctrl.loadingInProgress = false;
    };

    ctrl.getData = function (deviceId, channel, openSetting) {

        var _runtimeGauge = new McPumpGaugeFactory(ctrl.accountInfo.customerId, deviceId, ctrl.accountInfo.timeZone, ctrl.mcWidgetsSharedFactory.getWidgetCategoryIdByPumpType(ctrl.pumpType), ctrl.mcWidgetsSharedFactory.getWidgetIdByPumpType(ctrl.pumpType), channel); //Category: Runtime, Widget: 'Single Needle Gauge'

        _runtimeGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;

            var device = _runtimeGauge.list.device;
            var deviceUnitState = _runtimeGauge.list.deviceUnitState;
            var deviceDigitalData = _runtimeGauge.list.digitalData;
            var enteredStateTime = _runtimeGauge.list.enteredStateTime;
            var defaultSetting = _runtimeGauge.list.defaultSetting;
            var runtimeGauge = _runtimeGauge.list.runtimeGauge[0].runtimeGauge;
            var runtimeWidgetSetting = _runtimeGauge.list.runtimeGauge[0].runtimeWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.widgetSetting.setting.displaySetting,
                displaySettingOn: ctrl.widgetSetting.setting.displaySettingOn,
                defaultSetting: ctrl.widgetSetting.setting.defaultSetting
            };

            ctrl.runtimeGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                deviceDigitalData: deviceDigitalData,
                enteredStateTime: enteredStateTime,
                defaultSetting: defaultSetting,
                runtimeGauge: runtimeGauge,
                runtimeWidgetSetting: runtimeWidgetSetting,
                setting: setting
            };

            ctrl.buildWidget(ctrl.runtimeGauge);

            //ctrl.fnMakeFitTextWork();
            if (!angular.isUndefined(openSetting)) {
                $timeout(function () {
                    ctrl.mouseOverHUD();
                    ctrl.editSetting();
                }, 0);
            }

            ctrl.updateWidgetTitle();
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.updateWidgetTitle = function () {
        ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.widgetSetting.device.deviceId, name: ctrl.widgetSetting.device.name, serialNumber: ctrl.widgetSetting.device.serialNumber, channel: ctrl.widgetSetting.runtimeGauge.channel, channelDescription: ctrl.widgetSetting.runtimeGauge.description, titleId: ctrl.widgetSetting.runtimeWidgetSetting.titleId } });
    };

    ctrl.fnMakeFitTextWork = function () {
        // $compile($element.find(".mc-fittext"))($scope);
    };

    ctrl.fnThemeOptions = function (themeOption) {
        ctrl.widgetSetting.runtimeWidgetSetting.theme = themeOption.name;
        ctrl.widgetSetting.runtimeWidgetSetting.themeId = themeOption.id;
        ctrl.buildMainClass();
    };

    ctrl.fnTitleOptions = function (titleOption) {
        ctrl.widgetSetting.runtimeWidgetSetting.titleId = titleOption.id;
        ctrl.widgetSetting.runtimeWidgetSetting.titleState = titleOption.state;
        ctrl.updateWidgetTitle();
    };

    ctrl.fnStateOptions = function (stateOption) {
        ctrl.widgetSetting.runtimeWidgetSetting.stateId = stateOption.id;
        ctrl.widgetSetting.runtimeWidgetSetting.stateDescription = stateOption.description;
        ctrl.buildMainClass();
    };

    ctrl.fnHeardTypeOptions = function (heardTypeOption) {
        ctrl.widgetSetting.runtimeWidgetSetting.dateTimeFormat = heardTypeOption.type;
        ctrl.widgetSetting.runtimeWidgetSetting.dateTimeFormatId = heardTypeOption.id;
        ctrl.DisplayTimestamp();
    };

    ctrl.fnSizeOptions = function (sizeOption, openSetting) {
        if (!ctrl.widgetSetting.setting.displaySetting) return;
        ctrl.widgetSetting.runtimeWidgetSetting.sizeId = sizeOption.id;
        ctrl.widgetSetting.runtimeWidgetSetting.size = sizeOption.description;
        ctrl.setSize(sizeOption.id);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.parent().addClass("ui-widget-content-mc");

            $timeout(function () {
                var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
                ctrl.popup.parent().css("height", svgH + "px");
                ctrl.popup.parent().css("width", svgH + 25 + "px");
                ctrl.popup.parent().find('.widgetContainer').css("left", 25 / 2 + "px");
            }, 0);
        }
        ctrl.closeSetting();
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);
        ctrl.buildMainClass();

        if (!angular.isUndefined(openSetting)) {
            $timeout(function () {
                ctrl.mouseOverHUD();
                ctrl.editSetting();
            }, 0);
        }
    };

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSizeNew(sizeId, 1, ctrl.pumpType);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.fnColorOptions = function (colorOption) {
        ctrl.widgetSetting.runtimeWidgetSetting.runningColor = colorOption.runningColor;
        ctrl.widgetSetting.runtimeWidgetSetting.runningBlink = colorOption.runningBlink;
        ctrl.widgetSetting.runtimeWidgetSetting.notRunningColor = colorOption.notRunningColor;
        ctrl.widgetSetting.runtimeWidgetSetting.notRunningBlink = colorOption.notRunningBlink;
        ctrl.widgetSetting.runtimeWidgetSetting.faultColor = colorOption.faultColor;
        ctrl.widgetSetting.runtimeWidgetSetting.faultBlink = colorOption.faultBlink;
        ctrl.buildMainClass();
        //ctrl.closeSetting();
    };

    ctrl.fnRtuStatusOptions = function (rtuStatus) {
        ctrl.buildMainClass();
        //ctrl.buildTachStrokeDash();
        ctrl.hudText = rtuStatus;
    };

    ctrl.fnRtuRuntimeOptions = function (rtuRuntime) {
        ctrl.buildMainClass();
        ctrl.hudText = rtuRuntime;
    };

    ctrl.fnChangeDisplayOptions = function (parSettingOptions) {
        if (!angular.isUndefined(parSettingOptions.titleOption)) {
            ctrl.fnTitleOptions(parSettingOptions.titleOption);
        }
        if (!angular.isUndefined(parSettingOptions.stateOption)) {
            ctrl.fnStateOptions(parSettingOptions.stateOption);
        }
        if (!angular.isUndefined(parSettingOptions.heardTypeOption)) {
            ctrl.fnHeardTypeOptions(parSettingOptions.heardTypeOption);
        }
        if (!angular.isUndefined(parSettingOptions.sizeOption)) {
            ctrl.fnSizeOptions(parSettingOptions.sizeOption, true);
        }
        if (!angular.isUndefined(parSettingOptions.themeOption)) {
            ctrl.fnThemeOptions(parSettingOptions.themeOption);
        }
        if (!angular.isUndefined(parSettingOptions.colorOption)) {
            ctrl.fnColorOptions(parSettingOptions.colorOption);
        }
        if (!angular.isUndefined(parSettingOptions.rtuOption)) {
            ctrl.getData(parSettingOptions.rtuOption.deviceId, parSettingOptions.rtuOption.channel, true);
        }
    };

    ctrl.editSetting = function (event) {
        ctrl.mcWidgetsSharedFactory.editSetting($element, event, ctrl);
    };

    ctrl.closeSetting = function () {
        ctrl.mcWidgetsSharedFactory.closeSetting($element, ctrl);
    };

    ctrl.mouseOverHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOver;
        }
    };

    ctrl.mouseOffHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOff;
        }
    };

    ctrl.resize_HUD = function (w_svgSizeW, w_svgSizeH) {
        ctrl.mcWidgetsSharedFactory.resizeHud(w_svgSizeW, w_svgSizeH, ctrl);
    };

    ctrl.webSocketHeartbeatReceived = function (data) {
        if (angular.isUndefined(ctrl.widgetSetting)) return; //The Widget has not initialized yetl
        ctrl.heartbeatDateTime = new Date(data.LocalDateTime).toISOString();
        ctrl.DisplayTimestamp();
    };

    ctrl.DisplayTimestamp = function () {

        var reportDateTime = ctrl.inputStatus == ctrl.translation.text.COMMS_FAULT ? ctrl.widgetSetting.deviceUnitState.lastTimeHeardUtc : ctrl.widgetSetting.enteredStateTime["d" + ctrl.widgetSetting.runtimeGauge.channel];
        var currentDateTime = _returnUtcNow();
        var format = ctrl.widgetSetting.runtimeWidgetSetting.dateTimeFormat;

        if (angular.isUndefined(reportDateTime) && angular.isUndefined(currentDateTime)) return;
        var _timestamp_Display;

        if (format === ctrl.translation.text.ABSOLUTE && reportDateTime !== "0001-01-01T00:00:00") {
            _timestamp_Display = $filter('filterDateAgentTextTimeFormat')(datetimeService.UtcToLocalByTimeZone(reportDateTime, ctrl.accountInfo.timeZone), ctrl.preferredTimeFormat);

            var _substrings;
            _substrings = _timestamp_Display.split(' ');
            //_timestamp_Display = _timestamp_Display.replace(/\s/g, '');

            switch (_timestamp_Display.length) {//"Nov 01 2019 02:42:21 AM"
                case 7: //2:42:21
                case 8: //02:42:21
                case 9:
                case 10: //2:42:21 AM
                case 11:
                    //02:42:21 AM
                    ctrl.timestamp_DisplayPre = "";
                    ctrl.timestamp_Display = _substrings[0] + (angular.isUndefined(_substrings[1]) ? " " : " " + _substrings[1]);
                    break;
                case 14: //Nov 01 2:42:21
                case 15: //Nov 01 02:42:21
                case 16:
                case 17: //Nov 01 2019 2:42:21 AM
                case 18:
                    //Nov 01 02:42:21 AM
                    ctrl.timestamp_DisplayPre = _substrings[0] + " " + _substrings[1];
                    ctrl.timestamp_Display = _substrings[2] + (angular.isUndefined(_substrings[3]) ? "" : " " + _substrings[3]);
                    break;
                case 19: //Nov 01 2019 2:42:21
                case 20: //Nov 01 2019 02:42:21
                case 21:
                case 22: //Nov 01 2019 2:42:21 AM
                case 23:
                    //Nov 01 2019 02:42:21 AM
                    if (_substrings.length === 2) {
                        //Yesterday 02:42:21 AM
                        ctrl.timestamp_DisplayPre = _substrings[0];
                        ctrl.timestamp_Display = _substrings[1];
                    } else {
                        ctrl.timestamp_DisplayPre = _substrings[0] + " " + _substrings[1] + " " + _substrings[2];
                        ctrl.timestamp_Display = _substrings[3] + (angular.isUndefined(_substrings[4]) ? "" : " " + _substrings[4]);
                    }
                    break;
            }

            ctrl.buildStyle(12, ctrl.timestamp_Display.length, 35, ctrl.timestamp_DisplayStyle);
        } else {
            //if (format === "Elapsed")
            _timestamp_Display = ctrl.getPopupWindowDateTimeDifference(reportDateTime, currentDateTime, format);
            _timestamp_Display.then(function (value) {
                ctrl.timestamp_DisplayPre = "";
                ctrl.timestamp_Display = value;
                ctrl.buildStyle(10, ctrl.timestamp_Display.length, 40, ctrl.timestamp_DisplayStyle);
            });
        }
    };

    ctrl.buildStyle = function (numberOfFontsThatFits, strLength, maxFontSize, obj) {
        var _minFontSize = 25;
        obj["font-size"] = ctrl.adjustFontSize(numberOfFontsThatFits, strLength, _minFontSize, maxFontSize) + "px";
    };

    ctrl.adjustFontSize = function (numberOfFontsThatFits, strLength, minFontSize, maxFontSize) {
        var newFontSize = maxFontSize / strLength * numberOfFontsThatFits;
        return newFontSize > maxFontSize ? maxFontSize : newFontSize < minFontSize ? minFontSize : newFontSize;
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ctrl.buildMainClass = function () {

        var gaugeType = "TachGauge1"; // Options: TachGauge1 (Styled in mcwidgets.css)
        var pumpTransparentObj = "PumpTransparentObj";
        var mainClass = ["upWidget", gaugeType, ctrl.widgetSetting.runtimeWidgetSetting.theme, "rtu" + getState(ctrl.widgetSetting.deviceUnitState.state), "acfail" + ctrl.widgetSetting.deviceUnitState.acFail, pumpTransparentObj];
        ctrl.mainClass = angular.copy(mainClass);

        ctrl.svgViewBox = _getSvgViewBox(ctrl.pumpType);

        _customAdjustment();

        ctrl.blink = false;

        switch (ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel]) {
            case "True":
                if (ctrl.widgetSetting.runtimeGauge.normalClosed === 0) {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.runtimeWidgetSetting.notRunningColor };
                    ctrl.blink = ctrl.widgetSetting.runtimeWidgetSetting.notRunningBlink ? _getRotatingClassByPumpType(ctrl.pumpType) : ctrl.blink;
                    ctrl.inputStatus = ctrl.translation.text.STOPPED;
                    ctrl.valveState = ctrl.valveStateClosed;
                } else {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.runtimeWidgetSetting.runningColor };
                    ctrl.blink = ctrl.widgetSetting.runtimeWidgetSetting.runningBlink ? _getRotatingClassByPumpType(ctrl.pumpType) : ctrl.blink;
                    ctrl.inputStatus = ctrl.translation.text.RUNNING;
                    ctrl.valveState = _getOpenValveClassByValveType(ctrl.pumpType);
                }
                break;

            case "False":
                if (ctrl.widgetSetting.runtimeGauge.normalClosed === 0) {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.runtimeWidgetSetting.runningColor };
                    ctrl.blink = ctrl.widgetSetting.runtimeWidgetSetting.runningBlink ? _getRotatingClassByPumpType(ctrl.pumpType) : ctrl.blink;
                    ctrl.inputStatus = ctrl.translation.text.RUNNING;
                    ctrl.valveState = _getOpenValveClassByValveType(ctrl.pumpType);
                } else {
                    ctrl.colorLayer = { 'fill': ctrl.widgetSetting.runtimeWidgetSetting.notRunningColor };
                    ctrl.blink = ctrl.widgetSetting.runtimeWidgetSetting.notRunningBlink ? _getRotatingClassByPumpType(ctrl.pumpType) : ctrl.blink;
                    ctrl.inputStatus = ctrl.translation.text.STOPPED;
                    ctrl.valveState = ctrl.valveStateClosed;
                }
                break;

            case "NULL":
            case "Fault":
                ctrl.colorLayer = { 'fill': ctrl.widgetSetting.runtimeWidgetSetting.faultColor };
                ctrl.blink = ctrl.widgetSetting.runtimeWidgetSetting.faultBlink ? _getRotatingClassByPumpType(ctrl.pumpType) : ctrl.blink;
                ctrl.inputStatus = ctrl.translation.text.FAULT;
                ctrl.valveState = ctrl.valveStateClosed;
                break;

        }

        if (getState(ctrl.widgetSetting.deviceUnitState.state) === "CommFail") ctrl.inputStatus = ctrl.translation.text.COMMS_FAULT;

        ctrl.pumpTextOverlayStyle = { "margin-top": "42.5%", "margin-left": "50%", "margin-right": "10%", "height": "15%", "color": "#000000", "font-size": ctrl.svgSizeW * .1 + "px" };
        ctrl.hideHudElements = _returnSizeId() <= 2 ? true : false;
        ctrl.mcXsmallOnlyNo = _returnSizeId() === 1 ? true : false;
        ctrl.cog = ctrl.blink;
        ctrl.bladeStyle = ctrl.colorLayer; //{" style="fill: rgb(0, 0, 128);"}
        ctrl.buildStyle(9, ctrl.inputStatus.length, 40, ctrl.inputStatusStyle);

        $timeout(function () {
            ctrl.svgStyle = angular.isUndefined(ctrl.svgStyleAdjustment) ? { "opacity": '1' } : _getSvgStyleAdjustments(ctrl.pumpType);
        }, 500);
    };

    var _getRotatingClassByPumpType = function _getRotatingClassByPumpType(pumpType) {
        var _pumpType = angular.isUndefined(pumpType) ? "" : pumpType;

        switch (_pumpType.toUpperCase()) {
            case "SUBMERSIBLE PUMP":
                return "run";
            case "WASTE WATER SUBMERSIBLE PUMP":
                return "run-short";
            case "VERTICAL TURBINE PUMP":
                return "vtp-run";
            case "BLOWER PUMP":
                return "two-spin";
            case "GRINDER PUMP":
                return "grind";
            case "STANDBY GENERATOR":
                return "shake";
            case "CONTROL VALVE":
            case "ALTITUDE VALVE":
                return "water-flow";
            default:
                return "spin";
        }
    };

    var _getOpenValveClassByValveType = function _getOpenValveClassByValveType(pumpType) {
        var _pumpType = angular.isUndefined(pumpType) ? "" : pumpType;

        switch (_pumpType.toUpperCase()) {
            case "CONTROL VALVE":
            case "ALTITUDE VALVE":
                return "valve-state-open";
            default:
                return "";
        }
    };

    var _getSvgStyleAdjustments = function _getSvgStyleAdjustments(pumpType) {
        var _pumpType = angular.isUndefined(pumpType) ? "" : pumpType;

        switch (_pumpType.toUpperCase()) {
            case "VANE PUMP":
                return { "top": '-7px', "left": '-10px', "opacity": '1' };
            case "CENTRIFUGAL PUMP":
                return { "top": '-10px', "left": '-14px', "opacity": '1' };
            case "IN LINE PUMP":
                return { "top": '-9px', "left": '-14px', "opacity": '1' };
            case "WASTE WATER SUBMERSIBLE PUMP":
                return { "top": '-24px', "left": '-10px', "opacity": '1' };
            case "GRINDER PUMP":
                return { "top": '3px', "left": '0px', "opacity": '1' };
            case "VERTICAL TURBINE PUMP":
                return { "top": '4px', "left": '-2px', "opacity": '1' };
            case "STANDBY GENERATOR":
                return { "left": '-2px', "opacity": '1' };
            case "CONTROL VALVE":
                return { "top": '1px', "left": '-2px', "opacity": '1' };
            case "ALTITUDE VALVE":
                return { "top": '1px', "left": '-1px', "opacity": '1' };
            default:
                return { "opacity": '1' };
        }
    };

    var _getSvgViewBox = function _getSvgViewBox(pumpType) {
        var _pumpType = angular.isUndefined(pumpType) ? "" : pumpType;
        var _sizeId = _returnSizeId();

        switch (_pumpType.toUpperCase()) {
            case "VERTICAL TURBINE PUMP":
                return _sizeId === 1 ? "310 548 5 78" : "0 0 618.1 760";
            case "GRINDER PUMP":
                return _sizeId === 1 ? "258 374 100 190" : "0 0 609.8 608.5";
        }
    };

    var _returnUtcNow = function _returnUtcNow() {
        var _a = $rootScope.heartbeatUtcDateTime;
        var _b = moment().utc().format('MM/DD/YY, h:mm:ss a').valueOf();
        var tmpTime = _a || _b;
        return tmpTime;
    };

    var _returnSizeId = function _returnSizeId() {
        if (angular.isUndefined(ctrl.sizeIdOverride)) {
            return ctrl.widgetSetting.setting.defaultSetting ? ctrl.widgetSetting.defaultSetting.sizeId : ctrl.widgetSetting.runtimeWidgetSetting.sizeId;
        } else return parseInt(ctrl.sizeIdOverride);
    };

    ctrl.openView = function ($event) {
        openViewService.openView(getView(ctrl.widgetSetting.deviceUnitState.state));
    };

    // from socket

    ctrl.updateValue = function (value) {

        switch (value) {
            case "1":
                return "True";
            case "0":
                return "False";
            case "-1":
                return "Fault";
        }
        return "Fault";
    };

    var _customAdjustment = function _customAdjustment() {
        ////TODO: This is very specific for Vertical Turbine Pump -> I will need to revisit
        //if (angular.isUndefined(ctrl.svgStyle.top) && ctrl.pumpType === "Vertical Turbine Pump" && _returnSizeId() == 1) {
        //    ctrl.svgStyle = { "top": '-115px', "clip-path": 'polygon(42.8% 71.60%, 57.3% 71.60%, 58.14% 72.87%, 59.4348% 74.6%, 58.93% 78.8%, 58.8% 82.07%, 42.13% 82.07%, 41.87% 78.8%, 41.1% 75.06%, 42.13% 72.94%)' };
        //}
        ////TODO: This is very specific for Vertical Turbine Pump -> I will need to revisit
    };

    ctrl.wsDataReceivedWD = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;

        ctrl.widgetSetting.deviceUnitState.lastTimeHeardUtc = datetimeService.socketStrToServerStrTime(data.UtcDateTime);

        // if (ctrl.widgetSetting.runtimeGauge.channel > 8) return;

        var chValue = data.Value;
        var channel = parseInt(data.CH);
        var digValue = ctrl.updateValue(chValue);
        if (ctrl.widgetSetting.runtimeGauge.channel == channel) {
            if (ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel] !== digValue) {
                ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel] = digValue;
                ctrl.widgetSetting.enteredStateTime["d" + ctrl.widgetSetting.runtimeGauge.channel] = datetimeService.socketStrToServerStrTime(data.UtcDateTime);
            }
        }

        ctrl.buildMainClass();
    };

    ctrl.wsDataReceivedWOD = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;

        ctrl.widgetSetting.deviceUnitState.lastTimeHeardUtc = datetimeService.socketStrToServerStrTime(data.UtcDateTime);

        if (ctrl.widgetSetting.runtimeGauge.channel <= 8) return;

        var chArray = data.Value.replace(/[[\]]/g, '').split(',');
        var digValue = ctrl.updateValue(chArray[ctrl.widgetSetting.runtimeGauge.channel - 9]);

        if (ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel] !== digValue) {
            ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel] = digValue;
            ctrl.widgetSetting.enteredStateTime["d" + ctrl.widgetSetting.runtimeGauge.channel] = datetimeService.socketStrToServerStrTime(data.UtcDateTime);
        }

        ctrl.buildMainClass();
    };

    ctrl.wsDataReceivedFAULTS = function (data) {
        if (ctrl.widgetSetting.device.serialNumber !== data.SN) return;

        ctrl.widgetSetting.deviceUnitState.lastTimeHeardUtc = datetimeService.socketStrToServerStrTime(data.UtcDateTime);

        var faultBinary;
        if (isNaN(data.Value)) {
            faultBinary = data.Value.replace(/[[\]]/g, '').split(',').join('');
        } else {
            faultBinary = (data.Value >>> 0).toString(2);

            while (faultBinary.length < 16) {
                faultBinary = faultBinary.length < 8 ? "0" + faultBinary : faultBinary + "0";
            }
        }

        if (faultBinary[ctrl.widgetSetting.runtimeGauge.channel - 1] === '1') {
            //console.log('Got a fault for channel: ', channelId);
            var digValue = "NULL";

            if (ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel] !== digValue) {
                ctrl.widgetSetting.deviceDigitalData["d" + ctrl.widgetSetting.runtimeGauge.channel] = digValue;
                ctrl.widgetSetting.enteredStateTime["d" + ctrl.widgetSetting.runtimeGauge.channel] = datetimeService.socketStrToServerStrTime(data.UtcDateTime);
            }

            ctrl.buildMainClass();
        }
    };

    ctrl.webSocketReconnect = function () {
        //if widget then toaster message... if gauge then not
        if (angular.isUndefined(ctrl.additionalSize)) toaster.pop('success', "Runtime Widget" + " -- " + ctrl.widgetSetting.device.name, 'View reloading');
        ctrl.getData(ctrl.widgetSetting.device.deviceId, ctrl.widgetSetting.runtimeGauge.channel);
    };

    var _onHeartbeat = $rootScope.$on('Heartbeat', function (event, args) {
        if (args.message.Type === "HEARTBEAT") {
            ctrl.webSocketHeartbeatReceived(args.message);
        }
    });

    var _onINPUTS = $rootScope.$on('DIGITALINPUT', function (event, args) {
        ctrl.wsDataReceivedWD(args.data);
    });

    var _onOPTIONDIGITAL = $rootScope.$on('OPTIONDIGITAL', function (event, args) {
        ctrl.wsDataReceivedWOD(args.data);
    });

    var _onFAULTS = $rootScope.$on('FAULTS', function (event, args) {
        ctrl.wsDataReceivedFAULTS(args.data);
    });

    var _onRECONNECT = $scope.$on('processReconnect', function (event, args) {
        ctrl.webSocketReconnect();
    });

    var _onDocumentClick = $rootScope.$on('document_click', function (event, args) {
        ctrl.closeSetting();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.buildMainClass();
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.applyTimeFormat(timeFormat);
    });

    $scope.applyTimeFormat = function (timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat);
    };

    $scope.$on("$destroy", function () {
        _onHeartbeat();
        _onDocumentClick();
        _onINPUTS();
        _onOPTIONDIGITAL();
        _onFAULTS();
        _onRECONNECT();
        _setTimeOut();
        ctrl.unRegisterListenerDigitalSetting(ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.runtimeGauge.channel);
        if (chart) chart.destroy();
    });

    $scope.$on("StopOverview", function (event, args) {
        if ($scope.$$destroyed) {
            // The scope is already destroyed, skip further processing.
            return;
        } else if (args.stop) {
            websocketService.connect();
            websocketService.startOverview();
        }
    });
}

McWidgetPumpDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'debounceService', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'McPumpGaugeFactory', 'authenticationService', 'translationService', 'PopupFactory', 'detectBrowserService', 'McWidgetsSharedFactory', '$filter', 'openViewService'];
'use strict';

angular.module('mc.widget-pump-display').component('mcWidgetPumpDisplay', {
    controller: McWidgetPumpDisplayController,
    templateUrl: 'ui/mcwidgetpumpdisplay/mcwidget-pump-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        settingShow: '&',
        changeWidgetTitle: '&',
        labelMode: '@',
        additionalSize: '@',
        pumpType: '<',
        sizeIdOverride: '@',
        themeIdOverridePopupOnly: '@',
        svgStyleAdjustment: '@'
    }
});
"use strict";

angular.module("mc.logins", []);
"use strict";

function LoginsFactory(HOST, $http) {

    // instantiate our initial object
    var Logins = function Logins(customerId) {
        this.customerId = customerId;
    };

    Logins.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + "/api/Logins" + "?customerId=" + this.customerId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.getLogins = function () {
        var self = this;
        return $http.get(HOST + "/api/Logins/GetInfo/" + "?customerId=" + this.customerId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.patchData = function (userId, userPatch) {
        var self = this;
        return $http.patch(HOST + '/api/Logins' + '?customerId=' + this.customerId + '&userId=' + userId, userPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.post = function (newUser) {
        var self = this;
        return $http.post(HOST + '/api/Logins' + '?customerId=' + this.customerId, newUser).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.delete = function (userId, userName) {
        var self = this;
        return $http.delete(HOST + '/api/Logins' + '?customerId=' + this.customerId + '&userId=' + userId + '&userName=' + userName).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.put = function (newUser) {
        var self = this;
        return $http.put(HOST + '/api/Logins' + '?customerId=' + this.customerId, newUser).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.sendResetEmail = function (loginUser, field) {
        //return $http({
        //    method: 'POST',
        //    url: HOST + '/api/LoginsCredentialReset/SendResetEmail/',
        //    params: { loginUser, field },
        //});
        var self = this;
        return $http.post(HOST + '/api/LoginsCredentialReset/SendResetEmail' + '?field=' + field, loginUser).then(function (response) {
            //self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.sendWelcomeEmail = function (loginId) {
        var self = this;
        return $http.post(HOST + '/api/Logins/SendWelcome' + '?customerId=' + this.customerId + '&loginId=' + loginId).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.updateDatabaseFlag = function (field, flag, loginUser) {
        var self = this;
        return $http.post(HOST + '/api/LoginsCredentialReset/UpdateDatabaseFlag' + '?field=' + field + '&flag=' + flag, loginUser).then(function (response) {
            //self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.clearSecret = function (userId) {
        var self = this;
        return $http.delete(HOST + '/api/LoginsCredentialReset/ClearSecret' + '?customerId=' + this.customerId + '&userId=' + userId).then(function (response) {
            //self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.suspend2Fa = function (userId, suspend2FaHours) {
        var self = this;
        return $http.put(HOST + '/api/LoginsCredentialReset/suspend2Fa' + '?customerId=' + this.customerId + '&userId=' + userId + '&suspend2FaHours=' + suspend2FaHours).then(function (response) {
            //self.currentUser = response.data;
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.redirectToLegacySite = function (loginId) {
        var self = this;
        return $http.post(HOST + '/api/Logins/RedirectToLegacy' + '?customerId=' + this.customerId + '&loginId=' + loginId).then(function (response) {
            self.loading = false;
            return response;
        });
    };

    Logins.prototype.unlockUser = function (userId, userName) {
        var self = this;
        return $http.put(HOST + '/api/FailedLoginAttempts' + '?customerId=' + this.customerId + '&userId=' + userId + '&userName=' + userName).then(function (response) {
            return response;
        });
    };

    return Logins;
}

LoginsFactory.$inject = ['HOST', '$http'];

angular.module('mc.logins').factory('LoginsFactory', LoginsFactory);
"use strict";

angular.module("mc.widget-cylinder-display", []);
"use strict";

function McWidgetCylinderDisplayController($, $timeout, $rootScope, $scope, $element, McTemperatureGaugeFactory, $compile, websocketService, toaster, datetimeService, sharedSetupService, authenticationService, translationService, PopupFactory, detectBrowserService, McWidgetsSharedFactory, openViewService) {

    var ctrl = this;
    var chart = void 0;
    var tmpInit = true;

    ctrl.$onInit = function () {
        ctrl.loadingInProgress = true;
        if (angular.isUndefined(ctrl.accountInfo)) {
            ctrl.accountInfo = authenticationService.getAccountInfo();
            ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
            ctrl.preferencesMeasurement = ctrl.accountInfo.preferenceUser.lookupMeasurementID; //1 is farenheit
        }
        if (angular.isUndefined(ctrl.popupWindow)) {
            ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
        }
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
    };

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            tmpInit = true;
            if (angular.isUndefined(ctrl.accountInfo)) {
                ctrl.accountInfo = authenticationService.getAccountInfo();
                ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
                ctrl.preferencesMeasurement = ctrl.accountInfo.preferenceUser.lookupMeasurementID;
            }
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            ctrl.curentBrowser = detectBrowserService();
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            if (angular.isUndefined(ctrl.popupWindow)) {
                ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
            }
            ctrl.buildWidget(changes.widgetSetting.currentValue);
        }
    };

    var _setTimeOut = function _setTimeOut() {
        $timeout(function () {
            ctrl.liveUpdateItem = null;
            ctrl.liveUpdated = null;
            ctrl.liveMessage = null;
        }, 20000); // 20 Seconds
    };

    ctrl.buildWidget = function (widgetData) {

        ctrl.widgetSetting = widgetData;

        ctrl.w_BorderWidth = 2; // Set the inside solid border of the HUD
        ctrl.w_BorderPadding = 5; // Set the outside opaque border outline

        ctrl.show_chartdata = "No";

        if (ctrl.widgetSetting.altSource) {
            ctrl.setSize(3);
        } else {
            ctrl.setSize(5);
        }

        ctrl.buildMainClass();

        //ctrl.fnSizeOptions(4);

        _getlevelMarks();

        _getWaterColor();

        _svgAttributsInitialization();

        _calcGaugeLevel();

        //_calcGaugeLevel(ctrl.widgetSetting.temperatureGauge[0].currentData.value);        

        //ctrl.loadingInProgress = false;

        _addAnimation();

        //ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);

        ctrl.buildMainClass();

        ctrl.loadingInProgress = false;
    };

    ctrl.updateWidgetTitle = function () {
        ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.widgetSetting.device.deviceId, name: ctrl.widgetSetting.device.name, serialNumber: ctrl.widgetSetting.device.serialNumber } });
    };

    ctrl.fnSizeOptions = function (sizeId, openSetting) {
        //if (!ctrl.widgetSetting.setting.displaySetting) return;
        //ctrl.widgetSetting.temperatureWidgetSetting.sizeId = sizeId;
        ctrl.setSize(sizeId);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.parent().addClass("ui-widget-content-mc");

            $timeout(function () {
                var svgH = parseInt(ctrl.popup.parent().find('svg').css("height"), 10);
                ctrl.popup.parent().css("height", svgH + "px");
                ctrl.popup.parent().css("width", svgH + 25 + "px");
                switch (sizeId) {
                    case 1:
                        ctrl.popup.parent().find('.widgetContainer').css("left", 60 / 2 + "px");
                        break;
                    case 2:
                        ctrl.popup.parent().find('.widgetContainer').css("left", 118 / 2 + "px");
                        break;
                    case 3:
                        ctrl.popup.parent().find('.widgetContainer').css("left", 156 / 2 + "px");
                        break;
                    case 4:
                        ctrl.popup.parent().find('.widgetContainer').css("left", 188 / 2 + "px");
                        break;
                    case 5:
                        ctrl.popup.parent().find('.widgetContainer').css("left", 220 / 2 + "px");
                        break;
                }
            }, 0);
        }
        //ctrl.closeSetting();
        //ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);
        ctrl.buildMainClass();

        //if (!angular.isUndefined(openSetting)) {
        //    $timeout(() => {
        //        ctrl.mouseOverHUD();
        //        ctrl.editSetting();
        //    }, 0);
        //}
    };

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSizeNew(sizeId, 1);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ctrl.buildMainClass = function () {

        var gaugeType = "TachGauge1"; // Options: TachGauge1 (Styled in mcwidgets.css)
        var pumpTransparentObj = "PumpTransparentObj";
        var mainClass = ["upWidget", gaugeType, "Dark", "rtuAllNormal", "acfailfalse", pumpTransparentObj];
        ctrl.mainClass = angular.copy(mainClass);
    };

    var _getWaterColor = function _getWaterColor() {
        ctrl.waterColorStyle = { "fill": ctrl.widgetSetting.cylFillColor };
    };

    var _getlevelMarks = function _getlevelMarks() {
        if (ctrl.widgetSetting.value > 0 && ctrl.widgetSetting.value < ctrl.widgetSetting.lowerLimit) ctrl.widgetSetting.lowerLimit = 0;
        if (ctrl.widgetSetting.value < 0 && ctrl.widgetSetting.value < ctrl.widgetSetting.lowerLimit) ctrl.widgetSetting.lowerLimit = Math.round(ctrl.widgetSetting.value - 1);

        var lower = ctrl.widgetSetting.lowerLimit;
        var upper = ctrl.widgetSetting.upperLimit;
        var range = upper - lower;

        ctrl.lowValue = lower + range * 0.25;
        ctrl.midValue = lower + range * 0.50;
        ctrl.highValue = lower + range * 0.75;
    };

    var _svgAttributsInitialization = function _svgAttributsInitialization() {
        ctrl.cylinderGaugeWaterPoints = "342.9,379.2 343,378.2 177,378.2 177,379.2 	";
        ctrl.shadeY = "380.2";
        ctrl.upperEllipse = "M342.9,379.2L342.9,379.2c0.1-16.3-37.1-29.5-82.9-29.5s-83,13.2-83,29.5l-0.1,0.1H342.9z";
        ctrl.temperatureGaugeBodyPoints = "256.7,442 256.7,457.5 178.8,457.5 178.8,442  ";
    };

    var _calcGaugeLevel = function _calcGaugeLevel() {
        var panelMinMaxDiff = 378.2 - 42;
        var currentWaterPercent = (ctrl.widgetSetting.value - ctrl.widgetSetting.lowerLimit) / (ctrl.widgetSetting.upperLimit - ctrl.widgetSetting.lowerLimit);
        if (ctrl.widgetSetting.value < ctrl.widgetSetting.lowerLimit) currentWaterPercent = 0;
        if (ctrl.widgetSetting.value > ctrl.widgetSetting.upperLimit) currentWaterPercent = 0.99;
        var waterLevel = "342.9,379.2 343," + (378.2 - panelMinMaxDiff * currentWaterPercent) + " 177," + (378.2 - panelMinMaxDiff * currentWaterPercent) + " 177,379.2 	";
        var upperEllipseLevel = "M342.9," + (378.2 - panelMinMaxDiff * currentWaterPercent + 1) + "L342.9," + (378.2 - panelMinMaxDiff * currentWaterPercent + 1) + "c0.1-16.3-37.1-29.5-82.9-29.5s-83,13.2-83,29.5l-0.1,0.1H342.9z";
        var shadeYLevel = 378.2 - panelMinMaxDiff * currentWaterPercent - 3;

        ctrl.oldCylinderGaugeWaterPoints = ctrl.cylinderGaugeWaterPoints;
        ctrl.cylinderGaugeWaterPoints = waterLevel;
        ctrl.oldUpperellipse = ctrl.upperEllipse;
        ctrl.upperEllipse = upperEllipseLevel;
        ctrl.oldShadeY = ctrl.shadeY;
        ctrl.shadeY = shadeYLevel;
    };

    var _addAnimation = function _addAnimation() {
        document.getElementById($scope.$id + 'water').beginElement();
        document.getElementById($scope.$id + 'upperEllipse').beginElement();
        document.getElementById($scope.$id + 'shade').beginElement();
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.buildMainClass();
    });

    $scope.$on("$destroy", function () {
        _setTimeOut();
        if (chart) chart.destroy();
    });
}

McWidgetCylinderDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'McTemperatureGaugeFactory', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'authenticationService', 'translationService', 'PopupFactory', 'detectBrowserService', 'McWidgetsSharedFactory', 'openViewService'];
'use strict';

angular.module('mc.widget-cylinder-display').component('mcWidgetCylinderDisplay', {
    controller: McWidgetCylinderDisplayController,
    templateUrl: 'ui/mcwidgetcylinderdisplay/mcwidget-cylinder-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<'
    }
});
"use strict";

angular.module("mc.live-demo", []);
'use strict';

function LiveDemoController(_, HOST, $scope, $http, $sce, datetimeService, sharedSetupService, $element, timeLapseService, translationService, websocketService, authenticationService, getDateRangeService, savePdfService) {
    var ctrl = this;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.showMsg = false;

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.popup.dialog('option', 'title', ctrl.translation.text.LIVE_DEMO);
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    $scope.$on('updatePreferencesLanguage', function () {
        var _tmpTimeFormat = $scope.timeFormat;
        $scope.timeFormat = 0;
        $timeout(function () {
            $scope.timeFormat = _tmpTimeFormat;
        }, 0);
    });
};

LiveDemoController.$inject = ['_', 'HOST', '$scope', '$http', '$sce', 'datetimeService', 'sharedSetupService', '$element', 'timeLapseService', 'translationService', 'websocketService', 'authenticationService', 'getDateRangeService', 'savePdfService'];
'use strict';

angular.module('mc.live-demo').component('liveDemo', {
    controller: LiveDemoController,
    templateUrl: 'ui/livedemo/live-demo-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
angular.module("mc.widget-output-setting", []);
"use strict";

function McWidgetOutputSettingController($, $timeout, $rootScope, $scope, $element, $interval, $compile, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, analogOutputWidgetService, analogWidgetService, McWidgetsSharedFactory) {

    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            ctrl.mcWidgetSetting = changes.widgetSetting.currentValue;
            if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.getUiData();
        }
    };

    ctrl.$onInit = function () {
        if (angular.isUndefined(ctrl.accountInfo)) ctrl.accountInfo = authenticationService.getAccountInfo();
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        ctrl.w_tabpaneIsOpen = { "height": "100%", "display": "block" };
        ctrl.w_tabpaneIsClosed = { "height": "0%", "display": "none" };
        ctrl.dynamicPopover = {
            templateUrl: "SelectColorPopoverTemplate.html"
        };
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.colorPalet = ctrl.mcWidgetsSharedFactory.getColorPalet();
    };

    ctrl.setModel = function (parm) {
        ctrl.clearModel();
        $timeout(function () {
            ctrl.parm = parm;
        }, 0);
    };

    ctrl.clearModel = function () {
        ctrl.parm = null;
    };

    ctrl.testNgChange = function () {
        ctrl.validateColors(true);
    };

    ctrl.selectColor = function (event) {
        switch (ctrl.parm) {
            case "lowAlarmColor":
                ctrl.lowAlarmColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "normalColor":
                ctrl.normalColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            case "highAlarmColor":
                ctrl.highAlarmColor = ctrl.mcWidgetsSharedFactory.rgb2hex($(event.currentTarget).css('background-color'));
                break;
            default:
            // code block
        }

        ctrl.clearModel();
        ctrl.validateColors(true);
    };

    ctrl.updateDisplayOptions = function (param) {

        var tmpNewAnalogOutputWidgetSetting = angular.copy(ctrl.mcWidgetSetting.analogOutputWidgetSetting);
        tmpNewAnalogOutputWidgetSetting.customerId = ctrl.accountInfo.customerId;
        tmpNewAnalogOutputWidgetSetting.deviceId = ctrl.mcWidgetSetting.device.deviceId;
        tmpNewAnalogOutputWidgetSetting.channel = ctrl.mcWidgetSetting.analogOutputGauge.channel;

        if (!angular.isUndefined(param.settingOptions.marksType)) {
            tmpNewAnalogOutputWidgetSetting.tickMarksId = param.settingOptions.marksType.id;
            ctrl.updateUiData(param, tmpNewAnalogOutputWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.heardTypeOption)) {
            tmpNewAnalogOutputWidgetSetting.dateTimeFormatId = param.settingOptions.heardTypeOption.id;
            ctrl.updateUiData(param, tmpNewAnalogOutputWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.sizeOption)) {
            tmpNewAnalogOutputWidgetSetting.sizeId = param.settingOptions.sizeOption.id;
            ctrl.updateUiData(param, tmpNewAnalogOutputWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.themeOption)) {
            tmpNewAnalogOutputWidgetSetting.themeId = param.settingOptions.themeOption.id;
            ctrl.updateUiData(param, tmpNewAnalogOutputWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.colorOption)) {
            tmpNewAnalogOutputWidgetSetting.lowAlarmColor = param.settingOptions.colorOption.low;
            tmpNewAnalogOutputWidgetSetting.normalColor = param.settingOptions.colorOption.normal;
            tmpNewAnalogWtmpNewAnalogOutputWidgetSettingidgetSetting.highAlarmColor = param.settingOptions.colorOption.high;
            ctrl.updateUiData(param, tmpNewAnalogOutputWidgetSetting);
        }

        if (!angular.isUndefined(param.settingOptions.rtuOption)) {

            ctrl.getChannels(param.settingOptions.rtuOption.deviceId, true);
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: param.settingOptions.rtuOption.deviceId, channel: ctrl.channelSelectedOption.channel } } });
        }

        if (!angular.isUndefined(param.settingOptions.channelOption)) {
            ctrl.channelSelectedOption = { channel: param.settingOptions.channelOption.channel };
            ctrl.changeDisplayOptions({ settingOptions: { rtuOption: { deviceId: ctrl.rtuSelectedOption.deviceId, channel: param.settingOptions.channelOption.channel } } });
        }
    };

    ctrl.updateUiData = function (param, naws) {
        ctrl.mcWidgetsSharedFactory.updateUiData(param, naws, "GaugeAnalogWidget", "newMcWidgetSettingOptions", ctrl);
    };

    ctrl.getUiData = function () {
        ctrl.mcWidgetsSharedFactory.getUiData("mcWidgetSettingOptions", "All", ctrl);
    };

    ctrl.getSetting = function () {
        analogOutputWidgetService.getAnalogOutputSettings(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.rtuOptions = result.data.analogDevices;
            ctrl.analogSettings = result.data.analogSettings;

            ctrl.getChannels(ctrl.mcWidgetSetting.device.deviceId);

            ctrl.rtuSelectedOption = { deviceId: ctrl.mcWidgetSetting.device.deviceId, name: ctrl.mcWidgetSetting.device.name };
        }, function (error) {});
    };

    ctrl.getChannels = function (deviceId, firstChannel) {
        ctrl.channelOptions = [];

        angular.forEach(ctrl.analogSettings, function (analogSetting) {
            if (parseInt(deviceId) === parseInt(analogSetting.deviceId)) {
                ctrl.channelOptions.push(analogSetting);
            }
        });

        ctrl.channelOptions.sort(function (a, b) {
            return parseFloat(a.channel) - parseFloat(b.channel);
        });

        if (firstChannel) {
            ctrl.channelSelectedOption = { channel: ctrl.channelOptions[0].channel, name: ctrl.channelOptions[0].name };
        } else {
            ctrl.channelSelectedOption = { channel: ctrl.mcWidgetSetting.analogOutputGauge.channel, name: ctrl.mcWidgetSetting.analogOutputGauge.name };
        }
    };

    ctrl.setOptions = function () {
        ctrl.chartTimeOptions = ctrl.mcWidgetSettingOptions.trendingChart;
        ctrl.chartTimeSelectedOption = { option: "Off" }; //{ option: ctrl.mcWidgetSetting.analogWidgetSetting.trendingChart };

        ctrl.heardTypeOptions = ctrl.mcWidgetSettingOptions.dateTimeFormat;
        ctrl.heardTypeSelectedOption = { id: ctrl.mcWidgetSetting.analogOutputWidgetSetting.dateTimeFormatId };

        ctrl.marksTypeOptions = ctrl.mcWidgetSettingOptions.tickMarks;
        ctrl.marksTypeSelectedOption = { id: ctrl.mcWidgetSetting.analogOutputWidgetSetting.tickMarksId };

        ctrl.themeOptions = ctrl.mcWidgetSettingOptions.theme;
        ctrl.themeSelectedOption = { id: ctrl.mcWidgetSetting.analogOutputWidgetSetting.themeId };

        ctrl.sizeOptions = ctrl.mcWidgetSettingOptions.size;
        ctrl.sizeSelectedOption = { id: ctrl.mcWidgetSetting.analogOutputWidgetSetting.sizeId };

        ctrl.lowAlarmColor = ctrl.mcWidgetSetting.analogOutputWidgetSetting.lowAlarmColor;
        ctrl.normalColor = ctrl.mcWidgetSetting.analogOutputWidgetSetting.normalColor;
        ctrl.highAlarmColor = ctrl.mcWidgetSetting.analogOutputWidgetSetting.highAlarmColor;
        ctrl.validateColors();
    };

    ctrl.validateColors = function (_dataChanged) {
        if (ctrl.lowAlarmColor.length !== 7 || ctrl.lowAlarmColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidLowAlarmColor = true;
        } else {
            ctrl.invalidLowAlarmColor = false;
        }
        if (ctrl.normalColor.length !== 7 || ctrl.normalColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidNormalColor = true;
        } else {
            ctrl.invalidNormalColor = false;
        }
        if (ctrl.highAlarmColor.length !== 7 || ctrl.highAlarmColor.charAt(0) !== "#") {
            ctrl.invalidColor = true;
            ctrl.invalidHighAlarmColor = true;
        } else {
            ctrl.invalidHighAlarmColor = false;
        }

        ctrl.invalidColor = ctrl.invalidLowAlarmColor || ctrl.invalidNormalColor || ctrl.invalidHighAlarmColor ? true : false;

        if (_dataChanged && !ctrl.invalidColor) {
            ctrl.updateDisplayOptions({
                settingOptions: {
                    colorOption: {
                        low: ctrl.lowAlarmColor,
                        normal: ctrl.normalColor,
                        high: ctrl.highAlarmColor
                    }
                }
            });
        }
    };

    ctrl.showTab = function (parm) {
        ctrl.clearModel();
        var element = $element.find(".w_tabbox");
        ctrl.mcWidgetsSharedFactory.showTab(parm, element, ctrl);
    };

    ctrl.translateOptions = function () {
        ctrl.themeOptions.forEach(function (option) {
            return option.name = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.sizeOptions.forEach(function (option) {
            return option.description = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.heardTypeOptions.forEach(function (option) {
            return option.type = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.marksTypeOptions.forEach(function (option) {
            return option.state = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
        ctrl.chartTimeOptions.forEach(function (option) {
            return option.option = ctrl.mcWidgetsSharedFactory.runTranslator(option.languageTag, ctrl.translation);
        });
    };

    var _onUpdatePreferencesLanguage = $rootScope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.translateOptions();
    });

    $scope.$on("$destroy", function () {
        _onUpdatePreferencesLanguage();
    });
}

McWidgetOutputSettingController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', '$interval', '$compile', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'analogOutputWidgetService', 'analogWidgetService', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-output-setting').component('mcWidgetOutputSetting', {
    controller: McWidgetOutputSettingController,
    templateUrl: 'ui/mcwidgetoutputsetting/mcwidget-output-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        changeDisplayOptions: '&'
    }
});
'use strict';

function McWidgetDisplayFactory(HOST, $http) {

    // instantiate our initial object
    var McWidgetDisplay = function McWidgetDisplay(customerId, deviceId, timeZone) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
    };

    McWidgetDisplay.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/Analog/Gauge' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetDisplay.prototype.getDeviceState = function () {
        var self = this;
        return $http.get(HOST + '/api/DeviceState' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetDisplay.prototype.getWidgetData = function (channel) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McWidgetDisplay;
}

McWidgetDisplayFactory.$inject = ['HOST', '$http'];

angular.module('mc.widget-display').factory('McWidgetDisplayFactory', McWidgetDisplayFactory);
"use strict";

function McWidgetDisplayController($, $timeout, $rootScope, $scope, $element, McWidgetDisplayFactory, $compile, websocketService, toaster, datetimeService, sharedSetupService, McAnalogGaugeFactory, authenticationService, openViewService, translationService, PopupFactory, McWidgetsSharedFactory, $http, HOST, tabButtonGaugeService) {

    var ctrl = this;
    var chart = void 0;
    var tmpInit = true;

    var deviceStateEnum = {
        Ok: 1,
        Alarm: 2,
        Offline: 3,
        Service: 4,
        Disabled: 5
    };

    var getState = function getState(state) {
        //Options: AllNormal, Alarm, Alert, Service, CommFail
        switch (state) {
            case deviceStateEnum.Ok:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
            case deviceStateEnum.Disabled:
                if (ctrl.analogType !== "Lake Level") {
                    return "AllNormal";
                } else {
                    return "Disabled";
                }
            case deviceStateEnum.Offline:
                //device.CommsFault
                ctrl.orbitTitle = ctrl.translation.text.COMM_FAIL;
                return "CommFail";
            case deviceStateEnum.Service:
                ctrl.orbitTitle = ctrl.translation.text.SERVICE_MODE;
                return "Service";
            case deviceStateEnum.Alarm:
                ctrl.orbitTitle = null; //ctrl.translation.text.ALARM;
                return "Alarm";
            default:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
        }
    };

    var getView = function getView(state) {
        switch (state) {
            //case deviceStateEnum.Service:
            //    return "RTU Configuration"; //"Service";
            //case deviceStateEnum.Alarm:
            //    return "Dashboard"; //"Alarm";
            default:
                return "Dashboard"; //"AllNormal";
        }
    };

    ctrl.$onInit = function () {
        ctrl.alerts = [];
        ctrl.plotlineTypes = [];
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.langId = ctrl.accountInfo.preferenceUser.i18nCode === 'fr' ? ctrl.accountInfo.preferenceUser.i18nCode : 'en';
        ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
        // TODO: If we ever add support for additional languages in the DB this will need to be updated as well.
        ctrl.supportedLanguages = ['en', 'fr'];
        ctrl.descriptionFields = ['lowRestore', 'highRestore', 'lowFault', 'highFault'];
        if (angular.isUndefined(ctrl.analogType)) ctrl.analogType = "Single Needle Gauge";
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.svgAttributsInitialization();
        ctrl.loadingFinished = false;

        ctrl.lastExecution = 0;
        ctrl.throttleTime = 1000;
    };

    ctrl.pwMouseEnter = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.getTooltip(ctrl.widgetSetting.device.deviceId, event, 20);
    };

    ctrl.pwMouseLeave = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.$onChanges = function (changes) {
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            tmpInit = true;
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.buildWidget(changes.widgetSetting.currentValue);
            _registerTabButton(changes.widgetSetting.currentValue);
        }
    };

    ctrl.svgAttributsInitialization = function () {
        //Standpipe Storage Tank
        ctrl.standpipeHighAlarm = 1;
        ctrl.standpipeHighRestore = 1;
        ctrl.standpipeLowRestore = 1;
        ctrl.standpipeLowAlarm = 1;
        ctrl.standpipeHighAlarmMarker = 1;
        ctrl.standpipeHighRestoreMarker = 1;
        ctrl.standpipeLowRestoreMarker = 1;
        ctrl.standpipeLowAlarmMarker = 1;
        ctrl.standpipeWaterBodyY = 1;
        ctrl.standpipeWaterBodyHeight = 1;

        //Hydro Pneumatic Tank
        ctrl.hydroLowAlarm = 1;
        ctrl.hydroLowRestore = 1;
        ctrl.hydroHighRestore = 1;
        ctrl.hydroHighAlarm = 1;
        ctrl.hydroHighAlarmMarker = 1;
        ctrl.hydroHighRestoreMarker = 1;
        ctrl.hydroLowRestoreMarker = 1;
        ctrl.hydroLowAlarmMarker = 1;
        ctrl.hydroWaterBodyY = 1;
        ctrl.hydroWaterBodyHeight = 1;

        //Elevated Water Tank
        ctrl.elevatedLowAlarm = 1;
        ctrl.elevatedLowRestore = 1;
        ctrl.elevatedHighRestore = 1;
        ctrl.elevatedHighAlarm = 1;
        ctrl.elevatedHighAlarmMarker = 1;
        ctrl.elevatedHighRestoreMarker = 1;
        ctrl.elevatedLowRestoreMarker = 1;
        ctrl.elevatedLowAlarmMarker = 1;
        ctrl.elevatedWaterBodyPoints = "390.4, 152.9 392.2, 310.8 219.1, 310.5 219.6, 152.9 		";

        //Lake Level 
        ctrl.lakeWaterBodyHeight = 323.2;
        ctrl.lakeDepthY = 214.1;
        ctrl.oldLakeDepthY = 214.1;

        //Staff Gauge
        ctrl.staffGaugeWaterBodyHeight = 40;
        ctrl.staffGaugeY = 475.5;
    };

    ctrl.calc_StaffGauge_Water = function () {
        if (ctrl.analogType !== "Staff Gauge") return;

        var currentWaterLevel = ctrl.widgetSetting.analogGauge.latestData < 0 ? 0 : ctrl.widgetSetting.analogGauge.latestData;
        ctrl.staffGaugeY = ctrl.calculateValueY(currentWaterLevel, ctrl.analogType);

        //set staffGaugeY to fixed value if current reading is outside of analog maximum and minimum setting
        if (ctrl.widgetSetting.analogGauge.latestData > ctrl.getGaugeMax()) ctrl.staffGaugeY = 19.3;
        if (ctrl.widgetSetting.analogGauge.latestData < ctrl.getGaugeMin()) ctrl.staffGaugeY = 498.3;

        ctrl.staffGaugeWaterBodyHeight = 40 + 475.5 - ctrl.staffGaugeY;

        var w_lowFault = ctrl.widgetSetting.analogGauge.lowAlarm < 0 ? 0 : ctrl.widgetSetting.analogGauge.lowAlarm,
            w_highFault = ctrl.widgetSetting.analogGauge.highAlarm < 0 ? 0 : ctrl.widgetSetting.analogGauge.highAlarm,
            w_lowRestore = ctrl.widgetSetting.analogGauge.lowRestore < 0 ? 0 : ctrl.widgetSetting.analogGauge.lowRestore,
            w_highRestore = ctrl.widgetSetting.analogGauge.highRestore < 0 ? 0 : ctrl.widgetSetting.analogGauge.highRestore;

        ctrl.lowFaultY = ctrl.calculateValueY(w_lowFault, ctrl.analogType);
        ctrl.lowRestoreY = ctrl.calculateValueY(w_lowRestore, ctrl.analogType);
        ctrl.highRestoreY = ctrl.calculateValueY(w_highRestore, ctrl.analogType);
        ctrl.highFaultY = ctrl.calculateValueY(w_highFault, ctrl.analogType);

        ctrl.filteringThresholdsDescriptions();
        if (ctrl.plotlineTypes.length == 0) {
            $http.get(HOST + "/api/LevelReference/GetPlotlineTypes?customerId=" + ctrl.accountInfo.customerId).then(function (resp) {
                ctrl.plotlineTypes = resp.data;
                displayLevelReferences();
            });
        } else {
            displayLevelReferences();
        }
        // 2 equally spaced markers between maxVal and minVal
        ctrl.analogGaugeRange = ctrl.getGaugeMax() - ctrl.getGaugeMin();
        ctrl.firstMarker = ctrl.getGaugeMax() - ctrl.analogGaugeRange * 1 / 3;
        ctrl.secondMarker = ctrl.getGaugeMax() - ctrl.analogGaugeRange * 2 / 3;
    };

    ctrl.calc_LakeLevel_Thresholds = function () {
        if (ctrl.analogType !== "Lake Level") return;

        var currentLakeDepth = ctrl.widgetSetting.analogGauge.latestData < 0 ? 0 : ctrl.widgetSetting.analogGauge.latestData;
        ctrl.lakeDepthY = ctrl.calculateValueY(currentLakeDepth, ctrl.analogType);
        //when water is below a certain level, we need to adjust the height of the water body
        if (ctrl.lakeDepthY >= 214.2) {
            ctrl.lakeWaterBodyHeight = 323.2 - (ctrl.lakeDepthY - 214.2);
        }

        var w_lowFault = ctrl.widgetSetting.analogGauge.lowAlarm < 0 ? 0 : ctrl.widgetSetting.analogGauge.lowAlarm,
            w_highFault = ctrl.widgetSetting.analogGauge.highAlarm < 0 ? 0 : ctrl.widgetSetting.analogGauge.highAlarm,
            w_lowRestore = ctrl.widgetSetting.analogGauge.lowRestore < 0 ? 0 : ctrl.widgetSetting.analogGauge.lowRestore,
            w_highRestore = ctrl.widgetSetting.analogGauge.highRestore < 0 ? 0 : ctrl.widgetSetting.analogGauge.highRestore;

        ctrl.lowFaultY = ctrl.calculateValueY(w_lowFault, ctrl.analogType);
        ctrl.lowRestoreY = ctrl.calculateValueY(w_lowRestore, ctrl.analogType);
        ctrl.highRestoreY = ctrl.calculateValueY(w_highRestore, ctrl.analogType);
        ctrl.highFaultY = ctrl.calculateValueY(w_highFault, ctrl.analogType);

        ctrl.filteringThresholdsDescriptions();
        if (ctrl.plotlineTypes.length == 0) {
            $http.get(HOST + "/api/LevelReference/GetPlotlineTypes?customerId=" + ctrl.accountInfo.customerId).then(function (resp) {
                ctrl.plotlineTypes = resp.data;
                displayLevelReferences();
            });
        } else {
            displayLevelReferences();
        }
        //_addAnimation();
    };

    ctrl.calculateValueY = function (currentValue, analogType) {
        var totalDepth = ctrl.getGaugeMax() - ctrl.getGaugeMin();
        var bottom = 0;
        var top = 0;
        if (analogType == "Lake Level") {
            bottom = 385.2;
            top = 117.9;
        } else {
            //bottom = 485.1;
            //top = 75.2;
            bottom = 475.5;
            top = 66.6;
        }
        //current reading is the abs difference between current value and minimum value from analog setting
        var currentReading = currentValue - ctrl.getGaugeMin();
        return bottom - currentReading / totalDepth * (bottom - top);
    };

    var displayLevelReferences = function displayLevelReferences() {
        for (var i = 0; i < ctrl.widgetSetting.levelReferences.length; i++) {
            var newY = ctrl.calculateValueY(ctrl.widgetSetting.levelReferences[i].referenceValue, ctrl.analogType);
            ctrl.widgetSetting.levelReferences[i].referenceValueY = newY;
            ctrl.widgetSetting.levelReferences[i].ngAttrD = ctrl.analogType == "Lake Level" ? "M 420 " + newY + " L 600 " + newY : "M 57 " + newY + " L 152 " + newY;
            //ctrl.widgetSetting.levelReferences[i].ngAttrD = "M 420 " + newY + " L 600 " + newY;
            ctrl.widgetSetting.levelReferences[i].strokeDasharray = ctrl.plotlineTypes[ctrl.widgetSetting.levelReferences[i].plotLineTypeID - 1].strokeDasharray;
        }
    };

    var _addAnimation = function _addAnimation() {
        document.getElementById("lakeWaterAnimation").beginElement();
        //ctrl.oldLakeDepthY = ctrl.lakeDepthY;
    };

    ctrl.filteringThresholdsDescriptions = function () {
        ctrl.supportedLanguages.forEach(function (lang) {
            ctrl.descriptionFields.forEach(function (field) {
                if (ctrl.widgetSetting.analogGauge.analogThresholdDescriptions[lang][field] !== null) ctrl.widgetSetting.analogGauge.analogThresholdDescriptions[lang][field] = ctrl.widgetSetting.analogGauge.analogThresholdDescriptions[lang][field].replace(/##1|\(##1\)/g, '').trim();
            });
        });
        ctrl.widgetSetting.analogGauge.highAlarmDescription = ctrl.widgetSetting.analogGauge.analogThresholdDescriptions[ctrl.langId]['highFault'];
        ctrl.widgetSetting.analogGauge.highRestoreDescription = ctrl.widgetSetting.analogGauge.analogThresholdDescriptions[ctrl.langId]['highRestore'];
        ctrl.widgetSetting.analogGauge.lowRestoreDescription = ctrl.widgetSetting.analogGauge.analogThresholdDescriptions[ctrl.langId]['lowRestore'];
        ctrl.widgetSetting.analogGauge.lowAlarmDescription = ctrl.widgetSetting.analogGauge.analogThresholdDescriptions[ctrl.langId]['lowFault'];

        ctrl.widgetSetting.analogGauge.highAlarmDescription = ctrl.trimThresholdsDescriptions(ctrl.widgetSetting.analogGauge.highAlarmDescription);
        ctrl.widgetSetting.analogGauge.highRestoreDescription = ctrl.trimThresholdsDescriptions(ctrl.widgetSetting.analogGauge.highRestoreDescription);
        ctrl.widgetSetting.analogGauge.lowRestoreDescription = ctrl.trimThresholdsDescriptions(ctrl.widgetSetting.analogGauge.lowRestoreDescription);
        ctrl.widgetSetting.analogGauge.lowAlarmDescription = ctrl.trimThresholdsDescriptions(ctrl.widgetSetting.analogGauge.lowAlarmDescription);
    };

    ctrl.trimThresholdsDescriptions = function (description) {
        if (description.length <= 25) return description;
        return description.substr(0, 25).concat("...");
    };

    ctrl.getWaterColor = function () {
        if (ctrl.analogType == "Single Needle Gauge" || ctrl.analogType == "Lake Level") return;
        var w_lowFault = ctrl.widgetSetting.analogGauge.lowAlarm,
            w_highFault = ctrl.widgetSetting.analogGauge.highAlarm,
            w_lowRestore = ctrl.widgetSetting.analogGauge.lowRestore,
            w_highRestore = ctrl.widgetSetting.analogGauge.highRestore,
            w_latestReading = ctrl.widgetSetting.analogGauge.latestData,
            w_lowcolor = ctrl.widgetSetting.analogWidgetSetting.lowAlarmColor,
            w_normalcolor = ctrl.widgetSetting.analogWidgetSetting.normalColor,
            w_highcolor = ctrl.widgetSetting.analogWidgetSetting.highAlarmColor;
        ctrl.lowRestoreColor = darken(w_lowcolor, 20);
        ctrl.highRestoreColor = darken(w_highcolor, 20);
        if (getState(ctrl.widgetSetting.deviceUnitState.state) === 'CommFail') {
            w_lowcolor = '#646464';
            w_normalcolor = '#7d7d7d';
            w_highcolor = '#969696';
        }
        if (w_latestReading <= w_lowFault) {
            ctrl.waterBodyColor = w_lowcolor;
        } else if (w_lowFault < w_latestReading && w_latestReading < w_highFault) {
            ctrl.waterBodyColor = w_normalcolor;
        } else {
            ctrl.waterBodyColor = w_highcolor;
        }

        //if all 4 thresholds are 0, we will display tank color with selected normal color
        if (w_lowFault == 0 && w_lowRestore == 0 && w_highFault == 0 && w_highRestore == 0) {
            ctrl.waterBodyColor = w_normalcolor;
        }
        //handles the rare situation where high alarm and high restore is not set
        else if (w_highFault == 0 && w_highRestore == 0) {
                if (w_latestReading <= w_lowFault) {
                    ctrl.waterBodyColor = w_lowcolor;
                } else {
                    ctrl.waterBodyColor = w_normalcolor;
                }
            }

        ctrl.waterTankColor = lighten(ctrl.waterBodyColor, 50);

        switch (ctrl.analogType) {
            case "Elevated Water Tank":
                ctrl.elevatedWaterBody_Style = { "fill": ctrl.waterBodyColor };
                ctrl.elevatedWaterTank_Style = { "fill": ctrl.waterTankColor };
                break;
            case "Standpipe Storage Tank":
                ctrl.standpipeWaterBody_Style = { "fill": ctrl.waterBodyColor };
                ctrl.standpipeWaterTank_Style = { "fill": ctrl.waterTankColor };
                break;
            case "Hydro Pneumatic Tank":
                ctrl.hydroWaterBody_Style = { "fill": ctrl.waterBodyColor };
                ctrl.hydroWaterTank_Style = { "fill": ctrl.waterTankColor };
                break;
        }
        ctrl.waterBody_Style = { "fill": ctrl.waterBodyColor };
        ctrl.waterTank_Style = { "fill": ctrl.waterTankColor };
    };

    ctrl.buildWidget = function (widgetData) {

        if (ctrl.mcWidgetsSharedFactory.checkForEmptyObject(widgetData.analogGauge)) {
            var errormsg = ctrl.translation.text.NOT_SETUP;
            ctrl.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            return;
        } else {
            ctrl.alerts = [];
        }

        ctrl.widgetSetting = widgetData;

        ctrl.w_BorderWidth = 2; // Set the inside solid border of the HUD
        ctrl.w_BorderPadding = 5; // Set the outside opaque border outline

        ctrl.hudText = getState(ctrl.widgetSetting.deviceUnitState.state); // Options: AllNormal, Alarm, Alert, Service, CommFail

        ctrl.show_chartdata = "No";

        ctrl.fnMarksTypeOptions(ctrl.widgetSetting.analogWidgetSetting.tickMarksId);
        ctrl.fnHeardTypeOptions(ctrl.widgetSetting.analogWidgetSetting.dateTimeFormat);
        ctrl.setSize(ctrl.widgetSetting.setting.defaultSetting ? ctrl.widgetSetting.defaultSetting.sizeId : ctrl.widgetSetting.analogWidgetSetting.sizeId);
        ctrl.setMarkerTextStyle();

        ctrl.buildMainClass();

        ctrl.loadingInProgress = false;

        ctrl.unRegisterListener();
        ctrl.registerListener();

        ctrl.noDecimals = sharedSetupService.getNumberOfDecimals(ctrl.getGaugeMax(), ctrl.getGaugeMin());

        ctrl.annimate_Needle(ctrl.getGaugeMin(), ctrl.getGaugeMax(), ctrl.widgetSetting.analogGauge.latestData);
        ctrl.create_Markers(ctrl.getGaugeMin(), ctrl.widgetSetting.analogGauge.lowAlarm, ctrl.widgetSetting.analogGauge.lowRestore, ctrl.widgetSetting.analogGauge.highAlarm, ctrl.widgetSetting.analogGauge.highRestore, ctrl.widgetSetting.analogGauge.highHighAlarm, ctrl.widgetSetting.analogGauge.highHighRestore, ctrl.getGaugeMax());
        ctrl.DisplayTimestamp(ctrl.widgetSetting.analogGauge.localDateTime, Date.now(), ctrl.widgetSetting.analogWidgetSetting.dateTimeFormat);
        if (ctrl.loadingFinished) {
            ctrl.buildTachStrokeDash();
            ctrl.getWaterColor();
            ctrl.calc_WaterLevel();
            ctrl.calc_LakeLevel_Thresholds();
            ctrl.calc_StaffGauge_Water();
        }
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);
        ctrl.resize_HUDBoxes();

        if (ctrl.widgetSetting.setting.displaySettingOn) {
            var newScope = $scope;
            //<mc-widget-setting widget-setting="$ctrl.widgetSetting" ng-if="$ctrl.widgetSetting.displaySetting" change-theme="$ctrl.fnThemeOptions(themeName)" change-heard-type="$ctrl.fnHeardTypeOptions(heardType)"></mc-widget-setting>
            var html = '<mc-widget-setting widget-setting="$ctrl.widgetSetting" ng-if="$ctrl.widgetSetting.setting.displaySetting" change-display-options="$ctrl.fnChangeDisplayOptions(settingOptions)"></mc-widget-setting>';
            var element = $element.find('.component-setting');
            if (element.is(':empty')) {
                element.append($compile(html)(newScope));
            }
        }

        ctrl.loadingInProgress = false;
    };

    ctrl.getData = function (deviceId, channel, openSetting, isFromWidget) {

        var _analogGauge = new McAnalogGaugeFactory(ctrl.accountInfo.customerId, deviceId, ctrl.accountInfo.timeZone, 1, ctrl.mcWidgetsSharedFactory.getWidgetIdByAnalogType(ctrl.analogType), channel, isFromWidget); //Category: Analog, Widget: 'Single Needle Gauge'

        _analogGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            var device = _analogGauge.list.device;
            var deviceUnitState = _analogGauge.list.deviceUnitState;
            var defaultSetting = _analogGauge.list.defaultSetting;

            // if _analogGauge.list.analogGauge is not available, set default values to empty object
            var analogGauge = _analogGauge.list.analogGauge.length == 0 ? {} : _analogGauge.list.analogGauge[0].analogGauge;
            var analogWidgetSetting = _analogGauge.list.analogGauge.length == 0 ? {} : _analogGauge.list.analogGauge[0].analogWidgetSetting;
            var levelReferences = _analogGauge.list.analogGauge.length == 0 ? {} : _analogGauge.list.analogGauge[0].levelReferences;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.widgetSetting.setting.displaySetting,
                displaySettingOn: ctrl.widgetSetting.setting.displaySettingOn,
                defaultSetting: ctrl.widgetSetting.setting.defaultSetting
            };
            ctrl.analogGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                defaultSetting: defaultSetting,
                analogGauge: analogGauge,
                analogWidgetSetting: analogWidgetSetting,
                setting: setting,
                levelReferences: levelReferences
            };

            if (isFromWidget) {
                ctrl.analogType = ctrl.mcWidgetsSharedFactory.getAnalogTypeByWidgetId(ctrl.analogGauge.analogGauge.widgetId);
                if (ctrl.analogType !== "Lake Level") ctrl.loadingFinished = false;
            }

            ctrl.buildWidget(ctrl.analogGauge);
            ctrl.fnSizeOptions(ctrl.analogGauge.analogWidgetSetting.sizeId);
            //ctrl.fnMakeFitTextWork();
            if (!angular.isUndefined(openSetting)) {
                $timeout(function () {
                    ctrl.mouseOverHUD();
                    ctrl.editSetting();
                }, 0);
            }
            ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.analogGauge.device.deviceId, name: ctrl.analogGauge.device.name, serialNumber: ctrl.analogGauge.device.serialNumber, channel: ctrl.analogGauge.analogGauge.channel, channelDescription: Object.keys(ctrl.analogGauge.analogGauge).length !== 0 ? ctrl.analogGauge.analogGauge.name : ctrl.translation.text.NOT_SETUP } });
        }, function (error) {
            console.log(error);
            var now = Date.now();
            if (now - ctrl.lastExecution < ctrl.throttleTime) {
                return;
            }
            toaster.pop('warning', ctrl.translation.text.ANALOG + " " + ctrl.translation.text.NOT_SETUP, 'Please select another one');
            ctrl.loadingInProgress = false;
            ctrl.lastExecution = now;
        });
    };

    ctrl.getDeviceState = function () {

        var _deviceState = new McWidgetDisplayFactory(ctrl.accountInfo.customerId, ctrl.widgetSetting.device.deviceId, ctrl.accountInfo.timeZone);

        _deviceState.getDeviceState().then(function () {
            ctrl.loadingInProgress = false;
            ctrl.fnRtuStatusOptions(getState(_deviceState.list.state));
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.fnMakeFitTextWork = function () {
        // $compile($element.find(".mc-fittext"))($scope);
    };

    ctrl.fnThemeOptions = function (themeName) {
        ctrl.widgetSetting.analogWidgetSetting.theme = themeName;
        ctrl.buildMainClass();
    };

    ctrl.fnHeardTypeOptions = function (heardType) {
        ctrl.widgetSetting.analogWidgetSetting.dateTimeFormat = heardType;
        ctrl.DisplayTimestamp(ctrl.widgetSetting.analogGauge.localDateTime, ctrl.heartbeatDateTime, ctrl.widgetSetting.analogWidgetSetting.dateTimeFormat);
    };

    ctrl.fnMarksTypeOptions = function (marksTypeId) {

        ctrl.widgetSetting.analogWidgetSetting.tickMarksId = marksTypeId;

        var Markers_Style_On = { 'opacity': '100%', 'display': 'block' };
        var Markers_Style_Off = { 'opacity': '0%', 'display': 'none' };

        if (marksTypeId === 1) {
            ctrl.Markers_Style = Markers_Style_On;
        } //"Show"
        if (marksTypeId === 2) {
            ctrl.Markers_Style = Markers_Style_Off;
        } //"Hide"
        if (marksTypeId === 3) {
            ctrl.Markers_Style = Markers_Style_Off;
        } //"Hover"
    };

    ctrl.fnMarksTypeOptionsHover = function (marksTypeId) {

        if (marksTypeId !== 3) return;
        ctrl.Markers_Style = { 'opacity': '100%', 'display': 'block' };
    };

    ctrl.fnMarksTypeOptionsLeave = function (marksTypeId) {

        if (marksTypeId !== 3) return;
        ctrl.Markers_Style = { 'opacity': '0%', 'display': 'none' };
    };

    ctrl.fnSizeOptions = function (sizeId, openSetting) {

        if (!ctrl.widgetSetting.setting.displaySetting) return;
        ctrl.widgetSetting.analogWidgetSetting.sizeId = sizeId;
        ctrl.setSize(sizeId);

        ctrl.setMarkerTextStyle();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.dialog('widget').css("width", ctrl.svgSizeH + "px");
            ctrl.popup.dialog("option", "width", ctrl.svgSizeH);

            ctrl.popup.dialog('widget').css("height", ctrl.svgSizeH + 40 + "px");
            ctrl.popup.dialog("option", "height", ctrl.svgSizeH + 40);
        }
        ctrl.closeSetting();
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);

        if (!angular.isUndefined(openSetting)) {
            $timeout(function () {
                ctrl.mouseOverHUD();
                ctrl.editSetting();
            }, 0);
        }
    };

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 1);
        if (ctrl.analogType == "Staff Gauge") {
            ctrl.svgSizeW = 0.73 * tmpSize.width;
            ctrl.svgSizeH = 0.73 * tmpSize.height;
        } else {
            ctrl.svgSizeW = tmpSize.width;
            ctrl.svgSizeH = tmpSize.height;
        }
    };

    ctrl.setMarkerTextStyle = function () {
        ctrl.markerTextStyle = { 'font-size': ctrl.svgSizeH / 290 + 'em' };
    };

    ctrl.fnColorOptions = function (colorOption) {
        ctrl.widgetSetting.analogWidgetSetting.lowAlarmColor = colorOption.low;
        ctrl.widgetSetting.analogWidgetSetting.normalColor = colorOption.normal;
        ctrl.widgetSetting.analogWidgetSetting.highAlarmColor = colorOption.high;
        ctrl.widgetSetting.analogWidgetSetting.highHighAlarmColor = colorOption.highHigh;
        ctrl.buildTachStrokeDash();
        ctrl.getWaterColor();
        //ctrl.closeSetting();
    };

    ctrl.fnRtuStatusOptions = function (rtuStatus) {
        ctrl.buildMainClass();
        ctrl.buildTachStrokeDash();
        ctrl.hudText = rtuStatus;
    };

    ctrl.fnChangeDisplayOptions = function (parSettingOptions) {
        if (!angular.isUndefined(parSettingOptions.themeOption)) {
            ctrl.fnThemeOptions(parSettingOptions.themeOption.name);
        }
        if (!angular.isUndefined(parSettingOptions.heardTypeOption)) {
            ctrl.fnHeardTypeOptions(parSettingOptions.heardTypeOption.type);
        }
        if (!angular.isUndefined(parSettingOptions.marksType)) {
            ctrl.fnMarksTypeOptions(parSettingOptions.marksType.id);
        }
        if (!angular.isUndefined(parSettingOptions.sizeOption)) {
            ctrl.fnSizeOptions(parSettingOptions.sizeOption.id, true);
        }
        if (!angular.isUndefined(parSettingOptions.colorOption)) {
            ctrl.fnColorOptions(parSettingOptions.colorOption);
        }
        if (!angular.isUndefined(parSettingOptions.rtuOption)) {
            ctrl.getData(parSettingOptions.rtuOption.deviceId, parSettingOptions.rtuOption.channel, true, true);
        }
    };

    ctrl.editSetting = function (event) {
        ctrl.mcWidgetsSharedFactory.editSetting($element, event, ctrl);
    };

    ctrl.closeSetting = function () {
        ctrl.mcWidgetsSharedFactory.closeSetting($element, ctrl);
    };

    ctrl.mouseOverHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOver;
            ctrl.set_HUDItemHeights('Yes');
        }
    };
    ctrl.mouseOffHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOff;
            ctrl.set_HUDItemHeights('No');
        }
    };

    ctrl.getGaugeMin = function () {
        var gaugeMin = Number(ctrl.widgetSetting.analogWidgetSetting.gaugeMinValue);
        // const gaugeMax = ctrl.widgetSetting.analogWidgetSetting.gaugeMaxValue;

        return gaugeMin == null || gaugeMin === 0 ? ctrl.widgetSetting.analogGauge.minVal : gaugeMin;
    };

    ctrl.getGaugeMax = function () {
        // const gaugeMin = ctrl.widgetSetting.analogWidgetSetting.gaugeMinValue;
        var gaugeMax = Number(ctrl.widgetSetting.analogWidgetSetting.gaugeMaxValue);

        return gaugeMax == null || gaugeMax === 0 ? ctrl.widgetSetting.analogGauge.maxVal : gaugeMax;
    };

    ctrl.annimate_Needle = function (w_minValue, w_maxValue, w_latestData) {

        // Get the percentage value of the diferance between min and max
        var pct_latestData = ctrl.calc_GuagePCT(w_minValue, w_maxValue, w_latestData);
        ctrl.latestData_Angle = ctrl.rotateDEG(pct_latestData);

        if (tmpInit) {
            ctrl.NeedleStyle_NoData = { 'transform': 'rotate(180deg)' };
            ctrl.NeedleStyle_LiveData = { 'transform': 'rotate(' + ctrl.latestData_Angle + 'deg)' };
            tmpInit = false;
        } else {
            ctrl.NeedleStyle_NoData = { 'transform': 'rotate(180deg)', 'transition': 'all 1.5s ease-in-out' };
            ctrl.NeedleStyle_LiveData = { 'transform': 'rotate(' + ctrl.latestData_Angle + 'deg)', 'transition': 'all 1.5s ease-in-out' };
        }

        if (w_minValue < w_maxValue) {
            if (w_latestData == "" || w_latestData < w_minValue || w_latestData > w_maxValue) {

                ctrl.Needle_Style = ctrl.NeedleStyle_NoData;
            } else {
                ctrl.Needle_Style = ctrl.NeedleStyle_LiveData;
            }
        } else {
            if (w_latestData == "" || w_latestData > w_minValue || w_latestData < w_maxValue) {
                ctrl.Needle_Style = ctrl.NeedleStyle_NoData;
            } else {
                ctrl.Needle_Style = ctrl.NeedleStyle_LiveData;
            }
        }
    };
    ctrl.create_Markers = function (m_minValue, m_lowfault, m_lowrestore, m_highfault, m_highrestore, m_highHighfault, m_highHighrestore, m_maxValue) {
        var gaugeMin = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : m_minValue;
        var gaugeMax = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : m_maxValue;


        // Which marker should be visible at given point of time
        var isVisible = function isVisible(value) {
            if (ctrl.getGaugeMin() < ctrl.getGaugeMax()) {
                return value !== 0 && value >= gaugeMin && value <= gaugeMax;
            } else {
                return value !== 0 && value <= gaugeMin && value >= gaugeMax;
            }
        };

        var getAngle = function getAngle(value) {
            var percent = ctrl.calc_GuagePCT(gaugeMin, gaugeMax, value);
            return ctrl.rotateDEG(percent);
        };

        var getStyle = function getStyle(angle) {
            return {
                transform: "rotate(" + angle + "deg)"
            };
        };

        // Marker Angles
        ctrl.minMarker_Angle = getAngle(gaugeMin);
        ctrl.lowfaultMarker_Angle = getAngle(m_lowfault);
        ctrl.lowrestoreMarker_Angle = getAngle(m_lowrestore);
        ctrl.highrestoreMarker_Angle = getAngle(m_highrestore);
        ctrl.highfaultMarker_Angle = getAngle(m_highfault);
        ctrl.highHighrestoreMarker_Angle = getAngle(m_highHighrestore);
        ctrl.highHighfaultMarker_Angle = getAngle(m_highHighfault);
        ctrl.maxMarker_Angle = getAngle(gaugeMax);

        // Marker Styles
        ctrl.minMarker_Style = getStyle(ctrl.minMarker_Angle);
        ctrl.lowfaultMarker_Style = getStyle(ctrl.lowfaultMarker_Angle);

        ctrl.lowrestoreMarker_Style = getStyle(ctrl.lowrestoreMarker_Angle);
        ctrl.highrestoreMarker_Style = getStyle(ctrl.highrestoreMarker_Angle);

        ctrl.highfaultMarker_Style = getStyle(ctrl.highfaultMarker_Angle);
        ctrl.highhighrestoreMarker_Style = getStyle(ctrl.highHighrestoreMarker_Angle);

        ctrl.highhighfaultMarker_Style = getStyle(ctrl.highHighfaultMarker_Angle);
        ctrl.maxMarker_Style = getStyle(ctrl.maxMarker_Angle);

        // Visibility
        ctrl.lowfaultMarker_AngleHide = !isVisible(m_lowfault);
        ctrl.lowrestoreMarker_AngleHide = !isVisible(m_lowrestore);
        ctrl.highrestoreMarker_AngleHide = !isVisible(m_highrestore);
        ctrl.highfaultMarker_AngleHide = !isVisible(m_highfault);

        ctrl.highhighrestoreMarker_AngleHide = !isVisible(m_highHighrestore);
        ctrl.highhighfaultMarker_AngleHide = !isVisible(m_highHighfault);

        // Ensure min/max markers are always visible
        ctrl.minMarker_AngleHide = false;
        ctrl.maxMarker_AngleHide = false;
    };

    ctrl.resize_HUD = function (w_svgSizeW, w_svgSizeH) {
        ctrl.mcWidgetsSharedFactory.resizeHud(w_svgSizeW, w_svgSizeH, ctrl, ctrl.setHudFont);
    };

    ctrl.setHudFont = function (w_svgSizeW) {
        //let displayOuputUnit = 
        ctrl.hudText_Style = { "font-size": ctrl.calc_HUDFont("hudText", 10, 30, 38, w_svgSizeW) + "px" };

        var latestData_Trim = Math.round(ctrl.widgetSetting.analogGauge.latestData.toString());
        var latestData_Length = latestData_Trim.toString().length + ctrl.noDecimals + 1;
        //console.log(latestData_Trim);
        //console.log(latestData_Length);
        var latestData_Cal = ctrl.calc_HUDFont("latestData", latestData_Length, 35, 85, w_svgSizeW);
        ctrl.latestData_Style = { "font-size": latestData_Cal + "px" };

        var unit_Cal = ctrl.calc_HUDFont("unit", ctrl.widgetSetting.analogGauge.unit.toString().length + 1, 15, 75, w_svgSizeW);
        var unit_Use = unit_Cal;

        if (latestData_Cal < unit_Cal) {
            unit_Use = latestData_Cal;
        }

        ctrl.unit_Style = { "font-size": unit_Use + "px" };

        ctrl.timestampDisplay_StyleAbsolute = { "font-size": ctrl.calc_HUDFont("StyleAbsolute", 10 + 1, 20, 30, w_svgSizeW) + "px" };
        ctrl.timestampDisplay_StyleElapsed = { "font-size": ctrl.calc_HUDFont("StyleElapsed", 6 + 1, 20, 30, w_svgSizeW) + "px" };
        //ctrl.calc_HUDFont(10, 6, 18, w_svgSizeW);

        ctrl.name_Style = { "font-size": ctrl.calc_HUDFont("nameText", 10, 20, 30, w_svgSizeW) + "px", "margin-left": ctrl.w_BorderWidth + ctrl.w_BorderPadding + "px", "margin-right": ctrl.w_BorderWidth + ctrl.w_BorderPadding + "px" };
        ctrl.channel_Style = { "font-size": ctrl.calc_HUDFont("channelText", 3, 40, 60, w_svgSizeW) + "px", "margin-left": ctrl.w_BorderWidth + ctrl.w_BorderPadding + "px", "margin-right": ctrl.w_BorderWidth + ctrl.w_BorderPadding + "px" };
        if (ctrl.analogType == "Lake Level") {
            ctrl.latestData_Style = { "font-size": latestData_Cal / 3 - 1 + "px", "white-space": "nowrap" };
        }
    };

    ctrl.calc_HUDFont = function (lbl, strLength, minFont, maxFont, svgSizeW) {

        //console.log(lbl + ": strLength :" + strLength);
        //console.log(lbl + ": ctrl.noDecimals :" + ctrl.noDecimals);

        var hudScaleFactor = svgSizeW / 600;
        //console.log(lbl + ": hudScaleFactor :" + hudScaleFactor);

        var scaled_minFont = Math.round(minFont * hudScaleFactor);
        //console.log(lbl + ": scaled_minFont :" +scaled_minFont);

        var scaled_maxFont = Math.round(maxFont * hudScaleFactor);
        //console.log(lbl + ": scaled_maxFont :" + scaled_maxFont);

        var widthSpaceAvailPX = ctrl.w_hudWidthPX - (ctrl.w_BorderWidth * 2 + ctrl.w_BorderPadding * 2 - 4);
        //console.log(lbl + ": widthSpaceAvailPX :" + widthSpaceAvailPX);

        var calc_FontSize = Math.round(widthSpaceAvailPX / strLength * 1.5);
        //console.log(lbl + ": calc_FontSize :" + calc_FontSize);

        var use_FontSize = calc_FontSize;
        if (calc_FontSize < scaled_minFont) {
            use_FontSize = scaled_minFont;
        }
        if (calc_FontSize > scaled_maxFont) {
            use_FontSize = scaled_maxFont;
        }

        //console.log(lbl + ": use_FontSize :" + use_FontSize);
        return use_FontSize;
    };

    ctrl.resize_HUDBoxes = function () {

        if (angular.isUndefined(ctrl.widgetSetting)) return;

        ctrl.lastHeardLabel = null;

        if (ctrl.widgetSetting.analogWidgetSetting.sizeId > 2) {
            ctrl.gaugeDataBorder_Style = { "padding": "5px" };
            ctrl.gaugeDataOverlay_Style = { "border-width": "2px" };
            ctrl.w_BorderPadding = 5;
            ctrl.w_BorderWidth = 2;

            ctrl.lastHeardLabel = ctrl.translation.text.LAST_HEARD + ":";
        }
        if (ctrl.widgetSetting.analogWidgetSetting.sizeId <= 2) {
            ctrl.gaugeDataBorder_Style = { "padding": "2px" };
            ctrl.gaugeDataOverlay_Style = { "border-width": "1px" };
            ctrl.w_BorderPadding = 2;
            ctrl.w_BorderWidth = 1;
        }
        if (ctrl.widgetSetting.analogWidgetSetting.sizeId <= 1) {
            ctrl.gaugeDataBorder_Style = { "padding": "0px" };
            ctrl.gaugeDataOverlay_Style = { "border-width": "01px" };
            ctrl.w_BorderPadding = 0;
            ctrl.w_BorderWidth = 0;
        }

        if (ctrl.analogType == "Staff Gauge") {
            if (!ctrl.widgetSetting.setting.displaySettingOn) {
                ctrl.gaugeDataBorder_Style.marginTop = '122px';
                ctrl.gaugeDataBorder_Style.marginLeft = '-4px';
            } else {
                if (ctrl.widgetSetting.analogWidgetSetting.sizeId == 1) {
                    ctrl.gaugeDataBorder_Style.marginTop = '80px';
                    ctrl.gaugeDataBorder_Style.marginLeft = '-2px';
                }
                if (ctrl.widgetSetting.analogWidgetSetting.sizeId == 2) {
                    ctrl.gaugeDataBorder_Style.marginTop = '122px';
                    ctrl.gaugeDataBorder_Style.marginLeft = '-4px';
                }
                if (ctrl.widgetSetting.analogWidgetSetting.sizeId == 3) {
                    ctrl.gaugeDataBorder_Style.marginTop = '185px';
                    ctrl.gaugeDataBorder_Style.marginLeft = '-8px';
                }
                if (ctrl.widgetSetting.analogWidgetSetting.sizeId == 4) {
                    ctrl.gaugeDataBorder_Style.marginTop = '238px';
                    ctrl.gaugeDataBorder_Style.marginLeft = '-10px';
                }
                if (ctrl.widgetSetting.analogWidgetSetting.sizeId == 5) {
                    ctrl.gaugeDataBorder_Style.marginTop = '315px';
                    ctrl.gaugeDataBorder_Style.marginLeft = '-12px';
                }
            }
        }

        // Setup Border and Outline
        // ------------------------------------------------------------------------------------------

        ctrl.HudPadding = ctrl.w_BorderWidth * 2 + ctrl.w_BorderPadding * 2; // total amount of spacing between outside HUD and inside HUD

        // ----------------------------------------------------------------------------

        ctrl.action_EditMode = 'No';

        // -- // (Stage) Give each Feature Box an AR (aspectratio) value, Give BttnBox a pixelvalue of ??. 
        // -- // (MouseOver) Set Override values for interaction events, Set a px value for BttnBox states.
        // -- // 
        // -- // 
        // -- // 

        ctrl.TitleBox_StageAR = 0 / 10; // Title
        ctrl.NumberBox_StageAR = 4 / 10; // Number
        ctrl.UnitBox_StageAR = 1 / 10; // Unit
        ctrl.AuxBox_StageAR = 0 / 10; // Chart
        ctrl.Aux2Box_StageAR = 2 / 10; // Last Heard

        ctrl.BttnBox_PX_StagePX = 25; // Edit Bttn

        ctrl.set_HUDItemHeights = function (isMouseOver) {

            if (isMouseOver === 'No') {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 4 / 10;
                ctrl.UnitBox_AR = 3 / 10;
                ctrl.AuxBox_AR = 0 / 10;
                ctrl.Aux2Box_AR = 0 / 10;
                ctrl.BttnBox_PX = 0;
            }
            if (isMouseOver === 'No' & ctrl.widgetSetting.analogWidgetSetting.sizeId <= 1) {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 4 / 10;
                ctrl.UnitBox_AR = 3 / 10;
                ctrl.AuxBox_AR = 0 / 10;
                ctrl.Aux2Box_AR = 0 / 10;
                ctrl.BttnBox_PX = 0;
            }

            if (isMouseOver === 'Yes' & ctrl.show_chartdata === 'No' & ctrl.widgetSetting.analogWidgetSetting.sizeId >= 3) {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 3 / 10;
                ctrl.UnitBox_AR = 2 / 10;
                ctrl.AuxBox_AR = 0 / 10;
                ctrl.Aux2Box_AR = 2 / 10;
                ctrl.BttnBox_PX = 25;
            }

            if (isMouseOver === 'Yes' & ctrl.show_chartdata === 'No' & ctrl.widgetSetting.analogWidgetSetting.sizeId <= 2) {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 3 / 10;
                ctrl.UnitBox_AR = 2 / 10;
                ctrl.AuxBox_AR = 0 / 10;
                ctrl.Aux2Box_AR = 0 / 10;
                ctrl.BttnBox_PX = 30;
            }

            if (isMouseOver === 'Yes' & ctrl.show_chartdata === 'No' & ctrl.widgetSetting.analogWidgetSetting.sizeId <= 1) {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 3 / 10;
                ctrl.UnitBox_AR = 2 / 10;
                ctrl.AuxBox_AR = 0 / 10;
                ctrl.Aux2Box_AR = 0 / 10;
                ctrl.BttnBox_PX = 20;
            }

            if (isMouseOver === 'Yes' & ctrl.show_chartdata === 'Yes') {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 0 / 10;
                ctrl.UnitBox_AR = 0 / 10;
                ctrl.AuxBox_AR = 6 / 10;
                ctrl.Aux2Box_AR = 2 / 10;
                ctrl.BttnBox_PX = 25;
            }

            var calc_w_hudAdjWidthPX = ctrl.w_hudWidthPX - ctrl.HudPadding; // 

            var calc_TitleBoxW_Height = ctrl.w_hudWidthPX * ctrl.TitleBox_AR;
            var calc_NumberBoxW_Height = ctrl.w_hudWidthPX * ctrl.NumberBox_AR;
            var calc_UnitBoxW_Height = ctrl.w_hudWidthPX * ctrl.UnitBox_AR;
            var calc_AuxBoxW_Height = ctrl.w_hudWidthPX * ctrl.AuxBox_AR;
            var calc_Aux2BoxW_Height = ctrl.w_hudWidthPX * ctrl.Aux2Box_AR;

            var calc_Aux2BoxW_Height_Default = calc_w_hudAdjWidthPX * ctrl.Aux2Box_StageAR;

            var calc_TotalBoxHeights = calc_TitleBoxW_Height + calc_NumberBoxW_Height + calc_UnitBoxW_Height + calc_AuxBoxW_Height + calc_Aux2BoxW_Height;

            var hudSpaceHeight_Default = ctrl.w_hudHeight_DefaultPX - ctrl.HudPadding - ctrl.BttnBox_PX;
            var hudSpaceHeight_Active = ctrl.w_hudHeight_ActivePX - ctrl.HudPadding - ctrl.BttnBox_PX;

            if (isMouseOver === 'No') {
                var calc_TotalBoxHeightFactorPane1 = hudSpaceHeight_Default / calc_TotalBoxHeights;
            }

            if (isMouseOver === 'Yes') {
                var calc_TotalBoxHeightFactorPane1 = hudSpaceHeight_Active / calc_TotalBoxHeights;
            }

            var print_TitleBoxW_Height = calc_TotalBoxHeightFactorPane1 * calc_TitleBoxW_Height;
            var print_NumberBoxW_Height = calc_TotalBoxHeightFactorPane1 * calc_NumberBoxW_Height;
            var print_UnitBoxW_Height = calc_TotalBoxHeightFactorPane1 * calc_UnitBoxW_Height;
            var print_AuxBoxW_Height = calc_TotalBoxHeightFactorPane1 * calc_AuxBoxW_Height;
            var print_Aux2BoxW_Height = calc_TotalBoxHeightFactorPane1 * calc_Aux2BoxW_Height;

            ctrl.w_TitleBoxW_Style = { "height": print_TitleBoxW_Height + "px" };
            ctrl.w_TitleBox_Style = { "height": calc_TitleBoxW_Height + "px", "margin-top": (print_TitleBoxW_Height - calc_TitleBoxW_Height) / 2 + "px" };

            ctrl.w_NumberBoxW_Style = { "height": print_NumberBoxW_Height + "px" };
            ctrl.w_NumberBox_Style = { "height": calc_NumberBoxW_Height + "px", "margin-top": (print_NumberBoxW_Height - calc_NumberBoxW_Height) / 2 + "px" };

            ctrl.w_UnitBoxW_Style = { "height": print_UnitBoxW_Height + "px" };
            ctrl.w_UnitBox_Style = { "height": calc_UnitBoxW_Height + "px", "margin-top": (print_UnitBoxW_Height - calc_UnitBoxW_Height) / 2 + "px" };

            ctrl.w_AuxBoxW_Style = { "height": 0 + "px" }; //need it back print_AuxBoxW_Height
            ctrl.w_AuxBox_Style = { "height": calc_AuxBoxW_Height + "px", "margin-top": (print_AuxBoxW_Height - calc_AuxBoxW_Height) / 2 + "px" };

            ctrl.w_Aux2BoxW_Style = { "height": print_AuxBoxW_Height + print_Aux2BoxW_Height + ctrl.BttnBox_PX + "px" }; //{ "height": (print_AuxBoxW_Height + print_Aux2BoxW_Height) + "px" };// remove it from here print_AuxBoxW_Height
            ctrl.w_Aux2Box_Style = {}; //{ "height": calc_Aux2BoxW_Height_Default + "px", "margin-top": ((print_Aux2BoxW_Height - calc_Aux2BoxW_Height) / 2) + "px" }};

            ctrl.w_BttnBoxW_Style = { "height": 0 }; // { "height": ctrl.BttnBox_PX + "px" };
            ctrl.w_BttnBox_Style = { "height": 0 }; // { "height": ctrl.BttnBox_PX_StagePX + "px" };

            if (ctrl.analogType == "Lake Level") {
                ctrl.w_LakeLevelBoxW_Style = { "height": print_NumberBoxW_Height + print_UnitBoxW_Height + "px" };
                ctrl.w_LakeLevelBox_Style = { "height": calc_NumberBoxW_Height + calc_UnitBoxW_Height + "px", "margin-top": (print_NumberBoxW_Height - calc_NumberBoxW_Height) / 2 + "px", "text-align": "center" };
            }
        };
        ctrl.set_HUDItemHeights('No');
    };

    ctrl.DisplayTimestamp = function (reportDateTime, currentDateTime, format) {

        var w_format = format;
        var w_reportDateTime = reportDateTime;
        var w_elapsedtime = datetime_difference(reportDateTime, currentDateTime);

        if (w_format === "Absolute") {
            ctrl.timestamp_Display = w_reportDateTime;
        }
        if (w_format === "Elapsed") {
            ctrl.timestamp_Display = w_elapsedtime;
        }
    };

    ctrl.finishLoading = function () {
        if (ctrl.widgetSetting) {
            ctrl.buildTachStrokeDash();
            ctrl.getWaterColor();
            ctrl.calc_WaterLevel();
            ctrl.calc_LakeLevel_Thresholds();
            ctrl.calc_StaffGauge_Water();
        }
        ctrl.loadingFinished = true;
    };

    ctrl.calc_WaterLevel = function () {
        if (ctrl.analogType == "Single Needle Gauge" || ctrl.analogType == "Lake Level") return;
        var w_minValue = ctrl.getGaugeMin(),
            w_maxValue = ctrl.getGaugeMax(),
            w_latestValue = ctrl.widgetSetting.analogGauge.latestData,
            w_lowRestore = ctrl.widgetSetting.analogGauge.lowRestore,
            w_highRestore = ctrl.widgetSetting.analogGauge.highRestore,
            w_lowFault = ctrl.widgetSetting.analogGauge.lowAlarm,
            w_highFault = ctrl.widgetSetting.analogGauge.highAlarm;
        var wt_MinMax = ctrl.difference(w_minValue, w_maxValue);
        var wt_latestValueDiff = ctrl.difference(w_minValue, w_latestValue);
        var wt_lowAlarmValueDiff = ctrl.difference(w_minValue, w_lowFault);
        var wt_lowRestoreValueDiff = ctrl.difference(w_minValue, w_lowRestore);
        var wt_highRestoreValueDiff = ctrl.difference(w_minValue, w_highRestore);
        var wt_highAlarmValueDiff = ctrl.difference(w_minValue, w_highFault);
        var wt_latestReadingPercent = wt_latestValueDiff / wt_MinMax;
        //if latest value is lower than minimum value, we will not display water body
        if (w_latestValue < w_minValue) wt_latestReadingPercent = 0;
        var wt_lowAlarmPercent = wt_lowAlarmValueDiff / wt_MinMax;
        var wt_lowRestorePercent = wt_lowRestoreValueDiff / wt_MinMax;
        var wt_highRestorePercent = wt_highRestoreValueDiff / wt_MinMax;
        var wt_highAlarmPercent = wt_highAlarmValueDiff / wt_MinMax;
        var panelMinMaxDiff = 0;
        var tankMinMaxDiff = 0;
        var tankHeight = 0;
        switch (ctrl.analogType) {
            case "Elevated Water Tank":
                panelMinMaxDiff = 273;
                tankMinMaxDiff = 273.9;
                tankHeight = 309.6;

                ctrl.elevatedLowAlarm = tankHeight - panelMinMaxDiff * wt_lowAlarmPercent;
                ctrl.elevatedLowRestore = tankHeight - panelMinMaxDiff * wt_lowRestorePercent;
                ctrl.elevatedHighRestore = tankHeight - panelMinMaxDiff * wt_highRestorePercent;
                ctrl.elevatedHighAlarm = tankHeight - panelMinMaxDiff * wt_highAlarmPercent;

                ctrl.elevatedHighAlarmMarker = tankHeight - panelMinMaxDiff * wt_highAlarmPercent + 8;
                ctrl.elevatedHighRestoreMarker = tankHeight - panelMinMaxDiff * wt_highRestorePercent + 8;
                ctrl.elevatedLowRestoreMarker = tankHeight - panelMinMaxDiff * wt_lowRestorePercent + 8;
                ctrl.elevatedLowAlarmMarker = tankHeight - panelMinMaxDiff * wt_lowAlarmPercent + 8;

                var waterLevel = "390.4," + (tankHeight - panelMinMaxDiff * wt_latestReadingPercent) + " 392.2,310.8 219.1,310.5 219.6," + (tankHeight - panelMinMaxDiff * wt_latestReadingPercent);
                ctrl.elevatedWaterBodyPoints = waterLevel;

                if (w_highRestore === 0 && w_highFault === 0) {
                    ctrl.elevatedHighfaultMarker_Hide = true;
                    ctrl.elevatedHighrestoreMarker_Hide = true;
                } else {
                    ctrl.elevatedHighfaultMarker_Hide = false;
                    ctrl.elevatedHighrestoreMarker_Hide = false;
                }

                if (w_lowRestore === 0 && w_lowFault === 0) {
                    ctrl.elevatedLowfaultMarker_Hide = true;
                    ctrl.elevatedLowrestoreMarker_Hide = true;
                } else {
                    ctrl.elevatedLowfaultMarker_Hide = false;
                    ctrl.elevatedLowrestoreMarker_Hide = false;
                }

                if (w_highFault > w_maxValue) ctrl.elevatedHighfaultMarker_Hide = true;
                if (w_highRestore > w_maxValue) ctrl.elevatedHighrestoreMarker_Hide = true;
                if (w_lowFault < w_minValue) ctrl.elevatedLowfaultMarker_Hide = true;
                if (w_lowRestore < w_minValue) ctrl.elevatedLowrestoreMarker_Hide = true;
                break;
            case "Standpipe Storage Tank":
                panelMinMaxDiff = 337.2;
                tankMinMaxDiff = 338.3;
                tankHeight = 407.8;

                ctrl.standpipeHighAlarm = tankHeight - panelMinMaxDiff * wt_highAlarmPercent;
                ctrl.standpipeHighRestore = tankHeight - panelMinMaxDiff * wt_highRestorePercent;
                ctrl.standpipeLowRestore = tankHeight - panelMinMaxDiff * wt_lowRestorePercent;
                ctrl.standpipeLowAlarm = tankHeight - panelMinMaxDiff * wt_lowAlarmPercent;

                ctrl.standpipeHighAlarmMarker = tankHeight - panelMinMaxDiff * wt_highAlarmPercent + 8;
                ctrl.standpipeHighRestoreMarker = tankHeight - panelMinMaxDiff * wt_highRestorePercent + 8;
                ctrl.standpipeLowRestoreMarker = tankHeight - panelMinMaxDiff * wt_lowRestorePercent + 8;
                ctrl.standpipeLowAlarmMarker = tankHeight - panelMinMaxDiff * wt_lowAlarmPercent + 8;

                ctrl.standpipeWaterBodyY = tankHeight - tankMinMaxDiff * wt_latestReadingPercent;
                ctrl.standpipeWaterBodyHeight = tankMinMaxDiff * wt_latestReadingPercent;

                if (w_highRestore === 0 && w_highFault === 0) {
                    ctrl.standpipeHighfaultMarker_Hide = true;
                    ctrl.standpipeHighrestoreMarker_Hide = true;
                } else {
                    ctrl.standpipeHighfaultMarker_Hide = false;
                    ctrl.standpipeHighrestoreMarker_Hide = false;
                }

                if (w_lowRestore === 0 && w_lowFault === 0) {
                    ctrl.standpipeLowfaultMarker_Hide = true;
                    ctrl.standpipeLowrestoreMarker_Hide = true;
                } else {
                    ctrl.standpipeLowfaultMarker_Hide = false;
                    ctrl.standpipeLowrestoreMarker_Hide = false;
                }

                if (w_highFault > w_maxValue) ctrl.standpipeHighfaultMarker_Hide = true;
                if (w_highRestore > w_maxValue) ctrl.standpipeHighrestoreMarker_Hide = true;
                if (w_lowFault < w_minValue) ctrl.standpipeLowfaultMarker_Hide = true;
                if (w_lowRestore < w_minValue) ctrl.standpipeLowrestoreMarker_Hide = true;
                break;
            case "Hydro Pneumatic Tank":
                panelMinMaxDiff = 280;
                tankMinMaxDiff = 280.9;
                tankHeight = 382.2;

                ctrl.hydroLowAlarm = tankHeight - panelMinMaxDiff * wt_lowAlarmPercent;
                ctrl.hydroLowRestore = tankHeight - panelMinMaxDiff * wt_lowRestorePercent;
                ctrl.hydroHighRestore = tankHeight - panelMinMaxDiff * wt_highRestorePercent;
                ctrl.hydroHighAlarm = tankHeight - panelMinMaxDiff * wt_highAlarmPercent;

                ctrl.hydroHighAlarmMarker = tankHeight - panelMinMaxDiff * wt_highAlarmPercent + 8;
                ctrl.hydroHighRestoreMarker = tankHeight - panelMinMaxDiff * wt_highRestorePercent + 8;
                ctrl.hydroLowRestoreMarker = tankHeight - panelMinMaxDiff * wt_lowRestorePercent + 8;
                ctrl.hydroLowAlarmMarker = tankHeight - panelMinMaxDiff * wt_lowAlarmPercent + 8;

                ctrl.hydroWaterBodyY = tankHeight - tankMinMaxDiff * wt_latestReadingPercent;
                ctrl.hydroWaterBodyHeight = tankMinMaxDiff * wt_latestReadingPercent;

                if (w_highRestore === 0 && w_highFault === 0) {
                    ctrl.hydroHighfaultMarker_Hide = true;
                    ctrl.hydroHighrestoreMarker_Hide = true;
                } else {
                    ctrl.hydroHighfaultMarker_Hide = false;
                    ctrl.hydroHighrestoreMarker_Hide = false;
                }

                if (w_lowRestore === 0 && w_lowFault === 0) {
                    ctrl.hydroLowfaultMarker_Hide = true;
                    ctrl.hydroLowrestoreMarker_Hide = true;
                } else {
                    ctrl.hydroLowfaultMarker_Hide = false;
                    ctrl.hydroLowrestoreMarker_Hide = false;
                }

                if (w_highFault > w_maxValue) ctrl.hydroHighfaultMarker_Hide = true;
                if (w_highRestore > w_maxValue) ctrl.hydroHighrestoreMarker_Hide = true;
                if (w_lowFault < w_minValue) ctrl.hydroLowfaultMarker_Hide = true;
                if (w_lowRestore < w_minValue) ctrl.hydroLowrestoreMarker_Hide = true;
                break;
        }
    };

    ctrl.buildTachStrokeDash = function () {
        if (ctrl.analogType != "Single Needle Gauge" && ctrl.analogType != "Wind Speed") return;

        if (ctrl.widgetSetting.device.deviceModel !== 20) {
            var w_minValue = ctrl.getGaugeMin(),
                w_maxValue = ctrl.getGaugeMax(),
                w_lowRestore = ctrl.widgetSetting.analogGauge.lowRestore,
                w_highRestore = ctrl.widgetSetting.analogGauge.highRestore,
                w_lowFault = ctrl.widgetSetting.analogGauge.lowAlarm,
                w_highFault = ctrl.widgetSetting.analogGauge.highAlarm,
                w_lowcolor = ctrl.widgetSetting.analogWidgetSetting.lowAlarmColor,
                w_normalcolor = ctrl.widgetSetting.analogWidgetSetting.normalColor,
                w_highcolor = ctrl.widgetSetting.analogWidgetSetting.highAlarmColor;

            ctrl.w_Path1 = $element.find('.path_5')[0];
            ctrl.w_Path2 = $element.find('.path_4')[0];
            ctrl.w_Path3 = $element.find('.path_3')[0];
            ctrl.w_Path4 = $element.find('.path_2')[0];
            ctrl.w_Path5 = $element.find('.path_1')[0];

            var gv_TachLength = ctrl.w_Path1.getTotalLength();

            ctrl.w_Path1.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_maxValue, gv_TachLength);
            ctrl.w_Path2.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_highFault, gv_TachLength);
            ctrl.w_Path3.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_highRestore, gv_TachLength);
            ctrl.w_Path4.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_lowRestore, gv_TachLength);
            ctrl.w_Path5.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_lowFault, gv_TachLength);

            if (getState(ctrl.widgetSetting.deviceUnitState.state) === 'CommFail') {
                w_lowcolor = '#646464';
                w_normalcolor = '#7d7d7d';
                w_highcolor = '#969696';
            }

            if (w_highRestore === 0 && w_highFault === 0) {
                w_highcolor = w_normalcolor;
            }

            if (w_lowRestore === 0 && w_lowFault === 0) {
                w_lowcolor = w_normalcolor;
            }

            ctrl.w_Path1.style.stroke = w_highcolor;
            ctrl.w_Path3.style.stroke = w_normalcolor;
            ctrl.w_Path5.style.stroke = w_lowcolor;

            ctrl.w_Path2.style.stroke = darken(w_highcolor, 20);
            ctrl.w_Path4.style.stroke = darken(w_lowcolor, 20);
        } else {
            var w_minValue = ctrl.getGaugeMin(),
                w_maxValue = ctrl.getGaugeMax(),
                w_lowRestore = ctrl.widgetSetting.analogGauge.lowRestore,
                w_highRestore = ctrl.widgetSetting.analogGauge.highRestore,
                w_highHighRestore = ctrl.widgetSetting.analogGauge.highHighRestore,
                w_lowFault = ctrl.widgetSetting.analogGauge.lowAlarm,
                w_highFault = ctrl.widgetSetting.analogGauge.highAlarm,
                w_highHighFault = ctrl.widgetSetting.analogGauge.highHighAlarm,
                w_lowcolor = ctrl.widgetSetting.analogWidgetSetting.lowAlarmColor,
                w_normalcolor = ctrl.widgetSetting.analogWidgetSetting.normalColor,
                w_highcolor = ctrl.widgetSetting.analogWidgetSetting.highAlarmColor,
                w_highHighcolor = ctrl.widgetSetting.analogWidgetSetting.highHighAlarmColor;

            ctrl.w_Path1 = $element.find('.path_7_highHigh')[0];
            ctrl.w_Path2 = $element.find('.path_6_highHigh')[0];
            ctrl.w_Path3 = $element.find('.path_5_highHigh')[0];
            ctrl.w_Path4 = $element.find('.path_4_highHigh')[0];
            ctrl.w_Path5 = $element.find('.path_3_highHigh')[0];
            ctrl.w_Path6 = $element.find('.path_2_highHigh')[0];
            ctrl.w_Path7 = $element.find('.path_1_highHigh')[0];

            var _gv_TachLength = ctrl.w_Path1.getTotalLength();

            ctrl.w_Path1.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_maxValue, _gv_TachLength);
            ctrl.w_Path2.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_highHighFault, _gv_TachLength);
            ctrl.w_Path3.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_highHighRestore, _gv_TachLength);
            ctrl.w_Path4.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_highFault, _gv_TachLength);
            ctrl.w_Path5.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_highRestore, _gv_TachLength);
            ctrl.w_Path6.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_lowRestore, _gv_TachLength);
            ctrl.w_Path7.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_lowFault, _gv_TachLength);

            if (getState(ctrl.widgetSetting.deviceUnitState.state) === 'CommFail') {
                w_lowcolor = '#646464';
                w_normalcolor = '#7d7d7d';
                w_highcolor = '#969696';
                w_highHighcolor = '#3d3d3d';
            }

            if (w_highHighRestore === 0 && w_highHighFault === 0) {
                w_highHighcolor = w_normalcolor;
            }

            if (w_highRestore === 0 && w_highFault === 0) {
                w_highcolor = w_normalcolor;
            }

            if (w_lowRestore === 0 && w_lowFault === 0) {
                w_lowcolor = w_normalcolor;
            }

            ctrl.w_Path1.style.stroke = w_highHighcolor;
            ctrl.w_Path3.style.stroke = w_highcolor;
            ctrl.w_Path5.style.stroke = w_normalcolor;
            ctrl.w_Path7.style.stroke = w_lowcolor;

            ctrl.w_Path2.style.stroke = darken(w_highHighcolor, 20);
            ctrl.w_Path4.style.stroke = darken(w_highcolor, 20);
            ctrl.w_Path6.style.stroke = darken(w_lowcolor, 20);
        }
    };

    /* Add the indicated percentage to a color (RR, GG or BB) hexadecimal to clarify it */
    var addLight = function addLight(color, amount) {
        var cc = parseInt(color, 16) + amount;
        var c = cc > 255 ? 255 : cc;
        c = c.toString(16).length > 1 ? c.toString(16) : "0" + c.toString(16);
        return c;
    };

    /* const hexToRGB = (color) => {
      color = (color.indexOf("#")>=0) ? color.substring(1,color.length) : color;
      let colorRGB = [color.substring(0,2)]
    } */

    /* Clarifies a hexadecimal color of 6 characters #RRGGBB according to the indicated percentage */
    var lighten = function lighten(color, amount) {
        color = color.indexOf("#") >= 0 ? color.substring(1, color.length) : color;
        amount = parseInt(255 * amount / 100);
        return color = "#" + addLight(color.substring(0, 2), amount) + addLight(color.substring(2, 4), amount) + addLight(color.substring(4, 6), amount);
    };

    /* Subtract the indicated percentage to a color (RR, GG or BB) hexadecimal to darken it */
    var subtractLight = function subtractLight(color, amount) {
        var cc = parseInt(color, 16) - amount;
        var c = cc < 0 ? 0 : cc;
        c = c.toString(16).length > 1 ? c.toString(16) : "0" + c.toString(16);
        return c;
    };

    /* Darken a hexadecimal color of 6 characters #RRGGBB according to the indicated percentage */
    var darken = function darken(color, amount) {
        color = color.indexOf("#") >= 0 ? color.substring(1, color.length) : color;
        amount = parseInt(255 * amount / 100);
        return color = "#" + subtractLight(color.substring(0, 2), amount) + subtractLight(color.substring(2, 4), amount) + subtractLight(color.substring(4, 6), amount);
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ctrl.difference = function (a, b) {
        return Math.abs(a - b);
    };

    ctrl.round = function (value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        //return Math.round(value * multiplier) / multiplier;
        return value * multiplier / multiplier;
    };

    ctrl.calc_GuagePCT = function (g_min, g_max, g_numb) {
        var val_min = g_min;
        var val_max = g_max;
        var val_numb = g_numb;

        var calc_minmaxDiff = ctrl.difference(val_min, val_max); // Calculate diference between min and max
        var calc_minnumbDiff = ctrl.difference(val_min, val_numb); // Calculate diference between min and number
        //let calc_numbPerc = Math.round((calc_minnumbDiff / calc_minmaxDiff) * 100);
        var calc_numbPerc = calc_minnumbDiff / calc_minmaxDiff * 100;
        return calc_numbPerc;
    };

    ctrl.genTachArch = function (w_min, w_max, w_val, w_TachLength) {
        //let cv_MinMax = parseInt(ctrl.difference(w_min, w_max));
        var cv_MinMax = ctrl.difference(w_min, w_max);
        //let cv_ValueDiff = parseInt(ctrl.difference(w_min, w_val));
        var cv_ValueDiff = ctrl.difference(w_min, w_val);
        var cv_TachPercent = cv_ValueDiff / cv_MinMax;
        var cv_TachValue = cv_TachPercent * w_TachLength;
        var cv_TachEndVal = w_TachLength - cv_TachValue;

        return cv_TachValue + " " + cv_TachEndVal;
    };

    ctrl.rotateDEG = function (g_PCT) {

        var w_Low = -133; // Percent Rotation
        var w_High = 133; // Percent Rotation

        var w_PCT = g_PCT;

        var total_Deg = ctrl.difference(w_Low, w_High); //266
        var val_PCT = w_PCT * total_Deg / 100; // calculate percent of track
        var val_adjPCT = val_PCT + w_Low;

        return val_adjPCT;
    };

    var datetime_difference = function datetime_difference(date1, date2) {
        var unixDate1 = new Date(date1).getTime();
        var unixDate2 = new Date(date2).getTime();
        var difference = unixDate2 - unixDate1;

        var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
        difference -= daysDifference * 1000 * 60 * 60 * 24;

        var hoursDifference = Math.floor(difference / 1000 / 60 / 60);
        difference -= hoursDifference * 1000 * 60 * 60;

        var minutesDifference = Math.floor(difference / 1000 / 60);
        difference -= minutesDifference * 1000 * 60;

        var secondsDifference = Math.floor(difference / 1000);

        var daysDiffStr_Pos = w_saydiff(daysDifference, "d") + w_saydiff(hoursDifference, "h") + w_saydiff(minutesDifference, "m") + w_saydiff(secondsDifference, "s");
        var daysDiffStr_Neg = "0s";

        if (unixDate2 > unixDate1) {
            return daysDiffStr_Pos;
        }
        if (unixDate2 < unixDate1) {
            return daysDiffStr_Neg;
        }
        return '';
    };

    var w_saydiff = function w_saydiff(w_val, w_lab) {

        if (w_val == 0) {
            return '';
        }
        if (w_val == 1) {
            return w_val + '' + w_lab + ' ';
        }
        if (w_val > 1) {
            return w_val + '' + w_lab + ' ';
        }
        return '';
    };

    ctrl.buildMainClass = function () {
        var gaugeType = "TachGauge1"; // Options: TachGauge1 (Styled in mcwidgets.css)
        var pumpTransparentObj = "PumpTransparentObj";
        var mainClass = ["upWidget", gaugeType, ctrl.widgetSetting.analogWidgetSetting.theme, "rtu" + getState(ctrl.widgetSetting.deviceUnitState.state), "acfail" + ctrl.widgetSetting.deviceUnitState.acFail];
        if (ctrl.analogType != "Single Needle Gauge") {
            mainClass = ["upWidget", gaugeType, ctrl.widgetSetting.analogWidgetSetting.theme, "rtu" + getState(ctrl.widgetSetting.deviceUnitState.state), "acfail" + ctrl.widgetSetting.deviceUnitState.acFail, pumpTransparentObj];
        }
        ctrl.mainClass = angular.copy(mainClass);
    };

    ctrl.openView = function () {
        openViewService.openView(getView(ctrl.widgetSetting.deviceUnitState.state));
    };

    // from socket

    ctrl.webSocketDataReceived = function (data) {
        if (ctrl.widgetSetting.analogGauge.channel == data.CH && ctrl.widgetSetting.device.serialNumber === data.SN) {
            ctrl.widgetSetting.analogGauge.latestData = parseFloat(data.Value);
            ctrl.rtuTimeFormated = datetimeService.socketStrToServerStrTime(data.Time);
            ctrl.widgetSetting.analogGauge.localDateTime = ctrl.rtuTimeFormated;
            // ctrl.fnMakeFitTextWork();
            ctrl.updateAnalogWidget(parseFloat(data.Value));
        }
    };

    ctrl.webSocketDataReceivedG2 = function (data) {
        if (ctrl.widgetSetting.analogGauge.channel == data.CH && ctrl.widgetSetting.device.serialNumber === data.SN) {
            ctrl.widgetSetting.analogGauge.latestData = parseFloat(data.Value);
            ctrl.rtuTimeFormated = datetimeService.socketStrToServerStrTime(data.Time);
            ctrl.widgetSetting.analogGauge.localDateTime = ctrl.rtuTimeFormated;
            ctrl.updateAnalogWidget(parseFloat(data.Value));
        }
    };

    ctrl.webSocketHeartbeatReceived = function (data) {
        if (angular.isUndefined(ctrl.widgetSetting)) return; //The Widget has not initialized yet
        ctrl.heartbeatDateTime = new Date(data.LocalDateTime).toISOString();;;
        ctrl.DisplayTimestamp(ctrl.widgetSetting.analogGauge.localDateTime, ctrl.heartbeatDateTime, ctrl.widgetSetting.analogWidgetSetting.dateTimeFormat);
    };

    ctrl.wsListDeviceStateMsgReceived = function (data) {
        ctrl.widgetSetting.deviceUnitState.state = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).state;
        ctrl.widgetSetting.deviceUnitState.acFail = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).acFail;
        ctrl.fnRtuStatusOptions(getState(ctrl.widgetSetting.deviceUnitState.state));
    };

    ctrl.wsDataReceivedANALOGSETTING = function (data) {
        if (ctrl.widgetSetting.analogGauge.channel == data.CH && ctrl.widgetSetting.device.serialNumber === data.SN) {

            switch (data.Value.path) {
                case 'minimumValue':
                    ctrl.widgetSetting.analogGauge.minVal = parseInt(data.Value.value);
                    break;
                case 'maximumValue':
                    ctrl.widgetSetting.analogGauge.maxVal = parseInt(data.Value.value);
                    break;
                case 'name':
                    ctrl.widgetSetting.analogGauge.name = data.Value.value;
                    break;
                case 'unit':
                    ctrl.widgetSetting.analogGauge.unit = data.Value.value;
                    break;
            }
            ctrl.annimate_Needle(ctrl.getGaugeMin(), ctrl.getGaugeMax(), ctrl.widgetSetting.analogGauge.latestData);
        }
    };

    ctrl.webSocketReconnect = function () {
        ctrl.unRegisterListener();
        //toaster.pop('success', "Analog Widget" + " -- " + ctrl.widgetSetting.device.name, 'View reloading');
        ctrl.getData(ctrl.widgetSetting.device.deviceId, ctrl.widgetSetting.analogGauge.channel);
    };

    var _onHeartbeat = $rootScope.$on('Heartbeat', function (event, args) {
        if (args.message.Type === "HEARTBEAT") {
            ctrl.webSocketHeartbeatReceived(args.message);
            //currentTime = new Date(args.message.LocalDateTime).getTime();
        }
    });

    ctrl.registerListener = function () {
        websocketService.connect();
        websocketService.register('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        setTimeout(function () {
            websocketService.register("ANALOGSETTING", ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.analogGauge.channel, ctrl.wsDataReceivedANALOGSETTING, null);
        }, 100);
        websocketService.startOverview();
        websocketService.register("ANALOG", ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.analogGauge.channel, ctrl.webSocketDataReceived, ctrl.webSocketReconnect);
        ctrl.urld = { type: "ANALOG", serialNumber: ctrl.widgetSetting.device.serialNumber, channel: ctrl.widgetSetting.analogGauge.channel, dataReceived: ctrl.webSocketDataReceived, reconnect: ctrl.webSocketReconnect };
        websocketService.register("ANALOG_G2", ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.analogGauge.channel, ctrl.webSocketDataReceivedG2, null);
    };

    ctrl.unRegisterListener = function (data) {
        if (angular.isUndefined(ctrl.urld)) return;
        websocketService.unRegister('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.stopOverview();
        websocketService.unRegister(ctrl.urld.type, ctrl.urld.serialNumber, ctrl.urld.channel, ctrl.urld.dataReceived, ctrl.urld.reconnect);
        websocketService.unRegister("ANALOGSETTING", ctrl.urld.serialNumber, ctrl.urld.channel, ctrl.wsDataReceivedANALOGSETTING, null);
        websocketService.unRegister("ANALOG_G2", ctrl.urld.serialNumber, ctrl.urld.channel, ctrl.webSocketDataReceivedG2, null);
    };

    ctrl.updateAnalogWidget = function (data) {
        ctrl.annimate_Needle(ctrl.getGaugeMin(), ctrl.getGaugeMax(), data);
        ctrl.DisplayTimestamp(ctrl.widgetSetting.analogGauge.localDateTime, ctrl.heartbeatDateTime, ctrl.widgetSetting.analogWidgetSetting.dateTimeFormat);
        ctrl.calc_WaterLevel();
        ctrl.getWaterColor();
        ctrl.calc_LakeLevel_Thresholds();
        ctrl.calc_StaffGauge_Water();
    };

    var _onDocumentDblClick = $rootScope.$on('document_click', function (event, args) {
        ctrl.closeSetting();
    });

    var _updateThresholdsAndLevelReference = $rootScope.$on('updateThresholdsAndLevelReference', function (event, args) {
        var _dataChanged = "any";
        if (args.deviceId == ctrl.widgetSetting.device.deviceId && _dataChanged.indexOf(args.fieldName) > -1) {
            ctrl.webSocketReconnect();
        }
    });

    $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
        ctrl.langId = langId === 'fr' ? langId : 'en';
    });
    /////////////////////////////////////////////////////////////////////////////
    ///////////////////   Keyboard (Tab) support - <start>   ////////////////////
    /////////////////////////////////////////////////////////////////////////////

    //Keyboard Tab/move support for the widget dialog, removed again when this scope is destroyed.
    //Only for the dragged-out widget: in the gauge list (displaySettingOn false) the closest dialog is the list view itself.
    //Called from $onChanges because widgetSetting arrives after the widget is linked (the analog widget loads it async).
    var _tabButtonRegistered = false;
    var _registerTabButton = function _registerTabButton(widgetSetting) {
        if (_tabButtonRegistered || !widgetSetting.setting || !widgetSetting.setting.displaySettingOn) return;
        _tabButtonRegistered = true;
        tabButtonGaugeService.register($scope, $element);
        //Status icon (bell) is a Tab stop too, right after the HUD box (same as in the gauge list, where registerList does it)
        tabButtonGaugeService.registerAlarmIcon($scope, $element, '.gaugeDataBox');
    };

    // Keyboard support for the HUD box: Enter/Space opens settings, Escape closes them.
    // Moving the widget is handled on the dialog itself (tabButtonGaugeService.register).
    ctrl.editSettingKeydown = function (event) {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;

        if (event.key === 'Escape' && ctrl.action_EditMode === 'Yes') {
            // preventDefault also stops jQuery UI's closeOnEscape from closing the whole dialog
            event.preventDefault();
            event.stopPropagation();
            ctrl.closeSetting();
            // Return focus to the HUD box once it is focusable again
            $timeout(function () {
                $element.find('.gaugeDataBox').focus();
            });
            return;
        }

        // Ignore keys typed into inputs/links inside the box
        if (event.target !== event.currentTarget) return;

        if ((event.key === 'Enter' || event.key === ' ') && ctrl.action_EditMode === 'No') {
            ctrl.editSetting(event);
            // In edit mode the box loses its tabindex, so the browser drops focus to <body> and Escape would never
            // reach this handler: move focus into the settings panel (first tab) once it is shown
            $timeout(function () {
                $element.find('.gaugeDataEditBoxWrapper').find('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').first().focus();
            });
        }
    };

    // Show the HUD info on keyboard focus, same as on hover
    ctrl.focusHUD = function () {
        ctrl.mouseOverHUD();
    };
    // Keep the HUD info open while focus moves to something inside it (e.g. the Edit link)
    ctrl.blurHUD = function (event) {
        if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) return;
        ctrl.mouseOffHUD();
    };

    // Lower/Upper Display Range saved from this widget's own settings panel: the widget is not recreated
    // (see mc-analog-widget), so redraw the gauge with the new range here and keep the settings panel open.
    // Same drawing as buildWidget, without resize_HUD which would switch the HUD box back out of edit mode.
    $scope.$on('updateGuageMinMaxforGauges', function (event, args) {
        if (!args.settingDialog || args.settingDialog !== $element.closest('.ui-dialog')[0]) return;
        if (!ctrl.widgetSetting || ctrl.mcWidgetsSharedFactory.checkForEmptyObject(ctrl.widgetSetting.analogGauge)) return;

        ctrl.widgetSetting.analogWidgetSetting.gaugeMinValue = args.gaugeMinValue;
        ctrl.widgetSetting.analogWidgetSetting.gaugeMaxValue = args.gaugeMaxValue;

        ctrl.noDecimals = sharedSetupService.getNumberOfDecimals(ctrl.getGaugeMax(), ctrl.getGaugeMin());
        ctrl.annimate_Needle(ctrl.getGaugeMin(), ctrl.getGaugeMax(), ctrl.widgetSetting.analogGauge.latestData);
        ctrl.create_Markers(ctrl.getGaugeMin(), ctrl.widgetSetting.analogGauge.lowAlarm, ctrl.widgetSetting.analogGauge.lowRestore, ctrl.widgetSetting.analogGauge.highAlarm, ctrl.widgetSetting.analogGauge.highRestore, ctrl.widgetSetting.analogGauge.highHighAlarm, ctrl.widgetSetting.analogGauge.highHighRestore, ctrl.getGaugeMax());
        if (ctrl.loadingFinished) {
            ctrl.buildTachStrokeDash();
            ctrl.getWaterColor();
            ctrl.calc_WaterLevel();
            ctrl.calc_LakeLevel_Thresholds();
            ctrl.calc_StaffGauge_Water();
        }
    });

    /////////////////////////////////////////////////////////////////////////////
    ///////////////////   Keyboard (Tab) support - <end>     ////////////////////
    /////////////////////////////////////////////////////////////////////////////

    $scope.$on("$destroy", function () {
        _onHeartbeat();
        ctrl.unRegisterListener();
        _updateThresholdsAndLevelReference();
        _onDocumentDblClick();
        if (chart) chart.destroy();
    });

    $scope.$on("StopOverview", function (event, args) {
        if ($scope.$$destroyed) {
            // The scope is already destroyed, skip further processing.
            return;
        } else if (args.stop) {
            websocketService.connect();
            websocketService.startOverview();
        }
    });
}

McWidgetDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'McWidgetDisplayFactory', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'McAnalogGaugeFactory', 'authenticationService', 'openViewService', 'translationService', 'PopupFactory', 'McWidgetsSharedFactory', '$http', 'HOST', 'tabButtonGaugeService'];
'use strict';

angular.module('mc.widget-display').component('mcWidgetDisplay', {
    controller: McWidgetDisplayController,
    templateUrl: 'ui/mcwidgetdisplay/mcwidget-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        settingShow: '&',
        changeWidgetTitle: '&',
        analogType: '<'
    }
});
mcapp.factory('interconnectListService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getAnalogInterconnectList: function (customerId) {
            return $http({
                method: 'GET',
                url: HOST + '/api/Interconnect/AnalogList',
                params: { customerId: customerId }
            });
        },
        getDigitalInterconnectList: function (customerId) {
            return $http({
              method: 'GET',
              url: HOST + '/api/Interconnect/DigitalList',
              params: { customerId: customerId }
            });
        },
        updateDigitalStatus: function (status, customerId) {
          return $http.put(HOST + '/api/Interconnect/DigitalList?customerId=' + customerId, status);
        },
        getDigitalIntertieChart: function (customerId, interconnectId, startDate, endDate) {
          return $http.get(HOST + '/api/Interconnect/DigitalIntertieChart' +
                                  '?customerId=' + customerId +
                                  '&interconnectId=' + interconnectId +
                                  '&StartDate=' + startDate +
                                  '&EndDate=' + endDate);
        },
        getDigitalIntertieDetails: function (interconnectId) {
          return $http.get(HOST + '/api/Interconnect/DigitalIntertieDetails' + '?interconnectId=' + interconnectId);
        }
    };
}]);

mcapp.controller('digitalIntertieLogController', ['$scope', '$rootScope', 'sharedSetupService', 'openViewService', 'translationService', 'detectBrowserService', 'authenticationService', function ($scope, $rootScope, sharedSetupService, openViewService, translationService, detectBrowserService, authenticationService) {
    $scope.myDate = null;
    $scope.qdpLeft = -237;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.popup = _this.getExistingDialog($scope.windowId).ref;
    $scope.alerts = [];
    $scope.currentBrowser = detectBrowserService();

    $scope.selectMyDate = function () {
        $scope.selectMyDateT();
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);

        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
				openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
        };
    }
}]);

mcapp.directive('drawDigitalLogTable', ['$timeout', 'digitalIntertieLogService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService',function($timeout, digitalIntertieLogService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        scope.dateAgentText = function (date) {
            return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, scope.accountInfo.preferenceUser.timeFormat);
        }

        element.on('scroll', function (event) {
          var $rowFirst = element.contents().find("tr:first");
          var $rowLast = element.contents().find("tr:last");
          var _firstRow = $rowFirst.attr("name");
          if (typeof $rowFirst.position() !== "undefined") {
              scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
              var _tableTop = element.offset().top;
              var _rowTop = $rowFirst.offset().top;
              _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
              previousScrollbarPosition = currentScrollbarPosition;
              currentScrollbarPosition = element[0].scrollTop;
          }

          if (scope.infiniteScrollOn === true) {
            scope.infiniteScrollUpOn = true;
            scope.infiniteScrollDownOn = true;

            if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
              $rowLast.addClass("active-row");
          	  scope.digitalIntertieLogService.alerts =[];
              scope.digitalIntertieLogService.nextPage();
            }
            if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
              $rowFirst.addClass("active-row");
              scope.digitalIntertieLogService.alerts =[];
              scope.digitalIntertieLogService.previousPage();
            }
          }

          var rows = element.children().children().children().children();
          var scrollpos = 40;
          var start = 0;
          var end = rows.length;
          var count = 0;

          while (start != end) {
              count++;
              var mid = start + Math.floor((end - start) / 2);
              if ($(rows[mid]).position().top < scrollpos)
                  start = mid + 1;
              else
                  end = mid;
          }
          _updateZoom(parseFloat($($(rows[start])).attr("name")));
        });

        var _updateZoom = function (currentRow) {
            if (isNaN(currentRow))
                return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            }
            else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('digitalIntertieLogService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        var init = function () {
          /////////////////////////////////////////////////////////////
          currentScrollbarPosition = 0;
          previousScrollbarPosition = 0;
          scope.checkFirstRowLiveStatus = null;
          /////////////////////////////////////////////////////////////
          scope.digitalIntertieLogService = new digitalIntertieLogService();
          scope.digitalIntertieLogService.customerId = scope.accountInfo.customerId;
          scope.digitalIntertieLogService.interconnectId = scope.stickyProperties.deviceId; //TODO: scope.stickyProperties.analogIntertieId;
          scope.digitalIntertieLogService.windowTitle = scope.windowTitle;
          scope.digitalIntertieLogService.startRow = 1;
          scope.digitalIntertieLogService.pageSize = 200;
          scope.alerts = [];
          sharedSetupService.setStickyProperties(scope.stickyProperties, { windowId: scope.windowId });
          if (scope.stickyProperties.savedDesktop === true && scope.stickyProperties.on === true || scope.classicView) {
              scope.savedDesktopRow = scope.stickyProperties.zoomMax;
              scope.stickyProperties.on = true;
              scope.stickyProperties.savedDesktop = false;
              scope.digitalIntertieLogService.pageSize = 200;
              if (scope.currentBrowser == "ie")
                  scope.digitalIntertieLogService.pageSize = 100;
              //scope.digitalIntertieLogService.start = scope.stickyProperties.dateMin;
              scope.digitalIntertieLogService.end = scope.stickyProperties.dateMax;
              scope.digitalIntertieLogService.nextPage();
          }
          else if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) { //doesn't work well - need to check
              scope.stickyProperties.on = true;
              scope.digitalIntertieLogService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
              timeLapseService.getLocalDateTime().then(function (result) {
                  if (scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && scope.stickyProperties.zoomMax + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                      scope.digitalIntertieLogService.end = scope.stickyProperties.dateMax;
                  }
                  else {
                      scope.digitalIntertieLogService.end = Math.round((scope.stickyProperties.zoomMax + scope.stickyProperties.zoomMin) / 2);
                  }
                  scope.digitalIntertieLogService.nextPage();
              });
          }
          else {
              scope.stickyProperties.on = false;
              timeLapseService.getLocalDateTime().then(function (result) {
                  /////////////////////////////////////////////////////////////
                  var startDate = new Date(new Date(result.data.localDateTime).getTime());
                  startDate.setHours(0, 0, 0, 0);
                  var endDate = new Date(startDate.getTime() + (3 * 86400000));
                  //TODO: Datamin is causing grief. Do this until I can come up with a better way
                  //var stickyStart = datetimeService.dateToUnixtime(new Date('2005-01-01'));
                  //scope.digitalIntertieLogService.start = datetimeService.dateToUnixtime(startDate);
                  scope.digitalIntertieLogService.end = datetimeService.dateToUnixtime(endDate);
                  sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMax: scope.digitalIntertieLogService.end, windowId: scope.windowId });
                  /////////////////////////////////////////////////////////////
                  scope.digitalIntertieLogService.nextPage();
              });
          }
        }

        init();

        scope.selectMyDateT = function () {
            scope.digitalIntertieLogService = new digitalIntertieLogService();
            scope.digitalIntertieLogService.interconnectId = scope.stickyProperties.deviceId; //TODO: scope.stickyProperties.analogIntertieId;
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            _unRegisterListener();
            /////////////////////////////////////////////////////////////
            var tmpDates = scope.myDate;
            var tmpDatesA = tmpDates;
            var safeEndDate;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            tmpDatesA.setHours(12, 0, 0, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            //scope.digitalIntertieLogService.start = tmpDates.startDate;
            if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                scope.digitalIntertieLogService.end = tmpDatesA;
                safeEndDate = tmpDatesA;
            }
            else {
                scope.digitalIntertieLogService.end = tmpDates.endDate;
                safeEndDate = tmpDates.endDate;
            }
            //var stickyStart = datetimeService.dateToUnixtime(new Date('2005-01-01'));
            /////////////////////////////////////////////////////////////
            scope.digitalIntertieLogService.startRow = 1;
            scope.digitalIntertieLogService.pageSize = 200;
            scope.digitalIntertieLogService.customerId = scope.accountInfo.customerId;
            scope.digitalIntertieLogService.windowTitle = scope.windowTitle;
            scope.alerts = [];
            scope.digitalIntertieLogService.nextPage();
            /////////////////////////////////////////////////////////////
            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMax: safeEndDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
        };

        var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            }
            else if (scope.checkFirstRowLiveStatus === null) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.checkFirstRowLiveStatus = true;
                        _checkTopOffset(liveDataStatusOn);
                    }
                    else {
                        scope.checkFirstRowLiveStatus = false;
                    }
                });
            }
        };

        var _checkTopOffset = function (liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListener();
            }
            else {
                _unRegisterListener();
            }
        };

        var wsDataReceivedANALOGOUT = function (data) {
            var temp = {};
            var i = 0;
            if (scope.liveData === false) {
                _unRegisterListener();
                return;
            }

            if (data.Type == 'ANALOGOUTPUTSOURCE') {
              scope.lastAnalogSourceLive.rawTime = data.Time;
              scope.lastAnalogSourceLive.requestTime = datetimeService.socketStrToServerStrTime(data.Time);
              scope.lastAnalogSourceLive.sourceVal = data.Value;
            } else {
              var varTime = datetimeService.socketStrToServerStrTime(data.Time);
              var varValue = parseFloat(data.Value);
              var _recordExistAtIndex = null;

              var sourceVal = parseFloat(scope.lastAnalogSourceLive.sourceVal);
              sourceVal = 20*((sourceVal/256) * (1023-204.5) + 204.5)/1024;

              var scaledSource = parseFloat(scope.lastAnalogSourceLive.sourceVal);
              if (scope.analogIntertieTableService.analogSettings.analogMode == 0) {
                scaledSource = ((scaledSource * (scope.analogIntertieTableService.analogSettings.maximumValue - scope.analogIntertieTableService.analogSettings.minimumValue)) / 1023) + scope.analogIntertieTableService.analogSettings.minimumValue;
              } else
              {
                scaledSource = (scaledSource / 256) * (1023 - 204.5) + 204.5;
                scaledSource = (scaledSource - 204.5) / (1023 - 204.5) * (scope.analogIntertieTableService.analogSettings.maximumValue - scope.analogIntertieTableService.analogSettings.minimumValue) + scope.analogIntertieTableService.analogSettings.minimumValue;
              }

              var outputVal = parseFloat(data.Value);
              outputVal = 4+16*(scope.stickyProperties.deviceId == 105 ? (outputVal * (2/3)) : outputVal)/256; //TODO: scope.stickyProperties.analogIntertieId

              for (i = 0; i < scope.analogIntertieTableService.items.length; i++) {
                  if (scope.analogIntertieTableService.items[i].localDateTime == varTime) {
                      _recordExistAtIndex = i;
                      break;
                  }
              }

              if (_recordExistAtIndex === null) {
                   _newRecord = { requestTime: scope.lastAnalogSourceLive.requestTime, scaledInputReading: scaledSource, inputReading: sourceVal, outputSetting: outputVal, executeTime: data.Time - scope.lastAnalogSourceLive.rawTime };
                  scope.analogIntertieTableService.items.unshift(_newRecord);
                  _recordExistAtIndex = 0;
              }

              scope.lastUpdateAt = varTime;
              scope.lastAnalogSourceLive = {};
            }
        };

        var wsReconnectANALOGOUT = function (data) {
            if (scope.liveData === false) {
                _unRegisterListener();
                return;
            }
            if (data.Channel != 1)
                return;
            toaster.pop('success', scope.windowTitle + " -- ", 'View reloading');
            scope.stickyProperties.on = true;
            scope.analogIntertieTableService.start = scope.stickyProperties.dateMin;
            scope.analogIntertieTableService.end = scope.stickyProperties.dateMax;
            scope.analogIntertieTableService.items = [];
            scope.analogIntertieTableService.setting = [];
            scope.analogIntertieTableService.numberOfReturnedRecords = -1;
            scope.analogIntertieTableService.startRow = 1;
            scope.analogIntertieTableService.pageSize = 10000;
            sharedSetupService.setStickyProperties(scope.stickyProperties, { windowId: scope.windowId });
            scope.analogIntertieTableService.alerts =[];
            scope.analogIntertieTableService.nextPage();
        };

        var _registerListener = function () {
          if (scope.liveData === true)
              return;

          scope.liveData = true;
          scope.digitalIntertieLogService.numberOfNewRecordsPrevious = -1;
          websocketService.connect();

          websocketService.register("ANALOGOUTPUTSOURCE", '689MIS0021', 0, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);
          // websocketService.register("ANALOGOUT", scope.details.destinationSerialNumber, scope.details.destinationOutputChannel, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);
        };

        var _unRegisterListener = function () {
          if (scope.liveData === false)
              return;

          scope.liveData = false;
          scope.lastUpdateAt = undefined;

          websocketService.unRegister("ANALOGOUTPUTSOURCE", '689MIS0021', 0, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);
          // websocketService.unRegister("ANALOGOUT", scope.details.destinationSerialNumber, scope.details.destinationOutputChannel, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);
        };

        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll();
            scope.checkFirstRowLiveStatus = null;
        });

        var _autoScroll = function () {
          if (scope.digitalIntertieLogService.numberOfNewRecordsPrevious > 0) {
            var trRow = element.find('tr').eq(scope.digitalIntertieLogService.numberOfNewRecordsPrevious - 1);
            var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
            element.scrollTop(yPosition);
          }
          else if (element[0].scrollTop <= 1) {
            element.animate({
                scrollTop: element.scrollTop() + 2
            }, 500);
          }
        };

        // var _resetView = function (args) {
        //     for (var i = 0; i < scope.analogIntertieTableService.setting.length; i++) {
        //         if (scope.analogIntertieTableService.setting[i].channel == args.channel) {
        //             var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
        //             var _newDataValue = _newData.name + " (" + _newData.unit + ")";
        //             scope.analogIntertieTableService.setting[i].name = _newData.name;
        //             scope.analogIntertieTableService.setting[i].unit = _newData.unit;
        //         }
        //     }
        // };
        //
        // var _getArgsFromNewSetting = function (channel, newSetting) {
        //     for (var i = 0; i < newSetting.length; i++) {
        //         if (newSetting[i].channel == channel) {
        //             return newSetting[i];
        //             break;
        //         }
        //     }
        //     return null;
        // };

        // scope.$on('rtuAnalogUpdate', function (event, args) {
        //     var _dataChanged = "name, unit";
        //     if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
        //         _resetView(args);
        //     }
        // });

        scope.$on("$destroy", function () {
            _unRegisterListener();
        });
    };
}]);

mcapp.factory('digitalIntertieLogService', ['$http', 'datetimeService', 'translationService', 'HOST', function ($http, datetimeService, translationService, HOST) {
    var digitalIntertieLogService = function () {
        this.items = [];
        this.setting = [];
        this.customerId = null;
        this.interconnectId = null;
        this.startRow = 1;
        this.pageSize = 200;
        this.start = '19000101'
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.alerts = [];
        this.translation = translationService.translation;
    };

    digitalIntertieLogService.prototype.getData = function () {
      if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
      this.busy = true;

      var url = HOST + "/api/Interconnect/DigitalIntertieLog?customerId=" + this.customerId + "&interconnectId=" + this.interconnectId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end;
      $http.get(url)
        .then(function (resp) {
          var data = resp.data;
          /////////////////////////
          var intDayWindow = 10;
          var intDay = 86400000;
          /////////////////////////

          var items = data;
          if (items.length > 0)
              var tmpstart = new Date(items[items.length - 1].requestTime);

          if (this.pageSize > 0) {
            this.items = this.items.concat(data);
            this.numberOfReturnedRecords = items.length;
          }
          if (this.pageSize < 0) {
            this.items = data.reverse().concat(this.items);
            this.numberOfNewRecordsPrevious = items.length;
          }

          //this.startRow = this.startRow + items.length;
          this.startRow = this.startRow == 1 ? items.length : this.startRow + items.length;

          if (items.length > 0) { //if there are records returned
            this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].eventTime.replace(/\D/g, '')) - (intDayWindow * intDay);
            this.end = datetimeService.toUnixtime(this.items[0].eventTime.replace(/\D/g, ''));
          }
        }.bind(this), function (resp) {
          var error = resp.data;
          this.alerts =[];
          var errorMessage = eval("this.translation.message." + error.message);
          this.alerts.push({ msg: errorMessage, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
        }.bind(this))
        .finally(function () {
          this.pageSize = 200;
          this.busy = false;
        }.bind(this));
    }

    digitalIntertieLogService.prototype.previousPage = function () {
      this.pageSize = this.pageSize < 0 ? this.pageSize : -this.pageSize;
      this.getData();
    };

    digitalIntertieLogService.prototype.nextPage = function () {
      this.getData();
    };

    return digitalIntertieLogService;
}]);

mcapp.controller('digitalIntertieChartController', [
    '$scope', '$rootScope', 'sharedSetupService', 'translationService', 'openViewService', '$element', 'interconnectListService', '$timeout', 'authenticationService', '$location', function ($scope, $rootScope, sharedSetupService, translationService, openViewService, $element, interconnectListService, $timeout, authenticationService, $location) {
        $scope.myDate = null;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.unixDay = sharedSetupService.unixDay;
        $scope.liveDataOffset = sharedSetupService.liveDataOffset;
        $scope.minPadding = 0;
        $scope.maxPadding = 0;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.translation = translationService.translation;
        $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
        $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
        $scope.alerts = [];
        $scope.loadingInProgress = true;
        $scope.qdpLeft = -237;
        $scope.liveData  = true;
        $scope.openView = openViewService.openView;

        // For Classic View Window Id is not reflecting
        if (!$scope.windowId) {
            $scope.windowId = "Digital Intertie Chart";
        }

        if ($scope.classicView && $element.parent('div').parent('div').parent('div').attr('class') && $element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") == 0) {
            $scope.largeChart = true;
            $element.height(500);
        };

        $scope.selectMyDate = function (date) {
            $scope.myDate = date;
            $scope.selectMyDateC();
        };

        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        $scope.stickyProperties = $scope.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties.device.title = $scope.stickyProperties.device.deviceName;

        if (!$scope.stickyProperties.deviceId) {
            $location.path('/interconnect/digital-interconnect-list');
            return;
        }

        interconnectListService.getDigitalIntertieDetails(($scope.stickyProperties.deviceId ? $scope.stickyProperties.deviceId : $scope.stickyPropertiesInterface.deviceId)).then(function (resp) {
            var datafromfactory = resp.data;
            $scope.details = datafromfactory;
            //TODO: This can be way too long
            $scope.windowTitle = $scope.translation.text.DIGITAL_INTERCONNECT_CHART + ", " + datafromfactory.sourceName + ', ' + getInputName(datafromfactory) + " -> " +
                datafromfactory.destinationName + ', ' + getOutputName(datafromfactory);
            if (!$rootScope.mobile && !$rootScope.classicView) {
                $scope.popup = _this.getExistingDialog($scope.windowId).ref;
                $scope.popup.dialog("option", "title", $scope.windowTitle);
            }
        });

        var getInputName = function (digitalStatus) {
            if (digitalStatus.sourceChannelName) {
                return digitalStatus.sourceChannelName;
            }
            else if( digitalStatus.sourceChannelDescriptionParmDigital)
            {
            return  digitalStatus.sourceChannelDescriptionParmDigital;
            }
            else if(digitalStatus.sourceChannelDescriptionChannelConfig)
            {
            return digitalStatus.sourceChannelDescriptionChannelConfig;
            }

            return $scope.translation.text.INPUT + ' ' + digitalStatus.input;
        };

        var getOutputName = function (digitalStatus) {
            if (digitalStatus.destinationChannelName) {
                return digitalStatus.destinationChannelName;
            }

            return $scope.translation.text.RELAY + ' ' + digitalStatus.output;
        };

        $scope.fnChangeLanguage = function () {
            if ($scope.alerts.length > 0 && $scope.alerts[0].languageCode) {
                var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }

            //TODO: This should be unnecessary
            $timeout(function () {
                $scope.windowTitle = $scope.translation.text.DIGITAL_INTERCONNECT_CHART + ", " + $scope.details.sourceName + ', ' + getInputName($scope.details) + " -> " +
                    $scope.details.destinationName + ', ' + getOutputName($scope.details);

                $scope.popup.dialog("option", "title", $scope.windowTitle);
            });

        };

        $scope.$on('digital_intertie_deleted', function(e, repId) {
            var digitalIntertieId = $scope.stickyProperties.deviceId;
            if (repId == digitalIntertieId) {
                $scope.popup.dialog("close");
            }
        });
    }
]);

mcapp.directive('digitalIntertieChart', ['$rootScope', '$timeout', 'interconnectListService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'sharedSetupService', 'openViewService', '$location', 'rangeSelectorService', function ($rootScope, $timeout, interconnectListService, datetimeService, websocketService, timeLapseService, toaster, sharedSetupService, openViewService, $location, rangeSelectorService) {
    return {
        link: function (scope, element, attrs) {
            var chart;
            var xValue = null;
            var scrollingInProgress = false;
            var zoomLevelCurrent, zoomLevelPrevious = 0;
            scope.downloadViewTypeOptions = [1];
            scope.liveData  = true;
            var initialLoad = true;

            if (!$rootScope.mobile && !$rootScope.classicView) {
                scope.popup = _this.getExistingDialog(scope.windowId).ref;
                sharedSetupService.maximize(scope.popup);
            }

            element.attr("class", "chart");

            element.on('mousewheel', function (event) {
                if (!scrollingInProgress)
                    scope.mouseWheelZoom(event, chart, xValue);
            });

            scope.$on('updatePreferencesLanguage', function () {
                scope.series[0].name = scope.translation.text.INPUT + ': ' + scope.seriesNames[0];
                scope.series[1].name = scope.translation.text.OUTPUT + ': ' + scope.seriesNames[1];
                _drawChart();
            })

            scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
                scope.applyTimeFormat(timeFormat);
                _drawChart();
            });

            scope.applyTimeFormat = function (timeFormat) {
                scope.preferredTimeFormat = parseInt(timeFormat);
            };

            if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

            scope.$watch('lastUpdateAt', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    scope.liveDataIn = !scope.liveDataIn;
                    $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
                }
            }, true);

            var _getData = function (StartDate, EndDate) {

                if (!scope.stickyProperties.deviceId) {
                    $location.path('/interconnect/digital-interconnect-list');
                    return;
                }

                scope.pageloading = true;
                element.empty();

                interconnectListService.getDigitalIntertieChart(scope.accountInfo.customerId, scope.stickyProperties.deviceId, StartDate, EndDate).then(function (resp) {
                    var result = resp.data;
                    scope.nodigital = false;
                    scope.series = result.series;
                    scope.seriesNames = [scope.series[0].name, scope.series[1].name];
                    scope.series[0].name = scope.translation.text.INPUT + ': ' + scope.seriesNames[0];
                    scope.series[1].name = scope.translation.text.OUTPUT + ': ' + scope.seriesNames[1];
                    scope.DigitalSettings = result.digitalSettings;
                    scope.relaySettings = result.relaySettings;
                    //scope.maxChannel = scope.DigitalSettings[scope.DigitalSettings.length - 1].channel;//query is select order by channel asc, so will get the largest channel number
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: StartDate, dataMax: EndDate, windowId: scope.windowId });

                    _drawChart();
                }, function (resp) {
                    var error = resp.data;
                    var errormsg = eval("scope.translation.message." + error.message);
                    scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
                }).finally(function () {
                    scope.pageloading = false;
                });
            };

            function init() {
                var tmpDates, tmpStartDate = null, tmpEndDate = null;
                scope.loadingInProgress = true;

                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) {
                    scope.stickyProperties.on = true;
                    tmpStartDate = scope.stickyProperties.dateMin;
                    tmpEndDate = scope.stickyProperties.dateMax;
                }
                else {
                    scope.stickyProperties.on = false;
                }

                if (!tmpStartDate) {
                    timeLapseService.getLocalDateTime().then(function (result) {
                        tmpDates = new Date(result.data.localDateTime);
                        tmpDates.setHours(0, 0, 0, 0);
                        tmpDates = datetimeService.dateToUnixtime(tmpDates);
                        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                        tmpStartDate = tmpDates.startDate;
                        tmpEndDate = tmpDates.endDate;
                        _getData(tmpStartDate, tmpEndDate);
                    });
                }
                else {
                    _getData(tmpStartDate, tmpEndDate);
                }
            }

            init();

            scope.zoomAdjust = function (varDay) {
                var chart = element.highcharts();
                var extremeMinMax = rangeSelectorService.getChartExtremes(chart.xAxis[1].dataMax, chart.xAxis[1].dataMin, varDay, scope.heartbeatLocalDateTime);
                chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
                _setLiveDataStatus();
            }

            scope.mostRecentData = function () {
                var tmpDates = new Date();
                scope.myDate = null;
                scope.loadingInProgress = true;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                toaster.pop('success', scope.windowTitle, scope.translation.text.VIEW_RELOADING);
                _getData(tmpDates.startDate, tmpDates.endDate);
            }

            scope.selectMyDateC = function () {
                var tmpDates = scope.myDate;
                scope.loadingInProgress = true;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                _getData(tmpDates.startDate, tmpDates.endDate);
            };

            var getTooltip = function (channel) {
                var tmpFontSize = "12px";
                tmpFontSize = element.height() < 400 && scope.DigitalSettings.length > 8 ? "8px" : tmpFontSize;
                tmpFontSize = element.height() < 330 && scope.DigitalSettings.length > 8 ? "4px" : tmpFontSize;
                for (var i = 0; i < scope.DigitalSettings.length; i++) {
                    if (scope.DigitalSettings[i].channel === channel)
                        return "<span style='font-size: " + tmpFontSize + ";' title='" + scope.DigitalSettings[i].description + "'>" + channel + "</span>";
                }
                return "<span>" + channel + "</span>";
            }

            var removeSeriesDuplicates = function (seriesData) {
                var seen = {};
                var filteredData = [];
                for (var j = 0; j < seriesData.length; j++) {
                    var point = seriesData[j];
                    var x = point[0];

                    if (!seen[x]) {
                        seen[x] = true;
                        filteredData.push(point);
                    }
                }
                return filteredData;
            }

            var _drawChart = function (resetView) {
                var tmpData = scope.series, chartDrawn = false;
                scope.numberOfSeries = scope.series.length;
                scope.numberOfHiddenSeries = 0;
                //var numberOfSeries, numberOfHiddenSeries = 0;
                var _tmpTimer;

                var chartXaxisHourFormat =
                    scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian
                        ? '%l:%M %P'
                        : '%H:%M';

                Highcharts.setOptions({
                    chart: {
                        style: {
                            fontFamily: 'arial'
                        }
                    },
                    loading: {
                        labelStyle: {
                            color: 'black'
                        },
                        style: {
                            position: 'absolute',
                            backgroundColor: 'transparent',
                            opacity: 1,
                            textAlign: 'center'
                        }
                    },
                    lang: {
                        loading: '<div class="imgtxtlod" title="Loading data..."><i class="fa fa-spinner fa-spin fa-3x red imglodred"></i> <span class="txtlodblk">Loading data...</span></div>',
                        rangeSelectorZoom: ''
                    }
                });
                chart = new Highcharts.StockChart({
                    credits: {
                        enabled: false
                    },
                    legend: {
                        enabled: true,
                        backgroundColor: '#f9f9f9',
                        borderColor: '#cccccc',
                        borderWidth: 1,
                        itemHoverStyle: {
                            cursor: 'default'
                        }
                    },
                    time: {
                        getTimezoneOffset: function (timestamp) {
                            return -moment.tz(timestamp, datetimeService.getTimeZoneId(scope.accountInfo.timeZone)).utcOffset();
                        }
                    },
                    chart: {
                        renderTo: element[0],
                        backgroundColor: '#ebebeb',
                        plotBackgroundColor: '#f9f9f9',
                        borderColor: '#cccccc',
                        borderWidth: 1,
                        borderRadius: 2,
                        panning: true,
                        panKey: 'shift',
                        pinchType: 'x',
                        plotBorderWidth: 1,
                        marginTop: 10,
                        marginLeft: 10,
                        marginRight: 10,
                        spacingBottom: 10,
                        spacingTop: 0,
                        spacingLeft: 2,
                        spacingRight: 5,
                        animation: false,
                        reflow: true,
                        events: {
                            redraw: function (event) {
                                var extremes = this.xAxis[0].getExtremes();
                                if (this.xAxis && chartDrawn === true && scrollingInProgress === false) {
                                    //drag to left
                                    if (!scope.liveupdate && extremes && extremes.dataMin >= extremes.min - scope.liveDataOffset * 2) {
                                        scrollingInProgress = true;
                                        this.showLoading();

                                        tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -11);
                                        tmpStartDate = tmpDates.startDate;
                                        tmpEndDate = tmpDates.endDate;
                                        interconnectListService.getDigitalIntertieChart(scope.accountInfo.customerId, scope.stickyProperties.deviceId, tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                                            var result = resp.data;
                                            for (var i = 0; i < result.series.length; i++) {
                                                removeNull(i);

                                                scope.series[i].data = result.series[i].data.concat(scope.series[i].data);
                                                scope.series[i].data = removeSeriesDuplicates(scope.series[i].data);
                                                chart.series[i].setData(scope.series[i].data);
                                                //var seen = {};
                                                //var filteredData = [];
                                                //for (var j = 0; j < scope.series[i].data.length; j++) {
                                                //    var point = scope.series[i].data[j];
                                                //    var x = point[0];

                                                //    if (!seen[x]) {
                                                //        seen[x] = true;
                                                //        filteredData.push(point);
                                                //    }
                                                //}                                                
                                            }
                                            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: tmpDates.startDate, windowId: scope.windowId });
                                        }).finally(function () {
                                            $timeout(function () {
                                                scrollingInProgress = false;
                                            }, 1000);
                                            chart.hideLoading();
                                            _setLiveDataStatus();
                                        });

                                    }
                                    //drag to right
                                    else if (scope.liveData === false && extremes && extremes.max + scope.liveDataOffset >= extremes.dataMax) {
                                        scrollingInProgress = true;
                                        this.showLoading();

                                        tmpDates = datetimeService.getNewStartEndDates(parseInt(extremes.dataMax), 11);

                                        tmpStartDate = tmpDates.startDate;
                                        tmpEndDate = tmpDates.endDate;
                                        interconnectListService.getDigitalIntertieChart(scope.accountInfo.customerId, scope.stickyProperties.deviceId, tmpDates.startDate, tmpDates.endDate).then(function (resp) {
                                            var result = resp.data;
                                            for (var i = 0; i < result.series.length; i++) {
                                                removeNull(i);

                                                scope.series[i].data = scope.series[i].data.concat(result.series[i].data);
                                                scope.series[i].data = removeSeriesDuplicates(scope.series[i].data);
                                                chart.series[i].setData(scope.series[i].data);
                                            }
                                            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMax: tmpDates.endDate, windowId: scope.windowId });
                                        }, function (resp) {
                                            var error = resp.data;
                                            var errormsg = eval("scope.translation.message." + error.message);
                                            toaster.pop('error', $scope.windowTitle, errormsg);
                                        }).finally(function () {
                                            $timeout(function () {
                                                scrollingInProgress = false;
                                            }, 1000);
                                            chart.hideLoading();
                                            _setLiveDataStatus();
                                        });
                                    }
                                }
                            },
                            load: function (event) {
                                if (initialLoad) openViewService.adjustContentSize(scope.popup);
                                initialLoad = false;
                            }
                        }
                    },
                    title: {
                        style: {
                            color: '#6D869F',
                            fontWeight: 'bold'
                        }
                    },
                    subtitle: {
                        text: null
                    },
                    exporting: {
                        enabled: false
                    },
                    xAxis: {
                        title: {
                            text: scope.translation.text.TIME,
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold',
                                fontSize: '15px'
                            }
                        },
                        endOnTick: true,
                        showLastLabel: true,
                        startOnTick: true,
                        ordinal: false,
                        minTickInterval: 3600 * 1000,
                        minRange: 3600 * 1000,
                        // minorGridLineColor: '#ebebeb',
                        // minorTickInterval: 'auto',
                        dateTimeLabelFormats: {
                            hour: chartXaxisHourFormat
                        },
                        labels: {
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold'
                            }
                        },
                        events: {
                            afterSetExtremes: function (e) {
                                if (chartDrawn === true) {
                                    if (e.trigger === 'rangeSelectorButton') {

                                        var newRanges = rangeSelectorService.getrangeExtremes(e.dataMax, e.dataMin, e.rangeSelectorButton, scope.dataGroupingInterval);

                                        sharedSetupService.setStickyProperties(
                                            scope.stickyProperties,
                                            {
                                                zoomMin: newRanges.newMin,
                                                zoomMax: newRanges.newMax,
                                                windowId: scope.windowId
                                            }
                                        );
                                        scope.stickyProperties.on = true;
                                        //Reload
                                        if (newRanges.newDataMax < event.dataMin || newRanges.newDataMax > event.dataMax)
                                            _getData(scope.stickyProperties.deviceId, newRanges.newDataMin, newRanges.newDataMax);

                                    }
                                    else {
                                        var extremes = chart.xAxis[0].getExtremes();
                                        if (scope.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) { //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                            if (extremes.max + scope.liveDataOffset <= extremes.dataMax) {
                                                _unRegisterListener(scope.deviceSelectedSn);
                                            }
                                        }
                                        sharedSetupService.setStickyProperties(scope.stickyProperties, { zoomMin: extremes.min, zoomMax: extremes.max, windowId: scope.windowId });
                                        //_downsampleSeries(extremes.min, extremes.max);
                                    }
                                }
                            }
                        }
                    },
                    yAxis: {
                        reversed: true,
                        align: 'left',
                        endOnTick: false,
                        showLastLabel: true,
                        showFirstLabel: true,
                        startOnTick: false,
                        labels: {
                            align: 'left',
                            useHTML: true,
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold'
                            },
                            formatter: function () {
                                return getTooltip(this.value);
                            }
                        },
                        minTickInterval: 1,
                        tickInterval: 1,
                        step: 1,
                        min: 0.5,
                        max: 2 + 0.5
                    },
                    tooltip: {
                        useHTML: true,
                        formatter: function () {
                            var tip = "";
                            tip += Highcharts.dateFormat(
                                '%A, %b %e, %Y ' + chartXaxisHourFormat,
                                datetimeService.utcToLocalTimeStampByTimeZone(this.x, scope.accountInfo.timeZone)
                            );

                                $.each(this.points, function (i, point) {
                                var status = "";
                                var seriesData = point.series.data || [];

                                var idx = point.point.index;
                                var nextPoint = (idx + 1 < seriesData.length) ? seriesData[idx + 1] : null;
                                var sourceSetting = _getSourceSetting();
                                var isRelay = point.series.index === 1 || (point.series.index === 0 && _sourceIsRelay()); // series[1] = relay in your chart
                                var isPump = point.series.index === 0 && ((point.series.name || "").toLowerCase().indexOf("pump") > -1 || sourceSetting.digitalMode == "P");
                                var normalOpen = _getSourceNormalState() === 0;

                                // a fault is plotted just off the row
                                if (point.y !== null && point.y !== parseInt(point.y, 10)) {
                                    status = scope.translation.text.FAULT;
                                }
                                else {
                                    // drawn on the row is 1, broken away from it is 0. A point
                                    // followed by a null is the moment the line breaks away, so it
                                    // already carries the 0 state.
                                    var onRow = (point.y !== null && !(nextPoint && nextPoint.y === null)) ? 1 : 0;

                                    // the relay row plots the raw bit, so its row position is that
                                    // bit. The input row is drawn while the input is closed (0, see
                                    // UpdateDIPlotValue), so the row position has to be turned back
                                    // into a bit first. A relay is closed on 1 while a digital input
                                    // is open on 1 (convertStatus in popup-service).
                                    var raw = (point.series.index === 0 && !_sourceIsRelay())
                                        ? _diBitFromRow(onRow)
                                        : onRow;

                                    if (isPump) {
                                        // a pump is stopped while its input sits in the normal state
                                        status = (raw === 1) === normalOpen ? scope.translation.text.STOPPED : scope.translation.text.RUNNING;
                                    }
                                    else if (isRelay) {
                                        status = raw === 1 ? scope.translation.text.CLOSE : scope.translation.text.OPEN;
                                    }
                                    else {
                                        status = raw === 1 ? scope.translation.text.OPEN : scope.translation.text.CLOSE;
                                    }
                                }
                                xValue = point.x;
                                tip += '<br><span style="color: ' + point.series.color + ';">' + point.series.name + '</span>: <b>' +
                                    status +
                                    '</b><br>' + scope.translation.text.DURATION + ':<b>' + getDuriration(point.series.index, point.point.index) + '</b>';
                            });
                        // $.each(this.points, function (i, point) {
                        //     var status = "";
                        //     var seriesName = (point.series.name || "").toLowerCase();

                        //     var isRelay = point.series.index === 1 || (point.series.index === 0 && scope.DigitalSettings[scope.DigitalSettings.length - 1].type == "Relay");
                        //     var isPump = (point.series.index === 0 && (scope.DigitalSettings[scope.DigitalSettings.length - 1].digitalMode == "P" || scope.DigitalSettings[scope.DigitalSettings.length - 1].digitalMode == "R" ));
                        //     var isDigitalInput = !isRelay && !isPump;

                        //     var raw = point.point.options[2]; // 🔥 ACTUAL VALUE (0 / 1)
                        //     var y = point.y;

                        //     // Fault
                        //     if (y !== null && y !== parseInt(y, 10)) {
                        //         status = scope.translation.text.FAULT;
                        //     }
                        //     else if (raw === null) {
                        //         status = isPump 
                        //             ? scope.translation.text.STOPPED 
                        //             : scope.translation.text.OPEN;
                        //     }
                        //     else {
                        //         if (isPump) {
                        //             status = raw === 1 
                        //                 ? scope.translation.text.STOPPED 
                        //                 : scope.translation.text.RUNNING;
                        //         }
                        //         else if (isRelay) {
                        //             // 🔥 Relay logic
                        //             // 0 = OPEN, 1 = CLOSE  
                        //             status = raw === 1 
                        //                 ? scope.translation.text.CLOSE 
                        //                 : scope.translation.text.OPEN;
                        //         }
                        //         else if (isDigitalInput) {
                        //             // 🔥 DI logic
                        //             // 0 = CLOSE, 1 = OPEN
                        //             status = raw === 0 
                        //                 ? scope.translation.text.CLOSE 
                        //                 : scope.translation.text.OPEN;
                        //         }
                        //     }

                        //     tip += '<br><span style="color: ' + point.series.color + ';">' +
                        //         point.series.name +
                        //         '</span>: <b>' +
                        //         status +
                        //         '</b><br>' +
                        //         scope.translation.text.DURATION +
                        //         ': <b>' +
                        //         getDuriration(point.series.index, point.point.index) +
                        //         '</b>';
                        // });

                            return tip;
                        },
                        crosshairs: true,
                        shared: true,
                        valueDecimals: 1,
                        backgroundColor: '#FFFFFF',
                        borderColor: 'gray',
                        borderWidth: 1
                    },
                    navigator: {
                        enabled: true,
                        adaptToUpdatedData: true,
                        series: {
                            lineWidth: 0,
                            color: 'transparent'
                        },
                        maskFill: 'rgba(255, 255, 255, 0.35)',
                        maskInside: true,
                        handles: {
                            backgroundColor: '#a4a7a9',
                            borderColor: '#384450'
                        },
                        height: 22,
                        margin: 0,
                        xAxis: {
                            tickWidth: 2,
                            lineWidth: 1,
                            gridLineWidth: 0,
                            tickLength: 15,
                            tickPosition: 'inside',
                            tickColor: '#98b3d1',
                            dateTimeLabelFormats: {
                                hour: '%l:%M %p',
                            },
                            labels: {
                                align: 'left',
                                style: {
                                    color: '#61768f',
                                    fontWeight: 'bold'
                                },
                                x: 8,
                                y: -8
                            }
                        }
                    },
                    scrollbar: {
                        enabled: true,
                        height: 0,
                        barBackgroundColor: '#959595',
                        barBorderRadius: 2,
                        barBorderWidth: 0,
                        buttonBackgroundColor: '#959595',
                        buttonBorderWidth: 0,
                        buttonBorderRadius: 2,
                        trackBackgroundColor: 'none',
                        trackBorderWidth: 1,
                        trackBorderRadius: 3,
                        trackBorderColor: '#CCC',
                        liveRedraw: true
                    },
                    rangeSelector: {
                        enabled: false
                    },                    
                    plotOptions: {
                        series: {
                            dataGrouping: {
                                enabled: false
                            },
                            point: {
                                events: {
                                    mouseOver: function () {
                                        xValue = this.x;
                                    }
                                }
                            },
                            marker: {
                                fillColor: '#FFFFFF',
                                lineWidth: 2,
                                lineColor: null // inherit from series
                            },
                            events: {
                                legendItemClick: function () {
                                    if (this.visible) {
                                        if (scope.numberOfHiddenSeries < (scope.numberOfSeries - 1)) {
                                            scope.numberOfHiddenSeries = scope.numberOfHiddenSeries + 1;
                                        } else {
                                            return false;
                                        }
                                    } else {
                                        scope.numberOfHiddenSeries = scope.numberOfHiddenSeries - 1;
                                    }
                                },
                                mouseOut: function () {
                                    xValue = null;
                                }
                            }
                        }
                    },
                    series: scope.series

                });

                scope.chart = chart;

                var tmpNewDateA;
                var tmpNewDateB;
                var extremes = chart.xAxis[0].getExtremes();

                if (scope.stickyProperties.on === true) {
                    tmpNewDateA = scope.stickyProperties.zoomMin >= extremes.dataMin ? scope.stickyProperties.zoomMin : extremes.dataMin;//extremes.dataMin + scope.unixDay / 24 * 3;
                    tmpNewDateB = scope.stickyProperties.zoomMax <= extremes.dataMax + scope.liveDataOffset ? scope.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
                    tmpNewDateB = tmpNewDateB >= tmpNewDateA + scope.unixDay / 24 ? tmpNewDateB : extremes.dataMax - scope.unixDay / 24 * 12;
                    scope.stickyProperties.on = false;
                }
                else {
                    tmpNewDateA = scope.myDate !== null ? extremes.dataMin + scope.unixDay : extremes.dataMax - scope.unixDay / 24 * 12;
                    tmpNewDateB = scope.myDate !== null ? tmpNewDateA + scope.unixDay : extremes.dataMax;
                    if (tmpNewDateB > extremes.dataMax) {
                        tmpNewDateB = extremes.dataMax;
                        tmpNewDateA = tmpNewDateB - scope.unixDay;
                    }
                    tmpNewDateA = tmpNewDateA + scope.minPadding;
                    tmpNewDateB = tmpNewDateB + scope.maxPadding;
                }

                chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
                if (scope.series !== null) { //only for analog chart if no setup
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: scope.windowId });
                }
                else {
                    chart.showLoading(scope.translation.text.ANALOG_SETUP_UNAVAILABLE);
                }

                if (!resetView) {
                    _setLiveDataStatus();
                }

                chartDrawn = true;
                scope.loadingInProgress = false;

            };
            var getDuriration = function (serieNumber, index) {

                var duration = null;
                var rightX = getRightX(serieNumber, index);
                var leftX = getLeftX(serieNumber, index);
                duration = millisecondsToStr(rightX - leftX);
                return duration;
            };

            var getRightX = function (serieNumber, index) {
                var chart = element.highcharts();
                var cutSeries = chart.series[serieNumber];
                var curLength = cutSeries.data.length;
                var rightX = null;
                rightX = cutSeries.data[curLength - 1].x;
                //if go right, didn't find null, use the very right point
                if (typeof cutSeries.data[index + 1] === "undefined") {
                    rightX = cutSeries.data[index].x;
                }
                //if the one on the right one is null//it is the very left point, then look for the next not null
                else if (cutSeries.data[index + 1].y === null) {
                    for (var i = index + 1; i < curLength; i++) {
                        if (cutSeries.data[i].y !== null) {
                            rightX = cutSeries.data[i].x;
                            break;
                        }
                    }
                    //if not find any close, right is current use the last data point
                    //rightX = cutSeries.data[curLength - 1].x;
                }
                else {
                    // look for the right
                    for (var i = index + 1; i < curLength; i++) {
                        if (cutSeries.data[i].y === null) {
                            rightX = cutSeries.data[i - 1].x;
                            break;
                        }
                    }
                    // rightX = cutSeries.data[curLength - 1].x;
                }

                return rightX;
            };
            var getLeftX = function (serieNumber, index) {
                var chart = element.highcharts();
                var cutSeries = chart.series[serieNumber];
                var leftX = null;

                leftX = scope.series[serieNumber].data[0][0];
                //if the point is the very left point, use itself
                if (typeof cutSeries.data[index - 1] === "undefined") {
                    leftX = cutSeries.data[index].x;
                }
                else if (typeof cutSeries.data[index + 1] === "undefined") {//last data
                    for (var t = index - 1; t >= 0; t--) {
                        if (cutSeries.data[t].y === null) {
                            leftX = cutSeries.data[t + 1].x;
                            break;
                        }
                    }
                }
                //if the one on the left is null//it is the very right point, use the point itself
                else if (cutSeries.data[index + 1].y === null) {
                    leftX = cutSeries.data[index].x;
                }
                else {
                    for (var t = index - 1; t >= 0; t--) {
                        if (cutSeries.data[t].y === null) {
                            leftX = cutSeries.data[t + 1].x;
                            break;
                        }
                    }
                }

                return leftX;
            };


            var millisecondsToStr = function (milliseconds) {
                // TIP: to find current time in milliseconds, use:
                // var  current_time_milliseconds = new Date().getTime();

                function numberEnding(number) {
                    return (number > 1) ? 's' : '';
                }

                var temp = Math.floor(milliseconds / 1000);
                var years = Math.floor(temp / 31536000);
                if (years) {
                    return years + ' ' + scope.translation.text.YEAR + numberEnding(years);
                }
                //TODO: Months! Maybe weeks?
                var days = Math.floor((temp %= 31536000) / 86400);
                if (days) {

                    temp = temp - days * 86400;
                    var rhours = Math.floor((temp %= 86400) / 3600);
                    if (rhours > 0)
                        return days + ' ' + scope.translation.text.DAY + numberEnding(days) + ' ' + rhours + ' ' + scope.translation.text.HOUR + numberEnding(rhours);
                    else
                        return days + ' ' + scope.translation.text.DAY + numberEnding(days);
                }
                var hours = Math.floor((temp %= 86400) / 3600);
                if (hours) {
                    temp = temp - hours * 3600;
                    var rminutes = Math.floor((temp %= 3600) / 60);
                    if (rminutes > 0)
                        return hours + ' ' + scope.translation.text.HOUR + numberEnding(hours) + ' ' + rminutes + ' ' + scope.translation.text.MINUTE + numberEnding(rminutes);
                    else
                        return hours + ' ' + scope.translation.text.HOUR + numberEnding(hours);
                }
                var minutes = Math.floor((temp %= 3600) / 60);
                if (minutes) {
                    return minutes + ' ' + scope.translation.text.MINUTE + numberEnding(minutes);
                }
                var seconds = temp % 60;
                if (seconds) {
                    return seconds + ' ' + scope.translation.text.SECOND + numberEnding(seconds);
                }
                return scope.translation.text.LESS_THAN_A_SECOND; //'just now' //or other string you like;
            };
            //==========================socket data================================
            var wsDataReceivedRelay = function (data) {
                $timeout(function () {
                    var channel = parseInt(data.CH, 10);
                    var channelOut = scope.details ? parseInt(scope.details.output, 10) : NaN;

                    // the feed carries every relay on the destination device, but
                    // series[1] only ever plots this intertie's output channel
                    if (isNaN(channelOut) || channel !== channelOut) {
                        return;
                    }

                    var x = datetimeService.toUnixtime(data.Time);
                    x = datetimeService.localToUtcTimeStampByTime(x, scope.accountInfo.timeZone);

                    var relayVal = data.Value;
                    var y = null;
                    var value = 0;
                    var chart = element.highcharts();

                    if (!chart || !chart.series || !chart.series[1] ) {
                        return;
                    }

                    removeNull(1);

                    var cutSeries = chart.series[1];
                    var lastPoint = (cutSeries.data && cutSeries.data.length > 0)
                        ? cutSeries.data[cutSeries.data.length - 1]
                        : null;

                    var preValue = lastPoint ? lastPoint.y : null;

                    // the output is always drawn on the second row of the chart
                    value = UpdatePlotValue(relayVal, 2);

                    y = value === null ? null : parseFloat(value);

                    // closed/fault -> open
                    if (preValue !== null && y === null) {
                        cutSeries.addPoint([x, preValue], false, false, false);
                        scope.series[1].data.push([x, preValue, 1]);

                        cutSeries.addPoint([x + 100, null], false, false, false);
                        scope.series[1].data.push([x + 100, null, 1]);
                    }
                    // open -> closed/fault
                    else if (preValue === null && y !== null) {
                        cutSeries.addPoint([x, y], false, false, false);
                        scope.series[1].data.push([x, y, 1]);
                    }
                    // closed <-> fault
                    else if (preValue !== null && y !== null && y !== preValue) {
                        cutSeries.addPoint([x - 100, null], false, false, false);
                        scope.series[1].data.push([x - 100, null, 1]);

                        cutSeries.addPoint([x, y], false, false, false);
                        scope.series[1].data.push([x, y, 1]);
                    }
                    // same state
                    else {
                        cutSeries.addPoint([x, y], false, false, false);
                        scope.series[1].data.push([x, y, 1]);
                    }

                    chart.redraw();

                    var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                    scope.lastUpdateAt = varTime;
                }, 200);
            };


            var wsDataReceivedDI = function (data) {
                $timeout(function () {
                    var channel = parseInt(data.CH, 10);
                    var channelIn = _getSourceChannel();
                    // every digital input on the source device arrives on this feed,
                    // but series[0] only ever plots this intertie's input channel
                    if (channelIn === null || channel !== channelIn) {
                        return;
                    }

                    var x = datetimeService.toUnixtime(data.Time);
                    x = datetimeService.localToUtcTimeStampByTime(x, scope.accountInfo.timeZone);

                    var chValue = data.Value;
                    var chart = element.highcharts();

                    var value = 0;
                    var y = null;

                    if (!chart || !chart.series || !chart.series[0]) {
                        return;
                    }

                    removeNull(0);

                    // Fault handling
                    if (scope.faultData !== undefined && scope.faultData !== null) {
                        if (scope.faultData[channel - 1] === '1') {
                            chValue = null;
                        }
                    }

                    var cutSeries = chart.series[0];
                    var lastPoint = (cutSeries.data && cutSeries.data.length > 0)
                        ? cutSeries.data[cutSeries.data.length - 1]
                        : null;

                    var preValue = lastPoint ? lastPoint.y : null;

                    // the input is always drawn on the first row of the chart
                    value = UpdateDIPlotValue(chValue, 1);

                    y = value === null ? null : parseFloat(value);

                    // From closed/fault -> open
                    if (preValue !== null && y === null) {
                        cutSeries.addPoint([x, preValue], false, false, false);
                        scope.series[0].data.push([x, preValue, 1]);

                        cutSeries.addPoint([x + 100, null], false, false, false);
                        scope.series[0].data.push([x + 100, null, 1]);
                    }
                    // From open -> closed/fault
                    else if (preValue === null && y !== null) {
                        cutSeries.addPoint([x, y], false, false, false);
                        scope.series[0].data.push([x, y, 1]);
                    }
                    // From fault -> close or close -> fault
                    else if (preValue !== null && y !== null && y !== preValue) {
                        cutSeries.addPoint([x - 100, null], false, false, false);
                        scope.series[0].data.push([x - 100, null, 1]);

                        cutSeries.addPoint([x, y], false, false, false);
                        scope.series[0].data.push([x, y, 1]);
                    }
                    // Same state
                    else {
                        cutSeries.addPoint([x, y], false, false, false);
                        scope.series[0].data.push([x, y, 1]);
                    }

                    chart.redraw();

                    scope.lastUpdateAt = datetimeService.socketStrToServerStrTime(data.Time);
                }, 200);
            };

            var removeNull = function (serieNumber) {
                var chart = element.highcharts();
                if (!chart || !chart.series || !chart.series[serieNumber]) {
                    return;
                }

                var cutSeries = chart.series[serieNumber];
                if (!scope.series || !scope.series[serieNumber] || !scope.series[serieNumber].data) {
                    return;
                }

                while (scope.series[serieNumber].data.length > 0) {
                    var pointindex = scope.series[serieNumber].data.length - 1;
                    var point = scope.series[serieNumber].data[pointindex];

                    if (!point || point[2] !== 0) {
                        break;
                    }

                    if (cutSeries.data[pointindex]) {
                        cutSeries.data[pointindex].remove(false);
                    }

                    scope.series[serieNumber].data.splice(pointindex, 1);
                }
            };

            var wsReconnectDI = function (data) {

                if (scope.liveData === false) {
                    _unRegisterListener();
                    return;
                }
                if (data.Channel != 1)
                    return;
                toaster.pop('success', scope.windowTitle + " -- " + scope.devicename, ' ' + scope.translation.text.VIEW_RELOADING);
                var tmpStartDate = null, tmpEndDate = null;
                scope.stickyProperties.on = true;
                tmpStartDate = scope.stickyProperties.dateMin;
                tmpEndDate = scope.stickyProperties.dateMax;
                _getData(tmpStartDate, tmpEndDate);

            };

            var tlDataReceived = function (data) {
                data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, scope.accountInfo.timeZone);

                if (scope.liveData === false) {
                    _unRegisterListener();
                    return;
                }
                var extremes = chart.xAxis[0].getExtremes();
                var tmpRange = extremes.max - extremes.min;

                if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - scope.unixDay / 2) {
                    _unRegisterListener();
                    return;
                }

                if (extremes.max + scope.liveDataOffset > extremes.dataMax) {
                    var x = data.Unix + scope.maxPadding;

                    for (var t = 0; t < scope.series.length; t++) {
                        // drop the point the previous heartbeat extended the line with
                        removeNull(t);

                        var series = chart.series[t];
                        var dataseries = scope.series[t];
                        var lastIndex = dataseries.data.length - 1;

                        if (lastIndex < 0 || typeof dataseries.data[lastIndex] === "undefined") {
                            continue;
                        }

                        var y = dataseries.data[lastIndex][1];

                        // the trailing 0 marks this as extrapolated up to the heartbeat so
                        // removeNull() can strip it again - it also keeps scope.series index
                        // aligned with chart.series, which removeNull, getLeftX/getRightX and
                        // the tooltip all rely on
                        series.addPoint([x, y], false, false, false);
                        dataseries.data.push([x, y, 0]);
                    }
                    scope.firsttime = false;
                    chart.xAxis[0].setExtremes(data.Unix - tmpRange + scope.minPadding, data.Unix + scope.maxPadding);
                }
            }

            // the socket sends the state as "0"/"1", but older feeds use booleans or
            // "True"/"False", so it is normalised to a bit before it is compared
            var _toBit = function (state) {
                if (state === null || state === undefined) {
                    return null;
                }
                if (state === true || state === false) {
                    return state ? 1 : 0;
                }

                var text = state.toString().trim().toLowerCase();
                if (text === "true") return 1;
                if (text === "false") return 0;

                var number = parseInt(text, 10);
                return isNaN(number) ? null : (number === 0 ? 0 : 1);
            };

            // the relay row plots the raw bit: a line sits on the row while the bit is 1
            // and breaks away from it while the bit is 0. normalClosed is deliberately
            // not used here: it only selects the normal/off-normal wording.
            var UpdatePlotValue = function (value, index) {
                if (value === null || value === undefined || value === "" || value === "null") {
                    return index - 0.2; // fault
                }

                var raw = _toBit(value);
                if (raw === null) {
                    return index - 0.2; // fault
                }

                return raw === 1 ? index : null;
            };

            // the digital input row is plotted the way the server plots its history
            // (UpdateValue in DigitalIntertieChartManager): a digital input is closed on 0
            // and open on 1 (convertStatus in popup-service), so the line sits on the row
            // while the input is closed and breaks away while it is open. normalClosed is
            // not used - comparing against it drew the opposite state to the history on a
            // normally closed channel. A relay source plots its raw bit like the relay row
            // (UpdateValueRelay with "+" polarity on the server).
            var UpdateDIPlotValue = function (value, index) {
                if (value === null || value === undefined || value === "" || value === "null") {
                    return index - 0.2; // fault
                }

                var raw = _toBit(value);
                if (raw === null) {
                    return index - 0.2; // fault
                }

                if (_sourceIsRelay()) {
                    return raw === 1 ? index : null;
                }

                return raw === 0 ? index : null;
            };

            // the inverse of UpdateDIPlotValue: on the row is 0 (closed) for a digital
            // input and 1 for a relay source
            var _diBitFromRow = function (onRow) {
                if (_sourceIsRelay()) {
                    return onRow;
                }
                return onRow === 1 ? 0 : 1;
            };

            // details.input is the source channel, negative when a relay on the source
            // device drives the intertie (see getInputName in the controller)
            var _getSourceChannel = function () {
                if (!scope.details) {
                    return null;
                }

                var input = parseInt(scope.details.input, 10);
                if (isNaN(input)) {
                    return null;
                }
                return isNaN(input) ? null : Math.abs(input);
            };

            var _sourceIsRelay = function () {
                return !!scope.details && parseInt(scope.details.input, 10) < 0;
            };

            // DigitalSettings holds a row per plotted row, and the source channel and the
            // destination relay routinely carry the same channel number (DI1 -> Relay 1),
            // so the channel alone does not identify the source - the sign of details.input
            // decides which of the two rows describes it
            var _getSourceSetting = function () {
                var settings = scope.DigitalSettings;
                if (!settings || !settings.length) {
                    return {};
                }

                var channel = _getSourceChannel();
                var sourceIsRelay = _sourceIsRelay();
                var fallback = null;

                for (var i = 0; i < settings.length; i++) {
                    if ((settings[i].type == "Relay") !== sourceIsRelay) {
                        continue;
                    }
                    if (channel !== null && parseInt(settings[i].channel, 10) === channel) {
                        return settings[i];
                    }
                    if (fallback === null) {
                        fallback = settings[i];
                    }
                }

                return fallback === null ? settings[0] : fallback;
            };

            // normalClosed on the source row: 1 = normally closed, 0 = normally open,
            // null when the row is missing or carries no setting. It only selects the
            // normal/off-normal wording - the plotted bit stays raw (see UpdatePlotValue)
            var _getSourceNormalState = function () {
                var normalClosed = parseInt(_getSourceSetting().normalClosed, 10);
                return isNaN(normalClosed) ? null : (normalClosed === 0 ? 0 : 1);
            };


            var _setLiveDataStatus = function () {
                // scope.liveDataIn = varEndDate != null ? varEndDate : scope.liveDataEndDate;
                timeLapseService.getLocalDateTime().then(function (result) {
                    scope.heartbeatLocalDateTime = result.data.unixTimeStamp;
                    if (scope.stickyProperties.zoomMax + scope.liveDataOffset >= result.data.unixTimeStamp) {
                        _registerListener();
                    }
                    else {
                        _unRegisterListener();
                    }
                });
            };

            var _registerListener = function () {
                websocketService.connect();
                sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });

                websocketService.register('DIGITALINPUT', scope.details.sourceSerial, '', wsDataReceivedDI, wsReconnectDI);
                timeLapseService.register('INPUTS', scope.details.sourceSerial, '', tlDataReceived);

                websocketService.register('DIGITALOUTPUT', scope.details.destinationSerial, '', wsDataReceivedRelay, null);
                //timeLapseService.register('RELAYS', scope.details.destinationSerial, '', tlDataReceivedRelay);

                scope.liveData = true;
            };

            var _unRegisterListener = function () {
                if (!angular.isDefined(scope.details)) return;
                sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });

                websocketService.unRegister('DIGITALINPUT', scope.details.sourceSerial, '', wsDataReceivedDI, wsReconnectDI);
                timeLapseService.unRegister('INPUTS', scope.details.sourceSerial, '', tlDataReceived);

                websocketService.unRegister('DIGITALOUTPUT', scope.details.destinationSerial, '', wsDataReceivedRelay);
                //timeLapseService.unRegister('RELAYS', scope.details.destinationSerial, '', tlDataReceivedRelay);

                scope.liveData = false;
                scope.lastUpdateAt = undefined;
            };

            var _downsampleSeries = function (varMin, varMax) {
                zoomLevelCurrent = varMax - varMin;
                if (zoomLevelCurrent <= scope.unixDay && zoomLevelPrevious > scope.unixDay) {
                    for (var i = 0; i < chart.series.length - 1; i++) {
                        chart.series[i].update({ downsample: { threshold: 0 } }, false);
                        chart.series[i].setData(scope.series[i].data, false);
                    }
                    chart.redraw();
                }
                else if (zoomLevelCurrent > scope.unixDay && zoomLevelPrevious <= scope.unixDay) {
                    for (var i = 0; i < chart.series.length - 1; i++) {
                        chart.series[i].update({ downsample: { threshold: 1000 } }, false);
                    }
                    chart.redraw();
                }
                zoomLevelPrevious = zoomLevelCurrent;
            };

            scope.$on("$destroy", function () {
                _unRegisterListener();
            });
        }
    }
}]);

(function () {
    var dilCont = function ($scope, authenticationService, translationService, interconnectListService, sharedSetupService, openViewService, websocketService, datetimeService, $location) {
        var self = this;
        var popupOffset = 0;
        var spinner = "<i class='fa fa-spinner fa-2x fa-spin'></i>";
        var okCheck = "<i class='fa fa-check fa-2x fa-green' ></i>";
        var errorCheck = "<i class='fa fa-exclamation-circle fa-2x fa-red'></i>";
        var resetIndicator = "<i class='fa fa-fw fa-2x'>&nbsp;</i>";
        var accountInfo = authenticationService.getAccountInfo();
        this.relayModes = [{ Name: "FORCED_OFF", Id: 0 },
        { Name: "FORCED_ON", Id: 1 },
        { Name: "AUTOMATIC", Id: 2 },
        { Name: "DISABLED", Id: 3 }];

        this.translation = translationService.translation;
        var windowTitle = this.translation.text.DIGITAL_INTERCONNECT_LIST;

        if (!$scope.mobile && !$scope.classicView) {
            var popup = _this.getExistingDialog($scope.windowId).ref;
            popup.dialog('option', 'title', windowTitle);
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                //$scope.adjustDeviceIdMenuSize();
            };
        }

        this.getRelayModeName = function (text) {
            if (!angular.isDefined(text)) return;
            return eval("$scope.translation.text." + text.toUpperCase());
        };
        //TODO: Does this need to stay on the scope because of silly magic?
        $scope.fnChangeLanguage = function () {
            windowTitle = this.translation.text.DIGITAL_INTERCONNECT_LIST;
            popup.dialog('option', 'title', windowTitle);
        }

        //$scope necessary here for event listening
        $scope.$on("$destroy", function () {
            _unRegisterListener();
        });

        this.getInputName = function (digitalStatus) {
            if (digitalStatus.sourceChannelName) {
                return digitalStatus.sourceChannelName;
            }

            return this.translation.text.INPUT + ' ' + digitalStatus.input;
        };

        this.getOutputName = function (digitalStatus) {
            if (digitalStatus.destinationChannelName) {
                return digitalStatus.destinationChannelName;
            }

            return this.translation.text.RELAY + ' ' + digitalStatus.output;
        };

        this.dateAgentText = function (date) {
            if (date == null)
                return '-';
            return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, accountInfo.preferenceUser.timeFormat);
        }

        this.getLastOperation = function (date) {
            if (date === '0001-01-01T00:00:00') {
                return '--';
            }

            return this.dateAgentText(date);
        };

        this.isAdmin = function () {
            return accountInfo.userRole === 'Administrator' || accountInfo.userRole === 'SuperAdministrator';
        }

        this.parseStatus = function (status) {
            if (status == 1)
                return this.translation.text.OK;
            if (status == 2)
                return this.translation.text.PENDING;

            return this.translation.text.BAD;
        }

        this.getStatusColor = function (status) {
            if (status == 1)
                return 'lightgreen';
            if (status == 2)
                return 'yellow';
            return 'tomato';
        }

        //TODO: Not currently being used, may be necessary again in future
        // this.sourceOnline = function (status) {
        //   return ((status.sourceIsOnline) || (status.sourceDeviceIsM80 && (status.sourceM80LastHeard > new Date() - 3.5)));
        // }

        this.describeDigitalIntertieMode = function (statusMode) {
            var mode;

            switch (statusMode) {
                case 0:
                    mode = this.translation.text.OFF;
                    break;
                case 1:
                    mode = this.translation.text.ON;
                    break;
                case 2:
                    mode = this.translation.text.AUTOMATIC;
                    break;
                case 3:
                    mode = this.translation.text.DISABLED;
                    break;
            }

            return mode;
        }

        this.updateStatus = function (status) {
            resetUpdateIndicator();
            status.updateState = spinner;
            interconnectListService.updateDigitalStatus(status, accountInfo.customerId).then(function (resp) {
                status.updateState = okCheck;
            }, function (resp) {
                status.updateState = errorCheck;
            });
        };

        resetUpdateIndicator = function () {
            for (var i = 0; i < self.digitalStatusList.length; i++) {
                self.digitalStatusList[i].updateState = resetIndicator;
            }
        };

        //Determine if the window has a scrollbar. Used to keep columns aligned with headers in both cases.
        this.hasOverflow = function () {
            var element = document.getElementById('digitalIntertieList');
            if (element.offsetHeight < element.scrollHeight)
                return true;
            return false;
        }

        this.openDetail = function (type, digitalIntertieId) {
            var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
            optionsStickyProperties.intertieId = digitalIntertieId;
            optionsStickyProperties.deviceId = digitalIntertieId;

            if ($scope.classicView || $scope.mobile) {
                $location.path('/interconnect/digital-intertie-chart');
            }
            else {

                var detailType;
                var width;

                if (type == 'log') {
                    detailType = 'Digital Intertie Log';
                    width = 750;
                } else if (type == 'chart') {
                    detailType = 'Digital Intertie Chart';
                    width = 750;
                }

                var popheight = 500;
                var popupPosition = popup.dialog("option", "position");
                var x = popup.offset().left;
                var y = popup.offset().top;
                var dialogWidth = popup.dialog("option", "width");
                var windowWidth = window.innerWidth;
                popupPosition.at = "left+" + (x + dialogWidth + popupOffset) + " top+" + (y + popupOffset);
                popupOffset = popupOffset + 10;
                openViewService.openView(detailType, { width: width, height: popheight }, popupPosition, optionsStickyProperties);
            }
        };

        // Fetches the latest digital interconnect status list. On the initial load it wires
        // up the websocket listeners; subsequent (interval) refreshes only update the data.
        this.refreshStatus = function (isInitialLoad) {
            if (isInitialLoad) {
                self.isLoading = true;
            }

            return interconnectListService.getDigitalInterconnectList(accountInfo.customerId).then(function (resp) {
                self.digitalStatusList = resp.data;

                for (var i = 0; i < self.digitalStatusList.length; i++) {
                    switch (self.digitalStatusList[i].input) {
                        case -1:
                            self.digitalStatusList[i].relay = "RLY1";
                            break;
                        case -2:
                            self.digitalStatusList[i].relay = "RLY2";
                            break;
                        case -3:
                            self.digitalStatusList[i].relay = "RLY3";
                            break;
                        case -4:
                            self.digitalStatusList[i].relay = "RLY4";
                            break;
                        case -5:
                            self.digitalStatusList[i].relay = "RLY5";
                            break;
                        case -6:
                            self.digitalStatusList[i].relay = "RLY6";
                            break;
                        case -7:
                            self.digitalStatusList[i].relay = "RLY7";
                            break;
                        case -8:
                            self.digitalStatusList[i].relay = "RLY8";
                            break;
                        case -9:
                            self.digitalStatusList[i].relay = "RLY9";
                            break;
                    }
                }

                if (isInitialLoad) {
                    _registerListener();
                }
            }, function (resp) {
                var errormsg = eval("self.translation.message." + resp.error.message);
                self.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            }).finally(function () {
                if (isInitialLoad) {
                    self.isLoading = false;
                }
            });
        };

        this.refreshStatus(true);

        // Manual refresh triggered by the toolbar button. The refresh-live-data
        // component handles disabling the button and the 30-second cooldown.
        this.manualRefresh = function () {
            self.refreshStatus(false);
        };

        var wsDataReceivedDIL = function (data) {
            var i = 0;
            if ($scope.liveData === false) {
                _unRegisterListener();
                return;
            }

            var updateRowIdx = _.findIndex(this.digitalStatusList, function (o) { return o.interconnectID == data.InterconnectId });
            if (updateRowIdx != -1) {
                this.digitalStatusList[updateRowIdx].sourceIsOnline = data.SourceOnline;
                this.digitalStatusList[updateRowIdx].destinationIsOnline = data.DestOnline;
                if (data.Status == "OK")
                    this.digitalStatusList[updateRowIdx].status = 1;
                else if (data.Status == "PENDING")
                    this.digitalStatusList[updateRowIdx].status = 2;
                else
                    this.digitalStatusList[updateRowIdx].status = 0;
            }

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            this.digitalStatusList[updateRowIdx].lastOperation = varTime;
            this.lastUpdateAt = varTime;
        };

        var wsReconnectDIL = function (data) {
            if ($scope.liveData === false) {
                _unRegisterListener();
                return;
            }
        };

        var wsDataReceivedRTUBASICINFOSETTING = function(data) {
            if (data.Type == 'DEVICEBASICINFO') {
                for (var i = 0; i < self.digitalStatusList.length; i++) {
                    if (self.digitalStatusList[i].sourceSerial == data.SN && data.Value.path == "name") {
                        self.digitalStatusList[i].sourceName = data.Value.value;
                    }
                    if (self.digitalStatusList[i].destinationSerial == data.SN && data.Value.path == "name") {
                        self.digitalStatusList[i].destinationName = data.Value.value;
                    }
                }
            }
        };

        var _registerListener = function () {
            if ($scope.liveData === true)
                return;
            $scope.liveData = true;
            websocketService.connect();
            var uniqueSources = _.uniq(this.digitalStatusList, function (o) { return o.sourceSerial });
            angular.forEach(uniqueSources, function (source) {
                websocketService.register("DIGITALINTERTIE", source.sourceSerial, "", wsDataReceivedDIL, wsReconnectDIL);
            });
            for (var i = 0; i < self.digitalStatusList.length; i++) {
                websocketService.register("DEVICEBASICINFO", self.digitalStatusList[i].sourceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
                websocketService.register("DEVICEBASICINFO", self.digitalStatusList[i].destinationSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
            }   
        };

        var _unRegisterListener = function () {
            if ($scope.liveData === false)
                return;
            $scope.liveData = false;
            this.lastUpdateAt = undefined;
            var uniqueSources = _.uniq(this.digitalStatusList, function (o) { return o.sourceSerial });
            angular.forEach(uniqueSources, function (source) {
                websocketService.unRegister("DIGITALINTERTIE", source.sourceSerial, "", wsDataReceivedDIL, wsReconnectDIL);
            });
            for (var i = 0; i < self.digitalStatusList.length; i++) {
                websocketService.unRegister("DEVICEBASICINFO", self.digitalStatusList[i].sourceSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
                websocketService.unRegister("DEVICEBASICINFO", self.digitalStatusList[i].destinationSerial, 0, wsDataReceivedRTUBASICINFOSETTING, null);
            }  
        };

        $scope.$onDestroy = function() {
            _unRegisterListener();
        };

        $scope.$on('digital_intertie_added', function (e, newDigitalInterconnect) {
            _unRegisterListener();
            self.digitalStatusList.push(newDigitalInterconnect);
            self.digitalStatusList.sort(function (a, b) {
                return a.interconnectID - b.interconnectID;
            });
            _registerListener();
        });

        $scope.$on('digital_intertie_updated', function (e, updatedDigitalInterconnect) {
            _unRegisterListener();
            var index = -1;
            for (var i = 0; i < self.digitalStatusList.length; i++) {
                if (self.digitalStatusList[i].interconnectID === updatedDigitalInterconnect.interconnectID) {
                    index = i;
                    break;
                }
            }
            if (index !== -1) {
                self.digitalStatusList[index] = updatedDigitalInterconnect;
            }
            _registerListener();
        });

        $scope.$on('digital_intertie_deleted', function(e, repId) {
            var newArray = [];
            for (var i = 0; i < self.digitalStatusList.length; i++) {
                if (self.digitalStatusList[i].interconnectID !== repId) {
                    newArray.push(self.digitalStatusList[i]);
                }
            }
            self.digitalStatusList = angular.copy(newArray);
        });
    };

    dilCont.$inject = ['$scope', 'authenticationService', 'translationService', 'interconnectListService', 'sharedSetupService', 'openViewService', 'websocketService', 'datetimeService', '$location'];
    mcapp.controller('digitalInterconnectListController', dilCont);
}());

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

mcapp.controller('analogIntertieTableController', ['$scope', '$rootScope', '$element', 'sharedSetupService', 'openViewService', 'analogIntertieDetailsService', 'translationService', 'detectBrowserService', 'authenticationService', '$location', function ($scope, $rootScope, $element, sharedSetupService, openViewService, analogIntertieDetailsService, translationService, detectBrowserService, authenticationService, $location) {
    $scope.myDate = null;
    $scope.qdpLeft = -237;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.alerts = [];
    $scope.currentBrowser = detectBrowserService();

    $scope.selectMyDate = function () {
        $scope.selectMyDateT(false);
    };

    $scope.liveTable = $element.find(".headertable");

    $scope.liveDataLine = function (varLiveData) {
        if (varLiveData) {
            $scope.liveTable.addClass("live-data-line");
        } else {
            $scope.liveTable.removeClass("live-data-line");
        }
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    var getInputName = function getInputName(status) {
        if (status.sourceChannelName) {
            return status.sourceChannelName;
        }

        return $scope.translation.text.CHANNEL + ' ' + status.sourceAnalogChannel;
    };

    var getOutputName = function getOutputName(status) {
        if (status.destinationChannelName) {
            return status.destinationChannelName;
        }

        return $scope.translation.text.CHANNEL + ' ' + status.destinationOutputChannel;
    };

    $scope.stickyProperties = $scope.stickyProperties || sharedSetupService.stickyPropertiesInterface;
    $scope.stickyProperties.device.title = $scope.stickyProperties.device.deviceName;

    if (!$scope.stickyProperties.deviceId) {
        $location.path('/interconnect/analoginterconnectlist/analog-interconnect-list');
        return;
    }

    //TODO: $scope.stickyPropertiesInterface.analogIntertieId
    analogIntertieDetailsService.getData('customerID=' + $scope.accountInfo.customerId + '&analogIntertieId=' + ($scope.stickyProperties.deviceId ? $scope.stickyProperties.deviceId : $scope.stickyPropertiesInterface.deviceId)).then(function (resp) {
        var datafromfactory = resp.data;
        $scope.details = datafromfactory;

        $scope.windowTitle = $scope.translation.text.ANALOG_INTERCONNECT_OPERATION + ', ' + datafromfactory.sourceDeviceName + ', ' + getInputName(datafromfactory) + ' to ' + datafromfactory.destinationDeviceName + ', ' + getOutputName(datafromfactory);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            $scope.popup.dialog("option", "title", $scope.windowTitle);
        }
    });

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);

        $scope.popup.dialog({
            resize: function resize(event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function maximize(event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function restore(event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
        };

        $scope.fnChangeLanguage = function () {
            if ($scope.alerts.length > 0) {
                var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }

            $scope.windowTitle = $scope.translation.text.ANALOG_INTERCONNECT_OPERATION + ", " + $scope.details.sourceDeviceName + " input " + $scope.details.sourceAnalogChannel + " to " + $scope.details.destinationDeviceName + " output " + $scope.details.destinationOutputChannel;

            $scope.popup.dialog("option", "title", $scope.windowTitle);
        };
    }

    $scope.$on('analog_intertie_deleted', function (e, repId) {
        var analogIntertieId = $scope.stickyProperties.deviceId ? $scope.stickyProperties.deviceId : $scope.stickyPropertiesInterface.deviceId;
        if (repId == analogIntertieId) {
            $scope.popup.dialog("close");
        }
    });
}]);

mcapp.directive('drawAnalogIntertieData', ['$rootScope', '$timeout', 'analogIntertieTableService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', '$filter', '$location', function ($rootScope, $timeout, analogIntertieTableService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService, $filter, $location) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        if (_typeof(scope.stickyProperties) != 'object') {
            scope.stickyProperties = scope.stickyPropertiesInterface;
        }

        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        scope.dateAgentText = function (date) {
            return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, scope.accountInfo.preferenceUser.timeFormat);
        };

        scope.trgScroll = function () {
            $timeout(function () {
                var $rowFirst = element.contents().find("tr:first");
                var _firstRow = $rowFirst.attr("name");
                if (typeof $rowFirst.position() !== "undefined") {
                    var _tableTop = element.offset().top;
                    var _rowTop = $rowFirst.offset().top;
                    _setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);
                }
            }, 0);
        };
        element.on('scroll', function (event) {
            var $rowFirst = element.contents().find("tr:first");
            var $rowLast = element.contents().find("tr:last");
            var _firstRow = $rowFirst.attr("name");
            if (typeof $rowFirst.position() !== "undefined") {
                scope.infiniteScrollOn = true;scope.infiniteScrollUpOn = true;scope.infiniteScrollDownOn = true;
                // var _topOffset = $rowFirst.position().top;
                // _setLiveDataStatus(_firstRow, _topOffset);
                scope.trgScroll();
                previousScrollbarPosition = currentScrollbarPosition;
                currentScrollbarPosition = element[0].scrollTop;
            }

            if (scope.infiniteScrollOn === true) {
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;

                if (scope.infiniteScrollDownOn === true && element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight) {
                    $rowLast.addClass("active-row");
                    scope.analogIntertieTableService.alerts = [];
                    scope.analogIntertieTableService.nextPage();
                }
                if (scope.infiniteScrollUpOn === true && element[0].scrollTop < 5 && currentScrollbarPosition < previousScrollbarPosition) {
                    $rowFirst.addClass("active-row");
                    scope.analogIntertieTableService.alerts = [];
                    scope.analogIntertieTableService.previousPage();
                }
            }

            var rows = element.children().children().children().children();
            var scrollpos = 40;
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
            }
            _updateZoom(parseFloat($($(rows[start])).attr("name")));
        });

        var _updateZoom = function _updateZoom(currentRow) {
            if (isNaN(currentRow)) return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            } else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () {
                    scope.liveDataIn = !scope.liveDataIn;
                }, 3000);
            }
        }, true);

        scope.$watch('analogIntertieTableService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        var init = function init() {

            if (!scope.stickyProperties.deviceId) {
                $location.path('/interconnect/analoginterconnectlist/analog-interconnect-list');
                return;
            }

            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            /////////////////////////////////////////////////////////////
            scope.analogIntertieTableService = new analogIntertieTableService();
            scope.analogIntertieTableService.customerId = scope.accountInfo.customerId;
            scope.analogIntertieTableService.analogIntertieId = scope.stickyProperties.deviceId; //TODO: scope.stickyProperties.analogIntertieId;
            scope.analogIntertieTableService.windowTitle = scope.windowTitle;
            scope.analogIntertieTableService.startRow = 1;
            scope.analogIntertieTableService.pageSize = 50;
            scope.alerts = [];
            sharedSetupService.setStickyProperties(scope.stickyProperties, { windowId: scope.windowId });
            if (scope.stickyProperties.savedDesktop === true && scope.stickyProperties.on === true || scope.classicView) {
                scope.savedDesktopRow = scope.stickyProperties.zoomMax;
                scope.stickyProperties.on = true;
                scope.stickyProperties.savedDesktop = false;
                scope.analogIntertieTableService.pageSize = 500;
                if (scope.currentBrowser == "ie") scope.analogIntertieTableService.pageSize = 100;
                scope.analogIntertieTableService.start = scope.stickyProperties.dateMin;
                scope.analogIntertieTableService.end = scope.stickyProperties.dateMax;

                scope.analogIntertieTableService.responseStart = scope.stickyProperties.dateMin;
                scope.analogIntertieTableService.responseEnd = scope.stickyProperties.dateMax;

                //TODO: will come back to reconsider sharedSetupService.regenerateDates()
                if (($rootScope.mobile || $rootScope.classicView) && !(new Date(scope.stickyProperties.dateMin).getTime() > 0 && new Date(scope.stickyProperties.dateMax).getTime() > 0)) {
                    var tmpDates = sharedSetupService.getLiveDates();
                    scope.analogIntertieTableService.start = tmpDates.startDate;
                    scope.analogIntertieTableService.end = tmpDates.endDate;
                    scope.analogIntertieTableService.responseStart = tmpDates.startDate;
                    scope.analogIntertieTableService.responseEnd = tmpDates.endDate;
                }
                scope.analogIntertieTableService.loadPage();
            } else if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) {
                //doesn't work well - need to check
                scope.stickyProperties.on = true;
                scope.analogIntertieTableService.start = scope.stickyProperties.dateMin - 3 * scope.unixDay; //need to extend data range
                scope.analogIntertieTableService.responseStart = scope.analogIntertieTableService.start;
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && scope.stickyProperties.zoomMax + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.analogIntertieTableService.end = scope.stickyProperties.dateMax;
                    } else {
                        scope.analogIntertieTableService.end = Math.round((scope.stickyProperties.zoomMax + scope.stickyProperties.zoomMin) / 2);
                    }
                    scope.analogIntertieTableService.responseEnd = scope.analogIntertieTableService.end;
                    scope.analogIntertieTableService.loadPage();
                });
            } else {
                scope.stickyProperties.on = false;
                timeLapseService.getLocalDateTime().then(function (result) {
                    /////////////////////////////////////////////////////////////
                    var startDate = new Date(result.data.localDateTime);
                    // startDate.setHours(0, 0, 0, 0);
                    var endDate = new Date(startDate.getTime() + 0.25 * 86400000);
                    startDate = new Date(startDate.getTime() - 0.25 * 86400000);
                    scope.analogIntertieTableService.start = datetimeService.dateToUnixtime(startDate);
                    scope.analogIntertieTableService.end = datetimeService.dateToUnixtime(endDate);
                    scope.analogIntertieTableService.responseStart = datetimeService.dateToUnixtime(startDate);
                    scope.analogIntertieTableService.responseEnd = datetimeService.dateToUnixtime(endDate);
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: scope.analogIntertieTableService.start, dataMax: scope.analogIntertieTableService.end, windowId: scope.windowId });
                    /////////////////////////////////////////////////////////////
                    scope.analogIntertieTableService.loadPage();
                });
            }
        };

        init();

        scope.mostRecentData = function () {
            scope.myDate = null;
            toaster.pop('success', scope.windowTitle + " -- ", 'View reloading');
            scope.selectMyDateT(true);
        };
        scope.selectMyDateT = function (isRefresh) {
            scope.analogIntertieTableService = new analogIntertieTableService();
            scope.analogIntertieTableService.analogIntertieId = scope.stickyProperties.deviceId; //TODO: scope.stickyProperties.analogIntertieId;
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            /////////////////////////////////////////////////////////////
            if (isRefresh) {
                var tmpDates = new Date(Date.now());
            } else {
                _unRegisterListener(scope.deviceSelectedSn);
                var tmpDates = scope.myDate;
            }
            var tmpDatesA = tmpDates;
            var safeEndDate;
            if (!isRefresh) {
                tmpDates.setHours(0, 0, 0, 0);
                tmpDatesA.setHours(12, 0, 0, 0);
            }
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            scope.analogIntertieTableService.start = tmpDates.startDate;

            if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                scope.analogIntertieTableService.end = tmpDatesA;
                safeEndDate = tmpDatesA;
            } else {
                scope.analogIntertieTableService.end = tmpDates.endDate;
                safeEndDate = tmpDates.endDate;
            }
            scope.analogIntertieTableService.responseEnd = scope.analogIntertieTableService.end;
            scope.analogIntertieTableService.responseStart = scope.analogIntertieTableService.start;
            /////////////////////////////////////////////////////////////
            scope.analogIntertieTableService.startRow = 1;
            scope.analogIntertieTableService.pageSize = 50;
            scope.analogIntertieTableService.customerId = scope.accountInfo.customerId;
            scope.analogIntertieTableService.windowTitle = scope.windowTitle;
            scope.alerts = [];
            scope.analogIntertieTableService.loadPage();
            /////////////////////////////////////////////////////////////
            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: tmpDates.startDate, dataMax: safeEndDate, zoomMin: tmpDates.startDate + scope.unixDay, zoomMax: tmpDates.endDate - scope.unixDay, windowId: scope.windowId });
        };

        var _setLiveDataStatus = function _setLiveDataStatus(firstRow, liveDataStatusOn) {
            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            } else if (scope.checkFirstRowLiveStatus === null) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.checkFirstRowLiveStatus = true;
                        _checkTopOffset(liveDataStatusOn);
                    } else {
                        scope.checkFirstRowLiveStatus = false;
                    }
                });
            }
        };

        var _checkTopOffset = function _checkTopOffset(liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListener();
            } else {
                _unRegisterListener();
            }
        };
        // An AnalogOutput message only tells us that a new request/response pair exists; the rows
        // themselves are refetched from the API so live and refreshed views always agree. Bursts of
        // messages are coalesced into a single refetch, which also gives the server a moment to
        // persist the records before we ask for them.
        var _liveRefreshDelay = 2000;
        var _liveRefreshTimer = null;

        var _refreshFromServer = function _refreshFromServer() {
            if (_liveRefreshTimer) {
                $timeout.cancel(_liveRefreshTimer);
            }

            _liveRefreshTimer = $timeout(function () {
                _liveRefreshTimer = null;
                scope.selectMyDateT(true);
            }, _liveRefreshDelay);
        };

        var wsDataReceivedANALOGOUT = function wsDataReceivedANALOGOUT(data) {
            if (scope.liveData === false) {
                _unRegisterListener();
                return;
            }

            scope.lastUpdateAt = datetimeService.socketStrToServerStrTime(data.Time);
            _refreshFromServer();
        };

        var wsReconnectANALOGOUT = function wsReconnectANALOGOUT(data) {
            if (scope.liveData === false) {
                _unRegisterListener();
                return;
            }
            if (data.Channel != 1) return;
            toaster.pop('success', scope.windowTitle + " -- ", 'View reloading');
            scope.stickyProperties.on = true;
            scope.analogIntertieTableService.start = scope.stickyProperties.dateMin;
            scope.analogIntertieTableService.end = scope.stickyProperties.dateMax;
            scope.analogIntertieTableService.responseStart = scope.stickyProperties.dateMin;
            scope.analogIntertieTableService.responseEnd = scope.stickyProperties.dateMax;
            scope.analogIntertieTableService.items = [];
            scope.analogIntertieTableService.setting = [];
            scope.analogIntertieTableService.numberOfReturnedRecords = -1;
            scope.analogIntertieTableService.startRow = 1;
            scope.analogIntertieTableService.pageSize = 10000;
            sharedSetupService.setStickyProperties(scope.stickyProperties, { windowId: scope.windowId });
            scope.analogIntertieTableService.alerts = [];
            scope.analogIntertieTableService.nextPage();
        };

        var _registerListener = function _registerListener(varSelectedSN) {
            if (scope.liveData === true) return;
            //sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });

            scope.liveData = true;
            scope.liveDataLine(scope.liveData);
            scope.analogIntertieTableService.numberOfNewRecordsPrevious = -1;
            websocketService.connect();

            websocketService.register("ANALOGOUT", scope.details.destinationSerialNumber, scope.details.destinationOutputChannel, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);
        };

        var _unRegisterListener = function _unRegisterListener(varSelectedSN) {
            if (scope.liveData === false) return;
            //sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });

            scope.liveData = false;
            scope.liveDataLine(scope.liveData);
            scope.lastUpdateAt = undefined;

            websocketService.unRegister("ANALOGOUT", scope.details.destinationSerialNumber, scope.details.destinationOutputChannel, wsDataReceivedANALOGOUT, wsReconnectANALOGOUT);

            if (_liveRefreshTimer) {
                $timeout.cancel(_liveRefreshTimer);
                _liveRefreshTimer = null;
            }
        };

        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll();
            scope.checkFirstRowLiveStatus = null;
            scope.trgScroll();
        });

        var _autoScroll = function _autoScroll() {

            element.animate({
                scrollTop: element.scrollTop()
            }, 500);
            // if (scope.analogIntertieTableService.numberOfNewRecordsPrevious > 0) {
            //     var trRow = element.find('tr').eq(scope.analogIntertieTableService.numberOfNewRecordsPrevious + 2);
            //     var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top + 100 : 2;
            //     console.log("Y position", yPosition);
            //     element.scrollTop(yPosition);
            // }
            // else if (element[0].scrollTop <= 1) {
            //     element.animate({
            //         scrollTop: element.scrollTop() + 5
            //     }, 500);
            // }
        };

        // var _resetView = function (args) {
        //     for (var i = 0; i < scope.analogIntertieTableService.setting.length; i++) {
        //         if (scope.analogIntertieTableService.setting[i].channel == args.channel) {
        //             var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
        //             var _newDataValue = _newData.name + " (" + _newData.unit + ")";
        //             scope.analogIntertieTableService.setting[i].name = _newData.name;
        //             scope.analogIntertieTableService.setting[i].unit = _newData.unit;
        //         }
        //     }
        // };
        //
        // var _getArgsFromNewSetting = function (channel, newSetting) {
        //     for (var i = 0; i < newSetting.length; i++) {
        //         if (newSetting[i].channel == channel) {
        //             return newSetting[i];
        //             break;
        //         }
        //     }
        //     return null;
        // };

        // scope.$on('rtuAnalogUpdate', function (event, args) {
        //     var _dataChanged = "name, unit";
        //     if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
        //         _resetView(args);
        //     }
        // });

        scope.$on("$destroy", function () {
            _unRegisterListener();
        });
    };
}]);

mcapp.factory('analogIntertieDetailsService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function getData(varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/Interconnect/AnalogIntertieDetails?' + varParm,
                cache: false
            });
        }
    };
}]);

mcapp.factory('analogIntertieTableService', ['$http', 'datetimeService', 'translationService', 'HOST', function ($http, datetimeService, translationService, HOST) {
    var analogIntertieTableService = function analogIntertieTableService() {
        this.items = [];
        this.setting = [];
        this.customerId = null;
        this.analogIntertieId = null;
        this.analogSettings = null;
        this.startRow = 1;
        this.pageSize = 100;
        this.start = null;
        this.end = null;
        this.responseStart = null;
        this.responseEnd = null;
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.alerts = [];
        this.translation = translationService.translation;
        this.pumpkinSpiceOn = null;
    };

    analogIntertieTableService.prototype.getData = function () {
        if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
        this.busy = true;

        var url = HOST + "/api/Interconnect/AnalogIntertieTable?customerId=" + this.customerId + "&analogIntertieId=" + this.analogIntertieId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end + "&responseStartDate=" + this.responseStart + "&responseEndDate=" + this.responseEnd;
        $http.get(url).then(function (resp) {
            var data = resp.data;
            this.analogSettings = data.settings;
            this.pumpkinSpiceOn = data.pumpkinSpiceOn;
            /////////////////////////
            var intDayWindow = 10;
            var intDay = 86400000;
            /////////////////////////

            var items = data.table;
            if (items.length > 0) var tmpstart = new Date(items[items.length - 1].requestTime);

            if (this.pageSize > 0) {
                this.items = this.items.concat(data.table);
                //this.numberOfReturnedRecords = items.length;
                this.numberOfNewRecordsPrevious = 100;
            }
            if (this.pageSize < 0) {
                this.items = data.table.reverse().concat(this.items);
                //this.numberOfNewRecordsPrevious = items.length;
                this.numberOfNewRecordsPrevious = 100;
            }

            this.items.sort(function (a, b) {
                if (a.requestTime > b.requestTime) return -1;
                if (a.requestTime < b.requestTime) return 1;
                return 0;
            });

            this.items = this.remove_duplicates(this.items);
            //this.startRow = this.startRow + items.length;
            this.startRow = this.startRow == 1 ? items.length : this.startRow + items.length;

            if (items.length > 0) {
                //if there are records returned
                this.start = datetimeService.toUnixtime(data.requestStart.replace(/\D/g, ''));
                this.end = datetimeService.toUnixtime(data.requestEnd.replace(/\D/g, ''));
                this.responseStart = datetimeService.toUnixtime(data.responseStart.replace(/\D/g, ''));
                this.responseEnd = datetimeService.toUnixtime(data.responseEnd.replace(/\D/g, ''));
            }
            if (!(this.items.length > 0)) {
                this.alerts = [];
                var errorMessage = this.translation.message.NO_DATA;
                this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        }.bind(this), function (resp) {
            var error = resp.data;
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.message);
            this.alerts.push({ msg: errorMessage, type: "danger" });
        }.bind(this)).finally(function () {
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };

    analogIntertieTableService.prototype.previousPage = function () {
        this.pageSize = this.pageSize < 0 ? this.pageSize : -this.pageSize;

        if (this.pumpkinSpiceOn) {
            this.start = this.end;
            this.tmpEndDate = new Date(this.end);
            this.end = this.tmpEndDate.setHours(this.tmpEndDate.getHours() + 3);

            this.responseStart = this.responseEnd;
            this.tmpResponseEndDate = new Date(this.responseEnd);
            this.responseEnd = this.tmpResponseEndDate.setHours(this.tmpResponseEndDate.getHours() + 3);
        }

        this.getData();
    };

    analogIntertieTableService.prototype.nextPage = function () {

        if (this.pumpkinSpiceOn) {

            this.end = this.start;
            this.tmpStart = new Date(this.end);
            this.start = this.tmpStart.setHours(this.tmpStart.getHours() - 3);

            this.responseEnd = this.responseStart;
            this.responseTmpStart = new Date(this.responseEnd);
            this.responseStart = this.responseTmpStart.setHours(this.responseTmpStart.getHours() - 3);
        }

        this.getData();
    };

    analogIntertieTableService.prototype.loadPage = function () {
        this.getData();
    };

    analogIntertieTableService.prototype.remove_duplicates = function (arr) {
        var obj = {};
        var ret_arr = [];
        for (var i = 0; i < arr.length; i++) {
            obj[arr[i].requestTime] = arr[i]; //reportTime should be unique across the array items
        }
        for (var key in obj) {
            ret_arr.push(obj[key]);
        }
        return ret_arr;
    };

    return analogIntertieTableService;
}]);
"use strict";

angular.module("mc.widget-analog-output-display", []);
'use strict';

function McWidgetAnalogOutputDisplayFactory(HOST, $http) {

    // instantiate our initial object
    var McWidgetAnalogOutputDisplay = function McWidgetAnalogOutputDisplay(customerId, deviceId, timeZone) {
        this.customerId = customerId;
        this.deviceId = deviceId;
        this.timeZone = timeZone;
    };

    McWidgetAnalogOutputDisplay.prototype.getGaugeData = function () {
        var self = this;
        return $http.get(HOST + '/api/Analog/Gauge' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetAnalogOutputDisplay.prototype.getDeviceState = function () {
        var self = this;
        return $http.get(HOST + '/api/DeviceState' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    McWidgetAnalogOutputDisplay.prototype.getWidgetData = function (channel) {
        var self = this;
        return $http.get(HOST + '/api/Analog/Widget' + '?customerId=' + this.customerId + '&deviceId=' + this.deviceId + '&channelId=' + channel).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return McWidgetAnalogOutputDisplay;
}

McWidgetAnalogOutputDisplayFactory.$inject = ['HOST', '$http'];

angular.module('mc.widget-analog-output-display').factory('McWidgetAnalogOutputDisplayFactory', McWidgetAnalogOutputDisplayFactory);
"use strict";

function McWidgetAnalogOutputDisplayController($, $timeout, $rootScope, $scope, $element, McWidgetAnalogOutputDisplayFactory, $compile, websocketService, toaster, datetimeService, sharedSetupService, McAnalogOutputGaugeFactory, authenticationService, openViewService, translationService, PopupFactory, McWidgetsSharedFactory) {

    var ctrl = this;
    var chart = void 0;
    var tmpInit = true;
    var tmpInitSource = true;
    var tmpInitDestination = true;

    var deviceStateEnum = {
        Ok: 1,
        Alarm: 2,
        Offline: 3,
        Service: 4,
        Disabled: 5
    };

    var getState = function getState(state) {
        //Options: AllNormal, Alarm, Alert, Service, CommFail
        switch (state) {
            case deviceStateEnum.Ok:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
            //case deviceStateEnum.Disabled:
            //    return "Disabled";
            case deviceStateEnum.Offline:
                //device.CommsFault
                ctrl.orbitTitle = ctrl.translation.text.COMM_FAIL;
                return "CommFail";
            case deviceStateEnum.Service:
                ctrl.orbitTitle = ctrl.translation.text.SERVICE_MODE;
                return "Service";
            case deviceStateEnum.Alarm:
                ctrl.orbitTitle = null; //ctrl.translation.text.ALARM;
                return "Alarm";
            default:
                ctrl.orbitTitle = ctrl.translation.text.ALL_NORMAL;
                return "AllNormal";
        }
    };

    var getView = function getView(state) {
        switch (state) {
            //case deviceStateEnum.Service:
            //    return "RTU Configuration"; //"Service";
            //case deviceStateEnum.Alarm:
            //    return "Dashboard"; //"Alarm";
            default:
                return "Dashboard"; //"AllNormal";
        }
    };

    ctrl.$onInit = function () {
        ctrl.alerts = [];
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
        if (angular.isUndefined(ctrl.analogType)) ctrl.analogType = "Single Needle Gauge";
        if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
        if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
        ctrl.loadingFinished = false;
    };

    ctrl.pwMouseEnter = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.getTooltip(ctrl.widgetSetting.device.deviceId, event, 20);
    };

    ctrl.pwMouseLeave = function (event) {
        if (ctrl.widgetSetting.deviceUnitState.state === 2) //Alarm
            ctrl.popupWindow.destroyTooltip(event);
    };

    ctrl.$onChanges = function (changes) {
        ctrl.alerts = [];
        if (changes.widgetSetting.currentValue && changes.widgetSetting.currentValue != changes.widgetSetting.previousValue) {
            tmpInit = true;
            tmpInitSource = true;
            tmpInitDestination = true;
            if (angular.isUndefined(ctrl.translation)) ctrl.translation = translationService.translation;
            if (angular.isUndefined(ctrl.mcWidgetsSharedFactory)) ctrl.mcWidgetsSharedFactory = new McWidgetsSharedFactory();
            ctrl.buildWidget(changes.widgetSetting.currentValue);
        }
    };

    ctrl.buildWidget = function (widgetData) {

        if (ctrl.mcWidgetsSharedFactory.checkForEmptyObject(widgetData.analogOutputGauge)) {
            var errormsg = ctrl.translation.text.NOT_SETUP;
            ctrl.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
            return;
        } else {
            ctrl.alerts = [];
        }

        ctrl.widgetSetting = widgetData;

        ctrl.widgetSetting.analogOutputGauge.newSetting = ctrl.scaledValues(ctrl.widgetSetting.analogOutputGauge.minVal, ctrl.widgetSetting.analogOutputGauge.maxVal, ctrl.widgetSetting.analogOutputGauge.newSettingRaw);

        ctrl.widgetSetting.analogOutputGauge.responseNewSetting = ctrl.scaledValues(ctrl.widgetSetting.analogOutputGauge.minVal, ctrl.widgetSetting.analogOutputGauge.maxVal, ctrl.widgetSetting.analogOutputGauge.responseNewSettingRaw);

        ctrl.w_BorderWidth = 2; // Set the inside solid border of the HUD
        ctrl.w_BorderPadding = 5; // Set the outside opaque border outline

        ctrl.hudText = getState(ctrl.widgetSetting.deviceUnitState.state); // Options: AllNormal, Alarm, Alert, Service, CommFail

        ctrl.show_chartdata = "No";

        ctrl.fnMarksTypeOptions(ctrl.widgetSetting.analogOutputWidgetSetting.tickMarksId);

        ctrl.setSize(ctrl.widgetSetting.setting.defaultSetting ? ctrl.widgetSetting.defaultSetting.sizeId : ctrl.widgetSetting.analogOutputWidgetSetting.sizeId);
        ctrl.setMarkerTextStyle();

        ctrl.buildMainClass();

        ctrl.loadingInProgress = false;

        ctrl.unRegisterListener();
        ctrl.registerListener();

        ctrl.noDecimals = sharedSetupService.getNumberOfDecimals(ctrl.widgetSetting.analogOutputGauge.maxVal, ctrl.widgetSetting.analogOutputGauge.minVal);

        //ctrl.annimate_Needle(ctrl.widgetSetting.analogOutputGauge.minVal, ctrl.widgetSetting.analogOutputGauge.maxVal, ctrl.widgetSetting.analogOutputGauge.newSetting, ctrl.widgetSetting.analogOutputGauge.responseNewSetting);
        ctrl.annimate_Needle_source(ctrl.widgetSetting.analogOutputGauge.minVal, ctrl.widgetSetting.analogOutputGauge.maxVal, ctrl.widgetSetting.analogOutputGauge.newSetting);
        ctrl.annimate_Needle_destination(ctrl.widgetSetting.analogOutputGauge.minVal, ctrl.widgetSetting.analogOutputGauge.maxVal, ctrl.widgetSetting.analogOutputGauge.responseNewSetting);
        ctrl.create_Markers(ctrl.widgetSetting.analogOutputGauge.minVal, ctrl.widgetSetting.analogOutputGauge.lowAlarm, ctrl.widgetSetting.analogOutputGauge.lowRestore, ctrl.widgetSetting.analogOutputGauge.highAlarm, ctrl.widgetSetting.analogOutputGauge.highRestore, ctrl.widgetSetting.analogOutputGauge.maxVal);

        if (ctrl.loadingFinished) {
            ctrl.buildTachStrokeDash();
            ctrl.DisplayTimestamp(datetimeService.UtcToLocalByTimeZone(ctrl.widgetSetting.device.lastHeardTime, ctrl.accountInfo.timeZone), Date.now(), ctrl.widgetSetting.analogOutputWidgetSetting.dateTimeFormat);
            ctrl.fnHeardTypeOptions(ctrl.widgetSetting.analogOutputWidgetSetting.dateTimeFormat);
        }
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);
        ctrl.resize_HUDBoxes();

        if (ctrl.widgetSetting.setting.displaySettingOn) {
            var newScope = $scope;
            var html = '<mc-widget-output-setting widget-setting="$ctrl.widgetSetting" ng-if="$ctrl.widgetSetting.setting.displaySetting" change-display-options="$ctrl.fnChangeDisplayOptions(settingOptions)"></mc-widget-output-setting>';
            var element = $element.find('.component-setting');
            if (element.is(':empty')) {
                element.append($compile(html)(newScope));
            }
        }

        ctrl.loadingInProgress = false;
    };

    ctrl.getData = function (deviceId, channel, openSetting) {

        var _analogOutputGauge = new McAnalogOutputGaugeFactory(ctrl.accountInfo.customerId, deviceId, ctrl.accountInfo.timeZone, 1, 24, channel); //Category: Analog, Widget: 'Single Needle Gauge'

        _analogOutputGauge.getGaugeData().then(function () {
            ctrl.loadingInProgress = false;
            var device = _analogOutputGauge.list.device;
            var deviceUnitState = _analogOutputGauge.list.deviceUnitState;
            var defaultSetting = _analogOutputGauge.list.defaultSetting;

            // if _analogGauge.list.analogGauge is not available, set default values to empty object
            var analogOutputGauge = _analogOutputGauge.list.analogOutputGauge.length == 0 ? {} : _analogOutputGauge.list.analogOutputGauge[0].analogOutputGauge;
            var analogOutputWidgetSetting = _analogOutputGauge.list.analogOutputGauge.length == 0 ? {} : _analogOutputGauge.list.analogOutputGauge[0].analogOutputWidgetSetting;

            var setting = {
                customerId: ctrl.accountInfo.customerId,
                displaySetting: ctrl.widgetSetting.setting.displaySetting,
                displaySettingOn: ctrl.widgetSetting.setting.displaySettingOn,
                defaultSetting: ctrl.widgetSetting.setting.defaultSetting
            };
            ctrl.analogOutputGauge = {
                device: device,
                deviceUnitState: deviceUnitState,
                defaultSetting: defaultSetting,
                analogOutputGauge: analogOutputGauge,
                analogOutputWidgetSetting: analogOutputWidgetSetting,
                setting: setting
            };

            ctrl.buildWidget(ctrl.analogOutputGauge);
            ctrl.fnSizeOptions(ctrl.analogOutputGauge.analogOutputWidgetSetting.sizeId);
            //ctrl.fnMakeFitTextWork();
            if (!angular.isUndefined(openSetting)) {
                $timeout(function () {
                    ctrl.mouseOverHUD();
                    ctrl.editSetting();
                }, 0);
            }
            ctrl.changeWidgetTitle({ titleOption: { deviceId: ctrl.analogOutputGauge.device.deviceId, name: ctrl.analogOutputGauge.device.name, serialNumber: ctrl.analogOutputGauge.device.serialNumber, channel: ctrl.analogOutputGauge.analogOutputGauge.channel, channelDescription: Object.keys(ctrl.analogOutputGauge.analogOutputGauge).length !== 0 ? ctrl.analogOutputGauge.analogOutputGauge.name : ctrl.translation.text.NOT_SETUP } });
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.getDeviceState = function () {

        var _deviceState = new McWidgetAnalogOutputDisplayFactory(ctrl.accountInfo.customerId, ctrl.widgetSetting.device.deviceId, ctrl.accountInfo.timeZone);

        _deviceState.getDeviceState().then(function () {
            ctrl.loadingInProgress = false;
            ctrl.fnRtuStatusOptions(getState(_deviceState.list.state));
        }, function (error) {
            console.log(error);
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.fnMakeFitTextWork = function () {
        // $compile($element.find(".mc-fittext"))($scope);
    };

    ctrl.fnThemeOptions = function (themeName) {
        ctrl.widgetSetting.analogOutputWidgetSetting.theme = themeName;
        ctrl.buildMainClass();
    };

    ctrl.fnHeardTypeOptions = function (heardType) {
        ctrl.widgetSetting.analogOutputWidgetSetting.dateTimeFormat = heardType;
        ctrl.DisplayTimestamp(datetimeService.UtcToLocalByTimeZone(ctrl.widgetSetting.device.lastHeardTime, ctrl.accountInfo.timeZone), ctrl.heartbeatDateTime, ctrl.widgetSetting.analogOutputWidgetSetting.dateTimeFormat);
    };

    ctrl.fnMarksTypeOptions = function (marksTypeId) {

        ctrl.widgetSetting.analogOutputWidgetSetting.tickMarksId = marksTypeId;

        var Markers_Style_On = { 'opacity': '100%', 'display': 'block' };
        var Markers_Style_Off = { 'opacity': '0%', 'display': 'none' };

        if (marksTypeId === 1) {
            ctrl.Markers_Style = Markers_Style_On;
        } //"Show"
        if (marksTypeId === 2) {
            ctrl.Markers_Style = Markers_Style_Off;
        } //"Hide"
        if (marksTypeId === 3) {
            ctrl.Markers_Style = Markers_Style_Off;
        } //"Hover"
    };

    ctrl.fnMarksTypeOptionsHover = function (marksTypeId) {

        if (marksTypeId !== 3) return;
        ctrl.Markers_Style = { 'opacity': '100%', 'display': 'block' };
    };

    ctrl.fnMarksTypeOptionsLeave = function (marksTypeId) {

        if (marksTypeId !== 3) return;
        ctrl.Markers_Style = { 'opacity': '0%', 'display': 'none' };
    };

    ctrl.fnSizeOptions = function (sizeId, openSetting) {

        if (!ctrl.widgetSetting.setting.displaySetting) return;
        ctrl.widgetSetting.analogOutputWidgetSetting.sizeId = sizeId;
        ctrl.setSize(sizeId);

        ctrl.setMarkerTextStyle();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;

            ctrl.popup.dialog('widget').css("width", ctrl.svgSizeH + "px");
            ctrl.popup.dialog("option", "width", ctrl.svgSizeH);

            ctrl.popup.dialog('widget').css("height", ctrl.svgSizeH + 40 + "px");
            ctrl.popup.dialog("option", "height", ctrl.svgSizeH + 40);
        }
        ctrl.closeSetting();
        ctrl.resize_HUD(ctrl.svgSizeW, ctrl.svgSizeH);

        if (!angular.isUndefined(openSetting)) {
            $timeout(function () {
                ctrl.mouseOverHUD();
                ctrl.editSetting();
            }, 0);
        }
    };

    ctrl.setSize = function (sizeId) {
        var tmpSize = ctrl.mcWidgetsSharedFactory.getSize(sizeId, 1);
        ctrl.svgSizeW = tmpSize.width;
        ctrl.svgSizeH = tmpSize.height;
    };

    ctrl.setMarkerTextStyle = function () {
        ctrl.markerTextStyle = { 'font-size': ctrl.svgSizeH / 290 + 'em' };
    };

    ctrl.fnColorOptions = function (colorOption) {
        ctrl.widgetSetting.analogOutputWidgetSetting.lowAlarmColor = colorOption.low;
        ctrl.widgetSetting.analogOutputWidgetSetting.normalColor = colorOption.normal;
        ctrl.widgetSetting.analogOutputWidgetSetting.highAlarmColor = colorOption.high;
        ctrl.buildTachStrokeDash();
        //ctrl.closeSetting();
    };

    ctrl.fnRtuStatusOptions = function (rtuStatus) {
        ctrl.buildMainClass();
        ctrl.buildTachStrokeDash();
        ctrl.hudText = rtuStatus;
    };

    ctrl.fnChangeDisplayOptions = function (parSettingOptions) {
        if (!angular.isUndefined(parSettingOptions.themeOption)) {
            ctrl.fnThemeOptions(parSettingOptions.themeOption.name);
        }
        if (!angular.isUndefined(parSettingOptions.heardTypeOption)) {
            ctrl.fnHeardTypeOptions(parSettingOptions.heardTypeOption.type);
        }
        if (!angular.isUndefined(parSettingOptions.marksType)) {
            ctrl.fnMarksTypeOptions(parSettingOptions.marksType.id);
        }
        if (!angular.isUndefined(parSettingOptions.sizeOption)) {
            ctrl.fnSizeOptions(parSettingOptions.sizeOption.id, true);
        }
        if (!angular.isUndefined(parSettingOptions.colorOption)) {
            ctrl.fnColorOptions(parSettingOptions.colorOption);
        }
        if (!angular.isUndefined(parSettingOptions.rtuOption)) {
            ctrl.getData(parSettingOptions.rtuOption.deviceId, parSettingOptions.rtuOption.channel, true);
        }
    };

    ctrl.editSetting = function (event) {
        ctrl.mcWidgetsSharedFactory.editSetting($element, event, ctrl);
    };

    ctrl.closeSetting = function () {
        ctrl.mcWidgetsSharedFactory.closeSetting($element, ctrl);
    };

    ctrl.mouseOverHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOver;
            ctrl.set_HUDItemHeights('Yes');
        }
    };
    ctrl.mouseOffHUD = function () {
        if (!ctrl.widgetSetting.setting.displaySettingOn) return;
        if (ctrl.action_EditMode === 'No') {
            ctrl.w_gaugeDataBoxStyle = ctrl.w_gaugeDataBoxStyleOff;
            ctrl.set_HUDItemHeights('No');
        }
    };

    ctrl.scaledValues = function (minVal, maxVal, value) {
        value = minVal + value / 255 * (maxVal - minVal);
        return value;
    };

    ctrl.annimate_Needle = function (w_minValue, w_maxValue, w_sourceData, w_destinationData) {

        // Get the percentage value of the diferance between min and max
        var pct_sourceData = ctrl.calc_GuagePCT(w_minValue, w_maxValue, w_sourceData);
        ctrl.latestSourceData_Angle = ctrl.rotateDEG(pct_sourceData);

        if (tmpInit) {
            ctrl.NeedleStyle_NoData = { 'transform': 'rotate(225deg)' };
            ctrl.NeedleStyle_LiveData = { 'transform': 'rotate(' + ctrl.latestSourceData_Angle + 'deg)' };
            tmpInit = false;
        } else {
            ctrl.NeedleStyle_NoData = { 'transform': 'rotate(225deg)', 'transition': 'all 1.5s ease-in-out' };
            ctrl.NeedleStyle_LiveData = { 'transform': 'rotate(' + ctrl.latestSourceData_Angle + 'deg)', 'transition': 'all 1.5s ease-in-out' };
        }

        if (w_minValue < w_maxValue) {
            if (w_sourceData == "" || w_sourceData < w_minValue || w_sourceData > w_maxValue) {

                ctrl.Needle_Style = ctrl.NeedleStyle_NoData;
            } else {
                ctrl.Needle_Style = ctrl.NeedleStyle_LiveData;
            }
        } else {
            if (w_sourceData == "" || w_sourceData > w_minValue || w_sourceData < w_maxValue) {
                ctrl.Needle_Style = ctrl.NeedleStyle_NoData;
            } else {
                ctrl.Needle_Style = ctrl.NeedleStyle_LiveData;
            }
        }

        var pct_destinationData = ctrl.calc_GuagePCT(w_minValue, w_maxValue, w_destinationData);
        ctrl.latestDestinationData_Angle = ctrl.rotateDEG(pct_destinationData);

        if (tmpInit) {
            ctrl.Second_NeedleStyle_NoData = { 'transform': 'rotate(225deg)' };
            ctrl.Second_NeedleStyle_LiveData = { 'transform': 'rotate(' + ctrl.latestDestinationData_Angle + 'deg)' };
            tmpInit = false;
        } else {
            ctrl.Second_NeedleStyle_NoData = { 'transform': 'rotate(225deg)', 'transition': 'all 1.5s ease-in-out' };
            ctrl.Second_NeedleStyle_LiveData = { 'transform': 'rotate(' + ctrl.latestDestinationData_Angle + 'deg)', 'transition': 'all 1.5s ease-in-out' };
        }

        if (w_minValue < w_maxValue) {
            if (w_destinationData == "" || w_destinationData < w_minValue || w_destinationData > w_maxValue) {

                ctrl.Second_Needle_Style = ctrl.Second_NeedleStyle_NoData;
            } else {
                ctrl.Second_Needle_Style = ctrl.Second_NeedleStyle_LiveData;
            }
        } else {
            if (w_destinationData == "" || w_destinationData > w_minValue || w_destinationData < w_maxValue) {
                ctrl.Second_Needle_Style = ctrl.Second_NeedleStyle_NoData;
            } else {
                ctrl.Second_Needle_Style = ctrl.Second_NeedleStyle_LiveData;
            }
        }
    };

    ctrl.annimate_Needle_source = function (w_minValue, w_maxValue, w_latestData) {

        // Get the percentage value of the diferance between min and max
        var pct_latestData_source = ctrl.calc_GuagePCT(w_minValue, w_maxValue, w_latestData);
        ctrl.latestData_Angle_source = ctrl.rotateDEG(pct_latestData_source);

        if (tmpInitSource) {
            ctrl.NeedleStyle_NoData = { 'transform': 'rotate(225deg)' };
            ctrl.NeedleStyle_LiveData = { 'transform': 'rotate(' + ctrl.latestData_Angle_source + 'deg)' };
            tmpInitSource = false;
        } else {
            ctrl.NeedleStyle_NoData = { 'transform': 'rotate(225deg)', 'transition': 'all 1.5s ease-in-out' };
            ctrl.NeedleStyle_LiveData = { 'transform': 'rotate(' + ctrl.latestData_Angle_source + 'deg)', 'transition': 'all 1.5s ease-in-out' };
        }

        if (w_minValue < w_maxValue) {
            if (w_latestData == "" || w_latestData < w_minValue || w_latestData > w_maxValue) {

                ctrl.Needle_Style = ctrl.NeedleStyle_NoData;
            } else {
                ctrl.Needle_Style = ctrl.NeedleStyle_LiveData;
            }
        } else {
            if (w_latestData == "" || w_latestData > w_minValue || w_latestData < w_maxValue) {
                ctrl.Needle_Style = ctrl.NeedleStyle_NoData;
            } else {
                ctrl.Needle_Style = ctrl.NeedleStyle_LiveData;
            }
        }
    };

    ctrl.annimate_Needle_destination = function (w_minValue, w_maxValue, w_latestData) {

        // Get the percentage value of the diferance between min and max
        var pct_latestData_destination = ctrl.calc_GuagePCT(w_minValue, w_maxValue, w_latestData);
        ctrl.latestData_Angle_destination = ctrl.rotateDEG(pct_latestData_destination);

        if (tmpInitDestination) {
            ctrl.Second_NeedleStyle_NoData = { 'transform': 'rotate(225deg)' };
            ctrl.Second_NeedleStyle_LiveData = { 'transform': 'rotate(' + ctrl.latestData_Angle_destination + 'deg)' };
            tmpInitDestination = false;
        } else {
            ctrl.Second_NeedleStyle_NoData = { 'transform': 'rotate(225deg)', 'transition': 'all 1.5s ease-in-out' };
            ctrl.Second_NeedleStyle_LiveData = { 'transform': 'rotate(' + ctrl.latestData_Angle_destination + 'deg)', 'transition': 'all 1.5s ease-in-out' };
        }

        if (w_minValue < w_maxValue) {
            if (w_latestData == "" || w_latestData < w_minValue || w_latestData > w_maxValue) {

                ctrl.Second_Needle_Style = ctrl.Second_NeedleStyle_NoData;
            } else {
                ctrl.Second_Needle_Style = ctrl.Second_NeedleStyle_LiveData;
            }
        } else {
            if (w_latestData == "" || w_latestData > w_minValue || w_latestData < w_maxValue) {
                ctrl.Second_Needle_Style = ctrl.Second_NeedleStyle_NoData;
            } else {
                ctrl.Second_Needle_Style = ctrl.Second_NeedleStyle_LiveData;
            }
        }
    };

    ctrl.create_Markers = function (m_minValue, m_lowfault, m_lowrestore, m_highfault, m_highrestore, m_maxValue) {

        // Get the percentage value of the diferance between min and max
        var pct_minValue = ctrl.calc_GuagePCT(m_minValue, m_maxValue, m_minValue); // Expected 0 
        //let pct_lowfault = ctrl.calc_GuagePCT(m_minValue, m_maxValue, m_lowfault);
        //let pct_lowrestore = ctrl.calc_GuagePCT(m_minValue, m_maxValue, m_lowrestore);
        //let pct_highfault = ctrl.calc_GuagePCT(m_minValue, m_maxValue, m_highfault);
        //let pct_highrestore = ctrl.calc_GuagePCT(m_minValue, m_maxValue, m_highrestore);
        var pct_maxValue = ctrl.calc_GuagePCT(m_minValue, m_maxValue, m_maxValue); // Expected 100

        ctrl.minMarker_Angle = ctrl.rotateDEG(pct_minValue);
        //ctrl.lowfaultMarker_Angle = ctrl.rotateDEG(pct_lowfault);
        //ctrl.lowrestoreMarker_Angle = ctrl.rotateDEG(pct_lowrestore);
        //ctrl.highrestoreMarker_Angle = ctrl.rotateDEG(pct_highrestore);
        //ctrl.highfaultMarker_Angle = ctrl.rotateDEG(pct_highfault);
        ctrl.maxMarker_Angle = ctrl.rotateDEG(pct_maxValue);

        ctrl.minMarker_Style = { 'transform': 'rotate(' + ctrl.minMarker_Angle + 'deg)' };
        //ctrl.lowfaultMarker_Style = { 'transform': 'rotate(' + ctrl.lowfaultMarker_Angle + 'deg)' };

        //ctrl.lowrestoreMarker_Style = { 'transform': 'rotate(' + ctrl.lowrestoreMarker_Angle + 'deg)' };
        //ctrl.highrestoreMarker_Style = { 'transform': 'rotate(' + ctrl.highrestoreMarker_Angle + 'deg)' };

        //ctrl.highfaultMarker_Style = { 'transform': 'rotate(' + ctrl.highfaultMarker_Angle + 'deg)' };
        ctrl.maxMarker_Style = { 'transform': 'rotate(' + ctrl.maxMarker_Angle + 'deg)' };

        //if (m_highrestore === 0 && m_highfault === 0) {
        //    ctrl.highfaultMarker_AngleHide = true;
        //    ctrl.highrestoreMarker_AngleHide = true;
        //} else {
        //    ctrl.highfaultMarker_AngleHide = false;
        //    ctrl.highrestoreMarker_AngleHide = false;
        //}

        //if (m_lowrestore === 0 && m_lowfault === 0) {
        //    ctrl.lowfaultMarker_AngleHide = true;
        //    ctrl.lowrestoreMarker_AngleHide = true;
        //} else {
        //    ctrl.lowfaultMarker_AngleHide = false;
        //    ctrl.lowrestoreMarker_AngleHide = false;
        //}
    };

    ctrl.resize_HUD = function (w_svgSizeW, w_svgSizeH) {
        ctrl.mcWidgetsSharedFactory.resizeHud(w_svgSizeW, w_svgSizeH, ctrl, ctrl.setHudFont);
    };

    ctrl.setHudFont = function (w_svgSizeW) {
        ctrl.hudText_Style = { "font-size": ctrl.calc_HUDFont("hudText", 10, 30, 38, w_svgSizeW) + "px" };

        var latestData_Trim = Math.round(ctrl.widgetSetting.analogOutputGauge.newSetting.toString());
        var latestData_Length = latestData_Trim.toString().length + ctrl.noDecimals + 1;

        var latestData_Cal = ctrl.calc_HUDFont("latestData", latestData_Length, 35, 85, w_svgSizeW);
        ctrl.latestData_Style = { "font-size": latestData_Cal / 2 + "px" };

        var unit_Cal = ctrl.calc_HUDFont("unit", ctrl.widgetSetting.analogOutputGauge.unit.toString().length + 1, 15, 75, w_svgSizeW);
        var unit_Use = unit_Cal;

        if (latestData_Cal < unit_Cal) {
            unit_Use = latestData_Cal;
        }

        ctrl.unit_Style = { "font-size": unit_Use + "px" };

        ctrl.timestampDisplay_StyleAbsolute = { "font-size": ctrl.calc_HUDFont("StyleAbsolute", 10 + 1, 20, 30, w_svgSizeW) + "px" };
        ctrl.timestampDisplay_StyleElapsed = { "font-size": ctrl.calc_HUDFont("StyleElapsed", 6 + 1, 20, 30, w_svgSizeW) + "px" };
        //ctrl.calc_HUDFont(10, 6, 18, w_svgSizeW);

        ctrl.name_Style = { "font-size": ctrl.calc_HUDFont("nameText", 10, 20, 30, w_svgSizeW) + "px", "margin-left": ctrl.w_BorderWidth + ctrl.w_BorderPadding + "px", "margin-right": ctrl.w_BorderWidth + ctrl.w_BorderPadding + "px" };
        ctrl.channel_Style = { "font-size": ctrl.calc_HUDFont("channelText", 3, 40, 60, w_svgSizeW) + "px", "margin-left": ctrl.w_BorderWidth + ctrl.w_BorderPadding + "px", "margin-right": ctrl.w_BorderWidth + ctrl.w_BorderPadding + "px" };
    };

    ctrl.calc_HUDFont = function (lbl, strLength, minFont, maxFont, svgSizeW) {

        var hudScaleFactor = svgSizeW / 600;

        var scaled_minFont = Math.round(minFont * hudScaleFactor);

        var scaled_maxFont = Math.round(maxFont * hudScaleFactor);

        var widthSpaceAvailPX = ctrl.w_hudWidthPX - (ctrl.w_BorderWidth * 2 + ctrl.w_BorderPadding * 2 - 4);

        var calc_FontSize = Math.round(widthSpaceAvailPX / strLength * 1.5);

        var use_FontSize = calc_FontSize;
        if (calc_FontSize < scaled_minFont) {
            use_FontSize = scaled_minFont;
        }
        if (calc_FontSize > scaled_maxFont) {
            use_FontSize = scaled_maxFont;
        }

        return use_FontSize;
    };

    ctrl.resize_HUDBoxes = function () {

        if (angular.isUndefined(ctrl.widgetSetting)) return;

        ctrl.lastHeardLabel = null;

        if (ctrl.widgetSetting.analogOutputWidgetSetting.sizeId > 2) {
            ctrl.gaugeDataBorder_Style = { "padding": "5px" };
            ctrl.gaugeDataOverlay_Style = { "border-width": "2px" };
            ctrl.w_BorderPadding = 5;
            ctrl.w_BorderWidth = 2;

            ctrl.lastHeardLabel = ctrl.translation.text.LAST_HEARD + ":";
        }
        if (ctrl.widgetSetting.analogOutputWidgetSetting.sizeId <= 2) {
            ctrl.gaugeDataBorder_Style = { "padding": "2px" };
            ctrl.gaugeDataOverlay_Style = { "border-width": "1px" };
            ctrl.w_BorderPadding = 2;
            ctrl.w_BorderWidth = 1;
        }
        if (ctrl.widgetSetting.analogOutputWidgetSetting.sizeId <= 1) {
            ctrl.gaugeDataBorder_Style = { "padding": "0px" };
            ctrl.gaugeDataOverlay_Style = { "border-width": "01px" };
            ctrl.w_BorderPadding = 0;
            ctrl.w_BorderWidth = 0;
        }

        // Setup Border and Outline
        // ------------------------------------------------------------------------------------------

        ctrl.HudPadding = ctrl.w_BorderWidth * 2 + ctrl.w_BorderPadding * 2; // total amount of spacing between outside HUD and inside HUD

        // ----------------------------------------------------------------------------

        ctrl.action_EditMode = 'No';

        // -- // (Stage) Give each Feature Box an AR (aspectratio) value, Give BttnBox a pixelvalue of ??. 
        // -- // (MouseOver) Set Override values for interaction events, Set a px value for BttnBox states.
        // -- // 
        // -- // 
        // -- // 

        ctrl.TitleBox_StageAR = 0 / 10; // Title
        ctrl.NumberBox_StageAR = 4 / 10; // Number
        ctrl.UnitBox_StageAR = 1 / 10; // Unit
        ctrl.AuxBox_StageAR = 0 / 10; // Chart
        ctrl.Aux2Box_StageAR = 2 / 10; // Last Heard

        ctrl.BttnBox_PX_StagePX = 25; // Edit Bttn

        ctrl.set_HUDItemHeights = function (isMouseOver) {

            if (isMouseOver === 'No') {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 4 / 10;
                ctrl.UnitBox_AR = 3 / 10;
                ctrl.AuxBox_AR = 0 / 10;
                ctrl.Aux2Box_AR = 0 / 10;
                ctrl.BttnBox_PX = 0;
            }
            if (isMouseOver === 'No' & ctrl.widgetSetting.analogOutputWidgetSetting.sizeId <= 1) {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 4 / 10;
                ctrl.UnitBox_AR = 3 / 10;
                ctrl.AuxBox_AR = 0 / 10;
                ctrl.Aux2Box_AR = 0 / 10;
                ctrl.BttnBox_PX = 0;
            }

            if (isMouseOver === 'Yes' & ctrl.show_chartdata === 'No' & ctrl.widgetSetting.analogOutputWidgetSetting.sizeId >= 3) {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 3 / 10;
                ctrl.UnitBox_AR = 2 / 10;
                ctrl.AuxBox_AR = 0 / 10;
                ctrl.Aux2Box_AR = 2 / 10;
                ctrl.BttnBox_PX = 25;
            }

            if (isMouseOver === 'Yes' & ctrl.show_chartdata === 'No' & ctrl.widgetSetting.analogOutputWidgetSetting.sizeId <= 2) {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 3 / 10;
                ctrl.UnitBox_AR = 2 / 10;
                ctrl.AuxBox_AR = 0 / 10;
                ctrl.Aux2Box_AR = 0 / 10;
                ctrl.BttnBox_PX = 30;
            }

            if (isMouseOver === 'Yes' & ctrl.show_chartdata === 'No' & ctrl.widgetSetting.analogOutputWidgetSetting.sizeId <= 1) {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 3 / 10;
                ctrl.UnitBox_AR = 2 / 10;
                ctrl.AuxBox_AR = 0 / 10;
                ctrl.Aux2Box_AR = 0 / 10;
                ctrl.BttnBox_PX = 20;
            }

            if (isMouseOver === 'Yes' & ctrl.show_chartdata === 'Yes') {
                ctrl.TitleBox_AR = 0 / 10;
                ctrl.NumberBox_AR = 0 / 10;
                ctrl.UnitBox_AR = 0 / 10;
                ctrl.AuxBox_AR = 6 / 10;
                ctrl.Aux2Box_AR = 2 / 10;
                ctrl.BttnBox_PX = 25;
            }

            var calc_w_hudAdjWidthPX = ctrl.w_hudWidthPX - ctrl.HudPadding; // 

            var calc_TitleBoxW_Height = ctrl.w_hudWidthPX * ctrl.TitleBox_AR;
            var calc_NumberBoxW_Height = ctrl.w_hudWidthPX * ctrl.NumberBox_AR;
            var calc_UnitBoxW_Height = ctrl.w_hudWidthPX * ctrl.UnitBox_AR;
            var calc_AuxBoxW_Height = ctrl.w_hudWidthPX * ctrl.AuxBox_AR;
            var calc_Aux2BoxW_Height = ctrl.w_hudWidthPX * ctrl.Aux2Box_AR;

            var calc_Aux2BoxW_Height_Default = calc_w_hudAdjWidthPX * ctrl.Aux2Box_StageAR;

            var calc_TotalBoxHeights = calc_TitleBoxW_Height + calc_NumberBoxW_Height + calc_UnitBoxW_Height + calc_AuxBoxW_Height + calc_Aux2BoxW_Height;

            var hudSpaceHeight_Default = ctrl.w_hudHeight_DefaultPX - ctrl.HudPadding - ctrl.BttnBox_PX;
            var hudSpaceHeight_Active = ctrl.w_hudHeight_ActivePX - ctrl.HudPadding - ctrl.BttnBox_PX;

            if (isMouseOver === 'No') {
                var calc_TotalBoxHeightFactorPane1 = hudSpaceHeight_Default / calc_TotalBoxHeights;
            }

            if (isMouseOver === 'Yes') {
                var calc_TotalBoxHeightFactorPane1 = hudSpaceHeight_Active / calc_TotalBoxHeights;
            }

            var print_TitleBoxW_Height = calc_TotalBoxHeightFactorPane1 * calc_TitleBoxW_Height;
            var print_NumberBoxW_Height = calc_TotalBoxHeightFactorPane1 * calc_NumberBoxW_Height;
            var print_UnitBoxW_Height = calc_TotalBoxHeightFactorPane1 * calc_UnitBoxW_Height;
            var print_AuxBoxW_Height = calc_TotalBoxHeightFactorPane1 * calc_AuxBoxW_Height;
            var print_Aux2BoxW_Height = calc_TotalBoxHeightFactorPane1 * calc_Aux2BoxW_Height;

            ctrl.w_TitleBoxW_Style = { "height": print_TitleBoxW_Height + "px" };
            ctrl.w_TitleBox_Style = { "height": calc_TitleBoxW_Height + "px", "margin-top": (print_TitleBoxW_Height - calc_TitleBoxW_Height) / 2 + "px" };

            ctrl.w_NumberBoxW_Style = { "height": print_NumberBoxW_Height / 2 + "px" };
            ctrl.w_NumberBox_Style = { "height": calc_NumberBoxW_Height / 2 + "px", "margin-top": (print_NumberBoxW_Height - calc_NumberBoxW_Height) / 2 + "px" };

            ctrl.w_UnitBoxW_Style = { "height": print_UnitBoxW_Height + "px" };
            ctrl.w_UnitBox_Style = { "height": calc_UnitBoxW_Height + "px", "margin-top": (print_UnitBoxW_Height - calc_UnitBoxW_Height) / 2 + "px" };

            ctrl.w_AuxBoxW_Style = { "height": 0 + "px" }; //need it back print_AuxBoxW_Height
            ctrl.w_AuxBox_Style = { "height": calc_AuxBoxW_Height + "px", "margin-top": (print_AuxBoxW_Height - calc_AuxBoxW_Height) / 2 + "px" };

            ctrl.w_Aux2BoxW_Style = { "height": print_AuxBoxW_Height + print_Aux2BoxW_Height + ctrl.BttnBox_PX + "px" }; //{ "height": (print_AuxBoxW_Height + print_Aux2BoxW_Height) + "px" };// remove it from here print_AuxBoxW_Height
            ctrl.w_Aux2Box_Style = {}; //{ "height": calc_Aux2BoxW_Height_Default + "px", "margin-top": ((print_Aux2BoxW_Height - calc_Aux2BoxW_Height) / 2) + "px" }};

            ctrl.w_BttnBoxW_Style = { "height": 0 }; // { "height": ctrl.BttnBox_PX + "px" };
            ctrl.w_BttnBox_Style = { "height": 0 }; // { "height": ctrl.BttnBox_PX_StagePX + "px" };
        };
        ctrl.set_HUDItemHeights('No');
    };

    ctrl.DisplayTimestamp = function (reportDateTime, currentDateTime, format) {

        var w_format = format;
        var w_reportDateTime = reportDateTime;
        var w_elapsedtime = datetime_difference(reportDateTime, currentDateTime);

        if (w_format === "Absolute") {
            ctrl.timestamp_Display = w_reportDateTime;
        }
        if (w_format === "Elapsed") {
            ctrl.timestamp_Display = w_elapsedtime;
        }
    };

    ctrl.finishLoading = function () {
        if (ctrl.widgetSetting) {
            ctrl.buildTachStrokeDash();
        }
        ctrl.loadingFinished = true;
    };

    ctrl.buildTachStrokeDash = function () {
        var w_minValue = ctrl.widgetSetting.analogOutputGauge.minVal,
            w_maxValue = ctrl.widgetSetting.analogOutputGauge.maxVal,
            w_lowRestore = ctrl.widgetSetting.analogOutputGauge.lowRestore,
            w_highRestore = ctrl.widgetSetting.analogOutputGauge.highRestore,
            w_lowFault = ctrl.widgetSetting.analogOutputGauge.lowAlarm,
            w_highFault = ctrl.widgetSetting.analogOutputGauge.highAlarm,
            w_lowcolor = ctrl.widgetSetting.analogOutputWidgetSetting.lowAlarmColor,
            w_normalcolor = ctrl.widgetSetting.analogOutputWidgetSetting.normalColor,
            w_highcolor = ctrl.widgetSetting.analogOutputWidgetSetting.highAlarmColor;

        ctrl.w_Path1 = $element.find('.path_5')[0];
        ctrl.w_Path2 = $element.find('.path_4')[0];
        ctrl.w_Path3 = $element.find('.path_3')[0];
        ctrl.w_Path4 = $element.find('.path_2')[0];
        ctrl.w_Path5 = $element.find('.path_1')[0];

        var gv_TachLength = ctrl.w_Path1.getTotalLength();

        ctrl.w_Path1.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_maxValue, gv_TachLength);
        ctrl.w_Path2.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_highFault, gv_TachLength);
        ctrl.w_Path3.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_highRestore, gv_TachLength);
        ctrl.w_Path4.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_lowRestore, gv_TachLength);
        ctrl.w_Path5.style.strokeDasharray = ctrl.genTachArch(w_minValue, w_maxValue, w_lowFault, gv_TachLength);

        if (getState(ctrl.widgetSetting.deviceUnitState.state) === 'CommFail') {
            w_lowcolor = '#646464';
            w_normalcolor = '#7d7d7d';
            w_highcolor = '#969696';
        }

        if (w_highRestore === 0 && w_highFault === 0) {
            w_highcolor = w_normalcolor;
        }

        if (w_lowRestore === 0 && w_lowFault === 0) {
            w_lowcolor = w_normalcolor;
        }

        //ctrl.w_Path1.style.stroke = w_highcolor;
        //ctrl.w_Path3.style.stroke = w_normalcolor;
        //ctrl.w_Path5.style.stroke = w_lowcolor;

        //ctrl.w_Path2.style.stroke = darken(w_highcolor, 20);
        //ctrl.w_Path4.style.stroke = darken(w_lowcolor, 20);

        ctrl.w_Path1.style.stroke = w_normalcolor;
        ctrl.w_Path3.style.stroke = w_normalcolor;
        ctrl.w_Path5.style.stroke = w_normalcolor;

        ctrl.w_Path2.style.stroke = w_normalcolor;
        ctrl.w_Path4.style.stroke = w_normalcolor;
    };

    /* Add the indicated percentage to a color (RR, GG or BB) hexadecimal to clarify it */
    var addLight = function addLight(color, amount) {
        var cc = parseInt(color, 16) + amount;
        var c = cc > 255 ? 255 : cc;
        c = c.toString(16).length > 1 ? c.toString(16) : "0" + c.toString(16);
        return c;
    };

    /* const hexToRGB = (color) => {
      color = (color.indexOf("#")>=0) ? color.substring(1,color.length) : color;
      let colorRGB = [color.substring(0,2)]
    } */

    /* Clarifies a hexadecimal color of 6 characters #RRGGBB according to the indicated percentage */
    var lighten = function lighten(color, amount) {
        color = color.indexOf("#") >= 0 ? color.substring(1, color.length) : color;
        amount = parseInt(255 * amount / 100);
        return color = "#" + addLight(color.substring(0, 2), amount) + addLight(color.substring(2, 4), amount) + addLight(color.substring(4, 6), amount);
    };

    /* Subtract the indicated percentage to a color (RR, GG or BB) hexadecimal to darken it */
    var subtractLight = function subtractLight(color, amount) {
        var cc = parseInt(color, 16) - amount;
        var c = cc < 0 ? 0 : cc;
        c = c.toString(16).length > 1 ? c.toString(16) : "0" + c.toString(16);
        return c;
    };

    /* Darken a hexadecimal color of 6 characters #RRGGBB according to the indicated percentage */
    var darken = function darken(color, amount) {
        color = color.indexOf("#") >= 0 ? color.substring(1, color.length) : color;
        amount = parseInt(255 * amount / 100);
        return color = "#" + subtractLight(color.substring(0, 2), amount) + subtractLight(color.substring(2, 4), amount) + subtractLight(color.substring(4, 6), amount);
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ctrl.difference = function (a, b) {
        return Math.abs(a - b);
    };

    ctrl.round = function (value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        //return Math.round(value * multiplier) / multiplier;
        return value * multiplier / multiplier;
    };

    ctrl.calc_GuagePCT = function (g_min, g_max, g_numb) {
        var val_min = g_min;
        var val_max = g_max;
        var val_numb = g_numb;

        var calc_minmaxDiff = ctrl.difference(val_min, val_max); // Calculate diference between min and max
        var calc_minnumbDiff = ctrl.difference(val_min, val_numb); // Calculate diference between min and number
        //let calc_numbPerc = Math.round((calc_minnumbDiff / calc_minmaxDiff) * 100);
        var calc_numbPerc = calc_minnumbDiff / calc_minmaxDiff * 100;
        return calc_numbPerc;
    };

    ctrl.genTachArch = function (w_min, w_max, w_val, w_TachLength) {
        //let cv_MinMax = parseInt(ctrl.difference(w_min, w_max));
        var cv_MinMax = ctrl.difference(w_min, w_max);
        //let cv_ValueDiff = parseInt(ctrl.difference(w_min, w_val));
        var cv_ValueDiff = ctrl.difference(w_min, w_val);
        var cv_TachPercent = cv_ValueDiff / cv_MinMax;
        var cv_TachValue = cv_TachPercent * w_TachLength;
        var cv_TachEndVal = w_TachLength - cv_TachValue;

        return cv_TachValue + " " + cv_TachEndVal;
    };

    ctrl.rotateDEG = function (g_PCT) {

        var w_Low = -133; // Percent Rotation
        var w_High = 133; // Percent Rotation

        var w_PCT = g_PCT;

        var total_Deg = ctrl.difference(w_Low, w_High); //266
        var val_PCT = w_PCT * total_Deg / 100; // calculate percent of track
        var val_adjPCT = val_PCT + w_Low;

        return val_adjPCT;
    };

    var datetime_difference = function datetime_difference(date1, date2) {
        var unixDate1 = new Date(date1).getTime();
        var unixDate2 = new Date(date2).getTime();
        var difference = unixDate2 - unixDate1;

        var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
        difference -= daysDifference * 1000 * 60 * 60 * 24;

        var hoursDifference = Math.floor(difference / 1000 / 60 / 60);
        difference -= hoursDifference * 1000 * 60 * 60;

        var minutesDifference = Math.floor(difference / 1000 / 60);
        difference -= minutesDifference * 1000 * 60;

        var secondsDifference = Math.floor(difference / 1000);

        var daysDiffStr_Pos = w_saydiff(daysDifference, "d") + w_saydiff(hoursDifference, "h") + w_saydiff(minutesDifference, "m") + w_saydiff(secondsDifference, "s");
        var daysDiffStr_Neg = "0s";

        if (unixDate2 > unixDate1) {
            return daysDiffStr_Pos;
        }
        if (unixDate2 < unixDate1) {
            return daysDiffStr_Neg;
        }
        return '';
    };

    var w_saydiff = function w_saydiff(w_val, w_lab) {

        if (w_val == 0) {
            return '';
        }
        if (w_val == 1) {
            return w_val + '' + w_lab + ' ';
        }
        if (w_val > 1) {
            return w_val + '' + w_lab + ' ';
        }
        return '';
    };

    ctrl.buildMainClass = function () {
        var gaugeType = "TachGauge1"; // Options: TachGauge1 (Styled in mcwidgets.css)
        var pumpTransparentObj = "PumpTransparentObj";
        var mainClass = ["upWidget", gaugeType, ctrl.widgetSetting.analogOutputWidgetSetting.theme, "rtu" + getState(ctrl.widgetSetting.deviceUnitState.state), "acfail" + ctrl.widgetSetting.deviceUnitState.acFail];
        if (ctrl.analogType != "Single Needle Gauge") {
            mainClass = ["upWidget", gaugeType, ctrl.widgetSetting.analogOutputWidgetSetting.theme, "rtu" + getState(ctrl.widgetSetting.deviceUnitState.state), "acfail" + ctrl.widgetSetting.deviceUnitState.acFail, pumpTransparentObj];
        }
        ctrl.mainClass = angular.copy(mainClass);
    };

    ctrl.openView = function () {
        openViewService.openView(getView(ctrl.widgetSetting.deviceUnitState.state));
    };

    // from socket

    ctrl.webSocketHeartbeatReceived = function (data) {
        if (angular.isUndefined(ctrl.widgetSetting)) return; //The Widget has not initialized yet
        ctrl.heartbeatDateTime = new Date(data.LocalDateTime).toISOString();;;
        ctrl.DisplayTimestamp(datetimeService.UtcToLocalByTimeZone(ctrl.widgetSetting.device.lastHeardTime, ctrl.accountInfo.timeZone), ctrl.heartbeatDateTime, ctrl.widgetSetting.analogOutputWidgetSetting.dateTimeFormat);
    };

    ctrl.wsDataReceivedAW = function (data) {

        if (ctrl.widgetSetting.analogOutputGauge.channel == data.CH && ctrl.widgetSetting.device.serialNumber === data.SN) {
            if (data.Value != 0) {
                ctrl.widgetSetting.analogOutputGauge.responseNewSetting = ctrl.scaledValues(ctrl.widgetSetting.analogOutputGauge.minVal, ctrl.widgetSetting.analogOutputGauge.maxVal, data.Value);
            }
        }
    };

    ctrl.wsDataReceivedAWSetPoint = function (data) {

        if (ctrl.widgetSetting.analogOutputGauge.channel == data.CH && ctrl.widgetSetting.device.serialNumber === data.SN) {
            if (data.Value != 0) {
                ctrl.widgetSetting.analogOutputGauge.newSetting = ctrl.scaledValues(ctrl.widgetSetting.analogOutputGauge.minVal, ctrl.widgetSetting.analogOutputGauge.maxVal, data.Value);
            }
        }
    };

    ctrl.wsListDeviceStateMsgReceived = function (data) {
        ctrl.widgetSetting.deviceUnitState.state = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).state;
        ctrl.widgetSetting.deviceUnitState.acFail = data.find(function (x) {
            return x.id === ctrl.widgetSetting.device.deviceId;
        }).acFail;
        ctrl.fnRtuStatusOptions(getState(ctrl.widgetSetting.deviceUnitState.state));
    };

    ctrl.webSocketReconnect = function () {
        ctrl.unRegisterListener();
        toaster.pop('success', "Analog Output Widget" + " -- " + ctrl.widgetSetting.device.name, 'View reloading');
        ctrl.getData(ctrl.widgetSetting.device.deviceId, ctrl.widgetSetting.analogOutputGauge.channel);
    };

    var _onHeartbeat = $rootScope.$on('Heartbeat', function (event, args) {
        if (args.message.Type === "HEARTBEAT") {
            ctrl.webSocketHeartbeatReceived(args.message);
            //currentTime = new Date(args.message.LocalDateTime).getTime();
        }
    });

    ctrl.registerListener = function () {
        websocketService.connect();
        websocketService.register('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.startOverview();
        websocketService.register("ANALOGOUT", ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.analogOutputGauge.channel, ctrl.wsDataReceivedAW, ctrl.wsReconnectAW);
        websocketService.register("ANALOGOUTPUTSOURCE", ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.analogOutputGauge.channel, ctrl.wsDataReceivedAWSetPoint, ctrl.wsReconnectAWSetPoint);
        ctrl.urld = { type: "ANALOGOUTPUT", serialNumber: ctrl.widgetSetting.device.serialNumber, channel: ctrl.widgetSetting.analogOutputGauge.channel, dataReceived: ctrl.wsDataReceivedAW, reconnect: ctrl.webSocketReconnect };
    };

    ctrl.unRegisterListener = function (data) {
        if (angular.isUndefined(ctrl.urld)) return;
        websocketService.unRegister('LISTDEVICESTATEMSG', '', '', ctrl.wsListDeviceStateMsgReceived, null);
        websocketService.unRegister("ANALOGOUT", ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.analogOutputGauge.channel, ctrl.wsDataReceivedAW, ctrl.wsReconnectAW);
        websocketService.unRegister("ANALOGOUTPUTSOURCE", ctrl.widgetSetting.device.serialNumber, ctrl.widgetSetting.analogOutputGauge.channel, ctrl.wsDataReceivedAWSetPoint, ctrl.wsReconnectAWSetPoint);
        websocketService.stopOverview();
        websocketService.unRegister(ctrl.urld.type, ctrl.urld.serialNumber, ctrl.urld.channel, ctrl.urld.dataReceived, ctrl.urld.reconnect);
    };

    var _onDocumentDblClick = $rootScope.$on('document_click', function (event, args) {
        ctrl.closeSetting();
    });

    $scope.$on("$destroy", function () {
        _onHeartbeat();
        ctrl.unRegisterListener();
        _onDocumentDblClick();
        if (chart) chart.destroy();
    });

    $scope.$on('rtuAnalogUpdate', function (event, args) {
        var _dataChanged = "name, unit, minimumValue, maximumValue";
        if (args.deviceId == ctrl.widgetSetting.device.deviceId && _dataChanged.indexOf(args.fieldName) > -1) {
            _resetView(args);
        }
    });

    var _resetView = function _resetView(args) {
        if (ctrl.widgetSetting.analogOutputGauge.channel == args.channel) {
            ctrl.getData(ctrl.widgetSetting.device.deviceId, ctrl.widgetSetting.analogOutputGauge.channel);
            //var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
            //ctrl.widgetSetting.analogOutputGauge.minVal = _newData.minimumValue;
            //ctrl.widgetSetting.analogOutputGauge.maxVal = _newData.maximumValue;
            //ctrl.widgetSetting.analogOutputGauge.name = _newData.name;
            //ctrl.widgetSetting.analogOutputGauge.unit = _newData.unit;
        }
    };

    $scope.$on("StopOverview", function (event, args) {
        if ($scope.$$destroyed) {
            // The scope is already destroyed, skip further processing.
            return;
        } else if (args.stop) {
            websocketService.connect();
            websocketService.startOverview();
        }
    });

    //var _getArgsFromNewSetting = function (channel, newSetting) {
    //    for (var i = 0; i < newSetting.length; i++) {
    //        if (newSetting[i].channel == channel) {
    //            return newSetting[i];
    //        }
    //    }
    //    return null;
    //};
}

McWidgetAnalogOutputDisplayController.$inject = ['$', '$timeout', '$rootScope', '$scope', '$element', 'McWidgetAnalogOutputDisplayFactory', '$compile', 'websocketService', 'toaster', 'datetimeService', 'sharedSetupService', 'McAnalogOutputGaugeFactory', 'authenticationService', 'openViewService', 'translationService', 'PopupFactory', 'McWidgetsSharedFactory'];
'use strict';

angular.module('mc.widget-analog-output-display').component('mcWidgetAnalogOutputDisplay', {
    controller: McWidgetAnalogOutputDisplayController,
    templateUrl: 'ui/mcwidgetanalogoutputdisplay/mcwidget-analog-output-display-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        widgetSetting: '<',
        settingShow: '&',
        changeWidgetTitle: '&',
        analogType: '<'
    }
});
angular.module("flowChartModule", []);
angular.module("flowChartModule").factory('flowChartService', ['$http', 'REPORTS', function ($http, REPORTS) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: REPORTS + '/api/Flow/FlowChart?' + varParm,
                cache: false
            });
        },
        getLiveData: function (varParm) {
            return $http({
                method: 'GET',
                url: REPORTS + '/api/Flow/FlowChart/GetLiveData?' + varParm,
                cache: false
            });
        }
    };
}]);
angular.module("flowChartModule").directive('drawFlowChart',
    ['$rootScope', '$timeout', 'flowChartService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'sharedSetupService', 'openViewService', 'highchartsOptionsService', 'HOST', '$http', '$q', 'detectBrowserService', 'getDateRangeService',
        function ($rootScope, $timeout, flowChartService, datetimeService, websocketService, timeLapseService, toaster, sharedSetupService, openViewService, highchartsOptionsService, HOST, $http, $q, detectBrowserService, getDateRangeService) {
            // return the directive link function. (compile function not needed)
            return function (scope, element, attrs) {
                var curentBrowser = detectBrowserService();
                var ieEdge = curentBrowser === 'ie' || curentBrowser === 'edge';

                var chart;
                var varToggle = false;
                var tmpData;

                var xValue = null;
                var scrollingInProgress = false;
                var zoomLevelCurrent, zoomLevelPrevious = 0;
                var initialLoad = true;
                scope.chartSeriesVisibility = [];
                scope.showMsg = false;
                scope.isRefresh = false;

                scope.detailedInfo = null;

                var _liveData = false;
                var _pollInterval = 23;// 23 minutes; 

                if (!$rootScope.mobile && !$rootScope.classicView) {
                    scope.popup = _this.getExistingDialog(scope.windowId).ref;
                    sharedSetupService.maximize(scope.popup);
                }

                element.attr("class", "chart");

                element.on('mousewheel', function (event) {
                    if (!scrollingInProgress)
                        scope.mouseWheelZoom(event, chart, xValue);
                });

                if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

                scope.$watch('lastUpdateAt', function (newValue, oldValue) {
                    if (newValue && newValue != oldValue) {
                        scope.liveDataIn = !scope.liveDataIn;
                        $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
                    }
                }, true);

                scope.$watch('deviceSelected', function (newValue, oldValue) {
                    if (newValue) {
                        var tmpNewValue = scope.findFirstDeviceWithFlow(newValue);
                        scope.deviceSelected = tmpNewValue.deviceId;
                        scope.deviceSelectedSn = tmpNewValue.serialNumber;
                        scope.deviceSelectedType = tmpNewValue.type;
                        scope.deviceSelectedName = tmpNewValue.name;
                        if (!$rootScope.mobile && !$rootScope.classicView)
                            scope.popup.dialog("option", "title", scope.windowTitle + ", " + tmpNewValue.name);
                        scope.currentSelectedDevice = tmpNewValue;
                        scope.goSelectReportData();
                    }
                }, true);

                scope.findFirstDeviceWithFlow = function (deviceId) {
                    for (var i = 0; i < scope.devices.length; ++i) {
                        if (scope.devices[i].deviceId === deviceId && scope.devices[i].sumDeviceAnalog > 0) {
                            return scope.devices[i];
                        }
                    }
                    for (var j = 0; j < scope.devices.length; ++j) {
                        if (scope.devices[j].sumDeviceAnalog > 0) {
                            return scope.devices[j];
                        }
                    }
                    return 0;
                };

                scope.isDataAvailable = function(indexValue) {
                    if (scope.series[indexValue].data.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                };

                scope.getBackgroundColor = function(indexValue) {
                    if (scope.series[indexValue].color) {
                        return scope.series[indexValue].color;
                    } else {
                        return false;
                    }
                };

                scope.mostRecentData = function() {
                    scope.isRefresh = true;
                    toaster.pop('success',
                        'Integrated Flow Report' + '--' + scope.deviceSelectedName,
                        'View reloading');
                    scope.goSelectReportData();
                };

                scope.goSelectReportData = function (isRefresh, startDate, endDate) {
                    element.empty();
                    scope.detailedInfo = null;
                    scope.loadingInProgress = true;
                    if (startDate) { scope.myDateRangeStart = startDate }
                    if (endDate) { scope.myDateRangeEnd = endDate }
                    scope.maxDateRange = getDateRangeService.getRange("Integratedflow");
                    scope.alerts = [];
                    var numberOfDays = 15, varDateRangeStart, varDateRangeEnd, varDateRangeEndTmp;
                    if (scope.stickyProperties.on == true && scope.stickyProperties.dateMax !== null) {
                        scope.stickyProperties.on = false;
                        varDateRangeStart = scope.stickyProperties.dateMin;
                        varDateRangeEnd = scope.stickyProperties.dateMax;
                        scope.myDateRangeStart = new Date(varDateRangeStart);
                        scope.myDateRangeEnd = new Date(varDateRangeEnd - scope.unixDay);
                    }
                    else if (new Date(scope.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeEnd)) && new Date(scope.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeStart))) {
                        scope.myDateRangeEnd = (new Date(scope.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeEnd))) ? scope.myDateRangeEnd : new Date();
                        scope.myDateRangeStart = (new Date(scope.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(scope.myDateRangeStart))) ? scope.myDateRangeStart : new Date();
                        varDateRangeEnd = scope.myDateRangeEnd;
                        varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                        varDateRangeStart = scope.myDateRangeStart;
                        varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
                    }
                    else {
                        scope.myDateRangeEnd = new Date();
                        scope.myDateRangeStart = new Date();
                        scope.myDateRangeStart.setDate(scope.myDateRangeStart.getDate() - (numberOfDays));

                        varDateRangeEnd = new Date();
                        varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                        ///////// needed to calculate varDateRangeStart
                        varDateRangeEndTmp = new Date();
                        varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
                        ///////// needed to calculate varDateRangeStart
                        varDateRangeStart = varDateRangeEndTmp - ((numberOfDays + 0) * scope.unixDay);
                    }

                    if (scope.isRefresh) {
                        scope.isRefresh = false;
                        scope.myDateRangeEnd = new Date();
                        scope.myDateRangeStart = new Date();
                        scope.myDateRangeStart.setDate(scope.myDateRangeStart.getDate() - (numberOfDays));

                        varDateRangeEnd = new Date();
                        varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                        ///////// needed to calculate varDateRangeStart
                        varDateRangeEndTmp = new Date();
                        varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
                        ///////// needed to calculate varDateRangeStart
                        varDateRangeStart = varDateRangeEndTmp - ((numberOfDays + 0) * scope.unixDay);
                    }

                    scope.showMsg = false;
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: scope.windowId });
                    flowChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&StartDate=' + varDateRangeStart + '&EndDate=' + varDateRangeEnd + '&MetarStationId=' + scope.accountInfo.preferenceCustomer.metarStationID).then(function (datafromFactory) {

                        scope.flowSetting = datafromFactory.data.setting;
                        scope.yAxis = datafromFactory.data.yAxis;
                        scope.yAxis[0].labels.formatter = function () {
                            var label = this.axis.defaultLabelFormatter.call(this);
                            if (label > 1000) {
                                return Math.round(label / 1000) + 'k';
                            }
                            return Highcharts.numberFormat(label, 0);;
                        };
                        scope.yAxis[1].labels.formatter = function () {
                            return this.value;
                        };
                        scope.yAxis[1].labels.x = -10;
                        scope.series = datafromFactory.data.series;
                        scope.detailedInfo = datafromFactory.data.detailedInfo; 
                        scope.alerts = [];
                        var _device = { deviceName: scope.deviceSelectedName };
                        if (datafromFactory.data.series.length > 0 && datafromFactory.data.series[0].data.length >= 1) {
                            scope.devicename = datafromFactory.data.device.name;
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, device: _device, dataMin: varDateRangeStart, dataMax: varDateRangeEnd, windowId: scope.windowId });
                            _drawChart();
                        }
                        else {
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, device: _device, dataMin: varDateRangeStart, dataMax: varDateRangeEnd, windowId: scope.windowId });
                            //element.empty();
                            scope.loadingInProgress = false;
                            scope.lastStart = varDateRangeStart;
                            scope.lastEnd = varDateRangeEnd;
                            var errormsg = scope.translation.message.NO_DATA + ": " + moment(varDateRangeStart).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(varDateRangeEnd).utc().format('MM/DD/YY, h:mm:ss a');
                            scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                            if (!$rootScope.mobile && !$rootScope.classicView) scope.adjustSize();
                        }
                    }, function (error) {
                        scope.alerts = [];
                        //element.empty();
                        scope.loadingInProgress = false;
                        var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                        scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
                    });
                };

                scope.downloadDataA = function (varChannel, varName) {
                    var deferred = $q.defer();
                    var defaultFileName = "IntegratedFlowData.xls";
                    var url = HOST + '/api/Flow/FlowChart?customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&channel=' + varChannel + '&StartDate=' + scope.stickyProperties.dateMin + '&EndDate=' + scope.stickyProperties.dateMax + '&MetarStationId=' + scope.accountInfo.preferenceCustomer.metarStationID;

                    $http.get(url, { responseType: 'arraybuffer' }).then(
                        function (result) {
                            var blob = new Blob([result.data], { type: 'application/vnd.ms-excel' });
                            saveAs(blob, defaultFileName);
                            deferred.resolve(defaultFileName);
                        }, function (data) {
                            var e = "error";
                            deferred.reject(e);
                        });
                    return deferred.promise;
                };

                scope.downloadData = function (varChannel, varName) {
                    var defaultFileName = "IntegratedFlowData-" + varName + ".xls";
                    defaultFileName = defaultFileName.replace(/[<>:"\/\\|?*]+/g, '_')
                    var url = HOST + '/api/Flow/FlowChart?customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&channel=' + varChannel + '&StartDate=' + scope.stickyProperties.dateMin + '&EndDate=' + scope.stickyProperties.dateMax + '&MetarStationId=' + scope.accountInfo.preferenceCustomer.metarStationID;
                    $http.get(url, { responseType: 'arraybuffer' }).then(function (result) {
                        var blob = new Blob([result.data], { type: 'application/vnd.ms-excel' });
                        $timeout(function () {
                            saveAs(blob, defaultFileName);
                        }, 0);
                    }, function (result) {
                        console.log("error");
                    });
                };

                scope.openDownloadMenu = function() {
                    if ($rootScope.classicView || $rootScope.mobile) {
                        $location.path('/download/download-partial');
                    } else {
                        const popup = _this.getExistingDialog(this.windowId).ref;
                        const popupPosition = popup.dialog('option', 'position');
                        const newPopupPosition = {
                            at: popupPosition.at,
                            my: popupPosition.my,
                            collision: popupPosition.collision,
                            of: popupPosition.of,
                            using: popupPosition.using
                        };

                        //newPopupPosition.at = `left+${popup.offset().left + this.popupOffset} top+${(popup.offset().top + this.popupOffset)}`;
                        //this.popupOffset += 10;

                        var endDate = new Date();
                        endDate = endDate.setHours(23, 59, 59, 999);
                        ///////// needed to calculate varDateRangeStart
                        var endDateTmp = new Date();
                        endDateTmp = endDateTmp.setHours(0, 0, 0, 0);
                        ///////// needed to calculate varDateRangeStart
                        var startDate = endDateTmp - ((15 + 0) * scope.unixDay);

                        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
                        optionsStickyProperties.downloadOptions.resolution = 0;
                        optionsStickyProperties.downloadOptions.deviceId = scope.stickyProperties.deviceId;
                        optionsStickyProperties.downloadOptions.deviceName = scope.stickyProperties.device.deviceName;
                        optionsStickyProperties.downloadOptions.startDate = new Date(startDate);
                        optionsStickyProperties.downloadOptions.endDate = new Date(endDate);
                        optionsStickyProperties.downloadOptions.reportType = "Integrated Flow";

                        openViewService.openView('Download',
                            { width: 400, height: 200 },
                            newPopupPosition,
                            optionsStickyProperties,
                            { minimumWidth: 200, minimumHeight: 100 });

                    }
                };

                scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
                    if (newValue && newValue != oldValue) {
                        scope.chartSeriesVisibility = [];
                        scope.stickyProperties.device.serialNumber = newValue;
                        if (oldValue) {
                            _unRegisterListener(oldValue);
                        }
                    }
                }, true);

                var _drawChart = function (resetView) {
                    varToggle = false;
                    tmpData = scope.series;
                    var chartDrawn = false;
                    var numberOfSeries, numberOfHiddenSeries = 0;

                    var chartXaxisHourFormat = scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
                    var chartToolTipHourFormat = scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

                    chart = new Highcharts.StockChart({
                        credits: {
                            enabled: false
                        },
                        legend: {
                            enabled: true,
                            backgroundColor: '#f9f9f9',
                            borderColor: '#cccccc',
                            borderWidth: 1,
                            useHTML: !ieEdge,
                            labelFormatter: function () {
                                return this.name;
                            }
                        },
                        chart: {
                            renderTo: element[0],
                            backgroundColor: '#ebebeb',
                            plotBackgroundColor: '#f9f9f9',
                            borderColor: '#d3d3d3',
                            borderWidth: 1,
                            borderRadius: 2,
                            panning: true,
                            panKey: 'shift',
                            pinchType: 'x',
                            plotBorderWidth: 1,
                            marginTop: 0,
                            //marginRight: 10,
                            spacingBottom: 5,
                            spacingTop: 0,
                            spacingLeft: 2,
                            //spacingRight: 5,
                            animation: false,
                            reflow: true,
                            events: {
                                redraw: function (event) {
                                    var tmpDates,
                                        i,
                                        flowData = [],
                                        extremes = this.xAxis[0].getExtremes();

                                    if (this.xAxis && chartDrawn === true && scrollingInProgress === false) {
                                        if (extremes && extremes.dataMin >= extremes.min - scope.liveDataOffset) {
                                            scrollingInProgress = true;
                                            this.showLoading();

                                            tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -11);

                                            flowChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromFactory) {
                                                if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                                    for (i = 0; i < datafromFactory.data.series.length; i++) {
                                                        flowData.push(datafromFactory.data.series[i].data);
                                                    }
                                                }

                                                if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                                    for (i = 0; i < datafromFactory.data.series.length; i++) {
                                                        tmpData[i].data = flowData[i].concat(tmpData[i].data);
                                                        chart.series[i].setData(tmpData[i].data);
                                                    }
                                                }

                                                scope.devicename = datafromFactory.data.device.name;
                                                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, windowId: scope.windowId });
                                                chart.xAxis[0].setExtremes(extremes.min + scope.minPadding, extremes.max + scope.maxPadding);

                                                $timeout(function () {
                                                    scrollingInProgress = false;
                                                }, 1000);

                                                chart.hideLoading();
                                            }, function (error) {
                                                scope.alerts = [];
                                                element.empty();
                                                scope.loadingInProgress = false;
                                                var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                                                scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
                                            });
                                        } else if (scope.liveData === false && extremes && extremes.max + scope.liveDataOffset >= extremes.dataMax) {
                                            scrollingInProgress = true;
                                            this.showLoading();

                                            tmpDates = datetimeService.getNewStartEndDates(extremes.dataMax, 11);

                                            flowChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromFactory) {
                                                if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                                    for (i = 0; i < datafromFactory.data.series.length; i++) {
                                                        flowData.push(datafromFactory.data.series[i].data);
                                                    }
                                                }

                                                if (datafromFactory.data.series && datafromFactory.data.series.length > 0) {
                                                    for (i = 0; i < datafromFactory.data.series.length; i++) {
                                                        tmpData[i].data = tmpData[i].data.concat(flowData[i]);
                                                        chart.series[i].setData(tmpData[i].data);
                                                    }
                                                }

                                                scope.devicename = datafromFactory.data.device.name;
                                                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMax: tmpDates.endDate, windowId: scope.windowId });
                                                chart.xAxis[0].setExtremes(extremes.min + scope.minPadding, extremes.max + scope.maxPadding);

                                                $timeout(function () {
                                                    scrollingInProgress = false;
                                                }, 1000);

                                                chart.hideLoading();
                                            }, function (error) {
                                                scope.alerts = [];
                                                element.empty();
                                                scope.loadingInProgress = false;
                                                var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                                                scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
                                            });
                                        }
                                    }
                                },
                                load: function (event) {
                                    //if (initialLoad) openViewService.adjustContentSize(scope.popup);
                                    //initialLoad = false;
                                    //_setLiveDataStatus(this);
                                    openViewService.adjustContentSize(scope.popup);
                                    _setLiveDataStatus(this);
                                }
                            }
                        },
                        title: {
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold'
                            }
                        },
                        subtitle: {
                            text: null
                        },
                        exporting: {
                            enabled: false
                        },
                        xAxis: {
                            minRange: 3600 / 4 * 1000, //15 minutes
                            title: {
                                text: scope.translation.text.TIME,
                                style: {
                                    color: '#6D869F',
                                    fontWeight: 'bold',
                                    fontSize: '15px'
                                }
                            },
                            plotLines: [{
                                value: 0,
                                width: 7,
                                color: 'green',
                                dashStyle: "solid",
                                zIndex: 1
                            }],
                            endOnTick: true,
                            showLastLabel: true,
                            startOnTick: true,
                            ordinal: false,
                            minTickInterval: 3600 * 1000,
                            minorGridLineColor: '#ebebeb',
                            minorTickInterval: 'auto',
                            dateTimeLabelFormats: {
                                hour: chartXaxisHourFormat
                            },
                            labels: {
                                style: {
                                    color: '#6D869F',
                                    fontWeight: 'bold'
                                }
                            },
                            events: {
                                afterSetExtremes: function (e) {
                                    if (chartDrawn === true) {
                                        var extremes = chart.xAxis[0].getExtremes();
                                        if (scope.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) { //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                            if (extremes.max + scope.liveDataOffset <= extremes.dataMax) {
                                                sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                                            }
                                        }
                                        sharedSetupService.setStickyProperties(scope.stickyProperties, { zoomMin: extremes.min, zoomMax: extremes.max, windowId: scope.windowId });
                                        _downsampleSeries(extremes.min, extremes.max);

                                    }
                                }
                            }
                        },
                        yAxis: scope.yAxis,
                        tooltip: {
                            padding: 4, // Sets 4px padding on all sides
                            useHTML: true,
                            formatter: function () {
                                var d = new Date(this.x);
                                var s = '';
                                s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                                s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, this.x) + '</td></tr>';
                                $.each(this.points, function (i, point) {
                                    var numDecimals = point.series.type === "line" ? 2 : 0;//sharedSetupService.getNumberOfDecimals(scope.flowSetting[i].maximumValue, scope.flowSetting[i].minimumValue)
                                    s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, numDecimals) + '</td></tr>';
                                    xValue = point.x;
                                });
                                s += '</table>';
                                return s;
                            },
                            crosshairs: true,
                            shared: true,
                            valueDecimals: 1,
                            backgroundColor: '#FFFFFF',
                            borderColor: 'gray',
                            borderWidth: 1
                        },
                        navigator: {
                            enabled: true,
                            adaptToUpdatedData: true,
                            series: {
                                lineWidth: 0,
                                color: 'transparent'
                            },
                            maskFill: 'rgba(255, 255, 255, 0.35)',
                            maskInside: true,
                            handles: {
                                backgroundColor: '#a4a7a9',
                                borderColor: '#384450'
                            },
                            height: 22,
                            margin: 0,
                            xAxis: {
                                tickWidth: 2,
                                lineWidth: 1,
                                gridLineWidth: 0,
                                tickLength: 15,
                                tickPosition: 'inside',
                                tickColor: '#98b3d1',
                                dateTimeLabelFormats: {
                                    hour: chartXaxisHourFormat
                                },
                                labels: {
                                    align: 'left',
                                    style: {
                                        color: '#61768f',
                                        fontWeight: 'bold'
                                    },
                                    x: 8,
                                    y: -8
                                }
                            }
                        },
                        scrollbar: {
                            enabled: true,
                            height: 0,
                            barBackgroundColor: '#959595',
                            barBorderRadius: 2,
                            barBorderWidth: 0,
                            buttonBackgroundColor: '#959595',
                            buttonBorderWidth: 0,
                            buttonBorderRadius: 2,
                            trackBackgroundColor: 'none',
                            trackBorderWidth: 1,
                            trackBorderRadius: 3,
                            trackBorderColor: '#CCC',
                            liveRedraw: true
                        },
                        rangeSelector: {
                            enabled: true,
                            buttonTheme: {
                                stroke: '#ccc',
                                'stroke-width': 1,
                                r: 4,
                                width: 60, //fit to contents
                                padding: 2
                            },
                            inputEnabled: false,
                            allButtonsEnabled: true,
                            buttons: [
                                { type: 'day', count: 1, text: '1 ' + scope.translation.text.DAY },
                                { type: 'day', count: 3, text: '3 ' + scope.translation.text.DAYS.toLowerCase() },
                                { type: 'day', count: 7, text: '7 ' + scope.translation.text.DAYS.toLowerCase() },
                                { type: 'month', count: 1, text: '1 ' + scope.translation.text.MONTH }
                            ]
                        },
                        plotOptions: {
                            series: {
                                dataGrouping: {
                                    enabled: true,
                                    approximation: "sum",
                                    groupPixelWidth: 8,
                                    //smoothed: true,
                                    //forced: true,
                                    units: [['day', [1]]]
                                },
                                point: {
                                    events: {
                                        mouseOver: function () {
                                            xValue = this.x;
                                        },
                                        click: function () {
                                            var d = Highcharts.dateFormat('%m-%d-%Y', this.x);
                                            var startDate = new Date(d.replace(/-/g, '/'));
                                            var o = startDate.getTimezoneOffset();
                                            startDate = startDate.setHours(0, 0, 0, 0);
                                            
                                            if (_liveData) {
                                                var liveDataLine = chart.xAxis[0].plotLinesAndBands;

                                                liveDataLine[0].options.value =
                                                    (startDate + scope.unixDay - o * 60 * 1000) +
                                                    scope.maxPadding +
                                                    3000000;
                                            }

                                            chart.xAxis[0].setExtremes((startDate - o * 60 * 1000) + scope.minPadding, (startDate + scope.unixDay - o * 60 * 1000) + scope.maxPadding);
                                            
                                        }
                                    }
                                },
                                marker: {
                                    fillColor: '#FFFFFF',
                                    lineWidth: 2,
                                    lineColor: null // inherit from series
                                },
                                events: {
                                    legendItemClick: function () {
                                        numberOfSeries = this.chart.series.length - 1;
                                        var visibility = this.visible ? 'visible' : 'hidden';
                                        numberOfHiddenSeries = visibility == 'hidden' ? scope.chartSeriesVisibility.filter(function (v) {
                                            return !v;
                                        }).length - 1 : scope.chartSeriesVisibility.filter(function (v) {
                                            return !v;
                                        }).length + 1;
                                        numberOfHiddenSeries = numberOfHiddenSeries < 0 ? 0 : numberOfHiddenSeries;
                                        if (numberOfHiddenSeries < numberOfSeries) {
                                            //if(this.chart.yAxis[this.index]) {
                                            //    this.chart.yAxis[this.index].update({
                                            //        labels: {
                                            //            enabled: visibility == 'visible' ? false : true
                                            //        },
                                            //        title: {
                                            //            text: visibility == 'visible' ? null : scope.series[this.index].name
                                            //        },
                                            //        lineWidth: visibility == 'visible' ? 0 : 2
                                            //    });
                                            //}
                                            sharedSetupService.getChartSeriesVisibility(this.chart, scope.chartSeriesVisibility);
                                            return true;
                                        }
                                        return false;
                                    },
                                    mouseOut: function () {
                                        xValue = null;
                                    }
                                }
                            }
                        },
                        series: scope.series

                    }, function (chart) {

                        $timeout(function () {
                            //chartDrawn = true;
                        }, 0);
                    });

                    var tmpNewDateA;
                    var tmpNewDateB;
                    var extremes = chart.xAxis[0].getExtremes();

                    if (scope.stickyProperties.on === true) {
                        tmpNewDateA = scope.stickyProperties.zoomMin >= extremes.dataMin ? scope.stickyProperties.zoomMin : extremes.dataMin;//extremes.dataMin + scope.unixDay / 24 * 3;
                        tmpNewDateB = scope.stickyProperties.zoomMax <= extremes.dataMax + scope.liveDataOffset ? scope.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
                        tmpNewDateB = tmpNewDateB >= tmpNewDateA + scope.unixDay / 24 ? tmpNewDateB : extremes.dataMax - scope.unixDay / 24 * 12;
                        scope.stickyProperties.on = false;
                    }
                    else {
                        tmpNewDateA = scope.myDate !== null ? extremes.dataMin + scope.unixDay : extremes.dataMax - scope.unixDay / 24 * 4.5;
                        tmpNewDateB = scope.myDate !== null ? tmpNewDateA + scope.unixDay : extremes.dataMax;
                        if (tmpNewDateB > extremes.dataMax) {
                            tmpNewDateB = extremes.dataMax;
                            tmpNewDateA = tmpNewDateB - scope.unixDay;
                        }
                        tmpNewDateA = tmpNewDateA + scope.minPadding;
                        tmpNewDateB = tmpNewDateB + scope.maxPadding;
                    }

                    chart.xAxis[0].setExtremes(sharedSetupService.setStickyProperties.zoomMin, sharedSetupService.setStickyProperties.zoomMax);
                    if (scope.series !== null) { //only for analog chart if no setup
                        sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: scope.windowId });
                    }
                    else {
                        chart.showLoading(scope.translation.text.ANALOG_SETUP_UNAVAILABLE);
                    }

                    //chartDrawn = true;
                    scope.loadingInProgress = false;
                    if (!$rootScope.mobile && !$rootScope.classicView) scope.adjustSize();
                };

                var isToday = function(someDate) {
                    var today = new Date();
                    return someDate.getDate() == today.getDate() &&
                        someDate.getMonth() == today.getMonth() &&
                        someDate.getFullYear() == today.getFullYear();
                }; 

                var _setLiveDataStatus = function (chart) {
                    var dayGroupingOn = false;

                    if (typeof chart.series[0].currentDataGrouping != "undefined" && chart.series[0].currentDataGrouping !== null) {

                        dayGroupingOn = chart.series[0].currentDataGrouping.unitName === "day" ? true : false;
                    }

                    var extremes = chart.xAxis[0].getExtremes();
                    var MS_PER_MINUTE = 60000;
                    var d = new Date(extremes.dataMax - MS_PER_MINUTE);

                    if (isToday(d)) {

                        var liveDataLine = chart.xAxis[0].plotLinesAndBands;

                        liveDataLine[0].options.value = dayGroupingOn
                            ? (extremes.dataMax / 1000 + (1000 * 10 * 4.1)) * 1000
                            : (extremes.dataMax / 1000 + (1000 * 1 * 1.78)) * 1000; 

                        sharedSetupService.setStickyProperties(scope.stickyProperties,
                            { liveData: true, windowId: scope.windowId });

                        if (!_liveData) {
                            _registerListener(scope.deviceSelectedSn);
                        }

                    } else { 

                        sharedSetupService.setStickyProperties(scope.stickyProperties, 
                            { liveData: false, windowId: scope.windowId });

                        _unRegisterListener(scope.deviceSelectedSn);
                    }
                };

                var _registerListener = function(varSelectedSN) { 
                    timeLapseService.register("INTEGRATEDFLOW", varSelectedSN, "", _pollForLiveData, _pollInterval);
                    _liveData = true;
                };

                var _unRegisterListener = function (varSelectedSN) {
                    timeLapseService.unRegister("INTEGRATEDFLOW", varSelectedSN, "", _pollForLiveData, _pollInterval);
                    _liveData = false;

                };

                var _pollForLiveData = function (data) {

                    if (data.SN != scope.deviceSelectedSn) {
                        _unRegisterListener(data.SN);
                    } else {
                        var numberOfDays = 1;
                        var flowChartData = [];

                        varDateRangeEnd = new Date();
                        varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                        varDateRangeEndTmp = new Date();
                        varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
                        varDateRangeStart = varDateRangeEndTmp - ((numberOfDays + 0) * scope.unixDay);

                        flowChartService.getLiveData('customerId=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&startDate=' + varDateRangeStart + '&endDate=' + varDateRangeEnd).then(function (liveData) {

                            var _liveData = liveData.data;

                            var extremes = chart.xAxis[0].getExtremes();
                            
                            if (_liveData.series && _liveData.series.length > 0) {
                                for (var i = 0; i < _liveData.series.length; i++) {

                                    if (tmpData[i].data.length > 0) {

                                        var _lastDataPoint = tmpData[i].data[tmpData[i].data.length - 1][0];

                                        var _tmpLiveData = _liveData.series[i].data.filter(function (item) {
                                            return item[0] > _lastDataPoint;
                                        });

                                        flowChartData.push(_tmpLiveData);

                                        tmpData[i].data = tmpData[i].data.concat(flowChartData[i]); 
                                        chart.series[i].setData(tmpData[i].data);

                                        chart.xAxis[0].setExtremes(extremes.min, extremes.max);
                                    }

                                }

                                _updatePanelDetails(_liveData.detailedInfo);

                                chart.redraw();
                            } 

                        }, function (error) {
                                console.log(error);
                        });
                    }
                };

                var _updatePanelDetails = function (detailedInfo) {

                    scope.detailedInfo = detailedInfo;
                };

                scope.$on('updatePreferencesLanguage', function () {
                    if (scope.alerts.length === 0) {
                        _drawChart();
                    }
                });

                scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
                    scope.applyTimeFormat(timeFormat);
                    if (scope.alerts.length === 0) {
                        _drawChart();
                    }
                });

                scope.applyTimeFormat = function (timeFormat) {
                    scope.preferredTimeFormat = parseInt(timeFormat);
                };

                scope.$on("$destroy", function () {
                    _unRegisterListener(scope.deviceSelectedSn);
                    if (chart) chart.destroy();
                });
            };
        }]);
angular.module("flowChartModule").controller('flowChartController', [
    '$scope', '$rootScope', 'sharedSetupService', 'openViewService', 'translationService', '$element', 'authenticationService', function ($scope,  $rootScope, sharedSetupService, openViewService, translationService, $element, authenticationService) {
        sharedSetupService.getWindowId($scope);
        $scope.myDate = null;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
        $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
        $scope.unixDay = sharedSetupService.unixDay;
        $scope.liveDataOffset = 20 * 60 * 1000;
        $scope.minPadding = 0;
        $scope.maxPadding = 0;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.translation = translationService.translation;
        $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.alerts = [];
        $scope.loadingInProgress = true;
        $scope.downloadViewTypeOptions = [0]; 

        sharedSetupService.broadcastAllDeviceSelected($scope);
        $scope.openView = openViewService.openView;

        $scope.greaterThan = function (prop, val) {
            return function (item) {
                return item[prop] > val;
            }
        }

        if ($scope.classicView && $element.parent('div').parent('div').parent('div').attr('class') && $element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") == 0) {
            $scope.largeChart = true;
            $element.height(500);
        };

        $scope.selectMyDate = function() {
            $scope.selectMyDateC();
        };

        $scope.getIcon = function(varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        $scope.fnChangeLanguage = function() {
          if ($scope.alerts.length > 0) {
                var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                  _msg += ': ' + moment($scope.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                }
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        };

        $scope.downArrowScroll = function (){
            // var target = document.getElementById("chart-cards-view");
            // if (target) {
            //     target.scrollIntoView({ behavior: "smooth", block: "medium" });
            // }
            var contactTopPosition = $('#cards-view').position().top;
            $('#chart-cards-view').animate({scrollTop: contactTopPosition});
        };

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                	$scope.adjustSize();
                },
                restore: function (event, ui) {
					openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.chart').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 190); //25: total padding
                var _char = $scope.popup.parent().find('.chart').highcharts();
                if ($scope.popup.parent().find(".chart").highcharts()) {
                    _char.reflow();
                }
            };

        }
    }
]);
angular.module('home-module', []);
"use strict";

angular.module("mc.download", []);
'use strict';

angular.module('mc.download').component('downloadYearPumpPerformance', {
    controller: YearPumpPerformanceController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/year-pump-performance.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        selectedyear: '='
    }
});

function YearPumpPerformanceController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, rainGaugeListService) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;

    ctrl.selectedformat = "0";
    ctrl.reportType = "d";
    ctrl.selectedresolution = 0;
    ctrl.selectedyear = String(moment().year());
    ctrl.selectedmonth = String(moment().month() + 1);

    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    var selectedDate = yesterday;
    ctrl.reportdate = selectedDate;

    ctrl.startDownload = function () {

        ctrl.showMsg = false;
        ctrl.inProgressDownloadFile = true;
        var date = ctrl.reportdate;
        if (ctrl.reportType === 'm') {
            var month = ctrl.selectedmonth < 10 ? "0" + ctrl.selectedmonth : ctrl.selectedmonth;
            var year = ctrl.selectedyear;
            date = year + month + "01";
        } else {
            date = datetimeService.formatDate(ctrl.reportdate, 'yyyyMMdd');
        }
        var params = {
            customerId: ctrl.accountInfo.customerId,
            userId: ctrl.accountInfo.userId,
            reportType: ctrl.reportType,
            reportDate: date,
            format: ctrl.selectedformat,
            langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
            startTimeHour: ctrl.reportdate.getHours()
        };
        var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
        fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
        fileName += "_" + date;

        var url = $scope.$parent.$parent.DownloadCtrl.reportList.MonthlyPumpPerformance.url;

        DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
            ctrl.inProgressDownloadFile = false;
        });
    };
}
YearPumpPerformanceController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "rainGaugeListService"];

angular.module('mc.download').controller('YearPumpPerformanceController', YearPumpPerformanceController);
'use strict';

angular.module('mc.download').component('downloadVolumetricflowSummary', {
    controller: VolumetricflowSummaryController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/volumetricflow-summary.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function VolumetricflowSummaryController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 0;
    ctrl.startDate = weekago;
    ctrl.endDate = today;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.getDevices = function () {
        ctrl.deviceList = [];
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            angular.forEach(result.data.devices, function (value, key) {
                if (value.hasVolumetricFlow) ctrl.deviceList.push(value);
            });

            if (ctrl.deviceList.length === 0) {
                ctrl.deviceList.push({ deviceId: "", name: ctrl.translation.text.NO_DEVICES });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.getDevices();
    });

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else if (ctrl.selecteddevice.deviceId === "") {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO_DEVICES;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceId: ctrl.selecteddevice.deviceId,
                deviceName: ctrl.selecteddevice.name,
                startDate: startDate,
                endDate: endDate,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                measurementId: ctrl.accountInfo.preferenceUser.lookupMeasurementID,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.VolumetricflowSummary.url;
            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
VolumetricflowSummaryController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "$uibModal"];

angular.module('mc.download').controller('VolumetricflowSummaryController', VolumetricflowSummaryController);
'use strict';

angular.module('mc.download').component('downloadVolumetricflow', {
    controller: VolumetricflowController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/volumetricflow.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function VolumetricflowController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 0;
    ctrl.startDate = weekago;
    ctrl.endDate = today;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.getDevices = function () {
        ctrl.deviceList = [];
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            angular.forEach(result.data.devices, function (value, key) {
                if (value.hasVolumetricFlow) ctrl.deviceList.push(value);
            });

            if (ctrl.deviceList.length === 0) {
                ctrl.deviceList.push({ deviceId: "", name: ctrl.translation.text.NO_DEVICES });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.getDevices();
    });

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else if (ctrl.selecteddevice.deviceId === "") {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO_DEVICES;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceId: ctrl.selecteddevice.deviceId,
                startDate: startDate,
                endDate: endDate,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                measurementId: ctrl.accountInfo.preferenceUser.lookupMeasurementID,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.Volumetricflow.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
VolumetricflowController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "$uibModal"];

angular.module('mc.download').controller('VolumetricflowController', VolumetricflowController);
'use strict';

angular.module('mc.download').component('downloadVoltage', {
    controller: VoltageController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/voltage.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function VoltageController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 4;
    ctrl.analogtype = 0;
    ctrl.datapointResolution = 0;

    ctrl.deviceList = [];
    ctrl.analogtypes = [{
        label: ctrl.translation.text.DATA_POINTS,
        value: 0
    }, {
        label: ctrl.translation.text.MIN_MAX_AVG,
        value: 1
    }, {
        label: ctrl.translation.text.NOON_READINGS,
        value: 2
    }];

    ctrl.datapointResolutions = [{
        label: ctrl.translation.text.ALL_POINTS,
        value: 0
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_5,
        value: 1
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_15,
        value: 2
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_30,
        value: 3
    }];
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data.devices;
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId,
                    name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName,
                    type: ctrl.deviceList.find(function (s) {
                        return s.deviceId == sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId;
                    }).type
                };
                var selectedDevice = ctrl.deviceList.find(function (s) {
                    return s.deviceId == ctrl.selecteddevice.deviceId;
                });
                ctrl.selecteddevice.hasRMDTRadio = selectedDevice.hasRMDTRadio;
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();
    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceId: ctrl.selecteddevice.deviceId,
                deviceName: ctrl.selecteddevice.name,
                deviceType: ctrl.selecteddevice.type,
                startDate: startDate,
                endDate: endDate,
                hasRMDTRadio: ctrl.selecteddevice.hasRMDTRadio,
                type: ctrl.analogtype,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.Voltage.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
VoltageController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('VoltageController', VoltageController);
'use strict';

angular.module('mc.download').component('downloadUserlogin', {
    controller: UserloginController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/userlogin.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function UserloginController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var params = {
                customerId: ctrl.accountInfo.customerId,
                startDate: startDate,
                endDate: endDate,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.UserLoginHistory.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
UserloginController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('UserloginController', UserloginController);
'use strict';

angular.module('mc.download').component('downloadUntestedInput', {
    controller: UntestedInputController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/untested-input.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function UntestedInputController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.selectedformat = "0";
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    ctrl.startDownload = function () {
        ctrl.showMsg = false;
        ctrl.inProgressDownloadFile = true;

        var params = {
            customerId: ctrl.accountInfo.customerId,
            format: ctrl.selectedformat,
            langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
            emailAddress: ctrl.emailAddress
        };
        var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
        fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
        var url = $scope.$parent.$parent.DownloadCtrl.reportList.UntestedInput.url;

        DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
            ctrl.inProgressDownloadFile = false;
            if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                ctrl.openConfirmationPopUp = true;
            }
        });
    };
}
UntestedInputController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('UntestedInputController', UntestedInputController);
'use strict';

angular.module('mc.download').component('downloadTemperature', {
    controller: TemperatureController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/temperature.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function TemperatureController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.deviceList = [];

    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data.devices;
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();
    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceId: ctrl.selecteddevice.deviceId,
                deviceName: ctrl.selecteddevice.name,
                startDate: startDate,
                endDate: endDate,
                genII: ctrl.selecteddevice.genII,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                temperatureUnit: ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2 ? 0 : 1,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");

            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.Temperature.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
TemperatureController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('TemperatureController', TemperatureController);
'use strict';

angular.module('mc.download').component('downloadStationsummary', {
    controller: StationSummaryController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/station-summary-report.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function StationSummaryController($, $rootScope, $scope, $sce, DownloadFactory, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, deviceMenuService, $uibModal) {
    var ctrl = this;
    ctrl.dateTimeDownload = true;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.label = ctrl.translation.text.DEVICE;
    ctrl.selectedyear = String(moment().year());
    ctrl.selectedmonth = String(moment().month() + 1);
    ctrl.selectedformat = "2";
    //ctrl.max = 12;

    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    var selectedDate = yesterday;
    ctrl.reportdate = selectedDate;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        var dat = new Date(sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate);
        //Advance Download reflects Current Date instead it should reflect Current Date minus 1, hence -1
        dat.setDate(dat.getDate() - 1);
        ctrl.reportdate = dat;
    }

    ctrl.startDownload = function () {
        if (ctrl.selecteddevices == undefined) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO + " " + ctrl.translation.text.DEVICE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var deviceIds = null;
            if (ctrl.selecteddevices.length !== ctrl.deviceList.length) {
                // if all devices not selected
                angular.forEach(ctrl.selecteddevices, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });

                deviceIds = deviceIds.substring(0, deviceIds.lastIndexOf(','));
            }

            var reportdate = datetimeService.formatDate(ctrl.reportdate, 'yyyyMMdd');
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            //fileName += "_" + ctrl.selecteddevices.name.replace(/\s/g, "");
            if (ctrl.selecteddevices.length === 1) {
                var selectDevice = ctrl.deviceList.find(function (x) {
                    return x.id === ctrl.selecteddevices[0].id;
                });
                fileName += "_" + selectDevice.label.replace(/\s/g, "");
            } else {
                fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            }
            fileName += "_" + reportdate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.StationSummaryReport.url;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceIds: deviceIds,
                reportdate: reportdate,
                langId: ctrl.accountInfo.preferenceUser.i18nCode,
                format: ctrl.selectedformat,
                measurementUnit: ctrl.accountInfo.preferenceUser.lookupMeasurementID,
                startTimeHour: ctrl.reportdate.getHours(),
                emailAddress: ctrl.emailAddress,
                download: true
            };

            ctrl.inProgressDownloadFile = true;
            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };

    ctrl.deviceList = [];
    ctrl.selecteddevices = [];
    ctrl.deviceListArray = [];
    ctrl.deviceListSettings = { smartButtonMaxItems: 3 };
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            for (var index = 0; index < result.data.devices.length; ++index) {
                ctrl.deviceList.push({
                    id: result.data.devices[index].deviceId,
                    label: result.data.devices[index].name
                });
                ctrl.deviceListArray.push({
                    id: result.data.devices[index].deviceId
                });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevices = [{
                    id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId,
                    label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName
                }];
            } else {
                ctrl.selecteddevices = ctrl.deviceListArray;
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();
}
StationSummaryController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "deviceMenuService", "$uibModal"];
angular.module('mc.download').controller('StationSummaryController', StationSummaryController);
'use strict';

angular.module('mc.download').component('downloadSolar', {
    controller: SolarController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/solar.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function SolarController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.deviceList = [];

    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            angular.forEach(result.data.devices, function (value, key) {
                if (value.solar) ctrl.deviceList.push(value);
            });

            if (ctrl.deviceList.length === 0) {
                ctrl.deviceList.push({ deviceId: "", name: ctrl.translation.text.NO_DEVICES });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.INVALID_DATE_RANGE;
        } else if (ctrl.selecteddevice.deviceId === "") {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO_DEVICES;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceId: ctrl.selecteddevice.deviceId,
                deviceName: ctrl.selecteddevice.name,
                startDate: startDate,
                endDate: endDate,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                temperatureUnit: ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2 ? 0 : 1,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");

            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.Solar.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
SolarController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('SolarController', SolarController);
'use strict';

angular.module('mc.download').component('downloadSiteaccess', {
    controller: SiteAccessController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/siteaccess.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function SiteAccessController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.accessBy = [{ value: 0, label: ctrl.translation.text.ALL }, { value: 1, label: ctrl.translation.text.SITE }, { value: 2, label: ctrl.translation.text.USER }];

    ctrl.deviceList = [];
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data.devices;
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.userList = [];
    ctrl.getUsers = function () {
        $http.get(HOST + '/api/DallasKey?customerId=' + ctrl.accountInfo.customerId).then(function (resp) {
            ctrl.userList = resp.data;
            ctrl.selectedUser = ctrl.userList[0];
        });
    };
    ctrl.getUsers();

    ctrl.selectedaccessBy = 0;
    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var params = {
                customerId: ctrl.accountInfo.customerId,
                startDate: startDate,
                endDate: endDate,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                category: ctrl.selectedaccessBy,
                deviceId: ctrl.selecteddevice.deviceId,
                keyName: ctrl.selectedUser.keyName,
                deviceName: ctrl.selecteddevice.name,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.SiteAccess.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
SiteAccessController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('SiteAccessController', SiteAccessController);
'use strict';

angular.module('mc.download').component('downloadSignal', {
    controller: SignalController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/signal.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function SignalController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 0;
    ctrl.datapointResolution = 0;
    ctrl.startDate = weekago;
    ctrl.endDate = today;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.resolution !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.resolution !== null) {
        ctrl.selectedresolution = sharedSetupService.stickyPropertiesInterface.downloadOptions.resolution;
    }

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.deviceList = [];

    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data.devices;
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
            var selectedDevice = ctrl.deviceList.find(function (s) {
                return s.deviceId == ctrl.selecteddevice.deviceId;
            });
            ctrl.selecteddevice.hasRMDTRadio = selectedDevice.hasRMDTRadio;
        }, function (error) {});
    };
    ctrl.getDevices();
    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var selectedresolution = ctrl.selectedresolution;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceId: ctrl.selecteddevice.deviceId,
                deviceName: ctrl.selecteddevice.name,
                startDate: startDate,
                endDate: endDate,
                hasRMDTRadio: ctrl.selecteddevice.hasRMDTRadio, //ctrl.selecteddevice.protocolVersion === 2,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
            switch (ctrl.selectedresolution) {
                case 0:
                    fileName += "_" + ctrl.translation.text.INDIVIDUAL_POINTS.replace(/\s/g, "");
                    break;
                case 5:
                    fileName += "_" + ctrl.translation.text.DAILY.replace(/\s/g, "");
                    break;
            }
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.Signal.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
SignalController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('SignalController', SignalController);
'use strict';

angular.module('mc.download').component('downloadSafeWater', {
    controller: SafeWaterController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/safe-water.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function SafeWaterController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, rainGaugeListService, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;

    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 0;
    ctrl.selectedyear = String(moment().year());
    ctrl.selectedmonth = String(moment().month() + 1);

    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    ctrl.deviceList = [];
    ctrl.selecteddevice = [];
    ctrl.deviceListArray = [];
    ctrl.deviceListSettings = { smartButtonMaxItems: 3 };

    ctrl.getDevices = function () {
        $http.get(HOST + '/api/SafewaterDownload?customerId=' + ctrl.accountInfo.customerId).then(function (result) {
            for (var index = 0; index < result.data.length; ++index) {
                ctrl.deviceList.push({
                    id: result.data[index].deviceId,
                    label: result.data[index].name
                });
                ctrl.deviceListArray.push({
                    id: result.data[index].deviceId
                });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName }];
            } else {
                ctrl.selecteddevice = ctrl.deviceListArray;
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getTextToTranslate();
    });

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();

    ctrl.startDownload = function () {
        if (ctrl.selecteddevice == undefined || ctrl.selecteddevice.length === 0) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.SELECT_DEVICES_NR;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var month = ctrl.selectedmonth < 10 ? "0" + ctrl.selectedmonth : ctrl.selectedmonth;
            var year = ctrl.selectedyear;
            var startDate = year + month + "01";
            var deviceIds = null;

            angular.forEach(ctrl.selecteddevice, function (value, key) {
                deviceIds = deviceIds + value.id + ",";
            });

            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceIds: deviceIds,
                startDate: startDate,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };

            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");

            if (ctrl.selecteddevice.length === 1) {
                var selectDevice = ctrl.deviceList.find(function (x) {
                    return x.id === ctrl.selecteddevice[0].id;
                });
                fileName += "_" + selectDevice.label.replace(/\s/g, "");
            } else {
                fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            }

            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.SafeWater.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
SafeWaterController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "rainGaugeListService", "$uibModal"];

angular.module('mc.download').controller('SafeWaterController', SafeWaterController);
'use strict';

angular.module('mc.download').component('downloadRuntimevariance', {
    controller: RuntimevarianceController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/runtimevariance.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function RuntimevarianceController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, datetimeService, authenticationService, HOST, $http, translationService, sharedSetupService, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    ctrl.startDate = today;
    ctrl.selectedformat = "0";
    ctrl.deviceList = [];
    ctrl.reportdate = today;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    ctrl.startDownload = function () {
        ctrl.showMsg = false;
        ctrl.inProgressDownloadFile = true;
        var params = {
            customerId: ctrl.accountInfo.customerId,
            endDate: ctrl.reportdate.setHours(0, 0, 0, 0),
            format: ctrl.selectedformat,
            langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
            emailAddress: ctrl.emailAddress
        };
        var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
        fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
        fileName += "_" + datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');

        var url = $scope.$parent.$parent.DownloadCtrl.reportList.Runtimevariance.url;

        DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
            ctrl.inProgressDownloadFile = false;
            if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                ctrl.openConfirmationPopUp = true;
            }
        });
    };
}
RuntimevarianceController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "datetimeService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "$uibModal"];

angular.module('mc.download').controller('RuntimevarianceController', RuntimevarianceController);
'use strict';

angular.module('mc.download').component('downloadRainfallVsRuntime', {
    controller: RainfallVsRuntimeController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/rainfall-vs-runtime.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function RainfallVsRuntimeController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.deviceList = [];
    ctrl.selecteddevice = [];
    ctrl.deviceListArray = [];
    ctrl.deviceListSettings = { smartButtonMaxItems: 3 };
    ctrl.getDevices = function () {
        deviceMenuService.getRAllDevicesRainfallMenuList(ctrl.accountInfo.customerId).then(function (result) {
            for (var index = 0; index < result.data.length; ++index) {
                ctrl.deviceList.push({
                    id: result.data[index].deviceId,
                    label: result.data[index].deviceName
                });
                ctrl.deviceListArray.push({
                    id: result.data[index].deviceId
                });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName }];
            } else {
                ctrl.selecteddevice = ctrl.deviceListArray;
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getTextToTranslate();
    });

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.INVALID_DATE_RANGE;
        } else if (ctrl.selecteddevice == undefined) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO + " " + ctrl.translation.text.DEVICE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var deviceIds = null;
            if (ctrl.selecteddevice.length !== ctrl.deviceList.length) {
                angular.forEach(ctrl.selecteddevice, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });
            }

            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceIds: deviceIds,
                startDate: startDate,
                endDate: endDate,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                measurementId: ctrl.accountInfo.preferenceUser.lookupMeasurementID,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            if (ctrl.selecteddevice.length === 1) {
                var selectDevice = ctrl.deviceList.find(function (x) {
                    return x.id === ctrl.selecteddevice[0].id;
                });
                fileName += "_" + selectDevice.label.replace(/\s/g, "");
            } else {
                fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            }

            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.RainfallVsRuntime.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
RainfallVsRuntimeController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('RainfallVsRuntimeController', RainfallVsRuntimeController);
'use strict';

angular.module('mc.download').component('downloadRainfallRtu', {
    controller: RainfallRtuController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/rainfall-rtu.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function RainfallRtuController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, rainGaugeListService, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 5;

    ctrl.deviceList = [];

    ctrl.getDevices = function () {
        //  $http.get(`${HOST}/api/DallasKey?customerId=${ctrl.accountInfo.customerId}`).then((resp) => {
        rainGaugeListService.getData(ctrl.accountInfo.customerId).then(function (result) {
            angular.forEach(result.data, function (value, key) {
                ctrl.deviceList.push({ deviceId: value.deviceId, name: value.deviceName });
            });

            if (ctrl.deviceList.length === 0) {
                ctrl.deviceList.push({ deviceId: "", name: ctrl.translation.text.NO_DEVICES });
            }

            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else if (ctrl.selecteddevice.deviceId === "") {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO_DEVICES;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceId: ctrl.selecteddevice.deviceId,
                deviceName: ctrl.selecteddevice.name,
                startDate: startDate,
                endDate: endDate,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.RainfallRTU.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
RainfallRtuController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "rainGaugeListService", "$uibModal"];

angular.module('mc.download').controller('RainfallRtuController', RainfallRtuController);
'use strict';

angular.module('mc.download').component('downloadRainfallAirport', {
    controller: RainfallAirportController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/rainfall-airport.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function RainfallAirportController($, $rootScope, $scope, $sce, DownloadFactory, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, preferencesService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var yesterday = new Date(today);
    var weekago = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    weekago.setDate(today.getDate() - 8);
    ctrl.startDate = weekago;
    ctrl.endDate = yesterday;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 0;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.resolution !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.resolution !== null) {
        ctrl.selectedresolution = sharedSetupService.stickyPropertiesInterface.downloadOptions.resolution;
    }

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 8);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.usStateList = sharedSetupService.usStateList;
    ctrl.canadaProvinceList = sharedSetupService.canadaProvinceList;
    ctrl.stateList = [];
    ctrl.stateListTop = [];
    ctrl.stateListMidd = [];
    ctrl.stateListBottom = [];
    ctrl.stateListDisabledA = [];
    ctrl.stateListDisabledB = [];
    var _setLists = function _setLists(array_all) {
        $.each(array_all, function (index, value) {
            if (value.state.length === 2 && ctrl.canadaProvinceList.indexOf(value.state) < 0) {
                if ($.inArray(value.state, ctrl.stateListTop) === -1) {
                    //check if id value not exits than add it
                    ctrl.stateListTop.push(value.state); //push id value in arr
                }
            } else if (value.state.length == 2 && ctrl.canadaProvinceList.indexOf(value.state) >= 0) {
                if ($.inArray(value.state, ctrl.stateListMidd) === -1) {
                    //check if id value not exits than add it
                    ctrl.stateListMidd.push(value.state); //push id value in arr
                }
            } else {
                if ($.inArray(value.state, ctrl.stateListBottom) === -1) {
                    //check if id value not exits than add it
                    ctrl.stateListBottom.push(value.state); //push id value in arr
                }
            }
        });
        ctrl.stateListDisabledA.push("--Canada--");
        ctrl.stateListDisabledB.push("--Other Countries--");
        ctrl.stateList = ctrl.stateListTop.concat(ctrl.stateListDisabledA).concat(ctrl.stateListMidd).concat(ctrl.stateListDisabledB).concat(ctrl.stateListBottom);
    };

    ctrl.filterMetarStation = function (varId) {
        ctrl.metarStationsCopy = ctrl.metarStations.filter(function (el) {
            return el.state === varId;
        });
    };

    preferencesService.getLookups().then(function (result) {

        _setLists(result.data.metarStation);

        ctrl.metarStations = result.data.metarStation;
        ctrl.selectedStation(ctrl.accountInfo.preferenceCustomer.metarStationID);
    }, function (result) {});

    ctrl.selectedStation = function (metarStationID) {
        for (var i = 0; i < ctrl.metarStations.length; i++) {
            if (parseInt(metarStationID) === ctrl.metarStations[i].metarStationID) {
                ctrl.stateListSelectedOption = ctrl.metarStations[i].state;
                ctrl.filterMetarStation(ctrl.metarStations[i].state);
                ctrl.metarStationIDSelectedOption = { metarStationID: metarStationID, icao: ctrl.metarStations[i].icao };

                return;
            }
        }
    };

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.msg = "";
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');

            var params = {
                customerId: ctrl.accountInfo.customerId,
                metarStationId: ctrl.metarStationIDSelectedOption.metarStationID,
                startDate: startDate,
                endDate: endDate,
                resolution: ctrl.selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                rainfallUnit: ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2 ? 0 : 1,
                temperatureUnit: ctrl.accountInfo.preferenceUser.lookupMeasurementID === 2 ? 0 : 1,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.metarStationIDSelectedOption.icao.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.RainfallAirport.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        };
    };
}
RainfallAirportController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "preferencesService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('RainfallAirportController', RainfallAirportController);
'use strict';

angular.module('mc.download').component('downloadRainAnalysisReport', {
    controller: DownloadRainAnalysisReportController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/rain-analysis-report.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function DownloadRainAnalysisReportController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 3);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var params = {
                customerId: ctrl.accountInfo.customerId,
                startDate: startDate,
                endDate: endDate,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.RainAnalysisReport.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
DownloadRainAnalysisReportController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('DownloadRainAnalysisReportController', DownloadRainAnalysisReportController);
'use strict';

angular.module('mc.download').component('downloadPumpPerformance', {
    controller: PumpPerformanceController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/pump-performance.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function PumpPerformanceController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7); //TODO: this line of code should be deleted
        ctrl.endDate = weekago; //TODO: this logic seems to be wrong, correct it, it should be startDate + 7
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 4;

    ctrl.getDevices = function () {
        ctrl.deviceList = [];
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            angular.forEach(result.data.devices, function (value, key) {
                if (value.hasPump) {
                    ctrl.deviceList.push(value);
                }
            });

            if (ctrl.deviceList.length === 0) {
                ctrl.deviceList.push({ deviceId: "", name: ctrl.translation.text.NO_DEVICES });
            }

            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();
    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.getDevices();
    });

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else if (ctrl.selecteddevice.deviceId === "") {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO_DEVICES;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMddHHmmss');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMddHHmmss');
            var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                userId: ctrl.accountInfo.userId,
                deviceId: ctrl.selecteddevice.deviceId,
                startDate: startDate,
                endDate: endDate,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
            fileName += "_" + datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.PumpPerformance.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
PumpPerformanceController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('PumpPerformanceController', PumpPerformanceController);
'use strict';

angular.module('mc.download').component('downloadPulseflow', {
    controller: PulseflowController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/pulseflow.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function PulseflowController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.label = ctrl.translation.text.DEVICE;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 0;

    ctrl.deviceList = [];
    ctrl.deviceListArray = [];
    ctrl.selecteddevices = [];
    ctrl.deviceListSettings = { smartButtonMaxItems: 3 };
    ctrl.getDevices = function () {
        ctrl.deviceList = [];
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            for (var index = 0; index < result.data.devices.length; ++index) {
                if (result.data.devices[index].hasPulseFlow) {
                    ctrl.deviceList.push({
                        id: result.data.devices[index].deviceId,
                        label: result.data.devices[index].name
                    });

                    ctrl.deviceListArray.push({
                        id: result.data.devices[index].deviceId,
                        label: result.data.devices[index].name
                    });
                }
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevices = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName }];
            } else {
                ctrl.selecteddevices = ctrl.deviceListArray;
            }

            //Below changes are for Single Device Selection
            //check whether ctrl.selecteddevice.name has value
            // if (ctrl.selecteddevice.name == null) {
            //     for (let i = 0; i < ctrl.deviceList.length; i++) {
            //         if (ctrl.deviceList[i].deviceId === ctrl.selecteddevice.deviceId) {
            //             ctrl.selecteddevice.name = ctrl.deviceList[i].name;
            //             break;
            //         }
            //     }
            // }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.getDevices();
        ctrl.getTextToTranslate();
    });

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else if (!ctrl.selecteddevices || ctrl.selecteddevices.length === 0) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO + " " + ctrl.translation.text.DEVICE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var deviceIds = null;
            if (ctrl.selecteddevices.length !== ctrl.deviceList.length) {
                angular.forEach(ctrl.selecteddevices, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });
            } else {
                deviceIds = "";
                angular.forEach(ctrl.deviceList, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });
            }
            deviceIds = deviceIds.substring(0, deviceIds.lastIndexOf(','));
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceIds: deviceIds,
                startDate: startDate,
                endDate: endDate,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            if (ctrl.selecteddevices.length === 1) {
                var selectDevice = ctrl.deviceList.find(function (x) {
                    return x.id === ctrl.selecteddevices[0].id;
                });
                fileName += "_" + selectDevice.label.replace(/\s/g, "");
            } else {
                fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            }
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.Pulseflow.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
PulseflowController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('PulseflowController', PulseflowController);
'use strict';

angular.module('mc.download').component('downloadPeakFlowAnalog', {
    controller: PeakFlowAnalogController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/peak-flow-analog.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function PeakFlowAnalogController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, analogSettingService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    ctrl.reportdate = today;
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 6);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;
    ctrl.channels = [];
    ctrl.deviceList = [];
    ctrl.deviceListArray = [];
    ctrl.devicesSelected = [];
    ctrl.peakChannelDevices = 0;
    ctrl.rtusCompared = 0;

    ctrl.popoverDeviceListIsOpen = true;
    ctrl.popoverPeakFlowDeviceList = {
        templateUrl: 'PeakFlowDeviceListDownloadPopoverTemplate.html'
    };

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.getDevices = function () {
        DownloadFactory.getDevices(ctrl.accountInfo.customerId, true).then(function (result) {
            for (var index = 0; index < result.data.devices.length; ++index) {
                if (result.data.devices[index].hasAnalog) {
                    ctrl.deviceList.push({
                        id: result.data.devices[index].deviceId,
                        label: result.data.devices[index].name
                    });
                    ctrl.deviceListArray.push({
                        id: result.data.devices[index].deviceId
                    });
                    ctrl.devicesSelected.push({
                        deviceId: result.data.devices[index].deviceId,
                        name: result.data.devices[index].name,
                        isSelected: false,
                        peakChannel: 0,
                        channels: result.data.devices[index].channels
                    });
                }
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName }];
            } else {
                ctrl.selecteddevice = ctrl.deviceListArray;
            }
        }, function (error) {});
    };
    ctrl.getDevices();
    ctrl.setReportConfigurationAll = function () {
        // console.log("Peak Flow Devices", ctrl.devicesSelected);
    };
    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getTextToTranslate();
    });

    ctrl.unCheckRadio = function (index) {
        if (!ctrl.devicesSelected[index].isSelected) {
            ctrl.devicesSelected[index].peakChannel = 0;
        }
        if (ctrl.devicesSelected[index].peakChannel != 0) {
            ctrl.devicesSelected[index].peakChannel = 0;
        }
        ctrl.checkPeakDevice();
    };

    ctrl.checkPeakDevice = function () {
        ctrl.peakChannelDevices = 0;
        ctrl.rtusCompared = 0;
        if (ctrl.devicesSelected.length > 0) {
            angular.forEach(ctrl.devicesSelected, function (value, key) {
                if (value.isSelected && value.peakChannel == 0) {
                    ctrl.rtusCompared = ctrl.rtusCompared + 1;
                } else if (value.isSelected && value.peakChannel != 0) {
                    ctrl.peakChannelDevices = ctrl.peakChannelDevices + 1;
                } else if (value.peakChannel != 0) {
                    value.isSelected = true;
                    ctrl.peakChannelDevices = ctrl.peakChannelDevices + 1;
                }
            });
        }
        if (ctrl.peakChannelDevices > 0) {
            ctrl.showMsg = false;
        }
    };

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();

    ctrl.startDownload = function () {
        if (ctrl.selecteddevice == undefined) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO + " " + ctrl.translation.text.DEVICE;
        } else if (ctrl.peakChannelDevices == 0) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO + "  Peak Analog " + ctrl.translation.text.DEVICE + " Selected";
        } else if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = Date.parse(ctrl.startDate);
            var endDate = Date.parse(ctrl.endDate);
            var peakFlowDeviceIds = null;
            var peakFlowChannelIds = "";
            if (ctrl.devicesSelected.length > 0) {
                angular.forEach(ctrl.devicesSelected, function (value, key) {
                    if (value.isSelected) {
                        peakFlowDeviceIds = peakFlowDeviceIds + value.deviceId + ",";
                        peakFlowChannelIds = peakFlowChannelIds + value.peakChannel + ",";
                    }
                });
            }

            var params = {
                customerId: ctrl.accountInfo.customerId,
                timeZone: ctrl.accountInfo.timeZone,
                peakFlowDeviceIds: peakFlowDeviceIds.slice(0, -1),
                peakFlowChannelIds: peakFlowChannelIds.slice(0, -1),
                startDate: startDate,
                endDate: endDate,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                format: ctrl.selectedformat,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");

            var startDateP = new Date(startDate);
            fileName += "_" + datetimeService.formatDate(startDateP, 'yyyyMMdd');

            var endDateP = new Date(endDate);
            fileName += "_" + datetimeService.formatDate(endDateP, 'yyyyMMdd');

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.PeakFlowAnalog.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
PeakFlowAnalogController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "analogSettingService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "$uibModal"];

angular.module('mc.download').controller('PeakFlowAnalogController', PeakFlowAnalogController);
'use strict';

angular.module('mc.download').component('downloadMonthlyPumpPerformance', {
    controller: MonthlyPumpPerformanceController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/monthly-pump-performance.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function MonthlyPumpPerformanceController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, rainGaugeListService, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;

    ctrl.selectedformat = "0";
    ctrl.reportType = "d";
    ctrl.selectedresolution = 0;
    ctrl.selectedyear = String(moment().year());
    ctrl.selectedmonth = String(moment().month() + 1);

    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    var selectedDate = yesterday;
    ctrl.reportdate = selectedDate;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    ctrl.startDownload = function () {

        ctrl.showMsg = false;
        ctrl.inProgressDownloadFile = true;
        var date = ctrl.reportdate;
        var monthDateFormat = ""; //this is to display Monthly report filename differently
        if (ctrl.reportType === 'm') {
            var month = ctrl.selectedmonth < 10 ? "0" + ctrl.selectedmonth : ctrl.selectedmonth;
            var year = ctrl.selectedyear;
            date = year + month;

            //this is to display Monthly report filename differently
            var tmpDate = new Date(2024, ctrl.selectedmonth - 1, 10);
            var monthNameShort = tmpDate.toLocaleString('default', { month: 'short' });
            monthDateFormat = monthNameShort + " " + year;
        } else if (ctrl.reportType === 'y' || ctrl.reportType === 't') {
            date = ctrl.selectedYear;
        } else {
            date = datetimeService.formatDate(ctrl.reportdate, 'yyyyMMdd');
        }

        var params = {
            customerId: ctrl.accountInfo.customerId,
            userId: ctrl.accountInfo.userId,
            reportType: ctrl.reportType,
            reportDate: date,
            format: ctrl.selectedformat,
            langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
            startTimeHour: ctrl.reportdate.getHours(),
            emailAddress: ctrl.emailAddress
        };
        var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
        fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
        // if it is monthly report then display filename differently
        if (ctrl.reportType === 'm') {
            fileName += "_" + monthDateFormat;
        } else {
            fileName += "_" + date;
        }

        var url = $scope.$parent.$parent.DownloadCtrl.reportList.MonthlyPumpPerformance.url;

        DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
            ctrl.inProgressDownloadFile = false;
            if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                ctrl.openConfirmationPopUp = true;
            }
        });
    };
}
MonthlyPumpPerformanceController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "rainGaugeListService", "$uibModal"];

angular.module('mc.download').controller('MonthlyPumpPerformanceController', MonthlyPumpPerformanceController);
'use strict';

angular.module('mc.download').component('downloadManagement', {
    controller: ManagementController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/management-report.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function ManagementController($, $rootScope, $scope, $sce, DownloadFactory, detectBrowserService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000),
        day = beforeOneWeek.getDay(),
        diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1),
        lastMonday = new Date(beforeOneWeek.setDate(diffToMonday)),
        lastSunday = new Date(beforeOneWeek.setDate(diffToMonday - 1));

    ctrl.reportdate = lastSunday;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        var dat = new Date(sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate);
        ctrl.reportdate = dat;
    }

    ctrl.selectedformat = "2";

    ctrl.startDownload = function () {
        ctrl.inProgressDownloadFile = true;
        var reportdate = datetimeService.formatDate(ctrl.reportdate, 'yyyyMMdd');
        var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
        var params = {
            customerId: ctrl.accountInfo.customerId,
            reportdate: reportdate,
            display: ctrl.selectedformat === "3" ? "inlinepng" : "pdf",
            format: ctrl.selectedformat,
            langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
            emailAddress: ctrl.emailAddress,
            download: true
        };
        var url = $scope.$parent.$parent.DownloadCtrl.reportList.ManagementReport.url;
        fileName += "_" + reportdate;
        DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
            ctrl.inProgressDownloadFile = false;
            if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                ctrl.openConfirmationPopUp = true;
            }
        });
    };
}
ManagementController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "detectBrowserService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('ManagementController', ManagementController);
'use strict';

/// <reference path="download-pump-service.html" />

angular.module('mc.download').component('downloadIntegratedflowSummary', {
    controller: IntegratedflowSummaryController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/integratedflowsummary.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function IntegratedflowSummaryController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    ctrl.reportdate = today;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 4;

    ctrl.getDevices = function () {
        ctrl.deviceList = [];
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            angular.forEach(result.data.devices, function (value, key) {
                if (value.sumDeviceAnalog > 0) {
                    ctrl.deviceList.push(value);
                }
            });

            if (ctrl.deviceList.length === 0) {
                ctrl.deviceList.push({ deviceId: "", name: ctrl.translation.text.NO_DEVICES });
            }

            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();
    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.getDevices();
    });

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else if (Math.floor((Date.UTC(ctrl.endDate.getFullYear(), ctrl.endDate.getMonth(), ctrl.endDate.getDate()) - Date.UTC(ctrl.startDate.getFullYear(), ctrl.startDate.getMonth(), ctrl.startDate.getDate())) / (1000 * 60 * 60 * 24)) >= 93) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE_3_MONTHS;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            //var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                startDate: startDate,
                endDate: endDate,
                //resolution: selectedresolution,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                format: ctrl.selectedformat,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.IntegratedflowSummary.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
IntegratedflowSummaryController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('IntegratedflowSummaryController', IntegratedflowSummaryController);
'use strict';

/// <reference path="download-pump-service.html" />

angular.module('mc.download').component('downloadIntegratedflow', {
    controller: IntegratedflowController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/integratedflow.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function IntegratedflowController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 4;

    ctrl.getDevices = function () {
        ctrl.deviceList = [];
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            angular.forEach(result.data.devices, function (value, key) {
                if (value.sumDeviceAnalog > 0) {
                    ctrl.deviceList.push(value);
                }
            });

            if (ctrl.deviceList.length === 0) {
                ctrl.deviceList.push({ deviceId: "", name: ctrl.translation.text.NO_DEVICES });
            }

            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();
    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.getDevices();
    });

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else if (Math.floor((Date.UTC(ctrl.endDate.getFullYear(), ctrl.endDate.getMonth(), ctrl.endDate.getDate()) - Date.UTC(ctrl.startDate.getFullYear(), ctrl.startDate.getMonth(), ctrl.startDate.getDate())) / (1000 * 60 * 60 * 24)) >= 186) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE_6_MONTHS;
        } else if (ctrl.selecteddevice.deviceId === "") {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO_DEVICES;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceId: ctrl.selecteddevice.deviceId,
                startDate: startDate,
                endDate: endDate,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.Integratedflow.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
IntegratedflowController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('IntegratedflowController', IntegratedflowController);
"use strict";

function DownloadPumpServiceController($scope, DownloadFactory, deviceMenuService, authenticationService, translationService, sharedSetupService, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.selectedformat = "0"; //XLSX = 0 OR CSV = 1
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    ctrl.deviceList = [];
    ctrl.selecteddevice = [];
    ctrl.deviceListArray = [];
    ctrl.deviceListSettings = { smartButtonMaxItems: 3 };
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            for (var index = 0; index < result.data.devices.length; ++index) {
                ctrl.deviceList.push({
                    id: result.data.devices[index].deviceId,
                    label: result.data.devices[index].name
                });
                ctrl.deviceListArray.push({
                    id: result.data.devices[index].deviceId
                });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName }];
            } else {
                ctrl.selecteddevice = ctrl.deviceListArray;
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getTextToTranslate();
    });

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();

    ctrl.startDownload = function () {

        if (ctrl.selecteddevice == undefined) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO + " " + ctrl.translation.text.DEVICE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;

            var deviceIds = null;
            if (ctrl.selecteddevice.length !== ctrl.deviceList.length) {
                angular.forEach(ctrl.selecteddevice, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });
            }

            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceIds: deviceIds,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            if (ctrl.selecteddevice.length === 1) {
                var selectDevice = ctrl.deviceList.find(function (x) {
                    return x.id === ctrl.selecteddevice[0].id;
                });
                fileName += "_" + selectDevice.label.replace(/\s/g, "");
            } else {
                fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            }

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.PumpService.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
DownloadPumpServiceController.$inject = ["$scope", "DownloadFactory", "deviceMenuService", "authenticationService", "translationService", "sharedSetupService", "$uibModal"];

angular.module('mc.download').controller('DownloadPumpServiceController', DownloadPumpServiceController);
'use strict';

angular.module('mc.download').component('downloadPumpService', {
    controller: DownloadPumpServiceController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/download-pump-service.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

function DownloadFactory(HOST, REPORTS, $http, $q, toaster) {
    var DownloadService = {};

    DownloadService.downloadFile = function (url, downloadparams, filename) {
        var deferred = $q.defer();
        switch (downloadparams.format) {
            case "0":
                filename += ".xlsx";
                break;
            case "1":
                filename += ".csv";
                break;
            case "2":
                filename += ".pdf";
                break;
            case "3":
                filename += ".png";
                break;
        }

        downloadparams.fileName = filename;

        $http({
            method: 'GET',
            url: REPORTS + url,
            params: downloadparams,
            responseType: 'arraybuffer'
        }).then(function (result, status, headers) {

            if (result.data.byteLength === 0) {
                // for Send Email functionality, NO Data is returned and hence no further action is required
                toaster.pop('success', 'Download Data', 'Email successfully sent!');
                deferred.resolve();
                return;
            }

            //below code is applicable to Download report feature only

            var octetStreamMime = 'application/octet-stream';
            var success = false;

            // Determine the content type from the header or default to "application/octet-stream"
            var contentType = octetStreamMime;

            try {
                var blob = new Blob([result.data], { type: contentType });
                saveAs(blob, filename);
                success = true;
                deferred.resolve();
            } catch (ex) {
                // console.log(ex);
            }
            if (!success) {
                // Fallback to window.open method
                window.open(url, '_blank', '');
            }
        }, function (data, status) {
            // console.log("Request failed with status: " + status);
            deferred.reject(status);
        });
        return deferred.promise;
    };

    DownloadService.getDevices = function (customerId, getChannels) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DeviceList?customerId=' + customerId + '&getChannels=' + getChannels,
            cache: false
        });
    };
    return DownloadService;
}

DownloadFactory.$inject = ['HOST', 'REPORTS', '$http', '$q', 'toaster'];

angular.module('mc.download').factory('DownloadFactory', DownloadFactory);
"use strict";

function DownloadController($, $rootScope, $scope, $sce, authenticationService, HOST, $http, translationService, sharedSetupService, openViewService) {
    var ctrl = this;
    ctrl.initLoad = true;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });
        }
        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        };
        ctrl.adjustHeight();
    };

    $rootScope.$broadcast('downloadViewOpen', ctrl.windowId);
    $scope.$on('downloadViewOpen', function (event, msg) {
        _this.getExistingDialog(ctrl.windowId).ref.dialog("close"); //cannot catch itself ($broadcast => $on)
    });

    var _initializeReportList = function _initializeReportList() {

        if (ctrl.accountInfo.userRole === "PublicUser") {

            ctrl.reportList = {
                RainfallAirport: {
                    value: "Rainfall",
                    label: ctrl.translation.text.RAINFALL + " " + ctrl.translation.text.AIRPORT,
                    type: "Option",

                    divHeight: 6,
                    url: "/api/Download/RainfallAirportDownload",
                    maxDateRange: 90
                },
                RainfallRTU: {
                    value: "RTU Rainfall",
                    label: ctrl.translation.text.RAINFALL + " " + ctrl.translation.text.RTU,
                    type: "Option",
                    divHeight: 6,
                    url: "/api/Download/RainfallRTUDownload",
                    maxDateRange: 90
                }
            };
            return;
        }

        ctrl.reportList = {

            RTUData: {
                value: "RTUDATA",
                label: "- - - - - -  - - - - " + ctrl.translation.text.SINGLE + " " + ctrl.translation.text.RTU + " " + ctrl.translation.text.DATA + " - - - - - -  - - - -",
                type: "OptionGroup"

            },
            Analog: {
                value: "Analog",
                label: ctrl.translation.text.ANALOG,
                type: "Option",
                divHeight: 6,
                url: "/api/Download/AnalogDownload",
                maxDateRange: 90
            },
            Digital: {
                value: "Digital",
                label: ctrl.translation.text.DIGITAL,
                type: "Option",
                divHeight: 4,
                url: "/api/Download/DigitalDownload",
                maxDateRange: 90
            },
            Pulseflow: {
                value: "Pulse",
                label: ctrl.translation.text.PULSE_FLOW,
                type: "Option",
                divHeight: 5,
                url: "/api/Download/PulseflowDownload",
                maxDateRange: 90
            },
            PumpPerformance: {
                value: "Pump",
                label: ctrl.translation.text.PUMP,
                type: "Option",
                divHeight: 5,
                url: "/api/Download/PumpPerformanceDownload",
                maxDateRange: 90
            },
            Signal: {
                value: "Signal",
                label: ctrl.translation.text.SIGNAL,
                type: "Option",
                divHeight: 5,
                url: "/api/Download/SignalDownload",
                maxDateRange: 90
            },
            // Solar: {
            //     value: "Solar",
            //     label: ctrl.translation.text.SOLAR,
            //     type: "Option",
            //     divHeight: 4,
            //     url: "/api/Download/SolarDownload",
            //     maxDateRange: 7
            // },
            Temperature: {
                value: "Temperature",
                label: ctrl.translation.text.TEMPERATURE,
                type: "Option",
                divHeight: 4,
                url: "/api/Download/TemperatureDownload",
                maxDateRange: 90
            },
            Voltage: {
                value: "Voltage",
                label: ctrl.translation.text.VOLTAGE,
                type: "Option",
                divHeight: 4,
                url: "/api/Download/VoltageDownload",
                maxDateRange: 90
            },
            Volumetricflow: {
                value: "Volumetric Flow",
                label: ctrl.translation.text.VOLUMETRIC_FLOW,
                type: "Option",
                divHeight: 5,
                url: "/api/Download/VolumetricflowDownload",
                maxDateRange: 90
            },
            VolumetricflowSummary: {
                value: "Volumetric Flow Summary",
                label: ctrl.translation.text.VOLUMETRIC_FLOW_SUMMARY,
                type: "Option",
                divHeight: 5,
                url: "/api/Download/VolumetricflowSummaryDownload",
                maxDateRange: 90
            },

            Report: {
                value: "REPORTS",
                label: "- - - - - -  - - - - " + ctrl.translation.text.REPORTS + " - - - - - -  - - - -",
                type: "OptionGroup"

            },
            DispatchHistory: {
                value: "Dispatch History",
                label: ctrl.translation.text.ALARM + " " + ctrl.translation.text.DISPATCH + " " + ctrl.translation.text.HISTORY,
                type: "Option",
                divHeight: 5,
                url: "/api/Download/DispatchHistoryDownload",
                maxDateRange: 7
            },
            AlarmHistory: {
                value: "Alarm History",
                label: ctrl.translation.text.ALARM_HISTORY,
                type: "Option",
                divHeight: 5,
                url: "/api/Download/AlarmHistoryDownload",
                maxDateRange: 7
            },
            AlertHistory: {
                value: "Alert History",
                label: ctrl.translation.text.ALERT_HISTORY,
                type: "Option",
                divHeight: 5,
                url: "/api/Download/AlertHistoryDownload",
                maxDateRange: 7

            },
            AnalogInterconnect: {
                value: "AnalogInterconnect",
                label: ctrl.translation.text.ANALOG_INTERCONNECT,
                type: "Option",
                divHeight: 3,
                url: "/api/Download/AnalogInterconnectDownload",
                maxDateRange: 90
            },
            ChlorineReport: {
                value: "Chlorine Report",
                label: ctrl.translation.text.CHLORINE_REPORT,
                type: "Option",
                divHeight: 3,
                url: "/api/Download/ChlorineReportDownload"
            },
            CumulativeFlowReading: {
                value: "CumulativeFlowReading",
                label: ctrl.translation.text.CUMULATIVE_FLOW_READING,
                type: "Option",
                divHeight: 2,
                url: "/api/Download/cumulativeFlowReadingDownload"
            },
            StationSummaryReport: {
                value: "Daily",
                label: ctrl.translation.text.DAILY_STATION_SUMMARY_REPORT,
                type: "Option",
                divHeight: 3,
                url: "/api/Reports/stationsummaryreport"

            },
            DelayedAlarmHistory: {
                value: "Delayed Alarm History",
                label: ctrl.translation.text.DELAYED_ALARM_HISTORY,
                type: "Option",
                divHeight: 4,
                url: "/api/Download/DelayedAlarmHistoryDownload",
                maxDateRange: 7

            },
            DigitalInterconnect: {
                value: "Digital Interconnect",
                label: ctrl.translation.text.DIGITAL_INTERCONNECT,
                type: "Option",
                divHeight: 4,
                url: "/api/Download/DigitalInterconnectDownload",
                maxDateRange: 90
            },
            Integratedflow: {
                value: "Integrated Flow",
                label: ctrl.translation.text.INTEGRATED_FLOW + " vs. " + ctrl.translation.text.RAINFALL,
                type: "Option",
                divHeight: 5,
                url: "/api/Download/IntegratedflowDownload",
                maxDateRange: 90
            },
            IntegratedflowSummary: {
                value: "Integrated Flow Summary",
                label: ctrl.translation.text.INTEGRATED_FLOW_SUMMARY,
                type: "Option",
                divHeight: 3,
                url: "/api/Download/IntegratedflowDownload/ListAllWeekly",
                maxDateRange: 90
            },
            ManagementReport: {
                value: "Management",
                label: ctrl.translation.text.MANAGEMENT_REPORT,
                type: "Option",
                divHeight: 2,
                url: "/api/Reports/ManagementReport"

            },
            MonthlyPumpPerformance: {
                value: "Runtime",
                label: ctrl.translation.text.PUMP + " " + ctrl.translation.text.PUMP_RUNTIME,
                type: "Option",
                divHeight: 3,
                url: "/api/Download/RuntimeDownload"

            },
            PeakFlowAnalog: {
                value: "Peak Flow Analog Data",
                label: "Peak Flow Analog",
                type: "Option",
                divHeight: 6,
                url: "/api/Download/PeakFlowAnalogDownload",
                maxDateRange: 90
            },
            PumpService: {
                value: "Pump Service",
                label: ctrl.translation.text.PUMP_SERVICE,
                type: "Option",
                divHeight: 2,
                url: "/api/Download/pumpServiceDownload"
            },
            RainfallAirport: {
                value: "Rainfall",
                label: ctrl.translation.text.RAINFALL + " " + ctrl.translation.text.AIRPORT,
                type: "Option",

                divHeight: 6,
                url: "/api/Download/RainfallAirportDownload",
                maxDateRange: 90
            },
            RainAnalysisReport: {
                value: "Rain",
                label: "Rain Analysis Report",
                type: "Option",
                divHeight: 3,
                url: "/api/Download/RainAnalysisReportDownload",
                maxDateRange: 30
            },
            RainfallRTU: {
                value: "RTU Rainfall",
                label: ctrl.translation.text.RAINFALL + " " + ctrl.translation.text.RTU,
                type: "Option",
                divHeight: 6,
                url: "/api/Download/RainfallRTUDownload",
                maxDateRange: 90
            },
            RainfallVsRuntime: {
                value: "Rainfall vs Runtime",
                label: ctrl.translation.text.RAINFALL_VS_RUNTIME,
                type: "Option",
                divHeight: 6,
                url: "/api/Download/RainfallVsRuntimeDownload",
                maxDateRange: 90
            },
            Runtimevariance: {
                value: "Runtime Variance",
                label: ctrl.translation.text.RUNTIME_VARIANCE,
                type: "Option",
                divHeight: 2,
                url: "/api/Download/RuntimevarianceDownload"
            },
            SafeWater: {
                value: "Safe Water Report",
                label: ctrl.translation.text.SAFE_WATER_REPORT,
                type: "Option",
                divHeight: 4,
                url: "/api/Download/SafewaterDownload"
            },

            SiteAccess: {
                value: "Site Access",
                label: ctrl.translation.text.SITE_ACCESS,
                type: "Option",
                divHeight: 5,
                url: "/api/Download/SiteAccessDownload",
                maxDateRange: 90
            },

            UntestedInput: {
                value: "Untested Input",
                label: ctrl.translation.text.UNTESTED_WET_WELL_INPUTS,
                type: "Option",
                divHeight: 2,
                url: "/api/Download/UntestedInputDownload"
            },
            UserLoginHistory: {
                value: "User Login History",
                label: ctrl.translation.text.USER_LOGIN + " " + ctrl.translation.text.HISTORY,
                type: "Option",
                divHeight: 3,
                url: "/api/Download/UserLoginHistoryDownload",
                maxDateRange: 90
            }
        };
    };
    _initializeReportList();
    $scope.$on('updatePreferencesLanguage', function (event, args) {
        _initializeReportList();
    });

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.reportType !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.reportType !== null) {
        ctrl.reportType = sharedSetupService.stickyPropertiesInterface.downloadOptions.reportType;
        // Condition only for Digital Gauge--> Advance Download 
        if (ctrl.reportType == "Mc") {
            ctrl.reportType = "Digital";
        }
    } else if (ctrl.accountInfo.userRole === "PublicUser") {
        ctrl.reportType = ctrl.reportList.RainfallAirport.value;
    } else {
        ctrl.reportType = ctrl.reportList.Analog.value;
    }

    ctrl.adjustReportList = function () {
        if (!ctrl.accountInfo.digitalInterconnect) {
            delete ctrl.reportList.DigitalInterconnect;
        }
        if (!ctrl.accountInfo.analogInterconnect) {
            delete ctrl.reportList.AnalogInterconnect;
        }
    };
    ctrl.adjustReportList();

    ctrl.adjustHeight = function () {
        if (!ctrl.classicView) {
            var _title = $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "");
            var _contentHeight = 250;
            var reportListArray = json2array(ctrl.reportList);
            var selectedItem = $.grep(reportListArray, function (e) {
                return e.value == ctrl.reportType;
            });
            var rowHight = 37;
            if (selectedItem.length > 0) {
                if (selectedItem[0].divHeight != "" && selectedItem[0].divHeight != null) _contentHeight = (selectedItem[0].divHeight + 1) * rowHight;
            }

            $scope.popup.parent().css("height", parseInt(_title) + parseInt(_contentHeight) + 125);
            $scope.popup.parent().find('div:eq(2)').css("height", _contentHeight + 125);
        }
    };

    function json2array(json) {
        var result = [];
        var keys = Object.keys(json);
        keys.forEach(function (key) {
            result.push(json[key]);
        });
        return result;
    }
}

DownloadController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'HOST', '$http', 'translationService', 'sharedSetupService', 'openViewService'];
'use strict';

angular.module('mc.download').component('download', {
    controller: DownloadController,
    controllerAs: 'DownloadCtrl',
    templateUrl: 'ui/download/download-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'

    }
});
'use strict';

function DownloadAlertHistoryController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    // From UI perspective ReportType = 0 means "Station Summary Report" and
    // ReportType = 1 means "Management Report"
    // But in the database, ReportType = 1 is associated with both "Station Summary Report" and "Management Report"
    // Hence we are filtering out data in business layer (Mc.Services) from database to corresponding report, either "Station Summary Report" or "Management Report"
    ctrl.reportList = [{ id: 0, label: 'Station Summary Report' }, { id: 1, label: 'Management Report' }, { id: 2, label: 'Watchdog Report' }, { id: 3, label: 'Runtime Variance' }, { id: 4, label: 'Low Battery' }, { id: 5, label: 'Pump Start Alert' }, { id: 202, label: 'System Alert' }];
    ctrl.selectedreport = [];
    ctrl.reportListArray = [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 202 }];
    ctrl.reportListSettings = { smartButtonMaxItems: 3 };

    ctrl.deviceList = [];
    ctrl.selecteddevice = [];
    ctrl.deviceListArray = [];
    ctrl.deviceListSettings = { smartButtonMaxItems: 3 };
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            for (var index = 0; index < result.data.devices.length; ++index) {
                ctrl.deviceList.push({
                    id: result.data.devices[index].deviceId,
                    label: result.data.devices[index].name
                });
                ctrl.deviceListArray.push({
                    id: result.data.devices[index].deviceId
                });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName }];
            } else {
                ctrl.selecteddevice = ctrl.deviceListArray;
            }

            // reports related code, TODO: in future retrieve reports list from the database and update the UI. at present we do not have the way by which we could fetch list of reports associated with "Alert History Download"
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.reportId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.reportId !== null) {
                ctrl.selectedreport = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.reportId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.reportName }];
            } else {
                ctrl.selectedreport = ctrl.reportListArray;
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.reportsTextToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_REPORTS
            //buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getTextToTranslate();
    });

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.INVALID_DATE_RANGE;
        } else if (ctrl.selecteddevice == undefined) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO + " " + ctrl.translation.text.DEVICE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var deviceIds = null;
            if (ctrl.selecteddevice.length !== ctrl.deviceList.length) {
                angular.forEach(ctrl.selecteddevice, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });
            }

            var reportIds = null;
            if (ctrl.selectedreport.length !== ctrl.reportList.length) {
                angular.forEach(ctrl.selectedreport, function (value, key) {
                    reportIds = reportIds + value.id + ",";
                });
            }

            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceIds: deviceIds,
                reportTypeIds: reportIds,
                startDate: startDate,
                endDate: endDate,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            if (ctrl.selecteddevice.length === 1) {
                var selectDevice = ctrl.deviceList.find(function (x) {
                    return x.id === ctrl.selecteddevice[0].id;
                });
                fileName += "_" + selectDevice.label.replace(/\s/g, "");
            } else {
                fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            }

            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.AlertHistory.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
DownloadAlertHistoryController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('DownloadAlertHistoryController', DownloadAlertHistoryController);
'use strict';

angular.module('mc.download').component('downloadAlertHistory', {
    controller: DownloadAlertHistoryController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/download-alert-history.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.download').component('downloadDispatchHistory', {
    controller: DispatchHistoryController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/dispatch-history.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function DispatchHistoryController($, $rootScope, $scope, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, serviceUserService, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.alarmBy = [{ value: 0, label: ctrl.translation.text.SITE }, { value: 1, label: ctrl.translation.text.ALARM + " " + ctrl.translation.text.TYPE }, { value: 2, label: ctrl.translation.text.NOTIFICATION + " " + ctrl.translation.text.RESULT }, { value: 3, label: ctrl.translation.text.DESTINATION }];

    ctrl.alarmTypes = [{ value: 0, label: ctrl.translation.text.ANALOG }, { value: 1, label: ctrl.translation.text.DIGITAL }, { value: 2, label: ctrl.translation.text.TEMPERATURE }, { value: 3, label: ctrl.translation.text.JT_AC_POWER }, { value: 4, label: ctrl.translation.text.JT_COMMS_LINK }, { value: 5, label: ctrl.translation.text.JT_SERVICE_MODE }, { value: 6, label: ctrl.translation.text.RELAY }, { value: 7, label: ctrl.translation.text.PULSE_FLOW }, { value: 8, label: ctrl.translation.text.ANALOG + " " + ctrl.translation.text.FLOW }];

    ctrl.resultTypes = [{ value: 0, label: ctrl.translation.text.ACKNOWLEDGED }, { value: 1, label: ctrl.translation.text.UNACKNOWLEDGED }];

    ctrl.selectedalarmBy = 0;
    ctrl.selectedAlarmType = 0;
    ctrl.selectedresultType = 0;

    ctrl.deviceList = [];
    ctrl.deviceListArray = [];
    ctrl.selecteddevice = [];
    ctrl.deviceListSettings = { smartButtonMaxItems: 3 };

    ctrl.getServiseUsers = function () {
        serviceUserService.getData(ctrl.accountInfo.customerId).then(function (dataFromFactory) {
            ctrl.serviceUsers = dataFromFactory.data.serviceUsers;
            ctrl.selectedserviceUser = ctrl.serviceUsers[0].serviceUserId;
        });
    };
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            for (var index = 0; index < result.data.devices.length; ++index) {
                ctrl.deviceList.push({
                    id: result.data.devices[index].deviceId,
                    label: result.data.devices[index].name
                });

                ctrl.deviceListArray.push({
                    id: result.data.devices[index].deviceId
                });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName }];
            } else {
                ctrl.selecteddevice = ctrl.deviceListArray;
            }
        }, function (error) {});
    };
    ctrl.getDevices();
    ctrl.getServiseUsers();
    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getTextToTranslate();
    });

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.INVALID_DATE_RANGE;
        } else if (ctrl.selecteddevice == undefined) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO + " " + ctrl.translation.text.DEVICE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var deviceIds = null;
            if (ctrl.selecteddevice.length !== ctrl.deviceList.length) {
                angular.forEach(ctrl.selecteddevice, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });
            }
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceIds: deviceIds,
                startDate: startDate,
                endDate: endDate,
                category: ctrl.selectedalarmBy,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                alarmType: ctrl.selectedAlarmType,
                resultType: ctrl.selectedresultType,
                serviceUserId: ctrl.selectedserviceUser,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            if (ctrl.selectedalarmBy === 0 && ctrl.selecteddevice.length === 1) {
                var selectDevice = ctrl.deviceList.find(function (x) {
                    return x.id === ctrl.selecteddevice[0].id;
                });
                fileName += "_" + selectDevice.label.replace(/\s/g, "");
            } else {
                fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            }

            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.DispatchHistory.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
DispatchHistoryController.$inject = ["$", "$rootScope", "$scope", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "serviceUserService", "$uibModal"];

angular.module('mc.download').controller('DispatchHistoryController', DispatchHistoryController);
'use strict';

angular.module('mc.download').component('downloadDigitalInterconnect', {
    controller: DigitalInterconnectController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/digital-interconnect.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function DigitalInterconnectController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 4;
    ctrl.analogtype = 0;
    ctrl.datapointResolution = 0;

    ctrl.deviceList = [];
    ctrl.analogtypes = [{
        label: ctrl.translation.text.DATA_POINTS,
        value: 0
    }, {
        label: ctrl.translation.text.MIN_MAX_AVG,
        value: 1
    }, {
        label: ctrl.translation.text.NOON_READINGS,
        value: 2
    }];

    ctrl.datapointResolutions = [{
        label: ctrl.translation.text.ALL_POINTS,
        value: 0
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_5,
        value: 1
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_15,
        value: 2
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_30,
        value: 3
    }];
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data.devices;
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();
    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                startDate: startDate,
                endDate: endDate,
                type: ctrl.analogtype,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            //fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.DigitalInterconnect.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
DigitalInterconnectController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element"];

angular.module('mc.download').controller('DigitalInterconnectController', DigitalInterconnectController);
'use strict';

angular.module('mc.download').component('downloadDigital', {
    controller: DigitalController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/digital.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function DigitalController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 4;
    ctrl.analogtype = 0;
    ctrl.datapointResolution = 0;

    ctrl.deviceList = [];
    ctrl.analogtypes = [{
        label: ctrl.translation.text.DATA_POINTS,
        value: 0
    }, {
        label: ctrl.translation.text.MIN_MAX_AVG,
        value: 1
    }, {
        label: ctrl.translation.text.NOON_READINGS,
        value: 2
    }];

    ctrl.datapointResolutions = [{
        label: ctrl.translation.text.ALL_POINTS,
        value: 0
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_5,
        value: 1
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_15,
        value: 2
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_30,
        value: 3
    }];
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data.devices;
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (error) {});
    };
    ctrl.getDevices();
    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceId: ctrl.selecteddevice.deviceId,
                deviceName: ctrl.selecteddevice.name,
                startDate: startDate,
                endDate: endDate,
                genII: ctrl.selecteddevice.protocolVersion === 2,
                type: ctrl.analogtype,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.Digital.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
DigitalController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('DigitalController', DigitalController);
'use strict';

angular.module('mc.download').component('downloadDelayedAlarmHistory', {
    controller: DelayedAlarmHistoryController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/delayed-alarm-history.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function DelayedAlarmHistoryController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.deviceList = [];
    ctrl.selecteddevice = [];
    ctrl.deviceListArray = [];
    ctrl.deviceListSettings = { smartButtonMaxItems: 3 };
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            for (var index = 0; index < result.data.devices.length; ++index) {
                ctrl.deviceList.push({
                    id: result.data.devices[index].deviceId,
                    label: result.data.devices[index].name
                });
                ctrl.deviceListArray.push({
                    id: result.data.devices[index].deviceId
                });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName }];
            } else {
                ctrl.selecteddevice = ctrl.deviceListArray;
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getTextToTranslate();
    });

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.INVALID_DATE_RANGE;
        } else if (ctrl.selecteddevice == undefined) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO + " " + ctrl.translation.text.DEVICE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var deviceIds = null;
            if (ctrl.selecteddevice.length !== ctrl.deviceList.length) {
                angular.forEach(ctrl.selecteddevice, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });
            }

            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceIds: deviceIds,
                startDate: startDate,
                endDate: endDate,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            if (ctrl.selecteddevice.length === 1) {
                var selectDevice = ctrl.deviceList.find(function (x) {
                    return x.id === ctrl.selecteddevice[0].id;
                });
                fileName += "_" + selectDevice.label.replace(/\s/g, "");
            } else {
                fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            }

            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.DelayedAlarmHistory.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
DelayedAlarmHistoryController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('DelayedAlarmHistoryController', DelayedAlarmHistoryController);
'use strict';

angular.module('mc.download').component('downloadCumulativeFlowReading', {
    controller: DownloadCumulativeFlowReadingController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/cumulative-flow-reading-download.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function DownloadCumulativeFlowReadingController($, $rootScope, $scope, $sce, DownloadFactory, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, deviceMenuService, $uibModal) {
    var ctrl = this;

    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.label = ctrl.translation.text.DEVICE;
    ctrl.deviceList = [];
    ctrl.selectedformat = "0";

    deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
        angular.forEach(result.data.devices, function (value, key) {
            if (value.hasCumulativeFlow === null || value.hasCumulativeFlow) ctrl.deviceList.push(value);
        });
        if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
            ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
        } else {
            ctrl.selecteddevice = ctrl.deviceList[0];
        }
    }, function (result) {});

    ctrl.startDownload = function () {
        //var reportdate = datetimeService.formatDate(ctrl.reportdate, 'yyyyMMdd');
        var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
        fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
        fileName += "_" + new Date().getTime();
        //fileName += "_" + reportdate;

        var url = $scope.$parent.$parent.DownloadCtrl.reportList.CumulativeFlowReading.url;
        var params = {
            customerId: ctrl.accountInfo.customerId,
            deviceId: ctrl.selecteddevice.deviceId,
            timeZone: ctrl.accountInfo.timeZone,
            //reportdate: reportdate,
            langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
            format: ctrl.selectedformat,
            emailAddress: ctrl.emailAddress
        };

        ctrl.inProgressDownloadFile = true;
        DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
            ctrl.inProgressDownloadFile = false;
            if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                ctrl.openConfirmationPopUp = true;
            }
        });
    };
}
DownloadCumulativeFlowReadingController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "deviceMenuService", "$uibModal"];

angular.module('mc.download').controller('DownloadCumulativeFlowReadingController', DownloadCumulativeFlowReadingController);
'use strict';

angular.module('mc.download').component('downloadChlorineReport', {
    controller: DownloadChlorineReportController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/chlorine-report.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function DownloadChlorineReportController($, $rootScope, $scope, $sce, DownloadFactory, detectBrowserService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    var selectedDate = yesterday;
    ctrl.reportdate = selectedDate;

    ctrl.selectedformat = "0";
    ctrl.reportType = "1";

    ctrl.startDownload = function () {
        ctrl.inProgressDownloadFile = true;
        var reportdate = datetimeService.formatDate(ctrl.reportdate, 'yyyyMMdd');
        var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
        var params = {
            customerId: ctrl.accountInfo.customerId,
            reportdate: reportdate,
            reporttype: ctrl.reportType,
            format: ctrl.selectedformat,
            langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
            emailAddress: ctrl.emailAddress

        };
        var url = $scope.$parent.$parent.DownloadCtrl.reportList.ChlorineReport.url;
        fileName += "_" + reportdate;
        DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
            ctrl.inProgressDownloadFile = false;
            if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                ctrl.openConfirmationPopUp = true;
            }
        });
    };
}
DownloadChlorineReportController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "detectBrowserService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('DownloadChlorineReportController', DownloadChlorineReportController);
'use strict';

angular.module('mc.download').component('downloadAnalogInterconnect', {
    controller: AnalogInterconnectController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/analog-interconnect.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function AnalogInterconnectController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, rtuRainfallSiteService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 4;
    ctrl.analogtype = 0;
    ctrl.datapointResolution = 0;

    ctrl.deviceList = [];
    ctrl.analogtypes = [{
        label: ctrl.translation.text.DATA_POINTS,
        value: 0
    }, {
        label: ctrl.translation.text.MIN_MAX_AVG,
        value: 1
    }, {
        label: ctrl.translation.text.NOON_READINGS,
        value: 2
    }];

    ctrl.datapointResolutions = [{
        label: ctrl.translation.text.ALL_POINTS,
        value: 0
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_5,
        value: 1
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_15,
        value: 2
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_30,
        value: 3
    }];
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            angular.forEach(result.data.devices, function (value, key) {
                if (value.hasAnalog) ctrl.deviceList.push(value);
            });
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = { deviceId: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, name: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName };
            } else {
                ctrl.selecteddevice = ctrl.deviceList[0];
            }
        }, function (result) {});
    };
    ctrl.getDevices();
    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.msg = "";
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceId: ctrl.selecteddevice.deviceId,
                startDate: startDate,
                endDate: endDate,
                type: ctrl.analogtype,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");

            //fileName += "_" + ctrl.selecteddevice.name.replace(/\s/g, "");
            switch (ctrl.analogtype) {
                case 0:
                    fileName += "_" + ctrl.translation.text.DATA_POINTS.replace(/\s/g, "");
                    break;
                case 1:
                    fileName += "_mma_";
                    break;
                case 2:
                    fileName += "_" + ctrl.translation.text.NOON_READINGS.replace(/\s/g, "");
                    break;
            }
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.AnalogInterconnect.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
AnalogInterconnectController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "rtuRainfallSiteService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('AnalogInterconnectController', AnalogInterconnectController);
'use strict';

angular.module('mc.download').component('downloadAnalog', {
    controller: AnalogController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/analog.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function AnalogController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, rtuRainfallSiteService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    ctrl.label = ctrl.translation.text.DEVICE;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.startDate = weekago;
    ctrl.endDate = today;
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }
    ctrl.selectedformat = "0";
    ctrl.selectedresolution = 4;
    ctrl.analogtype = 0;
    ctrl.datapointResolution = 0;
    ctrl.emailAddress = "";
    ctrl.isEmailValid = false;

    ctrl.deviceList = [];
    ctrl.deviceListArray = [];
    ctrl.selecteddevices = [];
    ctrl.deviceListSettings = { smartButtonMaxItems: 3 };
    ctrl.analogtypes = [{
        label: ctrl.translation.text.DATA_POINTS,
        value: 0
    }, {
        label: ctrl.translation.text.MIN_MAX_AVG,
        value: 1
    }, {
        label: ctrl.translation.text.NOON_READINGS,
        value: 2
    }];

    ctrl.datapointResolutions = [{
        label: ctrl.translation.text.ALL_POINTS,
        value: 0
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_5,
        value: 1
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_15,
        value: 2
    }, {
        label: ctrl.translation.text.MIN_SAMPLES_30,
        value: 3
    }];
    ctrl.getDevices = function () {
        ctrl.deviceList = [];
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            for (var index = 0; index < result.data.devices.length; ++index) {
                if (result.data.devices[index].hasAnalog) {
                    ctrl.deviceList.push({
                        id: result.data.devices[index].deviceId,
                        label: result.data.devices[index].name
                    });

                    ctrl.deviceListArray.push({
                        id: result.data.devices[index].deviceId,
                        label: result.data.devices[index].name
                    });
                }
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevices = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName }];
            } else {
                ctrl.selecteddevices = ctrl.deviceListArray;
            }

            //Below changes are for Single Device Selection
            //check whether ctrl.selecteddevice.name has value
            // if (ctrl.selecteddevice.name == null) {
            //     for (let i = 0; i < ctrl.deviceList.length; i++) {
            //         if (ctrl.deviceList[i].deviceId === ctrl.selecteddevice.deviceId) {
            //             ctrl.selecteddevice.name = ctrl.deviceList[i].name;
            //             break;
            //         }
            //     }
            // }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();

    ctrl.changeDevice = function () {
        if (ctrl.selecteddevice.protocolVersion === 2) {
            ctrl.analogtype = 0;
            ctrl.datapointResolution = 0;
        }
    };

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = translationService.translation.text.INVALID_DATE_RANGE;
        } else {
            ctrl.showMsg = false;
            ctrl.msg = "";
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var selectedresolution = ctrl.analogtype === 0 ? ctrl.datapointResolution : ctrl.selectedresolution;
            var deviceIds = null;
            if (ctrl.selecteddevices.length !== ctrl.deviceList.length) {
                angular.forEach(ctrl.selecteddevices, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });
            } else {
                deviceIds = "";
                angular.forEach(ctrl.deviceList, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });
            }
            deviceIds = deviceIds.substring(0, deviceIds.lastIndexOf(','));
            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceIds: deviceIds,
                startDate: startDate,
                endDate: endDate,
                // genII: ctrl.selecteddevice.protocolVersion === 2,
                type: ctrl.analogtype,
                resolution: selectedresolution,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");

            if (ctrl.selecteddevices.length === 1) {
                var selectDevice = ctrl.deviceList.find(function (x) {
                    return x.id === ctrl.selecteddevices[0].id;
                });
                fileName += "_" + selectDevice.label.replace(/\s/g, "");
            } else {
                fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            }
            switch (ctrl.analogtype) {
                case 0:
                    fileName += "_" + ctrl.translation.text.DATA_POINTS.replace(/\s/g, "");
                    break;
                case 1:
                    fileName += "_mma_";
                    break;
                case 2:
                    fileName += "_" + ctrl.translation.text.NOON_READINGS.replace(/\s/g, "");
                    break;
            }
            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.Analog.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
AnalogController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "rtuRainfallSiteService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('AnalogController', AnalogController);
'use strict';

angular.module('mc.download').component('downloadAlarmHistory', {
    controller: DownloadAlarmHistoryController,
    controllerAs: 'subCtrl',
    templateUrl: 'ui/download/alarm-history.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});

function DownloadAlarmHistoryController($, $rootScope, $scope, $sce, DownloadFactory, deviceMenuService, authenticationService, HOST, $http, translationService, sharedSetupService, datetimeService, deviceService, $timeout, $filter, $element, $uibModal) {
    var ctrl = this;
    ctrl.inProgressDownloadFile = false;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    var today = new Date();
    var weekago = new Date(today);
    weekago.setDate(today.getDate() - 7);
    ctrl.selectedformat = "0";
    ctrl.startDate = weekago;
    ctrl.endDate = today;

    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate !== null) {
        ctrl.startDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.startDate;
        weekago.setDate(ctrl.startDate - 7);
        ctrl.endDate = weekago;
    }
    if (sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate !== null) {
        ctrl.endDate = sharedSetupService.stickyPropertiesInterface.downloadOptions.endDate;
    }

    ctrl.alarmBy = [{ value: 0, label: ctrl.translation.text.SITE }, { value: 1, label: ctrl.translation.text.ALARM + " " + ctrl.translation.text.TYPE }, { value: 2, label: ctrl.translation.text.NOTIFICATION + " " + ctrl.translation.text.RESULT }];

    ctrl.alarmTypes = [{ value: 0, label: ctrl.translation.text.ANALOG }, { value: 1, label: ctrl.translation.text.DIGITAL }, { value: 2, label: ctrl.translation.text.TEMPERATURE }, { value: 3, label: ctrl.translation.text.JT_AC_POWER }, { value: 4, label: ctrl.translation.text.JT_COMMS_LINK }, { value: 5, label: ctrl.translation.text.JT_SERVICE_MODE }, { value: 6, label: ctrl.translation.text.RELAY }, { value: 7, label: ctrl.translation.text.PULSE_FLOW }, { value: 8, label: ctrl.translation.text.ANALOG + " " + ctrl.translation.text.FLOW }];

    ctrl.resultTypes = [{ value: 0, label: ctrl.translation.text.ACKNOWLEDGED }, { value: 1, label: ctrl.translation.text.UNACKNOWLEDGED }, { value: 2, label: ctrl.translation.text.SERVICE_MODE }, { value: 3, label: ctrl.translation.text.DISABLED + "/" + ctrl.translation.text.ABORTED }, { value: 4, label: ctrl.translation.text.NO_DESTINATIONS }];

    ctrl.selectedalarmBy = 0;
    ctrl.selectedAlarmType = 0;
    ctrl.selectedresultType = 0;
    ctrl.deviceList = [];
    ctrl.selecteddevice = [];
    ctrl.deviceListArray = [];
    ctrl.deviceListSettings = { smartButtonMaxItems: 3 };
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            for (var index = 0; index < result.data.devices.length; ++index) {
                ctrl.deviceList.push({
                    id: result.data.devices[index].deviceId,
                    label: result.data.devices[index].name
                });
                ctrl.deviceListArray.push({
                    id: result.data.devices[index].deviceId
                });
            }
            if (sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== undefined && sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId !== null) {
                ctrl.selecteddevice = [{ id: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceId, label: sharedSetupService.stickyPropertiesInterface.downloadOptions.deviceName }];
            } else {
                ctrl.selecteddevice = ctrl.deviceListArray;
            }
        }, function (error) {});
    };
    ctrl.getDevices();

    ctrl.getTextToTranslate = function () {
        ctrl.textToTranslate = {
            checkAll: ctrl.translation.text.CHECK_ALL,
            uncheckAll: ctrl.translation.text.UNCHECK_ALL,
            selectionCount: ctrl.translation.text.CHECKED,
            selectionOf: '/',
            searchPlaceholder: ctrl.translation.text.SEARCH + '...',
            buttonDefaultText: ctrl.translation.text.SELECT,
            dynamicButtonTextSuffix: ctrl.translation.text.CHECKED,
            buttonDefaultTextAllDevices: ctrl.translation.text.ALL_DEVICES,
            buttonDefaultTextAllInputs: ctrl.translation.text.ALL_INPUTS
        };

        ctrl.languageChange = !ctrl.languageChange;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getTextToTranslate();
    });

    ctrl.languageChange = false;
    ctrl.getTextToTranslate();

    ctrl.startDownload = function () {
        if (ctrl.endDate < ctrl.startDate || !ctrl.startDate) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.INVALID_DATE_RANGE;
        } else if (ctrl.selecteddevice == undefined) {
            ctrl.showMsg = true;
            ctrl.msg = ctrl.translation.text.NO + " " + ctrl.translation.text.DEVICE;
        } else {
            ctrl.showMsg = false;
            ctrl.inProgressDownloadFile = true;
            var startDate = datetimeService.formatDate(ctrl.startDate, 'yyyyMMdd');
            var endDate = datetimeService.formatDate(ctrl.endDate, 'yyyyMMdd');
            var deviceIds = null;
            if (ctrl.selecteddevice.length !== ctrl.deviceList.length) {
                angular.forEach(ctrl.selecteddevice, function (value, key) {
                    deviceIds = deviceIds + value.id + ",";
                });
            }

            var params = {
                customerId: ctrl.accountInfo.customerId,
                deviceIds: deviceIds,
                startDate: startDate,
                endDate: endDate,
                category: ctrl.selectedalarmBy,
                format: ctrl.selectedformat,
                langId: ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"),
                alarmType: ctrl.selectedAlarmType,
                resultType: ctrl.selectedresultType,
                emailAddress: ctrl.emailAddress
            };
            var fileName = $scope.$parent.$parent.DownloadCtrl.reportType.replace(/\s/g, "");
            if (ctrl.selectedalarmBy === 0 && ctrl.selecteddevice.length === 1) {
                var selectDevice = ctrl.deviceList.find(function (x) {
                    return x.id === ctrl.selecteddevice[0].id;
                });
                fileName += "_" + selectDevice.label.replace(/\s/g, "");
            } else {
                fileName += "_" + ctrl.accountInfo.customerName.replace(/\s/g, "");
            }

            fileName += "_" + startDate;

            var url = $scope.$parent.$parent.DownloadCtrl.reportList.AlarmHistory.url;

            DownloadFactory.downloadFile(url, params, fileName).finally(function (data) {
                ctrl.inProgressDownloadFile = false;
                if (ctrl.emailAddress && typeof ctrl.emailAddress != "undefined") {
                    ctrl.openConfirmationPopUp = true;
                }
            });
        }
    };
}
DownloadAlarmHistoryController.$inject = ["$", "$rootScope", "$scope", "$sce", "DownloadFactory", "deviceMenuService", "authenticationService", "HOST", "$http", "translationService", "sharedSetupService", "datetimeService", "deviceService", "$timeout", "$filter", "$element", "$uibModal"];

angular.module('mc.download').controller('DownloadAlarmHistoryController', DownloadAlarmHistoryController);
"use strict";

angular.module("mc.important-information", []);
"use strict";

function ImportantInformationController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, $location, desktopViewService, AdminPortalService, $window, modalService, mcApplicationVersionAlertService, timeLapseService, toaster, websocketService, importantInformationModalService, SiteSecurityPortalFactory) {
    var ctrl = this;
    $scope.alerts = [];
    var _uiUpToDate = $rootScope.uiUpToDate;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        $rootScope.CustomerNameStart = ""; // need for removing customer menu

        ctrl.translation = translationService.translation;
        ctrl.accountInfo = authenticationService.getAccountInfo();

        ctrl.portalInfoName = "Communication Portal";

        websocketService.close();

        var _initViews = function _initViews() {
            importantInformationModalService.importantInformation(ctrl, true).then(function () {
                //                   
            }, function (error) {
                //                      
            });
        };

        if (angular.isDefined($scope.translation)) {
            _initViews();
            _tlDataReceivedUIVERSION();
        } else {
            translationService.loadLanguage(true).then(function (result) {
                $scope.translation = translationService.translation;
                _initViews();
                _tlDataReceivedUIVERSION();
            }, function (error) {
                console.log("error");
            });
        }
    };

    $scope.$on("$destroy", function () {
        desktopViewService.closeAllViews();
    });

    var _tlDataReceivedUIVERSION = function _tlDataReceivedUIVERSION() {

        var _displayMessage = false;

        mcApplicationVersionAlertService.getData('customerId=' + ctrl.accountInfo.customerId + '&applicationId=1' + '&timeZone=' + ctrl.accountInfo.timeZone).then(function (datafromfactory) {

            var _type, _title, _message, _duration;

            if (datafromfactory.data.buildNumber > $('meta[name=build]').attr("content")) {
                _displayMessage = true;
                _uiUpToDate = false;
                _type = "error";
                _title = $scope.translation.text.NEW_123SCADA_AVAILABLE;
                _message = "<br>" + $scope.translation.text.SAVE_YOUR_WORK + "<a href='#' onclick='location.reload(true); return false;' style='text-decoration: underline;'>" + $scope.translation.text.CLICK_HERE + "</a>" + $scope.translation.text.TO_UPDATE;
                _duration = 15000;
            } else if (!$rootScope.uiUpToDate) {
                _displayMessage = true;
                _uiUpToDate = true;
                _type = "success";
                _title = $scope.translation.text.UP_TO_DATE_123SCADA;
                _message = "";
                _duration = 5000;
            }

            if (_displayMessage) toaster.pop(_type, _title, _message, _duration, 'trustedHtml');
            $rootScope.uiUpToDate = _uiUpToDate;
            _displayMessage = false;
        }, function (error) {
            console.log("error");
        });
    };
}

ImportantInformationController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$location', 'desktopViewService', 'AdminPortalService', '$window', 'modalService', 'mcApplicationVersionAlertService', 'timeLapseService', 'toaster', 'websocketService', 'importantInformationModalService', 'SiteSecurityPortalFactory'];
'use strict';

angular.module('mc.important-information').component('importantInformation', {
    controller: ImportantInformationController,
    templateUrl: 'ui/importantinformation/important-information-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.help-documents', []);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function HelpDocumentsController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, LoginsFactory, $uibModal, $element, $timeout, datetimeService, savePdfService, registerWebinarService, DocumentationFactory, $filter, $window, unsavedChangesService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.isMcAdmin = false;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.editModeIndex = null;
        ctrl.editMode = null;
        ctrl.addMode = null;
        ctrl.myModalTemplate = null;
        ctrl.reverse = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl._loading = true;
        ctrl.documentation = new DocumentationFactory(ctrl.accountInfo.customerId, ctrl.viewName, ctrl.fileName);
        ctrl.getDocuments();
        ctrl.showTooltip = false;
        ctrl.downloadViewTypeOptions = [0, 1, 2];

        // binding 'dialogbeforeclose' event to Check for unsaved Changes function
        if (!$rootScope.mobile && !$rootScope.classicView) {
            _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
            $(_this2._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    ctrl.dynamicPopover = {
        templateUrl: 'ManageUserAccountPopoverTemplate.html'
    };

    ctrl.getAccessLevelName = function (item) {
        var data = ctrl.roles.filter(function (login) {
            if (login.id == item.accessLevel) {
                //assign lastAccessLevel if unassigned
                item.lastAccessLevel = item.lastAccessLevel ? item.lastAccessLevel : login.id;
                return login;
            }
        });
        //Return Translation for role
        return data.length ? _this2.translation.text['USER_ROLE_' + data[0].id] : _this2.translation.text['USER_ROLE_100'];
    };

    ctrl.updateAccessLevel = function (item) {
        _this2._prevName = item.lastAccessLevel;
        //Alert user if accessLevel is being lowered from admin status
        if (item.lastAccessLevel >= 255 & item.accessLevel < 255) {
            ctrl.openCommonModal(item, false);
        }
        //else run patch
        else {
                ctrl.patchData(item, 'accessLevel');
            }
    };

    ctrl.editingTo = function (name) {
        _this2._prevName = name;
    };

    ctrl.getDocuments = function () {
        ctrl.documentation.listUnDeletedData().then(function () {
            ctrl.docs = ctrl.documentation.data;
            ctrl.setFileNameValid();
            ctrl.order("viewName", false);
            ctrl._loading = false;
        }, function (error) {
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.setFileNameValid = function () {
        ctrl.docs.map(function (doc) {
            ctrl.validateUrl(doc);
        });
    };

    ctrl.patchData = function (item, propertyName) {
        //Conditions to not patch Data
        if (item.id === -1 || item[propertyName] == _this2._prevName || !item.fileNameValid || item.viewName.length < 3 || item.menuOption.length < 3) return false;
        //All conditions passed, patch data
        ctrl.updateValue(item, propertyName);
    };

    ctrl.updateValue = function (item, propertyName) {
        var tmpServiceUserPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        ctrl.documentation.patchData(item.id, tmpServiceUserPatch).then(function (resp) {
            item[propertyName] = resp.data[propertyName];
            ctrl.updateLocalStorage(item, propertyName);
        });
    };

    ctrl.updateLocalStorage = function (item, propertyName) {

        var accountInfo = JSON.parse($window.sessionStorage.accountInfo);
        //update local storage for activeDocumentationList on patch
        if (propertyName) {
            accountInfo.activeDocumentationList.map(function (doc) {
                if (doc.id == item.id) {
                    doc[propertyName] = item[propertyName];
                }
            });
        }
        //If new doc add item to array
        else {
                accountInfo.activeDocumentationList.push(item);
            }
        $window.sessionStorage.accountInfo = JSON.stringify(accountInfo);
        $rootScope.$broadcast('updateActiveDocumentationList');
    };

    ctrl.save = function (item) {
        ctrl.documentation.postData(item.id, item).then(function (resp) {
            item.id = resp.data;
            ctrl.editModeIndex = null;
            ctrl.addMode = null;
            ctrl.editMode = null;
            ctrl.updateLocalStorage(item);
        });
    };

    ctrl.addNew = function () {
        if (ctrl.addMode === -1) return false;

        var newDoc = {
            id: -1,
            viewName: "",
            menuOption: "",
            fileName: "",
            fileNameValid: false,
            active: true,
            isDeleted: false
        };
        ctrl.docs.unshift(newDoc);
        ctrl.editModeIndex = -1;
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.cancel = function (item) {
        ctrl.editModeIndex = null;
        if (item.id === -1) ctrl.docs.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.setEditMode = function (index) {
        ctrl.addMode = null;
        ctrl.editMode = null;
        ctrl.editModeIndex = ctrl.editModeIndex === index ? null : index;
        if (ctrl.docs[0].userId === -1) ctrl.docs.splice(0, 1);
    };

    ctrl.validateUrl = function (item) {
        item.fileNameValid = item.fileName.toLowerCase().endsWith("html");
    };

    ctrl.openHelpPanel = function (viewName) {
        if (angular.isDefined(viewName)) openViewService.openHelpPanel(viewName);
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    var orderBy = $filter('orderBy');
    ctrl.order = function (predicate) {
        ctrl.reverse = !ctrl.reverse;
        switch (predicate) {
            case "viewName":
                ctrl.docs = orderBy(ctrl.docs, predicate, ctrl.reverse);
                break;
            case "menuOption":
                ctrl.docs = orderBy(ctrl.docs, predicate, ctrl.reverse);
                break;
            case "fileName":
                ctrl.docs = orderBy(ctrl.docs, predicate, ctrl.reverse);
                break;
        }
        ctrl.predicate = predicate;
    };

    ctrl.openCommonModal = function (item) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            //this.tmpConfirmMessageA =  this.translation.text.READONLY_ACCOUNT_MESSAGE_A + item.fullName  + ` ${this.translation.text.TO} ` + this.translation.text[`USER_ROLE_${item.accessLevel}`];
            this.tmpConfirmMessageA = this.translation.text.DELETE + " " + this.translation.text.DOCUMENTATION;
            //this.tmpConfirmMessageB =   this.translation.text.DELETE_ACCOUNT_MESSAGE_C ;
            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            item.isDeleted = true;
            ctrl.patchData(item, 'isDeleted');
        }, function () {
            // cancel button
        });
    };
}

HelpDocumentsController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'LoginsFactory', '$uibModal', '$element', '$timeout', 'datetimeService', 'savePdfService', 'registerWebinarService', 'DocumentationFactory', '$filter', '$window', 'unsavedChangesService'];
'use strict';

angular.module('mc.help-documents').component('helpDocuments', {
    controller: HelpDocumentsController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/helpdocuments/help-documents-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.global_dependencies', []);
'use strict';

function UnderscoreFactory($window) {
  if (!$window._) {
    throw new Error('Underscore was not found!');
  }
  return $window._;
}

UnderscoreFactory.$inject = ['$window'];

angular.module('mc.global_dependencies').factory('_', UnderscoreFactory);
'use strict';

function JqueryFactory($window) {
  if (!$window.$) {
    throw new Error('jQuery was not found!');
  }
  return $window.$;
}

JqueryFactory.$inject = ['$window'];

angular.module('mc.global_dependencies').factory('$', JqueryFactory);
angular.module("mc.wizardSplash", []);
"use strict";

function WizardSplashFactory(HOST, $http) {

    function GetWizardSteps(customerId, loginId, wizardId) {
        return $http({
            method: 'GET',
            url: HOST + "/api/Wizard",
            params: { customerId: customerId, loginId: loginId, wizardId: wizardId }
        });
    }

    //function GetLatestWizardStepsHistory(customerId, loginId) {
    //    return $http({
    //        method: 'GET',
    //        url: `${HOST}/api/Wizard`,
    //        params: { customerId, loginId },
    //    });
    //}

    function SaveWizardStatus(customerId, loginId, wizardId, wizardStepStatusId) {
        return $http.post(HOST + "/api/Wizard?customerId=" + customerId + "&loginId=" + loginId + "&wizardId=" + wizardId + "&wizardStepStatusId=" + wizardStepStatusId);
    }

    function SaveWizardStepStatus(customerId, loginId, wizardId, stepViewName, wizardStepStatusId) {
        //return $http.post(HOST + "/api/Wizard?customerId=" + customerId + "&loginId=" + loginId + "&wizardId=" + wizardId + "&stepViewName=" + stepViewName + "&wizardStepStatusId=" + wizardStepStatusId);
        return $http({
            method: 'POST',
            url: HOST + "/api/Wizard",
            params: {
                customerId: customerId, loginId: loginId, wizardId: wizardId, stepViewName: stepViewName, wizardStepStatusId: wizardStepStatusId
            }
        });
    }

    return {
        GetWizardSteps: GetWizardSteps,
        //GetLatestWizardStepsHistory,
        SaveWizardStatus: SaveWizardStatus,
        SaveWizardStepStatus: SaveWizardStepStatus
    };
}

WizardSplashFactory.$inject = ['HOST', '$http'];

angular.module('mc.wizardSplash').factory('wizardSplashService', WizardSplashFactory);
"use strict";

function WizardSplashController($scope, $q, $timeout, $rootScope, authenticationService, translationService, sharedSetupService, openViewService, wizardSplashService) {
    var ctrl = this;

    // Wizard Step Status :
    // 1. skipped
    // 2. complete
    // 3. unknown

    // wizardStep is nothing but wizardlookup row from database.

    ctrl.wizardHistory = null;
    ctrl.wizardSteps = [];
    ctrl.latestWizardStepsHistory = [];
    ctrl.wizardStatuses = [];
    ctrl.stepArray = []; // create steps array for binding processed/calculated values with UI

    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.translation = translationService.translation;
    $scope.windowId = ctrl.windowId; //need for
    //$scope.stickyProperties = ctrl.stickyProperties || sharedSetupService.stickyPropertiesInterface;

    this.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        $rootScope.wizardId = 1; //TODO:VEN at present hardcoding, but need to figure out how it could be passed to UI

        //$timeout(function () {
        ctrl.getWizardSteps($rootScope.wizardId);
        //}, 1000);


        $q.all([wizardPromise.promise]).then(function () {

            //if (!!ctrl.wizardHistory && ctrl.wizardHistory.wizardStatusId === 1) { // if wizard is supposed to be skipped (1), no action is required
            //    //close the wizard if it is opened
            //    var _popup = _this.getExistingDialog($scope.windowId).ref;
            //    if (!!_popup) { _popup.dialog("close") };
            //}


            //first close all the opened views
            ctrl.closeAllViews();

            //Manage Dialog Geometry
            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
                ctrl.popup.dialog({
                    resize: function resize(event, ui) {
                        ctrl.adjustSize();
                    }
                });

                ctrl.popup.dialogExtend({
                    maximize: function maximize(event, ui) {
                        openViewService.adjustContentSizeStart(ctrl.popup);
                        ctrl.adjustSize();
                    },
                    restore: function restore(event, ui) {
                        openViewService.adjustContentSizeStart(ctrl.popup);
                        ctrl.adjustSize();
                    }
                });
            }

            //manually making call to adjustSize in order to load scrollbar
            $timeout(function () {
                ctrl.adjustSize();
            }, 500);
        });
    };

    // this function closes all the views except WizardSplash view.
    ctrl.closeAllViews = function () {
        for (var i = 0; i < $rootScope.arrPopup.length; i++) {
            if ($rootScope.arrPopup[i].desktopIndex != "Wizard Splash") {
                var _popup = _this.getExistingDialog($rootScope.arrPopup[i].desktopIndex).ref;
                _popup.dialog("close");
            }
        }
        $rootScope.arrPopup = [];
        $rootScope.desktopName = null;
        return;
    };

    var wizardPromise = $q.defer();
    ctrl.getWizardSteps = function (wizardId) {
        //clear existing arrays
        ctrl.wizardSteps = [];
        ctrl.stepArray = [];
        ctrl.latestWizardStepsHistory = [];

        wizardSplashService.GetWizardSteps(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, wizardId).then(function (resp) {
            ctrl.wizardHistory = resp.data.wizardHistory;
            ctrl.wizardSteps = resp.data.wizardSteps;
            ctrl.latestWizardStepsHistory = resp.data.listWizardStepHistory;
            ctrl.wizardStatuses = resp.data.statuses;
            wizardPromise.resolve();

            //set sticky property  "launchedByWizard = false" to indicate initial state
            $rootScope.launchedByWizard = false;

            // wizard steps history, if any
            //wizardSplashService.GetLatestWizardStepsHistory(ctrl.accountInfo.customerId, ctrl.accountInfo.userId).then((resp) => {
            //    ctrl.latestWizardStepsHistory = resp.data;

            //console.log("Latest Wizard History");
            //console.log(ctrl.latestWizardStepsHistory);

            //if (ctrl.latestWizardStepsHistory.length > 0) {
            for (var j = 0; j < ctrl.wizardSteps.length; j++) {
                var uiStep = ctrl.createStepObject(ctrl.wizardSteps[j]); //parent step

                if (uiStep.hasChildren) {
                    for (var k = 0; k < ctrl.wizardSteps[j].children.length; k++) {
                        //loop thru child steps
                        uiStep.children.push(ctrl.createStepObject(ctrl.wizardSteps[j].children[k])); //add child step to parent
                    }
                    //update parent step status color
                    //if all the steps complete then parent step is complete
                    //if atleast one step is skipped then parent step status is skipped
                    //otherwise parent step status is unknown
                    var parentStepStatusId = 2; //default value 2:complete
                    for (var _k = 0; _k < uiStep.children.length; _k++) {
                        if (parentStepStatusId !== 1 && uiStep.children[_k].stepStatusId === 1) {
                            //statusId 1:skipped
                            parentStepStatusId = 1;
                        } else if (parentStepStatusId !== 1 && uiStep.children[_k].stepStatusId === 3) {
                            //statusId 3:unknown
                            parentStepStatusId = 3;
                        }
                    }
                    uiStep.stepStatusColor = ctrl.getStepStatusColor(parentStepStatusId);
                }

                ctrl.stepArray.push(uiStep); // steps collection
            }

            //ctrl.stepArray[1].hasChildren = true;
            //ctrl.stepArray[1].children.push(ctrl.stepArray[0]);
            //ctrl.stepArray[1].children.push(ctrl.stepArray[2]);
            //}
            //}, function (error) {
            //    console.log(error); //wizardStepsHistory Error
            //});

            //console.log("List of WizardSteps");
            //console.log(ctrl.wizardSteps);
            //console.log("Loaded Array of WizardSteps");
            //console.log(ctrl.stepArray);
        }, function (error) {
            console.log(error); //wizardSteps Error
        });
    };

    ctrl.createStepObject = function (wizardStep) {
        var stepViewName = wizardStep.stepViewName;
        var stepStatusId = ctrl.getStepStatusId(wizardStep.wizardStepLookupId);

        var myObj = {
            wizardStepLookupId: wizardStep.wizardStepLookupId,
            stepViewName: stepViewName,
            stepDescription: wizardStep.stepDescription,
            stepImage: wizardStep.stepImage,
            prevWizardStepLookupId: wizardStep.prevWizardStepLookupId,
            nextWizardStepLookupId: wizardStep.nextWizardStepLookupId,
            stepStatusId: stepStatusId,
            stepStatusColor: ctrl.getStepStatusColor(stepStatusId),
            skippable: wizardStep.skippable, //ctrl.isSkippable(wizardStep.skippable, stepViewName),
            hasChildren: wizardStep.children.length > 0,
            children: [],
            display: ctrl.stepToDisplay(stepViewName), // helps to hide/show wizardStep on UI
            isImage: ctrl.isImage(wizardStep.stepImage) // helps to apply different tag for icon vs image
        };

        return myObj;
    };

    ctrl.stepToDisplay = function (stepViewName) {
        //add code below for stepView which should not be displayed based on some condition
        var retVal = true;
        switch (stepViewName) {
            case "Tank And Well Overview":
                retVal = ctrl.accountInfo.tankAndWell;
                break;
        }
        return retVal;
    };

    ctrl.isImage = function (stepImage) {
        // to make sure whether this step has specific image instead of icon
        return stepImage.indexOf("images") > -1 ? true : false;
    };

    ctrl.getStepStatusId = function (wizardStepLookupId) {
        var foundItem = ctrl.latestWizardStepsHistory.find(function (wizardStep) {
            return wizardStep.wizardStepLookupId === wizardStepLookupId;
        });
        return !!foundItem ? foundItem.wizardStatusId : 3; //wizardStatudId 3:unknown
    };

    ctrl.isStepAlreadyComplete = function (stepName) {
        var lookupFound = ctrl.wizardSteps.find(function (wizardStep) {
            return wizardStep.stepViewName === stepViewName;
        });
        var stepHistoryFound = ctrl.latestWizardStepsHistory.find(function (wizardHistory) {
            return wizardHistory.wizardStepLookupId === lookupFound.wizardStepLookupId;
        });
        return !!stepHistoryFound && stepHistoryFound.wizardStatusId === 2 ? true : false;
    };

    ctrl.isStepAlreadySkipped = function (stepName) {
        var lookupFound = ctrl.wizardSteps.find(function (wizardStep) {
            return wizardStep.stepViewName === stepViewName;
        });
        var stepHistoryFound = ctrl.latestWizardStepsHistory.find(function (wizardHistory) {
            return wizardHistory.wizardStepLookupId === lookupFound.wizardStepLookupId;
        });

        return !!stepHistoryFound && stepHistoryFound.wizardStatusId === 1 ? true : false;
    };

    ctrl.getStepStatusColor = function (stepStatusId) {
        var retColor = "#FFFFFF"; //"dimgray"; //3: status is unknown

        switch (stepStatusId) {
            case 1:
                //skipped
                retColor = "#DCB239"; //"yellow";
                break;
            case 2:
                // complete
                retColor = "#0E8044"; //"green";
                break;
        }
        return retColor;
    };

    ctrl.launchStep = function (currenStepViewName) {
        //validate whether this step is already completed
        //if (ctrl.isStepAlreadyComplete(currenStepName)) {
        //    return;
        //}
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        var position = null;
        var isAdmin = authenticationService.getAccountInfo().userRole.indexOf("Administrator") > -1;

        //launch the view related to the given step
        switch (currenStepViewName) {
            //TODO:VEN: all these CASE statements will move to single call once Ned finish his refactoring of Open-View-Service to accommodate openview externally by passing view name.
            case "Customer Preferences":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 400, height: 300 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 400, minimumHeight: 300 }, undefined);
                break;
            case "User Preferences":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 400, height: 520 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 400, minimumHeight: 470 }, undefined);
                break;
            case "Destinations":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 900, height: 400 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 850, minimumHeight: 350 }, undefined);
                break;
            case "Electronic Keys":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 650, height: 340 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 650, minimumHeight: 100 }, undefined);
                break;
            case "RTU Info":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 850, height: 600 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 800, minimumHeight: 600 }, undefined);
                break;
            case "RTU Configuration":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 775, height: 400 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 700, minimumHeight: 400 }, undefined);
                break;
            case "Alerts":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 900, height: 450 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 900, minimumHeight: 150 }, undefined);
                break;
            case "Mission Reports":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 824, height: 400 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 740, minimumHeight: 350 });
                break;
            case "Notification Rules":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                position = { my: "left+100 top+10", at: "left top", of: window };
                $timeout(function () {
                    openViewService.openView(currenStepViewName, { width: 900, height: 400 }, position, optionsStickyProperties, { minimumWidth: 850, minimumHeight: 350 });
                }, 1000);
                break;
            case "Manage Schedule":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                position = { my: 'top+120', at: 'center top', of: window };
                $timeout(function () {
                    openViewService.openView(currenStepViewName, { width: 900, height: isAdmin ? 400 : 360 }, position, optionsStickyProperties, {
                        minimumWidth: 900, minimumHeight: isAdmin ? 400 : 360
                    }, true);
                }, 1000);
                break;
            case "Manage Desktops":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 550, height: 400 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 550, minimumHeight: 350 }, true);
                break;
            case "Analog Interconnect Setup":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 1000, height: 340 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 1000, minimumHeight: 100 }, undefined);
                break;
            case "Digital Interconnect Setup":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 1000, height: 340 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 1000, minimumHeight: 100 }, undefined);
                break;
            case "Tank And Well Overview":
                // first Minimize WizardSplash, then launch the view
                ctrl.minimizeViewAndSetSticky();
                openViewService.openView(currenStepViewName, { width: 500, height: 450 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 500, minimumHeight: 300 }, undefined);
                break;
        }
        //}
        //ctrl.direction = 1;
        //ctrl.stage = stage;
    };

    ctrl.skipStep = function (currenStepViewName) {
        //validate whether this step is already completed
        //if (ctrl.isStepAlreadySkipped(currenStepName)) {
        //    return;
        //}

        var foundItem = ctrl.stepArray.find(function (wizardStep) {
            return wizardStep.stepViewName === currenStepViewName;
        });
        if (!foundItem) {
            for (var j = 0; j < ctrl.stepArray.length; j++) {
                if (ctrl.stepArray[j].children.length > 0) {
                    foundItem = ctrl.stepArray[j].children.find(function (wizardStep) {
                        return wizardStep.stepViewName === currenStepViewName;
                    });
                }
            }
        }

        if (!!foundItem) {
            // save step status information to database
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, foundItem.stepViewName, 1); //save status as skipped (id:1)
            //Reload the steps from db.
            ctrl.getWizardSteps($rootScope.wizardId);
        }
    };

    ctrl.skipWizard = function () {
        wizardSplashService.SaveWizardStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, 1); //save status as skipped (id:1)
        //close the wizard now
        var _popup = _this.getExistingDialog(ctrl.windowId).ref;
        _popup.dialog("close");
    };

    ctrl.minimizeViewAndSetSticky = function () {
        if (!this.mobile && !this.classicView) {
            var popup = _this.getExistingDialog(this.windowId).ref;
            popup.dialogExtend("minimize");
            popup.parent().css("zIndex", 0);

            //set sticky property to indicate following view has been launched by WizardSpalash
            $rootScope.launchedByWizard = true;
            //sharedSetupService.setStickyProperties($scope.stickyProperties, { lauchedByWizard: true });
        }
    };

    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));

            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('.wizard-splash-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 8); //25: total padding
        }
    };

    $scope.$on('wizardSplashStepClosed', function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.getWizardSteps($rootScope.wizardId);
            var _popup = _this.getExistingDialog(ctrl.windowId).ref;
            _popup.dialogExtend("restore");
            _popup.dialog("moveToTop"); //.effect("pulsate", 100);
        }
    });
};

WizardSplashController.$inject = ['$scope', '$q', '$timeout', '$rootScope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'wizardSplashService'];
'use strict';

angular.module('mc.wizardSplash').component('wizardSplash', {
    controller: WizardSplashController,
    templateUrl: 'ui/gettingstarted/wizard-splash-partial.html',
    bindings: {
        //stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        classicView: '<'
        //windowTitle: '<'
    }
});
"use strict";

angular.module("mc.documents", []);
'use strict';

function DocumentFactory(host, $http, $q) {

    function getDmsContents(customerId) {
        return $http({
            method: 'GET',
            url: host + '/api/Documents',
            params: { customerId: customerId }
        });
    }

    function getDocumentContents(customerId, documentId, filename) {
        return $http({
            method: 'GET',
            url: host + '/api/Documents',
            params: { customerId: customerId, documentId: documentId, filename: filename }
        });
    }

    function downloadFile(customerId, documentId, filename) {
        var deferred = $q.defer();

        $http({
            method: 'GET',
            url: host + '/api/Documents',
            params: { customerId: customerId, documentId: documentId, filename: filename },
            responseType: 'arraybuffer'
        }).then(function (result) {
            var success = false;

            try {
                // Determine the content-type and disposition from the header 
                var contentType = result.headers()["content-type"]; //ex:"application/pdf"
                var sections = result.headers()["content-disposition"].split(";"); //0: "attachment" 1: " filename="RTU_Setup_Form_(PDF)_-_Updated_7/20/18.pdf""
                //filename = sections[1].split("=")[1];
                //updating file extension based on content-type
                filename = filename.concat("." + contentType.split("/")[1]);

                var blob = new Blob([result.data], { type: contentType });
                saveAs(blob, filename);
                success = true;
                deferred.resolve();
            } catch (ex) {
                console.log(ex);
            }
            if (!success) {
                // Fallback to window.open method
                //window.open(url, '_blank', '');
                console.log("Failed to download, try again");
            }
        }, function (data, status) {
            console.log("Request failed with status: " + status);
            deferred.reject(status);
        });
        return deferred.promise;
    };

    function sendEmailWithDocuments(customerId, documentEmailContent) {
        return $http({
            method: 'POST',
            url: host + '/api/Documents',
            params: { customerId: customerId },
            data: documentEmailContent
        });
    }

    return {
        getDmsContents: getDmsContents,
        getDocumentContents: getDocumentContents,
        downloadFile: downloadFile,
        sendEmailWithDocuments: sendEmailWithDocuments
    };
}

DocumentFactory.$inject = ['HOST', '$http', '$q'];

angular.module('mc.documents').factory('documentService', DocumentFactory);
"use strict";

function DocumentController($, $rootScope, $scope, $timeout, $element, authenticationService, translationService, sharedSetupService, openViewService, documentService, ivhTreeviewOptions, $uibModal) {
    var ctrl = this;
    $scope.qdpLeft = -237;
    $scope.alerts = [];
    ctrl.popup = null;
    ctrl.loading = true;
    ctrl.enableSendEmail = false; // this represents whether Email Form is shown or hidden

    ctrl.emailArray = [];

    ctrl.documentEmailContent = {};
    ctrl.documentEmailContent.enableSend = false;
    ctrl.documentEmailContent.emailToValid = false;
    ctrl.documentEmailContent.emailFromValid = false;
    ctrl.documentEmailContent.emailTo = "";

    ctrl.documents = [];
    ctrl.totalDocsSize = 0;
    ctrl.enalbeEmailForm = true; // use this flag to disable repetitive SEND button clicks
    ctrl.disableEmailForm = false; // used to disable the email form when Send Email is in-progress.

    //status filter related variables
    ctrl.statusModel = [];
    ctrl.statusData = [];
    ctrl.statusModelLength = null;
    ctrl.folderContents = [];
    ctrl.dmsRootFolder = null;
    ctrl.collapseIcon = "fa fa-folder-o"; //'<i class="fa fa-folder-open"></i>';
    ctrl.expandIcon = "fa fa-folder-open"; //'<i class="fa fa-folder"></i>';
    ctrl.leafIcon = "fa fa-file-text-o"; //'<i class="fa fa-file-text-o"></i>';
    ctrl.documentColorAttbt = ""; //"color:#33baf4";//bright blue; 
    ctrl.downloadIconClass = "fa fa-download download-icon" + ($rootScope.mobileApp ? " hidden" : "");

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.loading = true;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;

        $scope.windowId = ctrl.windowId; //need for
        //$scope.windowTitle = ctrl.windowTitle;//need for
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        $scope.alerts = [];

        //DISPLAY THE FIRST EMAIL INPUT ON INIT
        ctrl.emailArray.push({ address: "", isValid: false });

        //Manage Dialog Geometry
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            //THE-51575: jQuery UI renders the window title as a plain <span>; role/aria-level expose
            //it as an <h2> without Bootstrap's h2 styling. children() so a .ui-dialog-title inside
            //the view content is never matched
            ctrl.popup.dialog('widget').children(".ui-dialog-titlebar").children(".ui-dialog-title").attr({ "role": "heading", "aria-level": "2" });

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        }

        //Handle infinite scrolling
        $timeout(function () {
            //find the element of the chart class
            if (!$rootScope.mobile && !$rootScope.classicView) {
                ctrl.element = $element.find('.tabular-data-container');
            } else {
                ctrl.element = $element.find('.tabular-data-container-mobile');
            }

            //fetch the data from WebApi
            //ctrl.getDMSContents();                        
            documentService.getDmsContents(ctrl.accountInfo.customerId).then(function (resp) {
                ctrl.dmsRootFolder = resp.data;
                //load email FORM contents
                loadEmailFormContents();
                ctrl.refreshAlerts();
            }).finally(function () {
                ctrl.loading = false;
            });
        });

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
        }

        //manually making call to adjustSize in order to load scrollbar
        $timeout(function () {
            ctrl.adjustSize();
        }, 500);
    };

    ctrl.addEmailAddress = function () {
        ctrl.emailArray.push({ address: "", isValid: false });
    };

    ctrl.removeEmailAddress = function (index) {
        if (ctrl.emailArray.length > 1) {
            //do not remove if only one email exists, clear it instead. 
            ctrl.emailArray.splice(index, 1);
            ctrl.mapEmailArrayToString();
        } else {
            ctrl.emailArray[index].address = "";
            ctrl.emailArray[0].isValid = false;
        }
    };

    ctrl.mapEmailArrayToString = function () {
        ctrl.documentEmailContent.emailTo = "";

        for (var i = 0; i < ctrl.emailArray.length; i++) {
            if (ctrl.emailArray[i].isValid) {
                ctrl.documentEmailContent.emailTo += ctrl.emailArray[i].address + ",";
            }
        }
        ctrl.documentEmailContent.emailTo = ctrl.documentEmailContent.emailTo.replace(/,\s*$/, "");
    };

    ctrl.validateEmail = function (index) {
        var regExpn = /^[a-zA-Z0-9.'_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
        if (regExpn.test(ctrl.emailArray[index].address)) {
            ctrl.emailArray[index].isValid = true;
            ctrl.documentEmailContent.emailToValid = true;
            ctrl.disableEmailForm = false;
            ctrl.mapEmailArrayToString();
        } else {
            ctrl.emailArray[index].isValid = false;
            ctrl.documentEmailContent.emailToValid = false;
        }
        //validate email FROM address
        if (ctrl.documentEmailContent.emailFrom.length === 0) {
            ctrl.documentEmailContent.emailFromValid = false;
        } else if (regExpn.test(String(ctrl.documentEmailContent.emailFrom).toLowerCase())) {

            ctrl.documentEmailContent.emailFromValid = true;
        } else {
            ctrl.documentEmailContent.emailFromValid = false;
        }
        validateSendButton();
    };

    ctrl.validateEmailFrom = function () {};

    // this is the callback function when enable email button is clicked on top-menu
    ctrl.enableCheckboxes = function (node) {
        if (!node) node = ctrl.dmsRootFolder;
        ctrl.enableSendEmail = !ctrl.enableSendEmail;
        //ctrl.enableEmailForm = true;

        toggleCheckboxes(node);
        if (!ctrl.enableSendEmail) clearCheckboxes(ctrl.dmsRootFolder);else loadEmailFormContents();
    };

    var toggleCheckboxes = function toggleCheckboxes(node) {
        angular.forEach(node.children, function (child, key) {
            child.enable = !child.enable;
            toggleCheckboxes(child);
        });
    };

    ctrl.onDocumentChecked = function (childNode) {
        if (childNode.checked) {
            ctrl.totalDocsSize += childNode.size;
            //validating total size of the email
            if (ctrl.totalDocsSize > 12000000) {
                ctrl.openOkModal(ctrl.translation.text.EMAIL_ATTACHMENT_LIMIT_MESSAGE + "  12MB.");
                ctrl.totalDocsSize -= childNode.size;
                childNode.checked = false;
                return;
            }
            ctrl.documents.push({ id: childNode.id, filename: childNode.name });
        } else {
            //var index = ctrl.documents.indexOf(child => child.id == childNode.id);
            var idx = _.findIndex(ctrl.documents, function (child) {
                return child.id === childNode.id;
            });
            if (idx > -1) {
                ctrl.totalDocsSize -= childNode.size;
                ctrl.documents.splice(idx, 1); //remove item from the list
            }
        }
        validateSendButton();
    };

    ctrl.onKeyUpValidateEmail = function () {
        var regExpn = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;

        //validate email From address
        if (ctrl.documentEmailContent.emailFrom.length === 0) {
            ctrl.documentEmailContent.emailFromValid = false;
        } else if (regExpn.test(String(ctrl.documentEmailContent.emailFrom).toLowerCase())) {

            ctrl.documentEmailContent.emailFromValid = true;
        } else {

            ctrl.documentEmailContent.emailFromValid = false;
        }

        //validate email TO address
        ctrl.documentEmailContent.emailToValid = false;
        if (ctrl.documentEmailContent.emailTo.length === 0) {
            ctrl.documentEmailContent.emailToValid = false;
        } else {
            //loop thru emailTo address if they are valid
            var tmpIsValidEmailTo = true;
            var emails = ctrl.documentEmailContent.emailTo.split(', '); // emails should be separated by comma and single space
            if (emails && emails.length > 0) {
                //validate each emailTo address
                angular.forEach(emails, function (email, key) {
                    if (!regExpn.test(String(email).toLowerCase())) tmpIsValidEmailTo = false;
                });
            } else {
                //validate single emailTo address
                if (!regExpn.test(String(ctrl.documentEmailContent.emailTo).toLowerCase())) tmpIsValidEmailTo = false;
            }
            ctrl.documentEmailContent.emailToValid = tmpIsValidEmailTo;
        }

        validateSendButton();
    };

    var validateSendButton = function validateSendButton() {
        ctrl.documentEmailContent.enableSend = false; // represents whether Send button on the form is enabled or not
        if (ctrl.documents.length > 0 && ctrl.documentEmailContent.emailToValid && ctrl.documentEmailContent.emailFromValid) {
            ctrl.documentEmailContent.enableSend = true;
        }
    };

    ctrl.sendEmail = function () {
        ctrl.documentEmailContent.documents = ctrl.documents;
        var noOfAttachments = ctrl.documents.length;
        ctrl.disableEmailForm = true; // disable email form while Send email in-progress
        documentService.sendEmailWithDocuments(ctrl.accountInfo.customerId, ctrl.documentEmailContent).then(function (success) {
            //console.log("Sent email");
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.OK + ", " + noOfAttachments + " " + ctrl.translation.text.ATTACHMENT;
            ctrl.openOkModal(userMessage);
            //clear user elections
            clearCheckboxes(ctrl.dmsRootFolder);
            ctrl.disableEmailForm = false; // enable email form after Send email success
            ctrl.documents.length = 0;
            ctrl.previousEmailTo = angular.copy(ctrl.documentEmailContent.emailTo);
            loadEmailFormContents();
            validateSendButton();
            //Load previous sent email address and check to see if email address is valid
            ctrl.documentEmailContent.emailTo = ctrl.previousEmailTo;
            ctrl.onKeyUpValidateEmail();
        }, function (fail) {
            var userMessage = ctrl.translation.text.SENT + " " + ctrl.translation.text.FAILURE;
            ctrl.openOkModal(userMessage);
            //console.log("fail to send email");
            ctrl.disableEmailForm = false; // enable email form after Send email failure
            validateSendButton();
        });
    };

    var clearCheckboxes = function clearCheckboxes(node) {
        angular.forEach(node.children, function (child, key) {
            if (child.type === 'document' && child.checked) child.checked = false;
            if (child.children !== null) clearCheckboxes(child);
        });
    };

    var loadEmailFormContents = function loadEmailFormContents() {
        //load email FORM contents
        ctrl.documentEmailContent.emailFrom = "techsupport@123mc.com";
        ctrl.documentEmailContent.emailFromValid = true;
        ctrl.documentEmailContent.emailTo = "";
        ctrl.documentEmailContent.emailToValid = false;
        ctrl.documentEmailContent.emailMessage = ctrl.translation.text.INFO_REQUESTED_ATTACHED;

        ctrl.totalDocsSize = 0;
    };

    ctrl.refreshAlerts = function () {
        $scope.alerts = [];
        if (ctrl.dmsRootFolder.children === null || ctrl.dmsRootFolder.children.length === 0 || ctrl.dmsRootFolder.children[0].children.length === 0) {
            var errorMessage = ctrl.translation.message.NO_RESULTS_FOUND;
            $scope.alerts.push({
                msg: errorMessage,
                type: "info"
            });
        }
    };

    ctrl.getNodeClass = function (node) {
        if (node.type === 'folder') {
            return ctrl.expandIcon;
        } else if (node.children === null) {
            return ctrl.leafIcon;
        }
    };

    ctrl.downloadFile = function (node) {
        if (node.type === 'folder') return;
        documentService.downloadFile(ctrl.accountInfo.customerId, node.id, node.name).finally(function (resp) {
            ctrl.inProgressDownloadFile = false;
        });
    };

    ctrl.getDocumentContents = function (folderId, filename) {
        documentService.getDocumentContents(ctrl.accountInfo.customerId, folderId, filename).then(function (resp) {
            ctrl.folderContents = resp.data;
        });
    };

    ctrl.adjustSize = function () {
        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));

            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('.documents-html').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 70); //143: total padding
        }
    };

    //Modal popover related code
    ctrl.openOkModal = function (message) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            this.popoverMessage = message;

            this.ok = function () {
                $uibModalInstance.close();
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/ok-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });
    };

    ctrl.convertBytesToString = function (sizeInBytes) {
        var b2s = function b2s(t) {
            var e = Math.log2(t) / 10 | 0;
            return (t / Math.pow(1024, e = e <= 0 ? 0 : e)).toFixed(1) + "BKMGP"[e];
        };
        return b2s(sizeInBytes);
    };

    ctrl.getEmailAttachmentsSize = function () {
        var msg = "(" + ctrl.translation.text.ATTACHMENTS + " " + ctrl.translation.text.SIZE + ": " + ctrl.convertBytesToString(ctrl.totalDocsSize) + ")";
        return ctrl.totalDocsSize > 0 ? msg : "";
    };
}

DocumentController.$inject = ['$', '$rootScope', '$scope', '$timeout', '$element', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'documentService', 'ivhTreeviewOptions', '$uibModal'];
'use strict';

angular.module('mc.documents').component('documents', {
    controller: DocumentController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/documents/documents-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        //windowTitle: '<',
        classicView: '<',
        out: '&'
    }
});
"use strict";

angular.module("mc.flow-summary-monthly", []);
'use strict';

function FlowSummaryMonthlyFactory(HOST, $http, GetDeviceNameService) {

    var FlowSummaryMonthlyData = function FlowSummaryMonthlyData(customerId) {
        this.customerId = customerId;
    };

    FlowSummaryMonthlyData.prototype.getData = function (startDate, endDate, deviceId, deviceType, channel) {
        var isRawCount = false;
        if (channel.includes("MR")) {
            isRawCount = true;
            channel = channel.replace('MR', '');
        }
        return $http.get(HOST + '/api/PulseFlowCalendar?customerId=' + this.customerId + '&deviceId=' + deviceId + '&channel=' + channel + '&deviceType=' + deviceType + '&startDate=' + startDate + '&endDate=' + endDate + '&isRawCount=' + isRawCount).then(function (response) {
            return response;
        });
    };

    FlowSummaryMonthlyData.prototype.getSettings = function (deviceId) {
        return $http.get(HOST + '/api/ParmPulse?deviceId=' + deviceId).then(function (response) {
            return response;
        });
    };
    return FlowSummaryMonthlyData;
}

FlowSummaryMonthlyFactory.$inject = ['HOST', '$http', 'GetDeviceNameService'];

angular.module('mc.flow-summary-monthly').factory('FlowSummaryMonthlyFactory', FlowSummaryMonthlyFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function FlowSummaryMonthlyController($, $rootScope, $scope, authenticationService, translationService, sharedSetupService, openViewService, FlowSummaryMonthlyFactory, $element, savePdfService, $location) {
    var _this2 = this;

    var ctrl = this;

    ctrl.$onInit = function () {
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        $scope.windowId = ctrl.windowId;
        ctrl.translation = translationService.translation;
        $scope.windowTitle = ctrl.windowTitle;
        sharedSetupService.getWindowId(_this2);

        $scope.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;
        if (_typeof($scope.stickyProperties) !== 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.setStickyProperties($scope.stickyProperties, { windowId: _this2.windowId });
        ctrl.selectedSetting = $scope.stickyProperties.device.channel;

        if (!$scope.stickyProperties.deviceId && (ctrl.mobile || ctrl.classicView)) {
            $location.path('/pulseflow/calendar/pulseflow-calendar-template');
            return;
        }

        ctrl.flowSummaryMonthlyFactory = new FlowSummaryMonthlyFactory(ctrl.accountInfo.customerId);
        ctrl.currentDate = new Date(new Date($scope.stickyProperties.zoomMax).getFullYear(), new Date($scope.stickyProperties.zoomMax).getMonth(), 1);
        ctrl.getSettings();

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");

        var drawCell = function drawCell(row, data) {
            if (typeof data.row.raw[1] == "undefined") {
                data.doc.setFillColor(226, 239, 248);
            }
            if (data.row.cells[0].text[0] == "Total Gallons:") {
                data.doc.setFontStyle('bold');
                data.doc.setFillColor(226, 239, 248);
            }
        };

        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle) + (': ' + moment(ctrl.reportDate).format("MMMM YYYY")),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            drawCell: drawCell
        };

        savePdfService.savePDF(pdfParams);
    };

    ctrl.setDate = function (months) {
        if (months == 0) ctrl.currentDate = new Date();
        var d = new Date(ctrl.currentDate || new Date());
        d.setMonth(d.getMonth() + (months || 0), d.getDate());
        ctrl.currentDate = d;
        ctrl.adjustButtons();
        ctrl.missionDataUsage = [];
        ctrl.monthSelect = d.getMonth() + 1;
        ctrl.yearSelect = d.getFullYear();
        ctrl.getData();
    };

    ctrl.adjustButtons = function () {
        if (new Date(ctrl.currentDate.getFullYear(), ctrl.currentDate.getMonth() + 1, 0).getTime() === new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime()) {
            ctrl.todaysDate = true;
            ctrl.nextDate = true;
        } else {
            ctrl.todaysDate = false;
            ctrl.nextDate = false;
        }
    };

    ctrl.getData = function (channel) {
        ctrl.loadingInProgress = true;
        var startDate = new Date(ctrl.currentDate.getFullYear(), ctrl.currentDate.getMonth(), 1);
        var endDate = new Date(ctrl.currentDate.getFullYear(), ctrl.currentDate.getMonth() + 1, 1);

        ctrl.flowSummaryMonthlyFactory.getData(ctrl.getUtc(startDate), ctrl.getUtc(endDate), $scope.stickyProperties.deviceId, $scope.deviceSelectedType, channel || ctrl.selectedSetting).then(function (result) {
            var data = result.data.reverse();

            for (var i = 0; i < new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate(); i++) {
                if (data[i]) {
                    var eventDate = new Date(data[i].start);

                    if (i + 1 !== eventDate.getDate()) {
                        var newEvent = {
                            allDay: true,
                            start: eventDate.getMonth() + 1 + '/' + (i + 1) + '/' + eventDate.getFullYear(),
                            title: '0'
                        };

                        data.splice(i, 0, newEvent);
                    }
                } else {
                    if (new Date(endDate.getFullYear(), endDate.getMonth() - 1, i + 1) <= new Date()) {
                        var _newEvent = {
                            allDay: true,
                            start: endDate.getMonth() + '/' + (i + 1) + '/' + endDate.getFullYear(),
                            title: '0'
                        };

                        data.push(_newEvent);
                    }
                }
            }
            ctrl.flowSummaryData = data;
            $scope.stickyProperties.zoomMax = ctrl.getUtc(endDate);
            sharedSetupService.setStickyProperties($scope.stickyProperties, { device: { channel: channel || ctrl.selectedSetting }, windowId: ctrl.windowId });
        });

        ctrl.loadingInProgress = false;
    };

    ctrl.getSettings = function (setFlowDefaultFlowChannel) {
        $scope.alerts = [];

        ctrl.flowSummaryMonthlyFactory.getSettings($scope.stickyProperties.deviceId).then(function (result) {
            ctrl.flowSummarySettings = result.data;
            for (var i = 0; i < ctrl.flowSummarySettings.length; i++) {
                ctrl.flowSummarySettings[i].meterReadingChannel = "MR" + ctrl.flowSummarySettings[i].channel;
            }
            if (ctrl.flowSummarySettings.length && setFlowDefaultFlowChannel) {
                ctrl.selectedSetting = ctrl.flowSummarySettings[0].channel.toString();
                ctrl.getData(ctrl.flowSummarySettings[0].channel.toString());
            } else if (ctrl.flowSummarySettings.length) {
                ctrl.getData();
            } else {
                $scope.alerts.push({ msg: ctrl.translation.text.NO_PULSE_FLOW_SETTINGS, type: 'info', languageCode: 'NO_PULSE_FLOW_SETTINGS' });
            }
            ctrl.alerts = $scope.alerts.length;
        });
    };

    ctrl.getMonthCumulative = function (index) {
        var total = 0;
        for (var i = 0; i < index + 1; i++) {
            total += parseFloat(ctrl.flowSummaryData[i].title);
        }
        return total;
    };

    ctrl.getUtc = function (date) {
        var userOffset = date.getTimezoneOffset() * 60000; // [min*60000 = ms]
        date = new Date(date.getTime() + userOffset * -1);
        return date.getTime();
    };

    $scope.$watch(function () {
        return $scope.deviceSelected;
    }, function (newVal, oldVal) {
        if (newVal != oldVal) {
            $scope.stickyProperties.deviceId = newVal;
            ctrl.getSettings(true);
        }
    }, true);
}

FlowSummaryMonthlyController.$inject = ['$', '$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'FlowSummaryMonthlyFactory', '$element', 'savePdfService', '$location'];
'use strict';

angular.module('mc.flow-summary-monthly').component('flowSummaryMonthly', {
    controller: FlowSummaryMonthlyController,
    templateUrl: 'ui/flowsummarymonthly/flow-summary-monthly-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.electronickeys', []);
'use strict';

function ElectronicKeysModel(_, HOST, $http, translationService, modalService, toaster) {
  var _this = this;

  var ElectronicKeys = function ElectronicKeys(customerId) {
    _this.keys = [];
    _this.customerId = customerId;
    _this.loading = true;
    $http.get(HOST + '/api/DallasKey?customerId=' + customerId).then(function (resp) {
      _this.keys = resp.data;
      _this.loading = false;
    });
  };

  var validateKey = function validateKey(key) {
    var regex = /[0-9A-Fa-f]{4}$/g;
    if (!regex.test(key.keyHex)) {
      return false;
    }

    return true;
  };

  ElectronicKeys.prototype.get = function () {
    return _this.keys;
  };

  ElectronicKeys.prototype.isLoading = function () {
    return _this.loading;
  };

  ElectronicKeys.prototype.addKey = function () {
    var newKey = {
      dallasKeyID: 0,
      keyName: '',
      nameError: true,
      nameMessage: translationService.translation.text.MISSING_NAME,
      keyHex: '',
      hexError: true,
      hexMessage: translationService.translation.text.MISSING_HEX,
      actions: {
        keyAck: false,
        keyService: false,
        keyRTUConfig: false
      }
    };

    _this.keys.unshift(newKey);
  };

  ElectronicKeys.prototype.cancelAdd = function () {
    _this.keys.splice(0, 1);
  };

  ElectronicKeys.prototype.deleteKey = function (id) {
    modalService.confirmDelete('DELETE_KEY').then(function () {
      $http.delete(HOST + '/api/DallasKey?customerId=' + _this.customerId + '&dallasKeyID=' + id).then(function (resp) {
        var idx = _.findIndex(_this.keys, function (key) {
          return key.dallasKeyID === id;
        });
        if (idx > -1) {
          _this.keys.splice(idx, 1);
        }
      }, function (resp) {
        toaster.pop('error', translationService.translation.text.ELECTRONIC_KEYS, resp.data.message);
      });
    }, function () {
      // Do nothing!
    });
  };

  ElectronicKeys.prototype.updateKey = function (key, oldKey, field, actions) {
    var tempKey = { op: 'replace', path: field.charAt(0).toUpperCase() + field.slice(1), value: actions ? key.actions[field].toString() : key[field] };
    var valid = field === 'keyHex' ? validateKey(key) : tempKey.value !== null && tempKey.value !== '';
    var changed = false;
    if (!oldKey) {
      changed = true;
    } else {
      changed = actions ? key.actions[field] !== oldKey.actions[field] : key[field] !== oldKey[field];
    }

    if (valid && changed && key.dallasKeyID !== 0) {
      return $http.patch(HOST + '/api/DallasKey?customerId=' + _this.customerId + '&dallasKeyID=' + key.dallasKeyID, tempKey);
    }
    return false;
  };

  ElectronicKeys.prototype.insertKey = function (key) {
    if (key.keyName !== '' && key.keyHex !== '' && validateKey(key)) {
      $http.post(HOST + '/api/DallasKey?customerId=' + _this.customerId + '&keyName=' + key.keyName + '&keyHex=' + key.keyHex + '&keyAck=' + key.actions.keyAck + '&keyService=' + key.actions.keyService + '&keyRTUConfig=' + key.actions.keyRTUConfig).then(function (resp) {
        key.dallasKeyID = resp.data.dallasKeyID;
        _this.keys = _.sortBy(_this.keys, function (k) {
          return k.keyName.toLowerCase();
        });
      }, function (resp) {
        if (resp.data === 'DUPLICATE_KEY') {
          key.hexError = true;
          key.hexMessage = translationService.translation.text.DUPLICATE_KEY;
        }
      });
    }
  };

  return ElectronicKeys;
}

ElectronicKeysModel.$inject = ['_', 'HOST', '$http', 'translationService', 'modalService', 'toaster'];

angular.module('mc.electronickeys').factory('electronicKeysModel', ElectronicKeysModel);
'use strict';

function ElectronicKeysController(_, $, $rootScope, $scope, $sce, authenticationService, translationService, modalService, ElectronicKeys, wizardSplashService, sharedSetupService, unsavedChangesService) {
  var _this2 = this;

  this.$onInit = function () {
    _this2._ = _;
    sharedSetupService.getWindowId(_this2);
    _this2.savedKey = null;
    _this2.canClose = false;
    _this2.accountInfo = authenticationService.getAccountInfo();
    _this2.translation = translationService.translation;
    _this2.electronicKeys = new ElectronicKeys(_this2.accountInfo.customerId);

    // binding 'dialogbeforeclose' event to Check for unsaved Changes function
    if (!_this2.mobile && !_this2.classicView) {
      _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
      $(_this2._popup).on('dialogbeforeclose', function (event) {
        unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, _this2.newKey());
      });
    }
  };

  this.getHeight = function () {
    if (!_this2.mobile && !_this2.classicView) {
      return _this2._popup.parent().find('.electronic-keys-container')[0].clientHeight - 23;
    }

    //return $('.electronic-keys-container')[0].clientHeight - 65;
  };

  $scope.$on('$routeChangeStart', function (event) {
    if (_this2.newKey()) {
      if (confirm(_this2.translation.text.EXIT_WITHOUT_SAVE) !== true) {
        console.log(event);
        event.preventDefault();
        $rootScope.loadingView = false;
      }
    }
  });

  this.isAdmin = function () {
    return _this2.accountInfo.userRole === 'Administrator' || _this2.accountInfo.userRole === 'SuperAdministrator';
  };

  this.editingKey = function (key) {
    _this2.savedKey = JSON.parse(JSON.stringify(key));
  };

  this.newKey = function () {
    return _.findIndex(_this2.electronicKeys.get(), function (key) {
      return key.dallasKeyID === 0;
    }) > -1;
  };

  this.validateName = function (key) {
    if (key.keyName === '') {
      key.nameError = true;
      key.nameMessage = _this2.translation.text.MISSING_NAME;
      return false;
    }

    key.nameError = false;
    key.nameMessage = '';
    return true;
  };

  this.validateKeyHex = function (key) {
    var regex = /[0-9A-Fa-f]{4}$/g;
    if (key.keyHex === '') {
      key.hexError = true;
      key.hexMessage = _this2.translation.text.MISSING_HEX;
      return false;
    } else if (!regex.test(key.keyHex)) {
      key.hexError = true;
      key.hexMessage = _this2.translation.text.INVALID_HEX;
      return false;
    }

    key.hexError = false;
    key.hexMessage = '';
    return true;
  };

  this.readOnlyValidateHex = function (key) {
    var regex = /[0-9A-Fa-f]{4}$/g;
    if (key.keyHex === '') {
      return false;
    } else if (!regex.test(key.keyHex)) {
      return false;
    }

    return true;
  };

  this.updateKey = function (key, field, actions) {
    var result = _this2.electronicKeys.updateKey(key, _this2.savedKey, field, actions);
    if (result !== false) {
      result.then(function (resp) {
        if (actions) {
          key.actions[field] = resp.data.actions[field];
        } else {
          key = resp.data[field];
        }
      }, function (resp) {
        if (resp.data === 'DUPLICATE_KEY') {
          key.hexError = true;
          key.hexMessage = _this2.translation.text.DUPLICATE_KEY;
        }
      });
    }
  };

  this.hasOverflow = function () {
    var element = document.getElementById('key-rows');
    if (element.offsetHeight < element.scrollHeight) {
      return true;
    }
    return false;
  };

  this.selectInput = function ($event) {
    $event.target.select();
  };

  this.$onDestroy = function () {
    //save wizard step status if wizard splash lauched this view.
    if ($rootScope.launchedByWizard) {
      wizardSplashService.SaveWizardStepStatus(_this2.accountInfo.customerId, _this2.accountInfo.userId, $rootScope.wizardId, _this2.windowId, 2); //save status as completed (2: status complete)
      $rootScope.$broadcast('wizardSplashStepClosed');
    }
  };
}

ElectronicKeysController.$inject = ['_', '$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'modalService', 'electronicKeysModel', 'wizardSplashService', 'sharedSetupService', 'unsavedChangesService'];

angular.module('mc.electronickeys').component('electronicKeys', {
  controller: ElectronicKeysController,
  transclude: true,
  templateUrl: 'ui/electronickeys/electronic-keys-partial.html',
  bindings: {
    windowId: '<',
    mobile: '<',
    classicView: '<'
  }
});
mcapp.controller("digitalWidgetController", ["$scope", "$rootScope", "authenticationService", "translationService", "sharedSetupService", "$timeout", "$element",
    function ($scope, $rootScope, authenticationService, translationService, sharedSetupService, $timeout, $element) {
        $scope.Time = null;
        $scope.digitalSettings = null;
        $scope.digitalWidget = null;
        $scope.alerts = [];
        $scope.translation = translationService.translation;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.showSetting = false;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;

        sharedSetupService.getWindowId($scope);
        if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }

        $scope.setSetting = function () {
            $scope.digitalDeviceSelectedId = { "deviceId": $scope.stickyProperties.device.deviceId };
            $scope.digitalChannelSelected = { "deviceId": $scope.stickyProperties.device.deviceId, "channel": $scope.stickyProperties.device.channel };
            $scope.preDigitalDeviceSelected = $scope.stickyProperties.device;
        };

        $scope.setSetting();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            $scope.closeWidget = function () {
                $element.find(".flip-container").hide();
                $scope.popup.dialog("close");
            };

            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.resizeContent();
                    $scope.$apply();
                }
            });

            $scope.resizeContent = function () {
                if (!$element.find(".digital-widget-icon"))
                    return;
                var _newWidth = $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "");
                $element.find('.widgetSettingNew').css("width", _newWidth < 240 ? 240 : _newWidth)
                    .css("margin-left", _newWidth < 240 ? -(240 - _newWidth) / 2 : "auto");

            };
        } else {
            $scope.popup = $(".flip-container");
            $scope.resizeContent = function () {
                return;
            }
        }

    }]);


mcapp.directive('digitalWidgetDirective', ['$rootScope', "authenticationService", "websocketService", "digitalGaugeService", "datetimeService", "toaster", "$document", "sharedSetupService", "$timeout",
    function ($rootScope, authenticationService, websocketService, digitalGaugeService, datetimeService, toaster, $document, sharedSetupService, $timeout) {
        function link(scope, element, attrs) {
            websocketService.connect();

            element.tooltip({
                track: true,
                tooltipClass: 'tooltip-jq',
                content: function () {
                    return this.getAttribute('data-title');
                },
                items: 'img[data-title]'
            });

            scope.getDigitalData = function (deviceId, channelId) {
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, windowId: scope.windowId });
                digitalGaugeService.getData(scope.accountInfo.customerId, deviceId, scope.accountInfo.timeZone)
                    .then(function (result) {
                        scope.alerts = [];
                        scope.digitalSettings = result.data.digitalSettings;
                        scope.device = result.data.device;
                        scope.lastData = result.data.lastDigitals;

                        var status;
                        var currentStatus;
                        scope.nomalState = 0;
                        var digValue = 0;
                        var channelDesc = null;
                        scope.widgetImage = '';

                        for (var i = 0; i < scope.digitalSettings.length; i++) {
                            if (parseInt(channelId) === parseInt(scope.digitalSettings[i].channel)) {
                                scope.nomalState = scope.digitalSettings[i].normalClosed;
                                scope.channelDesc = scope.digitalSettings[i].description;
                                scope.digitalMode = scope.digitalSettings[i].digitalMode;
                                scope.widgetImage = scope.digitalSettings[i].image;
                            }
                        }

                        var deviceSN = result.data.device.serialNumber;
                        var _device = { deviceId: deviceId, channel: channelId, serialNumber: deviceSN };
                        var channel = scope.translation.text.INPUT + " " + channelId + ": " + (scope.channelDesc || scope.translation.text.NOT_SETUP); 
                        var deviceName = result.data.device.name;

                        if (result.data.digitalSettings.length <= 0) {
                            scope.alerts.push({ msg: scope.translation.message.NO_DIGIAL_SETUP, type: "info" });
                            status = _convertStatus("-1", "-1");
                        }
                        else if (result.data.digitalData == null) {
                            scope.alerts.push({ msg: scope.translation.message.NO_DATA, type: "info" });
                            status = _convertStatus("-1", "-1");
                        }
                        else {
                            websocketService.unRegister("INPUTS", scope.preDigitalDeviceSelected.serialNumber, '', wsDataReceivedWD, wsReconnectWD);
                            websocketService.unRegister("OPTIONDIGITAL", scope.preDigitalDeviceSelected.serialNumber, '', wsDataReceivedWOD, null);
                            websocketService.unRegister("FAULTS", scope.preDigitalDeviceSelected.serialNumber, '', wsDataReceivedFAULTS, null);
                            _unRegisterListenerDigitalSetting(scope.device.serialNumber,channelId);
                            websocketService.register("INPUTS", scope.device.serialNumber, '', wsDataReceivedWD, wsReconnectWD);
                            websocketService.register("OPTIONDIGITAL", scope.device.serialNumber, '', wsDataReceivedWOD, null);
                            websocketService.register("FAULTS", scope.device.serialNumber, '', wsDataReceivedFAULTS, null);
                            _registerListenerDigitalSetting(scope.device.serialNumber,channelId);
                            scope.preDigitalDeviceSelected = result.data.device;
                            digValue = result.data.digitalData[Object.keys(result.data.digitalData)[parseInt(channelId) - 1]];

                            if (digValue === "True")
                                digValue = "1";
                            if (digValue === "False")
                                digValue = "0";
                            var currentVal = digValue;
                            digValue = UpdateValue(digValue, channelId, scope.nomalState);
                            status = _convertStatus(digValue, scope.digitalMode, scope.widgetImage);

                            currentStatus = scope.translation.text.STATUS + ": " + status.statusMessage;
                        }

                        scope.digitalWidget = { channel: channel, status: currentStatus, image: status.statusImage, input: channelId, deviceName: deviceName, deviceSN: deviceSN, currentVal: currentVal };
                        sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: _device, windowId: scope.windowId });
                        if (scope.popup.selector !== ".flip-container") scope.popup.dialog("option", "title", scope.device.name + ", " + scope.digitalWidget.channel);
                        scope.deviceSelectedName = scope.device.name;
                        scope.resizeContent();
                    }, function (error) {

                        var errormsg = eval("scope.translation.message." + error.data.message);

                        scope.alerts.push({ msg: errormsg, type: "danger" });
                    });
            };

            var wsDataReceivedDIGITALSETTINGDW = function (data) {
                if (data.Type == 'DIGITALSETTING' && data.SN == scope.device.serialNumber && data.CH == scope.digitalChannelSelected.channel) {
                    $timeout(function () {
                        scope.getDigitalData(scope.digitalDeviceSelectedId.deviceId, scope.digitalChannelSelected.channel);
                    }, 200);
                }
            };
    
            var _registerListenerDigitalSetting = function (varSerialNum, channel) {
                //subscribe for digital setting changes scope.digitalChannelSelected.channel
                websocketService.connect();
                websocketService.register("DIGITALSETTING", varSerialNum, channel, wsDataReceivedDIGITALSETTINGDW, null);
            };
            var _unRegisterListenerDigitalSetting = function (varSerialNum, channel) {
                websocketService.connect();
                websocketService.unRegister("DIGITALSETTING", varSerialNum, channel, wsDataReceivedDIGITALSETTINGDW, null);
            };

            var millisecondsToStr = function (milliseconds) {
                // TIP: to find current time in milliseconds, use:
                // var  current_time_milliseconds = new Date().getTime();

                function numberEnding(number) {
                    return (number > 1) ? 's' : '';
                }

                var temp = Math.floor(milliseconds / 1000);
                var years = Math.floor(temp / 31536000);
                if (years) {
                    return years + ' ' + scope.translation.text.YEAR + numberEnding(years);
                }
                //TODO: Months! Maybe weeks?
                var days = Math.floor((temp %= 31536000) / 86400);
                if (days) {

                    temp = temp - days * 86400;
                    var rhours = Math.floor((temp %= 86400) / 3600);
                    if (rhours > 0)
                        return days + ' ' + scope.translation.text.DAY + numberEnding(days) + ' ' + rhours + ' ' + scope.translation.text.HOUR + numberEnding(rhours);
                    else
                        return days + ' ' + scope.translation.text.DAY + numberEnding(days);
                }
                var hours = Math.floor((temp %= 86400) / 3600);
                if (hours) {
                    temp = temp - hours * 3600;
                    var rminutes = Math.floor((temp %= 3600) / 60);
                    if (rminutes > 0)
                        return hours + ' ' + scope.translation.text.HOUR + numberEnding(hours) + ' ' + rminutes + ' ' + scope.translation.text.MINUTE + numberEnding(rminutes);
                    else
                        return hours + ' ' + scope.translation.text.HOUR + numberEnding(hours);
                }
                var minutes = Math.floor((temp %= 3600) / 60);
                if (minutes) {
                    return minutes + ' ' + scope.translation.text.MINUTE + numberEnding(minutes);
                }
                var seconds = temp % 60;
                if (seconds) {
                    return seconds + ' ' + scope.translation.text.SECOND + numberEnding(seconds);
                }
                return scope.translation.text.LESS_THAN_A_SECOND; //'just now' //or other string you like;
            };

            var wsDataReceivedWD = function (data) {
                if (scope.device.serialNumber === data.SN) {
                    channelId = scope.digitalChannelSelected.channel;
                    if (channelId > 8) return;
                    var chArray = data.Value.replace(/[[\]]/g, '').split(',');
                    digValue = UpdateValue(chArray[channelId - 1], channelId, scope.nomalState);
                    var status = _convertStatus(digValue, scope.digitalMode, scope.widgetImage);
                    var channel = scope.translation.text.INPUT + " " + channelId + ": " + scope.channelDesc;
                    var currentStatus = scope.translation.text.STATUS + ": " + status.statusMessage;
                    var deviceName = scope.device.name;
                    var deviceSN = scope.device.serialNumber;
                    scope.digitalWidget = { channel: channel, status: currentStatus, image: status.statusImage, input: channelId, deviceName: deviceName, deviceSN: deviceSN, currentVal: String(chArray[channelId - 1]) };

                    var varTime = data.Time;
                    scope.lastUpdateAt = varTime;
                }
            };

            var wsDataReceivedWOD = function (data) {
                if (scope.device.serialNumber === data.SN) {
                    channelId = scope.digitalChannelSelected.channel;
                    if (channelId <= 8) return;
                    var chArray = data.Value.replace(/[[\]]/g, '').split(',');
                    digValue = UpdateValue(chArray[channelId - 9], channelId, scope.nomalState);
                    var status = _convertStatus(digValue, scope.digitalMode, scope.widgetImage);
                    var channel = scope.translation.text.INPUT + " " + channelId + ": " + scope.channelDesc;
                    var currentStatus = scope.translation.text.STATUS + ": " + status.statusMessage;
                    var deviceName = scope.device.name;
                    var deviceSN = scope.device.serialNumber
                    scope.digitalWidget = { channel: channel, status: currentStatus, image: status.statusImage, input: channelId, deviceName: deviceName, deviceSN: deviceSN };

                    var varTime = data.Time;
                    scope.lastUpdateAt = varTime;
                }
            };

            var wsDataReceivedFAULTS = function (data) {
                if (scope.device.serialNumber === data.SN) {
                    var faultBinary;
                    if (isNaN(data.Value)) {
                        faultBinary = data.Value.replace(/[[\]]/g, '').split(',').join('');
                        //console.log(faultBinary);
                    } else {
                        faultBinary = (data.Value >>> 0).toString(2);

                        while (faultBinary.length < 16) {
                            faultBinary = faultBinary.length < 8 ? "0" + faultBinary : faultBinary + "0";
                        }
                    }

                    channelId = scope.digitalChannelSelected.channel;
                    //console.log(faultBinary);
                    //console.log(channelId);
                    if (faultBinary[channelId - 1] === '1') {
                        //console.log('Got a fault for channel: ', channelId);
                        var status = _convertStatus(null, scope.digitalMode, scope.widgetImage);
                        var channel = scope.translation.text.INPUT + " " + channelId + ": " + scope.channelDesc;
                        var currentStatus = scope.translation.text.STATUS + ": " + status.statusMessage;
                        var deviceName = scope.device.name;
                        var deviceSN = scope.device.serialNumber;
                        scope.digitalWidget = { channel: channel, status: currentStatus, image: status.statusImage, input: channelId, deviceName: deviceName, deviceSN: deviceSN };

                        var varTime = data.Time;
                        scope.lastUpdateAt = varTime;
                    }
                }
            }

            scope.mostRecentData = function () {
                toaster.pop('success', 'Digital Widget' + " -- " + scope.device.name, 'View reloading');
                wsReconnectWD();
            }

            var wsReconnectWD = function (data) {
                scope.getDigitalData(scope.digitalDeviceSelectedId.deviceId, scope.digitalChannelSelected.channel);
            };

            scope.getTitle = function () {
                var lastData = _.find(scope.lastData, function (item) { return item.channel === parseInt(scope.digitalChannelSelected.channel, 10); });
                if (!lastData) return;
                var now = new Date();

                if (lastData.regTime !== null) {
                    //return scope.translation.text.INPUT + " " + scope.digitalChannelSelected.channel + ": " + scope.channelDesc + "<br />" + scope.digitalWidget.status + '<br />Duration: ' + (lastData.regTime === '0001-01-01T00:00:00' ? scope.translation.text.UNKNOWN : millisecondsToStr(moment.utc().valueOf() - (lastData.livePoint === true ? moment(lastData.regTime).valueOf() : moment.utc(lastData.regTime).valueOf())));
                    return scope.translation.text.INPUT + " " + scope.digitalChannelSelected.channel + ": " + scope.channelDesc + "<br />" + scope.digitalWidget.status + '<br />Duration: ' + (lastData.regTime === '0001-01-01T00:00:00' ? scope.translation.text.UNKNOWN : millisecondsToStr(moment.utc().valueOf() - moment.utc(lastData.regTime).valueOf()));
                } else {
                    return scope.translation.text.INPUT + " " + scope.digitalChannelSelected.channel + ": " + scope.channelDesc + "<br />" + scope.digitalWidget.status + '<br />Duration: <i class="fa fa-spinner fa-spin" />';
                }
            }

            scope.fetchHoverData = function (digitalGauge) {
                var lastData = _.find(scope.lastData, function (item) { return item.channel === parseInt(scope.digitalChannelSelected.channel, 10); });
                if (angular.isDefined(lastData) && angular.isDefined(lastData.regTime)) {
                    //if (lastData.regTime === null) {
                        digitalGaugeService.getMostRecentData(scope.digitalDeviceSelectedId.deviceId, lastData.channel, scope.accountInfo.timeZone, scope.digitalWidget.currentVal).then(function (resp) {
                            lastData.regTime = resp.data;

                            $timeout(function () {
                                var elements = document.getElementsByClassName('tooltip-jq');
                                for (var i = 0; i < elements.length; i++) {
                                    elements[i].innerHTML = scope.getTitle();
                                }
                            });

                        });
                    //}
                }
                return;
            };

            var UpdateValue = function (Value, Channel, NomalState) {

                var ReturnValue = "0";
                if (Value === String(NomalState))
                    ReturnValue = "1";
                else if (Value === "NULL" || Value === null || Value === "")
                    ReturnValue = null;

                return ReturnValue;
            };

            var _convertStatus = function (statusCode, digitalMode, image) {
                statusMsg = null;
                //Set Default image if none
                image = image ? image : "alarm_1.png";
                switch (statusCode) {
                    default:
                    case "0": //open
                        if (digitalMode === "P")
                            statusMsg = { statusImage: "off_" + image, statusMessage: scope.translation.text.STOPPED };
                        else if (digitalMode === 'D')
                            statusMsg = { statusImage: "open_" + image, statusMessage: scope.translation.text.OPEN };
                        else
                            statusMsg = { statusImage: "open_" + image, statusMessage: scope.translation.text.OPEN };
                        break;
                    case "1": //close
                        if (digitalMode === "P")
                            statusMsg = { statusImage: "run_" + image, statusMessage: scope.translation.text.RUNNING };
                        else if (digitalMode === 'D')
                            statusMsg = { statusImage: "open_" + image, statusMessage: scope.translation.text.OPEN };
                        else
                            statusMsg = { statusImage: "close_" + image, statusMessage: scope.translation.text.CLOSE };
                        break;
                    case "-1": //No Data || No Setup
                        statusMsg = { statusImage: "pixel.png", statusMessage: scope.translation.text.NO_DATA };
                        break;
                    case null: //fault
                    case "":
                        if (digitalMode === "P")
                            statusMsg = { statusImage: "fault_" + image, statusMessage: scope.translation.text.FAULT };
                        else if (digitalMode === 'D')
                            statusMsg = { statusImage: "open_" + image, statusMessage: scope.translation.text.OPEN };
                        else
                            statusMsg = { statusImage: "fault_" + image, statusMessage: scope.translation.text.FAULT };
                        break;
                }
                return statusMsg;
            };


            scope.$on('updateDigitalWidgetImage', function (event, args) {
                if (scope.digitalDeviceSelectedId.deviceId == args.deviceId && scope.digitalChannelSelected.channel == args.channel) wsReconnectWD();
            });

            scope.$on('updateDigitalSetting', function (event, args) {
                if (scope.digitalDeviceSelectedId.deviceId == args.deviceId && scope.digitalChannelSelected.channel == args.channel) wsReconnectWD();
            });

            scope.isTouchSupported = function () {
                var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
                var generalTouchEnabled = "ontouchstart" in document.createElement("div");

                if (msTouchEnabled || generalTouchEnabled) {
                    return true;
                }
                return false;
            };

            scope.replaceSpaces = function (str) {
                return str.replace(/ /g, '_');
            }

            scope.$on('document_click', function (e, event) {
                var $tgt = $(event.target);
                if ($tgt.closest('#digital-widget-' + scope.replaceSpaces(scope.windowId)).length === 0 || ($tgt.closest('.back').length === 0 && $tgt.closest('.front').length === 0)) {

                    if (scope.isTouchSupported()) {
                        scope.popup.parent().find(".front").toggle(true);
                        scope.popup.parent().find(".back").toggle(false);
                    } else {
                        $('#digital-widget-' + scope.replaceSpaces(scope.windowId)).offsetParent().offsetParent().find('.flip-container').toggleClass('flip', false);
                    }

                    scope.setSetting();
                    scope.resizeContent();
                }
            });

            scope.popup.parent().on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            if (scope.popup.parent().is('.ui-draggable-dragging, .ui-resizable-resizing') || event.target.nodeName === 'SELECT') {
                                return;
                            }

                            if (scope.isTouchSupported()) {
                                scope.popup.parent().find(".back").toggle();
                                scope.popup.parent().find(".front").toggle();
                            } else {
                                scope.popup.parent().find('.flip-container').toggleClass('flip');
                            }
                            scope.setSetting();
                            scope.resizeContent();
                        }
                    );
                }
            );

            scope.popup.parent().find("select").on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            );

            scope.popup.parent().on(
                "mouseover",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            scope.popup.parent().addClass("x-resize");
                            //scope.popup.parent().find(".ui-dialog-titlebar-close").css("display", "block");
                            scope.closeIcon = true;
                        }
                    );
                }
            );

            scope.popup.parent().on(
                "mouseout",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            scope.popup.parent().removeClass("x-resize");
                            //scope.popup.parent().find(".ui-dialog-titlebar-close").css("display", "none");
                            if (scope.isTouchSupported()) {
                                setTimeout(function () {
                                    scope.closeIcon = false;
                                }, 3000);
                            }
                            else {
                                scope.closeIcon = false;
                            }
                        }
                    );
                }
            );

            scope.$on(
                "$destroy",
                function (event) {
                    websocketService.unRegister("INPUTS", scope.device.serialNumber, '', wsDataReceivedWD, wsReconnectWD);
                    websocketService.unRegister("OPTIONDIGITAL", scope.device.serialNumber, '', wsDataReceivedWOD, null);
                    websocketService.unRegister("FAULTS", scope.device.serialNumber, '', wsDataReceivedFAULTS, null);
                    _unRegisterListenerDigitalSetting(scope.device.serialNumber,  scope.digitalChannelSelected.channel);
                    scope.popup.parent().off();
                    scope.popup.parent().find("select").off();
                }
            );

            scope.getDigitalData(scope.digitalDeviceSelectedId.deviceId, scope.digitalChannelSelected.channel);
            if (scope.popup.selector !== ".flip-container") scope.popup.dialog("option", "dialogClass", "ui-widget-content-new");
        }

        return {
            restrict: 'A',
            replace: false,
            link: link
        };
    }]);

mcapp.directive('digitalSettingDirective', ["authenticationService", "websocketService", "digitalWidgetService", "deviceService", "toaster",
    function (authenticationService, websocketService, digitalWidgetService, deviceService, toaster) {
        function link(scope, element, attrs) {
            scope.targetField = null;
            scope.getSetting = function () {
                digitalWidgetService.getSettings(scope.accountInfo.customerId)
                    .then(function (result) {
                        scope.digitalDevices = result.data.digitalDevices;
                        scope.digitalSettingsAll = result.data.digitalSettings;

                        for (var i = scope.digitalDevices.length - 1; i >= 0; i--) {

                            if (!scope.hasDigitalSetting(scope.digitalDevices[i].deviceId)) {
                                scope.digitalDevices.splice(i, 1);
                            }
                        }

                        scope.getChannels();
                    }, function (error) {
                    });
            };

            scope.hasDigitalSetting = function (deviceId) {
                for (var i = 0; i < scope.digitalSettingsAll.length; i++) {
                    if (parseInt(deviceId) === scope.digitalSettingsAll[i].deviceId) {
                        return true;
                    }
                }
                return false;
            };

            scope.getChannels = function () {
                scope.digitalChannels = [];
                angular.forEach(scope.digitalSettingsAll, function (digitalSettingsAll) {
                    if (parseInt(scope.digitalDeviceSelectedId.deviceId) === parseInt(digitalSettingsAll.deviceId)) {
                        scope.digitalChannels.push(digitalSettingsAll);
                    }
                });

                if (scope.digitalDeviceSelectedId.deviceId == scope.stickyProperties.device.deviceId) {
                    scope.digitalChannelSelected.channel = scope.stickyProperties.device.channel;
                } else {
                    scope.digitalChannelSelected.channel = scope.digitalChannels[0].channel;
                }
            };

            scope.getSetting();

            scope.getBackToDigitalData = function () {
                if (scope.targetField === "digitalDeviceSelectedId") scope.getChannels();
                scope.getDigitalData(scope.digitalDeviceSelectedId.deviceId, scope.digitalChannelSelected.channel);
                if (scope.targetField === "digitalChannelSelected") {
                    scope.popup.parent().find('.flip-container').toggleClass('flip');
                    if (scope.isTouchSupported()) {
                        scope.popup.parent().find(".back").toggle();
                        scope.popup.parent().find(".front").toggle();
                    }
                }
                scope.resizeContent();
            };

            scope.focusCallback = function ($event) {
                if ($event.target === null) {
                    return;
                }
                scope.targetField = $($event.target).attr("ng-model");
            };

        }
        return {
            link: link
        };
    }
]);

mcapp.factory("digitalWidgetService", ["$http", "HOST", function ($http, HOST) {
    var digitalWidgetFatory = {};


    var _getSettings = function (customerId, isPumpWidget) {

        if (isPumpWidget === undefined || isPumpWidget === null) isPumpWidget = false;

        return $http({
            method: 'Get',
            url: HOST + '/api/DigitalWidget?customerId=' + customerId + '&isPumpWidget=' + isPumpWidget,
            cache: false
        });
    };
    digitalWidgetFatory.getSettings = _getSettings;
    return digitalWidgetFatory;

}]);
mcapp.controller('digitalTableController', ['$scope', '$rootScope', 'sharedSetupService', 'openViewService', 'translationService', 'detectBrowserService', '$element', 'authenticationService', '$timeout', '$window', function ($scope, $rootScope, sharedSetupService, openViewService, translationService, detectBrowserService, $element, authenticationService, $timeout, $window) {
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.alerts = [];
    $scope.hideLegend = false;
    $scope.curentBrowser = detectBrowserService();
    $scope.downloadViewTypeOptions = [0, 4];
    if (/Edge\/\d./i.test(navigator.userAgent)) {
      $scope.isEdge = true;
    }

    $scope.isFF = !!navigator.userAgent.match(/firefox/i);
    sharedSetupService.getWindowId($scope);
    $scope.getScrollOffset = function () {
      if ($scope.isEdge) {
        return 12;
      }

      return 18;
    }

    sharedSetupService.broadcastAllDeviceSelected($scope);

    $scope.liveTable = $element.find(".headertable");//$element.find(".digital-table-header");

    $scope.liveDataLine = function (varLiveData) {
        if (varLiveData) {
            $scope.liveTable.addClass("live-data-line");
        } else {
            $scope.liveTable.removeClass("live-data-line");
        }
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
    });

    $scope.getDigitalHeaderWidth = function (num) {
      if (num < 3) return 3 * ($scope.mobile ? 4.5 : 4.2) + '%';
      return num * ($scope.mobile ? 4.5 : 4.2) + '%';
    }

    $scope.getRelayHeaderWidth = function (num) {
      if (num == 1) return 2 * ($scope.mobile ? 4.5 : 4.2) + '%';
      return num * ($scope.mobile ? 4.5 : 4.2) + '%';
    }

    $scope.getDigitalWidth = function (num) {
      if (num < 3) {
        var totalSpace = 3 * ($scope.mobile ? 4.5 : 4.2);
        return (totalSpace / num) + '%';
      }
      return $scope.mobile ? '4.5%' : '4.2%';
    }

    $scope.getRelayWidth = function (num) {
      if (num == 1)
        return $scope.mobile ? '9%' : '8.4%';
      return $scope.mobile ? '4.5%' : '4.2%';
    }

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);
        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
				openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            // $scope.popup.parent().find('.digital-body').css('height', $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 30 - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 35);
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            // $scope.adjustDeviceIdMenuSize();
        };

        $timeout(function () {
          // $scope.adjustSize();
        });

        $scope.adjustDeviceIdMenuSize = function () {
            var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")
            if (spph < 450) {
                $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            }
            else {
                $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        };
    } else if ($rootScope.classicView) {
      $(document).find('.tabular-data-container-mobile').css('height', $(document).find('.content-classic').css('height').replace(/[^0-9.]+/g, "") - 150);

      angular.element($window).bind('resize', function () {
        $(document).find('.tabular-data-container-mobile').css('height', $(document).find('.content-classic').css('height').replace(/[^0-9.]+/g, "") - 134);
      });

      $scope.$watch(function () { if ($scope.digitalTableService) return $scope.digitalTableService.items.length; return false; }, function () {
        $timeout(function () {
          $(document).find('.tabular-data-container-mobile').css('height', $(document).find('.content-classic').css('height').replace(/[^0-9.]+/g, "") - 134);
        }, 200);
      });
      // $scope.popup.parent().find('.digital-body').css('height', $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 30 - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 35);
    } else if ($rootScope.mobile) {
      $(document).find('.digital-body').css('height', $(document).find('.content-mobile').css('height').replace(/[^0-9.]+/g, "") - 116);

      angular.element($window).bind('orientationchange', function () {
        $timeout(function () {
          $(document).find('.digital-body').css('height', $(document).find('.content-mobile').css('height').replace(/[^0-9.]+/g, "") - 116);
        });
      });
    }

    $scope.setHideLegend = function ($event) {
      $scope.position = $('#digital_key_' + $scope.replaceSpaces($scope.windowId)).position().left + $('#digital_key_' + $scope.replaceSpaces($scope.windowId)).width() - 160;
      $scope.hideLegend = !$scope.hideLegend;
    };

    $scope.getWindowId = function () {
      if ($scope.windowId)
        return $scope.windowId.replace(" ", "_");
      return "";
    }

    $scope.replaceSpaces = function (str) {
      if (str) {
        return str.replace(new RegExp(' ', 'g'), '_');
      }

      return '';
    };

    $scope.hasOverflow = function () {
      if ($rootScope.classicView) {
        return true;
      }

      var element = document.getElementById('digital-table-' + $scope.replaceSpaces($scope.windowId));
      if (!element || $rootScope.mobile) {
        return false;
      }

      if (element.offsetHeight < element.scrollHeight)
        return true;
      return false; 
    }
}]);

mcapp.directive('drawDigitalData', ['$rootScope', '$timeout', 'digitalTableService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'openViewService', 'deviceMenuService', 'debounceService', '$q',
    function ($rootScope, $timeout, digitalTableService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, openViewService, deviceMenuService, debounceService, $q) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        scope.trgScroll = function() {
            $timeout(function() {
                    var $rowFirst = element.find("tr:first");
                    var _firstRow = $rowFirst.attr("name");
                    if (typeof $rowFirst.position() !== "undefined") {
                        var _tableTop = element.offset().top;
                        var _rowTop = $rowFirst.offset().top;
                        _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 10));
                    }
                },
                0);
        };

        scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
          if (scope.alerts.length > 0) {
            var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
            var _type = scope.alerts[0].type;
            var _languageCode = scope.alerts[0].languageCode;
            if (_languageCode.toUpperCase() === 'NO_DATA') {
              _msg += ': ' + moment(scope.digitalTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.digitalTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
            }
            scope.alerts = [];
            scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
          }
        });

        element.on('scroll', function (event) {
            var $rowFirst = element.find("tr:first");
            var $rowLast = element.find("tr:last");
            if (typeof $rowFirst.position() !== "undefined") {
                scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
                scope.trgScroll();
                previousScrollbarPosition = currentScrollbarPosition;
                currentScrollbarPosition = element[0].scrollTop;
            }

            if (scope.infiniteScrollOn === true) {
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;

                if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
                    $rowLast.addClass("active-row");
                    scope.digitalTableService.alerts = [];
                    scope.digitalTableService.nextPage();
                    scope.m110Runtime = ( scope.digitalTableService.deviceType === 8 || scope.digitalTableService.deviceType === 17 || scope.digitalTableService.deviceType === 18) ? true : false;
                }
                if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 5) && currentScrollbarPosition < previousScrollbarPosition) {
                    $rowFirst.addClass("active-row");
                    scope.digitalTableService.alerts = [];
                    scope.digitalTableService.previousPage();
                    scope.m110Runtime = ( scope.digitalTableService.deviceType === 8 ||  scope.digitalTableService.deviceType === 17 || scope.digitalTableService.deviceType === 18) ? true : false;
                }
            }

            var rows = element.children().children().children().children();
            var scrollpos = 40;
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos)
                    start = mid + 1;
                else
                    end = mid;
            }
            _updateZoom(parseFloat($($(rows[start])).attr("name")));
        });

        var _updateZoom = function (currentRow) {
            if (isNaN(currentRow))
                return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            }
            else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.getDeviceType = function(deviceId) {
            deviceMenuService.getDeviceMenuList(scope.accountInfo.customerId)
                .then(function(result) {
                        var _devices = result.data.devices;

                        for (var index = 0; index < _devices.length; ++index) {
                            if (_devices[index].deviceId === deviceId) {
                                scope.m110Runtime =
                                    _devices[index].model === 8 || _devices[index].model === 17 || _devices[index].model === 18 ? true : false;
                                break;
                            }
                        }
                    },
                    function(error) {
                        scope.m110Runtime = false;
                    });
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('digitalTableService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        scope.newDigitalTableServiceService = function () {
            scope.digitalTableService = new digitalTableService();
            scope.digitalTableService.customerId = scope.accountInfo.customerId;
            scope.digitalTableService.timeZone = scope.accountInfo.timeZone;
            scope.digitalTableService.deviceId = scope.deviceSelected;
            scope.digitalTableService.windowTitle = scope.windowTitle;
            scope.digitalTableService.startRow = 1;
            scope.digitalTableService.pageSize = 50;
            scope.digitalTableService.alerts = [];
        };

        var _openTableInLiveMode = function () {
            scope.stickyProperties.on = false;
            timeLapseService.getLocalDateTime().then(function (result) {
                /////////////////////////////////////////////////////////////
                var tmpDates = new Date(result.data.localDateTime);
                var tmpDatesA = tmpDates;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                tmpDatesA.setHours(23, 59, 59, 0);
                tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
                /////////////////////////////////////////////////////////////
                scope.newDigitalTableServiceService();
                scope.digitalTableService.start = tmpDates.startDate;
                scope.digitalTableService.end = tmpDatesA;
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
                scope.digitalTableService.nextPage();
                scope.m110Runtime = ( scope.digitalTableService.deviceType === 8 ||  scope.digitalTableService.deviceType === 17 || scope.digitalTableService.deviceType === 18) ? true : false;
                /////////////////////////////////////////////////////////////
            });
        };

        var wsDataReceivedDIGITALSETTINGDT = function (data) {
            if (data.Type == 'DIGITALSETTING' && data.SN == scope.deviceSelectedSn) {
                $timeout(function () {
                    scope.digitalTableService.startRow = 1
                    scope.digitalTableService.items = []
                    scope.digitalTableService.nextPage();
                }, 200);
            }
        };

        var _registerListenerDigitalSetting = function () {
            //subscribe for digital setting changes
            websocketService.connect();
            for (var i = 1; i <= 8; i++) {
                websocketService.register("DIGITALSETTING", scope.deviceSelectedSn, i, wsDataReceivedDIGITALSETTINGDT, null);
             }
        };
        var _unRegisterListenerDigitalSetting = function (varSerialNum) {
            websocketService.connect();
            for (var i = 1; i <= 8; i++) {
                websocketService.unRegister("DIGITALSETTING", varSerialNum, i, wsDataReceivedDIGITALSETTINGDT, null);
             }
        };

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                /////////////////////////////////////////////////////////////
                currentScrollbarPosition = 0;
                previousScrollbarPosition = 0;
                scope.checkFirstRowLiveStatus = null;
                /////////////////////////////////////////////////////////////
                scope.alerts = [];
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });

                //Register for digital setting changes
                _registerListenerDigitalSetting();

                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMin !== null) {
                    scope.stickyProperties.on = true;
                    timeLapseService.getLocalDateTime().then(function (result) {
                        if (scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && scope.stickyProperties.zoomMax + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                            scope.newDigitalTableServiceService();
                            scope.digitalTableService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
                            scope.digitalTableService.end = scope.stickyProperties.dateMax;
                            scope.digitalTableService.nextPage();
                            scope.m110Runtime = ( scope.digitalTableService.deviceType === 8 ||  scope.digitalTableService.deviceType === 17 || scope.digitalTableService.deviceType === 18) ? true : false;
                        }
                        else {
                            scope.newDigitalTableServiceService();
                            scope.digitalTableService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
                            scope.digitalTableService.end = Math.round((scope.stickyProperties.zoomMax + scope.stickyProperties.zoomMin) / 2);
                            scope.digitalTableService.nextPage();
                            scope.m110Runtime = ( scope.digitalTableService.deviceType === 8 ||  scope.digitalTableService.deviceType === 17 || scope.digitalTableService.deviceType === 18) ? true : false;
                        }
                    });
                }
                else {
                    _openTableInLiveMode();
                }

                scope.getDeviceType(newValue);
            }
        }, true);

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.stickyProperties.device.serialNumber = newValue;
                if (oldValue) {
                    _unRegisterListener(oldValue);
                    _unRegisterListenerDigitalSetting(oldValue);
                }
            }
        }, true);

        scope.selectMyDate = function (date) {
            scope.myDate = date;
            scope.alerts = [];
            scope.digitalTableService = new digitalTableService();
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            _unRegisterListener(scope.deviceSelectedSn);
            /////////////////////////////////////////////////////////////
            //var tmpDates = scope.myDate;
            var tmpDates = new Date(scope.myDate.getTime());
            tmpDates.setDate(tmpDates.getDate() + 1);  // add 1 day
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            tmpDatesA.setHours(0, 0, 0, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            scope.digitalTableService.start = tmpDates.startDate;
            if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                scope.digitalTableService.end = tmpDatesA;
            }
            else {
                scope.digitalTableService.end = tmpDates.endDate;
            }
            /////////////////////////////////////////////////////////////
            scope.digitalTableService.startRow = 1;
            scope.digitalTableService.pageSize = 50;
            scope.digitalTableService.customerId = scope.accountInfo.customerId;
            scope.digitalTableService.timeZone = scope.accountInfo.timeZone;
            scope.digitalTableService.deviceId = scope.deviceSelected;
            scope.digitalTableService.windowTitle = scope.windowTitle;
            scope.digitalTableService.alerts = [];
            scope.digitalTableService.nextPage();
            scope.m110Runtime = ( scope.digitalTableService.deviceType === 8 ||   scope.digitalTableService.deviceType === 17 || scope.digitalTableService.deviceType === 18) ? true : false;
            /////////////////////////////////////////////////////////////
            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });

        };

        var _getLocalDateTime = function (firstRow, topOffset) {
            var deferred = $q.defer();
            timeLapseService.getLocalDateTime().then(function (result) {
                if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                    scope.checkFirstRowLiveStatus = true;
                    _checkTopOffset(topOffset);
                }
                else {
                    scope.checkFirstRowLiveStatus = false;
                }
                deferred.resolve(true);
            });
            return deferred.promise;
        };

        scope.getLocalDateTimeDebounced = debounceService(_getLocalDateTime, 200, false);

        var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {

            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            }
            else if (scope.checkFirstRowLiveStatus === null) {
                var _returned = scope.getLocalDateTimeDebounced(firstRow, liveDataStatusOn);
                //console.log('Log: ', _returned);
                //_returned.then(function (value) {
                //    console.log('Resolved:', value);
                //});
            }
        };

        var _checkTopOffset = function (liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListener(scope.deviceSelectedSn);
            }
            else {
                _unRegisterListener(scope.deviceSelectedSn);
            }
        };
        var wsDataReceivedDICHTABLE = function (data) {
            var i = 0;
            var _recordExistAtIndex = null;
            var Values = [];
              if (scope.liveData === false) {
                  _unRegisterListener(scope.deviceSelectedSn);
                  return;
              }
  
              var varTime = datetimeService.socketStrToServerStrTime(data.Time);
              var chValue = data.Value;
              var channel = parseInt(data.CH);
              var ds = scope.digitalTableService.digitalSettings;
              scope.digitalTableService.end = datetimeService.toUnixtime(data.Time) + scope.unixDay;
  
              for (i = 0; i < scope.digitalTableService.items.length; i++) {
                if (scope.digitalTableService.items[i].localTime === varTime) {
                  _recordExistAtIndex = i;
                  break;
                }
              }
  
              if (_recordExistAtIndex !== null) {
                //console.log('New row in input at: ' + varTime);
                for (var i = 0; i < ds.length; i++) {
                    if(ds[i].channel == channel)
                    {
                        var value = UpdateValue(chValue, ds[i].channel, ds[i].normalClosed, scope.deviceSelectedType);
                        scope.digitalTableService.items[_recordExistAtIndex].values[i] = value;
                    }
                  }
              } else {
                //console.log('Existing row for input at: ' + varTime);
                for (var i = 0; i < ds.length; i++) {
                 var valueNew = (ds[i].channel == channel) ? UpdateValue(chValue, ds[i].channel, ds[i].normalClosed, scope.deviceSelectedType) : scope.digitalTableService.items[0].values[i];
                  Values.push(valueNew);
                }
  
                var ry = scope.digitalTableService.relaySettings;
                // Since this was an INPUTS event, we should just pull over the relay values from the previous row since they weren't changed by this event.
                for (var i = 0; i < ry.length; i++) {
                  Values.push(scope.digitalTableService.items[0].values[ds.length + i]);
                }
                var _newRecord = { localTime: varTime, values: Values };
                scope.digitalTableService.items.unshift(_newRecord);
              }
              //console.log("Digital Items", scope.digitalTableService.items);
              scope.lastUpdateAt = varTime;
          };

        var wsDataReceivedODITABLE = function (data) {
          var i = 0;
          var _recordExistAtIndex = null;
          if (scope.liveData === false) {
            _unRegisterListener(scope.deviceSelectedSn);
            return;
          }

          var varTime = datetimeService.socketStrToServerStrTime(data.Time);
          var Values = ['C', 'C', 'C', 'C', 'C', 'C', 'C', 'C'];
          //convert 0,1,0,0,.. to array
          var chArray = data.Value.replace(/[[\]]/g, '').split(',');
          var ds = scope.digitalTableService.digitalSettings;

          for (i = 0; i < scope.digitalTableService.items.length; i++) {
            if (scope.digitalTableService.items[i].localTime === varTime) {
              _recordExistAtIndex = i;
              break;
            }
          }

          if (_recordExistAtIndex !== null) {
            //console.log('New row in input at: ' + varTime);
            for (var i = 0; i < ds.length; i++) {
              if (ds[i].channel <= 8) continue;
              var value = UpdateValue(chArray[parseInt(ds[i].channel) - 9], ds[i].channel, ds[i].normalClosed, scope.deviceSelectedType);
              scope.digitalTableService.items[_recordExistAtIndex].values[i] = value;
            }
          } else {
            //console.log('Existing row for input at: ' + varTime);
            for (var i = 0; i < ds.length; i++) {
              if (ds[i].channel <= 8) continue;
              var value = UpdateValue(chArray[parseInt(ds[i].channel) - 9], ds[i].channel, ds[i].normalClosed, scope.deviceSelectedType);
              Values.push(value);
            }

            var ry = scope.digitalTableService.relaySettings;
            // Since this was an INPUTS event, we should just pull over the relay values from the previous row since they weren't changed by this event.
            for (var i = 0; i < ry.length; i++) {
              Values.push(scope.digitalTableService.items[0].values[ds.length + i]);
            }
            _newRecord = { localTime: varTime, values: Values };
            scope.digitalTableService.items.unshift(_newRecord);
          }

          scope.lastUpdateAt = varTime;
        };

        var wsDataReceivedDIOutputs = function(data) {
            var DOValue = data.Value;
            var DOCh = parseInt(data.CH);
            var ry = scope.digitalTableService.relaySettings;
            if (ry.length === 0 || DOCh > 9) return;
            var i = 0;
            var Values = [];
            var _recordExistAtIndex = null;
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }
            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            var ds = scope.digitalTableService.digitalSettings;

            for (i = 0; i < scope.digitalTableService.items.length; i++) {
                if (scope.digitalTableService.items[i].localTime == varTime) {
                    _recordExistAtIndex = i;
                    break;
                }
            }
            if (_recordExistAtIndex !== null) {
                if(scope.digitalTableService.items[_recordExistAtIndex].values.length >= (ds.length + DOCh) && DOCh < 10)
                {
                    scope.digitalTableService.items[_recordExistAtIndex].values[ds.length + (DOCh - 1)] = UpdateValueDO(DOValue);
                }
            } else {
                // Since this was a RELAYS event, we should just pull over the input values from the previous row since they weren't changed by this event.
                for (var i = 0; i < ds.length; i++) {
                    Values.push(scope.digitalTableService.items[0].values[i]);
                }
                for (var i = 0; i < ry.length; i++) {
                   Values.push(scope.digitalTableService.items[0].values[ds.length + i]);
                }
                if(scope.digitalTableService.items[0].values.length >= (ds.length + (DOCh - 1)) && DOCh < 10)
                {
                    Values[ds.length + (DOCh - 1)] = UpdateValueDO(DOValue);
                }
                _newRecord = { localTime: varTime, values: Values };
                scope.digitalTableService.items.unshift(_newRecord);
            }
            scope.lastUpdateAt = varTime;
        };

        var wsDataReceivedFAULTS = function (data) {
          var i = 0;
          var _recordExistAtIndex = null;
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            //convert 0,1,0,0,.. to array
            var ds = scope.digitalTableService.digitalSettings;
            var faultBinary;
            if (isNaN(data.Value)) {
              faultBinary = data.Value.replace(/[[\]]/g, '').split(',').join('');
            } else {
              faultBinary = (data.Value >>> 0).toString(2);
              while (faultBinary.length < 16) {
                 faultBinary = faultBinary.length < 8 ? "0" + faultBinary : faultBinary + "0";
              }
            }

            for (i = 0; i < scope.digitalTableService.items.length; i++) {
              if (scope.digitalTableService.items[i].localTime == varTime) {
                _recordExistAtIndex = i;
                break;
              }
            }

            if (_recordExistAtIndex !== null) {
              for (var i = 0; i < ds.length; i++) {
                if (faultBinary[ds[i].channel - 1] === '1') {
                  scope.digitalTableService.items[_recordExistAtIndex].values[i] = 'F';
                }
              }
            }
        };        

        scope.$on('processReconnect', function (event, args) {
            scope.reconnectData(event, args);
        });

        scope.reconnectData = function (event, args) {
            sharedSetupService.processReconnect({
                stickyProperties: scope.stickyProperties,
                localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
                dateRangeOption: null,
                windowTitle: scope.windowTitle,
                fnUnregister: _unRegisterListener,
                fnGetData: _openTableInLiveMode,
                viewType: "Table"
            });            
        };

        scope.mostRecentData = function (event, args) {
            scope.stickyProperties.liveData = true;
            scope.myDate = null;
            scope.reconnectData(event, args);
        };

        var _registerListener = function (varSelectedSN) {
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
            if (scope.liveData === true)
                return;
            scope.liveData = true;
            scope.liveDataLine(scope.liveData);
            scope.digitalTableService.numberOfNewRecordsPrevious = -1;
            websocketService.connect();

            websocketService.register("DIGITALINPUT", varSelectedSN, '', wsDataReceivedDICHTABLE, null);
            websocketService.register("OPTIONDIGITAL", varSelectedSN, '', wsDataReceivedODITABLE, null);
            websocketService.register("FAULTS", varSelectedSN, '', wsDataReceivedFAULTS, null);
            websocketService.register("DIGITALOUTPUT", varSelectedSN, '', wsDataReceivedDIOutputs, null);
        };

        var _unRegisterListener = function (varSelectedSN) {
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
            if (scope.liveData === false)
                return;
            scope.liveData = false;
            scope.liveDataLine(scope.liveData);
            scope.lastUpdateAt = undefined;
            websocketService.unRegister("DIGITALINPUT", varSelectedSN, '', wsDataReceivedDICHTABLE, null);
            websocketService.unRegister("OPTIONDIGITAL", varSelectedSN, '', wsDataReceivedODITABLE, null);
            websocketService.unRegister("FAULTS", varSelectedSN, '', wsDataReceivedFAULTS, null);
            websocketService.unRegister("DIGITALOUTPUT", varSelectedSN, '', wsDataReceivedDIOutputs, null);
        };

        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll();
            scope.checkFirstRowLiveStatus = null;
            scope.trgScroll();
        });

        var _autoScroll = function () {
            if (scope.digitalTableService.numberOfNewRecordsPrevious > 0) {
                var trRow = element.find('tr').eq(0)[0];
                var yPosition = scope.digitalTableService.numberOfNewRecordsPrevious * (trRow.scrollHeight > 0 ? trRow.scrollHeight : 24);
                element.scrollTop(yPosition);
            }
            else {
                $timeout(function () {
                    element.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        var UpdateValue = function (Value, Channel, NomalState, deviceModel) {
            return UpdateDIValue(Value); 
        };

        var UpdateDIValue = function (Value) {
            if (Value === "null" || Value == "-1")//falut
                ReturnValue = "F";
            if (Value === "1")
                ReturnValue = "O";
            else if (Value === "0")
                ReturnValue = "C";
            else
                ReturnValue = "F";
            return ReturnValue;
        };

        var UpdateValueDO = function (Value) {
            if (Value === "null" || Value == "-1")//falut
                ReturnValue = "F";
            if (Value === "0")
                ReturnValue = "O";
            else if(Value === "1")
                ReturnValue = "C";
            else
               ReturnValue = "F";
            return ReturnValue;
        };

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
            _unRegisterListenerDigitalSetting(scope.deviceSelectedSn);
        });
    };
}]);

mcapp.factory('digitalTableService', ['$rootScope', '$http', 'datetimeService', 'translationService', '$sce', 'HOST', '$timeout', function ($rootScope, $http, datetimeService, translationService, $sce, HOST, $timeout) {
    var digitalTableService = function () {
        this.items = [];
        this.digitalSettings = [];
        this.relaySettings = [];
        this.deviceName = '';
        this.customerId = null;
        this.deviceId = null;
        this.timeZone = "Z";
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.tdWidth = null;
        this.digitalNumber = 0;
        this.relayNumber = 0;
        this.showRelay = false;
        this.showDigital = false;
        this.hasDigital = false;
        this.alerts = [];
        this.translation = translationService.translation;
        this.scrollUp = "";
        this.scrollDown = "";
        this.deviceType = null;
        this.hasMydroExpansion = false;
    };

    digitalTableService.prototype.previousPage = function () {
      var intDayWindow = 10;
      var intDay = 86400000;
        this.alerts = [];
        if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
        this.busy = true;
        this.pageSize = -50;

        if (this.items.length > 0) {
            var tmpEndDate = datetimeService.toUnixtimeMs(this.items[0].localTime.replace(/\D/g, ''));
            this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localTime.replace(/\D/g, '')) - (intDayWindow * intDay);
            this.end = this.end > tmpEndDate ? this.end : tmpEndDate;
        }

        //from is: very top record
        var url = HOST + '/api/Digital?timeZone=' + this.timeZone + '&deviceId=' + this.deviceId + '&customerId=' + this.customerId + '&startDate=' + this.start + '&endDate=' + this.end + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&fromDate=" + this.scrollUp;
        $http.get(url).then(function (result) {
            /////////////////////////

            var intDayWindow = 10;
            var intDay = 86400000;
            /////////////////////////
            var deviceName = result.data.device.name;
            this.deviceType =  result.data.device.model;
            this.hasMydroExpansion =  result.data.device.hasMydroExpansion;
            this.digitalSettings = result.data.digitalSettings;
            this.relaySettings = result.data.relaySettings;
            this.digitalNumber = result.data.digitalSettings.length;
            this.relayNumber = result.data.relaySettings.length;
            if (this.digitalNumber > 0 || this.relayNumber > 0)
                this.hasDigital = true;
            else {
                this.alerts = [];
                this.alerts.push({ msg: this.translation.message.DIGITAL_SETUP_INCOMPLETE, type: "info" });
                return;
            }

            if (this.relayNumber > 0)
                this.showRelay = true;

            if (this.digitalNumber > 0) this.showDigital = true;

            var digitalNum = this.digitalNumber < 3 ? 3 : this.digitalNumber;
            var digitalWidth = digitalNum * ($rootScope.mobile ? 4.5 : 4.2);
            var relayWidth = 0;
            if (this.relayNumber == 1) relayWidth = ($rootScope.mobile ? 9 : 8.4);
            if (this.relayNumber > 1) relayWidth = this.relayNumber * ($rootScope.mobile ? 4.5 : 4.2);
            this.tdWidth =  this.digitalNumber > 8 ? (130 - (digitalWidth + relayWidth)) : (100 - (digitalWidth + relayWidth));

            // this.items = items.concat(this.items);
            var items = result.data.digitalData;

            var timeToCompare = this.items.length > 0 ? this.items[this.items.length - 1].localTime : null;
            //Data is sorted and grouped in Mc.Services and the following
            //will take care off NOT adding duplicates to the table if any
            //returned from Mc.Services (Degital with 9 channels will have some!)
            for (var j = 0; j < items.length; j++) {
                if (timeToCompare == null || items[j].localTime < timeToCompare)
                    this.items.push(items[j]);
            }

            this.numberOfNewRecordsPrevious = items.length;
            this.numberOfRecords = this.items.length;

            this.deviceName = deviceName;
            this.startRow = this.startRow + items.length;


            for (var j = 0; j < items.length; j++) {
                this.items.unshift(items[j]);
            }
            if (items.length > 0 || this.items.length > 0) { //if there are records returned
                var tmpEndDate = datetimeService.toUnixtimeMs(this.items[0].localTime.replace(/\D/g, ''));
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = this.end > tmpEndDate ? this.end : tmpEndDate;
            }
            else {
                this.alerts = [];
                var errorMessage = "No data available";
                this.alerts.push({ msg: errorMessage, type: "info" });
            }

            if (this.items.length > 0) {
                this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].localTime.replace(/\D/g, ''));
                this.scrollDown = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localTime.replace(/\D/g, ''));
            } else {
                this.scrollUp = "";
                this.scrollDown = "";
            }
            
            this.pageSize = 50;
            var _this = this;
            this.fn = $timeout(function () { _this.busy = false; }, 1000);
        }.bind(this),
        function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({ msg: errorMessage, type: "danger" });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };

    digitalTableService.prototype.nextPage = function () {
      var intDayWindow = 10;
      var intDay = 86400000;
        this.alerts = [];
        if (this.busy || this.numberOfReturnedRecords === 0) return;
        this.busy = true;

        if (this.items.length > 0) {
            var tmpEndDate = datetimeService.toUnixtimeMs(this.items[0].localTime.replace(/\D/g, ''));
            this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localTime.replace(/\D/g, '')) - (intDayWindow * intDay);
            this.end = this.end > tmpEndDate ? this.end : tmpEndDate;
        }

        //from is: very bottom record
        var url = HOST + '/api/Digital?timeZone=' + this.timeZone + '&deviceId=' + this.deviceId + '&customerId=' + this.customerId + '&startDate=' + this.start + '&endDate=' + this.end + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&fromDate=" + this.scrollDown;
        $http.get(url).then(function (result) {
            /////////////////////////
            var intDayWindow = 10;
            var intDay = 86400000;
            this.alerts = [];
            /////////////////////////
            var deviceName = result.data.device.name;
            this.deviceType =  result.data.device.model;
            this.hasMydroExpansion =  result.data.device.hasMydroExpansion;
            this.digitalSettings = result.data.digitalSettings;
            this.relaySettings = result.data.relaySettings;
            this.digitalNumber = result.data.digitalSettings.length;
            this.relayNumber = result.data.relaySettings.length;
            var items = result.data.digitalData;
            this.items = this.items.concat(items);
            if(this.deviceType  == 21)
            {
                this.items = this.items.filter(function(value, index, self) {
                    return self.indexOf(value) === index;
                });
            }
            if (this.digitalNumber > 0 || this.relayNumber > 0)
                this.hasDigital = true;
            else{
                this.alerts = [];
                this.alerts.push({ msg: this.translation.message.DIGITAL_SETUP_INCOMPLETE, type: "info" });
                this.busy = false;
                return;
            }

            if (this.relayNumber > 0)
                this.showRelay = true;

            if (this.digitalNumber > 0) this.showDigital = true;

            var digitalNum = this.digitalNumber < 3 ? 3 : this.digitalNumber;
            var digitalWidth = digitalNum * ($rootScope.mobile ? 4.5 : 4.2);
            var relayWidth = 0;
            if (this.relayNumber == 1) relayWidth = ($rootScope.mobile ? 9 : 8.4);
            if (this.relayNumber > 1) relayWidth = this.relayNumber * ($rootScope.mobile ? 4.5 : 4.2);
            this.tdWidth =  this.digitalNumber > 8 ? (130 - (digitalWidth + relayWidth)) : (100 - (digitalWidth + relayWidth));
            
            var timeToCompare = this.items.length > 0 ? this.items[this.items.length - 1].localTime : null;
            //Data is sorted and grouped in Mc.Services and the following
            //will take care off NOT adding duplicates to the table if any
            //returned from Mc.Services (Degital with 9 channels will have some!)
            for (var j = 0; j < items.length; j++) {
                if (timeToCompare == null || items[j].localTime < timeToCompare)
                    this.items.push(items[j]);
            }

            this.numberOfReturnedRecords = items.length;
            this.deviceName = deviceName;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) { //if there are records returned
                var tmpEndDate = datetimeService.toUnixtimeMs(this.items[0].localTime.replace(/\D/g, ''));
                this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = this.end > tmpEndDate ? this.end : tmpEndDate;
            }
            else {
                // If we didn't get any items back AND there aren't already any items
                if (this.items.length === 0) {
                    this.alerts = [];
                    var errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                    this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            }

            if (this.items.length > 0) {
                this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].localTime.replace(/\D/g, ''));
                this.scrollDown = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localTime.replace(/\D/g, ''));
            } else {
                this.scrollUp = "";
                this.scrollDown = "";
            }

            this.pageSize = 50;
            var _this = this;
            this.fn = $timeout(function () { _this.busy = false; }, 1000);
        }.bind(this),
        function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({ msg: errorMessage, type: "danger" });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this)); 
    };

    digitalTableService.prototype.getBackground = function (parentIndex, index) {
      if (this.items[parentIndex]) {
        if (this.items[parentIndex].values[index] === "F")
            return "#e75a5a";
        if (parentIndex < this.items.length - 1) {
            if (this.items[parentIndex].values[index] !== this.items[parentIndex + 1].values[index])
                return "#e9ecf0";
        }
         return "";
      }
      return "";
    }
    digitalTableService.prototype.getIcon = function (input) {
        switch (input) {
            case "C":
                return $sce.trustAsHtml('<i class="fa fa-circle"></i>');
            case "O":
                return $sce.trustAsHtml('<i class="fa fa-circle-thin"></i>');
            case "U":
                return $sce.trustAsHtml('<i class="fa fa-minus-square-o"></i>');
            case "F":
                return $sce.trustAsHtml('<i class="fa fa-times-circle-o"></i>');
        }
        return "";
    }
    return digitalTableService;
}]);

mcapp.controller("digitalGaugeController", ["$scope", "$rootScope", "authenticationService", "translationService", "sharedSetupService", "openViewService",
    function ($scope, $rootScope, authenticationService, translationService, sharedSetupService, openViewService) {
        $scope.Time = null;
        $scope.digitalSettings = null;
        $scope.digitalGauges = [];
        $scope.translation = translationService.translation;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.downloadViewTypeOptions = [0];
        $scope.uniqueWebID = $rootScope.uniqueWebID;
        sharedSetupService.getWindowId($scope);
        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);
            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                	$scope.adjustSize();
                },
                restore: function (event, ui) {
					openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.digital-gauge-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 20);
                //$scope.adjustDeviceIdMenuSize();
            };

            $scope.adjustDeviceIdMenuSize = function () {
                var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")
                if (spph < 450) {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
                }
                else {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
                }
            };
        }

        $scope.isPc3000InAlarm = function () {
            if (!$scope.isPc3000) return; //this is set in rtu-view-module.js (PC-3000x)
            for (var i = 0; i < $scope.digitalGauges.length; i++) {
                if ($scope.digitalGauges[i].input > 8 && ($scope.digitalGauges[i].image).indexOf("close_alarm") > -1) { //&& $scope.digitalGauges[i].digitalMode === "A"
                    $scope.pc3000InAlarm = true;
                    return;
                }
            }
            $scope.pc3000InAlarm = false;
        };
    }]);
mcapp.directive('digitalGaugeDirective', ["authenticationService", "websocketService", "digitalGaugeService", "datetimeService", "toaster", "openViewService", "$sce", "sharedSetupService", "$timeout",
    function (authenticationService, websocketService, digitalGaugeService, datetimeService, toaster, openViewService, $sce, sharedSetupService, $timeout) {
        function link(scope, element, attrs) {

            var accountInfo = authenticationService.getAccountInfo();
            if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

            var millisecondsToStr = function (milliseconds) {
                // TIP: to find current time in milliseconds, use:
                // var  current_time_milliseconds = new Date().getTime();

                function numberEnding(number) {
                    return (number > 1) ? 's' : '';
                }

                var temp = Math.floor(milliseconds / 1000);
                var years = Math.floor(temp / 31536000);
                if (years) {
                    return years + ' ' + scope.translation.text.YEAR + numberEnding(years);
                }
                //TODO: Months! Maybe weeks?
                var days = Math.floor((temp %= 31536000) / 86400);
                if (days) {

                    temp = temp - days * 86400;
                    var rhours = Math.floor((temp %= 86400) / 3600);
                    if (rhours > 0)
                        return days + ' ' + scope.translation.text.DAY + numberEnding(days) + ' ' + rhours + ' ' + scope.translation.text.HOUR + numberEnding(rhours);
                    else
                        return days + ' ' + scope.translation.text.DAY + numberEnding(days);
                }
                var hours = Math.floor((temp %= 86400) / 3600);
                if (hours) {
                    temp = temp - hours * 3600;
                    var rminutes = Math.floor((temp %= 3600) / 60);
                    if (rminutes > 0)
                        return hours + ' ' + scope.translation.text.HOUR + numberEnding(hours) + ' ' + rminutes + ' ' + scope.translation.text.MINUTE + numberEnding(rminutes);
                    else
                        return hours + ' ' + scope.translation.text.HOUR + numberEnding(hours);
                }
                var minutes = Math.floor((temp %= 3600) / 60);
                if (minutes) {
                    return minutes + ' ' + scope.translation.text.MINUTE + numberEnding(minutes);
                }
                var seconds = temp % 60;
                if (seconds) {
                    return seconds + ' ' + scope.translation.text.SECOND + numberEnding(seconds);
                }
                return scope.translation.text.LESS_THAN_A_SECOND; //'just now' //or other string you like;
            };

            scope.$watch('deviceSelected', function (newValue, oldValue) {
                if (newValue) {
                    scope.digitalGauges =[];
                    _unRegisterListener();
                    var _device = { deviceName: scope.deviceSelectedName };
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                    _getDigitalData(newValue);
                }
            }, true);

            scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    scope.stickyProperties.device.serialNumber = newValue;
                    if (oldValue) {
                        _unRegisterListenerDigitalSetting(oldValue);
                    }
                }
            }, true);

            scope.$on("$destroy", function () {
                //distroyScopeChannel();
                element.empty();
                _unRegisterListener();
                // websocketService.unRegister("INPUT", scope.deviceSelectedSn, '', wsDataReceivedDIGITAL, wsReconnectDIGITAL);
            });

            var _getDigitalData = function (deviceId) {
                scope.deviceId = deviceId;
                var noData = scope.digitalGauges.length > 0 ? false : true;
                //scope.digitalGauges = [];

                //scope.liveData = true;

                digitalGaugeService.getData(accountInfo.customerId, deviceId, accountInfo.timeZone)
                    .then(function (result) {
                        _registerListener();
                        scope.digitalSettings = result.data.digitalSettings;
                        scope.rtuDigital = scope.digitalSettings.length;
                        scope.lastData = result.data.lastDigitals;
                        scope.m110Runtime = result.data.device.model === 8 || result.data.device.model === 18 ? true : false;
                        if (result.data.digitalSettings.length <= 0) {
                            //   element.append("<div>No digital channel is setup for this device</div>");
                            scope.alerts = [];
                            scope.alerts.push({ msg: scope.translation.message.DIGITAL_SETUP_INCOMPLETE, type: "info" });
                            scope.$emit('rtuDigitalDone_' + scope.windowId, { message: 0 });
                        }
                        else if (result.data.digitalData === null) {

                            scope.alerts = [];
                            scope.alerts.push({ msg: scope.translation.text.NO_DATA, type: "info" });
                            scope.$emit('rtuDigitalDone_' + scope.windowId, { message: 0 });
                        } else {
                            //    websocketService.connect();
                            //   websocketService.register("INPUT", scope.deviceSelectedSn, '', wsDataReceivedDIGITAL, wsReconnectDIGITAL);
                            scope.alerts = [];
                            scope.$emit('rtuDigitalDone_' + scope.windowId, { message: scope.rtuDigital });
                            for (var i = 0; i < scope.digitalSettings.length; i++) {
                                var inputChannle = scope.digitalSettings[i].channel;
                                var digValue = 0;
                                switch (inputChannle) {
                                    case 1:
                                        digValue = result.data.digitalData.d1;
                                        break;
                                    case 2:
                                        digValue = result.data.digitalData.d2;
                                        break;
                                    case 3:
                                        digValue = result.data.digitalData.d3;
                                        break;
                                    case 4:
                                        digValue = result.data.digitalData.d4;
                                        break;
                                    case 5:
                                        digValue = result.data.digitalData.d5;
                                        break;
                                    case 6:
                                        digValue = result.data.digitalData.d6;
                                        break;
                                    case 7:
                                        digValue = result.data.digitalData.d7;
                                        break;
                                    case 8:
                                        digValue = result.data.digitalData.d8;
                                        break;
                                    case 9:
                                        digValue = result.data.digitalData.d9;
                                        break;
                                    case 10:
                                        digValue = result.data.digitalData.d10;
                                        break;
                                    case 11:
                                        digValue = result.data.digitalData.d11;
                                        break;
                                    case 12:
                                        digValue = result.data.digitalData.d12;
                                        break;
                                    case 13:
                                        digValue = result.data.digitalData.d13;
                                        break;
                                    case 14:
                                        digValue = result.data.digitalData.d14;
                                        break;
                                    case 15:
                                        digValue = result.data.digitalData.d15;
                                        break;
                                    case 16:
                                        digValue = result.data.digitalData.d16;
                                        break;

                                }
                                if (digValue === "True")
                                    digValue = "1";
                                if (digValue === "False")
                                    digValue = "0";
                                // if (digValue === "Fault")
                                //     digValue = "-1";
                                var currentVal = digValue;
                                digValue = UpdateValue(digValue, inputChannle, scope.digitalSettings[i].normalClosed);
                                var status = _convertStatus(digValue, scope.digitalSettings[i].digitalMode, scope.digitalSettings[i].image);
                                var des = scope.translation.text.INPUT + " " + inputChannle + ": " + scope.digitalSettings[i].description + "<br />" + scope.translation.text.STATUS + ": " + status.statusMessage;
                                var name = scope.digitalSettings[i].description;
                                var digitaldata = { description: des, image: status.statusImage, input: inputChannle, name: name, currentVal: currentVal, digitalMode: scope.digitalSettings[i].digitalMode, model: result.data.device.model };
                                // _drawDigitalGauge(digitaldata)
                                if (noData) {
                                    scope.digitalGauges.push(digitaldata);
                                } else {

                                    for (var i = 0; i < scope.digitalGauges.length; i++) {
                                        if (scope.digitalGauges[i].input == inputChannle) {
                                            scope.digitalGauges[i] = digitaldata;
                                            break;
                                        };
                                    }
                                }

                            }
                        }

                        scope.isPc3000InAlarm();
                        _registerListenerDigitalSetting();

                    }, function (error) {
                        $scope.m110Runtime = false;
                        _unRegisterListener();
                        _unRegisterListenerDigitalSetting(scope.deviceSelectedSn);
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                });
            };

            scope.getTitle = function (digitalGauge) {
                //Enable status for pumps connected to Rtu of type MyDro M850 (Model=19) or Model 800 (Model=9)
                if (typeof digitalGauge == "undefined") return;
                if (digitalGauge.digitalMode == 'P' && !(digitalGauge.model == 9 || digitalGauge.model == 19))
                    return;

                var lastData = _.find(scope.lastData, function (item) { return item.channel === digitalGauge.input; });
                var now = new Date();

                if (lastData.regTime !== null) {
                    //return digitalGauge.description + '<br />Duration: ' + (lastData.regTime === '0001-01-01T00:00:00' ? scope.translation.text.UNKNOWN : millisecondsToStr(moment.utc().valueOf() - (lastData.livePoint === true ? moment(lastData.regTime).valueOf() : moment.utc(lastData.regTime).valueOf())));
                    return digitalGauge.description + '<br />Duration: ' + (lastData.regTime === '0001-01-01T00:00:00' ? scope.translation.text.UNKNOWN : millisecondsToStr(moment.utc().valueOf() - moment.utc(lastData.regTime).valueOf()));
                } else {
                    return digitalGauge.description + '<br />Duration: <i class="fa fa-spinner fa-spin" />';
                }
            }

            scope.fetchHoverData = function (digitalGauge) {
                var lastData = _.find(scope.lastData, function (item) { return item.channel === digitalGauge.input; });
                //if (lastData.regTime === null) {
                    digitalGaugeService.getMostRecentData(scope.deviceId, lastData.channel, scope.accountInfo.timeZone, digitalGauge.currentVal).then(function (resp) {
                        lastData.regTime = resp.data;

                        $timeout(function () {
                            var elements = document.getElementsByClassName('tooltip-jq');
                            for (var i = 0; i < elements.length; i++) {
                                elements[i].innerHTML = scope.getTitle(digitalGauge);
                            }
                        });

                    });
                //}

                return;
            };

            var wsDataReceivedDIGITALSETTINGDG = function (data) {
                if (data.Type == 'DIGITALSETTING' && data.SN == scope.deviceSelectedSn) {
                    $timeout(function () {
                        if (data.UniqueWebID != scope.uniqueWebID) {
                            _getDigitalData(scope.deviceSelected);
                        } 
                        else if(data.Value.path == "digitalMode")
                        {
                            _getDigitalData(scope.deviceSelected);
                        }
                    }, 200);
                }
            };
    
            var _registerListenerDigitalSetting = function () {
                //subscribe for digital setting changes
                websocketService.connect();
                for (var i = 1; i <= 8; i++) {
                    websocketService.register("DIGITALSETTING", scope.deviceSelectedSn, i, wsDataReceivedDIGITALSETTINGDG, null);
                 }
            };
            var _unRegisterListenerDigitalSetting = function (varSerialNum) {
                websocketService.connect();
                for (var i = 1; i <= 8; i++) {
                    websocketService.unRegister("DIGITALSETTING", varSerialNum, i, wsDataReceivedDIGITALSETTINGDG, null);
                 }
            };

            var wsDataReceivedGaugeDIGITAL = function (data) {
                if (scope.deviceSelectedSn === data.SN) {
                    var chValue = data.Value;
                    var channelIndex = channel - 1;
                    //var chArray = data.Value.replace(/[[\]]/g, '').split(',');
                    //for (var i = 0; i < scope.digitalSettings.length; i++) {
                      //if (scope.digitalSettings[i].channel > 8) break;
                        var inputChannle = scope.digitalSettings[channelIndex].channel;
                        var value = UpdateValue(chValue, inputChannle, scope.digitalSettings[channelIndex].normalClosed);
                        var digValue = value === null ? null : String(value);

                        if (digValue !== scope.digitalGauges[channelIndex].currentVal) {
                            scope.lastData[channelIndex].livePoint = true;
                            scope.lastData[channelIndex].regTime = datetimeService.socketStrToServerStrTime(data.Time);
                        }

                        var status = _convertStatus(digValue, scope.digitalSettings[channelIndex].digitalMode, scope.digitalSettings[channelIndex].image);
                        var des = "Input " + inputChannle + ": " + scope.digitalSettings[channelIndex].description + "<br>Status: " + status.statusMessage;
                        var name = scope.digitalSettings[channelIndex].description;
                        var digitaldata = { description: des, image: status.statusImage, input: inputChannle, name: name, currentVal: String(chValue)};
                        // _drawDigitalGauge(digitaldata)
                        scope.digitalGauges[channelIndex] = digitaldata;
                    //}
                    var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                    if (typeof scope.deviceInfo != "undefined") scope.deviceInfo.lastTimeHeard = Date.now(); //used in RTU View
                    scope.lastUpdateAt = varTime;
                }
            };

            var wsDataReceivedGaugeOPTIONDIGITAL = function (data) {
              if (scope.deviceSelectedSn === data.SN) {
                var chArray = data.Value.replace(/[[\]]/g, '').split(',');
                for (var i = 0; i < scope.digitalSettings.length; i++) {
                  if (scope.digitalSettings[i].channel <= 8) continue;
                  var inputChannle = scope.digitalSettings[i].channel;
                  var value = UpdateValue(chArray[inputChannle - 9], inputChannle, scope.digitalSettings[i].normalClosed);
                  var digValue = value === null ? null : String(value);

                  if (digValue !== scope.digitalGauges[i].currentVal) {
                    scope.lastData[i].livePoint = true;
                    scope.lastData[i].regTime = datetimeService.socketStrToServerStrTime(data.Time);
                  }

                  var status = _convertStatus(digValue, scope.digitalSettings[i].digitalMode, scope.digitalSettings[i].image);
                  var des = "Input " + inputChannle + ": " + scope.digitalSettings[i].description + "<br>Status: " + status.statusMessage;
                  var name = scope.digitalSettings[i].description;
                  var digitaldata = { description: des, image: status.statusImage, input: inputChannle, name: name, currentVal: digValue === null ? null : (String(value) === "1" ? "0" : "1") };
                  // _drawDigitalGauge(digitaldata)
                  scope.digitalGauges[i] = digitaldata;
                }
                var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                if (typeof scope.deviceInfo != "undefined") scope.deviceInfo.lastTimeHeard = Date.now(); //used in RTU View
                scope.lastUpdateAt = varTime;

                  scope.isPc3000InAlarm();
              }
            };

            var wsDataReceivedFAULTS = function (data) {
                if (scope.deviceSelectedSn === data.SN) {
                    var faultBinary;
                    if (isNaN(data.Value)) {
                        faultBinary = data.Value.replace(/[[\]]/g, '').split(',').join('');
                        //console.log(faultBinary);
                    } else {
                        faultBinary = (data.Value >>> 0).toString(2);

                        while (faultBinary.length < 16) {
                            faultBinary = faultBinary.length < 8 ? "0" + faultBinary : faultBinary + "0";
                        }
                    }

                    for (var i = 0; i < scope.digitalSettings.length; i++) {
                        var inputChannel = scope.digitalSettings[i].channel;

                        if (faultBinary[inputChannel - 1] === '1') {
                            var status = _convertStatus(null, scope.digitalSettings[i].digitalMode, scope.digitalSettings[i].image);
                            var des = "Input " + inputChannel + ": " + scope.digitalSettings[i].description + "<br>Status: " + status.statusMessage;
                            var name = scope.digitalSettings[i].description;
                            var digitalData = { description: des, image: status.statusImage, input: inputChannel, name: name };
                            scope.digitalGauges[i] = digitalData;
                        }
                    }
                }
            }

            scope.mostRecentData = function () {
                scope.digitalGauges = [];
                toaster.pop('success', "Digital Gauge" + " -- " + scope.deviceSelectedName, 'View reloading');
                wsReconnectGaugeDIGITAL();
            }

            var wsReconnectGaugeDIGITAL = function (data) {
                _getDigitalData(scope.deviceSelected);
            };

            var _registerListener = function () {
                scope.lastSn = scope.deviceSelectedSn;
                websocketService.connect();
                //websocketService.register("INPUTS", scope.deviceSelectedSn, '', wsDataReceivedGaugeDIGITAL, wsReconnectGaugeDIGITAL);
                websocketService.register("DIGITALINPUT", scope.deviceSelectedSn, '', wsDataReceivedGaugeDIGITAL, wsReconnectGaugeDIGITAL);
                websocketService.register("OPTIONDIGITAL", scope.deviceSelectedSn, '', wsDataReceivedGaugeOPTIONDIGITAL, null);
                websocketService.register("FAULTS", scope.deviceSelectedSn, '', wsDataReceivedFAULTS, null);
                scope.liveData = true;
            };

            var _unRegisterListener = function () {
              //websocketService.unRegister("INPUTS", scope.lastSn || scope.deviceSelectedSn, '', wsDataReceivedGaugeDIGITAL, wsReconnectGaugeDIGITAL);
              websocketService.unRegister("DIGITALINPUT", scope.lastSn || scope.deviceSelectedSn, '', wsDataReceivedGaugeDIGITAL, wsReconnectGaugeDIGITAL);
              websocketService.unRegister("OPTIONDIGITAL", scope.deviceSelectedSn, '', wsDataReceivedGaugeOPTIONDIGITAL, null);
                websocketService.unRegister("FAULTS", scope.lastSn || scope.deviceSelectedSn, '', wsDataReceivedFAULTS, null);
                scope.lastSn = null;
            };

            var UpdateValue = function (Value, Channel, NomalState) {

                var ReturnValue = "0";
                if (Value === String(NomalState))
                    ReturnValue = "1";
            else if (Value === "NULL" || Value === null || Value === "")
                    ReturnValue = null;

                return ReturnValue;
            };

            var _convertStatus = function (statusCode, digitalMode, image) {
                statusMsg = null;
                switch (statusCode) {
                    default:
                    case "0": //open
                        if (digitalMode === "P")
                            statusMsg = { statusImage: "off_" + image, statusMessage: scope.translation.text.STOPPED };
                        else if (digitalMode === 'D')
                            statusMsg = { statusImage: "open_" + image, statusMessage: scope.translation.text.OPEN };
                        else
                            statusMsg = { statusImage: "open_" + image, statusMessage: scope.translation.text.OPEN };
                        break;
                    case "1": //close
                        if (digitalMode === "P")
                            statusMsg = { statusImage: "run_" + image, statusMessage: scope.translation.text.RUNNING };
                        else if (digitalMode === 'D')
                            statusMsg = { statusImage: "open_" + image, statusMessage: scope.translation.text.OPEN };
                        else
                            statusMsg = { statusImage: "close_" + image, statusMessage: scope.translation.text.CLOSE };
                        break;
                    case null: //fault
                    case "":
                        if (digitalMode === "P")
                            statusMsg = { statusImage: "fault_" + image, statusMessage: scope.translation.text.FAULT };
                        else if (digitalMode === 'D')
                            statusMsg = { statusImage: "open_" + image, statusMessage: scope.translation.text.OPEN };
                        else
                            statusMsg = { statusImage: "fault_" + image, statusMessage: scope.translation.text.FAULT };
                        break;
                }
                return statusMsg;
            };

            scope.$on('updateDigitalWidgetImage', function (event, args) {
                if (scope.deviceSelected != args.deviceId) return;
                wsReconnectGaugeDIGITAL();
                return;
                var status;
                for (var i = 0; i < scope.digitalGauges.length; i++) {
                    if (scope.digitalGauges[i].input == args.channel) {
                        var value = UpdateValue(scope.digitalGauges[i].currentVal, scope.digitalGauges[i].input, scope.digitalSettings[i].normalClosed); // will change to args.normalClosed when broadcasting normalClosed state!!!
                        var digValue = value === null ? null : String(value);
                        status = _convertStatus(digValue, scope.digitalGauges[i].digitalMode, args.image);
                        scope.digitalGauges[i].image = status.statusImage;
                        break;
                    };
                }
            });

            scope.$on('updateDigitalSetting', function (event, args) {
                if (scope.deviceSelected != args.deviceId) return;
                wsReconnectGaugeDIGITAL();
                return;
            });

            element.on(
                    "mouseover.digitalGaugeDirective",
                    ".hcolDigital",
                    ".pc3000",
                    function (event) {
                        var localScope = $(event.target).scope();
                        //console.log(scope.m110Runtime);
                        if ($(event.currentTarget).is(".hcolDigital")) {

                            if (!angular.isDefined(event.target.attributes["mc-channel"])) return; // channel is required to proceed with draggability feature

                            var channel = event.target.attributes["mc-channel"].value;
                            
                            var gaugeFound = scope.digitalGauges.find(function (value, index, array) {
                                if (value.input == channel) return value;
                            });

                            //by default gauges for all the inputs are draggable, except runtime input for 110 series device 
                            var isDraggable = scope.m110Runtime && gaugeFound.digitalMode == "P" ? false : true;

                            if (isDraggable && !scope.mobile && !scope.classicView) {
                                $(event.currentTarget).draggable({
                                    helper: "clone",
                                    revert: false,
                                    appendTo: "body",
                                    containment: "body",
                                    opacity: 0.35,
                                    stop: function (event, ui) {
                                        var mcDevice = { deviceId: scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: scope.deviceSelectedSn };

                                        var optionsStickyProperties = {
                                            device: mcDevice
                                        };

                                        var $newPosX = ui.offset.left;
                                        var $newPosY = ui.offset.top;
                                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                                        openViewService.openWidget('Digital Widget', { width: 240, height: 240 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                        scope.$apply();
                                    }
                                });
                            }
                        }
                    }
                )
            .tooltip({
                track: true,
                tooltipClass: 'tooltip-jq',
                content: function () {
                    return this.getAttribute('data-title');
                },
                items: 'img[data-title], i[data-title], div[data-title]'
            });

            scope.$on(
                       "$destroy",
                       function (event) {
                           element.off("mouseover.digitalGaugeDirective");
                           _unRegisterListener();
                           _unRegisterListenerDigitalSetting(scope.deviceSelectedSn);
                       }
                   );

            scope.isPc3000InAlarm();
        }

        return {
            restrict: 'A',
            replace: false,
            link: link
        };
    }]);
mcapp.factory("digitalGaugeService", ["$http", "HOST", function ($http, HOST) {
    var digitalGaugeService = {};

    var _getData = function (customerId, deviceId, timeZone) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DigitalGauge',
            params: { customerId: customerId, deviceId: deviceId, timeZone: timeZone }
        });
    };

    var _getMostRecentData = function (deviceId, channel, timeZone, currentVal) {
        return $http({
            method: 'GET',
            url: HOST + '/api/MostRecentDigital?deviceId=' + deviceId + '&channel=' + channel + '&timeZone=' + timeZone + '&currentVal=' + currentVal,
        });
    }

    digitalGaugeService.getData = _getData;
    digitalGaugeService.getMostRecentData = _getMostRecentData;
    return digitalGaugeService;

}]);

mcapp.controller("digitalChartController", ["$scope", "authenticationService", "sharedSetupService", "translationService",
    function ($scope, authenticationService, sharedSetupService, translationService) {
        $scope.SN = "";
        var NomalState;
        sharedSetupService.getWindowId($scope); 
        $scope.Channel = [];
        $scope.DigitalSettings = [];
        $scope.nodigital = true;
        $scope.series = null;
        $scope.firsttime = true;
        $scope.timer = 0;
        $scope.liveData = true;
        $scope.myDate = new Date();
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
        $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
        $scope.unixDay = sharedSetupService.unixDay;
        $scope.liveDataOffset = 20 * 60 * 1000;
        $scope.minPadding = 0;
        $scope.maxPadding = 0;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.alerts = [];
        $scope.currentTime;
        $scope.maxChannel = 1;
        $scope.translation = translationService.translation;
        $scope.pageloading = false;
        $scope.firsttime = true;

        sharedSetupService.broadcastAllDeviceSelected($scope);
        sharedSetupService.getWindowId($scope);
        $scope.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };
    }]);

mcapp.directive('digitalChartDirective', ["$rootScope", "$timeout", "authenticationService", "websocketService", "digitalChartService", "datetimeService", "timeLapseService", "toaster", "sharedSetupService", "openViewService", "rangeSelectorService", "SaveDesktopSettingService",
    function ($rootScope, $timeout, authenticationService, websocketService, digitalChartService, datetimeService, timeLapseService, toaster, sharedSetupService, openViewService, rangeSelectorService, SaveDesktopSettingService) {
        function link(scope, element, attrs) {
            scope.downloadViewTypeOptions = [0,1];
            var chart;
            var xValue = null;
            var  xValueMousePoint = null;
            var addpoint;
            var scrollingInProgress = false;
            var initialLoad = true;

        if (!$rootScope.mobile && !$rootScope.classicView) {
            scope.popup = _this.getExistingDialog(scope.windowId).ref;
            sharedSetupService.maximize(scope.popup);
        }

            element.attr("class", "chart")
            .tooltip({
                track: true,
                tooltipClass: 'tooltip-jq',
                close: function (event, ui) { $(".ui-tooltip").hide(); }
            });


            if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }

            scope.$watch('lastUpdateAt', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    scope.liveDataIn = !scope.liveDataIn;
                    $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
                }
            }, true);

            scope.$watch('deviceSelected', function (newValue, oldValue) {
                if (newValue) {
                    var tmpStartDate = null, tmpEndDate = null;

                    scope.saveDesktopSettingService = new SaveDesktopSettingService(newValue, scope.windowId);

                    if (scope.stickyProperties.setting && scope.stickyProperties.setting.savedDesktop) {
                        scope.savedDesktopSetting = scope.stickyProperties.setting;
                    }
                    else {
                        scope.savedDesktopSetting = scope.saveDesktopSettingService.getObject();
                    }

                    if (scope.stickyProperties.on !== false && scope.stickyProperties.on !== null && scope.stickyProperties.zoomMin !== null) {
                        scope.stickyProperties.on = true;
                        tmpStartDate = scope.stickyProperties.dateMin;
                        tmpEndDate = scope.stickyProperties.dateMax;
                    }
                    else {
                        scope.stickyProperties.on = false;
                    }

                    if (!tmpStartDate) {
                        //if (tmpStartDate) {//for test
                        timeLapseService.getLocalDateTime().then(function (result) {
                            var tmpDates = new Date(result.data.localDateTime);
                            tmpDates.setHours(0, 0, 0, 0);
                            tmpDates = datetimeService.dateToUnixtime(tmpDates);
                            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                            tmpDates = datetimeService.startEndLocalToUtc(tmpDates, scope.accountInfo.timeZone);
                            tmpStartDate = tmpDates.startDate;
                            tmpEndDate = tmpDates.endDate; 
                            _getData(newValue, tmpStartDate, tmpEndDate);
                        });
                    }
                    else {
                        _getData(newValue, tmpStartDate, tmpEndDate);
                    }
                }
            }, true);

            scope.selectMyDate = function (date) {
                scope.myDate = date;
                var tmpDates = date;
                scope.liveData = false;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                tmpDates = datetimeService.startEndLocalToUtc(tmpDates, scope.accountInfo.timeZone);
                tmpStartDate = tmpDates.startDate;
                tmpEndDate = tmpDates.endDate;
                _getData(scope.deviceSelected, tmpStartDate, tmpEndDate);
            };

            scope.zoomAdjust = function(varDay){
                var extremes = scope.chart.xAxis[0].getExtremes();
                var extremeMinMax = rangeSelectorService.getChartExtremes(  extremes.max, extremes.min, varDay, scope.heartbeatLocalDateTime);
                scope.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
                scope.saveDesktopSettingService.setZoomAdjustSetting(varDay, scope);
                _setLiveDataStatus();
            };

            var _getData = function (deviceId, StartDate, EndDate) {
                scope.refreshStartData = StartDate;
                scope.refreshEndData = EndDate;
                scope.liveDataEndDate = EndDate;
                scope.pageloading = true;
                element.empty();
                scope.chart = null;
                var _device = { deviceName: scope.deviceSelectedName };

                digitalChartService.getData(scope.accountInfo.timeZone, deviceId, scope.accountInfo.customerId, StartDate, EndDate)
                    .then(function (result) {

                        scope.m110Runtime = result.data.device.model === 8 || result.data.device.model === 18 ? true : false;
                        scope.hasMydroExpansion  = result.data.device.hasMydroExpansion;
                        if (result.data.digitalSettings.length <= 0) {
							sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, zoomMin: scope.stickyProperties.zoomMin || StartDate, zoomMax: scope.stickyProperties.zoomMax || EndDate, windowId: scope.windowId });
                            scope.alerts = [];
                            scope.alerts.push({ msg: scope.translation.message.DIGITAL_SETUP_INCOMPLETE, type: "info" });
                        }
                        else if (result.data.series.length <= 0) {
                            scope.alerts = [];
                            errormsg = scope.translation.message.NO_DATA + ": " + moment(StartDate).format('MM/DD/YY, h:mm:ss a') + " - " + moment(EndDate).format('MM/DD/YY, h:mm:ss a');
                            scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                        }
                        else {
                            scope.nodigital = false;
                            scope.series = result.data.series;
                            scope.device = result.data.device;
                            scope.SN = scope.device.serialNumber;
                            scope.DigitalSettings = result.data.digitalSettings;
                            scope.maxChannel = scope.DigitalSettings[scope.DigitalSettings.length - 1].channel;//query is select order by channel asc, so will get the largest channel number
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, zoomMin: scope.stickyProperties.zoomMin || StartDate, zoomMax: scope.stickyProperties.zoomMax || EndDate, windowId: scope.windowId });

                            _drawDigitalChart();
                        }

                        scope.pageloading = false;
                        _registerListenerDigitalSetting();
                    },function (error) {
                        scope.m110Runtime = false;
                        scope.hasMydroExpansion = false;
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                        scope.pageloading = false;
                   });

            };

            scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    scope.stickyProperties.device.serialNumber = newValue;
                    if (oldValue) {
                        _unRegisterListenerDigitalSetting(oldValue);
                    }
                }
            }, true);

            var _drawDigitalChart = function () {
                scope.alerts = [];
                var chartDrawn = false;
                scope.numberOfSeries = scope.series.length;
                scope.numberOfHiddenSeries = 0;
                var chartXaxisHourFormat = scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
                var chartToolTipHourFormat = scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

                chart = new Highcharts.StockChart({
                    credits: {
                        enabled: false
                    },
                    legend: {
                    enabled: true,
                    backgroundColor: '#f9f9f9',
                    borderColor: '#cccccc',
                    borderWidth: 1
                    },
                    time: {
                        getTimezoneOffset: function (timestamp) {
                           return -moment.tz(timestamp, datetimeService.getTimeZoneId(scope.accountInfo.timeZone)).utcOffset();
                       }
                   },
                    series: scope.series,
                    //  series:[{name: "Pump 1", threshold: 0.85, color: "#0000ff", negativeColor: "#ff0000", lineWidth: 4, color: "#0000ff", data: [[1426982400000, null, 0], [1427103341024.222, null, 0]]}],
                    chart: {
                        renderTo: element[0],
                        backgroundColor: '#ebebeb',
                        plotBackgroundColor: '#f9f9f9',
                        borderColor: '#cccccc',
                        borderWidth: 1,
                        borderRadius: 2,
                        panning: true,
                        panKey: 'shift',
                        pinchType: 'x',
                        plotBorderWidth: 1,
                        marginTop: 10,
                        marginRight: 10,
                        marginLeft: 10,
                        spacingBottom: 10,
                        spacingTop: 0,
                        spacingLeft: 5,
                        spacingRight: 5,
                        animation: true,
                        reflow: true,
                        events: {
                            redraw: function (event) {
                                if (this.options.chart.forExport) return false;
                                var extremes = this.xAxis[0].getExtremes();
                                if (this.xAxis && chartDrawn === true && scrollingInProgress === false) {
                                    //drag to left
                                    if (!scope.liveupdate && extremes && extremes.dataMin >= extremes.min - scope.liveDataOffset * 2) {
                                        scrollingInProgress = true;
                                        this.showLoading();

                                        tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -11);
                                        tmpStartDate = tmpDates.startDate;
                                        tmpEndDate = tmpDates.endDate;
                                        digitalChartService.getData(scope.accountInfo.timeZone, scope.deviceSelected, scope.accountInfo.customerId, tmpStartDate, tmpEndDate)
                                            .then(function (result) {
                                                scope.hasMydroExpansion  = result.data.device.hasMydroExpansion;
                                                for (var i = 0; i < result.data.series.length; i++) {
                                                    if (result.data.series[i].data.length > 3) result.data.series[i].data.pop();
                                                    removeNull(i, true);

                                                    scope.series[i].data = result.data.series[i].data.concat(scope.series[i].data);
                                                    chart.series[i].setData(scope.series[i].data);
                                                }
                                                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, windowId: scope.windowId });
												$timeout(function () {
													scrollingInProgress = false;
												}, 1000);
												chart.hideLoading();
												_setLiveDataStatus();

                                            },function (datafromfactory) {
                                            //var uiErrorMessage = userMessageService.getUiErrorMessage(datafromfactory.message);
                                            // toaster.pop('error', scope.windowTitle, uiErrorMessage);
                                            $timeout(function () {
                                                scrollingInProgress = false;
                                            }, 1000);
                                            chart.hideLoading();
                                            _setLiveDataStatus();
                                        });

                                    }
                                        //drag to right
                                    else if (scope.liveData === false && extremes && extremes.max + scope.liveDataOffset >= extremes.dataMax) {
                                        scrollingInProgress = true;
                                        this.showLoading();

                                        tmpDates = datetimeService.getNewStartEndDates(parseInt(extremes.dataMax), 11);

                                        tmpStartDate = tmpDates.startDate;
                                        tmpEndDate = tmpDates.endDate;
                                        digitalChartService.getData(scope.accountInfo.timeZone, scope.deviceSelected, scope.accountInfo.customerId, tmpStartDate, tmpEndDate)
                                             .then(function (result) {
                                                scope.hasMydroExpansion  = result.data.device.hasMydroExpansion;
                                                 for (var i = 0; i < result.data.series.length; i++) {
                                                     if (result.data.series[i].data.length > 3) result.data.series[i].data.shift();
                                                     removeNull(i);

                                                     //result.data.series[i].data[0][1] = result.data.series[i].data[0][1] === 0 ? null : result.data.series[i].data[0][1];
                                                     //result.data.series[i].data[1][1] = result.data.series[i].data[1][1] === 0 ? null : result.data.series[i].data[1][1];
                                                     //if (typeof result.data.series[i].data[2] !== "undefined")
                                                     //      result.data.series[i].data[2][1] = result.data.series[i].data[2][1] === 0 ? null : result.data.series[i].data[2][1];

                                                     scope.series[i].data = scope.series[i].data.concat(result.data.series[i].data);
                                                     chart.series[i].setData(scope.series[i].data);
                                                 }


                                                 sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMax: tmpDates.endDate, windowId: scope.windowId });
                                                 $timeout(function () {
                                                     scrollingInProgress = false;
                                                 }, 1000);
                                                 chart.hideLoading();
                                                 _setLiveDataStatus(tmpDates.endDate);

                                             }, function (error) {
                                                var errormsg = eval("scope.translation.message." + error.data.message);
                                                toaster.pop('error', scope.windowTitle, errormsg);
                                                 $timeout(function () {
                                                     scrollingInProgress = false;
                                                 }, 1000);
                                                 chart.hideLoading();
                                                 _setLiveDataStatus(tmpDates.endDate);
                                            });

                                    }
                                }

                            },
                            load: function () {
                                var firsttime = true;
                                var s = 60;
	                            if (initialLoad) openViewService.adjustContentSize(scope.popup);
                                initialLoad = false;

                                $timeout(function () { scope.saveDesktopSettingService.applySavedDesktopSetting(chart, scope, false); }, 0);

                                //addpoint = setInterval(function () {

                                //    if (scope.liveData) {
                                //        var chart = element.highcharts();
                                //        scope.liveupdate = true;

                                //        //  if (s >= 60) {
                                //        if (false) {
                                //            timeLapseService.getLocalDateTime().then(function (result) {
                                //                s = 0;
                                //                var x = parseInt(result.data.unixTimeStamp);
                                //                scope.currentTime = x;
                                //                for (var t = 0; t < scope.series.length; t++) {

                                //                    removeNull(t);
                                //                    var series = chart.series[t];
                                //                    var dataseries = scope.series[t];
                                //                    var y = dataseries.data[series.data.length - 1][1];

                                //                    if (!firsttime) {
                                //                        if (typeof series.points[series.data.length - 1] !== "undefined")
                                //                            series.points[series.data.length - 1].remove();
                                //                    }
                                //                    series.addPoint([x, y], false, false, false);
                                //                }
                                //                firsttime = false;
                                //                var extremes = chart.xAxis[0].getExtremes();
                                //                var tmpRange = extremes.max - extremes.min;
                                //                chart.xAxis[0].setExtremes((x - tmpRange + 15000), x);
                                //                // chart.redraw();
                                //            });
                                //        }
                                //        else {
                                //            s++;

                                //            var x = "";
                                //            for (var t = 0; t < scope.series.length; t++) {

                                //                removeNull(t);
                                //                var series = chart.series[t];
                                //                var dataseries = scope.series[t];
                                //                var y = dataseries.data[series.data.length - 1][1];
                                //                scope.currentTime = series.points[series.data.length - 1].x + 15000;
                                //                x = scope.currentTime;
                                //                if (!firsttime) {
                                //                    if (typeof series.points[series.data.length - 1] !== "undefined")
                                //                        series.points[series.data.length - 1].remove();
                                //                }
                                //                series.addPoint([x, y], false, false, false);
                                //            }
                                //            firsttime = false;
                                //            var extremes = chart.xAxis[0].getExtremes();
                                //            var tmpRange = extremes.max - extremes.min;
                                //            chart.xAxis[0].setExtremes((x - tmpRange + 15000), x);
                                //            //  chart.redraw();

                                //        }


                                //    }

                                //}, 15000);

                            }
                        }
                    },
                    xAxis: {
                        type: 'datetime',
                        endOnTick: false,
                        showLastLabel: true,
                        showFirstLabel: true,
                        startOnTick: true,
                        ordinal: false,
                        minRange: 3600 / 4 * 1000, //15 minutes
                        minTickInterval: 3600 * 1000,
                        dateTimeLabelFormats: {
                            hour: chartXaxisHourFormat,
                        },
                        plotLines: [{
                            value: 0,
                            width: 3,
                            color: 'green',
                            dashStyle: "solid",
                            zIndex: 1
                        }],
                        // min: scope.stickyProperties.dateMin,
                        //  datamin: scope.stickyProperties.zoomMin,
                        // datamax: scope.stickyProperties.zoomMax,
                        labels: {
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold'
                            }
                        },
                        events: {
                            afterSetExtremes: function (e) {
                                // chartDrawn = true;
                                if (chartDrawn === true) {
                                    var extremes = chart.xAxis[0].getExtremes();
                                        if (scope.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) { //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                            if (extremes.max + scope.liveDataOffset <= extremes.dataMax) {
                                                sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                                                _unRegisterListener();
                                            }
                                        }
                                        sharedSetupService.setStickyProperties(scope.stickyProperties, { zoomMin: extremes.min, zoomMax: extremes.max, windowId: scope.windowId });
                                }
                            },
                            setExtremes: function (e) {
                                sharedSetupService.setStickyProperties(scope.stickyProperties, { zoomMin: e.min, zoomMax: e.max, windowId: scope.windowId });
                            }
                        }
                    },
                    yAxis: {
                        reversed: true,
                        align: 'left',
                        endOnTick: false,
                        showLastLabel: true,
                        showFirstLabel: true,
                        startOnTick: false,
                        labels: {
                            align: 'left',
                            useHTML: true,
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold'
                            },
                            formatter: function () {
                                return getTooltip(this.value);
                            }
                        },
                        minTickInterval: 1,
                        tickInterval: 1,
                        step: 1,
                        min: 0.5,
                        max: scope.maxChannel + 0.5
                    },
                    exporting: {
                        enabled: false
                    },
                    rangeSelector: {
                        enabled: false
                    },
                    plotOptions: {

                        series: {
                            lineWidth: 4,
                            states: {
                                hover: {
                                    enabled: true,
                                    lineWidth: 4
                                }
                            },
                            dataGrouping: {
                                enabled: false
                            },
                            point: {
                                events: {
                                    mouseOver: function () {
                                        xValue = this.x;
                                    }
                                }
                            },
                            events: {
                                legendItemClick: function () {
                                    if (this.visible) {
                                        if (scope.numberOfHiddenSeries < (scope.numberOfSeries - 1)) {
                                            scope.numberOfHiddenSeries = scope.numberOfHiddenSeries + 1;
                                        } else {
                                            return false;
                                        }
                                    } else {
                                        scope.numberOfHiddenSeries = scope.numberOfHiddenSeries - 1;
                                    }

                                    scope.saveDesktopSettingService.setSerieVisibilitySetting(this.options.id, this.visible ? false : true, scope);
                                },
                                mouseOut: function () {
                                    xValue = null;
                                }
                            }
                        }
                    },
                    tooltip: {
                        // crosshairs: false,
                        // shared: false,
                        backgroundColor: '#FFFFFF',
                        formatter: function () {

                            var tip = "";
                            tip += Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x,scope.accountInfo.timeZone));
                            var status = scope.translation.text.CLOSE;
                            $.each(this.points, function (i, point) {

                                // Check digital settings for digital mode and normal closed to display appropriate status text
                                for (var i = 0; i < scope.DigitalSettings.length; i++) {

                                    if (scope.DigitalSettings[i].description == point.series.name) {

                                        if (point.y !== parseInt(point.y, 10))
                                                status = scope.translation.text.FAULT;
                                        else if ((point.index == this.series.data.length - 1) && point.y != null) {//last point and in close status
                                            if (point.series.name.toLowerCase().indexOf("pump") > -1 && scope.DigitalSettings[i].digitalMode == "P" )
                                                status = scope.translation.text.RUNNING;
                                            else if (scope.DigitalSettings[i].normalClosed == 0) // If normal state is normal open
                                                status = scope.translation.text.OFF_NORMAL;
                                            else
                                                status = scope.translation.text.NORMAL;
                                            }
                                        else if (angular.isDefined(point.series.data[point.point.index + 1]) && point.series.data[point.point.index + 1].y == null) {
                                            if (point.series.name.toLowerCase().indexOf("pump") > -1 && scope.DigitalSettings[i].digitalMode == "P" )
                                                status = scope.translation.text.STOPPED;
                                            else
                                                status = scope.translation.text.NORMAL;
                                            }
                                        else {
                                            if (this.series.name.toLowerCase().indexOf("pump") > -1 && scope.DigitalSettings[i].digitalMode == "P")
                                                status = scope.translation.text.RUNNING;
                                            else
                                                status = scope.translation.text.OFF_NORMAL;
                                    }
                                xValue = point.x;

                                tip += '<br><span style="color: ' + point.series.color + ';">' + point.series.name + "</span>: <b>";
                                tip += status;
                                tip += "</b><br>" + scope.translation.text.DURATION + ":<b>" + getDuriration(point.series.index, point.point.index) + "</b>";

                                    }

                                }

                            });
                            return tip;
                        }
                        //formatter: function () {
                        //     xValue = this.x;

                        //    var status = scope.translation.text.CLOSE;
                        //    if (this.y !== parseInt(this.y, 10))
                        //        status = scope.translation.text.FAULT;
                        //    else if ((this.point.index == this.series.data.length - 1) && this.y != null) {//last point and in close status
                        //        if (this.series.name.toLowerCase().indexOf("pump") > -1)
                        //            status = scope.translation.text.RUNNING;
                        //        else
                        //            status = scope.translation.text.CLOSE;
                        //    }
                        //    else if (this.series.data[this.point.index + 1].y == null) {
                        //        if (this.series.name.toLowerCase().indexOf("pump") > -1)
                        //            status = scope.translation.text.STOPPED;
                        //        else
                        //            status = scope.translation.text.OPEN;
                        //    }
                        //    else {
                        //        if (this.series.name.toLowerCase().indexOf("pump") > -1)
                        //            status = scope.translation.text.RUNNING;
                        //        else
                        //            status = scope.translation.text.CLOSE;
                        //    }



                        //    var tip = "";
                        //    tip += Highcharts.dateFormat('%b %e, %Y %H:%M:%S', this.x);
                        //    tip += '<br>' + this.series.name + ": <b>";
                        //    tip += status;
                        //    tip += "</b><br>" + scope.translation.text.DURATION + ":<b>" + getDuriration(this.series.index, this.point.index) + "</b>";
                        //    return tip;

                        //}
                    },
                    navigator: {
                        enabled: true,
                        adaptToUpdatedData: true,
                        series: {
                            lineWidth: 0,
                            color: 'transparent'
                        },
                        maskFill: 'rgba(255, 255, 255, 0.35)',
                        maskInside: true,
                        handles: {
                            backgroundColor: '#a4a7a9',
                            borderColor: '#384450'
                        },
                        height: 22,
                        margin: 0,
                        xAxis: {

                            //dateTimeLabelFormats: {
                            //    millisecond: '%H:%M:%S.%L',
                            //    second: '%H:%M:%S',
                            //    minute: '%H:%M',
                            //    hour: '%H:%M',
                            //    day: '%b %e',
                            //    week: '%b %e',
                            //    month: '%b \'%y',
                            //    year: '%Y'
                            //},


                            tickWidth: 2,
                            lineWidth: 1,
                            gridLineWidth: 0,
                            tickLength: 15,
                            tickPosition: 'inside',
                            tickColor: '#98b3d1',
                            dateTimeLabelFormats: {
                                hour: chartXaxisHourFormat,
                            },
                            labels: {
                                align: 'left',
                                style: {
                                    color: '#61768f',
                                    fontWeight: 'bold'
                                },
                                x: 8,
                                y: -8
                            }
                        }
                    },
                    scrollbar: {
                        enabled: true,
		    			height: 0,
                        liveRedraw: true
                    }
                });

                scope.chart = chart;

                var tmpNewDateA;
                var tmpNewDateB;
                var extremes = chart.xAxis[0].getExtremes();
                if (scope.stickyProperties.on === true && scope.stickyProperties.mostRecentData === undefined) {
                    tmpNewDateA = scope.stickyProperties.zoomMin >= extremes.dataMin ? scope.stickyProperties.zoomMin : extremes.dataMin;//extremes.dataMin + scope.unixDay / 24 * 3;
                    // tmpNewDateA = scope.stickyProperties.zoomMin;
                    tmpNewDateB = scope.stickyProperties.zoomMax <= extremes.dataMax + scope.liveDataOffset ? scope.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
                    tmpNewDateB = tmpNewDateB >= tmpNewDateA + scope.unixDay / 24 ? tmpNewDateB : extremes.dataMax - scope.unixDay / 24 * 12;
                    scope.stickyProperties.on = false;
                }
                else {
                    scope.stickyProperties.mostRecentData = undefined;
                    tmpNewDateA = scope.myDate !== null ? extremes.dataMin + scope.unixDay : extremes.dataMax - scope.unixDay / 24 * 12;
                    tmpNewDateB = scope.myDate !== null ? tmpNewDateA + scope.unixDay : extremes.dataMax;
                    if (tmpNewDateB > extremes.dataMax) {
                        tmpNewDateB = extremes.dataMax;
                        tmpNewDateA = tmpNewDateB - scope.unixDay;
                    }
                    tmpNewDateA = tmpNewDateA + scope.minPadding;
                    tmpNewDateB = tmpNewDateB + scope.maxPadding;
                }

                chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);

                //if (scope.series !== null) { //only for analog chart if no setup
                //    _setStickyProperties(scope.deviceSelected, null, null, tmpNewDateA, tmpNewDateB);
                //}
                //else {
                //    chart.showLoading('Digital Setup not available!');
                //}
                _setLiveDataStatus();
                chartDrawn = true;

            };

            var getTooltip = function (channel) {
                var tmpFontSize = "12px";
                tmpFontSize = element.height() < 400 && scope.DigitalSettings.length > 8 ? "8px" : tmpFontSize;
                tmpFontSize = element.height() < 330 && scope.DigitalSettings.length > 8 ? "4px" : tmpFontSize;
                for (var i = 0; i < scope.DigitalSettings.length; i++) {
                    if (scope.DigitalSettings[i].channel === channel)
                        return "<span style='font-size: " + tmpFontSize + ";' title='" + scope.DigitalSettings[i].description + "'>" + channel + "</span>";
                }
                return "<span>" + channel + "</span>";
            }


            var wsDataReceivedDI = function (data) {
              $timeout(function () {
                //console.log(scope.faultData);
                var channel = parseInt(data.CH);
                var channelIndex = null;
                //find matching channel for incoming live data
                for (var i = 0; i < scope.series.length; i++) {
                    if (scope.series[i].id == channel) {
                        channelIndex = i;
                    }
                }
                //if no matching channel is found, do nothing and return
                if (channelIndex == null) {
                    return;
                }
                var x = datetimeService.toUnixtime(data.Time);
                x = datetimeService.localToUtcTimeStampByTime(x, scope.accountInfo.timeZone);                
                
                var value = 0;
                var y = null;
                var chValue = data.Value;
                var chart = element.highcharts();

                existingSeries = chart.series[0];
                var recordAtX = existingSeries.xData[existingSeries.xData.length - 1];
                if((x == recordAtX) && scope.DigitalSettings.length > 8 && scope.hasMydroExpansion)
                {
                    value = UpdateValue(chValue, channel, scope.DigitalSettings[channelIndex].normalClosed, scope.deviceSelectedType);
                    cutSeries = chart.series[channelIndex];
                    preValue = cutSeries.data[cutSeries.data.length - 1].y;//last value
                    y = value === null ? null : parseFloat(value);
                    if (preValue !== null && y !== null && y !== preValue) {//from fault to close or from close to fault
                      cutSeries.addPoint([x - 100, null], false, false, false); //insert a null to break the line
                      scope.series[channelIndex].data.push([x - 100, null, 1]);
                    }
                    cutSeries.addPoint([x, y], false, false, false);
                    scope.series[i].data.push([x, y, 1]);
                      chart.redraw();
                }
                else
                {
                    if (typeof scope.faultData !== "undefined" || scope.faultData != null) {
                        if (scope.faultData[channelIndex] === '1') {
                            chValue = "null";
                          }
                    }

                    if (channelIndex < scope.DigitalSettings.length) {
                        value = UpdateValue(chValue, channel, scope.DigitalSettings[channelIndex].normalClosed, scope.deviceSelectedType);
                        cutSeries = chart.series[channelIndex];
                        preValue = cutSeries.data[cutSeries.data.length - 1].y;//last value
                        y = value === null ? null : parseFloat(value);
                        if (preValue !== null && y !== null && y !== preValue) {//from fault to close or from close to fault
                            cutSeries.addPoint([x - 100, null], false, false, false); //insert a null to break the line
                            scope.series[channelIndex].data.push([x - 100, null, 1]);
                        }
                        cutSeries.addPoint([x, y], false, false, false);
                        scope.series[channelIndex].data.push([x, y, 1]);

                        chart.redraw();
                    }                                        
                }
              }, 200);
            };

            var wsDataReceivedDIGITALSETTINGDC = function (data) {
                if (data.Type == 'DIGITALSETTING' && data.SN == scope.deviceSelectedSn) {
                    $timeout(function () {
                        _getData(scope.deviceSelected, scope.refreshStartData, scope.refreshEndData);
                    }, 200);
                }
            };

            var wsDataReceivedODI = function (data) {
              $timeout(function () {
                //console.log(scope.faultData);
                var x = datetimeService.toUnixtime(data.Time);
                x = datetimeService.localToUtcTimeStampByTime(x, scope.accountInfo.timeZone);
                var channel = 1;
                var value = 0;
                var y = null;
                var chArray = data.Value.replace(/[[\]]/g, '').split(',');

                var chart = element.highcharts();
                for (var i = 0; i < scope.DigitalSettings.length; i++) {
                  if (scope.DigitalSettings[i].channel <= 8) continue;
                  removeNull(i);
                  channel = scope.DigitalSettings[i].channel;
                  value = UpdateValue(chArray[channel - 9], channel, scope.DigitalSettings[i].normalClosed);
                  cutSeries = chart.series[i];
                  preValue = cutSeries.data[cutSeries.data.length - 1].y;//last value
                  y = value === null ? null : parseFloat(value);
                  if (preValue !== null && y !== null && y !== preValue) {//from fault to close or from close to fault
                    cutSeries.addPoint([x - 100, null], false, false, false); //insert a null to break the line
                    scope.series[i].data.push([x - 100, null, 1]);
                  }
                  cutSeries.addPoint([x, y], false, false, false);
                  scope.series[i].data.push([x, y, 1]);
                }
                chart.redraw();
              }, 200);
            };

            var wsDataReceivedFAULTS = function (data) {
              var x = datetimeService.toUnixtime(data.Time);
              x = datetimeService.localToUtcTimeStampByTime(x, scope.accountInfo.timeZone);
              var channel = 1;
              var value = 0;
              var y = null;

              if (isNaN(data.Value)) {
                faultBinary = data.Value.replace(/[[\]]/g, '').split(',').join('');
                //console.log(faultBinary);
                } else {
                  faultBinary = (data.Value >>> 0).toString(2);

                  //while (faultBinary.length < scope.DigitalSettings.length) {
                  while (faultBinary.length < 8) {
                    faultBinary = '0' + faultBinary;
                  }
              }

              scope.faultData = faultBinary;
            }

            var removeNull = function (serieNumber, front) {
                var chart = element.highcharts();
                var cutSeries = chart.series[serieNumber];
                var curLength = cutSeries.data.length > 50 ? 50 : cutSeries.data.length;
                var pointindex = 0;

                if (front && cutSeries.data.length > 3) {
                    if (scope.series[serieNumber].data[pointindex][2] === 0) {
                        if (cutSeries.data[pointindex])
                            cutSeries.data[pointindex].remove();
                    }
                    return;
                }
                if (cutSeries.data.length > 3) {

                    for (var i = 1; i < curLength; i++) {
                        pointindex = scope.series[serieNumber].data.length -1;
                        if (scope.series[serieNumber].data[pointindex][2] === 0) {
                            //  cutSeries.points[pointindex].remove();
                            if (cutSeries.data[pointindex])
                                cutSeries.data[pointindex].remove();
                            scope.series[serieNumber].data.splice(pointindex, 1);
                        }
                    }
                }
            };

            var getDuriration = function (serieNumber, index) {

                var duration = null;
                var rightX = getRightX(serieNumber, index);
                var leftX = getLeftX(serieNumber, index);
                duration = millisecondsToStr(rightX - leftX);
                return duration;
            };

            var getRightX = function (serieNumber, index) {
                var chart = element.highcharts();
                var cutSeries = chart.series[serieNumber];
                var curLength = cutSeries.data.length;
                var rightX = null;
                rightX = cutSeries.data[curLength - 1].x;
                //if go right, didn't find null, use the very right point
                if (typeof cutSeries.data[index + 1] === "undefined") {
                    rightX = cutSeries.data[index].x;
                }
                    //if the one on the right one is null//it is the very left point, then look for the next not null
                else if (cutSeries.data[index + 1].y === null) {
                    for (var i = index + 1; i < curLength; i++) {
                        if (cutSeries.data[i].y !== null) {
                            rightX = cutSeries.data[i].x;
                            break;
                        }
                    }
                    //if not find any close, right is current use the last data point
                    //rightX = cutSeries.data[curLength - 1].x;
                }
                else {
                    // look for the right
                    for (var i = index + 1; i < curLength; i++) {
                        if (cutSeries.data[i].y === null) {
                            rightX = cutSeries.data[i - 1].x;
                            break;
                        }
                    }
                    // rightX = cutSeries.data[curLength - 1].x;
                }

                return rightX;
            };
            var getLeftX = function (serieNumber, index) {
                var chart = element.highcharts();
                var cutSeries = chart.series[serieNumber];
                var leftX = null;

                leftX = scope.series[serieNumber].data[0][0];
                //if the point is the very left point, use itself
                if (typeof cutSeries.data[index - 1] === "undefined") {
                    leftX = cutSeries.data[index].x;
                }
                else if (typeof cutSeries.data[index + 1] === "undefined") {//last data
                    for (var t = index - 1; t >= 0; t--) {
                        if (cutSeries.data[t].y === null) {
                            leftX = cutSeries.data[t + 1].x;
                            break;
                        }
                    }
                }
                    //if the one on the left is null//it is the very right point, use the point itself
                else if (cutSeries.data[index + 1].y === null) {
                    leftX = cutSeries.data[index].x;
                }
                else {
                    for (var t = index - 1; t >= 0; t--) {
                        if (cutSeries.data[t].y === null) {
                            leftX = cutSeries.data[t + 1].x;
                            break;
                        }
                    }
                }

                return leftX;
            };


            var millisecondsToStr = function (milliseconds) {
                // TIP: to find current time in milliseconds, use:
                // var  current_time_milliseconds = new Date().getTime();

                function numberEnding(number) {
                    return (number > 1) ? 's' : '';
                }

                var temp = Math.floor(milliseconds / 1000);
                var years = Math.floor(temp / 31536000);
                if (years) {
                    return years + ' ' + scope.translation.text.YEAR + numberEnding(years);
                }
                //TODO: Months! Maybe weeks?
                var days = Math.floor((temp %= 31536000) / 86400);
                if (days) {

                    temp = temp - days * 86400;
                    var rhours = Math.floor((temp %= 86400) / 3600);
                    if (rhours > 0)
                        return days + ' ' + scope.translation.text.DAY + numberEnding(days) + ' ' + rhours + ' ' + scope.translation.text.HOUR + numberEnding(rhours);
                    else
                        return days + ' ' + scope.translation.text.DAY + numberEnding(days);
                }
                var hours = Math.floor((temp %= 86400) / 3600);
                if (hours) {
                    temp = temp - hours * 3600;
                    var rminutes = Math.floor((temp %= 3600) / 60);
                    if (rminutes > 0)
                        return hours + ' ' + scope.translation.text.HOUR + numberEnding(hours) + ' ' + rminutes + ' ' + scope.translation.text.MINUTE + numberEnding(rminutes);
                    else
                        return hours + ' ' + scope.translation.text.HOUR + numberEnding(hours);
                }
                var minutes = Math.floor((temp %= 3600) / 60);
                if (minutes) {
                    return minutes + ' ' + scope.translation.text.MINUTE + numberEnding(minutes);
                }
                var seconds = temp % 60;
                if (seconds) {
                    return seconds + ' ' + scope.translation.text.SECOND + numberEnding(seconds);
                }
                return scope.translation.text.LESS_THAN_A_SECOND; //'just now' //or other string you like;
            };            

            scope.$on('processReconnect', function (event, args) {
                scope.reconnectData(event, args);
            });

            scope.reconnectData = function (event, args) {
                sharedSetupService.processReconnect({
                    stickyProperties: scope.stickyProperties,
                    localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
                    dateRangeOption: 0,
                    windowTitle: scope.windowTitle,
                    fnUnregister: _unRegisterListener,
                    fnGetData: _getData,
                    viewType: "Chart"
                });                
            };

            scope.mostRecentData = function (event, args) {
                scope.stickyProperties.mostRecentData = true;
                scope.stickyProperties.liveData = true;
                scope.myDate = null;
                scope.reconnectData(event, args);
            };

            var tlDataReceivedDI = function (data) {
                data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, scope.accountInfo.timeZone);
                if (scope.liveData === false) {
                    _unRegisterListener();
                    return;
                }
                var extremes = chart.xAxis[0].getExtremes();
                var tmpRange = extremes.max - extremes.min;

                if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - scope.unixDay / 2) {
                    _unRegisterListener();
                    return;
                }

                var liveDataLine = chart.xAxis[0].plotLinesAndBands;
                liveDataLine[0].options.value = data.Unix + scope.maxPadding;

                if (extremes.max + scope.liveDataOffset > extremes.dataMax) {

                    x = data.Unix + scope.maxPadding;

                    for (var t = 0; t < scope.series.length; t++) {

                        //removeNull(t);
                        var series = chart.series[t];
                        var dataseries = scope.series[t];
                        if (typeof dataseries.data[series.data.length - 1] !== "undefined")
                        {
                            var y = dataseries.data[series.data.length - 1][1];
                            series.addPoint([x, y], false, false, false);
                        }


                        // thinik about add it back later
                        //if (!scope.firsttime) {
                        //    if (typeof series.points[series.data.length - 1] !== "undefined")
                        //        series.points[series.data.length - 1].remove();
                        //}

                    }
                    scope.firsttime = false;
                    chart.xAxis[0].setExtremes(data.Unix - tmpRange + scope.minPadding, data.Unix + scope.maxPadding);
                }
            };

            element.on('mouseover', function (event) {
                if(chart)
                {
                    var normalizedEvent = chart.pointer.normalize(event);
                    xValueMousePoint  =  Math.trunc(chart.xAxis[0].toValue(normalizedEvent.chartX));
                }
              });

            element.on('mousewheel', function (event) {
              if(!scrollingInProgress) {
                if (xValue === null) {
                  scope.mouseWheelZoom(event, chart, xValueMousePoint); 
                } else {
                  scope.mouseWheelZoom(event, chart, xValue);
                }
              }
            });

            var UpdateValue = function (Value, Channel, NomalState, deviceModel) {
                return UpdateDIValue(Value, Channel, NomalState);
            };

            var UpdateDIValue = function (Value, Channel, NomalState) {
                if (Value === "null")//falut
                    ReturnValue = parseFloat(Channel) - 0.3;
                else if (Value === String(NomalState))
                    ReturnValue = Channel;
                else
                    ReturnValue = null;
                return ReturnValue;
            };


            var _setLiveDataStatus = function (varEndDate) {
                scope.liveDataEndDate = varEndDate != null ? varEndDate : scope.liveDataEndDate;
                timeLapseService.getLocalDateTime().then(function (result) {
                    scope.heartbeatLocalDateTime = result.data.unixTimeStamp;
                    var extremes = chart.xAxis[0].getExtremes();
                    if (scope.liveDataEndDate > result.data.unixTimeStamp && (scope.stickyProperties.zoomMax + scope.liveDataOffset >= extremes.dataMax)) {
                        _registerListener(scope.deviceSelectedSn);
                        var data = { Unix: result.data.unixTimeStamp, Value: null, SN: null, CH: null }
                        tlDataReceivedDI(data);
                    }
                    else {
                        sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                        _unRegisterListener();
                    }
                });
            };

            var _registerListener = function () {
                websocketService.connect();
                sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
                //websocketService.register("INPUTS", scope.SN, '', wsDataReceivedDI, null);
                websocketService.register("DIGITALINPUT", scope.SN, '', wsDataReceivedDI, null);
                websocketService.register("OPTIONDIGITAL", scope.SN, '', wsDataReceivedODI, null);
                websocketService.register("FAULTS", scope.SN, '', wsDataReceivedFAULTS, null);
                timeLapseService.register("INPUTS", scope.SN, '', tlDataReceivedDI);
                scope.liveData = true;
                //  setInterval(addpoint);
            };
            
            var _registerListenerDigitalSetting = function () {
                //subscribe for digital setting changes
                websocketService.connect();
                for (var i = 1; i <= 8; i++) {
                    websocketService.register("DIGITALSETTING", scope.SN, i, wsDataReceivedDIGITALSETTINGDC, null);
                 }
            };
            var _unRegisterListenerDigitalSetting = function (varSerialNum) {
                websocketService.connect();
                for (var i = 1; i <= 8; i++) {
                    websocketService.unRegister("DIGITALSETTING", varSerialNum, i, wsDataReceivedDIGITALSETTINGDC, null);
                 }
            };

            var _unRegisterListener = function () {

              //websocketService.unRegister("INPUTS", scope.SN, '', wsDataReceivedDI, null);
              websocketService.unRegister("DIGITALINPUT", scope.SN, '', wsDataReceivedDI, null);
              websocketService.unRegister("OPTIONDIGITAL", scope.SN, '', wsDataReceivedODI, null);
              websocketService.unRegister("FAULTS", scope.SN, '', wsDataReceivedFAULTS, null);
              timeLapseService.unRegister("INPUTS", scope.SN, '', tlDataReceivedDI);
                scope.liveupdate = false;
                scope.liveData = false;

            };

            scope.$on('updatePreferencesLanguage', function () {
                _drawDigitalChart();
            });

            scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
                scope.applyTimeFormat(timeFormat);
                _drawDigitalChart();
            });

            scope.applyTimeFormat = function (timeFormat) {
                scope.preferredTimeFormat = parseInt(timeFormat);
            };

            scope.$on("$destroy", function () {
                scope.DigitalSettings = [];
                clearInterval(addpoint);
                _unRegisterListener();
                _unRegisterListenerDigitalSetting(scope.SN);
                if (chart) chart.destroy();
                if (!angular.isUndefined(scope.stickyProperties.setting)) scope.stickyProperties.setting = null;
            });
        }
        return {
            link: link
        };
    }]);
mcapp.factory("digitalChartService", ["$http", "HOST", function ($http, HOST) {
    var digitalChartFatory = {};

    var _getData = function (timeZone, deviceId, customerId, startDate, endDate) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DigitalHC?timeZone=' + timeZone + '&deviceId=' + deviceId + '&customerId=' + customerId + '&startDate=' + startDate + '&endDate=' + endDate,
            cache: false
        });
    };

    digitalChartFatory.getData = _getData;
    return digitalChartFatory;
}]);

"use strict";

angular.module("mc.ebpc-config-rtu-setting", []);
"use strict";

function EbpcConfigurationRtuSettingFactory(HOST, $http) {

    // instantiate our initial object
    var EbpcConfigurationRtuSetting = function EbpcConfigurationRtuSetting(customerId) {
        this.customerId = customerId;
    };

    EbpcConfigurationRtuSetting.prototype.getData = function (deviceId) {
        var self = this;
        return $http.get(HOST + "/api/EbpcConfigSetting/GetEbpcConfig" + "?deviceId=" + deviceId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    EbpcConfigurationRtuSetting.prototype.patchEbpcConfigPatch = function (deviceId, emergencyBackupPumpConfig) {
        var self = this;
        return $http.patch(HOST + "/api/EbpcConfigSetting/PatchEbpcConfig" + "?deviceId=" + deviceId, emergencyBackupPumpConfig).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    EbpcConfigurationRtuSetting.prototype.insertDefaultData = function (deviceId) {
        var self = this;
        return $http.post(HOST + "/api/EbpcConfigSetting/PostEbpcConfig" + "?deviceId=" + deviceId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    EbpcConfigurationRtuSetting.prototype.configMMPlusDevice = function (deviceId, imei) {
        var self = this;
        return $http.post(HOST + "/api/Gen2/DeviceConfig/ConfigMMPlusDevice" + "?customerId=" + this.customerId + "&deviceId=" + deviceId + "&imei=" + imei).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return EbpcConfigurationRtuSetting;
}

EbpcConfigurationRtuSettingFactory.$inject = ['HOST', '$http'];

angular.module('mc.ebpc-config-rtu-setting').factory('EbpcConfigurationRtuSettingFactory', EbpcConfigurationRtuSettingFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function EbpcConfigurationController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, deviceMenuService, wizardSplashService, EbpcConfigurationRtuSettingFactory, deviceService, commandOptionsService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.hasModbusRTU = false;
    ctrl.isMyDro = false;
    ctrl.noEbpcConfig = false;

    ctrl.numberOfPumps = [{ id: 1, name: '1', pump: 1 }, { id: 2, name: '2', pump: 2 }];

    ctrl.highFloatDIs = [{ id: 1, name: '3', highFloatDI: 3 }, { id: 2, name: '4', highFloatDI: 4 }, { id: 3, name: '5', highFloatDI: 5 }, { id: 4, name: '6', highFloatDI: 6 }, { id: 5, name: '7', highFloatDI: 7 }, { id: 6, name: '8', highFloatDI: 8 }, { id: 7, name: '9', highFloatDI: 9 }, { id: 8, name: '10', highFloatDI: 10 }, { id: 9, name: '11', highFloatDI: 11 }, { id: 10, name: '12', highFloatDI: 12 }, { id: 11, name: '13', highFloatDI: 13 }, { id: 12, name: '14', highFloatDI: 14 }, { id: 13, name: '15', highFloatDI: 15 }, { id: 14, name: '16', highFloatDI: 16 }];

    ctrl.lowFloatDIs = [{ id: 1, name: '3', lowFloatDI: 3 }, { id: 2, name: '4', lowFloatDI: 4 }, { id: 3, name: '5', lowFloatDI: 5 }, { id: 4, name: '6', lowFloatDI: 6 }, { id: 5, name: '7', lowFloatDI: 7 }, { id: 6, name: '8', lowFloatDI: 8 }, { id: 7, name: '9', lowFloatDI: 9 }, { id: 8, name: '10', lowFloatDI: 10 }, { id: 9, name: '11', lowFloatDI: 11 }, { id: 10, name: '12', lowFloatDI: 12 }, { id: 11, name: '13', lowFloatDI: 13 }, { id: 12, name: '14', lowFloatDI: 14 }, { id: 13, name: '15', lowFloatDI: 15 }, { id: 14, name: '16', lowFloatDI: 16 }];

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyProperties = ctrl.stickyProperties;
        ctrl.loading = true;
        ctrl.popoverConfigHistoryListIsOpen = false;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(_this2);
        ctrl.EbpcConfigurationRtuSettingFactory = new EbpcConfigurationRtuSettingFactory(ctrl.accountInfo.customerId);

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.adjustSize = function () {
                var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                ctrl.popup.parent().css("height", _tmpHeight);
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            };
        };
    };

    ctrl.getData = function () {
        ctrl.EbpcConfigurationRtuSettingFactory.getData(ctrl.deviceId).then(function (result) {
            ctrl.data = result.data;
            //if (ctrl.data.numberOfPumps === null || ctrl.data.numberOfPumps === undefined) {
            //    ctrl.data.numberOfPumps = 1;
            //    ctrl.postData('numberOfPumps');
            //}
            //if (ctrl.data.highFloatDI === null || ctrl.data.highFloatDI === undefined) {
            //    ctrl.data.highFloatDI = 1;
            //    ctrl.postData('highFloatDI');
            //}
            //if (ctrl.data.lowFloatDI === null || ctrl.data.lowFloatDI === undefined) {
            //    ctrl.data.lowFloatDI = 5;
            //    ctrl.postData('lowFloatDI');
            //}

            // ctrl.getMQTTBrokerPorts();
            ctrl.getImeiAndModel();
            //ctrl.getConfigData();
            if (!ctrl.data) {
                ctrl.noEbpcConfig = true;
                ctrl.setDefaultData();
                //ctrl.alertMessage = "Please configure the device as Gen 2";
                ctrl.configButtonVisible = false;
            } else {
                ctrl.configButtonVisible = true;
            }
        }, function (error) {
            //error
        });
    };

    ctrl.getImeiAndModel = function () {
        deviceService.getDevice(ctrl.deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
            ctrl.imei = datafromFactory.data.imei;
            ctrl.model = datafromFactory.data.model;
            if (ctrl.model == 18 || ctrl.model == 19) ctrl.isMyDro = true;
            ctrl.loading = false;
        }, function (error) {
            //error

        }).then(function (data) {
            $scope.loadingInProgress = false;
        });
    };

    ctrl.postData = function (path) {
        if (ctrl.noEbpcConfig) {
            ctrl.EbpcConfigurationRtuSettingFactory.insertDefaultData(ctrl.deviceId).then(function (result) {
                ctrl.data = result.data;
                ctrl.configButtonVisible = true;
                ctrl.noEbpcConfig = false;
            }, function (error) {
                //error
            });
        } else {
            var tmpData = { "op": "replace", "path": path, "value": ctrl.data[path] };
            ctrl.EbpcConfigurationRtuSettingFactory.patchEbpcConfigPatch(ctrl.deviceId, tmpData).then(function (result) {
                ctrl.data = result.data;
                ctrl.configButtonVisible = true;
            }, function (error) {
                //error
            });
        }
    };

    ctrl.setDefaultData = function () {
        ctrl.data = {
            isEnabled: false,
            numberOfPumps: 2,
            highFloatDI: 4,
            lowFloatDI: 8,
            onTime: 60,
            ioConfig: false
        };
    };

    ctrl.configure = function () {
        //$timeout(function () {
        //    ctrl.EbpcConfigurationRtuSettingFactory.configMMPlusDevice(ctrl.deviceId, ctrl.imei)
        //        .then(function (result) {
        //            //success
        //            var configResult = String(result.data).match(/"[^"\\]*(?:\\.[^"\\]*)*"/gi);
        //            ctrl.alertMessage = "Device Config " + configResult[0] + ": " + configResult[1];
        //            ctrl.setTimeOut();
        //        }, function (error) {
        //            //error
        //            ctrl.alertMessage = "Something went wrong while processing device config request";
        //            ctrl.setTimeOut();
        //        });
        //}, 500);

    };

    ctrl.setTimeOut = function () {
        setTimeout(function () {
            ctrl.alertMessage = null;
        }, 15000); // 15 Seconds
    };
    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    //$scope.$on("$destroy", function () {
    //    //save wizard step status if wizard splash lauched this view.
    //    if ($rootScope.launchedByWizard) {
    //        wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
    //        $rootScope.$broadcast('wizardSplashStepClosed');
    //    }
    //});

    $scope.$parent.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            ctrl.deviceId = newValue;
            var _device = { deviceId: newValue, deviceName: $scope.$parent.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });

            if (!angular.isUndefined(ctrl.currentDevice)) return;

            ctrl.currentDevice = newValue;

            $timeout(function () {
                ctrl.getData();
            }, 0);
        }
    }, true);
};

EbpcConfigurationController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', 'deviceMenuService', 'wizardSplashService', 'EbpcConfigurationRtuSettingFactory', 'deviceService', 'commandOptionsService'];
'use strict';

angular.module('mc.ebpc-config-rtu-setting').component('ebpcConfig', {
    controller: EbpcConfigurationController,
    templateUrl: 'ui/ebpcconfigrtusetting/ebpc-config-rtu-setting-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelectedName: '<'
    }
});
mcapp.factory("deviceService", ["$http", "authenticationService", "HOST", "$rootScope", function ($http, authenticationService, HOST, $rootScope) {
    var deviceFactory = {};
    
    var _getDeviceLookup = function (custid,deviceid) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DeviceLookup?customerId=' + custid + '&deviceId=' + deviceid,
            cache: true,
            async: false
        });
    };

    var _getDevice = function (deviceId, customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/Device?deviceId=' + deviceId + '&customerId=' + customerId,
            cache: true,
            async: false
        });
    };

    var _patchDevice = function (deviceId, customerId, devicePatch) {
        return $http.patch(HOST + "/api/Device?deviceId=" + deviceId + "&customerId=" + customerId + "&uniqueWebID=" + $rootScope.uniqueWebID, devicePatch);
    };

    deviceFactory.getDeviceLookup = _getDeviceLookup;
    deviceFactory.getDevice = _getDevice;
    deviceFactory.patchDevice = _patchDevice;

    return deviceFactory;
}
]);
"use strict";

angular.module("mc.documentation", []);
"use strict";

function DocumentationFactory(HOST, $http) {

    // instantiate our initial object
    var Documentation = function Documentation(customerId, viewName, fileName) {
        this.customerId = customerId;
        this.viewName = encodeURIComponent(viewName);
        this.fileName = fileName;
    };

    Documentation.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + "/api/Documentation" + "?customerId=" + this.customerId + "&viewName=" + this.viewName + "&fileName=" + this.fileName).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    Documentation.prototype.listData = function () {
        var self = this;
        return $http.get(HOST + "/api/Documentation" + "?customerId=" + this.customerId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    Documentation.prototype.listUnDeletedData = function () {
        var self = this;
        return $http.get(HOST + "/api/Documentation" + "?customerId=" + this.customerId + "&unDeleted=true").then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    Documentation.prototype.patchData = function (ID, docPatch) {
        var self = this;
        return $http.patch(HOST + "/api/Documentation?ID=" + ID, docPatch).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    Documentation.prototype.postData = function (ID, newDoc) {
        var self = this;
        return $http.post(HOST + '/api/Documentation' + '?ID=' + ID, newDoc).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return Documentation;
}

DocumentationFactory.$inject = ['HOST', '$http'];

angular.module('mc.documentation').factory('DocumentationFactory', DocumentationFactory);
"use strict";

function DocumentationController($, $rootScope, $scope, DocumentationFactory, authenticationService, $timeout, $element, $window) {
    var ctrl = this;

    ctrl.$onChanges = function (changes) {
        if ($rootScope.mobile) return;
        if (angular.isDefined(changes.stickyProperties.currentValue) && changes.stickyProperties.currentValue != changes.stickyProperties.previousValue) {
            var viewName = changes.stickyProperties.currentValue.device.channel;
            viewName = viewName == 0 ? "Documentation" : viewName;
            // Updating Mc Digital Gauge to Digital Gauge
            if (/^Mc\s+/i.test(viewName)) {
                viewName = viewName.replace(/^Mc\s+/i, '');
            }
            ctrl.getDocument(viewName);
        }
    };

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        //Need for old directives/services to work properly: Dialog (open-view-service.js), Select Device (device-lookup-module.js), Save Desktop... ??when $compileProvider.preAssignBindingsEnabled(true);
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        $scope.deviceSelected = ctrl.deviceSelected;
        $scope.stickyProperties = ctrl.stickyProperties;
        $element.find(".dropdown-menu").css("max-height", "400px").css("overflow-y", "auto");

        ctrl.getMenuOptions();
    };

    ctrl.getMenuOptions = function () {
        ctrl.activeDocumentationList = JSON.parse($window.sessionStorage.accountInfo).activeDocumentationList;
        ctrl.menuOptions = ctrl.activeDocumentationList.filter(function (item) {
            return item.active && !item.isDeleted;
        });
        var grouped = {};
        ctrl.menuOptions.forEach(function (item) {
            var words = item.viewName.trim().split(/\s+/);
            var group = words[0];
            for (var i = Math.min(3, words.length); i > 0; i--) {
                var prefix = words.slice(0, i).join(' ');
                var count = ctrl.menuOptions.filter(function (x) {
                    return x.viewName.indexOf(prefix) === 0;
                }).length;

                if (count > 1 || i === 1) {
                    group = prefix;
                    break;
                }
            }
            if (!grouped[group]) {
                grouped[group] = [];
            }
            grouped[group].push(item);
        });

        ctrl.groupedMenuOptions = Object.keys(grouped).map(function (key) {
            return {
                group: key,
                items: grouped[key]
            };
        });
    };

    ctrl.getDocument = function (viewName) {
        ctrl.accountInfo = angular.isDefined(ctrl.accountInfo) ? ctrl.accountInfo : authenticationService.getAccountInfo();
        ctrl.fileName = "";
        ctrl.viewName = "";

        if (viewName.includes(".html")) {
            ctrl.fileName = viewName;
        } else {
            ctrl.viewName = viewName;
        }
        var _documentation = new DocumentationFactory(ctrl.accountInfo.customerId, ctrl.viewName, ctrl.fileName);

        _documentation.getData().then(function () {
            ctrl.documentation = _documentation;
            ctrl.fileHtml = ctrl.documentation.data;

            $timeout(function () {
                angular.element($('.confluence-embedded-image')).ready(function () {

                    var pic_real_width, pic_real_height;
                    $("<img/>") // Make in memory copy of image to avoid css issues
                    .attr("src", $('.confluence-embedded-image').attr("src")).load(function () {
                        pic_real_width = this.width; // Note: $(this).width() will not
                        pic_real_height = this.height; // work for in memory images.

                        var _magnify = 600 / pic_real_width;
                        $('.confluence-embedded-image').wrap('<span class="btn btn-primary btn-sm"></span>').css('display', 'block').parent().zoom({
                            magnify: _magnify
                        });
                    });
                });
            }, 0);

            ctrl.loadingInProgress = false;
            //Change Data Attribute
            $('#documentation-title').attr('data-documentation', viewName);
        }, function (error) {
            ctrl.minioError = "ui/documentation/Main-Desktop-View_609320961.html";
            ctrl.loadingInProgress = false;
        });
    };

    ctrl.convertHTMLToPDF = function () {
        var elementHTML = document.getElementById('saveHelpFile');
        // elementHTML.setAttribute("style", "left: 1200px; width: 750px");
        html2canvas(elementHTML, {
            useCORS: true,
            onrendered: function onrendered(canvas) {
                var pdf = new jsPDF('p', 'pt', [elementHTML.clientHeight, elementHTML.clientWidth]);

                var pageHeight = elementHTML.clientHeight;
                var pageWidth = elementHTML.clientWidth;
                //for (var i = 0; i <= elementHTML.clientHeight / pageHeight; i++) {
                //elementHTML.setAttribute("style", "left: 1200px; width: 750px");
                var srcImg = canvas;
                var sX = 0;
                var sY = 0; // start 1 pageHeight down for every new page
                var sWidth = pageWidth;
                var sHeight = pageHeight;
                var dX = 0;
                var dY = 0;
                var dWidth = pageWidth;
                var dHeight = pageHeight;

                window.onePageCanvas = document.createElement("canvas");
                onePageCanvas.setAttribute('width', pageWidth);
                onePageCanvas.setAttribute('height', pageHeight);
                var ctx = onePageCanvas.getContext('2d');
                ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);

                var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);
                var width = onePageCanvas.clientWidth;
                var height = onePageCanvas.height;

                //if (i > 0) // if we're on anything other than the first page, add another page
                //  pdf.addPage(elementHTML.clientWidth, elementHTML.clientHeight); // 8.5" x 12" in pts (inches*72)

                //pdf.setPage(i + 1); // now we declare that we're working on that page
                pdf.addImage(canvasDataURL, 'PNG', 20, 40, width * .82, height * .82); // add content to the page
                //}

                // Save the PDF
                pdf.save('document.pdf');
            }
        });
    };

    $scope.$on('updateActiveDocumentationList', function () {
        ctrl.getMenuOptions();
    });
};

DocumentationController.$inject = ['$', '$rootScope', '$scope', 'DocumentationFactory', 'authenticationService', '$timeout', '$element', '$window'];
'use strict';

angular.module('mc.documentation').component('documentation', {
    controller: DocumentationController,
    templateUrl: 'ui/documentation/documentation-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
'use strict';

angular.module('mc.distributor-device-info-list', []);
"use strict";

function DistributorDeviceInfoListController($, $rootScope, $scope, $location, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, DistributorCustomerInfoListFactory, $timeout, $filter, $element, deviceMenuService, $q, $uibModal, savePdfService) {
    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.customerId = ctrl.accountInfo.customerId;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.alerts = [];

        ctrl.customerName = DistributorCustomerInfoListFactory.getCustomerName();
        ctrl.customerId = DistributorCustomerInfoListFactory.getCustomerId();
        //--------------------------------------------------------------------------------------------------        
        ctrl.downloadViewTypeOptions = [1];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for   
        $scope.alerts = [];

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                //$scope.popup.parent().find('.product-quote-wizard-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }

        ctrl.getDevices();
    };

    ctrl.getDevices = function () {
        DistributorCustomerInfoListFactory.ListCustomerDeviceInfoByCustomerIdDistributorId(ctrl.customerId, ctrl.accountInfo.userId).then(function (result) {
            ctrl.devices = result.data;
            ctrl.viewLoading = false;
            ctrl.refreshAlerts();
        });
    };

    ctrl.getDeviceExpansion = function (device) {
        if (device.tableCreated == 2) return "A";
        if (device.tableCreated == 3) return "D";
        if (device.hasAnalogOutputBoard) return "O";
        if (device.hasPulseData) return "P";

        return "";
    };

    ctrl.getLastHeardTime = function (date) {
        var today = new Date();
        var threeDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 3);
        var lastHeardDate = new Date(date);
        var lastHeardDateWithoutTime = new Date(lastHeardDate.getFullYear(), lastHeardDate.getMonth(), lastHeardDate.getDate());

        if (lastHeardDateWithoutTime > threeDaysAgo) {
            return $scope.translation.text.NOW;
        } else {
            return $filter('date')(date, 'MM/dd/yyyy');
        }
    };

    ctrl.getInvoicedTime = function (date) {
        var invoicedDate = new Date(date);
        var invoicedYear = invoicedDate.getFullYear();

        if (invoicedYear > 2000) {
            return $filter('date')(date, 'MMM yyyy');
        } else {
            return "";
        }
    };

    ctrl.getRadioUpgrade = function (device) {
        if (ctrl.containsSubstring(device.radioType, "H5") || ctrl.containsSubstring(device.radioType, "PH8") || ctrl.containsSubstring(device.radioType, "PXS8") || ctrl.containsSubstring(device.radioType, "EV3")) {
            return $scope.translation.text.YES;
        } else if (ctrl.containsSubstring(device.radioType, "LAT3") && device.softwareVersion < 17) {
            return $scope.translation.text.FIRMWARE;
        } else {
            return $scope.translation.text.NO;
        }
    };

    ctrl.containsSubstring = function (mainStr, subStr) {
        return mainStr.indexOf(subStr) !== -1;
    };

    ctrl.refreshAlerts = function () {
        $scope.alerts = [];
        if (ctrl.devices.length === 0) {
            var errorMessage = ctrl.translation.text.NO_DATA;
            $scope.alerts.push({
                msg: errorMessage,
                type: "info"
            });
        }
    };

    ctrl.openView = function (varUrl) {
        $location.path(varUrl);
    };
}

DistributorDeviceInfoListController.$inject = ['$', '$rootScope', '$scope', '$location', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'DistributorCustomerInfoListFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', '$uibModal', 'savePdfService'];
'use strict';

angular.module('mc.distributor-device-info-list').component('distributorDeviceInfoList', {
    controller: DistributorDeviceInfoListController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/distributordeviceinfolist/distributor-device-info-list-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.distributor-customer-info-list', []);
'use strict';

function DistributorCustomerInfoListFactory(HOST, $http) {

    var customerId = null;

    var customerName = "";

    var customerIdForTicketView = null;

    function getCustomerId() {
        return customerId;
    }

    function setCustomerId(value) {
        customerId = value;
    }

    function getCustomerName() {
        return customerName;
    }

    function setCustomerName(value) {
        customerName = value;
    }

    function getCustomerIdForTicketView() {
        return customerIdForTicketView;
    }

    function setCustomerIdForTicketView(value) {
        customerIdForTicketView = value;
    }

    function getCustomerIdForTicketView() {
        return customerIdForTicketView;
    }

    function setCustomerIdForTicketView(value) {
        customerIdForTicketView = value;
    }

    function ListDistributorCustomerInfoByDistributorId(loginId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/DistributorCustomerInfoList',
            params: { loginId: loginId }
        });
    }

    function ListCustomerDeviceInfoByCustomerIdDistributorId(customerId, loginId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/DistributorCustomerInfoList',
            params: { customerId: customerId, loginId: loginId }
        });
    }

    return {
        ListDistributorCustomerInfoByDistributorId: ListDistributorCustomerInfoByDistributorId,
        ListCustomerDeviceInfoByCustomerIdDistributorId: ListCustomerDeviceInfoByCustomerIdDistributorId,
        getCustomerId: getCustomerId,
        setCustomerId: setCustomerId,
        getCustomerIdForTicketView: getCustomerIdForTicketView,
        setCustomerIdForTicketView: setCustomerIdForTicketView,
        getCustomerName: getCustomerName,
        setCustomerName: setCustomerName
    };
}

DistributorCustomerInfoListFactory.$inject = ['HOST', '$http'];

angular.module('mc.distributor-customer-info-list').factory('DistributorCustomerInfoListFactory', DistributorCustomerInfoListFactory);
"use strict";

function DistributorCustomerInfoListController($, $rootScope, $scope, $location, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, DistributorCustomerInfoListFactory, $timeout, $filter, $element, deviceMenuService, $q, $uibModal, savePdfService) {
    var ctrl = this;
    $scope.alerts = [];
    ctrl.viewLoading = true;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.customerId = ctrl.accountInfo.customerId;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.alerts = [];

        //--------------------------------------------------------------------------------------------------        
        ctrl.downloadViewTypeOptions = [1];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for   
        $scope.alerts = [];

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                //$scope.popup.parent().find('.product-quote-wizard-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find(".description-container").css("height").replace(/[^0-9.]+/g, "") - 155); //25: total padding
            };
        }

        ctrl.getCustomers();
    };

    ctrl.getCustomers = function () {
        $scope.alerts = [];
        DistributorCustomerInfoListFactory.ListDistributorCustomerInfoByDistributorId(ctrl.accountInfo.userId).then(function (result) {
            ctrl.customers = result.data;
            ctrl.viewLoading = false;
            ctrl.refreshAlerts();
        }, function (error) {
            ctrl.viewLoading = false;
            if (error.status === 403) {
                var errorMessage = ctrl.translation.text.ACCESS_DENIED;
                $scope.alerts.push({
                    msg: errorMessage,
                    type: "info"
                });
            }
        });
    };

    ctrl.openDeviceInfoList = function (customerId, customerName) {
        DistributorCustomerInfoListFactory.setCustomerId(customerId);
        DistributorCustomerInfoListFactory.setCustomerName(customerName);

        var optionsStickyProperties = {};
        var position = null;
        position = { my: 'top+120', at: 'center top', of: window };

        if (!ctrl.mobile && !ctrl.classicView) {
            openViewService.openView("Distributor Device Info List", { width: 900, height: 600 }, position, optionsStickyProperties, { minimumWidth: 900, minimumHeight: 600 }, false);
        } else {
            $location.path('/distributordeviceinfolist/distributor-device-info-list-view');
        }
    };

    ctrl.formatPhoneNumberDisplay = function (f_val) {
        if (typeof f_val === "undefined" || !f_val) return f_val;
        f_val = f_val.replace(/\D/g, '');
        //f_val = f_val.substring(0, 1) == "1" ? f_val.substring(1, f_val.lenght) : f_val;
        f_val = f_val.length > 10 ? f_val.replace(/(\d{3})(\d{3})(\d{4})(\d{4})/, "($1) $2-$3 ext. $4") : f_val.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        return f_val;
    };

    ctrl.viewTicket = function (customerId) {
        DistributorCustomerInfoListFactory.setCustomerIdForTicketView(customerId);

        var optionsStickyProperties = {};
        var position = null;
        position = { my: 'top+120', at: 'center top', of: window };

        if (!ctrl.mobile && !ctrl.classicView) {
            openViewService.openView("Ticket System", { width: 900, height: 600 }, position, optionsStickyProperties, { minimumWidth: 900, minimumHeight: 600 }, true);
        } else {
            $location.path('/ticketsystem/ticket-system-template');
        }
    };

    ctrl.refreshAlerts = function () {
        $scope.alerts = [];
        if (ctrl.customers.length === 0) {
            var errorMessage = ctrl.translation.text.NO_DATA;
            $scope.alerts.push({
                msg: errorMessage,
                type: "info"
            });
        }
    };
}

DistributorCustomerInfoListController.$inject = ['$', '$rootScope', '$scope', '$location', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'DistributorCustomerInfoListFactory', '$timeout', '$filter', '$element', 'deviceMenuService', '$q', '$uibModal', 'savePdfService'];
'use strict';

angular.module('mc.distributor-customer-info-list').component('distributorCustomerInfoList', {
    controller: DistributorCustomerInfoListController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/distributorcustomerinfolist/distributor-customer-info-list-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.factory('openViewService', ['$rootScope', 'dialogService', 'translationService', 'sharedSetupService', '$timeout', '$compile', function ($rootScope, dialogService, translationService, sharedSetupService, $timeout, $compile) {
    var _weatherMode = ""; //Sm, Lg
    var unixDay = sharedSetupService.unixDay;
    var openViewFactory = {};
    //Dialogs with these titles behave as "Single Instance"
    var singleViewArray = [
        "Overview",
        "Electronic Keys",
        "Dashboard",
        "Preferences",
        "User Preferences",
        "Customer Preferences",
        "Notification Rules",
        "Map",
        "Paging",
        "Digital Interconnect List",
        "Analog Interconnect List",
        "Analog Interconnect Setup",
        "Digital Interconnect Setup",
        "Ticket System",
        "Destinations",
        "Runtime Variance",
        "Tank And Well Overview",
        "Revision Log",
        "Audit History",
        "Update Username",
        "Update Password",
        "Manage User Accounts",
        "User Accounts",
        "Blocked Access",
        "Memory Cache Manager",
        "User Terms",
        "Contact Information",
        "Signal Connect",
/*        "Signal Connect Chart",*/
        "Register Webinar",
        "Customer List",
        "Search Customer",
        "Customer Search",
        "Customer Lookup",
        "Help Documents",
        "Map Marker",
        "Style Guide",
        "Monthly Flow Summary",
        "Schedules Legacy",
    ];

    var singleViewArrayPortal = [
        "Device Status"
    ];
    //Dialogs with these title+deviceid behave as "Single Instance"
    var singleViewArrayAndId = [
        "Notification Schedule",
        "RTU View",
        "Marker Customer",
        "Marker Rural Water Association",
        "Marker Distributor",
        "Tank And Well Setup"
    ];

    var _findElement = function (propValue) {
        for (var i = 0; i < $rootScope.arrPopup.length; i++) {
            if ($rootScope.arrPopup[i]["desktopIndex"] == propValue) {
                return i;
            }
        }
        return -1;
    }

    var _findElementAndId = function (propValue, deviceId) {
        for (var i = 0; i < $rootScope.arrPopup.length; i++) {
            if ($rootScope.arrPopup[i]["desktopName"] == propValue && $rootScope.arrPopup[i].desktopValue.deviceId == deviceId) {
                return $rootScope.arrPopup[i]["desktopIndex"];
            }
        }
        return "";
    }

    var _findWeatherElement = function (propValue) {
        for (var i = 0; i < $rootScope.arrPopup.length; i++) {
            if ($rootScope.arrPopup[i]["desktopName"] == propValue) {
                return i;
            }
        }
        return -1;
    }

    var getMinWindowSizes = function (viewName) {
        switch (viewName) {
            case "Tank And Well Detail":
                return {
                    minimumWidth: 700, minimumHeight: 530
                };
            case "Tank And Well Chart":
                return {
                    minimumWidth: 300, minimumHeight: 300
                };
            case "Tank And Well Setup":
                return {
                    minimumWidth: 800, minimumHeight: 510
                };
            case "Tank And Well Overview":
            case "Tank And Well Log":
            case "MM Plus Config History":
            case "MM Plus Network History":
            case "MM Plus Channel History":
                return {
                    minimumWidth: 500, minimumHeight: 300
                };
            case "Volumetric Flow Table":
                return {
                    minimumWidth: 535, minimumHeight: 400
                };
            case "Alarm Rule Test":
                return {
                    minimumWidth: 800, minimumHeight: 500
                };
            case "Notification Rules":
                return {
                    minimumWidth: 850, minimumHeight: 350
                };
            case "Daily Station Summary":
            case "Management Report":
                return {
                    minimumWidth: 600, minimumHeight: 300
                };
            case "Download":
                return {
                    minimumWidth: 400, minimumHeight: 375
                };
            case "RTU View":
                return {
                    minimumWidth: 300, minimumHeight: 280
                };
            case "RTU Info":
            case "RTU Setting":
            case "MM Plus RTU Setting":
            case "All Devices":
                return {
                    minimumWidth: 875, minimumHeight: 600
                };
            case "Integrated Flow Report":
                return {
                    minimumWidth: 700, minimumHeight: 600
                };
            case "Pump Duty Cycle Plot":
                return {
                    minimumWidth: 700, minimumHeight: 500
                };
            case "Supergraph":
                return {
                    minimumWidth: 600, minimumHeight: 500
                };
            case "Destinations":
                return {
                    minimumWidth: 850, minimumHeight: 350
                }
            case "Analog Chart Recorder":
                return {
                    minimumWidth: 550, minimumHeight: 550
                }
            case "Analog Chart":
            case "Analog Table":
            case "Analog Gauge":
            case "Analog Output Chart":
            case "Analog Output Table":
            case "Analog Output Gauge":
            case "Mc Analog Gauge":
            case "Mc Analog Output Gauge":
            case "Mc Status Gauge":
            case "Mc Switch Gauge":
            case "Mc Runtime Gauge":
            case "Mc Digital Gauge":
            case "Signal Chart":
            case "Signal Table":
            case "Signal Gauge":
            case "Temperature Chart":
            case "Temperature Table":
            case "Temperature Gauge":
            case "Mc Temperature Gauge":
            case "Digital Chart":
            case "Digital Table":
            case "Digital Gauge":
            case "Voltage Chart":
            case "Voltage Table":
            case "Voltage Gauge":
            case "Pump Chart":
            case "Pump Table":
            case "Volumetric Flow Chart":
            case "Pulse Flow Chart":
            case "Pulse Flow Table":
            case "Pulse Flow Gauge":
                return {
                    minimumWidth: 350, minimumHeight: 350
                };
            case "Signal Calendar":
            case "Pulse Flow Calendar":
            case "Rainfall Calendar":
            case "Station Notes":    
                return {
                    minimumWidth: 600, minimumHeight: 500
                };
            case "Voltage Widget":
            case "Analog Widget":
            case "Signal Widget":
                return {
                    minimumWidth: 170, minimumHeight: 170
                };
            case "Pump Peak Flow Capacity Estimator":
                return {
                    minimumWidth: 800, minimumHeight: 600
                };
            case "Dashboard":
                return {
                    minimumWidth: 500, minimumHeight: 100
                };
            case "Documentation":
                return {
                    minimumWidth: 500,
                    minimumHeight: 300
                };
            case "WTS Customer Management":
                return {
                    minimumWidth: 800,
                    minimumHeight: 400
                };
            case "Map Marker":
                return {
                    minimumWidth: 250, minimumHeight: 250
                };
            case "Marker Customer":
            case "Marker Distributor":
                return {
                    minimumWidth: 250, minimumHeight: 250
                };
            case "Marker Rural Water Association":
                return {
                    minimumWidth: 300, minimumHeight: 250
                };
            case "Audit History":
                return {
                    minimumWidth: 750, minimumHeight: 300
                };
            case "MyLevel":
                return {
                    minimumWidth: 340, minimumHeight: 530
                };
            case "User Accounts":
            case "Memory Cache Manager":
            case "Blocked Access":
                return {
                    minimumWidth: 900, minimumHeight: 590
                };
            default:
                return undefined;
        }
    };

    var getWindowSize = function (viewName) {
        switch (viewName) {
            case "Dashboard":
                return {
                    width: 750, height: 450
                };
            case "RTU Configuration":
                return {
                    width: 775, height: 400
                }
            default:
                return undefined;
        }
    };

    var _allowViewResize = function (viewName) {
        switch (viewName) {
            case "RTU View":
                return false;
            default:
                return true;
        }
    };

    // Adjusting the views that are opened based on Menu Seen/Hidden
    $rootScope.$on('menuPosition', function(event, args) {
        $rootScope.menuHidden = args;
        // Adjust the initial offset for all dialogs based on whether the menu is hidden
        angular.forEach($rootScope.arrPopup, function(popup) {
            var dialogRef = _this.getExistingDialog(popup.desktopIndex).ref;
            var isSavedDesktop = popup.saveDesktop;
            if (!isSavedDesktop) {
            if (dialogRef && dialogRef.dialog("isOpen")) {
                // Only adjust left dialogs
                var updatedPosition = dialogRef.dialog("option", "position");
                if (updatedPosition.my && updatedPosition.my.indexOf("left") === 0) {
                    var tmpPosition;
                    // Setting default value for view when Menu is hidden or seen
                    var menuOffset = $rootScope.menuHidden ? 100 : 360;
                    var menuTopOffset = 10;
                    // Getting the value of updated left/top position
                    if (updatedPosition.my == "left top") {
                        tmpPosition = updatedPosition.at;
                    } else if (updatedPosition.at == "left top") {
                        tmpPosition = updatedPosition.my;
                    }
                    // Extracting the value for Left and Top 
                    var match = tmpPosition.match(/left\+(\d+)/);
                    var numberLeft = parseInt(match[1])
                    var topMatch = tmpPosition.match(/top\+(\d+)/);
                    var numberTop = parseInt(topMatch[1])
                    // Adjust top position to updated value
                    menuTopOffset = numberTop;
                    // Adjust left position based on the current dialog's position
                    if (numberLeft) {
                        if (menuOffset == 360) {
                            menuOffset = numberLeft - 100 + menuOffset;
                            if (menuOffset < 0) menuOffset = 360;
                        } else if (menuOffset == 100) {
                            menuOffset = numberLeft - 360 + menuOffset;
                            if (menuOffset < 0) menuOffset = 100;
                        }
                    }

                    // Update the dialog position individually
                    dialogRef.dialog("option", "position", { 
                        my: "left+" + menuOffset + " top+" + menuTopOffset, 
                        at: "left top", 
                        of: window 
                    });
                }
            }
        }
        });
    });

    // based on Menu hiddden/seen below code will set left/top
    var _getDialogPosition = function(objPosition, viewType, menuHidden) {
        var menuOffset = menuHidden ? 100 : 360;
        var newPosition;

        switch (typeof objPosition) {
            case 'string': {
                var parsed = JSON.parse(objPosition);
                newPosition = { my: parsed.my, at: parsed.at, of: window };
                break;
            }
            case 'object':
                // if (objPosition && objPosition.at === "left top") {
                //     newPosition = {my: "left+" + menuOffset + " top+10", at: "left top", of: window};
                // } else {
                    newPosition = objPosition;
                // }
                break;

            default:
                switch (viewType) {
                    case 0:
                    case 1:
                    case 4:
                        newPosition = {
                            my: "left+" + menuOffset + " top+10", at: "left top", of: window};
                        break;
                    case 2:
                        newPosition = {
                            my: "right-250 bottom-350", at: "right bottom", of: window};
                        break;
                    case 3:
                        newPosition = {
                            my: "right-180 top+150", at: "right top", of: window};
                        break;
                    default:
                        newPosition = {
                            my: "left+" + menuOffset + " top+10", at: "left top", of: window};
                }
        }

        return newPosition;
    }

    var _openView = function (varType, objSize, objPosition, varStickyProperties, objMinimumSize, objModal) {

        var tmpIndex;

        if (!varType) return ""; // SCADA-1745 white space was clicked

        var viewType = varType.indexOf("Widget") > -1 && varType.indexOf("Perfect Widget") <= -1 ? 1 : 0; //Chart, Table: 0; Widget: 1

        //TODO: Maybe not, but for now
        if (varType == "RTU View")
            viewType = 4;

        if (varType.indexOf("Weather") > -1) {
            tmpIndex = _findWeatherElement(varType);
            if (tmpIndex != -1) {
                _this.getExistingDialog($rootScope.arrPopup[tmpIndex].desktopIndex).ref.dialog("close");
            }
            viewType = _weatherMode == "" ? 2 : _weatherMode == "Sm" ? 3 : 0; //0 - nothing
            _weatherMode = _weatherMode == "" ? "Sm" : _weatherMode == "Sm" ? "Lg" : "";

            if (_weatherMode == "") {
                if (typeof $rootScope.arrPopup[tmpIndex] !== 'undefined')
                    _this.getExistingDialog($rootScope.arrPopup[tmpIndex].desktopIndex).ref.dialog("close");
                return false;
            }
        }

        ////////////////////////////////////////////////////
        ////////////////////////////////////////////////////
        ////////////////////////////////////////////////////
        var _mcPumpWidgets = ["Mc", "Pump", "Widget"];
        var _mcPumpWidgetTitle = "Mc Empty Title";
        var _isMcPumpWidget = false;

        for (var i = 0, ln = _mcPumpWidgets.length; i < ln; i++) {
            if (varType.indexOf(_mcPumpWidgets[i]) !== -1) {
                _isMcPumpWidget = true;
                break;
            }
        }

        var tmpTitle = _isMcPumpWidget ? _mcPumpWidgetTitle : varType;

        //Pump Service Report and Pump Alarm Data views have pump in their names and would be considerred as McPumpWidget, so added code to revert to use original title
        if (varType == "Pump Service Report" || varType == "Pump Alarm Data") tmpTitle = varType;
        ////////////////////////////////////////////////////
        ////////////////////////////////////////////////////
        ////////////////////////////////////////////////////

        var _tmpSingleView = _singleView(varType);
        if (_tmpSingleView) {
            var _popup = _this.getExistingDialog(varType).ref;
            _popup.dialogExtend("restore");
            _popup.dialog("moveToTop").effect("pulsate", 100);
            return false;
        }

        var _tmpSingleViewAndId = typeof varStickyProperties !== 'undefined' ? _singleViewAndId(varType, varStickyProperties) : "";
        if (_tmpSingleViewAndId !== "") {
            var _popup = _this.getExistingDialog(_tmpSingleViewAndId).ref;
            _popup.dialogExtend("restore");
            _popup.dialog("moveToTop").effect("pulsate", 100);
            return false;
        }

        var _translation = translationService.translation;

        var newDivID = varType.trim();
        var newDivIDtmp = newDivID;

        for (var i = 0; i < 100; i++) {
            var _findId = _findElement(newDivID);
            if (_findId === -1) {
                i = 100;
            }
            else {
                newDivID = newDivIDtmp + "_" + i;
            }
        }

        // Adding below condition to keep the actual code seperate from Hide/Show Menu
        // Adding Property Name = saveDesktop helps to identify the views that are under Saved Desktop and should not be shifted when Hide/Show button is clicked
        if ($rootScope.showStartButtonState === false) {
            // varStickyProperties is added if the view belongs to Saved Desktop 
            if (varStickyProperties) {
                var _desktopView = { "desktopIndex": newDivID, "desktopName": newDivIDtmp, "desktopValue": {},"saveDesktop": varStickyProperties.savedDesktop };
                $rootScope.arrPopup.push(_desktopView);
            } else {
                var _desktopView = { "desktopIndex": newDivID, "desktopName": newDivIDtmp, "desktopValue": {},"saveDesktop": false };
                $rootScope.arrPopup.push(_desktopView);
            }
        } else {
            //newDivID = newDivIDtmp.substring(0, 7) == "Weather" ? newDivIDtmp : newDivID;
            var _desktopView = { "desktopIndex": newDivID, "desktopName": newDivIDtmp, "desktopValue": {} };
            $rootScope.arrPopup.push(_desktopView);
        }

        //get view's size
        var windowSize = getWindowSize(varType);
        //if the retrieved value is not null, asign the value to objSize if not provided
        if (!objSize && windowSize) { objSize = windowSize };

        //get view's minimum size
        var minimumSetting = getMinWindowSizes(varType);
        //if the retrieved value is not null, asign the value to objMinimumSize
        if (minimumSetting) { objMinimumSize = minimumSetting };

        var newWidth, newHeight, newMinimumWidth, newMinimumHeight, newModal;
        switch (typeof objSize) {
            case 'string':
                newWidth = JSON.parse(objSize).width;
                newHeight = JSON.parse(objSize).height;
                break;
            case 'object':
                newWidth = objSize.width;
                newHeight = objSize.height;
                break;
            default: //case 'undefined':
                switch (viewType) {
                    case 0:
                        newWidth = 630;
                        newHeight = 530;
                        break;
                    case 1:
                        newWidth = 230;
                        newHeight = 230;
                        break;
                    case 2:
                        newWidth = 340;
                        newHeight = 110;
                        break;
                    case 3:
                        newWidth = 640;
                        newHeight = 130;
                        break;
                    default: //case 'undefined':
                        newWidth = 630;
                        newHeight = 530;
                }
        }

        switch (typeof objMinimumSize) {
            case 'string':
                newMinimumWidth = JSON.parse(objMinimumSize).minimumWidth;
                newMinimumHeight = JSON.parse(objMinimumSize).minimumHeight;
                break;
            case 'object':
                newMinimumWidth = objMinimumSize.minimumWidth;
                newMinimumHeight = objMinimumSize.minimumHeight;
                break;
            default: //case 'undefined':
                switch (viewType) {
                    case 0:
                        newMinimumWidth = 400;
                        newMinimumHeight = 400;
                        break;
                    case 1:
                        newMinimumWidth = 120;
                        newMinimumHeight = 120;
                        break;
                    case 2:
                        newMinimumWidth = 340;
                        newMinimumHeight = 110;
                        break;
                    case 3:
                        newMinimumWidth = 640;
                        newMinimumHeight = 130;
                        break;
                    case 4:
                        newMinimumWidth = 250;
                        newMinimumHeight = 0;
                        break;
                    default:
                        newMinimumWidth = 400;
                        newMinimumHeight = 400;
                }
        }

        switch (typeof objModal) {
            case 'string':
                newModal = objModal == 'true' ? true : false;
                break;
            case 'boolean':
                newModal = objModal;
                break;
            default:
                newModal = false;
        }

        //compare height, width with minimumHeight and minimumWidth
        if (newHeight < newMinimumHeight) { newHeight = newMinimumHeight };
        if (newWidth < newMinimumWidth) { newWidth = newMinimumWidth };

        //compare height, width with window size height/width
        //the visible desktop wins over the configured minimums, otherwise controls end up off screen
        //with no way to reach them at high browser zoom levels (WCAG 1.4.10)
        var currentDesktopSize = sharedSetupService.getWindowSize();
        var taskbarHeight = 42;
        if ((newHeight + taskbarHeight) > currentDesktopSize.height) newHeight = currentDesktopSize.height - taskbarHeight;
        //the dialog border/padding render outside the width option, so stay 10px inside the window
        if ((newWidth + 10) > currentDesktopSize.width) newWidth = currentDesktopSize.width - 10;
        if (newMinimumHeight > newHeight) newMinimumHeight = newHeight;
        if (newMinimumWidth > newWidth) newMinimumWidth = newWidth;

        var newPosition;
        // Adjusting the views that populate on Left Side for Show/Hide Menu
        if ($rootScope.showStartButtonState === false) {
            newPosition = _getDialogPosition(objPosition, viewType, $rootScope.menuHidden);
        } else {
        switch (typeof objPosition) {
            case 'string':
                var my = JSON.parse(objPosition).my;
                var at = JSON.parse(objPosition).at;
                newPosition = { my: my, at: at, of: window };
                break;
            case 'object':
                newPosition = objPosition;
                break;
            default: //case 'undefined':
                switch (viewType) {
                    case 0:
                    case 1:
                    case 4:
                        newPosition = { my: "left+100 top+10", at: "left top", of: window };
                        break;
                    case 2:
                        newPosition = { my: "right-250 bottom-350", at: "right bottom", of: window };
                        break;
                    case 3:
                        newPosition = { my: "right-180 top+150", at: "right top", of: window };
                        break;
                    default:
                        newPosition = { my: "left+100 top+10", at: "left top", of: window };
                }
        }
        }

        //when the view is wider than the space right of its default offset, pull it left so it opens fully on screen (high browser zoom)
        if (newPosition && typeof newPosition.my === 'string' && newPosition.at === 'left top') {
            var positionMatch = newPosition.my.match(/^left\+(\d+) top\+(\d+)$/);
            if (positionMatch && (parseInt(positionMatch[1], 10) + newWidth + 10) > currentDesktopSize.width) {
                var maxLeftOffset = currentDesktopSize.width - newWidth - 10;
                if (maxLeftOffset < 0) maxLeftOffset = 0;
                newPosition = { my: "left+" + maxLeftOffset + " top+" + positionMatch[2], at: "left top", of: window };
            }
        }

        var titleCustomerName = varStickyProperties == null
            || varStickyProperties.adminPortal == null
            || varStickyProperties.adminPortal.customerName == null
            ? ""
            : ": " + varStickyProperties.adminPortal.customerName;

        // jQuery UI dialog options
        var options = {
            autoOpen: false,
            modal: newModal,
            width: newWidth, //575
            height: newHeight, //600
            minWidth: newMinimumWidth,
            minHeight: newMinimumHeight,
            fluid: true,
            resizable: (viewType < 2),
            position: newPosition,
            title: eval("_translation.text." + tmpTitle.toUpperCase().replace(/ /g, "_")) + titleCustomerName,
            dialogClass: newDivID.replace(/ /g, "_"),
            show: { effect: "fade", duration: 400, easing: "easeInQuad" },
            hide: { effect: "fade", duration: 300, easing: "easeOutQuad" },
            open: function (event, ui) {
                var tmpTmp = _getIcon(varType);
                $(this).dialog('widget').css("height", $(this).dialog('widget').css("height"));
                $(this).dialog('widget').attr("mc-view-name", newDivIDtmp);
                if (viewType !== 1) $(this).dialog('widget').find("div.ui-dialog-titlebar.ui-widget-header").prepend(tmpTmp);
                $(this).dialog('widget').find(".ui-dialog-titlebar-close").find("span").removeClass("ui-button-icon-primary").removeClass("ui-icon");
                $(this).dialog('widget').find(".ui-dialog-titlebar-collapse, .ui-dialog-titlebar-maximize, .ui-dialog-titlebar-minimize, .ui-dialog-titlebar-restore").find("span").removeClass("ui-icon").html("");
                if (viewType == 1) {
                    $(this).dialog('widget').find("div.ui-dialog-titlebar.ui-widget-header").addClass('mc-widget-header-titlebar');
                    $(this).dialog('widget').find(".ui-dialog-titlebar-close").addClass("mc-close-widget");
                    $(this).dialog('widget').addClass('ui-widget-content2');
                    $(this).dialog('widget').removeClass('box-shadow');
                }
                else if (viewType == 1 || viewType == 2 || viewType == 3) {
                    $(this).dialog('widget').find("div.ui-dialog-titlebar.ui-widget-header").hide();
                    $(this).dialog('widget').addClass('ui-widget-content2');
                    $(this).dialog('widget').removeClass('box-shadow');
                }
                //else {
                attachUpdatePreferencesLanguage(event);
                //}
            },
            close: function (event, ui) {
                $rootScope.arrPopup.splice(_findElement(newDivID), 1);
                _closeHelpPanel();
            },
            resize: function (event, ui) {
                if (viewType == 0) {
                    adjustContentSize(this);
                }
            },
            resizeStart: function (event, ui) {
                $('#map').addClass('no-events');
            },
            resizeStop: function (event, ui) {
                $('#map').removeClass('no-events');
            },
            dragStart: function (event, ui) {
                var _thisWidget = $(this).dialog('widget');
                _thisWidget.find(".device-id-menu").trigger("click");
                if (_thisWidget.find(".dropdown-menu.dropdown-menu-form").css("display") === "block") _thisWidget.find(".dropdown-toggle").trigger("click");
                $(this).dialog("moveToTop");
                $(this).parent().css("opacity", ".70");
                $(this).parent().css("filter", "Alpha(opacity = 70)");
            },
            dragStop: function (event, ui) {
                $(this).parent().css("opacity", "1");
                $(this).parent().css("filter", "Alpha(opacity = 100)");
                sharedSetupService.adjustPopupTopPosition($(this));
            },
            create: function (e, ui) {
                if (viewType == 0 || viewType == 4) {
                    $(this).css('overflow', 'hidden');
                    $(this).dialog('widget').find(".ui-dialog-titlebar-close").css("height", "24px").css("width", "24px");
                    $(this).dialog('widget').css("box-shadow", "#515151 1px 1px 1px");
                    $(this).dialog('widget').find('.ui-dialog-titlebar').removeClass('ui-corner-all').addClass('ui-corner-top');
                }
                if (viewType == 1) {
                    $(this).dialog('widget').css('overflow', 'visible');
                    $(this).dialog('widget').find("div.ui-widget-content ").css('overflow', 'hidden');
                    $(this).dialog('widget').draggable('option', {
                        cancel: '',
                        handle: '.dragwidget, .ui-dialog-titlebar'
                    });
                    $(this).dialog('widget').removeClass('ui-widget-content');
                    $(this).dialog('widget').addClass('ui-widget-content2');
                }
                if (viewType == 2 || viewType == 3) {
                    $(this).dialog('widget').css('overflow', 'visible');
                    $(this).dialog('widget').find("div.ui-widget-content ").css('overflow', 'hidden');
                    $(this).dialog('widget').css("box-shadow", "#515151 1px 1px 1px");
                    $(this).dialog('widget').draggable('option', {
                        cancel: '.ui-dialog-titlebar-close',
                        handle: '.ui-widget-header',
                        cursor: 'pointer'
                    });
                }
                if (viewType == 4) {
                    $(this).dialog('widget').css("opacity", 0);
                }
            }
        };

        // When Static Menu is visible Minimised view position is 305px and for Dynamic 265px
        var minimizeLeft = $rootScope.showStartButtonState ? "265px" : "305px";

        // dialog-extend options
        var optionsExt = {
            closable: (viewType != 1),
            maximizable: (viewType < 1),
            minimizable: (!newModal && (viewType < 1 || viewType == 4)),
            collapsable: (!newModal && viewType < 1),
            dblclick: false, //'minimize' || false,
            minimizeLocation: 'left',
            minimize: function (event, ui) {
                $("#dialog-extend-fixed-container").css("left", minimizeLeft);
            },
            maximize: function (event, ui) {
                var self = this;
                $timeout(function () {
                    _adjustContentSizeStart(_this.getExistingDialog(newDivID).ref);
                    adjustContentSize(self);
                });
            },
            restore: function (event, ui) {
                var self = this;
                $timeout(function () {
                    _adjustContentSizeStart(_this.getExistingDialog(newDivID).ref);
                    adjustContentSize(self);
                });
            },
            icons: {
                "close": "fa fa-times",
                "collapse": "dlgexTitlebarCo fa fa-caret-down",
                "maximize": "dlgexTitlebarMa fa fa-external-link",
                "minimize": "dlgexTitlebarMi fa fa-minus",
                "restore": "dlgexTitlebarRe fa fa-expand"
            }
        };

        // initial-state options
        var _isOn, _isSavedDesktop, _isUpdate, _isAdminPortal, _isDeviceId, _isDateMin, _isDateMax, _isZoomMin, _isZoomMax, _isDataFormat, _isView, _isSetting, _runtimeType;
        switch (typeof varStickyProperties) {
            case 'string':
                _isOn = true;
                _isSavedDesktop = JSON.parse(varStickyProperties).savedDesktop;
                _isAdminPortal = JSON.parse(varStickyProperties).adminPortal;
                _isDeviceId = JSON.parse(varStickyProperties).deviceId;
                _isAnalogIntertieId = JSON.parse(varStickyProperties).analogIntertieId;
                _isDevice = JSON.parse(varStickyProperties).device;
                _isDateMin = JSON.parse(varStickyProperties).dateMin;
                _isDateMax = JSON.parse(varStickyProperties).dateMax;
                _isZoomMin = JSON.parse(varStickyProperties).zoomMin;
                _isZoomMax = JSON.parse(varStickyProperties).zoomMax;
                _isDataFormat = JSON.parse(varStickyProperties).dataFormat;
                _isView = JSON.parse(varStickyProperties).view;
                _isSetting = JSON.parse(varStickyProperties).setting;
                _runtimeType = JSON.parse(varStickyProperties).runtimeType;
                break;
            case 'object':
                _isOn = true;
                _isSavedDesktop = varStickyProperties.savedDesktop;
                _isAdminPortal = varStickyProperties.adminPortal;
                _isDeviceId = varStickyProperties.deviceId;
                _isAnalogIntertieId = varStickyProperties.analogIntertieId;
                _isDevice = varStickyProperties.device;
                _isDateMin = varStickyProperties.dateMin;
                _isDateMax = varStickyProperties.dateMax;
                _isZoomMin = varStickyProperties.zoomMin;
                _isZoomMax = varStickyProperties.zoomMax;
                _isDataFormat = varStickyProperties.dataFormat;
                _isView = varStickyProperties.view;
                _isSetting = varStickyProperties.setting;
                _runtimeType = varStickyProperties.runtimeType;
                break;
            default: //case 'undefined':
                _isOn = false;
                _isSavedDesktop = false;
                _isAdminPortal = { customerId: null, customerName: null };
                _isDeviceId = null;
                _isAnalogIntertieId = null;
                _isDevice = { deviceId: null, deviceName: null, channel: null, serialNumber: null };
                _isDateMin = null;
                _isDateMax = null;
                _isZoomMin = null;
                _isZoomMax = null;
                _isDataFormat = null;
                _isView = { type: null, expanded: null };
                _isSetting = null;
                _runtimeType = null;
        }

        var optionsStickyProperties = {
            on: _isOn,
            savedDesktop: _isSavedDesktop,
            adminPortal: _isAdminPortal,
            deviceId: _isDeviceId,
            analogIntertieId: _isAnalogIntertieId,
            device: _isDevice,
            dateMin: _isDateMin,
            dateMax: _isDateMax,
            zoomMin: _isZoomMin,
            zoomMax: _isZoomMax,
            dataFormat: _isDataFormat,
            view: _isView,
            setting: _isSetting,
            runtimeType: _runtimeType
        };

        var dateRange = optionsStickyProperties.dateMax != null ? (optionsStickyProperties.dateMax - optionsStickyProperties.dateMin) / unixDay : null;
        //console.log(dateRange);
        //console.log(new Date(optionsStickyProperties.dateMin), new Date(optionsStickyProperties.dateMax));
        if (1 == 2 && (varType == "Analog Chart" || varType == "Analog Table") && (dateRange != null && dateRange >= 15)) { //need to check
            if (((optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) / unixDay) <= 5) {
                //console.log(optionsStickyProperties.dateMax);
                //console.log(15 * unixDay - (optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) / 2);
                //console.log(Math.floor((optionsStickyProperties.zoomMax + (15 * unixDay - (optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) - (optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) / 2))));
                //console.log(Math.floor((optionsStickyProperties.zoomMin - (15 * unixDay - (optionsStickyProperties.zoomMax -optionsStickyProperties.zoomMin) - (optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) / 2))));
                optionsStickyProperties.dateMax = Math.floor((optionsStickyProperties.zoomMax + (2.5 * unixDay - (optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) - (optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) / 2)));
                optionsStickyProperties.dateMin = Math.floor((optionsStickyProperties.zoomMin - (2.5 * unixDay - (optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) - (optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) / 2)));
            }
            else {
                optionsStickyProperties.zoomMax = (((optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) / 2) + 2 * unixDay).toFixed(0);
                optionsStickyProperties.zoomMin = (((optionsStickyProperties.zoomMax - optionsStickyProperties.zoomMin) / 2) - 2 * unixDay).toFixed(0);
                optionsStickyProperties.dateMax = (optionsStickyProperties.zoomMax + unixDay).toFixed(0);
                optionsStickyProperties.dateMin = (optionsStickyProperties.zoomMin - unixDay).toFixed(0);
            }
        }
        //console.log(new Date(optionsStickyProperties.dateMin), new Date(optionsStickyProperties.dateMax));
        //console.log(optionsStickyProperties);
        // Open the dialog
        dialogService.open(newDivID, varType, options, optionsExt, optionsStickyProperties);

    };

    var _getIcon = function (varTitle, varMode) {
        if (varTitle === "Tank And Well" || varTitle === "Tank And Well Overview" || varTitle === "Tank And Well Detail") return _getIconImg(varTitle, varMode);
        var modeClass = varMode != null ? 'nav-menu-icon' : 'ui-title-MS';
        //THE-51582: always rendered next to the window title / menu text, so decorative
        return "<i class='" + _getIconClass(varTitle) + " " + modeClass + "' aria-hidden='true'></i>";
    };

    var _getIconClass = function (varTitle, varMode) {
        switch (varTitle) {
            case "Chart":
            case "Analog Chart":
            case "Analog Output Chart":
            case "Signal Chart":
            case "Signal Connect Chart":
            case "Temperature Chart":
            case "Digital Chart":
            case "Pump Chart":
            case "Voltage Chart":
            case "Analog Interconnect Chart":
            case "Digital Intertie Chart":
            case "Digital Interconnect Chart":
            case "Solar Chart":
            case "Tank And Well Chart":
            case "Pulse Flow Chart":
            case "Volumetric Flow Chart":
            case "Pump Duty Cycle Plot":
            case "Runtime Variance Chart":
            case "Humidity Chart":
                return "fa fa-line-chart";
            case "Table":
            case "Analog Table":
            case "Analog Output Table":
            case "Signal Table":
            case "Signal Connect Table":
            case "Temperature Table":
            case "Digital Table":
            case "Pump Table":
            case "Voltage Table":
            case "Solar Table":
            case "Analog Intertie Table":
            case "Digital Intertie Log":
            case "Pulse Flow Table":
            case "Volumetric Flow Table":
            case "Daily Volumetric Flow Summary":
            case "Tank And Well Log":
            case "Humidity Table":
            case "Sequence Number Table":
            case "Runtime Data":
            case "All Devices":
            case "Station Notes":
            case "Multiple Runtimes Report":
                return "fa fa-table";
            case "Analog Gauge":
            case "Analog Output Gauge":
            case "Mc Analog Gauge":
            case "Mc Analog Output Gauge":
            case "Mc Status Gauge":
            case "Mc Switch Gauge":
            case "Mc Runtime Gauge":
            case "Mc Digital Gauge":
            case "Signal Gauge":
            case "Temperature Gauge":
            case "Mc Temperature Gauge":
            case "Digital Gauge":
            case "Voltage Gauge":
            case 'Pulse Flow Gauge':
            case "Analog Widget":
            case "Mc Analog Widget":
            case "Mc Analog Output Widget":
            case "Mc Status Widget":
            case "Mc Switch Widget":
            case "Mc Runtime Widget":
            case "Signal Widget":
            case "Connection Widget":
            case "Temperature Widget":
            case "Mc Temperature Widget":
            case "Digital Widget":
            case "Voltage Widget":
            case 'Pulse Flow Widget':
            case "Humidity Gauge":
            case "Humidity Widget":
            case "Mc Pump Gauge":
            case "Mc Pump Widget":
            case "Pump Gauge":
            case "Pump Widget":
            case "Mc Pump Gauge View":
            case "Mc Pump Gauge View Submersible":
            case "Mc Pump Gauge View Blower":
            case "Mc Pump Gauge View Booster":
                return "fa fa-tachometer";
            case "Reports":
            case "User Login":
            case "Site Access":
            case "Disabled Inputs":
            case "Management":
            case "Management Report":
            case "Alert History":
            case "Delayed Alarm History":
            case "Live Demo":
            case "Runtime Daily":
            case "Runtime Multi Day":
            case "Runtime Monthly":
            case "Runtime Variance":
            case "User Login Report":
            case "Live User":
            case "Live User Report":
            case "Site Access Report":
            case "Disabled Inputs Report":
            case "Alert History Report":
            case "Delayed Alarm History Report":
            case "Integrated Flow":
            case "Integrated Flow Report":
            case "Unit Check In Report":
            case "Unit Check In":
            case "Safe Water":
            case "Chlorine Report":
            case "Safe Water Report":
            case "WTS Usage Log":
            case "Runtime Daily Report":
            case "Runtime Multi Day Report":
            case "Pulse Flow Multi Day Report":
            case "Runtime Monthly Report":
            case "Web User Login":
            case "Paging Log":
            case "Mission Reports":
            case "Untested Wet Well Inputs":
            case "SSO CSO Report":
            case 'Daily Station Summary':
            case 'Cumulative Flow Reading':
            case 'Pump Service Report':
            case 'Pump Alarm Data':
            case 'Documents':
            case 'Radio Upgrades':
            case 'Spare Radio Report':
            case 'Customer Notes':
            case 'MM Plus Config History':
            case "MM Plus Network History":
            case "MM Plus Channel History":
            case "Rain Analysis Report":
            case "Schedules Legacy":
                return "fa fa-file-text-o";
            case "Tech Support Assign Customer":
                return "fa fa-user-plus";
            case "Calendar":
            case "Signal Calendar":
            case "Signal Connect Calendar":
            case "Pulse Flow Calendar":
                return "fa fa-calendar-o";
            case "Dashboard":
            case "RTU Migrate Settings":
                return "fa fa-clipboard";
            case "Raw Data":
                return "fa fa-database";
            case "Notification Rules":
            case 'WTS Customer Management':
            case 'WTS Key Management':
            case 'Bulk Water Management':
                return "fa fa-book";
            case "Notification Rules CG":
                return "fa fa-book";
            case "Notification Schedule":
                return "fa fa-calendar-o";
            case "Notification Destinations":
                return "fa fa-calendar-o";
            case "Destinations":
                return "fa fa-map-signs";
            case "Preferences":
            case "Customer Preferences":
            case "User Preferences":
            case "Alarm Rule Test":
                return "fa fa-cogs";
            case "Notifications":
                return "fa fa-volume-control-phone";
            case "Map":
            case "Marker Customer":
            case "Marker Distributor":
            case "Marker Rural Water Association":
                return "fa fa-map-marker";
            case "Tank And Well":
            case "Tank And Well Overview":
            case "Tank And Well Detail":
                return "fa fa-hourglass-end";
            case "Interconnect":
            case "Interconnect Setup":
            case "Analog Interconnect List":
            case "Digital Interconnect List":
            case "Analog Interconnect Setup":
            case "Digital Interconnect Setup":
                return "fa fa-link";
            case "Alarm":
            case "Alarm History":
                return "fa fa-bell";
            case "Manage Desktops":
            case "Saved Desktop":
            case "Device Status":
            case "Distributor Device Info List":
                return "fa fa-desktop";
            case "Logout":
                return "fa fa-sign-out";
            case "Close All Views":
                return "fa fa-object-group";
            case "Commands":
                return "fa fa-angle-double-up";
            case "Setup":
            case "Manage Schedule":
            case "Wizard":
            case "Wizard Splash":
            case "Migrate Notification":
            case "Tank And Well Setup":
                return "fa fa-wrench";
            case "RTU View":
                return "fa fa-signal";
            case "RTU Info":
            case "Device Info":
                return "fa fa-info-circle";
            case "RTU Configuration":
            case "RTU Setting":
            case "MM Plus RTU Setting":
                return "fa fa-cog";
            case "Search Customer":
            case "Customer List":
            case "Customer Search":
            case "Customer Lookup":
            case "User Accounts":
            case "Blocked Access":
            case "Memory Cache Manager":
                return "fa fa-users";
            case "Upload Logo":
                return "fa fa-upload";
            case "Weather":
                return "wi wi-day-sprinkle";
            case "Rainfall":
            case "Rainfall Table":
            case "Rainfall Chart":
            case "Rainfall Calendar":
            case "Rainfall Data Table":
            case "Rainfall Data Chart":
            case "Rainfall Data Calendar":
            case "Rainfall vs Runtime Table":
            case "Rainfall vs Runtime Chart":
            case "Rainfall vs Runtime Calendar":
                return "wi wi-sprinkle";
            case "Paging":
            case "Paging Option":
                return "fa fa-keyboard-o";
            case "Home":
                return "fa fa-home";
            case "Communication":
                return "fa fa-plug";
            case "Overview":
                return "fa fa-heartbeat";
            case "Electronic Keys":
                return "fa fa-key";
            case "Alerts":
                return "fa fa-bell";
            case "Ticket System":
                return "fa fa-folder-o";
            case "View Ticket":
                return "fa fa-folder-open";
            case "Create Ticket":
                return "fa fa-plus-square";
            case "Audit History":
                return "fa fa-history";
            case "Send Feedback":
            case "Toaster Messages":
                return "fa fa-commenting";
            case "Video Player":
                return "fa fa-film";
            case "Supergraph":
                return "fa fa-area-chart";
            case 'Download':
                return 'fa fa-download';
            case "Analog Chart Recorder":
                return "fa fa-bullseye";
            case 'Revision Log':
                return "fa fa-list-alt";
            case 'Mission Tech Support':
            case 'Technical Support':
                return "fa fa-life-ring";
            case 'Pump Peak Flow Capacity Estimator':
                return "fa fa-calculator";
            case 'Current Status':
            case 'Radio Upgrade Data':
                return "fa fa-exclamation";
            case 'Carrier Data Usage':
            case 'Sim Data Usage':
                return "fa fa-mobile fa-lg";
            case 'Carrier Rate Plan':
            case 'Data Usage':
                return "fa fa-book";
            case 'SVG Elements':
                return "fa fa-cubes";
            case 'Help':
                return "fa fa-question-circle fa-lg";
            case 'Documentation':
            case 'Help Documents':
                return "fa fa-file-text";
            case 'Update Username':
            case 'Update Password':
            case 'Register Webinar':
            case 'Customers':
                return "fa fa-address-book";
            case 'Manage User Accounts':
            case 'Tech Support Assignment':
                return "fa fa-file-text-o";
            case 'Tech Support Assign RTU to Customer':
                return "fa fa-arrows";
            case 'Signal Connect':
                return "fa fa-bar-chart";
            case 'Contact Information':
            case 'Monthly Flow Summary':
            case 'Style Guide':
                return "fa fa-file-text-o";
            case 'WTS Usage Log Print':
                return "fa fa-print fa-lg";
            case 'User Terms':
                return "fa fa-file-text-o";
            case 'Admin Portal':
            case 'McAdmin Portal':
            case 'Customer Portal':
            case 'Distributor Portal':
            case 'RSM Portal':
                return "fa fa-home fa-lg";
            case 'Go To Portal':
                return "fa fa-laptop";
            case 'Analog Data':
            case 'Signal Data':
            case 'Temperature Data':
            case 'Digital Data':
            case 'Voltage Data':
            case 'Pump Data':
            case 'Pulse Flow':
            case 'Volumetric Calc':
                return "fa fa-database";
            case 'Map Marker':
                return "fa fa-thumb-tack";
            case 'Pump Station':
            case 'Mc Pump Station Widget':
                return "fa fa-industry";
            case 'MyLevel':
            case 'Mc MyLevel Widget':
                return "fa fa-building-o";
            case 'Enable Two Factor Authentication':
                return "fa fa-lock";
            case 'Welcome To Scada':
                return "fa fa-handshake-o";
            case 'Device Management':
                return "fa fa-server";
            default:
                return "";
        }
    };

    var _getIconImg = function (varTitle, varMode) {
        var modeClass = varMode != null ? 'nav-menu-icon' : 'ui-title-MS';
        return "<i class='img-filter sss " + modeClass + "' aria-hidden='true'>" + _getIconImgTag(varTitle, varMode) + "</i>";
    };

    var _getIconImgTag = function (varTitle, varMode) {
        switch (varTitle) {
            case "Tank And Well":
            case "Tank And Well Overview":
            case 'Tank And Well Detail':
                return (varMode != null) ? "<img src='images/tankandwellmenu.png' alt=''/>" : "<img src='images/tankandwelltitle.png' alt=''/>";
            default: //case 'undefined':
                return "";
        }
    }

    var _adjustContentSizeStart = function (obj, _desktopName) {
        var taskBarHeight = 43;
        var _windowDimensions = _getWindowSize();
        var _windowHeight = _windowDimensions.height;
        var _windowWidth = _windowDimensions.width;

        var _popup = obj;
        _desktopName = _desktopName || _popup.dialog('widget').attr("mc-view-name");
        var _popupTop = parseInt(_popup.dialog('widget').css("top"), 10);
        var _popupLeft = parseInt(_popup.dialog('widget').css("left"), 10);
        var _popupWidth = parseInt(_popup.dialog('widget').css("width"), 10);
        var _popupHeight = parseInt(_popup.dialog('widget').css("height"), 10);
        var notCollapsed = _popup.dialog('widget').find("a[class='ui-dialog-titlebar-collapse ui-corner-all ui-state-default']").is(":visible")

        if (_popup.dialog('widget').find("a[class='ui-dialog-titlebar-restore ui-corner-all ui-state-default']").is(":visible") && notCollapsed) {
            _popup.dialog('widget').css("height", (_windowHeight - taskBarHeight) + "px");
            _popup.dialog("option", "height", _windowHeight - taskBarHeight);
            _popup.dialog('widget').css("top", 0 + "px");
            _popup.dialog("option", "top", 0);
            _popup.dialog('widget').css("width", _windowWidth + "px");
            _popup.dialog("option", "width", _windowWidth);
            _popup.dialog('widget').css("left", 0 + "px");
            _popup.dialog("option", "left", 0);
            //return;
            _popupTop = 0;
            _popupLeft = 0;
            _popupWidth = _windowWidth;
            _popupHeight = (_windowHeight - taskBarHeight);
        }

        if (_allowViewResize(_desktopName) && (_windowHeight < _popupHeight || _windowWidth < _popupWidth)) {
            //shrink to the visible window even below the view's configured minimum size, otherwise
            //controls end up off screen with no way to reach them at high browser zoom levels (WCAG 1.4.10);
            //the view's content scrolls within the smaller window
            if (_windowHeight < _popupHeight && notCollapsed) {
                //aim ~60px below the visible height: the follow-up adjustContentSize() re-derives the
                //content min-height without the titlebar/padding/border, growing the dialog back by that chrome
                var newHeight = _windowHeight - taskBarHeight - 60;
                if (_popup.dialog("option", "minHeight") > newHeight) _popup.dialog("option", "minHeight", newHeight);
                _popup.dialog('widget').css("height", newHeight + "px");
                _popup.dialog("option", "height", newHeight);
                _popupTop = parseInt(_popup.dialog('widget').css("top"), 10);
                _popupHeight = parseInt(_popup.dialog('widget').css("height"), 10);
            }
            if (_windowWidth < _popupWidth) {
                //the dialog border/padding render outside the width option, so stay 10px inside the window
                var newWidth = _windowWidth - 10;
                if (_popup.dialog("option", "minWidth") > newWidth) _popup.dialog("option", "minWidth", newWidth);
                _popup.dialog('widget').css("width", newWidth + "px");
                _popup.dialog("option", "width", newWidth);
                _popupLeft = parseInt(_popup.dialog('widget').css("left"), 10);
                _popupWidth = parseInt(_popup.dialog('widget').css("width"), 10);

                if (!notCollapsed) {
                    _popup.dialogExtend("collapse");
                }
            }
        }

        if (_popupTop < 0 || ((_windowHeight - _popupTop - _popupHeight) < 0)) {
            _popup.dialog('widget').css("top", (((_windowHeight - _popupHeight) < 0) ? 0 : (_windowHeight - _popupHeight)) + "px");
            _popup.dialog("option", "top", (((_windowHeight - _popupHeight) < 0) ? 0 : (_windowHeight - _popupHeight)));
        }
        if ((_popupLeft < 0) || (_windowWidth - _popupLeft - _popupWidth - 10) < 0) {
            //the dialog border/padding render outside the css width, so pull 10px further left
            var _fixedLeft = _windowWidth - _popupWidth - 10;
            if (_fixedLeft < 0) _fixedLeft = 0;
            _popup.dialog('widget').css("left", _fixedLeft + "px");
            _popup.dialog("option", "left", _fixedLeft);
        }
    };

    var adjustContentSize = function (obj) {
        if ($rootScope.mobile || $rootScope.classicView) return;
        if ($(obj).find(".chart").highcharts()) {
            $(obj).parent().find('div:eq(2)').css("width", $(obj).parent().css("width"));
            $(obj).parent().find('div:eq(2)').css("min-width", $(obj).parent().css("width").replace(/[^0-9.]+/g, ""));
            $(obj).parent().find('div:eq(2)').css("height", $(obj).parent().css("height").replace(/[^0-9.]+/g, "") - $(obj).parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $(obj).parent().find('div:eq(2)').css("min-height", $(obj).parent().css("height").replace(/[^0-9.]+/g, "") - $(obj).parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $(obj).parent().find('.chart').css("height", $(obj).parent().css("height").replace(/[^0-9.]+/g, "") - $(obj).parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $(obj).parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - ($(obj).parent().find('.additional-heading').css("height") ? $(obj).parent().find('.additional-heading').css("height").replace(/[^0-9.]+/g, "") : 0) - 10);
            var _char = $(obj).find(".chart").highcharts();
            _char.reflow();
        }
        else {
            $(obj).parent().find('div:eq(2)').css("width", $(obj).parent().css("width"));
            $(obj).parent().find('div:eq(2)').css("min-width", $(obj).parent().css("width").replace(/[^0-9.]+/g, ""));
            $(obj).parent().find('div:eq(2)').css("height", $(obj).parent().css("height").replace(/[^0-9.]+/g, "") - $(obj).parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") + 0);
            $(obj).parent().find('div:eq(2)').css("min-height", $(obj).parent().css("height").replace(/[^0-9.]+/g, "") - $(obj).parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") + 0);
        }
        $rootScope.$broadcast('contentAdjusted');
        //adjustDeviceIdMenuSize(obj);
    }

    //WCAG 4.1.2: aria-label is set alongside title so the accessible name tracks the same
    //translated string - the plugin's own default aria-label (jquery.dialogextend.js) is plain
    //English and gets overwritten here once the real language is known
    var translateTitleBar = function (widget) {
        var minimizeText = eval("_translation.text." + "MINIMIZE");
        var maximizeText = eval("_translation.text." + "MAXIMIZE");
        var collapseText = eval("_translation.text." + "COLLAPSE");
        var restoreText = eval("_translation.text." + "RESTORE");
        var closeText = eval("_translation.text." + "CLOSE");

        widget.find(".ui-dialog-titlebar-minimize").attr("title", minimizeText).attr("aria-label", minimizeText);
        widget.find(".ui-dialog-titlebar-maximize").attr("title", maximizeText).attr("aria-label", maximizeText);
        widget.find(".ui-dialog-titlebar-collapse").attr("title", collapseText).attr("aria-label", collapseText);
        widget.find(".ui-dialog-titlebar-restore, .dlgexTitlebarRe").attr("title", restoreText);
        widget.find(".ui-dialog-titlebar-restore").attr("aria-label", restoreText);
        widget.find(".ui-dialog-titlebar-close").attr("title", closeText).attr("aria-label", closeText);
    };

    var attachUpdatePreferencesLanguage = function (obj) {
        var localScope = $(obj.target).scope();

        $timeout(function () {
            localScope.$apply(
                function () {
                    localScope.popup = _this.getExistingDialog(localScope.windowId).ref;

                    translateTitleBar(localScope.popup.dialog('widget'));

                    localScope.$on('updatePreferencesLanguage', function (event, args) {
                        var customerNameString = localScope.stickyProperties == null
                            || localScope.stickyProperties.adminPortal == null
                            || localScope.stickyProperties.adminPortal.customerName == null
                            ? ""
                            : ": " + localScope.stickyProperties.adminPortal.customerName;
                        var deviceNameString = localScope.stickyProperties.device != null && localScope.stickyProperties.device.deviceName != null ? ", " + localScope.stickyProperties.device.deviceName : "";
                        var tmpElement = $("#" + obj.target.id).find("div:eq(1)");
                        var scope = angular.element(tmpElement).scope();
                        var tmpTable = undefined;
                        if (scope.analogTableService) {
                            tmpTable = scope.analogTableService;
                        } else if (scope.signalTableService) {
                            tmpTable = scope.signalTableService;
                        } else if (scope.temperatureDataService) {
                            tmpTable = scope.temperatureDataService;
                        } else if (scope.digitalTableService) {
                            tmpTable = scope.digitalTableService;
                        } else if (scope.voltageTableService) {
                            tmpTable = scope.voltageTableService;
                        } else if (scope.pumpTableService) {
                            tmpTable = scope.pumpTableService;
                        } else if (scope.siteAccessReportService) {
                            tmpTable = scope.siteAccessReportService;
                        }
                        if (angular.isDefined(tmpTable)) {
                            var localCopyOfVar = angular.copy(tmpTable.items);
                            tmpTable.items = localCopyOfVar;
                        }
                        if (typeof scope.fnChangeLanguage === 'function') scope.fnChangeLanguage();

                        //TEMP CODE//
                        if (eval("_translation.text." + localScope.languageTitleCode) != undefined) {
                            localScope.popup.dialog("option", "title", eval("_translation.text." + localScope.languageTitleCode) + customerNameString + deviceNameString);
                            translateTitleBar(localScope.popup.dialog('widget'));
                        }
                    });
                }
            );
        }, 0);
    }

    var adjustDeviceIdMenuSize = function (obj) {
        if ($(obj).parent().css("height").replace(/[^0-9.]+/g, "") < 450) {
            $(obj).parent().find('.device-id-menu').css('max-height', $(obj).parent().css("height").replace(/[^0-9.]+/g, "") - 70);
        }
        else {
            $(obj).parent().find('.device-id-menu').css('max-height', 400);
        }
    };

    var _singleView = function (obj) {
        if (sharedSetupService.adminPortal()) {
            if (singleViewArrayPortal.indexOf(obj) != -1 && _findElement(obj) != -1) {
                return true;
            }
        }
        if (singleViewArray.indexOf(obj) != -1) {
            return (_findElement(obj) != -1);
        }
        else {
            return false;
        }
    }

    var _singleViewAndId = function (obj, varStickyProperties) {
        if (singleViewArrayAndId.indexOf(obj) !== -1) {
            return _findElementAndId(obj, varStickyProperties.deviceId);
        }
        else {
            return "";
        }
    }

    var _getWeatherViewMode = function () {
        return _weatherMode;
    }

    var _setWeatherViewMode = function (varMode) {
        switch (varMode) {
            case "Sm":
                _weatherMode = "";
                break;
            case "Lg":
                _weatherMode = "Sm";
                break;
            default:
                _weatherMode = "";
        }
    }

    var compiledElement;
    var tmpHtml;

    var _compileElement = function (viewName, tabName) {
        var newScope = $rootScope.$new();
        var docName = (tabName != null) ? viewName + ", " + tabName : viewName;
        newScope.tmpStickyProperties = { device: { channel: docName } };
        var dataDocName = docName.replace(/ /g, "_");
        newScope.translation = _translation;
        tmpHtml = '<div id="documentation" class="right">' +
            '<div id="documentation-title" class="ui-widget-header ui-dialog-titlebar ui-widget-header" data-documentation=' + dataDocName + '>' +
            '<i class="fa fa-file-text ui-title-MS" style="position: static!important;" aria-hidden="true"></i>' +
            '<span id="ui-id-87" class="ui-dialog-title">{{translation.text.HELP_FILE}}</span>' +
            '<span class="btn btn-xs" ng-click="closeHelpPanel()" id="close-documentation" style="float: right; padding: 2px 5px; cursor: pointer;">' +
            '<i class="fa fa-angle-double-right fa-lg" aria-hidden="true"></i>' +
            '</span>' +
            '</div>' +
            '<div id="documentation-content">' +
            '<documentation window-id="windowId" mobile="mobile" sticky-properties="tmpStickyProperties" classic-view="classicView" window-title="Documentation" deviceSelected="deviceSelected"></documentation>' +
            '</div>' +
            '</div>';
        newScope.closeHelpPanel = function () {
            _closeHelpPanel();
        };
        compiledElement = $compile(tmpHtml)(newScope);
    };

    var _openHelpPanel = function (viewName, tabName) {
        if (angular.isDefined(compiledElement)) compiledElement.remove();
        var body = angular.element(document.getElementsByTagName('body'));
        _compileElement(viewName, tabName);
        body.append(compiledElement);
        $timeout(function () {
            $("#documentation").addClass("show");
            $("#documentation").resizable({
                maxWidth: 750,
                minWidth: 350,
                handles: 'w'
            });
        }, 0);
    };

    var _closeHelpPanel = function () {
        $("#documentation").removeClass("show");
        $timeout(function () { if (angular.isDefined(compiledElement)) compiledElement.remove(); }, 500);
    };

    var _closeView = function (varType) {
        var _tmpSingleView = _singleView(varType);
        if (_tmpSingleView) {
            var _popup = _this.getExistingDialog(varType).ref;
            _popup.dialog("close");
            return true;
        }
    }

    var _closeConfigHistoryView = function (varType) {
        var _popup = _this.getExistingDialog(varType).ref;
        _popup.dialog("close");
    }

    openViewFactory.openView = _openView;
    openViewFactory.openWidget = _openView;
    openViewFactory.getIcon = _getIcon;
    openViewFactory.getIconImg = _getIconImg;
    openViewFactory.getWeatherViewMode = _getWeatherViewMode;
    openViewFactory.setWeatherViewMode = _setWeatherViewMode;
    openViewFactory.adjustContentSize = adjustContentSize;
    openViewFactory.adjustContentSizeStart = _adjustContentSizeStart;
    openViewFactory.getMinWindowSizes = getMinWindowSizes;
    openViewFactory.openHelpPanel = _openHelpPanel;
    openViewFactory.closeHelpPanel = _closeHelpPanel;
    openViewFactory.closeView = _closeView;
    openViewFactory.closeConfigHistoryView = _closeConfigHistoryView;
    return openViewFactory;
}]);
angular.module('dialogService', []).service('dialogService',
['$rootScope', '$q', '$compile', '$templateCache', 'translationService', 
function ($rootScope, $q, $compile, $templateCache, translationService) {

	_this = this;
	this.dialogs = {};

	_translation = translationService.translation;
	if (_translation === null || typeof _translation === "undefined") {
		translationService.loadLanguage(true)
		.then(function (result) {
			_translation = translationService.translation;
		});
	}

	_fnNoOverlapPosition = function (varId, varPosition) {
        for (var i = 0; i < $rootScope.arrPopup.length; i++) {
            if ($rootScope.arrPopup[i].desktopIndex !== varId) {
                var _popup = _this.getExistingDialog($rootScope.arrPopup[i].desktopIndex).ref;
                var _popupPosition = _popup.dialog("option", "position");
                if (_popupPosition.my === varPosition.my && _popupPosition.at === varPosition.at) {
                    var _top = parseInt(_popup.parent().css('top'), 10) + 5;
                    var _left = parseInt(_popup.parent().css('left'), 10) + _fnOffSet(parseInt(_popup.parent().css('left'), 10));
                    return { top: _top, left: _left };
                }
            }
        }
        return null;
    };

	_fnNoOverlapPx = function (varId, varPx) {
        for(var i = 0; i < $rootScope.arrPopup.length; i++) {
            if($rootScope.arrPopup[i].desktopIndex !== varId) {
                var _popup = _this.getExistingDialog($rootScope.arrPopup[i].desktopIndex).ref;
                if (varPx.top === parseInt(_popup.parent().css('top'), 10) && varPx.left === parseInt(_popup.parent().css('left'), 10)) {
                    var _top = varPx.top + 5;
                    var _left = varPx.left + _fnOffSet(varPx.left);
                    return { top: _top, left: _left };
                }
            }
        }
        return null;
	};

    _fnOffSet = function (varLeft) {
        if (varLeft > 300) {
            return -5;
        } else {
            return 5;
        }
    };

	this.open = function (id, template, options, optionsExt, optionsStickyProperties) {
        // Check our required arguments
		if (!angular.isDefined(id)) {
			throw "dialogService requires id in call to open";
		}

		if (!angular.isDefined(template)) {
			throw "dialogService requires template in call to open";
		}

		// Copy options so the change to close isn't propagated back.
		// Extend is used instead of copy because window references are
		// often used in the options for positioning and they can't be deep
		// copied.
		var dialogOptions = {};
		if (angular.isDefined(options)) {
			angular.extend(dialogOptions, options);
		}
		var dialogOptionsExt = {};
		if (angular.isDefined(optionsExt)) {
			angular.extend(dialogOptionsExt, optionsExt);
		}

		// Initialize our dialog structure
		var dialog = { scope: null, ref: null, deferred: null };

		// Get the template and trim to make it valid
		var dialogTemplate = $templateCache.get(template);
		if (!angular.isDefined(dialogTemplate)) {
			throw "dialogService could not find template " + template;
		}
		dialogTemplate = dialogTemplate.trim();

		// Create a new scope, inherited from the parent.
		var windowName = eval("_translation.text." + template.toUpperCase().replace(/ /g, "_"));
		dialog.scope = $rootScope.$new();
		dialog.scope.windowTitle = windowName;
		dialog.scope.windowId = id;
		dialog.scope.stickyProperties = optionsStickyProperties;
		dialog.scope.languageTitleCode = template.toUpperCase().replace(/ /g, "_");
		var dialogLinker = $compile(dialogTemplate);
		dialog.ref = $(dialogLinker(dialog.scope));

		// Handle the case where the user provides a custom close and also
		// the case where the user clicks the X or ESC and doesn't call
		// close or cancel.
		var customCloseFn = dialogOptions.close;
		var cleanupFn = this.cleanup;
		dialogOptions.close = function (event, ui) {
			if (customCloseFn) {
				customCloseFn(event, ui);
			}
			cleanupFn(id);
		};

	    // Initialize the dialog
	    dialog.ref.dialog(dialogOptions).dialogExtend(dialogOptionsExt);

	    // Adjust position if needed
	    var _position = dialog.ref.dialog("option", "position");
	    var _rePosition = (_position.of === window) ? _fnNoOverlapPosition(id, _position) : null;
	    for (var i = 0; i < 100; i++) {
	        if (_rePosition === null) {
	            break;
	        } else {
	            var newPosition = {my: "left+" + _rePosition.left + " " + "top+" + _rePosition.top, at: "left top", of : window};
	            _rePosition = _fnNoOverlapPx(id, _rePosition);
	            if (_rePosition === null) {
	                dialog.ref.dialog("option", "position", newPosition);
	                break;
	            } else {
	                newPosition = {
	                    my: "left+" +_rePosition.left + " " + "top+" + _rePosition.top, at: "left top", of: window
	                };
	            }
	        }
	    }

	    // Open dialog
	    dialog.ref.dialog("open");
		
		// Cache the dialog
		_this.dialogs[id] = dialog;
		
		// Create our promise, cache it to complete later, and return it
		dialog.deferred = $q.defer();
		return dialog.deferred.promise;
	};

	this.close = function (id, result) {
		// Get the dialog and throw exception if not found
		var dialog = _this.getExistingDialog(id);

		// Notify those waiting for the result
		// This occurs first because the close calls the close handler on the
		// dialog whose default action is to cancel.
		dialog.deferred.resolve(result);

		// Close the dialog (must be last)
		dialog.ref.dialog("close");
	};

	this.cancel = function (id) {
		// Get the dialog and throw exception if not found
		var dialog = _this.getExistingDialog(id);

		// Notify those waiting for the result
		// This occurs first because the cancel calls the close handler on the
		// dialog whose default action is to cancel.
		dialog.deferred.reject();

		// Cancel and close the dialog (must be last)
		dialog.ref.dialog("close");
	};

	/* private */
	this.cleanup = function (id) {
		// Get the dialog and throw exception if not found
		var dialog = _this.getExistingDialog(id);

		// This is only called from the close handler of the dialog
		// in case the x or escape are used to cancel the dialog. Don't
		// call this from close, cancel, or externally.
	    //dialog.deferred.reject(); //Not needed - in new AngularJS 1.6.9 this is causing "Possibly unhandled rejection: undefined"
		dialog.scope.$destroy();

		// Remove the object from the DOM
		dialog.ref.remove();

		// Delete the dialog from the cache
		delete _this.dialogs[id];
	};

	/* private */
	this.getExistingDialog = function (id) {
		// Get the dialog from the cache
		var dialog = _this.dialogs[id];
		// Throw an exception if the dialog is not found
		if (!angular.isDefined(dialog)) {
			throw "DialogService does not have a reference to dialog id " + id;
		}
		return dialog;
	};

}
]);
mcapp.directive('deviceList', ['$document', 'authenticationService', 'deviceMenuService', '$rootScope', '$timeout', 'translationService', function ($document, authenticationService, deviceMenuService, $rootScope, $timeout, translationService) {
    return { 
        restrict: 'E',
        transclude: true,
        replace: true,
        templateUrl: function (element, attrs) {
            return 'ui/devicelookup/device-lookup' + (attrs.deviceLookupTemplate ? "-" + attrs.deviceLookupTemplate + ".html" : ".html");
        }, 
        link: function (scope, element, attrs) {
            scope.getAnyDeviceList = function(){
                scope.deviceListType = attrs.deviceListType;
                 // if view, that displays first device as default device
                if (attrs.deviceListType === "firstDevice")
                    scope.isFirstDevice = true;

            //load device list based on attrs.deviceListType
            $timeout(function(){
                switch (attrs.deviceListType) {
                    case "pumpAlarm":
                        scope.addAllDevicesOption = true;
                        scope.callCtrlSetDevice = true;
                        break;
                    case "ssocso":
                        scope.showFilterIcon = true;
                        break;
                    case "chlorine":
                        scope.showFilterIcon = true;
                        break;
                    case "cumFlow":
                        scope.showFilterIcon = true;
                        scope.callCtrlSetDevice = true;
                        break;
                    case "flow":
                        scope.showFilterIcon = true;
                        break;
                    case "signalConnect":
                        scope.checkBoxEnabled = true;
                        scope.addAllDevicesOption = true;
                        break;
                    case "volFlow":
                        scope.showFilterIcon = true;
                        scope.callCtrlSetDevice = true;
                        break;
                    case "mmPlus":
                        scope.showFilterIcon = true;
                        break;
                    case "mmPlusOnly":
                        scope.showFilterIcon = true;
                        break;
                    case "pumpStationOnly":
                        scope.showFilterIcon = true;
                        break;
                    case "rainfall":
                        scope.showFilterIcon = true;
                        scope.callCtrlSetDevice = true;
                        return scope.getRainfallDeviceList();
                }
                //Run default Logic
                scope.getDeviceList();
            }, 0 );
            }
            //Run on init
            scope.getAnyDeviceList();

            //Logic Shared by all device lists
            var _elementContainer = element;
            if (!$rootScope.mobile && !$rootScope.classicView) _elementContainer = _this.getExistingDialog(scope.windowId).ref;
            scope.translation = translationService.translation;


            scope.accountInfo = authenticationService.getAccountInfo();
            scope.topMenuMarginLeft = (typeof scope.topMenuMarginLeft === "undefined") ? ($rootScope.mobile ? "-200px" : "-240px") : scope.topMenuMarginLeft;
            scope.topMenuWidth = '300px';
            scope.maxHeight = $rootScope.mobile ? "calc(100% - 150px)" : "360px";
            if (attrs.menuType == "broadcast") {
                scope.topMenuWidth = '410px';
                $(element).find('div').filter(':eq(1)').css('top', '108px').css('left', '410px');
            }
            scope.hasSolar = false;
            scope.hasPulseFlow = false;
            
            scope.dynamicPopover = {
                templateUrl: 'deviceSelectionTemplate.html'
            };

            scope.setDevice = function (id, name, serialNumber, type, device) {
                //if device checkbox mode enabled, update device.selected & prevent remaining code from running
                if(scope.checkBoxEnabled){
                    device.selected = !device.selected; 
                    return scope.updateDevicesSelected(device);
                }

                scope.showMenu = false;
                scope.selected = id;
                scope.selectedDeviceName = device.deviceName;
                scope.deviceSelected = id;
                scope.deviceSelectedSn = serialNumber;
                scope.deviceSelectedType = type;
                scope.hasRMDTRadio = device.hasRMDTRadio;
                scope.hasAnalogOutputBoard = device.hasAnalogOutputBoard;
                scope.hasLevelSensor = device.hasLevelSensor;
                scope.deviceSKUId = device.skuId;
                var titleCustomerName = scope.stickyProperties == null
                    || scope.stickyProperties.adminPortal == null
                    || scope.stickyProperties.adminPortal.customerName == null
                    ? ""
                    : ": " + scope.stickyProperties.adminPortal.customerName;

                if (!$rootScope.mobile && !$rootScope.classicView) {
                    _elementContainer.dialog("option", "title", (scope.windowTitle || scope.$ctrl.windowTitle) + titleCustomerName + ", " + name);
                }
                scope.deviceSelectedName = name;

                if (typeof scope.stickyProperties !== 'undefined' && scope.stickyProperties.device !== null) {
                    scope.stickyProperties.device = {deviceId:device.deviceId, deviceName:device.deviceName, serialNumber:device.serialNumber, protocolVersion:device.protocolVersion, model:device.model};
                } else {
                    if (typeof scope.stickyProperties != 'object') {
                        scope.stickyProperties = {
                            device: {
                                deviceId: null
                            }
                        };
                    }
                    scope.stickyProperties.device = { deviceName: name };
                }
                
                if (attrs.menuType == "broadcast") {
                    var tmpDevice = { deviceSelected: scope.deviceSelected, deviceSelectedSn: scope.deviceSelectedSn, deviceSelectedName: scope.deviceSelectedName, 
                        deviceSelectedType: scope.deviceSelectedType, hasRMDTRadio: scope.hasRMDTRadio, hasLevelSensor : scope.hasLevelSensor, deviceSKUId: scope.skuId, hasAnalogOutputBoard: scope.hasAnalogOutputBoard}
                    scope.broadcastAllDeviceSelected(tmpDevice);
                }

                //Call method in ctrl depending on deviceListType
                if (scope.callCtrlSetDevice && scope.$ctrl && scope.$ctrl.setDevice) { scope.$ctrl.setDevice(device); }
            };
 
            scope.isDeviceSelected = function (section) {
                if(attrs.deviceListType == "rainfall"){return scope.selectedDeviceName == section.deviceName}
                return scope.selected === section.deviceId;
            };

            //THE-51618 (WCAG 2.1.1, custom radio buttons not operable with keyboard)
            //and THE-51621 (WCAG 4.1.2, ARIA role and state not defined).
            //The device options are a custom single-select list: an <li> whose dot is a
            //fa-circle-o / fa-dot-circle-o glyph. The popover is appended to <body>,
            //and focus could not be made to land inside it, so this is built as a
            //select-only combobox instead: DOM focus stays on the trigger button, keys
            //are handled there, and the highlighted option is tracked with
            //aria-activedescendant. All of it is skipped in checkbox mode
            //(device-list-type="signalConnect"), which uses real <input> elements.

            scope.activeDeviceIndex = -1;
            scope.activeDeviceOptionId = null;

            var _deviceOptionId = function (device) {
                return device ? "deviceoption_" + device.deviceId : null;
            };

            //point the highlight at whatever is currently selected, used when opening
            scope.syncActiveDeviceOption = function () {
                if (scope.checkBoxEnabled || !scope.devices || !scope.devices.length) return;
                var index = 0;
                for (var i = 0; i < scope.devices.length; i++) {
                    if (scope.isDeviceSelected(scope.devices[i])) {
                        index = i;
                        break;
                    }
                }
                scope.activeDeviceIndex = index;
                scope.activeDeviceOptionId = _deviceOptionId(scope.devices[index]);
            };

            scope.setActiveDeviceOption = function (index) {
                if (!scope.devices || !scope.devices.length) return;
                if (index < 0) index = scope.devices.length - 1;
                if (index >= scope.devices.length) index = 0;
                scope.activeDeviceIndex = index;
                scope.activeDeviceOptionId = _deviceOptionId(scope.devices[index]);

                //nothing inside the popover holds focus, so the browser will not scroll
                //the highlighted option into view for us
                var option = document.getElementById(scope.activeDeviceOptionId);
                if (option && option.scrollIntoView) option.scrollIntoView({ block: "nearest" });
            };

            //THE-51618: all keyboard operation for the device menu lives here, bound to
            //the trigger button rather than to the options
            scope.deviceMenuKeydown = function ($event) {
                if (scope.checkBoxEnabled || !scope.devices || !scope.devices.length) return;

                var key = $event.key;

                //closed: Down/Up opens the list, Enter/Space fall through to the
                //button's native click, which opens it as well
                if (!scope.showMenu) {
                    if (key === "ArrowDown" || key === "ArrowUp") {
                        $event.preventDefault();
                        scope.showMenu = true;
                        scope.syncActiveDeviceOption();
                    }
                    return;
                }

                switch (key) {
                    case "ArrowDown":
                        scope.setActiveDeviceOption(scope.activeDeviceIndex + 1);
                        break;
                    case "ArrowUp":
                        scope.setActiveDeviceOption(scope.activeDeviceIndex - 1);
                        break;
                    case "Home":
                        scope.setActiveDeviceOption(0);
                        break;
                    case "End":
                        scope.setActiveDeviceOption(scope.devices.length - 1);
                        break;
                    case "Enter":
                    case " ":
                    case "Spacebar":
                        var device = scope.devices[scope.activeDeviceIndex];
                        if (device) scope.setDevice(device.deviceId, device.name, device.serialNumber, device.type, device);
                        break;
                    case "Escape":
                    case "Esc":
                        scope.showMenu = false;
                        break;
                    default:
                        return;
                }

                //preventDefault also stops Enter/Space re-triggering the button's click,
                //which would toggle the popover straight back open
                $event.preventDefault();
            };

            scope.selectDevice = function ($event, varId, varName) {
                $event.stopPropagation();
                scope.deviceSelected = varId;
                scope.showMenu = false;
            };

            scope.initialDeviceSelect = function (varIndex) {
                //Do not run remaining code if checkBoxEnabled
                if(scope.checkBoxEnabled){
                    //Default to all devices selected
                    scope.devices[0].selected = true;
                    return scope.updateDevicesSelected();
                }

                //Do not run if rtuBasicInfoUpdate was updated via broadcast
                if(!scope.preventInitialSetup){
                    scope.selected = scope.devices[varIndex].deviceId;
                    scope.selectedDeviceName = scope.devices[varIndex].deviceName;
                    scope.deviceSelected = scope.devices[varIndex].deviceId;
                    scope.deviceSelectedSn = scope.devices[varIndex].serialNumber;
                    scope.deviceSelectedType = scope.devices[varIndex].type;
                    scope.hasRMDTRadio = scope.devices[varIndex].hasRMDTRadio;
                    scope.hasLevelSensor = scope.devices[varIndex].hasLevelSensor;
                    scope.deviceSKUId = scope.devices[varIndex].skuId;
                    scope.hasAnalogOutputBoard = scope.devices[varIndex].hasAnalogOutputBoard;
                    if (scope.topMenuDevice) {
                        if (!$rootScope.mobile && !$rootScope.classicView) {
                            var titleCustomerName = scope.stickyProperties == null
                                || scope.stickyProperties.adminPortal == null
                                || scope.stickyProperties.adminPortal.customerName == null
                                ? ""
                                : ": " + scope.stickyProperties.adminPortal.customerName;
                            _elementContainer.dialog("option", "title", (scope.windowTitle || scope.$ctrl.windowTitle) + titleCustomerName + ", " + scope.devices[varIndex].name);
                        }
                        scope.deviceSelectedName = scope.devices[varIndex].name;
                    }       
                    //Call method in ctrl depending on deviceListType
                    if(scope.callCtrlSetDevice){scope.ctrlSetDevice()} 
                }
                //Run if rtuBasicInfoUpdate was updated via broadcast to update device Name in view title
                else{
                    if (!$rootScope.mobile && !$rootScope.classicView) {
                        _elementContainer.dialog("option", "title", (scope.windowTitle || scope.$ctrl.windowTitle) + ", " + scope.devices[varIndex].name);
                    }
                    scope.preventInitialSetup = false; 
                }
            };

            scope.updateDevicesSelected = function (deviceSelected) {
               scope.filteredDeviceIds = [];

                //Check if all devices ALREADY selected
                if (scope.allDevicesChecked && typeof deviceSelected !== 'undefined') {
                   //Unselect device picked and all devices option
                   scope.devices[0].selected = false;
                   deviceSelected.selected = false;

                    //Unselect all devices if All Devices Selected twice
                   if(deviceSelected.deviceId == -1){
                    scope.devices.forEach(function(device, idx){
                        device.selected = false;
                    });
                   }
               }
               //Check if all devices selected
               if(scope.devices[0].selected){
                   scope.devices.forEach(function(device, idx){
                       device.selected = true;
                       if(idx > 0){scope.filteredDeviceIds.push(device.deviceId)}
                   });
               }
               else{
                scope.devices.filter(function(device, idx){
                    if(device.selected){scope.filteredDeviceIds.push(device.deviceId)}
                    //reset all devices option to false
                    if(idx == 0){device.selected = false;}
                })
               }

               //Check if all devices have been individually selected
               var deviceSelectedCount = 0;
               scope.devices.forEach(function(device){
                    if(device.selected) deviceSelectedCount += 1;
                });
                //If true then all devices option set to true
                if(deviceSelectedCount == (scope.devices.length -1)){
                    scope.devices[0].selected = true;
                }

                scope.allDevicesChecked = scope.devices[0].selected;
                if (scope.$ctrl && scope.$ctrl.setDevicesSelected)
                    scope.$ctrl.setDevicesSelected(scope.filteredDeviceIds);
            };

            scope.ctrlSetDevice = function(){
                var index = 0;
                //if deviceId is set earlier in sticky props
                if (scope.$ctrl && scope.$ctrl.stickyProperties && scope.$ctrl.stickyProperties.deviceId) {
                    for (var idx = 0; idx < scope.devices.length; idx++) {
                        //Get device id from sticky property if set before
                        if (scope.devices[idx].deviceId == scope.$ctrl.stickyProperties.deviceId) {
                            index = idx;                            
                        }                        
                    }
                    scope.selected = scope.devices[index].deviceId;
                    scope.selectedDeviceName = scope.devices[index].deviceName;
                    //when device id not set, default to first item in device array ie index = 0
                    if (scope.$ctrl && scope.$ctrl.setDevice)
                        scope.$ctrl.setDevice(scope.devices[index]);
                }
                //default to first item in device array
                else{
                    scope.selected = scope.devices[0].deviceId;
                    scope.selectedDeviceName = scope.devices[0].deviceName;
                    if (scope.$ctrl && scope.$ctrl.setDevice)
                        scope.$ctrl.setDevice(scope.devices[0]);
                }
                //Set Window title
                if (!$rootScope.mobile && !$rootScope.classicView) {
                    _elementContainer.dialog("option", "title", (scope.windowTitle || scope.$ctrl.windowTitle || scope.$ctrl.windowId) + ", " + (scope.devices[index].name || scope.devices[index].deviceName));
                }
            }

            scope.deviceListCheck = function () {
                return function (item) {
                    if (item.model == 15 || item.model == 20 || item.ssoCso)
                    {
                        return true;
                    }
                    return false;
                };
            }

            scope.filterDeviceList = function(item){
                switch (attrs.deviceListType) {
                    case "ssocso":
                        if (item.model == 15 || item.model == 20 || item.ssoCso){return true;}
                        return false;
                    case "chlorine":
                        if (item.hasChlorineReport){return true;}
                        return false;
                    case "cumFlow":
                        if (item.hasCumulativeFlow === null || item.hasCumulativeFlow){return true;}
                        return false;
                    case "flow":
                        if (item.sumDeviceAnalog > 0){return true;}
                        return false;
                    case "volFlow":
                        if (item.hasVolumetricFlow && (item.model == 9 || item.model == 19)){return true;}
                        return false;
                    case "mmPlus":
                        if (item.type == 20 || item.protocolVersion == 2 || item.hasAdamsRelayModule){return true;}
                        return false;
                    case "mmPlusOnly":
                        if (item.type == 20 && item.hasLevelSensor) { return true; }
                        return false;
                    case "pumpStationOnly":
                        if (item.pumpStationWidgetId > 0 && (item.type == 8 || item.type == 9 || item.type == 17 || item.type == 18 || item.type == 19 || item.type == 21)) { return true; }
                        return false;
                    case "rainfall":
                        var type = item.type || item.deviceType;
                        if (type != 15 && type != 20){return true;}
                        return false;
                    default:
                        return true;
                }
            }

            // Default DeviceList
            scope.getDeviceList = function(){

                scope.deviceList = function () {
                    if (scope.accountInfo === null)
                        return;                
                    deviceMenuService.getDeviceMenuList(scope.portalCustomerId || scope.accountInfo.customerId)
                    .then(function (datafromfactory) {
                        scope.devices = angular.copy(datafromfactory.data.devices);
                        //Filter devices based on attrs.deviceListType
                        scope.devices = scope.devices.filter(scope.filterDeviceList);
                        if(scope.addAllDevicesOption && scope.devices[0].id != -1){ scope.devices.unshift({"deviceId": -1, "name": 'All Devices'}) }
                        if (scope.devices.length === 0) {scope.devices.push({ deviceId: "", name: scope.translation.text.NO_DEVICES });}

                        var tmpSelected = false;
                        var tmpSelectedIndex = -1;

                        //NOTE: by default first device is selected, if sticky properties is not set with any specific deviceId
    
                        for (var index = 0; index < scope.devices.length; ++index) {

                            if (typeof scope.stickyProperties !== 'undefined' && scope.devices[index].deviceId == scope.stickyProperties.deviceId) {
                                scope.initialDeviceSelect(index);
                                tmpSelected = true;
                                //break;
                            }
                            if (tmpSelectedIndex < 0 && !scope.isFirstDevice && scope.devices[index].hasAnalog && scope.devices[index].heardInLast24h)
                                tmpSelectedIndex = index;
                            if (scope.devices[index].solar)
                                scope.hasSolar = true;
                            if (scope.devices[index].hasPulseFlow)
                                scope.hasPulseFlow = true;                           
                        }
                        deviceMenuService.setSolar(scope.hasSolar);
                        deviceMenuService.setPulseFlow(scope.hasPulseFlow);
    
                        if (!tmpSelected && scope.devices.length > 0) {
                            tmpSelectedIndex = tmpSelectedIndex < 0 ? 0 : tmpSelectedIndex;
                            scope.initialDeviceSelect(tmpSelectedIndex);
                        }
                    },
                    function (error) {
                        //error
                    });
    
                };
    
                if (!$rootScope.mobile && !$rootScope.classicView) {
                    if (_elementContainer.parent().css("height").replace(/[^0-9.]+/g, "") < 470) {
                        scope.maxHeight = (_elementContainer.parent().css("height").replace(/[^0-9.]+/g, "") - 70) + 'px';
                    }
                }
    
                scope.deviceList();
                scope.label = attrs.label;
                scope.showMenu = false;
            }

            //Get RainFall Device List
            scope.getRainfallDeviceList = function(){
                deviceMenuService.resetRainfallDeviceMenuList(); //clear the list before making call.

                if(attrs.rainfall == "true")
                {
                    deviceMenuService.getRainfallDeviceMenuList(scope.accountInfo.customerId)
                    .then(function (result) {
                        scope.devices = angular.copy(result.data);
                        scope.initialDeviceSelect(0);
                    }, function (error) {
                        console.log(error);
                    });
                }
                else
                {
                    deviceMenuService.getRAllDevicesRainfallMenuList(scope.accountInfo.customerId)
                    .then(function (result) {
                        scope.devices = angular.copy(result.data);
                        //Filter devices to remove ManHole
                        scope.devices = scope.devices.filter(scope.filterDeviceList);
                        scope.initialDeviceSelect(0);
                    }, function (error) {
                        console.log(error);
                    });
                }

            }

            ///Scroll menu up to selected device
            scope.scrollToSelectedDevice = function () {
                $timeout(function () {
                    var deviceList = $('body').find('.device-id-menu, .top-menu');// $(element).parent().find('.device-id-menu');
                    var selectedDevice = deviceList.find('.fa-dot-circle-o');
                    var selectedDeviceParentLi = selectedDevice.parent();

                    var yPosition = typeof selectedDeviceParentLi.position() != "undefined" ? selectedDeviceParentLi.position().top : -1;

                    if (typeof deviceList != "undefined" && yPosition >= 0)
                    deviceList.scrollTop(yPosition);
                }, 0);
            };
            
            ///// Shared by all device list setups
            scope.broadcastAllDeviceSelected = function (varDevice) {
                $rootScope.$broadcast('broadcastAllDeviceSelected', varDevice);
            };

            scope.$on('rtuBasicInfoUpdate', function (event, args) {
                scope.getAnyDeviceList();
                scope.preventInitialSetup = true;
            });

            scope.$on('updateSignalConnectDeviceList', function (event, args) {
                //when refresh on signal connect / set to all devices
                scope.devices[0].selected = true;
                scope.allDevicesChecked = false;
                scope.updateDevicesSelected(scope.devices[0]);
            });

            var tmpEvent = "click.deviceList" + scope.windowId;
            tmpEvent = tmpEvent.replace(/ /g, "_");

            scope.$on(
                "$destroy",
                function (event) {
                    _elementContainer.off("mouseup.deviceList");
                    $document.off(tmpEvent);
                }
            );
        }
    };
}]);

mcapp.factory("deviceMenuService", ["$http", "HOST", "sharedSetupService", "$q", function ($http, HOST, sharedSetupService, $q) {
    var deviceMenuFactory = {};
    var deviceMenuList = {};
    var deviceRainfallMenuList = {};
    var allDevicesRainfallMenuList = {};
    var hasSolar = undefined;
    var hasPulseFlow = undefined;
    var skuId = undefined;
    var isRanger = undefined;
    var _devices = []; //keeping devices list locally for future access, no services call is required later

    var _setSolar = function (varData) {
        hasSolar = varData;
    };

    var _getSolar = function (varData) {
        return hasSolar; 
    };

    var _setPulseFlow = function (varData) {
      hasPulseFlow = varData;
    };

    var _getPulseFlow = function (varData) {
      return hasPulseFlow;
    };

    var _getSKUId = function (varData) {
       return skuId;
    };

    var _getDeviceMenu = function (customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DeviceMenuList?customerID=' + customerId,
            cache: false
        });
    };

    var isEmpty = function(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    var _getDeviceMenuList = function (customerId) {
        //if (Object.keys(deviceMenuList).length == 0) {
        if (isEmpty(deviceMenuList) || sharedSetupService.adminPortal()) {
            deviceMenuList = _getDeviceMenu(customerId);
        }
        return deviceMenuList;
    };

    var _resetDeviceMenuList = function () {
        deviceMenuList = {};
    };

    //START: Rainfall specific devices list related code
    var _getRainfallDeviceMenu = function (customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/MetarRainfallTable?customerID=' + customerId,
            cache: false
        });
    };

    var _getRainfallDeviceMenuList = function (customerId) {
        if (Object.keys(deviceRainfallMenuList).length == 0) {
            deviceRainfallMenuList = _getRainfallDeviceMenu(customerId);
        }
        return deviceRainfallMenuList;
    };

    var _resetRainfallDeviceMenuList = function () {
        deviceRainfallMenuList = {};
    };

    var _getAllDevicesRainfallMenu = function (customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DeviceMenuList?customerId=' + customerId + '&rainfallDevices=' + true,
            cache: false
        });
    };

    var _getRAllDevicesRainfallMenuList = function (customerId) {
        if (Object.keys(allDevicesRainfallMenuList).length == 0) {
            allDevicesRainfallMenuList = _getAllDevicesRainfallMenu(customerId);
        }
        return allDevicesRainfallMenuList;
    };

    var _resetAllDevicesRainfallMenuList = function () {
        allDevicesRainfallMenuList = {};
    };
    //END: Rainfall specific devices list related code

    var _isMmPlusOrGenII = function (customerId, deviceId) {
        var deferred = $q.defer();
        _getDeviceMenuList(customerId)
            .then(function (result) {
                _devices = result.data.devices;
                for (var index = 0; index < _devices.length; ++index) {
                    if (_devices[index].deviceId === deviceId) {
                        isRanger = false;
                        if(_devices[index].type == 15) {
                            deferred.resolve(false);
                        } else if (_devices[index].type == 20 || _devices[index].protocolVersion == 2 || _devices[index].hasAdamsRelayModule) {
                            skuId =  _devices[index].skuId;
                            deferred.resolve(true);
                        } else if (_devices[index].type == 21 || _devices[index].protocolVersion == 4) {
                            isRanger = true;
                            deferred.resolve(true);
                        } else {
                            deferred.resolve(false);
                        }
                        break;
                    }
                }
            }, function (error) {
                    console.log("Error");
                    deferred.resolve(false);
            });

        return deferred.promise;
    };

    var _isRanger = function () {
        return isRanger;
    };
    var _getDevice = function(deviceId) {
        if (_devices != null && _devices.length > 0) {
            return _devices.find(
                function(device) {
                    return device.deviceId == deviceId;
                });
        }
    };

    deviceMenuFactory.getDeviceMenuList = _getDeviceMenuList;
    deviceMenuFactory.resetDeviceMenuList = _resetDeviceMenuList;
    deviceMenuFactory.getRainfallDeviceMenuList = _getRainfallDeviceMenuList;
    deviceMenuFactory.resetRainfallDeviceMenuList = _resetRainfallDeviceMenuList;
    deviceMenuFactory.getRAllDevicesRainfallMenuList = _getRAllDevicesRainfallMenuList;
    deviceMenuFactory.resetAllDevicesRainfallMenuList = _resetAllDevicesRainfallMenuList;
    deviceMenuFactory.setSolar = _setSolar;
    deviceMenuFactory.getSolar = _getSolar;
    deviceMenuFactory.setPulseFlow = _setPulseFlow;
    deviceMenuFactory.getPulseFlow = _getPulseFlow;
    deviceMenuFactory.isMmPlusOrGenII = _isMmPlusOrGenII;
    deviceMenuFactory.getskuId = _getSKUId;
    deviceMenuFactory.getIsRanger = _isRanger;
    deviceMenuFactory.getDevice = _getDevice;
    return deviceMenuFactory;
}]);

"use strict";

angular.module("mc.delayed-alarm", []);
'use strict';

function DelayedAlarmFactory(REPORTS, $http) {

    var DelayedAlarm = function DelayedAlarm(customerId, startDate, endDate, timeZone, langId) {
        this.customerId = customerId;
        this.startDate = startDate;
        this.endDate = endDate;
        this.timeZone = timeZone;
        this.langId = langId;
    };

    DelayedAlarm.prototype.getData = function () {
        var self = this;
        return $http.get(REPORTS + '/api/DelayedAlarmHistory' + '?customerId=' + this.customerId + '&startDate=' + this.startDate + '&endDate=' + this.endDate + '&timeZone=' + this.timeZone + '&langId=' + this.langId).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };
    return DelayedAlarm;
}

DelayedAlarmFactory.$inject = ['REPORTS', '$http'];

angular.module('mc.delayed-alarm').factory('DelayedAlarmFactory', DelayedAlarmFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function DelayedAlarmController(_, HOST, $scope, $http, $sce, datetimeService, sharedSetupService, $element, timeLapseService, translationService, websocketService, authenticationService, getDateRangeService, savePdfService, DelayedAlarmFactory, toaster) {
    var ctrl = this;
    //  ctrl.goSelectReportData();
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.showMsg = false;
        ctrl.downloadViewTypeOptions = [0, 1, 2];

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.goSelectReportData(false);

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            ctrl.popup.dialog('option', 'title', ctrl.translation.text.DELAYED_ALARM_HISTORY);
            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    $scope.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.goSelectReportData(true);
    };

    ctrl.goSelectReportData = function (isRefresh) {

        ctrl.maxDateRange = getDateRangeService.getRange("DelayedAlarmHistory");

        ctrl.delayedAlarms = [];
        var varDateRangeStart = void 0;
        var varDateRangeEnd = void 0;
        var varDateRangeEndTmp = void 0;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        }
        if (ctrl.stickyProperties.on == true) {
            ctrl.stickyProperties.on = false;
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else {
            if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
                ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
                ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
                varDateRangeEnd = ctrl.myDateRangeEnd;
                varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                varDateRangeStart = ctrl.myDateRangeStart;
                varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
            } else {
                ctrl.myDateRangeEnd = new Date();
                ctrl.myDateRangeStart = new Date();
                ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - (ctrl.maxDateRange - 1));

                varDateRangeEnd = new Date();
                varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                varDateRangeEndTmp = new Date();
                varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
                varDateRangeStart = varDateRangeEndTmp - (ctrl.maxDateRange + 0 - 1) * ctrl.unixDay;
            }
        }
        //used for refresh button to reload newest data
        if (isRefresh) {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - (ctrl.maxDateRange - 1));

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            varDateRangeStart = varDateRangeEndTmp - (ctrl.maxDateRange + 0 - 1) * ctrl.unixDay;
        }
        ctrl.showMsg = false;
        ctrl.loadingInProgress = true;
        var _delayedAlarm = new DelayedAlarmFactory(ctrl.accountInfo.customerId, varDateRangeStart, varDateRangeEnd, ctrl.accountInfo.timeZone, ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"));

        _delayedAlarm.getData().then(function () {
            ctrl.loadingInProgress = false;
            ctrl.delayedAlarms = _delayedAlarm.list;
        });

        //     $http.get(`${HOST}/api/DelayedAlarmHistory?customerId=${ctrl.accountInfo.customerId}`
        //     + `&startDate=${varDateRangeStart}`
        //     + `&endDate=${varDateRangeEnd}`
        //     + `&timeZone=${ctrl.accountInfo.timeZone}`
        //     + `&langId=${ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_")}`
        //     ).then((resp) => {
        //     ctrl.loadingInProgress = false;
        //     ctrl.delayedAlarms = resp.data;
        //    });
    };

    ctrl.getResultColor = function (resultId) {
        //ResultId values, 
        //0: Active
        //1: Cancelled
        //2: Triggered
        //NOTE: result description cant be used as it is translated value, so we need to use ResultID instead.
        var retColor = ''; //CANCELLED
        switch (resultId) {
            case 0:
                //ACTIVE
                retColor = '#5cb85c'; //'green';
                break;
            case 2:
                //TRIGGERED
                retColor = '#E75A5A'; // 'red';
                break;
        }
        return retColor;
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.goSelectReportData(false);
        var _tmpTimeFormat = $scope.timeFormat;
        $scope.timeFormat = 0;
        $timeout(function () {
            $scope.timeFormat = _tmpTimeFormat;
        }, 0);
    });
};

DelayedAlarmController.$inject = ['_', 'HOST', '$scope', '$http', '$sce', 'datetimeService', 'sharedSetupService', '$element', 'timeLapseService', 'translationService', 'websocketService', 'authenticationService', 'getDateRangeService', 'savePdfService', 'DelayedAlarmFactory', 'toaster'];
'use strict';

angular.module('mc.delayed-alarm').component('delayedAlarmHistory', {
    controller: DelayedAlarmController,
    templateUrl: 'ui/delayedalarm/delayed-alarm-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.device-status", []);
'use strict';

function DeviceStatusFactory(HOST, $http) {

    var _deviceStatus = function _deviceStatus() {};

    _deviceStatus.prototype.ListDevicesStatusByCustomerId = function (customerId, getNetworkOperator) {
        return $http({
            method: 'GET',
            url: HOST + '/api/DeviceStatus/',
            params: { customerId: customerId, getNetworkOperator: getNetworkOperator }
        });
    };

    _deviceStatus.prototype.UpdateDeviceCallout = function (deviceId, customerId, serialNumber, calloutStatus) {
        return $http({
            method: 'POST',
            url: HOST + '/api/DeviceStatus/UpdateDeviceCallOut/',
            params: { deviceId: deviceId, customerId: customerId, serialNumber: serialNumber, calloutStatus: calloutStatus }
        });
    };

    _deviceStatus.prototype.ModifyExpansionModule = function (deviceId, deviceTypeId, model, hasAnalogOutputBoard, hasMydroExpansion) {
        return $http({
            method: 'POST',
            url: HOST + '/api/DeviceStatus/ModifyExpansionModule/',
            params: { deviceId: deviceId, deviceTypeId: deviceTypeId, model: model, hasAnalogOutputBoard: hasAnalogOutputBoard, hasMydroExpansion: hasMydroExpansion }
        });
    };
    _deviceStatus.prototype.ModifyDOExpansionModule = function (deviceId, model, hasDOExpansion, hasMydroExpansion) {
        return $http({
            method: 'POST',
            url: HOST + '/api/DeviceStatus/ModifyDOExpansionModule/',
            params: { deviceId: deviceId, model: model, hasDOExpansion: hasDOExpansion, hasMydroExpansion: hasMydroExpansion }
        });
    };

    _deviceStatus.prototype.UpdateNewDeviceDefaultSetting = function (deviceId, deviceType) {
        return $http({
            method: 'POST',
            url: HOST + '/api/DeviceStatus/UpdateNewDeviceDefaultSetting/',
            params: { deviceId: deviceId, deviceType: deviceType }
        });
    };

    //_attRatePlan.prototype.GetDeviceTypesCurrentPlansCustomers = function (wirelessCarrier) {
    //    return $http({
    //        method: 'GET',
    //        url: HOST + '/api/CarrierRatePlan/GetDeviceTypeCarrierPlanAndCustomer/',
    //        params: { wirelessCarrier }
    //    });
    //}

    //_attRatePlan.prototype.GetRtuByDeviceTypeCarrierPlanCustomer = function (wirelessCarrier, deviceTypeId, ratePlan, customer) {
    //    return $http({
    //        method: 'GET',
    //        url: HOST + '/api/CarrierRatePlan/GetRtuByDeviceTypeCarrierPlanCustomer/',
    //        params: { wirelessCarrier, deviceTypeId, ratePlan, customer },
    //    });
    //}

    //_attRatePlan.prototype.GetRtuBySimOrSerialNumber = function (wirelessCarrier, simNumber, serialNumber) {
    //    return $http({
    //        method: 'GET',
    //        url: HOST + '/api/CarrierRatePlan/GetRtuBySimOrSerialNumber/',
    //        params: { wirelessCarrier, simNumber, serialNumber },
    //    });
    //}

    //_attRatePlan.prototype.GetRtuProvisionLog = function (simNumber, meid) {
    //    return $http({
    //        method: 'GET',
    //        url: HOST + '/api/CarrierRatePlan/GetRtuProvisionLog/',
    //        params: { simNumber, meid },
    //    });
    //}

    //_attRatePlan.prototype.ActivateSim = function (activateSimInformation, customerId, wirelessCarrier) {
    //    return $http.post(HOST + "/api/CarrierSimManagement?customerId=" + customerId + "&wirelessCarrier=" + wirelessCarrier, activateSimInformation);
    //}

    //_attRatePlan.prototype.BulkActivateSim = function (activateModel) {
    //    return $http.post(HOST + "/api/CarrierSimManagement", activateModel);
    //}

    //_attRatePlan.prototype.DeactivateSim = function (rtuList, wirelessCarrier) {
    //    return $http.post(HOST + "/api/CarrierSimManagement?wirelessCarrier=" + wirelessCarrier, rtuList);
    //}

    //_attRatePlan.prototype.UpdateRtuRatePlan = function (rtuList, ratePlan, wirelessCarrier) {
    //    return $http.post(HOST + "/api/CarrierRatePlan?ratePlan=" + ratePlan + "&wirelessCarrier=" + wirelessCarrier, rtuList);
    //}

    return _deviceStatus;
}

DeviceStatusFactory.$inject = ['HOST', '$http'];

angular.module('mc.device-status').factory('DeviceStatusFactory', DeviceStatusFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function DeviceStatusController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, DeviceStatusFactory, $uibModal, $location, deviceMenuService, timeLapseService, datetimeService, deviceNotificationSettingService, websocketService, toaster) {
    var _this2 = this;

    var ctrl = this;
    var _customerId;
    ctrl.devicesStatusList = [];
    ctrl.shrinkUI = false;
    ctrl.loadingInProgress = false;
    ctrl.simUsageChartLoading = false;
    ctrl.simMessageTransmissionCountLoading = false;

    ctrl._deviceStatus = null;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this2);
        ctrl.adminPortal = sharedSetupService.adminPortal();
        ctrl.deviceTypes = [8, 9, 18, 19];
        ctrl._deviceStatus = new DeviceStatusFactory();
        if (_typeof(ctrl.stickyProperties) !== 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        _customerId = ctrl.stickyProperties.adminPortal.customerId || ctrl.accountInfo.customerId;
        ctrl.getDeviceStatusList(_customerId);
        sharedSetupService.getWindowId($scope);

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    adjustSize();
                }
            });
        };
    };

    var adjustSize = function adjustSize() {
        if (ctrl.shrinkUI === false && ctrl.popup.parent().width() < 725) {
            ctrl.shrinkUI = true;
        } else if (ctrl.shrinkUI === true && ctrl.popup.parent().width() >= 725) {
            ctrl.shrinkUI = false;
        }

        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

        //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
        //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
    };

    var wsDataReceivedRTUBASICINFOSETTING = function wsDataReceivedRTUBASICINFOSETTING(data) {
        if (data.Type == 'DEVICEBASICINFO') {
            for (var i = 0; i < ctrl.devicesStatusList.length; i++) {
                if (ctrl.devicesStatusList[i].serialNumber == data.SN && (data.Value.path == "name" || data.Value.path == "wirelessCarrier")) {
                    switch (data.Value.path) {
                        case "name":
                            ctrl.devicesStatusList[i].name = data.Value.value;
                            return;
                        case "wirelessCarrier":
                            ctrl.devicesStatusList[i].wirelessCarrier = data.Value.value;
                            return;
                        default:
                            return;
                    }
                }
            }
        }
    };

    var _registerListener = function _registerListener(deviceList) {
        for (var i = 0; i < deviceList.length; i++) {
            websocketService.register("DEVICEBASICINFO", deviceList[i].serialNumber, 0, wsDataReceivedRTUBASICINFOSETTING, null);
        }
    };

    var _unRegisterListener = function _unRegisterListener(deviceList) {
        for (var k = 0; k < deviceList.length; k++) {
            websocketService.unRegister("DEVICEBASICINFO", deviceList[k].serialNumber, 0, wsDataReceivedRTUBASICINFOSETTING, null);
        }
    };
    ctrl.checkConnectionPercentage = function (percentageUptime) {
        if (percentageUptime > 98) {
            return { 'color': 'green' };
        } else if (percentageUptime > 96) {
            return { 'color': 'yellow' };
        } else {
            return { 'color': 'red' };
        }
    };
    ctrl.getCarrierColor = function (carrierName) {

        if (carrierName.includes('AT&T')) {
            return { 'color': 'blue' };
        } else if (carrierName.includes('Verizon')) {
            return { 'color': 'red' };
        } else if (carrierName.includes('T-Mobile')) {
            return { 'color': 'deeppink' };
        } else if (carrierName.includes('Telenor')) {
            return { 'color': 'darkorange' };
        }
    };

    ctrl.getDeviceStatusList = function (customerId) {
        ctrl.loadingInProgress = true;
        var getNetworkOperator = true;
        ctrl._deviceStatus.ListDevicesStatusByCustomerId(customerId, getNetworkOperator).then(function (resp) {
            ctrl.loadingInProgress = false;
            ctrl.devicesStatusList = resp.data;
            ctrl.checkApnProxyCalloutStatusAndConvertDate();
            ctrl.checkExpansionModule();
            _registerListener(resp.data);
            //console.log(resp.data);
        });
    };

    //Insert default settings for analog and digital
    ctrl.updateNewDeviceDefaultSetting = function (deviceStatus) {
        ctrl._deviceStatus.UpdateNewDeviceDefaultSetting(deviceStatus.deviceId, deviceStatus.model).then(function (resp) {
            toaster.pop('success', "Update Device", 'Default setting inserted');
        });
    };

    //open Current Status
    ctrl.openBangPage = function (deviceStatus) {
        //sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, windowId: $scope.windowId });
        var _device = { deviceId: deviceStatus.deviceId, deviceName: deviceStatus.deviceName };
        $scope.stickyProperties.deviceId = deviceStatus.deviceId;
        $scope.stickyProperties.device = _device;

        if (!$rootScope.mobile && !$rootScope.classicView) {
            openViewService.openView('Current Status', { width: 700, height: 500 }, { my: 'right-10 top+6', at: 'right top', of: window }, $scope.stickyProperties, { minimumWidth: 600, minimumHeight: 350 });
        } else {
            $location.path('/technicalsupport/technical-support');
        }
    };

    ctrl.toggleHiddenField = function (deviceStatus, field) {
        //if (ctrl.simUsageChartLoading) return;
        ctrl.currentDeviceId = deviceStatus.deviceId;
        //var oldState = deviceStatus.showSimUsageChart;
        //for (var i = 0; i < ctrl.devicesStatusList.length; i++) {
        //    //ctrl.devicesStatusList[i].showHiddenField = false;
        //    ctrl.devicesStatusList[i].showSimUsageChart = false;
        //    ctrl.devicesStatusList[i].showSimMessageTransmissionCount = false;
        //}

        //if (!oldState) {
        //$scope.dispatchHistory.length = 0;
        //ctrl.simUsageChartLoading = true;
        //We want the 'loading' and the data to be wiped on the digest cycle PRIOR to showing the new dispatch detail row to prevent ugly collapse behavior, hence the timeout
        //    $timeout(function () {
        //        deviceStatus.showSimUsageChart = true;
        //ctrl.simUsageChartLoading = false;
        //    });            
        // }

        if (field == "SIM_USAGE_CHART") {
            deviceStatus.showSimMessageTransmissionCount = false;
            var oldState = deviceStatus.showSimUsageChart;
            for (var i = 0; i < ctrl.devicesStatusList.length; i++) {
                ctrl.devicesStatusList[i].showSimUsageChart = false;
                ctrl.devicesStatusList[i].showSimMessageTransmissionCount = false;
            }
            if (!oldState) {
                $timeout(function () {
                    deviceStatus.showSimUsageChart = true;
                });
            }
        } else {
            deviceStatus.showSimUsageChart = false;
            var _oldState = deviceStatus.showSimMessageTransmissionCount;
            for (var _i = 0; _i < ctrl.devicesStatusList.length; _i++) {
                ctrl.devicesStatusList[_i].showSimUsageChart = false;
                ctrl.devicesStatusList[_i].showSimMessageTransmissionCount = false;
            }
            if (!_oldState) {
                $timeout(function () {
                    deviceStatus.showSimMessageTransmissionCount = true;
                });
            }
        }
    };

    //get SIM data usage by device id
    ctrl.checkSimDataUsage = function (deviceStatus) {
        var device = {
            deviceId: deviceStatus.deviceId,
            deviceName: deviceStatus.name
        };

        timeLapseService.getLocalDateTime().then(function (result) {
            var tmpDates = new Date(result.data.localDateTime);
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);

            var optionsStickyProperties = { deviceId: deviceStatus.deviceId, on: true, device: device, dateMin: tmpDates.startDate, dateMax: tmpDates.endDate, zoomMin: tmpDates.endDate - 3 * 120 * 60 * 1000, zoomMax: tmpDates.endDate, windowId: ctrl.windowId };
            var position = null;
            position = { my: 'top+120', at: 'center top', of: window };

            if (!$rootScope.mobile && !$rootScope.classicView) {
                openViewService.openView('Data Usage', { width: 850, height: 600 }, position, optionsStickyProperties, { minimumWidth: 800, minimumHeight: 600 }, false);
            } else {
                $scope.stickyProperties = ctrl.stickyProperties;
                if (_typeof(ctrl.stickyProperties) != 'object') {
                    ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
                }
                sharedSetupService.setStickyProperties(ctrl.stickyProperties, optionsStickyProperties);
                $location.path('/missiondatausage/mission-data-usage');
            }
            return;
        });
    };

    //create new ticket for selected device
    ctrl.createNewTicket = function (deviceId) {
        var optionsStickyProperties = { deviceId: deviceId };
        var position = null;
        $rootScope.deviceStatusDeviceId = deviceId;
        position = { my: 'top+120', at: 'center top', of: window };
        openViewService.openView("Ticket System", { width: 900, height: 600 }, position, optionsStickyProperties, { minimumWidth: 900, minimumHeight: 600 }, true);
        //Open Ticket creation
        $timeout(function () {
            $('#ticketSystemNewTicket').click();
        }, 100);
    };

    //view ticket for selected device 
    ctrl.viewTicket = function (deviceId) {
        var optionsStickyProperties = { deviceId: deviceId };
        var position = null;
        position = { my: 'top+120', at: 'center top', of: window };
        openViewService.openView("Ticket System", { width: 900, height: 600 }, position, optionsStickyProperties, { minimumWidth: 900, minimumHeight: 600 }, true);
    };

    //add or remove expansion module
    ctrl.modifyExpansionModule = function (deviceStatus, expansionModuleType) {
        if (!ctrl.deviceTypes.includes(deviceStatus.type)) return;
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            //this.tmpConfirmMessageA = item.inUse ? _translation.text.DELETE_SERVICE_USER2 : "";
            this.tmpConfirmMessageB = _translation.text.MODIFY_EXPANSION_MODULE + '?';

            this.ok = function () {
                $uibModalInstance.close();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        };

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            if (expansionModuleType == 'Digital Output') {
                ctrl._deviceStatus.ModifyDOExpansionModule(deviceStatus.deviceId, deviceStatus.type, deviceStatus.hasDOExpansion, deviceStatus.hasMydroExpansion).then(function (resp) {
                    deviceMenuService.resetDeviceMenuList();
                    deviceStatus = resp.data;
                    ctrl.devicesStatusList.find(function (x) {
                        return x.deviceId == deviceStatus.deviceId;
                    }).hasDOExpansion = deviceStatus.hasDOExpansion;
                });
            } else {
                switch (expansionModuleType) {
                    case "Analog Option Board":
                        switch (deviceStatus.typeId) {
                            case 1:
                                deviceStatus.typeId = 2;
                                deviceStatus.analogOptionBoard = true;
                                break;
                            case 2:
                                deviceStatus.typeId = 1;
                                deviceStatus.analogOptionBoard = false;
                                break;
                            case 3:
                                deviceStatus.typeId = 4;
                                deviceStatus.analogOptionBoard = true;
                                break;
                            case 4:
                                deviceStatus.typeId = 3;
                                deviceStatus.analogOptionBoard = false;
                                break;
                        }
                        break;
                    case "Digital Option Board":
                        switch (deviceStatus.typeId) {
                            case 1:
                                deviceStatus.typeId = 3;
                                deviceStatus.digitalOptionBoard = true;
                                break;
                            case 2:
                                deviceStatus.typeId = 4;
                                deviceStatus.digitalOptionBoard = true;
                                break;
                            case 3:
                                deviceStatus.typeId = 1;
                                deviceStatus.digitalOptionBoard = false;
                                break;
                            case 4:
                                deviceStatus.typeId = 2;
                                deviceStatus.digitalOptionBoard = false;
                                break;
                        }
                        break;
                    case "Analog Output":
                        deviceStatus.hasAnalogOutputBoard = !deviceStatus.hasAnalogOutputBoard;
                        break;
                }

                ctrl._deviceStatus.ModifyExpansionModule(deviceStatus.deviceId, deviceStatus.typeId, deviceStatus.type, deviceStatus.hasAnalogOutputBoard, deviceStatus.hasMydroExpansion).then(function (resp) {
                    deviceMenuService.resetDeviceMenuList();
                    deviceStatus = resp.data;
                });
            }
        }, function () {
            // cancel button
        });

        ctrl.checkExpansionModule();
    };

    //convert DeviceTypeId to check whether device has Analog Option Board, Digital Option Board or Analog Output
    ctrl.checkExpansionModule = function () {
        var deviceTypes = [8, 9, 18, 19];
        for (var i = 0; i < ctrl.devicesStatusList.length; i++) {
            if (deviceTypes.includes(ctrl.devicesStatusList[i].type) /*&& ctrl.devicesStatusList[i].lastFlowTime*/ && ctrl.devicesStatusList[i].typeId == 2) {
                ctrl.devicesStatusList[i].analogOptionBoard = true;
            } else if (deviceTypes.includes(ctrl.devicesStatusList[i].type) /*&& ctrl.devicesStatusList[i].lastFlowTime*/ && ctrl.devicesStatusList[i].typeId == 3) {
                ctrl.devicesStatusList[i].digitalOptionBoard = true;
            } else if (deviceTypes.includes(ctrl.devicesStatusList[i].type) /*&& ctrl.devicesStatusList[i].lastFlowTime*/ && ctrl.devicesStatusList[i].typeId == 4) {
                ctrl.devicesStatusList[i].analogOptionBoard = true;
                ctrl.devicesStatusList[i].digitalOptionBoard = true;
            }
        }
    };

    //convert IPAddress to check whether device is on APN or PROXY
    ctrl.checkApnProxyCalloutStatusAndConvertDate = function () {
        var deviceTypes = [8, 9, 18, 19];
        for (var i = 0; i < ctrl.devicesStatusList.length; i++) {
            ctrl.devicesStatusList[i].simVerifiedDate = new Date(ctrl.devicesStatusList[i].simVerifiedDate);
            if (ctrl.devicesStatusList[i].disabled == true) {
                ctrl.devicesStatusList[i].calloutStatusOn = false;
            } else {
                ctrl.devicesStatusList[i].calloutStatusOn = true;
            }
            if (ctrl.devicesStatusList[i].wirelessCarrier == "C" && deviceTypes.includes(ctrl.devicesStatusList[i].type)) {
                if (ctrl.devicesStatusList[i].ipAddress.substring(0, 7) == "172.16.") {
                    ctrl.devicesStatusList[i].apnOrProxy = "";
                } else if (ctrl.devicesStatusList[i].ipAddress.substring(0, 7) == "172.17." || ctrl.devicesStatusList[i].ipAddress.substring(0, 7) == "172.27.") {
                    ctrl.devicesStatusList[i].apnOrProxy = "(APN2)";
                } else {
                    ctrl.devicesStatusList[i].apnOrProxy = "(PROXY)";
                }
            } else {
                ctrl.devicesStatusList[i].apnOrProxy = "";
            }
        }
    };

    //get wireless carrier icon and radio type for each device
    //ctrl.getWirelessCarrierIcon = () => {
    //    for (let i = 0; i < ctrl.devicesStatusList.length; i++) {
    //        switch (ctrl.devicesStatusList[i].wirelessCarrier) {
    //            case "C":
    //                let imeis = ["351579050", "351579051", "351579052", "351579053"];
    //                if (ctrl.devicesStatusList[i].simNumber != null) {
    //                    if (ctrl.devicesStatusList[i].softwareVersion == 11.1 || ctrl.devicesStatusList[i].imei.substring(0, 9) in imeis) {
    //                        ctrl.devicesStatusList[i].radio = "H5";
    //                    }
    //                    else if (ctrl.devicesStatusList[i].imei.substring(0, 4) == "3569") {
    //                        ctrl.devicesStatusList[i].radio = "4G";
    //                    }
    //                    else {
    //                        ctrl.devicesStatusList[i].radio = "F2/F4";
    //                    }
    //                }
    //                else {
    //                    if (ctrl.devicesStatusList[i].softwareVersion == 11.1 || ctrl.devicesStatusList[i].imei.substring(0, 9) in imeis) {
    //                        ctrl.devicesStatusList[i].radio = "H5";
    //                    }
    //                    else {
    //                        ctrl.devicesStatusList[i].radio = "F2/F4";
    //                    }
    //                }
    //                break;
    //            case "S":
    //            case "K":
    //                if (ctrl.devicesStatusList[i].radioEsn != null) {

    //                }
    //                break;
    //            case "N":
    //                break;
    //            case "L":
    //                break;
    //            case "R":
    //                break;
    //            case "V":
    //            case "Z":
    //                break;
    //            case "T":
    //                break;

    //        }
    //    }
    //}    

    //update device callout status
    ctrl.updateDeviceCallout = function (deviceStatus) {
        //ctrl._deviceStatus.UpdateDeviceCallout(deviceStatus.deviceId, deviceStatus.customerId, deviceStatus.serialNumber, deviceStatus.disabled).then((resp) => {

        //})
        deviceStatus.disabled = !deviceStatus.disabled;
        var tmpDeviceNotificationSetting = { "op": "replace", "path": "disabled", "value": deviceStatus.disabled };
        deviceNotificationSettingService.patchDeviceNotificationSetting(deviceStatus.customerId, deviceStatus.deviceId, deviceStatus.name, tmpDeviceNotificationSetting).then(function (results) {

            if (deviceStatus.disabled) {
                tmpDeviceNotificationSetting = { "op": "replace", "path": "disabledUntil", "value": 0 };

                deviceNotificationSettingService.patchDeviceNotificationSetting(deviceStatus.customerId, deviceStatus.deviceId, deviceStatus.name, tmpDeviceNotificationSetting).then(function (results) {
                    //if we need to do something         

                }, function (error) {
                    console.log("error");
                });
            }
        }, function (error) {
            console.log("error");
        });
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getDeviceStatusList(_customerId);
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
            _unRegisterListener(ctrl.devicesStatusList);
        }
    });
};

DeviceStatusController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'DeviceStatusFactory', '$uibModal', '$location', 'deviceMenuService', 'timeLapseService', 'datetimeService', 'deviceNotificationSettingService', 'websocketService', 'toaster'];
'use strict';

angular.module('mc.device-status').component('deviceStatus', {
    controller: DeviceStatusController,
    templateUrl: 'ui/devicestatus/device-status-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.disabled-input-report", []);
"use strict";

function DisabledInputReportFactory(HOST, $http, translationService, REPORTS, $filter) {
    var disabledInputReportService = function disabledInputReportService() {};

    var _getData = function _getData(customerId, languageId) {
        return $http({
            method: 'Get',
            url: REPORTS + "/api/DisabledInputReport?customerId=" + customerId + "&languageId=" + languageId,
            cache: false
        });
    };

    disabledInputReportService.getData = _getData;

    return disabledInputReportService;
}

DisabledInputReportFactory.$inject = ['HOST', '$http', 'translationService', 'REPORTS', '$filter'];

angular.module('mc.disabled-input-report').factory('DisabledInputReportFactory', DisabledInputReportFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function DisabledInputReportController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, DisabledInputReportFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, savePdfService, toaster, textToSpeechService, websocketService, timeLapseService) {
    var ctrl = this;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        ctrl.reverse = false;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.languageID = ctrl.accountInfo.preferenceUser.lookupLanguageID;
        $scope.languageID = ctrl.languageID;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        ctrl.alerts = [];
        ctrl.items = [];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        ctrl.goSelectReportData(false);
        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.busy = true;

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });
            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
            ctrl.adjustSize = function () {
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('.tabular-data-container').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }

        ctrl.getIcon = function (varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        ctrl.fnChangeLanguage = function () {
            if (ctrl.alerts.length > 0) {
                var _msg = eval("$scope.translation.message." + ctrl.disabledInputReportService.alerts[0].languageCode.toUpperCase());
                var _type = ctrl.disabledInputReportService.alerts[0].type;
                var _languageCode = ctrl.disabledInputReportService.alerts[0].languageCode;
                ctrl.disabledInputReportService.alerts = [];
                ctrl.disabledInputReportService.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        };
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.languageID = ctrl.accountInfo.preferenceUser.lookupLanguageID;
        ctrl.goSelectReportData();

        $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
            if (ctrl.alerts.length > 0) {
                var _msg = eval("scope.translation.message." + ctrl.alerts[0].languageCode.toUpperCase());
                var _type = ctrl.alerts[0].type;
                var _languageCode = ctrl.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                    _msg += ': ' + moment(ctrl.disabledInputReportService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.disabledInputReportService.end).utc().format('MM/DD/YY, h:mm:ss a');
                }
                ctrl.alerts = [];
                ctrl.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        });
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.goSelectReportData();
    });

    $scope.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.goSelectReportData();
    };

    ctrl.goSelectReportData = function () {
        ctrl.busy = true;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        ctrl.alerts = [];
        ctrl.items = [];
        ctrl.stickyProperties.on = false;
        DisabledInputReportFactory.getData(ctrl.accountInfo.customerId, ctrl.languageID).then(function (dataFromFactory) {
            ctrl.alerts = [];
            ctrl.items = dataFromFactory.data;
            for (var i = 0; i < ctrl.items.length; i++) {
                ctrl.items[i].enableTime = new Date(ctrl.items[i].enableTime).getFullYear() > 1 ? $filter('date')(ctrl.items[i].enableTime, ctrl.timeFormat) : ctrl.translation.text.INDEFINITELY;
            }
            if (ctrl.items.length > 0) {//if there are records returned
                //
            } else {
                ctrl.alerts = [];
                var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(ctrl.start).format('MM/DD/YY, HH:mm') + ' - ' + moment(ctrl.end).format('MM/DD/YY, h:mm:ss a');
                ctrl.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
            ctrl.pageSize = 50;
            // If we didn't get any items back 
            if (ctrl.items.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
            ctrl.busy = false;
        }, function (error) {
            ctrl.alerts = [];
            var errorMessage = eval("ctrl.translation.message." + error.data.message);
            ctrl.alerts.push({ msg: errorMessage, type: "danger" });
            ctrl.pageSize = 50;
        }).then(function (data) {
            ctrl.loadingInProgress = false;
            ctrl.busy = false;
        });
    };

    ctrl.savePdf = function () {
        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: ctrl.translation.text.DISABLED_INPUTS_REPORT,
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };
        savePdfService.savePDF(pdfParams);
    };

    $scope.toggle = function ($event) {
        if ($($event.currentTarget).hasClass("active-row")) {
            $($event.currentTarget).removeClass("active-row");
        } else {
            $($event.currentTarget).addClass("active-row");
        }
    };

    $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            ctrl.liveDataIn = !ctrle.liveDataIn;
            $timeout(function () {
                ctrl.liveDataIn = !ctrl.liveDataIn;
            }, 3000);
        }
    }, true);

    $scope.$watch('disabledInputReportService.alerts', function (newValue, oldValue) {
        if (newValue && newValue.length > 0 && newValue != oldValue) {
            ctrl.alerts = newValue;
        }
    }, true);

    var orderBy = $filter('orderBy');
    ctrl.order = function (predicate, reverse) {
        switch (predicate) {
            case "deviceName":
            case "inputDescription":
            case "enableTime":
                ctrl.input = reverse ? '-input' : 'input';
                ctrl.items = orderBy(ctrl.items, [predicate, ctrl.input], reverse);
                break;
            default:
                ctrl.items = orderBy(ctrl.items, predicate, reverse);
                break;
        }
        ctrl.predicate = predicate;
    };

    ctrl.setSorting = function () {
        ctrl.order('deviceName', ctrl.reverse);
    };
}

DisabledInputReportController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'DisabledInputReportFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', 'savePdfService', 'toaster', 'textToSpeechService', 'websocketService', 'timeLapseService'];
'use strict';

angular.module('mc.disabled-input-report').component('disabledInputReport', {
    controller: DisabledInputReportController,
    templateUrl: 'ui/disabledinput/disabled-input-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dashboardService = function () {
    function dashboardService($http, HOST) {
        _classCallCheck(this, dashboardService);

        this.$http = $http;
        this.HOST = HOST;
        this.AgentText = [];
        this.busy = false;
        this.after = '';
        this.enddate = null;
    }
    dashboardService.$inject = ["$http", "HOST"];

    _createClass(dashboardService, [{
        key: 'getAlarmCountByDevice',
        value: function getAlarmCountByDevice(customerId) {
            return this.$http({
                method: 'GET',
                url: this.HOST + '/api/livestatus/alarmcount?customerId=' + customerId,
                cache: true
            });
        }
    }, {
        key: 'getLiveStatus',
        value: function getLiveStatus(customerId) {
            return this.$http({
                method: 'GET',
                url: this.HOST + '/api/livestatus?customerId=' + customerId,
                cache: true
            });
        }
    }, {
        key: 'getOfflineDevices',
        value: function getOfflineDevices(customerId) {
            return this.$http({
                method: 'GET',
                url: this.HOST + '/api/livestatus/offlinedevices?customerId=' + customerId,
                cache: true
            });
        }
    }, {
        key: 'getServiceDevices',
        value: function getServiceDevices(customerId) {
            return this.$http({
                method: 'GET',
                url: this.HOST + '/api/livestatus/servicedevices?customerId=' + customerId,
                cache: true
            });
        }
    }, {
        key: 'getDisabledDevices',
        value: function getDisabledDevices(customerId) {
            return this.$http({
                method: 'GET',
                url: this.HOST + '/api/livestatus/disableddevices?customerId=' + customerId,
                cache: true
            });
        }
    }, {
        key: 'getOnlineDevices',
        value: function getOnlineDevices(customerId) {
            return this.$http({
                method: 'GET',
                url: this.HOST + '/api/livestatus/onlinedevices?customerId=' + customerId,
                cache: true
            });
        }
    }, {
        key: 'webAckAlarm',
        value: function webAckAlarm(customerId, userId, userName, eventId) {
            return this.$http({
                method: 'GET',
                url: this.HOST + '/api/WebAckAlarm' + '?customerId=' + customerId + '&userId=' + userId + '&userName=' + userName + '&eventId=' + eventId
            });
        }
    }, {
        key: 'webAckAlarmByDevice',
        value: function webAckAlarmByDevice(customerId, deviceId, unaknowledgedAlarm, deviceName) {
            return this.$http({
                method: 'PUT',
                url: this.HOST + '/api/WebAckAlarm' + '?customerId=' + customerId + '&deviceId=' + deviceId + '&alarmCount=' + unaknowledgedAlarm + '&deviceName=' + deviceName
            });
        }
    }, {
        key: 'webAckAlarmByCustomerId',
        value: function webAckAlarmByCustomerId(customerId) {
            return this.$http({
                method: 'PUT',
                url: this.HOST + '/api/WebAckAlarm' + '?customerId=' + customerId
            });
        }
    }, {
        key: 'getAgentText',
        value: function getAgentText(customerId, timeZone, endDate) {
            return this.$http({
                method: 'Get',
                url: this.HOST + '/api/AgentText' + '?customerId=' + customerId + '&timeZone=' + timeZone + '&endDate=' + endDate,
                cache: true
            });
        }
    }, {
        key: 'getAgentClass',
        value: function getAgentClass(text) {
            text = text.toLowerCase();
            if (text.indexOf(" just accessed ") >= 0 || text.indexOf(" is back online") >= 0) return "warning";
            if (text.indexOf(" acknowledged the ") >= 0) return "lightred";
            if (text.indexOf(" starts in last hour ") >= 0) return "danger";
            if (text.indexOf("being notified") >= 0) return "danger";
            if (text.indexOf("disabled") >= 0 || text.indexOf("reenabled") >= 0) return "lightblue";
            return "";
        }
    }, {
        key: 'stripAgentText',
        value: function stripAgentText(text) {
            if (text.indexOf("[") >= 0 && text.indexOf("]") >= 0) return text.replace(/\[(.+?)\]/g, "");else return text;
        }
    }, {
        key: 'getEventID',
        value: function getEventID(text) {
            var eventId = text.match(/[^[\]]+(?=])/g);
            if (eventId !== null) eventId = eventId[0];
            return eventId;
        }
    }]);

    return dashboardService;
}();

dashboardService.$inject = ['$http', 'HOST'];
mcapp.service('dashboardService', dashboardService);
'use strict';

function DashboardController(_, $scope, $rootScope, authenticationService, dashboardService, websocketService, toaster, translationService, sharedSetupService, openViewService, textToSpeechService, deviceNotificationSettingService, $timeout, $element, datetimeService) {

    var ctrl = this;
    ctrl.showServiceModeNotificationLogic = false; // based on completion of SCADA-4970
    ctrl.alerts = [];
    $scope.alerts = [];
    ctrl.dataLoaded = false;

    var element = $(".dashboard-scroll-height-reference");
    ctrl.enddate = null;
    ctrl.agentText = [];
    ctrl.agentTextTopFifty = [];
    var noRecord = false;
    var btnClassEnum = Object.freeze({
        acknowledged: 'fa fa-check-circle',
        unAcknowledged: 'fa fa-times-circle',
        busy: 'fa fa-spinner fa-spin',
        error: 'fa fa-exclamation-circle'
    });

    ctrl.$onInit = function () {
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.audioEnabled = ctrl.accountInfo.preferenceUser.audioEnabled === 1;

        if (ctrl.accountInfo.userRole === 'AlarmUser' || ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') {
            ctrl.hasAckAccess = true; //determines whether user has access to Alarm & Acknowledge Alarm feature
        }

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for

        // If a dashboard is already instantiated, but minimized, restore it:
        if (!ctrl.mobile && !ctrl.classicView && ctrl.windowTitle != "DashboardSM") {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);
        }

        ctrl.setSpeakFunction();
        //Read Data from DB
        ctrl.getData();
        //Fetch initial data
        ctrl.loadMore();

        startListening();

        if (!ctrl.mobile && !ctrl.classicView && ctrl.windowTitle != "DashboardSM") {
            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);$scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);$scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.adjustHeader();
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.row').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.table').css("height").replace(/[^0-9.]+/g, "") - 40); //40: total padding
                $scope.popup.parent().find('.popover-content').find('div:eq(0)').css("max-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 200);

                var windowHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                var scrollHeight = $scope.popup.parent().find('.tabular-data-container')[0].scrollHeight;
                if (windowHeight > scrollHeight) {
                    if (!ctrl.loadingInProgress) {
                        ctrl.loadMore();
                    }
                }
            };

            $scope.adjustHeader = function () {
                var windowWidth = $scope.popup.outerWidth();
                if (windowWidth < 600) {
                    $scope.popup.parent().find('.pull-right,.shortcut-tiles,.tiles-body i').css("font-size", ".4em");
                    $scope.popup.parent().find('.pull-right,shortcut-tiles.tiles-body i').css("line-height", ".5em");
                    $scope.popup.parent().find('.pull-right span').css("font-size", "10px");
                } else if (windowWidth < 680) {
                    $scope.popup.parent().find('.pull-right,.shortcut-tiles,.tiles-body i').css("font-size", ".5em");
                    $scope.popup.parent().find('.pull-right,shortcut-tiles,.tiles-body i').css("line-height", ".6em");
                    $scope.popup.parent().find('.pull-right span').css("font-size", "12px");
                } else if (windowWidth < 720) {
                    $scope.popup.parent().find('.pull-right,.shortcut-tiles,.tiles-body i').css("font-size", ".6em");
                    $scope.popup.parent().find('.pull-right,shortcut-tiles,.tiles-body i').css("line-height", ".7em");
                    $scope.popup.parent().find('.pull-right span').css("font-size", "12px");
                } else {
                    $scope.popup.parent().find('.pull-right,.shortcut-tiles,.tiles-body i').css("font-size", ".8em");
                    $scope.popup.parent().find('.pull-right,shortcut-tiles,.tiles-body i').css("line-height", ".8em");
                    $scope.popup.parent().find('.pull-right span').css("font-size", "14px");
                }
            };

            $scope.popoverIsOpen = function () {
                $scope.popup.parent().find('.popover-content').find('div:eq(0)').css("max-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - 200);
            };
        }
    };

    // Get Data from the DB:
    ctrl.getData = function () {
        dashboardService.getLiveStatus(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.dataLoaded = true;
            ctrl.ServiceMode = result.data.serviceMode;
            ctrl.isOffline = result.data.isOffline || 0;
            ctrl.isDisabled = result.data.isDisabled;
            ctrl.isDormant = result.data.isDormant;
            ctrl.hasAlarm = result.data.hasAlarm;
            ctrl.Connection = result.data.connection;
            ctrl.getDeviceNotificationStatusData();
        }, function (error) {
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            toaster.pop('error', $scope.windowTitle, errormsg);
        });
    };

    ctrl.getDeviceNotificationStatusData = function () {
        deviceNotificationSettingService.getAllDeviceServiceModeNotifications(ctrl.accountInfo.customerId).then(function (dataFromFactory) {
            ctrl.deviceServiceModeNotifications = dataFromFactory.data;
        });
    };

    ctrl.showServiceModeNotification = function (text) {
        if (!ctrl.showServiceModeNotificationLogic) return;
        var hideAlarmAck = false;
        if (text.toLowerCase().includes('service mode')) {
            ctrl.deviceServiceModeNotifications.forEach(function (device) {
                if (text.includes(" " + device.deviceName + ".") && !device.serviceModeNotification) {
                    hideAlarmAck = true;
                }
            });
        }
        return hideAlarmAck;
    };

    var repStates = {
        Processing: 0,
        NoDestination: 1,
        NeverAcknowledged: 2,
        UserAck: 3,
        InputDisabled: 4,
        KeyAck: 5,
        UnitNotFound: 6,
        ServiceMode: 7,
        SwingerMode: 8,
        NoActiveConditions: 9,
        UnitDisabled: 10,
        WebAck: 11,
        AcFailureOverride: 12,
        AbortedByPrescript: 15,
        WebAck16: 16,
        OpcAck: 17
    };

    ctrl.getDispatchIcon = function (notifyType) {
        switch (notifyType) {
            case 2:
                return "<i class='fa fa-envelope fa-lg'></i>";
            case 3:
                return "<i class='fa fa-square fa-lg'></i>";
            case 4:
                return "<i class='fa fa-fax fa-lg'></i>";
            case 5:
            case 6:
            case 7:
            case 8:
                return "<i class='fa fa-square fa-lg'></i>";
            case 9:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case repStates.OpcAck:
                return "<i class='fa fa-phone fa-lg'></i>";
            case 18:
                return "<i class='fa fa-commenting-o fa-lg'></i>";
            default:
                return "";
        }
    };

    ctrl.getDevices = function (id) {
        switch (id) {
            case 'Offline':
                ctrl.getOfflineDevices();
                break;
            case 'Service':
                ctrl.getServiceDevices();
                break;
            case 'Disabled':
                ctrl.getDisabledDevices();
                break;
            case 'Online':
                ctrl.getOnlineDevices();
                ctrl.setIfDormantLabel();
                break;
            default:
            // do nothing
        }
    };

    ctrl.setIfDormantLabel = function () {
        ctrl.ifDormantLabel = ctrl.isDormant > 0 ? " (" + ctrl.isDormant + " " + ctrl.translation.text.DORMANT + ")" : "";
    };

    ctrl.getAlarmCountByDevice = function () {
        dashboardService.getAlarmCountByDevice(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data;
        }, function (error) {
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            toaster.pop('error', $scope.windowTitle, errormsg);
        });
    };

    ctrl.getOfflineDevices = function () {
        dashboardService.getOfflineDevices(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data;
        }, function (error) {
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            toaster.pop('error', $scope.windowTitle, errormsg);
        });
    };

    ctrl.getServiceDevices = function () {
        dashboardService.getServiceDevices(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data;
        }, function (error) {
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            toaster.pop('error', $scope.windowTitle, errormsg);
        });
    };

    ctrl.getDisabledDevices = function () {
        dashboardService.getDisabledDevices(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data;
        }, function (error) {
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            toaster.pop('error', $scope.windowTitle, errormsg);
        });
    };

    ctrl.getOnlineDevices = function () {
        dashboardService.getOnlineDevices(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.deviceList = result.data;
        }, function (error) {
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            toaster.pop('error', $scope.windowTitle, errormsg);
        });
    };

    ctrl.dynamicPopover = {
        templateUrl: 'DevicesPopoverTemplate.html',
        templateAlarmUrl: 'DevicesAlarmsPopoverTemplate.html'
    };

    ctrl.setSpeakFunction = function () {
        if (ctrl.windowTitle != "DashboardSM") ctrl.speak = ctrl.audioEnabled ? textToSpeechService.speak : null;
    };

    // Watch for Time Format Preference Change
    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;ctrl.getData();
    });

    // Watch for turning speech on and off
    $scope.$on('updatePreferencesAudio', function (event, preferencesAudio) {
        ctrl.audioEnabled = preferencesAudio === 1;
        ctrl.setSpeakFunction();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.loadingInProgress = true;
        ctrl.agentText = angular.copy(ctrl.agentText);
        ctrl.loadingInProgress = false;
    });

    $scope.$on('serviceModeNotificationUpdate', function (event, deviceUpdate) {
        if (!ctrl.showServiceModeNotificationLogic) return;
        ctrl.deviceServiceModeNotifications.forEach(function (device) {
            if (device.deviceId == deviceUpdate.deviceId) {
                device.serviceModeNotification = deviceUpdate.serviceModeNotification;
            }
        });
        //Reassign agentText to allow onetime binding to run again && return to same scroll height
        ctrl.loadingInProgress = true;
        var _element = $($element[0]).find(".dashboard-scroll-height-reference");
        var scrollTop = $(_element)[0].scrollTop;

        ctrl.agentText = angular.copy(ctrl.agentText);
        $timeout(function () {
            ctrl.loadingInProgress = false;
            $(_element).scrollTop(scrollTop);
        }, 0);
    });

    ctrl.getTextTranslations = function (text) {
        var tranlatedText = text;
        if (text.indexOf("acknowledged the") >= 0) tranlatedText = tranlatedText.replace("acknowledged the", ctrl.translation.text.ACKNOWLEDGED_THE);
        if (text.indexOf("A NewUser is being notified.") >= 0) tranlatedText = tranlatedText.replace("A NewUser is being notified.", ctrl.translation.text.NEWUSER_NOTIFIED);
        if (text.indexOf("Nobody is being notified because input is in swinger mode.") >= 0) tranlatedText = tranlatedText.replace("Nobody is being notified because input is in swinger mode.", ctrl.translation.text.SWINGERMODE_NOT_NOTIFIED);
        if (text.indexOf("Nobody was notified because it was end of the cycle.") >= 0) tranlatedText = tranlatedText.replace("Nobody was notified because it was end of the cycle.", ctrl.translation.text.ENDOFCYCLE_NOT_NOTIFIED);
        if (text.indexOf("On Call Phone is being notified.") >= 0) tranlatedText = tranlatedText.replace("On Call Phone is being notified.", ctrl.translation.text.ONCALL_NOTIFIED);
        if (text.indexOf("are being notified.") >= 0) tranlatedText = tranlatedText.replace("are being notified.", ctrl.translation.text.BEING_NOTIFIED);
        if (text.indexOf("Unit now in service mode.") >= 0) tranlatedText = tranlatedText.replace("Unit now in service mode.", ctrl.translation.text.UNIT_SERVICE_MODE);
        if (text.indexOf("Nobody is being notified because it has no active condition.") >= 0) tranlatedText = tranlatedText.replace("Nobody is being notified because it has no active condition.", ctrl.translation.text.NOT_ACTIVE_NOT_NOTIFIED);
        if (text.indexOf("Mission Email Default is being notified.") >= 0) tranlatedText = tranlatedText.replace("Mission Email Default is being notified.", ctrl.translation.text.EMAIL_DEFAULT_NOTIFIED);
        if (text.indexOf("Control Room is being notified.") >= 0) tranlatedText = tranlatedText.replace("Control Room is being notified.", ctrl.translation.text.CONTROLROOM_NOTIFIED);
        if (text.indexOf("Nobody is being notified because unit is disabled.") >= 0) tranlatedText = tranlatedText.replace("Nobody is being notified because unit is disabled.", ctrl.translation.text.UNIT_DISABLED_NOT_NOTIFIED);
        if (text.indexOf("Mission could not notify this event because there is no destination!") >= 0) tranlatedText = tranlatedText.replace("Mission could not notify this event because there is no destination!", ctrl.translation.text.NO_DESTINATION_NOT_NOTIFIED);
        if (text.indexOf("Nobody is being notified because unit is in service mode.") >= 0) tranlatedText = tranlatedText.replace("Nobody is being notified because unit is in service mode.", ctrl.translation.text.UNIT_SERVICEMODE_NOT_NOTIFIED);
        if (text.indexOf("Service mode ended automatically at") >= 0) tranlatedText = tranlatedText.replace("Service mode ended automatically at", ctrl.translation.text.SERVICE_MODE_ENDED_AUTO);
        if (text.indexOf("This is a test alarm") >= 0) tranlatedText = tranlatedText.replace("This is a test alarm", ctrl.translation.text.IS_TEST_ALARM);

        tranlatedText = tranlatedText.replace(/Pump [1-8] had [1-9][0-9]{1,2} starts in last hour at/gi, function (x) {
            x = x.replace(/Pump/gi, ctrl.translation.text.PUMP);x = x.replace(/had/gi, ctrl.translation.text.HAD);x = x.replace(/starts in last hour at/gi, ctrl.translation.text.START_IN_HOUR_AT);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Relay [1-3] Normal at/gi, function (x) {
            x = x.replace(/Relay/gi, ctrl.translation.text.RELAY);x = x.replace(/Normal at/gi, ctrl.translation.text.NORMAL_AT);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Relay [1-3] Off-Normal at/gi, function (x) {
            x = x.replace(/Relay/gi, ctrl.translation.text.RELAY);x = x.replace(/Off-Normal at/gi, ctrl.translation.text.OFF_NORMAL_AT);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Pump [1-3] failed to run at/gi, function (x) {
            x = x.replace(/Pump/gi, ctrl.translation.text.PUMP);x = x.replace(/failed to run at/gi, ctrl.translation.text.FAILED_TO_RUN);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Pump [1-3] failed to stop at/gi, function (x) {
            x = x.replace(/Pump/gi, ctrl.translation.text.PUMP);x = x.replace(/failed to stop at/gi, ctrl.translation.text.FAILED_TO_STOP);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Pump [1-3] started prematurely at/gi, function (x) {
            x = x.replace(/Pump/gi, ctrl.translation.text.PUMP);x = x.replace(/started prematurely at/gi, ctrl.translation.text.STARTED_PREMATURELY);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Pump [1-3] stopped and is now operating normally at/gi, function (x) {
            x = x.replace(/Pump/gi, ctrl.translation.text.PUMP);x = x.replace(/stopped and is now operating normally at/gi, ctrl.translation.text.STOPPED_OPERATING_NORMALLY);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Pump [1-3] stopped prematurely at/gi, function (x) {
            x = x.replace(/Pump/gi, ctrl.translation.text.PUMP);x = x.replace(/stopped prematurely at/gi, ctrl.translation.text.STOPPED_PREMATURELY);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Pump [1-3] started and is now operating normally at/gi, function (x) {
            x = x.replace(/Pump/gi, ctrl.translation.text.PUMP);x = x.replace(/started and is now operating normally at/gi, ctrl.translation.text.STARTED_OPERATING_NORMALLY);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Low Temperature Alarm .*(\w*)+.* at/gi, function (x) {
            x = x.replace(/Low Temperature Alarm/gi, ctrl.translation.text.LOW_TEMP_ALARM);x = x.replace(/at/gi, ctrl.translation.text.AT);
            return x;
        });
        tranlatedText = tranlatedText.replace(/High Temperature Restore .*(\w*)+.* at/gi, function (x) {
            x = x.replace(/High Temperature Restore/gi, ctrl.translation.text.HIGH_TEMP_RESTORE);x = x.replace(/at/gi, ctrl.translation.text.AT);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Low Temperature Restore .*(\w*)+.* at/gi, function (x) {
            x = x.replace(/Low Temperature Restore/gi, ctrl.translation.text.LOW_TEMP_RESTORE);x = x.replace(/at/gi, ctrl.translation.text.AT);
            return x;
        });
        tranlatedText = tranlatedText.replace(/High Temperature Alarm .*(\w*)+.* at/gi, function (x) {
            x = x.replace(/High Temperature Alarm/gi, ctrl.translation.text.HIGH_TEMP_ALARM);x = x.replace(/at/gi, ctrl.translation.text.AT);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Service mode started by .*(\w*)+.* at/gi, function (x) {
            x = x.replace(/Service mode started by/gi, ctrl.translation.text.SERVICE_MODE_STARTED);x = x.replace(/at/gi, ctrl.translation.text.AT);
            return x;
        });
        tranlatedText = tranlatedText.replace(/Service mode ended by .*(\w*)+.* at/gi, function (x) {
            x = x.replace(/Service mode ended by/gi, ctrl.translation.text.SERVICE_MODE_ENDED);x = x.replace(/at/gi, ctrl.translation.text.AT);
            return x;
        });

        tranlatedText = tranlatedText.replace(/is being notified/gi, ctrl.translation.text.IS_BEING_NOTIFIED);
        tranlatedText = tranlatedText.replace(/Power Restore at /gi, ctrl.translation.text.POWER_RESTORE_AT);
        tranlatedText = tranlatedText.replace(/Power Fault at /gi, ctrl.translation.text.POWER_FAULT_AT);
        tranlatedText = tranlatedText.replace(/communications fault. There will be no alarms or remote control from this unit until it returns on line at/gi, ctrl.translation.text.COMMUNICATIONS_FAULT);
        tranlatedText = tranlatedText.replace(/The communications link has returned to normal. Alarms and remote control are now active for this unit at/gi, ctrl.translation.text.COMMUNICATIONS_RETURN_NORMAL);
        tranlatedText = tranlatedText.replace(/Water System Control is Off-line, System must be controlled manually at/gi, ctrl.translation.text.WATER_SYSTEM_CONTROL);
        tranlatedText = tranlatedText.replace(/communication fault. There will be no alarms until the communication link is restored at/gi, ctrl.translation.text.COMMUNICATIONS_FAULT_UNTIL);
        tranlatedText = tranlatedText.replace(/Service mode ended by/gi, ctrl.translation.text.SERVICE_MODE_ENDED);
        tranlatedText = tranlatedText.replace(/Service mode started by/gi, ctrl.translation.text.SERVICE_MODE_STARTED);

        tranlatedText = tranlatedText.replace(/at (.*) is being notified/gi, function (x) {
            x = x.replace(/at/gi, ctrl.translation.text.AT);x = x.replace(/is being notified/gi, ctrl.translation.text.IS_BEING_NOTIFIED);
            return x;
        });

        return tranlatedText;
    };

    ctrl.mostRecentData = function () {
        ctrl.enddate = null;
        ctrl.agentText = [];
        ctrl.getData();
        ctrl.loadMore();
        toaster.pop('success', "Dashboard", 'View reloading');
    };

    ctrl.selectMyDate = function (date) {
        date.setHours(23, 59, 59, 999);
        ctrl.myDate = date;
        ctrl.enddate = ctrl.myDate.toJSON();
        ctrl.agentText = [];
        ctrl.loadMore();
    };

    //Fetch data from the DB
    ctrl.loadMore = function () {
        if (ctrl.busy || noRecord || ctrl.windowTitle == "DashboardSM") return;
        ctrl.busy = true;
        dashboardService.getAgentText(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone, ctrl.enddate).then(function (result) {
            var items = result.data;
            if (items.length === 0) {
                noRecord = true;
                ctrl.busy = false;
                $scope.alerts.push({ msg: ctrl.translation.text.NO_DATA, type: "info" });
                return;
            }

            for (var i = 0; i < items.length; i++) {
                items[i].class = dashboardService.getAgentClass(items[i].agentTextString);
                items[i].translatedText = ctrl.getTextTranslations(items[i].agentTextString);
                items[i].eventId = items[i].repId;
                items[i].showAck = false;
                items[i].showAlreadyAck = false;
                if (items[i].eventId !== "" && items[i].eventId !== 0) {
                    if (items[i].firstAckId === 0 && items[i].keyAckId === 0) {
                        items[i].btnClass = btnClassEnum.unAcknowledged;
                        items[i].showAck = true;
                    } else {
                        items[i].showAlreadyAck = true;
                        items[i].btnClass = btnClassEnum.acknowledged;
                    }
                }
                items[i].agentTextString = dashboardService.stripAgentText(items[i].agentTextString);
                if (items[i].agentTextString.indexOf("acknowledged") >= 0) {
                    items[i].showAck = false;
                    items[i].showAlreadyAck = false;
                    items[i].btnClass = "";
                }
                var atLocal = new Date(items[i].agentTimeLocal);
                var itemYear = atLocal.getFullYear();
                var currentYear = new Date().getFullYear();
                if (itemYear == currentYear) {
                    items[i].isCurrent = 'true';
                } else {
                    items[i].isCurrent = 'false';
                }
                ctrl.agentText.push(items[i]);
            }
            ctrl.enddate = items[items.length - 1].agentTimeEs;
            if (!$rootScope.mobile && !$rootScope.classicView && ctrl.windowTitle != "DashboardSM") $scope.adjustSize();
            ctrl.busy = false;
        }, function (error) {
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            ctrl.alerts.push({ msg: errormsg, type: "danger" });
            if (!$rootScope.mobile && !$rootScope.classicView && ctrl.windowTitle != "DashboardSM") $scope.adjustSize();
            ctrl.busy = false;
        });
    };

    //Top 50 data from the DB
    ctrl.getTopFifty = function () {
        ctrl.agentTextTopFifty = [];
        dashboardService.getAgentText(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone, null).then(function (result) {
            var items = result.data;
            if (items.length === 0) {
                noRecord = true;
                return;
            }

            for (var i = 0; i < items.length; i++) {
                items[i].class = dashboardService.getAgentClass(items[i].agentTextString);
                items[i].translatedText = ctrl.getTextTranslations(items[i].agentTextString);
                items[i].eventId = items[i].repId;
                items[i].showAck = false;
                items[i].showAlreadyAck = false;
                if (items[i].eventId !== "" && items[i].eventId !== 0) {
                    if (items[i].firstAckId === 0 && items[i].keyAckId === 0) {
                        items[i].btnClass = btnClassEnum.unAcknowledged;
                        items[i].showAck = true;
                    } else {
                        items[i].showAlreadyAck = true;
                        items[i].btnClass = btnClassEnum.acknowledged;
                    }
                }
                items[i].agentTextString = dashboardService.stripAgentText(items[i].agentTextString);
                if (items[i].agentTextString.indexOf("acknowledged") >= 0) {
                    items[i].showAck = false;
                    items[i].showAlreadyAck = false;
                    items[i].btnClass = "";
                }
                ctrl.agentTextTopFifty.push(items[i]);
            }
        }, function (error) {
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            ctrl.alerts.push({ msg: errormsg, type: "danger" });
        }).then(function () {
            for (var i = 0; i < ctrl.agentTextTopFifty.length; i++) {
                for (var j = 0; j < ctrl.agentText.length; j++) {
                    if (ctrl.agentTextTopFifty[i].agentTimeLocal == ctrl.agentText[j].agentTimeLocal && ctrl.agentTextTopFifty[i].agentTextString == ctrl.agentText[j].agentTextString && ctrl.agentTextTopFifty[i].eventId == ctrl.agentText[j].eventId) {
                        ctrl.agentText[j] = ctrl.agentTextTopFifty[i];
                        break;
                    }
                }
            }
        });
    };

    ctrl.webAckAlarm = function (eventId, index) {
        dashboardService.webAckAlarm(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, ctrl.accountInfo.userName, eventId).then(function (result) {
            $rootScope.$broadcast('web_ack_alarm', eventId, ctrl.accountInfo.userName, result);
            toaster.pop('success', $scope.windowTitle, ctrl.translation.message.ACK_ALARM_SUCCESS);
        }, function (error) {
            ctrl.agentText[index].btnClass = btnClassEnum.error;
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            toaster.pop('error', $scope.windowTitle, errormsg);
        });
    };

    ctrl.webAckAlarmByRTU = function (deviceId, unacknowledgedAlarm, deviceName) {
        dashboardService.webAckAlarmByDevice(ctrl.accountInfo.customerId, deviceId, unacknowledgedAlarm, deviceName).then(function (result) {
            toaster.pop('success', $scope.windowTitle, ctrl.translation.message.ACK_ALARM_SUCCESS);
            ctrl.deviceList = result.data;
        }, function (error) {
            ctrl.agentText[index].btnClass = btnClassEnum.error;
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            toaster.pop('error', $scope.windowTitle, errormsg);
        });
    };

    ctrl.webAckAlarmByCustomerId = function () {
        dashboardService.webAckAlarmByCustomerId(ctrl.accountInfo.customerId).then(function (result) {
            $timeout(function () {
                ctrl.getData();
                toaster.pop('success', $scope.windowTitle, ctrl.translation.message.ACK_ALARM_SUCCESS);
                ctrl.deviceList = result.data;
                $(".dashboard-template-html .dashboard-alarms").click();
            }, 300);
        }, function (error) {
            ctrl.agentText[index].btnClass = btnClassEnum.error;
            var errormsg = eval("ctrl.translation.message." + error.data.message);
            toaster.pop('error', $scope.windowTitle, errormsg);
        });
    };

    //Mark this alarm as acknowledged
    var markAlarmAsAcknowledged = function markAlarmAsAcknowledged(agentData) {
        var agentText = agentData.agentTextString;

        if (agentText.indexOf('acknowledged the') >= 0 && agentData.eventId == 0) {
            ctrl.getTopFifty();
            return;
        }

        if (agentText.indexOf('acknowledged the') === -1 || agentData.eventId == 0) return;

        for (var i = 0; i < ctrl.agentText.length; i++) {
            if (ctrl.agentText[i].agentTextString.indexOf('acknowledged the') === -1) {
                if (ctrl.agentText[i].eventId == agentData.eventId) {
                    if (ctrl.agentText[i].btnClass !== btnClassEnum.acknowledged) {
                        ctrl.agentText[i].btnClass = btnClassEnum.acknowledged;
                        ctrl.agentText[i].showAck = false;
                        ctrl.agentText[i].showAlreadyAck = true;
                    }
                }
            }
        }
    };

    //Handler when socket data received
    var wsInfoDataReceived = function wsInfoDataReceived(data) {
        var agentTimeLocal = datetimeService.socketStrToServerStrTime(data.Time);
        var agentText = dashboardService.stripAgentText(data.Value);
        var agentClass = dashboardService.getAgentClass(data.Value);
        var translatedValue = ctrl.getTextTranslations(data.Value);
        var agentEventId = data.RepID;
        var aShowAck = parseFloat(agentEventId) > 0;
        var aBtnClass = btnClassEnum.unAcknowledged;
        if (agentText.indexOf("acknowledged") >= 0 || data.RepID == 0) {
            aShowAck = false;
            aBtnClass = "";
        }
        var agentData = {
            agentTimeLocal: agentTimeLocal,
            agentTextString: agentText,
            class: agentClass,
            translatedText: translatedValue,
            eventId: agentEventId,
            showAck: aShowAck,
            btnClass: aBtnClass
        };
        ctrl.agentText.unshift(agentData);
        if ($rootScope.mobile && ctrl.audioEnabled) ctrl.speak(agentText);
        markAlarmAsAcknowledged(agentData);
    };

    //Handle socket reconnect
    var wsReloadInfoData = function wsReloadInfoData() {
        stopListening();
        ctrl.enddate = null;
        ctrl.agentText = [];
        ctrl.loadMore();
        startListening();
        toaster.pop('success', $scope.windowTitle, ctrl.translation.text.VIEW_RELOADING);
    };

    var blink = function blink($o) {
        $o.addClass('blink_me');
        $timeout(function () {
            $o.removeClass('blink_me');
        }, 5000);
    };

    var wsNewLiveStatusMsgReceived = function wsNewLiveStatusMsgReceived(data) {
        if (ctrl.ServiceMode != data.ServiceMode) {
            ctrl.ServiceMode = data.ServiceMode;
            blink($('#Service'));
        }
        if (ctrl.isOffline != data.IsOffline) {
            ctrl.isOffline = data.IsOffline;
            blink($('#Offline'));
        }
        if (ctrl.isDisabled != data.IsDisabled) {
            ctrl.isDisabled = data.IsDisabled;
            blink($('#Disabled'));
        }
        if (ctrl.hasAlarm != data.HasAlarm) {
            ctrl.hasAlarm = data.HasAlarm;
            blink($('#Alarm'));
        }
        if (ctrl.Connection != data.Connection) {
            ctrl.Connection = parseInt(data.Connection);
            blink($('#Connection'));
        }
        if (ctrl.isDormant != data.IsDormant) {
            ctrl.isDormant = data.IsDormant;
            ctrl.setIfDormantLabel();
            blink($('#Connection'));
        }
    };

    //Register and start listening to the socket data
    var startListening = function startListening() {
        websocketService.connect();
        if (ctrl.windowTitle != "DashboardSM") websocketService.register("INFO", "", "", wsInfoDataReceived, wsReloadInfoData);
        websocketService.register("NEWLIVESTATUSMSG", "", "", wsNewLiveStatusMsgReceived, ctrl.windowTitle != "DashboardSM" ? null : wsReloadInfoData);
        websocketService.startLiveStatus();
    };

    //Disconnect and release the socket
    var stopListening = function stopListening() {
        if (ctrl.windowTitle != "DashboardSM") websocketService.unRegister("INFO", "", "", wsInfoDataReceived, wsReloadInfoData);
        websocketService.unRegister("NEWLIVESTATUSMSG", "", "", wsNewLiveStatusMsgReceived, ctrl.windowTitle != "DashboardSM" ? null : wsReloadInfoData);
        websocketService.stopLiveStatus();
    };

    $scope.$on('web_ack_alarm', function (e, eventId, username, cycleEnd) {
        for (var i = 0; i < ctrl.agentText.length; i++) {
            if (ctrl.agentText[i].agentTextString.indexOf('acknowledged the') === -1) {
                if (ctrl.agentText[i].eventId == eventId) {
                    if (ctrl.agentText[i].btnClass !== btnClassEnum.acknowledged) {
                        ctrl.agentText[i].btnClass = btnClassEnum.acknowledged;
                        ctrl.agentText[i].showAck = false;
                        ctrl.agentText[i].showAlreadyAck = true;
                    }
                }
            }
        }
    });

    //Handle user scroll event
    element.on('scroll', function (event) {
        if (element[0].scrollTop + element[0].offsetHeight + 20 > element[0].scrollHeight) !ctrl.loadingInProgress ? ctrl.loadMore() : null;
    });

    //close all webSocket listeners when the window is closed
    $scope.$on("$destroy", function () {
        stopListening();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        for (var i = 0; i < ctrl.agentText.length; i++) {
            ctrl.agentText[i].translatedText = ctrl.getTextTranslations(ctrl.agentText[i].agentTextString);
        }
    });

    $scope.$on("StopLiveStatus", function (event, args) {
        if ($scope.$$destroyed) {
            // The scope is already destroyed, skip further processing.
            return;
        } else if (args.stop) {
            websocketService.connect();
            websocketService.startLiveStatus();
        }
    });
};

DashboardController.$inject = ['_', "$scope", "$rootScope", "authenticationService", "dashboardService", "websocketService", "toaster", "translationService", "sharedSetupService", "openViewService", "textToSpeechService", "deviceNotificationSettingService", "$timeout", "$element", "datetimeService"];
'use strict';

mcapp.component('dashboardComponent', {
    controller: DashboardController,
    templateUrl: ['$element', '$attrs', function ($element, $attrs) {
        var _template = angular.isUndefined($attrs.templateUrl) ? "dashboard-template.html" : $attrs.templateUrl;
        return "ui/dashboard/" + _template;
    }],
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        templateUrl: '<'
    }
});
mcapp.controller("manageDesktopsController", ["$scope", "$rootScope", "$http", "authenticationService", "translationService", "sharedSetupService", "openViewService", "desktopViewService", "modalService", "toaster", "desktopViewListService", "$element", "$window", "LoginsFactory",
function ($scope, $rootScope, $http, authenticationService, translationService, sharedSetupService, openViewService, desktopViewService, modalService, toaster, desktopViewListService, $element, $window, LoginsFactory) {
    sharedSetupService.getWindowId($scope);
    $scope.translation = translationService.translation;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.isAdmin = $scope.accountInfo.userRole == "SuperAdministrator" || $scope.accountInfo.userRole == "Administrator" ? true : false;
    $scope.selectedDesktopId = null;
    $scope.desktopViewBusy = true;
    $scope.alerts = []; $scope.popup = _this.getExistingDialog($scope.windowId).ref;
    $scope.editModeId = 0;
    $scope.checkBoxBeforeChange = null;
    $scope.newViewTxt = '';    
    //$scope.fieldNameToSearch = 'desktopName';
    $scope.openDesktopViewInProgress = false;
    $scope.desktopNameUpdate = false;

    $scope.getWindowDimensions = function () {
        var w = angular.element($window);
        return {
            'width': w.width(),
            'height': w.height()
        };
    };

    $scope.openDesktopView = function (varDesktopId) {
        if (varDesktopId == null || $scope.openDesktopViewInProgress)
            return;
        $rootScope.$broadcast('selectedDesktopId', varDesktopId);
        $scope.openDesktopViewInProgress = true;
        desktopViewService.closeAllViews();
        $rootScope.arrPopup = [];
        $rootScope.desktopName = "<i class='fa fa-spinner fa-spin'></i> " + $scope.translation.text.LOADING_DATA + "...";
        setTimeout(function () {
            desktopViewService.openViewDetail(varDesktopId, $scope.getDesktopName(varDesktopId), $scope.accountInfo.customerId);
        }, 500);
    };

    var _htmlDecode = function (str) {
        var div = document.createElement("div");
        div.innerHTML = str;
        return div.textContent || div.innerText;
    }

    $scope.saveDesktopView = function (varDesktopId) {
        $scope.desktopNameUpdate = varDesktopId ? true : false;
        $scope.editModeId = 0;
        if (!varDesktopId) {
            _newDesktopName = _htmlDecode($scope.newViewTxt);

            if ($scope.checkIfNameExist(_newDesktopName)) {
                var varObj = $(event.currentTarget).parent().closest('.add_new_desktop').find(":text");
                varObj.val("Desktop name already exists ...");
                varObj.addClass("bg-danger");
                $scope.errorAnimation($(event.currentTarget).parent().closest('li').find(":text"), function () {
                    varObj.removeClass("bg-danger");
                    varObj.val(_newDesktopName);
                });
                return false;
            }
        }
        var tmpPosition = { my: "left+100 top+10", at: "left top", of: window };
        var _desktop = {
            "desktopName": !varDesktopId ? _htmlDecode($scope.newViewTxt) + "" : $rootScope.desktopName,
            "customerId": $scope.accountInfo.customerId,
            "userName": $scope.accountInfo.userName,
            "desktopId": varDesktopId,
            "desktopSize": JSON.stringify($scope.getWindowDimensions()),
            "documentation": $scope.getHelpWindow()
        };
        var _views = [];
                for (var i = 0; i < $rootScope.arrPopup.length; i++) {
                    if ($rootScope.arrPopup[i].desktopName == "Manage Desktops")
                        continue;
                    var tmpAdjustmentSize = 0;
                    if ($rootScope.arrPopup[i].desktopName == "Analog Widget")
                        tmpAdjustmentSize = 0;
                    if ($rootScope.arrPopup[i].desktopName == "Voltage Widget")
                        tmpAdjustmentSize = 0;

                    if (!angular.isUndefined($rootScope.arrPopup[i].desktopValue.setting) && $rootScope.arrPopup[i].desktopValue.setting != null)
                        $rootScope.arrPopup[i].desktopValue.setting.savedDesktop = true;

                        var _popup = _this.getExistingDialog($rootScope.arrPopup[i].desktopIndex).ref;
                        var _popupPosition = _popup.dialog("option", "position");
                        var _popupWidth = parseInt(_popup.dialog("option", "width"), 10);
                        var _popupHeight = parseInt(_popup.dialog("option", "height") + tmpAdjustmentSize, 10);
                        var tmpView = {
                            "viewId": i+1,
                            "viewName": $rootScope.arrPopup[i].desktopName,
                            "deviceId": ($rootScope.arrPopup[i].desktopName.indexOf("Widget") > -1 ? $rootScope.arrPopup[i].desktopValue.device.deviceId : $rootScope.arrPopup[i].desktopValue.deviceId),
                            "width": _popupWidth,
                            "height": _popupHeight,
                            "positionMy": typeof _popupPosition.my == 'undefined' ? tmpPosition.my : _popupPosition.my,
                            "positionAt": typeof _popupPosition.my == 'undefined' ? tmpPosition.at : _popupPosition.at,
                            "positionOf": "window",
                            "dateMinimum": (typeof $rootScope.arrPopup[i].desktopValue.dateMin == 'undefined' || $rootScope.arrPopup[i].desktopValue.dateMin == null ? new Date().getTime() : $rootScope.arrPopup[i].desktopValue.dateMin.toFixed(0)),
                            "dateMaximum": (typeof $rootScope.arrPopup[i].desktopValue.dateMax == 'undefined' || $rootScope.arrPopup[i].desktopValue.dateMax == null ? new Date().getTime() : $rootScope.arrPopup[i].desktopValue.dateMax.toFixed(0)),
                            "zoomMinimum": (typeof $rootScope.arrPopup[i].desktopValue.zoomMin == 'undefined' || $rootScope.arrPopup[i].desktopValue.zoomMin == null ? new Date().getTime() : $rootScope.arrPopup[i].desktopValue.zoomMin.toFixed(0)),
                            "zoomMaximum": (typeof $rootScope.arrPopup[i].desktopValue.zoomMax == 'undefined' || $rootScope.arrPopup[i].desktopValue.zoomMax == null ? new Date().getTime() : $rootScope.arrPopup[i].desktopValue.zoomMax.toFixed(0)),
                            "widget": ($rootScope.arrPopup[i].desktopName.indexOf("Widget") > -1),
                            "serialNumber": (($rootScope.arrPopup[i].desktopName.indexOf("Widget") > -1) || $rootScope.arrPopup[i].desktopName === 'Tank And Well Chart' || $rootScope.arrPopup[i].desktopName === 'Pulse Flow Calendar' ? $rootScope.arrPopup[i].desktopValue.device.serialNumber : 0),
                            "channel": (typeof $rootScope.arrPopup[i].desktopValue.device == 'undefined' || $rootScope.arrPopup[i].desktopValue.device == null ? 0 : $rootScope.arrPopup[i].desktopValue.device.channel),
                            "liveData": $rootScope.arrPopup[i].desktopValue.liveData,
                            "zIndex": isNaN(parseInt(_popup.parent().css("z-index"))) ? 0 : parseInt(_popup.parent().css("z-index")),
                            "expanded": $rootScope.arrPopup[i].desktopValue.view && $rootScope.arrPopup[i].desktopValue.view.expanded ? $rootScope.arrPopup[i].desktopValue.view.expanded : 0,
                            "setting": $rootScope.arrPopup[i].desktopValue.setting ? JSON.stringify($rootScope.arrPopup[i].desktopValue.setting) : ""
                        };

                    _views.push(tmpView);
                }

                var testData = {
                    "desktop": _desktop,
                    "views": _views
                };

        if (!varDesktopId) {
            desktopViewListService.postData($scope.accountInfo.customerId, testData)
                .then(function(result) {
                    $scope.desktopViews = result.data.desktopViews;
                    $scope.newViewTxt = "";
                    if (result.data.desktopViews.length > 1) {
                        $element.find('.desktop_view_div').animate({
                            scrollTop: ($element.find('.desktop_view_div li').length + 2) * 32
                        });
                    }
                    $rootScope.desktopViewCheck++;
                },function(error) {
                    alert("Error");
                });
        } else {
            desktopViewListService.updateData($scope.accountInfo.customerId, testData)
                .then(function (result) {
                    $scope.desktopViews = result.data.desktopViews;
                    $scope.newViewTxt = "";
                    $scope.desktopNameUpdate = false;
                },function (error) {
                    $scope.desktopNameUpdate = false;
                    alert("Error");

                });
        }

    };

    $scope.dynamicPopover = {        
        templateUrl: 'accessControlPopoverTemplate.html'        
    };

    $scope.getHelpWindow = function() {
        var helpDocTitle = "";
        if($('#documentation-title').length == 1){
            helpDocTitle = $('#documentation-title[data-documentation]')[0].attributes[2].value;
            helpDocTitle = helpDocTitle.replace(/_/g, ' ');
        }
        return helpDocTitle;
    };

    $scope.checkTheBox = function() {
        var i;
        for (i = 0; i < $scope.desktopViews.length; i++) {

                if ($scope.desktopViews[i].desktopId == $scope.editModeId) {
                    $scope.checkBoxBeforeChange = $scope.checkBoxBeforeChange == null ? $scope.desktopViews[i].displayIcon: $scope.checkBoxBeforeChange;
                    $scope.desktopViews[i].displayIcon = $scope.desktopViews[i].displayIcon == 0 ? 1 : 0;
                }
        }
    };

    $scope.checkTheBoxBack = function(varDesktopId) {
        var i;
        for(i = 0; i < $scope.desktopViews.length; i++) {
            if ($scope.desktopViews[i].desktopId == varDesktopId) {
                    $scope.desktopViews[i].displayIcon = $scope.checkBoxBeforeChange;
                }
        }
        $scope.checkBoxBeforeChange = null;
    };

    $scope.checkIfNameExist = function(varDesktopName) {
        var i;
        for(i = 0; i < $scope.desktopViews.length; i++) {
            if ($scope.desktopViews[i].desktopName == varDesktopName) {
                return $scope.editModeId == 0 || $scope.editModeId != $scope.desktopViews[i].desktopId;
                }
        }
        return false;
    };

    $scope.getDesktopName = function(varDesktopId) {
        var i;
        for(i = 0; i < $scope.desktopViews.length; i++) {
            if ($scope.desktopViews[i].desktopId == varDesktopId) {
                return $scope.desktopViews[i].desktopName;
                }
        }
    };

    $scope.errorAnimation = function (varObj, callbackFunction) {
        setTimeout(function () {
            callbackFunction();
        }, 1000);

    };

    $scope.listReadOnlyUsers = function () {
        var _loginsFactory = new LoginsFactory($scope.accountInfo.customerId);
        _loginsFactory.getLogins().then(function () {            
            $scope.logins = _loginsFactory.data.loginsInfo;
            $scope.readOnlyUsers = [];
            $scope.logins.forEach(function (element) {
                element.hasAccess = false;
                element.disableCheckbox = false;
                if (element.accessLevel == 127 || element.accessLevel == 200) {
                    $scope.readOnlyUsers.push(element);                    
                }
            });            
        });
    }

    $scope.listDesktopViewUserAccessByDesktopId = function (desktopId) {
        //Get current selected desktop
        $scope.desktopViews.forEach(function (element) {
            if (element.desktopId == desktopId) {
                $scope.currentDesktop = element;                
            }
        });
        $scope.currentDesktopId = desktopId;
        //Mark read only user and disable checkbox if current selected desktop is created by that user
        $scope.readOnlyUsers.forEach(function (element) {
            element.hasAccess = false;
            element.disableCheckbox = false;
            if ($scope.currentDesktop.createdByLoginId == element.userId) {
                element.hasAccess = true;
                element.disableCheckbox = true;
            }
        })

        desktopViewListService.listDesktopViewUserAccessByDesktopId($scope.accountInfo.customerId, desktopId)
            .then(function (result) {
                $scope.desktopViewUserAccess = result.data;  
                if ($scope.desktopViewUserAccess.length > 0) {
                    $scope.desktopViewUserAccess.forEach(function (element) {
                        for (var i = 0; i < $scope.readOnlyUsers.length; i++) {
                            if ($scope.readOnlyUsers[i].userId == element.loginId) {
                                $scope.readOnlyUsers[i].hasAccess = true;
                            }
                        }
                    });
                }
            }, function (error) {
               
            });
    }

    $scope.grantOrRemoveAccess = function (readOnlyUser) {        
        if (readOnlyUser.hasAccess) {            
            desktopViewListService.grantAccess($scope.accountInfo.customerId, $scope.currentDesktopId, readOnlyUser.userId, $scope.accountInfo.userId, encodeURIComponent($scope.currentDesktop.desktopName), encodeURIComponent(readOnlyUser.fullName))
                .then(function (result) {
                    if (result.data.length > 0) {
                        $scope.currentDesktop.accessGranted = true;
                    }
                }, function (error) {

                });
        }
        else {
            desktopViewListService.removeAccess($scope.accountInfo.customerId, $scope.currentDesktopId, readOnlyUser.userId, $scope.accountInfo.userId, encodeURIComponent($scope.currentDesktop.desktopName), encodeURIComponent(readOnlyUser.fullName))
                .then(function (result) {
                    if (!result.data.length > 0) {
                        $scope.currentDesktop.accessGranted = false;
                    }
                }, function (error) {

                });
        }
    }
    
    $scope.popup.dialog({
        resize: function (event, ui) {
            $scope.adjustSize();
        }
    });

    $scope.popup.dialogExtend({
        maximize: function (event, ui) {
            openViewService.adjustContentSizeStart($scope.popup);
            $scope.adjustSize();
        },
        restore: function (event, ui) {
			openViewService.adjustContentSizeStart($scope.popup);
            $scope.adjustSize();
        }
    });

    $scope.adjustSize = function () {
        $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
        $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        $scope.popup.parent().find('.desktop_view_div').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.add_new_desktop').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 20); //25: total padding
    };

    $scope.listReadOnlyUsers();
}]);

mcapp.directive('desktopViewOpenDropdown', ['$rootScope', 'desktopViewListService', 'modalService', 'toaster', 'wizardSplashService', function ($rootScope, desktopViewListService, modalService, toaster, wizardSplashService) {
    return {
        // A = attribute, E = Element, C = Class and M = HTML Comment
        restrict: 'A',
        //The link function is responsible for registering DOM listeners as well as updating the DOM.
        link: function (scope, element, attrs) {
            desktopViewListService.getData(scope.accountInfo.customerId)
            .then(function (result) {
                scope.desktopViews = result.data.desktopViews;                
                scope.selectedDesktopId = result.data.desktopViews.length > 0 ? scope.desktopViews[0].desktopId : scope.selectedDesktopId;
                scope.desktopViewBusy = false;
            },function (error) {
                scope.desktopViewBusy = false;
                var errormsg = eval("scope.translation.message." + error.data.message);
                scope.alerts.push({ msg: errormsg, type: "danger" });
                toaster.pop('error', scope.windowTitle, errormsg);
            });

            element.on(
                       "click.desktopViewOpenDropdown",
                       "span",
                       function (event) {
                           event.preventDefault();
                           var localScope = $(event.target).scope();
                           if (typeof localScope == 'undefined')
                               return true;
                           localScope.$apply(
                               function () {
                                   var varActionName = $(event.currentTarget).attr("action-name");
                                   switch (varActionName) {
                                       case "Remove":
                                           if(scope.editModeId != 0 && scope.checkBoxBeforeChange != null)
                                                scope.checkTheBoxBack(scope.editModeId);
                                           scope.selectedDesktopId = $(event.currentTarget).parent().closest('li').attr("desktop-id");

                                           event.stopPropagation();
                                           event.preventDefault();
                                           modalService.confirmDelete().then(function () {
                                             for (var j = 0; j < scope.desktopViews.length; j++) {
                                               if (scope.desktopViews[j].desktopId == scope.selectedDesktopId) {
                                                 scope.desktopViews.splice(j, 1);
                                                 break;
                                               }
                                             }

                                             desktopViewListService.deleteData(scope.accountInfo.customerId, scope.selectedDesktopId)
                                             .then(function (result) {
                                               scope.selectedDesktopId = null;
                                               scope.desktopViews = result.data.desktopViews;
                                               $rootScope.desktopViewCheck++;
                                               return true;
                                             },function (error) {
                                               scope.selectedDesktopId = null;
                                               return false;
                                             });
                                           }, function () {
                                             return false;
                                           });
                                           //if (confirm("Remove Desktop View?") == true) {
                                           //    event.stopPropagation();
                                           //    event.preventDefault();
                                           //    for (var j = 0; j < scope.desktopViews.length; j++) {
                                           //        if (scope.desktopViews[j].desktopId == scope.selectedDesktopId) {
                                           //            scope.desktopViews.splice(j, 1);
                                           //            break;
                                           //        }
                                           //    }

                                           //    desktopViewListService.deleteData(scope.accountInfo.customerId, scope.selectedDesktopId)
                                           //    .then(function (result) {
                                           //        scope.selectedDesktopId = null;
                                           //        scope.desktopViews = result.data.desktopViews;
                                           //        $rootScope.desktopViewCheck++;
                                           //        return true;
                                           //    })
                                           //    .error(function (error) {
                                           //        scope.selectedDesktopId = null;
                                           //        return false;
                                           //    });

                                           //} else {
                                           //    event.stopPropagation();
                                           //    event.preventDefault();
                                           //    return false;
                                           //}
                                           break;
                                       case "AccessControl":
                                           if (scope.editModeId != 0 && scope.checkBoxBeforeChange != null)
                                               scope.checkTheBoxBack(scope.editModeId);                                           
                                           scope.selectedDesktopId = $(event.currentTarget).parent().closest('li').attr("desktop-id");                                           
                                           scope.listDesktopViewUserAccessByDesktopId(scope.selectedDesktopId);
                                           //Close other popovers when button clicked
                                           scope.desktopViews.forEach(function (element) {
                                                element.isOpen = false;
                                           })
                                           event.stopPropagation();
                                           event.preventDefault();                                           
                                           break;
                                       case "Edit":
                                           if(scope.editModeId != 0 && scope.checkBoxBeforeChange != null)
                                                scope.checkTheBoxBack(scope.editModeId);
                                           scope.selectedDesktopId = $(event.currentTarget).parent().closest('li').attr("desktop-id");
                                           scope.editModeId = scope.selectedDesktopId;
                                           break;
                                       case "Update":
                                           event.stopPropagation();
                                           event.preventDefault();
                                           if (scope.editModeId != 0 && scope.checkBoxBeforeChange != null)
                                               scope.checkTheBoxBack(scope.editModeId);
                                           scope.selectedDesktopId = $(event.currentTarget).parent().closest('li').attr("desktop-id");
                                           scope.saveDesktopView(scope.selectedDesktopId);
                                           break;
                                       case "Undo":
                                           if(scope.editModeId != 0 && scope.checkBoxBeforeChange != null)
                                                scope.checkTheBoxBack(scope.editModeId);
                                           scope.editModeId = 0;
                                           break;
                                       case "DisplayIcon":
                                           if(scope.editModeId != 0 && scope.checkBoxBeforeChange != null)
                                                scope.checkTheBoxBack(scope.editModeId);
                                           scope.selectedDesktopId = $(event.currentTarget).parent().closest('li').attr("desktop-id");
                                           scope.editModeId = scope.selectedDesktopId;
                                           scope.checkTheBox();
                                           break;
                                       case "Save":
                                           _newDesktopName = $(event.currentTarget).parent().closest('li').find(":text").val();
                                           if (_newDesktopName.replace(/ /g, '') == "") {
                                               $(event.currentTarget).parent().closest('li').find(":text").val(_newDesktopName.replace(/ /g, ''));
                                               return false;
                                           }
                                           if (scope.checkIfNameExist(_newDesktopName)) {
                                               var varObj = $(event.currentTarget).parent().closest('li').find(":text");
                                               varObj.val("Desktop name already exists ...");
                                               varObj.addClass("bg-danger");
                                               scope.errorAnimation($(event.currentTarget).parent().closest('li').find(":text"), function () {
                                                   varObj.removeClass("bg-danger");
                                                   varObj.val(_newDesktopName);
                                               });
                                              return false;
                                           }
                                           scope.editModeId = 0;
                                           scope.checkBoxBeforeChange = null;
                                           scope.selectedDesktopId = $(event.currentTarget).parent().closest('li').attr("desktop-id");
                                           _newDisplayIcon = $(event.currentTarget).parent().closest('li').attr("display-icon");
                                           var _desktopView = { "desktopId": scope.selectedDesktopId, "desktopName": _newDesktopName, "displayIcon": _newDisplayIcon };
                                           var tmpDesktopView = { desktopViews: [_desktopView]};
                                           desktopViewListService.putData(scope.accountInfo.customerId, scope.selectedDesktopId, tmpDesktopView)
                                               .then(function (result) {
                                                   scope.selectedDesktopId = null;
                                                   scope.desktopViews = result.data.desktopViews;
                                                   $rootScope.desktopViewCheck++;
                                                   return true;
                                               },function (error) {
                                                   scope.selectedDesktopId = null;
                                                   return false;
                                               });
                                           break;
                                       default:
                                           return;
                                   }
                               }
                           );
                       }
                   );

            element.on(
                       "click.desktopViewOpenDropdown",
                       "li",
                       function (event) {
                           event.preventDefault();
                           var localScope = $(event.target).scope();
                           if (typeof localScope == 'undefined')
                               return true;
                           localScope.$apply(
                               function () {
                                   var varSelector = $(event.currentTarget).is("li") ? "li" : "???";
                                   switch (varSelector) {
                                       case "li":
                                           scope.selectedDesktopId = $(event.currentTarget).attr("desktop-id");
                                           if (scope.editModeId == scope.selectedDesktopId)
                                               return;
                                           scope.openDesktopView(scope.selectedDesktopId);
                                           break;
                                       default:
                                           return;
                                   }
                               }
                           );
                       }
                   );

            scope.$on(
                       "$destroy",
                       function (event) {
                           element.off("click.desktopViewOpenDropdown");
                           element.off("click.desktopViewOpenDropdown");

                           //save wizard step status if wizard splash lauched this view.
                           if ($rootScope.launchedByWizard) {
                               wizardSplashService.SaveWizardStepStatus(scope.accountInfo.customerId, scope.accountInfo.userId, $rootScope.wizardId, scope.windowId, 2); //save status as completed (2: status complete)
                               $rootScope.$broadcast('wizardSplashStepClosed');
                           }
                       }
                   );
        }
    };
}]);

mcapp.factory('desktopViewListService', ['$http', 'HOST', function ($http, HOST) {
    var desktopViewListFactory = {};

    var _getData = function (customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DesktopViewList?customerId=' + customerId + "&" + new Date().getTime(),
            cache: false
        });
    };

    var _deleteData = function (customerId, varDesktopId) {
        return $http.delete(HOST + '/api/DesktopViewList?customerId=' + customerId + "&desktopId=" + varDesktopId);
    };

    var _putData = function (customerId, varDesktopId, varDesktopView) {
        return $http.put(HOST + '/api/DesktopViewList?customerId=' + customerId + "&desktopId=" + varDesktopId, varDesktopView);
    };

    var _postData = function (customerId, varDesktopView) {
        return $http.post(HOST + '/api/DesktopView?customerId=' + customerId, varDesktopView);
    };

    var _updateData = function (customerId, varDesktopView) {
        return $http.put(HOST + '/api/DesktopView?customerId=' + customerId, varDesktopView);
    };

    var _getDesktopViewUserAccessByLoginId = function (customerId, loginId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DesktopViewUserAccess/ListDesktopViewUserAccessByLoginId?customerId=' + customerId + "&loginId=" + loginId,
            cache: false
        });
    };

    var _listDesktopViewUserAccessByDesktopId = function (customerId, varDesktopId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/DesktopViewUserAccess?customerId=' + customerId + "&desktopId=" + varDesktopId,
            cache: false
        });
    }

    var _grantAccess = function (customerId, desktopId, loginId, createdLoginId, desktopName, readOnlyUserName) {
        return $http.post(HOST + '/api/DesktopViewUserAccess?customerId=' + customerId + "&desktopId=" + desktopId + "&loginId=" + loginId + "&createdLoginId=" + createdLoginId + "&desktopName=" + desktopName + "&readOnlyUserName=" + readOnlyUserName);
    };

    var _removeAccess = function (customerId, desktopId, loginId, deletedLoginId, desktopName, readOnlyUserName) {
        return $http.delete(HOST + '/api/DesktopViewUserAccess?customerId=' + customerId + "&desktopId=" + desktopId + "&loginId=" + loginId + "&deletedLoginId=" + deletedLoginId + "&desktopName=" + desktopName + "&readOnlyUserName=" + readOnlyUserName);
    };

    desktopViewListFactory.deleteData = _deleteData;
    desktopViewListFactory.getData = _getData;
    desktopViewListFactory.putData = _putData;
    desktopViewListFactory.postData = _postData;
    desktopViewListFactory.updateData = _updateData;
    desktopViewListFactory.getDesktopViewUserAccessByLoginId = _getDesktopViewUserAccessByLoginId;
    desktopViewListFactory.listDesktopViewUserAccessByDesktopId = _listDesktopViewUserAccessByDesktopId;
    desktopViewListFactory.grantAccess = _grantAccess;
    desktopViewListFactory.removeAccess = _removeAccess;
    return desktopViewListFactory;
}]);

'use strict';

function IntroVideoController($timeout, $http, modalService, translationService) {
  var _this = this;

  this.$onInit = function () {
    _this.removed = false;
    _this.hovering = false;
    _this.isOpen = false;
    _this.translation = translationService.translation;

    translationService.loadLanguage(true).then(function () {
      _this.translation = translationService.translation;
    });

    //$http.get('https://api.vimeo.com/channels/1253760/videos', { headers: { 'Authorization': 'Bearer de80698101d0919a68ba258bebee8099', 'Accept': 'application/vnd.vimeo.*+json;version=3.2' } }).then((resp) => {
    //  this.videos = resp.data.data;
    //});
  };

  this.toggle = function () {
    _this.isOpen = !_this.isOpen;
    //if (this.isOpen === true) {
    //  $http.get('https://api.vimeo.com/channels/1253760/videos', { headers: { 'Authorization': 'Bearer de80698101d0919a68ba258bebee8099', 'Accept': 'application/vnd.vimeo.*+json;version=3.2' } }).then((resp) => {
    //    this.videos = resp.data.data;
    //  });
    //}
  };

  this.openVideo = function (link) {
    var id = link.substring(link.lastIndexOf('/') + 1);
    modalService.displayVideo(id);
  };
}

IntroVideoController.$inject = ['$timeout', '$http', 'modalService', 'translationService'];

angular.module('mcapp').component('introVideoButton', {
  controller: IntroVideoController,
  transclude: true,
  templateUrl: 'ui/desktop/intro-video-partial.html',
  bindings: {
    windowId: '<',
    mobile: '<',
    classicView: '<'
  }
});
mcapp.factory('desktopViewService', ['$http', 'HOST', 'openViewService', '$rootScope', '$timeout', 'sharedSetupService', '$window', function ($http, HOST, openViewService, $rootScope, $timeout, sharedSetupService, $window) {
    var desktopViewFatory = {};

    var getAdjustedPosition = function (savedPosition, scaleWidth, scaleHeight) {
        var position = savedPosition;
        var my = position.my.split(" ");
        var at = position.at.split(" ");

        var tmpMy;
        var tmpAt;

        var newMy = [];
        var newAt = [];


        if (my[0].indexOf("+") !== -1) {
            tmpMy = my[0].split("+");
            newMy[0] = tmpMy[0] + "+" + tmpMy[1] * scaleWidth;
        } else if (my[0].indexOf("-") !== -1) {
            tmpMy = my[0].split("-");
            newMy[0] = tmpMy[0] + "-" + tmpMy[1] * scaleWidth;
        } else {
            newMy[0] = my[0];
        }

        if (my[1].indexOf("+") !== -1) {
            tmpMy = my[1].split("+");
            newMy[1] = tmpMy[0] + "+" + tmpMy[1] * scaleHeight;
        } else if (my[1].indexOf("-") !== -1) {
            tmpMy = my[1].split("-");
            newMy[1] = tmpMy[0] + "-" + tmpMy[1] * scaleHeight;
        } else {
            newMy[1] = my[1];
        }

        if (at[0].indexOf("+") !== -1) {
            tmpAt = at[0].split("+");
            newAt[0] = tmpAt[0] + "+" + tmpAt[1] * scaleWidth;
        } else if (at[0].indexOf("-") !== -1) {
            tmpAt = at[0].split("-");
            newAt[0] = tmpAt[0] + "-" + tmpAt[1] * scaleWidth;
        } else {
            newAt[0] = at[0];
        }

        if (at[1].indexOf("+") !== -1) {
            tmpAt = at[1].split("+");
            newAt[1] = tmpAt[0] + "+" + tmpAt[1] * scaleHeight;
        } else if (at[1].indexOf("-") !== -1) {
            tmpAt = at[1].split("-");
            newAt[1] = tmpAt[0] + "-" + tmpAt[1] * scaleHeight;
        } else {
            newAt[1] = at[1];
        }

        return { my: newMy.join(' '), at: newAt.join(' '), of: position.of };
    };

    var _getData = function (customerId, desktopId) {
        
        return $http({
            method: 'Get',
            url: HOST + '/api/DesktopView?customerId=' + customerId + '&desktopId=' + desktopId,
            cache: false
        });
    };

    
    var _getLegacyToasterInfoData = function (customerId, loginId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/Account/GetLegacyPricingToasterInfo?customerId=' + customerId + '&loginId=' + loginId,
            cache: false
        });
    };

    
    var _correctViewName = function (varViewName, varChannel) {
        var viewName = varViewName;
        if (varViewName === 'Tank And Well List All') {
            viewName = 'Tank And Well Overview';
        } else if (varViewName === 'Tank And Well' && varChannel === 'tank') {
            viewName = 'Tank And Well Detail';
        } else if (varViewName === 'Tank And Well' && varChannel === 'chart') {
            viewName = 'Tank And Well Chart';
        }
        return viewName;
    };

    _openViewDetail = function (varDesktopId, varDesktopName, varCustomerId) {
         _getData(varCustomerId, varDesktopId)
            .then(function (result) {
                $rootScope.desktopName = varDesktopName;
                 var savedDesktopSize = JSON.parse(result.data.desktop.desktopSize);

                 var currentDesktopSize = sharedSetupService.getWindowSize();
                var scaleWidth = 1;
                var scaleHeight = 1;
                if (savedDesktopSize) {
                    scaleWidth = currentDesktopSize.width / savedDesktopSize.width;
                    scaleHeight = currentDesktopSize.height / savedDesktopSize.height;
                }

                scaleWidth = scaleWidth > 1 ? 1 : scaleWidth;
                scaleHeight = scaleHeight > 1 ? 1 : scaleHeight;
                 
                result.data.views.sort(function (a, b) {
                    return a.zIndex - b.zIndex;
                });

                //Check if Desktop has Documentation
                if(result.data.desktop.documentation){openViewService.openHelpPanel(result.data.desktop.documentation, null);}

                angular.forEach(result.data.views, function (dataView, idx) {
                    var _optionsStickyProperties = {};
                    var _mcDevice = { deviceId: dataView.deviceId, deviceName: null, channel: dataView.channel, serialNumber: dataView.serialNumber };
                    var _view = { type: null, expanded: dataView.expanded };
                    var _minimumWidth = sharedSetupService.getViewPropery(0, "minimumWidth");
                    switch (dataView.widget) {
                        case false:
                            _optionsStickyProperties = {
                                on: true,
                                savedDesktop: true,
                                deviceId: dataView.deviceId,
                                device: _mcDevice,
                                dateMin: dataView.liveData ? null : dataView.dateMinimum,
                                dateMax: dataView.liveData ? null : dataView.dateMaximum,
                                zoomMin: dataView.liveData ? null : dataView.zoomMinimum,
                                zoomMax: dataView.liveData ? null : dataView.zoomMaximum,
                                dataFormat: null,
                                view: _view,
                                adminPortal: { customerId: null, customerName: null },
                                setting: dataView.setting != "" ? JSON.parse(dataView.setting) : null
                            };
                            _minimumWidth = sharedSetupService.getViewPropery(1, "minimumWidth");
                            if (dataView.viewName == "Weather") {
                                var _viewMode = dataView.width > 400 ? "Lg" : "Sm";
                                openViewService.setWeatherViewMode(_viewMode);
                            }
                            break;
                        case true:
                            if (dataView.viewName == "Pulse Flow Widget") {
                                _optionsStickyProperties = {
                                    on: true,
                                    savedDesktop: true,
                                    device: _mcDevice,
                                    setting: dataView.setting != "" ? JSON.parse(dataView.setting) : null
                                };
                            }
                            else {
                                _optionsStickyProperties = {
                                    on: true,
                                    savedDesktop: true,
                                    device: _mcDevice
                                };
                            }                            
                            _minimumWidth = sharedSetupService.getViewPropery(0, "minimumWidth");
                            break;
                    }
                    $timeout(function () {

                      var savedPosition = { my: dataView.positionMy, at: dataView.positionAt, of: window };
                      dataView.viewName = _correctViewName(dataView.viewName, _optionsStickyProperties.device.channel);

                      var minSizes = openViewService.getMinWindowSizes(dataView.viewName);

                      var adjustWidth = scaleWidth;
                      var adjustHeight = scaleHeight;

                      //if needed
                      //if (dataView.widget) {
                      //    adjustWidth = 1;
                      //    adjustHeight = 1;
                      //}

                      var adjustPosition = (scaleWidth * scaleHeight < 1) ? getAdjustedPosition(savedPosition, scaleWidth, scaleHeight) : savedPosition;

                        openViewService.openWidget(dataView.viewName, { width: (minSizes && minSizes.minimumWidth > dataView.width * adjustWidth) ? minSizes.minimumWidth : dataView.width * adjustWidth, height: (minSizes && minSizes.minimumHeight > dataView.height * adjustHeight) ? minSizes.minimumHeight : dataView.height * adjustHeight }, adjustPosition, _optionsStickyProperties, minSizes);

                        if (idx === result.data.views.length -1) {
                            _toggleDesktopName(true);
                        }
                    }, ((idx) * 500));
                });
            },function (error) {
                alert("Error");
                $rootScope.desktopName = null;
            });
    };

    var _timeout = null;

    _toggleDesktopName = function (startTimer) {
        if ($rootScope.desktopName && !$rootScope.mobile && !$rootScope.classicView) {
            if (_timeout != null) $timeout.cancel(_timeout);
            $("#desktop_title").removeClass("desktop-title_overwrite");

            if (startTimer) {
                _timeout = $timeout(
                    function () {
                        $("#desktop_title").addClass("desktop-title_overwrite");
                    },
                    10000 // 10 seconds
                );
            }
        }
    };

    function closeHelpWindow(){
        if($('#documentation-title').length == 1){
            openViewService.closeHelpPanel();
        }
    }

    _closeAllViews = function () {
        for (var i = 0; i < $rootScope.arrPopup.length; i++) {
            var _popup = _this.getExistingDialog($rootScope.arrPopup[i].desktopIndex).ref;
            _popup.dialog("close");
        }
        closeHelpWindow();
        $rootScope.arrPopup = [];
        $rootScope.desktopName = null;
        return;
    };

    desktopViewFatory.getData = _getData;
    desktopViewFatory.openViewDetail = _openViewDetail;
    desktopViewFatory.correctViewName = _correctViewName;
    desktopViewFatory.closeAllViews = _closeAllViews;
    desktopViewFatory.toggleDesktopName = _toggleDesktopName;
    desktopViewFatory.getLegacyToasterInfoData = _getLegacyToasterInfoData;
    return desktopViewFatory;
}]);
mcapp.controller('desktopController', ['$rootScope', '$scope', '$timeout', 'modalService', 'dialogService', 'authenticationService', 'websocketService', 'translationService', 'tmhDynamicLocale', 'openViewService', '$location', '$window', 'desktopViewService', 'weatherShareService', 'timeLapseService', 'weatherSmService', 'weatherSevereService', 'toaster', 'ticketAlertService', 'datetimeService', 'TICKETURL', '$cookies', 'customerExtService', 'textToSpeechService', 'dashboardService', 'mcApplicationVersionAlertService', '$interval', 'systemAlertMessageService', 'sharedSetupService', 'registerWebinarService', 'desktopViewListService', 'LoginsFactory', 'RadioUpgradeFactory', 'ToasterMessageTimestampFactory', '$uibModal', 'toasterMasterService', '$http', 'HOST', 'importantInformationModalService', 'RWAID',
    function ($rootScope, $scope, $timeout, modalService, dialogService, authenticationService, websocketService, translationService, tmhDynamicLocale, openViewService, $location, $window, desktopViewService, weatherShareService, timeLapseService, weatherSmService, weatherSevereService, toaster, ticketAlertService, datetimeService, TICKETURL, $cookies, customerExtService, textToSpeechService, dashboardService, mcApplicationVersionAlertService, $interval, systemAlertMessageService, sharedSetupService, registerWebinarService, desktopViewListService, LoginsFactory, RadioUpgradeFactory, ToasterMessageTimestampFactory, $uibModal, toasterMasterService, $http, HOST, importantInformationModalService, RWAID) {
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
        var sessionCAW = $window.sessionStorage.getItem("msr");//Mission Security Reminder August, 2026//
        var localCAW = $window.localStorage.getItem("msr");
        if ($rootScope.mobile && sessionCAW == null && localCAW == null)
            $location.path("/welcometoscada/welcome-to-scada");
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
        var isNoU = sharedSetupService.isNullOrUndefined;
        $rootScope.login = false;
        $scope.desktopBusy = true;
        $scope.openDesktopBusy = false;
        $scope.weatherCodeInfoIconPath = "images/metarweathercodes/";
        $scope.accountInfo = authenticationService.getAccountInfo();
        $rootScope.colorSchemeId = typeof $scope.accountInfo.preferenceUser.colorSchemeId === 'undefined' ? 2 : $scope.accountInfo.preferenceUser.colorSchemeId
        $rootScope.fontSizeId = typeof $scope.accountInfo.preferenceUser.fontSizeId === 'undefined' ? 2 : $scope.accountInfo.preferenceUser.fontSizeId;
        $rootScope.logoSizeId = typeof $scope.accountInfo.logoSizeId === 'undefined' || $scope.accountInfo.logoSizeId === 0 ? 2 : $scope.accountInfo.logoSizeId;
        $rootScope.notificationMode = typeof $scope.accountInfo.notificationMode === 'undefined' ? 1 : $scope.accountInfo.notificationMode;
        $scope.isAdmin = $scope.accountInfo.userRole.indexOf("Administrator") > -1 ? true : false;
        $scope.isPublicUser = $scope.accountInfo.userRole.indexOf("PublicUser") > -1 ? true : false;
        $scope.audioEnabled = $scope.accountInfo.preferenceUser.audioEnabled == 1 ? true : false;
        $scope.displayWeatherNotification = $scope.accountInfo.preferenceUser.displayWeatherNotification == 1 ? true : false;
        $rootScope.backgroundLogo = $scope.accountInfo.logoName == "" ? $rootScope.defaultBackgroundLogo : $scope.accountInfo.logoName;
        tmhDynamicLocale.set($scope.accountInfo.preferenceUser.i18nCode);
        $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
        $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
        $scope.openView = openViewService.openView;
        $scope.openWidget = openViewService.openWidget;
        $scope.showLiveData = true;
        $scope.showWeather = true;
        if ($scope.accountInfo !== null) $rootScope.login = true;
        $scope.isMcAdmin = $cookies.get('AdminInfo') != null ? true : false;
        $scope.menuTemplate = "";
        $scope.firstNotification;
        $scope.secondNotification;
        $scope.onlyNotification;
        $scope.firstNotificationFrench;
        $scope.secondNotificationFrench;
        $scope.onlyNotificationFrench;
        $scope.hasTankAndWell = $scope.accountInfo.tankAndWell;        

        $scope.isMcAdmin = sharedSetupService.mcAdmin();
        $scope.isAdmin = sharedSetupService.isAdmin($scope.accountInfo);
        $scope.isAlarmUser = sharedSetupService.isAlarmUser($scope.accountInfo);

        $scope.mfaMigrationStatus = $scope.accountInfo.mfaMigrationStatus;

        $scope.rwaMode = $scope.accountInfo.customerId == RWAID ? true : false;

        var DAYSPASTDUETIMER = (86400 * 1000) / 2; //10 seconds: 10 * 1000; One day: 86400 * 1000; 12 Hours: (86400 * 1000)/2

        //Making certain main menu on mobi site is loading properly after introducing security/portal and 2FA!
        if ($rootScope.mobile && ($rootScope.CustomerNameStart == "" || $rootScope.CustomerNameStart == null))
            $rootScope.$broadcast('refreshMobiMenuItems');

        $scope.hasPumpStation = false;
        $scope.hasMyLevel = false;

        $scope.isCanadianCustomer = $scope.accountInfo.customerCountry == 'CA' ? true : false;

        $scope.translation = translationService.translation;
        $scope.initDesktopIcons = function () {
            $scope.desktopIcons = {
                dashboard: $scope.translation.text.DASHBOARD,
                rtuData: $scope.translation.text.RTU_DATA,
                rtuView: $scope.translation.text.RTU_VIEW,
                map: $scope.translation.text.MAP,
                customers: $scope.translation.text.CUSTOMERS,
                closeView: $scope.translation.text.CLOSE_VIEW,
                supergraph: $scope.translation.text.SUPERGRAPH,
                pumpStation: $scope.translation.text.PUMP_STATION,
                mmPlus: "MyLevel",
                overview: $scope.translation.text.OVERVIEW,
                reports: $scope.translation.text.REPORTS,
                tankAndWell: $scope.translation.text.TANK_AND_WELL,
                commands: $scope.translation.text.COMMANDS,
                legacy: $scope.translation.text.REDIRECT_LEGACY,
                runtimeData: "Runtime Data",
                rainDownload: "Download Rainfall",
                analog: $scope.translation.text.ALL_DEVICES_ANALOG,
                allDevices: $scope.translation.text.ALL_DEVICES,
                alarm: $scope.translation.text.ALARM,
                rtuSetting: $scope.translation.text.RTU_SETTING,
                stationNotes: $scope.translation.text.STATION_NOTES,
                documents: $scope.translation.text.DOCUMENTS,
                deviceManagement: "Device Management"
            };
        };

        // For live notifications 
        $rootScope.uniqueWebID = $scope.accountInfo.customerId + "_" + $scope.accountInfo.userId + "_" + Math.round(Math.random() * 1000);

        $scope.missionAlertLevel = 0;
        $scope.missionWeatherAlerts = [];
        $scope.missionTicketAlerts = [];
        $scope.missionUpdateAlerts = [];
        $scope.missionOfflineWeatherStationAlerts = [];
        $scope.missionNotifications = [];
        $scope.parameterWeatherId = 0;
        $scope.parameterStartDate = null;
        $scope.loadingDelay = 1000;
        $scope.adminUser = $cookies.get('AdminUser1') != null ? true : false;//old, will go away

        var _hideRecconectFalseClick;
        var _hideRecconectFalseOn;

        $scope.offlinePopoverTemplate = {
            templateUrl: 'offline-popover-template.html'
        };

        $scope.resetSiteConnection = function (force) {
            websocketService.resetSiteConnection(force);
            $scope.hideRecconect = true;

            _hideRecconectFalseClick = $timeout(function () {
                $scope.hideRecconect = false;
            }, 45000);
        };

        $rootScope.$on('onOnlineStatus', function (event, args) {
            if (args.online) {
                $scope.hideRecconect = true;
                if (!angular.isUndefined(_hideRecconectFalseOn)) $timeout.cancel(_hideRecconectFalseOn);
                if (!angular.isUndefined(_hideRecconectFalseClick)) $timeout.cancel(_hideRecconectFalseClick);
            } else {
                $scope.hideRecconect = true;
                _hideRecconectFalseOn = $timeout(function () {
                    $scope.hideRecconect = false;
                }, 45000);
            }
        });

        $scope.getIcon = function (varTitle, varMode) {
            return openViewService.getIcon(varTitle, varMode);
        };

        $scope.getIconImg = function (varTitle, varMode) {
            return openViewService.getIconImg(varTitle, varMode);
        };

        $scope.mobileMenuOption = function (varUrl) {
            if(varUrl !== '/saveddesktop/saved-desktop-view') {
                window.localStorage.removeItem("savedDesktop");
            }
            $location.path(varUrl);
        };

        $scope.printWidget = function (id) {
            var DocumentContainer = $('div[class*="' + id + '"]');
            var WindowObject = window.open('', 'PrintWindow', 'width=750,height=650,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes');
            var strHtml = "<!DOCTYPE HTML><html>\n<head>\n<style>.print-no, .ui-dialog-titlebar-buttonpane {display: none;} .tabular-data a:link {color: #666;font-weight: bold;text-decoration:none;}.tabular-data a:visited {color: #999999;font-weight:bold;text-decoration:none;}.tabular-data a:active,.tabular-data a:hover {color: #bd5a35;	text-decoration:underline;}.tabular-data {font-family:Arial, Helvetica, sans-serif;color:#666;font-size:12px;text-shadow: 1px 1px 0px #fff;background:#eaebec;margin:20px;border:#ccc 1px solid;-moz-border-radius:3px;	-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow: 0 1px 2px #d1d1d1;-webkit-box-shadow: 0 1px 2px #d1d1d1;box-shadow: 0 1px 2px #d1d1d1;}.tabular-data th {padding:15px 20px 17px 20px;border-top:1px solid #fafafa;border-bottom:1px solid #e0e0e0;background: #ededed;background: -webkit-gradient(linear, left top, left bottom, from(#ededed), to(#ebebeb));	background: -moz-linear-gradient(top,  #ededed,  #ebebeb);}.tabular-data th:first-child {text-align: left;padding-left:20px;}.tabular-data tr:first-child th:first-child {	-moz-border-radius-topleft:3px;	-webkit-border-top-left-radius:3px;border-top-left-radius:3px;}.tabular-data tr:first-child th:last-child {-moz-border-radius-topright:3px;-webkit-border-top-right-radius:3px;border-top-right-radius:3px;}.tabular-data tr {text-align: center;padding-left:20px;}.tabular-data td:first-child {text-align: left;padding-left:20px;border-left: 0;}.tabular-data td {padding:18px;border-top: 1px solid #ffffff;border-bottom:1px solid #e0e0e0;border-left: 1px solid #e0e0e0;	background: #fafafa;background: -webkit-gradient(linear, left top, left bottom, from(#fbfbfb), to(#fafafa));background: -moz-linear-gradient(top,  #fbfbfb,  #fafafa);}.tabular-data tr.even td {background: #f6f6f6;background: -webkit-gradient(linear, left top, left bottom, from(#f8f8f8), to(#f6f6f6));background: -moz-linear-gradient(top,  #f8f8f8,  #f6f6f6);}.tabular-data tr:last-child td {border-bottom:0;}.tabular-data tr:last-child td:first-child {-moz-border-radius-bottomleft:3px;-webkit-border-bottom-left-radius:3px;border-bottom-left-radius:3px;}.tabular-data tr:last-child td:last-child {-moz-border-radius-bottomright:3px;-webkit-border-bottom-right-radius:3px;	border-bottom-right-radius:3px;}.tabular-data tr:hover td {background: #f2f2f2;background: -webkit-gradient(linear, left top, left bottom, from(#f2f2f2), to(#f0f0f0));background: -moz-linear-gradient(top,  #f2f2f2,  #f0f0f0);}.tabular-data .thmain { background: #d6d3d3; color: #000000;font-size:larger;}.tabular-data .thmain a:link {color: #000000;	font-weight: bold;text-decoration:underline;}.tabular-data .thmain a:visited {color: #000000;	font-weight:bold;text-decoration:underline;}.tabular-data .thmain a:active,.tabular-data .thmain a:hover {color: #bd5a35;	text-decoration:none;}.tabular-data .tha a:link {color: #bd5a35;font-weight: bold;text-decoration:underline;}.tabular-data .tha a:visited {color: #bd5a35;font-weight:bold;text-decoration:underline;}.tabular-data .tha a:active,.tabular-data .tha a:hover {	color: #bd5a35;	text-decoration:underline;}</style></head><body><div>\n" + DocumentContainer.html() + "\n</div>\n</body>\n</html>";
            WindowObject.document.writeln(strHtml);
            WindowObject.document.close();
            WindowObject.focus();
            $timeout(function () {
                WindowObject.print();
                WindowObject.close();
            });
        };

        $scope.$on('updatePreferencesLanguage', function (event, args) {
            $scope.translation = args;
            $scope.initDesktopIcons();
        });

        $scope.clickToOpen = function () {
            ngDialog.open({ template: 'ui/temperature/chart/temperature-chart.html' });
        };

        $scope.toggleDesktopName = function (startTimer) {
            if (startTimer && $scope.dropdownIsOpen) return;
            desktopViewService.toggleDesktopName(startTimer);
        };

        $scope.toggled = function (open) {
            $scope.dropdownIsOpen = open;
            $scope.toggleDesktopName(!open);
        };

        $scope.savedView = function () {
            if ($scope.accountInfo.customerId != 10162)
                return;
            $(".ui-dialog-content").dialog("close");
            $scope.openView('Temperature Chart', { width: 300, height: 230 }, { my: 'left+50 top+0', at: 'left top', of: window }, { on: true, deviceId: 27714, dateMin: 1412035228000, dateMax: 1412294307000, zoomMin: 1412121748000, zoomMax: 1412208148000 }); $scope.openView('Signal Chart', { width: 300, height: 230 }, { my: 'left+50 top+230', at: 'left top', of: window }, { on: true, deviceId: 27714, dateMin: 1412035228000, dateMax: 1412294307000, zoomMin: 1412121748000, zoomMax: 1412208148000 }); $scope.openView('Analog Chart', { width: 600, height: 460 }, { my: 'left+350 top+0', at: 'left top', of: window }, { on: true, deviceId: 27714, dateMin: 1412035228000, dateMax: 1412294307000, zoomMin: 1412121748000, zoomMax: 1412208148000 });
            $scope.openView('Temperature Chart', { width: 300, height: 230 }, { my: 'left+950 top+0', at: 'left top', of: window }, { on: true, deviceId: 27713, dateMin: 1412035228000, dateMax: 1412294307000, zoomMin: 1412121748000, zoomMax: 1412208148000 }); $scope.openView('Signal Chart', { width: 300, height: 230 }, { my: 'left+950 top+230', at: 'left top', of: window }, { on: true, deviceId: 27713, dateMin: 1412035228000, dateMax: 1412294307000, zoomMin: 1412121748000, zoomMax: 1412208148000 }); $scope.openView('Analog Chart', { width: 600, height: 460 }, { my: 'left+1250 top+0', at: 'left top', of: window }, { on: true, deviceId: 27713, dateMin: 1412035228000, dateMax: 1412294307000, zoomMin: 1412121748000, zoomMax: 1412208148000 });
            $scope.openView('Temperature Chart', { width: 300, height: 230 }, { my: 'left+50 top+460', at: 'left top', of: window }, { on: true, deviceId: 27715, dateMin: 1412035228000, dateMax: 1412294307000, zoomMin: 1412121748000, zoomMax: 1412208148000 }); $scope.openView('Signal Chart', { width: 300, height: 230 }, { my: 'left+50 top+690', at: 'left top', of: window }, { on: true, deviceId: 27715, dateMin: 1412035228000, dateMax: 1412294307000, zoomMin: 1412121748000, zoomMax: 1412208148000 }); $scope.openView('Analog Chart', { width: 600, height: 460 }, { my: 'left+350 top+460', at: 'left top', of: window }, { on: true, deviceId: 27715, dateMin: 1412035228000, dateMax: 1412294307000, zoomMin: 1412121748000, zoomMax: 1412208148000 });
            $scope.openView('Analog Table', { width: 900, height: 460 }, { my: 'left+950 top+460', at: 'left top', of: window }, { on: true, deviceId: 27713, dateMin: 1412035228000, dateMax: 1412294307000, zoomMin: 1412121748000, zoomMax: 1412208148000 });
        };

        switch ($scope.accountInfo.customerId) {
            case 597:
            case 15177:
            case 15147:
                $scope.menuTemplate = "germantown";
                $scope.bulkWaterManagementAccess = true;
                break;
            default:
                $scope.menuTemplate = "";
                $scope.bulkWaterManagementAccess = false;
        }

        $scope.preLogout = function () {
            websocketService.close();
            _unRegisterListener();
            $(".ui-dialog-content").dialog("close");

            $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
            $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
            $rootScope.logoSizeId = $rootScope.defaultFontAndColorId;
            $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;

            if (!angular.isUndefined($scope.firstNotification)) $timeout.cancel($scope.firstNotification);
            if (!angular.isUndefined($scope.secondNotification)) $timeout.cancel($scope.secondNotification);
            if (!angular.isUndefined($scope.onlyNotification)) $timeout.cancel($scope.onlyNotification);
            if (!angular.isUndefined($scope.firstNotificationFrench)) $timeout.cancel($scope.firstNotificationFrench);
            if (!angular.isUndefined($scope.secondNotificationFrench)) $timeout.cancel($scope.secondNotificationFrench);
            if (!angular.isUndefined($scope.onlyNotificationFrench)) $timeout.cancel($scope.onlyNotificationFrench);
        };

        $scope.logout = function () {
            $scope.preLogout();

            $rootScope.CustomerNameStart = "";
            $scope.accountInfo = null;
            $rootScope.login = false;

            authenticationService.logout()
                .then(function (result) {
                    $location.path(result.loginPath);
                }, function (error) {
                    $window.alert("logout error");
                    console.log(error);
                });
        };

        $rootScope.logout = $scope.logout;

        var _postRedirectFeedback = function (customerId, _jiraIssue) {
            return $http.post(HOST + "/api/Jira?customerId=" + customerId, _jiraIssue);
        };

        $scope.redirectToLegacySite = function () {
            //notify mc.services to create record with sessionid
            //collect the sessionID returned from mc.services
            //build url for LegacySite
            //append url with sessionID
            //then change the location to new url

            /////////////////////////////////////////////////////////////////////////////////////////
            $scope.redirectToLegacyFeedback = "";
            $scope.skipFeedback = false;
            function modalController($uibModalInstance, translation) {

                this.translation = _translation;
                this.tmpConfirmMessageB = _translation.text.DEACTIVATE_SIM_CONFIRMATION + '?';

                this.ok = function () {
                    $uibModalInstance.close();
                };

                this.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                this.skip = function () {
                    $scope.skipFeedback = true;
                    $uibModalInstance.dismiss('cancel');
                };

                this.gatherInformation = function () {
                    $scope.redirectToLegacyFeedback = this.comment.trim();
                }
            };

            modalController.$inject = ['$uibModalInstance', 'translation'];

            const modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'ui/components/scadaviews/feedback-popover.html',
                controller: modalController,
                controllerAs: '$ctrl',
                /*size: 'lg',*/
                resolve: {
                    translation: function () { $scope.translation }
                }
            });

            modalInstance.result.then(function (item) {
                if ($scope.redirectToLegacyFeedback.length > 0) {
                    var _jiraIssue = { customerId: $scope.accountInfo.customerId, inputComments: $scope.redirectToLegacyFeedback, inputAttachmentImgBase64: null };
                    _postRedirectFeedback($scope.accountInfo.customerId, _jiraIssue);
                }
                var _loginsService = new LoginsFactory($scope.accountInfo.customerId);
                _loginsService.redirectToLegacySite($scope.accountInfo.userId).then(
                    function (success) {
                        var slstObj = success.data; //scadaLegacySessionTransfer object
                        //console.log(success.data);
                        var legacyUrl = slstObj.legacySiteUrl + "?s=" + slstObj.sessionID; // TODO: update this with correct Url later
                        $window.location.href = legacyUrl;
                    },
                    function (failure) {
                        console.log(failure.data);
                    }
                );
            }, function () {
                // cancel button
                if (!$scope.skipFeedback) {
                    return;
                }
                var _loginsService = new LoginsFactory($scope.accountInfo.customerId);
                _loginsService.redirectToLegacySite($scope.accountInfo.userId).then(
                    function (success) {
                        var slstObj = success.data; //scadaLegacySessionTransfer object
                        //console.log(success.data);
                        var legacyUrl = slstObj.legacySiteUrl + "?s=" + slstObj.sessionID; // TODO: update this with correct Url later
                        $window.location.href = legacyUrl;
                    },
                    function (failure) {
                        console.log(failure.data);
                    }
                );
            });
            /////////////////////////////////////////////////////////////////////////////////////////


        };

        $scope.setColorScheme = function (colorSchemeId) {
            $rootScope.colorSchemeId = colorSchemeId;
        };

        $scope.setFontSize = function (fontSizeId) {
            $rootScope.fontSizeId = fontSizeId;
        };

        $scope.setLogoSize = function (logoSizeId) {
            $rootScope.logoSizeId = logoSizeId;
        };

        $scope.uploadLogo = function () {
            $("#font-color-menu").hide("slow");
            $scope.openView('Upload Logo', { width: 450, height: 350 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 450, minimumHeight: 350 }, true);
        };

        $scope.removeLogo = function () {
            customerExtService.deleteData($scope.accountInfo.customerId).then(function (datafromfactory) {
                $scope.accountInfo.logoName = "";
                $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
                authenticationService.setAccountInfo($scope.accountInfo);
                $("#font-color-menu").hide("slow");
            }, function (error) {
                var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                toaster.pop('error', $scope.windowTitle, errormsg);
                $("#font-color-menu").hide("slow");
            });
        };

        $scope.closeAllViews = function () {
            desktopViewService.closeAllViews();
        };

        $scope.openDesktopView = function (varDesktopId) {
            if (varDesktopId == null || $scope.openDesktopBusy)
                return;
            $scope.openDesktopBusy = true;
            $('#desktopDropdown').scrollTop(0);
            $scope.closeAllViews();
            $rootScope.desktopName = "<i class='fa fa-spinner fa-spin'></i> " + $scope.translation.text.LOADING_DATA + "...";
            setTimeout(function () {
                $scope.selectedDesktopId = varDesktopId;
                desktopViewService.openViewDetail(varDesktopId, $scope.getDesktopName(varDesktopId), $scope.accountInfo.customerId);
                setTimeout(function () {
                    $scope.openDesktopBusy = false;
                }, 1000);
            }, 500);
        };

        $scope.$on('selectedDesktopId', function (event, id) {
            $scope.selectedDesktopId = id;
        });

        $scope.openDesktopViewMobile = function (varDesktopId, varDesktopName) {
            if ((varDesktopId == null && varDesktopName == null) || $scope.openDesktopBusy)
                return;
            $scope.stickyProperties = sharedSetupService.stickyPropertiesInterface;
            var _device = {
                deviceId: varDesktopId,
                deviceName: varDesktopName != null ? varDesktopName : $scope.getDesktopName(varDesktopId)
            };
            window.localStorage.setItem("savedDesktop", varDesktopName);
            //sharedSetupService.setStickyProperties($scope.stickyProperties, { device: _device, windowId: "Saved Desktop" });
            $scope.stickyProperties.device = _device;
            $scope.stickyProperties.windowId = "Saved Desktop";
            $scope.mobileMenuOption("/saveddesktop/saved-desktop-view");
        };

        $scope.getDesktopName = function (varDesktopId) {
            var i;
            for (i = 0; i < $scope.desktopViews.length; i++) {
                if ($scope.desktopViews[i].desktopId == varDesktopId) {
                    return $scope.desktopViews[i].desktopName;
                }
            }
        };

        $scope.openVideoPlayer = function () {
            modalService.displayVideo(219751456);
        };

        var tlDataReceivedWEATHERSHARED = function (data) {
            var _missionOfflineWeatherStationAlert = {};
            var _type = "offline_warning";
            var _title, _message, _id;
            var tmpData = weatherShareService.getWeatherData();
            if (tmpData.temperature == '') {
                weatherSmService.getData('customerID=' + $scope.accountInfo.customerId).then(function (datafromfactory) {
                    $scope.metarStationReport = datafromfactory.data.metarStationReport;
                    $scope.weatherCodeInfo = datafromfactory.data.weatherCodeInfo;
                    if ($scope.weatherCodeInfo != null)
                        $scope.weatherCodeInfoIcon = $scope.weatherCodeInfoIconPath + weatherShareService.getWeatherCodeInfoIcon($scope.weatherCodeInfo.dayTimeIcon, $scope.weatherCodeInfo.nightTimeIcon);
                    if ($scope.metarStationReport != null)
                        $scope.weatherTemperature = $scope.metarStationReport.temperature;
                    if ($scope.weatherCodeInfo != null && $scope.metarStationReport != null)
                        weatherShareService.setWeatherData($scope.weatherTemperature, $scope.weatherCodeInfoIcon);
                    if ($scope.metarStationReport == null) {
                        $scope.weatherTemperature = tmpData.temperature;
                        _id = datafromfactory.data.metarStationInfo.icao;
                        if ($scope.missionOfflineWeatherStationAlerts.length == 0 || $scope.missionOfflineWeatherStationAlerts[0].id != _id) {
                            _title = $scope.translation.text.WEATHER_STATION_OFFLINE;
                            _message = '<b>' + datafromfactory.data.metarStationInfo.city + ' (' + datafromfactory.data.metarStationInfo.icao + ')</b><br><br>' + $scope.translation.text.WEATHER_STATION_OFFLINE_MSG;
                            _missionOfflineWeatherStationAlert = { type: _type, title: _title, message: _message, id: _id };
                            $scope.alertRead = "alert-unread";
                            $scope.missionOfflineWeatherStationAlerts = [];
                            $scope.missionOfflineWeatherStationAlerts.push(_missionOfflineWeatherStationAlert);
                            //Only display weather notification if user enables preference toggle
                            if ($scope.displayWeatherNotification) toaster.pop(_type, _title, _message, 15000, 'trustedHtml');
                            _setMissionAlertLevel();
                        }
                    }
                    else {
                        $scope.missionOfflineWeatherStationAlerts = [];
                    }
                }, function (error) {
                    $scope.loadingInProgress = false;
                    var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                    toaster.pop('error', $scope.windowTitle, errormsg);

                    if (!isNoU(error) && !isNoU(error.data) && !isNoU(error.data.message) && error.data.message === "SYSTEM_LOG_OUT")
                        throw new Error(error.data.message);
                });
            }
            else {
                $scope.weatherTemperature = tmpData.temperature;
                $scope.weatherCodeInfoIcon = tmpData.weatherCodeInfoIcon;
            }
        };

        var tlDataReceivedWEATHERSEVERE = function (data) {
            weatherSevereService.getData('timeZone=' + $scope.accountInfo.timeZone + '&fips=' + $scope.accountInfo.fips + '&Id=' + $scope.parameterWeatherId).then(function (datafromfactory) {
                var _missionWeatherAlert = {};
                var _type = "weather_watch";
                var _title, _expire;
                $scope.severeWeather = datafromfactory.data;
                $scope.loadingInProgress = false;

                for (var j = 0; j < $scope.severeWeather.length; j++) {
                    $scope.parameterWeatherId = $scope.parameterWeatherId < $scope.severeWeather[j].id ? $scope.severeWeather[j].id : $scope.parameterWeatherId;
                    if ($scope.severeWeather[j].priority == 1 || $scope.severeWeather[j].priority == 2) {
                        _type = "ticket_warning";
                        _expire = 30000;
                    }
                    else if ($scope.severeWeather[j].priority == 3 || $scope.severeWeather[j].priority == 4) {
                        _type = "weather_advisory";
                        _expire = 60000;
                    }
                    else if ($scope.severeWeather[j].priority == 5) {
                        _type = "weather_warning";
                        _expire = 3600000;
                    }
                    $scope.alertRead = "alert-unread";
                    _title = $scope.severeWeather[j].product;
                    fnRemoveSevereWeatherByTitle(_title);

                    var expireTimeFormat = $scope.preferredTimeFormat === $scope.TimeFormatEnum.Civilian ? 'MMM Do, h:mm a' : 'MMM Do, HH:mm';

                    var expireTime = moment($scope.severeWeather[j].localTimeExpires).format(expireTimeFormat);

                    var untilMessage = $scope.translation.text.UNTIL + ": " + expireTime;

                    var fullMessage = $scope.severeWeather[j].fullMessage;

                    var shortMessage;
                    if (fullMessage.length > 200) {
                        shortMessage = fullMessage.substring(0, 200);
                        shortMessage = shortMessage.substr(0, Math.min(shortMessage.length, shortMessage.lastIndexOf(" ")));
                        shortMessage = untilMessage + '<div>' + shortMessage + '</div>';
                        fullMessage = untilMessage + '<div>' + fullMessage + '</div>';

                        //Only display weather notification if user enables preference toggle
                        if ($scope.displayWeatherNotification) toaster.pop(_type, _title, shortMessage, _expire, 'trustedHtml', null, null, { long: fullMessage, short: shortMessage, timeout: _expire, icon: 'fa fa-chevron-down' });
                        _missionWeatherAlert = { type: _type, title: _title, message: shortMessage, expire: $scope.severeWeather[j].localTimeExpires, msgObj: { long: fullMessage, short: shortMessage, timeout: _expire, icon: 'fa fa-chevron-down' } };
                        $scope.missionWeatherAlerts.push(_missionWeatherAlert);
                    } else {
                        fullMessage = untilMessage + '<div>' + fullMessage + '</div>'
                        //Only display weather notification if user enables preference toggle
                        if ($scope.displayWeatherNotification) toaster.pop(_type, _title, fullMessage, _expire, 'trustedHtml', null, null);
                        _missionWeatherAlert = { type: _type, title: _title, message: fullMessage, expire: $scope.severeWeather[j].localTimeExpires, msgObj: { timeout: _expire } };
                        $scope.missionWeatherAlerts.push(_missionWeatherAlert);
                    }
                }
                _setMissionAlertLevel();
            }, function (error) {
                $scope.loadingInProgress = false;
                var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                toaster.pop('error', $scope.windowTitle, errormsg);
            });
        };

        var tlDataReceivedTICKETALERT = function (data) {
            ticketAlertService.getData('customerId=' + $scope.accountInfo.customerId + '&timeZone=' + $scope.accountInfo.timeZone + '&startDate=' + $scope.parameterStartDate).then(function (datafromfactory) {
                var _missionTicketAlert = {};
                var _type = "ticket_warning";
                var _title, _message, _expire;
                $scope.ticketAlert = datafromfactory;
                $scope.loadingInProgress = false;
                for (var j = 0; j < $scope.ticketAlert.length; j++) {
                    $scope.parameterStartDate = $scope.parameterStartDate === null || $scope.parameterStartDate < $scope.ticketAlert[j].eventDateTimeLocal ? $scope.ticketAlert[j].eventDateTimeLocal : $scope.parameterStartDate;
                    $scope.alertRead = "alert-unread";
                    _title = $scope.ticketAlert[j].title;
                    fnRemoveTicketByTitle(_title);
                    _message = "TicketSystem.html";
                    _expire = $scope.ticketAlert[j].eventDateTimeLocalExpires;
                    _missionTicketAlert = { type: _type, title: _title, message: _message, expire: _expire, ticketNumber: $scope.ticketAlert[j].ticketId };
                    $scope.missionTicketAlerts.push(_missionTicketAlert);
                    toaster.pop(_type, _title, _message, 15000, 'template', null, $scope.ticketAlert[j].ticketId);
                }
                _setMissionAlertLevel();
            }, function (error) {
                $scope.loadingInProgress = false;
                var errormsg = $scope.translation.message.GENERAL_SERVER_ERROR;
                toaster.pop('error', $scope.windowTitle, errormsg);
            });
        };

        var tlDataReceivedUIVERSION = function (data) {
            mcApplicationVersionAlertService.getData('customerId=' + $scope.accountInfo.customerId + '&applicationId=1' + '&timeZone=' + $scope.accountInfo.timeZone).then(function (datafromfactory) {
                if (datafromfactory.data.buildNumber > $('meta[name=build]').attr("content")) {
                    var _missionUpdateAlerts = {};
                    var _title, _message, _expire;
                    $scope.loadingInProgress = false;

                    var d = new Date();
                    var year = d.getFullYear();
                    var month = d.getMonth();
                    var day = d.getDate();
                    var c = new Date(year + 1, month, day);

                    _type = "error";

                    $scope.alertRead = "alert-unread";
                    _title = $scope.translation.text.NEW_123SCADA_AVAILABLE;
                    fnRemoveUpdateByTitle(_title);
                    _message = "<br>" + $scope.translation.text.SAVE_YOUR_WORK + "<a href='#' onclick='location.reload(true); return false;' style='text-decoration: underline;'>" + $scope.translation.text.CLICK_HERE + "</a>" + $scope.translation.text.TO_UPDATE;
                    _expire = c;
                    _missionUpdateAlerts = { type: _type, title: _title, message: _message, expire: _expire };
                    $scope.missionUpdateAlerts.push(_missionUpdateAlerts);
                    toaster.pop(_type, _title, _message, 15000, 'trustedHtml');

                    _setMissionAlertLevel();
                } else if (!$rootScope.uiUpToDate) {
                    toaster.pop('success', $scope.translation.text.UP_TO_DATE_123SCADA, "", 5000, 'trustedHtml');
                    $rootScope.uiUpToDate = true;
                }
            }, function (error) {
                console.log("error");
            });
        };

        var tlDataReceivedSYSTEMALERTSMESSAGE = function () {
            systemAlertMessageService.getData("languageCode=" + $scope.accountInfo.preferenceUser.lookupLanguageID + "&isMobile=" + $rootScope.mobile).then(function (response) {
                var _title = $scope.translation.text.SYSTEM_ALERT_MESSAGE;
                if (!response.data.status && typeof $scope.SAMessage !== "undefined" && response.data.message === null) {
                    $scope.SAMessage = undefined;
                    fnRemoveUpdateByTitle(_title);
                    $scope.fnMissionAlerts();
                    return; //clear the message if set before
                }
                if (!response.data.status || $scope.SAMessage === response.data.message) return; //skip if message is the same
                if (response.data.status && typeof $scope.SAMessage !== "undefined" && $scope.SAMessage !== response.data.message) {
                    fnRemoveUpdateByTitle(_title);
                    $scope.fnMissionAlerts();
                } //update the message if different
                var _missionUpdateAlerts = {};
                var _message, _type;  // removed _title which was defined on line 342 already JS
                var d = new Date();
                var year = d.getFullYear();
                var month = d.getMonth();
                var day = d.getDate();
                var _expire = new Date(year + 1, month, day);
                $scope.loadingInProgress = false;
                _type = "error";
                $scope.alertRead = "alert-unread";

                $scope.SAMTitle = _title;
                _message = response.data.message.replace(/<br>/g, ' ').replace(/<\/br>/g, ' ');
                $scope.SAMessage = _message;
                _missionUpdateAlerts = { type: _type, title: _title, message: _message, expire: _expire };
                if ($scope.missionUpdateAlerts.length > 0) {
                    toaster.clear();
                }
                $scope.missionUpdateAlerts = [];
                $scope.missionUpdateAlerts.push(_missionUpdateAlerts);
                toaster.pop(_type, _title, "<br>" + _message, 0, 'trustedHtml');
                _setMissionAlertLevel();
            }, function (error) {
                console.log("error");
            });
        };

        var wsDataReceivedAaINFO = function (data) { //AudioAnnouncement
            var agentText = dashboardService.stripAgentText(data.Value);
            if (!$rootScope.mobile && $scope.audioEnabled) $scope.speak(agentText);
        };


        var wsDataReceivedDesktopNotification = function (data) {

            if (data.UniqueWebID != $rootScope.uniqueWebID) {
                toaster.pop('warning', "Device Setting Changes", data.Value, 30000, 'trustedHtml');
            }
        };

        $scope.setSpeakFunction = function () {
            $scope.speak = $scope.audioEnabled ? textToSpeechService.speak : null;
        };

        $scope.$on('updatePreferencesAudio', function (event, preferencesAudio) {
            $scope.audioEnabled = preferencesAudio == 1 ? true : false;
            $scope.setSpeakFunction();
        });

        $scope.$on('switchedCustomers', function (e) {
            $scope.accountInfo = authenticationService.getAccountInfo();
        });

        $scope.setSpeakFunction();

        var _registerListener = function () {
            websocketService.connect();
            timeLapseService.register("WEATHERSHARED", 0, "", tlDataReceivedWEATHERSHARED, 1);
            timeLapseService.register("WEATHERSEVERE", 0, "", tlDataReceivedWEATHERSEVERE, 40);
            timeLapseService.register("TICKETALERT", 0, "", tlDataReceivedTICKETALERT, 60);
            timeLapseService.register("UIVERSION", 0, "", tlDataReceivedUIVERSION, 12);
            timeLapseService.register("SYSTEMALERTSMESSAGE", 0, "", tlDataReceivedSYSTEMALERTSMESSAGE, 30);
            websocketService.register("INFO", "", "", wsDataReceivedAaINFO, null);
            websocketService.register("DESKTOPNOTIFICATION", "", 0, wsDataReceivedDesktopNotification, null);
        };

        var _unRegisterListener = function () {
            timeLapseService.unRegister("WEATHERSHARED", 0, "", tlDataReceivedWEATHERSHARED, 1);
            timeLapseService.unRegister("WEATHERSEVERE", 0, "", tlDataReceivedWEATHERSEVERE, 40);
            timeLapseService.unRegister("TICKETALERT", 0, "", tlDataReceivedTICKETALERT, 60);
            timeLapseService.unRegister("UIVERSION", 0, "", tlDataReceivedUIVERSION, 12);
            timeLapseService.unRegister("SYSTEMALERTSMESSAGE", 0, "", tlDataReceivedSYSTEMALERTSMESSAGE, 30);
            websocketService.unRegister("INFO", "", "", wsDataReceivedAaINFO, null);
            websocketService.unRegister("DESKTOPNOTIFICATION", "", 0, wsDataReceivedDesktopNotification, null);
        };

        var fnRemoveExpiredNotifications = function (data) {
            var _missionAlertLevel = $scope.missionAlertLevel;
            var _type = "ticket_warning";
            var _title, _message, _expire;
            for (var z = 0; z < $scope.missionUpdateAlerts.length; z++) {
                if (new Date($scope.missionUpdateAlerts[z].expire).getTime() - data.Unix < 0)
                    $scope.missionUpdateAlerts.splice(z, 1);
            }
            for (var i = 0; i < $scope.missionWeatherAlerts.length; i++) {
                if (new Date($scope.missionWeatherAlerts[i].expire).getTime() - data.Unix < 0)
                    $scope.missionWeatherAlerts.splice(i, 1);
            }
            for (var j = 0; j < $scope.missionTicketAlerts.length; j++) {
                if (new Date($scope.missionTicketAlerts[j].expire).getTime() - data.Unix < 0)
                    $scope.missionTicketAlerts.splice(j, 1);
            }
            if ($scope.missionTicketAlerts.length === 0 && $scope.missionWeatherAlerts.length === 0 && $scope.missionUpdateAlerts.length === 0 && $scope.missionOfflineWeatherStationAlerts.length === 0) {
                $scope.missionAlertLevel = 0;
            }
            else {
                _setMissionAlertLevel();
            }
        };

        var fnRemoveTicketByTitle = function (varTitle) {
            for (var j = 0; j < $scope.missionTicketAlerts.length; j++) {
                if ($scope.missionTicketAlerts[j].title == varTitle)
                    $scope.missionTicketAlerts.splice(j, 1);
            }
        };

        var fnRemoveUpdateByTitle = function (varTitle) {
            for (var j = 0; j < $scope.missionUpdateAlerts.length; j++) {
                if ($scope.missionUpdateAlerts[j].title == varTitle)
                    $scope.missionUpdateAlerts.splice(j, 1);
            }
        };

        var fnRemoveSevereWeatherByTitle = function (varTitle) {
            for (var j = 0; j < $scope.missionWeatherAlerts.length; j++) {
                if ($scope.missionWeatherAlerts[j].title == varTitle)
                    $scope.missionWeatherAlerts.splice(j, 1);
            }
        };

        var _setMissionAlertLevel = function () {
            var _missionAlertLevel = 0;
            for (var i = 0; i < $scope.missionOfflineWeatherStationAlerts.length; i++) {
                _missionAlertLevel = 1;
            }
            for (var x = 0; x < $scope.missionTicketAlerts.length; x++) { // both var were i so changed this iterator to x
                _missionAlertLevel = 1;
            }
            for (var k = 0; k < $scope.missionWeatherAlerts.length; k++) {
                if ($scope.missionWeatherAlerts[k].type.toLowerCase().indexOf("watch") > -1) {
                    _missionAlertLevel = _missionAlertLevel < 4 ? 3 : _missionAlertLevel;
                }
                else if ($scope.missionWeatherAlerts[k].type.toLowerCase().indexOf("advisory") > -1) {
                    _missionAlertLevel = _missionAlertLevel < 4 ? 3 : _missionAlertLevel;
                }
                else if ($scope.missionWeatherAlerts[k].type.toLowerCase().indexOf("warning") > -1) {
                    _missionAlertLevel = 4;
                }
            }
            for (var j = 0; j < $scope.missionUpdateAlerts.length; j++) {
                _missionAlertLevel = 4;
            }
            $scope.missionAlertLevel = _missionAlertLevel;
        };

        var _registerRemoveExpiredNotificationsListener = function () {
            timeLapseService.register("REMOVENOTIFICATIONS", 0, "", fnRemoveExpiredNotifications, 1);
        };

        var _setMissionNotifications = function () {
            $scope.missionNotifications.push({ callFunction: tlDataReceivedTICKETALERT });
            $scope.missionNotifications.push({ callFunction: tlDataReceivedWEATHERSEVERE });
        };

        $scope.$on('updatePreferenceWeather', function (event, args) {
            weatherShareService.setWeatherData('', '');
            $timeout(function () { tlDataReceivedWEATHERSHARED(); }, 3000);
            //weatherShareService.getWeatherData();
        });

        $scope.$on('updatePreferencesLanguage', function () {
            if ($scope.missionOfflineWeatherStationAlerts && $scope.missionOfflineWeatherStationAlerts.length > 0) {
                $scope.missionOfflineWeatherStationAlerts[0].id = "";
            }
            tlDataReceivedWEATHERSHARED();
            tlDataReceivedWEATHERSEVERE();
            tlDataReceivedUIVERSION();
            tlDataReceivedSYSTEMALERTSMESSAGE();
        });

        $scope.fnMissionAlerts = function () {
            toaster.clear();
            $scope.alertRead = "alert-read";
            if ($scope.displayWeatherNotification) {
                for (var i = 0; i < $scope.missionOfflineWeatherStationAlerts.length; i++) {
                    toaster.pop($scope.missionOfflineWeatherStationAlerts[i].type, $scope.missionOfflineWeatherStationAlerts[i].title, $scope.missionOfflineWeatherStationAlerts[i].message, 15000, 'trustedHtml');
                };
                for (var k = 0; k < $scope.missionWeatherAlerts.length; k++) {
                    toaster.pop($scope.missionWeatherAlerts[k].type, $scope.missionWeatherAlerts[k].title, $scope.missionWeatherAlerts[k].message, $scope.missionWeatherAlerts[k].msgObj.timeout || 3600000, 'trustedHtml', null, null, $scope.missionWeatherAlerts[k].msgObj);
                };
            };
            for (var j = 0; j < $scope.missionTicketAlerts.length; j++) {
                toaster.pop($scope.missionTicketAlerts[j].type, $scope.missionTicketAlerts[j].title, 'TicketSystem.html', 15000, 'template', null, $scope.missionTicketAlerts[j].ticketNumber);
            }
            for (var z = 0; z < $scope.missionUpdateAlerts.length; z++) {
                toaster.pop($scope.missionUpdateAlerts[z].type, $scope.missionUpdateAlerts[z].title, $scope.missionUpdateAlerts[z].message, 15000, 'trustedHtml');
            }
        };

        _initDesktop = function () {
            $scope.initDesktopIcons();

            _registerListener();
            tlDataReceivedWEATHERSHARED();
            tlDataReceivedUIVERSION();
            tlDataReceivedSYSTEMALERTSMESSAGE();
            _registerRemoveExpiredNotificationsListener();
            _setMissionNotifications();

            $("title").text($scope.accountInfo.customerName + ", " + $scope.translation.text.POWERED_BY_MISSION);
            angular.forEach($scope.missionNotifications, function (data, i) {
                $timeout(function () {
                    data.callFunction();
                }, (i + 1) * $scope.loadingDelay);
            });
        };

        if (angular.isDefined($scope.translation)) {
            _initDesktop();
        } else {
            translationService.loadLanguage(true)
                .then(function (result) {
                    $scope.translation = translationService.translation;
                    _initDesktop();
                }, function (error) {
                    console.log("error");
                });
        }

        $scope.openFeedback = function () {
            $timeout(function () {
                $("#send-feedback-button").trigger("click");
            }, 0);
        };

        ////////////////////////////////////////////////////////////////////////////////////
        if (!($rootScope.mobile || $rootScope.classicView)) {
            var _startAdjustViews;
            var _startScopeApply;
            var _windowDimensionsOld;
            var _windowDimensionsNew;

            var w = angular.element($window);
            $scope.getWindowDimensions = function () {
                return {
                    'h': w.height(),
                    'w': w.width()
                };
            };

            _windowDimensionsOld = $scope.getWindowDimensions();

            w.on('resize', function (event) {
                //only if from window - we do not want it if bubble up from views ('resize')
                if (event.target === this) {
                    //do it on resize-end rather than on every single resize
                    if (angular.isDefined(_startScopeApply)) {
                        $timeout.cancel(_startScopeApply);
                        _startScopeApply = undefined;
                    }
                    _startScopeApply = $timeout(function () {
                        $scope.$apply();
                        _windowDimensionsNew = $scope.getWindowDimensions();
                        _watchWindowDimensions();
                    }, 300);
                }
            });

            //more control with custom $watch on "$scope.getWindowDimensions"
            var _watchWindowDimensions = function () {
                if (_windowDimensionsNew && _windowDimensionsNew != _windowDimensionsOld) {
                    $scope.windowHeight = _windowDimensionsNew.h;
                    $scope.windowWidth = _windowDimensionsNew.w;
                    $scope.showLiveData = _windowDimensionsNew.w > 425 ? true : false;
                    $scope.showWeather = _windowDimensionsNew.w > 360 ? true : false;
                    $("#dialog-extend-fixed-container").css("width", $scope.windowWidth - 430); //check /scripts/dialogextend/jquery.dialogextend.js ln: 454
                    _adjustViews();
                }
            };

            var _adjustViews = function () {
                //do it only once per resize
                if (angular.isDefined(_startAdjustViews)) {
                    $timeout.cancel(_startAdjustViews);
                    _startAdjustViews = undefined;
                }

                _startAdjustViews = $timeout(function () {
                    for (var i = 0; i < $rootScope.arrPopup.length; i++) {
                        var _popup = _this.getExistingDialog($rootScope.arrPopup[i].desktopIndex).ref;
                        //fit all views better within window size
                        openViewService.adjustContentSizeStart(_popup, $rootScope.arrPopup[i].desktopName);
                        //fit content better within views
                        openViewService.adjustContentSize(_popup);
                    }
                }, 300, true);
            };
        }
        ////////////////////////////////////////////////////////////////////////////////////
        var fMc = function () {
            var root = angular.element(document.getElementsByTagName('html'));

            var watchers = [];

            var f = function (element) {
                angular.forEach(['$scope', '$isolateScope'], function (scopeProperty) {
                    if (element.data() && element.data().hasOwnProperty(scopeProperty)) {
                        angular.forEach(element.data()[scopeProperty].$$watchers, function (watcher) {
                            watchers.push(watcher);
                        });
                    }
                });

                angular.forEach(element.children(), function (childElement) {
                    f(angular.element(childElement));
                });
            };

            f(root);

            // Remove duplicate watchers
            var watchersWithoutDuplicates = [];
            angular.forEach(watchers, function (item) {
                if (watchersWithoutDuplicates.indexOf(item) < 0) {
                    watchersWithoutDuplicates.push(item);
                }
            });

            $scope.watchers = watchersWithoutDuplicates.length;
            $scope.wsListeners = websocketService.getWebsocketListenerCount();
        };

        if (!$rootScope.mobile && (document.location.hostname !== "123scada.com"))
            $interval(function () { fMc(); }, 5000);

        $scope.$on('Heartbeat', function (event, args) {
            if (args.message.Type === "HEARTBEAT") {
                $rootScope.heartbeatUtcDateTime = args.message.UtcDateTime;
            }
        });

        $scope.$on('processReconnect', function (event, args) {
            _unRegisterListener();
            $timeout(function () { _registerListener(); }, 10000);
        });

        $scope.$on('addDeviceNameToPrintChart', function (event, args) {
            //If for example args.windowId == Tank And Well Chart_0 then below condition is used
            if (/_\d+$/.test(args.windowId)) {
                    args.windowId = args.windowId.replace(/_\d+$/, '');
            }
            //adding title on the print screen that says View Name followed by Device Name and Customer Name
            $("title").text(args.windowId + ", " + (args.stickyProperties.device.deviceName ? args.stickyProperties.device.deviceName : args.stickyProperties.device.title) + ", " + $scope.accountInfo.customerName);
        });

        $scope.startTimeout = function () {
            $scope.myTimeout = $timeout(function () {

                importantInformationModalService.importantInformation($scope, false).then(function() {
                    //                   
                },
                    function(error) {
                        //                      
                    });

            }, DAYSPASTDUETIMER);
        }

        if (!$rootScope.mobile && angular.isUndefined($scope.accountInfo.daysPastDue)) {
            customerExtService.getDaysPastDue($scope.accountInfo.customerId).then(function (resp) {
                var daysPastDue = resp.data;
                $scope.accountInfo.daysPastDue = daysPastDue;
                $window.sessionStorage.accountInfo = JSON.stringify($scope.accountInfo);

                if (!$rootScope.mobile && daysPastDue > 0) {
                    importantInformationModalService.importantInformation($scope, false).then(function () { });
                }

            }, function (error) {
                //
            });
        }
        else if (!$rootScope.mobile && $scope.accountInfo.daysPastDue > 0) {
                importantInformationModalService.importantInformation($scope, false).then(function () { });
        }        

        $scope.stopTimeout = function () {
            if (!angular.isUndefined($scope.myTimeout)) $timeout.cancel($scope.myTimeout); 
            $scope.myTimeout = undefined; // Clear $scope.myTimeout reference
        }

        $scope.$on("$destroy", function () {
            _unRegisterListener();
            weatherShareService.setWeatherData('', '');
            openViewService.setWeatherViewMode();
            if (angular.isDefined(w)) w.off('resize');
            if (!angular.isUndefined(_hideRecconectFalseOn)) $timeout.cancel(_hideRecconectFalseOn);
            if (!angular.isUndefined(_hideRecconectFalseClick)) $timeout.cancel(_hideRecconectFalseClick);
            if (!($rootScope.mobile || $rootScope.classicView || $rootScope.freshLogin) && $location.path().indexOf("/portal") === -1) $scope.logout();
            if (!($rootScope.mobile || $rootScope.classicView || $rootScope.freshLogin) && $location.path().indexOf("/portal") > -1) $scope.preLogout();
            if (!$rootScope.mobile) $scope.stopTimeout();
        });

        ////////////////////////////////////////////////////////////////////////
        var setRadioUpgradeToaster = function () {
            var _radioUpgrade = new RadioUpgradeFactory();
            var toasterMessage = "";
            var noOfLegacyDevices = 0;
            var noOfMydroDevices = 0;
            var noOfManholeDevices = 0;
            var msgObj = { RadioUpgradeToaster: true, customerId: $scope.accountInfo.customerId, loginId: $scope.accountInfo.userId };
            _radioUpgrade.ListRadioUpgradeDevicesByCustomerId($scope.accountInfo.customerId, false, false, false).then(function (resp) {
                if (resp.data.length == 0) return;

                for (var i = 0; i < resp.data.length; i++) {
                    if (resp.data[i].model == 18 || resp.data[i].model == 19) noOfMydroDevices += 1;
                    if (resp.data[i].model == 15) noOfManholeDevices += 1;
                }
                noOfLegacyDevices = resp.data.length - noOfMydroDevices - noOfManholeDevices;

                if ((noOfMydroDevices > 0 && noOfLegacyDevices > 0) || (noOfLegacyDevices > 0 && noOfManholeDevices > 0) || (noOfManholeDevices > 0 && noOfMydroDevices > 0)) {
                    toasterMessage += $scope.translation.text.MULTIPLE_MODULES_NEED_UPGRADE;
                }
                else if (noOfMydroDevices > 0) {
                    if (noOfMydroDevices > 1) {
                        toasterMessage += noOfMydroDevices + " " + $scope.translation.text.MYDRO_MODULES_NEED_UPGRADE;
                    }
                    else {
                        toasterMessage += noOfMydroDevices + " " + $scope.translation.text.MYDRO_MODULE_NEEDS_UPGRADE;
                    }
                }
                else if (noOfManholeDevices > 0) {
                    if (noOfManholeDevices > 1) {
                        toasterMessage += noOfManholeDevices + " " + $scope.translation.text.MANHOLE_MODULES_NEED_UPGRADE;
                    }
                    else {
                        toasterMessage += noOfManholeDevices + " " + $scope.translation.text.MANHOLE_MODULE_NEEDS_UPGRADE;
                    }
                }
                else if (noOfLegacyDevices > 0) {
                    if (noOfLegacyDevices > 1) {
                        toasterMessage += noOfLegacyDevices + " " + $scope.translation.text.LEGACY_MODULES_NEED_UPGRADE;
                    }
                    else {
                        toasterMessage += noOfLegacyDevices + " " + $scope.translation.text.LEGACY_MODULE_NEEDS_UPGRADE;
                    }
                }

                //if (resp.data.length > 2) {
                //    var leftDevices = resp.data.length - 2;
                //    toasterMessage = resp.data[0].name + " " + $scope.translation.text.AND + " " + resp.data[1].name + " " + $scope.translation.text.AND + " " + leftDevices + " " + $scope.translation.text.RADIO_MODULE_NEED_UPGRADE_MORE;
                //}
                //else if (resp.data.length == 2) {
                //    toasterMessage = resp.data[0].name + " " + $scope.translation.text.AND + " " + resp.data[1].name + " " + $scope.translation.text.RADIO_MODULE_NEED_UPGRADE;
                //}
                //else if (resp.data.length == 1) {
                //    toasterMessage = resp.data[0].name + " " + $scope.translation.text.RADIO_MODULE_NEED_UPGRADE;
                //}

                var augustDeadline = new Date(2020, 8, 31);
                var octoberDeadline = new Date(2020, 10, 31);
                var today = new Date();
                if (today <= augustDeadline) {
                    toaster.pop('success', $scope.translation.text.RADIO_UPGRADE_NOTIFICATION, toasterMessage, 30000, 'trustedHtml');
                }
                else if (augustDeadline < today && today <= octoberDeadline) {
                    toaster.pop('ticket_warning', $scope.translation.text.RADIO_UPGRADE_NOTIFICATION, toasterMessage, 30000, 'trustedHtml');
                }
                else {
                    toaster.pop('error', $scope.translation.text.WARNING.toUpperCase() + ": " + $scope.translation.text.ACTION_REQUIRED, toasterMessage, -1, 'trustedHtml', null, null, msgObj);
                }
            })
        }

        ////////////////////////////////////////////////////////////////////////
        var numDaysBetween = function (d1, d2) {
            var diff = Math.abs(new Date(d1).getTime() - new Date(d2).getTime());
            return diff / (1000 * 60 * 60 * 24);
        };

        ////////////////////////////////////////////////////////////////////////
        var setTwitterToaster = function () {
            if (typeof $scope.accountInfo.preferenceUser.loginId !== 'undefined') {
                ToasterMessageTimestampFactory.GetExistingRecord($scope.accountInfo.customerId, $scope.accountInfo.preferenceUser.loginId).then(function (resp) {
                    var currentDate = new Date();
                    if (resp.data == null) {
                        toaster.pop('success', $scope.translation.text.FOLLOW_US, $scope.translation.text.FOLLOW_MISSION_ON_TWITTER, 30000, 'trustedHtml');
                        ToasterMessageTimestampFactory.InsertNewRecord($scope.accountInfo.customerId, $scope.accountInfo.preferenceUser.loginId, $scope.accountInfo.email, currentDate);
                    }
                    else {
                        if (numDaysBetween(currentDate, resp.data.twitterNotificationDate) >= 180) {
                            toaster.pop('success', $scope.translation.text.FOLLOW_US, $scope.translation.text.FOLLOW_MISSION_ON_TWITTER, 30000, 'trustedHtml');
                            ToasterMessageTimestampFactory.UpdateExistingRecord($scope.accountInfo.customerId, $scope.accountInfo.preferenceUser.loginId, currentDate);
                        }
                    }
                }, function (error) {
                    console.log("error", error);
                });
            }
            else {
                ToasterMessageTimestampFactory.GetExistingRecord($scope.accountInfo.customerId, $scope.accountInfo.preferenceUser.loginID).then(function (resp) {
                    var currentDate = new Date();
                    if (resp.data == null) {
                        toaster.pop('success', $scope.translation.text.FOLLOW_US, $scope.translation.text.FOLLOW_MISSION_ON_TWITTER, 30000, 'trustedHtml');
                        ToasterMessageTimestampFactory.InsertNewRecord($scope.accountInfo.customerId, $scope.accountInfo.preferenceUser.loginID, $scope.accountInfo.email, currentDate);
                    }
                    else {
                        if (numDaysBetween(currentDate, resp.data.twitterNotificationDate) >= 180) {
                            toaster.pop('success', $scope.translation.text.FOLLOW_US, $scope.translation.text.FOLLOW_MISSION_ON_TWITTER, 30000, 'trustedHtml');
                            ToasterMessageTimestampFactory.UpdateExistingRecord($scope.accountInfo.customerId, $scope.accountInfo.preferenceUser.loginID, currentDate);
                        }
                    }
                }, function (error) {
                    console.log("error", error);
                });
            }
        }

        ////////////////////////////////////////////////////////////////////////
        var setWebinarToaster = function () {
            registerWebinarService.GetWebinarHeading($scope.accountInfo.customerId).then(function (resp) {
                if (resp.data.schedule.length == 0) return;

                var webinarDescriptionArray = resp.data.description.split("\n");
                var webinarDescription = webinarDescriptionArray[0];

                var webinarDay = new Date(new Date(resp.data.schedule[0].startTime).setHours(13, 0, 0, 0));
                var placeHolder = new Date(webinarDay.getTime());
                var prevWebinarDay = new Date(new Date(placeHolder.setDate(webinarDay.getDate() - 1)).setHours(12, 0, 0, 0));

                var webinarStartTime = new Date(resp.data.schedule[0].startTime);
                var webinarEndTime = new Date(webinarStartTime.getTime() + 60 * 60000);
                var startArray = convertDateString(webinarStartTime).split(" ");
                var endArray = convertDateString(webinarEndTime).split(" ");
                var webinarStartTimeConverted = startArray[0] + ' ' + startArray[1];
                var webinarEndTimeConverted = endArray[1] + ' ' + endArray[2];

                var weekOffset = 0;                   //handle the situation where the end of previous month and the beginning of current are in the same week
                var currentWeek = getMonthWeek();
                var today = new Date();
                var numberOfDay = today.getDay();
                var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

                if (firstDayOfMonth.getDay() <= 3) {   //if the first day is before wednesday means schedule is correct, if after wednesday, all schedule will be pushed back for 1 week
                    weekOffset = 0;
                }
                else {
                    weekOffset = -1;
                }
                if (numberOfDay <= 3) {
                    webinarDescription = webinarDescriptionArray[currentWeek + weekOffset - 1];
                }
                else {
                    if (currentWeek <= 3) {
                        webinarDescription = webinarDescriptionArray[currentWeek + weekOffset];
                    }
                    else {
                        if (lastDayOfMonth.getDay() <= 3) {
                            webinarDescription = webinarDescriptionArray[0];
                        }
                        else {
                            webinarDescription = webinarDescriptionArray[currentWeek + weekOffset];
                        }

                    }
                }

                if (today.getTime() <= prevWebinarDay.getTime()) {
                    $scope.firstNotification = $timeout(function () {
                        $timeout(function () {
                            toaster.pop("ticket_warning", $scope.translation.text.WEBINAR_SCHEDULE_NOTIFICATION, $scope.translation.text.WEBINAR_REMINDER_DAY + " "
                                + webinarStartTimeConverted + "-" + webinarEndTimeConverted + '<br>' + $scope.translation.text.WEBINAR_TOPIC + " " + webinarDescription, 30000, 'trustedHtml');
                        }, 300);
                    }, prevWebinarDay.getTime() - today.getTime());
                    $scope.secondNotification = $timeout(function () {
                        $timeout(function () {
                            toaster.pop("ticket_warning", $scope.translation.text.WEBINAR_SCHEDULE_NOTIFICATION, $scope.translation.text.WEBINAR_REMINDER_HOUR + " "
                                + webinarStartTimeConverted + "-" + webinarEndTimeConverted + '<br>' + $scope.translation.text.WEBINAR_TOPIC + " " + + webinarDescription, 30000, 'trustedHtml');
                        }, 300);
                        //call set toaster method again after 6 hours so next week's content would display, calling the method again would set up the toaster for next week
                        $timeout(function () {
                            setWebinarToaster();
                        }, 6 * 60 * 60000);
                    }, webinarDay.getTime() - today.getTime());
                }
                else if (today.getTime() <= webinarDay.getTime()) {
                    $scope.onlyNotification = $timeout(function () {
                        $timeout(function () {
                            toaster.pop("ticket_warning", $scope.translation.text.WEBINAR_SCHEDULE_NOTIFICATION, $scope.translation.text.WEBINAR_REMINDER_HOUR + " "
                                + webinarStartTimeConverted + "-" + webinarEndTimeConverted + '<br>' + $scope.translation.text.WEBINAR_TOPIC + " " + webinarDescription, 30000, 'trustedHtml');
                        }, 300);
                        //call set toaster method again after 6 hours so next week's content would display, calling the method again would set up the toaster for next week
                        $timeout(function () {
                            setWebinarToaster();
                        }, 6 * 60 * 60000);
                    }, webinarDay.getTime() - today.getTime());
                }
                else if (today.getTime() - webinarDay.getTime() < 60 * 60000) {
                    $scope.onlyNotification = $timeout(function () {
                        $timeout(function () {
                            toaster.pop("ticket_warning", $scope.translation.text.WEBINAR_SCHEDULE_NOTIFICATION, $scope.translation.text.WEBINAR_REMINDER_SHORTLY + " "
                                + webinarStartTimeConverted + "-" + webinarEndTimeConverted + '<br>' + $scope.translation.text.WEBINAR_TOPIC + " " + webinarDescription, 30000, 'trustedHtml');
                        }, 300);
                        //call set toaster method again after 6 hours so next week's content would display, calling the method again would set up the toaster for next week
                        $timeout(function () {
                            setWebinarToaster();
                        }, 6 * 60 * 60000);
                    }, 0);
                }

                //toaster for French webinar
                if ($scope.accountInfo.preferenceUser.lookupLanguageID == 4) {
                    var frenchWebinarSchedules = [
                        {
                            endTime: "3:00 PM",
                            startTime: "05/25/2021 2:00 PM"
                        },
                        {
                            endTime: "3:00 PM",
                            startTime: "06/01/2021 2:00 PM"
                        },
                        {
                            endTime: "3:00 PM",
                            startTime: "06/15/2021 2:00 PM"
                        },
                        {
                            endTime: "3:00 PM",
                            startTime: "06/22/2021 2:00 PM"
                        }
                    ]

                    var frenchWebinarFirst = new Date(new Date(frenchWebinarSchedules[0].startTime).setHours(13, 0, 0, 0));
                    var frenchWebinarSecond = new Date(new Date(frenchWebinarSchedules[1].startTime).setHours(13, 0, 0, 0));
                    var frenchWebinarThird = new Date(new Date(frenchWebinarSchedules[2].startTime).setHours(13, 0, 0, 0));
                    var frenchWebinarFourth = new Date(new Date(frenchWebinarSchedules[3].startTime).setHours(13, 0, 0, 0));

                    var webinarDayFrench = new Date();

                    if (today.getTime() <= frenchWebinarFirst.getTime()) {
                        webinarDayFrench = frenchWebinarFirst;
                    }
                    else if (frenchWebinarFirst.getTime() < today.getTime() && today.getTime() <= frenchWebinarSecond.getTime()) {
                        webinarDayFrench = frenchWebinarSecond;
                    }
                    else if (frenchWebinarSecond.getTime() < today.getTime() && today.getTime() <= frenchWebinarThird.getTime()) {
                        webinarDayFrench = frenchWebinarThird;
                    }
                    else {
                        webinarDayFrench = frenchWebinarFourth;
                    }

                    var currentMonth = today.getMonth() + 1;
                    //only need the following logic as for now French Webinar is only held at May and June
                    var frenchWebinarMonth = currentMonth == 5 || currentMonth == 6 ? true : false;
                    if (!frenchWebinarMonth) return;

                    var webinarDescriptionFrench = "Quelques-un des sujets que nous aborderons sont:\
                        - Les évolutions des réseaux cellulaires et nos réactions face à ces derniers\
                        - Les différentes applications du système\
                        - Les façons d'aller chercher vos données\
                        - Les alarmes, des plus simples au plus complexes\
                        - Les problèmes les plus fréquents, comment les prévenir.\
                        - Le nouvel enregistreur de débordements"

                    var placeHolderFrench = new Date(webinarDayFrench.getTime());
                    var prevWebinarDayFrench = new Date(new Date(placeHolderFrench.setDate(webinarDayFrench.getDate() - 1)).setHours(12, 0, 0, 0));

                    var webinarStartTimeConvertedFrench = webinarStartTimeConverted;
                    var webinarEndTimeConvertedFrench = webinarEndTimeConverted;

                    if (today.getTime() <= prevWebinarDayFrench.getTime()) {
                        $scope.firstNotificationFrench = $timeout(function () {
                            $timeout(function () {
                                toaster.pop("ticket_warning", $scope.translation.text.WEBINAR_SCHEDULE_NOTIFICATION, $scope.translation.text.WEBINAR_REMINDER_DAY + " "
                                    + webinarStartTimeConvertedFrench + "-" + webinarEndTimeConvertedFrench + '<br>' + $scope.translation.text.WEBINAR_TOPIC + " " + webinarDescriptionFrench, 30000, 'trustedHtml');
                            }, 300);
                        }, prevWebinarDayFrench.getTime() - today.getTime());
                        $scope.secondNotificationFrench = $timeout(function () {
                            $timeout(function () {
                                toaster.pop("ticket_warning", $scope.translation.text.WEBINAR_SCHEDULE_NOTIFICATION, $scope.translation.text.WEBINAR_REMINDER_HOUR + " "
                                    + webinarStartTimeConvertedFrench + "-" + webinarEndTimeConvertedFrench + '<br>' + $scope.translation.text.WEBINAR_TOPIC + " " + + webinarDescriptionFrench, 30000, 'trustedHtml');
                            }, 300);
                            //call set toaster method again after 6 hours so next week's content would display, calling the method again would set up the toaster for next week
                            $timeout(function () {
                                setWebinarToaster();
                            }, 6 * 60 * 60000);
                        }, webinarDayFrench.getTime() - today.getTime());
                    }
                    else if (today.getTime() <= webinarDayFrench.getTime()) {
                        $scope.onlyNotificationFrench = $timeout(function () {
                            $timeout(function () {
                                toaster.pop("ticket_warning", $scope.translation.text.WEBINAR_SCHEDULE_NOTIFICATION, $scope.translation.text.WEBINAR_REMINDER_HOUR + " "
                                    + webinarStartTimeConvertedFrench + "-" + webinarEndTimeConvertedFrench + '<br>' + $scope.translation.text.WEBINAR_TOPIC + " " + webinarDescriptionFrench, 30000, 'trustedHtml');
                            }, 300);
                            //call set toaster method again after 6 hours so next week's content would display, calling the method again would set up the toaster for next week
                            $timeout(function () {
                                setWebinarToaster();
                            }, 6 * 60 * 60000);
                        }, webinarDayFrench.getTime() - today.getTime());
                    }
                    else if (today.getTime() - webinarDayFrench.getTime() < 60 * 60000) {
                        $scope.onlyNotificationFrench = $timeout(function () {
                            $timeout(function () {
                                toaster.pop("ticket_warning", $scope.translation.text.WEBINAR_SCHEDULE_NOTIFICATION, $scope.translation.text.WEBINAR_REMINDER_SHORTLY + " "
                                    + webinarStartTimeConvertedFrench + "-" + webinarEndTimeConvertedFrench + '<br>' + $scope.translation.text.WEBINAR_TOPIC + " " + webinarDescriptionFrench, 30000, 'trustedHtml');
                            }, 300);
                            //call set toaster method again after 6 hours so next week's content would display, calling the method again would set up the toaster for next week
                            $timeout(function () {
                                setWebinarToaster();
                            }, 6 * 60 * 60000);
                        }, 0);
                    }
                }

            }, function (error) {
                console.log("error", error);
                toaster.pop("ticket_warning", $scope.translation.text.WEBINAR_SCHEDULE_NOTIFICATION, $scope.translation.text.WEBINAR_UNAVAILABLE, 30000, 'trustedHtml');
            });
        }

        ////////////////////////////////////////////////////////////////////////
        var setMissionAcquisitionToaster = function () {

            $timeout(function () {
                if (!$scope.accountInfo.optOutTASIToaster) {
                    var msgObj = { TASIToaster: true, customerId: $scope.accountInfo.customerId, loginId: $scope.accountInfo.userId };
                    toaster.pop('info', "Mission Joins TASI Group", "", 60000, 'trustedHtml', null, null, msgObj);
                }
            }, 300);
        };

        //////////////////////////////////////////////////////////////////////
        var iconClasses = [
            {
                "id": 1,
                "description": "error"
            },
            {
                "id": 2,
                "description": "info"
            },
            {
                "id": 3,
                "description": "wait"
            },
            {
                "id": 4,
                "description": "success"
            },
            {
                "id": 5,
                "description": "warning"
            },
            {
                "id": 6,
                "description": "weather_warning"
            },
            {
                "id": 7,
                "description": "weather_watch"
            },
            {
                "id": 8,
                "description": "weather_advisory"
            },
            {
                "id": 9,
                "description": "ticket_warning"
            },
            {
                "id": 10,
                "description": "offline_warning"
            },
            {
                "id": 11,
                "description": "announcement"
            }
        ];

        var internalViews = [
            {
                "id": 1,
                "viewname": "Alarm History",
                "description": "Alarm History"
            },
            {
                "id": 2,
                "viewname": "Alert History Report",
                "description": "Alert History"
            },
            {
                "id": 3,
                "viewname": "Audit History",
                "description": "Audit History"
            },
            {
                "id": 4,
                "viewname": "Paging Log",
                "description": "Command Log"
            },
            {
                "id": 5,
                "viewname": "Cumulative Flow Reading",
                "description": "Cumulative Flow Reading"
            },
            {
                "id": 6,
                "viewname": "Daily Station Summary",
                "description": "Daily Station Summary"
            },
            {
                "id": 7,
                "viewname": "Delayed Alarm History Report",
                "description": "Delayed Alarm History"
            },
            {
                "id": 8,
                "viewname": "Disabled Inputs Report",
                "description": "Disabled Input"
            },
            {
                "id": 9,
                "viewname": "Integrated Flow Report",
                "description": "Integrated Flow"
            },
            {
                "id": 10,
                "viewname": "Management Report",
                "description": "Management Report"
            },
            {
                "id": 11,
                "viewname": "Pump Alarm Data",
                "description": "Pump Alarm Data"
            },
            {
                "id": 12,
                "viewname": "Pump Service Report",
                "description": "Pump Service Report"
            },
            {
                "id": 13,
                "viewname": "Radio Upgrades",
                "description": "Radio Upgrades Report"
            },
            {
                "id": 14,
                "viewname": "Runtime Daily Report",
                "description": "Runtime Daily"
            },
            {
                "id": 15,
                "viewname": "Runtime Multi Day Report",
                "description": "All RTU Multi Day"
            },
            {
                "id": 16,
                "viewname": "Runtime Monthly Report",
                "description": "Runtime Monthly"
            },
            {
                "id": 17,
                "viewname": "Runtime Variance",
                "description": "Runtime Variance"
            },
            {
                "id": 18,
                "viewname": "Site Access Report",
                "description": "Site Access"
            },
            {
                "id": 19,
                "viewname": "SSO CSO Report",
                "description": "SSO CSO Report"
            },
            {
                "id": 20,
                "viewname": "Unit Check In Report",
                "description": "Unit Check In"
            },
            {
                "id": 21,
                "viewname": "Untested Wet Well Inputs",
                "description": "Untested Wet Well Inputs"
            },
            {
                "id": 22,
                "viewname": "User Login Report",
                "description": "User Login"
            },
            {
                "id": 23,
                "viewname": "Pulse Flow Multi Day Report",
                "description": "Pulse Flow Multi Day Report"
            }
        ]

        var initiateToasterMaster = function () {
            toasterMasterService.ListToasterMessages($scope.accountInfo.userId, false).then(function (result) {
                var toasterMessages = result.data;
                for (var i = 0; i < toasterMessages.length; i++) {
                    for (var j = 0; j < iconClasses.length; j++) {
                        if (toasterMessages[i].iconClassID == iconClasses[j].id) {
                            toasterMessages[i].iconClass = iconClasses[j].description;
                            break;
                        }
                    }
                    for (var k = 0; k < internalViews.length; k++) {
                        if (toasterMessages[i].internalLinkID == internalViews[k].id) {
                            toasterMessages[i].internalLink = internalViews[k].viewname;
                            toasterMessages[i].internalLinkDescription = internalViews[k].description;
                            break;
                        }
                    }
                    if (toasterMessages[i].isActive) {
                        var msgObj = {
                            isToasterMaster: true, toasterMessageId: toasterMessages[i].toasterMessageID,
                            customerId: $scope.accountInfo.customerId, loginId: $scope.accountInfo.userId,
                            internalLink: toasterMessages[i].internalLink, externalLink: toasterMessages[i].externalLink, internalLinkDescription: toasterMessages[i].internalLinkDescription,
                            externalLinkLabel: toasterMessages[i].externalLinkLabel, canAcknowledge: toasterMessages[i].canAcknowledge
                        };
                        if (toasterMessages[i].iconClass == null) toasterMessages[i].iconClass = "info";
                        var today = new Date();
                        if (toasterMessages[i].startDate != null) {
                            var startDate = new Date(datetimeService.UtcToLocalByTimeZone(toasterMessages[i].startDate, $scope.accountInfo.timeZone));
                            startDate.setHours(0, 0, 0, 0);
                            if (toasterMessages[i].endDate != null) {
                                var endDate = new Date(datetimeService.UtcToLocalByTimeZone(toasterMessages[i].endDate, $scope.accountInfo.timeZone));
                                endDate.setHours(23, 59, 59, 999);
                                if (startDate <= today && today <= endDate) {
                                    toaster.pop(toasterMessages[i].iconClass, toasterMessages[i].messageHeader, toasterMessages[i].messageContent, toasterMessages[i].displayTimerID, 'trustedHtml', null, null, msgObj);
                                }
                            }
                            else {
                                if (startDate <= today) {
                                    toaster.pop(toasterMessages[i].iconClass, toasterMessages[i].messageHeader, toasterMessages[i].messageContent, toasterMessages[i].displayTimerID, 'trustedHtml', null, null, msgObj);
                                }
                            }
                        }
                        else {
                            if (toasterMessages[i].endDate != null) {
                                var endDate = new Date(datetimeService.UtcToLocalByTimeZone(toasterMessages[i].endDate, $scope.accountInfo.timeZone));
                                endDate.setHours(23, 59, 59, 999);
                                if (today <= endDate) {
                                    toaster.pop(toasterMessages[i].iconClass, toasterMessages[i].messageHeader, toasterMessages[i].messageContent, toasterMessages[i].displayTimerID, 'trustedHtml', null, null, msgObj);
                                }
                            }
                            else {
                                toaster.pop(toasterMessages[i].iconClass, toasterMessages[i].messageHeader, toasterMessages[i].messageContent, toasterMessages[i].displayTimerID, 'trustedHtml', null, null, msgObj);
                            }
                        }


                    }
                }
            }, function (error) {
                console.log("error");
            });
        }
        /////////////////////////////////////////////////////////////////////

        var getMonthWeek = function () {
            //var date = new Date();
            //var adjustedDate = date.getDate() + date.getDay();
            //var prefixes = ['0', '1', '2', '3', '4', '5'];
            //return (parseInt(prefixes[0 | adjustedDate / 7]) + 1);
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
            return Math.ceil((date.getDate() + firstDay) / 7);
        }

        var convertDateString = function (dateObject) {
            var timezoneArray = dateObject.toTimeString().match(/\((.+)\)/)[1].split(' ');
            var timezone = '';
            timezoneArray.forEach(function (element) {
                timezone += element.charAt(0);
            });

            var month = dateObject.getMonth() + 1;
            month = month < 10 ? ('0' + month) : month.toString();

            var date = dateObject.getDate() < 10 ? ('0' + dateObject.getDate()) : dateObject.getDate().toString();
            var hour = dateObject.getHours() < 10 ? ('0' + dateObject.getHours()) : dateObject.getHours().toString();
            var min = dateObject.getMinutes() < 10 ? ('0' + dateObject.getMinutes()) : dateObject.getMinutes().toString();
            //var sec = dateObject.getSeconds() < 10 ? ('0' + dateObject.getSeconds()) : dateObject.getSeconds().toString();

            //var output = month + '/' + date + '/' + dateObject.getFullYear() + ' ' + hour + '/' + min + '/' + sec + ' ' + tz;
            var output = month + '/' + date + '/' + dateObject.getFullYear() + ' ' + hour + ':' + min + ' ' + timezone;
            return output;
        };

        $rootScope.$on('ItHasPumpStation', function (event, args) {
            $scope.accountInfo.hasPumpStation = true;
            checkIfPumpStation();
        });

        var checkIfMyLevel = function () {
            $scope.hasMyLevel = $scope.accountInfo.hasMyLevel;
        };

        var checkIfPumpStation = function () {
            $scope.hasPumpStation = $scope.accountInfo.hasPumpStation;
        };

        checkIfPumpStation();
        checkIfMyLevel();

        $timeout(function () {

            setTwitterToaster();

            //setWebinarToaster();

            //if (!$scope.isCanadianCustomer)setRadioUpgradeToaster();

            setMissionAcquisitionToaster();

            initiateToasterMaster();

        }, 0);

    }]);

mcapp.controller('angularFeedbackController', ['$scope', 'angularBootstrapFeedbackFactory', 'HOST', 'authenticationService', '$http', '$timeout', 'toaster',

    function ($scope, feedbackFactory, HOST, authenticationService, $http, $timeout, toaster) {
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.image = null;
        $scope.fbc.comments = null;
        $scope.includeScreenshot = false;

        $scope.options = {
            modalTitle: 'Feedback',
            takeScreenshotButtonText: "Take screenshot",
            submitButtonText: "Submit",
            sendFeedbackButtonText: "Send Feedback",
            cancelScreenshotOptionsButtonText: "Cancel",
            takeScreenshotOptionsButtonText: "Take Screenshot",
            takeScreenshotButtonPressed: takeScreenshotButtonPressed,
            submitButtonPressed: submitButtonPressed,
            sendFeedbackButtonPressed: sendFeedbackButtonPressed,
            cancelScreenshotOptionsButtonPressed: cancelScreenshotOptionsButtonPressed,
            takeScreenshotOptionsButtonPressed: takeScreenshotOptionsButtonPressed,
            screenshotTaken: screenshotTaken,
            highlightDrawn: highlightDrawn,
            modalDismissed: modalDismissed
        };

        $scope.getScreenShot = function () {
            $scope.includeScreenshot = !$scope.includeScreenshot;
            var tmpColor = "rgba(0, 0, 0, 0)";
            var dskColor = "#258bd5";
            if ($scope.includeScreenshot) {
                if ($("body").css("background-color") === tmpColor) $("body").css("background-color", dskColor);
                $("#feedback-screenshot-img").css("visibility", "initial");
                feedbackFactory.takeScreenshot();
                $timeout(function () { $("body").css("background-color", ""); }, 3000);
            } else {
                $scope.image = null;
                feedbackFactory.resetScreenshot();
                $("#feedback-screenshot-img").css("visibility", "hidden");
            }
        };

        function takeScreenshotButtonPressed() { }
        function submitButtonPressed(form) {
            var _jiraIssue = { customerId: $scope.accountInfo.customerId, inputComments: $scope.fbc.comments, inputAttachmentImgBase64: $scope.image };
            _postData($scope.accountInfo.customerId, _jiraIssue)
                .then(function (data) {
                    toaster.pop('success', "Feedback received!", "", 5000, 'trustedHtml');
                }
                    , function (error) {
                        toaster.pop('error', "Feedback not received!", "", 5000, 'trustedHtml');
                    });
        }
        function sendFeedbackButtonPressed() { }
        function cancelScreenshotOptionsButtonPressed() { $scope.image = null; }
        function takeScreenshotOptionsButtonPressed() { }
        function screenshotTaken(image, canvas) { $scope.image = image; }
        function highlightDrawn(element) { }
        function modalDismissed() { $scope.image = null; $scope.fbc.comments = null; $scope.includeScreenshot = false; }

        var _postData = function (customerId, _jiraIssue) {
            feedbackFactory.closeModal();
            return $http.post(HOST + "/api/Jira?customerId=" + customerId, _jiraIssue);
        };
    }]);

mcapp.directive('desktopIcons', ['desktopViewListService', 'desktopViewService', 'preferencesService', 'toaster', '$timeout', 'accountWorkflowService', '$rootScope', 'translationService', 'debounceService', 'AlarmFactory', '$interval', 'sharedSetupService', function (desktopViewListService, desktopViewService, preferencesService, toaster, $timeout, accountWorkflowService, $rootScope, translationService, debounceService, AlarmFactory, $interval, sharedSetupService) {
    return {
        // A = attribute, E = Element, C = Class and M = HTML Comment
        restrict: 'A',
        //The link function is responsible for registering DOM listeners as well as updating the DOM.
        link: function (scope, element, attrs) {

            //Open default desktop only once
            var onlyOnceDone = false;
            scope.isActiveAlarm = false;
            scope.isMcAdmin = sharedSetupService.mcAdmin();
            scope.isAdmin = sharedSetupService.isAdmin(scope.accountInfo);
            scope.isAlarmUser = sharedSetupService.isAlarmUser(scope.accountInfo);

            var _isActiveAlarm = function () {
                AlarmFactory.isActiveAlarm(scope.accountInfo.customerId)
                .then(function (dataFromFactory) {
                    scope.isActiveAlarm = dataFromFactory.data;
                });
            };

            var _getDefaultDesktopID = function () {
                preferencesService.getPreferenceUser(scope.accountInfo.userId, scope.accountInfo.customerId)
                .then(function (result) {
                    scope.defaultDesktopID = result.data.defaultDesktopID;
                }, function (error) {
                    //$scope.status = 'Unable to load User preference data: ' + error.message;
                });
            };

            var _getDefaultDesktop = function () {
                if (!($rootScope.mobile || $rootScope.classicView)) {

                    if (onlyOnceDone) return;
                    onlyOnceDone = true;

                    //Check if desktop exists/has not been deleted
                    var desktopOpenDone = false;

                    scope.desktopViews.map(function (desktop) {
                        if (desktop.defaultDesktop) {
                            desktopOpenDone = true;
                            scope.selectedDesktopId = desktop.desktopId;
                            scope.openDesktopView(desktop.desktopId);
                        }
                    });
                   
                    if (!desktopOpenDone && scope.defaultDesktopID < 0) {
                        switch (scope.defaultDesktopID) {
                            case -3:
                                scope.openView('Map', { width: 900, height: 500 }, { my: 'right-10 top+10', at: 'right top', of: window }, {}, { minimumWidth: 500, minimumHeight: 500 });
                                if (scope.accountInfo.preferenceUser.i18nCode == "fr") // provide more height for french
                                    scope.openView('Welcome To Scada', { width: 700, height: 510 }, { my: 'top+120', at: 'center top', of: window }, {}, { minimumWidth: 700, minimumHeight: 510 }, true);
                                else
                                    scope.openView('Welcome To Scada', { width: 700, height: 480 }, { my: 'top+120', at: 'center top', of: window }, {}, { minimumWidth: 700, minimumHeight: 480 }, true);

                                break;

                            case -2:
                                scope.openView('Map', { width: 900, height: 500 }, { my: 'right-10 top+10', at: 'right top', of: window }, {}, { minimumWidth: 500, minimumHeight: 500 });
                                break;

                            case -1:
                                scope.openView('Dashboard', { width: 750, height: 450 }, { my: 'right-10 top+10', at: 'right top', of: window }, {}, { minimumWidth: 500, minimumHeight: 100 });
                                break;
                        }
                    }
                }
            }

            var getDefaultDesktopDebounced = debounceService(_getDefaultDesktop, 1000, false);

            var _runAccountWorkFlowService = function () {
                //for mobile view we initialize accountWorkflowService in main-menu-mobile-module.js
                if ($rootScope.mobile) return;
                //launch update username & password etc views
                accountWorkflowService.init(); //initialize the account workflow service
                accountWorkflowService.launchView();
            }

            var _activeDesktopViews = function (desktopViews) {
                var arr = desktopViews;
                var index = arr.findIndex(function (element) {
                    return element.displayIcon == 1;
                });
                if (index !== -1) {
                    scope.activeDesktop = true;
                }
            };

            _getDesktops = function () {
                desktopViewListService.getData(scope.accountInfo.customerId)
                    .then(function (response) {
                        scope.desktopViews = response.data.desktopViews;
                        scope.desktopBusy = false;
                        _activeDesktopViews(scope.desktopViews);
                        if (angular.isDefined(scope.translation)) {
                            _runAccountWorkFlowService();
                        } else {
                            translationService.loadLanguage(true)
                                .then(function (result) {
                                    scope.translation = translationService.translation;
                                    _runAccountWorkFlowService();
                                }, function (error) {
                                    console.log("error");
                                });
                        }
                    },
                        function (error) {
                            scope.desktopBusy = false;
                            var errormsg = eval("scope.translation.message." + error.data.message);
                            scope.alerts.push({ msg: errormsg, type: "danger" });
                            toaster.pop('error', scope.windowTitle, errormsg);
                        });
            };

            scope.$watch('desktopViewCheck', function (newValue, oldValue) {
                if (newValue > 0 && newValue != oldValue) {
                    _getDesktops();
                }
            }, true);

            angular.element(document).ready(function () {
                $timeout(function () { 
                    if((scope.isAdmin || scope.isAlarmUser) && $rootScope.mobile){
                        _isActiveAlarm();
                        //scope.setIntervalIsActiveAlarm = $interval( function () {_isActiveAlarm()}, 60000); //set the interval for is any active alarms
                    }
                    _getDesktops();
                }, 500);
            });

            scope.$on("$destroy", function () {
                // if((scope.isAdmin || scope.isAlarmUser) && $rootScope.mobile){
                //     $interval.cancel(scope.setIntervalIsActiveAlarm);
                // }
                scope.closeAllViews();
            });

            scope.$on('openDefaultDesktop', function () {
                // Refresh Default Desktop ID 
                _getDefaultDesktopID();
                getDefaultDesktopDebounced();
            });

            //$timeout(function () {
            //    //launch wizard splash if Status is NOT Skipped(1)/Complete(2)
            //    if (!scope.mobile && !scope.classicView && scope.accountInfo.wizardStatusId > 2) {
            //        scope.openView('Wizard Splash', { width: 770, height: 435 }, { my: 'top+120', at: 'center top', of: window }, { deviceId: 2 }, { minimumWidth: 750, minimumHeight: 350 }, true);
            //    }
            //}, 0);
        }
    };
}]);

mcapp.factory('ticketAlertService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/TicketAlert?' + varParm,
                cache: false
            });
        }
    };
}]);

mcapp.factory("customerExtService", ["$http", "HOST", function ($http, HOST) {
    var customerExtFactory = {};

    var _deleteData = function (customerId) {
        return $http.delete(HOST + '/api/CustomerExt?customerId=' + customerId);
    };

    var _updateLogoSize = function (customerId, logoSizeId) {
        return $http.put(HOST + '/api/CustomerExt?customerId=' + customerId + '&logoSizeId=' + logoSizeId);
    };

    var _updateNotificationMode = function (customerId, notificationMode, logoSizeId) {
        return $http.put(HOST + '/api/CustomerExt?customerId=' + customerId + '&notificationMode=' + notificationMode + '&logoSizeId=' + logoSizeId);
    };

    var _getDaysPastDue = function (customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/CustomerExt/GetDaysPastDue?customerId=' + customerId,
            cache: true,
            async: false
        });
    };

    customerExtFactory.updateLogoSize = _updateLogoSize;
    customerExtFactory.updateNotificationMode = _updateNotificationMode;
    customerExtFactory.deleteData = _deleteData;
    customerExtFactory.getDaysPastDue = _getDaysPastDue;

    return customerExtFactory;
}]);

mcapp.factory('mcApplicationVersionAlertService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: 'McApplicationVersion.html?' + varParm,
                cache: false
            });
        }
    };
}]);

mcapp.factory('systemAlertMessageService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/SystemAlertMessage?' + varParm,
                cache: false
            });
        }
    };
}]);
"use strict";

angular.module("mc.destinations", []);
'use strict';

function DestinationsFactory(HOST, $http, $rootScope) {

    // instantiate our initial object
    var Destinations = function Destinations(customerId) {
        this.customerId = customerId;
    };

    Destinations.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + '/api/Destinations' + '?customerId=' + this.customerId).then(function (response) {
            self.serviceUsers = response.data;
            self.loading = false;
            return response;
        });
    };

    Destinations.prototype.postData = function (serviceUser) {
        var self = this;
        return $http.post(HOST + '/api/Destinations' + '?customerId=' + this.customerId, serviceUser).then(function (response) {
            self.newUser = response.data;
            self.loading = false;
            $rootScope.$broadcast('destinationsPatch');
            return response;
        });
    };

    Destinations.prototype.patchData = function (serviceUserId, serviceUserPatch) {
        var self = this;
        return $http.patch(HOST + '/api/Destinations' + '?customerId=' + this.customerId + '&serviceUserId=' + serviceUserId, serviceUserPatch).then(function (response) {
            self.currentUser = response.data;
            self.loading = false;
            $rootScope.$broadcast('destinationsPatch');
            return response;
        });
    };

    Destinations.prototype.deleteData = function (serviceUserId) {
        var self = this;
        return $http.delete(HOST + '/api/Destinations' + '?customerId=' + this.customerId + '&serviceUserId=' + serviceUserId).then(function (response) {
            self.dataBack = response.data;
            self.loading = false;
            return response;
        });
    };

    Destinations.prototype.listRuleIdsByServiceUserIdCustomerId = function (serviceUserId) {
        var self = this;
        return $http.get(HOST + '/api/Destinations' + '?customerId=' + this.customerId + '&serviceUserId=' + serviceUserId).then(function (response) {
            self.ruleIdList = response.data;
            self.loading = false;
            return response;
        });
    };

    /////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////

    Destinations.prototype.checkDm = function (destinationMethodCheck) {
        var self = this;
        return $http.post(HOST + '/api/DestinationMethodCheck' + '?customerId=' + this.customerId, destinationMethodCheck).then(function (response) {
            self.newDM = response.data;
            self.loading = false;
            return response;
        });
    };

    /////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////

    return Destinations;
}

DestinationsFactory.$inject = ['HOST', '$http', '$rootScope'];

angular.module('mc.destinations').factory('DestinationsFactory', DestinationsFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function DestinationsController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, DestinationsFactory, $timeout, $filter, toaster, $uibModal, wizardSplashService, unsavedChangesService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.voiceTypes = [];
    ctrl.emailTypes = [];
    ctrl.languages = [];
    ctrl.countryCodes = [];
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.editMode = null;
        ctrl.addMode = null;
        ctrl.myModalTemplate = null;
        ctrl.textEmailDomains = ['txt.att.net', 'txt.bell.ca', 'gocbw.com', 'msg.iridium.com', 'messaging.nextel.com', 'pcs.rogers.com', 'messaging.sprintpcs.com', 'tmomail.net', 'vtext.com', 'email.uscc.net', 'msg.telus.com'];
        ctrl.SMSExample = "<div align='left'>AT&amp;T: 10digitnumber@txt.att.net<br>\
        Bell Mobility (Canada): 10digitnumber@txt.bell.ca<br>\
        Cincinnati Bell: 10digitnumber@gocbw.com<br>\
        Iridium: 10digitnumber@msg.iridium.com<br>\
        Nextel: 10digitnumber@messaging.nextel.com<br>\
        Rogers&nbsp;Wireless&nbsp;(Canada):&nbsp;10digitnumber@pcs.rogers.com<br>\
        Sprint: 10digitnumber@messaging.sprintpcs.com<br>\
        T-Mobile: 10digitnumber@tmomail.net<br>\
        Verizon: 10digitnumber@vtext.com<br>\
        US Cellular: 10digitnumber@email.uscc.net<br>\
        Telus:10digitnumber@msg.telus.com</div>";
        ctrl.accountInfo = authenticationService.getAccountInfo();
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        ctrl.initializeSetting();
        ctrl.getDestinations();

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl._popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl._popup);

            ctrl._popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                },
                resizeStop: function resizeStop(event, ui) {
                    ctrl.adjustSizeAgain();
                    $('#map').removeClass('no-events');
                }
            });

            ctrl._popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl._popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl._popup);
                    ctrl.adjustSize();
                }
            });

            $timeout(function () {
                ctrl.adjustSize(15);
            }, 500);

            // binding 'dialogbeforeclose' event to Check for unsaved Changes function
            $(ctrl._popup).on('dialogbeforeclose', function (event) {
                unsavedChangesService.checkUnsavedChanges(event, ctrl._popup, _this2, ctrl.addMode == -1);
            });
        }
    };

    ctrl.adjustSize = function (varAdjust) {
        var _newHeight = ctrl._popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl._popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "");
        ctrl._popup.parent().find('div:eq(2)').css("width", ctrl._popup.parent().css("width"));
        ctrl._popup.parent().find('div:eq(2)').css("min-width", ctrl._popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl._popup.parent().find('div:eq(2)').css("height", _newHeight);
        ctrl._popup.parent().find('.tabular-data-container').css("height", _newHeight - (varAdjust ? varAdjust : 0));
    };

    ctrl.adjustSizeAgain = function () {
        ctrl.adjustSize(15);
    };

    ctrl.$onDestroy = function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    };

    ctrl.deleteDestination = function (item) {
        function modalController($uibModalInstance, translation) {

            this.translation = translation;
            this.tmpConfirmMessageA = item.inUse ? _translation.text.DELETE_SERVICE_USER2 : "";
            this.tmpConfirmMessageB = _translation.text.DELETE_SERVICE_USER + ", " + (item.firstName + ' ' + item.lastName) + "?";

            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        if (item.inUse) {
            var _destinations = new DestinationsFactory(ctrl.accountInfo.customerId);
            _destinations.listRuleIdsByServiceUserIdCustomerId(item.serviceUserId).then(function () {
                ctrl.ruleIdList = _destinations.ruleIdList;
            });
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return _this2.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            var _destinations = new DestinationsFactory(ctrl.accountInfo.customerId);
            _destinations.deleteData(item.serviceUserId).then(function () {

                var index = ctrl.serviceUsers.indexOf(item);
                if (index !== -1) {
                    ctrl.serviceUsers.splice(index, 1);
                }

                ctrl.addMode = null;
                ctrl.editMode = null;

                if (item.inUse) {
                    $rootScope.$broadcast('removeNotificationDestination', ctrl.ruleIdList);
                }
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.NOTIFICATION_DESTINATIONS, "Check " + translationService.translation.text.NOTIFICATION_SCHEDULE + " setting! Still working on...");
            });
        }, function () {
            // cancel button
        });
    };

    var _voiceTypes = function _voiceTypes() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.voiceTypes.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.voiceTypes.push(arguments[i]);
            } else {
                ctrl.voiceTypes[i].name = arguments[i].name;
            }
        }
    };

    var _emailTypes = function _emailTypes() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.emailTypes.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.emailTypes.push(arguments[i]);
            } else {
                ctrl.emailTypes[i].name = arguments[i].name;
            }
        }
    };

    var _languages = function _languages() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.languages.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.languages.push(arguments[i]);
            } else {
                ctrl.languages[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        _voiceTypes({
            "id": 12,
            "name": ctrl.translation.text.VOICE_SHORT_NAME
        }, {
            "id": 11,
            "name": ctrl.translation.text.VOICE_STANDARD_NAME
        }, {
            "id": 13,
            "name": ctrl.translation.text.VOICE_SHORT_9_NAME
        }, {
            "id": 15,
            "name": ctrl.translation.text.VOICE_SHORT_STAR_NAME
        }, {
            "id": 14,
            "name": ctrl.translation.text.VOICE_SHORT_NO_ACK_NAME
        });

        _emailTypes({
            "id": 1,
            "name": ctrl.translation.text.PLAIN_TEXT
        }, {
            "id": 2,
            "name": ctrl.translation.text.ALPHA_PAGER
        }, {
            "id": 6,
            "name": ctrl.translation.text.SHORT_ALPHA
        }, {
            "id": 4,
            "name": ctrl.translation.text.HTML
        });

        _languages({
            "id": 1,
            "name": ctrl.translation.text.ENGLISH
        }, {
            "id": 2,
            "name": ctrl.translation.text.FRENCH
        });
    };

    ctrl.getDestinations = function () {

        var _destinations = new DestinationsFactory(ctrl.accountInfo.customerId);

        _destinations.getData().then(function () {
            ctrl.destinations = _destinations;
            ctrl.serviceUsers = _destinations.serviceUsers.serviceUsers;
            ctrl.countryCodes = _destinations.serviceUsers.countryCodes;
            for (var i = 0; i < ctrl.serviceUsers.length; i++) {
                if (ctrl.serviceUsers[i].countryCode == null) {
                    ctrl.serviceUsers[i].countryCode = 1;
                }
                ctrl.serviceUsers[i].voiceType = ctrl.serviceUsers[i].voiceType_New;
                ctrl.serviceUsers[i].emailType = { id: ctrl.serviceUsers[i].emailType };
                ctrl.serviceUsers[i].languageId = { id: ctrl.serviceUsers[i].languageId };
                ctrl.serviceUsers[i].countryCode = { id: ctrl.serviceUsers[i].countryCode };
                //ctrl.serviceUsers[i].voiceNumber = ctrl.serviceUsers[i].voiceNumber.length > 10 && ctrl.serviceUsers[i].voiceNumber.charAt(0) == "1" ? ctrl.serviceUsers[i].voiceNumber.slice(1) : ctrl.serviceUsers[i].voiceNumber;
                //ctrl.serviceUsers[i].voiceNumberA = undefined ;
                //ctrl.serviceUsers[i].voiceNumberB = undefined;
                //ctrl.serviceUsers[i].voiceNumberC = undefined;
                ctrl.setVoiceABC(ctrl.serviceUsers[i]);
                ctrl.serviceUsers[i].fax = ctrl.serviceUsers[i].fax.length > 10 && ctrl.serviceUsers[i].fax.charAt(0) == "1" ? ctrl.serviceUsers[i].fax.slice(1) : ctrl.serviceUsers[i].fax;
                ctrl.serviceUsers[i].numericPager = ctrl.serviceUsers[i].numericPager.length > 10 && ctrl.serviceUsers[i].numericPager.charAt(0) == "1" ? ctrl.serviceUsers[i].numericPager.slice(1) : ctrl.serviceUsers[i].numericPager;
                ctrl.serviceUsers[i].voicePager = ctrl.serviceUsers[i].voicePager.length > 10 && ctrl.serviceUsers[i].voicePager.charAt(0) == "1" ? ctrl.serviceUsers[i].voicePager.slice(1) : ctrl.serviceUsers[i].voicePager;
            }
            for (var i = 0; i < ctrl.countryCodes.length; i++) {
                ctrl.countryCodes[i].name = "+" + ctrl.countryCodes[i].dialingCode + "    " + ctrl.countryCodes[i].country;
                ctrl.countryCodes[i].id = ctrl.countryCodes[i].countryCodeID;
            }
        });
    };

    ctrl.setVoiceABC = function (serviceUser) {
        var _tmpVoiceNumber = serviceUser.voiceNumber; //.length > 10 && serviceUser.voiceNumber.charAt(0) == "1" ? serviceUser.voiceNumber.slice(1) : serviceUser.voiceNumber;

        serviceUser.voiceNumberC = (_tmpVoiceNumber.match(/,/g) || []).length;
        serviceUser.voiceNumberA = _tmpVoiceNumber.replace(/\D/g, '').substring(0, 10);
        serviceUser.voiceNumberB = _tmpVoiceNumber.replace(/\D/g, '').substring(10);
        serviceUser.voiceNumber = _tmpVoiceNumber;
    };

    ctrl.editDestination = function (destination) {
        if (ctrl.editMode === null) ctrl.setVoiceABC(destination);
        ctrl.editMode = ctrl.editMode == destination.serviceUserId ? null : destination.serviceUserId;
    };

    ctrl.addDestination = function () {
        var newServiceUser = {
            customerId: ctrl.accountInfo.customerId,
            serviceUserId: -1,
            voiceType: { id: 12 },
            emailType: { id: 4 },
            languageId: { id: 1 },
            disabled: 0,
            voicePagerBdDelay: 1000,
            voiceNumberA: '',
            email: '',
            countryCode: { id: 1 },
            smsNumber: '',
            fax: '',
            numericPager: '',
            voicePager: '',
            //SCADA-4251: Destinations VXML Setting >> Causing speech server
            //to crash if the data for one of the properties is not provided
            gender: 'female',
            speed: '+0%',
            dtmfAndVoice: 0
        };
        ctrl.serviceUsers.unshift(newServiceUser);
        ctrl.addMode = -1;
        ctrl.editMode = null;
    };

    ctrl.saveDestination = function (item) {
        var _destinations = new DestinationsFactory(ctrl.accountInfo.customerId);
        ctrl.formatPhoneNumberSave(item); //NOT voiceNumber
        ctrl.setVoiceNumber(item); //voiceNumber only
        item.email = ctrl.checkEmail(item.email, item) ? "" : item.email; //email
        if (angular.isUndefined(item.lastName)) {
            item.lastName = " ";
            item.ttsLastName = " ";
        }
        if (!angular.isUndefined(item.voiceType)) item.voiceType = item.voiceType.id;
        if (!angular.isUndefined(item.emailType)) item.emailType = item.emailType.id;
        if (!angular.isUndefined(item.languageId)) item.languageId = item.languageId.id;
        if (!angular.isUndefined(item.countryCode)) item.countryCode = item.countryCode.id;
        _destinations.postData(item).then(function () {
            ctrl.serviceUsers[0] = _destinations.newUser;
            ctrl.serviceUsers[0].voiceType = ctrl.serviceUsers[0].voiceType_New;
            ctrl.serviceUsers[0].emailType = { id: ctrl.serviceUsers[0].emailType };
            ctrl.serviceUsers[0].languageId = { id: ctrl.serviceUsers[0].languageId };
            ctrl.serviceUsers[0].countryCode = { id: ctrl.serviceUsers[0].countryCode };
            ctrl.setVoiceABC(ctrl.serviceUsers[0]);
        });
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.closeModal = function (varDelete) {
        if (varDelete) {
            var _destinations = new DestinationsFactory(ctrl.accountInfo.customerId);
            _destinations.deleteData(ctrl.item.serviceUserId).then(function () {

                var index = ctrl.serviceUsers.indexOf(ctrl.item);
                if (index !== -1) {
                    ctrl.serviceUsers.splice(index, 1);
                }

                ctrl.addMode = null;
                ctrl.editMode = null;
            }, function (resp) {
                toaster.pop('error', translationService.translation.text.NOTIFICATION_DESTINATIONS, "Check " + translationService.translation.text.NOTIFICATION_SCHEDULE + " setting! Still working on...");
            });
        }
        ctrl.myModalTemplate = null;
    };
    //ctrl.deleteDestination = (item) => {
    //    ctrl.item = item;
    //    ctrl.tmpConfirmMessageA = item.inUse ? ctrl.translation.text.DELETE_SERVICE_USER2 : "";
    //    ctrl.tmpConfirmMessageB = ctrl.translation.text.DELETE_SERVICE_USER + ", " + $filter('filterLimitLength') (item.firstName + ' ' +item.lastName, 110) + "?";
    //    ctrl.myModalTemplate = "myModalTemplate.html";
    //};

    ctrl.cancelDestination = function (destination) {
        if (destination.serviceUserId === -1) ctrl.serviceUsers.splice(0, 1);
        ctrl.addMode = null;
        ctrl.editMode = null;
    };

    ctrl.formatPhoneNumberSave = function (o) {
        var f_val;
        //if (!angular.isUndefined(o.voiceNumber)) {
        //    f_val = o.voiceNumber.replace(/\D[^\.]/g, "");
        //    o.voiceNumber = f_val.length > 10 ? f_val : f_val.slice(0, 3) + "-" + f_val.slice(3, 6) + "-" + f_val.slice(6);
        //}

        var regexMobiFix = /(<([^>]+)>)/ig;

        if (!angular.isUndefined(o.fax)) {
            o.fax = o.fax.replace(regexMobiFix, "");
            f_val = o.fax.replace(/\D[^\.]/g, "");
            o.fax = f_val.length === 0 ? "" : f_val.slice(0, 3) + "-" + f_val.slice(3, 6) + "-" + f_val.slice(6);
        }
        if (!angular.isUndefined(o.numericPager)) {
            o.numericPager = o.numericPager.replace(regexMobiFix, "");
            f_val = o.numericPager.replace(/\D[^\.]/g, "");
            o.numericPager = f_val.length === 0 ? "" : f_val.slice(0, 3) + "-" + f_val.slice(3, 6) + "-" + f_val.slice(6);
        }
        if (!angular.isUndefined(o.voicePager)) {
            o.voicePager = o.voicePager.replace(regexMobiFix, "");
            f_val = o.voicePager.replace(/\D[^\.]/g, "");
            o.voicePager = f_val.length === 0 ? "" : f_val.slice(0, 3) + "-" + f_val.slice(3, 6) + "-" + f_val.slice(6);
        }
        if (!angular.isUndefined(o.smsNumber)) {
            o.smsNumber = o.smsNumber.replace(regexMobiFix, "");
            f_val = o.smsNumber.replace(/\D[^\.]/g, "");
            o.smsNumber = f_val.length === 0 ? "" : f_val.slice(0, 3) + "-" + f_val.slice(3, 6) + "-" + f_val.slice(6);
        }
    };

    ctrl.formatPhoneNumberPatch = function (item, propertyName) {
        switch (propertyName) {
            case "voiceNumber":
            case "fax":
            case "numericPager":
            case "voicePager":
            case "smsNumber":
                if (!angular.isUndefined(item[propertyName])) {
                    item[propertyName] = item[propertyName].replace(/\D[^\.]/g, "");
                    if (item[propertyName].length === 0) return "";
                    return item[propertyName].length > 10 ? item[propertyName] : item[propertyName].slice(0, 3) + "-" + item[propertyName].slice(3, 6) + "-" + item[propertyName].slice(6);
                }
                break;
            default:
                return item[propertyName];
        }
    };

    ctrl.formatPhoneNumberDisplay = function (f_val) {
        if (typeof f_val === "undefined") return f_val;
        f_val = f_val.replace(/\D/g, '');
        //f_val = f_val.substring(0, 1) == "1" ? f_val.substring(1, f_val.lenght) : f_val;
        f_val = f_val.length > 10 ? f_val.replace(/(\d{3})(\d{3})(\d{4})(\d{4})/, "($1) $2-$3 ext. $4") : f_val.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        return f_val;
    };

    ctrl.checkPhoneNumber = function (item) {
        return angular.isUndefined(item);
    };

    ctrl.checkEmail = function (item, dest) {
        ctrl.checkEmailPhoneDomain(item, dest);
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!angular.isUndefined(item) && item.length === 0) return false;
        return !re.test(item);
    };

    ctrl.checkEmailPhoneDomain = function (item, dest) {
        //Check email domain for 10 phone addresses   
        if (dest) {
            var emailSplit = item.split("@");
            if (emailSplit[1] && emailSplit[1].length) {
                for (var i = 0; i < ctrl.textEmailDomains.length; i++) {
                    var domain = ctrl.textEmailDomains[i];
                    //Check if domain matches
                    if (emailSplit[1].toLowerCase() == domain) {
                        //Check if email includes -
                        if (emailSplit[0].includes('-')) {
                            item = item.replace(/-/gi, '');
                        }
                        //update destination email address & email type to short alpha
                        dest.email = item;
                        dest.emailType = ctrl.emailTypes[2];
                        //check to patch emailType with not add mode
                        if (ctrl.addMode != -1) {
                            ctrl.updateEmailType = true;
                        }
                    }
                }
            }
        }
    };

    ctrl.firstNameToTts = function (item) {
        if (item.serviceUserId === -1) item.ttsFirstName = item.firstName;
    };

    ctrl.lastNameToTts = function (item) {
        if (item.serviceUserId === -1) item.ttsLastName = item.lastName;
        if (angular.isUndefined(item.lastName) || item.lastName == "") {
            item.lastName = " ";
            item.ttsLastName = " ";
        }
    };

    ctrl.patchData = function (item, propertyName, propertyNameOld) {
        if (item.serviceUserId === -1 || propertyNameOld !== null && item[propertyName] == item[propertyNameOld]) return false;
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName], item)) return false;
        if (item.notificationTypeInUse[propertyName] && item[propertyName].length === 0) {
            item[propertyName] = item[propertyNameOld];
            return false;
        }

        var regex = /(<([^>]+)>)/ig;

        switch (propertyName) {
            //case "voiceNumber":
            case "fax":
            case "numericPager":
            case "voicePager":
            case "smsNumber":
                item[propertyName] = item[propertyName].replace(regex, "");
                break;
        }

        item[propertyName] = ctrl.formatPhoneNumberPatch(item, propertyName);
        var tmpServiceUserPatch = { "op": "replace", "path": propertyName, "value": _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName] };
        var _destinations = new DestinationsFactory(ctrl.accountInfo.customerId);
        _destinations.patchData(item.serviceUserId, tmpServiceUserPatch).then(function () {
            //success, if updateEmailType run additional patch
            if (ctrl.updateEmailType) {
                ctrl.updateEmailType = false;
                ctrl.patchData(item, "emailType");
            }
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.NOTIFICATION_DESTINATIONS, "Update Error!");
        });
    };

    ctrl.patchVoiceNumber = function (item, propertyName, propertyNameOld, e) {
        var tmpElement = typeof e !== "undefined" ? e.target : "";
        if (tmpElement && $(tmpElement).val().replace(/\D/g, '') == "") $(tmpElement).val(""); //placeholder issue

        if (item.serviceUserId === -1 || propertyNameOld !== null && item[propertyName] == item[propertyNameOld]) return false;
        if (!ctrl.checkData(propertyName, _typeof(item[propertyName]) == "object" && item[propertyName] != null && typeof item[propertyName].id != "undefined" ? item[propertyName].id : item[propertyName], item)) return false;
        //item[propertyName] = ctrl.formatPhoneNumberPatch(item, propertyName);
        if (propertyName === "voiceNumberC" && parseInt(item.voiceNumberC, 10) > parseInt("15", 10)) item.voiceNumberC = "15";

        if (propertyName === "voiceNumberA" && (!angular.isDefined(item.voiceNumberA) || item.voiceNumberA.length === 0) && item.notificationTypeInUse.voice) {
            if (angular.isDefined(item.voiceNumberA) && item.voiceNumberA.length === 0) {
                item[propertyName] = item[propertyNameOld];
            }
            return false;
        }

        ctrl.setVoiceNumber(item);

        var tmpServiceUserPatch = { "op": "replace", "path": "voiceNumber", "value": item.voiceNumber };
        var _destinations = new DestinationsFactory(ctrl.accountInfo.customerId);
        _destinations.patchData(item.serviceUserId, tmpServiceUserPatch).then(function () {
            //success
        }, function (resp) {
            toaster.pop('error', translationService.translation.text.NOTIFICATION_DESTINATIONS, "Update Error!");
        });
    };

    ctrl.setVoiceNumber = function (item) {

        var regexMobiFix = /(<([^>]+)>)/ig;

        var _voiceNumberA = item.voiceNumberA.replace(regexMobiFix, "");;
        var _voiceNumberB = !angular.isUndefined(item.voiceNumberB) ? item.voiceNumberB.replace(regexMobiFix, "") : item.voiceNumberB;
        var _voiceNumberC = !angular.isUndefined(item.voiceNumberC) ? item.voiceNumberC.toString().replace(regexMobiFix, "") : item.voiceNumberC;

        if ((angular.isUndefined(_voiceNumberB) || _voiceNumberB.length === 0) && !angular.isUndefined(_voiceNumberA) && _voiceNumberA.length === 10) {
            item.voiceNumber = _voiceNumberA.slice(0, 3) + "-" + _voiceNumberA.slice(3, 6) + "-" + _voiceNumberA.slice(6);
            item.voiceNumberB = undefined;

            if (angular.isUndefined(_voiceNumberC) || _voiceNumberC.length === 0) {
                item.voiceNumberC = undefined;
            } else {
                item.voiceNumber = item.voiceNumber + Array(parseInt(_voiceNumberC) + 1).join(",");
            }
        } else if (!angular.isUndefined(_voiceNumberB) && _voiceNumberB.length > 0 && !angular.isUndefined(_voiceNumberC) && _voiceNumberC.length > 0 && !angular.isUndefined(_voiceNumberA) && _voiceNumberA.length === 10) {
            item.voiceNumber = _voiceNumberA + Array(parseInt(_voiceNumberC) + 1).join(",") + _voiceNumberB;
        } else if (!angular.isUndefined(_voiceNumberB) && _voiceNumberB.length > 0 && !angular.isUndefined(_voiceNumberA) && _voiceNumberA.length === 10) {
            item.voiceNumber = _voiceNumberA + Array(4 + 1).join(",") + _voiceNumberB;
        } else if (!angular.isUndefined(_voiceNumberC) && _voiceNumberC.length > 0 && !angular.isUndefined(_voiceNumberA) && _voiceNumberA.length === 10) {
            item.voiceNumber = _voiceNumberA.slice(0, 3) + "-" + _voiceNumberA.slice(3, 6) + "-" + _voiceNumberA.slice(6);
        } else if (angular.isUndefined(_voiceNumberA) || _voiceNumberA.length === 0) {
            item.voiceNumber = "";
        }
    };

    ctrl.checkData = function (propertyName, value, item) {
        switch (propertyName) {
            case "firstName":
            case "lastName":
            case "ttsFirstName":
            case "ttsLastName":
                return value.length > 0;
            case "languageId":
            case "disabled":
            case "voiceType":
            case "emailType":
            case "countryCode":
                return true;
            case "voiceNumberA":
            case "fax":
            case "numericPager":
            case "voicePager":
            case "smsNumber":
                return !ctrl.checkPhoneNumber(value);
            case "email":
                return !ctrl.checkEmail(value, item);
            case "voiceNumberB":
            case "voiceNumberC":
            case "gender":
            case "speed":
            case "dtmfAndVoice":
                return true;
            default:
                return false;
        }
    };

    ctrl.checkMethod = function (item, type) {
        var _sendType, _sendSubType, _sendData, _sendToPath, _methodDescription, _subRepType;

        switch (type) {
            case "voiceNumber":
                _sendType = 4;
                _sendSubType = 0;
                _sendToPath = item.voiceNumber;
                _sendData = "This is a test message to verify your phone number.";
                _methodDescription = "Phone";
                _subRepType = 0;
                break;
            case "fax":
                _sendType = 0;
                _sendSubType = 1;
                _sendToPath = item.fax;
                _sendData = "";
                _methodDescription = "Fax";
                _subRepType = 0;
                break;
            case "voicePager":
                _sendType = 0;
                _sendSubType = 1;
                _sendToPath = item.voicePager;
                _sendData = "";
                _methodDescription = "Voice Pager";
                _subRepType = 0;
                break;
            case "email":
                _sendType = 1;
                _sendSubType = 1;
                _sendToPath = item.email;
                _sendData = "This message is for " + item.firstName + " " + item.lastName + " at " + ctrl.accountInfo.customerName + ".";
                _methodDescription = "Email";
                _subRepType = item.emailType.id;
                break;
            case "numericPager":
                //not available for testing
                _sendType = 4;
                _sendSubType = 0;
                _sendToPath = item.popoverIsOpen3 ? item.fax : item.popoverIsOpen4 ? item.numericPager : item.popoverIsOpen5 ? item.voicePager : 0;
                _sendData = "This is a test message to verify your phone number.";
                if (item.email) {
                    _sendType = 1;
                    _sendSubType = 1;
                    _sendToPath = item.email;
                    _sendData = "This message is for " + item.firstName + " " + item.lastName + " at " + ctrl.accountInfo.customerName + ".";
                }
                _methodDescription = "Numeric Pager";
                _subRepType = 0;
                break;
            case "smsNumber":
                //SMS, not available for testing 
                _sendType = 18;
                _sendSubType = 0;
                _sendToPath = item.countryCode.id + item.smsNumber.replace(/[^0-9]/g, '');
                _sendData = "This is SMS test message to verify your phone number.";
                _methodDescription = "SMS";
                _subRepType = 0;
                break;
        }

        item.popoverIsOpen1 = false;
        item.popoverIsOpen2 = false;
        item.popoverIsOpen3 = false;
        item.popoverIsOpen4 = false;
        item.popoverIsOpen5 = false;

        var tmpDestinationMethodCheck = {
            DestinationMethodId: 0,
            CustomerId: ctrl.accountInfo.customerId,
            SendType: _sendType,
            SendSubType: _sendSubType,
            RepType: 200,
            SubRepType: _subRepType,
            AckRequired: 1,
            SendData: _sendData,
            SendTo: item.firstName + " " + item.lastName,
            SendToPath: _sendToPath,
            MethodDescription: _methodDescription
        };

        var _destinations = new DestinationsFactory(ctrl.accountInfo.customerId);

        _destinations.checkDm(tmpDestinationMethodCheck).then(function () {
            toaster.pop('success', "Destination Method Check", "Destination Method Check Sent.");
        }, function (err) {
            toaster.pop('error', "Destination Method Check", "Error!");
        });
    };

    ctrl.getTestHtml = function () {
        var testHtml = "<i class='fa fa-telegram clickable' style='font-size: 25px; color: lightslategrey; cursor: pointer;' title='" + ctrl.translation.text.TEST + "'></i>";
        return $sce.trustAsHtml(testHtml);
    };

    ctrl.dynamicPopover = {
        templateUrl: 'DestinationServiceUserPopoverTemplate.html'
    };

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.initializeSetting();
    });
};

DestinationsController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'DestinationsFactory', '$timeout', '$filter', 'toaster', '$uibModal', 'wizardSplashService', 'unsavedChangesService'];
'use strict';

angular.module('mc.destinations').component('destinations', {
    controller: DestinationsController,
    transclude: true,
    templateUrl: 'ui/destinations/destinations-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.device-management", []);
'use strict';

function DeviceManagementFactory(HOST, $http) {
    var deviceManagementService = function deviceManagementService() {};

    var _getData = function _getData(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/DeviceStatus',
            params: { customerId: customerId, getNetworkOperator: true },
            cache: false
        });
    };

    var _getDeviceStateData = function _getDeviceStateData(customerId, timeZone) {
        return $http({
            method: 'GET',
            url: HOST + '/api/DeviceState?customerId=' + customerId + '&timeZone=' + timeZone,
            cache: false
        });
    };

    var _getLiveStatus = function _getLiveStatus(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/livestatus?customerId=' + customerId,
            cache: true
        });
    };

    deviceManagementService.getData = _getData;
    deviceManagementService.getDeviceStateData = _getDeviceStateData;
    deviceManagementService.getLiveStatus = _getLiveStatus;

    //Same as _getData without the network operator lookup, which this report doesn't show (faster response)
    var _getDataWithoutNetworkOperator = function _getDataWithoutNetworkOperator(customerId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/DeviceStatus',
            params: { customerId: customerId, getNetworkOperator: false },
            cache: false
        });
    };

    deviceManagementService.getDataWithoutNetworkOperator = _getDataWithoutNetworkOperator;

    return deviceManagementService;
}

DeviceManagementFactory.$inject = ['HOST', '$http'];

angular.module('mc.device-management').factory('DeviceManagementFactory', DeviceManagementFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function DeviceManagementController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, $timeout, $filter, $element, savePdfService, toaster, $location, PopupFactory, DeviceManagementFactory) {
    var ctrl = this;
    //Filters: status card, Model column dropdown and the top-menu search box
    ctrl.statusFilter = null;
    ctrl.modelFilterId = 0;
    ctrl.filteredItems = [];
    ctrl.modelFilterSelected = {};

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        ctrl.reverse = false;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat === 1 ? "hh:mm a" : "HH:mm";
        if (ctrl.accountInfo.userRole == 'Administrator' || ctrl.accountInfo.userRole == 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.languageID = ctrl.accountInfo.preferenceUser.lookupLanguageID;
        $scope.languageID = ctrl.languageID;
        ctrl.translation = translationService.translation;
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        ctrl.alerts = [];
        ctrl.items = [];
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        $scope.hideMobileBackButton = true; //hides the back arrow in top-menu-disabled-input on mobile
        ctrl.downloadViewTypeOptions = [0, 1, 2]; //used by top-menu save-pdf-chart-excel-print
        ctrl.detailsRequest = 0;
        ctrl.getRtuListData();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);
            //Fallback title until RTU_LIST_REPORT is added to server translations
            if (!ctrl.translation.text.RTU_LIST_REPORT) {
                ctrl.popup.dialog('option', 'title', 'Device Management');
            }
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });
            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
            //Pixel height of an element, 0 when it isn't rendered (avoids .replace on undefined)
            var _height = function _height(el) {
                var value = $(el).first().css("height");
                return value ? parseFloat(value.replace(/[^0-9.]+/g, "")) : 0;
            };
            ctrl.adjustSize = function () {
                var popupParent = ctrl.popup.parent();
                var popupWidth = popupParent.css("width");
                var contentHeight = _height(popupParent) - _height(popupParent.find('div:eq(0)'));
                popupParent.find('div:eq(2)').css("width", popupWidth);
                popupParent.find('div:eq(2)').css("min-width", popupWidth.replace(/[^0-9.]+/g, ""));
                popupParent.find('div:eq(2)').css("height", contentHeight);
                popupParent.find('div:eq(2)').css("min-height", contentHeight);
                //Header row stays fixed, device rows scroll inside .tabular-data-container
                popupParent.find('.tabular-data-container').css("height", contentHeight - _height(popupParent.find('.headertable')) - _height(popupParent.find('.top-menu')) - (popupParent.find('.summary-cards').outerHeight(true) || 0) - 25); //25: total padding
            };
        }
    };

    //Options for the Model column filter
    ctrl.deviceModel = [{ "id": 8, "name": "Model 110" }, { "id": 9, "name": "Model 800" }, { "id": 10, "name": "Model M80" }, { "id": 15, "name": "Manhole Monitor" }, { "id": 17, "name": "MyDro M120" }, { "id": 18, "name": "MyDro M150" }, { "id": 19, "name": "MyDro M850" }, { "id": 20, "name": "M84" }, { "id": 21, "name": "M50" }];

    //Status entries indexed by device.state - 1, translation getters follow language changes
    ctrl.statusList = [{ type: 1, get translation() {
            return ctrl.translation.text.OK;
        }, icon: "fa fa-check-circle", color: "rgb(22, 160, 133)" }, { type: 2, get translation() {
            return ctrl.translation.text.ALARM;
        }, icon: "fa fa-times-circle", color: "rgb(231, 90, 90)" }, { type: 3, get translation() {
            return ctrl.translation.text.OFFLINE;
        }, icon: "fa fa-minus-circle", color: "rgb(188, 0, 188)" }, { type: 4, get translation() {
            return ctrl.translation.text.SERVICE;
        }, icon: "fa fa-minus-circle", color: "rgb(255, 216, 0)" }, { type: 5, get translation() {
            return ctrl.translation.text.DISABLED;
        }, icon: "fa fa-minus-circle", color: "blue" }, { type: 6, get translation() {
            return ctrl.translation.text.STATUS_ACK_AS_ALARM;
        }, icon: "fa fa-times-circle", color: "rgb(76, 179, 255)" }];

    //Called by the refresh button in top-menu
    $scope.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.statusFilter = null;
        ctrl.modelFilterId = 0;
        ctrl.modelFilterSelected = {};
        ctrl.getRtuListData();
    };

    ctrl.getRtuListData = function () {
        ctrl.loadingInProgress = true;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        ctrl.stickyProperties.on = false;
        ctrl.alerts = [];
        ctrl.items = [];
        ctrl.stateCounts = {};
        ctrl.applyFilters();
        //null when device states fail: devices are still shown, just without status
        var deviceStatePromise = DeviceManagementFactory.getDeviceStateData(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone).then(function (deviceStateDataFromFactory) {
            return deviceStateDataFromFactory.data || [];
        }, function (error) {
            return null;
        });
        DeviceManagementFactory.getDataWithoutNetworkOperator(ctrl.accountInfo.customerId).then(function (dataFromFactory) {
            ctrl.items = dataFromFactory.data || [];
            if (ctrl.items.length === 0) {
                ctrl.alerts.push({ msg: ctrl.translation.message.NO_RECENT_DATA, type: "info" });
                return;
            }
            //Returned so the loading spinner stays on until the states are merged
            return deviceStatePromise.then(function (deviceStateItems) {
                if (deviceStateItems) {
                    ctrl.mergeDeviceState(deviceStateItems);
                }
                if (ctrl.predicate) {
                    ctrl.order(ctrl.predicate, ctrl.reverse);
                } else {
                    ctrl.applyFilters();
                }
                //Size the scroll area once the rows are rendered
                $timeout(function () {
                    if (ctrl.adjustSize) ctrl.adjustSize();
                }, 0);
            });
        }, function (error) {
            //error
        }).then(function () {
            ctrl.loadingInProgress = false;
        });
    };

    //api/DeviceState decides the state of each device; merge it into the list and count devices per status card
    ctrl.mergeDeviceState = function (deviceStateItems) {
        var stateById = {};
        deviceStateItems.forEach(function (deviceState) {
            stateById[deviceState.id] = deviceState;
        });
        var stateKeys = { 1: 'ok', 2: 'alarm', 3: 'offline', 4: 'service', 5: 'disabled', 6: 'statusAckAsAlarm' };
        ctrl.stateCounts = { ok: 0, alarm: 0, offline: 0, service: 0, disabled: 0, statusAckAsAlarm: 0 };
        ctrl.items.forEach(function (device) {
            var deviceState = stateById[device.deviceId];
            device.state = deviceState ? deviceState.state : undefined;
            device.acFail = deviceState ? deviceState.acFail : false;
            //Counted the same way as the status icon (AC fail on an OK device is Alarm)
            var status = ctrl.getDeviceStatus(device);
            if (status && stateKeys[status.type]) {
                ctrl.stateCounts[stateKeys[status.type]]++;
            }
        });
    };

    //Click a row to expand the device details below it
    ctrl.toggleDeviceDetails = function (device) {
        var wasOpen = device.showDetails;
        ctrl.items.forEach(function (item) {
            item.showDetails = false;
        });
        if (wasOpen) {
            return;
        }

        if (!ctrl.popupWindow) {
            ctrl.popupWindow = new PopupFactory(ctrl.accountInfo);
        }
        ctrl.deviceDetails = null;
        ctrl.detailsLoading = true;
        //Wipe old content on the digest before opening, to avoid a jumpy collapse
        $timeout(function () {
            device.showDetails = true;
        });

        var currentRequest = ++ctrl.detailsRequest;
        ctrl.popupWindow.fetchTooltipData(device.deviceId, ctrl.accountInfo.timeZone, null).then(function (resp) {
            //Only the latest click updates the panel
            if (currentRequest !== ctrl.detailsRequest) {
                return;
            }
            //Drop the tooltip's header div (device name), it's already in the row
            ctrl.deviceDetails = $sce.trustAsHtml(resp.substring(resp.indexOf("</div>") + 6));
            ctrl.detailsLoading = false;
        }, function () {
            if (currentRequest === ctrl.detailsRequest) {
                ctrl.detailsLoading = false;
            }
        });
    };

    //Redirects to RTU Setting with selected device
    ctrl.editDevice = function (device) {
        if (!ctrl.isAdmin) return;
        ctrl.stickyPropertiesInterface.deviceId = device.deviceId;
        ctrl.stickyPropertiesInterface.device = { deviceId: device.deviceId, deviceName: device.name };

        if (ctrl.mobile || ctrl.classicView) {
            $location.path('/rtusetting/rtu-setting');
        } else {
            openViewService.openView('RTU Setting', { width: 800, height: 600 }, undefined, ctrl.stickyPropertiesInterface, { minimumWidth: 800, minimumHeight: 600 });
        }
    };

    var orderBy = $filter('orderBy');
    ctrl.order = function (predicate, reverse) {
        //Ties are broken by serial number
        ctrl.items = orderBy(ctrl.items, predicate === 'serialNumber' ? predicate : [predicate, 'serialNumber'], reverse);
        ctrl.predicate = predicate;
        ctrl.applyFilters();
    };

    //Called by the PDF button in top-menu
    ctrl.savePdf = function () {
        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: ctrl.translation.text.device_management || 'Device Management',
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            $scope: $scope,
            $element: $element
        };
        savePdfService.savePDF(pdfParams);
    };

    //Status entry for a device, same rules as the overview (AC fail on an OK device shows as Alarm)
    ctrl.getDeviceStatus = function (device) {
        if (!device.state || !ctrl.statusList) {
            return null;
        }
        if (device.acFail && device.state === 1) {
            return ctrl.statusList[1];
        }
        return ctrl.statusList[device.state - 1] || null;
    };

    //Alarm column: same rule as the Alarm card
    ctrl.hasActiveAlarm = function (device) {
        var status = ctrl.getDeviceStatus(device);
        return !!status && (status.type === 2 || status.type === 6);
    };

    //api/DeviceStatus returns the model id as "model"
    ctrl.matchesModelFilter = function (device) {
        return device.model == ctrl.modelFilterId;
    };

    //Called when card is clicked, search, or Model filter is used which rebuilds the list the table shows
    ctrl.applyFilters = function () {
        var search = ($scope.search && $scope.search.undefined || '').trim().toLowerCase();
        ctrl.filteredItems = (ctrl.items || []).filter(function (device) {
            if (ctrl.statusFilter) {
                var status = ctrl.getDeviceStatus(device);
                if (!status || status.type !== ctrl.statusFilter) {
                    return false;
                }
            }
            if (ctrl.modelFilterId && !ctrl.matchesModelFilter(device)) {
                return false;
            }
            if (!search) {
                return true;
            }
            return [device.name, device.serialNumber, device.modelName, device.softwareVersion].some(function (value) {
                return value != null && String(value).toLowerCase().indexOf(search) !== -1;
            });
        });
    };

    //Called after clicking cards
    ctrl.setStatusFilter = function (statusType) {
        ctrl.statusFilter = ctrl.statusFilter === statusType ? null : statusType;
        ctrl.applyFilters();
    };

    //Called by the top-menu filter box
    ctrl.searchFieldChanged = function () {
        ctrl.applyFilters();
    };

    //Model column filter, single select
    ctrl.modelFilterSetting = {
        displayProp: 'name', //ctrl.deviceModel uses "name", the directive defaults to "label"
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.modelFilterEvents = {
        onItemSelect: function onItemSelect(item) {
            //Picking the selected model again turns the filter off
            if (item.id == ctrl.modelFilterId) {
                ctrl.clearModelFilter();
            } else {
                ctrl.modelFilterId = item.id;
                ctrl.applyFilters();
            }
        }
    };

    ctrl.clearFilters = function () {
        ctrl.statusFilter = null;
        ctrl.modelFilterId = 0;
        ctrl.modelFilterSelected = {};
        ctrl.applyFilters();
    };

    //Turns off only the Model filter, leaving the status card and search as they are
    ctrl.clearModelFilter = function () {
        ctrl.modelFilterId = 0;
        ctrl.modelFilterSelected = {};
        ctrl.applyFilters();
    };

    ctrl.openAlarmHistory = function (device) {
        // Alarm History pre-selects this device in its filter (same as the RTU View dispatch icon)
        ctrl.stickyPropertiesInterface.deviceId = device.deviceId;
        ctrl.stickyPropertiesInterface.device = { deviceId: device.deviceId, deviceName: device.name };

        if (!$rootScope.mobile && !$rootScope.classicView) {
            openViewService.openView('Alarm History', { width: 850, height: 500 }, undefined, ctrl.stickyPropertiesInterface, { minimumWidth: 625, minimumHeight: 240 });
        } else {
            $location.path('/alarmhistory/alarm-history');
        }
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.languageID = ctrl.accountInfo.preferenceUser.lookupLanguageID;
        ctrl.getRtuListData(); //reload rebuilds alerts in the new language
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, preferredTimeFormat) {
        ctrl.timeFormat = preferredTimeFormat === 1 ? "hh:mm a" : "HH:mm";
        ctrl.getRtuListData();
    });

    $scope.$on("$destroy", function () {
        ctrl.adjustSize = null;
        ctrl.popup = null;
        ctrl.items = [];
        ctrl.filteredItems = [];
        ctrl.alerts = [];
    });
}

DeviceManagementController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$timeout', '$filter', '$element', 'savePdfService', 'toaster', '$location', 'PopupFactory', 'DeviceManagementFactory'];
'use strict';

angular.module('mc.device-management').component('deviceManagement', {
    controller: DeviceManagementController,
    templateUrl: 'ui/devicemanagement/device-management-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("customer-list", []);
"use strict";

function CustomerListFactory(HOST, $http) {

    // instantiate our initial object
    var CustomerList = function CustomerList() {};

    CustomerList.prototype.getData = function () {
        var managedSites = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        this.managedSites = managedSites;
        var self = this;
        return $http.get(HOST + "/api/CustomerList" + "?managedSites=" + this.managedSites).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return CustomerList;
}

CustomerListFactory.$inject = ['HOST', '$http'];

angular.module('customer-list').factory('CustomerListFactory', CustomerListFactory);
'use strict';

function CustomerListController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, CustomerListFactory, AuthorizeAccessFactory, $timeout, $filter, $element, getDateRangeService, savePdfService, $window, $location, $http, HOST, AdminPortalService, CustomerSearchRecentFactory, ApplicationPortalFactory) {
    var ctrl = this;
    ctrl.isMcAdmin = false;
    $scope.alerts = [];
    ctrl.int = false;
    ctrl.$onInit = function () {
        //sharedSetupService.getWindowId(this);
        ctrl.alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        ctrl.seearchLetter = null;
        ctrl.seearchLengthTrigger = 3;
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurementId = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? 1 : 3.78541;
        ctrl.customerListScale = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? 1 : 1.00 / 60.00;
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for

        ctrl.insideCustomerLookup = !angular.isUndefined($element.parents('.mc-combined-view').html());
        ctrl.isOnAdminPortal = sharedSetupService.adminPortal();

        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.customerSearchRecentFactory = new CustomerSearchRecentFactory();
        ctrl.recentCustomerList = ctrl.customerSearchRecentFactory.getRecentCustomerList();

        ctrl.goGetData();

        if ($rootScope.autoLogin === true && ctrl.isMcAdmin) {
            $rootScope.autoLogin = null;
            var cust = {};
            cust.customerId = ctrl.accountInfo.customerId;
            cust.name = ctrl.accountInfo.customerName;
            ctrl.selectCustomer(cust, null);
        }
    };

    ctrl.selectCustomer = function (customer, busyLoading) {
        var _applicationPortal = new ApplicationPortalFactory(customer.customerId);
        _applicationPortal.switchCustomer(customer, busyLoading);
    };

    ctrl.goGetData = function () {
        $scope.alerts = [];
        if (!angular.isUndefined(ctrl.customerList)) ctrl.customerList.loading = true;

        var _customerList = new CustomerListFactory();

        _customerList.getData(ctrl.managedSites).then(function () {
            ctrl.customerList = _customerList.data.customers;
            ctrl.distributorList = _customerList.data.distributors;
            ctrl.firstName = _customerList.data.firstName;
            ctrl.lastName = _customerList.data.lastName;
            ctrl.ouMission = _customerList.data.ouMission;
            ctrl.customerList.loading = false;

            ctrl.checkCustomerListLength();

            ctrl.refreshAlerts();
        });
    };

    ctrl.searchFieldChanged = function (t) {
        $element.find('span').removeClass("alphabet-selected");
        if (typeof t !== 'undefined' && t.search["undefined"].length > ctrl.seearchLengthTrigger) {
            ctrl.customerListSearch = angular.copy(ctrl.customerList).filter(function (el) {
                return el.customerName.toUpperCase().indexOf(t.search["undefined"].toUpperCase()) >= 0;
            });
        } else {
            ctrl.checkCustomerListLength();
        }
    };

    ctrl.filterCustomer = function (varLetter) {
        $scope.search = { undefined: '' };
        $element.find('span').removeClass("alphabet-selected");

        if (ctrl.seearchLetter === varLetter) {
            ctrl.checkCustomerListLength();
            ctrl.seearchLetter = null;
            return;
        }

        ctrl.seearchLetter = varLetter;

        $element.find('.' + varLetter).addClass("alphabet-selected");

        ctrl.customerListSearch = angular.copy(ctrl.customerList).filter(function (el) {
            if (varLetter == "A") return el.customerName.toUpperCase().indexOf(varLetter) == 0 || !isNaN(parseInt(el.customerName.charAt(0)));
            return el.customerName.toUpperCase().indexOf(varLetter) == 0;
        });
    };

    ctrl.checkCustomerListLength = function () {
        if (ctrl.customerList.length > 100) {
            if (!ctrl.initOneTimeOnly) {
                //Customer List: Pre-select a letter (A) if more than 100 records (ng-repeat issue)
                ctrl.initOneTimeOnly = true;
                ctrl.filterCustomer("A");
            } else {
                ctrl.customerListSearch = null;
            }
            ctrl.seearchLengthTrigger = 3;
        } else {
            ctrl.customerListSearch = ctrl.customerList;
            ctrl.seearchLengthTrigger = 0;
        }
    };

    ctrl.refreshAlerts = function () {
        $scope.alerts = [];
        if (ctrl.customerList.length === 0) {
            var errorMessage = ctrl.translation.message.NO_DATA;
            $scope.alerts.push({
                msg: errorMessage,
                type: "info"
            });
        }
    };

    ctrl.openDeviceStatus = function (customerId, customerName) {
        $scope.stickyProperties = angular.copy(sharedSetupService.stickyPropertiesInterface);
        $scope.stickyProperties.adminPortal = { customerId: customerId, customerName: customerName };
        openViewService.openView('Device Status', { width: 990, height: 500 }, { my: 'right-10 top+6', at: 'right top', of: window }, $scope.stickyProperties, { minimumWidth: 990, minimumHeight: 350 }, false);
    };

    ctrl.openCustomerNotes = function (customerId, customerName) {
        $scope.stickyProperties = angular.copy(sharedSetupService.stickyPropertiesInterface);
        $scope.stickyProperties.adminPortal = { customerId: customerId, customerName: customerName };
        openViewService.openView('Customer Notes', { width: 900, height: 600 }, { my: 'right-10 top+6', at: 'right top', of: window }, $scope.stickyProperties, { minimumWidth: 990, minimumHeight: 350 }, false);
    };
}

CustomerListController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'CustomerListFactory', 'AuthorizeAccessFactory', '$timeout', '$filter', '$element', 'getDateRangeService', 'savePdfService', '$window', '$location', '$http', 'HOST', 'AdminPortalService', 'CustomerSearchRecentFactory', 'ApplicationPortalFactory'];
'use strict';

angular.module('customer-list').component('customerList', {
    controller: CustomerListController,
    templateUrl: 'ui/customerlist/customer-list-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        managedSites: '<'
    }
});
"use strict";

function AuthorizeAccessFactory(HOST, $http) {

    // instantiate our initial object
    var AuthorizeAccess = function AuthorizeAccess() {};

    AuthorizeAccess.prototype.authorize = function (customerId) {
        var self = this;
        return $http.get(HOST + "/api/AuthorizeAccess/GetData/" + "?customerId=" + customerId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return AuthorizeAccess;
}

AuthorizeAccessFactory.$inject = ['HOST', '$http'];

angular.module('customer-list').factory('AuthorizeAccessFactory', AuthorizeAccessFactory);
'use strict';

angular.module('mc.checkin', []);
'use strict';

function CheckinFactory(HOST, $http, GetDeviceNameService) {

    var CheckinReportData = function CheckinReportData(timeZone, customerId) {
        this.timeZone = timeZone;
        this.customerId = customerId;
    };

    CheckinReportData.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + '/api/DeviceUnitState' + '?timeZone=' + this.timeZone + '&customerId=' + this.customerId).then(function (response) {
            var deviceNameCall = new GetDeviceNameService();
            self.list = response.data;
            self.loading = false;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = self.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var value = _step.value;

                    value.deviceModel = deviceNameCall.setDeviceName(value.deviceType);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return response;
        });
    };
    return CheckinReportData;
}

CheckinFactory.$inject = ['HOST', '$http', 'GetDeviceNameService'];

angular.module('mc.checkin').factory('CheckinFactory', CheckinFactory);
'use strict';

function CheckinController(_, $, $rootScope, $scope, $sce, $interval, authenticationService, translationService, modalService, CheckinFactory, openViewService, sharedSetupService, toaster) {
    var _this = this;

    var ctrl = this;
    ctrl.reportData = '';
    ctrl.isClassic = false;
    ctrl.setInterval = '';
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;
        ctrl.selectedDevice = '';
        ctrl.downloadViewTypeOptions = [0];

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        if (ctrl.mobile || ctrl.classicView) {
            ctrl.isClassic = true;
        }
        ctrl.getReportData(); //get the report data
        ctrl.setInterval = $interval(ctrl.getReportData, 45000); //set the interval after making the first call
    };

    ctrl.mostRecentData = function () {
        toaster.pop('success', 'Unit Check-in', 'View reloading');
        ctrl.getReportData();
    };

    ctrl.getReportData = function () {
        var _checkinReportData = new CheckinFactory(ctrl.accountInfo.timeZone, ctrl.accountInfo.customerId);
        _checkinReportData.getData().then(function () {
            ctrl.reportData = _checkinReportData;
        });
    };

    ctrl.openCalendarView = function (item) {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = item.deviceID;
        optionsStickyProperties.zoomMin = item.lastTimeHeard;

        if (_this.mobile || _this.classicView) {
            $location.path('/rtuview/rtu-view');
        } else {
            openViewService.openView('Signal Calendar', { width: 598, height: 489 }, undefined, optionsStickyProperties);
        }
    };

    ctrl.isDeviceOffline = function (isOnline, lastHeardTime, deviceType) {
        var lhd = new Date(lastHeardTime);
        var day30 = new Date();
        var hour25 = new Date();
        var validTypes = [5, 8, 9, 18, 19];

        day30.setDate(day30.getDate() - 30);
        hour25.setHours(hour25.getHours() - 25);
        //let boolValue =  lhd > day30 && (!isOnline && validTypes.find(x => x === deviceType) || (lhd < hour25 && deviceType === 15));
        var boolValue = lhd > day30 && (validTypes.find(function (x) {
            return x === deviceType;
        }) || lhd < hour25 && deviceType === 15);

        if (boolValue === false) {
            return 'device-disabled';
        }
    };

    $scope.$on("$destroy", function () {
        $interval.cancel(ctrl.setInterval);
    });
}

CheckinController.$inject = ['_', '$', '$rootScope', '$scope', '$sce', '$interval', 'authenticationService', 'translationService', 'modalService', 'CheckinFactory', 'openViewService', 'sharedSetupService', 'toaster'];

angular.module('mc.checkin').component('checkin', {
    controller: CheckinController,
    transclude: true,
    templateUrl: 'ui/checkin/checkin-template.html',
    bindings: {
        deviceId: '<',
        windowId: '<',
        windowTitle: '<',
        mobile: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.chlorine-report", []);
"use strict";
"use strict";

function ChlorineReportController(_, REPORTS, $scope, $http, $sce, datetimeService, sharedSetupService, openViewService, $element, timeLapseService, translationService, websocketService, authenticationService, savePdfService, toaster) {
    var ctrl = this;
    ctrl.$onInit = function () {
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.isRefresh = false;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.reportType = "1";
        ctrl.loadReportData();

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.mostRecentData = function () {
        ctrl.isRefresh = true;
        ctrl.myDate == null;
        //console.log($scope.myDate);
        toaster.pop('success', ctrl.windowTitle, 'View reloading');
        ctrl.loadReportData();
    };

    ctrl.selectMyDate = function () {
        ctrl.loadReportData();
    };

    ctrl.loadReportData = function () {
        ctrl.reportLists = [];
        ctrl.loadingInProgress = true;
        var varReportDate;
        var today = new Date();
        var yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        if (new Date(ctrl.myDate) !== "Invalid Date" && !isNaN(new Date(ctrl.myDate))) {
            ctrl.myDate = new Date(ctrl.myDate) !== "Invalid Date" && !isNaN(new Date(ctrl.myDate)) ? ctrl.myDate : yesterday;
        } else {
            ctrl.myDate = yesterday;
        }

        if (ctrl.isRefresh) {
            ctrl.myDate = yesterday;
            ctrl.isRefresh = false;
        }

        varReportDate = datetimeService.formatDate(ctrl.myDate, 'yyyyMMdd');

        $http.get(REPORTS + "/api/reports/ChlorineReport?customerId=" + ctrl.accountInfo.customerId + ("&reportDate=" + varReportDate)
        // + `&reportDate=20190114`
        + ("&reportType=" + $scope.reportType) + ("&langId=" + ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_"))).then(function (resp) {
            ctrl.loadingInProgress = false;
            ctrl.reportLists = resp.data;
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };
};

ChlorineReportController.$inject = ['_', 'REPORTS', '$scope', '$http', '$sce', 'datetimeService', 'sharedSetupService', 'openViewService', '$element', 'timeLapseService', 'translationService', 'websocketService', 'authenticationService', 'savePdfService', 'toaster'];
'use strict';

angular.module('mc.chlorine-report').component('chlorineReport', {
    controller: ChlorineReportController,
    templateUrl: 'ui/chlorine/chlorine-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.daily-station-summary-report", []);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function DailyStationSummaryReportController($, $rootScope, $scope, $sce, $http, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, REPORTS, $timeout, $filter, $element, $window, detectBrowserService, toaster) {
    var ctrl = this;
    ctrl.initLoad = true;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        $scope.downloadViewTypeOptions = !ctrl.classicView ? [3, 0] : [3];
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.changeTranslation = false;
        ctrl.isRefresh = false;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.curentBrowser = detectBrowserService();
        $scope.stickyProperties = ctrl.stickyProperties;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId($scope);
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.dateTimeDownload = true;
        //$scope.max = 12;

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.mostRecentData = function () {
        ctrl.isRefresh = true;
        toaster.pop('success', $scope.windowTitle + '--' + $scope.deviceSelectedName, 'View reloading');
        ctrl.goSelectReportData();
    };

    ctrl.selectMyDate = function () {
        ctrl.goSelectReportData(true);
        return;
    };

    ctrl.goSelectReportData = function (varClick) {
        if (!ctrl.changeTranslation) ctrl.dailyStationSummaryReportLoading = true;
        ctrl.alerts = [];
        var numberOfDays = 30,
            _tmpStartDate;

        var currentDate = new Date();
        var previousDate = new Date();
        previousDate.setDate(previousDate.getDate() - 1);
        currentDate.setHours(0, 0, 0, 0);
        previousDate.setHours(0, 0, 0, 0);

        //DSSR DO NOT support Live data, so we will always set the liveDataFlag to 2,
        var isLiveData = false;
        var liveDataFlag = 2; //used as a flag to determine whether in live mode as null value won't save to sticky properties

        if (varClick && ctrl.myDate) {
            //if (ctrl.myDate.getTime() <= currentDate.getTime() && ctrl.myDate.getTime() >= previousDate.getTime()) { //
            //    isLiveData = true;
            //    liveDataFlag = 1;
            //}

            //if the selected date is today, then set the start date to yesterday to avoid empty report
            if (ctrl.myDate.toDateString() == currentDate.toDateString()) {
                _tmpStartDate = previousDate;
            } else {
                _tmpStartDate = ctrl.myDate;
            }

            ctrl.startHour = ctrl.myDate.getHours();
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        } else if (!ctrl.mobile && !ctrl.classicView && ctrl.stickyProperties.on == true && ctrl.stickyProperties.device.channel !== "1") {
            //check flag value in channel to see if it is live data
            ctrl.stickyProperties.on = false;
            var date = new Date(ctrl.stickyProperties.dateMin);
            var userTimezoneOffset = date.getTimezoneOffset() * 60000;
            _tmpStartDate = new Date(date.getTime() + userTimezoneOffset);
            ctrl.myDate = _tmpStartDate;
            ctrl.startHour = ctrl.myDate.getHours();
            ctrl.deviceSelected = ctrl.stickyProperties.deviceId;
            ctrl.startDate = datetimeService.dateToUnixtime(_tmpStartDate);
        } else {
            ctrl.initLoad = false;
            //isLiveData = true;
            //liveDataFlag = 1;
            _tmpStartDate = new Date();
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.myDate = _tmpStartDate;
            ctrl.startHour = ctrl.myDate.getHours();
        }

        if (ctrl.isRefresh) {
            ctrl.isRefresh = false;
            //isLiveData = true;
            //liveDataFlag = 1;
            _tmpStartDate = new Date();
            _tmpStartDate.setHours(0, 0, 0, 0);
            ctrl.myDate = _tmpStartDate;

            //ctrl.startDate = datetimeService.dateToUnixtime(new Date(_tmpStartDate.setDate(_tmpStartDate.getDate() - 1)));
            ctrl.startDate = undefined;
            ctrl.startHour = ctrl.myDate.getHours();
        }

        ctrl.stickyProperties.dateMin = datetimeService.dateToUnixtime(ctrl.myDate);
        var now = new Date(ctrl.startDate);
        var _tmpTestEventDate = now.getUTCFullYear().toString() + ("0" + (now.getUTCMonth() + 1)).slice(-2) + ("0" + now.getUTCDate()).slice(-2);

        var url;
        ctrl.reportDate = _tmpStartDate == null ? "" : _tmpTestEventDate;
        if (ctrl.reportDate === "NaNaNaN") {
            ctrl.reportDate = "";
        }
        url = REPORTS + "/api/Reports/StationSummaryReport?deviceId=" + ctrl.deviceSelected + "&display=html" + "&reportDate=" + ctrl.reportDate + "&langId=" + ctrl.accountInfo.preferenceUser.i18nCode + "&measurementUnit=" + ctrl.accountInfo.preferenceUser.lookupMeasurementID + "&startTimeHour=" + ctrl.startHour;
        var _elm = $element.find(".mc-rpt-pdf");

        $http.get(url).then(function (result) {
            _elm.html(result.data);
            if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: ctrl.deviceSelected, dataMin: ctrl.startDate, dataMax: null, zoomMin: ctrl.startDate, zoomMax: null, liveData: isLiveData, device: { channel: liveDataFlag, deviceName: $scope.deviceSelectedName }, windowId: ctrl.windowId }); //stored live flag in channel cause we won't need to use channel for this report
            ctrl.dailyStationSummaryReportLoading = false;
            if (!ctrl.mobile && !ctrl.classicView) $scope.adjustSize();
        });
    };

    $scope.$on('updatePreferencesLanguage', function (event, args) {
        ctrl.changeTranslation = true;
        ctrl.goSelectReportData();
        ctrl.changeTranslation = false;
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
    });

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            var tmpNewValue;
            if (ctrl.stickyProperties.on == true) {
                tmpNewValue = $scope.findDevice(ctrl.stickyProperties.deviceId);
                $scope.setDeviceData(tmpNewValue);
                ctrl.goSelectReportData();
            } else {
                tmpNewValue = $scope.findDevice(newValue);
                $scope.setDeviceData(tmpNewValue);
                ctrl.goSelectReportData(true);
            }
        }
    }, true);

    $scope.findDevice = function (deviceId) {
        for (var i = 0; i < $scope.devices.length; ++i) {
            if ($scope.devices[i].deviceId === deviceId) {
                return $scope.devices[i];
            }
        }
        return 0;
    };

    $scope.setDeviceData = function (value) {
        ctrl.deviceSelected = value.deviceId;
        $scope.deviceSelectedSn = value.serialNumber;
        $scope.deviceSelectedType = value.type;
        $scope.deviceSelectedName = value.name;
        if (!$rootScope.mobile && !$rootScope.classicView) $scope.popup.dialog("option", "title", $scope.windowTitle + ", " + value.name);
        $scope.currentSelectedDevice = value;
    };

    ctrl.downloadWidget = function () {
        var url = REPORTS + "/api/Reports/StationSummaryReport?deviceId=" + ctrl.deviceSelected + "&display=pdf" + "&reportDate=" + ctrl.reportDate + "&langId=" + (ctrl.accountInfo.preferenceUser.i18nCode === "fr" ? "fr" : "en") + "&measurementUnit=" + ctrl.accountInfo.preferenceUser.lookupMeasurementID + "&startTimeHour=" + ctrl.startHour;
        $http.get(url, { responseType: 'arraybuffer' }).then(function (result) {
            var blob = new Blob([result.data], { type: 'application/pdf' });
            $timeout(function () {
                var today = new Date();
                var yesterday = new Date();
                yesterday.setDate(today.getDate() - 1);
                var date = ctrl.reportDate == "" ? datetimeService.formatDate(yesterday, 'yyyyMMdd') : ctrl.reportDate;
                var name = "StationSummaryReport_" + $scope.deviceSelectedName.replace(/\s/g, "") + "_" + date + ".pdf";
                saveAs(blob, name);
            }, 0);
            ctrl.dailyStationSummaryReportLoading = false;
        });
    };
};

DailyStationSummaryReportController.$inject = ['$', '$rootScope', '$scope', '$sce', '$http', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'REPORTS', '$timeout', '$filter', '$element', '$window', 'detectBrowserService', 'toaster'];
'use strict';

angular.module('mc.daily-station-summary-report').component('dailyStationSummaryReport', {
    controller: DailyStationSummaryReportController,
    transclude: true,
    templateUrl: 'ui/dailystationsummary/daily-station-summary-report-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("customer-search", []);
"use strict";

function CustomerSearchRecentFactory() {
    var _this = this;

    // instantiate our initial object
    var CustomerSearchRecentFactory = function CustomerSearchRecentFactory() {
        this.recentCustomerList;
    };

    CustomerSearchRecentFactory.prototype.getRecentCustomerList = function () {
        _this.recentCustomerList = JSON.parse(window.localStorage.getItem("recentCustomerList"));
        //if does not exsit in local storage set to empty array
        if (_this.recentCustomerList == null) {
            _this.recentCustomerList = [];
        } else {
            _this.recentCustomerList = _this.recentCustomerList.filter(function (i, n) {
                return !angular.isUndefined(i.name) && i.name != '';
            });
        }
        return _this.recentCustomerList;
    };

    CustomerSearchRecentFactory.prototype.setRecentCustomerList = function (customer) {
        //check if customer is already in list
        if (JSON.stringify(_this.recentCustomerList).includes(customer.customerId.toString())) return;
        //Add Customer to List
        _this.recentCustomerList.unshift({ customerId: customer.customerId, name: customer.name || customer.customerName });
        //Remove last recored if more than 15
        if (_this.recentCustomerList.length > 15) {
            _this.recentCustomerList.pop();
        }
        //Set local storage
        window.localStorage.setItem("recentCustomerList", JSON.stringify(_this.recentCustomerList));
    };

    CustomerSearchRecentFactory.prototype.removeCustomerById = function (customerId) {
        //Remove
        var arr = _this.recentCustomerList;
        var index = arr.findIndex(function (element) {
            return element.customerId == customerId;
        });
        if (index !== -1) {
            arr.splice(index, 1);
        }

        //Set local storage
        window.localStorage.setItem("recentCustomerList", JSON.stringify(_this.recentCustomerList));
    };

    return CustomerSearchRecentFactory;
}

CustomerSearchRecentFactory.$inject = [];

angular.module('customer-search').factory('CustomerSearchRecentFactory', CustomerSearchRecentFactory);
"use strict";

function CustomerSearchFactory(HOST, $http) {

    // instantiate our initial object
    var CustomerSearch = function CustomerSearch(searchQuery, powerSearch) {
        this.searchQuery = searchQuery;
        this.powerSearch = powerSearch;
    };

    CustomerSearch.prototype.getData = function () {
        var self = this;
        this.searchQuery = this.searchQuery.replace("+", "%2B");
        return $http.get(HOST + "/api/CustomerSearch" + "?searchQuery=" + this.searchQuery + '&powerSearch=' + this.powerSearch).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return CustomerSearch;
}

CustomerSearchFactory.$inject = ['HOST', '$http'];

angular.module('customer-search').factory('CustomerSearchFactory', CustomerSearchFactory);
'use strict';

function CustomerSearchController($, $rootScope, $scope, authenticationService, translationService, sharedSetupService, openViewService, CustomerSearchFactory, manageSecurityService, $timeout, $element, CustomerSearchRecentFactory, ApplicationPortalFactory, toaster) {
    var ctrl = this;
    ctrl.isMcAdmin = false;
    $scope.alerts = [];
    ctrl.int = false;
    ctrl.powerSearch = false;
    ctrl.searchCustomerBusy = false;

    ctrl.$onInit = function () {
        //sharedSetupService.getWindowId(this);
        ctrl.alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        ctrl.seearchLetter = null;
        ctrl.seearchLengthTrigger = 3;
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurementId = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? 1 : 3.78541;
        ctrl.customerListScale = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? 1 : 1.00 / 60.00;
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.fieldNameToSearch = 'name';
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for

        ctrl.insideCustomerLookup = !angular.isUndefined($element.parents('.mc-combined-view').html());
        ctrl.isOnAdminPortal = sharedSetupService.adminPortal();

        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.customerSearchRecentFactory = new CustomerSearchRecentFactory();
        ctrl.recentCustomerList = ctrl.customerSearchRecentFactory.getRecentCustomerList();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            ctrl.popup = _this.getExistingDialog($scope.windowId).ref;
            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });

            ctrl.filterCustomer = function (varLetter) {
                return false;
            };

            ctrl.adjustSize = function () {
                ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
                ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('div:eq(2)').css("min-height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                ctrl.popup.parent().find('.search_customer_div').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 85); //25: total padding
            };
        }
    };

    ctrl.needSearchBox = true; //display search box
    $scope.needSearchBox = true; //display search box
    ctrl.mcSetFocusHide = false;

    ctrl.searchFieldChanged = function (t) {
        if (typeof t === 'undefined' || typeof t !== 'undefined' && t.search.name.length < 4) {
            ctrl.searchCustomersAll = null;
            ctrl.searchCustomers = null;
        } else {
            ctrl.getCustomers(t.search.name, ctrl.searchType);
        }
    };

    $scope.clearSearchField = function () {
        $scope.search.name = "";
    };

    ctrl.powerSarchChanged = function (powerSearch) {
        ctrl.searchType = powerSearch;
        if (typeof $scope.search !== 'undefined' && typeof $scope.search.name !== 'undefined' && $scope.search.name.length > 3) {
            ctrl.getCustomers($scope.search.name, powerSearch);
        } else {
            ctrl.searchCustomersAll = null;
            ctrl.searchCustomers = null;
        }
    };

    ctrl.getCustomers = function (searchQuery, searchType) {
        ctrl.alerts = [];
        ctrl.searchCustomersAll = null;
        ctrl.searchCustomers = null;
        ctrl.searchCustomerBusy = true;

        var _customerList = new CustomerSearchFactory(searchQuery, searchType);

        _customerList.getData().then(function () {

            $scope.mcSetFocusHide = false;
            $timeout(function () {
                if (!$rootScope.mobile && !$rootScope.classicView) ctrl.popup.parent().find('input[focus-on=mcSetFocus]').focus(); //firefox issue
            }, 300);
            $scope.$broadcast('mcSetFocus');
            ctrl.searchCustomersAll = _customerList.data;
            ctrl.searchCustomers = _customerList.data;
            //ctrl.filterCustomer("A");
            ctrl.selectedCustomerId = _customerList.data.length > 0 ? ctrl.searchCustomersAll[0].customerId : ctrl.selectedCustomerId;
            ctrl.searchCustomerBusy = false;

            if (ctrl.searchCustomers.length === 0) {
                var errorMessage = ctrl.translation.message.NO_RESULTS_FOUND;
                ctrl.alerts.push({ msg: errorMessage, type: "info" });
            }
        });
    };

    ctrl.selectCustomerAction = function (customer, busyLoading) {
        var _applicationPortal = new ApplicationPortalFactory(customer.customerId);
        _applicationPortal.switchCustomer(customer, busyLoading);
    };

    ctrl.selectCustomer = function (customer, busyLoading) {

        if (ctrl.accountInfo.mfaMigrationStatus !== 2 && customer.customerId !== ctrl.accountInfo.customerId) {
            //Check if 2FA is on
            manageSecurityService.GetSecuritySetting(customer.customerId).then(function (resp) {

                if (resp.data == null) {
                    ctrl.selectCustomerAction(customer, busyLoading);
                } else {
                    //remove from Customers Last Visited list
                    ctrl.customerSearchRecentFactory.removeCustomerById(customer.customerId);
                    ctrl.recentCustomerList = ctrl.customerSearchRecentFactory.getRecentCustomerList();
                    toaster.pop('error', '2FA needed to access the customer!', customer.name + ', Error!');
                }
            }, function (err) {
                //
            });
        } else {
            ctrl.selectCustomerAction(customer, busyLoading);
        }
    };

    ctrl.openDeviceStatus = function (customerId, customerName) {
        $scope.stickyProperties = angular.copy(sharedSetupService.stickyPropertiesInterface);
        $scope.stickyProperties.adminPortal = { customerId: customerId, customerName: customerName };
        openViewService.openView('Device Status', { width: 990, height: 500 }, { my: 'right-10 top+6', at: 'right top', of: window }, $scope.stickyProperties, { minimumWidth: 990, minimumHeight: 350 }, false);
    };

    ctrl.openCustomerNotes = function (customerId, customerName) {
        $scope.stickyProperties = angular.copy(sharedSetupService.stickyPropertiesInterface);
        $scope.stickyProperties.adminPortal = { customerId: customerId, customerName: customerName };
        openViewService.openView('Customer Notes', { width: 900, height: 600 }, { my: 'right-10 top+6', at: 'right top', of: window }, $scope.stickyProperties, { minimumWidth: 990, minimumHeight: 350 }, false);
    };

    ctrl.removeCustomerFromList = function (recentCustomer) {
        ctrl.customerSearchRecentFactory.removeCustomerById(recentCustomer.customerId);
        ctrl.recentCustomerList = ctrl.customerSearchRecentFactory.getRecentCustomerList();
    };
}

CustomerSearchController.$inject = ['$', '$rootScope', '$scope', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'CustomerSearchFactory', 'manageSecurityService', '$timeout', '$element', 'CustomerSearchRecentFactory', 'ApplicationPortalFactory', 'toaster'];
'use strict';

angular.module('customer-search').component('customerSearch', {
    controller: CustomerSearchController,
    templateUrl: 'ui/customersearch/customer-search-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.customer-notes', []);
'use strict';

function CustomerNotesFactory(HOST, $http) {

    var _customerNotes = function _customerNotes() {};

    _customerNotes.prototype.ListCustomerNotes = function (endDate, customerId, direction) {
        return $http({
            method: 'GET',
            url: HOST + '/api/CustomerNotes/',
            params: { endDate: endDate, customerId: customerId, direction: direction }
        });
    };

    return _customerNotes;
}

CustomerNotesFactory.$inject = ['HOST', '$http'];

angular.module('mc.customer-notes').factory('CustomerNotesFactory', CustomerNotesFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function CustomerNotesController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, CustomerNotesFactory, $uibModal, $location, deviceMenuService, timeLapseService, datetimeService, deviceNotificationSettingService, savePdfService, toaster, websocketService) {
    var _this2 = this;

    var ctrl = this;
    var _customerId;
    $scope.infiniteScroll = false;
    $scope.infiniteScrollUp = false;
    ctrl.selectNewDate = false;
    $scope.numberOfNewRecordsPrevious = -1;

    ctrl.customerNotes = [];
    ctrl.originalCustomerNotes = [];
    ctrl.initials = [];
    ctrl.shrinkUI = false;
    ctrl.loadingInProgress = false;

    ctrl.deviceModel = [];
    ctrl.deviceData = [];
    ctrl.filterDevice = null;
    ctrl.deviceModelLength = null;

    ctrl.userModel = [];
    ctrl.userData = [];
    ctrl.filterUser = null;
    ctrl.userModelLength = null;

    ctrl._customerNotes = null;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this2);
        ctrl.adminPortal = sharedSetupService.adminPortal();
        ctrl.deviceTypes = [8, 9, 18, 19];
        $scope.downloadViewTypeOptions = [0, 2];
        ctrl._customerNotes = new CustomerNotesFactory();
        if (_typeof(ctrl.stickyProperties) !== 'object') ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        $scope.stickyProperties = ctrl.stickyProperties;
        _customerId = ctrl.stickyProperties.adminPortal.customerId || ctrl.accountInfo.customerId;
        ctrl.myDate = new Date();
        ctrl.getDevices();
        ctrl.getCustomerNotes(ctrl.myDate);
        sharedSetupService.getWindowId($scope);

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    adjustSize();
                }
            });
        };
    };

    var adjustSize = function adjustSize() {
        if (ctrl.shrinkUI === false && ctrl.popup.parent().width() < 725) {
            ctrl.shrinkUI = true;
        } else if (ctrl.shrinkUI === true && ctrl.popup.parent().width() >= 725) {
            ctrl.shrinkUI = false;
        }

        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

        //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
        //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
    };

    //handling infinite scrolling
    var customerNotesContainer = $element.find('#customer-notes-scroll-identifier');
    customerNotesContainer.on('scroll', function (event) {
        if (customerNotesContainer[0].scrollTop + customerNotesContainer[0].offsetHeight >= customerNotesContainer[0].scrollHeight - 1 && !ctrl.selectNewDate) {
            $scope.infiniteScroll = true;
            ctrl.getCustomerNotes(new Date(ctrl.originalCustomerNotes[ctrl.originalCustomerNotes.length - 1].noteTime));
            return;
        }
        if (customerNotesContainer[0].scrollTop <= 0 && !ctrl.selectNewDate) {
            var today = new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate();
            var currentDate = ctrl.myDate.getFullYear() + "/" + (ctrl.myDate.getMonth() + 1) + "/" + ctrl.myDate.getDate();
            if (today == currentDate) return;
            $scope.infiniteScrollUp = true;
            ctrl.getCustomerNotes(new Date(ctrl.originalCustomerNotes[0].noteTime));
            return;
        }
    });

    $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
        var today = new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate();
        var currentDate = ctrl.myDate.getFullYear() + "/" + (ctrl.myDate.getMonth() + 1) + "/" + ctrl.myDate.getDate();
        if (today == currentDate) return;
        _autoScroll();
        //scope.checkFirstRowLiveStatus = null;
        // scope.trgScroll();
    });

    var _autoScroll = function _autoScroll() {
        if ($scope.numberOfNewRecordsPrevious > 0) {
            var trRow = customerNotesContainer.find('tr').eq($scope.numberOfNewRecordsPrevious - 1);
            var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
            customerNotesContainer.scrollTop(yPosition);
        } else {
            $timeout(function () {
                customerNotesContainer.animate({
                    scrollTop: 5
                }, 500);
            }, 0);
        }
    };

    ctrl.getCustomerNotes = function (endDate) {
        ctrl.loadingInProgress = true;
        //let endDate = new Date();
        if ($scope.infiniteScroll) {
            $scope.infiniteScroll = false;
            ctrl._customerNotes.ListCustomerNotes(endDate, _customerId, 1).then(function (resp) {
                ctrl.originalCustomerNotes = ctrl.originalCustomerNotes.concat(resp.data);
                ctrl.customerNotes = ctrl.originalCustomerNotes.slice();
                ctrl.getUserInitialList();
                ctrl.filterCustomerNotes();
                ctrl.loadingInProgress = false;
            });
            return;
        }

        if ($scope.infiniteScrollUp) {
            $scope.infiniteScrollUp = false;
            ctrl._customerNotes.ListCustomerNotes(endDate, _customerId, 0).then(function (resp) {
                var items = resp.data;
                //if (ctrl.originalCustomerNotes.some(item => items.includes(item))) {
                //    return;
                //}
                if (items.every(function (element) {
                    return ctrl.originalCustomerNotes.includes(element);
                })) {
                    ctrl.loadingInProgress = false;
                    $scope.numberOfNewRecordsPrevious = -1;
                    return;
                }
                $scope.numberOfNewRecordsPrevious = resp.data.length;
                ctrl.originalCustomerNotes = [].concat(_toConsumableArray(items), _toConsumableArray(ctrl.originalCustomerNotes));
                //for (var i = 0; i < items.length; i++) {
                //    items[i].localDateTime = items[i].localDateTime;
                //    items[i].value = items[i].value;
                //    ctrl.originalCustomerNotes.unshift(items[i]);
                //}
                ctrl.customerNotes = ctrl.originalCustomerNotes.slice();
                ctrl.getUserInitialList();
                ctrl.filterCustomerNotes();
                ctrl.loadingInProgress = false;
            });
            return;
        }

        ctrl._customerNotes.ListCustomerNotes(endDate, _customerId, 1).then(function (resp) {
            ctrl.originalCustomerNotes = resp.data;
            ctrl.customerNotes = ctrl.originalCustomerNotes.slice();
            ctrl.getUserInitialList();
            ctrl.filterCustomerNotes();
            ctrl.registerListeners();
            ctrl.loadingInProgress = false;
            ctrl.selectNewDate = false;
        });
    };

    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(_customerId).then(function (result) {
            ctrl.devices = result.data.devices;
            var tmp = [];
            for (var i = 0; i < ctrl.devices.length; i++) {
                tmp.push({ id: i, label: ctrl.devices[i].name });
            }
            ctrl.deviceData = tmp;
        }, function (error) {});
    };

    ctrl.getUserInitialList = function () {
        ctrl.initials = [];
        ctrl.userData = [];

        for (var i = 0; i < ctrl.customerNotes.length; i++) {
            if (ctrl.initials.indexOf(ctrl.customerNotes[i].initials) == -1) ctrl.initials.push(ctrl.customerNotes[i].initials);
        }

        for (var _i = 0; _i < ctrl.initials.length; _i++) {
            ctrl.userData.push({ id: _i, label: ctrl.initials[_i] });
        }
    };

    ctrl.filterCustomerNotes = function () {
        ctrl.customerNotes = [];
        if (ctrl.filterDevice == null && ctrl.filterUser == null) {
            ctrl.customerNotes = ctrl.originalCustomerNotes.slice();
            return;
        }
        if (ctrl.filterDevice !== null && ctrl.filterUser == null) {
            for (var i = 0; i < ctrl.originalCustomerNotes.length; i++) {
                if (ctrl.originalCustomerNotes[i].deviceName == ctrl.filterDevice) ctrl.customerNotes.push(ctrl.originalCustomerNotes[i]);
            }
            return;
        }
        if (ctrl.filterDevice == null && ctrl.filterUser !== null) {
            for (var _i2 = 0; _i2 < ctrl.originalCustomerNotes.length; _i2++) {
                if (ctrl.originalCustomerNotes[_i2].initials == ctrl.filterUser) ctrl.customerNotes.push(ctrl.originalCustomerNotes[_i2]);
            }
            return;
        }
        if (ctrl.filterDevice !== null && ctrl.filterUser !== null) {
            for (var _i3 = 0; _i3 < ctrl.originalCustomerNotes.length; _i3++) {
                if (ctrl.originalCustomerNotes[_i3].initials == ctrl.filterUser && ctrl.originalCustomerNotes[_i3].deviceName == ctrl.filterDevice) ctrl.customerNotes.push(ctrl.originalCustomerNotes[_i3]);
            }
            return;
        }
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    ctrl.deviceSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.deviceEvents = {
        onItemSelect: function onItemSelect(item) {
            if (ctrl.deviceData[item.id].label === ctrl.filterDevice) {
                ctrl.filterDevice = null;
                ctrl.deviceModel = [];
            } else {
                ctrl.filterDevice = ctrl.deviceData[item.id].label;
            }
            ctrl.deviceModelLength = ctrl.deviceModel.length;
            ctrl.filterCustomerNotes();
        }
    };
    ////////////////////////////////////////////////////////////////////////////////////////////////
    ctrl.userSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.userEvents = {
        onItemSelect: function onItemSelect(item) {
            if (ctrl.userData[item.id].label === ctrl.filterUser) {
                ctrl.filterUser = null;
                ctrl.userModel = [];
            } else {
                ctrl.filterUser = ctrl.userData[item.id].label;
            }
            ctrl.userModelLength = ctrl.userModel.length;
            ctrl.filterCustomerNotes();
        }
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    $scope.$watch(function () {
        return ctrl.myDate;
    }, function (newVal, oldVal) {
        if (newVal && moment(newVal).format("YYYY/MM/DD") != moment(oldVal).format("YYYY/MM/DD")) {
            var endDate = new Date(newVal.setHours(23, 59, 59, 999));
            ctrl.customerNotes = [];
            ctrl.deviceModel = [];
            ctrl.userModel = [];
            ctrl.filterDevice = null;
            ctrl.filterUser = null;
            ctrl.selectNewDate = true;
            ctrl.getCustomerNotes(endDate);
        }
    });

    $scope.mostRecentData = function () {
        ctrl.customerNotes = [];
        ctrl.deviceModel = [];
        ctrl.userModel = [];
        ctrl.unRegisterListeners();
        ctrl.filterDevice = null;
        ctrl.filterUser = null;
        ctrl.myDate = new Date();
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.getCustomerNotes(ctrl.myDate);
    };

    $scope.savePdf = function () {

        var windowTitle = $scope.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: $scope.translation.text.DISABLED_INPUTS_REPORT,
            customerName: $scope.accountInfo.customerName,
            customerId: $scope.accountInfo.customerId,
            dateTranslate: $scope.translation.text.DATE_CREATED,
            dateRangeStart: $scope.myDateRangeStart,
            dateRangeEnd: $scope.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('deviceSelectedDone', function (event, args) {
        ctrl.deviceSelectedName = args.message;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getDeviceStatusList(_customerId);
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
        ctrl.unRegisterListeners();
    });

    ctrl.wsDataReceivedCustomerNotesRTUBASICINFOSETTING = function (data) {
        if (data.Type == 'DEVICEBASICINFO') {
            for (var i = 0; i < ctrl.customerNotes.length; i++) {
                if (ctrl.customerNotes[i].serialNumber == data.SN && data.Value.path == "name") {
                    ctrl.customerNotes[i].deviceName = data.Value.value;
                }
            }
        }
    };

    ctrl.wsDataReceivedDevicesRTUBASICINFOSETTING = function (data) {
        if (data.Type == 'DEVICEBASICINFO') {
            for (var i = 0; i < ctrl.devices.length; i++) {
                if (ctrl.devices[i].serialNumber == data.SN && data.Value.path == "name") {
                    ctrl.devices[i].name = data.Value.value;
                }
            }
            var tmp = [];
            for (var i = 0; i < ctrl.devices.length; i++) {
                tmp.push({ id: i, label: ctrl.devices[i].name });
            }
            ctrl.deviceData = tmp;
        }
    };

    ctrl.registerListeners = function () {
        websocketService.connect();
        for (var i = 0; i < ctrl.customerNotes.length; i++) {
            websocketService.register("DEVICEBASICINFO", ctrl.customerNotes[i].serialNumber, 0, ctrl.wsDataReceivedCustomerNotesRTUBASICINFOSETTING, null);
        }
        for (var i = 0; i < ctrl.devices.length; i++) {
            websocketService.register("DEVICEBASICINFO", ctrl.devices[i].serialNumber, 0, ctrl.wsDataReceivedDevicesRTUBASICINFOSETTING, null);
        }
    };

    ctrl.unRegisterListeners = function () {
        for (var k = 0; k < ctrl.customerNotes.length; k++) {
            websocketService.unRegister("DEVICEBASICINFO", ctrl.customerNotes[k].serialNumber, 0, ctrl.wsDataReceivedCustomerNotesRTUBASICINFOSETTING, null);
        }
        for (var k = 0; k < ctrl.devices.length; k++) {
            websocketService.unRegister("DEVICEBASICINFO", ctrl.devices[k].serialNumber, 0, ctrl.wsDataReceivedDevicesRTUBASICINFOSETTING, null);
        }
    };
};

CustomerNotesController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'CustomerNotesFactory', '$uibModal', '$location', 'deviceMenuService', 'timeLapseService', 'datetimeService', 'deviceNotificationSettingService', 'savePdfService', 'toaster', 'websocketService'];
'use strict';

angular.module('mc.customer-notes').component('customerNotes', {
    controller: CustomerNotesController,
    templateUrl: 'ui/customernotes/customer-notes-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("application-portal", []);
'use strict';

function ApplicationPortalFactory(HOST, $http, $rootScope, $window, $location, AuthorizeAccessFactory, CustomerSearchRecentFactory, AdminPortalService, $timeout, $uibModal) {
    var _this = this;

    // instantiate our initial object
    var ApplicationPortal = function ApplicationPortal(customerId) {
        this.customerId = customerId;
    };

    ApplicationPortal.prototype.getData = function () {
        var self = this;
        var viewMode = $rootScope.mobileApp === true ? 4 : $rootScope.mobile === true ? 3 : $rootScope.classicView === true ? 2 : 1;

        return $http.get(HOST + '/api/account' + '?customerId=' + this.customerId + "&viewMode=" + viewMode).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    ApplicationPortal.prototype.switchCustomer = function (cust, busyLoading) {

        if (busyLoading !== null) busyLoading = true;

        var _customerToken = new AuthorizeAccessFactory();
        var _customerSearchRecentFactory = new CustomerSearchRecentFactory();
        var _recentCustomerList = _customerSearchRecentFactory.getRecentCustomerList();

        _customerToken.authorize(cust.customerId).then(function () {
            var authorizeAccessToken = _customerToken.data.token;
            var authorizeUserRole = _customerToken.data.userRole;
            if (busyLoading !== null) busyLoading = false;

            var customer = {
                id: cust.customerId,
                token: authorizeAccessToken,
                userRole: authorizeUserRole
            };

            $window.sessionStorage.customer = JSON.stringify(customer);

            if ($location.path().indexOf("/portal") >= 0 && !AdminPortalService.getPin()) {
                var newTab = $window.open($location.absUrl().replace($location.path(), "/application/portal"), '_blank');
                $window.sessionStorage.removeItem("customer");

                if (!newTab || newTab.closed || typeof newTab.closed == 'undefined') {
                    ApplicationPortal.prototype.displayBrowserInstructions();
                }
            } else {
                $timeout(function () {
                    $location.url("/application/portal");
                }, 0);
            }
            _customerSearchRecentFactory.setRecentCustomerList(cust);
        });
    };

    ApplicationPortal.prototype.displayBrowserInstructions = function (varInt) {
        function modalController($uibModalInstance, translationService, detectBrowserService, $rootScope) {
            this.translation = translationService.translation;
            this.userMessage = this.translation.text.BROWSER_POPUP_ERROR;

            this.userAgent = navigator.userAgent.toLowerCase();
            this.isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(this.userAgent);

            this.browserInstructions = _getBrowserInstructions(detectBrowserService(), this.isTablet);

            this.ok = function () {
                $uibModalInstance.dismiss();
            };

            this.cancel = function () {
                $uibModalInstance.dismiss();
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translationService', 'detectBrowserService', '$rootScope'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/new-tab-issue-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'm',
            resolve: {
                translation: function translation() {
                    return _this.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            //Ok
        }, function () {
            //Cancel
        });

        var _getBrowserInstructions = function _getBrowserInstructions(browser, tablet) {

            if (browser.toLowerCase() === "safari" && tablet === true) return "<b>" + browser.toUpperCase() + ", Turn pop-ups off on an iPad:</b>" + "<br>" + "<ol type = '1'>" + "<li>Start the Settings app.</li>" + "<li>In the pane on the left, tap 'Safari.'</li>" + "<li>In the General section, turn off 'Block Pop-ups' by swiping the switch to the left.</li>" + "<li><img src='images/safari-popups.jpg' height='300'></li>" + "</ol>";

            switch (browser.toLowerCase()) {
                case "firefox":
                default:
                    return "<b>" + browser.toUpperCase() + ", Turn pop-ups off:</b>" + "<br>" + "<ol type = '1'>" + " <li>On your computer, open " + browser.toUpperCase() + ".</li>" + " <li>At the top right, click to open menu (the icon of three horizontal lines in the top right of the browser window).</li>" + " <li> Select Options.</li>" + "<li>Under 'Privacy and security', go to Permissions.</li>" + " <li>Uncheck Block pop-up windows option.</li>" + " <li>Close the browser setting.</li>" + " <li>Refresh the page before continuing.</li>" + "</ol>";
            }
        };
    };

    return ApplicationPortal;
}

ApplicationPortalFactory.$inject = ['HOST', '$http', '$rootScope', '$window', '$location', 'AuthorizeAccessFactory', 'CustomerSearchRecentFactory', 'AdminPortalService', '$timeout', '$uibModal'];

angular.module('application-portal').factory('ApplicationPortalFactory', ApplicationPortalFactory);
"use strict";

function ApplicationPortalController($, $rootScope, $scope, $timeout, $window, authenticationService, translationService, $location, desktopViewService, ApplicationPortalFactory, AccountInfoService, deviceMenuService) {
    var ctrl = this;
    $scope.alerts = [];
    ctrl.loading = true;
    $rootScope.CustomerNameStart = null;

    ctrl.$onInit = function () {
        //sharedSetupService.getWindowId(this);

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;

        var tmpCustomer = $window.sessionStorage.getItem("customer");
        $window.sessionStorage.removeItem("customer");

        var tmpAuthorizationInfo = $window.sessionStorage.getItem("authorizationInfo");
        $window.sessionStorage.removeItem("authorizationInfo");

        var objCustomer = $.parseJSON(tmpCustomer);
        ctrl.newCustomerId = objCustomer.id;
        ctrl.newToken = objCustomer.token;

        var _newUserInfo = { userRole: objCustomer.userRole };

        var objAuthorizationInfo = $.parseJSON(tmpAuthorizationInfo);
        ctrl.newUserName = objAuthorizationInfo.userName;
        ctrl.newRefreshToken = objAuthorizationInfo.refreshToken;
        ctrl.newRefreshTokens = objAuthorizationInfo.useRefreshTokens;
        ctrl.newExpires = objAuthorizationInfo.expires;

        var authorizationInfo = {
            token: ctrl.newToken,
            userName: ctrl.newUserName,
            refreshToken: ctrl.newRefreshToken,
            useRefreshTokens: ctrl.newRefreshToken,
            expires: ctrl.newExpires
        };
        $window.sessionStorage.authorizationInfo = JSON.stringify(authorizationInfo);

        var _applicationPortal = new ApplicationPortalFactory(ctrl.newCustomerId);
        _applicationPortal.getData().then(function () {

            AccountInfoService.getAccountInfo(ctrl.accountInfo, _applicationPortal.data, true);
            AccountInfoService.updateAccountInfoUserData(ctrl.accountInfo, _newUserInfo);

            ctrl.setGermantownMenuTemplate();
            $window.sessionStorage.accountInfo = JSON.stringify(ctrl.accountInfo);
            $rootScope.CustomerNameStart = ctrl.accountInfo.customerName;
            deviceMenuService.resetDeviceMenuList();
            deviceMenuService.resetRainfallDeviceMenuList();
            deviceMenuService.resetAllDevicesRainfallMenuList();
            $rootScope.readyClassicView = true;
            $timeout(function () {
                var _path = $scope.classicView ? "map/map" : "/";
                $location.path(_path).replace();
            }, 0);
            ctrl.loading = false;
        }, function (error) {
            console.log(error);
            ctrl.loading = false;
        });
    };

    ctrl.setGermantownMenuTemplate = function () {
        switch (ctrl.accountInfo.customerId) {
            case 597:
            case 15177:
            case 15147:
                $rootScope.menuTemplate = "germantown";
                break;
            default:
                $rootScope.menuTemplate = "main";
        }
    };

    $scope.$on("$destroy", function () {
        desktopViewService.closeAllViews();
        ctrl.loading = false;
    });
}

ApplicationPortalController.$inject = ['$', '$rootScope', '$scope', '$timeout', '$window', 'authenticationService', 'translationService', '$location', 'desktopViewService', 'ApplicationPortalFactory', 'AccountInfoService', 'deviceMenuService'];
'use strict';

angular.module('application-portal').component('applicationPortal', {
    controller: ApplicationPortalController,
    templateUrl: 'ui/application/application-portal-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.customer-lookup", []);
'use strict';

function CustomerLookupController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, $timeout, $filter, toaster, $uibModal, wizardSplashService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        sharedSetupService.getWindowId(_this2);
        ctrl.initializeSetting();
        ctrl.customerLookupTabs = ctrl.tabConfiguration.filter(function (v) {
            return v.access.includes(ctrl.accountInfo.userType);
        });

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    adjustSize();
                }
            });
        }
    };

    var adjustSize = function adjustSize() {
        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

        //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
        //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": "CustomerSearch",
            "name": ctrl.translation.text.SEARCH,
            "templateName": "Customer Search",
            "templateUrl": "ui/customersearch/customer-search.html",
            "height": 150,
            "access": ["TechSupport"]
        }, {
            "id": "CustomerList",
            "name": ctrl.translation.text.LIST,
            "templateName": "Customer List",
            "templateUrl": "ui/customerlist/customer-list.html",
            "height": 135,
            "access": ["Customer", "Distributor", "RSM", "TechSupport"]
        }, {
            "id": "ManagedSites",
            "name": ctrl.translation.text.MANAGED_SITES,
            "templateName": "Customer List",
            "templateUrl": "ui/customerlist/customer-list-managed-sites.html",
            "height": 135,
            "access": ctrl.accountInfo.managedSites ? ["Customer", "Distributor", "RSM", "InvestorOwnedUtility", "TechSupport"] : []
        });
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {
        //save wizard step status if wizard splash lauched this view.
        if ($rootScope.launchedByWizard) {
            wizardSplashService.SaveWizardStepStatus(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, $rootScope.wizardId, ctrl.windowId, 2); //save status as completed (2: status complete)
            $rootScope.$broadcast('wizardSplashStepClosed');
        }
    });
};

CustomerLookupController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$timeout', '$filter', 'toaster', '$uibModal', 'wizardSplashService'];
'use strict';

angular.module('mc.customer-lookup').component('customerLookup', {
    controller: CustomerLookupController,
    templateUrl: 'ui/customerlookup/customer-lookup-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.contact-information', []);
"use strict";

function ContactInformationFactory(HOST, $http) {

    // instantiate our initial object
    var ContactInformation = function ContactInformation(customerId) {
        this.customerId = customerId;
    };

    ContactInformation.prototype.getData = function (ZIP) {
        var self = this;
        return $http.get(HOST + "/api/CustomerContact" + "?customerId=" + this.customerId + "&" + "ZIP=" + ZIP).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return ContactInformation;
}

ContactInformationFactory.$inject = ['HOST', '$http'];

angular.module('mc.contact-information').factory('ContactInformationFactory', ContactInformationFactory);
'use strict';

function contactInformationController($, $rootScope, $scope, $location, sharedSetupService, openViewService, translationService, authenticationService, $uibModal, $element, $timeout, datetimeService, ContactInformationFactory, $cookies) {

    var ctrl = this;
    ctrl.mobile = $rootScope.mobile;
    ctrl.classicView = $rootScope.classicView;
    ctrl.isTicketSystemAvailable = true;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl._loading = true;
        ctrl.adminUser = $cookies.get('AdminUser1') != null ? true : false;
        ctrl.pagingViewHeightAdjustment = 1000;
        ctrl.editModeIndex = null;
        ctrl.editMode = null;
        ctrl.addMode = null;
        ctrl.myModalTemplate = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.customerName = ctrl.accountInfo.customerName;
        ctrl.address1 = ctrl.accountInfo.address1;
        ctrl.address2 = ctrl.accountInfo.address2;
        ctrl.address3 = ctrl.accountInfo.city + ' ' + ctrl.accountInfo.state + ', ' + ctrl.accountInfo.zip;
        ctrl.phone = ctrl.accountInfo.customerPhone;
        ctrl.fax = ctrl.accountInfo.fax;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId;
        $scope.windowTitle = ctrl.windowTitle;
        //Check if ZIP is int, else it is a Canada address so set to 0
        ctrl.accountInfo.zip = isNaN(ctrl.accountInfo.zip) ? 0 : ctrl.accountInfo.zip;
        //Get Contact Info
        ctrl.getContactInformation();
    };

    ctrl.getContactInformation = function () {

        var _contactInformation = new ContactInformationFactory(ctrl.accountInfo.customerId);
        _contactInformation.getData(ctrl.accountInfo.zip).then(function () {
            ctrl.distributor = _contactInformation.data.distributor;
            ctrl.techArray = _contactInformation.data.techSupport;
            ctrl.techArray.map(function (tech) {
                return tech.phone = 6789690021;
            });

            ctrl._loading = false;
            //Adjust height to match content
            if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.viewAutoHeight(ctrl.windowId);
            //Get row styling based on amount of data
            ctrl.distributorStyle = ctrl.distributorStyleCheck();
            ctrl.customerStyle = ctrl.customerStyleCheck();
            ctrl.techStyle = ctrl.techStyleCheck();

            ctrl.isTicketSystemAvailable = isTicketSystemAvailable();
        });
    };

    ctrl.customerStyleCheck = function () {
        var rowCount = 0;
        if (ctrl.customerName) {
            rowCount++;
        }
        if (ctrl.address1) {
            rowCount++;
        }
        if (ctrl.address2) {
            rowCount++;
        }
        if (ctrl.address3) {
            rowCount++;
        }
        if (ctrl.phone) {
            rowCount++;
        }
        if (ctrl.fax) {
            rowCount++;
        }

        if (rowCount <= 1) {
            return 'margin-top: 7px;';
        } else {
            return 'margin-top: ' + 7 * rowCount + 'px;';
        }
    };

    ctrl.distributorStyleCheck = function () {
        var rowCount = 0;
        if (ctrl.distributor.name) {
            rowCount++;
        }
        if (ctrl.distributor.address) {
            rowCount++;
        }
        if (ctrl.distributor.state && ctrl.distributor.city && ctrl.distributor.zip) {
            rowCount++;
        }
        if (ctrl.distributor.country && ctrl.distributor.country != "USA") {
            rowCount++;
        }
        if (ctrl.distributor.phone) {
            rowCount++;
        }
        if (ctrl.distributor.regionalManagerName) {
            rowCount = rowCount + 3;
        }

        if (rowCount <= 1) {
            return 'margin-top: 7px;';
        } else {
            return 'margin-top: ' + 8 * rowCount + 'px;';
        }
    };

    ctrl.techStyleCheck = function () {
        return 'margin-top: ' + (20 * ctrl.techArray.length + 40) + 'px;';
    };

    ctrl.newSupportTicket = function () {
        openViewService.openView("Ticket System", { width: 900, height: 600 }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: 900, minimumHeight: 600 }, true);
        //Open Ticket creation
        $timeout(function () {
            $('#ticketSystemNewTicket').click();
        }, 100);
    };

    ctrl.openCommonModal = function (item, deleteUser) {
        function modalController($uibModalInstance, translation) {
            this.translation = translation;
            if (deleteUser) {
                this.tmpConfirmMessageA = this.translation.text.DELETE_ACCOUNT_MESSAGE_A + item.fullName + this.translation.text.DELETE_ACCOUNT_MESSAGE_B;
            } else {
                this.tmpConfirmMessageA = this.translation.text.READONLY_ACCOUNT_MESSAGE_A + item.fullName + this.translation.text.READONLY_ACCOUNT_MESSAGE_B;
            }
            this.tmpConfirmMessageB = this.translation.text.DELETE_ACCOUNT_MESSAGE_C;
            this.ok = function () {
                $uibModalInstance.close(item);
            };

            this.cancel = function () {
                if (!deleteUser) {
                    var index = ctrl.logins.findIndex(function (l) {
                        return l.userId == item.userId;
                    });
                    ctrl.logins[index].administrator = true;
                }

                $uibModalInstance.dismiss('cancel');
            };
        }

        modalController.$inject = ['$uibModalInstance', 'translation'];

        var modalInstance = $uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'ui/components/scadaviews/confirmation-popover.html',
            controller: modalController,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
                translation: function translation() {
                    return ctrl.translation;
                }
            }
        });

        modalInstance.result.then(function (item) {
            if (deleteUser) {
                var _contactInformation = new contactInformation(ctrl.accountInfo.customerId);
                _contactInformation.delete(item.userId, item.userName).then(function (resp) {
                    var index = ctrl.logins.indexOf(item);
                    if (index !== -1) {
                        ctrl.logins.splice(index, 1);
                    }
                    ctrl.addMode = null;
                    ctrl.editMode = null;
                });
            } else {

                var propertyName = 'administrator';
                ctrl.updateValue(item, propertyName);
            }
        }, function () {
            // cancel button
        });
    };

    var isTicketSystemAvailable = function isTicketSystemAvailable() {
        // if Ticket System is available to current user, then ONLY they should be able to create ticket from Contact Information view
        var foundMenuItem = ctrl.accountInfo.menuItems.find(function (item) {
            return item.name === "Ticket System";
        });
        return foundMenuItem ? true : false;
    };
}

contactInformationController.$inject = ['$', '$rootScope', '$scope', '$location', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$uibModal', '$element', '$timeout', 'datetimeService', 'ContactInformationFactory', '$cookies'];
'use strict';

angular.module('mc.contact-information').component('contactInformation', {
    controller: contactInformationController,
    controllerAs: '$ctrl',
    templateUrl: 'ui/contactinformation/contact-information-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.controller('communicationController', ["$scope", "translationService", "sharedSetupService", function ($scope, translationService, sharedSetupService) {
    $scope.WebSocketMesasge = "";
    $scope.translation = translationService.translation;
    sharedSetupService.getWindowId($scope);
}]);

mcapp.directive('communicationDirective', [function () {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        angular.forEach(['WebSocketService', 'Heartbeat'], function (broadcast) {
            var intBr;
            scope.$on(broadcast, function (event, args) {
                intBr = 0;
                angular.forEach(args.message, function (val, i) {
                    element.find("span:first").append((intBr === 0 ? "" : ", ") + val);
                    intBr = 1;
                });
                element.find("span:first").append("<br>");
                element.parent().animate({
                    scrollTop: element.css("height").replace(/[^0-9.]+/g, "") + "px"
                }, 0);
            });
        });
    };
}]);


mcapp.controller("analogWidgetController", ['$', "$scope", "$rootScope", "authenticationService", "translationService", "sharedSetupService", "$element",
    function ($, $scope, $rootScope, authenticationService, translationService, sharedSetupService, $element) {
        $scope.liveData = true;
        $scope.Channel = [];
        $scope.fontSizeDefault = ".95em";
        $scope.closeIcon = false;
        $scope.channelName = null;

        $scope.alerts = [];
        $scope.translation = translationService.translation;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;

        sharedSetupService.getWindowId($scope);
        if (typeof $scope.stickyProperties != 'object') { $scope.stickyProperties = $scope.stickyPropertiesInterface; }

        $scope.setSetting = function () {
            $scope.analogDeviceSelectedId = { "deviceId": $scope.stickyProperties.device.deviceId };
            $scope.analogChannelSelected = { "deviceId": $scope.stickyProperties.device.deviceId, "channel": $scope.stickyProperties.device.channel };
            $scope.preAnalogDeviceSelected = $scope.stickyProperties.device;
        };

        $scope.setSetting();

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            $scope.closeWidget = function () {
                $element.find(".flip-container").hide();
                $scope.popup.dialog("close");
            };

            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.resizeContent();
                    $scope.$apply();
                }
            });

            $scope.resizeContent = function () {
                if (!$element.find(".gauge-widget-icon").highcharts())
                    return;
                $element.find('circle:not(:last)').each(function () {
                    $(this).remove();
                });

                var _newWidth = $scope.popup.parent().css("width").replace(/[^0-9.]+/g, "");
                var _newHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $element.find('.widgetSettingNew').css("width", _newWidth < 240 ? 240 : _newWidth)
                    .css("margin-left", _newWidth < 240 ? -(240 - _newWidth) / 2 : "auto");

                $scope.popup.parent().find('.gauge-widget-icon')
                    .css("width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.gauge-widget-icon')
                    .css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "")); //25: total padding
                var _char = $element.find(".gauge-widget-icon").highcharts();
                _char.setSize(
                    $scope.popup.parent().find('.gauge-widget-icon').css("width").replace(/[^0-9.]+/g, "") * 1,
                    ($scope.popup.parent().find('.gauge-widget-icon').css("height").replace(/[^0-9.]+/g, "") -
                        $scope.popup.parent().find('.widget-title').css("height").replace(/[^0-9.]+/g, "")) *
                    0.95,
                    false
                );
                var _fontSize = _newWidth < _newHeight ? _newWidth / 12 : _newHeight / 12;
                _fontSize = _fontSize < 12 ? 12 : _fontSize > 35 ? 35 : _fontSize;
                _char.container.parentNode.style.fontSize = _fontSize + "px";
                _char.reflow();
            };

        } else {
            $scope.popup = $(".flip-container");
            $scope.resizeContent = function () {
                if (!$element.find(".gauge-widget-icon").highcharts())
                    return;
                $element.find('circle:not(:last)').each(function () {
                    $(this).remove();
                });

                var _char = $element.find(".gauge-widget-icon").highcharts();

                var _fontSize = 25;
                _char.container.parentNode.style.fontSize = _fontSize + "px";
                _char.reflow();
            }
        }

        var timer;
        var firstover = true;


    }]);
mcapp.directive('analogWidgetDirective', ['$rootScope', "authenticationService", "websocketService", "analogWidgetService", "deviceService", "toaster", "$filter", "$document", "sharedSetupService", "$timeout",
    function ($rootScope, authenticationService, websocketService, analogWidgetService, deviceService, toaster, $filter, $document, sharedSetupService, $timeout) {
        function link(scope, element, attrs) {
            var chart;
            // element.attr("class", "widget dragwidget");
            scope.drawGauge = function (deviceId, channelId) {

                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, windowId: scope.windowId });
                analogWidgetService.getData(scope.accountInfo.customerId, deviceId, channelId)
                    .then(function (result) {
                        // if (result.data.length > 0) {
                        scope.gaugeServerData = result.data;
                        websocketService.connect();
                        scope.device = result.data.device;
                        websocketService.unRegister("ANALOG", scope.preAnalogDeviceSelected.serialNumber, scope.preAnalogDeviceSelected.channel, wsDataReceivedAW, wsReconnectAW);
                        websocketService.register("ANALOG", scope.device.serialNumber, scope.analogChannelSelected.channel, wsDataReceivedAW, wsReconnectAW);
                        websocketService.unRegister("ANALOG_G2", scope.preAnalogDeviceSelected.serialNumber, scope.preAnalogDeviceSelected.channel, _wsUpdateAnalogG2, wsReconnectAW);
                        websocketService.register("ANALOG_G2", scope.device.serialNumber, scope.analogChannelSelected.channel, _wsUpdateAnalogG2, wsReconnectAW);
                       
                        //Register For Analog Seting Changes
                        websocketService.unRegister("ANALOGSETTING", scope.preAnalogDeviceSelected.serialNumber, scope.preAnalogDeviceSelected.channel, wsDataReceivedANALOGSETTINGAW, wsReconnectAW);
                        websocketService.register("ANALOGSETTING", scope.preAnalogDeviceSelected.serialNumber, scope.preAnalogDeviceSelected.channel, wsDataReceivedANALOGSETTINGAW, wsReconnectAW);

                        scope.preAnalogDeviceSelected = result.data.device;

                        //Set default analogGauge if No data
                        result.data.analogGauge = result.data.analogGauge ? result.data.analogGauge : {};
                        result.data.analogGauge.lowAlarm = result.data.analogGauge ? result.data.analogGauge.lowAlarm == '0' ? result.data.analogGauge.minVal : result.data.analogGauge.lowAlarm : '0';
                        result.data.analogGauge.highAlarm = result.data.analogGauge ? result.data.analogGauge.highAlarm == '0' ? result.data.analogGauge.maxVal : result.data.analogGauge.highAlarm : '0';
                        //scope.Channel.push(result.data.analogGauge.channel);
                        drawAnalogGauge(result.data.analogGauge, result.data.device);
                        scope.resizeContent();
                        $timeout(function () {
                            scope.resizeContent();
                        }, 0); //need second call to adjust alignment
                    }, function (error) {
                        scope.alerts = [];
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                        scope.resizeContent();
                        $timeout(function () {
                            scope.resizeContent();
                        }, 0); //need second call to adjust alignment
                    });
            };

            scope.getPlotBands = function (data) {
                var plotBands = [];
                var A = data.minVal, B = data.lowAlarm, C = data.highAlarm, D = data.highHighAlarm, E = data.maxVal;

                var plotAB = {
                    from: data.minVal,
                    to: data.lowAlarm,
                    color: '#DF5353' // red
                };

                var plotAC = {
                    from: data.minVal,
                    to: data.highAlarm,
                    color: '#55BF3B' // green
                };

                var plotAD = {
                    from: data.minVal,
                    to: data.highHighAlarm,
                    color: '#55BF3B' // green
                };

                var plotBC = {
                    from: data.lowAlarm,
                    to: data.highAlarm,
                    color: '#55BF3B' // green
                };

                var plotBE = {
                    from: data.lowAlarm,
                    to: data.maxVal,
                    color: '#55BF3B' // green
                };

                var plotCE = {
                    from: data.highAlarm,
                    to: data.maxVal,
                    color: '#DF5353' // red
                };

                var plotCD = {
                    from: data.highAlarm,
                    to: data.highHighAlarm,
                    color: '#DF5353' // red
                };

                var plotDE = {
                    from: data.highHighAlarm,
                    to: data.maxVal,
                    color: '#8B0000' // dark red
                };

                var plotSetupIsOff = {
                    from: data.minVal,
                    to: data.maxVal,
                    color: '#55BF3B' // green
                };

                if (A < B && B < C && C < D && D < E) {
                    plotBands.push(plotAB);
                    plotBands.push(plotBC);
                    //plotBands.push(plotCE);
                    plotBands.push(plotCD);
                    plotBands.push(plotDE);
                }
                else if (A < B && B < E) {
                    plotBands.push(plotAB);
                    plotBands.push(plotBE);
                    if (B < C && C < E) plotBands.push(plotCE);
                    if (B < D && D < E) plotBands.push(plotDE);
                }
                else if (A < C && C < E) {
                    plotBands.push(plotAC);
                    plotBands.push(plotCE);
                    if (C < D && D < E) plotBands.push(plotDE);
                }
                else if (A < D && D < E) {
                    plotBands.push(plotAD);
                    plotBands.push(plotDE);
                }
                else if (A > B && B > C && C > D && D > E) {
                    plotBands.push(plotAB);
                    plotBands.push(plotBC);
                    plotBands.push(plotCE);
                    plotBands.push(plotCD);
                    plotBands.push(plotDE);
                }
                else if (A > B && B > E) {
                    plotBands.push(plotAB);
                    plotBands.push(plotBE);
                    if (B > C && C > E) plotBands.push(plotCE);
                    if (B > D && D > E) plotBands.push(plotDE);
                }
                else if (A > C && C > E) {
                    plotBands.push(plotAC);
                    plotBands.push(plotCE);
                    if (C > D && D > E) plotBands.push(plotDE);
                }
                else if (A > D && D > E) {
                    plotBands.push(plotAD);
                    plotBands.push(plotDE);
                }
                else {
                    plotBands.push(plotSetupIsOff);
                }
                return plotBands;
            };

            scope.getTickPositions = function (data) {
                var tickPositions = [];
                var A = data.minVal, B = data.lowAlarm, C = data.highAlarm, D = data.highHighAlarm, E = data.maxVal;

                tickPositions.push(A);
                tickPositions.push(E);
                if (A < B && B < C && C < D && D < E) {
                    if ((B - A) > ((E - A) * 3 / 100))
                        tickPositions.push(B);
                    if ((E - C) > ((E - A) * 3 / 100))
                        tickPositions.push(C);
                    if ((E - D) > ((E - A) * 3 / 100))
                        tickPositions.push(D);
                }
                if (A < B && B < E) {
                    if ((B - A) > ((E - A) * 3 / 100))
                        tickPositions.push(B);
                }
                if (A < C && C < E) {
                    if ((E - C) > ((E - A) * 3 / 100))
                        tickPositions.push(C);
                }
                if (A < D && D < E) {
                    if ((E - D) > ((E - A) * 3 / 100))
                        tickPositions.push(D);
                }
                if (A > B && B > C && C > E && D > E) {
                    if ((A - B) > ((A - E) * 3 / 100))
                        tickPositions.push(B);
                    if ((C - E) > ((A - E) * 3 / 100))
                        tickPositions.push(C);
                    if ((D - E) > ((A - E) * 3 / 100))
                        tickPositions.push(D);
                }
                if (A > B && B > E) {
                    if ((A - B) > ((A - E) * 3 / 100))
                        tickPositions.push(B);
                }
                if (A > C && C > E) {
                    if ((C - E) > ((A - E) * 3 / 100))
                        tickPositions.push(C);
                }
                if (A > D && D > E) {
                    if ((D - E) > ((A - E) * 3 / 100))
                        tickPositions.push(D);
                }

                return tickPositions;
         
            };
            
            element.attr("class", "gauge-widget-icon");

            var drawAnalogGauge = function (data, device, varContainer) {
                if (varContainer) {
                    $(element).empty();
                }
                var title = scope.translation.text.CHANNEL + ' ' + (data.channel ? data.channel : scope.translation.text.NOT_SETUP);
                scope.channelName = data.name || scope.translation.text.NOT_SETUP;
                var _device = { deviceId: device.deviceId, channel: data.channel, serialNumber: device.serialNumber };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: device.deviceId, device: _device, windowId: scope.windowId });
                if (scope.popup.selector !== ".flip-container" & !$rootScope.mobile && !$rootScope.classicView) scope.popup.dialog("option", "title", scope.device.name + ", " + scope.channelName);
                scope.deviceSelectedName = scope.device.name;
                chart = new Highcharts.Chart({

                    chart: {
                        renderTo: element[0],
                        type: 'gauge',
                        plotBackgroundColor: null,
                        plotBackgroundImage: null,
                        backgroundColor: 'rgba(0,0,0,0)',
                        plotBorderWidth: 0,
                        plotShadow: false,
                        spacing: [0, 0, 0, 0],
                        marginTop: -5,
                        spacingTop: -15,
                        style: {
                            fontSize: '1em'
                        }
                    },

                    title: {
                        text: '',
                        align: 'center',
                        y: 30,
                        style: {
                            color: '#ffffff'
                        }
                    },
                    exporting: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    pane: {
                        startAngle: -150,
                        endAngle: 150

                    },
                    xAxis: {
                        labels: {
                            formatter: function () {
                                return this.value.toString().substring(0, 2);
                            }
                        },

                    },
                    tooltip: {
                        enabled: false
                    },
                    yAxis: {
                        min: (data.minVal > data.maxVal ? data.maxVal : data.minVal),
                        max: (data.minVal > data.maxVal ? data.minVal : data.maxVal),

                        minorTickWidth: 0,

                        reversed: (data.minVal > data.maxVal ? true : false),

                        //   tickPixelInterval: 30,
                        tickWidth: 1,
                        tickLength: 10,
                        tickColor: '#666',
                        tickPositions: scope.getTickPositions(data),
                        labels: {
                            style: {
                                fontSize: '.5em'
                            }

                        },

                        title: {
                            style: {
                                fontSize: '.7em'
                            },
                            text: '<p style="text-align:center; margin-top:5px;">' + title + '</p>'
                        },

                        plotBands: scope.getPlotBands(data)
                    },
                    plotOptions: {

                        gauge: {
                            // innerRadius: '95%',
                            dataLabels: {
                                y: -10,
                                borderWidth: 0,
                                useHTML: true
                            }
                        }
                    },

                    series: [{
                        data: [data.latestData || null],
                        dataLabels: {
                            enabled: true,
                            borderWidth: 0,
                            style: {
                                fontSize: '.8em'
                            },
                            formatter: function () {
                                return '<div style="text-align:center; margin-top:20px;"><span style="font-size:120%; color:' + ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">' + $filter('number')(this.y, sharedSetupService.getNumberOfDecimals(data.maxVal, data.minVal)) + '</span><br/>' + '<span style="font-size:100%;">' + data.unit + '</span></div>';
                            }
                        },
                        overshoot: 30
                    }]

                });
            };

            var distroySingleGauge = function () {
                element.empty();
                scope.alerts = [];
                // websocketService.unRegister("ANALOG", scope.deviceSelectedSn, scope.Channel[i], wsDataReceivedAG);
            };

            var wsDataReceivedAW = function (data) {

                if (scope.analogChannelSelected.channel == data.CH && scope.device.serialNumber === data.SN) {
                    var chart = element.highcharts();
                    chart.series[0].points[0].update(parseFloat(data.Value));
                }
            };

            var _wsUpdateAnalogG2 = function (message) {

                if (scope.deviceSelectedType < 21) return;

                //if (angular.isUndefined(ctrl.currentStatus.analog)) return;

                //if (scope.deviceSelectedType == 20 && message.Ch != 1) return;

                if (scope.analogChannelSelected.channel == message.CH && scope.device.serialNumber === message.SN) {
                    var chart = element.highcharts();
                    chart.series[0].points[0].update(parseFloat(message.Value));
                }
            };

            var wsDataReceivedANALOGSETTINGAW = function (data) {

                if (data.Type == 'ANALOGSETTING') {

                    var _dataChanged = "name, unit, minimumValue, maximumValue";
                    if (scope.analogChannelSelected.channel == data.CH && scope.device.serialNumber === data.SN && _dataChanged.indexOf(data.Value.path) > -1) {

                        _resetViewFromLive(data.CH, data.Value);

                    }
                }
            };


            scope.isTouchSupported = function () {
                var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
                var generalTouchEnabled = "ontouchstart" in document.createElement("div");

                if (msTouchEnabled || generalTouchEnabled) {
                    return true;
                }
                return false;
            };

            scope.mostRecentData = function () {
                wsReconnectAW();
            }

            var wsReconnectAW = function (data) {
                toaster.pop('success', "Analog Widget" + " -- " + scope.device.name, 'View reloading');
                scope.drawGauge(scope.analogDeviceSelectedId.deviceId, scope.analogChannelSelected.channel);
            };

            scope.drawGauge(scope.analogDeviceSelectedId.deviceId, scope.analogChannelSelected.channel);
            if (scope.popup.selector !== ".flip-container" && !$rootScope.mobile && !$rootScope.classicView) scope.popup.dialog("option", "dialogClass", "ui-widget-content-new");

            scope.replaceSpaces = function (str) {
                return str.replace(/ /g, '_');
            };

            scope.$on('document_click', function (e, event) {
                var $tgt = $(event.target);
                if ($tgt.closest('#analog-widget-' + scope.replaceSpaces(scope.windowId)).length === 0 || ($tgt.closest('.back').length === 0 && $tgt.closest('.front').length === 0)) {

                    if (scope.isTouchSupported()) {
                        scope.popup.parent().find(".front").toggle(true);
                        scope.popup.parent().find(".back").toggle(false);
                    } else {
                        $('#analog-widget-' + scope.replaceSpaces(scope.windowId)).offsetParent().offsetParent().find('.flip-container').toggleClass('flip', false);
                    }

                    scope.setSetting();
                    scope.resizeContent();
                }
            });

            scope.popup.parent().on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            if (scope.popup.parent().is('.ui-draggable-dragging, .ui-resizable-resizing') || event.target.nodeName === 'SELECT') {
                                return;
                            }

                            $rootScope.$broadcast('document_click', event);

                            if (scope.isTouchSupported()) {
                                scope.popup.parent().find(".back").toggle();
                                scope.popup.parent().find(".front").toggle();
                            } else {
                                scope.popup.parent().find('.flip-container').toggleClass('flip');
                            }
                            scope.setSetting();
                            scope.resizeContent();
                        }
                    );
                }
            );

            scope.popup.parent().find("select").on(
                "mouseup",
                function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            );

            scope.popup.parent().on(
                "mouseover",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            scope.popup.parent().addClass("x-resize");
                            scope.closeIcon = true;
                        }
                    );
                }
            );

            scope.popup.parent().on(
                "mouseout",
                function (event) {
                    event.preventDefault();
                    var localScope = $(event.target).scope();
                    localScope.$apply(
                        function () {
                            scope.popup.parent().removeClass("x-resize");
                            if (scope.isTouchSupported()) {
                                setTimeout(function () {
                                    scope.closeIcon = false;
                                }, 3000);
                            }
                            else {
                                scope.closeIcon = false;
                            }
                        }
                    );
                }
            );

            scope.$on(
                "$destroy",
                function (event) {
                    websocketService.unRegister("ANALOG", scope.preAnalogDeviceSelected.serialNumber, scope.preAnalogDeviceSelected.channel, wsDataReceivedAW, wsReconnectAW);
                    websocketService.unRegister("ANALOG_G2", scope.preAnalogDeviceSelected.serialNumber, scope.preAnalogDeviceSelected.channel, _wsUpdateAnalogG2, wsReconnectAW);
                    websocketService.unRegister("ANALOGSETTING", scope.preAnalogDeviceSelected.serialNumber, scope.preAnalogDeviceSelected.channel, wsDataReceivedANALOGSETTINGAW, wsReconnectAW);
                    scope.popup.parent().off();
                    scope.popup.parent().find("select").off();
                    if (chart) chart.destroy();
                }
            );

            var _resetView = function (args) {
                var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
                var _lmData = scope.gaugeServerData.analogGauge;
                var _lmDevice = scope.gaugeServerData.device;
                var _container = true;

                _lmData.minVal = _newData.minimumValue;
                _lmData.maxVal = _newData.maximumValue;
                _lmData.name = _newData.name;
                _lmData.unit = _newData.unit;
                drawAnalogGauge(_lmData, scope.device, _container);
                return;
            };

            var _resetViewFromLive = function (channel, patch) {

                var _lmData = scope.gaugeServerData.analogGauge;
                var _lmDevice = scope.gaugeServerData.device;
                var _container = true;

                switch(patch.path)
                {
                    case 'minimumValue':
                        _lmData.minVal = parseInt(patch.value);
                        break;
                    case 'maximumValue' :
                        _lmData.maxVal = parseInt(patch.value);
                        break;
                    case 'name':
                        _lmData.name = patch.value;
                        break;
                    case 'unit' :
                        _lmData.unit = patch.value;
                        break;
                }

                drawAnalogGauge(_lmData, scope.device, _container);
                return;
            };

            var _getArgsFromNewSetting = function (channel, newSetting) {
                for (var i = 0; i < newSetting.length; i++) {
                    if (newSetting[i].channel == channel) {
                        return newSetting[i];
                        //break; line is never reached :JS
                    }
                }
                return null;
            };

            scope.$on('rtuAnalogUpdate', function (event, args) {
                var _dataChanged = "name, unit, minimumValue, maximumValue";
                if (args.deviceId == scope.analogDeviceSelectedId.deviceId && args.channel == scope.analogChannelSelected.channel && _dataChanged.indexOf(args.fieldName) > -1) {
                   // _resetView(args);
                }
            });

            scope.$on('rtuBasicInfoUpdate', function (event, args) {
                _resetView();
            });

            scope.$on('updatePreferencesLanguage', function () {
                scope.drawGauge(scope.analogDeviceSelectedId.deviceId, scope.analogChannelSelected.channel);
            });
        }
        return {
            link: link
        };

    }
]);

mcapp.directive('analogSettingDirective', ["authenticationService", "websocketService", "analogWidgetService", "deviceService", "toaster",
    function (authenticationService, websocketService, analogWidgetService, deviceService, toaster) {
        function link(scope, element, attrs) {
            scope.targetField = null;
            scope.getSetting = function () {
                analogWidgetService.getSettings(scope.accountInfo.customerId)
                    .then(function (result) {
                        scope.analogDevices = result.data.analogDevices;
                        scope.analogSettings = result.data.analogSettings;

                        scope.getChannels();
                    }, function (error) {
                    });
            };

            scope.getChannels = function () {
                scope.analogChannels = [];

                angular.forEach(scope.analogSettings, function (analogSetting) {
                    if (parseInt(scope.analogDeviceSelectedId.deviceId) === parseInt(analogSetting.deviceId)) {
                        scope.analogChannels.push(analogSetting);
                    }
                });

                if (scope.analogDeviceSelectedId.deviceId == scope.stickyProperties.device.deviceId) {
                    scope.analogChannelSelected.channel = scope.stickyProperties.device.channel;
                } else {
                    scope.analogChannelSelected.channel = scope.analogChannels[0].channel;
                }

            };

            scope.getSetting();

            scope.getBackToAnalogData = function (deviceId, channel) {

                if (deviceId != null)
                    scope.drawGauge(deviceId, channel);


            };

            scope.getAnalogData = function () {
                if (scope.targetField === "analogDeviceSelectedId") scope.getChannels();
                scope.drawGauge(scope.analogDeviceSelectedId.deviceId, scope.analogChannelSelected.channel);
                if (scope.targetField === "analogChannelSelected") {
                    scope.popup.parent().find('.flip-container').toggleClass('flip');
                    if (scope.isTouchSupported()) {
                        scope.popup.parent().find(".back").toggle();
                        scope.popup.parent().find(".front").toggle();
                    }
                }
                scope.resizeContent();
            };

            scope.focusCallback = function ($event) {
                if ($event.target === null) {
                    return;
                }
                scope.targetField = $($event.target).attr("ng-model");
            };

            var _resetView = function () {
                scope.getSetting();
            };

            scope.$on('rtuAnalogUpdate', function (event, args) {
                var _dataChanged = "name, unit";
                if (args.deviceId == scope.analogDeviceSelectedId.deviceId && args.channel == scope.analogChannelSelected.channel && _dataChanged.indexOf(args.fieldName) > -1) {
                    _resetView();
                }
            });

            scope.$on('rtuBasicInfoUpdate', function (event, args) {
                _resetView();
            });
        }
        return {
            link: link
        };
    }
]);
mcapp.factory("analogWidgetService", ["$http", "HOST", function ($http, HOST) {
    var analogWidgetFatory = {};

    var _getData = function (customerId, deviceId, channelId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/Analog/Widget?customerId=' + customerId + '&deviceId=' + deviceId + '&channelId=' + channelId,
            cache: false
        });
    };

    var _getSettings = function (customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/Analog/Widget?customerId=' + customerId,
            cache: false
        });
    };
    analogWidgetFatory.getSettings = _getSettings;
    analogWidgetFatory.getData = _getData;
    return analogWidgetFatory;

}]);

mcapp.controller('analogTableController', ['$scope', '$rootScope', 'sharedSetupService', 'openViewService', 'translationService', 'detectBrowserService', '$element', 'authenticationService', function ($scope, $rootScope, sharedSetupService, openViewService, translationService, detectBrowserService, $element, authenticationService) {
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.alerts = [];
    $scope.curentBrowser = detectBrowserService();
    $scope.downloadViewTypeOptions = [0, 4];

    sharedSetupService.broadcastAllDeviceSelected($scope);
    sharedSetupService.getWindowId($scope);
    $scope.selectMyDate = function (date) {
        $scope.myDate = date;
        $scope.selectMyDateT();
    };

    //THE-51649: header and body are one table now, so the live-data line lands
    //on the <thead> instead of the removed .headertable
    $scope.liveTable = $element.find(".analog-table-thead");

    $scope.liveDataLine = function (varLiveData) {
        if (varLiveData) {
            $scope.liveTable.addClass("live-data-line");
        } else {
             $scope.liveTable.removeClass("live-data-line");
        }
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
        $scope.analogTableService.items = angular.copy($scope.analogTableService.items);
    });

    $scope.$on('updatePreferencesLanguage', function () {
        $scope.updateSetting();
    });

    $scope.updateSetting = function () {
        $scope.analogTableService.setting = angular.copy($scope.analogTableService.setting);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        //THE-51575: jQuery UI renders the window title as a plain <span>; role/aria-level expose
        //it as an <h2> without Bootstrap's h2 styling. children() so a .ui-dialog-title inside
        //the view content is never matched
        $scope.popup.dialog('widget').children(".ui-dialog-titlebar").children(".ui-dialog-title").attr({ "role": "heading", "aria-level": "2" });
        sharedSetupService.maximize($scope.popup);

        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function (event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            if($scope.popup.parent().length > 0) {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                //THE-51649: no .headertable term any more - the header is a sticky
                //<thead> inside .tabular-data-container, so its height is the
                //container's now
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            }
        };

        $scope.adjustDeviceIdMenuSize = function () {
            var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            if (spph < 450) {
                $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            }
            else {
                $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        };
    }
}]);

mcapp.directive('drawAnalogData', ['$rootScope', '$timeout', 'analogTableService', 'datetimeService', 'timeLapseService', 'websocketService', 'toaster', 'sharedSetupService', 'debounceService',
    function ($rootScope, $timeout, analogTableService, datetimeService, timeLapseService, websocketService, toaster, sharedSetupService, debounceService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }
        var callInCountTimeout;
        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        var paddingZoom = Math.round((scope.stickyProperties.zoomMax - scope.stickyProperties.zoomMin) / 2);
        paddingZoom = paddingZoom === 0 ? scope.unixDay / 2 : paddingZoom;

        scope.trgScroll = function () {
            $timeout(function () {
                //THE-51649: "tbody tr" so the sticky header row is never mistaken for a data row
                var $rowFirst = element.find("tbody tr").first();
                var _firstRow = $rowFirst.attr("name");
                if (typeof $rowFirst.position() !== "undefined") {
                    var _tableTop = element.offset().top;
                    var _rowTop = $rowFirst.offset().top;
                    _setLiveDataStatus(_firstRow, _tableTop < (_rowTop + 200));
                }
            }, 0);
        };

        scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
          if (scope.alerts.length > 0) {
            var _msg = eval("scope.translation.message." + scope.alerts[0].languageCode.toUpperCase());
            var _type = scope.alerts[0].type;
            var _languageCode = scope.alerts[0].languageCode;
            if (_languageCode.toUpperCase() === 'NO_DATA') {
              _msg += ': ' + moment(scope.analogTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(scope.analogTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
            }
            scope.alerts = [];
            scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
          }
        });

        element.on('scroll', function (event) {
            //THE-51649: was contents().find("tr:first"/"tr:last"), which would now
            //match the sticky header row
            var $rowFirst = element.find("tbody tr").first();
            var $rowLast = element.find("tbody tr").last();
            if (typeof $rowFirst.position() !== "undefined") {
                scope.infiniteScrollOn = true; scope.infiniteScrollUpOn = true; scope.infiniteScrollDownOn = true;
                scope.trgScroll();
                previousScrollbarPosition = currentScrollbarPosition;
                currentScrollbarPosition = element[0].scrollTop;
            }

            if (scope.infiniteScrollOn === true) {
                scope.infiniteScrollUpOn = true;
                scope.infiniteScrollDownOn = true;

                if (scope.infiniteScrollDownOn === true && (element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight)) {
                    $rowLast.addClass("active-row");
                	scope.analogTableService.alerts =[];
                	scope.analogTableService.nextPage();
                }
                if (scope.infiniteScrollUpOn === true && (element[0].scrollTop < 3) && currentScrollbarPosition < previousScrollbarPosition) {
                    $rowFirst.addClass("active-row");
                	scope.analogTableService.alerts =[];
                	scope.analogTableService.previousPage();
                }
            }

            //THE-51649: was children().children().children().children(), which now
            //walks into <caption>/<thead> too - address the body rows directly
            var rows = element.find("tbody tr");
            //THE-51649: the sticky <thead> sits inside the scroll container now, so
            //the "top visible row" threshold has to clear it
            var scrollpos = 40 + (element.find("thead").outerHeight() || 0);
            var start = 0;
            var end = rows.length;
            var count = 0;

            while (start != end) {
                count++;
                var mid = start + Math.floor((end - start) / 2);
                if ($(rows[mid]).position().top < scrollpos)
                    start = mid + 1;
                else
                    end = mid;
            }
            _updateZoom(parseFloat($($(rows[start])).attr("name")));
        });

        var _updateZoom = function (currentRow) {
            if (isNaN(currentRow))
                return;

            var zoomMin = currentRow - paddingZoom;
            var zoomMax = currentRow + paddingZoom;

            var dateMin = scope.stickyProperties.dateMin;
            var dateMax = scope.stickyProperties.dateMax;

            if (zoomMin < scope.stickyProperties.dateMin) {
                dateMin = zoomMin;
            }
            if (zoomMax > scope.stickyProperties.dateMax) {
                dateMax = zoomMax;
            }

            sharedSetupService.setStickyProperties(scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: scope.windowId });
        };

        scope.toggle = function ($event) {
            if ($($event.currentTarget).hasClass("active-row")) {
                $($event.currentTarget).removeClass("active-row");
            }
            else {
                $($event.currentTarget).addClass("active-row");
            }
        };

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
            }
        }, true);

        scope.$watch('analogTableService.alerts', function (newValue, oldValue) {
            if (newValue && newValue.length > 0 && newValue != oldValue) {
                scope.alerts = newValue;
            }
        }, true);

        scope.getTableScrollX = function() {
            return scope.analogTableService && scope.analogTableService.setting.length > 4;
        };

        scope.newAnalogTableService = function() {
            scope.analogTableService = new analogTableService();
            scope.analogTableService.customerId = scope.accountInfo.customerId;
            scope.analogTableService.deviceId = scope.deviceSelected;
            scope.analogTableService.windowTitle = scope.windowTitle;
            scope.analogTableService.startRow = 1;
            scope.analogTableService.pageSize = 50;
        };

        var _openTableInLiveMode = function () {
            scope.stickyProperties.on = false;
            timeLapseService.getLocalDateTime().then(function (result) {
                /////////////////////////////////////////////////////////////
                var tmpDates = new Date(result.data.localDateTime);
                var tmpDatesA = tmpDates;
                tmpDates.setHours(0, 0, 0, 0);
                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                tmpDatesA.setHours(23, 59, 59, 0);
                tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
                /////////////////////////////////////////////////////////////
                scope.newAnalogTableService();
                scope.analogTableService.start = tmpDates.startDate;
                scope.analogTableService.end = tmpDatesA;
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
                scope.analogTableService.nextPage();
                /////////////////////////////////////////////////////////////
            });
        };

        scope.openTableInLiveModeDebounced = debounceService(_openTableInLiveMode, 400, false);

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                /////////////////////////////////////////////////////////////
                currentScrollbarPosition = 0;
                previousScrollbarPosition = 0;
                scope.checkFirstRowLiveStatus = null;
                /////////////////////////////////////////////////////////////
                scope.alerts = [];
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });

                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMin !== null) { //doesn't work well - need to check
                    scope.stickyProperties.on = true;
                    timeLapseService.getLocalDateTime().then(function (result) {
                        if (scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && scope.stickyProperties.zoomMax + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                            scope.newAnalogTableService();
                            scope.analogTableService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
                            scope.analogTableService.end = scope.stickyProperties.dateMax;
                            scope.analogTableService.nextPage();
                        }
                        else {
                            scope.newAnalogTableService();
                            scope.analogTableService.start = scope.stickyProperties.dateMin - (3 * scope.unixDay); //need to extend data range
                            scope.analogTableService.end = Math.round((scope.stickyProperties.zoomMax + scope.stickyProperties.zoomMin) / 2);
                            scope.analogTableService.nextPage();
                        }
                    });
                }
                else {
                    _openTableInLiveMode();
                }

            }
        }, true);

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.stickyProperties.device.serialNumber = newValue;
                if (oldValue) {
                    _unRegisterListener(oldValue);
                }
            }
        }, true);

        scope.selectMyDateT = function () {
            scope.analogTableService = new analogTableService();
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            scope.checkFirstRowLiveStatus = null;
            _unRegisterListener(scope.deviceSelectedSn);
            /////////////////////////////////////////////////////////////
            var tmpDates = scope.myDate;
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            tmpDatesA.setHours(12, 0, 0, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            scope.analogTableService.start = tmpDates.startDate;
            if (new Date(scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                scope.analogTableService.end = tmpDatesA;
            }
            else {
                scope.analogTableService.end = tmpDates.endDate;
            }
            /////////////////////////////////////////////////////////////
            scope.analogTableService.startRow = 1;
            scope.analogTableService.pageSize = 50;
            scope.analogTableService.customerId = scope.accountInfo.customerId;
            scope.analogTableService.deviceId = scope.deviceSelected;
            scope.analogTableService.windowTitle = scope.windowTitle;
            scope.alerts = [];
            scope.analogTableService.nextPage();
            /////////////////////////////////////////////////////////////
            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
        };

        var _setLiveDataStatus = function (firstRow, liveDataStatusOn) {
            if (scope.checkFirstRowLiveStatus === true) {
                _checkTopOffset(liveDataStatusOn);
            }
            else if (scope.checkFirstRowLiveStatus === null) {
                timeLapseService.getLocalDateTime().then(function (result) {
                    if (parseFloat(firstRow) + parseFloat(scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        scope.checkFirstRowLiveStatus = true;
                        _checkTopOffset(liveDataStatusOn);
                    }
                    else {
                        scope.checkFirstRowLiveStatus = false;
                    }
                });
            }
        };

        var _checkTopOffset = function (liveDataStatusOn) {
            if (liveDataStatusOn) {
                _registerListenerDebounced(scope.deviceSelectedSn);
            }
            else {
                _unRegisterListenerDebounced(scope.deviceSelectedSn);
            }
        };

        var getTheLastKnownRecord = function () {
            return scope.analogTableService.items.length > 0 ?
                scope.analogTableService.items[0] :
                { localDateTime: null, scaledValues: null }
        };

        var getTheLastKnownScaledValues = function (lastRecord) {
            var scaledValues = [];
            var scaledValue;

            for (var i = 0; i < lastRecord.scaledValues.length; i++) {
                scaledValue = { "value": lastRecord.scaledValues[i].value };
                scaledValues.push(scaledValue);
            }

            return scaledValues;
        };

        var insertMissingRecord = function (data) {

            var time = datetimeService.socketStrToServerStrTime(data.Time);

            var lastRecord = getTheLastKnownRecord();
            if (lastRecord.localDateTime !== time) {
                var scaledValues = [];
                var newRecord = { localDateTime: time, scaledValues: scaledValues };

                newRecord.scaledValues = getTheLastKnownScaledValues(lastRecord);
                scope.analogTableService.items.unshift(newRecord);

                scope.lastUpdateAt = time;
            }
        };

        var addNewAnalogRecord = function (data) {

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);

            var scaledValues = [];
            var scaledValues;
            var newRecord;

            if (scope.deviceSelectedType == 21) {
                var lastRecord = getTheLastKnownRecord();
                scaledValues = getTheLastKnownScaledValues(lastRecord);
            } else {
                for (var j = 0; j < scope.analogTableService.setting.length; j++) {
                    scaledValue = { "value": null };
                    scaledValues.push(scaledValue);
                }
            }

            newRecord = { localDateTime: varTime, scaledValues: scaledValues };
            scope.analogTableService.items.unshift(newRecord);
        };
       
        var wsDataReceivedANALOG = function (data) {

            //Catch empty data in old ANALOG message for GENII/SparkPlug device
            if (data.Type == "ANALOG" && scope.deviceSelectedType == 21) {
                console.log(data);
                return;
            }

           var i = 0;
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            if (scope.deviceSelectedType == 20) {
                scope.openTableInLiveModeDebounced();
                return;
            }

            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            var varValue = parseFloat(data.Value).toFixed(5);
            var _ScaledValue;
            var _recordExistAtIndex = null;
            var _channelIndex = null;

            scope.analogTableService.end = datetimeService.toUnixtime(data.Time) + scope.unixDay;
            scope.analogTableService.start = datetimeService.toUnixtime(data.Time) + 1000;    
            scope.analogTableService.scrollUp = datetimeService.toUnixtime(data.Time) + 1000;

            for (i = 0; i < scope.analogTableService.items.length; i++) {
                if (scope.analogTableService.items[i].localDateTime == varTime) {
                    _recordExistAtIndex = i;
                    break;
                }
            }

            if (_recordExistAtIndex === null) {
                addNewAnalogRecord(data);
                _recordExistAtIndex = 0;
            }

            for (i = 0; i < scope.analogTableService.setting.length; i++) {
                if (scope.analogTableService.setting[i].channel == data.CH) {
                    _channelIndex = i;
                    break;
                    }
            }

            _ScaledValue = {"value": varValue};
            scope.analogTableService.items[_recordExistAtIndex].scaledValues[_channelIndex]= _ScaledValue;
            scope.lastUpdateAt = varTime;
        };

        var wsDataReceivedCALLINSCOUNT = function(data) {

            if (scope.deviceSelectedType != 21) {
                return;
            }

            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            callInCountTimeout = $timeout(function () {

                insertMissingRecord(data);

            }, 1000);
 
        }

        scope.$on('processReconnect', function (event, args) {
            scope.reconnectData(event, args);
        });

        scope.reconnectData = function (event, args) {             
            sharedSetupService.processReconnect({
                stickyProperties: scope.stickyProperties,
                localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
                dateRangeOption: null,
                windowTitle: scope.windowTitle,
                fnUnregister: _unRegisterListener,
                fnGetData: _openTableInLiveMode,
                viewType: "Table"
            });
        };

        scope.mostRecentData = function (event, args) {
            scope.stickyProperties.liveData = true;
            scope.myDate = null;
            scope.reconnectData(event, args);
        }

        var wsDataReceivedANALOGSETTINGAT = function (data) {

            if (data.Type == 'ANALOGSETTING') {

                ///reload table when recieved new analog setting from SignalR
                if (scope.liveData) {
                    var refreshStartDate = scope.analogTableService.start;
                    var refreshEndDate = scope.analogTableService.end;

                    scope.newAnalogTableService();
                    scope.analogTableService.start = refreshStartDate;
                    scope.analogTableService.end = refreshEndDate;
                    scope.analogTableService.nextPage();
                }
                else {
                    _resetViewFromLive(data.CH, data.Value);
                }
            }
        };

        var _registerListener = function (varSelectedSN) {
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
            scope.liveData = true;
            scope.liveDataLine(scope.liveData);
            scope.analogTableService.numberOfNewRecordsPrevious = -1;
            websocketService.connect();
            for (var i = 0; i < scope.analogTableService.setting.length; i++) { //chart.series.length - 1
                websocketService.register("ANALOG", varSelectedSN, (scope.analogTableService.setting[i].channel).toString(), wsDataReceivedANALOG, null);
                websocketService.register("ANALOG_G2", varSelectedSN, (scope.analogTableService.setting[i].channel).toString(), wsDataReceivedANALOG, null);
                websocketService.register("ANALOGSETTING", varSelectedSN, (scope.analogTableService.setting[i].channel).toString(), wsDataReceivedANALOGSETTINGAT, null);
                if (i == 0) websocketService.register("CALLINSCOUNT", varSelectedSN, "", wsDataReceivedCALLINSCOUNT, null);
            }
        };

        var _registerListenerDebounced = debounceService(_registerListener, 100, false);

        var _unRegisterListener = function (varSelectedSN) {
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
            if (scope.liveData === false)
                return;
            scope.liveData = false;
            scope.liveDataLine(scope.liveData);
            scope.lastUpdateAt = undefined;

            if (angular.isDefined(callInCountTimeout)) {
                $timeout.cancel(callInCountTimeout);
                callInCountTimeout = undefined;
            }
            
            for (var i = 0; i < scope.analogTableService.setting.length; i++) { //chart.series.length - 1
                websocketService.unRegister("ANALOG", varSelectedSN, scope.analogTableService.setting[i].channel.toString(), wsDataReceivedANALOG, null);
                websocketService.unRegister("ANALOG_G2", varSelectedSN, scope.analogTableService.setting[i].channel.toString(), wsDataReceivedANALOG, null);
                websocketService.unRegister("ANALOGSETTING", varSelectedSN, (scope.analogTableService.setting[i].channel).toString(), wsDataReceivedANALOGSETTINGAT, null);
                if (i == 0) websocketService.unRegister("CALLINSCOUNT", varSelectedSN, "", wsDataReceivedCALLINSCOUNT, null);
            }
        };

        var _unRegisterListenerDebounced = debounceService(_unRegisterListener, 100, false);
        
        scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            _autoScroll();
            scope.checkFirstRowLiveStatus = null;
            scope.trgScroll();
        });

        var _autoScroll = function () {
            if (scope.analogTableService.numberOfNewRecordsPrevious > 0) {
                //THE-51649: index tbody rows so this is not off by the header row
                var trRow = element.find('tbody tr').eq(scope.analogTableService.numberOfNewRecordsPrevious - 1);
                var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
                element.scrollTop(yPosition);
            }
            else {
                $timeout(function () {
                    element.animate({
                        scrollTop: 5
                    }, 500);
                }, 0);
            }
        };

        var _resetView = function (args) {
            for (var i = 0; i < scope.analogTableService.setting.length; i++) {
                if (scope.analogTableService.setting[i].channel == args.channel) {
                    var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
                    var _newDataValue = _newData.name + " (" + _newData.unit + ")";
                    scope.analogTableService.setting[i].name = _newData.name;
                    scope.analogTableService.setting[i].unit = _newData.unit;
                }
            }
        };

        var _resetViewFromLive = function (channel, patch) {
            for (var i = 0; i < scope.analogTableService.setting.length; i++) {
                if (scope.analogTableService.setting[i].channel == channel) {
                    switch(patch.path)
                    {
                        case 'name':
                            scope.analogTableService.setting[i].name = patch.value;
                            break;
                        case 'unit' :
                            scope.analogTableService.setting[i].unit = patch.value;
                            break;
                    }
                }
            }
        };

        var _getArgsFromNewSetting = function (channel, newSetting) {
            for (var i = 0; i < newSetting.length; i++) {
                if (newSetting[i].channel == channel) {
                    return newSetting[i];
                }
            }
            return null;
        };

        scope.$on('rtuAnalogUpdate', function (event, args) {
            var _dataChanged = "name, unit";
            if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
                _resetView(args);
            }
        });
                        
        scope.$on('rtuAnalogUpdateMMPlus', function (event, args) {
            var _dataChanged = "channelDesc, unitOfValueID, manholeDepthMeters";           
            if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {    
                _openTableInLiveMode();
            }
        });

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
        });
    };
}]);

mcapp.factory('analogTableService', ['$http', 'datetimeService', 'translationService', 'HOST', 'sharedSetupService', function ($http, datetimeService, translationService, HOST, sharedSetupService) {
    var analogTableService = function () {
        this.items = [];
        this.setting = [];
        this.numberOfDecimals =[];
        this.deviceName = '';
        this.customerId = null;
        this.deviceId = null;
        this.startRow = 1;
        this.pageSize = 50;
        this.start = '19000101';
        this.end = '19000101';
        this.busy = false;
        this.numberOfReturnedRecords = -1;
        this.numberOfNewRecordsPrevious = -1;
        this.tdWidth = null;
        this.alerts = [];
        this.translation = translationService.translation;
        this.displayWeirLvalueColumn = false;
    };


    analogTableService.prototype.previousPage = function () {
        if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
        this.busy = true;
        this.pageSize = -50;
        var url = HOST + "/api/Analog/Table?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end+ "&fromDate=" + this.scrollUp;
        $http.get(url).then(function (result) {
            /////////////////////////
            var intDayWindow = 10;
            var intDay = 86400000;
            /////////////////////////
            var deviceName = result.data.device.name;
            var setting = result.data.setting;
            if (this.setting.length === 0) {
                for (var i = 0; i < setting.length; i++) {
                    this.setting.push(setting[i]);
                    this.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
                }
                this.tdWidth = parseInt(100 / (setting.length + 1)) + "%";
            }

            var items = result.data.analogMeasurements;

            var timeToCompare = this.items.length > 0 ? this.items[0].localDateTime : null;

            //Data is sorted and grouped in Mc.Services and the following
            //will take care off NOT adding duplicates to the table if any
            //returned from Mc.Services (Analog with 9 channels will have some!)
            for (var j = 0; j < items.length; j++) {
                if (timeToCompare == null || items[j].localDateTime > timeToCompare)
                    this.items.unshift(items[j]);
            }

            //remove duplicate item
            //this.items = remove_duplicates(this.items);

            this.numberOfNewRecordsPrevious = items.length;
            this.numberOfRecords = this.items.length;
            this.deviceName = deviceName;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) { //if there are records returned
                this.start = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
            }
            if (this.items.length > 0) {
                this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, '')) + 1000;
                this.scrollDown = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localDateTime.replace(/\D/g, ''));
            } else {
                this.scrollUp = "";
                this.scrollDown = "";
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this),
        function (error) {
            this.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            this.alerts.push({ msg: errorMessage, type: "danger" });
            this.pageSize = 50;
            this.busy = false;
        }.bind(this));
    };
    remove_duplicates = function (arr) {

        var obj = {};
        var ret_arr = [];
        for (var i = 0; i < arr.length; i++) {
            if (!obj[datetimeService.toUnixtime(arr[i].localDateTime.replace(/\D/g, ''))])
                obj[datetimeService.toUnixtime(arr[i].localDateTime.replace(/\D/g, ''))] = arr[i]; //localDateTime should be unique across the array items
        }
        for (var key in obj) {
            ret_arr.push(obj[key]);
        }
        return ret_arr;
    }

    analogTableService.prototype.nextPage = function () {
        if (this.busy || this.numberOfReturnedRecords === 0) return;
        this.busy = true;

        var url = HOST + "/api/Analog/Table?customerId=" + this.customerId + "&deviceId=" + this.deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + this.start + "&EndDate=" + this.end + "&fromDate=" + this.scrollDown;
        $http.get(url).then(function (result) {
            /////////////////////////
            var intDayWindow = 10;
            var intDay = 86400000;
            /////////////////////////
            var deviceName = result.data.device.name;
            var model = result.data.device.model;
            var skuId = result.data.device.skuId;
            var setting = result.data.setting;
            if (this.setting.length === 0) {
                for (var i = 0; i < setting.length; i++) {
                    this.setting.push(setting[i]);
                    this.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
                }
                var noOfExtraColumns = 1;
                (result.data.device.weirLvalueInches > 0) ? noOfExtraColumns++ : noOfExtraColumns;
                this.tdWidth = parseInt(100 / (setting.length + noOfExtraColumns)) + "%"; //including "CalculatedWeirGpm" column too
                this.displayWeirLvalueColumn = result.data.device.weirLvalueInches > 0; // display extra WeirLvalue column,if value present on device
            }
            var items = result.data.analogMeasurements;

            var timeToCompare = this.items.length > 0 ? this.items[this.items.length - 1].localDateTime : null;

            //Data is sorted and grouped in Mc.Services and the following
            //will take care off NOT adding duplicates to the table if any
            //returned from Mc.Services (Analog with 9 channels will have some!)
            for (var j = 0; j < items.length; j++) {
                if (timeToCompare == null || items[j].localDateTime < timeToCompare)
                    this.items.push(items[j]);
            }

            //remove duplicate item
            //this.items = remove_duplicates(this.items);

            this.numberOfReturnedRecords = items.length;
            this.deviceName = deviceName;
            this.startRow = this.startRow + items.length;
            if (items.length > 0) { //if there are records returned
                this.start = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
                this.end = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
            }
            else {
                // If we didn't get any items back AND there aren't already any items
                if (this.items.length === 0) {
                    this.alerts = [];
                    var errorMessage;
                    if (this.setting.length > 0) {
                        errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
                        this.alerts.push({ msg: errorMessage, type: "info", languageCode: "NO_DATA" });
                    }
                    else if(model == 20 && skuId <=1) {
                        errorMessage = this.translation.text.DEVICE_UNSUPPORTED;
                        this.alerts.push({ msg: errorMessage, type: "info", languageCode: "DEVICE_UNSUPPORTED" });
                    }
                    else {
                        errorMessage = this.translation.message.ANALOG_SETUP_INCOMPLETE
                        this.alerts.push({ msg: errorMessage, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
                    }
                }
            }
            if (this.items.length > 0) {
                this.scrollUp = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
                this.scrollDown = datetimeService.toUnixtimeMs(this.items[this.items.length - 1].localDateTime.replace(/\D/g, ''));
            } else {
                this.scrollUp = "";
                this.scrollDown = "";
            }
            this.pageSize = 50;
            this.busy = false;
        }.bind(this),
            function (error) {
                this.alerts = [];
                var errorMessage = eval("this.translation.message." + error.data.message);
                this.alerts.push({ msg: errorMessage, type: "danger" });
                this.pageSize = 50;
                this.busy = false;
            }.bind(this));
    };

    return analogTableService;
}]);

mcapp.controller("analogGaugeController", ["$scope", "$rootScope", "authenticationService", "translationService", "sharedSetupService", "openViewService",
    function ($scope, $rootScope, authenticationService, translationService, sharedSetupService, openViewService) {
        sharedSetupService.getWindowId($scope);
        $scope.Channel = [];
        $scope.alerts = [];
        $scope.translation = translationService.translation;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.downloadViewTypeOptions = [0];
        sharedSetupService.getWindowId($scope);

        if (!$rootScope.mobile && !$rootScope.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function (event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function (event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)')
                    .css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height",
                    $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") -
                    $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.analog-gauge-container').css("height",
                    $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") -
                    $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") -
                    $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") -
                    20);
                //$scope.adjustDeviceIdMenuSize();
            };

            $scope.adjustDeviceIdMenuSize = function () {
                var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                if (spph < 450) {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
                } else {
                    $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
                }
            };
        }
    }]);
mcapp.directive('analogGaugeDirective', ["authenticationService", "websocketService", "analogGaugeService", "deviceService", "toaster", "openViewService", "datetimeService", "sharedSetupService", '$filter',
    function (authenticationService, websocketService, analogGaugeService, deviceService, toaster, openViewService, datetimeService, sharedSetupService, $filter) {
        function link(scope, element, attrs) {
            if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }
            scope.charts = [];
            element.on(
                "mouseover.analogGaugeDirective",
                ".hcolAnalog",
                function (event) {
                    var localScope = $(event.target).scope();
                    if ($(event.currentTarget).is(".hcolAnalog") && !scope.mobile && !scope.classicView) {
                        $(event.currentTarget).draggable({
                            helper: "clone",
                            revert: false,
                            appendTo: "body",
                            containment: "body",
                            opacity: 0.35,
                            stop: function (event, ui) {
                                var mcDevice = { deviceId: scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: scope.deviceSelectedSn };

                                var optionsStickyProperties = {
                                    device: mcDevice
                                };

                                var $newPosX = ui.offset.left;
                                var $newPosY = ui.offset.top;
                                var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                                openViewService.openWidget('Analog Widget', { width: 240, height: 240 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                                scope.$apply();

                                //   console.log(optionsStickyProperties);
                            }
                        });
                    }
                }
            );

            scope.$on(
                "$destroy",
                function (event) {
                    element.off("mouseover.analogGaugeDirective");
                    angular.forEach(analogGauges, function (value, key) {
                        if (value.Chart) value.Chart.destroy();
                    });
                }
            );
            var chart;
            var analogGauges = [];
            var accountInfo = authenticationService.getAccountInfo();


            //==========================socket data================================

            var wsDataReceivedAG = function (data) {
                if (scope.deviceSelectedType < 21) return;
                if (data) {
                    for (var i = 0; i < analogGauges.length; i++) {
                        if (analogGauges[i].Channel == data.CH) {
                            if (analogGauges[i].Chart && analogGauges[i].Chart.series[0] && analogGauges[i].Chart.series[0].points[0]) {
                                analogGauges[i].Chart.series[0].points[0].update(parseFloat(data.Value));
                            }
                        }
                    }

                    var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                    scope.lastUpdateAt = varTime;
                }
            };

            var _wsUpdateAnalogG2 = function (message) {

                if (scope.liveData === false) {
                    _unRegisterListener(scope.deviceSelectedSn);
                    return;
                }

                if (scope.deviceSelectedType < 21) return;

                //if (angular.isUndefined(ctrl.currentStatus.analog)) return;

                //if (scope.deviceSelectedType == 20 && message.Ch != 1) return;

                if (message) {
                    for (var i = 0; i < analogGauges.length; i++) {
                        if (analogGauges[i].Channel == message.CH) {
                            if (analogGauges[i].Chart && analogGauges[i].Chart.series[0] && analogGauges[i].Chart.series[0].points[0]) {
                                analogGauges[i].Chart.series[0].points[0].update(parseFloat(message.Value));
                            }
                        }
                    }

                    var varTime = datetimeService.socketStrToServerStrTime(message.Time);
                    scope.lastUpdateAt = varTime;
                }
            };
            
            var wsDataReceivedANALOGSETTINGAG = function (data) {

                if (data.Type == 'ANALOGSETTING') {

                    var _dataChanged = "name, unit, minimumValue, maximumValue";
                    if (data.SN == scope.deviceSelectedSn && _dataChanged.indexOf(data.Value.path) > -1) {

                        _resetViewFromLive(data.CH, data.Value);

                    }
                }
            };

            scope.$watch('deviceSelected', function (newValue, oldValue) {
                if (newValue) {
                    analogGauges = [];
                    scope.currentDeviceId = newValue;                    
                    var _device = { deviceName: scope.deviceSelectedName };
                    scope.currentDeviceName = _device.deviceName;
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                    drawGauge(newValue);
                }
            }, true);

            scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
                distroyScopeChannel(oldValue);

            }, true);

            scope.$on("$destroy", function () {
                distroyScopeChannel(scope.deviceSelectedSn);
            });

            scope.mostRecentData = function () {
                toaster.pop('success', "Analog Gauge" + " -- " + scope.currentDeviceName, 'View reloading');
                drawGauge(scope.currentDeviceId);
            };

            var drawGauge = function (deviceID) {
                distroySingleGauge();
                analogGaugeService.getData(deviceID, accountInfo.customerId)
                    .then(function (result) {
                        scope.gaugeServerData = result.data;
                        if (result.data.length > 0) {
                            websocketService.connect();
                            scope.liveData = true;
                            for (var i = 0; i < result.data.length; i++) {
                                if (!result.data[i].isMyLevelDevice) {
                                    result.data[i].lowAlarm = result.data[i].lowAlarm == '0' ? result.data[i].minVal : result.data[i].lowAlarm;
                                    result.data[i].highAlarm = result.data[i].highAlarm == '0' ? result.data[i].maxVal : result.data[i].highAlarm;
                                }                                
                                scope.Channel.push(result.data[i].channel);
                                drawSingleGauge(result.data[i], deviceID);
                            }
                        }
                        else if (scope.deviceSelectedType == 20 && scope.deviceSKUId <= 1) {
                            scope.alerts = [];
                            scope.alerts.push({ msg: scope.translation.text.DEVICE_UNSUPPORTED, type: "info" });
                        }
                        else {
                            scope.alerts = [];
                            scope.alerts.push({ msg: scope.translation.message.ANALOG_SETUP_INCOMPLETE, type: "info" });
                        }
                    }, function (error) {
                        scope.alerts = [];
                        if (!error) error = { data: { message: "GENERAL_SERVER_ERROR" } };
                        var errormsg = eval("scope.translation.message." + error.data.message);
                        scope.alerts.push({ msg: errormsg, type: "danger" });
                    });
            };

            scope.getPlotBands = function (data) {
                var plotBands = [];
                var A = data.minVal, B = data.lowAlarm, C = data.highAlarm, D = data.highHighAlarm, E = data.maxVal;

                var plotAB = {
                    from: data.minVal,
                    to: data.lowAlarm,
                    color: '#DF5353' // red
                };

                var plotAC = {
                    from: data.minVal,
                    to: data.highAlarm,
                    color: '#55BF3B' // green
                };

                var plotAD = {
                    from: data.minVal,
                    to: data.highHighAlarm,
                    color: '#55BF3B' // green
                };

                var plotBC = {
                    from: data.lowAlarm,
                    to: data.highAlarm,
                    color: '#55BF3B' // green
                };

                var plotBE = {
                    from: data.lowAlarm,
                    to: data.maxVal,
                    color: '#55BF3B' // green
                };

                var plotCE = {
                    from: data.highAlarm,
                    to: data.maxVal,
                    color: '#DF5353' // red
                };

                var plotCD = {
                    from: data.highAlarm,
                    to: data.highHighAlarm,
                    color: '#DF5353' // red
                };

                var plotDE = {
                    from: data.highHighAlarm,
                    to: data.maxVal,
                    color: '#8B0000' // dark red
                };

                var plotSetupIsOff = {
                    from: data.minVal,
                    to: data.maxVal,
                    color: '#55BF3B' // green
                };

                if (A < B && B < C && C < D && D < E) {
                    plotBands.push(plotAB);
                    plotBands.push(plotBC);
                    //plotBands.push(plotCE);
                    plotBands.push(plotCD);
                    plotBands.push(plotDE);
                }
                else if (A < B && B < E) {
                    plotBands.push(plotAB);
                    plotBands.push(plotBE);
                    if (B < C && C < E) plotBands.push(plotCE);
                    if (B < D && D < E) plotBands.push(plotDE);
                }
                else if (A < C && C < E) {
                    plotBands.push(plotAC);
                    plotBands.push(plotCE);
                    if (C < D && D < E) plotBands.push(plotDE);
                }
                else if (A < D && D < E) {
                    plotBands.push(plotAD);
                    plotBands.push(plotDE);
                }
                else if (A > B && B > C && C > D && D > E) {
                    plotBands.push(plotAB);
                    plotBands.push(plotBC);
                    plotBands.push(plotCE);
                    plotBands.push(plotCD);
                    plotBands.push(plotDE);
                }
                else if (A > B && B > E) {
                    plotBands.push(plotAB);
                    plotBands.push(plotBE);
                    if (B > C && C > E) plotBands.push(plotCE);
                    if (B > D && D > E) plotBands.push(plotDE);
                }
                else if (A > C && C > E) {
                    plotBands.push(plotAC);
                    plotBands.push(plotCE);
                    if (C > D && D > E) plotBands.push(plotDE);
                }
                else if (A > D && D > E) {
                    plotBands.push(plotAD);
                    plotBands.push(plotDE);
                }
                else {
                    plotBands.push(plotSetupIsOff);
                }
                return plotBands;
            };

            scope.getTickPositions = function (data) {
                var tickPositions = [];
                var A = data.minVal, B = data.lowAlarm, C = data.highAlarm, D = data.highHighAlarm, E = data.maxVal;

                tickPositions.push(A);
                tickPositions.push(E);
                if (A < B && B < C && C < D && D < E) {                    
                    if ((B - A) > ((E - A) * 3 / 100))
                        tickPositions.push(B);
                    if ((E - C) > ((E - A) * 3 / 100))
                        tickPositions.push(C);
                    if ((E - D) > ((E - A) * 3 / 100))
                        tickPositions.push(D);                                        
                }
                if (A < B && B < E) {                    
                    if ((B - A) > ((E - A) * 3 / 100))
                        tickPositions.push(B);                    
                }
                if (A < C && C < E) {                    
                    if ((E - C) > ((E - A) * 3 / 100))
                        tickPositions.push(C);                    
                }
                if (A < D && D < E) {                    
                    if ((E - D) > ((E - A) * 3 / 100))
                        tickPositions.push(D);                    
                }
                if (A > B && B > C && C > E && D > E) {                    
                    if ((A - B) > ((A - E) * 3 / 100))
                        tickPositions.push(B);
                    if ((C - E) > ((A -E) * 3 / 100))
                        tickPositions.push(C);
                    if ((D - E) > ((A -E) * 3 / 100))
                        tickPositions.push(D);                    
                }
                if (A > B && B > E) {                    
                    if ((A - B) > ((A - E) * 3 / 100))
                        tickPositions.push(B);                    
                }
                if (A > C && C > E) {                    
                    if ((C - E) > ((A - E) * 3 / 100))
                        tickPositions.push(C);                    
                }
                if (A > D && D > E) {                    
                    if ((D - E) > ((A - E) * 3 / 100))
                        tickPositions.push(D);                   
                }
                
                return tickPositions;
            };

            var agg, container;
            var drawSingleGauge = function (data, DeviceID) {

                //   deviceService.getDeviceLookup(accountInfo.customerId, DeviceID).then(function (result) {
                //      SN = result.data.serialNumber;

                container = document.createElement('div');
                container.setAttribute("class", "hcolAnalog");
                container.setAttribute("mc-deviceid", DeviceID);
                container.setAttribute("mc-channel", data.channel);

                element.append(container);
                setTimeout(function(){ websocketService.register("ANALOGSETTING", scope.deviceSelectedSn, data.channel, wsDataReceivedANALOGSETTINGAG, null); }, 1000);
                websocketService.register("ANALOG", scope.deviceSelectedSn, data.channel, wsDataReceivedAG, null);
                websocketService.register("ANALOG_G2", scope.deviceSelectedSn, data.channel, _wsUpdateAnalogG2, null);
                _makeChart(data);
                //        });
            };

            var _makeChart = function (data, varContainer) {
                if (varContainer) {
                    container = varContainer;
                    $(container).empty();
                }
                chart = new Highcharts.Chart({

                    chart: {
                        renderTo: container,
                        type: 'gauge',
                        plotBackgroundColor: null,
                        plotBackgroundImage: null,
                        backgroundColor: 'rgba(0,0,0,0)',
                        plotBorderWidth: 0,
                        plotShadow: false,
                        spacing: [0, 0, 0, 0]
                    },

                    title: {
                        text: null
                    },
                    exporting: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    pane: {
                        startAngle: -150,
                        endAngle: 150

                    },
                    xAxis: {
                        labels: {
                            formatter: function () {
                                return this.value.toString().substring(0, 2);
                            }
                        },

                    },
                    tooltip: {
                        enabled: false
                    },
                    yAxis: {
                        min: (data.minVal > data.maxVal ? data.maxVal : data.minVal),
                        max: (data.minVal > data.maxVal ? data.minVal : data.maxVal),

                        minorTickWidth: 0,

                        reversed: (data.minVal > data.maxVal ? true : false),

                        //   tickPixelInterval: 30,
                        tickWidth: 1,
                        tickLength: 10,
                        tickColor: '#666',
                        tickPositions: scope.getTickPositions(data),
                        labels: {
                            // step: 2,
                            // rotation: 'auto'
                            //overflow: 'justify',

                        },

                        title: {
                            text: '<p style="text-align:center;">' + _getGaugeTitle(data.channel, data.name) + '</p>'
                        },

                        plotBands: scope.getPlotBands(data)
                    },
                    plotOptions: {
                        gauge: {
                            dataLabels: {
                                y: -10,
                                borderWidth: 0,
                                useHTML: true
                            }
                        }
                    },

                    series: [{
                        data: [data.latestData],
                        dataLabels: {
                            enabled: true,
                            borderWidth: 0,
                            formatter: function () {
                                return '<div style="text-align:center; margin-top:20px;"><span style="font-size:120%; color:' + ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">' + $filter('number')(this.y, sharedSetupService.getNumberOfDecimals(data.maxVal, data.minVal)) + '</span><br/>' + '<span style="font-size:100%;">' + data.unit + '</span></div>';
                            }
                        },
                        overshoot: 30
                    }]

                });

                if (!_.find(scope.charts, function (obj) { return obj.channel === data.channel })) {
                    scope.charts.push({ channel: data.channel, chart: chart, data: data });
                }

                if (!varContainer) {
                    agg = { Channel: data.channel, Chart: chart, container: container };
                    analogGauges.push(agg);
                }

            };

            var _getGaugeTitle = function (varChannel, varName) {
                if (varName == scope.translation.text.CHANNEL + ' ' + varChannel) {
                    return varName;
                }
                else {
                    return scope.translation.text.CHANNEL + ' ' + varChannel + '<br>' + varName;
                }
            };

            var _getGaugeUnit = function (varUnit, data) {
                return '<div style="text-align:center; margin-top:20px;"><span style="font-size:120%; color:' +
                    ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">' + $filter('number')(data, 2) + '</span><br/>' +
                    '<span style="font-size:100%;">' + varUnit + '</span></div>';
            };

            var distroySingleGauge = function () {
                element.empty();
                scope.alerts = [];
            };

            var distroyScopeChannel = function (oldSn) {
                //remove from socket service
                for (var i = 0; i < scope.Channel.length; i++) {
                    websocketService.unRegister("ANALOG", oldSn, scope.Channel[i], wsDataReceivedAG);
                    websocketService.unRegister("ANALOG_G2", oldSn, scope.Channel[i], _wsUpdateAnalogG2);
                    websocketService.unRegister("ANALOGSETTING", oldSn, scope.Channel[i], wsDataReceivedANALOGSETTINGAG, null);
                }

                scope.Channel = [];

            };

            var _resetView = function (args) {
                for (var i = 0; i < analogGauges.length; i++) {
                    if (analogGauges[i].Channel == args.channel) {
                        var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
                        var _lmData = _getLowMax(args.channel);
                        var _container = _getContainer(args.channel);
                        var _data = { "minVal": _newData.minimumValue, "lowAlarm": _lmData.lowAlarm, "highAlarm": _lmData.highAlarm, "maxVal": _newData.maximumValue };

                        _lmData.minVal = _newData.minimumValue;
                        _lmData.maxVal = _newData.maximumValue;
                        _lmData.name = _newData.name;
                        _lmData.unit = _newData.unit;
                        _makeChart(_lmData, _container);
                        return;
                    }
                }
            };

            var _resetViewFromLive = function (channel, patch) {
                for (var i = 0; i < analogGauges.length; i++) {
                    if (analogGauges[i].Channel == channel) {
                        var _lmData = _getLowMax(channel);
                        var _container = _getContainer(channel);
                      
                        switch(patch.path)
                        {
                            case 'minimumValue':
                                _lmData.minVal = parseInt(patch.value);
                                break;
                            case 'maximumValue' :
                                _lmData.maxVal = parseInt(patch.value);
                                break;
                            case 'name':
                                _lmData.name = patch.value;
                                break;
                            case 'unit' :
                                _lmData.unit = patch.value;
                                break;
                        }
                        _makeChart(_lmData, _container);
                        return;
                    }
                }
            };


            var _getLowMax = function (channel) {
                for (var i = 0; i < scope.gaugeServerData.length; i++) {
                    if (scope.gaugeServerData[i].channel == channel) {
                        return scope.gaugeServerData[i];
                    }
                }
                return null;
            };

            var _getContainer = function (channel) {
                for (var i = 0; i < analogGauges.length; i++) {
                    if (analogGauges[i].Channel == channel) {
                        return analogGauges[i].container;
                    }
                }
                return null;
            };

            var _getArgsFromNewSetting = function (channel, newSetting) {
                for (var i = 0; i < newSetting.length; i++) {
                    if (newSetting[i].channel == channel) {
                        return newSetting[i];
                    }
                }
                return null;
            };

            // scope.$on('rtuAnalogUpdate', function (event, args) {
            //     var _dataChanged = "name, unit, minimumValue, maximumValue";
            //     if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
            //         console.log("Args", args);
            //         _resetView(args);
            //     }
            // });

                            
            scope.$on('rtuAnalogUpdateMMPlus', function (event, args) {
                var _dataChanged = "channelDesc, unitOfValueID, manholeDepthMeters";
                if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {              
                    drawGauge(args.deviceId);  
                } 
            });

            scope.$on('updatePreferencesLanguage', function () {
                for (var i = 0; i < scope.charts.length; i++) {
                    _makeChart(scope.charts[i].data, _getContainer(scope.charts[i].channel));
                }
            });

        }
        return {
            link: link
        };



    }
]);
mcapp.factory('analogGaugeService', ['$http', 'HOST', function ($http, HOST) {
    var analogGaugeFatory = {};

    var _getData = function (deviceId, customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/Analog/Gauge?deviceId=' + deviceId + '&customerId=' + customerId,
            cache: false
        });
    };
    analogGaugeFatory.getData = _getData;
    return analogGaugeFatory;

}]);

mcapp.controller('analogData2Controller', ['$scope', 'sharedSetupService', 'translationService', 'detectBrowserService', '$rootScope', 'authenticationService', function ($scope, sharedSetupService, translationService, detectBrowserService, $rootScope, authenticationService) {
    $scope.myDate = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.minPadding = sharedSetupService.minPadding;
    $scope.maxPadding = sharedSetupService.maxPadding;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
    $scope.alerts = [];
    $scope.loadingInProgress = true;

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.selectMyDate = function () {
        $scope.selectMyDateC();
        $scope.selectMyDateT();
    };

    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.curentBrowser = detectBrowserService();

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;

        $scope.popup.dialog({
            resize: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function (event, ui) {
                $scope.adjustSize();
            },
            restore: function (event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            //$scope.adjustDeviceIdMenuSize();
        };

        $scope.adjustDeviceIdMenuSize = function () {
            var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            if (spph < 450) {
                $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            }
            else {
                $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        };
    }


    $scope.fnChangeLanguage = function () {
        if ($scope.alerts.length > 0) {
            var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
            var _type = $scope.alerts[0].type;
            var _languageCode = $scope.alerts[0].languageCode;
            $scope.alerts = [];
            $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        }
    };
}]);

angular.module("analogChartModule", []);
angular.module("analogChartModule").factory('analogChartService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function (varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/Analog/Chart?' + varParm,
                cache: false
            });
        }
    };
}]);

angular.module("analogChartModule").directive('drawAnalogChart',
    ['$rootScope', '$timeout', 'analogChartService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'sharedSetupService', 'openViewService', 'highchartsOptionsService', 'rangeSelectorService', '$', 'SaveDesktopSettingService', 'debounceService', '$compile',
        function ($rootScope, $timeout, analogChartService, datetimeService, websocketService, timeLapseService, toaster, sharedSetupService, openViewService, highchartsOptionsService, rangeSelectorService, $, SaveDesktopSettingService, debounceService, $compile) {
            // return the directive link function. (compile function not needed)
            return function (scope, element, attrs) {
                scope.downloadViewTypeOptions = [0,1];//[0, 1];
                var chart;
                var xValue = null;
                var scrollingInProgress = false;
                var zoomLevelCurrent, zoomLevelPrevious = 0;
                scope.chartSeriesVisibility = [];
                scope.downloadOptions = { resolution: 0 };
                scope.liveRefresh = false;
                scope.sidebarLegend = true;
                var initialLoad = true;
                var checkYaxis = !initialLoad;

                scope.langId = scope.accountInfo.preferenceUser.i18nCode === 'fr' ? scope.accountInfo.preferenceUser.i18nCode : 'en';
                scope.showAutoscaleBtn = true;

                var callInCountTimeout;

                if (!$rootScope.mobile && !$rootScope.classicView) {
                    scope.popup = _this.getExistingDialog(scope.windowId).ref;
                    sharedSetupService.maximize(scope.popup);
                    scope.popup.dialog({
                        resizeStop: function(event, ui) { 
                            scope.yAxisVisibleCheck();
                            ui.size.width < 420 ? scope.showAutoscaleBtn = false : scope.showAutoscaleBtn = true;
                            $('#map').removeClass('no-events');
                            scope.$apply();
                        }
                    }); 
 
                }

                element.attr("class", "chart");

                element.on('mousewheel', function (event) {
                    if (!scrollingInProgress)
                        scope.mouseWheelZoom(event, chart, xValue);
                });

                if (typeof scope.stickyProperties != 'object') { scope.stickyProperties = scope.stickyPropertiesInterface; }
                
                scope.toggleSidebarLegend = function (sidebarLegend) {

                    scope.sidebarLegend = !angular.isUndefined(sidebarLegend) ? !sidebarLegend : scope.sidebarLegend;

                    var button = chart.exportSVGElements[0];
                    var button2 = chart.exportSVGElements[2];

                    switch (scope.sidebarLegend) {
                        case true:
                            chart.legend.update({ enabled: false });
                            break;
                        case false:
                            chart.legend.update({ enabled: true });
                            break;
                    }

                    scope.sidebarLegend = !scope.sidebarLegend;

                    button.attr({
                        display: scope.sidebarLegend ? 'inline-block' : 'none'
                    });
                    button2.attr({
                        display: scope.sidebarLegend ? 'inline-block' : 'none'
                    });

                    scope.saveDesktopSettingService.setAnalogChartSidebarLegend(scope.sidebarLegend, scope);
                  
                };

                scope.$watch('lastUpdateAt', function (newValue, oldValue) {
                    if (newValue && newValue != oldValue) {
                        scope.liveDataIn = !scope.liveDataIn;
                        $timeout(function () { scope.liveDataIn = !scope.liveDataIn; }, 3000);
                    }
                }, true);
                
                scope.$watch('deviceSelected', function (newValue, oldValue) {
                    if (newValue) {
                        scope.varToggle = false;
                        scope.sidebarLegend = true;
                        scope.series = undefined;
                        scope.tmpData = undefined;
                        scope.varDay = undefined;

                        scope.saveDesktopSettingService = new SaveDesktopSettingService(newValue, scope.windowId);
                        if (scope.stickyProperties.setting && scope.stickyProperties.setting.savedDesktop && scope.stickyProperties.setting.deviceId == newValue) {
                            scope.savedDesktopSetting = scope.stickyProperties.setting;
                        }
                        else {
                            scope.savedDesktopSetting = scope.saveDesktopSettingService.getObject();
                            scope.saveDesktopSettingService.setAnalogChartAutoScalingSetting(!scope.varToggle, scope);
                        }                        

                        var tmpDates, tmpStartDate = null, tmpEndDate = null;
                        scope.loadingInProgress = true;
                        
                        if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) {
                            scope.stickyProperties.on = true;
                            tmpStartDate = scope.stickyProperties.dateMin;
                            tmpEndDate = scope.stickyProperties.dateMax;
                        }
                        else {
                            scope.stickyProperties.on = false;
                        }

                        if (!tmpStartDate) {
                            timeLapseService.getLocalDateTime().then(function (result) {
                                tmpDates = new Date(result.data.localDateTime);
                                tmpDates.setHours(0, 0, 0, 0);
                                tmpDates = datetimeService.dateToUnixtime(tmpDates);
                                tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                                tmpDates = datetimeService.startEndLocalToUtc(tmpDates, scope.accountInfo.timeZone);
                                tmpStartDate = tmpDates.startDate;
                                tmpEndDate = tmpDates.endDate;
                                _getData(newValue, tmpStartDate, tmpEndDate);
                            });
                        }
                        else {
                            _getData(newValue, tmpStartDate, tmpEndDate);
                        }
                    }
                }, true);

                scope.yAxisVisibleCheck = function () {
                    if (scope.yAxis == null || angular.isUndefined(chart) || $rootScope.classicView) return;
                    scope.loadingInProgress = true;
                    scope.windowWidth = $(element).width();
                    var additionalWidth = scope.yAxis.length > 2 ? (scope.yAxis.length - 2) * 70 : 0;
                    if (scope.yAxis.length > 1 && (scope.windowWidth <= (450 + additionalWidth))) {

                        for (var i = 0; i < chart.series.length - 1; i++) {
                            chart.yAxis[i].update({
                                visible: true,
                                labels: {
                                    enabled: false
                                },
                                title: {
                                    enabled: false
                                },
                                lineWidth: 0
                            });
                        }
                    }
                    else {
                        for (var i = 0; i < chart.series.length - 1; i++) {
                            chart.yAxis[i].update({
                                visible: true, //chart.series[i].visible ? true : false,
                                labels: {
                                    enabled: chart.series[i].visible ? true : false
                                },
                                title: {
                                    enabled: chart.series[i].visible ? true : false
                                },
                                lineWidth: chart.series[i].visible ? 2 : 0
                            });
                        }
                    }
                    scope.getButtonPositionY();
                    scope.loadingInProgress = false;
                }

                scope.getButtonPositionY = function() {
                    if (scope.windowWidth >= 364 && scope.windowWidth < 450) {
                        return -50;
                    } else return -65;
                }

                scope.getDashStyle = function (plotLineTypeID) {
                    switch (plotLineTypeID) {
                        case 0:
                            return 'Solid';
                            break;
                        case 1:
                            return 'ShortDash';
                            break;
                        case 2:
                            return 'ShortDot';
                            break;
                        case 3:
                            return 'ShortDashDot';
                            break;
                        case 4:
                            return 'ShortDashDotDot';
                            break;
                        case 5:
                            return 'Dot';
                            break;
                        case 6:
                            return 'Dash';
                            break;
                        case 7:
                            return 'LongDash';
                            break;
                        case 8:
                            return 'DashDot';
                            break;
                        case 9:
                            return 'LongDashDot';
                            break;
                        case 10:
                            return 'LongDashDotDot';
                            break;
                    }
                }

                scope.preparePlotLines = function () {

                    if (scope.series == null) return;

                    for (var i = 0; i < scope.thresholds.length; i++) {
                        scope.thresholds[i].thresholdDescriptions.en.highFault =  scope.thresholds[i].thresholdDescriptions.en.highFault != null ? scope.thresholds[i].thresholdDescriptions.en.highFault.replace(/##1|\(##1\)/g, '').trim()
                        :scope.thresholds[i].thresholdDescriptions.en.highFault;
                        scope.thresholds[i].thresholdDescriptions.en.highRestore = scope.thresholds[i].thresholdDescriptions.en.highRestore != null ? scope.thresholds[i].thresholdDescriptions.en.highRestore.replace(/##1|\(##1\)/g, '').trim()
                        : scope.thresholds[i].thresholdDescriptions.en.highRestore ;
                        scope.thresholds[i].thresholdDescriptions.en.highHighFault = scope.thresholds[i].thresholdDescriptions.en.highHighFault != null? scope.thresholds[i].thresholdDescriptions.en.highHighFault.replace(/##1|\(##1\)/g, '').trim()
                        : scope.thresholds[i].thresholdDescriptions.en.highHighFault;
                        scope.thresholds[i].thresholdDescriptions.en.highHighRestore = scope.thresholds[i].thresholdDescriptions.en.highHighRestore != null ? scope.thresholds[i].thresholdDescriptions.en.highHighRestore.replace(/##1|\(##1\)/g, '').trim()
                        : scope.thresholds[i].thresholdDescriptions.en.highHighRestore;
                        scope.thresholds[i].thresholdDescriptions.en.lowFault = scope.thresholds[i].thresholdDescriptions.en.lowFault != null ? scope.thresholds[i].thresholdDescriptions.en.lowFault.replace(/##1|\(##1\)/g, '').trim()
                        : scope.thresholds[i].thresholdDescriptions.en.lowFault;
                        scope.thresholds[i].thresholdDescriptions.en.lowRestore =  scope.thresholds[i].thresholdDescriptions.en.lowRestore != null ? scope.thresholds[i].thresholdDescriptions.en.lowRestore.replace(/##1|\(##1\)/g, '').trim()
                        : scope.thresholds[i].thresholdDescriptions.en.lowRestore;
                        scope.thresholds[i].thresholdDescriptions.fr.highFault = scope.thresholds[i].thresholdDescriptions.en.highFault != null ?scope.thresholds[i].thresholdDescriptions.en.highFault.replace(/##1|\(##1\)/g, '').trim()
                        : scope.thresholds[i].thresholdDescriptions.en.highFault;
                        scope.thresholds[i].thresholdDescriptions.fr.highRestore = scope.thresholds[i].thresholdDescriptions.en.highRestore != null  ? scope.thresholds[i].thresholdDescriptions.en.highRestore.replace(/##1|\(##1\)/g, '').trim()
                        : scope.thresholds[i].thresholdDescriptions.en.highRestore;
                        scope.thresholds[i].thresholdDescriptions.fr.highHighFault = scope.thresholds[i].thresholdDescriptions.en.highHighFault != null ? scope.thresholds[i].thresholdDescriptions.en.highHighFault.replace(/##1|\(##1\)/g, '').trim()
                        : scope.thresholds[i].thresholdDescriptions.en.highHighFault;
                        scope.thresholds[i].thresholdDescriptions.fr.highHighRestore = scope.thresholds[i].thresholdDescriptions.en.highHighRestore != null ? scope.thresholds[i].thresholdDescriptions.en.highHighRestore.replace(/##1|\(##1\)/g, '').trim()
                        :scope.thresholds[i].thresholdDescriptions.en.highHighRestore;
                        scope.thresholds[i].thresholdDescriptions.fr.lowFault = scope.thresholds[i].thresholdDescriptions.en.lowFault != null ? scope.thresholds[i].thresholdDescriptions.en.lowFault.replace(/##1|\(##1\)/g, '').trim()
                        : scope.thresholds[i].thresholdDescriptions.en.lowFault;
                        scope.thresholds[i].thresholdDescriptions.fr.lowRestore = scope.thresholds[i].thresholdDescriptions.en.lowRestore != null ? scope.thresholds[i].thresholdDescriptions.en.lowRestore.replace(/##1|\(##1\)/g, '').trim()
                        : scope.thresholds[i].thresholdDescriptions.en.lowRestore;
                    }

                    for (var i = 0; i < scope.series.length; i++) {
                        if(typeof scope.yAxis[i] === 'undefined') {
                            // yAxis does not exist Do nothing
                        }
                        else {
                            scope.yAxis[i].plotLines = [];
                            //adding lake level reference lines
                            for (var j = 0; j < scope.levelReferences.length; j++) {
                                for (var k = 0; k < scope.levelReferences[j].length; k++) {
                                    if (scope.series[i].id == scope.levelReferences[j][k].channel) {
                                        scope.yAxis[i].plotLines.push({
                                            id: "Lake Reference" + j + k,
                                            color: scope.levelReferences[j][k].hexColor, // Color value
                                            dashStyle: scope.getDashStyle(scope.levelReferences[j][k].plotLineTypeID - 1), // Style of the plot line. Default to solid
                                            value: scope.levelReferences[j][k].referenceValue, // Value of where the line will appear
                                            width: scope.series[i].lVisible ? 1 : 0, // Width of the line
                                            zIndex: scope.levelReferences[j][k].channel,
                                            label: {
                                                text: scope.levelReferences[j][k].referenceDescription,
                                                align: "right",
                                                y: -2,
                                                x: -10,
                                                style: {
                                                    color: scope.series[i].lVisible ? scope.levelReferences[j][k].hexColor : "transparent"
                                                }
                                            }
                                        })
                                    }
                                }
                            }
                        }
                        //adding thresholds lines
                        for (var m = 0; m < scope.thresholds.length; m++) {
                            var thresholdsLowFault = scope.thresholds[m].lowFault;
                            if (thresholdsLowFault !== null && thresholdsLowFault !== 0 && scope.series[i].id == scope.thresholds[m].channel) scope.yAxis[i].plotLines.push({
                                id: "Threshold lf",
                                color: scope.series[i].color,
                                dashStyle: "ShortDash",
                                label: {
                                    text: scope.thresholds[m].thresholdDescriptions[scope.langId].lowFault + "<i class='fa fa-bell' style='margin-left: 2px;'></i>",
                                    align: "right",
                                    y: 10,
                                    x: -2,
                                    style: {
                                        color: scope.series[i].tVisible ? scope.series[i].color : "transparent"
                                    },
                                    useHTML: true,
                                },
                                value: thresholdsLowFault,
                                width: scope.series[i].tVisible ? 1 : 0,
                                zIndex: scope.thresholds[m].channel
                            });
                            var thresholdsLowRestore = scope.thresholds[m].lowRestore;
                            if (thresholdsLowRestore !== null && thresholdsLowRestore !== 0 && scope.series[i].id == scope.thresholds[m].channel) scope.yAxis[i].plotLines.push({
                                id: "Threshold lr",
                                color: scope.series[i].color,
                                dashStyle: "Dash",
                                label: {
                                    text: scope.thresholds[m].thresholdDescriptions[scope.langId].lowRestore + "<i class='fa fa-bell-slash-o' style='margin-left: 2px;'></i>",
                                    align: "right",
                                    y: -2,
                                    x: -2,
                                    style: {
                                        color: scope.series[i].tVisible ? scope.series[i].color : "transparent"
                                    },
                                    useHTML: true,
                                },
                                value: thresholdsLowRestore,
                                width: scope.series[i].tVisible ? 1 : 0,
                                zIndex: scope.thresholds[m].channel
                            });
                            var thresholdsHighRestore = scope.thresholds[m].highRestore;
                            if (thresholdsHighRestore !== null && thresholdsHighRestore !== 0 && scope.series[i].id == scope.thresholds[m].channel) scope.yAxis[i].plotLines.push({
                                id: "Threshold hr",
                                color: scope.series[i].color,
                                dashStyle: "Dash",
                                label: {
                                    text: scope.thresholds[m].thresholdDescriptions[scope.langId].highRestore + "<i class='fa fa-bell-slash-o' style='margin-left: 2px;'></i>",
                                    align: "right",
                                    y: 10,
                                    x: -2,
                                    style: {
                                        color: scope.series[i].tVisible ? scope.series[i].color : "transparent"
                                    },
                                    useHTML: true
                                },
                                value: thresholdsHighRestore,
                                width: scope.series[i].tVisible ? 1 : 0,
                                zIndex: scope.thresholds[m].channel
                            });
                            var thresholdsHighHighRestore = scope.thresholds[m].highHighRestore;
                            if (thresholdsHighHighRestore !== null && thresholdsHighHighRestore !== 0 && scope.series[i].id == scope.thresholds[m].channel) scope.yAxis[i].plotLines.push({
                                id: "Threshold hhr",
                                color: scope.series[i].color,
                                dashStyle: "Dash",
                                label: {
                                    text: scope.thresholds[m].thresholdDescriptions[scope.langId].highHighRestore + "<i class='fa fa-bell-slash-o' style='margin-left: 2px;'></i>",
                                    align: "right",
                                    y: 10,
                                    x: -2,
                                    style: {
                                        color: scope.series[i].tVisible ? scope.series[i].color : "transparent"
                                    },
                                    useHTML: true
                                },
                                value: thresholdsHighHighRestore,
                                width: scope.series[i].tVisible ? 1 : 0,
                                zIndex: scope.thresholds[m].channel
                            });
                            var thresholdsHighFault = scope.thresholds[m].highFault;
                            if (thresholdsHighFault !== null && thresholdsHighFault !== 0 && scope.series[i].id == scope.thresholds[m].channel) scope.yAxis[i].plotLines.push({
                                id: "Threshold hf",
                                color: scope.series[i].color,
                                dashStyle: "ShortDash",
                                label: {
                                    text: scope.thresholds[m].thresholdDescriptions[scope.langId].highFault + "<i class='fa fa-bell' style='margin-left: 2px;'></i>",
                                    align: "right",
                                    y: -2,
                                    x: -2,
                                    style: {
                                        color: scope.series[i].tVisible ? scope.series[i].color : "transparent"
                                    },
                                    useHTML: true
                                },
                                value: thresholdsHighFault,
                                width: scope.series[i].tVisible ? 1 : 0,
                                zIndex: scope.thresholds[m].channel
                            });
                            var thresholdsHighHighFault = scope.thresholds[m].highHighFault;
                            if (thresholdsHighHighFault !== null && thresholdsHighHighFault !== 0 && scope.series[i].id == scope.thresholds[m].channel) scope.yAxis[i].plotLines.push({
                                id: "Threshold hhf",
                                color: scope.series[i].color,
                                dashStyle: "ShortDash",
                                label: {
                                    text: scope.thresholds[m].thresholdDescriptions[scope.langId].highHighFault + "<i class='fa fa-bell' style='margin-left: 2px;'></i>",
                                    align: "right",
                                    y: -2,
                                    x: -2,
                                    style: {
                                        color: scope.series[i].tVisible ? scope.series[i].color : "transparent"
                                    },
                                    useHTML: true
                                },
                                value: thresholdsHighHighFault,
                                width: scope.series[i].tVisible ? 1 : 0,
                                zIndex: scope.thresholds[m].channel
                            });
                        }
                    }
                };

                var _getData = function (deviceId, StartDate, EndDate) {
                    scope.liveDataEndDate = EndDate;
                    scope.refreshStart = StartDate;
                    scope.refreshEnd = EndDate;
                    
                    var tmpScopeSeries = angular.copy(scope.series);

                    analogChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + deviceId + '&StartDate=' + StartDate + '&EndDate=' + EndDate).then(function (datafromfactory) {
                         
                        scope.analogSetting = datafromfactory.data.setting;
                        scope.yAxis = datafromfactory.data.yAxis;

                        scope.series = datafromfactory.data.series;

                        setScopeSeriesLegendParameters(datafromfactory.data.thresholds, datafromfactory.data.levelReferences);

                        preserveLegendState(tmpScopeSeries);
                        tmpScopeSeries = undefined;

                        scope.levelReferences = datafromfactory.data.levelReferences;
                        scope.thresholds = datafromfactory.data.thresholds;

                        scope.preparePlotLines();                        
                        
                        scope.alerts = [];
                        var _device = { deviceName: scope.deviceSelectedName };
                        var hasData = false;

                        if (datafromfactory.data.series != null)
                            for (var k = 0; k < datafromfactory.data.series.length; k++) {
                                if (datafromfactory.data.series[k].data.length >= 1) {
                                    hasData = true;
                                }
                            }

                        if (datafromfactory.data.series && hasData) {
                            scope.devicename = datafromfactory.data.device.name;
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, windowId: scope.windowId });
                            _drawChart();
                            if(typeof  scope.varDay != "undefined")
                            {
                                scope.zoomAdjust(scope.varDay);
                            }
                            scope.loadingInProgress = false;
                        }
                        else {
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, zoomMin: scope.stickyProperties.zoomMin || StartDate, zoomMax: scope.stickyProperties.zoomMax || EndDate, windowId: scope.windowId });
                            element.empty();
                            scope.chart = null;
                            scope.loadingInProgress = false;
                            scope.lastStart = StartDate;
                            scope.lastEnd = EndDate;
                            var errormsg;
                            if (scope.analogSetting.length > 0) {
                                errormsg = scope.translation.message.NO_DATA + ": " + moment(StartDate).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(EndDate).utc().format('MM/DD/YY, h:mm:ss a');
                                scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                            }
                            else if (scope.deviceSelectedType == 20 && scope.deviceSKUId <= 1) {
                                errormsg = scope.translation.text.DEVICE_UNSUPPORTED;
                                scope.alerts.push({ msg: errormsg, type: "info", languageCode: "DEVICE_UNSUPPORTED" });
                            }
                            else {
                                errormsg = scope.translation.message.ANALOG_SETUP_INCOMPLETE;
                                scope.alerts.push({ msg: errormsg, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
                            }
                        }
                    },
                        function (error) {
                            scope.alerts = [];
                            element.empty();
                            scope.chart = null;
                            scope.loadingInProgress = false;
                            var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                            scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
                        });
                };

                scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
                    if (newValue && newValue != oldValue) {
                        scope.chartSeriesVisibility = [];
                        scope.stickyProperties.device.serialNumber = newValue;
                        if (oldValue) {
                            _unRegisterListener(oldValue);
                            scope._unRegisterListenerAnalogSetting(oldValue);
                        }
                    }
                }, true);

                scope.zoomAdjust = function(varDay){
                    var extremes = scope.chart.xAxis[0].getExtremes();
                    scope.varDay = varDay;
                    var extremeMinMax = rangeSelectorService.getChartExtremes( extremes.max, extremes.min, varDay, scope.heartbeatLocalDateTime);
                    scope.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
                    _setLiveDataStatus();
                };

                scope.adjustScaleNew = function () {
                    adjustScale(scope.chart);
                }

                scope.selectMyDateC = function () {
                    scope.stickyProperties.setting.savedDesktop = true;
                    var tmpDates = this.myDate;
                    scope.loadingInProgress = true;
                    tmpDates.setHours(0, 0, 0, 0);
                    tmpDates = datetimeService.dateToUnixtime(tmpDates);
                    tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                    tmpDates = datetimeService.startEndLocalToUtc(tmpDates, scope.accountInfo.timeZone);
                    scope.refreshStart = tmpDates.startDate;
                    scope.refreshEnd = tmpDates.endDate;
                    analogChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromfactory) {
                            var tmpScopeSeries = angular.copy(scope.series);
                            scope.series = datafromfactory.data.series;
                            preserveLegendState(tmpScopeSeries);
                            tmpScopeSeries = undefined;
                            scope.devicename = datafromfactory.data.device.name;
                            scope.alerts = [];
                            var hasData = false;

                            for(var k = 0; k < datafromfactory.data.series.length; k++)
                            {
                               if(datafromfactory.data.series[k].data.length >= 1)
                               {
                                hasData = true;
                               }
                            }
                            if (datafromfactory.data.series && hasData) {
                                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, windowId: scope.windowId });
                                _drawChart();
                            }
                            else {
                                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: (tmpDates.startDate + scope.unixDay), zoomMax: (tmpDates.endDate - scope.unixDay), windowId: scope.windowId });
                                element.empty();
                                scope.chart = null;
                                scope.lastStart = tmpDates.startDate;
                                scope.lastEnd = tmpDates.endDate;
                                var errormsg = scope.translation.message.NO_DATA + ': ' + moment(tmpDates.startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(tmpDates.endDate).utc().format('MM/DD/YY, h:mm:ss a');
                                scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                                scope.loadingInProgress = false;
                            }
                        },
                        function (error) {
                            scope.alerts = [];
                            element.empty();
                            scope.chart = null;
                            scope.loadingInProgress = false;
                            var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                            scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
                        });
                };

                function adjustScale(chart) {
                    scope.saveDesktopSettingService.setAnalogChartAutoScalingSetting(scope.varToggle, scope);
                    for (var i = 0; i < chart.series.length - 1 ; i++) {
                        if (scope.varToggle === false) {
                            if (scope.analogSetting[i].minimumValue > scope.analogSetting[i].maximumValue) {
                                chart.yAxis[i].setExtremes(scope.analogSetting[i].maximumValue, scope.analogSetting[i].minimumValue);
                            } else {
                                chart.yAxis[i].setExtremes(scope.analogSetting[i].minimumValue, scope.analogSetting[i].maximumValue);
                            }
                        } else {
                            chart.yAxis[i].setExtremes(null, null);
                        }
                    }
                    var extremes = chart.xAxis[0].getExtremes();
                    chart.xAxis[0].setExtremes(extremes.min + scope.minPadding, extremes.max + scope.maxPadding);
                    scope.varToggle = !scope.varToggle;                    
                }

                //Check if Thresholds are setup
                var checkIfThresholdsAreSetup = function (threshold) {
                    return (
                        (threshold.lowFault != null && threshold.lowFault != 0) ||
                        (threshold.lowRestore != null && threshold.lowRestore != 0) ||
                        (threshold.highRestore != null && threshold.highRestore != 0) ||
                        (threshold.highFault != null && threshold.highFault != 0) ||
                        (threshold.highHighRestore != null && threshold.highHighRestore != 0) ||
                        (threshold.highHighFault != null && threshold.highHighFault != 0)
                    );
                };

                //Set yAxis check-boxes for Thresholds & Lake Level
                var setScopeSeriesLegendParameters = function (thresholds, levelReferences) {                    
                    setyAxisLegendThresholds(thresholds);                    
                    setyAxisLegendLakeLevel(levelReferences);
                };

                //Set yAxis check-boxes for Thresholds
                var setyAxisLegendThresholds = function (thresholds) {
                    if (scope.series == null) return;
                    for (var i = 0; i < scope.series.length; i++) {
                        var channel = scope.series[i].id;
                        for (var j = 0; j < thresholds.length; j++) {
                            if (thresholds[j].channel == channel && checkIfThresholdsAreSetup(thresholds[j]))  {  
                                scope.series[i].tExist = true;
                                scope.series[i].tVisible = true;
                                break;
                            }
                        }
                    }
                };

                //Set yAxis check-boxes for Lake Level
                var setyAxisLegendLakeLevel = function (lakelevel) {
                    if (scope.series == null) return;
                    for (var i = 0; i < scope.series.length; i++) {
                        var channel = scope.series[i].id;
                        for (var j = 0; j < lakelevel.length; j++) {

                            for (var z = 0; z < lakelevel[j].length; z++) {
                                if (lakelevel[j][z].channel == channel) {
                                    scope.series[i].lExist = true;
                                    scope.series[i].lVisible = true;
                                    break;
                                }
                            }

                        }
                    }
                };

                var preserveLegendState = function (state) {
                    if (state == null || angular.isUndefined(state)) return;
                    for (var i = 0; i < scope.series.length; i++) {
                        var id = scope.series[i].id;
                        for (var j = 0; j < state.length; j++) {
                            if (state[j].id == id) {
                                scope.series[i].tExist = state[j].tExist;
                                scope.series[i].tVisible = state[j].tVisible;
                                scope.series[i].lExist = state[j].lExist;
                                scope.series[i].lVisible = state[j].lVisible;
                                break;
                            }
                        } 
                    }
                };

                scope.getLegendLabels = function (index, color) {
                    if (angular.isUndefined(scope.series[index])) return; 
                    var myHTML = "";

                    if (scope.series[index].tExist && scope.series[index].tVisible) {
                        myHTML = myHTML + '<i style="display: block; padding: 2px; color: ' + color + '" class="fa fa-check-square mc-analog-thresholds"><span style="font-family: Roboto; font-size: smaller; color: #333333;" class="span-mc-analog-thresholds"> Thresholds</span></i>';
                    }
                    else if (scope.series[index].tExist && !scope.series[index].tVisible) {
                        myHTML = myHTML + '<i style="display: block; padding: 2px; color: ' + color + '" class="fa fa-square-o mc-analog-thresholds"><span style="font-family: Roboto; font-size: smaller; color: #333333;" class="span-mc-analog-thresholds"> Thresholds</span></i>';
                    }


                    if (scope.series[index].lExist && scope.series[index].lVisible) {
                        myHTML = myHTML + '<i style="display: block; padding: 2px; color: ' + color + '" class="fa fa-check-square mc-analog-lakeLevel"><span style="font-family: Roboto; font-size: smaller; color: #333333;" class="span-mc-analog-lakeLevel"> Level Reference</span></i>';
                    }
                    else if (scope.series[index].lExist && !scope.series[index].lVisible) {
                        myHTML = myHTML + '<i style="display: block; padding: 2px; color: ' + color + '" class="fa fa-square-o mc-analog-lakeLevel"><span style="font-family: Roboto; font-size: smaller; color: #333333;" class="span-mc-analog-lakeLevel""> Level Reference</span></i>';
                    }

                    return myHTML;

                };

                var formatLegend = function () {
                    return this.name + ' ' + scope.getLegendLabels(this.index, this.color);
                }

                scope.togglePlotLines = function (visible, channel, type) {
                    for (var i = 0; i < chart.yAxis.length; i++) {
                        if (angular.isUndefined(chart.yAxis[i].options.plotLines))
                            continue;
                        for (var j = 0; j < chart.yAxis[i].options.plotLines.length; j++) {
                            if (chart.yAxis[i].options.plotLines[j].zIndex == channel && (chart.yAxis[i].options.plotLines[j].id).includes(type)) {
                                chart.yAxis[i].options.plotLines[j].width = visible ? 1 : 0;
                                chart.yAxis[i].options.plotLines[j].label.style.color = visible ? chart.yAxis[i].options.plotLines[j].color : "transparent"; 
                            }
                        }
                        chart.yAxis[i].update({});
                    }
                };

                function placeHighchartsTooltipInTooltipContainer() {
                    //Timeout needed for the content to be written to the Tooltip
                    //so we initially do not have an empty tooltip.
                    $timeout(function () {
                        //FInd Highcharts Tooltip
                        var toolTip = $(element).find('div.analog-chart-tooltip');
                        //Check if in the wrong position (outside tooltip container)
                        if (toolTip.length && !toolTip.parent().hasClass("highcharts-tooltip-container")) {
                            //Find the Tooltip Container (always find the very last)
                            var toolTipContainer = $("body").find('div.highcharts-tooltip-container:last');
                            //Remove the Tooltip before appending it to the Container
                            $(element).find('div.analog-chart-tooltip').remove();
                            //Append the Tooltip to the Container
                            toolTip.appendTo(toolTipContainer);
                        }
                    }, 0);
                }            
                
                var _drawChart = function (resetView) {
                    scope.tmpData = scope.series, chartDrawn = false;
                    scope.numberOfSeries = scope.series.length;
                    scope.numberOfHiddenSeries = 0;

                    var chartXaxisHourFormat = scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
                    var chartToolTipHourFormat = scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

                    chart = new Highcharts.StockChart({
                        credits: {
                            enabled: false
                        },
                        legend: {
                            enabled: true,
                            backgroundColor: '#f9f9f9',
                            borderColor: '#cccccc',
                            borderWidth: 1,
                            align: 'left',
                            layout: 'vertical',
                            verticalAlign: 'top',
                            y: 9,
                            useHTML: true,
                            style: { 'font-family': 'Roboto' },
                            labelFormatter: formatLegend
                            
                        },
                        time: {
                             getTimezoneOffset: function (timestamp) {
                                return -moment.tz(timestamp, datetimeService.getTimeZoneId(scope.accountInfo.timeZone)).utcOffset();
                            }
                        },
                        chart: {
                            renderTo: element[0],
                            alignThresholds: false,
                            backgroundColor: '#ebebeb',
                            plotBackgroundColor: '#f9f9f9',
                            borderColor: '#d3d3d3',
                            borderWidth: 1,
                            borderRadius: 2,
                            panning: true,
                            panKey: 'shift',
                            pinchType: 'x',
                            plotBorderWidth: 1,
                            marginTop: 10,
                            //marginRight: 10,
                            spacingBottom: 10,
                            spacingTop: 0,
                            spacingLeft: 2,
                            //spacingRight: 30,
                            animation: false,
                            reflow: true,
                            events: {
                                redraw: function (event) {
                                    if (this.options.chart.forExport) return false;
                                    var tmpDates,
                                        i,
                                        analogData = [],
                                        extremes = this.xAxis[0].getExtremes();

                                    if (this.xAxis && chartDrawn === true && scrollingInProgress === false) {
                                        if (scope.loadingInProgress == false && extremes && extremes.dataMin >= extremes.min - scope.liveDataOffset) {
                                            scrollingInProgress = true;
                                            this.showLoading();
                                            var dateMin = new Date(extremes.dataMin);
                                            var dateMinOffset = dateMin.getTimezoneOffset();
                                            var offset= !isNaN(dateMinOffset) ? dateMinOffset : scope.accountInfo.timeZoneOffset; 

                                            //Highcharts retruns extreme data points in Local Machine TimeZone. 
                                            //If customer logs in from different timeZone. Respect the set Customer TimeZone for the incoming data
                                            if(dateMinOffset != scope.accountInfo.timeZoneOffset)
                                            {
                                                extremes.dataMin = extremes.dataMin + Number(dateMinOffset - scope.accountInfo.timeZoneOffset) * 60 * 1000;
                                            }
                                            //convert utctime to local time by considering timezoneoffset
                                            var newtempDate = extremes.dataMin - offset * 60 * 1000;
                                            if(scope.varDay == 3)
                                            {
                                                tmpDates = datetimeService.getNewStartEndDates(newtempDate, -12);
                                            }
                                            else
                                            {    
                                                tmpDates = datetimeService.getNewStartEndDates(newtempDate, -11);
                                            }
                                            analogChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromfactory) {
                                                    if (datafromfactory.data.series && datafromfactory.data.series.length > 0) {
                                                     for (i = 0; i < datafromfactory.data.series.length; i++) {
                                                            analogData.push(datafromfactory.data.series[i].data);
                                                        }
                                                    }

                                                    if (datafromfactory.data.series && datafromfactory.data.series.length > 0) {
                                                        for (i = 0; i < datafromfactory.data.series.length; i++) {
                                                            scope.tmpData[i].data = analogData[i].concat(scope.tmpData[i].data);
                                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                                            scope.tmpData[i].data.sort(function (a, b) {
                                                                return a[0] - b[0];
                                                            });
                                                            chart.series[i].setData(scope.tmpData[i].data);
                                                         }
                                                    }

                                                    scope.devicename = datafromfactory.data.device.name;
                                                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, windowId: scope.windowId });
                                                    chart.xAxis[0].setExtremes(extremes.min + scope.minPadding, extremes.max + scope.maxPadding);
                                                    _setLiveDataStatus();

                                                    $timeout(function () {
                                                        scrollingInProgress = false;
                                                    }, 1000);

                                                    chart.hideLoading();
                                                },
                                                function (error) {
                                                    scope.alerts = [];
                                                    element.empty();
                                                    scope.chart = null;
                                                    scope.loadingInProgress = false;
                                                    var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                                                    scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
                                                });
                                        } else if (scope.loadingInProgress == false && scope.liveData === false && extremes && extremes.max + scope.liveDataOffset >= extremes.dataMax) {
                                            scrollingInProgress = true;
                                            this.showLoading();
                                            //convert utctime to local time by considering timezoneoffset
                                            var dateMax = new Date(extremes.dataMax);
                                            var dateMaxOffset = dateMax.getTimezoneOffset();
                                            var offsetMax= !isNaN(dateMaxOffset) ? dateMaxOffset :  scope.accountInfo.timeZoneOffset; 

                                            //If customer logs in from different timeZone. Respect the set Customer TimeZone for the incoming data
                                            if(dateMaxOffset != scope.accountInfo.timeZoneOffset)
                                            {
                                                extremes.dataMax = extremes.dataMax + Number(dateMaxOffset - scope.accountInfo.timeZoneOffset) * 60 * 1000;
                                            }
                                            var tempDateNew = extremes.dataMax - offsetMax * 60 * 1000;
                                            tmpDates = datetimeService.getNewStartEndDates(parseInt(tempDateNew), 11);

                                            analogChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate).then(function (datafromfactory) {
                                                    if (datafromfactory.data.series && datafromfactory.data.series.length > 0) {
                                                        for (i = 0; i < datafromfactory.data.series.length; i++) {
                                                            analogData.push(datafromfactory.data.series[i].data);
                                                        }
                                                    }

                                                    if (datafromfactory.data.series && datafromfactory.data.series.length > 0) {
                                                        for (i = 0; i < datafromfactory.data.series.length; i++) {
                                                            scope.tmpData[i].data = scope.tmpData[i].data.concat(analogData[i]);
                                                            //sort series to avoid HighChart multi line issue(SCADA-9892)
                                                            scope.tmpData[i].data.sort(function (a, b) {
                                                                return a[0] - b[0];
                                                            });
                                                            chart.series[i].setData(scope.tmpData[i].data);
                                                        }
                                                    }

                                                    scope.devicename = datafromfactory.data.device.name;
                                                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMax: tmpDates.endDate, windowId: scope.windowId });
                                                    chart.xAxis[0].setExtremes(extremes.min + scope.minPadding, extremes.max + scope.maxPadding);
                                                    _setLiveDataStatus(tmpDates.endDate);

                                                    $timeout(function () {
                                                        scrollingInProgress = false;
                                                    }, 1000);

                                                    chart.hideLoading();
                                                },
                                                function (error) {
                                                    scope.alerts = [];
                                                    element.empty();
                                                    scope.chart = null;
                                                    scope.loadingInProgress = false;
                                                    var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                                                    scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
                                                });
                                        }
                                    }
                                },
                                load: function (event) {
                                    if (initialLoad) {
                                        openViewService.adjustContentSize(scope.popup);
                                    }
                                    else {
                                        if (scope.stickyProperties.setting == null)
                                            scope.stickyProperties.setting = { savedDesktop: false };
                                        scope.stickyProperties.setting.savedDesktop = true;
                                    }
                                    //will remove after changing Mc.Services
                                    for (var i = 0; i < this.series.length - 1 ; i++) {
                                        if (scope.accountInfo.customerId == 13041 && scope.deviceSelected == 29138 && i == 0) {
                                            this.yAxis[i].update({
                                                startOnTick: false,
                                                endOnTick: false,
                                                allowDecimals: true,
                                                labels: {
                                                    format: "{value:.1f}"
                                                }
                                            });
                                        }
                                        else {
                                            this.yAxis[i].update({
                                                allowDecimals: false,
                                                labels: {
                                                    format: "{value:.0f}"
                                                }
                                            });
                                        }
                                        if (scope.chartSeriesVisibility.length > 0) sharedSetupService.setChartSeriesVisibility(this, scope.chartSeriesVisibility);
                                    }
                                    //will remove after changing Mc.Services                                    
                                    //initialLoad = false;     
                                    scope.adjustLegend();
                                    $timeout(function () {
                                        scope.saveDesktopSettingService.applySavedDesktopSetting(chart, scope, true);
                                        if (initialLoad || checkYaxis) {
                                            $timeout(function () {
                                                scope.yAxisVisibleCheck();
                                            }, 0);
                                        }
                                        initialLoad = false; 
                                        checkYaxis = !initialLoad;
                                    }, 0);                                    
                                },
                                selection: function (event) {
                                    if (event.xAxis) {
                                        //
                                    } else {
                                        var button = this.exportSVGElements[0];
                                        var button2 = this.exportSVGElements[2];
                                        button.attr({
                                            x: -200//-5
                                        });
                                        button2.attr({
                                            x: -200
                                        });
                                        adjustScale(this);
                                    }
                                }
                            }
                        },
                        title: {
                            style: {
                                color: '#6D869F',
                                fontWeight: 'bold'
                            }
                        },
                        subtitle: {
                            text: null
                        },
                        exporting: {
                            buttons: {
                                contextButton: {
                                    enabled: false
                                },
                                customButton: {
                                    symbol: 'text:\uf205',
                                    text: scope.translation.text.AUTO_SCALE,
                                    symbolSize: 9,
                                    symbolFill: '#337ab7',
                                    symbolStrokeWidth: 0,
                                    align: "left",
                                    verticalAlign: 'bottom',
                                    //x: scope.varToggle ? -200 : -5,
                                    x: scope.varToggle ? -200 : -200,
                                    y: $rootScope.mobile ? scope.getButtonPositionY() : scope.getButtonPositionY(), //I know...
                                    symbolY: $rootScope.mobile ? 14 : 14,
                                    theme: {
                                        'stroke-width': 0,
                                        stroke: 'transparent',
                                        fill: 'transparent',
                                        r: 0,
                                        states: {
                                            hover: {
                                                title: scope.translation.text.TOGGLE_AUTOSCALE,
                                                fill: 'transparent'
                                            },
                                            select: {
                                                stroke: 'transparent',
                                                fill: 'transparent'
                                            }
                                        }
                                    },
                                    onclick: function () {
                                        var button = this.exportSVGElements[0];
                                        var button2 = this.exportSVGElements[2];
                                        button.attr({
                                            x: -200
                                        });
                                        button2.attr({
                                            x: -200//-5
                                        });
                                        adjustScale(this);
                                    }
                                },
                                customButton2: {
                                    symbol: 'text:\uf204',
                                    text: scope.translation.text.AUTO_SCALE,
                                    symbolSize: 9,
                                    symbolFill: '#6b7074',
                                    symbolStrokeWidth: 0,
                                    align: "left",
                                    verticalAlign: 'bottom',
                                    //x: scope.varToggle ? -5 : -200,
                                    x: scope.varToggle ? -200 : -200,
                                    y: $rootScope.mobile ? scope.getButtonPositionY() : scope.getButtonPositionY(), //I know...
                                    symbolY: $rootScope.mobile ? 14 : 14,
                                    theme: {
                                        'stroke-width': 0,
                                        stroke: 'transparent',
                                        fill: 'transparent',
                                        r: 0,
                                        states: {
                                            hover: {
                                                title: scope.translation.text.TOGGLE_AUTOSCALE,
                                                fill: 'transparent'
                                            },
                                            select: {
                                                stroke: 'transparent',
                                                fill: 'transparent'
                                            }
                                        }
                                    },
                                    onclick: function () {
                                        var button = this.exportSVGElements[0];
                                        var button2 = this.exportSVGElements[2];
                                        button.attr({
                                            x: -200//-5
                                        });
                                        button2.attr({
                                            x: -200
                                        });
                                        adjustScale(this);
                                    }
                                }
                            }
                        },
                        xAxis: {
                            minRange: 3600 / 4 * 1000, //15 minutes
                            title: {
                                //text: scope.translation.text.TIME,
                                style: {
                                    color: '#6D869F',
                                    fontWeight: 'bold',
                                    fontSize: '15px'
                                }
                            },
                            plotLines: [{
                                value: 0,
                                width: 3,
                                color: 'green',
                                dashStyle: "solid",
                                zIndex: 1
                            }],
                            endOnTick: true,
                            showLastLabel: true,
                            startOnTick: true,
                            ordinal: false,
                            minTickInterval: 3600 * 1000,
                            minorGridLineColor: '#ebebeb',
                            minorTickInterval: 'auto',
                            dateTimeLabelFormats: {
                                hour: chartXaxisHourFormat
                            },
                            labels: {
                                style: {
                                    color: '#6D869F',
                                    fontWeight: 'bold'
                                }
                            },
                            events: {
                                afterSetExtremes: function (e) {
                                    if (chartDrawn === true) {
                                        var extremes = chart.xAxis[0].getExtremes();
                                        if (scope.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) { //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                            if (extremes.max + scope.liveDataOffset <= extremes.dataMax) {
                                                sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                                                _unRegisterListener(scope.deviceSelectedSn);
                                            }
                                        }
                                        sharedSetupService.setStickyProperties(scope.stickyProperties, { zoomMin: extremes.min, zoomMax: extremes.max, windowId: scope.windowId });
                                        _downsampleSeries(extremes.min, extremes.max);
                                    }
                                }
                            }
                        },
                        yAxis: scope.yAxis,
                        tooltip: {
                            useHTML: true,
                            formatter: function () {
                                var d = new Date(this.x);
                                var s = '';
                                s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                                s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x,scope.accountInfo.timeZone)) + '</td></tr>';
                                $.each(this.points, function (i, point) {
                                    var numDecimals = sharedSetupService.getNumberOfDecimals(scope.analogSetting[point.series.index].maximumValue, scope.analogSetting[point.series.index].minimumValue)
                                    s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, numDecimals) + '</td></tr>';
                                    xValue = point.x;
                                });
                                s += '</table>';
                                placeHighchartsTooltipInTooltipContainer();//correcting Highcharts bug
                                return s;
                            },
                            crosshairs: true,
                            shared: true,
                            valueDecimals: 1,
                            //hideDelay: 1000 * 60 * 10,
                            outside: true,
                            className: 'analog-chart-tooltip'
                        },
                        navigator: {
                            enabled: true,
                            adaptToUpdatedData: true,
                            series: {
                                lineWidth: 0,
                                color: 'transparent'
                            },
                            maskFill: 'rgba(255, 255, 255, 0.35)',
                            maskInside: true,
                            handles: {
                                backgroundColor: '#a4a7a9',
                                borderColor: '#384450'
                            },
                            height: 22,
                            margin: 0,
                            xAxis: {
                                tickWidth: 2,
                                lineWidth: 1,
                                gridLineWidth: 0,
                                tickLength: 15,
                                tickPosition: 'inside',
                                tickColor: '#98b3d1',
                                dateTimeLabelFormats: {
                                    hour: chartXaxisHourFormat
                                },
                                labels: {
                                    align: 'left',
                                    style: {
                                        color: '#61768f',
                                        fontWeight: 'bold'
                                    },
                                    x: 8,
                                    y: -8
                                }
                            }
                        },
                        scrollbar: {
                            enabled: true,
                            height: 0,
                            barBackgroundColor: '#959595',
                            barBorderRadius: 2,
                            barBorderWidth: 0,
                            buttonBackgroundColor: '#959595',
                            buttonBorderWidth: 0,
                            buttonBorderRadius: 2,
                            trackBackgroundColor: 'none',
                            trackBorderWidth: 1,
                            trackBorderRadius: 3,
                            trackBorderColor: '#CCC',
                            liveRedraw: true
                        },
                        rangeSelector: {
                            enabled: false
                        },
                        plotOptions: {
                            series: {
                                showCheckbox: false,
                                dataGrouping: {
                                    enabled: false
                                },
                                point: {
                                    events: {
                                        mouseOver: function () {
                                            xValue = this.x;
                                        }
                                    }
                                },
                                marker: {
                                    fillColor: '#FFFFFF',
                                    lineWidth: 2,
                                    lineColor: null // inherit from series
                                },
                                events: {
                                    legendItemClick: function (e) {
                                        var legendElement = e.browserEvent.target.className;
                                        switch (legendElement) {
                                            case 'fa fa-check-square mc-analog-thresholds':
                                            case 'fa fa-square-o mc-analog-thresholds':
                                            case 'span-mc-analog-thresholds':
                                                e.preventDefault();                                                
                                                scope.series[this.index].tVisible = !scope.series[this.index].tVisible;
                                                scope.togglePlotLines(scope.series[this.index].tVisible, scope.series[this.index].id, "Threshold");
                                                chart.legend.update({
                                                    labelFormatter: formatLegend
                                                });
                                                scope.saveDesktopSettingService.setVisibilitySetting("t", this.options.id, scope.series[this.index].tVisible ? true : false, scope);
                                                break;
                                            case 'fa fa-check-square mc-analog-lakeLevel':
                                            case 'fa fa-square-o mc-analog-lakeLevel':
                                            case 'span-mc-analog-lakeLevel':
                                                e.preventDefault();
                                                scope.series[this.index].lVisible = !scope.series[this.index].lVisible;
                                                scope.togglePlotLines(scope.series[this.index].lVisible, scope.series[this.index].id, "Lake");
                                                chart.legend.update({
                                                    labelFormatter: formatLegend
                                                });
                                                scope.saveDesktopSettingService.setVisibilitySetting("l", this.options.id, scope.series[this.index].lVisible ? true : false, scope);
                                                break;
                                            default:
                                                if (this.visible) {
                                                    if (scope.numberOfHiddenSeries < (scope.numberOfSeries - 1)) {
                                                        scope.numberOfHiddenSeries = scope.numberOfHiddenSeries + 1;
                                                    } else {
                                                        return false;
                                                    }
                                                } else {
                                                    scope.numberOfHiddenSeries = scope.numberOfHiddenSeries - 1;
                                                }

                                                scope.windowWidth = $(element).width();
                                                var additionalWidth = scope.yAxis.length > 2 ? (scope.yAxis.length - 2) * 70 : 0;

                                                if (scope.yAxis.length > 1 && (scope.windowWidth <= (450 + additionalWidth))) {
                                                    this.chart.yAxis[this.index].update({
                                                        labels: {
                                                            enabled: false
                                                        },
                                                        title: {
                                                            enabled: false
                                                        },
                                                        lineWidth: 0
                                                    });
                                                } else {
                                                    this.chart.yAxis[this.index].update({
                                                        labels: {
                                                            enabled: this.visible ? false : true
                                                        },
                                                        title: {
                                                            enabled: this.visible ? false : true
                                                        },
                                                        lineWidth: this.visible ? 0 : 2
                                                    });
                                                }

                                                {
                                                    scope.series[this.index].lVisible = !this.visible;
                                                    scope.togglePlotLines(!this.visible, scope.series[this.index].id, "Lake");
                                                    scope.series[this.index].tVisible = !this.visible;
                                                    scope.togglePlotLines(!this.visible, scope.series[this.index].id, "Threshold");

                                                    chart.legend.update({
                                                        labelFormatter: formatLegend
                                                    });
                                                    scope.saveDesktopSettingService.setVisibilitySetting("l", this.options.id, scope.series[this.index].lVisible ? true : false, scope);
                                                    scope.saveDesktopSettingService.setVisibilitySetting("t", this.options.id, scope.series[this.index].tVisible ? true : false, scope);
                                                }

                                                scope.saveDesktopSettingService.setSerieVisibilitySetting(this.options.id, this.visible ? false : true, scope);
                                                if(scope.deviceSelectedType == 20 && scope.yAxis.length == 1) {
                                                    var rollingAvgExist = false;
                                                    rollingAvgExist = scope.series.length == 2 && scope.series[1].name.includes("Rolling Average");  
                                                    if(rollingAvgExist) {
                                                        if(!scope.series[this.index].lVisible && this.index == 0) {
                                                            this.chart.yAxis[0].update({visible: true, labels: {enabled: true}, title: {enabled: true, text: scope.series[this.index + 1].name, style: {color: scope.series[this.index + 1].color}}, lineWidth: 2, lineColor: scope.series[this.index + 1].color});
                                                        } 
                                                        else 
                                                        {
                                                            this.chart.yAxis[0].update({title: {enabled: true, text: scope.series[0].name, style: {color: scope.series[0].color}}, lineWidth: 2, lineColor: scope.series[0].color});  
                                                        }                                                    
                                                    }   
                                                }
                                            break;
                                        }                                        
                                    },
                                    mouseOut: function () {
                                        xValue = null;
                                    }
                                }
                            }
                        },
                        series: scope.series
                    });

                    scope.chart = chart;

                    var tmpNewDateA;
                    var tmpNewDateB;
                    var extremes = chart.xAxis[0].getExtremes();

                    if (scope.stickyProperties.on === true && scope.stickyProperties.mostRecentData === undefined) {
                        tmpNewDateA = scope.stickyProperties.zoomMin >= extremes.dataMin ? scope.stickyProperties.zoomMin : extremes.dataMin;//extremes.dataMin + scope.unixDay / 24 * 3;
                        tmpNewDateB = scope.stickyProperties.zoomMax <= extremes.dataMax + scope.liveDataOffset ? scope.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
                        tmpNewDateB = tmpNewDateB >= tmpNewDateA + scope.unixDay / 24 ? tmpNewDateB : extremes.dataMax - scope.unixDay / 24 * 12;
                        scope.stickyProperties.on = false;
                    }
                    else {
                        scope.stickyProperties.mostRecentData = undefined;
                        tmpNewDateA = scope.myDate !== null ? extremes.dataMin + scope.unixDay : extremes.dataMax - scope.unixDay / 24 * 4.5;
                        tmpNewDateB = scope.myDate !== null ? tmpNewDateA + scope.unixDay : extremes.dataMax;
                        if (tmpNewDateB > extremes.dataMax) {
                            tmpNewDateB = extremes.dataMax;
                            tmpNewDateA = tmpNewDateB - scope.unixDay;
                        }
                        tmpNewDateA = tmpNewDateA + scope.minPadding;
                        tmpNewDateB = tmpNewDateB + scope.maxPadding;

                    }

                    if(!scope.liveRefresh)  {
                        
                        chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
                    }
                    else
                    {
                        chart.xAxis[0].setExtremes(scope.extremesXaxis.max, scope.extremesXaxis.min);
                    }
                    if (scope.series !== null) { //only for analog chart if no setup
                        sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: scope.windowId });
                    }
                    else {
                        chart.showLoading(scope.translation.text.ANALOG_SETUP_UNAVAILABLE);
                    }

                    if (!resetView) {
                        _setLiveDataStatus();
                    }

                    chartDrawn = true;
                };

                //==========================socket data================================
                var wsDataReceivedANALOG = function (data) {

                    //Catch empty data in old ANALOG message for GENII/SparkPlug device
                    if (data.Type == "ANALOG" && scope.deviceSelectedType == 21) {
                        console.log(data);
                        return;
                    }

                    if (scope.liveData === false) {
                        _unRegisterListener(scope.deviceSelectedSn);
                        return;
                    }
                    
                    if (scope.deviceSelectedType == 20) {
                        scope.mostRecentDataDebounced();
                        return;
                    }

                    var extremes = chart.xAxis[0].getExtremes();
                    var tmpRange = extremes.max - extremes.min;

                    var str = data.Time + "";
                    var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
                    var varValue = parseFloat(data.Value);
                    unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, scope.accountInfo.timeZone);

                    for (var i = 0; i < 9; i++) {
                        if (chart.series[i] && parseInt(chart.series[i].options.id) <= 9 && data.CH) {
                            if (data.CH == chart.series[i].options.id) {
                                var series = chart.get(data.CH).series[0];
                                for (var j = 1; j <= 3; j++) {
                                    if (series && series.data && series.data[series.data.length - j] && series.data[series.data.length - j].marker) {
                                        series.data[series.data.length - j].remove();
                                    }
                                }
                                series.addPoint([unixtime, varValue]);
                                series.addPoint([unixtime, varValue]);
                                var tmpObj = series.data[series.data.length - 1];

                                if (!angular.isUndefined(tmpObj)) {

                                    tmpObj.update({
                                        marker: {
                                            enabled: true,
                                            fillColor: '#d4eacf',
                                            lineWidth: 4,
                                            lineColor: '#299610', // inherit from series
                                            radius: 6
                                        },
                                        color: '#659355'
                                    }, $timeout(function () {
                                        if (tmpObj.series != null) {
                                            tmpObj.update({
                                                marker: {
                                                    enabled: false
                                                }
                                            });
                                        }
                                    }, 2000));
                                }
                            }
                        }
                    }

                    if ((extremes.max + scope.liveDataOffset > extremes.dataMax) && data.CH == 1)
                        chart.xAxis[0].setExtremes(unixtime - tmpRange + scope.minPadding, unixtime + scope.maxPadding);
                    var varTime = datetimeService.socketStrToServerStrTime(data.Time);
                    scope.lastUpdateAt = varTime;
                };

                var wsDataReceivedCALLINSCOUNT = function (data) {
                    //CALLINSCOUNT message belongs to Ranger Device, and it is not applicable to other device type
                    if (scope.deviceSelectedType != 21) {
                        return;
                    }

                    if (scope.liveData === false) {
                        _unRegisterListener(scope.deviceSelectedSn);
                        return;
                    }

                    callInCountTimeout = $timeout(function () {

                        var str = data.Time + "";
                        var time = datetimeService.socketStrToServerStrTime(data.Time);
                        var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
                        unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, scope.accountInfo.timeZone);

                        for (var i = 0; i < 9; i++) {
                            if (chart.series[i] && parseInt(chart.series[i].options.id) <= 9) {
                                var series = chart.get(chart.series[i].options.id).series[0];
                                var tmpObj = series.data[series.data.length - 1]; //current data
                                //if new data point timestamp is different than current data timestamp, 
                                //then build the dummy data for ANALOG_G2 message with new timestamp and current data value
                                //because, we did not receive any ANALOG_G2 message for Ranger device, but it is has to be updated based on the time lapse
                                if (tmpObj.x != unixtime) { 
                                    data.Type = "ANALOG_G2";
                                    data.Value = tmpObj.y;
                                    data.CH = chart.series[i].options.id;
                                    wsDataReceivedANALOG(data);
                                }
                            }
                        }
                    }, 1000);

                }

                scope.$on('processReconnect', function (event, args) {                   
                    scope.reconnectData(event, args);
                });

                scope.reconnectData = function(event, args) {
                    sharedSetupService.processReconnect({
                        stickyProperties: scope.stickyProperties,
                        localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
                        dateRangeOption: 0,
                        windowTitle: scope.windowTitle,
                        fnUnregister: _unRegisterListener,
                        fnGetData: _getData,
                        viewType: "Chart"
                    });
                };

                scope.mostRecentData = function(event, args) {
                    scope.stickyProperties.mostRecentData = true;
                    scope.stickyProperties.liveData = true;
                    scope.myDate = null;
                    scope.reconnectData(event, args);
                };

                scope.mostRecentDataDebounced = debounceService(scope.mostRecentData, 400, false);

                var tlDataReceivedANALOG = function (data) {
                    data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, scope.accountInfo.timeZone);
                    if (scope.liveData === false) {
                        _unRegisterListener(scope.deviceSelectedSn);
                        return;
                    }

                    var extremes = chart.xAxis[0].getExtremes();
                    var tmpRange = extremes.max - extremes.min;

                    if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - scope.unixDay / 2) {
                        _unRegisterListener(scope.deviceSelectedSn);
                        return;
                    }
                    var liveDataLine = chart.xAxis[0].plotLinesAndBands;
                    liveDataLine[0].options.value = data.Unix + scope.maxPadding;

                    if (extremes.max + scope.liveDataOffset > extremes.dataMax)
                        chart.xAxis[0].setExtremes(data.Unix - tmpRange + scope.minPadding, data.Unix + scope.maxPadding);
                };

                var _setLiveDataStatus = function (varEndDate) {
                    scope.liveDataEndDate = varEndDate != null ? varEndDate : scope.liveDataEndDate;
                    timeLapseService.getLocalDateTime().then(function (result) {
                        var extremes = chart.xAxis[0].getExtremes();
                        scope.heartbeatLocalDateTime = result.data.unixTimeStamp;
                        if (scope.liveDataEndDate > result.data.unixTimeStamp && (scope.stickyProperties.zoomMax + scope.liveDataOffset >= extremes.dataMax)) {
                            _registerListener(scope.deviceSelectedSn);
                            var data = { Unix: result.data.unixTimeStamp, Value: null, SN: null, CH: null }
                            tlDataReceivedANALOG(data);
                        }
                        else {
                            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                            _unRegisterListener(scope.deviceSelectedSn);
                        }
                    });
                };

                var _registerListener = function (varSelectedSN) {
                    websocketService.connect();
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
                    for (var i = 0; i < 9; i++) { //chart.series.length - 1
                        if (chart.series[i] && parseInt(chart.series[i].options.id) <= 9) {
                            websocketService.register("ANALOG", varSelectedSN, chart.series[i].options.id, wsDataReceivedANALOG, null);
                            if (i == 0) {
                                timeLapseService.register("ANALOG", varSelectedSN, chart.series[i].options.id, tlDataReceivedANALOG);
                                websocketService.register("CALLINSCOUNT", varSelectedSN, "", wsDataReceivedCALLINSCOUNT, null);
                            }
                            websocketService.register("ANALOGSETTING", varSelectedSN, chart.series[i].options.id, scope.wsDataReceivedANALOGSETTINGAC, scope.wsReconnectANALOGOUTSETTING);
                            websocketService.register("ANALOG_G2", varSelectedSN, chart.series[i].options.id, wsDataReceivedANALOG, null);
                        }
                    }
                    scope.liveData = true;
                };

                scope.wsDataReceivedANALOGSETTINGAC = function (data) {

                    if (data.Type == 'ANALOGSETTING' && data.SN == scope.deviceSelectedSn) {
                        if(scope.liveData)
                        {
                            scope.liveRefresh = true;
                            scope.extremesXaxis = scope.chart.xAxis[0].getExtremes();
                            _getData(scope.deviceSelected, scope.refreshStart, scope.refreshEnd);
                            scope.liveRefresh = false;
                        }
                        else
                        {
                            _resetViewFromLive(data.CH, data.Value);
                        }
                    }
                };
        
                scope.wsReconnectANALOGOUTSETTING = function (data) {
                    if (scope.liveData === false) {
                        _unRegisterListener();
                        return;
                    }
                };

                scope._unRegisterListenerAnalogSetting = function  (varSelectedSN) {

                    for (var i = 0; i < 9; i++) { //chart.series.length - 1
                        websocketService.unRegister("ANALOGSETTING", varSelectedSN, i + 1, scope.wsDataReceivedANALOGSETTINGAC, scope.wsReconnectANALOGOUTSETTING);
                    }
                };

                var _unRegisterListener = function (varSelectedSN) {

                    if (angular.isDefined(callInCountTimeout)) {
                        $timeout.cancel(callInCountTimeout);
                        callInCountTimeout = undefined;
                    }

                    for (var i = 0; i < 9; i++) { //chart.series.length - 1
                        websocketService.unRegister("ANALOG", varSelectedSN, i + 1, wsDataReceivedANALOG, null);
                        if (i == 0) {
                            timeLapseService.unRegister("ANALOG", varSelectedSN, i + 1, tlDataReceivedANALOG);
                            websocketService.unRegister("CALLINSCOUNT", varSelectedSN, "", wsDataReceivedCALLINSCOUNT, null);
                        }
                        websocketService.unRegister("ANALOG_G2", varSelectedSN, i + 1, wsDataReceivedANALOG, null);
                    }
                    scope.liveData = false;
                    scope.lastUpdateAt = undefined;
                };

                var _downsampleSeries = function (varMin, varMax) {
                    zoomLevelCurrent = varMax - varMin;
                    if (zoomLevelCurrent <= scope.unixDay && zoomLevelPrevious > scope.unixDay) {
                        for (var i = 0; i < chart.series.length - 1; i++) {
                            chart.series[i].update({ downsample: { threshold: 0 } }, false);
                            chart.series[i].setData(scope.series[i].data, false);
                        }
                        chart.redraw();
                    }
                    else if (zoomLevelCurrent > scope.unixDay && zoomLevelPrevious <= scope.unixDay) {
                        for (var i = 0; i < chart.series.length - 1; i++) {
                            chart.series[i].update({ downsample: { threshold: 1000 } }, false);
                        }
                        chart.redraw();
                    }
                    zoomLevelPrevious = zoomLevelCurrent;
                };


                var _resetView = function (args) {
                    scope.stickyProperties.on = true; 
                    for (var i = 0; i < scope.series.length; i++) {
                        if (scope.series[i].id == args.channel) {
                            var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
                            var _newDataValue = _newData.name + " (" + _newData.unit + ")";
                            scope.series[i].name = _newDataValue;
                            scope.yAxis[i].title.text = _newDataValue;
                        }
                    }
                    _drawChart(true);
                };

                var _resetViewFromLive = function (channel,patch) {
                    scope.stickyProperties.on = true;
                    for (var i = 0; i < scope.series.length; i++) {
                        if (scope.series[i].id == channel) {
                            var _newDataValue;
                            switch(patch.path)
                            {
                                case 'name':
                                    _newDataValue =  patch.value + " (" + scope.analogSetting[i].unit + ")";;
                                    break;
                                case 'unit' :
                                    _newDataValue = scope.analogSetting[i].name + " (" +  patch.value+ ")";
                                    break;
                            }

                            scope.series[i].name = _newDataValue;
                            scope.yAxis[i].title.text = _newDataValue;
                        }
                    }
                    _drawChart(true);
                };

                var _getArgsFromNewSetting = function (channel, newSetting) {
                    for (var i = 0; i < newSetting.length; i++) {
                        if (newSetting[i].channel == channel) {
                            return newSetting[i];
                            break;
                        }
                    }
                    return null;
                };

                scope.$on('rtuAnalogUpdate', function (event, args) {
                    var _dataChanged = "name, unit";
                    if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
                        _resetView(args);
                    }
                });

                scope.$on('rtuAnalogUpdateMMPlus', function (event, args) {
                    var _dataChanged = "channelDesc, unitOfValueID, manholeDepthMeters";
                    if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) { 
                        _getData(scope.deviceSelected, scope.refreshStart, scope.refreshEnd);
                        _drawChart(true);
                    }  
                });

                scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
                    if (scope.alerts.length === 0) {
                        scope.langId = langId === 'fr' ? langId : 'en';
                        _drawChart();
                    }
                });

                scope.$on('updateThresholdsAndLevelReference', function (event, args) {
                    var _dataChanged = "any";
                    if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
                        if (scope.alerts.length === 0) {
                            var tmpDeviceSelected = angular.copy(scope.deviceSelected);
                            scope.deviceSelected = null;
                            $timeout(function () {
                                scope.deviceSelected = tmpDeviceSelected;
                            }, 0);
                        }
                    }
                });

                scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
                    scope.applyTimeFormat(timeFormat);
                    if (scope.alerts.length === 0) {
                        _drawChart();
                    }
                });

                scope.applyTimeFormat = function (timeFormat) {
                    scope.preferredTimeFormat = parseInt(timeFormat);
                };

                scope.adjustLegend = function () {
                    //Adding below if for condition when Legend is closed and Download button is clicked
                    if (typeof $(element).find('.highcharts-legend-box').css('width') == "undefined") {
                        return;
                    }
                    var _width = $(element).find('.highcharts-legend-box').css('width').replace(/[^0-9.]+/g, "");
                    var newWidth = (parseInt(_width) - 5) + 'px';
                    var tmpDiv = "<div ng-style=\"{'position': 'absolute', 'top': '0', 'left': sidebarLegend ? '" + newWidth + "' : '0', 'padding': sidebarLegend ? '1px 4px' : '1px 3px', 'z-index': 1, 'cursor': 'pointer'}\" style=\"color: #757575; background-color: #f5f5f5; border-color: #a8a8a8;\" class=\"btn btn-xs\" ng-click=\"toggleSidebarLegend($ctrl.sidebarLegend)\">"
                    tmpDiv = tmpDiv+ "    <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\" ng-hide=\"sidebarLegend\"></i><i class=\"fa fa-angle-double-left\" aria-hidden=\"true\" ng-show=\"sidebarLegend\"></i>"
                    tmpDiv = tmpDiv + "</div>"
                    scope.sidebarLegend
                    $timeout(function () {
                        var lg = $(element).find('.highcharts-legend');
                        lg.append($compile(tmpDiv)(scope));
                        chart.legend.update({ enabled: scope.sidebarLegend ? true : false });
                    }, 0);
                }                

                scope.$on("$destroy", function () {
                    _unRegisterListener(scope.deviceSelectedSn);
                    scope._unRegisterListenerAnalogSetting(scope.deviceSelectedSn);
                    if (chart) chart.destroy();
                    if (!angular.isUndefined(scope.stickyProperties.setting)) scope.stickyProperties.setting = null;
                }); 
            };
        }]);
angular.module("analogChartModule").controller('analogChartController', [
    '$scope', 'sharedSetupService', 'translationService', 'openViewService', '$element', 'authenticationService', 'SaveDesktopSettingService', function ($scope, sharedSetupService, translationService, openViewService, $element, authenticationService, SaveDesktopSettingService) {
        $scope.myDate = null;
        $scope.accountInfo = authenticationService.getAccountInfo();
        $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
        $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
        $scope.unixDay = sharedSetupService.unixDay;
        $scope.liveDataOffset = 20 * 60 * 1000;
        $scope.minPadding = 0;
        $scope.maxPadding = 0;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        $scope.translation = translationService.translation;
        $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
        $scope.alerts = [];
        $scope.loadingInProgress = true;
                
        sharedSetupService.broadcastAllDeviceSelected($scope);
        $scope.openView = openViewService.openView;

        sharedSetupService.getWindowId($scope);

        if ($scope.classicView && $element.parent('div').parent('div').parent('div').attr('class') && $element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") == 0) {
            $scope.largeChart = true;
            $element.height(500);
        };

        $scope.selectMyDate = function(date) {
            $scope.myDate = date;
            $scope.selectMyDateC();
        };

        $scope.getIcon = function(varTitle, varMode) {
            return sharedSetupService.getIcon(varTitle, varMode);
        };

        $scope.fnChangeLanguage = function() {
          if ($scope.alerts.length > 0) {
                var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
                var _type = $scope.alerts[0].type;
                var _languageCode = $scope.alerts[0].languageCode;
                if (_languageCode.toUpperCase() === 'NO_DATA') {
                  _msg += ': ' + moment($scope.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
                }
                $scope.alerts = [];
                $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
            }
        };

    }
]);
"use strict";

angular.module("mc.audit-history", []);
"use strict";

function AuditHistoryFactory(HOST, $http) {

    // instantiate our initial object
    var AuditHistory = function AuditHistory(customerId, startDate, endDate, timeZone, deviceId, userId, categoryId, severityId) {
        this.customerId = customerId;
        this.startDate = startDate;
        this.endDate = endDate;
        this.timeZone = timeZone;
        this.deviceId = deviceId;
        this.userId = userId;
        this.categoryId = categoryId;
        this.severityId = severityId;
    };

    AuditHistory.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + "/api/AuditHistory" + "?customerId=" + this.customerId + "&startDate=" + this.startDate + "&endDate=" + this.endDate + "&timeZone=" + this.timeZone + '&deviceId=' + this.deviceId + '&userId=' + this.userId + '&categoryId=' + this.categoryId + '&severityId=' + this.severityId).then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return AuditHistory;
}

AuditHistoryFactory.$inject = ['HOST', '$http'];

angular.module('mc.audit-history').factory('AuditHistoryFactory', AuditHistoryFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AuditHistoryController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, AuditHistoryFactory, LoginsFactory, $timeout, $filter, $element, deviceMenuService, savePdfService, toaster, textToSpeechService, websocketService) {
    var ctrl = this;
    $scope.alerts = [];
    ////////////////////////////////////////////////
    ////////////////////////////////////////////////
    ctrl.deviceModel = [];
    ctrl.deviceData = [];
    ctrl.filterDeviceId = null;
    ctrl.deviceModelLength = null;

    ctrl.userModel = [];
    ctrl.userData = [];
    ctrl.filterUserId = null;
    ctrl.userModelLength = null;

    ctrl.categoryModel = [];
    ctrl.categoryData = [];
    ctrl.filterCategoryId = null;
    ctrl.categoryModelLength = null;

    ctrl.severityModel = [];
    ctrl.severityData = [];
    ctrl.filterSeverityId = null;
    ctrl.severityModelLength = null;

    ////////////////////////////////////////////////
    ////////////////////////////////////////////////
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.measurementId = ctrl.accountInfo.preferenceUser.lookupMeasurementID === 1 ? 1 : 3.78541;
        ctrl.audithistoryScale = ctrl.accountInfo.preferenceCustomer.lookupRuntimeScale === "M" ? 1 : 1.00 / 60.00;
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        ctrl.getDevices();
        ctrl.getUsers();
        ctrl.voices = textToSpeechService.isCapable ? textToSpeechService.getVoices() : [];
        ctrl.goSelectReportData(false);
        ctrl.downloadViewTypeOptions = [0, 1, 2];

        //used for tank and well offpeak schedule audits
        ctrl.days = [{ id: 1, name: ctrl.translation.text.SUNDAY }, { id: 2, name: ctrl.translation.text.MONDAY }, { id: 3, name: ctrl.translation.text.TUESDAY }, { id: 4, name: ctrl.translation.text.WEDNESDAY }, { id: 5, name: ctrl.translation.text.THURSDAY }, { id: 6, name: ctrl.translation.text.FRIDAY }, { id: 7, name: ctrl.translation.text.SATURDAY }, { id: 8, name: ctrl.translation.text.ALL_DAYS }, { id: 9, name: ctrl.translation.text.WEEKDAYS }, { id: 10, name: ctrl.translation.text.WEEKEND }];

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                var _tmpHeight = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
                $scope.popup.parent().css("height", _tmpHeight);
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    $scope.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.unRegisterListeners();
        ctrl.auditHistory.data.audits = [];
        ctrl.goSelectReportData(true);
    };

    ctrl.goSelectReportData = function (isRefresh) {
        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = ctrl.stickyPropertiesInterface;
        }
        var numberOfDays = 3,
            varDateRangeStart,
            varDateRangeEnd,
            varDateRangeEndTmp;
        if (ctrl.stickyProperties.on === true) {
            //sharedSetupService.checkStickyProperties(ctrl.stickyProperties); TODO: will come back to reconsider sharedSetupService.getLiveDates()
            ctrl.stickyProperties.on = false;
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
            ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
            ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
            varDateRangeEnd = ctrl.myDateRangeEnd;
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            varDateRangeStart = ctrl.myDateRangeStart;
            varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
        } else {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }
        //used for refresh button to reload newest data
        if (isRefresh) {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - numberOfDays);

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (numberOfDays + 0) * ctrl.unixDay;
        }
        //TODO: will come back to reconsider sharedSetupService.regenerateDates()
        if ((ctrl.mobile || ctrl.classicView) && !(new Date(varDateRangeStart).getTime() > 0 && new Date(varDateRangeEnd).getTime() > 0)) {
            var tmpDates = sharedSetupService.getLiveDates();
            varDateRangeStart = tmpDates.startDate;
            varDateRangeEnd = tmpDates.endDate;

            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(tmpDates.endDate);
        }

        ctrl.auditHistory = new AuditHistoryFactory(ctrl.accountInfo.customerId, varDateRangeStart, varDateRangeEnd, ctrl.accountInfo.timeZone, ctrl.filterDeviceId, ctrl.filterUserId, ctrl.filterCategoryId, ctrl.filterSeverityId); //varDateRangeEndTmp - is StartDate
        ctrl.auditHistory.loading = true;
        ctrl.auditHistory.getData().then(function () {
            if (!ctrl.mobile && !ctrl.classicView) sharedSetupService.setStickyProperties(ctrl.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: ctrl.windowId });
            ctrl.refreshAlerts();
            ctrl.getEventDescription();
            if (ctrl.categoryData.length == 0 && ctrl.severityData.length == 0) {
                ctrl.getCategories();
                ctrl.getSeveritiess();
            }
            ctrl.registerListeners();
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                0: { columnWidth: 70 },
                1: { columnWidth: 100 },
                2: { columnWidth: 100 },
                3: { columnWidth: 100 },
                4: { columnWidth: 100 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };

    ctrl.getAdditionalInfo = function (additionalInfo, channel) {
        if (additionalInfo && additionalInfo.length > 0 && channel) {
            return " (" + additionalInfo + ", " + ctrl.translation.text.CHANNEL + " " + channel + ")";
        } else if (additionalInfo && additionalInfo.length > 0) {
            return " (" + additionalInfo + ")";
        } else if (channel) {
            return " (" + ctrl.translation.text.CHANNEL + " " + channel + ")";
        } else {
            return "";
        }
    };

    ctrl.getEventDescription = function () {
        for (var i = 0; i < ctrl.auditHistory.data.audits.length; i++) {
            if (ctrl.auditHistory.data.audits[i].auditEventId > 0 && [0, 3, 4].indexOf(ctrl.auditHistory.data.audits[i].actionId) >= 0) {
                //Create 0, Read 1, Update 2, Delete 3, Custom 4
                ctrl.auditHistory.data.audits[i].description = ctrl.auditHistory.data.audits[i].eventDescription + "<br>" + ctrl.auditHistory.data.audits[i].description + ctrl.getAdditionalInfo(ctrl.auditHistory.data.audits[i].additionalInfo, ctrl.auditHistory.data.audits[i].channel);
            } else if (ctrl.auditHistory.data.audits[i].auditEventId == 20) {
                ctrl.auditHistory.data.audits[i].description = ctrl.auditHistory.data.audits[i].eventDescription + " " + ctrl.auditHistory.data.audits[i].newValue;
            } else if (ctrl.auditHistory.data.audits[i].eventDescription && (ctrl.auditHistory.data.audits[i].oldValue || ctrl.auditHistory.data.audits[i].oldValueDescriptionKey || ctrl.auditHistory.data.audits[i].newValue || ctrl.auditHistory.data.audits[i].newValueDescriptionKey)) {
                var oldValueKey = ctrl.auditHistory.data.audits[i].oldValueDescriptionKey;
                var newValueKey = ctrl.auditHistory.data.audits[i].newValueDescriptionKey;
                var oldDescription = typeof ctrl.translation.text[oldValueKey] == 'undefined' ? ctrl.auditHistory.data.audits[i].oldValue : ctrl.translation.text[oldValueKey];
                var newDescription = typeof ctrl.translation.text[newValueKey] == 'undefined' ? ctrl.auditHistory.data.audits[i].newValue : ctrl.translation.text[newValueKey];
                ctrl.auditHistory.data.audits[i].description = ctrl.auditHistory.data.audits[i].eventDescription + " " + "from " + " " + oldDescription + " " + "to" + " " + newDescription + ctrl.getAdditionalInfo(ctrl.auditHistory.data.audits[i].additionalInfo, ctrl.auditHistory.data.audits[i].channel);
            } else if (ctrl.auditHistory.data.audits[i].auditEventId == 20) {
                ctrl.auditHistory.data.audits[i].description = ctrl.auditHistory.data.audits[i].eventDescription + " (" + ctrl.auditHistory.data.audits[i].newValue + ")";
            } else if (ctrl.auditHistory.data.audits[i].eventDescription) {
                ctrl.auditHistory.data.audits[i].description = ctrl.auditHistory.data.audits[i].eventDescription + ctrl.getAdditionalInfo(ctrl.auditHistory.data.audits[i].additionalInfo, ctrl.auditHistory.data.audits[i].channel);
            }

            if (ctrl.auditHistory.data.audits[i].auditEventId == 330) {
                var oldDay = "";
                var newDay = "";
                for (var j = 0; j < ctrl.days.length; j++) {
                    if (Number(ctrl.auditHistory.data.audits[i].oldValue) == ctrl.days[j].id) oldDay = ctrl.days[j].name;
                    if (Number(ctrl.auditHistory.data.audits[i].newValue) == ctrl.days[j].id) newDay = ctrl.days[j].name;
                }
                ctrl.auditHistory.data.audits[i].description = ctrl.auditHistory.data.audits[i].eventDescription + " " + "from " + " " + oldDay + " " + "to" + " " + newDay;
            }

            if (ctrl.auditHistory.data.audits[i].auditEventId == 344) {
                var oldVoice = ctrl.voices[Number(ctrl.auditHistory.data.audits[i].oldValue)].name;
                var newVoice = ctrl.voices[Number(ctrl.auditHistory.data.audits[i].newValue)].name;
                ctrl.auditHistory.data.audits[i].description = ctrl.auditHistory.data.audits[i].eventDescription + " " + "from " + " " + oldVoice + " " + "to" + " " + newVoice;
            }
        }
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ctrl.getDevices = function () {
        deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.devices = result.data.devices;
            var tmp = [];
            for (var i = 0; i < ctrl.devices.length; i++) {
                tmp.push({ id: ctrl.devices[i].deviceId, label: ctrl.devices[i].name });
            }
            ctrl.deviceData = tmp;
        }, function (error) {});
    };

    ctrl.deviceSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.deviceEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === ctrl.filterDeviceId) {
                ctrl.filterDeviceId = null;
                ctrl.deviceModel = [];
            } else {
                ctrl.filterDeviceId = item.id;
            }
            ctrl.deviceModelLength = ctrl.deviceModel.length;
            ctrl.goSelectReportData(ctrl.filterDeviceId);
        }
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ctrl.getUsers = function () {
        var _logins = new LoginsFactory(ctrl.accountInfo.customerId);
        _logins.getData().then(function () {
            ctrl.logins = _logins.data;
            var tmp = [];
            for (var i = 0; i < ctrl.logins.length; i++) {
                tmp.push({ id: ctrl.logins[i].userId, label: ctrl.logins[i].fullName });
            }
            ctrl.userData = tmp;
        });
    };

    ctrl.userSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.userEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === ctrl.filterUserId) {
                ctrl.filterUserId = null;
                ctrl.userModel = [];
            } else {
                ctrl.filterUserId = item.id;
            }
            ctrl.userModelLength = ctrl.userModel.length;
            ctrl.goSelectReportData(ctrl.filterUserId);
        }
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ctrl.getCategories = function () {
        var tmp = [];
        for (var i = 0; i < ctrl.auditHistory.data.categories.length; i++) {
            tmp.push({ id: ctrl.auditHistory.data.categories[i].id, label: ctrl.auditHistory.data.categories[i].description });
        }
        ctrl.categoryData = tmp;
    };

    ctrl.categorySetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.categoryEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === ctrl.filterCategoryId) {
                ctrl.filterCategoryId = null;
                ctrl.categoryModel = [];
            } else {
                ctrl.filterCategoryId = item.id;
            }
            ctrl.categoryModelLength = ctrl.categoryModel.length;
            ctrl.goSelectReportData(ctrl.filterCategoryId);
        }
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ctrl.getSeveritiess = function () {
        var tmp = [];
        for (var i = 0; i < ctrl.auditHistory.data.severities.length; i++) {
            tmp.push({
                id: ctrl.auditHistory.data.severities[i].id, label: ctrl.auditHistory.data.severities[i].description
            });
        }
        ctrl.severityData = tmp;
    };

    ctrl.severitySetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.severityEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id === ctrl.filterSeverityId) {
                ctrl.filterSeverityId = null;
                ctrl.severityModel = [];
            } else {
                ctrl.filterSeverityId = item.id;
            }
            ctrl.severityModelLength = ctrl.severityModel.length;
            ctrl.goSelectReportData(ctrl.filterSeverityId);
        }
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    ctrl.getLdapUserInfo = function (item) {
        if (item.userType.toLowerCase().includes("customer")) {
            //Targeting Customer(s) and customer(s)
            return $sce.trustAsHtml(item.userFullName);
        } else {
            return $sce.trustAsHtml(item.userFullName + "<br/>(" + item.userType + ")");
        }
    };

    ctrl.getUserName = function (item) {
        if (item.userType != null) return ctrl.getLdapUserInfo(item);

        return item.adminWebUserId !== 0 ? $sce.trustAsHtml((item.userName !== null && item.userName.toLowerCase() === "mission" ? item.userFullNameLogin !== null ? item.userFullNameLogin : "" : "Mission/" + (item.userFullNameLogin !== null ? item.userFullNameLogin : "")) + "<br/>(" + item.adminWebUserFirstName + " " + item.adminWebUserLastName + ")") : item.userFullNameLogin;
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.refreshAlerts();
        ctrl.refreshData();
    });

    ctrl.refreshAlerts = function () {
        $scope.alerts = [];
        if (ctrl.auditHistory.data.length === 0) {
            var errorMessage = ctrl.translation.message.NO_DATA + ': ' + moment(ctrl.auditHistory.startDate).format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(ctrl.auditHistory.endDate).format('MM/DD/YY, h:mm:ss a');
            $scope.alerts.push({
                msg: errorMessage,
                type: "info"
            });
        }
    };

    ctrl.refreshData = function () {
        ctrl.auditHistory = angular.copy(ctrl.auditHistory);
    };

    $scope.$on("$destroy", function () {
        ctrl.unRegisterListeners();
    });

    ctrl.wsDataReceivedAuditsRTUBASICINFOSETTING = function (data) {
        if (data.Type == 'DEVICEBASICINFO') {
            for (var i = 0; i < ctrl.auditHistory.data.audits.length; i++) {
                if (ctrl.auditHistory.data.audits[i].serialNumber == data.SN && data.Value.path == "name") {
                    ctrl.auditHistory.data.audits[i].deviceName = data.Value.value;
                }
            }
        }
    };

    ctrl.wsDataReceivedDevicesRTUBASICINFOSETTING = function (data) {
        if (data.Type == 'DEVICEBASICINFO') {
            for (var i = 0; i < ctrl.devices.length; i++) {
                if (ctrl.devices[i].serialNumber == data.SN && data.Value.path == "name") {
                    ctrl.devices[i].name = data.Value.value;
                }
            }
            var tmp = [];
            for (var i = 0; i < ctrl.devices.length; i++) {
                tmp.push({ id: i, label: ctrl.devices[i].name });
            }
            ctrl.deviceData = tmp;
        }
    };

    ctrl.registerListeners = function () {
        websocketService.connect();
        for (var i = 0; i < ctrl.auditHistory.data.audits.length; i++) {
            websocketService.register("DEVICEBASICINFO", ctrl.auditHistory.data.audits[i].serialNumber, 0, ctrl.wsDataReceivedAuditsRTUBASICINFOSETTING, null);
        }
        for (var i = 0; i < ctrl.devices.length; i++) {
            websocketService.register("DEVICEBASICINFO", ctrl.devices[i].serialNumber, 0, ctrl.wsDataReceivedDevicesRTUBASICINFOSETTING, null);
        }
    };

    ctrl.unRegisterListeners = function () {
        for (var k = 0; k < ctrl.auditHistory.data.audits.length; k++) {
            websocketService.unRegister("DEVICEBASICINFO", ctrl.auditHistory.data.audits[k].serialNumber, 0, ctrl.wsDataReceivedAuditsRTUBASICINFOSETTING, null);
        }
        for (var k = 0; k < ctrl.devices.length; k++) {
            websocketService.unRegister("DEVICEBASICINFO", ctrl.devices[k].serialNumber, 0, ctrl.wsDataReceivedDevicesRTUBASICINFOSETTING, null);
        }
    };
}

AuditHistoryController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'AuditHistoryFactory', 'LoginsFactory', '$timeout', '$filter', '$element', 'deviceMenuService', 'savePdfService', 'toaster', 'textToSpeechService', 'websocketService'];
'use strict';

angular.module('mc.audit-history').component('auditHistory', {
    controller: AuditHistoryController,
    templateUrl: 'ui/audithistory/audit-history-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

mcapp.factory("analogOutputWidgetService", ["$http", "HOST", function ($http, HOST) {
  var analogOutputWidgetFatory = {};

  var _getAnalogOutputSettings = function _getAnalogOutputSettings(customerId) {
    return $http({
      method: 'Get',
      url: HOST + '/api/Analog/OutputWidget?customerId=' + customerId,
      cache: false
    });
  };

  var _getOutputData = function _getOutputData(deviceId, deviceType, channel, customerId) {
    return $http({
      method: 'Get',
      url: HOST + '/api/Analog/OutputWidget?deviceId=' + deviceId + '&deviceType=' + deviceType + '&channelId=' + channel + '&customerId=' + customerId,
      cache: false
    });
  };

  analogOutputWidgetFatory.getOutputData = _getOutputData;

  analogOutputWidgetFatory.getAnalogOutputSettings = _getAnalogOutputSettings;
  return analogOutputWidgetFatory;
}]);
"use strict";

angular.module("mc.analog-output-widget", []);
"use strict";

function AnalogOutputWidgetController($, $scope, $rootScope, authenticationService, translationService, sharedSetupService, $element, analogOutputWidgetService, websocketService, $filter, $timeout, toaster, deviceService) {
  var _this2 = this;

  var ctrl = this;
  ctrl.$onInit = function () {
    ctrl.test = "10px";
    ctrl.mobile = $rootScope.mobile;
    ctrl.voiceTypes = [];
    ctrl.emailTypes = [];
    ctrl.windowId = ctrl.windowId;
    ctrl.liveData = true;
    ctrl.Channel = [];
    ctrl.fontSizeDefault = ".95em";
    ctrl.closeIcon = false;
    ctrl.channelName = null;
    ctrl.alerts = [];
    ctrl.translation = translationService.translation;
    ctrl.accountInfo = authenticationService.getAccountInfo();
    ctrl.stickyProperties = _this2.stickyProperties || sharedSetupService.stickyPropertiesInterface;

    ctrl.setSetting = function () {
      ctrl.analogDeviceSelectedId = { "deviceId": ctrl.stickyProperties.device.deviceId };
      ctrl.analogChannelSelected = { "deviceId": ctrl.stickyProperties.device.deviceId, "channel": ctrl.stickyProperties.device.channel };
      ctrl.preAnalogDeviceSelected = ctrl.stickyProperties.device;
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
      ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
      ctrl.closeWidget = function () {
        $element.find(".flip-container").hide();
        ctrl.popup.dialog("close");
      };

      ctrl.popup.dialog({
        resize: function resize(event, ui) {
          ctrl.resizeContent();
          $scope.$apply();
        }
      });

      ctrl.resizeContent = function () {
        if (!$element.find(".gauge-widget-icon").highcharts()) return;
        $element.find('circle:not(:last)').each(function () {
          $(this).remove();
        });

        var _newWidth = ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, "");
        var _newHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        $element.find('.widgetSettingNew').css("width", _newWidth < 240 ? 240 : _newWidth).css("margin-left", _newWidth < 240 ? -(240 - _newWidth) / 2 : "auto");
        if (_newWidth < 190) {
          ctrl.popup.parent().find('.gauge-widget-icon').css("width", 190);
        } else {
          ctrl.popup.parent().find('.gauge-widget-icon').css("width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        }
        if (_newHeight < 190) {
          ctrl.popup.parent().find('.gauge-widget-icon').css("height", 190);
        } else {
          ctrl.popup.parent().find('.gauge-widget-icon').css("height", ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "")); //25: total padding
        }
        var _char = $element.find(".gauge-widget-icon").highcharts();
        _char.setSize(ctrl.popup.parent().find('.gauge-widget-icon').css("width").replace(/[^0-9.]+/g, "") * 1, (ctrl.popup.parent().find('.gauge-widget-icon').css("height").replace(/[^0-9.]+/g, "") - ctrl.popup.parent().find('.widget-title').css("height").replace(/[^0-9.]+/g, "")) * 0.95, false);
        var _fontSize = _newWidth < _newHeight ? _newWidth / 12 : _newHeight / 12;
        _fontSize = _fontSize < 12 ? 12 : _fontSize > 35 ? 35 : _fontSize;
        _char.container.parentNode.style.fontSize = _fontSize + "px";
        _char.reflow();
      };
    } else {
      ctrl.popup = $(".flip-container");
      ctrl.resizeContent = function () {
        var _this3 = this;

        if (!$element.find(".gauge-widget-icon").highcharts()) return;
        $element.find('circle:not(:last)').each(function () {
          $(_this3).remove();
        });

        var _char = $element.find(".gauge-widget-icon").highcharts();

        var _fontSize = 25;
        _char.container.parentNode.style.fontSize = _fontSize + "px";
        _char.reflow();
      };
    }

    ///////setting-directive////////


    ctrl.getOutputSettings = function () {
      ctrl.accountInfo = authenticationService.getAccountInfo();
      analogOutputWidgetService.getAnalogOutputSettings(ctrl.accountInfo.customerId).then(function (result) {
        ctrl.analogDevices = result.data.analogDevices;
        ctrl.analogSettings = result.data.analogSettings;
        ctrl.getChannels();
      }, function (error) {});
    };

    ctrl.getChannels = function () {
      ctrl.analogChannels = [];

      angular.forEach(ctrl.analogSettings, function (analogSetting) {
        if (parseInt(ctrl.analogDeviceSelectedId.deviceId) === parseInt(analogSetting.deviceId)) {
          ctrl.analogChannels.push(analogSetting);
        }
      });

      if (ctrl.analogDeviceSelectedId.deviceId == ctrl.stickyProperties.device.deviceId) {
        ctrl.analogChannelSelected.channel = ctrl.stickyProperties.device.channel;
      } else {
        ctrl.analogChannelSelected.channel = ctrl.analogChannels[0].channel;
      }
    };

    ctrl.getOutputSettings();

    ctrl.getBackToAnalogData = function (deviceId, channel) {

      if (deviceId != null) ctrl.drawGauge(deviceId, channel);
    };

    ctrl.getAnalogData = function () {
      if (ctrl.targetField === "analogDeviceSelectedId") ctrl.getChannels();
      ctrl.drawGauge(ctrl.analogDeviceSelectedId.deviceId, ctrl.analogChannelSelected.channel);
      if (ctrl.targetField === "analogChannelSelected") {
        ctrl.popup.parent().find('.flip-container').toggleClass('flip');
        if (ctrl.isTouchSupported()) {
          ctrl.popup.parent().find(".back").toggle();
          ctrl.popup.parent().find(".front").toggle();
        }
      }
      ctrl.resizeContent();
    };

    ctrl.focusCallback = function ($event, targetField) {
      if ($event.target === null) {
        return;
      }
      ctrl.targetField = targetField;
    };

    var _resetView = function _resetView() {
      ctrl.getSetting();
    };

    $scope.$on('rtuAnalogUpdate', function (event, args) {
      var _dataChanged = "name, unit";
      if (args.deviceId == ctrl.analogDeviceSelectedId.deviceId && args.channel == ctrl.analogChannelSelected.channel && _dataChanged.indexOf(args.fieldName) > -1) {
        _resetView();
      }
    });

    $scope.$on('rtuBasicInfoUpdate', function (event, args) {
      _resetView();
    });

    ///////setting-directive////////


    ///////widget-directive////////

    var chart;
    ctrl.drawGauge = function (deviceId, channelId) {
      sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: deviceId, windowId: ctrl.windowId });
      deviceService.getDevice(deviceId, ctrl.accountInfo.customerId).then(function (datafromFactory) {
        $scope.deviceSelectedType = datafromFactory.data.deviceModel;
        analogOutputWidgetService.getOutputData(deviceId, $scope.deviceSelectedType, channelId, ctrl.accountInfo.customerId).then(function (result) {
          ctrl.gaugeServerData = result;
          websocketService.connect();
          ctrl.device = result.data.device;
          ctrl.scaledValues(result.data.analogOutputGauge);
          ctrl.currentAnalogOutputGauge = result.data.analogOutputGauge;

          websocketService.unRegister("ANALOGOUT", ctrl.preAnalogDeviceSelected.serialNumber, ctrl.preAnalogDeviceSelected.channel, wsDataReceivedAW, wsReconnectAW);
          websocketService.unRegister("ANALOGOUTPUTSOURCE", ctrl.preAnalogDeviceSelected.serialNumber, ctrl.preAnalogDeviceSelected.channel, wsDataReceivedAWSetPoint, wsReconnectAWSetPoint);

          websocketService.register("ANALOGOUT", ctrl.device.serialNumber, ctrl.analogChannelSelected.channel, wsDataReceivedAW, wsReconnectAW);
          websocketService.register("ANALOGOUTPUTSOURCE", ctrl.device.serialNumber, ctrl.analogChannelSelected.channel, wsDataReceivedAWSetPoint, wsReconnectAWSetPoint);
          ctrl.preAnalogDeviceSelected = result.data.device;

          drawAnalogGauge(result.data.analogOutputGauge, result.data.device);
          ctrl.resizeContent();
          $timeout(function () {
            ctrl.resizeContent();
          }, 0); //need second call to adjust alignment
        }, function (error) {
          ctrl.alerts = [];
          var errormsg = eval("ctrl.translation.message." + error.data.message);
          ctrl.alerts.push({ msg: errormsg, type: "danger" });
          ctrl.resizeContent();
          $timeout(function () {
            ctrl.resizeContent();
          }, 0); //need second call to adjust alignment
        });
      });
    };

    ctrl.getPlotBands = function (data) {
      var plotBands = [];
      var plotAC = {
        from: data.minVal,
        to: data.maxVal,
        color: '#55BF3B' // green
      };
      plotBands.push(plotAC);
      return plotBands;
    };

    ctrl.getTickPositions = function (data) {
      var tickPositions = [];
      var A = data.minVal,
          D = data.maxVal;
      tickPositions.push(A);
      tickPositions.push(D);
      return tickPositions;
    };

    ctrl.gaugeWidgetElement = $element.find(".gauge-widget-icon");

    var drawAnalogGauge = function drawAnalogGauge(data, device, varContainer) {
      if (varContainer) {
        $(ctrl.gaugeWidgetElement).empty();
      }
      var title = ctrl.translation.text.CHANNEL + ' ' + data.channel;
      ctrl.channelName = data.name;
      var _device = { deviceId: device.deviceId, channel: data.channel, serialNumber: device.serialNumber };
      sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: device.deviceId, device: _device, windowId: ctrl.windowId });
      if (ctrl.popup.selector !== ".flip-container") ctrl.popup.dialog("option", "title", ctrl.device.name + ", " + ctrl.channelName);
      ctrl.deviceSelectedName = ctrl.device.name;
      chart = new Highcharts.Chart({

        chart: {
          renderTo: ctrl.gaugeWidgetElement[0],
          type: 'gauge',
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          backgroundColor: 'rgba(0,0,0,0)',
          plotBorderWidth: 0,
          plotShadow: false,
          spacing: [0, 0, 0, 0],
          marginTop: -5,
          spacingTop: -15,
          style: {
            fontSize: '1em'
          }
        },

        title: {
          text: '',
          align: 'center',
          y: 30,
          style: {
            color: '#ffffff'
          }
        },
        exporting: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        pane: {
          startAngle: -150,
          endAngle: 150

        },
        xAxis: {
          labels: {
            formatter: function formatter() {
              return this.value.toString().substring(0, 2);
            }
          }

        },
        tooltip: {
          enabled: true,
          followPointer: false,
          followTouchMove: false,
          useHTML: true,
          formatter: function formatter() {
            return ctrl.translation.text.LBL_DESTINATION + " " + ctrl.translation.text.DESTINATION + "</br>" + ctrl.translation.text.LBL_SOURCE + " " + ctrl.translation.text.SOURCE;
          }
        },
        yAxis: {
          min: data.minVal > data.maxVal ? data.maxVal : data.minVal,
          max: data.minVal > data.maxVal ? data.minVal : data.maxVal,

          minorTickWidth: 0,

          reversed: data.minVal > data.maxVal ? true : false,

          //   tickPixelInterval: 30,
          tickWidth: 1,
          tickLength: 10,
          tickColor: '#666',
          tickPositions: ctrl.getTickPositions(data),
          labels: {
            style: {
              fontSize: '.5em'
            }

          },

          title: {
            style: {
              fontSize: '.7em'
            },
            text: '<p style="text-align:center; margin-top:5px;">' + title + '</p>'
          },

          plotBands: ctrl.getPlotBands(data)
        },
        plotOptions: {

          gauge: {
            // innerRadius: '95%',
            dataLabels: {
              y: -10,
              borderWidth: 0,
              useHTML: true
            }
          }
        },

        series: [{
          data: [{
            y: ctrl.scaledValues(data, data.responseNewSettingRaw)
          }, {
            y: ctrl.scaledValues(data, data.newSettingRaw),
            dial: {
              backgroundColor: 'rgb(255,0,0,.5)',
              opacity: .5,
              baseWidth: 7,
              rearLength: '0%',
              radius: '100%',
              baseLength: '70%'
            }
          }],
          dataLabels: {
            enabled: true,
            borderWidth: 0,
            style: {
              fontSize: '.8em'
            },
            formatter: function formatter() {
              return "<div style=\"text-align:left; margin-top:20px;\">\n                <span style=\"font-size:100%; color: " + (Highcharts.theme && Highcharts.theme.contrastTextColor || 'black') + "\">\n                " + $filter('number')(this.series.data[0].options.y, sharedSetupService.getNumberOfDecimals(data.maxVal, data.minVal)) + " <span style=\"font-size: smaller;\">" + ctrl.translation.text.LBL_DESTINATION + "</span>\n                </span>\n                <br>\n                <span style=\"font-size:90%; color: " + (Highcharts.theme && Highcharts.theme.contrastTextColor || 'red') + "\">\n                " + $filter('number')(this.series.data[1].options.y, sharedSetupService.getNumberOfDecimals(data.maxVal, data.minVal)) + " <span style=\"font-size: smaller;\">" + ctrl.translation.text.LBL_SOURCE + "</span>\n                </span>\n                <br>\n                <br>\n                <span style=\"font-size:80%;margin-left:" + (data.unit.length > 7 ? data.unit.length * -1 : 0) + "\"> " + data.unit + " </span></div>";
            }
          },
          overshoot: 30
        }]

      });
    };

    var distroySingleGauge = function distroySingleGauge() {
      ctrl.gaugeWidgetElement.empty();
      ctrl.alerts = [];
      // websocketService.unRegister("ANALOG", ctrl.deviceSelectedSn, ctrl.Channel[i], wsDataReceivedAG);
    };

    var wsDataReceivedAW = function wsDataReceivedAW(data) {

      if (ctrl.analogChannelSelected.channel == data.CH && ctrl.device.serialNumber === data.SN) {
        if (data.Value != 0) {

          var chart = ctrl.gaugeWidgetElement.highcharts();
          data.Value = ctrl.scaledValues(ctrl.currentAnalogOutputGauge, data.Value);
          chart.series[0].points[0].update(parseFloat(data.Value));
        }
      }
    };

    var wsDataReceivedAWSetPoint = function wsDataReceivedAWSetPoint(data) {

      if (ctrl.analogChannelSelected.channel == data.CH && ctrl.device.serialNumber === data.SN) {
        if (data.Value != 0) {

          var chart = ctrl.gaugeWidgetElement.highcharts();
          var scaledValue = ctrl.scaledValues(ctrl.currentAnalogOutputGauge, data.Value);
          chart.series[0].points[1].update(parseFloat(scaledValue));
        }
      }
    };

    ctrl.isTouchSupported = function () {
      var msTouchEnabled = 0; //msTouchEnabled = window.navigator.msMaxTouchPoints;
      var generalTouchEnabled = "ontouchstart" in document.createElement("div");

      if (msTouchEnabled || generalTouchEnabled) {
        return true;
      }
      return false;
    };

    var wsReconnectAW = function wsReconnectAW(data) {
      toaster.pop('success', "Analog Widget" + " -- " + ctrl.device.name, 'View reloading');
      ctrl.drawGauge(ctrl.analogDeviceSelectedId.deviceId, ctrl.analogChannelSelected.channel);
    };

    var wsReconnectAWSetPoint = function wsReconnectAWSetPoint(data) {
      /*       toaster.pop('success', "Analog Widget" + " -- " + ctrl.device.name, 'View reloading');
            ctrl.drawGauge(ctrl.analogDeviceSelectedId.deviceId, ctrl.analogChannelSelected.channel); */
    };

    ctrl.replaceSpaces = function (str) {
      return str.replace(/ /g, '_');
    };

    $scope.$on('document_click', function (e, event) {
      var $tgt = $(event.target);
      if ($tgt.closest('#analog-widget-' + ctrl.replaceSpaces(ctrl.windowId)).length === 0 || $tgt.closest('.back').length === 0 && $tgt.closest('.front').length === 0) {
        if (ctrl.isTouchSupported()) {
          ctrl.popup.parent().find(".front").toggle(true);
          ctrl.popup.parent().find(".back").toggle(false);
        } else {
          $('#analog-widget-' + ctrl.replaceSpaces(ctrl.windowId)).offsetParent().offsetParent().find('.flip-container').toggleClass('flip', false);
        }

        ctrl.setSetting();
        ctrl.resizeContent();
      }
    });

    ctrl.popup.parent().on("mouseup", function (event) {
      event.preventDefault();
      var localScope = $(event.target).scope();
      localScope.$apply(function () {
        if (ctrl.popup.parent().is('.ui-draggable-dragging, .ui-resizable-resizing') || event.target.nodeName === 'SELECT') {
          return;
        }

        $rootScope.$broadcast('document_click', event);

        if (ctrl.isTouchSupported()) {
          ctrl.popup.parent().find(".back").toggle();
          ctrl.popup.parent().find(".front").toggle();
        } else {
          ctrl.popup.parent().find('.flip-container').toggleClass('flip');
        }
        ctrl.setSetting();
        ctrl.resizeContent();
      });
    });

    ctrl.popup.parent().find("select").on("mouseup", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    ctrl.popup.parent().on("mouseover", function (event) {
      event.preventDefault();
      var localScope = $(event.target).scope();
      localScope.$apply(function () {
        ctrl.popup.parent().addClass("x-resize");
        ctrl.closeIcon = true;
      });
    });

    ctrl.popup.parent().on("mouseout", function (event) {
      event.preventDefault();
      var localScope = $(event.target).scope();
      localScope.$apply(function () {
        ctrl.popup.parent().removeClass("x-resize");
        if (ctrl.isTouchSupported()) {
          setTimeout(function () {
            ctrl.closeIcon = false;
          }, 3000);
        } else {
          ctrl.closeIcon = false;
        }
      });
    });

    ctrl.setSetting();
    ctrl.drawGauge(ctrl.analogDeviceSelectedId.deviceId, ctrl.analogChannelSelected.channel);
    if (ctrl.popup.selector !== ".flip-container") ctrl.popup.dialog("option", "dialogClass", "ui-widget-content-new");
  };

  $scope.$on("$destroy", function (event) {
    websocketService.unRegister("ANALOGOUT", ctrl.preAnalogDeviceSelected.serialNumber, ctrl.preAnalogDeviceSelected.channel, wsDataReceivedAW, wsReconnectAW);
    websocketService.unRegister("ANALOGOUTPUTSOURCE", ctrl.preAnalogDeviceSelected.serialNumber, ctrl.preAnalogDeviceSelected.channel, wsDataReceivedAWSetPoint, wsReconnectAWSetPoint);
    ctrl.popup.parent().off();
    ctrl.popup.parent().find("select").off();
    ctrl.gaugeWidgetElement.empty();
  });

  var _resetView = function _resetView(args) {
    var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
    var _lmData = ctrl.gaugeServerData.analogGauge;
    var _lmDevice = ctrl.gaugeServerData.device;
    var _container = true;

    _lmData.minVal = _newData.minimumValue;
    _lmData.maxVal = _newData.maximumValue;
    _lmData.name = _newData.name;
    _lmData.unit = _newData.unit;
    drawAnalogGauge(_lmData, ctrl.device, _container);
    return;
  };

  var _getArgsFromNewSetting = function _getArgsFromNewSetting(channel, newSetting) {
    for (var i = 0; i < newSetting.length; i++) {
      if (newSetting[i].channel == channel) {
        return newSetting[i];
        //break; line is never reached :JS
      }
    }
    return null;
  };

  ctrl.scaledValues = function (data, value) {
    value = data.minVal + value / 255 * (data.maxVal - data.minVal);
    return value;
  };

  $scope.$on('rtuAnalogUpdate', function (event, args) {
    var _dataChanged = "name, unit, minimumValue, maximumValue";
    if (args.deviceId == ctrl.analogDeviceSelectedId.deviceId && args.channel == ctrl.analogChannelSelected.channel && _dataChanged.indexOf(args.fieldName) > -1) {
      _resetView(args);
    }
  });

  $scope.$on('rtuBasicInfoUpdate', function (event, args) {
    _resetView();
  });

  $scope.$on('updatePreferencesLanguage', function () {
    ctrl.drawGauge(ctrl.analogDeviceSelectedId.deviceId, ctrl.analogChannelSelected.channel);
  });

  ///////widget-directive////////

};

AnalogOutputWidgetController.$inject = ['$', "$scope", "$rootScope", "authenticationService", "translationService", "sharedSetupService", "$element", "analogOutputWidgetService", "websocketService", "$filter", "$timeout", "toaster", "deviceService"];
'use strict';

angular.module('mc.analog-output-widget').component('analogOutputWidget', {
    controller: AnalogOutputWidgetController,
    templateUrl: 'ui/analogoutput/analog-output-widget-template.html',
    controllerAs: '$ctrl',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<',
        deviceSelected: '<'
    }
});
'use strict';

mcapp.factory('analogOutputTableService', ['$http', 'datetimeService', 'translationService', 'HOST', 'sharedSetupService', function ($http, datetimeService, translationService, HOST, sharedSetupService) {
    var _this = this;

    var analogOutputTableService = function analogOutputTableService() {
        _this.items = [];
        _this.setting = [];
        _this.numberOfDecimals = [];
        _this.deviceName = '';
        _this.customerId = null;
        _this.deviceId = null;
        _this.startRow = 1;
        _this.pageSize = 50;
        _this.start = '19000101';
        _this.end = '19000101';
        _this.busy = false;
        _this.numberOfReturnedRecords = -1;
        _this.numberOfNewRecordsPrevious = -1;
        _this.tdWidth = null;
        _this.alerts = [];
        _this.translation = translationService.translation;
        _this.hasMydroExpansion = false;
    };

    //analogOutputTableService.prototype.previousPage = (customerId, deviceId, start, end) => {
    //    if (this.busy || this.numberOfNewRecordsPrevious === 0) return;
    //    this.busy = true;
    //    this.pageSize = -50;
    //    var url = HOST + "/api/AnalogOutputTable?customerId=" + customerId + "&deviceId=" + deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + start + "&EndDate=" + end;
    //    $http.get(url).then(function (result) {
    //        /////////////////////////
    //        var intDayWindow = 10;
    //        var intDay = 86400000;
    //        /////////////////////////
    //        var deviceName = result.data.device.name;
    //        var setting = result.data.setting;
    //        if (this.setting.length === 0) {
    //            for (var i = 0; i < setting.length; i++) {
    //                this.setting.push(setting[i]);
    //                this.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
    //            }
    //            this.tdWidth = parseInt(100 / (setting.length + 1)) + "%";
    //        }
    //        var items = result.data.analogOutputMeasurements;
    //        if (items.length > 0)
    //            var tmpstart = new Date(items[items.length - 1].localDateTime);
    //        for (var j = 0; j < items.length; j++) {
    //            items[j].localDateTime = items[j].localDateTime;

    //            //for (var k = 0; k < items[j].scaledValues.length; k++) {
    //            //    items[j].scaledValues[k].value = parseFloat(items[j].scaledValues[k].value).toFixed(2);
    //            //}

    //            this.items.unshift(items[j]);
    //        }
    //        this.numberOfNewRecordsPrevious = items.length;
    //        this.numberOfRecords = this.items.length;
    //        this.deviceName = deviceName;
    //        this.startRow = this.startRow + items.length;
    //        //if (items.length > 0) { //if there are records returned                
    //        //    this.start = datetimeService.toUnixtime(this.items[0].localDateTime.replace(/\D/g, ''));
    //        //    this.end = this.start + intDayWindow * intDay;
    //        //    //this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
    //        //    //this.end = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
    //        //}
    //        this.pageSize = 50;
    //        this.busy = false;
    //    }.bind(this),
    //        function (error) {
    //            this.alerts = [];
    //            var errorMessage = eval("this.translation.message." + error.data.message);
    //            this.alerts.push({ msg: errorMessage, type: "danger" });
    //            this.pageSize = 50;
    //            this.busy = false;
    //        }.bind(this));
    //};

    //analogOutputTableService.prototype.nextPage = (customerId, deviceId, start, end) => {
    //    if (this.busy || this.numberOfReturnedRecords === 0) return;
    //    this.busy = true;

    //    var url = HOST + "/api/AnalogOutputTable?customerId=" + customerId + "&deviceId=" + deviceId + "&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&StartDate=" + start + "&EndDate=" + end;
    //    $http.get(url).then(function (result) {
    //        /////////////////////////
    //        var intDayWindow = 10;
    //        var intDay = 86400000;
    //        /////////////////////////
    //        var deviceName = result.data.device.name;
    //        var setting = result.data.setting;
    //        if (this.setting.length === 0) {
    //            for (var i = 0; i < setting.length; i++) {
    //                this.setting.push(setting[i]);
    //                this.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
    //            }
    //            var noOfExtraColumns = 1;
    //            this.tdWidth = parseInt(100 / (setting.length + noOfExtraColumns)) + "%"; //including "CalculatedWeirGpm" column too                
    //        }
    //        var items = result.data.analogOutputMeasurements;
    //        if (items.length > 0)
    //            var tmpstart = new Date(items[items.length - 1].localDateTime);
    //        for (var j = 0; j < items.length; j++) {
    //            items[j].localDateTime = items[j].localDateTime;

    //            //for (var k = 0; k < items[j].scaledValues.length; k++) {
    //            //    items[j].scaledValues[k].value = parseFloat(items[j].scaledValues[k].value).toFixed(2);
    //            //}

    //            this.items.push(items[j]);
    //        }
    //        this.numberOfReturnedRecords = items.length;
    //        this.deviceName = deviceName;
    //        this.startRow = this.startRow + items.length;
    //        if (items.length == 0) {
    //            if (this.items.length === 0) {
    //                this.alerts = [];
    //                var errorMessage;
    //                if (this.setting.length > 0) {
    //                    errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
    //                    this.alerts.push({ msg: errorMessage, type: "info", languageCode: "NO_DATA" });
    //                }
    //                else {
    //                    errorMessage = this.translation.message.ANALOG_SETUP_INCOMPLETE
    //                    this.alerts.push({ msg: errorMessage, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
    //                }
    //            }
    //        }
    //        //if (items.length > 0) { //if there are records returned
    //        //    this.end = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, ''));
    //        //    this.start = this.end - intDay;
    //        //    //this.start = datetimeService.toUnixtime(this.items[this.items.length - 1].localDateTime.replace(/\D/g, '')) - (intDayWindow * intDay);
    //        //    //this.end = datetimeService.toUnixtimeMs(this.items[0].localDateTime.replace(/\D/g, ''));
    //        //}
    //        //else {
    //        //    // If we didn't get any items back AND there aren't already any items
    //        //    if (this.items.length === 0) {
    //        //        this.alerts = [];
    //        //        var errorMessage;
    //        //        if (this.setting.length > 0) {
    //        //            errorMessage = this.translation.message.NO_DATA + ': ' + moment(this.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(this.end).utc().format('MM/DD/YY, h:mm:ss a');
    //        //            this.alerts.push({ msg: errorMessage, type: "info", languageCode: "NO_DATA" });
    //        //        }
    //        //        else {
    //        //            errorMessage = this.translation.message.ANALOG_SETUP_INCOMPLETE
    //        //            this.alerts.push({ msg: errorMessage, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
    //        //        }
    //        //    }
    //        //}
    //        this.pageSize = 50;
    //        this.busy = false;
    //    }.bind(this),
    //        function (error) {
    //            this.alerts = [];
    //            var errorMessage = eval("this.translation.message." + error.data.message);
    //            this.alerts.push({ msg: errorMessage, type: "danger" });
    //            this.pageSize = 50;
    //            this.busy = false;
    //        }.bind(this));
    //};

    analogOutputTableService.prototype.nextPage = function (customerId, deviceId, deviceType, start, end, startRow, pageSize) {
        return $http({
            method: 'GET',
            url: HOST + "/api/AnalogOutputTable?customerId=" + customerId + "&deviceId=" + deviceId + "&deviceType=" + deviceType + "&StartRow=" + startRow + "&PageSize=" + pageSize + "&StartDate=" + start + "&EndDate=" + end,
            cache: true
        });
    };

    analogOutputTableService.prototype.previousPage = function (customerId, deviceId, deviceType, start, end, startRow, pageSize) {
        return $http({
            method: 'GET',
            url: HOST + "/api/AnalogOutputTable?customerId=" + customerId + "&deviceId=" + deviceId + "&deviceType=" + deviceType + "&StartRow=" + startRow + "&PageSize=" + pageSize + "&StartDate=" + start + "&EndDate=" + end,
            cache: true
        });
    };

    return analogOutputTableService;
}]);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

mcapp.controller('analogOutputTableController', ['$scope', '$rootScope', 'sharedSetupService', 'openViewService', 'translationService', 'detectBrowserService', '$element', 'authenticationService', 'timeLapseService', 'analogOutputTableService', 'websocketService', '$timeout', 'datetimeService', function ($scope, $rootScope, sharedSetupService, openViewService, translationService, detectBrowserService, $element, authenticationService, timeLapseService, analogOutputTableService, websocketService, $timeout, datetimeService) {
    var ctrl = this;
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.infiniteScrollOn = false;
    $scope.infiniteScrollUpOn = false;
    $scope.infiniteScrollDownOn = false;
    $scope.checkFirstRowLiveStatus = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.timeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = sharedSetupService.liveDataOffset;
    $scope.liveDataOffsetAdj = sharedSetupService.liveDataOffsetAdj;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.alerts = [];
    $scope.curentBrowser = detectBrowserService();
    $scope.downloadViewTypeOptions = [0, 4];

    var element = $(".analog-output-table-scroll-height-reference");

    sharedSetupService.broadcastAllDeviceSelected($scope);
    sharedSetupService.getWindowId($scope);
    $scope.selectMyDate = function (date) {
        $scope.myDate = date;
        $scope.selectMyDateT();
    };

    $scope.liveTable = $element.find(".headertable");

    $scope.liveDataLine = function (varLiveData) {
        if (varLiveData) {
            $scope.liveTable.addClass("live-data-line");
        } else {
            $scope.liveTable.removeClass("live-data-line");
        }
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
        $scope.analogOutputTableService.items = angular.copy($scope.analogOutputTableService.items);
    });

    $scope.$on('updatePreferencesLanguage', function () {
        $scope.updateSetting();
    });

    $scope.updateSetting = function () {
        $scope.analogOutputTableService.setting = angular.copy($scope.analogOutputTableService.setting);
    };

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);

        $scope.popup.dialog({
            resize: function resize(event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function maximize(event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function restore(event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            if ($scope.popup.parent().length > 0) {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            }
        };

        $scope.adjustDeviceIdMenuSize = function () {
            var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            if (spph < 450) {
                $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            } else {
                $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        };
    }

    if (_typeof($scope.stickyProperties) != 'object') {
        $scope.stickyProperties = $scope.stickyPropertiesInterface;
    }

    var currentScrollbarPosition = 0;
    var previousScrollbarPosition = 0;
    var paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2);
    paddingZoom = paddingZoom === 0 ? $scope.unixDay / 2 : paddingZoom;

    $scope.trgScroll = function () {
        $timeout(function () {
            var $rowFirst = element.contents().find("tr:first");
            var _firstRow = $rowFirst.attr("name");
            if (typeof $rowFirst.position() !== "undefined") {
                var _tableTop = element.offset().top;
                var _rowTop = $rowFirst.offset().top;
                _setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);
            }
        }, 0);
    };

    $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
        if ($scope.alerts.length > 0) {
            var _msg = eval("scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
            var _type = $scope.alerts[0].type;
            var _languageCode = $scope.alerts[0].languageCode;
            if (_languageCode.toUpperCase() === 'NO_DATA') {
                _msg += ': ' + moment($scope.analogOutputTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.analogOutputTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
            }
            $scope.alerts = [];
            $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        }
    });

    element.on('scroll', function (event) {
        var $rowFirst = element.contents().find("tr:first");
        var $rowLast = element.contents().find("tr:last");
        if (typeof $rowFirst.position() !== "undefined") {
            $scope.infiniteScrollOn = true;$scope.infiniteScrollUpOn = true;$scope.infiniteScrollDownOn = true;
            $scope.trgScroll();
            previousScrollbarPosition = currentScrollbarPosition;
            currentScrollbarPosition = element[0].scrollTop;
        }

        if ($scope.infiniteScrollOn === true) {
            $scope.infiniteScrollUpOn = true;
            $scope.infiniteScrollDownOn = true;

            if ($scope.infiniteScrollDownOn === true && element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight) {
                $rowLast.addClass("active-row");
                $scope.analogOutputTableService.alerts = [];
                $scope.alerts = [];
                //added to avoid duplicate records
                if ($scope.analogOutputTableService.items[$scope.analogOutputTableService.items.length - 1]) {
                    $scope.analogOutputTableService.end = datetimeService.toUnixtime($scope.analogOutputTableService.items[$scope.analogOutputTableService.items.length - 1].localDateTime.replace(/\D/g, '')) - 1000;
                }
                $scope.analogOutputTableService.start = $scope.analogOutputTableService.end - 86400000;
                if (!$scope.analogOutputTableService.busy) {
                    $scope.analogOutputTableService.busy = true;
                    $scope.analogOutputTableService.nextPage($scope.analogOutputTableService.customerId, $scope.analogOutputTableService.deviceId, $scope.analogOutputTableService.deviceType, $scope.analogOutputTableService.start, $scope.analogOutputTableService.end, $scope.analogOutputTableService.startRow, $scope.analogOutputTableService.pageSize).then(function (result) {
                        /////////////////////////
                        var intDayWindow = 10;
                        var intDay = 86400000;
                        /////////////////////////
                        var deviceName = result.data.device.name;
                        var setting = result.data.setting;
                        $scope.analogOutputTableService.hasMydroExpansion = result.data.device.model == 19 && result.data.device.softwareVersion >= 18;

                        if ($scope.analogOutputTableService.setting.length === 0) {
                            for (var i = 0; i < setting.length; i++) {
                                $scope.analogOutputTableService.setting.push(setting[i]);
                                $scope.analogOutputTableService.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
                            }
                            var noOfExtraColumns = 1;
                            $scope.analogOutputTableService.tdWidth = parseInt(100 / (setting.length + noOfExtraColumns)) + "%"; //including "CalculatedWeirGpm" column too                
                        }
                        var readings = result.data.analogOutputMeasurements;
                        if (readings.length > 0) var tmpstart = new Date(readings[readings.length - 1].localDateTime);
                        for (var j = 0; j < readings.length; j++) {
                            readings[j].localDateTime = readings[j].localDateTime;
                            $scope.analogOutputTableService.items.push(readings[j]);
                        }
                        $scope.analogOutputTableService.numberOfReturnedRecords = readings.length;
                        $scope.analogOutputTableService.deviceName = deviceName;
                        $scope.analogOutputTableService.startRow = $scope.analogOutputTableService.startRow + readings.length;
                        if (readings.length == 0) {
                            if ($scope.analogOutputTableService.items.length === 0) {
                                $scope.analogOutputTableService.alerts = [];
                                $scope.alerts = [];
                                var errorMessage = void 0;
                                if ($scope.analogOutputTableService.setting.length > 0) {
                                    errorMessage = $scope.analogOutputTableService.translation.message.NO_DATA + ': ' + moment($scope.analogOutputTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.analogOutputTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                                    $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "NO_DATA" });
                                    $scope.alerts = $scope.analogOutputTableService.alerts;
                                } else {
                                    errorMessage = $scope.analogOutputTableService.translation.message.ANALOG_SETUP_INCOMPLETE;
                                    $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
                                    $scope.alerts = $scope.analogOutputTableService.alerts;
                                }
                            }
                        }
                        $scope.analogOutputTableService.pageSize = 50;
                        $scope.analogOutputTableService.busy = false;
                    }.bind($scope.analogOutputTableService), function (error) {
                        $scope.analogOutputTableService.alerts = [];
                        $scope.alerts = [];
                        var errorMessage = eval("this.translation.message." + error.data.message);
                        $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "danger" });
                        $scope.alerts = $scope.analogOutputTableService.alerts;
                        $scope.analogOutputTableService.pageSize = 50;
                        $scope.analogOutputTableService.busy = false;
                    }.bind($scope.analogOutputTableService));
                }
            }
            if ($scope.infiniteScrollUpOn === true && element[0].scrollTop < 5 && currentScrollbarPosition < previousScrollbarPosition) {
                $rowFirst.addClass("active-row");
                $scope.analogOutputTableService.alerts = [];
                $scope.alerts = [];
                //added to avoid duplicate records
                $scope.analogOutputTableService.start = datetimeService.toUnixtime($scope.analogOutputTableService.items[0].localDateTime.replace(/\D/g, '')) + 1000;
                $scope.analogOutputTableService.end = $scope.analogOutputTableService.start + 86400000;
                if (!$scope.analogOutputTableService.busy) {
                    $scope.analogOutputTableService.busy = true;
                    $scope.analogOutputTableService.pageSize = -50;
                    $scope.analogOutputTableService.previousPage($scope.analogOutputTableService.customerId, $scope.analogOutputTableService.deviceId, $scope.analogOutputTableService.deviceType, $scope.analogOutputTableService.start, $scope.analogOutputTableService.end, $scope.analogOutputTableService.startRow, $scope.analogOutputTableService.pageSize).then(function (result) {
                        /////////////////////////
                        var intDayWindow = 10;
                        var intDay = 86400000;
                        /////////////////////////
                        var deviceName = result.data.device.name;
                        var setting = result.data.setting;
                        $scope.analogOutputTableService.hasMydroExpansion = result.data.device.model == 19 && result.data.device.softwareVersion >= 18;
                        if ($scope.analogOutputTableService.setting.length === 0) {
                            for (var i = 0; i < setting.length; i++) {
                                $scope.analogOutputTableService.setting.push(setting[i]);
                                $scope.analogOutputTableService.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
                            }
                            $scope.analogOutputTableService.tdWidth = parseInt(100 / (setting.length + 1)) + "%";
                        }
                        var readings = result.data.analogOutputMeasurements;
                        if (readings.length > 0) var tmpstart = new Date(readings[readings.length - 1].localDateTime);
                        for (var j = 0; j < readings.length; j++) {
                            readings[j].localDateTime = readings[j].localDateTime;
                            $scope.analogOutputTableService.items.unshift(readings[j]);
                        }
                        $scope.analogOutputTableService.numberOfNewRecordsPrevious = readings.length;
                        $scope.analogOutputTableService.numberOfRecords = $scope.analogOutputTableService.items.length;
                        $scope.analogOutputTableService.deviceName = deviceName;
                        $scope.analogOutputTableService.startRow = $scope.analogOutputTableService.startRow + readings.length;

                        $scope.analogOutputTableService.pageSize = 50;
                        $scope.analogOutputTableService.busy = false;
                    }.bind($scope.analogOutputTableService), function (error) {
                        $scope.analogOutputTableService.alerts = [];
                        $scope.alerts = [];
                        var errorMessage = eval("this.translation.message." + error.data.message);
                        $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "danger" });
                        $scope.alerts = $scope.analogOutputTableService.alerts;
                        $scope.analogOutputTableService.pageSize = 50;
                        $scope.analogOutputTableService.busy = false;
                    }.bind($scope.analogOutputTableService));
                }
            }
        }

        var rows = element.children().children().children().children();
        var scrollpos = 40;
        var start = 0;
        var end = rows.length;
        var count = 0;

        while (start != end) {
            count++;
            var mid = start + Math.floor((end - start) / 2);
            if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
        }
        _updateZoom(parseFloat($($(rows[start])).attr("name")));
    });

    var _updateZoom = function _updateZoom(currentRow) {
        if (isNaN(currentRow)) return;

        var zoomMin = currentRow - paddingZoom;
        var zoomMax = currentRow + paddingZoom;

        var dateMin = $scope.stickyProperties.dateMin;
        var dateMax = $scope.stickyProperties.dateMax;

        if (zoomMin < $scope.stickyProperties.dateMin) {
            dateMin = zoomMin;
        }
        if (zoomMax > $scope.stickyProperties.dateMax) {
            dateMax = zoomMax;
        }

        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: $scope.windowId });
    };

    $scope.toggle = function ($event) {
        if ($($event.currentTarget).hasClass("active-row")) {
            $($event.currentTarget).removeClass("active-row");
        } else {
            $($event.currentTarget).addClass("active-row");
        }
    };

    $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            $scope.liveDataIn = !$scope.liveDataIn;
            $timeout(function () {
                $scope.liveDataIn = !$scope.liveDataIn;
            }, 3000);
        }
    }, true);

    //$scope.$watch('$scope.analogOutputTableService.alerts', (newValue, oldValue) => {
    //    if (newValue && newValue.length > 0 && newValue != oldValue) {
    //        $scope.alerts = newValue;
    //    }
    //}, true);

    $scope.newAnalogOutputTableService = function () {
        $scope.analogOutputTableService = new analogOutputTableService();
        $scope.analogOutputTableService.customerId = $scope.accountInfo.customerId;
        $scope.analogOutputTableService.deviceId = $scope.deviceSelected;
        $scope.analogOutputTableService.deviceType = $scope.deviceSelectedType;
        $scope.analogOutputTableService.windowTitle = $scope.windowTitle;
        $scope.analogOutputTableService.startRow = 1;
        $scope.analogOutputTableService.pageSize = 50;
        $scope.analogOutputTableService.items = [];
        $scope.analogOutputTableService.setting = [];
        $scope.analogOutputTableService.numberOfDecimals = [];
        $scope.analogOutputTableService.deviceName = '';
        $scope.analogOutputTableService.start = '19000101';
        $scope.analogOutputTableService.end = '19000101';
        $scope.analogOutputTableService.busy = false;
        $scope.analogOutputTableService.numberOfReturnedRecords = -1;
        $scope.analogOutputTableService.numberOfNewRecordsPrevious = -1;
        $scope.analogOutputTableService.tdWidth = null;
        $scope.analogOutputTableService.alerts = [];
        $scope.analogOutputTableService.translation = translationService.translation;
        $scope.analogOutputTableService.hasMydroExpansion = false;
    };

    var _openTableInLiveMode = function _openTableInLiveMode() {
        $scope.stickyProperties.on = false;
        timeLapseService.getLocalDateTime().then(function (result) {
            /////////////////////////////////////////////////////////////
            var tmpDates = new Date(result.data.localDateTime);
            var tmpDatesA = tmpDates;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            tmpDatesA.setHours(23, 59, 59, 0);
            tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
            /////////////////////////////////////////////////////////////
            $scope.newAnalogOutputTableService();
            $scope.analogOutputTableService.start = tmpDates.startDate;
            $scope.analogOutputTableService.end = tmpDatesA;
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + $scope.unixDay, zoomMax: tmpDates.endDate - $scope.unixDay, windowId: $scope.windowId });
            $scope.analogOutputTableService.busy = true;
            $scope.analogOutputTableService.nextPage($scope.analogOutputTableService.customerId, $scope.analogOutputTableService.deviceId, $scope.analogOutputTableService.deviceType, $scope.analogOutputTableService.start, $scope.analogOutputTableService.end, $scope.analogOutputTableService.startRow, $scope.analogOutputTableService.pageSize).then(function (result) {
                /////////////////////////
                var intDayWindow = 10;
                var intDay = 86400000;
                /////////////////////////
                var deviceName = result.data.device.name;
                var setting = result.data.setting;
                $scope.analogOutputTableService.hasMydroExpansion = result.data.device.model == 19 && result.data.device.softwareVersion >= 18;
                if ($scope.analogOutputTableService.setting.length === 0) {
                    for (var i = 0; i < setting.length; i++) {
                        $scope.analogOutputTableService.setting.push(setting[i]);
                        $scope.analogOutputTableService.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
                    }
                    var noOfExtraColumns = 1;
                    $scope.analogOutputTableService.tdWidth = parseInt(100 / (setting.length + noOfExtraColumns)) + "%"; //including "CalculatedWeirGpm" column too                
                }
                var readings = result.data.analogOutputMeasurements;
                if (readings.length > 0) var tmpstart = new Date(readings[readings.length - 1].localDateTime);
                for (var j = 0; j < readings.length; j++) {
                    readings[j].localDateTime = readings[j].localDateTime;
                    $scope.analogOutputTableService.items.push(readings[j]);
                }
                $scope.analogOutputTableService.numberOfReturnedRecords = readings.length;
                $scope.analogOutputTableService.deviceName = deviceName;
                $scope.analogOutputTableService.startRow = $scope.analogOutputTableService.startRow + readings.length;
                if (readings.length == 0) {
                    if ($scope.analogOutputTableService.items.length === 0) {
                        $scope.analogOutputTableService.alerts = [];
                        $scope.alerts = [];
                        var errorMessage = void 0;
                        if ($scope.analogOutputTableService.setting.length > 0) {
                            errorMessage = $scope.analogOutputTableService.translation.message.NO_DATA + ': ' + moment($scope.analogOutputTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.analogOutputTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                            $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "NO_DATA" });
                            $scope.alerts = $scope.analogOutputTableService.alerts;
                        } else {
                            errorMessage = $scope.analogOutputTableService.translation.message.ANALOG_SETUP_INCOMPLETE;
                            $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
                            $scope.alerts = $scope.analogOutputTableService.alerts;
                        }
                    }
                }
                $scope.analogOutputTableService.pageSize = 50;
                $scope.analogOutputTableService.busy = false;
            }.bind($scope.analogOutputTableService), function (error) {
                $scope.analogOutputTableService.alerts = [];
                $scope.alerts = [];
                var errorMessage = eval("this.translation.message." + error.data.message);
                $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "danger" });
                $scope.alerts = $scope.analogOutputTableService.alerts;
                $scope.analogOutputTableService.pageSize = 50;
                $scope.analogOutputTableService.busy = false;
            }.bind($scope.analogOutputTableService));
            /////////////////////////////////////////////////////////////
        });
    };

    $scope.$watch('deviceSelected', function (newValue, oldValue) {
        if (newValue) {
            /////////////////////////////////////////////////////////////
            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            $scope.checkFirstRowLiveStatus = null;
            /////////////////////////////////////////////////////////////
            $scope.alerts = [];
            var _device = { deviceName: $scope.deviceSelectedName };
            sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: newValue, device: _device, windowId: $scope.windowId });

            if ($scope.stickyProperties.on !== null && $scope.stickyProperties.dateMin !== null) {
                //doesn't work well - need to check
                $scope.stickyProperties.on = true;
                timeLapseService.getLocalDateTime().then(function (result) {
                    if ($scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && $scope.stickyProperties.zoomMax + parseFloat($scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                        $scope.newAnalogOutputTableService();
                        $scope.analogOutputTableService.start = $scope.stickyProperties.dateMin - 3 * $scope.unixDay; //need to extend data range
                        $scope.analogOutputTableService.end = $scope.stickyProperties.dateMax;
                        $scope.analogOutputTableService.busy = true;
                        $scope.analogOutputTableService.nextPage($scope.analogOutputTableService.customerId, $scope.analogOutputTableService.deviceId, $scope.analogOutputTableService.deviceType, $scope.analogOutputTableService.start, $scope.analogOutputTableService.end, $scope.analogOutputTableService.startRow, $scope.analogOutputTableService.pageSize).then(function (result) {
                            /////////////////////////
                            var intDayWindow = 10;
                            var intDay = 86400000;
                            /////////////////////////
                            var deviceName = result.data.device.name;
                            var setting = result.data.setting;
                            $scope.analogOutputTableService.hasMydroExpansion = result.data.device.model == 19 && result.data.device.softwareVersion >= 18;
                            if ($scope.analogOutputTableService.setting.length === 0) {
                                for (var i = 0; i < setting.length; i++) {
                                    $scope.analogOutputTableService.setting.push(setting[i]);
                                    $scope.analogOutputTableService.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
                                }
                                var noOfExtraColumns = 1;
                                $scope.analogOutputTableService.tdWidth = parseInt(100 / (setting.length + noOfExtraColumns)) + "%"; //including "CalculatedWeirGpm" column too                
                            }
                            var readings = result.data.analogOutputMeasurements;
                            if (readings.length > 0) var tmpstart = new Date(readings[readings.length - 1].localDateTime);
                            for (var j = 0; j < readings.length; j++) {
                                readings[j].localDateTime = readings[j].localDateTime;
                                $scope.analogOutputTableService.items.push(readings[j]);
                            }
                            $scope.analogOutputTableService.numberOfReturnedRecords = readings.length;
                            $scope.analogOutputTableService.deviceName = deviceName;
                            $scope.analogOutputTableService.startRow = $scope.analogOutputTableService.startRow + readings.length;
                            if (readings.length == 0) {
                                if ($scope.analogOutputTableService.items.length === 0) {
                                    $scope.analogOutputTableService.alerts = [];
                                    $scope.alerts = [];
                                    var errorMessage = void 0;
                                    if ($scope.analogOutputTableService.setting.length > 0) {
                                        errorMessage = $scope.analogOutputTableService.translation.message.NO_DATA + ': ' + moment($scope.analogOutputTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.analogOutputTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                                        $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "NO_DATA" });
                                        $scope.alerts = $scope.analogOutputTableService.alerts;
                                    } else {
                                        errorMessage = $scope.analogOutputTableService.translation.message.ANALOG_SETUP_INCOMPLETE;
                                        $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
                                        $scope.alerts = $scope.analogOutputTableService.alerts;
                                    }
                                }
                            }
                            $scope.analogOutputTableService.pageSize = 50;
                            $scope.analogOutputTableService.busy = false;
                        }.bind($scope.analogOutputTableService), function (error) {
                            $scope.analogOutputTableService.alerts = [];
                            $scope.alerts = [];
                            var errorMessage = eval("this.translation.message." + error.data.message);
                            $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "danger" });
                            $scope.alerts = $scope.analogOutputTableService.alerts;
                            $scope.analogOutputTableService.pageSize = 50;
                            $scope.analogOutputTableService.busy = false;
                        }.bind($scope.analogOutputTableService));
                    } else {
                        $scope.newAnalogOutputTableService();
                        $scope.analogOutputTableService.start = $scope.stickyProperties.dateMin - 3 * $scope.unixDay; //need to extend data range
                        $scope.analogOutputTableService.end = Math.round(($scope.stickyProperties.zoomMax + $scope.stickyProperties.zoomMin) / 2);
                        $scope.analogOutputTableService.busy = true;
                        $scope.analogOutputTableService.nextPage($scope.analogOutputTableService.customerId, $scope.analogOutputTableService.deviceId, $scope.analogOutputTableService.deviceType, $scope.analogOutputTableService.start, $scope.analogOutputTableService.end, $scope.analogOutputTableService.startRow, $scope.analogOutputTableService.pageSize).then(function (result) {
                            /////////////////////////
                            var intDayWindow = 10;
                            var intDay = 86400000;
                            /////////////////////////
                            var deviceName = result.data.device.name;
                            var setting = result.data.setting;
                            $scope.analogOutputTableService.hasMydroExpansion = result.data.device.model == 19 && result.data.device.softwareVersion >= 18;
                            if ($scope.analogOutputTableService.setting.length === 0) {
                                for (var i = 0; i < setting.length; i++) {
                                    $scope.analogOutputTableService.setting.push(setting[i]);
                                    $scope.analogOutputTableService.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
                                }
                                var noOfExtraColumns = 1;
                                $scope.analogOutputTableService.tdWidth = parseInt(100 / (setting.length + noOfExtraColumns)) + "%"; //including "CalculatedWeirGpm" column too                
                            }
                            var readings = result.data.analogOutputMeasurements;
                            if (readings.length > 0) var tmpstart = new Date(readings[readings.length - 1].localDateTime);
                            for (var j = 0; j < readings.length; j++) {
                                readings[j].localDateTime = readings[j].localDateTime;
                                $scope.analogOutputTableService.items.push(readings[j]);
                            }
                            $scope.analogOutputTableService.numberOfReturnedRecords = readings.length;
                            $scope.analogOutputTableService.deviceName = deviceName;
                            $scope.analogOutputTableService.startRow = $scope.analogOutputTableService.startRow + readings.length;
                            if (readings.length == 0) {
                                if ($scope.analogOutputTableService.items.length === 0) {
                                    $scope.analogOutputTableService.alerts = [];
                                    $scope.alerts = [];
                                    var errorMessage = void 0;
                                    if ($scope.analogOutputTableService.setting.length > 0) {
                                        errorMessage = $scope.analogOutputTableService.translation.message.NO_DATA + ': ' + moment($scope.analogOutputTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.analogOutputTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                                        $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "NO_DATA" });
                                        $scope.alerts = $scope.analogOutputTableService.alerts;
                                    } else {
                                        errorMessage = $scope.analogOutputTableService.translation.message.ANALOG_SETUP_INCOMPLETE;
                                        $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
                                        $scope.alerts = $scope.analogOutputTableService.alerts;
                                    }
                                }
                            }
                            $scope.analogOutputTableService.pageSize = 50;
                            $scope.analogOutputTableService.busy = false;
                        }.bind($scope.analogOutputTableService), function (error) {
                            $scope.analogOutputTableService.alerts = [];
                            $scope.alerts = [];
                            var errorMessage = eval("this.translation.message." + error.data.message);
                            $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "danger" });
                            $scope.alerts = $scope.analogOutputTableService.alerts;
                            $scope.analogOutputTableService.pageSize = 50;
                            $scope.analogOutputTableService.busy = false;
                        }.bind($scope.analogOutputTableService));
                    }
                });
            } else {
                _openTableInLiveMode();
            }
        }
    }, true);

    $scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
            $scope.stickyProperties.device.serialNumber = newValue;
            if (oldValue) {
                _unRegisterListener(oldValue);
            }
        }
    }, true);

    $scope.selectMyDateT = function () {
        //$scope.analogOutputTableService = new analogOutputTableService();
        $scope.newAnalogOutputTableService();
        /////////////////////////////////////////////////////////////
        currentScrollbarPosition = 0;
        previousScrollbarPosition = 0;
        $scope.checkFirstRowLiveStatus = null;
        _unRegisterListener($scope.deviceSelectedSn);
        /////////////////////////////////////////////////////////////
        var tmpDates = $scope.myDate;
        var tmpDatesA = tmpDates;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
        tmpDatesA.setHours(12, 0, 0, 0);
        tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
        /////////////////////////////////////////////////////////////
        $scope.analogOutputTableService.start = tmpDates.startDate;
        if (new Date($scope.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
            $scope.analogOutputTableService.end = tmpDatesA;
        } else {
            $scope.analogOutputTableService.end = tmpDates.endDate;
        }
        /////////////////////////////////////////////////////////////
        $scope.analogOutputTableService.startRow = 1;
        $scope.analogOutputTableService.pageSize = 50;
        $scope.analogOutputTableService.customerId = $scope.accountInfo.customerId;
        $scope.analogOutputTableService.deviceId = $scope.deviceSelected;
        $scope.analogOutputTableService.windowTitle = $scope.windowTitle;
        $scope.alerts = [];
        $scope.analogOutputTableService.busy = true;
        $scope.analogOutputTableService.nextPage($scope.analogOutputTableService.customerId, $scope.analogOutputTableService.deviceId, $scope.analogOutputTableService.deviceType, $scope.analogOutputTableService.start, $scope.analogOutputTableService.end, $scope.analogOutputTableService.startRow, $scope.analogOutputTableService.pageSize).then(function (result) {
            /////////////////////////
            var intDayWindow = 10;
            var intDay = 86400000;
            /////////////////////////
            var deviceName = result.data.device.name;
            var setting = result.data.setting;
            $scope.analogOutputTableService.hasMydroExpansion = result.data.device.model == 19 && result.data.device.softwareVersion >= 18;
            if ($scope.analogOutputTableService.setting.length === 0) {
                for (var i = 0; i < setting.length; i++) {
                    $scope.analogOutputTableService.setting.push(setting[i]);
                    $scope.analogOutputTableService.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
                }
                var noOfExtraColumns = 1;
                $scope.analogOutputTableService.tdWidth = parseInt(100 / (setting.length + noOfExtraColumns)) + "%"; //including "CalculatedWeirGpm" column too                
            }
            var readings = result.data.analogOutputMeasurements;
            if (readings.length > 0) var tmpstart = new Date(readings[readings.length - 1].localDateTime);
            for (var j = 0; j < readings.length; j++) {
                readings[j].localDateTime = readings[j].localDateTime;
                $scope.analogOutputTableService.items.push(readings[j]);
            }
            $scope.analogOutputTableService.numberOfReturnedRecords = readings.length;
            $scope.analogOutputTableService.deviceName = deviceName;
            $scope.analogOutputTableService.startRow = $scope.analogOutputTableService.startRow + readings.length;
            if (readings.length == 0) {
                if ($scope.analogOutputTableService.items.length === 0) {
                    $scope.analogOutputTableService.alerts = [];
                    $scope.alerts = [];
                    var errorMessage = void 0;
                    if ($scope.analogOutputTableService.setting.length > 0) {
                        errorMessage = $scope.analogOutputTableService.translation.message.NO_DATA + ': ' + moment($scope.analogOutputTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.analogOutputTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                        $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "NO_DATA" });
                        $scope.alerts = $scope.analogOutputTableService.alerts;
                    } else {
                        errorMessage = $scope.analogOutputTableService.translation.message.ANALOG_SETUP_INCOMPLETE;
                        $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
                        $scope.alerts = $scope.analogOutputTableService.alerts;
                    }
                }
            }
            $scope.analogOutputTableService.pageSize = 50;
            $scope.analogOutputTableService.busy = false;
        }.bind($scope.analogOutputTableService), function (error) {
            $scope.analogOutputTableService.alerts = [];
            $scope.alerts = [];
            var errorMessage = eval("this.translation.message." + error.data.message);
            $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "danger" });
            $scope.alerts = $scope.analogOutputTableService.alerts;
            $scope.analogOutputTableService.pageSize = 50;
            $scope.analogOutputTableService.busy = false;
        }.bind($scope.analogOutputTableService));
        /////////////////////////////////////////////////////////////
        sharedSetupService.setStickyProperties($scope.stickyProperties, { deviceId: $scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + $scope.unixDay, zoomMax: tmpDates.endDate - $scope.unixDay, windowId: $scope.windowId });
    };

    var _setLiveDataStatus = function _setLiveDataStatus(firstRow, liveDataStatusOn) {
        if ($scope.checkFirstRowLiveStatus === true) {
            _checkTopOffset(liveDataStatusOn);
        } else if ($scope.checkFirstRowLiveStatus === null) {
            timeLapseService.getLocalDateTime().then(function (result) {
                if (parseFloat(firstRow) + parseFloat($scope.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                    $scope.checkFirstRowLiveStatus = true;
                    _checkTopOffset(liveDataStatusOn);
                } else {
                    $scope.checkFirstRowLiveStatus = false;
                }
            });
        }
    };

    var _checkTopOffset = function _checkTopOffset(liveDataStatusOn) {
        if (liveDataStatusOn) {
            _registerListener($scope.deviceSelectedSn);
        } else {
            _unRegisterListener($scope.deviceSelectedSn);
        }
    };

    var wsDataReceivedANALOGOUTPUT = function wsDataReceivedANALOGOUTPUT(data) {
        var i = 0;
        if ($scope.liveData === false) {
            _unRegisterListener($scope.deviceSelectedSn);
            return;
        }

        var varTime = datetimeService.socketStrToServerStrTime(data.Time);
        var varValue = parseFloat(data.Value).toFixed(2);
        var _ScaledValues = [];
        var _ScaledValue = void 0;
        var _newRecord = void 0;
        var _recordExistAtIndex = null;
        var _channelIndex = null;

        $scope.analogOutputTableService.end = datetimeService.toUnixtime(data.Time) + $scope.unixDay;

        for (i = 0; i < $scope.analogOutputTableService.items.length; i++) {
            if ($scope.analogOutputTableService.items[i].localDateTime == varTime) {
                _recordExistAtIndex = i;
                break;
            }
        }

        if (_recordExistAtIndex === null) {
            // for (i = 0; i < $scope.analogOutputTableService.setting.length; i++) {
            //     _ScaledValue = { "value": null };
            //     _ScaledValues.push(_ScaledValue);
            // }
            _newRecord = { localDateTime: varTime, scaledValue1: null, scaledValue2: null, scaledValue3: null, scaledValue4: null };
            $scope.analogOutputTableService.items.unshift(_newRecord);
            _recordExistAtIndex = 0;
        }

        for (i = 0; i < $scope.analogOutputTableService.setting.length; i++) {
            if ($scope.analogOutputTableService.setting[i].channel == data.CH) {
                _channelIndex = i;
                _ScaledValue = $scope.analogOutputTableService.setting[_channelIndex].minimumValue + varValue / 255 * ($scope.analogOutputTableService.setting[_channelIndex].maximumValue - $scope.analogOutputTableService.setting[_channelIndex].minimumValue);
                switch (data.CH) {
                    case '1':
                        $scope.analogOutputTableService.items[_recordExistAtIndex].scaledValue1 = _ScaledValue;
                        break;
                    case '2':
                        $scope.analogOutputTableService.items[_recordExistAtIndex].scaledValue2 = _ScaledValue;
                        break;
                    case '3':
                        $scope.analogOutputTableService.items[_recordExistAtIndex].scaledValue3 = _ScaledValue;
                        break;
                    case '4':
                        $scope.analogOutputTableService.items[_recordExistAtIndex].scaledValue4 = _ScaledValue;
                        break;
                }
                break;
            }
        }
        $scope.lastUpdateAt = varTime;
    };

    $scope.$on('processReconnect', function (event, args) {
        $scope.reconnectData(event, args);
    });

    $scope.reconnectData = function (event, args) {
        sharedSetupService.processReconnect({
            stickyProperties: $scope.stickyProperties,
            localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
            dateRangeOption: null,
            windowTitle: $scope.windowTitle,
            fnUnregister: _unRegisterListener,
            fnGetData: _openTableInLiveMode,
            viewType: "Table"
        });
    };

    $scope.mostRecentData = function (event, args) {
        $scope.stickyProperties.liveData = true;
        $scope.myDate = null;
        $scope.reconnectData(event, args);
    };

    var _registerListener = function _registerListener(varSelectedSN) {
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: true, windowId: $scope.windowId });
        $scope.liveData = true;
        $scope.liveDataLine($scope.liveData);
        $scope.analogOutputTableService.numberOfNewRecordsPrevious = -1;
        websocketService.connect();
        for (var i = 0; i < $scope.analogOutputTableService.setting.length; i++) {
            //chart.series.length - 1
            websocketService.register("ANALOGOUT", varSelectedSN, $scope.analogOutputTableService.setting[i].channel.toString(), wsDataReceivedANALOGOUTPUT, null);

            websocketService.register("ANALOGSETTING", varSelectedSN, $scope.analogOutputTableService.setting[i].channel.toString(), wsDataReceivedANALOGSETTINGAT, null);
        }
    };

    var _unRegisterListener = function _unRegisterListener(varSelectedSN) {
        sharedSetupService.setStickyProperties($scope.stickyProperties, { liveData: false, windowId: $scope.windowId });
        if ($scope.liveData === false) return;
        $scope.liveData = false;
        $scope.liveDataLine($scope.liveData);
        $scope.lastUpdateAt = undefined;
        for (var i = 0; i < 2; i++) {
            //chart.series.length - 1
            websocketService.unRegister("ANALOGOUT", varSelectedSN, (i + 1).toString(), wsDataReceivedANALOGOUTPUT, null);
        }
    };

    var _unRegisterListenerAnalogSetting = function _unRegisterListenerAnalogSetting(varSelectedSN) {

        for (var i = 0; i < 6; i++) {
            //chart.series.length - 1
            websocketService.unRegister("ANALOGSETTING", varSelectedSN, (i + 1).toString(), wsDataReceivedANALOGSETTINGAT, null);
        }
    };

    var wsDataReceivedANALOGSETTINGAT = function wsDataReceivedANALOGSETTINGAT(data) {

        if (data.Type == 'ANALOGSETTING') {

            ///reload table when recieved new analog setting from SignalR
            if ($scope.liveData) {
                var refreshStartDate = $scope.analogOutputTableService.start;
                var refreshEndDate = $scope.analogOutputTableService.end;

                $scope.newAnalogOutputTableService();
                $scope.analogOutputTableService.start = refreshStartDate;
                $scope.analogOutputTableService.end = refreshEndDate;
                $scope.analogOutputTableService.busy = true;
                $scope.analogOutputTableService.nextPage($scope.analogOutputTableService.customerId, $scope.analogOutputTableService.deviceId, $scope.analogOutputTableService.deviceType, $scope.analogOutputTableService.start, $scope.analogOutputTableService.end, $scope.analogOutputTableService.startRow, $scope.analogOutputTableService.pageSize).then(function (result) {
                    /////////////////////////
                    var intDayWindow = 10;
                    var intDay = 86400000;
                    /////////////////////////
                    var deviceName = result.data.device.name;
                    var setting = result.data.setting;
                    $scope.analogOutputTableService.hasMydroExpansion = result.data.device.model == 19 && result.data.device.softwareVersion >= 18;
                    if ($scope.analogOutputTableService.setting.length === 0) {
                        for (var i = 0; i < setting.length; i++) {
                            $scope.analogOutputTableService.setting.push(setting[i]);
                            $scope.analogOutputTableService.numberOfDecimals.push(sharedSetupService.getNumberOfDecimals(setting[i].maximumValue, setting[i].minimumValue));
                        }
                        var noOfExtraColumns = 1;
                        $scope.analogOutputTableService.tdWidth = parseInt(100 / (setting.length + noOfExtraColumns)) + "%"; //including "CalculatedWeirGpm" column too                
                    }
                    var readings = result.data.analogOutputMeasurements;
                    if (readings.length > 0) var tmpstart = new Date(readings[readings.length - 1].localDateTime);
                    for (var j = 0; j < readings.length; j++) {
                        readings[j].localDateTime = readings[j].localDateTime;
                        $scope.analogOutputTableService.items.push(readings[j]);
                    }
                    $scope.analogOutputTableService.numberOfReturnedRecords = readings.length;
                    $scope.analogOutputTableService.deviceName = deviceName;
                    $scope.analogOutputTableService.startRow = $scope.analogOutputTableService.startRow + readings.length;
                    if (readings.length == 0) {
                        if ($scope.analogOutputTableService.items.length === 0) {
                            $scope.analogOutputTableService.alerts = [];
                            $scope.alerts = [];
                            var errorMessage = void 0;
                            if ($scope.analogOutputTableService.setting.length > 0) {
                                errorMessage = $scope.analogOutputTableService.translation.message.NO_DATA + ': ' + moment($scope.analogOutputTableService.start).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.analogOutputTableService.end).utc().format('MM/DD/YY, h:mm:ss a');
                                $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "NO_DATA" });
                                $scope.alerts = $scope.analogOutputTableService.alerts;
                            } else {
                                errorMessage = $scope.analogOutputTableService.translation.message.ANALOG_SETUP_INCOMPLETE;
                                $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
                                $scope.alerts = $scope.analogOutputTableService.alerts;
                            }
                        }
                    }
                    $scope.analogOutputTableService.pageSize = 50;
                    $scope.analogOutputTableService.busy = false;
                }.bind($scope.analogOutputTableService), function (error) {
                    $scope.analogOutputTableService.alerts = [];
                    $scope.alerts = [];
                    var errorMessage = eval("this.translation.message." + error.data.message);
                    $scope.analogOutputTableService.alerts.push({ msg: errorMessage, type: "danger" });
                    $scope.alerts = $scope.analogOutputTableService.alerts;
                    $scope.analogOutputTableService.pageSize = 50;
                    $scope.analogOutputTableService.busy = false;
                }.bind($scope.analogOutputTableService));
            } else {
                _resetViewFromLive(data.CH, data.Value);
            }
        }
    };

    $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
        _autoScroll();
        $scope.checkFirstRowLiveStatus = null;
        $scope.trgScroll();
    });

    var _autoScroll = function _autoScroll() {
        if ($scope.analogOutputTableService.numberOfNewRecordsPrevious > 0) {
            var trRow = element.find('tr').eq($scope.analogOutputTableService.numberOfNewRecordsPrevious - 1);
            var yPosition = typeof trRow.position() != "undefined" ? trRow.position().top - 90 : 2;
            element.scrollTop(yPosition);
        } else {
            $timeout(function () {
                element.animate({
                    scrollTop: 5
                }, 500);
            }, 0);
        }
    };

    var _resetView = function _resetView(args) {
        for (var i = 0; i < $scope.analogOutputTableService.setting.length; i++) {
            if ($scope.analogOutputTableService.setting[i].channel == args.channel) {
                var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
                var _newDataValue = _newData.name + " (" + _newData.unit + ")";
                $scope.analogOutputTableService.setting[i].name = _newData.name;
                $scope.analogOutputTableService.setting[i].unit = _newData.unit;
            }
        }
    };
    var _resetViewFromLive = function _resetViewFromLive(channel, patch) {
        for (var i = 0; i < $scope.analogOutputTableService.setting.length; i++) {
            if ($scope.analogOutputTableService.setting[i].channel == channel) {
                switch (patch.path) {
                    case 'name':
                        $scope.analogOutputTableService.setting[i].name = patch.value;
                        break;
                    case 'unit':
                        $scope.analogOutputTableService.setting[i].unit = patch.value;
                        break;
                }
            }
        }
    };

    var _getArgsFromNewSetting = function _getArgsFromNewSetting(channel, newSetting) {
        for (var i = 0; i < newSetting.length; i++) {
            if (newSetting[i].channel == channel) {
                return newSetting[i];
            }
        }
        return null;
    };

    $scope.$on('rtuAnalogUpdate', function (event, args) {
        var _dataChanged = "name, unit";
        if (args.deviceId == $scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
            _resetView(args);
        }
    });

    $scope.$on("$destroy", function () {
        _unRegisterListener($scope.deviceSelectedSn);
        _unRegisterListenerAnalogSetting($scope.deviceSelectedSn);
    });
}]);
////mcapp.component('analogOutputTableComponent', {
////    controller: analogOutputTableController,
////    templateUrl: 'ui/analogoutput/analog-output-table-template.html',    
////    bindings: {
////        stickyProperties: '<',
////        windowId: '<',
////        mobile: '<',
////        windowTitle: '<',
////        classicView: '<'       
////    }
////});
"use strict";
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

mcapp.controller("analogOutputGaugeController", ["$scope", "$rootScope", "authenticationService", "translationService", "sharedSetupService", "openViewService", function ($scope, $rootScope, authenticationService, translationService, sharedSetupService, openViewService) {

    $scope.Channel = [];
    $scope.alerts = [];
    $scope.translation = translationService.translation;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.downloadViewTypeOptions = [0];
    sharedSetupService.getWindowId($scope);

    if (!$rootScope.mobile && !$rootScope.classicView) {
        $scope.popup = _this.getExistingDialog($scope.windowId).ref;
        sharedSetupService.maximize($scope.popup);

        $scope.popup.dialog({
            resize: function resize(event, ui) {
                $scope.adjustSize();
            }
        });

        $scope.popup.dialogExtend({
            maximize: function maximize(event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            },
            restore: function restore(event, ui) {
                openViewService.adjustContentSizeStart($scope.popup);
                $scope.adjustSize();
            }
        });

        $scope.adjustSize = function () {
            $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
            $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            $scope.popup.parent().find('.analog-gauge-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 20);
            //$scope.adjustDeviceIdMenuSize();
        };

        $scope.adjustDeviceIdMenuSize = function () {
            var spph = $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            if (spph < 450) {
                $scope.popup.parent().find('.device-id-menu').css('max-height', spph - 70);
            } else {
                $scope.popup.parent().find('.device-id-menu').css('max-height', 400);
            }
        };
    }
}]);
mcapp.directive('analogOutputGaugeDirective', ["authenticationService", "websocketService", "analogOutputGaugeService", "deviceService", "toaster", "openViewService", "datetimeService", "sharedSetupService", '$filter', function (authenticationService, websocketService, analogOutputGaugeService, deviceService, toaster, openViewService, datetimeService, sharedSetupService, $filter) {
    function link(scope, element, attrs) {
        if (_typeof(scope.stickyProperties) != 'object') {
            scope.stickyProperties = scope.stickyPropertiesInterface;
        }
        scope.charts = [];
        element.on("mouseover.analogOutputGaugeDirective", ".hcolAnalog", function (event) {
            var localScope = $(event.target).scope();
            if ($(event.currentTarget).is(".hcolAnalog") && !scope.mobile && !scope.classicView) {
                $(event.currentTarget).draggable({
                    helper: "clone",
                    revert: false,
                    appendTo: "body",
                    containment: "body",
                    opacity: 0.35,
                    stop: function stop(event, ui) {
                        var mcDevice = { deviceId: scope.deviceSelected, channel: ui.helper.attr("mc-channel"), serialNumber: scope.deviceSelectedSn };

                        var optionsStickyProperties = {
                            device: mcDevice
                        };

                        var $newPosX = ui.offset.left;
                        var $newPosY = ui.offset.top;
                        var position = { my: "left+" + $newPosX + " top+" + $newPosY, at: "left top", of: window };
                        openViewService.openWidget('Analog Output Widget', { width: 240, height: 240 }, position, optionsStickyProperties, sharedSetupService.getViewPropery(1, "minimumWidth"));
                        scope.$apply();
                    }
                });
            }
        });

        scope.$on("$destroy", function (event) {
            element.off("mouseover.analogOutputGaugeDirective");
            angular.forEach(analogOutputGauges, function (value, key) {
                if (value.Chart) value.Chart.destroy();
            });
        });
        var chart;
        var analogOutputGauges = [];
        var accountInfo = authenticationService.getAccountInfo();

        //==========================socket data================================

        var wsDataReceivedAW = function wsDataReceivedAW(data) {
            if (data) {
                for (var i = 0; i < analogOutputGauges.length; i++) {
                    if (analogOutputGauges[i].Channel == data.CH) {
                        if (analogOutputGauges[i].Chart && analogOutputGauges[i].Chart.series[0] && analogOutputGauges[i].Chart.series[0].points[0]) {
                            data.Value = scope.scaledValues(analogOutputGauges[i].minVal, analogOutputGauges[i].maxVal, data.Value);
                            analogOutputGauges[i].Chart.series[0].points[0].update(parseFloat(data.Value));
                        }
                    }
                }
            }
        };

        var wsDataReceivedAWSetPoint = function wsDataReceivedAWSetPoint(data) {
            if (data) {
                for (var i = 0; i < analogOutputGauges.length; i++) {
                    if (analogOutputGauges[i].Channel == data.CH) {
                        if (analogOutputGauges[i].Chart && analogOutputGauges[i].Chart.series[0] && analogOutputGauges[i].Chart.series[0].points[0]) {
                            data.Value = scope.scaledValues(analogOutputGauges[i].minVal, analogOutputGauges[i].maxVal, data.Value);
                            analogOutputGauges[i].Chart.series[0].points[1].update(parseFloat(data.Value));
                        }
                    }
                }
            }
        };

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                analogOutputGauges = [];
                var _device = { deviceName: scope.deviceSelectedName };
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: newValue, device: _device, windowId: scope.windowId });
                drawGauge(newValue);
            }
        }, true);

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            distroyScopeChannel(oldValue);
        }, true);

        scope.$on("$destroy", function () {
            distroyScopeChannel(scope.deviceSelectedSn);
        });

        var drawGauge = function drawGauge(deviceID) {
            distroySingleGauge();
            analogOutputGaugeService.getData(deviceID, scope.deviceSelectedType, accountInfo.customerId).then(function (result) {
                scope.gaugeServerData = result.data.analogOutputGauges;
                scope.analogOutputSetting = result.data.outputSetting;
                if (result.data.device.deviceModel == 20 || !result.data.device.hasAnalogOutputBoard) {
                    scope.alerts = [];
                    scope.alerts.push({ msg: scope.translation.text.ANALOG_OUTPUT_SETUP_INCOMPLETE, type: "info" });
                } else if (scope.analogOutputSetting.length > 0) {
                    websocketService.connect();
                    scope.liveData = true;
                    for (var i = 0; i < result.data.analogOutputGauges.length; i++) {
                        scope.Channel.push(result.data.analogOutputGauges[i].channel);
                        drawSingleGauge(result.data.analogOutputGauges[i], deviceID);
                    }
                } else {
                    scope.alerts = [];
                    scope.alerts.push({ msg: scope.translation.text.ANALOG_OUTPUT_SETUP_INCOMPLETE, type: "info" });
                }
            }, function (error) {
                scope.alerts = [];
                if (!error) error = { data: { message: "GENERAL_SERVER_ERROR" } };
                var errormsg = eval("scope.translation.message." + error.data.message);
                scope.alerts.push({ msg: errormsg, type: "danger" });
            });
        };

        scope.getPlotBands = function (data) {
            var plotBands = [];
            var plotAC = {
                from: data.minVal,
                to: data.maxVal,
                color: '#55BF3B' // green
            };
            plotBands.push(plotAC);
            return plotBands;
        };

        scope.getTickPositions = function (data) {
            var tickPositions = [];
            var A = data.minVal,
                D = data.maxVal;
            tickPositions.push(A);
            tickPositions.push(D);
            return tickPositions;
        };

        scope.scaledValues = function (minVal, maxVal, value) {
            value = minVal + value / 255 * (maxVal - minVal);
            return value;
        };

        var agg, container;
        var drawSingleGauge = function drawSingleGauge(data, DeviceID) {

            //   deviceService.getDeviceLookup(accountInfo.customerId, DeviceID).then(function (result) {
            //      SN = result.data.serialNumber;

            container = document.createElement('div');
            container.setAttribute("class", "hcolAnalog");
            container.setAttribute("mc-deviceid", DeviceID);
            container.setAttribute("mc-channel", data.channel);

            element.append(container);

            websocketService.register("ANALOGOUT", scope.deviceSelectedSn, data.channel, wsDataReceivedAW, null);
            websocketService.register("ANALOGOUTPUTSOURCE", scope.deviceSelectedSn, data.channel, wsDataReceivedAWSetPoint, null);

            _makeChart(data);

            //        });
        };

        var _makeChart = function _makeChart(data, varContainer) {
            if (varContainer) {
                container = varContainer;
                $(container).empty();
            }
            chart = new Highcharts.Chart({

                chart: {
                    renderTo: container,
                    type: 'gauge',
                    plotBackgroundColor: null,
                    plotBackgroundImage: null,
                    backgroundColor: 'rgba(0,0,0,0)',
                    plotBorderWidth: 0,
                    plotShadow: false,
                    spacing: [0, 0, 0, 0]
                    //marginTop: -5,
                    //spacingTop: -15,
                    //style: {
                    //    fontSize: '1em'
                    //}
                },

                title: {
                    text: '',
                    align: 'center',
                    y: 30,
                    style: {
                        color: '#ffffff'
                    }
                },
                exporting: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                pane: {
                    startAngle: -150,
                    endAngle: 150

                },
                xAxis: {
                    labels: {
                        formatter: function formatter() {
                            return this.value.toString().substring(0, 2);
                        }
                    }

                },
                tooltip: {
                    enabled: true,
                    followPointer: false,
                    followTouchMove: false,
                    useHTML: true,
                    formatter: function formatter() {
                        return scope.translation.text.LBL_DESTINATION + " " + scope.translation.text.DESTINATION + "</br>" + scope.translation.text.LBL_SOURCE + " " + scope.translation.text.SOURCE;
                    }
                },
                yAxis: {
                    min: data.minVal > data.maxVal ? data.maxVal : data.minVal,
                    max: data.minVal > data.maxVal ? data.minVal : data.maxVal,

                    minorTickWidth: 0,

                    reversed: data.minVal > data.maxVal ? true : false,

                    //   tickPixelInterval: 30,
                    tickWidth: 1,
                    tickLength: 10,
                    tickColor: '#666',
                    tickPositions: scope.getTickPositions(data),
                    labels: {
                        //style: {
                        //    fontSize: '.5em'
                        //}
                    },

                    title: {
                        //style: {
                        //    fontSize: '.7em'
                        //},
                        text: '<p style="text-align:center; margin-top:5px;">' + _getGaugeTitle(data.channel, data.name) + '</p>'
                    },

                    plotBands: scope.getPlotBands(data)
                },
                plotOptions: {
                    gauge: {
                        dataLabels: {
                            y: -10,
                            borderWidth: 0,
                            useHTML: true
                        }
                    }
                },

                series: [{
                    data: [{
                        y: scope.scaledValues(data.minVal, data.maxVal, data.responseNewSettingRaw)
                    }, {
                        y: scope.scaledValues(data.minVal, data.maxVal, data.newSettingRaw),
                        dial: {
                            backgroundColor: 'rgb(255,0,0,.5)',
                            opacity: .5,
                            baseWidth: 7,
                            rearLength: '0%',
                            radius: '100%',
                            baseLength: '70%'
                        }
                    }],
                    dataLabels: {
                        enabled: true,
                        borderWidth: 0,
                        formatter: function formatter() {
                            return "<div style=\"text-align:left; margin-top:40px;\">\n                                <span style=\"font-size:100%; color: " + (Highcharts.theme && Highcharts.theme.contrastTextColor || 'black') + "\">\n                                " + $filter('number')(this.series.data[0].options.y, sharedSetupService.getNumberOfDecimals(data.maxVal, data.minVal)) + " <span style=\"font-size: smaller;\">" + scope.translation.text.LBL_DESTINATION + "</span>\n                                </span>\n                                <br>\n                                <span style=\"font-size:90%; color: " + (Highcharts.theme && Highcharts.theme.contrastTextColor || 'red') + "\">\n                                " + $filter('number')(this.series.data[1].options.y, sharedSetupService.getNumberOfDecimals(data.maxVal, data.minVal)) + " <span style=\"font-size: smaller;\">" + scope.translation.text.LBL_SOURCE + "</span>\n                                </span>\n                                <br>\n                                <br>\n                                <span style=\"font-size:80%;margin-left:" + (data.unit.length > 7 ? data.unit.length * -1 : data.unit.length * 3) + "\"> " + data.unit + " </span></div>";
                        }
                    },
                    overshoot: 30
                }]

            });

            if (!_.find(scope.charts, function (obj) {
                return obj.channel === data.channel;
            })) {
                scope.charts.push({ channel: data.channel, chart: chart, data: data });
            }

            if (!varContainer) {
                agg = { Channel: data.channel, Chart: chart, container: container, MinVal: data.minVal, MaxVal: data.maxVal };
                analogOutputGauges.push(agg);
            }
        };

        var _getGaugeTitle = function _getGaugeTitle(varChannel, varName) {
            if (varName == scope.translation.text.CHANNEL + ' ' + varChannel) {
                return varName;
            } else {
                return scope.translation.text.CHANNEL + ' ' + varChannel + '<br>' + varName;
            }
        };

        var _getGaugeUnit = function _getGaugeUnit(varUnit, data) {
            return '<div style="text-align:center; margin-top:20px;"><span style="font-size:120%; color:' + (Highcharts.theme && Highcharts.theme.contrastTextColor || 'black') + '">' + $filter('number')(data, 2) + '</span><br/>' + '<span style="font-size:100%;">' + varUnit + '</span></div>';
        };

        var distroySingleGauge = function distroySingleGauge() {
            element.empty();
            scope.alerts = [];
        };

        var distroyScopeChannel = function distroyScopeChannel(oldSn) {
            //remove from socket service
            for (var i = 0; i < scope.Channel.length; i++) {
                websocketService.unRegister("ANALOGOUT", oldSn, scope.Channel[i], wsDataReceivedAW);
                websocketService.unRegister("ANALOGOUTPUTSOURCE", oldSn, scope.Channel[i], wsDataReceivedAWSetPoint);
            }

            scope.Channel = [];
        };

        var _resetView = function _resetView(args) {
            for (var i = 0; i < analogOutputGauges.length; i++) {
                if (analogOutputGauges[i].Channel == args.channel) {
                    var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
                    var _lmData = _getLowMax(args.channel);
                    var _container = _getContainer(args.channel);
                    var _data = { "minVal": _newData.minimumValue, "lowAlarm": _lmData.lowAlarm, "highAlarm": _lmData.highAlarm, "maxVal": _newData.maximumValue };

                    _lmData.minVal = _newData.minimumValue;
                    _lmData.maxVal = _newData.maximumValue;
                    _lmData.name = _newData.name;
                    _lmData.unit = _newData.unit;
                    _makeChart(_lmData, _container);
                    return;
                }
            }
        };

        var _getLowMax = function _getLowMax(channel) {
            for (var i = 0; i < scope.gaugeServerData.length; i++) {
                if (scope.gaugeServerData[i].channel == channel) {
                    return scope.gaugeServerData[i];
                }
            }
            return null;
        };

        var _getContainer = function _getContainer(channel) {
            for (var i = 0; i < analogOutputGauges.length; i++) {
                if (analogOutputGauges[i].Channel == channel) {
                    return analogOutputGauges[i].container;
                }
            }
            return null;
        };

        var _getArgsFromNewSetting = function _getArgsFromNewSetting(channel, newSetting) {
            for (var i = 0; i < newSetting.length; i++) {
                if (newSetting[i].channel == channel) {
                    return newSetting[i];
                }
            }
            return null;
        };

        scope.$on('rtuAnalogUpdate', function (event, args) {
            var _dataChanged = "name, unit, minimumValue, maximumValue";
            if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
                _resetView(args);
            }
        });

        scope.$on('updatePreferencesLanguage', function () {
            for (var i = 0; i < scope.charts.length; i++) {
                _makeChart(scope.charts[i].data, _getContainer(scope.charts[i].channel));
            }
        });
    }
    return {
        link: link
    };
}]);
mcapp.factory('analogOutputGaugeService', ['$http', 'HOST', function ($http, HOST) {
    var analogOutputGaugeFatory = {};

    var _getData = function _getData(deviceId, deviceType, customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/AnalogOutputGauge?deviceId=' + deviceId + '&deviceType=' + deviceType + '&customerId=' + customerId,
            cache: false
        });
    };
    analogOutputGaugeFatory.getData = _getData;
    return analogOutputGaugeFatory;
}]);
"use strict";

angular.module("analogOutputChartModule", []);
'use strict';

angular.module("analogOutputChartModule").factory('analogOutputChartService', ['$http', 'HOST', function ($http, HOST) {
    return {
        getData: function getData(varParm) {
            return $http({
                method: 'GET',
                url: HOST + '/api/AnalogOutputChart?' + varParm,
                cache: false
            });
        }
    };
}]);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module("analogOutputChartModule").directive('drawAnalogOutputChart', ['$rootScope', '$timeout', 'analogOutputChartService', 'datetimeService', 'websocketService', 'timeLapseService', 'toaster', 'sharedSetupService', 'openViewService', 'highchartsOptionsService', 'rangeSelectorService', '$', 'SaveDesktopSettingService', function ($rootScope, $timeout, analogOutputChartService, datetimeService, websocketService, timeLapseService, toaster, sharedSetupService, openViewService, highchartsOptionsService, rangeSelectorService, $, SaveDesktopSettingService) {
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
        scope.downloadViewTypeOptions = [0, 1]; //[0, 1];
        var chart;
        var varToggle = false;
        var xValue = null;
        var scrollingInProgress = false;
        var zoomLevelCurrent,
            zoomLevelPrevious = 0;
        var initialLoad = true;
        scope.chartSeriesVisibility = [];
        scope.downloadOptions = { resolution: 0 };
        scope.liveRefresh = false;

        if (!$rootScope.mobile && !$rootScope.classicView) {
            scope.popup = _this.getExistingDialog(scope.windowId).ref;
            sharedSetupService.maximize(scope.popup);
            scope.popup.dialog({
                resizeStop: function resizeStop(event, ui) {
                    $('#map').removeClass('no-events');
                    scope.yAxisVisibleCheck();
                    _drawChart();
                }
            });
        }

        element.attr("class", "chart");

        element.on('mousewheel', function (event) {
            if (!scrollingInProgress) scope.mouseWheelZoom(event, chart, xValue);
        });

        if (_typeof(scope.stickyProperties) != 'object') {
            scope.stickyProperties = scope.stickyPropertiesInterface;
        }

        scope.$watch('lastUpdateAt', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.liveDataIn = !scope.liveDataIn;
                $timeout(function () {
                    scope.liveDataIn = !scope.liveDataIn;
                }, 3000);
            }
        }, true);

        scope.$watch('deviceSelected', function (newValue, oldValue) {
            if (newValue) {
                var tmpDates,
                    tmpStartDate = null,
                    tmpEndDate = null;
                scope.loadingInProgress = true;

                scope.saveDesktopSettingService = new SaveDesktopSettingService(newValue, scope.windowId);

                if (scope.stickyProperties.setting && scope.stickyProperties.setting.savedDesktop) {
                    scope.savedDesktopSetting = scope.stickyProperties.setting;
                } else {
                    scope.savedDesktopSetting = scope.saveDesktopSettingService.getObject();
                }

                if (scope.stickyProperties.on !== null && scope.stickyProperties.dateMax !== null) {
                    scope.stickyProperties.on = true;
                    tmpStartDate = scope.stickyProperties.dateMin;
                    tmpEndDate = scope.stickyProperties.dateMax;
                } else {
                    scope.stickyProperties.on = false;
                }

                if (!tmpStartDate) {
                    timeLapseService.getLocalDateTime().then(function (result) {
                        tmpDates = new Date(result.data.localDateTime);
                        tmpDates.setHours(0, 0, 0, 0);
                        tmpDates = datetimeService.dateToUnixtime(tmpDates);
                        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
                        tmpStartDate = tmpDates.startDate;
                        tmpEndDate = tmpDates.endDate;
                        _getData(newValue, tmpStartDate, tmpEndDate);
                    });
                } else {
                    _getData(newValue, tmpStartDate, tmpEndDate);
                }
            }
        }, true);

        scope.getyAxisCorrectColor = function () {
            if (scope.yAxis == null || scope.series == null) return;
            for (var i = 0; i < scope.yAxis.length; i++) {
                for (var j = 0; j < scope.series.length; j++) {
                    if (scope.yAxis[i].id == scope.series[j].id) {
                        scope.yAxis[i].lineColor = scope.series[j].color;
                        scope.yAxis[i].title.style.color = scope.series[j].color;
                    }
                }
            }
        };

        scope.yAxisVisibleCheck = function () {
            if (scope.yAxis == null) return;
            scope.windowWidth = $(element).width();
            //Commenting out the below code to Display yAxis on Mobile view also
            // if (scope.yAxis.length > 1 && (scope.windowWidth <= 450)) {
            //     scope.yAxis.forEach(function (yAxis) { yAxis.visible = false; })
            // }
            // else {
            scope.yAxis.forEach(function (yAxis) {
                yAxis.visible = true;
            });
            // }
            scope.getButtonPositionY();
        };

        scope.getButtonPositionY = function () {
            if (scope.windowWidth >= 364 && scope.windowWidth < 450) {
                return -50;
            } else return -65;
        };

        var _getData = function _getData(deviceId, StartDate, EndDate) {
            scope.liveDataEndDate = EndDate;
            scope.refreshStart = StartDate;
            scope.refreshEnd = EndDate;
            analogOutputChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + deviceId + '&deviceType=' + scope.deviceSelectedType + '&StartDate=' + StartDate + '&EndDate=' + EndDate + '&timeZone=' + scope.accountInfo.timeZone).then(function (datafromfactory) {
                scope.analogOutputSetting = datafromfactory.data.outputSetting;
                scope.yAxis = datafromfactory.data.yAxis;
                scope.series = datafromfactory.data.series;
                scope.yAxisVisibleCheck();
                scope.getyAxisCorrectColor();
                scope.alerts = [];
                var _device = { deviceName: scope.deviceSelectedName };

                if (datafromfactory.data.series && datafromfactory.data.series[0].data.length >= 1) {
                    scope.devicename = datafromfactory.data.device.name;
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, windowId: scope.windowId });
                    _drawChart();
                } else {
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: deviceId, device: _device, dataMin: StartDate, dataMax: EndDate, zoomMin: scope.stickyProperties.zoomMin || StartDate, zoomMax: scope.stickyProperties.zoomMax || EndDate, windowId: scope.windowId });
                    element.empty();
                    scope.chart = null;
                    scope.loadingInProgress = false;
                    scope.lastStart = StartDate;
                    scope.lastEnd = EndDate;
                    var errormsg;
                    if (scope.analogOutputSetting.length > 0) {
                        errormsg = scope.translation.message.NO_DATA + ": " + moment(StartDate).utc().format('MM/DD/YY, h:mm:ss a') + " - " + moment(EndDate).utc().format('MM/DD/YY, h:mm:ss a');
                        scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                    } else {
                        errormsg = scope.translation.text.ANALOG_OUTPUT_SETUP_INCOMPLETE;
                        scope.alerts.push({ msg: errormsg, type: "info", languageCode: "ANALOG_SETUP_INCOMPLETE" });
                    }
                }
            }, function (error) {
                scope.alerts = [];
                element.empty();
                scope.chart = null;
                scope.loadingInProgress = false;
                var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            });
        };

        scope.$watch('deviceSelectedSn', function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                scope.chartSeriesVisibility = [];
                scope.stickyProperties.device.serialNumber = newValue;
                if (oldValue) {
                    _unRegisterListener(oldValue);
                    scope._unRegisterListenerAnalogSetting(oldValue);
                }
            }
        }, true);

        scope.zoomAdjust = function (varDay) {
            var extremes = scope.chart.xAxis[0].getExtremes();
            scope.varDay = varDay;
            var extremeMinMax = rangeSelectorService.getChartExtremes(extremes.max, extremes.min, varDay, scope.heartbeatLocalDateTime);
            scope.chart.xAxis[0].setExtremes(extremeMinMax.extremeMin, extremeMinMax.extremeMax);
            _setLiveDataStatus();
        };

        scope.selectMyDateC = function () {
            var tmpDates = this.myDate;
            scope.loadingInProgress = true;
            tmpDates.setHours(0, 0, 0, 0);
            tmpDates = datetimeService.dateToUnixtime(tmpDates);
            tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
            scope.refreshStart = tmpDates.startDate;
            scope.refreshEnd = tmpDates.endDate;
            analogOutputChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&deviceType=' + scope.deviceSelectedType + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate + '&timeZone=' + scope.accountInfo.timeZone).then(function (datafromfactory) {
                scope.series = datafromfactory.data.series;
                scope.devicename = datafromfactory.data.device.name;
                scope.alerts = [];
                if (datafromfactory.data.series && datafromfactory.data.series[0].data.length >= 1) {
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, windowId: scope.windowId });
                    _drawChart();
                } else {
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, dataMax: tmpDates.endDate, zoomMin: tmpDates.startDate + scope.unixDay, zoomMax: tmpDates.endDate - scope.unixDay, windowId: scope.windowId });
                    element.empty();
                    scope.chart = null;
                    scope.lastStart = tmpDates.startDate;
                    scope.lastEnd = tmpDates.endDate;
                    var errormsg = scope.translation.message.NO_DATA + ': ' + moment(tmpDates.startDate).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment(tmpDates.endDate).utc().format('MM/DD/YY, h:mm:ss a');
                    scope.alerts.push({ msg: errormsg, type: "info", languageCode: "NO_DATA" });
                    scope.loadingInProgress = false;
                }
            }, function (error) {
                scope.alerts = [];
                element.empty();
                scope.chart = null;
                scope.loadingInProgress = false;
                var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
            });
        };

        function adjustScale(chart) {

            for (var i = 0; i < chart.series.length - 1; i++) {
                if (varToggle === false) {
                    if (scope.analogOutputSetting[i].minimumValue > scope.analogOutputSetting[i].maximumValue) {
                        chart.yAxis[i].setExtremes(scope.analogOutputSetting[i].maximumValue, scope.analogOutputSetting[i].minimumValue);
                    } else {
                        chart.yAxis[i].setExtremes(scope.analogOutputSetting[i].minimumValue, scope.analogOutputSetting[i].maximumValue);
                    }
                } else {
                    chart.yAxis[i].setExtremes(null, null);
                }
            }
            var extremes = chart.xAxis[0].getExtremes();
            chart.xAxis[0].setExtremes(extremes.min + scope.minPadding, extremes.max + scope.maxPadding);
            varToggle = !varToggle;
        }

        var _drawChart = function _drawChart(resetView) {
            varToggle = false;
            var tmpData = scope.series,
                chartDrawn = false;
            scope.numberOfSeries = scope.series.length;
            scope.numberOfHiddenSeries = 0;

            var chartXaxisHourFormat = scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian ? '%l:%M %p' : '%H:%M';
            var chartToolTipHourFormat = scope.preferredTimeFormat === scope.TimeFormatEnum.Civilian ? '%l:%M:%S %p' : '%H:%M:%S';

            chart = new Highcharts.StockChart({
                credits: {
                    enabled: false
                },
                legend: {
                    enabled: true,
                    backgroundColor: '#f9f9f9',
                    borderColor: '#cccccc',
                    borderWidth: 1
                },
                time: {
                    getTimezoneOffset: function getTimezoneOffset(timestamp) {
                        return -moment.tz(timestamp, datetimeService.getTimeZoneId(scope.accountInfo.timeZone)).utcOffset();
                    }
                },
                chart: {
                    renderTo: element[0],
                    alignThresholds: false,
                    backgroundColor: '#ebebeb',
                    plotBackgroundColor: '#f9f9f9',
                    borderColor: '#d3d3d3',
                    borderWidth: 1,
                    borderRadius: 2,
                    panning: true,
                    panKey: 'shift',
                    pinchType: 'x',
                    plotBorderWidth: 1,
                    marginTop: 10,
                    marginRight: 10,
                    spacingBottom: 10,
                    spacingTop: 0,
                    spacingLeft: 2,
                    spacingRight: 5,
                    animation: false,
                    reflow: true,
                    events: {
                        redraw: function redraw(event) {
                            if (this.options.chart.forExport) return false;
                            var tmpDates,
                                i,
                                analogData = [],
                                extremes = this.xAxis[0].getExtremes();

                            if (this.xAxis && chartDrawn === true && scrollingInProgress === false) {
                                if (extremes && extremes.dataMin >= extremes.min - scope.liveDataOffset) {
                                    scrollingInProgress = true;
                                    this.showLoading();
                                    if (scope.varDay == 3) {
                                        tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -12);
                                    } else {
                                        tmpDates = datetimeService.getNewStartEndDates(extremes.dataMin, -11);
                                    }
                                    analogOutputChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&deviceType=' + scope.deviceSelectedType + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate + '&timeZone=' + scope.accountInfo.timeZone).then(function (datafromfactory) {
                                        if (datafromfactory.data.series && datafromfactory.data.series.length > 0) {
                                            for (i = 0; i < datafromfactory.data.series.length; i++) {
                                                analogData.push(datafromfactory.data.series[i].data);
                                            }
                                        }

                                        if (datafromfactory.data.series && datafromfactory.data.series.length > 0) {
                                            for (i = 0; i < datafromfactory.data.series.length; i++) {
                                                tmpData[i].data = analogData[i].concat(tmpData[i].data);
                                                chart.series[i].setData(tmpData[i].data);
                                            }
                                        }

                                        scope.devicename = datafromfactory.data.device.name;
                                        sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMin: tmpDates.startDate, windowId: scope.windowId });
                                        chart.xAxis[0].setExtremes(extremes.min + scope.minPadding, extremes.max + scope.maxPadding);
                                        _setLiveDataStatus();

                                        $timeout(function () {
                                            scrollingInProgress = false;
                                        }, 1000);

                                        chart.hideLoading();
                                    }, function (error) {
                                        scope.alerts = [];
                                        element.empty();
                                        scope.chart = null;
                                        scope.loadingInProgress = false;
                                        var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                                        scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
                                    });
                                } else if (scope.liveData === false && extremes && extremes.max + scope.liveDataOffset >= extremes.dataMax) {
                                    scrollingInProgress = true;
                                    this.showLoading();

                                    tmpDates = datetimeService.getNewStartEndDates(parseInt(extremes.dataMax), 11);

                                    analogOutputChartService.getData('customerID=' + scope.accountInfo.customerId + '&deviceId=' + scope.deviceSelected + '&deviceType=' + scope.deviceSelectedType + '&StartDate=' + tmpDates.startDate + '&EndDate=' + tmpDates.endDate + '&timeZone=' + scope.accountInfo.timeZone).then(function (datafromfactory) {
                                        if (datafromfactory.data.series && datafromfactory.data.series.length > 0) {
                                            for (i = 0; i < datafromfactory.data.series.length; i++) {
                                                analogData.push(datafromfactory.data.series[i].data);
                                            }
                                        }

                                        if (datafromfactory.data.series && datafromfactory.data.series.length > 0) {
                                            for (i = 0; i < datafromfactory.data.series.length; i++) {
                                                tmpData[i].data = tmpData[i].data.concat(analogData[i]);
                                                chart.series[i].setData(tmpData[i].data);
                                            }
                                        }

                                        scope.devicename = datafromfactory.data.device.name;
                                        sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, dataMax: tmpDates.endDate, windowId: scope.windowId });
                                        chart.xAxis[0].setExtremes(extremes.min + scope.minPadding, extremes.max + scope.maxPadding);
                                        _setLiveDataStatus(tmpDates.endDate);

                                        $timeout(function () {
                                            scrollingInProgress = false;
                                        }, 1000);

                                        chart.hideLoading();
                                    }, function (error) {
                                        scope.alerts = [];
                                        element.empty();
                                        scope.chart = null;
                                        scope.loadingInProgress = false;
                                        var errormsg = scope.translation.message.GENERAL_SERVER_ERROR;
                                        scope.alerts.push({ msg: errormsg, type: "danger", languageCode: "GENERAL_SERVER_ERROR" });
                                    });
                                }
                            }
                        },
                        load: function load(event) {
                            if (initialLoad) openViewService.adjustContentSize(scope.popup);
                            //will remove after changing Mc.Services
                            for (var i = 0; i < this.series.length - 1; i++) {
                                if (scope.accountInfo.customerId == 13041 && scope.deviceSelected == 29138 && i == 0) {
                                    this.yAxis[i].update({
                                        startOnTick: false,
                                        endOnTick: false,
                                        allowDecimals: true,
                                        labels: {
                                            format: "{value:.1f}"
                                        }
                                    });
                                } else {
                                    this.yAxis[i].update({
                                        allowDecimals: false,
                                        labels: {
                                            format: "{value:.0f}"
                                        }
                                    });
                                }
                                if (scope.chartSeriesVisibility.length > 0) sharedSetupService.setChartSeriesVisibility(this, scope.chartSeriesVisibility);
                            }
                            //will remove after changing Mc.Services
                            initialLoad = false;
                            $timeout(function () {
                                scope.saveDesktopSettingService.applySavedDesktopSetting(chart, scope, true);
                            }, 0);
                        },
                        selection: function selection(event) {
                            if (event.xAxis) {
                                //
                            } else {
                                var button = this.exportSVGElements[0];
                                var button2 = this.exportSVGElements[2];
                                button.attr({
                                    x: -5
                                });
                                button2.attr({
                                    x: -200
                                });
                                adjustScale(this);
                            }
                        }
                    }
                },
                title: {
                    style: {
                        color: '#6D869F',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    text: null
                },
                exporting: {
                    buttons: {
                        contextButton: {
                            enabled: false
                        },
                        customButton: {
                            symbol: 'text:\uF205',
                            text: scope.translation.text.AUTO_SCALE,
                            symbolSize: 9,
                            symbolFill: '#337ab7',
                            symbolStrokeWidth: 0,
                            align: "left",
                            verticalAlign: 'bottom',
                            x: -5,
                            y: $rootScope.mobile ? scope.getButtonPositionY() : scope.getButtonPositionY(), //I know...
                            symbolY: $rootScope.mobile ? 14 : 14,
                            theme: {
                                'stroke-width': 0,
                                stroke: 'transparent',
                                fill: 'transparent',
                                r: 0,
                                states: {
                                    hover: {
                                        title: scope.translation.text.TOGGLE_AUTOSCALE,
                                        fill: 'transparent'
                                    },
                                    select: {
                                        stroke: 'transparent',
                                        fill: 'transparent'
                                    }
                                }
                            },
                            onclick: function onclick() {
                                var button = this.exportSVGElements[0];
                                var button2 = this.exportSVGElements[2];
                                button.attr({
                                    x: -200
                                });
                                button2.attr({
                                    x: -5
                                });
                                adjustScale(this);
                            }
                        },
                        customButton2: {
                            symbol: 'text:\uF204',
                            text: scope.translation.text.AUTO_SCALE,
                            symbolSize: 9,
                            symbolFill: '#6b7074',
                            symbolStrokeWidth: 0,
                            align: "left",
                            verticalAlign: 'bottom',
                            x: -200,
                            y: $rootScope.mobile ? scope.getButtonPositionY() : scope.getButtonPositionY(), //I know...
                            symbolY: $rootScope.mobile ? 14 : 14,
                            theme: {
                                'stroke-width': 0,
                                stroke: 'transparent',
                                fill: 'transparent',
                                r: 0,
                                states: {
                                    hover: {
                                        title: scope.translation.text.TOGGLE_AUTOSCALE,
                                        fill: 'transparent'
                                    },
                                    select: {
                                        stroke: 'transparent',
                                        fill: 'transparent'
                                    }
                                }
                            },
                            onclick: function onclick() {
                                var button = this.exportSVGElements[0];
                                var button2 = this.exportSVGElements[2];
                                button.attr({
                                    x: -5
                                });
                                button2.attr({
                                    x: -200
                                });
                                adjustScale(this);
                            }
                        }
                    }
                },
                xAxis: {
                    minRange: 3600 / 4 * 1000, //15 minutes
                    title: {
                        //text: scope.translation.text.TIME,
                        style: {
                            color: '#6D869F',
                            fontWeight: 'bold',
                            fontSize: '15px'
                        }
                    },
                    plotLines: [{
                        value: 0,
                        width: 3,
                        color: 'green',
                        dashStyle: "solid",
                        zIndex: 1
                    }],
                    endOnTick: true,
                    showLastLabel: true,
                    startOnTick: true,
                    ordinal: false,
                    minTickInterval: 3600 * 1000,
                    minorGridLineColor: '#ebebeb',
                    minorTickInterval: 'auto',
                    dateTimeLabelFormats: {
                        hour: chartXaxisHourFormat
                    },
                    labels: {
                        style: {
                            color: '#6D869F',
                            fontWeight: 'bold'
                        }
                    },
                    events: {
                        afterSetExtremes: function afterSetExtremes(e) {
                            if (chartDrawn === true) {
                                var extremes = chart.xAxis[0].getExtremes();
                                if (scope.liveData === true && (e.trigger == "navigator" || e.trigger == "pan" || typeof e.trigger == "undefined")) {
                                    //typeof e.trigger == "undefined" doesn't know about mouse scroll
                                    if (extremes.max + scope.liveDataOffset <= extremes.dataMax) {
                                        sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                                        _unRegisterListener(scope.deviceSelectedSn);
                                    }
                                }
                                sharedSetupService.setStickyProperties(scope.stickyProperties, { zoomMin: extremes.min, zoomMax: extremes.max, windowId: scope.windowId });
                                _downsampleSeries(extremes.min, extremes.max);
                            }
                        }
                    }
                },
                yAxis: scope.yAxis,
                tooltip: {
                    useHTML: true,
                    formatter: function formatter() {
                        var d = new Date(this.x);
                        var s = '';
                        s += '<table style="width: 250px; white-space: normal !important; font-size:small;">';
                        s += '<tr><td colspan="2" style="color: #000000; padding-bottom: 3px;">' + Highcharts.dateFormat('%A, %b %e, %Y ' + chartToolTipHourFormat, datetimeService.utcToLocalTimeStampByTimeZone(this.x, scope.accountInfo.timeZone)) + '</td></tr>';
                        $.each(this.points, function (i, point) {
                            var numDecimals = sharedSetupService.getNumberOfDecimals(scope.analogOutputSetting[i].maximumValue, scope.analogOutputSetting[i].minimumValue);
                            s += '<tr><td style="color: ' + point.series.color + ';">' + point.series.name + ': </td><td style="text-align: right; color: #000000; font-weight: bold;">' + Highcharts.numberFormat(point.y, numDecimals) + '</td></tr>';
                            xValue = point.x;
                        });
                        s += '</table>';
                        return s;
                    },
                    crosshairs: true,
                    shared: true,
                    valueDecimals: 1,
                    backgroundColor: '#FFFFFF',
                    borderColor: 'gray',
                    borderWidth: 1
                },
                navigator: {
                    enabled: true,
                    adaptToUpdatedData: true,
                    series: {
                        lineWidth: 0,
                        color: 'transparent'
                    },
                    maskFill: 'rgba(255, 255, 255, 0.35)',
                    maskInside: true,
                    handles: {
                        backgroundColor: '#a4a7a9',
                        borderColor: '#384450'
                    },
                    height: 22,
                    margin: 0,
                    xAxis: {
                        tickWidth: 2,
                        lineWidth: 1,
                        gridLineWidth: 0,
                        tickLength: 15,
                        tickPosition: 'inside',
                        tickColor: '#98b3d1',
                        dateTimeLabelFormats: {
                            hour: chartXaxisHourFormat
                        },
                        labels: {
                            align: 'left',
                            style: {
                                color: '#61768f',
                                fontWeight: 'bold'
                            },
                            x: 8,
                            y: -8
                        }
                    }
                },
                scrollbar: {
                    enabled: true,
                    height: 0,
                    barBackgroundColor: '#959595',
                    barBorderRadius: 2,
                    barBorderWidth: 0,
                    buttonBackgroundColor: '#959595',
                    buttonBorderWidth: 0,
                    buttonBorderRadius: 2,
                    trackBackgroundColor: 'none',
                    trackBorderWidth: 1,
                    trackBorderRadius: 3,
                    trackBorderColor: '#CCC',
                    liveRedraw: true
                },
                rangeSelector: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        dataGrouping: {
                            enabled: false
                        },
                        point: {
                            events: {
                                mouseOver: function mouseOver() {
                                    xValue = this.x;
                                }
                            }
                        },
                        marker: {
                            fillColor: '#FFFFFF',
                            lineWidth: 2,
                            lineColor: null // inherit from series
                        },
                        events: {
                            legendItemClick: function legendItemClick() {
                                if (this.visible) {
                                    if (scope.numberOfHiddenSeries < scope.numberOfSeries - 1) {
                                        scope.numberOfHiddenSeries = scope.numberOfHiddenSeries + 1;
                                    } else {
                                        return false;
                                    }
                                } else {
                                    scope.numberOfHiddenSeries = scope.numberOfHiddenSeries - 1;
                                }

                                this.chart.yAxis[this.index].update({
                                    labels: {
                                        enabled: this.visible ? false : true
                                    },
                                    title: {
                                        enabled: this.visible ? false : true
                                    },
                                    lineWidth: this.visible ? 0 : 2
                                });

                                scope.saveDesktopSettingService.setSerieVisibilitySetting(this.options.id, this.visible ? false : true, scope);
                            },
                            mouseOut: function mouseOut() {
                                xValue = null;
                            }
                        }
                    }
                },
                series: scope.series
            });

            scope.chart = chart;

            var tmpNewDateA;
            var tmpNewDateB;
            var extremes = chart.xAxis[0].getExtremes();

            if (scope.stickyProperties.on === true && scope.stickyProperties.mostRecentData === undefined) {
                tmpNewDateA = scope.stickyProperties.zoomMin >= extremes.dataMin ? scope.stickyProperties.zoomMin : extremes.dataMin; //extremes.dataMin + scope.unixDay / 24 * 3;
                tmpNewDateB = scope.stickyProperties.zoomMax <= extremes.dataMax + scope.liveDataOffset ? scope.stickyProperties.zoomMax : extremes.dataMax; //extremes.dataMax - scope.unixDay / 24 * 3;
                tmpNewDateB = tmpNewDateB >= tmpNewDateA + scope.unixDay / 24 ? tmpNewDateB : extremes.dataMax - scope.unixDay / 24 * 12;
                scope.stickyProperties.on = false;
            } else {
                scope.stickyProperties.mostRecentData = undefined;
                tmpNewDateA = scope.myDate !== null ? extremes.dataMin + scope.unixDay : extremes.dataMax - scope.unixDay / 24 * 4.5;
                tmpNewDateB = scope.myDate !== null ? tmpNewDateA + scope.unixDay : extremes.dataMax;
                if (tmpNewDateB > extremes.dataMax) {
                    tmpNewDateB = extremes.dataMax;
                    tmpNewDateA = tmpNewDateB - scope.unixDay;
                }
                tmpNewDateA = tmpNewDateA + scope.minPadding;
                tmpNewDateB = tmpNewDateB + scope.maxPadding;
            }

            if (tmpNewDateA >= tmpNewDateB) {
                tmpNewDateA = scope.myDate !== null ? extremes.dataMin + scope.unixDay : extremes.dataMax - scope.unixDay / 24 * 4.5;
                tmpNewDateB = scope.myDate !== null ? tmpNewDateA + scope.unixDay : extremes.dataMax;
                if (tmpNewDateB > extremes.dataMax) {
                    tmpNewDateB = extremes.dataMax;
                    tmpNewDateA = tmpNewDateB - scope.unixDay;
                }
                tmpNewDateA = tmpNewDateA + scope.minPadding;
                tmpNewDateB = tmpNewDateB + scope.maxPadding;
            }

            if (!scope.liveRefresh) {

                chart.xAxis[0].setExtremes(tmpNewDateA, tmpNewDateB);
            } else {
                chart.xAxis[0].setExtremes(scope.extremesXaxis.max, scope.extremesXaxis.min);
            }
            if (scope.series !== null) {
                //only for analog chart if no setup
                sharedSetupService.setStickyProperties(scope.stickyProperties, { deviceId: scope.deviceSelected, zoomMin: tmpNewDateA, zoomMax: tmpNewDateB, windowId: scope.windowId });
            } else {
                chart.showLoading(scope.translation.text.ANALOG_SETUP_UNAVAILABLE);
            }

            if (!resetView) {
                _setLiveDataStatus();
            }

            chartDrawn = true;
            scope.loadingInProgress = false;
        };

        //==========================socket data================================               
        var wsDataReceivedANALOGOUTPUT = function wsDataReceivedANALOGOUTPUT(data) {

            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var extremes = chart.xAxis[0].getExtremes();
            var tmpRange = extremes.max - extremes.min;

            var str = data.Time + "";
            var unixtime = Date.UTC(str.substr(0, 4), parseInt(str.substr(4, 2)) - 1, str.substr(6, 2), str.substr(8, 2), str.substr(10, 2), str.substr(12, 2)); //1404751962000
            var varValue = parseFloat(data.Value);
            unixtime = datetimeService.localToUtcTimeStampByTime(unixtime, scope.accountInfo.timeZone);

            for (var i = 0; i < 2; i++) {
                if (chart.series[i] && parseInt(chart.series[i].options.id) <= 2 && data.CH) {
                    if (data.CH == chart.series[i].options.id) {
                        var series = chart.get(data.CH).series[0];
                        for (var j = 1; j <= 3; j++) {
                            if (series && series.data && series.data[series.data.length - j] && series.data[series.data.length - j].marker && series.data[series.data.length - j].marker.enabled == true) {
                                series.data[series.data.length - j].update({
                                    marker: {
                                        enabled: false
                                    }
                                });
                            }
                        }
                        var scaledValue = scope.analogOutputSetting[i].minimumValue + varValue / 255 * (scope.analogOutputSetting[i].maximumValue - scope.analogOutputSetting[i].minimumValue);
                        series.addPoint([unixtime, scaledValue]);
                        if (series.data.length > 0) {
                            var tmpObj = series.data[series.data.length - 1];
                            tmpObj.update({
                                marker: {
                                    enabled: true,
                                    fillColor: '#d4eacf',
                                    lineWidth: 4,
                                    lineColor: '#299610', // inherit from series
                                    radius: 6
                                },
                                color: '#659355'
                            }, $timeout(function () {
                                if (tmpObj.series != null) {
                                    tmpObj.update({
                                        marker: {
                                            enabled: false
                                        }
                                    });
                                }
                            }, 2000));
                        }
                    }
                }
            }

            if (extremes.max + scope.liveDataOffset > extremes.dataMax && data.CH == 1) chart.xAxis[0].setExtremes(unixtime - tmpRange + scope.minPadding, unixtime + scope.maxPadding);
            var varTime = datetimeService.socketStrToServerStrTime(data.Time);
            scope.lastUpdateAt = varTime;
        };

        scope.$on('processReconnect', function (event, args) {
            scope.reconnectData(event, args);
        });

        scope.reconnectData = function (event, args) {
            sharedSetupService.processReconnect({
                stickyProperties: scope.stickyProperties,
                localDateTime: args != null ? args.localDateTime : $rootScope.keepAlive,
                dateRangeOption: 0,
                windowTitle: scope.windowTitle,
                fnUnregister: _unRegisterListener,
                fnGetData: _getData,
                viewType: "Chart"
            });
        };

        scope.mostRecentData = function (event, args) {
            scope.stickyProperties.mostRecentData = true;
            scope.stickyProperties.liveData = true;
            scope.myDate = null;
            scope.reconnectData(event, args);
        };

        var tlDataReceivedANALOGOUTPUT = function tlDataReceivedANALOGOUTPUT(data) {
            data.Unix = datetimeService.localToUtcTimeStampByTime(data.Unix, scope.accountInfo.timeZone);
            if (scope.liveData === false) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }

            var extremes = chart.xAxis[0].getExtremes();
            var tmpRange = extremes.max - extremes.min;

            if (extremes.dataMax < data.Unix - tmpRange || extremes.dataMax < data.Unix - scope.unixDay / 2) {
                _unRegisterListener(scope.deviceSelectedSn);
                return;
            }
            var liveDataLine = chart.xAxis[0].plotLinesAndBands;
            liveDataLine[0].options.value = data.Unix + scope.maxPadding;

            if (extremes.max + scope.liveDataOffset > extremes.dataMax) chart.xAxis[0].setExtremes(data.Unix - tmpRange + scope.minPadding, data.Unix + scope.maxPadding);
        };

        var _setLiveDataStatus = function _setLiveDataStatus(varEndDate) {
            scope.liveDataEndDate = varEndDate != null ? varEndDate : scope.liveDataEndDate;
            timeLapseService.getLocalDateTime().then(function (result) {
                var extremes = chart.xAxis[0].getExtremes();
                scope.heartbeatLocalDateTime = result.data.unixTimeStamp;
                if (scope.liveDataEndDate > result.data.unixTimeStamp && scope.stickyProperties.zoomMax + scope.liveDataOffset >= extremes.dataMax) {
                    _registerListener(scope.deviceSelectedSn);
                    var data = { Unix: result.data.unixTimeStamp, Value: null, SN: null, CH: null };
                    tlDataReceivedANALOGOUTPUT(data);
                } else {
                    sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: false, windowId: scope.windowId });
                    _unRegisterListener(scope.deviceSelectedSn);
                }
            });
        };

        var _registerListener = function _registerListener(varSelectedSN) {
            websocketService.connect();
            sharedSetupService.setStickyProperties(scope.stickyProperties, { liveData: true, windowId: scope.windowId });
            for (var i = 0; i < 6; i++) {
                //chart.series.length - 1
                if (chart.series[i] && parseInt(chart.series[i].options.id) <= 6) {
                    websocketService.register("ANALOGOUT", varSelectedSN, chart.series[i].options.id, wsDataReceivedANALOGOUTPUT, null);
                    if (i == 0) timeLapseService.register("ANALOGOUT", varSelectedSN, chart.series[i].options.id, tlDataReceivedANALOGOUTPUT);
                    websocketService.register("ANALOGSETTING", varSelectedSN, chart.series[i].options.id, scope.wsDataReceivedANALOGSETTINGAC, scope.wsReconnectANALOGOUTSETTING);
                }
            }
            scope.liveData = true;
        };

        scope.wsDataReceivedANALOGSETTINGAC = function (data) {

            if (data.Type == 'ANALOGSETTING' && data.SN == scope.deviceSelectedSn) {
                if (scope.liveData) {
                    scope.liveRefresh = true;
                    scope.extremesXaxis = scope.chart.xAxis[0].getExtremes();
                    _getData(scope.deviceSelected, scope.refreshStart, scope.refreshEnd);
                    scope.liveRefresh = false;
                } else {
                    _resetViewFromLive(data.CH, data.Value);
                }
            }
        };

        scope.wsReconnectANALOGOUTSETTING = function (data) {
            if (scope.liveData === false) {
                _unRegisterListener();
                return;
            }
        };

        scope._unRegisterListenerAnalogSetting = function (varSelectedSN) {

            for (var i = 0; i < 6; i++) {
                //chart.series.length - 1
                websocketService.unRegister("ANALOGSETTING", varSelectedSN, i + 1, scope.wsDataReceivedANALOGSETTINGAC, scope.wsReconnectANALOGOUTSETTING);
            }
        };

        var _unRegisterListener = function _unRegisterListener(varSelectedSN) {
            for (var i = 0; i < 6; i++) {
                //chart.series.length - 1
                websocketService.unRegister("ANALOGOUT", varSelectedSN, i + 1, wsDataReceivedANALOGOUTPUT, null);
                if (i == 0) timeLapseService.unRegister("ANALOGOUT", varSelectedSN, i + 1, tlDataReceivedANALOGOUTPUT);
            }
            scope.liveData = false;
            scope.lastUpdateAt = undefined;
        };

        var _downsampleSeries = function _downsampleSeries(varMin, varMax) {
            zoomLevelCurrent = varMax - varMin;
            if (zoomLevelCurrent <= scope.unixDay && zoomLevelPrevious > scope.unixDay) {
                for (var i = 0; i < chart.series.length - 1; i++) {
                    chart.series[i].update({ downsample: { threshold: 0 } }, false);
                    chart.series[i].setData(scope.series[i].data, false);
                }
                chart.redraw();
            } else if (zoomLevelCurrent > scope.unixDay && zoomLevelPrevious <= scope.unixDay) {
                for (var i = 0; i < chart.series.length - 1; i++) {
                    chart.series[i].update({ downsample: { threshold: 1000 } }, false);
                }
                chart.redraw();
            }
            zoomLevelPrevious = zoomLevelCurrent;
        };

        var _resetView = function _resetView(args) {
            scope.stickyProperties.on = true;
            for (var i = 0; i < scope.series.length; i++) {
                if (scope.series[i].id == args.channel) {
                    var _newData = _getArgsFromNewSetting(args.channel, args.newSetting);
                    var _newDataValue = _newData.name + " (" + _newData.unit + ")";
                    scope.series[i].name = _newDataValue;
                    scope.yAxis[i].title.text = _newDataValue;
                }
            }
            _drawChart(true);
        };

        var _resetViewFromLive = function _resetViewFromLive(channel, patch) {
            scope.stickyProperties.on = true;
            for (var i = 0; i < scope.series.length; i++) {
                if (scope.series[i].id == channel) {
                    var _newDataValue;
                    switch (patch.path) {
                        case 'name':
                            _newDataValue = patch.value + " (" + scope.analogOutputSetting[i].unit + ")";;
                            break;
                        case 'unit':
                            _newDataValue = scope.analogOutputSetting[i].channelName + " (" + patch.value + ")";
                            break;
                    }

                    scope.series[i].name = _newDataValue;
                    scope.yAxis[i].title.text = _newDataValue;
                }
            }
            _drawChart(true);
        };

        var _getArgsFromNewSetting = function _getArgsFromNewSetting(channel, newSetting) {
            for (var i = 0; i < newSetting.length; i++) {
                if (newSetting[i].channel == channel) {
                    return newSetting[i];
                    break;
                }
            }
            return null;
        };

        scope.$on('rtuAnalogOutputUpdate', function (event, args) {
            var _dataChanged = "name, unit";
            if (args.deviceId == scope.deviceSelected && _dataChanged.indexOf(args.fieldName) > -1) {
                _resetView(args);
            }
        });

        scope.$on('updatePreferencesLanguage', function () {
            if (scope.alerts.length === 0) {
                _drawChart();
            }
        });

        scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
            scope.applyTimeFormat(timeFormat);
            if (scope.alerts.length === 0) {
                _drawChart();
            }
        });

        scope.applyTimeFormat = function (timeFormat) {
            scope.preferredTimeFormat = parseInt(timeFormat);
        };

        scope.$on("$destroy", function () {
            _unRegisterListener(scope.deviceSelectedSn);
            scope._unRegisterListenerAnalogSetting(scope.deviceSelectedSn);
            if (chart) chart.destroy();
            if (!angular.isUndefined(scope.stickyProperties.setting)) scope.stickyProperties.setting = null;
        });
    };
}]);
'use strict';

angular.module("analogOutputChartModule").controller('analogOutputChartController', ['$scope', 'sharedSetupService', 'translationService', 'openViewService', '$element', 'authenticationService', function ($scope, sharedSetupService, translationService, openViewService, $element, authenticationService) {
    sharedSetupService.getWindowId($scope);
    $scope.myDate = null;
    $scope.accountInfo = authenticationService.getAccountInfo();
    $scope.TimeFormatEnum = { Civilian: 1, Military: 2 };
    $scope.preferredTimeFormat = $scope.accountInfo.preferenceUser.timeFormat;
    $scope.unixDay = sharedSetupService.unixDay;
    $scope.liveDataOffset = 20 * 60 * 1000;
    $scope.minPadding = 0;
    $scope.maxPadding = 0;
    $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
    $scope.translation = translationService.translation;
    $scope.mouseWheelZoom = sharedSetupService.mouseWheelZoom;
    $scope.alerts = [];
    $scope.loadingInProgress = true;

    sharedSetupService.broadcastAllDeviceSelected($scope);
    $scope.openView = openViewService.openView;

    sharedSetupService.getWindowId($scope);

    if ($scope.classicView && $element.parent('div').parent('div').parent('div').attr('class') && $element.parent('div').parent('div').parent('div').attr('class').indexOf("ui-dialog") == 0) {
        $scope.largeChart = true;
        $element.height(500);
    };

    $scope.selectMyDate = function (date) {
        $scope.myDate = date;
        $scope.selectMyDateC();
    };

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.fnChangeLanguage = function () {
        if ($scope.alerts.length > 0) {
            var _msg = eval("$scope.translation.message." + $scope.alerts[0].languageCode.toUpperCase());
            var _type = $scope.alerts[0].type;
            var _languageCode = $scope.alerts[0].languageCode;
            if (_languageCode.toUpperCase() === 'NO_DATA') {
                _msg += ': ' + moment($scope.lastStart).utc().format('MM/DD/YY, h:mm:ss a') + ' - ' + moment($scope.lastEnd).utc().format('MM/DD/YY, h:mm:ss a');
            }
            $scope.alerts = [];
            $scope.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        }
    };
}]);
"use strict";

angular.module("mc.carrier-data-usage", []);
'use strict';

function CarrierDataUsageController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, $timeout, $filter, toaster, $uibModal) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(_this2);
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.translation = translationService.translation;
        ctrl.initializeSetting();
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": "Att",
            "name": $scope.translation.text.ATT,
            "templateName": "Att",
            "templateUrl": "ui/carrierdatausage/att/att-data-usage-template.html",
            "height": 135
        }, {
            "id": "Verizon",
            "name": $scope.translation.text.VERIZON,
            "templateName": "Verizon",
            "templateUrl": "ui/carrierdatausage/att/att-data-usage-template-v.html",
            "height": 135
        }, {
            "id": "Telenor",
            "name": $scope.translation.text.TELENOR,
            "templateName": "Telenor",
            "templateUrl": "ui/carrierdatausage/att/att-data-usage-template-t.html",
            "height": 135
        });
    };

    ctrl.alertMe = function (id) {
        switch (id) {
            case 0:
                ctrl.carrierTab = "ATT";
                break;
            case 1:
                ctrl.carrierTab = "VERIZON";
                break;
            case 2:
                ctrl.carrierTab = "TELENOR";
                break;
            default:
                ctrl.carrierTab = "ATT";
                break;
        }
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/carrierdatausage/' + tab.templateName.toLowerCase().replace(' ', '-') + '-tab.html';
    };

    ctrl.carrierDataUsageTabs = ctrl.tabConfiguration;

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    if (!ctrl.mobile && !ctrl.classicView) {
        ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
        sharedSetupService.maximize(ctrl.popup);

        $scope.adjustSize = function () {
            ctrl.adjustSize();
        };

        ctrl.popup.dialog({
            resize: function resize(event, ui) {
                ctrl.adjustSize();
            }
        });

        ctrl.popup.dialogExtend({
            maximize: function maximize(event, ui) {
                openViewService.adjustContentSizeStart(ctrl.popup);
                ctrl.adjustSize();
            },
            restore: function restore(event, ui) {
                openViewService.adjustContentSizeStart(ctrl.popup);
                ctrl.adjustSize();
            }
        });

        ctrl.adjustSize = function () {
            var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            ctrl.popup.parent().css("height", _tmpHeight);
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
            //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
        };
    }
};

CarrierDataUsageController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$timeout', '$filter', 'toaster', '$uibModal'];
'use strict';

angular.module('mc.carrier-data-usage').component('carrierDataUsage', {
    controller: CarrierDataUsageController,
    templateUrl: 'ui/carrierdatausage/carrier-data-usage-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.all-devices", []);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AllDevicesController($, $rootScope, $scope, $timeout, sharedSetupService, openViewService, translationService, authenticationService, $element, wizardSplashService, UpdateDeviceInfoFactory, deviceMenuService) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.firstLoad = true;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        ctrl.isAdmin = sharedSetupService.isAdmin(ctrl.accountInfo);
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        $scope.stickyProperties = ctrl.stickyProperties;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(_this2);

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        };

        ctrl.initializeSetting();
    };

    ctrl.adjustSize = function () {
        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": 0,
            "name": ctrl.translation.text.ANALOG,
            "templateName": "Analog",
            "templateUrl": "ui/alldevicesanalog/all-devices-analog.html",
            "height": 135
        }, {
            "id": 1,
            "name": ctrl.translation.text.DIGITAL,
            "templateName": "Digital",
            "templateUrl": "ui/alldevicesdigital/all-devices-digital.html",
            "height": 150
        }, {
            "id": 2,
            "name": 'Runtime Data',
            "templateName": "Runtimedata",
            "templateUrl": "ui/alldevicesruntimedata/all-devices-runtimedata.html",
            "height": 150
        }, {
            "id": 3,
            "name": 'Pulse Flow',
            "templateName": "PulseFlow",
            "templateUrl": "ui/alldevicespulseflow/all-devices-pulseflow.html",
            "height": 150
        }, {
            "id": 4,
            "name": 'Integrated Flow',
            "templateName": "IntegratedFlow",
            "templateUrl": "ui/alldevicesintegratedflow/all-devices-integratedflow.html",
            "height": 150
        });
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/alldevices' + tab.templateName.toLowerCase() + '/all-devices-' + tab.templateName.toLowerCase() + '.html';
    };

    ctrl.selectTab = function (id) {
        ctrl.selectedTab = id;
    };

    ctrl.allDevicesTabs = ctrl.tabConfiguration;

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {});
};

AllDevicesController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'sharedSetupService', 'openViewService', 'translationService', 'authenticationService', '$element', 'wizardSplashService', 'UpdateDeviceInfoFactory', 'deviceMenuService'];
'use strict';

angular.module('mc.all-devices').component('allDevices', {
    controller: AllDevicesController,
    templateUrl: 'ui/alldevices/all-devices-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.carrier-rate-plan", []);
'use strict';

function CarrierRatePlanController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, $timeout, $filter, toaster, $uibModal) {
    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        if (ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') ctrl.isAdmin = true;
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.translation = translationService.translation;
        ctrl.initializeSetting();
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": "Att",
            "name": $scope.translation.text.ATT,
            "templateName": "Att",
            "templateUrl": "ui/carrierrateplan/att/att-rate-plan-template.html",
            "height": 135
        }, {
            "id": "Verizon",
            "name": $scope.translation.text.VERIZON,
            "templateName": "Verizon",
            "templateUrl": "ui/carrierrateplan/verizon/verizon-rate-plan-template.html",
            "height": 135
            //{
            //    "id": "Sprint",
            //    "name": $scope.translation.text.SPRINT,
            //    "templateName": "Telenor",
            //    "templateUrl": "ui/carrierdatausage/att/att-data-usage-template-t.html",
            //    "height": 135
            //},
            //{
            //    "id": "Telenor",
            //    "name": $scope.translation.text.TELENOR,
            //    "templateName": "Telenor",
            //    "templateUrl": "ui/carrierdatausage/att/att-data-usage-template-t.html",
            //    "height": 135
            //}
        });
    };

    ctrl.alertMe = function (id) {
        switch (id) {
            case 0:
                ctrl.carrierTab = "ATT";
                break;
            case 1:
                ctrl.carrierTab = "VERIZON";
                break;
            case 2:
                ctrl.carrierTab = "TELENOR";
                break;
            default:
                ctrl.carrierTab = "ATT";
                break;
        }
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/carrierdatausage/' + tab.templateName.toLowerCase().replace(' ', '-') + '-tab.html';
    };

    ctrl.carrierDataUsageTabs = ctrl.tabConfiguration;

    $scope.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    if (!ctrl.mobile && !ctrl.classicView) {
        ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
        sharedSetupService.maximize(ctrl.popup);

        $scope.adjustSize = function () {
            ctrl.adjustSize();
        };

        ctrl.popup.dialog({
            resize: function resize(event, ui) {
                ctrl.adjustSize();
            }
        });

        ctrl.popup.dialogExtend({
            maximize: function maximize(event, ui) {
                openViewService.adjustContentSizeStart(ctrl.popup);
                ctrl.adjustSize();
            },
            restore: function restore(event, ui) {
                openViewService.adjustContentSizeStart(ctrl.popup);
                ctrl.adjustSize();
            }
        });

        ctrl.adjustSize = function () {
            var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
            ctrl.popup.parent().css("height", _tmpHeight);
            ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
            ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
            ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));

            //ctrl.popup.parent().find('.tab-content').css("height", _tmpHeight - 85);
            //ctrl.popup.parent().find('.tab-content').css("overflow-y", "auto").css("overflow-x", "hidden");
        };
    }
};

CarrierRatePlanController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$timeout', '$filter', 'toaster', '$uibModal'];
'use strict';

angular.module('mc.carrier-rate-plan').component('carrierRatePlan', {
    controller: CarrierRatePlanController,
    templateUrl: 'ui/carrierrateplan/carrier-rate-plan-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function BlockedAccessController($rootScope, $scope, $location, authenticationService, translationService, sharedSetupService, openViewService, $uibModal, AuthorizedUsersFactory, AuthorizedPortalsFactory) {
    var _this2 = this;

    var ctrl = this;
    ctrl.tabConfiguration = [];
    ctrl.selectedTab = 0;
    ctrl.firstLoad = true;

    ctrl.$onInit = function () {
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        ctrl.isAdmin = sharedSetupService.isAdmin(ctrl.accountInfo);
        ctrl.isMcAdmin = sharedSetupService.mcAdmin();
        ctrl.translation = translationService.translation;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        //// --> need windowId for Wiki/Help for the Classic View
        $scope.stickyProperties = ctrl.stickyProperties;
        if (_typeof($scope.stickyProperties) != 'object') {
            $scope.stickyProperties = $scope.stickyPropertiesInterface;
        }
        sharedSetupService.getWindowId(_this2);

        if (!ctrl.mobile && !ctrl.classicView) {
            ctrl.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize(ctrl.popup);

            $scope.adjustSize = function () {
                ctrl.adjustSize();
            };

            ctrl.popup.dialog({
                resize: function resize(event, ui) {
                    ctrl.adjustSize();
                }
            });

            ctrl.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart(ctrl.popup);
                    ctrl.adjustSize();
                }
            });
        };

        ctrl.initializeSetting();
    };

    ctrl.adjustSize = function () {
        var _tmpHeight = ctrl.popup.parent().css("height").replace(/[^0-9.]+/g, "");
        ctrl.popup.parent().css("height", _tmpHeight);
        ctrl.popup.parent().find('div:eq(2)').css("width", ctrl.popup.parent().css("width"));
        ctrl.popup.parent().find('div:eq(2)').css("min-width", ctrl.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
        ctrl.popup.parent().find('div:eq(2)').css("min-height", _tmpHeight - ctrl.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
    };

    var _tabConfiguration = function _tabConfiguration() {
        var len = arguments.length,
            i = 0;
        var tmpLength = ctrl.tabConfiguration.length;
        for (i = 0; i < len; i++) {
            if (tmpLength == 0) {
                ctrl.tabConfiguration.push(arguments[i]);
            } else {
                ctrl.tabConfiguration[i].name = arguments[i].name;
            }
        }
    };

    ctrl.initializeSetting = function () {
        _tabConfiguration({
            "id": 0,
            "name": ctrl.translation.text.USERS,
            "templateName": "Users",
            "templateUrl": "ui/blockedaccess/blockedusers/blocked-users-template.html",
            "height": 150
        }, {
            "id": 1,
            "name": ctrl.translation.text.CUSTOMERS,
            "templateName": "Customers",
            "templateUrl": "ui/blockedaccess/blockedcustomers/blocked-customers-template.html",
            "height": 150
        }, {
            "id": 2,
            "name": 'McAdmin',
            "templateName": "McAdmin",
            "templateUrl": "ui/blockedaccess/blockedmcadmin/blocked-mcadmin-template.html",
            "height": 150
        });
    };

    ctrl.getTemplateSource = function (tab) {
        if (tab.templateUrl) {
            return tab.templateUrl;
        }

        return 'ui/blockedaccess/blocked' + tab.templateName.toLowerCase() + '/blocked-' + tab.templateName.toLowerCase() + '-template.html';
    };

    ctrl.selectTab = function (id) {
        ctrl.activeTab = id;
    };

    ctrl.blockedAccessTabs = ctrl.tabConfiguration;

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.initializeSetting();
    });

    $scope.$on("$destroy", function () {});
};

angular.module('mc.blocked-access').controller('blockedAccessController', BlockedAccessController);
BlockedAccessController.$inject = ['$rootScope', '$scope', '$location', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$uibModal', 'AuthorizedUsersFactory', 'AuthorizedPortalsFactory'];
'use strict';

angular.module('mc.blocked-access').component('blockedAccess', {
    controller: BlockedAccessController,
    templateUrl: 'ui/blockedaccess/blocked-access-partial.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.alerts', []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AlertsModel(_, HOST, $http, translationService, modalService, toaster) {
  var Alerts = function () {
    function Alerts(customerId) {
      var _this = this;

      _classCallCheck(this, Alerts);

      this._destinations = [];
      this._loading = false;
      this._customerId = customerId;
      this._prevName = null;
      $http.get(HOST + '/api/AlertDest?customerId=' + customerId).then(function (resp) {
        _this._destinations = resp.data;
        for (var i = 0; i < _this._destinations.length; i++) {
          if (_this._destinations[i].entryType === 1) {
            _this._destinations[i].rawFormat = { id: 0 };
          } else {
            switch (_this._destinations[i].formatType + _this._destinations[i].textOnly * 10) {
              case 0:
                _this._destinations[i].rawFormat = { id: 1 };
                _this._destinations[i].data1 = _this._destinations[i].data1.replace(/\D/g, '');
                break;
              case 1:
                _this._destinations[i].rawFormat = { id: 2 };
                break;
              case 11:
                _this._destinations[i].rawFormat = { id: 3 };
                break;
              default:
                _this._destinations[i].rawFormat = { id: 0 };
            }
          }
        }
        _this._loading = false;
      });
    }

    _createClass(Alerts, [{
      key: 'updateFormat',
      value: function updateFormat(dest) {
        if (dest.rawFormat.id === 0) {
          dest.entryType = 1;
          dest.formatType = 0;
          dest.textOnly = 0;
        } else {
          dest.entryType = 0;
          if (dest.rawFormat.id === 1) {
            dest.formatType = 0;
            dest.textOnly = 0;
          } else {
            dest.formatType = 1;
            if (dest.rawFormat.id === 2) {
              dest.textOnly = 0;
            } else {
              dest.textOnly = 1;
            }
          }
        }

        this.updateDest(dest);
      }
    }, {
      key: 'determineFormat',
      value: function determineFormat(dest) {
        if (dest.entryType === 1) {
          return translationService.translation.text.HEADS_UP;
        }

        switch (dest.formatType + dest.textOnly * 10) {
          case 0:
            return translationService.translation.text.BY_FAX;
          case 1:
            return translationService.translation.text.BY_EMAIL_HTML;
          case 11:
            return translationService.translation.text.BY_EMAIL_TEXT;
          default:
            return translationService.translation.text.FORMAT + ' #' + dest.formatType;
        }
      }
    }, {
      key: 'verifyEmail',
      value: function verifyEmail(email) {
        var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return regex.test(email);
      }
    }, {
      key: 'formatMismatch',
      value: function formatMismatch(dest) {
        if (dest.entryType === 1) {
          return false;
        }

        switch (dest.formatType + dest.textOnly * 10) {
          case 0:
            return false;
          case 1:
            return !this.verifyEmail(dest.data1);
          case 11:
            return !this.verifyEmail(dest.data1);
          default:
            return !this.verifyEmail(dest.data1);
        }
      }
    }, {
      key: 'addDest',
      value: function addDest() {
        var newDest = {
          id: 0,
          name: "",
          entryType: 0,
          formatType: 1,
          rawFormat: { id: 0 },
          textOnly: 0,
          data1: '',
          wdAlert: false,
          rtAlert: false,
          systemAlert: false,
          psAlert: false,
          psAlertTime: new Date()
        };
        this.addMode = true;
        this.editDest = 0;
        this._destinations.unshift(newDest);
      }
    }, {
      key: 'hasNewAlert',
      value: function hasNewAlert() {
        return _.findIndex(this._destinations, function (dest) {
          return dest.id === 0;
        }) > -1;
      }
    }, {
      key: 'cancelAdd',
      value: function cancelAdd() {
        this._destinations.splice(0, 1);
        this.addMode = false;
        this.editDest = null;
      }
    }, {
      key: 'deleteDest',
      value: function deleteDest(id) {
        var _this2 = this;

        modalService.confirmDelete('DELETE_ALERT').then(function () {
          $http.delete(HOST + '/api/AlertDest?customerId=' + _this2._customerId + '&alertDestId=' + id).then(function (resp) {
            var idx = _.findIndex(_this2._destinations, function (dest) {
              return dest.id === id;
            });
            if (idx > -1) {
              _this2._destinations.splice(idx, 1);
            }
          }, function (resp) {
            toaster.pop('error', translationService.translation.text.ALERTS, resp.data.message);
          });
        }, function () {
          // Do nothing!
        });
      }
    }, {
      key: 'editingTo',
      value: function editingTo(name) {
        this._prevName = name;
      }
    }, {
      key: 'updateDest',
      value: function updateDest(dest) {
        if (dest.id !== 0 && this._prevName !== dest.data1 && this.validateDest(dest)) {
          dest.rawFormat = { id: dest.rawFormat.id };

          //Create Copy for proper UI format
          var destCopy = angular.copy(dest);

          //update current date, and keep old time
          dest.psAlertTime = moment(dest.psAlertTime).format('YYYY-MM-DD HH:mm:ss');
          dest.psAlertTime = dest.psAlertTime.split(" ");
          dest.psAlertTime[0] = moment().format('YYYY-MM-DD');
          dest.psAlertTime.splice(1, 0, " ");
          dest.psAlertTime = dest.psAlertTime.join("");

          //Check for New Entry
          $http.put(HOST + '/api/AlertDest?customerId=' + this._customerId + '&alertDestId=' + dest.id, dest).then(function (resp) {
            //Return date to proper format for front-end
            dest.psAlertTime = destCopy.psAlertTime;
          });
        }
      }
    }, {
      key: 'validateDest',
      value: function validateDest(dest) {
        if (dest.data1 === '' || dest.entryType === -1 || dest.formatType === -1 || dest.textOnly === -1) {
          return false;
        }

        if (this.formatMismatch(dest)) {
          return false;
        }

        if (dest.formatType + dest.textOnly * 10 === 0 && dest.data1.length !== 10) {
          return false;
        }

        return true;
      }
    }, {
      key: 'insertDest',
      value: function insertDest(dest) {
        var _this3 = this;

        if (this.validateDest(dest)) {
          //Create Copy and set proper format for DB
          var destCopy = angular.copy(dest);
          dest.psAlertTime = moment(dest.psAlertTime).format('YYYY-MM-DD HH:mm:ss');

          $http.post(HOST + '/api/AlertDest?customerId=' + this._customerId, dest).then(function (resp) {
            dest.id = resp.data.id;
            _this3._destinations.sort(firstBy('data1', { ignoreCase: true }));
            dest.psAlertTime = destCopy.psAlertTime;
          });
          this.addMode = false;
          this.editDest = null;
        }
      }
    }, {
      key: 'updatePumpStartAlerts',
      value: function updatePumpStartAlerts(index, dest) {
        var _this4 = this;

        modalService.pumpStartAlertsTime('UPDATE_PUMP_START_ALERTS', index, this).then(function () {
          //update 
          _this4.updateDest(dest);
        }, function () {
          //close modal
        });
      }
    }, {
      key: 'destinations',
      get: function get() {
        return this._destinations;
      }
    }, {
      key: 'loading',
      get: function get() {
        return this._loading;
      }
    }]);

    return Alerts;
  }();

  return Alerts;
}

AlertsModel.$inject = ['_', 'HOST', '$http', 'translationService', 'modalService', 'toaster'];

angular.module('mc.alerts').factory('AlertsModel', AlertsModel);
'use strict';

function AlertsController(_, $, $rootScope, $scope, $sce, authenticationService, translationService, modalService, AlertsModel, sharedSetupService, wizardSplashService, preferencesService, unsavedChangesService) {
  var _this2 = this;

  this.$onInit = function () {

    _this2._ = _;
    sharedSetupService.getWindowId(_this2);
    _this2.savedAlert = null;
    _this2.canClose = false;
    _this2.accountInfo = authenticationService.getAccountInfo();
    _this2.translation = translationService.translation;
    preferencesService.getPreferenceUser(_this2.accountInfo.userId, _this2.accountInfo.customerId).then(function (result) {
      _this2.timeFormat = result.data.timeFormat;
    }, function (error) {
      //$scope.status = 'Unable to load customer data: ' + error.message;
    });

    $rootScope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
      _this2.timeFormat = timeFormat;
    });

    _this2.alerts = new AlertsModel(_this2.accountInfo.customerId);
    //// --> need windowId for Downloads, Wiki/Help for the Classic View
    sharedSetupService.getWindowId(_this2);

    // binding 'dialogbeforeclose' event to Check for unsaved Changes function
    if (!_this2.mobile && !_this2.classicView) {
      _this2._popup = _this.getExistingDialog(_this2.windowId).ref;
      $(_this2._popup).on('dialogbeforeclose', function (event) {
        unsavedChangesService.checkUnsavedChanges(event, _this2._popup, _this2, _this2.alerts.hasNewAlert());
      });
    }
  };

  this.getHeight = function () {
    if (!_this2.mobile && !_this2.classicView) {
      return _this2._popup.parent().find('.alerts-container')[0].clientHeight - _this2._popup.parent().find('.table')[0].clientHeight;
    }

    return $('.alerts-container')[0].clientHeight - 65;
  };

  this.getMask = function (dest) {
    if (dest.formatType + dest.textOnly * 10 === 0) {
      return '(999) 999-9999';
    }

    return '';
  };

  $scope.$on('$routeChangeStart', function (event) {
    if (_this2.alerts.hasNewAlert()) {
      if (confirm(_this2.translation.text.EXIT_WITHOUT_SAVE) !== true) {
        console.log(event);
        event.preventDefault();
        $rootScope.loadingView = false;
      }
    }
  });

  this.isAdmin = function () {
    return _this2.accountInfo.userRole === 'Administrator' || _this2.accountInfo.userRole === 'SuperAdministrator';
  };

  this.newAlert = function () {
    return _.findIndex(_this2.alerts.get(), function (alert) {
      return alert.id === 0;
    }) > -1;
  };

  this.editingAlert = function (alert) {
    _this2.savedAlert = JSON.parse(JSON.stringify(alert));
  };

  this.hasOverflow = function () {
    var element = document.getElementById('alert-rows');
    if (element.offsetHeight < element.scrollHeight) {
      return true;
    }
    return false;
  };

  this.selectInput = function ($event) {
    $event.target.select();
  };

  this.contactOptions = [{ id: 1, description: translationService.translation.text.BY_FAX }, { id: 2, description: translationService.translation.text.BY_EMAIL_HTML }, { id: 3, description: translationService.translation.text.BY_EMAIL_TEXT }];

  this.$onDestroy = function () {
    //save wizard step status if wizard splash lauched this view.
    if ($rootScope.launchedByWizard) {
      wizardSplashService.SaveWizardStepStatus(_this2.accountInfo.customerId, _this2.accountInfo.userId, $rootScope.wizardId, _this2.windowId, 2); //save status as completed (2: status complete)
      $rootScope.$broadcast('wizardSplashStepClosed');
    }
  };

  this.dynamicPopover = {
    templateUrl: 'AlertPopoverTemplate.html'
  };

  this.updateType = function (dest, type) {
    if (type == "html") {
      dest.formatType = 1;
      dest.textOnly = 0;
    } else if (type == "text") {
      dest.formatType = 1;
      dest.textOnly = 1;
    } else {
      dest.formatType = 0;
      dest.textOnly = 0;
    }
    _this2.alerts.updateDest(dest);
  };

  this.formatPhoneNumberDisplay = function (f_val) {
    if (typeof f_val === "undefined") return f_val;
    f_val = f_val.replace(/\D/g, '');
    f_val = f_val.length > 10 ? f_val.replace(/(\d{3})(\d{3})(\d{4})(\d{4})/, "($1) $2-$3 ext. $4") : f_val.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    return f_val;
  };
}

AlertsController.$inject = ['_', '$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'modalService', 'AlertsModel', 'sharedSetupService', 'wizardSplashService', 'preferencesService', 'unsavedChangesService'];

angular.module('mc.alerts').component('alerts', {
  controller: AlertsController,
  transclude: true,
  templateUrl: 'ui/alerts/alerts-partial.html',
  bindings: {
    windowId: '<',
    mobile: '<',
    classicView: '<'
  }
});
mcapp.directive('compileTemplate', ["$compile", "$parse", function ($compile, $parse) {
    return {
        link: function (scope, element, attr) {
            var parsed = $parse(attr.ngBindHtml);
            function getStringValue() { return (parsed(scope) || '').toString(); }

            //Recompile if the template changes
            scope.$watch(getStringValue, function () {
                $compile(element, null, -9999)(scope);  //The -9999 makes it skip directives so that we do not recompile ourselves
            });
        }
    }
}]);
"use strict";

angular.module("mc.alarm-history", []);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlarmHistoryFactory = function AlarmHistoryFactory($http, REPORTS, translationService, datetimeService) {
    var AlarmHistory = function () {
        function AlarmHistory() {
            _classCallCheck(this, AlarmHistory);

            this.filterCol = false;
            this.filterDeviceId = 0;
            this.finalItems = [];
            this.items = [];
            this.customerId = null;
            this.startRow = 1;
            this.pageSize = 50;
            this.end = '19000101';
            this.busy = false;
            this.lang = 1;
            this.numberOfReturnedRecords = -1;
            this.numberOfNewRecordsPrevious = -1;
            this.alerts = [];
            this.filter = {
                acknowledged: true,
                unacknowledged: true,
                service: true,
                disabled: true,
                noDestinations: true
            };
            this.translation = translationService.translation;
            this.remove_duplicates = function (arr, props) {
                var seen = new Set();
                return arr.filter(function (item) {
                    // Create a unique key by joining the values of the specified properties
                    var key = props.map(function (prop) {
                        return item[prop];
                    }).join('|');
                    if (seen.has(key)) {
                        return false; // Duplicate found
                    } else {
                        seen.add(key); // New key, add to Set and keep the item
                        return true;
                    }
                });
            };
        }

        _createClass(AlarmHistory, [{
            key: 'webAckAlarm',
            value: function webAckAlarm(userId, userName, eventId) {
                return $http.get(REPORTS + '/api/WebAckAlarm?customerId=' + this.customerId + '&userId=' + userId + '&userName=' + userName + '&eventId=' + eventId);
            }
        }, {
            key: 'getDispatchHistory',
            value: function getDispatchHistory(reportId) {
                if (this.dispatchBusy) return;

                var url = REPORTS + "/api/DispatchHistory?customerId=" + this.customerId + "&reportId=" + reportId;
                return $http.get(url);
            }
        }, {
            key: 'getData',
            value: function getData() {
                var _this = this;

                if (this.busy) return;
                this.busy = true;

                //direction is fixed when the request is sent; previousPage() can change pageSize while this request is in flight
                var isPrevious = this.pageSize < 0;
                var toUnix = function toUnix(item) {
                    return datetimeService.toUnixtime(item.arrivalDateTime.replace(/\D/g, ''));
                };
                var keyOf = function keyOf(item) {
                    return [item.arrivalDateTime, item.alarmDescription, item.reportID].join('|');
                };

                var url = REPORTS + "/api/AlarmHistory?customerId=" + this.customerId + "&PageSize=" + this.pageSize + "&deviceId=" + this.filterDeviceId; //"&StartRow=" + this.startRow + "&PageSize=" + this.pageSize + "&EndDate=" + this.end;
                if (this.pageSize < 0) url += "&startDate=" + this.end + "&endDate=" + null;else {
                    if (this.items.length > 0) url += "&startDate=" + null + "&endDate=" + datetimeService.toUnixtime(this.items[this.items.length - 1].arrivalDateTime.replace(/\D/g, ''));else url += "&startDate=" + null + "&endDate=" + this.end;
                }

                url += "&lang=" + this.lang + "&acknowledged=" + this.filter.acknowledged + "&unacknowledged=" + this.filter.unacknowledged + "&service=" + this.filter.service + "&disabled=" + this.filter.disabled + "&nodest=" + this.filter.noDestinations;
                $http.get(url).then(function (resp) {
                    /////////////////////////
                    var intDayWindow = 10;
                    var intDay = 86400000;
                    /////////////////////////

                    var items = resp.data;

                    var previousFinalCount = _this.finalItems.length;

                    if (!isPrevious) {
                        //older records are appended below the existing ones
                        _this.items = _this.items.concat(items);
                        _this.numberOfReturnedRecords = items.length;
                        _this.numberOfNewRecordsPrevious = 0;
                    } else {
                        //newer records go above the existing ones; do not rely on the order returned by the server
                        var existing = new Set(_this.items.map(keyOf));
                        var newer = items.filter(function (item) {
                            return !existing.has(keyOf(item));
                        }).sort(function (a, b) {
                            return toUnix(b) - toUnix(a);
                        });
                        _this.items = newer.concat(_this.items);
                        _this.numberOfNewRecordsPrevious = 0;
                    }

                    _this.startRow = _this.startRow + items.length;
                    //this.startRow = this.startRow == 1 ? items.length : this.startRow + items.length;

                    if (items.length > 0) {
                        //if there are records returned
                        //remove duplicate items, if any (group by arrivalDateTime, alarmDescription and reportID)
                        _this.items = _this.remove_duplicates(_this.items, ['arrivalDateTime', 'alarmDescription', 'reportID']);
                        _this.filterAlarmHistory();
                        if (isPrevious) {
                            //rows actually rendered above the previous first row (respects the device filter)
                            _this.numberOfNewRecordsPrevious = Math.max(_this.finalItems.length - previousFinalCount, 0);
                        }

                        _this.end = datetimeService.toUnixtime(_this.items[0].arrivalDateTime.replace(/\D/g, ''));
                        _this.alerts.length = 0;
                    }
                    if (!(_this.items.length > 0)) {
                        _this.alerts = [];
                        var start = !_this.start ? moment(_this.end).subtract(6, 'months').utc().format('MM/DD/YY, h:mm:ss a') : moment(_this.start).utc().format('MM/DD/YY, h:mm:ss a');
                        var errorMessage = _this.translation.message.NO_DATA + ': ' + start + ' - ' + moment(_this.end).utc().format('MM/DD/YY, h:mm:ss a');
                        _this.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                    }

                    _this.pageSize = 50;
                    _this.busy = false;
                }, function (error) {
                    var _error = error.data;
                    _this.numberOfNewRecordsPrevious = 0;
                    _this.alerts = [];
                    var errorMessage = eval("this.translation.message." + _error.message);
                    _this.alerts.push({ msg: errorMessage, type: "danger" });

                    _this.pageSize = 50;
                    _this.busy = false;
                });
            }
        }, {
            key: 'previousPage',
            value: function previousPage() {
                this.pageSize = this.pageSize < 0 ? this.pageSize : -this.pageSize;
                this.getData();
            }
        }, {
            key: 'nextPage',
            value: function nextPage() {
                this.getData();
            }
        }, {
            key: 'filterAlarmHistory',
            value: function filterAlarmHistory() {
                var _this2 = this;

                this.finalItems = [];

                if (this.filterDeviceId == 0) {
                    this.finalItems = this.items.slice();
                } else {
                    this.finalItems = this.items.filter(function (item) {
                        return item.unitID == _this2.filterDeviceId;
                    });
                }

                // this will run after col filtering deviceId and records less then below 10 OR removed col filter
                if (this.finalItems.length < 10 && this.filterCol) {
                    this.filterCol = false; // for avoid multiple call
                    this.getData(); // call service
                }
            }
        }]);

        return AlarmHistory;
    }();

    return AlarmHistory;
};

AlarmHistoryFactory.$inject = ['$http', 'REPORTS', 'translationService', 'datetimeService'];

angular.module('mc.alarm-history').factory('AlarmHistoryFactory', AlarmHistoryFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AlarmHistoryController(_, $scope, $rootScope, $sce, $filter, AlarmHistoryFactory, sharedSetupService, openViewService, translationService, timeLapseService, $timeout, authenticationService, datetimeService, ngAudio, toaster, $element, savePdfService, websocketService, deviceMenuService) {

    var ctrl = this;

    ctrl.myDate = null;
    ctrl.infiniteScrollOn = false;
    ctrl.infiniteScrollUpOn = false;
    ctrl.infiniteScrollDownOn = false;
    ctrl.checkFirstRowLiveStatus = null;
    ctrl.shrinkUI = false;
    ctrl.dispatchLoading = false;
    ctrl.alerts = [];

    var element = $('#alarm-history-table');
    var currentScrollbarPosition = void 0;
    var previousScrollbarPosition = void 0;
    var paddingZoom = void 0;

    ctrl.deviceData = [];
    ctrl.deviceModel = [];
    ctrl.deviceModelLength = null;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.prefLang = ctrl.accountInfo.preferenceUser.i18nCode;

        ctrl.translation = translationService.translation;

        ctrl.unixDay = sharedSetupService.unixDay;
        ctrl.liveDataOffset = sharedSetupService.liveDataOffset;

        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for

        ctrl.downloadViewTypeOptions = [0, 1, 2];
        ctrl.dispatchHistory = [];

        $scope.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof($scope.stickyProperties) != 'object') $scope.stickyProperties = $scope.stickyPropertiesInterface;
        paddingZoom = Math.round(($scope.stickyProperties.zoomMax - $scope.stickyProperties.zoomMin) / 2) || ctrl.unixDay / 2;

        ctrl.getDevices().then(function () {
            getAlarmHistory();
        });

        //Manage Dialog Geometry
        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.qdpLeft = -237;
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            //THE-51575: jQuery UI renders the window title as a plain <span>; role/aria-level expose
            //it as an <h2> without Bootstrap's h2 styling. children() so a .ui-dialog-title inside
            //the view content is never matched
            $scope.popup.dialog('widget').children(".ui-dialog-titlebar").children(".ui-dialog-title").attr({ "role": "heading", "aria-level": "2" });
            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                if (ctrl.shrinkUI === false && $scope.popup.parent().width() < 725) {
                    ctrl.shrinkUI = true;
                } else if (ctrl.shrinkUI === true && $scope.popup.parent().width() >= 725) {
                    ctrl.shrinkUI = false;
                }

                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    ctrl.getDevices = function () {
        return deviceMenuService.getDeviceMenuList(ctrl.accountInfo.customerId).then(function (result) {
            ctrl.devices = result.data.devices;
            var tmp = [];
            for (var i = 0; i < ctrl.devices.length; i++) {
                tmp.push({ id: ctrl.devices[i].deviceId, label: ctrl.devices[i].name });
            }
            ctrl.deviceData = tmp;
        });
    };

    ctrl.deviceSetting = {
        smartButtonMaxItems: 1,
        selectionLimit: 1,
        closeOnSelect: true,
        showCheckAll: false,
        showUncheckAll: false
    };

    ctrl.deviceEvents = {
        onItemSelect: function onItemSelect(item) {
            if (item.id == ctrl.AlarmHistoryFactory.filterDeviceId) {
                ctrl.AlarmHistoryFactory.filterDeviceId = 0;
                ctrl.deviceModel = [];
            } else {
                ctrl.AlarmHistoryFactory.filterDeviceId = item.id;
            }
            ctrl.AlarmHistoryFactory.filterCol = true;
            ctrl.deviceModelLength = ctrl.deviceModel.length;
            ctrl.AlarmHistoryFactory.filterAlarmHistory();
        }
    };

    //Enum of all known repStates
    var repStates = {
        Processing: 0,
        NoDestination: 1,
        NeverAcknowledged: 2,
        UserAck: 3,
        InputDisabled: 4,
        KeyAck: 5,
        UnitNotFound: 6,
        ServiceMode: 7,
        SwingerMode: 8,
        NoActiveConditions: 9,
        UnitDisabled: 10,
        WebAck: 11,
        AcFailureOverride: 12,
        AbortedByPrescript: 15,
        WebAck16: 16,
        OpcAck: 17

        //Dictionary of RepStateProperties
    };var repStateProperties = {};
    repStateProperties[repStates.NoDestination] = {
        Name: 'NoDest',
        Description: 'Alarm was generated, but there was no one to send it to',
        StateIcon: 'fa-minus-circle',
        StateColor: 'black',
        IconColor: 'blue',
        RowColor: '#FF4040',
        DispatchColor: 'black'
    };
    repStateProperties[repStates.NeverAcknowledged] = {
        Name: 's2',
        StateIcon: 'fa-times-circle',
        StateColor: '#e75a5a',
        RowColor: '#FF4040',
        DispatchColor: '8B0000'
    };
    repStateProperties[repStates.UserAck] = {
        Name: 'UserAck',
        Description: 'Acknowledged by User',
        StateIcon: 'fa-check-circle',
        StateColor: '#16a085',
        IconColor: '#16a085',
        RowColor: '#40FF40',
        IsAck: true
    };
    repStateProperties[repStates.KeyAck] = {
        Name: 'Acknowledged by Service Key',
        StateIcon: 'fa-check-circle',
        StateColor: '#16a085',
        IconColor: '#16a085',
        RowColor: '#4099FF',
        IsAck: true
    };
    repStateProperties[repStates.WebAck] = {
        Name: 'WebAck',
        Description: 'Acknowledged by Web User',
        StateIcon: 'fa-check-circle',
        IconColor: '#16a085',
        StateColor: '#16a085',
        RowColor: '#A0FFA0',
        IsAck: true
    };
    repStateProperties[repStates.WebAck16] = {
        Name: 'WebAck16',
        StateIcon: 'fa-check-circle',
        IconColor: '#16a085',
        StateColor: '#16a085',
        RowColor: '#A0FFA0',
        IsAck: true
    };
    repStateProperties[repStates.OpcAck] = {
        Name: 'OpcAck',
        Description: 'Acknowledged by Opc User',
        IconColor: '#16a085',
        StateIcon: 'fa-check-circle',
        StateColor: '#16a085',
        RowColor: '#A0FFA0',
        IsAck: true
    };
    repStateProperties[repStates.InputDisabled] = {
        Name: 'Input Disabled'
    };
    repStateProperties[repStates.s16] = {
        Name: 'RepState 16',
        IsAck: true
    };
    repStateProperties[repStates.UnitNotFound] = {
        Name: 'Unit Not Found',
        StateIcon: 'fa-times-circle',
        StateColor: '#e75a5a',
        RowColor: '#FF4040'
    };
    repStateProperties[repStates.ServiceMode] = {
        Name: 'ServiceMode',
        StateIcon: 'fa-minus-circle',
        StateColor: '#FFD800',
        RowColor: '#A0FFA0'
    };
    repStateProperties[repStates.NoActiveConditions] = {
        Name: 'NoActiveConditions',
        StateIcon: 'fa-minus-circle',
        StateColor: 'black'
    };
    repStateProperties[repStates.SwingerMode] = {
        Name: 'SwingerMode'
    };
    repStateProperties[repStates.UnitDisabled] = {
        Name: 'UnitDisabled'
    };
    repStateProperties[repStates.AcFailureOverride] = {
        Name: 'AcFailureOverride'
    };
    repStateProperties[repStates.AbortedByPrescript] = {
        Name: 'AbortedByPrescript'
    };

    ctrl.getStateIcon = function (repState) {
        if (repStateProperties[repState] === null || repStateProperties[repState] === undefined) return '';
        var icon = repStateProperties[repState].StateIcon || 'fa-minus-circle';
        var color = repStateProperties[repState].StateColor || 'blue';
        return $sce.trustAsHtml("<i class='fa " + icon + "' style='color:" + color + "; font-size: 20px;'></i>");
    };

    ctrl.getAdditionalRepStateDesc = function (item) {
        if (repStateProperties[item.repState] === null || repStateProperties[item.repState] === undefined) return '';
        if (!repStateProperties[item.repState].IsAck) return '';
        return $filter('number')((new Date(item.cycleEnd).getTime() - new Date(item.arrivalDateTime).getTime()) / 1000 / 60, 1);
    };

    //Get my icon based on my title
    ctrl.getIcon = function (varTitle, varMode) {
        return sharedSetupService.getIcon(varTitle, varMode);
    };

    ctrl.translatedResult = function (desc) {
        if (desc) return ctrl.translation.text[desc.toUpperCase().replace(/ /g, "_")];
        return undefined;
    };

    ctrl.dateAgentText = function (date) {
        return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, ctrl.accountInfo.preferenceUser.timeFormat);
    };

    ctrl.getNameDispatch = function (dispatchItem) {
        if (!dispatchItem.fName) return "Unknown Deleted User";
        return dispatchItem.fName + " " + dispatchItem.lName;
    };

    ctrl.getDispatchIcon = function (dispatch) {
        switch (dispatch.notifyType) {
            case 2:
                return "<i class='fa fa-envelope fa-lg'></i>";
            // case 3:
            //     return "<i class='fa fa-square fa-lg'></i>";
            // case 3:
            //     return "<i class='fa fa-commenting-o fa-lg'></i>";
            case 4:
                return "<i class='fa fa-fax fa-lg'></i>";
            case 5:
            case 6:
            case 7:
            case 8:
                return "<i class='fa fa-square fa-lg'></i>";
            case 9:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case repStates.OpcAck:
                return "<i class='fa fa-phone fa-lg'></i>";
            case 18:
                return "<i class='fa fa-commenting-o fa-lg'></i>";
            default:
                return "";
        }
    };

    //Handle UI Scroll event
    element.on('scroll', function (event) {
        var $rowFirst = element.contents().find("tr:first");
        var $rowLast = element.contents().find("tr:last");
        var _firstRow = $rowFirst.attr("name");
        if (typeof $rowFirst.position() !== "undefined") {
            ctrl.infiniteScrollOn = true;ctrl.infiniteScrollUpOn = true;ctrl.infiniteScrollDownOn = true;

            var _tableTop = element.offset().top;
            var _rowTop = $rowFirst.offset().top;
            _setLiveDataStatus(_firstRow, _tableTop < _rowTop + 10);

            previousScrollbarPosition = currentScrollbarPosition;
            currentScrollbarPosition = element[0].scrollTop;
        }

        if (ctrl.infiniteScrollOn === true) {
            ctrl.unregisterListeners();
            ctrl.infiniteScrollUpOn = true;
            ctrl.infiniteScrollDownOn = true;

            if (ctrl.infiniteScrollDownOn === true && element[0].scrollTop + element[0].offsetHeight + 5 > element[0].scrollHeight) {
                $rowLast.addClass("active-row");
                ctrl.AlarmHistoryFactory.alerts = [];
                ctrl.AlarmHistoryFactory.nextPage();
            }
            if (ctrl.infiniteScrollUpOn === true && element[0].scrollTop < 5 && currentScrollbarPosition < previousScrollbarPosition) {
                $rowFirst.addClass("active-row");
                ctrl.AlarmHistoryFactory.alerts = [];
                ctrl.AlarmHistoryFactory.previousPage();
            }

            $timeout(function () {
                ctrl.registerListeners();
            }, 3000);
        }

        var rows = element.children().children().children().children();
        var scrollpos = 40;
        var start = 0;
        var end = rows.length;
        var count = 0;

        while (start !== end) {
            count++;
            var mid = start + Math.floor((end - start) / 2);
            if ($(rows[mid]).position().top < scrollpos) start = mid + 1;else end = mid;
        }
        _updateZoom(parseFloat($($(rows[start])).attr("name")));
    });

    $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
        _autoScroll();
        ctrl.checkFirstRowLiveStatus = null;
    });

    //Handle Alarm Ack Event
    $scope.$on('web_ack_alarm', function (e, repId, username, end) {
        var idx = _.findIndex(ctrl.AlarmHistoryFactory.items, function (alarm) {
            return alarm.reportID === repId;
        });

        if (idx !== -1) {
            ctrl.AlarmHistoryFactory.items[idx].ackName = 'Web: ' + username;
            ctrl.AlarmHistoryFactory.items[idx].repStateDesc = null;
            ctrl.AlarmHistoryFactory.items[idx].cycleEnd = end;
            ctrl.AlarmHistoryFactory.items[idx].repState = 11;
        }
    });

    $scope.$on("$destroy", function () {
        if ($scope.curAudio) {
            $scope.curAudio.pause();
            $scope.curAudio.currentTime = 0;
        }
        //_unRegisterListener();
    });

    var getIconSetNums = function getIconSetNums() {
        var iconSetCount = 0;
        for (var i = 0; i < ctrl.dispatchHistory.length; i++) {
            var innerCount = 0;
            switch (ctrl.dispatchHistory[i].notifyType) {
                case 5:
                case 6:
                case 9:
                    if (ctrl.dispatchHistory[i].resultTimeDate > new Date('4/20/2005')) {
                        innerCount++;
                        if (dispatch.tries > 1) innerCount++;
                    }
                    break;
                case 7:
                    if (ctrl.dispatchHistory[i].resultTimeDate > new Date('4/20/2005')) innerCount++;
                    break;
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case repStates.OpcAck:
                    if (ctrl.dispatchHistory[i].sessionID) innerCount++;
                    break;
            }

            if (innerCount > iconSetCount) iconSetCount = innerCount;
        }

        return iconSetCount;
    };

    var _updateZoom = function _updateZoom(currentRow) {
        if (isNaN(currentRow)) return;
        var zoomMin = currentRow - paddingZoom;
        var zoomMax = currentRow + paddingZoom;
        var dateMin = $scope.stickyProperties.dateMin;
        var dateMax = $scope.stickyProperties.dateMax;
        if (zoomMin < $scope.stickyProperties.dateMin) dateMin = zoomMin;
        if (zoomMax > $scope.stickyProperties.dateMax) dateMax = zoomMax;
        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMin: dateMin, dataMax: dateMax, zoomMin: zoomMin, zoomMax: zoomMax, windowId: $scope.windowId });
    };

    var _setLiveDataStatus = function _setLiveDataStatus(firstRow, liveDataStatusOn) {
        if (ctrl.checkFirstRowLiveStatus === true) {
            _checkTopOffset(liveDataStatusOn);
        } else if (ctrl.checkFirstRowLiveStatus === null) {
            timeLapseService.getLocalDateTime().then(function (result) {
                if (parseFloat(firstRow) + parseFloat(ctrl.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                    ctrl.checkFirstRowLiveStatus = true;
                    _checkTopOffset(liveDataStatusOn);
                } else {
                    ctrl.checkFirstRowLiveStatus = false;
                }
            });
        }
    };

    var _checkTopOffset = function _checkTopOffset(liveDataStatusOn) {
        if (liveDataStatusOn) {
            //_registerListener();
        } else {
                //_unRegisterListener();
            }
    };

    var _autoScroll = function _autoScroll() {
        if (ctrl.AlarmHistoryFactory.numberOfNewRecordsPrevious > 0) {
            //each alarm renders two <tr> (the row and its dispatch detail row), so the row that was first
            //before the newer records were added is at index numberOfNewRecordsPrevious * 2
            var trRow = element.find('tr').eq(ctrl.AlarmHistoryFactory.numberOfNewRecordsPrevious * 2);
            var rowTop = trRow.length > 0 ? trRow.offset().top - element.offset().top + element[0].scrollTop : 0;
            //keep scrollTop above 5 so the scroll-up trigger is not fired again straight away
            element.scrollTop(Math.max(rowTop - 90, 6));
        } else if (element[0].scrollTop <= 1) {
            element.animate({
                scrollTop: element.scrollTop() + 2
            }, 500);
        }
    };

    ctrl.dynamicPopover = {
        content: 'Hello, World!',
        templateUrl: 'alarmPopoverTemplate.html',
        title: 'Title'
    };

    ctrl.getAudioIcons = function (dispatch) {
        var audio = "";
        switch (dispatch.notifyType) {
            case 5:
            case 6:
            case 7:
            case 9:
                if (dispatch.resultTimeDate > new Date('4/20/2005')) {
                    audio = " <a title='Play First Attempt' style='margin-right: 5px'>" + "<i class='fa fa-volume-up fa-lg' aria-hidden='true'></i></a>" + "<a href='/recwaves/mp3_files/Out_" + dispatch.notifyID + ".wav' " + "target='_blank' download='/recwaves/mp3_files/Out_" + dispatch.notifyID + ".wav' " + "title='Save First Attempt'>" + "<i class='fa fa-floppy-o fa-lg' aria-hidden='true'></i></a>";

                    if (dispatch.notifyType !== 7 && dispatch.tries > 1) {
                        audio += " <a title='Play Second Attempt'>" + "<i class='fa fa-volume-up fa-lg' aria-hidden='true'></i></a>" + "<a href='/recwaves/mp3_files/Out_" + dispatch.notifyID + "R.wav' " + "target='_blank' download='/recwaves/mp3_files/Out_" + dispatch.notifyID + ".wav' " + "title='Save Second Attempt'>" + "<i class='fa fa-floppy-o fa-lg' aria-hidden='true'></i></a>";
                    }
                }
                break;
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
                if (dispatch.sessionID) {
                    // if (typeof $scope.audio === "undefined" || $scope.audio === null)
                    //     $scope.audio = ngAudio.load('/recwaves/mp3_files/' + dispatch.sessionID);
                    audio = " <a style='margin-right: 5px' title='" + dispatch.sessionID + "'>" + "<i class='fa fa-volume-up fa-lg' aria-hidden='true' " + "ng-click='$ctrl.playAudio(dispatch.sessionID)'></i></a>" + "<a href='/recwaves/mp3_files/" + dispatch.sessionID + "' " + "target='_blank' download='/recwaves/mp3_files/" + dispatch.sessionID + ".wav' " + "title='Save File'><i class='fa fa-floppy-o fa-lg' aria-hidden='true'></i></a>";
                }
                break;
        }
        return $sce.trustAsHtml(audio);
    };

    ctrl.playAudio = function (sessionId) {
        if ($scope.curSess !== sessionId) {
            if ($scope.curAudio) {
                $scope.curAudio.pause();
                $scope.curAudio.currentTime = 0;
            }

            $scope.curSess = sessionId;
            //$scope.curAudio = new Audio('http://123scada.com/recwaves/mp3_files/' + sessionID);
            $scope.curAudio = new Audio('/recwaves/mp3_files/' + sessionId);
            $scope.curAudio.play();
        } else {
            if ($scope.curAudio.currentTime !== 0) {
                $scope.curAudio.pause();
                $scope.curAudio.currentTime = 0;
            } else {
                $scope.curAudio.play();
            }
        }
    };

    ctrl.momentFormat = function (date) {
        return moment(date).format('MM/DD/YYYY, h:mm:ss a');
    };

    ctrl.toggleDispatch = function (item) {
        if (ctrl.dispatchLoading || !(item.notifyCount > 0)) return;
        var oldState = item.showDispatch;

        for (var i = 0; i < ctrl.AlarmHistoryFactory.items.length; i++) {
            ctrl.AlarmHistoryFactory.items[i].showDispatch = false;
        }

        if (!oldState) {
            ctrl.dispatchHistory.length = 0;
            ctrl.dispatchLoading = true;
            //We want the 'loading' and the data to be wiped on the digest cycle PRIOR to showing the new dispatch detail row to prevent ugly collapse behavior, hence the timeout
            $timeout(function () {
                item.showDispatch = true;
            });

            $timeout(function () {
                ctrl.AlarmHistoryFactory.getDispatchHistory(item.reportID).then(function (resp) {
                    if (typeof $scope.audio !== "undefined" && $scope.audio !== null) $scope.audio.pause();
                    $scope.audio = null;
                    ctrl.dispatchHistory = resp.data;
                    $scope.audioIconPlaceholders = getIconSetNums();
                    ctrl.dispatchLoading = false;
                });
            }, 200);
        }
    };

    ctrl.ackAlarm = function ($event, repState, reportId) {
        if (repState === 2 || repState === 6) {
            $event.stopPropagation();
            ctrl.AlarmHistoryFactory.webAckAlarm(ctrl.accountInfo.userId, ctrl.accountInfo.userName, reportId).then(function (resp) {
                $rootScope.$broadcast('web_ack_alarm', reportId, ctrl.accountInfo.userName, resp.data);
                toaster.pop('success', $scope.windowTitle, ctrl.translation.message.ACK_ALARM_SUCCESS);
            });
        }
    };

    //ToDo: This should be a common global fn somewhere
    ctrl.millisecondsToStr = function (item) {

        if (!repStateProperties[item.RepState].IsAck) return null;

        var milliseconds = new Date(item.cycleEnd).getTime() - new Date(item.arrivalDateTime).getTime();

        if (milliseconds > 0) {
            var numberEnding = function numberEnding(number) {
                return number > 1 ? 's' : '';
            };

            var temp = Math.floor(milliseconds / 1000);
            var years = Math.floor(temp / 31536000);
            if (years) {
                return years + ' ' + ctrl.translation.text.YEAR + numberEnding(years);
            }

            var days = Math.floor((temp %= 31536000) / 86400);
            if (days) {
                var totalSeconds = (new Date(item.cycleEnd).getTime() - new Date(item.arrivalDateTime).getTime()) / 1000;
                var daysRounded = Math.round(totalSeconds / 86400 * 10) / 10; //days rounded to the nearest tenth 
                return daysRounded + ' ' + ctrl.translation.text.DAY + numberEnding(days);
            }

            var hours = Math.floor((temp %= 86400) / 3600);
            if (hours) {
                var _totalSeconds = (new Date(item.cycleEnd).getTime() - new Date(item.arrivalDateTime).getTime()) / 1000;
                var hoursRounded = Math.round(_totalSeconds / 3600 * 10) / 10; //hours rounded to the nearest tenth 
                return hoursRounded + ' ' + ctrl.translation.text.HOUR + numberEnding(hours);
            }

            var minutes = Math.floor((temp %= 3600) / 60);
            if (minutes) {
                var _totalSeconds2 = (new Date(item.cycleEnd).getTime() - new Date(item.arrivalDateTime).getTime()) / 1000;
                var totalMinutes = (_totalSeconds2 / 60).toFixed(1); //minutes fixed to the tenths place
                return totalMinutes + ' ' + ctrl.translation.text.MINUTE + numberEnding(minutes);
            }

            var seconds = temp % 60;
            if (seconds) {
                return seconds + ' ' + ctrl.translation.text.SECOND + numberEnding(seconds);
            }

            return ctrl.translation.text.LESS_THAN_A_SECOND;
        } else {
            //TODO: Does a duration of '0' make sense? Should it say something else?
            return null;
        }
    };

    $scope.$watch('lastUpdateAt', function (newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
            $scope.liveDataIn = !$scope.liveDataIn;
            $timeout(function () {
                $scope.liveDataIn = !$scope.liveDataIn;
            }, 3000);
        }
    }, true);

    $scope.$watch('$ctrl.AlarmHistoryFactory.alerts', function (newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
            ctrl.alerts = newValue;
        }
    }, true);

    $scope.$on('updatePreferencesLanguage', function (e, translation, langId) {
        if (ctrl.alerts.length > 0) {
            var _msg = eval("ctrl.translation.message." + ctrl.alerts[0].languageCode.toUpperCase());
            var _type = ctrl.alerts[0].type;
            var _languageCode = ctrl.alerts[0].languageCode;
            if (_languageCode.toUpperCase() === 'NO_DATA') {
                var start = !ctrl.AlarmHistoryFactory.start ? moment(ctrl.AlarmHistoryFactory.end).subtract(6, 'months').utc().format('MM/DD/YY, h:mm:ss a') : moment(ctrl.AlarmHistoryFactory.start).utc().format('MM/DD/YY, h:mm:ss a');
                _msg += ': ' + start + ' - ' + moment(ctrl.AlarmHistoryFactory.end).utc().format('MM/DD/YY, h:mm:ss a');
            }
            ctrl.alerts = [];
            ctrl.alerts.push({ msg: _msg, type: _type, languageCode: _languageCode });
        }
        //Update Translations for sort status Display popover
        ctrl.getStatusList();
    });

    $scope.$watch('$ctrl.AlarmHistoryFactory.filter', function (newVal, oldVal) {
        if (!(JSON.stringify(newVal) === JSON.stringify(oldVal))) {
            //Wipe the existing table data
            //TODO: Blech, this feels wrong, but for some reason wiping the arrow is triggering the scroll listener?
            ctrl.infiniteScrollOn = false;
            ctrl.AlarmHistoryFactory.items.length = 0;
            ctrl.AlarmHistoryFactory.end = '19000101';

            currentScrollbarPosition = 0;
            previousScrollbarPosition = 0;
            ctrl.checkFirstRowLiveStatus = null;

            ctrl.AlarmHistoryFactory.customerId = ctrl.accountInfo.customerId;

            //When the filter changes...
            //If the user selected a specific date to use, continue to use it
            if (ctrl.myDate) {
                ctrl.selectMyDate();
            } else {
                //Otherwise refresh the data based on right now
                timeLapseService.getLocalDateTime().then(function (result) {
                    /////////////////////////////////////////////////////////////
                    var newDate = new Date(result.data.localDateTime);
                    newDate.setHours(0, 0, 0, 0);
                    var endDate = new Date(newDate.getTime() + 3 * 86400000);
                    ctrl.AlarmHistoryFactory.end = datetimeService.dateToUnixtime(endDate);
                    sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: ctrl.AlarmHistoryFactory.end, windowId: $scope.windowId });
                    /////////////////////////////////////////////////////////////
                    ctrl.AlarmHistoryFactory.nextPage();
                });
            }
        }
    }, true);

    $scope.$on("$destroy", function () {
        ctrl.unregisterListeners();
    });

    ctrl.wsDataReceivedRTUBASICINFOSETTING = function (data) {
        if (data.Type == 'DEVICEBASICINFO') {
            for (var i = 0; i < ctrl.AlarmHistoryFactory.items.length; i++) {
                if (ctrl.AlarmHistoryFactory.items[i].serialNumber == data.SN && data.Value.path == "name") {
                    ctrl.AlarmHistoryFactory.items[i].deviceName = data.Value.value;
                }
            }
        }
    };

    ctrl.registerListeners = function () {
        if (ctrl.AlarmHistoryFactory.items.length > 0) {
            websocketService.connect();
            for (var i = 0; i < ctrl.AlarmHistoryFactory.items.length; i++) {
                websocketService.register("DEVICEBASICINFO", ctrl.AlarmHistoryFactory.items[i].serialNumber, 0, ctrl.wsDataReceivedRTUBASICINFOSETTING, null);
            }
        } else {
            $timeout(function () {
                ctrl.registerListeners();
            }, 1000);
        }
    };

    ctrl.unregisterListeners = function () {
        for (var k = 0; k < ctrl.AlarmHistoryFactory.items.length; k++) {
            websocketService.unRegister("DEVICEBASICINFO", ctrl.AlarmHistoryFactory.items[k].serialNumber, 0, ctrl.wsDataReceivedRTUBASICINFOSETTING, null);
        }
    };

    ctrl.refreshLiveData = function () {
        ctrl.myDate = null;
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.selectMyDate();
    };

    ctrl.selectMyDate = function () {
        //ctrl.AlarmHistoryFactory = new AlarmHistoryFactory();
        ctrl.unregisterListeners();
        ctrl.AlarmHistoryFactory.items.length = 0;
        ctrl.AlarmHistoryFactory.finalItems.length = 0;
        ctrl.AlarmHistoryFactory.end = null;
        /////////////////////////////////////////////////////////////
        currentScrollbarPosition = 0;
        previousScrollbarPosition = 0;
        ctrl.checkFirstRowLiveStatus = null;
        //_unRegisterListener();
        /////////////////////////////////////////////////////////////

        var tmpDates = ctrl.myDate == null ? new Date() : ctrl.myDate;

        var tmpDatesA = tmpDates;
        var safeEndDate = void 0;
        tmpDates.setHours(0, 0, 0, 0);
        tmpDates = datetimeService.dateToUnixtime(tmpDates);
        tmpDates = datetimeService.getNewStartEndDates(tmpDates, 0);
        tmpDatesA.setHours(23, 59, 59, 999);
        tmpDatesA = datetimeService.dateToUnixtime(tmpDatesA);
        /////////////////////////////////////////////////////////////
        if (new Date(ctrl.myDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
            ctrl.AlarmHistoryFactory.end = tmpDatesA;
            safeEndDate = tmpDatesA;
        } else {
            ctrl.AlarmHistoryFactory.end = tmpDates.endDate;
            safeEndDate = tmpDates.endDate;
        }
        /////////////////////////////////////////////////////////////
        ctrl.AlarmHistoryFactory.startRow = 1;
        ctrl.AlarmHistoryFactory.pageSize = 50;
        ctrl.AlarmHistoryFactory.customerId = ctrl.accountInfo.customerId;
        ctrl.alerts = [];
        ctrl.AlarmHistoryFactory.nextPage();

        $timeout(function () {
            ctrl.registerListeners();
        }, 3000);
        /////////////////////////////////////////////////////////////
        sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: safeEndDate, zoomMin: tmpDates.startDate + ctrl.unixDay, zoomMax: tmpDates.endDate - ctrl.unixDay, windowId: $scope.windowId });
    };

    var getAlarmHistory = function getAlarmHistory() {
        /////////////////////////////////////////////////////////////
        currentScrollbarPosition = 0;
        previousScrollbarPosition = 0;
        ctrl.checkFirstRowLiveStatus = null;
        $scope.lastAnalogSourceLive = {};
        /////////////////////////////////////////////////////////////
        ctrl.AlarmHistoryFactory = new AlarmHistoryFactory();
        ctrl.AlarmHistoryFactory.customerId = ctrl.accountInfo.customerId;
        ctrl.AlarmHistoryFactory.startRow = 1;
        ctrl.AlarmHistoryFactory.pageSize = 50;
        ctrl.AlarmHistoryFactory.lang = ctrl.prefLang === 'fr' ? 2 : 1;
        ctrl.AlarmHistoryFactory.filterCol = false;
        ctrl.alerts = [];
        ctrl.getStatusList();

        // in RTU View when clicked on Dispatch icon the Alarm History Report 
        // should open with filter having device selected
        if (ctrl.stickyProperties && ctrl.stickyProperties.deviceId) {
            var deviceObj = ctrl.deviceData.find(function (item) {
                return item.id == ctrl.stickyProperties.deviceId;
            });
            if (deviceObj) {
                ctrl.AlarmHistoryFactory.filterDeviceId = deviceObj.id;
                angular.extend(ctrl.deviceModel, { id: deviceObj.id });
                ctrl.deviceModelLength = ctrl.deviceModel.length;
            }
        }

        sharedSetupService.setStickyProperties($scope.stickyProperties, { windowId: $scope.windowId });
        if ($scope.stickyProperties.savedDesktop === true && $scope.stickyProperties.on === true || $scope.classicView) {
            $scope.savedDesktopRow = $scope.stickyProperties.zoomMax;
            $scope.stickyProperties.on = true;
            $scope.stickyProperties.savedDesktop = false;
            ctrl.AlarmHistoryFactory.pageSize = 500;
            if ($scope.currentBrowser === "ie") ctrl.AlarmHistoryFactory.pageSize = 100;
            ctrl.AlarmHistoryFactory.end = $scope.stickyProperties.dateMax;
            ctrl.AlarmHistoryFactory.nextPage();
        } else if ($scope.stickyProperties.on !== null && $scope.stickyProperties.zoomMin !== null) {
            //doesn't work well - need to check
            $scope.stickyProperties.on = true;
            timeLapseService.getLocalDateTime().then(function (result) {
                if ($scope.stickyProperties.dateMax >= parseFloat(result.data.unixTimeStamp) && $scope.stickyProperties.zoomMax + parseFloat(ctrl.liveDataOffset) >= parseFloat(result.data.unixTimeStamp)) {
                    ctrl.AlarmHistoryFactory.end = $scope.stickyProperties.dateMax;
                } else {
                    ctrl.AlarmHistoryFactory.end = Math.round(($scope.stickyProperties.zoomMax + $scope.stickyProperties.zoomMin) / 2);
                }
                ctrl.AlarmHistoryFactory.nextPage();
            });
        } else {
            $scope.stickyProperties.on = false;
            timeLapseService.getLocalDateTime().then(function (result) {
                /////////////////////////////////////////////////////////////
                var newDate = new Date(result.data.localDateTime);
                newDate.setHours(0, 0, 0, 0);
                var endDate = new Date(newDate.getTime() + 3 * 86400000);
                ctrl.AlarmHistoryFactory.end = datetimeService.dateToUnixtime(endDate);
                sharedSetupService.setStickyProperties($scope.stickyProperties, { dataMax: ctrl.AlarmHistoryFactory.end, windowId: $scope.windowId });
                /////////////////////////////////////////////////////////////
                ctrl.AlarmHistoryFactory.nextPage();

                $timeout(function () {
                    if (ctrl.AlarmHistoryFactory.items.length == 0) {
                        ctrl.AlarmHistoryFactory.end = null;
                        ctrl.AlarmHistoryFactory.busy = false;
                        ctrl.AlarmHistoryFactory.nextPage();
                    }
                }, 5000);
            });
        }
        $timeout(function () {
            ctrl.registerListeners();
        }, 3000);
    };
    //List of all Statuses available for Display Filter
    ctrl.getStatusList = function () {
        ctrl.statusList = [{ model: 'acknowledged', translation: ctrl.translation.text.ACKNOWLEDGED, icon: "fa fa-check-circle", color: "#16a085" }, { model: 'unacknowledged', translation: ctrl.translation.text.UNACKNOWLEDGED, icon: "fa fa-times-circle", color: "#e75a5a" }, { model: 'service', translation: ctrl.translation.text.SERVICE_MODE, icon: "fa fa-minus-circle", color: "#FFD800" }, { model: 'disabled', translation: ctrl.translation.text.DISABLED + "/" + ctrl.translation.text.ABORTED, icon: "fa fa-minus-circle", color: "blue" }, { model: 'noDestinations', translation: ctrl.translation.text.NO_DESTINATIONS, icon: "fa fa-minus-circle", color: "black" }];
    };

    ctrl.savePdf = function () {

        var windowTitle = $scope.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: ctrl.translation.text.ALARM_HISTORY,
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element,
            columnStyles: {
                0: { columnWidth: 70 },
                1: { columnWidth: 100 },
                3: { columnWidth: 120 },
                4: { columnWidth: 60 }
            }
        };

        savePdfService.savePDF(pdfParams);
    };
};

AlarmHistoryController.$inject = ['_', '$scope', '$rootScope', '$sce', '$filter', 'AlarmHistoryFactory', 'sharedSetupService', 'openViewService', 'translationService', 'timeLapseService', '$timeout', 'authenticationService', 'datetimeService', 'ngAudio', 'toaster', '$element', 'savePdfService', 'websocketService', 'deviceMenuService'];
'use strict';

angular.module('mc.alarm-history').component('alarmHistory', {
    controller: AlarmHistoryController,
    templateUrl: 'ui/alarmhistory/alarm-history-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.all-devices-runtime-data", []);
"use strict";

function AllDevicesRuntimeDataFactory($http, HOST) {
    var AllDevicesRuntimeDataFactory = {};
    var _getData = function _getData(customerId, startRow, pageSize) {
        return $http({
            method: 'GET',
            url: HOST + "/api/PumpTable?customerId=" + customerId + "&startRow=" + startRow + "&pageSize=" + pageSize
        });
    };

    AllDevicesRuntimeDataFactory.getData = _getData;
    return AllDevicesRuntimeDataFactory;
}

AllDevicesRuntimeDataFactory.$inject = ['$http', 'REPORTS'];

angular.module('mc.all-devices-runtime-data').factory('AllDevicesRuntimeDataFactory', AllDevicesRuntimeDataFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AllDevicesRuntimeDataController($, $rootScope, $scope, $location, authenticationService, translationService, sharedSetupService, openViewService, AllDevicesRuntimeDataFactory, debounceService) {
    var ctrl = this;
    $scope.alerts = [];

    ctrl.startRow = 1;
    ctrl.pageSize = 5;
    ctrl.items = [];
    ctrl.numberOfReturnedRecords = -1;
    ctrl.currentPage = 1;
    ctrl.totalPages = 0;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        ctrl.mobile = $rootScope.mobile; //need for
        ctrl.classicView = $rootScope.classicView; //need for

        ctrl.translation = translationService.translation;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = ctrl.stickyPropertiesInterface;

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                if ($scope.popup.parent().length > 0) {
                    $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                    $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                    $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                    $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                }
            };
        }

        ctrl.getAllData();
    };

    ctrl.getAllData = function () {
        ctrl.loading = true;
        AllDevicesRuntimeDataFactory.getData(ctrl.accountInfo.customerId, ctrl.startRow, ctrl.pageSize).then(function (dataFromFactory) {
            ctrl.loading = false;
            $scope.alerts = [];

            ctrl.items = dataFromFactory.data.allDevicesPumpTable;
            ctrl.totalPages = Math.ceil(dataFromFactory.data.deviceCount / ctrl.pageSize);
            ctrl.numberOfReturnedRecords = dataFromFactory.data.allDevicesPumpTable.length;

            if (ctrl.items.length > 0) {
                ctrl.showScrollX = ctrl.items.some(function (item) {
                    return item.setting && item.setting.length > 4;
                });
            }

            ctrl.items.forEach(function (allDevice) {
                // cache runtimeDataList
                allDevice.runtimeDataListCache = ctrl.runtimeDataList(allDevice.setting, allDevice.device);

                // cache processed pumpMeasurements
                allDevice.processedPumpData = ctrl.processData(allDevice.pumpMeasurements);

                // cache totals for each channel index
                allDevice.totalMinutesCache = allDevice.runtimeDataListCache.map(function (_, index) {
                    return ctrl.getTotalMinutesBasedOnCol(allDevice.pumpMeasurements, index);
                });
            });

            // If we didn't get any items back 
            if (dataFromFactory.data.allDevicesPumpTable.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        });
    };

    ctrl.debounceGetAllData = debounceService(ctrl.getAllData, 1000, false);

    ctrl.processData = function (entries) {
        var result = {};
        entries.forEach(function (entry) {
            // Extract the date (YYYY-MM-DD) from localDateTime
            var dateKey = entry.localDateTimeStart.split("T")[0] + "T00:00:00";
            // If the date key doesn't exist, initialize it
            if (!result[dateKey]) {
                result[dateKey] = [];
            }
            // Push entry into the respective date array
            result[dateKey].push(entry);
        });
        return Object.keys(result).length == 0 ? null : result;
    };

    ctrl.runtimeDataList = function (setting, device) {
        if (!setting || setting.length === 0) return setting;
        for (var i = 0; i < setting.length; i++) {
            //logic to determine whether it is Multiple or Simultaneous column
            //if device is 800 series, channel 8 as Alarm (inputMode = 'A') --> Multiple
            //OR for all other devices (mostly 100 series), channel 3 description as 'both' --> Simultaneous
            if ([5, 9, 19].indexOf(device.type) > -1 && setting[i].channel === 8 && setting[i].digitalMode === 'A') setting[i].description = ctrl.translation.text.MULTIPLE;else if (setting[i].channel === 3 && setting[i].description === 'both') setting[i].description = ctrl.translation.text.SIMULTANEOUS;
        }
        return setting;
    };

    ctrl.getTotalMinutesBasedOnCol = function (entries, index) {
        var result = entries.reduce(function (sum, row) {
            return sum + (row.runtime[index].value || 0);
        }, 0); // Initialize sum as 0
        return result;
    };

    ctrl.calculateTotals = function (dataArray) {
        if (!dataArray || dataArray.length === 0) {
            return [];
        }

        // Get the number of columns (based on the first item's runtime array length)
        var numColumns = dataArray[0].runtime.length;

        // Initialize an array of zeros for the totals of each column
        var totals = new Array(numColumns).fill(0);

        // Loop through each item (row) in the data array
        dataArray.forEach(function (item) {
            if (item.runtime) {
                // Loop through each runtime data entry in the row (column)
                item.runtime.forEach(function (runtimeData, index) {
                    var value = runtimeData.value;
                    // Add the value to the corresponding column's total
                    if (typeof value === 'number') {
                        totals[index] += value;
                    }
                });
            }
        });

        return totals;
    };

    ctrl.setPage = function (page) {
        if (ctrl.currentPage != page) {
            ctrl.currentPage = page;
            ctrl.setStartRow();
        }
    };

    ctrl.prevPage = function () {
        if (ctrl.currentPage > 1) {
            ctrl.currentPage--;
            ctrl.setStartRow();
        }
    };

    ctrl.nextPage = function () {
        if (ctrl.currentPage < ctrl.totalPages) {
            ctrl.currentPage++;
            ctrl.setStartRow();
        }
    };

    ctrl.getPageButtons = function () {
        var buttons = [];
        var start = Math.max(1, ctrl.currentPage - 2);
        var end = Math.min(ctrl.totalPages, start + 4);

        // If we are at the end, shift start back to still show 3 buttons
        if (end - start < 4 && start > 1) {
            start = Math.max(1, end - 4);
        }

        for (var i = start; i <= end; i++) {
            buttons.push(i);
        }

        return buttons;
    };

    ctrl.setStartRow = function () {
        ctrl.startRow = (ctrl.currentPage - 1) * ctrl.pageSize + 1;
        this.debounceGetAllData();
    };

    ctrl.openPumpDataViewByDevice = function (item, varUrl, tabName) {
        sharedSetupService.setStickyProperties(ctrl.stickyProperties, { deviceId: item.deviceId, dataFormat: "H", runtimeType: "R", windowId: $scope.windowId });
        if (!ctrl.mobile && !ctrl.classicView) {
            openViewService.openView(tabName, { width: 625, height: 500 }, undefined, ctrl.stickyProperties, { minimumWidth: 350, minimumHeight: 350 });
        } else {
            var mobileStickyProperties = sharedSetupService.stickyPropertiesInterface;
            mobileStickyProperties.deviceId = item.deviceId;
            mobileStickyProperties.device = { deviceId: item.deviceId };
            $location.path(varUrl);
        }
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.getAllData();
    });

    $scope.$on("$destroy", function () {});
};

AllDevicesRuntimeDataController.$inject = ['$', '$rootScope', '$scope', '$location', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'AllDevicesRuntimeDataFactory', 'debounceService'];
'use strict';

angular.module('mc.all-devices-runtime-data').component('allDevicesRuntimeData', {
    controller: AllDevicesRuntimeDataController,
    templateUrl: 'ui/alldevicesruntimedata/all-devices-runtimedata-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.all-devices-pulseflow", []);
"use strict";

angular.module("mc.all-devices-digital", []);
"use strict";

function AllDevicesPulseflowFactory($http, HOST) {
    var AllDevicesPulseflowFactory = {};
    var _getData = function _getData(customerId, startRow, pageSize, start, end) {
        return $http({
            method: 'GET',
            url: HOST + "/api/PulseFlowTable?customerId=" + customerId + "&startRow=" + startRow + "&pageSize=" + pageSize + "&startDate=" + start + "&endDate=" + end
        });
    };

    AllDevicesPulseflowFactory.getData = _getData;
    return AllDevicesPulseflowFactory;
}

AllDevicesPulseflowFactory.$inject = ['$http', 'REPORTS'];

angular.module('mc.all-devices-digital').factory('AllDevicesPulseflowFactory', AllDevicesPulseflowFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AllDevicesPulseflowController(_, $, $rootScope, $scope, $sce, $location, authenticationService, translationService, sharedSetupService, openViewService, AllDevicesPulseflowFactory, debounceService, timeLapseService, datetimeService) {
    var ctrl = this;
    $scope.alerts = [];

    ctrl.startRow = 1;
    ctrl.pageSize = 5;
    ctrl.items = [];
    ctrl.currentPage = 1;
    ctrl.totalPages = 0;
    ctrl.debounceTimeout;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        ctrl.mobile = $rootScope.mobile; //need for
        ctrl.classicView = $rootScope.classicView; //need for

        ctrl.translation = translationService.translation;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.preferredTimeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        ctrl.mcAdmin = sharedSetupService.mcAdmin();

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = ctrl.stickyPropertiesInterface;

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                if ($scope.popup.parent().length > 0) {
                    $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                    $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                    $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                    $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                }
            };
        }

        ctrl.getAllData();
    };

    ctrl.getAllData = function () {
        ctrl.loading = true;
        timeLapseService.getLocalDateTime().then(function (resp) {
            var result = resp.data;
            var newDate = new Date(result.localDateTime);
            newDate.setHours(0, 0, 0, 0);
            // startDate = 6 months before
            var startDate = new Date(newDate);
            startDate.setMonth(startDate.getMonth() - 6);
            // endDate = current date (or same as newDate)
            var endDate = new Date(newDate.getTime() + 3 * 86400000);

            var end = datetimeService.dateToUnixtime(endDate);
            var start = datetimeService.dateToUnixtime(startDate);
            AllDevicesPulseflowFactory.getData(ctrl.accountInfo.customerId, ctrl.startRow, ctrl.pageSize, start, end).then(function (dataFromFactory) {
                ctrl.loading = false;
                $scope.alerts = [];

                ctrl.items = dataFromFactory.data.allDevicesPulseFlowTable;
                ctrl.totalPages = Math.ceil(dataFromFactory.data.deviceCount / ctrl.pageSize);

                // If we didn't get any items back 
                if (dataFromFactory.data.allDevicesPulseFlowTable.length === 0) {
                    var errorMessage = ctrl.translation.text.NO_DATA;
                    $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
                }
            });
        });
    };

    ctrl.debounceGetAllData = debounceService(ctrl.getAllData, 1000, false);

    ctrl.setPage = function (page) {
        if (ctrl.currentPage != page) {
            ctrl.currentPage = page;
            ctrl.setStartRow();
        }
    };

    ctrl.prevPage = function () {
        if (ctrl.currentPage > 1) {
            ctrl.currentPage--;
            ctrl.setStartRow();
        }
    };

    ctrl.nextPage = function () {
        if (ctrl.currentPage < ctrl.totalPages) {
            ctrl.currentPage++;
            ctrl.setStartRow();
        }
    };

    ctrl.getPageButtons = function () {
        var buttons = [];
        var start = Math.max(1, ctrl.currentPage - 2);
        var end = Math.min(ctrl.totalPages, start + 4);

        // If we are at the end, shift start back to still show 3 buttons
        if (end - start < 4 && start > 1) {
            start = Math.max(1, end - 4);
        }

        for (var i = start; i <= end; i++) {
            buttons.push(i);
        }

        return buttons;
    };

    ctrl.setStartRow = function () {
        ctrl.startRow = (ctrl.currentPage - 1) * ctrl.pageSize + 1;
        ctrl.debounceGetAllData();
    };

    ctrl.openPulseflowViewByDevice = function (item, varUrl, tabName) {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = item.deviceId;
        optionsStickyProperties.zoomMin = item.lastHeardTime;

        if (ctrl.mobile || ctrl.classicView) {
            $location.path(varUrl);
        } else {
            openViewService.openView(tabName, { width: 625, height: 500 }, undefined, optionsStickyProperties);
        }
    };

    ctrl.hasChannel = function (settings, channel) {
        if (_.findIndex(settings, function (setting) {
            return setting.channel === channel;
        }) > -1) {
            return true;
        }

        return false;
    };

    ctrl.getDecimalPoints = function (setting) {
        if (setting && setting.flowScale < 1) {
            return 2;
        } else if (setting && setting.flowScale < 12) {
            return 1;
        }

        return 0;
    };

    // Toggle the active row when user clicks
    ctrl.toggle = function ($event) {
        if ($($event.currentTarget).hasClass('active-row')) {
            $($event.currentTarget).removeClass('active-row');
        } else {
            $($event.currentTarget).addClass('active-row');
        }
    };

    // dateAgentText filter called from html
    ctrl.dateAgentText = function (date, timeFormat) {
        return datetimeService.formatDateAgentText(date, 'yyyy-MM-ddTHH:mm:ss', false, timeFormat);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.preferredTimeFormat = parseInt(timeFormat, 10);
        ctrl.getAllData();
    });

    $scope.$on("$destroy", function () {});
}

AllDevicesPulseflowController.$inject = ['_', '$', '$rootScope', '$scope', '$sce', '$location', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'AllDevicesPulseflowFactory', 'debounceService', 'timeLapseService', 'datetimeService'];
'use strict';

angular.module('mc.all-devices-pulseflow').component('allDevicesPulseflow', {
    controller: AllDevicesPulseflowController,
    templateUrl: 'ui/alldevicespulseflow/all-devices-pulseflow-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.alert-history", []);
'use strict';

function AlertHistoryFactory(REPORTS, $http) {

    // instantiate our initial object
    var AlertHistory = function AlertHistory(customerId, startDate, endDate, timeZone, stickyProperties) {
        this.customerId = customerId;
        this.startDate = startDate;
        this.endDate = endDate;
        this.timeZone = timeZone;
        this.stickyProperties = stickyProperties;
    };

    AlertHistory.prototype.getData = function () {
        var self = this;
        return $http.get(REPORTS + '/api/AlertHistory' + '?customerId=' + this.customerId + '&startDate=' + this.startDate + '&endDate=' + this.endDate + '&timeZone=' + this.timeZone).then(function (response) {
            self.list = response.data;
            self.loading = false;
            return response;
        });
    };

    return AlertHistory;
}

AlertHistoryFactory.$inject = ['REPORTS', '$http'];

angular.module('mc.alarm-rule-test').factory('AlertHistoryFactory', AlertHistoryFactory);

//function AlertHistoryFactory(HOST, $http) {
//    class AlertHistory {
//        constructor(customerId, startDate, endDate, timeZone) {
//            this._list = [];
//            this._loading = false;
//            this._customerId = customerId;
//            $http.get(`${HOST}/api/AlertHistory?customerId=${customerId}&startDate=${startDate}&endDate=${endDate}&timeZone=${timeZone}`).then((resp) => {
//                this._list = resp.data;
//                this._loading = false;
//                return resp;
//            });
//        }

//        get list() {
//            return this._list;
//        }

//        get loading() {
//            return this._loading;
//        }
//    }
//    return AlertHistory;
//}

//AlertHistoryFactory.$inject = ['HOST', '$http'];

//angular.module('mc.alert-history').factory('AlertHistoryFactory', AlertHistoryFactory);
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AlertHistoryController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, datetimeService, AlertHistoryFactory, $timeout, $filter, $element, getDateRangeService, savePdfService, toaster) {
    var ctrl = this;
    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        ctrl.reverse = true;
        ctrl.savedAlert = null;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.translation = translationService.translation;
        ctrl.unixDay = sharedSetupService.unixDay;
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.showMsg = false;
        ctrl.goSelectReportData(false);
        ctrl.downloadViewTypeOptions = [0, 1, 2];

        if (!ctrl.mobile && !ctrl.classicView) {

            $scope.popup = _this.getExistingDialog(ctrl.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('div:eq(2)').css("min-height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.headertable').css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('.top-menu').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
            };
        }
    };

    $scope.mostRecentData = function () {
        toaster.pop('success', $scope.windowTitle, 'View reloading');
        ctrl.goSelectReportData(true);
    };

    ctrl.goSelectReportData = function (isRefresh) {

        ctrl.maxDateRange = getDateRangeService.getRange("AlertHistory");

        ctrl.alerts = [];
        var varDateRangeStart = void 0;
        var varDateRangeEnd = void 0;
        var varDateRangeEndTmp = void 0;
        if (_typeof(ctrl.stickyProperties) != 'object') {
            ctrl.stickyProperties = sharedSetupService.stickyPropertiesInterface;
        }
        if (ctrl.stickyProperties.on == true) {
            ctrl.stickyProperties.on = false;
            varDateRangeStart = ctrl.stickyProperties.dateMin;
            varDateRangeEnd = ctrl.stickyProperties.dateMax;
            ctrl.myDateRangeStart = new Date(varDateRangeStart);
            ctrl.myDateRangeEnd = new Date(varDateRangeEnd - ctrl.unixDay);
        } else {
            if (new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) && new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart))) {
                ctrl.myDateRangeEnd = new Date(ctrl.myDateRangeEnd) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeEnd)) ? ctrl.myDateRangeEnd : new Date();
                ctrl.myDateRangeStart = new Date(ctrl.myDateRangeStart) !== "Invalid Date" && !isNaN(new Date(ctrl.myDateRangeStart)) ? ctrl.myDateRangeStart : new Date();
                varDateRangeEnd = ctrl.myDateRangeEnd;
                varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                varDateRangeStart = ctrl.myDateRangeStart;
                varDateRangeStart = varDateRangeStart.setHours(0, 0, 0, 0);
            } else {
                ctrl.myDateRangeEnd = new Date();
                ctrl.myDateRangeStart = new Date();
                ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - (ctrl.maxDateRange - 1));

                varDateRangeEnd = new Date();
                varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
                ///////// needed to calculate varDateRangeStart
                varDateRangeEndTmp = new Date();
                varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
                ///////// needed to calculate varDateRangeStart
                varDateRangeStart = varDateRangeEndTmp - (ctrl.maxDateRange + 0 - 1) * ctrl.unixDay;
            }
        }
        //used for refresh button to reload newest data
        if (isRefresh) {
            ctrl.myDateRangeEnd = new Date();
            ctrl.myDateRangeStart = new Date();
            ctrl.myDateRangeStart.setDate(ctrl.myDateRangeStart.getDate() - (ctrl.maxDateRange - 1));

            varDateRangeEnd = new Date();
            varDateRangeEnd = varDateRangeEnd.setHours(23, 59, 59, 999);
            ///////// needed to calculate varDateRangeStart
            varDateRangeEndTmp = new Date();
            varDateRangeEndTmp = varDateRangeEndTmp.setHours(0, 0, 0, 0);
            ///////// needed to calculate varDateRangeStart
            varDateRangeStart = varDateRangeEndTmp - (ctrl.maxDateRange + 0 - 1) * ctrl.unixDay;
        }
        /////////////////////////////////////////////////////////////
        var currentScrollbarPosition = 0;
        var previousScrollbarPosition = 0;
        ctrl.checkFirstRowLiveStatus = null;
        /////////////////////////////////////////////////////////////
        ctrl.isLoading = true;
        ctrl.showMsg = false;
        var _alertHistory = new AlertHistoryFactory(ctrl.accountInfo.customerId, varDateRangeStart, varDateRangeEnd, ctrl.accountInfo.timeZone, ctrl.stickyProperties);

        _alertHistory.getData().then(function () {
            ctrl.isLoading = false;
            ctrl.alertHistory = _alertHistory;
            for (var i = 0; i < ctrl.alertHistory.list.length; i++) {
                ctrl.alertHistory.list[i].device = "";
                ctrl.alertHistory.list[i].send = "";
                for (var j = 0; j < ctrl.alertHistory.list[i].devices.length; j++) {
                    ctrl.alertHistory.list[i].device = ctrl.alertHistory.list[i].device + (ctrl.alertHistory.list[i].device.length > 0 ? "\r\n" : "") + ctrl.alertHistory.list[i].devices[j].deviceName;
                }
                for (var z = 0; z < ctrl.alertHistory.list[i].sends.length; z++) {
                    ctrl.alertHistory.list[i].send = ctrl.alertHistory.list[i].send + (ctrl.alertHistory.list[i].send.length > 0 ? "\r\n" : "") + ctrl.alertHistory.list[i].sends[z].toPath;
                }
                ctrl.alertHistory.list[i].repTypeDescription = eval("ctrl.translation.text." + ctrl.alertHistory.list[i].reportNameTag);
            }

            //ctrl.destinations = alarmDestination.destinations;
            //ctrl.ruleName = alarmDestination.notificationRule.ruleName;
            //ctrl.shiftId = alarmDestination.shiftId;
            //ctrl.shiftName = alarmDestination.shiftName;
            sharedSetupService.setStickyProperties(ctrl.alertHistory.stickyProperties, { dataMin: varDateRangeStart, dataMax: varDateRangeEnd, zoomMin: varDateRangeStart, zoomMax: varDateRangeEnd, windowId: ctrl.windowId });
        });
    };

    ctrl.savePdf = function () {

        var windowTitle = ctrl.windowTitle.toUpperCase().replace(/ /g, "_");
        var pdfParams = {
            windowTitle: windowTitle,
            pdfTitle: eval("ctrl.translation.text." + windowTitle),
            customerName: ctrl.accountInfo.customerName,
            customerId: ctrl.accountInfo.customerId,
            dateTranslate: ctrl.translation.text.DATE_CREATED,
            dateRangeStart: ctrl.myDateRangeStart,
            dateRangeEnd: ctrl.myDateRangeEnd,
            $scope: $scope,
            $element: $element
        };

        savePdfService.savePDF(pdfParams);
    };

    var orderBy = $filter('orderBy');
    ctrl.order = function (predicate, reverse) {
        switch (predicate) {
            case "repTypeDescription":
                ctrl.sortLoginTime = reverse ? 'localDateTime' : '-localDateTime';
                ctrl.alertHistory.list = orderBy(ctrl.alertHistory.list, [predicate, ctrl.sortLoginTime], reverse);
                break;
            case "deviceName":
            case "sendToPath":
                ctrl.alertHistory.list = orderBy(ctrl.alertHistory.list, predicate, reverse);
                break;
            default:
                ctrl.alertHistory.list = orderBy(ctrl.alertHistory.list, predicate, reverse);
                break;
        }
        ctrl.predicate = predicate;
    };

    $scope.setSorting = function () {
        ctrl.order('localDateTime', ctrl.reverse);
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        $scope.timeFormat = timeFormat;
    });

    $scope.$on('updatePreferencesLanguage', function () {
        var _tmpTimeFormat = $scope.timeFormat;
        $scope.timeFormat = 0;
        $timeout(function () {
            $scope.timeFormat = _tmpTimeFormat;
        }, 0);
        for (var i = 0; i < ctrl.alertHistory.list.length; i++) {
            ctrl.alertHistory.list[i].repTypeDescription = eval("ctrl.translation.text." + ctrl.alertHistory.list[i].reportNameTag);
            //console.log(f(ctrl.translation.text, ctrl.alertHistory.list[i].reportNameTag));
        }
    });

    //const f = new Function('translate', 'value', 'return translate.value');
    //var abc = new Function('x', 'y', 'return x+y');
    //console.log(abc(3, 4));
};

AlertHistoryController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'datetimeService', 'AlertHistoryFactory', '$timeout', '$filter', '$element', 'getDateRangeService', 'savePdfService', 'toaster'];
'use strict';

angular.module('mc.alert-history').component('alertHistory', {
    controller: AlertHistoryController,
    templateUrl: 'ui/alerthistory/alert-history-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.all-devices-integrated-flow", []);
"use strict";

function AllDevicesIntegratedFlowFactory($http, HOST) {
    var AllDevicesIntegratedFlowFactory = {};
    var _getData = function _getData(customerId, startRow, pageSize) {
        return $http({
            method: 'GET',
            url: HOST + "/api/FlowChart?customerId=" + customerId + "&startRow=" + startRow + "&pageSize=" + pageSize
        });
    };

    AllDevicesIntegratedFlowFactory.getData = _getData;
    return AllDevicesIntegratedFlowFactory;
}

AllDevicesIntegratedFlowFactory.$inject = ['$http', 'REPORTS'];

angular.module('mc.all-devices-integrated-flow').factory('AllDevicesIntegratedFlowFactory', AllDevicesIntegratedFlowFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AllDevicesIntegratedFlowController($, $rootScope, $scope, $location, authenticationService, translationService, sharedSetupService, openViewService, AllDevicesIntegratedFlowFactory, debounceService) {
    var ctrl = this;
    $scope.alerts = [];

    ctrl.startRow = 1;
    ctrl.pageSize = 5;
    ctrl.items = [];
    ctrl.numberOfReturnedRecords = -1;
    ctrl.currentPage = 1;
    ctrl.totalPages = 0;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        ctrl.mobile = $rootScope.mobile; //need for
        ctrl.classicView = $rootScope.classicView; //need for

        ctrl.translation = translationService.translation;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = ctrl.stickyPropertiesInterface;

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                if ($scope.popup.parent().length > 0) {
                    $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                    $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                    $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                    $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                }
            };
        }

        ctrl.getAllData();
    };

    ctrl.getAllData = function () {
        ctrl.loading = true;
        AllDevicesIntegratedFlowFactory.getData(ctrl.accountInfo.customerId, ctrl.startRow, ctrl.pageSize).then(function (dataFromFactory) {
            $scope.alerts = [];
            ctrl.items = dataFromFactory.data.allDevicesIntegratedFlow;
            ctrl.totalPages = Math.ceil(dataFromFactory.data.deviceCount / ctrl.pageSize);
            ctrl.numberOfReturnedRecords = dataFromFactory.data.allDevicesIntegratedFlow.length;

            ctrl.items.map(function (allDevice) {
                allDevice.integratedFlow = ctrl.processData(allDevice.integratedFlow);
                ctrl.loading = false;
            });

            if (ctrl.items.length > 0) {
                ctrl.showScrollX = ctrl.items.some(function (item) {
                    return item.setting && item.setting.length > 4;
                });
            }

            // If we didn't get any items back 
            if (dataFromFactory.data.allDevicesIntegratedFlow.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        });
    };

    ctrl.debounceGetAllData = debounceService(ctrl.getAllData, 1000, false);

    ctrl.processData = function (entries) {
        var result = {};

        entries.sort(function (a, b) {
            return new Date(b.localDateTime) - new Date(a.localDateTime);
        }).forEach(function (entry) {
            // Extract the date (YYYY-MM-DD) from localDateTime
            var dateKey = entry.localDateTime.split("T")[0] + "T00:00:00";
            // If the date key doesn't exist, initialize it
            if (!result[dateKey]) {
                result[dateKey] = [];
            }
            // Push entry into the respective date array
            result[dateKey].push(entry);
        });
        return Object.keys(result).length == 0 ? null : result;
    };

    ctrl.calculateTotals = function (dataArray) {
        if (!dataArray || dataArray.length === 0) {
            return [];
        }

        // Get the number of columns (based on the first item's runtime array length)
        var numColumns = dataArray[0].values.length;

        // Initialize an array of zeros for the totals of each column
        var totals = new Array(numColumns).fill(0);

        // Loop through each item (row) in the data array
        dataArray.forEach(function (item) {
            if (item.values) {
                // Loop through each runtime data entry in the row (column)
                item.values.forEach(function (integratedFlow, index) {
                    // Add the value to the corresponding column's total
                    if (typeof integratedFlow === 'number') {
                        totals[index] += integratedFlow;
                    }
                });
            }
        });

        return totals;
    };

    ctrl.setPage = function (page) {
        if (ctrl.currentPage != page) {
            ctrl.currentPage = page;
            ctrl.setStartRow();
        }
    };

    ctrl.prevPage = function () {
        if (ctrl.currentPage > 1) {
            ctrl.currentPage--;
            ctrl.setStartRow();
        }
    };

    ctrl.nextPage = function () {
        if (ctrl.currentPage < ctrl.totalPages) {
            ctrl.currentPage++;
            ctrl.setStartRow();
        }
    };

    ctrl.getPageButtons = function () {
        var buttons = [];
        var start = Math.max(1, ctrl.currentPage - 2);
        var end = Math.min(ctrl.totalPages, start + 4);

        // If we are at the end, shift start back to still show 3 buttons
        if (end - start < 4 && start > 1) {
            start = Math.max(1, end - 4);
        }

        for (var i = start; i <= end; i++) {
            buttons.push(i);
        }

        return buttons;
    };

    ctrl.setStartRow = function () {
        ctrl.startRow = (ctrl.currentPage - 1) * ctrl.pageSize + 1;
        this.debounceGetAllData();
    };

    ctrl.openIntegratedFlowViewByDevice = function (item, varUrl, tabName) {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = item.deviceId;
        optionsStickyProperties.zoomMin = item.lastHeardTime;

        if (ctrl.mobile || ctrl.classicView) {
            $location.path(varUrl);
        } else {
            openViewService.openView(tabName, { width: 625, height: 500 }, undefined, optionsStickyProperties);
        }
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.getAllData();
    });

    $scope.$on("$destroy", function () {});
};

AllDevicesIntegratedFlowController.$inject = ['$', '$rootScope', '$scope', '$location', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'AllDevicesIntegratedFlowFactory', 'debounceService'];
'use strict';

angular.module('mc.all-devices-integrated-flow').component('allDevicesIntegratedFlow', {
    controller: AllDevicesIntegratedFlowController,
    templateUrl: 'ui/alldevicesintegratedflow/all-devices-integratedflow-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

function AllDevicesDigitalFactory($http, HOST) {
    var AllDevicesDigitalFactory = {};
    var _getData = function _getData(timeZone, customerId, startRow, pageSize) {
        return $http({
            method: 'GET',
            url: HOST + "/api/Digital?timeZone=" + timeZone + "&customerId=" + customerId + "&startRow=" + startRow + "&pageSize=" + pageSize
        });
    };

    AllDevicesDigitalFactory.getData = _getData;
    return AllDevicesDigitalFactory;
}

AllDevicesDigitalFactory.$inject = ['$http', 'REPORTS'];

angular.module('mc.all-devices-digital').factory('AllDevicesDigitalFactory', AllDevicesDigitalFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AllDevicesDigitalController($, $rootScope, $scope, $sce, $location, authenticationService, translationService, sharedSetupService, openViewService, AllDevicesDigitalFactory, debounceService) {
    var ctrl = this;
    $scope.alerts = [];

    ctrl.startRow = 1;
    ctrl.pageSize = 5;
    ctrl.items = [];
    ctrl.numberOfReturnedRecords = -1;
    ctrl.currentPage = 1;
    ctrl.totalPages = 0;
    ctrl.debounceTimeout;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        ctrl.mobile = $rootScope.mobile; //need for
        ctrl.classicView = $rootScope.classicView; //need for

        ctrl.translation = translationService.translation;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = ctrl.stickyPropertiesInterface;

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                if ($scope.popup.parent().length > 0) {
                    $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                    $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                    $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                    $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                }
            };
        }

        ctrl.getAllData();
    };

    ctrl.getAllData = function () {
        ctrl.loading = true;
        AllDevicesDigitalFactory.getData(ctrl.accountInfo.timeZone, ctrl.accountInfo.customerId, ctrl.startRow, ctrl.pageSize).then(function (dataFromFactory) {
            ctrl.loading = false;
            $scope.alerts = [];

            ctrl.items = dataFromFactory.data.allDevicesDigital;
            ctrl.totalPages = Math.ceil(dataFromFactory.data.deviceCount / ctrl.pageSize);
            ctrl.numberOfReturnedRecords = dataFromFactory.data.allDevicesDigital.length;

            if (ctrl.items.length > 0) {
                ctrl.showScrollX = ctrl.items.some(function (item) {
                    return item.digitalSettings && item.relaySettings && item.digitalSettings.length + item.relaySettings.length > 12;
                });
            }

            // If we didn't get any items back 
            if (dataFromFactory.data.allDevicesDigital.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        });
    };

    ctrl.debounceGetAllData = debounceService(ctrl.getAllData, 1000, false);

    ctrl.tdWidth = function (digitalNumber, relayNumber) {
        var digitalNum = digitalNumber < 3 ? 3 : digitalNumber;
        var digitalWidth = digitalNum * ($rootScope.mobile ? 4.5 : 4.2);
        var relayWidth = 0;
        if (relayNumber == 1) relayWidth = $rootScope.mobile ? 9 : 8.4;
        if (relayNumber > 1) relayWidth = relayNumber * ($rootScope.mobile ? 4.5 : 4.2);
        return digitalNumber > 8 ? 140 - (digitalWidth + relayWidth) : 100 - (digitalWidth + relayWidth);
    };

    ctrl.setPage = function (page) {
        if (ctrl.currentPage != page) {
            ctrl.currentPage = page;
            ctrl.setStartRow();
        }
    };

    ctrl.prevPage = function () {
        if (ctrl.currentPage > 1) {
            ctrl.currentPage--;
            ctrl.setStartRow();
        }
    };

    ctrl.nextPage = function () {
        if (ctrl.currentPage < ctrl.totalPages) {
            ctrl.currentPage++;
            ctrl.setStartRow();
        }
    };

    ctrl.getPageButtons = function () {
        var buttons = [];
        var start = Math.max(1, ctrl.currentPage - 2);
        var end = Math.min(ctrl.totalPages, start + 4);

        // If we are at the end, shift start back to still show 3 buttons
        if (end - start < 4 && start > 1) {
            start = Math.max(1, end - 4);
        }

        for (var i = start; i <= end; i++) {
            buttons.push(i);
        }

        return buttons;
    };

    ctrl.setStartRow = function () {
        ctrl.startRow = (ctrl.currentPage - 1) * ctrl.pageSize + 1;
        ctrl.debounceGetAllData();
    };

    ctrl.openDigitalViewByDevice = function (item, varUrl, tabName) {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = item.deviceId;
        optionsStickyProperties.zoomMin = item.lastHeardTime;

        if (ctrl.mobile || ctrl.classicView) {
            $location.path(varUrl);
        } else {
            openViewService.openView(tabName, { width: 625, height: 500 }, undefined, optionsStickyProperties);
        }
    };

    ctrl.getIcon = function (input) {
        switch (input) {
            case "C":
                return $sce.trustAsHtml('<i class="fa fa-circle"></i>');
            case "O":
                return $sce.trustAsHtml('<i class="fa fa-circle-thin"></i>');
            case "U":
                return $sce.trustAsHtml('<i class="fa fa-minus-square-o"></i>');
            case "F":
                return $sce.trustAsHtml('<i class="fa fa-times-circle-o"></i>');
        }
        return "";
    };

    $scope.getDigitalHeaderWidth = function (num) {
        if (num < 3) return 3 * ($scope.mobile ? 4.5 : 4.2) + '%';
        return num * ($scope.mobile ? 4.5 : 4.2) + '%';
    };

    $scope.getRelayHeaderWidth = function (num) {
        if (num == 1) return 2 * ($scope.mobile ? 4.5 : 4.2) + '%';
        return num * ($scope.mobile ? 4.5 : 4.2) + '%';
    };

    $scope.getDigitalWidth = function (num) {
        if (num < 3) {
            var totalSpace = 3 * ($scope.mobile ? 4.5 : 4.2);
            return totalSpace / num + '%';
        }
        return $scope.mobile ? '4.5%' : '4.2%';
    };

    $scope.getRelayWidth = function (num) {
        if (num == 1) return $scope.mobile ? '9%' : '8.4%';
        return $scope.mobile ? '4.5%' : '4.2%';
    };

    $scope.getScrollOffset = function () {
        if ($scope.isEdge) {
            return 12;
        }

        return 18;
    };

    $scope.replaceSpaces = function (str) {
        if (str) {
            return str.replace(new RegExp(' ', 'g'), '_');
        }

        return '';
    };

    $scope.hasOverflow = function () {
        if ($rootScope.classicView) {
            return true;
        }

        var element = document.getElementById('digital-table-' + $scope.replaceSpaces($scope.windowId));
        if (!element || $rootScope.mobile) {
            return false;
        }

        if (element.offsetHeight < element.scrollHeight) return true;
        return false;
    };

    $scope.setHideLegend = function ($event) {
        $scope.position = $('#digital_key_' + $scope.replaceSpaces($scope.windowId)).position().left + $('#digital_key_' + $scope.replaceSpaces($scope.windowId)).width() - 160;
        $scope.hideLegend = !$scope.hideLegend;
    };

    $scope.getWindowId = function () {
        if ($scope.windowId) return $scope.windowId.replace(" ", "_");
        return "";
    };

    $scope.getBackground = function (items, parentIndex, index) {
        if (items[parentIndex]) {
            if (items[parentIndex].values[index] === "F") return "#e75a5a";
            if (parentIndex < items.length - 1) {
                if (items[parentIndex].values[index] !== items[parentIndex + 1].values[index]) return "#e9ecf0";
            }
            return "";
        }
        return "";
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.getAllData();
    });

    $scope.$on("$destroy", function () {});
}

AllDevicesDigitalController.$inject = ['$', '$rootScope', '$scope', '$sce', '$location', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'AllDevicesDigitalFactory', 'debounceService'];
'use strict';

angular.module('mc.all-devices-digital').component('allDevicesDigital', {
    controller: AllDevicesDigitalController,
    templateUrl: 'ui/alldevicesdigital/all-devices-digital-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
"use strict";

angular.module("mc.all-devices-analog", []);
"use strict";

function AllDevicesAnalogFactory($http, HOST) {
    var AllDevicesAnalogFactory = {};
    var _getData = function _getData(customerId, startRow, pageSize) {
        return $http({
            method: 'GET',
            url: HOST + "/api/Analog/Table?customerId=" + customerId + "&startRow=" + startRow + "&pageSize=" + pageSize
        });
    };

    AllDevicesAnalogFactory.getData = _getData;
    return AllDevicesAnalogFactory;
}

AllDevicesAnalogFactory.$inject = ['$http', 'REPORTS'];

angular.module('mc.all-devices-analog').factory('AllDevicesAnalogFactory', AllDevicesAnalogFactory);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function AllDevicesAnalogController($, $rootScope, $scope, $location, authenticationService, translationService, sharedSetupService, openViewService, AllDevicesAnalogFactory, debounceService) {
    var ctrl = this;
    $scope.alerts = [];

    ctrl.startRow = 1;
    ctrl.pageSize = 5;
    ctrl.items = [];
    ctrl.numberOfReturnedRecords = -1;
    ctrl.currentPage = 1;
    ctrl.totalPages = 0;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        ctrl.mobile = $rootScope.mobile; //need for
        ctrl.classicView = $rootScope.classicView; //need for

        ctrl.translation = translationService.translation;
        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;

        ctrl.stickyPropertiesInterface = sharedSetupService.stickyPropertiesInterface;
        if (_typeof(ctrl.stickyProperties) != 'object') ctrl.stickyProperties = ctrl.stickyPropertiesInterface;

        if (!ctrl.mobile && !ctrl.classicView) {
            $scope.popup = _this.getExistingDialog($scope.windowId).ref;
            sharedSetupService.maximize($scope.popup);

            $scope.popup.dialog({
                resize: function resize(event, ui) {
                    $scope.adjustSize();
                }
            });

            $scope.popup.dialogExtend({
                maximize: function maximize(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                },
                restore: function restore(event, ui) {
                    openViewService.adjustContentSizeStart($scope.popup);
                    $scope.adjustSize();
                }
            });

            $scope.adjustSize = function () {
                if ($scope.popup.parent().length > 0) {
                    $scope.popup.parent().find('div:eq(2)').css("width", $scope.popup.parent().css("width"));
                    $scope.popup.parent().find('div:eq(2)').css("min-width", $scope.popup.parent().css("width").replace(/[^0-9.]+/g, ""));
                    $scope.popup.parent().find('div:eq(2)').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, ""));
                    $scope.popup.parent().find('.tabular-data-container').css("height", $scope.popup.parent().css("height").replace(/[^0-9.]+/g, "") - $scope.popup.parent().find('div:eq(0)').css("height").replace(/[^0-9.]+/g, "") - 15); //25: total padding
                }
            };
        }

        ctrl.getAllData();
    };

    ctrl.getAllData = function () {
        ctrl.loading = true;
        AllDevicesAnalogFactory.getData(ctrl.accountInfo.customerId, ctrl.startRow, ctrl.pageSize).then(function (dataFromFactory) {
            ctrl.loading = false;
            $scope.alerts = [];

            ctrl.items = dataFromFactory.data.allDevicesAnalog;
            ctrl.totalPages = Math.ceil(dataFromFactory.data.deviceCount / ctrl.pageSize);
            ctrl.numberOfReturnedRecords = dataFromFactory.data.allDevicesAnalog.length;

            if (ctrl.items.length > 0) {
                ctrl.showScrollX = ctrl.items.some(function (item) {
                    return item.setting && item.setting.length > 4;
                });
            }

            // If we didn't get any items back 
            if (dataFromFactory.data.allDevicesAnalog.length === 0) {
                var errorMessage = ctrl.translation.text.NO_DATA;
                $scope.alerts.push({ msg: errorMessage, type: "info", languageCode: 'NO_DATA' });
            }
        });
    };

    ctrl.debounceGetAllData = debounceService(ctrl.getAllData, 1000, false);

    ctrl.setPage = function (page) {
        if (ctrl.currentPage != page) {
            ctrl.currentPage = page;
            ctrl.setStartRow();
        }
    };

    ctrl.prevPage = function () {
        if (ctrl.currentPage > 1) {
            ctrl.currentPage--;
            ctrl.setStartRow();
        }
    };

    ctrl.nextPage = function () {
        if (ctrl.currentPage < ctrl.totalPages) {
            ctrl.currentPage++;
            ctrl.setStartRow();
        }
    };

    ctrl.getPageButtons = function () {
        var buttons = [];
        var start = Math.max(1, ctrl.currentPage - 2);
        var end = Math.min(ctrl.totalPages, start + 4);

        // If we are at the end, shift start back to still show 3 buttons
        if (end - start < 4 && start > 1) {
            start = Math.max(1, end - 4);
        }

        for (var i = start; i <= end; i++) {
            buttons.push(i);
        }

        return buttons;
    };

    ctrl.setStartRow = function () {
        ctrl.startRow = (ctrl.currentPage - 1) * ctrl.pageSize + 1;
        this.debounceGetAllData();
    };

    ctrl.openAnalogViewByDevice = function (item, varUrl, tabName) {
        var optionsStickyProperties = sharedSetupService.stickyPropertiesInterface;
        optionsStickyProperties.deviceId = item.deviceId;
        optionsStickyProperties.zoomMin = item.lastHeardTime;

        if (ctrl.mobile || ctrl.classicView) {
            $location.path(varUrl);
        } else {
            openViewService.openView(tabName, { width: 625, height: 500 }, undefined, optionsStickyProperties);
        }
    };

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.getAllData();
    });

    $scope.$on("$destroy", function () {});
}

AllDevicesAnalogController.$inject = ['$', '$rootScope', '$scope', '$location', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', 'AllDevicesAnalogFactory', 'debounceService'];
'use strict';

angular.module('mc.all-devices-analog').component('allDevicesAnalog', {
    controller: AllDevicesAnalogController,
    templateUrl: 'ui/alldevicesanalog/all-devices-analog-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
'use strict';

angular.module('mc.alarm', []);
'use strict';

function AlarmFactory($http, HOST) {
    var AlarmFactory = {};
    var _getData = function _getData(customerId, timeZone, endDate, langId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/AlarmsView/GetAlarmsList' + '?customerId=' + customerId + '&timeZone=' + timeZone + '&endDate=' + endDate + '&langId=' + langId
        });
    };

    var _isActiveAlarm = function _isActiveAlarm(customerId) {
        return $http({
            method: 'Get',
            url: HOST + '/api/AlarmsView/isActiveAlarm' + '?customerId=' + customerId
        });
    };

    var _webAckAlarm = function _webAckAlarm(customerId, userId, userName, reportId) {
        return $http({
            method: 'GET',
            url: HOST + '/api/AlarmsView/WebAckAlarm' + '?customerId=' + customerId + '&userId=' + userId + '&userName=' + userName + '&eventId=' + reportId
        });
    };

    var _webAckAllAlarm = function _webAckAllAlarm(customerId) {
        return $http({
            method: 'PUT',
            url: HOST + '/api/AlarmsView/WebAckAllAlarm' + '?customerId=' + customerId
        });
    };

    AlarmFactory.getData = _getData;
    AlarmFactory.webAckAlarm = _webAckAlarm;
    AlarmFactory.webAckAllAlarm = _webAckAllAlarm;
    AlarmFactory.isActiveAlarm = _isActiveAlarm;
    return AlarmFactory;
}

AlarmFactory.$inject = ['$http', 'HOST'];

angular.module('mc.alarm').factory('AlarmFactory', AlarmFactory);
'use strict';

function AlarmController($, $rootScope, $scope, $timeout, authenticationService, translationService, sharedSetupService, AlarmFactory, toaster) {
    var ctrl = this;
    ctrl.$onInit = function () {
        $scope.alerts = [];
        ctrl.enddate = null;
        ctrl.isLoading = false;
        ctrl.ackAll = false;
        sharedSetupService.getWindowId(ctrl);
        $scope.windowId = ctrl.windowId;

        ctrl.accountInfo = authenticationService.getAccountInfo();
        ctrl.timeFormat = ctrl.accountInfo.preferenceUser.timeFormat;
        ctrl.translation = translationService.translation;

        if (ctrl.accountInfo.userRole === 'AlarmUser' || ctrl.accountInfo.userRole === 'Administrator' || ctrl.accountInfo.userRole === 'SuperAdministrator') {
            ctrl.hasAckAccess = true; //determines whether user has access to Alarm & Acknowledge Alarm feature
        }

        ctrl.getAlarmData(); //get the report data
    };

    ctrl.getAlarmData = function () {
        ctrl.isLoading = true;
        var langId = ctrl.accountInfo.preferenceUser.i18nCode.replace("-", "_");

        AlarmFactory.getData(ctrl.accountInfo.customerId, ctrl.accountInfo.timeZone, ctrl.enddate, langId).then(function (dataFromFactory) {
            ctrl.isLoading = false;
            $scope.alerts = [];
            ctrl.items = dataFromFactory.data;

            if (ctrl.items.length == 0) {
                $scope.alerts.push({ msg: ctrl.translation.text.NO_DATA, type: "info" });
            }
        }, function (error) {
            //error
        }).then(function (data) {
            ctrl.isLoading = false;
        });
    };

    ctrl.checkAckAll = function () {
        $timeout(function () {
            if (ctrl.ackAll) {
                ctrl.webAckAlarmAll();
            }
        }, 100);
    };

    ctrl.showAckAll = function () {
        return ctrl.items && ctrl.items.some(function (data) {
            return data.repState == 2 || data.repState == 0;
        });
    };

    ctrl.webAckAlarm = function (reportId) {
        AlarmFactory.webAckAlarm(ctrl.accountInfo.customerId, ctrl.accountInfo.userId, ctrl.accountInfo.userName, reportId).then(function (result) {
            ctrl.getAlarmData();
        }, function (error) {});
    };

    ctrl.webAckAlarmAll = function () {
        AlarmFactory.webAckAllAlarm(ctrl.accountInfo.customerId).then(function (result) {
            $timeout(function () {
                ctrl.getAlarmData();
            }, 300);
        }, function (error) {});
    };

    ctrl.ackByNameOrStatus = function (item) {
        var ACKBy = void 0;
        switch (item.repState) {
            case 3:
            case 5:
            case 11:
            case 16:
                ACKBy = item.ackBy;
                break;
            case 2:
                ACKBy = 'No Ack';
                break;
            default:
                ACKBy = item.sData;
        }
        return ACKBy;
    };

    $scope.$on('updatePreferencesLanguage', function () {
        ctrl.getAlarmData();
    });

    $scope.$on('updatePreferencesTimeFormat', function (event, timeFormat) {
        ctrl.timeFormat = timeFormat;
        ctrl.getAlarmData();
    });

    $scope.$on("$destroy", function () {});
}

AlarmController.$inject = ['$', '$rootScope', '$scope', '$timeout', 'authenticationService', 'translationService', 'sharedSetupService', 'AlarmFactory', 'toaster'];
'use strict';

angular.module('mc.alarm').component('alarm', {
    controller: AlarmController,
    templateUrl: 'ui/alarm/alarm-template.html',
    bindings: {
        deviceId: '<',
        windowId: '<',
        windowTitle: '<',
        mobile: '<',
        classicView: '<'
    }
});
mcapp.factory('AdminPortalService', function () {
    var pinState = false;
    var customer = 0;

    function setPin(data) {
        pinState = data;
    }

    function getPin() {
        return pinState;
    }

    function setCustomer(data) {
        customer = data;
    }

    function getCustomer() {
        return customer;
    }

    return {
        setPin: setPin,
        getPin: getPin,
        setCustomer: setCustomer,
        getCustomer: getCustomer
    };

});
"use strict";

angular.module("admin-portal", []);
'use strict';

function AdminPortalFactory(HOST, $http) {

    // instantiate our initial object
    var AdminPortal = function AdminPortal() {};

    AdminPortal.prototype.getData = function () {
        var self = this;
        return $http.get(HOST + "/api/AdminPortal").then(function (response) {
            self.data = response.data;
            self.loading = false;
            return response;
        });
    };

    return McAdminPortal;
}

AdminPortalFactory.$inject = ['HOST', '$http'];

angular.module('admin-portal').factory('AdminPortalFactory', AdminPortalFactory);
"use strict";

function AdminPortalController($, $rootScope, $scope, $sce, authenticationService, translationService, sharedSetupService, openViewService, $location, desktopViewService, AdminPortalService, $window, modalService, mcApplicationVersionAlertService, timeLapseService, toaster, websocketService) {
    var ctrl = this;
    $scope.alerts = [];
    var _uiUpToDate = $rootScope.uiUpToDate;

    ctrl.$onInit = function () {
        sharedSetupService.getWindowId($scope);
        $scope.windowId = ctrl.windowId; //need for
        $scope.windowTitle = ctrl.windowTitle; //need for
        $scope.mobile = ctrl.mobile; //need for
        $scope.classicView = ctrl.classicView; //need for
        $scope.translation = ctrl.translation; //need for
        $rootScope.CustomerNameStart = ""; // need for removing customer menu

        ctrl.translation = translationService.translation;
        ctrl.accountInfo = authenticationService.getAccountInfo();

        //update session storage so portal user is not presented with update flags when logging into specific customer
        ctrl.updateSessionStorage();

        if (ctrl.accountInfo.portal === false) {
            ctrl.navbarOptions(null, null, "/account/userlogin");
            return false;
        }

        $scope.isNavCollapsed = true;
        $scope.isCollapsed = false;
        $scope.isCollapsedHorizontal = false;
        websocketService.close();
        //_registerListener();

        if (!ctrl.mobile) {

            var _initViews = function _initViews() {
                if (ctrl.accountInfo.userType === "TechSupport") {
                    ctrl.navbarOptions({
                        name: "Customer Lookup",
                        width: 600,
                        height: 500,
                        my: "top+73",
                        at: "center top",
                        bool1: false,
                        minWidth: 550,
                        minHeight: 450,
                        bool2: false
                    });
                } else {
                    ctrl.navbarOptions({
                        name: "Customer List",
                        width: 600,
                        height: 500,
                        my: "top+73",
                        at: "center top",
                        bool1: false,
                        minWidth: 550,
                        minHeight: 450,
                        bool2: false
                    });
                }
            };

            if (angular.isDefined($scope.translation)) {
                _initViews();
                _tlDataReceivedUIVERSION();
            } else {
                translationService.loadLanguage(true).then(function (result) {
                    $scope.translation = translationService.translation;
                    _initViews();
                    _tlDataReceivedUIVERSION();
                }, function (error) {
                    console.log("error");
                });
            }
        } else {
            AdminPortalService.setPin(true);
            if (angular.isDefined($scope.translation)) {
                _tlDataReceivedUIVERSION();
            } else {
                translationService.loadLanguage(true).then(function (result) {
                    $scope.translation = translationService.translation;
                    _tlDataReceivedUIVERSION();
                }, function (error) {
                    console.log("error");
                });
            }
        }

        ctrl.togglePinState = AdminPortalService.getPin();

        ctrl.portalInfo = ctrl.getPortalInfo(ctrl.accountInfo.userType);

        ctrl.MenuOptionsFiltered = ctrl.MenuOptions.filter(function (v) {
            return v.access.includes(ctrl.accountInfo.userType);
        });
    };

    ctrl.updateSessionStorage = function () {
        var currentSessionInfo = JSON.parse($window.sessionStorage.accountInfo);
        currentSessionInfo.updateUsernameFlag = 0;
        currentSessionInfo.updatePasswordFlag = 0;
        currentSessionInfo.termsAgreedFlag = false;
        currentSessionInfo.optOutWebinar = true;
        $window.sessionStorage.accountInfo = JSON.stringify(currentSessionInfo);
    };

    ctrl.navbarOptions = function (option, videoId, location) {
        if (option) {
            openViewService.openView(option.name, { width: option.width, height: option.height }, { my: option.my, at: option.at, of: window }, option.bool1, { minimumWidth: option.minWidth, minimumHeight: option.minHeight }, option.bool2);
        } else if (videoId) {
            modalService.displayVideo(videoId);
        } else if (location) {
            $rootScope.CustomerNameStart = "";
            $scope.accountInfo = null;
            $rootScope.login = false;

            authenticationService.logout().then(function (result) {
                $location.path(result.loginPath);
            }, function (error) {
                //$window.alert("logout error");
                console.log(error);
            });
        }
        return;
    };

    ctrl.getPortalInfo = function (userType) {
        switch (userType) {
            case "TechSupport":
                return {
                    name: "McAdmin Portal",
                    color: "#7dcc93"
                };
            case "Distributor":
                return {
                    name: "Distributor Portal",
                    color: "#9e9e9e"
                };
            case "RSM":
                return {
                    name: "RSM Portal",
                    color: "#7dcc93"
                };
            case "Customer":
                return {
                    name: "Customer Portal",
                    color: "#5ab1f3"
                };
            default:
                return {
                    name: "Admin Portal",
                    color: "#5ab1f3"
                };
        }
    };

    ctrl.togglePin = function () {
        AdminPortalService.setPin(!ctrl.togglePinState);
        ctrl.togglePinState = AdminPortalService.getPin();
    };

    $scope.$on("$destroy", function () {
        //_unRegisterListener();
        timeLapseService.stop();
        websocketService.close();
        desktopViewService.closeAllViews();
    });

    ctrl.MenuOptions = [{
        translation: "CUSTOMERS",
        icon: "fa fa-users",
        access: ["TechSupport"],
        navBarOption: {
            name: "Customer Lookup",
            width: 600,
            height: 500,
            my: "top+40",
            at: "center top",
            bool1: false,
            minWidth: 550,
            minHeight: 450,
            bool2: false
        }
    }, {
        translation: "CUSTOMER_LIST",
        icon: "fa fa-file-text-o",
        access: ["Customer", "Distributor", "RSM", "InvestorOwnedUtility"],
        navBarOption: {
            name: "Customer List",
            width: 600,
            height: 500,
            my: "top+40",
            at: "center top",
            bool1: false,
            minWidth: 550,
            minHeight: 450,
            bool2: false
        }
    }, {
        translation: "REPORTS",
        icon: "fa fa-file-text-o",
        access: ["TechSupport"],
        navBarOption: null,
        subMenu: [{
            translation: "LIVE_USER",
            icon: "fa fa-file-text-o",
            navBarOption: {
                name: "Live User Report",
                width: 900,
                height: 600,
                my: "left+100 top+40",
                at: "left top",
                bool1: false,
                minWidth: 500,
                minHeight: 300,
                bool2: false
            },
            subMenu: []
        }, {
            translation: "WEB_USER_LOGIN",
            icon: "fa fa-file-text-o",
            navBarOption: {
                name: "Web User Login",
                width: 900,
                height: 600,
                my: "left+100 top+40",
                at: "left top",
                bool1: false,
                minWidth: 500,
                minHeight: 300,
                bool2: false
            },
            subMenu: []
        }]
    }, {
        translation: "WIRELESS_CARRIER",
        icon: "fa fa-mobile fa-lg",
        access: ["TechSupport"],
        navBarOption: null,
        subMenu: [{
            translation: "CARRIER_DATA_USAGE",
            icon: "fa fa-mobile fa-lg",
            navBarOption: {
                name: "Carrier Data Usage",
                width: 990,
                height: 720,
                my: "right-10 top+40",
                at: "right top",
                bool1: false,
                minWidth: 700,
                minHeight: 500,
                bool2: false
            },
            subMenu: []
        }, {
            translation: "CARRIER_RATE_PLAN",
            icon: "fa fa-book",
            navBarOption: {
                name: "Carrier Rate Plan",
                width: 990,
                height: 800,
                my: "right-10 top+40",
                at: "right top",
                bool1: false,
                minWidth: 700,
                minHeight: 600,
                bool2: false
            },
            subMenu: []
        }]
    }, {
        translation: "USER_PREFERENCES",
        icon: "fa fa-cogs",
        access: ["Customer", "Distributor", "RSM", "TechSupport"],
        navBarOption: {
            name: "Preferences",
            width: 450,
            height: 570,
            my: "left+100 top+40",
            at: "left top",
            bool1: false,
            minWidth: 450,
            minHeight: 350,
            bool2: false
        }
    }, {
        translation: "HELP",
        icon: "fa fa-question-circle fa-lg",
        access: ["Customer", "Distributor", "RSM", "InvestorOwnedUtility"],
        navBarOption: null,
        border: true,
        subMenu: [{
            translation: "DOCUMENTS",
            icon: "fa fa-file-text-o",
            navBarOption: {
                name: "Documents",
                width: 990,
                height: 600,
                my: "left+100 top+40",
                at: "left top",
                bool1: false,
                minWidth: 500,
                minHeight: 300,
                bool2: false
            },
            subMenu: []
        }, {
            translation: "REVISION_LOG",
            icon: "fa fa-list-alt",
            navBarOption: {
                name: "Revision Log",
                width: 990,
                height: 600,
                my: "left+100 top+40",
                at: "left top",
                bool1: false,
                minWidth: 500,
                minHeight: 300,
                bool2: false
            },
            subMenu: []
        }, {
            translation: "TRAINING_VIDEOS",
            icon: "fa fa-list-alt",
            navBarOption: null,
            subMenu: [{
                translation: "SCADA_INTRODUCTION",
                icon: "fa fa-film",
                navBarOption: null,
                subMenu: [],
                videoId: 219751456
            }, {
                translation: "SCADA_TOP_REASONS",
                icon: "fa fa-film",
                navBarOption: null,
                subMenu: [],
                videoId: 219751357
            }, {
                translation: "SCADA_NOTIFICATION_BASICS",
                icon: "fa fa-film",
                navBarOption: null,
                subMenu: [],
                videoId: 226347312
            }]
        }]
    }, {
        translation: "HELP",
        icon: "fa fa-question-circle fa-lg",
        access: ["TechSupport"],
        navBarOption: null,
        border: true,
        subMenu: [{
            translation: "DOCUMENTS",
            icon: "fa fa-file-text-o",
            navBarOption: {
                name: "Documents",
                width: 990,
                height: 600,
                my: "left+100 top+40",
                at: "left top",
                bool1: false,
                minWidth: 500,
                minHeight: 300,
                bool2: false
            },
            subMenu: []
        }, {
            translation: "HELP_DOCUMENTS",
            icon: "fa fa-file-text",
            navBarOption: {
                name: "Help Documents",
                width: 990,
                height: 600,
                my: "left+100 top+40",
                at: "left top",
                bool1: false,
                minWidth: 500,
                minHeight: 300,
                bool2: false
            },
            subMenu: []
        }, {
            translation: "REVISION_LOG",
            icon: "fa fa-list-alt",
            navBarOption: {
                name: "Revision Log",
                width: 990,
                height: 600,
                my: "left+100 top+40",
                at: "left top",
                bool1: false,
                minWidth: 500,
                minHeight: 300,
                bool2: false
            },
            subMenu: []
        }, {
            translation: "TRAINING_VIDEOS",
            icon: "fa fa-list-alt",
            navBarOption: null,
            subMenu: [{
                translation: "SCADA_INTRODUCTION",
                icon: "fa fa-film",
                navBarOption: null,
                subMenu: [],
                videoId: 219751456
            }, {
                translation: "SCADA_TOP_REASONS",
                icon: "fa fa-film",
                navBarOption: null,
                subMenu: [],
                videoId: 219751357
            }, {
                translation: "SCADA_NOTIFICATION_BASICS",
                icon: "fa fa-film",
                navBarOption: null,
                subMenu: [],
                videoId: 226347312
            }]
        }]
    }, {
        translation: "TECH_SUPPORT_ASSIGNMENT",
        icon: "fa fa-address-book",
        access: ["TechSupport"],
        navBarOption: {
            name: "Tech Support Assignment",
            width: 990,
            height: 720,
            my: "right-10 top+40",
            at: "right top",
            bool1: false,
            minWidth: 950,
            minHeight: 500,
            bool2: false
        }
    }, {
        translation: "LOGOUT",
        icon: "fa fa-sign-out",
        access: ["Customer", "Distributor", "RSM", "InvestorOwnedUtility", "TechSupport"],
        navBarOption: null,
        location: "/account/userlogin"
    }];

    $scope.missionUpdateAlerts = [];

    var _tlDataReceivedUIVERSION = function _tlDataReceivedUIVERSION() {

        var _displayMessage = false;

        mcApplicationVersionAlertService.getData('customerId=' + ctrl.accountInfo.customerId + '&applicationId=1' + '&timeZone=' + ctrl.accountInfo.timeZone).then(function (datafromfactory) {

            var _type, _title, _message, _duration;

            if (datafromfactory.data.buildNumber > $('meta[name=build]').attr("content")) {
                _displayMessage = true;
                _uiUpToDate = false;
                _type = "error";
                _title = $scope.translation.text.NEW_123SCADA_AVAILABLE;
                _message = "<br>" + $scope.translation.text.SAVE_YOUR_WORK + "<a href='#' onclick='location.reload(true); return false;' style='text-decoration: underline;'>" + $scope.translation.text.CLICK_HERE + "</a>" + $scope.translation.text.TO_UPDATE;
                _duration = 15000;
            } else if (!$rootScope.uiUpToDate) {
                _displayMessage = true;
                _uiUpToDate = true;
                _type = "success";
                _title = $scope.translation.text.UP_TO_DATE_123SCADA;
                _message = "";
                _duration = 5000;
            }

            if (_displayMessage) toaster.pop(_type, _title, _message, _duration, 'trustedHtml');
            $rootScope.uiUpToDate = _uiUpToDate;
            _displayMessage = false;
        }, function (error) {
            console.log("error");
        });
    };

    ctrl.updateSessionStorageAfterPreferenceChange = function (data) {
        var currentSessionInfo = JSON.parse($window.sessionStorage.accountInfo);
        currentSessionInfo.preferenceUser.adminPortal = data.Value.AdminPortal;
        currentSessionInfo.preferenceUser.audioEnabled = data.Value.AudioEnabled;
        currentSessionInfo.preferenceUser.timeFormat = data.Value.TimeFormat;
        currentSessionInfo.preferenceUser.websiteMode = data.Value.WebsiteMode;
        currentSessionInfo.preferenceUser.engineeringUnitDisplay = data.Value.EngineeringUnitDisplay;
        currentSessionInfo.preferenceUser.shareUserLocation = data.Value.ShareUserLocation;
        currentSessionInfo.preferenceUser.lookupLanguageID = data.Value.LookupLanguageID;
        //$scope.languageSelectedOption = { "lookupLanguageID": data.Value.LookupLanguageID, "i18n": data.Value.I18nCode };
        currentSessionInfo.preferenceUser.lookupMeasurementID = data.Value.LookupMeasurementID;
        currentSessionInfo.preferenceUser.colorSchemeId = data.Value.ColorSchemeId;
        currentSessionInfo.preferenceUser.fontSizeId = data.Value.FontSizeId;
        currentSessionInfo.preferenceUser.i18nCode = data.Value.I18nCode;
        currentSessionInfo.preferenceUser.displayWebinarToaster = data.Value.DisplayWebinarToaster;
        currentSessionInfo.preferenceUser.defaultDesktopID = data.Value.DefaultDesktopID;
        currentSessionInfo.preferenceUser.voice = data.Value.Voice;
        $window.sessionStorage.accountInfo = JSON.stringify(currentSessionInfo);
    };

    ctrl.wsDataReceivedPREFERENCEUSERCHANGE = function (data) {
        if (data.Type == 'PREFERENCEUSERCHANGE' && data.UniqueWebID != $rootScope.uniqueWebID) {
            if (typeof ctrl.accountInfo.preferenceUser.loginId !== 'undefined') {
                if (ctrl.accountInfo.preferenceUser.loginId.toString() == data.SN) {
                    ctrl.updateSessionStorageAfterPreferenceChange(data);
                }
            } else {
                if (ctrl.accountInfo.preferenceUser.loginID.toString() == data.SN) {
                    ctrl.updateSessionStorageAfterPreferenceChange(data);
                }
            }
        }
    };

    var _registerListener = function _registerListener() {
        timeLapseService.register("UIVERSION", 0, "", _tlDataReceivedUIVERSION, 12);
        websocketService.connect();
        if (typeof ctrl.accountInfo.preferenceUser.loginId !== 'undefined') {
            websocketService.register("PREFERENCEUSERCHANGE", ctrl.accountInfo.preferenceUser.loginId.toString(), 0, ctrl.wsDataReceivedPREFERENCEUSERCHANGE, null);
        } else {
            websocketService.register("PREFERENCEUSERCHANGE", ctrl.accountInfo.preferenceUser.loginID.toString(), 0, ctrl.wsDataReceivedPREFERENCEUSERCHANGE, null);
        }
    };

    var _unRegisterListener = function _unRegisterListener() {
        timeLapseService.unRegister("UIVERSION", 0, "", _tlDataReceivedUIVERSION, 12);
        if (typeof ctrl.accountInfo.preferenceUser.loginId !== 'undefined') {
            websocketService.unRegister("PREFERENCEUSERCHANGE", ctrl.accountInfo.preferenceUser.loginId.toString(), 0, ctrl.wsDataReceivedPREFERENCEUSERCHANGE, null);
        } else {
            websocketService.unRegister("PREFERENCEUSERCHANGE", ctrl.accountInfo.preferenceUser.loginID.toString(), 0, ctrl.wsDataReceivedPREFERENCEUSERCHANGE, null);
        }
    };
}

AdminPortalController.$inject = ['$', '$rootScope', '$scope', '$sce', 'authenticationService', 'translationService', 'sharedSetupService', 'openViewService', '$location', 'desktopViewService', 'AdminPortalService', '$window', 'modalService', 'mcApplicationVersionAlertService', 'timeLapseService', 'toaster', 'websocketService'];
'use strict';

angular.module('admin-portal').component('adminPortal', {
    controller: AdminPortalController,
    templateUrl: 'ui/admin/admin-portal-template.html',
    bindings: {
        stickyProperties: '<',
        windowId: '<',
        mobile: '<',
        windowTitle: '<',
        classicView: '<'
    }
});
mcapp.controller("verifyUsernameController", ['$location', 'verifyUsernameFactory', function ($location, verifyUsernameFactory) {
    var vCode = $location.search()['vcode'];
    var username = $location.search()['username'];

    var verifyUsername = function () { 
        //1. validate username "mission"
        if (username.toLowerCase().trim() !== "mission") {
            verifyUsernameFactory.Verify(username, vCode)
                .then(function (result) {
                    $location.url("/account/userlogin?verifiedStatus=ok");
                }, function (error) {
                    $location.url("/account/userlogin?verifiedStatus=" + error.data.message);
                });
        }
        else {
            $location.url("/account/userlogin?verifiedStatus=not-allowed");
        }
    };

    if (!!vCode && !!username) verifyUsername();

}]);

mcapp.factory("verifyUsernameFactory", ["$http", "HOST", function ($http, HOST) {
    var Result = {};

    var _verify = function (username, verificationCode) {
        return $http.put(HOST + '/api/contact' + '?username=' + username + '&verificationCode=' + verificationCode);
    };
    
    Result.Verify = _verify;
    return Result;
}]);



mcapp.factory("userloginRoutingService", ["$rootScope", "$window", "sharedSetupService", "$location", "$timeout", function ($rootScope, $window, sharedSetupService, $location, $timeout) {

    var UserloginRoutingFactory = {};
    
    var getIfNeedToUpdatePassword = function (passwordChangedDateString, passwordResetEveryNDays) {

        if (passwordChangedDateString == "")
            return true;

        var todayDate = new Date();
        var passwordChangedDate = new Date(passwordChangedDateString);

        passwordChangedDate.setDate(passwordChangedDate.getDate() + passwordResetEveryNDays);
        passwordChangedDate.setDate(passwordChangedDate.getDate() - 7);

        return passwordChangedDate < todayDate;
    };

    var _routUser = function (accountInfo, okToSkip) {

        var userTypeParms = sharedSetupService.getUserTypeParms(accountInfo.portal, accountInfo.preferenceUser.adminPortal);
        //Need it for LDP to access portals in desktop or mobile mode. No classicView mode supported!!!
        if (userTypeParms.path.indexOf("/portal") > -1) $rootScope.classicView = false;

        if ((angular.isUndefined(okToSkip) || angular.isUndefined(okToSkip.communicationPortal) || !okToSkip.communicationPortal) && accountInfo.daysPastDue > 0) {
            $rootScope.classicView = false;
            $location.path('/communication/portal');
        }
        else if ((angular.isUndefined(okToSkip) || angular.isUndefined(okToSkip.securityPortal) || !okToSkip.securityPortal) && (accountInfo.mfaMigrationRequired || (accountInfo.mfaMigrationExpiryDate != null && accountInfo.mfaMigrationStatus < 2))) {
            $rootScope.classicView = false;
            $location.path('/security/portal');
        }
        else if ((angular.isUndefined(okToSkip) || angular.isUndefined(okToSkip.securityPortal) || !okToSkip.securityPortal) && (accountInfo.securityPortalRequired || (accountInfo.mfaMigrationStatus == 2 && accountInfo.updatePasswordFlag >= 1) || (accountInfo.mfaMigrationStatus == 2 && accountInfo.passwordResetEveryNDays > 0 && getIfNeedToUpdatePassword(accountInfo.passwordChangedDate, accountInfo.passwordResetEveryNDays)))) {
            $rootScope.classicView = false;
            $location.path('/security/portal');
        }
        else if (userTypeParms.name.length > 0) {
            $rootScope.freshLogin = true;
            $timeout(function () {
                $rootScope.freshLogin = false;
            }, 500);
            $location.path(userTypeParms.path);
        }
        else if (accountInfo.numberOfDevices === 0) {
            $rootScope.classicView = false;
            $location.path('/nodevices/template');
        }
        else if ($rootScope.classicView || sharedSetupService.getClassicViewState()) {
            $rootScope.classicView = true;
            var tmpCustomerId = { customerId: accountInfo.customerId }
            $rootScope.$broadcast('resetDeviceMenuList', tmpCustomerId);
            $location.path("map/map");
        }
        else {
            $rootScope.freshLogin = true;
            $timeout(function () {
                $rootScope.freshLogin = false;
            }, 500);
            $location.path(userTypeParms.path);
        }

    };

    UserloginRoutingFactory.routUser = _routUser;    

    return UserloginRoutingFactory;
}]);
mcapp.controller("userloginController", ["$scope", "$http", "$location", "$window", "authenticationService", "$rootScope", "translationService", "deviceMenuService", "$cookies", "websocketService", "sharedSetupService", "uiErrorCounterService", "forgotUsernameModalService", "forgotPasswordModalService", '$timeout', 'locationFactory', 'openViewService', 'userloginRoutingService',
function ($scope, $http, $location, $window, authenticationService, $rootScope, translationService, deviceMenuService, $cookies, websocketService, sharedSetupService, uiErrorCounterService, forgotUsernameModalService, forgotPasswordModalService, $timeout, locationFactory, openViewService, userloginRoutingService) {
    $scope.isLegacyToScada = false;
    $scope.authenticatorRequired = false;
    $scope._varWebsiteMode = undefined;
    //$window.sessionStorage.removeItem("caw");//Mission Customer Appreciation Week May 13 - 20, 2026//
    $window.sessionStorage.removeItem("msr");//Mission Security Reminder August, 2026//
    $scope.setState = function (varClassicView) {
        var state = {
            classicView: varClassicView || false
        };
        $window.sessionStorage.state = JSON.stringify(state);
    };
    $scope.clearAdminUser = function () {
        $rootScope.adminUserName = null;
        $rootScope.adminPassword = null;
        uiErrorCounterService.resetCounter();
        $rootScope.uiUpToDate = false;
        $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
    };
    $scope.siteAccess = function () {
        $scope.clearAdminUser();
        if ($rootScope.mobile) {
            window.location.replace("https://123Scada.com");
        }
        else {
            $location.path("/underconstruction/under-construction");
        }
    };

    $scope.rot13 = function (rot13text) {
        var rot13text_rotated = ""; //' the function will return this string
        for (var i = 0, len = rot13text.length; i < len; i++) { //' take the next character in the string
            var j = rot13text[i];
            var k = j.charCodeAt(0); // ' find out the character code
            if (k >= 97 && k <= 109) {
                k = k + 13;//' a ... m inclusive become n ... z
            }
            else if (k >= 110 && k <= 122) {
                k = k - 13; //' n ... z inclusive become a ... m
            }
            else if (k >= 65 && k <= 77) {
                k = k + 13; //' A ... M inclusive become N ... Z
            }
            else if (k >= 78 && k <= 90) {
                k = k - 13; //' N ... Z inclusive become A ... M
            }
            rot13text_rotated = rot13text_rotated + String.fromCharCode(k);  //'add the current character
        }
        return rot13text_rotated;
    };

    // did we receive the token/GUID? -> so extract URL parameters
    var guidPattern = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', 'i');
    var absUrl = decodeURIComponent($location.absUrl().split('?')[1]);

    if ($rootScope.mobile && !(angular.isDefined(absUrl) && guidPattern.test(absUrl) === true)) $rootScope.$broadcast('mobileLogout', "Login Page");

    deviceMenuService.resetDeviceMenuList();
    $scope.accountInfo = null;
    $rootScope.online = true;    
    $("title").text("Mission Communications");
    $scope.userName = $rootScope.adminUserName;
    $scope.password = $rootScope.adminPassword;
    $scope.usernameEmailSentMessage = undefined;
    //$scope.displayUsernameMsg = false;

    /////////////////////////////////////////////////START//////////////////////////////////////////////////////////////////////
    ///////////////if user is redirected from legacy site, then extract the login credentials from querystring /////////////////
    ///////////////Following logic is when querystring contains encoded username & password           //////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var absParms = absUrl.split('|');

    if (angular.isDefined(absParms[0]) && angular.isDefined(absParms[1])) {
        $scope.isLegacyToScada = true;
        $location.url($location.path());
        $scope.userName = $scope.rot13(absParms[0]);
        $scope.password = $scope.rot13(absParms[1]);
    }
    /////////////If querystring contains GUID(sessionID) then following logic kick-off//////////////////////////////////////////
    if (angular.isDefined(absUrl) && guidPattern.test(absUrl) === true) {
        //validate the token (GUID) with length = 36 Ex: DBE06BE8-653F-4AFD-B3BF-01853EF4040A
        $scope.isLegacyToScada = true;
        //then fetch credentials using the token from webapi call (from this table ScadaLegacySessionTransfer)
        $location.url($location.path());
        $scope.userName = "00000-00000";
        $scope.password = absUrl; // absURL is actual token (sessionID)
        //This is for SSO only
        sharedSetupService.adjustBrowserHistoryForLoginPath("replace");
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //////////////////////END/////////////redirected from legacy site logic///////////////END///////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /////////////////////////////////////////////////START//////////////////////////////////////////////////////////////////////
    ///////////////SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-/////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var paramUrlWithCode = absUrl.split('&')[0];// $location.absUrl().split('&')[0];
    //var paramUrlWithCode = paramUrl.split('?')[1];
    var paramCode = !angular.isUndefined(paramUrlWithCode) ? paramUrlWithCode.split('=')[0] : undefined;
    var paramCodeValue = !angular.isUndefined(paramUrlWithCode) ? paramUrlWithCode.split('=')[1] : undefined;
    if (!angular.isUndefined(paramCode) && paramCode == "code" && !angular.isUndefined(paramCodeValue))
        $location.path("/sso/validation");
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-SSO-/////////////////////
    ///////////////////////////////////////////////////////END//////////////////////////////////////////////////////////////////



    translationService.loadLanguage(true)
    .then(function () {
        $scope.translation = translationService.translation;
    }, function (error) {
        console.log("error");
    });

    $scope.mobileAppManageLogin = function () {
        if (!$rootScope.mobileApp) return;
        if ($scope.mobileAppRememberMe) {
            window.localStorage.setItem("mobileAppUserName", $scope.userName);
            window.localStorage.setItem("mobileAppPassword", $scope.password);
            window.localStorage.setItem("mobileAppRememberMe", "true");
        } else {
            window.localStorage.removeItem("mobileAppUserName");
            window.localStorage.removeItem("mobileAppPassword");
            window.localStorage.setItem("mobileAppRememberMe", "false");
        }
    }

    $scope.mobileAppManageLoginApply = function () {
        if (!$rootScope.mobileApp) return;
        $scope.mobileAppRememberMe = window.localStorage.getItem("mobileAppRememberMe") === "true" ? true : false;
        if ($scope.mobileAppRememberMe) {
            $scope.userName = window.localStorage.getItem("mobileAppUserName");
            $scope.password = window.localStorage.getItem("mobileAppPassword");
        }
    }

    $scope.setGermantownMenuTemplate = function (customerId, $rootScope) {        
        switch (customerId) {
            case 597:
            case 15177:
            case 15147:
                $rootScope.menuTemplate = "germantown";
                $rootScope.bulkWaterManagementAccess = true;
                break;
            default:
                $rootScope.menuTemplate = "main";
                $rootScope.bulkWaterManagementAccess = false;
        }
    }

    $scope.login = function (varWebsiteMode) {
        if (varWebsiteMode) $scope._varWebsiteMode = varWebsiteMode;
        var authCode = $scope.authenticatorCode ? $scope.authenticatorCode.trim() : "";
        if ($scope.userName.trim() == "" || $scope.password.trim() == "") return;
        websocketService.resetListenerArray();
        $scope.showloading = true;  
        $scope.alerts = [];
        $scope.mobileAppManageLogin();
        var viewModeNow = $rootScope.mobileApp === true ? 4 : $rootScope.mobile === true ? 3 : $scope._varWebsiteMode > 0 ? $scope._varWebsiteMode : 1;
        authenticationService.login($scope.userName.trim(), $scope.password.trim(), viewModeNow, authCode)
            .then(function (result) {
                //This is for SSO only
                sharedSetupService.adjustBrowserHistoryForLoginPath("replace");
                //first validate whether it is 2FA => NOTE: authenticatorCode property determines whether it is 2FA (Two-Factor Authentication)
                if (result.data && result.data.authenticatorCode) {
                    if (result.data.authenticatorCode === "Required") {
                        // show textbox to capture the authenticator code
                        $scope.authenticatorRequired = true;                        
                        $timeout(function () {
                            document.getElementById("authcode").focus();
                        }, 0);
                    } else if (result.data.authenticatorCode === "Invalid") {
                        //display error message
                        errormsg = "The code you entered is incorrect. Please check it and try again.";
                        $scope.alerts.push({ msg: errormsg, type: "danger" });
                    }
                    $scope.showloading = false;
                    return;
                }
                if ($rootScope.mobileApp) locationFactory.mobileAppShareMyLocation();
                if ($scope._varWebsiteMode === 1) {
                    $rootScope.classicView = false;
                    //$rootScope.mobile = true;
                }
                else if ($scope._varWebsiteMode === 2) {
                    $rootScope.classicView = true;
                    $rootScope.mobile = false;
                } else {
                    $rootScope.classicView = $rootScope.mobile === false && result.preferenceUser.websiteMode === 2 ? true : false;
                }

                var viewModeCalculated = $rootScope.mobileApp === true ? 4 : $rootScope.mobile === true
                    ? 3 : $rootScope.classicView === true ? 2 : 1;
                if (viewModeNow !== viewModeCalculated) authenticationService.getAccountInfo('refresh');

                if ($rootScope.mobile) sharedSetupService.stickyPropertiesInterface.on = null;
                $scope.setState($rootScope.classicView);
                $scope.clearAdminUser();
                $scope.setGermantownMenuTemplate(result.customerId, $rootScope);
                $rootScope.login = true;
                $rootScope.CustomerNameStart = result.customerName;
                $rootScope.backgroundLogo = authenticationService.getAccountInfo().logoName || $rootScope.defaultBackgroundLogo;

                userloginRoutingService.routUser(result);

            }, function (error) {
                $scope.isLegacyToScada = false;
                var tmpError = '';
                //first validating, whether error is related to recent username update
                if (error.data.error === 'ERROR_OLD_USERNAME') {
                    tmpError = error.data.error;
                    $scope.userName = error.data.error_description;
                }
                else {
                    tmpError = typeof error.data.error !== 'undefined' ? error.data.error : error.data.message; // error from token [ Authorize ] OR error from [ InputParameterValidatorFilter ] or HttpError().
                }
                $scope.clearAdminUser();
                $rootScope.CustomerNameStart = "";
                $scope.showloading = false;
                $scope.alerts = [];
                var errormsg = tmpError == "user_locked" ? error.data.error_description : eval("$scope.translation.message." + tmpError);
                $scope.alerts.push({ msg: errormsg, type: "danger" });
            });
    };

    $scope.cancel = function () {
        $scope.userName = "";
        $scope.password = "";
    };

    if ($scope.password != null && $scope.userName != null) {
        $rootScope.autoLogin = true;
        $scope.login();
    } else {
        $scope.setState();
        $rootScope.classicView = false;
    }

    $scope.ForgotUsername = function () {
        forgotUsernameModalService.confirmForgotUsername();
    };

    $scope.ForgotPassword = function () {
        forgotPasswordModalService.confirmForgotPassword();
    };

    $scope.$on('forgotUsernameEmailSent', function () {
        $scope.alerts = [];
        $scope.alerts.push({ msg: "Your username has been sent to your email", type: "danger" });
    });

    //Prevent Username Enumeration, redirect to Login page in case of failure (i.e, email address in not present in DB)
    $scope.$on('forgotUsernameEmailSentFailed', function (evt, errorMsg) {
        $scope.alerts = [];
        $scope.alerts.push({ msg: errorMsg, type: "danger" });
    });

    $scope.mobileAppManageLoginApply();
    if ($rootScope.mobileApp) locationFactory.mobileAppClearShareMyLocation();

    openViewService.closeHelpPanel();

    $scope.checkAuthCodeLength = function () {
        if (!angular.isUndefined($scope.authenticatorCode) && ($scope.authenticatorCode).length === 6)
            document.getElementById("btnLogin").focus();
    }

    $scope.checkIfVcodeVerify = function () {
        var verifiedStatus = $location.search()['verifiedStatus'];
        if (!!verifiedStatus) {
            $scope.alerts = [];

            switch (verifiedStatus) {
            case "ok":
                $timeout(function () {
                    $scope.alerts.push({ msg: "Thank you for verifying your user email address.", type: "success" });
                    $location.search('verifiedStatus', null);
                }, 0);
                break;
            case "not-allowed":
                $timeout(function () {
                    $scope.alerts.push({ msg: "Verify username for mission is not allowed", type: "danger" });
                    $location.search('verifiedStatus', null);
                }, 0);
                break;
            default:
                $timeout(function () {
                    $scope.alerts.push({ msg: verifiedStatus, type: "danger" });
                    $location.search('verifiedStatus', null);
                }, 0);
                break;
            }
        }
    }
    $scope.checkIfVcodeVerify();
}]);

mcapp.controller("userlogoutController", ["$location", "authenticationService", "websocketService", "$rootScope", function ($location, authenticationService, websocketService, $rootScope) {

    websocketService.close();
    $rootScope.CustomerNameStart = "";
    authenticationService.logout()
        .then(function (result) {
            $rootScope.login = false;
            $location.path("/account/userlogin");
        }, function (error) {
            $window.alert("logout error");
        });

}]);
mcapp.controller("resetPasswordController", ['$scope', '$location', 'resetPasswordFactory', 'translationService', function ($scope, $location, resetPasswordFactory, translationService) {
    $scope.username = "";
    $scope.password = "";
    $scope.confirmPassword = "";
    $scope.vCode = $location.search()['vcode'];
    $scope.displayMessage = undefined;
    $scope.translation = translationService.translation;

    $scope.ok = function(){
        //1. validate username "mission"
        if ($scope.username.toLowerCase().trim() != "mission") {

            //validate password (make sure both have same content
            if ($scope.password !== $scope.confirmPassword) {
                $scope.alerts = [];
                $scope.alerts.push({ msg: "Password confirmation failed.", type: "danger" });
            }
            else {
                    resetPasswordFactory.Reset($scope.username, $scope.password, $scope.vCode, "ResetPassword")
                    .then(function (result) {

                        //navigate to login.html
                        $location.url("/account/userlogin");
                    }, function (error) {
                        $scope.username = "";
                        $scope.password = "";
                        $scope.confirmPassword = "";
                        $scope.alerts = [];
                        $scope.alerts.push({ msg: error.data.message, type: "danger" });
                    });
              }
        }
        else {
            $scope.alerts =[];
            $scope.alerts.push({ msg: "Reset password for mission is not allowed", type: "danger" });
            $scope.username = "";
            $scope.password = "";
            $scope.confirmPassword = "";
        }
    };
}]);

mcapp.factory("resetPasswordFactory", ["$http", "HOST", function ($http, HOST) {
    var Result = {};

    var _reset = function (username, password, verificationCode, toServicesController) {

        password = rot13(password + 'sAlTsTrInG');

        return $http.put(HOST + '/api/' + toServicesController + '?username=' + username + '&password=' + password + '&verificationCode=' + verificationCode);
    };

    function rot13(rot13text) {
        var rot13text_rotated = ""; //' the function will return this string
        for (var i = 0, len = rot13text.length; i < len; i++) { //' take the next character in the string
            var j = rot13text[i];
            var k = j.charCodeAt(0); // ' find out the character code
            if (k >= 97 && k <= 109) {
                k = k + 13;//' a ... m inclusive become n ... z
            }
            else if (k >= 110 && k <= 122) {
                k = k - 13; //' n ... z inclusive become a ... m
            }
            else if (k >= 65 && k <= 77) {
                k = k + 13; //' A ... M inclusive become N ... Z
            }
            else if (k >= 78 && k <= 90) {
                k = k - 13; //' N ... Z inclusive become A ... M
            }
            rot13text_rotated = rot13text_rotated + String.fromCharCode(k);  //'add the current character
        }
        return rot13text_rotated;
    }

    Result.Reset = _reset;

    return Result;
}]);
mcapp.factory("authenticationService", ["$rootScope", "$http", "$q", "$window", "HOST", "APPLICATION", "$location", "AccountInfoService", function ($rootScope, $http, $q, $window, HOST, APPLICATION, $location, AccountInfoService) {
    var accountInfo;
    var authorizationInfo;
    function login(userName, password, websiteMode, authenticatorCode) {

      var deferred = $q.defer();

      password = rot13(password + 'sAlTsTrInG');

        authenticate(userName, password, authenticatorCode)
            .then(function (result) {
                if (result.data.authenticatorCode) {
                    deferred.resolve(result);
                } else {
                    retrieveAccountInfo(userName, password, websiteMode)
                        .then(function (accountInfo) {
                            deferred.resolve(accountInfo);
                        },
                            function (error) {
                                deferred.reject(error);
                            });
                }
            },
            function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    function rot13(rot13text) {
      var rot13text_rotated = ""; //' the function will return this string
      for (var i = 0, len = rot13text.length; i < len; i++) { //' take the next character in the string
        var j = rot13text[i];
        var k = j.charCodeAt(0); // ' find out the character code
        if (k >= 97 && k <= 109) {
          k = k + 13;//' a ... m inclusive become n ... z
        }
        else if (k >= 110 && k <= 122) {
          k = k - 13; //' n ... z inclusive become a ... m
        }
        else if (k >= 65 && k <= 77) {
          k = k + 13; //' A ... M inclusive become N ... Z
        }
        else if (k >= 78 && k <= 90) {
          k = k - 13; //' N ... Z inclusive become A ... M
        }
        rot13text_rotated = rot13text_rotated + String.fromCharCode(k);  //'add the current character
      }
      return rot13text_rotated;
    }

    function authenticate(userName, password, authenticatorCode) {

        var data = "grant_type=password&username=" + encodeURIComponent(userName) + "&password=" + encodeURIComponent(password) + "&client_id=" + APPLICATION + "&authenticatorCode=" + authenticatorCode;

        //if (loginData.useRefreshTokens) {
        //    data = data + "&client_id=" + ngAuthSettings.clientId;
        //}

        var deferred = $q.defer();

        $http.post(HOST + '/token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }) 
            .then(function (response) {
                //first handle if it is two-factor authentication => NOTE: authenticatorCode property determines whether it is 2FA
                if (response.data.authenticatorCode) {
                    // throw the response to calling method
                    deferred.resolve(response);
                    return;
                } 
                try {
                    $window.sessionStorage.authorizationInfo = JSON.stringify({ token: response.data.access_token, userName: response.data.userName, refreshToken: "", useRefreshTokens: false, expires: response.data[".expires"]});

                } catch (e) {

                    alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you. \n\nPlease turn off private browsing mode if you wish to use this site.');
                }
                var authData = $window.sessionStorage.authorizationInfo;

                deferred.resolve(response);

            }, function (err, status) {
                try {
                    $window.sessionStorage.safariTest = JSON.stringify({ token: 'sa', userName: 'fa', refreshToken: 'ri', useRefreshTokens: false });

                } catch (e) {

                    alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you. \n\nPlease turn off private browsing mode if you wish to use this site.');
                }
                logout();
                deferred.reject(err);
            });

        return deferred.promise;
    }

    function retrieveAccountInfo(userName, password, websiteMode) {

        var viewMode = $rootScope.mobileApp === true ? 4 : $rootScope.mobile === true
            ? 3 : $rootScope.classicView === true ? 2 : 1;
      
        var deferred = $q.defer();
        $http({
            method: 'GET',
            url: HOST + '/api/account/GetSettings/?' + "viewMode=" + websiteMode,
            cache: false
        }).then(function (result) {
            if (accountInfo == null) accountInfo = {};
            AccountInfoService.getAccountInfo(accountInfo, result.data); 

            setGermantownMenuTemplate();
            $window.sessionStorage.accountInfo = JSON.stringify(accountInfo);

            deferred.resolve(accountInfo);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }


    function logout() {
        var loginPath = window.sessionStorage.getItem("loginPath");
        var logoutObj = {
            "loginPath": loginPath == null ? "/account/userlogin" : loginPath
        };
        var deferred = $q.defer();

        accountInfo = null;
        $window.sessionStorage.accountInfo = null;

        authorizationInfo = null;
        $window.sessionStorage.authorizationInfo = null;

        deferred.resolve(logoutObj);

        return deferred.promise;
    }


    function getAccountInfo(refresh) {
        if (refresh) {
            var viewModeNow = $rootScope.mobileApp === true ? 4 : $rootScope.mobile === true
                ? 3 : $rootScope.classicView === true ? 2 : 1;
            return retrieveAccountInfo(accountInfo.userName, accountInfo.password, viewModeNow).then(function (accountInfo) {
                return accountInfo;
            }, function (error) {
                console.log("error");
            });
        }
        return accountInfo;
    }

    function setAccountInfo( newaccountInfo ) {
        accountInfo = newaccountInfo;
        $window.sessionStorage.accountInfo = JSON.stringify(newaccountInfo);
        $rootScope.$broadcast('refreshMenuItems');
        return accountInfo;
    }

    function setAccountInfoNull() { 
       $window.sessionStorage.accountInfo = null;
    }

    function getAuthorizationInfo() {
        return authorizationInfo;
    }

    function setAuthorizationInfoNull() {
        $window.sessionStorage.authorizationInfo = null;
    }

    function setGermantownMenuTemplate() {
        switch (accountInfo.customerId) {
        case 597:
        case 15177:
        case 15147:
            $rootScope.menuTemplate = "germantown";            
            break;
        default:
            $rootScope.menuTemplate = "main";            
        }
    }

    function init() {
        if ($window.sessionStorage.accountInfo && window.sessionStorage.accountInfo !== "null") {
            accountInfo = JSON.parse($window.sessionStorage.accountInfo);
            if (!angular.isUndefined($window.sessionStorage.authorizationInfo)) authorizationInfo = JSON.parse($window.sessionStorage.authorizationInfo);
            var viewModeNow = $rootScope.mobileApp === true ? 4 : $rootScope.mobile === true
                ? 3 : $rootScope.classicView === true ? 2 : 1;

            var tmpAccountInfo = angular.copy(accountInfo);

            var viewModeBefore = accountInfo.menuItems[0].viewMode;

            if (viewModeNow > 2) {
                $rootScope.classicView = false;
            }

            if (viewModeNow !== viewModeBefore) {
                var url = HOST + "/api/Menu?userId=" + tmpAccountInfo.userId + "&customerId=" + tmpAccountInfo.customerId + "&viewMode=" + viewModeNow;
                $http.get(url).then(function (result) {
                    tmpAccountInfo.menuItems = result.data;
                    accountInfo = angular.copy(tmpAccountInfo);
                    $window.sessionStorage.accountInfo = JSON.stringify(accountInfo);
                    if (!!accountInfo) setGermantownMenuTemplate();

                    if (viewModeBefore === 2 && viewModeNow > 2) { //issue when was in classic view => switching to mobile
                        $location.path("/desktop/desktop");
                    }

                }, function (error) {
                    console.log(error);
                    //error
                });
            }

        }
        //if ($window.sessionStorage.authorizationInfo) {
        //    authorizationInfo = JSON.parse($window.sessionStorage.authorizationInfo);
        //}
    }

    init();

    return {
        login: login,
        logout: logout,
        getAccountInfo: getAccountInfo,
        setAccountInfo: setAccountInfo,
        retrieveAccountInfo: retrieveAccountInfo,
        getAuthorizationInfo: getAuthorizationInfo,
        setAccountInfoNull: setAccountInfoNull,
        setAuthorizationInfoNull: setAuthorizationInfoNull

    };
}]);

mcapp.factory('authenticationInterceptorService', ['$q', '$injector', '$location', '$window', function ($q, $injector, $location, $window) {

    var authenticationInterceptorServiceFactory = {};

    var _request = function (config) {

        if (config.url.indexOf('https://graph.microsoft.com/v1.0/me') >= 0)
            return config;

        if (config.url.indexOf('.html') === -1 || config.url.indexOf('McApplicationVersion.html') >= 0) {
            var _separator = config.url.indexOf('?') === -1 ? '?' : '&';
            config.url = config.url + _separator + 'timestamp=' + (new Date().getTime());
        }

        config.headers = config.headers || {};

        if (config.url.indexOf('http://api.ipstack.com/') > -1) {
            delete config.headers.Authorization;
        } else if (config.url.indexOf('https://api.vimeo.com') > -1) {
          // Keep other headers out of this
        }
        else if ($window.sessionStorage.authorizationInfo !== null && $window.sessionStorage.authorizationInfo !== "null" && $window.sessionStorage.authorizationInfo !==undefined) {
            var authData = JSON.parse($window.sessionStorage.authorizationInfo);
            config.headers.Authorization = 'Bearer ' + authData.token;
        }

        return config;
    };

    var _responseError = function (rejection) {
        //if (rejection.status === 401) {
        //    var authData = authenticationService.getAuthorizationInfo();

        //    if (authData) {
        //        if (authData.useRefreshTokens) {
        //            $location.path('/refresh');
        //            return $q.reject(rejection);
        //        }
        //    }
        //    authenticationService.logOut();
        //    $location.path('/login');
        //}
        return $q.reject(rejection);
    };

    authenticationInterceptorServiceFactory.request = _request;
    authenticationInterceptorServiceFactory.responseError = _responseError;

    return authenticationInterceptorServiceFactory;
}]);
mcapp.factory('accountWorkflowService', ['authenticationService', 'openViewService', '$location','websocketService', '$rootScope', '$window', '$timeout',
function (authenticationService, openViewService, $location, websocketService, $rootScope, $window, $timeout) {
    var accountWorkflowService = {};
    var _accountInfo = authenticationService.getAccountInfo();
    var _viewSequence = [];
    var _currentState = {};
    var _mobiRoutingInProgress = false;

    var _init = function () {
        _mobiRoutingInProgress = false;
        _viewSequence = [];
        _currentState = {};
        _accountInfo = authenticationService.getAccountInfo();
        //Create objects for pop-up ui windows | Add Views in order of priority to open
        var _view = _accountInfo.termsAgreedFlag ? {
            "name": "User Terms", "nextView": undefined, "canLogoutOnClose": true, "path": "/account/terms/user-terms-template", "width": 550, "height": 235, "minimumWidth": 550, "minimumHeight": 235
        } : undefined;
        _addToViewSequence(_view);
        _view = _accountInfo.updateUsernameFlag > 0 ? {
            "name": "Update Username", "nextView": undefined, "canLogoutOnClose": _accountInfo.updateUsernameFlag === 2, "path": "/account/username/update-username-template", "width": 550, "height": 235, "minimumWidth": 550, "minimumHeight": 235
        } : undefined;
        _addToViewSequence(_view);
        _view = _accountInfo.updatePasswordFlag > 0 && _accountInfo.mfaMigrationStatus == 0 ? {
            "name": "Update Password", "nextView": undefined, "canLogoutOnClose": _accountInfo.updatePasswordFlag === 2, "path": "/account/password/update-password-template", "width": 700, "height": 280, "minimumWidth": 700, "minimumHeight": 280
        } : undefined;
        _addToViewSequence(_view);
        _view = _accountInfo.optOutWebinar == false && _accountInfo.alreadyRegisteredWebinar == false && !_accountInfo.customerName.toLowerCase().startsWith("mission ") ? {
            "name": "Register Webinar", "nextView": undefined, "canLogoutOnClose": false, "path": "/account/webinar/register-webinar-popup-template", "width": 700, "height": 600, "minimumWidth": 700, "minimumHeight": 600
        } : undefined;
        _addToViewSequence(_view); 
        //_view = _accountInfo.turnOn2FaFlag > 0 ? {
        //    "name": "Enable Two Factor Authentication", "nextView": undefined, "canLogoutOnClose": _accountInfo.turnOn2FaFlag === 2, "path": "/preferences/preferences-user-2fa", "width": 550, "height": 120, "minimumWidth": 500, "minimumHeight": 110
        //} : undefined;
        //_addToViewSequence(_view);
    };

    var _addToViewSequence = function(view) {
        if (!!view && !!_viewSequence) {
            if (_viewSequence.length > 0) _viewSequence[_viewSequence.length - 1].nextView = view;
            _viewSequence.push(view);
        }
    }

    //this method is meant to launch first available view
    var launchView = function () {
        if (_viewSequence.length > 0) { //if views exists, then launch first view
            _openView(_viewSequence[0]);
        }
        else openDefaultDesktop();
    }

    var _launchNextView = function (viewName, viewStatus, viewActionFlag) {
        if (viewActionFlag === "success") {
            if (!$rootScope.mobile) { //mobile do not have popup to close
                openViewService.closeView(viewName);
            }
            else if ($rootScope.mobile && !_currentState.nextView) {
                $location.path("/desktop/desktop");
            }
            //launch next view
            if (!!_currentState.nextView) {
                _openView(_currentState.nextView);
            }
            else { // set _currentState as empty view
                _currentState = {
                    "name": 'dummy', "nextView": undefined, "canLogoutOnClose": undefined
                };
                openDefaultDesktop();
            }
        }

        if (viewActionFlag === "close") {
            if (isViewExists(viewName) && (!!viewStatus)) {
                return;
            }
            if (_currentState.canLogoutOnClose) {
                _logout();
            }
            else {
                //launch next view
                if (!!_currentState.nextView) {
                    _openView(_currentState.nextView);
                } 
                else if (!_currentState.nextView){ // no more views to launch
                    $rootScope.mobile ? $location.path("/desktop/desktop") : openDefaultDesktop();
                }

                if ($rootScope.mobile && !_mobiRoutingInProgress) {
                    $location.path("/desktop/desktop");
                } else {
                    _mobiRoutingInProgress = false;
                }
            }
        }
    };

    var setCurrentState = function (viewName) {
        for (i in _viewSequence) {
            if (_viewSequence[i].name === viewName) {
                _currentState = _viewSequence[i];
                break;
            }
        }
    };

    var isViewExists = function (viewName) {
        var retVal = false;
        for (i in _viewSequence) {
            if (_viewSequence[i].name === viewName) {
                retVal = true;
                break;
            }
        }

        return retVal;
    };

    var _openView = function (view) {
        if (isViewExists(view.name)) {
            setCurrentState(view.name);
            if ($rootScope.mobile) {
                _mobiRoutingInProgress = true;
                $location.path(view.path);
            }
            else {
                openViewService.openView(view.name, { width: view.width, height: view.height }, { my: 'top+120', at: 'center top', of: window }, false, { minimumWidth: view.minWidth, minimumHeight: view.minHeight }, true);
            }
        }
    };

    var _logout = function () {
        websocketService.close();
        $rootScope.CustomerNameStart = "";
        _accountInfo = null;
        $rootScope.login = false;
        $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
        $rootScope.colorSchemeId = $rootScope.defaultFontAndColorId;
        $rootScope.logoSizeId = $rootScope.defaultFontAndColorId;
        $rootScope.backgroundLogo = $rootScope.defaultBackgroundLogo;
        authenticationService.logout()
            .then(function (result) {
                $location.path(result.loginPath);
            }, function (error) {
                $window.alert("logout error");
                console.log(error);
            });
    };

    var openDefaultDesktop = function(){
            $rootScope.$broadcast('openDefaultDesktop');
    }

    accountWorkflowService.init = _init;
    accountWorkflowService.launchView = launchView;
    accountWorkflowService.launchNextView = _launchNextView;

    return accountWorkflowService;

}]);
